"use strict";
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined") return require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported');
  });
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod3) => function __require2() {
    return mod3 || (0, cb[__getOwnPropNames(cb)[0]])((mod3 = { exports: {} }).exports, mod3), mod3.exports;
  };
  var __export = (target, all3) => {
    for (var name2 in all3)
      __defProp(target, name2, { get: all3[name2], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod3, isNodeMode, target) => (target = mod3 != null ? __create(__getProtoOf(mod3)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod3 || !mod3.__esModule ? __defProp(target, "default", { value: mod3, enumerable: true }) : target,
    mod3
  ));
  var __toCommonJS = (mod3) => __copyProps(__defProp({}, "__esModule", { value: true }), mod3);

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/version.js
  var require_version = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/version.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.VERSION = void 0;
      exports2.VERSION = "10.5.0";
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js
  var require_isPrototype = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isPrototype.js"(exports2, module2) {
      var objectProto = Object.prototype;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto2;
      }
      module2.exports = isPrototype;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js
  var require_overArg = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overArg.js"(exports2, module2) {
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      module2.exports = overArg;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js
  var require_nativeKeys = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeys.js"(exports2, module2) {
      var overArg = require_overArg();
      var nativeKeys = overArg(Object.keys, Object);
      module2.exports = nativeKeys;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js
  var require_baseKeys = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeys.js"(exports2, module2) {
      var isPrototype = require_isPrototype();
      var nativeKeys = require_nativeKeys();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result.push(key);
          }
        }
        return result;
      }
      module2.exports = baseKeys;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js
  var require_freeGlobal = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_freeGlobal.js"(exports2, module2) {
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      module2.exports = freeGlobal;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js
  var require_root = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_root.js"(exports2, module2) {
      var freeGlobal = require_freeGlobal();
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      module2.exports = root;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js
  var require_Symbol = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Symbol.js"(exports2, module2) {
      var root = require_root();
      var Symbol2 = root.Symbol;
      module2.exports = Symbol2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js
  var require_getRawTag = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getRawTag.js"(exports2, module2) {
      var Symbol2 = require_Symbol();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var nativeObjectToString = objectProto.toString;
      var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = void 0;
          var unmasked = true;
        } catch (e2) {
        }
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }
      module2.exports = getRawTag;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js
  var require_objectToString = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_objectToString.js"(exports2, module2) {
      var objectProto = Object.prototype;
      var nativeObjectToString = objectProto.toString;
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      module2.exports = objectToString;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js
  var require_baseGetTag = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetTag.js"(exports2, module2) {
      var Symbol2 = require_Symbol();
      var getRawTag = require_getRawTag();
      var objectToString = require_objectToString();
      var nullTag = "[object Null]";
      var undefinedTag = "[object Undefined]";
      var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
      function baseGetTag(value) {
        if (value == null) {
          return value === void 0 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }
      module2.exports = baseGetTag;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js
  var require_isObject = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObject.js"(exports2, module2) {
      function isObject3(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      module2.exports = isObject3;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js
  var require_isFunction = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isFunction.js"(exports2, module2) {
      var baseGetTag = require_baseGetTag();
      var isObject3 = require_isObject();
      var asyncTag = "[object AsyncFunction]";
      var funcTag = "[object Function]";
      var genTag = "[object GeneratorFunction]";
      var proxyTag = "[object Proxy]";
      function isFunction2(value) {
        if (!isObject3(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      module2.exports = isFunction2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js
  var require_coreJsData = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_coreJsData.js"(exports2, module2) {
      var root = require_root();
      var coreJsData = root["__core-js_shared__"];
      module2.exports = coreJsData;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js
  var require_isMasked = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isMasked.js"(exports2, module2) {
      var coreJsData = require_coreJsData();
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      module2.exports = isMasked;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js
  var require_toSource = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toSource.js"(exports2, module2) {
      var funcProto = Function.prototype;
      var funcToString = funcProto.toString;
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e2) {
          }
          try {
            return func + "";
          } catch (e2) {
          }
        }
        return "";
      }
      module2.exports = toSource;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js
  var require_baseIsNative = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNative.js"(exports2, module2) {
      var isFunction2 = require_isFunction();
      var isMasked = require_isMasked();
      var isObject3 = require_isObject();
      var toSource = require_toSource();
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var funcProto = Function.prototype;
      var objectProto = Object.prototype;
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var reIsNative = RegExp(
        "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      function baseIsNative(value) {
        if (!isObject3(value) || isMasked(value)) {
          return false;
        }
        var pattern2 = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern2.test(toSource(value));
      }
      module2.exports = baseIsNative;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js
  var require_getValue = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getValue.js"(exports2, module2) {
      function getValue(object, key) {
        return object == null ? void 0 : object[key];
      }
      module2.exports = getValue;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js
  var require_getNative = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getNative.js"(exports2, module2) {
      var baseIsNative = require_baseIsNative();
      var getValue = require_getValue();
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : void 0;
      }
      module2.exports = getNative;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js
  var require_DataView = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_DataView.js"(exports2, module2) {
      var getNative = require_getNative();
      var root = require_root();
      var DataView2 = getNative(root, "DataView");
      module2.exports = DataView2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js
  var require_Map = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Map.js"(exports2, module2) {
      var getNative = require_getNative();
      var root = require_root();
      var Map2 = getNative(root, "Map");
      module2.exports = Map2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js
  var require_Promise = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Promise.js"(exports2, module2) {
      var getNative = require_getNative();
      var root = require_root();
      var Promise2 = getNative(root, "Promise");
      module2.exports = Promise2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js
  var require_Set = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Set.js"(exports2, module2) {
      var getNative = require_getNative();
      var root = require_root();
      var Set2 = getNative(root, "Set");
      module2.exports = Set2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js
  var require_WeakMap = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_WeakMap.js"(exports2, module2) {
      var getNative = require_getNative();
      var root = require_root();
      var WeakMap2 = getNative(root, "WeakMap");
      module2.exports = WeakMap2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js
  var require_getTag = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getTag.js"(exports2, module2) {
      var DataView2 = require_DataView();
      var Map2 = require_Map();
      var Promise2 = require_Promise();
      var Set2 = require_Set();
      var WeakMap2 = require_WeakMap();
      var baseGetTag = require_baseGetTag();
      var toSource = require_toSource();
      var mapTag = "[object Map]";
      var objectTag = "[object Object]";
      var promiseTag = "[object Promise]";
      var setTag = "[object Set]";
      var weakMapTag = "[object WeakMap]";
      var dataViewTag = "[object DataView]";
      var dataViewCtorString = toSource(DataView2);
      var mapCtorString = toSource(Map2);
      var promiseCtorString = toSource(Promise2);
      var setCtorString = toSource(Set2);
      var weakMapCtorString = toSource(WeakMap2);
      var getTag = baseGetTag;
      if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }
      module2.exports = getTag;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js
  var require_isObjectLike = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isObjectLike.js"(exports2, module2) {
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      module2.exports = isObjectLike;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js
  var require_baseIsArguments = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsArguments.js"(exports2, module2) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var argsTag = "[object Arguments]";
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      module2.exports = baseIsArguments;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js
  var require_isArguments = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArguments.js"(exports2, module2) {
      var baseIsArguments = require_baseIsArguments();
      var isObjectLike = require_isObjectLike();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      var isArguments = baseIsArguments(/* @__PURE__ */ function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      module2.exports = isArguments;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js
  var require_isArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArray.js"(exports2, module2) {
      var isArray2 = Array.isArray;
      module2.exports = isArray2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js
  var require_isLength = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isLength.js"(exports2, module2) {
      var MAX_SAFE_INTEGER = 9007199254740991;
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      module2.exports = isLength;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js
  var require_isArrayLike = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLike.js"(exports2, module2) {
      var isFunction2 = require_isFunction();
      var isLength = require_isLength();
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      module2.exports = isArrayLike;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js
  var require_stubFalse = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubFalse.js"(exports2, module2) {
      function stubFalse() {
        return false;
      }
      module2.exports = stubFalse;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js
  var require_isBuffer = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isBuffer.js"(exports2, module2) {
      var root = require_root();
      var stubFalse = require_stubFalse();
      var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
      var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var Buffer7 = moduleExports ? root.Buffer : void 0;
      var nativeIsBuffer = Buffer7 ? Buffer7.isBuffer : void 0;
      var isBuffer2 = nativeIsBuffer || stubFalse;
      module2.exports = isBuffer2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js
  var require_baseIsTypedArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsTypedArray.js"(exports2, module2) {
      var baseGetTag = require_baseGetTag();
      var isLength = require_isLength();
      var isObjectLike = require_isObjectLike();
      var argsTag = "[object Arguments]";
      var arrayTag = "[object Array]";
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var errorTag = "[object Error]";
      var funcTag = "[object Function]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var objectTag = "[object Object]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var weakMapTag = "[object WeakMap]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var float32Tag = "[object Float32Array]";
      var float64Tag = "[object Float64Array]";
      var int8Tag = "[object Int8Array]";
      var int16Tag = "[object Int16Array]";
      var int32Tag = "[object Int32Array]";
      var uint8Tag = "[object Uint8Array]";
      var uint8ClampedTag = "[object Uint8ClampedArray]";
      var uint16Tag = "[object Uint16Array]";
      var uint32Tag = "[object Uint32Array]";
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      module2.exports = baseIsTypedArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js
  var require_baseUnary = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUnary.js"(exports2, module2) {
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      module2.exports = baseUnary;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js
  var require_nodeUtil = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nodeUtil.js"(exports2, module2) {
      var freeGlobal = require_freeGlobal();
      var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
      var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types3 = freeModule && freeModule.require && freeModule.require("util").types;
          if (types3) {
            return types3;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e2) {
        }
      }();
      module2.exports = nodeUtil;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js
  var require_isTypedArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isTypedArray.js"(exports2, module2) {
      var baseIsTypedArray = require_baseIsTypedArray();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      module2.exports = isTypedArray2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js
  var require_isEmpty = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEmpty.js"(exports2, module2) {
      var baseKeys = require_baseKeys();
      var getTag = require_getTag();
      var isArguments = require_isArguments();
      var isArray2 = require_isArray();
      var isArrayLike = require_isArrayLike();
      var isBuffer2 = require_isBuffer();
      var isPrototype = require_isPrototype();
      var isTypedArray2 = require_isTypedArray();
      var mapTag = "[object Map]";
      var setTag = "[object Set]";
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      module2.exports = isEmpty;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js
  var require_arrayMap = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayMap.js"(exports2, module2) {
      function arrayMap(array, iteratee) {
        var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
        while (++index2 < length2) {
          result[index2] = iteratee(array[index2], index2, array);
        }
        return result;
      }
      module2.exports = arrayMap;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js
  var require_listCacheClear = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheClear.js"(exports2, module2) {
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      module2.exports = listCacheClear;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js
  var require_eq = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/eq.js"(exports2, module2) {
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      module2.exports = eq;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js
  var require_assocIndexOf = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assocIndexOf.js"(exports2, module2) {
      var eq = require_eq();
      function assocIndexOf(array, key) {
        var length2 = array.length;
        while (length2--) {
          if (eq(array[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      module2.exports = assocIndexOf;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js
  var require_listCacheDelete = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheDelete.js"(exports2, module2) {
      var assocIndexOf = require_assocIndexOf();
      var arrayProto = Array.prototype;
      var splice = arrayProto.splice;
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      module2.exports = listCacheDelete;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js
  var require_listCacheGet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheGet.js"(exports2, module2) {
      var assocIndexOf = require_assocIndexOf();
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? void 0 : data[index2][1];
      }
      module2.exports = listCacheGet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js
  var require_listCacheHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheHas.js"(exports2, module2) {
      var assocIndexOf = require_assocIndexOf();
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      module2.exports = listCacheHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js
  var require_listCacheSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_listCacheSet.js"(exports2, module2) {
      var assocIndexOf = require_assocIndexOf();
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      module2.exports = listCacheSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js
  var require_ListCache = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_ListCache.js"(exports2, module2) {
      var listCacheClear = require_listCacheClear();
      var listCacheDelete = require_listCacheDelete();
      var listCacheGet = require_listCacheGet();
      var listCacheHas = require_listCacheHas();
      var listCacheSet = require_listCacheSet();
      function ListCache(entries2) {
        var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries2[index2];
          this.set(entry[0], entry[1]);
        }
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      module2.exports = ListCache;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js
  var require_stackClear = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackClear.js"(exports2, module2) {
      var ListCache = require_ListCache();
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      module2.exports = stackClear;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js
  var require_stackDelete = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackDelete.js"(exports2, module2) {
      function stackDelete(key) {
        var data = this.__data__, result = data["delete"](key);
        this.size = data.size;
        return result;
      }
      module2.exports = stackDelete;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js
  var require_stackGet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackGet.js"(exports2, module2) {
      function stackGet(key) {
        return this.__data__.get(key);
      }
      module2.exports = stackGet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js
  var require_stackHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackHas.js"(exports2, module2) {
      function stackHas(key) {
        return this.__data__.has(key);
      }
      module2.exports = stackHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js
  var require_nativeCreate = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeCreate.js"(exports2, module2) {
      var getNative = require_getNative();
      var nativeCreate = getNative(Object, "create");
      module2.exports = nativeCreate;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js
  var require_hashClear = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashClear.js"(exports2, module2) {
      var nativeCreate = require_nativeCreate();
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      module2.exports = hashClear;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js
  var require_hashDelete = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashDelete.js"(exports2, module2) {
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }
      module2.exports = hashDelete;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js
  var require_hashGet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashGet.js"(exports2, module2) {
      var nativeCreate = require_nativeCreate();
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? void 0 : result;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : void 0;
      }
      module2.exports = hashGet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js
  var require_hashHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashHas.js"(exports2, module2) {
      var nativeCreate = require_nativeCreate();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== void 0 : hasOwnProperty2.call(data, key);
      }
      module2.exports = hashHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js
  var require_hashSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hashSet.js"(exports2, module2) {
      var nativeCreate = require_nativeCreate();
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
        return this;
      }
      module2.exports = hashSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js
  var require_Hash = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Hash.js"(exports2, module2) {
      var hashClear = require_hashClear();
      var hashDelete = require_hashDelete();
      var hashGet = require_hashGet();
      var hashHas = require_hashHas();
      var hashSet = require_hashSet();
      function Hash2(entries2) {
        var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries2[index2];
          this.set(entry[0], entry[1]);
        }
      }
      Hash2.prototype.clear = hashClear;
      Hash2.prototype["delete"] = hashDelete;
      Hash2.prototype.get = hashGet;
      Hash2.prototype.has = hashHas;
      Hash2.prototype.set = hashSet;
      module2.exports = Hash2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js
  var require_mapCacheClear = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheClear.js"(exports2, module2) {
      var Hash2 = require_Hash();
      var ListCache = require_ListCache();
      var Map2 = require_Map();
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash2(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash2()
        };
      }
      module2.exports = mapCacheClear;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js
  var require_isKeyable = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKeyable.js"(exports2, module2) {
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      module2.exports = isKeyable;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js
  var require_getMapData = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMapData.js"(exports2, module2) {
      var isKeyable = require_isKeyable();
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      module2.exports = getMapData;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js
  var require_mapCacheDelete = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheDelete.js"(exports2, module2) {
      var getMapData = require_getMapData();
      function mapCacheDelete(key) {
        var result = getMapData(this, key)["delete"](key);
        this.size -= result ? 1 : 0;
        return result;
      }
      module2.exports = mapCacheDelete;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js
  var require_mapCacheGet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheGet.js"(exports2, module2) {
      var getMapData = require_getMapData();
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      module2.exports = mapCacheGet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js
  var require_mapCacheHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheHas.js"(exports2, module2) {
      var getMapData = require_getMapData();
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      module2.exports = mapCacheHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js
  var require_mapCacheSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapCacheSet.js"(exports2, module2) {
      var getMapData = require_getMapData();
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }
      module2.exports = mapCacheSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js
  var require_MapCache = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_MapCache.js"(exports2, module2) {
      var mapCacheClear = require_mapCacheClear();
      var mapCacheDelete = require_mapCacheDelete();
      var mapCacheGet = require_mapCacheGet();
      var mapCacheHas = require_mapCacheHas();
      var mapCacheSet = require_mapCacheSet();
      function MapCache(entries2) {
        var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries2[index2];
          this.set(entry[0], entry[1]);
        }
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      module2.exports = MapCache;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js
  var require_stackSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stackSet.js"(exports2, module2) {
      var ListCache = require_ListCache();
      var Map2 = require_Map();
      var MapCache = require_MapCache();
      var LARGE_ARRAY_SIZE = 200;
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      module2.exports = stackSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js
  var require_Stack = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Stack.js"(exports2, module2) {
      var ListCache = require_ListCache();
      var stackClear = require_stackClear();
      var stackDelete = require_stackDelete();
      var stackGet = require_stackGet();
      var stackHas = require_stackHas();
      var stackSet = require_stackSet();
      function Stack(entries2) {
        var data = this.__data__ = new ListCache(entries2);
        this.size = data.size;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      module2.exports = Stack;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js
  var require_setCacheAdd = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheAdd.js"(exports2, module2) {
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      module2.exports = setCacheAdd;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js
  var require_setCacheHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setCacheHas.js"(exports2, module2) {
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      module2.exports = setCacheHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js
  var require_SetCache = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_SetCache.js"(exports2, module2) {
      var MapCache = require_MapCache();
      var setCacheAdd = require_setCacheAdd();
      var setCacheHas = require_setCacheHas();
      function SetCache(values) {
        var index2 = -1, length2 = values == null ? 0 : values.length;
        this.__data__ = new MapCache();
        while (++index2 < length2) {
          this.add(values[index2]);
        }
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      module2.exports = SetCache;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js
  var require_arraySome = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arraySome.js"(exports2, module2) {
      function arraySome(array, predicate) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (predicate(array[index2], index2, array)) {
            return true;
          }
        }
        return false;
      }
      module2.exports = arraySome;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js
  var require_cacheHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cacheHas.js"(exports2, module2) {
      function cacheHas(cache2, key) {
        return cache2.has(key);
      }
      module2.exports = cacheHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js
  var require_equalArrays = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalArrays.js"(exports2, module2) {
      var SetCache = require_SetCache();
      var arraySome = require_arraySome();
      var cacheHas = require_cacheHas();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== void 0) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result;
      }
      module2.exports = equalArrays;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js
  var require_Uint8Array = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_Uint8Array.js"(exports2, module2) {
      var root = require_root();
      var Uint8Array2 = root.Uint8Array;
      module2.exports = Uint8Array2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js
  var require_mapToArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_mapToArray.js"(exports2, module2) {
      function mapToArray(map) {
        var index2 = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index2] = [key, value];
        });
        return result;
      }
      module2.exports = mapToArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js
  var require_setToArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToArray.js"(exports2, module2) {
      function setToArray(set4) {
        var index2 = -1, result = Array(set4.size);
        set4.forEach(function(value) {
          result[++index2] = value;
        });
        return result;
      }
      module2.exports = setToArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js
  var require_equalByTag = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalByTag.js"(exports2, module2) {
      var Symbol2 = require_Symbol();
      var Uint8Array2 = require_Uint8Array();
      var eq = require_eq();
      var equalArrays = require_equalArrays();
      var mapToArray = require_mapToArray();
      var setToArray = require_setToArray();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var errorTag = "[object Error]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var symbolTag = "[object Symbol]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
      var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert2 = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert2 || (convert2 = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result = equalArrays(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      module2.exports = equalByTag;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js
  var require_arrayPush = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayPush.js"(exports2, module2) {
      function arrayPush(array, values) {
        var index2 = -1, length2 = values.length, offset = array.length;
        while (++index2 < length2) {
          array[offset + index2] = values[index2];
        }
        return array;
      }
      module2.exports = arrayPush;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js
  var require_baseGetAllKeys = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGetAllKeys.js"(exports2, module2) {
      var arrayPush = require_arrayPush();
      var isArray2 = require_isArray();
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
      }
      module2.exports = baseGetAllKeys;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js
  var require_arrayFilter = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayFilter.js"(exports2, module2) {
      function arrayFilter(array, predicate) {
        var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index2 < length2) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      module2.exports = arrayFilter;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js
  var require_stubArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/stubArray.js"(exports2, module2) {
      function stubArray() {
        return [];
      }
      module2.exports = stubArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js
  var require_getSymbols = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbols.js"(exports2, module2) {
      var arrayFilter = require_arrayFilter();
      var stubArray = require_stubArray();
      var objectProto = Object.prototype;
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      var nativeGetSymbols = Object.getOwnPropertySymbols;
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol2) {
          return propertyIsEnumerable.call(object, symbol2);
        });
      };
      module2.exports = getSymbols;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js
  var require_baseTimes = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTimes.js"(exports2, module2) {
      function baseTimes(n2, iteratee) {
        var index2 = -1, result = Array(n2);
        while (++index2 < n2) {
          result[index2] = iteratee(index2);
        }
        return result;
      }
      module2.exports = baseTimes;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js
  var require_isIndex = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIndex.js"(exports2, module2) {
      var MAX_SAFE_INTEGER = 9007199254740991;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      function isIndex(value, length2) {
        var type = typeof value;
        length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
        return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
      }
      module2.exports = isIndex;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js
  var require_arrayLikeKeys = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayLikeKeys.js"(exports2, module2) {
      var baseTimes = require_baseTimes();
      var isArguments = require_isArguments();
      var isArray2 = require_isArray();
      var isBuffer2 = require_isBuffer();
      var isIndex = require_isIndex();
      var isTypedArray2 = require_isTypedArray();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType2 = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType2, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType2 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex(key, length2)))) {
            result.push(key);
          }
        }
        return result;
      }
      module2.exports = arrayLikeKeys;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js
  var require_keys = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keys.js"(exports2, module2) {
      var arrayLikeKeys = require_arrayLikeKeys();
      var baseKeys = require_baseKeys();
      var isArrayLike = require_isArrayLike();
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      module2.exports = keys;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js
  var require_getAllKeys = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeys.js"(exports2, module2) {
      var baseGetAllKeys = require_baseGetAllKeys();
      var getSymbols = require_getSymbols();
      var keys = require_keys();
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      module2.exports = getAllKeys;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js
  var require_equalObjects = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_equalObjects.js"(exports2, module2) {
      var getAllKeys = require_getAllKeys();
      var COMPARE_PARTIAL_FLAG = 1;
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result;
      }
      module2.exports = equalObjects;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js
  var require_baseIsEqualDeep = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqualDeep.js"(exports2, module2) {
      var Stack = require_Stack();
      var equalArrays = require_equalArrays();
      var equalByTag = require_equalByTag();
      var equalObjects = require_equalObjects();
      var getTag = require_getTag();
      var isArray2 = require_isArray();
      var isBuffer2 = require_isBuffer();
      var isTypedArray2 = require_isTypedArray();
      var COMPARE_PARTIAL_FLAG = 1;
      var argsTag = "[object Arguments]";
      var arrayTag = "[object Array]";
      var objectTag = "[object Object]";
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      module2.exports = baseIsEqualDeep;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js
  var require_baseIsEqual = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsEqual.js"(exports2, module2) {
      var baseIsEqualDeep = require_baseIsEqualDeep();
      var isObjectLike = require_isObjectLike();
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      module2.exports = baseIsEqual;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMatch.js
  var require_baseIsMatch = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMatch.js"(exports2, module2) {
      var Stack = require_Stack();
      var baseIsEqual = require_baseIsEqual();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      function baseIsMatch(object, source, matchData, customizer) {
        var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length2;
        }
        object = Object(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length2) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === void 0 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }
        return true;
      }
      module2.exports = baseIsMatch;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isStrictComparable.js
  var require_isStrictComparable = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isStrictComparable.js"(exports2, module2) {
      var isObject3 = require_isObject();
      function isStrictComparable(value) {
        return value === value && !isObject3(value);
      }
      module2.exports = isStrictComparable;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMatchData.js
  var require_getMatchData = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getMatchData.js"(exports2, module2) {
      var isStrictComparable = require_isStrictComparable();
      var keys = require_keys();
      function getMatchData(object) {
        var result = keys(object), length2 = result.length;
        while (length2--) {
          var key = result[length2], value = object[key];
          result[length2] = [key, value, isStrictComparable(value)];
        }
        return result;
      }
      module2.exports = getMatchData;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_matchesStrictComparable.js
  var require_matchesStrictComparable = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_matchesStrictComparable.js"(exports2, module2) {
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
        };
      }
      module2.exports = matchesStrictComparable;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatches.js
  var require_baseMatches = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatches.js"(exports2, module2) {
      var baseIsMatch = require_baseIsMatch();
      var getMatchData = require_getMatchData();
      var matchesStrictComparable = require_matchesStrictComparable();
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      module2.exports = baseMatches;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js
  var require_isSymbol = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSymbol.js"(exports2, module2) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var symbolTag = "[object Symbol]";
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      module2.exports = isSymbol;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKey.js
  var require_isKey = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isKey.js"(exports2, module2) {
      var isArray2 = require_isArray();
      var isSymbol = require_isSymbol();
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
      var reIsPlainProp = /^\w*$/;
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }
      module2.exports = isKey;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js
  var require_memoize = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/memoize.js"(exports2, module2) {
      var MapCache = require_MapCache();
      var FUNC_ERROR_TEXT = "Expected a function";
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache2.set(key, result) || cache2;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      module2.exports = memoize;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_memoizeCapped.js
  var require_memoizeCapped = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_memoizeCapped.js"(exports2, module2) {
      var memoize = require_memoize();
      var MAX_MEMOIZE_SIZE = 500;
      function memoizeCapped(func) {
        var result = memoize(func, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result.cache;
        return result;
      }
      module2.exports = memoizeCapped;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToPath.js
  var require_stringToPath = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToPath.js"(exports2, module2) {
      var memoizeCapped = require_memoizeCapped();
      var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reEscapeChar = /\\(\\)?/g;
      var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46) {
          result.push("");
        }
        string.replace(rePropName, function(match, number2, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
        });
        return result;
      });
      module2.exports = stringToPath;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js
  var require_baseToString = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseToString.js"(exports2, module2) {
      var Symbol2 = require_Symbol();
      var arrayMap = require_arrayMap();
      var isArray2 = require_isArray();
      var isSymbol = require_isSymbol();
      var INFINITY = 1 / 0;
      var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
      var symbolToString = symbolProto ? symbolProto.toString : void 0;
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
      }
      module2.exports = baseToString;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js
  var require_toString = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toString.js"(exports2, module2) {
      var baseToString = require_baseToString();
      function toString3(value) {
        return value == null ? "" : baseToString(value);
      }
      module2.exports = toString3;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castPath.js
  var require_castPath = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castPath.js"(exports2, module2) {
      var isArray2 = require_isArray();
      var isKey = require_isKey();
      var stringToPath = require_stringToPath();
      var toString3 = require_toString();
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString3(value));
      }
      module2.exports = castPath;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toKey.js
  var require_toKey = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_toKey.js"(exports2, module2) {
      var isSymbol = require_isSymbol();
      var INFINITY = 1 / 0;
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
      }
      module2.exports = toKey;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGet.js
  var require_baseGet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseGet.js"(exports2, module2) {
      var castPath = require_castPath();
      var toKey = require_toKey();
      function baseGet(object, path3) {
        path3 = castPath(path3, object);
        var index2 = 0, length2 = path3.length;
        while (object != null && index2 < length2) {
          object = object[toKey(path3[index2++])];
        }
        return index2 && index2 == length2 ? object : void 0;
      }
      module2.exports = baseGet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js
  var require_get = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/get.js"(exports2, module2) {
      var baseGet = require_baseGet();
      function get4(object, path3, defaultValue) {
        var result = object == null ? void 0 : baseGet(object, path3);
        return result === void 0 ? defaultValue : result;
      }
      module2.exports = get4;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHasIn.js
  var require_baseHasIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHasIn.js"(exports2, module2) {
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }
      module2.exports = baseHasIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasPath.js
  var require_hasPath = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasPath.js"(exports2, module2) {
      var castPath = require_castPath();
      var isArguments = require_isArguments();
      var isArray2 = require_isArray();
      var isIndex = require_isIndex();
      var isLength = require_isLength();
      var toKey = require_toKey();
      function hasPath(object, path3, hasFunc) {
        path3 = castPath(path3, object);
        var index2 = -1, length2 = path3.length, result = false;
        while (++index2 < length2) {
          var key = toKey(path3[index2]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index2 != length2) {
          return result;
        }
        length2 = object == null ? 0 : object.length;
        return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray2(object) || isArguments(object));
      }
      module2.exports = hasPath;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/hasIn.js
  var require_hasIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/hasIn.js"(exports2, module2) {
      var baseHasIn = require_baseHasIn();
      var hasPath = require_hasPath();
      function hasIn(object, path3) {
        return object != null && hasPath(object, path3, baseHasIn);
      }
      module2.exports = hasIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatchesProperty.js
  var require_baseMatchesProperty = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMatchesProperty.js"(exports2, module2) {
      var baseIsEqual = require_baseIsEqual();
      var get4 = require_get();
      var hasIn = require_hasIn();
      var isKey = require_isKey();
      var isStrictComparable = require_isStrictComparable();
      var matchesStrictComparable = require_matchesStrictComparable();
      var toKey = require_toKey();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      function baseMatchesProperty(path3, srcValue) {
        if (isKey(path3) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path3), srcValue);
        }
        return function(object) {
          var objValue = get4(object, path3);
          return objValue === void 0 && objValue === srcValue ? hasIn(object, path3) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      module2.exports = baseMatchesProperty;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/identity.js
  var require_identity = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/identity.js"(exports2, module2) {
      function identity(value) {
        return value;
      }
      module2.exports = identity;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js
  var require_baseProperty = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseProperty.js"(exports2, module2) {
      function baseProperty(key) {
        return function(object) {
          return object == null ? void 0 : object[key];
        };
      }
      module2.exports = baseProperty;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePropertyDeep.js
  var require_basePropertyDeep = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePropertyDeep.js"(exports2, module2) {
      var baseGet = require_baseGet();
      function basePropertyDeep(path3) {
        return function(object) {
          return baseGet(object, path3);
        };
      }
      module2.exports = basePropertyDeep;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/property.js
  var require_property = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/property.js"(exports2, module2) {
      var baseProperty = require_baseProperty();
      var basePropertyDeep = require_basePropertyDeep();
      var isKey = require_isKey();
      var toKey = require_toKey();
      function property(path3) {
        return isKey(path3) ? baseProperty(toKey(path3)) : basePropertyDeep(path3);
      }
      module2.exports = property;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIteratee.js
  var require_baseIteratee = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIteratee.js"(exports2, module2) {
      var baseMatches = require_baseMatches();
      var baseMatchesProperty = require_baseMatchesProperty();
      var identity = require_identity();
      var isArray2 = require_isArray();
      var property = require_property();
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      module2.exports = baseIteratee;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseFor.js
  var require_createBaseFor = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseFor.js"(exports2, module2) {
      function createBaseFor(fromRight) {
        return function(object, iteratee, keysFunc) {
          var index2 = -1, iterable = Object(object), props = keysFunc(object), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index2];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      module2.exports = createBaseFor;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFor.js
  var require_baseFor = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFor.js"(exports2, module2) {
      var createBaseFor = require_createBaseFor();
      var baseFor = createBaseFor();
      module2.exports = baseFor;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseForOwn.js
  var require_baseForOwn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseForOwn.js"(exports2, module2) {
      var baseFor = require_baseFor();
      var keys = require_keys();
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }
      module2.exports = baseForOwn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseEach.js
  var require_createBaseEach = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createBaseEach.js"(exports2, module2) {
      var isArrayLike = require_isArrayLike();
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (iteratee(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      module2.exports = createBaseEach;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEach.js
  var require_baseEach = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEach.js"(exports2, module2) {
      var baseForOwn = require_baseForOwn();
      var createBaseEach = require_createBaseEach();
      var baseEach = createBaseEach(baseForOwn);
      module2.exports = baseEach;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMap.js
  var require_baseMap = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseMap.js"(exports2, module2) {
      var baseEach = require_baseEach();
      var isArrayLike = require_isArrayLike();
      function baseMap(collection, iteratee) {
        var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result[++index2] = iteratee(value, key, collection2);
        });
        return result;
      }
      module2.exports = baseMap;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/map.js
  var require_map = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/map.js"(exports2, module2) {
      var arrayMap = require_arrayMap();
      var baseIteratee = require_baseIteratee();
      var baseMap = require_baseMap();
      var isArray2 = require_isArray();
      function map(collection, iteratee) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, baseIteratee(iteratee, 3));
      }
      module2.exports = map;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayEach.js
  var require_arrayEach = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayEach.js"(exports2, module2) {
      function arrayEach(array, iteratee) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (iteratee(array[index2], index2, array) === false) {
            break;
          }
        }
        return array;
      }
      module2.exports = arrayEach;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castFunction.js
  var require_castFunction = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castFunction.js"(exports2, module2) {
      var identity = require_identity();
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      module2.exports = castFunction;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/forEach.js
  var require_forEach = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/forEach.js"(exports2, module2) {
      var arrayEach = require_arrayEach();
      var baseEach = require_baseEach();
      var castFunction = require_castFunction();
      var isArray2 = require_isArray();
      function forEach2(collection, iteratee) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, castFunction(iteratee));
      }
      module2.exports = forEach2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseValues.js
  var require_baseValues = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseValues.js"(exports2, module2) {
      var arrayMap = require_arrayMap();
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      module2.exports = baseValues;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/values.js
  var require_values = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/values.js"(exports2, module2) {
      var baseValues = require_baseValues();
      var keys = require_keys();
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      module2.exports = values;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHas.js
  var require_baseHas = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseHas.js"(exports2, module2) {
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      module2.exports = baseHas;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/has.js
  var require_has = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/has.js"(exports2, module2) {
      var baseHas = require_baseHas();
      var hasPath = require_hasPath();
      function has(object, path3) {
        return object != null && hasPath(object, path3, baseHas);
      }
      module2.exports = has;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_defineProperty.js
  var require_defineProperty = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_defineProperty.js"(exports2, module2) {
      var getNative = require_getNative();
      var defineProperty = function() {
        try {
          var func = getNative(Object, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e2) {
        }
      }();
      module2.exports = defineProperty;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssignValue.js
  var require_baseAssignValue = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssignValue.js"(exports2, module2) {
      var defineProperty = require_defineProperty();
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      module2.exports = baseAssignValue;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assignValue.js
  var require_assignValue = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_assignValue.js"(exports2, module2) {
      var baseAssignValue = require_baseAssignValue();
      var eq = require_eq();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      module2.exports = assignValue;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyObject.js
  var require_copyObject = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyObject.js"(exports2, module2) {
      var assignValue = require_assignValue();
      var baseAssignValue = require_baseAssignValue();
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length2 = props.length;
        while (++index2 < length2) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
          if (newValue === void 0) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      module2.exports = copyObject;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssign.js
  var require_baseAssign = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssign.js"(exports2, module2) {
      var copyObject = require_copyObject();
      var keys = require_keys();
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      module2.exports = baseAssign;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeysIn.js
  var require_nativeKeysIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_nativeKeysIn.js"(exports2, module2) {
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }
      module2.exports = nativeKeysIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeysIn.js
  var require_baseKeysIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseKeysIn.js"(exports2, module2) {
      var isObject3 = require_isObject();
      var isPrototype = require_isPrototype();
      var nativeKeysIn = require_nativeKeysIn();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function baseKeysIn(object) {
        if (!isObject3(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }
      module2.exports = baseKeysIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keysIn.js
  var require_keysIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/keysIn.js"(exports2, module2) {
      var arrayLikeKeys = require_arrayLikeKeys();
      var baseKeysIn = require_baseKeysIn();
      var isArrayLike = require_isArrayLike();
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      module2.exports = keysIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssignIn.js
  var require_baseAssignIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAssignIn.js"(exports2, module2) {
      var copyObject = require_copyObject();
      var keysIn = require_keysIn();
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      module2.exports = baseAssignIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneBuffer.js
  var require_cloneBuffer = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneBuffer.js"(exports2, module2) {
      var root = require_root();
      var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
      var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var Buffer7 = moduleExports ? root.Buffer : void 0;
      var allocUnsafe = Buffer7 ? Buffer7.allocUnsafe : void 0;
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length2 = buffer.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
        buffer.copy(result);
        return result;
      }
      module2.exports = cloneBuffer;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyArray.js
  var require_copyArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copyArray.js"(exports2, module2) {
      function copyArray(source, array) {
        var index2 = -1, length2 = source.length;
        array || (array = Array(length2));
        while (++index2 < length2) {
          array[index2] = source[index2];
        }
        return array;
      }
      module2.exports = copyArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copySymbols.js
  var require_copySymbols = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copySymbols.js"(exports2, module2) {
      var copyObject = require_copyObject();
      var getSymbols = require_getSymbols();
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      module2.exports = copySymbols;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getPrototype.js
  var require_getPrototype = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getPrototype.js"(exports2, module2) {
      var overArg = require_overArg();
      var getPrototype = overArg(Object.getPrototypeOf, Object);
      module2.exports = getPrototype;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbolsIn.js
  var require_getSymbolsIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getSymbolsIn.js"(exports2, module2) {
      var arrayPush = require_arrayPush();
      var getPrototype = require_getPrototype();
      var getSymbols = require_getSymbols();
      var stubArray = require_stubArray();
      var nativeGetSymbols = Object.getOwnPropertySymbols;
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };
      module2.exports = getSymbolsIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copySymbolsIn.js
  var require_copySymbolsIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_copySymbolsIn.js"(exports2, module2) {
      var copyObject = require_copyObject();
      var getSymbolsIn = require_getSymbolsIn();
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      module2.exports = copySymbolsIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeysIn.js
  var require_getAllKeysIn = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_getAllKeysIn.js"(exports2, module2) {
      var baseGetAllKeys = require_baseGetAllKeys();
      var getSymbolsIn = require_getSymbolsIn();
      var keysIn = require_keysIn();
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      module2.exports = getAllKeysIn;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_initCloneArray.js
  var require_initCloneArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_initCloneArray.js"(exports2, module2) {
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      function initCloneArray(array) {
        var length2 = array.length, result = new array.constructor(length2);
        if (length2 && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }
      module2.exports = initCloneArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneArrayBuffer.js
  var require_cloneArrayBuffer = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneArrayBuffer.js"(exports2, module2) {
      var Uint8Array2 = require_Uint8Array();
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
        return result;
      }
      module2.exports = cloneArrayBuffer;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneDataView.js
  var require_cloneDataView = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneDataView.js"(exports2, module2) {
      var cloneArrayBuffer = require_cloneArrayBuffer();
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      module2.exports = cloneDataView;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneRegExp.js
  var require_cloneRegExp = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneRegExp.js"(exports2, module2) {
      var reFlags = /\w*$/;
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }
      module2.exports = cloneRegExp;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneSymbol.js
  var require_cloneSymbol = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneSymbol.js"(exports2, module2) {
      var Symbol2 = require_Symbol();
      var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
      var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
      function cloneSymbol(symbol2) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol2)) : {};
      }
      module2.exports = cloneSymbol;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneTypedArray.js
  var require_cloneTypedArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_cloneTypedArray.js"(exports2, module2) {
      var cloneArrayBuffer = require_cloneArrayBuffer();
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      module2.exports = cloneTypedArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_initCloneByTag.js
  var require_initCloneByTag = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_initCloneByTag.js"(exports2, module2) {
      var cloneArrayBuffer = require_cloneArrayBuffer();
      var cloneDataView = require_cloneDataView();
      var cloneRegExp = require_cloneRegExp();
      var cloneSymbol = require_cloneSymbol();
      var cloneTypedArray = require_cloneTypedArray();
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var symbolTag = "[object Symbol]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var float32Tag = "[object Float32Array]";
      var float64Tag = "[object Float64Array]";
      var int8Tag = "[object Int8Array]";
      var int16Tag = "[object Int16Array]";
      var int32Tag = "[object Int32Array]";
      var uint8Tag = "[object Uint8Array]";
      var uint8ClampedTag = "[object Uint8ClampedArray]";
      var uint16Tag = "[object Uint16Array]";
      var uint32Tag = "[object Uint32Array]";
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      module2.exports = initCloneByTag;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseCreate.js
  var require_baseCreate = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseCreate.js"(exports2, module2) {
      var isObject3 = require_isObject();
      var objectCreate = Object.create;
      var baseCreate = /* @__PURE__ */ function() {
        function object() {
        }
        return function(proto2) {
          if (!isObject3(proto2)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto2);
          }
          object.prototype = proto2;
          var result = new object();
          object.prototype = void 0;
          return result;
        };
      }();
      module2.exports = baseCreate;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_initCloneObject.js
  var require_initCloneObject = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_initCloneObject.js"(exports2, module2) {
      var baseCreate = require_baseCreate();
      var getPrototype = require_getPrototype();
      var isPrototype = require_isPrototype();
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      module2.exports = initCloneObject;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMap.js
  var require_baseIsMap = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsMap.js"(exports2, module2) {
      var getTag = require_getTag();
      var isObjectLike = require_isObjectLike();
      var mapTag = "[object Map]";
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      module2.exports = baseIsMap;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isMap.js
  var require_isMap = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isMap.js"(exports2, module2) {
      var baseIsMap = require_baseIsMap();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsMap = nodeUtil && nodeUtil.isMap;
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      module2.exports = isMap;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsSet.js
  var require_baseIsSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsSet.js"(exports2, module2) {
      var getTag = require_getTag();
      var isObjectLike = require_isObjectLike();
      var setTag = "[object Set]";
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      module2.exports = baseIsSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSet.js
  var require_isSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isSet.js"(exports2, module2) {
      var baseIsSet = require_baseIsSet();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsSet = nodeUtil && nodeUtil.isSet;
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      module2.exports = isSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseClone.js
  var require_baseClone = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseClone.js"(exports2, module2) {
      var Stack = require_Stack();
      var arrayEach = require_arrayEach();
      var assignValue = require_assignValue();
      var baseAssign = require_baseAssign();
      var baseAssignIn = require_baseAssignIn();
      var cloneBuffer = require_cloneBuffer();
      var copyArray = require_copyArray();
      var copySymbols = require_copySymbols();
      var copySymbolsIn = require_copySymbolsIn();
      var getAllKeys = require_getAllKeys();
      var getAllKeysIn = require_getAllKeysIn();
      var getTag = require_getTag();
      var initCloneArray = require_initCloneArray();
      var initCloneByTag = require_initCloneByTag();
      var initCloneObject = require_initCloneObject();
      var isArray2 = require_isArray();
      var isBuffer2 = require_isBuffer();
      var isMap = require_isMap();
      var isObject3 = require_isObject();
      var isSet = require_isSet();
      var keys = require_keys();
      var keysIn = require_keysIn();
      var CLONE_DEEP_FLAG = 1;
      var CLONE_FLAT_FLAG = 2;
      var CLONE_SYMBOLS_FLAG = 4;
      var argsTag = "[object Arguments]";
      var arrayTag = "[object Array]";
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var errorTag = "[object Error]";
      var funcTag = "[object Function]";
      var genTag = "[object GeneratorFunction]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var objectTag = "[object Object]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var symbolTag = "[object Symbol]";
      var weakMapTag = "[object WeakMap]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var float32Tag = "[object Float32Array]";
      var float64Tag = "[object Float64Array]";
      var int8Tag = "[object Int8Array]";
      var int16Tag = "[object Int16Array]";
      var int32Tag = "[object Int32Array]";
      var uint8Tag = "[object Uint8Array]";
      var uint8ClampedTag = "[object Uint8ClampedArray]";
      var uint16Tag = "[object Uint16Array]";
      var uint32Tag = "[object Uint32Array]";
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== void 0) {
          return result;
        }
        if (!isObject3(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer2(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? void 0 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result;
      }
      module2.exports = baseClone;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/clone.js
  var require_clone = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/clone.js"(exports2, module2) {
      var baseClone = require_baseClone();
      var CLONE_SYMBOLS_FLAG = 4;
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      module2.exports = clone;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/print.js
  var require_print = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/print.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.PRINT_WARNING = exports2.PRINT_ERROR = void 0;
      function PRINT_ERROR(msg) {
        if (console && console.error) {
          console.error("Error: ".concat(msg));
        }
      }
      exports2.PRINT_ERROR = PRINT_ERROR;
      function PRINT_WARNING(msg) {
        if (console && console.warn) {
          console.warn("Warning: ".concat(msg));
        }
      }
      exports2.PRINT_WARNING = PRINT_WARNING;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/timer.js
  var require_timer = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/timer.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.timer = void 0;
      function timer(func) {
        var start = (/* @__PURE__ */ new Date()).getTime();
        var val = func();
        var end = (/* @__PURE__ */ new Date()).getTime();
        var total = end - start;
        return { time: total, value: val };
      }
      exports2.timer = timer;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/to-fast-properties.js
  var require_to_fast_properties = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/to-fast-properties.js"(exports, module) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      exports.toFastProperties = void 0;
      function toFastProperties(toBecomeFast) {
        function FakeConstructor() {
        }
        FakeConstructor.prototype = toBecomeFast;
        var fakeInstance = new FakeConstructor();
        function fakeAccess() {
          return typeof fakeInstance.bar;
        }
        fakeAccess();
        fakeAccess();
        if (1)
          return toBecomeFast;
        eval(toBecomeFast);
      }
      exports.toFastProperties = toFastProperties;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/api.js
  var require_api = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+utils@10.5.0/node_modules/@chevrotain/utils/lib/src/api.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.toFastProperties = exports2.timer = exports2.PRINT_ERROR = exports2.PRINT_WARNING = void 0;
      var print_1 = require_print();
      Object.defineProperty(exports2, "PRINT_WARNING", { enumerable: true, get: function() {
        return print_1.PRINT_WARNING;
      } });
      Object.defineProperty(exports2, "PRINT_ERROR", { enumerable: true, get: function() {
        return print_1.PRINT_ERROR;
      } });
      var timer_1 = require_timer();
      Object.defineProperty(exports2, "timer", { enumerable: true, get: function() {
        return timer_1.timer;
      } });
      var to_fast_properties_1 = require_to_fast_properties();
      Object.defineProperty(exports2, "toFastProperties", { enumerable: true, get: function() {
        return to_fast_properties_1.toFastProperties;
      } });
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js
  var require_baseSlice = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSlice.js"(exports2, module2) {
      function baseSlice(array, start, end) {
        var index2 = -1, length2 = array.length;
        if (start < 0) {
          start = -start > length2 ? 0 : length2 + start;
        }
        end = end > length2 ? length2 : end;
        if (end < 0) {
          end += length2;
        }
        length2 = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length2);
        while (++index2 < length2) {
          result[index2] = array[index2 + start];
        }
        return result;
      }
      module2.exports = baseSlice;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_trimmedEndIndex.js
  var require_trimmedEndIndex = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_trimmedEndIndex.js"(exports2, module2) {
      var reWhitespace = /\s/;
      function trimmedEndIndex(string) {
        var index2 = string.length;
        while (index2-- && reWhitespace.test(string.charAt(index2))) {
        }
        return index2;
      }
      module2.exports = trimmedEndIndex;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTrim.js
  var require_baseTrim = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseTrim.js"(exports2, module2) {
      var trimmedEndIndex = require_trimmedEndIndex();
      var reTrimStart = /^\s+/;
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      module2.exports = baseTrim;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toNumber.js
  var require_toNumber = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toNumber.js"(exports2, module2) {
      var baseTrim = require_baseTrim();
      var isObject3 = require_isObject();
      var isSymbol = require_isSymbol();
      var NAN = 0 / 0;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsOctal = /^0o[0-7]+$/i;
      var freeParseInt = parseInt;
      function toNumber3(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject3(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject3(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      module2.exports = toNumber3;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toFinite.js
  var require_toFinite = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toFinite.js"(exports2, module2) {
      var toNumber3 = require_toNumber();
      var INFINITY = 1 / 0;
      var MAX_INTEGER2 = 17976931348623157e292;
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber3(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign6 = value < 0 ? -1 : 1;
          return sign6 * MAX_INTEGER2;
        }
        return value === value ? value : 0;
      }
      module2.exports = toFinite;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toInteger.js
  var require_toInteger = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/toInteger.js"(exports2, module2) {
      var toFinite = require_toFinite();
      function toInteger(value) {
        var result = toFinite(value), remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }
      module2.exports = toInteger;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/drop.js
  var require_drop = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/drop.js"(exports2, module2) {
      var baseSlice = require_baseSlice();
      var toInteger = require_toInteger();
      function drop(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === void 0 ? 1 : toInteger(n2);
        return baseSlice(array, n2 < 0 ? 0 : n2, length2);
      }
      module2.exports = drop;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js
  var require_isString = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isString.js"(exports2, module2) {
      var baseGetTag = require_baseGetTag();
      var isArray2 = require_isArray();
      var isObjectLike = require_isObjectLike();
      var stringTag = "[object String]";
      function isString3(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      module2.exports = isString3;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsRegExp.js
  var require_baseIsRegExp = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsRegExp.js"(exports2, module2) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var regexpTag = "[object RegExp]";
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      module2.exports = baseIsRegExp;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isRegExp.js
  var require_isRegExp = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isRegExp.js"(exports2, module2) {
      var baseIsRegExp = require_baseIsRegExp();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
      var isRegExp2 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      module2.exports = isRegExp2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSet.js
  var require_baseSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSet.js"(exports2, module2) {
      var assignValue = require_assignValue();
      var castPath = require_castPath();
      var isIndex = require_isIndex();
      var isObject3 = require_isObject();
      var toKey = require_toKey();
      function baseSet(object, path3, value, customizer) {
        if (!isObject3(object)) {
          return object;
        }
        path3 = castPath(path3, object);
        var index2 = -1, length2 = path3.length, lastIndex = length2 - 1, nested = object;
        while (nested != null && ++index2 < length2) {
          var key = toKey(path3[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : void 0;
            if (newValue === void 0) {
              newValue = isObject3(objValue) ? objValue : isIndex(path3[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      module2.exports = baseSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePickBy.js
  var require_basePickBy = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_basePickBy.js"(exports2, module2) {
      var baseGet = require_baseGet();
      var baseSet = require_baseSet();
      var castPath = require_castPath();
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length2 = paths.length, result = {};
        while (++index2 < length2) {
          var path3 = paths[index2], value = baseGet(object, path3);
          if (predicate(value, path3)) {
            baseSet(result, castPath(path3, object), value);
          }
        }
        return result;
      }
      module2.exports = basePickBy;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/pickBy.js
  var require_pickBy = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/pickBy.js"(exports2, module2) {
      var arrayMap = require_arrayMap();
      var baseIteratee = require_baseIteratee();
      var basePickBy = require_basePickBy();
      var getAllKeysIn = require_getAllKeysIn();
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = baseIteratee(predicate);
        return basePickBy(object, props, function(value, path3) {
          return predicate(value, path3[0]);
        });
      }
      module2.exports = pickBy;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_apply.js
  var require_apply = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_apply.js"(exports2, module2) {
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      module2.exports = apply;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overRest.js
  var require_overRest = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_overRest.js"(exports2, module2) {
      var apply = require_apply();
      var nativeMax = Math.max;
      function overRest(func, start, transform) {
        start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length2 = nativeMax(args.length - start, 0), array = Array(length2);
          while (++index2 < length2) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }
      module2.exports = overRest;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/constant.js
  var require_constant = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/constant.js"(exports2, module2) {
      function constant(value) {
        return function() {
          return value;
        };
      }
      module2.exports = constant;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSetToString.js
  var require_baseSetToString = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSetToString.js"(exports2, module2) {
      var constant = require_constant();
      var defineProperty = require_defineProperty();
      var identity = require_identity();
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      module2.exports = baseSetToString;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_shortOut.js
  var require_shortOut = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_shortOut.js"(exports2, module2) {
      var HOT_COUNT = 800;
      var HOT_SPAN = 16;
      var nativeNow = Date.now;
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(void 0, arguments);
        };
      }
      module2.exports = shortOut;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToString.js
  var require_setToString = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_setToString.js"(exports2, module2) {
      var baseSetToString = require_baseSetToString();
      var shortOut = require_shortOut();
      var setToString = shortOut(baseSetToString);
      module2.exports = setToString;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRest.js
  var require_baseRest = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseRest.js"(exports2, module2) {
      var identity = require_identity();
      var overRest = require_overRest();
      var setToString = require_setToString();
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      module2.exports = baseRest;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIterateeCall.js
  var require_isIterateeCall = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isIterateeCall.js"(exports2, module2) {
      var eq = require_eq();
      var isArrayLike = require_isArrayLike();
      var isIndex = require_isIndex();
      var isObject3 = require_isObject();
      function isIterateeCall(value, index2, object) {
        if (!isObject3(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      module2.exports = isIterateeCall;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createAssigner.js
  var require_createAssigner = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createAssigner.js"(exports2, module2) {
      var baseRest = require_baseRest();
      var isIterateeCall = require_isIterateeCall();
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : void 0, guard = length2 > 2 ? sources[2] : void 0;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length2 < 3 ? void 0 : customizer;
            length2 = 1;
          }
          object = Object(object);
          while (++index2 < length2) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      module2.exports = createAssigner;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/assign.js
  var require_assign = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/assign.js"(exports2, module2) {
      var assignValue = require_assignValue();
      var copyObject = require_copyObject();
      var createAssigner = require_createAssigner();
      var isArrayLike = require_isArrayLike();
      var isPrototype = require_isPrototype();
      var keys = require_keys();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var assign2 = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      module2.exports = assign2;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/model.js
  var require_model = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/model.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.serializeProduction = exports2.serializeGrammar = exports2.Terminal = exports2.Alternation = exports2.RepetitionWithSeparator = exports2.Repetition = exports2.RepetitionMandatoryWithSeparator = exports2.RepetitionMandatory = exports2.Option = exports2.Alternative = exports2.Rule = exports2.NonTerminal = exports2.AbstractProduction = void 0;
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var isString_1 = __importDefault(require_isString());
      var isRegExp_1 = __importDefault(require_isRegExp());
      var pickBy_1 = __importDefault(require_pickBy());
      var assign_1 = __importDefault(require_assign());
      function tokenLabel2(tokType) {
        if (hasTokenLabel(tokType)) {
          return tokType.LABEL;
        } else {
          return tokType.name;
        }
      }
      function hasTokenLabel(obj) {
        return (0, isString_1.default)(obj.LABEL) && obj.LABEL !== "";
      }
      var AbstractProduction = (
        /** @class */
        function() {
          function AbstractProduction2(_definition) {
            this._definition = _definition;
          }
          Object.defineProperty(AbstractProduction2.prototype, "definition", {
            get: function() {
              return this._definition;
            },
            set: function(value) {
              this._definition = value;
            },
            enumerable: false,
            configurable: true
          });
          AbstractProduction2.prototype.accept = function(visitor) {
            visitor.visit(this);
            (0, forEach_1.default)(this.definition, function(prod) {
              prod.accept(visitor);
            });
          };
          return AbstractProduction2;
        }()
      );
      exports2.AbstractProduction = AbstractProduction;
      var NonTerminal2 = (
        /** @class */
        function(_super) {
          __extends(NonTerminal3, _super);
          function NonTerminal3(options) {
            var _this = _super.call(this, []) || this;
            _this.idx = 1;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          Object.defineProperty(NonTerminal3.prototype, "definition", {
            get: function() {
              if (this.referencedRule !== void 0) {
                return this.referencedRule.definition;
              }
              return [];
            },
            set: function(definition) {
            },
            enumerable: false,
            configurable: true
          });
          NonTerminal3.prototype.accept = function(visitor) {
            visitor.visit(this);
          };
          return NonTerminal3;
        }(AbstractProduction)
      );
      exports2.NonTerminal = NonTerminal2;
      var Rule2 = (
        /** @class */
        function(_super) {
          __extends(Rule3, _super);
          function Rule3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.orgText = "";
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return Rule3;
        }(AbstractProduction)
      );
      exports2.Rule = Rule2;
      var Alternative2 = (
        /** @class */
        function(_super) {
          __extends(Alternative3, _super);
          function Alternative3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.ignoreAmbiguities = false;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return Alternative3;
        }(AbstractProduction)
      );
      exports2.Alternative = Alternative2;
      var Option2 = (
        /** @class */
        function(_super) {
          __extends(Option3, _super);
          function Option3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.idx = 1;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return Option3;
        }(AbstractProduction)
      );
      exports2.Option = Option2;
      var RepetitionMandatory2 = (
        /** @class */
        function(_super) {
          __extends(RepetitionMandatory3, _super);
          function RepetitionMandatory3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.idx = 1;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return RepetitionMandatory3;
        }(AbstractProduction)
      );
      exports2.RepetitionMandatory = RepetitionMandatory2;
      var RepetitionMandatoryWithSeparator2 = (
        /** @class */
        function(_super) {
          __extends(RepetitionMandatoryWithSeparator3, _super);
          function RepetitionMandatoryWithSeparator3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.idx = 1;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return RepetitionMandatoryWithSeparator3;
        }(AbstractProduction)
      );
      exports2.RepetitionMandatoryWithSeparator = RepetitionMandatoryWithSeparator2;
      var Repetition2 = (
        /** @class */
        function(_super) {
          __extends(Repetition3, _super);
          function Repetition3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.idx = 1;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return Repetition3;
        }(AbstractProduction)
      );
      exports2.Repetition = Repetition2;
      var RepetitionWithSeparator2 = (
        /** @class */
        function(_super) {
          __extends(RepetitionWithSeparator3, _super);
          function RepetitionWithSeparator3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.idx = 1;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          return RepetitionWithSeparator3;
        }(AbstractProduction)
      );
      exports2.RepetitionWithSeparator = RepetitionWithSeparator2;
      var Alternation2 = (
        /** @class */
        function(_super) {
          __extends(Alternation3, _super);
          function Alternation3(options) {
            var _this = _super.call(this, options.definition) || this;
            _this.idx = 1;
            _this.ignoreAmbiguities = false;
            _this.hasPredicates = false;
            (0, assign_1.default)(_this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
            return _this;
          }
          Object.defineProperty(Alternation3.prototype, "definition", {
            get: function() {
              return this._definition;
            },
            set: function(value) {
              this._definition = value;
            },
            enumerable: false,
            configurable: true
          });
          return Alternation3;
        }(AbstractProduction)
      );
      exports2.Alternation = Alternation2;
      var Terminal2 = (
        /** @class */
        function() {
          function Terminal3(options) {
            this.idx = 1;
            (0, assign_1.default)(this, (0, pickBy_1.default)(options, function(v) {
              return v !== void 0;
            }));
          }
          Terminal3.prototype.accept = function(visitor) {
            visitor.visit(this);
          };
          return Terminal3;
        }()
      );
      exports2.Terminal = Terminal2;
      function serializeGrammar2(topRules) {
        return (0, map_1.default)(topRules, serializeProduction2);
      }
      exports2.serializeGrammar = serializeGrammar2;
      function serializeProduction2(node) {
        function convertDefinition(definition) {
          return (0, map_1.default)(definition, serializeProduction2);
        }
        if (node instanceof NonTerminal2) {
          var serializedNonTerminal = {
            type: "NonTerminal",
            name: node.nonTerminalName,
            idx: node.idx
          };
          if ((0, isString_1.default)(node.label)) {
            serializedNonTerminal.label = node.label;
          }
          return serializedNonTerminal;
        } else if (node instanceof Alternative2) {
          return {
            type: "Alternative",
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof Option2) {
          return {
            type: "Option",
            idx: node.idx,
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof RepetitionMandatory2) {
          return {
            type: "RepetitionMandatory",
            idx: node.idx,
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof RepetitionMandatoryWithSeparator2) {
          return {
            type: "RepetitionMandatoryWithSeparator",
            idx: node.idx,
            separator: serializeProduction2(new Terminal2({ terminalType: node.separator })),
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof RepetitionWithSeparator2) {
          return {
            type: "RepetitionWithSeparator",
            idx: node.idx,
            separator: serializeProduction2(new Terminal2({ terminalType: node.separator })),
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof Repetition2) {
          return {
            type: "Repetition",
            idx: node.idx,
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof Alternation2) {
          return {
            type: "Alternation",
            idx: node.idx,
            definition: convertDefinition(node.definition)
          };
        } else if (node instanceof Terminal2) {
          var serializedTerminal = {
            type: "Terminal",
            name: node.terminalType.name,
            label: tokenLabel2(node.terminalType),
            idx: node.idx
          };
          if ((0, isString_1.default)(node.label)) {
            serializedTerminal.terminalLabel = node.label;
          }
          var pattern2 = node.terminalType.PATTERN;
          if (node.terminalType.PATTERN) {
            serializedTerminal.pattern = (0, isRegExp_1.default)(pattern2) ? pattern2.source : pattern2;
          }
          return serializedTerminal;
        } else if (node instanceof Rule2) {
          return {
            type: "Rule",
            name: node.name,
            orgText: node.orgText,
            definition: convertDefinition(node.definition)
          };
        } else {
          throw Error("non exhaustive match");
        }
      }
      exports2.serializeProduction = serializeProduction2;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/visitor.js
  var require_visitor = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/visitor.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.GAstVisitor = void 0;
      var model_1 = require_model();
      var GAstVisitor2 = (
        /** @class */
        function() {
          function GAstVisitor3() {
          }
          GAstVisitor3.prototype.visit = function(node) {
            var nodeAny = node;
            switch (nodeAny.constructor) {
              case model_1.NonTerminal:
                return this.visitNonTerminal(nodeAny);
              case model_1.Alternative:
                return this.visitAlternative(nodeAny);
              case model_1.Option:
                return this.visitOption(nodeAny);
              case model_1.RepetitionMandatory:
                return this.visitRepetitionMandatory(nodeAny);
              case model_1.RepetitionMandatoryWithSeparator:
                return this.visitRepetitionMandatoryWithSeparator(nodeAny);
              case model_1.RepetitionWithSeparator:
                return this.visitRepetitionWithSeparator(nodeAny);
              case model_1.Repetition:
                return this.visitRepetition(nodeAny);
              case model_1.Alternation:
                return this.visitAlternation(nodeAny);
              case model_1.Terminal:
                return this.visitTerminal(nodeAny);
              case model_1.Rule:
                return this.visitRule(nodeAny);
              default:
                throw Error("non exhaustive match");
            }
          };
          GAstVisitor3.prototype.visitNonTerminal = function(node) {
          };
          GAstVisitor3.prototype.visitAlternative = function(node) {
          };
          GAstVisitor3.prototype.visitOption = function(node) {
          };
          GAstVisitor3.prototype.visitRepetition = function(node) {
          };
          GAstVisitor3.prototype.visitRepetitionMandatory = function(node) {
          };
          GAstVisitor3.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
          };
          GAstVisitor3.prototype.visitRepetitionWithSeparator = function(node) {
          };
          GAstVisitor3.prototype.visitAlternation = function(node) {
          };
          GAstVisitor3.prototype.visitTerminal = function(node) {
          };
          GAstVisitor3.prototype.visitRule = function(node) {
          };
          return GAstVisitor3;
        }()
      );
      exports2.GAstVisitor = GAstVisitor2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSome.js
  var require_baseSome = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseSome.js"(exports2, module2) {
      var baseEach = require_baseEach();
      function baseSome(collection, predicate) {
        var result;
        baseEach(collection, function(value, index2, collection2) {
          result = predicate(value, index2, collection2);
          return !result;
        });
        return !!result;
      }
      module2.exports = baseSome;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/some.js
  var require_some = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/some.js"(exports2, module2) {
      var arraySome = require_arraySome();
      var baseIteratee = require_baseIteratee();
      var baseSome = require_baseSome();
      var isArray2 = require_isArray();
      var isIterateeCall = require_isIterateeCall();
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = void 0;
        }
        return func(collection, baseIteratee(predicate, 3));
      }
      module2.exports = some;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayEvery.js
  var require_arrayEvery = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayEvery.js"(exports2, module2) {
      function arrayEvery(array, predicate) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (!predicate(array[index2], index2, array)) {
            return false;
          }
        }
        return true;
      }
      module2.exports = arrayEvery;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEvery.js
  var require_baseEvery = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseEvery.js"(exports2, module2) {
      var baseEach = require_baseEach();
      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function(value, index2, collection2) {
          result = !!predicate(value, index2, collection2);
          return result;
        });
        return result;
      }
      module2.exports = baseEvery;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/every.js
  var require_every = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/every.js"(exports2, module2) {
      var arrayEvery = require_arrayEvery();
      var baseEvery = require_baseEvery();
      var baseIteratee = require_baseIteratee();
      var isArray2 = require_isArray();
      var isIterateeCall = require_isIterateeCall();
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = void 0;
        }
        return func(collection, baseIteratee(predicate, 3));
      }
      module2.exports = every;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js
  var require_baseFindIndex = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFindIndex.js"(exports2, module2) {
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index2-- : ++index2 < length2) {
          if (predicate(array[index2], index2, array)) {
            return index2;
          }
        }
        return -1;
      }
      module2.exports = baseFindIndex;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js
  var require_baseIsNaN = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIsNaN.js"(exports2, module2) {
      function baseIsNaN(value) {
        return value !== value;
      }
      module2.exports = baseIsNaN;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js
  var require_strictIndexOf = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_strictIndexOf.js"(exports2, module2) {
      function strictIndexOf(array, value, fromIndex) {
        var index2 = fromIndex - 1, length2 = array.length;
        while (++index2 < length2) {
          if (array[index2] === value) {
            return index2;
          }
        }
        return -1;
      }
      module2.exports = strictIndexOf;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js
  var require_baseIndexOf = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseIndexOf.js"(exports2, module2) {
      var baseFindIndex = require_baseFindIndex();
      var baseIsNaN = require_baseIsNaN();
      var strictIndexOf = require_strictIndexOf();
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      module2.exports = baseIndexOf;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/includes.js
  var require_includes = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/includes.js"(exports2, module2) {
      var baseIndexOf = require_baseIndexOf();
      var isArrayLike = require_isArrayLike();
      var isString3 = require_isString();
      var toInteger = require_toInteger();
      var values = require_values();
      var nativeMax = Math.max;
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length2 = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length2 + fromIndex, 0);
        }
        return isString3(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value, fromIndex) > -1;
      }
      module2.exports = includes;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/helpers.js
  var require_helpers = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/helpers.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.getProductionDslName = exports2.isBranchingProd = exports2.isOptionalProd = exports2.isSequenceProd = void 0;
      var some_1 = __importDefault(require_some());
      var every_1 = __importDefault(require_every());
      var includes_1 = __importDefault(require_includes());
      var model_1 = require_model();
      function isSequenceProd(prod) {
        return prod instanceof model_1.Alternative || prod instanceof model_1.Option || prod instanceof model_1.Repetition || prod instanceof model_1.RepetitionMandatory || prod instanceof model_1.RepetitionMandatoryWithSeparator || prod instanceof model_1.RepetitionWithSeparator || prod instanceof model_1.Terminal || prod instanceof model_1.Rule;
      }
      exports2.isSequenceProd = isSequenceProd;
      function isOptionalProd(prod, alreadyVisited) {
        if (alreadyVisited === void 0) {
          alreadyVisited = [];
        }
        var isDirectlyOptional = prod instanceof model_1.Option || prod instanceof model_1.Repetition || prod instanceof model_1.RepetitionWithSeparator;
        if (isDirectlyOptional) {
          return true;
        }
        if (prod instanceof model_1.Alternation) {
          return (0, some_1.default)(prod.definition, function(subProd) {
            return isOptionalProd(subProd, alreadyVisited);
          });
        } else if (prod instanceof model_1.NonTerminal && (0, includes_1.default)(alreadyVisited, prod)) {
          return false;
        } else if (prod instanceof model_1.AbstractProduction) {
          if (prod instanceof model_1.NonTerminal) {
            alreadyVisited.push(prod);
          }
          return (0, every_1.default)(prod.definition, function(subProd) {
            return isOptionalProd(subProd, alreadyVisited);
          });
        } else {
          return false;
        }
      }
      exports2.isOptionalProd = isOptionalProd;
      function isBranchingProd(prod) {
        return prod instanceof model_1.Alternation;
      }
      exports2.isBranchingProd = isBranchingProd;
      function getProductionDslName(prod) {
        if (prod instanceof model_1.NonTerminal) {
          return "SUBRULE";
        } else if (prod instanceof model_1.Option) {
          return "OPTION";
        } else if (prod instanceof model_1.Alternation) {
          return "OR";
        } else if (prod instanceof model_1.RepetitionMandatory) {
          return "AT_LEAST_ONE";
        } else if (prod instanceof model_1.RepetitionMandatoryWithSeparator) {
          return "AT_LEAST_ONE_SEP";
        } else if (prod instanceof model_1.RepetitionWithSeparator) {
          return "MANY_SEP";
        } else if (prod instanceof model_1.Repetition) {
          return "MANY";
        } else if (prod instanceof model_1.Terminal) {
          return "CONSUME";
        } else {
          throw Error("non exhaustive match");
        }
      }
      exports2.getProductionDslName = getProductionDslName;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/api.js
  var require_api2 = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+gast@10.5.0/node_modules/@chevrotain/gast/lib/src/api.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.isSequenceProd = exports2.isBranchingProd = exports2.isOptionalProd = exports2.getProductionDslName = exports2.GAstVisitor = exports2.serializeProduction = exports2.serializeGrammar = exports2.Alternative = exports2.Alternation = exports2.RepetitionWithSeparator = exports2.RepetitionMandatoryWithSeparator = exports2.RepetitionMandatory = exports2.Repetition = exports2.Option = exports2.NonTerminal = exports2.Terminal = exports2.Rule = void 0;
      var model_1 = require_model();
      Object.defineProperty(exports2, "Rule", { enumerable: true, get: function() {
        return model_1.Rule;
      } });
      Object.defineProperty(exports2, "Terminal", { enumerable: true, get: function() {
        return model_1.Terminal;
      } });
      Object.defineProperty(exports2, "NonTerminal", { enumerable: true, get: function() {
        return model_1.NonTerminal;
      } });
      Object.defineProperty(exports2, "Option", { enumerable: true, get: function() {
        return model_1.Option;
      } });
      Object.defineProperty(exports2, "Repetition", { enumerable: true, get: function() {
        return model_1.Repetition;
      } });
      Object.defineProperty(exports2, "RepetitionMandatory", { enumerable: true, get: function() {
        return model_1.RepetitionMandatory;
      } });
      Object.defineProperty(exports2, "RepetitionMandatoryWithSeparator", { enumerable: true, get: function() {
        return model_1.RepetitionMandatoryWithSeparator;
      } });
      Object.defineProperty(exports2, "RepetitionWithSeparator", { enumerable: true, get: function() {
        return model_1.RepetitionWithSeparator;
      } });
      Object.defineProperty(exports2, "Alternation", { enumerable: true, get: function() {
        return model_1.Alternation;
      } });
      Object.defineProperty(exports2, "Alternative", { enumerable: true, get: function() {
        return model_1.Alternative;
      } });
      Object.defineProperty(exports2, "serializeGrammar", { enumerable: true, get: function() {
        return model_1.serializeGrammar;
      } });
      Object.defineProperty(exports2, "serializeProduction", { enumerable: true, get: function() {
        return model_1.serializeProduction;
      } });
      var visitor_1 = require_visitor();
      Object.defineProperty(exports2, "GAstVisitor", { enumerable: true, get: function() {
        return visitor_1.GAstVisitor;
      } });
      var helpers_1 = require_helpers();
      Object.defineProperty(exports2, "getProductionDslName", { enumerable: true, get: function() {
        return helpers_1.getProductionDslName;
      } });
      Object.defineProperty(exports2, "isOptionalProd", { enumerable: true, get: function() {
        return helpers_1.isOptionalProd;
      } });
      Object.defineProperty(exports2, "isBranchingProd", { enumerable: true, get: function() {
        return helpers_1.isBranchingProd;
      } });
      Object.defineProperty(exports2, "isSequenceProd", { enumerable: true, get: function() {
        return helpers_1.isSequenceProd;
      } });
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/rest.js
  var require_rest = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/rest.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.RestWalker = void 0;
      var drop_1 = __importDefault(require_drop());
      var forEach_1 = __importDefault(require_forEach());
      var gast_1 = require_api2();
      var RestWalker = (
        /** @class */
        function() {
          function RestWalker2() {
          }
          RestWalker2.prototype.walk = function(prod, prevRest) {
            var _this = this;
            if (prevRest === void 0) {
              prevRest = [];
            }
            (0, forEach_1.default)(prod.definition, function(subProd, index2) {
              var currRest = (0, drop_1.default)(prod.definition, index2 + 1);
              if (subProd instanceof gast_1.NonTerminal) {
                _this.walkProdRef(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.Terminal) {
                _this.walkTerminal(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.Alternative) {
                _this.walkFlat(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.Option) {
                _this.walkOption(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.RepetitionMandatory) {
                _this.walkAtLeastOne(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.RepetitionMandatoryWithSeparator) {
                _this.walkAtLeastOneSep(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.RepetitionWithSeparator) {
                _this.walkManySep(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.Repetition) {
                _this.walkMany(subProd, currRest, prevRest);
              } else if (subProd instanceof gast_1.Alternation) {
                _this.walkOr(subProd, currRest, prevRest);
              } else {
                throw Error("non exhaustive match");
              }
            });
          };
          RestWalker2.prototype.walkTerminal = function(terminal, currRest, prevRest) {
          };
          RestWalker2.prototype.walkProdRef = function(refProd, currRest, prevRest) {
          };
          RestWalker2.prototype.walkFlat = function(flatProd, currRest, prevRest) {
            var fullOrRest = currRest.concat(prevRest);
            this.walk(flatProd, fullOrRest);
          };
          RestWalker2.prototype.walkOption = function(optionProd, currRest, prevRest) {
            var fullOrRest = currRest.concat(prevRest);
            this.walk(optionProd, fullOrRest);
          };
          RestWalker2.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
            var fullAtLeastOneRest = [
              new gast_1.Option({ definition: atLeastOneProd.definition })
            ].concat(currRest, prevRest);
            this.walk(atLeastOneProd, fullAtLeastOneRest);
          };
          RestWalker2.prototype.walkAtLeastOneSep = function(atLeastOneSepProd, currRest, prevRest) {
            var fullAtLeastOneSepRest = restForRepetitionWithSeparator(atLeastOneSepProd, currRest, prevRest);
            this.walk(atLeastOneSepProd, fullAtLeastOneSepRest);
          };
          RestWalker2.prototype.walkMany = function(manyProd, currRest, prevRest) {
            var fullManyRest = [
              new gast_1.Option({ definition: manyProd.definition })
            ].concat(currRest, prevRest);
            this.walk(manyProd, fullManyRest);
          };
          RestWalker2.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
            var fullManySepRest = restForRepetitionWithSeparator(manySepProd, currRest, prevRest);
            this.walk(manySepProd, fullManySepRest);
          };
          RestWalker2.prototype.walkOr = function(orProd, currRest, prevRest) {
            var _this = this;
            var fullOrRest = currRest.concat(prevRest);
            (0, forEach_1.default)(orProd.definition, function(alt) {
              var prodWrapper = new gast_1.Alternative({ definition: [alt] });
              _this.walk(prodWrapper, fullOrRest);
            });
          };
          return RestWalker2;
        }()
      );
      exports2.RestWalker = RestWalker;
      function restForRepetitionWithSeparator(repSepProd, currRest, prevRest) {
        var repSepRest = [
          new gast_1.Option({
            definition: [
              new gast_1.Terminal({ terminalType: repSepProd.separator })
            ].concat(repSepProd.definition)
          })
        ];
        var fullRepSepRest = repSepRest.concat(currRest, prevRest);
        return fullRepSepRest;
      }
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isFlattenable.js
  var require_isFlattenable = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_isFlattenable.js"(exports2, module2) {
      var Symbol2 = require_Symbol();
      var isArguments = require_isArguments();
      var isArray2 = require_isArray();
      var spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      module2.exports = isFlattenable;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFlatten.js
  var require_baseFlatten = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFlatten.js"(exports2, module2) {
      var arrayPush = require_arrayPush();
      var isFlattenable = require_isFlattenable();
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index2 = -1, length2 = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);
        while (++index2 < length2) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }
      module2.exports = baseFlatten;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatten.js
  var require_flatten = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatten.js"(exports2, module2) {
      var baseFlatten = require_baseFlatten();
      function flatten2(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseFlatten(array, 1) : [];
      }
      module2.exports = flatten2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludes.js
  var require_arrayIncludes = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludes.js"(exports2, module2) {
      var baseIndexOf = require_baseIndexOf();
      function arrayIncludes(array, value) {
        var length2 = array == null ? 0 : array.length;
        return !!length2 && baseIndexOf(array, value, 0) > -1;
      }
      module2.exports = arrayIncludes;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludesWith.js
  var require_arrayIncludesWith = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayIncludesWith.js"(exports2, module2) {
      function arrayIncludesWith(array, value, comparator) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          if (comparator(value, array[index2])) {
            return true;
          }
        }
        return false;
      }
      module2.exports = arrayIncludesWith;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/noop.js
  var require_noop = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/noop.js"(exports2, module2) {
      function noop2() {
      }
      module2.exports = noop2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createSet.js
  var require_createSet = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createSet.js"(exports2, module2) {
      var Set2 = require_Set();
      var noop2 = require_noop();
      var setToArray = require_setToArray();
      var INFINITY = 1 / 0;
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values) {
        return new Set2(values);
      };
      module2.exports = createSet;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUniq.js
  var require_baseUniq = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseUniq.js"(exports2, module2) {
      var SetCache = require_SetCache();
      var arrayIncludes = require_arrayIncludes();
      var arrayIncludesWith = require_arrayIncludesWith();
      var cacheHas = require_cacheHas();
      var createSet = require_createSet();
      var setToArray = require_setToArray();
      var LARGE_ARRAY_SIZE = 200;
      function baseUniq(array, iteratee, comparator) {
        var index2 = -1, includes = arrayIncludes, length2 = array.length, isCommon = true, result = [], seen = result;
        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length2 >= LARGE_ARRAY_SIZE) {
          var set4 = iteratee ? null : createSet(array);
          if (set4) {
            return setToArray(set4);
          }
          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }
        outer:
          while (++index2 < length2) {
            var value = array[index2], computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee) {
                seen.push(computed);
              }
              result.push(value);
            } else if (!includes(seen, computed, comparator)) {
              if (seen !== result) {
                seen.push(computed);
              }
              result.push(value);
            }
          }
        return result;
      }
      module2.exports = baseUniq;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniq.js
  var require_uniq = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/uniq.js"(exports2, module2) {
      var baseUniq = require_baseUniq();
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      module2.exports = uniq;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/first.js
  var require_first = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/first.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.firstForTerminal = exports2.firstForBranching = exports2.firstForSequence = exports2.first = void 0;
      var flatten_1 = __importDefault(require_flatten());
      var uniq_1 = __importDefault(require_uniq());
      var map_1 = __importDefault(require_map());
      var gast_1 = require_api2();
      var gast_2 = require_api2();
      function first(prod) {
        if (prod instanceof gast_1.NonTerminal) {
          return first(prod.referencedRule);
        } else if (prod instanceof gast_1.Terminal) {
          return firstForTerminal(prod);
        } else if ((0, gast_2.isSequenceProd)(prod)) {
          return firstForSequence(prod);
        } else if ((0, gast_2.isBranchingProd)(prod)) {
          return firstForBranching(prod);
        } else {
          throw Error("non exhaustive match");
        }
      }
      exports2.first = first;
      function firstForSequence(prod) {
        var firstSet = [];
        var seq = prod.definition;
        var nextSubProdIdx = 0;
        var hasInnerProdsRemaining = seq.length > nextSubProdIdx;
        var currSubProd;
        var isLastInnerProdOptional = true;
        while (hasInnerProdsRemaining && isLastInnerProdOptional) {
          currSubProd = seq[nextSubProdIdx];
          isLastInnerProdOptional = (0, gast_2.isOptionalProd)(currSubProd);
          firstSet = firstSet.concat(first(currSubProd));
          nextSubProdIdx = nextSubProdIdx + 1;
          hasInnerProdsRemaining = seq.length > nextSubProdIdx;
        }
        return (0, uniq_1.default)(firstSet);
      }
      exports2.firstForSequence = firstForSequence;
      function firstForBranching(prod) {
        var allAlternativesFirsts = (0, map_1.default)(prod.definition, function(innerProd) {
          return first(innerProd);
        });
        return (0, uniq_1.default)((0, flatten_1.default)(allAlternativesFirsts));
      }
      exports2.firstForBranching = firstForBranching;
      function firstForTerminal(terminal) {
        return [terminal.terminalType];
      }
      exports2.firstForTerminal = firstForTerminal;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/constants.js
  var require_constants = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/constants.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.IN = void 0;
      exports2.IN = "_~IN~_";
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/follow.js
  var require_follow = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/follow.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.buildInProdFollowPrefix = exports2.buildBetweenProdsFollowPrefix = exports2.computeAllProdsFollows = exports2.ResyncFollowsWalker = void 0;
      var rest_1 = require_rest();
      var first_1 = require_first();
      var forEach_1 = __importDefault(require_forEach());
      var assign_1 = __importDefault(require_assign());
      var constants_1 = require_constants();
      var gast_1 = require_api2();
      var ResyncFollowsWalker = (
        /** @class */
        function(_super) {
          __extends(ResyncFollowsWalker2, _super);
          function ResyncFollowsWalker2(topProd) {
            var _this = _super.call(this) || this;
            _this.topProd = topProd;
            _this.follows = {};
            return _this;
          }
          ResyncFollowsWalker2.prototype.startWalking = function() {
            this.walk(this.topProd);
            return this.follows;
          };
          ResyncFollowsWalker2.prototype.walkTerminal = function(terminal, currRest, prevRest) {
          };
          ResyncFollowsWalker2.prototype.walkProdRef = function(refProd, currRest, prevRest) {
            var followName = buildBetweenProdsFollowPrefix(refProd.referencedRule, refProd.idx) + this.topProd.name;
            var fullRest = currRest.concat(prevRest);
            var restProd = new gast_1.Alternative({ definition: fullRest });
            var t_in_topProd_follows = (0, first_1.first)(restProd);
            this.follows[followName] = t_in_topProd_follows;
          };
          return ResyncFollowsWalker2;
        }(rest_1.RestWalker)
      );
      exports2.ResyncFollowsWalker = ResyncFollowsWalker;
      function computeAllProdsFollows(topProductions) {
        var reSyncFollows = {};
        (0, forEach_1.default)(topProductions, function(topProd) {
          var currRefsFollow = new ResyncFollowsWalker(topProd).startWalking();
          (0, assign_1.default)(reSyncFollows, currRefsFollow);
        });
        return reSyncFollows;
      }
      exports2.computeAllProdsFollows = computeAllProdsFollows;
      function buildBetweenProdsFollowPrefix(inner, occurenceInParent) {
        return inner.name + occurenceInParent + constants_1.IN;
      }
      exports2.buildBetweenProdsFollowPrefix = buildBetweenProdsFollowPrefix;
      function buildInProdFollowPrefix(terminal) {
        var terminalName = terminal.terminalType.name;
        return terminalName + terminal.idx + constants_1.IN;
      }
      exports2.buildInProdFollowPrefix = buildInProdFollowPrefix;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isUndefined.js
  var require_isUndefined = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isUndefined.js"(exports2, module2) {
      function isUndefined2(value) {
        return value === void 0;
      }
      module2.exports = isUndefined2;
    }
  });

  // ../../node_modules/.pnpm/regexp-to-ast@0.5.0/node_modules/regexp-to-ast/lib/regexp-to-ast.js
  var require_regexp_to_ast = __commonJS({
    "../../node_modules/.pnpm/regexp-to-ast@0.5.0/node_modules/regexp-to-ast/lib/regexp-to-ast.js"(exports2, module2) {
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory);
        } else if (typeof module2 === "object" && module2.exports) {
          module2.exports = factory();
        } else {
          root.regexpToAst = factory();
        }
      })(
        typeof self !== "undefined" ? (
          // istanbul ignore next
          self
        ) : exports2,
        function() {
          function RegExpParser() {
          }
          RegExpParser.prototype.saveState = function() {
            return {
              idx: this.idx,
              input: this.input,
              groupIdx: this.groupIdx
            };
          };
          RegExpParser.prototype.restoreState = function(newState) {
            this.idx = newState.idx;
            this.input = newState.input;
            this.groupIdx = newState.groupIdx;
          };
          RegExpParser.prototype.pattern = function(input) {
            this.idx = 0;
            this.input = input;
            this.groupIdx = 0;
            this.consumeChar("/");
            var value = this.disjunction();
            this.consumeChar("/");
            var flags = {
              type: "Flags",
              loc: { begin: this.idx, end: input.length },
              global: false,
              ignoreCase: false,
              multiLine: false,
              unicode: false,
              sticky: false
            };
            while (this.isRegExpFlag()) {
              switch (this.popChar()) {
                case "g":
                  addFlag(flags, "global");
                  break;
                case "i":
                  addFlag(flags, "ignoreCase");
                  break;
                case "m":
                  addFlag(flags, "multiLine");
                  break;
                case "u":
                  addFlag(flags, "unicode");
                  break;
                case "y":
                  addFlag(flags, "sticky");
                  break;
              }
            }
            if (this.idx !== this.input.length) {
              throw Error(
                "Redundant input: " + this.input.substring(this.idx)
              );
            }
            return {
              type: "Pattern",
              flags,
              value,
              loc: this.loc(0)
            };
          };
          RegExpParser.prototype.disjunction = function() {
            var alts = [];
            var begin = this.idx;
            alts.push(this.alternative());
            while (this.peekChar() === "|") {
              this.consumeChar("|");
              alts.push(this.alternative());
            }
            return { type: "Disjunction", value: alts, loc: this.loc(begin) };
          };
          RegExpParser.prototype.alternative = function() {
            var terms = [];
            var begin = this.idx;
            while (this.isTerm()) {
              terms.push(this.term());
            }
            return { type: "Alternative", value: terms, loc: this.loc(begin) };
          };
          RegExpParser.prototype.term = function() {
            if (this.isAssertion()) {
              return this.assertion();
            } else {
              return this.atom();
            }
          };
          RegExpParser.prototype.assertion = function() {
            var begin = this.idx;
            switch (this.popChar()) {
              case "^":
                return {
                  type: "StartAnchor",
                  loc: this.loc(begin)
                };
              case "$":
                return { type: "EndAnchor", loc: this.loc(begin) };
              case "\\":
                switch (this.popChar()) {
                  case "b":
                    return {
                      type: "WordBoundary",
                      loc: this.loc(begin)
                    };
                  case "B":
                    return {
                      type: "NonWordBoundary",
                      loc: this.loc(begin)
                    };
                }
                throw Error("Invalid Assertion Escape");
              case "(":
                this.consumeChar("?");
                var type;
                switch (this.popChar()) {
                  case "=":
                    type = "Lookahead";
                    break;
                  case "!":
                    type = "NegativeLookahead";
                    break;
                }
                ASSERT_EXISTS(type);
                var disjunction = this.disjunction();
                this.consumeChar(")");
                return {
                  type,
                  value: disjunction,
                  loc: this.loc(begin)
                };
            }
            ASSERT_NEVER_REACH_HERE();
          };
          RegExpParser.prototype.quantifier = function(isBacktracking) {
            var range;
            var begin = this.idx;
            switch (this.popChar()) {
              case "*":
                range = {
                  atLeast: 0,
                  atMost: Infinity
                };
                break;
              case "+":
                range = {
                  atLeast: 1,
                  atMost: Infinity
                };
                break;
              case "?":
                range = {
                  atLeast: 0,
                  atMost: 1
                };
                break;
              case "{":
                var atLeast = this.integerIncludingZero();
                switch (this.popChar()) {
                  case "}":
                    range = {
                      atLeast,
                      atMost: atLeast
                    };
                    break;
                  case ",":
                    var atMost;
                    if (this.isDigit()) {
                      atMost = this.integerIncludingZero();
                      range = {
                        atLeast,
                        atMost
                      };
                    } else {
                      range = {
                        atLeast,
                        atMost: Infinity
                      };
                    }
                    this.consumeChar("}");
                    break;
                }
                if (isBacktracking === true && range === void 0) {
                  return void 0;
                }
                ASSERT_EXISTS(range);
                break;
            }
            if (isBacktracking === true && range === void 0) {
              return void 0;
            }
            ASSERT_EXISTS(range);
            if (this.peekChar(0) === "?") {
              this.consumeChar("?");
              range.greedy = false;
            } else {
              range.greedy = true;
            }
            range.type = "Quantifier";
            range.loc = this.loc(begin);
            return range;
          };
          RegExpParser.prototype.atom = function() {
            var atom;
            var begin = this.idx;
            switch (this.peekChar()) {
              case ".":
                atom = this.dotAll();
                break;
              case "\\":
                atom = this.atomEscape();
                break;
              case "[":
                atom = this.characterClass();
                break;
              case "(":
                atom = this.group();
                break;
            }
            if (atom === void 0 && this.isPatternCharacter()) {
              atom = this.patternCharacter();
            }
            ASSERT_EXISTS(atom);
            atom.loc = this.loc(begin);
            if (this.isQuantifier()) {
              atom.quantifier = this.quantifier();
            }
            return atom;
          };
          RegExpParser.prototype.dotAll = function() {
            this.consumeChar(".");
            return {
              type: "Set",
              complement: true,
              value: [cc("\n"), cc("\r"), cc("\u2028"), cc("\u2029")]
            };
          };
          RegExpParser.prototype.atomEscape = function() {
            this.consumeChar("\\");
            switch (this.peekChar()) {
              case "1":
              case "2":
              case "3":
              case "4":
              case "5":
              case "6":
              case "7":
              case "8":
              case "9":
                return this.decimalEscapeAtom();
              case "d":
              case "D":
              case "s":
              case "S":
              case "w":
              case "W":
                return this.characterClassEscape();
              case "f":
              case "n":
              case "r":
              case "t":
              case "v":
                return this.controlEscapeAtom();
              case "c":
                return this.controlLetterEscapeAtom();
              case "0":
                return this.nulCharacterAtom();
              case "x":
                return this.hexEscapeSequenceAtom();
              case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
              default:
                return this.identityEscapeAtom();
            }
          };
          RegExpParser.prototype.decimalEscapeAtom = function() {
            var value = this.positiveInteger();
            return { type: "GroupBackReference", value };
          };
          RegExpParser.prototype.characterClassEscape = function() {
            var set4;
            var complement = false;
            switch (this.popChar()) {
              case "d":
                set4 = digitsCharCodes;
                break;
              case "D":
                set4 = digitsCharCodes;
                complement = true;
                break;
              case "s":
                set4 = whitespaceCodes;
                break;
              case "S":
                set4 = whitespaceCodes;
                complement = true;
                break;
              case "w":
                set4 = wordCharCodes;
                break;
              case "W":
                set4 = wordCharCodes;
                complement = true;
                break;
            }
            ASSERT_EXISTS(set4);
            return { type: "Set", value: set4, complement };
          };
          RegExpParser.prototype.controlEscapeAtom = function() {
            var escapeCode;
            switch (this.popChar()) {
              case "f":
                escapeCode = cc("\f");
                break;
              case "n":
                escapeCode = cc("\n");
                break;
              case "r":
                escapeCode = cc("\r");
                break;
              case "t":
                escapeCode = cc("	");
                break;
              case "v":
                escapeCode = cc("\v");
                break;
            }
            ASSERT_EXISTS(escapeCode);
            return { type: "Character", value: escapeCode };
          };
          RegExpParser.prototype.controlLetterEscapeAtom = function() {
            this.consumeChar("c");
            var letter = this.popChar();
            if (/[a-zA-Z]/.test(letter) === false) {
              throw Error("Invalid ");
            }
            var letterCode = letter.toUpperCase().charCodeAt(0) - 64;
            return { type: "Character", value: letterCode };
          };
          RegExpParser.prototype.nulCharacterAtom = function() {
            this.consumeChar("0");
            return { type: "Character", value: cc("\0") };
          };
          RegExpParser.prototype.hexEscapeSequenceAtom = function() {
            this.consumeChar("x");
            return this.parseHexDigits(2);
          };
          RegExpParser.prototype.regExpUnicodeEscapeSequenceAtom = function() {
            this.consumeChar("u");
            return this.parseHexDigits(4);
          };
          RegExpParser.prototype.identityEscapeAtom = function() {
            var escapedChar = this.popChar();
            return { type: "Character", value: cc(escapedChar) };
          };
          RegExpParser.prototype.classPatternCharacterAtom = function() {
            switch (this.peekChar()) {
              case "\n":
              case "\r":
              case "\u2028":
              case "\u2029":
              case "\\":
              case "]":
                throw Error("TBD");
              default:
                var nextChar = this.popChar();
                return { type: "Character", value: cc(nextChar) };
            }
          };
          RegExpParser.prototype.characterClass = function() {
            var set4 = [];
            var complement = false;
            this.consumeChar("[");
            if (this.peekChar(0) === "^") {
              this.consumeChar("^");
              complement = true;
            }
            while (this.isClassAtom()) {
              var from = this.classAtom();
              var isFromSingleChar = from.type === "Character";
              if (isFromSingleChar && this.isRangeDash()) {
                this.consumeChar("-");
                var to = this.classAtom();
                var isToSingleChar = to.type === "Character";
                if (isToSingleChar) {
                  if (to.value < from.value) {
                    throw Error("Range out of order in character class");
                  }
                  set4.push({ from: from.value, to: to.value });
                } else {
                  insertToSet(from.value, set4);
                  set4.push(cc("-"));
                  insertToSet(to.value, set4);
                }
              } else {
                insertToSet(from.value, set4);
              }
            }
            this.consumeChar("]");
            return { type: "Set", complement, value: set4 };
          };
          RegExpParser.prototype.classAtom = function() {
            switch (this.peekChar()) {
              case "]":
              case "\n":
              case "\r":
              case "\u2028":
              case "\u2029":
                throw Error("TBD");
              case "\\":
                return this.classEscape();
              default:
                return this.classPatternCharacterAtom();
            }
          };
          RegExpParser.prototype.classEscape = function() {
            this.consumeChar("\\");
            switch (this.peekChar()) {
              case "b":
                this.consumeChar("b");
                return { type: "Character", value: cc("\b") };
              case "d":
              case "D":
              case "s":
              case "S":
              case "w":
              case "W":
                return this.characterClassEscape();
              case "f":
              case "n":
              case "r":
              case "t":
              case "v":
                return this.controlEscapeAtom();
              case "c":
                return this.controlLetterEscapeAtom();
              case "0":
                return this.nulCharacterAtom();
              case "x":
                return this.hexEscapeSequenceAtom();
              case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
              default:
                return this.identityEscapeAtom();
            }
          };
          RegExpParser.prototype.group = function() {
            var capturing = true;
            this.consumeChar("(");
            switch (this.peekChar(0)) {
              case "?":
                this.consumeChar("?");
                this.consumeChar(":");
                capturing = false;
                break;
              default:
                this.groupIdx++;
                break;
            }
            var value = this.disjunction();
            this.consumeChar(")");
            var groupAst = {
              type: "Group",
              capturing,
              value
            };
            if (capturing) {
              groupAst.idx = this.groupIdx;
            }
            return groupAst;
          };
          RegExpParser.prototype.positiveInteger = function() {
            var number2 = this.popChar();
            if (decimalPatternNoZero.test(number2) === false) {
              throw Error("Expecting a positive integer");
            }
            while (decimalPattern.test(this.peekChar(0))) {
              number2 += this.popChar();
            }
            return parseInt(number2, 10);
          };
          RegExpParser.prototype.integerIncludingZero = function() {
            var number2 = this.popChar();
            if (decimalPattern.test(number2) === false) {
              throw Error("Expecting an integer");
            }
            while (decimalPattern.test(this.peekChar(0))) {
              number2 += this.popChar();
            }
            return parseInt(number2, 10);
          };
          RegExpParser.prototype.patternCharacter = function() {
            var nextChar = this.popChar();
            switch (nextChar) {
              case "\n":
              case "\r":
              case "\u2028":
              case "\u2029":
              case "^":
              case "$":
              case "\\":
              case ".":
              case "*":
              case "+":
              case "?":
              case "(":
              case ")":
              case "[":
              case "|":
                throw Error("TBD");
              default:
                return { type: "Character", value: cc(nextChar) };
            }
          };
          RegExpParser.prototype.isRegExpFlag = function() {
            switch (this.peekChar(0)) {
              case "g":
              case "i":
              case "m":
              case "u":
              case "y":
                return true;
              default:
                return false;
            }
          };
          RegExpParser.prototype.isRangeDash = function() {
            return this.peekChar() === "-" && this.isClassAtom(1);
          };
          RegExpParser.prototype.isDigit = function() {
            return decimalPattern.test(this.peekChar(0));
          };
          RegExpParser.prototype.isClassAtom = function(howMuch) {
            if (howMuch === void 0) {
              howMuch = 0;
            }
            switch (this.peekChar(howMuch)) {
              case "]":
              case "\n":
              case "\r":
              case "\u2028":
              case "\u2029":
                return false;
              default:
                return true;
            }
          };
          RegExpParser.prototype.isTerm = function() {
            return this.isAtom() || this.isAssertion();
          };
          RegExpParser.prototype.isAtom = function() {
            if (this.isPatternCharacter()) {
              return true;
            }
            switch (this.peekChar(0)) {
              case ".":
              case "\\":
              case "[":
              case "(":
                return true;
              default:
                return false;
            }
          };
          RegExpParser.prototype.isAssertion = function() {
            switch (this.peekChar(0)) {
              case "^":
              case "$":
                return true;
              case "\\":
                switch (this.peekChar(1)) {
                  case "b":
                  case "B":
                    return true;
                  default:
                    return false;
                }
              case "(":
                return this.peekChar(1) === "?" && (this.peekChar(2) === "=" || this.peekChar(2) === "!");
              default:
                return false;
            }
          };
          RegExpParser.prototype.isQuantifier = function() {
            var prevState = this.saveState();
            try {
              return this.quantifier(true) !== void 0;
            } catch (e2) {
              return false;
            } finally {
              this.restoreState(prevState);
            }
          };
          RegExpParser.prototype.isPatternCharacter = function() {
            switch (this.peekChar()) {
              case "^":
              case "$":
              case "\\":
              case ".":
              case "*":
              case "+":
              case "?":
              case "(":
              case ")":
              case "[":
              case "|":
              case "/":
              case "\n":
              case "\r":
              case "\u2028":
              case "\u2029":
                return false;
              default:
                return true;
            }
          };
          RegExpParser.prototype.parseHexDigits = function(howMany) {
            var hexString = "";
            for (var i3 = 0; i3 < howMany; i3++) {
              var hexChar = this.popChar();
              if (hexDigitPattern.test(hexChar) === false) {
                throw Error("Expecting a HexDecimal digits");
              }
              hexString += hexChar;
            }
            var charCode = parseInt(hexString, 16);
            return { type: "Character", value: charCode };
          };
          RegExpParser.prototype.peekChar = function(howMuch) {
            if (howMuch === void 0) {
              howMuch = 0;
            }
            return this.input[this.idx + howMuch];
          };
          RegExpParser.prototype.popChar = function() {
            var nextChar = this.peekChar(0);
            this.consumeChar();
            return nextChar;
          };
          RegExpParser.prototype.consumeChar = function(char) {
            if (char !== void 0 && this.input[this.idx] !== char) {
              throw Error(
                "Expected: '" + char + "' but found: '" + this.input[this.idx] + "' at offset: " + this.idx
              );
            }
            if (this.idx >= this.input.length) {
              throw Error("Unexpected end of input");
            }
            this.idx++;
          };
          RegExpParser.prototype.loc = function(begin) {
            return { begin, end: this.idx };
          };
          var hexDigitPattern = /[0-9a-fA-F]/;
          var decimalPattern = /[0-9]/;
          var decimalPatternNoZero = /[1-9]/;
          function cc(char) {
            return char.charCodeAt(0);
          }
          function insertToSet(item, set4) {
            if (item.length !== void 0) {
              item.forEach(function(subItem) {
                set4.push(subItem);
              });
            } else {
              set4.push(item);
            }
          }
          function addFlag(flagObj, flagKey) {
            if (flagObj[flagKey] === true) {
              throw "duplicate flag " + flagKey;
            }
            flagObj[flagKey] = true;
          }
          function ASSERT_EXISTS(obj) {
            if (obj === void 0) {
              throw Error("Internal Error - Should never get here!");
            }
          }
          function ASSERT_NEVER_REACH_HERE() {
            throw Error("Internal Error - Should never get here!");
          }
          var i2;
          var digitsCharCodes = [];
          for (i2 = cc("0"); i2 <= cc("9"); i2++) {
            digitsCharCodes.push(i2);
          }
          var wordCharCodes = [cc("_")].concat(digitsCharCodes);
          for (i2 = cc("a"); i2 <= cc("z"); i2++) {
            wordCharCodes.push(i2);
          }
          for (i2 = cc("A"); i2 <= cc("Z"); i2++) {
            wordCharCodes.push(i2);
          }
          var whitespaceCodes = [
            cc(" "),
            cc("\f"),
            cc("\n"),
            cc("\r"),
            cc("	"),
            cc("\v"),
            cc("	"),
            cc("\xA0"),
            cc("\u1680"),
            cc("\u2000"),
            cc("\u2001"),
            cc("\u2002"),
            cc("\u2003"),
            cc("\u2004"),
            cc("\u2005"),
            cc("\u2006"),
            cc("\u2007"),
            cc("\u2008"),
            cc("\u2009"),
            cc("\u200A"),
            cc("\u2028"),
            cc("\u2029"),
            cc("\u202F"),
            cc("\u205F"),
            cc("\u3000"),
            cc("\uFEFF")
          ];
          function BaseRegExpVisitor() {
          }
          BaseRegExpVisitor.prototype.visitChildren = function(node) {
            for (var key in node) {
              var child = node[key];
              if (node.hasOwnProperty(key)) {
                if (child.type !== void 0) {
                  this.visit(child);
                } else if (Array.isArray(child)) {
                  child.forEach(function(subChild) {
                    this.visit(subChild);
                  }, this);
                }
              }
            }
          };
          BaseRegExpVisitor.prototype.visit = function(node) {
            switch (node.type) {
              case "Pattern":
                this.visitPattern(node);
                break;
              case "Flags":
                this.visitFlags(node);
                break;
              case "Disjunction":
                this.visitDisjunction(node);
                break;
              case "Alternative":
                this.visitAlternative(node);
                break;
              case "StartAnchor":
                this.visitStartAnchor(node);
                break;
              case "EndAnchor":
                this.visitEndAnchor(node);
                break;
              case "WordBoundary":
                this.visitWordBoundary(node);
                break;
              case "NonWordBoundary":
                this.visitNonWordBoundary(node);
                break;
              case "Lookahead":
                this.visitLookahead(node);
                break;
              case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                break;
              case "Character":
                this.visitCharacter(node);
                break;
              case "Set":
                this.visitSet(node);
                break;
              case "Group":
                this.visitGroup(node);
                break;
              case "GroupBackReference":
                this.visitGroupBackReference(node);
                break;
              case "Quantifier":
                this.visitQuantifier(node);
                break;
            }
            this.visitChildren(node);
          };
          BaseRegExpVisitor.prototype.visitPattern = function(node) {
          };
          BaseRegExpVisitor.prototype.visitFlags = function(node) {
          };
          BaseRegExpVisitor.prototype.visitDisjunction = function(node) {
          };
          BaseRegExpVisitor.prototype.visitAlternative = function(node) {
          };
          BaseRegExpVisitor.prototype.visitStartAnchor = function(node) {
          };
          BaseRegExpVisitor.prototype.visitEndAnchor = function(node) {
          };
          BaseRegExpVisitor.prototype.visitWordBoundary = function(node) {
          };
          BaseRegExpVisitor.prototype.visitNonWordBoundary = function(node) {
          };
          BaseRegExpVisitor.prototype.visitLookahead = function(node) {
          };
          BaseRegExpVisitor.prototype.visitNegativeLookahead = function(node) {
          };
          BaseRegExpVisitor.prototype.visitCharacter = function(node) {
          };
          BaseRegExpVisitor.prototype.visitSet = function(node) {
          };
          BaseRegExpVisitor.prototype.visitGroup = function(node) {
          };
          BaseRegExpVisitor.prototype.visitGroupBackReference = function(node) {
          };
          BaseRegExpVisitor.prototype.visitQuantifier = function(node) {
          };
          return {
            RegExpParser,
            BaseRegExpVisitor,
            VERSION: "0.5.0"
          };
        }
      );
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/head.js
  var require_head = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/head.js"(exports2, module2) {
      function head(array) {
        return array && array.length ? array[0] : void 0;
      }
      module2.exports = head;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/first.js
  var require_first2 = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/first.js"(exports2, module2) {
      module2.exports = require_head();
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/compact.js
  var require_compact = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/compact.js"(exports2, module2) {
      function compact2(array) {
        var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index2 < length2) {
          var value = array[index2];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      module2.exports = compact2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFilter.js
  var require_baseFilter = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseFilter.js"(exports2, module2) {
      var baseEach = require_baseEach();
      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result.push(value);
          }
        });
        return result;
      }
      module2.exports = baseFilter;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/negate.js
  var require_negate = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/negate.js"(exports2, module2) {
      var FUNC_ERROR_TEXT = "Expected a function";
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      module2.exports = negate;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/reject.js
  var require_reject = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/reject.js"(exports2, module2) {
      var arrayFilter = require_arrayFilter();
      var baseFilter = require_baseFilter();
      var baseIteratee = require_baseIteratee();
      var isArray2 = require_isArray();
      var negate = require_negate();
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(baseIteratee(predicate, 3)));
      }
      module2.exports = reject;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseDifference.js
  var require_baseDifference = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseDifference.js"(exports2, module2) {
      var SetCache = require_SetCache();
      var arrayIncludes = require_arrayIncludes();
      var arrayIncludesWith = require_arrayIncludesWith();
      var arrayMap = require_arrayMap();
      var baseUnary = require_baseUnary();
      var cacheHas = require_cacheHas();
      var LARGE_ARRAY_SIZE = 200;
      function baseDifference(array, values, iteratee, comparator) {
        var index2 = -1, includes = arrayIncludes, isCommon = true, length2 = array.length, result = [], valuesLength = values.length;
        if (!length2) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer:
          while (++index2 < length2) {
            var value = array[index2], computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result.push(value);
            } else if (!includes(values, computed, comparator)) {
              result.push(value);
            }
          }
        return result;
      }
      module2.exports = baseDifference;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLikeObject.js
  var require_isArrayLikeObject = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isArrayLikeObject.js"(exports2, module2) {
      var isArrayLike = require_isArrayLike();
      var isObjectLike = require_isObjectLike();
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      module2.exports = isArrayLikeObject;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/difference.js
  var require_difference = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/difference.js"(exports2, module2) {
      var baseDifference = require_baseDifference();
      var baseFlatten = require_baseFlatten();
      var baseRest = require_baseRest();
      var isArrayLikeObject = require_isArrayLikeObject();
      var difference = baseRest(function(array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
      });
      module2.exports = difference;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/indexOf.js
  var require_indexOf = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/indexOf.js"(exports2, module2) {
      var baseIndexOf = require_baseIndexOf();
      var toInteger = require_toInteger();
      var nativeMax = Math.max;
      function indexOf(array, value, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length2 + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      module2.exports = indexOf;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createFind.js
  var require_createFind = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createFind.js"(exports2, module2) {
      var baseIteratee = require_baseIteratee();
      var isArrayLike = require_isArrayLike();
      var keys = require_keys();
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee ? collection[index2] : index2] : void 0;
        };
      }
      module2.exports = createFind;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findIndex.js
  var require_findIndex = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findIndex.js"(exports2, module2) {
      var baseFindIndex = require_baseFindIndex();
      var baseIteratee = require_baseIteratee();
      var toInteger = require_toInteger();
      var nativeMax = Math.max;
      function findIndex(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length2 + index2, 0);
        }
        return baseFindIndex(array, baseIteratee(predicate, 3), index2);
      }
      module2.exports = findIndex;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/find.js
  var require_find = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/find.js"(exports2, module2) {
      var createFind = require_createFind();
      var findIndex = require_findIndex();
      var find = createFind(findIndex);
      module2.exports = find;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/filter.js
  var require_filter = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/filter.js"(exports2, module2) {
      var arrayFilter = require_arrayFilter();
      var baseFilter = require_baseFilter();
      var baseIteratee = require_baseIteratee();
      var isArray2 = require_isArray();
      function filter2(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, baseIteratee(predicate, 3));
      }
      module2.exports = filter2;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/defaults.js
  var require_defaults = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/defaults.js"(exports2, module2) {
      var baseRest = require_baseRest();
      var eq = require_eq();
      var isIterateeCall = require_isIterateeCall();
      var keysIn = require_keysIn();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var defaults3 = baseRest(function(object, sources) {
        object = Object(object);
        var index2 = -1;
        var length2 = sources.length;
        var guard = length2 > 2 ? sources[2] : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length2 = 1;
        }
        while (++index2 < length2) {
          var source = sources[index2];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === void 0 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      module2.exports = defaults3;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayReduce.js
  var require_arrayReduce = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayReduce.js"(exports2, module2) {
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        if (initAccum && length2) {
          accumulator = array[++index2];
        }
        while (++index2 < length2) {
          accumulator = iteratee(accumulator, array[index2], index2, array);
        }
        return accumulator;
      }
      module2.exports = arrayReduce;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseReduce.js
  var require_baseReduce = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseReduce.js"(exports2, module2) {
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index2, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
        });
        return accumulator;
      }
      module2.exports = baseReduce;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/reduce.js
  var require_reduce = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/reduce.js"(exports2, module2) {
      var arrayReduce = require_arrayReduce();
      var baseEach = require_baseEach();
      var baseIteratee = require_baseIteratee();
      var baseReduce = require_baseReduce();
      var isArray2 = require_isArray();
      function reduce(collection, iteratee, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }
      module2.exports = reduce;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/reg_exp_parser.js
  var require_reg_exp_parser = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/reg_exp_parser.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.clearRegExpParserCache = exports2.getRegExpAst = void 0;
      var regexp_to_ast_1 = require_regexp_to_ast();
      var regExpAstCache = {};
      var regExpParser = new regexp_to_ast_1.RegExpParser();
      function getRegExpAst(regExp) {
        var regExpStr = regExp.toString();
        if (regExpAstCache.hasOwnProperty(regExpStr)) {
          return regExpAstCache[regExpStr];
        } else {
          var regExpAst = regExpParser.pattern(regExpStr);
          regExpAstCache[regExpStr] = regExpAst;
          return regExpAst;
        }
      }
      exports2.getRegExpAst = getRegExpAst;
      function clearRegExpParserCache() {
        regExpAstCache = {};
      }
      exports2.clearRegExpParserCache = clearRegExpParserCache;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/reg_exp.js
  var require_reg_exp = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/reg_exp.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.canMatchCharCode = exports2.firstCharOptimizedIndices = exports2.getOptimizedStartCodesIndices = exports2.failedOptimizationPrefixMsg = void 0;
      var regexp_to_ast_1 = require_regexp_to_ast();
      var isArray_1 = __importDefault(require_isArray());
      var every_1 = __importDefault(require_every());
      var forEach_1 = __importDefault(require_forEach());
      var find_1 = __importDefault(require_find());
      var values_1 = __importDefault(require_values());
      var includes_1 = __importDefault(require_includes());
      var utils_1 = require_api();
      var reg_exp_parser_1 = require_reg_exp_parser();
      var lexer_1 = require_lexer();
      var complementErrorMessage = "Complement Sets are not supported for first char optimization";
      exports2.failedOptimizationPrefixMsg = 'Unable to use "first char" lexer optimizations:\n';
      function getOptimizedStartCodesIndices(regExp, ensureOptimizations) {
        if (ensureOptimizations === void 0) {
          ensureOptimizations = false;
        }
        try {
          var ast = (0, reg_exp_parser_1.getRegExpAst)(regExp);
          var firstChars = firstCharOptimizedIndices(ast.value, {}, ast.flags.ignoreCase);
          return firstChars;
        } catch (e2) {
          if (e2.message === complementErrorMessage) {
            if (ensureOptimizations) {
              (0, utils_1.PRINT_WARNING)("".concat(exports2.failedOptimizationPrefixMsg) + "	Unable to optimize: < ".concat(regExp.toString(), " >\n") + "	Complement Sets cannot be automatically optimized.\n	This will disable the lexer's first char optimizations.\n	See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#COMPLEMENT for details.");
            }
          } else {
            var msgSuffix = "";
            if (ensureOptimizations) {
              msgSuffix = "\n	This will disable the lexer's first char optimizations.\n	See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#REGEXP_PARSING for details.";
            }
            (0, utils_1.PRINT_ERROR)("".concat(exports2.failedOptimizationPrefixMsg, "\n") + "	Failed parsing: < ".concat(regExp.toString(), " >\n") + "	Using the regexp-to-ast library version: ".concat(regexp_to_ast_1.VERSION, "\n") + "	Please open an issue at: https://github.com/bd82/regexp-to-ast/issues" + msgSuffix);
          }
        }
        return [];
      }
      exports2.getOptimizedStartCodesIndices = getOptimizedStartCodesIndices;
      function firstCharOptimizedIndices(ast, result, ignoreCase) {
        switch (ast.type) {
          case "Disjunction":
            for (var i2 = 0; i2 < ast.value.length; i2++) {
              firstCharOptimizedIndices(ast.value[i2], result, ignoreCase);
            }
            break;
          case "Alternative":
            var terms = ast.value;
            for (var i2 = 0; i2 < terms.length; i2++) {
              var term = terms[i2];
              switch (term.type) {
                case "EndAnchor":
                case "GroupBackReference":
                case "Lookahead":
                case "NegativeLookahead":
                case "StartAnchor":
                case "WordBoundary":
                case "NonWordBoundary":
                  continue;
              }
              var atom = term;
              switch (atom.type) {
                case "Character":
                  addOptimizedIdxToResult(atom.value, result, ignoreCase);
                  break;
                case "Set":
                  if (atom.complement === true) {
                    throw Error(complementErrorMessage);
                  }
                  (0, forEach_1.default)(atom.value, function(code) {
                    if (typeof code === "number") {
                      addOptimizedIdxToResult(code, result, ignoreCase);
                    } else {
                      var range = code;
                      if (ignoreCase === true) {
                        for (var rangeCode = range.from; rangeCode <= range.to; rangeCode++) {
                          addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                        }
                      } else {
                        for (var rangeCode = range.from; rangeCode <= range.to && rangeCode < lexer_1.minOptimizationVal; rangeCode++) {
                          addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                        }
                        if (range.to >= lexer_1.minOptimizationVal) {
                          var minUnOptVal = range.from >= lexer_1.minOptimizationVal ? range.from : lexer_1.minOptimizationVal;
                          var maxUnOptVal = range.to;
                          var minOptIdx = (0, lexer_1.charCodeToOptimizedIndex)(minUnOptVal);
                          var maxOptIdx = (0, lexer_1.charCodeToOptimizedIndex)(maxUnOptVal);
                          for (var currOptIdx = minOptIdx; currOptIdx <= maxOptIdx; currOptIdx++) {
                            result[currOptIdx] = currOptIdx;
                          }
                        }
                      }
                    }
                  });
                  break;
                case "Group":
                  firstCharOptimizedIndices(atom.value, result, ignoreCase);
                  break;
                default:
                  throw Error("Non Exhaustive Match");
              }
              var isOptionalQuantifier = atom.quantifier !== void 0 && atom.quantifier.atLeast === 0;
              if (
                // A group may be optional due to empty contents /(?:)/
                // or if everything inside it is optional /((a)?)/
                atom.type === "Group" && isWholeOptional(atom) === false || // If this term is not a group it may only be optional if it has an optional quantifier
                atom.type !== "Group" && isOptionalQuantifier === false
              ) {
                break;
              }
            }
            break;
          default:
            throw Error("non exhaustive match!");
        }
        return (0, values_1.default)(result);
      }
      exports2.firstCharOptimizedIndices = firstCharOptimizedIndices;
      function addOptimizedIdxToResult(code, result, ignoreCase) {
        var optimizedCharIdx = (0, lexer_1.charCodeToOptimizedIndex)(code);
        result[optimizedCharIdx] = optimizedCharIdx;
        if (ignoreCase === true) {
          handleIgnoreCase(code, result);
        }
      }
      function handleIgnoreCase(code, result) {
        var char = String.fromCharCode(code);
        var upperChar = char.toUpperCase();
        if (upperChar !== char) {
          var optimizedCharIdx = (0, lexer_1.charCodeToOptimizedIndex)(upperChar.charCodeAt(0));
          result[optimizedCharIdx] = optimizedCharIdx;
        } else {
          var lowerChar = char.toLowerCase();
          if (lowerChar !== char) {
            var optimizedCharIdx = (0, lexer_1.charCodeToOptimizedIndex)(lowerChar.charCodeAt(0));
            result[optimizedCharIdx] = optimizedCharIdx;
          }
        }
      }
      function findCode(setNode, targetCharCodes) {
        return (0, find_1.default)(setNode.value, function(codeOrRange) {
          if (typeof codeOrRange === "number") {
            return (0, includes_1.default)(targetCharCodes, codeOrRange);
          } else {
            var range_1 = codeOrRange;
            return (0, find_1.default)(targetCharCodes, function(targetCode) {
              return range_1.from <= targetCode && targetCode <= range_1.to;
            }) !== void 0;
          }
        });
      }
      function isWholeOptional(ast) {
        var quantifier = ast.quantifier;
        if (quantifier && quantifier.atLeast === 0) {
          return true;
        }
        if (!ast.value) {
          return false;
        }
        return (0, isArray_1.default)(ast.value) ? (0, every_1.default)(ast.value, isWholeOptional) : isWholeOptional(ast.value);
      }
      var CharCodeFinder = (
        /** @class */
        function(_super) {
          __extends(CharCodeFinder2, _super);
          function CharCodeFinder2(targetCharCodes) {
            var _this = _super.call(this) || this;
            _this.targetCharCodes = targetCharCodes;
            _this.found = false;
            return _this;
          }
          CharCodeFinder2.prototype.visitChildren = function(node) {
            if (this.found === true) {
              return;
            }
            switch (node.type) {
              case "Lookahead":
                this.visitLookahead(node);
                return;
              case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                return;
            }
            _super.prototype.visitChildren.call(this, node);
          };
          CharCodeFinder2.prototype.visitCharacter = function(node) {
            if ((0, includes_1.default)(this.targetCharCodes, node.value)) {
              this.found = true;
            }
          };
          CharCodeFinder2.prototype.visitSet = function(node) {
            if (node.complement) {
              if (findCode(node, this.targetCharCodes) === void 0) {
                this.found = true;
              }
            } else {
              if (findCode(node, this.targetCharCodes) !== void 0) {
                this.found = true;
              }
            }
          };
          return CharCodeFinder2;
        }(regexp_to_ast_1.BaseRegExpVisitor)
      );
      function canMatchCharCode(charCodes, pattern2) {
        if (pattern2 instanceof RegExp) {
          var ast = (0, reg_exp_parser_1.getRegExpAst)(pattern2);
          var charCodeFinder = new CharCodeFinder(charCodes);
          charCodeFinder.visit(ast);
          return charCodeFinder.found;
        } else {
          return (0, find_1.default)(pattern2, function(char) {
            return (0, includes_1.default)(charCodes, char.charCodeAt(0));
          }) !== void 0;
        }
      }
      exports2.canMatchCharCode = canMatchCharCode;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/lexer.js
  var require_lexer = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/lexer.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.charCodeToOptimizedIndex = exports2.minOptimizationVal = exports2.buildLineBreakIssueMessage = exports2.LineTerminatorOptimizedTester = exports2.isShortPattern = exports2.isCustomPattern = exports2.cloneEmptyGroups = exports2.performWarningRuntimeChecks = exports2.performRuntimeChecks = exports2.addStickyFlag = exports2.addStartOfInput = exports2.findUnreachablePatterns = exports2.findModesThatDoNotExist = exports2.findInvalidGroupType = exports2.findDuplicatePatterns = exports2.findUnsupportedFlags = exports2.findStartOfInputAnchor = exports2.findEmptyMatchRegExps = exports2.findEndOfInputAnchor = exports2.findInvalidPatterns = exports2.findMissingPatterns = exports2.validatePatterns = exports2.analyzeTokenTypes = exports2.enableSticky = exports2.disableSticky = exports2.SUPPORT_STICKY = exports2.MODES = exports2.DEFAULT_MODE = void 0;
      var regexp_to_ast_1 = require_regexp_to_ast();
      var lexer_public_1 = require_lexer_public();
      var first_1 = __importDefault(require_first2());
      var isEmpty_1 = __importDefault(require_isEmpty());
      var compact_1 = __importDefault(require_compact());
      var isArray_1 = __importDefault(require_isArray());
      var values_1 = __importDefault(require_values());
      var flatten_1 = __importDefault(require_flatten());
      var reject_1 = __importDefault(require_reject());
      var difference_1 = __importDefault(require_difference());
      var indexOf_1 = __importDefault(require_indexOf());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var isString_1 = __importDefault(require_isString());
      var isFunction_1 = __importDefault(require_isFunction());
      var isUndefined_1 = __importDefault(require_isUndefined());
      var find_1 = __importDefault(require_find());
      var has_1 = __importDefault(require_has());
      var keys_1 = __importDefault(require_keys());
      var isRegExp_1 = __importDefault(require_isRegExp());
      var filter_1 = __importDefault(require_filter());
      var defaults_1 = __importDefault(require_defaults());
      var reduce_1 = __importDefault(require_reduce());
      var includes_1 = __importDefault(require_includes());
      var utils_1 = require_api();
      var reg_exp_1 = require_reg_exp();
      var reg_exp_parser_1 = require_reg_exp_parser();
      var PATTERN = "PATTERN";
      exports2.DEFAULT_MODE = "defaultMode";
      exports2.MODES = "modes";
      exports2.SUPPORT_STICKY = typeof new RegExp("(?:)").sticky === "boolean";
      function disableSticky() {
        exports2.SUPPORT_STICKY = false;
      }
      exports2.disableSticky = disableSticky;
      function enableSticky() {
        exports2.SUPPORT_STICKY = true;
      }
      exports2.enableSticky = enableSticky;
      function analyzeTokenTypes(tokenTypes, options) {
        options = (0, defaults_1.default)(options, {
          useSticky: exports2.SUPPORT_STICKY,
          debug: false,
          safeMode: false,
          positionTracking: "full",
          lineTerminatorCharacters: ["\r", "\n"],
          tracer: function(msg, action) {
            return action();
          }
        });
        var tracer = options.tracer;
        tracer("initCharCodeToOptimizedIndexMap", function() {
          initCharCodeToOptimizedIndexMap();
        });
        var onlyRelevantTypes;
        tracer("Reject Lexer.NA", function() {
          onlyRelevantTypes = (0, reject_1.default)(tokenTypes, function(currType) {
            return currType[PATTERN] === lexer_public_1.Lexer.NA;
          });
        });
        var hasCustom = false;
        var allTransformedPatterns;
        tracer("Transform Patterns", function() {
          hasCustom = false;
          allTransformedPatterns = (0, map_1.default)(onlyRelevantTypes, function(currType) {
            var currPattern = currType[PATTERN];
            if ((0, isRegExp_1.default)(currPattern)) {
              var regExpSource = currPattern.source;
              if (regExpSource.length === 1 && // only these regExp meta characters which can appear in a length one regExp
              regExpSource !== "^" && regExpSource !== "$" && regExpSource !== "." && !currPattern.ignoreCase) {
                return regExpSource;
              } else if (regExpSource.length === 2 && regExpSource[0] === "\\" && // not a meta character
              !(0, includes_1.default)([
                "d",
                "D",
                "s",
                "S",
                "t",
                "r",
                "n",
                "t",
                "0",
                "c",
                "b",
                "B",
                "f",
                "v",
                "w",
                "W"
              ], regExpSource[1])) {
                return regExpSource[1];
              } else {
                return options.useSticky ? addStickyFlag(currPattern) : addStartOfInput(currPattern);
              }
            } else if ((0, isFunction_1.default)(currPattern)) {
              hasCustom = true;
              return { exec: currPattern };
            } else if (typeof currPattern === "object") {
              hasCustom = true;
              return currPattern;
            } else if (typeof currPattern === "string") {
              if (currPattern.length === 1) {
                return currPattern;
              } else {
                var escapedRegExpString = currPattern.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
                var wrappedRegExp = new RegExp(escapedRegExpString);
                return options.useSticky ? addStickyFlag(wrappedRegExp) : addStartOfInput(wrappedRegExp);
              }
            } else {
              throw Error("non exhaustive match");
            }
          });
        });
        var patternIdxToType;
        var patternIdxToGroup;
        var patternIdxToLongerAltIdxArr;
        var patternIdxToPushMode;
        var patternIdxToPopMode;
        tracer("misc mapping", function() {
          patternIdxToType = (0, map_1.default)(onlyRelevantTypes, function(currType) {
            return currType.tokenTypeIdx;
          });
          patternIdxToGroup = (0, map_1.default)(onlyRelevantTypes, function(clazz) {
            var groupName = clazz.GROUP;
            if (groupName === lexer_public_1.Lexer.SKIPPED) {
              return void 0;
            } else if ((0, isString_1.default)(groupName)) {
              return groupName;
            } else if ((0, isUndefined_1.default)(groupName)) {
              return false;
            } else {
              throw Error("non exhaustive match");
            }
          });
          patternIdxToLongerAltIdxArr = (0, map_1.default)(onlyRelevantTypes, function(clazz) {
            var longerAltType = clazz.LONGER_ALT;
            if (longerAltType) {
              var longerAltIdxArr = (0, isArray_1.default)(longerAltType) ? (0, map_1.default)(longerAltType, function(type) {
                return (0, indexOf_1.default)(onlyRelevantTypes, type);
              }) : [(0, indexOf_1.default)(onlyRelevantTypes, longerAltType)];
              return longerAltIdxArr;
            }
          });
          patternIdxToPushMode = (0, map_1.default)(onlyRelevantTypes, function(clazz) {
            return clazz.PUSH_MODE;
          });
          patternIdxToPopMode = (0, map_1.default)(onlyRelevantTypes, function(clazz) {
            return (0, has_1.default)(clazz, "POP_MODE");
          });
        });
        var patternIdxToCanLineTerminator;
        tracer("Line Terminator Handling", function() {
          var lineTerminatorCharCodes = getCharCodes(options.lineTerminatorCharacters);
          patternIdxToCanLineTerminator = (0, map_1.default)(onlyRelevantTypes, function(tokType) {
            return false;
          });
          if (options.positionTracking !== "onlyOffset") {
            patternIdxToCanLineTerminator = (0, map_1.default)(onlyRelevantTypes, function(tokType) {
              if ((0, has_1.default)(tokType, "LINE_BREAKS")) {
                return !!tokType.LINE_BREAKS;
              } else {
                return checkLineBreaksIssues(tokType, lineTerminatorCharCodes) === false && (0, reg_exp_1.canMatchCharCode)(lineTerminatorCharCodes, tokType.PATTERN);
              }
            });
          }
        });
        var patternIdxToIsCustom;
        var patternIdxToShort;
        var emptyGroups;
        var patternIdxToConfig;
        tracer("Misc Mapping #2", function() {
          patternIdxToIsCustom = (0, map_1.default)(onlyRelevantTypes, isCustomPattern);
          patternIdxToShort = (0, map_1.default)(allTransformedPatterns, isShortPattern);
          emptyGroups = (0, reduce_1.default)(onlyRelevantTypes, function(acc, clazz) {
            var groupName = clazz.GROUP;
            if ((0, isString_1.default)(groupName) && !(groupName === lexer_public_1.Lexer.SKIPPED)) {
              acc[groupName] = [];
            }
            return acc;
          }, {});
          patternIdxToConfig = (0, map_1.default)(allTransformedPatterns, function(x, idx) {
            return {
              pattern: allTransformedPatterns[idx],
              longerAlt: patternIdxToLongerAltIdxArr[idx],
              canLineTerminator: patternIdxToCanLineTerminator[idx],
              isCustom: patternIdxToIsCustom[idx],
              short: patternIdxToShort[idx],
              group: patternIdxToGroup[idx],
              push: patternIdxToPushMode[idx],
              pop: patternIdxToPopMode[idx],
              tokenTypeIdx: patternIdxToType[idx],
              tokenType: onlyRelevantTypes[idx]
            };
          });
        });
        var canBeOptimized = true;
        var charCodeToPatternIdxToConfig = [];
        if (!options.safeMode) {
          tracer("First Char Optimization", function() {
            charCodeToPatternIdxToConfig = (0, reduce_1.default)(onlyRelevantTypes, function(result, currTokType, idx) {
              if (typeof currTokType.PATTERN === "string") {
                var charCode = currTokType.PATTERN.charCodeAt(0);
                var optimizedIdx = charCodeToOptimizedIndex(charCode);
                addToMapOfArrays(result, optimizedIdx, patternIdxToConfig[idx]);
              } else if ((0, isArray_1.default)(currTokType.START_CHARS_HINT)) {
                var lastOptimizedIdx_1;
                (0, forEach_1.default)(currTokType.START_CHARS_HINT, function(charOrInt) {
                  var charCode2 = typeof charOrInt === "string" ? charOrInt.charCodeAt(0) : charOrInt;
                  var currOptimizedIdx = charCodeToOptimizedIndex(charCode2);
                  if (lastOptimizedIdx_1 !== currOptimizedIdx) {
                    lastOptimizedIdx_1 = currOptimizedIdx;
                    addToMapOfArrays(result, currOptimizedIdx, patternIdxToConfig[idx]);
                  }
                });
              } else if ((0, isRegExp_1.default)(currTokType.PATTERN)) {
                if (currTokType.PATTERN.unicode) {
                  canBeOptimized = false;
                  if (options.ensureOptimizations) {
                    (0, utils_1.PRINT_ERROR)("".concat(reg_exp_1.failedOptimizationPrefixMsg) + "	Unable to analyze < ".concat(currTokType.PATTERN.toString(), " > pattern.\n") + "	The regexp unicode flag is not currently supported by the regexp-to-ast library.\n	This will disable the lexer's first char optimizations.\n	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#UNICODE_OPTIMIZE");
                  }
                } else {
                  var optimizedCodes = (0, reg_exp_1.getOptimizedStartCodesIndices)(currTokType.PATTERN, options.ensureOptimizations);
                  if ((0, isEmpty_1.default)(optimizedCodes)) {
                    canBeOptimized = false;
                  }
                  (0, forEach_1.default)(optimizedCodes, function(code) {
                    addToMapOfArrays(result, code, patternIdxToConfig[idx]);
                  });
                }
              } else {
                if (options.ensureOptimizations) {
                  (0, utils_1.PRINT_ERROR)("".concat(reg_exp_1.failedOptimizationPrefixMsg) + "	TokenType: <".concat(currTokType.name, "> is using a custom token pattern without providing <start_chars_hint> parameter.\n") + "	This will disable the lexer's first char optimizations.\n	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#CUSTOM_OPTIMIZE");
                }
                canBeOptimized = false;
              }
              return result;
            }, []);
          });
        }
        return {
          emptyGroups,
          patternIdxToConfig,
          charCodeToPatternIdxToConfig,
          hasCustom,
          canBeOptimized
        };
      }
      exports2.analyzeTokenTypes = analyzeTokenTypes;
      function validatePatterns(tokenTypes, validModesNames) {
        var errors = [];
        var missingResult = findMissingPatterns(tokenTypes);
        errors = errors.concat(missingResult.errors);
        var invalidResult = findInvalidPatterns(missingResult.valid);
        var validTokenTypes = invalidResult.valid;
        errors = errors.concat(invalidResult.errors);
        errors = errors.concat(validateRegExpPattern(validTokenTypes));
        errors = errors.concat(findInvalidGroupType(validTokenTypes));
        errors = errors.concat(findModesThatDoNotExist(validTokenTypes, validModesNames));
        errors = errors.concat(findUnreachablePatterns(validTokenTypes));
        return errors;
      }
      exports2.validatePatterns = validatePatterns;
      function validateRegExpPattern(tokenTypes) {
        var errors = [];
        var withRegExpPatterns = (0, filter_1.default)(tokenTypes, function(currTokType) {
          return (0, isRegExp_1.default)(currTokType[PATTERN]);
        });
        errors = errors.concat(findEndOfInputAnchor(withRegExpPatterns));
        errors = errors.concat(findStartOfInputAnchor(withRegExpPatterns));
        errors = errors.concat(findUnsupportedFlags(withRegExpPatterns));
        errors = errors.concat(findDuplicatePatterns(withRegExpPatterns));
        errors = errors.concat(findEmptyMatchRegExps(withRegExpPatterns));
        return errors;
      }
      function findMissingPatterns(tokenTypes) {
        var tokenTypesWithMissingPattern = (0, filter_1.default)(tokenTypes, function(currType) {
          return !(0, has_1.default)(currType, PATTERN);
        });
        var errors = (0, map_1.default)(tokenTypesWithMissingPattern, function(currType) {
          return {
            message: "Token Type: ->" + currType.name + "<- missing static 'PATTERN' property",
            type: lexer_public_1.LexerDefinitionErrorType.MISSING_PATTERN,
            tokenTypes: [currType]
          };
        });
        var valid = (0, difference_1.default)(tokenTypes, tokenTypesWithMissingPattern);
        return { errors, valid };
      }
      exports2.findMissingPatterns = findMissingPatterns;
      function findInvalidPatterns(tokenTypes) {
        var tokenTypesWithInvalidPattern = (0, filter_1.default)(tokenTypes, function(currType) {
          var pattern2 = currType[PATTERN];
          return !(0, isRegExp_1.default)(pattern2) && !(0, isFunction_1.default)(pattern2) && !(0, has_1.default)(pattern2, "exec") && !(0, isString_1.default)(pattern2);
        });
        var errors = (0, map_1.default)(tokenTypesWithInvalidPattern, function(currType) {
          return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' can only be a RegExp, a Function matching the {CustomPatternMatcherFunc} type or an Object matching the {ICustomPattern} interface.",
            type: lexer_public_1.LexerDefinitionErrorType.INVALID_PATTERN,
            tokenTypes: [currType]
          };
        });
        var valid = (0, difference_1.default)(tokenTypes, tokenTypesWithInvalidPattern);
        return { errors, valid };
      }
      exports2.findInvalidPatterns = findInvalidPatterns;
      var end_of_input = /[^\\][$]/;
      function findEndOfInputAnchor(tokenTypes) {
        var EndAnchorFinder = (
          /** @class */
          function(_super) {
            __extends(EndAnchorFinder2, _super);
            function EndAnchorFinder2() {
              var _this = _super !== null && _super.apply(this, arguments) || this;
              _this.found = false;
              return _this;
            }
            EndAnchorFinder2.prototype.visitEndAnchor = function(node) {
              this.found = true;
            };
            return EndAnchorFinder2;
          }(regexp_to_ast_1.BaseRegExpVisitor)
        );
        var invalidRegex = (0, filter_1.default)(tokenTypes, function(currType) {
          var pattern2 = currType.PATTERN;
          try {
            var regexpAst = (0, reg_exp_parser_1.getRegExpAst)(pattern2);
            var endAnchorVisitor = new EndAnchorFinder();
            endAnchorVisitor.visit(regexpAst);
            return endAnchorVisitor.found;
          } catch (e2) {
            return end_of_input.test(pattern2.source);
          }
        });
        var errors = (0, map_1.default)(invalidRegex, function(currType) {
          return {
            message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain end of input anchor '$'\n	See chevrotain.io/docs/guide/resolving_lexer_errors.html#ANCHORS	for details.",
            type: lexer_public_1.LexerDefinitionErrorType.EOI_ANCHOR_FOUND,
            tokenTypes: [currType]
          };
        });
        return errors;
      }
      exports2.findEndOfInputAnchor = findEndOfInputAnchor;
      function findEmptyMatchRegExps(tokenTypes) {
        var matchesEmptyString = (0, filter_1.default)(tokenTypes, function(currType) {
          var pattern2 = currType.PATTERN;
          return pattern2.test("");
        });
        var errors = (0, map_1.default)(matchesEmptyString, function(currType) {
          return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' must not match an empty string",
            type: lexer_public_1.LexerDefinitionErrorType.EMPTY_MATCH_PATTERN,
            tokenTypes: [currType]
          };
        });
        return errors;
      }
      exports2.findEmptyMatchRegExps = findEmptyMatchRegExps;
      var start_of_input = /[^\\[][\^]|^\^/;
      function findStartOfInputAnchor(tokenTypes) {
        var StartAnchorFinder = (
          /** @class */
          function(_super) {
            __extends(StartAnchorFinder2, _super);
            function StartAnchorFinder2() {
              var _this = _super !== null && _super.apply(this, arguments) || this;
              _this.found = false;
              return _this;
            }
            StartAnchorFinder2.prototype.visitStartAnchor = function(node) {
              this.found = true;
            };
            return StartAnchorFinder2;
          }(regexp_to_ast_1.BaseRegExpVisitor)
        );
        var invalidRegex = (0, filter_1.default)(tokenTypes, function(currType) {
          var pattern2 = currType.PATTERN;
          try {
            var regexpAst = (0, reg_exp_parser_1.getRegExpAst)(pattern2);
            var startAnchorVisitor = new StartAnchorFinder();
            startAnchorVisitor.visit(regexpAst);
            return startAnchorVisitor.found;
          } catch (e2) {
            return start_of_input.test(pattern2.source);
          }
        });
        var errors = (0, map_1.default)(invalidRegex, function(currType) {
          return {
            message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain start of input anchor '^'\n	See https://chevrotain.io/docs/guide/resolving_lexer_errors.html#ANCHORS	for details.",
            type: lexer_public_1.LexerDefinitionErrorType.SOI_ANCHOR_FOUND,
            tokenTypes: [currType]
          };
        });
        return errors;
      }
      exports2.findStartOfInputAnchor = findStartOfInputAnchor;
      function findUnsupportedFlags(tokenTypes) {
        var invalidFlags = (0, filter_1.default)(tokenTypes, function(currType) {
          var pattern2 = currType[PATTERN];
          return pattern2 instanceof RegExp && (pattern2.multiline || pattern2.global);
        });
        var errors = (0, map_1.default)(invalidFlags, function(currType) {
          return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' may NOT contain global('g') or multiline('m')",
            type: lexer_public_1.LexerDefinitionErrorType.UNSUPPORTED_FLAGS_FOUND,
            tokenTypes: [currType]
          };
        });
        return errors;
      }
      exports2.findUnsupportedFlags = findUnsupportedFlags;
      function findDuplicatePatterns(tokenTypes) {
        var found = [];
        var identicalPatterns = (0, map_1.default)(tokenTypes, function(outerType) {
          return (0, reduce_1.default)(tokenTypes, function(result, innerType) {
            if (outerType.PATTERN.source === innerType.PATTERN.source && !(0, includes_1.default)(found, innerType) && innerType.PATTERN !== lexer_public_1.Lexer.NA) {
              found.push(innerType);
              result.push(innerType);
              return result;
            }
            return result;
          }, []);
        });
        identicalPatterns = (0, compact_1.default)(identicalPatterns);
        var duplicatePatterns = (0, filter_1.default)(identicalPatterns, function(currIdenticalSet) {
          return currIdenticalSet.length > 1;
        });
        var errors = (0, map_1.default)(duplicatePatterns, function(setOfIdentical) {
          var tokenTypeNames = (0, map_1.default)(setOfIdentical, function(currType) {
            return currType.name;
          });
          var dupPatternSrc = (0, first_1.default)(setOfIdentical).PATTERN;
          return {
            message: "The same RegExp pattern ->".concat(dupPatternSrc, "<-") + "has been used in all of the following Token Types: ".concat(tokenTypeNames.join(", "), " <-"),
            type: lexer_public_1.LexerDefinitionErrorType.DUPLICATE_PATTERNS_FOUND,
            tokenTypes: setOfIdentical
          };
        });
        return errors;
      }
      exports2.findDuplicatePatterns = findDuplicatePatterns;
      function findInvalidGroupType(tokenTypes) {
        var invalidTypes = (0, filter_1.default)(tokenTypes, function(clazz) {
          if (!(0, has_1.default)(clazz, "GROUP")) {
            return false;
          }
          var group = clazz.GROUP;
          return group !== lexer_public_1.Lexer.SKIPPED && group !== lexer_public_1.Lexer.NA && !(0, isString_1.default)(group);
        });
        var errors = (0, map_1.default)(invalidTypes, function(currType) {
          return {
            message: "Token Type: ->" + currType.name + "<- static 'GROUP' can only be Lexer.SKIPPED/Lexer.NA/A String",
            type: lexer_public_1.LexerDefinitionErrorType.INVALID_GROUP_TYPE_FOUND,
            tokenTypes: [currType]
          };
        });
        return errors;
      }
      exports2.findInvalidGroupType = findInvalidGroupType;
      function findModesThatDoNotExist(tokenTypes, validModes) {
        var invalidModes = (0, filter_1.default)(tokenTypes, function(clazz) {
          return clazz.PUSH_MODE !== void 0 && !(0, includes_1.default)(validModes, clazz.PUSH_MODE);
        });
        var errors = (0, map_1.default)(invalidModes, function(tokType) {
          var msg = "Token Type: ->".concat(tokType.name, "<- static 'PUSH_MODE' value cannot refer to a Lexer Mode ->").concat(tokType.PUSH_MODE, "<-") + "which does not exist";
          return {
            message: msg,
            type: lexer_public_1.LexerDefinitionErrorType.PUSH_MODE_DOES_NOT_EXIST,
            tokenTypes: [tokType]
          };
        });
        return errors;
      }
      exports2.findModesThatDoNotExist = findModesThatDoNotExist;
      function findUnreachablePatterns(tokenTypes) {
        var errors = [];
        var canBeTested = (0, reduce_1.default)(tokenTypes, function(result, tokType, idx) {
          var pattern2 = tokType.PATTERN;
          if (pattern2 === lexer_public_1.Lexer.NA) {
            return result;
          }
          if ((0, isString_1.default)(pattern2)) {
            result.push({ str: pattern2, idx, tokenType: tokType });
          } else if ((0, isRegExp_1.default)(pattern2) && noMetaChar(pattern2)) {
            result.push({ str: pattern2.source, idx, tokenType: tokType });
          }
          return result;
        }, []);
        (0, forEach_1.default)(tokenTypes, function(tokType, testIdx) {
          (0, forEach_1.default)(canBeTested, function(_a6) {
            var str = _a6.str, idx = _a6.idx, tokenType = _a6.tokenType;
            if (testIdx < idx && testTokenType(str, tokType.PATTERN)) {
              var msg = "Token: ->".concat(tokenType.name, "<- can never be matched.\n") + "Because it appears AFTER the Token Type ->".concat(tokType.name, "<-") + "in the lexer's definition.\nSee https://chevrotain.io/docs/guide/resolving_lexer_errors.html#UNREACHABLE";
              errors.push({
                message: msg,
                type: lexer_public_1.LexerDefinitionErrorType.UNREACHABLE_PATTERN,
                tokenTypes: [tokType, tokenType]
              });
            }
          });
        });
        return errors;
      }
      exports2.findUnreachablePatterns = findUnreachablePatterns;
      function testTokenType(str, pattern2) {
        if ((0, isRegExp_1.default)(pattern2)) {
          var regExpArray = pattern2.exec(str);
          return regExpArray !== null && regExpArray.index === 0;
        } else if ((0, isFunction_1.default)(pattern2)) {
          return pattern2(str, 0, [], {});
        } else if ((0, has_1.default)(pattern2, "exec")) {
          return pattern2.exec(str, 0, [], {});
        } else if (typeof pattern2 === "string") {
          return pattern2 === str;
        } else {
          throw Error("non exhaustive match");
        }
      }
      function noMetaChar(regExp) {
        var metaChars = [
          ".",
          "\\",
          "[",
          "]",
          "|",
          "^",
          "$",
          "(",
          ")",
          "?",
          "*",
          "+",
          "{"
        ];
        return (0, find_1.default)(metaChars, function(char) {
          return regExp.source.indexOf(char) !== -1;
        }) === void 0;
      }
      function addStartOfInput(pattern2) {
        var flags = pattern2.ignoreCase ? "i" : "";
        return new RegExp("^(?:".concat(pattern2.source, ")"), flags);
      }
      exports2.addStartOfInput = addStartOfInput;
      function addStickyFlag(pattern2) {
        var flags = pattern2.ignoreCase ? "iy" : "y";
        return new RegExp("".concat(pattern2.source), flags);
      }
      exports2.addStickyFlag = addStickyFlag;
      function performRuntimeChecks(lexerDefinition, trackLines, lineTerminatorCharacters) {
        var errors = [];
        if (!(0, has_1.default)(lexerDefinition, exports2.DEFAULT_MODE)) {
          errors.push({
            message: "A MultiMode Lexer cannot be initialized without a <" + exports2.DEFAULT_MODE + "> property in its definition\n",
            type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE
          });
        }
        if (!(0, has_1.default)(lexerDefinition, exports2.MODES)) {
          errors.push({
            message: "A MultiMode Lexer cannot be initialized without a <" + exports2.MODES + "> property in its definition\n",
            type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY
          });
        }
        if ((0, has_1.default)(lexerDefinition, exports2.MODES) && (0, has_1.default)(lexerDefinition, exports2.DEFAULT_MODE) && !(0, has_1.default)(lexerDefinition.modes, lexerDefinition.defaultMode)) {
          errors.push({
            message: "A MultiMode Lexer cannot be initialized with a ".concat(exports2.DEFAULT_MODE, ": <").concat(lexerDefinition.defaultMode, ">") + "which does not exist\n",
            type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST
          });
        }
        if ((0, has_1.default)(lexerDefinition, exports2.MODES)) {
          (0, forEach_1.default)(lexerDefinition.modes, function(currModeValue, currModeName) {
            (0, forEach_1.default)(currModeValue, function(currTokType, currIdx) {
              if ((0, isUndefined_1.default)(currTokType)) {
                errors.push({
                  message: "A Lexer cannot be initialized using an undefined Token Type. Mode:" + "<".concat(currModeName, "> at index: <").concat(currIdx, ">\n"),
                  type: lexer_public_1.LexerDefinitionErrorType.LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED
                });
              } else if ((0, has_1.default)(currTokType, "LONGER_ALT")) {
                var longerAlt = (0, isArray_1.default)(currTokType.LONGER_ALT) ? currTokType.LONGER_ALT : [currTokType.LONGER_ALT];
                (0, forEach_1.default)(longerAlt, function(currLongerAlt) {
                  if (!(0, isUndefined_1.default)(currLongerAlt) && !(0, includes_1.default)(currModeValue, currLongerAlt)) {
                    errors.push({
                      message: "A MultiMode Lexer cannot be initialized with a longer_alt <".concat(currLongerAlt.name, "> on token <").concat(currTokType.name, "> outside of mode <").concat(currModeName, ">\n"),
                      type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_LONGER_ALT_NOT_IN_CURRENT_MODE
                    });
                  }
                });
              }
            });
          });
        }
        return errors;
      }
      exports2.performRuntimeChecks = performRuntimeChecks;
      function performWarningRuntimeChecks(lexerDefinition, trackLines, lineTerminatorCharacters) {
        var warnings = [];
        var hasAnyLineBreak = false;
        var allTokenTypes = (0, compact_1.default)((0, flatten_1.default)((0, values_1.default)(lexerDefinition.modes)));
        var concreteTokenTypes = (0, reject_1.default)(allTokenTypes, function(currType) {
          return currType[PATTERN] === lexer_public_1.Lexer.NA;
        });
        var terminatorCharCodes = getCharCodes(lineTerminatorCharacters);
        if (trackLines) {
          (0, forEach_1.default)(concreteTokenTypes, function(tokType) {
            var currIssue = checkLineBreaksIssues(tokType, terminatorCharCodes);
            if (currIssue !== false) {
              var message = buildLineBreakIssueMessage(tokType, currIssue);
              var warningDescriptor = {
                message,
                type: currIssue.issue,
                tokenType: tokType
              };
              warnings.push(warningDescriptor);
            } else {
              if ((0, has_1.default)(tokType, "LINE_BREAKS")) {
                if (tokType.LINE_BREAKS === true) {
                  hasAnyLineBreak = true;
                }
              } else {
                if ((0, reg_exp_1.canMatchCharCode)(terminatorCharCodes, tokType.PATTERN)) {
                  hasAnyLineBreak = true;
                }
              }
            }
          });
        }
        if (trackLines && !hasAnyLineBreak) {
          warnings.push({
            message: "Warning: No LINE_BREAKS Found.\n	This Lexer has been defined to track line and column information,\n	But none of the Token Types can be identified as matching a line terminator.\n	See https://chevrotain.io/docs/guide/resolving_lexer_errors.html#LINE_BREAKS \n	for details.",
            type: lexer_public_1.LexerDefinitionErrorType.NO_LINE_BREAKS_FLAGS
          });
        }
        return warnings;
      }
      exports2.performWarningRuntimeChecks = performWarningRuntimeChecks;
      function cloneEmptyGroups(emptyGroups) {
        var clonedResult = {};
        var groupKeys = (0, keys_1.default)(emptyGroups);
        (0, forEach_1.default)(groupKeys, function(currKey) {
          var currGroupValue = emptyGroups[currKey];
          if ((0, isArray_1.default)(currGroupValue)) {
            clonedResult[currKey] = [];
          } else {
            throw Error("non exhaustive match");
          }
        });
        return clonedResult;
      }
      exports2.cloneEmptyGroups = cloneEmptyGroups;
      function isCustomPattern(tokenType) {
        var pattern2 = tokenType.PATTERN;
        if ((0, isRegExp_1.default)(pattern2)) {
          return false;
        } else if ((0, isFunction_1.default)(pattern2)) {
          return true;
        } else if ((0, has_1.default)(pattern2, "exec")) {
          return true;
        } else if ((0, isString_1.default)(pattern2)) {
          return false;
        } else {
          throw Error("non exhaustive match");
        }
      }
      exports2.isCustomPattern = isCustomPattern;
      function isShortPattern(pattern2) {
        if ((0, isString_1.default)(pattern2) && pattern2.length === 1) {
          return pattern2.charCodeAt(0);
        } else {
          return false;
        }
      }
      exports2.isShortPattern = isShortPattern;
      exports2.LineTerminatorOptimizedTester = {
        // implements /\n|\r\n?/g.test
        test: function(text) {
          var len = text.length;
          for (var i2 = this.lastIndex; i2 < len; i2++) {
            var c = text.charCodeAt(i2);
            if (c === 10) {
              this.lastIndex = i2 + 1;
              return true;
            } else if (c === 13) {
              if (text.charCodeAt(i2 + 1) === 10) {
                this.lastIndex = i2 + 2;
              } else {
                this.lastIndex = i2 + 1;
              }
              return true;
            }
          }
          return false;
        },
        lastIndex: 0
      };
      function checkLineBreaksIssues(tokType, lineTerminatorCharCodes) {
        if ((0, has_1.default)(tokType, "LINE_BREAKS")) {
          return false;
        } else {
          if ((0, isRegExp_1.default)(tokType.PATTERN)) {
            try {
              (0, reg_exp_1.canMatchCharCode)(lineTerminatorCharCodes, tokType.PATTERN);
            } catch (e2) {
              return {
                issue: lexer_public_1.LexerDefinitionErrorType.IDENTIFY_TERMINATOR,
                errMsg: e2.message
              };
            }
            return false;
          } else if ((0, isString_1.default)(tokType.PATTERN)) {
            return false;
          } else if (isCustomPattern(tokType)) {
            return { issue: lexer_public_1.LexerDefinitionErrorType.CUSTOM_LINE_BREAK };
          } else {
            throw Error("non exhaustive match");
          }
        }
      }
      function buildLineBreakIssueMessage(tokType, details) {
        if (details.issue === lexer_public_1.LexerDefinitionErrorType.IDENTIFY_TERMINATOR) {
          return "Warning: unable to identify line terminator usage in pattern.\n" + "	The problem is in the <".concat(tokType.name, "> Token Type\n") + "	 Root cause: ".concat(details.errMsg, ".\n") + "	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#IDENTIFY_TERMINATOR";
        } else if (details.issue === lexer_public_1.LexerDefinitionErrorType.CUSTOM_LINE_BREAK) {
          return "Warning: A Custom Token Pattern should specify the <line_breaks> option.\n" + "	The problem is in the <".concat(tokType.name, "> Token Type\n") + "	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#CUSTOM_LINE_BREAK";
        } else {
          throw Error("non exhaustive match");
        }
      }
      exports2.buildLineBreakIssueMessage = buildLineBreakIssueMessage;
      function getCharCodes(charsOrCodes) {
        var charCodes = (0, map_1.default)(charsOrCodes, function(numOrString) {
          if ((0, isString_1.default)(numOrString)) {
            return numOrString.charCodeAt(0);
          } else {
            return numOrString;
          }
        });
        return charCodes;
      }
      function addToMapOfArrays(map, key, value) {
        if (map[key] === void 0) {
          map[key] = [value];
        } else {
          map[key].push(value);
        }
      }
      exports2.minOptimizationVal = 256;
      var charCodeToOptimizedIdxMap = [];
      function charCodeToOptimizedIndex(charCode) {
        return charCode < exports2.minOptimizationVal ? charCode : charCodeToOptimizedIdxMap[charCode];
      }
      exports2.charCodeToOptimizedIndex = charCodeToOptimizedIndex;
      function initCharCodeToOptimizedIndexMap() {
        if ((0, isEmpty_1.default)(charCodeToOptimizedIdxMap)) {
          charCodeToOptimizedIdxMap = new Array(65536);
          for (var i2 = 0; i2 < 65536; i2++) {
            charCodeToOptimizedIdxMap[i2] = i2 > 255 ? 255 + ~~(i2 / 255) : i2;
          }
        }
      }
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/last.js
  var require_last = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/last.js"(exports2, module2) {
      function last(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? array[length2 - 1] : void 0;
      }
      module2.exports = last;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/tokens.js
  var require_tokens = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/tokens.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.isTokenType = exports2.hasExtendingTokensTypesMapProperty = exports2.hasExtendingTokensTypesProperty = exports2.hasCategoriesProperty = exports2.hasShortKeyProperty = exports2.singleAssignCategoriesToksMap = exports2.assignCategoriesMapProp = exports2.assignCategoriesTokensProp = exports2.assignTokenDefaultProps = exports2.expandCategories = exports2.augmentTokenTypes = exports2.tokenIdxToClass = exports2.tokenShortNameIdx = exports2.tokenStructuredMatcherNoCategories = exports2.tokenStructuredMatcher = void 0;
      var isEmpty_1 = __importDefault(require_isEmpty());
      var compact_1 = __importDefault(require_compact());
      var isArray_1 = __importDefault(require_isArray());
      var flatten_1 = __importDefault(require_flatten());
      var difference_1 = __importDefault(require_difference());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var has_1 = __importDefault(require_has());
      var includes_1 = __importDefault(require_includes());
      var clone_1 = __importDefault(require_clone());
      function tokenStructuredMatcher(tokInstance, tokConstructor) {
        var instanceType = tokInstance.tokenTypeIdx;
        if (instanceType === tokConstructor.tokenTypeIdx) {
          return true;
        } else {
          return tokConstructor.isParent === true && tokConstructor.categoryMatchesMap[instanceType] === true;
        }
      }
      exports2.tokenStructuredMatcher = tokenStructuredMatcher;
      function tokenStructuredMatcherNoCategories(token, tokType) {
        return token.tokenTypeIdx === tokType.tokenTypeIdx;
      }
      exports2.tokenStructuredMatcherNoCategories = tokenStructuredMatcherNoCategories;
      exports2.tokenShortNameIdx = 1;
      exports2.tokenIdxToClass = {};
      function augmentTokenTypes(tokenTypes) {
        var tokenTypesAndParents = expandCategories(tokenTypes);
        assignTokenDefaultProps(tokenTypesAndParents);
        assignCategoriesMapProp(tokenTypesAndParents);
        assignCategoriesTokensProp(tokenTypesAndParents);
        (0, forEach_1.default)(tokenTypesAndParents, function(tokType) {
          tokType.isParent = tokType.categoryMatches.length > 0;
        });
      }
      exports2.augmentTokenTypes = augmentTokenTypes;
      function expandCategories(tokenTypes) {
        var result = (0, clone_1.default)(tokenTypes);
        var categories = tokenTypes;
        var searching = true;
        while (searching) {
          categories = (0, compact_1.default)((0, flatten_1.default)((0, map_1.default)(categories, function(currTokType) {
            return currTokType.CATEGORIES;
          })));
          var newCategories = (0, difference_1.default)(categories, result);
          result = result.concat(newCategories);
          if ((0, isEmpty_1.default)(newCategories)) {
            searching = false;
          } else {
            categories = newCategories;
          }
        }
        return result;
      }
      exports2.expandCategories = expandCategories;
      function assignTokenDefaultProps(tokenTypes) {
        (0, forEach_1.default)(tokenTypes, function(currTokType) {
          if (!hasShortKeyProperty(currTokType)) {
            exports2.tokenIdxToClass[exports2.tokenShortNameIdx] = currTokType;
            currTokType.tokenTypeIdx = exports2.tokenShortNameIdx++;
          }
          if (hasCategoriesProperty(currTokType) && !(0, isArray_1.default)(currTokType.CATEGORIES)) {
            currTokType.CATEGORIES = [currTokType.CATEGORIES];
          }
          if (!hasCategoriesProperty(currTokType)) {
            currTokType.CATEGORIES = [];
          }
          if (!hasExtendingTokensTypesProperty(currTokType)) {
            currTokType.categoryMatches = [];
          }
          if (!hasExtendingTokensTypesMapProperty(currTokType)) {
            currTokType.categoryMatchesMap = {};
          }
        });
      }
      exports2.assignTokenDefaultProps = assignTokenDefaultProps;
      function assignCategoriesTokensProp(tokenTypes) {
        (0, forEach_1.default)(tokenTypes, function(currTokType) {
          currTokType.categoryMatches = [];
          (0, forEach_1.default)(currTokType.categoryMatchesMap, function(val, key) {
            currTokType.categoryMatches.push(exports2.tokenIdxToClass[key].tokenTypeIdx);
          });
        });
      }
      exports2.assignCategoriesTokensProp = assignCategoriesTokensProp;
      function assignCategoriesMapProp(tokenTypes) {
        (0, forEach_1.default)(tokenTypes, function(currTokType) {
          singleAssignCategoriesToksMap([], currTokType);
        });
      }
      exports2.assignCategoriesMapProp = assignCategoriesMapProp;
      function singleAssignCategoriesToksMap(path3, nextNode) {
        (0, forEach_1.default)(path3, function(pathNode) {
          nextNode.categoryMatchesMap[pathNode.tokenTypeIdx] = true;
        });
        (0, forEach_1.default)(nextNode.CATEGORIES, function(nextCategory) {
          var newPath = path3.concat(nextNode);
          if (!(0, includes_1.default)(newPath, nextCategory)) {
            singleAssignCategoriesToksMap(newPath, nextCategory);
          }
        });
      }
      exports2.singleAssignCategoriesToksMap = singleAssignCategoriesToksMap;
      function hasShortKeyProperty(tokType) {
        return (0, has_1.default)(tokType, "tokenTypeIdx");
      }
      exports2.hasShortKeyProperty = hasShortKeyProperty;
      function hasCategoriesProperty(tokType) {
        return (0, has_1.default)(tokType, "CATEGORIES");
      }
      exports2.hasCategoriesProperty = hasCategoriesProperty;
      function hasExtendingTokensTypesProperty(tokType) {
        return (0, has_1.default)(tokType, "categoryMatches");
      }
      exports2.hasExtendingTokensTypesProperty = hasExtendingTokensTypesProperty;
      function hasExtendingTokensTypesMapProperty(tokType) {
        return (0, has_1.default)(tokType, "categoryMatchesMap");
      }
      exports2.hasExtendingTokensTypesMapProperty = hasExtendingTokensTypesMapProperty;
      function isTokenType(tokType) {
        return (0, has_1.default)(tokType, "tokenTypeIdx");
      }
      exports2.isTokenType = isTokenType;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/lexer_errors_public.js
  var require_lexer_errors_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/lexer_errors_public.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.defaultLexerErrorProvider = void 0;
      exports2.defaultLexerErrorProvider = {
        buildUnableToPopLexerModeMessage: function(token) {
          return "Unable to pop Lexer Mode after encountering Token ->".concat(token.image, "<- The Mode Stack is empty");
        },
        buildUnexpectedCharactersMessage: function(fullText, startOffset, length2, line, column) {
          return "unexpected character: ->".concat(fullText.charAt(startOffset), "<- at offset: ").concat(startOffset, ",") + " skipped ".concat(length2, " characters.");
        }
      };
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/lexer_public.js
  var require_lexer_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/lexer_public.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.Lexer = exports2.LexerDefinitionErrorType = void 0;
      var lexer_1 = require_lexer();
      var noop_1 = __importDefault(require_noop());
      var isEmpty_1 = __importDefault(require_isEmpty());
      var isArray_1 = __importDefault(require_isArray());
      var last_1 = __importDefault(require_last());
      var reject_1 = __importDefault(require_reject());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var keys_1 = __importDefault(require_keys());
      var isUndefined_1 = __importDefault(require_isUndefined());
      var identity_1 = __importDefault(require_identity());
      var assign_1 = __importDefault(require_assign());
      var reduce_1 = __importDefault(require_reduce());
      var clone_1 = __importDefault(require_clone());
      var utils_1 = require_api();
      var tokens_1 = require_tokens();
      var lexer_errors_public_1 = require_lexer_errors_public();
      var reg_exp_parser_1 = require_reg_exp_parser();
      var LexerDefinitionErrorType2;
      (function(LexerDefinitionErrorType3) {
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["MISSING_PATTERN"] = 0] = "MISSING_PATTERN";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["INVALID_PATTERN"] = 1] = "INVALID_PATTERN";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["EOI_ANCHOR_FOUND"] = 2] = "EOI_ANCHOR_FOUND";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["UNSUPPORTED_FLAGS_FOUND"] = 3] = "UNSUPPORTED_FLAGS_FOUND";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["DUPLICATE_PATTERNS_FOUND"] = 4] = "DUPLICATE_PATTERNS_FOUND";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["INVALID_GROUP_TYPE_FOUND"] = 5] = "INVALID_GROUP_TYPE_FOUND";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["PUSH_MODE_DOES_NOT_EXIST"] = 6] = "PUSH_MODE_DOES_NOT_EXIST";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE"] = 7] = "MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY"] = 8] = "MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST"] = 9] = "MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED"] = 10] = "LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["SOI_ANCHOR_FOUND"] = 11] = "SOI_ANCHOR_FOUND";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["EMPTY_MATCH_PATTERN"] = 12] = "EMPTY_MATCH_PATTERN";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["NO_LINE_BREAKS_FLAGS"] = 13] = "NO_LINE_BREAKS_FLAGS";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["UNREACHABLE_PATTERN"] = 14] = "UNREACHABLE_PATTERN";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["IDENTIFY_TERMINATOR"] = 15] = "IDENTIFY_TERMINATOR";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["CUSTOM_LINE_BREAK"] = 16] = "CUSTOM_LINE_BREAK";
        LexerDefinitionErrorType3[LexerDefinitionErrorType3["MULTI_MODE_LEXER_LONGER_ALT_NOT_IN_CURRENT_MODE"] = 17] = "MULTI_MODE_LEXER_LONGER_ALT_NOT_IN_CURRENT_MODE";
      })(LexerDefinitionErrorType2 = exports2.LexerDefinitionErrorType || (exports2.LexerDefinitionErrorType = {}));
      var DEFAULT_LEXER_CONFIG = {
        deferDefinitionErrorsHandling: false,
        positionTracking: "full",
        lineTerminatorsPattern: /\n|\r\n?/g,
        lineTerminatorCharacters: ["\n", "\r"],
        ensureOptimizations: false,
        safeMode: false,
        errorMessageProvider: lexer_errors_public_1.defaultLexerErrorProvider,
        traceInitPerf: false,
        skipValidations: false,
        recoveryEnabled: true
      };
      Object.freeze(DEFAULT_LEXER_CONFIG);
      var Lexer2 = (
        /** @class */
        function() {
          function Lexer3(lexerDefinition, config) {
            if (config === void 0) {
              config = DEFAULT_LEXER_CONFIG;
            }
            var _this = this;
            this.lexerDefinition = lexerDefinition;
            this.lexerDefinitionErrors = [];
            this.lexerDefinitionWarning = [];
            this.patternIdxToConfig = {};
            this.charCodeToPatternIdxToConfig = {};
            this.modes = [];
            this.emptyGroups = {};
            this.trackStartLines = true;
            this.trackEndLines = true;
            this.hasCustom = false;
            this.canModeBeOptimized = {};
            this.TRACE_INIT = function(phaseDesc, phaseImpl) {
              if (_this.traceInitPerf === true) {
                _this.traceInitIndent++;
                var indent = new Array(_this.traceInitIndent + 1).join("	");
                if (_this.traceInitIndent < _this.traceInitMaxIdent) {
                  console.log("".concat(indent, "--> <").concat(phaseDesc, ">"));
                }
                var _a6 = (0, utils_1.timer)(phaseImpl), time = _a6.time, value = _a6.value;
                var traceMethod = time > 10 ? console.warn : console.log;
                if (_this.traceInitIndent < _this.traceInitMaxIdent) {
                  traceMethod("".concat(indent, "<-- <").concat(phaseDesc, "> time: ").concat(time, "ms"));
                }
                _this.traceInitIndent--;
                return value;
              } else {
                return phaseImpl();
              }
            };
            if (typeof config === "boolean") {
              throw Error("The second argument to the Lexer constructor is now an ILexerConfig Object.\na boolean 2nd argument is no longer supported");
            }
            this.config = (0, assign_1.default)({}, DEFAULT_LEXER_CONFIG, config);
            var traceInitVal = this.config.traceInitPerf;
            if (traceInitVal === true) {
              this.traceInitMaxIdent = Infinity;
              this.traceInitPerf = true;
            } else if (typeof traceInitVal === "number") {
              this.traceInitMaxIdent = traceInitVal;
              this.traceInitPerf = true;
            }
            this.traceInitIndent = -1;
            this.TRACE_INIT("Lexer Constructor", function() {
              var actualDefinition;
              var hasOnlySingleMode = true;
              _this.TRACE_INIT("Lexer Config handling", function() {
                if (_this.config.lineTerminatorsPattern === DEFAULT_LEXER_CONFIG.lineTerminatorsPattern) {
                  _this.config.lineTerminatorsPattern = lexer_1.LineTerminatorOptimizedTester;
                } else {
                  if (_this.config.lineTerminatorCharacters === DEFAULT_LEXER_CONFIG.lineTerminatorCharacters) {
                    throw Error("Error: Missing <lineTerminatorCharacters> property on the Lexer config.\n	For details See: https://chevrotain.io/docs/guide/resolving_lexer_errors.html#MISSING_LINE_TERM_CHARS");
                  }
                }
                if (config.safeMode && config.ensureOptimizations) {
                  throw Error('"safeMode" and "ensureOptimizations" flags are mutually exclusive.');
                }
                _this.trackStartLines = /full|onlyStart/i.test(_this.config.positionTracking);
                _this.trackEndLines = /full/i.test(_this.config.positionTracking);
                if ((0, isArray_1.default)(lexerDefinition)) {
                  actualDefinition = {
                    modes: { defaultMode: (0, clone_1.default)(lexerDefinition) },
                    defaultMode: lexer_1.DEFAULT_MODE
                  };
                } else {
                  hasOnlySingleMode = false;
                  actualDefinition = (0, clone_1.default)(lexerDefinition);
                }
              });
              if (_this.config.skipValidations === false) {
                _this.TRACE_INIT("performRuntimeChecks", function() {
                  _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat((0, lexer_1.performRuntimeChecks)(actualDefinition, _this.trackStartLines, _this.config.lineTerminatorCharacters));
                });
                _this.TRACE_INIT("performWarningRuntimeChecks", function() {
                  _this.lexerDefinitionWarning = _this.lexerDefinitionWarning.concat((0, lexer_1.performWarningRuntimeChecks)(actualDefinition, _this.trackStartLines, _this.config.lineTerminatorCharacters));
                });
              }
              actualDefinition.modes = actualDefinition.modes ? actualDefinition.modes : {};
              (0, forEach_1.default)(actualDefinition.modes, function(currModeValue, currModeName) {
                actualDefinition.modes[currModeName] = (0, reject_1.default)(currModeValue, function(currTokType) {
                  return (0, isUndefined_1.default)(currTokType);
                });
              });
              var allModeNames = (0, keys_1.default)(actualDefinition.modes);
              (0, forEach_1.default)(actualDefinition.modes, function(currModDef, currModName) {
                _this.TRACE_INIT("Mode: <".concat(currModName, "> processing"), function() {
                  _this.modes.push(currModName);
                  if (_this.config.skipValidations === false) {
                    _this.TRACE_INIT("validatePatterns", function() {
                      _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat((0, lexer_1.validatePatterns)(currModDef, allModeNames));
                    });
                  }
                  if ((0, isEmpty_1.default)(_this.lexerDefinitionErrors)) {
                    (0, tokens_1.augmentTokenTypes)(currModDef);
                    var currAnalyzeResult_1;
                    _this.TRACE_INIT("analyzeTokenTypes", function() {
                      currAnalyzeResult_1 = (0, lexer_1.analyzeTokenTypes)(currModDef, {
                        lineTerminatorCharacters: _this.config.lineTerminatorCharacters,
                        positionTracking: config.positionTracking,
                        ensureOptimizations: config.ensureOptimizations,
                        safeMode: config.safeMode,
                        tracer: _this.TRACE_INIT
                      });
                    });
                    _this.patternIdxToConfig[currModName] = currAnalyzeResult_1.patternIdxToConfig;
                    _this.charCodeToPatternIdxToConfig[currModName] = currAnalyzeResult_1.charCodeToPatternIdxToConfig;
                    _this.emptyGroups = (0, assign_1.default)({}, _this.emptyGroups, currAnalyzeResult_1.emptyGroups);
                    _this.hasCustom = currAnalyzeResult_1.hasCustom || _this.hasCustom;
                    _this.canModeBeOptimized[currModName] = currAnalyzeResult_1.canBeOptimized;
                  }
                });
              });
              _this.defaultMode = actualDefinition.defaultMode;
              if (!(0, isEmpty_1.default)(_this.lexerDefinitionErrors) && !_this.config.deferDefinitionErrorsHandling) {
                var allErrMessages = (0, map_1.default)(_this.lexerDefinitionErrors, function(error) {
                  return error.message;
                });
                var allErrMessagesString = allErrMessages.join("-----------------------\n");
                throw new Error("Errors detected in definition of Lexer:\n" + allErrMessagesString);
              }
              (0, forEach_1.default)(_this.lexerDefinitionWarning, function(warningDescriptor) {
                (0, utils_1.PRINT_WARNING)(warningDescriptor.message);
              });
              _this.TRACE_INIT("Choosing sub-methods implementations", function() {
                if (lexer_1.SUPPORT_STICKY) {
                  _this.chopInput = identity_1.default;
                  _this.match = _this.matchWithTest;
                } else {
                  _this.updateLastIndex = noop_1.default;
                  _this.match = _this.matchWithExec;
                }
                if (hasOnlySingleMode) {
                  _this.handleModes = noop_1.default;
                }
                if (_this.trackStartLines === false) {
                  _this.computeNewColumn = identity_1.default;
                }
                if (_this.trackEndLines === false) {
                  _this.updateTokenEndLineColumnLocation = noop_1.default;
                }
                if (/full/i.test(_this.config.positionTracking)) {
                  _this.createTokenInstance = _this.createFullToken;
                } else if (/onlyStart/i.test(_this.config.positionTracking)) {
                  _this.createTokenInstance = _this.createStartOnlyToken;
                } else if (/onlyOffset/i.test(_this.config.positionTracking)) {
                  _this.createTokenInstance = _this.createOffsetOnlyToken;
                } else {
                  throw Error('Invalid <positionTracking> config option: "'.concat(_this.config.positionTracking, '"'));
                }
                if (_this.hasCustom) {
                  _this.addToken = _this.addTokenUsingPush;
                  _this.handlePayload = _this.handlePayloadWithCustom;
                } else {
                  _this.addToken = _this.addTokenUsingMemberAccess;
                  _this.handlePayload = _this.handlePayloadNoCustom;
                }
              });
              _this.TRACE_INIT("Failed Optimization Warnings", function() {
                var unOptimizedModes = (0, reduce_1.default)(_this.canModeBeOptimized, function(cannotBeOptimized, canBeOptimized, modeName) {
                  if (canBeOptimized === false) {
                    cannotBeOptimized.push(modeName);
                  }
                  return cannotBeOptimized;
                }, []);
                if (config.ensureOptimizations && !(0, isEmpty_1.default)(unOptimizedModes)) {
                  throw Error("Lexer Modes: < ".concat(unOptimizedModes.join(", "), " > cannot be optimized.\n") + '	 Disable the "ensureOptimizations" lexer config flag to silently ignore this and run the lexer in an un-optimized mode.\n	 Or inspect the console log for details on how to resolve these issues.');
                }
              });
              _this.TRACE_INIT("clearRegExpParserCache", function() {
                (0, reg_exp_parser_1.clearRegExpParserCache)();
              });
              _this.TRACE_INIT("toFastProperties", function() {
                (0, utils_1.toFastProperties)(_this);
              });
            });
          }
          Lexer3.prototype.tokenize = function(text, initialMode) {
            if (initialMode === void 0) {
              initialMode = this.defaultMode;
            }
            if (!(0, isEmpty_1.default)(this.lexerDefinitionErrors)) {
              var allErrMessages = (0, map_1.default)(this.lexerDefinitionErrors, function(error) {
                return error.message;
              });
              var allErrMessagesString = allErrMessages.join("-----------------------\n");
              throw new Error("Unable to Tokenize because Errors detected in definition of Lexer:\n" + allErrMessagesString);
            }
            return this.tokenizeInternal(text, initialMode);
          };
          Lexer3.prototype.tokenizeInternal = function(text, initialMode) {
            var _this = this;
            var i2, j, k, matchAltImage, longerAlt, matchedImage, payload, altPayload, imageLength, group, tokType, newToken, errLength, droppedChar, msg, match;
            var orgText = text;
            var orgLength = orgText.length;
            var offset = 0;
            var matchedTokensIndex = 0;
            var guessedNumberOfTokens = this.hasCustom ? 0 : Math.floor(text.length / 10);
            var matchedTokens = new Array(guessedNumberOfTokens);
            var errors = [];
            var line = this.trackStartLines ? 1 : void 0;
            var column = this.trackStartLines ? 1 : void 0;
            var groups = (0, lexer_1.cloneEmptyGroups)(this.emptyGroups);
            var trackLines = this.trackStartLines;
            var lineTerminatorPattern = this.config.lineTerminatorsPattern;
            var currModePatternsLength = 0;
            var patternIdxToConfig = [];
            var currCharCodeToPatternIdxToConfig = [];
            var modeStack = [];
            var emptyArray = [];
            Object.freeze(emptyArray);
            var getPossiblePatterns;
            function getPossiblePatternsSlow() {
              return patternIdxToConfig;
            }
            function getPossiblePatternsOptimized(charCode) {
              var optimizedCharIdx = (0, lexer_1.charCodeToOptimizedIndex)(charCode);
              var possiblePatterns = currCharCodeToPatternIdxToConfig[optimizedCharIdx];
              if (possiblePatterns === void 0) {
                return emptyArray;
              } else {
                return possiblePatterns;
              }
            }
            var pop_mode = function(popToken) {
              if (modeStack.length === 1 && // if we have both a POP_MODE and a PUSH_MODE this is in-fact a "transition"
              // So no error should occur.
              popToken.tokenType.PUSH_MODE === void 0) {
                var msg_1 = _this.config.errorMessageProvider.buildUnableToPopLexerModeMessage(popToken);
                errors.push({
                  offset: popToken.startOffset,
                  line: popToken.startLine,
                  column: popToken.startColumn,
                  length: popToken.image.length,
                  message: msg_1
                });
              } else {
                modeStack.pop();
                var newMode = (0, last_1.default)(modeStack);
                patternIdxToConfig = _this.patternIdxToConfig[newMode];
                currCharCodeToPatternIdxToConfig = _this.charCodeToPatternIdxToConfig[newMode];
                currModePatternsLength = patternIdxToConfig.length;
                var modeCanBeOptimized = _this.canModeBeOptimized[newMode] && _this.config.safeMode === false;
                if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) {
                  getPossiblePatterns = getPossiblePatternsOptimized;
                } else {
                  getPossiblePatterns = getPossiblePatternsSlow;
                }
              }
            };
            function push_mode(newMode) {
              modeStack.push(newMode);
              currCharCodeToPatternIdxToConfig = this.charCodeToPatternIdxToConfig[newMode];
              patternIdxToConfig = this.patternIdxToConfig[newMode];
              currModePatternsLength = patternIdxToConfig.length;
              currModePatternsLength = patternIdxToConfig.length;
              var modeCanBeOptimized = this.canModeBeOptimized[newMode] && this.config.safeMode === false;
              if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) {
                getPossiblePatterns = getPossiblePatternsOptimized;
              } else {
                getPossiblePatterns = getPossiblePatternsSlow;
              }
            }
            push_mode.call(this, initialMode);
            var currConfig;
            var recoveryEnabled = this.config.recoveryEnabled;
            while (offset < orgLength) {
              matchedImage = null;
              var nextCharCode = orgText.charCodeAt(offset);
              var chosenPatternIdxToConfig = getPossiblePatterns(nextCharCode);
              var chosenPatternsLength = chosenPatternIdxToConfig.length;
              for (i2 = 0; i2 < chosenPatternsLength; i2++) {
                currConfig = chosenPatternIdxToConfig[i2];
                var currPattern = currConfig.pattern;
                payload = null;
                var singleCharCode = currConfig.short;
                if (singleCharCode !== false) {
                  if (nextCharCode === singleCharCode) {
                    matchedImage = currPattern;
                  }
                } else if (currConfig.isCustom === true) {
                  match = currPattern.exec(orgText, offset, matchedTokens, groups);
                  if (match !== null) {
                    matchedImage = match[0];
                    if (match.payload !== void 0) {
                      payload = match.payload;
                    }
                  } else {
                    matchedImage = null;
                  }
                } else {
                  this.updateLastIndex(currPattern, offset);
                  matchedImage = this.match(currPattern, text, offset);
                }
                if (matchedImage !== null) {
                  longerAlt = currConfig.longerAlt;
                  if (longerAlt !== void 0) {
                    var longerAltLength = longerAlt.length;
                    for (k = 0; k < longerAltLength; k++) {
                      var longerAltConfig = patternIdxToConfig[longerAlt[k]];
                      var longerAltPattern = longerAltConfig.pattern;
                      altPayload = null;
                      if (longerAltConfig.isCustom === true) {
                        match = longerAltPattern.exec(orgText, offset, matchedTokens, groups);
                        if (match !== null) {
                          matchAltImage = match[0];
                          if (match.payload !== void 0) {
                            altPayload = match.payload;
                          }
                        } else {
                          matchAltImage = null;
                        }
                      } else {
                        this.updateLastIndex(longerAltPattern, offset);
                        matchAltImage = this.match(longerAltPattern, text, offset);
                      }
                      if (matchAltImage && matchAltImage.length > matchedImage.length) {
                        matchedImage = matchAltImage;
                        payload = altPayload;
                        currConfig = longerAltConfig;
                        break;
                      }
                    }
                  }
                  break;
                }
              }
              if (matchedImage !== null) {
                imageLength = matchedImage.length;
                group = currConfig.group;
                if (group !== void 0) {
                  tokType = currConfig.tokenTypeIdx;
                  newToken = this.createTokenInstance(matchedImage, offset, tokType, currConfig.tokenType, line, column, imageLength);
                  this.handlePayload(newToken, payload);
                  if (group === false) {
                    matchedTokensIndex = this.addToken(matchedTokens, matchedTokensIndex, newToken);
                  } else {
                    groups[group].push(newToken);
                  }
                }
                text = this.chopInput(text, imageLength);
                offset = offset + imageLength;
                column = this.computeNewColumn(column, imageLength);
                if (trackLines === true && currConfig.canLineTerminator === true) {
                  var numOfLTsInMatch = 0;
                  var foundTerminator = void 0;
                  var lastLTEndOffset = void 0;
                  lineTerminatorPattern.lastIndex = 0;
                  do {
                    foundTerminator = lineTerminatorPattern.test(matchedImage);
                    if (foundTerminator === true) {
                      lastLTEndOffset = lineTerminatorPattern.lastIndex - 1;
                      numOfLTsInMatch++;
                    }
                  } while (foundTerminator === true);
                  if (numOfLTsInMatch !== 0) {
                    line = line + numOfLTsInMatch;
                    column = imageLength - lastLTEndOffset;
                    this.updateTokenEndLineColumnLocation(newToken, group, lastLTEndOffset, numOfLTsInMatch, line, column, imageLength);
                  }
                }
                this.handleModes(currConfig, pop_mode, push_mode, newToken);
              } else {
                var errorStartOffset = offset;
                var errorLine = line;
                var errorColumn = column;
                var foundResyncPoint = recoveryEnabled === false;
                while (foundResyncPoint === false && offset < orgLength) {
                  text = this.chopInput(text, 1);
                  offset++;
                  for (j = 0; j < currModePatternsLength; j++) {
                    var currConfig_1 = patternIdxToConfig[j];
                    var currPattern = currConfig_1.pattern;
                    var singleCharCode = currConfig_1.short;
                    if (singleCharCode !== false) {
                      if (orgText.charCodeAt(offset) === singleCharCode) {
                        foundResyncPoint = true;
                      }
                    } else if (currConfig_1.isCustom === true) {
                      foundResyncPoint = currPattern.exec(orgText, offset, matchedTokens, groups) !== null;
                    } else {
                      this.updateLastIndex(currPattern, offset);
                      foundResyncPoint = currPattern.exec(text) !== null;
                    }
                    if (foundResyncPoint === true) {
                      break;
                    }
                  }
                }
                errLength = offset - errorStartOffset;
                msg = this.config.errorMessageProvider.buildUnexpectedCharactersMessage(orgText, errorStartOffset, errLength, errorLine, errorColumn);
                errors.push({
                  offset: errorStartOffset,
                  line: errorLine,
                  column: errorColumn,
                  length: errLength,
                  message: msg
                });
                if (recoveryEnabled === false) {
                  break;
                }
              }
            }
            if (!this.hasCustom) {
              matchedTokens.length = matchedTokensIndex;
            }
            return {
              tokens: matchedTokens,
              groups,
              errors
            };
          };
          Lexer3.prototype.handleModes = function(config, pop_mode, push_mode, newToken) {
            if (config.pop === true) {
              var pushMode = config.push;
              pop_mode(newToken);
              if (pushMode !== void 0) {
                push_mode.call(this, pushMode);
              }
            } else if (config.push !== void 0) {
              push_mode.call(this, config.push);
            }
          };
          Lexer3.prototype.chopInput = function(text, length2) {
            return text.substring(length2);
          };
          Lexer3.prototype.updateLastIndex = function(regExp, newLastIndex) {
            regExp.lastIndex = newLastIndex;
          };
          Lexer3.prototype.updateTokenEndLineColumnLocation = function(newToken, group, lastLTIdx, numOfLTsInMatch, line, column, imageLength) {
            var lastCharIsLT, fixForEndingInLT;
            if (group !== void 0) {
              lastCharIsLT = lastLTIdx === imageLength - 1;
              fixForEndingInLT = lastCharIsLT ? -1 : 0;
              if (!(numOfLTsInMatch === 1 && lastCharIsLT === true)) {
                newToken.endLine = line + fixForEndingInLT;
                newToken.endColumn = column - 1 + -fixForEndingInLT;
              }
            }
          };
          Lexer3.prototype.computeNewColumn = function(oldColumn, imageLength) {
            return oldColumn + imageLength;
          };
          Lexer3.prototype.createOffsetOnlyToken = function(image, startOffset, tokenTypeIdx, tokenType) {
            return {
              image,
              startOffset,
              tokenTypeIdx,
              tokenType
            };
          };
          Lexer3.prototype.createStartOnlyToken = function(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn) {
            return {
              image,
              startOffset,
              startLine,
              startColumn,
              tokenTypeIdx,
              tokenType
            };
          };
          Lexer3.prototype.createFullToken = function(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn, imageLength) {
            return {
              image,
              startOffset,
              endOffset: startOffset + imageLength - 1,
              startLine,
              endLine: startLine,
              startColumn,
              endColumn: startColumn + imageLength - 1,
              tokenTypeIdx,
              tokenType
            };
          };
          Lexer3.prototype.addTokenUsingPush = function(tokenVector, index2, tokenToAdd) {
            tokenVector.push(tokenToAdd);
            return index2;
          };
          Lexer3.prototype.addTokenUsingMemberAccess = function(tokenVector, index2, tokenToAdd) {
            tokenVector[index2] = tokenToAdd;
            index2++;
            return index2;
          };
          Lexer3.prototype.handlePayloadNoCustom = function(token, payload) {
          };
          Lexer3.prototype.handlePayloadWithCustom = function(token, payload) {
            if (payload !== null) {
              token.payload = payload;
            }
          };
          Lexer3.prototype.matchWithTest = function(pattern2, text, offset) {
            var found = pattern2.test(text);
            if (found === true) {
              return text.substring(offset, pattern2.lastIndex);
            }
            return null;
          };
          Lexer3.prototype.matchWithExec = function(pattern2, text) {
            var regExpArray = pattern2.exec(text);
            return regExpArray !== null ? regExpArray[0] : null;
          };
          Lexer3.SKIPPED = "This marks a skipped Token pattern, this means each token identified by it willbe consumed and then thrown into oblivion, this can be used to for example to completely ignore whitespace.";
          Lexer3.NA = /NOT_APPLICABLE/;
          return Lexer3;
        }()
      );
      exports2.Lexer = Lexer2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/tokens_public.js
  var require_tokens_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/scan/tokens_public.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.tokenMatcher = exports2.createTokenInstance = exports2.EOF = exports2.createToken = exports2.hasTokenLabel = exports2.tokenName = exports2.tokenLabel = void 0;
      var isString_1 = __importDefault(require_isString());
      var has_1 = __importDefault(require_has());
      var isUndefined_1 = __importDefault(require_isUndefined());
      var lexer_public_1 = require_lexer_public();
      var tokens_1 = require_tokens();
      function tokenLabel2(tokType) {
        if (hasTokenLabel(tokType)) {
          return tokType.LABEL;
        } else {
          return tokType.name;
        }
      }
      exports2.tokenLabel = tokenLabel2;
      function tokenName2(tokType) {
        return tokType.name;
      }
      exports2.tokenName = tokenName2;
      function hasTokenLabel(obj) {
        return (0, isString_1.default)(obj.LABEL) && obj.LABEL !== "";
      }
      exports2.hasTokenLabel = hasTokenLabel;
      var PARENT = "parent";
      var CATEGORIES = "categories";
      var LABEL = "label";
      var GROUP = "group";
      var PUSH_MODE = "push_mode";
      var POP_MODE = "pop_mode";
      var LONGER_ALT = "longer_alt";
      var LINE_BREAKS = "line_breaks";
      var START_CHARS_HINT = "start_chars_hint";
      function createToken2(config) {
        return createTokenInternal(config);
      }
      exports2.createToken = createToken2;
      function createTokenInternal(config) {
        var pattern2 = config.pattern;
        var tokenType = {};
        tokenType.name = config.name;
        if (!(0, isUndefined_1.default)(pattern2)) {
          tokenType.PATTERN = pattern2;
        }
        if ((0, has_1.default)(config, PARENT)) {
          throw "The parent property is no longer supported.\nSee: https://github.com/chevrotain/chevrotain/issues/564#issuecomment-349062346 for details.";
        }
        if ((0, has_1.default)(config, CATEGORIES)) {
          tokenType.CATEGORIES = config[CATEGORIES];
        }
        (0, tokens_1.augmentTokenTypes)([tokenType]);
        if ((0, has_1.default)(config, LABEL)) {
          tokenType.LABEL = config[LABEL];
        }
        if ((0, has_1.default)(config, GROUP)) {
          tokenType.GROUP = config[GROUP];
        }
        if ((0, has_1.default)(config, POP_MODE)) {
          tokenType.POP_MODE = config[POP_MODE];
        }
        if ((0, has_1.default)(config, PUSH_MODE)) {
          tokenType.PUSH_MODE = config[PUSH_MODE];
        }
        if ((0, has_1.default)(config, LONGER_ALT)) {
          tokenType.LONGER_ALT = config[LONGER_ALT];
        }
        if ((0, has_1.default)(config, LINE_BREAKS)) {
          tokenType.LINE_BREAKS = config[LINE_BREAKS];
        }
        if ((0, has_1.default)(config, START_CHARS_HINT)) {
          tokenType.START_CHARS_HINT = config[START_CHARS_HINT];
        }
        return tokenType;
      }
      exports2.EOF = createToken2({ name: "EOF", pattern: lexer_public_1.Lexer.NA });
      (0, tokens_1.augmentTokenTypes)([exports2.EOF]);
      function createTokenInstance2(tokType, image, startOffset, endOffset, startLine, endLine, startColumn, endColumn) {
        return {
          image,
          startOffset,
          endOffset,
          startLine,
          endLine,
          startColumn,
          endColumn,
          tokenTypeIdx: tokType.tokenTypeIdx,
          tokenType: tokType
        };
      }
      exports2.createTokenInstance = createTokenInstance2;
      function tokenMatcher2(token, tokType) {
        return (0, tokens_1.tokenStructuredMatcher)(token, tokType);
      }
      exports2.tokenMatcher = tokenMatcher2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/errors_public.js
  var require_errors_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/errors_public.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.defaultGrammarValidatorErrorProvider = exports2.defaultGrammarResolverErrorProvider = exports2.defaultParserErrorProvider = void 0;
      var tokens_public_1 = require_tokens_public();
      var first_1 = __importDefault(require_first2());
      var map_1 = __importDefault(require_map());
      var reduce_1 = __importDefault(require_reduce());
      var gast_1 = require_api2();
      var gast_2 = require_api2();
      exports2.defaultParserErrorProvider = {
        buildMismatchTokenMessage: function(_a6) {
          var expected = _a6.expected, actual = _a6.actual, previous = _a6.previous, ruleName = _a6.ruleName;
          var hasLabel = (0, tokens_public_1.hasTokenLabel)(expected);
          var expectedMsg = hasLabel ? "--> ".concat((0, tokens_public_1.tokenLabel)(expected), " <--") : "token of type --> ".concat(expected.name, " <--");
          var msg = "Expecting ".concat(expectedMsg, " but found --> '").concat(actual.image, "' <--");
          return msg;
        },
        buildNotAllInputParsedMessage: function(_a6) {
          var firstRedundant = _a6.firstRedundant, ruleName = _a6.ruleName;
          return "Redundant input, expecting EOF but found: " + firstRedundant.image;
        },
        buildNoViableAltMessage: function(_a6) {
          var expectedPathsPerAlt = _a6.expectedPathsPerAlt, actual = _a6.actual, previous = _a6.previous, customUserDescription = _a6.customUserDescription, ruleName = _a6.ruleName;
          var errPrefix = "Expecting: ";
          var actualText = (0, first_1.default)(actual).image;
          var errSuffix = "\nbut found: '" + actualText + "'";
          if (customUserDescription) {
            return errPrefix + customUserDescription + errSuffix;
          } else {
            var allLookAheadPaths = (0, reduce_1.default)(expectedPathsPerAlt, function(result, currAltPaths) {
              return result.concat(currAltPaths);
            }, []);
            var nextValidTokenSequences = (0, map_1.default)(allLookAheadPaths, function(currPath) {
              return "[".concat((0, map_1.default)(currPath, function(currTokenType) {
                return (0, tokens_public_1.tokenLabel)(currTokenType);
              }).join(", "), "]");
            });
            var nextValidSequenceItems = (0, map_1.default)(nextValidTokenSequences, function(itemMsg, idx) {
              return "  ".concat(idx + 1, ". ").concat(itemMsg);
            });
            var calculatedDescription = "one of these possible Token sequences:\n".concat(nextValidSequenceItems.join("\n"));
            return errPrefix + calculatedDescription + errSuffix;
          }
        },
        buildEarlyExitMessage: function(_a6) {
          var expectedIterationPaths = _a6.expectedIterationPaths, actual = _a6.actual, customUserDescription = _a6.customUserDescription, ruleName = _a6.ruleName;
          var errPrefix = "Expecting: ";
          var actualText = (0, first_1.default)(actual).image;
          var errSuffix = "\nbut found: '" + actualText + "'";
          if (customUserDescription) {
            return errPrefix + customUserDescription + errSuffix;
          } else {
            var nextValidTokenSequences = (0, map_1.default)(expectedIterationPaths, function(currPath) {
              return "[".concat((0, map_1.default)(currPath, function(currTokenType) {
                return (0, tokens_public_1.tokenLabel)(currTokenType);
              }).join(","), "]");
            });
            var calculatedDescription = "expecting at least one iteration which starts with one of these possible Token sequences::\n  " + "<".concat(nextValidTokenSequences.join(" ,"), ">");
            return errPrefix + calculatedDescription + errSuffix;
          }
        }
      };
      Object.freeze(exports2.defaultParserErrorProvider);
      exports2.defaultGrammarResolverErrorProvider = {
        buildRuleNotFoundError: function(topLevelRule, undefinedRule) {
          var msg = "Invalid grammar, reference to a rule which is not defined: ->" + undefinedRule.nonTerminalName + "<-\ninside top level rule: ->" + topLevelRule.name + "<-";
          return msg;
        }
      };
      exports2.defaultGrammarValidatorErrorProvider = {
        buildDuplicateFoundError: function(topLevelRule, duplicateProds) {
          function getExtraProductionArgument(prod) {
            if (prod instanceof gast_1.Terminal) {
              return prod.terminalType.name;
            } else if (prod instanceof gast_1.NonTerminal) {
              return prod.nonTerminalName;
            } else {
              return "";
            }
          }
          var topLevelName = topLevelRule.name;
          var duplicateProd = (0, first_1.default)(duplicateProds);
          var index2 = duplicateProd.idx;
          var dslName = (0, gast_2.getProductionDslName)(duplicateProd);
          var extraArgument = getExtraProductionArgument(duplicateProd);
          var hasExplicitIndex = index2 > 0;
          var msg = "->".concat(dslName).concat(hasExplicitIndex ? index2 : "", "<- ").concat(extraArgument ? "with argument: ->".concat(extraArgument, "<-") : "", "\n                  appears more than once (").concat(duplicateProds.length, " times) in the top level rule: ->").concat(topLevelName, "<-.                  \n                  For further details see: https://chevrotain.io/docs/FAQ.html#NUMERICAL_SUFFIXES \n                  ");
          msg = msg.replace(/[ \t]+/g, " ");
          msg = msg.replace(/\s\s+/g, "\n");
          return msg;
        },
        buildNamespaceConflictError: function(rule) {
          var errMsg = "Namespace conflict found in grammar.\n" + "The grammar has both a Terminal(Token) and a Non-Terminal(Rule) named: <".concat(rule.name, ">.\n") + "To resolve this make sure each Terminal and Non-Terminal names are unique\nThis is easy to accomplish by using the convention that Terminal names start with an uppercase letter\nand Non-Terminal names start with a lower case letter.";
          return errMsg;
        },
        buildAlternationPrefixAmbiguityError: function(options) {
          var pathMsg = (0, map_1.default)(options.prefixPath, function(currTok) {
            return (0, tokens_public_1.tokenLabel)(currTok);
          }).join(", ");
          var occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
          var errMsg = "Ambiguous alternatives: <".concat(options.ambiguityIndices.join(" ,"), "> due to common lookahead prefix\n") + "in <OR".concat(occurrence, "> inside <").concat(options.topLevelRule.name, "> Rule,\n") + "<".concat(pathMsg, "> may appears as a prefix path in all these alternatives.\n") + "See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#COMMON_PREFIX\nFor Further details.";
          return errMsg;
        },
        buildAlternationAmbiguityError: function(options) {
          var pathMsg = (0, map_1.default)(options.prefixPath, function(currtok) {
            return (0, tokens_public_1.tokenLabel)(currtok);
          }).join(", ");
          var occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
          var currMessage = "Ambiguous Alternatives Detected: <".concat(options.ambiguityIndices.join(" ,"), "> in <OR").concat(occurrence, ">") + " inside <".concat(options.topLevelRule.name, "> Rule,\n") + "<".concat(pathMsg, "> may appears as a prefix path in all these alternatives.\n");
          currMessage = currMessage + "See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#AMBIGUOUS_ALTERNATIVES\nFor Further details.";
          return currMessage;
        },
        buildEmptyRepetitionError: function(options) {
          var dslName = (0, gast_2.getProductionDslName)(options.repetition);
          if (options.repetition.idx !== 0) {
            dslName += options.repetition.idx;
          }
          var errMsg = "The repetition <".concat(dslName, "> within Rule <").concat(options.topLevelRule.name, "> can never consume any tokens.\n") + "This could lead to an infinite loop.";
          return errMsg;
        },
        // TODO: remove - `errors_public` from nyc.config.js exclude
        //       once this method is fully removed from this file
        buildTokenNameError: function(options) {
          return "deprecated";
        },
        buildEmptyAlternationError: function(options) {
          var errMsg = "Ambiguous empty alternative: <".concat(options.emptyChoiceIdx + 1, ">") + " in <OR".concat(options.alternation.idx, "> inside <").concat(options.topLevelRule.name, "> Rule.\n") + "Only the last alternative may be an empty alternative.";
          return errMsg;
        },
        buildTooManyAlternativesError: function(options) {
          var errMsg = "An Alternation cannot have more than 256 alternatives:\n" + "<OR".concat(options.alternation.idx, "> inside <").concat(options.topLevelRule.name, "> Rule.\n has ").concat(options.alternation.definition.length + 1, " alternatives.");
          return errMsg;
        },
        buildLeftRecursionError: function(options) {
          var ruleName = options.topLevelRule.name;
          var pathNames = (0, map_1.default)(options.leftRecursionPath, function(currRule) {
            return currRule.name;
          });
          var leftRecursivePath = "".concat(ruleName, " --> ").concat(pathNames.concat([ruleName]).join(" --> "));
          var errMsg = "Left Recursion found in grammar.\n" + "rule: <".concat(ruleName, "> can be invoked from itself (directly or indirectly)\n") + "without consuming any Tokens. The grammar path that causes this is: \n ".concat(leftRecursivePath, "\n") + " To fix this refactor your grammar to remove the left recursion.\nsee: https://en.wikipedia.org/wiki/LL_parser#Left_factoring.";
          return errMsg;
        },
        // TODO: remove - `errors_public` from nyc.config.js exclude
        //       once this method is fully removed from this file
        buildInvalidRuleNameError: function(options) {
          return "deprecated";
        },
        buildDuplicateRuleNameError: function(options) {
          var ruleName;
          if (options.topLevelRule instanceof gast_1.Rule) {
            ruleName = options.topLevelRule.name;
          } else {
            ruleName = options.topLevelRule;
          }
          var errMsg = "Duplicate definition, rule: ->".concat(ruleName, "<- is already defined in the grammar: ->").concat(options.grammarName, "<-");
          return errMsg;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/resolver.js
  var require_resolver = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/resolver.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.GastRefResolverVisitor = exports2.resolveGrammar = void 0;
      var parser_1 = require_parser();
      var forEach_1 = __importDefault(require_forEach());
      var values_1 = __importDefault(require_values());
      var gast_1 = require_api2();
      function resolveGrammar(topLevels, errMsgProvider) {
        var refResolver = new GastRefResolverVisitor(topLevels, errMsgProvider);
        refResolver.resolveRefs();
        return refResolver.errors;
      }
      exports2.resolveGrammar = resolveGrammar;
      var GastRefResolverVisitor = (
        /** @class */
        function(_super) {
          __extends(GastRefResolverVisitor2, _super);
          function GastRefResolverVisitor2(nameToTopRule, errMsgProvider) {
            var _this = _super.call(this) || this;
            _this.nameToTopRule = nameToTopRule;
            _this.errMsgProvider = errMsgProvider;
            _this.errors = [];
            return _this;
          }
          GastRefResolverVisitor2.prototype.resolveRefs = function() {
            var _this = this;
            (0, forEach_1.default)((0, values_1.default)(this.nameToTopRule), function(prod) {
              _this.currTopLevel = prod;
              prod.accept(_this);
            });
          };
          GastRefResolverVisitor2.prototype.visitNonTerminal = function(node) {
            var ref = this.nameToTopRule[node.nonTerminalName];
            if (!ref) {
              var msg = this.errMsgProvider.buildRuleNotFoundError(this.currTopLevel, node);
              this.errors.push({
                message: msg,
                type: parser_1.ParserDefinitionErrorType.UNRESOLVED_SUBRULE_REF,
                ruleName: this.currTopLevel.name,
                unresolvedRefName: node.nonTerminalName
              });
            } else {
              node.referencedRule = ref;
            }
          };
          return GastRefResolverVisitor2;
        }(gast_1.GAstVisitor)
      );
      exports2.GastRefResolverVisitor = GastRefResolverVisitor;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayAggregator.js
  var require_arrayAggregator = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_arrayAggregator.js"(exports2, module2) {
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index2 = -1, length2 = array == null ? 0 : array.length;
        while (++index2 < length2) {
          var value = array[index2];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      module2.exports = arrayAggregator;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAggregator.js
  var require_baseAggregator = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_baseAggregator.js"(exports2, module2) {
      var baseEach = require_baseEach();
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee(value), collection2);
        });
        return accumulator;
      }
      module2.exports = baseAggregator;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createAggregator.js
  var require_createAggregator = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createAggregator.js"(exports2, module2) {
      var arrayAggregator = require_arrayAggregator();
      var baseAggregator = require_baseAggregator();
      var baseIteratee = require_baseIteratee();
      var isArray2 = require_isArray();
      function createAggregator(setter, initializer) {
        return function(collection, iteratee) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
        };
      }
      module2.exports = createAggregator;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/groupBy.js
  var require_groupBy = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/groupBy.js"(exports2, module2) {
      var baseAssignValue = require_baseAssignValue();
      var createAggregator = require_createAggregator();
      var objectProto = Object.prototype;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var groupBy = createAggregator(function(result, value, key) {
        if (hasOwnProperty2.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });
      module2.exports = groupBy;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatMap.js
  var require_flatMap = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/flatMap.js"(exports2, module2) {
      var baseFlatten = require_baseFlatten();
      var map = require_map();
      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }
      module2.exports = flatMap;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/dropRight.js
  var require_dropRight = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/dropRight.js"(exports2, module2) {
      var baseSlice = require_baseSlice();
      var toInteger = require_toInteger();
      function dropRight(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === void 0 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      module2.exports = dropRight;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/interpreter.js
  var require_interpreter = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/interpreter.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.nextPossibleTokensAfter = exports2.possiblePathsFrom = exports2.NextTerminalAfterAtLeastOneSepWalker = exports2.NextTerminalAfterAtLeastOneWalker = exports2.NextTerminalAfterManySepWalker = exports2.NextTerminalAfterManyWalker = exports2.AbstractNextTerminalAfterProductionWalker = exports2.NextAfterTokenWalker = exports2.AbstractNextPossibleTokensWalker = void 0;
      var rest_1 = require_rest();
      var first_1 = __importDefault(require_first2());
      var isEmpty_1 = __importDefault(require_isEmpty());
      var dropRight_1 = __importDefault(require_dropRight());
      var drop_1 = __importDefault(require_drop());
      var last_1 = __importDefault(require_last());
      var forEach_1 = __importDefault(require_forEach());
      var clone_1 = __importDefault(require_clone());
      var first_2 = require_first();
      var gast_1 = require_api2();
      var AbstractNextPossibleTokensWalker = (
        /** @class */
        function(_super) {
          __extends(AbstractNextPossibleTokensWalker2, _super);
          function AbstractNextPossibleTokensWalker2(topProd, path3) {
            var _this = _super.call(this) || this;
            _this.topProd = topProd;
            _this.path = path3;
            _this.possibleTokTypes = [];
            _this.nextProductionName = "";
            _this.nextProductionOccurrence = 0;
            _this.found = false;
            _this.isAtEndOfPath = false;
            return _this;
          }
          AbstractNextPossibleTokensWalker2.prototype.startWalking = function() {
            this.found = false;
            if (this.path.ruleStack[0] !== this.topProd.name) {
              throw Error("The path does not start with the walker's top Rule!");
            }
            this.ruleStack = (0, clone_1.default)(this.path.ruleStack).reverse();
            this.occurrenceStack = (0, clone_1.default)(this.path.occurrenceStack).reverse();
            this.ruleStack.pop();
            this.occurrenceStack.pop();
            this.updateExpectedNext();
            this.walk(this.topProd);
            return this.possibleTokTypes;
          };
          AbstractNextPossibleTokensWalker2.prototype.walk = function(prod, prevRest) {
            if (prevRest === void 0) {
              prevRest = [];
            }
            if (!this.found) {
              _super.prototype.walk.call(this, prod, prevRest);
            }
          };
          AbstractNextPossibleTokensWalker2.prototype.walkProdRef = function(refProd, currRest, prevRest) {
            if (refProd.referencedRule.name === this.nextProductionName && refProd.idx === this.nextProductionOccurrence) {
              var fullRest = currRest.concat(prevRest);
              this.updateExpectedNext();
              this.walk(refProd.referencedRule, fullRest);
            }
          };
          AbstractNextPossibleTokensWalker2.prototype.updateExpectedNext = function() {
            if ((0, isEmpty_1.default)(this.ruleStack)) {
              this.nextProductionName = "";
              this.nextProductionOccurrence = 0;
              this.isAtEndOfPath = true;
            } else {
              this.nextProductionName = this.ruleStack.pop();
              this.nextProductionOccurrence = this.occurrenceStack.pop();
            }
          };
          return AbstractNextPossibleTokensWalker2;
        }(rest_1.RestWalker)
      );
      exports2.AbstractNextPossibleTokensWalker = AbstractNextPossibleTokensWalker;
      var NextAfterTokenWalker = (
        /** @class */
        function(_super) {
          __extends(NextAfterTokenWalker2, _super);
          function NextAfterTokenWalker2(topProd, path3) {
            var _this = _super.call(this, topProd, path3) || this;
            _this.path = path3;
            _this.nextTerminalName = "";
            _this.nextTerminalOccurrence = 0;
            _this.nextTerminalName = _this.path.lastTok.name;
            _this.nextTerminalOccurrence = _this.path.lastTokOccurrence;
            return _this;
          }
          NextAfterTokenWalker2.prototype.walkTerminal = function(terminal, currRest, prevRest) {
            if (this.isAtEndOfPath && terminal.terminalType.name === this.nextTerminalName && terminal.idx === this.nextTerminalOccurrence && !this.found) {
              var fullRest = currRest.concat(prevRest);
              var restProd = new gast_1.Alternative({ definition: fullRest });
              this.possibleTokTypes = (0, first_2.first)(restProd);
              this.found = true;
            }
          };
          return NextAfterTokenWalker2;
        }(AbstractNextPossibleTokensWalker)
      );
      exports2.NextAfterTokenWalker = NextAfterTokenWalker;
      var AbstractNextTerminalAfterProductionWalker = (
        /** @class */
        function(_super) {
          __extends(AbstractNextTerminalAfterProductionWalker2, _super);
          function AbstractNextTerminalAfterProductionWalker2(topRule, occurrence) {
            var _this = _super.call(this) || this;
            _this.topRule = topRule;
            _this.occurrence = occurrence;
            _this.result = {
              token: void 0,
              occurrence: void 0,
              isEndOfRule: void 0
            };
            return _this;
          }
          AbstractNextTerminalAfterProductionWalker2.prototype.startWalking = function() {
            this.walk(this.topRule);
            return this.result;
          };
          return AbstractNextTerminalAfterProductionWalker2;
        }(rest_1.RestWalker)
      );
      exports2.AbstractNextTerminalAfterProductionWalker = AbstractNextTerminalAfterProductionWalker;
      var NextTerminalAfterManyWalker = (
        /** @class */
        function(_super) {
          __extends(NextTerminalAfterManyWalker2, _super);
          function NextTerminalAfterManyWalker2() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          NextTerminalAfterManyWalker2.prototype.walkMany = function(manyProd, currRest, prevRest) {
            if (manyProd.idx === this.occurrence) {
              var firstAfterMany = (0, first_1.default)(currRest.concat(prevRest));
              this.result.isEndOfRule = firstAfterMany === void 0;
              if (firstAfterMany instanceof gast_1.Terminal) {
                this.result.token = firstAfterMany.terminalType;
                this.result.occurrence = firstAfterMany.idx;
              }
            } else {
              _super.prototype.walkMany.call(this, manyProd, currRest, prevRest);
            }
          };
          return NextTerminalAfterManyWalker2;
        }(AbstractNextTerminalAfterProductionWalker)
      );
      exports2.NextTerminalAfterManyWalker = NextTerminalAfterManyWalker;
      var NextTerminalAfterManySepWalker = (
        /** @class */
        function(_super) {
          __extends(NextTerminalAfterManySepWalker2, _super);
          function NextTerminalAfterManySepWalker2() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          NextTerminalAfterManySepWalker2.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
            if (manySepProd.idx === this.occurrence) {
              var firstAfterManySep = (0, first_1.default)(currRest.concat(prevRest));
              this.result.isEndOfRule = firstAfterManySep === void 0;
              if (firstAfterManySep instanceof gast_1.Terminal) {
                this.result.token = firstAfterManySep.terminalType;
                this.result.occurrence = firstAfterManySep.idx;
              }
            } else {
              _super.prototype.walkManySep.call(this, manySepProd, currRest, prevRest);
            }
          };
          return NextTerminalAfterManySepWalker2;
        }(AbstractNextTerminalAfterProductionWalker)
      );
      exports2.NextTerminalAfterManySepWalker = NextTerminalAfterManySepWalker;
      var NextTerminalAfterAtLeastOneWalker = (
        /** @class */
        function(_super) {
          __extends(NextTerminalAfterAtLeastOneWalker2, _super);
          function NextTerminalAfterAtLeastOneWalker2() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          NextTerminalAfterAtLeastOneWalker2.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
            if (atLeastOneProd.idx === this.occurrence) {
              var firstAfterAtLeastOne = (0, first_1.default)(currRest.concat(prevRest));
              this.result.isEndOfRule = firstAfterAtLeastOne === void 0;
              if (firstAfterAtLeastOne instanceof gast_1.Terminal) {
                this.result.token = firstAfterAtLeastOne.terminalType;
                this.result.occurrence = firstAfterAtLeastOne.idx;
              }
            } else {
              _super.prototype.walkAtLeastOne.call(this, atLeastOneProd, currRest, prevRest);
            }
          };
          return NextTerminalAfterAtLeastOneWalker2;
        }(AbstractNextTerminalAfterProductionWalker)
      );
      exports2.NextTerminalAfterAtLeastOneWalker = NextTerminalAfterAtLeastOneWalker;
      var NextTerminalAfterAtLeastOneSepWalker = (
        /** @class */
        function(_super) {
          __extends(NextTerminalAfterAtLeastOneSepWalker2, _super);
          function NextTerminalAfterAtLeastOneSepWalker2() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          NextTerminalAfterAtLeastOneSepWalker2.prototype.walkAtLeastOneSep = function(atleastOneSepProd, currRest, prevRest) {
            if (atleastOneSepProd.idx === this.occurrence) {
              var firstAfterfirstAfterAtLeastOneSep = (0, first_1.default)(currRest.concat(prevRest));
              this.result.isEndOfRule = firstAfterfirstAfterAtLeastOneSep === void 0;
              if (firstAfterfirstAfterAtLeastOneSep instanceof gast_1.Terminal) {
                this.result.token = firstAfterfirstAfterAtLeastOneSep.terminalType;
                this.result.occurrence = firstAfterfirstAfterAtLeastOneSep.idx;
              }
            } else {
              _super.prototype.walkAtLeastOneSep.call(this, atleastOneSepProd, currRest, prevRest);
            }
          };
          return NextTerminalAfterAtLeastOneSepWalker2;
        }(AbstractNextTerminalAfterProductionWalker)
      );
      exports2.NextTerminalAfterAtLeastOneSepWalker = NextTerminalAfterAtLeastOneSepWalker;
      function possiblePathsFrom(targetDef, maxLength, currPath) {
        if (currPath === void 0) {
          currPath = [];
        }
        currPath = (0, clone_1.default)(currPath);
        var result = [];
        var i2 = 0;
        function remainingPathWith(nextDef) {
          return nextDef.concat((0, drop_1.default)(targetDef, i2 + 1));
        }
        function getAlternativesForProd(definition) {
          var alternatives = possiblePathsFrom(remainingPathWith(definition), maxLength, currPath);
          return result.concat(alternatives);
        }
        while (currPath.length < maxLength && i2 < targetDef.length) {
          var prod = targetDef[i2];
          if (prod instanceof gast_1.Alternative) {
            return getAlternativesForProd(prod.definition);
          } else if (prod instanceof gast_1.NonTerminal) {
            return getAlternativesForProd(prod.definition);
          } else if (prod instanceof gast_1.Option) {
            result = getAlternativesForProd(prod.definition);
          } else if (prod instanceof gast_1.RepetitionMandatory) {
            var newDef = prod.definition.concat([
              new gast_1.Repetition({
                definition: prod.definition
              })
            ]);
            return getAlternativesForProd(newDef);
          } else if (prod instanceof gast_1.RepetitionMandatoryWithSeparator) {
            var newDef = [
              new gast_1.Alternative({ definition: prod.definition }),
              new gast_1.Repetition({
                definition: [new gast_1.Terminal({ terminalType: prod.separator })].concat(prod.definition)
              })
            ];
            return getAlternativesForProd(newDef);
          } else if (prod instanceof gast_1.RepetitionWithSeparator) {
            var newDef = prod.definition.concat([
              new gast_1.Repetition({
                definition: [new gast_1.Terminal({ terminalType: prod.separator })].concat(prod.definition)
              })
            ]);
            result = getAlternativesForProd(newDef);
          } else if (prod instanceof gast_1.Repetition) {
            var newDef = prod.definition.concat([
              new gast_1.Repetition({
                definition: prod.definition
              })
            ]);
            result = getAlternativesForProd(newDef);
          } else if (prod instanceof gast_1.Alternation) {
            (0, forEach_1.default)(prod.definition, function(currAlt) {
              if ((0, isEmpty_1.default)(currAlt.definition) === false) {
                result = getAlternativesForProd(currAlt.definition);
              }
            });
            return result;
          } else if (prod instanceof gast_1.Terminal) {
            currPath.push(prod.terminalType);
          } else {
            throw Error("non exhaustive match");
          }
          i2++;
        }
        result.push({
          partialPath: currPath,
          suffixDef: (0, drop_1.default)(targetDef, i2)
        });
        return result;
      }
      exports2.possiblePathsFrom = possiblePathsFrom;
      function nextPossibleTokensAfter(initialDef, tokenVector, tokMatcher, maxLookAhead) {
        var EXIT_NON_TERMINAL = "EXIT_NONE_TERMINAL";
        var EXIT_NON_TERMINAL_ARR = [EXIT_NON_TERMINAL];
        var EXIT_ALTERNATIVE = "EXIT_ALTERNATIVE";
        var foundCompletePath = false;
        var tokenVectorLength = tokenVector.length;
        var minimalAlternativesIndex = tokenVectorLength - maxLookAhead - 1;
        var result = [];
        var possiblePaths = [];
        possiblePaths.push({
          idx: -1,
          def: initialDef,
          ruleStack: [],
          occurrenceStack: []
        });
        while (!(0, isEmpty_1.default)(possiblePaths)) {
          var currPath = possiblePaths.pop();
          if (currPath === EXIT_ALTERNATIVE) {
            if (foundCompletePath && (0, last_1.default)(possiblePaths).idx <= minimalAlternativesIndex) {
              possiblePaths.pop();
            }
            continue;
          }
          var currDef = currPath.def;
          var currIdx = currPath.idx;
          var currRuleStack = currPath.ruleStack;
          var currOccurrenceStack = currPath.occurrenceStack;
          if ((0, isEmpty_1.default)(currDef)) {
            continue;
          }
          var prod = currDef[0];
          if (prod === EXIT_NON_TERMINAL) {
            var nextPath = {
              idx: currIdx,
              def: (0, drop_1.default)(currDef),
              ruleStack: (0, dropRight_1.default)(currRuleStack),
              occurrenceStack: (0, dropRight_1.default)(currOccurrenceStack)
            };
            possiblePaths.push(nextPath);
          } else if (prod instanceof gast_1.Terminal) {
            if (currIdx < tokenVectorLength - 1) {
              var nextIdx = currIdx + 1;
              var actualToken = tokenVector[nextIdx];
              if (tokMatcher(actualToken, prod.terminalType)) {
                var nextPath = {
                  idx: nextIdx,
                  def: (0, drop_1.default)(currDef),
                  ruleStack: currRuleStack,
                  occurrenceStack: currOccurrenceStack
                };
                possiblePaths.push(nextPath);
              }
            } else if (currIdx === tokenVectorLength - 1) {
              result.push({
                nextTokenType: prod.terminalType,
                nextTokenOccurrence: prod.idx,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
              });
              foundCompletePath = true;
            } else {
              throw Error("non exhaustive match");
            }
          } else if (prod instanceof gast_1.NonTerminal) {
            var newRuleStack = (0, clone_1.default)(currRuleStack);
            newRuleStack.push(prod.nonTerminalName);
            var newOccurrenceStack = (0, clone_1.default)(currOccurrenceStack);
            newOccurrenceStack.push(prod.idx);
            var nextPath = {
              idx: currIdx,
              def: prod.definition.concat(EXIT_NON_TERMINAL_ARR, (0, drop_1.default)(currDef)),
              ruleStack: newRuleStack,
              occurrenceStack: newOccurrenceStack
            };
            possiblePaths.push(nextPath);
          } else if (prod instanceof gast_1.Option) {
            var nextPathWithout = {
              idx: currIdx,
              def: (0, drop_1.default)(currDef),
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            possiblePaths.push(EXIT_ALTERNATIVE);
            var nextPathWith = {
              idx: currIdx,
              def: prod.definition.concat((0, drop_1.default)(currDef)),
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
          } else if (prod instanceof gast_1.RepetitionMandatory) {
            var secondIteration = new gast_1.Repetition({
              definition: prod.definition,
              idx: prod.idx
            });
            var nextDef = prod.definition.concat([secondIteration], (0, drop_1.default)(currDef));
            var nextPath = {
              idx: currIdx,
              def: nextDef,
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPath);
          } else if (prod instanceof gast_1.RepetitionMandatoryWithSeparator) {
            var separatorGast = new gast_1.Terminal({
              terminalType: prod.separator
            });
            var secondIteration = new gast_1.Repetition({
              definition: [separatorGast].concat(prod.definition),
              idx: prod.idx
            });
            var nextDef = prod.definition.concat([secondIteration], (0, drop_1.default)(currDef));
            var nextPath = {
              idx: currIdx,
              def: nextDef,
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPath);
          } else if (prod instanceof gast_1.RepetitionWithSeparator) {
            var nextPathWithout = {
              idx: currIdx,
              def: (0, drop_1.default)(currDef),
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            possiblePaths.push(EXIT_ALTERNATIVE);
            var separatorGast = new gast_1.Terminal({
              terminalType: prod.separator
            });
            var nthRepetition = new gast_1.Repetition({
              definition: [separatorGast].concat(prod.definition),
              idx: prod.idx
            });
            var nextDef = prod.definition.concat([nthRepetition], (0, drop_1.default)(currDef));
            var nextPathWith = {
              idx: currIdx,
              def: nextDef,
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
          } else if (prod instanceof gast_1.Repetition) {
            var nextPathWithout = {
              idx: currIdx,
              def: (0, drop_1.default)(currDef),
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            possiblePaths.push(EXIT_ALTERNATIVE);
            var nthRepetition = new gast_1.Repetition({
              definition: prod.definition,
              idx: prod.idx
            });
            var nextDef = prod.definition.concat([nthRepetition], (0, drop_1.default)(currDef));
            var nextPathWith = {
              idx: currIdx,
              def: nextDef,
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
          } else if (prod instanceof gast_1.Alternation) {
            for (var i2 = prod.definition.length - 1; i2 >= 0; i2--) {
              var currAlt = prod.definition[i2];
              var currAltPath = {
                idx: currIdx,
                def: currAlt.definition.concat((0, drop_1.default)(currDef)),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
              };
              possiblePaths.push(currAltPath);
              possiblePaths.push(EXIT_ALTERNATIVE);
            }
          } else if (prod instanceof gast_1.Alternative) {
            possiblePaths.push({
              idx: currIdx,
              def: prod.definition.concat((0, drop_1.default)(currDef)),
              ruleStack: currRuleStack,
              occurrenceStack: currOccurrenceStack
            });
          } else if (prod instanceof gast_1.Rule) {
            possiblePaths.push(expandTopLevelRule(prod, currIdx, currRuleStack, currOccurrenceStack));
          } else {
            throw Error("non exhaustive match");
          }
        }
        return result;
      }
      exports2.nextPossibleTokensAfter = nextPossibleTokensAfter;
      function expandTopLevelRule(topRule, currIdx, currRuleStack, currOccurrenceStack) {
        var newRuleStack = (0, clone_1.default)(currRuleStack);
        newRuleStack.push(topRule.name);
        var newCurrOccurrenceStack = (0, clone_1.default)(currOccurrenceStack);
        newCurrOccurrenceStack.push(1);
        return {
          idx: currIdx,
          def: topRule.definition,
          ruleStack: newRuleStack,
          occurrenceStack: newCurrOccurrenceStack
        };
      }
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/lookahead.js
  var require_lookahead = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/lookahead.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.areTokenCategoriesNotUsed = exports2.isStrictPrefixOfPath = exports2.containsPath = exports2.getLookaheadPathsForOptionalProd = exports2.getLookaheadPathsForOr = exports2.lookAheadSequenceFromAlternatives = exports2.buildSingleAlternativeLookaheadFunction = exports2.buildAlternativesLookAheadFunc = exports2.buildLookaheadFuncForOptionalProd = exports2.buildLookaheadFuncForOr = exports2.getLookaheadPaths = exports2.getProdType = exports2.PROD_TYPE = void 0;
      var isEmpty_1 = __importDefault(require_isEmpty());
      var flatten_1 = __importDefault(require_flatten());
      var every_1 = __importDefault(require_every());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var has_1 = __importDefault(require_has());
      var reduce_1 = __importDefault(require_reduce());
      var interpreter_1 = require_interpreter();
      var rest_1 = require_rest();
      var tokens_1 = require_tokens();
      var gast_1 = require_api2();
      var gast_2 = require_api2();
      var PROD_TYPE;
      (function(PROD_TYPE2) {
        PROD_TYPE2[PROD_TYPE2["OPTION"] = 0] = "OPTION";
        PROD_TYPE2[PROD_TYPE2["REPETITION"] = 1] = "REPETITION";
        PROD_TYPE2[PROD_TYPE2["REPETITION_MANDATORY"] = 2] = "REPETITION_MANDATORY";
        PROD_TYPE2[PROD_TYPE2["REPETITION_MANDATORY_WITH_SEPARATOR"] = 3] = "REPETITION_MANDATORY_WITH_SEPARATOR";
        PROD_TYPE2[PROD_TYPE2["REPETITION_WITH_SEPARATOR"] = 4] = "REPETITION_WITH_SEPARATOR";
        PROD_TYPE2[PROD_TYPE2["ALTERNATION"] = 5] = "ALTERNATION";
      })(PROD_TYPE = exports2.PROD_TYPE || (exports2.PROD_TYPE = {}));
      function getProdType(prod) {
        if (prod instanceof gast_1.Option || prod === "Option") {
          return PROD_TYPE.OPTION;
        } else if (prod instanceof gast_1.Repetition || prod === "Repetition") {
          return PROD_TYPE.REPETITION;
        } else if (prod instanceof gast_1.RepetitionMandatory || prod === "RepetitionMandatory") {
          return PROD_TYPE.REPETITION_MANDATORY;
        } else if (prod instanceof gast_1.RepetitionMandatoryWithSeparator || prod === "RepetitionMandatoryWithSeparator") {
          return PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR;
        } else if (prod instanceof gast_1.RepetitionWithSeparator || prod === "RepetitionWithSeparator") {
          return PROD_TYPE.REPETITION_WITH_SEPARATOR;
        } else if (prod instanceof gast_1.Alternation || prod === "Alternation") {
          return PROD_TYPE.ALTERNATION;
        } else {
          throw Error("non exhaustive match");
        }
      }
      exports2.getProdType = getProdType;
      function getLookaheadPaths2(options) {
        var occurrence = options.occurrence, rule = options.rule, prodType = options.prodType, maxLookahead = options.maxLookahead;
        var type = getProdType(prodType);
        if (type === PROD_TYPE.ALTERNATION) {
          return getLookaheadPathsForOr(occurrence, rule, maxLookahead);
        } else {
          return getLookaheadPathsForOptionalProd(occurrence, rule, type, maxLookahead);
        }
      }
      exports2.getLookaheadPaths = getLookaheadPaths2;
      function buildLookaheadFuncForOr(occurrence, ruleGrammar, maxLookahead, hasPredicates, dynamicTokensEnabled, laFuncBuilder) {
        var lookAheadPaths = getLookaheadPathsForOr(occurrence, ruleGrammar, maxLookahead);
        var tokenMatcher2 = areTokenCategoriesNotUsed(lookAheadPaths) ? tokens_1.tokenStructuredMatcherNoCategories : tokens_1.tokenStructuredMatcher;
        return laFuncBuilder(lookAheadPaths, hasPredicates, tokenMatcher2, dynamicTokensEnabled);
      }
      exports2.buildLookaheadFuncForOr = buildLookaheadFuncForOr;
      function buildLookaheadFuncForOptionalProd(occurrence, ruleGrammar, k, dynamicTokensEnabled, prodType, lookaheadBuilder) {
        var lookAheadPaths = getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k);
        var tokenMatcher2 = areTokenCategoriesNotUsed(lookAheadPaths) ? tokens_1.tokenStructuredMatcherNoCategories : tokens_1.tokenStructuredMatcher;
        return lookaheadBuilder(lookAheadPaths[0], tokenMatcher2, dynamicTokensEnabled);
      }
      exports2.buildLookaheadFuncForOptionalProd = buildLookaheadFuncForOptionalProd;
      function buildAlternativesLookAheadFunc(alts, hasPredicates, tokenMatcher2, dynamicTokensEnabled) {
        var numOfAlts = alts.length;
        var areAllOneTokenLookahead = (0, every_1.default)(alts, function(currAlt) {
          return (0, every_1.default)(currAlt, function(currPath) {
            return currPath.length === 1;
          });
        });
        if (hasPredicates) {
          return function(orAlts) {
            var predicates2 = (0, map_1.default)(orAlts, function(currAlt2) {
              return currAlt2.GATE;
            });
            for (var t2 = 0; t2 < numOfAlts; t2++) {
              var currAlt = alts[t2];
              var currNumOfPaths = currAlt.length;
              var currPredicate = predicates2[t2];
              if (currPredicate !== void 0 && currPredicate.call(this) === false) {
                continue;
              }
              nextPath: for (var j = 0; j < currNumOfPaths; j++) {
                var currPath = currAlt[j];
                var currPathLength = currPath.length;
                for (var i2 = 0; i2 < currPathLength; i2++) {
                  var nextToken = this.LA(i2 + 1);
                  if (tokenMatcher2(nextToken, currPath[i2]) === false) {
                    continue nextPath;
                  }
                }
                return t2;
              }
            }
            return void 0;
          };
        } else if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
          var singleTokenAlts = (0, map_1.default)(alts, function(currAlt) {
            return (0, flatten_1.default)(currAlt);
          });
          var choiceToAlt_1 = (0, reduce_1.default)(singleTokenAlts, function(result, currAlt, idx) {
            (0, forEach_1.default)(currAlt, function(currTokType) {
              if (!(0, has_1.default)(result, currTokType.tokenTypeIdx)) {
                result[currTokType.tokenTypeIdx] = idx;
              }
              (0, forEach_1.default)(currTokType.categoryMatches, function(currExtendingType) {
                if (!(0, has_1.default)(result, currExtendingType)) {
                  result[currExtendingType] = idx;
                }
              });
            });
            return result;
          }, {});
          return function() {
            var nextToken = this.LA(1);
            return choiceToAlt_1[nextToken.tokenTypeIdx];
          };
        } else {
          return function() {
            for (var t2 = 0; t2 < numOfAlts; t2++) {
              var currAlt = alts[t2];
              var currNumOfPaths = currAlt.length;
              nextPath: for (var j = 0; j < currNumOfPaths; j++) {
                var currPath = currAlt[j];
                var currPathLength = currPath.length;
                for (var i2 = 0; i2 < currPathLength; i2++) {
                  var nextToken = this.LA(i2 + 1);
                  if (tokenMatcher2(nextToken, currPath[i2]) === false) {
                    continue nextPath;
                  }
                }
                return t2;
              }
            }
            return void 0;
          };
        }
      }
      exports2.buildAlternativesLookAheadFunc = buildAlternativesLookAheadFunc;
      function buildSingleAlternativeLookaheadFunction(alt, tokenMatcher2, dynamicTokensEnabled) {
        var areAllOneTokenLookahead = (0, every_1.default)(alt, function(currPath) {
          return currPath.length === 1;
        });
        var numOfPaths = alt.length;
        if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
          var singleTokensTypes = (0, flatten_1.default)(alt);
          if (singleTokensTypes.length === 1 && (0, isEmpty_1.default)(singleTokensTypes[0].categoryMatches)) {
            var expectedTokenType = singleTokensTypes[0];
            var expectedTokenUniqueKey_1 = expectedTokenType.tokenTypeIdx;
            return function() {
              return this.LA(1).tokenTypeIdx === expectedTokenUniqueKey_1;
            };
          } else {
            var choiceToAlt_2 = (0, reduce_1.default)(singleTokensTypes, function(result, currTokType, idx) {
              result[currTokType.tokenTypeIdx] = true;
              (0, forEach_1.default)(currTokType.categoryMatches, function(currExtendingType) {
                result[currExtendingType] = true;
              });
              return result;
            }, []);
            return function() {
              var nextToken = this.LA(1);
              return choiceToAlt_2[nextToken.tokenTypeIdx] === true;
            };
          }
        } else {
          return function() {
            nextPath: for (var j = 0; j < numOfPaths; j++) {
              var currPath = alt[j];
              var currPathLength = currPath.length;
              for (var i2 = 0; i2 < currPathLength; i2++) {
                var nextToken = this.LA(i2 + 1);
                if (tokenMatcher2(nextToken, currPath[i2]) === false) {
                  continue nextPath;
                }
              }
              return true;
            }
            return false;
          };
        }
      }
      exports2.buildSingleAlternativeLookaheadFunction = buildSingleAlternativeLookaheadFunction;
      var RestDefinitionFinderWalker = (
        /** @class */
        function(_super) {
          __extends(RestDefinitionFinderWalker2, _super);
          function RestDefinitionFinderWalker2(topProd, targetOccurrence, targetProdType) {
            var _this = _super.call(this) || this;
            _this.topProd = topProd;
            _this.targetOccurrence = targetOccurrence;
            _this.targetProdType = targetProdType;
            return _this;
          }
          RestDefinitionFinderWalker2.prototype.startWalking = function() {
            this.walk(this.topProd);
            return this.restDef;
          };
          RestDefinitionFinderWalker2.prototype.checkIsTarget = function(node, expectedProdType, currRest, prevRest) {
            if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdType) {
              this.restDef = currRest.concat(prevRest);
              return true;
            }
            return false;
          };
          RestDefinitionFinderWalker2.prototype.walkOption = function(optionProd, currRest, prevRest) {
            if (!this.checkIsTarget(optionProd, PROD_TYPE.OPTION, currRest, prevRest)) {
              _super.prototype.walkOption.call(this, optionProd, currRest, prevRest);
            }
          };
          RestDefinitionFinderWalker2.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
            if (!this.checkIsTarget(atLeastOneProd, PROD_TYPE.REPETITION_MANDATORY, currRest, prevRest)) {
              _super.prototype.walkOption.call(this, atLeastOneProd, currRest, prevRest);
            }
          };
          RestDefinitionFinderWalker2.prototype.walkAtLeastOneSep = function(atLeastOneSepProd, currRest, prevRest) {
            if (!this.checkIsTarget(atLeastOneSepProd, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, currRest, prevRest)) {
              _super.prototype.walkOption.call(this, atLeastOneSepProd, currRest, prevRest);
            }
          };
          RestDefinitionFinderWalker2.prototype.walkMany = function(manyProd, currRest, prevRest) {
            if (!this.checkIsTarget(manyProd, PROD_TYPE.REPETITION, currRest, prevRest)) {
              _super.prototype.walkOption.call(this, manyProd, currRest, prevRest);
            }
          };
          RestDefinitionFinderWalker2.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
            if (!this.checkIsTarget(manySepProd, PROD_TYPE.REPETITION_WITH_SEPARATOR, currRest, prevRest)) {
              _super.prototype.walkOption.call(this, manySepProd, currRest, prevRest);
            }
          };
          return RestDefinitionFinderWalker2;
        }(rest_1.RestWalker)
      );
      var InsideDefinitionFinderVisitor = (
        /** @class */
        function(_super) {
          __extends(InsideDefinitionFinderVisitor2, _super);
          function InsideDefinitionFinderVisitor2(targetOccurrence, targetProdType, targetRef) {
            var _this = _super.call(this) || this;
            _this.targetOccurrence = targetOccurrence;
            _this.targetProdType = targetProdType;
            _this.targetRef = targetRef;
            _this.result = [];
            return _this;
          }
          InsideDefinitionFinderVisitor2.prototype.checkIsTarget = function(node, expectedProdName) {
            if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdName && (this.targetRef === void 0 || node === this.targetRef)) {
              this.result = node.definition;
            }
          };
          InsideDefinitionFinderVisitor2.prototype.visitOption = function(node) {
            this.checkIsTarget(node, PROD_TYPE.OPTION);
          };
          InsideDefinitionFinderVisitor2.prototype.visitRepetition = function(node) {
            this.checkIsTarget(node, PROD_TYPE.REPETITION);
          };
          InsideDefinitionFinderVisitor2.prototype.visitRepetitionMandatory = function(node) {
            this.checkIsTarget(node, PROD_TYPE.REPETITION_MANDATORY);
          };
          InsideDefinitionFinderVisitor2.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
            this.checkIsTarget(node, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR);
          };
          InsideDefinitionFinderVisitor2.prototype.visitRepetitionWithSeparator = function(node) {
            this.checkIsTarget(node, PROD_TYPE.REPETITION_WITH_SEPARATOR);
          };
          InsideDefinitionFinderVisitor2.prototype.visitAlternation = function(node) {
            this.checkIsTarget(node, PROD_TYPE.ALTERNATION);
          };
          return InsideDefinitionFinderVisitor2;
        }(gast_2.GAstVisitor)
      );
      function initializeArrayOfArrays(size) {
        var result = new Array(size);
        for (var i2 = 0; i2 < size; i2++) {
          result[i2] = [];
        }
        return result;
      }
      function pathToHashKeys(path3) {
        var keys = [""];
        for (var i2 = 0; i2 < path3.length; i2++) {
          var tokType = path3[i2];
          var longerKeys = [];
          for (var j = 0; j < keys.length; j++) {
            var currShorterKey = keys[j];
            longerKeys.push(currShorterKey + "_" + tokType.tokenTypeIdx);
            for (var t2 = 0; t2 < tokType.categoryMatches.length; t2++) {
              var categoriesKeySuffix = "_" + tokType.categoryMatches[t2];
              longerKeys.push(currShorterKey + categoriesKeySuffix);
            }
          }
          keys = longerKeys;
        }
        return keys;
      }
      function isUniquePrefixHash(altKnownPathsKeys, searchPathKeys, idx) {
        for (var currAltIdx = 0; currAltIdx < altKnownPathsKeys.length; currAltIdx++) {
          if (currAltIdx === idx) {
            continue;
          }
          var otherAltKnownPathsKeys = altKnownPathsKeys[currAltIdx];
          for (var searchIdx = 0; searchIdx < searchPathKeys.length; searchIdx++) {
            var searchKey = searchPathKeys[searchIdx];
            if (otherAltKnownPathsKeys[searchKey] === true) {
              return false;
            }
          }
        }
        return true;
      }
      function lookAheadSequenceFromAlternatives(altsDefs, k) {
        var partialAlts = (0, map_1.default)(altsDefs, function(currAlt) {
          return (0, interpreter_1.possiblePathsFrom)([currAlt], 1);
        });
        var finalResult = initializeArrayOfArrays(partialAlts.length);
        var altsHashes = (0, map_1.default)(partialAlts, function(currAltPaths) {
          var dict = {};
          (0, forEach_1.default)(currAltPaths, function(item) {
            var keys = pathToHashKeys(item.partialPath);
            (0, forEach_1.default)(keys, function(currKey) {
              dict[currKey] = true;
            });
          });
          return dict;
        });
        var newData = partialAlts;
        for (var pathLength = 1; pathLength <= k; pathLength++) {
          var currDataset = newData;
          newData = initializeArrayOfArrays(currDataset.length);
          var _loop_1 = function(altIdx2) {
            var currAltPathsAndSuffixes = currDataset[altIdx2];
            for (var currPathIdx = 0; currPathIdx < currAltPathsAndSuffixes.length; currPathIdx++) {
              var currPathPrefix = currAltPathsAndSuffixes[currPathIdx].partialPath;
              var suffixDef = currAltPathsAndSuffixes[currPathIdx].suffixDef;
              var prefixKeys = pathToHashKeys(currPathPrefix);
              var isUnique = isUniquePrefixHash(altsHashes, prefixKeys, altIdx2);
              if (isUnique || (0, isEmpty_1.default)(suffixDef) || currPathPrefix.length === k) {
                var currAltResult = finalResult[altIdx2];
                if (containsPath(currAltResult, currPathPrefix) === false) {
                  currAltResult.push(currPathPrefix);
                  for (var j = 0; j < prefixKeys.length; j++) {
                    var currKey = prefixKeys[j];
                    altsHashes[altIdx2][currKey] = true;
                  }
                }
              } else {
                var newPartialPathsAndSuffixes = (0, interpreter_1.possiblePathsFrom)(suffixDef, pathLength + 1, currPathPrefix);
                newData[altIdx2] = newData[altIdx2].concat(newPartialPathsAndSuffixes);
                (0, forEach_1.default)(newPartialPathsAndSuffixes, function(item) {
                  var prefixKeys2 = pathToHashKeys(item.partialPath);
                  (0, forEach_1.default)(prefixKeys2, function(key) {
                    altsHashes[altIdx2][key] = true;
                  });
                });
              }
            }
          };
          for (var altIdx = 0; altIdx < currDataset.length; altIdx++) {
            _loop_1(altIdx);
          }
        }
        return finalResult;
      }
      exports2.lookAheadSequenceFromAlternatives = lookAheadSequenceFromAlternatives;
      function getLookaheadPathsForOr(occurrence, ruleGrammar, k, orProd) {
        var visitor = new InsideDefinitionFinderVisitor(occurrence, PROD_TYPE.ALTERNATION, orProd);
        ruleGrammar.accept(visitor);
        return lookAheadSequenceFromAlternatives(visitor.result, k);
      }
      exports2.getLookaheadPathsForOr = getLookaheadPathsForOr;
      function getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k) {
        var insideDefVisitor = new InsideDefinitionFinderVisitor(occurrence, prodType);
        ruleGrammar.accept(insideDefVisitor);
        var insideDef = insideDefVisitor.result;
        var afterDefWalker = new RestDefinitionFinderWalker(ruleGrammar, occurrence, prodType);
        var afterDef = afterDefWalker.startWalking();
        var insideFlat = new gast_1.Alternative({ definition: insideDef });
        var afterFlat = new gast_1.Alternative({ definition: afterDef });
        return lookAheadSequenceFromAlternatives([insideFlat, afterFlat], k);
      }
      exports2.getLookaheadPathsForOptionalProd = getLookaheadPathsForOptionalProd;
      function containsPath(alternative, searchPath) {
        compareOtherPath: for (var i2 = 0; i2 < alternative.length; i2++) {
          var otherPath = alternative[i2];
          if (otherPath.length !== searchPath.length) {
            continue;
          }
          for (var j = 0; j < otherPath.length; j++) {
            var searchTok = searchPath[j];
            var otherTok = otherPath[j];
            var matchingTokens = searchTok === otherTok || otherTok.categoryMatchesMap[searchTok.tokenTypeIdx] !== void 0;
            if (matchingTokens === false) {
              continue compareOtherPath;
            }
          }
          return true;
        }
        return false;
      }
      exports2.containsPath = containsPath;
      function isStrictPrefixOfPath(prefix, other) {
        return prefix.length < other.length && (0, every_1.default)(prefix, function(tokType, idx) {
          var otherTokType = other[idx];
          return tokType === otherTokType || otherTokType.categoryMatchesMap[tokType.tokenTypeIdx];
        });
      }
      exports2.isStrictPrefixOfPath = isStrictPrefixOfPath;
      function areTokenCategoriesNotUsed(lookAheadPaths) {
        return (0, every_1.default)(lookAheadPaths, function(singleAltPaths) {
          return (0, every_1.default)(singleAltPaths, function(singlePath) {
            return (0, every_1.default)(singlePath, function(token) {
              return (0, isEmpty_1.default)(token.categoryMatches);
            });
          });
        });
      }
      exports2.areTokenCategoriesNotUsed = areTokenCategoriesNotUsed;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/checks.js
  var require_checks = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/checks.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __assign = exports2 && exports2.__assign || function() {
        __assign = Object.assign || function(t2) {
          for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
            s2 = arguments[i2];
            for (var p12 in s2) if (Object.prototype.hasOwnProperty.call(s2, p12))
              t2[p12] = s2[p12];
          }
          return t2;
        };
        return __assign.apply(this, arguments);
      };
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.checkPrefixAlternativesAmbiguities = exports2.validateSomeNonEmptyLookaheadPath = exports2.validateTooManyAlts = exports2.RepetitionCollector = exports2.validateAmbiguousAlternationAlternatives = exports2.validateEmptyOrAlternative = exports2.getFirstNoneTerminal = exports2.validateNoLeftRecursion = exports2.validateRuleIsOverridden = exports2.validateRuleDoesNotAlreadyExist = exports2.OccurrenceValidationCollector = exports2.identifyProductionForDuplicates = exports2.validateGrammar = exports2.validateLookahead = void 0;
      var first_1 = __importDefault(require_first2());
      var isEmpty_1 = __importDefault(require_isEmpty());
      var drop_1 = __importDefault(require_drop());
      var flatten_1 = __importDefault(require_flatten());
      var filter_1 = __importDefault(require_filter());
      var reject_1 = __importDefault(require_reject());
      var difference_1 = __importDefault(require_difference());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var groupBy_1 = __importDefault(require_groupBy());
      var reduce_1 = __importDefault(require_reduce());
      var pickBy_1 = __importDefault(require_pickBy());
      var values_1 = __importDefault(require_values());
      var includes_1 = __importDefault(require_includes());
      var flatMap_1 = __importDefault(require_flatMap());
      var clone_1 = __importDefault(require_clone());
      var parser_1 = require_parser();
      var gast_1 = require_api2();
      var lookahead_1 = require_lookahead();
      var interpreter_1 = require_interpreter();
      var gast_2 = require_api2();
      var gast_3 = require_api2();
      var dropRight_1 = __importDefault(require_dropRight());
      var compact_1 = __importDefault(require_compact());
      var tokens_1 = require_tokens();
      function validateLookahead(options) {
        var lookaheadValidationErrorMessages = options.lookaheadStrategy.validate({
          rules: options.rules,
          tokenTypes: options.tokenTypes,
          grammarName: options.grammarName
        });
        return (0, map_1.default)(lookaheadValidationErrorMessages, function(errorMessage) {
          return __assign({ type: parser_1.ParserDefinitionErrorType.CUSTOM_LOOKAHEAD_VALIDATION }, errorMessage);
        });
      }
      exports2.validateLookahead = validateLookahead;
      function validateGrammar(topLevels, tokenTypes, errMsgProvider, grammarName) {
        var duplicateErrors = (0, flatMap_1.default)(topLevels, function(currTopLevel) {
          return validateDuplicateProductions(currTopLevel, errMsgProvider);
        });
        var termsNamespaceConflictErrors = checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider);
        var tooManyAltsErrors = (0, flatMap_1.default)(topLevels, function(curRule) {
          return validateTooManyAlts(curRule, errMsgProvider);
        });
        var duplicateRulesError = (0, flatMap_1.default)(topLevels, function(curRule) {
          return validateRuleDoesNotAlreadyExist(curRule, topLevels, grammarName, errMsgProvider);
        });
        return duplicateErrors.concat(termsNamespaceConflictErrors, tooManyAltsErrors, duplicateRulesError);
      }
      exports2.validateGrammar = validateGrammar;
      function validateDuplicateProductions(topLevelRule, errMsgProvider) {
        var collectorVisitor = new OccurrenceValidationCollector();
        topLevelRule.accept(collectorVisitor);
        var allRuleProductions = collectorVisitor.allProductions;
        var productionGroups = (0, groupBy_1.default)(allRuleProductions, identifyProductionForDuplicates);
        var duplicates = (0, pickBy_1.default)(productionGroups, function(currGroup) {
          return currGroup.length > 1;
        });
        var errors = (0, map_1.default)((0, values_1.default)(duplicates), function(currDuplicates) {
          var firstProd = (0, first_1.default)(currDuplicates);
          var msg = errMsgProvider.buildDuplicateFoundError(topLevelRule, currDuplicates);
          var dslName = (0, gast_1.getProductionDslName)(firstProd);
          var defError = {
            message: msg,
            type: parser_1.ParserDefinitionErrorType.DUPLICATE_PRODUCTIONS,
            ruleName: topLevelRule.name,
            dslName,
            occurrence: firstProd.idx
          };
          var param = getExtraProductionArgument(firstProd);
          if (param) {
            defError.parameter = param;
          }
          return defError;
        });
        return errors;
      }
      function identifyProductionForDuplicates(prod) {
        return "".concat((0, gast_1.getProductionDslName)(prod), "_#_").concat(prod.idx, "_#_").concat(getExtraProductionArgument(prod));
      }
      exports2.identifyProductionForDuplicates = identifyProductionForDuplicates;
      function getExtraProductionArgument(prod) {
        if (prod instanceof gast_2.Terminal) {
          return prod.terminalType.name;
        } else if (prod instanceof gast_2.NonTerminal) {
          return prod.nonTerminalName;
        } else {
          return "";
        }
      }
      var OccurrenceValidationCollector = (
        /** @class */
        function(_super) {
          __extends(OccurrenceValidationCollector2, _super);
          function OccurrenceValidationCollector2() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.allProductions = [];
            return _this;
          }
          OccurrenceValidationCollector2.prototype.visitNonTerminal = function(subrule) {
            this.allProductions.push(subrule);
          };
          OccurrenceValidationCollector2.prototype.visitOption = function(option) {
            this.allProductions.push(option);
          };
          OccurrenceValidationCollector2.prototype.visitRepetitionWithSeparator = function(manySep) {
            this.allProductions.push(manySep);
          };
          OccurrenceValidationCollector2.prototype.visitRepetitionMandatory = function(atLeastOne) {
            this.allProductions.push(atLeastOne);
          };
          OccurrenceValidationCollector2.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
            this.allProductions.push(atLeastOneSep);
          };
          OccurrenceValidationCollector2.prototype.visitRepetition = function(many) {
            this.allProductions.push(many);
          };
          OccurrenceValidationCollector2.prototype.visitAlternation = function(or) {
            this.allProductions.push(or);
          };
          OccurrenceValidationCollector2.prototype.visitTerminal = function(terminal) {
            this.allProductions.push(terminal);
          };
          return OccurrenceValidationCollector2;
        }(gast_3.GAstVisitor)
      );
      exports2.OccurrenceValidationCollector = OccurrenceValidationCollector;
      function validateRuleDoesNotAlreadyExist(rule, allRules, className, errMsgProvider) {
        var errors = [];
        var occurrences = (0, reduce_1.default)(allRules, function(result, curRule) {
          if (curRule.name === rule.name) {
            return result + 1;
          }
          return result;
        }, 0);
        if (occurrences > 1) {
          var errMsg = errMsgProvider.buildDuplicateRuleNameError({
            topLevelRule: rule,
            grammarName: className
          });
          errors.push({
            message: errMsg,
            type: parser_1.ParserDefinitionErrorType.DUPLICATE_RULE_NAME,
            ruleName: rule.name
          });
        }
        return errors;
      }
      exports2.validateRuleDoesNotAlreadyExist = validateRuleDoesNotAlreadyExist;
      function validateRuleIsOverridden(ruleName, definedRulesNames, className) {
        var errors = [];
        var errMsg;
        if (!(0, includes_1.default)(definedRulesNames, ruleName)) {
          errMsg = "Invalid rule override, rule: ->".concat(ruleName, "<- cannot be overridden in the grammar: ->").concat(className, "<-") + "as it is not defined in any of the super grammars ";
          errors.push({
            message: errMsg,
            type: parser_1.ParserDefinitionErrorType.INVALID_RULE_OVERRIDE,
            ruleName
          });
        }
        return errors;
      }
      exports2.validateRuleIsOverridden = validateRuleIsOverridden;
      function validateNoLeftRecursion(topRule, currRule, errMsgProvider, path3) {
        if (path3 === void 0) {
          path3 = [];
        }
        var errors = [];
        var nextNonTerminals = getFirstNoneTerminal(currRule.definition);
        if ((0, isEmpty_1.default)(nextNonTerminals)) {
          return [];
        } else {
          var ruleName = topRule.name;
          var foundLeftRecursion = (0, includes_1.default)(nextNonTerminals, topRule);
          if (foundLeftRecursion) {
            errors.push({
              message: errMsgProvider.buildLeftRecursionError({
                topLevelRule: topRule,
                leftRecursionPath: path3
              }),
              type: parser_1.ParserDefinitionErrorType.LEFT_RECURSION,
              ruleName
            });
          }
          var validNextSteps = (0, difference_1.default)(nextNonTerminals, path3.concat([topRule]));
          var errorsFromNextSteps = (0, flatMap_1.default)(validNextSteps, function(currRefRule) {
            var newPath = (0, clone_1.default)(path3);
            newPath.push(currRefRule);
            return validateNoLeftRecursion(topRule, currRefRule, errMsgProvider, newPath);
          });
          return errors.concat(errorsFromNextSteps);
        }
      }
      exports2.validateNoLeftRecursion = validateNoLeftRecursion;
      function getFirstNoneTerminal(definition) {
        var result = [];
        if ((0, isEmpty_1.default)(definition)) {
          return result;
        }
        var firstProd = (0, first_1.default)(definition);
        if (firstProd instanceof gast_2.NonTerminal) {
          result.push(firstProd.referencedRule);
        } else if (firstProd instanceof gast_2.Alternative || firstProd instanceof gast_2.Option || firstProd instanceof gast_2.RepetitionMandatory || firstProd instanceof gast_2.RepetitionMandatoryWithSeparator || firstProd instanceof gast_2.RepetitionWithSeparator || firstProd instanceof gast_2.Repetition) {
          result = result.concat(getFirstNoneTerminal(firstProd.definition));
        } else if (firstProd instanceof gast_2.Alternation) {
          result = (0, flatten_1.default)((0, map_1.default)(firstProd.definition, function(currSubDef) {
            return getFirstNoneTerminal(currSubDef.definition);
          }));
        } else if (firstProd instanceof gast_2.Terminal) {
        } else {
          throw Error("non exhaustive match");
        }
        var isFirstOptional = (0, gast_1.isOptionalProd)(firstProd);
        var hasMore = definition.length > 1;
        if (isFirstOptional && hasMore) {
          var rest = (0, drop_1.default)(definition);
          return result.concat(getFirstNoneTerminal(rest));
        } else {
          return result;
        }
      }
      exports2.getFirstNoneTerminal = getFirstNoneTerminal;
      var OrCollector = (
        /** @class */
        function(_super) {
          __extends(OrCollector2, _super);
          function OrCollector2() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.alternations = [];
            return _this;
          }
          OrCollector2.prototype.visitAlternation = function(node) {
            this.alternations.push(node);
          };
          return OrCollector2;
        }(gast_3.GAstVisitor)
      );
      function validateEmptyOrAlternative(topLevelRule, errMsgProvider) {
        var orCollector = new OrCollector();
        topLevelRule.accept(orCollector);
        var ors = orCollector.alternations;
        var errors = (0, flatMap_1.default)(ors, function(currOr) {
          var exceptLast = (0, dropRight_1.default)(currOr.definition);
          return (0, flatMap_1.default)(exceptLast, function(currAlternative, currAltIdx) {
            var possibleFirstInAlt = (0, interpreter_1.nextPossibleTokensAfter)([currAlternative], [], tokens_1.tokenStructuredMatcher, 1);
            if ((0, isEmpty_1.default)(possibleFirstInAlt)) {
              return [
                {
                  message: errMsgProvider.buildEmptyAlternationError({
                    topLevelRule,
                    alternation: currOr,
                    emptyChoiceIdx: currAltIdx
                  }),
                  type: parser_1.ParserDefinitionErrorType.NONE_LAST_EMPTY_ALT,
                  ruleName: topLevelRule.name,
                  occurrence: currOr.idx,
                  alternative: currAltIdx + 1
                }
              ];
            } else {
              return [];
            }
          });
        });
        return errors;
      }
      exports2.validateEmptyOrAlternative = validateEmptyOrAlternative;
      function validateAmbiguousAlternationAlternatives(topLevelRule, globalMaxLookahead, errMsgProvider) {
        var orCollector = new OrCollector();
        topLevelRule.accept(orCollector);
        var ors = orCollector.alternations;
        ors = (0, reject_1.default)(ors, function(currOr) {
          return currOr.ignoreAmbiguities === true;
        });
        var errors = (0, flatMap_1.default)(ors, function(currOr) {
          var currOccurrence = currOr.idx;
          var actualMaxLookahead = currOr.maxLookahead || globalMaxLookahead;
          var alternatives = (0, lookahead_1.getLookaheadPathsForOr)(currOccurrence, topLevelRule, actualMaxLookahead, currOr);
          var altsAmbiguityErrors = checkAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
          var altsPrefixAmbiguityErrors = checkPrefixAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
          return altsAmbiguityErrors.concat(altsPrefixAmbiguityErrors);
        });
        return errors;
      }
      exports2.validateAmbiguousAlternationAlternatives = validateAmbiguousAlternationAlternatives;
      var RepetitionCollector = (
        /** @class */
        function(_super) {
          __extends(RepetitionCollector2, _super);
          function RepetitionCollector2() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.allProductions = [];
            return _this;
          }
          RepetitionCollector2.prototype.visitRepetitionWithSeparator = function(manySep) {
            this.allProductions.push(manySep);
          };
          RepetitionCollector2.prototype.visitRepetitionMandatory = function(atLeastOne) {
            this.allProductions.push(atLeastOne);
          };
          RepetitionCollector2.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
            this.allProductions.push(atLeastOneSep);
          };
          RepetitionCollector2.prototype.visitRepetition = function(many) {
            this.allProductions.push(many);
          };
          return RepetitionCollector2;
        }(gast_3.GAstVisitor)
      );
      exports2.RepetitionCollector = RepetitionCollector;
      function validateTooManyAlts(topLevelRule, errMsgProvider) {
        var orCollector = new OrCollector();
        topLevelRule.accept(orCollector);
        var ors = orCollector.alternations;
        var errors = (0, flatMap_1.default)(ors, function(currOr) {
          if (currOr.definition.length > 255) {
            return [
              {
                message: errMsgProvider.buildTooManyAlternativesError({
                  topLevelRule,
                  alternation: currOr
                }),
                type: parser_1.ParserDefinitionErrorType.TOO_MANY_ALTS,
                ruleName: topLevelRule.name,
                occurrence: currOr.idx
              }
            ];
          } else {
            return [];
          }
        });
        return errors;
      }
      exports2.validateTooManyAlts = validateTooManyAlts;
      function validateSomeNonEmptyLookaheadPath(topLevelRules, maxLookahead, errMsgProvider) {
        var errors = [];
        (0, forEach_1.default)(topLevelRules, function(currTopRule) {
          var collectorVisitor = new RepetitionCollector();
          currTopRule.accept(collectorVisitor);
          var allRuleProductions = collectorVisitor.allProductions;
          (0, forEach_1.default)(allRuleProductions, function(currProd) {
            var prodType = (0, lookahead_1.getProdType)(currProd);
            var actualMaxLookahead = currProd.maxLookahead || maxLookahead;
            var currOccurrence = currProd.idx;
            var paths = (0, lookahead_1.getLookaheadPathsForOptionalProd)(currOccurrence, currTopRule, prodType, actualMaxLookahead);
            var pathsInsideProduction = paths[0];
            if ((0, isEmpty_1.default)((0, flatten_1.default)(pathsInsideProduction))) {
              var errMsg = errMsgProvider.buildEmptyRepetitionError({
                topLevelRule: currTopRule,
                repetition: currProd
              });
              errors.push({
                message: errMsg,
                type: parser_1.ParserDefinitionErrorType.NO_NON_EMPTY_LOOKAHEAD,
                ruleName: currTopRule.name
              });
            }
          });
        });
        return errors;
      }
      exports2.validateSomeNonEmptyLookaheadPath = validateSomeNonEmptyLookaheadPath;
      function checkAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
        var foundAmbiguousPaths = [];
        var identicalAmbiguities = (0, reduce_1.default)(alternatives, function(result, currAlt, currAltIdx) {
          if (alternation.definition[currAltIdx].ignoreAmbiguities === true) {
            return result;
          }
          (0, forEach_1.default)(currAlt, function(currPath) {
            var altsCurrPathAppearsIn = [currAltIdx];
            (0, forEach_1.default)(alternatives, function(currOtherAlt, currOtherAltIdx) {
              if (currAltIdx !== currOtherAltIdx && (0, lookahead_1.containsPath)(currOtherAlt, currPath) && // ignore (skip) ambiguities with this "other" alternative
              alternation.definition[currOtherAltIdx].ignoreAmbiguities !== true) {
                altsCurrPathAppearsIn.push(currOtherAltIdx);
              }
            });
            if (altsCurrPathAppearsIn.length > 1 && !(0, lookahead_1.containsPath)(foundAmbiguousPaths, currPath)) {
              foundAmbiguousPaths.push(currPath);
              result.push({
                alts: altsCurrPathAppearsIn,
                path: currPath
              });
            }
          });
          return result;
        }, []);
        var currErrors = (0, map_1.default)(identicalAmbiguities, function(currAmbDescriptor) {
          var ambgIndices = (0, map_1.default)(currAmbDescriptor.alts, function(currAltIdx) {
            return currAltIdx + 1;
          });
          var currMessage = errMsgProvider.buildAlternationAmbiguityError({
            topLevelRule: rule,
            alternation,
            ambiguityIndices: ambgIndices,
            prefixPath: currAmbDescriptor.path
          });
          return {
            message: currMessage,
            type: parser_1.ParserDefinitionErrorType.AMBIGUOUS_ALTS,
            ruleName: rule.name,
            occurrence: alternation.idx,
            alternatives: currAmbDescriptor.alts
          };
        });
        return currErrors;
      }
      function checkPrefixAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
        var pathsAndIndices = (0, reduce_1.default)(alternatives, function(result, currAlt, idx) {
          var currPathsAndIdx = (0, map_1.default)(currAlt, function(currPath) {
            return { idx, path: currPath };
          });
          return result.concat(currPathsAndIdx);
        }, []);
        var errors = (0, compact_1.default)((0, flatMap_1.default)(pathsAndIndices, function(currPathAndIdx) {
          var alternativeGast = alternation.definition[currPathAndIdx.idx];
          if (alternativeGast.ignoreAmbiguities === true) {
            return [];
          }
          var targetIdx = currPathAndIdx.idx;
          var targetPath = currPathAndIdx.path;
          var prefixAmbiguitiesPathsAndIndices = (0, filter_1.default)(pathsAndIndices, function(searchPathAndIdx) {
            return (
              // ignore (skip) ambiguities with this "other" alternative
              alternation.definition[searchPathAndIdx.idx].ignoreAmbiguities !== true && searchPathAndIdx.idx < targetIdx && // checking for strict prefix because identical lookaheads
              // will be be detected using a different validation.
              (0, lookahead_1.isStrictPrefixOfPath)(searchPathAndIdx.path, targetPath)
            );
          });
          var currPathPrefixErrors = (0, map_1.default)(prefixAmbiguitiesPathsAndIndices, function(currAmbPathAndIdx) {
            var ambgIndices = [currAmbPathAndIdx.idx + 1, targetIdx + 1];
            var occurrence = alternation.idx === 0 ? "" : alternation.idx;
            var message = errMsgProvider.buildAlternationPrefixAmbiguityError({
              topLevelRule: rule,
              alternation,
              ambiguityIndices: ambgIndices,
              prefixPath: currAmbPathAndIdx.path
            });
            return {
              message,
              type: parser_1.ParserDefinitionErrorType.AMBIGUOUS_PREFIX_ALTS,
              ruleName: rule.name,
              occurrence,
              alternatives: ambgIndices
            };
          });
          return currPathPrefixErrors;
        }));
        return errors;
      }
      exports2.checkPrefixAlternativesAmbiguities = checkPrefixAlternativesAmbiguities;
      function checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider) {
        var errors = [];
        var tokenNames = (0, map_1.default)(tokenTypes, function(currToken) {
          return currToken.name;
        });
        (0, forEach_1.default)(topLevels, function(currRule) {
          var currRuleName = currRule.name;
          if ((0, includes_1.default)(tokenNames, currRuleName)) {
            var errMsg = errMsgProvider.buildNamespaceConflictError(currRule);
            errors.push({
              message: errMsg,
              type: parser_1.ParserDefinitionErrorType.CONFLICT_TOKENS_RULES_NAMESPACE,
              ruleName: currRuleName
            });
          }
        });
        return errors;
      }
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/gast/gast_resolver_public.js
  var require_gast_resolver_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/gast/gast_resolver_public.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateGrammar = exports2.resolveGrammar = void 0;
      var forEach_1 = __importDefault(require_forEach());
      var defaults_1 = __importDefault(require_defaults());
      var resolver_1 = require_resolver();
      var checks_1 = require_checks();
      var errors_public_1 = require_errors_public();
      function resolveGrammar(options) {
        var actualOptions = (0, defaults_1.default)(options, {
          errMsgProvider: errors_public_1.defaultGrammarResolverErrorProvider
        });
        var topRulesTable = {};
        (0, forEach_1.default)(options.rules, function(rule) {
          topRulesTable[rule.name] = rule;
        });
        return (0, resolver_1.resolveGrammar)(topRulesTable, actualOptions.errMsgProvider);
      }
      exports2.resolveGrammar = resolveGrammar;
      function validateGrammar(options) {
        options = (0, defaults_1.default)(options, {
          errMsgProvider: errors_public_1.defaultGrammarValidatorErrorProvider
        });
        return (0, checks_1.validateGrammar)(options.rules, options.tokenTypes, options.errMsgProvider, options.grammarName);
      }
      exports2.validateGrammar = validateGrammar;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/exceptions_public.js
  var require_exceptions_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/exceptions_public.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.EarlyExitException = exports2.NotAllInputParsedException = exports2.NoViableAltException = exports2.MismatchedTokenException = exports2.isRecognitionException = void 0;
      var includes_1 = __importDefault(require_includes());
      var MISMATCHED_TOKEN_EXCEPTION = "MismatchedTokenException";
      var NO_VIABLE_ALT_EXCEPTION = "NoViableAltException";
      var EARLY_EXIT_EXCEPTION = "EarlyExitException";
      var NOT_ALL_INPUT_PARSED_EXCEPTION = "NotAllInputParsedException";
      var RECOGNITION_EXCEPTION_NAMES = [
        MISMATCHED_TOKEN_EXCEPTION,
        NO_VIABLE_ALT_EXCEPTION,
        EARLY_EXIT_EXCEPTION,
        NOT_ALL_INPUT_PARSED_EXCEPTION
      ];
      Object.freeze(RECOGNITION_EXCEPTION_NAMES);
      function isRecognitionException2(error) {
        return (0, includes_1.default)(RECOGNITION_EXCEPTION_NAMES, error.name);
      }
      exports2.isRecognitionException = isRecognitionException2;
      var RecognitionException = (
        /** @class */
        function(_super) {
          __extends(RecognitionException2, _super);
          function RecognitionException2(message, token) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            _this.token = token;
            _this.resyncedTokens = [];
            Object.setPrototypeOf(_this, _newTarget.prototype);
            if (Error.captureStackTrace) {
              Error.captureStackTrace(_this, _this.constructor);
            }
            return _this;
          }
          return RecognitionException2;
        }(Error)
      );
      var MismatchedTokenException2 = (
        /** @class */
        function(_super) {
          __extends(MismatchedTokenException3, _super);
          function MismatchedTokenException3(message, token, previousToken) {
            var _this = _super.call(this, message, token) || this;
            _this.previousToken = previousToken;
            _this.name = MISMATCHED_TOKEN_EXCEPTION;
            return _this;
          }
          return MismatchedTokenException3;
        }(RecognitionException)
      );
      exports2.MismatchedTokenException = MismatchedTokenException2;
      var NoViableAltException2 = (
        /** @class */
        function(_super) {
          __extends(NoViableAltException3, _super);
          function NoViableAltException3(message, token, previousToken) {
            var _this = _super.call(this, message, token) || this;
            _this.previousToken = previousToken;
            _this.name = NO_VIABLE_ALT_EXCEPTION;
            return _this;
          }
          return NoViableAltException3;
        }(RecognitionException)
      );
      exports2.NoViableAltException = NoViableAltException2;
      var NotAllInputParsedException2 = (
        /** @class */
        function(_super) {
          __extends(NotAllInputParsedException3, _super);
          function NotAllInputParsedException3(message, token) {
            var _this = _super.call(this, message, token) || this;
            _this.name = NOT_ALL_INPUT_PARSED_EXCEPTION;
            return _this;
          }
          return NotAllInputParsedException3;
        }(RecognitionException)
      );
      exports2.NotAllInputParsedException = NotAllInputParsedException2;
      var EarlyExitException2 = (
        /** @class */
        function(_super) {
          __extends(EarlyExitException3, _super);
          function EarlyExitException3(message, token, previousToken) {
            var _this = _super.call(this, message, token) || this;
            _this.previousToken = previousToken;
            _this.name = EARLY_EXIT_EXCEPTION;
            return _this;
          }
          return EarlyExitException3;
        }(RecognitionException)
      );
      exports2.EarlyExitException = EarlyExitException2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/recoverable.js
  var require_recoverable = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/recoverable.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.attemptInRepetitionRecovery = exports2.Recoverable = exports2.InRuleRecoveryException = exports2.IN_RULE_RECOVERY_EXCEPTION = exports2.EOF_FOLLOW_KEY = void 0;
      var tokens_public_1 = require_tokens_public();
      var isEmpty_1 = __importDefault(require_isEmpty());
      var dropRight_1 = __importDefault(require_dropRight());
      var flatten_1 = __importDefault(require_flatten());
      var map_1 = __importDefault(require_map());
      var find_1 = __importDefault(require_find());
      var has_1 = __importDefault(require_has());
      var includes_1 = __importDefault(require_includes());
      var clone_1 = __importDefault(require_clone());
      var exceptions_public_1 = require_exceptions_public();
      var constants_1 = require_constants();
      var parser_1 = require_parser();
      exports2.EOF_FOLLOW_KEY = {};
      exports2.IN_RULE_RECOVERY_EXCEPTION = "InRuleRecoveryException";
      var InRuleRecoveryException = (
        /** @class */
        function(_super) {
          __extends(InRuleRecoveryException2, _super);
          function InRuleRecoveryException2(message) {
            var _this = _super.call(this, message) || this;
            _this.name = exports2.IN_RULE_RECOVERY_EXCEPTION;
            return _this;
          }
          return InRuleRecoveryException2;
        }(Error)
      );
      exports2.InRuleRecoveryException = InRuleRecoveryException;
      var Recoverable = (
        /** @class */
        function() {
          function Recoverable2() {
          }
          Recoverable2.prototype.initRecoverable = function(config) {
            this.firstAfterRepMap = {};
            this.resyncFollows = {};
            this.recoveryEnabled = (0, has_1.default)(config, "recoveryEnabled") ? config.recoveryEnabled : parser_1.DEFAULT_PARSER_CONFIG.recoveryEnabled;
            if (this.recoveryEnabled) {
              this.attemptInRepetitionRecovery = attemptInRepetitionRecovery;
            }
          };
          Recoverable2.prototype.getTokenToInsert = function(tokType) {
            var tokToInsert = (0, tokens_public_1.createTokenInstance)(tokType, "", NaN, NaN, NaN, NaN, NaN, NaN);
            tokToInsert.isInsertedInRecovery = true;
            return tokToInsert;
          };
          Recoverable2.prototype.canTokenTypeBeInsertedInRecovery = function(tokType) {
            return true;
          };
          Recoverable2.prototype.canTokenTypeBeDeletedInRecovery = function(tokType) {
            return true;
          };
          Recoverable2.prototype.tryInRepetitionRecovery = function(grammarRule, grammarRuleArgs, lookAheadFunc, expectedTokType) {
            var _this = this;
            var reSyncTokType = this.findReSyncTokenType();
            var savedLexerState = this.exportLexerState();
            var resyncedTokens = [];
            var passedResyncPoint = false;
            var nextTokenWithoutResync = this.LA(1);
            var currToken = this.LA(1);
            var generateErrorMessage = function() {
              var previousToken = _this.LA(0);
              var msg = _this.errorMessageProvider.buildMismatchTokenMessage({
                expected: expectedTokType,
                actual: nextTokenWithoutResync,
                previous: previousToken,
                ruleName: _this.getCurrRuleFullName()
              });
              var error = new exceptions_public_1.MismatchedTokenException(msg, nextTokenWithoutResync, _this.LA(0));
              error.resyncedTokens = (0, dropRight_1.default)(resyncedTokens);
              _this.SAVE_ERROR(error);
            };
            while (!passedResyncPoint) {
              if (this.tokenMatcher(currToken, expectedTokType)) {
                generateErrorMessage();
                return;
              } else if (lookAheadFunc.call(this)) {
                generateErrorMessage();
                grammarRule.apply(this, grammarRuleArgs);
                return;
              } else if (this.tokenMatcher(currToken, reSyncTokType)) {
                passedResyncPoint = true;
              } else {
                currToken = this.SKIP_TOKEN();
                this.addToResyncTokens(currToken, resyncedTokens);
              }
            }
            this.importLexerState(savedLexerState);
          };
          Recoverable2.prototype.shouldInRepetitionRecoveryBeTried = function(expectTokAfterLastMatch, nextTokIdx, notStuck) {
            if (notStuck === false) {
              return false;
            }
            if (this.tokenMatcher(this.LA(1), expectTokAfterLastMatch)) {
              return false;
            }
            if (this.isBackTracking()) {
              return false;
            }
            if (this.canPerformInRuleRecovery(expectTokAfterLastMatch, this.getFollowsForInRuleRecovery(expectTokAfterLastMatch, nextTokIdx))) {
              return false;
            }
            return true;
          };
          Recoverable2.prototype.getFollowsForInRuleRecovery = function(tokType, tokIdxInRule) {
            var grammarPath = this.getCurrentGrammarPath(tokType, tokIdxInRule);
            var follows = this.getNextPossibleTokenTypes(grammarPath);
            return follows;
          };
          Recoverable2.prototype.tryInRuleRecovery = function(expectedTokType, follows) {
            if (this.canRecoverWithSingleTokenInsertion(expectedTokType, follows)) {
              var tokToInsert = this.getTokenToInsert(expectedTokType);
              return tokToInsert;
            }
            if (this.canRecoverWithSingleTokenDeletion(expectedTokType)) {
              var nextTok = this.SKIP_TOKEN();
              this.consumeToken();
              return nextTok;
            }
            throw new InRuleRecoveryException("sad sad panda");
          };
          Recoverable2.prototype.canPerformInRuleRecovery = function(expectedToken, follows) {
            return this.canRecoverWithSingleTokenInsertion(expectedToken, follows) || this.canRecoverWithSingleTokenDeletion(expectedToken);
          };
          Recoverable2.prototype.canRecoverWithSingleTokenInsertion = function(expectedTokType, follows) {
            var _this = this;
            if (!this.canTokenTypeBeInsertedInRecovery(expectedTokType)) {
              return false;
            }
            if ((0, isEmpty_1.default)(follows)) {
              return false;
            }
            var mismatchedTok = this.LA(1);
            var isMisMatchedTokInFollows = (0, find_1.default)(follows, function(possibleFollowsTokType) {
              return _this.tokenMatcher(mismatchedTok, possibleFollowsTokType);
            }) !== void 0;
            return isMisMatchedTokInFollows;
          };
          Recoverable2.prototype.canRecoverWithSingleTokenDeletion = function(expectedTokType) {
            if (!this.canTokenTypeBeDeletedInRecovery(expectedTokType)) {
              return false;
            }
            var isNextTokenWhatIsExpected = this.tokenMatcher(this.LA(2), expectedTokType);
            return isNextTokenWhatIsExpected;
          };
          Recoverable2.prototype.isInCurrentRuleReSyncSet = function(tokenTypeIdx) {
            var followKey = this.getCurrFollowKey();
            var currentRuleReSyncSet = this.getFollowSetFromFollowKey(followKey);
            return (0, includes_1.default)(currentRuleReSyncSet, tokenTypeIdx);
          };
          Recoverable2.prototype.findReSyncTokenType = function() {
            var allPossibleReSyncTokTypes = this.flattenFollowSet();
            var nextToken = this.LA(1);
            var k = 2;
            while (true) {
              var foundMatch = (0, find_1.default)(allPossibleReSyncTokTypes, function(resyncTokType) {
                var canMatch = (0, tokens_public_1.tokenMatcher)(nextToken, resyncTokType);
                return canMatch;
              });
              if (foundMatch !== void 0) {
                return foundMatch;
              }
              nextToken = this.LA(k);
              k++;
            }
          };
          Recoverable2.prototype.getCurrFollowKey = function() {
            if (this.RULE_STACK.length === 1) {
              return exports2.EOF_FOLLOW_KEY;
            }
            var currRuleShortName = this.getLastExplicitRuleShortName();
            var currRuleIdx = this.getLastExplicitRuleOccurrenceIndex();
            var prevRuleShortName = this.getPreviousExplicitRuleShortName();
            return {
              ruleName: this.shortRuleNameToFullName(currRuleShortName),
              idxInCallingRule: currRuleIdx,
              inRule: this.shortRuleNameToFullName(prevRuleShortName)
            };
          };
          Recoverable2.prototype.buildFullFollowKeyStack = function() {
            var _this = this;
            var explicitRuleStack = this.RULE_STACK;
            var explicitOccurrenceStack = this.RULE_OCCURRENCE_STACK;
            return (0, map_1.default)(explicitRuleStack, function(ruleName, idx) {
              if (idx === 0) {
                return exports2.EOF_FOLLOW_KEY;
              }
              return {
                ruleName: _this.shortRuleNameToFullName(ruleName),
                idxInCallingRule: explicitOccurrenceStack[idx],
                inRule: _this.shortRuleNameToFullName(explicitRuleStack[idx - 1])
              };
            });
          };
          Recoverable2.prototype.flattenFollowSet = function() {
            var _this = this;
            var followStack = (0, map_1.default)(this.buildFullFollowKeyStack(), function(currKey) {
              return _this.getFollowSetFromFollowKey(currKey);
            });
            return (0, flatten_1.default)(followStack);
          };
          Recoverable2.prototype.getFollowSetFromFollowKey = function(followKey) {
            if (followKey === exports2.EOF_FOLLOW_KEY) {
              return [tokens_public_1.EOF];
            }
            var followName = followKey.ruleName + followKey.idxInCallingRule + constants_1.IN + followKey.inRule;
            return this.resyncFollows[followName];
          };
          Recoverable2.prototype.addToResyncTokens = function(token, resyncTokens) {
            if (!this.tokenMatcher(token, tokens_public_1.EOF)) {
              resyncTokens.push(token);
            }
            return resyncTokens;
          };
          Recoverable2.prototype.reSyncTo = function(tokType) {
            var resyncedTokens = [];
            var nextTok = this.LA(1);
            while (this.tokenMatcher(nextTok, tokType) === false) {
              nextTok = this.SKIP_TOKEN();
              this.addToResyncTokens(nextTok, resyncedTokens);
            }
            return (0, dropRight_1.default)(resyncedTokens);
          };
          Recoverable2.prototype.attemptInRepetitionRecovery = function(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
          };
          Recoverable2.prototype.getCurrentGrammarPath = function(tokType, tokIdxInRule) {
            var pathRuleStack = this.getHumanReadableRuleStack();
            var pathOccurrenceStack = (0, clone_1.default)(this.RULE_OCCURRENCE_STACK);
            var grammarPath = {
              ruleStack: pathRuleStack,
              occurrenceStack: pathOccurrenceStack,
              lastTok: tokType,
              lastTokOccurrence: tokIdxInRule
            };
            return grammarPath;
          };
          Recoverable2.prototype.getHumanReadableRuleStack = function() {
            var _this = this;
            return (0, map_1.default)(this.RULE_STACK, function(currShortName) {
              return _this.shortRuleNameToFullName(currShortName);
            });
          };
          return Recoverable2;
        }()
      );
      exports2.Recoverable = Recoverable;
      function attemptInRepetitionRecovery(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
        var key = this.getKeyForAutomaticLookahead(dslMethodIdx, prodOccurrence);
        var firstAfterRepInfo = this.firstAfterRepMap[key];
        if (firstAfterRepInfo === void 0) {
          var currRuleName = this.getCurrRuleFullName();
          var ruleGrammar = this.getGAstProductions()[currRuleName];
          var walker = new nextToksWalker(ruleGrammar, prodOccurrence);
          firstAfterRepInfo = walker.startWalking();
          this.firstAfterRepMap[key] = firstAfterRepInfo;
        }
        var expectTokAfterLastMatch = firstAfterRepInfo.token;
        var nextTokIdx = firstAfterRepInfo.occurrence;
        var isEndOfRule = firstAfterRepInfo.isEndOfRule;
        if (this.RULE_STACK.length === 1 && isEndOfRule && expectTokAfterLastMatch === void 0) {
          expectTokAfterLastMatch = tokens_public_1.EOF;
          nextTokIdx = 1;
        }
        if (expectTokAfterLastMatch === void 0 || nextTokIdx === void 0) {
          return;
        }
        if (this.shouldInRepetitionRecoveryBeTried(expectTokAfterLastMatch, nextTokIdx, notStuck)) {
          this.tryInRepetitionRecovery(prodFunc, args, lookaheadFunc, expectTokAfterLastMatch);
        }
      }
      exports2.attemptInRepetitionRecovery = attemptInRepetitionRecovery;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/keys.js
  var require_keys2 = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/keys.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.getKeyForAutomaticLookahead = exports2.AT_LEAST_ONE_SEP_IDX = exports2.MANY_SEP_IDX = exports2.AT_LEAST_ONE_IDX = exports2.MANY_IDX = exports2.OPTION_IDX = exports2.OR_IDX = exports2.BITS_FOR_ALT_IDX = exports2.BITS_FOR_RULE_IDX = exports2.BITS_FOR_OCCURRENCE_IDX = exports2.BITS_FOR_METHOD_TYPE = void 0;
      exports2.BITS_FOR_METHOD_TYPE = 4;
      exports2.BITS_FOR_OCCURRENCE_IDX = 8;
      exports2.BITS_FOR_RULE_IDX = 12;
      exports2.BITS_FOR_ALT_IDX = 8;
      exports2.OR_IDX = 1 << exports2.BITS_FOR_OCCURRENCE_IDX;
      exports2.OPTION_IDX = 2 << exports2.BITS_FOR_OCCURRENCE_IDX;
      exports2.MANY_IDX = 3 << exports2.BITS_FOR_OCCURRENCE_IDX;
      exports2.AT_LEAST_ONE_IDX = 4 << exports2.BITS_FOR_OCCURRENCE_IDX;
      exports2.MANY_SEP_IDX = 5 << exports2.BITS_FOR_OCCURRENCE_IDX;
      exports2.AT_LEAST_ONE_SEP_IDX = 6 << exports2.BITS_FOR_OCCURRENCE_IDX;
      function getKeyForAutomaticLookahead(ruleIdx, dslMethodIdx, occurrence) {
        return occurrence | dslMethodIdx | ruleIdx;
      }
      exports2.getKeyForAutomaticLookahead = getKeyForAutomaticLookahead;
      var BITS_START_FOR_ALT_IDX = 32 - exports2.BITS_FOR_ALT_IDX;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/llk_lookahead.js
  var require_llk_lookahead = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/grammar/llk_lookahead.js"(exports2) {
      "use strict";
      var __spreadArray = exports2 && exports2.__spreadArray || function(to, from, pack) {
        if (pack || arguments.length === 2) for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
          if (ar || !(i2 in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i2);
            ar[i2] = from[i2];
          }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
      };
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.LLkLookaheadStrategy = void 0;
      var flatMap_1 = __importDefault(require_flatMap());
      var isEmpty_1 = __importDefault(require_isEmpty());
      var errors_public_1 = require_errors_public();
      var parser_1 = require_parser();
      var checks_1 = require_checks();
      var lookahead_1 = require_lookahead();
      var LLkLookaheadStrategy2 = (
        /** @class */
        function() {
          function LLkLookaheadStrategy3(options) {
            var _a6;
            this.maxLookahead = (_a6 = options === null || options === void 0 ? void 0 : options.maxLookahead) !== null && _a6 !== void 0 ? _a6 : parser_1.DEFAULT_PARSER_CONFIG.maxLookahead;
          }
          LLkLookaheadStrategy3.prototype.validate = function(options) {
            var leftRecursionErrors = this.validateNoLeftRecursion(options.rules);
            if ((0, isEmpty_1.default)(leftRecursionErrors)) {
              var emptyAltErrors = this.validateEmptyOrAlternatives(options.rules);
              var ambiguousAltsErrors = this.validateAmbiguousAlternationAlternatives(options.rules, this.maxLookahead);
              var emptyRepetitionErrors = this.validateSomeNonEmptyLookaheadPath(options.rules, this.maxLookahead);
              var allErrors = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], leftRecursionErrors, true), emptyAltErrors, true), ambiguousAltsErrors, true), emptyRepetitionErrors, true);
              return allErrors;
            }
            return leftRecursionErrors;
          };
          LLkLookaheadStrategy3.prototype.validateNoLeftRecursion = function(rules) {
            return (0, flatMap_1.default)(rules, function(currTopRule) {
              return (0, checks_1.validateNoLeftRecursion)(currTopRule, currTopRule, errors_public_1.defaultGrammarValidatorErrorProvider);
            });
          };
          LLkLookaheadStrategy3.prototype.validateEmptyOrAlternatives = function(rules) {
            return (0, flatMap_1.default)(rules, function(currTopRule) {
              return (0, checks_1.validateEmptyOrAlternative)(currTopRule, errors_public_1.defaultGrammarValidatorErrorProvider);
            });
          };
          LLkLookaheadStrategy3.prototype.validateAmbiguousAlternationAlternatives = function(rules, maxLookahead) {
            return (0, flatMap_1.default)(rules, function(currTopRule) {
              return (0, checks_1.validateAmbiguousAlternationAlternatives)(currTopRule, maxLookahead, errors_public_1.defaultGrammarValidatorErrorProvider);
            });
          };
          LLkLookaheadStrategy3.prototype.validateSomeNonEmptyLookaheadPath = function(rules, maxLookahead) {
            return (0, checks_1.validateSomeNonEmptyLookaheadPath)(rules, maxLookahead, errors_public_1.defaultGrammarValidatorErrorProvider);
          };
          LLkLookaheadStrategy3.prototype.buildLookaheadForAlternation = function(options) {
            return (0, lookahead_1.buildLookaheadFuncForOr)(options.prodOccurrence, options.rule, options.maxLookahead, options.hasPredicates, options.dynamicTokensEnabled, lookahead_1.buildAlternativesLookAheadFunc);
          };
          LLkLookaheadStrategy3.prototype.buildLookaheadForOptional = function(options) {
            return (0, lookahead_1.buildLookaheadFuncForOptionalProd)(options.prodOccurrence, options.rule, options.maxLookahead, options.dynamicTokensEnabled, (0, lookahead_1.getProdType)(options.prodType), lookahead_1.buildSingleAlternativeLookaheadFunction);
          };
          return LLkLookaheadStrategy3;
        }()
      );
      exports2.LLkLookaheadStrategy = LLkLookaheadStrategy2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/looksahead.js
  var require_looksahead = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/looksahead.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.collectMethods = exports2.LooksAhead = void 0;
      var forEach_1 = __importDefault(require_forEach());
      var has_1 = __importDefault(require_has());
      var parser_1 = require_parser();
      var keys_1 = require_keys2();
      var gast_1 = require_api2();
      var gast_2 = require_api2();
      var llk_lookahead_1 = require_llk_lookahead();
      var LooksAhead = (
        /** @class */
        function() {
          function LooksAhead2() {
          }
          LooksAhead2.prototype.initLooksAhead = function(config) {
            this.dynamicTokensEnabled = (0, has_1.default)(config, "dynamicTokensEnabled") ? config.dynamicTokensEnabled : parser_1.DEFAULT_PARSER_CONFIG.dynamicTokensEnabled;
            this.maxLookahead = (0, has_1.default)(config, "maxLookahead") ? config.maxLookahead : parser_1.DEFAULT_PARSER_CONFIG.maxLookahead;
            this.lookaheadStrategy = (0, has_1.default)(config, "lookaheadStrategy") ? config.lookaheadStrategy : new llk_lookahead_1.LLkLookaheadStrategy({ maxLookahead: this.maxLookahead });
            this.lookAheadFuncsCache = /* @__PURE__ */ new Map();
          };
          LooksAhead2.prototype.preComputeLookaheadFunctions = function(rules) {
            var _this = this;
            (0, forEach_1.default)(rules, function(currRule) {
              _this.TRACE_INIT("".concat(currRule.name, " Rule Lookahead"), function() {
                var _a6 = collectMethods(currRule), alternation = _a6.alternation, repetition = _a6.repetition, option = _a6.option, repetitionMandatory = _a6.repetitionMandatory, repetitionMandatoryWithSeparator = _a6.repetitionMandatoryWithSeparator, repetitionWithSeparator = _a6.repetitionWithSeparator;
                (0, forEach_1.default)(alternation, function(currProd) {
                  var prodIdx = currProd.idx === 0 ? "" : currProd.idx;
                  _this.TRACE_INIT("".concat((0, gast_2.getProductionDslName)(currProd)).concat(prodIdx), function() {
                    var laFunc = _this.lookaheadStrategy.buildLookaheadForAlternation({
                      prodOccurrence: currProd.idx,
                      rule: currRule,
                      maxLookahead: currProd.maxLookahead || _this.maxLookahead,
                      hasPredicates: currProd.hasPredicates,
                      dynamicTokensEnabled: _this.dynamicTokensEnabled
                    });
                    var key = (0, keys_1.getKeyForAutomaticLookahead)(_this.fullRuleNameToShort[currRule.name], keys_1.OR_IDX, currProd.idx);
                    _this.setLaFuncCache(key, laFunc);
                  });
                });
                (0, forEach_1.default)(repetition, function(currProd) {
                  _this.computeLookaheadFunc(currRule, currProd.idx, keys_1.MANY_IDX, "Repetition", currProd.maxLookahead, (0, gast_2.getProductionDslName)(currProd));
                });
                (0, forEach_1.default)(option, function(currProd) {
                  _this.computeLookaheadFunc(currRule, currProd.idx, keys_1.OPTION_IDX, "Option", currProd.maxLookahead, (0, gast_2.getProductionDslName)(currProd));
                });
                (0, forEach_1.default)(repetitionMandatory, function(currProd) {
                  _this.computeLookaheadFunc(currRule, currProd.idx, keys_1.AT_LEAST_ONE_IDX, "RepetitionMandatory", currProd.maxLookahead, (0, gast_2.getProductionDslName)(currProd));
                });
                (0, forEach_1.default)(repetitionMandatoryWithSeparator, function(currProd) {
                  _this.computeLookaheadFunc(currRule, currProd.idx, keys_1.AT_LEAST_ONE_SEP_IDX, "RepetitionMandatoryWithSeparator", currProd.maxLookahead, (0, gast_2.getProductionDslName)(currProd));
                });
                (0, forEach_1.default)(repetitionWithSeparator, function(currProd) {
                  _this.computeLookaheadFunc(currRule, currProd.idx, keys_1.MANY_SEP_IDX, "RepetitionWithSeparator", currProd.maxLookahead, (0, gast_2.getProductionDslName)(currProd));
                });
              });
            });
          };
          LooksAhead2.prototype.computeLookaheadFunc = function(rule, prodOccurrence, prodKey, prodType, prodMaxLookahead, dslMethodName) {
            var _this = this;
            this.TRACE_INIT("".concat(dslMethodName).concat(prodOccurrence === 0 ? "" : prodOccurrence), function() {
              var laFunc = _this.lookaheadStrategy.buildLookaheadForOptional({
                prodOccurrence,
                rule,
                maxLookahead: prodMaxLookahead || _this.maxLookahead,
                dynamicTokensEnabled: _this.dynamicTokensEnabled,
                prodType
              });
              var key = (0, keys_1.getKeyForAutomaticLookahead)(_this.fullRuleNameToShort[rule.name], prodKey, prodOccurrence);
              _this.setLaFuncCache(key, laFunc);
            });
          };
          LooksAhead2.prototype.getKeyForAutomaticLookahead = function(dslMethodIdx, occurrence) {
            var currRuleShortName = this.getLastExplicitRuleShortName();
            return (0, keys_1.getKeyForAutomaticLookahead)(currRuleShortName, dslMethodIdx, occurrence);
          };
          LooksAhead2.prototype.getLaFuncFromCache = function(key) {
            return this.lookAheadFuncsCache.get(key);
          };
          LooksAhead2.prototype.setLaFuncCache = function(key, value) {
            this.lookAheadFuncsCache.set(key, value);
          };
          return LooksAhead2;
        }()
      );
      exports2.LooksAhead = LooksAhead;
      var DslMethodsCollectorVisitor = (
        /** @class */
        function(_super) {
          __extends(DslMethodsCollectorVisitor2, _super);
          function DslMethodsCollectorVisitor2() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.dslMethods = {
              option: [],
              alternation: [],
              repetition: [],
              repetitionWithSeparator: [],
              repetitionMandatory: [],
              repetitionMandatoryWithSeparator: []
            };
            return _this;
          }
          DslMethodsCollectorVisitor2.prototype.reset = function() {
            this.dslMethods = {
              option: [],
              alternation: [],
              repetition: [],
              repetitionWithSeparator: [],
              repetitionMandatory: [],
              repetitionMandatoryWithSeparator: []
            };
          };
          DslMethodsCollectorVisitor2.prototype.visitOption = function(option) {
            this.dslMethods.option.push(option);
          };
          DslMethodsCollectorVisitor2.prototype.visitRepetitionWithSeparator = function(manySep) {
            this.dslMethods.repetitionWithSeparator.push(manySep);
          };
          DslMethodsCollectorVisitor2.prototype.visitRepetitionMandatory = function(atLeastOne) {
            this.dslMethods.repetitionMandatory.push(atLeastOne);
          };
          DslMethodsCollectorVisitor2.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
            this.dslMethods.repetitionMandatoryWithSeparator.push(atLeastOneSep);
          };
          DslMethodsCollectorVisitor2.prototype.visitRepetition = function(many) {
            this.dslMethods.repetition.push(many);
          };
          DslMethodsCollectorVisitor2.prototype.visitAlternation = function(or) {
            this.dslMethods.alternation.push(or);
          };
          return DslMethodsCollectorVisitor2;
        }(gast_1.GAstVisitor)
      );
      var collectorVisitor = new DslMethodsCollectorVisitor();
      function collectMethods(rule) {
        collectorVisitor.reset();
        rule.accept(collectorVisitor);
        var dslMethods = collectorVisitor.dslMethods;
        collectorVisitor.reset();
        return dslMethods;
      }
      exports2.collectMethods = collectMethods;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/cst/cst.js
  var require_cst = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/cst/cst.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.addNoneTerminalToCst = exports2.addTerminalToCst = exports2.setNodeLocationFull = exports2.setNodeLocationOnlyOffset = void 0;
      function setNodeLocationOnlyOffset(currNodeLocation, newLocationInfo) {
        if (isNaN(currNodeLocation.startOffset) === true) {
          currNodeLocation.startOffset = newLocationInfo.startOffset;
          currNodeLocation.endOffset = newLocationInfo.endOffset;
        } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) {
          currNodeLocation.endOffset = newLocationInfo.endOffset;
        }
      }
      exports2.setNodeLocationOnlyOffset = setNodeLocationOnlyOffset;
      function setNodeLocationFull(currNodeLocation, newLocationInfo) {
        if (isNaN(currNodeLocation.startOffset) === true) {
          currNodeLocation.startOffset = newLocationInfo.startOffset;
          currNodeLocation.startColumn = newLocationInfo.startColumn;
          currNodeLocation.startLine = newLocationInfo.startLine;
          currNodeLocation.endOffset = newLocationInfo.endOffset;
          currNodeLocation.endColumn = newLocationInfo.endColumn;
          currNodeLocation.endLine = newLocationInfo.endLine;
        } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) {
          currNodeLocation.endOffset = newLocationInfo.endOffset;
          currNodeLocation.endColumn = newLocationInfo.endColumn;
          currNodeLocation.endLine = newLocationInfo.endLine;
        }
      }
      exports2.setNodeLocationFull = setNodeLocationFull;
      function addTerminalToCst(node, token, tokenTypeName) {
        if (node.children[tokenTypeName] === void 0) {
          node.children[tokenTypeName] = [token];
        } else {
          node.children[tokenTypeName].push(token);
        }
      }
      exports2.addTerminalToCst = addTerminalToCst;
      function addNoneTerminalToCst(node, ruleName, ruleResult) {
        if (node.children[ruleName] === void 0) {
          node.children[ruleName] = [ruleResult];
        } else {
          node.children[ruleName].push(ruleResult);
        }
      }
      exports2.addNoneTerminalToCst = addNoneTerminalToCst;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/lang/lang_extensions.js
  var require_lang_extensions = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/lang/lang_extensions.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.defineNameProp = void 0;
      var NAME = "name";
      function defineNameProp(obj, nameValue) {
        Object.defineProperty(obj, NAME, {
          enumerable: false,
          configurable: true,
          writable: false,
          value: nameValue
        });
      }
      exports2.defineNameProp = defineNameProp;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/cst/cst_visitor.js
  var require_cst_visitor = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/cst/cst_visitor.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateMissingCstMethods = exports2.validateVisitor = exports2.CstVisitorDefinitionError = exports2.createBaseVisitorConstructorWithDefaults = exports2.createBaseSemanticVisitorConstructor = exports2.defaultVisit = void 0;
      var isEmpty_1 = __importDefault(require_isEmpty());
      var compact_1 = __importDefault(require_compact());
      var isArray_1 = __importDefault(require_isArray());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var filter_1 = __importDefault(require_filter());
      var keys_1 = __importDefault(require_keys());
      var isFunction_1 = __importDefault(require_isFunction());
      var isUndefined_1 = __importDefault(require_isUndefined());
      var lang_extensions_1 = require_lang_extensions();
      function defaultVisit(ctx, param) {
        var childrenNames = (0, keys_1.default)(ctx);
        var childrenNamesLength = childrenNames.length;
        for (var i2 = 0; i2 < childrenNamesLength; i2++) {
          var currChildName = childrenNames[i2];
          var currChildArray = ctx[currChildName];
          var currChildArrayLength = currChildArray.length;
          for (var j = 0; j < currChildArrayLength; j++) {
            var currChild = currChildArray[j];
            if (currChild.tokenTypeIdx === void 0) {
              this[currChild.name](currChild.children, param);
            }
          }
        }
      }
      exports2.defaultVisit = defaultVisit;
      function createBaseSemanticVisitorConstructor(grammarName, ruleNames) {
        var derivedConstructor = function() {
        };
        (0, lang_extensions_1.defineNameProp)(derivedConstructor, grammarName + "BaseSemantics");
        var semanticProto = {
          visit: function(cstNode, param) {
            if ((0, isArray_1.default)(cstNode)) {
              cstNode = cstNode[0];
            }
            if ((0, isUndefined_1.default)(cstNode)) {
              return void 0;
            }
            return this[cstNode.name](cstNode.children, param);
          },
          validateVisitor: function() {
            var semanticDefinitionErrors = validateVisitor(this, ruleNames);
            if (!(0, isEmpty_1.default)(semanticDefinitionErrors)) {
              var errorMessages = (0, map_1.default)(semanticDefinitionErrors, function(currDefError) {
                return currDefError.msg;
              });
              throw Error("Errors Detected in CST Visitor <".concat(this.constructor.name, ">:\n	") + "".concat(errorMessages.join("\n\n").replace(/\n/g, "\n	")));
            }
          }
        };
        derivedConstructor.prototype = semanticProto;
        derivedConstructor.prototype.constructor = derivedConstructor;
        derivedConstructor._RULE_NAMES = ruleNames;
        return derivedConstructor;
      }
      exports2.createBaseSemanticVisitorConstructor = createBaseSemanticVisitorConstructor;
      function createBaseVisitorConstructorWithDefaults(grammarName, ruleNames, baseConstructor) {
        var derivedConstructor = function() {
        };
        (0, lang_extensions_1.defineNameProp)(derivedConstructor, grammarName + "BaseSemanticsWithDefaults");
        var withDefaultsProto = Object.create(baseConstructor.prototype);
        (0, forEach_1.default)(ruleNames, function(ruleName) {
          withDefaultsProto[ruleName] = defaultVisit;
        });
        derivedConstructor.prototype = withDefaultsProto;
        derivedConstructor.prototype.constructor = derivedConstructor;
        return derivedConstructor;
      }
      exports2.createBaseVisitorConstructorWithDefaults = createBaseVisitorConstructorWithDefaults;
      var CstVisitorDefinitionError;
      (function(CstVisitorDefinitionError2) {
        CstVisitorDefinitionError2[CstVisitorDefinitionError2["REDUNDANT_METHOD"] = 0] = "REDUNDANT_METHOD";
        CstVisitorDefinitionError2[CstVisitorDefinitionError2["MISSING_METHOD"] = 1] = "MISSING_METHOD";
      })(CstVisitorDefinitionError = exports2.CstVisitorDefinitionError || (exports2.CstVisitorDefinitionError = {}));
      function validateVisitor(visitorInstance, ruleNames) {
        var missingErrors = validateMissingCstMethods(visitorInstance, ruleNames);
        return missingErrors;
      }
      exports2.validateVisitor = validateVisitor;
      function validateMissingCstMethods(visitorInstance, ruleNames) {
        var missingRuleNames = (0, filter_1.default)(ruleNames, function(currRuleName) {
          return (0, isFunction_1.default)(visitorInstance[currRuleName]) === false;
        });
        var errors = (0, map_1.default)(missingRuleNames, function(currRuleName) {
          return {
            msg: "Missing visitor method: <".concat(currRuleName, "> on ").concat(visitorInstance.constructor.name, " CST Visitor."),
            type: CstVisitorDefinitionError.MISSING_METHOD,
            methodName: currRuleName
          };
        });
        return (0, compact_1.default)(errors);
      }
      exports2.validateMissingCstMethods = validateMissingCstMethods;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/tree_builder.js
  var require_tree_builder = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/tree_builder.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.TreeBuilder = void 0;
      var cst_1 = require_cst();
      var noop_1 = __importDefault(require_noop());
      var has_1 = __importDefault(require_has());
      var keys_1 = __importDefault(require_keys());
      var isUndefined_1 = __importDefault(require_isUndefined());
      var cst_visitor_1 = require_cst_visitor();
      var parser_1 = require_parser();
      var TreeBuilder = (
        /** @class */
        function() {
          function TreeBuilder2() {
          }
          TreeBuilder2.prototype.initTreeBuilder = function(config) {
            this.CST_STACK = [];
            this.outputCst = config.outputCst;
            this.nodeLocationTracking = (0, has_1.default)(config, "nodeLocationTracking") ? config.nodeLocationTracking : parser_1.DEFAULT_PARSER_CONFIG.nodeLocationTracking;
            if (!this.outputCst) {
              this.cstInvocationStateUpdate = noop_1.default;
              this.cstFinallyStateUpdate = noop_1.default;
              this.cstPostTerminal = noop_1.default;
              this.cstPostNonTerminal = noop_1.default;
              this.cstPostRule = noop_1.default;
            } else {
              if (/full/i.test(this.nodeLocationTracking)) {
                if (this.recoveryEnabled) {
                  this.setNodeLocationFromToken = cst_1.setNodeLocationFull;
                  this.setNodeLocationFromNode = cst_1.setNodeLocationFull;
                  this.cstPostRule = noop_1.default;
                  this.setInitialNodeLocation = this.setInitialNodeLocationFullRecovery;
                } else {
                  this.setNodeLocationFromToken = noop_1.default;
                  this.setNodeLocationFromNode = noop_1.default;
                  this.cstPostRule = this.cstPostRuleFull;
                  this.setInitialNodeLocation = this.setInitialNodeLocationFullRegular;
                }
              } else if (/onlyOffset/i.test(this.nodeLocationTracking)) {
                if (this.recoveryEnabled) {
                  this.setNodeLocationFromToken = cst_1.setNodeLocationOnlyOffset;
                  this.setNodeLocationFromNode = cst_1.setNodeLocationOnlyOffset;
                  this.cstPostRule = noop_1.default;
                  this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRecovery;
                } else {
                  this.setNodeLocationFromToken = noop_1.default;
                  this.setNodeLocationFromNode = noop_1.default;
                  this.cstPostRule = this.cstPostRuleOnlyOffset;
                  this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRegular;
                }
              } else if (/none/i.test(this.nodeLocationTracking)) {
                this.setNodeLocationFromToken = noop_1.default;
                this.setNodeLocationFromNode = noop_1.default;
                this.cstPostRule = noop_1.default;
                this.setInitialNodeLocation = noop_1.default;
              } else {
                throw Error('Invalid <nodeLocationTracking> config option: "'.concat(config.nodeLocationTracking, '"'));
              }
            }
          };
          TreeBuilder2.prototype.setInitialNodeLocationOnlyOffsetRecovery = function(cstNode) {
            cstNode.location = {
              startOffset: NaN,
              endOffset: NaN
            };
          };
          TreeBuilder2.prototype.setInitialNodeLocationOnlyOffsetRegular = function(cstNode) {
            cstNode.location = {
              // without error recovery the starting Location of a new CstNode is guaranteed
              // To be the next Token's startOffset (for valid inputs).
              // For invalid inputs there won't be any CSTOutput so this potential
              // inaccuracy does not matter
              startOffset: this.LA(1).startOffset,
              endOffset: NaN
            };
          };
          TreeBuilder2.prototype.setInitialNodeLocationFullRecovery = function(cstNode) {
            cstNode.location = {
              startOffset: NaN,
              startLine: NaN,
              startColumn: NaN,
              endOffset: NaN,
              endLine: NaN,
              endColumn: NaN
            };
          };
          TreeBuilder2.prototype.setInitialNodeLocationFullRegular = function(cstNode) {
            var nextToken = this.LA(1);
            cstNode.location = {
              startOffset: nextToken.startOffset,
              startLine: nextToken.startLine,
              startColumn: nextToken.startColumn,
              endOffset: NaN,
              endLine: NaN,
              endColumn: NaN
            };
          };
          TreeBuilder2.prototype.cstInvocationStateUpdate = function(fullRuleName) {
            var cstNode = {
              name: fullRuleName,
              children: /* @__PURE__ */ Object.create(null)
            };
            this.setInitialNodeLocation(cstNode);
            this.CST_STACK.push(cstNode);
          };
          TreeBuilder2.prototype.cstFinallyStateUpdate = function() {
            this.CST_STACK.pop();
          };
          TreeBuilder2.prototype.cstPostRuleFull = function(ruleCstNode) {
            var prevToken = this.LA(0);
            var loc = ruleCstNode.location;
            if (loc.startOffset <= prevToken.startOffset === true) {
              loc.endOffset = prevToken.endOffset;
              loc.endLine = prevToken.endLine;
              loc.endColumn = prevToken.endColumn;
            } else {
              loc.startOffset = NaN;
              loc.startLine = NaN;
              loc.startColumn = NaN;
            }
          };
          TreeBuilder2.prototype.cstPostRuleOnlyOffset = function(ruleCstNode) {
            var prevToken = this.LA(0);
            var loc = ruleCstNode.location;
            if (loc.startOffset <= prevToken.startOffset === true) {
              loc.endOffset = prevToken.endOffset;
            } else {
              loc.startOffset = NaN;
            }
          };
          TreeBuilder2.prototype.cstPostTerminal = function(key, consumedToken) {
            var rootCst = this.CST_STACK[this.CST_STACK.length - 1];
            (0, cst_1.addTerminalToCst)(rootCst, consumedToken, key);
            this.setNodeLocationFromToken(rootCst.location, consumedToken);
          };
          TreeBuilder2.prototype.cstPostNonTerminal = function(ruleCstResult, ruleName) {
            var preCstNode = this.CST_STACK[this.CST_STACK.length - 1];
            (0, cst_1.addNoneTerminalToCst)(preCstNode, ruleName, ruleCstResult);
            this.setNodeLocationFromNode(preCstNode.location, ruleCstResult.location);
          };
          TreeBuilder2.prototype.getBaseCstVisitorConstructor = function() {
            if ((0, isUndefined_1.default)(this.baseCstVisitorConstructor)) {
              var newBaseCstVisitorConstructor = (0, cst_visitor_1.createBaseSemanticVisitorConstructor)(this.className, (0, keys_1.default)(this.gastProductionsCache));
              this.baseCstVisitorConstructor = newBaseCstVisitorConstructor;
              return newBaseCstVisitorConstructor;
            }
            return this.baseCstVisitorConstructor;
          };
          TreeBuilder2.prototype.getBaseCstVisitorConstructorWithDefaults = function() {
            if ((0, isUndefined_1.default)(this.baseCstVisitorWithDefaultsConstructor)) {
              var newConstructor = (0, cst_visitor_1.createBaseVisitorConstructorWithDefaults)(this.className, (0, keys_1.default)(this.gastProductionsCache), this.getBaseCstVisitorConstructor());
              this.baseCstVisitorWithDefaultsConstructor = newConstructor;
              return newConstructor;
            }
            return this.baseCstVisitorWithDefaultsConstructor;
          };
          TreeBuilder2.prototype.getLastExplicitRuleShortName = function() {
            var ruleStack = this.RULE_STACK;
            return ruleStack[ruleStack.length - 1];
          };
          TreeBuilder2.prototype.getPreviousExplicitRuleShortName = function() {
            var ruleStack = this.RULE_STACK;
            return ruleStack[ruleStack.length - 2];
          };
          TreeBuilder2.prototype.getLastExplicitRuleOccurrenceIndex = function() {
            var occurrenceStack = this.RULE_OCCURRENCE_STACK;
            return occurrenceStack[occurrenceStack.length - 1];
          };
          return TreeBuilder2;
        }()
      );
      exports2.TreeBuilder = TreeBuilder;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/lexer_adapter.js
  var require_lexer_adapter = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/lexer_adapter.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.LexerAdapter = void 0;
      var parser_1 = require_parser();
      var LexerAdapter = (
        /** @class */
        function() {
          function LexerAdapter2() {
          }
          LexerAdapter2.prototype.initLexerAdapter = function() {
            this.tokVector = [];
            this.tokVectorLength = 0;
            this.currIdx = -1;
          };
          Object.defineProperty(LexerAdapter2.prototype, "input", {
            get: function() {
              return this.tokVector;
            },
            set: function(newInput) {
              if (this.selfAnalysisDone !== true) {
                throw Error("Missing <performSelfAnalysis> invocation at the end of the Parser's constructor.");
              }
              this.reset();
              this.tokVector = newInput;
              this.tokVectorLength = newInput.length;
            },
            enumerable: false,
            configurable: true
          });
          LexerAdapter2.prototype.SKIP_TOKEN = function() {
            if (this.currIdx <= this.tokVector.length - 2) {
              this.consumeToken();
              return this.LA(1);
            } else {
              return parser_1.END_OF_FILE;
            }
          };
          LexerAdapter2.prototype.LA = function(howMuch) {
            var soughtIdx = this.currIdx + howMuch;
            if (soughtIdx < 0 || this.tokVectorLength <= soughtIdx) {
              return parser_1.END_OF_FILE;
            } else {
              return this.tokVector[soughtIdx];
            }
          };
          LexerAdapter2.prototype.consumeToken = function() {
            this.currIdx++;
          };
          LexerAdapter2.prototype.exportLexerState = function() {
            return this.currIdx;
          };
          LexerAdapter2.prototype.importLexerState = function(newState) {
            this.currIdx = newState;
          };
          LexerAdapter2.prototype.resetLexerState = function() {
            this.currIdx = -1;
          };
          LexerAdapter2.prototype.moveToTerminatedState = function() {
            this.currIdx = this.tokVector.length - 1;
          };
          LexerAdapter2.prototype.getLexerPosition = function() {
            return this.exportLexerState();
          };
          return LexerAdapter2;
        }()
      );
      exports2.LexerAdapter = LexerAdapter;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/recognizer_api.js
  var require_recognizer_api = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/recognizer_api.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.RecognizerApi = void 0;
      var values_1 = __importDefault(require_values());
      var includes_1 = __importDefault(require_includes());
      var exceptions_public_1 = require_exceptions_public();
      var parser_1 = require_parser();
      var errors_public_1 = require_errors_public();
      var checks_1 = require_checks();
      var gast_1 = require_api2();
      var RecognizerApi = (
        /** @class */
        function() {
          function RecognizerApi2() {
          }
          RecognizerApi2.prototype.ACTION = function(impl) {
            return impl.call(this);
          };
          RecognizerApi2.prototype.consume = function(idx, tokType, options) {
            return this.consumeInternal(tokType, idx, options);
          };
          RecognizerApi2.prototype.subrule = function(idx, ruleToCall, options) {
            return this.subruleInternal(ruleToCall, idx, options);
          };
          RecognizerApi2.prototype.option = function(idx, actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, idx);
          };
          RecognizerApi2.prototype.or = function(idx, altsOrOpts) {
            return this.orInternal(altsOrOpts, idx);
          };
          RecognizerApi2.prototype.many = function(idx, actionORMethodDef) {
            return this.manyInternal(idx, actionORMethodDef);
          };
          RecognizerApi2.prototype.atLeastOne = function(idx, actionORMethodDef) {
            return this.atLeastOneInternal(idx, actionORMethodDef);
          };
          RecognizerApi2.prototype.CONSUME = function(tokType, options) {
            return this.consumeInternal(tokType, 0, options);
          };
          RecognizerApi2.prototype.CONSUME1 = function(tokType, options) {
            return this.consumeInternal(tokType, 1, options);
          };
          RecognizerApi2.prototype.CONSUME2 = function(tokType, options) {
            return this.consumeInternal(tokType, 2, options);
          };
          RecognizerApi2.prototype.CONSUME3 = function(tokType, options) {
            return this.consumeInternal(tokType, 3, options);
          };
          RecognizerApi2.prototype.CONSUME4 = function(tokType, options) {
            return this.consumeInternal(tokType, 4, options);
          };
          RecognizerApi2.prototype.CONSUME5 = function(tokType, options) {
            return this.consumeInternal(tokType, 5, options);
          };
          RecognizerApi2.prototype.CONSUME6 = function(tokType, options) {
            return this.consumeInternal(tokType, 6, options);
          };
          RecognizerApi2.prototype.CONSUME7 = function(tokType, options) {
            return this.consumeInternal(tokType, 7, options);
          };
          RecognizerApi2.prototype.CONSUME8 = function(tokType, options) {
            return this.consumeInternal(tokType, 8, options);
          };
          RecognizerApi2.prototype.CONSUME9 = function(tokType, options) {
            return this.consumeInternal(tokType, 9, options);
          };
          RecognizerApi2.prototype.SUBRULE = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 0, options);
          };
          RecognizerApi2.prototype.SUBRULE1 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 1, options);
          };
          RecognizerApi2.prototype.SUBRULE2 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 2, options);
          };
          RecognizerApi2.prototype.SUBRULE3 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 3, options);
          };
          RecognizerApi2.prototype.SUBRULE4 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 4, options);
          };
          RecognizerApi2.prototype.SUBRULE5 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 5, options);
          };
          RecognizerApi2.prototype.SUBRULE6 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 6, options);
          };
          RecognizerApi2.prototype.SUBRULE7 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 7, options);
          };
          RecognizerApi2.prototype.SUBRULE8 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 8, options);
          };
          RecognizerApi2.prototype.SUBRULE9 = function(ruleToCall, options) {
            return this.subruleInternal(ruleToCall, 9, options);
          };
          RecognizerApi2.prototype.OPTION = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 0);
          };
          RecognizerApi2.prototype.OPTION1 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 1);
          };
          RecognizerApi2.prototype.OPTION2 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 2);
          };
          RecognizerApi2.prototype.OPTION3 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 3);
          };
          RecognizerApi2.prototype.OPTION4 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 4);
          };
          RecognizerApi2.prototype.OPTION5 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 5);
          };
          RecognizerApi2.prototype.OPTION6 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 6);
          };
          RecognizerApi2.prototype.OPTION7 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 7);
          };
          RecognizerApi2.prototype.OPTION8 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 8);
          };
          RecognizerApi2.prototype.OPTION9 = function(actionORMethodDef) {
            return this.optionInternal(actionORMethodDef, 9);
          };
          RecognizerApi2.prototype.OR = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 0);
          };
          RecognizerApi2.prototype.OR1 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 1);
          };
          RecognizerApi2.prototype.OR2 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 2);
          };
          RecognizerApi2.prototype.OR3 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 3);
          };
          RecognizerApi2.prototype.OR4 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 4);
          };
          RecognizerApi2.prototype.OR5 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 5);
          };
          RecognizerApi2.prototype.OR6 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 6);
          };
          RecognizerApi2.prototype.OR7 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 7);
          };
          RecognizerApi2.prototype.OR8 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 8);
          };
          RecognizerApi2.prototype.OR9 = function(altsOrOpts) {
            return this.orInternal(altsOrOpts, 9);
          };
          RecognizerApi2.prototype.MANY = function(actionORMethodDef) {
            this.manyInternal(0, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY1 = function(actionORMethodDef) {
            this.manyInternal(1, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY2 = function(actionORMethodDef) {
            this.manyInternal(2, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY3 = function(actionORMethodDef) {
            this.manyInternal(3, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY4 = function(actionORMethodDef) {
            this.manyInternal(4, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY5 = function(actionORMethodDef) {
            this.manyInternal(5, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY6 = function(actionORMethodDef) {
            this.manyInternal(6, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY7 = function(actionORMethodDef) {
            this.manyInternal(7, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY8 = function(actionORMethodDef) {
            this.manyInternal(8, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY9 = function(actionORMethodDef) {
            this.manyInternal(9, actionORMethodDef);
          };
          RecognizerApi2.prototype.MANY_SEP = function(options) {
            this.manySepFirstInternal(0, options);
          };
          RecognizerApi2.prototype.MANY_SEP1 = function(options) {
            this.manySepFirstInternal(1, options);
          };
          RecognizerApi2.prototype.MANY_SEP2 = function(options) {
            this.manySepFirstInternal(2, options);
          };
          RecognizerApi2.prototype.MANY_SEP3 = function(options) {
            this.manySepFirstInternal(3, options);
          };
          RecognizerApi2.prototype.MANY_SEP4 = function(options) {
            this.manySepFirstInternal(4, options);
          };
          RecognizerApi2.prototype.MANY_SEP5 = function(options) {
            this.manySepFirstInternal(5, options);
          };
          RecognizerApi2.prototype.MANY_SEP6 = function(options) {
            this.manySepFirstInternal(6, options);
          };
          RecognizerApi2.prototype.MANY_SEP7 = function(options) {
            this.manySepFirstInternal(7, options);
          };
          RecognizerApi2.prototype.MANY_SEP8 = function(options) {
            this.manySepFirstInternal(8, options);
          };
          RecognizerApi2.prototype.MANY_SEP9 = function(options) {
            this.manySepFirstInternal(9, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE = function(actionORMethodDef) {
            this.atLeastOneInternal(0, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE1 = function(actionORMethodDef) {
            return this.atLeastOneInternal(1, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE2 = function(actionORMethodDef) {
            this.atLeastOneInternal(2, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE3 = function(actionORMethodDef) {
            this.atLeastOneInternal(3, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE4 = function(actionORMethodDef) {
            this.atLeastOneInternal(4, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE5 = function(actionORMethodDef) {
            this.atLeastOneInternal(5, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE6 = function(actionORMethodDef) {
            this.atLeastOneInternal(6, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE7 = function(actionORMethodDef) {
            this.atLeastOneInternal(7, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE8 = function(actionORMethodDef) {
            this.atLeastOneInternal(8, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE9 = function(actionORMethodDef) {
            this.atLeastOneInternal(9, actionORMethodDef);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP = function(options) {
            this.atLeastOneSepFirstInternal(0, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP1 = function(options) {
            this.atLeastOneSepFirstInternal(1, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP2 = function(options) {
            this.atLeastOneSepFirstInternal(2, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP3 = function(options) {
            this.atLeastOneSepFirstInternal(3, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP4 = function(options) {
            this.atLeastOneSepFirstInternal(4, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP5 = function(options) {
            this.atLeastOneSepFirstInternal(5, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP6 = function(options) {
            this.atLeastOneSepFirstInternal(6, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP7 = function(options) {
            this.atLeastOneSepFirstInternal(7, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP8 = function(options) {
            this.atLeastOneSepFirstInternal(8, options);
          };
          RecognizerApi2.prototype.AT_LEAST_ONE_SEP9 = function(options) {
            this.atLeastOneSepFirstInternal(9, options);
          };
          RecognizerApi2.prototype.RULE = function(name2, implementation, config) {
            if (config === void 0) {
              config = parser_1.DEFAULT_RULE_CONFIG;
            }
            if ((0, includes_1.default)(this.definedRulesNames, name2)) {
              var errMsg = errors_public_1.defaultGrammarValidatorErrorProvider.buildDuplicateRuleNameError({
                topLevelRule: name2,
                grammarName: this.className
              });
              var error = {
                message: errMsg,
                type: parser_1.ParserDefinitionErrorType.DUPLICATE_RULE_NAME,
                ruleName: name2
              };
              this.definitionErrors.push(error);
            }
            this.definedRulesNames.push(name2);
            var ruleImplementation = this.defineRule(name2, implementation, config);
            this[name2] = ruleImplementation;
            return ruleImplementation;
          };
          RecognizerApi2.prototype.OVERRIDE_RULE = function(name2, impl, config) {
            if (config === void 0) {
              config = parser_1.DEFAULT_RULE_CONFIG;
            }
            var ruleErrors = (0, checks_1.validateRuleIsOverridden)(name2, this.definedRulesNames, this.className);
            this.definitionErrors = this.definitionErrors.concat(ruleErrors);
            var ruleImplementation = this.defineRule(name2, impl, config);
            this[name2] = ruleImplementation;
            return ruleImplementation;
          };
          RecognizerApi2.prototype.BACKTRACK = function(grammarRule, args) {
            return function() {
              this.isBackTrackingStack.push(1);
              var orgState = this.saveRecogState();
              try {
                grammarRule.apply(this, args);
                return true;
              } catch (e2) {
                if ((0, exceptions_public_1.isRecognitionException)(e2)) {
                  return false;
                } else {
                  throw e2;
                }
              } finally {
                this.reloadRecogState(orgState);
                this.isBackTrackingStack.pop();
              }
            };
          };
          RecognizerApi2.prototype.getGAstProductions = function() {
            return this.gastProductionsCache;
          };
          RecognizerApi2.prototype.getSerializedGastProductions = function() {
            return (0, gast_1.serializeGrammar)((0, values_1.default)(this.gastProductionsCache));
          };
          return RecognizerApi2;
        }()
      );
      exports2.RecognizerApi = RecognizerApi;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/recognizer_engine.js
  var require_recognizer_engine = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/recognizer_engine.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.RecognizerEngine = void 0;
      var isEmpty_1 = __importDefault(require_isEmpty());
      var isArray_1 = __importDefault(require_isArray());
      var flatten_1 = __importDefault(require_flatten());
      var every_1 = __importDefault(require_every());
      var uniq_1 = __importDefault(require_uniq());
      var isObject_1 = __importDefault(require_isObject());
      var has_1 = __importDefault(require_has());
      var values_1 = __importDefault(require_values());
      var reduce_1 = __importDefault(require_reduce());
      var clone_1 = __importDefault(require_clone());
      var keys_1 = require_keys2();
      var exceptions_public_1 = require_exceptions_public();
      var lookahead_1 = require_lookahead();
      var interpreter_1 = require_interpreter();
      var parser_1 = require_parser();
      var recoverable_1 = require_recoverable();
      var tokens_public_1 = require_tokens_public();
      var tokens_1 = require_tokens();
      var RecognizerEngine = (
        /** @class */
        function() {
          function RecognizerEngine2() {
          }
          RecognizerEngine2.prototype.initRecognizerEngine = function(tokenVocabulary, config) {
            this.className = this.constructor.name;
            this.shortRuleNameToFull = {};
            this.fullRuleNameToShort = {};
            this.ruleShortNameIdx = 256;
            this.tokenMatcher = tokens_1.tokenStructuredMatcherNoCategories;
            this.subruleIdx = 0;
            this.definedRulesNames = [];
            this.tokensMap = {};
            this.isBackTrackingStack = [];
            this.RULE_STACK = [];
            this.RULE_OCCURRENCE_STACK = [];
            this.gastProductionsCache = {};
            if ((0, has_1.default)(config, "serializedGrammar")) {
              throw Error("The Parser's configuration can no longer contain a <serializedGrammar> property.\n	See: https://chevrotain.io/docs/changes/BREAKING_CHANGES.html#_6-0-0\n	For Further details.");
            }
            if ((0, isArray_1.default)(tokenVocabulary)) {
              if ((0, isEmpty_1.default)(tokenVocabulary)) {
                throw Error("A Token Vocabulary cannot be empty.\n	Note that the first argument for the parser constructor\n	is no longer a Token vector (since v4.0).");
              }
              if (typeof tokenVocabulary[0].startOffset === "number") {
                throw Error("The Parser constructor no longer accepts a token vector as the first argument.\n	See: https://chevrotain.io/docs/changes/BREAKING_CHANGES.html#_4-0-0\n	For Further details.");
              }
            }
            if ((0, isArray_1.default)(tokenVocabulary)) {
              this.tokensMap = (0, reduce_1.default)(tokenVocabulary, function(acc, tokType) {
                acc[tokType.name] = tokType;
                return acc;
              }, {});
            } else if ((0, has_1.default)(tokenVocabulary, "modes") && (0, every_1.default)((0, flatten_1.default)((0, values_1.default)(tokenVocabulary.modes)), tokens_1.isTokenType)) {
              var allTokenTypes_1 = (0, flatten_1.default)((0, values_1.default)(tokenVocabulary.modes));
              var uniqueTokens = (0, uniq_1.default)(allTokenTypes_1);
              this.tokensMap = (0, reduce_1.default)(uniqueTokens, function(acc, tokType) {
                acc[tokType.name] = tokType;
                return acc;
              }, {});
            } else if ((0, isObject_1.default)(tokenVocabulary)) {
              this.tokensMap = (0, clone_1.default)(tokenVocabulary);
            } else {
              throw new Error("<tokensDictionary> argument must be An Array of Token constructors, A dictionary of Token constructors or an IMultiModeLexerDefinition");
            }
            this.tokensMap["EOF"] = tokens_public_1.EOF;
            var allTokenTypes = (0, has_1.default)(tokenVocabulary, "modes") ? (0, flatten_1.default)((0, values_1.default)(tokenVocabulary.modes)) : (0, values_1.default)(tokenVocabulary);
            var noTokenCategoriesUsed = (0, every_1.default)(allTokenTypes, function(tokenConstructor) {
              return (0, isEmpty_1.default)(tokenConstructor.categoryMatches);
            });
            this.tokenMatcher = noTokenCategoriesUsed ? tokens_1.tokenStructuredMatcherNoCategories : tokens_1.tokenStructuredMatcher;
            (0, tokens_1.augmentTokenTypes)((0, values_1.default)(this.tokensMap));
          };
          RecognizerEngine2.prototype.defineRule = function(ruleName, impl, config) {
            if (this.selfAnalysisDone) {
              throw Error("Grammar rule <".concat(ruleName, "> may not be defined after the 'performSelfAnalysis' method has been called'\n") + "Make sure that all grammar rule definitions are done before 'performSelfAnalysis' is called.");
            }
            var resyncEnabled = (0, has_1.default)(config, "resyncEnabled") ? config.resyncEnabled : parser_1.DEFAULT_RULE_CONFIG.resyncEnabled;
            var recoveryValueFunc = (0, has_1.default)(config, "recoveryValueFunc") ? config.recoveryValueFunc : parser_1.DEFAULT_RULE_CONFIG.recoveryValueFunc;
            var shortName = this.ruleShortNameIdx << keys_1.BITS_FOR_METHOD_TYPE + keys_1.BITS_FOR_OCCURRENCE_IDX;
            this.ruleShortNameIdx++;
            this.shortRuleNameToFull[shortName] = ruleName;
            this.fullRuleNameToShort[ruleName] = shortName;
            var invokeRuleWithTry;
            if (this.outputCst === true) {
              invokeRuleWithTry = function invokeRuleWithTry2() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }
                try {
                  this.ruleInvocationStateUpdate(shortName, ruleName, this.subruleIdx);
                  impl.apply(this, args);
                  var cst = this.CST_STACK[this.CST_STACK.length - 1];
                  this.cstPostRule(cst);
                  return cst;
                } catch (e2) {
                  return this.invokeRuleCatch(e2, resyncEnabled, recoveryValueFunc);
                } finally {
                  this.ruleFinallyStateUpdate();
                }
              };
            } else {
              invokeRuleWithTry = function invokeRuleWithTryCst() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
                }
                try {
                  this.ruleInvocationStateUpdate(shortName, ruleName, this.subruleIdx);
                  return impl.apply(this, args);
                } catch (e2) {
                  return this.invokeRuleCatch(e2, resyncEnabled, recoveryValueFunc);
                } finally {
                  this.ruleFinallyStateUpdate();
                }
              };
            }
            var wrappedGrammarRule = Object.assign(invokeRuleWithTry, { ruleName, originalGrammarAction: impl });
            return wrappedGrammarRule;
          };
          RecognizerEngine2.prototype.invokeRuleCatch = function(e2, resyncEnabledConfig, recoveryValueFunc) {
            var isFirstInvokedRule = this.RULE_STACK.length === 1;
            var reSyncEnabled = resyncEnabledConfig && !this.isBackTracking() && this.recoveryEnabled;
            if ((0, exceptions_public_1.isRecognitionException)(e2)) {
              var recogError = e2;
              if (reSyncEnabled) {
                var reSyncTokType = this.findReSyncTokenType();
                if (this.isInCurrentRuleReSyncSet(reSyncTokType)) {
                  recogError.resyncedTokens = this.reSyncTo(reSyncTokType);
                  if (this.outputCst) {
                    var partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
                    partialCstResult.recoveredNode = true;
                    return partialCstResult;
                  } else {
                    return recoveryValueFunc(e2);
                  }
                } else {
                  if (this.outputCst) {
                    var partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
                    partialCstResult.recoveredNode = true;
                    recogError.partialCstResult = partialCstResult;
                  }
                  throw recogError;
                }
              } else if (isFirstInvokedRule) {
                this.moveToTerminatedState();
                return recoveryValueFunc(e2);
              } else {
                throw recogError;
              }
            } else {
              throw e2;
            }
          };
          RecognizerEngine2.prototype.optionInternal = function(actionORMethodDef, occurrence) {
            var key = this.getKeyForAutomaticLookahead(keys_1.OPTION_IDX, occurrence);
            return this.optionInternalLogic(actionORMethodDef, occurrence, key);
          };
          RecognizerEngine2.prototype.optionInternalLogic = function(actionORMethodDef, occurrence, key) {
            var _this = this;
            var lookAheadFunc = this.getLaFuncFromCache(key);
            var action;
            if (typeof actionORMethodDef !== "function") {
              action = actionORMethodDef.DEF;
              var predicate_1 = actionORMethodDef.GATE;
              if (predicate_1 !== void 0) {
                var orgLookaheadFunction_1 = lookAheadFunc;
                lookAheadFunc = function() {
                  return predicate_1.call(_this) && orgLookaheadFunction_1.call(_this);
                };
              }
            } else {
              action = actionORMethodDef;
            }
            if (lookAheadFunc.call(this) === true) {
              return action.call(this);
            }
            return void 0;
          };
          RecognizerEngine2.prototype.atLeastOneInternal = function(prodOccurrence, actionORMethodDef) {
            var laKey = this.getKeyForAutomaticLookahead(keys_1.AT_LEAST_ONE_IDX, prodOccurrence);
            return this.atLeastOneInternalLogic(prodOccurrence, actionORMethodDef, laKey);
          };
          RecognizerEngine2.prototype.atLeastOneInternalLogic = function(prodOccurrence, actionORMethodDef, key) {
            var _this = this;
            var lookAheadFunc = this.getLaFuncFromCache(key);
            var action;
            if (typeof actionORMethodDef !== "function") {
              action = actionORMethodDef.DEF;
              var predicate_2 = actionORMethodDef.GATE;
              if (predicate_2 !== void 0) {
                var orgLookaheadFunction_2 = lookAheadFunc;
                lookAheadFunc = function() {
                  return predicate_2.call(_this) && orgLookaheadFunction_2.call(_this);
                };
              }
            } else {
              action = actionORMethodDef;
            }
            if (lookAheadFunc.call(this) === true) {
              var notStuck = this.doSingleRepetition(action);
              while (lookAheadFunc.call(this) === true && notStuck === true) {
                notStuck = this.doSingleRepetition(action);
              }
            } else {
              throw this.raiseEarlyExitException(prodOccurrence, lookahead_1.PROD_TYPE.REPETITION_MANDATORY, actionORMethodDef.ERR_MSG);
            }
            this.attemptInRepetitionRecovery(this.atLeastOneInternal, [prodOccurrence, actionORMethodDef], lookAheadFunc, keys_1.AT_LEAST_ONE_IDX, prodOccurrence, interpreter_1.NextTerminalAfterAtLeastOneWalker);
          };
          RecognizerEngine2.prototype.atLeastOneSepFirstInternal = function(prodOccurrence, options) {
            var laKey = this.getKeyForAutomaticLookahead(keys_1.AT_LEAST_ONE_SEP_IDX, prodOccurrence);
            this.atLeastOneSepFirstInternalLogic(prodOccurrence, options, laKey);
          };
          RecognizerEngine2.prototype.atLeastOneSepFirstInternalLogic = function(prodOccurrence, options, key) {
            var _this = this;
            var action = options.DEF;
            var separator = options.SEP;
            var firstIterationLookaheadFunc = this.getLaFuncFromCache(key);
            if (firstIterationLookaheadFunc.call(this) === true) {
              ;
              action.call(this);
              var separatorLookAheadFunc = function() {
                return _this.tokenMatcher(_this.LA(1), separator);
              };
              while (this.tokenMatcher(this.LA(1), separator) === true) {
                this.CONSUME(separator);
                action.call(this);
              }
              this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
                prodOccurrence,
                separator,
                separatorLookAheadFunc,
                action,
                interpreter_1.NextTerminalAfterAtLeastOneSepWalker
              ], separatorLookAheadFunc, keys_1.AT_LEAST_ONE_SEP_IDX, prodOccurrence, interpreter_1.NextTerminalAfterAtLeastOneSepWalker);
            } else {
              throw this.raiseEarlyExitException(prodOccurrence, lookahead_1.PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, options.ERR_MSG);
            }
          };
          RecognizerEngine2.prototype.manyInternal = function(prodOccurrence, actionORMethodDef) {
            var laKey = this.getKeyForAutomaticLookahead(keys_1.MANY_IDX, prodOccurrence);
            return this.manyInternalLogic(prodOccurrence, actionORMethodDef, laKey);
          };
          RecognizerEngine2.prototype.manyInternalLogic = function(prodOccurrence, actionORMethodDef, key) {
            var _this = this;
            var lookaheadFunction = this.getLaFuncFromCache(key);
            var action;
            if (typeof actionORMethodDef !== "function") {
              action = actionORMethodDef.DEF;
              var predicate_3 = actionORMethodDef.GATE;
              if (predicate_3 !== void 0) {
                var orgLookaheadFunction_3 = lookaheadFunction;
                lookaheadFunction = function() {
                  return predicate_3.call(_this) && orgLookaheadFunction_3.call(_this);
                };
              }
            } else {
              action = actionORMethodDef;
            }
            var notStuck = true;
            while (lookaheadFunction.call(this) === true && notStuck === true) {
              notStuck = this.doSingleRepetition(action);
            }
            this.attemptInRepetitionRecovery(
              this.manyInternal,
              [prodOccurrence, actionORMethodDef],
              lookaheadFunction,
              keys_1.MANY_IDX,
              prodOccurrence,
              interpreter_1.NextTerminalAfterManyWalker,
              // The notStuck parameter is only relevant when "attemptInRepetitionRecovery"
              // is invoked from manyInternal, in the MANY_SEP case and AT_LEAST_ONE[_SEP]
              // An infinite loop cannot occur as:
              // - Either the lookahead is guaranteed to consume something (Single Token Separator)
              // - AT_LEAST_ONE by definition is guaranteed to consume something (or error out).
              notStuck
            );
          };
          RecognizerEngine2.prototype.manySepFirstInternal = function(prodOccurrence, options) {
            var laKey = this.getKeyForAutomaticLookahead(keys_1.MANY_SEP_IDX, prodOccurrence);
            this.manySepFirstInternalLogic(prodOccurrence, options, laKey);
          };
          RecognizerEngine2.prototype.manySepFirstInternalLogic = function(prodOccurrence, options, key) {
            var _this = this;
            var action = options.DEF;
            var separator = options.SEP;
            var firstIterationLaFunc = this.getLaFuncFromCache(key);
            if (firstIterationLaFunc.call(this) === true) {
              action.call(this);
              var separatorLookAheadFunc = function() {
                return _this.tokenMatcher(_this.LA(1), separator);
              };
              while (this.tokenMatcher(this.LA(1), separator) === true) {
                this.CONSUME(separator);
                action.call(this);
              }
              this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
                prodOccurrence,
                separator,
                separatorLookAheadFunc,
                action,
                interpreter_1.NextTerminalAfterManySepWalker
              ], separatorLookAheadFunc, keys_1.MANY_SEP_IDX, prodOccurrence, interpreter_1.NextTerminalAfterManySepWalker);
            }
          };
          RecognizerEngine2.prototype.repetitionSepSecondInternal = function(prodOccurrence, separator, separatorLookAheadFunc, action, nextTerminalAfterWalker) {
            while (separatorLookAheadFunc()) {
              this.CONSUME(separator);
              action.call(this);
            }
            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
              prodOccurrence,
              separator,
              separatorLookAheadFunc,
              action,
              nextTerminalAfterWalker
            ], separatorLookAheadFunc, keys_1.AT_LEAST_ONE_SEP_IDX, prodOccurrence, nextTerminalAfterWalker);
          };
          RecognizerEngine2.prototype.doSingleRepetition = function(action) {
            var beforeIteration = this.getLexerPosition();
            action.call(this);
            var afterIteration = this.getLexerPosition();
            return afterIteration > beforeIteration;
          };
          RecognizerEngine2.prototype.orInternal = function(altsOrOpts, occurrence) {
            var laKey = this.getKeyForAutomaticLookahead(keys_1.OR_IDX, occurrence);
            var alts = (0, isArray_1.default)(altsOrOpts) ? altsOrOpts : altsOrOpts.DEF;
            var laFunc = this.getLaFuncFromCache(laKey);
            var altIdxToTake = laFunc.call(this, alts);
            if (altIdxToTake !== void 0) {
              var chosenAlternative = alts[altIdxToTake];
              return chosenAlternative.ALT.call(this);
            }
            this.raiseNoAltException(occurrence, altsOrOpts.ERR_MSG);
          };
          RecognizerEngine2.prototype.ruleFinallyStateUpdate = function() {
            this.RULE_STACK.pop();
            this.RULE_OCCURRENCE_STACK.pop();
            this.cstFinallyStateUpdate();
            if (this.RULE_STACK.length === 0 && this.isAtEndOfInput() === false) {
              var firstRedundantTok = this.LA(1);
              var errMsg = this.errorMessageProvider.buildNotAllInputParsedMessage({
                firstRedundant: firstRedundantTok,
                ruleName: this.getCurrRuleFullName()
              });
              this.SAVE_ERROR(new exceptions_public_1.NotAllInputParsedException(errMsg, firstRedundantTok));
            }
          };
          RecognizerEngine2.prototype.subruleInternal = function(ruleToCall, idx, options) {
            var ruleResult;
            try {
              var args = options !== void 0 ? options.ARGS : void 0;
              this.subruleIdx = idx;
              ruleResult = ruleToCall.apply(this, args);
              this.cstPostNonTerminal(ruleResult, options !== void 0 && options.LABEL !== void 0 ? options.LABEL : ruleToCall.ruleName);
              return ruleResult;
            } catch (e2) {
              throw this.subruleInternalError(e2, options, ruleToCall.ruleName);
            }
          };
          RecognizerEngine2.prototype.subruleInternalError = function(e2, options, ruleName) {
            if ((0, exceptions_public_1.isRecognitionException)(e2) && e2.partialCstResult !== void 0) {
              this.cstPostNonTerminal(e2.partialCstResult, options !== void 0 && options.LABEL !== void 0 ? options.LABEL : ruleName);
              delete e2.partialCstResult;
            }
            throw e2;
          };
          RecognizerEngine2.prototype.consumeInternal = function(tokType, idx, options) {
            var consumedToken;
            try {
              var nextToken = this.LA(1);
              if (this.tokenMatcher(nextToken, tokType) === true) {
                this.consumeToken();
                consumedToken = nextToken;
              } else {
                this.consumeInternalError(tokType, nextToken, options);
              }
            } catch (eFromConsumption) {
              consumedToken = this.consumeInternalRecovery(tokType, idx, eFromConsumption);
            }
            this.cstPostTerminal(options !== void 0 && options.LABEL !== void 0 ? options.LABEL : tokType.name, consumedToken);
            return consumedToken;
          };
          RecognizerEngine2.prototype.consumeInternalError = function(tokType, nextToken, options) {
            var msg;
            var previousToken = this.LA(0);
            if (options !== void 0 && options.ERR_MSG) {
              msg = options.ERR_MSG;
            } else {
              msg = this.errorMessageProvider.buildMismatchTokenMessage({
                expected: tokType,
                actual: nextToken,
                previous: previousToken,
                ruleName: this.getCurrRuleFullName()
              });
            }
            throw this.SAVE_ERROR(new exceptions_public_1.MismatchedTokenException(msg, nextToken, previousToken));
          };
          RecognizerEngine2.prototype.consumeInternalRecovery = function(tokType, idx, eFromConsumption) {
            if (this.recoveryEnabled && // TODO: more robust checking of the exception type. Perhaps Typescript extending expressions?
            eFromConsumption.name === "MismatchedTokenException" && !this.isBackTracking()) {
              var follows = this.getFollowsForInRuleRecovery(tokType, idx);
              try {
                return this.tryInRuleRecovery(tokType, follows);
              } catch (eFromInRuleRecovery) {
                if (eFromInRuleRecovery.name === recoverable_1.IN_RULE_RECOVERY_EXCEPTION) {
                  throw eFromConsumption;
                } else {
                  throw eFromInRuleRecovery;
                }
              }
            } else {
              throw eFromConsumption;
            }
          };
          RecognizerEngine2.prototype.saveRecogState = function() {
            var savedErrors = this.errors;
            var savedRuleStack = (0, clone_1.default)(this.RULE_STACK);
            return {
              errors: savedErrors,
              lexerState: this.exportLexerState(),
              RULE_STACK: savedRuleStack,
              CST_STACK: this.CST_STACK
            };
          };
          RecognizerEngine2.prototype.reloadRecogState = function(newState) {
            this.errors = newState.errors;
            this.importLexerState(newState.lexerState);
            this.RULE_STACK = newState.RULE_STACK;
          };
          RecognizerEngine2.prototype.ruleInvocationStateUpdate = function(shortName, fullName, idxInCallingRule) {
            this.RULE_OCCURRENCE_STACK.push(idxInCallingRule);
            this.RULE_STACK.push(shortName);
            this.cstInvocationStateUpdate(fullName);
          };
          RecognizerEngine2.prototype.isBackTracking = function() {
            return this.isBackTrackingStack.length !== 0;
          };
          RecognizerEngine2.prototype.getCurrRuleFullName = function() {
            var shortName = this.getLastExplicitRuleShortName();
            return this.shortRuleNameToFull[shortName];
          };
          RecognizerEngine2.prototype.shortRuleNameToFullName = function(shortName) {
            return this.shortRuleNameToFull[shortName];
          };
          RecognizerEngine2.prototype.isAtEndOfInput = function() {
            return this.tokenMatcher(this.LA(1), tokens_public_1.EOF);
          };
          RecognizerEngine2.prototype.reset = function() {
            this.resetLexerState();
            this.subruleIdx = 0;
            this.isBackTrackingStack = [];
            this.errors = [];
            this.RULE_STACK = [];
            this.CST_STACK = [];
            this.RULE_OCCURRENCE_STACK = [];
          };
          return RecognizerEngine2;
        }()
      );
      exports2.RecognizerEngine = RecognizerEngine;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/error_handler.js
  var require_error_handler = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/error_handler.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.ErrorHandler = void 0;
      var exceptions_public_1 = require_exceptions_public();
      var has_1 = __importDefault(require_has());
      var clone_1 = __importDefault(require_clone());
      var lookahead_1 = require_lookahead();
      var parser_1 = require_parser();
      var ErrorHandler2 = (
        /** @class */
        function() {
          function ErrorHandler3() {
          }
          ErrorHandler3.prototype.initErrorHandler = function(config) {
            this._errors = [];
            this.errorMessageProvider = (0, has_1.default)(config, "errorMessageProvider") ? config.errorMessageProvider : parser_1.DEFAULT_PARSER_CONFIG.errorMessageProvider;
          };
          ErrorHandler3.prototype.SAVE_ERROR = function(error) {
            if ((0, exceptions_public_1.isRecognitionException)(error)) {
              error.context = {
                ruleStack: this.getHumanReadableRuleStack(),
                ruleOccurrenceStack: (0, clone_1.default)(this.RULE_OCCURRENCE_STACK)
              };
              this._errors.push(error);
              return error;
            } else {
              throw Error("Trying to save an Error which is not a RecognitionException");
            }
          };
          Object.defineProperty(ErrorHandler3.prototype, "errors", {
            get: function() {
              return (0, clone_1.default)(this._errors);
            },
            set: function(newErrors) {
              this._errors = newErrors;
            },
            enumerable: false,
            configurable: true
          });
          ErrorHandler3.prototype.raiseEarlyExitException = function(occurrence, prodType, userDefinedErrMsg) {
            var ruleName = this.getCurrRuleFullName();
            var ruleGrammar = this.getGAstProductions()[ruleName];
            var lookAheadPathsPerAlternative = (0, lookahead_1.getLookaheadPathsForOptionalProd)(occurrence, ruleGrammar, prodType, this.maxLookahead);
            var insideProdPaths = lookAheadPathsPerAlternative[0];
            var actualTokens = [];
            for (var i2 = 1; i2 <= this.maxLookahead; i2++) {
              actualTokens.push(this.LA(i2));
            }
            var msg = this.errorMessageProvider.buildEarlyExitMessage({
              expectedIterationPaths: insideProdPaths,
              actual: actualTokens,
              previous: this.LA(0),
              customUserDescription: userDefinedErrMsg,
              ruleName
            });
            throw this.SAVE_ERROR(new exceptions_public_1.EarlyExitException(msg, this.LA(1), this.LA(0)));
          };
          ErrorHandler3.prototype.raiseNoAltException = function(occurrence, errMsgTypes) {
            var ruleName = this.getCurrRuleFullName();
            var ruleGrammar = this.getGAstProductions()[ruleName];
            var lookAheadPathsPerAlternative = (0, lookahead_1.getLookaheadPathsForOr)(occurrence, ruleGrammar, this.maxLookahead);
            var actualTokens = [];
            for (var i2 = 1; i2 <= this.maxLookahead; i2++) {
              actualTokens.push(this.LA(i2));
            }
            var previousToken = this.LA(0);
            var errMsg = this.errorMessageProvider.buildNoViableAltMessage({
              expectedPathsPerAlt: lookAheadPathsPerAlternative,
              actual: actualTokens,
              previous: previousToken,
              customUserDescription: errMsgTypes,
              ruleName: this.getCurrRuleFullName()
            });
            throw this.SAVE_ERROR(new exceptions_public_1.NoViableAltException(errMsg, this.LA(1), previousToken));
          };
          return ErrorHandler3;
        }()
      );
      exports2.ErrorHandler = ErrorHandler2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/context_assist.js
  var require_context_assist = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/context_assist.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.ContentAssist = void 0;
      var interpreter_1 = require_interpreter();
      var first_1 = __importDefault(require_first2());
      var isUndefined_1 = __importDefault(require_isUndefined());
      var ContentAssist = (
        /** @class */
        function() {
          function ContentAssist2() {
          }
          ContentAssist2.prototype.initContentAssist = function() {
          };
          ContentAssist2.prototype.computeContentAssist = function(startRuleName, precedingInput) {
            var startRuleGast = this.gastProductionsCache[startRuleName];
            if ((0, isUndefined_1.default)(startRuleGast)) {
              throw Error("Rule ->".concat(startRuleName, "<- does not exist in this grammar."));
            }
            return (0, interpreter_1.nextPossibleTokensAfter)([startRuleGast], precedingInput, this.tokenMatcher, this.maxLookahead);
          };
          ContentAssist2.prototype.getNextPossibleTokenTypes = function(grammarPath) {
            var topRuleName = (0, first_1.default)(grammarPath.ruleStack);
            var gastProductions = this.getGAstProductions();
            var topProduction = gastProductions[topRuleName];
            var nextPossibleTokenTypes = new interpreter_1.NextAfterTokenWalker(topProduction, grammarPath).startWalking();
            return nextPossibleTokenTypes;
          };
          return ContentAssist2;
        }()
      );
      exports2.ContentAssist = ContentAssist;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/gast_recorder.js
  var require_gast_recorder = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/gast_recorder.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.GastRecorder = void 0;
      var last_1 = __importDefault(require_last());
      var isArray_1 = __importDefault(require_isArray());
      var some_1 = __importDefault(require_some());
      var forEach_1 = __importDefault(require_forEach());
      var isFunction_1 = __importDefault(require_isFunction());
      var has_1 = __importDefault(require_has());
      var gast_1 = require_api2();
      var lexer_public_1 = require_lexer_public();
      var tokens_1 = require_tokens();
      var tokens_public_1 = require_tokens_public();
      var parser_1 = require_parser();
      var keys_1 = require_keys2();
      var RECORDING_NULL_OBJECT = {
        description: "This Object indicates the Parser is during Recording Phase"
      };
      Object.freeze(RECORDING_NULL_OBJECT);
      var HANDLE_SEPARATOR = true;
      var MAX_METHOD_IDX = Math.pow(2, keys_1.BITS_FOR_OCCURRENCE_IDX) - 1;
      var RFT = (0, tokens_public_1.createToken)({ name: "RECORDING_PHASE_TOKEN", pattern: lexer_public_1.Lexer.NA });
      (0, tokens_1.augmentTokenTypes)([RFT]);
      var RECORDING_PHASE_TOKEN = (0, tokens_public_1.createTokenInstance)(
        RFT,
        "This IToken indicates the Parser is in Recording Phase\n	See: https://chevrotain.io/docs/guide/internals.html#grammar-recording for details",
        // Using "-1" instead of NaN (as in EOF) because an actual number is less likely to
        // cause errors if the output of LA or CONSUME would be (incorrectly) used during the recording phase.
        -1,
        -1,
        -1,
        -1,
        -1,
        -1
      );
      Object.freeze(RECORDING_PHASE_TOKEN);
      var RECORDING_PHASE_CSTNODE = {
        name: "This CSTNode indicates the Parser is in Recording Phase\n	See: https://chevrotain.io/docs/guide/internals.html#grammar-recording for details",
        children: {}
      };
      var GastRecorder = (
        /** @class */
        function() {
          function GastRecorder2() {
          }
          GastRecorder2.prototype.initGastRecorder = function(config) {
            this.recordingProdStack = [];
            this.RECORDING_PHASE = false;
          };
          GastRecorder2.prototype.enableRecording = function() {
            var _this = this;
            this.RECORDING_PHASE = true;
            this.TRACE_INIT("Enable Recording", function() {
              var _loop_1 = function(i3) {
                var idx = i3 > 0 ? i3 : "";
                _this["CONSUME".concat(idx)] = function(arg1, arg2) {
                  return this.consumeInternalRecord(arg1, i3, arg2);
                };
                _this["SUBRULE".concat(idx)] = function(arg1, arg2) {
                  return this.subruleInternalRecord(arg1, i3, arg2);
                };
                _this["OPTION".concat(idx)] = function(arg1) {
                  return this.optionInternalRecord(arg1, i3);
                };
                _this["OR".concat(idx)] = function(arg1) {
                  return this.orInternalRecord(arg1, i3);
                };
                _this["MANY".concat(idx)] = function(arg1) {
                  this.manyInternalRecord(i3, arg1);
                };
                _this["MANY_SEP".concat(idx)] = function(arg1) {
                  this.manySepFirstInternalRecord(i3, arg1);
                };
                _this["AT_LEAST_ONE".concat(idx)] = function(arg1) {
                  this.atLeastOneInternalRecord(i3, arg1);
                };
                _this["AT_LEAST_ONE_SEP".concat(idx)] = function(arg1) {
                  this.atLeastOneSepFirstInternalRecord(i3, arg1);
                };
              };
              for (var i2 = 0; i2 < 10; i2++) {
                _loop_1(i2);
              }
              _this["consume"] = function(idx, arg1, arg2) {
                return this.consumeInternalRecord(arg1, idx, arg2);
              };
              _this["subrule"] = function(idx, arg1, arg2) {
                return this.subruleInternalRecord(arg1, idx, arg2);
              };
              _this["option"] = function(idx, arg1) {
                return this.optionInternalRecord(arg1, idx);
              };
              _this["or"] = function(idx, arg1) {
                return this.orInternalRecord(arg1, idx);
              };
              _this["many"] = function(idx, arg1) {
                this.manyInternalRecord(idx, arg1);
              };
              _this["atLeastOne"] = function(idx, arg1) {
                this.atLeastOneInternalRecord(idx, arg1);
              };
              _this.ACTION = _this.ACTION_RECORD;
              _this.BACKTRACK = _this.BACKTRACK_RECORD;
              _this.LA = _this.LA_RECORD;
            });
          };
          GastRecorder2.prototype.disableRecording = function() {
            var _this = this;
            this.RECORDING_PHASE = false;
            this.TRACE_INIT("Deleting Recording methods", function() {
              var that = _this;
              for (var i2 = 0; i2 < 10; i2++) {
                var idx = i2 > 0 ? i2 : "";
                delete that["CONSUME".concat(idx)];
                delete that["SUBRULE".concat(idx)];
                delete that["OPTION".concat(idx)];
                delete that["OR".concat(idx)];
                delete that["MANY".concat(idx)];
                delete that["MANY_SEP".concat(idx)];
                delete that["AT_LEAST_ONE".concat(idx)];
                delete that["AT_LEAST_ONE_SEP".concat(idx)];
              }
              delete that["consume"];
              delete that["subrule"];
              delete that["option"];
              delete that["or"];
              delete that["many"];
              delete that["atLeastOne"];
              delete that.ACTION;
              delete that.BACKTRACK;
              delete that.LA;
            });
          };
          GastRecorder2.prototype.ACTION_RECORD = function(impl) {
          };
          GastRecorder2.prototype.BACKTRACK_RECORD = function(grammarRule, args) {
            return function() {
              return true;
            };
          };
          GastRecorder2.prototype.LA_RECORD = function(howMuch) {
            return parser_1.END_OF_FILE;
          };
          GastRecorder2.prototype.topLevelRuleRecord = function(name2, def) {
            try {
              var newTopLevelRule = new gast_1.Rule({ definition: [], name: name2 });
              newTopLevelRule.name = name2;
              this.recordingProdStack.push(newTopLevelRule);
              def.call(this);
              this.recordingProdStack.pop();
              return newTopLevelRule;
            } catch (originalError) {
              if (originalError.KNOWN_RECORDER_ERROR !== true) {
                try {
                  originalError.message = originalError.message + '\n	 This error was thrown during the "grammar recording phase" For more info see:\n	https://chevrotain.io/docs/guide/internals.html#grammar-recording';
                } catch (mutabilityError) {
                  throw originalError;
                }
              }
              throw originalError;
            }
          };
          GastRecorder2.prototype.optionInternalRecord = function(actionORMethodDef, occurrence) {
            return recordProd.call(this, gast_1.Option, actionORMethodDef, occurrence);
          };
          GastRecorder2.prototype.atLeastOneInternalRecord = function(occurrence, actionORMethodDef) {
            recordProd.call(this, gast_1.RepetitionMandatory, actionORMethodDef, occurrence);
          };
          GastRecorder2.prototype.atLeastOneSepFirstInternalRecord = function(occurrence, options) {
            recordProd.call(this, gast_1.RepetitionMandatoryWithSeparator, options, occurrence, HANDLE_SEPARATOR);
          };
          GastRecorder2.prototype.manyInternalRecord = function(occurrence, actionORMethodDef) {
            recordProd.call(this, gast_1.Repetition, actionORMethodDef, occurrence);
          };
          GastRecorder2.prototype.manySepFirstInternalRecord = function(occurrence, options) {
            recordProd.call(this, gast_1.RepetitionWithSeparator, options, occurrence, HANDLE_SEPARATOR);
          };
          GastRecorder2.prototype.orInternalRecord = function(altsOrOpts, occurrence) {
            return recordOrProd.call(this, altsOrOpts, occurrence);
          };
          GastRecorder2.prototype.subruleInternalRecord = function(ruleToCall, occurrence, options) {
            assertMethodIdxIsValid(occurrence);
            if (!ruleToCall || (0, has_1.default)(ruleToCall, "ruleName") === false) {
              var error = new Error("<SUBRULE".concat(getIdxSuffix(occurrence), "> argument is invalid") + " expecting a Parser method reference but got: <".concat(JSON.stringify(ruleToCall), ">") + "\n inside top level rule: <".concat(this.recordingProdStack[0].name, ">"));
              error.KNOWN_RECORDER_ERROR = true;
              throw error;
            }
            var prevProd = (0, last_1.default)(this.recordingProdStack);
            var ruleName = ruleToCall.ruleName;
            var newNoneTerminal = new gast_1.NonTerminal({
              idx: occurrence,
              nonTerminalName: ruleName,
              label: options === null || options === void 0 ? void 0 : options.LABEL,
              // The resolving of the `referencedRule` property will be done once all the Rule's GASTs have been created
              referencedRule: void 0
            });
            prevProd.definition.push(newNoneTerminal);
            return this.outputCst ? RECORDING_PHASE_CSTNODE : RECORDING_NULL_OBJECT;
          };
          GastRecorder2.prototype.consumeInternalRecord = function(tokType, occurrence, options) {
            assertMethodIdxIsValid(occurrence);
            if (!(0, tokens_1.hasShortKeyProperty)(tokType)) {
              var error = new Error("<CONSUME".concat(getIdxSuffix(occurrence), "> argument is invalid") + " expecting a TokenType reference but got: <".concat(JSON.stringify(tokType), ">") + "\n inside top level rule: <".concat(this.recordingProdStack[0].name, ">"));
              error.KNOWN_RECORDER_ERROR = true;
              throw error;
            }
            var prevProd = (0, last_1.default)(this.recordingProdStack);
            var newNoneTerminal = new gast_1.Terminal({
              idx: occurrence,
              terminalType: tokType,
              label: options === null || options === void 0 ? void 0 : options.LABEL
            });
            prevProd.definition.push(newNoneTerminal);
            return RECORDING_PHASE_TOKEN;
          };
          return GastRecorder2;
        }()
      );
      exports2.GastRecorder = GastRecorder;
      function recordProd(prodConstructor, mainProdArg, occurrence, handleSep) {
        if (handleSep === void 0) {
          handleSep = false;
        }
        assertMethodIdxIsValid(occurrence);
        var prevProd = (0, last_1.default)(this.recordingProdStack);
        var grammarAction = (0, isFunction_1.default)(mainProdArg) ? mainProdArg : mainProdArg.DEF;
        var newProd = new prodConstructor({ definition: [], idx: occurrence });
        if (handleSep) {
          newProd.separator = mainProdArg.SEP;
        }
        if ((0, has_1.default)(mainProdArg, "MAX_LOOKAHEAD")) {
          newProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
        }
        this.recordingProdStack.push(newProd);
        grammarAction.call(this);
        prevProd.definition.push(newProd);
        this.recordingProdStack.pop();
        return RECORDING_NULL_OBJECT;
      }
      function recordOrProd(mainProdArg, occurrence) {
        var _this = this;
        assertMethodIdxIsValid(occurrence);
        var prevProd = (0, last_1.default)(this.recordingProdStack);
        var hasOptions = (0, isArray_1.default)(mainProdArg) === false;
        var alts = hasOptions === false ? mainProdArg : mainProdArg.DEF;
        var newOrProd = new gast_1.Alternation({
          definition: [],
          idx: occurrence,
          ignoreAmbiguities: hasOptions && mainProdArg.IGNORE_AMBIGUITIES === true
        });
        if ((0, has_1.default)(mainProdArg, "MAX_LOOKAHEAD")) {
          newOrProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
        }
        var hasPredicates = (0, some_1.default)(alts, function(currAlt) {
          return (0, isFunction_1.default)(currAlt.GATE);
        });
        newOrProd.hasPredicates = hasPredicates;
        prevProd.definition.push(newOrProd);
        (0, forEach_1.default)(alts, function(currAlt) {
          var currAltFlat = new gast_1.Alternative({ definition: [] });
          newOrProd.definition.push(currAltFlat);
          if ((0, has_1.default)(currAlt, "IGNORE_AMBIGUITIES")) {
            currAltFlat.ignoreAmbiguities = currAlt.IGNORE_AMBIGUITIES;
          } else if ((0, has_1.default)(currAlt, "GATE")) {
            currAltFlat.ignoreAmbiguities = true;
          }
          _this.recordingProdStack.push(currAltFlat);
          currAlt.ALT.call(_this);
          _this.recordingProdStack.pop();
        });
        return RECORDING_NULL_OBJECT;
      }
      function getIdxSuffix(idx) {
        return idx === 0 ? "" : "".concat(idx);
      }
      function assertMethodIdxIsValid(idx) {
        if (idx < 0 || idx > MAX_METHOD_IDX) {
          var error = new Error(
            // The stack trace will contain all the needed details
            "Invalid DSL Method idx value: <".concat(idx, ">\n	") + "Idx value must be a none negative value smaller than ".concat(MAX_METHOD_IDX + 1)
          );
          error.KNOWN_RECORDER_ERROR = true;
          throw error;
        }
      }
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/perf_tracer.js
  var require_perf_tracer = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/traits/perf_tracer.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.PerformanceTracer = void 0;
      var has_1 = __importDefault(require_has());
      var utils_1 = require_api();
      var parser_1 = require_parser();
      var PerformanceTracer = (
        /** @class */
        function() {
          function PerformanceTracer2() {
          }
          PerformanceTracer2.prototype.initPerformanceTracer = function(config) {
            if ((0, has_1.default)(config, "traceInitPerf")) {
              var userTraceInitPerf = config.traceInitPerf;
              var traceIsNumber = typeof userTraceInitPerf === "number";
              this.traceInitMaxIdent = traceIsNumber ? userTraceInitPerf : Infinity;
              this.traceInitPerf = traceIsNumber ? userTraceInitPerf > 0 : userTraceInitPerf;
            } else {
              this.traceInitMaxIdent = 0;
              this.traceInitPerf = parser_1.DEFAULT_PARSER_CONFIG.traceInitPerf;
            }
            this.traceInitIndent = -1;
          };
          PerformanceTracer2.prototype.TRACE_INIT = function(phaseDesc, phaseImpl) {
            if (this.traceInitPerf === true) {
              this.traceInitIndent++;
              var indent = new Array(this.traceInitIndent + 1).join("	");
              if (this.traceInitIndent < this.traceInitMaxIdent) {
                console.log("".concat(indent, "--> <").concat(phaseDesc, ">"));
              }
              var _a6 = (0, utils_1.timer)(phaseImpl), time = _a6.time, value = _a6.value;
              var traceMethod = time > 10 ? console.warn : console.log;
              if (this.traceInitIndent < this.traceInitMaxIdent) {
                traceMethod("".concat(indent, "<-- <").concat(phaseDesc, "> time: ").concat(time, "ms"));
              }
              this.traceInitIndent--;
              return value;
            } else {
              return phaseImpl();
            }
          };
          return PerformanceTracer2;
        }()
      );
      exports2.PerformanceTracer = PerformanceTracer;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/utils/apply_mixins.js
  var require_apply_mixins = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/utils/apply_mixins.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.applyMixins = void 0;
      function applyMixins(derivedCtor, baseCtors) {
        baseCtors.forEach(function(baseCtor) {
          var baseProto = baseCtor.prototype;
          Object.getOwnPropertyNames(baseProto).forEach(function(propName) {
            if (propName === "constructor") {
              return;
            }
            var basePropDescriptor = Object.getOwnPropertyDescriptor(baseProto, propName);
            if (basePropDescriptor && (basePropDescriptor.get || basePropDescriptor.set)) {
              Object.defineProperty(derivedCtor.prototype, propName, basePropDescriptor);
            } else {
              derivedCtor.prototype[propName] = baseCtor.prototype[propName];
            }
          });
        });
      }
      exports2.applyMixins = applyMixins;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/parser.js
  var require_parser = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/parse/parser/parser.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.EmbeddedActionsParser = exports2.CstParser = exports2.Parser = exports2.EMPTY_ALT = exports2.ParserDefinitionErrorType = exports2.DEFAULT_RULE_CONFIG = exports2.DEFAULT_PARSER_CONFIG = exports2.END_OF_FILE = void 0;
      var isEmpty_1 = __importDefault(require_isEmpty());
      var map_1 = __importDefault(require_map());
      var forEach_1 = __importDefault(require_forEach());
      var values_1 = __importDefault(require_values());
      var has_1 = __importDefault(require_has());
      var clone_1 = __importDefault(require_clone());
      var utils_1 = require_api();
      var follow_1 = require_follow();
      var tokens_public_1 = require_tokens_public();
      var errors_public_1 = require_errors_public();
      var gast_resolver_public_1 = require_gast_resolver_public();
      var recoverable_1 = require_recoverable();
      var looksahead_1 = require_looksahead();
      var tree_builder_1 = require_tree_builder();
      var lexer_adapter_1 = require_lexer_adapter();
      var recognizer_api_1 = require_recognizer_api();
      var recognizer_engine_1 = require_recognizer_engine();
      var error_handler_1 = require_error_handler();
      var context_assist_1 = require_context_assist();
      var gast_recorder_1 = require_gast_recorder();
      var perf_tracer_1 = require_perf_tracer();
      var apply_mixins_1 = require_apply_mixins();
      var checks_1 = require_checks();
      exports2.END_OF_FILE = (0, tokens_public_1.createTokenInstance)(tokens_public_1.EOF, "", NaN, NaN, NaN, NaN, NaN, NaN);
      Object.freeze(exports2.END_OF_FILE);
      exports2.DEFAULT_PARSER_CONFIG = Object.freeze({
        recoveryEnabled: false,
        maxLookahead: 3,
        dynamicTokensEnabled: false,
        outputCst: true,
        errorMessageProvider: errors_public_1.defaultParserErrorProvider,
        nodeLocationTracking: "none",
        traceInitPerf: false,
        skipValidations: false
      });
      exports2.DEFAULT_RULE_CONFIG = Object.freeze({
        recoveryValueFunc: function() {
          return void 0;
        },
        resyncEnabled: true
      });
      var ParserDefinitionErrorType2;
      (function(ParserDefinitionErrorType3) {
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["INVALID_RULE_NAME"] = 0] = "INVALID_RULE_NAME";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["DUPLICATE_RULE_NAME"] = 1] = "DUPLICATE_RULE_NAME";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["INVALID_RULE_OVERRIDE"] = 2] = "INVALID_RULE_OVERRIDE";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["DUPLICATE_PRODUCTIONS"] = 3] = "DUPLICATE_PRODUCTIONS";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["UNRESOLVED_SUBRULE_REF"] = 4] = "UNRESOLVED_SUBRULE_REF";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["LEFT_RECURSION"] = 5] = "LEFT_RECURSION";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["NONE_LAST_EMPTY_ALT"] = 6] = "NONE_LAST_EMPTY_ALT";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["AMBIGUOUS_ALTS"] = 7] = "AMBIGUOUS_ALTS";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["CONFLICT_TOKENS_RULES_NAMESPACE"] = 8] = "CONFLICT_TOKENS_RULES_NAMESPACE";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["INVALID_TOKEN_NAME"] = 9] = "INVALID_TOKEN_NAME";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["NO_NON_EMPTY_LOOKAHEAD"] = 10] = "NO_NON_EMPTY_LOOKAHEAD";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["AMBIGUOUS_PREFIX_ALTS"] = 11] = "AMBIGUOUS_PREFIX_ALTS";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["TOO_MANY_ALTS"] = 12] = "TOO_MANY_ALTS";
        ParserDefinitionErrorType3[ParserDefinitionErrorType3["CUSTOM_LOOKAHEAD_VALIDATION"] = 13] = "CUSTOM_LOOKAHEAD_VALIDATION";
      })(ParserDefinitionErrorType2 = exports2.ParserDefinitionErrorType || (exports2.ParserDefinitionErrorType = {}));
      function EMPTY_ALT2(value) {
        if (value === void 0) {
          value = void 0;
        }
        return function() {
          return value;
        };
      }
      exports2.EMPTY_ALT = EMPTY_ALT2;
      var Parser2 = (
        /** @class */
        function() {
          function Parser3(tokenVocabulary, config) {
            this.definitionErrors = [];
            this.selfAnalysisDone = false;
            var that = this;
            that.initErrorHandler(config);
            that.initLexerAdapter();
            that.initLooksAhead(config);
            that.initRecognizerEngine(tokenVocabulary, config);
            that.initRecoverable(config);
            that.initTreeBuilder(config);
            that.initContentAssist();
            that.initGastRecorder(config);
            that.initPerformanceTracer(config);
            if ((0, has_1.default)(config, "ignoredIssues")) {
              throw new Error("The <ignoredIssues> IParserConfig property has been deprecated.\n	Please use the <IGNORE_AMBIGUITIES> flag on the relevant DSL method instead.\n	See: https://chevrotain.io/docs/guide/resolving_grammar_errors.html#IGNORING_AMBIGUITIES\n	For further details.");
            }
            this.skipValidations = (0, has_1.default)(config, "skipValidations") ? config.skipValidations : exports2.DEFAULT_PARSER_CONFIG.skipValidations;
          }
          Parser3.performSelfAnalysis = function(parserInstance) {
            throw Error("The **static** `performSelfAnalysis` method has been deprecated.	\nUse the **instance** method with the same name instead.");
          };
          Parser3.prototype.performSelfAnalysis = function() {
            var _this = this;
            this.TRACE_INIT("performSelfAnalysis", function() {
              var defErrorsMsgs;
              _this.selfAnalysisDone = true;
              var className = _this.className;
              _this.TRACE_INIT("toFastProps", function() {
                (0, utils_1.toFastProperties)(_this);
              });
              _this.TRACE_INIT("Grammar Recording", function() {
                try {
                  _this.enableRecording();
                  (0, forEach_1.default)(_this.definedRulesNames, function(currRuleName) {
                    var wrappedRule = _this[currRuleName];
                    var originalGrammarAction = wrappedRule["originalGrammarAction"];
                    var recordedRuleGast;
                    _this.TRACE_INIT("".concat(currRuleName, " Rule"), function() {
                      recordedRuleGast = _this.topLevelRuleRecord(currRuleName, originalGrammarAction);
                    });
                    _this.gastProductionsCache[currRuleName] = recordedRuleGast;
                  });
                } finally {
                  _this.disableRecording();
                }
              });
              var resolverErrors = [];
              _this.TRACE_INIT("Grammar Resolving", function() {
                resolverErrors = (0, gast_resolver_public_1.resolveGrammar)({
                  rules: (0, values_1.default)(_this.gastProductionsCache)
                });
                _this.definitionErrors = _this.definitionErrors.concat(resolverErrors);
              });
              _this.TRACE_INIT("Grammar Validations", function() {
                if ((0, isEmpty_1.default)(resolverErrors) && _this.skipValidations === false) {
                  var validationErrors = (0, gast_resolver_public_1.validateGrammar)({
                    rules: (0, values_1.default)(_this.gastProductionsCache),
                    tokenTypes: (0, values_1.default)(_this.tokensMap),
                    errMsgProvider: errors_public_1.defaultGrammarValidatorErrorProvider,
                    grammarName: className
                  });
                  var lookaheadValidationErrors = (0, checks_1.validateLookahead)({
                    lookaheadStrategy: _this.lookaheadStrategy,
                    rules: (0, values_1.default)(_this.gastProductionsCache),
                    tokenTypes: (0, values_1.default)(_this.tokensMap),
                    grammarName: className
                  });
                  _this.definitionErrors = _this.definitionErrors.concat(validationErrors, lookaheadValidationErrors);
                }
              });
              if ((0, isEmpty_1.default)(_this.definitionErrors)) {
                if (_this.recoveryEnabled) {
                  _this.TRACE_INIT("computeAllProdsFollows", function() {
                    var allFollows = (0, follow_1.computeAllProdsFollows)((0, values_1.default)(_this.gastProductionsCache));
                    _this.resyncFollows = allFollows;
                  });
                }
                _this.TRACE_INIT("ComputeLookaheadFunctions", function() {
                  var _a6, _b3;
                  (_b3 = (_a6 = _this.lookaheadStrategy).initialize) === null || _b3 === void 0 ? void 0 : _b3.call(_a6, {
                    rules: (0, values_1.default)(_this.gastProductionsCache)
                  });
                  _this.preComputeLookaheadFunctions((0, values_1.default)(_this.gastProductionsCache));
                });
              }
              if (!Parser3.DEFER_DEFINITION_ERRORS_HANDLING && !(0, isEmpty_1.default)(_this.definitionErrors)) {
                defErrorsMsgs = (0, map_1.default)(_this.definitionErrors, function(defError) {
                  return defError.message;
                });
                throw new Error("Parser Definition Errors detected:\n ".concat(defErrorsMsgs.join("\n-------------------------------\n")));
              }
            });
          };
          Parser3.DEFER_DEFINITION_ERRORS_HANDLING = false;
          return Parser3;
        }()
      );
      exports2.Parser = Parser2;
      (0, apply_mixins_1.applyMixins)(Parser2, [
        recoverable_1.Recoverable,
        looksahead_1.LooksAhead,
        tree_builder_1.TreeBuilder,
        lexer_adapter_1.LexerAdapter,
        recognizer_engine_1.RecognizerEngine,
        recognizer_api_1.RecognizerApi,
        error_handler_1.ErrorHandler,
        context_assist_1.ContentAssist,
        gast_recorder_1.GastRecorder,
        perf_tracer_1.PerformanceTracer
      ]);
      var CstParser2 = (
        /** @class */
        function(_super) {
          __extends(CstParser3, _super);
          function CstParser3(tokenVocabulary, config) {
            if (config === void 0) {
              config = exports2.DEFAULT_PARSER_CONFIG;
            }
            var configClone = (0, clone_1.default)(config);
            configClone.outputCst = true;
            return _super.call(this, tokenVocabulary, configClone) || this;
          }
          return CstParser3;
        }(Parser2)
      );
      exports2.CstParser = CstParser2;
      var EmbeddedActionsParser2 = (
        /** @class */
        function(_super) {
          __extends(EmbeddedActionsParser3, _super);
          function EmbeddedActionsParser3(tokenVocabulary, config) {
            if (config === void 0) {
              config = exports2.DEFAULT_PARSER_CONFIG;
            }
            var configClone = (0, clone_1.default)(config);
            configClone.outputCst = false;
            return _super.call(this, tokenVocabulary, configClone) || this;
          }
          return EmbeddedActionsParser3;
        }(Parser2)
      );
      exports2.EmbeddedActionsParser = EmbeddedActionsParser2;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+cst-dts-gen@10.5.0/node_modules/@chevrotain/cst-dts-gen/lib/src/model.js
  var require_model2 = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+cst-dts-gen@10.5.0/node_modules/@chevrotain/cst-dts-gen/lib/src/model.js"(exports2) {
      "use strict";
      var __extends = exports2 && exports2.__extends || /* @__PURE__ */ function() {
        var extendStatics = function(d, b) {
          extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b3) {
            d2.__proto__ = b3;
          } || function(d2, b3) {
            for (var p12 in b3) if (Object.prototype.hasOwnProperty.call(b3, p12)) d2[p12] = b3[p12];
          };
          return extendStatics(d, b);
        };
        return function(d, b) {
          if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.buildModel = void 0;
      var gast_1 = require_api2();
      var map_1 = __importDefault(require_map());
      var flatten_1 = __importDefault(require_flatten());
      var values_1 = __importDefault(require_values());
      var some_1 = __importDefault(require_some());
      var groupBy_1 = __importDefault(require_groupBy());
      var assign_1 = __importDefault(require_assign());
      function buildModel(productions) {
        var generator = new CstNodeDefinitionGenerator();
        var allRules = (0, values_1.default)(productions);
        return (0, map_1.default)(allRules, function(rule) {
          return generator.visitRule(rule);
        });
      }
      exports2.buildModel = buildModel;
      var CstNodeDefinitionGenerator = (
        /** @class */
        function(_super) {
          __extends(CstNodeDefinitionGenerator2, _super);
          function CstNodeDefinitionGenerator2() {
            return _super !== null && _super.apply(this, arguments) || this;
          }
          CstNodeDefinitionGenerator2.prototype.visitRule = function(node) {
            var rawElements = this.visitEach(node.definition);
            var grouped = (0, groupBy_1.default)(rawElements, function(el) {
              return el.propertyName;
            });
            var properties = (0, map_1.default)(grouped, function(group, propertyName) {
              var allNullable = !(0, some_1.default)(group, function(el) {
                return !el.canBeNull;
              });
              var propertyType = group[0].type;
              if (group.length > 1) {
                propertyType = (0, map_1.default)(group, function(g) {
                  return g.type;
                });
              }
              return {
                name: propertyName,
                type: propertyType,
                optional: allNullable
              };
            });
            return {
              name: node.name,
              properties
            };
          };
          CstNodeDefinitionGenerator2.prototype.visitAlternative = function(node) {
            return this.visitEachAndOverrideWith(node.definition, { canBeNull: true });
          };
          CstNodeDefinitionGenerator2.prototype.visitOption = function(node) {
            return this.visitEachAndOverrideWith(node.definition, { canBeNull: true });
          };
          CstNodeDefinitionGenerator2.prototype.visitRepetition = function(node) {
            return this.visitEachAndOverrideWith(node.definition, { canBeNull: true });
          };
          CstNodeDefinitionGenerator2.prototype.visitRepetitionMandatory = function(node) {
            return this.visitEach(node.definition);
          };
          CstNodeDefinitionGenerator2.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
            return this.visitEach(node.definition).concat({
              propertyName: node.separator.name,
              canBeNull: true,
              type: getType2(node.separator)
            });
          };
          CstNodeDefinitionGenerator2.prototype.visitRepetitionWithSeparator = function(node) {
            return this.visitEachAndOverrideWith(node.definition, {
              canBeNull: true
            }).concat({
              propertyName: node.separator.name,
              canBeNull: true,
              type: getType2(node.separator)
            });
          };
          CstNodeDefinitionGenerator2.prototype.visitAlternation = function(node) {
            return this.visitEachAndOverrideWith(node.definition, { canBeNull: true });
          };
          CstNodeDefinitionGenerator2.prototype.visitTerminal = function(node) {
            return [
              {
                propertyName: node.label || node.terminalType.name,
                canBeNull: false,
                type: getType2(node)
              }
            ];
          };
          CstNodeDefinitionGenerator2.prototype.visitNonTerminal = function(node) {
            return [
              {
                propertyName: node.label || node.nonTerminalName,
                canBeNull: false,
                type: getType2(node)
              }
            ];
          };
          CstNodeDefinitionGenerator2.prototype.visitEachAndOverrideWith = function(definition, override) {
            return (0, map_1.default)(this.visitEach(definition), function(definition2) {
              return (0, assign_1.default)({}, definition2, override);
            });
          };
          CstNodeDefinitionGenerator2.prototype.visitEach = function(definition) {
            var _this = this;
            return (0, flatten_1.default)((0, map_1.default)(definition, function(definition2) {
              return _this.visit(definition2);
            }));
          };
          return CstNodeDefinitionGenerator2;
        }(gast_1.GAstVisitor)
      );
      function getType2(production) {
        if (production instanceof gast_1.NonTerminal) {
          return {
            kind: "rule",
            name: production.referencedRule.name
          };
        }
        return { kind: "token" };
      }
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js
  var require_castSlice = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_castSlice.js"(exports2, module2) {
      var baseSlice = require_baseSlice();
      function castSlice(array, start, end) {
        var length2 = array.length;
        end = end === void 0 ? length2 : end;
        return !start && end >= length2 ? array : baseSlice(array, start, end);
      }
      module2.exports = castSlice;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js
  var require_hasUnicode = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_hasUnicode.js"(exports2, module2) {
      var rsAstralRange = "\\ud800-\\udfff";
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsVarRange = "\\ufe0e\\ufe0f";
      var rsZWJ = "\\u200d";
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      module2.exports = hasUnicode;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js
  var require_asciiToArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_asciiToArray.js"(exports2, module2) {
      function asciiToArray(string) {
        return string.split("");
      }
      module2.exports = asciiToArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js
  var require_unicodeToArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_unicodeToArray.js"(exports2, module2) {
      var rsAstralRange = "\\ud800-\\udfff";
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsVarRange = "\\ufe0e\\ufe0f";
      var rsAstral = "[" + rsAstralRange + "]";
      var rsCombo = "[" + rsComboRange + "]";
      var rsFitz = "\\ud83c[\\udffb-\\udfff]";
      var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
      var rsNonAstral = "[^" + rsAstralRange + "]";
      var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
      var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
      var rsZWJ = "\\u200d";
      var reOptMod = rsModifier + "?";
      var rsOptVar = "[" + rsVarRange + "]?";
      var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
      var rsSeq = rsOptVar + reOptMod + rsOptJoin;
      var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      module2.exports = unicodeToArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js
  var require_stringToArray = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_stringToArray.js"(exports2, module2) {
      var asciiToArray = require_asciiToArray();
      var hasUnicode = require_hasUnicode();
      var unicodeToArray = require_unicodeToArray();
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      module2.exports = stringToArray;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createCaseFirst.js
  var require_createCaseFirst = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/_createCaseFirst.js"(exports2, module2) {
      var castSlice = require_castSlice();
      var hasUnicode = require_hasUnicode();
      var stringToArray = require_stringToArray();
      var toString3 = require_toString();
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString3(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      module2.exports = createCaseFirst;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/upperFirst.js
  var require_upperFirst = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/upperFirst.js"(exports2, module2) {
      var createCaseFirst = require_createCaseFirst();
      var upperFirst = createCaseFirst("toUpperCase");
      module2.exports = upperFirst;
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+cst-dts-gen@10.5.0/node_modules/@chevrotain/cst-dts-gen/lib/src/generate.js
  var require_generate = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+cst-dts-gen@10.5.0/node_modules/@chevrotain/cst-dts-gen/lib/src/generate.js"(exports2) {
      "use strict";
      var __importDefault = exports2 && exports2.__importDefault || function(mod3) {
        return mod3 && mod3.__esModule ? mod3 : { "default": mod3 };
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.genDts = void 0;
      var flatten_1 = __importDefault(require_flatten());
      var isArray_1 = __importDefault(require_isArray());
      var map_1 = __importDefault(require_map());
      var reduce_1 = __importDefault(require_reduce());
      var uniq_1 = __importDefault(require_uniq());
      var upperFirst_1 = __importDefault(require_upperFirst());
      function genDts(model, options) {
        var contentParts = [];
        contentParts = contentParts.concat('import type { CstNode, ICstVisitor, IToken } from "chevrotain";');
        contentParts = contentParts.concat((0, flatten_1.default)((0, map_1.default)(model, function(node) {
          return genCstNodeTypes(node);
        })));
        if (options.includeVisitorInterface) {
          contentParts = contentParts.concat(genVisitor(options.visitorInterfaceName, model));
        }
        return contentParts.join("\n\n") + "\n";
      }
      exports2.genDts = genDts;
      function genCstNodeTypes(node) {
        var nodeCstInterface = genNodeInterface(node);
        var nodeChildrenInterface = genNodeChildrenType(node);
        return [nodeCstInterface, nodeChildrenInterface];
      }
      function genNodeInterface(node) {
        var nodeInterfaceName = getNodeInterfaceName(node.name);
        var childrenTypeName = getNodeChildrenTypeName(node.name);
        return "export interface ".concat(nodeInterfaceName, ' extends CstNode {\n  name: "').concat(node.name, '";\n  children: ').concat(childrenTypeName, ";\n}");
      }
      function genNodeChildrenType(node) {
        var typeName = getNodeChildrenTypeName(node.name);
        return "export type ".concat(typeName, " = {\n  ").concat((0, map_1.default)(node.properties, function(property) {
          return genChildProperty(property);
        }).join("\n  "), "\n};");
      }
      function genChildProperty(prop) {
        var typeName = buildTypeString(prop.type);
        return "".concat(prop.name).concat(prop.optional ? "?" : "", ": ").concat(typeName, "[];");
      }
      function genVisitor(name2, nodes) {
        return "export interface ".concat(name2, "<IN, OUT> extends ICstVisitor<IN, OUT> {\n  ").concat((0, map_1.default)(nodes, function(node) {
          return genVisitorFunction(node);
        }).join("\n  "), "\n}");
      }
      function genVisitorFunction(node) {
        var childrenTypeName = getNodeChildrenTypeName(node.name);
        return "".concat(node.name, "(children: ").concat(childrenTypeName, ", param?: IN): OUT;");
      }
      function buildTypeString(type) {
        if ((0, isArray_1.default)(type)) {
          var typeNames2 = (0, uniq_1.default)((0, map_1.default)(type, function(t2) {
            return getTypeString(t2);
          }));
          var typeString = (0, reduce_1.default)(typeNames2, function(sum, t2) {
            return sum + " | " + t2;
          });
          return "(" + typeString + ")";
        } else {
          return getTypeString(type);
        }
      }
      function getTypeString(type) {
        if (type.kind === "token") {
          return "IToken";
        }
        return getNodeInterfaceName(type.name);
      }
      function getNodeInterfaceName(ruleName) {
        return (0, upperFirst_1.default)(ruleName) + "CstNode";
      }
      function getNodeChildrenTypeName(ruleName) {
        return (0, upperFirst_1.default)(ruleName) + "CstChildren";
      }
    }
  });

  // ../../node_modules/.pnpm/@chevrotain+cst-dts-gen@10.5.0/node_modules/@chevrotain/cst-dts-gen/lib/src/api.js
  var require_api3 = __commonJS({
    "../../node_modules/.pnpm/@chevrotain+cst-dts-gen@10.5.0/node_modules/@chevrotain/cst-dts-gen/lib/src/api.js"(exports2) {
      "use strict";
      var __assign = exports2 && exports2.__assign || function() {
        __assign = Object.assign || function(t2) {
          for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
            s2 = arguments[i2];
            for (var p12 in s2) if (Object.prototype.hasOwnProperty.call(s2, p12))
              t2[p12] = s2[p12];
          }
          return t2;
        };
        return __assign.apply(this, arguments);
      };
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.generateCstDts = void 0;
      var model_1 = require_model2();
      var generate_1 = require_generate();
      var defaultOptions = {
        includeVisitorInterface: true,
        visitorInterfaceName: "ICstNodeVisitor"
      };
      function generateCstDts2(productions, options) {
        var effectiveOptions = __assign(__assign({}, defaultOptions), options);
        var model = (0, model_1.buildModel)(productions);
        return (0, generate_1.genDts)(model, effectiveOptions);
      }
      exports2.generateCstDts = generateCstDts2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/diagrams/render_public.js
  var require_render_public = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/diagrams/render_public.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.createSyntaxDiagramsCode = void 0;
      var version_1 = require_version();
      function createSyntaxDiagramsCode2(grammar, _a6) {
        var _b3 = _a6 === void 0 ? {} : _a6, _c2 = _b3.resourceBase, resourceBase = _c2 === void 0 ? "https://unpkg.com/chevrotain@".concat(version_1.VERSION, "/diagrams/") : _c2, _d = _b3.css, css = _d === void 0 ? "https://unpkg.com/chevrotain@".concat(version_1.VERSION, "/diagrams/diagrams.css") : _d;
        var header = '\n<!-- This is a generated file -->\n<!DOCTYPE html>\n<meta charset="utf-8">\n<style>\n  body {\n    background-color: hsl(30, 20%, 95%)\n  }\n</style>\n\n';
        var cssHtml = "\n<link rel='stylesheet' href='".concat(css, "'>\n");
        var scripts = "\n<script src='".concat(resourceBase, "vendor/railroad-diagrams.js'><\/script>\n<script src='").concat(resourceBase, "src/diagrams_builder.js'><\/script>\n<script src='").concat(resourceBase, "src/diagrams_behavior.js'><\/script>\n<script src='").concat(resourceBase, "src/main.js'><\/script>\n");
        var diagramsDiv = '\n<div id="diagrams" align="center"></div>    \n';
        var serializedGrammar = "\n<script>\n    window.serializedGrammar = ".concat(JSON.stringify(grammar, null, "  "), ";\n<\/script>\n");
        var initLogic = '\n<script>\n    var diagramsDiv = document.getElementById("diagrams");\n    main.drawDiagramsFromSerializedGrammar(serializedGrammar, diagramsDiv);\n<\/script>\n';
        return header + cssHtml + scripts + diagramsDiv + serializedGrammar + initLogic;
      }
      exports2.createSyntaxDiagramsCode = createSyntaxDiagramsCode2;
    }
  });

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/api.js
  var require_api4 = __commonJS({
    "../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib/src/api.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.Parser = exports2.createSyntaxDiagramsCode = exports2.clearCache = exports2.generateCstDts = exports2.GAstVisitor = exports2.serializeProduction = exports2.serializeGrammar = exports2.Terminal = exports2.Rule = exports2.RepetitionWithSeparator = exports2.RepetitionMandatoryWithSeparator = exports2.RepetitionMandatory = exports2.Repetition = exports2.Option = exports2.NonTerminal = exports2.Alternative = exports2.Alternation = exports2.defaultLexerErrorProvider = exports2.NoViableAltException = exports2.NotAllInputParsedException = exports2.MismatchedTokenException = exports2.isRecognitionException = exports2.EarlyExitException = exports2.defaultParserErrorProvider = exports2.LLkLookaheadStrategy = exports2.getLookaheadPaths = exports2.tokenName = exports2.tokenMatcher = exports2.tokenLabel = exports2.EOF = exports2.createTokenInstance = exports2.createToken = exports2.LexerDefinitionErrorType = exports2.Lexer = exports2.EMPTY_ALT = exports2.ParserDefinitionErrorType = exports2.EmbeddedActionsParser = exports2.CstParser = exports2.VERSION = void 0;
      var version_1 = require_version();
      Object.defineProperty(exports2, "VERSION", { enumerable: true, get: function() {
        return version_1.VERSION;
      } });
      var parser_1 = require_parser();
      Object.defineProperty(exports2, "CstParser", { enumerable: true, get: function() {
        return parser_1.CstParser;
      } });
      Object.defineProperty(exports2, "EmbeddedActionsParser", { enumerable: true, get: function() {
        return parser_1.EmbeddedActionsParser;
      } });
      Object.defineProperty(exports2, "ParserDefinitionErrorType", { enumerable: true, get: function() {
        return parser_1.ParserDefinitionErrorType;
      } });
      Object.defineProperty(exports2, "EMPTY_ALT", { enumerable: true, get: function() {
        return parser_1.EMPTY_ALT;
      } });
      var lexer_public_1 = require_lexer_public();
      Object.defineProperty(exports2, "Lexer", { enumerable: true, get: function() {
        return lexer_public_1.Lexer;
      } });
      Object.defineProperty(exports2, "LexerDefinitionErrorType", { enumerable: true, get: function() {
        return lexer_public_1.LexerDefinitionErrorType;
      } });
      var tokens_public_1 = require_tokens_public();
      Object.defineProperty(exports2, "createToken", { enumerable: true, get: function() {
        return tokens_public_1.createToken;
      } });
      Object.defineProperty(exports2, "createTokenInstance", { enumerable: true, get: function() {
        return tokens_public_1.createTokenInstance;
      } });
      Object.defineProperty(exports2, "EOF", { enumerable: true, get: function() {
        return tokens_public_1.EOF;
      } });
      Object.defineProperty(exports2, "tokenLabel", { enumerable: true, get: function() {
        return tokens_public_1.tokenLabel;
      } });
      Object.defineProperty(exports2, "tokenMatcher", { enumerable: true, get: function() {
        return tokens_public_1.tokenMatcher;
      } });
      Object.defineProperty(exports2, "tokenName", { enumerable: true, get: function() {
        return tokens_public_1.tokenName;
      } });
      var lookahead_1 = require_lookahead();
      Object.defineProperty(exports2, "getLookaheadPaths", { enumerable: true, get: function() {
        return lookahead_1.getLookaheadPaths;
      } });
      var llk_lookahead_1 = require_llk_lookahead();
      Object.defineProperty(exports2, "LLkLookaheadStrategy", { enumerable: true, get: function() {
        return llk_lookahead_1.LLkLookaheadStrategy;
      } });
      var errors_public_1 = require_errors_public();
      Object.defineProperty(exports2, "defaultParserErrorProvider", { enumerable: true, get: function() {
        return errors_public_1.defaultParserErrorProvider;
      } });
      var exceptions_public_1 = require_exceptions_public();
      Object.defineProperty(exports2, "EarlyExitException", { enumerable: true, get: function() {
        return exceptions_public_1.EarlyExitException;
      } });
      Object.defineProperty(exports2, "isRecognitionException", { enumerable: true, get: function() {
        return exceptions_public_1.isRecognitionException;
      } });
      Object.defineProperty(exports2, "MismatchedTokenException", { enumerable: true, get: function() {
        return exceptions_public_1.MismatchedTokenException;
      } });
      Object.defineProperty(exports2, "NotAllInputParsedException", { enumerable: true, get: function() {
        return exceptions_public_1.NotAllInputParsedException;
      } });
      Object.defineProperty(exports2, "NoViableAltException", { enumerable: true, get: function() {
        return exceptions_public_1.NoViableAltException;
      } });
      var lexer_errors_public_1 = require_lexer_errors_public();
      Object.defineProperty(exports2, "defaultLexerErrorProvider", { enumerable: true, get: function() {
        return lexer_errors_public_1.defaultLexerErrorProvider;
      } });
      var gast_1 = require_api2();
      Object.defineProperty(exports2, "Alternation", { enumerable: true, get: function() {
        return gast_1.Alternation;
      } });
      Object.defineProperty(exports2, "Alternative", { enumerable: true, get: function() {
        return gast_1.Alternative;
      } });
      Object.defineProperty(exports2, "NonTerminal", { enumerable: true, get: function() {
        return gast_1.NonTerminal;
      } });
      Object.defineProperty(exports2, "Option", { enumerable: true, get: function() {
        return gast_1.Option;
      } });
      Object.defineProperty(exports2, "Repetition", { enumerable: true, get: function() {
        return gast_1.Repetition;
      } });
      Object.defineProperty(exports2, "RepetitionMandatory", { enumerable: true, get: function() {
        return gast_1.RepetitionMandatory;
      } });
      Object.defineProperty(exports2, "RepetitionMandatoryWithSeparator", { enumerable: true, get: function() {
        return gast_1.RepetitionMandatoryWithSeparator;
      } });
      Object.defineProperty(exports2, "RepetitionWithSeparator", { enumerable: true, get: function() {
        return gast_1.RepetitionWithSeparator;
      } });
      Object.defineProperty(exports2, "Rule", { enumerable: true, get: function() {
        return gast_1.Rule;
      } });
      Object.defineProperty(exports2, "Terminal", { enumerable: true, get: function() {
        return gast_1.Terminal;
      } });
      var gast_2 = require_api2();
      Object.defineProperty(exports2, "serializeGrammar", { enumerable: true, get: function() {
        return gast_2.serializeGrammar;
      } });
      Object.defineProperty(exports2, "serializeProduction", { enumerable: true, get: function() {
        return gast_2.serializeProduction;
      } });
      Object.defineProperty(exports2, "GAstVisitor", { enumerable: true, get: function() {
        return gast_2.GAstVisitor;
      } });
      var cst_dts_gen_1 = require_api3();
      Object.defineProperty(exports2, "generateCstDts", { enumerable: true, get: function() {
        return cst_dts_gen_1.generateCstDts;
      } });
      function clearCache2() {
        console.warn("The clearCache function was 'soft' removed from the Chevrotain API.\n	 It performs no action other than printing this message.\n	 Please avoid using it as it will be completely removed in the future");
      }
      exports2.clearCache = clearCache2;
      var render_public_1 = require_render_public();
      Object.defineProperty(exports2, "createSyntaxDiagramsCode", { enumerable: true, get: function() {
        return render_public_1.createSyntaxDiagramsCode;
      } });
      var Parser2 = (
        /** @class */
        /* @__PURE__ */ function() {
          function Parser3() {
            throw new Error("The Parser class has been deprecated, use CstParser or EmbeddedActionsParser instead.	\nSee: https://chevrotain.io/docs/changes/BREAKING_CHANGES.html#_7-0-0");
          }
          return Parser3;
        }()
      );
      exports2.Parser = Parser2;
    }
  });

  // ../../node_modules/.pnpm/eventemitter3@5.0.1/node_modules/eventemitter3/index.js
  var require_eventemitter3 = __commonJS({
    "../../node_modules/.pnpm/eventemitter3@5.0.1/node_modules/eventemitter3/index.js"(exports2, module2) {
      "use strict";
      var has = Object.prototype.hasOwnProperty;
      var prefix = "~";
      function Events() {
      }
      if (Object.create) {
        Events.prototype = /* @__PURE__ */ Object.create(null);
        if (!new Events().__proto__) prefix = false;
      }
      function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
      }
      function addListener(emitter, event, fn, context, once) {
        if (typeof fn !== "function") {
          throw new TypeError("The listener must be a function");
        }
        var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
        if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
        else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
        else emitter._events[evt] = [emitter._events[evt], listener];
        return emitter;
      }
      function clearEvent(emitter, evt) {
        if (--emitter._eventsCount === 0) emitter._events = new Events();
        else delete emitter._events[evt];
      }
      function EventEmitter4() {
        this._events = new Events();
        this._eventsCount = 0;
      }
      EventEmitter4.prototype.eventNames = function eventNames() {
        var names = [], events, name2;
        if (this._eventsCount === 0) return names;
        for (name2 in events = this._events) {
          if (has.call(events, name2)) names.push(prefix ? name2.slice(1) : name2);
        }
        if (Object.getOwnPropertySymbols) {
          return names.concat(Object.getOwnPropertySymbols(events));
        }
        return names;
      };
      EventEmitter4.prototype.listeners = function listeners(event) {
        var evt = prefix ? prefix + event : event, handlers = this._events[evt];
        if (!handlers) return [];
        if (handlers.fn) return [handlers.fn];
        for (var i2 = 0, l = handlers.length, ee = new Array(l); i2 < l; i2++) {
          ee[i2] = handlers[i2].fn;
        }
        return ee;
      };
      EventEmitter4.prototype.listenerCount = function listenerCount(event) {
        var evt = prefix ? prefix + event : event, listeners = this._events[evt];
        if (!listeners) return 0;
        if (listeners.fn) return 1;
        return listeners.length;
      };
      EventEmitter4.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return false;
        var listeners = this._events[evt], len = arguments.length, args, i2;
        if (listeners.fn) {
          if (listeners.once) this.removeListener(event, listeners.fn, void 0, true);
          switch (len) {
            case 1:
              return listeners.fn.call(listeners.context), true;
            case 2:
              return listeners.fn.call(listeners.context, a1), true;
            case 3:
              return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
              return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
          }
          for (i2 = 1, args = new Array(len - 1); i2 < len; i2++) {
            args[i2 - 1] = arguments[i2];
          }
          listeners.fn.apply(listeners.context, args);
        } else {
          var length2 = listeners.length, j;
          for (i2 = 0; i2 < length2; i2++) {
            if (listeners[i2].once) this.removeListener(event, listeners[i2].fn, void 0, true);
            switch (len) {
              case 1:
                listeners[i2].fn.call(listeners[i2].context);
                break;
              case 2:
                listeners[i2].fn.call(listeners[i2].context, a1);
                break;
              case 3:
                listeners[i2].fn.call(listeners[i2].context, a1, a2);
                break;
              case 4:
                listeners[i2].fn.call(listeners[i2].context, a1, a2, a3);
                break;
              default:
                if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }
                listeners[i2].fn.apply(listeners[i2].context, args);
            }
          }
        }
        return true;
      };
      EventEmitter4.prototype.on = function on(event, fn, context) {
        return addListener(this, event, fn, context, false);
      };
      EventEmitter4.prototype.once = function once(event, fn, context) {
        return addListener(this, event, fn, context, true);
      };
      EventEmitter4.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;
        if (!this._events[evt]) return this;
        if (!fn) {
          clearEvent(this, evt);
          return this;
        }
        var listeners = this._events[evt];
        if (listeners.fn) {
          if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
            clearEvent(this, evt);
          }
        } else {
          for (var i2 = 0, events = [], length2 = listeners.length; i2 < length2; i2++) {
            if (listeners[i2].fn !== fn || once && !listeners[i2].once || context && listeners[i2].context !== context) {
              events.push(listeners[i2]);
            }
          }
          if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
          else clearEvent(this, evt);
        }
        return this;
      };
      EventEmitter4.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;
        if (event) {
          evt = prefix ? prefix + event : event;
          if (this._events[evt]) clearEvent(this, evt);
        } else {
          this._events = new Events();
          this._eventsCount = 0;
        }
        return this;
      };
      EventEmitter4.prototype.off = EventEmitter4.prototype.removeListener;
      EventEmitter4.prototype.addListener = EventEmitter4.prototype.on;
      EventEmitter4.prefixed = prefix;
      EventEmitter4.EventEmitter = EventEmitter4;
      if ("undefined" !== typeof module2) {
        module2.exports = EventEmitter4;
      }
    }
  });

  // ../../node_modules/.pnpm/eventemitter3@5.0.1/node_modules/eventemitter3/index.mjs
  var import_index;
  var init_eventemitter3 = __esm({
    "../../node_modules/.pnpm/eventemitter3@5.0.1/node_modules/eventemitter3/index.mjs"() {
      import_index = __toESM(require_eventemitter3(), 1);
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/list.js
  var List;
  var init_list = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/list.js"() {
      init_eventemitter3();
      List = class extends import_index.default {
        [Symbol.toStringTag] = "List";
        constructor(values) {
          super();
          if (values) {
            this.push(...values);
          }
        }
        data = /* @__PURE__ */ new Set();
        toSet() {
          return new Set(this.data);
        }
        toArray() {
          return Array.from(this.data);
        }
        toJSON() {
          return Array.from(this.data);
        }
        toString() {
          return this.join(",");
        }
        _set(index2, value, _delete = false) {
          if (Math.abs(index2) > this.data.size) {
            throw new ReferenceError("Can not set an element outside the bounds of the list");
          }
          const data = Array.from(this.data);
          data.splice(index2, +_delete, value);
          this.data = new Set(data);
          this.emit("update");
        }
        set(index2, value) {
          this._set(index2, value, true);
        }
        deleteAt(index2) {
          if (Math.abs(index2) > this.data.size) {
            throw new ReferenceError("Can not delete an element outside the bounds of the list");
          }
          this.delete(Array.from(this.data).at(index2));
        }
        insert(value, index2 = this.data.size) {
          this._set(index2, value, false);
        }
        // Array methods
        at(index2) {
          if (Math.abs(index2) > this.data.size) {
            throw new ReferenceError("Can not access an element outside the bounds of the list");
          }
          return Array.from(this.data).at(index2);
        }
        pop() {
          const item = Array.from(this.data).pop();
          if (item !== void 0) {
            this.delete(item);
          }
          return item;
        }
        push(...items) {
          for (const item of items) {
            this.add(item);
          }
          return this.data.size;
        }
        join(separator) {
          return Array.from(this.data).join(separator);
        }
        splice(start, deleteCount, ...items) {
          if (Math.abs(start) > this.data.size) {
            throw new ReferenceError("Can not splice elements outside the bounds of the list");
          }
          const data = Array.from(this.data);
          const deleted = data.splice(start, deleteCount, ...items);
          this.data = new Set(data);
          this.emit("update");
          return deleted;
        }
        // Set methods
        add(value) {
          this.data.add(value);
          this.emit("update");
          this.emit("add", value);
          return this;
        }
        clear() {
          this.data.clear();
          this.emit("update");
        }
        delete(value) {
          const success = this.data.delete(value);
          this.emit("update");
          return success;
        }
        has(value) {
          return this.data.has(value);
        }
        get size() {
          return this.data.size;
        }
        // Iteration
        entries() {
          return this.toArray().entries();
        }
        keys() {
          return this.toArray().keys();
        }
        values() {
          return this.data.values();
        }
        [Symbol.iterator]() {
          return this.data[Symbol.iterator]();
        }
      };
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/objects.js
  function filterObject(object, predicate) {
    const entries2 = Object.entries(object);
    return Object.fromEntries(entries2.filter(([key, value]) => predicate(key, value)));
  }
  function pick(object, ...keys) {
    const picked = {};
    for (const key of keys.flat()) {
      picked[key] = object[key];
    }
    return picked;
  }
  function omit(object, ...keys) {
    return filterObject(object, (key) => !keys.flat().includes(key));
  }
  function isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch {
      return false;
    }
  }
  function resolveConstructors(object) {
    const constructors = [];
    for (let prototype3 = object; prototype3 && !["Function", "Object"].includes(prototype3.constructor.name); prototype3 = Object.getPrototypeOf(prototype3)) {
      constructors.push(prototype3.constructor.name);
    }
    return constructors;
  }
  function bindFunctions(fns, thisValue) {
    return Object.fromEntries(Object.entries(fns).map(([k, v]) => [k, typeof v == "function" ? v.bind(thisValue) : v]));
  }
  var init_objects = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/objects.js"() {
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/misc.js
  function canary(error = new Error()) {
    const timeout = setTimeout(() => {
      throw error;
    }, 5e3);
    return () => clearTimeout(timeout);
  }
  function _throw(e2) {
    if (e2 && typeof e2 == "object" && resolveConstructors(e2).includes("Error"))
      Error?.captureStackTrace(e2, _throw);
    throw e2;
  }
  var init_misc = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/misc.js"() {
      init_objects();
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/numbers.js
  var __formatter, formatCompact;
  var init_numbers = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/numbers.js"() {
      __formatter = Intl.NumberFormat("en", { notation: "compact" });
      formatCompact = __formatter.format.bind(__formatter);
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/random.js
  function randomInt(min = 0, max2 = 1) {
    return Math.round(Math.random() * (max2 - min) + min);
  }
  var init_random = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/random.js"() {
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/string.js
  function capitalize(value) {
    return value.at(0).toUpperCase() + value.slice(1);
  }
  function encodeUTF8(input) {
    return encoder.encode(input);
  }
  function decodeUTF8(input) {
    if (!input)
      return "";
    if (input.buffer instanceof ArrayBuffer && !input.buffer.resizable)
      return decoder.decode(input);
    const buffer = new Uint8Array(input.byteLength);
    buffer.set(input);
    return decoder.decode(buffer);
  }
  function decodeUUID(uuid) {
    const hex = Array.from(uuid).map((b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  function encodeUUID(uuid) {
    const hex = uuid.replace(/-/g, "");
    const data = new Uint8Array(16);
    for (let i2 = 0; i2 < 16; i2++) {
      data[i2] = parseInt(hex.slice(i2 * 2, i2 * 2 + 2), 16);
    }
    return data;
  }
  var encoder, decoder;
  var init_string = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/string.js"() {
      encoder = new TextEncoder();
      decoder = new TextDecoder();
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/types.js
  var init_types = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/types.js"() {
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/version.js
  var init_version = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/version.js"() {
      init_string();
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/index.js
  var init_dist = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/index.js"() {
      init_list();
      init_misc();
      init_numbers();
      init_objects();
      init_random();
      init_string();
      init_types();
      init_version();
    }
  });

  // ../../node_modules/.pnpm/kerium@1.3.5/node_modules/kerium/dist/error.js
  function setUVMessage(ex) {
    let message = `${ex.code}: ${errnoMessages[ex.errno]}, ${ex.syscall}`;
    if (ex.path)
      message += ` '${ex.path}'`;
    if (ex.dest)
      message += ` -> '${ex.dest}'`;
    if (ex.message && !ex.message.startsWith(errnoMessages[ex.errno]))
      message += ` (${ex.message})`;
    ex.message = message;
    return ex;
  }
  function UV(code, context, path3, dest) {
    if (typeof context === "string")
      context = { syscall: context, path: path3, dest };
    const err3 = new Exception(Errno[code], false, context ?? {});
    Error.captureStackTrace?.(err3, UV);
    return err3;
  }
  function withErrno(code, message) {
    const err3 = new Exception(Errno[code], message ?? errnoMessages[Errno[code]]);
    Error.captureStackTrace?.(err3, withErrno);
    return err3;
  }
  function rethrow(extra, path3, dest) {
    const ctx = typeof extra === "string" ? { syscall: extra } : extra;
    if (path3)
      ctx.path = path3;
    if (dest)
      ctx.dest = dest;
    return function(e2) {
      Object.assign(e2, ctx);
      setUVMessage(e2);
      throw e2;
    };
  }
  var Errno, errnoMessages, Exception;
  var init_error = __esm({
    "../../node_modules/.pnpm/kerium@1.3.5/node_modules/kerium/dist/error.js"() {
      init_dist();
      (function(Errno2) {
        Errno2[Errno2["EPERM"] = 1] = "EPERM";
        Errno2[Errno2["ENOENT"] = 2] = "ENOENT";
        Errno2[Errno2["ESRCH"] = 3] = "ESRCH";
        Errno2[Errno2["EINTR"] = 4] = "EINTR";
        Errno2[Errno2["EIO"] = 5] = "EIO";
        Errno2[Errno2["ENXIO"] = 6] = "ENXIO";
        Errno2[Errno2["E2BIG"] = 7] = "E2BIG";
        Errno2[Errno2["ENOEXEC"] = 8] = "ENOEXEC";
        Errno2[Errno2["EBADF"] = 9] = "EBADF";
        Errno2[Errno2["ECHILD"] = 10] = "ECHILD";
        Errno2[Errno2["EAGAIN"] = 11] = "EAGAIN";
        Errno2[Errno2["ENOMEM"] = 12] = "ENOMEM";
        Errno2[Errno2["EACCES"] = 13] = "EACCES";
        Errno2[Errno2["EFAULT"] = 14] = "EFAULT";
        Errno2[Errno2["ENOTBLK"] = 15] = "ENOTBLK";
        Errno2[Errno2["EBUSY"] = 16] = "EBUSY";
        Errno2[Errno2["EEXIST"] = 17] = "EEXIST";
        Errno2[Errno2["EXDEV"] = 18] = "EXDEV";
        Errno2[Errno2["ENODEV"] = 19] = "ENODEV";
        Errno2[Errno2["ENOTDIR"] = 20] = "ENOTDIR";
        Errno2[Errno2["EISDIR"] = 21] = "EISDIR";
        Errno2[Errno2["EINVAL"] = 22] = "EINVAL";
        Errno2[Errno2["ENFILE"] = 23] = "ENFILE";
        Errno2[Errno2["EMFILE"] = 24] = "EMFILE";
        Errno2[Errno2["ETXTBSY"] = 26] = "ETXTBSY";
        Errno2[Errno2["EFBIG"] = 27] = "EFBIG";
        Errno2[Errno2["ENOSPC"] = 28] = "ENOSPC";
        Errno2[Errno2["ESPIPE"] = 29] = "ESPIPE";
        Errno2[Errno2["EROFS"] = 30] = "EROFS";
        Errno2[Errno2["EMLINK"] = 31] = "EMLINK";
        Errno2[Errno2["EPIPE"] = 32] = "EPIPE";
        Errno2[Errno2["EDOM"] = 33] = "EDOM";
        Errno2[Errno2["ERANGE"] = 34] = "ERANGE";
        Errno2[Errno2["EDEADLK"] = 35] = "EDEADLK";
        Errno2[Errno2["ENAMETOOLONG"] = 36] = "ENAMETOOLONG";
        Errno2[Errno2["ENOLCK"] = 37] = "ENOLCK";
        Errno2[Errno2["ENOSYS"] = 38] = "ENOSYS";
        Errno2[Errno2["ENOTEMPTY"] = 39] = "ENOTEMPTY";
        Errno2[Errno2["ELOOP"] = 40] = "ELOOP";
        Errno2[Errno2["ENOMSG"] = 42] = "ENOMSG";
        Errno2[Errno2["EIDRM"] = 43] = "EIDRM";
        Errno2[Errno2["ECHRNG"] = 44] = "ECHRNG";
        Errno2[Errno2["EL2NSYNC"] = 45] = "EL2NSYNC";
        Errno2[Errno2["EL3HLT"] = 46] = "EL3HLT";
        Errno2[Errno2["EL3RST"] = 47] = "EL3RST";
        Errno2[Errno2["ENRNG"] = 48] = "ENRNG";
        Errno2[Errno2["EUNATCH"] = 49] = "EUNATCH";
        Errno2[Errno2["ECSI"] = 50] = "ECSI";
        Errno2[Errno2["EL2HLT"] = 51] = "EL2HLT";
        Errno2[Errno2["EBADE"] = 52] = "EBADE";
        Errno2[Errno2["EBADR"] = 53] = "EBADR";
        Errno2[Errno2["EXFULL"] = 54] = "EXFULL";
        Errno2[Errno2["ENOANO"] = 55] = "ENOANO";
        Errno2[Errno2["EBADRQC"] = 56] = "EBADRQC";
        Errno2[Errno2["EBADSLT"] = 57] = "EBADSLT";
        Errno2[Errno2["EBFONT"] = 59] = "EBFONT";
        Errno2[Errno2["ENOSTR"] = 60] = "ENOSTR";
        Errno2[Errno2["ENODATA"] = 61] = "ENODATA";
        Errno2[Errno2["ETIME"] = 62] = "ETIME";
        Errno2[Errno2["ENOSR"] = 63] = "ENOSR";
        Errno2[Errno2["ENONET"] = 64] = "ENONET";
        Errno2[Errno2["ENOPKG"] = 65] = "ENOPKG";
        Errno2[Errno2["EREMOTE"] = 66] = "EREMOTE";
        Errno2[Errno2["ENOLINK"] = 67] = "ENOLINK";
        Errno2[Errno2["EADV"] = 68] = "EADV";
        Errno2[Errno2["ESRMNT"] = 69] = "ESRMNT";
        Errno2[Errno2["ECOMM"] = 70] = "ECOMM";
        Errno2[Errno2["EPROTO"] = 71] = "EPROTO";
        Errno2[Errno2["EMULTIHOP"] = 72] = "EMULTIHOP";
        Errno2[Errno2["EDOTDOT"] = 73] = "EDOTDOT";
        Errno2[Errno2["EBADMSG"] = 74] = "EBADMSG";
        Errno2[Errno2["EOVERFLOW"] = 75] = "EOVERFLOW";
        Errno2[Errno2["ENOTUNIQ"] = 76] = "ENOTUNIQ";
        Errno2[Errno2["EBADFD"] = 77] = "EBADFD";
        Errno2[Errno2["EREMCHG"] = 78] = "EREMCHG";
        Errno2[Errno2["ELIBACC"] = 79] = "ELIBACC";
        Errno2[Errno2["ELIBBAD"] = 80] = "ELIBBAD";
        Errno2[Errno2["ELIBSCN"] = 81] = "ELIBSCN";
        Errno2[Errno2["ELIBMAX"] = 82] = "ELIBMAX";
        Errno2[Errno2["ELIBEXEC"] = 83] = "ELIBEXEC";
        Errno2[Errno2["EILSEQ"] = 84] = "EILSEQ";
        Errno2[Errno2["ERESTART"] = 85] = "ERESTART";
        Errno2[Errno2["ESTRPIPE"] = 86] = "ESTRPIPE";
        Errno2[Errno2["EUSERS"] = 87] = "EUSERS";
        Errno2[Errno2["ENOTSOCK"] = 88] = "ENOTSOCK";
        Errno2[Errno2["EDESTADDRREQ"] = 89] = "EDESTADDRREQ";
        Errno2[Errno2["EMSGSIZE"] = 90] = "EMSGSIZE";
        Errno2[Errno2["EPROTOTYPE"] = 91] = "EPROTOTYPE";
        Errno2[Errno2["ENOPROTOOPT"] = 92] = "ENOPROTOOPT";
        Errno2[Errno2["EPROTONOSUPPORT"] = 93] = "EPROTONOSUPPORT";
        Errno2[Errno2["ESOCKTNOSUPPORT"] = 94] = "ESOCKTNOSUPPORT";
        Errno2[Errno2["ENOTSUP"] = 95] = "ENOTSUP";
        Errno2[Errno2["EPFNOSUPPORT"] = 96] = "EPFNOSUPPORT";
        Errno2[Errno2["EAFNOSUPPORT"] = 97] = "EAFNOSUPPORT";
        Errno2[Errno2["EADDRINUSE"] = 98] = "EADDRINUSE";
        Errno2[Errno2["EADDRNOTAVAIL"] = 99] = "EADDRNOTAVAIL";
        Errno2[Errno2["ENETDOWN"] = 100] = "ENETDOWN";
        Errno2[Errno2["ENETUNREACH"] = 101] = "ENETUNREACH";
        Errno2[Errno2["ENETRESET"] = 102] = "ENETRESET";
        Errno2[Errno2["ECONNABORTED"] = 103] = "ECONNABORTED";
        Errno2[Errno2["ECONNRESET"] = 104] = "ECONNRESET";
        Errno2[Errno2["ENOBUFS"] = 105] = "ENOBUFS";
        Errno2[Errno2["EISCONN"] = 106] = "EISCONN";
        Errno2[Errno2["ENOTCONN"] = 107] = "ENOTCONN";
        Errno2[Errno2["ESHUTDOWN"] = 108] = "ESHUTDOWN";
        Errno2[Errno2["ETOOMANYREFS"] = 109] = "ETOOMANYREFS";
        Errno2[Errno2["ETIMEDOUT"] = 110] = "ETIMEDOUT";
        Errno2[Errno2["ECONNREFUSED"] = 111] = "ECONNREFUSED";
        Errno2[Errno2["EHOSTDOWN"] = 112] = "EHOSTDOWN";
        Errno2[Errno2["EHOSTUNREACH"] = 113] = "EHOSTUNREACH";
        Errno2[Errno2["EALREADY"] = 114] = "EALREADY";
        Errno2[Errno2["EINPROGRESS"] = 115] = "EINPROGRESS";
        Errno2[Errno2["ESTALE"] = 116] = "ESTALE";
        Errno2[Errno2["EEUCLEAN"] = 117] = "EEUCLEAN";
        Errno2[Errno2["ENOTNAM"] = 118] = "ENOTNAM";
        Errno2[Errno2["ENAVAIL"] = 119] = "ENAVAIL";
        Errno2[Errno2["EISNAM"] = 120] = "EISNAM";
        Errno2[Errno2["EREMOTEIO"] = 121] = "EREMOTEIO";
        Errno2[Errno2["EDQUOT"] = 122] = "EDQUOT";
        Errno2[Errno2["ENOMEDIUM"] = 123] = "ENOMEDIUM";
        Errno2[Errno2["EMEDIUMTYPE"] = 124] = "EMEDIUMTYPE";
        Errno2[Errno2["ECANCELED"] = 125] = "ECANCELED";
        Errno2[Errno2["ENOKEY"] = 126] = "ENOKEY";
        Errno2[Errno2["EKEYEXPIRED"] = 127] = "EKEYEXPIRED";
        Errno2[Errno2["EKEYREVOKED"] = 128] = "EKEYREVOKED";
        Errno2[Errno2["EKEYREJECTED"] = 129] = "EKEYREJECTED";
        Errno2[Errno2["EOWNERDEAD"] = 130] = "EOWNERDEAD";
        Errno2[Errno2["ENOTRECOVERABLE"] = 131] = "ENOTRECOVERABLE";
        Errno2[Errno2["ERFKILL"] = 132] = "ERFKILL";
        Errno2[Errno2["EHWPOISON"] = 133] = "EHWPOISON";
      })(Errno || (Errno = {}));
      errnoMessages = {
        [Errno.EPERM]: "Operation not permitted",
        [Errno.ENOENT]: "No such file or directory",
        [Errno.ESRCH]: "No such process",
        [Errno.EINTR]: "Interrupted system call",
        [Errno.EIO]: "Input/output error",
        [Errno.ENXIO]: "No such device or address",
        [Errno.E2BIG]: "Argument list too long",
        [Errno.ENOEXEC]: "Exec format error",
        [Errno.EBADF]: "Bad file descriptor",
        [Errno.ECHILD]: "No child processes",
        [Errno.EAGAIN]: "Resource temporarily unavailable",
        [Errno.ENOMEM]: "Out of memory",
        [Errno.EACCES]: "Permission denied",
        [Errno.EFAULT]: "Bad address",
        [Errno.ENOTBLK]: "Block device required",
        [Errno.EBUSY]: "Resource busy or locked",
        [Errno.EEXIST]: "File exists",
        [Errno.EXDEV]: "Invalid cross-device link",
        [Errno.ENODEV]: "No such device",
        [Errno.ENOTDIR]: "File is not a directory",
        [Errno.EISDIR]: "File is a directory",
        [Errno.EINVAL]: "Invalid argument",
        [Errno.ENFILE]: "Too many open files in system",
        [Errno.EMFILE]: "Too many open files",
        [Errno.ETXTBSY]: "Text file busy",
        [Errno.EFBIG]: "File is too big",
        [Errno.ENOSPC]: "No space left on disk",
        [Errno.ESPIPE]: "Illegal seek",
        [Errno.EROFS]: "Cannot modify a read-only file system",
        [Errno.EMLINK]: "Too many links",
        [Errno.EPIPE]: "Broken pipe",
        [Errno.EDOM]: "Numerical argument out of domain",
        [Errno.ERANGE]: "Numerical result out of range",
        [Errno.EDEADLK]: "Resource deadlock would occur",
        [Errno.ENAMETOOLONG]: "File name too long",
        [Errno.ENOLCK]: "No locks available",
        [Errno.ENOSYS]: "Function not implemented",
        [Errno.ENOTEMPTY]: "Directory is not empty",
        [Errno.ELOOP]: "Too many levels of symbolic links",
        [Errno.ENOMSG]: "No message of desired type",
        [Errno.EIDRM]: "Identifier removed",
        [Errno.ECHRNG]: "Channel number out of range",
        [Errno.EL2NSYNC]: "Level 2 not synchronized",
        [Errno.EL3HLT]: "Level 3 halted",
        [Errno.EL3RST]: "Level 3 reset",
        [Errno.ENRNG]: "Link number out of range",
        [Errno.EUNATCH]: "Protocol driver not attached",
        [Errno.ECSI]: "No CSI structure available",
        [Errno.EL2HLT]: "Level 2 halted",
        [Errno.EBADE]: "Invalid exchange",
        [Errno.EBADR]: "Invalid request descriptor",
        [Errno.EXFULL]: "Exchange full",
        [Errno.ENOANO]: "No anode",
        [Errno.EBADRQC]: "Invalid request code",
        [Errno.EBADSLT]: "Invalid slot",
        [Errno.EBFONT]: "Bad font file format",
        [Errno.ENOSTR]: "Device not a stream",
        [Errno.ENODATA]: "No data available",
        [Errno.ETIME]: "Timer expired",
        [Errno.ENOSR]: "Out of streams resources",
        [Errno.ENONET]: "Machine is not on the network",
        [Errno.ENOPKG]: "Package not installed",
        [Errno.EREMOTE]: "Object is remote",
        [Errno.ENOLINK]: "Link has been severed",
        [Errno.EADV]: "Advertise error",
        [Errno.ESRMNT]: "Srmount error",
        [Errno.ECOMM]: "Communication error on send",
        [Errno.EPROTO]: "Protocol error",
        [Errno.EMULTIHOP]: "Multihop attempted",
        [Errno.EDOTDOT]: "RFS specific error",
        [Errno.EBADMSG]: "Bad message",
        [Errno.EOVERFLOW]: "Value too large for defined data type",
        [Errno.ENOTUNIQ]: "Name not unique on network",
        [Errno.EBADFD]: "File descriptor in bad state",
        [Errno.EREMCHG]: "Remote address changed",
        [Errno.ELIBACC]: "Can not access a needed shared library",
        [Errno.ELIBBAD]: "Accessing a corrupted shared library",
        [Errno.ELIBSCN]: ".lib section in a.out corrupted",
        [Errno.ELIBMAX]: "Attempting to link in too many shared libraries",
        [Errno.ELIBEXEC]: "Cannot exec a shared library directly",
        [Errno.EILSEQ]: "Invalid or incomplete multibyte or wide character",
        [Errno.ERESTART]: "Interrupted system call should be restarted",
        [Errno.ESTRPIPE]: "Streams pipe error",
        [Errno.EUSERS]: "Too many users",
        [Errno.ENOTSOCK]: "Socket operation on non-socket",
        [Errno.EDESTADDRREQ]: "Destination address required",
        [Errno.EMSGSIZE]: "Message too long",
        [Errno.EPROTOTYPE]: "Protocol wrong type for socket",
        [Errno.ENOPROTOOPT]: "Protocol not available",
        [Errno.EPROTONOSUPPORT]: "Protocol not supported",
        [Errno.ESOCKTNOSUPPORT]: "Socket type not supported",
        [Errno.ENOTSUP]: "Operation is not supported",
        [Errno.EPFNOSUPPORT]: "Protocol family not supported",
        [Errno.EAFNOSUPPORT]: "Address family not supported by protocol",
        [Errno.EADDRINUSE]: "Address already in use",
        [Errno.EADDRNOTAVAIL]: "Cannot assign requested address",
        [Errno.ENETDOWN]: "Network is down",
        [Errno.ENETUNREACH]: "Network is unreachable",
        [Errno.ENETRESET]: "Network dropped connection on reset",
        [Errno.ECONNABORTED]: "Software caused connection abort",
        [Errno.ECONNRESET]: "Connection reset by peer",
        [Errno.ENOBUFS]: "No buffer space available",
        [Errno.EISCONN]: "Transport endpoint is already connected",
        [Errno.ENOTCONN]: "Transport endpoint is not connected",
        [Errno.ESHUTDOWN]: "Cannot send after transport endpoint shutdown",
        [Errno.ETOOMANYREFS]: "Too many references: cannot splice",
        [Errno.ETIMEDOUT]: "Connection timed out",
        [Errno.ECONNREFUSED]: "Connection refused",
        [Errno.EHOSTDOWN]: "Host is down",
        [Errno.EHOSTUNREACH]: "No route to host",
        [Errno.EALREADY]: "Operation already in progress",
        [Errno.EINPROGRESS]: "Operation now in progress",
        [Errno.ESTALE]: "Stale file handle",
        [Errno.EEUCLEAN]: "Structure needs cleaning",
        [Errno.ENOTNAM]: "Not a XENIX named type file",
        [Errno.ENAVAIL]: "No XENIX semaphores available",
        [Errno.EISNAM]: "Is a named type file",
        [Errno.EREMOTEIO]: "Remote I/O error",
        [Errno.EDQUOT]: "Disk quota exceeded",
        [Errno.ENOMEDIUM]: "No medium found",
        [Errno.EMEDIUMTYPE]: "Wrong medium type",
        [Errno.ECANCELED]: "Operation canceled",
        [Errno.ENOKEY]: "Required key not available",
        [Errno.EKEYEXPIRED]: "Key has expired",
        [Errno.EKEYREVOKED]: "Key has been revoked",
        [Errno.EKEYREJECTED]: "Key was rejected by service",
        [Errno.EOWNERDEAD]: "Owner died",
        [Errno.ENOTRECOVERABLE]: "State not recoverable",
        [Errno.ERFKILL]: "Operation not possible due to RF-kill",
        [Errno.EHWPOISON]: "Memory page has hardware error"
      };
      Exception = class _Exception extends Error {
        errno;
        code;
        path;
        dest;
        syscall;
        constructor(errno, message, ctx = {}) {
          const code = Errno[errno];
          super(message || "");
          this.errno = errno;
          this.code = code;
          Object.assign(this, omit(ctx, "message"));
          if (!message)
            setUVMessage(this);
          Error.captureStackTrace?.(this, this.constructor);
        }
        toString() {
          return this.message;
        }
        toJSON() {
          const json = {
            errno: this.errno,
            code: this.code,
            stack: this.stack,
            message: this.message
          };
          if (this.path)
            json.path = this.path;
          if (this.dest)
            json.dest = this.dest;
          if (this.syscall)
            json.syscall = this.syscall;
          return json;
        }
        static fromJSON(json) {
          const err3 = json.syscall ? new _Exception(json.errno, false, json) : new _Exception(json.errno, json.message);
          err3.stack = json.stack;
          return err3;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/kerium@1.3.5/node_modules/kerium/dist/log.js
  var log_exports = {};
  __export(log_exports, {
    Level: () => Level,
    alert: () => alert,
    configure: () => configure,
    crit: () => crit,
    debug: () => debug,
    deprecated: () => deprecated,
    emerg: () => emerg,
    entries: () => entries,
    err: () => err,
    fancy: () => fancy,
    format: () => format,
    info: () => info,
    isEnabled: () => isEnabled,
    levelOf: () => levelOf,
    levels: () => levels,
    log: () => log,
    notice: () => notice,
    warn: () => warn
  });
  function levelOf(value) {
    return levels.indexOf(value);
  }
  function log(level2, message) {
    if (!isEnabled)
      return;
    const entry = {
      level: level2,
      message,
      timestamp: /* @__PURE__ */ new Date(),
      elapsedMs: performance.now()
    };
    entries.add(entry);
    output(entry);
  }
  function _shortcut(level2) {
    return function(message) {
      log(level2, message.toString());
      return message;
    };
  }
  function deprecated(symbol2) {
    log(Level.WARN, symbol2 + " is deprecated and should not be used.");
  }
  function ansi(text, format5) {
    return `\x1B[${format5}m${text}\x1B[0m`;
  }
  function _prettyMs(entry, style) {
    const text = "[" + (entry.elapsedMs / 1e3).toFixed(3).padStart(10) + "] ";
    switch (style) {
      case "ansi":
        return [ansi(text, "2;37")];
      case "css":
        return ["%c" + text, "opacity: 0.8; color: white;"];
      default:
        return [text];
    }
  }
  function fancy({ style, colorize }) {
    return function* (entry) {
      yield* _prettyMs(entry, style);
      const levelText = style == "ansi" ? [ansi(levels[entry.level].toUpperCase(), levelColor.ansi[entry.level])] : ["%c" + levels[entry.level].toUpperCase(), levelColor.css[entry.level]];
      if (colorize == "level") {
        yield* levelText;
        yield entry.message;
        return;
      }
      if (entry.level < Level.CRIT) {
        yield* levelText;
        yield ": ";
      }
      if (colorize == "message")
        yield ansi(entry.message, messageColor.ansi[entry.level]);
      else
        yield* ["%c" + entry.message, messageColor.css[entry.level]];
    };
  }
  function format(entry) {
    const formatted = _format(entry);
    return typeof formatted == "string" ? [formatted] : Array.from(formatted);
  }
  function output(entry) {
    if (entry.level > minLevel)
      return;
    _output(...format(entry));
  }
  function configure(options) {
    _format = options.format ?? _format;
    _output = options.output ?? _output;
    minLevel = typeof options.level == "string" ? levelOf(options.level) : options.level ?? minLevel;
    isEnabled = options.enabled ?? isEnabled;
    includeStack = options.stack ?? includeStack;
    if (!options.dumpBacklog)
      return;
    for (const entry of entries) {
      output(entry);
    }
  }
  var Level, levels, entries, emerg, alert, crit, err, warn, notice, info, debug, levelColor, messageColor, _format, _output, minLevel, includeStack, isEnabled;
  var init_log = __esm({
    "../../node_modules/.pnpm/kerium@1.3.5/node_modules/kerium/dist/log.js"() {
      init_dist();
      (function(Level2) {
        Level2[Level2["EMERG"] = 0] = "EMERG";
        Level2[Level2["ALERT"] = 1] = "ALERT";
        Level2[Level2["CRIT"] = 2] = "CRIT";
        Level2[Level2["ERR"] = 3] = "ERR";
        Level2[Level2["WARN"] = 4] = "WARN";
        Level2[Level2["NOTICE"] = 5] = "NOTICE";
        Level2[Level2["INFO"] = 6] = "INFO";
        Level2[Level2["DEBUG"] = 7] = "DEBUG";
      })(Level || (Level = {}));
      levels = [
        "emergency",
        "alert",
        "critical",
        "error",
        "warning",
        "notice",
        "info",
        "debug"
      ];
      entries = new List();
      emerg = _shortcut(Level.EMERG);
      alert = _shortcut(Level.ALERT);
      crit = _shortcut(Level.CRIT);
      err = _shortcut(Level.ERR);
      warn = _shortcut(Level.WARN);
      notice = _shortcut(Level.NOTICE);
      info = _shortcut(Level.INFO);
      debug = _shortcut(Level.DEBUG);
      levelColor = {
        ansi: {
          [Level.EMERG]: "1;4;37;41",
          [Level.ALERT]: "1;37;41",
          [Level.CRIT]: "1;35",
          [Level.ERR]: "1;31",
          [Level.WARN]: "1;33",
          [Level.NOTICE]: "1;36",
          [Level.INFO]: "1;37",
          [Level.DEBUG]: "0;2;37"
        },
        css: {
          [Level.EMERG]: "font-weight: bold; text-decoration: underline; color: white; background-color: red;",
          [Level.ALERT]: "font-weight: bold; color: white; background-color: red;",
          [Level.CRIT]: "font-weight: bold; color: magenta;",
          [Level.ERR]: "font-weight: bold; color: red;",
          [Level.WARN]: "font-weight: bold; color: yellow;",
          [Level.NOTICE]: "font-weight: bold; color: cyan;",
          [Level.INFO]: "font-weight: bold; color: white;",
          [Level.DEBUG]: "opacity: 0.8; color: white;"
        }
      };
      messageColor = {
        ansi: {
          [Level.EMERG]: "1;31",
          [Level.ALERT]: "1;31",
          [Level.CRIT]: "1;31",
          [Level.ERR]: "31",
          [Level.WARN]: "33",
          [Level.NOTICE]: "1;37",
          [Level.INFO]: "37",
          [Level.DEBUG]: "2;37"
        },
        css: {
          [Level.EMERG]: "font-weight: bold; color: red;",
          [Level.ALERT]: "font-weight: bold; color: red;",
          [Level.CRIT]: "font-weight: bold; color: red;",
          [Level.ERR]: "color: red;",
          [Level.WARN]: "color: yellow;",
          [Level.NOTICE]: "font-weight: bold; color: white;",
          [Level.INFO]: "color: white;",
          [Level.DEBUG]: "opacity: 0.8; color: white;"
        }
      };
      _format = (entry) => [..._prettyMs(entry), entry.message];
      _output = console.error;
      minLevel = Level.ALERT;
      includeStack = false;
      isEnabled = true;
    }
  });

  // ../../node_modules/.pnpm/kerium@1.3.5/node_modules/kerium/dist/index.js
  var init_dist2 = __esm({
    "../../node_modules/.pnpm/kerium@1.3.5/node_modules/kerium/dist/index.js"() {
      init_error();
      init_log();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/backend.js
  function isBackend(arg) {
    return arg != null && typeof arg == "object" && "create" in arg && typeof arg.create == "function";
  }
  function _fnOpt(name2, fn) {
    Object.defineProperty(fn, "prototype", { value: void 0 });
    if (name2)
      Object.defineProperty(fn, "name", { value: name2 });
    return fn;
  }
  function checkOptions(backend, options) {
    if (typeof options != "object" || options === null) {
      throw err(withErrno("EINVAL", "Invalid options"));
    }
    for (const [optName, opt] of Object.entries(backend.options)) {
      const value = options === null || options === void 0 ? void 0 : options[optName];
      if (value === void 0 || value === null) {
        if (!opt.required) {
          debug("Using default for option: " + optName);
          continue;
        }
        throw err(withErrno("EINVAL", "Missing required option: " + optName));
      }
      const isType2 = (type2, _2 = value) => {
        var _a6;
        return typeof type2 == "function" ? Symbol.hasInstance in type2 && type2.prototype ? value instanceof type2 : type2(value) : typeof value === type2 || ((_a6 = value === null || value === void 0 ? void 0 : value.constructor) === null || _a6 === void 0 ? void 0 : _a6.name) === type2;
      };
      if (Array.isArray(opt.type) ? opt.type.some((v) => isType2(v)) : isType2(opt.type))
        continue;
      const type = typeof value == "object" && "constructor" in value ? value.constructor.name : typeof value;
      const name2 = (type2) => typeof type2 == "function" ? type2.name != "type" ? type2.name : type2.toString() : type2;
      const expected = Array.isArray(opt.type) ? `one of ${opt.type.map(name2).join(", ")}` : name2(opt.type);
      throw err(withErrno("EINVAL", `Incorrect type for "${optName}": ${type} (expected ${expected})`));
    }
  }
  function isBackendConfig(arg) {
    return arg != null && typeof arg == "object" && "backend" in arg && isBackend(arg.backend);
  }
  var init_backend = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/backend.js"() {
      init_dist2();
      init_log();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/credentials.js
  function createCredentials(source) {
    return {
      suid: source.uid,
      sgid: source.gid,
      euid: source.uid,
      egid: source.gid,
      groups: [],
      ...source
    };
  }
  var init_credentials = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/credentials.js"() {
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/contexts.js
  var defaultContext;
  var init_contexts = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/contexts.js"() {
      init_credentials();
      defaultContext = {
        id: 0,
        root: "/",
        pwd: "/",
        credentials: createCredentials({ uid: 0, gid: 0 }),
        descriptors: /* @__PURE__ */ new Map(),
        parent: null,
        children: []
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/constants.js
  var constants_exports = {};
  __export(constants_exports, {
    COPYFILE_EXCL: () => COPYFILE_EXCL,
    COPYFILE_FICLONE: () => COPYFILE_FICLONE,
    COPYFILE_FICLONE_FORCE: () => COPYFILE_FICLONE_FORCE,
    F_OK: () => F_OK,
    O_APPEND: () => O_APPEND,
    O_CREAT: () => O_CREAT,
    O_DIRECT: () => O_DIRECT,
    O_DIRECTORY: () => O_DIRECTORY,
    O_DSYNC: () => O_DSYNC,
    O_EXCL: () => O_EXCL,
    O_NOATIME: () => O_NOATIME,
    O_NOCTTY: () => O_NOCTTY,
    O_NOFOLLOW: () => O_NOFOLLOW,
    O_NONBLOCK: () => O_NONBLOCK,
    O_RDONLY: () => O_RDONLY,
    O_RDWR: () => O_RDWR,
    O_SYMLINK: () => O_SYMLINK,
    O_SYNC: () => O_SYNC,
    O_TRUNC: () => O_TRUNC,
    O_WRONLY: () => O_WRONLY,
    R_OK: () => R_OK,
    S_IFBLK: () => S_IFBLK,
    S_IFCHR: () => S_IFCHR,
    S_IFDIR: () => S_IFDIR,
    S_IFIFO: () => S_IFIFO,
    S_IFLNK: () => S_IFLNK,
    S_IFMT: () => S_IFMT,
    S_IFREG: () => S_IFREG,
    S_IFSOCK: () => S_IFSOCK,
    S_IRGRP: () => S_IRGRP,
    S_IROTH: () => S_IROTH,
    S_IRUSR: () => S_IRUSR,
    S_IRWXG: () => S_IRWXG,
    S_IRWXO: () => S_IRWXO,
    S_IRWXU: () => S_IRWXU,
    S_ISGID: () => S_ISGID,
    S_ISUID: () => S_ISUID,
    S_ISVTX: () => S_ISVTX,
    S_IWGRP: () => S_IWGRP,
    S_IWOTH: () => S_IWOTH,
    S_IWUSR: () => S_IWUSR,
    S_IXGRP: () => S_IXGRP,
    S_IXOTH: () => S_IXOTH,
    S_IXUSR: () => S_IXUSR,
    UV_FS_O_FILEMAP: () => UV_FS_O_FILEMAP,
    W_OK: () => W_OK,
    X_OK: () => X_OK,
    size_max: () => size_max
  });
  var F_OK, R_OK, W_OK, X_OK, COPYFILE_EXCL, COPYFILE_FICLONE, COPYFILE_FICLONE_FORCE, O_RDONLY, O_WRONLY, O_RDWR, O_CREAT, O_EXCL, O_NOCTTY, O_TRUNC, O_APPEND, O_DIRECTORY, O_NOATIME, O_NOFOLLOW, O_SYNC, O_DSYNC, O_SYMLINK, O_DIRECT, O_NONBLOCK, S_IFMT, S_IFSOCK, S_IFLNK, S_IFREG, S_IFBLK, S_IFDIR, S_IFCHR, S_IFIFO, S_ISUID, S_ISGID, S_ISVTX, S_IRWXU, S_IRUSR, S_IWUSR, S_IXUSR, S_IRWXG, S_IRGRP, S_IWGRP, S_IXGRP, S_IRWXO, S_IROTH, S_IWOTH, S_IXOTH, UV_FS_O_FILEMAP, size_max;
  var init_constants = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/constants.js"() {
      F_OK = 0;
      R_OK = 4;
      W_OK = 2;
      X_OK = 1;
      COPYFILE_EXCL = 1;
      COPYFILE_FICLONE = 2;
      COPYFILE_FICLONE_FORCE = 4;
      O_RDONLY = 0;
      O_WRONLY = 1;
      O_RDWR = 2;
      O_CREAT = 64;
      O_EXCL = 128;
      O_NOCTTY = 256;
      O_TRUNC = 512;
      O_APPEND = 1024;
      O_DIRECTORY = 65536;
      O_NOATIME = 262144;
      O_NOFOLLOW = 131072;
      O_SYNC = 1052672;
      O_DSYNC = 4096;
      O_SYMLINK = 32768;
      O_DIRECT = 16384;
      O_NONBLOCK = 2048;
      S_IFMT = 61440;
      S_IFSOCK = 49152;
      S_IFLNK = 40960;
      S_IFREG = 32768;
      S_IFBLK = 24576;
      S_IFDIR = 16384;
      S_IFCHR = 8192;
      S_IFIFO = 4096;
      S_ISUID = 2048;
      S_ISGID = 1024;
      S_ISVTX = 512;
      S_IRWXU = 448;
      S_IRUSR = 256;
      S_IWUSR = 128;
      S_IXUSR = 64;
      S_IRWXG = 56;
      S_IRGRP = 32;
      S_IWGRP = 16;
      S_IXGRP = 8;
      S_IRWXO = 7;
      S_IROTH = 4;
      S_IWOTH = 2;
      S_IXOTH = 1;
      UV_FS_O_FILEMAP = 0;
      size_max = 4294967295;
    }
  });

  // ../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/internal.js
  function initMetadata(context) {
    context.metadata ??= {};
    const existing = context.metadata.structInit ?? {};
    context.metadata.structInit = {
      fields: [...existing.fields ?? []]
    };
    return context.metadata.structInit;
  }
  function isValidMetadata(arg) {
    return arg != null && typeof arg == "object" && "struct" in arg;
  }
  function isStatic(arg) {
    return typeof arg == "function" && Symbol.metadata in arg && isValidMetadata(arg[Symbol.metadata]);
  }
  function isInstance(arg) {
    return arg != null && typeof arg == "object" && isStatic(arg.constructor);
  }
  function isStruct(arg) {
    return isInstance(arg) || isStatic(arg);
  }
  function checkStruct(arg) {
    if (isStruct(arg))
      return;
    throw new TypeError((typeof arg == "function" ? arg.name : typeof arg == "object" && arg ? arg.constructor.name : arg) + " is not a struct");
  }
  var init_internal = __esm({
    "../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/internal.js"() {
      Symbol.metadata ??= Symbol.for("Symbol.metadata");
    }
  });

  // ../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/types.js
  function isType(type) {
    return (typeof type == "object" || typeof type == "function") && type != null && "name" in type && "size" in type && "get" in type && "set" in type && typeof type.name == "string" && typeof type.size == "number" && typeof type.get == "function" && typeof type.set == "function" && typeRegistry.has(type.name) && typeRegistry.get(type.name)?.name === type.name;
  }
  function registerType(t2) {
    if (typeRegistry.has(t2.name))
      throw new ReferenceError(`Type is already registered: ${t2.name}`);
    typeRegistry.set(t2.name, t2);
  }
  var typeRegistry;
  var init_types2 = __esm({
    "../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/types.js"() {
      typeRegistry = /* @__PURE__ */ new Map();
    }
  });

  // ../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/primitives.js
  function view(buffer) {
    buffer[__view__] ??= new DataView(buffer);
    return buffer[__view__];
  }
  function isValid(type) {
    return validNames.includes(type.toString());
  }
  function checkValid(type) {
    if (!isValid(type))
      throw withErrno("EINVAL", "Not a valid primitive type: " + type);
  }
  function normalize(type) {
    return type == "char" ? "uint8" : type.toLowerCase();
  }
  var __view__, types, typeNames, validNames;
  var init_primitives = __esm({
    "../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/primitives.js"() {
      init_dist2();
      init_string();
      init_types2();
      __view__ = Symbol("DataView");
      types = {
        int8: {
          name: "int8",
          size: 1,
          array: Int8Array,
          get: (buffer, offset) => view(buffer).getInt8(offset),
          set: (buffer, offset, value) => view(buffer).setInt8(offset, value)
        },
        uint8: {
          name: "uint8",
          size: 1,
          array: Uint8Array,
          get: (buffer, offset) => view(buffer).getUint8(offset),
          set: (buffer, offset, value) => view(buffer).setUint8(offset, value)
        },
        int16: {
          name: "int16",
          size: 2,
          array: Int16Array,
          get: (buffer, offset) => view(buffer).getInt16(offset, true),
          set: (buffer, offset, value) => view(buffer).setInt16(offset, value, true)
        },
        uint16: {
          name: "uint16",
          size: 2,
          array: Uint16Array,
          get: (buffer, offset) => view(buffer).getUint16(offset, true),
          set: (buffer, offset, value) => view(buffer).setUint16(offset, value, true)
        },
        int32: {
          name: "int32",
          size: 4,
          array: Int32Array,
          get: (buffer, offset) => view(buffer).getInt32(offset, true),
          set: (buffer, offset, value) => view(buffer).setInt32(offset, value, true)
        },
        uint32: {
          name: "uint32",
          size: 4,
          array: Uint32Array,
          get: (buffer, offset) => view(buffer).getUint32(offset, true),
          set: (buffer, offset, value) => view(buffer).setUint32(offset, value, true)
        },
        int64: {
          name: "int64",
          size: 8,
          array: BigInt64Array,
          get: (buffer, offset) => view(buffer).getBigInt64(offset, true),
          set: (buffer, offset, value) => view(buffer).setBigInt64(offset, value, true)
        },
        uint64: {
          name: "uint64",
          size: 8,
          array: BigUint64Array,
          get: (buffer, offset) => view(buffer).getBigUint64(offset, true),
          set: (buffer, offset, value) => view(buffer).setBigUint64(offset, value, true)
        },
        float32: {
          name: "float32",
          size: 4,
          array: Float32Array,
          get: (buffer, offset) => view(buffer).getFloat32(offset, true),
          set: (buffer, offset, value) => view(buffer).setFloat32(offset, value, true)
        },
        float64: {
          name: "float64",
          size: 8,
          array: Float64Array,
          get: (buffer, offset) => view(buffer).getFloat64(offset, true),
          set: (buffer, offset, value) => view(buffer).setFloat64(offset, value, true)
        }
      };
      typeNames = Object.keys(types);
      for (const t2 of Object.values(types))
        registerType(t2);
      validNames = [...typeNames, ...typeNames.map((t2) => capitalize(t2)), "char"];
    }
  });

  // ../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/misc.js
  function sizeof(type) {
    if (isType(type))
      return type.size;
    if (type === void 0 || type === null)
      return 0;
    if (typeof type == "object" && isType(type.constructor))
      return type.constructor.size;
    if (Array.isArray(type)) {
      let size = 0;
      for (let i2 = 0; i2 < type.length; i2++)
        size += sizeof(type[i2]);
      return size;
    }
    if (typeof type == "string") {
      checkValid(type);
      return types[normalize(type)].size;
    }
    throw new TypeError(`Unable to resolve size of \`${type.toString()}\``);
  }
  function offsetof(type, fieldName) {
    checkStruct(type);
    const constructor = isStatic(type) ? type : type.constructor;
    const { fields } = constructor[Symbol.metadata].struct;
    if (!(fieldName in fields))
      throw withErrno("EINVAL", "Struct does not have field: " + fieldName);
    return fields[fieldName].offset;
  }
  var init_misc2 = __esm({
    "../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/misc.js"() {
      init_dist2();
      init_internal();
      init_primitives();
      init_types2();
    }
  });

  // ../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/struct.js
  function struct(...options) {
    return function __decorateStruct(target, context) {
      const opts = options.reduce((acc, opt) => ({ ...acc, ...opt }), {});
      const init3 = initMetadata(context);
      let fieldAlignment = 1;
      const fields = {};
      let size = 0;
      const align = (to) => {
        size = Math.ceil(size / to) * to;
      };
      for (const field2 of init3.fields) {
        if (!opts.isPacked)
          align(field2.alignment);
        if (opts.isUnion)
          size = Math.max(size, field2.size);
        else {
          field2.offset = size;
          size += field2.size * (field2.length ?? 1);
        }
        fields[field2.name] = field2;
        fieldAlignment = Math.max(fieldAlignment, field2.alignment);
      }
      opts.alignment ??= fieldAlignment;
      if (!opts.isPacked)
        align(opts.alignment);
      context.metadata.struct = {
        fields,
        size,
        alignment: opts.isPacked ? 1 : opts.alignment,
        isUnion: opts.isUnion ?? false
      };
      const struct2 = new Function("target", `return class ${target.name} extends target {
				constructor(...args) {
					if (!args.length) args = [new ArrayBuffer(${size}), 0, ${size}];
					super(...args);
				}
			}`)(target);
      const fix = (value) => ({
        writable: false,
        enumerable: false,
        configurable: false,
        value
      });
      Object.defineProperties(struct2, {
        size: fix(size),
        get: fix((buffer, offset) => new struct2(buffer, offset)),
        set: fix((buffer, offset, value) => {
          const source = new Uint8Array(value.buffer, value.byteOffset, size);
          const target2 = new Uint8Array(buffer, offset, size);
          if (value.buffer === buffer && value.byteOffset === offset)
            return;
          for (let i2 = 0; i2 < size; i2++)
            target2[i2] = source[i2];
        })
      });
      registerType(struct2);
      return struct2;
    };
  }
  function field(type, opt = {}) {
    return function __decorateField(value, context) {
      if (context.kind != "accessor")
        throw withErrno("EINVAL", "Field must be an accessor");
      const init3 = initMetadata(context);
      let name2 = context.name;
      if (typeof name2 == "symbol") {
        console.warn("Symbol used for struct field name will be coerced to string: " + name2.toString());
        name2 = name2.toString();
      }
      if (!name2)
        throw withErrno("EINVAL", "Invalid name for struct field");
      if (!isType(type))
        throw withErrno("EINVAL", "Not a valid type: " + type.name);
      if (opt.countedBy)
        opt.length ??= 0;
      const field2 = {
        name: name2,
        offset: 0,
        // set when `@struct` is run
        type,
        length: opt.length,
        countedBy: opt.countedBy,
        size: type.size,
        alignment: opt.align ?? type.size,
        decl: `${opt.typeName ?? type.name} ${name2}${typeof opt.length === "number" ? `[${opt.length}]` : opt.countedBy ? `[${opt.countedBy}]` : ""}`,
        littleEndian: !opt.bigEndian
      };
      init3.fields.push(field2);
      return {
        get() {
          return _get(this, field2);
        },
        set(value2) {
          _set(this, field2, value2);
        }
      };
    };
  }
  function _fieldLength(instance, length2, countedBy) {
    if (length2 === void 0)
      return -1;
    if (typeof countedBy == "string")
      length2 = Math.min(length2, instance[countedBy]);
    return Number.isSafeInteger(length2) && length2 >= 0 ? length2 : _throw(withErrno("EINVAL", "Array lengths must be natural numbers"));
  }
  function _set(instance, field2, value, index2) {
    const { type, length: maxLength, countedBy } = field2;
    const length2 = _fieldLength(instance, maxLength, countedBy);
    if (length2 === -1 || typeof index2 === "number") {
      if (typeof value == "string")
        value = value.charCodeAt(0);
      type.set(instance.buffer, instance.byteOffset + field2.offset + (index2 ?? 0) * type.size, value);
      return;
    }
    for (let i2 = 0; i2 < Math.min(length2, value.length); i2++) {
      const offset = field2.offset + i2 * type.size;
      type.set(instance.buffer, instance.byteOffset + offset, value[i2]);
    }
  }
  function _get(instance, field2, index2) {
    const { type, length: maxLength, countedBy } = field2;
    const length2 = _fieldLength(instance, maxLength, countedBy);
    const offset = instance.byteOffset + field2.offset + (index2 ?? 0) * field2.size;
    if (length2 === -1 || typeof index2 === "number") {
      return type.get(instance.buffer, offset);
    }
    if (length2 !== 0 && type.array) {
      return new type.array(instance.buffer, offset, length2 * type.size);
    }
    return new Proxy({
      get length() {
        return _fieldLength(instance, field2.length, field2.countedBy);
      },
      *[Symbol.iterator]() {
        for (let i2 = 0; i2 < this.length; i2++)
          yield this[i2];
      }
    }, {
      get(target, index3) {
        if (Object.hasOwn(target, index3))
          return target[index3];
        const i2 = parseInt(index3.toString());
        if (!Number.isSafeInteger(i2))
          throw withErrno("EINVAL", "Invalid index: " + index3.toString());
        return _get(instance, field2, i2);
      },
      set(target, index3, value) {
        const i2 = parseInt(index3.toString());
        if (!Number.isSafeInteger(i2))
          throw withErrno("EINVAL", "Invalid index: " + index3.toString());
        _set(instance, field2, i2, value);
        return true;
      }
    });
  }
  function _shortcut2(typeName) {
    const type = types[normalize(typeName)];
    function __decoratePrimitiveField(valueOrLength, context) {
      return typeof valueOrLength == "number" ? field(type, { typeName, length: valueOrLength, ...context }) : field(type, { typeName })(valueOrLength, context && "name" in context ? context : _throw(withErrno("EINVAL", "Invalid decorator context object")));
    }
    return __decoratePrimitiveField;
  }
  var packed, types2;
  var init_struct = __esm({
    "../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/struct.js"() {
      init_dist2();
      init_misc();
      init_internal();
      init_primitives();
      init_types2();
      packed = { isPacked: true };
      types2 = Object.fromEntries(validNames.map((t2) => [t2, _shortcut2(t2)]));
    }
  });

  // ../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/index.js
  var init_dist3 = __esm({
    "../../node_modules/.pnpm/memium@0.2.0/node_modules/memium/dist/index.js"() {
      init_internal();
      init_misc2();
      init_primitives();
      init_struct();
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/buffer.js
  function extendBuffer(buffer, newByteLength) {
    if (buffer.byteLength >= newByteLength)
      return buffer;
    if (ArrayBuffer.isView(buffer)) {
      const newBuffer = extendBuffer(buffer.buffer, newByteLength);
      return new buffer.constructor(newBuffer, buffer.byteOffset, newByteLength);
    }
    const isShared = typeof SharedArrayBuffer !== "undefined" && buffer instanceof SharedArrayBuffer;
    if (buffer.maxByteLength > newByteLength) {
      isShared ? buffer.grow(newByteLength) : buffer.resize(newByteLength);
      return buffer;
    }
    if (isShared) {
      const newBuffer = new SharedArrayBuffer(newByteLength);
      new Uint8Array(newBuffer).set(new Uint8Array(buffer));
      return newBuffer;
    }
    try {
      return buffer.transfer(newByteLength);
    } catch {
      const newBuffer = new ArrayBuffer(newByteLength);
      new Uint8Array(newBuffer).set(new Uint8Array(buffer));
      return newBuffer;
    }
  }
  var BufferView;
  var init_buffer = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/buffer.js"() {
      BufferView = class extends DataView {
        constructor(_buffer, _byteOffset, _byteLength) {
          const { buffer, byteOffset, byteLength } = new Uint8Array(_buffer, _byteOffset, _byteLength);
          super(buffer, byteOffset, byteLength);
        }
      };
      for (const key of Object.getOwnPropertyNames(DataView.prototype)) {
        if (!key.startsWith("get") && !key.startsWith("set"))
          continue;
        Object.defineProperty(BufferView.prototype, key, {
          value: () => {
            throw new ReferenceError("Do not use DataView methods on a BufferView.");
          },
          writable: false,
          enumerable: false,
          configurable: false
        });
      }
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/utils.js
  function decodeDirListing(data) {
    return JSON.parse(decodeUTF8(data), (k, v) => k == "" ? v : typeof v == "string" ? BigInt(v).toString(16).slice(0, Math.min(v.length, 8)) : v);
  }
  function encodeDirListing(data) {
    return encodeUTF8(JSON.stringify(data));
  }
  function normalizeMode(mode, def) {
    if (typeof mode == "number")
      return mode;
    if (typeof mode == "string") {
      const parsed = parseInt(mode, 8);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }
    if (typeof def == "number")
      return def;
    throw withErrno("EINVAL", "Invalid mode: " + (mode === null || mode === void 0 ? void 0 : mode.toString()));
  }
  function normalizeTime(time) {
    if (time instanceof Date)
      return time.getTime();
    try {
      return Number(time);
    } catch {
      throw withErrno("EINVAL", "Invalid time.");
    }
  }
  function __assertType(value) {
  }
  function normalizePath(p12, noResolve = false) {
    if (p12 instanceof URL) {
      if (p12.protocol != "file:")
        throw withErrno("EINVAL", "URLs must use the file: protocol");
      p12 = p12.pathname;
    }
    p12 = p12.toString();
    if (p12.startsWith("file://"))
      p12 = p12.slice("file://".length);
    if (p12.includes("\0"))
      throw withErrno("EINVAL", "Path can not contain null character");
    if (p12.length == 0)
      throw withErrno("EINVAL", "Path can not be empty");
    p12 = p12.replaceAll(/[/\\]+/g, "/");
    return noResolve ? p12 : resolve(p12);
  }
  function normalizeOptions(options, encoding = "utf8", flag, mode = 0) {
    if (typeof options != "object" || options === null) {
      return {
        encoding: typeof options == "string" ? options : encoding !== null && encoding !== void 0 ? encoding : null,
        flag,
        mode
      };
    }
    return {
      encoding: typeof (options === null || options === void 0 ? void 0 : options.encoding) == "string" ? options.encoding : encoding !== null && encoding !== void 0 ? encoding : null,
      flag: typeof (options === null || options === void 0 ? void 0 : options.flag) == "string" ? options.flag : flag,
      mode: normalizeMode("mode" in options ? options === null || options === void 0 ? void 0 : options.mode : null, mode)
    };
  }
  function globToRegex(pattern2) {
    pattern2 = pattern2.replace(/([.?+^$(){}|[\]/])/g, "$1").replace(/\*\*/g, ".*").replace(/\*/g, "[^/]*").replace(/\?/g, ".");
    return new RegExp(`^${pattern2}$`);
  }
  var init_utils = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/utils.js"() {
      init_dist2();
      init_dist();
      init_path();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/path.js
  var path_exports = {};
  __export(path_exports, {
    basename: () => basename,
    dirname: () => dirname,
    extname: () => extname,
    format: () => format2,
    formatExt: () => formatExt,
    isAbsolute: () => isAbsolute,
    join: () => join,
    matchesGlob: () => matchesGlob,
    normalize: () => normalize2,
    normalizeString: () => normalizeString,
    parse: () => parse,
    relative: () => relative,
    resolve: () => resolve,
    sep: () => sep
  });
  function validateObject(str, name2) {
    if (typeof str != "object") {
      throw new TypeError(`"${name2}" is not an object`);
    }
  }
  function normalizeString(path3, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let char = "\0";
    for (let i2 = 0; i2 <= path3.length; ++i2) {
      if (i2 < path3.length) {
        char = path3[i2];
      } else if (char == "/") {
        break;
      } else {
        char = "/";
      }
      if (char == "/") {
        if (lastSlash === i2 - 1 || dots === 1) {
        } else if (dots === 2) {
          if (res.length < 2 || lastSegmentLength !== 2 || res.at(-1) !== "." || res.at(-2) !== ".") {
            if (res.length > 2) {
              const lastSlashIndex = res.lastIndexOf("/");
              if (lastSlashIndex === -1) {
                res = "";
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
              }
              lastSlash = i2;
              dots = 0;
              continue;
            } else if (res.length !== 0) {
              res = "";
              lastSegmentLength = 0;
              lastSlash = i2;
              dots = 0;
              continue;
            }
          }
          if (allowAboveRoot) {
            res += res.length > 0 ? "/.." : "..";
            lastSegmentLength = 2;
          }
        } else {
          if (res.length > 0)
            res += "/" + path3.slice(lastSlash + 1, i2);
          else
            res = path3.slice(lastSlash + 1, i2);
          lastSegmentLength = i2 - lastSlash - 1;
        }
        lastSlash = i2;
        dots = 0;
      } else if (char === "." && dots !== -1) {
        ++dots;
      } else {
        dots = -1;
      }
    }
    return res;
  }
  function formatExt(ext) {
    return ext ? `${ext[0] === "." ? "" : "."}${ext}` : "";
  }
  function resolve(...parts) {
    var _a6;
    let resolved = "";
    for (const part of [...parts.reverse(), (_a6 = this === null || this === void 0 ? void 0 : this.pwd) !== null && _a6 !== void 0 ? _a6 : defaultContext.pwd]) {
      if (!(part === null || part === void 0 ? void 0 : part.length))
        continue;
      resolved = `${part}/${resolved}`;
      if (part.startsWith("/")) {
        break;
      }
    }
    const absolute = resolved.startsWith("/");
    resolved = normalizeString(resolved, !absolute);
    if (absolute) {
      return `/${resolved}`;
    }
    return resolved.length ? resolved : "/";
  }
  function normalize2(path3) {
    if (!path3.length)
      return ".";
    const isAbsolute2 = path3.startsWith("/");
    const trailingSeparator = path3.endsWith("/");
    path3 = normalizeString(path3, !isAbsolute2);
    if (!path3.length) {
      if (isAbsolute2)
        return "/";
      return trailingSeparator ? "./" : ".";
    }
    if (trailingSeparator)
      path3 += "/";
    return isAbsolute2 ? `/${path3}` : path3;
  }
  function isAbsolute(path3) {
    return path3.startsWith("/");
  }
  function join(...parts) {
    if (!parts.length)
      return ".";
    const joined = parts.join("/");
    if (!(joined === null || joined === void 0 ? void 0 : joined.length))
      return ".";
    return normalize2(joined);
  }
  function relative(from, to) {
    if (from === to)
      return "";
    from = resolve.call(this, from);
    to = resolve.call(this, to);
    if (from === to)
      return "";
    const fromStart = 1;
    const fromEnd = from.length;
    const fromLen = fromEnd - fromStart;
    const toStart = 1;
    const toLen = to.length - toStart;
    const length2 = fromLen < toLen ? fromLen : toLen;
    let lastCommonSep = -1;
    let i2 = 0;
    for (; i2 < length2; i2++) {
      const fromCode = from[fromStart + i2];
      if (fromCode !== to[toStart + i2])
        break;
      else if (fromCode === "/")
        lastCommonSep = i2;
    }
    if (i2 === length2) {
      if (toLen > length2) {
        if (to[toStart + i2] === "/") {
          return to.slice(toStart + i2 + 1);
        }
        if (i2 === 0) {
          return to.slice(toStart + i2);
        }
      } else if (fromLen > length2) {
        if (from[fromStart + i2] === "/") {
          lastCommonSep = i2;
        } else if (i2 === 0) {
          lastCommonSep = 0;
        }
      }
    }
    let out = "";
    for (i2 = fromStart + lastCommonSep + 1; i2 <= fromEnd; ++i2) {
      if (i2 === fromEnd || from[i2] === "/") {
        out += out.length === 0 ? ".." : "/..";
      }
    }
    return `${out}${to.slice(toStart + lastCommonSep)}`;
  }
  function dirname(path3) {
    if (path3.length === 0)
      return ".";
    const hasRoot = path3[0] === "/";
    let end = -1;
    let matchedSlash = true;
    for (let i2 = path3.length - 1; i2 >= 1; --i2) {
      if (path3[i2] === "/") {
        if (!matchedSlash) {
          end = i2;
          break;
        }
      } else {
        matchedSlash = false;
      }
    }
    if (end === -1)
      return hasRoot ? "/" : ".";
    if (hasRoot && end === 1)
      return "//";
    return path3.slice(0, end);
  }
  function basename(path3, suffix) {
    let start = 0;
    let end = -1;
    let matchedSlash = true;
    if (suffix !== void 0 && suffix.length > 0 && suffix.length <= path3.length) {
      if (suffix === path3)
        return "";
      let extIdx = suffix.length - 1;
      let firstNonSlashEnd = -1;
      for (let i2 = path3.length - 1; i2 >= 0; --i2) {
        if (path3[i2] === "/") {
          if (!matchedSlash) {
            start = i2 + 1;
            break;
          }
        } else {
          if (firstNonSlashEnd === -1) {
            matchedSlash = false;
            firstNonSlashEnd = i2 + 1;
          }
          if (extIdx >= 0) {
            if (path3[i2] === suffix[extIdx]) {
              if (--extIdx === -1) {
                end = i2;
              }
            } else {
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }
      if (start === end)
        end = firstNonSlashEnd;
      else if (end === -1)
        end = path3.length;
      return path3.slice(start, end);
    }
    for (let i2 = path3.length - 1; i2 >= 0; --i2) {
      if (path3[i2] === "/") {
        if (!matchedSlash) {
          start = i2 + 1;
          break;
        }
      } else if (end === -1) {
        matchedSlash = false;
        end = i2 + 1;
      }
    }
    if (end === -1)
      return "";
    return path3.slice(start, end);
  }
  function extname(path3) {
    let startDot = -1;
    let startPart = 0;
    let end = -1;
    let matchedSlash = true;
    let preDotState = 0;
    for (let i2 = path3.length - 1; i2 >= 0; --i2) {
      if (path3[i2] === "/") {
        if (!matchedSlash) {
          startPart = i2 + 1;
          break;
        }
        continue;
      }
      if (end === -1) {
        matchedSlash = false;
        end = i2 + 1;
      }
      if (path3[i2] === ".") {
        if (startDot === -1)
          startDot = i2;
        else if (preDotState !== 1)
          preDotState = 1;
      } else if (startDot !== -1) {
        preDotState = -1;
      }
    }
    if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return "";
    }
    return path3.slice(startDot, end);
  }
  function format2(pathObject) {
    validateObject(pathObject, "pathObject");
    const dir = pathObject.dir || pathObject.root;
    const base2 = pathObject.base || `${pathObject.name || ""}${formatExt(pathObject.ext)}`;
    if (!dir) {
      return base2;
    }
    return dir === pathObject.root ? `${dir}${base2}` : `${dir}/${base2}`;
  }
  function parse(path3) {
    const isAbsolute2 = path3.startsWith("/");
    const ret = { root: isAbsolute2 ? "/" : "", dir: "", base: "", ext: "", name: "" };
    if (path3.length === 0)
      return ret;
    const start = isAbsolute2 ? 1 : 0;
    let startDot = -1;
    let startPart = 0;
    let end = -1;
    let matchedSlash = true;
    let i2 = path3.length - 1;
    let preDotState = 0;
    for (; i2 >= start; --i2) {
      if (path3[i2] === "/") {
        if (!matchedSlash) {
          startPart = i2 + 1;
          break;
        }
        continue;
      }
      if (end === -1) {
        matchedSlash = false;
        end = i2 + 1;
      }
      if (path3[i2] === ".") {
        if (startDot === -1)
          startDot = i2;
        else if (preDotState !== 1)
          preDotState = 1;
      } else if (startDot !== -1) {
        preDotState = -1;
      }
    }
    if (end !== -1) {
      const start2 = startPart === 0 && isAbsolute2 ? 1 : startPart;
      if (startDot === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
        ret.base = ret.name = path3.slice(start2, end);
      } else {
        ret.name = path3.slice(start2, startDot);
        ret.base = path3.slice(start2, end);
        ret.ext = path3.slice(startDot, end);
      }
    }
    if (startPart > 0)
      ret.dir = path3.slice(0, startPart - 1);
    else if (isAbsolute2)
      ret.dir = "/";
    return ret;
  }
  function matchesGlob(pattern2, str) {
    return globToRegex(pattern2).test(str);
  }
  var sep;
  var init_path = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/path.js"() {
      init_contexts();
      init_utils();
      sep = "/";
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/stats.js
  function _chown(stats, uid, gid) {
    let valid = true;
    if (!isNaN(uid) && uid >= 0 && uid < size_max)
      stats.uid = uid;
    else
      valid = false;
    if (!isNaN(gid) && gid >= 0 && gid < size_max)
      stats.gid = gid;
    else
      valid = false;
    return valid;
  }
  function isStatsEqual(left, right) {
    return left.size == right.size && +left.atime == +right.atime && +left.mtime == +right.mtime && +left.ctime == +right.ctime && left.mode == right.mode;
  }
  var n1000, StatsCommon, Stats, BigIntStats, ZenFsType, StatsFs, BigIntStatsFs;
  var init_stats = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/stats.js"() {
      init_dist();
      init_inode();
      init_constants();
      n1000 = BigInt(1e3);
      StatsCommon = class {
        _convert(arg) {
          return this._isBigint ? BigInt(arg) : Number(arg);
        }
        get blocks() {
          return this._convert(Math.ceil(Number(this.size) / 512));
        }
        set blocks(value) {
        }
        get atime() {
          return new Date(Number(this.atimeMs));
        }
        set atime(value) {
          this.atimeMs = this._convert(value.getTime());
        }
        get mtime() {
          return new Date(Number(this.mtimeMs));
        }
        set mtime(value) {
          this.mtimeMs = this._convert(value.getTime());
        }
        get ctime() {
          return new Date(Number(this.ctimeMs));
        }
        set ctime(value) {
          this.ctimeMs = this._convert(value.getTime());
        }
        get birthtime() {
          return new Date(Number(this.birthtimeMs));
        }
        set birthtime(value) {
          this.birthtimeMs = this._convert(value.getTime());
        }
        /**
         * Creates a new stats instance from a stats-like object. Can be used to copy stats (note)
         */
        constructor({ atimeMs, mtimeMs, ctimeMs, birthtimeMs, uid, gid, size, mode, ino, ...rest } = {}) {
          this.dev = this._convert(0);
          this.ino = this._convert(0);
          this.rdev = this._convert(0);
          this.nlink = this._convert(1);
          this.blksize = this._convert(4096);
          this.uid = this._convert(0);
          this.gid = this._convert(0);
          const now = Date.now();
          this.atimeMs = this._convert(atimeMs !== null && atimeMs !== void 0 ? atimeMs : now);
          this.mtimeMs = this._convert(mtimeMs !== null && mtimeMs !== void 0 ? mtimeMs : now);
          this.ctimeMs = this._convert(ctimeMs !== null && ctimeMs !== void 0 ? ctimeMs : now);
          this.birthtimeMs = this._convert(birthtimeMs !== null && birthtimeMs !== void 0 ? birthtimeMs : now);
          this.uid = this._convert(uid !== null && uid !== void 0 ? uid : 0);
          this.gid = this._convert(gid !== null && gid !== void 0 ? gid : 0);
          this.size = this._convert(size !== null && size !== void 0 ? size : 0);
          this.ino = this._convert(ino !== null && ino !== void 0 ? ino : 0);
          this.mode = this._convert(mode !== null && mode !== void 0 ? mode : 420 & S_IFREG);
          if ((this.mode & S_IFMT) == 0) {
            this.mode = this.mode | this._convert(S_IFREG);
          }
          Object.assign(this, rest);
        }
        isFile() {
          return (this.mode & S_IFMT) === S_IFREG;
        }
        isDirectory() {
          return (this.mode & S_IFMT) === S_IFDIR;
        }
        isSymbolicLink() {
          return (this.mode & S_IFMT) === S_IFLNK;
        }
        isSocket() {
          return (this.mode & S_IFMT) === S_IFSOCK;
        }
        isBlockDevice() {
          return (this.mode & S_IFMT) === S_IFBLK;
        }
        isCharacterDevice() {
          return (this.mode & S_IFMT) === S_IFCHR;
        }
        isFIFO() {
          return (this.mode & S_IFMT) === S_IFIFO;
        }
        toJSON() {
          return pick(this, _inode_fields);
        }
        /**
         * Checks if a given user/group has access to this item
         * @param mode The requested access, combination of W_OK, R_OK, and X_OK
         * @returns True if the request has access, false if the request does not
         * @internal
         */
        hasAccess(mode, context) {
          return hasAccess(context, this._isBigint ? new Stats(this) : this, mode);
        }
        get atimeNs() {
          return BigInt(this.atimeMs) * n1000;
        }
        get mtimeNs() {
          return BigInt(this.mtimeMs) * n1000;
        }
        get ctimeNs() {
          return BigInt(this.ctimeMs) * n1000;
        }
        get birthtimeNs() {
          return BigInt(this.birthtimeMs) * n1000;
        }
      };
      Stats = class extends StatsCommon {
        constructor() {
          super(...arguments);
          this._isBigint = false;
        }
      };
      BigIntStats = class extends StatsCommon {
        constructor() {
          super(...arguments);
          this._isBigint = true;
        }
      };
      ZenFsType = 525687744115;
      StatsFs = class {
        constructor() {
          this.type = 525687744115;
          this.bsize = 4096;
          this.blocks = 0;
          this.bfree = 0;
          this.bavail = 0;
          this.files = size_max;
          this.ffree = size_max;
        }
      };
      BigIntStatsFs = class {
        constructor() {
          this.type = BigInt("0x7a656e6673");
          this.bsize = BigInt(4096);
          this.blocks = BigInt(0);
          this.bfree = BigInt(0);
          this.bavail = BigInt(0);
          this.files = BigInt(size_max);
          this.ffree = BigInt(size_max);
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/inode.js
  function isFile(metadata) {
    return (metadata.mode & S_IFMT) === S_IFREG;
  }
  function isDirectory(metadata) {
    return (metadata.mode & S_IFMT) === S_IFDIR;
  }
  function isSymbolicLink(metadata) {
    return (metadata.mode & S_IFMT) === S_IFLNK;
  }
  function isSocket(metadata) {
    return (metadata.mode & S_IFMT) === S_IFSOCK;
  }
  function isBlockDevice(metadata) {
    return (metadata.mode & S_IFMT) === S_IFBLK;
  }
  function isCharacterDevice(metadata) {
    return (metadata.mode & S_IFMT) === S_IFCHR;
  }
  function isFIFO(metadata) {
    return (metadata.mode & S_IFMT) === S_IFIFO;
  }
  function hasAccess($, inode, access3) {
    const credentials = ($ === null || $ === void 0 ? void 0 : $.credentials) || defaultContext.credentials;
    if (isSymbolicLink(inode) || credentials.euid === 0 || credentials.egid === 0)
      return true;
    let perm = 0;
    if (credentials.uid === inode.uid) {
      if (inode.mode & S_IRUSR)
        perm |= R_OK;
      if (inode.mode & S_IWUSR)
        perm |= W_OK;
      if (inode.mode & S_IXUSR)
        perm |= X_OK;
    }
    if (credentials.gid === inode.gid || credentials.groups.includes(Number(inode.gid))) {
      if (inode.mode & S_IRGRP)
        perm |= R_OK;
      if (inode.mode & S_IWGRP)
        perm |= W_OK;
      if (inode.mode & S_IXGRP)
        perm |= X_OK;
    }
    if (inode.mode & S_IROTH)
      perm |= R_OK;
    if (inode.mode & S_IWOTH)
      perm |= W_OK;
    if (inode.mode & S_IXOTH)
      perm |= X_OK;
    return (perm & access3) === access3;
  }
  var __esDecorate, __runInitializers, __setFunctionName, __classPrivateFieldGet, __classPrivateFieldSet, rootIno, maxDynamicData, Attribute, Attributes, _inode_fields, _inode_version, InodeFlags, userVisibleFlags, userModifiableFlags, Inode;
  var init_inode = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/inode.js"() {
      init_dist2();
      init_log();
      init_dist3();
      init_dist();
      init_buffer();
      init_constants();
      init_stats();
      init_contexts();
      __esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
        function accept(f) {
          if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
          return f;
        }
        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
        var _2, done = false;
        for (var i2 = decorators.length - 1; i2 >= 0; i2--) {
          var context = {};
          for (var p12 in contextIn) context[p12] = p12 === "access" ? {} : contextIn[p12];
          for (var p12 in contextIn.access) context.access[p12] = contextIn.access[p12];
          context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
          };
          var result = (0, decorators[i2])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
          if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_2 = accept(result.get)) descriptor.get = _2;
            if (_2 = accept(result.set)) descriptor.set = _2;
            if (_2 = accept(result.init)) initializers.unshift(_2);
          } else if (_2 = accept(result)) {
            if (kind === "field") initializers.unshift(_2);
            else descriptor[key] = _2;
          }
        }
        if (target) Object.defineProperty(target, contextIn.name, descriptor);
        done = true;
      };
      __runInitializers = function(thisArg, initializers, value) {
        var useValue = arguments.length > 2;
        for (var i2 = 0; i2 < initializers.length; i2++) {
          value = useValue ? initializers[i2].call(thisArg, value) : initializers[i2].call(thisArg);
        }
        return useValue ? value : void 0;
      };
      __setFunctionName = function(f, name2, prefix) {
        if (typeof name2 === "symbol") name2 = name2.description ? "[".concat(name2.description, "]") : "";
        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name2) : name2 });
      };
      __classPrivateFieldGet = function(receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      rootIno = 0;
      maxDynamicData = 3968;
      Attribute = (() => {
        var _Attribute_keySize_accessor_storage, _Attribute_valueSize_accessor_storage;
        var _a6, _b3;
        let _classDecorators = [struct(packed)];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = Uint8Array;
        let _keySize_decorators;
        let _keySize_initializers = [];
        let _keySize_extraInitializers = [];
        let _valueSize_decorators;
        let _valueSize_initializers = [];
        let _valueSize_extraInitializers = [];
        var Attribute2 = _classThis = class extends _classSuper {
          get keySize() {
            return __classPrivateFieldGet(this, _Attribute_keySize_accessor_storage, "f");
          }
          set keySize(value) {
            __classPrivateFieldSet(this, _Attribute_keySize_accessor_storage, value, "f");
          }
          get valueSize() {
            return __classPrivateFieldGet(this, _Attribute_valueSize_accessor_storage, "f");
          }
          set valueSize(value) {
            __classPrivateFieldSet(this, _Attribute_valueSize_accessor_storage, value, "f");
          }
          get name() {
            return decodeUTF8(this.subarray(8, 8 + this.keySize));
          }
          /**
           * Note that this does not handle moving the data.
           * Changing the name after setting the value is undefined behavior and will lead to corruption.
           * This should only be used when creating a new attribute.
           */
          set name(value) {
            const buf = encodeUTF8(value);
            if (8 + buf.length + this.valueSize > maxDynamicData)
              throw withErrno("EOVERFLOW");
            this.set(buf, 8);
            this.keySize = buf.length;
          }
          get value() {
            return this.subarray(8 + this.keySize, this.size);
          }
          set value(value) {
            if (8 + this.keySize + value.length > maxDynamicData)
              throw withErrno("EOVERFLOW");
            this.valueSize = value.length;
            this.set(value, 8 + this.keySize);
          }
          get size() {
            return 8 + this.keySize + this.valueSize;
          }
          constructor() {
            super(...arguments);
            _Attribute_keySize_accessor_storage.set(this, __runInitializers(this, _keySize_initializers, void 0));
            _Attribute_valueSize_accessor_storage.set(this, (__runInitializers(this, _keySize_extraInitializers), __runInitializers(this, _valueSize_initializers, void 0)));
            __runInitializers(this, _valueSize_extraInitializers);
          }
        };
        _Attribute_keySize_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Attribute_valueSize_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName(_classThis, "Attribute");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _keySize_decorators = [(_a7 = types2).uint32.bind(_a7)];
          _valueSize_decorators = [(_b3 = types2).uint32.bind(_b3)];
          __esDecorate(_classThis, null, _keySize_decorators, { kind: "accessor", name: "keySize", static: false, private: false, access: { has: (obj) => "keySize" in obj, get: (obj) => obj.keySize, set: (obj, value) => {
            obj.keySize = value;
          } }, metadata: _metadata }, _keySize_initializers, _keySize_extraInitializers);
          __esDecorate(_classThis, null, _valueSize_decorators, { kind: "accessor", name: "valueSize", static: false, private: false, access: { has: (obj) => "valueSize" in obj, get: (obj) => obj.valueSize, set: (obj, value) => {
            obj.valueSize = value;
          } }, metadata: _metadata }, _valueSize_initializers, _valueSize_extraInitializers);
          __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          Attribute2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers(_classThis, _classExtraInitializers);
        })();
        return Attribute2 = _classThis;
      })();
      Attributes = (() => {
        var _Attributes_size_accessor_storage;
        var _a6;
        let _classDecorators = [struct(packed)];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = BufferView;
        let _size_decorators;
        let _size_initializers = [];
        let _size_extraInitializers = [];
        var Attributes2 = _classThis = class extends _classSuper {
          get size() {
            return __classPrivateFieldGet(this, _Attributes_size_accessor_storage, "f");
          }
          set size(value) {
            __classPrivateFieldSet(this, _Attributes_size_accessor_storage, value, "f");
          }
          get byteSize() {
            let offset = this.byteOffset + sizeof(this);
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              offset += entry.size;
            }
            return offset;
          }
          has(name2) {
            let offset = this.byteOffset + sizeof(this);
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              if (entry.name == name2)
                return true;
              offset += entry.size;
            }
            return false;
          }
          get(name2) {
            let offset = this.byteOffset + sizeof(this);
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              if (entry.name == name2)
                return entry.value;
              offset += entry.size;
            }
          }
          set(name2, value) {
            let offset = this.byteOffset + sizeof(this);
            let remove3;
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              if (entry.name == name2)
                remove3 = [offset, entry.size];
              offset += entry.size;
            }
            const buf = new Uint8Array(this.buffer);
            if (remove3) {
              const [start, size] = remove3;
              offset -= size;
              buf.copyWithin(start, start + size, offset + size);
              buf.fill(0, offset, offset + size);
              this.size--;
            }
            const attr = new Attribute(this.buffer, offset);
            attr.name = name2;
            attr.value = value;
            this.size++;
          }
          remove(name2) {
            let offset = this.byteOffset + sizeof(this);
            let remove3;
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              if (entry.name == name2)
                remove3 = [offset, entry.size];
              offset += entry.size;
            }
            if (!remove3)
              return false;
            const [start, size] = remove3;
            const buf = new Uint8Array(this.buffer);
            buf.copyWithin(start, start + size, offset);
            buf.fill(0, offset - size, offset);
            this.size--;
            return true;
          }
          copyFrom(other) {
            const { byteSize } = other;
            new Uint8Array(this.buffer, this.byteOffset, byteSize).set(new Uint8Array(other.buffer, other.byteOffset, byteSize));
          }
          *keys() {
            let offset = this.byteOffset + sizeof(this);
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              yield entry.name;
              offset += entry.size;
            }
          }
          *values() {
            let offset = this.byteOffset + sizeof(this);
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              yield entry.value;
              offset += entry.size;
            }
          }
          *entries() {
            let offset = this.byteOffset + sizeof(this);
            for (let i2 = 0; i2 < this.size; i2++) {
              const entry = new Attribute(this.buffer, offset);
              yield [entry.name, entry.value];
              offset += entry.size;
            }
          }
          constructor() {
            super(...arguments);
            _Attributes_size_accessor_storage.set(this, __runInitializers(this, _size_initializers, void 0));
            __runInitializers(this, _size_extraInitializers);
          }
        };
        _Attributes_size_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName(_classThis, "Attributes");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _size_decorators = [(_a7 = types2).uint32.bind(_a7)];
          __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: (obj) => "size" in obj, get: (obj) => obj.size, set: (obj, value) => {
            obj.size = value;
          } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
          __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          Attributes2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers(_classThis, _classExtraInitializers);
        })();
        return Attributes2 = _classThis;
      })();
      _inode_fields = [
        "ino",
        "data",
        "size",
        "mode",
        "flags",
        "nlink",
        "uid",
        "gid",
        "atimeMs",
        "birthtimeMs",
        "mtimeMs",
        "ctimeMs",
        "version"
      ];
      _inode_version = 5;
      (function(InodeFlags2) {
        InodeFlags2[InodeFlags2["Sync"] = 1] = "Sync";
        InodeFlags2[InodeFlags2["NoAtime"] = 2] = "NoAtime";
        InodeFlags2[InodeFlags2["Append"] = 4] = "Append";
        InodeFlags2[InodeFlags2["Immutable"] = 8] = "Immutable";
        InodeFlags2[InodeFlags2["Dead"] = 16] = "Dead";
        InodeFlags2[InodeFlags2["NoQuota"] = 32] = "NoQuota";
        InodeFlags2[InodeFlags2["Dirsync"] = 64] = "Dirsync";
        InodeFlags2[InodeFlags2["NoCMtime"] = 128] = "NoCMtime";
        InodeFlags2[InodeFlags2["SwapFile"] = 256] = "SwapFile";
        InodeFlags2[InodeFlags2["Private"] = 512] = "Private";
        InodeFlags2[InodeFlags2["IMA"] = 1024] = "IMA";
        InodeFlags2[InodeFlags2["AutoMount"] = 2048] = "AutoMount";
        InodeFlags2[InodeFlags2["NoSec"] = 4096] = "NoSec";
        InodeFlags2[InodeFlags2["DAX"] = 8192] = "DAX";
        InodeFlags2[InodeFlags2["Encrypted"] = 16384] = "Encrypted";
        InodeFlags2[InodeFlags2["CaseFold"] = 32768] = "CaseFold";
        InodeFlags2[InodeFlags2["Verity"] = 65536] = "Verity";
        InodeFlags2[InodeFlags2["KernelFile"] = 131072] = "KernelFile";
      })(InodeFlags || (InodeFlags = {}));
      userVisibleFlags = 253951;
      userModifiableFlags = 229631;
      Inode = (() => {
        var _Inode_data_accessor_storage, _Inode___data_old_accessor_storage, _Inode_size_accessor_storage, _Inode_mode_accessor_storage, _Inode_nlink_accessor_storage, _Inode_uid_accessor_storage, _Inode_gid_accessor_storage, _Inode_atimeMs_accessor_storage, _Inode_birthtimeMs_accessor_storage, _Inode_mtimeMs_accessor_storage, _Inode_ctimeMs_accessor_storage, _Inode_ino_accessor_storage, _Inode___ino_old_accessor_storage, _Inode_flags_accessor_storage, _Inode___after_flags_accessor_storage, _Inode_version_accessor_storage, _Inode___padding_accessor_storage, _Inode_attributes_accessor_storage, _Inode___data_accessor_storage;
        var _a6, _b3, _c2, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        let _classDecorators = [struct(packed)];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = BufferView;
        let _data_decorators;
        let _data_initializers = [];
        let _data_extraInitializers = [];
        let ___data_old_decorators;
        let ___data_old_initializers = [];
        let ___data_old_extraInitializers = [];
        let _size_decorators;
        let _size_initializers = [];
        let _size_extraInitializers = [];
        let _mode_decorators;
        let _mode_initializers = [];
        let _mode_extraInitializers = [];
        let _nlink_decorators;
        let _nlink_initializers = [];
        let _nlink_extraInitializers = [];
        let _uid_decorators;
        let _uid_initializers = [];
        let _uid_extraInitializers = [];
        let _gid_decorators;
        let _gid_initializers = [];
        let _gid_extraInitializers = [];
        let _atimeMs_decorators;
        let _atimeMs_initializers = [];
        let _atimeMs_extraInitializers = [];
        let _birthtimeMs_decorators;
        let _birthtimeMs_initializers = [];
        let _birthtimeMs_extraInitializers = [];
        let _mtimeMs_decorators;
        let _mtimeMs_initializers = [];
        let _mtimeMs_extraInitializers = [];
        let _ctimeMs_decorators;
        let _ctimeMs_initializers = [];
        let _ctimeMs_extraInitializers = [];
        let _ino_decorators;
        let _ino_initializers = [];
        let _ino_extraInitializers = [];
        let ___ino_old_decorators;
        let ___ino_old_initializers = [];
        let ___ino_old_extraInitializers = [];
        let _flags_decorators;
        let _flags_initializers = [];
        let _flags_extraInitializers = [];
        let ___after_flags_decorators;
        let ___after_flags_initializers = [];
        let ___after_flags_extraInitializers = [];
        let _version_decorators;
        let _version_initializers = [];
        let _version_extraInitializers = [];
        let ___padding_decorators;
        let ___padding_initializers = [];
        let ___padding_extraInitializers = [];
        let _attributes_decorators;
        let _attributes_initializers = [];
        let _attributes_extraInitializers = [];
        let ___data_decorators;
        let ___data_initializers = [];
        let ___data_extraInitializers = [];
        var Inode2 = _classThis = class extends _classSuper {
          constructor(...args) {
            let data = {};
            if (typeof args[0] === "object" && args[0] !== null && !ArrayBuffer.isView(args[0])) {
              data = args[0];
              args = [sizeof(Inode2)];
            }
            super(...args);
            _Inode_data_accessor_storage.set(this, __runInitializers(this, _data_initializers, void 0));
            _Inode___data_old_accessor_storage.set(this, (__runInitializers(this, _data_extraInitializers), __runInitializers(this, ___data_old_initializers, void 0)));
            _Inode_size_accessor_storage.set(this, (__runInitializers(this, ___data_old_extraInitializers), __runInitializers(this, _size_initializers, void 0)));
            _Inode_mode_accessor_storage.set(this, (__runInitializers(this, _size_extraInitializers), __runInitializers(this, _mode_initializers, void 0)));
            _Inode_nlink_accessor_storage.set(this, (__runInitializers(this, _mode_extraInitializers), __runInitializers(this, _nlink_initializers, void 0)));
            _Inode_uid_accessor_storage.set(this, (__runInitializers(this, _nlink_extraInitializers), __runInitializers(this, _uid_initializers, void 0)));
            _Inode_gid_accessor_storage.set(this, (__runInitializers(this, _uid_extraInitializers), __runInitializers(this, _gid_initializers, void 0)));
            _Inode_atimeMs_accessor_storage.set(this, (__runInitializers(this, _gid_extraInitializers), __runInitializers(this, _atimeMs_initializers, void 0)));
            _Inode_birthtimeMs_accessor_storage.set(this, (__runInitializers(this, _atimeMs_extraInitializers), __runInitializers(this, _birthtimeMs_initializers, void 0)));
            _Inode_mtimeMs_accessor_storage.set(this, (__runInitializers(this, _birthtimeMs_extraInitializers), __runInitializers(this, _mtimeMs_initializers, void 0)));
            _Inode_ctimeMs_accessor_storage.set(this, (__runInitializers(this, _mtimeMs_extraInitializers), __runInitializers(this, _ctimeMs_initializers, void 0)));
            _Inode_ino_accessor_storage.set(this, (__runInitializers(this, _ctimeMs_extraInitializers), __runInitializers(this, _ino_initializers, void 0)));
            _Inode___ino_old_accessor_storage.set(this, (__runInitializers(this, _ino_extraInitializers), __runInitializers(this, ___ino_old_initializers, void 0)));
            _Inode_flags_accessor_storage.set(this, (__runInitializers(this, ___ino_old_extraInitializers), __runInitializers(this, _flags_initializers, void 0)));
            _Inode___after_flags_accessor_storage.set(this, (__runInitializers(this, _flags_extraInitializers), __runInitializers(this, ___after_flags_initializers, void 0)));
            _Inode_version_accessor_storage.set(this, (__runInitializers(this, ___after_flags_extraInitializers), __runInitializers(this, _version_initializers, void 0)));
            _Inode___padding_accessor_storage.set(this, (__runInitializers(this, _version_extraInitializers), __runInitializers(this, ___padding_initializers, void 0)));
            _Inode_attributes_accessor_storage.set(this, (__runInitializers(this, ___padding_extraInitializers), __runInitializers(this, _attributes_initializers, void 0)));
            _Inode___data_accessor_storage.set(this, (__runInitializers(this, _attributes_extraInitializers), __runInitializers(this, ___data_initializers, void 0)));
            __runInitializers(this, ___data_extraInitializers);
            if (this.byteLength < sizeof(Inode2)) {
              throw crit(withErrno("EIO", `Buffer is too small to create an inode (${this.byteLength} bytes)`));
            }
            Object.assign(this, data);
            this.atimeMs || (this.atimeMs = Date.now());
            this.mtimeMs || (this.mtimeMs = Date.now());
            this.ctimeMs || (this.ctimeMs = Date.now());
            this.birthtimeMs || (this.birthtimeMs = Date.now());
            if (this.ino && !this.nlink) {
              warn(`Inode ${this.ino} has an nlink of 0`);
            }
          }
          get data() {
            return __classPrivateFieldGet(this, _Inode_data_accessor_storage, "f");
          }
          set data(value) {
            __classPrivateFieldSet(this, _Inode_data_accessor_storage, value, "f");
          }
          /** For future use */
          get __data_old() {
            return __classPrivateFieldGet(this, _Inode___data_old_accessor_storage, "f");
          }
          set __data_old(value) {
            __classPrivateFieldSet(this, _Inode___data_old_accessor_storage, value, "f");
          }
          get size() {
            return __classPrivateFieldGet(this, _Inode_size_accessor_storage, "f");
          }
          set size(value) {
            __classPrivateFieldSet(this, _Inode_size_accessor_storage, value, "f");
          }
          get mode() {
            return __classPrivateFieldGet(this, _Inode_mode_accessor_storage, "f");
          }
          set mode(value) {
            __classPrivateFieldSet(this, _Inode_mode_accessor_storage, value, "f");
          }
          get nlink() {
            return __classPrivateFieldGet(this, _Inode_nlink_accessor_storage, "f");
          }
          set nlink(value) {
            __classPrivateFieldSet(this, _Inode_nlink_accessor_storage, value, "f");
          }
          get uid() {
            return __classPrivateFieldGet(this, _Inode_uid_accessor_storage, "f");
          }
          set uid(value) {
            __classPrivateFieldSet(this, _Inode_uid_accessor_storage, value, "f");
          }
          get gid() {
            return __classPrivateFieldGet(this, _Inode_gid_accessor_storage, "f");
          }
          set gid(value) {
            __classPrivateFieldSet(this, _Inode_gid_accessor_storage, value, "f");
          }
          get atimeMs() {
            return __classPrivateFieldGet(this, _Inode_atimeMs_accessor_storage, "f");
          }
          set atimeMs(value) {
            __classPrivateFieldSet(this, _Inode_atimeMs_accessor_storage, value, "f");
          }
          get birthtimeMs() {
            return __classPrivateFieldGet(this, _Inode_birthtimeMs_accessor_storage, "f");
          }
          set birthtimeMs(value) {
            __classPrivateFieldSet(this, _Inode_birthtimeMs_accessor_storage, value, "f");
          }
          get mtimeMs() {
            return __classPrivateFieldGet(this, _Inode_mtimeMs_accessor_storage, "f");
          }
          set mtimeMs(value) {
            __classPrivateFieldSet(this, _Inode_mtimeMs_accessor_storage, value, "f");
          }
          /**
           * The time the inode was changed.
           *
           * This is automatically updated whenever changed are made using `update()`.
           */
          get ctimeMs() {
            return __classPrivateFieldGet(this, _Inode_ctimeMs_accessor_storage, "f");
          }
          set ctimeMs(value) {
            __classPrivateFieldSet(this, _Inode_ctimeMs_accessor_storage, value, "f");
          }
          get ino() {
            return __classPrivateFieldGet(this, _Inode_ino_accessor_storage, "f");
          }
          set ino(value) {
            __classPrivateFieldSet(this, _Inode_ino_accessor_storage, value, "f");
          }
          /** For future use */
          get __ino_old() {
            return __classPrivateFieldGet(this, _Inode___ino_old_accessor_storage, "f");
          }
          set __ino_old(value) {
            __classPrivateFieldSet(this, _Inode___ino_old_accessor_storage, value, "f");
          }
          get flags() {
            return __classPrivateFieldGet(this, _Inode_flags_accessor_storage, "f");
          }
          set flags(value) {
            __classPrivateFieldSet(this, _Inode_flags_accessor_storage, value, "f");
          }
          /** For future use */
          get __after_flags() {
            return __classPrivateFieldGet(this, _Inode___after_flags_accessor_storage, "f");
          }
          set __after_flags(value) {
            __classPrivateFieldSet(this, _Inode___after_flags_accessor_storage, value, "f");
          }
          /**
           * The "version" of the inode/data.
           * Unrelated to the inode format!
           */
          get version() {
            return __classPrivateFieldGet(this, _Inode_version_accessor_storage, "f");
          }
          set version(value) {
            __classPrivateFieldSet(this, _Inode_version_accessor_storage, value, "f");
          }
          /**
           * Padding up to 128 bytes.
           * This ensures there is enough room for expansion without breaking the ABI.
           * @internal
           */
          get __padding() {
            return __classPrivateFieldGet(this, _Inode___padding_accessor_storage, "f");
          }
          set __padding(value) {
            __classPrivateFieldSet(this, _Inode___padding_accessor_storage, value, "f");
          }
          get attributes() {
            return __classPrivateFieldGet(this, _Inode_attributes_accessor_storage, "f");
          }
          set attributes(value) {
            __classPrivateFieldSet(this, _Inode_attributes_accessor_storage, value, "f");
          }
          /**
           * Since the attribute data uses dynamic arrays,
           * it is necessary to add this so attributes can be added.
           * @internal @hidden
           */
          get __data() {
            return __classPrivateFieldGet(this, _Inode___data_accessor_storage, "f");
          }
          set __data(value) {
            __classPrivateFieldSet(this, _Inode___data_accessor_storage, value, "f");
          }
          toString() {
            return `<Inode ${this.ino}>`;
          }
          toJSON() {
            return {
              ...pick(this, _inode_fields),
              attributes: this.attributes
            };
          }
          /**
           * Handy function that converts the Inode to a Node Stats object.
           */
          toStats() {
            return new Stats(this);
          }
          /**
           * Updates the Inode using information from the stats object. Used by file
           * systems at sync time, e.g.:
           * - Program opens file and gets a File object.
           * - Program mutates file. File object is responsible for maintaining
           *   metadata changes locally -- typically in a Stats object.
           * - Program closes file. File object's metadata changes are synced with the
           *   file system.
           * @returns whether any changes have occurred.
           */
          update(data) {
            if (!data)
              return false;
            let hasChanged = false;
            for (const key of _inode_fields) {
              if (data[key] === void 0)
                continue;
              if (key == "ino" || key == "data")
                continue;
              if (this[key] === data[key])
                continue;
              if (key == "atimeMs" && this.flags & InodeFlags.NoAtime)
                continue;
              this[key] = data[key];
              hasChanged = true;
            }
            if (data.attributes) {
              this.attributes.copyFrom(data.attributes);
              hasChanged = true;
            }
            if (hasChanged)
              this.ctimeMs = Date.now();
            return hasChanged;
          }
        };
        _Inode_data_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode___data_old_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_size_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_mode_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_nlink_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_uid_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_gid_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_atimeMs_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_birthtimeMs_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_mtimeMs_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_ctimeMs_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_ino_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode___ino_old_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_flags_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode___after_flags_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_version_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode___padding_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode_attributes_accessor_storage = /* @__PURE__ */ new WeakMap();
        _Inode___data_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName(_classThis, "Inode");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _data_decorators = [(_a7 = types2).uint32.bind(_a7)];
          ___data_old_decorators = [(_b3 = types2).uint32.bind(_b3)];
          _size_decorators = [(_c2 = types2).uint32.bind(_c2)];
          _mode_decorators = [(_d = types2).uint16.bind(_d)];
          _nlink_decorators = [(_e = types2).uint32.bind(_e)];
          _uid_decorators = [(_f = types2).uint32.bind(_f)];
          _gid_decorators = [(_g = types2).uint32.bind(_g)];
          _atimeMs_decorators = [(_h = types2).float64.bind(_h)];
          _birthtimeMs_decorators = [(_j = types2).float64.bind(_j)];
          _mtimeMs_decorators = [(_k = types2).float64.bind(_k)];
          _ctimeMs_decorators = [(_l = types2).float64.bind(_l)];
          _ino_decorators = [(_m = types2).uint32.bind(_m)];
          ___ino_old_decorators = [(_o = types2).uint32.bind(_o)];
          _flags_decorators = [(_p = types2).uint32.bind(_p)];
          ___after_flags_decorators = [(_q = types2).uint16.bind(_q)];
          _version_decorators = [(_r = types2).uint32.bind(_r)];
          ___padding_decorators = [types2.uint8(48)];
          _attributes_decorators = [field(Attributes)];
          ___data_decorators = [types2.uint8(maxDynamicData)];
          __esDecorate(_classThis, null, _data_decorators, { kind: "accessor", name: "data", static: false, private: false, access: { has: (obj) => "data" in obj, get: (obj) => obj.data, set: (obj, value) => {
            obj.data = value;
          } }, metadata: _metadata }, _data_initializers, _data_extraInitializers);
          __esDecorate(_classThis, null, ___data_old_decorators, { kind: "accessor", name: "__data_old", static: false, private: false, access: { has: (obj) => "__data_old" in obj, get: (obj) => obj.__data_old, set: (obj, value) => {
            obj.__data_old = value;
          } }, metadata: _metadata }, ___data_old_initializers, ___data_old_extraInitializers);
          __esDecorate(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: (obj) => "size" in obj, get: (obj) => obj.size, set: (obj, value) => {
            obj.size = value;
          } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
          __esDecorate(_classThis, null, _mode_decorators, { kind: "accessor", name: "mode", static: false, private: false, access: { has: (obj) => "mode" in obj, get: (obj) => obj.mode, set: (obj, value) => {
            obj.mode = value;
          } }, metadata: _metadata }, _mode_initializers, _mode_extraInitializers);
          __esDecorate(_classThis, null, _nlink_decorators, { kind: "accessor", name: "nlink", static: false, private: false, access: { has: (obj) => "nlink" in obj, get: (obj) => obj.nlink, set: (obj, value) => {
            obj.nlink = value;
          } }, metadata: _metadata }, _nlink_initializers, _nlink_extraInitializers);
          __esDecorate(_classThis, null, _uid_decorators, { kind: "accessor", name: "uid", static: false, private: false, access: { has: (obj) => "uid" in obj, get: (obj) => obj.uid, set: (obj, value) => {
            obj.uid = value;
          } }, metadata: _metadata }, _uid_initializers, _uid_extraInitializers);
          __esDecorate(_classThis, null, _gid_decorators, { kind: "accessor", name: "gid", static: false, private: false, access: { has: (obj) => "gid" in obj, get: (obj) => obj.gid, set: (obj, value) => {
            obj.gid = value;
          } }, metadata: _metadata }, _gid_initializers, _gid_extraInitializers);
          __esDecorate(_classThis, null, _atimeMs_decorators, { kind: "accessor", name: "atimeMs", static: false, private: false, access: { has: (obj) => "atimeMs" in obj, get: (obj) => obj.atimeMs, set: (obj, value) => {
            obj.atimeMs = value;
          } }, metadata: _metadata }, _atimeMs_initializers, _atimeMs_extraInitializers);
          __esDecorate(_classThis, null, _birthtimeMs_decorators, { kind: "accessor", name: "birthtimeMs", static: false, private: false, access: { has: (obj) => "birthtimeMs" in obj, get: (obj) => obj.birthtimeMs, set: (obj, value) => {
            obj.birthtimeMs = value;
          } }, metadata: _metadata }, _birthtimeMs_initializers, _birthtimeMs_extraInitializers);
          __esDecorate(_classThis, null, _mtimeMs_decorators, { kind: "accessor", name: "mtimeMs", static: false, private: false, access: { has: (obj) => "mtimeMs" in obj, get: (obj) => obj.mtimeMs, set: (obj, value) => {
            obj.mtimeMs = value;
          } }, metadata: _metadata }, _mtimeMs_initializers, _mtimeMs_extraInitializers);
          __esDecorate(_classThis, null, _ctimeMs_decorators, { kind: "accessor", name: "ctimeMs", static: false, private: false, access: { has: (obj) => "ctimeMs" in obj, get: (obj) => obj.ctimeMs, set: (obj, value) => {
            obj.ctimeMs = value;
          } }, metadata: _metadata }, _ctimeMs_initializers, _ctimeMs_extraInitializers);
          __esDecorate(_classThis, null, _ino_decorators, { kind: "accessor", name: "ino", static: false, private: false, access: { has: (obj) => "ino" in obj, get: (obj) => obj.ino, set: (obj, value) => {
            obj.ino = value;
          } }, metadata: _metadata }, _ino_initializers, _ino_extraInitializers);
          __esDecorate(_classThis, null, ___ino_old_decorators, { kind: "accessor", name: "__ino_old", static: false, private: false, access: { has: (obj) => "__ino_old" in obj, get: (obj) => obj.__ino_old, set: (obj, value) => {
            obj.__ino_old = value;
          } }, metadata: _metadata }, ___ino_old_initializers, ___ino_old_extraInitializers);
          __esDecorate(_classThis, null, _flags_decorators, { kind: "accessor", name: "flags", static: false, private: false, access: { has: (obj) => "flags" in obj, get: (obj) => obj.flags, set: (obj, value) => {
            obj.flags = value;
          } }, metadata: _metadata }, _flags_initializers, _flags_extraInitializers);
          __esDecorate(_classThis, null, ___after_flags_decorators, { kind: "accessor", name: "__after_flags", static: false, private: false, access: { has: (obj) => "__after_flags" in obj, get: (obj) => obj.__after_flags, set: (obj, value) => {
            obj.__after_flags = value;
          } }, metadata: _metadata }, ___after_flags_initializers, ___after_flags_extraInitializers);
          __esDecorate(_classThis, null, _version_decorators, { kind: "accessor", name: "version", static: false, private: false, access: { has: (obj) => "version" in obj, get: (obj) => obj.version, set: (obj, value) => {
            obj.version = value;
          } }, metadata: _metadata }, _version_initializers, _version_extraInitializers);
          __esDecorate(_classThis, null, ___padding_decorators, { kind: "accessor", name: "__padding", static: false, private: false, access: { has: (obj) => "__padding" in obj, get: (obj) => obj.__padding, set: (obj, value) => {
            obj.__padding = value;
          } }, metadata: _metadata }, ___padding_initializers, ___padding_extraInitializers);
          __esDecorate(_classThis, null, _attributes_decorators, { kind: "accessor", name: "attributes", static: false, private: false, access: { has: (obj) => "attributes" in obj, get: (obj) => obj.attributes, set: (obj, value) => {
            obj.attributes = value;
          } }, metadata: _metadata }, _attributes_initializers, _attributes_extraInitializers);
          __esDecorate(_classThis, null, ___data_decorators, { kind: "accessor", name: "__data", static: false, private: false, access: { has: (obj) => "__data" in obj, get: (obj) => obj.__data, set: (obj, value) => {
            obj.__data = value;
          } }, metadata: _metadata }, ___data_initializers, ___data_extraInitializers);
          __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          Inode2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers(_classThis, _classExtraInitializers);
        })();
        return Inode2 = _classThis;
      })();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/file_index.js
  var version, Index;
  var init_file_index = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/file_index.js"() {
      init_dist2();
      init_dist3();
      init_dist();
      init_path();
      init_constants();
      init_inode();
      version = 1;
      Index = class _Index extends Map {
        constructor() {
          super(...arguments);
          this.maxSize = size_max;
        }
        /**
         * Converts the index to JSON
         */
        toJSON() {
          return {
            version,
            maxSize: this.maxSize,
            entries: Object.fromEntries([...this].map(([k, v]) => [k, v.toJSON()]))
          };
        }
        /**
         * Converts the index to a string
         */
        toString() {
          return JSON.stringify(this.toJSON());
        }
        /**
         * Get the size in bytes of the index (including the size reported for each entry)
         */
        get byteSize() {
          let size = this.size * sizeof(Inode);
          for (const entry of this.values())
            size += entry.size;
          return size;
        }
        usage() {
          return {
            totalSpace: this.maxSize,
            freeSpace: this.maxSize - this.byteSize
          };
        }
        pathOf(id) {
          for (const [path3, inode] of this) {
            if (inode.ino == id || inode.data == id)
              return path3;
          }
        }
        getByID(id) {
          var _a6;
          return (_a6 = this.entryByID(id)) === null || _a6 === void 0 ? void 0 : _a6.inode;
        }
        entryByID(id) {
          for (const [path3, inode] of this) {
            if (inode.ino == id || inode.data == id)
              return { path: path3, inode };
          }
        }
        directoryEntries(path3) {
          const node = this.get(path3);
          if (!node)
            throw withErrno("ENOENT");
          if ((node.mode & S_IFMT) != S_IFDIR)
            throw withErrno("ENOTDIR");
          const entries2 = {};
          for (const entry of this.keys()) {
            if (dirname(entry) == path3 && entry != path3) {
              entries2[basename(entry)] = this.get(entry).ino;
            }
          }
          return entries2;
        }
        /**
         * Get the next available ID in the index
         * @internal
         */
        _alloc() {
          return Math.max(...[...this.values()].flatMap((i2) => [i2.ino, i2.data])) + 1;
        }
        /**
         * Gets a list of entries for each directory in the index.
         * Use
         */
        directories() {
          const dirs = /* @__PURE__ */ new Map();
          for (const [path3, node] of this) {
            if ((node.mode & S_IFMT) != S_IFDIR)
              continue;
            const entries2 = {};
            for (const entry of this.keys()) {
              if (dirname(entry) == path3 && entry != path3)
                entries2[basename(entry)] = this.get(entry).ino;
            }
            dirs.set(path3, entries2);
          }
          return dirs;
        }
        /**
         * Loads the index from JSON data
         */
        fromJSON(json) {
          var _a6;
          if (json.version != version)
            throw withErrno("EINVAL", "Index version mismatch");
          this.clear();
          for (const [path3, node] of Object.entries(json.entries)) {
            (_a6 = node.data) !== null && _a6 !== void 0 ? _a6 : node.data = randomInt(1, size_max);
            if (path3 == "/")
              node.ino = 0;
            this.set(path3, new Inode(node));
          }
          return this;
        }
        /**
         * Parses an index from a string
         */
        static parse(data) {
          if (!isJSON(data))
            throw withErrno("EINVAL", "Invalid JSON");
          const json = JSON.parse(data);
          const index2 = new _Index();
          index2.fromJSON(json);
          return index2;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/filesystem.js
  var _chunkSize, FileSystem;
  var init_filesystem = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/filesystem.js"() {
      _chunkSize = 4096;
      FileSystem = class _FileSystem {
        get uuid() {
          return this._uuid;
        }
        constructor(type, name2) {
          this.type = type;
          this.name = name2;
          this._uuid = crypto.randomUUID();
          this.attributes = /* @__PURE__ */ new Map();
          if (this.streamRead === _FileSystem.prototype.streamRead)
            this.attributes.set("default_stream_read");
          if (this.streamWrite === _FileSystem.prototype.streamWrite)
            this.attributes.set("default_stream_write");
        }
        toString() {
          return `${this.name} ${this.label ? JSON.stringify(this.label) : ""} (${this._mountPoint ? "mounted on " + this._mountPoint : "unmounted"})`;
        }
        /**
         * Default implementation.
         * @todo Implement
         * @experimental
         */
        usage() {
          return {
            totalSpace: 0,
            freeSpace: 0
          };
        }
        async ready() {
        }
        /**
         * Test whether or not `path` exists.
         */
        async exists(path3) {
          try {
            await this.stat(path3);
            return true;
          } catch (e2) {
            return e2.code != "ENOENT";
          }
        }
        /**
         * Test whether or not `path` exists.
         */
        existsSync(path3) {
          try {
            this.statSync(path3);
            return true;
          } catch (e2) {
            return e2.code != "ENOENT";
          }
        }
        /**
         * Read a file using a stream.
         * @privateRemarks The default implementation of `streamRead` uses "chunked" `read`s
         */
        streamRead(path3, options) {
          return new ReadableStream({
            start: async (controller) => {
              const { size } = await this.stat(path3);
              const { start = 0, end = size } = options;
              for (let offset = start; offset < end; offset += _chunkSize) {
                const bytesRead = offset + _chunkSize > end ? end - offset : _chunkSize;
                const buffer = new Uint8Array(bytesRead);
                await this.read(path3, buffer, offset, offset + bytesRead).catch(controller.error.bind(controller));
                controller.enqueue(buffer);
              }
              controller.close();
            },
            type: "bytes"
          });
        }
        /**
         * Write a file using stream.
         * @privateRemarks The default implementation of `streamWrite` uses "chunked" `write`s
         */
        streamWrite(path3, options) {
          var _a6;
          let position = (_a6 = options.start) !== null && _a6 !== void 0 ? _a6 : 0;
          return new WritableStream({
            write: async (chunk, controller) => {
              let err3 = false;
              const _err = (ex) => {
                err3 = true;
                controller.error(ex);
              };
              const { size } = await this.stat(path3);
              await this.write(path3, chunk, position).catch(_err);
              if (err3)
                return;
              position += chunk.byteLength;
              await this.touch(path3, { mtimeMs: Date.now(), size: Math.max(size, position) }).catch(_err);
            }
          });
        }
      };
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/cache.js
  var Resource;
  var init_cache = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/cache.js"() {
      init_buffer();
      Resource = class {
        id;
        _size;
        options;
        /** Regions used to reduce unneeded allocations. Think of sparse arrays. */
        regions = [];
        /** The full size of the resource */
        get size() {
          return this._size;
        }
        set size(value) {
          if (value >= this._size) {
            this._size = value;
            return;
          }
          this._size = value;
          for (let i2 = this.regions.length - 1; i2 >= 0; i2--) {
            const region = this.regions[i2];
            if (region.offset >= value) {
              this.regions.splice(i2, 1);
              continue;
            }
            const maxLength = value - region.offset;
            if (region.data.byteLength > maxLength) {
              region.data = region.data.subarray(0, maxLength);
            }
            region.ranges = region.ranges.filter((range) => range.start < value).map((range) => {
              if (range.end > value) {
                return { start: range.start, end: value };
              }
              return range;
            });
          }
        }
        constructor(id, _size, options, resources) {
          this.id = id;
          this._size = _size;
          this.options = options;
          options.sparse ??= true;
          if (!options.sparse)
            this.regions.push({ offset: 0, data: new Uint8Array(_size), ranges: [] });
          resources?.set(id, this);
        }
        /** Combines adjacent regions and combines adjacent ranges within a region */
        collect() {
          if (!this.options.sparse)
            return;
          const { regionGapThreshold = 4095 } = this.options;
          for (let i2 = 0; i2 < this.regions.length - 1; ) {
            const current = this.regions[i2];
            const next = this.regions[i2 + 1];
            if (next.offset - (current.offset + current.data.byteLength) > regionGapThreshold) {
              i2++;
              continue;
            }
            current.ranges.push(...next.ranges);
            current.ranges.sort((a, b) => a.start - b.start);
            current.ranges = current.ranges.reduce((acc, range) => {
              if (!acc.length || acc.at(-1).end < range.start) {
                acc.push(range);
              } else {
                acc.at(-1).end = Math.max(acc.at(-1).end, range.end);
              }
              return acc;
            }, []);
            current.data = extendBuffer(current.data, next.offset + next.data.byteLength);
            current.data.set(next.data, next.offset - current.offset);
            this.regions.splice(i2 + 1, 1);
          }
        }
        /** Takes an initial range and finds the sub-ranges that are not in the cache */
        missing(start, end) {
          const missingRanges = [];
          for (const region of this.regions) {
            if (region.offset >= end)
              break;
            for (const range of region.ranges) {
              if (range.end <= start)
                continue;
              if (range.start >= end)
                break;
              if (range.start > start) {
                missingRanges.push({ start, end: Math.min(range.start, end) });
              }
              if (range.end > start)
                start = Math.max(start, range.end);
              if (start >= end)
                break;
            }
            if (start >= end)
              break;
          }
          if (start < end)
            missingRanges.push({ start, end });
          return missingRanges;
        }
        /**
         * Get the cached sub-ranges of an initial range.
         * This is conceptually the inverse of `missing`.
         */
        cached(start, end) {
          const cachedRanges = [];
          for (const region of this.regions) {
            if (region.offset >= end)
              break;
            for (const range of region.ranges) {
              if (range.end <= start)
                continue;
              if (range.start >= end)
                break;
              cachedRanges.push({
                start: Math.max(start, range.start),
                end: Math.min(end, range.end)
              });
            }
          }
          cachedRanges.sort((a, b) => a.start - b.start);
          const merged = [];
          for (const curr of cachedRanges) {
            const last = merged.at(-1);
            if (last && curr.start <= last.end) {
              last.end = Math.max(last.end, curr.end);
            } else {
              merged.push(curr);
            }
          }
          return merged;
        }
        /** Get the region who's ranges include an offset */
        regionAt(offset) {
          if (!this.regions.length)
            return;
          for (const region of this.regions) {
            if (region.offset > offset)
              break;
            if (offset >= region.offset && offset < region.offset + region.data.byteLength)
              return region;
          }
        }
        /** Add new data to the cache at given specified offset */
        add(data, offset) {
          const end = offset + data.byteLength;
          const region = this.regionAt(offset);
          if (region) {
            region.data = extendBuffer(region.data, end);
            region.data.set(data, offset);
            region.ranges.push({ start: offset, end });
            region.ranges.sort((a, b) => a.start - b.start);
            this.collect();
            return this;
          }
          const newRegion = { data, offset, ranges: [{ start: offset, end }] };
          const insertIndex = this.regions.findIndex((region2) => region2.offset > offset);
          if (insertIndex == -1) {
            this.regions.push(newRegion);
          } else {
            this.regions.splice(insertIndex, 0, newRegion);
          }
          this.collect();
          return this;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/polyfills.js
  var _a, _b, _c;
  var init_polyfills = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/polyfills.js"() {
      init_log();
      (_a = Promise.withResolvers) !== null && _a !== void 0 ? _a : Promise.withResolvers = (warn("Using a polyfill of Promise.withResolvers"), function() {
        let _resolve2, _reject;
        const promise = new Promise((resolve2, reject) => {
          _resolve2 = resolve2;
          _reject = reject;
        });
        return { promise, resolve: _resolve2, reject: _reject };
      });
      (_b = Symbol["dispose"]) !== null && _b !== void 0 ? _b : Symbol["dispose"] = (warn("Using a polyfill of Symbol.dispose"), Symbol("Symbol.dispose"));
      (_c = Symbol["asyncDispose"]) !== null && _c !== void 0 ? _c : Symbol["asyncDispose"] = (warn("Using a polyfill of Symbol.asyncDispose"), Symbol("Symbol.asyncDispose"));
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/store/store.js
  var Transaction, SyncTransaction, AsyncTransaction, WrappedTransaction;
  var init_store = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/store/store.js"() {
      init_dist2();
      init_log();
      init_cache();
      init_polyfills();
      Transaction = class {
        constructor(store) {
          this.store = store;
        }
      };
      SyncTransaction = class extends Transaction {
        /* eslint-disable @typescript-eslint/require-await */
        async get(id, offset, end) {
          return this.getSync(id, offset, end);
        }
        async set(id, data, offset) {
          return this.setSync(id, data, offset);
        }
        async remove(id) {
          return this.removeSync(id);
        }
      };
      AsyncTransaction = class extends Transaction {
        constructor() {
          super(...arguments);
          this.asyncDone = Promise.resolve();
        }
        /**
         * Run a asynchronous operation from a sync context. Not magic and subject to (race) conditions.
         * @internal
         */
        async(promise) {
          this.asyncDone = this.asyncDone.then(() => promise);
        }
        /**
         * Gets a cache resource
         * If `info` is set and the resource doesn't exist, it will be created
         * @internal
         */
        _cached(id, info2) {
          var _a6;
          var _b3;
          (_a6 = (_b3 = this.store).cache) !== null && _a6 !== void 0 ? _a6 : _b3.cache = /* @__PURE__ */ new Map();
          const resource = this.store.cache.get(id);
          if (!resource)
            return !info2 ? void 0 : new Resource(id, info2.size, {}, this.store.cache);
          if (info2)
            resource.size = info2.size;
          return resource;
        }
        getSync(id, offset, end) {
          const resource = this._cached(id);
          if (!resource)
            return;
          end !== null && end !== void 0 ? end : end = resource.size;
          const missing = resource.missing(offset, end);
          for (const { start, end: end2 } of missing) {
            this.async(this.get(id, start, end2));
          }
          if (missing.length)
            throw withErrno("EAGAIN");
          const region = resource.regionAt(offset);
          if (!region) {
            warn("Missing cache region for " + id);
            return;
          }
          return region.data.subarray(offset - region.offset, end - region.offset);
        }
        setSync(id, data, offset) {
          this.async(this.set(id, data, offset));
        }
        removeSync(id) {
          var _a6;
          this.async(this.remove(id));
          (_a6 = this.store.cache) === null || _a6 === void 0 ? void 0 : _a6.delete(id);
        }
      };
      WrappedTransaction = class {
        flag(flag) {
          var _a6, _b3;
          return (_b3 = (_a6 = this.raw.store.flags) === null || _a6 === void 0 ? void 0 : _a6.includes(flag)) !== null && _b3 !== void 0 ? _b3 : false;
        }
        constructor(raw, fs2) {
          this.raw = raw;
          this.fs = fs2;
          this.done = false;
          this.originalData = /* @__PURE__ */ new Map();
          this.modifiedKeys = /* @__PURE__ */ new Set();
        }
        keys() {
          return this.raw.keys();
        }
        async get(id, offset = 0, end) {
          const data = await this.raw.get(id, offset, end);
          this.stash(id);
          return data;
        }
        getSync(id, offset = 0, end) {
          const data = this.raw.getSync(id, offset, end);
          this.stash(id);
          return data;
        }
        async set(id, view2, offset = 0) {
          await this.markModified(id, offset, view2.byteLength);
          const buffer = view2 instanceof Uint8Array ? view2 : new Uint8Array(view2.buffer, view2.byteOffset, view2.byteLength);
          await this.raw.set(id, buffer, offset);
        }
        setSync(id, view2, offset = 0) {
          this.markModifiedSync(id, offset, view2.byteLength);
          const buffer = view2 instanceof Uint8Array ? view2 : new Uint8Array(view2.buffer, view2.byteOffset, view2.byteLength);
          this.raw.setSync(id, buffer, offset);
        }
        async remove(id) {
          await this.markModified(id, 0, void 0);
          await this.raw.remove(id);
        }
        removeSync(id) {
          this.markModifiedSync(id, 0, void 0);
          this.raw.removeSync(id);
        }
        commit() {
          this.done = true;
          return Promise.resolve();
        }
        commitSync() {
          this.done = true;
        }
        async abort() {
          if (this.done)
            return;
          for (const [id, entries2] of this.originalData) {
            if (!this.modifiedKeys.has(id))
              continue;
            if (entries2.some((ent) => !ent.data)) {
              await this.raw.remove(id);
              this.fs._remove(id);
              continue;
            }
            for (const entry of entries2.reverse()) {
              await this.raw.set(id, entry.data, entry.offset);
            }
          }
          this.done = true;
        }
        abortSync() {
          if (this.done)
            return;
          for (const [id, entries2] of this.originalData) {
            if (!this.modifiedKeys.has(id))
              continue;
            if (entries2.some((ent) => !ent.data)) {
              this.raw.removeSync(id);
              this.fs._remove(id);
              continue;
            }
            for (const entry of entries2.reverse()) {
              this.raw.setSync(id, entry.data, entry.offset);
            }
          }
          this.done = true;
        }
        async [Symbol.asyncDispose]() {
          if (this.done)
            return;
          await this.abort();
        }
        [Symbol.dispose]() {
          if (this.done)
            return;
          this.abortSync();
        }
        /**
         * Stashes given key value pair into `originalData` if it doesn't already exist.
         * Allows us to stash values the program is requesting anyway to
         * prevent needless `get` requests if the program modifies the data later
         * on during the transaction.
         */
        stash(id, data, offset = 0) {
          if (!this.originalData.has(id))
            this.originalData.set(id, []);
          this.originalData.get(id).push({ data, offset });
        }
        /**
         * Marks an id as modified, and stashes its value if it has not been stashed already.
         */
        async markModified(id, offset, length2) {
          this.modifiedKeys.add(id);
          const end = length2 ? offset + length2 : void 0;
          try {
            this.stash(id, await this.raw.get(id, offset, end), offset);
          } catch (e2) {
            if (!(this.raw instanceof AsyncTransaction))
              throw e2;
            const tx = this.raw;
            const resource = tx._cached(id);
            if (!resource)
              throw e2;
            for (const range of resource.cached(offset, end !== null && end !== void 0 ? end : offset)) {
              this.stash(id, await this.raw.get(id, range.start, range.end), range.start);
            }
          }
        }
        /**
         * Marks an id as modified, and stashes its value if it has not been stashed already.
         */
        markModifiedSync(id, offset, length2) {
          this.modifiedKeys.add(id);
          const end = length2 ? offset + length2 : void 0;
          try {
            this.stash(id, this.raw.getSync(id, offset, end), offset);
          } catch (e2) {
            if (!(this.raw instanceof AsyncTransaction))
              throw e2;
            const tx = this.raw;
            const resource = tx._cached(id);
            if (!resource)
              throw e2;
            for (const range of resource.cached(offset, end !== null && end !== void 0 ? end : offset)) {
              this.stash(id, this.raw.getSync(id, range.start, range.end), range.start);
            }
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/store/fs.js
  var __addDisposableResource, __disposeResources, StoreFS;
  var init_fs = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/store/fs.js"() {
      init_dist2();
      init_log();
      init_dist3();
      init_dist();
      init_buffer();
      init_file_index();
      init_filesystem();
      init_inode();
      init_path();
      init_utils();
      init_constants();
      init_store();
      __addDisposableResource = function(env, value, async) {
        if (value !== null && value !== void 0) {
          if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
          var dispose, inner;
          if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
          }
          if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
          }
          if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
          if (inner) dispose = function() {
            try {
              inner.call(this);
            } catch (e2) {
              return Promise.reject(e2);
            }
          };
          env.stack.push({ value, dispose, async });
        } else if (async) {
          env.stack.push({ async: true });
        }
        return value;
      };
      __disposeResources = /* @__PURE__ */ function(SuppressedError2) {
        return function(env) {
          function fail(e2) {
            env.error = env.hasError ? new SuppressedError2(e2, env.error, "An error was suppressed during disposal.") : e2;
            env.hasError = true;
          }
          var r2, s2 = 0;
          function next() {
            while (r2 = env.stack.pop()) {
              try {
                if (!r2.async && s2 === 1) return s2 = 0, env.stack.push(r2), Promise.resolve().then(next);
                if (r2.dispose) {
                  var result = r2.dispose.call(r2.value);
                  if (r2.async) return s2 |= 2, Promise.resolve(result).then(next, function(e2) {
                    fail(e2);
                    return next();
                  });
                } else s2 |= 1;
              } catch (e2) {
                fail(e2);
              }
            }
            if (s2 === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
            if (env.hasError) throw env.error;
          }
          return next();
        };
      }(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
        var e2 = new Error(message);
        return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
      });
      StoreFS = class extends FileSystem {
        /**
         * Gets the first path associated with an inode
         */
        _path(id) {
          var _a6;
          const [path3] = (_a6 = this._paths.get(id)) !== null && _a6 !== void 0 ? _a6 : [];
          return path3;
        }
        /**
         * Add a inode/path pair
         */
        _add(ino, path3) {
          if (!this._paths.has(ino))
            this._paths.set(ino, /* @__PURE__ */ new Set());
          this._paths.get(ino).add(path3);
          this._ids.set(path3, ino);
        }
        /**
         * Remove a inode/path pair
         */
        _remove(ino) {
          var _a6;
          for (const path3 of (_a6 = this._paths.get(ino)) !== null && _a6 !== void 0 ? _a6 : []) {
            this._ids.delete(path3);
          }
          this._paths.delete(ino);
        }
        /**
         * Move paths in the tables
         */
        _move(from, to) {
          const toMove = [];
          for (const [path3, ino] of this._ids) {
            const rel = relative(from, path3);
            if (rel.startsWith(".."))
              continue;
            let newKey = join(to, rel);
            if (newKey.endsWith("/"))
              newKey = newKey.slice(0, -1);
            toMove.push({ oldKey: path3, newKey, ino });
          }
          for (const { oldKey, newKey, ino } of toMove) {
            this._ids.delete(oldKey);
            this._ids.set(newKey, ino);
            const p12 = this._paths.get(ino);
            if (!p12) {
              warn("Missing paths in table for ino " + ino);
              continue;
            }
            p12.delete(oldKey);
            p12.add(newKey);
          }
        }
        async ready() {
          if (this._initialized)
            return;
          this.checkRootSync();
          await this.checkRoot();
          await this._populate();
          this._initialized = true;
        }
        constructor(store) {
          var _a6, _b3, _c2;
          super((_a6 = store.type) !== null && _a6 !== void 0 ? _a6 : 1802921587, store.name);
          this.store = store;
          this._ids = /* @__PURE__ */ new Map([["/", 0]]);
          this._paths = /* @__PURE__ */ new Map([[0, new Set("/")]]);
          this._initialized = false;
          store.fs = this;
          this._uuid = (_b3 = store.uuid) !== null && _b3 !== void 0 ? _b3 : this.uuid;
          this.label = store.label;
          debug(this.name + ": supports features: " + ((_c2 = this.store.flags) === null || _c2 === void 0 ? void 0 : _c2.join(", ")));
        }
        /**
         * @experimental
         */
        usage() {
          var _a6, _b3;
          return ((_b3 = (_a6 = this.store).usage) === null || _b3 === void 0 ? void 0 : _b3.call(_a6)) || {
            totalSpace: 0,
            freeSpace: 0
          };
        }
        /**
         * Load an index into the StoreFS.
         * You *must* manually add non-directory files
         */
        async loadIndex(index2) {
          const env_1 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_1, this.transaction(), true);
            const dirs = index2.directories();
            for (const [path3, inode] of index2) {
              this._add(inode.ino, path3);
              await tx.set(inode.ino, inode);
              if (dirs.has(path3))
                await tx.set(inode.data, encodeDirListing(dirs.get(path3)));
            }
            await tx.commit();
          } catch (e_1) {
            env_1.error = e_1;
            env_1.hasError = true;
          } finally {
            const result_1 = __disposeResources(env_1);
            if (result_1)
              await result_1;
          }
        }
        /**
         * Load an index into the StoreFS.
         * You *must* manually add non-directory files
         */
        loadIndexSync(index2) {
          const env_2 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_2, this.transaction(), false);
            const dirs = index2.directories();
            for (const [path3, inode] of index2) {
              this._add(inode.ino, path3);
              tx.setSync(inode.ino, inode);
              if (dirs.has(path3))
                tx.setSync(inode.data, encodeDirListing(dirs.get(path3)));
            }
            tx.commitSync();
          } catch (e_2) {
            env_2.error = e_2;
            env_2.hasError = true;
          } finally {
            __disposeResources(env_2);
          }
        }
        async createIndex() {
          var _a6;
          const env_3 = { stack: [], error: void 0, hasError: false };
          try {
            const index2 = new Index();
            const tx = __addDisposableResource(env_3, this.transaction(), true);
            const queue = [["/", 0]];
            const silence = canary(withErrno("EDEADLK"));
            while (queue.length) {
              const [path3, ino] = queue.shift();
              const inode = new Inode(await tx.get(ino));
              index2.set(path3, inode);
              if (inode.mode & S_IFDIR) {
                const dir = decodeDirListing((_a6 = await tx.get(inode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA")));
                for (const [name2, id] of Object.entries(dir)) {
                  queue.push([join(path3, name2), id]);
                }
              }
            }
            silence();
            return index2;
          } catch (e_3) {
            env_3.error = e_3;
            env_3.hasError = true;
          } finally {
            const result_2 = __disposeResources(env_3);
            if (result_2)
              await result_2;
          }
        }
        createIndexSync() {
          var _a6;
          const env_4 = { stack: [], error: void 0, hasError: false };
          try {
            const index2 = new Index();
            const tx = __addDisposableResource(env_4, this.transaction(), false);
            const queue = [["/", 0]];
            const silence = canary(withErrno("EDEADLK"));
            while (queue.length) {
              const [path3, ino] = queue.shift();
              const inode = new Inode(tx.getSync(ino));
              index2.set(path3, inode);
              if (inode.mode & S_IFDIR) {
                const dir = decodeDirListing((_a6 = tx.getSync(inode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA")));
                for (const [name2, id] of Object.entries(dir)) {
                  queue.push([join(path3, name2), id]);
                }
              }
            }
            silence();
            return index2;
          } catch (e_4) {
            env_4.error = e_4;
            env_4.hasError = true;
          } finally {
            __disposeResources(env_4);
          }
        }
        /**
         * @todo Make rename compatible with the cache.
         */
        async rename(oldPath, newPath) {
          var _a6, _b3, _c2;
          const env_5 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_5, this.transaction(), true);
            const _old = parse(oldPath), _new = parse(newPath), oldDirNode = await this.findInode(tx, _old.dir), oldDirList = decodeDirListing((_a6 = await tx.get(oldDirNode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA")));
            if (!oldDirList[_old.base])
              throw withErrno("ENOENT");
            const ino = oldDirList[_old.base];
            if (ino != this._ids.get(oldPath))
              err(`Ino mismatch while renaming ${oldPath} to ${newPath}`);
            delete oldDirList[_old.base];
            if ((_new.dir + "/").startsWith(oldPath + "/"))
              throw withErrno("EBUSY");
            const sameParent = _new.dir == _old.dir;
            const newDirNode = sameParent ? oldDirNode : await this.findInode(tx, _new.dir);
            const newDirList = sameParent ? oldDirList : decodeDirListing((_b3 = await tx.get(newDirNode.data)) !== null && _b3 !== void 0 ? _b3 : _throw(withErrno("ENODATA")));
            if (newDirList[_new.base]) {
              const existing = new Inode((_c2 = await tx.get(newDirList[_new.base])) !== null && _c2 !== void 0 ? _c2 : _throw(withErrno("ENOENT")));
              if (!existing.toStats().isFile())
                throw withErrno("EISDIR");
              await tx.remove(existing.data);
              await tx.remove(newDirList[_new.base]);
            }
            newDirList[_new.base] = ino;
            await tx.set(oldDirNode.data, encodeDirListing(oldDirList));
            await tx.set(newDirNode.data, encodeDirListing(newDirList));
            await tx.commit();
            this._move(oldPath, newPath);
          } catch (e_5) {
            env_5.error = e_5;
            env_5.hasError = true;
          } finally {
            const result_3 = __disposeResources(env_5);
            if (result_3)
              await result_3;
          }
        }
        renameSync(oldPath, newPath) {
          var _a6, _b3, _c2;
          const env_6 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_6, this.transaction(), false);
            const _old = parse(oldPath), _new = parse(newPath), oldDirNode = this.findInodeSync(tx, _old.dir), oldDirList = decodeDirListing((_a6 = tx.getSync(oldDirNode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA")));
            if (!oldDirList[_old.base])
              throw withErrno("ENOENT");
            const ino = oldDirList[_old.base];
            if (ino != this._ids.get(oldPath))
              err(`Ino mismatch while renaming ${oldPath} to ${newPath}`);
            delete oldDirList[_old.base];
            if ((_new.dir + "/").startsWith(oldPath + "/"))
              throw withErrno("EBUSY");
            const sameParent = _new.dir === _old.dir;
            const newDirNode = sameParent ? oldDirNode : this.findInodeSync(tx, _new.dir);
            const newDirList = sameParent ? oldDirList : decodeDirListing((_b3 = tx.getSync(newDirNode.data)) !== null && _b3 !== void 0 ? _b3 : _throw(withErrno("ENODATA")));
            if (newDirList[_new.base]) {
              const existing = new Inode((_c2 = tx.getSync(newDirList[_new.base])) !== null && _c2 !== void 0 ? _c2 : _throw(withErrno("ENOENT")));
              if (!existing.toStats().isFile())
                throw withErrno("EISDIR");
              tx.removeSync(existing.data);
              tx.removeSync(newDirList[_new.base]);
            }
            newDirList[_new.base] = ino;
            tx.setSync(oldDirNode.data, encodeDirListing(oldDirList));
            tx.setSync(newDirNode.data, encodeDirListing(newDirList));
            tx.commitSync();
            this._move(oldPath, newPath);
          } catch (e_6) {
            env_6.error = e_6;
            env_6.hasError = true;
          } finally {
            __disposeResources(env_6);
          }
        }
        async stat(path3) {
          const env_7 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_7, this.transaction(), true);
            return await this.findInode(tx, path3);
          } catch (e_7) {
            env_7.error = e_7;
            env_7.hasError = true;
          } finally {
            const result_4 = __disposeResources(env_7);
            if (result_4)
              await result_4;
          }
        }
        statSync(path3) {
          const env_8 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_8, this.transaction(), false);
            return this.findInodeSync(tx, path3);
          } catch (e_8) {
            env_8.error = e_8;
            env_8.hasError = true;
          } finally {
            __disposeResources(env_8);
          }
        }
        async touch(path3, metadata) {
          const env_9 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_9, this.transaction(), true);
            const inode = await this.findInode(tx, path3);
            if (inode.update(metadata)) {
              this._add(inode.ino, path3);
              tx.setSync(inode.ino, inode);
            }
            await tx.commit();
          } catch (e_9) {
            env_9.error = e_9;
            env_9.hasError = true;
          } finally {
            const result_5 = __disposeResources(env_9);
            if (result_5)
              await result_5;
          }
        }
        touchSync(path3, metadata) {
          const env_10 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_10, this.transaction(), false);
            const inode = this.findInodeSync(tx, path3);
            if (inode.update(metadata)) {
              this._add(inode.ino, path3);
              tx.setSync(inode.ino, inode);
            }
            tx.commitSync();
          } catch (e_10) {
            env_10.error = e_10;
            env_10.hasError = true;
          } finally {
            __disposeResources(env_10);
          }
        }
        async createFile(path3, options) {
          options.mode |= S_IFREG;
          return await this.commitNew(path3, options, new Uint8Array());
        }
        createFileSync(path3, options) {
          options.mode |= S_IFREG;
          return this.commitNewSync(path3, options, new Uint8Array());
        }
        async unlink(path3) {
          return this.remove(path3, false);
        }
        unlinkSync(path3) {
          this.removeSync(path3, false);
        }
        async rmdir(path3) {
          if ((await this.readdir(path3)).length)
            throw withErrno("ENOTEMPTY");
          await this.remove(path3, true);
        }
        rmdirSync(path3) {
          if (this.readdirSync(path3).length)
            throw withErrno("ENOTEMPTY");
          this.removeSync(path3, true);
        }
        async mkdir(path3, options) {
          options.mode |= S_IFDIR;
          return await this.commitNew(path3, options, encodeUTF8("{}"));
        }
        mkdirSync(path3, options) {
          options.mode |= S_IFDIR;
          return this.commitNewSync(path3, options, encodeUTF8("{}"));
        }
        async readdir(path3) {
          var _a6;
          const env_11 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_11, this.transaction(), true);
            const node = await this.findInode(tx, path3);
            return Object.keys(decodeDirListing((_a6 = await tx.get(node.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT"))));
          } catch (e_11) {
            env_11.error = e_11;
            env_11.hasError = true;
          } finally {
            const result_6 = __disposeResources(env_11);
            if (result_6)
              await result_6;
          }
        }
        readdirSync(path3) {
          var _a6;
          const env_12 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_12, this.transaction(), false);
            const node = this.findInodeSync(tx, path3);
            return Object.keys(decodeDirListing((_a6 = tx.getSync(node.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT"))));
          } catch (e_12) {
            env_12.error = e_12;
            env_12.hasError = true;
          } finally {
            __disposeResources(env_12);
          }
        }
        /**
         * Updated the inode and data node at `path`
         */
        async sync() {
        }
        /**
         * Updated the inode and data node at `path`
         */
        syncSync() {
        }
        async link(target, link3) {
          var _a6;
          const env_13 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_13, this.transaction(), true);
            const newDir = dirname(link3), newDirNode = await this.findInode(tx, newDir), listing = decodeDirListing((_a6 = await tx.get(newDirNode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
            const inode = await this.findInode(tx, target);
            inode.nlink++;
            listing[basename(link3)] = inode.ino;
            this._add(inode.ino, link3);
            await tx.set(inode.ino, inode);
            await tx.set(newDirNode.data, encodeDirListing(listing));
            await tx.commit();
          } catch (e_13) {
            env_13.error = e_13;
            env_13.hasError = true;
          } finally {
            const result_7 = __disposeResources(env_13);
            if (result_7)
              await result_7;
          }
        }
        linkSync(target, link3) {
          var _a6;
          const env_14 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_14, this.transaction(), false);
            const newDir = dirname(link3), newDirNode = this.findInodeSync(tx, newDir), listing = decodeDirListing((_a6 = tx.getSync(newDirNode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
            const inode = this.findInodeSync(tx, target);
            inode.nlink++;
            listing[basename(link3)] = inode.ino;
            this._add(inode.ino, link3);
            tx.setSync(inode.ino, inode);
            tx.setSync(newDirNode.data, encodeDirListing(listing));
            tx.commitSync();
          } catch (e_14) {
            env_14.error = e_14;
            env_14.hasError = true;
          } finally {
            __disposeResources(env_14);
          }
        }
        async read(path3, buffer, offset, end) {
          var _a6;
          const env_15 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_15, this.transaction(), true);
            const inode = await this.findInode(tx, path3);
            if (inode.size == 0)
              return;
            const data = (_a6 = await tx.get(inode.data, offset, end)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA"));
            const _2 = tx.flag("partial") ? data : data.subarray(offset, end);
            if (_2.byteLength > buffer.byteLength)
              err(`Trying to place ${_2.byteLength} bytes into a ${buffer.byteLength} byte buffer on read`);
            buffer.set(_2);
          } catch (e_15) {
            env_15.error = e_15;
            env_15.hasError = true;
          } finally {
            const result_8 = __disposeResources(env_15);
            if (result_8)
              await result_8;
          }
        }
        readSync(path3, buffer, offset, end) {
          var _a6;
          const env_16 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_16, this.transaction(), false);
            const inode = this.findInodeSync(tx, path3);
            if (inode.size == 0)
              return;
            const data = (_a6 = tx.getSync(inode.data, offset, end)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA"));
            const _2 = tx.flag("partial") ? data : data.subarray(offset, end);
            if (_2.byteLength > buffer.byteLength)
              err(`Trying to place ${_2.byteLength} bytes into a ${buffer.byteLength} byte buffer on read`);
            buffer.set(_2);
          } catch (e_16) {
            env_16.error = e_16;
            env_16.hasError = true;
          } finally {
            __disposeResources(env_16);
          }
        }
        async write(path3, data, offset) {
          var _a6;
          const env_17 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_17, this.transaction(), true);
            const inode = await this.findInode(tx, path3);
            let buffer = data;
            if (!tx.flag("partial")) {
              buffer = extendBuffer((_a6 = await tx.get(inode.data)) !== null && _a6 !== void 0 ? _a6 : new Uint8Array(), offset + data.byteLength);
              buffer.set(data, offset);
              offset = 0;
            }
            await tx.set(inode.data, buffer, offset);
            this._add(inode.ino, path3);
            await tx.commit();
          } catch (e_17) {
            env_17.error = e_17;
            env_17.hasError = true;
          } finally {
            const result_9 = __disposeResources(env_17);
            if (result_9)
              await result_9;
          }
        }
        writeSync(path3, data, offset) {
          var _a6;
          const env_18 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_18, this.transaction(), false);
            const inode = this.findInodeSync(tx, path3);
            let buffer = data;
            if (!tx.flag("partial")) {
              buffer = extendBuffer((_a6 = tx.getSync(inode.data)) !== null && _a6 !== void 0 ? _a6 : new Uint8Array(), offset + data.byteLength);
              buffer.set(data, offset);
              offset = 0;
            }
            tx.setSync(inode.data, buffer, offset);
            this._add(inode.ino, path3);
            tx.commitSync();
          } catch (e_18) {
            env_18.error = e_18;
            env_18.hasError = true;
          } finally {
            __disposeResources(env_18);
          }
        }
        /**
         * Wraps a transaction
         * @internal @hidden
         */
        transaction() {
          return new WrappedTransaction(this.store.transaction(), this);
        }
        /**
         * Checks if the root directory exists. Creates it if it doesn't.
         */
        async checkRoot() {
          const env_19 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_19, this.transaction(), true);
            if (await tx.get(rootIno))
              return;
            const inode = new Inode({ ino: rootIno, data: 1, mode: 511 | S_IFDIR });
            await tx.set(inode.data, encodeUTF8("{}"));
            this._add(rootIno, "/");
            await tx.set(rootIno, inode);
            await tx.commit();
          } catch (e_19) {
            env_19.error = e_19;
            env_19.hasError = true;
          } finally {
            const result_10 = __disposeResources(env_19);
            if (result_10)
              await result_10;
          }
        }
        /**
         * Checks if the root directory exists. Creates it if it doesn't.
         */
        checkRootSync() {
          const env_20 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_20, this.transaction(), false);
            if (tx.getSync(rootIno))
              return;
            const inode = new Inode({ ino: rootIno, data: 1, mode: 511 | S_IFDIR });
            tx.setSync(inode.data, encodeUTF8("{}"));
            this._add(rootIno, "/");
            tx.setSync(rootIno, inode);
            tx.commitSync();
          } catch (e_20) {
            env_20.error = e_20;
            env_20.hasError = true;
          } finally {
            __disposeResources(env_20);
          }
        }
        /**
         * Populates the `_ids` and `_paths` maps with all existing files stored in the underlying `Store`.
         */
        async _populate() {
          const env_21 = { stack: [], error: void 0, hasError: false };
          try {
            if (this._initialized) {
              warn("Attempted to populate tables after initialization");
              return;
            }
            debug("Populating tables with existing store metadata");
            const tx = __addDisposableResource(env_21, this.transaction(), true);
            const rootData = await tx.get(rootIno);
            if (!rootData) {
              notice("Store does not have a root inode");
              const inode = new Inode({ ino: rootIno, data: 1, mode: 511 | S_IFDIR });
              await tx.set(inode.data, encodeUTF8("{}"));
              this._add(rootIno, "/");
              await tx.set(rootIno, inode);
              await tx.commit();
              return;
            }
            if (rootData.length < sizeof(Inode)) {
              crit("Store contains an invalid root inode. Refusing to populate tables");
              return;
            }
            const visitedDirectories = /* @__PURE__ */ new Set();
            let i2 = 0;
            const queue = [["/", rootIno]];
            while (queue.length > 0) {
              i2++;
              const [path3, ino] = queue.shift();
              this._add(ino, path3);
              const inodeData = await tx.get(ino);
              if (!inodeData) {
                warn("Store is missing data for inode: " + ino);
                continue;
              }
              if (inodeData.length < sizeof(Inode)) {
                warn(`Invalid inode size for ino ${ino}: ${inodeData.length}`);
                continue;
              }
              const inode = new Inode(inodeData);
              if ((inode.mode & S_IFDIR) != S_IFDIR || visitedDirectories.has(ino)) {
                continue;
              }
              visitedDirectories.add(ino);
              const dirData = await tx.get(inode.data);
              if (!dirData) {
                warn("Store is missing directory data: " + inode.data);
                continue;
              }
              const dirListing = decodeDirListing(dirData);
              for (const [entryName, childIno] of Object.entries(dirListing)) {
                queue.push([join(path3, entryName), childIno]);
              }
            }
            debug(`Added ${i2} existing inode(s) from store`);
          } catch (e_21) {
            env_21.error = e_21;
            env_21.hasError = true;
          } finally {
            const result_11 = __disposeResources(env_21);
            if (result_11)
              await result_11;
          }
        }
        /**
         * Find an inode without using the ID tables
         */
        async _findInode(tx, path3, visited = /* @__PURE__ */ new Set()) {
          var _a6, _b3, _c2;
          if (visited.has(path3))
            throw crit(withErrno("EIO", "Infinite loop detected while finding inode"));
          visited.add(path3);
          if (path3 == "/")
            return new Inode((_a6 = await tx.get(rootIno)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENODATA")));
          const { dir: parent, base: filename } = parse(path3);
          const inode = await this._findInode(tx, parent, visited);
          const dirList = decodeDirListing((_b3 = await tx.get(inode.data)) !== null && _b3 !== void 0 ? _b3 : _throw(withErrno("ENODATA")));
          if (!(filename in dirList))
            throw withErrno("ENOENT");
          return new Inode((_c2 = await tx.get(dirList[filename])) !== null && _c2 !== void 0 ? _c2 : _throw(withErrno("ENODATA")));
        }
        /**
         * Find an inode without using the ID tables
         */
        _findInodeSync(tx, path3, visited = /* @__PURE__ */ new Set()) {
          var _a6, _b3, _c2;
          if (visited.has(path3))
            throw crit(withErrno("EIO", "Infinite loop detected while finding inode"));
          visited.add(path3);
          if (path3 == "/")
            return new Inode((_a6 = tx.getSync(rootIno)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
          const { dir: parent, base: filename } = parse(path3);
          const inode = this._findInodeSync(tx, parent, visited);
          const dir = decodeDirListing((_b3 = tx.getSync(inode.data)) !== null && _b3 !== void 0 ? _b3 : _throw(withErrno("ENODATA")));
          if (!(filename in dir))
            throw withErrno("ENOENT");
          return new Inode((_c2 = tx.getSync(dir[filename])) !== null && _c2 !== void 0 ? _c2 : _throw(withErrno("ENODATA")));
        }
        /**
         * Finds the Inode of `path`.
         * @param path The path to look up.
         * @todo memoize/cache
         */
        async findInode(tx, path3) {
          var _a6;
          if (this.attributes.has("no_id_tables"))
            return await this._findInode(tx, path3);
          const ino = this._ids.get(path3);
          if (ino === void 0)
            throw withErrno("ENOENT");
          return new Inode((_a6 = await tx.get(ino)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
        }
        /**
         * Finds the Inode of `path`.
         * @param path The path to look up.
         * @return The Inode of the path p.
         * @todo memoize/cache
         */
        findInodeSync(tx, path3) {
          var _a6;
          if (this.attributes.has("no_id_tables"))
            return this._findInodeSync(tx, path3);
          const ino = this._ids.get(path3);
          if (ino === void 0)
            throw withErrno("ENOENT");
          return new Inode((_a6 = tx.getSync(ino)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
        }
        /** Allocates a new ID and adds the ID/path */
        allocNew(path3) {
          var _a6;
          (_a6 = this._lastID) !== null && _a6 !== void 0 ? _a6 : this._lastID = Math.max(...this._paths.keys());
          this._lastID += 2;
          const id = this._lastID;
          if (id > size_max)
            throw err(withErrno("ENOSPC", "No IDs available"));
          this._add(id, path3);
          return id;
        }
        /**
         * Commits a new file (well, a FILE or a DIRECTORY) to the file system with `mode`.
         * Note: This will commit the transaction.
         * @param path The path to the new file.
         * @param options The options to create the new file with.
         * @param data The data to store at the file's data node.
         */
        async commitNew(path3, options, data) {
          var _a6;
          const env_22 = { stack: [], error: void 0, hasError: false };
          try {
            if (path3 == "/")
              throw withErrno("EEXIST");
            const tx = __addDisposableResource(env_22, this.transaction(), true);
            const { dir: parentPath, base: fname } = parse(path3);
            const parent = await this.findInode(tx, parentPath);
            const listing = decodeDirListing((_a6 = await tx.get(parent.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
            if (listing[fname])
              throw withErrno("EEXIST");
            const id = this.allocNew(path3);
            const inode = new Inode({
              ...options,
              ino: id,
              data: id + 1,
              size: data.byteLength,
              nlink: 1
            });
            await tx.set(inode.ino, inode);
            await tx.set(inode.data, data);
            listing[fname] = inode.ino;
            await tx.set(parent.data, encodeDirListing(listing));
            await tx.commit();
            return inode;
          } catch (e_22) {
            env_22.error = e_22;
            env_22.hasError = true;
          } finally {
            const result_12 = __disposeResources(env_22);
            if (result_12)
              await result_12;
          }
        }
        /**
         * Commits a new file (well, a FILE or a DIRECTORY) to the file system with `mode`.
         * Note: This will commit the transaction.
         * @param path The path to the new file.
         * @param options The options to create the new file with.
         * @param data The data to store at the file's data node.
         * @return The Inode for the new file.
         */
        commitNewSync(path3, options, data) {
          var _a6;
          const env_23 = { stack: [], error: void 0, hasError: false };
          try {
            if (path3 == "/")
              throw withErrno("EEXIST");
            const tx = __addDisposableResource(env_23, this.transaction(), false);
            const { dir: parentPath, base: fname } = parse(path3);
            const parent = this.findInodeSync(tx, parentPath);
            const listing = decodeDirListing((_a6 = tx.getSync(parent.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
            if (listing[fname])
              throw withErrno("EEXIST");
            const id = this.allocNew(path3);
            const inode = new Inode({
              ...options,
              ino: id,
              data: id + 1,
              size: data.byteLength,
              nlink: 1
            });
            tx.setSync(inode.ino, inode);
            tx.setSync(inode.data, data);
            listing[fname] = inode.ino;
            tx.setSync(parent.data, encodeDirListing(listing));
            tx.commitSync();
            return inode;
          } catch (e_23) {
            env_23.error = e_23;
            env_23.hasError = true;
          } finally {
            __disposeResources(env_23);
          }
        }
        /**
         * Remove all traces of `path` from the file system.
         * @param path The path to remove from the file system.
         * @param isDir Does the path belong to a directory, or a file?
         */
        async remove(path3, isDir) {
          var _a6, _b3;
          const env_24 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_24, this.transaction(), true);
            const { dir: parent, base: fileName } = parse(path3), parentNode = await this.findInode(tx, parent), listing = decodeDirListing((_a6 = await tx.get(parentNode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT")));
            if (!listing[fileName])
              throw withErrno("ENOENT");
            const ino = listing[fileName];
            const inode = new Inode((_b3 = await tx.get(ino)) !== null && _b3 !== void 0 ? _b3 : _throw(withErrno("ENOENT")));
            delete listing[fileName];
            if (!isDir && isDirectory(inode))
              throw withErrno("EISDIR");
            await tx.set(parentNode.data, encodeDirListing(listing));
            if (inode.nlink > 1) {
              inode.update({ nlink: inode.nlink - 1 });
              await tx.set(inode.ino, inode);
            } else {
              await tx.remove(inode.data);
              await tx.remove(ino);
              this._remove(ino);
            }
            await tx.commit();
          } catch (e_24) {
            env_24.error = e_24;
            env_24.hasError = true;
          } finally {
            const result_13 = __disposeResources(env_24);
            if (result_13)
              await result_13;
          }
        }
        /**
         * Remove all traces of `path` from the file system.
         * @param path The path to remove from the file system.
         * @param isDir Does the path belong to a directory, or a file?
         */
        removeSync(path3, isDir) {
          var _a6, _b3;
          const env_25 = { stack: [], error: void 0, hasError: false };
          try {
            const tx = __addDisposableResource(env_25, this.transaction(), false);
            const { dir: parent, base: fileName } = parse(path3), parentNode = this.findInodeSync(tx, parent), listing = decodeDirListing((_a6 = tx.getSync(parentNode.data)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT"))), ino = listing[fileName];
            if (!ino)
              throw withErrno("ENOENT");
            const inode = new Inode((_b3 = tx.getSync(ino)) !== null && _b3 !== void 0 ? _b3 : _throw(withErrno("ENOENT")));
            delete listing[fileName];
            if (!isDir && isDirectory(inode))
              throw withErrno("EISDIR");
            tx.setSync(parentNode.data, encodeDirListing(listing));
            if (inode.nlink > 1) {
              inode.update({ nlink: inode.nlink - 1 });
              tx.setSync(inode.ino, inode);
            } else {
              tx.removeSync(inode.data);
              tx.removeSync(ino);
              this._remove(ino);
            }
            tx.commitSync();
          } catch (e_25) {
            env_25.error = e_25;
            env_25.hasError = true;
          } finally {
            __disposeResources(env_25);
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/store/map.js
  var SyncMapTransaction, AsyncMapTransaction;
  var init_map = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/store/map.js"() {
      init_store();
      SyncMapTransaction = class extends SyncTransaction {
        // eslint-disable-next-line @typescript-eslint/require-await
        async keys() {
          return this.store.keys();
        }
        async get(id) {
          var _a6, _b3, _c2;
          return await ((_c2 = (_b3 = (_a6 = this.store).getAsync) === null || _b3 === void 0 ? void 0 : _b3.call(_a6, id)) !== null && _c2 !== void 0 ? _c2 : this.store.get(id));
        }
        getSync(id) {
          return this.store.get(id);
        }
        setSync(id, data) {
          this.store.set(id, data);
        }
        removeSync(id) {
          this.store.delete(id);
        }
      };
      AsyncMapTransaction = class extends AsyncTransaction {
        async keys() {
          await this.asyncDone;
          return this.store.keys();
        }
        async get(id, offset, end) {
          await this.asyncDone;
          return await this.store.get(id, offset, end);
        }
        getSync(id, offset, end) {
          return this.store.cached(id, offset, end);
        }
        async set(id, data, offset = 0) {
          await this.asyncDone;
          await this.store.set(id, data, offset);
        }
        async remove(id) {
          await this.asyncDone;
          await this.store.delete(id);
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/memory.js
  var InMemoryStore, _InMemory, InMemory;
  var init_memory = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/memory.js"() {
      init_constants();
      init_fs();
      init_map();
      InMemoryStore = class extends Map {
        constructor(maxSize = size_max, label) {
          super();
          this.maxSize = maxSize;
          this.label = label;
          this.flags = [];
          this.name = "tmpfs";
        }
        async sync() {
        }
        transaction() {
          return new SyncMapTransaction(this);
        }
        get bytes() {
          let size = this.size * 4;
          for (const data of this.values())
            size += data.byteLength;
          return size;
        }
        usage() {
          return {
            totalSpace: this.maxSize,
            freeSpace: this.maxSize - this.bytes
          };
        }
      };
      _InMemory = {
        name: "InMemory",
        options: {
          maxSize: { type: "number", required: false },
          label: { type: "string", required: false }
        },
        create({ maxSize, label }) {
          const fs2 = new StoreFS(new InMemoryStore(maxSize, label));
          fs2.checkRootSync();
          return fs2;
        }
      };
      InMemory = _InMemory;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/devices.js
  var DeviceFS, emptyBuffer, nullDevice, zeroDevice, fullDevice, randomDevice, consoleDevice, devices;
  var init_devices = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/devices.js"() {
      init_dist2();
      init_log();
      init_dist();
      init_memory();
      init_fs();
      init_path();
      init_constants();
      init_inode();
      DeviceFS = class extends StoreFS {
        devicesWithDriver(driver, forceIdentity) {
          if (forceIdentity && typeof driver == "string") {
            throw err(withErrno("EINVAL", "Can not fetch devices using only a driver name"));
          }
          const devs = [];
          for (const device of this.devices.values()) {
            if (forceIdentity && device.driver != driver)
              continue;
            const name2 = typeof driver == "string" ? driver : driver.name;
            if (name2 == device.driver.name)
              devs.push(device);
          }
          return devs;
        }
        /**
         * @internal
         */
        _createDevice(driver, options = {}) {
          var _a6;
          let ino = 1;
          const lastDev = Array.from(this.devices.values()).at(-1);
          while (this.store.has(ino) || (lastDev === null || lastDev === void 0 ? void 0 : lastDev.inode.ino) == ino)
            ino++;
          const init3 = (_a6 = driver.init) === null || _a6 === void 0 ? void 0 : _a6.call(driver, ino, options);
          const dev = {
            data: {},
            minor: 0,
            major: 0,
            ...omit(init3 !== null && init3 !== void 0 ? init3 : {}, "metadata"),
            driver,
            inode: new Inode({
              mode: S_IFCHR | 438,
              ...init3 === null || init3 === void 0 ? void 0 : init3.metadata
            })
          };
          const path3 = "/" + (dev.name || driver.name) + (driver.singleton ? "" : this.devicesWithDriver(driver).length);
          if (this.existsSync(path3))
            throw withErrno("EEXIST");
          this.devices.set(path3, dev);
          info("Initialized device: " + this._mountPoint + path3);
          return dev;
        }
        /**
         * Adds default devices
         */
        addDefaults() {
          this._createDevice(nullDevice);
          this._createDevice(zeroDevice);
          this._createDevice(fullDevice);
          this._createDevice(randomDevice);
          this._createDevice(consoleDevice);
          debug("Added default devices");
        }
        constructor() {
          super(new InMemoryStore(16777216, "devfs"));
          this.devices = /* @__PURE__ */ new Map();
        }
        async rename(oldPath, newPath) {
          if (this.devices.has(oldPath))
            throw withErrno("EPERM");
          if (this.devices.has(newPath))
            throw withErrno("EEXIST");
          return super.rename(oldPath, newPath);
        }
        renameSync(oldPath, newPath) {
          if (this.devices.has(oldPath))
            throw withErrno("EPERM");
          if (this.devices.has(newPath))
            throw withErrno("EEXIST");
          return super.renameSync(oldPath, newPath);
        }
        async stat(path3) {
          const dev = this.devices.get(path3);
          if (dev)
            return dev.inode;
          return super.stat(path3);
        }
        statSync(path3) {
          const dev = this.devices.get(path3);
          if (dev)
            return dev.inode;
          return super.statSync(path3);
        }
        async touch(path3, metadata) {
          const dev = this.devices.get(path3);
          if (dev)
            dev.inode.update(metadata);
          else
            await super.touch(path3, metadata);
        }
        touchSync(path3, metadata) {
          const dev = this.devices.get(path3);
          if (dev)
            dev.inode.update(metadata);
          else
            super.touchSync(path3, metadata);
        }
        async createFile(path3, options) {
          if (this.devices.has(path3))
            throw withErrno("EEXIST");
          return super.createFile(path3, options);
        }
        createFileSync(path3, options) {
          if (this.devices.has(path3))
            throw withErrno("EEXIST");
          return super.createFileSync(path3, options);
        }
        async unlink(path3) {
          if (this.devices.has(path3))
            throw withErrno("EPERM");
          return super.unlink(path3);
        }
        unlinkSync(path3) {
          if (this.devices.has(path3))
            throw withErrno("EPERM");
          return super.unlinkSync(path3);
        }
        async rmdir(path3) {
          return super.rmdir(path3);
        }
        rmdirSync(path3) {
          return super.rmdirSync(path3);
        }
        async mkdir(path3, options) {
          if (this.devices.has(path3))
            throw withErrno("EEXIST");
          return super.mkdir(path3, options);
        }
        mkdirSync(path3, options) {
          if (this.devices.has(path3))
            throw withErrno("EEXIST");
          return super.mkdirSync(path3, options);
        }
        async readdir(path3) {
          const entries2 = await super.readdir(path3);
          for (const dev of this.devices.keys()) {
            if (dirname(dev) == path3) {
              entries2.push(basename(dev));
            }
          }
          return entries2;
        }
        readdirSync(path3) {
          const entries2 = super.readdirSync(path3);
          for (const dev of this.devices.keys()) {
            if (dirname(dev) == path3) {
              entries2.push(basename(dev));
            }
          }
          return entries2;
        }
        async link(target, link3) {
          if (this.devices.has(target))
            throw withErrno("EPERM");
          if (this.devices.has(link3))
            throw withErrno("EEXIST");
          return super.link(target, link3);
        }
        linkSync(target, link3) {
          if (this.devices.has(target))
            throw withErrno("EPERM");
          if (this.devices.has(link3))
            throw withErrno("EEXIST");
          return super.linkSync(target, link3);
        }
        async sync() {
          var _a6, _b3;
          for (const device of this.devices.values()) {
            (_b3 = (_a6 = device.driver).sync) === null || _b3 === void 0 ? void 0 : _b3.call(_a6, device);
          }
          return super.sync();
        }
        syncSync() {
          var _a6, _b3;
          for (const device of this.devices.values()) {
            (_b3 = (_a6 = device.driver).sync) === null || _b3 === void 0 ? void 0 : _b3.call(_a6, device);
          }
          return super.syncSync();
        }
        async read(path3, buffer, offset, end) {
          const device = this.devices.get(path3);
          if (!device) {
            await super.read(path3, buffer, offset, end);
            return;
          }
          device.driver.read(device, buffer, offset, end);
        }
        readSync(path3, buffer, offset, end) {
          const device = this.devices.get(path3);
          if (!device) {
            super.readSync(path3, buffer, offset, end);
            return;
          }
          device.driver.read(device, buffer, offset, end);
        }
        async write(path3, data, offset) {
          const device = this.devices.get(path3);
          if (!device) {
            return await super.write(path3, data, offset);
          }
          device.driver.write(device, data, offset);
        }
        writeSync(path3, data, offset) {
          const device = this.devices.get(path3);
          if (!device) {
            return super.writeSync(path3, data, offset);
          }
          device.driver.write(device, data, offset);
        }
      };
      emptyBuffer = new Uint8Array();
      nullDevice = {
        name: "null",
        singleton: true,
        init() {
          return { major: 1, minor: 3 };
        },
        read() {
          return emptyBuffer;
        },
        write() {
          return;
        }
      };
      zeroDevice = {
        name: "zero",
        singleton: true,
        init() {
          return { major: 1, minor: 5 };
        },
        read(device, buffer, offset, end) {
          buffer.fill(0, offset, end);
        },
        write() {
          return;
        }
      };
      fullDevice = {
        name: "full",
        singleton: true,
        init() {
          return { major: 1, minor: 7 };
        },
        read(device, buffer, offset, end) {
          buffer.fill(0, offset, end);
        },
        write() {
          throw withErrno("ENOSPC");
        }
      };
      randomDevice = {
        name: "random",
        singleton: true,
        init() {
          return { major: 1, minor: 8 };
        },
        read(device, buffer) {
          for (let i2 = 0; i2 < buffer.length; i2++) {
            buffer[i2] = Math.floor(Math.random() * 256);
          }
        },
        write() {
          return;
        }
      };
      consoleDevice = {
        name: "console",
        singleton: true,
        init(ino, { output: output3 = (text) => console.log(text) } = {}) {
          return { major: 5, minor: 1, data: { output: output3 } };
        },
        read() {
          return emptyBuffer;
        },
        write(device, buffer, offset) {
          const text = decodeUTF8(buffer);
          device.data.output(text, offset);
        }
      };
      devices = {
        null: nullDevice,
        zero: zeroDevice,
        full: fullDevice,
        random: randomDevice,
        console: consoleDevice
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/config.js
  function _setAccessChecks(value) {
    checkAccess = value;
  }
  var checkAccess;
  var init_config = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/config.js"() {
      checkAccess = true;
    }
  });

  // ../../node_modules/.pnpm/base64-js@1.5.1/node_modules/base64-js/index.js
  var require_base64_js = __commonJS({
    "../../node_modules/.pnpm/base64-js@1.5.1/node_modules/base64-js/index.js"(exports2) {
      "use strict";
      exports2.byteLength = byteLength;
      exports2.toByteArray = toByteArray;
      exports2.fromByteArray = fromByteArray;
      var lookup = [];
      var revLookup = [];
      var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
      var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      for (i2 = 0, len = code.length; i2 < len; ++i2) {
        lookup[i2] = code[i2];
        revLookup[code.charCodeAt(i2)] = i2;
      }
      var i2;
      var len;
      revLookup["-".charCodeAt(0)] = 62;
      revLookup["_".charCodeAt(0)] = 63;
      function getLens(b64) {
        var len2 = b64.length;
        if (len2 % 4 > 0) {
          throw new Error("Invalid string. Length must be a multiple of 4");
        }
        var validLen = b64.indexOf("=");
        if (validLen === -1) validLen = len2;
        var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
        return [validLen, placeHoldersLen];
      }
      function byteLength(b64) {
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
      }
      function _byteLength(b64, validLen, placeHoldersLen) {
        return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
      }
      function toByteArray(b64) {
        var tmp;
        var lens = getLens(b64);
        var validLen = lens[0];
        var placeHoldersLen = lens[1];
        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
        var curByte = 0;
        var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
        var i3;
        for (i3 = 0; i3 < len2; i3 += 4) {
          tmp = revLookup[b64.charCodeAt(i3)] << 18 | revLookup[b64.charCodeAt(i3 + 1)] << 12 | revLookup[b64.charCodeAt(i3 + 2)] << 6 | revLookup[b64.charCodeAt(i3 + 3)];
          arr[curByte++] = tmp >> 16 & 255;
          arr[curByte++] = tmp >> 8 & 255;
          arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 2) {
          tmp = revLookup[b64.charCodeAt(i3)] << 2 | revLookup[b64.charCodeAt(i3 + 1)] >> 4;
          arr[curByte++] = tmp & 255;
        }
        if (placeHoldersLen === 1) {
          tmp = revLookup[b64.charCodeAt(i3)] << 10 | revLookup[b64.charCodeAt(i3 + 1)] << 4 | revLookup[b64.charCodeAt(i3 + 2)] >> 2;
          arr[curByte++] = tmp >> 8 & 255;
          arr[curByte++] = tmp & 255;
        }
        return arr;
      }
      function tripletToBase64(num) {
        return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
      }
      function encodeChunk(uint8, start, end) {
        var tmp;
        var output3 = [];
        for (var i3 = start; i3 < end; i3 += 3) {
          tmp = (uint8[i3] << 16 & 16711680) + (uint8[i3 + 1] << 8 & 65280) + (uint8[i3 + 2] & 255);
          output3.push(tripletToBase64(tmp));
        }
        return output3.join("");
      }
      function fromByteArray(uint8) {
        var tmp;
        var len2 = uint8.length;
        var extraBytes = len2 % 3;
        var parts = [];
        var maxChunkLength = 16383;
        for (var i3 = 0, len22 = len2 - extraBytes; i3 < len22; i3 += maxChunkLength) {
          parts.push(encodeChunk(uint8, i3, i3 + maxChunkLength > len22 ? len22 : i3 + maxChunkLength));
        }
        if (extraBytes === 1) {
          tmp = uint8[len2 - 1];
          parts.push(
            lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
          );
        } else if (extraBytes === 2) {
          tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
          parts.push(
            lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
          );
        }
        return parts.join("");
      }
    }
  });

  // ../../node_modules/.pnpm/ieee754@1.2.1/node_modules/ieee754/index.js
  var require_ieee754 = __commonJS({
    "../../node_modules/.pnpm/ieee754@1.2.1/node_modules/ieee754/index.js"(exports2) {
      exports2.read = function(buffer, offset, isLE2, mLen, nBytes) {
        var e2, m;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var nBits = -7;
        var i2 = isLE2 ? nBytes - 1 : 0;
        var d = isLE2 ? -1 : 1;
        var s2 = buffer[offset + i2];
        i2 += d;
        e2 = s2 & (1 << -nBits) - 1;
        s2 >>= -nBits;
        nBits += eLen;
        for (; nBits > 0; e2 = e2 * 256 + buffer[offset + i2], i2 += d, nBits -= 8) {
        }
        m = e2 & (1 << -nBits) - 1;
        e2 >>= -nBits;
        nBits += mLen;
        for (; nBits > 0; m = m * 256 + buffer[offset + i2], i2 += d, nBits -= 8) {
        }
        if (e2 === 0) {
          e2 = 1 - eBias;
        } else if (e2 === eMax) {
          return m ? NaN : (s2 ? -1 : 1) * Infinity;
        } else {
          m = m + Math.pow(2, mLen);
          e2 = e2 - eBias;
        }
        return (s2 ? -1 : 1) * m * Math.pow(2, e2 - mLen);
      };
      exports2.write = function(buffer, value, offset, isLE2, mLen, nBytes) {
        var e2, m, c;
        var eLen = nBytes * 8 - mLen - 1;
        var eMax = (1 << eLen) - 1;
        var eBias = eMax >> 1;
        var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
        var i2 = isLE2 ? 0 : nBytes - 1;
        var d = isLE2 ? 1 : -1;
        var s2 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
        value = Math.abs(value);
        if (isNaN(value) || value === Infinity) {
          m = isNaN(value) ? 1 : 0;
          e2 = eMax;
        } else {
          e2 = Math.floor(Math.log(value) / Math.LN2);
          if (value * (c = Math.pow(2, -e2)) < 1) {
            e2--;
            c *= 2;
          }
          if (e2 + eBias >= 1) {
            value += rt / c;
          } else {
            value += rt * Math.pow(2, 1 - eBias);
          }
          if (value * c >= 2) {
            e2++;
            c /= 2;
          }
          if (e2 + eBias >= eMax) {
            m = 0;
            e2 = eMax;
          } else if (e2 + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e2 = e2 + eBias;
          } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e2 = 0;
          }
        }
        for (; mLen >= 8; buffer[offset + i2] = m & 255, i2 += d, m /= 256, mLen -= 8) {
        }
        e2 = e2 << mLen | m;
        eLen += mLen;
        for (; eLen > 0; buffer[offset + i2] = e2 & 255, i2 += d, e2 /= 256, eLen -= 8) {
        }
        buffer[offset + i2 - d] |= s2 * 128;
      };
    }
  });

  // ../../node_modules/.pnpm/buffer@6.0.3/node_modules/buffer/index.js
  var require_buffer = __commonJS({
    "../../node_modules/.pnpm/buffer@6.0.3/node_modules/buffer/index.js"(exports2) {
      "use strict";
      var base64 = require_base64_js();
      var ieee754 = require_ieee754();
      var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
      exports2.Buffer = Buffer7;
      exports2.SlowBuffer = SlowBuffer;
      exports2.INSPECT_MAX_BYTES = 50;
      var K_MAX_LENGTH = 2147483647;
      exports2.kMaxLength = K_MAX_LENGTH;
      Buffer7.TYPED_ARRAY_SUPPORT = typedArraySupport();
      if (!Buffer7.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
        console.error(
          "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
        );
      }
      function typedArraySupport() {
        try {
          const arr = new Uint8Array(1);
          const proto2 = { foo: function() {
            return 42;
          } };
          Object.setPrototypeOf(proto2, Uint8Array.prototype);
          Object.setPrototypeOf(arr, proto2);
          return arr.foo() === 42;
        } catch (e2) {
          return false;
        }
      }
      Object.defineProperty(Buffer7.prototype, "parent", {
        enumerable: true,
        get: function() {
          if (!Buffer7.isBuffer(this)) return void 0;
          return this.buffer;
        }
      });
      Object.defineProperty(Buffer7.prototype, "offset", {
        enumerable: true,
        get: function() {
          if (!Buffer7.isBuffer(this)) return void 0;
          return this.byteOffset;
        }
      });
      function createBuffer(length2) {
        if (length2 > K_MAX_LENGTH) {
          throw new RangeError('The value "' + length2 + '" is invalid for option "size"');
        }
        const buf = new Uint8Array(length2);
        Object.setPrototypeOf(buf, Buffer7.prototype);
        return buf;
      }
      function Buffer7(arg, encodingOrOffset, length2) {
        if (typeof arg === "number") {
          if (typeof encodingOrOffset === "string") {
            throw new TypeError(
              'The "string" argument must be of type string. Received type number'
            );
          }
          return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length2);
      }
      Buffer7.poolSize = 8192;
      function from(value, encodingOrOffset, length2) {
        if (typeof value === "string") {
          return fromString(value, encodingOrOffset);
        }
        if (ArrayBuffer.isView(value)) {
          return fromArrayView(value);
        }
        if (value == null) {
          throw new TypeError(
            "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
          );
        }
        if (isInstance2(value, ArrayBuffer) || value && isInstance2(value.buffer, ArrayBuffer)) {
          return fromArrayBuffer(value, encodingOrOffset, length2);
        }
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance2(value, SharedArrayBuffer) || value && isInstance2(value.buffer, SharedArrayBuffer))) {
          return fromArrayBuffer(value, encodingOrOffset, length2);
        }
        if (typeof value === "number") {
          throw new TypeError(
            'The "value" argument must not be of type number. Received type number'
          );
        }
        const valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) {
          return Buffer7.from(valueOf, encodingOrOffset, length2);
        }
        const b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
          return Buffer7.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length2);
        }
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      Buffer7.from = function(value, encodingOrOffset, length2) {
        return from(value, encodingOrOffset, length2);
      };
      Object.setPrototypeOf(Buffer7.prototype, Uint8Array.prototype);
      Object.setPrototypeOf(Buffer7, Uint8Array);
      function assertSize(size) {
        if (typeof size !== "number") {
          throw new TypeError('"size" argument must be of type number');
        } else if (size < 0) {
          throw new RangeError('The value "' + size + '" is invalid for option "size"');
        }
      }
      function alloc2(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) {
          return createBuffer(size);
        }
        if (fill !== void 0) {
          return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        }
        return createBuffer(size);
      }
      Buffer7.alloc = function(size, fill, encoding) {
        return alloc2(size, fill, encoding);
      };
      function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
      }
      Buffer7.allocUnsafe = function(size) {
        return allocUnsafe(size);
      };
      Buffer7.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
      };
      function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") {
          encoding = "utf8";
        }
        if (!Buffer7.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        const length2 = byteLength(string, encoding) | 0;
        let buf = createBuffer(length2);
        const actual = buf.write(string, encoding);
        if (actual !== length2) {
          buf = buf.slice(0, actual);
        }
        return buf;
      }
      function fromArrayLike(array) {
        const length2 = array.length < 0 ? 0 : checked(array.length) | 0;
        const buf = createBuffer(length2);
        for (let i2 = 0; i2 < length2; i2 += 1) {
          buf[i2] = array[i2] & 255;
        }
        return buf;
      }
      function fromArrayView(arrayView) {
        if (isInstance2(arrayView, Uint8Array)) {
          const copy = new Uint8Array(arrayView);
          return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
      }
      function fromArrayBuffer(array, byteOffset, length2) {
        if (byteOffset < 0 || array.byteLength < byteOffset) {
          throw new RangeError('"offset" is outside of buffer bounds');
        }
        if (array.byteLength < byteOffset + (length2 || 0)) {
          throw new RangeError('"length" is outside of buffer bounds');
        }
        let buf;
        if (byteOffset === void 0 && length2 === void 0) {
          buf = new Uint8Array(array);
        } else if (length2 === void 0) {
          buf = new Uint8Array(array, byteOffset);
        } else {
          buf = new Uint8Array(array, byteOffset, length2);
        }
        Object.setPrototypeOf(buf, Buffer7.prototype);
        return buf;
      }
      function fromObject(obj) {
        if (Buffer7.isBuffer(obj)) {
          const len = checked(obj.length) | 0;
          const buf = createBuffer(len);
          if (buf.length === 0) {
            return buf;
          }
          obj.copy(buf, 0, 0, len);
          return buf;
        }
        if (obj.length !== void 0) {
          if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
            return createBuffer(0);
          }
          return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) {
          return fromArrayLike(obj.data);
        }
      }
      function checked(length2) {
        if (length2 >= K_MAX_LENGTH) {
          throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        }
        return length2 | 0;
      }
      function SlowBuffer(length2) {
        if (+length2 != length2) {
          length2 = 0;
        }
        return Buffer7.alloc(+length2);
      }
      Buffer7.isBuffer = function isBuffer2(b) {
        return b != null && b._isBuffer === true && b !== Buffer7.prototype;
      };
      Buffer7.compare = function compare(a, b) {
        if (isInstance2(a, Uint8Array)) a = Buffer7.from(a, a.offset, a.byteLength);
        if (isInstance2(b, Uint8Array)) b = Buffer7.from(b, b.offset, b.byteLength);
        if (!Buffer7.isBuffer(a) || !Buffer7.isBuffer(b)) {
          throw new TypeError(
            'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
          );
        }
        if (a === b) return 0;
        let x = a.length;
        let y = b.length;
        for (let i2 = 0, len = Math.min(x, y); i2 < len; ++i2) {
          if (a[i2] !== b[i2]) {
            x = a[i2];
            y = b[i2];
            break;
          }
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
      };
      Buffer7.isEncoding = function isEncoding(encoding) {
        switch (String(encoding).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return true;
          default:
            return false;
        }
      };
      Buffer7.concat = function concat2(list2, length2) {
        if (!Array.isArray(list2)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        }
        if (list2.length === 0) {
          return Buffer7.alloc(0);
        }
        let i2;
        if (length2 === void 0) {
          length2 = 0;
          for (i2 = 0; i2 < list2.length; ++i2) {
            length2 += list2[i2].length;
          }
        }
        const buffer = Buffer7.allocUnsafe(length2);
        let pos = 0;
        for (i2 = 0; i2 < list2.length; ++i2) {
          let buf = list2[i2];
          if (isInstance2(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
              if (!Buffer7.isBuffer(buf)) buf = Buffer7.from(buf);
              buf.copy(buffer, pos);
            } else {
              Uint8Array.prototype.set.call(
                buffer,
                buf,
                pos
              );
            }
          } else if (!Buffer7.isBuffer(buf)) {
            throw new TypeError('"list" argument must be an Array of Buffers');
          } else {
            buf.copy(buffer, pos);
          }
          pos += buf.length;
        }
        return buffer;
      };
      function byteLength(string, encoding) {
        if (Buffer7.isBuffer(string)) {
          return string.length;
        }
        if (ArrayBuffer.isView(string) || isInstance2(string, ArrayBuffer)) {
          return string.byteLength;
        }
        if (typeof string !== "string") {
          throw new TypeError(
            'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string
          );
        }
        const len = string.length;
        const mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        let loweredCase = false;
        for (; ; ) {
          switch (encoding) {
            case "ascii":
            case "latin1":
            case "binary":
              return len;
            case "utf8":
            case "utf-8":
              return utf8ToBytes4(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return len * 2;
            case "hex":
              return len >>> 1;
            case "base64":
              return base64ToBytes(string).length;
            default:
              if (loweredCase) {
                return mustMatch ? -1 : utf8ToBytes4(string).length;
              }
              encoding = ("" + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer7.byteLength = byteLength;
      function slowToString(encoding, start, end) {
        let loweredCase = false;
        if (start === void 0 || start < 0) {
          start = 0;
        }
        if (start > this.length) {
          return "";
        }
        if (end === void 0 || end > this.length) {
          end = this.length;
        }
        if (end <= 0) {
          return "";
        }
        end >>>= 0;
        start >>>= 0;
        if (end <= start) {
          return "";
        }
        if (!encoding) encoding = "utf8";
        while (true) {
          switch (encoding) {
            case "hex":
              return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
              return utf8Slice(this, start, end);
            case "ascii":
              return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
              return latin1Slice(this, start, end);
            case "base64":
              return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return utf16leSlice(this, start, end);
            default:
              if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
              encoding = (encoding + "").toLowerCase();
              loweredCase = true;
          }
        }
      }
      Buffer7.prototype._isBuffer = true;
      function swap(b, n2, m) {
        const i2 = b[n2];
        b[n2] = b[m];
        b[m] = i2;
      }
      Buffer7.prototype.swap16 = function swap16() {
        const len = this.length;
        if (len % 2 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 16-bits");
        }
        for (let i2 = 0; i2 < len; i2 += 2) {
          swap(this, i2, i2 + 1);
        }
        return this;
      };
      Buffer7.prototype.swap32 = function swap32() {
        const len = this.length;
        if (len % 4 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 32-bits");
        }
        for (let i2 = 0; i2 < len; i2 += 4) {
          swap(this, i2, i2 + 3);
          swap(this, i2 + 1, i2 + 2);
        }
        return this;
      };
      Buffer7.prototype.swap64 = function swap64() {
        const len = this.length;
        if (len % 8 !== 0) {
          throw new RangeError("Buffer size must be a multiple of 64-bits");
        }
        for (let i2 = 0; i2 < len; i2 += 8) {
          swap(this, i2, i2 + 7);
          swap(this, i2 + 1, i2 + 6);
          swap(this, i2 + 2, i2 + 5);
          swap(this, i2 + 3, i2 + 4);
        }
        return this;
      };
      Buffer7.prototype.toString = function toString3() {
        const length2 = this.length;
        if (length2 === 0) return "";
        if (arguments.length === 0) return utf8Slice(this, 0, length2);
        return slowToString.apply(this, arguments);
      };
      Buffer7.prototype.toLocaleString = Buffer7.prototype.toString;
      Buffer7.prototype.equals = function equals(b) {
        if (!Buffer7.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
        if (this === b) return true;
        return Buffer7.compare(this, b) === 0;
      };
      Buffer7.prototype.inspect = function inspect() {
        let str = "";
        const max2 = exports2.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max2).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max2) str += " ... ";
        return "<Buffer " + str + ">";
      };
      if (customInspectSymbol) {
        Buffer7.prototype[customInspectSymbol] = Buffer7.prototype.inspect;
      }
      Buffer7.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance2(target, Uint8Array)) {
          target = Buffer7.from(target, target.offset, target.byteLength);
        }
        if (!Buffer7.isBuffer(target)) {
          throw new TypeError(
            'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
          );
        }
        if (start === void 0) {
          start = 0;
        }
        if (end === void 0) {
          end = target ? target.length : 0;
        }
        if (thisStart === void 0) {
          thisStart = 0;
        }
        if (thisEnd === void 0) {
          thisEnd = this.length;
        }
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
          throw new RangeError("out of range index");
        }
        if (thisStart >= thisEnd && start >= end) {
          return 0;
        }
        if (thisStart >= thisEnd) {
          return -1;
        }
        if (start >= end) {
          return 1;
        }
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        let x = thisEnd - thisStart;
        let y = end - start;
        const len = Math.min(x, y);
        const thisCopy = this.slice(thisStart, thisEnd);
        const targetCopy = target.slice(start, end);
        for (let i2 = 0; i2 < len; ++i2) {
          if (thisCopy[i2] !== targetCopy[i2]) {
            x = thisCopy[i2];
            y = targetCopy[i2];
            break;
          }
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
      };
      function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        if (buffer.length === 0) return -1;
        if (typeof byteOffset === "string") {
          encoding = byteOffset;
          byteOffset = 0;
        } else if (byteOffset > 2147483647) {
          byteOffset = 2147483647;
        } else if (byteOffset < -2147483648) {
          byteOffset = -2147483648;
        }
        byteOffset = +byteOffset;
        if (numberIsNaN(byteOffset)) {
          byteOffset = dir ? 0 : buffer.length - 1;
        }
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
          if (dir) return -1;
          else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
          if (dir) byteOffset = 0;
          else return -1;
        }
        if (typeof val === "string") {
          val = Buffer7.from(val, encoding);
        }
        if (Buffer7.isBuffer(val)) {
          if (val.length === 0) {
            return -1;
          }
          return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
          val = val & 255;
          if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) {
              return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            } else {
              return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
          }
          return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
      }
      function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        let indexSize = 1;
        let arrLength = arr.length;
        let valLength = val.length;
        if (encoding !== void 0) {
          encoding = String(encoding).toLowerCase();
          if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) {
              return -1;
            }
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
          }
        }
        function read2(buf, i3) {
          if (indexSize === 1) {
            return buf[i3];
          } else {
            return buf.readUInt16BE(i3 * indexSize);
          }
        }
        let i2;
        if (dir) {
          let foundIndex = -1;
          for (i2 = byteOffset; i2 < arrLength; i2++) {
            if (read2(arr, i2) === read2(val, foundIndex === -1 ? 0 : i2 - foundIndex)) {
              if (foundIndex === -1) foundIndex = i2;
              if (i2 - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
              if (foundIndex !== -1) i2 -= i2 - foundIndex;
              foundIndex = -1;
            }
          }
        } else {
          if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
          for (i2 = byteOffset; i2 >= 0; i2--) {
            let found = true;
            for (let j = 0; j < valLength; j++) {
              if (read2(arr, i2 + j) !== read2(val, j)) {
                found = false;
                break;
              }
            }
            if (found) return i2;
          }
        }
        return -1;
      }
      Buffer7.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
      };
      Buffer7.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
      };
      Buffer7.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
      };
      function hexWrite(buf, string, offset, length2) {
        offset = Number(offset) || 0;
        const remaining = buf.length - offset;
        if (!length2) {
          length2 = remaining;
        } else {
          length2 = Number(length2);
          if (length2 > remaining) {
            length2 = remaining;
          }
        }
        const strLen = string.length;
        if (length2 > strLen / 2) {
          length2 = strLen / 2;
        }
        let i2;
        for (i2 = 0; i2 < length2; ++i2) {
          const parsed = parseInt(string.substr(i2 * 2, 2), 16);
          if (numberIsNaN(parsed)) return i2;
          buf[offset + i2] = parsed;
        }
        return i2;
      }
      function utf8Write(buf, string, offset, length2) {
        return blitBuffer(utf8ToBytes4(string, buf.length - offset), buf, offset, length2);
      }
      function asciiWrite(buf, string, offset, length2) {
        return blitBuffer(asciiToBytes(string), buf, offset, length2);
      }
      function base64Write(buf, string, offset, length2) {
        return blitBuffer(base64ToBytes(string), buf, offset, length2);
      }
      function ucs2Write(buf, string, offset, length2) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length2);
      }
      Buffer7.prototype.write = function write2(string, offset, length2, encoding) {
        if (offset === void 0) {
          encoding = "utf8";
          length2 = this.length;
          offset = 0;
        } else if (length2 === void 0 && typeof offset === "string") {
          encoding = offset;
          length2 = this.length;
          offset = 0;
        } else if (isFinite(offset)) {
          offset = offset >>> 0;
          if (isFinite(length2)) {
            length2 = length2 >>> 0;
            if (encoding === void 0) encoding = "utf8";
          } else {
            encoding = length2;
            length2 = void 0;
          }
        } else {
          throw new Error(
            "Buffer.write(string, encoding, offset[, length]) is no longer supported"
          );
        }
        const remaining = this.length - offset;
        if (length2 === void 0 || length2 > remaining) length2 = remaining;
        if (string.length > 0 && (length2 < 0 || offset < 0) || offset > this.length) {
          throw new RangeError("Attempt to write outside buffer bounds");
        }
        if (!encoding) encoding = "utf8";
        let loweredCase = false;
        for (; ; ) {
          switch (encoding) {
            case "hex":
              return hexWrite(this, string, offset, length2);
            case "utf8":
            case "utf-8":
              return utf8Write(this, string, offset, length2);
            case "ascii":
            case "latin1":
            case "binary":
              return asciiWrite(this, string, offset, length2);
            case "base64":
              return base64Write(this, string, offset, length2);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return ucs2Write(this, string, offset, length2);
            default:
              if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
              encoding = ("" + encoding).toLowerCase();
              loweredCase = true;
          }
        }
      };
      Buffer7.prototype.toJSON = function toJSON2() {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) {
          return base64.fromByteArray(buf);
        } else {
          return base64.fromByteArray(buf.slice(start, end));
        }
      }
      function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        const res = [];
        let i2 = start;
        while (i2 < end) {
          const firstByte = buf[i2];
          let codePoint = null;
          let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
          if (i2 + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch (bytesPerSequence) {
              case 1:
                if (firstByte < 128) {
                  codePoint = firstByte;
                }
                break;
              case 2:
                secondByte = buf[i2 + 1];
                if ((secondByte & 192) === 128) {
                  tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                  if (tempCodePoint > 127) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 3:
                secondByte = buf[i2 + 1];
                thirdByte = buf[i2 + 2];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                  tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                  if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                    codePoint = tempCodePoint;
                  }
                }
                break;
              case 4:
                secondByte = buf[i2 + 1];
                thirdByte = buf[i2 + 2];
                fourthByte = buf[i2 + 3];
                if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                  tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                  if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                    codePoint = tempCodePoint;
                  }
                }
            }
          }
          if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
          } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
          }
          res.push(codePoint);
          i2 += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
      }
      var MAX_ARGUMENTS_LENGTH = 4096;
      function decodeCodePointsArray(codePoints) {
        const len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) {
          return String.fromCharCode.apply(String, codePoints);
        }
        let res = "";
        let i2 = 0;
        while (i2 < len) {
          res += String.fromCharCode.apply(
            String,
            codePoints.slice(i2, i2 += MAX_ARGUMENTS_LENGTH)
          );
        }
        return res;
      }
      function asciiSlice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for (let i2 = start; i2 < end; ++i2) {
          ret += String.fromCharCode(buf[i2] & 127);
        }
        return ret;
      }
      function latin1Slice(buf, start, end) {
        let ret = "";
        end = Math.min(buf.length, end);
        for (let i2 = start; i2 < end; ++i2) {
          ret += String.fromCharCode(buf[i2]);
        }
        return ret;
      }
      function hexSlice(buf, start, end) {
        const len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        let out = "";
        for (let i2 = start; i2 < end; ++i2) {
          out += hexSliceLookupTable[buf[i2]];
        }
        return out;
      }
      function utf16leSlice(buf, start, end) {
        const bytes2 = buf.slice(start, end);
        let res = "";
        for (let i2 = 0; i2 < bytes2.length - 1; i2 += 2) {
          res += String.fromCharCode(bytes2[i2] + bytes2[i2 + 1] * 256);
        }
        return res;
      }
      Buffer7.prototype.slice = function slice(start, end) {
        const len = this.length;
        start = ~~start;
        end = end === void 0 ? len : ~~end;
        if (start < 0) {
          start += len;
          if (start < 0) start = 0;
        } else if (start > len) {
          start = len;
        }
        if (end < 0) {
          end += len;
          if (end < 0) end = 0;
        } else if (end > len) {
          end = len;
        }
        if (end < start) end = start;
        const newBuf = this.subarray(start, end);
        Object.setPrototypeOf(newBuf, Buffer7.prototype);
        return newBuf;
      };
      function checkOffset(offset, ext, length2) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
        if (offset + ext > length2) throw new RangeError("Trying to access beyond buffer length");
      }
      Buffer7.prototype.readUintLE = Buffer7.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) checkOffset(offset, byteLength2, this.length);
        let val = this[offset];
        let mul = 1;
        let i2 = 0;
        while (++i2 < byteLength2 && (mul *= 256)) {
          val += this[offset + i2] * mul;
        }
        return val;
      };
      Buffer7.prototype.readUintBE = Buffer7.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          checkOffset(offset, byteLength2, this.length);
        }
        let val = this[offset + --byteLength2];
        let mul = 1;
        while (byteLength2 > 0 && (mul *= 256)) {
          val += this[offset + --byteLength2] * mul;
        }
        return val;
      };
      Buffer7.prototype.readUint8 = Buffer7.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
      };
      Buffer7.prototype.readUint16LE = Buffer7.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
      };
      Buffer7.prototype.readUint16BE = Buffer7.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
      };
      Buffer7.prototype.readUint32LE = Buffer7.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
      };
      Buffer7.prototype.readUint32BE = Buffer7.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
      };
      Buffer7.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === void 0 || last === void 0) {
          boundsError(offset, this.length - 8);
        }
        const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
        const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
        return BigInt(lo) + (BigInt(hi) << BigInt(32));
      });
      Buffer7.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === void 0 || last === void 0) {
          boundsError(offset, this.length - 8);
        }
        const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
        const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
        return (BigInt(hi) << BigInt(32)) + BigInt(lo);
      });
      Buffer7.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) checkOffset(offset, byteLength2, this.length);
        let val = this[offset];
        let mul = 1;
        let i2 = 0;
        while (++i2 < byteLength2 && (mul *= 256)) {
          val += this[offset + i2] * mul;
        }
        mul *= 128;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
        return val;
      };
      Buffer7.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) checkOffset(offset, byteLength2, this.length);
        let i2 = byteLength2;
        let mul = 1;
        let val = this[offset + --i2];
        while (i2 > 0 && (mul *= 256)) {
          val += this[offset + --i2] * mul;
        }
        mul *= 128;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
        return val;
      };
      Buffer7.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 128)) return this[offset];
        return (255 - this[offset] + 1) * -1;
      };
      Buffer7.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset] | this[offset + 1] << 8;
        return val & 32768 ? val | 4294901760 : val;
      };
      Buffer7.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        const val = this[offset + 1] | this[offset] << 8;
        return val & 32768 ? val | 4294901760 : val;
      };
      Buffer7.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
      };
      Buffer7.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
      };
      Buffer7.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === void 0 || last === void 0) {
          boundsError(offset, this.length - 8);
        }
        const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
        return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
      });
      Buffer7.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
        offset = offset >>> 0;
        validateNumber(offset, "offset");
        const first = this[offset];
        const last = this[offset + 7];
        if (first === void 0 || last === void 0) {
          boundsError(offset, this.length - 8);
        }
        const val = (first << 24) + // Overflow
        this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
        return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
      });
      Buffer7.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, true, 23, 4);
      };
      Buffer7.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754.read(this, offset, false, 23, 4);
      };
      Buffer7.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, true, 52, 8);
      };
      Buffer7.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754.read(this, offset, false, 52, 8);
      };
      function checkInt(buf, value, offset, ext, max2, min) {
        if (!Buffer7.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max2 || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
      }
      Buffer7.prototype.writeUintLE = Buffer7.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
          checkInt(this, value, offset, byteLength2, maxBytes, 0);
        }
        let mul = 1;
        let i2 = 0;
        this[offset] = value & 255;
        while (++i2 < byteLength2 && (mul *= 256)) {
          this[offset + i2] = value / mul & 255;
        }
        return offset + byteLength2;
      };
      Buffer7.prototype.writeUintBE = Buffer7.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength2 = byteLength2 >>> 0;
        if (!noAssert) {
          const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
          checkInt(this, value, offset, byteLength2, maxBytes, 0);
        }
        let i2 = byteLength2 - 1;
        let mul = 1;
        this[offset + i2] = value & 255;
        while (--i2 >= 0 && (mul *= 256)) {
          this[offset + i2] = value / mul & 255;
        }
        return offset + byteLength2;
      };
      Buffer7.prototype.writeUint8 = Buffer7.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 255, 0);
        this[offset] = value & 255;
        return offset + 1;
      };
      Buffer7.prototype.writeUint16LE = Buffer7.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        return offset + 2;
      };
      Buffer7.prototype.writeUint16BE = Buffer7.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 65535, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
        return offset + 2;
      };
      Buffer7.prototype.writeUint32LE = Buffer7.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 255;
        return offset + 4;
      };
      Buffer7.prototype.writeUint32BE = Buffer7.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 4294967295, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
        return offset + 4;
      };
      function wrtBigUInt64LE(buf, value, offset, min, max2) {
        checkIntBI(value, min, max2, buf, offset, 7);
        let lo = Number(value & BigInt(4294967295));
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        lo = lo >> 8;
        buf[offset++] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(4294967295));
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        hi = hi >> 8;
        buf[offset++] = hi;
        return offset;
      }
      function wrtBigUInt64BE(buf, value, offset, min, max2) {
        checkIntBI(value, min, max2, buf, offset, 7);
        let lo = Number(value & BigInt(4294967295));
        buf[offset + 7] = lo;
        lo = lo >> 8;
        buf[offset + 6] = lo;
        lo = lo >> 8;
        buf[offset + 5] = lo;
        lo = lo >> 8;
        buf[offset + 4] = lo;
        let hi = Number(value >> BigInt(32) & BigInt(4294967295));
        buf[offset + 3] = hi;
        hi = hi >> 8;
        buf[offset + 2] = hi;
        hi = hi >> 8;
        buf[offset + 1] = hi;
        hi = hi >> 8;
        buf[offset] = hi;
        return offset + 8;
      }
      Buffer7.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
      });
      Buffer7.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
      });
      Buffer7.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          const limit = Math.pow(2, 8 * byteLength2 - 1);
          checkInt(this, value, offset, byteLength2, limit - 1, -limit);
        }
        let i2 = 0;
        let mul = 1;
        let sub = 0;
        this[offset] = value & 255;
        while (++i2 < byteLength2 && (mul *= 256)) {
          if (value < 0 && sub === 0 && this[offset + i2 - 1] !== 0) {
            sub = 1;
          }
          this[offset + i2] = (value / mul >> 0) - sub & 255;
        }
        return offset + byteLength2;
      };
      Buffer7.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          const limit = Math.pow(2, 8 * byteLength2 - 1);
          checkInt(this, value, offset, byteLength2, limit - 1, -limit);
        }
        let i2 = byteLength2 - 1;
        let mul = 1;
        let sub = 0;
        this[offset + i2] = value & 255;
        while (--i2 >= 0 && (mul *= 256)) {
          if (value < 0 && sub === 0 && this[offset + i2 + 1] !== 0) {
            sub = 1;
          }
          this[offset + i2] = (value / mul >> 0) - sub & 255;
        }
        return offset + byteLength2;
      };
      Buffer7.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 127, -128);
        if (value < 0) value = 255 + value + 1;
        this[offset] = value & 255;
        return offset + 1;
      };
      Buffer7.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        return offset + 2;
      };
      Buffer7.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 32767, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 255;
        return offset + 2;
      };
      Buffer7.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
        this[offset] = value & 255;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
      };
      Buffer7.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 2147483647, -2147483648);
        if (value < 0) value = 4294967295 + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 255;
        return offset + 4;
      };
      Buffer7.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
        return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      Buffer7.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
        return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
      });
      function checkIEEE754(buf, value, offset, ext, max2, min) {
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
        if (offset < 0) throw new RangeError("Index out of range");
      }
      function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
        }
        ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
      }
      Buffer7.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
      };
      Buffer7.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
      };
      function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
          checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
        }
        ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
      }
      Buffer7.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
      };
      Buffer7.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
      };
      Buffer7.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer7.isBuffer(target)) throw new TypeError("argument should be a Buffer");
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        if (targetStart < 0) {
          throw new RangeError("targetStart out of bounds");
        }
        if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
        if (end < 0) throw new RangeError("sourceEnd out of bounds");
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) {
          end = target.length - targetStart + start;
        }
        const len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
          this.copyWithin(targetStart, start, end);
        } else {
          Uint8Array.prototype.set.call(
            target,
            this.subarray(start, end),
            targetStart
          );
        }
        return len;
      };
      Buffer7.prototype.fill = function fill(val, start, end, encoding) {
        if (typeof val === "string") {
          if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
          } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
          }
          if (encoding !== void 0 && typeof encoding !== "string") {
            throw new TypeError("encoding must be a string");
          }
          if (typeof encoding === "string" && !Buffer7.isEncoding(encoding)) {
            throw new TypeError("Unknown encoding: " + encoding);
          }
          if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") {
              val = code;
            }
          }
        } else if (typeof val === "number") {
          val = val & 255;
        } else if (typeof val === "boolean") {
          val = Number(val);
        }
        if (start < 0 || this.length < start || this.length < end) {
          throw new RangeError("Out of range index");
        }
        if (end <= start) {
          return this;
        }
        start = start >>> 0;
        end = end === void 0 ? this.length : end >>> 0;
        if (!val) val = 0;
        let i2;
        if (typeof val === "number") {
          for (i2 = start; i2 < end; ++i2) {
            this[i2] = val;
          }
        } else {
          const bytes2 = Buffer7.isBuffer(val) ? val : Buffer7.from(val, encoding);
          const len = bytes2.length;
          if (len === 0) {
            throw new TypeError('The value "' + val + '" is invalid for argument "value"');
          }
          for (i2 = 0; i2 < end - start; ++i2) {
            this[i2 + start] = bytes2[i2 % len];
          }
        }
        return this;
      };
      var errors = {};
      function E(sym, getMessage2, Base) {
        errors[sym] = class NodeError extends Base {
          constructor() {
            super();
            Object.defineProperty(this, "message", {
              value: getMessage2.apply(this, arguments),
              writable: true,
              configurable: true
            });
            this.name = `${this.name} [${sym}]`;
            this.stack;
            delete this.name;
          }
          get code() {
            return sym;
          }
          set code(value) {
            Object.defineProperty(this, "code", {
              configurable: true,
              enumerable: true,
              value,
              writable: true
            });
          }
          toString() {
            return `${this.name} [${sym}]: ${this.message}`;
          }
        };
      }
      E(
        "ERR_BUFFER_OUT_OF_BOUNDS",
        function(name2) {
          if (name2) {
            return `${name2} is outside of buffer bounds`;
          }
          return "Attempt to access memory outside buffer bounds";
        },
        RangeError
      );
      E(
        "ERR_INVALID_ARG_TYPE",
        function(name2, actual) {
          return `The "${name2}" argument must be of type number. Received type ${typeof actual}`;
        },
        TypeError
      );
      E(
        "ERR_OUT_OF_RANGE",
        function(str, range, input) {
          let msg = `The value of "${str}" is out of range.`;
          let received = input;
          if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
            received = addNumericalSeparator(String(input));
          } else if (typeof input === "bigint") {
            received = String(input);
            if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
              received = addNumericalSeparator(received);
            }
            received += "n";
          }
          msg += ` It must be ${range}. Received ${received}`;
          return msg;
        },
        RangeError
      );
      function addNumericalSeparator(val) {
        let res = "";
        let i2 = val.length;
        const start = val[0] === "-" ? 1 : 0;
        for (; i2 >= start + 4; i2 -= 3) {
          res = `_${val.slice(i2 - 3, i2)}${res}`;
        }
        return `${val.slice(0, i2)}${res}`;
      }
      function checkBounds(buf, offset, byteLength2) {
        validateNumber(offset, "offset");
        if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
          boundsError(offset, buf.length - (byteLength2 + 1));
        }
      }
      function checkIntBI(value, min, max2, buf, offset, byteLength2) {
        if (value > max2 || value < min) {
          const n2 = typeof min === "bigint" ? "n" : "";
          let range;
          if (byteLength2 > 3) {
            if (min === 0 || min === BigInt(0)) {
              range = `>= 0${n2} and < 2${n2} ** ${(byteLength2 + 1) * 8}${n2}`;
            } else {
              range = `>= -(2${n2} ** ${(byteLength2 + 1) * 8 - 1}${n2}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n2}`;
            }
          } else {
            range = `>= ${min}${n2} and <= ${max2}${n2}`;
          }
          throw new errors.ERR_OUT_OF_RANGE("value", range, value);
        }
        checkBounds(buf, offset, byteLength2);
      }
      function validateNumber(value, name2) {
        if (typeof value !== "number") {
          throw new errors.ERR_INVALID_ARG_TYPE(name2, "number", value);
        }
      }
      function boundsError(value, length2, type) {
        if (Math.floor(value) !== value) {
          validateNumber(value, type);
          throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
        }
        if (length2 < 0) {
          throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
        }
        throw new errors.ERR_OUT_OF_RANGE(
          type || "offset",
          `>= ${type ? 1 : 0} and <= ${length2}`,
          value
        );
      }
      var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
      function base64clean(str) {
        str = str.split("=")[0];
        str = str.trim().replace(INVALID_BASE64_RE, "");
        if (str.length < 2) return "";
        while (str.length % 4 !== 0) {
          str = str + "=";
        }
        return str;
      }
      function utf8ToBytes4(string, units) {
        units = units || Infinity;
        let codePoint;
        const length2 = string.length;
        let leadSurrogate = null;
        const bytes2 = [];
        for (let i2 = 0; i2 < length2; ++i2) {
          codePoint = string.charCodeAt(i2);
          if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
              if (codePoint > 56319) {
                if ((units -= 3) > -1) bytes2.push(239, 191, 189);
                continue;
              } else if (i2 + 1 === length2) {
                if ((units -= 3) > -1) bytes2.push(239, 191, 189);
                continue;
              }
              leadSurrogate = codePoint;
              continue;
            }
            if (codePoint < 56320) {
              if ((units -= 3) > -1) bytes2.push(239, 191, 189);
              leadSurrogate = codePoint;
              continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
          } else if (leadSurrogate) {
            if ((units -= 3) > -1) bytes2.push(239, 191, 189);
          }
          leadSurrogate = null;
          if (codePoint < 128) {
            if ((units -= 1) < 0) break;
            bytes2.push(codePoint);
          } else if (codePoint < 2048) {
            if ((units -= 2) < 0) break;
            bytes2.push(
              codePoint >> 6 | 192,
              codePoint & 63 | 128
            );
          } else if (codePoint < 65536) {
            if ((units -= 3) < 0) break;
            bytes2.push(
              codePoint >> 12 | 224,
              codePoint >> 6 & 63 | 128,
              codePoint & 63 | 128
            );
          } else if (codePoint < 1114112) {
            if ((units -= 4) < 0) break;
            bytes2.push(
              codePoint >> 18 | 240,
              codePoint >> 12 & 63 | 128,
              codePoint >> 6 & 63 | 128,
              codePoint & 63 | 128
            );
          } else {
            throw new Error("Invalid code point");
          }
        }
        return bytes2;
      }
      function asciiToBytes(str) {
        const byteArray = [];
        for (let i2 = 0; i2 < str.length; ++i2) {
          byteArray.push(str.charCodeAt(i2) & 255);
        }
        return byteArray;
      }
      function utf16leToBytes(str, units) {
        let c, hi, lo;
        const byteArray = [];
        for (let i2 = 0; i2 < str.length; ++i2) {
          if ((units -= 2) < 0) break;
          c = str.charCodeAt(i2);
          hi = c >> 8;
          lo = c % 256;
          byteArray.push(lo);
          byteArray.push(hi);
        }
        return byteArray;
      }
      function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
      }
      function blitBuffer(src, dst, offset, length2) {
        let i2;
        for (i2 = 0; i2 < length2; ++i2) {
          if (i2 + offset >= dst.length || i2 >= src.length) break;
          dst[i2 + offset] = src[i2];
        }
        return i2;
      }
      function isInstance2(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
      }
      function numberIsNaN(obj) {
        return obj !== obj;
      }
      var hexSliceLookupTable = function() {
        const alphabet = "0123456789abcdef";
        const table = new Array(256);
        for (let i2 = 0; i2 < 16; ++i2) {
          const i16 = i2 * 16;
          for (let j = 0; j < 16; ++j) {
            table[i16 + j] = alphabet[i2] + alphabet[j];
          }
        }
        return table;
      }();
      function defineBigIntMethod(fn) {
        return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
      }
      function BufferBigIntNotDefined() {
        throw new Error("BigInt not supported");
      }
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/readline.js
  function createInterface(input, output3, completer, terminal) {
    return "input" in input ? new Interface(input.input, input.output, input.completer, input.terminal) : new Interface(input, output3, completer, terminal);
  }
  function clearLine(stream, dir) {
    stream.write(dir >= 0 ? "\r\x1B[K" : "\x1B[K");
    return true;
  }
  function moveCursor(stream, dx, dy) {
    if (!stream.write)
      return false;
    let cmd = "";
    if (dx < 0) {
      cmd += `\x1B[${-dx}D`;
    } else if (dx > 0) {
      cmd += `\x1B[${dx}C`;
    }
    if (dy < 0) {
      cmd += `\x1B[${-dy}A`;
    } else if (dy > 0) {
      cmd += `\x1B[${dy}B`;
    }
    if (cmd)
      stream.write(cmd);
    return true;
  }
  var Interface;
  var init_readline = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/readline.js"() {
      init_eventemitter3();
      init_log();
      Interface = class extends import_index.default {
        get cursor() {
          return this._cursor;
        }
        constructor(input, output3, completer, terminal = false) {
          super();
          this.input = input;
          this.output = output3;
          this.terminal = terminal;
          this.line = "";
          this._cursor = 0;
          this._buffer = "";
          this._closed = false;
          this._paused = false;
          this._prompt = "";
          this._history = [];
          this._historyIndex = -1;
          this._currentLine = "";
          this._onData = (data) => {
            if (this._paused || this._closed)
              return;
            this._buffer += typeof data === "string" ? data : data.toString("utf8");
            for (let lineEnd = this._buffer.indexOf("\n"); lineEnd >= 0; lineEnd = this._buffer.indexOf("\n")) {
              let line = this._buffer.substring(0, lineEnd);
              if (line.endsWith("\r")) {
                line = line.substring(0, line.length - 1);
              }
              this._buffer = this._buffer.substring(lineEnd + 1);
              this.line = line;
              if (line.trim() && !line.trim().match(/^\s*$/) && this._history.at(-1) != line) {
                this._history.push(line);
                this._historyIndex = this._history.length;
                this.emit("history", this._history);
              }
              this.emit("line", line);
            }
          };
          this.input.on("data", this._onData);
          this.input.on("end", this.close.bind(this));
          this.input.on("close", this.close.bind(this));
        }
        /**
         * Closes the interface and removes all event listeners
         */
        close() {
          var _a6, _b3;
          if (this._closed)
            return;
          this._closed = true;
          (_b3 = (_a6 = this.input) === null || _a6 === void 0 ? void 0 : _a6.removeAllListeners) === null || _b3 === void 0 ? void 0 : _b3.call(_a6);
          if (this._buffer.length) {
            const line = this._buffer;
            this._buffer = "";
            this.line = line;
            this.emit("line", line);
          }
          this.emit("history", this._history);
          this.emit("close");
          this.removeAllListeners();
        }
        /**
         * Pauses the input stream
         */
        pause() {
          if (this._paused)
            return this;
          this._paused = true;
          if ("pause" in this.input)
            this.input.pause();
          this.emit("pause");
          return this;
        }
        /**
         * Resumes the input stream
         */
        resume() {
          if (!this._paused)
            return this;
          this._paused = false;
          if ("resume" in this.input)
            this.input.resume();
          this.emit("resume");
          return this;
        }
        /**
         * Sets the prompt text
         */
        setPrompt(prompt) {
          this._prompt = prompt;
        }
        /**
         * Gets the current prompt text
         */
        getPrompt() {
          return this._prompt;
        }
        /**
         * Displays the prompt to the user
         */
        prompt(preserveCursor) {
          if (!this.output)
            return;
          if (!preserveCursor) {
            this.output.write(this._prompt);
            return;
          }
          const { cols } = this.getCursorPos();
          this.output.write(this._prompt);
          this._cursor = cols;
        }
        /**
         * Writes data to the interface and handles key events
         */
        write(data, key) {
          if (this._closed)
            return;
          if (data) {
            const str = typeof data === "string" ? data : data.toString("utf8");
            this._onData(str);
          }
          if (!key || !this.terminal)
            return;
          switch ((key.ctrl ? "^" : "") + key.name) {
            case "^c":
              this.emit("SIGINT");
              break;
            case "^z":
              this.emit("SIGTSTP");
              break;
            case "^q":
              this.emit("SIGCONT");
              break;
            case "home":
            case "^a":
              if (!this.output)
                return;
              moveCursor(this.output, -this._cursor, 0);
              this._cursor = 0;
              this._cursor = 0;
              break;
            case "^e":
            case "end": {
              if (!this.output)
                return;
              const dx = this.line.length - this._cursor;
              if (!dx)
                return;
              moveCursor(this.output, dx, 0);
              this._cursor = this.line.length;
              this._cursor = this.line.length;
              break;
            }
            case "^k": {
              if (!this.output)
                return;
              if (this._cursor >= this.line.length)
                return;
              const newLine = this.line.slice(0, this._cursor);
              clearLine(this.output, 1);
              this.line = newLine;
              break;
            }
            case "^u": {
              if (!this.output || !this._cursor)
                return;
              const newLine = this.line.slice(this._cursor);
              clearLine(this.output, 0);
              moveCursor(this.output, 0, 0);
              this.output.write(this._prompt + newLine);
              this.line = newLine;
              this._cursor = 0;
              this._cursor = 0;
              break;
            }
            case "^w": {
              if (!this.output || !this._cursor)
                return;
              let i2 = this._cursor - 1;
              while (i2 >= 0 && this.line[i2] === " ")
                i2--;
              while (i2 >= 0 && this.line[i2] !== " ")
                i2--;
              const newLine = this.line.slice(0, i2 + 1) + this.line.slice(this._cursor);
              const newCursorPos = i2 + 1;
              this._renderLine(newLine);
              this._cursor = newCursorPos;
              this._cursor = newCursorPos;
              moveCursor(this.output, -newLine.length, 0);
              moveCursor(this.output, newCursorPos, 0);
              break;
            }
            case "^return":
            case "^enter":
              this._onData("\n");
              break;
            case "return":
            case "enter":
              this._onData((!data ? "" : typeof data == "string" ? data : data.toString("utf8")) + "\n");
              break;
            case "up":
            case "down": {
              if (!this.output || !this._history.length)
                return;
              if (this._historyIndex === this._history.length) {
                this._currentLine = this.line || "";
              }
              if (key.name == "up" && this._historyIndex > 0) {
                this._historyIndex--;
              } else if (key.name == "down" && this._historyIndex < this._history.length - 1) {
                this._historyIndex++;
              } else if (key.name == "down" && this._historyIndex == this._history.length - 1) {
                this._historyIndex = this._history.length;
                this._renderLine(this._currentLine);
                return;
              } else {
                return;
              }
              const historyItem = this._history[this._historyIndex];
              this._renderLine(historyItem);
              break;
            }
            case "left":
            case "right": {
              const dx = key.name == "left" ? -1 : 1;
              if (!this.output)
                return;
              const newPos = Math.max(0, Math.min(this.line.length, this._cursor + dx));
              if (newPos == this._cursor)
                return;
              moveCursor(this.output, dx, 0);
              this._cursor = newPos;
              this._cursor = newPos;
              break;
            }
            case "backspace": {
              if (!this.output || !this._cursor)
                return;
              const newLine = this.line.slice(0, this._cursor - 1) + this.line.slice(this._cursor);
              this._renderLine(newLine);
              this._cursor = --this._cursor;
              if (this._cursor > 0) {
                moveCursor(this.output, -this._cursor, 0);
                moveCursor(this.output, this._cursor, 0);
              }
              break;
            }
            case "delete": {
              if (!this.output)
                return;
              if (this._cursor >= this.line.length)
                return;
              const newLine = this.line.slice(0, this._cursor) + this.line.slice(this._cursor + 1);
              clearLine(this.output, 0);
              moveCursor(this.output, 0, 0);
              this.output.write(this._prompt + newLine);
              this.line = newLine;
              moveCursor(this.output, -newLine.length, 0);
              moveCursor(this.output, this._cursor, 0);
              break;
            }
          }
        }
        _renderLine(text) {
          if (!this.output)
            return;
          clearLine(this.output, 0);
          moveCursor(this.output, 0, 0);
          this.output.write(this._prompt + text);
          this.line = text;
          this._cursor = text.length;
          this._cursor = text.length;
        }
        question(query, optionsOrCallback, maybeCallback) {
          const callback = typeof optionsOrCallback === "function" ? optionsOrCallback : maybeCallback;
          if (this._closed || !this.output) {
            callback("");
            return;
          }
          this.output.write(query);
          this.once("line", callback);
        }
        /**
         * Gets the current cursor position
         */
        getCursorPos() {
          return { rows: 0, cols: this.cursor };
        }
        /**
         * Prepends a listener for the specified event
         */
        prependListener(event, listener) {
          const listeners = this.listeners(event);
          this.removeAllListeners(event);
          this.on(event, listener);
          listeners.forEach(this.on.bind(this, event));
          return this;
        }
        /**
         * Prepends a one-time listener for the specified event
         */
        prependOnceListener(event, listener) {
          const listeners = this.listeners(event);
          this.removeAllListeners(event);
          this.once(event, listener);
          listeners.forEach(this.on.bind(this, event));
          return this;
        }
        /**
         * Sets the maximum number of listeners
         */
        setMaxListeners() {
          warn("Interface.prototype.setMaxListeners is not supported");
          return this;
        }
        /**
         * Gets the maximum number of listeners
         */
        getMaxListeners() {
          warn("Interface.prototype.getMaxListeners is not supported");
          return 10;
        }
        [Symbol.asyncIterator]() {
          let done = false;
          return {
            next: async () => {
              if (done)
                return { done, value: void 0 };
              const { resolve: resolve2, promise } = Promise.withResolvers();
              this.once("line", (line) => resolve2({ value: line, done: false }));
              this.once("close", () => {
                done = true;
                resolve2({ value: void 0, done });
              });
              return promise;
            },
            return: async (value) => {
              if (done)
                return { done, value };
              done = true;
              this.close();
              return { done, value };
            },
            throw: async (error) => {
              if (!done) {
                done = true;
                this.close();
              }
              throw error;
            },
            [Symbol.asyncIterator]() {
              return this;
            },
            [Symbol.asyncDispose]: async () => {
              if (done)
                return;
              done = true;
              this.close();
            }
          };
        }
        [Symbol.dispose]() {
          this.close();
        }
        async [Symbol.asyncDispose]() {
          if (this._closed)
            return;
          const { resolve: resolve2, promise } = Promise.withResolvers();
          this.once("close", () => resolve2());
          this.close();
          await promise;
        }
        rawListeners(event) {
          return this.listeners(event);
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/error.js
  function withPath(e2, path3) {
    e2.path = path3;
    return e2;
  }
  function wrap(fs2, prop, path3, dest) {
    const fn = fs2[prop];
    if (typeof fn !== "function")
      throw new TypeError(`${prop} is not a function`);
    return function(...args) {
      try {
        return fn.call(fs2, ...args);
      } catch (e2) {
        throw setUVMessage(Object.assign(e2, { path: path3, dest, syscall: prop.endsWith("Sync") ? prop.slice(0, -4) : prop }));
      }
    };
  }
  var ErrnoError;
  var init_error2 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/error.js"() {
      init_dist2();
      ErrnoError = Exception;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/file.js
  function toFD(file) {
    var _a6, _b3;
    const map = (_b3 = (_a6 = file.context) === null || _a6 === void 0 ? void 0 : _a6.descriptors) !== null && _b3 !== void 0 ? _b3 : defaultContext.descriptors;
    const fd2 = Math.max(map.size ? Math.max(...map.keys()) + 1 : 0, 4);
    map.set(fd2, file);
    return fd2;
  }
  function fromFD($, fd2) {
    var _a6;
    const map = (_a6 = $ === null || $ === void 0 ? void 0 : $.descriptors) !== null && _a6 !== void 0 ? _a6 : defaultContext.descriptors;
    const value = map.get(fd2);
    if (!value)
      throw withErrno("EBADF");
    return value;
  }
  function deleteFD($, fd2) {
    var _a6;
    return ((_a6 = $ === null || $ === void 0 ? void 0 : $.descriptors) !== null && _a6 !== void 0 ? _a6 : defaultContext.descriptors).delete(fd2);
  }
  var SyncHandle;
  var init_file = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/file.js"() {
      init_dist2();
      init_contexts();
      init_inode();
      init_polyfills();
      init_constants();
      init_stats();
      SyncHandle = class {
        /**
         * Get the current file position.
         *
         * We emulate the following bug mentioned in the Node documentation:
         *
         * On Linux, positional writes don't work when the file is opened in append mode.
         * The kernel ignores the position argument and always appends the data to the end of the file.
         * @returns The current file position.
         */
        get position() {
          return this.flag & O_APPEND ? this.inode.size : this._position;
        }
        set position(value) {
          this._position = value;
        }
        /**
         * Creates a file with `path` and, optionally, the given contents.
         * Note that, if contents is specified, it will be mutated by the file.
         */
        constructor(context, path3, fs2, internalPath, flag, inode) {
          this.context = context;
          this.path = path3;
          this.fs = fs2;
          this.internalPath = internalPath;
          this.flag = flag;
          this.inode = inode;
          this._position = 0;
          this.dirty = false;
          this.closed = false;
        }
        [Symbol.dispose]() {
          this.close();
        }
        get _isSync() {
          return !!(this.flag & O_SYNC || this.inode.flags & InodeFlags.Sync || this.fs.attributes.has("sync"));
        }
        sync() {
          if (this.closed)
            throw UV("EBADF", "sync", this.path);
          if (!this.dirty)
            return;
          if (!this.fs.attributes.has("no_write"))
            this.fs.touchSync(this.internalPath, this.inode);
          this.dirty = false;
        }
        /**
         * Default implementation maps to `syncSync`.
         */
        datasync() {
          return this.sync();
        }
        close() {
          if (this.closed)
            throw UV("EBADF", "close", this.path);
          this.sync();
          this.dispose();
        }
        /**
         * Cleans up. This will *not* sync the file data to the FS
         */
        dispose(force) {
          if (this.closed)
            throw UV("EBADF", "close", this.path);
          if (this.dirty && !force)
            throw UV("EBUSY", "close", this.path);
          this.closed = true;
        }
        stat() {
          if (this.closed)
            throw UV("EBADF", "stat", this.path);
          return this.inode;
        }
        truncate(length2) {
          if (length2 < 0)
            throw UV("EINVAL", "truncate", this.path);
          if (this.closed)
            throw UV("EBADF", "truncate", this.path);
          if (!(this.flag & O_WRONLY || this.flag & O_RDWR))
            throw UV("EBADF", "truncate", this.path);
          if (this.fs.attributes.has("readonly"))
            throw UV("EROFS", "truncate", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "truncate", this.path);
          this.dirty = true;
          this.inode.mtimeMs = Date.now();
          this.inode.size = length2;
          this.inode.ctimeMs = Date.now();
          if (this._isSync)
            this.sync();
        }
        /**
         * Write buffer to the file.
         * @param buffer Uint8Array containing the data to write to the file.
         * @param offset Offset in the buffer to start reading data from.
         * @param length The amount of bytes to write to the file.
         * @param position Offset from the beginning of the file where this data should be written.
         * If position is null, the data will be written at  the current position.
         * @returns bytes written
         */
        write(buffer, offset = 0, length2 = buffer.byteLength - offset, position = this.position) {
          if (this.closed)
            throw UV("EBADF", "write", this.path);
          if (!(this.flag & O_WRONLY || this.flag & O_RDWR))
            throw UV("EBADF", "write", this.path);
          if (this.fs.attributes.has("readonly"))
            throw UV("EROFS", "write", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "write", this.path);
          this.dirty = true;
          const end = position + length2;
          const slice = buffer.subarray(offset, offset + length2);
          if (!isCharacterDevice(this.inode) && !isBlockDevice(this.inode) && end > this.inode.size)
            this.inode.size = end;
          this.inode.mtimeMs = Date.now();
          this.inode.ctimeMs = Date.now();
          this._position = position + slice.byteLength;
          this.fs.writeSync(this.internalPath, slice, position);
          if (this._isSync)
            this.sync();
          return slice.byteLength;
        }
        /**
         * Read data from the file.
         * @param buffer The buffer that the data will be written to.
         * @param offset The offset within the buffer where writing will start.
         * @param length An integer specifying the number of bytes to read.
         * @param position An integer specifying where to begin reading from in the file.
         * If position is null, data will be read from the current file position.
         * @returns number of bytes written
         */
        read(buffer, offset = 0, length2 = buffer.byteLength - offset, position = this.position) {
          if (this.closed)
            throw UV("EBADF", "read", this.path);
          if (this.flag & O_WRONLY)
            throw UV("EBADF", "read", this.path);
          if (!(this.inode.flags & InodeFlags.NoAtime) && !this.fs.attributes.has("no_atime")) {
            this.dirty = true;
            this.inode.atimeMs = Date.now();
          }
          let end = position + length2;
          if (!isCharacterDevice(this.inode) && !isBlockDevice(this.inode) && end > this.inode.size) {
            end = position + Math.max(this.inode.size - position, 0);
          }
          this._position = end;
          const uint8 = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
          this.fs.readSync(this.internalPath, uint8.subarray(offset, offset + length2), position, end);
          if (this._isSync)
            this.sync();
          return end - position;
        }
        chmod(mode) {
          if (this.closed)
            throw UV("EBADF", "chmod", this.path);
          this.dirty = true;
          this.inode.mode = this.inode.mode & (mode > S_IFMT ? ~S_IFMT : S_IFMT) | mode;
          if (this._isSync || mode > S_IFMT)
            this.sync();
        }
        chown(uid, gid) {
          if (this.closed)
            throw UV("EBADF", "chmod", this.path);
          this.dirty = true;
          _chown(this.inode, uid, gid);
          if (this._isSync)
            this.sync();
        }
        /**
         * Change the file timestamps of the file.
         */
        utimes(atime, mtime) {
          if (this.closed)
            throw UV("EBADF", "utimes", this.path);
          this.dirty = true;
          this.inode.atimeMs = atime;
          this.inode.mtimeMs = mtime;
          if (this._isSync)
            this.sync();
        }
        /**
         * Create a stream for reading the file.
         */
        streamRead(options) {
          if (this.closed)
            throw UV("EBADF", "streamRead", this.path);
          return this.fs.streamRead(this.internalPath, options);
        }
        /**
         * Create a stream for writing the file.
         */
        streamWrite(options) {
          if (this.closed)
            throw UV("EBADF", "write", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "write", this.path);
          if (this.fs.attributes.has("readonly"))
            throw UV("EROFS", "write", this.path);
          return this.fs.streamWrite(this.internalPath, options);
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/flags.js
  function parse2(flag) {
    if (typeof flag == "number")
      return flag;
    if (!pattern.test(flag)) {
      throw withErrno("EINVAL", "Invalid flag string: " + flag);
    }
    return toNumber(flag);
  }
  function toNumber(flag) {
    if (!flag.includes("r") && !flag.includes("w") && !flag.includes("a")) {
      throw withErrno("EINVAL", "Invalid flag string: " + flag);
    }
    let n2 = flag.includes("r") ? O_RDONLY : O_CREAT;
    if (flag.includes("w"))
      n2 |= O_TRUNC;
    if (flag.includes("a"))
      n2 |= O_APPEND;
    if (flag.includes("+"))
      n2 |= O_RDWR;
    else if (!flag.includes("r"))
      n2 |= O_WRONLY;
    if (flag.includes("s"))
      n2 |= O_SYNC;
    if (flag.includes("x"))
      n2 |= O_EXCL;
    return n2;
  }
  function toMode(flag) {
    let mode = 0;
    if (!(flag & O_WRONLY))
      mode |= R_OK;
    if (flag & O_WRONLY || flag & O_RDWR)
      mode |= W_OK;
    return mode;
  }
  var pattern;
  var init_flags = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/flags.js"() {
      init_dist2();
      init_constants();
      pattern = /[rwasx]{1,2}\+?/;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/shared.js
  function mount(mountPoint, fs2) {
    if (mountPoint[0] != "/")
      mountPoint = "/" + mountPoint;
    mountPoint = resolve.call(this, mountPoint);
    if (mounts.has(mountPoint))
      throw err(withErrno("EINVAL", "Mount point is already in use: " + mountPoint));
    fs2._mountPoint = mountPoint;
    mounts.set(mountPoint, fs2);
    info(`Mounted ${fs2.name} on ${mountPoint}`);
    debug(`${fs2.name} attributes: ${[...fs2.attributes].map(([k, v]) => v !== void 0 && v !== null ? k + "=" + v : k).join(", ")}`);
  }
  function umount(mountPoint) {
    if (mountPoint[0] != "/")
      mountPoint = "/" + mountPoint;
    mountPoint = resolve.call(this, mountPoint);
    if (!mounts.has(mountPoint)) {
      warn(mountPoint + " is already unmounted");
      return;
    }
    mounts.delete(mountPoint);
    notice("Unmounted " + mountPoint);
  }
  function resolveMount(path3, ctx) {
    const root = (ctx === null || ctx === void 0 ? void 0 : ctx.root) || defaultContext.root;
    path3 = normalizePath(join(root, path3));
    const sortedMounts = [...mounts].sort((a, b) => a[0].length > b[0].length ? -1 : 1);
    for (const [mountPoint, fs2] of sortedMounts) {
      if (!_isParentOf(mountPoint, path3))
        continue;
      path3 = path3.slice(mountPoint.length > 1 ? mountPoint.length : 0);
      if (path3 === "")
        path3 = root;
      const case_fold = fs2.attributes.get("case_fold");
      if (case_fold === "lower")
        path3 = path3.toLowerCase();
      if (case_fold === "upper")
        path3 = path3.toUpperCase();
      return { fs: fs2, path: path3, mountPoint, root };
    }
    throw alert(new Exception(Errno.EIO, "No file system for " + path3));
  }
  function _statfs(fs2, bigint) {
    const md = fs2.usage();
    const bs = md.blockSize || 4096;
    return {
      type: (bigint ? BigInt : Number)(fs2.type),
      bsize: (bigint ? BigInt : Number)(bs),
      ffree: (bigint ? BigInt : Number)(md.freeNodes || size_max),
      files: (bigint ? BigInt : Number)(md.totalNodes || size_max),
      bavail: (bigint ? BigInt : Number)(md.freeSpace / bs),
      bfree: (bigint ? BigInt : Number)(md.freeSpace / bs),
      blocks: (bigint ? BigInt : Number)(md.totalSpace / bs)
    };
  }
  function chroot(path3) {
    var _a6, _b3, _c2, _d, _e, _f, _g;
    const $ = this !== null && this !== void 0 ? this : defaultContext;
    if (((_a6 = $.credentials) === null || _a6 === void 0 ? void 0 : _a6.uid) !== 0 && ((_b3 = $.credentials) === null || _b3 === void 0 ? void 0 : _b3.gid) !== 0 && ((_c2 = $.credentials) === null || _c2 === void 0 ? void 0 : _c2.euid) !== 0 && ((_d = $.credentials) === null || _d === void 0 ? void 0 : _d.egid) !== 0)
      throw withErrno("EPERM", "Can not chroot() as non-root user");
    (_e = $.root) !== null && _e !== void 0 ? _e : $.root = "/";
    const newRoot = join($.root, path3);
    for (const handle of (_g = (_f = $.descriptors) === null || _f === void 0 ? void 0 : _f.values()) !== null && _g !== void 0 ? _g : []) {
      if (!handle.path.startsWith($.root))
        throw UV("EBUSY", "chroot", handle.path);
      handle.path = handle.path.slice($.root.length);
    }
    if (newRoot.length > $.root.length)
      throw withErrno("EPERM", "Can not chroot() outside of current root");
    $.root = newRoot;
  }
  function _isParentOf(parent, child) {
    if (parent === "/" || parent === child)
      return true;
    if (!parent.endsWith("/"))
      parent += "/";
    return child.startsWith(parent);
  }
  var mounts;
  var init_shared = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/shared.js"() {
      init_dist2();
      init_log();
      init_memory();
      init_contexts();
      init_path();
      init_utils();
      init_constants();
      mounts = /* @__PURE__ */ new Map();
      mount("/", InMemory.create({ label: "root" }));
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/watchers.js
  function addWatcher(path3, watcher) {
    const normalizedPath = normalizePath(path3);
    if (!watchers.has(normalizedPath)) {
      watchers.set(normalizedPath, /* @__PURE__ */ new Set());
    }
    watchers.get(normalizedPath).add(watcher);
  }
  function removeWatcher(path3, watcher) {
    const normalizedPath = normalizePath(path3);
    if (watchers.has(normalizedPath)) {
      watchers.get(normalizedPath).delete(watcher);
      if (watchers.get(normalizedPath).size === 0) {
        watchers.delete(normalizedPath);
      }
    }
  }
  function emitChange($, eventType, filename) {
    var _a6;
    if ($)
      filename = join((_a6 = $.root) !== null && _a6 !== void 0 ? _a6 : "/", filename);
    filename = normalizePath(filename);
    for (let path3 = filename; path3 != "/"; path3 = dirname(path3)) {
      const watchersForPath = watchers.get(path3);
      if (!watchersForPath)
        continue;
      for (const watcher of watchersForPath) {
        watcher.emit("change", eventType, relative.call(watcher._context, path3, filename) || basename(filename));
      }
    }
  }
  var Watcher, FSWatcher, StatWatcher, watchers;
  var init_watchers = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/watchers.js"() {
      init_eventemitter3();
      init_dist2();
      init_path();
      init_utils();
      init_stats();
      init_sync();
      Watcher = class extends import_index.default {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        off(event, fn, context, once) {
          return super.off(event, fn, context, once);
        }
        removeListener(event, fn, context, once) {
          return super.removeListener(event, fn, context, once);
        }
        /* eslint-enable @typescript-eslint/no-explicit-any */
        constructor(_context, path3) {
          super();
          this._context = _context;
          this.path = path3;
        }
        setMaxListeners() {
          throw UV("ENOSYS", "Watcher.setMaxListeners");
        }
        getMaxListeners() {
          throw UV("ENOSYS", "Watcher.getMaxListeners");
        }
        prependListener() {
          throw UV("ENOSYS", "Watcher.prependListener");
        }
        prependOnceListener() {
          throw UV("ENOSYS", "Watcher.prependOnceListener");
        }
        rawListeners() {
          throw UV("ENOSYS", "Watcher.rawListeners");
        }
        ref() {
          return this;
        }
        unref() {
          return this;
        }
      };
      FSWatcher = class extends Watcher {
        constructor(context, path3, options) {
          super(context, path3);
          this.options = options;
          this.realpath = (context === null || context === void 0 ? void 0 : context.root) ? join(context.root, path3) : path3;
          addWatcher(this.realpath, this);
        }
        close() {
          super.emit("close");
          removeWatcher(this.realpath, this);
        }
        [Symbol.dispose]() {
          this.close();
        }
      };
      StatWatcher = class extends Watcher {
        constructor(context, path3, options) {
          super(context, path3);
          this.options = options;
          this.start();
        }
        onInterval() {
          try {
            const current = statSync(this.path);
            if (!isStatsEqual(this.previous, current)) {
              this.emit("change", current, this.previous);
              this.previous = current;
            }
          } catch (e2) {
            this.emit("error", e2);
          }
        }
        start() {
          const interval = this.options.interval || 5e3;
          try {
            this.previous = statSync(this.path);
          } catch (e2) {
            this.emit("error", e2);
            return;
          }
          this.intervalId = setInterval(this.onInterval.bind(this), interval);
          if (!this.options.persistent && typeof this.intervalId == "object") {
            this.intervalId.unref();
          }
        }
        /**
         * @internal
         */
        stop() {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = void 0;
          }
          this.removeAllListeners();
        }
      };
      watchers = /* @__PURE__ */ new Map();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/sync.js
  function renameSync(oldPath, newPath) {
    oldPath = normalizePath(oldPath);
    __assertType(oldPath);
    newPath = normalizePath(newPath);
    __assertType(newPath);
    const src = resolveMount(oldPath, this);
    const dst = resolveMount(newPath, this);
    const $ex = { syscall: "rename", path: oldPath, dest: newPath };
    if (src.fs !== dst.fs)
      throw UV("EXDEV", $ex);
    if (dst.path.startsWith(src.path + "/"))
      throw UV("EBUSY", $ex);
    const oldStats = statSync.call(this, oldPath);
    const oldParent = statSync.call(this, dirname(oldPath));
    const newParent = statSync.call(this, dirname(newPath));
    let newStats;
    try {
      newStats = statSync.call(this, newPath);
    } catch (e2) {
      setUVMessage(Object.assign(e2, $ex));
      if (e2.code != "ENOENT")
        throw e2;
    }
    if (checkAccess && (!oldParent.hasAccess(R_OK, this) || !newParent.hasAccess(W_OK, this)))
      throw UV("EACCES", $ex);
    if (newStats && !isDirectory(oldStats) && isDirectory(newStats))
      throw UV("EISDIR", $ex);
    if (newStats && isDirectory(oldStats) && !isDirectory(newStats))
      throw UV("ENOTDIR", $ex);
    try {
      src.fs.renameSync(src.path, dst.path);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, $ex));
    }
    emitChange(this, "rename", oldPath);
    emitChange(this, "change", newPath);
  }
  function existsSync(path3) {
    path3 = normalizePath(path3);
    try {
      const { fs: fs2, path: resolvedPath } = resolveMount(realpathSync.call(this, path3), this);
      return fs2.existsSync(resolvedPath);
    } catch (e2) {
      if (e2.errno == Errno.ENOENT)
        return false;
      throw e2;
    }
  }
  function statSync(path3, options) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(realpathSync.call(this, path3), this);
    let stats;
    try {
      stats = fs2.statSync(resolved);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", { syscall: "stat", path: path3 });
    return (options === null || options === void 0 ? void 0 : options.bigint) ? new BigIntStats(stats) : new Stats(stats);
  }
  function lstatSync(path3, options) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const stats = wrap(fs2, "statSync", path3)(resolved);
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", { syscall: "lstat", path: path3 });
    return (options === null || options === void 0 ? void 0 : options.bigint) ? new BigIntStats(stats) : new Stats(stats);
  }
  function truncateSync(path3, len = 0) {
    const env_1 = { stack: [], error: void 0, hasError: false };
    try {
      const file = __addDisposableResource2(env_1, _openSync.call(this, path3, { flag: "r+" }), false);
      len || (len = 0);
      if (len < 0)
        throw UV("EINVAL", "truncate", path3.toString());
      file.truncate(len);
    } catch (e_1) {
      env_1.error = e_1;
      env_1.hasError = true;
    } finally {
      __disposeResources2(env_1);
    }
  }
  function unlinkSync(path3) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    try {
      if (checkAccess && !hasAccess(this, fs2.statSync(resolved), W_OK)) {
        throw UV("EACCES", "unlink");
      }
      fs2.unlinkSync(resolved);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
    emitChange(this, "rename", path3.toString());
  }
  function _openSync(path3, opt) {
    var _a6;
    path3 = normalizePath(path3);
    const mode = normalizeMode(opt.mode, 420), flag = parse2(opt.flag);
    path3 = opt.preserveSymlinks ? path3 : realpathSync.call(this, path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    let stats;
    try {
      stats = fs2.statSync(resolved);
    } catch {
    }
    if (!stats) {
      if (!(flag & O_CREAT)) {
        throw UV("ENOENT", "open", path3);
      }
      const parentStats = fs2.statSync(dirname(resolved));
      if (checkAccess && !hasAccess(this, parentStats, W_OK)) {
        throw UV("EACCES", "open", path3);
      }
      if (!isDirectory(parentStats)) {
        throw UV("ENOTDIR", "open", path3);
      }
      if (!opt.allowDirectory && mode & S_IFDIR)
        throw UV("EISDIR", "open", path3);
      if (checkAccess && !hasAccess(this, parentStats, W_OK)) {
        throw UV("EACCES", "open", path3);
      }
      const { euid: uid, egid: gid } = (_a6 = this === null || this === void 0 ? void 0 : this.credentials) !== null && _a6 !== void 0 ? _a6 : defaultContext.credentials;
      const inode = fs2.createFileSync(resolved, {
        mode,
        uid: parentStats.mode & S_ISUID ? parentStats.uid : uid,
        gid: parentStats.mode & S_ISGID ? parentStats.gid : gid
      });
      return new SyncHandle(this, path3, fs2, resolved, flag, inode);
    }
    if (checkAccess && (!hasAccess(this, stats, mode) || !hasAccess(this, stats, toMode(flag)))) {
      throw UV("EACCES", "open", path3);
    }
    if (flag & O_EXCL)
      throw UV("EEXIST", "open", path3);
    const file = new SyncHandle(this, path3, fs2, resolved, flag, stats);
    if (!opt.allowDirectory && stats.mode & S_IFDIR)
      throw UV("EISDIR", "open", path3);
    if (flag & O_TRUNC)
      file.truncate(0);
    return file;
  }
  function openSync(path3, flag, mode = F_OK) {
    return toFD(_openSync.call(this, path3, { flag, mode }));
  }
  function lopenSync(path3, flag, mode) {
    return toFD(_openSync.call(this, path3, { flag, mode, preserveSymlinks: true }));
  }
  function readFileSync(path3, _options = {}) {
    const env_2 = { stack: [], error: void 0, hasError: false };
    try {
      const options = normalizeOptions(_options, null, "r", 420);
      const flag = parse2(options.flag);
      if (flag & O_WRONLY)
        throw UV("EBADF", "read", path3.toString());
      const file = __addDisposableResource2(env_2, typeof path3 == "number" ? fromFD(this, path3) : _openSync.call(this, path3.toString(), { flag: options.flag, mode: 420, preserveSymlinks: false }), false);
      const { size } = file.stat();
      const data = import_buffer4.Buffer.alloc(size);
      file.read(data, 0, size, 0);
      return options.encoding ? data.toString(options.encoding) : data;
    } catch (e_2) {
      env_2.error = e_2;
      env_2.hasError = true;
    } finally {
      __disposeResources2(env_2);
    }
  }
  function writeFileSync(path3, data, _options = {}) {
    const env_3 = { stack: [], error: void 0, hasError: false };
    try {
      const options = normalizeOptions(_options, "utf8", "w+", 420);
      const flag = parse2(options.flag);
      if (!(flag & O_WRONLY || flag & O_RDWR)) {
        throw new Exception(Errno.EINVAL, "Flag passed to writeFile must allow for writing");
      }
      if (typeof data != "string" && !options.encoding) {
        throw new Exception(Errno.EINVAL, "Encoding not specified");
      }
      const encodedData = typeof data == "string" ? import_buffer4.Buffer.from(data, options.encoding) : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
      if (!encodedData) {
        throw new Exception(Errno.EINVAL, "Data not specified");
      }
      const file = __addDisposableResource2(env_3, typeof path3 == "number" ? fromFD(this, path3) : _openSync.call(this, path3.toString(), {
        flag,
        mode: options.mode,
        preserveSymlinks: true
      }), false);
      file.write(encodedData, 0, encodedData.byteLength, 0);
      emitChange(this, "change", path3.toString());
    } catch (e_3) {
      env_3.error = e_3;
      env_3.hasError = true;
    } finally {
      __disposeResources2(env_3);
    }
  }
  function appendFileSync(filename, data, _options = {}) {
    const env_4 = { stack: [], error: void 0, hasError: false };
    try {
      const options = normalizeOptions(_options, "utf8", "a+", 420);
      const flag = parse2(options.flag);
      if (!(flag & O_APPEND)) {
        throw new Exception(Errno.EINVAL, "Flag passed to appendFile must allow for appending");
      }
      if (typeof data != "string" && !options.encoding) {
        throw new Exception(Errno.EINVAL, "Encoding not specified");
      }
      const encodedData = typeof data == "string" ? import_buffer4.Buffer.from(data, options.encoding) : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
      const file = __addDisposableResource2(env_4, _openSync.call(this, typeof filename == "number" ? fromFD(this, filename).path : filename.toString(), {
        flag,
        mode: options.mode,
        preserveSymlinks: true
      }), false);
      file.write(encodedData, 0, encodedData.byteLength);
    } catch (e_4) {
      env_4.error = e_4;
      env_4.hasError = true;
    } finally {
      __disposeResources2(env_4);
    }
  }
  function fstatSync(fd2, options) {
    const stats = fromFD(this, fd2).stat();
    return (options === null || options === void 0 ? void 0 : options.bigint) ? new BigIntStats(stats) : new Stats(stats);
  }
  function closeSync(fd2) {
    fromFD(this, fd2).close();
    deleteFD(this, fd2);
  }
  function ftruncateSync(fd2, len = 0) {
    len || (len = 0);
    if (len < 0) {
      throw new Exception(Errno.EINVAL);
    }
    fromFD(this, fd2).truncate(len);
  }
  function fsyncSync(fd2) {
    fromFD(this, fd2).sync();
  }
  function fdatasyncSync(fd2) {
    fromFD(this, fd2).datasync();
  }
  function writeSync(fd2, data, posOrOff, lenOrEnc, pos) {
    let buffer, offset, length2, position;
    if (typeof data === "string") {
      position = typeof posOrOff === "number" ? posOrOff : null;
      const encoding = typeof lenOrEnc === "string" ? lenOrEnc : "utf8";
      offset = 0;
      buffer = import_buffer4.Buffer.from(data, encoding);
      length2 = buffer.byteLength;
    } else {
      buffer = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
      offset = posOrOff;
      length2 = lenOrEnc;
      position = typeof pos === "number" ? pos : null;
    }
    const file = fromFD(this, fd2);
    position !== null && position !== void 0 ? position : position = file.position;
    const bytesWritten = file.write(buffer, offset, length2, position);
    emitChange(this, "change", file.path);
    return bytesWritten;
  }
  function readSync(fd2, buffer, options, length2, position) {
    const file = fromFD(this, fd2);
    const offset = typeof options == "object" ? options.offset : options;
    if (typeof options == "object") {
      length2 = options.length;
      position = options.position;
    }
    position = Number(position);
    if (isNaN(position)) {
      position = file.position;
    }
    return file.read(buffer, offset, length2, position);
  }
  function fchownSync(fd2, uid, gid) {
    fromFD(this, fd2).chown(uid, gid);
  }
  function fchmodSync(fd2, mode) {
    const numMode = normalizeMode(mode, -1);
    if (numMode < 0) {
      throw new Exception(Errno.EINVAL, `Invalid mode.`);
    }
    fromFD(this, fd2).chmod(numMode);
  }
  function futimesSync(fd2, atime, mtime) {
    fromFD(this, fd2).utimes(normalizeTime(atime), normalizeTime(mtime));
  }
  function rmdirSync(path3) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(realpathSync.call(this, path3), this);
    const stats = wrap(fs2, "statSync", path3)(resolved);
    if (!isDirectory(stats))
      throw UV("ENOTDIR", "rmdir", path3);
    if (checkAccess && !hasAccess(this, stats, W_OK))
      throw UV("EACCES", "rmdir", path3);
    wrap(fs2, "rmdirSync", path3)(resolved);
    emitChange(this, "rename", path3.toString());
  }
  function mkdirSync(path3, options) {
    var _a6;
    const { euid: uid, egid: gid } = (_a6 = this === null || this === void 0 ? void 0 : this.credentials) !== null && _a6 !== void 0 ? _a6 : defaultContext.credentials;
    options = typeof options === "object" ? options : { mode: options };
    const mode = normalizeMode(options === null || options === void 0 ? void 0 : options.mode, 511);
    path3 = realpathSync.call(this, path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const __create2 = (path4, resolved2, parent) => {
      if (checkAccess && !hasAccess(this, parent, W_OK))
        throw UV("EACCES", "mkdir", dirname(path4));
      const inode = wrap(fs2, "mkdirSync", path4)(resolved2, {
        mode,
        uid: parent.mode & S_ISUID ? parent.uid : uid,
        gid: parent.mode & S_ISGID ? parent.gid : gid
      });
      emitChange(this, "rename", path4);
      return inode;
    };
    if (!(options === null || options === void 0 ? void 0 : options.recursive)) {
      __create2(path3, resolved, wrap(fs2, "statSync", dirname(path3))(dirname(resolved)));
      return;
    }
    const dirs = [];
    for (let dir = resolved, original = path3; !wrap(fs2, "existsSync", original)(dir); dir = dirname(dir), original = dirname(original)) {
      dirs.unshift({ resolved: dir, original });
    }
    if (!dirs.length)
      return;
    const stats = [wrap(fs2, "statSync", dirname(dirs[0].original))(dirname(dirs[0].resolved))];
    for (const [i2, dir] of dirs.entries()) {
      stats.push(__create2(dir.original, dir.resolved, stats[i2]));
    }
    return dirs[0].original;
  }
  function readdirSync(path3, options) {
    options = typeof options === "object" ? options : { encoding: options };
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(realpathSync.call(this, path3), this);
    const stats = wrap(fs2, "statSync", path3)(resolved);
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", "readdir", path3);
    if (!isDirectory(stats))
      throw UV("ENOTDIR", "readdir", path3);
    const entries2 = wrap(fs2, "readdirSync", path3)(resolved);
    const values = [];
    for (const entry of entries2) {
      let entryStat;
      try {
        entryStat = fs2.statSync(join(resolved, entry));
      } catch {
        continue;
      }
      if (options === null || options === void 0 ? void 0 : options.withFileTypes) {
        values.push(new Dirent(entry, entryStat));
      } else if ((options === null || options === void 0 ? void 0 : options.encoding) == "buffer") {
        values.push(import_buffer4.Buffer.from(entry));
      } else {
        values.push(entry);
      }
      if (!isDirectory(entryStat) || !(options === null || options === void 0 ? void 0 : options.recursive))
        continue;
      for (const subEntry of readdirSync.call(this, join(path3, entry), options)) {
        if (subEntry instanceof Dirent) {
          subEntry.path = join(entry, subEntry.path);
          values.push(subEntry);
        } else if (import_buffer4.Buffer.isBuffer(subEntry)) {
          values.push(import_buffer4.Buffer.from(join(entry, decodeUTF8(subEntry))));
        } else {
          values.push(join(entry, subEntry));
        }
      }
    }
    return values;
  }
  function linkSync(targetPath, linkPath) {
    targetPath = normalizePath(targetPath);
    if (checkAccess && !statSync(dirname(targetPath)).hasAccess(R_OK, this)) {
      throw UV("EACCES", "link", dirname(targetPath));
    }
    linkPath = normalizePath(linkPath);
    if (checkAccess && !statSync(dirname(linkPath)).hasAccess(W_OK, this)) {
      throw UV("EACCES", "link", dirname(linkPath));
    }
    const { fs: fs2, path: path3 } = resolveMount(targetPath, this);
    const link3 = resolveMount(linkPath, this);
    if (fs2 != link3.fs) {
      throw UV("EXDEV", "link", linkPath);
    }
    const stats = wrap(fs2, "statSync", targetPath)(path3);
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", "link", path3);
    return wrap(fs2, "linkSync", targetPath, linkPath)(path3, link3.path);
  }
  function symlinkSync(target, path3, type = "file") {
    const env_5 = { stack: [], error: void 0, hasError: false };
    try {
      if (!["file", "dir", "junction"].includes(type))
        throw new TypeError("Invalid symlink type: " + type);
      path3 = normalizePath(path3);
      const file = __addDisposableResource2(env_5, _openSync.call(this, path3, { flag: "wx", mode: 420 }), false);
      file.write(encodeUTF8(normalizePath(target, true)));
      file.chmod(S_IFLNK);
    } catch (e_5) {
      env_5.error = e_5;
      env_5.hasError = true;
    } finally {
      __disposeResources2(env_5);
    }
  }
  function readlinkSync(path3, options) {
    const env_6 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource2(env_6, _openSync.call(this, normalizePath(path3), { flag: "r", mode: 420, preserveSymlinks: true }), false);
      if (!isSymbolicLink(handle.inode))
        throw new Exception(Errno.EINVAL, "Not a symbolic link: " + path3);
      const size = handle.inode.size;
      const data = import_buffer4.Buffer.alloc(size);
      handle.read(data, 0, size, 0);
      const encoding = typeof options == "object" ? options === null || options === void 0 ? void 0 : options.encoding : options;
      if (encoding == "buffer") {
        return data;
      }
      return data.toString(encoding !== null && encoding !== void 0 ? encoding : "utf-8");
    } catch (e_6) {
      env_6.error = e_6;
      env_6.hasError = true;
    } finally {
      __disposeResources2(env_6);
    }
  }
  function chownSync(path3, uid, gid) {
    const fd2 = openSync.call(this, path3, "r+");
    fchownSync.call(this, fd2, uid, gid);
    closeSync.call(this, fd2);
  }
  function lchownSync(path3, uid, gid) {
    const fd2 = lopenSync.call(this, path3, "r+");
    fchownSync.call(this, fd2, uid, gid);
    closeSync.call(this, fd2);
  }
  function chmodSync(path3, mode) {
    const fd2 = openSync.call(this, path3, "r+");
    fchmodSync.call(this, fd2, mode);
    closeSync.call(this, fd2);
  }
  function lchmodSync(path3, mode) {
    const fd2 = lopenSync.call(this, path3, "r+");
    fchmodSync.call(this, fd2, mode);
    closeSync.call(this, fd2);
  }
  function utimesSync(path3, atime, mtime) {
    const fd2 = openSync.call(this, path3, "r+");
    futimesSync.call(this, fd2, atime, mtime);
    closeSync.call(this, fd2);
  }
  function lutimesSync(path3, atime, mtime) {
    const fd2 = lopenSync.call(this, path3, "r+");
    futimesSync.call(this, fd2, atime, mtime);
    closeSync.call(this, fd2);
  }
  function _resolveSync($, path3, preserveSymlinks) {
    if (preserveSymlinks) {
      const resolved2 = resolveMount(path3, $);
      const stats2 = resolved2.fs.statSync(resolved2.path);
      return { ...resolved2, fullPath: path3, stats: stats2 };
    }
    try {
      const resolved2 = resolveMount(path3, $);
      const stats2 = resolved2.fs.statSync(resolved2.path);
      if (!isSymbolicLink(stats2)) {
        return { ...resolved2, fullPath: path3, stats: stats2 };
      }
      const target2 = resolve.call($, dirname(path3), readlinkSync.call($, path3).toString());
      return _resolveSync($, target2);
    } catch {
    }
    const { base: base2, dir } = parse(path3);
    const realDir = dir == "/" ? "/" : realpathSync.call($, dir);
    const maybePath = join(realDir, base2);
    const resolved = resolveMount(maybePath, $);
    let stats;
    try {
      stats = resolved.fs.statSync(resolved.path);
    } catch (e2) {
      if (e2.code === "ENOENT")
        return { ...resolved, fullPath: path3 };
      throw setUVMessage(Object.assign(e2, { syscall: "stat", path: maybePath }));
    }
    if (!isSymbolicLink(stats)) {
      return { ...resolved, fullPath: maybePath, stats };
    }
    const target = resolve.call($, realDir, readlinkSync.call($, maybePath).toString());
    return _resolveSync($, target);
  }
  function realpathSync(path3, options) {
    var _a6;
    const encoding = typeof options == "string" ? options : (_a6 = options === null || options === void 0 ? void 0 : options.encoding) !== null && _a6 !== void 0 ? _a6 : "utf8";
    path3 = normalizePath(path3);
    const { fullPath } = _resolveSync(this, path3);
    if (encoding == "utf8" || encoding == "utf-8")
      return fullPath;
    const buf = import_buffer4.Buffer.from(fullPath, "utf-8");
    if (encoding == "buffer")
      return buf;
    return buf.toString(encoding);
  }
  function accessSync(path3, mode = 384) {
    if (!checkAccess)
      return;
    if (!hasAccess(this, statSync.call(this, path3), mode)) {
      throw new Exception(Errno.EACCES);
    }
  }
  function rmSync(path3, options) {
    path3 = normalizePath(path3);
    let stats;
    try {
      stats = lstatSync.bind(this)(path3);
    } catch (error) {
      if (error.code != "ENOENT" || !(options === null || options === void 0 ? void 0 : options.force))
        throw error;
    }
    if (!stats)
      return;
    switch (stats.mode & S_IFMT) {
      case S_IFDIR:
        if (options === null || options === void 0 ? void 0 : options.recursive) {
          for (const entry of readdirSync.call(this, path3)) {
            rmSync.call(this, join(path3, entry), options);
          }
        }
        rmdirSync.call(this, path3);
        break;
      case S_IFREG:
      case S_IFLNK:
      case S_IFBLK:
      case S_IFCHR:
        unlinkSync.call(this, path3);
        break;
      case S_IFIFO:
      case S_IFSOCK:
      default:
        throw UV("ENOSYS", "rm", path3);
    }
  }
  function mkdtempSync(prefix, options) {
    const encoding = typeof options === "object" ? options === null || options === void 0 ? void 0 : options.encoding : options || "utf8";
    const fsName = `${prefix}${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const resolvedPath = "/tmp/" + fsName;
    mkdirSync.call(this, resolvedPath);
    return encoding == "buffer" ? import_buffer4.Buffer.from(resolvedPath) : resolvedPath;
  }
  function copyFileSync(source, destination, flags) {
    source = normalizePath(source);
    destination = normalizePath(destination);
    if (flags && flags & COPYFILE_EXCL && existsSync(destination))
      throw UV("EEXIST", "copyFile", destination);
    writeFileSync.call(this, destination, readFileSync(source));
    emitChange(this, "rename", destination.toString());
  }
  function readvSync(fd2, buffers, position) {
    const file = fromFD(this, fd2);
    let bytesRead = 0;
    for (const buffer of buffers) {
      bytesRead += file.read(buffer, 0, buffer.byteLength, position + bytesRead);
    }
    return bytesRead;
  }
  function writevSync(fd2, buffers, position) {
    const file = fromFD(this, fd2);
    let bytesWritten = 0;
    for (const buffer of buffers) {
      bytesWritten += file.write(new Uint8Array(buffer.buffer), 0, buffer.byteLength, position + bytesWritten);
    }
    return bytesWritten;
  }
  function opendirSync(path3, options) {
    path3 = normalizePath(path3);
    return new Dir(path3, this);
  }
  function cpSync(source, destination, opts) {
    source = normalizePath(source);
    destination = normalizePath(destination);
    const srcStats = lstatSync.call(this, source);
    if ((opts === null || opts === void 0 ? void 0 : opts.errorOnExist) && existsSync.call(this, destination))
      throw UV("EEXIST", "cp", destination);
    switch (srcStats.mode & S_IFMT) {
      case S_IFDIR:
        if (!(opts === null || opts === void 0 ? void 0 : opts.recursive))
          throw UV("EISDIR", "cp", source);
        mkdirSync.call(this, destination, { recursive: true });
        for (const dirent of readdirSync.call(this, source, { withFileTypes: true })) {
          if (opts.filter && !opts.filter(join(source, dirent.name), join(destination, dirent.name))) {
            continue;
          }
          cpSync.call(this, join(source, dirent.name), join(destination, dirent.name), opts);
        }
        break;
      case S_IFREG:
      case S_IFLNK:
        copyFileSync.call(this, source, destination);
        break;
      case S_IFBLK:
      case S_IFCHR:
      case S_IFIFO:
      case S_IFSOCK:
      default:
        throw UV("ENOSYS", "cp", source);
    }
    if (opts === null || opts === void 0 ? void 0 : opts.preserveTimestamps) {
      utimesSync.call(this, destination, srcStats.atime, srcStats.mtime);
    }
  }
  function statfsSync(path3, options) {
    path3 = normalizePath(path3);
    const { fs: fs2 } = resolveMount(path3, this);
    return _statfs(fs2, options === null || options === void 0 ? void 0 : options.bigint);
  }
  function globSync(pattern2, options = {}) {
    pattern2 = Array.isArray(pattern2) ? pattern2 : [pattern2];
    const { cwd = "/", withFileTypes = false, exclude = () => false } = options;
    const regexPatterns = pattern2.map(globToRegex);
    const results = [];
    function recursiveList(dir) {
      const entries2 = readdirSync(dir, { withFileTypes, encoding: "utf8" });
      for (const entry of entries2) {
        const fullPath = withFileTypes ? entry.path : dir + "/" + entry;
        if (typeof exclude != "function" ? exclude.some((p12) => matchesGlob(p12, fullPath)) : exclude(withFileTypes ? entry : fullPath))
          continue;
        if (statSync(fullPath).isDirectory() && regexPatterns.some((pattern3) => pattern3.source.includes(".*"))) {
          recursiveList(fullPath);
        }
        if (regexPatterns.some((pattern3) => pattern3.test(fullPath.replace(/^\/+/g, "")))) {
          results.push(withFileTypes ? entry.path : fullPath.replace(/^\/+/g, ""));
        }
      }
    }
    recursiveList(cwd);
    return results;
  }
  var import_buffer4, __addDisposableResource2, __disposeResources2;
  var init_sync = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/sync.js"() {
      import_buffer4 = __toESM(require_buffer(), 1);
      init_dist2();
      init_dist();
      init_contexts();
      init_error2();
      init_inode();
      init_path();
      init_utils();
      init_config();
      init_constants();
      init_dir();
      init_file();
      init_flags();
      init_shared();
      init_stats();
      init_watchers();
      __addDisposableResource2 = function(env, value, async) {
        if (value !== null && value !== void 0) {
          if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
          var dispose, inner;
          if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
          }
          if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
          }
          if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
          if (inner) dispose = function() {
            try {
              inner.call(this);
            } catch (e2) {
              return Promise.reject(e2);
            }
          };
          env.stack.push({ value, dispose, async });
        } else if (async) {
          env.stack.push({ async: true });
        }
        return value;
      };
      __disposeResources2 = /* @__PURE__ */ function(SuppressedError2) {
        return function(env) {
          function fail(e2) {
            env.error = env.hasError ? new SuppressedError2(e2, env.error, "An error was suppressed during disposal.") : e2;
            env.hasError = true;
          }
          var r2, s2 = 0;
          function next() {
            while (r2 = env.stack.pop()) {
              try {
                if (!r2.async && s2 === 1) return s2 = 0, env.stack.push(r2), Promise.resolve().then(next);
                if (r2.dispose) {
                  var result = r2.dispose.call(r2.value);
                  if (r2.async) return s2 |= 2, Promise.resolve(result).then(next, function(e2) {
                    fail(e2);
                    return next();
                  });
                } else s2 |= 1;
              } catch (e2) {
                fail(e2);
              }
            }
            if (s2 === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
            if (env.hasError) throw env.error;
          }
          return next();
        };
      }(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
        var e2 = new Error(message);
        return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
      });
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/dir.js
  var Dirent, Dir;
  var init_dir = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/dir.js"() {
      init_dist2();
      init_inode();
      init_path();
      init_promises();
      init_sync();
      Dirent = class {
        get name() {
          return basename(this.path);
        }
        constructor(path3, stats) {
          this.path = path3;
          this.stats = stats;
        }
        get parentPath() {
          return this.path;
        }
        isFile() {
          return isFile(this.stats);
        }
        isDirectory() {
          return isDirectory(this.stats);
        }
        isBlockDevice() {
          return isBlockDevice(this.stats);
        }
        isCharacterDevice() {
          return isCharacterDevice(this.stats);
        }
        isSymbolicLink() {
          return isSymbolicLink(this.stats);
        }
        isFIFO() {
          return isFIFO(this.stats);
        }
        isSocket() {
          return isSocket(this.stats);
        }
      };
      Dir = class {
        checkClosed() {
          if (this.closed)
            throw withErrno("EBADF", "Can not use closed Dir");
        }
        constructor(path3, context) {
          this.path = path3;
          this.context = context;
          this.closed = false;
        }
        close(cb) {
          this.closed = true;
          if (!cb) {
            return Promise.resolve();
          }
          cb();
        }
        /**
         * Synchronously close the directory's underlying resource handle.
         * Subsequent reads will result in errors.
         */
        closeSync() {
          this.closed = true;
        }
        async _read() {
          var _a6, _b3;
          this.checkClosed();
          (_a6 = this._entries) !== null && _a6 !== void 0 ? _a6 : this._entries = await readdir.call(this.context, this.path, {
            withFileTypes: true
          });
          if (!this._entries.length)
            return null;
          return (_b3 = this._entries.shift()) !== null && _b3 !== void 0 ? _b3 : null;
        }
        read(cb) {
          if (!cb) {
            return this._read();
          }
          void this._read().then((value) => cb(void 0, value));
        }
        /**
         * Synchronously read the next directory entry via `readdir(3)` as a `Dirent`.
         * If there are no more directory entries to read, null will be returned.
         * Directory entries returned by this function are in no particular order as provided by the operating system's underlying directory mechanisms.
         */
        readSync() {
          var _a6, _b3;
          this.checkClosed();
          (_a6 = this._entries) !== null && _a6 !== void 0 ? _a6 : this._entries = readdirSync.call(this.context, this.path, { withFileTypes: true });
          if (!this._entries.length)
            return null;
          return (_b3 = this._entries.shift()) !== null && _b3 !== void 0 ? _b3 : null;
        }
        async next() {
          const value = await this._read();
          if (value) {
            return { done: false, value };
          }
          await this.close();
          return { done: true, value: void 0 };
        }
        /**
         * Asynchronously iterates over the directory via `readdir(3)` until all entries have been read.
         */
        [Symbol.asyncIterator]() {
          return this;
        }
        [Symbol.asyncDispose]() {
          return Promise.resolve();
        }
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/primordials.js
  var require_primordials = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/primordials.js"(exports2, module2) {
      "use strict";
      var AggregateError = class extends Error {
        constructor(errors) {
          if (!Array.isArray(errors)) {
            throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
          }
          let message = "";
          for (let i2 = 0; i2 < errors.length; i2++) {
            message += `    ${errors[i2].stack}
`;
          }
          super(message);
          this.name = "AggregateError";
          this.errors = errors;
        }
      };
      module2.exports = {
        AggregateError,
        ArrayIsArray(self2) {
          return Array.isArray(self2);
        },
        ArrayPrototypeIncludes(self2, el) {
          return self2.includes(el);
        },
        ArrayPrototypeIndexOf(self2, el) {
          return self2.indexOf(el);
        },
        ArrayPrototypeJoin(self2, sep2) {
          return self2.join(sep2);
        },
        ArrayPrototypeMap(self2, fn) {
          return self2.map(fn);
        },
        ArrayPrototypePop(self2, el) {
          return self2.pop(el);
        },
        ArrayPrototypePush(self2, el) {
          return self2.push(el);
        },
        ArrayPrototypeSlice(self2, start, end) {
          return self2.slice(start, end);
        },
        Error,
        FunctionPrototypeCall(fn, thisArgs, ...args) {
          return fn.call(thisArgs, ...args);
        },
        FunctionPrototypeSymbolHasInstance(self2, instance) {
          return Function.prototype[Symbol.hasInstance].call(self2, instance);
        },
        MathFloor: Math.floor,
        Number,
        NumberIsInteger: Number.isInteger,
        NumberIsNaN: Number.isNaN,
        NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
        NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
        NumberParseInt: Number.parseInt,
        ObjectDefineProperties(self2, props) {
          return Object.defineProperties(self2, props);
        },
        ObjectDefineProperty(self2, name2, prop) {
          return Object.defineProperty(self2, name2, prop);
        },
        ObjectGetOwnPropertyDescriptor(self2, name2) {
          return Object.getOwnPropertyDescriptor(self2, name2);
        },
        ObjectKeys(obj) {
          return Object.keys(obj);
        },
        ObjectSetPrototypeOf(target, proto2) {
          return Object.setPrototypeOf(target, proto2);
        },
        Promise,
        PromisePrototypeCatch(self2, fn) {
          return self2.catch(fn);
        },
        PromisePrototypeThen(self2, thenFn, catchFn) {
          return self2.then(thenFn, catchFn);
        },
        PromiseReject(err3) {
          return Promise.reject(err3);
        },
        PromiseResolve(val) {
          return Promise.resolve(val);
        },
        ReflectApply: Reflect.apply,
        RegExpPrototypeTest(self2, value) {
          return self2.test(value);
        },
        SafeSet: Set,
        String,
        StringPrototypeSlice(self2, start, end) {
          return self2.slice(start, end);
        },
        StringPrototypeToLowerCase(self2) {
          return self2.toLowerCase();
        },
        StringPrototypeToUpperCase(self2) {
          return self2.toUpperCase();
        },
        StringPrototypeTrim(self2) {
          return self2.trim();
        },
        Symbol,
        SymbolFor: Symbol.for,
        SymbolAsyncIterator: Symbol.asyncIterator,
        SymbolHasInstance: Symbol.hasInstance,
        SymbolIterator: Symbol.iterator,
        SymbolDispose: Symbol.dispose || Symbol("Symbol.dispose"),
        SymbolAsyncDispose: Symbol.asyncDispose || Symbol("Symbol.asyncDispose"),
        TypedArrayPrototypeSet(self2, buf, len) {
          return self2.set(buf, len);
        },
        Boolean,
        Uint8Array
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/util/inspect.js
  var require_inspect = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/util/inspect.js"(exports2, module2) {
      "use strict";
      module2.exports = {
        format(format5, ...args) {
          return format5.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === "f") {
              return replacement.toFixed(6);
            } else if (type === "j") {
              return JSON.stringify(replacement);
            } else if (type === "s" && typeof replacement === "object") {
              const ctor = replacement.constructor !== Object ? replacement.constructor.name : "";
              return `${ctor} {}`.trim();
            } else {
              return replacement.toString();
            }
          });
        },
        inspect(value) {
          switch (typeof value) {
            case "string":
              if (value.includes("'")) {
                if (!value.includes('"')) {
                  return `"${value}"`;
                } else if (!value.includes("`") && !value.includes("${")) {
                  return `\`${value}\``;
                }
              }
              return `'${value}'`;
            case "number":
              if (isNaN(value)) {
                return "NaN";
              } else if (Object.is(value, -0)) {
                return String(value);
              }
              return value;
            case "bigint":
              return `${String(value)}n`;
            case "boolean":
            case "undefined":
              return String(value);
            case "object":
              return "{}";
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/errors.js
  var require_errors = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/errors.js"(exports2, module2) {
      "use strict";
      var { format: format5, inspect } = require_inspect();
      var { AggregateError: CustomAggregateError } = require_primordials();
      var AggregateError = globalThis.AggregateError || CustomAggregateError;
      var kIsNodeError = Symbol("kIsNodeError");
      var kTypes = [
        "string",
        "function",
        "number",
        "object",
        // Accept 'Function' and 'Object' as alternative to the lower cased version.
        "Function",
        "Object",
        "boolean",
        "bigint",
        "symbol"
      ];
      var classRegExp = /^([A-Z][a-z0-9]*)+$/;
      var nodeInternalPrefix = "__node_internal_";
      var codes = {};
      function assert2(value, message) {
        if (!value) {
          throw new codes.ERR_INTERNAL_ASSERTION(message);
        }
      }
      function addNumericalSeparator(val) {
        let res = "";
        let i2 = val.length;
        const start = val[0] === "-" ? 1 : 0;
        for (; i2 >= start + 4; i2 -= 3) {
          res = `_${val.slice(i2 - 3, i2)}${res}`;
        }
        return `${val.slice(0, i2)}${res}`;
      }
      function getMessage2(key, msg, args) {
        if (typeof msg === "function") {
          assert2(
            msg.length <= args.length,
            // Default options do not count.
            `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`
          );
          return msg(...args);
        }
        const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
        assert2(
          expectedLength === args.length,
          `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`
        );
        if (args.length === 0) {
          return msg;
        }
        return format5(msg, ...args);
      }
      function E(code, message, Base) {
        if (!Base) {
          Base = Error;
        }
        class NodeError extends Base {
          constructor(...args) {
            super(getMessage2(code, message, args));
          }
          toString() {
            return `${this.name} [${code}]: ${this.message}`;
          }
        }
        Object.defineProperties(NodeError.prototype, {
          name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
          },
          toString: {
            value() {
              return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
          }
        });
        NodeError.prototype.code = code;
        NodeError.prototype[kIsNodeError] = true;
        codes[code] = NodeError;
      }
      function hideStackFrames(fn) {
        const hidden = nodeInternalPrefix + fn.name;
        Object.defineProperty(fn, "name", {
          value: hidden
        });
        return fn;
      }
      function aggregateTwoErrors(innerError, outerError) {
        if (innerError && outerError && innerError !== outerError) {
          if (Array.isArray(outerError.errors)) {
            outerError.errors.push(innerError);
            return outerError;
          }
          const err3 = new AggregateError([outerError, innerError], outerError.message);
          err3.code = outerError.code;
          return err3;
        }
        return innerError || outerError;
      }
      var AbortError = class extends Error {
        constructor(message = "The operation was aborted", options = void 0) {
          if (options !== void 0 && typeof options !== "object") {
            throw new codes.ERR_INVALID_ARG_TYPE("options", "Object", options);
          }
          super(message, options);
          this.code = "ABORT_ERR";
          this.name = "AbortError";
        }
      };
      E("ERR_ASSERTION", "%s", Error);
      E(
        "ERR_INVALID_ARG_TYPE",
        (name2, expected, actual) => {
          assert2(typeof name2 === "string", "'name' must be a string");
          if (!Array.isArray(expected)) {
            expected = [expected];
          }
          let msg = "The ";
          if (name2.endsWith(" argument")) {
            msg += `${name2} `;
          } else {
            msg += `"${name2}" ${name2.includes(".") ? "property" : "argument"} `;
          }
          msg += "must be ";
          const types3 = [];
          const instances = [];
          const other = [];
          for (const value of expected) {
            assert2(typeof value === "string", "All expected entries have to be of type string");
            if (kTypes.includes(value)) {
              types3.push(value.toLowerCase());
            } else if (classRegExp.test(value)) {
              instances.push(value);
            } else {
              assert2(value !== "object", 'The value "object" should be written as "Object"');
              other.push(value);
            }
          }
          if (instances.length > 0) {
            const pos = types3.indexOf("object");
            if (pos !== -1) {
              types3.splice(types3, pos, 1);
              instances.push("Object");
            }
          }
          if (types3.length > 0) {
            switch (types3.length) {
              case 1:
                msg += `of type ${types3[0]}`;
                break;
              case 2:
                msg += `one of type ${types3[0]} or ${types3[1]}`;
                break;
              default: {
                const last = types3.pop();
                msg += `one of type ${types3.join(", ")}, or ${last}`;
              }
            }
            if (instances.length > 0 || other.length > 0) {
              msg += " or ";
            }
          }
          if (instances.length > 0) {
            switch (instances.length) {
              case 1:
                msg += `an instance of ${instances[0]}`;
                break;
              case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
              default: {
                const last = instances.pop();
                msg += `an instance of ${instances.join(", ")}, or ${last}`;
              }
            }
            if (other.length > 0) {
              msg += " or ";
            }
          }
          switch (other.length) {
            case 0:
              break;
            case 1:
              if (other[0].toLowerCase() !== other[0]) {
                msg += "an ";
              }
              msg += `${other[0]}`;
              break;
            case 2:
              msg += `one of ${other[0]} or ${other[1]}`;
              break;
            default: {
              const last = other.pop();
              msg += `one of ${other.join(", ")}, or ${last}`;
            }
          }
          if (actual == null) {
            msg += `. Received ${actual}`;
          } else if (typeof actual === "function" && actual.name) {
            msg += `. Received function ${actual.name}`;
          } else if (typeof actual === "object") {
            var _actual$constructor;
            if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== void 0 && _actual$constructor.name) {
              msg += `. Received an instance of ${actual.constructor.name}`;
            } else {
              const inspected = inspect(actual, {
                depth: -1
              });
              msg += `. Received ${inspected}`;
            }
          } else {
            let inspected = inspect(actual, {
              colors: false
            });
            if (inspected.length > 25) {
              inspected = `${inspected.slice(0, 25)}...`;
            }
            msg += `. Received type ${typeof actual} (${inspected})`;
          }
          return msg;
        },
        TypeError
      );
      E(
        "ERR_INVALID_ARG_VALUE",
        (name2, value, reason = "is invalid") => {
          let inspected = inspect(value);
          if (inspected.length > 128) {
            inspected = inspected.slice(0, 128) + "...";
          }
          const type = name2.includes(".") ? "property" : "argument";
          return `The ${type} '${name2}' ${reason}. Received ${inspected}`;
        },
        TypeError
      );
      E(
        "ERR_INVALID_RETURN_VALUE",
        (input, name2, value) => {
          var _value$constructor;
          const type = value !== null && value !== void 0 && (_value$constructor = value.constructor) !== null && _value$constructor !== void 0 && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
          return `Expected ${input} to be returned from the "${name2}" function but got ${type}.`;
        },
        TypeError
      );
      E(
        "ERR_MISSING_ARGS",
        (...args) => {
          assert2(args.length > 0, "At least one arg needs to be specified");
          let msg;
          const len = args.length;
          args = (Array.isArray(args) ? args : [args]).map((a) => `"${a}"`).join(" or ");
          switch (len) {
            case 1:
              msg += `The ${args[0]} argument`;
              break;
            case 2:
              msg += `The ${args[0]} and ${args[1]} arguments`;
              break;
            default:
              {
                const last = args.pop();
                msg += `The ${args.join(", ")}, and ${last} arguments`;
              }
              break;
          }
          return `${msg} must be specified`;
        },
        TypeError
      );
      E(
        "ERR_OUT_OF_RANGE",
        (str, range, input) => {
          assert2(range, 'Missing "range" argument');
          let received;
          if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
            received = addNumericalSeparator(String(input));
          } else if (typeof input === "bigint") {
            received = String(input);
            const limit = BigInt(2) ** BigInt(32);
            if (input > limit || input < -limit) {
              received = addNumericalSeparator(received);
            }
            received += "n";
          } else {
            received = inspect(input);
          }
          return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
        },
        RangeError
      );
      E("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
      E("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
      E("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
      E("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
      E("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
      E("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
      E("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
      E("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
      E("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
      E("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
      E("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
      module2.exports = {
        AbortError,
        aggregateTwoErrors: hideStackFrames(aggregateTwoErrors),
        hideStackFrames,
        codes
      };
    }
  });

  // ../../node_modules/.pnpm/abort-controller@3.0.0/node_modules/abort-controller/browser.js
  var require_browser = __commonJS({
    "../../node_modules/.pnpm/abort-controller@3.0.0/node_modules/abort-controller/browser.js"(exports2, module2) {
      "use strict";
      var { AbortController: AbortController2, AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : (
        /* otherwise */
        void 0
      );
      module2.exports = AbortController2;
      module2.exports.AbortSignal = AbortSignal;
      module2.exports.default = AbortController2;
    }
  });

  // ../../node_modules/.pnpm/events@3.3.0/node_modules/events/events.js
  var require_events = __commonJS({
    "../../node_modules/.pnpm/events@3.3.0/node_modules/events/events.js"(exports2, module2) {
      "use strict";
      var R = typeof Reflect === "object" ? Reflect : null;
      var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
      };
      var ReflectOwnKeys;
      if (R && typeof R.ownKeys === "function") {
        ReflectOwnKeys = R.ownKeys;
      } else if (Object.getOwnPropertySymbols) {
        ReflectOwnKeys = function ReflectOwnKeys2(target) {
          return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
        };
      } else {
        ReflectOwnKeys = function ReflectOwnKeys2(target) {
          return Object.getOwnPropertyNames(target);
        };
      }
      function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
      }
      var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
        return value !== value;
      };
      function EventEmitter4() {
        EventEmitter4.init.call(this);
      }
      module2.exports = EventEmitter4;
      module2.exports.once = once;
      EventEmitter4.EventEmitter = EventEmitter4;
      EventEmitter4.prototype._events = void 0;
      EventEmitter4.prototype._eventsCount = 0;
      EventEmitter4.prototype._maxListeners = void 0;
      var defaultMaxListeners = 10;
      function checkListener(listener) {
        if (typeof listener !== "function") {
          throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
        }
      }
      Object.defineProperty(EventEmitter4, "defaultMaxListeners", {
        enumerable: true,
        get: function() {
          return defaultMaxListeners;
        },
        set: function(arg) {
          if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
            throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
          }
          defaultMaxListeners = arg;
        }
      });
      EventEmitter4.init = function() {
        if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || void 0;
      };
      EventEmitter4.prototype.setMaxListeners = function setMaxListeners(n2) {
        if (typeof n2 !== "number" || n2 < 0 || NumberIsNaN(n2)) {
          throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n2 + ".");
        }
        this._maxListeners = n2;
        return this;
      };
      function _getMaxListeners(that) {
        if (that._maxListeners === void 0)
          return EventEmitter4.defaultMaxListeners;
        return that._maxListeners;
      }
      EventEmitter4.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
      };
      EventEmitter4.prototype.emit = function emit(type) {
        var args = [];
        for (var i2 = 1; i2 < arguments.length; i2++) args.push(arguments[i2]);
        var doError = type === "error";
        var events = this._events;
        if (events !== void 0)
          doError = doError && events.error === void 0;
        else if (!doError)
          return false;
        if (doError) {
          var er;
          if (args.length > 0)
            er = args[0];
          if (er instanceof Error) {
            throw er;
          }
          var err3 = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
          err3.context = er;
          throw err3;
        }
        var handler = events[type];
        if (handler === void 0)
          return false;
        if (typeof handler === "function") {
          ReflectApply(handler, this, args);
        } else {
          var len = handler.length;
          var listeners = arrayClone(handler, len);
          for (var i2 = 0; i2 < len; ++i2)
            ReflectApply(listeners[i2], this, args);
        }
        return true;
      };
      function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        checkListener(listener);
        events = target._events;
        if (events === void 0) {
          events = target._events = /* @__PURE__ */ Object.create(null);
          target._eventsCount = 0;
        } else {
          if (events.newListener !== void 0) {
            target.emit(
              "newListener",
              type,
              listener.listener ? listener.listener : listener
            );
            events = target._events;
          }
          existing = events[type];
        }
        if (existing === void 0) {
          existing = events[type] = listener;
          ++target._eventsCount;
        } else {
          if (typeof existing === "function") {
            existing = events[type] = prepend ? [listener, existing] : [existing, listener];
          } else if (prepend) {
            existing.unshift(listener);
          } else {
            existing.push(listener);
          }
          m = _getMaxListeners(target);
          if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
          }
        }
        return target;
      }
      EventEmitter4.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
      };
      EventEmitter4.prototype.on = EventEmitter4.prototype.addListener;
      EventEmitter4.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
      };
      function onceWrapper() {
        if (!this.fired) {
          this.target.removeListener(this.type, this.wrapFn);
          this.fired = true;
          if (arguments.length === 0)
            return this.listener.call(this.target);
          return this.listener.apply(this.target, arguments);
        }
      }
      function _onceWrap(target, type, listener) {
        var state = { fired: false, wrapFn: void 0, target, type, listener };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
      }
      EventEmitter4.prototype.once = function once2(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
      };
      EventEmitter4.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
      };
      EventEmitter4.prototype.removeListener = function removeListener(type, listener) {
        var list2, events, position, i2, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === void 0)
          return this;
        list2 = events[type];
        if (list2 === void 0)
          return this;
        if (list2 === listener || list2.listener === listener) {
          if (--this._eventsCount === 0)
            this._events = /* @__PURE__ */ Object.create(null);
          else {
            delete events[type];
            if (events.removeListener)
              this.emit("removeListener", type, list2.listener || listener);
          }
        } else if (typeof list2 !== "function") {
          position = -1;
          for (i2 = list2.length - 1; i2 >= 0; i2--) {
            if (list2[i2] === listener || list2[i2].listener === listener) {
              originalListener = list2[i2].listener;
              position = i2;
              break;
            }
          }
          if (position < 0)
            return this;
          if (position === 0)
            list2.shift();
          else {
            spliceOne(list2, position);
          }
          if (list2.length === 1)
            events[type] = list2[0];
          if (events.removeListener !== void 0)
            this.emit("removeListener", type, originalListener || listener);
        }
        return this;
      };
      EventEmitter4.prototype.off = EventEmitter4.prototype.removeListener;
      EventEmitter4.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i2;
        events = this._events;
        if (events === void 0)
          return this;
        if (events.removeListener === void 0) {
          if (arguments.length === 0) {
            this._events = /* @__PURE__ */ Object.create(null);
            this._eventsCount = 0;
          } else if (events[type] !== void 0) {
            if (--this._eventsCount === 0)
              this._events = /* @__PURE__ */ Object.create(null);
            else
              delete events[type];
          }
          return this;
        }
        if (arguments.length === 0) {
          var keys = Object.keys(events);
          var key;
          for (i2 = 0; i2 < keys.length; ++i2) {
            key = keys[i2];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
          }
          this.removeAllListeners("removeListener");
          this._events = /* @__PURE__ */ Object.create(null);
          this._eventsCount = 0;
          return this;
        }
        listeners = events[type];
        if (typeof listeners === "function") {
          this.removeListener(type, listeners);
        } else if (listeners !== void 0) {
          for (i2 = listeners.length - 1; i2 >= 0; i2--) {
            this.removeListener(type, listeners[i2]);
          }
        }
        return this;
      };
      function _listeners(target, type, unwrap) {
        var events = target._events;
        if (events === void 0)
          return [];
        var evlistener = events[type];
        if (evlistener === void 0)
          return [];
        if (typeof evlistener === "function")
          return unwrap ? [evlistener.listener || evlistener] : [evlistener];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
      }
      EventEmitter4.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
      };
      EventEmitter4.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
      };
      EventEmitter4.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === "function") {
          return emitter.listenerCount(type);
        } else {
          return listenerCount.call(emitter, type);
        }
      };
      EventEmitter4.prototype.listenerCount = listenerCount;
      function listenerCount(type) {
        var events = this._events;
        if (events !== void 0) {
          var evlistener = events[type];
          if (typeof evlistener === "function") {
            return 1;
          } else if (evlistener !== void 0) {
            return evlistener.length;
          }
        }
        return 0;
      }
      EventEmitter4.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
      };
      function arrayClone(arr, n2) {
        var copy = new Array(n2);
        for (var i2 = 0; i2 < n2; ++i2)
          copy[i2] = arr[i2];
        return copy;
      }
      function spliceOne(list2, index2) {
        for (; index2 + 1 < list2.length; index2++)
          list2[index2] = list2[index2 + 1];
        list2.pop();
      }
      function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for (var i2 = 0; i2 < ret.length; ++i2) {
          ret[i2] = arr[i2].listener || arr[i2];
        }
        return ret;
      }
      function once(emitter, name2) {
        return new Promise(function(resolve2, reject) {
          function errorListener(err3) {
            emitter.removeListener(name2, resolver);
            reject(err3);
          }
          function resolver() {
            if (typeof emitter.removeListener === "function") {
              emitter.removeListener("error", errorListener);
            }
            resolve2([].slice.call(arguments));
          }
          ;
          eventTargetAgnosticAddListener(emitter, name2, resolver, { once: true });
          if (name2 !== "error") {
            addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
          }
        });
      }
      function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === "function") {
          eventTargetAgnosticAddListener(emitter, "error", handler, flags);
        }
      }
      function eventTargetAgnosticAddListener(emitter, name2, listener, flags) {
        if (typeof emitter.on === "function") {
          if (flags.once) {
            emitter.once(name2, listener);
          } else {
            emitter.on(name2, listener);
          }
        } else if (typeof emitter.addEventListener === "function") {
          emitter.addEventListener(name2, function wrapListener(arg) {
            if (flags.once) {
              emitter.removeEventListener(name2, wrapListener);
            }
            listener(arg);
          });
        } else {
          throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
        }
      }
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/util.js
  var require_util = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/util.js"(exports2, module2) {
      "use strict";
      var bufferModule = require_buffer();
      var { format: format5, inspect } = require_inspect();
      var {
        codes: { ERR_INVALID_ARG_TYPE }
      } = require_errors();
      var { kResistStopPropagation, AggregateError, SymbolDispose } = require_primordials();
      var AbortSignal = globalThis.AbortSignal || require_browser().AbortSignal;
      var AbortController2 = globalThis.AbortController || require_browser().AbortController;
      var AsyncFunction = Object.getPrototypeOf(async function() {
      }).constructor;
      var Blob2 = globalThis.Blob || bufferModule.Blob;
      var isBlob2 = typeof Blob2 !== "undefined" ? function isBlob3(b) {
        return b instanceof Blob2;
      } : function isBlob3(b) {
        return false;
      };
      var validateAbortSignal = (signal, name2) => {
        if (signal !== void 0 && (signal === null || typeof signal !== "object" || !("aborted" in signal))) {
          throw new ERR_INVALID_ARG_TYPE(name2, "AbortSignal", signal);
        }
      };
      var validateFunction = (value, name2) => {
        if (typeof value !== "function") {
          throw new ERR_INVALID_ARG_TYPE(name2, "Function", value);
        }
      };
      module2.exports = {
        AggregateError,
        kEmptyObject: Object.freeze({}),
        once(callback) {
          let called = false;
          return function(...args) {
            if (called) {
              return;
            }
            called = true;
            callback.apply(this, args);
          };
        },
        createDeferredPromise: function() {
          let resolve2;
          let reject;
          const promise = new Promise((res, rej) => {
            resolve2 = res;
            reject = rej;
          });
          return {
            promise,
            resolve: resolve2,
            reject
          };
        },
        promisify(fn) {
          return new Promise((resolve2, reject) => {
            fn((err3, ...args) => {
              if (err3) {
                return reject(err3);
              }
              return resolve2(...args);
            });
          });
        },
        debuglog() {
          return function() {
          };
        },
        format: format5,
        inspect,
        types: {
          isAsyncFunction(fn) {
            return fn instanceof AsyncFunction;
          },
          isArrayBufferView(arr) {
            return ArrayBuffer.isView(arr);
          }
        },
        isBlob: isBlob2,
        deprecate(fn, message) {
          return fn;
        },
        addAbortListener: require_events().addAbortListener || function addAbortListener(signal, listener) {
          if (signal === void 0) {
            throw new ERR_INVALID_ARG_TYPE("signal", "AbortSignal", signal);
          }
          validateAbortSignal(signal, "signal");
          validateFunction(listener, "listener");
          let removeEventListener;
          if (signal.aborted) {
            queueMicrotask(() => listener());
          } else {
            signal.addEventListener("abort", listener, {
              __proto__: null,
              once: true,
              [kResistStopPropagation]: true
            });
            removeEventListener = () => {
              signal.removeEventListener("abort", listener);
            };
          }
          return {
            __proto__: null,
            [SymbolDispose]() {
              var _removeEventListener;
              (_removeEventListener = removeEventListener) === null || _removeEventListener === void 0 ? void 0 : _removeEventListener();
            }
          };
        },
        AbortSignalAny: AbortSignal.any || function AbortSignalAny(signals) {
          if (signals.length === 1) {
            return signals[0];
          }
          const ac = new AbortController2();
          const abort = () => ac.abort();
          signals.forEach((signal) => {
            validateAbortSignal(signal, "signals");
            signal.addEventListener("abort", abort, {
              once: true
            });
          });
          ac.signal.addEventListener(
            "abort",
            () => {
              signals.forEach((signal) => signal.removeEventListener("abort", abort));
            },
            {
              once: true
            }
          );
          return ac.signal;
        }
      };
      module2.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/validators.js
  var require_validators = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/validators.js"(exports2, module2) {
      "use strict";
      var {
        ArrayIsArray,
        ArrayPrototypeIncludes,
        ArrayPrototypeJoin,
        ArrayPrototypeMap,
        NumberIsInteger,
        NumberIsNaN,
        NumberMAX_SAFE_INTEGER,
        NumberMIN_SAFE_INTEGER,
        NumberParseInt,
        ObjectPrototypeHasOwnProperty,
        RegExpPrototypeExec,
        String: String2,
        StringPrototypeToUpperCase,
        StringPrototypeTrim
      } = require_primordials();
      var {
        hideStackFrames,
        codes: { ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL }
      } = require_errors();
      var { normalizeEncoding } = require_util();
      var { isAsyncFunction, isArrayBufferView: isArrayBufferView2 } = require_util().types;
      var signals = {};
      function isInt32(value) {
        return value === (value | 0);
      }
      function isUint32(value) {
        return value === value >>> 0;
      }
      var octalReg = /^[0-7]+$/;
      var modeDesc = "must be a 32-bit unsigned integer or an octal string";
      function parseFileMode(value, name2, def) {
        if (typeof value === "undefined") {
          value = def;
        }
        if (typeof value === "string") {
          if (RegExpPrototypeExec(octalReg, value) === null) {
            throw new ERR_INVALID_ARG_VALUE(name2, value, modeDesc);
          }
          value = NumberParseInt(value, 8);
        }
        validateUint32(value, name2);
        return value;
      }
      var validateInteger = hideStackFrames((value, name2, min = NumberMIN_SAFE_INTEGER, max2 = NumberMAX_SAFE_INTEGER) => {
        if (typeof value !== "number") throw new ERR_INVALID_ARG_TYPE(name2, "number", value);
        if (!NumberIsInteger(value)) throw new ERR_OUT_OF_RANGE(name2, "an integer", value);
        if (value < min || value > max2) throw new ERR_OUT_OF_RANGE(name2, `>= ${min} && <= ${max2}`, value);
      });
      var validateInt32 = hideStackFrames((value, name2, min = -2147483648, max2 = 2147483647) => {
        if (typeof value !== "number") {
          throw new ERR_INVALID_ARG_TYPE(name2, "number", value);
        }
        if (!NumberIsInteger(value)) {
          throw new ERR_OUT_OF_RANGE(name2, "an integer", value);
        }
        if (value < min || value > max2) {
          throw new ERR_OUT_OF_RANGE(name2, `>= ${min} && <= ${max2}`, value);
        }
      });
      var validateUint32 = hideStackFrames((value, name2, positive = false) => {
        if (typeof value !== "number") {
          throw new ERR_INVALID_ARG_TYPE(name2, "number", value);
        }
        if (!NumberIsInteger(value)) {
          throw new ERR_OUT_OF_RANGE(name2, "an integer", value);
        }
        const min = positive ? 1 : 0;
        const max2 = 4294967295;
        if (value < min || value > max2) {
          throw new ERR_OUT_OF_RANGE(name2, `>= ${min} && <= ${max2}`, value);
        }
      });
      function validateString(value, name2) {
        if (typeof value !== "string") throw new ERR_INVALID_ARG_TYPE(name2, "string", value);
      }
      function validateNumber(value, name2, min = void 0, max2) {
        if (typeof value !== "number") throw new ERR_INVALID_ARG_TYPE(name2, "number", value);
        if (min != null && value < min || max2 != null && value > max2 || (min != null || max2 != null) && NumberIsNaN(value)) {
          throw new ERR_OUT_OF_RANGE(
            name2,
            `${min != null ? `>= ${min}` : ""}${min != null && max2 != null ? " && " : ""}${max2 != null ? `<= ${max2}` : ""}`,
            value
          );
        }
      }
      var validateOneOf = hideStackFrames((value, name2, oneOf) => {
        if (!ArrayPrototypeIncludes(oneOf, value)) {
          const allowed = ArrayPrototypeJoin(
            ArrayPrototypeMap(oneOf, (v) => typeof v === "string" ? `'${v}'` : String2(v)),
            ", "
          );
          const reason = "must be one of: " + allowed;
          throw new ERR_INVALID_ARG_VALUE(name2, value, reason);
        }
      });
      function validateBoolean(value, name2) {
        if (typeof value !== "boolean") throw new ERR_INVALID_ARG_TYPE(name2, "boolean", value);
      }
      function getOwnPropertyValueOrDefault(options, key, defaultValue) {
        return options == null || !ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
      }
      var validateObject3 = hideStackFrames((value, name2, options = null) => {
        const allowArray = getOwnPropertyValueOrDefault(options, "allowArray", false);
        const allowFunction = getOwnPropertyValueOrDefault(options, "allowFunction", false);
        const nullable = getOwnPropertyValueOrDefault(options, "nullable", false);
        if (!nullable && value === null || !allowArray && ArrayIsArray(value) || typeof value !== "object" && (!allowFunction || typeof value !== "function")) {
          throw new ERR_INVALID_ARG_TYPE(name2, "Object", value);
        }
      });
      var validateDictionary = hideStackFrames((value, name2) => {
        if (value != null && typeof value !== "object" && typeof value !== "function") {
          throw new ERR_INVALID_ARG_TYPE(name2, "a dictionary", value);
        }
      });
      var validateArray = hideStackFrames((value, name2, minLength = 0) => {
        if (!ArrayIsArray(value)) {
          throw new ERR_INVALID_ARG_TYPE(name2, "Array", value);
        }
        if (value.length < minLength) {
          const reason = `must be longer than ${minLength}`;
          throw new ERR_INVALID_ARG_VALUE(name2, value, reason);
        }
      });
      function validateStringArray(value, name2) {
        validateArray(value, name2);
        for (let i2 = 0; i2 < value.length; i2++) {
          validateString(value[i2], `${name2}[${i2}]`);
        }
      }
      function validateBooleanArray(value, name2) {
        validateArray(value, name2);
        for (let i2 = 0; i2 < value.length; i2++) {
          validateBoolean(value[i2], `${name2}[${i2}]`);
        }
      }
      function validateAbortSignalArray(value, name2) {
        validateArray(value, name2);
        for (let i2 = 0; i2 < value.length; i2++) {
          const signal = value[i2];
          const indexedName = `${name2}[${i2}]`;
          if (signal == null) {
            throw new ERR_INVALID_ARG_TYPE(indexedName, "AbortSignal", signal);
          }
          validateAbortSignal(signal, indexedName);
        }
      }
      function validateSignalName(signal, name2 = "signal") {
        validateString(signal, name2);
        if (signals[signal] === void 0) {
          if (signals[StringPrototypeToUpperCase(signal)] !== void 0) {
            throw new ERR_UNKNOWN_SIGNAL(signal + " (signals must use all capital letters)");
          }
          throw new ERR_UNKNOWN_SIGNAL(signal);
        }
      }
      var validateBuffer = hideStackFrames((buffer, name2 = "buffer") => {
        if (!isArrayBufferView2(buffer)) {
          throw new ERR_INVALID_ARG_TYPE(name2, ["Buffer", "TypedArray", "DataView"], buffer);
        }
      });
      function validateEncoding(data, encoding) {
        const normalizedEncoding = normalizeEncoding(encoding);
        const length2 = data.length;
        if (normalizedEncoding === "hex" && length2 % 2 !== 0) {
          throw new ERR_INVALID_ARG_VALUE("encoding", encoding, `is invalid for data of length ${length2}`);
        }
      }
      function validatePort(port, name2 = "Port", allowZero = true) {
        if (typeof port !== "number" && typeof port !== "string" || typeof port === "string" && StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 65535 || port === 0 && !allowZero) {
          throw new ERR_SOCKET_BAD_PORT(name2, port, allowZero);
        }
        return port | 0;
      }
      var validateAbortSignal = hideStackFrames((signal, name2) => {
        if (signal !== void 0 && (signal === null || typeof signal !== "object" || !("aborted" in signal))) {
          throw new ERR_INVALID_ARG_TYPE(name2, "AbortSignal", signal);
        }
      });
      var validateFunction = hideStackFrames((value, name2) => {
        if (typeof value !== "function") throw new ERR_INVALID_ARG_TYPE(name2, "Function", value);
      });
      var validatePlainFunction = hideStackFrames((value, name2) => {
        if (typeof value !== "function" || isAsyncFunction(value)) throw new ERR_INVALID_ARG_TYPE(name2, "Function", value);
      });
      var validateUndefined = hideStackFrames((value, name2) => {
        if (value !== void 0) throw new ERR_INVALID_ARG_TYPE(name2, "undefined", value);
      });
      function validateUnion(value, name2, union) {
        if (!ArrayPrototypeIncludes(union, value)) {
          throw new ERR_INVALID_ARG_TYPE(name2, `('${ArrayPrototypeJoin(union, "|")}')`, value);
        }
      }
      var linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
      function validateLinkHeaderFormat(value, name2) {
        if (typeof value === "undefined" || !RegExpPrototypeExec(linkValueRegExp, value)) {
          throw new ERR_INVALID_ARG_VALUE(
            name2,
            value,
            'must be an array or string of format "</styles.css>; rel=preload; as=style"'
          );
        }
      }
      function validateLinkHeaderValue(hints) {
        if (typeof hints === "string") {
          validateLinkHeaderFormat(hints, "hints");
          return hints;
        } else if (ArrayIsArray(hints)) {
          const hintsLength = hints.length;
          let result = "";
          if (hintsLength === 0) {
            return result;
          }
          for (let i2 = 0; i2 < hintsLength; i2++) {
            const link3 = hints[i2];
            validateLinkHeaderFormat(link3, "hints");
            result += link3;
            if (i2 !== hintsLength - 1) {
              result += ", ";
            }
          }
          return result;
        }
        throw new ERR_INVALID_ARG_VALUE(
          "hints",
          hints,
          'must be an array or string of format "</styles.css>; rel=preload; as=style"'
        );
      }
      module2.exports = {
        isInt32,
        isUint32,
        parseFileMode,
        validateArray,
        validateStringArray,
        validateBooleanArray,
        validateAbortSignalArray,
        validateBoolean,
        validateBuffer,
        validateDictionary,
        validateEncoding,
        validateFunction,
        validateInt32,
        validateInteger,
        validateNumber,
        validateObject: validateObject3,
        validateOneOf,
        validatePlainFunction,
        validatePort,
        validateSignalName,
        validateString,
        validateUint32,
        validateUndefined,
        validateUnion,
        validateAbortSignal,
        validateLinkHeaderValue
      };
    }
  });

  // ../../node_modules/.pnpm/process@0.11.10/node_modules/process/browser.js
  var require_browser2 = __commonJS({
    "../../node_modules/.pnpm/process@0.11.10/node_modules/process/browser.js"(exports2, module2) {
      var process2 = module2.exports = {};
      var cachedSetTimeout;
      var cachedClearTimeout;
      function defaultSetTimout() {
        throw new Error("setTimeout has not been defined");
      }
      function defaultClearTimeout() {
        throw new Error("clearTimeout has not been defined");
      }
      (function() {
        try {
          if (typeof setTimeout === "function") {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e2) {
          cachedSetTimeout = defaultSetTimout;
        }
        try {
          if (typeof clearTimeout === "function") {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e2) {
          cachedClearTimeout = defaultClearTimeout;
        }
      })();
      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          return setTimeout(fun, 0);
        }
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }
        try {
          return cachedSetTimeout(fun, 0);
        } catch (e2) {
          try {
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e3) {
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }
      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          return clearTimeout(marker);
        }
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }
        try {
          return cachedClearTimeout(marker);
        } catch (e2) {
          try {
            return cachedClearTimeout.call(null, marker);
          } catch (e3) {
            return cachedClearTimeout.call(this, marker);
          }
        }
      }
      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;
      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }
        draining = false;
        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }
        if (queue.length) {
          drainQueue();
        }
      }
      function drainQueue() {
        if (draining) {
          return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;
        while (len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }
          queueIndex = -1;
          len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }
      process2.nextTick = function(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            args[i2 - 1] = arguments[i2];
          }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      };
      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }
      Item.prototype.run = function() {
        this.fun.apply(null, this.array);
      };
      process2.title = "browser";
      process2.browser = true;
      process2.env = {};
      process2.argv = [];
      process2.version = "";
      process2.versions = {};
      function noop2() {
      }
      process2.on = noop2;
      process2.addListener = noop2;
      process2.once = noop2;
      process2.off = noop2;
      process2.removeListener = noop2;
      process2.removeAllListeners = noop2;
      process2.emit = noop2;
      process2.prependListener = noop2;
      process2.prependOnceListener = noop2;
      process2.listeners = function(name2) {
        return [];
      };
      process2.binding = function(name2) {
        throw new Error("process.binding is not supported");
      };
      process2.cwd = function() {
        return "/";
      };
      process2.chdir = function(dir) {
        throw new Error("process.chdir is not supported");
      };
      process2.umask = function() {
        return 0;
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/utils.js
  var require_utils = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/utils.js"(exports2, module2) {
      "use strict";
      var { SymbolAsyncIterator, SymbolIterator, SymbolFor } = require_primordials();
      var kIsDestroyed = SymbolFor("nodejs.stream.destroyed");
      var kIsErrored = SymbolFor("nodejs.stream.errored");
      var kIsReadable = SymbolFor("nodejs.stream.readable");
      var kIsWritable = SymbolFor("nodejs.stream.writable");
      var kIsDisturbed = SymbolFor("nodejs.stream.disturbed");
      var kIsClosedPromise = SymbolFor("nodejs.webstream.isClosedPromise");
      var kControllerErrorFunction = SymbolFor("nodejs.webstream.controllerErrorFunction");
      function isReadableNodeStream(obj, strict = false) {
        var _obj$_readableState;
        return !!(obj && typeof obj.pipe === "function" && typeof obj.on === "function" && (!strict || typeof obj.pause === "function" && typeof obj.resume === "function") && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === void 0 ? void 0 : _obj$_readableState.readable) !== false) && // Duplex
        (!obj._writableState || obj._readableState));
      }
      function isWritableNodeStream(obj) {
        var _obj$_writableState;
        return !!(obj && typeof obj.write === "function" && typeof obj.on === "function" && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === void 0 ? void 0 : _obj$_writableState.writable) !== false));
      }
      function isDuplexNodeStream(obj) {
        return !!(obj && typeof obj.pipe === "function" && obj._readableState && typeof obj.on === "function" && typeof obj.write === "function");
      }
      function isNodeStream(obj) {
        return obj && (obj._readableState || obj._writableState || typeof obj.write === "function" && typeof obj.on === "function" || typeof obj.pipe === "function" && typeof obj.on === "function");
      }
      function isReadableStream(obj) {
        return !!(obj && !isNodeStream(obj) && typeof obj.pipeThrough === "function" && typeof obj.getReader === "function" && typeof obj.cancel === "function");
      }
      function isWritableStream(obj) {
        return !!(obj && !isNodeStream(obj) && typeof obj.getWriter === "function" && typeof obj.abort === "function");
      }
      function isTransformStream(obj) {
        return !!(obj && !isNodeStream(obj) && typeof obj.readable === "object" && typeof obj.writable === "object");
      }
      function isWebStream(obj) {
        return isReadableStream(obj) || isWritableStream(obj) || isTransformStream(obj);
      }
      function isIterable2(obj, isAsync3) {
        if (obj == null) return false;
        if (isAsync3 === true) return typeof obj[SymbolAsyncIterator] === "function";
        if (isAsync3 === false) return typeof obj[SymbolIterator] === "function";
        return typeof obj[SymbolAsyncIterator] === "function" || typeof obj[SymbolIterator] === "function";
      }
      function isDestroyed(stream) {
        if (!isNodeStream(stream)) return null;
        const wState = stream._writableState;
        const rState = stream._readableState;
        const state = wState || rState;
        return !!(stream.destroyed || stream[kIsDestroyed] || state !== null && state !== void 0 && state.destroyed);
      }
      function isWritableEnded(stream) {
        if (!isWritableNodeStream(stream)) return null;
        if (stream.writableEnded === true) return true;
        const wState = stream._writableState;
        if (wState !== null && wState !== void 0 && wState.errored) return false;
        if (typeof (wState === null || wState === void 0 ? void 0 : wState.ended) !== "boolean") return null;
        return wState.ended;
      }
      function isWritableFinished(stream, strict) {
        if (!isWritableNodeStream(stream)) return null;
        if (stream.writableFinished === true) return true;
        const wState = stream._writableState;
        if (wState !== null && wState !== void 0 && wState.errored) return false;
        if (typeof (wState === null || wState === void 0 ? void 0 : wState.finished) !== "boolean") return null;
        return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
      }
      function isReadableEnded(stream) {
        if (!isReadableNodeStream(stream)) return null;
        if (stream.readableEnded === true) return true;
        const rState = stream._readableState;
        if (!rState || rState.errored) return false;
        if (typeof (rState === null || rState === void 0 ? void 0 : rState.ended) !== "boolean") return null;
        return rState.ended;
      }
      function isReadableFinished(stream, strict) {
        if (!isReadableNodeStream(stream)) return null;
        const rState = stream._readableState;
        if (rState !== null && rState !== void 0 && rState.errored) return false;
        if (typeof (rState === null || rState === void 0 ? void 0 : rState.endEmitted) !== "boolean") return null;
        return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
      }
      function isReadable(stream) {
        if (stream && stream[kIsReadable] != null) return stream[kIsReadable];
        if (typeof (stream === null || stream === void 0 ? void 0 : stream.readable) !== "boolean") return null;
        if (isDestroyed(stream)) return false;
        return isReadableNodeStream(stream) && stream.readable && !isReadableFinished(stream);
      }
      function isWritable(stream) {
        if (stream && stream[kIsWritable] != null) return stream[kIsWritable];
        if (typeof (stream === null || stream === void 0 ? void 0 : stream.writable) !== "boolean") return null;
        if (isDestroyed(stream)) return false;
        return isWritableNodeStream(stream) && stream.writable && !isWritableEnded(stream);
      }
      function isFinished(stream, opts) {
        if (!isNodeStream(stream)) {
          return null;
        }
        if (isDestroyed(stream)) {
          return true;
        }
        if ((opts === null || opts === void 0 ? void 0 : opts.readable) !== false && isReadable(stream)) {
          return false;
        }
        if ((opts === null || opts === void 0 ? void 0 : opts.writable) !== false && isWritable(stream)) {
          return false;
        }
        return true;
      }
      function isWritableErrored(stream) {
        var _stream$_writableStat, _stream$_writableStat2;
        if (!isNodeStream(stream)) {
          return null;
        }
        if (stream.writableErrored) {
          return stream.writableErrored;
        }
        return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === void 0 ? void 0 : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== void 0 ? _stream$_writableStat : null;
      }
      function isReadableErrored(stream) {
        var _stream$_readableStat, _stream$_readableStat2;
        if (!isNodeStream(stream)) {
          return null;
        }
        if (stream.readableErrored) {
          return stream.readableErrored;
        }
        return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === void 0 ? void 0 : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== void 0 ? _stream$_readableStat : null;
      }
      function isClosed(stream) {
        if (!isNodeStream(stream)) {
          return null;
        }
        if (typeof stream.closed === "boolean") {
          return stream.closed;
        }
        const wState = stream._writableState;
        const rState = stream._readableState;
        if (typeof (wState === null || wState === void 0 ? void 0 : wState.closed) === "boolean" || typeof (rState === null || rState === void 0 ? void 0 : rState.closed) === "boolean") {
          return (wState === null || wState === void 0 ? void 0 : wState.closed) || (rState === null || rState === void 0 ? void 0 : rState.closed);
        }
        if (typeof stream._closed === "boolean" && isOutgoingMessage(stream)) {
          return stream._closed;
        }
        return null;
      }
      function isOutgoingMessage(stream) {
        return typeof stream._closed === "boolean" && typeof stream._defaultKeepAlive === "boolean" && typeof stream._removedConnection === "boolean" && typeof stream._removedContLen === "boolean";
      }
      function isServerResponse(stream) {
        return typeof stream._sent100 === "boolean" && isOutgoingMessage(stream);
      }
      function isServerRequest(stream) {
        var _stream$req;
        return typeof stream._consuming === "boolean" && typeof stream._dumped === "boolean" && ((_stream$req = stream.req) === null || _stream$req === void 0 ? void 0 : _stream$req.upgradeOrConnect) === void 0;
      }
      function willEmitClose(stream) {
        if (!isNodeStream(stream)) return null;
        const wState = stream._writableState;
        const rState = stream._readableState;
        const state = wState || rState;
        return !state && isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
      }
      function isDisturbed(stream) {
        var _stream$kIsDisturbed;
        return !!(stream && ((_stream$kIsDisturbed = stream[kIsDisturbed]) !== null && _stream$kIsDisturbed !== void 0 ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
      }
      function isErrored(stream) {
        var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
        return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[kIsErrored]) !== null && _stream$kIsErrored !== void 0 ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== void 0 ? _ref5 : stream.writableErrored) !== null && _ref4 !== void 0 ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === void 0 ? void 0 : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== void 0 ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === void 0 ? void 0 : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== void 0 ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === void 0 ? void 0 : _stream$_readableStat4.errored) !== null && _ref !== void 0 ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === void 0 ? void 0 : _stream$_writableStat4.errored));
      }
      module2.exports = {
        isDestroyed,
        kIsDestroyed,
        isDisturbed,
        kIsDisturbed,
        isErrored,
        kIsErrored,
        isReadable,
        kIsReadable,
        kIsClosedPromise,
        kControllerErrorFunction,
        kIsWritable,
        isClosed,
        isDuplexNodeStream,
        isFinished,
        isIterable: isIterable2,
        isReadableNodeStream,
        isReadableStream,
        isReadableEnded,
        isReadableFinished,
        isReadableErrored,
        isNodeStream,
        isWebStream,
        isWritable,
        isWritableNodeStream,
        isWritableStream,
        isWritableEnded,
        isWritableFinished,
        isWritableErrored,
        isServerRequest,
        isServerResponse,
        willEmitClose,
        isTransformStream
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/end-of-stream.js
  var require_end_of_stream = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/end-of-stream.js"(exports2, module2) {
      "use strict";
      var process2 = require_browser2();
      var { AbortError, codes } = require_errors();
      var { ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE } = codes;
      var { kEmptyObject, once } = require_util();
      var { validateAbortSignal, validateFunction, validateObject: validateObject3, validateBoolean } = require_validators();
      var { Promise: Promise2, PromisePrototypeThen, SymbolDispose } = require_primordials();
      var {
        isClosed,
        isReadable,
        isReadableNodeStream,
        isReadableStream,
        isReadableFinished,
        isReadableErrored,
        isWritable,
        isWritableNodeStream,
        isWritableStream,
        isWritableFinished,
        isWritableErrored,
        isNodeStream,
        willEmitClose: _willEmitClose,
        kIsClosedPromise
      } = require_utils();
      var addAbortListener;
      function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === "function";
      }
      var nop2 = () => {
      };
      function eos(stream, options, callback) {
        var _options$readable, _options$writable;
        if (arguments.length === 2) {
          callback = options;
          options = kEmptyObject;
        } else if (options == null) {
          options = kEmptyObject;
        } else {
          validateObject3(options, "options");
        }
        validateFunction(callback, "callback");
        validateAbortSignal(options.signal, "options.signal");
        callback = once(callback);
        if (isReadableStream(stream) || isWritableStream(stream)) {
          return eosWeb(stream, options, callback);
        }
        if (!isNodeStream(stream)) {
          throw new ERR_INVALID_ARG_TYPE("stream", ["ReadableStream", "WritableStream", "Stream"], stream);
        }
        const readable = (_options$readable = options.readable) !== null && _options$readable !== void 0 ? _options$readable : isReadableNodeStream(stream);
        const writable = (_options$writable = options.writable) !== null && _options$writable !== void 0 ? _options$writable : isWritableNodeStream(stream);
        const wState = stream._writableState;
        const rState = stream._readableState;
        const onlegacyfinish = () => {
          if (!stream.writable) {
            onfinish();
          }
        };
        let willEmitClose = _willEmitClose(stream) && isReadableNodeStream(stream) === readable && isWritableNodeStream(stream) === writable;
        let writableFinished = isWritableFinished(stream, false);
        const onfinish = () => {
          writableFinished = true;
          if (stream.destroyed) {
            willEmitClose = false;
          }
          if (willEmitClose && (!stream.readable || readable)) {
            return;
          }
          if (!readable || readableFinished) {
            callback.call(stream);
          }
        };
        let readableFinished = isReadableFinished(stream, false);
        const onend = () => {
          readableFinished = true;
          if (stream.destroyed) {
            willEmitClose = false;
          }
          if (willEmitClose && (!stream.writable || writable)) {
            return;
          }
          if (!writable || writableFinished) {
            callback.call(stream);
          }
        };
        const onerror = (err3) => {
          callback.call(stream, err3);
        };
        let closed = isClosed(stream);
        const onclose = () => {
          closed = true;
          const errored = isWritableErrored(stream) || isReadableErrored(stream);
          if (errored && typeof errored !== "boolean") {
            return callback.call(stream, errored);
          }
          if (readable && !readableFinished && isReadableNodeStream(stream, true)) {
            if (!isReadableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE());
          }
          if (writable && !writableFinished) {
            if (!isWritableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE());
          }
          callback.call(stream);
        };
        const onclosed = () => {
          closed = true;
          const errored = isWritableErrored(stream) || isReadableErrored(stream);
          if (errored && typeof errored !== "boolean") {
            return callback.call(stream, errored);
          }
          callback.call(stream);
        };
        const onrequest = () => {
          stream.req.on("finish", onfinish);
        };
        if (isRequest(stream)) {
          stream.on("complete", onfinish);
          if (!willEmitClose) {
            stream.on("abort", onclose);
          }
          if (stream.req) {
            onrequest();
          } else {
            stream.on("request", onrequest);
          }
        } else if (writable && !wState) {
          stream.on("end", onlegacyfinish);
          stream.on("close", onlegacyfinish);
        }
        if (!willEmitClose && typeof stream.aborted === "boolean") {
          stream.on("aborted", onclose);
        }
        stream.on("end", onend);
        stream.on("finish", onfinish);
        if (options.error !== false) {
          stream.on("error", onerror);
        }
        stream.on("close", onclose);
        if (closed) {
          process2.nextTick(onclose);
        } else if (wState !== null && wState !== void 0 && wState.errorEmitted || rState !== null && rState !== void 0 && rState.errorEmitted) {
          if (!willEmitClose) {
            process2.nextTick(onclosed);
          }
        } else if (!readable && (!willEmitClose || isReadable(stream)) && (writableFinished || isWritable(stream) === false)) {
          process2.nextTick(onclosed);
        } else if (!writable && (!willEmitClose || isWritable(stream)) && (readableFinished || isReadable(stream) === false)) {
          process2.nextTick(onclosed);
        } else if (rState && stream.req && stream.aborted) {
          process2.nextTick(onclosed);
        }
        const cleanup = () => {
          callback = nop2;
          stream.removeListener("aborted", onclose);
          stream.removeListener("complete", onfinish);
          stream.removeListener("abort", onclose);
          stream.removeListener("request", onrequest);
          if (stream.req) stream.req.removeListener("finish", onfinish);
          stream.removeListener("end", onlegacyfinish);
          stream.removeListener("close", onlegacyfinish);
          stream.removeListener("finish", onfinish);
          stream.removeListener("end", onend);
          stream.removeListener("error", onerror);
          stream.removeListener("close", onclose);
        };
        if (options.signal && !closed) {
          const abort = () => {
            const endCallback = callback;
            cleanup();
            endCallback.call(
              stream,
              new AbortError(void 0, {
                cause: options.signal.reason
              })
            );
          };
          if (options.signal.aborted) {
            process2.nextTick(abort);
          } else {
            addAbortListener = addAbortListener || require_util().addAbortListener;
            const disposable = addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = once((...args) => {
              disposable[SymbolDispose]();
              originalCallback.apply(stream, args);
            });
          }
        }
        return cleanup;
      }
      function eosWeb(stream, options, callback) {
        let isAborted3 = false;
        let abort = nop2;
        if (options.signal) {
          abort = () => {
            isAborted3 = true;
            callback.call(
              stream,
              new AbortError(void 0, {
                cause: options.signal.reason
              })
            );
          };
          if (options.signal.aborted) {
            process2.nextTick(abort);
          } else {
            addAbortListener = addAbortListener || require_util().addAbortListener;
            const disposable = addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = once((...args) => {
              disposable[SymbolDispose]();
              originalCallback.apply(stream, args);
            });
          }
        }
        const resolverFn = (...args) => {
          if (!isAborted3) {
            process2.nextTick(() => callback.apply(stream, args));
          }
        };
        PromisePrototypeThen(stream[kIsClosedPromise].promise, resolverFn, resolverFn);
        return nop2;
      }
      function finished(stream, opts) {
        var _opts;
        let autoCleanup = false;
        if (opts === null) {
          opts = kEmptyObject;
        }
        if ((_opts = opts) !== null && _opts !== void 0 && _opts.cleanup) {
          validateBoolean(opts.cleanup, "cleanup");
          autoCleanup = opts.cleanup;
        }
        return new Promise2((resolve2, reject) => {
          const cleanup = eos(stream, opts, (err3) => {
            if (autoCleanup) {
              cleanup();
            }
            if (err3) {
              reject(err3);
            } else {
              resolve2();
            }
          });
        });
      }
      module2.exports = eos;
      module2.exports.finished = finished;
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/destroy.js
  var require_destroy = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/destroy.js"(exports2, module2) {
      "use strict";
      var process2 = require_browser2();
      var {
        aggregateTwoErrors,
        codes: { ERR_MULTIPLE_CALLBACK },
        AbortError
      } = require_errors();
      var { Symbol: Symbol2 } = require_primordials();
      var { kIsDestroyed, isDestroyed, isFinished, isServerRequest } = require_utils();
      var kDestroy = Symbol2("kDestroy");
      var kConstruct = Symbol2("kConstruct");
      function checkError(err3, w, r2) {
        if (err3) {
          err3.stack;
          if (w && !w.errored) {
            w.errored = err3;
          }
          if (r2 && !r2.errored) {
            r2.errored = err3;
          }
        }
      }
      function destroy(err3, cb) {
        const r2 = this._readableState;
        const w = this._writableState;
        const s2 = w || r2;
        if (w !== null && w !== void 0 && w.destroyed || r2 !== null && r2 !== void 0 && r2.destroyed) {
          if (typeof cb === "function") {
            cb();
          }
          return this;
        }
        checkError(err3, w, r2);
        if (w) {
          w.destroyed = true;
        }
        if (r2) {
          r2.destroyed = true;
        }
        if (!s2.constructed) {
          this.once(kDestroy, function(er) {
            _destroy(this, aggregateTwoErrors(er, err3), cb);
          });
        } else {
          _destroy(this, err3, cb);
        }
        return this;
      }
      function _destroy(self2, err3, cb) {
        let called = false;
        function onDestroy(err4) {
          if (called) {
            return;
          }
          called = true;
          const r2 = self2._readableState;
          const w = self2._writableState;
          checkError(err4, w, r2);
          if (w) {
            w.closed = true;
          }
          if (r2) {
            r2.closed = true;
          }
          if (typeof cb === "function") {
            cb(err4);
          }
          if (err4) {
            process2.nextTick(emitErrorCloseNT, self2, err4);
          } else {
            process2.nextTick(emitCloseNT, self2);
          }
        }
        try {
          self2._destroy(err3 || null, onDestroy);
        } catch (err4) {
          onDestroy(err4);
        }
      }
      function emitErrorCloseNT(self2, err3) {
        emitErrorNT(self2, err3);
        emitCloseNT(self2);
      }
      function emitCloseNT(self2) {
        const r2 = self2._readableState;
        const w = self2._writableState;
        if (w) {
          w.closeEmitted = true;
        }
        if (r2) {
          r2.closeEmitted = true;
        }
        if (w !== null && w !== void 0 && w.emitClose || r2 !== null && r2 !== void 0 && r2.emitClose) {
          self2.emit("close");
        }
      }
      function emitErrorNT(self2, err3) {
        const r2 = self2._readableState;
        const w = self2._writableState;
        if (w !== null && w !== void 0 && w.errorEmitted || r2 !== null && r2 !== void 0 && r2.errorEmitted) {
          return;
        }
        if (w) {
          w.errorEmitted = true;
        }
        if (r2) {
          r2.errorEmitted = true;
        }
        self2.emit("error", err3);
      }
      function undestroy() {
        const r2 = this._readableState;
        const w = this._writableState;
        if (r2) {
          r2.constructed = true;
          r2.closed = false;
          r2.closeEmitted = false;
          r2.destroyed = false;
          r2.errored = null;
          r2.errorEmitted = false;
          r2.reading = false;
          r2.ended = r2.readable === false;
          r2.endEmitted = r2.readable === false;
        }
        if (w) {
          w.constructed = true;
          w.destroyed = false;
          w.closed = false;
          w.closeEmitted = false;
          w.errored = null;
          w.errorEmitted = false;
          w.finalCalled = false;
          w.prefinished = false;
          w.ended = w.writable === false;
          w.ending = w.writable === false;
          w.finished = w.writable === false;
        }
      }
      function errorOrDestroy(stream, err3, sync) {
        const r2 = stream._readableState;
        const w = stream._writableState;
        if (w !== null && w !== void 0 && w.destroyed || r2 !== null && r2 !== void 0 && r2.destroyed) {
          return this;
        }
        if (r2 !== null && r2 !== void 0 && r2.autoDestroy || w !== null && w !== void 0 && w.autoDestroy)
          stream.destroy(err3);
        else if (err3) {
          err3.stack;
          if (w && !w.errored) {
            w.errored = err3;
          }
          if (r2 && !r2.errored) {
            r2.errored = err3;
          }
          if (sync) {
            process2.nextTick(emitErrorNT, stream, err3);
          } else {
            emitErrorNT(stream, err3);
          }
        }
      }
      function construct(stream, cb) {
        if (typeof stream._construct !== "function") {
          return;
        }
        const r2 = stream._readableState;
        const w = stream._writableState;
        if (r2) {
          r2.constructed = false;
        }
        if (w) {
          w.constructed = false;
        }
        stream.once(kConstruct, cb);
        if (stream.listenerCount(kConstruct) > 1) {
          return;
        }
        process2.nextTick(constructNT, stream);
      }
      function constructNT(stream) {
        let called = false;
        function onConstruct(err3) {
          if (called) {
            errorOrDestroy(stream, err3 !== null && err3 !== void 0 ? err3 : new ERR_MULTIPLE_CALLBACK());
            return;
          }
          called = true;
          const r2 = stream._readableState;
          const w = stream._writableState;
          const s2 = w || r2;
          if (r2) {
            r2.constructed = true;
          }
          if (w) {
            w.constructed = true;
          }
          if (s2.destroyed) {
            stream.emit(kDestroy, err3);
          } else if (err3) {
            errorOrDestroy(stream, err3, true);
          } else {
            process2.nextTick(emitConstructNT, stream);
          }
        }
        try {
          stream._construct((err3) => {
            process2.nextTick(onConstruct, err3);
          });
        } catch (err3) {
          process2.nextTick(onConstruct, err3);
        }
      }
      function emitConstructNT(stream) {
        stream.emit(kConstruct);
      }
      function isRequest(stream) {
        return (stream === null || stream === void 0 ? void 0 : stream.setHeader) && typeof stream.abort === "function";
      }
      function emitCloseLegacy(stream) {
        stream.emit("close");
      }
      function emitErrorCloseLegacy(stream, err3) {
        stream.emit("error", err3);
        process2.nextTick(emitCloseLegacy, stream);
      }
      function destroyer(stream, err3) {
        if (!stream || isDestroyed(stream)) {
          return;
        }
        if (!err3 && !isFinished(stream)) {
          err3 = new AbortError();
        }
        if (isServerRequest(stream)) {
          stream.socket = null;
          stream.destroy(err3);
        } else if (isRequest(stream)) {
          stream.abort();
        } else if (isRequest(stream.req)) {
          stream.req.abort();
        } else if (typeof stream.destroy === "function") {
          stream.destroy(err3);
        } else if (typeof stream.close === "function") {
          stream.close();
        } else if (err3) {
          process2.nextTick(emitErrorCloseLegacy, stream, err3);
        } else {
          process2.nextTick(emitCloseLegacy, stream);
        }
        if (!stream.destroyed) {
          stream[kIsDestroyed] = true;
        }
      }
      module2.exports = {
        construct,
        destroyer,
        destroy,
        undestroy,
        errorOrDestroy
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/legacy.js
  var require_legacy = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/legacy.js"(exports2, module2) {
      "use strict";
      var { ArrayIsArray, ObjectSetPrototypeOf } = require_primordials();
      var { EventEmitter: EE } = require_events();
      function Stream(opts) {
        EE.call(this, opts);
      }
      ObjectSetPrototypeOf(Stream.prototype, EE.prototype);
      ObjectSetPrototypeOf(Stream, EE);
      Stream.prototype.pipe = function(dest, options) {
        const source = this;
        function ondata(chunk) {
          if (dest.writable && dest.write(chunk) === false && source.pause) {
            source.pause();
          }
        }
        source.on("data", ondata);
        function ondrain() {
          if (source.readable && source.resume) {
            source.resume();
          }
        }
        dest.on("drain", ondrain);
        if (!dest._isStdio && (!options || options.end !== false)) {
          source.on("end", onend);
          source.on("close", onclose);
        }
        let didOnEnd = false;
        function onend() {
          if (didOnEnd) return;
          didOnEnd = true;
          dest.end();
        }
        function onclose() {
          if (didOnEnd) return;
          didOnEnd = true;
          if (typeof dest.destroy === "function") dest.destroy();
        }
        function onerror(er) {
          cleanup();
          if (EE.listenerCount(this, "error") === 0) {
            this.emit("error", er);
          }
        }
        prependListener(source, "error", onerror);
        prependListener(dest, "error", onerror);
        function cleanup() {
          source.removeListener("data", ondata);
          dest.removeListener("drain", ondrain);
          source.removeListener("end", onend);
          source.removeListener("close", onclose);
          source.removeListener("error", onerror);
          dest.removeListener("error", onerror);
          source.removeListener("end", cleanup);
          source.removeListener("close", cleanup);
          dest.removeListener("close", cleanup);
        }
        source.on("end", cleanup);
        source.on("close", cleanup);
        dest.on("close", cleanup);
        dest.emit("pipe", source);
        return dest;
      };
      function prependListener(emitter, event, fn) {
        if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [fn, emitter._events[event]];
      }
      module2.exports = {
        Stream,
        prependListener
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/add-abort-signal.js
  var require_add_abort_signal = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/add-abort-signal.js"(exports2, module2) {
      "use strict";
      var { SymbolDispose } = require_primordials();
      var { AbortError, codes } = require_errors();
      var { isNodeStream, isWebStream, kControllerErrorFunction } = require_utils();
      var eos = require_end_of_stream();
      var { ERR_INVALID_ARG_TYPE } = codes;
      var addAbortListener;
      var validateAbortSignal = (signal, name2) => {
        if (typeof signal !== "object" || !("aborted" in signal)) {
          throw new ERR_INVALID_ARG_TYPE(name2, "AbortSignal", signal);
        }
      };
      module2.exports.addAbortSignal = function addAbortSignal(signal, stream) {
        validateAbortSignal(signal, "signal");
        if (!isNodeStream(stream) && !isWebStream(stream)) {
          throw new ERR_INVALID_ARG_TYPE("stream", ["ReadableStream", "WritableStream", "Stream"], stream);
        }
        return module2.exports.addAbortSignalNoValidate(signal, stream);
      };
      module2.exports.addAbortSignalNoValidate = function(signal, stream) {
        if (typeof signal !== "object" || !("aborted" in signal)) {
          return stream;
        }
        const onAbort = isNodeStream(stream) ? () => {
          stream.destroy(
            new AbortError(void 0, {
              cause: signal.reason
            })
          );
        } : () => {
          stream[kControllerErrorFunction](
            new AbortError(void 0, {
              cause: signal.reason
            })
          );
        };
        if (signal.aborted) {
          onAbort();
        } else {
          addAbortListener = addAbortListener || require_util().addAbortListener;
          const disposable = addAbortListener(signal, onAbort);
          eos(stream, disposable[SymbolDispose]);
        }
        return stream;
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/buffer_list.js
  var require_buffer_list = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/buffer_list.js"(exports2, module2) {
      "use strict";
      var { StringPrototypeSlice, SymbolIterator, TypedArrayPrototypeSet, Uint8Array: Uint8Array2 } = require_primordials();
      var { Buffer: Buffer7 } = require_buffer();
      var { inspect } = require_util();
      module2.exports = class BufferList {
        constructor() {
          this.head = null;
          this.tail = null;
          this.length = 0;
        }
        push(v) {
          const entry = {
            data: v,
            next: null
          };
          if (this.length > 0) this.tail.next = entry;
          else this.head = entry;
          this.tail = entry;
          ++this.length;
        }
        unshift(v) {
          const entry = {
            data: v,
            next: this.head
          };
          if (this.length === 0) this.tail = entry;
          this.head = entry;
          ++this.length;
        }
        shift() {
          if (this.length === 0) return;
          const ret = this.head.data;
          if (this.length === 1) this.head = this.tail = null;
          else this.head = this.head.next;
          --this.length;
          return ret;
        }
        clear() {
          this.head = this.tail = null;
          this.length = 0;
        }
        join(s2) {
          if (this.length === 0) return "";
          let p12 = this.head;
          let ret = "" + p12.data;
          while ((p12 = p12.next) !== null) ret += s2 + p12.data;
          return ret;
        }
        concat(n2) {
          if (this.length === 0) return Buffer7.alloc(0);
          const ret = Buffer7.allocUnsafe(n2 >>> 0);
          let p12 = this.head;
          let i2 = 0;
          while (p12) {
            TypedArrayPrototypeSet(ret, p12.data, i2);
            i2 += p12.data.length;
            p12 = p12.next;
          }
          return ret;
        }
        // Consumes a specified amount of bytes or characters from the buffered data.
        consume(n2, hasStrings) {
          const data = this.head.data;
          if (n2 < data.length) {
            const slice = data.slice(0, n2);
            this.head.data = data.slice(n2);
            return slice;
          }
          if (n2 === data.length) {
            return this.shift();
          }
          return hasStrings ? this._getString(n2) : this._getBuffer(n2);
        }
        first() {
          return this.head.data;
        }
        *[SymbolIterator]() {
          for (let p12 = this.head; p12; p12 = p12.next) {
            yield p12.data;
          }
        }
        // Consumes a specified amount of characters from the buffered data.
        _getString(n2) {
          let ret = "";
          let p12 = this.head;
          let c = 0;
          do {
            const str = p12.data;
            if (n2 > str.length) {
              ret += str;
              n2 -= str.length;
            } else {
              if (n2 === str.length) {
                ret += str;
                ++c;
                if (p12.next) this.head = p12.next;
                else this.head = this.tail = null;
              } else {
                ret += StringPrototypeSlice(str, 0, n2);
                this.head = p12;
                p12.data = StringPrototypeSlice(str, n2);
              }
              break;
            }
            ++c;
          } while ((p12 = p12.next) !== null);
          this.length -= c;
          return ret;
        }
        // Consumes a specified amount of bytes from the buffered data.
        _getBuffer(n2) {
          const ret = Buffer7.allocUnsafe(n2);
          const retLen = n2;
          let p12 = this.head;
          let c = 0;
          do {
            const buf = p12.data;
            if (n2 > buf.length) {
              TypedArrayPrototypeSet(ret, buf, retLen - n2);
              n2 -= buf.length;
            } else {
              if (n2 === buf.length) {
                TypedArrayPrototypeSet(ret, buf, retLen - n2);
                ++c;
                if (p12.next) this.head = p12.next;
                else this.head = this.tail = null;
              } else {
                TypedArrayPrototypeSet(ret, new Uint8Array2(buf.buffer, buf.byteOffset, n2), retLen - n2);
                this.head = p12;
                p12.data = buf.slice(n2);
              }
              break;
            }
            ++c;
          } while ((p12 = p12.next) !== null);
          this.length -= c;
          return ret;
        }
        // Make sure the linked list only shows the minimal necessary information.
        [Symbol.for("nodejs.util.inspect.custom")](_2, options) {
          return inspect(this, {
            ...options,
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
          });
        }
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/state.js
  var require_state = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/state.js"(exports2, module2) {
      "use strict";
      var { MathFloor, NumberIsInteger } = require_primordials();
      var { validateInteger } = require_validators();
      var { ERR_INVALID_ARG_VALUE } = require_errors().codes;
      var defaultHighWaterMarkBytes = 16 * 1024;
      var defaultHighWaterMarkObjectMode = 16;
      function highWaterMarkFrom(options, isDuplex, duplexKey) {
        return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
      }
      function getDefaultHighWaterMark(objectMode) {
        return objectMode ? defaultHighWaterMarkObjectMode : defaultHighWaterMarkBytes;
      }
      function setDefaultHighWaterMark(objectMode, value) {
        validateInteger(value, "value", 0);
        if (objectMode) {
          defaultHighWaterMarkObjectMode = value;
        } else {
          defaultHighWaterMarkBytes = value;
        }
      }
      function getHighWaterMark(state, options, duplexKey, isDuplex) {
        const hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
        if (hwm != null) {
          if (!NumberIsInteger(hwm) || hwm < 0) {
            const name2 = isDuplex ? `options.${duplexKey}` : "options.highWaterMark";
            throw new ERR_INVALID_ARG_VALUE(name2, hwm);
          }
          return MathFloor(hwm);
        }
        return getDefaultHighWaterMark(state.objectMode);
      }
      module2.exports = {
        getHighWaterMark,
        getDefaultHighWaterMark,
        setDefaultHighWaterMark
      };
    }
  });

  // ../../node_modules/.pnpm/safe-buffer@5.2.1/node_modules/safe-buffer/index.js
  var require_safe_buffer = __commonJS({
    "../../node_modules/.pnpm/safe-buffer@5.2.1/node_modules/safe-buffer/index.js"(exports2, module2) {
      var buffer = require_buffer();
      var Buffer7 = buffer.Buffer;
      function copyProps(src, dst) {
        for (var key in src) {
          dst[key] = src[key];
        }
      }
      if (Buffer7.from && Buffer7.alloc && Buffer7.allocUnsafe && Buffer7.allocUnsafeSlow) {
        module2.exports = buffer;
      } else {
        copyProps(buffer, exports2);
        exports2.Buffer = SafeBuffer;
      }
      function SafeBuffer(arg, encodingOrOffset, length2) {
        return Buffer7(arg, encodingOrOffset, length2);
      }
      SafeBuffer.prototype = Object.create(Buffer7.prototype);
      copyProps(Buffer7, SafeBuffer);
      SafeBuffer.from = function(arg, encodingOrOffset, length2) {
        if (typeof arg === "number") {
          throw new TypeError("Argument must not be a number");
        }
        return Buffer7(arg, encodingOrOffset, length2);
      };
      SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== "number") {
          throw new TypeError("Argument must be a number");
        }
        var buf = Buffer7(size);
        if (fill !== void 0) {
          if (typeof encoding === "string") {
            buf.fill(fill, encoding);
          } else {
            buf.fill(fill);
          }
        } else {
          buf.fill(0);
        }
        return buf;
      };
      SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== "number") {
          throw new TypeError("Argument must be a number");
        }
        return Buffer7(size);
      };
      SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== "number") {
          throw new TypeError("Argument must be a number");
        }
        return buffer.SlowBuffer(size);
      };
    }
  });

  // ../../node_modules/.pnpm/string_decoder@1.3.0/node_modules/string_decoder/lib/string_decoder.js
  var require_string_decoder = __commonJS({
    "../../node_modules/.pnpm/string_decoder@1.3.0/node_modules/string_decoder/lib/string_decoder.js"(exports2) {
      "use strict";
      var Buffer7 = require_safe_buffer().Buffer;
      var isEncoding = Buffer7.isEncoding || function(encoding) {
        encoding = "" + encoding;
        switch (encoding && encoding.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return true;
          default:
            return false;
        }
      };
      function _normalizeEncoding(enc) {
        if (!enc) return "utf8";
        var retried;
        while (true) {
          switch (enc) {
            case "utf8":
            case "utf-8":
              return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";
            case "latin1":
            case "binary":
              return "latin1";
            case "base64":
            case "ascii":
            case "hex":
              return enc;
            default:
              if (retried) return;
              enc = ("" + enc).toLowerCase();
              retried = true;
          }
        }
      }
      function normalizeEncoding(enc) {
        var nenc = _normalizeEncoding(enc);
        if (typeof nenc !== "string" && (Buffer7.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
        return nenc || enc;
      }
      exports2.StringDecoder = StringDecoder;
      function StringDecoder(encoding) {
        this.encoding = normalizeEncoding(encoding);
        var nb;
        switch (this.encoding) {
          case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
          case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
          case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
          default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = Buffer7.allocUnsafe(nb);
      }
      StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return "";
        var r2;
        var i2;
        if (this.lastNeed) {
          r2 = this.fillLast(buf);
          if (r2 === void 0) return "";
          i2 = this.lastNeed;
          this.lastNeed = 0;
        } else {
          i2 = 0;
        }
        if (i2 < buf.length) return r2 ? r2 + this.text(buf, i2) : this.text(buf, i2);
        return r2 || "";
      };
      StringDecoder.prototype.end = utf8End;
      StringDecoder.prototype.text = utf8Text;
      StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
          buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
          return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
      };
      function utf8CheckByte(byte) {
        if (byte <= 127) return 0;
        else if (byte >> 5 === 6) return 2;
        else if (byte >> 4 === 14) return 3;
        else if (byte >> 3 === 30) return 4;
        return byte >> 6 === 2 ? -1 : -2;
      }
      function utf8CheckIncomplete(self2, buf, i2) {
        var j = buf.length - 1;
        if (j < i2) return 0;
        var nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
          if (nb > 0) self2.lastNeed = nb - 1;
          return nb;
        }
        if (--j < i2 || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
          if (nb > 0) self2.lastNeed = nb - 2;
          return nb;
        }
        if (--j < i2 || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
          if (nb > 0) {
            if (nb === 2) nb = 0;
            else self2.lastNeed = nb - 3;
          }
          return nb;
        }
        return 0;
      }
      function utf8CheckExtraBytes(self2, buf, p12) {
        if ((buf[0] & 192) !== 128) {
          self2.lastNeed = 0;
          return "\uFFFD";
        }
        if (self2.lastNeed > 1 && buf.length > 1) {
          if ((buf[1] & 192) !== 128) {
            self2.lastNeed = 1;
            return "\uFFFD";
          }
          if (self2.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 192) !== 128) {
              self2.lastNeed = 2;
              return "\uFFFD";
            }
          }
        }
      }
      function utf8FillLast(buf) {
        var p12 = this.lastTotal - this.lastNeed;
        var r2 = utf8CheckExtraBytes(this, buf, p12);
        if (r2 !== void 0) return r2;
        if (this.lastNeed <= buf.length) {
          buf.copy(this.lastChar, p12, 0, this.lastNeed);
          return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p12, 0, buf.length);
        this.lastNeed -= buf.length;
      }
      function utf8Text(buf, i2) {
        var total = utf8CheckIncomplete(this, buf, i2);
        if (!this.lastNeed) return buf.toString("utf8", i2);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString("utf8", i2, end);
      }
      function utf8End(buf) {
        var r2 = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) return r2 + "\uFFFD";
        return r2;
      }
      function utf16Text(buf, i2) {
        if ((buf.length - i2) % 2 === 0) {
          var r2 = buf.toString("utf16le", i2);
          if (r2) {
            var c = r2.charCodeAt(r2.length - 1);
            if (c >= 55296 && c <= 56319) {
              this.lastNeed = 2;
              this.lastTotal = 4;
              this.lastChar[0] = buf[buf.length - 2];
              this.lastChar[1] = buf[buf.length - 1];
              return r2.slice(0, -1);
            }
          }
          return r2;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString("utf16le", i2, buf.length - 1);
      }
      function utf16End(buf) {
        var r2 = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) {
          var end = this.lastTotal - this.lastNeed;
          return r2 + this.lastChar.toString("utf16le", 0, end);
        }
        return r2;
      }
      function base64Text(buf, i2) {
        var n2 = (buf.length - i2) % 3;
        if (n2 === 0) return buf.toString("base64", i2);
        this.lastNeed = 3 - n2;
        this.lastTotal = 3;
        if (n2 === 1) {
          this.lastChar[0] = buf[buf.length - 1];
        } else {
          this.lastChar[0] = buf[buf.length - 2];
          this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString("base64", i2, buf.length - n2);
      }
      function base64End(buf) {
        var r2 = buf && buf.length ? this.write(buf) : "";
        if (this.lastNeed) return r2 + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
        return r2;
      }
      function simpleWrite(buf) {
        return buf.toString(this.encoding);
      }
      function simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : "";
      }
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/from.js
  var require_from = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/from.js"(exports2, module2) {
      "use strict";
      var process2 = require_browser2();
      var { PromisePrototypeThen, SymbolAsyncIterator, SymbolIterator } = require_primordials();
      var { Buffer: Buffer7 } = require_buffer();
      var { ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES } = require_errors().codes;
      function from(Readable2, iterable, opts) {
        let iterator;
        if (typeof iterable === "string" || iterable instanceof Buffer7) {
          return new Readable2({
            objectMode: true,
            ...opts,
            read() {
              this.push(iterable);
              this.push(null);
            }
          });
        }
        let isAsync3;
        if (iterable && iterable[SymbolAsyncIterator]) {
          isAsync3 = true;
          iterator = iterable[SymbolAsyncIterator]();
        } else if (iterable && iterable[SymbolIterator]) {
          isAsync3 = false;
          iterator = iterable[SymbolIterator]();
        } else {
          throw new ERR_INVALID_ARG_TYPE("iterable", ["Iterable"], iterable);
        }
        const readable = new Readable2({
          objectMode: true,
          highWaterMark: 1,
          // TODO(ronag): What options should be allowed?
          ...opts
        });
        let reading = false;
        readable._read = function() {
          if (!reading) {
            reading = true;
            next();
          }
        };
        readable._destroy = function(error, cb) {
          PromisePrototypeThen(
            close2(error),
            () => process2.nextTick(cb, error),
            // nextTick is here in case cb throws
            (e2) => process2.nextTick(cb, e2 || error)
          );
        };
        async function close2(error) {
          const hadError = error !== void 0 && error !== null;
          const hasThrow = typeof iterator.throw === "function";
          if (hadError && hasThrow) {
            const { value, done } = await iterator.throw(error);
            await value;
            if (done) {
              return;
            }
          }
          if (typeof iterator.return === "function") {
            const { value } = await iterator.return();
            await value;
          }
        }
        async function next() {
          for (; ; ) {
            try {
              const { value, done } = isAsync3 ? await iterator.next() : iterator.next();
              if (done) {
                readable.push(null);
              } else {
                const res = value && typeof value.then === "function" ? await value : value;
                if (res === null) {
                  reading = false;
                  throw new ERR_STREAM_NULL_VALUES();
                } else if (readable.push(res)) {
                  continue;
                } else {
                  reading = false;
                }
              }
            } catch (err3) {
              readable.destroy(err3);
            }
            break;
          }
        }
        return readable;
      }
      module2.exports = from;
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/readable.js
  var require_readable = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/readable.js"(exports2, module2) {
      "use strict";
      var process2 = require_browser2();
      var {
        ArrayPrototypeIndexOf,
        NumberIsInteger,
        NumberIsNaN,
        NumberParseInt,
        ObjectDefineProperties,
        ObjectKeys,
        ObjectSetPrototypeOf,
        Promise: Promise2,
        SafeSet,
        SymbolAsyncDispose,
        SymbolAsyncIterator,
        Symbol: Symbol2
      } = require_primordials();
      module2.exports = Readable2;
      Readable2.ReadableState = ReadableState;
      var { EventEmitter: EE } = require_events();
      var { Stream, prependListener } = require_legacy();
      var { Buffer: Buffer7 } = require_buffer();
      var { addAbortSignal } = require_add_abort_signal();
      var eos = require_end_of_stream();
      var debug2 = require_util().debuglog("stream", (fn) => {
        debug2 = fn;
      });
      var BufferList = require_buffer_list();
      var destroyImpl = require_destroy();
      var { getHighWaterMark, getDefaultHighWaterMark } = require_state();
      var {
        aggregateTwoErrors,
        codes: {
          ERR_INVALID_ARG_TYPE,
          ERR_METHOD_NOT_IMPLEMENTED: ERR_METHOD_NOT_IMPLEMENTED2,
          ERR_OUT_OF_RANGE,
          ERR_STREAM_PUSH_AFTER_EOF,
          ERR_STREAM_UNSHIFT_AFTER_END_EVENT
        },
        AbortError
      } = require_errors();
      var { validateObject: validateObject3 } = require_validators();
      var kPaused = Symbol2("kPaused");
      var { StringDecoder } = require_string_decoder();
      var from = require_from();
      ObjectSetPrototypeOf(Readable2.prototype, Stream.prototype);
      ObjectSetPrototypeOf(Readable2, Stream);
      var nop2 = () => {
      };
      var { errorOrDestroy } = destroyImpl;
      var kObjectMode = 1 << 0;
      var kEnded = 1 << 1;
      var kEndEmitted = 1 << 2;
      var kReading = 1 << 3;
      var kConstructed = 1 << 4;
      var kSync = 1 << 5;
      var kNeedReadable = 1 << 6;
      var kEmittedReadable = 1 << 7;
      var kReadableListening = 1 << 8;
      var kResumeScheduled = 1 << 9;
      var kErrorEmitted = 1 << 10;
      var kEmitClose = 1 << 11;
      var kAutoDestroy = 1 << 12;
      var kDestroyed = 1 << 13;
      var kClosed = 1 << 14;
      var kCloseEmitted = 1 << 15;
      var kMultiAwaitDrain = 1 << 16;
      var kReadingMore = 1 << 17;
      var kDataEmitted = 1 << 18;
      function makeBitMapDescriptor(bit) {
        return {
          enumerable: false,
          get() {
            return (this.state & bit) !== 0;
          },
          set(value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
          }
        };
      }
      ObjectDefineProperties(ReadableState.prototype, {
        objectMode: makeBitMapDescriptor(kObjectMode),
        ended: makeBitMapDescriptor(kEnded),
        endEmitted: makeBitMapDescriptor(kEndEmitted),
        reading: makeBitMapDescriptor(kReading),
        // Stream is still being constructed and cannot be
        // destroyed until construction finished or failed.
        // Async construction is opt in, therefore we start as
        // constructed.
        constructed: makeBitMapDescriptor(kConstructed),
        // A flag to be able to tell if the event 'readable'/'data' is emitted
        // immediately, or on a later tick.  We set this to true at first, because
        // any actions that shouldn't happen until "later" should generally also
        // not happen before the first read call.
        sync: makeBitMapDescriptor(kSync),
        // Whenever we return null, then we set a flag to say
        // that we're awaiting a 'readable' event emission.
        needReadable: makeBitMapDescriptor(kNeedReadable),
        emittedReadable: makeBitMapDescriptor(kEmittedReadable),
        readableListening: makeBitMapDescriptor(kReadableListening),
        resumeScheduled: makeBitMapDescriptor(kResumeScheduled),
        // True if the error was already emitted and should not be thrown again.
        errorEmitted: makeBitMapDescriptor(kErrorEmitted),
        emitClose: makeBitMapDescriptor(kEmitClose),
        autoDestroy: makeBitMapDescriptor(kAutoDestroy),
        // Has it been destroyed.
        destroyed: makeBitMapDescriptor(kDestroyed),
        // Indicates whether the stream has finished destroying.
        closed: makeBitMapDescriptor(kClosed),
        // True if close has been emitted or would have been emitted
        // depending on emitClose.
        closeEmitted: makeBitMapDescriptor(kCloseEmitted),
        multiAwaitDrain: makeBitMapDescriptor(kMultiAwaitDrain),
        // If true, a maybeReadMore has been scheduled.
        readingMore: makeBitMapDescriptor(kReadingMore),
        dataEmitted: makeBitMapDescriptor(kDataEmitted)
      });
      function ReadableState(options, stream, isDuplex) {
        if (typeof isDuplex !== "boolean") isDuplex = stream instanceof require_duplex();
        this.state = kEmitClose | kAutoDestroy | kConstructed | kSync;
        if (options && options.objectMode) this.state |= kObjectMode;
        if (isDuplex && options && options.readableObjectMode) this.state |= kObjectMode;
        this.highWaterMark = options ? getHighWaterMark(this, options, "readableHighWaterMark", isDuplex) : getDefaultHighWaterMark(false);
        this.buffer = new BufferList();
        this.length = 0;
        this.pipes = [];
        this.flowing = null;
        this[kPaused] = null;
        if (options && options.emitClose === false) this.state &= ~kEmitClose;
        if (options && options.autoDestroy === false) this.state &= ~kAutoDestroy;
        this.errored = null;
        this.defaultEncoding = options && options.defaultEncoding || "utf8";
        this.awaitDrainWriters = null;
        this.decoder = null;
        this.encoding = null;
        if (options && options.encoding) {
          this.decoder = new StringDecoder(options.encoding);
          this.encoding = options.encoding;
        }
      }
      function Readable2(options) {
        if (!(this instanceof Readable2)) return new Readable2(options);
        const isDuplex = this instanceof require_duplex();
        this._readableState = new ReadableState(options, this, isDuplex);
        if (options) {
          if (typeof options.read === "function") this._read = options.read;
          if (typeof options.destroy === "function") this._destroy = options.destroy;
          if (typeof options.construct === "function") this._construct = options.construct;
          if (options.signal && !isDuplex) addAbortSignal(options.signal, this);
        }
        Stream.call(this, options);
        destroyImpl.construct(this, () => {
          if (this._readableState.needReadable) {
            maybeReadMore(this, this._readableState);
          }
        });
      }
      Readable2.prototype.destroy = destroyImpl.destroy;
      Readable2.prototype._undestroy = destroyImpl.undestroy;
      Readable2.prototype._destroy = function(err3, cb) {
        cb(err3);
      };
      Readable2.prototype[EE.captureRejectionSymbol] = function(err3) {
        this.destroy(err3);
      };
      Readable2.prototype[SymbolAsyncDispose] = function() {
        let error;
        if (!this.destroyed) {
          error = this.readableEnded ? null : new AbortError();
          this.destroy(error);
        }
        return new Promise2((resolve2, reject) => eos(this, (err3) => err3 && err3 !== error ? reject(err3) : resolve2(null)));
      };
      Readable2.prototype.push = function(chunk, encoding) {
        return readableAddChunk(this, chunk, encoding, false);
      };
      Readable2.prototype.unshift = function(chunk, encoding) {
        return readableAddChunk(this, chunk, encoding, true);
      };
      function readableAddChunk(stream, chunk, encoding, addToFront) {
        debug2("readableAddChunk", chunk);
        const state = stream._readableState;
        let err3;
        if ((state.state & kObjectMode) === 0) {
          if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
              if (addToFront && state.encoding) {
                chunk = Buffer7.from(chunk, encoding).toString(state.encoding);
              } else {
                chunk = Buffer7.from(chunk, encoding);
                encoding = "";
              }
            }
          } else if (chunk instanceof Buffer7) {
            encoding = "";
          } else if (Stream._isUint8Array(chunk)) {
            chunk = Stream._uint8ArrayToBuffer(chunk);
            encoding = "";
          } else if (chunk != null) {
            err3 = new ERR_INVALID_ARG_TYPE("chunk", ["string", "Buffer", "Uint8Array"], chunk);
          }
        }
        if (err3) {
          errorOrDestroy(stream, err3);
        } else if (chunk === null) {
          state.state &= ~kReading;
          onEofChunk(stream, state);
        } else if ((state.state & kObjectMode) !== 0 || chunk && chunk.length > 0) {
          if (addToFront) {
            if ((state.state & kEndEmitted) !== 0) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else addChunk(stream, state, chunk, true);
          } else if (state.ended) {
            errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
          } else if (state.destroyed || state.errored) {
            return false;
          } else {
            state.state &= ~kReading;
            if (state.decoder && !encoding) {
              chunk = state.decoder.write(chunk);
              if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
              else maybeReadMore(stream, state);
            } else {
              addChunk(stream, state, chunk, false);
            }
          }
        } else if (!addToFront) {
          state.state &= ~kReading;
          maybeReadMore(stream, state);
        }
        return !state.ended && (state.length < state.highWaterMark || state.length === 0);
      }
      function addChunk(stream, state, chunk, addToFront) {
        if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount("data") > 0) {
          if ((state.state & kMultiAwaitDrain) !== 0) {
            state.awaitDrainWriters.clear();
          } else {
            state.awaitDrainWriters = null;
          }
          state.dataEmitted = true;
          stream.emit("data", chunk);
        } else {
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);
          else state.buffer.push(chunk);
          if ((state.state & kNeedReadable) !== 0) emitReadable(stream);
        }
        maybeReadMore(stream, state);
      }
      Readable2.prototype.isPaused = function() {
        const state = this._readableState;
        return state[kPaused] === true || state.flowing === false;
      };
      Readable2.prototype.setEncoding = function(enc) {
        const decoder2 = new StringDecoder(enc);
        this._readableState.decoder = decoder2;
        this._readableState.encoding = this._readableState.decoder.encoding;
        const buffer = this._readableState.buffer;
        let content = "";
        for (const data of buffer) {
          content += decoder2.write(data);
        }
        buffer.clear();
        if (content !== "") buffer.push(content);
        this._readableState.length = content.length;
        return this;
      };
      var MAX_HWM = 1073741824;
      function computeNewHighWaterMark(n2) {
        if (n2 > MAX_HWM) {
          throw new ERR_OUT_OF_RANGE("size", "<= 1GiB", n2);
        } else {
          n2--;
          n2 |= n2 >>> 1;
          n2 |= n2 >>> 2;
          n2 |= n2 >>> 4;
          n2 |= n2 >>> 8;
          n2 |= n2 >>> 16;
          n2++;
        }
        return n2;
      }
      function howMuchToRead(n2, state) {
        if (n2 <= 0 || state.length === 0 && state.ended) return 0;
        if ((state.state & kObjectMode) !== 0) return 1;
        if (NumberIsNaN(n2)) {
          if (state.flowing && state.length) return state.buffer.first().length;
          return state.length;
        }
        if (n2 <= state.length) return n2;
        return state.ended ? state.length : 0;
      }
      Readable2.prototype.read = function(n2) {
        debug2("read", n2);
        if (n2 === void 0) {
          n2 = NaN;
        } else if (!NumberIsInteger(n2)) {
          n2 = NumberParseInt(n2, 10);
        }
        const state = this._readableState;
        const nOrig = n2;
        if (n2 > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n2);
        if (n2 !== 0) state.state &= ~kEmittedReadable;
        if (n2 === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
          debug2("read: emitReadable", state.length, state.ended);
          if (state.length === 0 && state.ended) endReadable(this);
          else emitReadable(this);
          return null;
        }
        n2 = howMuchToRead(n2, state);
        if (n2 === 0 && state.ended) {
          if (state.length === 0) endReadable(this);
          return null;
        }
        let doRead = (state.state & kNeedReadable) !== 0;
        debug2("need readable", doRead);
        if (state.length === 0 || state.length - n2 < state.highWaterMark) {
          doRead = true;
          debug2("length less than watermark", doRead);
        }
        if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
          doRead = false;
          debug2("reading, ended or constructing", doRead);
        } else if (doRead) {
          debug2("do read");
          state.state |= kReading | kSync;
          if (state.length === 0) state.state |= kNeedReadable;
          try {
            this._read(state.highWaterMark);
          } catch (err3) {
            errorOrDestroy(this, err3);
          }
          state.state &= ~kSync;
          if (!state.reading) n2 = howMuchToRead(nOrig, state);
        }
        let ret;
        if (n2 > 0) ret = fromList(n2, state);
        else ret = null;
        if (ret === null) {
          state.needReadable = state.length <= state.highWaterMark;
          n2 = 0;
        } else {
          state.length -= n2;
          if (state.multiAwaitDrain) {
            state.awaitDrainWriters.clear();
          } else {
            state.awaitDrainWriters = null;
          }
        }
        if (state.length === 0) {
          if (!state.ended) state.needReadable = true;
          if (nOrig !== n2 && state.ended) endReadable(this);
        }
        if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
          state.dataEmitted = true;
          this.emit("data", ret);
        }
        return ret;
      };
      function onEofChunk(stream, state) {
        debug2("onEofChunk");
        if (state.ended) return;
        if (state.decoder) {
          const chunk = state.decoder.end();
          if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
          }
        }
        state.ended = true;
        if (state.sync) {
          emitReadable(stream);
        } else {
          state.needReadable = false;
          state.emittedReadable = true;
          emitReadable_(stream);
        }
      }
      function emitReadable(stream) {
        const state = stream._readableState;
        debug2("emitReadable", state.needReadable, state.emittedReadable);
        state.needReadable = false;
        if (!state.emittedReadable) {
          debug2("emitReadable", state.flowing);
          state.emittedReadable = true;
          process2.nextTick(emitReadable_, stream);
        }
      }
      function emitReadable_(stream) {
        const state = stream._readableState;
        debug2("emitReadable_", state.destroyed, state.length, state.ended);
        if (!state.destroyed && !state.errored && (state.length || state.ended)) {
          stream.emit("readable");
          state.emittedReadable = false;
        }
        state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
        flow(stream);
      }
      function maybeReadMore(stream, state) {
        if (!state.readingMore && state.constructed) {
          state.readingMore = true;
          process2.nextTick(maybeReadMore_, stream, state);
        }
      }
      function maybeReadMore_(stream, state) {
        while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
          const len = state.length;
          debug2("maybeReadMore read 0");
          stream.read(0);
          if (len === state.length)
            break;
        }
        state.readingMore = false;
      }
      Readable2.prototype._read = function(n2) {
        throw new ERR_METHOD_NOT_IMPLEMENTED2("_read()");
      };
      Readable2.prototype.pipe = function(dest, pipeOpts) {
        const src = this;
        const state = this._readableState;
        if (state.pipes.length === 1) {
          if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new SafeSet(state.awaitDrainWriters ? [state.awaitDrainWriters] : []);
          }
        }
        state.pipes.push(dest);
        debug2("pipe count=%d opts=%j", state.pipes.length, pipeOpts);
        const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process2.stdout && dest !== process2.stderr;
        const endFn = doEnd ? onend : unpipe;
        if (state.endEmitted) process2.nextTick(endFn);
        else src.once("end", endFn);
        dest.on("unpipe", onunpipe);
        function onunpipe(readable, unpipeInfo) {
          debug2("onunpipe");
          if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
              unpipeInfo.hasUnpiped = true;
              cleanup();
            }
          }
        }
        function onend() {
          debug2("onend");
          dest.end();
        }
        let ondrain;
        let cleanedUp = false;
        function cleanup() {
          debug2("cleanup");
          dest.removeListener("close", onclose);
          dest.removeListener("finish", onfinish);
          if (ondrain) {
            dest.removeListener("drain", ondrain);
          }
          dest.removeListener("error", onerror);
          dest.removeListener("unpipe", onunpipe);
          src.removeListener("end", onend);
          src.removeListener("end", unpipe);
          src.removeListener("data", ondata);
          cleanedUp = true;
          if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        function pause() {
          if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
              debug2("false write response, pause", 0);
              state.awaitDrainWriters = dest;
              state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
              debug2("false write response, pause", state.awaitDrainWriters.size);
              state.awaitDrainWriters.add(dest);
            }
            src.pause();
          }
          if (!ondrain) {
            ondrain = pipeOnDrain(src, dest);
            dest.on("drain", ondrain);
          }
        }
        src.on("data", ondata);
        function ondata(chunk) {
          debug2("ondata");
          const ret = dest.write(chunk);
          debug2("dest.write", ret);
          if (ret === false) {
            pause();
          }
        }
        function onerror(er) {
          debug2("onerror", er);
          unpipe();
          dest.removeListener("error", onerror);
          if (dest.listenerCount("error") === 0) {
            const s2 = dest._writableState || dest._readableState;
            if (s2 && !s2.errorEmitted) {
              errorOrDestroy(dest, er);
            } else {
              dest.emit("error", er);
            }
          }
        }
        prependListener(dest, "error", onerror);
        function onclose() {
          dest.removeListener("finish", onfinish);
          unpipe();
        }
        dest.once("close", onclose);
        function onfinish() {
          debug2("onfinish");
          dest.removeListener("close", onclose);
          unpipe();
        }
        dest.once("finish", onfinish);
        function unpipe() {
          debug2("unpipe");
          src.unpipe(dest);
        }
        dest.emit("pipe", src);
        if (dest.writableNeedDrain === true) {
          pause();
        } else if (!state.flowing) {
          debug2("pipe resume");
          src.resume();
        }
        return dest;
      };
      function pipeOnDrain(src, dest) {
        return function pipeOnDrainFunctionResult() {
          const state = src._readableState;
          if (state.awaitDrainWriters === dest) {
            debug2("pipeOnDrain", 1);
            state.awaitDrainWriters = null;
          } else if (state.multiAwaitDrain) {
            debug2("pipeOnDrain", state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
          }
          if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount("data")) {
            src.resume();
          }
        };
      }
      Readable2.prototype.unpipe = function(dest) {
        const state = this._readableState;
        const unpipeInfo = {
          hasUnpiped: false
        };
        if (state.pipes.length === 0) return this;
        if (!dest) {
          const dests = state.pipes;
          state.pipes = [];
          this.pause();
          for (let i2 = 0; i2 < dests.length; i2++)
            dests[i2].emit("unpipe", this, {
              hasUnpiped: false
            });
          return this;
        }
        const index2 = ArrayPrototypeIndexOf(state.pipes, dest);
        if (index2 === -1) return this;
        state.pipes.splice(index2, 1);
        if (state.pipes.length === 0) this.pause();
        dest.emit("unpipe", this, unpipeInfo);
        return this;
      };
      Readable2.prototype.on = function(ev, fn) {
        const res = Stream.prototype.on.call(this, ev, fn);
        const state = this._readableState;
        if (ev === "data") {
          state.readableListening = this.listenerCount("readable") > 0;
          if (state.flowing !== false) this.resume();
        } else if (ev === "readable") {
          if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug2("on readable", state.length, state.reading);
            if (state.length) {
              emitReadable(this);
            } else if (!state.reading) {
              process2.nextTick(nReadingNextTick, this);
            }
          }
        }
        return res;
      };
      Readable2.prototype.addListener = Readable2.prototype.on;
      Readable2.prototype.removeListener = function(ev, fn) {
        const res = Stream.prototype.removeListener.call(this, ev, fn);
        if (ev === "readable") {
          process2.nextTick(updateReadableListening, this);
        }
        return res;
      };
      Readable2.prototype.off = Readable2.prototype.removeListener;
      Readable2.prototype.removeAllListeners = function(ev) {
        const res = Stream.prototype.removeAllListeners.apply(this, arguments);
        if (ev === "readable" || ev === void 0) {
          process2.nextTick(updateReadableListening, this);
        }
        return res;
      };
      function updateReadableListening(self2) {
        const state = self2._readableState;
        state.readableListening = self2.listenerCount("readable") > 0;
        if (state.resumeScheduled && state[kPaused] === false) {
          state.flowing = true;
        } else if (self2.listenerCount("data") > 0) {
          self2.resume();
        } else if (!state.readableListening) {
          state.flowing = null;
        }
      }
      function nReadingNextTick(self2) {
        debug2("readable nexttick read 0");
        self2.read(0);
      }
      Readable2.prototype.resume = function() {
        const state = this._readableState;
        if (!state.flowing) {
          debug2("resume");
          state.flowing = !state.readableListening;
          resume(this, state);
        }
        state[kPaused] = false;
        return this;
      };
      function resume(stream, state) {
        if (!state.resumeScheduled) {
          state.resumeScheduled = true;
          process2.nextTick(resume_, stream, state);
        }
      }
      function resume_(stream, state) {
        debug2("resume", state.reading);
        if (!state.reading) {
          stream.read(0);
        }
        state.resumeScheduled = false;
        stream.emit("resume");
        flow(stream);
        if (state.flowing && !state.reading) stream.read(0);
      }
      Readable2.prototype.pause = function() {
        debug2("call pause flowing=%j", this._readableState.flowing);
        if (this._readableState.flowing !== false) {
          debug2("pause");
          this._readableState.flowing = false;
          this.emit("pause");
        }
        this._readableState[kPaused] = true;
        return this;
      };
      function flow(stream) {
        const state = stream._readableState;
        debug2("flow", state.flowing);
        while (state.flowing && stream.read() !== null) ;
      }
      Readable2.prototype.wrap = function(stream) {
        let paused = false;
        stream.on("data", (chunk) => {
          if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
          }
        });
        stream.on("end", () => {
          this.push(null);
        });
        stream.on("error", (err3) => {
          errorOrDestroy(this, err3);
        });
        stream.on("close", () => {
          this.destroy();
        });
        stream.on("destroy", () => {
          this.destroy();
        });
        this._read = () => {
          if (paused && stream.resume) {
            paused = false;
            stream.resume();
          }
        };
        const streamKeys = ObjectKeys(stream);
        for (let j = 1; j < streamKeys.length; j++) {
          const i2 = streamKeys[j];
          if (this[i2] === void 0 && typeof stream[i2] === "function") {
            this[i2] = stream[i2].bind(stream);
          }
        }
        return this;
      };
      Readable2.prototype[SymbolAsyncIterator] = function() {
        return streamToAsyncIterator(this);
      };
      Readable2.prototype.iterator = function(options) {
        if (options !== void 0) {
          validateObject3(options, "options");
        }
        return streamToAsyncIterator(this, options);
      };
      function streamToAsyncIterator(stream, options) {
        if (typeof stream.read !== "function") {
          stream = Readable2.wrap(stream, {
            objectMode: true
          });
        }
        const iter = createAsyncIterator(stream, options);
        iter.stream = stream;
        return iter;
      }
      async function* createAsyncIterator(stream, options) {
        let callback = nop2;
        function next(resolve2) {
          if (this === stream) {
            callback();
            callback = nop2;
          } else {
            callback = resolve2;
          }
        }
        stream.on("readable", next);
        let error;
        const cleanup = eos(
          stream,
          {
            writable: false
          },
          (err3) => {
            error = err3 ? aggregateTwoErrors(error, err3) : null;
            callback();
            callback = nop2;
          }
        );
        try {
          while (true) {
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) {
              yield chunk;
            } else if (error) {
              throw error;
            } else if (error === null) {
              return;
            } else {
              await new Promise2(next);
            }
          }
        } catch (err3) {
          error = aggregateTwoErrors(error, err3);
          throw error;
        } finally {
          if ((error || (options === null || options === void 0 ? void 0 : options.destroyOnReturn) !== false) && (error === void 0 || stream._readableState.autoDestroy)) {
            destroyImpl.destroyer(stream, null);
          } else {
            stream.off("readable", next);
            cleanup();
          }
        }
      }
      ObjectDefineProperties(Readable2.prototype, {
        readable: {
          __proto__: null,
          get() {
            const r2 = this._readableState;
            return !!r2 && r2.readable !== false && !r2.destroyed && !r2.errorEmitted && !r2.endEmitted;
          },
          set(val) {
            if (this._readableState) {
              this._readableState.readable = !!val;
            }
          }
        },
        readableDidRead: {
          __proto__: null,
          enumerable: false,
          get: function() {
            return this._readableState.dataEmitted;
          }
        },
        readableAborted: {
          __proto__: null,
          enumerable: false,
          get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
          }
        },
        readableHighWaterMark: {
          __proto__: null,
          enumerable: false,
          get: function() {
            return this._readableState.highWaterMark;
          }
        },
        readableBuffer: {
          __proto__: null,
          enumerable: false,
          get: function() {
            return this._readableState && this._readableState.buffer;
          }
        },
        readableFlowing: {
          __proto__: null,
          enumerable: false,
          get: function() {
            return this._readableState.flowing;
          },
          set: function(state) {
            if (this._readableState) {
              this._readableState.flowing = state;
            }
          }
        },
        readableLength: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._readableState.length;
          }
        },
        readableObjectMode: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._readableState ? this._readableState.objectMode : false;
          }
        },
        readableEncoding: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._readableState ? this._readableState.encoding : null;
          }
        },
        errored: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._readableState ? this._readableState.errored : null;
          }
        },
        closed: {
          __proto__: null,
          get() {
            return this._readableState ? this._readableState.closed : false;
          }
        },
        destroyed: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._readableState ? this._readableState.destroyed : false;
          },
          set(value) {
            if (!this._readableState) {
              return;
            }
            this._readableState.destroyed = value;
          }
        },
        readableEnded: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._readableState ? this._readableState.endEmitted : false;
          }
        }
      });
      ObjectDefineProperties(ReadableState.prototype, {
        // Legacy getter for `pipesCount`.
        pipesCount: {
          __proto__: null,
          get() {
            return this.pipes.length;
          }
        },
        // Legacy property for `paused`.
        paused: {
          __proto__: null,
          get() {
            return this[kPaused] !== false;
          },
          set(value) {
            this[kPaused] = !!value;
          }
        }
      });
      Readable2._fromList = fromList;
      function fromList(n2, state) {
        if (state.length === 0) return null;
        let ret;
        if (state.objectMode) ret = state.buffer.shift();
        else if (!n2 || n2 >= state.length) {
          if (state.decoder) ret = state.buffer.join("");
          else if (state.buffer.length === 1) ret = state.buffer.first();
          else ret = state.buffer.concat(state.length);
          state.buffer.clear();
        } else {
          ret = state.buffer.consume(n2, state.decoder);
        }
        return ret;
      }
      function endReadable(stream) {
        const state = stream._readableState;
        debug2("endReadable", state.endEmitted);
        if (!state.endEmitted) {
          state.ended = true;
          process2.nextTick(endReadableNT, state, stream);
        }
      }
      function endReadableNT(state, stream) {
        debug2("endReadableNT", state.endEmitted, state.length);
        if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
          state.endEmitted = true;
          stream.emit("end");
          if (stream.writable && stream.allowHalfOpen === false) {
            process2.nextTick(endWritableNT, stream);
          } else if (state.autoDestroy) {
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) {
              stream.destroy();
            }
          }
        }
      }
      function endWritableNT(stream) {
        const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
        if (writable) {
          stream.end();
        }
      }
      Readable2.from = function(iterable, opts) {
        return from(Readable2, iterable, opts);
      };
      var webStreamsAdapters;
      function lazyWebStreams() {
        if (webStreamsAdapters === void 0) webStreamsAdapters = {};
        return webStreamsAdapters;
      }
      Readable2.fromWeb = function(readableStream, options) {
        return lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
      };
      Readable2.toWeb = function(streamReadable, options) {
        return lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
      };
      Readable2.wrap = function(src, options) {
        var _ref, _src$readableObjectMo;
        return new Readable2({
          objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== void 0 ? _src$readableObjectMo : src.objectMode) !== null && _ref !== void 0 ? _ref : true,
          ...options,
          destroy(err3, callback) {
            destroyImpl.destroyer(src, err3);
            callback(err3);
          }
        }).wrap(src);
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/writable.js
  var require_writable = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/writable.js"(exports2, module2) {
      "use strict";
      var process2 = require_browser2();
      var {
        ArrayPrototypeSlice,
        Error: Error2,
        FunctionPrototypeSymbolHasInstance,
        ObjectDefineProperty,
        ObjectDefineProperties,
        ObjectSetPrototypeOf,
        StringPrototypeToLowerCase,
        Symbol: Symbol2,
        SymbolHasInstance
      } = require_primordials();
      module2.exports = Writable2;
      Writable2.WritableState = WritableState;
      var { EventEmitter: EE } = require_events();
      var Stream = require_legacy().Stream;
      var { Buffer: Buffer7 } = require_buffer();
      var destroyImpl = require_destroy();
      var { addAbortSignal } = require_add_abort_signal();
      var { getHighWaterMark, getDefaultHighWaterMark } = require_state();
      var {
        ERR_INVALID_ARG_TYPE,
        ERR_METHOD_NOT_IMPLEMENTED: ERR_METHOD_NOT_IMPLEMENTED2,
        ERR_MULTIPLE_CALLBACK,
        ERR_STREAM_CANNOT_PIPE,
        ERR_STREAM_DESTROYED,
        ERR_STREAM_ALREADY_FINISHED,
        ERR_STREAM_NULL_VALUES,
        ERR_STREAM_WRITE_AFTER_END,
        ERR_UNKNOWN_ENCODING
      } = require_errors().codes;
      var { errorOrDestroy } = destroyImpl;
      ObjectSetPrototypeOf(Writable2.prototype, Stream.prototype);
      ObjectSetPrototypeOf(Writable2, Stream);
      function nop2() {
      }
      var kOnFinished = Symbol2("kOnFinished");
      function WritableState(options, stream, isDuplex) {
        if (typeof isDuplex !== "boolean") isDuplex = stream instanceof require_duplex();
        this.objectMode = !!(options && options.objectMode);
        if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
        this.highWaterMark = options ? getHighWaterMark(this, options, "writableHighWaterMark", isDuplex) : getDefaultHighWaterMark(false);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        const noDecode = !!(options && options.decodeStrings === false);
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options && options.defaultEncoding || "utf8";
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = onwrite.bind(void 0, stream);
        this.writecb = null;
        this.writelen = 0;
        this.afterWriteTickInfo = null;
        resetBuffer(this);
        this.pendingcb = 0;
        this.constructed = true;
        this.prefinished = false;
        this.errorEmitted = false;
        this.emitClose = !options || options.emitClose !== false;
        this.autoDestroy = !options || options.autoDestroy !== false;
        this.errored = null;
        this.closed = false;
        this.closeEmitted = false;
        this[kOnFinished] = [];
      }
      function resetBuffer(state) {
        state.buffered = [];
        state.bufferedIndex = 0;
        state.allBuffers = true;
        state.allNoop = true;
      }
      WritableState.prototype.getBuffer = function getBuffer() {
        return ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
      };
      ObjectDefineProperty(WritableState.prototype, "bufferedRequestCount", {
        __proto__: null,
        get() {
          return this.buffered.length - this.bufferedIndex;
        }
      });
      function Writable2(options) {
        const isDuplex = this instanceof require_duplex();
        if (!isDuplex && !FunctionPrototypeSymbolHasInstance(Writable2, this)) return new Writable2(options);
        this._writableState = new WritableState(options, this, isDuplex);
        if (options) {
          if (typeof options.write === "function") this._write = options.write;
          if (typeof options.writev === "function") this._writev = options.writev;
          if (typeof options.destroy === "function") this._destroy = options.destroy;
          if (typeof options.final === "function") this._final = options.final;
          if (typeof options.construct === "function") this._construct = options.construct;
          if (options.signal) addAbortSignal(options.signal, this);
        }
        Stream.call(this, options);
        destroyImpl.construct(this, () => {
          const state = this._writableState;
          if (!state.writing) {
            clearBuffer(this, state);
          }
          finishMaybe(this, state);
        });
      }
      ObjectDefineProperty(Writable2, SymbolHasInstance, {
        __proto__: null,
        value: function(object) {
          if (FunctionPrototypeSymbolHasInstance(this, object)) return true;
          if (this !== Writable2) return false;
          return object && object._writableState instanceof WritableState;
        }
      });
      Writable2.prototype.pipe = function() {
        errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
      };
      function _write(stream, chunk, encoding, cb) {
        const state = stream._writableState;
        if (typeof encoding === "function") {
          cb = encoding;
          encoding = state.defaultEncoding;
        } else {
          if (!encoding) encoding = state.defaultEncoding;
          else if (encoding !== "buffer" && !Buffer7.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding);
          if (typeof cb !== "function") cb = nop2;
        }
        if (chunk === null) {
          throw new ERR_STREAM_NULL_VALUES();
        } else if (!state.objectMode) {
          if (typeof chunk === "string") {
            if (state.decodeStrings !== false) {
              chunk = Buffer7.from(chunk, encoding);
              encoding = "buffer";
            }
          } else if (chunk instanceof Buffer7) {
            encoding = "buffer";
          } else if (Stream._isUint8Array(chunk)) {
            chunk = Stream._uint8ArrayToBuffer(chunk);
            encoding = "buffer";
          } else {
            throw new ERR_INVALID_ARG_TYPE("chunk", ["string", "Buffer", "Uint8Array"], chunk);
          }
        }
        let err3;
        if (state.ending) {
          err3 = new ERR_STREAM_WRITE_AFTER_END();
        } else if (state.destroyed) {
          err3 = new ERR_STREAM_DESTROYED("write");
        }
        if (err3) {
          process2.nextTick(cb, err3);
          errorOrDestroy(stream, err3, true);
          return err3;
        }
        state.pendingcb++;
        return writeOrBuffer(stream, state, chunk, encoding, cb);
      }
      Writable2.prototype.write = function(chunk, encoding, cb) {
        return _write(this, chunk, encoding, cb) === true;
      };
      Writable2.prototype.cork = function() {
        this._writableState.corked++;
      };
      Writable2.prototype.uncork = function() {
        const state = this._writableState;
        if (state.corked) {
          state.corked--;
          if (!state.writing) clearBuffer(this, state);
        }
      };
      Writable2.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === "string") encoding = StringPrototypeToLowerCase(encoding);
        if (!Buffer7.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
      };
      function writeOrBuffer(stream, state, chunk, encoding, callback) {
        const len = state.objectMode ? 1 : chunk.length;
        state.length += len;
        const ret = state.length < state.highWaterMark;
        if (!ret) state.needDrain = true;
        if (state.writing || state.corked || state.errored || !state.constructed) {
          state.buffered.push({
            chunk,
            encoding,
            callback
          });
          if (state.allBuffers && encoding !== "buffer") {
            state.allBuffers = false;
          }
          if (state.allNoop && callback !== nop2) {
            state.allNoop = false;
          }
        } else {
          state.writelen = len;
          state.writecb = callback;
          state.writing = true;
          state.sync = true;
          stream._write(chunk, encoding, state.onwrite);
          state.sync = false;
        }
        return ret && !state.errored && !state.destroyed;
      }
      function doWrite(stream, state, writev2, len, chunk, encoding, cb) {
        state.writelen = len;
        state.writecb = cb;
        state.writing = true;
        state.sync = true;
        if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED("write"));
        else if (writev2) stream._writev(chunk, state.onwrite);
        else stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
      }
      function onwriteError(stream, state, er, cb) {
        --state.pendingcb;
        cb(er);
        errorBuffer(state);
        errorOrDestroy(stream, er);
      }
      function onwrite(stream, er) {
        const state = stream._writableState;
        const sync = state.sync;
        const cb = state.writecb;
        if (typeof cb !== "function") {
          errorOrDestroy(stream, new ERR_MULTIPLE_CALLBACK());
          return;
        }
        state.writing = false;
        state.writecb = null;
        state.length -= state.writelen;
        state.writelen = 0;
        if (er) {
          er.stack;
          if (!state.errored) {
            state.errored = er;
          }
          if (stream._readableState && !stream._readableState.errored) {
            stream._readableState.errored = er;
          }
          if (sync) {
            process2.nextTick(onwriteError, stream, state, er, cb);
          } else {
            onwriteError(stream, state, er, cb);
          }
        } else {
          if (state.buffered.length > state.bufferedIndex) {
            clearBuffer(stream, state);
          }
          if (sync) {
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) {
              state.afterWriteTickInfo.count++;
            } else {
              state.afterWriteTickInfo = {
                count: 1,
                cb,
                stream,
                state
              };
              process2.nextTick(afterWriteTick, state.afterWriteTickInfo);
            }
          } else {
            afterWrite(stream, state, 1, cb);
          }
        }
      }
      function afterWriteTick({ stream, state, count, cb }) {
        state.afterWriteTickInfo = null;
        return afterWrite(stream, state, count, cb);
      }
      function afterWrite(stream, state, count, cb) {
        const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
        if (needDrain) {
          state.needDrain = false;
          stream.emit("drain");
        }
        while (count-- > 0) {
          state.pendingcb--;
          cb();
        }
        if (state.destroyed) {
          errorBuffer(state);
        }
        finishMaybe(stream, state);
      }
      function errorBuffer(state) {
        if (state.writing) {
          return;
        }
        for (let n2 = state.bufferedIndex; n2 < state.buffered.length; ++n2) {
          var _state$errored;
          const { chunk, callback } = state.buffered[n2];
          const len = state.objectMode ? 1 : chunk.length;
          state.length -= len;
          callback(
            (_state$errored = state.errored) !== null && _state$errored !== void 0 ? _state$errored : new ERR_STREAM_DESTROYED("write")
          );
        }
        const onfinishCallbacks = state[kOnFinished].splice(0);
        for (let i2 = 0; i2 < onfinishCallbacks.length; i2++) {
          var _state$errored2;
          onfinishCallbacks[i2](
            (_state$errored2 = state.errored) !== null && _state$errored2 !== void 0 ? _state$errored2 : new ERR_STREAM_DESTROYED("end")
          );
        }
        resetBuffer(state);
      }
      function clearBuffer(stream, state) {
        if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) {
          return;
        }
        const { buffered, bufferedIndex, objectMode } = state;
        const bufferedLength = buffered.length - bufferedIndex;
        if (!bufferedLength) {
          return;
        }
        let i2 = bufferedIndex;
        state.bufferProcessing = true;
        if (bufferedLength > 1 && stream._writev) {
          state.pendingcb -= bufferedLength - 1;
          const callback = state.allNoop ? nop2 : (err3) => {
            for (let n2 = i2; n2 < buffered.length; ++n2) {
              buffered[n2].callback(err3);
            }
          };
          const chunks = state.allNoop && i2 === 0 ? buffered : ArrayPrototypeSlice(buffered, i2);
          chunks.allBuffers = state.allBuffers;
          doWrite(stream, state, true, state.length, chunks, "", callback);
          resetBuffer(state);
        } else {
          do {
            const { chunk, encoding, callback } = buffered[i2];
            buffered[i2++] = null;
            const len = objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, callback);
          } while (i2 < buffered.length && !state.writing);
          if (i2 === buffered.length) {
            resetBuffer(state);
          } else if (i2 > 256) {
            buffered.splice(0, i2);
            state.bufferedIndex = 0;
          } else {
            state.bufferedIndex = i2;
          }
        }
        state.bufferProcessing = false;
      }
      Writable2.prototype._write = function(chunk, encoding, cb) {
        if (this._writev) {
          this._writev(
            [
              {
                chunk,
                encoding
              }
            ],
            cb
          );
        } else {
          throw new ERR_METHOD_NOT_IMPLEMENTED2("_write()");
        }
      };
      Writable2.prototype._writev = null;
      Writable2.prototype.end = function(chunk, encoding, cb) {
        const state = this._writableState;
        if (typeof chunk === "function") {
          cb = chunk;
          chunk = null;
          encoding = null;
        } else if (typeof encoding === "function") {
          cb = encoding;
          encoding = null;
        }
        let err3;
        if (chunk !== null && chunk !== void 0) {
          const ret = _write(this, chunk, encoding);
          if (ret instanceof Error2) {
            err3 = ret;
          }
        }
        if (state.corked) {
          state.corked = 1;
          this.uncork();
        }
        if (err3) {
        } else if (!state.errored && !state.ending) {
          state.ending = true;
          finishMaybe(this, state, true);
          state.ended = true;
        } else if (state.finished) {
          err3 = new ERR_STREAM_ALREADY_FINISHED("end");
        } else if (state.destroyed) {
          err3 = new ERR_STREAM_DESTROYED("end");
        }
        if (typeof cb === "function") {
          if (err3 || state.finished) {
            process2.nextTick(cb, err3);
          } else {
            state[kOnFinished].push(cb);
          }
        }
        return this;
      };
      function needFinish(state) {
        return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
      }
      function callFinal(stream, state) {
        let called = false;
        function onFinish(err3) {
          if (called) {
            errorOrDestroy(stream, err3 !== null && err3 !== void 0 ? err3 : ERR_MULTIPLE_CALLBACK());
            return;
          }
          called = true;
          state.pendingcb--;
          if (err3) {
            const onfinishCallbacks = state[kOnFinished].splice(0);
            for (let i2 = 0; i2 < onfinishCallbacks.length; i2++) {
              onfinishCallbacks[i2](err3);
            }
            errorOrDestroy(stream, err3, state.sync);
          } else if (needFinish(state)) {
            state.prefinished = true;
            stream.emit("prefinish");
            state.pendingcb++;
            process2.nextTick(finish, stream, state);
          }
        }
        state.sync = true;
        state.pendingcb++;
        try {
          stream._final(onFinish);
        } catch (err3) {
          onFinish(err3);
        }
        state.sync = false;
      }
      function prefinish(stream, state) {
        if (!state.prefinished && !state.finalCalled) {
          if (typeof stream._final === "function" && !state.destroyed) {
            state.finalCalled = true;
            callFinal(stream, state);
          } else {
            state.prefinished = true;
            stream.emit("prefinish");
          }
        }
      }
      function finishMaybe(stream, state, sync) {
        if (needFinish(state)) {
          prefinish(stream, state);
          if (state.pendingcb === 0) {
            if (sync) {
              state.pendingcb++;
              process2.nextTick(
                (stream2, state2) => {
                  if (needFinish(state2)) {
                    finish(stream2, state2);
                  } else {
                    state2.pendingcb--;
                  }
                },
                stream,
                state
              );
            } else if (needFinish(state)) {
              state.pendingcb++;
              finish(stream, state);
            }
          }
        }
      }
      function finish(stream, state) {
        state.pendingcb--;
        state.finished = true;
        const onfinishCallbacks = state[kOnFinished].splice(0);
        for (let i2 = 0; i2 < onfinishCallbacks.length; i2++) {
          onfinishCallbacks[i2]();
        }
        stream.emit("finish");
        if (state.autoDestroy) {
          const rState = stream._readableState;
          const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
          // if readable is explicitly set to false.
          (rState.endEmitted || rState.readable === false);
          if (autoDestroy) {
            stream.destroy();
          }
        }
      }
      ObjectDefineProperties(Writable2.prototype, {
        closed: {
          __proto__: null,
          get() {
            return this._writableState ? this._writableState.closed : false;
          }
        },
        destroyed: {
          __proto__: null,
          get() {
            return this._writableState ? this._writableState.destroyed : false;
          },
          set(value) {
            if (this._writableState) {
              this._writableState.destroyed = value;
            }
          }
        },
        writable: {
          __proto__: null,
          get() {
            const w = this._writableState;
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
          },
          set(val) {
            if (this._writableState) {
              this._writableState.writable = !!val;
            }
          }
        },
        writableFinished: {
          __proto__: null,
          get() {
            return this._writableState ? this._writableState.finished : false;
          }
        },
        writableObjectMode: {
          __proto__: null,
          get() {
            return this._writableState ? this._writableState.objectMode : false;
          }
        },
        writableBuffer: {
          __proto__: null,
          get() {
            return this._writableState && this._writableState.getBuffer();
          }
        },
        writableEnded: {
          __proto__: null,
          get() {
            return this._writableState ? this._writableState.ending : false;
          }
        },
        writableNeedDrain: {
          __proto__: null,
          get() {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
          }
        },
        writableHighWaterMark: {
          __proto__: null,
          get() {
            return this._writableState && this._writableState.highWaterMark;
          }
        },
        writableCorked: {
          __proto__: null,
          get() {
            return this._writableState ? this._writableState.corked : 0;
          }
        },
        writableLength: {
          __proto__: null,
          get() {
            return this._writableState && this._writableState.length;
          }
        },
        errored: {
          __proto__: null,
          enumerable: false,
          get() {
            return this._writableState ? this._writableState.errored : null;
          }
        },
        writableAborted: {
          __proto__: null,
          enumerable: false,
          get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
          }
        }
      });
      var destroy = destroyImpl.destroy;
      Writable2.prototype.destroy = function(err3, cb) {
        const state = this._writableState;
        if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[kOnFinished].length)) {
          process2.nextTick(errorBuffer, state);
        }
        destroy.call(this, err3, cb);
        return this;
      };
      Writable2.prototype._undestroy = destroyImpl.undestroy;
      Writable2.prototype._destroy = function(err3, cb) {
        cb(err3);
      };
      Writable2.prototype[EE.captureRejectionSymbol] = function(err3) {
        this.destroy(err3);
      };
      var webStreamsAdapters;
      function lazyWebStreams() {
        if (webStreamsAdapters === void 0) webStreamsAdapters = {};
        return webStreamsAdapters;
      }
      Writable2.fromWeb = function(writableStream, options) {
        return lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
      };
      Writable2.toWeb = function(streamWritable) {
        return lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/duplexify.js
  var require_duplexify = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/duplexify.js"(exports2, module2) {
      var process2 = require_browser2();
      var bufferModule = require_buffer();
      var {
        isReadable,
        isWritable,
        isIterable: isIterable2,
        isNodeStream,
        isReadableNodeStream,
        isWritableNodeStream,
        isDuplexNodeStream,
        isReadableStream,
        isWritableStream
      } = require_utils();
      var eos = require_end_of_stream();
      var {
        AbortError,
        codes: { ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE }
      } = require_errors();
      var { destroyer } = require_destroy();
      var Duplex = require_duplex();
      var Readable2 = require_readable();
      var Writable2 = require_writable();
      var { createDeferredPromise } = require_util();
      var from = require_from();
      var Blob2 = globalThis.Blob || bufferModule.Blob;
      var isBlob2 = typeof Blob2 !== "undefined" ? function isBlob3(b) {
        return b instanceof Blob2;
      } : function isBlob3(b) {
        return false;
      };
      var AbortController2 = globalThis.AbortController || require_browser().AbortController;
      var { FunctionPrototypeCall } = require_primordials();
      var Duplexify = class extends Duplex {
        constructor(options) {
          super(options);
          if ((options === null || options === void 0 ? void 0 : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
          }
          if ((options === null || options === void 0 ? void 0 : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
          }
        }
      };
      module2.exports = function duplexify(body, name2) {
        if (isDuplexNodeStream(body)) {
          return body;
        }
        if (isReadableNodeStream(body)) {
          return _duplexify({
            readable: body
          });
        }
        if (isWritableNodeStream(body)) {
          return _duplexify({
            writable: body
          });
        }
        if (isNodeStream(body)) {
          return _duplexify({
            writable: false,
            readable: false
          });
        }
        if (isReadableStream(body)) {
          return _duplexify({
            readable: Readable2.fromWeb(body)
          });
        }
        if (isWritableStream(body)) {
          return _duplexify({
            writable: Writable2.fromWeb(body)
          });
        }
        if (typeof body === "function") {
          const { value, write: write2, final, destroy } = fromAsyncGen(body);
          if (isIterable2(value)) {
            return from(Duplexify, value, {
              // TODO (ronag): highWaterMark?
              objectMode: true,
              write: write2,
              final,
              destroy
            });
          }
          const then2 = value === null || value === void 0 ? void 0 : value.then;
          if (typeof then2 === "function") {
            let d;
            const promise = FunctionPrototypeCall(
              then2,
              value,
              (val) => {
                if (val != null) {
                  throw new ERR_INVALID_RETURN_VALUE("nully", "body", val);
                }
              },
              (err3) => {
                destroyer(d, err3);
              }
            );
            return d = new Duplexify({
              // TODO (ronag): highWaterMark?
              objectMode: true,
              readable: false,
              write: write2,
              final(cb) {
                final(async () => {
                  try {
                    await promise;
                    process2.nextTick(cb, null);
                  } catch (err3) {
                    process2.nextTick(cb, err3);
                  }
                });
              },
              destroy
            });
          }
          throw new ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or AsyncFunction", name2, value);
        }
        if (isBlob2(body)) {
          return duplexify(body.arrayBuffer());
        }
        if (isIterable2(body)) {
          return from(Duplexify, body, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            writable: false
          });
        }
        if (isReadableStream(body === null || body === void 0 ? void 0 : body.readable) && isWritableStream(body === null || body === void 0 ? void 0 : body.writable)) {
          return Duplexify.fromWeb(body);
        }
        if (typeof (body === null || body === void 0 ? void 0 : body.writable) === "object" || typeof (body === null || body === void 0 ? void 0 : body.readable) === "object") {
          const readable = body !== null && body !== void 0 && body.readable ? isReadableNodeStream(body === null || body === void 0 ? void 0 : body.readable) ? body === null || body === void 0 ? void 0 : body.readable : duplexify(body.readable) : void 0;
          const writable = body !== null && body !== void 0 && body.writable ? isWritableNodeStream(body === null || body === void 0 ? void 0 : body.writable) ? body === null || body === void 0 ? void 0 : body.writable : duplexify(body.writable) : void 0;
          return _duplexify({
            readable,
            writable
          });
        }
        const then = body === null || body === void 0 ? void 0 : body.then;
        if (typeof then === "function") {
          let d;
          FunctionPrototypeCall(
            then,
            body,
            (val) => {
              if (val != null) {
                d.push(val);
              }
              d.push(null);
            },
            (err3) => {
              destroyer(d, err3);
            }
          );
          return d = new Duplexify({
            objectMode: true,
            writable: false,
            read() {
            }
          });
        }
        throw new ERR_INVALID_ARG_TYPE(
          name2,
          [
            "Blob",
            "ReadableStream",
            "WritableStream",
            "Stream",
            "Iterable",
            "AsyncIterable",
            "Function",
            "{ readable, writable } pair",
            "Promise"
          ],
          body
        );
      };
      function fromAsyncGen(fn) {
        let { promise, resolve: resolve2 } = createDeferredPromise();
        const ac = new AbortController2();
        const signal = ac.signal;
        const value = fn(
          async function* () {
            while (true) {
              const _promise = promise;
              promise = null;
              const { chunk, done, cb } = await _promise;
              process2.nextTick(cb);
              if (done) return;
              if (signal.aborted)
                throw new AbortError(void 0, {
                  cause: signal.reason
                });
              ({ promise, resolve: resolve2 } = createDeferredPromise());
              yield chunk;
            }
          }(),
          {
            signal
          }
        );
        return {
          value,
          write(chunk, encoding, cb) {
            const _resolve2 = resolve2;
            resolve2 = null;
            _resolve2({
              chunk,
              done: false,
              cb
            });
          },
          final(cb) {
            const _resolve2 = resolve2;
            resolve2 = null;
            _resolve2({
              done: true,
              cb
            });
          },
          destroy(err3, cb) {
            ac.abort();
            cb(err3);
          }
        };
      }
      function _duplexify(pair) {
        const r2 = pair.readable && typeof pair.readable.read !== "function" ? Readable2.wrap(pair.readable) : pair.readable;
        const w = pair.writable;
        let readable = !!isReadable(r2);
        let writable = !!isWritable(w);
        let ondrain;
        let onfinish;
        let onreadable;
        let onclose;
        let d;
        function onfinished(err3) {
          const cb = onclose;
          onclose = null;
          if (cb) {
            cb(err3);
          } else if (err3) {
            d.destroy(err3);
          }
        }
        d = new Duplexify({
          // TODO (ronag): highWaterMark?
          readableObjectMode: !!(r2 !== null && r2 !== void 0 && r2.readableObjectMode),
          writableObjectMode: !!(w !== null && w !== void 0 && w.writableObjectMode),
          readable,
          writable
        });
        if (writable) {
          eos(w, (err3) => {
            writable = false;
            if (err3) {
              destroyer(r2, err3);
            }
            onfinished(err3);
          });
          d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) {
              callback();
            } else {
              ondrain = callback;
            }
          };
          d._final = function(callback) {
            w.end();
            onfinish = callback;
          };
          w.on("drain", function() {
            if (ondrain) {
              const cb = ondrain;
              ondrain = null;
              cb();
            }
          });
          w.on("finish", function() {
            if (onfinish) {
              const cb = onfinish;
              onfinish = null;
              cb();
            }
          });
        }
        if (readable) {
          eos(r2, (err3) => {
            readable = false;
            if (err3) {
              destroyer(r2, err3);
            }
            onfinished(err3);
          });
          r2.on("readable", function() {
            if (onreadable) {
              const cb = onreadable;
              onreadable = null;
              cb();
            }
          });
          r2.on("end", function() {
            d.push(null);
          });
          d._read = function() {
            while (true) {
              const buf = r2.read();
              if (buf === null) {
                onreadable = d._read;
                return;
              }
              if (!d.push(buf)) {
                return;
              }
            }
          };
        }
        d._destroy = function(err3, callback) {
          if (!err3 && onclose !== null) {
            err3 = new AbortError();
          }
          onreadable = null;
          ondrain = null;
          onfinish = null;
          if (onclose === null) {
            callback(err3);
          } else {
            onclose = callback;
            destroyer(w, err3);
            destroyer(r2, err3);
          }
        };
        return d;
      }
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/duplex.js
  var require_duplex = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/duplex.js"(exports2, module2) {
      "use strict";
      var {
        ObjectDefineProperties,
        ObjectGetOwnPropertyDescriptor,
        ObjectKeys,
        ObjectSetPrototypeOf
      } = require_primordials();
      module2.exports = Duplex;
      var Readable2 = require_readable();
      var Writable2 = require_writable();
      ObjectSetPrototypeOf(Duplex.prototype, Readable2.prototype);
      ObjectSetPrototypeOf(Duplex, Readable2);
      {
        const keys = ObjectKeys(Writable2.prototype);
        for (let i2 = 0; i2 < keys.length; i2++) {
          const method = keys[i2];
          if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable2.prototype[method];
        }
      }
      function Duplex(options) {
        if (!(this instanceof Duplex)) return new Duplex(options);
        Readable2.call(this, options);
        Writable2.call(this, options);
        if (options) {
          this.allowHalfOpen = options.allowHalfOpen !== false;
          if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
          }
          if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
          }
        } else {
          this.allowHalfOpen = true;
        }
      }
      ObjectDefineProperties(Duplex.prototype, {
        writable: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writable")
        },
        writableHighWaterMark: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableHighWaterMark")
        },
        writableObjectMode: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableObjectMode")
        },
        writableBuffer: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableBuffer")
        },
        writableLength: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableLength")
        },
        writableFinished: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableFinished")
        },
        writableCorked: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableCorked")
        },
        writableEnded: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableEnded")
        },
        writableNeedDrain: {
          __proto__: null,
          ...ObjectGetOwnPropertyDescriptor(Writable2.prototype, "writableNeedDrain")
        },
        destroyed: {
          __proto__: null,
          get() {
            if (this._readableState === void 0 || this._writableState === void 0) {
              return false;
            }
            return this._readableState.destroyed && this._writableState.destroyed;
          },
          set(value) {
            if (this._readableState && this._writableState) {
              this._readableState.destroyed = value;
              this._writableState.destroyed = value;
            }
          }
        }
      });
      var webStreamsAdapters;
      function lazyWebStreams() {
        if (webStreamsAdapters === void 0) webStreamsAdapters = {};
        return webStreamsAdapters;
      }
      Duplex.fromWeb = function(pair, options) {
        return lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
      };
      Duplex.toWeb = function(duplex) {
        return lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
      };
      var duplexify;
      Duplex.from = function(body) {
        if (!duplexify) {
          duplexify = require_duplexify();
        }
        return duplexify(body, "body");
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/transform.js
  var require_transform = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/transform.js"(exports2, module2) {
      "use strict";
      var { ObjectSetPrototypeOf, Symbol: Symbol2 } = require_primordials();
      module2.exports = Transform;
      var { ERR_METHOD_NOT_IMPLEMENTED: ERR_METHOD_NOT_IMPLEMENTED2 } = require_errors().codes;
      var Duplex = require_duplex();
      var { getHighWaterMark } = require_state();
      ObjectSetPrototypeOf(Transform.prototype, Duplex.prototype);
      ObjectSetPrototypeOf(Transform, Duplex);
      var kCallback = Symbol2("kCallback");
      function Transform(options) {
        if (!(this instanceof Transform)) return new Transform(options);
        const readableHighWaterMark = options ? getHighWaterMark(this, options, "readableHighWaterMark", true) : null;
        if (readableHighWaterMark === 0) {
          options = {
            ...options,
            highWaterMark: null,
            readableHighWaterMark,
            // TODO (ronag): 0 is not optimal since we have
            // a "bug" where we check needDrain before calling _write and not after.
            // Refs: https://github.com/nodejs/node/pull/32887
            // Refs: https://github.com/nodejs/node/pull/35941
            writableHighWaterMark: options.writableHighWaterMark || 0
          };
        }
        Duplex.call(this, options);
        this._readableState.sync = false;
        this[kCallback] = null;
        if (options) {
          if (typeof options.transform === "function") this._transform = options.transform;
          if (typeof options.flush === "function") this._flush = options.flush;
        }
        this.on("prefinish", prefinish);
      }
      function final(cb) {
        if (typeof this._flush === "function" && !this.destroyed) {
          this._flush((er, data) => {
            if (er) {
              if (cb) {
                cb(er);
              } else {
                this.destroy(er);
              }
              return;
            }
            if (data != null) {
              this.push(data);
            }
            this.push(null);
            if (cb) {
              cb();
            }
          });
        } else {
          this.push(null);
          if (cb) {
            cb();
          }
        }
      }
      function prefinish() {
        if (this._final !== final) {
          final.call(this);
        }
      }
      Transform.prototype._final = final;
      Transform.prototype._transform = function(chunk, encoding, callback) {
        throw new ERR_METHOD_NOT_IMPLEMENTED2("_transform()");
      };
      Transform.prototype._write = function(chunk, encoding, callback) {
        const rState = this._readableState;
        const wState = this._writableState;
        const length2 = rState.length;
        this._transform(chunk, encoding, (err3, val) => {
          if (err3) {
            callback(err3);
            return;
          }
          if (val != null) {
            this.push(val);
          }
          if (wState.ended || // Backwards compat.
          length2 === rState.length || // Backwards compat.
          rState.length < rState.highWaterMark) {
            callback();
          } else {
            this[kCallback] = callback;
          }
        });
      };
      Transform.prototype._read = function() {
        if (this[kCallback]) {
          const callback = this[kCallback];
          this[kCallback] = null;
          callback();
        }
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/passthrough.js
  var require_passthrough = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/passthrough.js"(exports2, module2) {
      "use strict";
      var { ObjectSetPrototypeOf } = require_primordials();
      module2.exports = PassThrough;
      var Transform = require_transform();
      ObjectSetPrototypeOf(PassThrough.prototype, Transform.prototype);
      ObjectSetPrototypeOf(PassThrough, Transform);
      function PassThrough(options) {
        if (!(this instanceof PassThrough)) return new PassThrough(options);
        Transform.call(this, options);
      }
      PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/pipeline.js
  var require_pipeline = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/pipeline.js"(exports2, module2) {
      var process2 = require_browser2();
      var { ArrayIsArray, Promise: Promise2, SymbolAsyncIterator, SymbolDispose } = require_primordials();
      var eos = require_end_of_stream();
      var { once } = require_util();
      var destroyImpl = require_destroy();
      var Duplex = require_duplex();
      var {
        aggregateTwoErrors,
        codes: {
          ERR_INVALID_ARG_TYPE,
          ERR_INVALID_RETURN_VALUE,
          ERR_MISSING_ARGS,
          ERR_STREAM_DESTROYED,
          ERR_STREAM_PREMATURE_CLOSE
        },
        AbortError
      } = require_errors();
      var { validateFunction, validateAbortSignal } = require_validators();
      var {
        isIterable: isIterable2,
        isReadable,
        isReadableNodeStream,
        isNodeStream,
        isTransformStream,
        isWebStream,
        isReadableStream,
        isReadableFinished
      } = require_utils();
      var AbortController2 = globalThis.AbortController || require_browser().AbortController;
      var PassThrough;
      var Readable2;
      var addAbortListener;
      function destroyer(stream, reading, writing) {
        let finished = false;
        stream.on("close", () => {
          finished = true;
        });
        const cleanup = eos(
          stream,
          {
            readable: reading,
            writable: writing
          },
          (err3) => {
            finished = !err3;
          }
        );
        return {
          destroy: (err3) => {
            if (finished) return;
            finished = true;
            destroyImpl.destroyer(stream, err3 || new ERR_STREAM_DESTROYED("pipe"));
          },
          cleanup
        };
      }
      function popCallback(streams) {
        validateFunction(streams[streams.length - 1], "streams[stream.length - 1]");
        return streams.pop();
      }
      function makeAsyncIterable(val) {
        if (isIterable2(val)) {
          return val;
        } else if (isReadableNodeStream(val)) {
          return fromReadable(val);
        }
        throw new ERR_INVALID_ARG_TYPE("val", ["Readable", "Iterable", "AsyncIterable"], val);
      }
      async function* fromReadable(val) {
        if (!Readable2) {
          Readable2 = require_readable();
        }
        yield* Readable2.prototype[SymbolAsyncIterator].call(val);
      }
      async function pumpToNode(iterable, writable, finish, { end }) {
        let error;
        let onresolve = null;
        const resume = (err3) => {
          if (err3) {
            error = err3;
          }
          if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
          }
        };
        const wait = () => new Promise2((resolve2, reject) => {
          if (error) {
            reject(error);
          } else {
            onresolve = () => {
              if (error) {
                reject(error);
              } else {
                resolve2();
              }
            };
          }
        });
        writable.on("drain", resume);
        const cleanup = eos(
          writable,
          {
            readable: false
          },
          resume
        );
        try {
          if (writable.writableNeedDrain) {
            await wait();
          }
          for await (const chunk of iterable) {
            if (!writable.write(chunk)) {
              await wait();
            }
          }
          if (end) {
            writable.end();
            await wait();
          }
          finish();
        } catch (err3) {
          finish(error !== err3 ? aggregateTwoErrors(error, err3) : err3);
        } finally {
          cleanup();
          writable.off("drain", resume);
        }
      }
      async function pumpToWeb(readable, writable, finish, { end }) {
        if (isTransformStream(writable)) {
          writable = writable.writable;
        }
        const writer = writable.getWriter();
        try {
          for await (const chunk of readable) {
            await writer.ready;
            writer.write(chunk).catch(() => {
            });
          }
          await writer.ready;
          if (end) {
            await writer.close();
          }
          finish();
        } catch (err3) {
          try {
            await writer.abort(err3);
            finish(err3);
          } catch (err4) {
            finish(err4);
          }
        }
      }
      function pipeline(...streams) {
        return pipelineImpl(streams, once(popCallback(streams)));
      }
      function pipelineImpl(streams, callback, opts) {
        if (streams.length === 1 && ArrayIsArray(streams[0])) {
          streams = streams[0];
        }
        if (streams.length < 2) {
          throw new ERR_MISSING_ARGS("streams");
        }
        const ac = new AbortController2();
        const signal = ac.signal;
        const outerSignal = opts === null || opts === void 0 ? void 0 : opts.signal;
        const lastStreamCleanup = [];
        validateAbortSignal(outerSignal, "options.signal");
        function abort() {
          finishImpl(new AbortError());
        }
        addAbortListener = addAbortListener || require_util().addAbortListener;
        let disposable;
        if (outerSignal) {
          disposable = addAbortListener(outerSignal, abort);
        }
        let error;
        let value;
        const destroys = [];
        let finishCount = 0;
        function finish(err3) {
          finishImpl(err3, --finishCount === 0);
        }
        function finishImpl(err3, final) {
          var _disposable;
          if (err3 && (!error || error.code === "ERR_STREAM_PREMATURE_CLOSE")) {
            error = err3;
          }
          if (!error && !final) {
            return;
          }
          while (destroys.length) {
            destroys.shift()(error);
          }
          ;
          (_disposable = disposable) === null || _disposable === void 0 ? void 0 : _disposable[SymbolDispose]();
          ac.abort();
          if (final) {
            if (!error) {
              lastStreamCleanup.forEach((fn) => fn());
            }
            process2.nextTick(callback, error, value);
          }
        }
        let ret;
        for (let i2 = 0; i2 < streams.length; i2++) {
          const stream = streams[i2];
          const reading = i2 < streams.length - 1;
          const writing = i2 > 0;
          const end = reading || (opts === null || opts === void 0 ? void 0 : opts.end) !== false;
          const isLastStream = i2 === streams.length - 1;
          if (isNodeStream(stream)) {
            let onError2 = function(err3) {
              if (err3 && err3.name !== "AbortError" && err3.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                finish(err3);
              }
            };
            var onError = onError2;
            if (end) {
              const { destroy, cleanup } = destroyer(stream, reading, writing);
              destroys.push(destroy);
              if (isReadable(stream) && isLastStream) {
                lastStreamCleanup.push(cleanup);
              }
            }
            stream.on("error", onError2);
            if (isReadable(stream) && isLastStream) {
              lastStreamCleanup.push(() => {
                stream.removeListener("error", onError2);
              });
            }
          }
          if (i2 === 0) {
            if (typeof stream === "function") {
              ret = stream({
                signal
              });
              if (!isIterable2(ret)) {
                throw new ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or Stream", "source", ret);
              }
            } else if (isIterable2(stream) || isReadableNodeStream(stream) || isTransformStream(stream)) {
              ret = stream;
            } else {
              ret = Duplex.from(stream);
            }
          } else if (typeof stream === "function") {
            if (isTransformStream(ret)) {
              var _ret;
              ret = makeAsyncIterable((_ret = ret) === null || _ret === void 0 ? void 0 : _ret.readable);
            } else {
              ret = makeAsyncIterable(ret);
            }
            ret = stream(ret, {
              signal
            });
            if (reading) {
              if (!isIterable2(ret, true)) {
                throw new ERR_INVALID_RETURN_VALUE("AsyncIterable", `transform[${i2 - 1}]`, ret);
              }
            } else {
              var _ret2;
              if (!PassThrough) {
                PassThrough = require_passthrough();
              }
              const pt = new PassThrough({
                objectMode: true
              });
              const then = (_ret2 = ret) === null || _ret2 === void 0 ? void 0 : _ret2.then;
              if (typeof then === "function") {
                finishCount++;
                then.call(
                  ret,
                  (val) => {
                    value = val;
                    if (val != null) {
                      pt.write(val);
                    }
                    if (end) {
                      pt.end();
                    }
                    process2.nextTick(finish);
                  },
                  (err3) => {
                    pt.destroy(err3);
                    process2.nextTick(finish, err3);
                  }
                );
              } else if (isIterable2(ret, true)) {
                finishCount++;
                pumpToNode(ret, pt, finish, {
                  end
                });
              } else if (isReadableStream(ret) || isTransformStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                pumpToNode(toRead, pt, finish, {
                  end
                });
              } else {
                throw new ERR_INVALID_RETURN_VALUE("AsyncIterable or Promise", "destination", ret);
              }
              ret = pt;
              const { destroy, cleanup } = destroyer(ret, false, true);
              destroys.push(destroy);
              if (isLastStream) {
                lastStreamCleanup.push(cleanup);
              }
            }
          } else if (isNodeStream(stream)) {
            if (isReadableNodeStream(ret)) {
              finishCount += 2;
              const cleanup = pipe(ret, stream, finish, {
                end
              });
              if (isReadable(stream) && isLastStream) {
                lastStreamCleanup.push(cleanup);
              }
            } else if (isTransformStream(ret) || isReadableStream(ret)) {
              const toRead = ret.readable || ret;
              finishCount++;
              pumpToNode(toRead, stream, finish, {
                end
              });
            } else if (isIterable2(ret)) {
              finishCount++;
              pumpToNode(ret, stream, finish, {
                end
              });
            } else {
              throw new ERR_INVALID_ARG_TYPE(
                "val",
                ["Readable", "Iterable", "AsyncIterable", "ReadableStream", "TransformStream"],
                ret
              );
            }
            ret = stream;
          } else if (isWebStream(stream)) {
            if (isReadableNodeStream(ret)) {
              finishCount++;
              pumpToWeb(makeAsyncIterable(ret), stream, finish, {
                end
              });
            } else if (isReadableStream(ret) || isIterable2(ret)) {
              finishCount++;
              pumpToWeb(ret, stream, finish, {
                end
              });
            } else if (isTransformStream(ret)) {
              finishCount++;
              pumpToWeb(ret.readable, stream, finish, {
                end
              });
            } else {
              throw new ERR_INVALID_ARG_TYPE(
                "val",
                ["Readable", "Iterable", "AsyncIterable", "ReadableStream", "TransformStream"],
                ret
              );
            }
            ret = stream;
          } else {
            ret = Duplex.from(stream);
          }
        }
        if (signal !== null && signal !== void 0 && signal.aborted || outerSignal !== null && outerSignal !== void 0 && outerSignal.aborted) {
          process2.nextTick(abort);
        }
        return ret;
      }
      function pipe(src, dst, finish, { end }) {
        let ended = false;
        dst.on("close", () => {
          if (!ended) {
            finish(new ERR_STREAM_PREMATURE_CLOSE());
          }
        });
        src.pipe(dst, {
          end: false
        });
        if (end) {
          let endFn2 = function() {
            ended = true;
            dst.end();
          };
          var endFn = endFn2;
          if (isReadableFinished(src)) {
            process2.nextTick(endFn2);
          } else {
            src.once("end", endFn2);
          }
        } else {
          finish();
        }
        eos(
          src,
          {
            readable: true,
            writable: false
          },
          (err3) => {
            const rState = src._readableState;
            if (err3 && err3.code === "ERR_STREAM_PREMATURE_CLOSE" && rState && rState.ended && !rState.errored && !rState.errorEmitted) {
              src.once("end", finish).once("error", finish);
            } else {
              finish(err3);
            }
          }
        );
        return eos(
          dst,
          {
            readable: false,
            writable: true
          },
          finish
        );
      }
      module2.exports = {
        pipelineImpl,
        pipeline
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/compose.js
  var require_compose = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/compose.js"(exports2, module2) {
      "use strict";
      var { pipeline } = require_pipeline();
      var Duplex = require_duplex();
      var { destroyer } = require_destroy();
      var {
        isNodeStream,
        isReadable,
        isWritable,
        isWebStream,
        isTransformStream,
        isWritableStream,
        isReadableStream
      } = require_utils();
      var {
        AbortError,
        codes: { ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS }
      } = require_errors();
      var eos = require_end_of_stream();
      module2.exports = function compose(...streams) {
        if (streams.length === 0) {
          throw new ERR_MISSING_ARGS("streams");
        }
        if (streams.length === 1) {
          return Duplex.from(streams[0]);
        }
        const orgStreams = [...streams];
        if (typeof streams[0] === "function") {
          streams[0] = Duplex.from(streams[0]);
        }
        if (typeof streams[streams.length - 1] === "function") {
          const idx = streams.length - 1;
          streams[idx] = Duplex.from(streams[idx]);
        }
        for (let n2 = 0; n2 < streams.length; ++n2) {
          if (!isNodeStream(streams[n2]) && !isWebStream(streams[n2])) {
            continue;
          }
          if (n2 < streams.length - 1 && !(isReadable(streams[n2]) || isReadableStream(streams[n2]) || isTransformStream(streams[n2]))) {
            throw new ERR_INVALID_ARG_VALUE(`streams[${n2}]`, orgStreams[n2], "must be readable");
          }
          if (n2 > 0 && !(isWritable(streams[n2]) || isWritableStream(streams[n2]) || isTransformStream(streams[n2]))) {
            throw new ERR_INVALID_ARG_VALUE(`streams[${n2}]`, orgStreams[n2], "must be writable");
          }
        }
        let ondrain;
        let onfinish;
        let onreadable;
        let onclose;
        let d;
        function onfinished(err3) {
          const cb = onclose;
          onclose = null;
          if (cb) {
            cb(err3);
          } else if (err3) {
            d.destroy(err3);
          } else if (!readable && !writable) {
            d.destroy();
          }
        }
        const head = streams[0];
        const tail = pipeline(streams, onfinished);
        const writable = !!(isWritable(head) || isWritableStream(head) || isTransformStream(head));
        const readable = !!(isReadable(tail) || isReadableStream(tail) || isTransformStream(tail));
        d = new Duplex({
          // TODO (ronag): highWaterMark?
          writableObjectMode: !!(head !== null && head !== void 0 && head.writableObjectMode),
          readableObjectMode: !!(tail !== null && tail !== void 0 && tail.readableObjectMode),
          writable,
          readable
        });
        if (writable) {
          if (isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
              if (head.write(chunk, encoding)) {
                callback();
              } else {
                ondrain = callback;
              }
            };
            d._final = function(callback) {
              head.end();
              onfinish = callback;
            };
            head.on("drain", function() {
              if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
              }
            });
          } else if (isWebStream(head)) {
            const writable2 = isTransformStream(head) ? head.writable : head;
            const writer = writable2.getWriter();
            d._write = async function(chunk, encoding, callback) {
              try {
                await writer.ready;
                writer.write(chunk).catch(() => {
                });
                callback();
              } catch (err3) {
                callback(err3);
              }
            };
            d._final = async function(callback) {
              try {
                await writer.ready;
                writer.close().catch(() => {
                });
                onfinish = callback;
              } catch (err3) {
                callback(err3);
              }
            };
          }
          const toRead = isTransformStream(tail) ? tail.readable : tail;
          eos(toRead, () => {
            if (onfinish) {
              const cb = onfinish;
              onfinish = null;
              cb();
            }
          });
        }
        if (readable) {
          if (isNodeStream(tail)) {
            tail.on("readable", function() {
              if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
              }
            });
            tail.on("end", function() {
              d.push(null);
            });
            d._read = function() {
              while (true) {
                const buf = tail.read();
                if (buf === null) {
                  onreadable = d._read;
                  return;
                }
                if (!d.push(buf)) {
                  return;
                }
              }
            };
          } else if (isWebStream(tail)) {
            const readable2 = isTransformStream(tail) ? tail.readable : tail;
            const reader = readable2.getReader();
            d._read = async function() {
              while (true) {
                try {
                  const { value, done } = await reader.read();
                  if (!d.push(value)) {
                    return;
                  }
                  if (done) {
                    d.push(null);
                    return;
                  }
                } catch {
                  return;
                }
              }
            };
          }
        }
        d._destroy = function(err3, callback) {
          if (!err3 && onclose !== null) {
            err3 = new AbortError();
          }
          onreadable = null;
          ondrain = null;
          onfinish = null;
          if (onclose === null) {
            callback(err3);
          } else {
            onclose = callback;
            if (isNodeStream(tail)) {
              destroyer(tail, err3);
            }
          }
        };
        return d;
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/operators.js
  var require_operators = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/internal/streams/operators.js"(exports2, module2) {
      "use strict";
      var AbortController2 = globalThis.AbortController || require_browser().AbortController;
      var {
        codes: { ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS, ERR_OUT_OF_RANGE },
        AbortError
      } = require_errors();
      var { validateAbortSignal, validateInteger, validateObject: validateObject3 } = require_validators();
      var kWeakHandler = require_primordials().Symbol("kWeak");
      var kResistStopPropagation = require_primordials().Symbol("kResistStopPropagation");
      var { finished } = require_end_of_stream();
      var staticCompose = require_compose();
      var { addAbortSignalNoValidate } = require_add_abort_signal();
      var { isWritable, isNodeStream } = require_utils();
      var { deprecate } = require_util();
      var {
        ArrayPrototypePush,
        Boolean: Boolean2,
        MathFloor,
        Number: Number2,
        NumberIsNaN,
        Promise: Promise2,
        PromiseReject,
        PromiseResolve,
        PromisePrototypeThen,
        Symbol: Symbol2
      } = require_primordials();
      var kEmpty = Symbol2("kEmpty");
      var kEof = Symbol2("kEof");
      function compose(stream, options) {
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        if (isNodeStream(stream) && !isWritable(stream)) {
          throw new ERR_INVALID_ARG_VALUE("stream", stream, "must be writable");
        }
        const composedStream = staticCompose(this, stream);
        if (options !== null && options !== void 0 && options.signal) {
          addAbortSignalNoValidate(options.signal, composedStream);
        }
        return composedStream;
      }
      function map(fn, options) {
        if (typeof fn !== "function") {
          throw new ERR_INVALID_ARG_TYPE("fn", ["Function", "AsyncFunction"], fn);
        }
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        let concurrency = 1;
        if ((options === null || options === void 0 ? void 0 : options.concurrency) != null) {
          concurrency = MathFloor(options.concurrency);
        }
        let highWaterMark = concurrency - 1;
        if ((options === null || options === void 0 ? void 0 : options.highWaterMark) != null) {
          highWaterMark = MathFloor(options.highWaterMark);
        }
        validateInteger(concurrency, "options.concurrency", 1);
        validateInteger(highWaterMark, "options.highWaterMark", 0);
        highWaterMark += concurrency;
        return async function* map2() {
          const signal = require_util().AbortSignalAny(
            [options === null || options === void 0 ? void 0 : options.signal].filter(Boolean2)
          );
          const stream = this;
          const queue = [];
          const signalOpt = {
            signal
          };
          let next;
          let resume;
          let done = false;
          let cnt = 0;
          function onCatch() {
            done = true;
            afterItemProcessed();
          }
          function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
          }
          function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
              resume();
              resume = null;
            }
          }
          async function pump() {
            try {
              for await (let val of stream) {
                if (done) {
                  return;
                }
                if (signal.aborted) {
                  throw new AbortError();
                }
                try {
                  val = fn(val, signalOpt);
                  if (val === kEmpty) {
                    continue;
                  }
                  val = PromiseResolve(val);
                } catch (err3) {
                  val = PromiseReject(err3);
                }
                cnt += 1;
                PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
                if (next) {
                  next();
                  next = null;
                }
                if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) {
                  await new Promise2((resolve2) => {
                    resume = resolve2;
                  });
                }
              }
              queue.push(kEof);
            } catch (err3) {
              const val = PromiseReject(err3);
              PromisePrototypeThen(val, afterItemProcessed, onCatch);
              queue.push(val);
            } finally {
              done = true;
              if (next) {
                next();
                next = null;
              }
            }
          }
          pump();
          try {
            while (true) {
              while (queue.length > 0) {
                const val = await queue[0];
                if (val === kEof) {
                  return;
                }
                if (signal.aborted) {
                  throw new AbortError();
                }
                if (val !== kEmpty) {
                  yield val;
                }
                queue.shift();
                maybeResume();
              }
              await new Promise2((resolve2) => {
                next = resolve2;
              });
            }
          } finally {
            done = true;
            if (resume) {
              resume();
              resume = null;
            }
          }
        }.call(this);
      }
      function asIndexedPairs(options = void 0) {
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        return async function* asIndexedPairs2() {
          let index2 = 0;
          for await (const val of this) {
            var _options$signal;
            if (options !== null && options !== void 0 && (_options$signal = options.signal) !== null && _options$signal !== void 0 && _options$signal.aborted) {
              throw new AbortError({
                cause: options.signal.reason
              });
            }
            yield [index2++, val];
          }
        }.call(this);
      }
      async function some(fn, options = void 0) {
        for await (const unused of filter2.call(this, fn, options)) {
          return true;
        }
        return false;
      }
      async function every(fn, options = void 0) {
        if (typeof fn !== "function") {
          throw new ERR_INVALID_ARG_TYPE("fn", ["Function", "AsyncFunction"], fn);
        }
        return !await some.call(
          this,
          async (...args) => {
            return !await fn(...args);
          },
          options
        );
      }
      async function find(fn, options) {
        for await (const result of filter2.call(this, fn, options)) {
          return result;
        }
        return void 0;
      }
      async function forEach2(fn, options) {
        if (typeof fn !== "function") {
          throw new ERR_INVALID_ARG_TYPE("fn", ["Function", "AsyncFunction"], fn);
        }
        async function forEachFn(value, options2) {
          await fn(value, options2);
          return kEmpty;
        }
        for await (const unused of map.call(this, forEachFn, options)) ;
      }
      function filter2(fn, options) {
        if (typeof fn !== "function") {
          throw new ERR_INVALID_ARG_TYPE("fn", ["Function", "AsyncFunction"], fn);
        }
        async function filterFn(value, options2) {
          if (await fn(value, options2)) {
            return value;
          }
          return kEmpty;
        }
        return map.call(this, filterFn, options);
      }
      var ReduceAwareErrMissingArgs = class extends ERR_MISSING_ARGS {
        constructor() {
          super("reduce");
          this.message = "Reduce of an empty stream requires an initial value";
        }
      };
      async function reduce(reducer, initialValue, options) {
        var _options$signal2;
        if (typeof reducer !== "function") {
          throw new ERR_INVALID_ARG_TYPE("reducer", ["Function", "AsyncFunction"], reducer);
        }
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        let hasInitialValue = arguments.length > 1;
        if (options !== null && options !== void 0 && (_options$signal2 = options.signal) !== null && _options$signal2 !== void 0 && _options$signal2.aborted) {
          const err3 = new AbortError(void 0, {
            cause: options.signal.reason
          });
          this.once("error", () => {
          });
          await finished(this.destroy(err3));
          throw err3;
        }
        const ac = new AbortController2();
        const signal = ac.signal;
        if (options !== null && options !== void 0 && options.signal) {
          const opts = {
            once: true,
            [kWeakHandler]: this,
            [kResistStopPropagation]: true
          };
          options.signal.addEventListener("abort", () => ac.abort(), opts);
        }
        let gotAnyItemFromStream = false;
        try {
          for await (const value of this) {
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== void 0 && (_options$signal3 = options.signal) !== null && _options$signal3 !== void 0 && _options$signal3.aborted) {
              throw new AbortError();
            }
            if (!hasInitialValue) {
              initialValue = value;
              hasInitialValue = true;
            } else {
              initialValue = await reducer(initialValue, value, {
                signal
              });
            }
          }
          if (!gotAnyItemFromStream && !hasInitialValue) {
            throw new ReduceAwareErrMissingArgs();
          }
        } finally {
          ac.abort();
        }
        return initialValue;
      }
      async function toArray2(options) {
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        const result = [];
        for await (const val of this) {
          var _options$signal4;
          if (options !== null && options !== void 0 && (_options$signal4 = options.signal) !== null && _options$signal4 !== void 0 && _options$signal4.aborted) {
            throw new AbortError(void 0, {
              cause: options.signal.reason
            });
          }
          ArrayPrototypePush(result, val);
        }
        return result;
      }
      function flatMap(fn, options) {
        const values = map.call(this, fn, options);
        return async function* flatMap2() {
          for await (const val of values) {
            yield* val;
          }
        }.call(this);
      }
      function toIntegerOrInfinity(number2) {
        number2 = Number2(number2);
        if (NumberIsNaN(number2)) {
          return 0;
        }
        if (number2 < 0) {
          throw new ERR_OUT_OF_RANGE("number", ">= 0", number2);
        }
        return number2;
      }
      function drop(number2, options = void 0) {
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        number2 = toIntegerOrInfinity(number2);
        return async function* drop2() {
          var _options$signal5;
          if (options !== null && options !== void 0 && (_options$signal5 = options.signal) !== null && _options$signal5 !== void 0 && _options$signal5.aborted) {
            throw new AbortError();
          }
          for await (const val of this) {
            var _options$signal6;
            if (options !== null && options !== void 0 && (_options$signal6 = options.signal) !== null && _options$signal6 !== void 0 && _options$signal6.aborted) {
              throw new AbortError();
            }
            if (number2-- <= 0) {
              yield val;
            }
          }
        }.call(this);
      }
      function take(number2, options = void 0) {
        if (options != null) {
          validateObject3(options, "options");
        }
        if ((options === null || options === void 0 ? void 0 : options.signal) != null) {
          validateAbortSignal(options.signal, "options.signal");
        }
        number2 = toIntegerOrInfinity(number2);
        return async function* take2() {
          var _options$signal7;
          if (options !== null && options !== void 0 && (_options$signal7 = options.signal) !== null && _options$signal7 !== void 0 && _options$signal7.aborted) {
            throw new AbortError();
          }
          for await (const val of this) {
            var _options$signal8;
            if (options !== null && options !== void 0 && (_options$signal8 = options.signal) !== null && _options$signal8 !== void 0 && _options$signal8.aborted) {
              throw new AbortError();
            }
            if (number2-- > 0) {
              yield val;
            }
            if (number2 <= 0) {
              return;
            }
          }
        }.call(this);
      }
      module2.exports.streamReturningOperators = {
        asIndexedPairs: deprecate(asIndexedPairs, "readable.asIndexedPairs will be removed in a future version."),
        drop,
        filter: filter2,
        flatMap,
        map,
        take,
        compose
      };
      module2.exports.promiseReturningOperators = {
        every,
        forEach: forEach2,
        reduce,
        toArray: toArray2,
        some,
        find
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/stream/promises.js
  var require_promises = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/stream/promises.js"(exports2, module2) {
      "use strict";
      var { ArrayPrototypePop, Promise: Promise2 } = require_primordials();
      var { isIterable: isIterable2, isNodeStream, isWebStream } = require_utils();
      var { pipelineImpl: pl } = require_pipeline();
      var { finished } = require_end_of_stream();
      require_stream();
      function pipeline(...streams) {
        return new Promise2((resolve2, reject) => {
          let signal;
          let end;
          const lastArg = streams[streams.length - 1];
          if (lastArg && typeof lastArg === "object" && !isNodeStream(lastArg) && !isIterable2(lastArg) && !isWebStream(lastArg)) {
            const options = ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
          }
          pl(
            streams,
            (err3, value) => {
              if (err3) {
                reject(err3);
              } else {
                resolve2(value);
              }
            },
            {
              signal,
              end
            }
          );
        });
      }
      module2.exports = {
        finished,
        pipeline
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/stream.js
  var require_stream = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/stream.js"(exports2, module2) {
      "use strict";
      var { Buffer: Buffer7 } = require_buffer();
      var { ObjectDefineProperty, ObjectKeys, ReflectApply } = require_primordials();
      var {
        promisify: { custom: customPromisify }
      } = require_util();
      var { streamReturningOperators, promiseReturningOperators } = require_operators();
      var {
        codes: { ERR_ILLEGAL_CONSTRUCTOR }
      } = require_errors();
      var compose = require_compose();
      var { setDefaultHighWaterMark, getDefaultHighWaterMark } = require_state();
      var { pipeline } = require_pipeline();
      var { destroyer } = require_destroy();
      var eos = require_end_of_stream();
      var promises = require_promises();
      var utils = require_utils();
      var Stream = module2.exports = require_legacy().Stream;
      Stream.isDestroyed = utils.isDestroyed;
      Stream.isDisturbed = utils.isDisturbed;
      Stream.isErrored = utils.isErrored;
      Stream.isReadable = utils.isReadable;
      Stream.isWritable = utils.isWritable;
      Stream.Readable = require_readable();
      for (const key of ObjectKeys(streamReturningOperators)) {
        let fn = function(...args) {
          if (new.target) {
            throw ERR_ILLEGAL_CONSTRUCTOR();
          }
          return Stream.Readable.from(ReflectApply(op, this, args));
        };
        const op = streamReturningOperators[key];
        ObjectDefineProperty(fn, "name", {
          __proto__: null,
          value: op.name
        });
        ObjectDefineProperty(fn, "length", {
          __proto__: null,
          value: op.length
        });
        ObjectDefineProperty(Stream.Readable.prototype, key, {
          __proto__: null,
          value: fn,
          enumerable: false,
          configurable: true,
          writable: true
        });
      }
      for (const key of ObjectKeys(promiseReturningOperators)) {
        let fn = function(...args) {
          if (new.target) {
            throw ERR_ILLEGAL_CONSTRUCTOR();
          }
          return ReflectApply(op, this, args);
        };
        const op = promiseReturningOperators[key];
        ObjectDefineProperty(fn, "name", {
          __proto__: null,
          value: op.name
        });
        ObjectDefineProperty(fn, "length", {
          __proto__: null,
          value: op.length
        });
        ObjectDefineProperty(Stream.Readable.prototype, key, {
          __proto__: null,
          value: fn,
          enumerable: false,
          configurable: true,
          writable: true
        });
      }
      Stream.Writable = require_writable();
      Stream.Duplex = require_duplex();
      Stream.Transform = require_transform();
      Stream.PassThrough = require_passthrough();
      Stream.pipeline = pipeline;
      var { addAbortSignal } = require_add_abort_signal();
      Stream.addAbortSignal = addAbortSignal;
      Stream.finished = eos;
      Stream.destroy = destroyer;
      Stream.compose = compose;
      Stream.setDefaultHighWaterMark = setDefaultHighWaterMark;
      Stream.getDefaultHighWaterMark = getDefaultHighWaterMark;
      ObjectDefineProperty(Stream, "promises", {
        __proto__: null,
        configurable: true,
        enumerable: true,
        get() {
          return promises;
        }
      });
      ObjectDefineProperty(pipeline, customPromisify, {
        __proto__: null,
        enumerable: true,
        get() {
          return promises.pipeline;
        }
      });
      ObjectDefineProperty(eos, customPromisify, {
        __proto__: null,
        enumerable: true,
        get() {
          return promises.finished;
        }
      });
      Stream.Stream = Stream;
      Stream._isUint8Array = function isUint8Array(value) {
        return value instanceof Uint8Array;
      };
      Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
        return Buffer7.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
      };
    }
  });

  // ../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/browser.js
  var require_browser3 = __commonJS({
    "../../node_modules/.pnpm/readable-stream@4.7.0/node_modules/readable-stream/lib/ours/browser.js"(exports2, module2) {
      "use strict";
      var CustomStream = require_stream();
      var promises = require_promises();
      var originalDestroy = CustomStream.Readable.destroy;
      module2.exports = CustomStream.Readable;
      module2.exports._uint8ArrayToBuffer = CustomStream._uint8ArrayToBuffer;
      module2.exports._isUint8Array = CustomStream._isUint8Array;
      module2.exports.isDisturbed = CustomStream.isDisturbed;
      module2.exports.isErrored = CustomStream.isErrored;
      module2.exports.isReadable = CustomStream.isReadable;
      module2.exports.Readable = CustomStream.Readable;
      module2.exports.Writable = CustomStream.Writable;
      module2.exports.Duplex = CustomStream.Duplex;
      module2.exports.Transform = CustomStream.Transform;
      module2.exports.PassThrough = CustomStream.PassThrough;
      module2.exports.addAbortSignal = CustomStream.addAbortSignal;
      module2.exports.finished = CustomStream.finished;
      module2.exports.destroy = CustomStream.destroy;
      module2.exports.destroy = originalDestroy;
      module2.exports.pipeline = CustomStream.pipeline;
      module2.exports.compose = CustomStream.compose;
      Object.defineProperty(CustomStream, "promises", {
        configurable: true,
        enumerable: true,
        get() {
          return promises;
        }
      });
      module2.exports.Stream = CustomStream.Stream;
      module2.exports.default = module2.exports;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/streams.js
  var import_readable_stream, ReadStream, WriteStream;
  var init_streams = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/streams.js"() {
      init_dist2();
      init_log();
      import_readable_stream = __toESM(require_browser3(), 1);
      ReadStream = class extends import_readable_stream.Readable {
        constructor(opts = {}, handleOrPromise) {
          var _a6;
          super({ ...opts, encoding: (_a6 = opts.encoding) !== null && _a6 !== void 0 ? _a6 : void 0 });
          this.pending = true;
          this._path = "<unknown>";
          this._bytesRead = 0;
          this.ready = Promise.resolve(handleOrPromise).then((handle) => {
            this._path = handle.path;
            const internal = handle.readableWebStream({ start: opts.start, end: opts.end });
            this.reader = internal.getReader();
            this.pending = false;
          }).catch((err3) => {
            this.destroy(err3);
          });
        }
        async _read() {
          try {
            await this.ready;
            if (!this.reader)
              return;
            const { done, value } = await this.reader.read();
            if (done) {
              this.push(null);
              return;
            }
            this._bytesRead += value.byteLength;
            this.push(value);
          } catch (err3) {
            this.destroy(new Exception(Errno.EIO, err3.toString()));
          }
        }
        close(callback = () => null) {
          try {
            this.destroy();
            this.emit("close");
            callback(null);
          } catch (err3) {
            callback(new Exception(Errno.EIO, err3.toString()));
          }
        }
        get path() {
          return this._path;
        }
        get bytesRead() {
          return this._bytesRead;
        }
        wrap(oldStream) {
          super.wrap(oldStream);
          return this;
        }
      };
      WriteStream = class extends import_readable_stream.Writable {
        constructor(opts = {}, handleOrPromise) {
          super(opts);
          this.pending = true;
          this._path = "<unknown>";
          this._bytesWritten = 0;
          this.ready = Promise.resolve(handleOrPromise).then((handle) => {
            this._path = handle.path;
            const internal = handle.writableWebStream({ start: opts.start });
            this.writer = internal.getWriter();
            this.pending = false;
          }).catch((err3) => this.destroy(err3));
        }
        async _write(chunk, encoding, callback) {
          await this.ready;
          if (!this.writer)
            return callback(warn(UV("EAGAIN", "write", this._path)));
          if (encoding != "buffer")
            return callback(warn(UV("ENOTSUP", "write", this._path)));
          const data = new Uint8Array(chunk.buffer, chunk.byteOffset, chunk.byteLength);
          try {
            await this.writer.write(data);
            this._bytesWritten += chunk.byteLength;
            callback();
          } catch (error) {
            callback(new Exception(Errno.EIO, error.toString()));
          }
        }
        async _final(callback) {
          await this.ready;
          if (!this.writer)
            return callback();
          try {
            await this.writer.close();
            callback();
          } catch (error) {
            callback(new Exception(Errno.EIO, error.toString()));
          }
        }
        close(callback = () => null) {
          try {
            this.destroy();
            this.emit("close");
            callback(null);
          } catch (error) {
            callback(new Exception(Errno.EIO, error.toString()));
          }
        }
        get path() {
          return this._path;
        }
        get bytesWritten() {
          return this._bytesWritten;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/promises.js
  var promises_exports = {};
  __export(promises_exports, {
    FileHandle: () => FileHandle,
    access: () => access,
    appendFile: () => appendFile,
    chmod: () => chmod,
    chown: () => chown,
    constants: () => constants_exports,
    copyFile: () => copyFile,
    cp: () => cp,
    exists: () => exists,
    glob: () => glob,
    lchmod: () => lchmod,
    lchown: () => lchown,
    link: () => link,
    lstat: () => lstat,
    lutimes: () => lutimes,
    mkdir: () => mkdir,
    mkdtemp: () => mkdtemp,
    open: () => open,
    opendir: () => opendir,
    readFile: () => readFile,
    readdir: () => readdir,
    readlink: () => readlink,
    realpath: () => realpath,
    rename: () => rename,
    rm: () => rm,
    rmdir: () => rmdir,
    stat: () => stat,
    statfs: () => statfs,
    symlink: () => symlink,
    truncate: () => truncate,
    unlink: () => unlink,
    utimes: () => utimes,
    watch: () => watch,
    writeFile: () => writeFile
  });
  async function rename(oldPath, newPath) {
    oldPath = normalizePath(oldPath);
    __assertType(oldPath);
    newPath = normalizePath(newPath);
    __assertType(newPath);
    const $ex = { syscall: "rename", path: oldPath, dest: newPath };
    const src = resolveMount(oldPath, this);
    const dst = resolveMount(newPath, this);
    if (src.fs !== dst.fs)
      throw UV("EXDEV", $ex);
    if (dst.path.startsWith(src.path + "/"))
      throw UV("EBUSY", $ex);
    const parent = await stat.call(this, dirname(oldPath)).catch(rethrow($ex));
    const stats = await stat.call(this, oldPath).catch(rethrow($ex));
    const newParent = await stat.call(this, dirname(newPath)).catch(rethrow($ex));
    const newStats = await stat.call(this, newPath).catch((e2) => {
      if (e2.code == "ENOENT")
        return null;
      throw setUVMessage(Object.assign(e2, $ex));
    });
    if (checkAccess && (!parent.hasAccess(R_OK, this) || !newParent.hasAccess(W_OK, this)))
      throw UV("EACCES", $ex);
    if (newStats && !isDirectory(stats) && isDirectory(newStats))
      throw UV("EISDIR", $ex);
    if (newStats && isDirectory(stats) && !isDirectory(newStats))
      throw UV("ENOTDIR", $ex);
    await src.fs.rename(src.path, dst.path).catch(rethrow($ex));
    emitChange(this, "rename", oldPath);
    emitChange(this, "change", newPath);
  }
  async function exists(path3) {
    try {
      const { fs: fs2, path: resolved } = resolveMount(await realpath.call(this, path3), this);
      return await fs2.exists(resolved);
    } catch (e2) {
      if (e2 instanceof Exception && e2.code == "ENOENT") {
        return false;
      }
      throw e2;
    }
  }
  async function stat(path3, options) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(await realpath.call(this, path3), this);
    const $ex = { syscall: "stat", path: path3 };
    const stats = await fs2.stat(resolved).catch(rethrow($ex));
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", $ex);
    return (options === null || options === void 0 ? void 0 : options.bigint) ? new BigIntStats(stats) : new Stats(stats);
  }
  async function lstat(path3, options) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const $ex = { syscall: "lstat", path: path3 };
    const stats = await fs2.stat(resolved).catch(rethrow($ex));
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", $ex);
    return (options === null || options === void 0 ? void 0 : options.bigint) ? new BigIntStats(stats) : new Stats(stats);
  }
  async function truncate(path3, len = 0) {
    const env_1 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_1, await open.call(this, path3, "r+"), true);
      await handle.truncate(len);
    } catch (e_1) {
      env_1.error = e_1;
      env_1.hasError = true;
    } finally {
      const result_1 = __disposeResources3(env_1);
      if (result_1)
        await result_1;
    }
  }
  async function unlink(path3) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const $ex = { syscall: "unlink", path: path3 };
    const stats = await fs2.stat(resolved).catch(rethrow($ex));
    if (checkAccess && !hasAccess(this, stats, W_OK))
      throw UV("EACCES", $ex);
    await fs2.unlink(resolved).catch(rethrow($ex));
    emitChange(this, "rename", path3.toString());
  }
  async function _open($, path3, opt) {
    var _a6;
    path3 = normalizePath(path3);
    const mode = normalizeMode(opt.mode, 420), flag = parse2(opt.flag);
    const $ex = { syscall: "open", path: path3 };
    const { fs: fs2, path: resolved, stats } = await _resolve($, path3.toString(), opt.preserveSymlinks);
    if (!stats) {
      if (!(flag & O_CREAT))
        throw UV("ENOENT", $ex);
      const parentStats = await fs2.stat(dirname(resolved));
      if (checkAccess && !hasAccess($, parentStats, W_OK))
        throw UV("EACCES", "open", dirname(path3));
      if (!isDirectory(parentStats))
        throw UV("ENOTDIR", "open", dirname(path3));
      if (!opt.allowDirectory && mode & S_IFDIR)
        throw UV("EISDIR", "open", path3);
      const { euid: uid, egid: gid } = (_a6 = $ === null || $ === void 0 ? void 0 : $.credentials) !== null && _a6 !== void 0 ? _a6 : defaultContext.credentials;
      const inode = await fs2.createFile(resolved, {
        mode,
        uid: parentStats.mode & S_ISUID ? parentStats.uid : uid,
        gid: parentStats.mode & S_ISGID ? parentStats.gid : gid
      });
      return new FileHandle($, toFD(new SyncHandle($, path3, fs2, resolved, flag, inode)));
    }
    if (checkAccess && !hasAccess($, stats, toMode(flag)))
      throw UV("EACCES", $ex);
    if (flag & O_EXCL)
      throw UV("EEXIST", $ex);
    const handle = new FileHandle($, toFD(new SyncHandle($, path3, fs2, resolved, flag, stats)));
    if (!opt.allowDirectory && mode & S_IFDIR)
      throw UV("EISDIR", "open", path3);
    if (flag & O_TRUNC)
      await handle.truncate(0);
    return handle;
  }
  async function open(path3, flag = "r", mode = 420) {
    return await _open(this, path3, { flag, mode });
  }
  async function readFile(path3, _options) {
    const env_2 = { stack: [], error: void 0, hasError: false };
    try {
      const options = normalizeOptions(_options, null, "r", 292);
      const handle = __addDisposableResource3(env_2, typeof path3 == "object" && "fd" in path3 ? path3 : await open.call(this, path3, options.flag, options.mode), true);
      return await handle.readFile(options);
    } catch (e_2) {
      env_2.error = e_2;
      env_2.hasError = true;
    } finally {
      const result_2 = __disposeResources3(env_2);
      if (result_2)
        await result_2;
    }
  }
  async function writeFile(path3, data, _options) {
    const env_3 = { stack: [], error: void 0, hasError: false };
    try {
      const options = normalizeOptions(_options, "utf8", "w+", 420);
      const handle = __addDisposableResource3(env_3, path3 instanceof FileHandle ? path3 : await open.call(this, path3.toString(), options.flag, options.mode), true);
      const _data = typeof data == "string" ? data : data instanceof DataView ? new Uint8Array(data.buffer, data.byteOffset, data.byteLength) : data;
      if (typeof _data != "string" && !(_data instanceof Uint8Array))
        throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView. Received ' + typeof data);
      await handle.writeFile(_data, options);
    } catch (e_3) {
      env_3.error = e_3;
      env_3.hasError = true;
    } finally {
      const result_3 = __disposeResources3(env_3);
      if (result_3)
        await result_3;
    }
  }
  async function appendFile(path3, data, _options) {
    const env_4 = { stack: [], error: void 0, hasError: false };
    try {
      const options = normalizeOptions(_options, "utf8", "a", 420);
      const flag = parse2(options.flag);
      const $ex = { syscall: "write", path: path3 instanceof FileHandle ? path3.path : path3.toString() };
      if (!(flag & O_APPEND))
        throw UV("EBADF", $ex);
      const encodedData = typeof data == "string" ? import_buffer5.Buffer.from(data, options.encoding) : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
      const handle = __addDisposableResource3(env_4, typeof path3 == "object" && "fd" in path3 ? path3 : await open.call(this, path3, options.flag, options.mode), true);
      await handle.appendFile(encodedData, options);
    } catch (e_4) {
      env_4.error = e_4;
      env_4.hasError = true;
    } finally {
      const result_4 = __disposeResources3(env_4);
      if (result_4)
        await result_4;
    }
  }
  async function rmdir(path3) {
    path3 = await realpath.call(this, path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const $ex = { syscall: "rmdir", path: path3 };
    const stats = await fs2.stat(resolved).catch(rethrow($ex));
    if (!stats)
      throw UV("ENOENT", $ex);
    if (!isDirectory(stats))
      throw UV("ENOTDIR", $ex);
    if (checkAccess && !hasAccess(this, stats, W_OK))
      throw UV("EACCES", $ex);
    await fs2.rmdir(resolved).catch(rethrow($ex));
    emitChange(this, "rename", path3.toString());
  }
  async function mkdir(path3, options) {
    var _a6;
    const { euid: uid, egid: gid } = (_a6 = this === null || this === void 0 ? void 0 : this.credentials) !== null && _a6 !== void 0 ? _a6 : defaultContext.credentials;
    options = typeof options === "object" ? options : { mode: options };
    const mode = normalizeMode(options === null || options === void 0 ? void 0 : options.mode, 511);
    path3 = await realpath.call(this, path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const __create2 = async (path4, resolved2, parent) => {
      if (checkAccess && !hasAccess(this, parent, W_OK))
        throw UV("EACCES", "mkdir", dirname(path4));
      const inode = await fs2.mkdir(resolved2, {
        mode,
        uid: parent.mode & S_ISUID ? parent.uid : uid,
        gid: parent.mode & S_ISGID ? parent.gid : gid
      }).catch(rethrow({ syscall: "mkdir", path: path4 }));
      emitChange(this, "rename", path4);
      return inode;
    };
    if (!(options === null || options === void 0 ? void 0 : options.recursive)) {
      await __create2(path3, resolved, await fs2.stat(dirname(resolved)).catch(rethrow({ path: dirname(path3) })));
      return;
    }
    const dirs = [];
    let origDir = path3;
    for (let dir = resolved; !await fs2.exists(dir).catch(rethrow({ syscall: "exists", path: origDir })); dir = dirname(dir), origDir = dirname(origDir)) {
      dirs.unshift([origDir, dir]);
    }
    if (!dirs.length)
      return;
    const stats = [await fs2.stat(dirname(dirs[0][1])).catch(rethrow({ syscall: "stat", path: dirname(dirs[0][0]) }))];
    for (const [i2, [path4, resolved2]] of dirs.entries()) {
      stats.push(await __create2(path4, resolved2, stats[i2]));
    }
    return dirs[0][0];
  }
  async function readdir(path3, options) {
    options = typeof options === "object" ? options : { encoding: options };
    path3 = await realpath.call(this, path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const $ex = { syscall: "readdir", path: path3 };
    const stats = await fs2.stat(resolved).catch(rethrow({ syscall: "stat", path: path3 }));
    if (!stats)
      throw UV("ENOENT", $ex);
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", $ex);
    if (!isDirectory(stats))
      throw UV("ENOTDIR", $ex);
    const entries2 = await fs2.readdir(resolved).catch(rethrow($ex));
    const values = [];
    const addEntry = async (entry) => {
      let entryStats;
      if ((options === null || options === void 0 ? void 0 : options.recursive) || (options === null || options === void 0 ? void 0 : options.withFileTypes)) {
        entryStats = await fs2.stat(join(resolved, entry)).catch((e2) => {
          if (e2.code == "ENOENT")
            return;
          throw setUVMessage(Object.assign(e2, { syscall: "stat", path: join(path3, entry) }));
        });
        if (!entryStats)
          return;
      }
      if (options === null || options === void 0 ? void 0 : options.withFileTypes) {
        values.push(new Dirent(entry, entryStats));
      } else if ((options === null || options === void 0 ? void 0 : options.encoding) == "buffer") {
        values.push(import_buffer5.Buffer.from(entry));
      } else {
        values.push(entry);
      }
      if (!(options === null || options === void 0 ? void 0 : options.recursive) || !isDirectory(entryStats))
        return;
      for (const subEntry of await readdir.call(this, join(path3, entry), options)) {
        if (subEntry instanceof Dirent) {
          subEntry.path = join(entry, subEntry.path);
          values.push(subEntry);
        } else if (import_buffer5.Buffer.isBuffer(subEntry)) {
          values.push(import_buffer5.Buffer.from(join(entry, decodeUTF8(subEntry))));
        } else {
          values.push(join(entry, subEntry));
        }
      }
    };
    await Promise.all(entries2.map(addEntry));
    return values;
  }
  async function link(path3, dest) {
    path3 = normalizePath(path3);
    dest = normalizePath(dest);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const dst = resolveMount(dest, this);
    const $ex = { syscall: "link", path: path3 };
    if (fs2 != dst.fs)
      throw UV("EXDEV", $ex);
    const stats = await fs2.stat(dirname(resolved)).catch(rethrow({ syscall: "stat", path: dirname(path3) }));
    if (checkAccess && !hasAccess(this, stats, R_OK))
      throw UV("EACCES", "link", dirname(path3));
    if (checkAccess && !(await stat.call(this, dirname(dest))).hasAccess(W_OK, this))
      throw UV("EACCES", "link", dirname(dest));
    if (checkAccess && !hasAccess(this, await fs2.stat(resolved).catch(rethrow($ex)), R_OK))
      throw UV("EACCES", $ex);
    return await fs2.link(resolved, dst.path).catch(rethrow($ex));
  }
  async function symlink(dest, path3, type = "file") {
    const env_5 = { stack: [], error: void 0, hasError: false };
    try {
      if (!["file", "dir", "junction"].includes(type))
        throw new TypeError("Invalid symlink type: " + type);
      path3 = normalizePath(path3);
      if (await exists.call(this, path3))
        throw UV("EEXIST", "symlink", path3);
      const handle = __addDisposableResource3(env_5, await _open(this, path3, { flag: "w+", mode: 420, preserveSymlinks: true }), true);
      await handle.writeFile(normalizePath(dest, true));
      await handle.chmod(S_IFLNK);
    } catch (e_5) {
      env_5.error = e_5;
      env_5.hasError = true;
    } finally {
      const result_5 = __disposeResources3(env_5);
      if (result_5)
        await result_5;
    }
  }
  async function readlink(path3, options) {
    const env_6 = { stack: [], error: void 0, hasError: false };
    try {
      path3 = normalizePath(path3);
      __assertType(path3);
      const handle = __addDisposableResource3(env_6, await _open(this, path3, { flag: "r", mode: 420, preserveSymlinks: true }), true);
      if (!isSymbolicLink(handle.inode))
        throw UV("EINVAL", "readlink", path3);
      const value = await handle.readFile();
      const encoding = typeof options == "object" ? options === null || options === void 0 ? void 0 : options.encoding : options;
      return encoding == "buffer" ? value : value.toString(encoding !== null && encoding !== void 0 ? encoding : "utf-8");
    } catch (e_6) {
      env_6.error = e_6;
      env_6.hasError = true;
    } finally {
      const result_6 = __disposeResources3(env_6);
      if (result_6)
        await result_6;
    }
  }
  async function chown(path3, uid, gid) {
    const env_7 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_7, await open.call(this, path3, "r+"), true);
      await handle.chown(uid, gid);
    } catch (e_7) {
      env_7.error = e_7;
      env_7.hasError = true;
    } finally {
      const result_7 = __disposeResources3(env_7);
      if (result_7)
        await result_7;
    }
  }
  async function lchown(path3, uid, gid) {
    const env_8 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_8, await _open(this, path3, {
        flag: "r+",
        mode: 420,
        preserveSymlinks: true,
        allowDirectory: true
      }), true);
      await handle.chown(uid, gid);
    } catch (e_8) {
      env_8.error = e_8;
      env_8.hasError = true;
    } finally {
      const result_8 = __disposeResources3(env_8);
      if (result_8)
        await result_8;
    }
  }
  async function chmod(path3, mode) {
    const env_9 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_9, await open.call(this, path3, "r+"), true);
      await handle.chmod(mode);
    } catch (e_9) {
      env_9.error = e_9;
      env_9.hasError = true;
    } finally {
      const result_9 = __disposeResources3(env_9);
      if (result_9)
        await result_9;
    }
  }
  async function lchmod(path3, mode) {
    const env_10 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_10, await _open(this, path3, {
        flag: "r+",
        mode: 420,
        preserveSymlinks: true,
        allowDirectory: true
      }), true);
      await handle.chmod(mode);
    } catch (e_10) {
      env_10.error = e_10;
      env_10.hasError = true;
    } finally {
      const result_10 = __disposeResources3(env_10);
      if (result_10)
        await result_10;
    }
  }
  async function utimes(path3, atime, mtime) {
    const env_11 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_11, await open.call(this, path3, "r+"), true);
      await handle.utimes(atime, mtime);
    } catch (e_11) {
      env_11.error = e_11;
      env_11.hasError = true;
    } finally {
      const result_11 = __disposeResources3(env_11);
      if (result_11)
        await result_11;
    }
  }
  async function lutimes(path3, atime, mtime) {
    const env_12 = { stack: [], error: void 0, hasError: false };
    try {
      const handle = __addDisposableResource3(env_12, await _open(this, path3, {
        flag: "r+",
        mode: 420,
        preserveSymlinks: true,
        allowDirectory: true
      }), true);
      await handle.utimes(new Date(atime), new Date(mtime));
    } catch (e_12) {
      env_12.error = e_12;
      env_12.hasError = true;
    } finally {
      const result_12 = __disposeResources3(env_12);
      if (result_12)
        await result_12;
    }
  }
  async function _resolve($, path3, preserveSymlinks) {
    if (preserveSymlinks) {
      const resolved2 = resolveMount(path3, $);
      const stats2 = await resolved2.fs.stat(resolved2.path).catch(() => void 0);
      return { ...resolved2, fullPath: path3, stats: stats2 };
    }
    try {
      const resolved2 = resolveMount(path3, $);
      const stats2 = await resolved2.fs.stat(resolved2.path);
      if (!isSymbolicLink(stats2)) {
        return { ...resolved2, fullPath: path3, stats: stats2 };
      }
      const target2 = resolve.call($, dirname(path3), (await readlink.call($, path3)).toString());
      return await _resolve($, target2);
    } catch {
    }
    const { base: base2, dir } = parse(path3);
    const realDir = dir == "/" ? "/" : await realpath.call($, dir);
    const maybePath = join(realDir, base2);
    const resolved = resolveMount(maybePath, $);
    const stats = await resolved.fs.stat(resolved.path).catch((e2) => {
      if (e2.code == "ENOENT")
        return;
      throw setUVMessage(Object.assign(e2, { syscall: "stat", path: maybePath }));
    });
    if (!stats)
      return { ...resolved, fullPath: path3 };
    if (!isSymbolicLink(stats)) {
      return { ...resolved, fullPath: maybePath, stats };
    }
    const target = resolve.call($, realDir, (await readlink.call($, maybePath)).toString());
    return await _resolve($, target);
  }
  async function realpath(path3, options) {
    var _a6;
    const encoding = typeof options == "string" ? options : (_a6 = options === null || options === void 0 ? void 0 : options.encoding) !== null && _a6 !== void 0 ? _a6 : "utf8";
    path3 = normalizePath(path3);
    const { fullPath } = await _resolve(this, path3);
    if (encoding == "utf8" || encoding == "utf-8")
      return fullPath;
    const buf = import_buffer5.Buffer.from(fullPath, "utf-8");
    if (encoding == "buffer")
      return buf;
    return buf.toString(encoding);
  }
  function watch(filename, options = {}) {
    const watcher = new FSWatcher(this, filename.toString(), typeof options !== "string" ? options : { encoding: options });
    const eventQueue = [];
    let done = false;
    watcher.on("change", (eventType, filename2) => {
      var _a6;
      (_a6 = eventQueue.shift()) === null || _a6 === void 0 ? void 0 : _a6({ value: { eventType, filename: filename2 }, done: false });
    });
    function cleanup() {
      done = true;
      watcher.close();
      for (const resolve2 of eventQueue) {
        resolve2({ value: null, done });
      }
      eventQueue.length = 0;
      return Promise.resolve({ value: null, done: true });
    }
    return {
      async next() {
        if (done)
          return Promise.resolve({ value: null, done });
        const { promise, resolve: resolve2 } = Promise.withResolvers();
        eventQueue.push(resolve2);
        return promise;
      },
      return: cleanup,
      throw: cleanup,
      async [Symbol.asyncDispose]() {
        await cleanup();
      },
      [Symbol.asyncIterator]() {
        return this;
      }
    };
  }
  async function access(path3, mode = F_OK) {
    if (!checkAccess)
      return;
    const stats = await stat.call(this, path3);
    if (!stats.hasAccess(mode, this))
      throw UV("EACCES", "access", path3.toString());
  }
  async function rm(path3, options) {
    path3 = normalizePath(path3);
    const stats = await lstat.call(this, path3).catch((error) => {
      if (error.code == "ENOENT" && (options === null || options === void 0 ? void 0 : options.force))
        return void 0;
      throw error;
    });
    if (!stats)
      return;
    switch (stats.mode & S_IFMT) {
      case S_IFDIR:
        if (options === null || options === void 0 ? void 0 : options.recursive) {
          for (const entry of await readdir.call(this, path3)) {
            await rm.call(this, join(path3, entry), options);
          }
        }
        await rmdir.call(this, path3);
        break;
      case S_IFREG:
      case S_IFLNK:
      case S_IFBLK:
      case S_IFCHR:
        await unlink.call(this, path3);
        break;
      case S_IFIFO:
      case S_IFSOCK:
      default:
        throw UV("ENOSYS", "rm", path3);
    }
  }
  async function mkdtemp(prefix, options) {
    const encoding = typeof options === "object" ? options === null || options === void 0 ? void 0 : options.encoding : options || "utf8";
    const fsName = `${prefix}${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const resolvedPath = "/tmp/" + fsName;
    await mkdir.call(this, resolvedPath);
    return encoding == "buffer" ? import_buffer5.Buffer.from(resolvedPath) : resolvedPath;
  }
  async function copyFile(src, dest, mode) {
    src = normalizePath(src);
    dest = normalizePath(dest);
    if (mode && mode & COPYFILE_EXCL && await exists.call(this, dest))
      throw UV("EEXIST", "copyFile", dest);
    await writeFile.call(this, dest, await readFile.call(this, src));
    emitChange(this, "rename", dest.toString());
  }
  function opendir(path3, options) {
    path3 = normalizePath(path3);
    return Promise.resolve(new Dir(path3, this));
  }
  async function cp(source, destination, opts) {
    source = normalizePath(source);
    destination = normalizePath(destination);
    const srcStats = await lstat.call(this, source);
    if ((opts === null || opts === void 0 ? void 0 : opts.errorOnExist) && await exists.call(this, destination))
      throw UV("EEXIST", "cp", destination);
    switch (srcStats.mode & S_IFMT) {
      case S_IFDIR: {
        if (!(opts === null || opts === void 0 ? void 0 : opts.recursive))
          throw UV("EISDIR", "cp", source);
        const [entries2] = await Promise.all(
          [
            readdir.call(this, source, { withFileTypes: true }),
            mkdir.call(this, destination, { recursive: true })
          ]
          // Ensure the destination directory exists
        );
        const _cp = async (dirent) => {
          if (opts.filter && !opts.filter(join(source, dirent.name), join(destination, dirent.name))) {
            return;
          }
          await cp.call(this, join(source, dirent.name), join(destination, dirent.name), opts);
        };
        await Promise.all(entries2.map(_cp));
        break;
      }
      case S_IFREG:
      case S_IFLNK:
        await copyFile.call(this, source, destination);
        break;
      case S_IFBLK:
      case S_IFCHR:
      case S_IFIFO:
      case S_IFSOCK:
      default:
        throw UV("ENOSYS", "cp", source);
    }
    if (opts === null || opts === void 0 ? void 0 : opts.preserveTimestamps) {
      await utimes.call(this, destination, srcStats.atime, srcStats.mtime);
    }
  }
  async function statfs(path3, opts) {
    path3 = normalizePath(path3);
    const { fs: fs2 } = resolveMount(path3, this);
    return Promise.resolve(_statfs(fs2, opts === null || opts === void 0 ? void 0 : opts.bigint));
  }
  function glob(pattern2, opt) {
    pattern2 = Array.isArray(pattern2) ? pattern2 : [pattern2];
    const { cwd = "/", withFileTypes = false, exclude = () => false } = opt || {};
    const regexPatterns = pattern2.map(globToRegex);
    async function* recursiveList(dir) {
      const entries2 = await readdir(dir, { withFileTypes, encoding: "utf8" });
      for (const entry of entries2) {
        const fullPath = withFileTypes ? entry.path : dir + "/" + entry;
        if (typeof exclude != "function" ? exclude.some((p12) => matchesGlob(p12, fullPath)) : exclude(withFileTypes ? entry : fullPath))
          continue;
        if ((await stat(fullPath)).isDirectory() && regexPatterns.some((pattern3) => pattern3.source.includes(".*"))) {
          yield* recursiveList(fullPath);
        }
        if (regexPatterns.some((pattern3) => pattern3.test(fullPath.replace(/^\/+/g, "")))) {
          yield withFileTypes ? entry : fullPath.replace(/^\/+/g, "");
        }
      }
    }
    return recursiveList(cwd);
  }
  var import_buffer5, __addDisposableResource3, __disposeResources3, FileHandle;
  var init_promises = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/promises.js"() {
      import_buffer5 = __toESM(require_buffer(), 1);
      init_dist2();
      init_dist();
      init_contexts();
      init_inode();
      init_path();
      init_polyfills();
      init_readline();
      init_utils();
      init_config();
      init_constants();
      init_dir();
      init_file();
      init_flags();
      init_shared();
      init_stats();
      init_streams();
      init_watchers();
      init_constants();
      __addDisposableResource3 = function(env, value, async) {
        if (value !== null && value !== void 0) {
          if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
          var dispose, inner;
          if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
          }
          if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
          }
          if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
          if (inner) dispose = function() {
            try {
              inner.call(this);
            } catch (e2) {
              return Promise.reject(e2);
            }
          };
          env.stack.push({ value, dispose, async });
        } else if (async) {
          env.stack.push({ async: true });
        }
        return value;
      };
      __disposeResources3 = /* @__PURE__ */ function(SuppressedError2) {
        return function(env) {
          function fail(e2) {
            env.error = env.hasError ? new SuppressedError2(e2, env.error, "An error was suppressed during disposal.") : e2;
            env.hasError = true;
          }
          var r2, s2 = 0;
          function next() {
            while (r2 = env.stack.pop()) {
              try {
                if (!r2.async && s2 === 1) return s2 = 0, env.stack.push(r2), Promise.resolve().then(next);
                if (r2.dispose) {
                  var result = r2.dispose.call(r2.value);
                  if (r2.async) return s2 |= 2, Promise.resolve(result).then(next, function(e2) {
                    fail(e2);
                    return next();
                  });
                } else s2 |= 1;
              } catch (e2) {
                fail(e2);
              }
            }
            if (s2 === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
            if (env.hasError) throw env.error;
          }
          return next();
        };
      }(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
        var e2 = new Error(message);
        return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
      });
      FileHandle = class {
        /**
         * Get the current file position.
         *
         * We emulate the following bug mentioned in the Node documentation:
         *
         * On Linux, positional writes don't work when the file is opened in append mode.
         * The kernel ignores the position argument and always appends the data to the end of the file.
         * @returns The current file position.
         */
        get position() {
          return this.flag & O_APPEND ? this.inode.size : this._position;
        }
        set position(value) {
          this._position = value;
        }
        constructor(context, fd2) {
          this.context = context;
          this.fd = fd2;
          this._position = 0;
          this.dirty = false;
          this.closed = false;
          const sync = fromFD(context, fd2);
          Object.assign(this, pick(sync, "path", "fs", "internalPath", "flag", "inode"));
        }
        get _isSync() {
          return !!(this.flag & O_SYNC || this.inode.flags & InodeFlags.Sync);
        }
        _emitChange() {
          emitChange(this.context, "change", this.path);
        }
        /**
         * Asynchronous fchown(2) - Change ownership of a file.
         */
        async chown(uid, gid) {
          if (this.closed)
            throw UV("EBADF", "chown", this.path);
          this.dirty = true;
          _chown(this.inode, uid, gid);
          if (this._isSync)
            await this.sync();
          this._emitChange();
        }
        /**
         * Asynchronous fchmod(2) - Change permissions of a file.
         * @param mode A file mode. If a string is passed, it is parsed as an octal integer.
         */
        async chmod(mode) {
          const numMode = normalizeMode(mode, -1);
          if (numMode < 0)
            throw UV("EINVAL", "chmod", this.path);
          if (this.closed)
            throw UV("EBADF", "chmod", this.path);
          this.dirty = true;
          this.inode.mode = this.inode.mode & (numMode > S_IFMT ? ~S_IFMT : S_IFMT) | numMode;
          if (this._isSync || numMode > S_IFMT)
            await this.sync();
          this._emitChange();
        }
        /**
         * Asynchronous fdatasync(2) - synchronize a file's in-core state with storage device.
         */
        datasync() {
          return this.sync();
        }
        /**
         * Asynchronous fsync(2) - synchronize a file's in-core state with the underlying storage device.
         */
        async sync() {
          if (this.closed)
            throw UV("EBADF", "sync", this.path);
          if (!this.dirty)
            return;
          if (!this.fs.attributes.has("no_write"))
            await this.fs.touch(this.internalPath, this.inode);
          this.dirty = false;
        }
        /**
         * Asynchronous ftruncate(2) - Truncate a file to a specified length.
         * @param length If not specified, defaults to `0`.
         */
        async truncate(length2 = 0) {
          if (this.closed)
            throw UV("EBADF", "truncate", this.path);
          if (length2 < 0)
            throw UV("EINVAL", "truncate", this.path);
          if (!(this.flag & O_WRONLY || this.flag & O_RDWR))
            throw UV("EBADF", "truncate", this.path);
          if (this.fs.attributes.has("readonly"))
            throw UV("EROFS", "truncate", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "truncate", this.path);
          this.dirty = true;
          if (!(this.flag & O_WRONLY || this.flag & O_RDWR))
            throw UV("EBADF", "truncate", this.path);
          this.inode.mtimeMs = Date.now();
          this.inode.size = length2;
          if (this._isSync)
            await this.sync();
          this._emitChange();
        }
        /**
         * Asynchronously change file timestamps of the file.
         * @param atime The last access time. If a string is provided, it will be coerced to number.
         * @param mtime The last modified time. If a string is provided, it will be coerced to number.
         */
        async utimes(atime, mtime) {
          if (this.closed)
            throw UV("EBADF", "utimes", this.path);
          this.dirty = true;
          this.inode.atimeMs = normalizeTime(atime);
          this.inode.mtimeMs = normalizeTime(mtime);
          if (this._isSync)
            await this.sync();
          this._emitChange();
        }
        /**
         * Asynchronously append data to a file, creating the file if it does not exist. The underlying file will _not_ be closed automatically.
         * The `FileHandle` must have been opened for appending.
         * @param data The data to write. If something other than a `Buffer` or `Uint8Array` is provided, the value is coerced to a string.
         * @param _options Either the encoding for the file, or an object optionally specifying the encoding, file mode, and flag.
         * - `encoding` defaults to `'utf8'`.
         * - `mode` defaults to `0o666`.
         * - `flag` defaults to `'a'`.
         */
        async appendFile(data, _options = {}) {
          const options = normalizeOptions(_options, "utf8", "a", 420);
          const flag = parse2(options.flag);
          if (!(flag & O_APPEND))
            throw UV("EBADF", "write", this.path);
          const encodedData = typeof data == "string" ? import_buffer5.Buffer.from(data, options.encoding) : data;
          await this._write(encodedData, 0, encodedData.length);
          this._emitChange();
        }
        /**
         * Read data from the file.
         * @param buffer The buffer that the data will be written to.
         * @param offset The offset within the buffer where writing will start.
         * @param length An integer specifying the number of bytes to read.
         * @param position An integer specifying where to begin reading from in the file.
         * If position is unset, data will be read from the current file position.
         */
        async _read(buffer, offset = 0, length2 = buffer.byteLength - offset, position = this.position) {
          if (this.closed)
            throw UV("EBADF", "read", this.path);
          if (this.flag & O_WRONLY)
            throw UV("EBADF", "read", this.path);
          if (!(this.inode.flags & InodeFlags.NoAtime) && !this.fs.attributes.has("no_atime")) {
            this.dirty = true;
            this.inode.atimeMs = Date.now();
          }
          let end = position + length2;
          if (!isCharacterDevice(this.inode) && !isBlockDevice(this.inode) && end > this.inode.size) {
            end = position + Math.max(this.inode.size - position, 0);
          }
          this._position = end;
          const uint8 = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
          await this.fs.read(this.internalPath, uint8.subarray(offset, offset + length2), position, end);
          if (this._isSync)
            await this.sync();
          return { bytesRead: end - position, buffer };
        }
        async read(buffer, offset, length2, position) {
          if (typeof offset == "object" && offset != null) {
            position = offset.position;
            length2 = offset.length;
            offset = offset.offset;
          }
          if (!ArrayBuffer.isView(buffer) && typeof buffer == "object") {
            position = buffer.position;
            length2 = buffer.length;
            offset = buffer.offset;
            buffer = buffer.buffer;
          }
          const pos = Number.isSafeInteger(position) ? position : this.position;
          buffer || (buffer = new Uint8Array(this.inode.size));
          offset !== null && offset !== void 0 ? offset : offset = 0;
          return this._read(buffer, offset, length2 !== null && length2 !== void 0 ? length2 : buffer.byteLength - offset, pos);
        }
        async readFile(_options) {
          const options = normalizeOptions(_options, null, "r", 292);
          const flag = parse2(options.flag);
          if (flag & O_WRONLY)
            throw UV("EBADF", "read", this.path);
          const { size } = await this.stat();
          const data = new Uint8Array(size);
          await this._read(data, 0, size, 0);
          const buffer = import_buffer5.Buffer.from(data);
          return options.encoding ? buffer.toString(options.encoding) : buffer;
        }
        /**
         * Read file data using a `ReadableStream`.
         * The handle will not be closed automatically.
         */
        readableWebStream(options = {}) {
          if (this.closed)
            throw UV("EBADF", "readableWebStream", this.path);
          return this.fs.streamRead(this.internalPath, options);
        }
        /**
         * Not part of the Node.js API!
         *
         * Write file data using a `WritableStream`.
         * The handle will not be closed automatically.
         * @internal
         */
        writableWebStream(options = {}) {
          if (this.closed)
            throw UV("EBADF", "writableWebStream", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "writableWebStream", this.path);
          return this.fs.streamWrite(this.internalPath, options);
        }
        /**
         * Creates a readline Interface object that allows reading the file line by line
         * @param options Options for creating a read stream
         * @returns A readline interface for reading the file line by line
         */
        readLines(options) {
          if (this.closed || this.flag & O_WRONLY)
            throw UV("EBADF", "read", this.path);
          return createInterface({ input: this.createReadStream(options), crlfDelay: Infinity });
        }
        [Symbol.asyncDispose]() {
          return this.close();
        }
        async stat(opts) {
          if (this.closed)
            throw UV("EBADF", "stat", this.path);
          if (checkAccess && !hasAccess(this.context, this.inode, R_OK))
            throw UV("EACCES", "stat", this.path);
          return (opts === null || opts === void 0 ? void 0 : opts.bigint) ? new BigIntStats(this.inode) : new Stats(this.inode);
        }
        /**
         * Write buffer to the file.
         * @param buffer Uint8Array containing the data to write to the file.
         * @param offset Offset in the buffer to start reading data from.
         * @param length The amount of bytes to write to the file.
         * @param position Offset from the beginning of the file where this data should be written.
         * If position is null, the data will be written at  the current position.
         */
        async _write(buffer, offset = 0, length2 = buffer.byteLength - offset, position = this.position) {
          if (this.closed)
            throw UV("EBADF", "write", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "write", this.path);
          if (!(this.flag & O_WRONLY || this.flag & O_RDWR))
            throw UV("EBADF", "write", this.path);
          if (this.fs.attributes.has("readonly"))
            throw UV("EROFS", "write", this.path);
          this.dirty = true;
          const end = position + length2;
          const slice = buffer.subarray(offset, offset + length2);
          if (!isCharacterDevice(this.inode) && !isBlockDevice(this.inode) && end > this.inode.size)
            this.inode.size = end;
          this.inode.mtimeMs = Date.now();
          this.inode.ctimeMs = Date.now();
          this._position = position + slice.byteLength;
          await this.fs.write(this.internalPath, slice, position);
          if (this._isSync)
            await this.sync();
          return slice.byteLength;
        }
        /**
         * Asynchronously writes `string` to the file.
         * The `FileHandle` must have been opened for writing.
         * It is unsafe to call `write()` multiple times on the same file without waiting for the `Promise`
         * to be resolved (or rejected). For this scenario, `createWriteStream` is strongly recommended.
         */
        async write(data, options, lenOrEnc, position) {
          let buffer, offset, length2;
          if (typeof options == "object" && options != null) {
            lenOrEnc = options.length;
            position = options.position;
            options = options.offset;
          }
          if (typeof data === "string") {
            position = typeof options === "number" ? options : null;
            offset = 0;
            buffer = import_buffer5.Buffer.from(data, typeof lenOrEnc === "string" ? lenOrEnc : "utf8");
            length2 = buffer.length;
          } else {
            buffer = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
            offset = options !== null && options !== void 0 ? options : 0;
            length2 = typeof lenOrEnc == "number" ? lenOrEnc : buffer.byteLength;
            position = typeof position === "number" ? position : null;
          }
          position !== null && position !== void 0 ? position : position = this.position;
          const bytesWritten = await this._write(buffer, offset, length2, position);
          this._emitChange();
          return { buffer: data, bytesWritten };
        }
        /**
         * Asynchronously writes data to a file, replacing the file if it already exists. The underlying file will _not_ be closed automatically.
         * The `FileHandle` must have been opened for writing.
         * It is unsafe to call `writeFile()` multiple times on the same file without waiting for the `Promise` to be resolved (or rejected).
         * @param data The data to write. If something other than a `Buffer` or `Uint8Array` is provided, the value is coerced to a string.
         * @param _options Either the encoding for the file, or an object optionally specifying the encoding, file mode, and flag.
         * - `encoding` defaults to `'utf8'`.
         * - `mode` defaults to `0o666`.
         * - `flag` defaults to `'w'`.
         */
        async writeFile(data, _options = {}) {
          const options = normalizeOptions(_options, "utf8", "w", 420);
          const flag = parse2(options.flag);
          if (!(flag & O_WRONLY || flag & O_RDWR))
            throw UV("EBADF", "writeFile", this.path);
          const encodedData = typeof data == "string" ? import_buffer5.Buffer.from(data, options.encoding) : data;
          await this._write(encodedData, 0, encodedData.length, 0);
          this._emitChange();
        }
        /**
         * Asynchronous close(2) - close a `FileHandle`.
         */
        async close() {
          if (this.closed)
            throw UV("EBADF", "close", this.path);
          await this.sync();
          this.dispose();
          deleteFD(this.context, this.fd);
        }
        /**
         * Cleans up. This will *not* sync the file data to the FS
         */
        dispose(force) {
          if (this.closed)
            throw UV("EBADF", "close", this.path);
          if (this.dirty && !force)
            throw UV("EBUSY", "close", this.path);
          this.closed = true;
        }
        /**
         * Asynchronous `writev`. Writes from multiple buffers.
         * @param buffers An array of Uint8Array buffers.
         * @param position The position in the file where to begin writing.
         * @returns The number of bytes written.
         */
        async writev(buffers, position) {
          if (typeof position == "number")
            this.position = position;
          let bytesWritten = 0;
          for (const buffer of buffers) {
            bytesWritten += (await this.write(buffer)).bytesWritten;
          }
          return { bytesWritten, buffers };
        }
        /**
         * Asynchronous `readv`. Reads into multiple buffers.
         * @param buffers An array of Uint8Array buffers.
         * @param position The position in the file where to begin reading.
         * @returns The number of bytes read.
         */
        async readv(buffers, position) {
          if (typeof position == "number")
            this.position = position;
          let bytesRead = 0;
          for (const buffer of buffers) {
            bytesRead += (await this.read(buffer)).bytesRead;
          }
          return { bytesRead, buffers };
        }
        /**
         * Creates a stream for reading from the file.
         * @param options Options for the readable stream
         */
        createReadStream(options = {}) {
          if (this.closed || this.flag & O_WRONLY)
            throw UV("EBADF", "createReadStream", this.path);
          return new ReadStream(options, this);
        }
        /**
         * Creates a stream for writing to the file.
         * @param options Options for the writeable stream.
         */
        createWriteStream(options = {}) {
          if (this.closed)
            throw UV("EBADF", "createWriteStream", this.path);
          if (this.inode.flags & InodeFlags.Immutable)
            throw UV("EPERM", "createWriteStream", this.path);
          if (this.fs.attributes.has("readonly"))
            throw UV("EROFS", "createWriteStream", this.path);
          return new WriteStream(options, this);
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/async.js
  async function collectAsyncIterator(it) {
    const results = [];
    for await (const result of it) {
      results.push(result);
    }
    return results;
  }
  function rename2(oldPath, newPath, cb = nop) {
    rename.call(this, oldPath, newPath).then(() => cb()).catch(cb);
  }
  function exists2(path3, cb = nop) {
    exists.call(this, path3).then(cb).catch(() => cb(false));
  }
  function stat2(path3, options, callback = nop) {
    callback = typeof options == "function" ? options : callback;
    stat.call(this, path3, typeof options != "function" ? options : {}).then((stats) => callback(void 0, stats)).catch(callback);
  }
  function lstat2(path3, options, callback = nop) {
    callback = typeof options == "function" ? options : callback;
    lstat.call(this, path3, typeof options != "function" ? options : {}).then((stats) => callback(void 0, stats)).catch(callback);
  }
  function truncate2(path3, cbLen = 0, cb = nop) {
    cb = typeof cbLen === "function" ? cbLen : cb;
    const len = typeof cbLen === "number" ? cbLen : 0;
    truncate.call(this, path3, len).then(() => cb()).catch(cb);
  }
  function unlink2(path3, cb = nop) {
    unlink.call(this, path3).then(() => cb()).catch(cb);
  }
  function open2(path3, flag, cbMode, cb = nop) {
    const mode = normalizeMode(cbMode, 420);
    cb = typeof cbMode === "function" ? cbMode : cb;
    open.call(this, path3, flag, mode).then((handle) => cb(void 0, handle.fd)).catch(cb);
  }
  function readFile2(filename, options, cb = nop) {
    cb = typeof options === "function" ? options : cb;
    readFile.call(this, filename, typeof options === "function" ? null : options).then((data) => cb(void 0, data)).catch(cb);
  }
  function writeFile2(filename, data, cbEncOpts, cb = nop) {
    cb = typeof cbEncOpts === "function" ? cbEncOpts : cb;
    writeFile.call(this, filename, data, typeof cbEncOpts != "function" ? cbEncOpts : null).then(() => cb(void 0)).catch(cb);
  }
  function appendFile2(filename, data, cbEncOpts, cb = nop) {
    const optionsOrEncoding = typeof cbEncOpts != "function" ? cbEncOpts : void 0;
    cb = typeof cbEncOpts === "function" ? cbEncOpts : cb;
    appendFile.call(this, filename, data, optionsOrEncoding).then(() => cb()).catch(cb);
  }
  function fstat(fd2, options, cb = nop) {
    cb = typeof options == "function" ? options : cb;
    new FileHandle(this, fd2).stat().then((stats) => cb(void 0, typeof options == "object" && (options === null || options === void 0 ? void 0 : options.bigint) ? new BigIntStats(stats) : stats)).catch(cb);
  }
  function close(fd2, cb = nop) {
    new FileHandle(this, fd2).close().then(() => cb()).catch(cb);
  }
  function ftruncate(fd2, lenOrCB, cb = nop) {
    const length2 = typeof lenOrCB === "number" ? lenOrCB : 0;
    cb = typeof lenOrCB === "function" ? lenOrCB : cb;
    const file = new FileHandle(this, fd2);
    if (length2 < 0)
      throw withErrno("EINVAL");
    file.truncate(length2).then(() => cb()).catch(cb);
  }
  function fsync(fd2, cb = nop) {
    new FileHandle(this, fd2).sync().then(() => cb()).catch(cb);
  }
  function fdatasync(fd2, cb = nop) {
    new FileHandle(this, fd2).datasync().then(() => cb()).catch(cb);
  }
  function write(fd2, data, cbPosOff, cbLenEnc, cbPosEnc, cb = nop) {
    let buffer, offset, length2, position, encoding;
    const handle = new FileHandle(this, fd2);
    if (typeof data === "string") {
      encoding = "utf8";
      switch (typeof cbPosOff) {
        case "function":
          cb = cbPosOff;
          break;
        case "number":
          position = cbPosOff;
          encoding = typeof cbLenEnc === "string" ? cbLenEnc : "utf8";
          cb = typeof cbPosEnc === "function" ? cbPosEnc : cb;
          break;
        default:
          cb = typeof cbLenEnc === "function" ? cbLenEnc : typeof cbPosEnc === "function" ? cbPosEnc : cb;
          cb(withErrno("EINVAL"));
          return;
      }
      buffer = import_buffer6.Buffer.from(data);
      offset = 0;
      length2 = buffer.length;
      const _cb = cb;
      handle.write(buffer, offset, length2, position).then(({ bytesWritten }) => _cb(void 0, bytesWritten, buffer.toString(encoding))).catch(_cb);
    } else {
      buffer = import_buffer6.Buffer.from(data.buffer);
      offset = cbPosOff;
      length2 = cbLenEnc;
      position = typeof cbPosEnc === "number" ? cbPosEnc : null;
      const _cb = typeof cbPosEnc === "function" ? cbPosEnc : cb;
      void handle.write(buffer, offset, length2, position).then(({ bytesWritten }) => _cb(void 0, bytesWritten, buffer)).catch(_cb);
    }
  }
  function read(fd2, buffer, offset, length2, position, cb = nop) {
    new FileHandle(this, fd2).read(buffer, offset, length2, position).then(({ bytesRead, buffer: buffer2 }) => cb(void 0, bytesRead, buffer2)).catch(cb);
  }
  function fchown(fd2, uid, gid, cb = nop) {
    new FileHandle(this, fd2).chown(uid, gid).then(() => cb()).catch(cb);
  }
  function fchmod(fd2, mode, cb) {
    new FileHandle(this, fd2).chmod(mode).then(() => cb()).catch(cb);
  }
  function futimes(fd2, atime, mtime, cb = nop) {
    new FileHandle(this, fd2).utimes(atime, mtime).then(() => cb()).catch(cb);
  }
  function rmdir2(path3, cb = nop) {
    rmdir.call(this, path3).then(() => cb()).catch(cb);
  }
  function mkdir2(path3, mode, cb = nop) {
    mkdir.call(this, path3, mode).then(() => cb()).catch(cb);
  }
  function readdir2(path3, _options, cb = nop) {
    cb = typeof _options == "function" ? _options : cb;
    const options = typeof _options != "function" ? _options : {};
    readdir.call(this, path3, options).then((entries2) => cb(void 0, entries2)).catch(cb);
  }
  function link2(existing, newpath, cb = nop) {
    link.call(this, existing, newpath).then(() => cb()).catch(cb);
  }
  function symlink2(target, path3, typeOrCB, cb = nop) {
    const type = typeof typeOrCB === "string" ? typeOrCB : "file";
    cb = typeof typeOrCB === "function" ? typeOrCB : cb;
    symlink.call(this, target, path3, type).then(() => cb()).catch(cb);
  }
  function readlink2(path3, options, callback = nop) {
    callback = typeof options == "function" ? options : callback;
    readlink.call(this, path3).then((result) => callback(void 0, result)).catch(callback);
  }
  function chown2(path3, uid, gid, cb = nop) {
    chown.call(this, path3, uid, gid).then(() => cb()).catch(cb);
  }
  function lchown2(path3, uid, gid, cb = nop) {
    lchown.call(this, path3, uid, gid).then(() => cb()).catch(cb);
  }
  function chmod2(path3, mode, cb = nop) {
    chmod.call(this, path3, mode).then(() => cb()).catch(cb);
  }
  function lchmod2(path3, mode, cb = nop) {
    lchmod.call(this, path3, mode).then(() => cb()).catch(cb);
  }
  function utimes2(path3, atime, mtime, cb = nop) {
    utimes.call(this, path3, atime, mtime).then(() => cb()).catch(cb);
  }
  function lutimes2(path3, atime, mtime, cb = nop) {
    lutimes.call(this, path3, atime, mtime).then(() => cb()).catch(cb);
  }
  function realpath2(path3, arg2, cb = nop) {
    cb = typeof arg2 === "function" ? arg2 : cb;
    realpath.call(this, path3, typeof arg2 === "function" ? null : arg2).then((result) => cb(void 0, result)).catch(cb);
  }
  function access2(path3, cbMode, cb = nop) {
    const mode = typeof cbMode === "number" ? cbMode : R_OK;
    cb = typeof cbMode === "function" ? cbMode : cb;
    access.call(this, path3, mode).then(() => cb()).catch(cb);
  }
  function watchFile(path3, options, listener) {
    const normalizedPath = normalizePath(path3);
    const opts = typeof options != "function" ? options : {};
    if (typeof options == "function") {
      listener = options;
    }
    if (!listener)
      throw UV("EINVAL", "watch", path3.toString());
    if (statWatchers.has(normalizedPath)) {
      const entry = statWatchers.get(normalizedPath);
      if (entry) {
        entry.listeners.add(listener);
      }
      return;
    }
    const watcher = new StatWatcher(this, normalizedPath, opts);
    watcher.on("change", (curr, prev) => {
      const entry = statWatchers.get(normalizedPath);
      if (!entry) {
        return;
      }
      for (const listener2 of entry.listeners) {
        listener2(curr, prev);
      }
    });
    statWatchers.set(normalizedPath, { watcher, listeners: /* @__PURE__ */ new Set() });
  }
  function unwatchFile(path3, listener = nop) {
    const normalizedPath = normalizePath(path3);
    const entry = statWatchers.get(normalizedPath);
    if (entry) {
      if (listener && listener !== nop) {
        entry.listeners.delete(listener);
      } else {
        entry.listeners.clear();
      }
      if (entry.listeners.size === 0) {
        entry.watcher.stop();
        statWatchers.delete(normalizedPath);
      }
    }
  }
  function watch2(path3, options, listener) {
    const watcher = new FSWatcher(this, normalizePath(path3), typeof options == "object" ? options : {});
    listener = typeof options == "function" ? options : listener;
    watcher.on("change", listener || nop);
    return watcher;
  }
  function createReadStream(path3, options) {
    options = typeof options == "object" ? options : { encoding: options };
    const _handle = open.call(this, path3, "r", options === null || options === void 0 ? void 0 : options.mode);
    return new ReadStream({ ...options, autoClose: true }, _handle);
  }
  function createWriteStream(path3, options) {
    options = typeof options == "object" ? options : { encoding: options };
    const _handle = open.call(this, path3, "w", options === null || options === void 0 ? void 0 : options.mode);
    return new WriteStream(options, _handle);
  }
  function rm2(path3, options, callback = nop) {
    callback = typeof options === "function" ? options : callback;
    rm.call(this, path3, typeof options === "function" ? void 0 : options).then(() => callback(void 0)).catch(callback);
  }
  function mkdtemp2(prefix, options, callback = nop) {
    callback = typeof options === "function" ? options : callback;
    mkdtemp.call(this, prefix, typeof options != "function" ? options : null).then((result) => callback(void 0, result)).catch(callback);
  }
  function copyFile2(src, dest, flags, callback = nop) {
    callback = typeof flags === "function" ? flags : callback;
    copyFile.call(this, src, dest, typeof flags === "function" ? void 0 : flags).then(() => callback(void 0)).catch(callback);
  }
  function readv(fd2, buffers, position, cb = nop) {
    cb = typeof position === "function" ? position : cb;
    new FileHandle(this, fd2).readv(buffers, typeof position === "function" ? void 0 : position).then(({ buffers: buffers2, bytesRead }) => cb(void 0, bytesRead, buffers2)).catch(cb);
  }
  function writev(fd2, buffers, position, cb = nop) {
    cb = typeof position === "function" ? position : cb;
    new FileHandle(this, fd2).writev(buffers, typeof position === "function" ? void 0 : position).then(({ buffers: buffers2, bytesWritten }) => cb(void 0, bytesWritten, buffers2)).catch(cb);
  }
  function opendir2(path3, options, cb = nop) {
    cb = typeof options === "function" ? options : cb;
    opendir.call(this, path3, typeof options === "function" ? void 0 : options).then((result) => cb(void 0, result)).catch(cb);
  }
  function cp2(source, destination, opts, callback = nop) {
    callback = typeof opts === "function" ? opts : callback;
    cp.call(this, source, destination, typeof opts === "function" ? void 0 : opts).then(() => callback(void 0)).catch(callback);
  }
  function statfs2(path3, options, callback = nop) {
    callback = typeof options === "function" ? options : callback;
    statfs.call(this, path3, typeof options === "function" ? void 0 : options).then((result) => callback(void 0, result)).catch(callback);
  }
  async function openAsBlob(path3, options) {
    const handle = await open.call(this, path3.toString(), "r");
    const buffer = await handle.readFile();
    await handle.close();
    return new Blob([buffer], options);
  }
  function glob2(pattern2, options, callback = nop) {
    callback = typeof options == "function" ? options : callback;
    const it = glob.call(this, pattern2, typeof options === "function" ? void 0 : options);
    collectAsyncIterator(it).then((results) => {
      var _a6;
      return callback(null, (_a6 = results) !== null && _a6 !== void 0 ? _a6 : []);
    }).catch((e2) => callback(e2));
  }
  var import_buffer6, nop, statWatchers;
  var init_async = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/async.js"() {
      import_buffer6 = __toESM(require_buffer(), 1);
      init_dist2();
      init_utils();
      init_constants();
      init_promises();
      init_stats();
      init_streams();
      init_watchers();
      nop = () => {
      };
      statWatchers = /* @__PURE__ */ new Map();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/ioctl.js
  async function ioctl(path3, command, ...args) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    try {
      const inode = new Inode(await fs2.stat(resolved));
      switch (command) {
        case IOC.GetFlags:
        case IOC32.GetFlags:
          return inode.flags;
        case IOC.SetFlags:
        case IOC32.SetFlags:
          inode.flags = args[0];
          await fs2.touch(resolved, inode);
          return void 0;
        case IOC.GetVersion:
        case IOC32.GetVersion:
          return inode.version;
        case IOC.SetVersion:
        case IOC32.SetVersion:
          inode.version = args[0];
          await fs2.touch(resolved, inode);
          return void 0;
        case IOC.Fiemap:
          break;
        case IOC.GetXattr:
          return new fsxattr(inode);
        case IOC.SetXattr:
          break;
        case IOC.GetLabel:
          return fs2.label;
        case IOC.SetLabel:
          fs2.label = args[0];
          return void 0;
        case IOC.GetUUID:
          return fs2.uuid;
        case IOC.GetSysfsPath:
          return `/sys/fs/${fs2.name}/${fs2.uuid}`;
      }
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { syscall: "ioctl", path: path3 }));
    }
    throw UV("ENOTSUP", "ioctl", path3);
  }
  function ioctlSync(path3, command, ...args) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    try {
      const inode = new Inode(fs2.statSync(resolved));
      switch (command) {
        case IOC.GetFlags:
        case IOC32.GetFlags:
          return inode.flags;
        case IOC.SetFlags:
        case IOC32.SetFlags:
          inode.flags = args[0];
          fs2.touchSync(resolved, inode);
          return void 0;
        case IOC.GetVersion:
        case IOC32.GetVersion:
          return inode.version;
        case IOC.SetVersion:
        case IOC32.SetVersion:
          inode.version = args[0];
          fs2.touchSync(resolved, inode);
          return void 0;
        case IOC.Fiemap:
          break;
        case IOC.GetXattr:
          return new fsxattr(inode);
        case IOC.SetXattr:
          break;
        case IOC.GetLabel:
          return fs2.label;
        case IOC.SetLabel:
          fs2.label = args[0];
          return void 0;
        case IOC.GetUUID:
          return fs2.uuid;
        case IOC.GetSysfsPath:
          return `/sys/fs/${fs2.name}/${fs2.uuid}`;
      }
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { syscall: "ioctl", path: path3 }));
    }
    throw UV("ENOTSUP", "ioctl", path3);
  }
  var __esDecorate2, __runInitializers2, __setFunctionName2, __classPrivateFieldGet2, __classPrivateFieldSet2, XFlag, fsxattr, FileFlag, IOC, IOC32;
  var init_ioctl = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/ioctl.js"() {
      init_dist2();
      init_dist3();
      init_dist();
      init_buffer();
      init_inode();
      init_utils();
      init_shared();
      __esDecorate2 = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
        function accept(f) {
          if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
          return f;
        }
        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
        var _2, done = false;
        for (var i2 = decorators.length - 1; i2 >= 0; i2--) {
          var context = {};
          for (var p12 in contextIn) context[p12] = p12 === "access" ? {} : contextIn[p12];
          for (var p12 in contextIn.access) context.access[p12] = contextIn.access[p12];
          context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
          };
          var result = (0, decorators[i2])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
          if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_2 = accept(result.get)) descriptor.get = _2;
            if (_2 = accept(result.set)) descriptor.set = _2;
            if (_2 = accept(result.init)) initializers.unshift(_2);
          } else if (_2 = accept(result)) {
            if (kind === "field") initializers.unshift(_2);
            else descriptor[key] = _2;
          }
        }
        if (target) Object.defineProperty(target, contextIn.name, descriptor);
        done = true;
      };
      __runInitializers2 = function(thisArg, initializers, value) {
        var useValue = arguments.length > 2;
        for (var i2 = 0; i2 < initializers.length; i2++) {
          value = useValue ? initializers[i2].call(thisArg, value) : initializers[i2].call(thisArg);
        }
        return useValue ? value : void 0;
      };
      __setFunctionName2 = function(f, name2, prefix) {
        if (typeof name2 === "symbol") name2 = name2.description ? "[".concat(name2.description, "]") : "";
        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name2) : name2 });
      };
      __classPrivateFieldGet2 = function(receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet2 = function(receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      (function(XFlag2) {
        XFlag2[XFlag2["RealTime"] = 1] = "RealTime";
        XFlag2[XFlag2["PreAlloc"] = 2] = "PreAlloc";
        XFlag2[XFlag2["Immutable"] = 8] = "Immutable";
        XFlag2[XFlag2["Append"] = 16] = "Append";
        XFlag2[XFlag2["Sync"] = 32] = "Sync";
        XFlag2[XFlag2["NoAtime"] = 64] = "NoAtime";
        XFlag2[XFlag2["NoDump"] = 128] = "NoDump";
        XFlag2[XFlag2["RtInherit"] = 256] = "RtInherit";
        XFlag2[XFlag2["ProjInherit"] = 512] = "ProjInherit";
        XFlag2[XFlag2["NoSymlinks"] = 1024] = "NoSymlinks";
        XFlag2[XFlag2["ExtSize"] = 2048] = "ExtSize";
        XFlag2[XFlag2["ExtSzInherit"] = 4096] = "ExtSzInherit";
        XFlag2[XFlag2["NoDefrag"] = 8192] = "NoDefrag";
        XFlag2[XFlag2["FileStream"] = 16384] = "FileStream";
        XFlag2[XFlag2["Dax"] = 32768] = "Dax";
        XFlag2[XFlag2["CowExtSize"] = 65536] = "CowExtSize";
        XFlag2[XFlag2["HasAttr"] = 2147483648] = "HasAttr";
      })(XFlag || (XFlag = {}));
      fsxattr = (() => {
        var _fsxattr_xflags_accessor_storage, _fsxattr_extsize_accessor_storage, _fsxattr_nextents_accessor_storage, _fsxattr_projid_accessor_storage, _fsxattr_cowextsize_accessor_storage, _fsxattr_pad_accessor_storage;
        var _a6, _b3, _c2, _d, _e;
        let _classDecorators = [struct()];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = BufferView;
        let _xflags_decorators;
        let _xflags_initializers = [];
        let _xflags_extraInitializers = [];
        let _extsize_decorators;
        let _extsize_initializers = [];
        let _extsize_extraInitializers = [];
        let _nextents_decorators;
        let _nextents_initializers = [];
        let _nextents_extraInitializers = [];
        let _projid_decorators;
        let _projid_initializers = [];
        let _projid_extraInitializers = [];
        let _cowextsize_decorators;
        let _cowextsize_initializers = [];
        let _cowextsize_extraInitializers = [];
        let _pad_decorators;
        let _pad_initializers = [];
        let _pad_extraInitializers = [];
        var fsxattr2 = _classThis = class extends _classSuper {
          /** xflags field value */
          get xflags() {
            return __classPrivateFieldGet2(this, _fsxattr_xflags_accessor_storage, "f");
          }
          set xflags(value) {
            __classPrivateFieldSet2(this, _fsxattr_xflags_accessor_storage, value, "f");
          }
          /** extsize field value */
          get extsize() {
            return __classPrivateFieldGet2(this, _fsxattr_extsize_accessor_storage, "f");
          }
          set extsize(value) {
            __classPrivateFieldSet2(this, _fsxattr_extsize_accessor_storage, value, "f");
          }
          /** nextents field value */
          get nextents() {
            return __classPrivateFieldGet2(this, _fsxattr_nextents_accessor_storage, "f");
          }
          set nextents(value) {
            __classPrivateFieldSet2(this, _fsxattr_nextents_accessor_storage, value, "f");
          }
          /** project identifier */
          get projid() {
            return __classPrivateFieldGet2(this, _fsxattr_projid_accessor_storage, "f");
          }
          set projid(value) {
            __classPrivateFieldSet2(this, _fsxattr_projid_accessor_storage, value, "f");
          }
          /** CoW extsize field value */
          get cowextsize() {
            return __classPrivateFieldGet2(this, _fsxattr_cowextsize_accessor_storage, "f");
          }
          set cowextsize(value) {
            __classPrivateFieldSet2(this, _fsxattr_cowextsize_accessor_storage, value, "f");
          }
          get pad() {
            return __classPrivateFieldGet2(this, _fsxattr_pad_accessor_storage, "f");
          }
          set pad(value) {
            __classPrivateFieldSet2(this, _fsxattr_pad_accessor_storage, value, "f");
          }
          constructor(inode = _throw(new Exception(Errno.EINVAL, "fsxattr must be initialized with an inode"))) {
            super(new ArrayBuffer(sizeof(fsxattr2)));
            _fsxattr_xflags_accessor_storage.set(this, __runInitializers2(this, _xflags_initializers, void 0));
            _fsxattr_extsize_accessor_storage.set(this, (__runInitializers2(this, _xflags_extraInitializers), __runInitializers2(this, _extsize_initializers, void 0)));
            _fsxattr_nextents_accessor_storage.set(this, (__runInitializers2(this, _extsize_extraInitializers), __runInitializers2(this, _nextents_initializers, void 0)));
            _fsxattr_projid_accessor_storage.set(this, (__runInitializers2(this, _nextents_extraInitializers), __runInitializers2(this, _projid_initializers, void 0)));
            _fsxattr_cowextsize_accessor_storage.set(this, (__runInitializers2(this, _projid_extraInitializers), __runInitializers2(this, _cowextsize_initializers, void 0)));
            _fsxattr_pad_accessor_storage.set(this, (__runInitializers2(this, _cowextsize_extraInitializers), __runInitializers2(this, _pad_initializers, [])));
            __runInitializers2(this, _pad_extraInitializers);
            this.extsize = inode.size;
            this.nextents = 1;
            this.projid = inode.uid;
            this.cowextsize = inode.size;
            for (const name2 of Object.keys(InodeFlags)) {
              if (!(inode.flags & InodeFlags[name2]))
                continue;
              if (name2 in XFlag)
                this.xflags |= XFlag[name2];
            }
          }
        };
        _fsxattr_xflags_accessor_storage = /* @__PURE__ */ new WeakMap();
        _fsxattr_extsize_accessor_storage = /* @__PURE__ */ new WeakMap();
        _fsxattr_nextents_accessor_storage = /* @__PURE__ */ new WeakMap();
        _fsxattr_projid_accessor_storage = /* @__PURE__ */ new WeakMap();
        _fsxattr_cowextsize_accessor_storage = /* @__PURE__ */ new WeakMap();
        _fsxattr_pad_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName2(_classThis, "fsxattr");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _xflags_decorators = [(_a7 = types2).uint32.bind(_a7)];
          _extsize_decorators = [(_b3 = types2).uint32.bind(_b3)];
          _nextents_decorators = [(_c2 = types2).uint32.bind(_c2)];
          _projid_decorators = [(_d = types2).uint32.bind(_d)];
          _cowextsize_decorators = [(_e = types2).uint32.bind(_e)];
          _pad_decorators = [types2.char(8)];
          __esDecorate2(_classThis, null, _xflags_decorators, { kind: "accessor", name: "xflags", static: false, private: false, access: { has: (obj) => "xflags" in obj, get: (obj) => obj.xflags, set: (obj, value) => {
            obj.xflags = value;
          } }, metadata: _metadata }, _xflags_initializers, _xflags_extraInitializers);
          __esDecorate2(_classThis, null, _extsize_decorators, { kind: "accessor", name: "extsize", static: false, private: false, access: { has: (obj) => "extsize" in obj, get: (obj) => obj.extsize, set: (obj, value) => {
            obj.extsize = value;
          } }, metadata: _metadata }, _extsize_initializers, _extsize_extraInitializers);
          __esDecorate2(_classThis, null, _nextents_decorators, { kind: "accessor", name: "nextents", static: false, private: false, access: { has: (obj) => "nextents" in obj, get: (obj) => obj.nextents, set: (obj, value) => {
            obj.nextents = value;
          } }, metadata: _metadata }, _nextents_initializers, _nextents_extraInitializers);
          __esDecorate2(_classThis, null, _projid_decorators, { kind: "accessor", name: "projid", static: false, private: false, access: { has: (obj) => "projid" in obj, get: (obj) => obj.projid, set: (obj, value) => {
            obj.projid = value;
          } }, metadata: _metadata }, _projid_initializers, _projid_extraInitializers);
          __esDecorate2(_classThis, null, _cowextsize_decorators, { kind: "accessor", name: "cowextsize", static: false, private: false, access: { has: (obj) => "cowextsize" in obj, get: (obj) => obj.cowextsize, set: (obj, value) => {
            obj.cowextsize = value;
          } }, metadata: _metadata }, _cowextsize_initializers, _cowextsize_extraInitializers);
          __esDecorate2(_classThis, null, _pad_decorators, { kind: "accessor", name: "pad", static: false, private: false, access: { has: (obj) => "pad" in obj, get: (obj) => obj.pad, set: (obj, value) => {
            obj.pad = value;
          } }, metadata: _metadata }, _pad_initializers, _pad_extraInitializers);
          __esDecorate2(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          fsxattr2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers2(_classThis, _classExtraInitializers);
        })();
        return fsxattr2 = _classThis;
      })();
      (function(FileFlag2) {
        FileFlag2[FileFlag2["SecureRm"] = 1] = "SecureRm";
        FileFlag2[FileFlag2["Undelete"] = 2] = "Undelete";
        FileFlag2[FileFlag2["Compress"] = 4] = "Compress";
        FileFlag2[FileFlag2["Sync"] = 8] = "Sync";
        FileFlag2[FileFlag2["Immutable"] = 16] = "Immutable";
        FileFlag2[FileFlag2["Append"] = 32] = "Append";
        FileFlag2[FileFlag2["NoDump"] = 64] = "NoDump";
        FileFlag2[FileFlag2["NoAtime"] = 128] = "NoAtime";
        FileFlag2[FileFlag2["Dirty"] = 256] = "Dirty";
        FileFlag2[FileFlag2["CompressBlk"] = 512] = "CompressBlk";
        FileFlag2[FileFlag2["NoCompress"] = 1024] = "NoCompress";
        FileFlag2[FileFlag2["Encrypt"] = 2048] = "Encrypt";
        FileFlag2[FileFlag2["Btree"] = 4096] = "Btree";
        FileFlag2[FileFlag2["Index"] = 4096] = "Index";
        FileFlag2[FileFlag2["IMagic"] = 8192] = "IMagic";
        FileFlag2[FileFlag2["JournalData"] = 16384] = "JournalData";
        FileFlag2[FileFlag2["NoTail"] = 32768] = "NoTail";
        FileFlag2[FileFlag2["DirSync"] = 65536] = "DirSync";
        FileFlag2[FileFlag2["TopDir"] = 131072] = "TopDir";
        FileFlag2[FileFlag2["HugeFile"] = 262144] = "HugeFile";
        FileFlag2[FileFlag2["Extent"] = 524288] = "Extent";
        FileFlag2[FileFlag2["Verity"] = 1048576] = "Verity";
        FileFlag2[FileFlag2["EaInode"] = 2097152] = "EaInode";
        FileFlag2[FileFlag2["EofBlocks"] = 4194304] = "EofBlocks";
        FileFlag2[FileFlag2["NoCow"] = 8388608] = "NoCow";
        FileFlag2[FileFlag2["Dax"] = 33554432] = "Dax";
        FileFlag2[FileFlag2["InlineData"] = 268435456] = "InlineData";
        FileFlag2[FileFlag2["ProjInherit"] = 536870912] = "ProjInherit";
        FileFlag2[FileFlag2["CaseFold"] = 1073741824] = "CaseFold";
        FileFlag2[FileFlag2["Reserved"] = 2147483648] = "Reserved";
      })(FileFlag || (FileFlag = {}));
      (function(IOC2) {
        IOC2[IOC2["GetFlags"] = 2148034049] = "GetFlags";
        IOC2[IOC2["SetFlags"] = 1074292226] = "SetFlags";
        IOC2[IOC2["GetVersion"] = 2148038145] = "GetVersion";
        IOC2[IOC2["SetVersion"] = 1074296322] = "SetVersion";
        IOC2[IOC2["Fiemap"] = 3223348747] = "Fiemap";
        IOC2[IOC2["GetXattr"] = 2149341215] = "GetXattr";
        IOC2[IOC2["SetXattr"] = 1075599392] = "SetXattr";
        IOC2[IOC2["GetLabel"] = 2164298801] = "GetLabel";
        IOC2[IOC2["SetLabel"] = 1090556978] = "SetLabel";
        IOC2[IOC2["GetUUID"] = 2148603136] = "GetUUID";
        IOC2[IOC2["GetSysfsPath"] = 2155943169] = "GetSysfsPath";
      })(IOC || (IOC = {}));
      (function(IOC322) {
        IOC322[IOC322["GetFlags"] = 2147771905] = "GetFlags";
        IOC322[IOC322["SetFlags"] = 1074030082] = "SetFlags";
        IOC322[IOC322["GetVersion"] = 2147776001] = "GetVersion";
        IOC322[IOC322["SetVersion"] = 1074034178] = "SetVersion";
      })(IOC32 || (IOC32 = {}));
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/xattr.js
  var xattr_exports = {};
  __export(xattr_exports, {
    get: () => get,
    getSync: () => getSync,
    list: () => list,
    listSync: () => listSync,
    remove: () => remove,
    removeSync: () => removeSync,
    set: () => set,
    setSync: () => setSync
  });
  function checkName($, name2, path3, syscall) {
    if (!name2.startsWith("user.") && !_allowedRestrictedNames.includes(name2))
      throw UV("ENOTSUP", syscall, path3);
  }
  async function get(path3, name2, opt = {}) {
    var _a6;
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    checkName(this, name2, path3, "xattr.get");
    const inode = await fs2.stat(resolved).catch(rethrow("xattr.get", path3));
    if (checkAccess && !hasAccess(this, inode, R_OK))
      throw UV("EACCES", "xattr.get", path3);
    (_a6 = inode.attributes) !== null && _a6 !== void 0 ? _a6 : inode.attributes = new Attributes();
    const value = inode.attributes.get(name2);
    if (!value)
      throw UV("ENODATA", "xattr.get", path3);
    const buffer = import_buffer8.Buffer.from(value);
    return opt.encoding == "buffer" || !opt.encoding ? buffer : buffer.toString(opt.encoding);
  }
  function getSync(path3, name2, opt = {}) {
    var _a6;
    path3 = normalizePath(path3);
    checkName(this, name2, path3, "xattr.get");
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    let inode;
    try {
      inode = fs2.statSync(resolved);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
    if (checkAccess && !hasAccess(this, inode, R_OK))
      throw UV("EACCES", "xattr.get", path3);
    (_a6 = inode.attributes) !== null && _a6 !== void 0 ? _a6 : inode.attributes = new Attributes();
    const value = inode.attributes.get(name2);
    if (!value)
      throw UV("ENODATA", "xattr.get", path3);
    const buffer = import_buffer8.Buffer.from(value);
    return opt.encoding == "buffer" || !opt.encoding ? buffer : buffer.toString(opt.encoding);
  }
  async function set(path3, name2, value, opt = {}) {
    var _a6;
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    checkName(this, name2, path3, "xattr.set");
    const inode = await fs2.stat(resolved).catch(rethrow("xattr.set", path3));
    if (checkAccess && !hasAccess(this, inode, W_OK))
      throw UV("EACCES", "xattr.set", path3);
    (_a6 = inode.attributes) !== null && _a6 !== void 0 ? _a6 : inode.attributes = new Attributes();
    const attr = inode.attributes.get(name2);
    if (opt.create && attr)
      throw UV("EEXIST", "xattr.set", path3);
    if (opt.replace && !attr)
      throw UV("ENODATA", "xattr.set", path3);
    inode.attributes.set(name2, import_buffer8.Buffer.from(value));
    await fs2.touch(resolved, inode).catch(rethrow("xattr.set", path3));
  }
  function setSync(path3, name2, value, opt = {}) {
    var _a6;
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    checkName(this, name2, path3, "xattr.set");
    let inode;
    try {
      inode = fs2.statSync(resolved);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
    if (checkAccess && !hasAccess(this, inode, W_OK))
      throw UV("EACCES", "xattr.set", path3);
    (_a6 = inode.attributes) !== null && _a6 !== void 0 ? _a6 : inode.attributes = new Attributes();
    const attr = inode.attributes.get(name2);
    if (opt.create && attr)
      throw UV("EEXIST", "xattr.set", path3);
    if (opt.replace && !attr)
      throw UV("ENODATA", "xattr.set", path3);
    inode.attributes.set(name2, import_buffer8.Buffer.from(value));
    try {
      fs2.touchSync(resolved, inode);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
  }
  async function remove(path3, name2) {
    var _a6;
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    checkName(this, name2, path3, "xattr.remove");
    const inode = await fs2.stat(resolved).catch(rethrow("xattr.remove", path3));
    if (checkAccess && !hasAccess(this, inode, W_OK))
      throw UV("EACCES", "xattr.remove", path3);
    (_a6 = inode.attributes) !== null && _a6 !== void 0 ? _a6 : inode.attributes = new Attributes();
    const attr = inode.attributes.get(name2);
    if (!attr)
      throw UV("ENODATA", "xattr.remove", path3);
    inode.attributes.remove(name2);
    await fs2.touch(resolved, inode);
  }
  function removeSync(path3, name2) {
    var _a6;
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    checkName(this, name2, path3, "xattr.remove");
    let inode;
    try {
      inode = fs2.statSync(resolved);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
    if (checkAccess && !hasAccess(this, inode, W_OK))
      throw UV("EACCES", "xattr.remove", path3);
    (_a6 = inode.attributes) !== null && _a6 !== void 0 ? _a6 : inode.attributes = new Attributes();
    const attr = inode.attributes.get(name2);
    if (!attr)
      throw UV("ENODATA", "xattr.remove", path3);
    inode.attributes.remove(name2);
    try {
      fs2.touchSync(resolved, inode);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
  }
  async function list(path3) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    const inode = await fs2.stat(resolved).catch(rethrow("xattr.list", path3));
    if (!inode.attributes)
      return [];
    return inode.attributes.keys().toArray();
  }
  function listSync(path3) {
    path3 = normalizePath(path3);
    const { fs: fs2, path: resolved } = resolveMount(path3, this);
    let inode;
    try {
      inode = fs2.statSync(resolved);
    } catch (e2) {
      throw setUVMessage(Object.assign(e2, { path: path3 }));
    }
    if (!inode.attributes)
      return [];
    return inode.attributes.keys().toArray();
  }
  var import_buffer8, _allowedRestrictedNames;
  var init_xattr = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/xattr.js"() {
      import_buffer8 = __toESM(require_buffer(), 1);
      init_dist2();
      init_inode();
      init_utils();
      init_config();
      init_constants();
      init_shared();
      _allowedRestrictedNames = [];
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/index.js
  var vfs_exports = {};
  __export(vfs_exports, {
    BigIntStatsFs: () => BigIntStatsFs,
    Dir: () => Dir,
    Dirent: () => Dirent,
    IOC: () => IOC,
    IOC32: () => IOC32,
    ReadStream: () => ReadStream,
    Stats: () => Stats,
    StatsFs: () => StatsFs,
    WriteStream: () => WriteStream,
    access: () => access2,
    accessSync: () => accessSync,
    appendFile: () => appendFile2,
    appendFileSync: () => appendFileSync,
    chmod: () => chmod2,
    chmodSync: () => chmodSync,
    chown: () => chown2,
    chownSync: () => chownSync,
    chroot: () => chroot,
    close: () => close,
    closeSync: () => closeSync,
    constants: () => constants_exports,
    copyFile: () => copyFile2,
    copyFileSync: () => copyFileSync,
    cp: () => cp2,
    cpSync: () => cpSync,
    createReadStream: () => createReadStream,
    createWriteStream: () => createWriteStream,
    exists: () => exists2,
    existsSync: () => existsSync,
    fchmod: () => fchmod,
    fchmodSync: () => fchmodSync,
    fchown: () => fchown,
    fchownSync: () => fchownSync,
    fdatasync: () => fdatasync,
    fdatasyncSync: () => fdatasyncSync,
    fstat: () => fstat,
    fstatSync: () => fstatSync,
    fsync: () => fsync,
    fsyncSync: () => fsyncSync,
    ftruncate: () => ftruncate,
    ftruncateSync: () => ftruncateSync,
    futimes: () => futimes,
    futimesSync: () => futimesSync,
    glob: () => glob2,
    globSync: () => globSync,
    ioctl: () => ioctl,
    ioctlSync: () => ioctlSync,
    lchmod: () => lchmod2,
    lchmodSync: () => lchmodSync,
    lchown: () => lchown2,
    lchownSync: () => lchownSync,
    link: () => link2,
    linkSync: () => linkSync,
    lopenSync: () => lopenSync,
    lstat: () => lstat2,
    lstatSync: () => lstatSync,
    lutimes: () => lutimes2,
    lutimesSync: () => lutimesSync,
    mkdir: () => mkdir2,
    mkdirSync: () => mkdirSync,
    mkdtemp: () => mkdtemp2,
    mkdtempSync: () => mkdtempSync,
    mount: () => mount,
    open: () => open2,
    openAsBlob: () => openAsBlob,
    openSync: () => openSync,
    opendir: () => opendir2,
    opendirSync: () => opendirSync,
    promises: () => promises_exports,
    read: () => read,
    readFile: () => readFile2,
    readFileSync: () => readFileSync,
    readSync: () => readSync,
    readdir: () => readdir2,
    readdirSync: () => readdirSync,
    readlink: () => readlink2,
    readlinkSync: () => readlinkSync,
    readv: () => readv,
    readvSync: () => readvSync,
    realpath: () => realpath2,
    realpathSync: () => realpathSync,
    rename: () => rename2,
    renameSync: () => renameSync,
    rm: () => rm2,
    rmSync: () => rmSync,
    rmdir: () => rmdir2,
    rmdirSync: () => rmdirSync,
    stat: () => stat2,
    statSync: () => statSync,
    statfs: () => statfs2,
    statfsSync: () => statfsSync,
    symlink: () => symlink2,
    symlinkSync: () => symlinkSync,
    truncate: () => truncate2,
    truncateSync: () => truncateSync,
    umount: () => umount,
    unlink: () => unlink2,
    unlinkSync: () => unlinkSync,
    unwatchFile: () => unwatchFile,
    utimes: () => utimes2,
    utimesSync: () => utimesSync,
    watch: () => watch2,
    watchFile: () => watchFile,
    write: () => write,
    writeFile: () => writeFile2,
    writeFileSync: () => writeFileSync,
    writeSync: () => writeSync,
    writev: () => writev,
    writevSync: () => writevSync,
    xattr: () => xattr_exports
  });
  var init_vfs = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/vfs/index.js"() {
      init_async();
      init_constants();
      init_dir();
      init_ioctl();
      init_promises();
      init_shared();
      init_stats();
      init_streams();
      init_sync();
      init_xattr();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/config.js
  function configureFileSystem(fs2, config) {
    if (config.disableAsyncCache)
      fs2.attributes.set("no_async_preload");
    if (config.caseFold)
      fs2.attributes.set("case_fold", config.caseFold);
  }
  function isMountConfig(arg) {
    return isBackendConfig(arg) || isBackend(arg) || arg instanceof FileSystem;
  }
  async function resolveMountConfig(configuration, _depth = 0) {
    if (typeof configuration !== "object" || configuration == null) {
      throw log_exports.err(withErrno("EINVAL", "Invalid options on mount configuration"));
    }
    if (!isMountConfig(configuration)) {
      throw log_exports.err(withErrno("EINVAL", "Invalid mount configuration"));
    }
    if (configuration instanceof FileSystem) {
      await configuration.ready();
      return configuration;
    }
    if (isBackend(configuration)) {
      configuration = { backend: configuration };
    }
    for (const [key, value] of Object.entries(configuration)) {
      if (key == "backend")
        continue;
      if (!isMountConfig(value))
        continue;
      log_exports.info("Resolving nested mount configuration: " + key);
      if (_depth > 10) {
        throw log_exports.err(withErrno("EINVAL", "Invalid configuration, too deep and possibly infinite"));
      }
      configuration[key] = await resolveMountConfig(value, ++_depth);
    }
    const { backend } = configuration;
    if (typeof backend.isAvailable == "function" && !await backend.isAvailable(configuration)) {
      throw log_exports.err(withErrno("EPERM", "Backend not available: " + backend.name));
    }
    checkOptions(backend, configuration);
    const mount3 = await backend.create(configuration);
    configureFileSystem(mount3, configuration);
    await mount3.ready();
    return mount3;
  }
  async function configureSingle(configuration) {
    if (!isBackendConfig(configuration)) {
      throw new TypeError("Invalid single mount point configuration");
    }
    const resolved = await resolveMountConfig(configuration);
    umount("/");
    mount("/", resolved);
  }
  async function mount2(path3, mount3) {
    if (path3 == "/") {
      mount(path3, mount3);
      return;
    }
    const stats = await promises_exports.stat(path3).catch(() => null);
    if (!stats) {
      await promises_exports.mkdir(path3, { recursive: true });
    } else if (!stats.isDirectory()) {
      throw withErrno("ENOTDIR", "Missing directory at mount point: " + path3);
    }
    mount(path3, mount3);
  }
  function addDevice(driver, options) {
    const devfs = mounts.get("/dev");
    if (!(devfs instanceof DeviceFS))
      throw log_exports.crit(withErrno("ENOTSUP", "/dev does not exist or is not a device file system"));
    return devfs._createDevice(driver, options);
  }
  async function configure2(configuration) {
    var _a6, _b3;
    Object.assign(defaultContext.credentials, createCredentials({
      uid: configuration.uid || 0,
      gid: configuration.gid || 0
    }));
    _setAccessChecks(!configuration.disableAccessChecks);
    if (configuration.log)
      log_exports.configure(configuration.log);
    if (configuration.mounts) {
      for (const [_point, mountConfig] of Object.entries(configuration.mounts).sort(([a], [b]) => a.length > b.length ? 1 : -1)) {
        const point = _point.startsWith("/") ? _point : "/" + _point;
        if (isBackendConfig(mountConfig)) {
          (_a6 = mountConfig.disableAsyncCache) !== null && _a6 !== void 0 ? _a6 : mountConfig.disableAsyncCache = configuration.disableAsyncCache || false;
          (_b3 = mountConfig.caseFold) !== null && _b3 !== void 0 ? _b3 : mountConfig.caseFold = configuration.caseFold;
        }
        if (point == "/")
          umount("/");
        await mount2(point, await resolveMountConfig(mountConfig));
      }
    }
    for (const fs2 of mounts.values()) {
      configureFileSystem(fs2, configuration);
    }
    if (configuration.addDevices && !mounts.has("/dev")) {
      const devfs = new DeviceFS();
      devfs.addDefaults();
      await devfs.ready();
      await mount2("/dev", devfs);
    }
  }
  var init_config2 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/config.js"() {
      init_dist2();
      init_backend();
      init_contexts();
      init_credentials();
      init_devices();
      init_filesystem();
      init_config();
      init_vfs();
      init_shared();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/cow.js
  function isJournalOp(op) {
    return journalOperations.includes(op);
  }
  var journalOperations, maxOpLength, journalMagicString, Journal, CopyOnWriteFS, _CopyOnWrite, CopyOnWrite;
  var init_cow = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/cow.js"() {
      init_eventemitter3();
      init_dist2();
      init_log();
      init_dist();
      init_config2();
      init_filesystem();
      init_inode();
      init_path();
      journalOperations = ["delete"];
      maxOpLength = Math.max(...journalOperations.map((op) => op.length));
      journalMagicString = "#journal@v0\n";
      Journal = class extends import_index.default {
        constructor() {
          super(...arguments);
          this.entries = [];
        }
        toString() {
          return journalMagicString + this.entries.map((entry) => `${entry.op.padEnd(maxOpLength)} ${entry.path}`).join("\n");
        }
        /**
         * Parse a journal from a string
         */
        fromString(value) {
          if (!value.startsWith(journalMagicString))
            throw err(withErrno("EINVAL", "Invalid journal contents, refusing to parse"));
          for (const line of value.split("\n")) {
            if (line.startsWith("#"))
              continue;
            const [op, path3] = line.split(/\s+/);
            if (!isJournalOp(op)) {
              warn("Unknown operation in journal (skipping): " + op);
              continue;
            }
            this.entries.push({ op, path: path3 });
          }
          return this;
        }
        add(op, path3) {
          this.entries.push({ op, path: path3 });
          this.emit("update", op, path3);
          this.emit(op, path3);
        }
        has(op, path3) {
          const test = JSON.stringify({ op, path: path3 });
          for (const entry of this.entries)
            if (JSON.stringify(entry) === test)
              return true;
          return false;
        }
        isDeleted(path3) {
          let deleted = false;
          for (const entry of this.entries) {
            if (entry.path != path3)
              continue;
            switch (entry.op) {
              case "delete":
                deleted = true;
            }
          }
          return deleted;
        }
      };
      CopyOnWriteFS = class extends FileSystem {
        async ready() {
          await this.readable.ready();
          await this.writable.ready();
        }
        constructor(readable, writable, journal = new Journal()) {
          super(1651862636, readable.name);
          this.readable = readable;
          this.writable = writable;
          this.journal = journal;
          if (writable.attributes.has("no_write")) {
            throw err(withErrno("EINVAL", "Writable file system can not be written to"));
          }
          readable.attributes.set("no_write");
        }
        isDeleted(path3) {
          return this.journal.isDeleted(path3);
        }
        /**
         * @todo Consider trying to track information on the writable as well
         */
        usage() {
          return this.readable.usage();
        }
        async sync() {
          await this.writable.sync();
        }
        syncSync() {
          this.writable.syncSync();
        }
        async read(path3, buffer, offset, end) {
          return await this.writable.exists(path3) ? await this.writable.read(path3, buffer, offset, end) : await this.readable.read(path3, buffer, offset, end);
        }
        readSync(path3, buffer, offset, end) {
          return this.writable.existsSync(path3) ? this.writable.readSync(path3, buffer, offset, end) : this.readable.readSync(path3, buffer, offset, end);
        }
        async write(path3, buffer, offset) {
          await this.copyForWrite(path3);
          return await this.writable.write(path3, buffer, offset);
        }
        writeSync(path3, buffer, offset) {
          this.copyForWriteSync(path3);
          return this.writable.writeSync(path3, buffer, offset);
        }
        async rename(oldPath, newPath) {
          await this.copyForWrite(oldPath);
          try {
            await this.writable.rename(oldPath, newPath);
          } catch {
            if (this.isDeleted(oldPath))
              throw withErrno("ENOENT");
          }
        }
        renameSync(oldPath, newPath) {
          this.copyForWriteSync(oldPath);
          try {
            this.writable.renameSync(oldPath, newPath);
          } catch {
            if (this.isDeleted(oldPath))
              throw withErrno("ENOENT");
          }
        }
        async stat(path3) {
          try {
            return await this.writable.stat(path3);
          } catch {
            if (this.isDeleted(path3))
              throw withErrno("ENOENT");
            return await this.readable.stat(path3);
          }
        }
        statSync(path3) {
          try {
            return this.writable.statSync(path3);
          } catch {
            if (this.isDeleted(path3))
              throw withErrno("ENOENT");
            return this.readable.statSync(path3);
          }
        }
        async touch(path3, metadata) {
          await this.copyForWrite(path3);
          await this.writable.touch(path3, metadata);
        }
        touchSync(path3, metadata) {
          this.copyForWriteSync(path3);
          this.writable.touchSync(path3, metadata);
        }
        async createFile(path3, options) {
          await this.createParentDirectories(path3);
          return await this.writable.createFile(path3, options);
        }
        createFileSync(path3, options) {
          this.createParentDirectoriesSync(path3);
          return this.writable.createFileSync(path3, options);
        }
        async link(srcpath, dstpath) {
          await this.copyForWrite(srcpath);
          await this.writable.link(srcpath, dstpath);
        }
        linkSync(srcpath, dstpath) {
          this.copyForWriteSync(srcpath);
          this.writable.linkSync(srcpath, dstpath);
        }
        async unlink(path3) {
          if (!await this.exists(path3))
            throw withErrno("ENOENT");
          if (await this.writable.exists(path3)) {
            await this.writable.unlink(path3);
          }
          if (await this.exists(path3)) {
            this.journal.add("delete", path3);
          }
        }
        unlinkSync(path3) {
          if (!this.existsSync(path3))
            throw withErrno("ENOENT");
          if (this.writable.existsSync(path3)) {
            this.writable.unlinkSync(path3);
          }
          if (this.existsSync(path3)) {
            this.journal.add("delete", path3);
          }
        }
        async rmdir(path3) {
          if (!await this.exists(path3))
            throw withErrno("ENOENT");
          if (await this.writable.exists(path3)) {
            await this.writable.rmdir(path3);
          }
          if (!await this.exists(path3)) {
            return;
          }
          if ((await this.readdir(path3)).length)
            throw withErrno("ENOTEMPTY");
          this.journal.add("delete", path3);
        }
        rmdirSync(path3) {
          if (!this.existsSync(path3))
            throw withErrno("ENOENT");
          if (this.writable.existsSync(path3)) {
            this.writable.rmdirSync(path3);
          }
          if (!this.existsSync(path3)) {
            return;
          }
          if (this.readdirSync(path3).length)
            throw withErrno("ENOTEMPTY");
          this.journal.add("delete", path3);
        }
        async mkdir(path3, options) {
          if (await this.exists(path3))
            throw withErrno("EEXIST");
          await this.createParentDirectories(path3);
          return await this.writable.mkdir(path3, options);
        }
        mkdirSync(path3, options) {
          if (this.existsSync(path3))
            throw withErrno("EEXIST");
          this.createParentDirectoriesSync(path3);
          return this.writable.mkdirSync(path3, options);
        }
        async readdir(path3) {
          if (this.isDeleted(path3) || !await this.exists(path3))
            throw withErrno("ENOENT");
          const entries2 = await this.readable.exists(path3) ? await this.readable.readdir(path3) : [];
          if (await this.writable.exists(path3))
            for (const entry of await this.writable.readdir(path3)) {
              if (!entries2.includes(entry))
                entries2.push(entry);
            }
          return entries2.filter((entry) => !this.isDeleted(join(path3, entry)));
        }
        readdirSync(path3) {
          if (this.isDeleted(path3) || !this.existsSync(path3))
            throw withErrno("ENOENT");
          const entries2 = this.readable.existsSync(path3) ? this.readable.readdirSync(path3) : [];
          if (this.writable.existsSync(path3))
            for (const entry of this.writable.readdirSync(path3)) {
              if (!entries2.includes(entry))
                entries2.push(entry);
            }
          return entries2.filter((entry) => !this.isDeleted(join(path3, entry)));
        }
        streamRead(path3, options) {
          return this.writable.existsSync(path3) ? this.writable.streamRead(path3, options) : this.readable.streamRead(path3, options);
        }
        streamWrite(path3, options) {
          this.copyForWriteSync(path3);
          return this.writable.streamWrite(path3, options);
        }
        /**
         * Create the needed parent directories on the writable storage should they not exist.
         * Use modes from the read-only storage.
         */
        createParentDirectoriesSync(path3) {
          const toCreate = [];
          const silence = canary(withErrno("EDEADLK"));
          for (let parent = dirname(path3); !this.writable.existsSync(parent); parent = dirname(parent)) {
            toCreate.push(parent);
          }
          silence();
          if (toCreate.length)
            debug("COW: Creating parent directories: " + toCreate.join(", "));
          for (const path4 of toCreate.reverse()) {
            this.writable.mkdirSync(path4, this.statSync(path4));
          }
        }
        /**
         * Create the needed parent directories on the writable storage should they not exist.
         * Use modes from the read-only storage.
         */
        async createParentDirectories(path3) {
          const toCreate = [];
          const silence = canary(withErrno("EDEADLK", path3));
          for (let parent = dirname(path3); !await this.writable.exists(parent); parent = dirname(parent)) {
            toCreate.push(parent);
          }
          silence();
          if (toCreate.length)
            debug("COW: Creating parent directories: " + toCreate.join(", "));
          for (const path4 of toCreate.reverse()) {
            await this.writable.mkdir(path4, await this.stat(path4));
          }
        }
        /**
         * Helper function:
         * - Ensures p is on writable before proceeding. Throws an error if it doesn't exist.
         * - Calls f to perform operation on writable.
         */
        copyForWriteSync(path3) {
          if (!this.existsSync(path3))
            throw withErrno("ENOENT");
          if (!this.writable.existsSync(dirname(path3))) {
            this.createParentDirectoriesSync(path3);
          }
          if (!this.writable.existsSync(path3)) {
            this.copyToWritableSync(path3);
          }
        }
        async copyForWrite(path3) {
          if (!await this.exists(path3))
            throw withErrno("ENOENT");
          if (!await this.writable.exists(dirname(path3))) {
            await this.createParentDirectories(path3);
          }
          if (!await this.writable.exists(path3)) {
            return this.copyToWritable(path3);
          }
        }
        /**
         * Copy from readable to writable storage.
         * PRECONDITION: File does not exist on writable storage.
         */
        copyToWritableSync(path3) {
          const stats = this.readable.statSync(path3);
          if (isDirectory(stats)) {
            this.writable.mkdirSync(path3, stats);
            for (const k of this.readable.readdirSync(path3)) {
              this.copyToWritableSync(join(path3, k));
            }
            return;
          }
          const data = new Uint8Array(stats.size);
          this.readable.readSync(path3, data, 0, data.byteLength);
          this.writable.createFileSync(path3, stats);
          this.writable.touchSync(path3, stats);
          this.writable.writeSync(path3, data, 0);
        }
        async copyToWritable(path3) {
          const stats = await this.readable.stat(path3);
          if (isDirectory(stats)) {
            await this.writable.mkdir(path3, stats);
            for (const k of await this.readable.readdir(path3)) {
              await this.copyToWritable(join(path3, k));
            }
            return;
          }
          const data = new Uint8Array(stats.size);
          await this.readable.read(path3, data, 0, stats.size);
          await this.writable.createFile(path3, stats);
          await this.writable.touch(path3, stats);
          await this.writable.write(path3, data, 0);
        }
      };
      _CopyOnWrite = {
        name: "CopyOnWrite",
        options: {
          writable: { type: "object", required: true },
          readable: { type: "object", required: true },
          journal: { type: "object", required: false }
        },
        async create(options) {
          const readable = await resolveMountConfig(options.readable);
          const writable = await resolveMountConfig(options.writable);
          return new CopyOnWriteFS(readable, writable, options.journal);
        }
      };
      CopyOnWrite = _CopyOnWrite;
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/requests.js
  async function _fetch(input, init3 = {}, bodyOptional = false) {
    const response = await fetch(input, init3).catch((error) => {
      throw { tag: "fetch", message: error.message };
    });
    if (!response.ok)
      throw { tag: "status", response };
    const raw = await response.arrayBuffer().catch((error) => {
      if (bodyOptional)
        return;
      throw { tag: "buffer", response, message: error.message };
    });
    return { response, data: raw ? new Uint8Array(raw) : void 0 };
  }
  async function get2(url, options, init3 = {}) {
    const req = new Request(url, init3);
    if (typeof options.start != "number" || typeof options.end != "number") {
      const { data } = await _fetch(url, init3);
      new Resource(url, data.byteLength, options, resourcesCache).add(data, 0);
      return data;
    }
    if (typeof options.size != "number") {
      options.warn?.(url + ": Size not provided, an additional HEAD request is being made");
      const { headers } = await fetch(req, { method: "HEAD" });
      const size2 = parseInt(headers.get("Content-Length") ?? "");
      if (typeof size2 != "number")
        throw {
          tag: "size",
          message: "Response is missing content-length header and no size was provided"
        };
      options.size = size2;
    }
    const { size, start, end } = options;
    const resource = resourcesCache.get(url) ?? new Resource(url, size, options, resourcesCache);
    req.headers.set("If-Range", (/* @__PURE__ */ new Date()).toUTCString());
    for (const { start: from, end: to } of resource.missing(start, end)) {
      const { data, response } = await _fetch(req, { headers: { Range: `bytes=${from}-${to}` } });
      if (response.status == 206) {
        resource.add(data, from);
        continue;
      }
      options.warn?.(url + ": Remote does not support range requests with bytes. Falling back to full data.");
      new Resource(url, size, options, resourcesCache).add(data, 0);
      return data.subarray(start, end);
    }
    resource.collect();
    const region = resource.regionAt(start);
    return region.data.subarray(start - region.offset, end - region.offset);
  }
  function getCached(url, options) {
    const cache2 = resourcesCache.get(url);
    if (!cache2) {
      if (options.size)
        return { data: new Uint8Array(0), missing: [{ start: 0, end: options.size ?? 0 }] };
      options.warn?.(url + ": Size not provided and cache is empty, can not determine missing range");
      return { data: void 0, missing: [] };
    }
    const { start = 0, end = cache2.size } = options;
    const data = new Uint8Array(end - start);
    for (const region of cache2.regions) {
      if (region.offset + region.data.byteLength <= start)
        continue;
      if (region.offset >= end)
        break;
      for (const range of region.ranges) {
        if (range.end <= start)
          continue;
        if (range.start >= end)
          break;
        const overlapStart = Math.max(range.start, start);
        const overlapEnd = Math.min(range.end, end);
        if (overlapStart >= overlapEnd)
          continue;
        data.set(region.data.subarray(overlapStart - region.offset, overlapEnd - region.offset), overlapStart - start);
      }
    }
    return { data, missing: cache2.missing(start, end) };
  }
  async function set2(url, data, options, init3 = {}) {
    if (!resourcesCache.has(url)) {
      new Resource(url, options.size ?? data.byteLength, options, resourcesCache);
    }
    const resource = resourcesCache.get(url);
    const { offset = 0 } = options;
    if (!options.cacheOnly)
      await _fetch(new Request(url, init3), { method: "POST" }, true);
    resource.add(data, offset);
  }
  async function remove2(url, options = {}, init3 = {}) {
    if (!options.cacheOnly)
      await _fetch(new Request(url, init3), { method: "DELETE" }, true);
    resourcesCache.delete(url);
  }
  var resourcesCache;
  var init_requests = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/requests.js"() {
      init_cache();
      resourcesCache = /* @__PURE__ */ new Map();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/index_fs.js
  var IndexFS;
  var init_index_fs = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/index_fs.js"() {
      init_dist2();
      init_dist();
      init_path();
      init_constants();
      init_file_index();
      init_filesystem();
      init_inode();
      IndexFS = class extends FileSystem {
        constructor(id, name2, index2 = new Index()) {
          super(id, name2);
          this.index = index2;
        }
        usage() {
          return this.index.usage();
        }
        /**
         * Finds all the paths in the index that need to be moved for a rename
         */
        pathsForRename(oldPath, newPath) {
          if (!this.index.has(oldPath))
            throw withErrno("ENOENT");
          if ((dirname(newPath) + "/").startsWith(oldPath + "/"))
            throw withErrno("EBUSY");
          const toRename = [];
          for (const [from, inode] of this.index.entries()) {
            const rel = relative(oldPath, from);
            if (rel.startsWith(".."))
              continue;
            let to = join(newPath, rel);
            if (to.endsWith("/"))
              to = to.slice(0, -1);
            toRename.push({ from, to, inode });
          }
          return toRename;
        }
        async rename(oldPath, newPath) {
          if (oldPath == newPath)
            return;
          for (const { from, to, inode } of this.pathsForRename(oldPath, newPath)) {
            const data = new Uint8Array(inode.size);
            await this.read(from, data, 0, inode.size);
            this.index.delete(from);
            this.index.set(to, inode);
            await this.write(to, data, 0);
          }
          await this.remove(oldPath);
        }
        renameSync(oldPath, newPath) {
          if (oldPath == newPath)
            return;
          for (const { from, to, inode } of this.pathsForRename(oldPath, newPath)) {
            const data = new Uint8Array(inode.size);
            this.readSync(from, data, 0, inode.size);
            this.index.delete(from);
            this.index.set(to, inode);
            this.writeSync(to, data, 0);
          }
          this.removeSync(oldPath);
        }
        async stat(path3) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          return inode;
        }
        statSync(path3) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          return inode;
        }
        async touch(path3, metadata) {
          var _a6;
          const inode = (_a6 = this.index.get(path3)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT"));
          inode.update(metadata);
        }
        touchSync(path3, metadata) {
          var _a6;
          const inode = (_a6 = this.index.get(path3)) !== null && _a6 !== void 0 ? _a6 : _throw(withErrno("ENOENT"));
          inode.update(metadata);
        }
        _remove(path3, isUnlink) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          const isDir = (inode.mode & S_IFMT) == S_IFDIR;
          if (!isDir && !isUnlink)
            throw withErrno("ENOTDIR");
          if (isDir && isUnlink)
            throw withErrno("EISDIR");
          if (isDir && this.readdirSync(path3).length)
            throw withErrno("ENOTEMPTY");
          this.index.delete(path3);
        }
        async unlink(path3) {
          this._remove(path3, true);
          await this.remove(path3);
        }
        unlinkSync(path3) {
          this._remove(path3, true);
          this.removeSync(path3);
        }
        async rmdir(path3) {
          this._remove(path3, false);
          await this.remove(path3);
        }
        rmdirSync(path3) {
          this._remove(path3, false);
          this.removeSync(path3);
        }
        create(path3, options) {
          if (this.index.has(path3))
            throw withErrno("EEXIST");
          const parent = this.index.get(dirname(path3));
          if (!parent)
            throw withErrno("ENOENT");
          const id = this.index._alloc();
          const inode = new Inode({
            ino: id,
            data: id + 1,
            mode: options.mode,
            size: 0,
            uid: parent.mode & S_ISUID ? parent.uid : options.uid,
            gid: parent.mode & S_ISGID ? parent.gid : options.gid,
            nlink: 1
          });
          this.index.set(path3, inode);
          return inode;
        }
        async createFile(path3, options) {
          options.mode |= S_IFREG;
          return this.create(path3, options);
        }
        createFileSync(path3, options) {
          options.mode |= S_IFREG;
          return this.create(path3, options);
        }
        async mkdir(path3, options) {
          options.mode |= S_IFDIR;
          return this.create(path3, options);
        }
        mkdirSync(path3, options) {
          options.mode |= S_IFDIR;
          return this.create(path3, options);
        }
        link(target, link3) {
          throw withErrno("ENOSYS");
        }
        linkSync(target, link3) {
          throw withErrno("ENOSYS");
        }
        async readdir(path3) {
          return Object.keys(this.index.directoryEntries(path3));
        }
        readdirSync(path3) {
          return Object.keys(this.index.directoryEntries(path3));
        }
        async sync() {
        }
        syncSync() {
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/fetch.js
  function parseError(error) {
    if (!("tag" in error))
      throw err(withErrno("EIO", error.stack));
    switch (error.tag) {
      case "fetch":
        throw err(withErrno("EREMOTEIO", error.message));
      case "status":
        throw err(withErrno(error.response.status > 500 ? "EREMOTEIO" : "EIO", "Response status code is " + error.response.status));
      case "size":
        throw err(withErrno("EBADE", error.message));
      case "buffer":
        throw err(withErrno("EIO", "Failed to decode buffer"));
    }
  }
  var FetchFS, _Fetch, Fetch;
  var init_fetch = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/fetch.js"() {
      init_dist2();
      init_log();
      init_dist();
      init_requests();
      init_file_index();
      init_index_fs();
      init_utils();
      init_constants();
      FetchFS = class extends IndexFS {
        _async(p12) {
          this._asyncDone = this._asyncDone.then(() => p12);
        }
        constructor(index2, baseUrl, requestInit = {}, remoteWrite) {
          super(544106099, "nfs", index2);
          this.baseUrl = baseUrl;
          this.requestInit = requestInit;
          this.remoteWrite = remoteWrite;
          this._asyncDone = Promise.resolve();
        }
        async remove(path3) {
          await remove2(this.baseUrl + path3, { warn, cacheOnly: !this.remoteWrite }, this.requestInit);
        }
        removeSync(path3) {
          this._async(remove2(this.baseUrl + path3, { warn, cacheOnly: !this.remoteWrite }, this.requestInit));
        }
        async read(path3, buffer, offset = 0, end) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          if (end - offset == 0)
            return;
          const data = await get2(this.baseUrl + path3, { start: offset, end, size: inode.size, warn }, this.requestInit).catch(parseError).catch(() => void 0);
          if (!data)
            throw withErrno("ENODATA");
          buffer.set(data);
        }
        readSync(path3, buffer, offset = 0, end) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          if (end - offset == 0)
            return;
          const { data, missing } = getCached(this.baseUrl + path3, { start: offset, end, size: inode.size, warn });
          if (!data)
            throw withErrno("ENODATA");
          if (missing.length) {
            this._async(get2(this.baseUrl + path3, { start: offset, end, size: inode.size, warn }));
            throw withErrno("EAGAIN");
          }
          buffer.set(data);
        }
        async write(path3, data, offset) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          inode.update({ mtimeMs: Date.now(), size: Math.max(inode.size, data.byteLength + offset) });
          await set2(this.baseUrl + path3, data, { offset, warn, cacheOnly: !this.remoteWrite }, this.requestInit).catch(parseError);
        }
        writeSync(path3, data, offset) {
          const inode = this.index.get(path3);
          if (!inode)
            throw withErrno("ENOENT");
          inode.update({ mtimeMs: Date.now(), size: Math.max(inode.size, data.byteLength + offset) });
          this._async(set2(this.baseUrl + path3, data, { offset, warn, cacheOnly: !this.remoteWrite }, this.requestInit).catch(parseError));
        }
      };
      _Fetch = {
        name: "Fetch",
        options: {
          index: { type: ["string", "object"], required: false },
          baseUrl: { type: "string", required: true },
          requestInit: { type: "object", required: false },
          remoteWrite: { type: "boolean", required: false }
        },
        isAvailable() {
          return typeof globalThis.fetch == "function";
        },
        async create(options) {
          var _a6;
          const url = new URL(options.baseUrl);
          url.pathname = normalizePath(url.pathname);
          let baseUrl = url.toString();
          if (baseUrl.at(-1) == "/")
            baseUrl = baseUrl.slice(0, -1);
          (_a6 = options.index) !== null && _a6 !== void 0 ? _a6 : options.index = "index.json";
          const index2 = new Index();
          if (typeof options.index != "string") {
            index2.fromJSON(options.index);
          } else {
            const data = await get2(options.index, { warn }, options.requestInit).catch(parseError);
            index2.fromJSON(JSON.parse(decodeUTF8(data)));
          }
          const fs2 = new FetchFS(index2, baseUrl, options.requestInit, options.remoteWrite);
          if (options.disableAsyncCache)
            return fs2;
          for (const [path3, node] of index2) {
            if (!(node.mode & S_IFREG))
              continue;
            await get2(baseUrl + path3, { warn }, options.requestInit).catch(parseError);
          }
          return fs2;
        }
      };
      Fetch = _Fetch;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/passthrough.js
  var __addDisposableResource4, __disposeResources4, PassthroughFS, _Passthrough, Passthrough;
  var init_passthrough = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/passthrough.js"() {
      init_log();
      init_filesystem();
      init_inode();
      init_path();
      __addDisposableResource4 = function(env, value, async) {
        if (value !== null && value !== void 0) {
          if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
          var dispose, inner;
          if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
          }
          if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
          }
          if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
          if (inner) dispose = function() {
            try {
              inner.call(this);
            } catch (e2) {
              return Promise.reject(e2);
            }
          };
          env.stack.push({ value, dispose, async });
        } else if (async) {
          env.stack.push({ async: true });
        }
        return value;
      };
      __disposeResources4 = /* @__PURE__ */ function(SuppressedError2) {
        return function(env) {
          function fail(e2) {
            env.error = env.hasError ? new SuppressedError2(e2, env.error, "An error was suppressed during disposal.") : e2;
            env.hasError = true;
          }
          var r2, s2 = 0;
          function next() {
            while (r2 = env.stack.pop()) {
              try {
                if (!r2.async && s2 === 1) return s2 = 0, env.stack.push(r2), Promise.resolve().then(next);
                if (r2.dispose) {
                  var result = r2.dispose.call(r2.value);
                  if (r2.async) return s2 |= 2, Promise.resolve(result).then(next, function(e2) {
                    fail(e2);
                    return next();
                  });
                } else s2 |= 1;
              } catch (e2) {
                fail(e2);
              }
            }
            if (s2 === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
            if (env.hasError) throw env.error;
          }
          return next();
        };
      }(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
        var e2 = new Error(message);
        return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
      });
      PassthroughFS = class extends FileSystem {
        constructor(nodeFS, prefix) {
          super(1852793957, "nodefs");
          this.nodeFS = nodeFS;
          this.prefix = prefix;
        }
        usage() {
          const info2 = this.nodeFS.statfsSync(this.prefix);
          return {
            totalSpace: info2.bsize * info2.blocks,
            freeSpace: info2.bsize * info2.bfree
          };
        }
        path(path3) {
          return this.prefix + path3;
        }
        /**
         * Rename a file or directory.
         */
        async rename(oldPath, newPath) {
          await this.nodeFS.promises.rename(this.path(oldPath), this.path(newPath));
        }
        /**
         * Rename a file or directory synchronously.
         */
        renameSync(oldPath, newPath) {
          this.nodeFS.renameSync(this.path(oldPath), this.path(newPath));
        }
        /**
         * Get file statistics.
         */
        async stat(path3) {
          return await this.nodeFS.promises.stat(this.path(path3));
        }
        /**
         * Get file statistics synchronously.
         */
        statSync(path3) {
          return this.nodeFS.statSync(this.path(path3));
        }
        async touch(path3, metadata) {
          const env_1 = { stack: [], error: void 0, hasError: false };
          try {
            const handle = __addDisposableResource4(env_1, await this.nodeFS.promises.open(this.path(path3), "w"), true);
            await handle.chmod(metadata.mode);
            await handle.chown(metadata.uid, metadata.gid);
            await handle.utimes(metadata.atimeMs, metadata.mtimeMs);
          } catch (e_1) {
            env_1.error = e_1;
            env_1.hasError = true;
          } finally {
            const result_1 = __disposeResources4(env_1);
            if (result_1)
              await result_1;
          }
        }
        touchSync(path3, metadata) {
          this.nodeFS.chmodSync(this.path(path3), metadata.mode);
          this.nodeFS.chownSync(this.path(path3), metadata.uid, metadata.gid);
          this.nodeFS.utimesSync(this.path(path3), metadata.atimeMs, metadata.mtimeMs);
        }
        /**
         * Unlink (delete) a file.
         */
        async unlink(path3) {
          await this.nodeFS.promises.unlink(this.path(path3));
        }
        /**
         * Unlink (delete) a file synchronously.
         */
        unlinkSync(path3) {
          this.nodeFS.unlinkSync(this.path(path3));
        }
        /**
         * Create a directory.
         */
        async mkdir(path3, options) {
          await this.nodeFS.promises.mkdir(this.path(path3), options);
          return await this.nodeFS.promises.stat(this.path(path3));
        }
        /**
         * Create a directory synchronously.
         */
        mkdirSync(path3, options) {
          this.nodeFS.mkdirSync(this.path(path3), options);
          return this.nodeFS.statSync(this.path(path3));
        }
        /**
         * Read the contents of a directory.
         */
        async readdir(path3) {
          return await this.nodeFS.promises.readdir(this.path(path3));
        }
        /**
         * Read the contents of a directory synchronously.
         */
        readdirSync(path3) {
          return this.nodeFS.readdirSync(this.path(path3));
        }
        /**
         * Create a file.
         */
        async createFile(path3, options) {
          if (isDirectory(options)) {
            await this.nodeFS.promises.mkdir(this.path(path3), { mode: options.mode });
          } else {
            const env_2 = { stack: [], error: void 0, hasError: false };
            try {
              const handle = __addDisposableResource4(env_2, await this.nodeFS.promises.open(this.path(path3), "wx"), true);
              await handle.close();
            } catch (e_2) {
              env_2.error = e_2;
              env_2.hasError = true;
            } finally {
              const result_2 = __disposeResources4(env_2);
              if (result_2)
                await result_2;
            }
          }
          return await this.nodeFS.promises.stat(this.path(path3));
        }
        /**
         * Create a file synchronously.
         */
        createFileSync(path3, options) {
          if (isDirectory(options)) {
            this.nodeFS.mkdirSync(this.path(path3), { mode: options.mode });
          } else {
            const fd2 = this.nodeFS.openSync(this.path(path3), "wx");
            this.nodeFS.closeSync(fd2);
          }
          return this.nodeFS.statSync(this.path(path3));
        }
        /**
         * Remove a directory.
         */
        async rmdir(path3) {
          await this.nodeFS.promises.rmdir(this.path(path3));
        }
        /**
         * Remove a directory synchronously.
         */
        rmdirSync(path3) {
          this.nodeFS.rmdirSync(this.path(path3));
        }
        /**
         * Synchronize data to the file system.
         */
        async sync() {
          warn("Sync on passthrough is unnecessary");
        }
        /**
         * Synchronize data to the file system synchronously.
         */
        syncSync() {
          warn("Sync on passthrough is unnecessary");
        }
        /**
         * Create a hard link.
         */
        async link(target, link3) {
          await this.nodeFS.promises.link(this.path(target), this.path(link3));
        }
        /**
         * Create a hard link synchronously.
         */
        linkSync(target, link3) {
          this.nodeFS.linkSync(this.path(target), this.path(link3));
        }
        async read(path3, buffer, offset, end) {
          const env_3 = { stack: [], error: void 0, hasError: false };
          try {
            const handle = __addDisposableResource4(env_3, await this.nodeFS.promises.open(this.path(path3), "r"), true);
            await handle.read({ buffer, offset, length: end - offset });
          } catch (e_3) {
            env_3.error = e_3;
            env_3.hasError = true;
          } finally {
            const result_3 = __disposeResources4(env_3);
            if (result_3)
              await result_3;
          }
        }
        readSync(path3, buffer, offset, end) {
          const fd2 = this.nodeFS.openSync(this.path(path3), "r");
          try {
            this.nodeFS.readSync(fd2, buffer, { offset, length: end - offset });
          } finally {
            this.nodeFS.closeSync(fd2);
          }
        }
        async write(path3, buffer, offset) {
          const env_4 = { stack: [], error: void 0, hasError: false };
          try {
            const handle = __addDisposableResource4(env_4, await this.nodeFS.promises.open(this.path(path3), "w"), true);
            await handle.write(buffer, offset);
          } catch (e_4) {
            env_4.error = e_4;
            env_4.hasError = true;
          } finally {
            const result_4 = __disposeResources4(env_4);
            if (result_4)
              await result_4;
          }
        }
        writeSync(path3, buffer, offset) {
          const fd2 = this.nodeFS.openSync(this.path(path3), "w");
          try {
            this.nodeFS.writeSync(fd2, buffer, offset);
          } finally {
            this.nodeFS.closeSync(fd2);
          }
        }
      };
      _Passthrough = {
        name: "Passthrough",
        options: {
          fs: { type: "object", required: true },
          prefix: { type: "string", required: true }
        },
        create({ fs: fs2, prefix }) {
          return new PassthroughFS(fs2, resolve(prefix));
        }
      };
      Passthrough = _Passthrough;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/shared.js
  var _asyncFSKeys;
  var init_shared2 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/shared.js"() {
      _asyncFSKeys = [
        "rename",
        "stat",
        "touch",
        "createFile",
        "unlink",
        "rmdir",
        "mkdir",
        "readdir",
        "exists",
        "link",
        "sync",
        "read",
        "write"
      ];
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/async.js
  function Async(FS) {
    class AsyncFS extends FS {
      /**
       * @deprecated Use {@link sync | `sync`} instead
       */
      async done() {
        return this.sync();
      }
      /**
       * @deprecated Use {@link sync | `sync`} instead
       */
      queueDone() {
        return this.sync();
      }
      _async(promise) {
        this._promise = this._promise.then(() => promise);
      }
      constructor(...args) {
        super(...args);
        this._promise = Promise.resolve();
        this._isInitialized = false;
        this._skippedCacheUpdates = 0;
        this._patchAsync();
      }
      async ready() {
        await super.ready();
        await this._promise;
        if (this._isInitialized || this.attributes.has("no_async_preload"))
          return;
        this.checkSync();
        await this._sync.ready();
        if (this._sync instanceof StoreFS && this instanceof StoreFS) {
          const sync = this._sync.transaction();
          const async = this.transaction();
          const promises = [];
          for (const key of await async.keys()) {
            promises.push(async.get(key).then((data) => sync.setSync(key, data)));
          }
          await Promise.all(promises);
          this._isInitialized = true;
          return;
        }
        try {
          await this.crossCopy("/");
          debug(`Skipped ${this._skippedCacheUpdates} updates to the sync cache during initialization`);
          this._isInitialized = true;
        } catch (e2) {
          this._isInitialized = false;
          throw crit(e2);
        }
      }
      checkSync() {
        if (this.attributes.has("no_async_preload")) {
          throw withErrno("ENOTSUP", "Sync preloading has been disabled for this async file system");
        }
        if (!this._sync) {
          throw crit(withErrno("ENOTSUP", "No sync cache is attached to this async file system"));
        }
      }
      renameSync(oldPath, newPath) {
        this.checkSync();
        this._sync.renameSync(oldPath, newPath);
        this._async(this.rename(oldPath, newPath));
      }
      statSync(path3) {
        this.checkSync();
        return this._sync.statSync(path3);
      }
      touchSync(path3, metadata) {
        this.checkSync();
        this._sync.touchSync(path3, metadata);
        this._async(this.touch(path3, metadata));
      }
      createFileSync(path3, options) {
        this.checkSync();
        this._async(this.createFile(path3, options));
        return this._sync.createFileSync(path3, options);
      }
      unlinkSync(path3) {
        this.checkSync();
        this._async(this.unlink(path3));
        this._sync.unlinkSync(path3);
      }
      rmdirSync(path3) {
        this.checkSync();
        this._sync.rmdirSync(path3);
        this._async(this.rmdir(path3));
      }
      mkdirSync(path3, options) {
        this.checkSync();
        this._async(this.mkdir(path3, options));
        return this._sync.mkdirSync(path3, options);
      }
      readdirSync(path3) {
        this.checkSync();
        return this._sync.readdirSync(path3);
      }
      linkSync(srcpath, dstpath) {
        this.checkSync();
        this._sync.linkSync(srcpath, dstpath);
        this._async(this.link(srcpath, dstpath));
      }
      async sync() {
        if (!this.attributes.has("no_async_preload") && this._sync)
          this._sync.syncSync();
        await this._promise;
      }
      syncSync() {
        this.checkSync();
        this._sync.syncSync();
      }
      existsSync(path3) {
        this.checkSync();
        return this._sync.existsSync(path3);
      }
      readSync(path3, buffer, offset, end) {
        this.checkSync();
        this._sync.readSync(path3, buffer, offset, end);
      }
      writeSync(path3, buffer, offset) {
        this.checkSync();
        this._sync.writeSync(path3, buffer, offset);
        this._async(this.write(path3, buffer, offset));
      }
      streamWrite(path3, options) {
        this.checkSync();
        const sync = this._sync.streamWrite(path3, options).getWriter();
        const async = super.streamWrite(path3, options).getWriter();
        return new WritableStream({
          async write(chunk, controller) {
            await Promise.all([sync.write(chunk), async.write(chunk)]).catch(controller.error.bind(controller));
          },
          async close() {
            await Promise.all([sync.close(), async.close()]);
          },
          async abort(reason) {
            await Promise.all([sync.abort(reason), async.abort(reason)]);
          }
        });
      }
      /**
       * @internal
       */
      async crossCopy(path3) {
        this.checkSync();
        const stats = await this.stat(path3);
        if (!isDirectory(stats)) {
          this._sync.createFileSync(path3, stats);
          const buffer = new Uint8Array(stats.size);
          await this.read(path3, buffer, 0, stats.size);
          this._sync.writeSync(path3, buffer, 0);
          this._sync.touchSync(path3, stats);
          return;
        }
        if (path3 !== "/") {
          this._sync.mkdirSync(path3, stats);
          this._sync.touchSync(path3, stats);
        }
        const promises = [];
        for (const file of await this.readdir(path3)) {
          promises.push(this.crossCopy(join(path3, file)));
        }
        await Promise.all(promises);
      }
      /**
       * @internal
       * Patch all async methods to also call their synchronous counterparts unless called from themselves (either sync or async)
       */
      _patchAsync() {
        debug(`Async: patched ${_asyncFSKeys.length} methods`);
        for (const key of _asyncFSKeys) {
          const originalMethod = this[key].bind(this);
          this[key] = async (...args) => {
            var _a6, _b3;
            const result = await originalMethod(...args);
            const stack = new Error().stack.split("\n").slice(2).join("\n");
            if (!stack || stack.includes(`at <computed> [as ${key}]`) || stack.includes(`at async <computed> [as ${key}]`) || stack.includes(`${key}Sync `))
              return result;
            if (!this._isInitialized) {
              this._skippedCacheUpdates++;
              return result;
            }
            try {
              (_b3 = (_a6 = this._sync) === null || _a6 === void 0 ? void 0 : _a6[`${key}Sync`]) === null || _b3 === void 0 ? void 0 : _b3.call(_a6, ...args);
            } catch (e2) {
              const stack2 = e2.stack.split("\n").slice(3).join("\n");
              if (stack2.includes(`at <computed> [as ${key}]`) || stack2.includes(`at async <computed> [as ${key}]`) || stack2.includes(`${key}Sync `))
                return result;
              e2.message += " (Out of sync!)";
              throw err(e2);
            }
            return result;
          };
        }
      }
    }
    return AsyncFS;
  }
  var init_async2 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/async.js"() {
      init_shared2();
      init_dist2();
      init_log();
      init_fs();
      init_inode();
      init_path();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/port.js
  function isRPCMessage(arg) {
    return typeof arg == "object" && arg != null && "_zenfs" in arg && !!arg._zenfs;
  }
  function disposeExecutors(id) {
    const executor = executors.get(id);
    if (!executor)
      return;
    if (executor.timeout) {
      clearTimeout(executor.timeout);
      if (typeof executor.timeout == "object")
        executor.timeout.unref();
    }
    executor.fs._executors.delete(id);
    executors.delete(id);
  }
  function request(request4, { port, timeout: ms = 1e3, fs: fs2 }) {
    const stack = "\n" + new Error().stack.slice("Error:".length);
    if (!port)
      throw err(withErrno("EINVAL", "Can not make an RPC request without a port"));
    const { resolve: resolve2, reject, promise } = Promise.withResolvers();
    const id = Math.random().toString(16).slice(10);
    const timeout = setTimeout(() => {
      const error = err(withErrno("EIO", "RPC Failed"));
      error.stack += stack;
      disposeExecutors(id);
      reject(error);
    }, ms);
    const executor = { resolve: resolve2, reject, promise, fs: fs2, timeout };
    fs2._executors.set(id, executor);
    executors.set(id, executor);
    port.postMessage({ ...request4, _zenfs: true, id, stack });
    return promise;
  }
  function __requestMethod(req) {
  }
  function __responseMethod(res, ...t2) {
    return t2.includes(res.method);
  }
  function handleResponse(response) {
    if (!isRPCMessage(response))
      return;
    if (!executors.has(response.id)) {
      const error = err(withErrno("EIO", "Invalid RPC id: " + response.id));
      error.stack += response.stack;
      throw error;
    }
    const { resolve: resolve2, reject } = executors.get(response.id);
    if (response.error) {
      const e2 = Exception.fromJSON({ code: "EIO", errno: Errno.EIO, ...response.error });
      e2.stack += response.stack;
      disposeExecutors(response.id);
      reject(e2);
      return;
    }
    disposeExecutors(response.id);
    resolve2(__responseMethod(response, "stat", "createFile", "mkdir") ? new Inode(response.value) : response.value);
    return;
  }
  function attach(port, handler) {
    if (!port)
      throw err(withErrno("EINVAL", "Cannot attach to non-existent port"));
    info("Attached handler to port: " + handler.name);
    port["on" in port ? "on" : "addEventListener"]("message", (message) => {
      handler(typeof message == "object" && message !== null && "data" in message ? message.data : message);
    });
  }
  function detach(port, handler) {
    if (!port)
      throw err(withErrno("EINVAL", "Cannot detach from non-existent port"));
    info("Detached handler from port: " + handler.name);
    port["off" in port ? "off" : "removeEventListener"]("message", (message) => {
      handler(typeof message == "object" && message !== null && "data" in message ? message.data : message);
    });
  }
  function catchMessages(port) {
    const events = [];
    const handler = events.push.bind(events);
    attach(port, handler);
    return async function(fs2) {
      detach(port, handler);
      for (const event of events) {
        const request4 = "data" in event ? event.data : event;
        await handleRequest(port, fs2, request4);
      }
    };
  }
  async function waitOnline(port) {
    if (!("on" in port))
      return;
    const online = Promise.withResolvers();
    setTimeout(online.reject, 500);
    port.on("online", online.resolve);
    await online.promise;
  }
  async function handleRequest(port, fs2, request4) {
    if (!isRPCMessage(request4))
      return;
    let value, error;
    const transferList = [];
    try {
      switch (request4.method) {
        case "read": {
          __requestMethod(request4);
          const [path3, buffer, start, end] = request4.args;
          await fs2.read(path3, buffer, start, end);
          value = buffer;
          break;
        }
        case "stat":
        case "createFile":
        case "mkdir": {
          __requestMethod(request4);
          const md = await fs2[request4.method](...request4.args);
          const inode = md instanceof Inode ? md : new Inode(md);
          value = new Uint8Array(inode.buffer, inode.byteOffset, inode.byteLength);
          break;
        }
        case "touch": {
          __requestMethod(request4);
          const [path3, metadata] = request4.args;
          await fs2.touch(path3, new Inode(metadata));
          value = void 0;
          break;
        }
        default:
          value = await fs2[request4.method](...request4.args);
      }
    } catch (e2) {
      error = e2 instanceof Exception ? e2.toJSON() : pick(e2, "message", "stack");
    }
    port.postMessage({ _zenfs: true, ...pick(request4, "id", "method", "stack"), error, value }, transferList);
  }
  function attachFS(port, fs2) {
    attach(port, (request4) => handleRequest(port, fs2, request4));
  }
  function detachFS(port, fs2) {
    detach(port, (request4) => handleRequest(port, fs2, request4));
  }
  async function resolveRemoteMount(port, config, _depth = 0) {
    const stopAndReplay = catchMessages(port);
    const fs2 = await resolveMountConfig(config, _depth);
    attachFS(port, fs2);
    await stopAndReplay(fs2);
    info("Resolved remote mount: " + fs2.toString());
    return fs2;
  }
  var executors, PortFS, _Port, Port;
  var init_port = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/port.js"() {
      init_dist2();
      init_log();
      init_dist();
      init_config2();
      init_filesystem();
      init_inode();
      init_async2();
      init_polyfills();
      init_backend();
      init_memory();
      executors = /* @__PURE__ */ new Map();
      PortFS = class extends Async(FileSystem) {
        /**
         * Constructs a new PortFS instance that connects with the FS running on `options.port`.
         */
        constructor(options) {
          super(1886351988, "portfs");
          this.options = options;
          this._executors = /* @__PURE__ */ new Map();
          this._sync = InMemory.create({ label: "tmpfs:port" });
          this.port = options.port;
          attach(this.port, handleResponse);
        }
        rpc(method, ...args) {
          return request({ method, args }, {
            ...this.options,
            fs: this
          });
        }
        async ready() {
          await this.rpc("ready");
          await super.ready();
        }
        rename(oldPath, newPath) {
          return this.rpc("rename", oldPath, newPath);
        }
        async stat(path3) {
          const result = await this.rpc("stat", path3);
          return result instanceof Inode ? result : new Inode(result);
        }
        async touch(path3, metadata) {
          const inode = metadata instanceof Inode ? metadata : new Inode(metadata);
          await this.rpc("touch", path3, new Uint8Array(inode.buffer, inode.byteOffset, inode.byteLength));
        }
        async sync() {
          await this.rpc("sync");
          for (const executor of this._executors.values()) {
            await executor.promise.catch(() => {
            });
          }
        }
        async createFile(path3, options) {
          if (options instanceof Inode)
            options = options.toJSON();
          const result = await this.rpc("createFile", path3, options);
          return result instanceof Inode ? result : new Inode(result);
        }
        unlink(path3) {
          return this.rpc("unlink", path3);
        }
        rmdir(path3) {
          return this.rpc("rmdir", path3);
        }
        async mkdir(path3, options) {
          if (options instanceof Inode)
            options = options.toJSON();
          const result = await this.rpc("mkdir", path3, options);
          return result instanceof Inode ? result : new Inode(result);
        }
        readdir(path3) {
          return this.rpc("readdir", path3);
        }
        exists(path3) {
          return this.rpc("exists", path3);
        }
        link(srcpath, dstpath) {
          return this.rpc("link", srcpath, dstpath);
        }
        async read(path3, buffer, start, end) {
          buffer.set(await this.rpc("read", path3, buffer, start, end));
        }
        write(path3, buffer, offset) {
          return this.rpc("write", path3, buffer, offset);
        }
      };
      _Port = {
        name: "Port",
        options: {
          port: {
            type: _fnOpt("RPCPort", (port) => typeof (port === null || port === void 0 ? void 0 : port.postMessage) == "function"),
            required: true
          },
          timeout: { type: "number", required: false }
        },
        create(options) {
          return new PortFS(options);
        }
      };
      Port = _Port;
    }
  });

  // ../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/checksum.js
  function crc32c(data) {
    let crc = 4294967295;
    for (let i2 = 0; i2 < data.length; i2++) {
      crc = crc >>> 8 ^ crc32cTable[(crc ^ data[i2]) & 255];
    }
    return (crc ^ 4294967295) >>> 0;
  }
  var crc32cTable;
  var init_checksum = __esm({
    "../../node_modules/.pnpm/utilium@2.3.3/node_modules/utilium/dist/checksum.js"() {
      crc32cTable = new Uint32Array(256);
      for (let i2 = 0; i2 < 256; i2++) {
        let value = i2;
        for (let j = 0; j < 8; j++) {
          value = value & 1 ? 2197175160 ^ value >>> 1 : value >>> 1;
        }
        crc32cTable[i2] = value;
      }
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/single_buffer.js
  function checksum(value) {
    return crc32c(new Uint8Array(value.buffer, value.byteOffset + 4, sizeof(value) - 4));
  }
  function _update(value) {
    if (value instanceof MetadataBlock)
      value.timestamp = BigInt(Date.now());
    value.checksum = checksum(value);
  }
  var __esDecorate3, __runInitializers3, __addDisposableResource5, __disposeResources5, __setFunctionName3, __classPrivateFieldGet3, __classPrivateFieldSet3, format3, MetadataEntry, entries_per_block, max_lock_attempts, MetadataBlock, sb_magic, SuperBlock, SingleBufferStore, _SingleBuffer, SingleBuffer;
  var init_single_buffer = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/single_buffer.js"() {
      init_dist2();
      init_log();
      init_dist3();
      init_buffer();
      init_checksum();
      init_string();
      init_inode();
      init_fs();
      init_map();
      __esDecorate3 = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
        function accept(f) {
          if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
          return f;
        }
        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
        var _2, done = false;
        for (var i2 = decorators.length - 1; i2 >= 0; i2--) {
          var context = {};
          for (var p12 in contextIn) context[p12] = p12 === "access" ? {} : contextIn[p12];
          for (var p12 in contextIn.access) context.access[p12] = contextIn.access[p12];
          context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
          };
          var result = (0, decorators[i2])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
          if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_2 = accept(result.get)) descriptor.get = _2;
            if (_2 = accept(result.set)) descriptor.set = _2;
            if (_2 = accept(result.init)) initializers.unshift(_2);
          } else if (_2 = accept(result)) {
            if (kind === "field") initializers.unshift(_2);
            else descriptor[key] = _2;
          }
        }
        if (target) Object.defineProperty(target, contextIn.name, descriptor);
        done = true;
      };
      __runInitializers3 = function(thisArg, initializers, value) {
        var useValue = arguments.length > 2;
        for (var i2 = 0; i2 < initializers.length; i2++) {
          value = useValue ? initializers[i2].call(thisArg, value) : initializers[i2].call(thisArg);
        }
        return useValue ? value : void 0;
      };
      __addDisposableResource5 = function(env, value, async) {
        if (value !== null && value !== void 0) {
          if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
          var dispose, inner;
          if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
          }
          if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
          }
          if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
          if (inner) dispose = function() {
            try {
              inner.call(this);
            } catch (e2) {
              return Promise.reject(e2);
            }
          };
          env.stack.push({ value, dispose, async });
        } else if (async) {
          env.stack.push({ async: true });
        }
        return value;
      };
      __disposeResources5 = /* @__PURE__ */ function(SuppressedError2) {
        return function(env) {
          function fail(e2) {
            env.error = env.hasError ? new SuppressedError2(e2, env.error, "An error was suppressed during disposal.") : e2;
            env.hasError = true;
          }
          var r2, s2 = 0;
          function next() {
            while (r2 = env.stack.pop()) {
              try {
                if (!r2.async && s2 === 1) return s2 = 0, env.stack.push(r2), Promise.resolve().then(next);
                if (r2.dispose) {
                  var result = r2.dispose.call(r2.value);
                  if (r2.async) return s2 |= 2, Promise.resolve(result).then(next, function(e2) {
                    fail(e2);
                    return next();
                  });
                } else s2 |= 1;
              } catch (e2) {
                fail(e2);
              }
            }
            if (s2 === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
            if (env.hasError) throw env.error;
          }
          return next();
        };
      }(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
        var e2 = new Error(message);
        return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
      });
      __setFunctionName3 = function(f, name2, prefix) {
        if (typeof name2 === "symbol") name2 = name2.description ? "[".concat(name2.description, "]") : "";
        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name2) : name2 });
      };
      __classPrivateFieldGet3 = function(receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
      };
      __classPrivateFieldSet3 = function(receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
      };
      ({ format: format3 } = new Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 2,
        unit: "byte",
        unitDisplay: "narrow"
      }));
      MetadataEntry = (() => {
        var _MetadataEntry_id_accessor_storage, _MetadataEntry_offset__accessor_storage, _MetadataEntry_offset_accessor_storage, _MetadataEntry_size_accessor_storage;
        var _a6, _b3, _c2, _d;
        let _classDecorators = [struct(packed)];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = BufferView;
        let _id_decorators;
        let _id_initializers = [];
        let _id_extraInitializers = [];
        let _offset__decorators;
        let _offset__initializers = [];
        let _offset__extraInitializers = [];
        let _offset_decorators;
        let _offset_initializers = [];
        let _offset_extraInitializers = [];
        let _size_decorators;
        let _size_initializers = [];
        let _size_extraInitializers = [];
        var MetadataEntry2 = _classThis = class extends _classSuper {
          /** Inode or data ID */
          get id() {
            return __classPrivateFieldGet3(this, _MetadataEntry_id_accessor_storage, "f");
          }
          set id(value) {
            __classPrivateFieldSet3(this, _MetadataEntry_id_accessor_storage, value, "f");
          }
          /** Reserved for 64-bit offset expansion */
          get offset_() {
            return __classPrivateFieldGet3(this, _MetadataEntry_offset__accessor_storage, "f");
          }
          set offset_(value) {
            __classPrivateFieldSet3(this, _MetadataEntry_offset__accessor_storage, value, "f");
          }
          /** Offset into the buffer the data is stored at. */
          get offset() {
            return __classPrivateFieldGet3(this, _MetadataEntry_offset_accessor_storage, "f");
          }
          set offset(value) {
            __classPrivateFieldSet3(this, _MetadataEntry_offset_accessor_storage, value, "f");
          }
          /** The size of the data */
          get size() {
            return __classPrivateFieldGet3(this, _MetadataEntry_size_accessor_storage, "f");
          }
          set size(value) {
            __classPrivateFieldSet3(this, _MetadataEntry_size_accessor_storage, value, "f");
          }
          toString() {
            return `<MetadataEntry @ 0x${this.byteOffset.toString(16).padStart(8, "0")}>`;
          }
          constructor() {
            super(...arguments);
            _MetadataEntry_id_accessor_storage.set(this, __runInitializers3(this, _id_initializers, void 0));
            _MetadataEntry_offset__accessor_storage.set(this, (__runInitializers3(this, _id_extraInitializers), __runInitializers3(this, _offset__initializers, void 0)));
            _MetadataEntry_offset_accessor_storage.set(this, (__runInitializers3(this, _offset__extraInitializers), __runInitializers3(this, _offset_initializers, void 0)));
            _MetadataEntry_size_accessor_storage.set(this, (__runInitializers3(this, _offset_extraInitializers), __runInitializers3(this, _size_initializers, void 0)));
            __runInitializers3(this, _size_extraInitializers);
          }
        };
        _MetadataEntry_id_accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataEntry_offset__accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataEntry_offset_accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataEntry_size_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName3(_classThis, "MetadataEntry");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _id_decorators = [(_a7 = types2).uint32.bind(_a7)];
          _offset__decorators = [(_b3 = types2).uint32.bind(_b3)];
          _offset_decorators = [(_c2 = types2).uint32.bind(_c2)];
          _size_decorators = [(_d = types2).uint32.bind(_d)];
          __esDecorate3(_classThis, null, _id_decorators, { kind: "accessor", name: "id", static: false, private: false, access: { has: (obj) => "id" in obj, get: (obj) => obj.id, set: (obj, value) => {
            obj.id = value;
          } }, metadata: _metadata }, _id_initializers, _id_extraInitializers);
          __esDecorate3(_classThis, null, _offset__decorators, { kind: "accessor", name: "offset_", static: false, private: false, access: { has: (obj) => "offset_" in obj, get: (obj) => obj.offset_, set: (obj, value) => {
            obj.offset_ = value;
          } }, metadata: _metadata }, _offset__initializers, _offset__extraInitializers);
          __esDecorate3(_classThis, null, _offset_decorators, { kind: "accessor", name: "offset", static: false, private: false, access: { has: (obj) => "offset" in obj, get: (obj) => obj.offset, set: (obj, value) => {
            obj.offset = value;
          } }, metadata: _metadata }, _offset_initializers, _offset_extraInitializers);
          __esDecorate3(_classThis, null, _size_decorators, { kind: "accessor", name: "size", static: false, private: false, access: { has: (obj) => "size" in obj, get: (obj) => obj.size, set: (obj, value) => {
            obj.size = value;
          } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
          __esDecorate3(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          MetadataEntry2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers3(_classThis, _classExtraInitializers);
        })();
        return MetadataEntry2 = _classThis;
      })();
      entries_per_block = 255;
      max_lock_attempts = 5;
      MetadataBlock = (() => {
        var _MetadataBlock_checksum_accessor_storage, _MetadataBlock_timestamp_accessor_storage, _MetadataBlock_previous_offset_accessor_storage, _MetadataBlock_items_accessor_storage, _MetadataBlock_locked_accessor_storage;
        var _a6, _b3, _c2, _d;
        let _classDecorators = [struct(packed)];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = Int32Array;
        let _checksum_decorators;
        let _checksum_initializers = [];
        let _checksum_extraInitializers = [];
        let _timestamp_decorators;
        let _timestamp_initializers = [];
        let _timestamp_extraInitializers = [];
        let _previous_offset_decorators;
        let _previous_offset_initializers = [];
        let _previous_offset_extraInitializers = [];
        let _items_decorators;
        let _items_initializers = [];
        let _items_extraInitializers = [];
        let _locked_decorators;
        let _locked_initializers = [];
        let _locked_extraInitializers = [];
        var MetadataBlock2 = _classThis = class extends _classSuper {
          /**
           * The crc32c checksum for the metadata block.
           * @privateRemarks Keep this first!
           */
          get checksum() {
            return __classPrivateFieldGet3(this, _MetadataBlock_checksum_accessor_storage, "f");
          }
          set checksum(value) {
            __classPrivateFieldSet3(this, _MetadataBlock_checksum_accessor_storage, value, "f");
          }
          /** The (last) time this metadata block was updated */
          get timestamp() {
            return __classPrivateFieldGet3(this, _MetadataBlock_timestamp_accessor_storage, "f");
          }
          set timestamp(value) {
            __classPrivateFieldSet3(this, _MetadataBlock_timestamp_accessor_storage, value, "f");
          }
          /** Offset to the previous metadata block */
          get previous_offset() {
            return __classPrivateFieldGet3(this, _MetadataBlock_previous_offset_accessor_storage, "f");
          }
          set previous_offset(value) {
            __classPrivateFieldSet3(this, _MetadataBlock_previous_offset_accessor_storage, value, "f");
          }
          get previous() {
            var _a7;
            if (!this.previous_offset)
              return;
            (_a7 = this._previous) !== null && _a7 !== void 0 ? _a7 : this._previous = new MetadataBlock2(this.buffer, this.previous_offset);
            return this._previous;
          }
          get offsetHex() {
            return "0x" + this.byteOffset.toString(16).padStart(8, "0");
          }
          /** Metadata entries. */
          get items() {
            return __classPrivateFieldGet3(this, _MetadataBlock_items_accessor_storage, "f");
          }
          set items(value) {
            __classPrivateFieldSet3(this, _MetadataBlock_items_accessor_storage, value, "f");
          }
          toString(long = false) {
            if (!long)
              return `<MetadataBlock @ ${this.offsetHex}>`;
            let text = [
              `---- Metadata block at ${this.offsetHex} ----`,
              `Checksum: 0x${this.checksum.toString(16).padStart(8, "0")}`,
              `Last updated: ${new Date(Number(this.timestamp)).toLocaleString()}`,
              `Previous block: 0x${this.previous_offset.toString(16).padStart(8, "0")}`,
              "Entries:"
            ].join("\n");
            for (const entry of this.items) {
              if (!entry.offset)
                continue;
              text += `
	0x${entry.id.toString(16).padStart(8, "0")}: ${format3(entry.size).padStart(5)} at 0x${entry.offset.toString(16).padStart(8, "0")}`;
            }
            return text;
          }
          /**
           * If non-zero, this block is locked for writing.
           * Note a int32 is used for `Atomics.wait`
           */
          get locked() {
            return __classPrivateFieldGet3(this, _MetadataBlock_locked_accessor_storage, "f");
          }
          set locked(value) {
            __classPrivateFieldSet3(this, _MetadataBlock_locked_accessor_storage, value, "f");
          }
          /**
           * Wait for the block to be unlocked.
           */
          waitUnlocked(depth = 0) {
            if (depth > max_lock_attempts)
              throw crit(withErrno("EBUSY", `sbfs: exceeded max attempts waiting for metadata block at ${this.offsetHex} to be unlocked`));
            const i2 = this.length - 1;
            if (!Atomics.load(this, i2))
              return;
            switch (Atomics.wait(this, i2, 1)) {
              case "ok":
                break;
              case "not-equal":
                depth++;
                err(`sbfs: waiting for metadata block at ${this.offsetHex} to be unlocked (${depth}/${max_lock_attempts})`);
                return this.waitUnlocked(depth);
              case "timed-out":
                throw crit(withErrno("EBUSY", `sbfs: timed out waiting for metadata block at ${this.offsetHex} to be unlocked`));
            }
          }
          lock() {
            this.waitUnlocked();
            const i2 = offsetof(this, "locked");
            Atomics.store(this, i2, 1);
            const release = () => {
              Atomics.store(this, i2, 0);
              Atomics.notify(this, i2, 1);
            };
            release[Symbol.dispose] = release;
            return release;
          }
          constructor() {
            super(...arguments);
            _MetadataBlock_checksum_accessor_storage.set(this, __runInitializers3(this, _checksum_initializers, void 0));
            _MetadataBlock_timestamp_accessor_storage.set(this, (__runInitializers3(this, _checksum_extraInitializers), __runInitializers3(this, _timestamp_initializers, BigInt(Date.now()))));
            _MetadataBlock_previous_offset_accessor_storage.set(this, (__runInitializers3(this, _timestamp_extraInitializers), __runInitializers3(this, _previous_offset_initializers, void 0)));
            this._previous = __runInitializers3(this, _previous_offset_extraInitializers);
            _MetadataBlock_items_accessor_storage.set(this, __runInitializers3(this, _items_initializers, void 0));
            _MetadataBlock_locked_accessor_storage.set(this, (__runInitializers3(this, _items_extraInitializers), __runInitializers3(this, _locked_initializers, void 0)));
            __runInitializers3(this, _locked_extraInitializers);
          }
        };
        _MetadataBlock_checksum_accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataBlock_timestamp_accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataBlock_previous_offset_accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataBlock_items_accessor_storage = /* @__PURE__ */ new WeakMap();
        _MetadataBlock_locked_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName3(_classThis, "MetadataBlock");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _checksum_decorators = [(_a7 = types2).uint32.bind(_a7)];
          _timestamp_decorators = [(_b3 = types2).uint64.bind(_b3)];
          _previous_offset_decorators = [(_c2 = types2).uint32.bind(_c2)];
          _items_decorators = [field(MetadataEntry, { length: entries_per_block })];
          _locked_decorators = [(_d = types2).int32.bind(_d)];
          __esDecorate3(_classThis, null, _checksum_decorators, { kind: "accessor", name: "checksum", static: false, private: false, access: { has: (obj) => "checksum" in obj, get: (obj) => obj.checksum, set: (obj, value) => {
            obj.checksum = value;
          } }, metadata: _metadata }, _checksum_initializers, _checksum_extraInitializers);
          __esDecorate3(_classThis, null, _timestamp_decorators, { kind: "accessor", name: "timestamp", static: false, private: false, access: { has: (obj) => "timestamp" in obj, get: (obj) => obj.timestamp, set: (obj, value) => {
            obj.timestamp = value;
          } }, metadata: _metadata }, _timestamp_initializers, _timestamp_extraInitializers);
          __esDecorate3(_classThis, null, _previous_offset_decorators, { kind: "accessor", name: "previous_offset", static: false, private: false, access: { has: (obj) => "previous_offset" in obj, get: (obj) => obj.previous_offset, set: (obj, value) => {
            obj.previous_offset = value;
          } }, metadata: _metadata }, _previous_offset_initializers, _previous_offset_extraInitializers);
          __esDecorate3(_classThis, null, _items_decorators, { kind: "accessor", name: "items", static: false, private: false, access: { has: (obj) => "items" in obj, get: (obj) => obj.items, set: (obj, value) => {
            obj.items = value;
          } }, metadata: _metadata }, _items_initializers, _items_extraInitializers);
          __esDecorate3(_classThis, null, _locked_decorators, { kind: "accessor", name: "locked", static: false, private: false, access: { has: (obj) => "locked" in obj, get: (obj) => obj.locked, set: (obj, value) => {
            obj.locked = value;
          } }, metadata: _metadata }, _locked_initializers, _locked_extraInitializers);
          __esDecorate3(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          MetadataBlock2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers3(_classThis, _classExtraInitializers);
        })();
        return MetadataBlock2 = _classThis;
      })();
      sb_magic = 1651715706;
      SuperBlock = (() => {
        var _SuperBlock_checksum_accessor_storage, _SuperBlock_magic_accessor_storage, _SuperBlock_version_accessor_storage, _SuperBlock_inode_format_accessor_storage, _SuperBlock_flags_accessor_storage, _SuperBlock_used_bytes_accessor_storage, _SuperBlock_total_bytes_accessor_storage, _SuperBlock_uuid_accessor_storage, _SuperBlock_metadata_block_size_accessor_storage, _SuperBlock_metadata_offset__accessor_storage, _SuperBlock_metadata_offset_accessor_storage, _SuperBlock_label_accessor_storage, _SuperBlock__padding_accessor_storage;
        var _a6, _b3, _c2, _d, _e, _f, _g, _h, _j, _k;
        let _classDecorators = [struct(packed)];
        let _classDescriptor;
        let _classExtraInitializers = [];
        let _classThis;
        let _classSuper = BufferView;
        let _checksum_decorators;
        let _checksum_initializers = [];
        let _checksum_extraInitializers = [];
        let _magic_decorators;
        let _magic_initializers = [];
        let _magic_extraInitializers = [];
        let _version_decorators;
        let _version_initializers = [];
        let _version_extraInitializers = [];
        let _inode_format_decorators;
        let _inode_format_initializers = [];
        let _inode_format_extraInitializers = [];
        let _flags_decorators;
        let _flags_initializers = [];
        let _flags_extraInitializers = [];
        let _used_bytes_decorators;
        let _used_bytes_initializers = [];
        let _used_bytes_extraInitializers = [];
        let _total_bytes_decorators;
        let _total_bytes_initializers = [];
        let _total_bytes_extraInitializers = [];
        let _uuid_decorators;
        let _uuid_initializers = [];
        let _uuid_extraInitializers = [];
        let _metadata_block_size_decorators;
        let _metadata_block_size_initializers = [];
        let _metadata_block_size_extraInitializers = [];
        let _metadata_offset__decorators;
        let _metadata_offset__initializers = [];
        let _metadata_offset__extraInitializers = [];
        let _metadata_offset_decorators;
        let _metadata_offset_initializers = [];
        let _metadata_offset_extraInitializers = [];
        let _label_decorators;
        let _label_initializers = [];
        let _label_extraInitializers = [];
        let __padding_decorators;
        let __padding_initializers = [];
        let __padding_extraInitializers = [];
        var SuperBlock2 = _classThis = class extends _classSuper {
          constructor(...args) {
            super(...args);
            _SuperBlock_checksum_accessor_storage.set(this, __runInitializers3(this, _checksum_initializers, void 0));
            _SuperBlock_magic_accessor_storage.set(this, (__runInitializers3(this, _checksum_extraInitializers), __runInitializers3(this, _magic_initializers, void 0)));
            _SuperBlock_version_accessor_storage.set(this, (__runInitializers3(this, _magic_extraInitializers), __runInitializers3(this, _version_initializers, void 0)));
            _SuperBlock_inode_format_accessor_storage.set(this, (__runInitializers3(this, _version_extraInitializers), __runInitializers3(this, _inode_format_initializers, void 0)));
            _SuperBlock_flags_accessor_storage.set(this, (__runInitializers3(this, _inode_format_extraInitializers), __runInitializers3(this, _flags_initializers, void 0)));
            _SuperBlock_used_bytes_accessor_storage.set(this, (__runInitializers3(this, _flags_extraInitializers), __runInitializers3(this, _used_bytes_initializers, void 0)));
            _SuperBlock_total_bytes_accessor_storage.set(this, (__runInitializers3(this, _used_bytes_extraInitializers), __runInitializers3(this, _total_bytes_initializers, void 0)));
            _SuperBlock_uuid_accessor_storage.set(this, (__runInitializers3(this, _total_bytes_extraInitializers), __runInitializers3(this, _uuid_initializers, void 0)));
            _SuperBlock_metadata_block_size_accessor_storage.set(this, (__runInitializers3(this, _uuid_extraInitializers), __runInitializers3(this, _metadata_block_size_initializers, void 0)));
            _SuperBlock_metadata_offset__accessor_storage.set(this, (__runInitializers3(this, _metadata_block_size_extraInitializers), __runInitializers3(this, _metadata_offset__initializers, void 0)));
            _SuperBlock_metadata_offset_accessor_storage.set(this, (__runInitializers3(this, _metadata_offset__extraInitializers), __runInitializers3(this, _metadata_offset_initializers, void 0)));
            this.metadata = __runInitializers3(this, _metadata_offset_extraInitializers);
            _SuperBlock_label_accessor_storage.set(this, __runInitializers3(this, _label_initializers, void 0));
            _SuperBlock__padding_accessor_storage.set(this, (__runInitializers3(this, _label_extraInitializers), __runInitializers3(this, __padding_initializers, void 0)));
            __runInitializers3(this, __padding_extraInitializers);
            if (this.magic != sb_magic) {
              warn("sbfs: Invalid magic value, assuming this is a fresh super block");
              const md = new MetadataBlock(this.buffer, sizeof(SuperBlock2));
              Object.assign(this, {
                metadata: md,
                metadata_offset: md.byteOffset,
                used_bytes: BigInt(sizeof(SuperBlock2) + sizeof(MetadataBlock)),
                total_bytes: BigInt(this.buffer.byteLength),
                magic: sb_magic,
                version: 1,
                inode_format: _inode_version,
                metadata_block_size: sizeof(MetadataBlock),
                uuid: encodeUUID(crypto.randomUUID())
              });
              _update(this);
              _update(md);
              return;
            }
            if (this.checksum !== checksum(this))
              throw crit(withErrno("EIO", "sbfs: checksum mismatch for super block"));
            this.metadata = new MetadataBlock(this.buffer, this.metadata_offset);
            if (this.metadata.checksum !== checksum(this.metadata))
              throw crit(withErrno("EIO", `sbfs: checksum mismatch for metadata block (saved ${this.metadata.checksum.toString(16).padStart(8, "0")}, computed ${checksum(this.metadata).toString(16).padStart(8, "0")})`));
            if (this.inode_format != _inode_version)
              throw crit(withErrno("EIO", "sbfs: inode format mismatch"));
            if (this.metadata_block_size != sizeof(MetadataBlock))
              throw crit(withErrno("EIO", "sbfs: metadata block size mismatch"));
          }
          /**
           * The crc32c checksum for the super block.
           * @privateRemarks Keep this first!
           */
          get checksum() {
            return __classPrivateFieldGet3(this, _SuperBlock_checksum_accessor_storage, "f");
          }
          set checksum(value) {
            __classPrivateFieldSet3(this, _SuperBlock_checksum_accessor_storage, value, "f");
          }
          /** Signature for the superblock. */
          get magic() {
            return __classPrivateFieldGet3(this, _SuperBlock_magic_accessor_storage, "f");
          }
          set magic(value) {
            __classPrivateFieldSet3(this, _SuperBlock_magic_accessor_storage, value, "f");
          }
          /** The version of the on-disk format */
          get version() {
            return __classPrivateFieldGet3(this, _SuperBlock_version_accessor_storage, "f");
          }
          set version(value) {
            __classPrivateFieldSet3(this, _SuperBlock_version_accessor_storage, value, "f");
          }
          /** Which format of `Inode` is used */
          get inode_format() {
            return __classPrivateFieldGet3(this, _SuperBlock_inode_format_accessor_storage, "f");
          }
          set inode_format(value) {
            __classPrivateFieldSet3(this, _SuperBlock_inode_format_accessor_storage, value, "f");
          }
          /** Flags for the file system. Currently unused */
          get flags() {
            return __classPrivateFieldGet3(this, _SuperBlock_flags_accessor_storage, "f");
          }
          set flags(value) {
            __classPrivateFieldSet3(this, _SuperBlock_flags_accessor_storage, value, "f");
          }
          /** The number of used bytes, including the super block and metadata */
          get used_bytes() {
            return __classPrivateFieldGet3(this, _SuperBlock_used_bytes_accessor_storage, "f");
          }
          set used_bytes(value) {
            __classPrivateFieldSet3(this, _SuperBlock_used_bytes_accessor_storage, value, "f");
          }
          /** The total size of the entire file system, including the super block and metadata */
          get total_bytes() {
            return __classPrivateFieldGet3(this, _SuperBlock_total_bytes_accessor_storage, "f");
          }
          set total_bytes(value) {
            __classPrivateFieldSet3(this, _SuperBlock_total_bytes_accessor_storage, value, "f");
          }
          /** A UUID for this file system */
          get uuid() {
            return __classPrivateFieldGet3(this, _SuperBlock_uuid_accessor_storage, "f");
          }
          set uuid(value) {
            __classPrivateFieldSet3(this, _SuperBlock_uuid_accessor_storage, value, "f");
          }
          /**
           * The size in bytes of a metadata block.
           * Not currently configurable.
           */
          get metadata_block_size() {
            return __classPrivateFieldGet3(this, _SuperBlock_metadata_block_size_accessor_storage, "f");
          }
          set metadata_block_size(value) {
            __classPrivateFieldSet3(this, _SuperBlock_metadata_block_size_accessor_storage, value, "f");
          }
          /** Reserved for 64-bit offset expansion */
          get metadata_offset_() {
            return __classPrivateFieldGet3(this, _SuperBlock_metadata_offset__accessor_storage, "f");
          }
          set metadata_offset_(value) {
            __classPrivateFieldSet3(this, _SuperBlock_metadata_offset__accessor_storage, value, "f");
          }
          /** Offset of the current metadata block */
          get metadata_offset() {
            return __classPrivateFieldGet3(this, _SuperBlock_metadata_offset_accessor_storage, "f");
          }
          set metadata_offset(value) {
            __classPrivateFieldSet3(this, _SuperBlock_metadata_offset_accessor_storage, value, "f");
          }
          /** An optional label for the file system */
          get label() {
            return __classPrivateFieldGet3(this, _SuperBlock_label_accessor_storage, "f");
          }
          set label(value) {
            __classPrivateFieldSet3(this, _SuperBlock_label_accessor_storage, value, "f");
          }
          /** Padded to 256 bytes */
          get _padding() {
            return __classPrivateFieldGet3(this, _SuperBlock__padding_accessor_storage, "f");
          }
          set _padding(value) {
            __classPrivateFieldSet3(this, _SuperBlock__padding_accessor_storage, value, "f");
          }
          /**
           * Rotate out the current metadata block.
           * Allocates a new metadata block, moves the current one to backup,
           * and updates used_bytes accordingly.
           * @returns the new metadata block
           */
          rotateMetadata() {
            const metadata = new MetadataBlock(this.buffer, Number(this.used_bytes));
            metadata.previous_offset = this.metadata_offset;
            this.metadata = metadata;
            this.metadata_offset = metadata.byteOffset;
            _update(metadata);
            this.used_bytes += BigInt(sizeof(MetadataBlock));
            _update(this);
            return metadata;
          }
          /**
           * Checks to see if `length` bytes are unused, starting at `offset`.
           * @internal Not for external use!
           */
          isUnused(offset, length2) {
            if (!length2)
              return true;
            if (offset + length2 > this.total_bytes || offset < sizeof(SuperBlock2))
              return false;
            for (let block = this.metadata; block; block = block.previous) {
              if (offset < block.byteOffset + sizeof(MetadataBlock) && offset + length2 > block.byteOffset)
                return false;
              for (const entry of block.items) {
                if (!entry.offset)
                  continue;
                if (offset >= entry.offset && offset < entry.offset + entry.size || offset + length2 > entry.offset && offset + length2 <= entry.offset + entry.size || offset <= entry.offset && offset + length2 >= entry.offset + entry.size) {
                  return false;
                }
              }
            }
            return true;
          }
        };
        _SuperBlock_checksum_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_magic_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_version_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_inode_format_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_flags_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_used_bytes_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_total_bytes_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_uuid_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_metadata_block_size_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_metadata_offset__accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_metadata_offset_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock_label_accessor_storage = /* @__PURE__ */ new WeakMap();
        _SuperBlock__padding_accessor_storage = /* @__PURE__ */ new WeakMap();
        __setFunctionName3(_classThis, "SuperBlock");
        (() => {
          var _a7;
          const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a7 = _classSuper[Symbol.metadata]) !== null && _a7 !== void 0 ? _a7 : null) : void 0;
          _checksum_decorators = [(_a7 = types2).uint32.bind(_a7)];
          _magic_decorators = [(_b3 = types2).uint32.bind(_b3)];
          _version_decorators = [(_c2 = types2).uint16.bind(_c2)];
          _inode_format_decorators = [(_d = types2).uint16.bind(_d)];
          _flags_decorators = [(_e = types2).uint32.bind(_e)];
          _used_bytes_decorators = [(_f = types2).uint64.bind(_f)];
          _total_bytes_decorators = [(_g = types2).uint64.bind(_g)];
          _uuid_decorators = [types2.uint8(16)];
          _metadata_block_size_decorators = [(_h = types2).uint32.bind(_h)];
          _metadata_offset__decorators = [(_j = types2).uint32.bind(_j)];
          _metadata_offset_decorators = [(_k = types2).uint32.bind(_k)];
          _label_decorators = [types2.char(64)];
          __padding_decorators = [types2.char(132)];
          __esDecorate3(_classThis, null, _checksum_decorators, { kind: "accessor", name: "checksum", static: false, private: false, access: { has: (obj) => "checksum" in obj, get: (obj) => obj.checksum, set: (obj, value) => {
            obj.checksum = value;
          } }, metadata: _metadata }, _checksum_initializers, _checksum_extraInitializers);
          __esDecorate3(_classThis, null, _magic_decorators, { kind: "accessor", name: "magic", static: false, private: false, access: { has: (obj) => "magic" in obj, get: (obj) => obj.magic, set: (obj, value) => {
            obj.magic = value;
          } }, metadata: _metadata }, _magic_initializers, _magic_extraInitializers);
          __esDecorate3(_classThis, null, _version_decorators, { kind: "accessor", name: "version", static: false, private: false, access: { has: (obj) => "version" in obj, get: (obj) => obj.version, set: (obj, value) => {
            obj.version = value;
          } }, metadata: _metadata }, _version_initializers, _version_extraInitializers);
          __esDecorate3(_classThis, null, _inode_format_decorators, { kind: "accessor", name: "inode_format", static: false, private: false, access: { has: (obj) => "inode_format" in obj, get: (obj) => obj.inode_format, set: (obj, value) => {
            obj.inode_format = value;
          } }, metadata: _metadata }, _inode_format_initializers, _inode_format_extraInitializers);
          __esDecorate3(_classThis, null, _flags_decorators, { kind: "accessor", name: "flags", static: false, private: false, access: { has: (obj) => "flags" in obj, get: (obj) => obj.flags, set: (obj, value) => {
            obj.flags = value;
          } }, metadata: _metadata }, _flags_initializers, _flags_extraInitializers);
          __esDecorate3(_classThis, null, _used_bytes_decorators, { kind: "accessor", name: "used_bytes", static: false, private: false, access: { has: (obj) => "used_bytes" in obj, get: (obj) => obj.used_bytes, set: (obj, value) => {
            obj.used_bytes = value;
          } }, metadata: _metadata }, _used_bytes_initializers, _used_bytes_extraInitializers);
          __esDecorate3(_classThis, null, _total_bytes_decorators, { kind: "accessor", name: "total_bytes", static: false, private: false, access: { has: (obj) => "total_bytes" in obj, get: (obj) => obj.total_bytes, set: (obj, value) => {
            obj.total_bytes = value;
          } }, metadata: _metadata }, _total_bytes_initializers, _total_bytes_extraInitializers);
          __esDecorate3(_classThis, null, _uuid_decorators, { kind: "accessor", name: "uuid", static: false, private: false, access: { has: (obj) => "uuid" in obj, get: (obj) => obj.uuid, set: (obj, value) => {
            obj.uuid = value;
          } }, metadata: _metadata }, _uuid_initializers, _uuid_extraInitializers);
          __esDecorate3(_classThis, null, _metadata_block_size_decorators, { kind: "accessor", name: "metadata_block_size", static: false, private: false, access: { has: (obj) => "metadata_block_size" in obj, get: (obj) => obj.metadata_block_size, set: (obj, value) => {
            obj.metadata_block_size = value;
          } }, metadata: _metadata }, _metadata_block_size_initializers, _metadata_block_size_extraInitializers);
          __esDecorate3(_classThis, null, _metadata_offset__decorators, { kind: "accessor", name: "metadata_offset_", static: false, private: false, access: { has: (obj) => "metadata_offset_" in obj, get: (obj) => obj.metadata_offset_, set: (obj, value) => {
            obj.metadata_offset_ = value;
          } }, metadata: _metadata }, _metadata_offset__initializers, _metadata_offset__extraInitializers);
          __esDecorate3(_classThis, null, _metadata_offset_decorators, { kind: "accessor", name: "metadata_offset", static: false, private: false, access: { has: (obj) => "metadata_offset" in obj, get: (obj) => obj.metadata_offset, set: (obj, value) => {
            obj.metadata_offset = value;
          } }, metadata: _metadata }, _metadata_offset_initializers, _metadata_offset_extraInitializers);
          __esDecorate3(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: (obj) => "label" in obj, get: (obj) => obj.label, set: (obj, value) => {
            obj.label = value;
          } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
          __esDecorate3(_classThis, null, __padding_decorators, { kind: "accessor", name: "_padding", static: false, private: false, access: { has: (obj) => "_padding" in obj, get: (obj) => obj._padding, set: (obj, value) => {
            obj._padding = value;
          } }, metadata: _metadata }, __padding_initializers, __padding_extraInitializers);
          __esDecorate3(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
          SuperBlock2 = _classThis = _classDescriptor.value;
          if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
          __runInitializers3(_classThis, _classExtraInitializers);
        })();
        return SuperBlock2 = _classThis;
      })();
      SingleBufferStore = class extends BufferView {
        get uuid() {
          return decodeUUID(this.superblock.uuid);
        }
        constructor(...args) {
          super(...args);
          this.flags = [];
          this.name = "sbfs";
          this.type = 1935828595;
          if (this.byteLength < sizeof(SuperBlock) + sizeof(MetadataBlock))
            throw crit(withErrno("EINVAL", "sbfs: Buffer is too small for a file system"));
          this._view = new DataView(this.buffer, this.byteOffset, this.byteLength);
          this._u8 = new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
          this.superblock = new SuperBlock(this.buffer, this.byteOffset);
        }
        *keys() {
          const keys = /* @__PURE__ */ new Set();
          for (let block = this.superblock.metadata; block; block = block.previous) {
            block.waitUnlocked();
            for (const entry of block.items) {
              if (!entry.offset || keys.has(entry.id))
                continue;
              keys.add(entry.id);
              yield entry.id;
            }
          }
        }
        get(id) {
          for (let block = this.superblock.metadata; block; block = block.previous) {
            block.waitUnlocked();
            for (const entry of block.items) {
              if (!entry.offset || entry.id != id)
                continue;
              const off = this.byteOffset + entry.offset;
              return new Uint8Array(this.buffer.slice(off, off + entry.size));
            }
          }
        }
        set(id, data) {
          const env_1 = { stack: [], error: void 0, hasError: false };
          try {
            if (id === 0 && data.length < sizeof(Inode))
              throw alert(withErrno("EIO", `sbfs: tried to set ${data.length} bytes for id 0!`));
            for (let block = this.superblock.metadata; block; block = block.previous) {
              block.waitUnlocked();
              for (const entry2 of block.items) {
                const env_2 = { stack: [], error: void 0, hasError: false };
                try {
                  if (!entry2.offset || entry2.id != id)
                    continue;
                  const lock2 = __addDisposableResource5(env_2, block.lock(), false);
                  if (data.length == entry2.size) {
                    this._u8.set(data, entry2.offset);
                    return;
                  }
                  if (data.length < entry2.size || this.superblock.isUnused(entry2.offset, data.length)) {
                    this._u8.set(data, entry2.offset);
                    entry2.size = data.length;
                    _update(block);
                    return;
                  }
                  entry2.offset = Number(this.superblock.used_bytes);
                  entry2.size = data.length;
                  this._u8.set(data, entry2.offset);
                  _update(block);
                  this.superblock.used_bytes += BigInt(data.length);
                  _update(this.superblock);
                  return;
                } catch (e_1) {
                  env_2.error = e_1;
                  env_2.hasError = true;
                } finally {
                  __disposeResources5(env_2);
                }
              }
            }
            let entry = Array.from(this.superblock.metadata.items).find((e2) => !e2.offset);
            if (!entry) {
              this.superblock.rotateMetadata();
              entry = this.superblock.metadata.items[0];
            }
            const lock = __addDisposableResource5(env_1, this.superblock.metadata.lock(), false);
            const offset = Number(this.superblock.used_bytes);
            entry.id = id;
            entry.offset = offset;
            entry.size = data.length;
            this._u8.set(data, offset);
            this.superblock.used_bytes += BigInt(data.length);
            _update(this.superblock.metadata);
            _update(this.superblock);
          } catch (e_2) {
            env_1.error = e_2;
            env_1.hasError = true;
          } finally {
            __disposeResources5(env_1);
          }
        }
        delete(id) {
          for (let block = this.superblock.metadata; block; block = block.previous) {
            block.waitUnlocked();
            for (const entry of block.items) {
              if (entry.id != id)
                continue;
              entry.offset = 0;
              entry.size = 0;
              entry.id = 0;
              _update(block);
              return;
            }
          }
        }
        get fs() {
          return this._fs;
        }
        set fs(fs2) {
          if (this.buffer instanceof SharedArrayBuffer)
            fs2 === null || fs2 === void 0 ? void 0 : fs2.attributes.set("no_id_tables", true);
          this._fs = fs2;
        }
        sync() {
          return Promise.resolve();
        }
        usage() {
          return {
            totalSpace: Number(this.superblock.total_bytes),
            freeSpace: Number(this.superblock.total_bytes - this.superblock.used_bytes)
          };
        }
        transaction() {
          return new SyncMapTransaction(this);
        }
      };
      _SingleBuffer = {
        name: "SingleBuffer",
        options: {
          buffer: { type: "object", required: true }
        },
        create(opt) {
          const fs2 = new StoreFS(ArrayBuffer.isView(opt.buffer) ? new SingleBufferStore(opt.buffer.buffer, opt.buffer.byteOffset, opt.buffer.byteLength) : new SingleBufferStore(opt.buffer));
          fs2.checkRootSync();
          return fs2;
        }
      };
      SingleBuffer = _SingleBuffer;
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/index.js
  var init_backends = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/backends/index.js"() {
      init_backend();
      init_cow();
      init_fetch();
      init_memory();
      init_passthrough();
      init_port();
      init_single_buffer();
      init_fs();
      init_map();
      init_store();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/context.js
  function bindContext({ root = (this === null || this === void 0 ? void 0 : this.root) || "/", pwd = (this === null || this === void 0 ? void 0 : this.pwd) || "/", credentials = structuredClone(defaultContext.credentials) } = {}) {
    const parent = this !== null && this !== void 0 ? this : defaultContext;
    const ctx = {
      id: _nextId++,
      root,
      pwd,
      credentials: createCredentials(credentials),
      descriptors: /* @__PURE__ */ new Map(),
      parent,
      children: []
    };
    const bound = {
      ...ctx,
      fs: {
        ...bindFunctions(vfs_exports, ctx),
        promises: bindFunctions(promises_exports, ctx),
        xattr: bindFunctions(xattr_exports, ctx)
      },
      path: bindFunctions(path_exports, ctx),
      bind: (init3) => {
        const child = bindContext.call(ctx, init3);
        ctx.children.push(child);
        return child;
      }
    };
    boundContexts.set(ctx.id, bound);
    return bound;
  }
  var _nextId, boundContexts;
  var init_context = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/context.js"() {
      init_dist();
      init_contexts();
      init_credentials();
      init_path();
      init_vfs();
      _nextId = 1;
      boundContexts = /* @__PURE__ */ new Map();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/index.js
  var init_internal2 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/internal/index.js"() {
      init_dist2();
      init_credentials();
      init_devices();
      init_error2();
      init_file_index();
      init_filesystem();
      init_index_fs();
      init_inode();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/mutexed.js
  function Mutexed(FS) {
    class MutexedFS extends _MutexedFS {
      constructor(...args) {
        super();
        this._fs = new FS(...args);
      }
    }
    return MutexedFS;
  }
  var __addDisposableResource6, __disposeResources6, MutexLock, _MutexedFS;
  var init_mutexed = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/mutexed.js"() {
      init_dist2();
      init_log();
      init_polyfills();
      __addDisposableResource6 = function(env, value, async) {
        if (value !== null && value !== void 0) {
          if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
          var dispose, inner;
          if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
          }
          if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
          }
          if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
          if (inner) dispose = function() {
            try {
              inner.call(this);
            } catch (e2) {
              return Promise.reject(e2);
            }
          };
          env.stack.push({ value, dispose, async });
        } else if (async) {
          env.stack.push({ async: true });
        }
        return value;
      };
      __disposeResources6 = /* @__PURE__ */ function(SuppressedError2) {
        return function(env) {
          function fail(e2) {
            env.error = env.hasError ? new SuppressedError2(e2, env.error, "An error was suppressed during disposal.") : e2;
            env.hasError = true;
          }
          var r2, s2 = 0;
          function next() {
            while (r2 = env.stack.pop()) {
              try {
                if (!r2.async && s2 === 1) return s2 = 0, env.stack.push(r2), Promise.resolve().then(next);
                if (r2.dispose) {
                  var result = r2.dispose.call(r2.value);
                  if (r2.async) return s2 |= 2, Promise.resolve(result).then(next, function(e2) {
                    fail(e2);
                    return next();
                  });
                } else s2 |= 1;
              } catch (e2) {
                fail(e2);
              }
            }
            if (s2 === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
            if (env.hasError) throw env.error;
          }
          return next();
        };
      }(typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
        var e2 = new Error(message);
        return e2.name = "SuppressedError", e2.error = error, e2.suppressed = suppressed, e2;
      });
      MutexLock = class {
        get isLocked() {
          return this._isLocked;
        }
        constructor(previous) {
          this.previous = previous;
          this.current = Promise.withResolvers();
          this._isLocked = true;
        }
        async done() {
          var _a6;
          await ((_a6 = this.previous) === null || _a6 === void 0 ? void 0 : _a6.done());
          await this.current.promise;
        }
        unlock() {
          this.current.resolve();
          this._isLocked = false;
        }
        [Symbol.dispose]() {
          this.unlock();
        }
      };
      _MutexedFS = class {
        get type() {
          return this._fs.type;
        }
        get name() {
          return this._fs.name;
        }
        get label() {
          return this._fs.label;
        }
        set label(value) {
          this._fs.label = value;
        }
        get attributes() {
          return this._fs.attributes;
        }
        get _uuid() {
          return this._fs._uuid;
        }
        set _uuid(value) {
          this._fs._uuid = value;
        }
        get uuid() {
          return this._fs.uuid;
        }
        async ready() {
          return await this._fs.ready();
        }
        usage() {
          return this._fs.usage();
        }
        /**
         * Adds a lock for a path
         */
        addLock() {
          const lock = new MutexLock(this.currentLock);
          this.currentLock = lock;
          return lock;
        }
        /**
         * Locks `path` asynchronously.
         * If the path is currently locked, waits for it to be unlocked.
         * @internal
         */
        async lock() {
          const previous = this.currentLock;
          const lock = this.addLock();
          const stack = new Error().stack;
          setTimeout(() => {
            if (lock.isLocked) {
              const error = withErrno("EDEADLK");
              error.stack += stack === null || stack === void 0 ? void 0 : stack.slice("Error".length);
              throw err(error);
            }
          }, 5e3);
          await (previous === null || previous === void 0 ? void 0 : previous.done());
          return lock;
        }
        /**
         * Locks `path` asynchronously.
         * If the path is currently locked, an error will be thrown
         * @internal
         */
        lockSync() {
          var _a6;
          if ((_a6 = this.currentLock) === null || _a6 === void 0 ? void 0 : _a6.isLocked) {
            throw err(withErrno("EBUSY"));
          }
          return this.addLock();
        }
        /**
         * Whether `path` is locked
         * @internal
         */
        get isLocked() {
          var _a6;
          return !!((_a6 = this.currentLock) === null || _a6 === void 0 ? void 0 : _a6.isLocked);
        }
        /* eslint-disable @typescript-eslint/no-unused-vars */
        async rename(oldPath, newPath) {
          const env_1 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_1, await this.lock(), false);
            await this._fs.rename(oldPath, newPath);
          } catch (e_1) {
            env_1.error = e_1;
            env_1.hasError = true;
          } finally {
            __disposeResources6(env_1);
          }
        }
        renameSync(oldPath, newPath) {
          const env_2 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_2, this.lockSync(), false);
            return this._fs.renameSync(oldPath, newPath);
          } catch (e_2) {
            env_2.error = e_2;
            env_2.hasError = true;
          } finally {
            __disposeResources6(env_2);
          }
        }
        async stat(path3) {
          const env_3 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_3, await this.lock(), false);
            return await this._fs.stat(path3);
          } catch (e_3) {
            env_3.error = e_3;
            env_3.hasError = true;
          } finally {
            __disposeResources6(env_3);
          }
        }
        statSync(path3) {
          const env_4 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_4, this.lockSync(), false);
            return this._fs.statSync(path3);
          } catch (e_4) {
            env_4.error = e_4;
            env_4.hasError = true;
          } finally {
            __disposeResources6(env_4);
          }
        }
        async touch(path3, metadata) {
          const env_5 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_5, await this.lock(), false);
            await this._fs.touch(path3, metadata);
          } catch (e_5) {
            env_5.error = e_5;
            env_5.hasError = true;
          } finally {
            __disposeResources6(env_5);
          }
        }
        touchSync(path3, metadata) {
          const env_6 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_6, this.lockSync(), false);
            this._fs.touchSync(path3, metadata);
          } catch (e_6) {
            env_6.error = e_6;
            env_6.hasError = true;
          } finally {
            __disposeResources6(env_6);
          }
        }
        async createFile(path3, options) {
          const env_7 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_7, await this.lock(), false);
            return await this._fs.createFile(path3, options);
          } catch (e_7) {
            env_7.error = e_7;
            env_7.hasError = true;
          } finally {
            __disposeResources6(env_7);
          }
        }
        createFileSync(path3, options) {
          const env_8 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_8, this.lockSync(), false);
            return this._fs.createFileSync(path3, options);
          } catch (e_8) {
            env_8.error = e_8;
            env_8.hasError = true;
          } finally {
            __disposeResources6(env_8);
          }
        }
        async unlink(path3) {
          const env_9 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_9, await this.lock(), false);
            await this._fs.unlink(path3);
          } catch (e_9) {
            env_9.error = e_9;
            env_9.hasError = true;
          } finally {
            __disposeResources6(env_9);
          }
        }
        unlinkSync(path3) {
          const env_10 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_10, this.lockSync(), false);
            return this._fs.unlinkSync(path3);
          } catch (e_10) {
            env_10.error = e_10;
            env_10.hasError = true;
          } finally {
            __disposeResources6(env_10);
          }
        }
        async rmdir(path3) {
          const env_11 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_11, await this.lock(), false);
            await this._fs.rmdir(path3);
          } catch (e_11) {
            env_11.error = e_11;
            env_11.hasError = true;
          } finally {
            __disposeResources6(env_11);
          }
        }
        rmdirSync(path3) {
          const env_12 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_12, this.lockSync(), false);
            return this._fs.rmdirSync(path3);
          } catch (e_12) {
            env_12.error = e_12;
            env_12.hasError = true;
          } finally {
            __disposeResources6(env_12);
          }
        }
        async mkdir(path3, options) {
          const env_13 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_13, await this.lock(), false);
            return await this._fs.mkdir(path3, options);
          } catch (e_13) {
            env_13.error = e_13;
            env_13.hasError = true;
          } finally {
            __disposeResources6(env_13);
          }
        }
        mkdirSync(path3, options) {
          const env_14 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_14, this.lockSync(), false);
            return this._fs.mkdirSync(path3, options);
          } catch (e_14) {
            env_14.error = e_14;
            env_14.hasError = true;
          } finally {
            __disposeResources6(env_14);
          }
        }
        async readdir(path3) {
          const env_15 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_15, await this.lock(), false);
            return await this._fs.readdir(path3);
          } catch (e_15) {
            env_15.error = e_15;
            env_15.hasError = true;
          } finally {
            __disposeResources6(env_15);
          }
        }
        readdirSync(path3) {
          const env_16 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_16, this.lockSync(), false);
            return this._fs.readdirSync(path3);
          } catch (e_16) {
            env_16.error = e_16;
            env_16.hasError = true;
          } finally {
            __disposeResources6(env_16);
          }
        }
        async exists(path3) {
          const env_17 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_17, await this.lock(), false);
            return await this._fs.exists(path3);
          } catch (e_17) {
            env_17.error = e_17;
            env_17.hasError = true;
          } finally {
            __disposeResources6(env_17);
          }
        }
        existsSync(path3) {
          const env_18 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_18, this.lockSync(), false);
            return this._fs.existsSync(path3);
          } catch (e_18) {
            env_18.error = e_18;
            env_18.hasError = true;
          } finally {
            __disposeResources6(env_18);
          }
        }
        async link(srcpath, dstpath) {
          const env_19 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_19, await this.lock(), false);
            await this._fs.link(srcpath, dstpath);
          } catch (e_19) {
            env_19.error = e_19;
            env_19.hasError = true;
          } finally {
            __disposeResources6(env_19);
          }
        }
        linkSync(srcpath, dstpath) {
          const env_20 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_20, this.lockSync(), false);
            return this._fs.linkSync(srcpath, dstpath);
          } catch (e_20) {
            env_20.error = e_20;
            env_20.hasError = true;
          } finally {
            __disposeResources6(env_20);
          }
        }
        async sync() {
          const env_21 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_21, await this.lock(), false);
            await this._fs.sync();
          } catch (e_21) {
            env_21.error = e_21;
            env_21.hasError = true;
          } finally {
            __disposeResources6(env_21);
          }
        }
        syncSync() {
          const env_22 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_22, this.lockSync(), false);
            return this._fs.syncSync();
          } catch (e_22) {
            env_22.error = e_22;
            env_22.hasError = true;
          } finally {
            __disposeResources6(env_22);
          }
        }
        async read(path3, buffer, offset, end) {
          const env_23 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_23, await this.lock(), false);
            return await this._fs.read(path3, buffer, offset, end);
          } catch (e_23) {
            env_23.error = e_23;
            env_23.hasError = true;
          } finally {
            __disposeResources6(env_23);
          }
        }
        readSync(path3, buffer, offset, end) {
          const env_24 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_24, this.lockSync(), false);
            return this._fs.readSync(path3, buffer, offset, end);
          } catch (e_24) {
            env_24.error = e_24;
            env_24.hasError = true;
          } finally {
            __disposeResources6(env_24);
          }
        }
        async write(path3, buffer, offset) {
          const env_25 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_25, await this.lock(), false);
            return await this._fs.write(path3, buffer, offset);
          } catch (e_25) {
            env_25.error = e_25;
            env_25.hasError = true;
          } finally {
            __disposeResources6(env_25);
          }
        }
        writeSync(path3, buffer, offset) {
          const env_26 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_26, this.lockSync(), false);
            return this._fs.writeSync(path3, buffer, offset);
          } catch (e_26) {
            env_26.error = e_26;
            env_26.hasError = true;
          } finally {
            __disposeResources6(env_26);
          }
        }
        streamRead(path3, options) {
          const env_27 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_27, this.lockSync(), false);
            return this._fs.streamRead(path3, options);
          } catch (e_27) {
            env_27.error = e_27;
            env_27.hasError = true;
          } finally {
            __disposeResources6(env_27);
          }
        }
        streamWrite(path3, options) {
          const env_28 = { stack: [], error: void 0, hasError: false };
          try {
            const _2 = __addDisposableResource6(env_28, this.lockSync(), false);
            return this._fs.streamWrite(path3, options);
          } catch (e_28) {
            env_28.error = e_28;
            env_28.hasError = true;
          } finally {
            __disposeResources6(env_28);
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/readonly.js
  function Readonly(FS) {
    class ReadonlyFS extends FS {
      constructor(...args) {
        super(...args);
        this.attributes.set("no_write");
      }
      async rename() {
        throw withErrno("EROFS");
      }
      renameSync() {
        throw withErrno("EROFS");
      }
      async createFile() {
        throw withErrno("EROFS");
      }
      createFileSync() {
        throw withErrno("EROFS");
      }
      async unlink() {
        throw withErrno("EROFS");
      }
      unlinkSync() {
        throw withErrno("EROFS");
      }
      async rmdir() {
        throw withErrno("EROFS");
      }
      rmdirSync() {
        throw withErrno("EROFS");
      }
      async mkdir() {
        throw withErrno("EROFS");
      }
      mkdirSync() {
        throw withErrno("EROFS");
      }
      async link() {
        throw withErrno("EROFS");
      }
      linkSync() {
        throw withErrno("EROFS");
      }
      async touch() {
        throw withErrno("EROFS");
      }
      touchSync() {
        throw withErrno("EROFS");
      }
      async sync() {
        throw withErrno("EROFS");
      }
      syncSync() {
        throw withErrno("EROFS");
      }
      async write() {
        throw withErrno("EROFS");
      }
      writeSync() {
        throw withErrno("EROFS");
      }
      streamWrite() {
        throw withErrno("EROFS");
      }
    }
    return ReadonlyFS;
  }
  var init_readonly = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/readonly.js"() {
      init_dist2();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/sync.js
  function Sync(FS) {
    class SyncFS extends FS {
      async exists(path3) {
        return this.existsSync(path3);
      }
      async rename(oldPath, newPath) {
        return this.renameSync(oldPath, newPath);
      }
      async stat(path3) {
        return this.statSync(path3);
      }
      async touch(path3, metadata) {
        return this.touchSync(path3, metadata);
      }
      async createFile(path3, options) {
        return this.createFileSync(path3, options);
      }
      async unlink(path3) {
        return this.unlinkSync(path3);
      }
      async rmdir(path3) {
        return this.rmdirSync(path3);
      }
      async mkdir(path3, options) {
        return this.mkdirSync(path3, options);
      }
      async readdir(path3) {
        return this.readdirSync(path3);
      }
      async link(srcpath, dstpath) {
        return this.linkSync(srcpath, dstpath);
      }
      async sync() {
        return this.syncSync();
      }
      async read(path3, buffer, offset, end) {
        return this.readSync(path3, buffer, offset, end);
      }
      async write(path3, buffer, offset) {
        return this.writeSync(path3, buffer, offset);
      }
    }
    return SyncFS;
  }
  var init_sync2 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/sync.js"() {
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/index.js
  var init_mixins = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/mixins/index.js"() {
      init_async2();
      init_mutexed();
      init_readonly();
      init_shared2();
      init_sync2();
    }
  });

  // ../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/index.js
  var dist_exports = {};
  __export(dist_exports, {
    Async: () => Async,
    AsyncMapTransaction: () => AsyncMapTransaction,
    AsyncTransaction: () => AsyncTransaction,
    Attributes: () => Attributes,
    BigIntStats: () => BigIntStats,
    BigIntStatsFs: () => BigIntStatsFs,
    CopyOnWrite: () => CopyOnWrite,
    CopyOnWriteFS: () => CopyOnWriteFS,
    DeviceFS: () => DeviceFS,
    Dir: () => Dir,
    Dirent: () => Dirent,
    ErrnoError: () => ErrnoError,
    Fetch: () => Fetch,
    FetchFS: () => FetchFS,
    FileSystem: () => FileSystem,
    IOC: () => IOC,
    IOC32: () => IOC32,
    InMemory: () => InMemory,
    InMemoryStore: () => InMemoryStore,
    Index: () => Index,
    IndexFS: () => IndexFS,
    Inode: () => Inode,
    InodeFlags: () => InodeFlags,
    Journal: () => Journal,
    MetadataBlock: () => MetadataBlock,
    MutexLock: () => MutexLock,
    Mutexed: () => Mutexed,
    Passthrough: () => Passthrough,
    PassthroughFS: () => PassthroughFS,
    Port: () => Port,
    PortFS: () => PortFS,
    ReadStream: () => ReadStream,
    Readonly: () => Readonly,
    SingleBuffer: () => SingleBuffer,
    SingleBufferStore: () => SingleBufferStore,
    Stats: () => Stats,
    StatsCommon: () => StatsCommon,
    StatsFs: () => StatsFs,
    StoreFS: () => StoreFS,
    SuperBlock: () => SuperBlock,
    Sync: () => Sync,
    SyncMapTransaction: () => SyncMapTransaction,
    SyncTransaction: () => SyncTransaction,
    Transaction: () => Transaction,
    WrappedTransaction: () => WrappedTransaction,
    WriteStream: () => WriteStream,
    ZenFsType: () => ZenFsType,
    _MutexedFS: () => _MutexedFS,
    __assertType: () => __assertType,
    _asyncFSKeys: () => _asyncFSKeys,
    _chown: () => _chown,
    _fnOpt: () => _fnOpt,
    _inode_fields: () => _inode_fields,
    _inode_version: () => _inode_version,
    access: () => access2,
    accessSync: () => accessSync,
    addDevice: () => addDevice,
    appendFile: () => appendFile2,
    appendFileSync: () => appendFileSync,
    attach: () => attach,
    attachFS: () => attachFS,
    bindContext: () => bindContext,
    boundContexts: () => boundContexts,
    catchMessages: () => catchMessages,
    checkOptions: () => checkOptions,
    chmod: () => chmod2,
    chmodSync: () => chmodSync,
    chown: () => chown2,
    chownSync: () => chownSync,
    chroot: () => chroot,
    close: () => close,
    closeSync: () => closeSync,
    configure: () => configure2,
    configureFileSystem: () => configureFileSystem,
    configureSingle: () => configureSingle,
    constants: () => constants_exports,
    copyFile: () => copyFile2,
    copyFileSync: () => copyFileSync,
    cp: () => cp2,
    cpSync: () => cpSync,
    createCredentials: () => createCredentials,
    createReadStream: () => createReadStream,
    createWriteStream: () => createWriteStream,
    decodeDirListing: () => decodeDirListing,
    default: () => dist_default,
    detach: () => detach,
    detachFS: () => detachFS,
    devices: () => devices,
    encodeDirListing: () => encodeDirListing,
    exists: () => exists2,
    existsSync: () => existsSync,
    fchmod: () => fchmod,
    fchmodSync: () => fchmodSync,
    fchown: () => fchown,
    fchownSync: () => fchownSync,
    fdatasync: () => fdatasync,
    fdatasyncSync: () => fdatasyncSync,
    fs: () => vfs_exports,
    fstat: () => fstat,
    fstatSync: () => fstatSync,
    fsync: () => fsync,
    fsyncSync: () => fsyncSync,
    ftruncate: () => ftruncate,
    ftruncateSync: () => ftruncateSync,
    fullDevice: () => fullDevice,
    futimes: () => futimes,
    futimesSync: () => futimesSync,
    glob: () => glob2,
    globSync: () => globSync,
    globToRegex: () => globToRegex,
    handleRequest: () => handleRequest,
    hasAccess: () => hasAccess,
    ioctl: () => ioctl,
    ioctlSync: () => ioctlSync,
    isBackend: () => isBackend,
    isBackendConfig: () => isBackendConfig,
    isBlockDevice: () => isBlockDevice,
    isCharacterDevice: () => isCharacterDevice,
    isDirectory: () => isDirectory,
    isFIFO: () => isFIFO,
    isFile: () => isFile,
    isSocket: () => isSocket,
    isStatsEqual: () => isStatsEqual,
    isSymbolicLink: () => isSymbolicLink,
    lchmod: () => lchmod2,
    lchmodSync: () => lchmodSync,
    lchown: () => lchown2,
    lchownSync: () => lchownSync,
    link: () => link2,
    linkSync: () => linkSync,
    log: () => log_exports,
    lopenSync: () => lopenSync,
    lstat: () => lstat2,
    lstatSync: () => lstatSync,
    lutimes: () => lutimes2,
    lutimesSync: () => lutimesSync,
    mkdir: () => mkdir2,
    mkdirSync: () => mkdirSync,
    mkdtemp: () => mkdtemp2,
    mkdtempSync: () => mkdtempSync,
    mount: () => mount,
    mounts: () => mounts,
    normalizeMode: () => normalizeMode,
    normalizeOptions: () => normalizeOptions,
    normalizePath: () => normalizePath,
    normalizeTime: () => normalizeTime,
    nullDevice: () => nullDevice,
    open: () => open2,
    openAsBlob: () => openAsBlob,
    openSync: () => openSync,
    opendir: () => opendir2,
    opendirSync: () => opendirSync,
    promises: () => promises_exports,
    randomDevice: () => randomDevice,
    read: () => read,
    readFile: () => readFile2,
    readFileSync: () => readFileSync,
    readSync: () => readSync,
    readdir: () => readdir2,
    readdirSync: () => readdirSync,
    readlink: () => readlink2,
    readlinkSync: () => readlinkSync,
    readv: () => readv,
    readvSync: () => readvSync,
    realpath: () => realpath2,
    realpathSync: () => realpathSync,
    rename: () => rename2,
    renameSync: () => renameSync,
    resolveMountConfig: () => resolveMountConfig,
    resolveRemoteMount: () => resolveRemoteMount,
    rm: () => rm2,
    rmSync: () => rmSync,
    rmdir: () => rmdir2,
    rmdirSync: () => rmdirSync,
    rootIno: () => rootIno,
    stat: () => stat2,
    statSync: () => statSync,
    statfs: () => statfs2,
    statfsSync: () => statfsSync,
    symlink: () => symlink2,
    symlinkSync: () => symlinkSync,
    truncate: () => truncate2,
    truncateSync: () => truncateSync,
    umount: () => umount,
    unlink: () => unlink2,
    unlinkSync: () => unlinkSync,
    unwatchFile: () => unwatchFile,
    userModifiableFlags: () => userModifiableFlags,
    userVisibleFlags: () => userVisibleFlags,
    utimes: () => utimes2,
    utimesSync: () => utimesSync,
    version: () => version,
    waitOnline: () => waitOnline,
    watch: () => watch2,
    watchFile: () => watchFile,
    withPath: () => withPath,
    wrap: () => wrap,
    write: () => write,
    writeFile: () => writeFile2,
    writeFileSync: () => writeFileSync,
    writeSync: () => writeSync,
    writev: () => writev,
    writevSync: () => writevSync,
    xattr: () => xattr_exports,
    zeroDevice: () => zeroDevice
  });
  var dist_default;
  var init_dist4 = __esm({
    "../../node_modules/.pnpm/@zenfs+core@2.2.0/node_modules/@zenfs/core/dist/index.js"() {
      init_backends();
      init_config2();
      init_context();
      init_internal2();
      init_mixins();
      init_stats();
      init_utils();
      init_shared();
      init_vfs();
      init_vfs();
      dist_default = vfs_exports;
      globalThis.__zenfs__ = vfs_exports;
    }
  });

  // ../../node_modules/.pnpm/zenroom@5.25.1/node_modules/zenroom/dist/module/zenroom.js
  var require_zenroom = __commonJS({
    "../../node_modules/.pnpm/zenroom@5.25.1/node_modules/zenroom/dist/module/zenroom.js"(exports2, module2) {
      var Module = (() => {
        var _scriptName = typeof document != "undefined" ? document.currentScript?.src : void 0;
        return async function(moduleArg = {}) {
          var moduleRtn;
          var Module2 = moduleArg;
          var ENVIRONMENT_IS_WEB = typeof window == "object";
          var ENVIRONMENT_IS_WORKER = typeof WorkerGlobalScope != "undefined";
          var ENVIRONMENT_IS_NODE = typeof process == "object" && process.versions?.node && process.type != "renderer";
          var ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
          var arguments_ = [];
          var thisProgram = "./this.program";
          var quit_ = (status, toThrow) => {
            throw toThrow;
          };
          if (typeof __filename != "undefined") {
            _scriptName = __filename;
          } else if (ENVIRONMENT_IS_WORKER) {
            _scriptName = self.location.href;
          }
          var scriptDirectory = "";
          var readAsync, readBinary;
          if (ENVIRONMENT_IS_NODE) {
            const isNode = typeof process == "object" && process.versions?.node && process.type != "renderer";
            if (!isNode) throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
            var nodeVersion = process.versions.node;
            var numericVersion = nodeVersion.split(".").slice(0, 3);
            numericVersion = numericVersion[0] * 1e4 + numericVersion[1] * 100 + numericVersion[2].split("-")[0] * 1;
            if (numericVersion < 16e4) {
              throw new Error("This emscripten-generated code requires node v16.0.0 (detected v" + nodeVersion + ")");
            }
            var fs2 = (init_dist4(), __toCommonJS(dist_exports));
            scriptDirectory = __dirname + "/";
            readBinary = (filename) => {
              filename = isFileURI(filename) ? new URL(filename) : filename;
              var ret = fs2.readFileSync(filename);
              assert2(Buffer.isBuffer(ret));
              return ret;
            };
            readAsync = async (filename, binary = true) => {
              filename = isFileURI(filename) ? new URL(filename) : filename;
              var ret = fs2.readFileSync(filename, binary ? void 0 : "utf8");
              assert2(binary ? Buffer.isBuffer(ret) : typeof ret == "string");
              return ret;
            };
            if (process.argv.length > 1) {
              thisProgram = process.argv[1].replace(/\\/g, "/");
            }
            arguments_ = process.argv.slice(2);
            quit_ = (status, toThrow) => {
              process.exitCode = status;
              throw toThrow;
            };
          } else if (ENVIRONMENT_IS_SHELL) {
            const isNode = typeof process == "object" && process.versions?.node && process.type != "renderer";
            if (isNode || typeof window == "object" || typeof WorkerGlobalScope != "undefined") throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
          } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            try {
              scriptDirectory = new URL(".", _scriptName).href;
            } catch {
            }
            if (!(typeof window == "object" || typeof WorkerGlobalScope != "undefined")) throw new Error("not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)");
            {
              if (ENVIRONMENT_IS_WORKER) {
                readBinary = (url) => {
                  var xhr = new XMLHttpRequest();
                  xhr.open("GET", url, false);
                  xhr.responseType = "arraybuffer";
                  xhr.send(null);
                  return new Uint8Array(xhr.response);
                };
              }
              readAsync = async (url) => {
                if (isFileURI(url)) {
                  return new Promise((resolve2, reject) => {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url, true);
                    xhr.responseType = "arraybuffer";
                    xhr.onload = () => {
                      if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        resolve2(xhr.response);
                        return;
                      }
                      reject(xhr.status);
                    };
                    xhr.onerror = reject;
                    xhr.send(null);
                  });
                }
                var response = await fetch(url, { credentials: "same-origin" });
                if (response.ok) {
                  return response.arrayBuffer();
                }
                throw new Error(response.status + " : " + response.url);
              };
            }
          } else {
            throw new Error("environment detection error");
          }
          var out = console.log.bind(console);
          var err3 = console.error.bind(console);
          assert2(!ENVIRONMENT_IS_SHELL, "shell environment detected but not enabled at build time.  Add `shell` to `-sENVIRONMENT` to enable.");
          var wasmBinary;
          if (typeof WebAssembly != "object") {
            err3("no native wasm support detected");
          }
          var ABORT = false;
          var EXITSTATUS;
          function assert2(condition, text) {
            if (!condition) {
              abort("Assertion failed" + (text ? ": " + text : ""));
            }
          }
          var isFileURI = (filename) => filename.startsWith("file://");
          function writeStackCookie() {
            var max2 = _emscripten_stack_get_end();
            assert2((max2 & 3) == 0);
            if (max2 == 0) {
              max2 += 4;
            }
            HEAPU32[max2 >> 2] = 34821223;
            HEAPU32[max2 + 4 >> 2] = 2310721022;
            HEAPU32[0 >> 2] = 1668509029;
          }
          function checkStackCookie() {
            if (ABORT) return;
            var max2 = _emscripten_stack_get_end();
            if (max2 == 0) {
              max2 += 4;
            }
            var cookie1 = HEAPU32[max2 >> 2];
            var cookie2 = HEAPU32[max2 + 4 >> 2];
            if (cookie1 != 34821223 || cookie2 != 2310721022) {
              abort(`Stack overflow! Stack cookie has been overwritten at ${ptrToString(max2)}, expected hex dwords 0x89BACDFE and 0x2135467, but received ${ptrToString(cookie2)} ${ptrToString(cookie1)}`);
            }
            if (HEAPU32[0 >> 2] != 1668509029) {
              abort("Runtime error: The application has corrupted its heap memory area (address zero)!");
            }
          }
          var runtimeDebug = true;
          (() => {
            var h16 = new Int16Array(1);
            var h8 = new Int8Array(h16.buffer);
            h16[0] = 25459;
            if (h8[0] !== 115 || h8[1] !== 99) throw "Runtime error: expected the system to be little-endian! (Run with -sSUPPORT_BIG_ENDIAN to bypass)";
          })();
          function makeInvalidEarlyAccess(name2) {
            return () => assert2(false, `call to '${name2}' via reference taken before Wasm module initialization`);
          }
          function ignoredModuleProp(prop) {
            if (Object.getOwnPropertyDescriptor(Module2, prop)) {
              abort(`\`Module.${prop}\` was supplied but \`${prop}\` not included in INCOMING_MODULE_JS_API`);
            }
          }
          function isExportedByForceFilesystem(name2) {
            return name2 === "FS_createPath" || name2 === "FS_createDataFile" || name2 === "FS_createPreloadedFile" || name2 === "FS_unlink" || name2 === "addRunDependency" || name2 === "FS_createLazyFile" || name2 === "FS_createDevice" || name2 === "removeRunDependency";
          }
          function hookGlobalSymbolAccess(sym, func) {
          }
          function missingGlobal(sym, msg) {
            hookGlobalSymbolAccess(sym, () => {
              warnOnce(`\`${sym}\` is not longer defined by emscripten. ${msg}`);
            });
          }
          missingGlobal("buffer", "Please use HEAP8.buffer or wasmMemory.buffer");
          missingGlobal("asm", "Please use wasmExports instead");
          function missingLibrarySymbol(sym) {
            hookGlobalSymbolAccess(sym, () => {
              var msg = `\`${sym}\` is a library symbol and not included by default; add it to your library.js __deps or to DEFAULT_LIBRARY_FUNCS_TO_INCLUDE on the command line`;
              var librarySymbol = sym;
              if (!librarySymbol.startsWith("_")) {
                librarySymbol = "$" + sym;
              }
              msg += ` (e.g. -sDEFAULT_LIBRARY_FUNCS_TO_INCLUDE='${librarySymbol}')`;
              if (isExportedByForceFilesystem(sym)) {
                msg += ". Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you";
              }
              warnOnce(msg);
            });
            unexportedRuntimeSymbol(sym);
          }
          function unexportedRuntimeSymbol(sym) {
            if (!Object.getOwnPropertyDescriptor(Module2, sym)) {
              Object.defineProperty(Module2, sym, { configurable: true, get() {
                var msg = `'${sym}' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the Emscripten FAQ)`;
                if (isExportedByForceFilesystem(sym)) {
                  msg += ". Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you";
                }
                abort(msg);
              } });
            }
          }
          var readyPromiseResolve, readyPromiseReject;
          var wasmMemory;
          var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
          var HEAP64, HEAPU64;
          var runtimeInitialized = false;
          function updateMemoryViews() {
            var b = wasmMemory.buffer;
            HEAP8 = new Int8Array(b);
            HEAP16 = new Int16Array(b);
            HEAPU8 = new Uint8Array(b);
            HEAPU16 = new Uint16Array(b);
            HEAP32 = new Int32Array(b);
            HEAPU32 = new Uint32Array(b);
            HEAPF32 = new Float32Array(b);
            HEAPF64 = new Float64Array(b);
            HEAP64 = new BigInt64Array(b);
            HEAPU64 = new BigUint64Array(b);
          }
          assert2(typeof Int32Array != "undefined" && typeof Float64Array !== "undefined" && Int32Array.prototype.subarray != void 0 && Int32Array.prototype.set != void 0, "JS engine does not provide full typed array support");
          function preRun() {
          }
          function initRuntime() {
            assert2(!runtimeInitialized);
            runtimeInitialized = true;
            checkStackCookie();
            if (!Module2["noFSInit"] && !FS.initialized) FS.init();
            TTY.init();
            wasmExports["__wasm_call_ctors"]();
            FS.ignorePermissions = false;
          }
          function postRun() {
            checkStackCookie();
          }
          var runDependencies = 0;
          var dependenciesFulfilled = null;
          var runDependencyTracking = {};
          var runDependencyWatcher = null;
          function addRunDependency(id) {
            runDependencies++;
            if (id) {
              assert2(!runDependencyTracking[id]);
              runDependencyTracking[id] = 1;
              if (runDependencyWatcher === null && typeof setInterval != "undefined") {
                runDependencyWatcher = setInterval(() => {
                  if (ABORT) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                    return;
                  }
                  var shown = false;
                  for (var dep in runDependencyTracking) {
                    if (!shown) {
                      shown = true;
                      err3("still waiting on run dependencies:");
                    }
                    err3(`dependency: ${dep}`);
                  }
                  if (shown) {
                    err3("(end of list)");
                  }
                }, 1e4);
              }
            } else {
              err3("warning: run dependency added without ID");
            }
          }
          function removeRunDependency(id) {
            runDependencies--;
            if (id) {
              assert2(runDependencyTracking[id]);
              delete runDependencyTracking[id];
            } else {
              err3("warning: run dependency removed without ID");
            }
            if (runDependencies == 0) {
              if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
              }
              if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback();
              }
            }
          }
          function abort(what) {
            what = "Aborted(" + what + ")";
            err3(what);
            ABORT = true;
            var e2 = new WebAssembly.RuntimeError(what);
            readyPromiseReject?.(e2);
            throw e2;
          }
          function createExportWrapper(name2, nargs) {
            return (...args) => {
              assert2(runtimeInitialized, `native function \`${name2}\` called before runtime initialization`);
              var f = wasmExports[name2];
              assert2(f, `exported native function \`${name2}\` not found`);
              assert2(args.length <= nargs, `native function \`${name2}\` called with ${args.length} args but expects ${nargs}`);
              return f(...args);
            };
          }
          var wasmBinaryFile;
          function findWasmBinary() {
            return base64Decode("AGFzbQEAAAAByARKYAF/AX9gA39/fwBgBH9/f38Bf2ACf38AYAN/f38Bf2ACf38Bf2ABfwBgBH9/f38AYAV/f39/fwF/YAV/f39/fwBgCH9/f39/f39/AX9gBn9/f39/fwBgBn9/f39/fwF/YAd/f39/f39/AGAAAGABfQF9YAd/f39/f39/AX9gBX9+fn5+AGAAAX9gCX9/f39/f39/fwBgC39/f39/f39/f39/AX9gCH9/f39/f39/AGAEf397ewBgCX9/f39/f39/fwF/YAN/fn8Bf2ABfwF+YAR/fn5/AGACfX0BfWADf35/AX5gAn5/AGACfX8BfWACfH8BfGABfwF9YAJ/fABgCn9/f39/f39/f38AYAJ/fwF7YAZ/fH9/f38Bf2ABfAF9YAABfGAEf35/fwF/YAJ/fAF/YAR+fn5+AX9gA35+fgF/YAF8AXxgAAF9YAABfmAIf39/fn9/f38AYAJ/fQF/YAJ/fwF9YAN/f38BfWACe3sBe2ADf35/AGABfwF7YAN7e38BfmADf39+AGAFe3t7e38Bf2ADf39+AX9gBH97e38AYAN7e38AYAV/f39+fwBgC39/f39/f39/f39/AGAQf39/f39/f39/f39/f39/fwF/YAJ/fwF+YAp/f39/f39/f39/AX9gEX9/f39/f39/f39/f39/f39/AX9gDH9/f39/f39/f39/fwF/YA5/f39/f39/f39/f39/fwF/YAR/fn5+AGADf39+AX5gAn5/AX9gAX0Bf2ACf30BfWACfX8Bf2ACfH8BfQLLBRoDZW52GGVtc2NyaXB0ZW5fYXNtX2NvbnN0X2ludAAEA2VudgRleGl0AAYDZW52Il9lbXNjcmlwdGVuX2ZzX2xvYWRfZW1iZWRkZWRfZmlsZXMABgNlbnYJX2Fib3J0X2pzAA4Wd2FzaV9zbmFwc2hvdF9wcmV2aWV3MQ5jbG9ja190aW1lX2dldAAYA2VudhNlbXNjcmlwdGVuX2RhdGVfbm93ACYDZW52EF9fc3lzY2FsbF9vcGVuYXQAAgNlbnYRX19zeXNjYWxsX2ZjbnRsNjQABANlbnYPX19zeXNjYWxsX2lvY3RsAAQWd2FzaV9zbmFwc2hvdF9wcmV2aWV3MQdmZF9yZWFkAAIWd2FzaV9zbmFwc2hvdF9wcmV2aWV3MQhmZF93cml0ZQACFndhc2lfc25hcHNob3RfcHJldmlldzEIZmRfY2xvc2UAAANlbnYOX19zeXNjYWxsX2R1cDMABBZ3YXNpX3NuYXBzaG90X3ByZXZpZXcxEWVudmlyb25fc2l6ZXNfZ2V0AAUWd2FzaV9zbmFwc2hvdF9wcmV2aWV3MQtlbnZpcm9uX2dldAAFFndhc2lfc25hcHNob3RfcHJldmlldzEHZmRfc2VlawAnA2VudglfdHpzZXRfanMABwNlbnYKX21rdGltZV9qcwAZA2Vudg1fbG9jYWx0aW1lX2pzAB0DZW52Cl9nbXRpbWVfanMAHQNlbnYWZW1zY3JpcHRlbl9yZXNpemVfaGVhcAAAA2Vudg1fc2V0aXRpbWVyX2pzACgDZW52I19lbXNjcmlwdGVuX3J1bnRpbWVfa2VlcGFsaXZlX2NsZWFyAA4Wd2FzaV9zbmFwc2hvdF9wcmV2aWV3MQlwcm9jX2V4aXQABgNlbnYZX2Vtc2NyaXB0ZW5fdGhyb3dfbG9uZ2ptcAAOA2VudgppbnZva2VfdmlpAAED8QzvDAYEAQADAwAABAcAHgAAHxEABgUDBQApKhoRGhERDhISEgYAEhERKyAgDxsDAywPDw8DIQMFDgMEAAMGAwAAAwEBAQABAgAAAAAAAAAAAwEABQQBBQEECAgEBQADBQQALQECAwQGAwMEAQYGAgUDBAUAAAwMCAQEBgACBgEGBgUBBgEBBAUBBQEDBwUBBAUFBAYDAAUAAAAAAAAAAAAAAAAAAAAAAAAABQUDCAQuAAUABAAAAAAAAAAAAAEAAAAAAwQDBAUvAwUAAAAAAAAAAAAAAAADAAAAAAAAAAAABgMFAAAEAwAAAAAAAAQAAQAAAAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUGAAMEBAAAAQMAAAMGAAYABgAAAAMAAwEAAAMABQMGAAYBBQAAAAAAAAMAAAAAAwAEBQMABQAGAAYAAAAAAAAAAAADAAYBAAEAAwAAAQAEAAMAAQUDAwMGAAYAAAMDAwMDAwMBAwUGAAAAAAEAAAUBBQAHAAEAAwAFAAAAAAAAAAAAAwAAAQAAAAAABwAFAAAAAAMAAQABAAAAAAAAAAAAAAAAAAUAAAADAAAAAAAAAAAGAAADAAMGAQAAAAgAAAQLAAAAAAMDBgAAAAAFAwEDAAEAAAEAAAAVABUACwAACwAIAAAAAA0AAAAABQAABAAAAAUIAgAFAAgAAAAAAAkAAAcDAQYBBgEBAwMADQAACQAACAAAAAABAQEGAQEAAAAAAAcAAAkGAxMGAwcDBgMNCwYDAwEGAwcDBgMAAAAAAAcDBwMHAAYHAAYBAQAAAAAACwAAABUAEAANAAAAAAMAAQMDAQMJAQADAQYBAwUwAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAQAAAAAAAAMBQkBBwMBAQkBBwMEBQAAAAAABAAAAAADBQALAQABCQABAQADAAATAAABBwAAAAMDAAAAAAUAAAIBBAQEMQUEBAECAwQJBQcDCQEDBwMBAQEDAwUGBQEDBAQEAgIBBQcEBQEHAQUBBQkDBA4DAQECBQQGAwMDARAFBgYDAQMBAwMDAwAAAwYAAwYEAQMAAwMGCBsCBQUBAwMEAwEGAwkDAQUDAwIDBwYHAwMBAQcEAQkFAwIBAQMFEwUJAQcDAwcBBgABAAADBQQBBAAFBR4FCAsEBQUBBAUEAAYEAgEGBQAEAAAAAAAAAAQAAAQABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8AAAAAAAAAAAAAAAAAAAAAAAAAAAASAAMAAAAAAAQAAQAAAAAAAAAAAAACAAUAAAQAAAAEBwAAAAAAAAAACAAABAUCAAEAAAAAAAAHBAAAAAAAAAAFAQEBAQEDAQABAQYDBgEDAwEBCQABAwEFBQMBAQcBAAADBgYFAQQEAwYDAQMBBwcBAQUNBwEHEwMDBwEJAQcJBQUDAwYJAQMGBwEHBwEDAwMAAQEFAQMDAQEDBgMDAwMAFjIBCQkABg4HAAkBCQkJAQEBBwEMBAsDAwMDMwEBAggAABgDAwsBFhYiDRYBAzQCAwUFAwMHAQEJCQkDAwUJCQkDBQEAAwE1AwUFAwMDAwcJNg0HBwUDAQkLBwcHAwYYBgACBAQDBQcJAQUFBwkBBQcJAQUEAAADBQsBBwQNDQkCBwQAAwUAAwUAAwUAAwUDNwkLBwQECQsHBAcLBCICBAMEBAQBAQ0DAQUHBwQHCQQAAwUEOAADAAQABQUEAQUFAQEBAwMDBwgJAwENIyMBFxUBBwcHBwkNAQE5AQcHAQcXEwkJOgAGAQMDBwcHBzsNAwEBAwkHAAMBCQADAQUFAQUDDAsNAAMBAAMBAhAMBAoMBBA8DBQ9BBA+BQkHBT8UBBQUFAEBQBkMCAwBCAhBEAQIEAEMCAgICAgICAgCAgIIAgICCAICAggCAgICAgICAgIIAgICAgICAgICCAICAgICAgICAggICAgICAgICAgICAgCAgIMCAICAggCAgIIAgICAgICAgICCAgICAgCAgIMCAwBBwsJCgoKCgoKCgoKCgoKCAwICAgICAEBAQFCChcCDQgICAQHBQAAAAAAHAQEAAUOBRwAAAIABgAAGUMaRAgQAQAHRQkFJAMfBAQORkclJUhJDxsPDwAAIQYGDgQHAXABgQWBBQUHAQGAAYCAAQYdBH8BQdCr9AMLfwFB0Ks0C38BQdCr9AMLfwFBAAsH/QMaBm1lbW9yeQIAEV9fd2FzbV9jYWxsX2N0b3JzAIgNBm1hbGxvYwAqBmNhbGxvYwAuBGZyZWUAKwdyZWFsbG9jACwGZmZsdXNoAFYMemVuY29kZV9leGVjAIwBDHplbnJvb21fZXhlYwCNARN6ZW5jb2RlX3ZhbGlkX2lucHV0AI4BEnplbmNvZGVfdmFsaWRfY29kZQCPARZ6ZW5jb2RlX2dldF9zdGF0ZW1lbnRzAJIBCHN0cmVycm9yACYRemVucm9vbV9oYXNoX2luaXQAuQUTemVucm9vbV9oYXNoX3VwZGF0ZQC6BRJ6ZW5yb29tX2hhc2hfZmluYWwAuwUZX19pbmRpcmVjdF9mdW5jdGlvbl90YWJsZQEAE19lbXNjcmlwdGVuX3RpbWVvdXQAhQ0Ic2V0VGhyZXcARRVlbXNjcmlwdGVuX3N0YWNrX2luaXQANxllbXNjcmlwdGVuX3N0YWNrX2dldF9mcmVlADgZZW1zY3JpcHRlbl9zdGFja19nZXRfYmFzZQA5GGVtc2NyaXB0ZW5fc3RhY2tfZ2V0X2VuZAA6GV9lbXNjcmlwdGVuX3N0YWNrX3Jlc3RvcmUAOxdfZW1zY3JpcHRlbl9zdGFja19hbGxvYwA8HGVtc2NyaXB0ZW5fc3RhY2tfZ2V0X2N1cnJlbnQAPQnuCQEAQQELgAVcX2BhYmNkZWZvqQGSBoABe3xSV4UBqgauAa8BsAGxAbIBswG0AbUBtgG3AbgBuQG6AbsBvAG9Ab4BvwHPBqgHqgerB60Hrwe1BrYGwwfKB44IlQi2CLcI9gy6C7sL2AzZDNoM2wzzDPQMwAGsAccByQHMAc0BywHOAc8B0AHRAdIB1QHWAdcB2AGbApwCnQLjAeQBmQLlAeYB5wHoAekBngKfAqACoQKiAqMCpAKlAqYCpwKoAqkCqgKrAqwCrQLiAewB7gHvAfEB8wHyAfQB9QH2Aa8C/wGAAocCiAKFAoECggKDArACvAW9Bb4FvwXABYsCjQKPAowCkAKRApICkwKUApUClgKXAuoB6wHwAfoB+wH+AYkCigKYAuEBmgLXAtgCwwLZAtoC3ALFAssCzQLdAt4C3wLWAuECvAK/AsECxALHAsoC0QK3AtUC/wKBA4MDigOMA40D5wLpAusC7ALtAu4C7wLwAvEC8gLzAvUC+AL6AuUC/AL9AsUDmgPHA5wDqQOeA58DowOlA6cDswOuA7EDtQO2A7gDuQO6A8kDygO7A74DywPAA8EDzAPNA8MDzgPPA9AD0QPSA9MD1APVA5sDqwOsA60DsgO8A5kDwgPeA9cD2APZA9sD3APdA7cC3wPgA+ED4gP6A+UD7QPvA/AD+wPzA/QD9QP2A+cD6wPsA+QDggSEBIUEhwSIBIkEiwSNBI8EkASSBJQElQSWBJcEmQSaBJsE/AOcBJ4EnwShBKIEowSnBKkEqwSsBK0ErgSvBLEEsgS9BL8EwATCBMMExQTGBMcEyATPBNAE0QTSBNME1QTWBO0E7gTvBPAE8QT3BPoE/gT/BIAFgQWCBYQFhQWGBYgFigWMBY0FjgWPBZEFmQWrBaEFowWmBacFqAWpBaoFrAWtBaIFpAWlBbcFrwW4BbQFtQW2BbAFsQWyBbMF0AXRBdIF0wXVBdYF1wXYBc8F2wXeBeEF5AXmBecF7QXuBe8F8gXzBfQF9QX3BZoHowelB6QHpgenB6kHrAeuB7AHsQeyB7MHtAe1B7YHtwe4B7oHuwe8B70HvgfAB8EHwgfEB8UHxgfHB8gHyQfLB8wHzQfOB88H0AfRB9IH0wfUB9UH1gfXB9gH2wfcB90H3gffB+AH4QfiB+QH5QfmB+cH6AfpB+oH6wfsB+0H7gfvB/AH8QfyB/MH9Af1B/YH9wfZB9oH+Af6B/wH/Qf/B4AIiwiMCI0IjwiRCJQIlgiZCJoImwicCJ0IngifCKAIogijCIIIhAiFCIYIhwiICIkIiginCKkIqgirCKwIrQiuCLEIsgizCLQItQiOCp8JmAv+Cv8KgAuOCp8JyQrKChqfCcsKnwnOCs8KGp8JpwqfCY8KkAoanwmRCp8JpQqmChqfCacKjgqfCZ8KoAoanwmhCp8JogqjChqfCaQKnwmcCp0KGp8JngqOCp8JkwuUCxqfCZULnwmPC5ALGp8JkQufCaELogsanwmjC58JngufCxqfCaAL0gvOC9UL/wuFDIsMqwy9DL8M1AvRC5QMogykDKYMwQzDDNMLzwvZC4AMhgyQDMAMwgzdC4EMhwzhC4IMiAyYDKMMpQzrC4MMiQz1C4QMigyxDLIMswy0DLUMtgy3DLgMuQy6DLsMvAzEDMUMxgzHDLcC3wyHDYYNDAKrAQqt0H7vDAMAAQuJBAEDfyACQYAETwRAIAIEQCAAIAEgAvwKAAALIAAPCyAAIAJqIQMCQCAAIAFzQQNxRQRAAkAgAEEDcUUEQCAAIQIMAQsgAkUEQCAAIQIMAQsgACECA0AgAiABLQAAOgAAIAFBAWohASACQQFqIgJBA3FFDQEgAiADSQ0ACwsgA0F8cSEEAkAgA0HAAEkNACACIARBQGoiBUsNAANAIAIgASgCADYCACACIAEoAgQ2AgQgAiABKAIINgIIIAIgASgCDDYCDCACIAEoAhA2AhAgAiABKAIUNgIUIAIgASgCGDYCGCACIAEoAhw2AhwgAiABKAIgNgIgIAIgASgCJDYCJCACIAEoAig2AiggAiABKAIsNgIsIAIgASgCMDYCMCACIAEoAjQ2AjQgAiABKAI4NgI4IAIgASgCPDYCPCABQUBrIQEgAkFAayICIAVNDQALCyACIARPDQEDQCACIAEoAgA2AgAgAUEEaiEBIAJBBGoiAiAESQ0ACwwBCyADQQRJBEAgACECDAELIANBBGsiBCAASQRAIAAhAgwBCyAAIQIDQCACIAEtAAA6AAAgAiABLQABOgABIAIgAS0AAjoAAiACIAEtAAM6AAMgAUEEaiEBIAJBBGoiAiAETQ0ACwsgAiADSQRAA0AgAiABLQAAOgAAIAFBAWohASACQQFqIgIgA0cNAAsLIAAL8AICAn8BfgJAIAJFDQAgACABOgAAIAAgAmoiA0EBayABOgAAIAJBA0kNACAAIAE6AAIgACABOgABIANBA2sgAToAACADQQJrIAE6AAAgAkEHSQ0AIAAgAToAAyADQQRrIAE6AAAgAkEJSQ0AIABBACAAa0EDcSIEaiIDIAFB/wFxQYGChAhsIgE2AgAgAyACIARrQXxxIgRqIgJBBGsgATYCACAEQQlJDQAgAyABNgIIIAMgATYCBCACQQhrIAE2AgAgAkEMayABNgIAIARBGUkNACADIAE2AhggAyABNgIUIAMgATYCECADIAE2AgwgAkEQayABNgIAIAJBFGsgATYCACACQRhrIAE2AgAgAkEcayABNgIAIAQgA0EEcUEYciIEayICQSBJDQAgAa1CgYCAgBB+IQUgAyAEaiEBA0AgASAFNwMYIAEgBTcDECABIAU3AwggASAFNwMAIAFBIGohASACQSBrIgJBH0sNAAsLC1kBAX8gACAAKAJIIgFBAWsgAXI2AkggACgCACIBQQhxBEAgACABQSByNgIAQX8PCyAAQgA3AgQgACAAKAIsIgE2AhwgACABNgIUIAAgASAAKAIwajYCEEEAC4ABAQJ/IwBBEGsiAiQAIAIgAToADwJAAkAgACgCECIDBH8gAwUgABAdDQIgACgCEAsgACgCFCIDRg0AIAAoAlAgAUH/AXFGDQAgACADQQFqNgIUIAMgAToAAAwBCyAAIAJBD2pBASAAKAIkEQQAQQFHDQAgAi0ADxoLIAJBEGokAAu6AQEDfwJAAkAgASgCTCICQQBOBEAgAkUNAUHglzQoAgAgAkH/////A3FHDQELAkAgAEH/AXEiAiABKAJQRg0AIAEoAhQiAyABKAIQRg0AIAEgA0EBajYCFCADIAA6AAAMAgsgASACEB4MAQsgAUHMAGoiAxAgGgJAAkAgAEH/AXEiBCABKAJQRg0AIAEoAhQiAiABKAIQRg0AIAEgAkEBajYCFCACIAA6AAAMAQsgASAEEB4LIAMQIRoLCxkAIAAgACgCACIAQf////8DIAAbNgIAIAALFAEBfyAAKAIAIQEgAEEANgIAIAELwgEBA38CQCACKAIQIgMEfyADBSACEB0NASACKAIQCyACKAIUIgRrIAFJBEAgAiAAIAEgAigCJBEEAA8LAkACQCACKAJQQQBIDQAgAUUNACABIQMDQCAAIANqIgVBAWstAABBCkcEQCADQQFrIgMNAQwCCwsgAiAAIAMgAigCJBEEACIEIANJDQIgASADayEBIAIoAhQhBAwBCyAAIQVBACEDCyAEIAUgARAbGiACIAIoAhQgAWo2AhQgASADaiEECyAECzgAIAEgAmwhAiACAn8gAygCTEEASARAIAAgAiADECIMAQsgACACIAMQIgsiAEYEQA8LIAAgAW4aC5QBAQJ/An8CQCAAKAJMIgFBAE4EQCABRQ0BQeCXNCgCACABQf////8DcUcNAQsgACgCBCIBIAAoAghHBEAgACABQQFqNgIEIAEtAAAMAgsgABDUDAwBCyAAQcwAaiICECAaAn8gACgCBCIBIAAoAghHBEAgACABQQFqNgIEIAEtAAAMAQsgABDUDAshACACECEaIAALC5oBAAJAIAFBgAFOBEAgAEMAAAB/lCEAIAFB/wFJBEAgAUH/AGshAQwCCyAAQwAAAH+UIQBB/QIgASABQf0CTxtB/gFrIQEMAQsgAUGBf0oNACAAQwAAgAyUIQAgAUGbfksEQCABQeYAaiEBDAELIABDAACADJQhAEG2fSABIAFBtn1NG0HMAWohAQsgACABQRd0QYCAgPwDar6UCx0AIABBACAAQZkBTRtBAXRBsIopai8BAEGs+yhqC30BA38CQAJAIAAiAUEDcUUNACABLQAARQRAQQAPCwNAIAFBAWoiAUEDcUUNASABLQAADQALDAELA0AgASICQQRqIQFBgIKECCACKAIAIgNrIANyQYCBgoR4cUGAgYKEeEYNAAsDQCACIgFBAWohAiABLQAADQALCyABIABrC6gBAAJAIAFBgAhOBEAgAEQAAAAAAADgf6IhACABQf8PSQRAIAFB/wdrIQEMAgsgAEQAAAAAAADgf6IhAEH9FyABIAFB/RdPG0H+D2shAQwBCyABQYF4Sg0AIABEAAAAAAAAYAOiIQAgAUG4cEsEQCABQckHaiEBDAELIABEAAAAAAAAYAOiIQBB8GggASABQfBoTRtBkg9qIQELIAAgAUH/B2qtQjSGv6ILwwYCBH8DfiMAQYABayIFJAACQAJAAkAgAyAEQgBCABAwRQ0AAn8gBEL///////8/gyEKAn8gBEIwiKdB//8BcSIHQf//AUcEQEEEIAcNARpBAkEDIAMgCoRQGwwCCyADIAqEUAsLRQ0AIAJCMIinIghB//8BcSIGQf//AUcNAQsgBUEQaiABIAIgAyAEEDUgBSAFKQMQIgQgBSkDGCIDIAQgAxAzIAUpAwghAiAFKQMAIQQMAQsgASACQv///////////wCDIgogAyAEQv///////////wCDIgkQMEEATARAIAEgCiADIAkQMARAIAEhBAwCCyAFQfAAaiABIAJCAEIAEDUgBSkDeCECIAUpA3AhBAwBCyAEQjCIp0H//wFxIQcgBgR+IAEFIAVB4ABqIAEgCkIAQoCAgICAgMC7wAAQNSAFKQNoIgpCMIinQfgAayEGIAUpA2ALIQQgB0UEQCAFQdAAaiADIAlCAEKAgICAgIDAu8AAEDUgBSkDWCIJQjCIp0H4AGshByAFKQNQIQMLIAlC////////P4NCgICAgICAwACEIQsgCkL///////8/g0KAgICAgIDAAIQhCiAGIAdKBEADQAJ+IAogC30gAyAEVq19IglCAFkEQCAJIAQgA30iBIRQBEAgBUEgaiABIAJCAEIAEDUgBSkDKCECIAUpAyAhBAwFCyAJQgGGIARCP4iEDAELIApCAYYgBEI/iIQLIQogBEIBhiEEIAZBAWsiBiAHSg0ACyAHIQYLAkAgCiALfSADIARWrX0iCUIAUwRAIAohCQwBCyAJIAQgA30iBIRCAFINACAFQTBqIAEgAkIAQgAQNSAFKQM4IQIgBSkDMCEEDAELIAlC////////P1gEQANAIARCP4ghAyAGQQFrIQYgBEIBhiEEIAMgCUIBhoQiCUKAgICAgIDAAFQNAAsLIAhBgIACcSEHIAZBAEwEQCAFQUBrIAQgCUL///////8/gyAGQfgAaiAHcq1CMIaEQgBCgICAgICAwMM/EDUgBSkDSCECIAUpA0AhBAwBCyAJQv///////z+DIAYgB3KtQjCGhCECCyAAIAQ3AwAgACACNwMIIAVBgAFqJAAL9iwBDH8jAEEQayILJAACQAJAAkACQCAAQfQBTQRAQdT7MygCACIGQRAgAEELakH4A3EgAEELSRsiBUEDdiIDdiIAQQNxBEACQCAAQX9zQQFxIANqIgVBA3QiAEH8+zNqIgIgAEGE/DNqKAIAIgMoAggiAEYEQEHU+zMgBkF+IAV3cTYCAAwBCyAAQeT7MygCAEkNBCAAKAIMIANHDQQgACACNgIMIAIgADYCCAsgA0EIaiEAIAMgBUEDdCIFQQNyNgIEIAMgBWoiAyADKAIEQQFyNgIEDAULIAVB3PszKAIAIgdNDQEgAARAAkAgACADdEECIAN0IgBBACAAa3JxaCICQQN0IgBB/PszaiIBIABBhPwzaigCACIAKAIIIgNGBEBB1PszIAZBfiACd3EiBjYCAAwBCyADQeT7MygCAEkNBCADKAIMIABHDQQgAyABNgIMIAEgAzYCCAsgACAFQQNyNgIEIAAgBWoiASACQQN0IgMgBWsiBUEBcjYCBCAAIANqIAU2AgAgBwRAIAdBeHFB/PszaiECQej7MygCACEDAkAgBkEBIAdBA3Z0IgRxRQRAQdT7MyAEIAZyNgIAIAIhBAwBCyACKAIIIgRB5PszKAIASQ0FCyACIAM2AgggBCADNgIMIAMgAjYCDCADIAQ2AggLIABBCGohAEHo+zMgATYCAEHc+zMgBTYCAAwFC0HY+zMoAgAiDEUNASAMaEECdEGE/jNqKAIAIgEoAgRBeHEgBWshAyABIQIDQAJAIAIoAhAiAEUEQCACKAIUIgBFDQELIAAoAgRBeHEgBWsiAiADIAIgA0kiAhshAyAAIAEgAhshASAAIQIMAQsLIAFB5PszKAIAIgpJDQIgASgCGCEJAkAgASABKAIMIgBHBEAgASgCCCICIApJDQQgAigCDCABRw0EIAAoAgggAUcNBCACIAA2AgwgACACNgIIDAELAkAgASgCFCICBH8gAUEUagUgASgCECICRQ0BIAFBEGoLIQQDQCAEIQggAiIAQRRqIQQgACgCFCICDQAgAEEQaiEEIAAoAhAiAg0ACyAIIApJDQQgCEEANgIADAELQQAhAAsCQCAJRQ0AAkAgASgCHCIEQQJ0QYT+M2oiAigCACABRgRAIAIgADYCACAADQFB2PszIAxBfiAEd3E2AgAMAgsgCSAKSQ0EAkAgASAJKAIQRgRAIAkgADYCEAwBCyAJIAA2AhQLIABFDQELIAAgCkkNAyAAIAk2AhggASgCECICBEAgAiAKSQ0EIAAgAjYCECACIAA2AhgLIAEoAhQiAkUNACACIApJDQMgACACNgIUIAIgADYCGAsCQCADQQ9NBEAgASADIAVqIgBBA3I2AgQgACABaiIAIAAoAgRBAXI2AgQMAQsgASAFQQNyNgIEIAEgBWoiBSADQQFyNgIEIAMgBWogAzYCACAHBEAgB0F4cUH8+zNqIQJB6PszKAIAIQACQEEBIAdBA3Z0IgQgBnFFBEBB1PszIAQgBnI2AgAgAiEEDAELIAIoAggiBCAKSQ0FCyACIAA2AgggBCAANgIMIAAgAjYCDCAAIAQ2AggLQej7MyAFNgIAQdz7MyADNgIACyABQQhqIQAMBAtBfyEFIABBv39LDQAgAEELaiIDQXhxIQVB2PszKAIAIglFDQBBHyEHIABB9P//B00EQCAFQSYgA0EIdmciAGt2QQFxIABBAXRrQT5qIQcLQQAgBWshAwJAAkACQCAHQQJ0QYT+M2ooAgAiAkUEQEEAIQAMAQtBACEAIAVBGSAHQQF2a0EAIAdBH0cbdCEBA0ACQCACKAIEQXhxIAVrIgYgA08NACACIQQgBiIDDQBBACEDIAIhAAwDCyAAIAIoAhQiBiAGIAIgAUEddkEEcWooAhAiCEYbIAAgBhshACABQQF0IQEgCCICDQALCyAAIARyRQRAQQAhBEECIAd0IgBBACAAa3IgCXEiAEUNAyAAaEECdEGE/jNqKAIAIQALIABFDQELA0AgACgCBEF4cSAFayIGIANJIQEgBiADIAEbIQMgACAEIAEbIQQgACgCECICBH8gAgUgACgCFAsiAA0ACwsgBEUNACADQdz7MygCACAFa08NACAEQeT7MygCACIISQ0BIAQoAhghBwJAIAQgBCgCDCIARwRAIAQoAggiAiAISQ0DIAIoAgwgBEcNAyAAKAIIIARHDQMgAiAANgIMIAAgAjYCCAwBCwJAIAQoAhQiAgR/IARBFGoFIAQoAhAiAkUNASAEQRBqCyEBA0AgASEGIAIiAEEUaiEBIAAoAhQiAg0AIABBEGohASAAKAIQIgINAAsgBiAISQ0DIAZBADYCAAwBC0EAIQALAkAgB0UNAAJAIAQoAhwiAUECdEGE/jNqIgIoAgAgBEYEQCACIAA2AgAgAA0BQdj7MyAJQX4gAXdxIgk2AgAMAgsgByAISQ0DAkAgBCAHKAIQRgRAIAcgADYCEAwBCyAHIAA2AhQLIABFDQELIAAgCEkNAiAAIAc2AhggBCgCECICBEAgAiAISQ0DIAAgAjYCECACIAA2AhgLIAQoAhQiAkUNACACIAhJDQIgACACNgIUIAIgADYCGAsCQCADQQ9NBEAgBCADIAVqIgBBA3I2AgQgACAEaiIAIAAoAgRBAXI2AgQMAQsgBCAFQQNyNgIEIAQgBWoiASADQQFyNgIEIAEgA2ogAzYCACADQf8BTQRAIANBeHFB/PszaiEAAkBB1PszKAIAIgVBASADQQN2dCIDcUUEQEHU+zMgAyAFcjYCACAAIQMMAQsgACgCCCIDIAhJDQQLIAAgATYCCCADIAE2AgwgASAANgIMIAEgAzYCCAwBC0EfIQAgA0H///8HTQRAIANBJiADQQh2ZyIAa3ZBAXEgAEEBdGtBPmohAAsgASAANgIcIAFCADcCECAAQQJ0QYT+M2ohBQJAAkAgCUEBIAB0IgJxRQRAQdj7MyACIAlyNgIAIAUgATYCACABIAU2AhgMAQsgA0EZIABBAXZrQQAgAEEfRxt0IQAgBSgCACECA0AgAiIFKAIEQXhxIANGDQIgAEEddiECIABBAXQhACAFIAJBBHFqIgYoAhAiAg0ACyAGQRBqIgAgCEkNBCAAIAE2AgAgASAFNgIYCyABIAE2AgwgASABNgIIDAELIAUgCEkNAiAFKAIIIgAgCEkNAiAAIAE2AgwgBSABNgIIIAFBADYCGCABIAU2AgwgASAANgIICyAEQQhqIQAMAwsgBUHc+zMoAgAiAE0EQEHo+zMoAgAhAwJAIAAgBWsiAkEQTwRAIAMgBWoiASACQQFyNgIEIAAgA2ogAjYCACADIAVBA3I2AgQMAQsgAyAAQQNyNgIEIAAgA2oiACAAKAIEQQFyNgIEQQAhAUEAIQILQdz7MyACNgIAQej7MyABNgIAIANBCGohAAwDCyAFQeD7MygCACIBSQRAQeD7MyABIAVrIgM2AgBB7PszQez7MygCACIAIAVqIgI2AgAgAiADQQFyNgIEIAAgBUEDcjYCBCAAQQhqIQAMAwtBACEAIAVBL2oiBwJ/Qaz/MygCAARAQbT/MygCAAwBC0G4/zNCfzcCAEGw/zNCgKCAgICABDcCAEGs/zMgC0EMakFwcUHYqtWqBXM2AgBBwP8zQQA2AgBBkP8zQQA2AgBBgCALIgNqIgZBACADayIIcSIEIAVNDQJBjP8zKAIAIgMEQEGE/zMoAgAiAiAEaiIJIAJNDQMgAyAJSQ0DCwJAAkBBkP8zLQAAQQRxRQRAAkACQAJAAkBB7PszKAIAIgMEQEGU/zMhAANAIAAoAgAiAiADTQRAIAMgAiAAKAIEakkNAwsgACgCCCIADQALC0EAEC8iAUF/Rg0DIAQhBkGw/zMoAgAiAEEBayIDIAFxBEAgBCABayABIANqQQAgAGtxaiEGCyAFIAZPDQNBjP8zKAIAIgAEQEGE/zMoAgAiAyAGaiICIANNDQQgACACSQ0ECyAGEC8iACABRw0BDAULIAYgAWsgCHEiBhAvIgEgACgCACAAKAIEakYNASABIQALIABBf0YNASAFQTBqIAZNBEAgACEBDAQLQbT/MygCACIDIAcgBmtqQQAgA2txIgMQL0F/Rg0BIAMgBmohBiAAIQEMAwsgAUF/Rw0CC0GQ/zNBkP8zKAIAQQRyNgIACyAEEC8hAUEAEC8hACABQX9GDQEgAEF/Rg0BIAAgAU0NASAAIAFrIgYgBUEoak0NAQtBhP8zQYT/MygCACAGaiIANgIAQYj/MygCACAASQRAQYj/MyAANgIACwJAAkACQEHs+zMoAgAiAwRAQZT/MyEAA0AgASAAKAIAIgIgACgCBCIEakYNAiAAKAIIIgANAAsMAgtB5PszKAIAIgBBACAAIAFNG0UEQEHk+zMgATYCAAtBACEAQZj/MyAGNgIAQZT/MyABNgIAQfT7M0F/NgIAQfj7M0Gs/zMoAgA2AgBBoP8zQQA2AgADQCAAQQN0IgNBhPwzaiADQfz7M2oiAjYCACADQYj8M2ogAjYCACAAQQFqIgBBIEcNAAtB4PszIAZBKGsiAEF4IAFrQQdxIgNrIgI2AgBB7PszIAEgA2oiAzYCACADIAJBAXI2AgQgACABakEoNgIEQfD7M0G8/zMoAgA2AgAMAgsgASADTQ0AIAIgA0sNACAAKAIMQQhxDQAgACAEIAZqNgIEQez7MyADQXggA2tBB3EiAGoiAjYCAEHg+zNB4PszKAIAIAZqIgEgAGsiADYCACACIABBAXI2AgQgASADakEoNgIEQfD7M0G8/zMoAgA2AgAMAQtB5PszKAIAIAFLBEBB5PszIAE2AgALIAEgBmohAkGU/zMhAAJAA0AgAiAAKAIAIgRHBEAgACgCCCIADQEMAgsLIAAtAAxBCHFFDQQLQZT/MyEAA0ACQCAAKAIAIgIgA00EQCADIAIgACgCBGoiAkkNAQsgACgCCCEADAELC0Hg+zMgBkEoayIAQXggAWtBB3EiBGsiCDYCAEHs+zMgASAEaiIENgIAIAQgCEEBcjYCBCAAIAFqQSg2AgRB8PszQbz/MygCADYCACADIAJBJyACa0EHcWpBL2siACAAIANBEGpJGyIEQRs2AgQgBEGc/zMpAgA3AhAgBEGU/zMpAgA3AghBnP8zIARBCGo2AgBBmP8zIAY2AgBBlP8zIAE2AgBBoP8zQQA2AgAgBEEYaiEAA0AgAEEHNgIEIABBCGohASAAQQRqIQAgASACSQ0ACyADIARGDQAgBCAEKAIEQX5xNgIEIAMgBCADayIBQQFyNgIEIAQgATYCAAJ/IAFB/wFNBEAgAUF4cUH8+zNqIQACQEHU+zMoAgAiAkEBIAFBA3Z0IgFxRQRAQdT7MyABIAJyNgIAIAAhAgwBCyAAKAIIIgJB5PszKAIASQ0FCyAAIAM2AgggAiADNgIMQQwhAUEIDAELQR8hACABQf///wdNBEAgAUEmIAFBCHZnIgBrdkEBcSAAQQF0a0E+aiEACyADIAA2AhwgA0IANwIQIABBAnRBhP4zaiECAkACQEHY+zMoAgAiBEEBIAB0IgZxRQRAQdj7MyAEIAZyNgIAIAIgAzYCACADIAI2AhgMAQsgAUEZIABBAXZrQQAgAEEfRxt0IQAgAigCACEEA0AgBCICKAIEQXhxIAFGDQIgAEEddiEEIABBAXQhACACIARBBHFqIgYoAhAiBA0ACyAGQRBqIgBB5PszKAIASQ0FIAAgAzYCACADIAI2AhgLQQghASADIQIgAyEAQQwMAQsgAkHk+zMoAgAiAUkNAyACKAIIIgAgAUkNAyAAIAM2AgwgAiADNgIIIAMgADYCCEEAIQBBGCEBQQwLIANqIAI2AgAgASADaiAANgIAC0Hg+zMoAgAiACAFTQ0AQeD7MyAAIAVrIgM2AgBB7PszQez7MygCACIAIAVqIgI2AgAgAiADQQFyNgIEIAAgBUEDcjYCBCAAQQhqIQAMAwtB0PszQTA2AgBBACEADAILEKwGAAsgACABNgIAIAAgACgCBCAGajYCBAJ/IAFBeCABa0EHcWoiCSAFQQNyNgIEIARBeCAEa0EHcWoiBiAFIAlqIgVrIQECQAJAQez7MygCACAGRgRAQez7MyAFNgIAQeD7M0Hg+zMoAgAgAWoiADYCACAFIABBAXI2AgQMAQtB6PszKAIAIAZGBEBB6PszIAU2AgBB3PszQdz7MygCACABaiIANgIAIAUgAEEBcjYCBCAAIAVqIAA2AgAMAQsgBigCBCIHQQNxQQFGBEAgBigCDCEAAkAgB0H/AU0EQCAGKAIIIgQgB0EDdiIDQQN0Qfz7M2oiAkcEQCAEQeT7MygCAEkNBSAEKAIMIAZHDQULIAAgBEYEQEHU+zNB1PszKAIAQX4gA3dxNgIADAILIAAgAkcEQCAAQeT7MygCAEkNBSAAKAIIIAZHDQULIAQgADYCDCAAIAQ2AggMAQsgBigCGCEIAkAgACAGRwRAIAYoAggiBEHk+zMoAgBJDQUgBCgCDCAGRw0FIAAoAgggBkcNBSAEIAA2AgwgACAENgIIDAELAkAgBigCFCIEBH8gBkEUagUgBigCECIERQ0BIAZBEGoLIQIDQCACIQMgBCIAQRRqIQIgACgCFCIEDQAgAEEQaiECIAAoAhAiBA0ACyADQeT7MygCAEkNBSADQQA2AgAMAQtBACEACyAIRQ0AAkAgBigCHCICQQJ0QYT+M2oiBCgCACAGRgRAIAQgADYCACAADQFB2PszQdj7MygCAEF+IAJ3cTYCAAwCCyAIQeT7MygCAEkNBAJAIAYgCCgCEEYEQCAIIAA2AhAMAQsgCCAANgIUCyAARQ0BCyAAQeT7MygCACICSQ0DIAAgCDYCGCAGKAIQIgQEQCACIARLDQQgACAENgIQIAQgADYCGAsgBigCFCIERQ0AIAIgBEsNAyAAIAQ2AhQgBCAANgIYCyAHQXhxIgAgAWohASAAIAZqIgYoAgQhBwsgBiAHQX5xNgIEIAUgAUEBcjYCBCABIAVqIAE2AgAgAUH/AU0EQCABQXhxQfz7M2ohAAJAQdT7MygCACIEQQEgAUEDdnQiAXFFBEBB1PszIAEgBHI2AgAgACEBDAELIAAoAggiAUHk+zMoAgBJDQMLIAAgBTYCCCABIAU2AgwgBSAANgIMIAUgATYCCAwBC0EfIQAgAUH///8HTQRAIAFBJiABQQh2ZyIAa3ZBAXEgAEEBdGtBPmohAAsgBSAANgIcIAVCADcCECAAQQJ0QYT+M2ohBAJAAkBB2PszKAIAIgJBASAAdCIGcUUEQEHY+zMgAiAGcjYCACAEIAU2AgAgBSAENgIYDAELIAFBGSAAQQF2a0EAIABBH0cbdCEAIAQoAgAhAgNAIAIiBCgCBEF4cSABRg0CIABBHXYhAiAAQQF0IQAgBCACQQRxaiIGKAIQIgINAAsgBkEQaiIAQeT7MygCAEkNAyAAIAU2AgAgBSAENgIYCyAFIAU2AgwgBSAFNgIIDAELIARB5PszKAIAIgFJDQEgBCgCCCIAIAFJDQEgACAFNgIMIAQgBTYCCCAFQQA2AhggBSAENgIMIAUgADYCCAsgCUEIagwBCxCsBgALIQALIAtBEGokACAAC68OAQp/AkACQCAARQ0AIABBCGsiA0Hk+zMoAgAiBkkNASAAQQRrKAIAIgFBA3FBAUYNASADIAFBeHEiAGohBAJAIAFBAXENACABQQJxRQ0BIAMgAygCACICayIDIAZJDQIgACACaiEAQej7MygCACADRwRAIAMoAgwhASACQf8BTQRAIAMoAggiBSACQQN2IghBA3RB/PszaiICRwRAIAUgBkkNBSAFKAIMIANHDQULIAEgBUYEQEHU+zNB1PszKAIAQX4gCHdxNgIADAMLIAEgAkcEQCABIAZJDQUgASgCCCADRw0FCyAFIAE2AgwgASAFNgIIDAILIAMoAhghBwJAIAEgA0cEQCADKAIIIgIgBkkNBSACKAIMIANHDQUgASgCCCADRw0FIAIgATYCDCABIAI2AggMAQsCQCADKAIUIgIEfyADQRRqBSADKAIQIgJFDQEgA0EQagshBQNAIAUhCCACIgFBFGohBSABKAIUIgINACABQRBqIQUgASgCECICDQALIAYgCEsNBSAIQQA2AgAMAQtBACEBCyAHRQ0BAkAgAygCHCIFQQJ0QYT+M2oiAigCACADRgRAIAIgATYCACABDQFB2PszQdj7MygCAEF+IAV3cTYCAAwDCyAGIAdLDQQCQCADIAcoAhBGBEAgByABNgIQDAELIAcgATYCFAsgAUUNAgsgASAGSQ0DIAEgBzYCGCADKAIQIgIEQCACIAZJDQQgASACNgIQIAIgATYCGAsgAygCFCICRQ0BIAIgBkkNAyABIAI2AhQgAiABNgIYDAELIAQoAgQiAUEDcUEDRw0AQdz7MyAANgIAIAQgAUF+cTYCBCADIABBAXI2AgQgBCAANgIADwsgAyAETw0BIAQoAgQiCEEBcUUNAQJAIAhBAnFFBEBB7PszKAIAIARGBEBB7PszIAM2AgBB4PszQeD7MygCACAAaiIANgIAIAMgAEEBcjYCBCADQej7MygCAEcNA0Hc+zNBADYCAEHo+zNBADYCAA8LQej7MygCACIKIARGBEBB6PszIAM2AgBB3PszQdz7MygCACAAaiIANgIAIAMgAEEBcjYCBCAAIANqIAA2AgAPCyAEKAIMIQECQCAIQf8BTQRAIAQoAggiAiAIQQN2IgdBA3RB/PszaiIFRwRAIAIgBkkNBiACKAIMIARHDQYLIAEgAkYEQEHU+zNB1PszKAIAQX4gB3dxNgIADAILIAEgBUcEQCABIAZJDQYgASgCCCAERw0GCyACIAE2AgwgASACNgIIDAELIAQoAhghCQJAIAEgBEcEQCAEKAIIIgIgBkkNBiACKAIMIARHDQYgASgCCCAERw0GIAIgATYCDCABIAI2AggMAQsCQCAEKAIUIgIEfyAEQRRqBSAEKAIQIgJFDQEgBEEQagshBQNAIAUhByACIgFBFGohBSABKAIUIgINACABQRBqIQUgASgCECICDQALIAYgB0sNBiAHQQA2AgAMAQtBACEBCyAJRQ0AAkAgBCgCHCIFQQJ0QYT+M2oiAigCACAERgRAIAIgATYCACABDQFB2PszQdj7MygCAEF+IAV3cTYCAAwCCyAGIAlLDQUCQCAEIAkoAhBGBEAgCSABNgIQDAELIAkgATYCFAsgAUUNAQsgASAGSQ0EIAEgCTYCGCAEKAIQIgIEQCACIAZJDQUgASACNgIQIAIgATYCGAsgBCgCFCICRQ0AIAIgBkkNBCABIAI2AhQgAiABNgIYCyADIAhBeHEgAGoiAEEBcjYCBCAAIANqIAA2AgAgAyAKRw0BQdz7MyAANgIADwsgBCAIQX5xNgIEIAMgAEEBcjYCBCAAIANqIAA2AgALIABB/wFNBEAgAEF4cUH8+zNqIQECQEHU+zMoAgAiAkEBIABBA3Z0IgBxRQRAQdT7MyAAIAJyNgIAIAEhAAwBCyABKAIIIgAgBkkNAwsgASADNgIIIAAgAzYCDCADIAE2AgwgAyAANgIIDwtBHyEBIABB////B00EQCAAQSYgAEEIdmciAWt2QQFxIAFBAXRrQT5qIQELIAMgATYCHCADQgA3AhAgAUECdEGE/jNqIQUCfwJAAn9B2PszKAIAIgJBASABdCIEcUUEQEHY+zMgAiAEcjYCACAFIAM2AgBBGCEBQQgMAQsgAEEZIAFBAXZrQQAgAUEfRxt0IQEgBSgCACEFA0AgBSICKAIEQXhxIABGDQIgAUEddiEFIAFBAXQhASACIAVBBHFqIgQoAhAiBQ0ACyAEQRBqIgAgBkkNBCAAIAM2AgBBGCEBIAIhBUEICyEAIAMhAiADDAELIAIgBkkNAiACKAIIIgUgBkkNAiAFIAM2AgwgAiADNgIIQRghAEEIIQFBAAshBCABIANqIAU2AgAgAyACNgIMIAAgA2ogBDYCAEH0+zNB9PszKAIAQQFrIgNBfyADGzYCAAsPCxCsBgALugkBC38gAEUEQCABECoPCyABQUBPBEBB0PszQTA2AgBBAA8LAn9BECABQQtqQXhxIAFBC0kbIQQCQAJAQeT7MygCACIJIABBCGsiBUsNACAFKAIEIghBA3EiA0EBRg0AIAhBeHEiAkUNACACIAVqIgYoAgQiB0EBcUUNACADRQRAQQAhAyAEQYACSQ0CIARBBGogAk0EQCAFIQMgAiAEa0G0/zMoAgBBAXRNDQMLQQAhAwwCCyACIARPBEAgAiAEayICQRBPBEAgBSAEIAhBAXFyQQJyNgIEIAQgBWoiBCACQQNyNgIEIAYgBigCBEEBcjYCBCAEIAIQLQsgBQwDC0EAIQNB7PszKAIAIAZGBEBB4PszKAIAIAJqIgIgBE0NAiAFIAQgCEEBcXJBAnI2AgQgBCAFaiIIIAIgBGsiAkEBcjYCBEHg+zMgAjYCAEHs+zMgCDYCACAFDAMLQej7MygCACAGRgRAQdz7MygCACACaiICIARJDQICQCACIARrIgNBEE8EQCAFIAQgCEEBcXJBAnI2AgQgBCAFaiIEIANBAXI2AgQgAiAFaiICIAM2AgAgAiACKAIEQX5xNgIEDAELIAUgCEEBcSACckECcjYCBCACIAVqIgIgAigCBEEBcjYCBEEAIQNBACEEC0Ho+zMgBDYCAEHc+zMgAzYCACAFDAMLIAdBAnENASAHQXhxIAJqIgsgBEkNASAGKAIMIQICQCAHQf8BTQRAIAYoAggiAyAHQQN2IgxBA3RB/PszaiIHRwRAIAMgCUkNAyADKAIMIAZHDQMLIAIgA0YEQEHU+zNB1PszKAIAQX4gDHdxNgIADAILIAIgB0cEQCACIAlJDQMgAigCCCAGRw0DCyADIAI2AgwgAiADNgIIDAELIAYoAhghCgJAIAIgBkcEQCAGKAIIIgMgCUkNAyADKAIMIAZHDQMgAigCCCAGRw0DIAMgAjYCDCACIAM2AggMAQsCQCAGKAIUIgMEfyAGQRRqBSAGKAIQIgNFDQEgBkEQagshBwNAIAchDCADIgJBFGohByACKAIUIgMNACACQRBqIQcgAigCECIDDQALIAkgDEsNAyAMQQA2AgAMAQtBACECCyAKRQ0AAkAgBigCHCIHQQJ0QYT+M2oiAygCACAGRgRAIAMgAjYCACACDQFB2PszQdj7MygCAEF+IAd3cTYCAAwCCyAJIApLDQICQCAGIAooAhBGBEAgCiACNgIQDAELIAogAjYCFAsgAkUNAQsgAiAJSQ0BIAIgCjYCGCAGKAIQIgMEQCADIAlJDQIgAiADNgIQIAMgAjYCGAsgBigCFCIDRQ0AIAMgCUkNASACIAM2AhQgAyACNgIYCyALIARrIgJBD00EQCAFIAhBAXEgC3JBAnI2AgQgBSALaiICIAIoAgRBAXI2AgQgBQwDCyAFIAQgCEEBcXJBAnI2AgQgBCAFaiIEIAJBA3I2AgQgBSALaiIIIAgoAgRBAXI2AgQgBCACEC0gBQwCCxCsBgALIAMLIgMEQCADQQhqDwsgARAqIgNFBEBBAA8LIAMgAEF8QXggAEEEaygCACICQQNxGyACQXhxaiICIAEgASACSxsQGxogABArIAML5g0BCX8gACABaiEEAkACQAJAIAAoAgQiAkEBcQRAQeT7MygCACEGDAELIAJBAnFFDQEgACAAKAIAIgNrIgBB5PszKAIAIgZJDQIgASADaiEBQej7MygCACAARwRAIAAoAgwhAiADQf8BTQRAIAAoAggiBSADQQN2IghBA3RB/PszaiIDRwRAIAUgBkkNBSAFKAIMIABHDQULIAIgBUYEQEHU+zNB1PszKAIAQX4gCHdxNgIADAMLIAIgA0cEQCACIAZJDQUgAigCCCAARw0FCyAFIAI2AgwgAiAFNgIIDAILIAAoAhghBwJAIAAgAkcEQCAAKAIIIgMgBkkNBSADKAIMIABHDQUgAigCCCAARw0FIAMgAjYCDCACIAM2AggMAQsCQCAAKAIUIgMEfyAAQRRqBSAAKAIQIgNFDQEgAEEQagshBQNAIAUhCCADIgJBFGohBSACKAIUIgMNACACQRBqIQUgAigCECIDDQALIAYgCEsNBSAIQQA2AgAMAQtBACECCyAHRQ0BAkAgACgCHCIFQQJ0QYT+M2oiAygCACAARgRAIAMgAjYCACACDQFB2PszQdj7MygCAEF+IAV3cTYCAAwDCyAGIAdLDQQCQCAAIAcoAhBGBEAgByACNgIQDAELIAcgAjYCFAsgAkUNAgsgAiAGSQ0DIAIgBzYCGCAAKAIQIgMEQCADIAZJDQQgAiADNgIQIAMgAjYCGAsgACgCFCIDRQ0BIAMgBkkNAyACIAM2AhQgAyACNgIYDAELIAQoAgQiAkEDcUEDRw0AQdz7MyABNgIAIAQgAkF+cTYCBCAAIAFBAXI2AgQgBCABNgIADwsgBCAGSQ0BAkAgBCgCBCIHQQJxRQRAQez7MygCACAERgRAQez7MyAANgIAQeD7M0Hg+zMoAgAgAWoiATYCACAAIAFBAXI2AgQgAEHo+zMoAgBHDQNB3PszQQA2AgBB6PszQQA2AgAPC0Ho+zMoAgAiCiAERgRAQej7MyAANgIAQdz7M0Hc+zMoAgAgAWoiATYCACAAIAFBAXI2AgQgACABaiABNgIADwsgBCgCDCECAkAgB0H/AU0EQCAEKAIIIgMgB0EDdiIIQQN0Qfz7M2oiBUcEQCADIAZJDQYgAygCDCAERw0GCyACIANGBEBB1PszQdT7MygCAEF+IAh3cTYCAAwCCyACIAVHBEAgAiAGSQ0GIAIoAgggBEcNBgsgAyACNgIMIAIgAzYCCAwBCyAEKAIYIQkCQCACIARHBEAgBCgCCCIDIAZJDQYgAygCDCAERw0GIAIoAgggBEcNBiADIAI2AgwgAiADNgIIDAELAkAgBCgCFCIDBH8gBEEUagUgBCgCECIDRQ0BIARBEGoLIQUDQCAFIQggAyICQRRqIQUgAigCFCIDDQAgAkEQaiEFIAIoAhAiAw0ACyAGIAhLDQYgCEEANgIADAELQQAhAgsgCUUNAAJAIAQoAhwiBUECdEGE/jNqIgMoAgAgBEYEQCADIAI2AgAgAg0BQdj7M0HY+zMoAgBBfiAFd3E2AgAMAgsgBiAJSw0FAkAgBCAJKAIQRgRAIAkgAjYCEAwBCyAJIAI2AhQLIAJFDQELIAIgBkkNBCACIAk2AhggBCgCECIDBEAgAyAGSQ0FIAIgAzYCECADIAI2AhgLIAQoAhQiA0UNACADIAZJDQQgAiADNgIUIAMgAjYCGAsgACAHQXhxIAFqIgFBAXI2AgQgACABaiABNgIAIAAgCkcNAUHc+zMgATYCAA8LIAQgB0F+cTYCBCAAIAFBAXI2AgQgACABaiABNgIACyABQf8BTQRAIAFBeHFB/PszaiECAkBB1PszKAIAIgNBASABQQN2dCIBcUUEQEHU+zMgASADcjYCACACIQEMAQsgAigCCCIBIAZJDQMLIAIgADYCCCABIAA2AgwgACACNgIMIAAgATYCCA8LQR8hAiABQf///wdNBEAgAUEmIAFBCHZnIgJrdkEBcSACQQF0a0E+aiECCyAAIAI2AhwgAEIANwIQIAJBAnRBhP4zaiEDAkACQEHY+zMoAgAiBUEBIAJ0IgRxRQRAQdj7MyAEIAVyNgIAIAMgADYCACAAIAM2AhgMAQsgAUEZIAJBAXZrQQAgAkEfRxt0IQIgAygCACEFA0AgBSIDKAIEQXhxIAFGDQIgAkEddiEFIAJBAXQhAiADIAVBBHFqIgQoAhAiBQ0ACyAEQRBqIgEgBkkNAyABIAA2AgAgACADNgIYCyAAIAA2AgwgACAANgIIDwsgAyAGSQ0BIAMoAggiASAGSQ0BIAEgADYCDCADIAA2AgggAEEANgIYIAAgAzYCDCAAIAE2AggLDwsQrAYAC1kCAX8BfgJAAn9BACAARQ0AGiAArSABrX4iA6ciAiAAIAFyQYCABEkNABpBfyACIANCIIinGwsiAhAqIgBFDQAgAEEEay0AAEEDcUUNACAAQQAgAhAcCyAAC1IBAn9BgMwyKAIAIgEgAEEHakF4cSICaiEAAkAgAkEAIAAgAU0bRQRAIAA/AEEQdE0NASAAEBQNAQtB0PszQTA2AgBBfw8LQYDMMiAANgIAIAEL2wECAX8CfkEBIQQCQCAAQgBSIAFC////////////AIMiBUKAgICAgIDA//8AViAFQoCAgICAgMD//wBRGw0AIAJCAFIgA0L///////////8AgyIGQoCAgICAgMD//wBWIAZCgICAgICAwP//AFEbDQAgACAChCAFIAaEhFAEQEEADwsgASADg0IAWQRAIAAgAlQgASADUyABIANRGwRAQX8PCyAAIAKFIAEgA4WEQgBSDwsgACACViABIANVIAEgA1EbBEBBfw8LIAAgAoUgASADhYRCAFIhBAsgBAvAAQIBfwJ+QX8hAwJAIABCAFIgAUL///////////8AgyIEQoCAgICAgMD//wBWIARCgICAgICAwP//AFEbDQAgAkL///////////8AgyIFQoCAgICAgMD//wBWIAVCgICAgICAwP//AFJxDQAgACAEIAWEhFAEQEEADwsgASACg0IAWQRAIAEgAlIgASACU3ENASAAIAEgAoWEQgBSDwsgAEIAUiABIAJVIAEgAlEbDQAgACABIAKFhEIAUiEDCyADC1ABAX4CQCADQcAAcQRAIAEgA0FAaq2GIQJCACEBDAELIANFDQAgAiADrSIEhiABQcAAIANrrYiEIQIgASAEhiEBCyAAIAE3AwAgACACNwMIC4cQAgV/D34jAEHQAmsiBSQAIARC////////P4MhCyACQv///////z+DIQogAiAEhUKAgICAgICAgIB/gyEMIARCMIinQf//AXEhBwJAAkAgAkIwiKdB//8BcSIIQf//AWtBgoB+TwRAIAdB//8Ba0GBgH5LDQELIAFQIAJC////////////AIMiDUKAgICAgIDA//8AVCANQoCAgICAgMD//wBRG0UEQCACQoCAgICAgCCEIQwMAgsgA1AgBEL///////////8AgyICQoCAgICAgMD//wBUIAJCgICAgICAwP//AFEbRQRAIARCgICAgICAIIQhDCADIQEMAgsgASANQoCAgICAgMD//wCFhFAEQCADIAJCgICAgICAwP//AIWEUARAQgAhAUKAgICAgIDg//8AIQwMAwsgDEKAgICAgIDA//8AhCEMQgAhAQwCCyADIAJCgICAgICAwP//AIWEUARAQgAhAQwCCyABIA2EUARAQoCAgICAgOD//wAgDCACIAOEUBshDEIAIQEMAgsgAiADhFAEQCAMQoCAgICAgMD//wCEIQxCACEBDAILIA1C////////P1gEQCAFQcACaiABIAogASAKIApQIgYbeULAAEIAIAYbfKciBkEPaxAyQRAgBmshBiAFKQPIAiEKIAUpA8ACIQELIAJC////////P1YNACAFQbACaiADIAsgAyALIAtQIgkbeULAAEIAIAkbfKciCUEPaxAyIAYgCWpBEGshBiAFKQO4AiELIAUpA7ACIQMLIAVBoAJqIAtCgICAgICAwACEIhFCD4YgA0IxiIQiAkIAQoCAgICw5ryC9QAgAn0iBEIAEDYgBUGQAmpCACAFKQOoAn1CACAEQgAQNiAFQYACaiAFKQOYAkIBhiAFKQOQAkI/iIQiBEIAIAJCABA2IAVB8AFqIARCAEIAIAUpA4gCfUIAEDYgBUHgAWogBSkD+AFCAYYgBSkD8AFCP4iEIgRCACACQgAQNiAFQdABaiAEQgBCACAFKQPoAX1CABA2IAVBwAFqIAUpA9gBQgGGIAUpA9ABQj+IhCIEQgAgAkIAEDYgBUGwAWogBEIAQgAgBSkDyAF9QgAQNiAFQaABaiACQgAgBSkDuAFCAYYgBSkDsAFCP4iEQgF9IgRCABA2IAVBkAFqIANCD4ZCACAEQgAQNiAFQfAAaiAEQgBCACAFKQOoASAFKQOgASILIAUpA5gBfCICIAtUrXwgAkIBVq18fUIAEDYgBUGAAWpCASACfUIAIARCABA2IAYgCCAHa2oiCEH//wBqIQcCfiAFKQNwIhJCAYYiDiAFKQOIASIPQgGGIAUpA4ABQj+IhHwiDULn7AB9IhNCIIgiAiAKQoCAgICAgMAAhCIVQgGGIhdCIIgiBH4iECABQgGGIhRCIIgiCyANIBNWrSANIA5UrSAFKQN4QgGGIBJCP4iEIA9CP4h8fHxCAX0iEkIgiCINfnwiDiAQVK0gDiASQv////8PgyISIAFCP4giGCAKQgGGhEL/////D4MiCn58Ig8gDlStfCAEIA1+fCAEIBJ+IhAgCiANfnwiDiAQVK1CIIYgDkIgiIR8IA8gDkIghnwiECAPVK18IBAgE0L/////D4MiEyAKfiIOIAIgC358Ig8gDlStIA8gEiAUQv7///8PgyIOfnwiFiAPVK18fCIPIBBUrXwgDyAEIBN+IhAgDSAOfnwiBCACIAp+fCIKIAsgEn58Ig1CIIggCiANVq0gBCAQVK0gBCAKVq18fEIghoR8IgQgD1StfCAEIBYgAiAOfiIKIAsgE358IgJCIIggAiAKVK1CIIaEfCIKIBZUrSAKIA1CIIZ8IgsgClStfHwiCiAEVK18IAogCyACQiCGIgIgDiATfnwgAlStQn+FIgJWIAIgC1JxrXwiBCAKVK18IgJC/////////wBYBEAgFyAYhCEVIAVB0ABqIAQgAkKAgICAgIDAAFQiBq0iC4YiCiACIAuGIARCAYggBkE/c62IhCIEIAMgERA2IAhB/v8AaiAHIAYbQQFrIQcgAUIxhiAFKQNYfSAFKQNQIgFCAFKtfSELQgAgAX0MAQsgBUHgAGogAkI/hiAEQgGIhCIKIAJCAYgiBCADIBEQNiABQjCGIAUpA2h9IAUpA2AiAkIAUq19IQsgASEUQgAgAn0LIQIgB0H//wFOBEAgDEKAgICAgIDA//8AhCEMQgAhAQwBCwJ+IAdBAEoEQCALQgGGIAJCP4iEIQEgBEL///////8/gyAHrUIwhoQhCyACQgGGDAELIAdBj39MBEBCACEBDAILIAVBQGsgCiAEQQEgB2sQNCAFQTBqIBQgFSAHQfAAahAyIAVBIGogAyARIAUpA0AiCiAFKQNIIgsQNiAFKQM4IAUpAyhCAYYgBSkDICIBQj+IhH0gBSkDMCICIAFCAYYiBFStfSEBIAIgBH0LIQIgBUEQaiADIBFCA0IAEDYgBSADIBFCBUIAEDYgCyAKIApCAYMiBCACfCICIANWIAEgAiAEVK18IgEgEVYgASARURutfCIEIApUrXwiAyAEIANCgICAgICAwP//AFQgAiAFKQMQViABIAUpAxgiA1YgASADURtxrXwiAyAEVK18IgQgAyAEQoCAgICAgMD//wBUIAIgBSkDAFYgASAFKQMIIgJWIAEgAlEbca18IgEgA1StfCAMhCEMCyAAIAE3AwAgACAMNwMIIAVB0AJqJAALUAEBfgJAIANBwABxBEAgAiADQUBqrYghAUIAIQIMAQsgA0UNACACQcAAIANrrYYgASADrSIEiIQhASACIASIIQILIAAgATcDACAAIAI3AwgL1QoCBX8JfiMAQeAAayIFJAAgBEL///////8/gyEKIAIgBIVCgICAgICAgICAf4MhCyACQv///////z+DIg9CIIghDSAEQjCIp0H//wFxIQYCQAJAIAJCMIinQf//AXEiCEH//wFrQYKAfk8EQCAGQf//AWtBgYB+Sw0BCyABUCACQv///////////wCDIgxCgICAgICAwP//AFQgDEKAgICAgIDA//8AURtFBEAgAkKAgICAgIAghCELDAILIANQIARC////////////AIMiAkKAgICAgIDA//8AVCACQoCAgICAgMD//wBRG0UEQCAEQoCAgICAgCCEIQsgAyEBDAILIAEgDEKAgICAgIDA//8AhYRQBEAgAiADhFAEQEKAgICAgIDg//8AIQtCACEBDAMLIAtCgICAgICAwP//AIQhC0IAIQEMAgsgAyACQoCAgICAgMD//wCFhFAEQCABIAyEIQJCACEBIAJQBEBCgICAgICA4P//ACELDAMLIAtCgICAgICAwP//AIQhCwwCCyABIAyEUARAQgAhAQwCCyACIAOEUARAQgAhAQwCCyAMQv///////z9YBEAgBUHQAGogASAPIAEgDyAPUCIHG3lCwABCACAHG3ynIgdBD2sQMkEQIAdrIQcgBSkDWCIPQiCIIQ0gBSkDUCEBCyACQv///////z9WDQAgBUFAayADIAogAyAKIApQIgkbeULAAEIAIAkbfKciCUEPaxAyIAcgCWtBEGohByAFKQNIIQogBSkDQCEDCyAGIAhqIAdqQf//AGshBgJAIApCD4YiDkIgiEKAgICACIQiAiABQiCIIgR+IhAgA0IPhiIRQiCIIgogDUKAgASEIg1+fCIMIBBUrSAMIANCMYggDoRC/////w+DIgMgD0L/////D4MiD358Ig4gDFStfCACIA1+fCAOIBFCgID+/w+DIgwgD34iESAEIAp+fCIQIBFUrSAQIAMgAUL/////D4MiAX58IhEgEFStfHwiECAOVK18IAMgDX4iEiACIA9+fCIOIBJUrUIghiAOQiCIhHwgECAOQiCGfCIOIBBUrXwgDiAMIA1+IhAgCiAPfnwiDSABIAJ+fCICIAMgBH58IgNCIIggAiADVq0gDSAQVK0gAiANVK18fEIghoR8IgIgDlStfCACIBEgBCAMfiINIAEgCn58IgRCIIggBCANVK1CIIaEfCIKIBFUrSAKIANCIIZ8IgMgClStfHwiCiACVK18IAogAyAEQiCGIgIgASAMfnwiASACVK18IgIgA1StfCIEIApUrXwiA0KAgICAgIDAAINCAFIEQCAGQQFqIQYMAQsgAUI/iCEKIANCAYYgBEI/iIQhAyAEQgGGIAJCP4iEIQQgAUIBhiEBIAogAkIBhoQhAgsgBkH//wFOBEAgC0KAgICAgIDA//8AhCELQgAhAQwBCwJ+IAZBAEwEQEEBIAZrIghB/wBNBEAgBUEwaiABIAIgBkH/AGoiBhAyIAVBIGogBCADIAYQMiAFQRBqIAEgAiAIEDQgBSAEIAMgCBA0IAUpAzAgBSkDOIRCAFKtIAUpAyAgBSkDEISEIQEgBSkDKCAFKQMYhCECIAUpAwAhBCAFKQMIDAILQgAhAQwCCyADQv///////z+DIAatQjCGhAsgC4QhCyABUCACQgBZIAJCgICAgICAgICAf1EbRQRAIAsgBEIBfCIBUK18IQsMAQsgASACQoCAgICAgICAgH+FhEIAUgRAIAQhAQwBCyALIAQgBEIBg3wiASAEVK18IQsLIAAgATcDACAAIAs3AwggBUHgAGokAAt1AQF+IAAgASAEfiACIAN+fCADQiCIIgIgAUIgiCIEfnwgA0L/////D4MiAyABQv////8PgyIBfiIFQiCIIAMgBH58IgNCIIh8IAEgAn4gA0L/////D4N8IgFCIIh8NwMIIAAgBUL/////D4MgAUIghoQ3AwALDwBB0Kv0AyQCQdCrNCQBCwcAIwAjAWsLBAAjAgsEACMBCwYAIAAkAAsQACMAIABrQXBxIgAkACAACwQAIwAL2wkCBH4EfyMAQfAAayIKJAAgBEL///////////8AgyEGAkACQCABUCIJIAJC////////////AIMiBUKAgICAgIDA//8AfUKAgICAgIDAgIB/VCAFUBtFBEAgA0IAUiAGQoCAgICAgMD//wB9IghCgICAgICAwICAf1YgCEKAgICAgIDAgIB/URsNAQsgCSAFQoCAgICAgMD//wBUIAVCgICAgICAwP//AFEbRQRAIAJCgICAgICAIIQhBCABIQMMAgsgA1AgBkKAgICAgIDA//8AVCAGQoCAgICAgMD//wBRG0UEQCAEQoCAgICAgCCEIQQMAgsgASAFQoCAgICAgMD//wCFhFAEQEKAgICAgIDg//8AIAIgASADhSACIASFQoCAgICAgICAgH+FhFAiCRshBEIAIAEgCRshAwwCCyADIAZCgICAgICAwP//AIWEUA0BIAEgBYRQBEAgAyAGhEIAUg0CIAEgA4MhAyACIASDIQQMAgsgAyAGhEIAUg0AIAEhAyACIQQMAQsgAyABIAEgA1QgBSAGVCAFIAZRGyILGyEGIAQgAiALGyIIQv///////z+DIQUgAiAEIAsbIgdCMIinQf//AXEhDCAIQjCIp0H//wFxIglFBEAgCkHgAGogBiAFIAYgBSAFUCIJG3lCwABCACAJG3ynIglBD2sQMkEQIAlrIQkgCikDYCEGIAopA2ghBQsgASADIAsbIQMgB0L///////8/gyEBIAwEfiABBSAKQdAAaiADIAEgAyABIAFQIgsbeULAAEIAIAsbfKciC0EPaxAyQRAgC2shDCAKKQNQIQMgCikDWAtCA4YgA0I9iIRCgICAgICAgASEIQEgBUIDhiAGQj2IhCEHIANCA4YhBSACIASFIQMCQCAJIAxGDQAgCSAMayILQf8ASwRAQgAhAUIBIQUMAQsgCkFAayAFIAFBgAEgC2sQMiAKQTBqIAUgASALEDQgCikDMCAKKQNAIAopA0iEQgBSrYQhBSAKKQM4IQELIAdCgICAgICAgASEIQcgBkIDhiEGAkAgA0IAUwRAQgAhA0IAIQQgBSAGhSABIAeFhFANAiAGIAV9IQIgByABfSAFIAZWrX0iBEL/////////A1YNASAKQSBqIAIgBCACIAQgBFAiCxt5QsAAQgAgCxt8p0EMayILEDIgCSALayEJIAopAyghBCAKKQMgIQIMAQsgBSAGfCICIAVUrSABIAd8fCIEQoCAgICAgIAIg1ANACAFQgGDIARCP4YgAkIBiISEIQIgCUEBaiEJIARCAYghBAsgCEKAgICAgICAgIB/gyEFIAlB//8BTgRAIAVCgICAgICAwP//AIQhBEIAIQMMAQtBACELAkAgCUEASgRAIAkhCwwBCyAKQRBqIAIgBCAJQf8AahAyIAogAiAEQQEgCWsQNCAKKQMAIAopAxAgCikDGIRCAFKthCECIAopAwghBAsgBEI9hiACQgOIhCEDIARCA4hC////////P4MgC61CMIaEIAWEIQQCQAJAIAKnQQdxIglBBEcEQCAEIAMgCUEES618IgUgA1StfCEEIAUhAwwBCyAEIAMgA0IBg3wiBSADVK18IQQgBSEDDAELIAlFDQELCyAAIAM3AwAgACAENwMIIApB8ABqJAALRAEBfyMAQRBrIgUkACAFIAEgAiADIARCgICAgICAgICAf4UQPiAFKQMAIQQgACAFKQMINwMIIAAgBDcDACAFQRBqJAAL/QQDAX8HfAJ+IAC9QjCIpyEBIAC9IglCgICAgPCVqfc/fUL/////n5WEAVgEQCAJQoCAgICAgID4P1EEQEQAAAAAAAAAAA8LQeiMKSsDACIDIABEAAAAAAAA8L+gIgC9QoCAgIBwg78iBKIiBSAAIACiIgIgAEGwjSkrAwCiQaiNKSsDAKCiIgagIgcgAiACoiIIIAggAiAAQfCNKSsDAKJB6I0pKwMAoKIgAEHgjSkrAwCiQdiNKSsDAKCgoiACIABB0I0pKwMAokHIjSkrAwCgoiAAQcCNKSsDAKJBuI0pKwMAoKCgoiAAIAShIAOiIABB8IwpKwMAoqAgBiAFIAehoKCgoA8LAkAgAUHw/wFrQZ+Afk0EQCAARAAAAAAAAAAAYQRAIwBBEGsiAUQAAAAAAADwvzkDCCABKwMIRAAAAAAAAAAAow8LIAlCgICAgICAgPj/AFENASABQfD/AXFB8P8BRyABQf//AU1xRQRAIAAgAKEiACAAow8LIABEAAAAAAAAMEOivUKAgICAgICAoAN9IQkLIAlCgICAgICAgPM/fSIKQi6Ip0E/cUEEdCIBQYCOKWorAwAgCkI0h6e3oCIDQeiMKSsDACIEIAFB+I0paisDACAJIApCgICAgICAgHiDfb8gAUH4lSlqKwMAoSABQYCWKWorAwChoiIAvUKAgICAcIO/IgWiIgagIgcgACAAoiICIAIgAqIgAEGgjSkrAwCiQZiNKSsDAKCiIAIgAEGQjSkrAwCiQYiNKSsDAKCiIABBgI0pKwMAokH4jCkrAwCgoKCiIAAgBaEgBKJB8IwpKwMAIACioCAGIAMgB6GgoKCgIQALIAALDAAgAEMAAABwEPoMCwwAIABDAAAAEBD6DAsMACAAIACTIgAgAJULxwMBBn8CQAJAIAG8IgZBAXQiAkUNACABvCEDIAC8IgdBF3ZB/wFxIgRB/wFGDQAgA0H/////B3FBgYCA/AdJDQELIAAgAZQiASABlQ8LIAIgB0EBdCIDTwRAIABDAAAAAJQgACACIANGGw8LIAZBF3ZB/wFxIQMCfyAERQRAQQAhBCAHQQl0IgJBAE4EQANAIARBAWshBCACQQF0IgJBAE4NAAsLIAdBASAEa3QMAQsgB0H///8DcUGAgIAEcgshAgJ/IANFBEBBACEDIAZBCXQiBUEATgRAA0AgA0EBayEDIAVBAXQiBUEATg0ACwsgBkEBIANrdAwBCyAGQf///wNxQYCAgARyCyEGIAMgBEgEQANAAkAgAiAGayIFQQBIDQAgBSICDQAgAEMAAAAAlA8LIAJBAXQhAiAEQQFrIgQgA0oNAAsgAyEECwJAIAIgBmsiA0EASA0AIAMiAg0AIABDAAAAAJQPCwJAIAJB////A0sEQCACIQUMAQsDQCAEQQFrIQQgAkGAgIACSSEDIAJBAXQiBSECIAMNAAsLIARBAEoEfyAFQYCAgARrIARBF3RyBSAFQQEgBGt2CyAHQYCAgIB4cXK+Cx8AQcT/MygCAEUEQEHI/zMgATYCAEHE/zMgADYCAAsLEgAgAEEBIAEgAUEBTRsQRRAYCw8AQwAAgL8QSEMAAAAAlQsVAQF/IwBBEGsiASAAOAIMIAEqAgwL7gECAn8CfCAAvCIBQYCAgPwDRgRAQwAAAAAPCwJAIAFBgICA/AdrQf///4d4TQRAIAFBAXQiAkUEQBBHDwsgAUGAgID8B0YNASACQYCAgHhJIAFBAE5xRQRAIAAQQw8LIABDAAAAS5S8QYCAgNwAayEBC0HIoikrAwAgASABQYCAzPkDayICQYCAgHxxa767IAJBD3ZB8AFxIgFBwKApaisDAKJEAAAAAAAA8L+gIgMgA6IiBKJB0KIpKwMAIAOiQdiiKSsDAKCgIASiIAJBF3W3QcCiKSsDAKIgAUHIoClqKwMAoCADoKC2IQALIAALsAICBH0CfwJAAkAgALwiBUH///8DTARAIABDAAAAAFsEQEMAAIC/IAAgAJSVDwsgBUEASARAIAAgAJNDAAAAAJUPCyAAQwAAAEyUvCEFQeh+IQYMAQsgBUH////7B0sNAUGBfyEGQwAAAAAhACAFQYCAgPwDRg0BCyAGIAVBjfarAmoiBUEXdmqyIgRDgCCaPpQgBUH///8DcUHzidT5A2q+QwAAgL+SIgAgACAAQwAAAD+UlCICk7xBgGBxviIDQwBg3j6UIAAgAEMAAABAkpUiASACIAEgAZQiASABIAGUIgFD7umRPpRDqqoqP5KUIAEgAUMmnng+lEMTzsw+kpSSkpQgACADkyACk5IiAEMAYN4+lCAEQ9snVDWUIAAgA5JD2eoEuJSSkpKSIQALIAALhAECAn8BfiMAQRBrIgMkACAAAn4gAUUEQEIADAELIAMgASABQR91IgJzIAJrIgKtQgAgAmciAkHRAGoQMiADKQMIQoCAgICAgMAAhUGegAEgAmutQjCGfEKAgICAgICAgIB/QgAgAUEASBuEIQQgAykDAAs3AwAgACAENwMIIANBEGokAAvPAQIEfgJ/IwBBEGsiBiQAIAG9IgVC/////////weDIQIgAAJ+IAVCNIhC/w+DIgNCAFIEQCADQv8PUgRAIAJCBIghBCADQoD4AHwhAyACQjyGDAILIAJCBIghBEL//wEhAyACQjyGDAELIAJQBEBCACEDQgAMAQsgBiACQgAgAnmnIgdBMWoQMiAGKQMIQoCAgICAgMAAhSEEQYz4ACAHa60hAyAGKQMACzcDACAAIAVCgICAgICAgICAf4MgA0IwhoQgBIQ3AwggBkEQaiQAC2YCAX8BfiMAQRBrIgIkACAAAn4gAUUEQEIADAELIAIgAa1CAEHwACABZyIBQR9zaxAyIAIpAwhCgICAgICAwACFQZ6AASABa61CMIZ8IQMgAikDAAs3AwAgACADNwMIIAJBEGokAAupAQECfwJ/AkAgASAAKAIUSw0AIAAoAgQiAkUNACAAKAIYIAFBAnRqIgMgAygCAEEBajYCACAAIAAoAhxBAWo2AhwgACAAKAIgIAFqNgIgIAAgACgCLCABajYCLCAAIAIoAgA2AgRBfyEBQQgMAQsgARAqIgJFBEAQTwsgACAAKAIkQQFqNgIkIAAgACgCKCABajYCKEEsCyAAaiIAIAAoAgAgAWo2AgAgAgt3AQN/QdD7MygCABAmIQFBASEAQdzvMygCABpB2O8zKAIAIQBBmPAzKAIAIQJB+o8qQfqPKhAnQQFBkO8zECNBOkGQ7zMQH0EgQZDvMxAfIAEgARAnQQFBkO8zECNBCkGQ7zMQH0GY8DMgAjYCAEHY7zMgADYCAAuIAQECfyMAQRBrIgIkAAJAIAFFDQAgAiABNgIMAkAgACgCACIDIAIoAgxLDQAgAigCDCADIAAoAhBqTw0AIAEgACgCBDYCACAAIAE2AgQgACAAKAIIQQFqNgIIIAAoAhQiAEEESQ0BIABBfHEiAEUNASABQQAgAPwLAAwBCyABECsLIAJBEGokAAvVBAEDfyMAQRBrIgQkAAJAIAFFBEACfwJAIAIgACgCFEsNACAAKAIEIgNFDQAgACgCGCACQQJ0aiIBIAEoAgBBAWo2AgAgACAAKAIcQQFqNgIcIAAgACgCICACajYCICAAIAAoAiwgAmo2AiwgACADKAIANgIEQX8hAkEIDAELIAIQKiIDRQRAEE8LIAAgACgCJEEBajYCJCAAIAAoAiggAmo2AihBLAsgAGoiACAAKAIAIAJqNgIADAELIAJFBEAgBCABNgIIAkAgACgCACICIAQoAghLDQAgBCgCCCACIAAoAhBqTw0AIAEgACgCBDYCACAAIAE2AgQgACAAKAIIQQFqNgIIIAAoAhQiAEEESQ0CIABBfHEiAEUNAiABQQAgAPwLAAwCCyABECsMAQsgBCABNgIMAkAgACgCACIDIAQoAgxLDQAgBCgCDCADIAAoAhBqTw0AIAAoAhQiBSACTwRAIAAoAhggAkECdGoiAyADKAIAQQFqNgIAIAAgACgCHEEBajYCHCAAIAAoAiAgAmo2AiAgACAAKAIsIAJqNgIsIAEhAwwCCyACECohAyAFBEAgAyABIAX8CgAACwJAIAVBA00EQCABIAAoAgQ2AgAgACABNgIEIAAgACgCCEEBajYCCAwBCyABIAAoAgQ2AgAgACABNgIEIAAgACgCCEEBajYCCCAFQXxxIgVFDQAgAUEAIAX8CwALIAAgACgCJEEBajYCJCAAIAAoAiggAmo2AiggACAAKAIsIAJqNgIsDAELIAEgAhAsIQMLIARBEGokACADC4ABAQR/IwBBEGsiASQAIAAoAgwiBEEIayECAkACQAJAIARBBGstAABBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCDEEIayECCyACKAIAQRBqIQMLIAEgAzYCAEHMkSwgARBVQZDvMxBWGiABQRBqJABBAAuwAQECfyMAQdAAayICJAACQCABLQAEQQNGBEAgAiABKAIANgIAIAJBIGpBLEHXwysgAhCmBCEDDAELIAIgASoCALs5AxAgAkEgakEsQYD0KiACQRBqEKYEIQMgAkEgakH75CsQ1gYgAkEgamotAAANACACQSBqIANqQa7gADsAACADQQJqIQMLIAEgACACQSBqIAMQgAYiAzYCACABIAMtAARBwAByOgAEIAJB0ABqJAAL+RIBCH8gACgCECICLQA+BEAgAkGv8P//ByACKAIMIAIoAghqIgAgAEGv8P//B0wbQf////8HayIBNgIMIAIgACABazYCCA8LIAIoAhQhBAJAAkACQAJAAkAgAi0AOkEBRwRAIARFDQQgAi0AOQ0BDAILIARFDQIgAi0AOEEYcSEDIAIoAkQiAQRAA0AgASABLQAFQcABcSADcjoABSABKAIAIgENAAsLIAJBADYCdCACQgA3AmwgAigCTCIBBEADQCABIAEtAAVBwAFxIANyOgAFIAEoAgAiAQ0ACwsgAigCZCIBBEADQCABIAEtAAVBwAFxIANyOgAFIAEoAgAiAQ0ACwsgAkEANgKEASACQgA3AnwgAkEIOwA5IAJBADYCFAsDQCAAEMQGGiACLQA5DQALCyAAEMUGIgggBEEDdiAEakkEQCAAIAIQxgYgAkEAIAItADwgAigCDCACKAIIaiIAQeQAbmxrIgEgAEH/////B2siAyABIANKGyIBNgIMIAIgACABazYCCA8LIAIgAigCDCACKAIIajYCECAAKAIQIgdBAzoAOSAHQcQAaiIGIQECQANAIAAoAhAhBCABKAIAIgNFBEBBACEBDAILAkAgAy0ABSIFIAQtADgiBEEYc3EEQCABIAMoAgA2AgAgACADEMMGDAELIAMgBUHAAXEgBEEYcXI6AAUgAyEBCyABQQAgASgCABsiASAGRg0ACyAAKAIQIQQLIAcgATYCSCAELQA5QQhHBEADQCAAEMQGGiAELQA5QQhHDQALCyACIAg2AhQgAiACKAIMIAIoAghqIgBB/////wcgAigCEEHkAG4iASACLQBAQQJ0IgNsIANB/////wcgAW5PG2siAUEfdSABcSIBIABB/////wdrIgMgASADShsiATYCDCACIAAgAWs2AggPCyACKAIQIghB5ABuIQECQCACKAIMIgNBAEwNACACKAIIIANqIAItAD0gAWxBAnQiBCAIak0NACACLQA4QRhxIQMgAigCRCIBBEADQCABIAEtAAVBwAFxIANyOgAFIAEoAgAiAQ0ACwsgAkEANgJ0IAJCADcCbCACKAJMIgEEQANAIAEgAS0ABUHAAXEgA3I6AAUgASgCACIBDQALCyACKAJkIgEEQANAIAEgAS0ABUHAAXEgA3I6AAUgASgCACIBDQALCyACQQA2AoQBIAJCADcCfCACQQg7ADkgAkEANgIUIAAgAhCUBiEBIAIoAgwgAigCCGoiACAEQQF2IAhqSQ0CIAIgATYCFCACIABB/////wcgAigCEEHkAG4iASACLQBAQQJ0IgNsIANB/////wcgAW5PG2siAUEfdSABcSIBIABB/////wdrIgMgASADShsiATYCDCACIAAgAWs2AggPCyACKAJ4IgEEQCACKAJ0IgQgAUcEQANAAkAgAS0ABSIDQQdxQQNHDQAgASADQQdzOgAFIANBIHFFDQAgAiABEI4GCyABKAIAIgEgBEcNAAsLIAJBADYCeAsgAigCTCIBIAIoAoQBIgRHBEADQAJAIAEtAAUiA0EHcUEDRw0AIAEgA0EHczoABSADQSBxRQ0AIAIgARCOBgsgASgCACIBIARHDQALCyACKAJkIgEEQANAAkAgAS0ABSIDQQdxQQNHDQAgASADQQdzOgAFIANBIHFFDQAgAiABEI4GCyABKAIAIgENAAsLIAAQxQYaIAJBAzoAOSACQcQAaiEDIAIoAkQiASACKAJsIgVHBEAgAi0AOEEYcUEBciEGA0ACQCABLQAFIgRBGHEEQCADIAEoAgA2AgAgACABEMMGDAELAkAgBEEHcSIDRQRAIAEgBEHAAXEgBnI6AAUMAQsgASADQeCqL2otAAAgBEHgAXFyOgAFIANBAksNACACKAJ4DQAgAiABNgJ4CyABIQMLIAMoAgAiASAFRw0ACwsgAigCcCIGIAFHBEAgAi0AOEEYcUEBciEHIAMhBANAAkAgAS0ABSIFQRhxBEAgBCABKAIANgIAIAAgARDDBgwBCwJAIAVBB3EiBEUEQCABIAVBwAFxIAdyOgAFDAELIAEgBEHgqi9qLQAAIAVB4AFxcjoABSAEQQJLDQAgAigCeA0AIAIgATYCeAsgASEECyAEKAIAIgEgBkcNAAsgAigCcCEGCyACQcwAaiEEIAIgBjYCdCACIAMoAgA2AnAgAiACKAJENgJsIAIoAkwiASACKAJ8IgVHBEAgAi0AOEEYcUEBciEGA0ACQCABLQAFIgNBGHEEQCAEIAEoAgA2AgAgACABEMMGDAELAkAgA0EHcSIERQRAIAEgA0HAAXEgBnI6AAUMAQsgASAEQeCqL2otAAAgA0HgAXFyOgAFCyABIQQLIAQoAgAiASAFRw0ACwsgAiACKAKAASIGIAFHBH8gAi0AOEEYcUEBciEHIAQhAwNAAkAgAS0ABSIFQRhxBEAgAyABKAIANgIAIAAgARDDBgwBCwJAIAVBB3EiA0UEQCABIAVBwAFxIAdyOgAFDAELIAEgA0Hgqi9qLQAAIAVB4AFxcjoABQsgASEDCyADKAIAIgEgBkcNAAsgAigCgAEFIAYLNgKEASACIAQoAgA2AoABIAIgAigCTDYCfCACKAJkIgEEQCACQeQAaiEDIAItADhBGHFBAXIhBQNAAkAgAS0ABSIEQRhxBEAgAyABKAIANgIAIAAgARDDBgwBCwJAIARBB3EiA0UEQCABIARBwAFxIAVyOgAFDAELIAEgA0Hgqi9qLQAAIARB4AFxcjoABQsgASEDCyADKAIAIgENAAsLIAAgAhDNBiACIAg2AhAgAkEAIAItADwgAigCDCACKAIIaiIAQeQAbmxrIgEgAEH/////B2siAyABIANKGyIBNgIMIAIgACABazYCCA8LIAItAEFBAnRBAXIiBiACKAIMQQN2bCEBQQBB/////wdBASACLQBCIgN0QQN2IAZsIANBH08bayEFIAICfwJAAkADQAJAIAAQxAYhAyACLQA5IQQgASADayIBIAVMDQAgBEH/AXFBCEcNAQwCCwsgBEH/AXFBCEcNAQsgAigCDCACKAIIaiIAQf////8HIAIoAhBB5ABuIgEgAi0AQEECdCIDbCADQf////8HIAFuTxtrIgFBH3UgAXEMAQsgAigCDCACKAIIaiEAIAEgBm1BA3QLIgEgAEH/////B2siAyABIANKGyIBNgIMIAIgACABazYCCAsLKwEBfyMAQRBrIgIkACACIAE2AgxBkO8zIAAgAUEAQQAQ6wwaIAJBEGokAAvzAQEDfwJAIABFBEBByPIzKAIABEBByPIzKAIAEFYhAQtBoPAzKAIABEBBoPAzKAIAEFYgAXIhAQtBxJc0KAIAIgBFDQEDQCAAKAJMGiAAKAIUIAAoAhxHBEAgABBWIAFyIQELIAAoAjgiAA0ACwwBCyAAKAJMQQBIIQICQAJAIAAoAhQgACgCHEYNACAAQQBBACAAKAIkEQQAGiAAKAIUDQBBfyEBIAJFDQEMAgsgACgCBCIBIAAoAggiA0cEQCAAIAEgA2usQQEgACgCKBEcABoLQQAhASAAQQA2AhwgAEIANwMQIABCADcCBCACDQELCyABC9gLAQR/IwBB4ABrIgIkACAAQYnyKxBYIAAgACgCECgCJCgCDEEIakGH3ysQWSACQYnyKzYCUCAAQdSJKiACQdAAahBaIABBq+orEFggACAAKAIQKAIkKAIMQQhqQc3bKxBZIAJBq+orNgJAIABB6IkqIAJBQGsQWiAAQY6UKhBYIAAgACgCECgCJCgCDEEIakHP4CsQWSACQY6UKjYCMCAAQf6JKiACQTBqEFsgAEGs3ysQWCAAIAAoAhAoAiQoAgxBCGpByuArEFkgAkGs3ys2AiAgAEGPiiogAkEgahBbIABBrfopEFggACAAKAIQKAIkKAIMQQhqQardKxBZIAJBrfopNgIQIABB7IsqIAJBEGoQWyAAQdbgK0EBEF0gACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIABB/I4rQQIQXSAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAEHslytBAxBdIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCAAQdmqKkEEEF0gACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIABBqvopQQUQXSAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAEH47SpBBhBdIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCAAQYHhKkEHEF0gACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIABBg+YrQQgQXSAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAEHl5ypBCRBdIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCAAQdbgKxBnIABB4OcsQQAQaCAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAEHZqioQZyAAQaDoLEEAEGggACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIABB1uArEGcgAEGw6CxBABBoIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCAAQdbgKxBnIABBoP8sQQAQaCAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgACgCECgCBCIEQewAaiEBA0AgASAEKAIkEGk6AAAgAUEBaiEBIANBAWoiA0GAAkcNAAsgAEHW4CsQZyAAQcCYLEEAEGggACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIABB3bMqQQAQWwJAQZDMMygCACIBBEBBkMwzIQMDQCABQYjeKRBqRQ0CIAMoAgwhASADQQxqIQMgAQ0ACwsgAkEANgIAIABBAiACEGsaIABBj9MpQQAQbAALAkAgACADEG1FBEAgAEG6uytBABBuQQIhAQwBCwJAQZCWNCgCACIBKAKAA0EBRw0AIAJBGzYCXCACQcKCLDYCWCAAQQogAkHYAGpBwoIsQQAQcA0AIABBAEEAQQBBABBxGgsgASgC9AJBAUYEQCACQRc2AlwgAkHjhSw2AlggAEEKIAJB2ABqQeOFLEEAEHBFBEAgAEEAQQBBAEEAEHEaCyACQR42AlwgAkGIhCs2AlggAEEKIAJB2ABqQYiEK0EAEHBFBEAgAEEAQQBBAEEAEHEaCyACQRg2AlwgAkHvgys2AlhBACEBIABBCiACQdgAakHvgytBABBwRQRAIABBAEEAQQBBABBxGgsgAkEbNgJcIAJBwoIsNgJYIABBCiACQdgAakHCgixBABBwDQEgAEEAQQBBAEEAEHEaDAELIAJBFjYCXCACQfuFLDYCWEEAIQEgAEEKIAJB2ABqQfuFLEEAEHANACAAQQBBAEEAQQAQcRoLIAJB4ABqJAAgAQuxAQEDfwJ/IAFFBEAgACgCDCEBQQAMAQsCQCABIAAoAhAgAUE1cEEDdGoiAigCoAIiA0EQahCtAUUEQCADIQIMAQsgASACQaACaiIEKAIEIgJBEGoQrQFFDQAgBCADNgIEIAQgACABIAEQJxCABiICNgIACyAAKAIMIgEgAjYCACACLQAEQcAAcgshAiABIAI6AAQgACAAKAIMQQhqNgIMIAAoAhAoAgxBAEoEQCAAEFQLC84DAQR/IwBBEGsiBSQAAkAgAiAAKAIQIAJBNXBBA3RqIgQoAqACIgNBEGoQrQFFBEAgAyEEDAELIAIgBEGgAmoiBigCBCIEQRBqEK0BRQ0AIAYgAzYCBCAGIAAgAiACECcQgAYiBDYCAAtBACECAkACQCABLQAEQcUARw0AIAEoAgAhAgJAIAQtAAQiA0EERgRAIAIoAhAgBCgCCEF/IAItAAd0QX9zcUEEdGohAgNAIAItAAVBxABGBEAgAigCDCAERg0DCyACIAIoAggiA0EEdGohAiADDQALQdSxLyECDAELIAUgBDYCCCAFIANBwAByOgAMIAIgBUEIakEAEIUGIQILIAItAARBD3FFDQAgAiAAKAIMIgNBCGsoAgA2AgAgAiADQQRrLQAAOgAEAkAgACgCDCICQQRrLQAAQcAAcUUNACABKAIAIgMtAAVBIHFFDQAgAkEIaygCAC0ABUEYcUUNACAAIAMQiQYgACgCDCECCyAAIAJBCGs2AgwMAQsgACgCDCIDIAQ2AgAgAyAELQAEQcAAcjoABCAAIAAoAgwiA0EIajYCDCAAIAEgAyADQQhrIAIQigYgACAAKAIMQRBrNgIMCyAFQRBqJAALhgEBAn8jAEEQayIDJAAgAyACNgIMAkAgAARAIAAoAhAoAgQiAgRAIAIoAvgCQQJIDQILIABBgAIQmAEiAigCCCIEIAIoAgRBBWsgASADKAIMEJMBGiACIAQQJzYCACAAQQMgAhCZASACEJoBDAELIAMgAygCDDYCACABIAMQdQsgA0EQaiQAC4YBAQJ/IwBBEGsiAyQAIAMgAjYCDAJAIAAEQCAAKAIQKAIEIgIEQCACKAL4AkEDSA0CCyAAQYACEJgBIgIoAggiBCACKAIEQQVrIAEgAygCDBCTARogAiAEECc2AgAgAEECIAIQmQEgAhCaAQwBCyADIAMoAgw2AgAgASADEHULIANBEGokAAuHAgEDfwJAIAAoAhAoAiQiASgCCEEBTQRAIAEoAhBBfyABLQAHdEF/c0GKqazRAHFBBHRqIQEDQCABLQAFQQNGBEAgASgCDEECRg0DCyABIAEoAggiAkEEdGohASACDQALQdSxLyEBDAELIAEoAgxBCGohAQsgACgCDCICIAEtAARBD3EEfyACIAEoAgA2AgAgAS0ABAUgAws6AAQgACAAKAIMQQhqNgIMIABBgLYvQQAQaCAAKAIMIgEgAUEIaygCADYCACABIAFBBGstAAA6AAQgACAAKAIMIgFBCGo2AgwgACABQQhrQdbgKxBZIABBqOwrEFggACAAKAIMQRBrQYbfKxBZQQEL8AMBA38gAEHY4c59QdfiKxCQAUEFRwRAIAAgACgCDEEIayIDIAAoAiRNBH8gACADQX9BABBeBSADCzYCDCAAQQBBABChASAAKAIMIgMgA0EIaygCADYCACADIANBBGstAAA6AAQgACAAKAIMQQhqNgIMIAAgACgCEEEkakHX4isQWQsgAEF/IAEQkAEaIAAoAgwiBEEEay0AACIDQQFHQQAgA0EPcRtFBEAgBEEIayIDIAAoAiRNBEAgACADQX9BABBeIQMLIAAgAzYCDCADQRY6AAQgAyACNgIAIAAgACgCDEEIajYCDCAAIAEQWCAAIAAoAgxBEGtBARCRBiAAKAIMIgMgA0EIaygCADYCACADIANBBGstAAA6AAQgACAAKAIMIgNBCGo2AgwgACADQRBrIAEQWSAAKAIMIQQLIARBEGshAyAEQQhrIQQDQCADKAIAIQIgAyAEKAIANgIAIAMtAAQhBSADIAQtAAQ6AAQgBCAFOgAEIAQgAjYCACADQQhqIgMgBEEIayIESQ0ACyAAKAIMQQhrIgMgACgCJE0EQCAAIANBf0EAEF4hAwsgACADNgIMIAMgA0EIaygCADYCACADIANBBGstAAA6AAQgACAAKAIMQQhqNgIMIAAgACgCECgCJCgCDEEIaiABEFkLpAYBB38gACgCHCEJAkAgACgCICIERQ0AIABBEGohBwNAIAQoAgggAUkNASAEKAIQIAQoAgwiBjYCACAGBEAgBiAEKAIQNgIQCyAEIAQoAggiBigCACIINgIMIAQgBi0ABCIFOgAQIAQgBEEMajYCCAJAIAQtAAUiBkEYcQ0AIAQgBkEgcjoABSAFQcAAcUUNACAILQAFQRhxRQ0AIAcoAgAiBS0AOUECTQRAIAUgCBCOBiAELQAFQQZxRQ0BIAggCC0ABUH4AXFBAnI6AAUMAQsgBS0AOg0AIAQgBS0AOEEYcSAGQccBcXI6AAULIAAoAiAiBA0ACwsgASAAKAIkIgVNBEAgASAJayEJIAAoAhwhBiACQX9HIQoDQAJAIAUgBS8BBkEDdGsiBCAGTQ0AA0AgBC8BBg0BIARB+P8fayIEIAZLDQALCyAAIAQ2AiQCQCAKRQRAIAAoAhBBLGohByAAKAIMIQEMAQsgBUEIaiEHQQAhBAJAAkACQAJAIAIOBgMCAgIAAQILIAcgACgCECgClAEiBDYCACAELQAEQcAAciEEDAILIAcgAEHF7ipBFxCABiIENgIAIAQtAARBwAByIQQMAQsgByAAKAIMIgRBCGsoAgA2AgAgBEEEay0AACEECyAFIAQ6AAwgACAFQRBqIgE2AgwLIAAoAhAhBgJAAn8CQAJAAkAgBS0ABEEPcSIEQQVrDgMAAgECCyAFKAIAQRhqDAILIAUoAgBBDGoMAQsgACgCECAEQQJ0akH8AWoLKAIAIgQEQCAEKAIQIAYoAvgBIggoAghBfyAELQAHdEF/c3FBBHRqIQQDQCAELQAFQcQARgRAIAQoAgwgCEYNAwsgBCAEKAIIIgZBBHRqIQQgBg0AC0HUsS8hBAwBCyAGQSxqIQQLIAEgBCgCADYCACABIAQtAAQ6AAQgASAFKAIANgIIIAEgBS0ABDoADCABIAcoAgA2AhAgASAHLQAEOgAUIAAgAUEYajYCDAJAIAMEQCAAIAFBABCQBgwBCyAAIAFBABCRBgsgACgCJCIFIAAoAhwiBiAJaiIBTw0ACwsgAQsXACAAQQBBCBChASAAQaC4L0EAEGhBAQsXACAAQQBBBxChASAAQdC/L0EAEGhBAQuNAQEBfyAAQQBBABChASAAQdyYLEEAEGggAEH+9SsQpAEaIAAoAgwiASABQQhrKAIANgIAIAEgAUEEay0AADoABCAAIAAoAgwiAUEIajYCDCAAIAFBCGtBlbwpEFkgAEHkmCxBABBoIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDEEBCxcAIABBAEEGEKEBIABB8LwvQQAQaEEBC+gBAQF/IABBAEEREKEBIABB8L0vQQAQaCAAQQBBCRChASAAQYC/L0EAEGggAEG3kywQWCAAKAIMIgEgAUEQaygCADYCACABIAFBDGstAAA6AAQgACAAKAIMQQhqNgIMIABBfhDbASAAKAIMQQhrIgEgACgCJE0EQCAAIAFBf0EAEF4hAQsgACABNgIMIAEgAUEQaygCADYCACABIAFBDGstAAA6AAQgACAAKAIMIgFBCGo2AgwgACABQQhrQZW8KRBZIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDEEBC8wGAgF/B34gAEEAQSMQoQEgAEGwui9BABBoIAAoAgwiAUETOgAEIAFB25+kggQ2AgAgACAAKAIMIgFBCGo2AgwgACABQQhrQYnbKhBZIAAoAgwiAUETOgAEIAFBgICA/Ac2AgAgACAAKAIMIgFBCGo2AgwgACABQQhrQaKZKxBZIAAoAgwiAUEDOgAEIAFB/////wc2AgAgACAAKAIMIgFBCGo2AgwgACABQQhrQbqXKhBZIAAoAgwiAUEDOgAEIAFBgICAgHg2AgAgACAAKAIMIgFBCGo2AgwgACABQQhrQd2XKhBZIABBIEEAENoBIgEgAK0iBRB5IghC/////w+DhSIEQv+BgICAgPgPhUItiSAFQv+B+A+FIgIgBEL/AYUiA4UiBIUiBkItiSACIANCEYaFIAVCgICAgICA+A+EIgKFIgMgBIUiBYUiB0ItiSACIAaFIgIgAyAEQhGGhYUiAyAFhSIEhSIGQi2JIAIgB4UiAiADIAVCEYaFhSIDIASFIgWFIgdCLYkgAiAGhSICIAMgBEIRhoWFIgMgBYUiBIUiBkItiSACIAeFIgIgAyAFQhGGhYUiAyAEhSIFhSIHQi2JIAIgBoUiAiADIARCEYaFhSIDIAWFIgSFIgZCLYkgAiAHhSICIAMgBUIRhoWFIgMgBIUiBYUiB0ItiSACIAaFIgIgAyAEQhGGhYUiAyAFhSIEhSIGQi2JIAIgB4UiAiADIAVCEYaFhSIDIASFIgWFIgdCLYkgAiAGhSICIAMgBEIRhoWFIgMgBYUiBIUiBkItiSACIAeFIgIgAyAFQhGGhYUiAyAEhSIFhSIHQi2JIAIgBoUiAiADIARCEYaFhSIDIAWFIgSFIgZCLYkgAiAHhSICIAMgBUIRhoWFIgMgBIUiBYUiB0ItiTcDGCABIAMgBEIRhoUgAiAGhSIEhSICIAVCEYaFNwMQIAEgAiAFhTcDCCABIAQgB4U3AwAgACgCDCIBQQM6AAQgASAIPgIAIAAgACgCDCIBQQhqNgIMIAFBAzoADCABIAA2AgggACAAKAIMIgFBCGo2AgwgACABQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIABB0LwvQQEQaEEBC3QBAn8gAEEAQQYQoQEgAEGQwC9BABBoIABByMAvQQ4QgAYhASAAKAIMIgIgATYCACACIAEtAARBwAByOgAEIAAgACgCDEEIaiIBNgIMIAAgACgCECgCDEEASgR/IAAQVCAAKAIMBSABC0EQa0GNrCoQWUEBCxcAIABBAEEREKEBIABBgLkvQQAQaEEBC4gDAQV/IwBBEGsiBSQAIAAoAhAiAygCJCgCDCECAkAgASADIAFBNXBBA3RqIgMoAqACIgRBEGoQrQFFBEAgBCEDDAELIAEgA0GgAmoiBigCBCIDQRBqEK0BRQ0AIAYgBDYCBCAGIAAgASABECcQgAYiAzYCAAsgAkEIaiEEQQAhAQJAAkAgAi0ADEHFAEcNACAEKAIAIQECQCADLQAEIgJBBEYEQCABKAIQIAMoAghBfyABLQAHdEF/c3FBBHRqIQEDQCABLQAFQcQARgRAIAEoAgwgA0YNAwsgASABKAIIIgJBBHRqIQEgAg0AC0HUsS8hAQwBCyAFIAM2AgggBSACQcAAcjoADCABIAVBCGpBABCFBiEBCyABLQAEQQ9xRQ0AIAAoAgwiAiABKAIANgIAIAIgAS0ABDoABCAAIAAoAgxBCGo2AgwMAQsgACgCDCICIAM2AgAgAiADLQAEQcAAcjoABCAAIAAoAgwiAkEIajYCDCAAIAQgAiACIAEQhgYLIAVBEGokAAuFAwEFfyMAQRBrIgYkACAAKAIUIQUCQCACIAAoAhgiBCAAKAIMIgNrQQN1TgR/IAQgACgCHCIHayIEQYC0iRNKDQEgAyAHa0EDdSACaiIDQcGWsQJOBEAgAEGImLECQQAQqwYaDAILIABBwJaxAiAEQQJ1IgQgBEHAlrECThsiBCADIAMgBEgbQQAQqwZFDQEgACgCDAUgAwsgAkEDdGoiAyAFKAIESwRAIAUgAzYCBAsgASgCAARAQX4gAmtBA3QhBUEAIAJrQQN0IQcDQAJAIAEoAgQiAwRAIAAgAgR/IAAoAgwiAyADIAdqIgQoAgA2AgAgAyAELQAEOgAEIAAgACgCDEEIajYCDCABKAIEBSADCyACEIIGIAAoAgwhAwwBCyAAKAIMQQE6AAQgACAAKAIMQQhqIgM2AgwLIAAgAyAFaiABKAIAEFkgASgCCCEDIAFBCGohASADDQALCyAAIAJBf3MQqwEgBkEQaiQADwsgBkGY/ik2AgAgAEHe+CsgBhClAQALuQMBC38jAEHwAmsiASQAIAAgACgCXCICQQFqNgJcIAIgAEHgAGoiB2otAAAhCCACQR9OBEAgAUEsaiIJQQBBgAL8CwAgAUEgNgLsAiABQquzj/yRo7Pw2wA3AiQgAUL/pLmIxZHagpt/NwIcIAFC8ua746On/aelfzcCFCABQufMp9DW0Ouzu383AgwgAUIANwIEA0AgACAAKAJUIgJBAWoiAzYCVCACQRNMBH8gACADQQJ0agVBACECIABBADYCVEEPIQMDQCAAIANBACADQRVHGyIKQQJ0aigCACIDIAAoAlggACACQQJ0aiILKAIAaiIFayEEIAMgBUkiBUUgAyAETXFFBEAgACAFNgJYCyALIAQ2AgAgCkEBaiEDIAJBAWoiAkEVRw0ACyAACyECIAkgASgCBCIDQQN2QTxxaiIEIAItAAAgBCgCAEEIdHI2AgAgASADQQhqIgI2AgQCQAJAIAJFBEAgAUEANgIEIAEgASgCCEEBajYCCAwBCyACQf8DcQ0BCyABQQRqEPcBCyAGQQFqIgZBgAFHDQALIAFBBGogBxD4ASAAQQA2AlwLIAFB8AJqJAAgCAtoAQN/AkAgAC0AACICRQ0AA0AgAS0AACIEBEACQCACIARGDQAgAhDTASAEENMBRg0AIAIhAwwDCyABQQFqIQEgAC0AASECIABBAWohACACDQEMAgsLIAIhAwsgAxDTASABLQAAENMBawuWBwEEfyMAQRBrIgUkAEF/IQQCQCAAKAIQIgMtAD5BAnENACAFIAI2AgwCQAJAAkACQAJAAkACQAJAAkACQAJAAkAgAQ4MAAECAwQFBgcMCAkKDAsgA0EBOgA+QQAhBAwLC0EAIQQgA0EAOgA+IAMoAgwhACADQQA2AgwgAyAAIAMoAghqNgIIDAoLQQAhBCAAQQAQkwYMCQsgAygCDCADKAIIakEKdiEEDAgLIAMoAgwgAygCCGpB/wdxIQQMBwsgBSAFKAIMIgRBBGo2AgwgAy0APiECIAQoAgAhBCADQQA6AD4gBEUEQCADKAIMIQQgA0EANgIMIAMgBCADKAIIajYCCCAAEFQgAyACOgA+DAYLIAMgAygCDCIBIARBCnRqIgQgASADKAIIaiIBQf////8HayIGIAQgBkobIgY2AgwgAyABIAZrNgIIIAAoAhAoAgxBAEoEQCAAEFQLIAMgAjoAPiAEQQBKDQVBACEEDAYLIAUgBSgCDCIEQQRqNgIMIAMtAEAhACADIAQoAgBBBG06AEAgAEECdCEEDAULIAUgBSgCDCIEQQRqNgIMIAMtAEEhACADIAQoAgBBBG06AEEgAEECdCEEDAQLIAMtAD5FIQQMAwsgBSAFKAIMIgJBBGo2AgwgAigCACEBIAUgAkEIajYCDEEKIQQgAy0AOkEBRwRAQQpBCyADKAIUGyEECyACKAIEIQIgAQRAIAMgAToAPAsgAgRAIAMgAkEEbToAPQsgACgCECIDLQA6QQFHBEAgACADEJQGGgsgA0EANgIUDAILIAUgBSgCDCICQQRqNgIMIAIoAgQhASACKAIAIQYgBSACQQxqNgIMQQohBCADLQA6QQFHBEBBCkELIAMoAhQbIQQLIAIoAgghAiAGBEAgAyAGQQRtOgBACyABBEAgAyABQQRtOgBBCyACBEAgAyACOgBCCyAAKAIQIgItADoEQCACLQA4QRhxIQAgAigCRCIDBEADQCADIAMtAAVBwAFxIAByOgAFIAMoAgAiAw0ACwsgAkEANgJ0IAJCADcCbCACKAJMIgMEQANAIAMgAy0ABUHAAXEgAHI6AAUgAygCACIDDQALCyACKAJkIgMEQANAIAMgAy0ABUHAAXEgAHI6AAUgAygCACIDDQALCyACQQA2AoQBIAJCADcCfCACQQg7ADkLIAJBADYCFAwBCyADLQA5QQhGIQQLIAVBEGokACAEC2YBAX8jAEGgAmsiAyQAIAMgAjYCDCADIAI2AgggA0EQakGAAiABIAIQkwEgA0EQampBADoAACADIANBEGo2AgAgAEGRjCogAxBuIAAQlAEgACABIAMoAggQlQEgABCWASAAEJcBAAvNDgEKfyMAQfAIayIGJAACQAJAIAEoAggiAkUNACAAQQxqIggoAgAhAyAAKAIUKAIAIQUgBiACNgJgIABBm4UqIAZB4ABqEKYBGiAGIAJB/6IqEKcBIgQ2AmwgAyAFa0EIa0EDdSIHQQFqIQUCQAJAIARFBEBB0PszKAIAECYhAiAAIAVBABCIASEDIAYgAjYCKCAGQZm8KjYCICAGIANBAWo2AiQgAEHriCogBkEgahCmARogCCgCACIDQQhrIQIgAiAHQQBOBH8gACgCFCgCAAUgAwsgBUEDdGoiA0EIaiIFSwRAIAIhBANAIAUoAgAhByAFIAQoAgA2AgAgBS0ABCEIIAUgBC0ABDoABCAEIAg6AAQgBCAHNgIAIAVBCGoiBSAEQQhrIgRJDQALCyACIANLBEADQCADKAIAIQUgAyACKAIANgIAIAMtAAQhBCADIAItAAQ6AAQgAiAEOgAEIAIgBTYCACADQQhqIgMgAkEIayICSQ0ACwsgACgCDEEIayICIAAoAiRLDQEgACACQX9BABBeIQIMAQsgBkHoAGogBkHkAGoQqAEEQCAGIAYoAmgiA0EBajYCaCADIAZqQQo6AHALIAYoAmQiA0EbRgRAIAYCfyAGKAJsIQRBosorENYMIQkgBCgCTEEASCEDIAQQVhoCQCACQaLKKxCnASICBEACQAJAIAIoAjwiCCAEKAI8IgpGBEAgAkF/NgI8DAELIAlBgIAgcSEJA0AgCCAKIAkQDCILQXZGDQALIAsQ1wxBAEgNAQsgBCACKAIAIAQoAgBBAXFyNgIAIAQgAigCIDYCICAEIAIoAiQ2AiQgBCACKAIoNgIoIAQgAigCDDYCDCACEKoBIARBADYCiAEgBEEANgJIIAMNAiAEDAMLIAIQqgELIAQQqgFBACEECyAECyICNgJsIAJFBEBB0PszKAIAECYhAiAAIAVBABCIASEDIAYgAjYCOCAGQZe8KjYCMCAGIANBAWo2AjQgAEHriCogBkEwahCmARogACgCDCIDQQhrIQIgAiAHQQBOBH8gACgCFCgCAAUgAwsgBUEDdGoiA0EIaiIFSwRAIAIhBANAIAUoAgAhByAFIAQoAgA2AgAgBS0ABCEIIAUgBC0ABDoABCAEIAg6AAQgBCAHNgIAIAVBCGoiBSAEQQhrIgRJDQALCyACIANLBEADQCADKAIAIQUgAyACKAIANgIAIAMtAAQhBCADIAItAAQ6AAQgAiAEOgAEIAIgBTYCACADQQhqIgMgAkEIayICSQ0ACwsgACgCDEEIayICIAAoAiRLDQIgACACQX9BABBeIQIMAgsgBkHoAGogBkHkAGoQqAEaIAYoAmQhAwsgA0F/RwRAIAYgBigCaCICQQFqNgJoIAIgBmogAzoAcAsgACgCDCIEQQhrIQNBACECAkACQAJAIARBBGstAABBD3FBA2sOAgABAgsgACADEFMgACgCECgCDEEASgRAIAAQVAsgACgCDEEIayEDCyADKAIAQRBqIQILIABBCyAGQegAaiACQQAQcCEKAn8gBigCbCICKAJMQQBIBEAgAigCAAwBCyACKAIACyEEIAIQqgEgBEEFdkEBcUUNASAAIAUQqwFB0PszKAIAECYhAiAAIAVBABCIASEDIAYgAjYCWCAGQZLBKzYCUCAGIANBAWo2AlQgAEHriCogBkHQAGoQpgEaIAAoAgwiA0EIayECIAIgB0EATgR/IAAoAhQoAgAFIAMLIAVBA3RqIgNBCGoiBUsEQCACIQQDQCAFKAIAIQcgBSAEKAIANgIAIAUtAAQhCCAFIAQtAAQ6AAQgBCAIOgAEIAQgBzYCACAFQQhqIgUgBEEIayIESQ0ACwsgAiADSwRAA0AgAygCACEFIAMgAigCADYCACADLQAEIQQgAyACLQAEOgAEIAIgBDoABCACIAU2AgAgA0EIaiIDIAJBCGsiAkkNAAsLIAAoAgxBCGsiAiAAKAIkSw0AIAAgAkF/QQAQXiECCyAAIAI2AgwMAQsgACgCDCIDQQhrIQIgAiAHQQBOBH8gACgCFCgCAAUgAwsgBUEDdGoiA0EIaiIFSwRAIAIhBANAIAUoAgAhByAFIAQoAgA2AgAgBS0ABCEIIAUgBC0ABDoABCAEIAg6AAQgBCAHNgIAIAVBCGoiBSAEQQhrIgRJDQALCyACIANLBEADQCADKAIAIQUgAyACKAIANgIAIAMtAAQhBCADIAItAAQ6AAQgAiAEOgAEIAIgBTYCACADQQhqIgMgAkEIayICSQ0ACwsgAEEMaiIDKAIAQQhrIgIgACgCJE0EQCAAIAJBf0EAEF4hAgsgAyACNgIAIAoNACAAQQBBAEEAQQAQcUUNAQsgBiAAQX9BABCIATYCECAAQZGMKiAGQRBqEG4gBiABKAIANgIEIAZB2bYqNgIAIABB8YUqIAYQbAALIAYgASgCADYCQCAAQeqHKiAGQUBrEFsgBkHwCGokAEEBC24BAn8jAEEQayIDJAAgAyACNgIMAkAgAARAIABBgAIQmAEiAigCCCIEIAIoAgRBBWsgASADKAIMEJMBGiACIAQQJzYCACAAQQYgAhCZASACEJoBDAELIAMgAygCDDYCACABIAMQdQsgA0EQaiQACyMAIAEoAgQiAEUEQEEADwsgAiAANgIAIAFBADYCBCABKAIAC5IFAQR/IwBB0ABrIgUkACAFIAI2AgwgBSABNgIIIAUgADYCECAFQgA3AgAgACAAKAJgQYCABGo2AmAgBSADQeTjKyADGzYCTCAFIAQ2AkggBUEANgJEIAVCADcCOCAFQgA3AiwgBUIANwIgIAVBADYCGCAFIAU2AhQgAC0AByECIAAoAhQhBCAAKAJcIQMgACgCHCEGIAAoAgwhB0EAIQEgAEEMIAVBFGoQfSIIBEAgACACOgAHIAAgBDYCFCAAIAAgByAGayICIAgQgQEiASAAKAIcIAJqEIIBIAAQgwELIAAgAzYCXCAAQRBqIgMoAgAiAigCBCAFKAIYIAUoAiAiBEEAIAIoAgARAgAhBiACIAIoAgwgBGs2AgwgBUEANgIgIAUgBjYCGCADKAIAIgIoAgQgBSgCJCAFKAIsQQR0IgRBACACKAIAEQIAGiACIAIoAgwgBGs2AgwgAygCACICKAIEIAUoAjAgBSgCOEEEdCIEQQAgAigCABECABogAiACKAIMIARrNgIMIAMoAgAiAygCBCAFKAI8IAUoAkRBBHQiAkEAIAMoAgARAgAaIAMgAygCDCACazYCDCAAIAAoAmBBgIAEazYCYAJAIAENACAAKAIMQQhrKAIAIgMtAAZFDQAgAygCECgCCCIEIAAoAhAoAiQoAgwiAigCCDYCACAEIAItAAwiBjoABCAGQcAAcUUNACADKAIQIgMtAAUiBEEgcUUNACACKAIIIgItAAVBGHFFDQAgACgCECIALQA5QQJNBEAgACACEI4GIAMtAAVBBnFFDQEgAiACLQAFQfgBcUECcjoABQwBCyAALQA6DQAgAyAALQA4QRhxIARBxwFxcjoABQsgBUHQAGokACABC+ICAQR/IwBBEGsiBSQAIAIEfyAAKAIUKAIAIAJBA3RqIAAoAhxrBUEACyEGIAUgACgCDCABQX9zQQN0aiIBNgIIAkACQCAEBEAgACgCYEGAgARJDQELIAVBfzYCDCAAKAJcIQQgACAGNgJcIAAtAAchBiAAKAIUIQMgACgCHCEHQQAhAiAAQQ0gBUEIahB9IggEQCAAIAY6AAcgACADNgIUIAAgACABIAdrIgEgCBCBASICIAAoAhwgAWoQggEgABCDAQsgACAENgJcDAELIAAoAhQiAiADNgIYIAIgBDYCECACIAEgACgCHGs2AhwgAiAAKAJcNgIUIAAgBjYCXCACIAAtAAcgAi8BIkHu/wNxckEQcjsBIiAAIAFBfxCQBiACIAIvASJB7/8DcTsBIiAAIAIoAhQ2AlxBACECCyAAKAIUIgEoAgQgACgCDCIASQRAIAEgADYCBAsgBUEQaiQAIAILuCkCDH8BeyMAQbAHayIFJABBsAQQKiIGQgE3AoADIAb9DAAAAAAAAAAAAAAAAAAAAAD9CwIEIAZCAjcC+AIgBkEBNgKsBCAGQQA6AIgDIAZCADcC8AIgBkEANgIkIAZCwICAgIAgNwKkBCAGQQA6AJsEIAZBseDIoQM2AJcEIAZBADoAkAQgBkGx4MCBAzYCjAQgBiAP/QsCFCAGQZcEaiELIAZBjARqIQ0CQAJAAkAgAEUNACAAQYAEEHMiCEEDSA0BIAZBiANqIQwDQAJAIAAgA2osAAAiBBB0DQAgBEEgRg0AIARBDmtBeksNACAEQf8BcUEsayIEQRFLDQNBASAEdEGBgAlxRQ0DCyADQQFqIgMgCEcNAAsgACAIaiEIIAAhAwNAIAchCQJAAkAgAyAIRg0AA0ACQAJAAkACQAJAAkACQAJAAkACQCADLQAAIgRBCWsOdAkJAQkJAQEBAQEBAQEBAQEBAQEBAQEBCQgIAAEICAgBAQgIAQgBCAICAgICAgICAgIBAQgICAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEIAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEIAQsCQCADIAhGDQADQAJAIAMtAABBCmsOBAIAAAIACyADQQFqIgMgCEcNAAsgCCEDCyADIAhHDQkMCgsCQCAEwCIHQeEAa0H/AXFBGkkNACAHQQBIDQAgB0HBAGtB/wFxQRpJDQAgBEHfAEYNACAEQTpHDQcLQQAhBEEBIQoDQCAEIg4gBUGgA2pqIAc6AAAgAyAKIgRqLQAAIgrAIQcCQCAKQTBrQf8BcUEKSQ0AIApBX3FBwQBrQf8BcUEaSQ0AIAdBAEgNACAHQd8ARg0AIAdB/wFxQTpHDQMLIARBAWoiCkGABEcNAAsgBSAANgLUASAFQbiCKzYC0AFBu4osIAVB0AFqEHUMDQsgBSADNgKsByADIAVBrAdqEHYhBCAFKAKsByEDIAlBAWsOCAEEBAQEBAIDBAsgBUGgA2ogBGpBADoAAEEBIQcgAyAOakEBaiEDIAVBoANqQeXnKhBqRQ0JIAVBoANqQZyDKxBqRQ0JQQIhByAFQaADakGhjCsQakUNCUEDIQcgBUGgA2pBjL4rEGpFDQlBBCEHIAVBoANqQdTbKRBqRQ0JQQUhByAFQaADakG/lCoQakUNCUEGIQcgBUGgA2pBwcUqEGpFDQlBByEHIAVBoANqQY/CKhBqRQ0JQQghByAFQaADakGO9yoQakUNCQJAAkACQAJAAkACQCAJQQJrDgUCAAEDBAULIAVBoANqQbnkK0EEEHcEQEH+kSxBABB1DBELIAVBoANqECciBEEEayEHAkAgBEF+cUGEAUYEQEEEIQQgB0EESg0BDA8LIAVBwAA2AoQCIAUgB0ECbTYCgAJBnJEsIAVBgAJqEHUMEQsDQCAFQaADaiAEaiwAACIJEHgEQCAHIARBAWoiBEcNAQwPCwsgBSAJNgLwAUH2kCwgBUHwAWoQdQwQCyAFQaADahAnIgRBBEcEQCAFIAQ2AqACQYGTLCAFQaACahB1DBALIAVBoANqQe+sKkEEEHdFBEAgBkEBNgKAA0EEIQcMDgsgBUGgA2pBk8opQQQQd0UEQCAGQQA2AoADQQQhBwwOCyAFIAVBoANqNgKQAkGciywgBUGQAmoQdQwPCyAFQaADahAnIgRBBmtBfU0EQCAFIAQ2ArACQYyKLCAFQbACahB1DA8LIAVBoANqQcDIKkEEEHdFBEAgBkEANgL0AkECIQcMDQsgBUGgA2pB8rsqQQUQd0UEQCAGQQE2AvQCQQIhBwwNCyAFIAVBoANqNgLAAkG7iywgBUHAAmoQdQwOCyAFQaADahAnIgdBD2tBdU0EQCAFQQo2AtACQZHwKSAFQdACahB1DA4LQQQhBAJAIAVBoANqQevkK0EEEHdFBEAgB0EEayEKDAELQaqSLEEAEHUMDgsCQANAIAVBoANqIARqLAAAIglBMGtBCkkEQCAHIARBAWoiBEcNAQwCCwsgBSAJNgLgAkG7kCwgBUHgAmoQdQwOCyAKBEAgDSAFQaADakEEciAK/AoAAAsgCiANakEAOgAAQQUhBwwLCyAFQaADahAnIgdBD2tBdU0EQCAFQQo2AvACQcjwKSAFQfACahB1DA0LQQQhBAJAIAVBoANqQevkK0EEEHdFBEAgB0EEayEKDAELQdaSLEEAEHUMDQsCQANAIAVBoANqIARqLAAAIglBMGtBCkkEQCAHIARBAWoiBEcNAQwCCwsgBSAJNgKAA0HZkCwgBUGAA2oQdQwNCyAKBEAgCyAFQaADakEEciAK/AoAAAsgCiALakEAOgAAQQYhBwwKCyAFIAVBoANqNgLgAUGBiywgBUHgAWoQdQwLCyAGIAQ2AvgCQQEhBwwICyAGIAQ2AqQEQQchBwwHCyAGIAQ2AqgEQQghBwwGC0GejCxBABB1DAcLIANBAWohA0EAIQcgBEEsRg0EAkAgBEE9RyIHDQAgCQ0AQQAhB0G9jCxBABB1DAULIAdFBEAgCSIHDQULIAUgBDYClAMgBUG4gis2ApADQbyJLCAFQZADahB1DAYLIANBAWoiAyAIRw0ACwsgDC0AACIARQ0CIAZBATYC8AIgBiAP/QsCKCAGIA/9CwI4IAYgD/0LAkggBiAP/QsCWCAGQYkDaiEHIAZBKGohCUEAIQRBACEDA0AgAyAHaiwAACIIRQ0DIADAQQJ0QYDZLGooAgAiAEEASA0DIAhBAnRBgNksaigCACIIQQBIDQMgBCAJaiAAQQR0IAhyOgAAIARBAWohBCAMIANBAmoiA2otAAAiAA0ACwwCCyAHBEAgDCAFQaADakEEciAH/AoAAAsgByAMakEAOgAAQQMhBwwACwALAkBBpIg0KAIAIgMEQAJ/AkAgAygCFEGAAUkNACADKAIEIgdFDQAgAygCGCIEIAQoAoAEQQFqNgKABCADIAMoAhxBAWo2AhwgAyADKAIgQYABajYCICADIAMoAixBgAFqNgIsIAMgBygCADYCBEF/IQRBCAwBC0GAARAqIgdFBEAQTwsgAyADKAIkQQFqNgIkQYABIQQgAyADKAIoQYABajYCKEEsCyADaiIDIAMoAgAgBGo2AgAMAQtBgAEQKiEHCwJAIAdFBEBBvo4qQQAQdQwBCyAGKALwAkUEQCAFQTw2ArABIAVB6QA7AKADIAZBKGohAEEAIQNBpfYzIAVBoANqIAVBsAFqEAAhBANAIAAgA2ogAyAEai0AADoAACAAIANBAXIiCGogBCAIai0AADoAACAAIANBAnIiCGogBCAIai0AADoAACAAIANBA3IiCGogBCAIai0AADoAACADQQRqIgNBPEcNAAsgBBArIAYQeaciA0EYdCADQYD+A3FBCHRyIANBCHZBgP4DcSADQRh2cnI2AmQLIAUgBv0AAlj9CwTQAyAFIAb9AAJI/QsEwAMgBSAG/QACOP0LBLADIAUgBv0AAij9CwSgAyAHQcAAIAVBoANqEHoLIAYgBzYCJAJAAkBByAYQKiIDRQRAIAVByAY2AhBBAEGO4ysgBUEQahBuDAELIANBADYCXCADQQg6ALABIANBiBA7AQggA0EANgIYIANBADYCNCADQQA2AnAgA0IANwIgIANCADcCaCADQoCAgICAgMAANwJgIANBgAI2AQogA0EANgIEIANBDjYCeCADIAY2AnwgA0IANwLABiADIANB+ABqNgIUIAMgA0EEaiIENgIwIANBADYCdCADIAQ2ArwBIAMgBDYCiAIgBxBpIQAgBigCJBBpIQggBigCJBBpIQcgBigCJBBpIQkgA0EANgKYASADQQA2AoQCIANBADoAoAEgA0IANwKQASADQQI7AbYBIANBADoAswEgA0EIOwCxASADIAAgCEEIdHIgB0EQdHIgCUEYdHI2AqwBIANBwAFqQQBBxAD8CwAgA0ENOgC6ASADQbIyOwG4ASADQQM6AKgBIANBADYCpAEgA0EANgKMASADQsgGNwKAASADQZQyOwG0ASADIA/9CwL0AiADIA/9CwKEAyADQQA2ApQDIARBD0EAEH1FDQEgBBB+C0EAIQMgBkEANgIAIAVB8t0pNgIAQZmQLCAFEHUgBigCJBArIAYQKwwCCyAGIAQ2AgAgBEEKQQAQaxogBigCAEEAQQAQaxoCQCAGKAKAA0EBRw0AIAYoAgAhACAFQpuAgICwAzcCoAMCQEGkiDQoAgAiBARAAn8CQCAEKAIUQSpJDQAgBCgCBCIDRQ0AIAQoAhgiCCAIKAKoAUEBajYCqAEgBCAEKAIcQQFqNgIcIAQgBCgCIEEqajYCICAEIAQoAixBKmo2AiwgBCADKAIANgIEQX8hCEEIDAELQSoQKiIDRQRAEE8LIAQgBCgCJEEBajYCJEEqIQggBCAEKAIoQSpqNgIoQSwLIARqIgQgBCgCACAIajYCAAwBC0EqECohAwsgBSADNgKoAyADQe/1KygAADYAFyADQej1KykAADcAECADQdj1K/0AAAD9CwAAIAAgBUGgA2oQfwJAQaSINCgCACIERQ0AIAUgAzYCrAcgBCgCACIAIAUoAqwHSw0AIAUoAqwHIAAgBCgCEGpPDQAgAyAEKAIENgIAIAQgAzYCBCAEIAQoAghBAWo2AgggBCgCFCIEQQRJDQEgBEF8cSIERQ0BIANBACAE/AsADAELIAMQKwsgBigC+AIhBCAGKAIAIgMoAgwiAEEDOgAEIAAgBDYCACADIAMoAgxBCGo2AgwgBigCACIDIAMoAhAoAiQoAgxBCGpB2eArEFkgBigCACANEFggBigCACIDIAMoAhAoAiQoAgxBCGpBut0rEFkgBigCACALEFggBigCACIDIAMoAhAoAiQoAgxBCGpBsd8rEFkgBigC9AJBAUYEQCAGKAIAQZ7fKxBYIAYoAgAiAyADKAIQKAIkKAIMQQhqQabiKxBZCyAGKAIAIgMoAhBBEDYCjAEgAygCDCIEQRY6AAQgBEERNgIAIAMgAygCDEEIajYCDEGQljQgBjYCACAGKAIAIgMoAgwhBCAFQQE2AqQDIAUgBEEIayIANgKgAyADKAJcIQQgA0EANgJcIAMtAAchCCADKAIUIQcgAygCHCEJAkAgA0ENIAVBoANqEH0iDEUEQCADIAQ2AlwMAQsgAyAIOgAHIAMgBzYCFCADIAMgACAJayIIIAwQgQEiACADKAIcIAhqEIIBIAMQgwEgAyAENgJcQfixKiEIAkACQAJAIAAOBQMAAgABAAtB1rAqQfuwKiAAQQVGGyEIDAELQZqxKiEIC0EAIQNBACEHIAYoAgAiBCgCFCgCAEEIaiIAIAQoAgxPBEAgBCgCEEEsaiEACwJAAkACQCAALQAEQQ9xQQNrDgIAAQILIAQgABBTIAQoAhAoAgxBAEoEQCAEEFQLIAQoAhQoAgBBCGoiACAEKAIMSQ0AIAQoAhBBLGohAAsgACgCAEEQaiEHCyAFIAc2AqgBIAUgCDYCpAEgBUHy3Sk2AqABIARBhowqIAVBoAFqEG4gBhCEAQwCCyAGKAIAIQMgBUEANgKQASADQQIgBUGQAWoQaxogBigCACEDIAVBADYCgAEgBSADQQMgBUGAAWoQazYCcCADQeHiKyAFQfAAahBbQaSINEE0ECoiADYCAAJAAkAgBigCqAQiBCAEQQFrcQRAQfWLLEEoQQFBkO8zECMMAQsgBigCpAQhCiAAQQA6ADAgACAEIApsIgsQKiIINgIAIAhFBEBBnIksQR9BAUGQ7zMQIwwBCwJAIAtBBEkNACALQXxxIgNFDQAgCEEAIAP8CwALIAAgBDYCFCAAIAo2AgwgACALNgIQIAAgCDYCBCAKQQFrIg0EQCANQQNxIQlBACEIQQAhAyAKQQJrQQNPBEAgDUF8cSEMA0AgACgCACADIARsaiIHIAQgB2o2AgAgACgCACADQQFyIARsaiIHIAQgB2o2AgAgACgCACADQQJyIARsaiIHIAQgB2o2AgAgACgCACADQQNyIARsaiIHIAQgB2o2AgAgA0EEaiIDIAxHDQALCyAJBEADQCAAKAIAIAMgBGxqIgcgBCAHajYCACADQQFqIQMgCEEBaiIIIAlHDQALCyAAKAIAIQgLIAAgCjYCCEEAIQMgCCAEIA1sakEANgIAIAAgBEEEakEEEC42AhggACAP/QsCHCAAQQA2AiwgCw0BCyAFQfLdKTYCIEHpjywgBUEgahB1IAYoAiQQKyAGECtBACEDQaSINCgCABArDAILIAYoAgAiBCgCECIAQRI2AgAgACAGNgIEIAZBKGohACAEQcAAEIYBIQQDQCAEKAIIIANqIAAgA2otAAA6AAAgA0EBciIIIAQoAghqIAAgCGotAAA6AAAgA0ECciIIIAQoAghqIAAgCGotAAA6AAAgA0EDciIIIAQoAghqIAAgCGotAAA6AAAgA0EEaiIDQcAARw0ACyAEQcAANgIAIAYoAgAiAyADKAIQKAIkKAIMQQhqQc/iKxBZIAYtAIgDBEAgBigCAEH4sypBABBaCwJAIAJFDQAgBigCAEG04ytBABBbIAYoAgAhAyACLQAARQRAIAVBxuMrNgJgIANB/YcqIAVB4ABqEFsMAQsgAyACEFggAyADKAIQKAIkKAIMQQhqQcbjKxBZCwJAIAFFDQAgBigCAEGI3StBABBbIAYoAgAhAyABLQAARQRAIAVBmt0rNgJQIANB/YcqIAVB0ABqEFsMAQsgAyABEFggAyADKAIQKAIkKAIMQQhqQZrdKxBZCyAGKAIAIQMgBUGB3ytBvdsrIAYoAoADQQFGGzYCQCADQdKIKiAFQUBrEFsgBigCACEDAkBBgd8rQb3bKyAGKAKAA0EBRhsiBC0AAEUEQCAFQcbbKzYCMCADQf2HKiAFQTBqEFsMAQsgAyAEEFggAyADKAIQKAIkKAIMQQhqQcbbKxBZCyAGIQMMAQsgBSAANgLAAUHgiiwgBUHAAWoQdUEAIQMLIAVBsAdqJAAgAwsXAQF/IABBACABEJMIIgIgAGsgASACGwsXACAAQTBrQQpJIABBIHJB4QBrQRpJcgtXAQF/IwBBoAJrIgIkACACIAE2AgwgAkEQakGAAiAAIAEQkwEgAkEQampBCjsAACACQfAAOwAKIAIgAkEQajYCAEHL9DMgAkEKaiACEAAaIAJBoAJqJAALEAAgACABQoCAgIAIEOoMpwt1AQN/AkAgAC0AACIDRQ0AA0ACQCABLQAAIgVFDQAgAkEBayICRQ0AAkAgAyAFRg0AIAMQ0wEgBRDTAUYNACADIQQMAwsgAUEBaiEBIAAtAAEhAyAAQQFqIQAgAw0BDAILCyADIQQLIAQQ0wEgAS0AABDTAWsLFwAgAEEwa0EKSSAAQSByQeEAa0EGSXILEAAQBUQAAAAAAECPQKP8BgvSCQEHfyMAQYAGayIFJAAgAEEANgJcIABBAEHUAPwLACABQQBKBEAgBUEsaiIGQQBBgAL8CwAgBUEgNgLsAiAFQquzj/yRo7Pw2wA3AiQgBUL/pLmIxZHagpt/NwIcIAVC8ua746On/aelfzcCFCAFQufMp9DW0Ouzu383AgwgBUIANwIEA0AgBiAFKAIEIgRBA3ZBPHFqIgcgAiADai0AACAHKAIAQQh0cjYCACAFIARBCGoiBDYCBAJAAkAgBEUEQCAFQQA2AgQgBSAFKAIIQQFqNgIIDAELIARB/wNxDQELIAVBBGoQ9wELIANBAWoiAyABRw0ACyAFQQRqIAVB8AJqEPgBA0AgBUHwAmogCEECdGooAgAhAyAAQgA3AlQgACAAKAIgQQFzNgIgIAAgAyAAKAIAczYCACAAIANBAWsiBCAAKAJAczYCQCAAQQIgA2siAyAAKAIMczYCDCAAIAQgA2siBCAAKAIsczYCLCAAIAMgBGsiAyAAKAJMczYCTCAAIAQgA2siBCAAKAIYczYCGCAAIAMgBGsiAyAAKAI4czYCOCAAIAQgA2siBCAAKAIEczYCBCAAIAMgBGsiAyAAKAIkczYCJCAAIAQgA2siBCAAKAJEczYCRCAAIAMgBGsiAyAAKAIQczYCECAAIAQgA2siBCAAKAIwczYCMCAAIAMgBGsiAyAAKAJQczYCUCAAIAQgA2siBCAAKAIcczYCHCAAIAMgBGsiAyAAKAI8czYCPCAAIAQgA2siBCAAKAIIczYCCCAAIAMgBGsiAyAAKAIoczYCKCAAIAQgA2siBCAAKAJIczYCSCAAIAMgBGsiAyAAKAIUczYCFCAAIAAoAjQgBCADa3M2AjRBACEJA0AgACAAKAJUIgNBAWo2AlQgA0EUTgRAQQAhAyAAQQA2AlRBDyEEA0AgACAEQQAgBEEVRxsiAUECdGooAgAiBCAAKAJYIAAgA0ECdGoiAigCAGoiBmshByAEIAZJIgZFIAQgB01xRQRAIAAgBjYCWAsgAiAHNgIAIAFBAWohBCADQQFqIgNBFUcNAAsLIAlBAWoiCUGQzgBHDQALIAhBAWoiCEEIRw0ACwtBACEJIAVBvANqIghBAEGAAvwLACAFQSA2AvwFIAVCq7OP/JGjs/DbADcCtAMgBUL/pLmIxZHagpt/NwKsAyAFQvLmu+Ojp/2npX83AqQDIAVC58yn0NbQ67O7fzcCnAMgBUIANwKUAwNAIAAgACgCVCIDQQFqIgQ2AlQgA0ETTAR/IAAgBEECdGoFQQAhAyAAQQA2AlRBDyEEA0AgACAEQQAgBEEVRxsiAUECdGooAgAiBCAAKAJYIAAgA0ECdGoiAigCAGoiBmshByAEIAZJIgZFIAQgB01xRQRAIAAgBjYCWAsgAiAHNgIAIAFBAWohBCADQQFqIgNBFUcNAAsgAAshAyAIIAUoApQDIgRBA3ZBPHFqIgcgAy0AACAHKAIAQQh0cjYCACAFIARBCGoiAzYClAMCQAJAIANFBEAgBUEANgKUAyAFIAUoApgDQQFqNgKYAwwBCyADQf8DcQ0BCyAFQZQDahD3AQsgCUEBaiIJQYABRw0ACyAFQZQDaiAAQeAAahD4ASAAQQA2AlwgBUGABmokAAtgACMAQRBrIgAkAAJAIAFFBEAgA0UEQEEAIQEMAgsgAxAqIgENASAAIAM2AgBBACEBQQBBjuMrIAAQbgwBCyADRQRAIAEQK0EAIQEMAQsgASADECwhAQsgAEEQaiQAIAEL9g0BB38CQCAAQRBqIgIoAgAiCCgCBEEAQQBB6AIgCCgCABECACIBRQRAIABBAEEAQegCEIMGIgFFDQELIAggCCgCDEHoAmo2AgwgACABNgIkIAAgATYCHCABQQA6AAQgACgCHEEAOgAMIAAoAhxBADoAFCAAKAIcQQA6ABwgACgCHEEAOgAkIAAoAhxBADoALCAAKAIcQQA6ADQgACgCHEEAOgA8IAAoAhxBADoARCAAKAIcQQA6AEwgACgCHEEAOgBUIAAoAhxBADoAXCAAKAIcQQA6AGQgACgCHEEAOgBsIAAoAhxBADoAdCAAKAIcQQA6AHwgACgCHEEAOgCEASAAKAIcQQA6AIwBIAAoAhxBADoAlAEgACgCHEEAOgCcASAAKAIcQQA6AKQBIAAoAhxBADoArAEgACgCHEEAOgC0ASAAKAIcQQA6ALwBIAAoAhxBADoAxAEgACgCHEEAOgDMASAAKAIcQQA6ANQBIAAoAhxBADoA3AEgACgCHEEAOgDkASAAKAIcQQA6AOwBIAAoAhxBADoA9AEgACgCHEEAOgD8ASAAKAIcQQA6AIQCIAAoAhxBADoAjAIgACgCHEEAOgCUAiAAKAIcQQA6AJwCIAAoAhxBADoApAIgACgCHEEAOgCsAiAAKAIcQQA6ALQCIAAoAhxBADoAvAIgACgCHEEAOgDEAiAAKAIcQQA6AMwCIAAoAhxBADoA1AIgACgCHEEAOgDcAiAAKAIcQQA6AOQCIABCADcCPCAAQYCACDYCVCAAQQA2AkQgACAAKAIcIgE2AgwgACABNgI0IAAgAUHAAmo2AhggAUEAOgAEIAAgAEE0ajYCFCAAIAAoAgwiAUGoAWo2AjggACABQQhqNgIMAkAgAigCACICKAIEQQBBBUEgIAIoAgARAgAiAUUEQCAAQQBBBUEgEIMGIgFFDQELIAIgAigCDEEgajYCDCACLQA4IQMgAUEFOgAEIAEgA0EYcToABSABIAIoAkQ2AgAgAiABNgJEIAFCADcCFCABQcSxLzYCECABQgA3AgggAUE/OwEGIAhBxQA6ACggCCABNgIkIAAgAUECQQAQiAYgASgCDCICQcgAOgAEIAIgADYCACABKAIMIQMCQCAAQRBqIgQoAgAiAigCBEEAQQVBICACKAIAEQIAIgFFBEAgAEEAQQVBIBCDBiIBRQ0BCyACIAIoAgxBIGo2AgwgAi0AOCEFIAFBBToABCABIAVBGHE6AAUgASACKAJENgIAIAIgATYCRCABQgA3AhQgAUHEsS82AhAgAUIANwIIIAFBPzsBBiADQcUAOgAMIAMgATYCCAJAIAQoAgAiAygCBEEAQQBBgAQgAygCABECACIBRQRAIABBAEEAQYAEEIMGIgFFDQELIAMgATYCGCADIAMoAgxBgARqNgIMQQAhBCABQQBBgAT8CwAgA0GAATYCICADIABB46kpQREQgAYiATYClAEgACgCECECIAEgAS0ABUHAAXFBBHI6AAUgAiABKAIANgJEIAEgAigCaDYCACACIAE2AmggA0GkAmohBSADQaACaiEGA0AgBiAEQQN0IgNqIAE2AgAgAyAFaiABNgIAIARBNEYEQEEAIQQDQAJAIARBAnQiBUGgsi9qKAIAIgMgAiADQTVwQQN0aiIBKAKgAiIGQRBqEK0BRQRAIAYhAQwBCyADIAFBoAJqIgcoAgQiAUEQahCtAUUNACAHIAY2AgQgByAAIAMgAxAnEIAGIgE2AgAgACgCECECCyACIAVqIAE2ApgBIAEgAS0ABUHAAXFBBHI6AAUgAiABKAIANgJEIAEgAigCaDYCACACIAE2AmggBEEBaiIEQRlHDQALIABBoNsrQQQQgAYhASAAQRBqIgcoAgAhAiABIAEtAAVBwAFxQQRyOgAFIAIgASgCADYCRCABIAIoAmg2AgAgAiABNgJoQQAhAwNAAkAgA0ECdEGwrS9qKAIAIgQgAiAEQTVwQQN0aiIBKAKgAiIFQRBqEK0BRQRAIAUhAQwBCyAEIAFBoAJqIgYoAgQiAUEQahCtAUUNACAGIAU2AgQgBiAAIAQgBBAnEIAGIgE2AgAgBygCACECCyABIAEtAAVBwAFxQQRyOgAFIAIgASgCADYCRCABIAIoAmg2AgAgAiABNgJoIAEgA0EBaiIDOgAGIANBFkcNAAsgCEEAOgAwIAhBADoAPg8FIAYgA0EIciIHaiABNgIAIAUgB2ogATYCACAGIANBEHIiB2ogATYCACAFIAdqIAE2AgAgBiADQRhyIgNqIAE2AgAgAyAFaiABNgIAIARBBGohBAwBCwALAAsgAEEEEIQGAAsgAEEEEIQGAAsgAEEEEIQGAAsgAEEEEIQGAAvpAQEFfyMAQbABayIEJAAgACgCYCEHIARBADYCqAEgBCAAKAIwNgIIIAAgBEEIajYCMCAEQQxqIgVBATYCBCAFIARBrAFqNgIAAkADQCADRQRAQcT/M0EANgIAIAEgACACEBlBxP8zKAIAIQNBxP8zQQA2AgBBfyEFAkAgA0UNAEHI/zMoAgAiBkUNACADKAIAIARBrAFqRgR/IAMoAgQFQQALIgVFDQMgBiQDCyMDIQMgBUEBRg0BCwsgBCgCCCEDIAAgBzYCYCAAIAM2AjAgBCgCqAEhAyAEQbABaiQAIAMPCyADIAYQRgALgwYBB38jAEEQayIFJAAgACgCECIGIQEgBi0AMEEPcUUEQCAAIABBNGoiAzYCFCAALQAHIQRBACEBA0AgACgCHCECIAUgATYCDCAFIAJBAWo2AgggAEETIAVBCGoQfSIBBEAgACAEOgAHIAAgAzYCFAwBCwsgACgCECEBCyABQQQ6AD4gAS0AOgRAIAEtADhBGHEhAyABKAJEIgIEQANAIAIgAi0ABUHAAXEgA3I6AAUgAigCACICDQALCyABQQA2AnQgAUIANwJsIAEoAkwiAgRAA0AgAiACLQAFQcABcSADcjoABSACKAIAIgINAAsLIAEoAmQiAgRAA0AgAiACLQAFQcABcSADcjoABSACKAIAIgINAAsLIAFBADYChAEgAUIANwJ8IAFBCDsAOQsgAUEANgIUIAFB5ABqIgchAgNAIAIiAygCACICDQALIAEoAkwiAiABKAKAAUcEQANAIAIoAgAhBCABKAJ8IAJGBEAgASAENgJ8CyABIAQ2AkwgAiADKAIANgIAIAMgAjYCACACIQMgASgCTCICIAEoAoABRw0ACwsgBygCAARAA0AgABDKBiAHKAIADQALCyABKAJEIgIgASgCkAEiBEcEQANAIAIoAgAhAyAAIAIQwwYgBCADIgJHDQALCyABKAJoIgEEQANAIAEoAgAhAiAAIAEQwwYgAiIBDQALCyAAKAIQIgEoAgQgASgCGCABKAIgQQJ0IgJBACABKAIAEQIAGiABIAEoAgwgAms2AgwgACgCHCIBBEAgACAAQTRqNgIUIAAoAkAhAiAAQQA2AkAgAgRAIABBEGohBANAIAIoAgwhAyAEKAIAIgEoAgQgAkEkQQAgASgCABECABogASABKAIMQSRrNgIMIAAgAC8BCEEBazsBCCADIgINAAsgACgCHCEBCyAAKAIQIgIoAgQgASAAKAIYIAFrQShqIgNBACACKAIAEQIAGiACIAIoAgwgA2s2AgwLIAYoAgQgAEEEa0HIBkEAIAYoAgARAgAaIAVBEGokAAuGAwEFfyMAQTBrIgMkACADQYiNKjYCICAAQfmGKiADQSBqEJsBAkACQEGQljQoAgAiAkUNACACKAIUIgVFDQAgAigCGCACKAIcIgYgASgCACIEakEBakkEQCAAQbGZKkEAEG4gASgCACEECyAFIAZqIQUgBARAIAUgASgCCCAE/AoAAAsgBSABKAIAakEKOgAAIAIgASgCACACKAIcakEBajYCHAwBCyABKAIAIgRBCGpBARAuIQIgBARAIAIgASgCCCAE/AoAAAsgAiAEakEKOwAAIAMgAjYCECADQfAAOwAqQav1MyADQSpqIANBEGoQABoCQEGkiDQoAgAiAUUNACADIAI2AiwgASgCACIEIAMoAixLDQAgAygCLCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASACQQAgAfwLAAwBCyACECsLIANBiI0qNgIAIABB4IcqIAMQmwEgA0EwaiQACxEAIAAgASgCACABKAIEEJEGC2YBBH8jAEEQayIDJAAgAC0AByEEIAAoAhQhBQNAIAAoAhwhBiADIAI2AgwgAyABIAZqNgIIIABBEyADQQhqEH0iAgRAIAAgBDoAByAAIAU2AhQMAQsLIAMoAgwhACADQRBqJAAgAAuEAQEBfwJAAkACQAJAIAEOBgMCAgIAAQILIAIgACgCECgClAEiAzYCACADLQAEQcAAciEDDAILIAIgAEHF7ipBFxCABiIDNgIAIAMtAARBwAByIQMMAQsgAiAAKAIMIgNBCGsoAgA2AgAgA0EEay0AACEDCyACIAM6AAQgACACQQhqNgIMC5kCAQV/IAAoAgwhASAAKAIUIgMEQCADIQIDQCACKAIEIgQgASABIARJGyEBIAIoAggiAg0ACwsCQCABIAAoAhwiAmtBA3UiAUG/lrECSg0AIAAoAhggAmtBA3VBwJaxAkETIAEgAUETTBtBAWoiAkEDbCABQenc5QBKG0wNACAAQaDLmAEgAiACQaDLmAFPG0EBdEEAEKsGGiAAKAIUIQMLAkAgAygCDCIERQ0AIAQoAgwiA0UNACAAQRBqIQUDQCAEIAMoAgwiATYCDCAAIAAvAQhBAWs7AQggBSgCACICKAIEIANBJEEAIAIoAgARAgAaIAIgAigCDEEkazYCDCABRQ0BIAEgBDYCCCABIQQgASgCDCIDDQALCwv+BgEGfyMAQYABayIDJAAgACgCACEEIwBBEGsiAiQAIAJBADYCDAJAIAQEQCAEKAIQKAIEIgEEQCABKAL4AkEATA0CCyAEQYACEJgBIgEoAggiBSABKAIEQQVrQYf0KyACKAIMEJMBGiABIAUQJzYCACAEQQQgARCZASABEJoBDAELIAIgAigCDDYCAEGH9CsgAhB1CyACQRBqJAAgACgCACECIANBADYCYCADIAJBAyADQeAAahBrNgJQIAJB++IrIANB0ABqEFpBpIg0KAIAIgIEQCAAKAIAIQEgAigCDCEEIAMgAigCFDYCRCADIAQ2AkAgAUGi5yogA0FAaxBbIAAoAgAhASADIAIoAixBCnY2AjAgAUHf3ysgA0EwahBbIAAoAgAhASACKAIoIQQgAyACKAIkNgIgIAMgBEEKdjYCJCABQZTgKyADQSBqEFsgACgCACEBIAIoAiAhBCADIAIoAhw2AhAgAyAEQQp2NgIUIAFB998rIANBEGoQWwsgACgCJCICBEAgAhArIABBADYCJAsCQCAAKAKAA0EBRw0AIAAoAgAhBCADQpiAgICAAzcCbAJAQaSINCgCACIBBEACfwJAIAEoAhRBJ0kNACABKAIEIgJFDQAgASgCGCIFIAUoApwBQQFqNgKcASABIAEoAhxBAWo2AhwgASABKAIgQSdqNgIgIAEgASgCLEEnajYCLCABIAIoAgA2AgRBCCEGQX8MAQtBJxAqIgJFBEAQTwsgASABKAIkQQFqNgIkIAEgASgCKEEnajYCKEEsIQZBJwshBSABIAZqIgEgASgCACAFajYCAAwBC0EnECohAgsgAyACNgJ0IAJBh9orKQAANwAQIAJB99kr/QAAAP0LAAAgBCADQewAahB/AkBBpIg0KAIAIgFFDQAgAyACNgJ8IAEoAgAiBCADKAJ8Sw0AIAMoAnwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgAkEAIAH8CwAMAQsgAhArCyAAKAIAIQIgA0EANgIAIAJBAiADEGsaIAAoAgAoAhAoApABEH4gAEEANgIAQaSINCgCACICBEAgAigCABArIAIoAhgQKyACECsLQaSINEEANgIAIAAQK0GQljRBADYCACADQYABaiQAC6EDAQJ/IwBBEGsiBCQAAkAgAUUEQCADRQRAQQAhAgwCCwJAIAJBB0YEQAJ/AkAgA0GkiDQoAgAiASgCFEsNACABKAIEIgJFDQAgASgCGCADQQJ0aiIAIAAoAgBBAWo2AgAgASABKAIcQQFqNgIcIAEgASgCICADajYCICABIAEoAiwgA2o2AiwgASACKAIANgIEQQghBUF/DAELIAMQKiICRQRAEE8LIAEgASgCJEEBajYCJCABIAEoAiggA2o2AihBLCEFIAMLIQAgASAFaiIBIAEoAgAgAGo2AgAMAQsgAxAqIQILIAINASAEIAM2AgBBACECQQBBjuMrIAQQbgwBC0GkiDQoAgAhAiADRQRAIAQgATYCDAJAIAIoAgAiAyAEKAIMSw0AIAQoAgwgAyACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgNBBEkEQEEAIQIMAwtBACECIANBfHEiA0UNAiABQQAgA/wLAAwCCyABECtBACECDAELIAIgASADEFEhAgsgBEEQaiQAIAILgwMBBn8jAEEgayIEJAACQCABQQBIBEAgAEHsqCpBABBuDAELIAFBgYD6AU8EQCAEIAE2AgAgAEHJxykgBBBuDAELIABBEEEBENoBIQUgAEHY4c59QcHiKRCQARogAEF+ENsBIAFBD2ohAwJAQaSINCgCACICBEACfwJAIAMgAigCFEsNACACKAIEIgZFDQAgAigCGCADQQJ0aiIHIAcoAgBBAWo2AgAgAiACKAIcQQFqNgIcIAIgAigCICADajYCICACIAIoAiwgA2o2AiwgAiAGKAIANgIEQX8hA0EIDAELIAMQKiIGRQRAEE8LIAIgAigCJEEBajYCJCACIAIoAiggA2o2AihBLAsgAmoiAiACKAIAIANqNgIADAELIAMQKiEGCyAFIAY2AgggBkUEQEEAIQUgAEHMiStBABBuIARB0PszKAIAECY2AhQgBEHovyk2AhAgAEGCiSogBEEQahBuDAELIAVBATYCDCAFIAE2AgQgBUEANgIACyAEQSBqJAAgBQv9BAEDfyMAQUBqIgMkACAAKAIAIQICQCABLQAARQRAIANBtOIrNgIwIAJB/YcqIANBMGoQWwwBCyACIAEQWCACIAIoAhAoAiQoAgxBCGpBtOIrEFkLIANB/AA2AjwgA0HYjCw2AjgCQAJAAkAgAkEKIANBOGpB2IwsQQAQcARAIABBATYCrAQMAQsgACACQQBBAEEAQQAQcSIBQQBHNgKsBCABRQ0BC0EAIQAgAkGOjypBABBuIAIoAgwiBEEIayEBAkACQAJAIARBBGstAABBD3FBA2sOAgABAgsgAiABEFMgAigCECgCDEEASgRAIAIQVAsgAigCDEEIayEBCyABKAIAQRBqIQALIAMgADYCACACQZGMKiADEG4MAQsgA0GYATYCPCADQdWNLDYCOAJAAkACQCACQQogA0E4akHVjSxBABBwRQRAIAAgAkEAQQBBAEEAEHEiAUEARzYCrAQgAQ0BIwBBEGsiBCQAIARB7o4sECc2AgwgBEHujiw2AgggAkEKIARBCGpB7o4sQQAQcCEBIARBEGokACABDQIgACACQQBBAEEAQQAQcSIBQQBHNgKsBCABDQMgAkGHsStBABBbDAQLIABBATYCrAQLQQAhACACQbuPKkEAEG4gAigCDCIEQQhrIQECQAJAAkAgBEEEay0AAEEPcUEDaw4CAAECCyACIAEQUyACKAIQKAIMQQBKBEAgAhBUCyACKAIMQQhrIQELIAEoAgBBEGohAAsgAyAANgIQIAJBkYwqIANBEGoQbgwCCyAAQQE2AqwECyACQeSPKkEAEG4gAyACQX9BABCIATYCICACQZGMKiADQSBqEG4LIANBQGskAAvgAwEBfyAAKAIUIQMCQCABQQBKBEAgAygCACABQQN0aiIDIAAoAgxJDQEgACgCEEEsaiEDDAELIAFB2eHOfU4EQCAAKAIMIAFBA3RqIQMMAQsgAUHY4c59RgRAIAAoAhBBJGohAwwBCyADKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdjhzn0gAWtPBEAgA0EAIAFrQQN0akG48okTayEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLAn8CQAJAAkAgAy0ABEEPcUEDaw4CAQIAC0EAIAJFDQIaIAJBADYCAEEADwsgACADEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCEDIAFBAEoEQCADKAIAIAFBA3RqIgMgACgCDEkNASAAKAIQQSxqIQMMAQsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAwwBCyABQdjhzn1GBEAgACgCEEEkaiEDDAELIAMoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSABa08EQCADQQAgAWtBA3RqQbjyiRNrIQMMAgsgACgCEEEsaiEDDAELIAAoAhBBLGohAwsgAgRAIAIgAygCACIBLQAHIgBB/wFGBH8gASgCDAUgAAs2AgALIAMoAgBBEGoLC8QBAQF/IwBBEGsiAiQAAn8CQCABRQRAIAAoAgBB19cpQQAQbiAAKAIAQbSyK0EAEG4gABCEASACQQA6AA9BzPIzIAJBD2pBABAAGiACQQA6AA5B4/IzIAJBDmpBABAAGgwBC0EAIAEtAAANARogACgCAEG31ylBABBuIAAoAgBBtLIrQQAQbiAAEIQBIAJBADoADUH18jMgAkENakEAEAAaIAJBADoADEGM8zMgAkEMakEAEAAaC0EECyEAIAJBEGokACAAC6sBAQF/IwBBEGsiASQAAn8CQCAARQRAQeP0K0EAEHVBtLIrQQAQdSABQQA6AA9BnvMzIAFBD2pBABAAGiABQQA6AA5BtfMzIAFBDmpBABAAGgwBC0EAIAAoAgANARpBgvUrQQAQdSAAEIQBQbSyK0EAEHUgAUEAOgANQcbzMyABQQ1qQQAQABogAUEAOgAMQd3zMyABQQxqQQAQABoLQQQLIQAgAUEQaiQAIAALiwEBA38jAEEQayIBJAAgACgCACECAkAgACgCrAQiA0UEQCACQZn0K0EAEFogABCEASABQQA6AA9B7vMzIAFBD2pBABAAGgwBCyACQejzK0EAEG4gABCEASABQQA6AA5BgvQzIAFBDmpBABAAGiABQQA6AA1BmfQzIAFBDWpBABAAGgsgAUEQaiQAIAML1wIBA38jAEEgayIGJAAgAQRAIAFBACABLQAAGyEICyACBEAgAkEAIAItAAAbIQcLQQAhAkEAIQEgAwRAIANBACADLQAAGyEBCyAEBEAgBEEAIAQtAAAbIQILIAUEfyAFQQAgBS0AABsFQQALIQQCQCAIIAcgARByIgVFDQACQCACRQ0AIAUoAgBBy+MrQQAQWyAFKAIAIQMgAi0AAEUEQCAGQd3jKzYCECADQf2HKiAGQRBqEFsMAQsgAyACEFggAyADKAIQKAIkKAIMQQhqQd3jKxBZCyAERQ0AIAUoAgBBqNsrQQAQWyAFKAIAIQMgBC0AAEUEQCAGQbrbKzYCACADQf2HKiAGEFsMAQsgAyAEEFggAyADKAIQKAIkKAIMQQhqQbrbKxBZC0EEIQQCQCAFEIoBDQAgBSAAEIkBDQAgBSAAEIcBIAUQiwEhBAsgBkEgaiQAIAQLiAUBA38jAEFAaiIGJAAgAQRAIAFBACABLQAAGyEICyACBEAgAkEAIAItAAAbIQcLQQAhAkEAIQEgAwRAIANBACADLQAAGyEBCyAEBEAgBEEAIAQtAAAbIQILIAUEfyAFQQAgBS0AABsFQQALIQQCQCAIIAcgARByIgVFDQACQCACRQ0AIAUoAgBBy+MrQQAQWyAFKAIAIQMgAi0AAEUEQCAGQd3jKzYCMCADQf2HKiAGQTBqEFsMAQsgAyACEFggAyADKAIQKAIkKAIMQQhqQd3jKxBZCyAERQ0AIAUoAgBBqNsrQQAQWyAFKAIAIQMgBC0AAEUEQCAGQbrbKzYCICADQf2HKiAGQSBqEFsMAQsgAyAEEFggAyADKAIQKAIkKAIMQQhqQbrbKxBZC0EEIQQCQCAFEIoBDQAgBSAAEIkBDQAgBSgCACEEAkAgAEUEQCAEQdi0K0EAEFsMAQsgAC0AAEUEQCAGQbTiKzYCECAEQf2HKiAGQRBqEFsMAQsgBCAAEFggBCAEKAIQKAIkKAIMQQhqQbTiKxBZCyAGIAAQJzYCPCAGIAA2AjhBACEDAkACQCAEQQogBkE4aiAAQQAQcA0AIARBAEEAQQBBABBxDQAgBEHmsCtBABBbIAVBADYCrAQMAQsgBEG+5CtBABBuIAQoAgwiAUEIayECAkACQAJAIAFBBGstAABBD3FBA2sOAgABAgsgBCACEFMgBCgCECgCDEEASgRAIAQQVAsgBCgCDEEIayECCyACKAIAQRBqIQMLIAYgAzYCACAEQZGMKiAGEG4gBEG0sitBABBuIAVBASAFKAKsBCIEIARBAU0bNgKsBAsgBRCLASEECyAGQUBrJAAgBAtdAEEAIQFBACEEIAIEQCACQQAgAi0AABshBAsgAwRAIANBACADLQAAGyEBC0EEIQMCQEHsuyogBCABEHIiAhCKAQ0AIAIgABCJAQ0AIAIgABCHASACEIsBIQMLIAMLzAYBB38jAEEwayIFJABBBCEEAkAgAQR/IAFBACABLQAAGwUgAwtBAEEAEHIiARCKAQ0AIAEgABCJAQ0AAkAgAg0AIAEoAgAhAyAFQR42AiwgBUGnhCs2AiggA0EKIAVBKGpBp4QrQQAQcA0AIAEoAgBBAEEAQQBBABBxGgsgASgCAEGa3ysQZyABKAIAQX9BprkqEJABGiABKAIAQZrfKxBnIAEoAgAiAygCDCEEIAVBADYCLCAFIARBEGsiAjYCKCADKAJcIQQgA0EANgJcIAMtAAchBiADKAIUIQcgAygCHCEIIAECfwJAAkACQCADQQ0gBUEoahB9IglFBEAgAyAENgJcIAEoAgAhAwwBCyADIAY6AAcgAyAHNgIUIAMgAyACIAhrIgIgCRCBASIGIAMoAhwgAmoQggEgAxCDASADIAQ2AlwgASgCACEDIAZFDQBBACEEIANBjo8qQQAQbiABKAIAIgMoAgwiAkEIayEAAkACQAJAIAJBBGstAABBD3FBA2sOAgABAgsgAyAAEFMgAygCECgCDEEASgRAIAMQVAsgAygCDEEIayEACyAAKAIAQRBqIQQLIAUgBDYCICADQZGMKiAFQSBqEG4MAQsgA0Ga3ysQZyABKAIAQX9BwYIrEJABGiABKAIAQZrfKxBnIAEoAgAgABBYIAEoAgAiAygCDCEEIAVBATYCLCAFIARBGGsiADYCKCADKAJcIQQgA0EANgJcIAMtAAchAiADKAIUIQYgAygCHCEHIANBDSAFQShqEH0iCEUEQCADIAQ2AlwgASgCACEEDAILIAMgAjoAByADIAY2AhQgAyADIAAgB2siACAIEIEBIgIgAygCHCAAahCCASADEIMBIAMgBDYCXCABKAIAIQQgAkUNAUEAIQAgBEHQjypBABBuIAEoAgAiAygCDCICQQhrIQQCQAJAAkAgAkEEay0AAEEPcUEDaw4CAAECCyADIAQQUyADKAIQKAIMQQBKBEAgAxBUCyADKAIMQQhrIQQLIAQoAgBBEGohAAsgBSAANgIQIANBkYwqIAVBEGoQbgtBAQwBCyAFIARBf0EAEIgBNgIAIAUQkQFBAAs2AqwEIAEQiwEhBAsgBUEwaiQAIAQL4AMBBH8jAEEQayIFJAACQCABQQBKBEAgACgCFCgCACABQQN0aiIEIAAoAgxJDQEgACgCEEEsaiEEDAELIAFB2eHOfU4EQCAAKAIMIAFBA3RqIQQMAQsgACgCEEEkaiEECwJAIAIgACgCECACQTVwQQN0aiIDKAKgAiIBQRBqEK0BRQRAIAEhAwwBCyACIANBoAJqIgYoAgQiA0EQahCtAUUNACAGIAE2AgQgBiAAIAIgAhAnEIAGIgM2AgALQQAhAgJAAkAgBC0ABEHFAEcNACAEKAIAIQICQCADLQAEIgFBBEYEQCACKAIQIAMoAghBfyACLQAHdEF/c3FBBHRqIQIDQCACLQAFQcQARgRAIAIoAgwgA0YNAwsgAiACKAIIIgFBBHRqIQIgAQ0AC0HUsS8hAgwBCyAFIAM2AgggBSABQcAAcjoADCACIAVBCGpBABCFBiECCyACLQAEQQ9xRQ0AIAAoAgwiASACKAIANgIAIAEgAi0ABDoABCAAIAAoAgxBCGoiAjYCDAwBCyAAKAIMIgEgAzYCACABIAMtAARBwAByOgAEIAAgACgCDCIBQQhqNgIMIAAgBCABIAEgAhCGBiAAKAIMIQILIAJBBGstAAAhAiAFQRBqJAAgAkEPcQtZAQF/IwBBoKABayIBJAAgASAANgIMIAFBEGpBgKABQZGMKiAAEJMBIAFqQQA6ABEgAUHwADsACiABIAFBEGo2AgBBqvQzIAFBCmogARAAGiABQaCgAWokAAvbAwEFfyMAQTBrIgMkAEEAQQBBABByIQECQCAARQ0AIAAtAABFDQAgASgCAEHN3itBABBbIAEoAgAhAiAALQAARQRAIANB394rNgIgIAJB/YcqIANBIGoQWwwBCyACIAAQWCACIAIoAhAoAiQoAgxBCGpB394rEFkLQQQhACABEIoBRQRAIAEoAgAhACADQZDMMhAnNgIsIANBkMwyNgIoQQAhAiABAn8CQCAAQQogA0EoakGQzDJBABBwRQRAQQAhACABKAIAQQBBAEEAQQAQcUUNAQsgASgCAEHciyxBABBuIAEoAgAiACgCDCIFQQhrIQQCQAJAAkAgBUEEay0AAEEPcUEDaw4CAAECCyAAIAQQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIMQQhrIQQLIAQoAgBBEGohAgsgAyACNgIQIABBkYwqIANBEGoQbkEBDAELIAEoAgBBn90rEGcgASgCACIEKAIMIgVBCGshAgJAAkACQCAFQQRrLQAAQQ9xQQNrDgIAAQILIAQgAhBTIAQoAhAoAgxBAEoEQCAEEFQLIAQoAgxBCGshAgsgAigCAEEQaiEACyADIAA2AgAgAxCRAUEACzYCrAQgARCLASEACyADQTBqJAAgAAuYEQILfwF+IwBBEGsiCSQAIAlBADYCDCACQQFqIQQgAi0AACEGQQAhAkF/IQcDQCAEIQUgBsAhDQJAAkACQAJAAkACQAJAAkACQCACQQcgBkH/AXEiCxsiAg4HAAECAwQFBggLQQEhAiALQSVHBEAgASAJKAIMIgJLBEAgACACaiAGOgAACyAJIAJBAWo2AgxBACECCyAFQQFqIQQgBS0AACEGDAcLQQIhAgJAAkACQAJAAkAgC0Egaw4RAgsLAwsLCwsLCwsBCwALCwQLC0EBIQIgBUEBaiEEIAhBAXIhCCAFLQAAIQYMCgtBASECIAVBAWohBCAIQQJyIQggBS0AACEGDAkLQQEhAiAFQQFqIQQgCEEEciEIIAUtAAAhBgwIC0EBIQIgBUEBaiEEIAhBCHIhCCAFLQAAIQYMBwtBASECIAVBAWohBCAIQRByIQggBS0AACEGDAYLIAZBMGtB/wFxQQlNBEAgBUEBaiEEIA0gCkEKbGpBMGshCiAFLQAAIQZBAiECDAYLQQMhAiALQSpHBEAMBgsgBUEBaiEEIAUtAAAhBiADKAIAIQogA0EEaiEDDAULIAtBLkcEQEEFIQIMBQsgBUEBaiEEDAMLIAZBMGtB/wFxQQlNBEAgBUEBaiEEIA0gB0EAIAdBAEobQQpsakEwayEHDAMLQQUhAiALQSpHBEAMBAsgBUEBaiEEIAUtAAAhBiADKAIAIQcgA0EEaiEDDAMLQQYhAgJAAkACQAJAIAtB6ABrDgUBBgYGAgALIAtBzABGDQIMBQtBASEMIAVBAWohBCAFLQAAIQYMBAsgBS0AACIGQewARwRAIAVBAWohBEECIQwMBAsgBUECaiEEIAUtAAEhBkEEIQwMAwsgBUEBaiEEIAUtAAAhBkEDIQwMAgsCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAtBJWsOVAsQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQBhAHEBAQEBAQEBAQEBAQEBAQEAMQEBAQEBAQEBAQCAAGBQcQABAQEBAMAQ0QEAkQAhAKBBALAkACQAJAAkACQCAMQQFrDgQAAQMCAwsgAzQCACEPIANBBGohAwwDCyADNAIAIQ8gA0EEaiEDDAILIANBB2pBeHEiAkEIaiEDIAIpAwAhDwwBCyADNAIAIQ8gA0EEaiEDCyAAIAlBDGogASAPQQogCiAHIAgQxgEMDwsCQAJAAkACQAJAIAxBAWsOBAABAwIDCyADNQIAIQ8gA0EEaiEDDAMLIAM0AgAhDyADQQRqIQMMAgsgA0EHakF4cSICQQhqIQMgAjQCACEPDAELIAM0AgAhDyADQQRqIQMLIAAgCUEMaiABIA9BCCAKIAcgCEHAAHIQxgEMDgsCQAJAAkACQAJAIAxBAWsOBAABAwIDCyADNQIAIQ8gA0EEaiEDDAMLIAM0AgAhDyADQQRqIQMMAgsgA0EHakF4cSICQQhqIQMgAikDACEPDAELIAM0AgAhDyADQQRqIQMLIAAgCUEMaiABIA9BCiAKIAcgCEHAAHIQxgEMDQsgCEEgciEICyAIQcAAciECAkACQAJAAkACQCAMQQFrDgQAAQMCAwsgAzUCACEPIANBBGohAwwDCyADNAIAIQ8gA0EEaiEDDAILIANBB2pBeHEiBkEIaiEDIAYpAwAhDwwBCyADNAIAIQ8gA0EEaiEDCyAAIAlBDGogASAPQRAgCiAHIAIQxgEMCwsgA0EHakF4cUEIaiEDDAoLIANBB2pBeHFBCGohAwwJCyADQQdqQXhxQQhqIQMMCAsgASAJKAIMIgJLBEAgACACaiADKAIAOgAACyADQQRqIQMgCSACQQFqNgIMDAcLIAMoAgAhAiAHQX9GBEAgAhAnIQcLQQAhBkEAIAogAkGg5CsgAhsiDRAnayICQQAgAkEAShsiAmsgAiAIQQFxGyEEAkAgCiAHIAcgCkgbIAcgB0EAThsgByAKQQBKGyILQQBMDQAgBEEATA0AIARBAWsiDCALQQFrIgIgAiAMSxsiDkEBaiIGQQNxIQggCSgCDCECIA5BA08EQCAGQXxxIQpBACEEA0AgASACSwRAIAAgAmpBIDoAAAsgASACQQFqIgdLBEAgACAHakEgOgAACyABIAJBAmoiB0sEQCAAIAdqQSA6AAALIAEgAkEDaiIHSwRAIAAgB2pBIDoAAAsgAkEEaiECIARBBGoiBCAKRw0ACwtBACEEIAgEQANAIAEgAksEQCAAIAJqQSA6AAALIAJBAWohAiAEQQFqIgQgCEcNAAsLIAkgAjYCDCAMIA5rIQQLIA0tAAAiB0UNBSAGIAtODQUgCSgCDCECA0AgASACSwRAIAAgAmogBzoAAAsgBkEBaiEGIAJBAWohAiANQQFqIg0tAAAiB0UNBSAGIAtIDQALDAQLIAVBAWohBQwFCyABIAkoAgwiAksEQCAAIAJqQSU6AAALIAkgAkEBajYCDAwECyADQQRqIQQgAygCACECIAkoAgwhBgJAAkACQCAMQQFrDgQAAgIBAgsgAiAGOwEAIAQhAwwFCyACIAatNwMAIAQhAwwECyACIAY2AgAgBCEDDAMLIAAgCUEMaiABIAM0AgBBECAKIAcgCBDGASADQQRqIQMMAgsgCSACNgIMCyADQQRqIQMgBEEATg0AIAYgC04NACAJKAIMIQIDQCABIAJLBEAgACACakEgOgAACyACQQFqIQIgBEF+TARAIARBAWohBCAGQQFqIgYgC0gNAQsLIAkgAjYCDAsgBUEBaiEEIAUtAAAhBkF/IQdBACEKQQAhAkEAIQhBACEMDAELIAUtAAAhBkEEIQILIAJBB0cNAAsgCSgCDCECIAEEQCAAIAIgAUEBayIGIAIgBkkbakEAOgAACyAJQRBqJAAgAgunAQEEf0EBIQMjAEGAAWsiASQAAkACQCAAKAIUIgIgAEE0aiIERg0AA0ACQCACKAIIIQIgA0EBayIDRQ0AIAIgBEcNAQsLIAMNACACIARGDQAgASACNgJ8IABBrtEqIAFBFGoQmgYaIAEoAiwiAkEATA0AIAEgAjYCBCABIAFBQGs2AgAgAEHkiCwgARCmARoMAQsgAEG3kyxBABCmARoLIAFBgAFqJAALHgAgACABIAIQgQYaIAAoAhAoAgxBAEoEQCAAEFQLCxsAIABBAhCYBiAAKAIQKAIMQQBKBEAgABBUCws8AQF/AkAgACgCDCIBQQRrLQAAQcQARw0AIAFBCGsoAgAgACgCECgClAFHDQAgAEEEEIQGAAsgABCVBgALsgQBBn8jAEEwayIGJAACQCABQQBIBEAgAEHsqCpBABBuDAELIAFBgYD6AU8EQCAGIAE2AgAgAEHJxykgBhBuDAELAkBBpIg0KAIAIgIEQAJ/AkAgAigCFEEQSQ0AIAIoAgQiBEUNACACKAIYIgMgAygCQEEBajYCQCACIAIoAhxBAWo2AhwgAiACKAIgQRBqNgIgIAIgAigCLEEQajYCLCACIAQoAgA2AgRBCCEFQX8MAQtBEBAqIgRFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKEEQajYCKEEsIQVBEAshAyACIAVqIgIgAigCACADajYCAAwBC0EQECohBAsgBEUEQCAGQdD7MygCABAmNgIQIABBpooqIAZBEGoQbkEAIQQMAQsgAUEPaiEDAkBBpIg0KAIAIgIEQAJ/AkAgAyACKAIUSw0AIAIoAgQiBUUNACACKAIYIANBAnRqIgcgBygCAEEBajYCACACIAIoAhxBAWo2AhwgAiACKAIgIANqNgIgIAIgAigCLCADajYCLCACIAUoAgA2AgRBfyEDQQgMAQsgAxAqIgVFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKCADajYCKEEsCyACaiICIAIoAgAgA2o2AgAMAQsgAxAqIQULIAQgBTYCCCAFRQRAIAZB0PszKAIAECY2AiAgAEHGiyogBkEgahBuQQAhBAwBCyAEQQA2AgAgBCABNgIEIAVBADoAAAsgBkEwaiQAIAQL4AIBBH8jAEEgayIDJAACQCACRQ0AIAIoAgAhBQJAQZCWNCgCACIEKAIURQ0AIAQoAhggBCgCHCAFakEFak8NACAAQdCZKkEAEG4MAQsgAigCCCAFaiEAIARBgANqIgYoAgBBAUYEfyAAQaLYADsAACAFQQJqIQUgAEECagUgAAtBCjsAACADQSA6ABwgA0GgwICBAjYCGCADQRhqIQAgBigCAEEBRgR/IANBIjoAGCADQRhqQQFyBSAACyABQQJ0QcCTLGooAgBBBBDKARogBCgCFCIABEAgACAEKAIcaiADQRhqQQUQygEhACAFQQFqIgEEQCAAQQVqIAIoAgggAfwKAAALIAQgBSAEKAIcakEGaiICNgIcIAQoAhQgAmpBADoAAAwBCyADQQA6ABcgA0Hw4AE7ABUgAyACKAIINgIEIAMgA0EYajYCAEHP9TMgA0EVaiADEAAaCyADQSBqJAALsgIBBH8jAEEQayIDJAACQCAARQ0AIAAgACgCDCIBQQFrNgIMIAFBAUoNAEGkiDQoAgAhAQJAAkAgACgCCCICBEAgAQRAIAMgAjYCCAJAIAEoAgAiBCADKAIISw0AIAMoAgggBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgRBBEkNAyAEQXxxIgRFDQMgAkEAIAT8CwAMAwsgAhArDAILIAIQKwwCCyABRQ0BCyADIAA2AgwgASgCACICIAMoAgxLDQAgAygCDCACIAEoAhBqTw0AIAAgASgCBDYCACABIAA2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAAQQAgAfwLAAwBCyAAECsLIANBEGokAAuGAQECfyMAQRBrIgMkACADIAI2AgwCQCAABEAgACgCECgCBCICBEAgAigC+AJBBEgNAgsgAEGAAhCYASICKAIIIgQgAigCBEEFayABIAMoAgwQkwEaIAIgBBAnNgIAIABBAiACEJkBIAIQmgEMAQsgAyADKAIMNgIAIAEgAxB1CyADQRBqJAALhgEBAn8jAEEQayIDJAAgAyACNgIMAkAgAARAIAAoAhAoAgQiAgRAIAIoAvgCQQBMDQILIABBgAIQmAEiAigCCCIEIAIoAgRBBWsgASADKAIMEJMBGiACIAQQJzYCACAAQQUgAhCZASACEJoBDAELIAMgAygCDDYCACABIAMQdQsgA0EQaiQAC4IEAQR/IAEEQCAAKAIMIgMgAUHZ4c59TgR/IAMgAUEDdGoFIAAoAhBBJGoLIgEoAgA2AgAgAyABLQAEOgAEIAAgACgCDEEIajYCDAsCQANAIAJBLhCeASIERQRAIAIQJyACaiEECyAAIAIgBCACayIGEJ8BIAAoAgwiAUEQaygCACABQQhrEKABIQEgACAAKAIMIgNBCGsiBTYCDCADQQRrIAEtAARBD3EEfyAFIAEoAgA2AgAgAS0ABAVBAAs6AAAgACAAKAIMIgFBCGoiAzYCDAJAAkAgAS0ABEEPcQ4GAAMDAwMBAwsgACABIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCAAQQBBARChASAAIAIgBhCfASAAKAIMIgIgAkEQaygCADYCACACIAJBDGstAAA6AAQgACAAKAIMQQhqNgIMIABBfBCiASAAKAIMIQMLIANBEGshAiADQQhrIQEDQCACKAIAIQMgAiABKAIANgIAIAItAAQhBSACIAEtAAQ6AAQgASAFOgAEIAEgAzYCACACQQhqIgIgAUEIayIBSQ0ACyAAIAAoAgxBCGsiAiAAKAIkTQR/IAAgAkF/QQAQXgUgAgs2AgwgBEEBaiECIAQtAABBLkYNAAtBAA8LIAAgAUEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCACCxoAIAAgARDcDCIAQQAgAC0AACABQf8BcUYbC6sBAQF/AkAgAkUEQEG3kywgACgCEEG4AmoiAigCoAIiAUEQahCtAUUEQCABIQIMAgtBt5MsIAJBoAJqIgMoAgQiAkEQahCtAUUNASADIAE2AgQgAyAAQbeTLEEAEIAGIgI2AgAMAQsgACABIAIQgAYhAgsgACgCDCIBIAI2AgAgASACLQAEQcAAcjoABCAAIAAoAgxBCGo2AgwgACgCECgCDEEASgRAIAAQVAsLwwQDAX4DfwF9QdSxLyEFAkACQAJAAkACQCABLQAEQT9xDhQEAwMBAAMDAwMDAwMDAwMDAwMDAgMLIAAoAhAgASgCACIDKAIIQX8gAC0AB3RBf3NxQQR0aiEBA0ACQCABLQAFQcQARw0AIAEoAgwgA0cNACABDwsgASABKAIIIgBBBHRqIQEgAA0ACwwDCwJAIAEoAgAiA0EBayIBIAAoAggiBE8EQCAALAAGQQBODQEgAUEAIARrcSAETw0BIAAgAzYCCAsgACgCDCABQQN0ag8LIAAoAhAgA6wiAkIeiCAChUK5y5Pn0e2RrL9/fiICQhuIIAKFQuujxJmxt5LolH9+IgJCH4ggAoWnQX8gAC0AB3RBf3NxQQR0aiEBA0ACQCABLQAFQQNHDQAgASgCDCADRw0AIAEPCyABIAEoAggiAEEEdGohASAADQALDAILIAEqAgAiBiAGjiIGXA0AIAZDAAAAz2BFDQAgBkMAAABPXUUNAAJAIAb8ACIDQQFrIgEgACgCCCIETwRAIAAsAAZBAE4NASABQQAgBGtxIARPDQEgACADNgIICyAAKAIMIAFBA3RqDwsgACgCECADrCICQh6IIAKFQrnLk+fR7ZGsv39+IgJCG4ggAoVC66PEmbG3kuiUf34iAkIfiCAChadBfyAALQAHdEF/c3FBBHRqIQEDQAJAIAEtAAVBA0cNACABKAIMIANHDQAgAQ8LIAEgASgCCCIAQQR0aiEBIAANAAsMAQsgACABQQAQhQYhBQsgBQvdAQEDfwJAIAAoAhAiBCgCBEEAQQVBICAEKAIAEQIAIgNFBEAgAEEAQQVBIBCDBiIDRQ0BCyAEIAQoAgxBIGo2AgwgBC0AOCEFIANBBToABCADIAVBGHE6AAUgAyAEKAJENgIAIAQgAzYCRCADQgA3AhQgA0HEsS82AhAgA0IANwIIIANBPzsBBiAAKAIMIgRBxQA6AAQgBCADNgIAIAAgACgCDEEIajYCDCACRSABQQBMcUUEQCAAIAMgASACEIgGCyAAKAIQKAIMQQBKBEAgABBUCw8LIABBBBCEBgALuwEBAn8CQAJAIAAoAgwiAiABQQN0aiIBLQAEQcUARw0AIAEoAgAgAkEQaxCgASEDIAAoAgwhAiADLQAEQQ9xRQ0AIAMgAkEIaygCADYCACADIAJBBGstAAA6AAQgACgCDCICQQRrLQAAQcAAcUUNASABKAIAIgMtAAVBIHFFDQEgAkEIaygCAC0ABUEYcUUNASAAIAMQiQYMAQsgACABIAJBEGsgAkEIayADEIoGCyAAIAAoAgxBEGs2AgwL/AQBBn8jAEGQBGsiBiQAIAZBEGpB8JMsQYAE/AoAACABIQQgBkEQaiIHECcgB2ohBUH/AyEIA0AgBC0AACIJBEAgBSAJOgAAIAVBAWohBSAEQQFqIQQgCEEBayIIDQELCyAFQQA6AAAgACAHEKQBGiAAQZW8KRBYIAAoAgwiBCAEQRBrKAIANgIAIAQgBEEMay0AADoABCAAIAAoAgxBCGo2AgwgAEF9EKIBIAAgA0EAEGggAEHY4c59QdfiKxCdARoCQCAAQX8gARCQAUEFRwRAIAAoAgxBCGsiBSAAKAIkTQRAIAAgBUF/QQAQXiEFCyAAIAU2AgwCQCAAKAIQKAIkIgQoAghBAU0EQCAEKAIQQX8gBC0AB3RBf3NBiqms0QBxQQR0aiEEA0AgBC0ABUEDRgRAIAQoAgxBAkYNAwsgBCAEKAIIIgNBBHRqIQQgAw0AC0HUsS8hBAwBCyAEKAIMQQhqIQQLIAUgBC0ABEEPcQR/IAUgBCgCADYCACAELQAEBUEACzoABCAAIAAoAgxBCGo2AgwgAEEAIAEQnQENASAAKAIMIgQgBEEIaygCADYCACAEIARBBGstAAA6AAQgACAAKAIMIgRBCGo2AgwgACAEQRBrIAEQWQsgACgCDCIDQRBrIQQgA0EIayEDA0AgBCgCACEBIAQgAygCADYCACAELQAEIQUgBCADLQAEOgAEIAMgBToABCADIAE2AgAgBEEIaiIEIANBCGsiA0kNAAsgACAAKAIMQQhrIgQgACgCJE0EfyAAIARBf0EAEF4FIAQLNgIMIAAgAkEAEGggBkGQBGokAA8LIAYgATYCACAAQbCELCAGEKUBAAuWAQEBfyAAQdjhzn0gARCQAQR/IAIFIAAgACgCDEEIayICIAAoAiRNBH8gACACQX9BABBeBSACCzYCDCAAQQBBAhChASAAIAEQWCAAIAAoAgxBEGtBypErEFkgACgCDCICIAJBCGsoAgA2AgAgAiACQQRrLQAAOgAEIAAgACgCDEEIajYCDCAAIAAoAhBBJGogARBZQQELC5wBAQJ/IwBBgAFrIgMkACADIAI2AhACQAJAIAAoAhQiAiAAQTRqIgRGDQAgAigCCCICIARGDQAgAyACNgJ8IABBrtEqIANBFGoQmgYaIAMoAiwiAkEATA0AIAMgAjYCBCADIANBQGs2AgAgAEHkiCwgAxCmARoMAQsgAEG3kyxBABCmARoLIAAgASADKAIQEJUBIAAQlgEgABCXAQALOgEBfyMAQRBrIgMkACADIAI2AgwgACABIAIQgQYhAiAAKAIQKAIMQQBKBEAgABBUCyADQRBqJAAgAgvGAwEEfyMAQRBrIgQkAAJAAkBB3MorIAEsAAAQngFFBEBB0PszQRw2AgAMAQsgARDWDCEDIARCtgM3AwBBnH8gACADQYCAAnIgBBAGENcMIgBBAEgNASMAQSBrIgMkAAJ/AkACQEHcyisgASwAABCeAUUEQEHQ+zNBHDYCAAwBC0GYCRAqIgINAQtBAAwBCyACQQBBkAEQHCABLQAAIQUgAUErEJ4BRQRAIAJBCEEEIAVB8gBGGzYCAAsCQCAFQeEARwRAIAIoAgAhAQwBCyAAQQNBABAHIgFBgAhxRQRAIAMgAUGACHKsNwMQIABBBCADQRBqEAcaCyACIAIoAgBBgAFyIgE2AgALIAJBfzYCUCACQYAINgIwIAIgADYCPCACIAJBmAFqNgIsAkAgAUEIcQ0AIAMgA0EYaq03AwAgAEGTqAEgAxAIDQAgAkEKNgJQCyACQTc2AiggAkE4NgIkIAJBOTYCICACQTo2AgxBzZg0LQAARQRAIAJBfzYCTAsgAkHElzQoAgAiATYCOCABBEAgASACNgI0C0HElzQgAjYCACACCyECIANBIGokACACDQEgABALGgtBACECCyAEQRBqJAAgAgvwAQEDfyAAQQA2AgACQAJAIAAoAgQQJCICQX9GDQACQCACQe8BRw0AIAAgACgCACICQQFqNgIAIAIgAEEIaiIEakHvAToAACAAKAIEECQiAkF/Rg0BIAJBuwFHDQAgACAAKAIAIgJBAWo2AgAgAiAEakG7AToAACAAKAIEECQiAkF/Rg0BIAJBvwFHDQAgBCAAKAIAakG/AToAACAAQQA2AgAgACgCBBAkIQILIAEgAjYCACACQSNHDQEDQAJAIAAoAgQQJEEBag4MAAEBAQEBAQEBAQEAAQsLQQEhAyAAKAIEECQhAgsgASACNgIACyADC5UCAQJ/An8CQCABKAIAIgBBAEoEQCACIAA2AgAgAUEANgIADAELQQACfyABKAIEIgMoAkxBAEgEQCADKAIADAELIAMoAgALQQR2QQFxDQEaIAICfyABQQhqIQQgASgCBCICKAJMGiACIAIoAkgiAEEBayAAcjYCSAJAIAIoAgQiACACKAIIIgNGBH9BgAgFIAQgAEGACCADIABrIgMgA0GACE8bIgAQGxogAiACKAIEIABqNgIEIANB/wdLDQEgACAEaiEEQYAIIABrCyEAA0ACQCACENUMRQRAIAIgBCAAIAIoAiARBAAiAw0BC0GACCAAawwDCyADIARqIQQgACADayIADQALC0GACAs2AgALIAFBCGoLC4UBAQJ/AkAgACgCTEEATgRAIAAQVhogACAAKAIMEQAAGgwBCyAAEFYaIAAgACgCDBEAABoLIAAtAABBAXFFBEAgACgCOCEBIAAoAjQiAgRAIAIgATYCOAsgAQRAIAEgAjYCNAsgAEHElzQoAgBGBEBBxJc0IAE2AgALIAAoAmAQKyAAECsLC8ICAQN/AkAgAUEATgRAIAAoAhQoAgAgAUEDdGogACgCDCIBa0EIakEDdSIDQQBMDQEgAEEMaiEAIAMiAUEDcSIEBEBBACEBA0AgACAAKAIAIgJBCGo2AgAgAkEAOgAEIAFBAWoiASAERw0ACyADQfz///8HcSEBCyADQQRPBEADQCAAIAAoAgAiAkEIajYCACACQQA6AAQgACAAKAIAIgJBCGo2AgAgAkEAOgAEIAAgACgCACICQQhqNgIAIAJBADoABCAAIAAoAgAiAkEIajYCACACQQA6AAQgAUEFayECIAFBBGshASACQX5JDQALCyAAIAAoAgA2AgAPCyABQQFqIQMgACgCDCEBCyAAQQxqIQIgASADQQN0aiEBAkAgA0EATg0AIAAoAiQgAUkNACAAIAFBf0EAEF4hAQsgAiABNgIAC4wHAQV/IwBBIGsiBCQAIAAoAhQoAgBBCGoiAyAAKAIMTwRAIAAoAhBBLGohAwsCQAJAAkAgAy0ABEEPcUEDaw4CAAECCyAAIAMQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgMgACgCDEkNACAAKAIQQSxqIQMLAkACQAJ/IAMoAgAiAi0AECIFQd8ARwRAQd8AIAVrDAELIAItABEiA0HHAEcEQEHHACADawwBC0EAIAItABJrC0UEQEHwlywhAkHW4CshAwwBC0H8jishA0H8jisgAkEQaiIBEK0BRQRAQfiXLCECDAELQeyXKyEDQeyXKyABEK0BRQRAQYCYLCECDAELAn9B6QAgBWsgBUHpAEcNABogAi0AESIDQe8ARwRAQe8AIANrDAELQQAgAi0AEmsLRQRAQYiYLCECQdmqKiEDDAELAn9B7wAgBWsgBUHvAEcNABogAi0AESIDQfMARwRAQfMAIANrDAELQQAgAi0AEmsLRQRAQZCYLCECQar6KSEDDAELQfjtKiEDQfjtKiABEK0BRQRAQZiYLCECDAELQYHhKiEDQYHhKiABEK0BRQRAQaCYLCECDAELQYPmKyEDQYPmKyABEK0BRQRAQaiYLCECDAELQeXnKiEDQeXnKiABEK0BRQRAQbCYLCECDAELQZDMMygCACIDBEBBkMwzIQIDQCADIAEQakUEQCAAIAIQbSECDAULIAIoAgwhAyACQQxqIQIgAw0ACwsCQCAAIAECf0EUIAFBkuUpEGpFDQAaIAFBi9crEK0BRQRAIAAgAUEVEF0MBAtBFiABQbrkKhBqRQ0AGkEXIAFBgIMqEGpFDQAaQRggAUGTpyoQakUNABpBGSABQZztKxBqRQ0AGkEaIAFBq/MqEGpFDQAaQRsgAUHY6ikQakUNABpBHCABQYqRKxBqRQ0AGkEdIAFB2e4rEGpFDQAaQR4gAUGu4yoQakUNABpBHyABQdikKhBqRQ0AGkEgIAFBxr8rEGpFDQAaQSEgAUHQ6SsQakUNABpBIiABQf2DKhBqRQ0AGkEjIAFBh+UrEGpFDQAaQSQgAUHD1CkQakUNABogAUGCvikQag0BQSULEF0gBCABNgIAIABB6ocqIAQQWwwCCyAEIAE2AhAgAEH6iiogBEEQahCcAUEAIQIMAgsgACADIAIoAgQQXQtBASECCyAEQSBqJAAgAgtNAQJ/IAEtAAAhAgJAIAAtAAAiA0UNACACIANHDQADQCABLQABIQIgAC0AASIDRQ0BIAFBAWohASAAQQFqIQAgAiADRg0ACwsgAyACawsVACAAQZLlKUGg6yxBgPAsEKMBQQELLwEBfyMAQRBrIgEkACABQgA3AwggAEGL1ytBsI0tIAFBCGoQowEgAUEQaiQAQQELkgIBAX8jAEFAaiIBJABBkIg0QQE6AAAgAUIANwMIIAFC//////ABNwMwIAFC//////D///8PNwMoIAFCrvX6//D///8PNwMgIAFCv/eAxcDemucNNwMYIAFCwYLZgdCZ+pINNwMQQdCHNCABQRBqEIEEQaCINEEBOgAAQZSINEHQhzQ2AgAgAUL/////8AE3AzAgAUL/////8P///w83AyggAUL/////8P///w83AyAgAUL/////8P///w83AxggAUKv+P//8P3//w83AxBB8Ic0IAFBEGoQgQRBnIg0QQE6AABBmIg0QfCHNDYCACAAQZfwK0EAEFogAEG65CpBsIItIAFBCGoQowEgAUFAayQAQQELLwEBfyMAQRBrIgEkACABQgA3AwggAEGAgypB8IQtIAFBCGoQowEgAUEQaiQAQQELOgEBfyMAQRBrIgEkACAAQZOnKkHw9CxBgPYsEKMBIAFBpPErNgIAIABB4YUqIAEQWiABQRBqJABBAQsVACAAQZztK0Gg9yxBgPgsEKMBQQELFQAgAEGr8ypBwPksQfD7LBCjAUEBCxUAIABB2OopQYCILUHgiC0QowFBAQsVACAAQYqRK0HAiS1BgIotEKMBQQELFQAgAEHZ7itBgP4sQcD+LBCjAUEBCxUAIABBruMqQYCALUHwgC0QowFBAQsvAQF/IwBBEGsiASQAIAFCADcDCCAAQdikKkGghS0gAUEIahCjASABQRBqJABBAQsvAQF/IwBBEGsiASQAIAFCADcDCCAAQca/K0HQhy0gAUEIahCjASABQRBqJABBAQsVACAAQdbpK0HAjC1BoI0tEKMBQQELLwEBfyMAQRBrIgEkACABQgA3AwggAEH9gypBgI4tIAFBCGoQowEgAUEQaiQAQQELLwEBfyMAQRBrIgEkACABQgA3AwggAEGH5StBkIQtIAFBCGoQowEgAUEQaiQAQQELLwEBfyMAQRBrIgEkACABQgA3AwggAEHD1ClBwOcsIAFBCGoQowEgAUEQaiQAQQELLwEBfyMAQRBrIgEkACABQgA3AwggAEGCvilB0KkvIAFBCGoQowEgAUEQaiQAQQELyQEBA38jAEEQayICJAACfyAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELIAEtAAQiAEETRgRAIAEqAgD8AAwBCyAAQQNGBEAgASgCALL8AAwBCwJAIABBD3FBBEcNACABKAIAIgBBEGogAkEIahDBASEDIAMgAC0AByIBQf8BRgR/IAAoAgwFIAELQQFqRw0AIAIoAggiALIgAL4gAi0ADEEDRhv8AAwBC0EBCyEAQZCWNCgCACAANgKsBCACQRBqJABBAAuxBQIIfwF9IwBB0AFrIgYkACAAIQMDQCADIgJBAWohAyACLQAAIgRB0a4vai0AAEEIcQ0AC0EBIQUCQAJAAkAgBEEraw4DAAIBAgtBACEFCyADLQAAIQQgAyECIAUhCAsCfyABAn8CQAJAAkAgBEH/AXEiA0EwRw0AIAItAAFBIHJB+ABHDQAgAkECaiEEQQAhBSACLQACIgJB0a4vai0AAEEQcUUEQCAEIQMMAgsDQCAFQQR0IALAIgJBMGsgAkEgckHXAGsgAkHRri9qLQAAQQJxG2ohBUEBIQcgBC0AASECIARBAWoiAyEEIAJB0a4vai0AAEEQcQ0ACwwBCyADQdGuL2otAABBAnFFBEAgAiEDQQAhBQwBCyAIQQdqIQlBACEFA0AgBMBBMGshAyAFQcyZs+YATwRAIAVBzJmz5gBHDQMgAyAJSg0DC0EBIQcgAyAFQQpsaiEFIAItAAEhBCACQQFqIgMhAiAEQdGuL2otAABBAnENAAsLA0AgAyICQQFqIQMgAi0AACIEQdGuL2otAABBCHENAAsgBCAHRXINAEEAIAVrIAUgCBu+IQpBAwwBCyAAQejeKxDVBiIDBEBBACADLQAAQd8BcUHOAEYNAhoLIAAgBhCgBSEKAkAgACAGKAIAIgNHBEADQCADIgJBAWohAyACLQAAIgRB0a4vai0AAEEIcQ0ACyAERQ0BCwJAAkAgAEEuEJ4BIgJFDQAgABAnQcgBSw0AIAYgABD5ASIFIAIgAGtqQS46AAAgBSAGQcwBahCgBSEKIAUgBigCzAEiAkYNAANAIAIiA0EBaiECIAMtAAAiBEHRri9qLQAAQQhxDQALIARFDQELQQAMAwsgACADIAVraiECC0ETCzoABCABIAo4AgAgAiAAa0EBagshAiAGQdABaiQAIAILhQEBBn8gAS0AACICRQRAQQAPCyABQQFqIQcDQAJAQX8hBiAEIAdqLAAAIgVFDQAgAsBBAnRBgNksaigCACICQQBIDQAgBUECdEGA2SxqKAIAIgVBAEgNACAAIANqIAJBBHQgBXI6AAAgA0EBaiIDIQYgASAEQQJqIgRqLQAAIgINAQsLIAYL+ysBIX8gACABKAIsIhkgASgCKCIPIAEoAhQiESARIAEoAjQiGiAPIBEgASgCHCIUIAEoAiQiGyABKAIgIhIgGyABKAIYIhYgFCAZIBYgASgCBCITIAAoAhAiH2ogACgCCCIgQQp3IgUgACgCBCIdcyABKAIAIhcgACgCACIhIAAoAgwiBCAdICBzc2pqQQt3IB9qIhBzakEOdyAEaiIOQQp3IgJqIAEoAhAiFSAdQQp3IgdqIAEoAggiGCAEaiAHIBBzIA5zakEPdyAFaiIDIAJzIAEoAgwiHCAFaiAOIBBBCnciEHMgA3NqQQx3IAdqIg5zakEFdyAQaiIGIA5BCnciCHMgECARaiAOIANBCnciEHMgBnNqQQh3IAJqIg5zakEHdyAQaiICQQp3IgNqIBsgBkEKdyIGaiAQIBRqIAYgDnMgAnNqQQl3IAhqIhAgA3MgCCASaiACIA5BCnciDnMgEHNqQQt3IAZqIgJzakENdyAOaiIGIAJBCnciCHMgDiAPaiACIBBBCnciCXMgBnNqQQ53IANqIgJzakEPdyAJaiIDQQp3IgpqIAJBCnciCyABKAI8IhBqIAggGmogCSABKAIwIg5qIAIgBkEKdyIGcyADc2pBBncgCGoiAiADIAtzc2pBB3cgBmoiAyACQQp3IghzIAYgASgCOCIBaiACIApzIANzakEJdyALaiIGc2pBCHcgCmoiAiAGcSADQQp3IgkgAkF/c3FyakGZ84nUBWpBB3cgCGoiA0EKdyIKaiAPIAJBCnciC2ogEyAGQQp3IgZqIAkgGmogCCAVaiACIANxIAYgA0F/c3FyakGZ84nUBWpBBncgCWoiAiADcSALIAJBf3NxcmpBmfOJ1AVqQQh3IAZqIgMgAnEgCiADQX9zcXJqQZnzidQFakENdyALaiIGIANxIAJBCnciCCAGQX9zcXJqQZnzidQFakELdyAKaiICIAZxIANBCnciCSACQX9zcXJqQZnzidQFakEJdyAIaiIDQQp3IgpqIBcgAkEKdyILaiAOIAZBCnciBmogCSAcaiAIIBBqIAIgA3EgBiADQX9zcXJqQZnzidQFakEHdyAJaiICIANxIAsgAkF/c3FyakGZ84nUBWpBD3cgBmoiAyACcSAKIANBf3NxcmpBmfOJ1AVqQQd3IAtqIgYgA3EgAkEKdyIIIAZBf3NxcmpBmfOJ1AVqQQx3IApqIgIgBnEgA0EKdyIJIAJBf3NxcmpBmfOJ1AVqQQ93IAhqIgNBCnciCmogGSACQQp3IgtqIAEgBkEKdyIGaiAJIBhqIAggEWogAiADcSAGIANBf3NxcmpBmfOJ1AVqQQl3IAlqIgIgA3EgCyACQX9zcXJqQZnzidQFakELdyAGaiIDIAJxIAogA0F/c3FyakGZ84nUBWpBB3cgC2oiBiADcSACQQp3IgIgBkF/c3FyakGZ84nUBWpBDXcgCmoiCCAGcSADQQp3IgMgCEF/cyILcXJqQZnzidQFakEMdyACaiIJQQp3IgpqIBUgCEEKdyIIaiABIAZBCnciBmogAyAPaiACIBxqIAkgC3IgBnNqQaHX5/YGakELdyADaiICIAlBf3NyIAhzakGh1+f2BmpBDXcgBmoiAyACQX9zciAKc2pBodfn9gZqQQZ3IAhqIgYgA0F/c3IgAkEKdyICc2pBodfn9gZqQQd3IApqIgggBkF/c3IgA0EKdyIDc2pBodfn9gZqQQ53IAJqIglBCnciCmogGCAIQQp3IgtqIBMgBkEKdyIGaiADIBJqIAIgEGogCSAIQX9zciAGc2pBodfn9gZqQQl3IANqIgIgCUF/c3IgC3NqQaHX5/YGakENdyAGaiIDIAJBf3NyIApzakGh1+f2BmpBD3cgC2oiBiADQX9zciACQQp3IgJzakGh1+f2BmpBDncgCmoiCCAGQX9zciADQQp3IgNzakGh1+f2BmpBCHcgAmoiCUEKdyIKaiAZIAhBCnciC2ogGiAGQQp3IgZqIAMgFmogAiAXaiAJIAhBf3NyIAZzakGh1+f2BmpBDXcgA2oiAiAJQX9zciALc2pBodfn9gZqQQZ3IAZqIgMgAkF/c3IgCnNqQaHX5/YGakEFdyALaiIGIANBf3NyIAJBCnciCHNqQaHX5/YGakEMdyAKaiIJIAZBf3NyIANBCnciCnNqQaHX5/YGakEHdyAIaiILQQp3IgJqIBkgCUEKdyIDaiAbIAZBCnciBmogCiATaiAIIA5qIAsgCUF/c3IgBnNqQaHX5/YGakEFdyAKaiIIIANxIAsgA0F/c3FyakGkhpGHB2tBC3cgBmoiBiACcSAIIAJBf3NxcmpBpIaRhwdrQQx3IANqIgkgCEEKdyIDcSAGIANBf3NxcmpBpIaRhwdrQQ53IAJqIgogBkEKdyICcSAJIAJBf3NxcmpBpIaRhwdrQQ93IANqIgtBCnciBmogFSAKQQp3IghqIA4gCUEKdyIJaiACIBJqIAMgF2ogCSALcSAKIAlBf3NxcmpBpIaRhwdrQQ53IAJqIgIgCHEgCyAIQX9zcXJqQaSGkYcHa0EPdyAJaiIDIAZxIAIgBkF/c3FyakGkhpGHB2tBCXcgCGoiCSACQQp3IgJxIAMgAkF/c3FyakGkhpGHB2tBCHcgBmoiCiADQQp3IgNxIAkgA0F/c3FyakGkhpGHB2tBCXcgAmoiC0EKdyIGaiABIApBCnciCGogECAJQQp3IglqIAMgFGogAiAcaiAJIAtxIAogCUF/c3FyakGkhpGHB2tBDncgA2oiAiAIcSALIAhBf3NxcmpBpIaRhwdrQQV3IAlqIgMgBnEgAiAGQX9zcXJqQaSGkYcHa0EGdyAIaiIIIAJBCnciAnEgAyACQX9zcXJqQaSGkYcHa0EIdyAGaiIJIANBCnciA3EgCCADQX9zcXJqQaSGkYcHa0EGdyACaiIKQQp3IgtqIBcgCUEKdyIGaiAVIAhBCnciCGogAyAYaiACIBZqIAggCnEgCSAIQX9zcXJqQaSGkYcHa0EFdyADaiICIAZxIAogBkF/c3FyakGkhpGHB2tBDHcgCGoiAyACIAtBf3Nyc2pBsoWwtQVrQQl3IAZqIgYgAyACQQp3IgJBf3Nyc2pBsoWwtQVrQQ93IAtqIgggBiADQQp3IgNBf3Nyc2pBsoWwtQVrQQV3IAJqIglBCnciCmogGCAIQQp3IgtqIA4gBkEKdyIGaiADIBRqIAIgG2ogCSAIIAZBf3Nyc2pBsoWwtQVrQQt3IANqIgIgCSALQX9zcnNqQbKFsLUFa0EGdyAGaiIDIAIgCkF/c3JzakGyhbC1BWtBCHcgC2oiBiADIAJBCnciAkF/c3JzakGyhbC1BWtBDXcgCmoiCCAGIANBCnciA0F/c3JzakGyhbC1BWtBDHcgAmoiCUEKdyIKaiASIAhBCnciC2ogHCAGQQp3IgZqIAMgE2ogASACaiAJIAggBkF/c3JzakGyhbC1BWtBBXcgA2oiAiAJIAtBf3Nyc2pBsoWwtQVrQQx3IAZqIgMgAiAKQX9zcnNqQbKFsLUFa0ENdyALaiIGIAMgAkEKdyIIQX9zcnNqQbKFsLUFa0EOdyAKaiIJIAYgA0EKdyIKQX9zcnNqQbKFsLUFa0ELdyAIaiILQQp3IiIgBGogGyAXIBUgFyAZIBwgEyAQIBcgDiAQIBggISAgIARBf3NyIB1zaiARakHml4qFBWpBCHcgH2oiAkEKdyIDaiAHIBtqIAUgF2ogBCAUaiAfIAIgHSAFQX9zcnNqIAFqQeaXioUFakEJdyAEaiIEIAIgB0F/c3JzakHml4qFBWpBCXcgBWoiBSAEIANBf3Nyc2pB5peKhQVqQQt3IAdqIgcgBSAEQQp3IgRBf3Nyc2pB5peKhQVqQQ13IANqIgIgByAFQQp3IgVBf3Nyc2pB5peKhQVqQQ93IARqIgNBCnciDGogFiACQQp3Ig1qIBogB0EKdyIHaiAFIBVqIAQgGWogAyACIAdBf3Nyc2pB5peKhQVqQQ93IAVqIgQgAyANQX9zcnNqQeaXioUFakEFdyAHaiIFIAQgDEF/c3JzakHml4qFBWpBB3cgDWoiByAFIARBCnciBEF/c3JzakHml4qFBWpBB3cgDGoiAiAHIAVBCnciBUF/c3JzakHml4qFBWpBCHcgBGoiA0EKdyIMaiAcIAJBCnciDWogDyAHQQp3IgdqIAUgE2ogBCASaiADIAIgB0F/c3JzakHml4qFBWpBC3cgBWoiBCADIA1Bf3Nyc2pB5peKhQVqQQ53IAdqIgUgBCAMQX9zcnNqQeaXioUFakEOdyANaiIHIAUgBEEKdyICQX9zcnNqQeaXioUFakEMdyAMaiIDIAcgBUEKdyIMQX9zcnNqQeaXioUFakEGdyACaiINQQp3IgRqIBQgA0EKdyIFaiAcIAdBCnciB2ogDCAZaiACIBZqIAcgDXEgAyAHQX9zcXJqQaSit+IFakEJdyAMaiICIAVxIA0gBUF/c3FyakGkorfiBWpBDXcgB2oiByAEcSACIARBf3NxcmpBpKK34gVqQQ93IAVqIgMgAkEKdyIFcSAHIAVBf3NxcmpBpKK34gVqQQd3IARqIgwgB0EKdyIEcSADIARBf3NxcmpBpKK34gVqQQx3IAVqIg1BCnciB2ogASAMQQp3IgJqIA8gA0EKdyIDaiAEIBFqIAUgGmogAyANcSAMIANBf3NxcmpBpKK34gVqQQh3IARqIgQgAnEgDSACQX9zcXJqQaSit+IFakEJdyADaiIFIAdxIAQgB0F/c3FyakGkorfiBWpBC3cgAmoiAyAEQQp3IgRxIAUgBEF/c3FyakGkorfiBWpBB3cgB2oiDCAFQQp3IgVxIAMgBUF/c3FyakGkorfiBWpBB3cgBGoiDUEKdyIHaiAbIAxBCnciAmogFSADQQp3IgNqIAUgDmogBCASaiADIA1xIAwgA0F/c3FyakGkorfiBWpBDHcgBWoiBCACcSANIAJBf3NxcmpBpKK34gVqQQd3IANqIgUgB3EgBCAHQX9zcXJqQaSit+IFakEGdyACaiICIARBCnciBHEgBSAEQX9zcXJqQaSit+IFakEPdyAHaiIDIAVBCnciBXEgAiAFQX9zcXJqQaSit+IFakENdyAEaiIMQQp3Ig1qIBMgA0EKdyIeaiARIAJBCnciB2ogBSAQaiAEIBhqIAcgDHEgAyAHQX9zcXJqQaSit+IFakELdyAFaiIEIAxBf3NyIB5zakHz/cDrBmpBCXcgB2oiBSAEQX9zciANc2pB8/3A6wZqQQd3IB5qIgcgBUF/c3IgBEEKdyIEc2pB8/3A6wZqQQ93IA1qIgIgB0F/c3IgBUEKdyIFc2pB8/3A6wZqQQt3IARqIgNBCnciDGogGyACQQp3Ig1qIBYgB0EKdyIHaiABIAVqIAQgFGogAyACQX9zciAHc2pB8/3A6wZqQQh3IAVqIgQgA0F/c3IgDXNqQfP9wOsGakEGdyAHaiIFIARBf3NyIAxzakHz/cDrBmpBBncgDWoiByAFQX9zciAEQQp3IgRzakHz/cDrBmpBDncgDGoiAiAHQX9zciAFQQp3IgVzakHz/cDrBmpBDHcgBGoiA0EKdyIMaiAPIAJBCnciDWogGCAHQQp3IgdqIAUgDmogBCASaiADIAJBf3NyIAdzakHz/cDrBmpBDXcgBWoiBCADQX9zciANc2pB8/3A6wZqQQV3IAdqIgUgBEF/c3IgDHNqQfP9wOsGakEOdyANaiIHIAVBf3NyIARBCnciBHNqQfP9wOsGakENdyAMaiICIAdBf3NyIAVBCnciBXNqQfP9wOsGakENdyAEaiIDQQp3IgxqIBYgAkEKdyINaiASIAdBCnciB2ogBSAaaiAEIBVqIAMgAkF/c3IgB3NqQfP9wOsGakEHdyAFaiICIANBf3NyIA1zakHz/cDrBmpBBXcgB2oiBCACcSAMIARBf3NxcmpB6e210wdqQQ93IA1qIgUgBHEgAkEKdyICIAVBf3NxcmpB6e210wdqQQV3IAxqIgcgBXEgBEEKdyIDIAdBf3NxcmpB6e210wdqQQh3IAJqIgRBCnciDGogECAHQQp3Ig1qIBkgBUEKdyIeaiADIBxqIAIgE2ogBCAHcSAeIARBf3NxcmpB6e210wdqQQt3IANqIgUgBHEgDSAFQX9zcXJqQenttdMHakEOdyAeaiIEIAVxIAwgBEF/c3FyakHp7bXTB2pBDncgDWoiByAEcSAFQQp3IgIgB0F/c3FyakHp7bXTB2pBBncgDGoiBSAHcSAEQQp3IgMgBUF/c3FyakHp7bXTB2pBDncgAmoiBEEKdyIMaiAaIAVBCnciDWogGCAHQQp3IgdqIAMgDmogAiARaiAEIAVxIAcgBEF/c3FyakHp7bXTB2pBBncgA2oiBSAEcSANIAVBf3NxcmpB6e210wdqQQl3IAdqIgQgBXEgDCAEQX9zcXJqQenttdMHakEMdyANaiIHIARxIAVBCnciAiAHQX9zcXJqQenttdMHakEJdyAMaiIFIAdxIARBCnciAyAFQX9zcXJqQenttdMHakEMdyACaiIEQQp3IgwgEGogASAHQQp3Ig1qIAMgD2ogAiAUaiAEIAVxIA0gBEF/c3FyakHp7bXTB2pBBXcgA2oiByAEcSAFQQp3IgUgB0F/c3FyakHp7bXTB2pBD3cgDWoiBCAHcSAMIARBf3NxcmpB6e210wdqQQh3IAVqIgIgBEEKdyIDcyAFIA5qIAQgB0EKdyIOcyACc2pBCHcgDGoiBHNqQQV3IA5qIgVBCnciByASaiACQQp3IhIgE2ogDiAPaiAEIBJzIAVzakEMdyADaiIPIAdzIAMgFWogBSAEQQp3IhNzIA9zakEJdyASaiISc2pBDHcgE2oiFSASQQp3Ig5zIBEgE2ogEiAPQQp3Ig9zIBVzakEFdyAHaiIRc2pBDncgD2oiEkEKdyITIAFqIBVBCnciASAYaiAPIBRqIAEgEXMgEnNqQQZ3IA5qIg8gE3MgDiAWaiASIBFBCnciEXMgD3NqQQh3IAFqIgFzakENdyARaiIUIAFBCnciEnMgESAaaiABIA9BCnciD3MgFHNqQQZ3IBNqIgFzakEFdyAPaiIRQQp3IhNqNgIIIAAgDyAXaiABIBRBCnciD3MgEXNqQQ93IBJqIhRBCnciGCAgIAggFmogCyAJIAZBCnciFkF/c3JzakGyhbC1BWtBCHcgCmoiFUEKd2pqNgIEIAAgHSAKIBBqIBUgCyAJQQp3IhdBf3Nyc2pBsoWwtQVrQQV3IBZqIhBqIBIgHGogESABQQp3IgFzIBRzakENdyAPaiIRQQp3ajYCACAAIA8gG2ogEyAUcyARc2pBC3cgAWoiDyAXICFqIBYgGmogECAVICJBf3Nyc2pBsoWwtQVrQQZ3amo2AhAgACAXIB9qIBNqIAEgGWogESAYcyAPc2pBC3dqNgIMC+kIAQ1/IwBBwAFrIgskAAJAIAQQJyIJQdsAa0Gtf0kNACAEIAlqIQUCQANAIAUgCkF/c2otAABBMUYNASAKQQFqIgogCUcNAAsgCSEKCyAKQQZJDQAgCSAKQQFqIgVNDQBBASAJIAVrIgwgDEEBTRshDkEBIQUDQCAEIAdqLAAAIgZBIWtB/wFxQd0ASw0BAkAgBkHhAGtB/wFxQRpJBEBBASEQDAELIAZBIHIgBiAGQcEAa0H/AXFBGkkiCBshBkEBIA8gCBshDwsgByALaiAGOgAAIAVBA3RBH3VB3eeI6gNxIAVBBHRBH3VB+rOE9QFxIAVBBnRBH3VBsq+p2wNxIAVBBXQiCEHg////A3FzIAhBH3VB7ZzCsgJxc3NzIhEgBUECdEEfdUGzxdHQAnFzIgggBkEFdnMhBSAHQQFqIgcgDkcNAAtBACEGIAsgDmpBADoAACARQQN0QR91Qd3niOoDcSAIQQR0QR91QfqzhPUBcSAFQQZ0QR91QbKvqdsDcSAFQQV0IgVB4P///wNxcyAFQR91Qe2cwrICcXNzc0GzxdHQAkEAIAhBgICAgAJPG3MhBQNAIAQgBmotAABBH3EgBUECdEEfdUGzxdHQAnEgBUEDdEEfdUHd54jqA3EgBUEEdEEfdUH6s4T1AXEgBUEGdEEfdUGyr6nbA3EgBUEFdCIHQeD///8DcXMgB0EfdUHtnMKyAnFzc3NzcyEFIAZBAWoiBiAMRw0ACyAJIAxBAWoiB0sEQCALQeAAaiAMQX9zaiENA0BBfyEGIAQgByIIaiwAACIHQQBOBEAgB0HA5ixqLAAAIQYLIAZBf0YEQEEAIQ0MAwsgB0HBAGtB/wFxQRpJIQ4gB0HhAGtB/wFxQRpJIQcgBUECdEEfdUGzxdHQAnEgBUEDdEEfdUHd54jqA3EgBUEEdEEfdUH6s4T1AXEgBUEGdEEfdUGyr6nbA3EgBUEFdCIRQeD///8DcXMgEUEfdUHtnMKyAnFzc3NzIQUgCSAMQQdqSwRAIAggDWogBjoAAAtBASAPIA4bIQ9BASAQIAcbIRAgBSAGcyEFIAghDCAIQQFqIgcgCUcNAAsLQQAhDSAQQQAgDxsNACAFQaPhoN4CRyAFQQFHcQ0AIApByABrQb9/SQ0AIAMgC0HUABDFAQ0AIAstAGAiByIGQRBLDQAgBkUgBUEBR3ENACAHQf8BcUEAIAVBAUYbDQAgAkEANgIAIAtB4ABqQQFyIQhBACEDQQAhBCAKQQdrIgkEQANAIAgtAAAgBEEFdHIhBAJAIANBA04EQCACIAIoAgAiCkEBajYCACABIApqIAQgA0EDayIDdjoAAAwBCyADQQVqIQMLIAhBAWohCCAJQQFrIgkNAAsLIARBCCADa3RB/wFxRSADQQVIcUUNACACKAIAIgVBKWtBWUkNAAJAIAdB/wFxIgoNACAFQRRrDg0AAQEBAQEBAQEBAQEAAQsgACAKNgIAQQEhDQsgC0HAAWokACANC2ABAn8gAkUEQEEADwsgAC0AACIDBH8CQANAIAMgAS0AACIERw0BIARFDQEgAkEBayICRQ0BIAFBAWohASAALQABIQMgAEEBaiEAIAMNAAtBACEDCyADBUEACyABLQAAawuWBwIHfwJ+IwBBIGshDCAGQQBKIQkCfyAHQT9LBEBBAQwBCyADQgBTBEBCACADfSEDQS0hC0EADAELIAdBAnEEQEErIQtBAAwBCyAHQQN0QSBxIQsgB0EEcUULIQ0gBkEAIAkbIQhBgOIrQfDTMSAHQSBxGyEJIAStIQ8DQAJAIAwgCiIGaiAJIAMgAyAPgCIQIA9+fadqLQAAOgAAIAZBAWohCiADIA9UDQAgECEDIAZBFUkNAQsLIAwgBiAKIApBFkYbIgpqQQA6AAAgCCAKayIGQQAgBkEAShsiBCAFIA1FayAIIAogCCAKShtrIgZBACAGQQBKGyIGIAQgBksbIQUCQEEAQQAgBiAHQRBxIg4bIgZrIAYgB0EBcRsiCEEATA0AIAEoAgAhBiAIQQFxBH8gASACIAZLBH8gACAGakEgOgAAIAEoAgAFIAYLQQFqIgY2AgAgCEEBawUgCAshCSAIQQFGIQdBACEIIAcNAANAIAEgAiAGSwR/IAAgBmpBIDoAACABKAIABSAGC0EBaiIGNgIAIAEgAiAGSwR/IAAgBmpBIDoAACABKAIABSAGC0EBaiIGNgIAIAlBAkohByAJQQJrIQkgBw0ACwsgBSAEIA4bIQcgDUUEQCABIAIgASgCACIGSwR/IAAgBmogCzoAACABKAIABSAGC0EBajYCAAsCQCAHRQ0AIAEoAgAhBiAHQQFxBH8gASACIAZLBH8gACAGakEwOgAAIAEoAgAFIAYLQQFqIgY2AgAgB0EBawUgBwshCSAHQQFGDQADQCABIAIgBksEfyAAIAZqQTA6AAAgASgCAAUgBgtBAWoiBjYCACABIAIgBksEfyAAIAZqQTA6AAAgASgCAAUgBgtBAWoiBjYCACAJQQJKIQcgCUECayEJIAcNAAsLIAoEQCABKAIAIQYDQCAKQQFrIQkgASACIAZLBH8gACAGaiAJIAxqLQAAOgAAIAEoAgAFIAYLQQFqIgY2AgAgCkEBSiEHIAkhCiAHDQALCwJAIAhBAE4NACABKAIAIQYgCEEBcQRAIAEgAiAGSwR/IAAgBmpBIDoAACABKAIABSAGC0EBaiIGNgIAIAhBAWoiCEUNAQsDQCABIAIgBksEfyAAIAZqQSA6AAAgASgCAAUgBgtBAWoiBjYCACABIAIgBksEfyAAIAZqQSA6AAAgASgCAAUgBgtBAWoiBjYCACAIQQJqIggNAAsLC7gCAgR/A34jAEEwayICJAAgAkGU6ys2AiAgAEH5hiogAkEgahCbASAAQQEQyAEiAwRAAkAgAygCACIBRQRADAELIAMoAggiBDAAACIFQgBZDQBBCiABIAFBCk8brSEHQgAhBQNAIAQgBqdqLAAAIgFB/wBxrSAGQgd+hiAFhCEFIAFBAE4NASAGQgF8IgYgB1INAAsLIAMQmgEgACgCDCIBQRM6AAQgASAFtTgCACAAIAAoAgxBCGo2AgwgAEEEEIYBIgEoAgggBUIYiDwAACABKAIIIAVCEIg8AAEgASgCCCAFQgiIPAACIAEoAgggBTwAAyABQQQ2AgAgAkGU6ys2AhAgAEHghyogAkEQahCbASACQTBqJABBAg8LIAJBs6kpNgIEIAJBlOsrNgIAIABB/IgqIAIQbAAL4wcBBX8jAEEwayIEJAACQCABQQBKBEAgACgCFCgCACABQQN0aiICIAAoAgxJDQEgACgCEEEsaiECDAELIAAoAgwgAUEDdGohAgsCfwJAIAItAARBD3EiAw0AIAIgACgCEEEsakcNAEEADAELIANBAWoLQQJ0QfCxL2ooAgAhAwJAAkACQAJAIAAgAUHB4ikQ3AEiAgRAIAIoAgAiA0GBgPoBTgRAIAQgAzYCJCAEIAE2AiAgAEHc/ykgBEEgahBuDAILIAIgAigCDEEBajYCDAwECwJAIAMQJ0EGSQ0AQfjtKiADQQYQxQEEQEGGoCogA0EGEMUBDQELAkAgAUEASgRAIAAoAhQoAgAgAUEDdGoiAiAAKAIMSQ0BIAAoAhBBLGohAgwBCyAAKAIMIAFBA3RqIQILIAItAARBD3FFBEBBACECIARBADYCLEG3kywhBQwECyAAIAEgBEEsahCIASIFRQ0CIAQoAiwiAkGBgPoBSQ0DIAQgAjYCACAAQfvCKSAEEG4MAQsgACABQbHwKhDcASICBEAgACACEN0BIgINBEEAIQIgAEGb4StBABBuDAQLIAAgAUGCkSsQ3AEiAgRAIAIoAgAhASAAQQQQmAEiAigCCCABNgAAIAJBBDYCAAwECyAAIAFBu+opENwBIgIEQCAAIAIqAgAQ3gEiAg0EQQAhAiAAQeTcK0EAEG4MBAsgACABQYunKhDcASIDBEAgACADKAIEEJgBIgJFBEBBACECIABBxt0rQQAQbgwFCyMAQYABayIAJAACQAJAIANBCGoiARC4AkUNACADQYABahC4AkUNACACKAIIQf8AOgAAIAIoAghB/wA6AAEgAigCCEEAOgADIAJBAjYCAAwBCyAAQUBrIAAgARC5AiACKAIIQQI6AAAgACgCAEGBgICAeHFBAUYEQCACKAIIQQM6AAALIAJBMTYCACACKAIIQQFqIABBQGsQugILIABBgAFqJAAMBAsgACABQZTtKxDcASIDBEAgACADKAIEEJgBIgJFBEBBACECIABB1+0rQQAQbgwFCyACIANBCGoQ3wEMBAsgACABEOABQQFqQQFNBEAgAEEBEJgBIgIoAghBADoAACACQQA2AgAMBAsgBCABNgIQIABBlMMpIARBEGoQbgtBACECDAILIAAgAUH47SoQ1AEACyAAIAIQmAEhAiAFLQAAIgNFDQAgAigCACIAIAIoAgQiASAAIAFKGyAAayEGQQAhAQNAIAEgBkYNASACKAIIIABqIAM6AAAgAiAAQQFqIgA2AgAgBSABQQFqIgFqLQAAIgMNAAsLIARBMGokACACC8MCAgR/A34jAEEwayICJAAgAkG+6ys2AiAgAEH5hiogAkEgahCbASAAQQEQyAEiAwRAAkAgAygCACIBRQ0AIAMoAggiBDAAACIGQgBZDQBBCiABIAFBCk8brSEHQgAhBgNAIAQgBadqLAAAIgFB/wBxrSAFQgd+hiAGhCEGIAFBAE4NASAFQgF8IgUgB1INAAsLIAMQmgEgACgCDCIBQRM6AAQgAUIAIAZCAYN9IAZCAYiFIgW0OAIAIAAgACgCDEEIajYCDCAAQQQQhgEiASgCCCAFQhiIPAAAIAEoAgggBUIQiDwAASABKAIIIAVCCIg8AAIgASgCCCAFPAADIAFBBDYCACACQb7rKzYCECAAQeCHKiACQRBqEJsBIAJBMGokAEECDwsgAkGzqSk2AgQgAkG+6ys2AgAgAEH8iCogAhBsAAvpAQECfwJAAkACQCABIAAiA3NBA3ENACABQQNxBEADQCADIAEtAAAiBDoAACAERQ0EIANBAWohAyABQQFqIgFBA3FBACACQQFrIgIbDQALIAJFDQILIAEtAABFDQIgAkEETwRAA0BBgIKECCABKAIAIgRrIARyQYCBgoR4cUGAgYKEeEcNAiADIAQ2AgAgA0EEaiEDIAFBBGohASACQQRrIgJBA0sNAAsLIAJFDQELA0AgAyABLQAAIgQ6AAAgBEUNAiADQQFqIQMgAUEBaiEBIAJBAWsiAg0ACwtBACECCyADQQAgAhAcIAAL0wIBBn8jAEHQAGsiASQAIAFBsv8qNgJAIABB+YYqIAFBQGsQmwFBkJY0KAIAIQMgAEEBEMgBIgQEQAJAIAMoAgQiBQRAIAMoAgggBCgCACICIAMoAgwiBmpJBEAgAEGxmSpBABBuIAQoAgAhAgsgAgRAIAUgBmogBCgCCCAC/AoAAAsgAyADKAIMIAQoAgBqNgIMDAELIAQoAgghBSAEKAIAIgMhBiMAQRBrIgIkACACIAY2AgwgAiAFNgIIQQEgAkEIakEBIAJBBGoQChDTDCEGIAIoAgQhBSACQRBqJABBfyAFIAYbQQBODQAgASADNgIwQeyJLCABQTBqEFUgAUHQ+zMoAgAQJjYCIEGziiwgAUEgahBVCyAEEJoBIAFBsv8qNgIQIABB4IcqIAFBEGoQmwEgAUHQAGokAEEADwsgAUGRvyk2AgAgAEGRjCogARBsAAu5AgEGfyMAQUBqIgIkACACQbnUKTYCMCAAQfmGKiACQTBqEJsBQZCWNCgCACEDAkACQCAAQQEQyAEiAQRAIAMoAgQiBEUNASADKAIIIAMoAgwiBiABKAIAIgVqQQFqSQRAIABBsZkqQQAQbiABKAIAIQULIAQgBmohBCAFBEAgBCABKAIIIAX8CgAACyAEIAEoAgBqQQo6AAAgBCABKAIAakEAOgABIAMgASgCACADKAIMakEBajYCDAwCCyACQZG/KTYCACAAQZGMKiACEGwACyABKAIIIAEoAgBqQQo6AAAgASgCCCABKAIAakEAOgABIAJB8AA7AD4gAiABKAIINgIgQYT2MyACQT5qIAJBIGoQABoLIAEQmgEgAkG51Ck2AhAgAEHghyogAkEQahCbASACQUBrJABBAAtkAQJ/IwBBIGsiASQAIAFBhI0qNgIQIABB+YYqIAFBEGoQmwEgAEEBEMgBIgJFBEAgAEGRvylBABBsAAsgACACEH8gAhCaASABQYSNKjYCACAAQeCHKiABEJsBIAFBIGokAEEAC2cBAn8jAEEgayIBJAAgAUHNpys2AhAgAEH5hiogAUEQahCbASAAQQEQyAEiAkUEQCAAQZG/KUEAEGwACyAAQQQgAhCZASACEJoBIAFBzacrNgIAIABB4IcqIAEQmwEgAUEgaiQAQQALZwECfyMAQSBrIgEkACABQbysKjYCECAAQfmGKiABQRBqEJsBIABBARDIASICRQRAIABBkb8pQQAQbAALIABBBSACEJkBIAIQmgEgAUG8rCo2AgAgAEHghyogARCbASABQSBqJABBAAtnAQJ/IwBBIGsiASQAIAFBnuopNgIQIABB+YYqIAFBEGoQmwEgAEEBEMgBIgJFBEAgAEGRvylBABBsAAsgAEEDIAIQmQEgAhCaASABQZ7qKTYCACAAQeCHKiABEJsBIAFBIGokAEEAC2cBAn8jAEEgayIBJAAgAUHT5yo2AhAgAEH5hiogAUEQahCbASAAQQEQyAEiAkUEQCAAQZG/KUEAEGwACyAAQQIgAhCZASACEJoBIAFB0+cqNgIAIABB4IcqIAEQmwEgAUEgaiQAQQALzwMBB38gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCACIBLQAHIgNB/wFGBEAgASgCDCEDCwJAIANFBEBBACEDQQAhAQwBCyABQRBqIQVB/wcgA0EBayIBIAFB/wdPGyIGQQFqIQdBACEBAkADQCABIAVqLAAAIgRBIEcgBEEOa0F7SXENASACQQFqIQIgASAGRiEEIAFBAWohASAERQ0ACyAHIgEhAgsgAkH//wNxIQQgAUH//wNxIgJB/wdLDQAgAiADTw0AIAIhAQNAIAEgBWosAAAiAkEgRyACQQ5rQXtJcUUEQCABQdD/M2pBADoAACABIQIMAgsgAUHQ/zNqIAIQ0wE6AAAgAUEBaiECIAFB/gdNBEAgAiIBIANJDQELCyACIQELIAFB//8DcUGACEcgAiADTXFFBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDEEBDwsgACAEQdD/M2ogAiAEaxCfAUEBDwsgAEEBQfjtKhDUAQALEwAgAEEgciAAIABBwQBrQRpJGwvhCAEGfyMAQRBrIgYkACAAKAIUIQMCQCABQQBKBEAgAygCACABQQN0aiIDIAAoAgxJDQEgACgCEEEsaiEDDAELIAFB2eHOfU4EQCAAKAIMIAFBA3RqIQMMAQsgAUHY4c59RgRAIAAoAhBBJGohAwwBCyADKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdjhzn0gAWtPBEAgA0EAIAFrQQN0akG48okTayEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLAkACQAJAAkACQAJAAn8CQAJAAkAgAy0ABEEPcSIEQQVrDgMAAgECCyADKAIAQRhqDAILIAMoAgBBDGoMAQsgACgCECAEQQJ0akH8AWoLKAIAIgNFDQAgACgCDCIEQcUAOgAEIAQgAzYCACAAIAAoAgxBCGo2AgwgAEHKkSsQWCAAKAIMIgNBEGsoAgAgA0EIaxCgASEDIAAgACgCDCIFQQhrIgc2AgxBACEEIAVBBGsgAy0ABEEPcQR/IAcgAygCADYCACADLQAEBSAECzoAACAAIAAoAgwiA0EIajYCDCADQQhrIQQgAy0ABEEPcSIIBEADQCAEKAIAIQUgBCADKAIANgIAIAQtAAQhByAEIAMtAAQ6AAQgAyAHOgAEIAMgBTYCACAEQQhqIgQgA0EIayIDSQ0ACyAAKAIMQQhrIgQgACgCJE0EQCAAIARBf0EAEF4hBAsgACAENgIMIAhBBEcNASAEQQhrIQVBACEDIARBBGstAABBD3FBA2sOAgIDBgsgACAEIAAoAiRNBH8gACAEQX9BABBeBSAECzYCDAsgACgCFCEEIAFBAEwNAiAEKAIAIAFBA3RqIgMgACgCDEkNAyAAKAIQQSxqIQMMAwsgACAFEFMgACgCECgCDEEASgRAIAAQVAsgACgCDEEIayEFCyAFKAIAQRBqIQMMAgsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAwwBCyABQdjhzn1GBEAgACgCEEEkaiEDDAELIAQoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSABa08EQCADQQAgAWtBA3RqQbjyiRNrIQMMAgsgACgCEEEsaiEDDAELIAAoAhBBLGohAwsgAy0ABEEPcUECRgRAQcjWKyEDDAELAkAgAUEASgRAIAQoAgAgAUEDdGoiAyAAKAIMSQ0BIAAoAhBBLGohAwwBCyABQdnhzn1OBEAgACgCDCABQQN0aiEDDAELIAFB2OHOfUYEQCAAKAIQQSRqIQMMAQsgBCgCACIDLQAEQeYARgRAIAMoAgAiAy0ABkHY4c59IAFrTwRAIANBACABa0EDdGpBuPKJE2shAwwCCyAAKAIQQSxqIQMMAQsgACgCEEEsaiEDCwJ/IAMtAARBD3EiBUUEQEEAIAMgACgCEEEsakYNARoLIAVBAWoLQQJ0QfCxL2ooAgAhAwsgBiADNgIEIAYgAjYCACAAIAEgAEHNhSogBhCmARCGAgALrAIBBH8gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgxJDQAgACgCEEEsaiEBCyABKAIAIgItAAciAUH/AUYEQCACKAIMIQELIAFFDQEgAkEQaiICIAFqQQFrIAIgARshAwNAAkAgAiwAACIEQSBGDQAgBEEOa0F6Sw0AA0AgAywAACIEQSBHIARBDmtBe0lxRQRAIANBAWshAyABQQFrIgENAQwFCwsgACACIAMgAmtBAWoQnwFBAQ8LIAJBAWohAiABQQFrIgENAAsMAQsgAEEBQfjtKhDUAQALIABBt5MsEFhBAQvIAgEFfyAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgxJDQAgACgCEEEsaiEBCyABKAIAIgEtAAciAkH/AUYEQCABKAIMIQILIAFBEGoiASACaiEDAkACQCACBEADQAJAIAEtAAAiBMBBCWtBBUkNACAEQSBrDggAAwMDAwMDAAMLIAFBAWohASACQQFrIgINAAsgAyEBCyADQQFrIQMMAQsgAyACQX9zaiEFA0ACQCADQQFrIgMtAAAiBMBBCWtBBUkNACAEQSBrDggAAgICAgICAAILIAJBAWsiAg0ACyAFIQMLIAAgASADIAFrQQFqEJ8BQQEPCyAAQQFB+O0qENQBAAutBwEKfyMAQdAgayICJAACfyAAKAIUKAIAQQhqIgEgACgCDCIHTwRAIAAoAhBBLGohAQsCQAJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiB0kNACAAKAIQQSxqIQELIAEoAgAiCS0AByIIQf8BRgRAIAkoAgwhCAsgCEUNASAJQRBqIgohBCAIIQMDQAJAIAQsAAAiAUEgRg0AIAFBDmtBe08NAANAIAQtAAAiAQRAIAFB2wBHIAFB+wBHcUUEQCACQf0AQd0AIAFB+wBGGzoAUEEBIQEgA0EBayIGBEADQCAEIgdBAWohBCAHLQABIQMCQAJAIAVB/wFxBEBBASEFIANBIkcNAiAHLQAAQdwARw0BIAdBAWstAABB3ABHDQIMAQsgA0EiRgRAQQEhBQwCCwJ/AkAgA0H7AEYiBQ0AIANB2wBGDQAgAQwBCyABQf8fTARAIAJB0ABqIAFqQf0AQd0AIAUbOgAACyABQQFqCyEFAkACQCADQSByQf0ARwRAIAUhAQwBCyAFQQFrIQEgBUGAIEoNAiACQdAAaiABai0AACIFIANHDQELIAENASAAIAogBCAKa0EBahCfASAHQQJqIQEgCCAJakERaiEDAkACQANAIAEsAAAiBEEgRyAEQQ5rQXtJcUUEQCABQQFqIQEgBkEBayIGDQEMAgsLIAEgBmohAwNAIAEtAAAEQCABIQMMAwsgAUEBaiEBIAZBAWsiBg0ACwtBACEGCyAAIAMgBhCfAUECDA0LIAIgAzYCRCACIAXANgJAIAIgBCAKa0EBajYCSCAAQaXCKSACQUBrEGwAC0EAIQULIAZBAWsiBg0ACwsgAEGhjypBABBuIAIgCDYCMCAAQd/CKSACQTBqEG4gAiABNgIgIABBlMcpIAJBIGoQbiABQQBKBEADQCACIAE2AhAgAiACQdAAaiABaiwAADYCFCAAQfuGLCACQRBqEG4gAUEBSyEEIAFBAWshASAEDQALCyAAQcGsK0EAEGwACyACIAHAIgE2AgQgAiABNgIAIABBzvYrIAIQWyAAKAIMQQA6AAQgACAAKAIMQQhqNgIMDAYLIARBAWohBCADQQFrIgMNAAsMAwsgBEEBaiEEIANBAWsiAw0ACwwBCyAAQQFB+O0qENQBAAsgB0EAOgAEIAAgACgCDEEIajYCDAtBAQshASACQdAgaiQAIAELYQEDfyAAQQBBABChAUHTrykhAgNAIAAoAgwiA0ETOgAEIAMgAUEBaiIBszgCACAAIAAoAgxBCGo2AgwgACACEFggAEF9EKIBIAFBAnRB4OgsaigCACECIAFBLEcNAAtBAQvSBAEIfyMAQRBrIgckACABKAIAIgVBAXQiA0EBciEEAkBBpIg0KAIAIgIEQAJ/AkAgAyACKAIUTw0AIAIoAgQiA0UNACACKAIYIARBAnRqIgYgBigCAEEBajYCACACIAIoAhxBAWo2AhwgAiACKAIgIARqNgIgIAIgAigCLCAEajYCLCACIAMoAgA2AgRBfyEEQQgMAQsgBBAqIgNFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKCAEajYCKEEsCyACaiICIAIoAgAgBGo2AgAgASgCACEFDAELIAQQKiEDCwJAIAVFDQAgASgCCCEEQQAhAiAFQQFHBEAgBUEBcSEIIAVBfnEhCQNAIAMgAkEBdGoiASACIARqLQAAIgZBD3FB8NMxai0AADoAASABIAZBBHZB8NMxai0AADoAACADIAJBAXIiAUEBdGoiBiABIARqLQAAIgFBD3FB8NMxai0AADoAASAGIAFBBHZB8NMxai0AADoAACACQQJqIgIgCUcNAAsgCEUNAQsgAyACQQF0aiIBIAIgBGotAAAiAkEPcUHw0zFqLQAAOgABIAEgAkEEdkHw0zFqLQAAOgAACyADIAVBAXRqQQA6AAAgACADEFgCQAJAQaSINCgCACICRQ0AIAcgAzYCDCACKAIAIgQgBygCDEsNACAHKAIMIAQgAigCEGpPDQAgAyACKAIENgIAIAIgAzYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIANBACAC/AsADAELIAMQKwsgB0EQaiQAC+0BAQN/AkAgACgCECIEKAIEQQBBByACQQN0QRhqQRAgAhsgAWoiBSAEKAIAEQIAIgNFBEAgAEEAQQcgBRCDBiIDRQ0BCyAEIAQoAgwgBWo2AgwgBC0AOCEFIANBBzoABCADIAVBGHE6AAUgAyAEKAJENgIAIAQgAzYCRCADQQA2AgwgAyACOwEGIAMgATYCCCACBEAgA0EAOgAcCyAAKAIMIgRBxwA6AAQgBCADNgIAIAAgACgCDEEIajYCDCAAKAIQKAIMQQBKBEAgABBUCyADIAMvAQYiBEEDdEEYakEQIAQbag8LIABBBBCEBgALwQMBBH8CQCABQQBKBEAgACgCFCgCAEEIaiIBIAAoAgwiAkkNASAAKAIQQSxqIQEMAQsgACgCDCICIAFBA3RqIQELIAJBBGstAABBD3EEfyACQQhrKAIABUEACyECAkACQAJAAkAgAS0ABEEPcSIDQQVrDgMAAgECCyABKAIAIAI2AhggAkUNAgJAIAEoAgAiAy0ABSIFQSBxRQ0AIAItAAVBGHFFDQACQCAAKAIQIgQtADlBAk0EQCAEIAIQjgYgAy0ABUEGcUUNASACIAItAAVB+AFxQQJyOgAFDAELIAQtADoNACADIAQtADhBGHEgBUHHAXFyOgAFCyABKAIAIQMLIAAgAyACEI8GDAILIAEoAgAgAjYCDCACRQ0BAkAgASgCACIDLQAFIgVBIHFFDQAgAi0ABUEYcUUNAAJAIAAoAhAiBC0AOUECTQRAIAQgAhCOBiADLQAFQQZxRQ0BIAIgAi0ABUH4AXFBAnI6AAUMAQsgBC0AOg0AIAMgBC0AOEEYcSAFQccBcXI6AAULIAEoAgAhAwsgACADIAIQjwYMAQsgACgCECADQQJ0aiACNgL8AQsgACAAKAIMQQhrNgIMC8cDAQR/AkAgAUEASgRAIAAoAhQoAgAgAUEDdGoiAyAAKAIMIgRJDQEgACgCEEEsaiEDDAELIAAoAgwiBCABQQN0aiEDCwJAAkACQAJAIAMtAARBD3FBAmsOBgADAwMDAQMLIAMoAgAiAw0BDAILIAMoAgAiAyADLwEGIgNBA3RBGGpBECADG2ohAwsCQCABQQBKBEAgACgCFCgCACABQQN0aiIBIARJDQEgACgCEEEsaiEBDAELIAQgAUEDdGohAQsCfwJAAkACQCABLQAEQQ9xIgZBBWsOAwACAQILIAEoAgBBGGoMAgsgASgCAEEMagwBCyAAKAIQIAZBAnRqQfwBagsoAgAiAUUNACAEQcUAOgAEIAQgATYCACAAIAAoAgxBCGo2AgwgAEHY4c59IAIQkAEaIAAoAgwiAUEIayEEAkACQCABQQRrLQAAQQ9xDQAgBCAAKAIQQSxqRw0ADAELIAFBEGshBQJAIAFBDGstAABBD3ENACAFIAAoAhBBLGpHDQBBACEFDAELIANBAEEAIAQgBRD8BRshBSAAKAIMIQELIAAgAUEQayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDAsgBQuCDwEffyMAQfAAayIDJAACQAJAAkACQAJAIAEvARRFDQAgASgCECICRQ0AAkAgAigCACIHIAIoAgQiBnINAEEAIQYgAigCCA0AIAIoAgwNACACKAIQDQAgAigCFA0AIAIoAhgNACACKAIcDQAgAigCIA0AIAIoAiQNACACKAIoDQAgAigCLA0AIAIoAjANACACKAI0DQAgAigCOA0AIAIoAjwNACACKAJADQAgAigCRA0AIAIoAkgNACACKAJMDQAgAigCUA0AIAIoAlQNACACKAJYDQAgAigCXA0AIAIoAmANACACKAJkDQAgAigCaA0AIAIoAmwNACAAQQEQmAEiCCgCCEEAOgAAIAhBATYCAAwFCyADIAY2AgQgAyAHNgIAIAMgAigCCDYCCCADIAIoAgw2AgwgAyACKAIQNgIQIAMgAigCFDYCFCADIAIoAhg2AhggAyACKAIcNgIcIAMgAigCIDYCICADIAIoAiQ2AiQgAyACKAIoNgIoIAMgAigCLDYCLCADIAIoAjA2AjAgAyACKAI0NgI0IAMgAigCODYCOCADIAIoAjw2AjwgAyACKAJANgJAIAMgAigCRDYCRCADIAIoAkg2AkggAyACKAJMNgJMIAMgAigCUDYCUCADIAIoAlQ2AlQgAyACKAJYNgJYIAMgAigCXDYCXCADIAIoAmA2AmAgAyACKAJkNgJkIAMgAigCaDYCaCADIAIoAmw2AmwgAxCYAyAAIAEoAgQQmAEhCCABKAIEIgRBAEwNAiAIKAIIIQoDQCAKIARBAWsiCWogAygCADoAAEEAIQADQCADIABBAnRqIgIgAkEEaiIGKAIAIgdBFXRBgICA/wFxIAIoAgBBCHVyNgIAIAYgAigCCCICQRV0QYCAgP8BcSAHQQh1cjYCACAAQQJqIgBBGkcNAAsgAyADKAJsIgBBCHU2AmwgAyAAQRV0QYCAgP8BcSACQQh1cjYCaCAEQQFLIQIgCSEEIAINAAsMAQsgASgCDCICRQ0CAkAgAigCACIGIAIoAgQiB3INAEEAIQcgAigCCA0AIAIoAgwNACACKAIQDQAgAigCFA0AIAIoAhgNACACKAIcDQAgAigCIA0AIAIoAiQNACACKAIoDQAgAigCLA0AIAIoAjANACACKAI0DQAgAEEBEJgBIggoAghBADoAACAIQQE2AgAMBAsgAigCNCEPIAIoAjAhECACKAIsIREgAigCKCESIAIoAiQhCyACKAIgIQwgAigCHCENIAIoAhghDiACKAIUIQogAigCECEJIAIoAgwhBSACKAIIIRMgACABKAIEEJgBIQggASgCBCIEQQBMDQEgBkH/////AXEhAiAHIAZBHXVqIgZB/////wFxIQAgEyAGQR11aiIHQf////8BcSEGIAUgB0EddWoiBUH/////AXEhByAJIAVBHXVqIgVB/////wFxIQkgCiAFQR11aiIFQf////8BcSEKIA4gBUEddWoiBUH/////AXEhDiANIAVBHXVqIgVB/////wFxIQ0gDCAFQR11aiIFQf////8BcSEMIAsgBUEddWoiBUH/////AXEhCyASIAVBHXVqIgVB/////wFxIRIgESAFQR11aiIFQf////8BcSERIBAgBUEddWoiBUH/////AXEhECAPIAVBHXVqIQ8gCCgCCCEUA0AgFCAEQQFrIgVqIAI6AAAgD0EVdCETIBBBFXQhFSARQRV0IRYgEkEVdCEXIAtBFXQhGCAMQRV0IRkgDUEVdCEaIA5BFXQhGyAKQRV0IRwgCUEVdCEdIAdBFXQhHiAGQRV0IR8gAEEVdEGAgID/AXEgAkEIdnIhAiAPQQh1IQ8gBEEBSyEgIBNBgICA/wFxIBBBCHZyIRAgFUGAgID/AXEgEUEIdnIhESAWQYCAgP8BcSASQQh2ciESIBdBgICA/wFxIAtBCHZyIQsgGEGAgID/AXEgDEEIdnIhDCAZQYCAgP8BcSANQQh2ciENIBpBgICA/wFxIA5BCHZyIQ4gG0GAgID/AXEgCkEIdnIhCiAcQYCAgP8BcSAJQQh2ciEJIB1BgICA/wFxIAdBCHZyIQcgHkGAgID/AXEgBkEIdnIhBiAfQYCAgP8BcSAAQQh2ciEAIAUhBCAgDQALCyABKAIEIQQLIAggBDYCACAIKAIIIgYtAAANASAEQQFGDQFBACEAAkAgBEEATA0AA0AgACAGai0AAA0BIABBAWoiACAERw0ACyAEIQALAkAgBCAAayILQQBMDQAgC0EDcSEJQQAhB0EAIQIgACAEa0F8TQRAIAZBA2ohCiAGQQJqIQ4gBkEBaiENIAtB/P///wdxIQwDQCACIAZqIgQgACAEai0AADoAACACIA1qIgQgACAEai0AADoAACACIA5qIgQgACAEai0AADoAACACIApqIgQgACAEai0AADoAACACQQRqIgIgDEcNAAsLIAlFDQADQCACIAZqIgQgACAEai0AADoAACACQQFqIQIgB0EBaiIHIAlHDQALCyAIIAs2AgAMAQtBAEGH5ClBABBuCyADQfAAaiQAIAgL/gEBBX8jAEGQCGsiBCQAIAQgAbs5AwACQAJAIARBEGpBgAhB+agrQYT3KiABQwAkdEleIgIbIAQQpgQiA0H/B0sNAAJAIAINACADRQ0AA0ACQCADQQJrIANBAWsiAiACIARBEGpqLQAAIgVBLkYiBhshAkF/IAMgBUEwRhsgBmsiBUEATg0AIAIiA0EASg0BCwsgBUEASgRAIARBEGogBWpBADoAAAsgAkF+TA0BIAJBAWohAwsgACADEJgBIQICQCADRQ0AIANFDQAgAigCCCAEQRBqIAP8CgAACyACIAM2AgAMAQtBACECIABBofEqQQAQbgsgBEGQCGokACACC7oJAgR/AXsjAEHgA2siAiQAIAJB+ABqIAIgARD+AiACQZwDaiIBQQA2AgAgAkH8AmoiBP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAkGMA2oiBSAG/QsCACACIAIoAng2ArACIAIgAv0AAnz9CwK0AiACIAL9AAKMAf0LAsQCIAIgAigCnAE2AtQCIAIgAikCoAE3A9gCIAIgAigCqAE2AuACIAIgBv0LAuwCIAIgAigCrAEiA0H/////AXE2AuQCIAIgA0EddTYC6AIgAkKjvcSA0AE3A9ADIAJC7dOblsGm8/8SNwPIAyACQsvukbvhrJeNEjcDwAMgAkLDufbXoJSczxA3A7gDIAJC6oOJ+4DrnqgJNwOwAyACQu7//6ehrP//FzcDqAMgAkKr1f7/8f//+w83A6ADIAJB8AFqIAJBoANqIAJBsAJqEMkCIAAoAgggAkHwAWoQugIgAUEANgIAIAQgBv0LAgAgBSAG/QsCACACIAIoArQBNgKwAiACIAL9AAK4Af0LArQCIAIgAv0AAsgB/QsCxAIgAiACKALYATYC1AIgAiACKQLcATcD2AIgAiACKALkATYC4AIgAiAG/QsC7AIgAiACKALoASIDQf////8BcTYC5AIgAiADQR11NgLoAiACQqO9xIDQATcD0AMgAkLt05uWwabz/xI3A8gDIAJCy+6Ru+Gsl40SNwPAAyACQsO59teglJzPEDcDuAMgAkLqg4n7gOueqAk3A7ADIAJC7v//p6Gs//8XNwOoAyACQqvV/v/x///7DzcDoAMgAkHwAWogAkGgA2ogAkGwAmoQyQIgACgCCEEwaiACQfABahC6AiABQQA2AgAgBCAG/QsCACAFIAb9CwIAIAIgAigCADYCsAIgAiAC/QACBP0LArQCIAIgAv0AAhT9CwLEAiACIAIoAiQ2AtQCIAIgAikCKDcD2AIgAiACKAIwNgLgAiACIAb9CwLsAiACIAIoAjQiA0H/////AXE2AuQCIAIgA0EddTYC6AIgAkKjvcSA0AE3A9ADIAJC7dOblsGm8/8SNwPIAyACQsvukbvhrJeNEjcDwAMgAkLDufbXoJSczxA3A7gDIAJC6oOJ+4DrnqgJNwOwAyACQu7//6ehrP//FzcDqAMgAkKr1f7/8f//+w83A6ADIAJB8AFqIAJBoANqIAJBsAJqEMkCIAAoAghB4ABqIAJB8AFqELoCIAFBADYCACAEIAb9CwIAIAUgBv0LAgAgAiACKAI8NgKwAiACIAL9AAJA/QsCtAIgAiAC/QACUP0LAsQCIAIgAigCYDYC1AIgAiACKQJkNwPYAiACIAIoAmw2AuACIAIgBv0LAuwCIAIgAigCcCIBQf////8BcTYC5AIgAiABQR11NgLoAiACQqO9xIDQATcD0AMgAkLt05uWwabz/xI3A8gDIAJCy+6Ru+Gsl40SNwPAAyACQsO59teglJzPEDcDuAMgAkLqg4n7gOueqAk3A7ADIAJC7v//p6Gs//8XNwOoAyACQqvV/v/x///7DzcDoAMgAkHwAWogAkGgA2ogAkGwAmoQyQIgACgCCEGQAWogAkHwAWoQugIgAEHAATYCACACQeADaiQAC9wBAQF/IAAoAhQhAgJAIAFBAEoEQCACKAIAIAFBA3RqIgEgACgCDEkNASAAKAIQQSxqIQEMAQsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAQwBCyABQdjhzn1GBEAgACgCEEEkaiEBDAELIAIoAgAiAi0ABEHmAEYEQCACKAIAIgItAAZB2OHOfSABa08EQCACQQAgAWtBA3RqQbjyiRNrIQEMAgsgACgCEEEsaiEBDAELIAAoAhBBLGohAQsCQCABLQAEQQ9xIgINACABIAAoAhBBLGpHDQBBfyECCyACC8EBAQN/IwBBEGsiAiQAAkAgAEEBQcHiKRDcASIARQ0AIAAgACgCDCIBQQFrNgIMIAFBAUoNACAAKAIIIgBFDQACQEGkiDQoAgAiAUUNACACIAA2AgwgASgCACIDIAIoAgxLDQAgAigCDCADIAEoAhBqTw0AIAAgASgCBDYCACABIAA2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAAQQAgAfwLAAwBCyAAECsLIAJBEGokAEEAC40DAQV/IwBBIGsiAiQAIAJB4rspNgIQIABB+YYqIAJBEGoQmwECQCAAQQEQyAEiAygCAEUEQCAAKAIMQQA6AAQgACAAKAIMQQhqNgIMDAELIAAgAxDZAQsgAyADKAIMIgFBAWs2AgwCQCABQQFKDQBBpIg0KAIAIQECQAJAIAMoAggiBARAIAEEQCACIAQ2AhwCQCABKAIAIgUgAigCHEsNACACKAIcIAUgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIFQQRJDQMgBUF8cSIFRQ0DIARBACAF/AsADAMLIAQQKwwCCyAEECsMAgsgAUUNAQsgAiADNgIcIAEoAgAiBCACKAIcSw0AIAIoAhwgBCABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgA0EAIAH8CwAMAQsgAxArCyACQeK7KTYCACAAQeCHKiACEJsBIAJBIGokAEEBC8YFAQ9/IwBBIGsiAyQAIANBt6gqNgIQIABB+YYqIANBEGoQmwFBASEBIABBARDIASIEKAIAIgdBAEoEQCAHQQNxIQwgBCgCCCEGAn8gB0EESQRAQQAMAQsgBkEDaiEIIAZBAmohCSAGQQFqIQoCQCAHQQRrIg1BBEkEQEEAIQEMAQsgDUECdkEBakH+////B3EhD0EAIQEDQCACIAggAUEEciILai0AACAJIAtqLQAAIAogC2otAAAgBiALai0AAHJyciABIAhqLQAAIAEgCWotAAAgASAKai0AACABIAZqLQAAcnJyckEAR3IhAiABQQhqIQEgDkECaiIOIA9HDQALCyANQQRxRQRAIAIgASAIai0AACABIAlqLQAAIAEgCmotAAAgASAGai0AAHJyckEAR3IhAgsgB0H8////B3ELIQEgDARAA0AgAiABIAZqLQAAQQBHciECIAFBAWohASAFQQFqIgUgDEcNAAsLQQFBESACQQFxGyEBCyAAKAIMIAE6AAQgACAAKAIMQQhqNgIMIAQgBCgCDCIBQQFrNgIMAkAgAUEBSg0AQaSINCgCACEBAkACQCAEKAIIIgIEQCABBEAgAyACNgIcAkAgASgCACIFIAMoAhxLDQAgAygCHCAFIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBUEESQ0DIAVBfHEiBUUNAyACQQAgBfwLAAwDCyACECsMAgsgAhArDAILIAFFDQELIAMgBDYCHCABKAIAIgIgAygCHEsNACADKAIcIAIgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIARBACAB/AsADAELIAQQKwsgA0G3qCo2AgAgAEHghyogAxCbASADQSBqJABBAQvUBAEHfyMAQSBrIgQkACAEQYjmKzYCECAAQfmGKiAEQRBqEJsBAkACQCAAQQEQyAEiBQRAQf8BIQEgBSgCACIGQQBKBEAgBSgCCCEHA0AgAiAHai0AACABcyIBQQF0IgNBMXMgAyABwEEASBsiAUEBdCIDQTFzIAMgAcBBAEgbIgFBAXQiA0ExcyADIAHAQQBIGyIBQQF0IgNBMXMgAyABwEEASBsiAUEBdCIDQTFzIAMgAcBBAEgbIgFBAXQiA0ExcyADIAHAQQBIGyIBQQF0IgNBMXMgAyABwEEASBsiAUEBdCIDQTFzIAMgAcBBAEgbIQEgAkEBaiICIAZHDQALCyAAQQEQhgEiAigCCCABOgAAIAJBATYCACAFIAUoAgwiAkEBazYCDCACQQFKDQJBpIg0KAIAIQICQCAFKAIIIgEEQCACBEAgBCABNgIcAkAgAigCACIDIAQoAhxLDQAgBCgCHCADIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiA0EESQ0DIANBfHEiA0UNAyABQQAgA/wLAAwDCyABECsMAgsgARArDAMLIAJFDQILIAQgBTYCHCACKAIAIgEgBCgCHEsNASAEKAIcIAEgAigCEGpPDQEgBSACKAIENgIAIAIgBTYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQIgAkF8cSICRQ0CIAVBACAC/AsADAILIARBgNwrNgIEIARBiOYrNgIAIABB/IgqIAQQbAALIAUQKwsgBEEgaiQAQQELwQcBCH8jAEEwayIDJAAgA0GX0yo2AiAgAEH5hiogA0EgahCbASAAQQEQyAEhBCAAQQIQyAEhBQJAAkACQCAERQ0AIAVFDQAgACAEKAIAIgEgBSgCACICIAEgAkgbEIYBIgFFBEBB6dsrIQgMAgsgASgCBCIGQQBKBEBBACECA0AgASgCCCACakEAOgAAIAJBAWoiAiABKAIEIgZIDQALCyABQQA2AgAgASAEKAIAIgIgBiACIAZIGyICNgIAIAJBAEoEQEEAIQIDQCABKAIIIAJqIAQoAgggAmotAAA6AAAgAkEBaiICIAEoAgBIDQALC0EBIQcgBSgCAEEATA0BQQAhAgNAIAIgASgCAE4NAiABKAIIIAJqIgYgBi0AACAFKAIIIAJqLQAAczoAACACQQFqIgIgBSgCAEgNAAsMAQtBgNwrIQggBEUNAQsgBCAEKAIMIgFBAWs2AgwgAUEBSg0AQaSINCgCACEBAkACQCAEKAIIIgIEQCABBEAgAyACNgIsAkAgASgCACIGIAMoAixLDQAgAygCLCAGIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBkEESQ0DIAZBfHEiBkUNAyACQQAgBvwLAAwDCyACECsMAgsgAhArDAILIAFFDQELIAMgBDYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIARBACAB/AsADAELIAQQKwsCQCAFRQ0AIAUgBSgCDCIBQQFrNgIMIAFBAUoNAEGkiDQoAgAhAQJAAkAgBSgCCCICBEAgAQRAIAMgAjYCLAJAIAEoAgAiBCADKAIsSw0AIAMoAiwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgRBBEkNAyAEQXxxIgRFDQMgAkEAIAT8CwAMAwsgAhArDAILIAIQKwwCCyABRQ0BCyADIAU2AiwgASgCACICIAMoAixLDQAgAygCLCACIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAFQQAgAfwLAAwBCyAFECsLIAdFBEAgAyAINgIUIANBl9MqNgIQIABB/IgqIANBEGoQbAALIANBl9MqNgIAIABB4IcqIAMQmwEgA0EwaiQAQQEL8w4BDn8jAEEgayIEJAAgBEGbvSk2AhAgAEH5hiogBEEQahCbASAAQQEQyAEhByAAQQIQyAEhCiAAIAcoAgAiAiAKKAIAIgEgASACSBsiBhCGASECIAAgBhCYASIMKAIIIQkgBygCACIBBEAgCSAHKAIIIAH8CgAACyAMIAcoAgAiBTYCAAJ/IAUgBSAGSg0AGiAFIAwoAgQgBkgNABogBiAFIAZGDQAaIAYgBWshASAFQQBKBEAgBiEDA0AgCSADQQFrIgNqIAkgAyABa2otAAA6AAAgASADSA0ACwsCQCABQQBMDQAgAUEDcSILBEBBACEDA0AgCSABQQFrIgFqQQA6AAAgA0EBaiIDIAtHDQALCyAFIAZrQXxLDQADQCAJIAFBBGsiA2pBADYAACABQQNrIQUgAyEBIAVBAUsNAAsLIAwgBjYCACAGCyENIAAgBhCYASILKAIIIQUgCigCACIBBEAgBSAKKAIIIAH8CgAACyALIAooAgAiCDYCAAJAIAYgCEgEQCAIIQYMAQsgCygCBCAGSARAIAghBgwBCyAGIAhGDQAgBiAIayEBIAhBAEoEQCAGIQMDQCAFIANBAWsiA2ogBSADIAFrai0AADoAACABIANIDQALCwJAIAFBAEwNACABQQNxIg4EQEEAIQMDQCAFIAFBAWsiAWpBADoAACADQQFqIgMgDkcNAAsLIAggBmtBfEsNAANAIAUgAUEEayIDakEANgAAIAFBA2shCCADIQEgCEEBSw0ACwsgCyAGNgIACyAHIAcoAgwiAUEBazYCDAJAIAFBAUoNAEGkiDQoAgAhAQJAAkAgBygCCCIDBEAgAQRAIAQgAzYCHAJAIAEoAgAiCCAEKAIcSw0AIAQoAhwgCCABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIghBBEkNAyAIQXxxIghFDQMgA0EAIAj8CwAMAwsgAxArDAILIAMQKwwCCyABRQ0BCyAEIAc2AhwgASgCACIDIAQoAhxLDQAgBCgCHCADIAEoAhBqTw0AIAcgASgCBDYCACABIAc2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAHQQAgAfwLAAwBCyAHECsLIAogCigCDCIBQQFrNgIMAkAgAUEBSg0AQaSINCgCACEBAkACQCAKKAIIIgMEQCABBEAgBCADNgIcAkAgASgCACIHIAQoAhxLDQAgBCgCHCAHIAEoAhBqTw0AIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiB0EESQ0DIAdBfHEiB0UNAyADQQAgB/wLAAwDCyADECsMAgsgAxArDAILIAFFDQELIAQgCjYCHCABKAIAIgMgBCgCHEsNACAEKAIcIAMgASgCEGpPDQAgCiABKAIENgIAIAEgCjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIApBACAB/AsADAELIAoQKwsgAigCBCIDQQBKBEBBACEBA0AgAigCCCABakEAOgAAIAFBAWoiASACKAIEIgNIDQALCyACIA0gAyADIA1KGyIBNgIAIAFBAEoEQEEAIQEDQCACKAIIIAFqIAEgCWotAAA6AAAgAUEBaiIBIAIoAgBIDQALCwJAIAZBAEwNAEEAIQEDQCABIAIoAgBODQEgAigCCCABaiIDIAMtAAAgASAFai0AAHM6AAAgAUEBaiIBIAZHDQALCyAMIAwoAgwiAkEBazYCDAJAIAJBAUoNAEGkiDQoAgAhAgJAAkAgCQRAIAIEQCAEIAk2AhwCQCACKAIAIgEgBCgCHEsNACAEKAIcIAEgAigCEGpPDQAgCSACKAIENgIAIAIgCTYCBCACIAIoAghBAWo2AgggAigCFCIBQQRJDQMgAUF8cSIBRQ0DIAlBACAB/AsADAMLIAkQKwwCCyAJECsMAgsgAkUNAQsgBCAMNgIcIAIoAgAiASAEKAIcSw0AIAQoAhwgASACKAIQak8NACAMIAIoAgQ2AgAgAiAMNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgDEEAIAL8CwAMAQsgDBArCyALIAsoAgwiAkEBazYCDAJAIAJBAUoNAEGkiDQoAgAhAgJAAkAgBQRAIAIEQCAEIAU2AhwCQCACKAIAIgEgBCgCHEsNACAEKAIcIAEgAigCEGpPDQAgBSACKAIENgIAIAIgBTYCBCACIAIoAghBAWo2AgggAigCFCIBQQRJDQMgAUF8cSIBRQ0DIAVBACAB/AsADAMLIAUQKwwCCyAFECsMAgsgAkUNAQsgBCALNgIcIAIoAgAiASAEKAIcSw0AIAQoAhwgASACKAIQak8NACALIAIoAgQ2AgAgAiALNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgC0EAIAL8CwAMAQsgCxArCyAEQZu9KTYCACAAQeCHKiAEEJsBIARBIGokAEEBC7IFAQd/IwBBMGsiBCQAIARBmcUqNgIgIABB+YYqIARBIGoQmwECQAJAIABBARDIASIFBEAgBSgCCCEBAkAgBSgCACIHRQ0AIAEgB2ohAyAHIQIDQCABLQAABEADQCADQQFrIgMtAAAEQCACIQYMBAsgAkEBayICDQALDAILIAFBAWohASACQQFrIgINAAsgAyEBCwJAIAYgB0YEQCAAIAcQhgEiAUUEQCAAQenbK0EAEG4MAgsgASgCBCIDQQBKBEBBACECA0AgASgCCCACakEAOgAAIAJBAWoiAiABKAIEIgNIDQALC0EAIQIgAUEANgIAIAEgBSgCACIGIAMgAyAGShsiAzYCACADQQBMDQEDQCABKAIIIAJqIAUoAgggAmotAAA6AAAgAkEBaiICIAEoAgBIDQALDAELIAAgBkEEahCGASECIAYEQCACKAIIIAEgBvwKAAALIAIgBjYCAAsgBSAFKAIMIgFBAWs2AgwgAUEBSg0CQaSINCgCACEBAkAgBSgCCCICBEAgAQRAIAQgAjYCLAJAIAEoAgAiAyAEKAIsSw0AIAQoAiwgAyABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgNBBEkNAyADQXxxIgNFDQMgAkEAIAP8CwAMAwsgAhArDAILIAIQKwwDCyABRQ0CCyAEIAU2AiwgASgCACICIAQoAixLDQEgBCgCLCACIAEoAhBqTw0BIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0CIAFBfHEiAUUNAiAFQQAgAfwLAAwCCyAEQYDcKzYCBCAEQZnFKjYCACAAQfyIKiAEEGwACyAFECsLIARBmcUqNgIQIABB4IcqIARBEGoQmwEgBEEwaiQAQQELmggBB38jAEHQAGsiAyQAIANB4aUqNgJAIABB+YYqIANBQGsQmwECQCAAQQEQyAEiBUUEQEGA3CshBgwBCwJAAn8CQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xDQFBAAwCC0EAIAAoAhAtADBBD3FFDQEaIAAoAhBBLGohAQsCfSABLQAEIgJBE0YEQCABKgIADAELIAJBA0YEQCABKAIAsgwBCyACQQ9xQQRHDQIgASgCACIBQRBqIANByABqEMEBIQQgBCABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQIgAygCSCIBsiABviADLQBMQQNGGwv8AAshBgJAAkACQAJ/IAYgBSgCACIBSgRAIAMgBjYCJCADIAE2AiAgAEHy3CogA0EgahBuQdTbKwwBCyAGQQBIBEAgAyAGNgIwIABB78ErIANBMGoQbkHU2ysMAQsgACABEIYBIgFFBEAgAEHp2ytBABBuQZncKwwBCyABKAIEIgRBAEoEQEEAIQIDQCABKAIIIAJqQQA6AAAgAkEBaiICIAEoAgQiBEgNAAsLQQAhAiABQQA2AgAgASAFKAIAIgcgBCAEIAdKGyIENgIAIARBAEoEQANAIAEoAgggAmogBSgCCCACai0AADoAACACQQFqIgIgASgCAEgNAAsLIAAgBSgCACAGaxCGASIEDQFB6dsrCyEGIAUgBSgCDCIBQQFrNgIMIAFBAUoNBEEAIQQMAQsCQCAGIAEoAgAiAk4EQCAEQQA2AgAMAQsgBCACIAZrNgIAIAEgBjYCACAEKAIAQQBMDQBBACECA0AgAiAEKAIETg0BIAQoAgggAmogASgCCCACaiAGai0AADoAACACQQFqIgIgBCgCAEgNAAsLIAUgBSgCDCIBQQFrNgIMQQEhBCABQQFKDQFBACEGC0GkiDQoAgAhAQJAAkACQCAFKAIIIgIEQCABRQ0CIAMgAjYCSAJAIAEoAgAiByADKAJISw0AIAMoAkggByABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgdBBEkNAiAHQXxxIgdFDQIgAkEAIAf8CwAMAgsgAhArDAELIAFFDQILIAMgBTYCSAJAAkAgASgCACICIAMoAkhLDQAgAygCSCACIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAFQQAgAfwLAAwBCyAFECsLIAQNAgwECyACECsLIAUQKyAERQ0CCyADQeGlKjYCECAAQeCHKiADQRBqEJsBIANB0ABqJABBAg8LIABBAkGGoCoQ1AEACyADIAY2AgQgA0HhpSo2AgAgAEH8iCogAxBsAAuqCgELfyMAQeAAayIDJAAgA0HoySs2AlAgAEH5hiogA0HQAGoQmwECQCAAQQEQyAEiBUUEQEGA3CshBAwBCwJAAkACQAJAAkACQAJAAkACQAJAIAAoAhQoAgBBEGoiASAAKAIMSQRAIAEtAARBD3ENAUEAIQEMAgsgACgCEC0AMEEPcUUEQEEAIQEMAgsgACgCEEEsaiEBCwJ9IAEtAAQiAkETRgRAIAEqAgAMAQsgAkEDRgRAIAEoAgCyDAELIAJBD3FBBEcNBSABKAIAIgFBEGogA0HYAGoQwQEhBCAEIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNBSADKAJYIgGyIAG+IAMtAFxBA0YbC/wAIgFBAEoNAQsgAyABNgIgIABButsqIANBIGoQbgwBCwJ/AkAgACgCFCgCAEEYaiICIAAoAgxJBEAgAi0ABEEPcQ0BQQAMAgtBACAAKAIQLQAwQQ9xRQ0BGiAAKAIQQSxqIQILAn0gAi0ABCIEQRNGBEAgAioCAAwBCyAEQQNGBEAgAigCALIMAQsgBEEPcUEERw0FIAIoAgAiAkEQaiADQdgAahDBASEHIAcgAi0AByIEQf8BRgR/IAIoAgwFIAQLQQFqRw0FIAMoAlgiArIgAr4gAy0AXEEDRhsL/AALIgIgAUgEQCADIAE2AjQgAyACNgIwIABB7NsqIANBMGoQbgwBCyAFKAIAIgQgAk4NASADIAQ2AkQgAyACNgJAIABBstwqIANBQGsQbgtByNwrIQQMAwsgACACIAFrIghBAWoiCRCGASIERQRAQenbKyEEDAMLIAFBAWshAQJAIAhBAkkEQEEAIQIMAQsgCEEBdkEBakF+cSEKQQAhAkEAIQcDQCAEKAIIIAJqIAUoAgggAWotAAA6AAAgBCgCCCACaiAFKAIIIAFqLQABOgABIAJBAnIiBiAEKAIIaiABQQJqIgsgBSgCCGotAAA6AAAgBCgCCCAGaiAFKAIIIAtqLQABOgABIAJBBGohAiABQQRqIQEgB0ECaiIHIApHDQALCyAIQQJqIQYgCEECcUUEQCAEKAIIIAJqIAUoAgggAWotAAA6AAAgBCgCCCACaiAFKAIIIAFqLQABOgABIAJBAmohAiABQQJqIQELQQEhByAGQQFxBEAgBCgCCCACaiAFKAIIIAFqLQAAOgAACyAEIAk2AgAgBSAFKAIMIgFBAWs2AgwgAUEBSg0EQQAhBAwDCyAAQQJBhqAqENQBAAsgAEEDQYagKhDUAQALIAUgBSgCDCIBQQFrNgIMIAFBAUoNAkEAIQcLQaSINCgCACEBAkACQAJAIAUoAggiAgRAIAFFDQIgAyACNgJYAkAgASgCACIGIAMoAlhLDQAgAygCWCAGIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBkEESQ0CIAZBfHEiBkUNAiACQQAgBvwLAAwCCyACECsMAQsgAUUNAgsgAyAFNgJYAkACQCABKAIAIgIgAygCWEsNACADKAJYIAIgASgCEGpPDQAgBSABKAIENgIAIAEgBTYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAVBACAB/AsADAELIAUQKwsgBw0CDAMLIAIQKwsgBRArIAdFDQELIANB6MkrNgIQIABB4IcqIANBEGoQmwEgA0HgAGokAEEBDwsgAyAENgIEIANB6MkrNgIAIABB/IgqIAMQbAALqwQBB38jAEEwayIDJAAgA0Gwgis2AiAgAEH5hiogA0EgahCbAQJAIABBARDIASICRQRAQYDcKyEFDAELAkACQCAAIAIoAgAQhgEiBgRAAkAgAigCACIEQQBMBEAgBCEFDAELA0AgBEEBayIEIAYoAghqIAIoAgggAWotAAA6AAAgAUEBaiIBIAIoAgAiBUgNAAsLIAYgBTYCACACIAIoAgwiAUEBazYCDEEAIQUgAUEBSg0CDAELIAIgAigCDCIBQQFrNgIMQenbKyEFIAFBAUoNAgtBpIg0KAIAIQECQAJAAkAgAigCCCIEBEAgAUUNAiADIAQ2AiwCQCABKAIAIgcgAygCLEsNACADKAIsIAcgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIHQQRJDQIgB0F8cSIHRQ0CIARBACAH/AsADAILIAQQKwwBCyABRQ0CCyADIAI2AiwCQAJAIAEoAgAiBCADKAIsSw0AIAMoAiwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgAkEAIAH8CwAgBg0EDAULIAIQKwsgBg0CDAMLIAQQKwsgAhArIAZFDQELIANBsIIrNgIQIABB4IcqIANBEGoQmwEgA0EwaiQAQQEPCyADIAU2AgQgA0Gwgis2AgAgAEH8iCogAxBsAAufAQEFfyMAQSBrIgEkACABQZjhKTYCECAAQfmGKiABQRBqEJsBIABBAUHB4ikQ3AEhAiAAQQJBweIpENwBIQQgAigCBCIFQQBKBEADQCACKAIIIANqIAQoAgggAyAEKAIAb2otAAA6AAAgA0EBaiIDIAIoAgQiBUgNAAsLIAIgBTYCACABQZjhKTYCACAAQeCHKiABEJsBIAFBIGokAEEAC70GAQd/IwBBMGsiAyQAIANB2esrNgIgIABB+YYqIANBIGoQmwECfwJAIABBARDIASIERQRAQYDcKyEHDAELIAQoAgAiAUUEQEEAIQEgACgCDEEAOgAEIAAgACgCDEEIajYCDEEBDAILIAQoAghFBEBBueMpIQcMAQsgAUEDbUECdEEPaiEFAkBBpIg0KAIAIgIEQAJ/AkAgBSACKAIUSw0AIAIoAgQiAUUNACACKAIYIAVBAnRqIgcgBygCAEEBajYCACACIAIoAhxBAWo2AhwgAiACKAIgIAVqNgIgIAIgAigCLCAFajYCLCACIAEoAgA2AgRBfyEFQQgMAQsgBRAqIgFFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKCAFajYCKEEsCyACaiICIAIoAgAgBWo2AgAMAQsgBRAqIQELIAEgBBDtASAAIAEQWEEAIQdBAQwBC0EAIQFBAAshBQJAAkBBpIg0KAIAIgJFDQAgAUUNASADIAE2AiwgAigCACIGIAMoAixLDQAgAygCLCAGIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASABQQAgAvwLAAwBCyABECsLAkAgBEUNACAEIAQoAgwiAUEBazYCDCABQQFKDQBBpIg0KAIAIQECQAJAIAQoAggiAgRAIAEEQCADIAI2AiwCQCABKAIAIgYgAygCLEsNACADKAIsIAYgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIGQQRJDQMgBkF8cSIGRQ0DIAJBACAG/AsADAMLIAIQKwwCCyACECsMAgsgAUUNAQsgAyAENgIsIAEoAgAiAiADKAIsSw0AIAMoAiwgAiABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBEEAIAH8CwAMAQsgBBArCyAFRQRAIAMgBzYCFCADQdnrKzYCECAAQfyIKiADQRBqEGwACyADQdnrKzYCACAAQeCHKiADEJsBIANBMGokAEEBC6kDAQp/IAEoAgAiAkEDbyEIIAJBAEoEQCMAQRBrIQdBBCEEA0ACQAJ/IAIgBkoEQCABKAIIIAZqLQAAIQkgBkEBagwBCyAEQQFrIQRBACEJIAYLIgMgAk4EQCAEQQFrIQRBACEKDAELIAEoAgggA2otAAAhCiADQQFqIQMLAn8gAiADTARAIARBAWshBEEAIQsgAwwBCyABKAIIIANqLQAAIQsgA0EBagshBiAHIAtBP3E2AgwgByAJQfwBcUECdjYCACAHIApBAnRBPHEgC0HAAXFBBnZyNgIIIAcgCUEEdEEwcSAKQfABcUEEdnI2AgRBACEDIARBAEoEQANAIAAgBWpBL0ErIAcgA0ECdGooAgAiAkHBAGogAiACQRpIGyICQccAaiACIAJBGmtBGkkbIgJBBGsgAiACQTRrQQpJGyICIAJBPkYbIgIgAkE/Rhs6AAAgBUEBaiEFIANBAWoiAyAERw0ACyABKAIAIQILIAIgBkoNAAsLIAhBAEoEf0EDIAhrIgMEQCAAIAVqQT0gA/wLAAsgBSAIa0EDagUgBQsgAGpBADoAAAv8CAEJfyMAQTBrIgQkACAEQarrKzYCICAAQfmGKiAEQSBqEJsBAn8CQCAAQQEQyAEiBkUEQEGA3CshBwwBCyAGKAIAIglFBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDEEBDAILIAYoAggiB0UEQEGW4ykhBwwBCyAJQQJqQQNtQQJ0IgJBAXIhAwJAQaSINCgCACIBBEACfwJAIAIgASgCFE8NACABKAIEIgVFDQAgASgCGCADQQJ0aiICIAIoAgBBAWo2AgAgASABKAIcQQFqNgIcIAEgASgCICADajYCICABIAEoAiwgA2o2AiwgASAFKAIANgIEQX8hA0EIDAELIAMQKiIFRQRAEE8LIAEgASgCJEEBajYCJCABIAEoAiggA2o2AihBLAsgAWoiASABKAIAIANqNgIAIAYoAgAhCSAGKAIIIQcMAQsgAxAqIQULQQAhAgJAIAlBA0gEQCAFIQEMAQsgCUECayEIIAUhAQNAIAEgAiAHaiIDLQAAQQJ2QYDjLGotAAA6AAAgASADLQAAQQR0QTBxIAMtAAFBBHZyQYDjLGotAAA6AAEgASADLQABQQJ0QTxxIAMtAAJBBnZyQYDjLGotAAA6AAIgASADLQACQT9xQYDjLGotAAA6AAMgAUEEaiEBIAJBA2oiAiAISA0ACwsCQCACIAlODQAgASACIAdqIgMtAABBAnZBgOMsai0AADoAACADLQAAQQR0QTBxIQcgCUEBayACRgRAIAEgB0GA4yxqLQAAOgABIAFBAmohAQwBCyABIAcgAy0AAUEEdnJBgOMsai0AADoAASABIAMtAAFBAnRBPHFBgOMsai0AADoAAiABQQNqIQELQQAhByABQQA6AAAgACAFEFhBAQwBC0EACyEDAkACQEGkiDQoAgAiAUUNACAFRQ0BIAQgBTYCLCABKAIAIgIgBCgCLEsNACAEKAIsIAIgASgCEGpPDQAgBSABKAIENgIAIAEgBTYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAVBACAB/AsADAELIAUQKwsCQCAGRQ0AIAYgBigCDCIBQQFrNgIMIAFBAUoNAEGkiDQoAgAhAQJAAkAgBigCCCICBEAgAQRAIAQgAjYCLAJAIAEoAgAiCCAEKAIsSw0AIAQoAiwgCCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIghBBEkNAyAIQXxxIghFDQMgAkEAIAj8CwAMAwsgAhArDAILIAIQKwwCCyABRQ0BCyAEIAY2AiwgASgCACICIAQoAixLDQAgBCgCLCACIAEoAhBqTw0AIAYgASgCBDYCACABIAY2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAGQQAgAfwLAAwBCyAGECsLIANFBEAgBCAHNgIUIARBqusrNgIQIABB/IgqIARBEGoQbAALIARBqusrNgIAIABB4IcqIAQQmwEgBEEwaiQAQQEL2goBD38jAEEwayIGJAAgBkGk5is2AiAgAEH5hiogBkEgahCbAQJ/AkAgAEEBEMgBIghFBEBBgNwrIQUMAQsgCCgCACIERQRAIAAoAgxBADoABCAAIAAoAgxBCGo2AgxBAQwCCyAIKAIIIgFFBEBB8uIpIQUMAQsgBEEDSARAQd+AKiEFDAELIARBAXQhBQJAQaSINCgCACIDBEACfwJAIAUgAygCFEsNACADKAIEIgJFDQAgAygCGCAFQQJ0aiIEIAQoAgBBAWo2AgAgAyADKAIcQQFqNgIcIAMgAygCICAFajYCICADIAMoAiwgBWo2AiwgAyACKAIANgIEQQghAUF/DAELIAUQKiICRQRAEE8LIAMgAygCJEEBajYCJCADIAMoAiggBWo2AihBLCEBIAULIQQgASADaiIDIAMoAgAgBGo2AgAgCCgCACEEIAgoAgghAQwBCyAFECohAgsgBiAFNgIoIAZBKGohDiABIQ9BACEDIwAhAQJAIARFDQADQCADIA9qLQAADQEgA0EBaiIDIARHDQALIAQhAwsgASAEIANrQYoBbEHkAG4iBUEQakHw//8/cWshCiAFQQFqIgsEQCAKQQAgC/wLAAsgAyAESQRAIAMhDCAFIQEDQCAMIA9qLQAAIQkCQCABIg0gBU8EQCAFIQEgCUUNAQsgBSEBA0AgASAKaiIHIActAABBCHQgCWoiByAHQTptIglBxgFsajoAACABRQRAQQAhAQwCCyABQQFrIgEgDUsNACAHQTprQY1/SQ0ACwsgDEEBaiIMIARHDQALC0EAIQECQANAIAEgCmotAAANASABIAVHIQcgAUEBaiEBIAcNAAsgCyEBCyADIAtqIAFrIgcgDigCAEkEQAJAIANFDQAgA0UNACACQTEgA/wLAAsCQCABIAVLBEAgAyEHDAELAn8gASAFakEBcQRAIAEhCSADDAELIAIgA2ogASAKai0AAEGA5ixqLQAAOgAAIAFBAWohCSADQQFqCyEHIAEgBUYNACACQQFqIQ0DQCACIAdqIAkgCmotAABBgOYsai0AADoAACAHIA1qIAogCUEBaiIBai0AAEGA5ixqLQAAOgAAIAlBAmohCSAHQQJqIQcgASAFRw0ACwsgAiAHakEAOgAACyAOIAdBAWo2AgAgACACEFhBACEFQQEMAQtBAAshAwJAAkBBpIg0KAIAIgRFDQAgAkUNASAGIAI2AiwgBCgCACIBIAYoAixLDQAgBigCLCABIAQoAhBqTw0AIAIgBCgCBDYCACAEIAI2AgQgBCAEKAIIQQFqNgIIIAQoAhQiBEEESQ0BIARBfHEiBEUNASACQQAgBPwLAAwBCyACECsLAkAgCEUNACAIIAgoAgwiAkEBazYCDCACQQFKDQBBpIg0KAIAIQICQAJAIAgoAggiBARAIAIEQCAGIAQ2AiwCQCACKAIAIgEgBigCLEsNACAGKAIsIAEgAigCEGpPDQAgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCIBQQRJDQMgAUF8cSIBRQ0DIARBACAB/AsADAMLIAQQKwwCCyAEECsMAgsgAkUNAQsgBiAINgIsIAIoAgAiBCAGKAIsSw0AIAYoAiwgBCACKAIQak8NACAIIAIoAgQ2AgAgAiAINgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgCEEAIAL8CwAMAQsgCBArCyADRQRAIAYgBTYCFCAGQaTmKzYCECAAQfyIKiAGQRBqEGwACyAGQaTmKzYCACAAQeCHKiAGEJsBIAZBMGokAEEBC9gHAQp/IwBBIGsiBCQAIARBtOorNgIQIABB+YYqIARBEGoQmwEgAEEBEMgBIgYoAgAiB0F+bSAHQQF0akEBaiECAkBBpIg0KAIAIgEEQAJ/AkAgAiABKAIUSw0AIAEoAgQiBUUNACABKAIYIAJBAnRqIgMgAygCAEEBajYCACABIAEoAhxBAWo2AhwgASABKAIgIAJqNgIgIAEgASgCLCACajYCLCABIAUoAgA2AgRBfyECQQgMAQsgAhAqIgVFBEAQTwsgASABKAIkQQFqNgIkIAEgASgCKCACajYCKEEsCyABaiIBIAEoAgAgAmo2AgAgBigCACEHDAELIAIQKiEFCwJAAkAgBQRAIAYoAgghCkEBIQNBACEBAkAgB0ECSARAQQAhAgwBC0EAIQIDQCACIAVqIgMgASAKaiIILQAAQQh0IAgsAAFyIghB//8DcSIJQekPbkHQ4yxqLQAAOgACIAMgCUEtbiIJQS1wQdDjLGotAAA6AAEgAyAJQVNsIAhqQf//A3FB0OMsai0AADoAACACQQNqIQIgAUEDaiEDIAFBAmohASADIAdIDQALIAdBAXIhAwsgAyAHRgR/IAIgBWoiASAHIApqQQFrLQAAwCIDQf//A3FBLW4iCEHQ4yxqLQAAOgABIAEgCEFTbCADakH//wNxQdDjLGotAAA6AAAgAkECagUgAgsgBWpBADoAACAAIAUQWEGkiDQoAgAiAUUhAyABRQ0BIAQgBTYCHCABKAIAIgIgBCgCHEsNASAEKAIcIAIgASgCEGpPDQEgBSABKAIENgIAIAEgBTYCBCABIAEoAghBAWo2AgggASgCFCICQQRJDQIgAkF8cSICRQ0CIAVBACAC/AsADAILIAAgBRBYQaSINCgCACIBRSEDIAENAQsgBRArCyAGIAYoAgwiAkEBazYCDAJAIAJBAUoNAAJAAkAgBigCCCICBEAgA0UEQCAEIAI2AhwCQCABKAIAIgMgBCgCHEsNACAEKAIcIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQMgA0F8cSIDRQ0DIAJBACAD/AsADAMLIAIQKwwCCyACECsMAgsgAw0BCyAEIAY2AhwgASgCACICIAQoAhxLDQAgBCgCHCACIAEoAhBqTw0AIAYgASgCBDYCACABIAY2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAGQQAgAfwLAAwBCyAGECsLIARBtOorNgIAIABB4IcqIAQQmwEgBEEgaiQAQQELwwYBBn8jAEEwayIDJAAgA0Ht6io2AiAgAEH5hiogA0EgahCbAQJAAkAgAEEBEMgBIgUEQAJAIAUoAgAiAkUEQCAAKAIMQQA6AAQgACAAKAIMQQhqNgIMDAELIAJBAmohBAJAQaSINCgCACIBBEACfwJAIAQgASgCFEsNACABKAIEIgZFDQAgASgCGCAEQQJ0aiICIAIoAgBBAWo2AgAgASABKAIcQQFqNgIcIAEgASgCICAEajYCICABIAEoAiwgBGo2AiwgASAGKAIANgIEQX8hBEEIDAELIAQQKiIGRQRAEE8LIAEgASgCJEEBajYCJCABIAEoAiggBGo2AihBLAsgAWoiASABKAIAIARqNgIAIAUoAgAhAgwBCyAEECohBgsgAkEASgRAQQAhAQNAIAUoAgggAWotAAAhAiABIAZqIgRBADoAASAEIAI6AAAgAUEBaiIBIAUoAgAiAkgNAAsLIAIgBmpBADoAACAAIAYgBSgCABCfAQJAQaSINCgCACIBRQ0AIAMgBjYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAZBACAB/AsADAELIAYQKwsgBSAFKAIMIgFBAWs2AgwgAUEBSg0CQaSINCgCACEBAkAgBSgCCCICBEAgAQRAIAMgAjYCLAJAIAEoAgAiBCADKAIsSw0AIAMoAiwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgRBBEkNAyAEQXxxIgRFDQMgAkEAIAT8CwAMAwsgAhArDAILIAIQKwwDCyABRQ0CCyADIAU2AiwgASgCACICIAMoAixLDQEgAygCLCACIAEoAhBqTw0BIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0CIAFBfHEiAUUNAiAFQQAgAfwLAAwCCyADQYDcKzYCBCADQe3qKjYCACAAQfyIKiADEGwACyAFECsLIANB7eoqNgIQIABB4IcqIANBEGoQmwEgA0EwaiQAQQEL4AQBB38jAEEwayICJAAgAkH84Sk2AiAgAEH5hiogAkEgahCbAQJAAkAgAEEBEMgBIgNFBEBBgNwrIQcMAQsCQCAAIAMoAgAQhgEiBUUEQCAAQenbK0EAEG4gAyADKAIMIgFBAWs2AgxBmdwrIQcgAUEBTA0BDAILIAUoAgQiBEEASgRAA0AgBSgCCCABakEAOgAAIAFBAWoiASAFKAIEIgRIDQALCyAFQQA2AgAgBSADKAIAIgEgBCABIARIGyIBNgIAIAFBAEoEQEEAIQEDQCAFKAIIIAFqIAMoAgggAWotAAA6AAAgAUEBaiIBIAUoAgBIDQALCyADIAMoAgwiAUEBazYCDCABQQFKDQILQaSINCgCACEBAkACQAJAIAMoAggiBARAIAFFDQIgAiAENgIsAkAgASgCACIGIAIoAixLDQAgAigCLCAGIAEoAhBqTw0AIAQgASgCBDYCACABIAQ2AgQgASABKAIIQQFqNgIIIAEoAhQiBkEESQ0CIAZBfHEiBkUNAiAEQQAgBvwLAAwCCyAEECsMAQsgAUUNAgsgAiADNgIsAkACQCABKAIAIgQgAigCLEsNACACKAIsIAQgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIANBACAB/AsADAELIAMQKwsgBUUNAgwDCyAEECsLIAMQKyAFDQELIAIgBzYCBCACQfzhKTYCACAAQfyIKiACEGwACyACQfzhKTYCECAAQeCHKiACQRBqEJsBIAJBMGokAEEBC6QFAQd/IwBBMGsiAyQAIANB/bgpNgIgIABB+YYqIANBIGoQmwECQAJAAkAgAEEBEMgBIgJFBEBBgNwrIQYMAQsCQAJAAn8CQAJAAkACQCACKAIARQRAIAAoAgxBADoABCAAIAAoAgxBCGo2AgwMAQsgAigCCEUNASAAQQBBABChASACKAIAIgVFDQADQCAAKAIMIgRBEzoABCAEIAFBAWoiBrM4AgAgACAAKAIMIgRBCGo2AgwgAigCCCABaiwAACEBIARBEzoADCAEIAGyOAIIIAAgACgCDEEIajYCDCAAQX0QogEgBiEBIAVBAWsiBQ0ACwsgAiACKAIMIgFBAWs2AgxBASEEIAFBAUoNCEGkiDQoAgAhAUEAIAIoAggiBUUNAxogAUUNByADIAU2AiwgASgCACIEIAMoAixLDQEgAygCLCAEIAEoAhBqTw0BIAUgASgCBDYCACABIAU2AgRBASEEIAEgASgCCEEBajYCCEEAIQYgASgCFCIHQQRJDQQgB0F8cSIHRQ0EIAVBACAH/AsADAQLIAIgAigCDCIBQQFrNgIMIAFBAUwNAUHP4ikhBgwFCyAFECtBASEEQQAhBgwCC0GkiDQoAgAhAUHP4ikLIQYgAUUNAQsgAyACNgIsAkACQCABKAIAIgUgAygCLEsNACADKAIsIAUgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAJBACAB/AsAIARFDQMMBQsgAhArCyAERQ0BDAMLIAIQKyAEDQILIAMgBjYCBCADQf24KTYCACAAQfyIKiADEGwACyAFECsgAhArCyADQf24KTYCECAAQeCHKiADQRBqEJsBIANBMGokAEEBC4gHAQZ/IwBBIGsiBCQAIARBxLkqNgIQIABB+YYqIARBEGoQmwECQCAAQQEQyAEiBSgCACIBRQRAIAAoAgxBADoABCAAIAAoAgxBCGo2AgwMAQsgAUEDdEECciEDAkBBpIg0KAIAIgIEQAJ/AkAgAyACKAIUSw0AIAIoAgQiBkUNACACKAIYIANBAnRqIgEgASgCAEEBajYCACACIAIoAhxBAWo2AhwgAiACKAIgIANqNgIgIAIgAigCLCADajYCLCACIAYoAgA2AgRBfyEDQQgMAQsgAxAqIgZFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKCADajYCKEEsCyACaiIBIAEoAgAgA2o2AgAgBSgCACEBDAELIAMQKiEGCyABQQBKBEBBACEDA0AgBiADQQN0aiIBQTFBMCAFKAIIIANqLAAAIgJBAnEbOgAGIAEgAkEBcUEwcjoAByABQTFBMCACQQRxGzoABSABQTFBMCACQQhxGzoABCABQTFBMCACQRBxGzoAAyABQTFBMCACQSBxGzoAAiABQTFBMCACQcAAcRs6AAEgAUEwQTEgAkEAThs6AAAgA0EBaiIDIAUoAgAiAUgNAAsLIAYgAUEDdGpBADoAACAAIAYQWAJAQaSINCgCACIBRQ0AIAQgBjYCHCABKAIAIgIgBCgCHEsNACAEKAIcIAIgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAZBACAB/AsADAELIAYQKwsgBSAFKAIMIgFBAWs2AgwCQCABQQFKDQBBpIg0KAIAIQECQAJAIAUoAggiAgRAIAEEQCAEIAI2AhwCQCABKAIAIgMgBCgCHEsNACAEKAIcIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQMgA0F8cSIDRQ0DIAJBACAD/AsADAMLIAIQKwwCCyACECsMAgsgAUUNAQsgBCAFNgIcIAEoAgAiAiAEKAIcSw0AIAQoAhwgAiABKAIQak8NACAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBUEAIAH8CwAMAQsgBRArCyAEQcS5KjYCACAAQeCHKiAEEJsBIARBIGokAEEBC/IKAQh/IwBBkAFrIgIkACACQbWuKzYCICAAQfmGKiACQSBqEJsBQe/jKSEFAkACQCAAQQEQyAEiBkUNAAJ/IAYoAgAiCEEQRgRAIAIgBigCCCIDLQAAIgFBD3FB8NMxai0AADoAYSACIAFBBHZB8NMxai0AADoAYCACIAMtAAEiAUEPcUHw0zFqLQAAOgBjIAIgAUEEdkHw0zFqLQAAOgBiIAIgAy0AAiIBQQ9xQfDTMWotAAA6AGUgAiABQQR2QfDTMWotAAA6AGQgAiADLQADIgFBD3FB8NMxai0AADoAZyACIAFBBHZB8NMxai0AADoAZiACIAMtAAQiAUEPcUHw0zFqLQAAOgBpIAIgAUEEdkHw0zFqLQAAOgBoIAIgAy0ABSIBQQ9xQfDTMWotAAA6AGsgAiABQQR2QfDTMWotAAA6AGogAiADLQAGIgFBD3FB8NMxai0AADoAbSACIAFBBHZB8NMxai0AADoAbCACIAMtAAciAUEPcUHw0zFqLQAAOgBvIAIgAUEEdkHw0zFqLQAAOgBuIAIgAy0ACCIBQQ9xQfDTMWotAAA6AHEgAiABQQR2QfDTMWotAAA6AHAgAiADLQAJIgFBD3FB8NMxai0AADoAcyACIAFBBHZB8NMxai0AADoAciACIAMtAAoiAUEPcUHw0zFqLQAAOgB1IAIgAUEEdkHw0zFqLQAAOgB0IAIgAy0ACyIBQQ9xQfDTMWotAAA6AHcgAiABQQR2QfDTMWotAAA6AHYgAiADLQAMIgFBD3FB8NMxai0AADoAeSACIAFBBHZB8NMxai0AADoAeCACIAMtAA0iAUEPcUHw0zFqLQAAOgB7IAIgAUEEdkHw0zFqLQAAOgB6IAIgAy0ADiIBQQ9xQfDTMWotAAA6AH0gAiABQQR2QfDTMWotAAA6AHwgAy0ADyEFQQAhASACQQA6AIABIAIgBUEPcUHw0zFqLQAAOgB/IAIgBUEEdkHw0zFqLQAAOgB+QQAhBQNAAn8CQCABQRdLDQBBLSEHQQEgAXRBgMKQBHFFDQAgBQwBCyACQeAAaiAFai0AACEHIAVBAWoLIQQgAkEwaiABaiAHOgAAAn8CQCABQRZLDQBBLSEFQQEgAXRBgKGIAnFFDQAgBAwBCyACQeAAaiAEai0AACEFIARBAWoLIQcgASACaiAFOgAxAn8CQCABQRVLDQBBLSEEQQEgAXRBwJCEAXFFDQAgBwwBCyACQeAAaiAHai0AACEEIAdBAWoLIQUgASACaiAEOgAyIAFBA2oiAUEkRw0ACyACQQA6AFQgBiAGKAIMIgFBAWs2AgxBACABQQFMDQEaDAMLIAYgBigCDCIBQQFrNgIMIAFBAUoNASAGKAIIIQNB7+MpCyEFQaSINCgCACEBAkACQAJAIAMEQCABRQ0CIAIgAzYCjAECQCABKAIAIgQgAigCjAFLDQAgAigCjAEgBCABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgRBBEkNAiAEQXxxIgRFDQIgA0EAIAT8CwAMAgsgAxArDAELIAFFDQILIAIgBjYCjAECQAJAIAEoAgAiBCACKAKMAUsNACACKAKMASAEIAEoAhBqTw0AIAYgASgCBDYCACABIAY2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAGQQAgAfwLAAwBCyAGECsLIAhBEEYNAwwCCyADECsLIAYQKyAIQRBGDQELIAIgBTYCBCACQbWuKzYCACAAQfyIKiACEGwACyAAIAJBMGoQWCACQbWuKzYCECAAQeCHKiACQRBqEJsBIAJBkAFqJABBAQuWEQEKfyMAQeADayIDJAAgA0G6xSs2AkAgAEH5hiogA0FAaxCbAUEBIQECQAJAIABBARDIASIEKAIAIgVFBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDCAEIAQoAgwiAkEBazYCDCACQQFKDQJBpIg0KAIAIQICQCAEKAIIIgYEQCACBEAgAyAGNgJ0AkAgAigCACIFIAMoAnRLDQAgAygCdCAFIAIoAhBqTw0AIAYgAigCBDYCACACIAY2AgQgAiACKAIIQQFqNgIIIAIoAhQiBUEESQ0DIAVBfHEiBUUNAyAGQQAgBfwLAAwDCyAGECsMAgsgBhArDAMLIAJFDQILIAMgBDYCdCACKAIAIgYgAygCdEsNASADKAJ0IAYgAigCEGpPDQEgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQIgAkF8cSICRQ0CIARBACAC/AsADAILAkACQCAFQSFOBEAgA0G6xSs2AhAgAEHUxSsgA0EQahBuIAQgBCgCDCIBQQFrNgIMIAFBAUoNAkGkiDQoAgAhAQJAIAQoAggiAgRAIAEEQCADIAI2AnQCQCABKAIAIgYgAygCdEsNACADKAJ0IAYgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIGQQRJDQMgBkF8cSIGRQ0DIAJBACAG/AsADAMLIAIQKwwCCyACECsMAwsgAUUNAgsgAyAENgJ0IAEoAgAiAiADKAJ0Sw0BIAMoAnQgAiABKAIQak8NASAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNAiABQXxxIgFFDQIgBEEAIAH8CwAMAgsCQEGkiDQoAgAiAQRAAn8CQCABKAIUQfABSQ0AIAEoAgQiB0UNACABKAIYIgIgAigCwAdBAWo2AsAHIAEgASgCHEEBajYCHCABIAEoAiBB8AFqNgIgIAEgASgCLEHwAWo2AiwgASAHKAIANgIEQX8hAkEIDAELQfABECoiB0UEQBBPCyABIAEoAiRBAWo2AiRB8AEhAiABIAEoAihB8AFqNgIoQSwLIAFqIgEgASgCACACajYCACAEKAIAIQUMAQtB8AEQKiEHCwJAAkAgBUEDcQ0AIAVBIWtBb0kNACAEKAIIIQhBACEBIANBnAFqIglBAEGAAvwLACADQSA2AtwDIANCq7OP/JGjs/DbADcClAEgA0L/pLmIxZHagpt/NwKMASADQvLmu+Ojp/2npX83AoQBIANC58yn0NbQ67O7fzcCfCADQgA3AnQDQCAJIAMoAnQiAkEDdkE8cWoiBiABIAhqLQAAIAYoAgBBCHRyNgIAIAMgAkEIaiICNgJ0AkACQCACRQRAIANBADYCdCADIAMoAnhBAWo2AngMAQsgAkH/A3ENAQsgA0H0AGoQ9wELIAFBAWoiASAFRw0ACyADQfQAaiADQdAAahD4ASADQdAAaiAFaiADLQBQOgAAIAUEQCADQdAAaiAIIAX8CgAACyAFQQNsQQJ2IglBAWshCiAHIQZBACECA0AgBiADQdAAaiACQQtsIgFBCWoiBUEDdmosAAAgBUF/c0EHcXZBAXEgA0HQAGogAUEHaiIFQQN2aiwAACAFQX9zQQdxdkEBcSADQdAAaiABQQVqIgVBA3ZqLAAAIAVBf3NBB3F2QQFxIANB0ABqIAFBA2oiBUEDdmosAAAgBUF/c0EHcXZBAXEgA0HQAGogAUECaiIIQQN2aiwAACAIQX9zQQdxdkEBdEECcSADQdAAaiABQQFqIgVBA3ZqLAAAIAVBf3NBB3F2QQFxIANB0ABqIAFBA3ZqLAAAIAFBf3NBB3EiBXZBAXRBAnFyQQJ0cnJBAnQgA0HQAGogAUEEaiIIQQN2aiwAACAIQX9zQQdxdkEBdEECcXJyQQJ0IANB0ABqIAFBBmoiCEEDdmosAAAgCEF/c0EHcXZBAXRBAnFyckECdCADQdAAaiABQQhqQQN2aiwAACAFdkEBdEECcXJyQQN0IANB0ABqIAFBCmoiAUEDdmosAAAgAUF/c0EHcXZBAXFBAnRyQfCYLGooAgAiARD5ASABECdqIgFBIEEAIAIgCkgbOgAAIAFBAWohBiACQQFqIgIgCUcNAAsgACAHEFgMAQsgA0G6xSs2AjAgAEGTxisgA0EwahBuIAAoAgxBAToABCAAIAAoAgxBCGo2AgwLIAQgBCgCDCICQQFrNgIMQaSINCgCACEBAkACQAJAIAJBAUwEQAJAAkACQCAEKAIIIgIEQCABRQ0CIAMgAjYCdAJAIAEoAgAiBiADKAJ0Sw0AIAMoAnQgBiABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgZBBEkNAiAGQXxxIgZFDQIgAkEAIAb8CwAMAgsgAhArDAELIAFFDQILIAMgBDYCdAJAIAEoAgAiAiADKAJ0Sw0AIAMoAnQgAiABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgJBBEkNBCACQXxxIgJFDQQgBEEAIAL8CwAMBAsgBBArDAMLIAIQKwsgBBArDAILIAFFDQELIAdFDQEgAyAHNgJ0IAEoAgAiAiADKAJ0Sw0AIAMoAnQgAiABKAIQak8NACAHIAEoAgQ2AgAgASAHNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgB0EAIAH8CwAMAQsgBxArCyADQbrFKzYCICAAQeCHKiADQSBqEJsBQQEhAQwDCyAEECsLIAAoAgxBAToABCAAIAAoAgxBCGo2AgwgA0G6xSs2AgAgAEHghyogAxCbAUEAIQEMAQsgBBArCyADQeADaiQAIAELngMBFH8gAEEoaiEKIAAoAighBEEQIQIDQCAKIAJBAnRqIgEgAUEcaygCACABQQhrKAIAIgNBD3cgA0ENd3MgA0EKdnNqIARqIAFBPGsoAgAiAUEZdyABQQ53cyABQQN2c2o2AgAgASEEIAJBAWoiAkHAAEcNAAsgACgCCCINIQUgACgCDCIOIQIgACgCJCIPIQggACgCICIQIQkgACgCHCIRIQsgACgCGCISIQYgACgCFCITIQwgACgCECIUIQMDQCADIQQgAiEDIAUiAkEedyACQRN3cyACQQp3cyACIAMgBHNxIAMgBHFzaiAHQQJ0IgVBsNQxaigCACAIIAYiAUEadyABQRV3cyABQQd3c2ogCSIIIAFBf3NxIAsiCSABcXJqaiAFIApqKAIAaiIGaiEFIAYgDGohBiABIQsgBCEMIAdBAWoiB0HAAEcNAAsgACAIIA9qNgIkIAAgCSAQajYCICAAIAEgEWo2AhwgACAGIBJqNgIYIAAgBCATajYCFCAAIAMgFGo2AhAgACACIA5qNgIMIAAgBSANajYCCAucAwEFfyAAKAIEIQQgAEEoaiIFIAAoAgAiBkEDdkE8cWoiAiACKAIAQQh0QYABcjYCACAAIAZBCGoiAjYCAAJAAkAgAkUEQCAAQQA2AgAgACAEQQFqNgIEDAELIAJB/wNxIgMNAQsgABD3ASAAKAIAIgJB/wNxIQMLIANBwANHBEADQCAFIAJBA3ZBPHFqIgMgAygCAEEIdDYCACAAIAJBCGoiAjYCAAJAAkAgAkUEQCAAQQA2AgAgACAAKAIEQQFqNgIEDAELIAJB/wNxDQELIAAQ9wEgACgCACECCyACQf8DcUHAA0cNAAsLIAAgBjYCZCAAIAQ2AmAgABD3ASAAKALoAkEASgRAIABBCGohA0EAIQIDQCABIAJqIAMgAkF8cWooAgAgAkF/c0EDdHY6AAAgAkEBaiICIAAoAugCSA0ACwsgBUEAQYAC/AsAIABBIDYC6AIgAEKrs4/8kaOz8NsANwIgIABC/6S5iMWR2oKbfzcCGCAAQvLmu+Ojp/2npX83AhAgAELnzKfQ1tDrs7t/NwIIIABCADcCAAvcAQECfwJAAkAgASAAIgNzQQNxBEAgAS0AACECDAELIAFBA3EEQANAIAMgAS0AACICOgAAIAJFDQMgA0EBaiEDIAFBAWoiAUEDcQ0ACwtBgIKECCABKAIAIgJrIAJyQYCBgoR4cUGAgYKEeEcNAANAIAMgAjYCACADQQRqIQMgASgCBCECIAFBBGohASACQYCChAggAmtyQYCBgoR4cUGAgYKEeEYNAAsLIAMgAjoAACACQf8BcUUNAANAIAMgAS0AASICOgABIANBAWohAyABQQFqIQEgAg0ACwsgAAv1BwELfyMAQTBrIgQkACAEQeqjKjYCICAAQfmGKiAEQSBqEJsBQQEhAQJAAkAgAEEBEMgBIgVBAEcgAEECEMgBIgZBAEdxIgoEQAJAIAUoAgAiCCAGKAIARw0AQQEhAiAIQQBMBEBBESEBDAELIAYoAgghAyAFKAIIIQdBACEBIAhBBE8EQCAIQfz///8HcSELA0AgAkEAIAEgB2otAAAgASADai0AAEYbQQAgByABQQFyIgJqLQAAIAIgA2otAABGG0EAIAcgAUECciICai0AACACIANqLQAARhtBACAHIAFBA3IiAmotAAAgAiADai0AAEYbIQIgAUEEaiIBIAtHDQALIAhB/P///wdxIQELIAhBA3EiCARAA0AgAkEAIAEgB2otAAAgASADai0AAEYbIQIgAUEBaiEBIAlBAWoiCSAIRw0ACwtBEUEBIAJB//8DcRshAQsgACgCDCABOgAEIAAgACgCDEEIajYCDEEAIQcMAQtBgNwrIQcgBUUNAQsgBSAFKAIMIgFBAWs2AgwgAUEBSg0AQaSINCgCACEBAkACQCAFKAIIIgMEQCABBEAgBCADNgIsAkAgASgCACICIAQoAixLDQAgBCgCLCACIAEoAhBqTw0AIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiAkEESQ0DIAJBfHEiAkUNAyADQQAgAvwLAAwDCyADECsMAgsgAxArDAILIAFFDQELIAQgBTYCLCABKAIAIgMgBCgCLEsNACAEKAIsIAMgASgCEGpPDQAgBSABKAIENgIAIAEgBTYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAVBACAB/AsADAELIAUQKwsCQCAGRQ0AIAYgBigCDCIBQQFrNgIMIAFBAUoNAEGkiDQoAgAhAQJAAkAgBigCCCIDBEAgAQRAIAQgAzYCLAJAIAEoAgAiAiAEKAIsSw0AIAQoAiwgAiABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgJBBEkNAyACQXxxIgJFDQMgA0EAIAL8CwAMAwsgAxArDAILIAMQKwwCCyABRQ0BCyAEIAY2AiwgASgCACIDIAQoAixLDQAgBCgCLCADIAEoAhBqTw0AIAYgASgCBDYCACABIAY2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAGQQAgAfwLAAwBCyAGECsLIAoEQCAEQeqjKjYCACAAQeCHKiAEEJsBIARBMGokAEEBDwsgBCAHNgIUIARB6qMqNgIQIABB/IgqIARBEGoQbAALuQcBCH8jAEEgayIEJAAgBEHawCs2AhAgAEH5hiogBEEQahCbAQJAAkAgAEEBEMgBIgVFBEBBgNwrIQYMAQsgBSgCBCEHAkACQCAAKAIUKAIAQRBqIgIgACgCDEkEQCACLQAEQQ9xRQ0CIARBADYCHAwBCyAAKAIQLQAwQQ9xRQ0BIARBADYCHCAAKAIQQSxqIQILIAItAARBA0YEQCACKAIAIQcMAQsgAiAEQRxqQQAQ/AEhAiAEKAIcIQcgAg0AIABBAhD9AQsCQCAAIAcQhgEiAkUEQCAFIAUoAgwiAUEBazYCDEHp2yshBiABQQFMDQEMAgsgAigCBCIDQQBKBEADQCACKAIIIAFqQQA6AAAgAUEBaiIBIAIoAgQiA0gNAAsLQQAhASACQQA2AgAgAiAFKAIAIgYgAyADIAZKGyIDNgIAIANBAEoEQANAIAIoAgggAWogBSgCCCABai0AADoAACABQQFqIgEgAigCACIDSA0ACwsCQCADIAdKDQAgByACKAIESg0AIAMgB0YNACAHIANrIQEgA0EASgRAIAchBgNAIAIoAggiCCAGQQFrIgZqIAggBiABa2otAAA6AAAgASAGSA0ACwsCQCABQQBMDQAgAUEDcSIIBEBBACEGA0AgAUEBayIBIAIoAghqQQA6AAAgBkEBaiIGIAhHDQALCyADIAdrQXxLDQADQCACKAIIIAFqQQFrQQA6AAAgAigCCCABakECa0EAOgAAIAFBA2siAyACKAIIakEAOgAAIAFBBGsiASACKAIIakEAOgAAIANBAUsNAAsLIAIgBzYCAAsgBSAFKAIMIgFBAWs2AgxBACEGIAFBAUoNAgtBpIg0KAIAIQECQAJAAkAgBSgCCCIDBEAgAUUNAiAEIAM2AhwCQCABKAIAIgggBCgCHEsNACAEKAIcIAggASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIIQQRJDQIgCEF8cSIIRQ0CIANBACAI/AsADAILIAMQKwwBCyABRQ0CCyAEIAU2AhwCQAJAIAEoAgAiAyAEKAIcSw0AIAQoAhwgAyABKAIQak8NACAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBUEAIAH8CwAMAQsgBRArCyACRQ0CDAMLIAMQKwsgBRArIAINAQsgBCAGNgIEIARB2sArNgIAIABB/IgqIAQQbAALIARBIGokAEEBC+UBAgR/AX0jAEEQayIFJAAgAC0ABCIEQQ9xQQRGBEAgACgCACIDQRBqIAVBCGoQwQEhBiAAIAVBCGogBiADLQAHIgRB/wFGBH8gAygCDAUgBAtBAWpHGyIALQAEIQQLQQAhAwJAAkACQCAEQQNrDhEBAgICAgICAgICAgICAgICAAILAkAgACoCACIHIAeOIgdbDQACQCACIgMOAwMBAAELIAdDAACAP5IhBwsgB0MAAABPXSAHQwAAAM9gcSIDRQ0BIAEgB/wANgIADAELIAEgACgCADYCAEEBIQMLIAVBEGokACADC8oCAQV/IwBBEGsiBSQAIAAiAygCFCECAkAgASIEQQBKBEAgAigCACAEQQN0aiICIAMoAgxJDQEgAygCEEEsaiECDAELIARB2eHOfU4EQCADKAIMIARBA3RqIQIMAQsgBEHY4c59RgRAIAMoAhBBJGohAgwBCyACKAIAIgItAARB5gBGBEAgAigCACICLQAGQdjhzn0gBGtPBEAgAkEAIARrQQN0akG48okTayECDAILIAMoAhBBLGohAgwBCyADKAIQQSxqIQILQQEhBAJAIAItAAQiA0ETRg0AIANBA0cEQEEAIQQgA0EPcUEERw0BIAIoAgAiA0EQaiAFQQhqEMEBIQYgBiADLQAHIgJB/wFGBH8gAygCDAUgAgtBAWpHDQELQQEhBAsgBUEQaiQAIAQEQCAAIAFBuLMqEIYCAAsgACABQYagKhDUAQALiAMBBX8jAEEgayICJAAgAkHIvCk2AhAgAEH5hiogAkEQahCbASAAQQEQyAEiBCgCBCEBIAAoAgwiA0EDOgAEIAMgATYCACAAIAAoAgxBCGo2AgwgBCAEKAIMIgFBAWs2AgwCQCABQQFKDQBBpIg0KAIAIQECQAJAIAQoAggiAwRAIAEEQCACIAM2AhwCQCABKAIAIgUgAigCHEsNACACKAIcIAUgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIFQQRJDQMgBUF8cSIFRQ0DIANBACAF/AsADAMLIAMQKwwCCyADECsMAgsgAUUNAQsgAiAENgIcIAEoAgAiAyACKAIcSw0AIAIoAhwgAyABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBEEAIAH8CwAMAQsgBBArCyACQci8KTYCACAAQeCHKiACEJsBIAJBIGokAEEBC4kKAwd/A30BfCMAQSBrIgQkACAEQfurKTYCECAAQfmGKiAEQRBqEJsBIABBARDIASEGAkACQEGkiDQoAgAiAQRAAn8CQCABKAIUQY4CSQ0AIAEoAgQiA0UNACABKAIYIgIgAigCuAhBAWo2ArgIIAEgASgCHEEBajYCHCABIAEoAiBBjgJqNgIgIAEgASgCLEGOAmo2AiwgASADKAIANgIEQX8hBSABIQJBCAwBCyABIQJBjgIQKiIDRQRAEE9BpIg0KAIAIQILIAEgASgCJEEBajYCJEGOAiEFIAEgASgCKEGOAmo2AihBLAsgAWoiASABKAIAIAVqNgIAIANBAEGOAvwLACACRQ0BAn8CQCACKAIUQbgISQ0AIAIoAgQiB0UNACACKAIYIgEgASgC4CFBAWo2AuAhIAIgAigCHEEBajYCHCACIAIoAiBBuAhqNgIgIAIgAigCLEG4CGo2AiwgAiAHKAIANgIEQQghBUF/DAELQbgIECoiB0UEQBBPCyACIAIoAiRBAWo2AiQgAiACKAIoQbgIajYCKEEsIQVBuAgLIQEgAiAFaiICIAIoAgAgAWo2AgAMAgtBAUGOAhAuIQMLQbgIECohBwsgB0EAQbgI/AsAIAYoAgAiBUEASgRAIAYoAgghAUEAIQIDQCADIAEtAABqIgUgBS0AAEEBajoAACABQQFqIQEgAkEBaiICIAYoAgAiBUgNAAsLIAWyIQpBACEBQQAhBQNAIAEgA2otAAAiAgRAIAcgAUECdGogAsCyIAqVIgk4AgAgBUEBaiEFIAm7IgsgCxBAoiAIu6C2IQgLIAFBAWoiAUH/AUcNAAsCQAJAQaSINCgCACIBRQ0AIAQgAzYCHCABKAIAIgIgBCgCHEsNACAEKAIcIAIgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIANBACAB/AsADAELIAMQKwsCQAJAQaSINCgCACIBRQ0AIAQgBzYCHCABKAIAIgMgBCgCHEsNACAEKAIcIAMgASgCEGpPDQAgByABKAIENgIAIAEgBzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAdBACAB/AsADAELIAcQKwsgBiAGKAIMIgFBAWs2AgwCQCABQQFKDQBBpIg0KAIAIQECQAJAIAYoAggiAwRAIAEEQCAEIAM2AhwCQCABKAIAIgIgBCgCHEsNACAEKAIcIAIgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCICQQRJDQMgAkF8cSICRQ0DIANBACAC/AsADAMLIAMQKwwCCyADECsMAgsgAUUNAQsgBCAGNgIcIAEoAgAiAyAEKAIcSw0AIAQoAhwgAyABKAIQak8NACAGIAEoAgQ2AgAgASAGNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBkEAIAH8CwAMAQsgBhArCyAAKAIMIgFBEzoABCABIAiMIgggBUH/AXG4EEC2IgmVOAIAIAAgACgCDCIBQQhqNgIMIAFBEzoADCABIAk4AgggACAAKAIMIgFBCGo2AgwgAUETOgAMIAEgCDgCCCAAIAAoAgxBCGo2AgwgBEH7qyk2AgAgAEHghyogBBCbASAEQSBqJABBAwvdBgEHfyMAQSBrIgQkACAEQaijKjYCECAAQfmGKiAEQRBqEJsBIABBARDIASEFAkBBpIg0KAIAIgEEQAJ/AkAgASgCFEH/AUkNACABKAIEIgZFDQAgASgCGCICIAIoAvwHQQFqNgL8ByABIAEoAhxBAWo2AhwgASABKAIgQf8BajYCICABIAEoAixB/wFqNgIsIAEgBigCADYCBEEIIQNBfwwBC0H/ARAqIgZFBEAQTwsgASABKAIkQQFqNgIkIAEgASgCKEH/AWo2AihBLCEDQf8BCyECIAEgA2oiASABKAIAIAJqNgIADAELQf8BECohBgsgBkEAQf8B/AsAIAUoAgBBAEoEQCAFKAIIIQFBACECA0AgBiABLQAAaiIDIAMtAABBAWo6AAAgAUEBaiEBIAJBAWoiAiAFKAIASA0ACwtBACEBIABBAEEAEKEBIAYhAgNAIAAoAgwiA0ETOgAEIAMgAUEBaiIBszgCACAAIAAoAgwiA0EIajYCDCACLAAAIQcgA0ETOgAMIAMgB7I4AgggACAAKAIMQQhqNgIMIABBfRCiASACQQFqIQIgAUH/AUcNAAsCQAJAQaSINCgCACIBRQ0AIAQgBjYCHCABKAIAIgIgBCgCHEsNACAEKAIcIAIgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCICQQRJDQEgAkF8cSICRQ0BIAZBACAC/AsADAELIAYQKwsgBSAFKAIMIgJBAWs2AgwCQCACQQFKDQACQAJAIAUoAggiAgRAIAEEQCAEIAI2AhwCQCABKAIAIgMgBCgCHEsNACAEKAIcIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQMgA0F8cSIDRQ0DIAJBACAD/AsADAMLIAIQKwwCCyACECsMAgsgAUUNAQsgBCAFNgIcIAEoAgAiAiAEKAIcSw0AIAQoAhwgAiABKAIQak8NACAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBUEAIAH8CwAMAQsgBRArCyAEQaijKjYCACAAQeCHKiAEEJsBIARBIGokAEEBC/kGAQx/IwBBMGsiAyQAIANB7KYrNgIgIABB+YYqIANBIGoQmwFBgNwrIQgCQAJAAkAgAEEBEMgBIgVBAEcgAEECEMgBIgZBAEdxIgkEQCAFKAIAIgogBigCAEcNAUEAIQggCkEASgRAIAYoAgghCyAFKAIIIQwDQCAHIAtqLQAAIgEgByAMai0AACIERwRAIAEgBHMhAQNAIAIgAUEBcWohAiABQf8BcSIEQQF2IQEgBEEBSw0ACwsgB0EBaiIHIApHDQALCyAAKAIMIgFBAzoABCABIAI2AgAgACAAKAIMQQhqNgIMCyAFRQ0CDAELQQAhCSAAQfL8KUEAEG5BorIrIQgLIAUgBSgCDCIBQQFrNgIMIAFBAUoNAEGkiDQoAgAhAQJAAkAgBSgCCCICBEAgAQRAIAMgAjYCLAJAIAEoAgAiBCADKAIsSw0AIAMoAiwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgRBBEkNAyAEQXxxIgRFDQMgAkEAIAT8CwAMAwsgAhArDAILIAIQKwwCCyABRQ0BCyADIAU2AiwgASgCACICIAMoAixLDQAgAygCLCACIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAFQQAgAfwLAAwBCyAFECsLAkAgBkUNACAGIAYoAgwiAUEBazYCDCABQQFKDQBBpIg0KAIAIQECQAJAIAYoAggiAgRAIAEEQCADIAI2AiwCQCABKAIAIgQgAygCLEsNACADKAIsIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIEQQRJDQMgBEF8cSIERQ0DIAJBACAE/AsADAMLIAIQKwwCCyACECsMAgsgAUUNAQsgAyAGNgIsIAEoAgAiAiADKAIsSw0AIAMoAiwgAiABKAIQak8NACAGIAEoAgQ2AgAgASAGNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBkEAIAH8CwAMAQsgBhArCyAJBEAgA0Hspis2AgAgAEHghyogAxCbASADQTBqJABBAQ8LIAMgCDYCFCADQeymKzYCECAAQfyIKiADQRBqEGwAC60HAgp/AX4jAEEwayIDJAAgA0HSpis2AiAgAEH5hiogA0EgahCbAQJAAkAgAEEBEMgBIgVBAEcgAEECEMgBIgZBAEdxIggEQCAFKAIAIgEgBigCACIHIAEgB0gbQQN1IgRBAEoEQCAGKAIIIQkgBSgCCCEKQQAhAQNAIAkgAUEDdCIHaikDACAHIApqKQMAhSILIAtCAYhC1arVqtWq1arVAIN9IgtCAohCs+bMmbPmzJkzgyALQrPmzJmz5syZM4N8IgtCBIggC3xCj568+PDhw4cPgyILQgiIIAt8IgtCEIggC3wiC0IgiCALfKdB/wBxIAJqIQIgAUEBaiIBIARHDQALCyAAKAIMIgFBAzoABCABIAI2AgAgACAAKAIMQQhqNgIMQQAhBwwBC0GA3CshByAFRQ0BCyAFIAUoAgwiAUEBazYCDCABQQFKDQBBpIg0KAIAIQECQAJAIAUoAggiAgRAIAEEQCADIAI2AiwCQCABKAIAIgQgAygCLEsNACADKAIsIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIEQQRJDQMgBEF8cSIERQ0DIAJBACAE/AsADAMLIAIQKwwCCyACECsMAgsgAUUNAQsgAyAFNgIsIAEoAgAiAiADKAIsSw0AIAMoAiwgAiABKAIQak8NACAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBUEAIAH8CwAMAQsgBRArCwJAIAZFDQAgBiAGKAIMIgFBAWs2AgwgAUEBSg0AQaSINCgCACEBAkACQCAGKAIIIgIEQCABBEAgAyACNgIsAkAgASgCACIEIAMoAixLDQAgAygCLCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBEEESQ0DIARBfHEiBEUNAyACQQAgBPwLAAwDCyACECsMAgsgAhArDAILIAFFDQELIAMgBjYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAZBACAB/AsADAELIAYQKwsgCEUEQCADIAc2AhQgA0HSpis2AhAgAEH8iCogA0EQahBsAAsgA0HSpis2AgAgAEHghyogAxCbASADQTBqJABBAQv5FgEWfyMAQeAAayIDJAAgA0GL8ik2AlAgAEH5hiogA0HQAGoQmwECQAJAIABBARDIASIJRQRAQYDcKyEGDAELIAkoAgBFBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDEEBIQgMAgsgA0EANgJcAn8gACgCFCgCACIEQRBqIgEgACgCDCIITwRAIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAMAQtBACEEIAEgA0HcAGpBABD8AUUEQEGhnyohBkEAIQgMAwsgACgCDCEIIAAoAhQoAgAhBCADKAJcCyEHIAggBEEYaiIBTQRAIAAoAhBBLGohAQtBvtkpIQZBACEEQQAhCAJAAkAgAS0ABEEPcUEDaw4CAAEDCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRhqIgEgACgCDEkNACAAKAIQQSxqIQELIAdBEU8EQCADIAc2AiAgAEG/wysgA0EgahBuQdS1KiEGDAELAkACQAJAAkACfwJAIAkoAgAiCEEpa0FZTwRAIAEoAgAiBEEQaiIGLQAAIgENASADQdkAagwCCyADIAg2AjAgAEGbwysgA0EwahBuQbHyKSEGDAYLIAMgAUEgciABIAFBwgBrQf8BcUEYSRs6AFkgBC0AESIBDQEgA0HaAGoLQQA6AAAMAQsgAyABQSByIAEgAUHCAGtB/wFxQRhJGzoAWiAELQASIQEgA0EAOgBbIAENAQsgA0HZAGpBksgrQQIQhAJFDQEgA0HZAGpBlsorQQIQhAJFDQELIAMgBjYCQCAAQZ2IKiADQUBrEG5Bx9EpIQYMAQsgA0HZAGoQJ0HJAGohAQJAQaSINCgCACIEBEAgBCABEE4hBCAJKAIAIQgMAQsgARAqIQQLAn8gBCEOIANB2QBqIQ8gCSgCCCEQQQAhAUEAIQYjAEHQAGshDAJAAkAgB0UEQCAIQRRrDg0BAgICAgICAgICAgIBAgsgCEEpa0FZTw0AQQAMAgsgDCAHOgAAIAxBBHIhESAMQQNyIRMgDEECciEUIAxBAXIhCgNAIBAtAAAiFSABQQh0ciEBAn8gAkEIaiIFIAJBfUgNABogAkEDaiIWQQVuIgJBAWohEgJAIAJBA3FBA0YEQCAGIQIMAQsgEkEDcSENQQAhCyAGIQIDQCACIApqIAEgBUEFayIFdkEfcToAACACQQFqIQIgC0EBaiILIA1HDQALCyAGIBJqIQYgBSAWQQ9JDQAaA0AgAiAKaiABIAVBBWt2QR9xOgAAIAIgFGogASAFQQprdkEfcToAACACIBNqIAEgBUEPa3ZBH3E6AAAgAiARaiABIAVBFGsiBXZBH3E6AAAgAkEEaiICIAZHDQALIAULIQIgEEEBaiEQIAhBAWsiCA0ACyACBEAgBiAKaiAVQQUgAmt0QR9xOgAAIAZBAWohBgtBACELQQEhAiAPLQAAIgEEQCABIQUDQEEAIQogBUH/AGtB/wFxQaIBSQ0CIAVBwQBrQf8BcUEaSQ0CIAJBAnRBH3VBs8XR0AJxIAJBA3RBH3VB3eeI6gNxIAJBBHRBH3VB+rOE9QFxIAJBBnRBH3VBsq+p2wNxIAJBBXQiCkHg////A3FzIApBH3VB7ZzCsgJxc3NzcyAFQeABcUEFdnMhAiAPIAtBAWoiC2otAAAiBQ0ACwtBACEKIAYgC2pBCGpB2gBLDQAgAkECdEEfdUGzxdHQAnEgAkEDdEEfdUHd54jqA3EgAkEEdEEfdUH6s4T1AXEgAkEGdEEfdUGyr6nbA3EgAkEFdCIFQeD///8DcXMgBUEfdUHtnMKyAnFzc3NzIQIgAQRAA0AgDiABOgAAIAFBH3EgAkECdEEfdUGzxdHQAnEgAkEDdEEfdUHd54jqA3EgAkEEdEEfdUH6s4T1AXEgAkEGdEEfdUGyr6nbA3EgAkEFdCIFQeD///8DcXMgBUEfdUHtnMKyAnFzc3NzcyECIA5BAWohDiAPLQABIQEgD0EBaiEPIAENAAsLIA5BMToAAEEBIQogDkEBaiEFIAZBf0cEQCAMIQFBACELA0BBACABLQAAIg1BH0sNAxogBSANQbHRKmotAAA6AAAgAkECdEEfdUGzxdHQAnEgAkEDdEEfdUHd54jqA3EgAkEEdEEfdUH6s4T1AXEgAkEGdEEfdUGyr6nbA3EgAkEFdCIRQeD///8DcXMgEUEfdUHtnMKyAnFzc3NzIA1zIQIgBUEBaiEFIAFBAWohASAGIAtGIQ0gC0EBaiELIA1FDQALCyAFQQA6AAYgBSACQQN0QR91Qd3niOoDcSACQQR0QR91QfqzhPUBcSACQQZ0QR91QbKvqdsDcSACQQV0IgFB4P///wNxcyABQR91Qe2cwrICcXNzcyIBIAJBAnRBH3VBs8XR0AJxcyICQQZ0QR91QbKvqdsDcSACQQV0QeD///8DcXMgAUEFdEEfdUHtnMKyAnFzIAJBBHRBH3VB+rOE9QFxcyABQQN0QR91Qd3niOoDcXMiAUGzxdHQAkEAIAJBgICAgAJPG3MiAkEGdEEfdUGyr6nbA3EgAkEFdEHg////A3FzIAFBBXRBH3VB7ZzCsgJxcyACQQR0QR91QfqzhPUBcXMgAUEDdEEfdUHd54jqA3FzIgFBs8XR0AJBACACQYCAgIACTxtzIgJBBnRBH3VBsq+p2wNxIAJBBXRB4P///wNxcyABQQV0QR91Qe2cwrICcXMgAkEEdEEfdUH6s4T1AXFzIAFBA3RBH3VB3eeI6gNxcyIBQbPF0dACQQAgAkGAgICAAk8bcyICQQZ0QR91QbKvqdsDcSACQQV0QeD///8DcXMgAUEFdEEfdUHtnMKyAnFzIAJBBHRBH3VB+rOE9QFxcyABQQN0QR91Qd3niOoDcXMiAUGzxdHQAkEAIAJBgICAgAJPG3MiAkEGdEEfdUGyr6nbA3EgAkEFdEHg////A3FzIAFBBXRBH3VB7ZzCsgJxcyACQQR0QR91QfqzhPUBcXMgAUEDdEEfdUHd54jqA3FzQbPF0dACQQAgAkGAgICAAk8bc0Gj4aDeAkEBIAcbcyICQR9xQbHRKmotAAA6AAUgBSACQRl2QbHRKmotAAA6AAAgBSACQQV2QR9xQbHRKmotAAA6AAQgBSACQQp2QR9xQbHRKmotAAA6AAMgBSACQQ92QR9xQbHRKmotAAA6AAIgBSACQRR2QR9xQbHRKmotAAA6AAELIAoLRQRAQf3qKSEGQQAhCAwCCyAAIAQQWEEAIQZBASEIDAELQQAhBEEAIQgLAkACQEGkiDQoAgAiAUUNACAERQ0BIAMgBDYCXCABKAIAIgcgAygCXEsNACADKAJcIAcgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIHQQRJDQEgB0F8cSIHRQ0BIARBACAH/AsADAELIAQQKwsCQCAJRQ0AIAkgCSgCDCIEQQFrNgIMIARBAUoNAAJAAkAgCSgCCCIEBEAgAQRAIAMgBDYCXAJAIAEoAgAiByADKAJcSw0AIAMoAlwgByABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgdBBEkNAyAHQXxxIgdFDQMgBEEAIAf8CwAMAwsgBBArDAILIAQQKwwCCyABRQ0BCyADIAk2AlwgASgCACIEIAMoAlxLDQAgAygCXCAEIAEoAhBqTw0AIAkgASgCBDYCACABIAk2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAJQQAgAfwLAAwBCyAJECsLIAgEQCADQYvyKTYCACAAQeCHKiADEJsBIANB4ABqJABBAQ8LIAMgBjYCFCADQYvyKTYCECAAQfyIKiADQRBqEGwAC4EBAQJ/AkACQCACQQRPBEAgACABckEDcQ0BA0AgACgCACABKAIARw0CIAFBBGohASAAQQRqIQAgAkEEayICQQNLDQALCyACRQ0BCwNAIAAtAAAiAyABLQAAIgRGBEAgAUEBaiEBIABBAWohACACQQFrIgINAQwCCwsgAyAEaw8LQQALrgUBCn8jAEEgayIEJAAgBEGS1Ck2AhAgAEH5hiogBEEQahCbASAAKAIUKAIAQRBqIgEgACgCDE8EQCAAKAIQQSxqIQELAkACQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBEGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCACEBAkAgAEEBEMgBIgUoAgAiA0EATA0AIAEtABAhBiADQQNxIQcgBSgCCCEBAkAgA0EESQRADAELIANB/P///wdxIQogBiEDA0AgAiADIAEtAABGaiADIAEtAAFGaiADIAEtAAJGaiADIAEtAANGaiECIAFBBGohASAJQQRqIgkgCkcNAAsLIAdFDQAgBiEDA0AgAiADIAEtAABGaiECIAFBAWohASAIQQFqIgggB0cNAAsLIAAoAgwiAUEDOgAEIAEgAjYCACAAIAAoAgxBCGo2AgwgBSAFKAIMIgFBAWs2AgwgAUEBSg0CQaSINCgCACEBAkAgBSgCCCICBEAgAQRAIAQgAjYCHAJAIAEoAgAiAyAEKAIcSw0AIAQoAhwgAyABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgNBBEkNAyADQXxxIgNFDQMgAkEAIAP8CwAMAwsgAhArDAILIAIQKwwDCyABRQ0CCyAEIAU2AhwgASgCACICIAQoAhxLDQEgBCgCHCACIAEoAhBqTw0BIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0CIAFBfHEiAUUNAiAFQQAgAfwLAAwCCyAAQQFBsrYrEIYCAAsgBRArCyAEQZLUKTYCACAAQeCHKiAEEJsBIARBIGokAEEBC6cCAQR/IwBBoAFrIgMkAAJAIAAoAhQiBCAAQTRqRwRAIAMgBDYCnAEgAEGgwSogA0E0ahCaBhogAygCPEHbqisQrQFFBEAgAUEBayIBRQ0CCwJAIAMoAjgiBA0AIAAgA0E0ahCYB0UEQEHk4yshBAwBCyAAKAIMIgZBCGshBUEAIQQCQAJAIAZBBGstAABBD3FBA2sOAgABAgsgACAFEFMgACgCECgCDEEASgRAIAAQVAsgACgCDEEIayEFCyAFKAIAQRBqIQQLIAMgAjYCKCADIAQ2AiQgAyABNgIgIABB3fkrIANBIGoQpQEACyADIAI2AgQgAyABNgIAIABBx/krIAMQpQEACyADIAMoAjg2AhAgAyACNgIUIABBqfkrIANBEGoQpQEAC8IGAQt/IwBBMGsiBCQAIARB4aEqNgIgIABB+YYqIARBIGoQmwEgAEEBEMgBIQIgAEECEMgBIQUCQAJAAkAgAkUNACAFRQ0AIAAgAigCABCGASIJRQRAQenbKyEIDAILQQEhByACKAIAIgZBAEoEQCAFKAIILQAAIQoDQCAKIAIoAgggAWotAAAiC0cEQCAJKAIIIANqIAs6AAAgAigCACEGIANBAWohAwsgAUEBaiIBIAZIDQALCyAJIAM2AgAMAQtBgNwrIQggAkUNAQsgAiACKAIMIgFBAWs2AgwgAUEBSg0AQaSINCgCACEBAkACQCACKAIIIgMEQCABBEAgBCADNgIsAkAgASgCACIGIAQoAixLDQAgBCgCLCAGIAEoAhBqTw0AIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiBkEESQ0DIAZBfHEiBkUNAyADQQAgBvwLAAwDCyADECsMAgsgAxArDAILIAFFDQELIAQgAjYCLCABKAIAIgMgBCgCLEsNACAEKAIsIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAJBACAB/AsADAELIAIQKwsCQCAFRQ0AIAUgBSgCDCIBQQFrNgIMIAFBAUoNAEGkiDQoAgAhAQJAAkAgBSgCCCICBEAgAQRAIAQgAjYCLAJAIAEoAgAiAyAEKAIsSw0AIAQoAiwgAyABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgNBBEkNAyADQXxxIgNFDQMgAkEAIAP8CwAMAwsgAhArDAILIAIQKwwCCyABRQ0BCyAEIAU2AiwgASgCACICIAQoAixLDQAgBCgCLCACIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAFQQAgAfwLAAwBCyAFECsLIAdFBEAgBCAINgIUIARB4aEqNgIQIABB/IgqIARBEGoQbAALIARB4aEqNgIAIABB4IcqIAQQmwEgBEEwaiQAQQELmQUBCX8jAEEwayIDJAAgA0GZ2yo2AiAgAEH5hiogA0EgahCbAQJAAkAgAEEBEMgBIgJFBEBBgNwrIQYMAQsCQCAAIAIoAgAQhgEiBwRAIAIoAgAiBkEASgRAA0ACQCACKAIIIAFqLQAAIgXAIgRBIUgNAAJAAkAgCARAIAVB3ABrIgVBGksNAUEAIQhBASAFdEHgiJAqcQ0DIAUNAQwCCyAEQdwARg0BCyAHKAIIIAlqIAQ6AAAgCUEBaiEJIAIoAgAhBkEAIQgMAQtBASEICyABQQFqIgEgBkgNAAsgByAJNgIAIAIgAigCDCIBQQFrNgIMQQAhBiABQQFMDQIMBAtBACEGIAdBADYCACACIAIoAgwiAUEBazYCDCABQQFMDQEMAwsgAiACKAIMIgFBAWs2AgxB6dsrIQYgAUEBSg0BC0GkiDQoAgAhAQJAAkACQCACKAIIIgQEQCABRQ0CIAMgBDYCLAJAIAEoAgAiBSADKAIsSw0AIAMoAiwgBSABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgVBBEkNAiAFQXxxIgVFDQIgBEEAIAX8CwAMAgsgBBArDAELIAFFDQILIAMgAjYCLAJAAkAgASgCACIEIAMoAixLDQAgAygCLCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASACQQAgAfwLACAHRQ0EDAULIAIQKwsgB0UNAgwDCyAEECsLIAIQKyAHDQELIAMgBjYCBCADQZnbKjYCACAAQfyIKiADEGwACyADQZnbKjYCECAAQeCHKiADQRBqEJsBIANBMGokAEEBC5QHAQd/IwBBMGsiBCQAIARBm9EpNgIgIABB+YYqIARBIGoQmwECQCAAQQEQyAEiA0UEQEGA3CshBwwBCwJAIABBAhDIASIGRQRAQYDcKyEHDAELIAYoAgAhBQJAIAMoAgAiB0EATARADAELIAVBACAFQQBKGyECA0AgASACRg0BIAMoAgggAWotAAAgBigCCCABai0AAEcEQCABIQIMAgsgAUEBaiIBIAdHDQALIAchAgsgAiAFRwRAQQAhByAAKAIMQQA6AAQgACAAKAIMQQhqNgIMDAELIAAgByAFaxCGASEBQQAhByADKAIAIgIgBUwNACACIAVrIgIEQCABKAIIIAMoAgggBWogAvwKAAALIAEgAygCACAGKAIAazYCAAsgAyADKAIMIgFBAWs2AgwCQCABQQFKDQBBpIg0KAIAIQECQAJAIAMoAggiAgRAIAEEQCAEIAI2AiwCQCABKAIAIgUgBCgCLEsNACAEKAIsIAUgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIFQQRJDQMgBUF8cSIFRQ0DIAJBACAF/AsADAMLIAIQKwwCCyACECsMAgsgAUUNAQsgBCADNgIsIAEoAgAiAiAEKAIsSw0AIAQoAiwgAiABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgA0EAIAH8CwAMAQsgAxArCyAGRQ0AIAYgBigCDCIBQQFrNgIMAkAgAUEBSg0AQaSINCgCACEBAkACQCAGKAIIIgMEQCABBEAgBCADNgIsAkAgASgCACICIAQoAixLDQAgBCgCLCACIAEoAhBqTw0AIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiAkEESQ0DIAJBfHEiAkUNAyADQQAgAvwLAAwDCyADECsMAgsgAxArDAILIAFFDQELIAQgBjYCLCABKAIAIgMgBCgCLEsNACAEKAIsIAMgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAZBACAB/AsADAELIAYQKwsgBEGb0Sk2AhAgAEHghyogBEEQahCbASAEQTBqJABBAQ8LIAQgBzYCBCAEQZvRKTYCACAAQfyIKiAEEGwAC+8EAQd/IwBBMGsiAiQAIAJBluwpNgIgIABB+YYqIAJBIGoQmwECQAJAIABBARDIASIDRQRAQYDcKyEHDAELIAJBADYCLAJAAn8gACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEQQNGBEBBASEFIAEMAQsgASACQSxqQQAQ/AEhBSACQSxqCygCACIBQQBOIAVxIgUEQCAAIAEQhgEiBCABNgIAIAEEQEEAIQEDQCAEKAIIIAFqIAMoAgggASADKAIAb2otAAA6AAAgAUEBaiIBIAQoAgBIDQALCyADIAMoAgwiAUEBazYCDCABQQFMDQEMAwsgAyADKAIMIgFBAWs2AgxBk54qIQcgAUEBSg0BC0GkiDQoAgAhAQJAAkACQCADKAIIIgQEQCABRQ0CIAIgBDYCLAJAIAEoAgAiBiACKAIsSw0AIAIoAiwgBiABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgZBBEkNAiAGQXxxIgZFDQIgBEEAIAb8CwAMAgsgBBArDAELIAFFDQILIAIgAzYCLAJAAkAgASgCACIEIAIoAixLDQAgAigCLCAEIAEoAhBqTw0AIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASADQQAgAfwLACAFDQUMBAsgAxArCyAFDQMMAgsgBBArCyADECsgBQ0BCyACIAc2AgQgAkGW7Ck2AgAgAEH8iCogAhBsAAsgAkGW7Ck2AhAgAEHghyogAkEQahCbASACQTBqJABBAQuHCAENfyMAQTBrIgQkACAEQefgKTYCICAAQfmGKiAEQSBqEJsBIABBARDIASEGIARBADYCLAJAAkACQAJAAn8gACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCAAwBCyABIARBLGpBABD8AUUNASAEKAIsCyEFIAAgBigCABCGASIBRQRAQenbKyEIDAMLIAEoAgQiA0EASgRAA0AgASgCCCACakEAOgAAIAJBAWoiAiABKAIEIgNIDQALC0EAIQIgAUEANgIAIAEgBigCACIHIAMgAyAHShsiAzYCACADQQBKBEADQCABKAIIIAJqIAYoAgggAmotAAA6AAAgAkEBaiICIAEoAgAiA0gNAAsLIANBA3QgBUwEQCABQQA2AgBBASECDAMLIAUgBUEIbSIHQQN0ayEJAkAgBUEISA0AIAMgB2siAkEASgRAQQAhBQNAIAEoAgggBWoiAiACIAdqLQAAOgAAIAVBAWoiBSABKAIAIgMgB2siAkgNAAsLIAIgA04NAANAIAEoAgggAmpBADoAACACQQFqIgIgASgCACIDSA0ACwtBASECIAlBAEwNAiADQQBMDQIgA0EBRgRAQQAhAkEBIQMMAgtBCCAJayEFIANBAXEhDEF/IAl0QX9zIQcgA0H+////B3EhDUEAIQIDQCABKAIIIANqQQFrIgogCi0AACIKIAl0IAJyOgAAIANBAmsiAyABKAIIaiICIAogBXYgB3EgAi0AACICIAl0cjoAACACIAV2IAdxIQIgC0ECaiILIA1HDQALIAwNAUEBIQIMAgtB4Z4qIQggBg0BDAILIAEoAgggA2pBAWsiASABLQAAIAl0IAJyOgAAQQEhAgsgBiAGKAIMIgFBAWs2AgwCQCABQQFMBEBBpIg0KAIAIQECQAJAAkAgBigCCCIDBEAgAUUNAiAEIAM2AiwCQCABKAIAIgUgBCgCLEsNACAEKAIsIAUgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIFQQRJDQIgBUF8cSIFRQ0CIANBACAF/AsADAILIAMQKwwBCyABRQ0CCyAEIAY2AiwCQAJAIAEoAgAiAyAEKAIsSw0AIAQoAiwgAyABKAIQak8NACAGIAEoAgQ2AgAgASAGNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBkEAIAH8CwAgAg0FDAYLIAYQKwsgAg0DDAQLIAMQKwsgBhArCyACRQ0BCyAEQefgKTYCACAAQeCHKiAEEJsBIARBMGokAEEBDwsgBCAINgIUIARB5+ApNgIQIABB/IgqIARBEGoQbAALrQoBC38jAEEwayIFJAAgBUHp3yk2AiAgAEH5hiogBUEgahCbASAAQQEQyAEhBiAFQQA2AiwCQAJAAkACQAJ/IAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAMAQsgASAFQSxqQQAQ/AFFDQEgBSgCLAshCSAAIAYoAgAQhgEiAUUEQEHp2yshCAwCCyABKAIEIgRBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIESA0ACwtBACECIAFBADYCACABIAYoAgAiAyAEIAMgBEgbIgQ2AgAgBEEASgRAA0AgASgCCCACaiAGKAIIIAJqLQAAOgAAIAJBAWoiAiABKAIAIgRIDQALCyAEQQN0IAlMBEAgAUEANgIAQQEhAwwCCyAJIAlBCG0iA0EDdGshCwJAIAlBCEgNAAJAIAMgBE4NACAEIgIgA2tBA3EiCgRAA0AgASgCCCIIIAJBAWsiAmogCCACIANrai0AADoAACAHQQFqIgcgCkcNAAsLIAMgBGtBfU8NAANAIAEoAggiBCACQQFrIgdqIAQgByADa2otAAA6AAAgASgCCCIEIAJBAmsiB2ogBCAHIANrai0AADoAACABKAIIIgQgAkEDayIHaiAEIAcgA2tqLQAAOgAAIAEoAggiBCACQQRrIgJqIAQgAiADa2otAAA6AAAgAiADSg0ACwtBASADIANBAUwbIgNBA3EhB0EAIQRBACECAkAgCUEgSA0AAkAgA0EEayIKQQRJBEAMAQsgCkECdkEBakH+////B3EhCUEAIQgDQCABKAIIIAJqQQA6AAAgASgCCCACakEAOgABIAEoAgggAmpBADoAAiABKAIIIAJqQQA6AAMgAkEEciIDIAEoAghqQQA6AAAgASgCCCADakEAOgABIAEoAgggA2pBADoAAiABKAIIIANqQQA6AAMgAkEIaiECIAhBAmoiCCAJRw0ACwsgCkEEcQ0AIAEoAgggAmpBADoAACABKAIIIAJqQQA6AAEgASgCCCACakEAOgACIAEoAgggAmpBADoAAyACQQRqIQILIAdFDQADQCABKAIIIAJqQQA6AAAgAkEBaiECIARBAWoiBCAHRw0ACwtBASEDQQAhCCALQQBMDQEgASgCAEEATA0BQQggC2shB0EAIQJBACEEA0AgASgCCCACaiIDIAMtAAAiAyALdiAEcjoAACADIAd0IQRBASEDIAJBAWoiAiABKAIASA0ACwwBC0HhniohCCAGRQ0BCyAGIAYoAgwiAUEBazYCDCABQQFMBEBBpIg0KAIAIQECQAJAAkAgBigCCCICBEAgAUUNAiAFIAI2AiwCQCABKAIAIgQgBSgCLEsNACAFKAIsIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIEQQRJDQIgBEF8cSIERQ0CIAJBACAE/AsADAILIAIQKwwBCyABRQ0CCyAFIAY2AiwCQAJAIAEoAgAiAiAFKAIsSw0AIAUoAiwgAiABKAIQak8NACAGIAEoAgQ2AgAgASAGNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBkEAIAH8CwAMAQsgBhArCyADRQ0DDAQLIAIQKwsgBhArCyADDQELIAUgCDYCFCAFQenfKTYCECAAQfyIKiAFQRBqEGwACyAFQenfKTYCACAAQeCHKiAFEJsBIAVBMGokAEEBC7sFAQd/IwBBMGsiAyQAIANBj6EqNgIgIABB+YYqIANBIGoQmwEgAEEBEMgBIQQgA0EANgIsAkACQAJAAkACQAJAAn8gACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCAAwBCyABIANBLGpBABD8AUUNASADKAIsCyEFIAAgBCgCABCGASIBDQJB6dsrIQcMAQtB4Z4qIQcgBEUNAwsgBCAEKAIMIgFBAWs2AgwgAUEBTA0BDAILIAEoAgQiBkEASgRAA0AgASgCCCACakEAOgAAIAJBAWoiAiABKAIEIgZIDQALCyABQQA2AgAgASAEKAIAIgIgBiACIAZIGyICNgIAIAJBAEoEQEEAIQIDQCABKAIIIAJqIAQoAgggAmotAAA6AAAgAkEBaiICIAEoAgBIDQALCyABIAUQjgIgBCAEKAIMIgFBAWs2AgxBASEGIAFBAUoNAgtBpIg0KAIAIQECQAJAAkAgBCgCCCICBEAgAUUNAiADIAI2AiwCQCABKAIAIgUgAygCLEsNACADKAIsIAUgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIFQQRJDQIgBUF8cSIFRQ0CIAJBACAF/AsADAILIAIQKwwBCyABRQ0CCyADIAQ2AiwCQAJAIAEoAgAiAiADKAIsSw0AIAMoAiwgAiABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBEEAIAH8CwAMAQsgBBArCyAGRQ0CDAMLIAIQKwsgBBArIAYNAQsgAyAHNgIEIANBj6EqNgIAIABB/IgqIAMQbAALIANBj6EqNgIQIABB4IcqIANBEGoQmwEgA0EwaiQAQQELmAMBCX8jACECIAAoAgAiBEEDdCIDIAFMBEAgASADbyEBCyABIAFBCG0iBkEDdGshAyABQQhOBEAgAiAEQQ9qQXBxayEEIAAoAgAiAkEASgRAIAIEQCAEIAAoAgggAvwKAAALQQAhAQNAIAAoAgggAWogBCABIAZqIAJvai0AADoAACABQQFqIgEgACgCACICSA0ACwsLIANBAEoEQEF/IAN0QX9zIgQgACgCCCIFLAAAQQggA2siBnVxIQggACgCACIBQQBKBH9BACECAkACQCABQQFGBEBBASEBDAELIAFBAXEhCSABQf7///8HcSEKQQAhBQNAIAAoAgggAWpBAWsiByAHLQAAIgcgA3QgAnI6AAAgAUECayIBIAAoAghqIgIgByAGdiAEcSACLQAAIgIgA3RyOgAAIAIgBnYgBHEhAiAFQQJqIgUgCkcNAAsgCUUNASAAKAIIIQULIAEgBWpBAWsiASABLQAAIAN0IAJyOgAACyAAKAIIIQUgACgCAAUgAQsgBWpBAWsiASABLQAAIAhyOgAACwvFBwEKfyMAQTBrIgQkACAEQfqgKjYCICAAQfmGKiAEQSBqEJsBIABBARDIASEGIARBADYCLAJAAkACQAJAAkACQAJ/IAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAMAQsgASAEQSxqQQAQ/AFFDQEgBCgCLAshAyAAIAYoAgAQhgEiAQ0CQenbKyEJDAELQeGeKiEJIAZFDQMLIAYgBigCDCIBQQFrNgIMIAFBAUwNAQwCCyABKAIEIgVBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIFSA0ACwsgAUEANgIAIAEgBigCACICIAUgAiAFSBsiAjYCACACQQBKBEBBACECA0AgASgCCCACaiAGKAIIIAJqLQAAOgAAIAJBAWoiAiABKAIASA0ACwsjACECIAEoAgAiB0EDdCIFIANMBEAgAyAFbyEDCyADQXhtIQUgA0EIbyEIIANBCE4EQCACIAdBD2pBcHFrIQcgASgCACICQQBKBEAgAgRAIAcgASgCCCAC/AoAAAtBACEDA0AgASgCCCADaiAHIAMgBWogAmogAm9qLQAAOgAAIANBAWoiAyABKAIAIgJIDQALCwsgCEEASgRAIAEoAggiAiABKAIAIgVqQQFrLQAAQQggCGsiB3QhCkEAIQMgBUEASgRAQQAhAgNAIAEoAgggA2oiBSAFLQAAIgUgCHYgAnI6AAAgBSAHdCECIANBAWoiAyABKAIASA0ACyABKAIIIQILIAIgAi0AACAKcjoAAAsgBiAGKAIMIgFBAWs2AgxBASEFIAFBAUoNAgtBpIg0KAIAIQECQAJAAkAgBigCCCICBEAgAUUNAiAEIAI2AiwCQCABKAIAIgMgBCgCLEsNACAEKAIsIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQIgA0F8cSIDRQ0CIAJBACAD/AsADAILIAIQKwwBCyABRQ0CCyAEIAY2AiwCQAJAIAEoAgAiAiAEKAIsSw0AIAQoAiwgAiABKAIQak8NACAGIAEoAgQ2AgAgASAGNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBkEAIAH8CwAMAQsgBhArCyAFRQ0CDAMLIAIQKwsgBhArIAUNAQsgBCAJNgIEIARB+qAqNgIAIABB/IgqIAQQbAALIARB+qAqNgIQIABB4IcqIARBEGoQmwEgBEEwaiQAQQELzAcBCH8jAEEwayIDJAAgA0Gi0yo2AiAgAEH5hiogA0EgahCbAUGA3CshCAJAAkACQCAAQQEQyAEiBEEARyAAQQIQyAEiBkEAR3EiB0UNACAAIAQoAgAiASAGKAIAIgUgASAFSBsQhgEiAUUEQEHp2yshCAwCCyABKAIEIgVBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIFSA0ACwtBACEIIAFBADYCACABIAQoAgAiAiAFIAIgBUgbIgI2AgAgAkEASgRAQQAhAgNAIAEoAgggAmogBCgCCCACai0AADoAACACQQFqIgIgASgCAEgNAAsLQQEhAiAGKAIAQQBMDQFBACECA0AgAiABKAIATg0BIAEoAgggAmoiBSAFLQAAIAYoAgggAmotAABxOgAAIAJBAWoiAiAGKAIASA0ACwsgByECIARFDQELIAQgBCgCDCIBQQFrNgIMAkAgAUEBSg0AQaSINCgCACEBAkACQCAEKAIIIgUEQCABBEAgAyAFNgIsAkAgASgCACIHIAMoAixLDQAgAygCLCAHIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiB0EESQ0DIAdBfHEiB0UNAyAFQQAgB/wLAAwDCyAFECsMAgsgBRArDAILIAFFDQELIAMgBDYCLCABKAIAIgUgAygCLEsNACADKAIsIAUgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIARBACAB/AsADAELIAQQKwsgAiEHCwJAIAZFDQAgBiAGKAIMIgFBAWs2AgwgAUEBSg0AQaSINCgCACEBAkACQCAGKAIIIgIEQCABBEAgAyACNgIsAkAgASgCACIEIAMoAixLDQAgAygCLCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBEEESQ0DIARBfHEiBEUNAyACQQAgBPwLAAwDCyACECsMAgsgAhArDAILIAFFDQELIAMgBjYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAZBACAB/AsADAELIAYQKwsgB0UEQCADIAg2AhQgA0Gi0yo2AhAgAEH8iCogA0EQahBsAAsgA0Gi0yo2AgAgAEHghyogAxCbASADQTBqJABBAQuUDAEKfyMAQTBrIgYkACAGQaS9KTYCICAAQfmGKiAGQSBqEJsBQYDcKyEIAkACQAJAIABBARDIASIEQQBHIABBAhDIASIFQQBHcSIJRQ0AIAAgBCgCACICIAUoAgAiAyACIANKGyIHEIYBIgJFBEBB6dsrIQgMAgsCQCAEKAIAIAdODQAgBCgCCCEBAn9BpIg0KAIAIgMEQCADIAEgBxBRDAELIAEgBxAsCyEBIAQgBzYCBCAEIAE2AgggByAEKAIAIgpMDQAgByAKayEBIApBAEoEQCAHIQMDQCAEKAIIIgggA0EBayIDaiAIIAMgAWtqLQAAOgAAIAEgA0gNAAsLAkAgAUEATA0AIAFBA3EiCARAQQAhAwNAIAFBAWsiASAEKAIIakEAOgAAIANBAWoiAyAIRw0ACwsgCiAHa0F8Sw0AA0AgBCgCCCABakEBa0EAOgAAIAQoAgggAWpBAmtBADoAACABQQNrIgMgBCgCCGpBADoAACABQQRrIgEgBCgCCGpBADoAACADQQFLDQALCyAEIAc2AgALAkAgBSgCACAHTg0AIAUoAgghAQJ/QaSINCgCACIDBEAgAyABIAcQUQwBCyABIAcQLAshASAFIAc2AgQgBSABNgIIIAcgBSgCACIKTA0AIAcgCmshASAKQQBKBEAgByEDA0AgBSgCCCIIIANBAWsiA2ogCCADIAFrai0AADoAACABIANIDQALCwJAIAFBAEwNACABQQNxIggEQEEAIQMDQCABQQFrIgEgBSgCCGpBADoAACADQQFqIgMgCEcNAAsLIAogB2tBfEsNAANAIAUoAgggAWpBAWtBADoAACAFKAIIIAFqQQJrQQA6AAAgAUEDayIDIAUoAghqQQA6AAAgAUEEayIBIAUoAghqQQA6AAAgA0EBSw0ACwsgBSAHNgIACyACKAIEIgNBAEoEQEEAIQEDQCACKAIIIAFqQQA6AAAgAUEBaiIBIAIoAgQiA0gNAAsLQQAhCCACQQA2AgAgAiAEKAIAIgEgAyABIANIGyIBNgIAIAFBAEoEQEEAIQEDQCACKAIIIAFqIAQoAgggAWotAAA6AAAgAUEBaiIBIAIoAgBIDQALC0EBIQEgBSgCAEEATA0BQQAhAQNAIAEgAigCAE4NASACKAIIIAFqIgMgAy0AACAFKAIIIAFqLQAAcToAACABQQFqIgEgBSgCAEgNAAsLIAkhASAERQ0BCyAEIAQoAgwiAkEBazYCDAJAIAJBAUoNAEGkiDQoAgAhAgJAAkAgBCgCCCIDBEAgAgRAIAYgAzYCLAJAIAIoAgAiCSAGKAIsSw0AIAYoAiwgCSACKAIQak8NACADIAIoAgQ2AgAgAiADNgIEIAIgAigCCEEBajYCCCACKAIUIglBBEkNAyAJQXxxIglFDQMgA0EAIAn8CwAMAwsgAxArDAILIAMQKwwCCyACRQ0BCyAGIAQ2AiwgAigCACIDIAYoAixLDQAgBigCLCADIAIoAhBqTw0AIAQgAigCBDYCACACIAQ2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASAEQQAgAvwLAAwBCyAEECsLIAEhCQsCQCAFRQ0AIAUgBSgCDCICQQFrNgIMIAJBAUoNAEGkiDQoAgAhAgJAAkAgBSgCCCIBBEAgAgRAIAYgATYCLAJAIAIoAgAiBCAGKAIsSw0AIAYoAiwgBCACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgRBBEkNAyAEQXxxIgRFDQMgAUEAIAT8CwAMAwsgARArDAILIAEQKwwCCyACRQ0BCyAGIAU2AiwgAigCACIBIAYoAixLDQAgBigCLCABIAIoAhBqTw0AIAUgAigCBDYCACACIAU2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASAFQQAgAvwLAAwBCyAFECsLIAlFBEAgBiAINgIUIAZBpL0pNgIQIABB/IgqIAZBEGoQbAALIAZBpL0pNgIAIABB4IcqIAYQmwEgBkEwaiQAQQELzAcBCH8jAEEwayIDJAAgA0GY0yo2AiAgAEH5hiogA0EgahCbAUGA3CshCAJAAkACQCAAQQEQyAEiBEEARyAAQQIQyAEiBkEAR3EiB0UNACAAIAQoAgAiASAGKAIAIgUgASAFSBsQhgEiAUUEQEHp2yshCAwCCyABKAIEIgVBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIFSA0ACwtBACEIIAFBADYCACABIAQoAgAiAiAFIAIgBUgbIgI2AgAgAkEASgRAQQAhAgNAIAEoAgggAmogBCgCCCACai0AADoAACACQQFqIgIgASgCAEgNAAsLQQEhAiAGKAIAQQBMDQFBACECA0AgAiABKAIATg0BIAEoAgggAmoiBSAFLQAAIAYoAgggAmotAAByOgAAIAJBAWoiAiAGKAIASA0ACwsgByECIARFDQELIAQgBCgCDCIBQQFrNgIMAkAgAUEBSg0AQaSINCgCACEBAkACQCAEKAIIIgUEQCABBEAgAyAFNgIsAkAgASgCACIHIAMoAixLDQAgAygCLCAHIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiB0EESQ0DIAdBfHEiB0UNAyAFQQAgB/wLAAwDCyAFECsMAgsgBRArDAILIAFFDQELIAMgBDYCLCABKAIAIgUgAygCLEsNACADKAIsIAUgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIARBACAB/AsADAELIAQQKwsgAiEHCwJAIAZFDQAgBiAGKAIMIgFBAWs2AgwgAUEBSg0AQaSINCgCACEBAkACQCAGKAIIIgIEQCABBEAgAyACNgIsAkAgASgCACIEIAMoAixLDQAgAygCLCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBEEESQ0DIARBfHEiBEUNAyACQQAgBPwLAAwDCyACECsMAgsgAhArDAILIAFFDQELIAMgBjYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBiABKAIENgIAIAEgBjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAZBACAB/AsADAELIAYQKwsgB0UEQCADIAg2AhQgA0GY0yo2AhAgAEH8iCogA0EQahBsAAsgA0GY0yo2AgAgAEHghyogAxCbASADQTBqJABBAQuUDAEKfyMAQTBrIgYkACAGQZy9KTYCICAAQfmGKiAGQSBqEJsBQYDcKyEIAkACQAJAIABBARDIASIEQQBHIABBAhDIASIFQQBHcSIJRQ0AIAAgBCgCACICIAUoAgAiAyACIANKGyIHEIYBIgJFBEBB6dsrIQgMAgsCQCAEKAIAIAdODQAgBCgCCCEBAn9BpIg0KAIAIgMEQCADIAEgBxBRDAELIAEgBxAsCyEBIAQgBzYCBCAEIAE2AgggByAEKAIAIgpMDQAgByAKayEBIApBAEoEQCAHIQMDQCAEKAIIIgggA0EBayIDaiAIIAMgAWtqLQAAOgAAIAEgA0gNAAsLAkAgAUEATA0AIAFBA3EiCARAQQAhAwNAIAFBAWsiASAEKAIIakEAOgAAIANBAWoiAyAIRw0ACwsgCiAHa0F8Sw0AA0AgBCgCCCABakEBa0EAOgAAIAQoAgggAWpBAmtBADoAACABQQNrIgMgBCgCCGpBADoAACABQQRrIgEgBCgCCGpBADoAACADQQFLDQALCyAEIAc2AgALAkAgBSgCACAHTg0AIAUoAgghAQJ/QaSINCgCACIDBEAgAyABIAcQUQwBCyABIAcQLAshASAFIAc2AgQgBSABNgIIIAcgBSgCACIKTA0AIAcgCmshASAKQQBKBEAgByEDA0AgBSgCCCIIIANBAWsiA2ogCCADIAFrai0AADoAACABIANIDQALCwJAIAFBAEwNACABQQNxIggEQEEAIQMDQCABQQFrIgEgBSgCCGpBADoAACADQQFqIgMgCEcNAAsLIAogB2tBfEsNAANAIAUoAgggAWpBAWtBADoAACAFKAIIIAFqQQJrQQA6AAAgAUEDayIDIAUoAghqQQA6AAAgAUEEayIBIAUoAghqQQA6AAAgA0EBSw0ACwsgBSAHNgIACyACKAIEIgNBAEoEQEEAIQEDQCACKAIIIAFqQQA6AAAgAUEBaiIBIAIoAgQiA0gNAAsLQQAhCCACQQA2AgAgAiAEKAIAIgEgAyABIANIGyIBNgIAIAFBAEoEQEEAIQEDQCACKAIIIAFqIAQoAgggAWotAAA6AAAgAUEBaiIBIAIoAgBIDQALC0EBIQEgBSgCAEEATA0BQQAhAQNAIAEgAigCAE4NASACKAIIIAFqIgMgAy0AACAFKAIIIAFqLQAAcjoAACABQQFqIgEgBSgCAEgNAAsLIAkhASAERQ0BCyAEIAQoAgwiAkEBazYCDAJAIAJBAUoNAEGkiDQoAgAhAgJAAkAgBCgCCCIDBEAgAgRAIAYgAzYCLAJAIAIoAgAiCSAGKAIsSw0AIAYoAiwgCSACKAIQak8NACADIAIoAgQ2AgAgAiADNgIEIAIgAigCCEEBajYCCCACKAIUIglBBEkNAyAJQXxxIglFDQMgA0EAIAn8CwAMAwsgAxArDAILIAMQKwwCCyACRQ0BCyAGIAQ2AiwgAigCACIDIAYoAixLDQAgBigCLCADIAIoAhBqTw0AIAQgAigCBDYCACACIAQ2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASAEQQAgAvwLAAwBCyAEECsLIAEhCQsCQCAFRQ0AIAUgBSgCDCICQQFrNgIMIAJBAUoNAEGkiDQoAgAhAgJAAkAgBSgCCCIBBEAgAgRAIAYgATYCLAJAIAIoAgAiBCAGKAIsSw0AIAYoAiwgBCACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgRBBEkNAyAEQXxxIgRFDQMgAUEAIAT8CwAMAwsgARArDAILIAEQKwwCCyACRQ0BCyAGIAU2AiwgAigCACIBIAYoAixLDQAgBigCLCABIAIoAhBqTw0AIAUgAigCBDYCACACIAU2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASAFQQAgAvwLAAwBCyAFECsLIAlFBEAgBiAINgIUIAZBnL0pNgIQIABB/IgqIAZBEGoQbAALIAZBnL0pNgIAIABB4IcqIAYQmwEgBkEwaiQAQQELyQQBBn8jAEEwayIDJAAgA0Hn0yk2AiAgAEH5hiogA0EgahCbAQJAAkAgAEEBEMgBIgQEQCAAIAQoAgAQhgEiASgCBCIFQQBKBEADQCABKAIIIAJqQQA6AAAgAkEBaiICIAEoAgQiBUgNAAsLQQAhAiABQQA2AgAgASAEKAIAIgYgBSAFIAZKGyIFNgIAIAVBAEoEQANAIAEoAgggAmogBCgCCCACai0AADoAACACQQFqIgIgASgCAEgNAAsLIAQoAgBBAEoEQEEAIQIDQCABKAIIIAJqIAQoAgggAmotAABBf3M6AAAgAkEBaiICIAQoAgBIDQALCyAEIAQoAgwiAUEBazYCDCABQQFKDQJBpIg0KAIAIQECQCAEKAIIIgIEQCABBEAgAyACNgIsAkAgASgCACIFIAMoAixLDQAgAygCLCAFIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiBUEESQ0DIAVBfHEiBUUNAyACQQAgBfwLAAwDCyACECsMAgsgAhArDAMLIAFFDQILIAMgBDYCLCABKAIAIgIgAygCLEsNASADKAIsIAIgASgCEGpPDQEgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIARBACAB/AsADAILIANBgNwrNgIEIANB59MpNgIAIABB/IgqIAMQbAALIAQQKwsgA0Hn0yk2AhAgAEHghyogA0EQahCbASADQTBqJABBAQv3EgISfwF9IwBBIGsiCiQAIApB+KsrNgIQIABB+YYqIApBEGoQmwEgAEEBEMgBIQsCQAJAAkACQCAAQQIQyAEiBSgCACIBIAsoAgAiAk4EQCAAKAIMQQA6AAQgACAAKAIMQQhqNgIMIABB6tgqQQAQbgwBCwJ/An8CQAJAAkAgACgCFCgCAEEYaiIJIAAoAgxJBEAgCS0ABEEPcUUNAQwDCyAAKAIQLQAwQQ9xDQELIAIhByALKAIIIgkMAgsgACgCEEEsaiEJCwJ9IAktAAQiAUETRgRAIAkqAgAMAQsgAUEDRgRAIAkoAgCyDAELIAFBD3FBBEcNBCAJKAIAIgFBEGogCkEYahDBASECIAIgAS0AByIJQf8BRgR/IAEoAgwFIAkLQQFqRw0EIAooAhgiAbIgAb4gCi0AHEEDRhsLIRMgCygCACEHIAsoAgghCSAT/AAiAkEATARAIAUoAgAhASAHIAJrIQcgCQwBCyACIAdOBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDCAAQZ/ZKkEAEG4MAwsgByACayIHIAUoAgAiAUgEQCAAKAIMQQA6AAQgACAAKAIMQQhqNgIMIABBpZQrQQAQbgwDCyACIAlqCyEIIAUoAgghBCAIIAFFDQAaAkACQCABIAdLDQAgCCAELQAAIgYgBxCTCCECIAFBAUYNASACRQ0BIAggAmsgB2oiByABSQ0AAkACQAJAAkAgAUECaw4DAAECAwsCfyAELQABIAZBCHRyIQMgAi8AACIIQQh0IAhBCHZyIQggB0ECayIEBEAgAkECaiEGA0AgBkECayAIQf//A3EgA0H//wNxRg0CGiAGLQAAIAhBCHRyIQggBkEBaiEGIARBAWsiBA0ACwsgAiAHakECa0EAIAhB//8DcSADQf//A3FGGwsMBQsCfyACLQABQRB0IAItAABBGHRyIAItAAJBCHRyIQggBC0AAUEQdCAELQAAQRh0ciAELQACQQh0ciEDIAdBA2siBgRAIAJBA2ohBANAIARBA2sgAyAIRg0CGiAIIAQtAAByQQh0IQggBEEBaiEEIAZBAWsiBg0ACwsgAiAHakEDa0EAIAMgCEYbCwwECwJ/IAIoAAAiCEEYdCAIQYD+A3FBCHRyIAhBCHZBgP4DcSAIQRh2cnIhCCAEKAAAIgRBGHQgBEGA/gNxQQh0ciAEQQh2QYD+A3EgBEEYdnJyIQMgB0EEayIGBEAgAkEEaiEEA0AgBEEEayADIAhGDQIaIAQtAAAgCEEIdHIhCCAEQQFqIQQgBkEBayIGDQALCyACIAdqQQRrQQAgAyAIRhsLDAMLIAIhCCACIAdqIRIgBCEMQQAhAiMAQaAIayIOJAAgDkGQCGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIA79DAAAAAAAAAAAAAAAAAAAAAD9CwSACANAQQEhBiAOIAMgDGotAAAiBEECdGogA0EBaiIHNgIAIA5BgAhqIARBA3ZBHHFqIgMgAygCAEEBIAR0cjYCACAHIgMgAUcNAAtBfyEHQQEhDUEBIQMDQAJ/IAcgDGogA2otAAAiBCAGIAxqLQAAIhFGBEAgAyANRgRAIAIgDWohAkEBDAILIANBAWoMAQsgBCARSwRAIAYgB2shDSAGIQJBAQwBCyACIgdBAWohAkEBIQ1BAQsiAyACaiIGIAFJDQALQX8hAkEAIQZBASEEQQEhD0EBIQMDQAJ/IAIgDGogA2otAAAiESAEIAxqLQAAIhBGBEAgAyAPRgRAIAYgD2ohBkEBDAILIANBAWoMAQsgECARSwRAIAQgAmshDyAEIQZBAQwBCyAGIgJBAWohBkEBIQ9BAQsiAyAGaiIEIAFJDQALAn8gDCAMIA8gDSACQQFqIAdBAWpLIgMbIg1qIAIgByADGyIQQQFqIhEQhAIEQCAQIAEgEEF/c2oiAyADIBBJG0EBaiENQQAMAQsgASANawshD0EAIQICQCASIAhrIAFJDQBBACEDA0AgAyEHAn9BACAOQYAIaiAIIgQgAWoiCEEBay0AACIGQQN2QRxxaigCACAGdkEBcUUNABoCfyAOIAZBAnRqKAIAIgMgAUcEQCAEIAEgA2siAyAHIAMgB0sbagwBCwJAIAEgESIDIAcgAyAHSxsiBksEQANAIAYgDGotAAAgBCAGai0AAEcNAiAGQQFqIgYgAUcNAAsLA0AgAyAHTQRAIAQhAgwGCyAMIANBAWsiA2otAAAgAyAEai0AAEYNAAsgBCANaiEIIA8MAgsgBCAGIBBragshCEEACyEDIBIgCGsgAU8NAAsLIA5BoAhqJAAgAiEDCyADDAELIAILIgFFBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDAwBCyAAKAIMIgJBEzoABCACIAEgCWuzOAIAIAAgACgCDEEIajYCDAsgBSAFKAIMIgFBAWs2AgwgAUEBSg0CQaSINCgCACEBAkAgBSgCCCIJBEAgAQRAIAogCTYCGAJAIAEoAgAiAiAKKAIYSw0AIAooAhggAiABKAIQak8NACAJIAEoAgQ2AgAgASAJNgIEIAEgASgCCEEBajYCCCABKAIUIgJBBEkNAyACQXxxIgJFDQMgCUEAIAL8CwAMAwsgCRArDAILIAkQKwwDCyABRQ0CCyAKIAU2AhggASgCACIJIAooAhhLDQEgCigCGCAJIAEoAhBqTw0BIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0CIAFBfHEiAUUNAiAFQQAgAfwLAAwCCyAAQQNBhqAqENQBAAsgBRArCyALIAsoAgwiBUEBazYCDAJAIAVBAUoNAEGkiDQoAgAhBQJAAkAgCygCCCIBBEAgBQRAIAogATYCGAJAIAUoAgAiCSAKKAIYSw0AIAooAhggCSAFKAIQak8NACABIAUoAgQ2AgAgBSABNgIEIAUgBSgCCEEBajYCCCAFKAIUIglBBEkNAyAJQXxxIglFDQMgAUEAIAn8CwAMAwsgARArDAILIAEQKwwCCyAFRQ0BCyAKIAs2AhggBSgCACIBIAooAhhLDQAgCigCGCABIAUoAhBqTw0AIAsgBSgCBDYCACAFIAs2AgQgBSAFKAIIQQFqNgIIIAUoAhQiBUEESQ0BIAVBfHEiBUUNASALQQAgBfwLAAwBCyALECsLIApB+KsrNgIAIABB4IcqIAoQmwEgCkEgaiQAQQELkAgCB38BfSMAQdAAayIDJAAgA0GDrCk2AkAgAEH5hiogA0FAaxCbAQJAIABBARDIASIFRQRAQYDcKyEGDAELAkACQAJAAkACQAJ/AkACQAJAAkAgACgCFCgCAEEQaiIBIAAoAgxJBEAgAS0ABEEPcQ0BQQAhAQwCCyAAKAIQLQAwQQ9xRQRAQQAhAQwCCyAAKAIQQSxqIQELAn0gAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0IIAEoAgAiAUEQaiADQcgAahDBASEEIAQgAS0AByICQf8BRgR/IAEoAgwFIAILQQFqRw0IIAMoAkgiAbIgAb4gAy0ATEEDRhsL/AAiAUEASA0BCyAFKAIAIgQgAU4NAQsgAyABNgIgIABB4d0qIANBIGoQbkHd4ykMAQsCfwJAIAAoAhQoAgBBGGoiAiAAKAIMSQRAIAItAARBD3ENAUEADAILQQAgACgCEC0AMEEPcUUNARogACgCEEEsaiECCwJ9IAItAAQiBEETRgRAIAIqAgAMAQsgBEEDRgRAIAIoAgCyDAELIARBD3FBBEcNByACKAIAIgJBEGogA0HIAGoQwQEhBiAGIAItAAciBEH/AUYEfyACKAIMBSAEC0EBakcNByADKAJIIgKyIAK+IAMtAExBA0YbCyEIIAUoAgAhBCAI/AALIgIgAWogBEoEQCADIAI2AjAgAEHA3iogA0EwahBuQd3jKQwBCyAAIAJBAWoQhgEiBA0BQbOpKQshBiAFIAUoAgwiAUEBazYCDCABQQFKDQVBACEEDAELIAIEQCAEKAIIIAUoAgggAWogAvwKAAALIAQgAjYCACAFIAUoAgwiAUEBazYCDEEBIQQgAUEBSg0BQQAhBgtBpIg0KAIAIQECQAJAAkAgBSgCCCICBEAgAUUNAiADIAI2AkgCQCABKAIAIgcgAygCSEsNACADKAJIIAcgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIHQQRJDQIgB0F8cSIHRQ0CIAJBACAH/AsADAILIAIQKwwBCyABRQ0CCyADIAU2AkgCQAJAIAEoAgAiAiADKAJISw0AIAMoAkggAiABKAIQak8NACAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBUEAIAH8CwAMAQsgBRArCyAEDQIMBQsgAhArCyAFECsgBEUNAwsgA0GDrCk2AhAgAEHghyogA0EQahCbASADQdAAaiQAQQEPCyAAQQJBhqAqENQBAAsgAEEDQYagKhDUAQALIAMgBjYCBCADQYOsKTYCACAAQfyIKiADEGwAC/AJAQh/IwBB0ABrIgMkACADQbP+KjYCQCAAQfmGKiADQUBrEJsBIABBARDIASEGAkACQAJAAkACQAJAAkAgAEECEMgBIgIEQAJ/AkACQCACKAIAIgEgBigCACIESgRAIAMgBDYCJCADIAE2AiAgAEH5+isgA0EgahBuDAELAkACQCAAKAIUKAIAQRhqIgEgACgCDEkEQCABLQAEQQ9xDQEMAgsgACgCEC0AMEEPcUUEQAwCCyAAKAIQQSxqIQELAn0gAS0ABCIEQRNGBEAgASoCAAwBCyAEQQNGBEAgASgCALIMAQsgBEEPcUEERw0GIAEoAgAiAUEQaiADQcgAahDBASEHIAcgAS0AByIEQf8BRgR/IAEoAgwFIAQLQQFqRw0GIAMoAkgiAbIgAb4gAy0ATEEDRhsL/AAiB0EATA0AIAYoAgAiASAHTA0AIAIoAgAgB2ogAUwNAgsgAyAHNgIwIABBkN4qIANBMGoQbgtBACEHQdXkKQwBCwJAIAAgARCGASIBRQRAIABB6dsrQQAQbgwBCyABKAIEIgVBAEoEQEEAIQQDQCABKAIIIARqQQA6AAAgBEEBaiIEIAEoAgQiBUgNAAsLQQAhBCABQQA2AgAgASAGKAIAIgggBSAFIAhKGyIFNgIAIAVBAEwNAANAIAEoAgggBGogBigCCCAEai0AADoAACAEQQFqIgQgASgCAEgNAAsLIAIoAgAiBARAIAEoAgggB2ogAigCCCAE/AoAAAtBASEHQQALIQQgAiACKAIMIgFBAWs2AgwgAUEBSg0DQaSINCgCACEBAkAgAigCCCIFBEAgAQRAIAMgBTYCSAJAIAEoAgAiCCADKAJISw0AIAMoAkggCCABKAIQak8NACAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIghBBEkNAyAIQXxxIghFDQMgBUEAIAj8CwAMAwsgBRArDAILIAUQKwwECyABRQ0DCyADIAI2AkggASgCACIFIAMoAkhLDQIgAygCSCAFIAEoAhBqTw0CIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0DIAFBfHEiAUUNAyACQQAgAfwLAAwDC0GzqSkhBCAGRQ0GIAYgBigCDCICQQFrNgIMIAJBAUoNBgwDCyAAQQNBhqAqENQBAAsgAhArCyAGIAYoAgwiAkEBazYCDCACQQFKDQELQaSINCgCACECAkACQAJAIAYoAggiAQRAIAJFDQIgAyABNgJIAkAgAigCACIFIAMoAkhLDQAgAygCSCAFIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiBUEESQ0CIAVBfHEiBUUNAiABQQAgBfwLAAwCCyABECsMAQsgAkUNAgsgAyAGNgJIAkACQCACKAIAIgEgAygCSEsNACADKAJIIAEgAigCEGpPDQAgBiACKAIENgIAIAIgBjYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIAZBACAC/AsADAELIAYQKwsgBw0DDAQLIAEQKwsgBhArCyAHRQ0BCyADQbP+KjYCECAAQeCHKiADQRBqEJsBIANB0ABqJABBAQ8LIAMgBDYCBCADQbP+KjYCACAAQfyIKiADEGwAC3EBA38jAEEgayIBJAAgAUGz9yo2AhAgAEH5hiogAUEQahCbASAAQQFBweIpENwBKAIAIQIgACgCDCIDQQM6AAQgAyACNgIAIAAgACgCDEEIajYCDCABQbP3KjYCACAAQeCHKiABEJsBIAFBIGokAEEBC7UJAQh/IwBB0ABrIgMkACADQZnBKjYCICAAQfmGKiADQSBqEJsBAkACQAJAIABBAUH47SoQ3AEEQEHA7CkhByAAKAIUKAIAQQhqIgQgACgCDE8EQCAAKAIQQSxqIQQLAkACQCAELQAEQQ9xQQNrDgIAAQQLIAAgBBBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiBCAAKAIMSQ0AIAAoAhBBLGohBAsgBCgCAEEQaiIEECchASADIAQ2AkQgAyABNgI8IANBPGohBAwBCyAAQQEQyAEiBA0AQcDsKSEHDAELAkACQCAAQQJB+O0qENwBBEBBwOwpIQcgACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkAgAS0ABEEPcUEDaw4CAAEECyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRBqIgEgACgCDEkNACAAKAIQQSxqIQELIAEoAgBBEGoiARAnIQYgAyABNgI0IAMgBjYCLCADQSxqIQEMAQsgAEECEMgBIgFFBEBBwOwpIQcMAgsgASgCACEGCyAAIAQoAgAgBmpBAWoQhgEiBgR/IAQoAgAiBwRAIAYoAgggBCgCCCAH/AoAAAsgASgCACIHBEAgBigCCCAEKAIAaiABKAIIIAf8CgAACyAGIAEoAgAgBCgCAGoiBzYCACAGIAdBAWo2AgRBAAVB6dsrCyEHIAZBAEchBiABIANBLGpGDQAgASABKAIMIgJBAWs2AgwgAkEBSg0AAkAgASgCCCICRQ0AAkBBpIg0KAIAIgVFDQAgAyACNgJMIAUoAgAiCCADKAJMSw0AIAMoAkwgCCAFKAIQak8NACACIAUoAgQ2AgAgBSACNgIEIAUgBSgCCEEBajYCCCAFKAIUIgVBBEkNASAFQXxxIgVFDQEgAkEAIAX8CwAMAQsgAhArCwJAQaSINCgCACICRQ0AIAMgATYCTCACKAIAIgUgAygCTEsNACADKAJMIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIAFBACAC/AsADAELIAEQKwsCQCAEIANBPGpGDQAgBCAEKAIMIgFBAWs2AgwgAUEBSg0AAkAgBCgCCCIBRQ0AAkBBpIg0KAIAIgJFDQAgAyABNgJMIAIoAgAiBSADKAJMSw0AIAMoAkwgBSACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgAUEAIAL8CwAMAQsgARArC0GkiDQoAgAiAQRAIAMgBDYCTAJAAkAgASgCACICIAMoAkxLDQAgAygCTCACIAEoAhBqTw0AIAQgASgCBDYCACABIAQ2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAEQQAgAfwLAAwBCyAEECsLIAZFDQIMAwsgBBArCyAGDQELIAMgBzYCBCADQZnBKjYCACAAQfyIKiADEGwACyADQZnBKjYCECAAQeCHKiADQRBqEJsBIANB0ABqJABBAQvDBQEGfyMAQSBrIgMkACADQcTAKjYCECAAQfmGKiADQRBqEJsBIABBARDIASEBIABBAhDIASEFIAAoAgxBAUERIAEoAgggBSgCCCABKAIAIgIgBSgCACIEIAIgBEgbEIQCQQBOGzoABCAAIAAoAgxBCGo2AgwgASABKAIMIgJBAWs2AgwCQCACQQFKDQBBpIg0KAIAIQICQAJAIAEoAggiBARAIAIEQCADIAQ2AhwCQCACKAIAIgYgAygCHEsNACADKAIcIAYgAigCEGpPDQAgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCIGQQRJDQMgBkF8cSIGRQ0DIARBACAG/AsADAMLIAQQKwwCCyAEECsMAgsgAkUNAQsgAyABNgIcIAIoAgAiBCADKAIcSw0AIAMoAhwgBCACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgAUEAIAL8CwAMAQsgARArCyAFIAUoAgwiAUEBazYCDAJAIAFBAUoNAEGkiDQoAgAhAQJAAkAgBSgCCCICBEAgAQRAIAMgAjYCHAJAIAEoAgAiBCADKAIcSw0AIAMoAhwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgRBBEkNAyAEQXxxIgRFDQMgAkEAIAT8CwAMAwsgAhArDAILIAIQKwwCCyABRQ0BCyADIAU2AhwgASgCACICIAMoAhxLDQAgAygCHCACIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAFQQAgAfwLAAwBCyAFECsLIANBxMAqNgIAIABB4IcqIAMQmwEgA0EgaiQAQQEL4AQBB38jAEEwayICJAAgAkGP4Sk2AiAgAEH5hiogAkEgahCbAQJAAkAgAEEBEMgBIgNFBEBB6dsrIQcMAQsCQCAAIAMoAgAQhgEiBUUEQCAAQenbK0EAEG4gAyADKAIMIgFBAWs2AgxBmdwrIQcgAUEBTA0BDAILIAUoAgQiBEEASgRAA0AgBSgCCCABakEAOgAAIAFBAWoiASAFKAIEIgRIDQALCyAFQQA2AgAgBSADKAIAIgEgBCABIARIGyIBNgIAIAFBAEoEQEEAIQEDQCAFKAIIIAFqIAMoAgggAWotAAA6AAAgAUEBaiIBIAUoAgBIDQALCyADIAMoAgwiAUEBazYCDCABQQFKDQILQaSINCgCACEBAkACQAJAIAMoAggiBARAIAFFDQIgAiAENgIsAkAgASgCACIGIAIoAixLDQAgAigCLCAGIAEoAhBqTw0AIAQgASgCBDYCACABIAQ2AgQgASABKAIIQQFqNgIIIAEoAhQiBkEESQ0CIAZBfHEiBkUNAiAEQQAgBvwLAAwCCyAEECsMAQsgAUUNAgsgAiADNgIsAkACQCABKAIAIgQgAigCLEsNACACKAIsIAQgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIANBACAB/AsADAELIAMQKwsgBUUNAgwDCyAEECsLIAMQKyAFDQELIAIgBzYCBCACQY/hKTYCACAAQfyIKiACEGwACyACQY/hKTYCECAAQeCHKiACQRBqEJsBIAJBMGokAEEBC94EAQd/IwBBMGsiAiQAIAJBouEpNgIgIABB+YYqIAJBIGoQmwECQAJAIABBABCYASIERQRAQYDcKyEGDAELAkAgACAEKAIAIgYQhgEiBUUEQCAAQenbK0EAEG4gBCAEKAIMIgFBAWs2AgxBmdwrIQYgAUEBTA0BDAILIAUoAgQiA0EASgRAA0AgBSgCCCABakEAOgAAIAFBAWoiASAFKAIEIgNIDQALCyAFIAYgAyADIAZKGyIBNgIAIAFBAEoEQCAEKAIIIQNBACEBA0AgBSgCCCABaiABIANqLQAAOgAAIAFBAWoiASAFKAIASA0ACwsgBCAEKAIMIgFBAWs2AgxBACEGIAFBAUoNAgtBpIg0KAIAIQECQAJAAkAgBCgCCCIDBEAgAUUNAiACIAM2AiwCQCABKAIAIgcgAigCLEsNACACKAIsIAcgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIHQQRJDQIgB0F8cSIHRQ0CIANBACAH/AsADAILIAMQKwwBCyABRQ0CCyACIAQ2AiwCQAJAIAEoAgAiAyACKAIsSw0AIAIoAiwgAyABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBEEAIAH8CwAMAQsgBBArCyAFRQ0CDAMLIAMQKwsgBBArIAUNAQsgAiAGNgIEIAJBouEpNgIAIABB/IgqIAIQbAALIAJBouEpNgIQIABB4IcqIAJBEGoQmwEgAkEwaiQAQQEL/QQBCn8jAEEwayIDJAAgA0GQqSo2AiAgAEH5hiogA0EgahCbAQJAAkACQAJAIAAoAhQoAgBBCGoiASAAKAIMSQRAIAEtAARBD3ENAUGAgPoBIQQMAgsgACgCEC0AMEEPcUUEQEGAgPoBIQQMAgsgACgCEEEsaiEBCwJ9IAEtAAQiAkETRgRAIAEqAgAMAQsgAkEDRgRAIAEoAgCyDAELIAJBD3FBBEcNAiABKAIAIgFBEGogA0EoahDBASEFIAUgAS0AByICQf8BRgR/IAEoAgwFIAILQQFqRw0CIAMoAigiAbIgAb4gAy0ALEEDRhsL/AAiBEEATA0CCyADIAQ2AhAgAEGL/ykgA0EQahBbIARBA3EhB0EAIQUgACAEEIYBIQJBACEBAkAgBEEESQ0AAkAgBEEEayIIQQRJBEAMAQsgCEECdkEBakH+////B3EhCgNAIAIoAgggAWpBADoAACACKAIIIAFqQQA6AAEgAigCCCABakEAOgACIAIoAgggAWpBADoAAyABQQRyIgYgAigCCGpBADoAACACKAIIIAZqQQA6AAEgAigCCCAGakEAOgACIAIoAgggBmpBADoAAyABQQhqIQEgCUECaiIJIApHDQALCyAIQQRxDQAgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBGohAQsgBwRAA0AgAigCCCABakEAOgAAIAFBAWohASAFQQFqIgUgB0cNAAsLIAIgBDYCACADQZCpKjYCACAAQeCHKiADEJsBIANBMGokAEEBDwsgAEEBQYagKhDUAQALIABBs+QpQQAQbAAL3gIBBn8jAEEgayICJAAgAkHH6ys2AhAgAEH5hiogAkEQahCbASAAKAIUKAIAQQhqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgEgACgCDCIESQ0AIAAoAhBBLGohAQsCQAJAAkAgASgCACIDLQAQIgFFDQAgA0EQaiEGQQAhAwNAIAMhBSABwBB0RQRAIAFB/wFxQStrIgFBEksNAkEBIAF0QZGAEHFFDQILIAYgBUEBaiIDai0AACIBDQALIAVBAksNAQsgBEEBOgAEIAAgACgCDEEIajYCDCAAQfylK0EAEFsMAQsgBEEROgAEIAAgACgCDEEIajYCDAsgAkHH6ys2AgAgAEHghyogAhCbASACQSBqJABBAQ8LIABBAUGytisQhgIAC8sCAQZ/IwBBIGsiAiQAIAJBnesrNgIQIABB+YYqIAJBEGoQmwEgACgCFCgCAEEIaiIBIAAoAgwiBE8EQCAAKAIQQSxqIQELAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiBEkNACAAKAIQQSxqIQELAkACQAJAIAEoAgAiAy0AECIBRQ0AIANBEGohBUEAIQMDQCADIQYgAUH/AXFBgOEsai0AAEE/Sw0BIAUgA0EBaiIDai0AACIBDQALIAZBAUsNAQsgBEEBOgAEIAAgACgCDEEIajYCDCAAQdelK0EAEFsMAQsgBEEROgAEIAAgACgCDEEIajYCDAsgAkGd6ys2AgAgAEHghyogAhCbASACQSBqJABBAQ8LIABBAUGytisQhgIAC98CAQV/IwBBIGsiAiQAIAJBluYrNgIQIABB+YYqIAJBEGoQmwEgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELAkACQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMIgNJDQAgACgCEEEsaiEBCyABKAIAIgQtABAiAUUNASAEQRBqIQVBACEEA0ACQCAAIAHAIgFBoOosai0AAEH/AUYEf0Hz3ikFIAFBAE4NAUHV3ikLQQAQWyAAKAIMIQMMAwsgBSAEQQFqIgRqLQAAIgENAAsgA0EROgAEIAAgACgCDEEIajYCDAwCCyAAQQFBsrYrEIYCAAsgA0EBOgAEIAAgACgCDEEIajYCDCAAQbGlK0EAEFsLIAJBluYrNgIAIABB4IcqIAIQmwEgAkEgaiQAQQEL1QIBBX8jAEEgayICJAAgAkHTuyk2AhAgAEH5hiogAkEQahCbASAAKAIUKAIAQQhqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQAJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiBEkNACAAKAIQQSxqIQELIAEoAgAiA0EQaiEFIAMtABAiAUEwRgRAIAVBAkEAIAMtABFB+ABGG2oiBS0AACEBCyABQf8BcUUNAUEAIQMDQCABwBB4RQ0CIAUgA0EBaiIDai0AACIBDQALIARBEToABCAAIAAoAgxBCGo2AgwMAgsgAEEBQbK2KxCGAgALIARBAToABCAAIAAoAgxBCGo2AgwgAEH2pCtBABBbCyACQdO7KTYCACAAQeCHKiACEJsBIAJBIGokAEEBC8wCAQV/IwBBIGsiAiQAIAJBubkqNgIQIABB+YYqIAJBEGoQmwEgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiA0kNACAAKAIQQSxqIQELIAEoAgBBEGohBUEAIQECQAJAAkADQAJAAkAgASAFai0AACIEQTBrQQJJDQAgBEUNASAEQSBGDQAgBMBBDmtBe0kNAwsgAUEBaiEBDAELCyABDQELIANBAToABCAAIAAoAgxBCGo2AgwgAEHQpCtBABBbDAELIANBEToABCAAIAAoAgxBCGo2AgwLIAJBubkqNgIAIABB4IcqIAIQmwEgAkEgaiQAQQEPCyAAQQFBsrYrEIYCAAuOAgIEfwF+IwBBIGsiAiQAIAJBxZwqNgIQIABB+YYqIAJBEGoQmwEgAkEANgIcAkACfyAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELIAEtAARBA0YEQCABKAIADAELIAEgAkEcakEAEPwBRQ0BIAIoAhwLIQMgAEEQEIYBIgQoAggiAUIANwAAIAEgAzoADyABIANBCHY6AA4gASADQRB2OgANIAEgA0EYdjoADCABIANBH3U6AAsgASADrCIFQiiIPAAKIAEgBUIwiDwACSABIAVCOIg8AAggBEEQNgIAIAJBxZwqNgIAIABB4IcqIAIQmwEgAkEgaiQAQQEPCyAAQf2eKkEAEGwAC/kHAQ9/IwBBIGsiBiQAIAZB4+srNgIQIABB+YYqIAZBEGoQmwEgACgCFCgCAEEIaiICIAAoAgxPBEAgACgCEEEsaiECCwJAAkACQAJAIAItAARBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiICIAAoAgxJDQAgACgCEEEsaiECCyACKAIAIgEtABAiAkUNASABQRBqIQcDQCAEIQMgAsAQdEUEQCACQf8BcUErayICQRJLDQNBASACdEGRgBBxRQ0DCyAHIANBAWoiBGotAAAiAg0ACyAAIANBBGpBAnZBA2wQhgEhBQJAIAcQJyIMQQBMBEBBACEDDAELIAFBE2ohDSABQRJqIQ4gAUERaiEPQQAhA0EAIQQDQCADIAUoAgRODQFBACECIAQgB2osAAAiAUEhTgRAIAhBP0E+Qb9/QdAAIAFBwQBrQf8BcUEaSRsgAWoiAkGXAWsgAiACQbEBa0EaSRsiAkHMAGsgAiACQYABa0EKSRsiAiACQfsARhsiAiACQf8ARhsiAiACQY0BRiICGyEICyAEIA9qLAAAIgFBIU4EQCAJQT9BPkG/f0HQACABQcEAa0H/AXFBGkkbIAFqIgFBlwFrIAEgAUGxAWtBGkkbIgFBzABrIAEgAUGAAWtBCkkbIgEgAUH7AEYbIgEgAUH/AEYbIgEgAUGNAUYiARshCSABIAJqIQILIAQgDmosAAAiAUEhTgRAIApBP0E+Qb9/QdAAIAFBwQBrQf8BcUEaSRsgAWoiAUGXAWsgASABQbEBa0EaSRsiAUHMAGsgASABQYABa0EKSRsiASABQfsARhsiASABQf8ARhsiASABQY0BRiIBGyEKIAEgAmohAgsgBCANaiwAACIBQSFOBEAgC0E/QT5Bv39B0AAgAUHBAGtB/wFxQRpJGyABaiIBQZcBayABIAFBsQFrQRpJGyIBQcwAayABIAFBgAFrQQpJGyIBIAFB+wBGGyIBIAFB/wBGGyIBIAFBjQFGIgEbIQsgASACaiECCwJAIAJBAksNACAFKAIIIANqIAhBAnQgCUEEdnI6AAAgA0EBaiEBIAJBAkYEQCABIQMMAQsgBSgCBCABTARAIAEhAwwBCyAFKAIIIAFqIAlBBHQgCkECdnI6AAAgA0ECaiEBIAJBAUYEQCABIQMMAQsgBSgCBCABTARAIAEhAwwBCyAFKAIIIAFqIAsgCkEGdHI6AAAgA0EDaiEDCyAEQQRqIgQgDEgNAAsLIAUgAzYCACAGQePrKzYCACAAQeCHKiAGEJsBIAZBIGokAEEBDwsgAEEBQau2KxCGAgALIABB6vUpQQAQbAALgwUBCn8jAEEgayIFJAAgBUG+6is2AhAgAEH5hiogBUEQahCbASAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELAkACQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCACIDQRBqIQRBACEBIAMtABAiAgR/QQAhAwNAQQEgAyACQf8BcUGA5CxqLAAAQT9KGyEDIAQgAUEBaiIBai0AACICDQALIANFBUEBCyEDIAFBA24iAkF9bCABaiIBQQFGDQEgA0UNASAAIAJBAXQgAUEBdnIQhgEhCUEAIQMCQCAELQAAIgJFBEBBACEBDAELIAkoAgghCkEAIQECQANAIAMgBGoiCC0AASIHRQ0FIAJB/wFxIQIgCC0AAiIIBEAgASAKaiAHQYDkLGosAABB//8DcUEtbCACQYDkLGosAABB//8DcWogCEGA5CxqLAAAQf//A3FB6Q9saiICQQh0IAJBgP4DcUEIdnI7AABBASAGIAJB//8DSxshBiABQQJqIQEgBCADQQNqIgNqLQAAIgINAQwCCwsgB0GA5CxqLAAAIQQCQAJAIAJBgOQsaiwAACIDQf//A3EiAkE/Sw0AIARB//8DcSIHQT9LDQAgB0EtbCACakGAAkkNAQtBASEGCyABIApqIARBLWwgA2o6AAAgAUEBciEBCyAGDQMLIAkgATYCACAFQb7qKzYCACAAQeCHKiAFEJsBIAVBIGokAEEBDwsgAEEBQf61KxCGAgALIABBl/UpQQAQbAALIABB2ewqQQAQbAALrgUBB38jAEEgayIEJAAgBEGz6ys2AhAgAEH5hiogBEEQahCbASAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELAkACQAJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgxJDQAgACgCEEEsaiEBCyABKAIAIgEtABAiAkUNASABQRBqIQEDQCADIQUgAkH/AXFBgOEsai0AAEE/Sw0CIAEgA0EBaiIDai0AACICDQALIAAgBUEEakECdkEDbBCGASIHKAIIIQYgASECA0AgAi0AACEDIAJBAWoiBSECIANBgOEsai0AAEHAAEkNAAsgBSABQX9zaiIDQQVODQIgBiECDAMLIABBAUGVtisQhgIACyAAQcH1KUEAEGwACyAGIQIDQCACIAEtAABBgOEsai0AAEECdCABLQABQYDhLGotAABBBHZyOgAAIAIgAS0AAUGA4SxqLQAAQQR0IAEtAAJBgOEsai0AAEECdnI6AAEgAiABLQADQYDhLGotAAAgAS0AAkGA4SxqLQAAQQZ0cjoAAiABQQRqIQEgAkEDaiECIANBCEshBSADQQRrIQMgBQ0ACwsCQCADQQJIDQAgAiABLQAAQYDhLGotAABBAnQgAS0AAUGA4SxqLQAAQQR2cjoAACADQQJGBEAgAkEBaiECDAELIAIgAS0AAUGA4SxqLQAAQQR0IAEtAAJBgOEsai0AAEECdnI6AAEgA0EERwRAIAJBAmohAgwBCyACIAEtAANBgOEsai0AACABLQACQYDhLGotAABBBnRyOgACIAJBA2ohAgsgAkEAOgAAIAcgAiAGazYCACAEQbPrKzYCACAAQeCHKiAEEJsBIARBIGokAEEBC7gNAhh/AX4jAEEwayIHJAAgB0Gu5is2AiAgAEH5hiogB0EgahCbASAAKAIUKAIAQQhqIgIgACgCDE8EQCAAKAIQQSxqIQILAkACQAJAAkACQCACLQAEQQ9xQQNrDgIAAQILIAAgAhBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiAiAAKAIMSQ0AIAAoAhBBLGohAgsgAigCACICLQAQIgNFDQIgAkEQaiEEQQAhAgNAIAIhAQJAIAAgA8AiAkGg6ixqLQAAQf8BRgR/QfPeKQUgAkEATg0BQdXeKQtBABBbDAQLIAQgAUEBaiICai0AACIDDQALIAFBBGpBAnZBA2whAwJAQaSINCgCACIBBEACfwJAIAMgASgCFEsNACABKAIEIgZFDQAgASgCGCADQQJ0aiIJIAkoAgBBAWo2AgAgASABKAIcQQFqNgIcIAEgASgCICADajYCICABIAEoAiwgA2o2AiwgASAGKAIANgIEQQghCEF/DAELIAMQKiIGRQRAEE8LIAEgASgCJEEBajYCJCABIAEoAiggA2o2AihBLCEIIAMLIQkgASAIaiIBIAEoAgAgCWo2AgAMAQsgAxAqIQYLIAcgAzYCKAJ/QQAhCUF/IAdBKGoiDSgCACIQQQNxIg5BA3QiFHQhBSMAIBBBA2oiD0F8cSILQQ9qQXBxayEKAkAgD0EESQ0AIAtFDQAgCkEAIAv8CwALIAVBACAOGyEVIA9BAnYhDAJAAkACQANAIAQgCWotAABBMUcNASAJQQFqIgkgAkcNAAsgAiEJDAELIAIgCU0NACAKQQRrIQsgD0EEcSEWIAogDEEBayIXQQJ0aiETIAkhEQNAIAQgEWosAAAiAUEASA0CIAFBoOosaiwAACIFQX9GDQICQCAPQQRJDQAgFgR/IBMgBa0gEzUCAEI6fnwiGT4CACAZQiCIpyEFIBcFIAwLIQEgDEEBRg0AIAFBAmsiCEECcUUEQCALIAFBAnRqIgEgBa0gATUCAEI6fnwiGT4CACAKIAhBAnRqIgEgATUCAEI6fiAZQiCIfCIZPgIAIBlCIIinIQUgCCEBCyAIQQJJDQADQCALIAFBAnQiCGoiGCAFrSAYNQIAQjp+fCIZPgIAIAogCEEIayIFaiIIIAg1AgBCOn4gGUIgiHwiGT4CACAFIAtqIgUgBTUCAEI6fiAZQiCIfCIZPgIAIAogAUEEayIBQQJ0aiIFIAU1AgBCOn4gGUIgiHwiGT4CACAZQiCIpyEFIAENAAsLIAUNAiAKKAIAIBVxDQIgEUEBaiIRIAJHDQALCwJ/IA5FBEBBACECIAYMAQsgBiAKKAIAIgEgFEEIa3Y6AABBASECIAZBAWogDkEBayIERQ0AGiAGIAEgBEEDdEEIa3Y6AAEgBkECaiAOQQJrIgRFDQAaIAYgASAEQQN0QQhrdjoAAiAGQQNqCyEBAkAgAiAMTw0AIAJBAWohBCAMIAJrQQFxBEAgASAKIAJBAnRqKAIAIgJBGHQgAkGA/gNxQQh0ciACQQh2QYD+A3EgAkEYdnJyNgAAIAFBBGohASAEIQILIAQgDEYNACAKQQRqIQgDQCABIAogAkECdCIFaiIEKAIAIgtBEHY6AAEgASALQRh2OgAAIAEgBCgCAEEIdjoAAiABIAQoAgA6AAMgASAFIAhqIgQoAgAiBUEQdjoABSABIAVBGHY6AAQgASAEKAIAQQh2OgAGIAEgBCgCADoAByABQQhqIQEgAkECaiICIAxHDQALCwJAIBBFDQBBACEBA0AgASAGai0AAA0BIA0gDSgCAEEBazYCACABQQFqIgEgEEcNAAsLIA0gDSgCACAJajYCAEEBIRILIBJFBEBBACEDQbrmKwwBCyAAIAcoAigiAhCGASIBRQRAQQAhA0Hp2ysMAQsgAiADIAIgA0kbIgQEQCABKAIIIAYgAiADayADIAJrIAIgA0sbaiAE/AoAAAsgASACNgIAQQEhA0EACyEBAkACQEGkiDQoAgAiAkUNACAGRQ0BIAcgBjYCLCACKAIAIgQgBygCLEsNACAHKAIsIAQgAigCEGpPDQAgBiACKAIENgIAIAIgBjYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIAZBACAC/AsADAELIAYQKwsgA0UNASAHQa7mKzYCACAAQeCHKiAHEJsBIAdBMGokAEEBDwsgAEEBQee1KxCGAgALIAcgATYCFCAHQa7mKzYCECAAQfyIKiAHQRBqEGwACyAAQe30KUEAEGwAC84CAQV/IwBBMGsiAiQAIAJB9+oqNgIgIABB+YYqIAJBIGoQmwEgACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgxJDQAgACgCEEEsaiEBCyABKAIAQRBqIgQQJyIBQYCA+gFKDQEgACABQQFqEIYBIQNBACEBIAQtAAAiBQRAA0AgAygCCCABaiAFOgAAIAQgAUEBaiIBai0AACIFDQALCyADIAE2AgAgAygCCCABakEAOgAAIAJB9+oqNgIQIABB4IcqIAJBEGoQmwEgAkEwaiQAQQEPCyAAQQFBsrYrEIYCAAsgAiABNgIEIAJB9+oqNgIAIABB78cpIAIQbiAAQY2zK0EAEGwAC/4DAQh/IwBBIGsiAyQAIANBnrwqNgIQIABB+YYqIANBEGoQmwEgACgCFCICKAIAQQhqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiAigCAEEIaiIBIAAoAgwiBEkNACAAKAIQQSxqIQELIAEoAgAhByADQQA2AhwgAAJ/IAQgAigCAEEQaiIBTQRAIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAMAQsgASADQRxqQQAQ/AFFDQIgAygCHAsiBhCGASECAkAgBkEATA0AIAdBEGohBEEAIQdBACEBIAZBBE8EQCAGQfz///8HcSEIA0AgAigCCCABaiABIARqLQAAOgAAIAFBAXIiBSACKAIIaiAEIAVqLQAAOgAAIAFBAnIiBSACKAIIaiAEIAVqLQAAOgAAIAFBA3IiBSACKAIIaiAEIAVqLQAAOgAAIAFBBGoiASAIRw0ACwsgBkEDcSIFRQ0AA0AgAigCCCABaiABIARqLQAAOgAAIAFBAWohASAHQQFqIgcgBUcNAAsLIAIgBjYCACADQZ68KjYCACAAQeCHKiADEJsBIANBIGokAEEBDwsgAEEBQbK2KxCGAgALIABBwJ8qQQAQbAALpQYBCX8jAEHgAGsiAiQAIAJB6bspNgJQIABB+YYqIAJB0ABqEJsBIAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQAJAAkACQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCACIDLQAQIgRFDQMgA0EQaiEHIARBMEcNASADLQARQfgARw0BIANBEmohBSADLQASIgRBMEYEQCAFQQJBACADLQATQfgARhtqIgUtAAAhBAsgBEH/AXFFDQNBACEBA0AgBMAQeEUNBCAFIAFBAWoiAWotAAAiBA0ACwwCCyACQem7KTYCECAAQdPZKSACQRBqEG4gACgCDEEBOgAEIAAgACgCDEEIajYCDAwDC0EAIQEDQCAEwBB4RQ0CIAcgAUEBaiIBai0AACIEDQALCyACIAE2AkAgAEGqxykgAkFAaxBbIAFBgYD6AU4EQCACIAFBAXQ2AiAgAEGBgCogAkEgahBuIAAoAgxBAToABCAAIAAoAgxBCGo2AgwMAgsCQCAAIAFBAXUQhgEiBgJ/AkACQAJAAkAgBy0AACIFQTBGBEAgAy0AEUH4AEcNASABQQFxRQ0EIANBEWoiAUEwOgAAIAYoAgggARDCAQwFCyAFRQ0BCyAGKAIIIQggA0ERaiEJQQAhAUEAIQQDQAJAIAQgCWosAAAiA0UNACAFwEECdEGA2SxqKAIAIgVBAEgNACADQQJ0QYDZLGooAgAiA0EASA0AIAEgCGogBUEEdCADcjoAACABQQFqIQEgByAEQQJqIgRqLQAAIgUNAQwDCwsgBkF/NgIADAQLQQAhAQsgBiABNgIADAQLIAYoAgggA0ESahDCAQsiATYCACABQQBODQILIAJB6bspNgIwIABBv+sqIAJBMGoQbiAAQY2zK0EAEGwACyAAQZWvK0EAEG4gACgCDEEBOgAEIAAgACgCDEEIajYCDAsgAkHpuyk2AgAgAEHghyogAhCbASACQeAAaiQAQQELgAQBCH8jAEEwayIBJAAgAUHLuSo2AiAgAEH5hiogAUEgahCbASAAKAIUKAIAQQhqIgIgACgCDE8EQCAAKAIQQSxqIQILAkACQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgIgACgCDEkNACAAKAIQQSxqIQILIAIoAgBBEGohBUEAIQIDQAJAAkAgAiAFai0AACIDQTBrQQJJDQAgA0UNASADQSBGDQAgA8BBDmtBe08NAEEAIQIMBAsgAkEBaiECDAELCyACQYGA/QBrQf//gn9NDQEgACACQQRqEIYBIQcgAUEAOgAvA0ACQCAFLQAAIgNBIEYNACADwEEOa0F6Sw0AIAZBBkwEQCADQTFGBEAgASABLQAvQQFyOgAvCyABIAEtAC9BAXQ6AC8gBkEBaiEGDAELIANBMUYEQCABIAEtAC9BAXI6AC8LIAcoAgggBGogAS0ALzoAAEEAIQYgAUEAOgAvIARBAWohBAsgBUEBaiEFIAhBAWoiCCACRw0ACyAHKAIIIARqQQA6AAAgByAENgIAIAFBy7kqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQEPCyAAQQFB0bYrEIYCAAsgASACNgIAIABBi8gpIAEQbiAAQY2zK0EAEGwAC6kPAhN/AXsjAEHwA2siASQAIAFBxsUrNgIwIABB+YYqIAFBMGoQmwEgACgCFCgCAEEIaiIDIAAoAgxPBEAgACgCEEEsaiEDCwJAAkACQAJAAkACQCADLQAEQQ9xQQNrDgIAAQILIAAgAxBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiAyAAKAIMSQ0AIAAoAhBBLGohAwsgAygCAEEQaiEGIABBIBCYASIJKAIIIQhBACEDAkACQANAAkACQCADIAZqLQAAIgJBIEcEQCACDQEgCkEXSw0FQQEgCnRBgJCIBHFFDQVBACEDIAFBADsB6AMgAUIANwPgAyABQQA6AJABIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSAASABIBT9CwRwIAYtAAAiAkUNBCABQekDaiELIAFB6ANqIQwgAUHnA2ohDSABQeYDaiEOIAFB5QNqIQ8gAUHkA2ohECABQeMDaiERIAFB4gNqIRIgAUHhA2ohEwwCCyAKQQFqIQoLIANBAWohAwwBCwsDQCABQeADaiEHAkAgAkH/AXFBIEYEQEEBIQIMAQsgASACOgDgAyAGIAVBAWoiBGotAAAiAkEgckEgRgRAIAQhBSATIQcMAQsgASACOgDhAyAGIAVBAmoiBGotAAAiAkEgckEgRgRAIAQhBSASIQcMAQsgASACOgDiAyAGIAVBA2oiBGotAAAiAkEgckEgRgRAIAQhBSARIQcMAQsgASACOgDjAyAGIAVBBGoiBGotAAAiAkEgckEgRgRAIAQhBSAQIQcMAQsgASACOgDkAyAGIAVBBWoiBGotAAAiAkEgckEgRgRAIAQhBSAPIQcMAQsgASACOgDlAyAGIAVBBmoiBGotAAAiAkEgckEgRgRAIAQhBSAOIQcMAQsgASACOgDmAyAGIAVBB2oiBGotAAAiAkEgckEgRgRAIAQhBSANIQcMAQsgASACOgDnAyAGIAVBCGoiBGotAAAiAkEgckEgRgRAIAQhBSAMIQcMAQsgASACOgDoAyALIQcgBiAFQQlqIgVqLQAAIgJBIHJBIEcNAwtBACEEIAdBADoAACAFIAJBAEdqIQVBz7cqIQIDQAJAIAFB4ANqIAIQrQFFBEBBACECA0AgBEEKIAJrdkEBcQRAIAFB8ABqIANBA3ZqIgcgBy0AAEEBIANBf3NBB3F0cjoAAAsgA0EBaiEDIAJBAWoiAkELRw0ACwwBCyAEQQFqIgRBAnRB8JgsaigCACICDQEMBAsLIAUgBmotAAAiAg0ACwsgAyAKQQtsQQtqRw0AIAEgAS0AkAE6AGAgASAB/QAEgAH9CwRQIAEgAf0ABHD9CwRAAkAgA0GEAUYNACADQYgCRg0AIANBxgFHDQELIAkgA0H//wNxQQtuQQJ0QfwBcUEDbiIENgIAIAQEQCAIIAFBQGsgBPwKAAALIAFBQGsgBGotAAAhBUEAIQIgAUGYAWoiB0EAQYAC/AsAIAFBIDYC2AMgAUKrs4/8kaOz8NsANwKQASABQv+kuYjFkdqCm383AogBIAFC8ua746On/aelfzcCgAEgAULnzKfQ1tDrs7t/NwJ4IAFCADcCcANAIAcgASgCcCIGQQN2QTxxaiIKIAFBQGsgAmotAAAgCigCAEEIdHI2AgAgASAGQQhqIgY2AnACQAJAIAZFBEAgAUEANgJwIAEgASgCdEEBajYCdAwBCyAGQf8DcQ0BCyABQfAAahD3AQsgAkEBaiICIARHDQALIAFB8ABqIAFBQGsQ+AEgA0GEAWtBCk0EQCABLQBAIAVB/wFxc0EQSQ0DDAELIANBxgFrQQpNBEAgAS0AQCAFQf8BcXNBBE8NAQwDCyADQYgCa0EKSw0AIAEtAEAgBUH/AXFGDQILIAFBxsUrNgIgIABBt+spIAFBIGoQbiAAKAIMQQE6AAQgACAAKAIMQQhqNgIMDAILIAFBxsUrNgIQIABB09kpIAFBEGoQbiAAKAIMQQE6AAQgACAAKAIMQQhqNgIMDAILIAAgBBCGASIDRQRAIABB6dsrQQAQbgwBCyADKAIEIgZBAEoEQEEAIQIDQCADKAIIIAJqQQA6AAAgAkEBaiICIAMoAgQiBkgNAAsLIAMgBCAGIAQgBkgbIgI2AgAgAkEATA0AQQAhAgNAIAMoAgggAmogAiAIai0AADoAACACQQFqIgIgAygCAEgNAAsLIAkgCSgCDCIDQQFrNgIMIANBAUoNAEGkiDQoAgAhAwJAAkAgCARAIAMEQCABIAg2AnACQCADKAIAIgIgASgCcEsNACABKAJwIAIgAygCEGpPDQAgCCADKAIENgIAIAMgCDYCBCADIAMoAghBAWo2AgggAygCFCICQQRJDQMgAkF8cSICRQ0DIAhBACAC/AsADAMLIAgQKwwCCyAIECsMAgsgA0UNAQsgASAJNgJwIAMoAgAiAiABKAJwSw0AIAEoAnAgAiADKAIQak8NACAJIAMoAgQ2AgAgAyAJNgIEIAMgAygCCEEBajYCCCADKAIUIgNBBEkNASADQXxxIgNFDQEgCUEAIAP8CwAMAQsgCRArCyABQcbFKzYCACAAQeCHKiABEJsBIAFB8ANqJABBAQvsCwEMfyMAQUBqIgYkACAGQb2uKzYCMCAAQfmGKiAGQTBqEJsBIAAoAhQoAgBBCGoiASECAkACfyABIAAoAgxJIgNFBEAgACgCEEEsaiECCwJAIAItAARBD3EiBw0AIAIgACgCEEEsakcNAEEADAELIAdBAWoLQQJ0QfCxL2ooAgBB+O0qEK0BBEBBge0qIQgMAQtB2dkpIQggA0UEQCAAKAIQQSxqIQELAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCAEEQaiIBECciAiACQQlrIAFB4eQrQQkQxQEiAhtBJEcEQEGp4CohCAwBC0H+hywhCCABQQBBCSACG2oiBC0ACEEtRw0AIAQtAA1BLUcNACAELQASQS1HDQAgBC0AF0EtRw0AIAQQrgIiByEBA0ACQCABLQAAIgJBLUcEQCACDQEgB0UEQCAGQde7KTYCECAAQYWHKiAGQRBqEG5Bla8rIQgMBAsgByEDQZWvKyEIIActAAAiAUEwRgRAIAdBAkEAIActAAFB+ABGG2oiAy0AACEBCwJAAkACQCABQf8BcUUNAEEAIQIDQCABwBB4RQ0BIAMgAkEBaiICai0AACIBDQALIAQQrgIhBSAAQSUQhgEhCyAFIQECQANAAkACQCABLQAAIgJBLUcEQCACDQFBrborIQgCQCAFLQAAIgNFDQAgCygCCCEJIAVBAWohCkEAIQJBACEBA0AgASAKaiwAACIERQ0BIAPAQQJ0QYDZLGooAgAiA0EASA0BIARBAnRBgNksaigCACIEQQBIDQEgAiAJaiADQQR0IARyOgAAIAJBAWohAiAFIAFBAmoiAWotAAAiAw0ACyACQQRHDQAgBS0ACSIDRQ0AIAVBCWohCSALKAIIQQRqIQwgBUEKaiEKQQAhAkEAIQEDQCABIApqLAAAIgRFDQEgA8BBAnRBgNksaigCACIDQQBIDQEgBEECdEGA2SxqKAIAIgRBAEgNASACIAxqIANBBHQgBHI6AAAgAkEBaiECIAkgAUECaiIBai0AACIDDQALIAJBAkcNACAFLQAOIgNFDQAgBUEOaiEJIAsoAghBBmohDCAFQQ9qIQpBACECQQAhAQNAIAEgCmosAAAiBEUNASADwEECdEGA2SxqKAIAIgNBAEgNASAEQQJ0QYDZLGooAgAiBEEASA0BIAIgDGogA0EEdCAEcjoAACACQQFqIQIgCSABQQJqIgFqLQAAIgMNAAsgAkECRw0AIAUtABMiA0UNACAFQRNqIQkgCygCCEEIaiEMIAVBFGohCkEAIQJBACEBA0AgASAKaiwAACIERQ0BIAPAQQJ0QYDZLGooAgAiA0EASA0BIARBAnRBgNksaigCACIEQQBIDQEgAiAMaiADQQR0IARyOgAAIAJBAWohAiAJIAFBAmoiAWotAAAiAw0ACyACQQJHDQAgCygCCEEKaiAFQRhqEMIBQQZHDQAgC0EQNgIAQQAhCAtBpIg0KAIAIgFFDQIgBiAFNgI8IAEoAgAiAiAGKAI8Sw0EIAYoAjwgAiABKAIQak8NBCAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNBSABQXxxIgFFDQUgBUEAIAH8CwAMBQsgAUEAOgAACyABQQFqIQEMAQsLIAUQKwwCCyAFECsLQaSINCgCACIBRQ0AIAYgBzYCPCABKAIAIgIgBigCPEsNACAGKAI8IAIgASgCEGpPDQAgByABKAIENgIAIAEgBzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAdBACAB/AsADAELIAcQKwsgCA0DIAZBva4rNgIgIABB4IcqIAZBIGoQmwEgBkFAayQAQQEPCyABQeEAOgAACyABQQFqIQEMAAsACyAGIAg2AgQgBkG9ris2AgAgAEH8iCogBhBsAAsgAQJ/IAAQJ0EBaiIBECoiAkUEQEEADwsgAiAAIAEQGwu9AgIGfwF9IwBBIGsiAyQAIANB8sMqNgIQIABB+YYqIANBEGoQmwEgACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAAQiAkETRgRAIAEqAgAhBwwBCyACQQNGBEAgASgCALIhBwwBCyACQQ9xQQRHDQAgASgCACIBQRBqIANBGGoQwQEhBCAEIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNACADKAIYIgGyIAG+IAMtABxBA0YbIQcLIAAgB/wAIgIQhgEhBEEAIQFBkJY0KAIAKAIkIQYgBCACIAQoAgQiBSACIAVIGyIFNgIAIAVBAEoEQANAIAYQaSECIAQoAgggAWogAjoAACABQQFqIgEgBUcNAAsLIANB8sMqNgIAIABB4IcqIAMQmwEgA0EgaiQAQQELhwUBCH8jAEGAAWsiASQAIAFBnfIpNgJAIABB+YYqIAFBQGsQmwEgACgCFCgCAEEIaiICIAAoAgxPBEAgACgCEEEsaiECCwJAAkACQAJAIAItAARBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiICIAAoAgxJDQAgACgCEEEsaiECCwJ/AkAgAUH8AGogAUHQAGogAUHMAGpBksgrIAIoAgBBEGoiAhDEAQ0AIAFB/ABqIAFB0ABqIAFBzABqQZbKKyACEMQBDQAgAUGd8ik2AjAgAEHR8ikgAUEwahBuIAAoAgwhA0EBIQZBAQwBCyAAIAEoAkwiBRCGASEDAkAgBUUEQEEAIQUMAQtBACECIAVBBE8EQCAFQXxxIQgDQCADKAIIIAJqIAFB0ABqIAJqLQAAOgAAIAJBAXIiBCADKAIIaiABQdAAaiAEai0AADoAACACQQJyIgQgAygCCGogAUHQAGogBGotAAA6AAAgAkEDciIEIAMoAghqIAFB0ABqIARqLQAAOgAAIAJBBGohAiAHQQRqIgcgCEcNAAsLIAVBA3EiBEUNAANAIAMoAgggAmogAUHQAGogAmotAAA6AAAgAkEBaiECIAZBAWoiBiAERw0ACwsgAyAFNgIAIAAoAgwiAyABKAJ8NgIAQQMhBkECCyECIAMgBjoABCAAIAAoAgxBCGo2AgwgAUGd8ik2AiAgAEHghyogAUEgahCbAQwBCyABQZ3yKTYCECAAQdPZKSABQRBqEG5BASECIAAoAgxBAToABCAAIAAoAgxBCGo2AgwgAUGd8ik2AgAgAEHghyogARCbAQsgAUGAAWokACACC5UEAQR/IwBBkAFrIgMkAAJAIAAgAUGLpyoQ3AEiAgRAIAIgAigCvAFBAWo2ArwBDAELIAAgARDIASIEBEAgBCgCCC0AACICQd8BTSACQaABcUEgR3FFBEAgAyABNgIAIABB6rgrIAMQbiAEEJoBQQAhAgwCCwJAQaSINCgCACIABEACfwJAIAAoAhRBwAFJDQAgACgCBCICRQ0AIAAoAhgiASABKAKABkEBajYCgAYgACAAKAIcQQFqNgIcIAAgACgCIEHAAWo2AiAgACAAKAIsQcABajYCLCAAIAIoAgA2AgRBCCEFQX8MAQtBwAEQKiICRQRAEE8LIAAgACgCJEEBajYCJCAAIAAoAihBwAFqNgIoQSwhBUHAAQshASAAIAVqIgAgACgCACABajYCAAwBC0HAARAqIQILIAJB4QA2AgQCQCAEKAIAIgFB4QBKDQAgBCgCCCEAAkAgAUECRw0AIAAtAABB/wBHDQAgAC0AAUH/AEcNACACQQhqELICDAELIAAQswJBAEgNACAALQAAIQEgA0HQAGogAEEBahC0AiACQQhqIQUgAUEERgRAIANBEGogAEExahC0AiAFIANB0ABqIANBEGoQtQIaDAELIAFB/gFxQQJHDQAgBSADQdAAaiABQQFxELYCGgsgAkEBNgK8ASAEEJoBDAELQQAhAiAAQfHYKUEAEG4LIANBkAFqJAAgAgucAwIBfwF7IwBBsAJrIgEkACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsCACAAQQE2AjggAEIANwIwIAAgAv0LAiAgACAC/QsCECABIAL9CwIUIAEgAv0LAiQgAUEANgI0IAFBATYCACABIAL9CwIEIAFCq9SZ9cEBNwNwIAFCvLn+6PDPrbwCNwNoIAFCmcfZ2fHo26kcNwNgIAFC28vDi5G2iccINwNYIAFC0tm486C1k7QRNwNQIAFC6Kf2lrDkmJEJNwNIIAFCru/7reGh85gQNwNAIAFBgAFqIAEgAUFAaxDTAiABQqO9xIDQATcDoAIgAULt05uWwabz/xI3A5gCIAFCy+6Ru+Gsl40SNwOQAiABQsO59teglJzPEDcDiAIgAULqg4n7gOueqAk3A4ACIAFC7v//p6Gs//8XNwP4ASABQqvV/v/x///7DzcD8AEgAEE8aiABQfABaiABQYABahDJAiAAQQI2AnQgAEIANwKoASAAIAL9CwKYASAAIAL9CwKIASAAIAL9CwJ4IABBATYCsAEgAUGwAmokAAvxDQIbfwF7IwBBwANrIgEkACABQQA2AvQBIAFCo73EgNABNwOwAiABQu3Tm5bBpvP/EjcDqAIgAULL7pG74ayXjRI3A6ACIAFCw7n216CUnM8QNwOYAiABQuqDifuA656oCTcDkAIgAULu//+noaz//xc3A4gCIAFCq9X+//H///sPNwOAAiABQafbzwM2AuABIAFC55mDqfH1zLIKNwPYASABQruqgeyBmoGCDDcD0AEgAUK//9v88b+BpBs3A8gBIAFCgYCAgID///8fNwPAASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsC5AEgAC0AACECIAFBgANqIABBAWoQtAICfwJAAkAgAkEERgRAIAFBwAJqIABBMWoQtAIgAUEMaiABQYADaiABQcACahC1AkUNAQwCCyACQf4BcUECRw0AIAFBDGogAUGAA2ogAkEBcRC2Ag0BC0F+DAELIAFBgAJqELADIQUgASAc/QsClAMgASAc/QsCpAMgAUG0A2oiAEEANgIAIAFBATYCgAMgASAc/QsChAMgAEEAIAVBBGoiA0E6bSICa0ECdCABaigCtAMgAkFjbCADQQJtaiIDdCIENgIAAkACQAJAIAVB7QVKDQBBDCEAIAFBACACa0ECdCABaigCsANBHSADayIHdSAEcjYCtAMgBUGzBUoNAEEMQQsgAiACQQtOG2siBEEBcSEIIAVB+QRMBEAgBEF+cSEJQQAhBANAIAFBgANqIABBAnRqIAFBgANqIAAgAmtBAnRqIgYoAgAgA3RB/////wFxIAZBBGsoAgAgB3VyNgIAIAFBgANqIABBAWsiBkECdGogAUGAA2ogBiACa0ECdGoiBigCACADdEH/////AXEgBkEEaygCACAHdXI2AgAgAEECayEAIARBAmoiBCAJRw0ACwsgCARAIAFBgANqIABBAnRqIAFBgANqIAAgAmtBAnRqIgAoAgAgA3RB/////wFxIABBBGsoAgAgB3VyNgIACyABQYADaiACQQJ0aiABKAKAAyADdEH/////AXE2AgAgBUE2Tg0BDAILIAFBgANqIAJBAnRqQQEgA3RB/////wFxNgIACyACQQJ0IgBFDQAgAUGAA2pBACAA/AsACyABIAEoAoADQavV/v8BajYCgAMgASABKAKEA0H//9//AGo2AoQDIAEgASgCiANB7v//pwFqNgKIAyABIAEoAowDQeL6/78BajYCjAMgASABKAKQA0Hqg4n7AGo2ApADIAEgASgClANB2PbBygBqNgKUAyABIAEoApgDQcO59tcAajYCmAMgASABKAKcA0Gi4fmEAWo2ApwDIAEgASgCoANBy+6RuwFqNgKgAyABIAEoAqQDQea66ZABajYCpAMgASABKAKoA0Ht05uWAWo2AqgDIAEgASgCrANBtJr/lwFqNgKsAyABIAEoArADQaO9xABqNgKwAyABIAEoArQDQQ1qNgK0AyABQYADaiABQcABahCoAyABKAK0AyEKIAEoArADIQsgASgCrAMhDCABKAKoAyENIAEoAqQDIQ4gASgCoAMhCCABKAKcAyEFIAEoApgDIQkgASgClAMhBiABKAKQAyEEIAEoAowDIQcgASgCiAMhAyABKAKEAyECIAEoAoADIQADQCAAQQFxRQRAIAFBDGoQwgIgASAKQQF1Ig82ArQDIAEgCkEcdEGAgICAAXEgC0EBdXIiEDYCsAMgASALQRx0QYCAgIABcSAMQQF1ciIRNgKsAyABIAxBHHRBgICAgAFxIA1BAXVyIhI2AqgDIAEgDUEcdEGAgICAAXEgDkEBdXIiEzYCpAMgASAOQRx0QYCAgIABcSAIQQF1ciIUNgKgAyABIAhBHHRBgICAgAFxIAVBAXVyIhU2ApwDIAEgBUEcdEGAgICAAXEgCUEBdXIiFjYCmAMgASAJQRx0QYCAgIABcSAGQQF1ciIXNgKUAyABIAZBHHRBgICAgAFxIARBAXVyIhg2ApADIAEgBEEcdEGAgICAAXEgB0EBdXIiGTYCjAMgASAHQRx0QYCAgIABcSADQQF1ciIaNgKIAyABIANBHHRBgICAgAFxIAJBAXVyIhs2AoQDIAEgAkEcdEGAgICAAXEgAEEBdXIiADYCgAMgDyEKIBAhCyARIQwgEiENIBMhDiAUIQggFSEFIBYhCSAXIQYgGCEEIBkhByAaIQMgGyECDAELCwJAAkAgAg0AIAMNACAHDQAgBA0AIAYNACAJDQAgBQ0AIAgNACAODQAgDQ0AIAwNACALDQAgCg0AIABBAUYNAQsgAUEMaiABQYADahDPAgtBACABQQxqELgCRQ0AGkF+QQAgAUGEAWoQuAIbCyEAIAFBwANqJAAgAAu8AwEafyAAQSxqIREgAEEoaiESIABBJGohEyAAQSBqIRQgAEEcaiEVIABBGGohFiAAQRRqIRcgAEEQaiEYIABBDGohGSAAQQRqIRoDQCAAIBBBCHQgA0EVdnIiEDYCNCAAIA9BCHRBgP7//wFxIhs2AgAgACADQQh0QYD+//8BcSAEQRV2ciIDNgIwIBEgBEEIdEGA/v//AXEgBUEVdnIiBDYCACASIAVBCHRBgP7//wFxIAZBFXZyIgU2AgAgEyAGQQh0QYD+//8BcSAHQRV2ciIGNgIAIBQgB0EIdEGA/v//AXEgCEEVdnIiBzYCACAVIAhBCHRBgP7//wFxIAlBFXZyIgg2AgAgFiAJQQh0QYD+//8BcSAKQRV2ciIJNgIAIBcgCkEIdEGA/v//AXEgC0EVdnIiCjYCACAYIAtBCHRBgP7//wFxIAxBFXZyIgs2AgAgGSAMQQh0QYD+//8BcSANQRV2ciIMNgIAIAAgDUEIdEGA/v//AXEgDkEVdnIiDTYCCCAaIA5BCHRBgP7//wFxIA9BFXZyIg42AgAgACAbIAEgAmotAAByIg82AgAgAkEBaiICQTBHDQALC8QPAgR/AXsjAEGwA2siAyQAIANCq9SZ9cEBNwOgAyADQry5/ujwz628AjcDmAMgA0KZx9nZ8ejbqRw3A5ADIANC28vDi5G2iccINwOIAyADQtLZuPOgtZO0ETcDgAMgA0Lop/aWsOSYkQk3A/gCIANCru/7reGh85gQNwPwAiADQYACaiACIANB8AJqENMCIANCo73EgNABNwNwIANC7dOblsGm8/8SNwNoIANCy+6Ru+Gsl40SNwNgIANCw7n216CUnM8QNwNYIANC6oOJ+4DrnqgJNwNQIANC7v//p6Gs//8XNwNIIANCq9X+//H///sPNwNAIANBBGogA0FAayADQYACahDJAkECIQUgA0ECNgI8IANBgAJqIANBBGoQtAMgA0KjvcSA0AE3A3AgA0Lt05uWwabz/xI3A2ggA0LL7pG74ayXjRI3A2AgA0LDufbXoJSczxA3A1ggA0Lqg4n7gOueqAk3A1AgA0Lu//+noaz//xc3A0ggA0Kr1f7/8f//+w83A0AgA0EEaiADQUBrIANBgAJqEMkCIANBAjYCPCADQQRqENICIANCq9SZ9cEBNwPwASADQry5/ujwz628AjcD6AEgA0KZx9nZ8ejbqRw3A+ABIANC28vDi5G2iccINwPYASADQtLZuPOgtZO0ETcD0AEgA0Lop/aWsOSYkQk3A8gBIANCru/7reGh85gQNwPAASADQYACaiABIANBwAFqENMCIANCo73EgNABNwOgAyADQu3Tm5bBpvP/EjcDmAMgA0LL7pG74ayXjRI3A5ADIANCw7n216CUnM8QNwOIAyADQuqDifuA656oCTcDgAMgA0Lu//+noaz//xc3A/gCIANCq9X+//H///sPNwPwAiADQUBrIANB8AJqIANBgAJqEMkCIANBAjYCeCAAQfgAaiEEIABBPGohBiADQUBrIANBQGsQ4AICfyADQQRqIANBQGsQ1AJFBEAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAgBBASEFIABBATYCOCAAQgA3AjAgACAH/QsCICAAIAf9CwIQIAMgB/0LApQBIAMgB/0LAqQBIANBADYCtAEgA0EBNgKAASADIAf9CwKEASADQqvUmfXBATcD8AEgA0K8uf7o8M+tvAI3A+gBIANCmcfZ2fHo26kcNwPgASADQtvLw4uRtonHCDcD2AEgA0LS2bjzoLWTtBE3A9ABIANC6Kf2lrDkmJEJNwPIASADQq7v+63hofOYEDcDwAEgA0GAAmogA0GAAWogA0HAAWoQ0wIgA0KjvcSA0AE3A6ADIANC7dOblsGm8/8SNwOYAyADQsvukbvhrJeNEjcDkAMgA0LDufbXoJSczxA3A4gDIANC6oOJ+4DrnqgJNwOAAyADQu7//6ehrP//FzcD+AIgA0Kr1f7/8f//+w83A/ACIAYgA0HwAmogA0GAAmoQyQIgAEECNgJ0IARCADcCMCAEIAf9CwIgIAQgB/0LAhAgBCAH/QsCAEEADAELIANCq9SZ9cEBNwPwASADQry5/ujwz628AjcD6AEgA0KZx9nZ8ejbqRw3A+ABIANC28vDi5G2iccINwPYASADQtLZuPOgtZO0ETcD0AEgA0Lop/aWsOSYkQk3A8gBIANCru/7reGh85gQNwPAASADQYACaiABIANBwAFqENMCIANCo73EgNABNwOgAyADQu3Tm5bBpvP/EjcDmAMgA0LL7pG74ayXjRI3A5ADIANCw7n216CUnM8QNwOIAyADQuqDifuA656oCTcDgAMgA0Lu//+noaz//xc3A/gCIANCq9X+//H///sPNwPwAiAAIANB8AJqIANBgAJqEMkCIABBAjYCOCADQqvUmfXBATcD8AEgA0K8uf7o8M+tvAI3A+gBIANCmcfZ2fHo26kcNwPgASADQtvLw4uRtonHCDcD2AEgA0LS2bjzoLWTtBE3A9ABIANC6Kf2lrDkmJEJNwPIASADQq7v+63hofOYEDcDwAEgA0GAAmogAiADQcABahDTAiADQqO9xIDQATcDoAMgA0Lt05uWwabz/xI3A5gDIANCy+6Ru+Gsl40SNwOQAyADQsO59teglJzPEDcDiAMgA0Lqg4n7gOueqAk3A4ADIANC7v//p6Gs//8XNwP4AiADQqvV/v/x///7DzcD8AIgBiADQfACaiADQYACahDJAiAAQQI2AnQgA/0MAAAAAAAAAAAAAAAAAAAAAP0LApQBIAMgB/0LAqQBIANBADYCtAEgA0EBNgKAASADIAf9CwKEASADQqvUmfXBATcD8AEgA0K8uf7o8M+tvAI3A+gBIANCmcfZ2fHo26kcNwPgASADQtvLw4uRtonHCDcD2AEgA0LS2bjzoLWTtBE3A9ABIANC6Kf2lrDkmJEJNwPIASADQq7v+63hofOYEDcDwAEgA0GAAmogA0GAAWogA0HAAWoQ0wIgA0KjvcSA0AE3A6ADIANC7dOblsGm8/8SNwOYAyADQsvukbvhrJeNEjcDkAMgA0LDufbXoJSczxA3A4gDIANC6oOJ+4DrnqgJNwOAAyADQu7//6ehrP//FzcD+AIgA0Kr1f7/8f//+w83A/ACIAQgA0HwAmogA0GAAmoQyQJBAQshAiAAIAU2ArABIANBsANqJAAgAguYEAIGfwF7IwBB8ANrIgMkACADQqO9xIDQATcDMCADQu3Tm5bBpvP/EjcDKCADQsvukbvhrJeNEjcDICADQsO59teglJzPEDcDGCADQuqDifuA656oCTcDECADQu7//6ehrP//FzcDCCADQqvV/v/x///7DzcDACADQqvUmfXBATcDsAIgA0K8uf7o8M+tvAI3A6gCIANCmcfZ2fHo26kcNwOgAiADQtvLw4uRtonHCDcDmAIgA0LS2bjzoLWTtBE3A5ACIANC6Kf2lrDkmJEJNwOIAiADQq7v+63hofOYEDcDgAIgA0HAAmogASADQYACahDTAiADQqO9xIDQATcD4AMgA0Lt05uWwabz/xI3A9gDIANCy+6Ru+Gsl40SNwPQAyADQsO59teglJzPEDcDyAMgA0Lqg4n7gOueqAk3A8ADIANC7v//p6Gs//8XNwO4AyADQqvV/v/x///7DzcDsAMgA0GEAWogA0GwA2ogA0HAAmoQyQIgA0ECNgK8ASADQYQBaiADQYQBahDgAiADQawDaiIGQQA2AgAgA0GMA2oiB/0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgA0GcA2oiCCAJ/QsCACADIAMoAoQBNgLAAiADIAP9AAKIAf0LAsQCIAMgA/0AApgB/QsC1AIgAyADKAKoATYC5AIgAyADKQKsATcD6AIgAyADKAK0ATYC8AIgAyAJ/QsC/AIgAyADKAK4ASIEQf////8BcTYC9AIgAyAEQR11NgL4AiADQqO9xIDQATcD4AMgA0Lt05uWwabz/xI3A9gDIANCy+6Ru+Gsl40SNwPQAyADQsO59teglJzPEDcDyAMgA0Lqg4n7gOueqAk3A8ADIANC7v//p6Gs//8XNwO4AyADQqvV/v/x///7DzcDsAMgAEE8aiEEIANBQGsgA0GwA2ogA0HAAmoQyQICQCADQUBrIAMQvwNBAUcEQCAAIAn9CwIAIABBATYCOCAAQgA3AjAgACAJ/QsCICAAIAn9CwIQIAMgCf0LAtQBIAMgCf0LAuQBIANBADYC9AEgA0EBNgLAASADIAn9CwLEASADQqvUmfXBATcDsAIgA0K8uf7o8M+tvAI3A6gCIANCmcfZ2fHo26kcNwOgAiADQtvLw4uRtonHCDcDmAIgA0LS2bjzoLWTtBE3A5ACIANC6Kf2lrDkmJEJNwOIAiADQq7v+63hofOYEDcDgAIgA0HAAmogA0HAAWogA0GAAmoQ0wIgA0KjvcSA0AE3A+ADIANC7dOblsGm8/8SNwPYAyADQsvukbvhrJeNEjcD0AMgA0LDufbXoJSczxA3A8gDIANC6oOJ+4DrnqgJNwPAAyADQu7//6ehrP//FzcDuAMgA0Kr1f7/8f//+w83A7ADIAQgA0GwA2ogA0HAAmoQyQIgAEECNgJ0IABCADcCqAEgACAJ/QsCmAEgACAJ/QsCiAEgACAJ/QsCeCAAQQE2ArABDAELIANCq9SZ9cEBNwOwAiADQry5/ujwz628AjcDqAIgA0KZx9nZ8ejbqRw3A6ACIANC28vDi5G2iccINwOYAiADQtLZuPOgtZO0ETcDkAIgA0Lop/aWsOSYkQk3A4gCIANCru/7reGh85gQNwOAAiADQcACaiABIANBgAJqENMCIANCo73EgNABNwPgAyADQu3Tm5bBpvP/EjcD2AMgA0LL7pG74ayXjRI3A9ADIANCw7n216CUnM8QNwPIAyADQuqDifuA656oCTcDwAMgA0Lu//+noaz//xc3A7gDIANCq9X+//H///sPNwOwAyAAIANBsANqIANBwAJqEMkCIABBAjYCOCAEIANBhAFqEPEFIAMgACgCPDYCwAIgAyAAKAJANgLEAiADIAAoAkQ2AsgCIAMgACgCSDYCzAIgAyAAKAJMNgLQAiADIAAoAlA2AtQCIAMgACgCVDYC2AIgAyAAKAJYNgLcAiADIAAoAlw2AuACIAMgACgCYDYC5AIgAyAAKAJkNgLoAiADIAAoAmg2AuwCIAMgACgCbDYC8AIgACgCcCEBIAcgCf0LAgAgCCAJ/QsCACAGQQA2AgAgAyAJ/QsC/AIgAyABQR11NgL4AiADIAFB/////wFxNgL0AiADQqO9xIDQATcD4AMgA0Lt05uWwabz/xI3A9gDIANCy+6Ru+Gsl40SNwPQAyADQsO59teglJzPEDcDyAMgA0Lqg4n7gOueqAk3A8ADIANC7v//p6Gs//8XNwO4AyADQqvV/v/x///7DzcDsAMgA0FAayADQbADaiADQcACahDJAiACIAMoAkBBAm9HBEAgBCAEEMwCCyAEENICIAMgCf0LAtQBIAMgCf0LAuQBIANBADYC9AFBASEFIANBATYCwAEgAyAJ/QsCxAEgA0Kr1Jn1wQE3A7ACIANCvLn+6PDPrbwCNwOoAiADQpnH2dnx6NupHDcDoAIgA0Lby8OLkbaJxwg3A5gCIANC0tm486C1k7QRNwOQAiADQuin9paw5JiRCTcDiAIgA0Ku7/ut4aHzmBA3A4ACIANBwAJqIANBwAFqIANBgAJqENMCIANCo73EgNABNwPgAyADQu3Tm5bBpvP/EjcD2AMgA0LL7pG74ayXjRI3A9ADIANCw7n216CUnM8QNwPIAyADQuqDifuA656oCTcDwAMgA0Lu//+noaz//xc3A7gDIANCq9X+//H///sPNwOwAyAAQfgAaiADQbADaiADQcACahDJAiAAQQI2ArABCyADQfADaiQAIAULBABBAAueAwEOfyMAQYABayIBJAAgAUKjvcSA0AE3A3AgAULt05uWwabz/xI3A2ggAULL7pG74ayXjRI3A2AgAULDufbXoJSczxA3A1ggAULqg4n7gOueqAk3A1AgAULu//+noaz//xc3A0ggAUKr1f7/8f//+w83A0AgASAAKAIANgIAIAEgACgCBDYCBCABIAAoAgg2AgggASAAKAIMNgIMIAEgACgCEDYCECABIAAoAhQ2AhQgASAAKAIYNgIYIAEgACgCHDYCHCABIAAoAiA2AiAgASAAKAIkNgIkIAEgACgCKDYCKCABIAAoAiw2AiwgASAAKAIwNgIwIAEgACgCNDYCNCABIAFBQGsQ2wIgASgCBCEAIAEoAgAhAiABKAIIIQMgASgCDCEEIAEoAhAhBSABKAIUIQYgASgCGCEHIAEoAhwhCCABKAIgIQkgASgCJCEKIAEoAighCyABKAIsIQwgASgCMCENIAEoAjQhDiABQYABaiQAIA4gDSAMIAsgCiAJIAggByAGIAUgBCADIAAgAnJycnJycnJycnJycnJFC5gIAgR/AXsjAEHwAmsiAyQAIAMgAigCADYCDCADIAIoAgQ2AhAgAyACKAIINgIUIAMgAigCDDYCGCADIAIoAhA2AhwgAyACKAIUNgIgIAMgAigCGDYCJCADIAIoAhw2AiggAyACKAIgNgIsIAMgAigCJDYCMCADIAIoAig2AjQgAyACKAIsNgI4IAMgAigCMDYCPCADIAIoAjQ2AkAgAyACKAI4NgJEIAMgAigCPDYCSCADIAIoAkA2AkwgAyACKAJENgJQIAMgAigCSDYCVCADIAIoAkw2AlggAyACKAJQNgJcIAMgAigCVDYCYCADIAIoAlg2AmQgAyACKAJcNgJoIAMgAigCYDYCbCADIAIoAmQ2AnAgAyACKAJoNgJ0IAMgAigCbDYCeCADIAIoAnA2AnwgAyACKAJ0NgKAASADIAIoAng2AoQBIAMgAigCfDYCiAEgAyACKAKAATYCjAEgAyACKAKEATYCkAEgAyACKAKIATYClAEgAyACKAKMATYCmAEgAyACKAKQATYCnAEgAyACKAKUATYCoAEgAyACKAKYATYCpAEgAyACKAKcATYCqAEgAyACKAKgATYCrAEgAyACKAKkATYCsAEgAyACKAKoATYCtAEgAyACKAKsATYCuAEgAyACKAKwATYCvAEgA0EMahC+AgJAIANBDGoQuAIEQCADQYQBahC4Ag0BCyADQawCaiICQQA2AgAgA0GMAmoiBP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgA0GcAmoiBSAH/QsCACADIAMoAkg2AsABIAMgA/0AAkz9CwLEASADIAP9AAJc/QsC1AEgAyAD/QACbP0LAuQBIAMgB/0LAvwBIAMgAygCfCIGQf////8BcTYC9AEgAyAGQR11NgL4ASADQqO9xIDQATcD4AIgA0Lt05uWwabz/xI3A9gCIANCy+6Ru+Gsl40SNwPQAiADQsO59teglJzPEDcDyAIgA0Lqg4n7gOueqAk3A8ACIANC7v//p6Gs//8XNwO4AiADQqvV/v/x///7DzcDsAIgASADQbACaiADQcABahDJAiAFIAf9CwIAIAQgB/0LAgAgAkEANgIAIAMgA/0AAgz9CwTAASADIAP9AAIc/QsE0AEgAyADKAIsNgLgASADIAP9AAIw/QsC5AEgAyADKAJAIgJB/////wFxNgL0ASADIAJBHXU2AvgBIAMgB/0LAvwBIANCo73EgNABNwPgAiADQu3Tm5bBpvP/EjcD2AIgA0LL7pG74ayXjRI3A9ACIANCw7n216CUnM8QNwPIAiADQuqDifuA656oCTcDwAIgA0Lu//+noaz//xc3A7gCIANCq9X+//H///sPNwOwAiAAIANBsAJqIANBwAFqEMkCCyADQfACaiQAC9YEARB/IAEoAgAiAkH/////AXEhDyABKAIEIAJBHXVqIgNB/////wFxIQIgASgCCCADQR11aiIEQf////8BcSEDIAEoAgwgBEEddWoiBUH/////AXEhBCABKAIQIAVBHXVqIgZB/////wFxIQUgASgCFCAGQR11aiIHQf////8BcSEGIAEoAhggB0EddWoiCEH/////AXEhByABKAIcIAhBHXVqIglB/////wFxIQggASgCICAJQR11aiIKQf////8BcSEJIAEoAiQgCkEddWoiC0H/////AXEhCiABKAIoIAtBHXVqIgxB/////wFxIQsgASgCLCAMQR11aiINQf////8BcSEMIAEoAjAgDUEddWoiDkH/////AXEhDSABKAI0IA5BHXVqIQFBLyEQA0AgACAQIg5qIA86AAAgAUEVdCERIAJBFXRBgICA/wFxIA9BCHZyIQ8gDkEBayEQIAFBCHUhASADQRV0QYCAgP8BcSACQQh2ciECIARBFXRBgICA/wFxIANBCHZyIQMgBUEVdEGAgID/AXEgBEEIdnIhBCAGQRV0QYCAgP8BcSAFQQh2ciEFIAdBFXRBgICA/wFxIAZBCHZyIQYgCEEVdEGAgID/AXEgB0EIdnIhByAJQRV0QYCAgP8BcSAIQQh2ciEIIApBFXRBgICA/wFxIAlBCHZyIQkgC0EVdEGAgID/AXEgCkEIdnIhCiAMQRV0QYCAgP8BcSALQQh2ciELIA1BFXRBgICA/wFxIAxBCHZyIQwgEUGAgID/AXEgDUEIdnIhDSAODQALC9QCAQJ/QQYhAQJ/AkAgACgCNCICQQZHDQBB0Z6igAEhASAAKAIwIgJB0Z6igAFHDQBBms3/ywEhASAAKAIsIgJBms3/ywFHDQBB9umNywAhASAAKAIoIgJB9umNywBHDQBBs920yAEhASAAKAIkIgJBs920yAFHDQBBpffI3QAhASAAKAIgIgJBpffI3QBHDQBB0fC8wgEhASAAKAIcIgJB0fC8wgFHDQBB4Zz7KyEBIAAoAhgiAkHhnPsrRw0AQaz7oKUBIQEgACgCFCICQaz7oKUBRw0AQfXBxD0hASAAKAIQIgJB9cHEPUcNAEGx/f/fACEBIAAoAgwiAkGx/f/fAEcNAEH3///TACEBIAAoAggiAkH3///TAEcNAEH//+8/IQEgACgCBCICQf//7z9HDQBB1ar//wEhAUEAIAAoAgAiAkHVqv//AUYNARoLIAEgAkgLC8gCAQR/IwBBMGsiAiQAIAJBwo8rNgIgIABB+YYqIAJBIGoQmwECQAJAIABBARCxAiIDBEAgAEHAAUEBENoBIgFCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASABQQE2ArwBIAFBCGoiASADQQhqEL0CIAEQvgIgAyADKAK8ASIBQQFrNgK8ASABQQFKDQJBpIg0KAIAIgFFDQEgAiADNgIsIAEoAgAiBCACKAIsSw0BIAIoAiwgBCABKAIQak8NASADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNAiABQXxxIgFFDQIgA0EAIAH8CwAMAgsgAkGC3is2AgQgAkHCjys2AgAgAEH8iCogAhBsAAsgAxArCyACQcKPKzYCECAAQeCHKiACQRBqEJsBIAJBMGokAEEBC94DACAAIAEoAgA2AgAgACABKAIENgIEIAAgASgCCDYCCCAAIAEoAgw2AgwgACABKAIQNgIQIAAgASgCFDYCFCAAIAEoAhg2AhggACABKAIcNgIcIAAgASgCIDYCICAAIAEoAiQ2AiQgACABKAIoNgIoIAAgASgCLDYCLCAAIAEoAjA2AjAgACABKAI0NgI0IAAgASgCODYCOCAAIAEoAjw2AjwgACABKAJANgJAIAAgASgCRDYCRCAAIAEoAkg2AkggACABKAJMNgJMIAAgASgCUDYCUCAAIAEoAlQ2AlQgACABKAJYNgJYIAAgASgCXDYCXCAAIAEoAmA2AmAgACABKAJkNgJkIAAgASgCaDYCaCAAIAEoAmw2AmwgACABKAJwNgJwIAAgASgCdDYCdCAAIAEoAng2AnggACABKAJ8NgJ8IAAgASgCgAE2AoABIAAgASgChAE2AoQBIAAgASgCiAE2AogBIAAgASgCjAE2AowBIAAgASgCkAE2ApABIAAgASgClAE2ApQBIAAgASgCmAE2ApgBIAAgASgCnAE2ApwBIAAgASgCoAE2AqABIAAgASgCpAE2AqQBIAAgASgCqAE2AqgBIAAgASgCrAE2AqwBIAAgASgCsAE2ArABC48HAwJ/AXsBfiMAQfACayIBJAACQCAAELgCBEAgAEH4AGoQuAINAQsgAf0MAAAAAAAAAAAAAAAAAAAAAP0LApQBIAEgA/0LAqQBIAFBADYCtAEgAUEBNgKAASABIAP9CwKEASABQqvUmfXBATcD4AIgAUK8uf7o8M+tvAI3A9gCIAFCmcfZ2fHo26kcNwPQAiABQtvLw4uRtonHCDcDyAIgAULS2bjzoLWTtBE3A8ACIAFC6Kf2lrDkmJEJNwO4AiABQq7v+63hofOYEDcDsAIgAUHAAWogAUGAAWogAUGwAmoQ0wIgAUKjvcSA0AE3AzAgAULt05uWwabz/xI3AyggAULL7pG74ayXjRI3AyAgAULDufbXoJSczxA3AxggAULqg4n7gOueqAk3AxAgAULu//+noaz//xc3AwggAUKr1f7/8f//+w83AwAgAUHEAGogASABQcABahDJAiABQQI2AnwgAEH4AGoiAiABQcQAahDUAg0AIAEgAhDwBSABNAI4IgQgADQCOH5CgICAEFkEQCAAENICCyABQcABaiAAIAEQ0wIgAUKjvcSA0AE3A+ACIAFC7dOblsGm8/8SNwPYAiABQsvukbvhrJeNEjcD0AIgAULDufbXoJSczxA3A8gCIAFC6oOJ+4DrnqgJNwPAAiABQu7//6ehrP//FzcDuAIgAUKr1f7/8f//+w83A7ACIAAgAUGwAmogAUHAAWoQyQIgAEECNgI4IABBPGohAiAEIAA0AnR+QoCAgBBZBEAgAhDSAgsgAUHAAWogAiABENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiACIAFBsAJqIAFBwAFqEMkCIABBAjYCdCACENICIAAQ0gIgACABKAJENgJ4IAAgASgCSDYCfCAAIAEoAkw2AoABIAAgASgCUDYChAEgACABKAJUNgKIASAAIAEoAlg2AowBIAAgASgCXDYCkAEgACABKAJgNgKUASAAIAEoAmQ2ApgBIAAgASgCaDYCnAEgACABKAJsNgKgASAAIAEoAnA2AqQBIAAgASgCdDYCqAEgASgCeCECIABBAjYCsAEgACACNgKsAQsgAUHwAmokAAvIAgEEfyMAQTBrIgIkACACQcn6KjYCICAAQfmGKiACQSBqEJsBAkACQCAAQQEQsQIiAwRAIABBwAFBARDaASIBQriAgICQDDcCACAAQdjhzn1Bi6cqEJABGiAAQX4Q2wEgAUEBNgK8ASABQQhqIgEgA0EIahC9AiABEMACIAMgAygCvAEiAUEBazYCvAEgAUEBSg0CQaSINCgCACIBRQ0BIAIgAzYCLCABKAIAIgQgAigCLEsNASACKAIsIAQgASgCEGpPDQEgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIANBACAB/AsADAILIAJBgt4rNgIEIAJByfoqNgIAIABB/IgqIAIQbAALIAMQKwsgAkHJ+io2AhAgAEHghyogAkEQahCbASACQTBqJABBAQvfAgEBfyAAQTxqIgEgARDMAiAAIAAoAjwiAUH/////AXE2AjwgACAAKAJAIAFBHXVqIgFB/////wFxNgJAIAAgACgCRCABQR11aiIBQf////8BcTYCRCAAIAAoAkggAUEddWoiAUH/////AXE2AkggACAAKAJMIAFBHXVqIgFB/////wFxNgJMIAAgACgCUCABQR11aiIBQf////8BcTYCUCAAIAAoAlQgAUEddWoiAUH/////AXE2AlQgACAAKAJYIAFBHXVqIgFB/////wFxNgJYIAAgACgCXCABQR11aiIBQf////8BcTYCXCAAIAAoAmAgAUEddWoiAUH/////AXE2AmAgACAAKAJkIAFBHXVqIgFB/////wFxNgJkIAAgACgCaCABQR11aiIBQf////8BcTYCaCAAIAAoAmwgAUEddWoiAUH/////AXE2AmwgACAAKAJwIAFBHXVqNgJwC8gCAQR/IwBBMGsiAiQAIAJBzZUrNgIgIABB+YYqIAJBIGoQmwECQAJAIABBARCxAiIDBEAgAEHAAUEBENoBIgFCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASABQQE2ArwBIAFBCGoiASADQQhqEL0CIAEQwgIgAyADKAK8ASIBQQFrNgK8ASABQQFKDQJBpIg0KAIAIgFFDQEgAiADNgIsIAEoAgAiBCACKAIsSw0BIAIoAiwgBCABKAIQak8NASADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNAiABQXxxIgFFDQIgA0EAIAH8CwAMAgsgAkGC3is2AgQgAkHNlSs2AgAgAEH8iCogAhBsAAsgAxArCyACQc2VKzYCECAAQeCHKiACQRBqEJsBIAJBMGokAEEBC5glAiF/AX4jAEHwA2siASQAIABBPGohDyAANAJ0IiIgIn5CgICAEFoEQCAPENICCyABQcACaiAPELQDIAFCo73EgNABNwPwASABQu3Tm5bBpvP/EjcD6AEgAULL7pG74ayXjRI3A+ABIAFCw7n216CUnM8QNwPYASABQuqDifuA656oCTcD0AEgAULu//+noaz//xc3A8gBIAFCq9X+//H///sPNwPAASABQYQCaiABQcABaiABQcACahDJAiABQQI2ArwCIABB+ABqIQIgADQCsAEgADQCdH5CgICAEFkEQCAPENICCyABQcACaiAPIAIQ0wIgAUKjvcSA0AE3A7ABIAFC7dOblsGm8/8SNwOoASABQsvukbvhrJeNEjcDoAEgAULDufbXoJSczxA3A5gBIAFC6oOJ+4DrnqgJNwOQASABQu7//6ehrP//FzcDiAEgAUKr1f7/8f//+w83A4ABIAFBwAFqIAFBgAFqIAFBwAJqEMkCIAFBAjYC+AEgADQCsAEiIiAifkKAgIAQWgRAIAIQ0gILIAFBwAJqIAIQtAMgAUKjvcSA0AE3A3AgAULt05uWwabz/xI3A2ggAULL7pG74ayXjRI3A2AgAULDufbXoJSczxA3A1ggAULqg4n7gOueqAk3A1AgAULu//+noaz//xc3A0ggAUKr1f7/8f//+w83A0AgAUGAAWogAUFAayABQcACahDJAiABQQI2ArgBIAAgASgChAJBAXQiAzYCeCAAIAEoAogCQQF0IgQ2AnwgACABKAKMAkEBdCIFNgKAASAAIAEoApACQQF0IgY2AoQBIAAgASgClAJBAXQiBzYCiAEgACABKAKYAkEBdCIINgKMASAAIAEoApwCQQF0Igk2ApABIAAgASgCoAJBAXQiCjYClAEgACABKAKkAkEBdCILNgKYASAAIAEoAqgCQQF0Igw2ApwBIAAgASgCrAJBAXQiDTYCoAEgACABKAKwAkEBdCIONgKkASAAIAEoArQCQQF0IhA2AqgBIAAgASgCuAJBAXQiETYCrAEgACABKAK8AiISQQF0NgKwASASQYCAgAhOBEAgAhDSAiAAKAKsASERIAAoAqgBIRAgACgCpAEhDiAAKAKgASENIAAoApwBIQwgACgCmAEhCyAAKAKUASEKIAAoApABIQkgACgCjAEhCCAAKAKIASEHIAAoAoQBIQYgACgCgAEhBSAAKAJ8IQQgACgCeCEDCyAAIANB/////wFxNgJ4IAAgBCADQR11aiIDQf////8BcTYCfCAAIAUgA0EddWoiA0H/////AXE2AoABIAAgBiADQR11aiIDQf////8BcTYChAEgACAHIANBHXVqIgNB/////wFxNgKIASAAIAggA0EddWoiA0H/////AXE2AowBIAAgCSADQR11aiIDQf////8BcTYCkAEgACAKIANBHXVqIgNB/////wFxNgKUASAAIAsgA0EddWoiA0H/////AXE2ApgBIAAgDCADQR11aiIDQf////8BcTYCnAEgACANIANBHXVqIgNB/////wFxNgKgASAAIA4gA0EddWoiA0H/////AXE2AqQBIAAgECADQR11aiIDQf////8BcTYCqAEgACARIANBHXVqNgKsASACIAIgAhD3AiACIAIgAhD3AiAAIAAoAngiA0H/////AXE2AnggACAAKAJ8IANBHXVqIgNB/////wFxNgJ8IAAgACgCgAEgA0EddWoiA0H/////AXE2AoABIAAgACgChAEgA0EddWoiA0H/////AXE2AoQBIAAgACgCiAEgA0EddWoiA0H/////AXE2AogBIAAgACgCjAEgA0EddWoiA0H/////AXE2AowBIAAgACgCkAEgA0EddWoiA0H/////AXE2ApABIAAgACgClAEgA0EddWoiA0H/////AXE2ApQBIAAgACgCmAEgA0EddWoiA0H/////AXE2ApgBIAAgACgCnAEgA0EddWoiA0H/////AXE2ApwBIAAgACgCoAEgA0EddWoiA0H/////AXE2AqABIAAgACgCpAEgA0EddWoiA0H/////AXE2AqQBIAAgACgCqAEgA0EddWoiA0H/////AXE2AqgBIAAgACgCrAEgA0EddWo2AqwBIAFBgAFqIAFBgAFqQQwQvAggADQCsAEgATQCuAF+QoCAgBBZBEAgAUGAAWoQ0gILIAFBwAJqIAFBgAFqIAIQ0wIgAUKjvcSA0AE3A+ADIAFC7dOblsGm8/8SNwPYAyABQsvukbvhrJeNEjcD0AMgAULDufbXoJSczxA3A8gDIAFC6oOJ+4DrnqgJNwPAAyABQu7//6ehrP//FzcDuAMgAUKr1f7/8f//+w83A7ADIAFBQGsgAUGwA2ogAUHAAmoQyQIgAUECNgJ4IAEgASgCgAEiEyABKAKEAmoiAzYCBCABIAEoAoQBIhQgASgCiAJqIgU2AgggASABKAKIASIVIAEoAowCaiIGNgIMIAEgASgCjAEiFiABKAKQAmoiBzYCECABIAEoApABIhcgASgClAJqIgg2AhQgASABKAKUASIYIAEoApgCaiIJNgIYIAEgASgCmAEiGSABKAKcAmoiCjYCHCABIAEoApwBIhogASgCoAJqIgs2AiAgASABKAKgASIbIAEoAqQCaiIMNgIkIAEgASgCpAEiHCABKAKoAmoiDTYCKCABIAEoAqgBIh0gASgCrAJqIg42AiwgASABKAKsASIeIAEoArACaiIQNgIwIAEgASgCsAEiHyABKAK0AmoiETYCNCABIAEoArQBIiAgASgCuAJqIhI2AjggASABKAK4ASIEIAEoArwCaiIhNgI8ICFBgICAEE4EQCABQQRqENICIAEoAjghEiABKAI0IREgASgCMCEQIAEoAiwhDiABKAIoIQ0gASgCJCEMIAEoAiAhCyABKAIcIQogASgCGCEJIAEoAhQhCCABKAIQIQcgASgCDCEGIAEoAgghBSABKAIEIQMLIAEgA0H/////AXE2AgQgASAFIANBHXVqIgNB/////wFxNgIIIAEgBiADQR11aiIDQf////8BcTYCDCABIAcgA0EddWoiA0H/////AXE2AhAgASAIIANBHXVqIgNB/////wFxNgIUIAEgCSADQR11aiIDQf////8BcTYCGCABIAogA0EddWoiA0H/////AXE2AhwgASALIANBHXVqIgNB/////wFxNgIgIAEgDCADQR11aiIDQf////8BcTYCJCABIA0gA0EddWoiA0H/////AXE2AiggASAOIANBHXVqIgNB/////wFxNgIsIAEgECADQR11aiIDQf////8BcTYCMCABIBEgA0EddWoiA0H/////AXE2AjQgASASIANBHXVqNgI4IAE0AvgBIAA0ArABfkKAgIAQWQRAIAIQ0gILIAFBwAJqIAIgAUHAAWoQ0wIgAUKjvcSA0AE3A+ADIAFC7dOblsGm8/8SNwPYAyABQsvukbvhrJeNEjcD0AMgAULDufbXoJSczxA3A8gDIAFC6oOJ+4DrnqgJNwPAAyABQu7//6ehrP//FzcDuAMgAUKr1f7/8f//+w83A7ADIAIgAUGwA2ogAUHAAmoQyQIgAEECNgKwASABIARBAXQ2AvgBIAEgIEEBdDYC9AEgASAfQQF0NgLwASABIB5BAXQ2AuwBIAEgHUEBdDYC6AEgASAcQQF0NgLkASABIBtBAXQ2AuABIAEgGkEBdDYC3AEgASAZQQF0NgLYASABIBhBAXQ2AtQBIAEgF0EBdDYC0AEgASAWQQF0NgLMASABIBVBAXQ2AsgBIAEgFEEBdDYCxAEgASATQQF0NgLAASAEQYCAgAhOBEAgAUHAAWoQ0gILIAFBgAFqIAFBgAFqIAFBwAFqEPcCIAFBhAJqIAFBhAJqIAFBgAFqEL0IIAEgASgChAIiAkH/////AXEiAzYChAIgASABKAKIAiACQR11aiICQf////8BcSIENgKIAiABIAEoAowCIAJBHXVqIgJB/////wFxIgU2AowCIAEgASgCkAIgAkEddWoiAkH/////AXEiBjYCkAIgASABKAKUAiACQR11aiICQf////8BcSIHNgKUAiABIAEoApgCIAJBHXVqIgJB/////wFxIgg2ApgCIAEgASgCnAIgAkEddWoiAkH/////AXEiCTYCnAIgASABKAKgAiACQR11aiICQf////8BcSIKNgKgAiABIAEoAqQCIAJBHXVqIgJB/////wFxIgs2AqQCIAEgASgCqAIgAkEddWoiAkH/////AXEiDDYCqAIgASABKAKsAiACQR11aiICQf////8BcSINNgKsAiABIAEoArACIAJBHXVqIgJB/////wFxIg42ArACIAEgASgCtAIgAkEddWoiAkH/////AXEiEDYCtAIgASABKAK4AiACQR11aiICNgK4AiABNAI8IAEoArwCIhGsfkKAgIAQWQRAIAFBBGoQ0gILIAFBwAJqIAFBBGogAUGEAmoQ0wIgAUKjvcSA0AE3A+ADIAFC7dOblsGm8/8SNwPYAyABQsvukbvhrJeNEjcD0AMgAULDufbXoJSczxA3A8gDIAFC6oOJ+4DrnqgJNwPAAyABQu7//6ehrP//FzcDuAMgAUKr1f7/8f//+w83A7ADIAFBBGogAUGwA2ogAUHAAmoQyQIgAUECNgI8IAFBBGogAUEEaiABQUBrEPcCIAA0AnQgADQCOH5CgICAEFkEQCAAENICCyABQcACaiAAIA8Q0wIgAUKjvcSA0AE3A+ADIAFC7dOblsGm8/8SNwPYAyABQsvukbvhrJeNEjcD0AMgAULDufbXoJSczxA3A8gDIAFC6oOJ+4DrnqgJNwPAAyABQu7//6ehrP//FzcDuAMgAUKr1f7/8f//+w83A7ADIAFBwAFqIAFBsANqIAFBwAJqEMkCIAFBAjYC+AEgASACNgK4AiABIBA2ArQCIAEgDjYCsAIgASANNgKsAiABIAw2AqgCIAEgCzYCpAIgASAKNgKgAiABIAk2ApwCIAEgCDYCmAIgASAHNgKUAiABIAY2ApACIAEgBTYCjAIgASAENgKIAiABIAM2AoQCIBFBgICACE4EQCABQYQCahDSAgsgAUHAAmogAUGEAmogAUHAAWoQ0wIgAUKjvcSA0AE3A+ADIAFC7dOblsGm8/8SNwPYAyABQsvukbvhrJeNEjcD0AMgAULDufbXoJSczxA3A8gDIAFC6oOJ+4DrnqgJNwPAAyABQu7//6ehrP//FzcDuAMgAUKr1f7/8f//+w83A7ADIAAgAUGwA2ogAUHAAmoQyQIgAEECNgI4IAAgACAAEPcCIAAgACgCACICQf////8BcTYCACAAIAAoAgQgAkEddWoiAkH/////AXE2AgQgACAAKAIIIAJBHXVqIgJB/////wFxNgIIIAAgACgCDCACQR11aiICQf////8BcTYCDCAAIAAoAhAgAkEddWoiAkH/////AXE2AhAgACAAKAIUIAJBHXVqIgJB/////wFxNgIUIAAgACgCGCACQR11aiICQf////8BcTYCGCAAIAAoAhwgAkEddWoiAkH/////AXE2AhwgACAAKAIgIAJBHXVqIgJB/////wFxNgIgIAAgACgCJCACQR11aiICQf////8BcTYCJCAAIAAoAiggAkEddWoiAkH/////AXE2AiggACAAKAIsIAJBHXVqIgJB/////wFxNgIsIAAgACgCMCACQR11aiICQf////8BcTYCMCAAIAAoAjQgAkEddWo2AjQgASgCOCEPIAEoAjQhAyABKAIwIQQgASgCLCEFIAEoAighBiABKAIkIQcgASgCICEIIAEoAhwhCSABKAIYIQogASgCFCELIAEoAhAhDCABKAIMIQ0gASgCCCEOIAEoAgQhAiAAIAEoAjw2AnQgACACQf////8BcTYCPCAAIA4gAkEddWoiAkH/////AXE2AkAgACANIAJBHXVqIgJB/////wFxNgJEIAAgDCACQR11aiICQf////8BcTYCSCAAIAsgAkEddWoiAkH/////AXE2AkwgACAKIAJBHXVqIgJB/////wFxNgJQIAAgCSACQR11aiICQf////8BcTYCVCAAIAggAkEddWoiAkH/////AXE2AlggACAHIAJBHXVqIgJB/////wFxNgJcIAAgBiACQR11aiICQf////8BcTYCYCAAIAUgAkEddWoiAkH/////AXE2AmQgACAEIAJBHXVqIgJB/////wFxNgJoIAAgAyACQR11aiICQf////8BcTYCbCAAIA8gAkEddWo2AnAgAUHwA2okAAu2AgEEfyMAQTBrIgIkACACQbf0KjYCICAAQfmGKiACQSBqEJsBQQEhAQJAAkAgAEEBELECIgMEQCADQQhqELgCBEBBEUEBIANBgAFqELgCGyEBCyAAKAIMIAE6AAQgACAAKAIMQQhqNgIMIAMgAygCvAEiAUEBazYCvAEgAUEBSg0CQaSINCgCACIBRQ0BIAIgAzYCLCABKAIAIgQgAigCLEsNASACKAIsIAQgASgCEGpPDQEgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIANBACAB/AsADAILIAJBgt4rNgIEIAJBt/QqNgIAIABB/IgqIAIQbAALIAMQKwsgAkG39Co2AhAgAEHghyogAkEQahCbASACQTBqJABBAQveAwEEfyMAQbABayICJAAgAkGy4Sk2AiAgAEH5hiogAkEgahCbAQJAAkACQCAAQQEQsQIiA0UNACAAIAMoAgRBD2oQhgEiAQRAAkACQCADQQhqIgQQuAJFDQAgA0GAAWoQuAJFDQAgASgCCEH/ADoAACABKAIIQf8AOgABIAEoAghBADoAAyABQQI2AgAMAQsgAkHwAGogAkEwaiAEELkCIAEoAghBAjoAACACKAIwQYGAgIB4cUEBRgRAIAEoAghBAzoAAAsgAUExNgIAIAEoAghBAWogAkHwAGoQugILIAMgAygCvAEiAUEBazYCvAEgAUEBSg0DQaSINCgCACIBRQ0CIAIgAzYCcCABKAIAIgQgAigCcEsNAiACKAJwIAQgASgCEGpPDQIgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQMgAUF8cSIBRQ0DIANBACAB/AsADAMLIAMgAygCvAEiAUEBazYCvAEgAUEBSg0AQaSINCgCACIBRQRAIAMQKwwBCyABIAMQUAsgAkHo3Ss2AgQgAkGy4Sk2AgAgAEH8iCogAhBsAAsgAxArCyACQbLhKTYCECAAQeCHKiACQRBqEJsBIAJBsAFqJABBAQuSBAEHfyMAQTBrIgMkACADQd6/KzYCICAAQfmGKiADQSBqEJsBAkACQCAAQQEQsQIiBEEARyAAQQIQsQIiAUEAR3EiBQRAIABBwAFBARDaASICQriAgICQDDcCACAAQdjhzn1Bi6cqEJABGiAAQX4Q2wEgAkEBNgK8ASACQQhqIgIgBEEIahC9AiACIAFBCGoQxgIMAQtBgt4rIQYgAUUNAQsgASABKAK8ASICQQFrNgK8AQJAIAJBAUoNAAJAQaSINCgCACICRQ0AIAMgATYCLCACKAIAIgcgAygCLEsNACADKAIsIAcgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIAFBACAC/AsADAELIAEQKwsgBSECCwJAIARFDQAgBCAEKAK8ASIBQQFrNgK8ASABQQFKDQACQEGkiDQoAgAiAUUNACADIAQ2AiwgASgCACIFIAMoAixLDQAgAygCLCAFIAEoAhBqTw0AIAQgASgCBDYCACABIAQ2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAEQQAgAfwLAAwBCyAEECsLIAJFBEAgAyAGNgIUIANB3r8rNgIQIABB/IgqIANBEGoQbAALIANB3r8rNgIAIABB4IcqIAMQmwEgA0EwaiQAQQEL2UwCEn8BfiMAQbAFayICJAAgATQCOCAANAI4fkKAgIAQWQRAIAAQ0gILIAJBgARqIAAgARDTAiACQqO9xIDQATcDsAMgAkLt05uWwabz/xI3A6gDIAJCy+6Ru+Gsl40SNwOgAyACQsO59teglJzPEDcDmAMgAkLqg4n7gOueqAk3A5ADIAJC7v//p6Gs//8XNwOIAyACQqvV/v/x///7DzcDgAMgAkHEA2ogAkGAA2ogAkGABGoQyQIgAkECNgL8AyABQTxqIQQgAEE8aiEHIAE0AnQgADQCdH5CgICAEFkEQCAHENICCyACQYAEaiAHIAQQ0wIgAkKjvcSA0AE3A/ACIAJC7dOblsGm8/8SNwPoAiACQsvukbvhrJeNEjcD4AIgAkLDufbXoJSczxA3A9gCIAJC6oOJ+4DrnqgJNwPQAiACQu7//6ehrP//FzcDyAIgAkKr1f7/8f//+w83A8ACIAJBgANqIAJBwAJqIAJBgARqEMkCIAJBAjYCuAMgAUH4AGohBiAAQfgAaiEIIAE0ArABIAA0ArABfkKAgIAQWQRAIAgQ0gILIAJBgARqIAggBhDTAiACQqO9xIDQATcDsAIgAkLt05uWwabz/xI3A6gCIAJCy+6Ru+Gsl40SNwOgAiACQsO59teglJzPEDcDmAIgAkLqg4n7gOueqAk3A5ACIAJC7v//p6Gs//8XNwOIAiACQqvV/v/x///7DzcDgAIgAkHAAmogAkGAAmogAkGABGoQyQIgAkECNgL4AiACQYACaiAAIAcQ9wIgAiACKAKAAiIDQf////8BcTYCgAIgAiACKAKEAiADQR11aiIDQf////8BcTYChAIgAiACKAKIAiADQR11aiIDQf////8BcTYCiAIgAiACKAKMAiADQR11aiIDQf////8BcTYCjAIgAiACKAKQAiADQR11aiIDQf////8BcTYCkAIgAiACKAKUAiADQR11aiIDQf////8BcTYClAIgAiACKAKYAiADQR11aiIDQf////8BcTYCmAIgAiACKAKcAiADQR11aiIDQf////8BcTYCnAIgAiACKAKgAiADQR11aiIDQf////8BcTYCoAIgAiACKAKkAiADQR11aiIDQf////8BcTYCpAIgAiACKAKoAiADQR11aiIDQf////8BcTYCqAIgAiACKAKsAiADQR11aiIDQf////8BcTYCrAIgAiACKAKwAiADQR11aiIDQf////8BcTYCsAIgAiACKAK0AiADQR11ajYCtAIgAkHEAWogASAEEPcCIAIgAigCxAEiA0H/////AXE2AsQBIAIgAigCyAEgA0EddWoiA0H/////AXE2AsgBIAIgAigCzAEgA0EddWoiA0H/////AXE2AswBIAIgAigC0AEgA0EddWoiA0H/////AXE2AtABIAIgAigC1AEgA0EddWoiA0H/////AXE2AtQBIAIgAigC2AEgA0EddWoiA0H/////AXE2AtgBIAIgAigC3AEgA0EddWoiA0H/////AXE2AtwBIAIgAigC4AEgA0EddWoiA0H/////AXE2AuABIAIgAigC5AEgA0EddWoiA0H/////AXE2AuQBIAIgAigC6AEgA0EddWoiA0H/////AXE2AugBIAIgAigC7AEgA0EddWoiA0H/////AXE2AuwBIAIgAigC8AEgA0EddWoiA0H/////AXE2AvABIAIgAigC9AEgA0EddWoiA0H/////AXE2AvQBIAIgAigC+AEgA0EddWo2AvgBIAI0AvwBIAI0ArgCfkKAgIAQWQRAIAJBgAJqENICCyACQYAEaiACQYACaiACQcQBahDTAiACQqO9xIDQATcDsAEgAkLt05uWwabz/xI3A6gBIAJCy+6Ru+Gsl40SNwOgASACQsO59teglJzPEDcDmAEgAkLqg4n7gOueqAk3A5ABIAJC7v//p6Gs//8XNwOIASACQqvV/v/x///7DzcDgAEgAkGAAmogAkGAAWogAkGABGoQyQIgAkECNgK4AiACIAIoAoADIAIoAsQDajYCxAEgAiACKAKEAyACKALIA2o2AsgBIAIgAigCiAMgAigCzANqNgLMASACIAIoAowDIAIoAtADajYC0AEgAiACKAKQAyACKALUA2o2AtQBIAIgAigClAMgAigC2ANqNgLYASACIAIoApgDIAIoAtwDajYC3AEgAiACKAKcAyACKALgA2o2AuABIAIgAigCoAMgAigC5ANqNgLkASACIAIoAqQDIAIoAugDajYC6AEgAiACKAKoAyACKALsA2o2AuwBIAIgAigCrAMgAigC8ANqNgLwASACIAIoArADIAIoAvQDajYC9AEgAiACKAK0AyACKAL4A2o2AvgBIAIgAigCuAMgAigC/ANqIgM2AvwBIANBgICAEE4EQCACQcQBahDSAgsgAkGAAmogAkGAAmogAkHEAWoQvQggAiACKAKAAiIDQf////8BcTYCgAIgAiACKAKEAiADQR11aiIDQf////8BcTYChAIgAiACKAKIAiADQR11aiIDQf////8BcTYCiAIgAiACKAKMAiADQR11aiIDQf////8BcTYCjAIgAiACKAKQAiADQR11aiIDQf////8BcTYCkAIgAiACKAKUAiADQR11aiIDQf////8BcTYClAIgAiACKAKYAiADQR11aiIDQf////8BcTYCmAIgAiACKAKcAiADQR11aiIDQf////8BcTYCnAIgAiACKAKgAiADQR11aiIDQf////8BcTYCoAIgAiACKAKkAiADQR11aiIDQf////8BcTYCpAIgAiACKAKoAiADQR11aiIDQf////8BcTYCqAIgAiACKAKsAiADQR11aiIDQf////8BcTYCrAIgAiACKAKwAiADQR11aiIDQf////8BcTYCsAIgAiACKAK0AiADQR11ajYCtAIgAkHEAWogByAIEPcCIAIgAigCxAEiA0H/////AXE2AsQBIAIgAigCyAEgA0EddWoiA0H/////AXE2AsgBIAIgAigCzAEgA0EddWoiA0H/////AXE2AswBIAIgAigC0AEgA0EddWoiA0H/////AXE2AtABIAIgAigC1AEgA0EddWoiA0H/////AXE2AtQBIAIgAigC2AEgA0EddWoiA0H/////AXE2AtgBIAIgAigC3AEgA0EddWoiA0H/////AXE2AtwBIAIgAigC4AEgA0EddWoiA0H/////AXE2AuABIAIgAigC5AEgA0EddWoiA0H/////AXE2AuQBIAIgAigC6AEgA0EddWoiA0H/////AXE2AugBIAIgAigC7AEgA0EddWoiA0H/////AXE2AuwBIAIgAigC8AEgA0EddWoiA0H/////AXE2AvABIAIgAigC9AEgA0EddWoiA0H/////AXE2AvQBIAIgAigC+AEgA0EddWo2AvgBIAJBgAFqIAQgBhD3AiACIAIoAoABIgRB/////wFxNgKAASACIAIoAoQBIARBHXVqIgRB/////wFxNgKEASACIAIoAogBIARBHXVqIgRB/////wFxNgKIASACIAIoAowBIARBHXVqIgRB/////wFxNgKMASACIAIoApABIARBHXVqIgRB/////wFxNgKQASACIAIoApQBIARBHXVqIgRB/////wFxNgKUASACIAIoApgBIARBHXVqIgRB/////wFxNgKYASACIAIoApwBIARBHXVqIgRB/////wFxNgKcASACIAIoAqABIARBHXVqIgRB/////wFxNgKgASACIAIoAqQBIARBHXVqIgRB/////wFxNgKkASACIAIoAqgBIARBHXVqIgRB/////wFxNgKoASACIAIoAqwBIARBHXVqIgRB/////wFxNgKsASACIAIoArABIARBHXVqIgRB/////wFxNgKwASACIAIoArQBIARBHXVqNgK0ASACNAK4ASACNAL8AX5CgICAEFkEQCACQcQBahDSAgsgAkGABGogAkHEAWogAkGAAWoQ0wIgAkKjvcSA0AE3A3AgAkLt05uWwabz/xI3A2ggAkLL7pG74ayXjRI3A2AgAkLDufbXoJSczxA3A1ggAkLqg4n7gOueqAk3A1AgAkLu//+noaz//xc3A0ggAkKr1f7/8f//+w83A0AgAkHEAWogAkFAayACQYAEahDJAiACQQI2AvwBIAIgAigCwAIgAigCgANqNgKAASACIAIoAsQCIAIoAoQDajYChAEgAiACKALIAiACKAKIA2o2AogBIAIgAigCzAIgAigCjANqNgKMASACIAIoAtACIAIoApADajYCkAEgAiACKALUAiACKAKUA2o2ApQBIAIgAigC2AIgAigCmANqNgKYASACIAIoAtwCIAIoApwDajYCnAEgAiACKALgAiACKAKgA2o2AqABIAIgAigC5AIgAigCpANqNgKkASACIAIoAugCIAIoAqgDajYCqAEgAiACKALsAiACKAKsA2o2AqwBIAIgAigC8AIgAigCsANqNgKwASACIAIoAvQCIAIoArQDajYCtAEgAiACKAL4AiACKAK4A2oiBDYCuAEgBEGAgIAQTgRAIAJBgAFqENICCyACQcQBaiACQcQBaiACQYABahC9CCACIAIoAsQBIgRB/////wFxNgLEASACIAIoAsgBIARBHXVqIgRB/////wFxNgLIASACIAIoAswBIARBHXVqIgRB/////wFxNgLMASACIAIoAtABIARBHXVqIgRB/////wFxNgLQASACIAIoAtQBIARBHXVqIgRB/////wFxNgLUASACIAIoAtgBIARBHXVqIgRB/////wFxNgLYASACIAIoAtwBIARBHXVqIgRB/////wFxNgLcASACIAIoAuABIARBHXVqIgRB/////wFxNgLgASACIAIoAuQBIARBHXVqIgRB/////wFxNgLkASACIAIoAugBIARBHXVqIgRB/////wFxNgLoASACIAIoAuwBIARBHXVqIgRB/////wFxNgLsASACIAIoAvABIARBHXVqIgRB/////wFxNgLwASACIAIoAvQBIARBHXVqIgRB/////wFxNgL0ASACIAIoAvgBIARBHXVqNgL4ASACQYABaiAAIAgQ9wIgAiACKAKAASIEQf////8BcTYCgAEgAiACKAKEASAEQR11aiIEQf////8BcTYChAEgAiACKAKIASAEQR11aiIEQf////8BcTYCiAEgAiACKAKMASAEQR11aiIEQf////8BcTYCjAEgAiACKAKQASAEQR11aiIEQf////8BcTYCkAEgAiACKAKUASAEQR11aiIEQf////8BcTYClAEgAiACKAKYASAEQR11aiIEQf////8BcTYCmAEgAiACKAKcASAEQR11aiIEQf////8BcTYCnAEgAiACKAKgASAEQR11aiIEQf////8BcTYCoAEgAiACKAKkASAEQR11aiIEQf////8BcTYCpAEgAiACKAKoASAEQR11aiIEQf////8BcTYCqAEgAiACKAKsASAEQR11aiIEQf////8BcTYCrAEgAiACKAKwASAEQR11aiIEQf////8BcTYCsAEgAiACKAK0ASAEQR11ajYCtAEgAkFAayABIAYQ9wIgAiACKAJAIgFB/////wFxNgJAIAIgAigCRCABQR11aiIBQf////8BcTYCRCACIAIoAkggAUEddWoiAUH/////AXE2AkggAiACKAJMIAFBHXVqIgFB/////wFxNgJMIAIgAigCUCABQR11aiIBQf////8BcTYCUCACIAIoAlQgAUEddWoiAUH/////AXE2AlQgAiACKAJYIAFBHXVqIgFB/////wFxNgJYIAIgAigCXCABQR11aiIBQf////8BcTYCXCACIAIoAmAgAUEddWoiAUH/////AXE2AmAgAiACKAJkIAFBHXVqIgFB/////wFxNgJkIAIgAigCaCABQR11aiIBQf////8BcTYCaCACIAIoAmwgAUEddWoiAUH/////AXE2AmwgAiACKAJwIAFBHXVqIgFB/////wFxNgJwIAIgAigCdCABQR11ajYCdCACNAJ4IAI0ArgBfkKAgIAQWQRAIAJBgAFqENICCyACQYAEaiACQYABaiACQUBrENMCIAJCo73EgNABNwMwIAJC7dOblsGm8/8SNwMoIAJCy+6Ru+Gsl40SNwMgIAJCw7n216CUnM8QNwMYIAJC6oOJ+4DrnqgJNwMQIAJC7v//p6Gs//8XNwMIIAJCq9X+//H///sPNwMAIAJBgAFqIAIgAkGABGoQyQIgAkECNgK4ASACIAIoAsQDIgQgAigCwAJqNgJAIAIgAigCyAMiBiACKALEAmo2AkQgAiACKALMAyIDIAIoAsgCajYCSCACIAIoAtADIgkgAigCzAJqNgJMIAIgAigC1AMiCiACKALQAmo2AlAgAiACKALYAyILIAIoAtQCajYCVCACIAIoAtwDIgwgAigC2AJqNgJYIAIgAigC4AMiDSACKALcAmo2AlwgAiACKALkAyIOIAIoAuACajYCYCACIAIoAugDIg8gAigC5AJqNgJkIAIgAigC7AMiECACKALoAmo2AmggAiACKALwAyIRIAIoAuwCajYCbCACIAIoAvQDIhIgAigC8AJqNgJwIAIgAigC+AMiEyACKAL0Amo2AnQgAiACKAL8AyIBIAIoAvgCaiIFNgJ4IAVBgICAEE4EQCACQUBrENICCyACQUBrIAJBgAFqIAJBQGsQvQggAiACKAJAIgVB/////wFxNgJAIAIgAigCRCAFQR11aiIFQf////8BcTYCRCACIAIoAkggBUEddWoiBUH/////AXE2AkggAiACKAJMIAVBHXVqIgVB/////wFxNgJMIAIgAigCUCAFQR11aiIFQf////8BcTYCUCACIAIoAlQgBUEddWoiBUH/////AXE2AlQgAiACKAJYIAVBHXVqIgVB/////wFxNgJYIAIgAigCXCAFQR11aiIFQf////8BcTYCXCACIAIoAmAgBUEddWoiBUH/////AXE2AmAgAiACKAJkIAVBHXVqIgVB/////wFxNgJkIAIgAigCaCAFQR11aiIFQf////8BcTYCaCACIAIoAmwgBUEddWoiBUH/////AXE2AmwgAiACKAJwIAVBHXVqIgVB/////wFxNgJwIAIgAigCdCAFQR11ajYCdCACIAFBAXQ2ArgBIAIgE0EBdDYCtAEgAiASQQF0NgKwASACIBFBAXQ2AqwBIAIgEEEBdDYCqAEgAiAPQQF0NgKkASACIA5BAXQ2AqABIAIgDUEBdDYCnAEgAiAMQQF0NgKYASACIAtBAXQ2ApQBIAIgCkEBdDYCkAEgAiAJQQF0NgKMASACIANBAXQ2AogBIAIgBkEBdDYChAEgAiAEQQF0NgKAASABQYCAgAhOBEAgAkGAAWoQ0gILIAJBxANqIAJBxANqIAJBgAFqEPcCIAIgAigCxAMiAUH/////AXE2AsQDIAIgAigCyAMgAUEddWoiAUH/////AXE2AsgDIAIgAigCzAMgAUEddWoiAUH/////AXE2AswDIAIgAigC0AMgAUEddWoiAUH/////AXE2AtADIAIgAigC1AMgAUEddWoiAUH/////AXE2AtQDIAIgAigC2AMgAUEddWoiAUH/////AXE2AtgDIAIgAigC3AMgAUEddWoiAUH/////AXE2AtwDIAIgAigC4AMgAUEddWoiAUH/////AXE2AuADIAIgAigC5AMgAUEddWoiAUH/////AXE2AuQDIAIgAigC6AMgAUEddWoiAUH/////AXE2AugDIAIgAigC7AMgAUEddWoiAUH/////AXE2AuwDIAIgAigC8AMgAUEddWoiAUH/////AXE2AvADIAIgAigC9AMgAUEddWoiAUH/////AXE2AvQDIAIgAigC+AMgAUEddWo2AvgDIAJBwAJqIAJBwAJqQQwQvAggAiACKALAAiACKAKAA2oiATYCACACIAIoAsQCIAIoAoQDaiIENgIEIAIgAigCyAIgAigCiANqIgY2AgggAiACKALMAiACKAKMA2oiAzYCDCACIAIoAtACIAIoApADaiIJNgIQIAIgAigC1AIgAigClANqIgo2AhQgAiACKALYAiACKAKYA2oiCzYCGCACIAIoAtwCIAIoApwDaiIMNgIcIAIgAigC4AIgAigCoANqIg02AiAgAiACKALkAiACKAKkA2oiDjYCJCACIAIoAugCIAIoAqgDaiIPNgIoIAIgAigC7AIgAigCrANqIhA2AiwgAiACKALwAiACKAKwA2oiETYCMCACIAIoAvQCIAIoArQDaiISNgI0IAIgAigC+AIgAigCuANqIhM2AjggE0GAgIAQTgRAIAIQ0gIgAigCNCESIAIoAjAhESACKAIsIRAgAigCKCEPIAIoAiQhDiACKAIgIQ0gAigCHCEMIAIoAhghCyACKAIUIQogAigCECEJIAIoAgwhAyACKAIIIQYgAigCBCEEIAIoAgAhAQsgAiABQf////8BcTYCACACIAQgAUEddWoiAUH/////AXE2AgQgAiAGIAFBHXVqIgFB/////wFxNgIIIAIgAyABQR11aiIBQf////8BcTYCDCACIAkgAUEddWoiAUH/////AXE2AhAgAiAKIAFBHXVqIgFB/////wFxNgIUIAIgCyABQR11aiIBQf////8BcTYCGCACIAwgAUEddWoiAUH/////AXE2AhwgAiANIAFBHXVqIgFB/////wFxNgIgIAIgDiABQR11aiIBQf////8BcTYCJCACIA8gAUEddWoiAUH/////AXE2AiggAiAQIAFBHXVqIgFB/////wFxNgIsIAIgESABQR11aiIBQf////8BcTYCMCACIBIgAUEddWo2AjQgAkGAA2ogAkGAA2ogAkHAAmoQvQggAiACKAKAAyIBQf////8BcTYCgAMgAiACKAKEAyABQR11aiIBQf////8BcTYChAMgAiACKAKIAyABQR11aiIBQf////8BcTYCiAMgAiACKAKMAyABQR11aiIBQf////8BcTYCjAMgAiACKAKQAyABQR11aiIBQf////8BcTYCkAMgAiACKAKUAyABQR11aiIBQf////8BcTYClAMgAiACKAKYAyABQR11aiIBQf////8BcTYCmAMgAiACKAKcAyABQR11aiIBQf////8BcTYCnAMgAiACKAKgAyABQR11aiIBQf////8BcTYCoAMgAiACKAKkAyABQR11aiIBQf////8BcTYCpAMgAiACKAKoAyABQR11aiIBQf////8BcTYCqAMgAiACKAKsAyABQR11aiIBQf////8BcTYCrAMgAiACKAKwAyABQR11aiIBQf////8BcTYCsAMgAiACKAK0AyABQR11ajYCtAMgAkFAayACQUBrQQwQvAggAjQC/AEgAjQCeH5CgICAEFkEQCACQUBrENICCyACQYAEaiACQUBrIAJBxAFqENMCIAJCo73EgNABNwOgBSACQu3Tm5bBpvP/EjcDmAUgAkLL7pG74ayXjRI3A5AFIAJCw7n216CUnM8QNwOIBSACQuqDifuA656oCTcDgAUgAkLu//+noaz//xc3A/gEIAJCq9X+//H///sPNwPwBCACQYABaiACQfAEaiACQYAEahDJAiACQQI2ArgBIAI0ArgDIhQgAjQCuAJ+QoCAgBBZBEAgAkGAAmoQ0gILIAJBgARqIAJBgAJqIAJBgANqENMCIAJCo73EgNABNwOgBSACQu3Tm5bBpvP/EjcDmAUgAkLL7pG74ayXjRI3A5AFIAJCw7n216CUnM8QNwOIBSACQuqDifuA656oCTcDgAUgAkLu//+noaz//xc3A/gEIAJCq9X+//H///sPNwPwBCACQcACaiACQfAEaiACQYAEahDJAiACQQI2AvgCIAAgAkHAAmogAkGAAWoQvQggAjQC/AMgAjQCeH5CgICAEFkEQCACQUBrENICCyACQYAEaiACQUBrIAJBxANqENMCIAJCo73EgNABNwOgBSACQu3Tm5bBpvP/EjcDmAUgAkLL7pG74ayXjRI3A5AFIAJCw7n216CUnM8QNwOIBSACQuqDifuA656oCTcDgAUgAkLu//+noaz//xc3A/gEIAJCq9X+//H///sPNwPwBCACQUBrIAJB8ARqIAJBgARqEMkCIAJBAjYCeCACNAI4IBR+QoCAgBBZBEAgAkGAA2oQ0gILIAJBgARqIAJBgANqIAIQ0wIgAkKjvcSA0AE3A6AFIAJC7dOblsGm8/8SNwOYBSACQsvukbvhrJeNEjcDkAUgAkLDufbXoJSczxA3A4gFIAJC6oOJ+4DrnqgJNwOABSACQu7//6ehrP//FzcD+AQgAkKr1f7/8f//+w83A/AEIAJBgANqIAJB8ARqIAJBgARqEMkCIAIoAkAhASACKAKAAyEEIAJBAjYCuAMgACABIARqNgI8IAAgAigChAMgAigCRGo2AkAgACACKAKIAyACKAJIajYCRCAAIAIoAowDIAIoAkxqNgJIIAAgAigCkAMgAigCUGo2AkwgACACKAKUAyACKAJUajYCUCAAIAIoApgDIAIoAlhqNgJUIAAgAigCnAMgAigCXGo2AlggACACKAKgAyACKAJgajYCXCAAIAIoAqQDIAIoAmRqNgJgIAAgAigCqAMgAigCaGo2AmQgACACKAKsAyACKAJsajYCaCAAIAIoArADIAIoAnBqNgJsIAAgAigCtAMgAigCdGo2AnAgACACKAJ4IgFBAmo2AnQgAUH+//8PTgRAIAcQ0gILIAI0ArgCIAI0AvwDfkKAgIAQWQRAIAJBxANqENICCyACQYAEaiACQcQDaiACQYACahDTAiACQqO9xIDQATcDoAUgAkLt05uWwabz/xI3A5gFIAJCy+6Ru+Gsl40SNwOQBSACQsO59teglJzPEDcDiAUgAkLqg4n7gOueqAk3A4AFIAJC7v//p6Gs//8XNwP4BCACQqvV/v/x///7DzcD8AQgAkHEA2ogAkHwBGogAkGABGoQyQIgAkECNgL8AyACNAL8ASACNAI4fkKAgIAQWQRAIAIQ0gILIAJBgARqIAIgAkHEAWoQ0wIgAkKjvcSA0AE3A6AFIAJC7dOblsGm8/8SNwOYBSACQsvukbvhrJeNEjcDkAUgAkLDufbXoJSczxA3A4gFIAJC6oOJ+4DrnqgJNwOABSACQu7//6ehrP//FzcD+AQgAkKr1f7/8f//+w83A/AEIAIgAkHwBGogAkGABGoQyQIgACACKALEAyACKAIAajYCeCAAIAIoAsgDIAIoAgRqNgJ8IAAgAigCzAMgAigCCGo2AoABIAAgAigC0AMgAigCDGo2AoQBIAAgAigC1AMgAigCEGo2AogBIAAgAigC2AMgAigCFGo2AowBIAAgAigC3AMgAigCGGo2ApABIAAgAigC4AMgAigCHGo2ApQBIAAgAigC5AMgAigCIGo2ApgBIAAgAigC6AMgAigCJGo2ApwBIAAgAigC7AMgAigCKGo2AqABIAAgAigC8AMgAigCLGo2AqQBIAAgAigC9AMgAigCMGo2AqgBIAAgAigC+AMgAigCNGo2AqwBIAAgAigC/AMiAUECajYCsAEgAUH+//8PTgRAIAgQ0gILIAAgACgCACIBQf////8BcTYCACAAIAAoAgQgAUEddWoiAUH/////AXE2AgQgACAAKAIIIAFBHXVqIgFB/////wFxNgIIIAAgACgCDCABQR11aiIBQf////8BcTYCDCAAIAAoAhAgAUEddWoiAUH/////AXE2AhAgACAAKAIUIAFBHXVqIgFB/////wFxNgIUIAAgACgCGCABQR11aiIBQf////8BcTYCGCAAIAAoAhwgAUEddWoiAUH/////AXE2AhwgACAAKAIgIAFBHXVqIgFB/////wFxNgIgIAAgACgCJCABQR11aiIBQf////8BcTYCJCAAIAAoAiggAUEddWoiAUH/////AXE2AiggACAAKAIsIAFBHXVqIgFB/////wFxNgIsIAAgACgCMCABQR11aiIBQf////8BcTYCMCAAIAAoAjQgAUEddWo2AjQgACAAKAI8IgFB/////wFxNgI8IAAgACgCQCABQR11aiIBQf////8BcTYCQCAAIAAoAkQgAUEddWoiAUH/////AXE2AkQgACAAKAJIIAFBHXVqIgFB/////wFxNgJIIAAgACgCTCABQR11aiIBQf////8BcTYCTCAAIAAoAlAgAUEddWoiAUH/////AXE2AlAgACAAKAJUIAFBHXVqIgFB/////wFxNgJUIAAgACgCWCABQR11aiIBQf////8BcTYCWCAAIAAoAlwgAUEddWoiAUH/////AXE2AlwgACAAKAJgIAFBHXVqIgFB/////wFxNgJgIAAgACgCZCABQR11aiIBQf////8BcTYCZCAAIAAoAmggAUEddWoiAUH/////AXE2AmggACAAKAJsIAFBHXVqIgFB/////wFxNgJsIAAgACgCcCABQR11ajYCcCAAIAAoAngiAUH/////AXE2AnggACAAKAJ8IAFBHXVqIgFB/////wFxNgJ8IAAgACgCgAEgAUEddWoiAUH/////AXE2AoABIAAgACgChAEgAUEddWoiAUH/////AXE2AoQBIAAgACgCiAEgAUEddWoiAUH/////AXE2AogBIAAgACgCjAEgAUEddWoiAUH/////AXE2AowBIAAgACgCkAEgAUEddWoiAUH/////AXE2ApABIAAgACgClAEgAUEddWoiAUH/////AXE2ApQBIAAgACgCmAEgAUEddWoiAUH/////AXE2ApgBIAAgACgCnAEgAUEddWoiAUH/////AXE2ApwBIAAgACgCoAEgAUEddWoiAUH/////AXE2AqABIAAgACgCpAEgAUEddWoiAUH/////AXE2AqQBIAAgACgCqAEgAUEddWoiAUH/////AXE2AqgBIAAgACgCrAEgAUEddWo2AqwBIAJBsAVqJAALpgUCBH8BeyMAQeABayIBJAAgAUHSvCk2AiAgAEH5hiogAUEgahCbAQJAAkAgAEEBELECIgMEQCADQQhqEL4CIABBGEEBENoBIQIgAEHY4c59QbHwKhCQARogAEF+ENsBIAJBADsBFCACQiA3AgggAkEANgIQIAJBAToAACAAIAIQyAIgAigCDCEEIAEgAygCCDYCMCABIAMoAgw2AjQgASADKAIQNgI4IAEgAygCFDYCPCABIAMoAhg2AkAgASADKAIcNgJEIAEgAygCIDYCSCABIAMoAiQ2AkwgASADKAIoNgJQIAEgAygCLDYCVCABIAMoAjA2AlggASADKAI0NgJcIAEgAygCODYCYCADKAI8IQIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAnwgASAF/QsCjAEgAUEANgKcASABIAX9CwJsIAEgAkEddTYCaCABIAJB/////wFxNgJkIAFCo73EgNABNwPQASABQu3Tm5bBpvP/EjcDyAEgAULL7pG74ayXjRI3A8ABIAFCw7n216CUnM8QNwO4ASABQuqDifuA656oCTcDsAEgAULu//+noaz//xc3A6gBIAFCq9X+//H///sPNwOgASAEIAFBoAFqIAFBMGoQyQIgAyADKAK8ASICQQFrNgK8ASACQQFKDQJBpIg0KAIAIgJFDQEgASADNgIwIAIoAgAiBCABKAIwSw0BIAEoAjAgBCACKAIQak8NASADIAIoAgQ2AgAgAiADNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNAiACQXxxIgJFDQIgA0EAIAL8CwAMAgsgAUG63is2AgQgAUHSvCk2AgAgAEH8iCogARBsAAsgAxArCyABQdK8KTYCECAAQeCHKiABQRBqEJsBIAFB4AFqJABBAQumAgEDfwJAIAEoAgwiAkUNACABLwEUDQAgAEH98SpBABBbDwsCQCABKAIQRQRAIAEvARRFDQELIABBw7EqQQAQbg8LIAJFBEACQEGkiDQoAgAiAARAAn8CQCAAKAIUQThJDQAgACgCBCICRQ0AIAAoAhgiAyADKALgAUEBajYC4AEgACAAKAIcQQFqNgIcIAAgACgCIEE4ajYCICAAIAAoAixBOGo2AiwgACACKAIANgIEQQghBEF/DAELQTgQKiICRQRAEE8LIAAgACgCJEEBajYCJCAAIAAoAihBOGo2AihBLCEEQTgLIQMgACAEaiIAIAAoAgAgA2o2AgAMAQtBOBAqIQILIAFBADsBFCABIAI2AgwgAUEwNgIEDwsgAEGYsipBABBuC/UFAgd+DH8jAEGwAWsiCyQAIAsgAigCACIKQf3/8/8BbEH/////AXEiDjYCACACNAIEIAqsIA6tIgYgATQCACIHfnxCHYd8IQNBASENA0AgAyAEfCABIA1BAnQiD2o0AgAiBSAGfnwhAyANQQFrIgogDUEBdiIQSwRAA0AgASAKQQJ0Ig5qKAIAIAEgDSAKa0ECdCIMaigCAGusIAsgDGooAgAgCyAOaigCAGusfiADfCEDIApBAWsiCiAQSg0ACwsgCyAPaiADp0H9//P/AWxB/////wFxIg42AgAgAiANQQFqIgpBAnRqNAIAIQggC0FAayANQQN0aiAOrSIJIAV+IgU3AwAgCCAHIAl+IAN8Qh2HfCEDIAQgBXwhBCAKIQ0gCkEORw0ACyAAQThrIQ1BDiEKIAsoAiAhESALKAIkIRIgCygCKCETIAsoAiwhFCALKAIwIRUgCygCNCEQA0AgDSAKQQJ0agJ+IAMgBHwgASgCNCABIApBDWsiDkECdCIMaigCAGusIAsgDGooAgAgEGusfnwiAyAKQRdLDQAaIAEoAjAgASAKQQJ0Ig9BMGsiDGooAgBrrCALIAxqKAIAIBVrrH4gA3wiAyAKQRVLDQAaIAEoAiwgASAPQSxrIgxqKAIAa6wgCyAMaigCACAUa6x+IAN8IgMgCkETSw0AGiABKAIoIAEgD0EoayIMaigCAGusIAsgDGooAgAgE2usfiADfCIDIApBEUsNABogASgCJCABIA9BJGsiDGooAgBrrCALIAxqKAIAIBJrrH4gA3wiAyAKQQ9LDQAaIAEoAiAgASAPQSBrIgxqKAIAa6wgCyAMaigCACARa6x+IAN8CyIDp0H/////AXE2AgAgAiAKQQFqIgpBAnRqNAIAIANCHYd8IQMgBCALQUBrIA5BA3RqKQMAfSEEIApBGkcNAAsgACADIAR8IgOnQf////8BcTYCMCAAIAIoAmwgA0IdiKdqQf////8BcTYCNCALQbABaiQAC6YFAgR/AXsjAEHgAWsiASQAIAFByrkpNgIgIABB+YYqIAFBIGoQmwECQAJAIABBARCxAiIDBEAgA0EIahC+AiAAQRhBARDaASECIABB2OHOfUGx8CoQkAEaIABBfhDbASACQQA7ARQgAkIgNwIIIAJBADYCECACQQE6AAAgACACEMgCIAIoAgwhBCABIAMoAkQ2AjAgASADKAJINgI0IAEgAygCTDYCOCABIAMoAlA2AjwgASADKAJUNgJAIAEgAygCWDYCRCABIAMoAlw2AkggASADKAJgNgJMIAEgAygCZDYCUCABIAMoAmg2AlQgASADKAJsNgJYIAEgAygCcDYCXCABIAMoAnQ2AmAgAygCeCECIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwJ8IAEgBf0LAowBIAFBADYCnAEgASAF/QsCbCABIAJBHXU2AmggASACQf////8BcTYCZCABQqO9xIDQATcD0AEgAULt05uWwabz/xI3A8gBIAFCy+6Ru+Gsl40SNwPAASABQsO59teglJzPEDcDuAEgAULqg4n7gOueqAk3A7ABIAFC7v//p6Gs//8XNwOoASABQqvV/v/x///7DzcDoAEgBCABQaABaiABQTBqEMkCIAMgAygCvAEiAkEBazYCvAEgAkEBSg0CQaSINCgCACICRQ0BIAEgAzYCMCACKAIAIgQgASgCMEsNASABKAIwIAQgAigCEGpPDQEgAyACKAIENgIAIAIgAzYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQIgAkF8cSICRQ0CIANBACAC/AsADAILIAFBut4rNgIEIAFByrkpNgIAIABB/IgqIAEQbAALIAMQKwsgAUHKuSk2AhAgAEHghyogAUEQahCbASABQeABaiQAQQEL7QoBB38jAEHgAWsiASQAIAFBxMkrNgIgIABB+YYqIAFBIGoQmwECQAJAIABBARCxAiIFQQBHIABBAhCxAiICQQBHcSIGBEAgAEHAAUEBENoBIgRCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASAEQQE2ArwBIARBCGoiBCAFQQhqEL0CIAEgAigCCDYCLCABIAIoAgw2AjAgASACKAIQNgI0IAEgAigCFDYCOCABIAIoAhg2AjwgASACKAIcNgJAIAEgAigCIDYCRCABIAIoAiQ2AkggASACKAIoNgJMIAEgAigCLDYCUCABIAIoAjA2AlQgASACKAI0NgJYIAEgAigCODYCXCABIAIoAjw2AmAgASACKAJANgJkIAEgAigCRDYCaCABIAIoAkg2AmwgASACKAJMNgJwIAEgAigCUDYCdCABIAIoAlQ2AnggASACKAJYNgJ8IAEgAigCXDYCgAEgASACKAJgNgKEASABIAIoAmQ2AogBIAEgAigCaDYCjAEgASACKAJsNgKQASABIAIoAnA2ApQBIAEgAigCdDYCmAEgASACKAJ4NgKcASABIAIoAnw2AqABIAEgAigCgAE2AqQBIAEgAigChAE2AqgBIAEgAigCiAE2AqwBIAEgAigCjAE2ArABIAEgAigCkAE2ArQBIAEgAigClAE2ArgBIAEgAigCmAE2ArwBIAEgAigCnAE2AsABIAEgAigCoAE2AsQBIAEgAigCpAE2AsgBIAEgAigCqAE2AswBIAEgAigCrAE2AtABIAEgAigCsAE2AtQBIAEgAigCtAE2AtgBIAEgAigCuAE2AtwBIAFB6ABqIgMgAxDMAiABIAEoAmgiA0H/////AXE2AmggASABKAJsIANBHXVqIgNB/////wFxNgJsIAEgASgCcCADQR11aiIDQf////8BcTYCcCABIAEoAnQgA0EddWoiA0H/////AXE2AnQgASABKAJ4IANBHXVqIgNB/////wFxNgJ4IAEgASgCfCADQR11aiIDQf////8BcTYCfCABIAEoAoABIANBHXVqIgNB/////wFxNgKAASABIAEoAoQBIANBHXVqIgNB/////wFxNgKEASABIAEoAogBIANBHXVqIgNB/////wFxNgKIASABIAEoAowBIANBHXVqIgNB/////wFxNgKMASABIAEoApABIANBHXVqIgNB/////wFxNgKQASABIAEoApQBIANBHXVqIgNB/////wFxNgKUASABIAEoApgBIANBHXVqIgNB/////wFxNgKYASABIAEoApwBIANBHXVqNgKcASAEIAFBLGoQxgJBACEDDAELQYLeKyEDIAJFDQELIAIgAigCvAEiBEEBazYCvAECQCAEQQFKDQACQEGkiDQoAgAiBEUNACABIAI2AiwgBCgCACIHIAEoAixLDQAgASgCLCAHIAQoAhBqTw0AIAIgBCgCBDYCACAEIAI2AgQgBCAEKAIIQQFqNgIIIAQoAhQiBEEESQ0BIARBfHEiBEUNASACQQAgBPwLAAwBCyACECsLIAYhBAsCQCAFRQ0AIAUgBSgCvAEiAkEBazYCvAEgAkEBSg0AAkBBpIg0KAIAIgJFDQAgASAFNgIsIAIoAgAiBiABKAIsSw0AIAEoAiwgBiACKAIQak8NACAFIAIoAgQ2AgAgAiAFNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgBUEAIAL8CwAMAQsgBRArCyAERQRAIAEgAzYCFCABQcTJKzYCECAAQfyIKiABQRBqEGwACyABQcTJKzYCACAAQeCHKiABEJsBIAFB4AFqJABBAQvMBAEDfyAAQavV/v8BIAEoAjhBAWsiAkEBdiACciICQQJ2IAJyIgJBBHYgAnIiAkEIdiACciICQRB2IAJyaSICdEH/////AXEgASgCAGs2AgAgAEH//9//ACACdEH/////AXFBq9X+/wFBHSACayIDdnIgASgCBGs2AgQgAEHu//+nASACdEH+////AXFB///f/wAgA3ZyIAEoAghrNgIIIABB4vr/vwEgAnRB/v///wFxQe7//6cBIAN2ciABKAIMazYCDCAAQeqDifsAIAJ0Qf7///8BcUHi+v+/ASADdnIgASgCEGs2AhAgAEHY9sHKACACdEH4////AXFB6oOJ+wAgA3ZyIAEoAhRrNgIUIABBw7n21wAgAnRB/////wFxQdj2wcoAIAN2ciABKAIYazYCGCAAQaLh+YQBIAJ0Qf7///8BcUHDufbXACADdnIgASgCHGs2AhwgAEHL7pG7ASACdEH/////AXFBouH5hAEgA3ZyIAEoAiBrNgIgIABB5rrpkAEgAnRB/v///wFxQcvukbsBIAN2ciABKAIkazYCJCAAQe3Tm5YBIAJ0Qf////8BcUHmuumQASADdnIgASgCKGs2AiggAEG0mv+XASACdEH8////AXFB7dOblgEgA3ZyIAEoAixrNgIsIABBo73EACACdEH/////AXFBtJr/lwEgA3ZyIAEoAjBrNgIwIAEoAjQhASAAQQEgAnQiBEEBajYCOCAAQQ0gAnRBo73EACADdnIgAWs2AjQgBEH///8PTgRAIAAQ0gILC/0DAQd/IwBBMGsiAyQAIANB1MYqNgIgIABB+YYqIANBIGoQmwFBASEEQQEhAgJAAkACQAJAIABBAUGLpyoQ3AENAEECIQIgAEECQYunKhDcAQ0AQfjuKSEFDAELAkAgAEEBQbHwKhDcAQ0AQQIhBCAAQQJBsfAqENwBDQBBpe8pIQUMAQsgACACELECIQIgACAEEM4CIQQCfwJAIAJFDQAgBEUNACAELwEUBEBBiaoqIQVBAAwCCyAAQcABQQEQ2gEiAUK4gICAkAw3AgAgAEHY4c59QYunKhCQARogAEF+ENsBIAFBATYCvAEgAUEIaiIBIAJBCGoQvQIgASAEKAIMEM8CQQEMAQtB38spIQUgAkUNAkEACyEGIAIgAigCvAEiAUEBazYCvAECQCABQQFKDQACQEGkiDQoAgAiAUUNACADIAI2AiwgASgCACIHIAMoAixLDQAgAygCLCAHIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASACQQAgAfwLAAwBCyACECsLIAQQ0AIgBkUNAiADQdTGKjYCECAAQeCHKiADQRBqEJsBIANBMGokAEEBDwtBACEECyAEENACCyADIAU2AgQgA0HUxio2AgAgAEH8iCogAxBsAAvnBwEEfwJAQaSINCgCACICBEACfwJAIAIoAhRBGEkNACACKAIEIgNFDQAgAigCGCIEIAQoAmBBAWo2AmAgAiACKAIcQQFqNgIcIAIgAigCIEEYajYCICACIAIoAixBGGo2AiwgAiADKAIANgIEQQghBUF/DAELQRgQKiIDRQRAEE8LIAIgAigCJEEBajYCJCACIAIoAihBGGo2AihBLCEFQRgLIQQgAiAFaiICIAIoAgAgBGo2AgAMAQtBGBAqIQMLIANBADsBFCADQiA3AgggA0EANgIQIANBAToAACAAIAFBsfAqENwBIgQEQCADIAQoAgg2AgggAyAELwEUOwEUAkACfyAEKAIMBEAgACADEMgCIAMoAgwiAiAEKAIMIgEoAgA2AgAgAiABKAIENgIEIAIgASgCCDYCCCACIAEoAgw2AgwgAiABKAIQNgIQIAIgASgCFDYCFCACIAEoAhg2AhggAiABKAIcNgIcIAIgASgCIDYCICACIAEoAiQ2AiQgAiABKAIoNgIoIAIgASgCLDYCLCACIAEoAjA2AjAgAUE0agwBCyAEKAIQRQ0BIAAgAxCWAyADKAIQIgIgBCgCECIBKAIANgIAIAIgASgCBDYCBCACIAEoAgg2AgggAiABKAIMNgIMIAIgASgCEDYCECACIAEoAhQ2AhQgAiABKAIYNgIYIAIgASgCHDYCHCACIAEoAiA2AiAgAiABKAIkNgIkIAIgASgCKDYCKCACIAEoAiw2AiwgAiABKAIwNgIwIAIgASgCNDYCNCACIAEoAjg2AjggAiABKAI8NgI8IAIgASgCQDYCQCACIAEoAkQ2AkQgAiABKAJINgJIIAIgASgCTDYCTCACIAEoAlA2AlAgAiABKAJUNgJUIAIgASgCWDYCWCACIAEoAlw2AlwgAiABKAJgNgJgIAIgASgCZDYCZCACIAEoAmg2AmggAiABKAJsNgJsIAMoAhAiAiAEKAIQIgEoAjg2AgAgAiABKAI8NgIEIAIgASgCQDYCCCACIAEoAkQ2AgwgAiABKAJINgIQIAIgASgCTDYCFCACIAEoAlA2AhggAiABKAJUNgIcIAIgASgCWDYCICACIAEoAlw2AiQgAiABKAJgNgIoIAIgASgCZDYCLCACIAEoAmg2AjAgAUHsAGoLIQEgAiABKAIANgI0CyADIAQtAAA6AAAgAygCDARAIAMPCyADKAIQBEAgAw8LIABBq7ArQQAQbiADENACQQAPCyAAIAEQyAEiAgRAIAAgAyACEOICBEAgAhCaASADDwsgAxDQAiACEJoBQQAPCyAAQbnYKUEAEG4gAxDQAkEAC/KbAQJOfwF7IwBB0A9rIgIkAAJAIAAQuAIEQCAAQfgAahC4Ag0BCwJAIAEoAgANACABKAIEDQAgASgCCA0AIAEoAgwNACABKAIQDQAgASgCFA0AIAEoAhgNACABKAIcDQAgASgCIA0AIAEoAiQNACABKAIoDQAgASgCLA0AIAEoAjANACABKAI0DQAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAEEBNgI4IABCADcCMCAAIFD9CwIgIAAgUP0LAhAgAiBQ/QsCFCACIFD9CwIkIAJBADYCNCACQQE2AgAgAiBQ/QsCBCACQqvUmfXBATcDwAwgAkK8uf7o8M+tvAI3A7gMIAJCmcfZ2fHo26kcNwOwDCACQtvLw4uRtonHCDcDqAwgAkLS2bjzoLWTtBE3A6AMIAJC6Kf2lrDkmJEJNwOYDCACQq7v+63hofOYEDcDkAwgAkHwAGogAiACQZAMahDTAiACQqO9xIDQATcDwA4gAkLt05uWwabz/xI3A7gOIAJCy+6Ru+Gsl40SNwOwDiACQsO59teglJzPEDcDqA4gAkLqg4n7gOueqAk3A6AOIAJC7v//p6Gs//8XNwOYDiACQqvV/v/x///7DzcDkA4gAEE8aiACQZAOaiACQfAAahDJAiAAQQI2AnQgAEIANwKoASAAIFD9CwKYASAAIFD9CwKIASAAIFD9CwJ4IABBATYCsAEMAQsgABC+AiACIAAoAgA2ApAMIAIgACgCBDYClAwgAiAAKAIINgKYDCACIAAoAgw2ApwMIAIgACgCEDYCoAwgAiAAKAIUNgKkDCACIAAoAhg2AqgMIAIgACgCHDYCrAwgAiAAKAIgNgKwDCACIAAoAiQ2ArQMIAIgACgCKDYCuAwgAiAAKAIsNgK8DCACIAAoAjA2AsAMIAIgACgCNDYCxAwgAiAAKAI4NgLIDCACIAAoAjw2AswMIAIgACgCQDYC0AwgAiAAKAJENgLUDCACIAAoAkg2AtgMIAIgACgCTDYC3AwgAiAAKAJQNgLgDCACIAAoAlQ2AuQMIAIgACgCWDYC6AwgAiAAKAJcNgLsDCACIAAoAmA2AvAMIAIgACgCZDYC9AwgAiAAKAJoNgL4DCACIAAoAmw2AvwMIAIgACgCcDYCgA0gAiAAKAJ0NgKEDSACIAAoAng2AogNIAIgACgCfDYCjA0gAiAAKAKAATYCkA0gAiAAKAKEATYClA0gAiAAKAKIATYCmA0gAiAAKAKMATYCnA0gAiAAKAKQATYCoA0gAiAAKAKUATYCpA0gAiAAKAKYATYCqA0gAiAAKAKcATYCrA0gAiAAKAKgATYCsA0gAiAAKAKkATYCtA0gAiAAKAKoATYCuA0gAiAAKAKsATYCvA0gAiAAKAKwATYCwA0gAkGQDGoQwgIgAiAAKAIANgJwIAIgACgCBDYCdCACIAAoAgg2AnggAiAAKAIMNgJ8IAIgACgCEDYCgAEgAiAAKAIUNgKEASACIAAoAhg2AogBIAIgACgCHDYCjAEgAiAAKAIgNgKQASACIAAoAiQ2ApQBIAIgACgCKDYCmAEgAiAAKAIsNgKcASACIAAoAjA2AqABIAIgACgCNDYCpAEgAiAAKAI4NgKoASACIAAoAjw2AqwBIAIgACgCQDYCsAEgAiAAKAJENgK0ASACIAAoAkg2ArgBIAIgACgCTDYCvAEgAiAAKAJQNgLAASACIAAoAlQ2AsQBIAIgACgCWDYCyAEgAiAAKAJcNgLMASACIAAoAmA2AtABIAIgACgCZDYC1AEgAiAAKAJoNgLYASACIAAoAmw2AtwBIAIgACgCcDYC4AEgAiAAKAJ0NgLkASACIAAoAng2AugBIAIgACgCfDYC7AEgAiAAKAKAATYC8AEgAiAAKAKEATYC9AEgAiAAKAKIATYC+AEgAiAAKAKMATYC/AEgAiAAKAKQATYCgAIgAiAAKAKUATYChAIgAiAAKAKYATYCiAIgAiAAKAKcATYCjAIgAiAAKAKgATYCkAIgAiAAKAKkATYClAIgAiAAKAKoATYCmAIgAiAAKAKsATYCnAIgAiAAKAKwATYCoAIgAiACKAJwNgKkAiACIAIoAnQ2AqgCIAIgAigCeDYCrAIgAiACKAJ8NgKwAiACIAIoAoABNgK0AiACIAIoAoQBNgK4AiACIAIoAogBNgK8AiACIAIoAowBNgLAAiACIAIoApABNgLEAiACIAIoApQBNgLIAiACIAIoApgBNgLMAiACIAIoApwBNgLQAiACIAIoAqABNgLUAiACIAIoAqQBNgLYAiACIAIoAqgBNgLcAiACIAIoAqwBNgLgAiACIAIoArABNgLkAiACIAIoArQBNgLoAiACIAIoArgBNgLsAiACIAIoArwBNgLwAiACIAIoAsABNgL0AiACIAIoAsQBNgL4AiACIAIoAsgBNgL8AiACIAIoAswBNgKAAyACIAIoAtABNgKEAyACIAIoAtQBNgKIAyACIAIoAtgBNgKMAyACIAIoAtwBNgKQAyACIAIoAuABNgKUAyACIAIoAuQBNgKYAyACIAIoAugBNgKcAyACIAIoAuwBNgKgAyACIAIoAvABNgKkAyACIAIoAvQBNgKoAyACIAIoAvgBNgKsAyACIAIoAvwBNgKwAyACIAIoAoACNgK0AyACIAIoAoQCNgK4AyACIAIoAogCNgK8AyACIAIoAowCNgLAAyACIAIoApACNgLEAyACIAIoApQCNgLIAyACIAIoApgCNgLMAyACIAIoApwCNgLQAyACIAIoAqACNgLUAyACQaQCaiACQZAMahDGAiACIAIoAqQCNgLYAyACIAL9AAOoAv0LAtwDIAIgAv0AA7gC/QsC7AMgAiAC/QADyAL9CwL8AyACIAL9AAPYAv0LAowEIAIgAv0AA+gC/QsCnAQgAiAC/QAD+AL9CwKsBCACIAIpA4gDNwK8BCACIAIoApADNgLEBCACIAIoApQDNgLIBCACIAL9AAOYA/0LAswEIAIgAv0AA6gD/QsC3AQgAiAC/QADuAP9CwLsBCACIAL9AAPIA/0LAvwEIAJB2ANqIAJBkAxqEMYCIAIgAigC2AM2AowFIAIgAv0AAtwD/QsEkAUgAiAC/QAC7AP9CwSgBSACIAL9AAL8A/0LBLAFIAIgAv0AAowE/QsEwAUgAiAC/QACnAT9CwTQBSACIAL9AAKsBP0LBOAFIAIgAikCvAQ3A/AFIAIgAigCxAQ2AvgFIAIgAigCyAQ2AvwFIAIgAv0AAswE/QsEgAYgAiAC/QAC3AT9CwSQBiACIAL9AALsBP0LBKAGIAIgAv0AAvwE/QsEsAYgAkGMBWogAkGQDGoQxgIgAiACKAKMBTYCwAYgAiAC/QAEkAX9CwLEBiACIAL9AASgBf0LAtQGIAIgAv0ABLAF/QsC5AYgAiAC/QAEwAX9CwL0BiACIAL9AATQBf0LAoQHIAIgAv0ABOAF/QsClAcgAiACKQPwBTcCpAcgAiACKAL4BTYCrAcgAiACKAL8BTYCsAcgAiAC/QAEgAb9CwK0ByACIAL9AASQBv0LAsQHIAIgAv0ABKAG/QsC1AcgAiAC/QAEsAb9CwLkByACQcAGaiACQZAMahDGAiACIAL9AATABv0LAvQHIAIgAv0ABNAG/QsChAggAiACKQPgBjcClAggAiACKALoBjYCnAggAiAC/QAC7Ab9CwSgCCACIAL9AAL8Bv0LBLAIIAIgAikCjAc3A8AIIAIgAigClAc2AsgIIAIgAigCmAc2AswIIAIgAigCnAc2AtAIIAIgAv0ABKAH/QsC1AggAiAC/QAEsAf9CwLkCCACIAL9AATAB/0LAvQIIAIgAv0ABNAH/QsChAkgAiAC/QAE4Af9CwKUCSACIAIoAvAHNgKkCSACQfQHaiACQZAMahDGAiACIAL9AAL0B/0LA6gJIAIgAv0AAoQI/QsDuAkgAiACKQKUCDcDyAkgAiAC/QAEsAj9CwLkCSACIAL9AATACP0LAvQJIAIgAv0ABNAI/QsChAogAiAC/QAEoAj9CwLUCSACIAL9AATgCP0LApQKIAIgAv0ABPAI/QsCpAogAiACKQOACTcCtAogAiACKAKICTYCvAogAiACKAKcCDYC0AkgAiACKAKMCTYCwAogAiACKQOQCTcCxAogAiAC/QADmAn9CwLMCiACQagJaiACQZAMahDGAiACIAIoAqgJNgLcCiACIAIoAqwJNgLgCiACIAIoArAJNgLkCiACIAIoArQJNgLoCiACIAIoArgJNgLsCiACIAIoArwJNgLwCiACIAIoAsAJNgL0CiACIAIoAsQJNgL4CiACIAIoAsgJNgL8CiACIAIoAswJNgKACyACIAIoAtAJNgKECyACIAL9AALUCf0LA4gLIAIgAv0AAuQJ/QsDmAsgAiAC/QAC9An9CwOoCyACIAL9AAKECv0LA7gLIAIgAv0AApQK/QsDyAsgAiAC/QACpAr9CwPYCyACIAIpArQKNwPoCyACIAIoArwKNgLwCyACIAIoAsAKNgL0CyACIAIpAsQKNwP4CyACIAL9AALMCv0LBIAMIAJB3ApqIAJBkAxqEMYCIAEoAjQhFSABKAIwIRAgASgCLCERIAEoAighEiABKAIkIRMgASgCICEUIAEoAhwhDSABKAIYIQMgASgCFCEOIAEoAhAhBCABKAIMIQ8gASgCCCEIIAEoAgQhDCACIAEoAgAiCUH/////AXFBAWoiBkH/////AXEiAUEBaiIKIAZzQQAgCUECb2siBXFB/////wFxIAFzIgE2AtANIAIgDCAJQR11aiILQf////8BcSAGQR12aiIMQf////8BcSIJIApBHXZqIgogDHMgBXFB/////wFxIAlzIgk2AtQNIAIgCCALQR11aiILQf////8BcSAMQR12aiIIQf////8BcSIMIApBHXZqIgogCHMgBXFB/////wFxIAxzIgw2AtgNIAIgDyALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIPIApBHXZqIgogCHMgBXFB/////wFxIA9zIg82AtwNIAIgBCALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIEIApBHXZqIgogCHMgBXFB/////wFxIARzIgQ2AuANIAIgDiALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIOIApBHXZqIgogCHMgBXFB/////wFxIA5zIg42AuQNIAIgAyALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIDIApBHXZqIgogCHMgBXFB/////wFxIANzIgM2AugNIAIgDSALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSINIApBHXZqIgogCHMgBXFB/////wFxIA1zIg02AuwNIAIgFCALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIUIApBHXZqIgogCHMgBXFB/////wFxIBRzIhQ2AvANIAIgEyALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSITIApBHXZqIgogCHMgBXFB/////wFxIBNzIhM2AvQNIAIgEiALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSISIApBHXZqIgogCHMgBXFB/////wFxIBJzIhI2AvgNIAIgESALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIRIApBHXZqIgogCHMgBXFB/////wFxIBFzIhE2AvwNIAIgECALQR11aiILQf////8BcSAIQR12aiIIQf////8BcSIQIApBHXZqIgogCHMgBXFB/////wFxIBBzIhA2AoAOIAIgFSALQR11aiAIQR12aiIIIApBHXZqIAhzIAVxIAhzIhU2AoQOIAJBACAGQQFxayIFIAIoApAMIgggACgCAHNxIAhzNgKQDCACIAIoApQMIgYgACgCBHMgBXEgBnM2ApQMIAIgAigCmAwiBiAAKAIIcyAFcSAGczYCmAwgAiACKAKcDCIGIAAoAgxzIAVxIAZzNgKcDCACIAIoAqAMIgYgACgCEHMgBXEgBnM2AqAMIAIgAigCpAwiBiAAKAIUcyAFcSAGczYCpAwgAiACKAKoDCIGIAAoAhhzIAVxIAZzNgKoDCACIAIoAqwMIgYgACgCHHMgBXEgBnM2AqwMIAIgAigCsAwiBiAAKAIgcyAFcSAGczYCsAwgAiACKAK0DCIGIAAoAiRzIAVxIAZzNgK0DCACIAIoArgMIgYgACgCKHMgBXEgBnM2ArgMIAIgAigCvAwiBiAAKAIscyAFcSAGczYCvAwgAiACKALADCIGIAAoAjBzIAVxIAZzNgLADCACIAIoAsQMIgYgACgCNHMgBXEgBnM2AsQMIAIgAigCyAwiBiAAKAI4cyAFcSAGczYCyAwgAiACKALMDCIGIAAoAjxzIAVxIAZzNgLMDCACIAIoAtAMIgYgACgCQHMgBXEgBnM2AtAMIAIgAigC1AwiBiAAKAJEcyAFcSAGczYC1AwgAiACKALYDCIGIAAoAkhzIAVxIAZzNgLYDCACIAIoAtwMIgYgACgCTHMgBXEgBnM2AtwMIAIgAigC4AwiBiAAKAJQcyAFcSAGczYC4AwgAiACKALkDCIGIAAoAlRzIAVxIAZzNgLkDCACIAIoAugMIgYgACgCWHMgBXEgBnM2AugMIAIgAigC7AwiBiAAKAJccyAFcSAGczYC7AwgAiACKALwDCIGIAAoAmBzIAVxIAZzNgLwDCACIAIoAvQMIgYgACgCZHMgBXEgBnM2AvQMIAIgAigC+AwiBiAAKAJocyAFcSAGczYC+AwgAiACKAL8DCIGIAAoAmxzIAVxIAZzNgL8DCACIAIoAoANIgYgACgCcHMgBXEgBnM2AoANIAIgAigChA0iBiAAKAJ0cyAFcSAGczYChA0gAiACKAKIDSIGIAAoAnhzIAVxIAZzNgKIDSACIAIoAowNIgYgACgCfHMgBXEgBnM2AowNIAIgAigCkA0iBiAAKAKAAXMgBXEgBnM2ApANIAIgAigClA0iBiAAKAKEAXMgBXEgBnM2ApQNIAIgAigCmA0iBiAAKAKIAXMgBXEgBnMiFzYCmA0gAiACKAKcDSIGIAAoAowBcyAFcSAGcyIYNgKcDSACIAIoAqANIgYgACgCkAFzIAVxIAZzIhk2AqANIAIgAigCpA0iBiAAKAKUAXMgBXEgBnMiGjYCpA0gAiACKAKoDSIGIAAoApgBcyAFcSAGcyIbNgKoDSACIAIoAqwNIgYgACgCnAFzIAVxIAZzIhw2AqwNIAIgAigCsA0iBiAAKAKgAXMgBXEgBnMiHTYCsA0gAiACKAK0DSIGIAAoAqQBcyAFcSAGcyIeNgK0DSACIAIoArgNIgYgACgCqAFzIAVxIAZzIh82ArgNIAIgAigCvA0iBiAAKAKsAXMgBXEgBnMiIDYCvA0gAiACKALADSIGIAAoArABcyAFcSAGcyIhNgLADSACKAKUDSEiIAIoApANISMgAigCjA0hJCACKAKIDSElIAIoAoQNISYgAigCgA0hJyACKAL8DCEoIAIoAvgMISkgAigC9AwhKiACKALwDCErIAIoAuwMISwgAigC6AwhLSACKALkDCEuIAIoAuAMIS8gAigC3AwhMCACKALYDCExIAIoAtQMITIgAigC0AwhMyACKALMDCE0IAIoAsgMITUgAigCxAwhNiACKALADCE3IAIoArwMITggAigCuAwhOSACKAK0DCE6IAIoArAMITsgAigCrAwhPCACKAKoDCE9IAIoAqQMIT4gAigCoAwhPyACKAKcDCFAIAIoApgMIUEgAigClAwhQiACKAKQDCFDIAJB0A1qELADIgVBA2pBBG0iCEEBaiELIAVBekgiFkUEQCAIQQAgCEEAShshCgNAIAIgB2ogAUEfcUEQayIFOgAAIAkgASAFayIBQR11aiIFQRl0QYCAgPABcSABQQR2Qf///w9xciEBIAwgBUEddWoiBkEZdEGAgIDwAXEgBUEEdkH///8PcXIhCSAPIAZBHXVqIgVBGXRBgICA8AFxIAZBBHZB////D3FyIQwgBCAFQR11aiIGQRl0QYCAgPABcSAFQQR2Qf///w9xciEPIA4gBkEddWoiBUEZdEGAgIDwAXEgBkEEdkH///8PcXIhBCADIAVBHXVqIgZBGXRBgICA8AFxIAVBBHZB////D3FyIQ4gDSAGQR11aiIFQRl0QYCAgPABcSAGQQR2Qf///w9xciEDIBQgBUEddWoiBkEZdEGAgIDwAXEgBUEEdkH///8PcXIhDSATIAZBHXVqIgVBGXRBgICA8AFxIAZBBHZB////D3FyIRQgEiAFQR11aiIGQRl0QYCAgPABcSAFQQR2Qf///w9xciETIBEgBkEddWoiBUEZdEGAgIDwAXEgBkEEdkH///8PcXIhEiAQIAVBHXVqIgZBGXRBgICA8AFxIAVBBHZB////D3FyIREgFSAGQR11aiIFQRl0QYCAgPABcSAGQQR2Qf///w9xciEQIAVBBHUhFSAHIApHIQUgB0EBaiEHIAUNAAsgAiAVNgKEDiACIBA2AoAOIAIgETYC/A0gAiASNgL4DSACIBM2AvQNIAIgFDYC8A0gAiANNgLsDSACIAM2AugNIAIgDjYC5A0gAiAENgLgDSACIA82AtwNIAIgDDYC2A0gAiAJNgLUDSACIAE2AtANCyACIAE2AtANIAIgC2ogAUEfcSIHOgAAIAIgFTYChA4gAiAQNgKADiACIBE2AvwNIAIgEjYC+A0gAiATNgL0DSACIBQ2AvANIAIgDTYC7A0gAiADNgLoDSACIA42AuQNIAIgBDYC4A0gAiAPNgLcDSACIAw2AtgNIAIgCTYC1A0gACACQfAAaiAHQQFrQQJtQf//A3FBtAFsaiIHKAIANgIAIAAgBygCBDYCBCAAIAcoAgg2AgggACAHKAIMNgIMIAAgBygCEDYCECAAIAcoAhQ2AhQgACAHKAIYNgIYIAAgBygCHDYCHCAAIAcoAiA2AiAgACAHKAIkNgIkIAAgBygCKDYCKCAAIAcoAiw2AiwgACAHKAIwNgIwIAAgBygCNDYCNCAAIAcoAjg2AjggACAHKAI8NgI8IAAgBygCQDYCQCAAIAcoAkQ2AkQgACAHKAJINgJIIAAgBygCTDYCTCAAIAcoAlA2AlAgACAHKAJUNgJUIAAgBygCWDYCWCAAIAcoAlw2AlwgACAHKAJgNgJgIAAgBygCZDYCZCAAIAcoAmg2AmggACAHKAJsNgJsIAAgBygCcDYCcCAAIAcoAnQ2AnQgACAHKAJ4NgJ4IAAgBygCfDYCfCAAIAcoAoABNgKAASAAIAcoAoQBNgKEASAAIAcoAogBNgKIASAAIAcoAowBNgKMASAAIAcoApABNgKQASAAIAcoApQBNgKUASAAIAcoApgBNgKYASAAIAcoApwBNgKcASAAIAcoAqABNgKgASAAIAcoAqQBNgKkASAAIAcoAqgBNgKoASAAIAcoAqwBNgKsASAAIAcoArABNgKwASAWRQRAIAJBzA5qIQ4gAkHcAmohFCACQZgDaiETIAJB1ANqIRIgAkGQBGohESACQcwEaiEQIAJBiAVqIRUgAkHEBWohCiACQYAGaiELIAJBvAZqIRYgAkH4BmohRCACQbQHaiFFIAJB8AdqIUYgAkGsCGohRyACQegIaiFIIAJBpAlqIUkgAkHgCWohSiACQZwKaiFLIAJB2ApqIUwgAkGUC2ohTSACQdALaiFOIAJBjAxqIU8DQCACIAIgCGosAAAiD0EfdSIHIA9zIAdBf3NqIgZBAm0iDEEBa0EfdSIBIAIoApAMIgUgAigCcHNxIAVzNgKQDCACIAIoApQMIgUgAigCdHMgAXEgBXM2ApQMIAIgAigCmAwiBSACKAJ4cyABcSAFczYCmAwgAiACKAKcDCIFIAIoAnxzIAFxIAVzNgKcDCACIAIoAqAMIgUgAigCgAFzIAFxIAVzNgKgDCACIAIoAqQMIgUgAigChAFzIAFxIAVzNgKkDCACIAIoAqgMIgUgAigCiAFzIAFxIAVzNgKoDCACIAIoAqwMIgUgAigCjAFzIAFxIAVzNgKsDCACIAIoArAMIgUgAigCkAFzIAFxIAVzNgKwDCACIAIoArQMIgUgAigClAFzIAFxIAVzNgK0DCACIAIoArgMIgUgAigCmAFzIAFxIAVzNgK4DCACIAIoArwMIgUgAigCnAFzIAFxIAVzNgK8DCACIAIoAsAMIgUgAigCoAFzIAFxIAVzNgLADCACIAIoAsQMIgUgAigCpAFzIAFxIAVzNgLEDCACIAJBqAFqIAJByAxqIgUgBkECSCIEGygCADYCyAwgAiACKALMDCIGIAIoAqwBcyABcSAGczYCzAwgAiACKALQDCIGIAIoArABcyABcSAGczYC0AwgAiACKALUDCIGIAIoArQBcyABcSAGczYC1AwgAiACKALYDCIGIAIoArgBcyABcSAGczYC2AwgAiACKALcDCIGIAIoArwBcyABcSAGczYC3AwgAiACKALgDCIGIAIoAsABcyABcSAGczYC4AwgAiACKALkDCIGIAIoAsQBcyABcSAGczYC5AwgAiACKALoDCIGIAIoAsgBcyABcSAGczYC6AwgAiACKALsDCIGIAIoAswBcyABcSAGczYC7AwgAiACKALwDCIGIAIoAtABcyABcSAGczYC8AwgAiACKAL0DCIGIAIoAtQBcyABcSAGczYC9AwgAiACKAL4DCIGIAIoAtgBcyABcSAGczYC+AwgAiACKAL8DCIGIAIoAtwBcyABcSAGczYC/AwgAiACKAKADSIGIAIoAuABcyABcSAGczYCgA0gAiACQeQBaiACQYQNaiIGIAQbKAIANgKEDSACIAIoAogNIgkgAigC6AFzIAFxIAlzNgKIDSACIAIoAowNIgkgAigC7AFzIAFxIAlzNgKMDSACIAIoApANIgkgAigC8AFzIAFxIAlzNgKQDSACIAIoApQNIgkgAigC9AFzIAFxIAlzNgKUDSACIAIoApgNIgkgAigC+AFzIAFxIAlzNgKYDSACIAIoApwNIgkgAigC/AFzIAFxIAlzNgKcDSACIAIoAqANIgkgAigCgAJzIAFxIAlzNgKgDSACIAIoAqQNIgkgAigChAJzIAFxIAlzNgKkDSACIAIoAqgNIgkgAigCiAJzIAFxIAlzNgKoDSACIAIoAqwNIgkgAigCjAJzIAFxIAlzNgKsDSACIAIoArANIgkgAigCkAJzIAFxIAlzNgKwDSACIAIoArQNIgkgAigClAJzIAFxIAlzNgK0DSACIAIoArgNIgkgAigCmAJzIAFxIAlzNgK4DSACIAIoArwNIgkgAigCnAJzIAFxIAlzNgK8DSACIAJBoAJqIAJBwA1qIgkgBBsoAgA2AsANIAIgDEEBcyIDQQFrQR91IgEgAigCkAwiBCACKAKkAnNxIARzNgKQDCACIAIoApQMIgQgAigCqAJzIAFxIARzNgKUDCACIAIoApgMIgQgAigCrAJzIAFxIARzNgKYDCACIAIoApwMIgQgAigCsAJzIAFxIARzNgKcDCACIAIoAqAMIgQgAigCtAJzIAFxIARzNgKgDCACIAIoAqQMIgQgAigCuAJzIAFxIARzNgKkDCACIAIoAqgMIgQgAigCvAJzIAFxIARzNgKoDCACIAIoAqwMIgQgAigCwAJzIAFxIARzNgKsDCACIAIoArAMIgQgAigCxAJzIAFxIARzNgKwDCACIAIoArQMIgQgAigCyAJzIAFxIARzNgK0DCACIAIoArgMIgQgAigCzAJzIAFxIARzNgK4DCACIAIoArwMIgQgAigC0AJzIAFxIARzNgK8DCACIAIoAsAMIgQgAigC1AJzIAFxIARzNgLADCACIAIoAsQMIgQgAigC2AJzIAFxIARzNgLEDCACIAUgFCADQQBKIgQbKAIANgLIDCACIAIoAswMIgMgAigC4AJzIAFxIANzNgLMDCACIAIoAtAMIgMgAigC5AJzIAFxIANzNgLQDCACIAIoAtQMIgMgAigC6AJzIAFxIANzNgLUDCACIAIoAtgMIgMgAigC7AJzIAFxIANzNgLYDCACIAIoAtwMIgMgAigC8AJzIAFxIANzNgLcDCACIAIoAuAMIgMgAigC9AJzIAFxIANzNgLgDCACIAIoAuQMIgMgAigC+AJzIAFxIANzNgLkDCACIAIoAugMIgMgAigC/AJzIAFxIANzNgLoDCACIAIoAuwMIgMgAigCgANzIAFxIANzNgLsDCACIAIoAvAMIgMgAigChANzIAFxIANzNgLwDCACIAIoAvQMIgMgAigCiANzIAFxIANzNgL0DCACIAIoAvgMIgMgAigCjANzIAFxIANzNgL4DCACIAIoAvwMIgMgAigCkANzIAFxIANzNgL8DCACIAIoAoANIgMgAigClANzIAFxIANzNgKADSACIAYgEyAEGygCADYChA0gAiACKAKIDSIDIAIoApwDcyABcSADczYCiA0gAiACKAKMDSIDIAIoAqADcyABcSADczYCjA0gAiACKAKQDSIDIAIoAqQDcyABcSADczYCkA0gAiACKAKUDSIDIAIoAqgDcyABcSADczYClA0gAiACKAKYDSIDIAIoAqwDcyABcSADczYCmA0gAiACKAKcDSIDIAIoArADcyABcSADczYCnA0gAiACKAKgDSIDIAIoArQDcyABcSADczYCoA0gAiACKAKkDSIDIAIoArgDcyABcSADczYCpA0gAiACKAKoDSIDIAIoArwDcyABcSADczYCqA0gAiACKAKsDSIDIAIoAsADcyABcSADczYCrA0gAiACKAKwDSIDIAIoAsQDcyABcSADczYCsA0gAiACKAK0DSIDIAIoAsgDcyABcSADczYCtA0gAiACKAK4DSIDIAIoAswDcyABcSADczYCuA0gAiACKAK8DSIDIAIoAtADcyABcSADczYCvA0gAiAJIBIgBBsoAgA2AsANIAIgDEECcyIDQQFrQR91IgEgAigCkAwiBCACKALYA3NxIARzNgKQDCACIAIoApQMIgQgAigC3ANzIAFxIARzNgKUDCACIAIoApgMIgQgAigC4ANzIAFxIARzNgKYDCACIAIoApwMIgQgAigC5ANzIAFxIARzNgKcDCACIAIoAqAMIgQgAigC6ANzIAFxIARzNgKgDCACIAIoAqQMIgQgAigC7ANzIAFxIARzNgKkDCACIAIoAqgMIgQgAigC8ANzIAFxIARzNgKoDCACIAIoAqwMIgQgAigC9ANzIAFxIARzNgKsDCACIAIoArAMIgQgAigC+ANzIAFxIARzNgKwDCACIAIoArQMIgQgAigC/ANzIAFxIARzNgK0DCACIAIoArgMIgQgAigCgARzIAFxIARzNgK4DCACIAIoArwMIgQgAigChARzIAFxIARzNgK8DCACIAIoAsAMIgQgAigCiARzIAFxIARzNgLADCACIAIoAsQMIgQgAigCjARzIAFxIARzNgLEDCACIAUgESADQQBKIgQbKAIANgLIDCACIAIoAswMIgMgAigClARzIAFxIANzNgLMDCACIAIoAtAMIgMgAigCmARzIAFxIANzNgLQDCACIAIoAtQMIgMgAigCnARzIAFxIANzNgLUDCACIAIoAtgMIgMgAigCoARzIAFxIANzNgLYDCACIAIoAtwMIgMgAigCpARzIAFxIANzNgLcDCACIAIoAuAMIgMgAigCqARzIAFxIANzNgLgDCACIAIoAuQMIgMgAigCrARzIAFxIANzNgLkDCACIAIoAugMIgMgAigCsARzIAFxIANzNgLoDCACIAIoAuwMIgMgAigCtARzIAFxIANzNgLsDCACIAIoAvAMIgMgAigCuARzIAFxIANzNgLwDCACIAIoAvQMIgMgAigCvARzIAFxIANzNgL0DCACIAIoAvgMIgMgAigCwARzIAFxIANzNgL4DCACIAIoAvwMIgMgAigCxARzIAFxIANzNgL8DCACIAIoAoANIgMgAigCyARzIAFxIANzNgKADSACIAYgECAEGygCADYChA0gAiACKAKIDSIDIAIoAtAEcyABcSADczYCiA0gAiACKAKMDSIDIAIoAtQEcyABcSADczYCjA0gAiACKAKQDSIDIAIoAtgEcyABcSADczYCkA0gAiACKAKUDSIDIAIoAtwEcyABcSADczYClA0gAiACKAKYDSIDIAIoAuAEcyABcSADczYCmA0gAiACKAKcDSIDIAIoAuQEcyABcSADczYCnA0gAiACKAKgDSIDIAIoAugEcyABcSADczYCoA0gAiACKAKkDSIDIAIoAuwEcyABcSADczYCpA0gAiACKAKoDSIDIAIoAvAEcyABcSADczYCqA0gAiACKAKsDSIDIAIoAvQEcyABcSADczYCrA0gAiACKAKwDSIDIAIoAvgEcyABcSADczYCsA0gAiACKAK0DSIDIAIoAvwEcyABcSADczYCtA0gAiACKAK4DSIDIAIoAoAFcyABcSADczYCuA0gAiACKAK8DSIDIAIoAoQFcyABcSADczYCvA0gAiAJIBUgBBsoAgA2AsANIAIgDEEDcyIDQQFrQR91IgEgAigCkAwiBCACKAKMBXNxIARzNgKQDCACIAIoApQMIgQgAigCkAVzIAFxIARzNgKUDCACIAIoApgMIgQgAigClAVzIAFxIARzNgKYDCACIAIoApwMIgQgAigCmAVzIAFxIARzNgKcDCACIAIoAqAMIgQgAigCnAVzIAFxIARzNgKgDCACIAIoAqQMIgQgAigCoAVzIAFxIARzNgKkDCACIAIoAqgMIgQgAigCpAVzIAFxIARzNgKoDCACIAIoAqwMIgQgAigCqAVzIAFxIARzNgKsDCACIAIoArAMIgQgAigCrAVzIAFxIARzNgKwDCACIAIoArQMIgQgAigCsAVzIAFxIARzNgK0DCACIAIoArgMIgQgAigCtAVzIAFxIARzNgK4DCACIAIoArwMIgQgAigCuAVzIAFxIARzNgK8DCACIAIoAsAMIgQgAigCvAVzIAFxIARzNgLADCACIAIoAsQMIgQgAigCwAVzIAFxIARzNgLEDCACIAUgCiADQQBKIgQbKAIANgLIDCACIAIoAswMIgMgAigCyAVzIAFxIANzNgLMDCACIAIoAtAMIgMgAigCzAVzIAFxIANzNgLQDCACIAIoAtQMIgMgAigC0AVzIAFxIANzNgLUDCACIAIoAtgMIgMgAigC1AVzIAFxIANzNgLYDCACIAIoAtwMIgMgAigC2AVzIAFxIANzNgLcDCACIAIoAuAMIgMgAigC3AVzIAFxIANzNgLgDCACIAIoAuQMIgMgAigC4AVzIAFxIANzNgLkDCACIAIoAugMIgMgAigC5AVzIAFxIANzNgLoDCACIAIoAuwMIgMgAigC6AVzIAFxIANzNgLsDCACIAIoAvAMIgMgAigC7AVzIAFxIANzNgLwDCACIAIoAvQMIgMgAigC8AVzIAFxIANzNgL0DCACIAIoAvgMIgMgAigC9AVzIAFxIANzNgL4DCACIAIoAvwMIgMgAigC+AVzIAFxIANzNgL8DCACIAIoAoANIgMgAigC/AVzIAFxIANzNgKADSACIAYgCyAEGygCADYChA0gAiACKAKIDSIDIAIoAoQGcyABcSADczYCiA0gAiACKAKMDSIDIAIoAogGcyABcSADczYCjA0gAiACKAKQDSIDIAIoAowGcyABcSADczYCkA0gAiACKAKUDSIDIAIoApAGcyABcSADczYClA0gAiACKAKYDSIDIAIoApQGcyABcSADczYCmA0gAiACKAKcDSIDIAIoApgGcyABcSADczYCnA0gAiACKAKgDSIDIAIoApwGcyABcSADczYCoA0gAiACKAKkDSIDIAIoAqAGcyABcSADczYCpA0gAiACKAKoDSIDIAIoAqQGcyABcSADczYCqA0gAiACKAKsDSIDIAIoAqgGcyABcSADczYCrA0gAiACKAKwDSIDIAIoAqwGcyABcSADczYCsA0gAiACKAK0DSIDIAIoArAGcyABcSADczYCtA0gAiACKAK4DSIDIAIoArQGcyABcSADczYCuA0gAiACKAK8DSIDIAIoArgGcyABcSADczYCvA0gAiAJIBYgBBsoAgA2AsANIAIgDEEEcyIDQQFrQR91IgEgAigCkAwiBCACKALABnNxIARzNgKQDCACIAIoApQMIgQgAigCxAZzIAFxIARzNgKUDCACIAIoApgMIgQgAigCyAZzIAFxIARzNgKYDCACIAIoApwMIgQgAigCzAZzIAFxIARzNgKcDCACIAIoAqAMIgQgAigC0AZzIAFxIARzNgKgDCACIAIoAqQMIgQgAigC1AZzIAFxIARzNgKkDCACIAIoAqgMIgQgAigC2AZzIAFxIARzNgKoDCACIAIoAqwMIgQgAigC3AZzIAFxIARzNgKsDCACIAIoArAMIgQgAigC4AZzIAFxIARzNgKwDCACIAIoArQMIgQgAigC5AZzIAFxIARzNgK0DCACIAIoArgMIgQgAigC6AZzIAFxIARzNgK4DCACIAIoArwMIgQgAigC7AZzIAFxIARzNgK8DCACIAIoAsAMIgQgAigC8AZzIAFxIARzNgLADCACIAIoAsQMIgQgAigC9AZzIAFxIARzNgLEDCACIAUgRCADQQBKIgQbKAIANgLIDCACIAIoAswMIgMgAigC/AZzIAFxIANzNgLMDCACIAIoAtAMIgMgAigCgAdzIAFxIANzNgLQDCACIAIoAtQMIgMgAigChAdzIAFxIANzNgLUDCACIAIoAtgMIgMgAigCiAdzIAFxIANzNgLYDCACIAIoAtwMIgMgAigCjAdzIAFxIANzNgLcDCACIAIoAuAMIgMgAigCkAdzIAFxIANzNgLgDCACIAIoAuQMIgMgAigClAdzIAFxIANzNgLkDCACIAIoAugMIgMgAigCmAdzIAFxIANzNgLoDCACIAIoAuwMIgMgAigCnAdzIAFxIANzNgLsDCACIAIoAvAMIgMgAigCoAdzIAFxIANzNgLwDCACIAIoAvQMIgMgAigCpAdzIAFxIANzNgL0DCACIAIoAvgMIgMgAigCqAdzIAFxIANzNgL4DCACIAIoAvwMIgMgAigCrAdzIAFxIANzNgL8DCACIAIoAoANIgMgAigCsAdzIAFxIANzNgKADSACIAYgRSAEGygCADYChA0gAiACKAKIDSIDIAIoArgHcyABcSADczYCiA0gAiACKAKMDSIDIAIoArwHcyABcSADczYCjA0gAiACKAKQDSIDIAIoAsAHcyABcSADczYCkA0gAiACKAKUDSIDIAIoAsQHcyABcSADczYClA0gAiACKAKYDSIDIAIoAsgHcyABcSADczYCmA0gAiACKAKcDSIDIAIoAswHcyABcSADczYCnA0gAiACKAKgDSIDIAIoAtAHcyABcSADczYCoA0gAiACKAKkDSIDIAIoAtQHcyABcSADczYCpA0gAiACKAKoDSIDIAIoAtgHcyABcSADczYCqA0gAiACKAKsDSIDIAIoAtwHcyABcSADczYCrA0gAiACKAKwDSIDIAIoAuAHcyABcSADczYCsA0gAiACKAK0DSIDIAIoAuQHcyABcSADczYCtA0gAiACKAK4DSIDIAIoAugHcyABcSADczYCuA0gAiACKAK8DSIDIAIoAuwHcyABcSADczYCvA0gAiAJIEYgBBsoAgA2AsANIAIgDEEFcyIDQQFrQR91IgEgAigCkAwiBCACKAL0B3NxIARzNgKQDCACIAIoApQMIgQgAigC+AdzIAFxIARzNgKUDCACIAIoApgMIgQgAigC/AdzIAFxIARzNgKYDCACIAIoApwMIgQgAigCgAhzIAFxIARzNgKcDCACIAIoAqAMIgQgAigChAhzIAFxIARzNgKgDCACIAIoAqQMIgQgAigCiAhzIAFxIARzNgKkDCACIAIoAqgMIgQgAigCjAhzIAFxIARzNgKoDCACIAIoAqwMIgQgAigCkAhzIAFxIARzNgKsDCACIAIoArAMIgQgAigClAhzIAFxIARzNgKwDCACIAIoArQMIgQgAigCmAhzIAFxIARzNgK0DCACIAIoArgMIgQgAigCnAhzIAFxIARzNgK4DCACIAIoArwMIgQgAigCoAhzIAFxIARzNgK8DCACIAIoAsAMIgQgAigCpAhzIAFxIARzNgLADCACIAIoAsQMIgQgAigCqAhzIAFxIARzNgLEDCACIAUgRyADQQBKIgQbKAIANgLIDCACIAIoAswMIgMgAigCsAhzIAFxIANzNgLMDCACIAIoAtAMIgMgAigCtAhzIAFxIANzNgLQDCACIAIoAtQMIgMgAigCuAhzIAFxIANzNgLUDCACIAIoAtgMIgMgAigCvAhzIAFxIANzNgLYDCACIAIoAtwMIgMgAigCwAhzIAFxIANzNgLcDCACIAIoAuAMIgMgAigCxAhzIAFxIANzNgLgDCACIAIoAuQMIgMgAigCyAhzIAFxIANzNgLkDCACIAIoAugMIgMgAigCzAhzIAFxIANzNgLoDCACIAIoAuwMIgMgAigC0AhzIAFxIANzNgLsDCACIAIoAvAMIgMgAigC1AhzIAFxIANzNgLwDCACIAIoAvQMIgMgAigC2AhzIAFxIANzNgL0DCACIAIoAvgMIgMgAigC3AhzIAFxIANzNgL4DCACIAIoAvwMIgMgAigC4AhzIAFxIANzNgL8DCACIAIoAoANIgMgAigC5AhzIAFxIANzNgKADSACIAYgSCAEGygCADYChA0gAiACKAKIDSIDIAIoAuwIcyABcSADczYCiA0gAiACKAKMDSIDIAIoAvAIcyABcSADczYCjA0gAiACKAKQDSIDIAIoAvQIcyABcSADczYCkA0gAiACKAKUDSIDIAIoAvgIcyABcSADczYClA0gAiACKAKYDSIDIAIoAvwIcyABcSADczYCmA0gAiACKAKcDSIDIAIoAoAJcyABcSADczYCnA0gAiACKAKgDSIDIAIoAoQJcyABcSADczYCoA0gAiACKAKkDSIDIAIoAogJcyABcSADczYCpA0gAiACKAKoDSIDIAIoAowJcyABcSADczYCqA0gAiACKAKsDSIDIAIoApAJcyABcSADczYCrA0gAiACKAKwDSIDIAIoApQJcyABcSADczYCsA0gAiACKAK0DSIDIAIoApgJcyABcSADczYCtA0gAiACKAK4DSIDIAIoApwJcyABcSADczYCuA0gAiACKAK8DSIDIAIoAqAJcyABcSADczYCvA0gAiAJIEkgBBsoAgA2AsANIAIgDEEGcyIDQQFrQR91IgEgAigCkAwiBCACKAKoCXNxIARzNgKQDCACIAIoApQMIgQgAigCrAlzIAFxIARzNgKUDCACIAIoApgMIgQgAigCsAlzIAFxIARzNgKYDCACIAIoApwMIgQgAigCtAlzIAFxIARzNgKcDCACIAIoAqAMIgQgAigCuAlzIAFxIARzNgKgDCACIAIoAqQMIgQgAigCvAlzIAFxIARzNgKkDCACIAIoAqgMIgQgAigCwAlzIAFxIARzNgKoDCACIAIoAqwMIgQgAigCxAlzIAFxIARzNgKsDCACIAIoArAMIgQgAigCyAlzIAFxIARzNgKwDCACIAIoArQMIgQgAigCzAlzIAFxIARzNgK0DCACIAIoArgMIgQgAigC0AlzIAFxIARzNgK4DCACIAIoArwMIgQgAigC1AlzIAFxIARzNgK8DCACIAIoAsAMIgQgAigC2AlzIAFxIARzNgLADCACIAIoAsQMIgQgAigC3AlzIAFxIARzNgLEDCACIAUgSiADQQBKIgQbKAIANgLIDCACIAIoAswMIgMgAigC5AlzIAFxIANzNgLMDCACIAIoAtAMIgMgAigC6AlzIAFxIANzNgLQDCACIAIoAtQMIgMgAigC7AlzIAFxIANzNgLUDCACIAIoAtgMIgMgAigC8AlzIAFxIANzNgLYDCACIAIoAtwMIgMgAigC9AlzIAFxIANzNgLcDCACIAIoAuAMIgMgAigC+AlzIAFxIANzNgLgDCACIAIoAuQMIgMgAigC/AlzIAFxIANzNgLkDCACIAIoAugMIgMgAigCgApzIAFxIANzNgLoDCACIAIoAuwMIgMgAigChApzIAFxIANzNgLsDCACIAIoAvAMIgMgAigCiApzIAFxIANzNgLwDCACIAIoAvQMIgMgAigCjApzIAFxIANzNgL0DCACIAIoAvgMIgMgAigCkApzIAFxIANzNgL4DCACIAIoAvwMIgMgAigClApzIAFxIANzNgL8DCACIAIoAoANIgMgAigCmApzIAFxIANzNgKADSACIAYgSyAEGygCADYChA0gAiACKAKIDSIDIAIoAqAKcyABcSADczYCiA0gAiACKAKMDSIDIAIoAqQKcyABcSADczYCjA0gAiACKAKQDSIDIAIoAqgKcyABcSADczYCkA0gAiACKAKUDSIDIAIoAqwKcyABcSADczYClA0gAiACKAKYDSIDIAIoArAKcyABcSADczYCmA0gAiACKAKcDSIDIAIoArQKcyABcSADczYCnA0gAiACKAKgDSIDIAIoArgKcyABcSADczYCoA0gAiACKAKkDSIDIAIoArwKcyABcSADczYCpA0gAiACKAKoDSIDIAIoAsAKcyABcSADczYCqA0gAiACKAKsDSIDIAIoAsQKcyABcSADczYCrA0gAiACKAKwDSIDIAIoAsgKcyABcSADczYCsA0gAiACKAK0DSIDIAIoAswKcyABcSADczYCtA0gAiACKAK4DSIDIAIoAtAKcyABcSADczYCuA0gAiACKAK8DSIDIAIoAtQKcyABcSADczYCvA0gAiAJIEwgBBsoAgA2AsANIAIgDEEHcyIMQQFrQR91IgEgAigCkAwiBCACKALcCnNxIARzNgKQDCACIAIoApQMIgQgAigC4ApzIAFxIARzNgKUDCACIAIoApgMIgQgAigC5ApzIAFxIARzNgKYDCACIAIoApwMIgQgAigC6ApzIAFxIARzNgKcDCACIAIoAqAMIgQgAigC7ApzIAFxIARzNgKgDCACIAIoAqQMIgQgAigC8ApzIAFxIARzNgKkDCACIAIoAqgMIgQgAigC9ApzIAFxIARzNgKoDCACIAIoAqwMIgQgAigC+ApzIAFxIARzNgKsDCACIAIoArAMIgQgAigC/ApzIAFxIARzNgKwDCACIAIoArQMIgQgAigCgAtzIAFxIARzNgK0DCACIAIoArgMIgQgAigChAtzIAFxIARzNgK4DCACIAIoArwMIgQgAigCiAtzIAFxIARzNgK8DCACIAIoAsAMIgQgAigCjAtzIAFxIARzNgLADCACIAIoAsQMIgQgAigCkAtzIAFxIARzNgLEDCACIAUgTSAMQQBKIgwbKAIANgLIDCACIAIoAswMIgQgAigCmAtzIAFxIARzNgLMDCACIAIoAtAMIgQgAigCnAtzIAFxIARzNgLQDCACIAIoAtQMIgQgAigCoAtzIAFxIARzNgLUDCACIAIoAtgMIgQgAigCpAtzIAFxIARzNgLYDCACIAIoAtwMIgQgAigCqAtzIAFxIARzNgLcDCACIAIoAuAMIgQgAigCrAtzIAFxIARzNgLgDCACIAIoAuQMIgQgAigCsAtzIAFxIARzNgLkDCACIAIoAugMIgQgAigCtAtzIAFxIARzNgLoDCACIAIoAuwMIgQgAigCuAtzIAFxIARzNgLsDCACIAIoAvAMIgQgAigCvAtzIAFxIARzNgLwDCACIAIoAvQMIgQgAigCwAtzIAFxIARzNgL0DCACIAIoAvgMIgQgAigCxAtzIAFxIARzNgL4DCACIAIoAvwMIgQgAigCyAtzIAFxIARzNgL8DCACIAIoAoANIgQgAigCzAtzIAFxIARzNgKADSACIAYgTiAMGygCADYChA0gAiACKAKIDSIEIAIoAtQLcyABcSAEczYCiA0gAiACKAKMDSIEIAIoAtgLcyABcSAEczYCjA0gAiACKAKQDSIEIAIoAtwLcyABcSAEczYCkA0gAiACKAKUDSIEIAIoAuALcyABcSAEczYClA0gAiACKAKYDSIEIAIoAuQLcyABcSAEczYCmA0gAiACKAKcDSIEIAIoAugLcyABcSAEczYCnA0gAiACKAKgDSIEIAIoAuwLcyABcSAEczYCoA0gAiACKAKkDSIEIAIoAvALcyABcSAEczYCpA0gAiACKAKoDSIEIAIoAvQLcyABcSAEczYCqA0gAiACKAKsDSIEIAIoAvgLcyABcSAEczYCrA0gAiACKAKwDSIEIAIoAvwLcyABcSAEczYCsA0gAiACKAK0DSIEIAIoAoAMcyABcSAEcyIENgK0DSACIAIoArgNIgMgAigChAxzIAFxIANzIgM2ArgNIAIgAigCvA0iDSACKAKIDHMgAXEgDXMiATYCvA0gAiAJIE8gDBsoAgAiDDYCwA0gAiACKAKQDDYCkA4gAiACKAKUDDYClA4gAiACKAKYDDYCmA4gAiACKAKcDDYCnA4gAiACKAKgDDYCoA4gAiACKAKkDDYCpA4gAiACKAKoDDYCqA4gAiACKAKsDDYCrA4gAiACKAKwDDYCsA4gAiACKAK0DDYCtA4gAiACKAK4DDYCuA4gAiACKAK8DDYCvA4gAiACKALADDYCwA4gAiACKALEDDYCxA4gAiACKALIDDYCyA4gAiACKALMDDYCzA4gAiACKALQDDYC0A4gAiACKALUDDYC1A4gAiACKALYDDYC2A4gAiACKALcDDYC3A4gAiACKALgDDYC4A4gAiACKALkDDYC5A4gAiACKALoDDYC6A4gAiACKALsDDYC7A4gAiACKALwDDYC8A4gAiACKAL0DDYC9A4gAiACKAL4DDYC+A4gAiACKAL8DDYC/A4gAiACKAKADTYCgA8gAiACKAKEDTYChA8gAiACKAKIDTYCiA8gAiACKAKMDTYCjA8gAiACKAKQDTYCkA8gAiACKAKUDTYClA8gAiACKAKYDTYCmA8gAiACKAKcDTYCnA8gAiACKAKgDTYCoA8gAiACKAKkDTYCpA8gAiACKAKoDTYCqA8gAiACKAKsDTYCrA8gAigCsA0hDSACIAw2AsAPIAIgATYCvA8gAiADNgK4DyACIAQ2ArQPIAIgDTYCsA8gDiAOEMwCIAIgAigCzA4iAUH/////AXE2AswOIAIgAigC0A4gAUEddWoiAUH/////AXE2AtAOIAIgAigC1A4gAUEddWoiAUH/////AXE2AtQOIAIgAigC2A4gAUEddWoiAUH/////AXE2AtgOIAIgAigC3A4gAUEddWoiAUH/////AXE2AtwOIAIgAigC4A4gAUEddWoiAUH/////AXE2AuAOIAIgAigC5A4gAUEddWoiAUH/////AXE2AuQOIAIgAigC6A4gAUEddWoiAUH/////AXE2AugOIAIgAigC7A4gAUEddWoiAUH/////AXE2AuwOIAIgAigC8A4gAUEddWoiAUH/////AXE2AvAOIAIgAigC9A4gAUEddWoiAUH/////AXE2AvQOIAIgAigC+A4gAUEddWoiAUH/////AXE2AvgOIAIgAigC/A4gAUEddWoiAUH/////AXE2AvwOIAIgAigCgA8gAUEddWo2AoAPIAIgAigCkAwiASACKAKQDnMgB3EgAXM2ApAMIAIgAigClAwiASACKAKUDnMgB3EgAXM2ApQMIAIgAigCmAwiASACKAKYDnMgB3EgAXM2ApgMIAIgAigCnAwiASACKAKcDnMgB3EgAXM2ApwMIAIgAigCoAwiASACKAKgDnMgB3EgAXM2AqAMIAIgAigCpAwiASACKAKkDnMgB3EgAXM2AqQMIAIgAigCqAwiASACKAKoDnMgB3EgAXM2AqgMIAIgAigCrAwiASACKAKsDnMgB3EgAXM2AqwMIAIgAigCsAwiASACKAKwDnMgB3EgAXM2ArAMIAIgAigCtAwiASACKAK0DnMgB3EgAXM2ArQMIAIgAigCuAwiASACKAK4DnMgB3EgAXM2ArgMIAIgAigCvAwiASACKAK8DnMgB3EgAXM2ArwMIAIgAigCwAwiASACKALADnMgB3EgAXM2AsAMIAIgAigCxAwiASACKALEDnMgB3EgAXM2AsQMIAIgAkHIDmogBSAPQQBIIgEbKAIANgLIDCACIAIoAswMIgUgAigCzA5zIAdxIAVzNgLMDCACIAIoAtAMIgUgAigC0A5zIAdxIAVzNgLQDCACIAIoAtQMIgUgAigC1A5zIAdxIAVzNgLUDCACIAIoAtgMIgUgAigC2A5zIAdxIAVzNgLYDCACIAIoAtwMIgUgAigC3A5zIAdxIAVzNgLcDCACIAIoAuAMIgUgAigC4A5zIAdxIAVzNgLgDCACIAIoAuQMIgUgAigC5A5zIAdxIAVzNgLkDCACIAIoAugMIgUgAigC6A5zIAdxIAVzNgLoDCACIAIoAuwMIgUgAigC7A5zIAdxIAVzNgLsDCACIAIoAvAMIgUgAigC8A5zIAdxIAVzNgLwDCACIAIoAvQMIgUgAigC9A5zIAdxIAVzNgL0DCACIAIoAvgMIgUgAigC+A5zIAdxIAVzNgL4DCACIAIoAvwMIgUgAigC/A5zIAdxIAVzNgL8DCACIAIoAoANIgUgAigCgA9zIAdxIAVzNgKADSACIAJBhA9qIAYgARsoAgA2AoQNIAIgAigCiA0iBSACKAKID3MgB3EgBXM2AogNIAIgAigCjA0iBSACKAKMD3MgB3EgBXM2AowNIAIgAigCkA0iBSACKAKQD3MgB3EgBXM2ApANIAIgAigClA0iBSACKAKUD3MgB3EgBXM2ApQNIAIgAigCmA0iBSACKAKYD3MgB3EgBXM2ApgNIAIgAigCnA0iBSACKAKcD3MgB3EgBXM2ApwNIAIgAigCoA0iBSACKAKgD3MgB3EgBXM2AqANIAIgAigCpA0iBSACKAKkD3MgB3EgBXM2AqQNIAIgAigCqA0iBSACKAKoD3MgB3EgBXM2AqgNIAIgAigCrA0iBSACKAKsD3MgB3EgBXM2AqwNIAIgAigCsA0iBSACKAKwD3MgB3EgBXM2ArANIAIgAigCtA0iBSACKAK0D3MgB3EgBXM2ArQNIAIgAigCuA0iBSACKAK4D3MgB3EgBXM2ArgNIAIgAigCvA0iBSACKAK8D3MgB3EgBXM2ArwNIAIgAkHAD2ogCSABGygCADYCwA0gABDCAiAAEMICIAAQwgIgABDCAiAAIAJBkAxqEMYCIAhBAEohByAIQQFrIQggBw0ACwsgAiAhNgLADyACICA2ArwPIAIgHzYCuA8gAiAeNgK0DyACIB02ArAPIAIgHDYCrA8gAiAbNgKoDyACIBo2AqQPIAIgGTYCoA8gAiAYNgKcDyACIBc2ApgPIAIgIjYClA8gAiAjNgKQDyACICQ2AowPIAIgJTYCiA8gAiAmNgKEDyACICc2AoAPIAIgKDYC/A4gAiApNgL4DiACICo2AvQOIAIgKzYC8A4gAiAsNgLsDiACIC02AugOIAIgLjYC5A4gAiAvNgLgDiACIDA2AtwOIAIgMTYC2A4gAiAyNgLUDiACIDM2AtAOIAIgNDYCzA4gAiA1NgLIDiACIDY2AsQOIAIgNzYCwA4gAiA4NgK8DiACIDk2ArgOIAIgOjYCtA4gAiA7NgKwDiACIDw2AqwOIAIgPTYCqA4gAiA+NgKkDiACID82AqAOIAIgQDYCnA4gAiBBNgKYDiACIEI2ApQOIAIgQzYCkA4gAkHMDmoiByAHEMwCIAIgAigCzA4iB0H/////AXE2AswOIAIgAigC0A4gB0EddWoiB0H/////AXE2AtAOIAIgAigC1A4gB0EddWoiB0H/////AXE2AtQOIAIgAigC2A4gB0EddWoiB0H/////AXE2AtgOIAIgAigC3A4gB0EddWoiB0H/////AXE2AtwOIAIgAigC4A4gB0EddWoiB0H/////AXE2AuAOIAIgAigC5A4gB0EddWoiB0H/////AXE2AuQOIAIgAigC6A4gB0EddWoiB0H/////AXE2AugOIAIgAigC7A4gB0EddWoiB0H/////AXE2AuwOIAIgAigC8A4gB0EddWoiB0H/////AXE2AvAOIAIgAigC9A4gB0EddWoiB0H/////AXE2AvQOIAIgAigC+A4gB0EddWoiB0H/////AXE2AvgOIAIgAigC/A4gB0EddWoiB0H/////AXE2AvwOIAIgAigCgA8gB0EddWo2AoAPIAAgAkGQDmoQxgIgABC+AgsgAkHQD2okAAuxAwEEfyMAQRBrIgQkAAJAIABFDQBBpIg0KAIAIQECQAJAAkACQAJAAkAgACgCECICRQ0AIAFFDQEgBCACNgIEAkAgASgCACIDIAQoAgRLDQAgBCgCBCADIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiA0EESQ0BIANBfHEiA0UNASACQQAgA/wLAAwBCyACECsLIAAoAgwiAkUNAiABRQ0BIAQgAjYCCAJAIAEoAgAiAyAEKAIISw0AIAQoAgggAyABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgNBBEkNBCADQXxxIgNFDQQgAkEAIAP8CwAMBAsgAhArDAMLIAIQKyAAKAIMIgJFDQMLIAIQKwwCCyABRQ0BCyAEIAA2AgwgASgCACICIAQoAgxLDQAgBCgCDCACIAEoAhBqTw0AIAAgASgCBDYCACABIAA2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAAQQAgAfwLAAwBCyAAECsLIARBEGokAAv2CQEHfyMAQeACayIBJAAgAUHCoyo2AiAgAEH5hiogAUEgahCbAQJAAkAgAEEBELECIgJBAEcgAEECELECIgRBAEdxIgcEQCACQQhqIgUQvgIgBEEIaiIGEL4CIARBgAFqIQMgBDQCuAEgAjQCQH5CgICAEFkEQCAFENICCyABQbABaiAFIAMQ0wIgAUKjvcSA0AE3A2AgAULt05uWwabz/xI3A1ggAULL7pG74ayXjRI3A1AgAULDufbXoJSczxA3A0ggAULqg4n7gOueqAk3A0AgAULu//+noaz//xc3AzggAUKr1f7/8f//+w83AzAgAUH0AGogAUEwaiABQbABahDJAiABQQI2AqwBIAJBgAFqIQUgAjQCuAEgBDQCQH5CgICAEFkEQCAGENICCyABQbABaiAGIAUQ0wIgAUKjvcSA0AE3A9ACIAFC7dOblsGm8/8SNwPIAiABQsvukbvhrJeNEjcDwAIgAULDufbXoJSczxA3A7gCIAFC6oOJ+4DrnqgJNwOwAiABQu7//6ehrP//FzcDqAIgAUKr1f7/8f//+w83A6ACIAFBMGogAUGgAmogAUGwAWoQyQIgAUECNgJoIAFB9ABqIAFBMGoQ1AIEfyACQcQAaiEGIAQ0ArgBIAI0Anx+QoCAgBBZBEAgBhDSAgsgAUGwAWogBiADENMCIAFCo73EgNABNwPQAiABQu3Tm5bBpvP/EjcDyAIgAULL7pG74ayXjRI3A8ACIAFCw7n216CUnM8QNwO4AiABQuqDifuA656oCTcDsAIgAULu//+noaz//xc3A6gCIAFCq9X+//H///sPNwOgAiABQfQAaiABQaACaiABQbABahDJAiABQQI2AqwBIARBxABqIQMgAjQCuAEgBDQCfH5CgICAEFkEQCADENICCyABQbABaiADIAUQ0wIgAUKjvcSA0AE3A9ACIAFC7dOblsGm8/8SNwPIAiABQsvukbvhrJeNEjcDwAIgAULDufbXoJSczxA3A7gCIAFC6oOJ+4DrnqgJNwOwAiABQu7//6ehrP//FzcDqAIgAUKr1f7/8f//+w83A6ACIAFBMGogAUGgAmogAUGwAWoQyQIgAUECNgJoQRFBASABQfQAaiABQTBqENQCGwVBAQshAyAAKAIMIAM6AAQgACAAKAIMQQhqNgIMQQAhBQwBC0GM1SkhBSACRQ0BCyACIAIoArwBIgNBAWs2ArwBIANBAUoNAAJAQaSINCgCACIDRQ0AIAEgAjYCsAEgAygCACIGIAEoArABSw0AIAEoArABIAYgAygCEGpPDQAgAiADKAIENgIAIAMgAjYCBCADIAMoAghBAWo2AgggAygCFCIDQQRJDQEgA0F8cSIDRQ0BIAJBACAD/AsADAELIAIQKwsCQCAERQ0AIAQgBCgCvAEiAkEBazYCvAEgAkEBSg0AAkBBpIg0KAIAIgJFDQAgASAENgKwASACKAIAIgMgASgCsAFLDQAgASgCsAEgAyACKAIQak8NACAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgBEEAIAL8CwAMAQsgBBArCyAHRQRAIAEgBTYCFCABQcKjKjYCECAAQfyIKiABQRBqEGwACyABQcKjKjYCACAAQeCHKiABEJsBIAFB4AJqJABBAQuTEwIrfwJ+IAAgACgCACIBQf////8BcSIINgIAIAAgACgCBCABQR11aiIBQf////8BcSIGNgIEIAAgACgCCCABQR11aiIBQf////8BcSIJNgIIIAAgACgCDCABQR11aiIBQf////8BcSIKNgIMIAAgACgCECABQR11aiIBQf////8BcSILNgIQIAAgACgCFCABQR11aiIBQf////8BcSIMNgIUIAAgACgCGCABQR11aiIBQf////8BcSIFNgIYIAAgACgCHCABQR11aiIBQf////8BcSIQNgIcIAAgACgCICABQR11aiIBQf////8BcSINNgIgIAAgACgCJCABQR11aiIBQf////8BcSIONgIkIAAgACgCKCABQR11aiIBQf////8BcSIRNgIoIAAgACgCLCABQR11aiICQf////8BcSISNgIsIABBMGoiASABKAIAIAJBHXVqIgdB/////wFxIgM2AgBBNCEEIABBNGoiAiACKAIAIAdBHXVqIgc2AgACQAJ/IAAoAjgiD0ERTgRAIAAgCCAHQQx0IANBEXZyQYmgA20iA0Gr1f7/AWxB/////wFxayIINgIAIAAgBiADrCItQv//3/8AfiAtQtiq9f8PfkIgh3wiLKdB/////wFxayIGNgIEIAAgCSAtQu7//6cBfiAsQh2HfCIsp0H/////AXFrIgk2AgggACAKIC1C4vr/vwF+ICxCHYd8IiynQf////8BcWsiCjYCDCAAIAsgLULqg4n7AH4gLEIdh3wiLKdB/////wFxayILNgIQIAAgDCAtQtj2wcoAfiAsQh2HfCIsp0H/////AXFrIgw2AhQgACAAKAIYIC1Cw7n21wB+ICxCHYd8IiynQf////8BcWsiAzYCGCAAIAAoAhwgLUKi4fmEAX4gLEIdh3wiLKdB/////wFxayIHNgIcIAAgACgCICAtQsvukbsBfiAsQh2HfCIsp0H/////AXFrIg02AiAgACAAKAIkIC1C5rrpkAF+ICxCHYd8IiynQf////8BcWsiDjYCJCAJIAYgCEEddWoiBkEddWoiBUH/////AXEhCSAKIAVBHXVqIgVB/////wFxIQogCyAFQR11aiIFQf////8BcSELIAwgBUEddWoiBUH/////AXEhDCADIAVBHXVqIgNB/////wFxIQUgByADQR11aiIDQf////8BcSEQIA0gA0EddWoiA0H/////AXEhDSAOIANBHXVqIgNB/////wFxIQ4gACgCKCAtQu3Tm5YBfiAsQh2HfCIsp0H/////AXFrIANBHXVqIgNB/////wFxIREgACgCLCAtQrSa/5cBfiAsQh2HfCIsp0H/////AXFrIANBHXVqIgNB/////wFxIRIgASgCACAtQqO9xAB+ICxCHYd8IiynQf////8BcWsgA0EddWoiAUH/////AXEhAyACKAIAIC1CDX4gLEIdiHynayABQR11aiEHIAZB/////wFxIQYgCEH/////AXEhCEECIQJB/////gEhAUG5//+fASEPQYrr//8BIRRBqo+k7AEhFUHh2ocqIRZBjebZ3wAhF0GJhecTIRhBrrrH7AEhGUGa66XDACEaQbbP7tgAIRtB0un83wAhHEGO9ZECIR1BrNX6/wEMAQsgD0EBayIBQQF2IAFyIgFBAnYgAXIiAUEEdiABciIBQQh2IAFyIgFBEHYgAXIiAUUNAUH//9//ACABaSICdEH/////AXFBq9X+/wFBHSACayIEdnIhAUHu//+nASACdEH+////AXFB///f/wAgBHZyIQ9B4vr/vwEgAnRB/v///wFxQe7//6cBIAR2ciEUQeqDifsAIAJ0Qf7///8BcUHi+v+/ASAEdnIhFUHY9sHKACACdEH4////AXFB6oOJ+wAgBHZyIRZBw7n21wAgAnRB/////wFxQdj2wcoAIAR2ciEXQaLh+YQBIAJ0Qf7///8BcUHDufbXACAEdnIhGEHL7pG7ASACdEH/////AXFBouH5hAEgBHZyIRlB5rrpkAEgAnRB/v///wFxQcvukbsBIAR2ciEaQe3Tm5YBIAJ0Qf////8BcUHmuumQASAEdnIhG0G0mv+XASACdEH8////AXFB7dOblgEgBHZyIRxBo73EACACdEH/////AXFBtJr/lwEgBHZyIR1BDSACdEGjvcQAIAR2ciEEQavV/v8BIAJ0Qf////8BcQshKQNAIA9BHHQhHiAUQRx0IRMgFUEcdCEfIBZBHHQhICAXQRx0ISEgGEEcdCEiIBlBHHQhIyAaQRx0ISQgG0EcdCElIBxBHHQhJiAdQRx0IScgBEEcdCEoIAcgBEEBdSIEayADIChBgICAgAFxIB1BAXZyIh1rIBIgJ0GAgICAAXEgHEEBdnIiHGsgESAmQYCAgIABcSAbQQF2ciIbayAOICVBgICAgAFxIBpBAXZyIhprIA0gJEGAgICAAXEgGUEBdnIiGWsgECAjQYCAgIABcSAYQQF2ciIYayAFICJBgICAgAFxIBdBAXZyIhdrIAwgIUGAgICAAXEgFkEBdnIiFmsgCyAgQYCAgIABcSAVQQF2ciIVayAKIB9BgICAgAFxIBRBAXZyIhRrIAkgE0GAgICAAXEgD0EBdnIiD2sgBiAeQYCAgIABcSABQQF2ciIeayAIIAFBHHRBgICAgAFxIClBAXZyIilrIhNBHXVqIh9BHXVqIiBBHXVqIiFBHXVqIiJBHXVqIiNBHXVqIiRBHXVqIiVBHXVqIiZBHXVqIidBHXVqIihBHXVqIipBHXVqIitBHXVqIgEgByABQQBOIgEbIQcgK0H/////AXEgAyABGyEDICpB/////wFxIBIgARshEiAoQf////8BcSARIAEbIREgJ0H/////AXEgDiABGyEOICZB/////wFxIA0gARshDSAlQf////8BcSAQIAEbIRAgJEH/////AXEgBSABGyEFICNB/////wFxIAwgARshDCAiQf////8BcSALIAEbIQsgIUH/////AXEgCiABGyEKICBB/////wFxIAkgARshCSAfQf////8BcSAGIAEbIQYgE0H/////AXEgCCABGyEIIAJBAUshEyAeIQEgAkEBayECIBMNAAsgACASNgIsIAAgETYCKCAAIA42AiQgACANNgIgIAAgEDYCHCAAIAU2AhggACAMNgIUIAAgCzYCECAAIAo2AgwgACAJNgIIIAAgBjYCBCAAIAg2AgAgACAHNgI0IAAgAzYCMAsgAEEBNgI4C6MGAgN+Bn8jAEHwAGsiBiACNAIAIAE0AgB+IgQ3AwAgBiACNAIEIAE0AgR+NwMIIAYgAjQCCCABNAIIfjcDECAGIAI0AgwgATQCDH43AxggBiACNAIQIAE0AhB+NwMgIAYgAjQCFCABNAIUfjcDKCAGIAI0AhggATQCGH43AzAgBiACNAIcIAE0Ahx+NwM4IAYgAjQCICABNAIgfjcDQCAGIAI0AiQgATQCJH43A0ggBiACNAIoIAE0Aih+NwNQIAYgAjQCLCABNAIsfjcDWCAGIAI0AjAgATQCMH4iBTcDYCAGIAI0AjQgATQCNH43A2ggACAEp0H/////AXE2AgAgBEIdhyEDQQEhCgNAIApBAXYhCyAGIApBA3RqKQMAIAR8IgQgA3whAyAKIQcDQCACIAogB2tBAnQiCWooAgAgAiAHQQJ0IghqKAIAa6wgASAIaigCACABIAlqKAIAa6x+IAN8IQMgB0EBayIHIAtKDQALIAAgCkECdGogA6dB/////wFxNgIAIANCHYchA0EOIQcgCkEBaiIKQQ5HDQALA0ACfiAEIAdBA3QgBmpB8ABrKQMAfSIEIAN8IAIgB0ECdCIJQTRrIghqKAIAIAIoAjRrrCABKAI0IAEgCGooAgBrrH58IgMgB0EXSw0AGiACIAlBMGsiCGooAgAgAigCMGusIAEoAjAgASAIaigCAGusfiADfCIDIAdBFUsNABogAiAJQSxrIghqKAIAIAIoAixrrCABKAIsIAEgCGooAgBrrH4gA3wiAyAHQRNLDQAaIAIgCUEoayIIaigCACACKAIoa6wgASgCKCABIAhqKAIAa6x+IAN8IgMgB0ERSw0AGiACIAlBJGsiCGooAgAgAigCJGusIAEoAiQgASAIaigCAGusfiADfCIDIAdBD0sNABogAiAJQSBrIghqKAIAIAIoAiBrrCABKAIgIAEgCGooAgBrrH4gA3wLIQMgACAJaiADp0H/////AXE2AgAgA0IdhyEDIAdBAWoiB0EaRw0ACyAAIAQgBX0gA3wiA0IdiD4CbCAAIAOnQf////8BcTYCaAuYBAEBfyMAQYABayICJAAgAiAAKAIANgJEIAIgACgCBDYCSCACIAAoAgg2AkwgAiAAKAIMNgJQIAIgACgCEDYCVCACIAAoAhQ2AlggAiAAKAIYNgJcIAIgACgCHDYCYCACIAAoAiA2AmQgAiAAKAIkNgJoIAIgACgCKDYCbCACIAAoAiw2AnAgAiAAKAIwNgJ0IAIgACgCNDYCeCACIAAoAjg2AnwgAiABKAIANgIIIAIgASgCBDYCDCACIAEoAgg2AhAgAiABKAIMNgIUIAIgASgCEDYCGCACIAEoAhQ2AhwgAiABKAIYNgIgIAIgASgCHDYCJCACIAEoAiA2AiggAiABKAIkNgIsIAIgASgCKDYCMCACIAEoAiw2AjQgAiABKAIwNgI4IAIgASgCNDYCPCACIAEoAjg2AkAgAkHEAGoQ0gIgAkEIahDSAgJ/AkAgAigCeCACKAI8Rw0AIAIoAnQgAigCOEcNACACKAJwIAIoAjRHDQAgAigCbCACKAIwRw0AIAIoAmggAigCLEcNACACKAJkIAIoAihHDQAgAigCYCACKAIkRw0AIAIoAlwgAigCIEcNACACKAJYIAIoAhxHDQAgAigCVCACKAIYRw0AIAIoAlAgAigCFEcNACACKAJMIAIoAhBHDQAgAigCSCACKAIMRw0AQQEgAigCRCACKAIIRg0BGgtBAAshACACQYABaiQAIAALqwQBBn8jAEGwAWsiAyQAIANBxsopNgIgIABB+YYqIANBIGoQmwECQAJAIABBARCxAiIERQRAQbreKyEFDAELAn8CQAJ/AkAgBEEIaiIBELgCRQ0AIARBgAFqELgCRQ0AIABBAxCGASICRQ0CIAIoAghB/wA6AAAgAigCCEH/ADoAASACKAIIQQA6AAMgAkECNgIAQQAMAQsgACAEKAIEQQ9qEIYBIgJFDQECQAJAIAEQuAJFDQAgBEGAAWoQuAJFDQAgAigCCEH/ADoAACACKAIIQf8AOgABIAIoAghBADoAAyACQQI2AgAMAQsgA0HwAGogA0EwaiABELkCIAIoAghBAjoAACADKAIwQYGAgIB4cUEBRgRAIAIoAghBAzoAAAsgAkExNgIAIAIoAghBAWogA0HwAGoQugILIAAgAhDZAUEACyEFQQEMAQtBs9wrIQVBAAshAiAEIAQoArwBIgFBAWs2ArwBAkAgAUEBSg0AAkBBpIg0KAIAIgFFDQAgAyAENgJwIAEoAgAiBiADKAJwSw0AIAMoAnAgBiABKAIQak8NACAEIAEoAgQ2AgAgASAENgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgBEEAIAH8CwAMAQsgBBArCyACDQELIAMgBTYCBCADQcbKKTYCACAAQfyIKiADEGwACyADQcbKKTYCECAAQeCHKiADQRBqEJsBIANBsAFqJABBAQu6BgIGfwF7IwBBwAFrIgIkACACQdHPKTYCMCAAQfmGKiACQTBqEJsBAkAgAEEBELECIgQEQCAAQTAQhgEiBQR/AkACQCAEQQhqIgEQuAJFDQAgBEGAAWoQuAJFDQAgBUEwNgIAIAUoAghBwAE6AAAgBSgCCCIB/QwAAAAAAAAAAAAAAAAAAAAA/QsAASABQgA3ACggAUIANwAhIAEgB/0LABEMAQsgAkGAAWogAkFAayABELkCQQYhAQJ/AkAgAigCdCIDQQZHDQBB0Z6igAEhASACKAJwIgNB0Z6igAFHDQBBms3/ywEhASACKAJsIgNBms3/ywFHDQBB9umNywAhASACKAJoIgNB9umNywBHDQBBs920yAEhASACKAJkIgNBs920yAFHDQBBpffI3QAhASACKAJgIgNBpffI3QBHDQBB0fC8wgEhASACKAJcIgNB0fC8wgFHDQBB4Zz7KyEBIAIoAlgiA0HhnPsrRw0AQaz7oKUBIQEgAigCVCIDQaz7oKUBRw0AQfXBxD0hASACKAJQIgNB9cHEPUcNAEGx/f/fACEBIAIoAkwiA0Gx/f/fAEcNAEH3///TACEBIAIoAkgiA0H3///TAEcNAEH//+8/IQEgAigCRCIDQf//7z9HDQBB1ar//wEhAUGAASACKAJAIgNB1ar//wFGDQEaC0Ggf0GAfyABIANIGwshBiAFKAIIIAJBgAFqELoCIAVBMDYCACAFKAIIIgEgAS0AACAGcjoAAAtBAAVBjNUpCyEDIAQgBCgCvAEiAUEBazYCvAECQCABQQFKDQACQEGkiDQoAgAiAUUNACACIAQ2AoABIAEoAgAiBiACKAKAAUsNACACKAKAASAGIAEoAhBqTw0AIAQgASgCBDYCACABIAQ2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAEQQAgAfwLAAwBCyAEECsLIAVFDQEgAkHRzyk2AiAgAEHghyogAkEgahCbASACQcABaiQAQQEPCyACQfHUKTYCBCACQdHPKTYCACAAQfyIKiACEGwACyACIAM2AhQgAkHRzyk2AhAgAEH8iCogAkEQahBsAAuwBgEGfyMAQcABayICJAAgAkHzpio2AjAgAEH5hiogAkEwahCbASAAQQFBsfAqENwBIQMgAEECQbHwKhDcASEBAkACQAJAAkAgA0UNACABRQ0AIABBwAFBARDaASIDQriAgICQDDcCACAAQdjhzn1Bi6cqEJABGiAAQX4Q2wEgA0EBNgK8AQJ/QZCEKiAAQQEQzgIiAUEARyAAQQIQzgIiBEEAR3EiBUUNABpBACADQQhqIAEoAgwgBCgCDBC1Ag0AGiAAQYT2K0EAEJwBQQALIQYgBBDQAiABENACIAUNAwwBCyAAQQFBsfAqENwBBEAgAEHAAUEBENoBIgNCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASADQQE2ArwBIABBARDOAiIBRQRAQQAQ0AJBveErIQYMAgsgA0EIaiABKAIMQQAQtgJFBEAgAEGE9itBABCcAQsgARDQAgwDCyAAQQEQyAEiA0UEQEH/5CkhBgwBCyAAQcABQQEQ2gEiAUK4gICAkAw3AgAgAEHY4c59QYunKhCQARogAEF+ENsBIAFBATYCvAEgAygCACIFIAEoAgRKBEAgACAAKAIMQQhrIgQgACgCJE0EfyAAIARBf0EAEF4FIAQLNgIMIAMoAgAhBCACIAEoAgQ2AiggAiAENgIkIAJB86YqNgIgIABBtP8pIAJBIGoQbiADEJoBDAMLIAMoAgghBAJAIAVBAkcNACAELQAAQf8ARw0AIAQtAAFB/wBHDQAgAUEIahCyAgwCCyAEELMCQQBIBH9Bz/srBSAELQAAIQUgAkGAAWogBEEBahC0AiABQQhqIQECQCAFQQRGBEAgAkFAayAEQTFqELQCIAEgAkGAAWogAkFAaxC1Ag0EDAELIAVB/gFxQQJHDQAgASACQYABaiAFQQFxELYCDQMLQZfeKwshBiAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAxCaAQsgAiAGNgIUIAJB86YqNgIQIABB/IgqIAJBEGoQbAALIAMQmgELIAJB86YqNgIAIABB4IcqIAIQmwEgAkHAAWokAEEBC4YEAgJ/AXsjAEHQAmsiASQAIAFB2KcpNgIQIABB+YYqIAFBEGoQmwEgAEHAAUEBENoBIgJCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASACQgA3AgggAkEBNgK8ASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCECACIAP9CwIgIAIgA/0LAjAgAkEBNgJAIAEgA/0LAjQgASAD/QsCRCABQQA2AlQgAUEBNgIgIAEgA/0LAiQgAUKr1Jn1wQE3A5ABIAFCvLn+6PDPrbwCNwOIASABQpnH2dnx6NupHDcDgAEgAULby8OLkbaJxwg3A3ggAULS2bjzoLWTtBE3A3AgAULop/aWsOSYkQk3A2ggAUKu7/ut4aHzmBA3A2AgAUGgAWogAUEgaiABQeAAahDTAiABQqO9xIDQATcDwAIgAULt05uWwabz/xI3A7gCIAFCy+6Ru+Gsl40SNwOwAiABQsO59teglJzPEDcDqAIgAULqg4n7gOueqAk3A6ACIAFC7v//p6Gs//8XNwOYAiABQqvV/v/x///7DzcDkAIgAkHEAGogAUGQAmogAUGgAWoQyQIgAkECNgJ8IAJCADcCsAEgAiAD/QsCoAEgAiAD/QsCkAEgAiAD/QsCgAEgAkEBNgK4ASABQdinKTYCACAAQeCHKiABEJsBIAFB0AJqJABBAQvvAQECfyMAQSBrIgIkACACQeiaKjYCECAAQfmGKiACQRBqEJsBIABBGEEBENoBIQEgAEHY4c59QbHwKhCQARogAEF+ENsBIAFBADsBFCABQiA3AgggAUEANgIQIAFBAToAACAAIAEQyAIgASgCDCIBQafbzwM2AiAgAULnmYOp8fXMsgo3AhggAUK7qoHsgZqBggw3AhAgAUK//9v88b+BpBs3AgggAUKBgICAgP///x83AgAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAiQgAUEANgI0IAJB6JoqNgIAIABB4IcqIAIQmwEgAkEgaiQAQQELhAkCF38BeyMAQYACayIBJAAgAUHY3Sk2AjAgAEH5hiogAUEwahCbAQJAIABBARDIASIFBEAgBSgCAEHAAEcNASAAQcABQQEQ2gEiBEK4gICAkAw3AgAgAEHY4c59QYunKhCQARogAEF+ENsBIARBATYCvAEgASAFKAIANgIQIABBgccpIAFBEGoQWyABQUBrIAUoAggQtAIgAUKjvcSA0AE3A7ABIAFC7dOblsGm8/8SNwOoASABQsvukbvhrJeNEjcDoAEgAULDufbXoJSczxA3A5gBIAFC6oOJ+4DrnqgJNwOQASABQu7//6ehrP//FzcDiAEgAUKr1f7/8f//+w83A4ABIARBgAFqIQYgBEEIaiEEIAFBQGsgAUGAAWoQ2wIgASgCdCEHIAEoAnAhCCABKAJsIQkgASgCaCEKIAEoAmQhCyABKAJgIQwgASgCXCENIAEoAlghDiABKAJUIQ8gASgCUCEQIAEoAkwhESABKAJIIRIgASgCRCETIAEoAkAhAiABQdQBaiIUQSBqIRYgFEEQaiEXA0AgBCABQUBrQQAQtgIaIAEgAkH/////AXFBAWoiA0H/////AXEiFTYCQCABIBMgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiEzYCRCABIBIgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiEjYCSCABIBEgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiETYCTCABIBAgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiEDYCUCABIA8gAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiDzYCVCABIA4gAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiDjYCWCABIA0gAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiDTYCXCABIAwgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiDDYCYCABIAsgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiCzYCZCABIAogAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiCjYCaCABIAkgAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiCTYCbCABIAggAkEddWoiAkH/////AXEgA0EddmoiA0H/////AXEiCDYCcCABIAcgAkEddWogA0EddmoiBzYCdCAEELgCBEAgFSECIAYQuAINAQsgAUGWBzYC0AEgAUKjq+GroZWAjBk3A8gBIAFCq9WCgICr1QI3A8ABIBZBADYCACAX/QwAAAAAAAAAAAAAAAAAAAAA/QsCACAUIBj9CwIAIAQgAUHAAWoQzwIgBBC4AgRAIBUhAiAGELgCDQELCyAFEJoBIAFB2N0pNgIAIABB4IcqIAEQmwEgAUGAAmokAEEBDwsgAEHU1ClBABBsAAsgBRCaASABIAUoAgA2AiAgAEGW/isgAUEgahBuIABBp+IqQQAQbAALzg4BKn8gASgCMCEHIAEoAiwhCCABKAIoIQkgASgCJCEKIAEoAiAhCyABKAIcIQwgASgCGCENIAEoAhQhDiABKAIQIQ8gASgCDCEQIAEoAgghESABKAIEIQUgASgCACESIAEoAjQhASAAIAAoAgAiA0H/////AXEiEzYCACAAIAAoAgQgA0EddWoiA0H/////AXEiFDYCBCAAIAAoAgggA0EddWoiA0H/////AXEiFTYCCCAAIAAoAgwgA0EddWoiA0H/////AXEiFjYCDCAAIAAoAhAgA0EddWoiA0H/////AXEiFzYCECAAIAAoAhQgA0EddWoiA0H/////AXEiGDYCFCAAIAAoAhggA0EddWoiA0H/////AXEiGTYCGCAAIAAoAhwgA0EddWoiA0H/////AXEiGjYCHCAAIAAoAiAgA0EddWoiA0H/////AXEiGzYCICAAIAAoAiQgA0EddWoiA0H/////AXEiHDYCJCAAIAAoAiggA0EddWoiA0H/////AXEiHTYCKCAAIAAoAiwgA0EddWoiA0H/////AXEiHjYCLCAAIAAoAjAgA0EddWoiA0H/////AXEiHzYCMCAAIAAoAjQgA0EddWoiAzYCNCADIQYgASECAkACQAJAIAEgA0cNACAfIQYgHyAHIgJHDQAgHiEGIB4gCCICRw0AIB0hBiAdIAkiAkcNACAcIQYgHCAKIgJHDQAgGyEGIBsgCyICRw0AIBohBiAaIAwiAkcNACAZIQYgGSANIgJHDQAgGCEGIBggDiICRw0AIBchBiAXIA8iAkcNACAWIQYgFiAQIgJHDQAgFSEGIBUgESICRw0AIBQhBiAFIQIgBSAURw0AIBMhBiATIBIiAkYNAQsgAiAGTg0BC0EAIQYDQCAFIgJBAXRB/v///wFxIBJBHHVyIQUgESIEQQF0Qf7///8BcSACQRx1ciERIBAiAkEBdEH+////AXEgBEEcdXIhECAPIgRBAXRB/v///wFxIAJBHHVyIQ8gDiICQQF0Qf7///8BcSAEQRx1ciEOIA0iBEEBdEH+////AXEgAkEcdXIhDSAMIgJBAXRB/v///wFxIARBHHVyIQwgCyIEQQF0Qf7///8BcSACQRx1ciELIAoiAkEBdEH+////AXEgBEEcdXIhCiAJIgRBAXRB/v///wFxIAJBHHVyIQkgCCICQQF0Qf7///8BcSAEQRx1ciEIIAciBEEBdEH+////AXEgAkEcdXIhByAGQQFqIQYgEkEBdEH+////AXEhEiABQQF0IARBHHVyIgEhBAJAIAMiAiABRw0AIAciBCAfIgJHDQAgCCIEIB4iAkcNACAJIgQgHSICRw0AIAoiBCAcIgJHDQAgCyIEIBsiAkcNACAMIgQgGiICRw0AIA0iBCAZIgJHDQAgDiIEIBgiAkcNACAPIgQgFyICRw0AIBAiBCAWIgJHDQAgESIEIBUiAkcNACAFIQQgFCICIAVHDQAgEiIEIBMiAkYNAQsgAiAESg0ACwNAIBQgEUEcdEGAgICAAXEgBUEBdXIiAmsgEyAFQRx0QYCAgIABcSASQQF2ciISayIEQR11aiIgQR11IBUgEEEcdEGAgICAAXEgEUEBdXIiEWtqIiFBHXUgFiAPQRx0QYCAgIABcSAQQQF1ciIQa2oiIkEddSAXIA5BHHRBgICAgAFxIA9BAXVyIg9raiIjQR11IBggDUEcdEGAgICAAXEgDkEBdXIiDmtqIiRBHXUgGSAMQRx0QYCAgIABcSANQQF1ciINa2oiJUEddSAaIAtBHHRBgICAgAFxIAxBAXVyIgxraiImQR11IBsgCkEcdEGAgICAAXEgC0EBdXIiC2tqIidBHXUgHCAJQRx0QYCAgIABcSAKQQF1ciIKa2oiKEEddSAdIAhBHHRBgICAgAFxIAlBAXVyIglraiIpQR11IB4gB0EcdEGAgICAAXEgCEEBdXIiCGtqIipBHXUgHyABQRx0QYCAgIABcSAHQQF1ciIHa2oiK0EddSADIAFBAXUiAWtqIgUgAyAFQQBOIgUbIQMgK0H/////AXEgHyAFGyEfICpB/////wFxIB4gBRshHiApQf////8BcSAdIAUbIR0gKEH/////AXEgHCAFGyEcICdB/////wFxIBsgBRshGyAmQf////8BcSAaIAUbIRogJUH/////AXEgGSAFGyEZICRB/////wFxIBggBRshGCAjQf////8BcSAXIAUbIRcgIkH/////AXEgFiAFGyEWICFB/////wFxIBUgBRshFSAgQf////8BcSAUIAUbIRQgBEH/////AXEgEyAFGyETIAZBAUohBCAGQQFrIQYgAiEFIAQNAAsgACADNgI0IAAgHzYCMCAAIB42AiwgACAdNgIoIAAgHDYCJCAAIBs2AiAgACAaNgIcIAAgGTYCGCAAIBg2AhQgACAXNgIQIAAgFjYCDCAAIBU2AgggACAUNgIEIAAgEzYCAAsL2gIBAn8jAEGgAWsiASQAIAFBoY4qNgIQIABB+YYqIAFBEGoQmwEgAEHAAUEBENoBIgJCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASACQQE2ArwBIAFC8/T0+LEBNwOQASABQuOxlc2A5euXAzcDiAEgAUKM0Y3+gKzTvgI3A4ABIAFCuIraoPDSu/kJNwN4IAFCxY2W1tHx4o8dNwNwIAFC/vea9KH+n+gLNwNoIAFCu42L2eGK4OsZNwNgIAFCnpD92cAANwNQIAFCu5iewbC80KoHNwNIIAFC4Ovzp/CKu9ALNwNAIAFC7Ibg3pDArt0SNwM4IAFCg7r72aDA5bIMNwMwIAFCg/KKkdCooscZNwMoIAFC4c+XtqCpxqgFNwMgIAJBCGogAUHgAGogAUEgahC1AhogAUGhjio2AgAgAEHghyogARCbASABQaABaiQAQQELnAEBA38jAEEwayIBJAAgAUGogSs2AiAgAEH5hiogAUEgahCbASAAQQEQyAEiAkUEQCABQYzVKTYCBCABQaiBKzYCACAAQfyIKiABEGwACyACKAIIELMCIQMgACgCDEEBQREgA0EASBs6AAQgACAAKAIMQQhqNgIMIAIQmgEgAUGogSs2AhAgAEHghyogAUEQahCbASABQTBqJABBAQvwAQECfyMAQSBrIgIkACACQY+RKzYCECAAQfmGKiACQRBqEJsBIABBGEEBENoBIQEgAEHY4c59QbHwKhCQARogAEF+ENsBIAFBADsBFCABQiA3AgggAUEANgIQIAFBAToAACAAIAEQyAIgASgCDCIBQqO9xIDQATcCMCABQu3Tm5bBpvP/EjcCKCABQsvukbvhrJeNEjcCICABQsO59teglJzPEDcCGCABQuqDifuA656oCTcCECABQu7//6ehrP//FzcCCCABQqvV/v/x///7DzcCACACQY+RKzYCACAAQeCHKiACEJsBIAJBIGokAEEBC+EFAgR/AXsjAEGQA2siASQAIAFBsf0pNgIgIABB+YYqIAFBIGoQmwEgAEEBEM4CIgNFBEAgAUHp4Ss2AgQgAUGx/Sk2AgAgAEH8iCogARBsAAsgAygCDCECIAFCq9SZ9cEBNwPQASABQry5/ujwz628AjcDyAEgAUKZx9nZ8ejbqRw3A8ABIAFC28vDi5G2iccINwO4ASABQtLZuPOgtZO0ETcDsAEgAULop/aWsOSYkQk3A6gBIAFCru/7reGh85gQNwOgASABQeABaiACIAFBoAFqENMCIAFCo73EgNABNwOAAyABQu3Tm5bBpvP/EjcD+AIgAULL7pG74ayXjRI3A/ACIAFCw7n216CUnM8QNwPoAiABQuqDifuA656oCTcD4AIgAULu//+noaz//xc3A9gCIAFCq9X+//H///sPNwPQAiABQeQAaiABQdACaiABQeABahDJAiABQQI2ApwBIAFBKGogAUHkAGoQ4AIgAEEYQQEQ2gEhAiAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgAkEAOwEUIAJCIDcCCCACQQA2AhAgAkEBOgAAIAAgAhDIAiACKAIMIQIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LArwCIAEgBf0LAqwCIAFBADYCzAIgASABKAIoNgLgASABIAH9AAIs/QsC5AEgASAB/QACPP0LAvQBIAEgAf0AAkz9CwKEAiABIAEoAlwiBEH/////AXE2ApQCIAEgBEEddTYCmAIgASAF/QsCnAIgAUKjvcSA0AE3A4ADIAFC7dOblsGm8/8SNwP4AiABQsvukbvhrJeNEjcD8AIgAULDufbXoJSczxA3A+gCIAFC6oOJ+4DrnqgJNwPgAiABQu7//6ehrP//FzcD2AIgAUKr1f7/8f//+w83A9ACIAIgAUHQAmogAUHgAWoQyQIgAxDQAiABQbH9KTYCECAAQeCHKiABQRBqEJsBIAFBkANqJABBAQuhBAIBfwF+IwBB8AFrIgIkACABNAI4IgMgA35CgICAEFoEQCABENICCyACQUBrIAEQtAMgAkKjvcSA0AE3A+ABIAJC7dOblsGm8/8SNwPYASACQsvukbvhrJeNEjcD0AEgAkLDufbXoJSczxA3A8gBIAJC6oOJ+4DrnqgJNwPAASACQu7//6ehrP//FzcDuAEgAkKr1f7/8f//+w83A7ABIAJBBGogAkGwAWogAkFAaxDJAiACQQI2AjwgASgCOEGAgIAITgRAIAJBBGoQ0gILIAJBQGsgAkEEaiABENMCIAJCo73EgNABNwPgASACQu3Tm5bBpvP/EjcD2AEgAkLL7pG74ayXjRI3A9ABIAJCw7n216CUnM8QNwPIASACQuqDifuA656oCTcDwAEgAkLu//+noaz//xc3A7gBIAJCq9X+//H///sPNwOwASACQQRqIAJBsAFqIAJBQGsQyQIgAkECNgI8IAAgAigCBDYCACAAIAIoAgg2AgQgACACKAIMNgIIIAAgAigCEDYCDCAAIAIoAhQ2AhAgACACKAIYNgIUIAAgAigCHDYCGCAAIAIoAiA2AhwgACACKAIkNgIgIAAgAigCKDYCJCAAIAIoAiw2AiggACACKAIwNgIsIAAgAigCNDYCMCACKAI4IQEgAEECNgI4IAAgATYCNCACQQRqQYDBLxCCAyAAIAJBBGogABD3AiAAENICIAJB8AFqJAALuAgCCH8BeyMAQaADayIBJAAgAUGC0Ck2AmAgAEH5hiogAUHgAGoQmwECQAJAAkAgAEEBEMgBIgQEQCAEKAIILQAAIgJB3wFLDQEgAkGgAXFBIEYNASAEKAIAIQMCQCACwCIGQQBIBEAgA0EwRg0BIAQQmgEgAUHWmyo2AlQgAUGC0Ck2AlAgAEH8iCogAUHQAGoQbAALIANB4ABHDQMLIABBwAFBARDaASICQriAgICQDDcCACAAQdjhzn1Bi6cqEJABGiAAQX4Q2wEgAkEBNgK8ASAGQcAAcQRAIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwIIIAJBATYCQCACQgA3AjggAiAJ/QsCKCACIAn9CwIYIAEgCf0LAoQBIAEgCf0LApQBIAFBADYCpAEgAUEBNgJwIAEgCf0LAnQgAUKr1Jn1wQE3A+ABIAFCvLn+6PDPrbwCNwPYASABQpnH2dnx6NupHDcD0AEgAULby8OLkbaJxwg3A8gBIAFC0tm486C1k7QRNwPAASABQuin9paw5JiRCTcDuAEgAUKu7/ut4aHzmBA3A7ABIAFB8AFqIAFB8ABqIAFBsAFqENMCIAFCo73EgNABNwOQAyABQu3Tm5bBpvP/EjcDiAMgAULL7pG74ayXjRI3A4ADIAFCw7n216CUnM8QNwP4AiABQuqDifuA656oCTcD8AIgAULu//+noaz//xc3A+gCIAFCq9X+//H///sPNwPgAiACQcQAaiABQeACaiABQfABahDJAiACQQI2AnwgAkIANwKwASACIAn9CwKgASACIAn9CwKQASACIAn9CwKAASACQQE2ArgBDAQLIAZBAE4Ef0GZtCsFIABBGEEBENoBIQMgAEHY4c59QbHwKhCQARogAEF+ENsBIANBADsBFCADQiA3AgggA0EANgIQIANBAToAACAAQTAQmAEiBygCCCIFIAQoAggiCP0AAAD9CwAAIAUgCP0AACD9CwAgIAUgCP0AABD9CwAQIAUgBS0AAEEfcToAACAHQTA2AgAgACADIAcQ4gIaIAcQmgEgAkEIaiICIAMoAgxBABC2AgRAIAFB8AFqIAFB4AJqIAIQuQIgAUHgAmoQuwIgBkHgAXFBBXZBAXFHBEAgAhDAAgsgACAAKAIMQQhrIgIgACgCJE0EfyAAIAJBf0EAEF4FIAILNgIMDAULQeX4KgshAiAEEJoBIAEgAjYCJCABQYLQKTYCICAAQfyIKiABQSBqEGwACyABQf/kKTYCBCABQYLQKTYCACAAQfyIKiABEGwACyAEEJoBIAFB1psqNgIUIAFBgtApNgIQIABB/IgqIAFBEGoQbAALIAQQmgEgAUHWmyo2AkQgAUGC0Ck2AkAgAEH8iCogAUFAaxBsAAsgBBCaASABQYLQKTYCMCAAQeCHKiABQTBqEJsBIAFBoANqJABBAQvCBgEGfwJAIAIoAgAiBEEwTARAIAAgARDIAiABKAIMIgD9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIABCADcCMCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsCICAA/QwAAAAAAAAAAAAAAAAAAAAA/QsCECACKAIAQQBMDQEDQCAAIAAoAjRBCHQgACgCMCIEQRV1cjYCNCAAIARBCHRB/////wFxIABBLGoiBCgCACIFQRV1cjYCMCAEIAVBCHRB/////wFxIABBKGoiBSgCACIDQRV1cjYCACAFIANBCHRB/////wFxIABBJGoiBCgCACIDQRV1cjYCACAEIANBCHRB/////wFxIABBIGoiBSgCACIDQRV1cjYCACAFIANBCHRB/////wFxIABBHGoiBCgCACIDQRV1cjYCACAEIANBCHRB/////wFxIABBGGoiBSgCACIDQRV1cjYCACAFIANBCHRB/////wFxIABBFGoiBCgCACIDQRV1cjYCACAEIANBCHRB/////wFxIABBEGoiBSgCACIDQRV1cjYCACAFIANBCHRB/////wFxIABBDGoiBCgCACIDQRV1cjYCACAEIANBCHRB/////wFxIABBCGoiBSgCACIDQRV1cjYCACAFIANBCHRB/////wFxIABBBGoiBCgCACIDQRV1cjYCACAEIANBCHRB/////wFxIAAoAgAiBUEVdXI2AgAgACAFQQh0Qf////8BcTYCACABKAIMIgAgACgCACACKAIIIAZqLQAAajYCACAGQQFqIgYgAigCAEgNAAsMAQsgBEHgAEsEQEEADwsgACABEJYDIAEoAhAiA0EAQfAA/AsAIAIoAgBBAEwNACACKAIIIQUDQCADIAMoAmxBCHQgAygCaEEVdXI2AmxBGiEBQQAhBANAIAMgAUECdGoiACAAKAIAQQh0QYD+//8BcSAAQQRrIgcoAgAiCEEVdXI2AgAgByAIQQh0QYD+//8BcSAAQQhrKAIAQRV1cjYCACABQQJrIQEgBEECaiIEQRpHDQALIAMgAygCAEEIdEGA/v//AXEiADYCACADIAAgBSAGai0AAHI2AgAgBkEBaiIGIAIoAgBIDQALCyAGC2UBAX8gAEH0AkEBENoBIgJC8ICAgJAYNwIAIABB2OHOfUGU7SsQkAEaIABBfhDbASACQQE2AvACIAJBCGogAUEIahDkAiACQYABaiABQYABahDkAiACQfgBaiABQfgBahDkAiACC7YCACAAIAFHBEAgACABKAIANgIAIAAgASgCBDYCBCAAIAEoAgg2AgggACABKAIMNgIMIAAgASgCEDYCECAAIAEoAhQ2AhQgACABKAIYNgIYIAAgASgCHDYCHCAAIAEoAiA2AiAgACABKAIkNgIkIAAgASgCKDYCKCAAIAEoAiw2AiwgACABKAIwNgIwIAAgASgCNDYCNCAAIAEoAjg2AjggACABKAI8NgI8IAAgASgCQDYCQCAAIAEoAkQ2AkQgACABKAJINgJIIAAgASgCTDYCTCAAIAEoAlA2AlAgACABKAJUNgJUIAAgASgCWDYCWCAAIAEoAlw2AlwgACABKAJgNgJgIAAgASgCZDYCZCAAIAEoAmg2AmggACABKAJsNgJsIAAgASgCcDYCcCAAIAEoAnQ2AnQLC0EBAX8jAEEgayIBJAAgAUHErCk2AhAgAEH5hiogAUEQahCbASABQcSsKTYCACAAQeCHKiABEJsBIAFBIGokAEEAC8ADAQJ/AkAgASgCACIDDQAgASgCBA0AIAEoAggNACABKAIMDQAgASgCEA0AIAEoAhQNACABKAIYDQAgASgCHA0AIAEoAiANACABKAIkDQAgASgCKA0AIAEoAiwNACABKAIwDQAgASgCNA0AIAAQuwIPC0EGIQACfwJAIAEoAjQiAkEGRw0AQdGeooABIQAgASgCMCICQdGeooABRw0AQZrN/8sBIQAgASgCLCICQZrN/8sBRw0AQfbpjcsAIQAgASgCKCICQfbpjcsARw0AQbPdtMgBIQAgASgCJCICQbPdtMgBRw0AQaX3yN0AIQAgASgCICICQaX3yN0ARw0AQdHwvMIBIQAgASgCHCICQdHwvMIBRw0AQeGc+yshACABKAIYIgJB4Zz7K0cNAEGs+6ClASEAIAEoAhQiAkGs+6ClAUcNAEH1wcQ9IQAgASgCECICQfXBxD1HDQBBsf3/3wAhACABKAIMIgJBsf3/3wBHDQBB9///0wAhACABKAIIIgJB9///0wBHDQBB///vPyEAIAEoAgQiAkH//+8/Rw0AQdWq//8BIQAgAyECQQAgA0HVqv//AUYNARoLIAAgAkgLC+ICAQR/IwBBQGoiAiQAIAJBzY8rNgIwIABB+YYqIAJBMGoQmwEgAEEBQZTtKxDcASIDRQRAIABBARDIASIDBEAgAygCCC0AACIBQd8BTSABQaABcUEgR3FFBEAgAkEBNgIQIABBibkrIAJBEGoQbgsgAxCaAQsgAkHF1Sk2AgQgAkHNjys2AgAgAEH8iCogAhBsAAsgAyADKALwAkEBajYC8AIgACADEOMCQQhqEOgCIAMgAygC8AIiAUEBazYC8AICQCABQQFKDQACQEGkiDQoAgAiAUUNACACIAM2AjwgASgCACIEIAIoAjxLDQAgAigCPCAEIAEoAhBqTw0AIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASADQQAgAfwLAAwBCyADECsLIAJBzY8rNgIgIABB4IcqIAJBIGoQmwEgAkFAayQAQQEL1ggCE38BeyMAQYADayIBJAACQAJ/IAAQuAIEQEEBIABBPGoQuAINARoLQQALAn8gAEHwAWoiAxC4AgRAQQEgAEGsAmoQuAINARoLQQALcQ0AIAFB1AFqIgL9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFB5AFqIgQgFP0LAgAgAUH0AWoiBUEANgIAIAFBATYCwAEgASAU/QsCxAEgAUKr1Jn1wQE3A7ACIAFCvLn+6PDPrbwCNwOoAiABQpnH2dnx6NupHDcDoAIgAULby8OLkbaJxwg3A5gCIAFC0tm486C1k7QRNwOQAiABQuin9paw5JiRCTcDiAIgAUKu7/ut4aHzmBA3A4ACIAEgAUHAAWogAUGAAmoQ0wIgAUKjvcSA0AE3A/ACIAFC7dOblsGm8/8SNwPoAiABQsvukbvhrJeNEjcD4AIgAULDufbXoJSczxA3A9gCIAFC6oOJ+4DrnqgJNwPQAiABQu7//6ehrP//FzcDyAIgAUKr1f7/8f//+w83A8ACIAFBhAFqIAFBwAJqIAEQyQIgASgChAEhBiABKAKIASEHIAEoAowBIQggASgCkAEhCSABKAKUASEKIAEoApgBIQsgASgCnAEhDCABKAKgASENIAEoAqQBIQ4gASgCqAEhDyABKAKsASEQIAEoArABIREgASgCtAEhEiABKAK4ASETIAIgFP0LAgAgBCAU/QsCACAFQQA2AgAgAUEBNgLAASABIBT9CwLEASABQqvUmfXBATcDsAIgAUK8uf7o8M+tvAI3A6gCIAFCmcfZ2fHo26kcNwOgAiABQtvLw4uRtonHCDcDmAIgAULS2bjzoLWTtBE3A5ACIAFC6Kf2lrDkmJEJNwOIAiABQq7v+63hofOYEDcDgAIgASABQcABaiABQYACahDTAiABQqO9xIDQATcD8AIgAULt05uWwabz/xI3A+gCIAFCy+6Ru+Gsl40SNwPgAiABQsO59teglJzPEDcD2AIgAULqg4n7gOueqAk3A9ACIAFC7v//p6Gs//8XNwPIAiABQqvV/v/x///7DzcDwAIgAUGEAWogAUHAAmogARDJAiABQQI2ArwBAkAgAyABQYQBahDUAkUNACAAQawCahC4AkUNACAAENICIABBPGoQ0gIgAEH4AGoQ0gIgAEG0AWoQ0gIMAQsgASADEIYDIAAgACABEPkCIABB+ABqIgIgAiABEPkCIAAQ0gIgAEE8ahDSAiACENICIABBtAFqENICIABCADcCrAIgAEECNgKoAiAAIBM2AqQCIAAgEjYCoAIgACARNgKcAiAAIBA2ApgCIAAgDzYClAIgACAONgKQAiAAIA02AowCIAAgDDYCiAIgACALNgKEAiAAIAo2AoACIAAgCTYC/AEgACAINgL4ASAAIAc2AvQBIAAgBjYC8AEgACAU/QsCtAIgACAU/QsCxAIgACAU/QsC1AIgAEEBNgLkAgsgAUGAA2okAAviAgEEfyMAQUBqIgIkACACQdb6KjYCMCAAQfmGKiACQTBqEJsBIABBAUGU7SsQ3AEiA0UEQCAAQQEQyAEiAwRAIAMoAggtAAAiAUHfAU0gAUGgAXFBIEdxRQRAIAJBATYCECAAQYm5KyACQRBqEG4LIAMQmgELIAJBxdUpNgIEIAJB1voqNgIAIABB/IgqIAIQbAALIAMgAygC8AJBAWo2AvACIAAgAxDjAkEIahDqAiADIAMoAvACIgFBAWs2AvACAkAgAUEBSg0AAkBBpIg0KAIAIgFFDQAgAiADNgI8IAEoAgAiBCACKAI8Sw0AIAIoAjwgBCABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgA0EAIAH8CwAMAQsgAxArCyACQdb6KjYCICAAQeCHKiACQSBqEJsBIAJBQGskAEEBC4gCAQN/IwBBgAFrIgEkACAAQfgAaiICEPYCIAFBxABqIAIgAEG0AWoiAxD3AiABQcQAaiABQcQAahDMAiABQQhqIAFBxABqIAMQ9wIgAyABQcQAaiACEPcCIAAgASgCCDYCeCAAIAEoAgw2AnwgACABKAIQNgKAASAAIAEoAhQ2AoQBIAAgASgCGDYCiAEgACABKAIcNgKMASAAIAEoAiA2ApABIAAgASgCJDYClAEgACABKAIoNgKYASAAIAEoAiw2ApwBIAAgASgCMDYCoAEgACABKAI0NgKkASAAIAEoAjg2AqgBIAAgASgCPDYCrAEgACABKAJANgKwASACEPYCIAFBgAFqJAALtQMBBH8jAEFAaiIDJAAgA0HB9Co2AjAgAEH5hiogA0EwahCbASAAQQFBlO0rENwBIgJFBEAgAEEBEMgBIgIEQCACKAIILQAAIgFB3wFNIAFBoAFxQSBHcUUEQCADQQE2AhAgAEGJuSsgA0EQahBuCyACEJoBCyADQcXVKTYCBCADQcH0KjYCACAAQfyIKiADEGwACyACIAIoAvACQQFqNgLwAgJ/IAJBCGoQuAIEQEEBIAJBxABqELgCDQEaC0EACyEBAn8gAkH4AWoQuAIEQEEBIAJBtAJqELgCDQEaC0EACyEEIAAoAgxBEUEBIAEgBHEbOgAEIAAgACgCDEEIajYCDCACIAIoAvACIgFBAWs2AvACAkAgAUEBSg0AAkBBpIg0KAIAIgFFDQAgAyACNgI8IAEoAgAiBCADKAI8Sw0AIAMoAjwgBCABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgAkEAIAH8CwAMAQsgAhArCyADQcH0KjYCICAAQeCHKiADQSBqEJsBIANBQGskAEEBC7QDAQR/IwBBQGoiAyQAIANBtuIpNgIwIABB+YYqIANBMGoQmwECQAJAIABBAUGU7SsQ3AEiAUUEQEHF1SkhAiAAQQEQyAEiAUUNASABKAIILQAAIgRB3wFNIARBoAFxQSBHcUUEQCADQQE2AhAgAEGJuSsgA0EQahBuCyABEJoBDAELIAEgASgC8AJBAWo2AvACIABBwQEQhgEiAg0BIAEgASgC8AIiBEEBazYC8AJB6dsrIQIgBEEBSg0AQaSINCgCACIEBEAgBCABEFAMAQsgARArCyADIAI2AgQgA0G24ik2AgAgAEH8iCogAxBsAAsgAiABQQhqEN8BIAEgASgC8AIiAkEBazYC8AICQCACQQFKDQBBpIg0KAIAIgJFBEAgARArDAELIAMgATYCPAJAIAIoAgAiBCADKAI8Sw0AIAMoAjwgBCACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgAUEAIAL8CwAMAQsgARArCyADQbbiKTYCICAAQeCHKiADQSBqEJsBIANBQGskAEEBC8IGAgR/AXsjAEGgAmsiASQAIAFBrIwqNgIwIABB+YYqIAFBMGoQmwEgAEEBQZTtKxDcASICRQRAIABBARDIASICBEAgAigCCC0AACIDQd8BTSADQaABcUEgR3FFBEAgAUEBNgIQIABBibkrIAFBEGoQbgsgAhCaAQsgAUHF1Sk2AgQgAUGsjCo2AgAgAEH8iCogARBsAAsgAiACKALwAkEBajYC8AIgAEEYQQEQ2gEhAyAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgA0EAOwEUIANCIDcCCCADQQA2AhAgA0EBOgAAIAAgAxDIAiABIAIoAgg2AjQgASACKAIMNgI4IAEgAigCEDYCPCABIAIoAhQ2AkAgASACKAIYNgJEIAEgAigCHDYCSCABIAIoAiA2AkwgASACKAIkNgJQIAEgAigCKDYCVCABIAIoAiw2AlggASACKAIwNgJcIAEgAigCNDYCYCABIAIoAjg2AmQgASACKAI8NgJoIAEgAigCQDYCbCABQTRqENICIAMoAgwhAyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCzAEgASAF/QsCvAEgAUEANgLcASABIAEoAjQ2AnAgASAB/QACOP0LAnQgASAB/QACSP0LAoQBIAEgAf0AAlj9CwKUASABIAEoAmgiBEH/////AXE2AqQBIAEgBEEddTYCqAEgASAF/QsCrAEgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAMgAUHgAWogAUHwAGoQyQIgAiACKALwAiIDQQFrNgLwAgJAIANBAUoNAAJAQaSINCgCACIDRQ0AIAEgAjYCcCADKAIAIgQgASgCcEsNACABKAJwIAQgAygCEGpPDQAgAiADKAIENgIAIAMgAjYCBCADIAMoAghBAWo2AgggAygCFCIDQQRJDQEgA0F8cSIDRQ0BIAJBACAD/AsADAELIAIQKwsgAUGsjCo2AiAgAEHghyogAUEgahCbASABQaACaiQAQQELwgYCBH8BeyMAQaACayIBJAAgAUH42io2AjAgAEH5hiogAUEwahCbASAAQQFBlO0rENwBIgJFBEAgAEEBEMgBIgIEQCACKAIILQAAIgNB3wFNIANBoAFxQSBHcUUEQCABQQE2AhAgAEGJuSsgAUEQahBuCyACEJoBCyABQcXVKTYCBCABQfjaKjYCACAAQfyIKiABEGwACyACIAIoAvACQQFqNgLwAiAAQRhBARDaASEDIABB2OHOfUGx8CoQkAEaIABBfhDbASADQQA7ARQgA0IgNwIIIANBADYCECADQQE6AAAgACADEMgCIAEgAigCRDYCNCABIAIoAkg2AjggASACKAJMNgI8IAEgAigCUDYCQCABIAIoAlQ2AkQgASACKAJYNgJIIAEgAigCXDYCTCABIAIoAmA2AlAgASACKAJkNgJUIAEgAigCaDYCWCABIAIoAmw2AlwgASACKAJwNgJgIAEgAigCdDYCZCABIAIoAng2AmggASACKAJ8NgJsIAFBNGoQ0gIgAygCDCEDIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwLMASABIAX9CwK8ASABQQA2AtwBIAEgASgCNDYCcCABIAH9AAI4/QsCdCABIAH9AAJI/QsChAEgASAB/QACWP0LApQBIAEgASgCaCIEQf////8BcTYCpAEgASAEQR11NgKoASABIAX9CwKsASABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAyABQeABaiABQfAAahDJAiACIAIoAvACIgNBAWs2AvACAkAgA0EBSg0AAkBBpIg0KAIAIgNFDQAgASACNgJwIAMoAgAiBCABKAJwSw0AIAEoAnAgBCADKAIQak8NACACIAMoAgQ2AgAgAyACNgIEIAMgAygCCEEBajYCCCADKAIUIgNBBEkNASADQXxxIgNFDQEgAkEAIAP8CwAMAQsgAhArCyABQfjaKjYCICAAQeCHKiABQSBqEJsBIAFBoAJqJABBAQvRBgIEfwF7IwBBoAJrIgEkACABQaCMKjYCMCAAQfmGKiABQTBqEJsBIABBAUGU7SsQ3AEiAkUEQCAAQQEQyAEiAgRAIAIoAggtAAAiA0HfAU0gA0GgAXFBIEdxRQRAIAFBATYCECAAQYm5KyABQRBqEG4LIAIQmgELIAFBxdUpNgIEIAFBoIwqNgIAIABB/IgqIAEQbAALIAIgAigC8AJBAWo2AvACIABBGEEBENoBIQMgAEHY4c59QbHwKhCQARogAEF+ENsBIANBADsBFCADQiA3AgggA0EANgIQIANBAToAACAAIAMQyAIgASACKAKAATYCNCABIAIoAoQBNgI4IAEgAigCiAE2AjwgASACKAKMATYCQCABIAIoApABNgJEIAEgAigClAE2AkggASACKAKYATYCTCABIAIoApwBNgJQIAEgAigCoAE2AlQgASACKAKkATYCWCABIAIoAqgBNgJcIAEgAigCrAE2AmAgASACKAKwATYCZCABIAIoArQBNgJoIAEgAigCuAE2AmwgAUE0ahDSAiADKAIMIQMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAswBIAEgBf0LArwBIAFBADYC3AEgASABKAI0NgJwIAEgAf0AAjj9CwJ0IAEgAf0AAkj9CwKEASABIAH9AAJY/QsClAEgASABKAJoIgRB/////wFxNgKkASABIARBHXU2AqgBIAEgBf0LAqwBIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASADIAFB4AFqIAFB8ABqEMkCIAIgAigC8AIiA0EBazYC8AICQCADQQFKDQACQEGkiDQoAgAiA0UNACABIAI2AnAgAygCACIEIAEoAnBLDQAgASgCcCAEIAMoAhBqTw0AIAIgAygCBDYCACADIAI2AgQgAyADKAIIQQFqNgIIIAMoAhQiA0EESQ0BIANBfHEiA0UNASACQQAgA/wLAAwBCyACECsLIAFBoIwqNgIgIABB4IcqIAFBIGoQmwEgAUGgAmokAEEBC9EGAgR/AXsjAEGgAmsiASQAIAFB59oqNgIwIABB+YYqIAFBMGoQmwEgAEEBQZTtKxDcASICRQRAIABBARDIASICBEAgAigCCC0AACIDQd8BTSADQaABcUEgR3FFBEAgAUEBNgIQIABBibkrIAFBEGoQbgsgAhCaAQsgAUHF1Sk2AgQgAUHn2io2AgAgAEH8iCogARBsAAsgAiACKALwAkEBajYC8AIgAEEYQQEQ2gEhAyAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgA0EAOwEUIANCIDcCCCADQQA2AhAgA0EBOgAAIAAgAxDIAiABIAIoArwBNgI0IAEgAigCwAE2AjggASACKALEATYCPCABIAIoAsgBNgJAIAEgAigCzAE2AkQgASACKALQATYCSCABIAIoAtQBNgJMIAEgAigC2AE2AlAgASACKALcATYCVCABIAIoAuABNgJYIAEgAigC5AE2AlwgASACKALoATYCYCABIAIoAuwBNgJkIAEgAigC8AE2AmggASACKAL0ATYCbCABQTRqENICIAMoAgwhAyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCzAEgASAF/QsCvAEgAUEANgLcASABIAEoAjQ2AnAgASAB/QACOP0LAnQgASAB/QACSP0LAoQBIAEgAf0AAlj9CwKUASABIAEoAmgiBEH/////AXE2AqQBIAEgBEEddTYCqAEgASAF/QsCrAEgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAMgAUHgAWogAUHwAGoQyQIgAiACKALwAiIDQQFrNgLwAgJAIANBAUoNAAJAQaSINCgCACIDRQ0AIAEgAjYCcCADKAIAIgQgASgCcEsNACABKAJwIAQgAygCEGpPDQAgAiADKAIENgIAIAMgAjYCBCADIAMoAghBAWo2AgggAygCFCIDQQRJDQEgA0F8cSIDRQ0BIAJBACAD/AsADAELIAIQKwsgAUHn2io2AiAgAEHghyogAUEgahCbASABQaACaiQAQQEL0QYCBH8BeyMAQaACayIBJAAgAUGUjCo2AjAgAEH5hiogAUEwahCbASAAQQFBlO0rENwBIgJFBEAgAEEBEMgBIgIEQCACKAIILQAAIgNB3wFNIANBoAFxQSBHcUUEQCABQQE2AhAgAEGJuSsgAUEQahBuCyACEJoBCyABQcXVKTYCBCABQZSMKjYCACAAQfyIKiABEGwACyACIAIoAvACQQFqNgLwAiAAQRhBARDaASEDIABB2OHOfUGx8CoQkAEaIABBfhDbASADQQA7ARQgA0IgNwIIIANBADYCECADQQE6AAAgACADEMgCIAEgAigC+AE2AjQgASACKAL8ATYCOCABIAIoAoACNgI8IAEgAigChAI2AkAgASACKAKIAjYCRCABIAIoAowCNgJIIAEgAigCkAI2AkwgASACKAKUAjYCUCABIAIoApgCNgJUIAEgAigCnAI2AlggASACKAKgAjYCXCABIAIoAqQCNgJgIAEgAigCqAI2AmQgASACKAKsAjYCaCABIAIoArACNgJsIAFBNGoQ0gIgAygCDCEDIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwLMASABIAX9CwK8ASABQQA2AtwBIAEgASgCNDYCcCABIAH9AAI4/QsCdCABIAH9AAJI/QsChAEgASAB/QACWP0LApQBIAEgASgCaCIEQf////8BcTYCpAEgASAEQR11NgKoASABIAX9CwKsASABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAyABQeABaiABQfAAahDJAiACIAIoAvACIgNBAWs2AvACAkAgA0EBSg0AAkBBpIg0KAIAIgNFDQAgASACNgJwIAMoAgAiBCABKAJwSw0AIAEoAnAgBCADKAIQak8NACACIAMoAgQ2AgAgAyACNgIEIAMgAygCCEEBajYCCCADKAIUIgNBBEkNASADQXxxIgNFDQEgAkEAIAP8CwAMAQsgAhArCyABQZSMKjYCICAAQeCHKiABQSBqEJsBIAFBoAJqJABBAQvRBgIEfwF7IwBBoAJrIgEkACABQdvaKjYCMCAAQfmGKiABQTBqEJsBIABBAUGU7SsQ3AEiAkUEQCAAQQEQyAEiAgRAIAIoAggtAAAiA0HfAU0gA0GgAXFBIEdxRQRAIAFBATYCECAAQYm5KyABQRBqEG4LIAIQmgELIAFBxdUpNgIEIAFB29oqNgIAIABB/IgqIAEQbAALIAIgAigC8AJBAWo2AvACIABBGEEBENoBIQMgAEHY4c59QbHwKhCQARogAEF+ENsBIANBADsBFCADQiA3AgggA0EANgIQIANBAToAACAAIAMQyAIgASACKAK0AjYCNCABIAIoArgCNgI4IAEgAigCvAI2AjwgASACKALAAjYCQCABIAIoAsQCNgJEIAEgAigCyAI2AkggASACKALMAjYCTCABIAIoAtACNgJQIAEgAigC1AI2AlQgASACKALYAjYCWCABIAIoAtwCNgJcIAEgAigC4AI2AmAgASACKALkAjYCZCABIAIoAugCNgJoIAEgAigC7AI2AmwgAUE0ahDSAiADKAIMIQMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAswBIAEgBf0LArwBIAFBADYC3AEgASABKAI0NgJwIAEgAf0AAjj9CwJ0IAEgAf0AAkj9CwKEASABIAH9AAJY/QsClAEgASABKAJoIgRB/////wFxNgKkASABIARBHXU2AqgBIAEgBf0LAqwBIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASADIAFB4AFqIAFB8ABqEMkCIAIgAigC8AIiA0EBazYC8AICQCADQQFKDQACQEGkiDQoAgAiA0UNACABIAI2AnAgAygCACIEIAEoAnBLDQAgASgCcCAEIAMoAhBqTw0AIAIgAygCBDYCACADIAI2AgQgAyADKAIIQQFqNgIIIAMoAhQiA0EESQ0BIANBfHEiA0UNASACQQAgA/wLAAwBCyACECsLIAFB29oqNgIgIABB4IcqIAFBIGoQmwEgAUGgAmokAEEBC80FAQZ/IwBB0ABrIgMkACADQYbAKzYCQCAAQfmGKiADQUBrEJsBAkAgAEEBQZTtKxDcASIBBEAgASABKALwAkEBajYC8AIMAQsgAEEBEMgBIgRFDQAgBCgCCC0AACICQd8BTSACQaABcUEgR3FFBEAgA0EBNgIwIABBibkrIANBMGoQbgsgBBCaAQsCQAJAAkACQAJ/IABBAkGU7SsQ3AEiBEUEQCAAQQIQyAEiAgRAIAIoAggtAAAiBUHfAU0gBUGgAXFBIEdxRQRAIANBAjYCICAAQYm5KyADQSBqEG4LIAIQmgELQcXVKSIFIAENARoMBAsgBCAEKALwAiICQQFqIgU2AvACIAFFDQEgACABEOMCQQhqIARBCGoQ9AJBAAshBSABIAEoAvACIgJBAWs2AvACAkAgAkEBSg0AAkBBpIg0KAIAIgJFDQAgAyABNgJMIAIoAgAiBiADKAJMSw0AIAMoAkwgBiACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgAUEAIAL8CwAMAQsgARArCyAERQ0CIAQgBCgC8AIiAUEBazYC8AJBASECIAFBAUoNA0GkiDQoAgAiAQ0BIAQQKwwDCyAEIAI2AvACIAVBAUoEQEHF1SkhBQwCC0EAIQJBxdUpIQVBpIg0KAIAIgENACAEECsMAQsgAyAENgJMAkACQCABKAIAIgYgAygCTEsNACADKAJMIAYgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIARBACAB/AsADAELIAQQKwsgAg0BCyADIAU2AgQgA0GGwCs2AgAgAEH8iCogAxBsAAsgA0GGwCs2AhAgAEHghyogA0EQahCbASADQdAAaiQAQQEL1yQBR38jAEHAB2siAiQAIAJByAZqIAAgARD5AiACQdAFaiAAQfgAaiIKIAFB+ABqIgMQ+QIgAkHYBGogAEHwAWoiCyABQfABaiIFEPkCIAJB4ANqIAAgChD3AiACQZwEaiAAQTxqIgYgAEG0AWoiJhD3AiACQeADahD2AiACQegCaiABIAMQ9wIgAkGkA2oiBCABQTxqIgwgAUG0AWoiCBD3AiACQegCahD2AiACQeADaiACQeADaiACQegCahD5AiACIAIoAtAFIAIoAsgGajYC6AIgAiACKALUBSACKALMBmo2AuwCIAIgAigC2AUgAigC0AZqNgLwAiACIAIoAtwFIAIoAtQGajYC9AIgAiACKALgBSACKALYBmo2AvgCIAIgAigC5AUgAigC3AZqNgL8AiACIAIoAugFIAIoAuAGajYCgAMgAiACKALsBSACKALkBmo2AoQDIAIgAigC8AUgAigC6AZqNgKIAyACIAIoAvQFIAIoAuwGajYCjAMgAiACKAL4BSACKALwBmo2ApADIAIgAigC/AUgAigC9AZqNgKUAyACIAIoAoAGIAIoAvgGajYCmAMgAiACKAKEBiACKAL8Bmo2ApwDIAIgAigCiAYgAigCgAdqIgc2AqADIAdBgICAEE4EQCACQegCahDSAgsgAiACKAKMBiACKAKEB2o2AqQDIAIgAigCkAYgAigCiAdqNgKoAyACIAIoApQGIAIoAowHajYCrAMgAiACKAKYBiACKAKQB2o2ArADIAIgAigCnAYgAigClAdqNgK0AyACIAIoAqAGIAIoApgHajYCuAMgAiACKAKkBiACKAKcB2o2ArwDIAIgAigCqAYgAigCoAdqNgLAAyACIAIoAqwGIAIoAqQHajYCxAMgAiACKAKwBiACKAKoB2o2AsgDIAIgAigCtAYgAigCrAdqNgLMAyACIAIoArgGIAIoArAHajYC0AMgAiACKAK8BiACKAK0B2o2AtQDIAIgAigCwAYgAigCuAdqNgLYAyACIAIoAsQGIAIoArwHaiIHNgLcAyAHQYCAgBBOBEAgBBDSAgsgAkHgA2ogAkHgA2ogAkHoAmoQwQggAkHgA2oQ9gIgAkHoAmogCiALEPcCIAQgJiAAQawCaiIHEPcCIAJB6AJqEPYCIAJB8AFqIAMgBRD3AiACQawCaiIDIAggAUGsAmoiBBD3AiACQfABahD2AiACQegCaiACQegCaiACQfABahD5AiACIAIoAtgEIgggAigC0AUiJ2o2AvABIAIgAigC3AQiDSACKALUBSIoajYC9AEgAiACKALgBCIOIAIoAtgFIilqNgL4ASACIAIoAuQEIg8gAigC3AUiKmo2AvwBIAIgAigC6AQiECACKALgBSIrajYCgAIgAiACKALsBCIRIAIoAuQFIixqNgKEAiACIAIoAvAEIhIgAigC6AUiLWo2AogCIAIgAigC9AQiEyACKALsBSIuajYCjAIgAiACKAL4BCIUIAIoAvAFIi9qNgKQAiACIAIoAvwEIhUgAigC9AUiMGo2ApQCIAIgAigCgAUiFiACKAL4BSIxajYCmAIgAiACKAKEBSIXIAIoAvwFIjJqNgKcAiACIAIoAogFIhggAigCgAYiM2o2AqACIAIgAigCjAUiGSACKAKEBiI0ajYCpAIgAiACKAKQBSIaIAIoAogGIjVqIgk2AqgCIAlBgICAEE4EQCACQfABahDSAgsgAiACKAKUBSIJIAIoAowGIjZqNgKsAiACIAIoApgFIhsgAigCkAYiN2o2ArACIAIgAigCnAUiHCACKAKUBiI4ajYCtAIgAiACKAKgBSIdIAIoApgGIjlqNgK4AiACIAIoAqQFIh4gAigCnAYiOmo2ArwCIAIgAigCqAUiHyACKAKgBiI7ajYCwAIgAiACKAKsBSIgIAIoAqQGIjxqNgLEAiACIAIoArAFIiEgAigCqAYiPWo2AsgCIAIgAigCtAUiIiACKAKsBiI+ajYCzAIgAiACKAK4BSIjIAIoArAGIj9qNgLQAiACIAIoArwFIiQgAigCtAYiQGo2AtQCIAIgAigCwAUiJSACKAK4BiJBajYC2AIgAiACKALEBSJCIAIoArwGIkNqNgLcAiACIAIoAsgFIkQgAigCwAYiRWo2AuACIAIgAigCzAUiRiACKALEBiJHaiJINgLkAiBIQYCAgBBOBEAgAxDSAgsgAkHoAmogAkHoAmogAkHwAWoQwQggAkHoAmoQ9gIgAkHwAWogACALEPcCIAMgBiAHEPcCIAJB8AFqEPYCIAJB+ABqIAEgBRD3AiACQbQBaiIBIAwgBBD3AiACQfgAahD2AiACQfABaiACQfABaiACQfgAahD5AiACIAggAigCyAYiBmo2AnggAiANIAIoAswGIgxqNgJ8IAIgDiACKALQBiIIajYCgAEgAiAPIAIoAtQGIg1qNgKEASACIBAgAigC2AYiDmo2AogBIAIgESACKALcBiIPajYCjAEgAiASIAIoAuAGIhBqNgKQASACIBMgAigC5AYiEWo2ApQBIAIgFCACKALoBiISajYCmAEgAiAVIAIoAuwGIhNqNgKcASACIBYgAigC8AYiFGo2AqABIAIgFyACKAL0BiIVajYCpAEgAiAYIAIoAvgGIhZqNgKoASACIBkgAigC/AYiF2o2AqwBIAIgGiACKAKAByIFaiIENgKwASAEQYCAgBBOBEAgAkH4AGoQ0gILIAIgCSACKAKEByIYajYCtAEgAiAbIAIoAogHIhlqNgK4ASACIBwgAigCjAciGmo2ArwBIAIgHSACKAKQByIJajYCwAEgAiAeIAIoApQHIhtqNgLEASACIB8gAigCmAciHGo2AsgBIAIgICACKAKcByIdajYCzAEgAiAhIAIoAqAHIh5qNgLQASACICIgAigCpAciH2o2AtQBIAIgIyACKAKoByIgajYC2AEgAiAkIAIoAqwHIiFqNgLcASACICUgAigCsAciImo2AuABIAIgQiACKAK0ByIjajYC5AEgAiBEIAIoArgHIiRqNgLoASACIEYgAigCvAciBGoiJTYC7AEgJUGAgIAQTgRAIAEQ0gILIAJB+ABqIAJB8AFqIAJB+ABqEMEIIAJB+ABqEPYCIAIgBUEBdDYCqAIgAiAXQQF0NgKkAiACIBZBAXQ2AqACIAIgFUEBdDYCnAIgAiAUQQF0NgKYAiACIBNBAXQ2ApQCIAIgEkEBdDYCkAIgAiARQQF0NgKMAiACIBBBAXQ2AogCIAIgD0EBdDYChAIgAiAOQQF0NgKAAiACIA1BAXQ2AvwBIAIgCEEBdDYC+AEgAiAMQQF0NgL0ASACIAZBAXQ2AvABIAVBgICACE4EQCACQfABahDSAgsgAkGEB2ohBSACQZQFaiEGIAIgBEEBdDYC5AIgAiAkQQF0NgLgAiACICNBAXQ2AtwCIAIgIkEBdDYC2AIgAiAhQQF0NgLUAiACICBBAXQ2AtACIAIgH0EBdDYCzAIgAiAeQQF0NgLIAiACIB1BAXQ2AsQCIAIgHEEBdDYCwAIgAiAbQQF0NgK8AiACIAlBAXQ2ArgCIAIgGkEBdDYCtAIgAiAZQQF0NgKwAiACIBhBAXQ2AqwCIARBgICACE4EQCADENICCyACQcgGaiACQcgGaiACQfABahD3AiAFIAUgAxD3AiACQcgGahD2AiACQdgEaiACQdgEakEMELwIIAYgBkEMELwIIAJB2ARqEMMIIAJB2ARqEPYCIAIgAigC2AQgJ2o2AgAgAiACKALcBCAoajYCBCACIAIoAuAEIClqNgIIIAIgAigC5AQgKmo2AgwgAiACKALoBCArajYCECACIAIoAuwEICxqNgIUIAIgAigC8AQgLWo2AhggAiACKAL0BCAuajYCHCACIAIoAvgEIC9qNgIgIAIgAigC/AQgMGo2AiQgAiACKAKABSAxajYCKCACIAIoAoQFIDJqNgIsIAIgAigCiAUgM2o2AjAgAiACKAKMBSA0ajYCNCACIAIoApAFIDVqIgM2AjggA0GAgIAQTgRAIAIQ0gILIAIgAigClAUgNmo2AjwgAiACKAKYBSA3ajYCQCACIAIoApwFIDhqNgJEIAIgAigCoAUgOWo2AkggAiACKAKkBSA6ajYCTCACIAIoAqgFIDtqNgJQIAIgAigCrAUgPGo2AlQgAiACKAKwBSA9ajYCWCACIAIoArQFID5qNgJcIAIgAigCuAUgP2o2AmAgAiACKAK8BSBAajYCZCACIAIoAsAFIEFqNgJoIAIgAigCxAUgQ2o2AmwgAiACKALIBSBFajYCcCACIAIoAswFIEdqIgM2AnQgA0GAgIAQTgRAIAJBPGoQ0gILIAIQ9gIgAkHQBWogAkHQBWogAkHYBGoQwQggAkHQBWoQ9gIgAkH4AGogAkH4AGpBDBC8CCABIAFBDBC8CCACQfgAahDDCCACQfgAahD2AiACQfABaiACQfgAaiACQegCahD5AiACQdgEaiACQeADaiACQdAFahD5AiAAIAJB2ARqIAJB8AFqEMEIIAJB+ABqIAJB+ABqIAJByAZqEPkCIAJB0AVqIAJB0AVqIAIQ+QIgACACKALQBSACKAJ4ajYCeCAAIAIoAtQFIAIoAnxqNgJ8IAAgAigC2AUgAigCgAFqNgKAASAAIAIoAtwFIAIoAoQBajYChAEgACACKALgBSACKAKIAWo2AogBIAAgAigC5AUgAigCjAFqNgKMASAAIAIoAugFIAIoApABajYCkAEgACACKALsBSACKAKUAWo2ApQBIAAgAigC8AUgAigCmAFqNgKYASAAIAIoAvQFIAIoApwBajYCnAEgACACKAL4BSACKAKgAWo2AqABIAAgAigC/AUgAigCpAFqNgKkASAAIAIoAoAGIAIoAqgBajYCqAEgACACKAKEBiACKAKsAWo2AqwBIAAgAigCiAYgAigCsAFqIgE2ArABIAFBgICAEE4EQCAKENICCyAAIAIoAowGIAIoArQBajYCtAEgACACKAKQBiACKAK4AWo2ArgBIAAgAigClAYgAigCvAFqNgK8ASAAIAIoApgGIAIoAsABajYCwAEgACACKAKcBiACKALEAWo2AsQBIAAgAigCoAYgAigCyAFqNgLIASAAIAIoAqQGIAIoAswBajYCzAEgACACKAKoBiACKALQAWo2AtABIAAgAigCrAYgAigC1AFqNgLUASAAIAIoArAGIAIoAtgBajYC2AEgACACKAK0BiACKALcAWo2AtwBIAAgAigCuAYgAigC4AFqNgLgASAAIAIoArwGIAIoAuQBajYC5AEgACACKALABiACKALoAWo2AugBIAAgAigCxAYgAigC7AFqIgE2AuwBIAFBgICAEE4EQCAmENICCyACQcgGaiACQcgGaiACQeADahD5AiACIAIgAkHoAmoQ+QIgACACKALIBiACKAIAajYC8AEgACACKALMBiACKAIEajYC9AEgACACKALQBiACKAIIajYC+AEgACACKALUBiACKAIMajYC/AEgACACKALYBiACKAIQajYCgAIgACACKALcBiACKAIUajYChAIgACACKALgBiACKAIYajYCiAIgACACKALkBiACKAIcajYCjAIgACACKALoBiACKAIgajYCkAIgACACKALsBiACKAIkajYClAIgACACKALwBiACKAIoajYCmAIgACACKAL0BiACKAIsajYCnAIgACACKAL4BiACKAIwajYCoAIgACACKAL8BiACKAI0ajYCpAIgACACKAKAByACKAI4aiIBNgKoAiABQYCAgBBOBEAgCxDSAgsgACACKAKEByACKAI8ajYCrAIgACACKAKIByACKAJAajYCsAIgACACKAKMByACKAJEajYCtAIgACACKAKQByACKAJIajYCuAIgACACKAKUByACKAJMajYCvAIgACACKAKYByACKAJQajYCwAIgACACKAKcByACKAJUajYCxAIgACACKAKgByACKAJYajYCyAIgACACKAKkByACKAJcajYCzAIgACACKAKoByACKAJgajYC0AIgACACKAKsByACKAJkajYC1AIgACACKAKwByACKAJoajYC2AIgACACKAK0ByACKAJsajYC3AIgACACKAK4ByACKAJwajYC4AIgACACKAK8ByACKAJ0aiIBNgLkAiABQYCAgBBOBEAgBxDSAgsgABD2AiAKEPYCIAsQ9gIgAkHAB2okAAuEDQEVfyMAQbAEayIBJAAgAUHjySs2AkAgAEH5hiogAUFAaxCbAQJAIABBAUGU7SsQ3AEiAgRAIAIgAigC8AJBAWo2AvACDAELIABBARDIASIERQ0AIAQoAggtAAAiA0HfAU0gA0GgAXFBIEdxRQRAIAFBATYCMCAAQYm5KyABQTBqEG4LIAQQmgELAkACQAJAAkACfyAAQQJBlO0rENwBIgRFBEAgAEECEMgBIgMEQCADKAIILQAAIgVB3wFNIAVBoAFxQSBHcUUEQCABQQI2AiAgAEGJuSsgAUEgahBuCyADEJoBC0HF1SkiBSACDQEaDAQLIAQgBCgC8AIiA0EBaiIFNgLwAiACRQ0BIAAgAhDjAiEFIAFB0ABqIARBCGoQ5AIgAUHIAWoiAyAEQYABahDkAiABQcACaiAEQfgBahDkAiADEPYCIAEgASgChAIgASgCyAFqNgL0AyABIAEoAogCIgcgASgCzAFqNgL4AyABIAEoAowCIgggASgC0AFqNgL8AyABIAEoApACIgkgASgC1AFqNgKABCABIAEoApQCIgogASgC2AFqNgKEBCABIAEoApgCIgsgASgC3AFqNgKIBCABIAEoApwCIgwgASgC4AFqNgKMBCABIAEoAqACIg0gASgC5AFqNgKQBCABIAEoAqQCIg4gASgC6AFqNgKUBCABIAEoAqgCIg8gASgC7AFqNgKYBCABIAEoAqwCIhAgASgC8AFqNgKcBCABIAEoArACIhEgASgC9AFqNgKgBCABIAEoArQCIhIgASgC+AFqNgKkBCABIAEoArgCIhMgASgC/AFqNgKoBCABIAEoArwCIhQgASgCgAJqIgY2AqwEIAZBgICAEE4EQCABQfQDahDSAgsgBUEIaiEVIAFB9ANqIAFB9ANqEMwCIAEgASgChAIgASgC9ANqIgY2ArgDIAEgByABKAL4A2oiBzYCvAMgASAIIAEoAvwDaiIINgLAAyABIAkgASgCgARqIgk2AsQDIAEgCiABKAKEBGoiCjYCyAMgASALIAEoAogEaiILNgLMAyABIAwgASgCjARqIgw2AtADIAEgDSABKAKQBGoiDTYC1AMgASAOIAEoApQEaiIONgLYAyABIA8gASgCmARqIg82AtwDIAEgECABKAKcBGoiEDYC4AMgASARIAEoAqAEaiIRNgLkAyABIBIgASgCpARqIhI2AugDIAEgEyABKAKoBGoiEzYC7AMgASAUIAEoAqwEaiIFNgLwAyAFQYCAgBBOBEAgAUG4A2oQ0gIgASgC7AMhEyABKALoAyESIAEoAuQDIREgASgC4AMhECABKALcAyEPIAEoAtgDIQ4gASgC1AMhDSABKALQAyEMIAEoAswDIQsgASgCyAMhCiABKALEAyEJIAEoAsADIQggASgCvAMhByABKAK4AyEGIAEoAvADIQULIAFBhAJqIAFB9ANqIAMQ9wIgASAFNgKAAiABIBM2AvwBIAEgEjYC+AEgASARNgL0ASABIBA2AvABIAEgDzYC7AEgASAONgLoASABIA02AuQBIAEgDDYC4AEgASALNgLcASABIAo2AtgBIAEgCTYC1AEgASAINgLQASABIAc2AswBIAEgBjYCyAEgAxD2AiAVIAFB0ABqEPQCQQALIQUgAiACKALwAiIDQQFrNgLwAgJAIANBAUoNAAJAQaSINCgCACIDRQ0AIAEgAjYCUCADKAIAIgYgASgCUEsNACABKAJQIAYgAygCEGpPDQAgAiADKAIENgIAIAMgAjYCBCADIAMoAghBAWo2AgggAygCFCIDQQRJDQEgA0F8cSIDRQ0BIAJBACAD/AsADAELIAIQKwsgBEUNAiAEIAQoAvACIgJBAWs2AvACQQEhAyACQQFKDQNBpIg0KAIAIgINASAEECsMAwsgBCADNgLwAiAFQQFKBEBBxdUpIQUMAgtBACEDQcXVKSEFQaSINCgCACICDQAgBBArDAELIAEgBDYCUAJAAkAgAigCACIGIAEoAlBLDQAgASgCUCAGIAIoAhBqTw0AIAQgAigCBDYCACACIAQ2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASAEQQAgAvwLAAwBCyAEECsLIAMNAQsgASAFNgIEIAFB48krNgIAIABB/IgqIAEQbAALIAFB48krNgIQIABB4IcqIAFBEGoQmwEgAUGwBGokAEEBC6IFAQF/IAAgACgCACIBQf////8BcTYCACAAIAAoAgQgAUEddWoiAUH/////AXE2AgQgACAAKAIIIAFBHXVqIgFB/////wFxNgIIIAAgACgCDCABQR11aiIBQf////8BcTYCDCAAIAAoAhAgAUEddWoiAUH/////AXE2AhAgACAAKAIUIAFBHXVqIgFB/////wFxNgIUIAAgACgCGCABQR11aiIBQf////8BcTYCGCAAIAAoAhwgAUEddWoiAUH/////AXE2AhwgACAAKAIgIAFBHXVqIgFB/////wFxNgIgIAAgACgCJCABQR11aiIBQf////8BcTYCJCAAIAAoAiggAUEddWoiAUH/////AXE2AiggACAAKAIsIAFBHXVqIgFB/////wFxNgIsIAAgACgCMCABQR11aiIBQf////8BcTYCMCAAIAAoAjQgAUEddWo2AjQgACAAKAI8IgFB/////wFxNgI8IAAgACgCQCABQR11aiIBQf////8BcTYCQCAAIAAoAkQgAUEddWoiAUH/////AXE2AkQgACAAKAJIIAFBHXVqIgFB/////wFxNgJIIAAgACgCTCABQR11aiIBQf////8BcTYCTCAAIAAoAlAgAUEddWoiAUH/////AXE2AlAgACAAKAJUIAFBHXVqIgFB/////wFxNgJUIAAgACgCWCABQR11aiIBQf////8BcTYCWCAAIAAoAlwgAUEddWoiAUH/////AXE2AlwgACAAKAJgIAFBHXVqIgFB/////wFxNgJgIAAgACgCZCABQR11aiIBQf////8BcTYCZCAAIAAoAmggAUEddWoiAUH/////AXE2AmggACAAKAJsIAFBHXVqIgFB/////wFxNgJsIAAgACgCcCABQR11ajYCcAuEAgAgACACKAIAIAEoAgBqNgIAIAAgAigCBCABKAIEajYCBCAAIAIoAgggASgCCGo2AgggACACKAIMIAEoAgxqNgIMIAAgAigCECABKAIQajYCECAAIAIoAhQgASgCFGo2AhQgACACKAIYIAEoAhhqNgIYIAAgAigCHCABKAIcajYCHCAAIAIoAiAgASgCIGo2AiAgACACKAIkIAEoAiRqNgIkIAAgAigCKCABKAIoajYCKCAAIAIoAiwgASgCLGo2AiwgACACKAIwIAEoAjBqNgIwIAAgAigCNCABKAI0ajYCNCAAIAIoAjggASgCOGoiATYCOCABQYCAgBBOBEAgABDSAgsLhgcBCH8jAEHAAmsiAiQAIAJB3aMqNgJAIABB+YYqIAJBQGsQmwECQCAAQQFBlO0rENwBIgEEQCABIAEoAvACQQFqNgLwAgwBCyAAQQEQyAEiBEUNACAEKAIILQAAIgNB3wFNIANBoAFxQSBHcUUEQCACQQE2AjAgAEGJuSsgAkEwahBuCyAEEJoBCwJAAkACQAJAAn8gAEECQZTtKxDcASIERQRAIABBAhDIASIDBEAgAygCCC0AACIFQd8BTSAFQaABcUEgR3FFBEAgAkECNgIgIABBibkrIAJBIGoQbgsgAxCaAQtBxdUpIgUgAQ0BGgwEC0EBIQMgBCAEKALwAiIFQQFqIgY2AvACIAFFDQEgAUEIaiIFEOgCIARBCGoiBhDoAiACQcgBaiAFIARB+AFqIgcQ+QIgAkHQAGogBiABQfgBaiIFEPkCAkAgAkHIAWogAkHQAGoQ1AJFDQAgAkGEAmoiBiACQYwBaiIIENQCRQ0AIAJByAFqIAFBgAFqIAcQ+QIgAkHQAGogBEGAAWogBRD5AiACQcgBaiACQdAAahDUAgRAQREhAyAGIAgQ1AINAQtBASEDCyAAKAIMIAM6AAQgACAAKAIMQQhqNgIMQQALIQUgASABKALwAiIDQQFrNgLwAgJAIANBAUoNAAJAQaSINCgCACIDRQ0AIAIgATYCyAEgAygCACIGIAIoAsgBSw0AIAIoAsgBIAYgAygCEGpPDQAgASADKAIENgIAIAMgATYCBCADIAMoAghBAWo2AgggAygCFCIDQQRJDQEgA0F8cSIDRQ0BIAFBACAD/AsADAELIAEQKwsgBEUNAiAEIAQoAvACIgFBAWs2AvACQQEhAyABQQFKDQNBpIg0KAIAIgENASAEECsMAwsgBCAFNgLwAiAGQQFKBEBBxdUpIQUMAgtBACEDQcXVKSEFQaSINCgCACIBDQAgBBArDAELIAIgBDYCyAECQAJAIAEoAgAiBiACKALIAUsNACACKALIASAGIAEoAhBqTw0AIAQgASgCBDYCACABIAQ2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAEQQAgAfwLAAwBCyAEECsLIAMNAQsgAiAFNgIEIAJB3aMqNgIAIABB/IgqIAIQbAALIAJB3aMqNgIQIABB4IcqIAJBEGoQmwEgAkHAAmokAEEBC4kaAVJ/IwBBkARrIgMkACABQTxqIQQCQCACKAJ0IAIoAjhqrCABKAJ0IgUgASgCOCIGaqx+QoCAgBBTDQAgBkECTgR/IAEQ0gIgASgCdAUgBQtBAkgNACAEENICCyADQeACaiABIAIQ0wIgA0HwAWogBCACQTxqENMCIAEoAnAhBCABKAI0IQUgASgCbCEGIAEoAjAhByABKAJoIQggASgCLCEJIAEoAmQhCiABKAIoIQsgASgCYCEMIAEoAiQhDSABKAJcIQ4gASgCICEPIAEoAlghECABKAIcIREgASgCVCESIAEoAhghEyABKAJQIRQgASgCFCEVIAEoAkwhFiABKAIQIRcgASgCSCEYIAEoAgwhGSABKAJEIRogASgCCCEbIAEoAkAhHCABKAIEIR0gAyABKAI8IAEoAgBqIgFB/////wFxNgJAIAMgHCAdaiABQR11aiIBQf////8BcTYCRCADIBogG2ogAUEddWoiAUH/////AXE2AkggAyAYIBlqIAFBHXVqIgFB/////wFxNgJMIAMgFiAXaiABQR11aiIBQf////8BcTYCUCADIBQgFWogAUEddWoiAUH/////AXE2AlQgAyASIBNqIAFBHXVqIgFB/////wFxNgJYIAMgECARaiABQR11aiIBQf////8BcTYCXCADIA4gD2ogAUEddWoiAUH/////AXE2AmAgAyAMIA1qIAFBHXVqIgFB/////wFxNgJkIAMgCiALaiABQR11aiIBQf////8BcTYCaCADIAggCWogAUEddWoiAUH/////AXE2AmwgAyAGIAdqIAFBHXVqIgFB/////wFxNgJwIAMgBCAFaiABQR11ajYCdCACKAJwIQEgAigCNCEEIAIoAmwhBSACKAIwIQYgAigCaCEHIAIoAiwhCCACKAJkIQkgAigCKCEKIAIoAmAhCyACKAIkIQwgAigCXCENIAIoAiAhDiACKAJYIQ8gAigCHCEQIAIoAlQhESACKAIYIRIgAigCUCETIAIoAhQhFCACKAJMIRUgAigCECEWIAIoAkghFyACKAIMIRggAigCRCEZIAIoAgghGiACKAJAIRsgAigCBCEcIAMgAigCPCACKAIAaiICQf////8BcTYCACADIBsgHGogAkEddWoiAkH/////AXE2AgQgAyAZIBpqIAJBHXVqIgJB/////wFxNgIIIAMgFyAYaiACQR11aiICQf////8BcTYCDCADIBUgFmogAkEddWoiAkH/////AXE2AhAgAyATIBRqIAJBHXVqIgJB/////wFxNgIUIAMgESASaiACQR11aiICQf////8BcTYCGCADIA8gEGogAkEddWoiAkH/////AXE2AhwgAyANIA5qIAJBHXVqIgJB/////wFxNgIgIAMgCyAMaiACQR11aiICQf////8BcTYCJCADIAkgCmogAkEddWoiAkH/////AXE2AiggAyAHIAhqIAJBHXVqIgJB/////wFxNgIsIAMgBSAGaiACQR11aiICQf////8BcTYCMCADIAEgBGogAkEddWo2AjQgA0GAAWogA0FAayADENMCIAMoAswDIQwgAygCyAMhDSADKALEAyEOIAMoAsADIQ8gAygCvAMhECADKAK4AyERIAMoArQDIRIgAygCsAMhEyADKAKsAyEUIAMoArgCIRUgAygCqAMhFiADKAK0AiEXIAMoAqQDIRggAygCsAIhGSADKAKgAyEaIAMoAqwCIRsgAygCnAMhHCADKAKoAiEdIAMoApgDIR8gAygCpAIhICADKAKUAyEhIAMoAqACISIgAygCkAMhIyADKAKcAiEkIAMoAowDISUgAygCmAIhJiADKAKIAyEnIAMoApQCISggAygChAMhKSADKAKQAiEqIAMoAoADISsgAygCjAIhLCADKAL8AiEtIAMoAogCIS4gAygC+AIhLyADKAKEAiEwIAMoAvQCITEgAygCgAIhMiADKALwAiEzIAMoAvwBITQgAygC7AIhNSADKAL4ASE2IAMoAugCITcgAygC9AEhOCADKALkAiE5IAMoAuACITogAygCvAIhASADKALAAiECIAMoAsQCIQQgAygCyAIhBSADKALMAiEGIAMoAtACIQcgAygC1AIhCCADKALYAiEJIAMoAtwCIQogA0EAIAMoAvABIgtrNgLwASADQQAgAygC9AEiO2s2AvQBIANBACADKAL4ASI8azYC+AEgA0EAIAMoAvwBIj1rNgL8ASADQQAgAygCgAIiPms2AoACIANBACADKAKEAiI/azYChAIgA0EAIAMoAogCIkBrNgKIAiADQQAgAygCjAIiQWs2AowCIANBACADKAKQAiJCazYCkAIgA0EAIAMoApQCIkNrNgKUAiADQQAgAygCmAIiRGs2ApgCIANBACADKAKcAiJFazYCnAIgA0EAIAMoAqACIkZrNgKgAiADQQAgAygCpAIiR2s2AqQCIANBq9X+/wEgAygCqAJrIkg2AqgCIANB///f/wAgAygCrAJrIkk2AqwCIANB7v//pwEgAygCsAJrIko2ArACIANB4vr/vwEgAygCtAJrIks2ArQCIAMoArgCIR4gA0ENIAprIkw2AtwCIANBo73EACAJayJNNgLYAiADQbSa/5cBIAhrIk42AtQCIANB7dOblgEgB2siTzYC0AIgA0HmuumQASAGayJQNgLMAiADQcvukbsBIAVrIlE2AsgCIANBouH5hAEgBGsiUjYCxAIgA0HDufbXACACayJTNgLAAiADQdj2wcoAIAFrIlQ2ArwCIANB6oOJ+wAgHmsiHjYCuAIgAyADKALgAiALazYC4AIgAyADKALkAiA7azYC5AIgAyADKALoAiA8azYC6AIgAyADKALsAiA9azYC7AIgAyADKALwAiA+azYC8AIgAyADKAL0AiA/azYC9AIgAyADKAL4AiBAazYC+AIgAyADKAL8AiBBazYC/AIgAyADKAKAAyBCazYCgAMgAyADKAKEAyBDazYChAMgAyADKAKIAyBEazYCiAMgAyADKAKMAyBFazYCjAMgAyADKAKQAyBGazYCkAMgAyADKAKUAyBHazYClAMgAyBIIAMoApgDajYCmAMgAyBJIAMoApwDajYCnAMgAyBKIAMoAqADajYCoAMgAyBLIAMoAqQDajYCpAMgAyAeIAMoAqgDajYCqAMgAyBUIAMoAqwDajYCrAMgAyBTIAMoArADajYCsAMgAyBSIAMoArQDajYCtAMgAyBRIAMoArgDajYCuAMgAyBQIAMoArwDajYCvAMgAyBPIAMoAsADajYCwAMgAyBOIAMoAsQDajYCxAMgAyBNIAMoAsgDajYCyAMgAyBMIAMoAswDajYCzAMgAyADKAKAASALIDpqazYCgAEgAyADKAKEASA4IDlqazYChAEgAyADKAKIASA2IDdqazYCiAEgAyADKAKMASA0IDVqazYCjAEgAyADKAKQASAyIDNqazYCkAEgAyADKAKUASAwIDFqazYClAEgAyADKAKYASAuIC9qazYCmAEgAyADKAKcASAsIC1qazYCnAEgAyADKAKgASAqICtqazYCoAEgAyADKAKkASAoIClqazYCpAEgAyADKAKoASAmICdqazYCqAEgAyADKAKsASAkICVqazYCrAEgAyADKAKwASAiICNqazYCsAEgAyADKAK0ASAgICFqazYCtAEgAyADKAK4ASAdIB9qazYCuAEgAyADKAK8ASAbIBxqazYCvAEgAyADKALAASAZIBpqazYCwAEgAyADKALEASAXIBhqazYCxAEgAyADKALIASAVIBZqazYCyAEgAyADKALMASABIBRqazYCzAEgAyADKALQASACIBNqazYC0AEgAyADKALUASAEIBJqazYC1AEgAyADKALYASAFIBFqazYC2AEgAyADKALcASAGIBBqazYC3AEgAyADKALgASAHIA9qazYC4AEgAyADKALkASAIIA5qazYC5AEgAyADKALoASAJIA1qazYC6AEgAyADKALsASAKIAxqazYC7AEgA0HgAmoQmAMgA0KjvcSA0AE3A4AEIANC7dOblsGm8/8SNwP4AyADQsvukbvhrJeNEjcD8AMgA0LDufbXoJSczxA3A+gDIANC6oOJ+4DrnqgJNwPgAyADQu7//6ehrP//FzcD2AMgA0Kr1f7/8f//+w83A9ADIAAgA0HQA2ogA0HgAmoQyQIgAEEDNgI4IANBgAFqEJgDIANCo73EgNABNwOABCADQu3Tm5bBpvP/EjcD+AMgA0LL7pG74ayXjRI3A/ADIANCw7n216CUnM8QNwPoAyADQuqDifuA656oCTcD4AMgA0Lu//+noaz//xc3A9gDIANCq9X+//H///sPNwPQAyAAQTxqIANB0ANqIANBgAFqEMkCIABBAjYCdCADQZAEaiQAC50DAQZ/IwBBQGoiAiQAIAJB6sYqNgIwIABB+YYqIAJBMGoQmwECQAJAIABBAUGU7SsQ3AEiAUUEQEHF1SkhBSAAQQEQyAEiAUUNASABKAIILQAAIgRB3wFNIARBoAFxQSBHcUUEQCACQQE2AhAgAEGJuSsgAkEQahBuCyABEJoBDAELIAEgASgC8AJBAWo2AvACIABBAhDOAiIEBH8gACABEOMCQQhqIAQoAgwQ+wJBAAVB0uErCyEFIAQQ0AIgASABKALwAiIDQQFrNgLwAiADQQFMBEBBpIg0KAIAIgMEQCACIAE2AjwCQAJAIAMoAgAiBiACKAI8Sw0AIAIoAjwgBiADKAIQak8NACABIAMoAgQ2AgAgAyABNgIEIAMgAygCCEEBajYCCCADKAIUIgNBBEkNASADQXxxIgNFDQEgAUEAIAP8CwAMAQsgARArCyAERQ0CDAMLIAEQKwsgBA0BCyACIAU2AgQgAkHqxio2AgAgAEH8iCogAhBsAAsgAkHqxio2AiAgAEHghyogAkEgahCbASACQUBrJABBAQuxjgIBnwF/IwBBwB5rIgIkAAJ/IAAQuAIEQEEBIABBPGoQuAINARoLQQALAn8gAEHwAWoiFhC4AgRAQQEgAEGsAmoQuAINARoLQQALcUUEQCACQbgXaiAAEOQCIAJBsBhqIABB+ABqIhcQ5AIgAkGoGWogFhDkAiACQbgXahCJAyACQfAAaiAAEOQCIAJB6AFqIBcQ5AIgAkHgAmogFhDkAiACIAIoAnA2AtgDIAIgAv0AAnT9CwLcAyACIAL9AAKEAf0LAuwDIAIgAv0AApQB/QsC/AMgAiAC/QACpAH9CwKMBCACIAL9AAK0Af0LApwEIAIgAv0AAsQB/QsCrAQgAiACKQLUATcCvAQgAiACKALcATYCxAQgAiACKALgATYCyAQgAiAC/QAC5AH9CwLMBCACIAL9AAL0Af0LAtwEIAIgAv0AAoQC/QsC7AQgAiAC/QAClAL9CwL8BCACIAL9AAKkAv0LAowFIAIgAv0AArQC/QsCnAUgAiACKQLEAjcCrAUgAiACKALMAjYCtAUgAiACKALQAjYCuAUgAiAC/QAC1AL9CwK8BSACIAL9AALkAv0LAswFIAIgAv0AAvQC/QsC3AUgAiAC/QAChAP9CwLsBSACIAL9AAKUA/0LAvwFIAIgAv0AAqQD/QsCjAYgAiACKQK0AzcCnAYgAiACKAK8AzYCpAYgAiACKALAAzYCqAYgAiACKALEAzYCrAYgAiACKALIAzYCsAYgAiACKALMAzYCtAYgAiACKALQAzYCuAYgAiACKALUAzYCvAYgAkHYA2ogAkG4F2oQ9AIgAiACKALYAzYCwAYgAiAC/QAC3AP9CwLEBiACIAL9AALsA/0LAtQGIAIgAv0AAvwD/QsC5AYgAiAC/QACjAT9CwL0BiACIAL9AAKcBP0LAoQHIAIgAv0AAqwE/QsClAcgAiACKQK8BDcCpAcgAiACKALEBDYCrAcgAiACKALIBDYCsAcgAiAC/QACzAT9CwK0ByACIAL9AALcBP0LAsQHIAIgAv0AAuwE/QsC1AcgAiAC/QAC/AT9CwLkByACIAL9AAKMBf0LAvQHIAIgAv0AApwF/QsChAggAiACKQKsBTcClAggAiACKAK0BTYCnAggAiACKAK4BTYCoAggAiAC/QACvAX9CwKkCCACIAL9AALMBf0LArQIIAIgAv0AAtwF/QsCxAggAiAC/QAC7AX9CwLUCCACIAL9AAL8Bf0LAuQIIAIgAv0AAowG/QsC9AggAiACKQKcBjcChAkgAiACKAKkBjYCjAkgAiACKAKoBjYCkAkgAiACKAKsBjYClAkgAiACKAKwBjYCmAkgAiACKAK0BjYCnAkgAiACKAK4BjYCoAkgAiACKAK8BjYCpAkgAkHABmogAkG4F2oQ9AIgAiACKALABjYCqAkgAiAC/QACxAb9CwKsCSACIAL9AALUBv0LArwJIAIgAv0AAuQG/QsCzAkgAiAC/QAC9Ab9CwLcCSACIAL9AAKEB/0LAuwJIAIgAv0AApQH/QsC/AkgAiACKQKkBzcCjAogAiACKAKsBzYClAogAiACKAKwBzYCmAogAiAC/QACtAf9CwKcCiACIAL9AALEB/0LAqwKIAIgAv0AAtQH/QsCvAogAiAC/QAC5Af9CwLMCiACIAL9AAL0B/0LAtwKIAIgAv0AAoQI/QsC7AogAiACKQKUCDcC/AogAiACKAKcCDYChAsgAiACKAKgCDYCiAsgAiAC/QACpAj9CwKMCyACIAL9AAK0CP0LApwLIAIgAv0AAsQI/QsCrAsgAiAC/QAC1Aj9CwK8CyACIAL9AALkCP0LAswLIAIgAv0AAvQI/QsC3AsgAiACKQKECTcC7AsgAiACKAKMCTYC9AsgAiACKAKQCTYC+AsgAiACKAKUCTYC/AsgAiACKAKYCTYCgAwgAiACKAKcCTYChAwgAiACKAKgCTYCiAwgAiACKAKkCTYCjAwgAkGoCWogAkG4F2oQ9AIgAiAC/QADqAn9CwSQDCACIAL9AAO4Cf0LBKAMIAIgAikDyAk3A7AMIAIgAv0AAuQJ/QsCzAwgAiAC/QAC9An9CwLcDCACIAL9AAKECv0LAuwMIAIgAv0AAtQJ/QsCvAwgAiAC/QAClAr9CwL8DCACIAL9AAKkCv0LAowNIAIgAikCtAo3ApwNIAIgAigCvAo2AqQNIAIgAigC0Ak2ArgMIAIgAigCwAo2AqgNIAIgAv0AAsQK/QsCrA0gAiAC/QAC1Ar9CwK8DSACIAL9AALkCv0LAswNIAIgAv0AAvQK/QsC3A0gAiAC/QAChAv9CwLsDSACIAL9AAKUC/0LAvwNIAIgAikCpAs3AowOIAIgAigCrAs2ApQOIAIgAigCsAs2ApgOIAIgAigCtAs2ApwOIAIgAigCuAs2AqAOIAIgAigCvAs2AqQOIAIgAigCwAs2AqgOIAIgAigCxAs2AqwOIAIgAigCyAs2ArAOIAIgAigCzAs2ArQOIAIgAigC0As2ArgOIAIgAigC1As2ArwOIAIgAigC2As2AsAOIAIgAigC3As2AsQOIAIgAigC4As2AsgOIAIgAigC5As2AswOIAIgAigC6As2AtAOIAIgAigC7As2AtQOIAIgAigC8As2AtgOIAIgAigC9As2AtwOIAIgAigC+As2AuAOIAIgAigC/As2AuQOIAIgAigCgAw2AugOIAIgAigChAw2AuwOIAIgAigCiAw2AvAOIAIgAigCjAw2AvQOIAJBkAxqIAJBuBdqEPQCIAIgAigCkAw2AvgOIAIgAigClAw2AvwOIAIgAigCmAw2AoAPIAIgAigCnAw2AoQPIAIgAigCoAw2AogPIAIgAigCpAw2AowPIAIgAigCqAw2ApAPIAIgAigCrAw2ApQPIAIgAigCsAw2ApgPIAIgAigCtAw2ApwPIAIgAigCuAw2AqAPIAIgAv0AArwM/QsCpA8gAiAC/QACzAz9CwK0DyACIAL9AALcDP0LAsQPIAIgAv0AAuwM/QsC1A8gAiAC/QAC/Az9CwLkDyACIAL9AAKMDf0LAvQPIAIgAikCnA03AoQQIAIgAigCpA02AowQIAIgAigCqA02ApAQIAIgAv0AAqwN/QsClBAgAiAC/QACvA39CwKkECACIAL9AALMDf0LArQQIAIgAv0AAtwN/QsCxBAgAiAC/QAC7A39CwLUECACIAL9AAL8Df0LAuQQIAIgAikCjA43AvQQIAIgAigClA42AvwQIAIgAigCmA42AoARIAIgAigCnA42AoQRIAIgAigCoA42AogRIAIgAigCpA42AowRIAIgAigCqA42ApARIAIgAigCrA42ApQRIAIgAigCsA42ApgRIAIgAigCtA42ApwRIAIgAigCuA42AqARIAIgAigCvA42AqQRIAIgAigCwA42AqgRIAIgAigCxA42AqwRIAIgAigCyA42ArARIAIgAigCzA42ArQRIAIgAigC0A42ArgRIAIgAigC1A42ArwRIAIgAigC2A42AsARIAIgAigC3A42AsQRIAIgAigC4A42AsgRIAIgAigC5A42AswRIAIgAigC6A42AtARIAIgAigC7A42AtQRIAIgAigC8A42AtgRIAIgAigC9A42AtwRIAJB+A5qIAJBuBdqEPQCIAIgAigC+A42AuARIAIgAigC/A42AuQRIAIgAigCgA82AugRIAIgAigChA82AuwRIAIgAigCiA82AvARIAIgAigCjA82AvQRIAIgAigCkA82AvgRIAIgAigClA82AvwRIAIgAigCmA82AoASIAIgAigCnA82AoQSIAIgAigCoA82AogSIAIgAv0AAqQP/QsCjBIgAiAC/QACtA/9CwKcEiACIAL9AALED/0LAqwSIAIgAv0AAtQP/QsCvBIgAiAC/QAC5A/9CwLMEiACIAL9AAL0D/0LAtwSIAIgAikChBA3AuwSIAIgAigCjBA2AvQSIAIgAigCkBA2AvgSIAIgAv0AApQQ/QsC/BIgAiAC/QACpBD9CwKMEyACIAL9AAK0EP0LApwTIAIgAv0AAsQQ/QsCrBMgAiAC/QAC1BD9CwK8EyACIAL9AALkEP0LAswTIAIgAikC9BA3AtwTIAIgAigC/BA2AuQTIAIgAigCgBE2AugTIAIgAigChBE2AuwTIAIgAigCiBE2AvATIAIgAigCjBE2AvQTIAIgAigCkBE2AvgTIAIgAigClBE2AvwTIAIgAigCmBE2AoAUIAIgAigCnBE2AoQUIAIgAigCoBE2AogUIAIgAigCpBE2AowUIAIgAigCqBE2ApAUIAIgAigCrBE2ApQUIAIgAigCsBE2ApgUIAIgAigCtBE2ApwUIAIgAigCuBE2AqAUIAIgAigCvBE2AqQUIAIgAigCwBE2AqgUIAIgAigCxBE2AqwUIAIgAigCyBE2ArAUIAIgAigCzBE2ArQUIAIgAigC0BE2ArgUIAIgAigC1BE2ArwUIAIgAigC2BE2AsAUIAIgAigC3BE2AsQUIAJB4BFqIAJBuBdqEPQCIAIgAigC4BE2AsgUIAIgAigC5BE2AswUIAIgAigC6BE2AtAUIAIgAigC7BE2AtQUIAIgAigC8BE2AtgUIAIgAigC9BE2AtwUIAIgAigC+BE2AuAUIAIgAigC/BE2AuQUIAIgAigCgBI2AugUIAIgAigChBI2AuwUIAIgAigCiBI2AvAUIAIgAv0AAowS/QsC9BQgAiAC/QACnBL9CwKEFSACIAL9AAKsEv0LApQVIAIgAv0AArwS/QsCpBUgAiAC/QACzBL9CwK0FSACIAL9AALcEv0LAsQVIAIgAikC7BI3AtQVIAIgAigC9BI2AtwVIAIgAigC+BI2AuAVIAIgAv0AAvwS/QsC5BUgAiAC/QACjBP9CwL0FSACIAL9AAKcE/0LAoQWIAIgAv0AAqwT/QsClBYgAiAC/QACvBP9CwKkFiACIAL9AALME/0LArQWIAIgAikC3BM3AsQWIAIgAigC5BM2AswWIAIgAigC6BM2AtAWIAIgAigC7BM2AtQWIAIgAigC8BM2AtgWIAIgAigC9BM2AtwWIAIgAigC+BM2AuAWIAIgAigC/BM2AuQWIAIgAigCgBQ2AugWIAIgAigChBQ2AuwWIAIgAigCiBQ2AvAWIAIgAigCjBQ2AvQWIAIgAigCkBQ2AvgWIAIgAigClBQ2AvwWIAIgAigCmBQ2AoAXIAIgAigCnBQ2AoQXIAIgAigCoBQ2AogXIAIgAigCpBQ2AowXIAIgAigCqBQ2ApAXIAIgAigCrBQ2ApQXIAIgAigCsBQ2ApgXIAIgAigCtBQ2ApwXIAIgAigCuBQ2AqAXIAIgAigCvBQ2AqQXIAIgAigCwBQ2AqgXIAIgAigCxBQ2AqwXIAJByBRqIAJBuBdqEPQCIAEoAjQhFSABKAIwIRQgASgCLCEQIAEoAighESABKAIkIQMgASgCICETIAEoAhwhEiABKAIYIQwgASgCFCEFIAEoAhAhDSABKAIMIQggASgCCCEJIAEoAgQhCiACIAEoAgAiC0H/////AXFBAWoiBkH/////AXEiB0EBaiIOIAZzQQAgC0ECb2siAXFB/////wFxIAdzIgc2AqAaIAIgCiALQR11aiIPQf////8BcSAGQR12aiIKQf////8BcSILIA5BHXZqIg4gCnMgAXFB/////wFxIAtzIgs2AqQaIAIgCSAPQR11aiIPQf////8BcSAKQR12aiIJQf////8BcSIKIA5BHXZqIg4gCXMgAXFB/////wFxIApzIgo2AqgaIAIgCCAPQR11aiIPQf////8BcSAJQR12aiIIQf////8BcSIJIA5BHXZqIg4gCHMgAXFB/////wFxIAlzIgk2AqwaIAIgDSAPQR11aiIPQf////8BcSAIQR12aiINQf////8BcSIIIA5BHXZqIg4gDXMgAXFB/////wFxIAhzIgg2ArAaIAIgBSAPQR11aiIPQf////8BcSANQR12aiIFQf////8BcSINIA5BHXZqIg4gBXMgAXFB/////wFxIA1zIg02ArQaIAIgDCAPQR11aiIPQf////8BcSAFQR12aiIMQf////8BcSIFIA5BHXZqIg4gDHMgAXFB/////wFxIAVzIgU2ArgaIAIgEiAPQR11aiIPQf////8BcSAMQR12aiIMQf////8BcSISIA5BHXZqIg4gDHMgAXFB/////wFxIBJzIhI2ArwaIAIgEyAPQR11aiIPQf////8BcSAMQR12aiIMQf////8BcSITIA5BHXZqIg4gDHMgAXFB/////wFxIBNzIhM2AsAaIAIgAyAPQR11aiIPQf////8BcSAMQR12aiIMQf////8BcSIDIA5BHXZqIg4gDHMgAXFB/////wFxIANzIgM2AsQaIAIgESAPQR11aiIPQf////8BcSAMQR12aiIMQf////8BcSIRIA5BHXZqIg4gDHMgAXFB/////wFxIBFzIhE2AsgaIAIgECAPQR11aiIPQf////8BcSAMQR12aiIMQf////8BcSIQIA5BHXZqIg4gDHMgAXFB/////wFxIBBzIhA2AswaIAIgFCAPQR11aiIPQf////8BcSAMQR12aiIMQf////8BcSIUIA5BHXZqIg4gDHMgAXFB/////wFxIBRzIhQ2AtAaIAIgFSAPQR11aiAMQR12aiIMIA5BHXZqIAxzIAFxIAxzIhU2AtQaIAJBACAGQQFxayIBIAIoArgXIgwgACgCAHNxIAxzNgK4FyACIAIoArwXIgYgACgCBHMgAXEgBnM2ArwXIAIgAigCwBciBiAAKAIIcyABcSAGczYCwBcgAiACKALEFyIGIAAoAgxzIAFxIAZzNgLEFyACIAIoAsgXIgYgACgCEHMgAXEgBnM2AsgXIAIgAigCzBciBiAAKAIUcyABcSAGczYCzBcgAiACKALQFyIGIAAoAhhzIAFxIAZzNgLQFyACIAIoAtQXIgYgACgCHHMgAXEgBnM2AtQXIAIgAigC2BciBiAAKAIgcyABcSAGczYC2BcgAiACKALcFyIGIAAoAiRzIAFxIAZzNgLcFyACIAIoAuAXIgYgACgCKHMgAXEgBnM2AuAXIAIgAigC5BciBiAAKAIscyABcSAGczYC5BcgAiACKALoFyIGIAAoAjBzIAFxIAZzNgLoFyACIAIoAuwXIgYgACgCNHMgAXEgBnM2AuwXIAIgAigC8BciBiAAKAI4cyABcSAGczYC8BcgAiACKAL0FyIGIAAoAjxzIAFxIAZzNgL0FyACIAIoAvgXIgYgACgCQHMgAXEgBnM2AvgXIAIgAigC/BciBiAAKAJEcyABcSAGczYC/BcgAiACKAKAGCIGIAAoAkhzIAFxIAZzNgKAGCACIAIoAoQYIgYgACgCTHMgAXEgBnM2AoQYIAIgAigCiBgiBiAAKAJQcyABcSAGczYCiBggAiACKAKMGCIGIAAoAlRzIAFxIAZzNgKMGCACIAIoApAYIgYgACgCWHMgAXEgBnM2ApAYIAIgAigClBgiBiAAKAJccyABcSAGczYClBggAiACKAKYGCIGIAAoAmBzIAFxIAZzNgKYGCACIAIoApwYIgYgACgCZHMgAXEgBnM2ApwYIAIgAigCoBgiBiAAKAJocyABcSAGczYCoBggAiACKAKkGCIGIAAoAmxzIAFxIAZzNgKkGCACIAIoAqgYIgYgACgCcHMgAXEgBnM2AqgYIAIgAigCrBgiBiAAKAJ0cyABcSAGczYCrBggAiACKAKwGCIGIAAoAnhzIAFxIAZzNgKwGCACIAIoArQYIgYgACgCfHMgAXEgBnM2ArQYIAIgAigCuBgiBiAAKAKAAXMgAXEgBnM2ArgYIAIgAigCvBgiBiAAKAKEAXMgAXEgBnM2ArwYIAIgAigCwBgiBiAAKAKIAXMgAXEgBnM2AsAYIAIgAigCxBgiBiAAKAKMAXMgAXEgBnM2AsQYIAIgAigCyBgiBiAAKAKQAXMgAXEgBnM2AsgYIAIgAigCzBgiBiAAKAKUAXMgAXEgBnM2AswYIAIgAigC0BgiBiAAKAKYAXMgAXEgBnM2AtAYIAIgAigC1BgiBiAAKAKcAXMgAXEgBnM2AtQYIAIgAigC2BgiBiAAKAKgAXMgAXEgBnM2AtgYIAIgAigC3BgiBiAAKAKkAXMgAXEgBnM2AtwYIAIgAigC4BgiBiAAKAKoAXMgAXEgBnM2AuAYIAIgAigC5BgiBiAAKAKsAXMgAXEgBnM2AuQYIAIgAigC6BgiBiAAKAKwAXMgAXEgBnM2AugYIAIgAigC7BgiBiAAKAK0AXMgAXEgBnM2AuwYIAIgAigC8BgiBiAAKAK4AXMgAXEgBnM2AvAYIAIgAigC9BgiBiAAKAK8AXMgAXEgBnM2AvQYIAIgAigC+BgiBiAAKALAAXMgAXEgBnM2AvgYIAIgAigC/BgiBiAAKALEAXMgAXEgBnM2AvwYIAIgAigCgBkiBiAAKALIAXMgAXEgBnM2AoAZIAIgAigChBkiBiAAKALMAXMgAXEgBnM2AoQZIAIgAigCiBkiBiAAKALQAXMgAXEgBnM2AogZIAIgAigCjBkiBiAAKALUAXMgAXEgBnM2AowZIAIgAigCkBkiBiAAKALYAXMgAXEgBnM2ApAZIAIgAigClBkiBiAAKALcAXMgAXEgBnM2ApQZIAIgAigCmBkiBiAAKALgAXMgAXEgBnM2ApgZIAIgAigCnBkiBiAAKALkAXMgAXEgBnM2ApwZIAIgAigCoBkiBiAAKALoAXMgAXEgBnM2AqAZIAIgAigCpBkiBiAAKALsAXMgAXEgBnM2AqQZIAIgAigCqBkiBiAAKALwAXMgAXEgBnM2AqgZIAIgAigCrBkiBiAAKAL0AXMgAXEgBnM2AqwZIAIgAigCsBkiBiAAKAL4AXMgAXEgBnM2ArAZIAIgAigCtBkiBiAAKAL8AXMgAXEgBnM2ArQZIAIgAigCuBkiBiAAKAKAAnMgAXEgBnM2ArgZIAIgAigCvBkiBiAAKAKEAnMgAXEgBnM2ArwZIAIgAigCwBkiBiAAKAKIAnMgAXEgBnM2AsAZIAIgAigCxBkiBiAAKAKMAnMgAXEgBnM2AsQZIAIgAigCyBkiBiAAKAKQAnMgAXEgBnM2AsgZIAIgAigCzBkiBiAAKAKUAnMgAXEgBnM2AswZIAIgAigC0BkiBiAAKAKYAnMgAXEgBnM2AtAZIAIgAigC1BkiBiAAKAKcAnMgAXEgBnM2AtQZIAIgAigC2BkiBiAAKAKgAnMgAXEgBnM2AtgZIAIgAigC3BkiBiAAKAKkAnMgAXEgBnM2AtwZIAIgAigC4BkiBiAAKAKoAnMgAXEgBnM2AuAZIAIgAigC5BkiBiAAKAKsAnMgAXEgBnM2AuQZIAIgAigC6BkiBiAAKAKwAnMgAXEgBnM2AugZIAIgAigC7BkiBiAAKAK0AnMgAXEgBnM2AuwZIAIgAigC8BkiBiAAKAK4AnMgAXEgBnM2AvAZIAIgAigC9BkiBiAAKAK8AnMgAXEgBnM2AvQZIAIgAigC+BkiBiAAKALAAnMgAXEgBnM2AvgZIAIgAigC/BkiBiAAKALEAnMgAXEgBnM2AvwZIAIgAigCgBoiBiAAKALIAnMgAXEgBnM2AoAaIAIgAigChBoiBiAAKALMAnMgAXEgBnM2AoQaIAIgAigCiBoiBiAAKALQAnMgAXEgBnM2AogaIAIgAigCjBoiBiAAKALUAnMgAXEgBnMiGzYCjBogAiACKAKQGiIGIAAoAtgCcyABcSAGcyIcNgKQGiACIAIoApQaIgYgACgC3AJzIAFxIAZzIh02ApQaIAIgAigCmBoiBiAAKALgAnMgAXEgBnMiHjYCmBogAiACKAKcGiIGIAAoAuQCcyABcSAGcyIfNgKcGiACKAKIGiEgIAIoAoQaISEgAigCgBohIiACKAL8GSEjIAIoAvgZISQgAigC9BkhJSACKALwGSEmIAIoAuwZIScgAigC6BkhKCACKALkGSEpIAIoAuAZISogAigC3BkhKyACKALYGSEsIAIoAtQZIS0gAigC0BkhLiACKALMGSEvIAIoAsgZITAgAigCxBkhMSACKALAGSEyIAIoArwZITMgAigCuBkhNCACKAK0GSE1IAIoArAZITYgAigCrBkhNyACKAKoGSE4IAIoAqQZITkgAigCoBkhOiACKAKcGSE7IAIoApgZITwgAigClBkhPSACKAKQGSE+IAIoAowZIT8gAigCiBkhQCACKAKEGSFBIAIoAoAZIUIgAigC/BghQyACKAL4GCFEIAIoAvQYIUUgAigC8BghRiACKALsGCFHIAIoAugYIUggAigC5BghSSACKALgGCFKIAIoAtwYIUsgAigC2BghTCACKALUGCFNIAIoAtAYIU4gAigCzBghTyACKALIGCFQIAIoAsQYIVEgAigCwBghUiACKAK8GCFTIAIoArgYIVQgAigCtBghVSACKAKwGCFWIAIoAqwYIVcgAigCqBghWCACKAKkGCFZIAIoAqAYIVogAigCnBghWyACKAKYGCFcIAIoApQYIV0gAigCkBghXiACKAKMGCFfIAIoAogYIWAgAigChBghYSACKAKAGCFiIAIoAvwXIWMgAigC+BchZCACKAL0FyFlIAIoAvAXIWYgAigC7BchZyACKALoFyFoIAIoAuQXIWkgAigC4BchaiACKALcFyFrIAIoAtgXIWwgAigC1BchbSACKALQFyFuIAIoAswXIW8gAigCyBchcCACKALEFyFxIAIoAsAXIXIgAigCvBchcyACKAK4FyF0IAJBoBpqELADIgFBA2pBBG0iDEEBaiEPIAFBekgiGEUEQCAMQQAgDEEAShshDgNAIAIgBGogB0EfcUEQayIBOgAAIAsgByABayIHQR11aiIBQRl0QYCAgPABcSAHQQR2Qf///w9xciEHIAogAUEddWoiBkEZdEGAgIDwAXEgAUEEdkH///8PcXIhCyAJIAZBHXVqIgFBGXRBgICA8AFxIAZBBHZB////D3FyIQogCCABQR11aiIGQRl0QYCAgPABcSABQQR2Qf///w9xciEJIA0gBkEddWoiAUEZdEGAgIDwAXEgBkEEdkH///8PcXIhCCAFIAFBHXVqIgZBGXRBgICA8AFxIAFBBHZB////D3FyIQ0gEiAGQR11aiIBQRl0QYCAgPABcSAGQQR2Qf///w9xciEFIBMgAUEddWoiBkEZdEGAgIDwAXEgAUEEdkH///8PcXIhEiADIAZBHXVqIgFBGXRBgICA8AFxIAZBBHZB////D3FyIRMgESABQR11aiIGQRl0QYCAgPABcSABQQR2Qf///w9xciEDIBAgBkEddWoiAUEZdEGAgIDwAXEgBkEEdkH///8PcXIhESAUIAFBHXVqIgZBGXRBgICA8AFxIAFBBHZB////D3FyIRAgFSAGQR11aiIBQRl0QYCAgPABcSAGQQR2Qf///w9xciEUIAFBBHUhFSAEIA5HIQEgBEEBaiEEIAENAAsgAiAVNgLUGiACIBQ2AtAaIAIgEDYCzBogAiARNgLIGiACIAM2AsQaIAIgEzYCwBogAiASNgK8GiACIAU2ArgaIAIgDTYCtBogAiAINgKwGiACIAk2AqwaIAIgCjYCqBogAiALNgKkGiACIAc2AqAaCyACIAc2AqAaIAIgD2ogB0EfcSIBOgAAIAIgFTYC1BogAiAUNgLQGiACIBA2AswaIAIgETYCyBogAiADNgLEGiACIBM2AsAaIAIgEjYCvBogAiAFNgK4GiACIA02ArQaIAIgCDYCsBogAiAJNgKsGiACIAo2AqgaIAIgCzYCpBogACACQfAAaiABQQFrQQJtQf//A3FB6AJsaiIBEOQCIBcgAUH4AGoQ5AIgFiABQfABahDkAiAYRQRAIAJBlBxqIXUgAkHYG2ohEiACQZAEaiF2IAJBzARqIXcgAkGIBWoheCACQcQFaiF5IAJBgAZqIXogAkG8BmoheyACQfgGaiF8IAJBtAdqIX0gAkHwB2ohfiACQawIaiF/IAJB6AhqIYABIAJBpAlqIYEBIAJB4AlqIYIBIAJBnApqIYMBIAJB2ApqIYQBIAJBlAtqIYUBIAJB0AtqIYYBIAJBjAxqIYcBIAJByAxqIYgBIAJBhA1qIYkBIAJBwA1qIYoBIAJB/A1qIYsBIAJBuA5qIYwBIAJB9A5qIY0BIAJBsA9qIY4BIAJB7A9qIY8BIAJBqBBqIZABIAJB5BBqIZEBIAJBoBFqIZIBIAJB3BFqIZMBIAJBmBJqIZQBIAJB1BJqIZUBIAJBkBNqIZYBIAJBzBNqIZcBIAJBiBRqIZgBIAJBxBRqIZkBIAJBgBVqIZoBIAJBvBVqIZsBIAJB+BVqIZwBIAJBtBZqIZ0BIAJB8BZqIZ4BIAJBrBdqIZ8BA0AgAiACIAxqLAAAIhNBH3UiASATcyABQX9zaiIGQQJtIg1BAWtBH3UiBCACKAK4FyIHIAIoAnBzcSAHczYCuBcgAiACKAK8FyIHIAIoAnRzIARxIAdzNgK8FyACIAIoAsAXIgcgAigCeHMgBHEgB3M2AsAXIAIgAigCxBciByACKAJ8cyAEcSAHczYCxBcgAiACKALIFyIHIAIoAoABcyAEcSAHczYCyBcgAiACKALMFyIHIAIoAoQBcyAEcSAHczYCzBcgAiACKALQFyIHIAIoAogBcyAEcSAHczYC0BcgAiACKALUFyIHIAIoAowBcyAEcSAHczYC1BcgAiACKALYFyIHIAIoApABcyAEcSAHczYC2BcgAiACKALcFyIHIAIoApQBcyAEcSAHczYC3BcgAiACKALgFyIHIAIoApgBcyAEcSAHczYC4BcgAiACKALkFyIHIAIoApwBcyAEcSAHczYC5BcgAiACKALoFyIHIAIoAqABcyAEcSAHczYC6BcgAiACKALsFyIHIAIoAqQBcyAEcSAHczYC7BcgAiACQagBaiACQfAXaiIHIAZBAkgiBRsoAgA2AvAXIAIgAigC9BciBiACKAKsAXMgBHEgBnM2AvQXIAIgAigC+BciBiACKAKwAXMgBHEgBnM2AvgXIAIgAigC/BciBiACKAK0AXMgBHEgBnM2AvwXIAIgAigCgBgiBiACKAK4AXMgBHEgBnM2AoAYIAIgAigChBgiBiACKAK8AXMgBHEgBnM2AoQYIAIgAigCiBgiBiACKALAAXMgBHEgBnM2AogYIAIgAigCjBgiBiACKALEAXMgBHEgBnM2AowYIAIgAigCkBgiBiACKALIAXMgBHEgBnM2ApAYIAIgAigClBgiBiACKALMAXMgBHEgBnM2ApQYIAIgAigCmBgiBiACKALQAXMgBHEgBnM2ApgYIAIgAigCnBgiBiACKALUAXMgBHEgBnM2ApwYIAIgAigCoBgiBiACKALYAXMgBHEgBnM2AqAYIAIgAigCpBgiBiACKALcAXMgBHEgBnM2AqQYIAIgAigCqBgiBiACKALgAXMgBHEgBnM2AqgYIAIgAkHkAWogAkGsGGoiBiAFGygCADYCrBggAiACKAKwGCILIAIoAugBcyAEcSALczYCsBggAiACKAK0GCILIAIoAuwBcyAEcSALczYCtBggAiACKAK4GCILIAIoAvABcyAEcSALczYCuBggAiACKAK8GCILIAIoAvQBcyAEcSALczYCvBggAiACKALAGCILIAIoAvgBcyAEcSALczYCwBggAiACKALEGCILIAIoAvwBcyAEcSALczYCxBggAiACKALIGCILIAIoAoACcyAEcSALczYCyBggAiACKALMGCILIAIoAoQCcyAEcSALczYCzBggAiACKALQGCILIAIoAogCcyAEcSALczYC0BggAiACKALUGCILIAIoAowCcyAEcSALczYC1BggAiACKALYGCILIAIoApACcyAEcSALczYC2BggAiACKALcGCILIAIoApQCcyAEcSALczYC3BggAiACKALgGCILIAIoApgCcyAEcSALczYC4BggAiACKALkGCILIAIoApwCcyAEcSALczYC5BggAiACQaACaiACQegYaiILIAUbKAIANgLoGCACIAIoAuwYIgogAigCpAJzIARxIApzNgLsGCACIAIoAvAYIgogAigCqAJzIARxIApzNgLwGCACIAIoAvQYIgogAigCrAJzIARxIApzNgL0GCACIAIoAvgYIgogAigCsAJzIARxIApzNgL4GCACIAIoAvwYIgogAigCtAJzIARxIApzNgL8GCACIAIoAoAZIgogAigCuAJzIARxIApzNgKAGSACIAIoAoQZIgogAigCvAJzIARxIApzNgKEGSACIAIoAogZIgogAigCwAJzIARxIApzNgKIGSACIAIoAowZIgogAigCxAJzIARxIApzNgKMGSACIAIoApAZIgogAigCyAJzIARxIApzNgKQGSACIAIoApQZIgogAigCzAJzIARxIApzNgKUGSACIAIoApgZIgogAigC0AJzIARxIApzNgKYGSACIAIoApwZIgogAigC1AJzIARxIApzNgKcGSACIAIoAqAZIgogAigC2AJzIARxIApzNgKgGSACIAJB3AJqIAJBpBlqIgogBRsoAgA2AqQZIAIgAigCqBkiCSACKALgAnMgBHEgCXM2AqgZIAIgAigCrBkiCSACKALkAnMgBHEgCXM2AqwZIAIgAigCsBkiCSACKALoAnMgBHEgCXM2ArAZIAIgAigCtBkiCSACKALsAnMgBHEgCXM2ArQZIAIgAigCuBkiCSACKALwAnMgBHEgCXM2ArgZIAIgAigCvBkiCSACKAL0AnMgBHEgCXM2ArwZIAIgAigCwBkiCSACKAL4AnMgBHEgCXM2AsAZIAIgAigCxBkiCSACKAL8AnMgBHEgCXM2AsQZIAIgAigCyBkiCSACKAKAA3MgBHEgCXM2AsgZIAIgAigCzBkiCSACKAKEA3MgBHEgCXM2AswZIAIgAigC0BkiCSACKAKIA3MgBHEgCXM2AtAZIAIgAigC1BkiCSACKAKMA3MgBHEgCXM2AtQZIAIgAigC2BkiCSACKAKQA3MgBHEgCXM2AtgZIAIgAigC3BkiCSACKAKUA3MgBHEgCXM2AtwZIAIgAkGYA2ogAkHgGWoiCSAFGygCADYC4BkgAiACKALkGSIIIAIoApwDcyAEcSAIczYC5BkgAiACKALoGSIIIAIoAqADcyAEcSAIczYC6BkgAiACKALsGSIIIAIoAqQDcyAEcSAIczYC7BkgAiACKALwGSIIIAIoAqgDcyAEcSAIczYC8BkgAiACKAL0GSIIIAIoAqwDcyAEcSAIczYC9BkgAiACKAL4GSIIIAIoArADcyAEcSAIczYC+BkgAiACKAL8GSIIIAIoArQDcyAEcSAIczYC/BkgAiACKAKAGiIIIAIoArgDcyAEcSAIczYCgBogAiACKAKEGiIIIAIoArwDcyAEcSAIczYChBogAiACKAKIGiIIIAIoAsADcyAEcSAIczYCiBogAiACKAKMGiIIIAIoAsQDcyAEcSAIczYCjBogAiACKAKQGiIIIAIoAsgDcyAEcSAIczYCkBogAiACKAKUGiIIIAIoAswDcyAEcSAIczYClBogAiACKAKYGiIIIAIoAtADcyAEcSAIczYCmBogAiACQdQDaiACQZwaaiIIIAUbKAIANgKcGiACIA1BAXMiA0EBa0EfdSIEIAIoArgXIgUgAigC2ANzcSAFczYCuBcgAiACKAK8FyIFIAIoAtwDcyAEcSAFczYCvBcgAiACKALAFyIFIAIoAuADcyAEcSAFczYCwBcgAiACKALEFyIFIAIoAuQDcyAEcSAFczYCxBcgAiACKALIFyIFIAIoAugDcyAEcSAFczYCyBcgAiACKALMFyIFIAIoAuwDcyAEcSAFczYCzBcgAiACKALQFyIFIAIoAvADcyAEcSAFczYC0BcgAiACKALUFyIFIAIoAvQDcyAEcSAFczYC1BcgAiACKALYFyIFIAIoAvgDcyAEcSAFczYC2BcgAiACKALcFyIFIAIoAvwDcyAEcSAFczYC3BcgAiACKALgFyIFIAIoAoAEcyAEcSAFczYC4BcgAiACKALkFyIFIAIoAoQEcyAEcSAFczYC5BcgAiACKALoFyIFIAIoAogEcyAEcSAFczYC6BcgAiACKALsFyIFIAIoAowEcyAEcSAFczYC7BcgAiAHIHYgA0EASiIFGygCADYC8BcgAiACKAL0FyIDIAIoApQEcyAEcSADczYC9BcgAiACKAL4FyIDIAIoApgEcyAEcSADczYC+BcgAiACKAL8FyIDIAIoApwEcyAEcSADczYC/BcgAiACKAKAGCIDIAIoAqAEcyAEcSADczYCgBggAiACKAKEGCIDIAIoAqQEcyAEcSADczYChBggAiACKAKIGCIDIAIoAqgEcyAEcSADczYCiBggAiACKAKMGCIDIAIoAqwEcyAEcSADczYCjBggAiACKAKQGCIDIAIoArAEcyAEcSADczYCkBggAiACKAKUGCIDIAIoArQEcyAEcSADczYClBggAiACKAKYGCIDIAIoArgEcyAEcSADczYCmBggAiACKAKcGCIDIAIoArwEcyAEcSADczYCnBggAiACKAKgGCIDIAIoAsAEcyAEcSADczYCoBggAiACKAKkGCIDIAIoAsQEcyAEcSADczYCpBggAiACKAKoGCIDIAIoAsgEcyAEcSADczYCqBggAiAGIHcgBRsoAgA2AqwYIAIgAigCsBgiAyACKALQBHMgBHEgA3M2ArAYIAIgAigCtBgiAyACKALUBHMgBHEgA3M2ArQYIAIgAigCuBgiAyACKALYBHMgBHEgA3M2ArgYIAIgAigCvBgiAyACKALcBHMgBHEgA3M2ArwYIAIgAigCwBgiAyACKALgBHMgBHEgA3M2AsAYIAIgAigCxBgiAyACKALkBHMgBHEgA3M2AsQYIAIgAigCyBgiAyACKALoBHMgBHEgA3M2AsgYIAIgAigCzBgiAyACKALsBHMgBHEgA3M2AswYIAIgAigC0BgiAyACKALwBHMgBHEgA3M2AtAYIAIgAigC1BgiAyACKAL0BHMgBHEgA3M2AtQYIAIgAigC2BgiAyACKAL4BHMgBHEgA3M2AtgYIAIgAigC3BgiAyACKAL8BHMgBHEgA3M2AtwYIAIgAigC4BgiAyACKAKABXMgBHEgA3M2AuAYIAIgAigC5BgiAyACKAKEBXMgBHEgA3M2AuQYIAIgCyB4IAUbKAIANgLoGCACIAIoAuwYIgMgAigCjAVzIARxIANzNgLsGCACIAIoAvAYIgMgAigCkAVzIARxIANzNgLwGCACIAIoAvQYIgMgAigClAVzIARxIANzNgL0GCACIAIoAvgYIgMgAigCmAVzIARxIANzNgL4GCACIAIoAvwYIgMgAigCnAVzIARxIANzNgL8GCACIAIoAoAZIgMgAigCoAVzIARxIANzNgKAGSACIAIoAoQZIgMgAigCpAVzIARxIANzNgKEGSACIAIoAogZIgMgAigCqAVzIARxIANzNgKIGSACIAIoAowZIgMgAigCrAVzIARxIANzNgKMGSACIAIoApAZIgMgAigCsAVzIARxIANzNgKQGSACIAIoApQZIgMgAigCtAVzIARxIANzNgKUGSACIAIoApgZIgMgAigCuAVzIARxIANzNgKYGSACIAIoApwZIgMgAigCvAVzIARxIANzNgKcGSACIAIoAqAZIgMgAigCwAVzIARxIANzNgKgGSACIAogeSAFGygCADYCpBkgAiACKAKoGSIDIAIoAsgFcyAEcSADczYCqBkgAiACKAKsGSIDIAIoAswFcyAEcSADczYCrBkgAiACKAKwGSIDIAIoAtAFcyAEcSADczYCsBkgAiACKAK0GSIDIAIoAtQFcyAEcSADczYCtBkgAiACKAK4GSIDIAIoAtgFcyAEcSADczYCuBkgAiACKAK8GSIDIAIoAtwFcyAEcSADczYCvBkgAiACKALAGSIDIAIoAuAFcyAEcSADczYCwBkgAiACKALEGSIDIAIoAuQFcyAEcSADczYCxBkgAiACKALIGSIDIAIoAugFcyAEcSADczYCyBkgAiACKALMGSIDIAIoAuwFcyAEcSADczYCzBkgAiACKALQGSIDIAIoAvAFcyAEcSADczYC0BkgAiACKALUGSIDIAIoAvQFcyAEcSADczYC1BkgAiACKALYGSIDIAIoAvgFcyAEcSADczYC2BkgAiACKALcGSIDIAIoAvwFcyAEcSADczYC3BkgAiAJIHogBRsoAgA2AuAZIAIgAigC5BkiAyACKAKEBnMgBHEgA3M2AuQZIAIgAigC6BkiAyACKAKIBnMgBHEgA3M2AugZIAIgAigC7BkiAyACKAKMBnMgBHEgA3M2AuwZIAIgAigC8BkiAyACKAKQBnMgBHEgA3M2AvAZIAIgAigC9BkiAyACKAKUBnMgBHEgA3M2AvQZIAIgAigC+BkiAyACKAKYBnMgBHEgA3M2AvgZIAIgAigC/BkiAyACKAKcBnMgBHEgA3M2AvwZIAIgAigCgBoiAyACKAKgBnMgBHEgA3M2AoAaIAIgAigChBoiAyACKAKkBnMgBHEgA3M2AoQaIAIgAigCiBoiAyACKAKoBnMgBHEgA3M2AogaIAIgAigCjBoiAyACKAKsBnMgBHEgA3M2AowaIAIgAigCkBoiAyACKAKwBnMgBHEgA3M2ApAaIAIgAigClBoiAyACKAK0BnMgBHEgA3M2ApQaIAIgAigCmBoiAyACKAK4BnMgBHEgA3M2ApgaIAIgCCB7IAUbKAIANgKcGiACIA1BAnMiA0EBa0EfdSIEIAIoArgXIgUgAigCwAZzcSAFczYCuBcgAiACKAK8FyIFIAIoAsQGcyAEcSAFczYCvBcgAiACKALAFyIFIAIoAsgGcyAEcSAFczYCwBcgAiACKALEFyIFIAIoAswGcyAEcSAFczYCxBcgAiACKALIFyIFIAIoAtAGcyAEcSAFczYCyBcgAiACKALMFyIFIAIoAtQGcyAEcSAFczYCzBcgAiACKALQFyIFIAIoAtgGcyAEcSAFczYC0BcgAiACKALUFyIFIAIoAtwGcyAEcSAFczYC1BcgAiACKALYFyIFIAIoAuAGcyAEcSAFczYC2BcgAiACKALcFyIFIAIoAuQGcyAEcSAFczYC3BcgAiACKALgFyIFIAIoAugGcyAEcSAFczYC4BcgAiACKALkFyIFIAIoAuwGcyAEcSAFczYC5BcgAiACKALoFyIFIAIoAvAGcyAEcSAFczYC6BcgAiACKALsFyIFIAIoAvQGcyAEcSAFczYC7BcgAiAHIHwgA0EASiIFGygCADYC8BcgAiACKAL0FyIDIAIoAvwGcyAEcSADczYC9BcgAiACKAL4FyIDIAIoAoAHcyAEcSADczYC+BcgAiACKAL8FyIDIAIoAoQHcyAEcSADczYC/BcgAiACKAKAGCIDIAIoAogHcyAEcSADczYCgBggAiACKAKEGCIDIAIoAowHcyAEcSADczYChBggAiACKAKIGCIDIAIoApAHcyAEcSADczYCiBggAiACKAKMGCIDIAIoApQHcyAEcSADczYCjBggAiACKAKQGCIDIAIoApgHcyAEcSADczYCkBggAiACKAKUGCIDIAIoApwHcyAEcSADczYClBggAiACKAKYGCIDIAIoAqAHcyAEcSADczYCmBggAiACKAKcGCIDIAIoAqQHcyAEcSADczYCnBggAiACKAKgGCIDIAIoAqgHcyAEcSADczYCoBggAiACKAKkGCIDIAIoAqwHcyAEcSADczYCpBggAiACKAKoGCIDIAIoArAHcyAEcSADczYCqBggAiAGIH0gBRsoAgA2AqwYIAIgAigCsBgiAyACKAK4B3MgBHEgA3M2ArAYIAIgAigCtBgiAyACKAK8B3MgBHEgA3M2ArQYIAIgAigCuBgiAyACKALAB3MgBHEgA3M2ArgYIAIgAigCvBgiAyACKALEB3MgBHEgA3M2ArwYIAIgAigCwBgiAyACKALIB3MgBHEgA3M2AsAYIAIgAigCxBgiAyACKALMB3MgBHEgA3M2AsQYIAIgAigCyBgiAyACKALQB3MgBHEgA3M2AsgYIAIgAigCzBgiAyACKALUB3MgBHEgA3M2AswYIAIgAigC0BgiAyACKALYB3MgBHEgA3M2AtAYIAIgAigC1BgiAyACKALcB3MgBHEgA3M2AtQYIAIgAigC2BgiAyACKALgB3MgBHEgA3M2AtgYIAIgAigC3BgiAyACKALkB3MgBHEgA3M2AtwYIAIgAigC4BgiAyACKALoB3MgBHEgA3M2AuAYIAIgAigC5BgiAyACKALsB3MgBHEgA3M2AuQYIAIgCyB+IAUbKAIANgLoGCACIAIoAuwYIgMgAigC9AdzIARxIANzNgLsGCACIAIoAvAYIgMgAigC+AdzIARxIANzNgLwGCACIAIoAvQYIgMgAigC/AdzIARxIANzNgL0GCACIAIoAvgYIgMgAigCgAhzIARxIANzNgL4GCACIAIoAvwYIgMgAigChAhzIARxIANzNgL8GCACIAIoAoAZIgMgAigCiAhzIARxIANzNgKAGSACIAIoAoQZIgMgAigCjAhzIARxIANzNgKEGSACIAIoAogZIgMgAigCkAhzIARxIANzNgKIGSACIAIoAowZIgMgAigClAhzIARxIANzNgKMGSACIAIoApAZIgMgAigCmAhzIARxIANzNgKQGSACIAIoApQZIgMgAigCnAhzIARxIANzNgKUGSACIAIoApgZIgMgAigCoAhzIARxIANzNgKYGSACIAIoApwZIgMgAigCpAhzIARxIANzNgKcGSACIAIoAqAZIgMgAigCqAhzIARxIANzNgKgGSACIAogfyAFGygCADYCpBkgAiACKAKoGSIDIAIoArAIcyAEcSADczYCqBkgAiACKAKsGSIDIAIoArQIcyAEcSADczYCrBkgAiACKAKwGSIDIAIoArgIcyAEcSADczYCsBkgAiACKAK0GSIDIAIoArwIcyAEcSADczYCtBkgAiACKAK4GSIDIAIoAsAIcyAEcSADczYCuBkgAiACKAK8GSIDIAIoAsQIcyAEcSADczYCvBkgAiACKALAGSIDIAIoAsgIcyAEcSADczYCwBkgAiACKALEGSIDIAIoAswIcyAEcSADczYCxBkgAiACKALIGSIDIAIoAtAIcyAEcSADczYCyBkgAiACKALMGSIDIAIoAtQIcyAEcSADczYCzBkgAiACKALQGSIDIAIoAtgIcyAEcSADczYC0BkgAiACKALUGSIDIAIoAtwIcyAEcSADczYC1BkgAiACKALYGSIDIAIoAuAIcyAEcSADczYC2BkgAiACKALcGSIDIAIoAuQIcyAEcSADczYC3BkgAiAJIIABIAUbKAIANgLgGSACIAIoAuQZIgMgAigC7AhzIARxIANzNgLkGSACIAIoAugZIgMgAigC8AhzIARxIANzNgLoGSACIAIoAuwZIgMgAigC9AhzIARxIANzNgLsGSACIAIoAvAZIgMgAigC+AhzIARxIANzNgLwGSACIAIoAvQZIgMgAigC/AhzIARxIANzNgL0GSACIAIoAvgZIgMgAigCgAlzIARxIANzNgL4GSACIAIoAvwZIgMgAigChAlzIARxIANzNgL8GSACIAIoAoAaIgMgAigCiAlzIARxIANzNgKAGiACIAIoAoQaIgMgAigCjAlzIARxIANzNgKEGiACIAIoAogaIgMgAigCkAlzIARxIANzNgKIGiACIAIoAowaIgMgAigClAlzIARxIANzNgKMGiACIAIoApAaIgMgAigCmAlzIARxIANzNgKQGiACIAIoApQaIgMgAigCnAlzIARxIANzNgKUGiACIAIoApgaIgMgAigCoAlzIARxIANzNgKYGiACIAgggQEgBRsoAgA2ApwaIAIgDUEDcyIDQQFrQR91IgQgAigCuBciBSACKAKoCXNxIAVzNgK4FyACIAIoArwXIgUgAigCrAlzIARxIAVzNgK8FyACIAIoAsAXIgUgAigCsAlzIARxIAVzNgLAFyACIAIoAsQXIgUgAigCtAlzIARxIAVzNgLEFyACIAIoAsgXIgUgAigCuAlzIARxIAVzNgLIFyACIAIoAswXIgUgAigCvAlzIARxIAVzNgLMFyACIAIoAtAXIgUgAigCwAlzIARxIAVzNgLQFyACIAIoAtQXIgUgAigCxAlzIARxIAVzNgLUFyACIAIoAtgXIgUgAigCyAlzIARxIAVzNgLYFyACIAIoAtwXIgUgAigCzAlzIARxIAVzNgLcFyACIAIoAuAXIgUgAigC0AlzIARxIAVzNgLgFyACIAIoAuQXIgUgAigC1AlzIARxIAVzNgLkFyACIAIoAugXIgUgAigC2AlzIARxIAVzNgLoFyACIAIoAuwXIgUgAigC3AlzIARxIAVzNgLsFyACIAcgggEgA0EASiIFGygCADYC8BcgAiACKAL0FyIDIAIoAuQJcyAEcSADczYC9BcgAiACKAL4FyIDIAIoAugJcyAEcSADczYC+BcgAiACKAL8FyIDIAIoAuwJcyAEcSADczYC/BcgAiACKAKAGCIDIAIoAvAJcyAEcSADczYCgBggAiACKAKEGCIDIAIoAvQJcyAEcSADczYChBggAiACKAKIGCIDIAIoAvgJcyAEcSADczYCiBggAiACKAKMGCIDIAIoAvwJcyAEcSADczYCjBggAiACKAKQGCIDIAIoAoAKcyAEcSADczYCkBggAiACKAKUGCIDIAIoAoQKcyAEcSADczYClBggAiACKAKYGCIDIAIoAogKcyAEcSADczYCmBggAiACKAKcGCIDIAIoAowKcyAEcSADczYCnBggAiACKAKgGCIDIAIoApAKcyAEcSADczYCoBggAiACKAKkGCIDIAIoApQKcyAEcSADczYCpBggAiACKAKoGCIDIAIoApgKcyAEcSADczYCqBggAiAGIIMBIAUbKAIANgKsGCACIAIoArAYIgMgAigCoApzIARxIANzNgKwGCACIAIoArQYIgMgAigCpApzIARxIANzNgK0GCACIAIoArgYIgMgAigCqApzIARxIANzNgK4GCACIAIoArwYIgMgAigCrApzIARxIANzNgK8GCACIAIoAsAYIgMgAigCsApzIARxIANzNgLAGCACIAIoAsQYIgMgAigCtApzIARxIANzNgLEGCACIAIoAsgYIgMgAigCuApzIARxIANzNgLIGCACIAIoAswYIgMgAigCvApzIARxIANzNgLMGCACIAIoAtAYIgMgAigCwApzIARxIANzNgLQGCACIAIoAtQYIgMgAigCxApzIARxIANzNgLUGCACIAIoAtgYIgMgAigCyApzIARxIANzNgLYGCACIAIoAtwYIgMgAigCzApzIARxIANzNgLcGCACIAIoAuAYIgMgAigC0ApzIARxIANzNgLgGCACIAIoAuQYIgMgAigC1ApzIARxIANzNgLkGCACIAsghAEgBRsoAgA2AugYIAIgAigC7BgiAyACKALcCnMgBHEgA3M2AuwYIAIgAigC8BgiAyACKALgCnMgBHEgA3M2AvAYIAIgAigC9BgiAyACKALkCnMgBHEgA3M2AvQYIAIgAigC+BgiAyACKALoCnMgBHEgA3M2AvgYIAIgAigC/BgiAyACKALsCnMgBHEgA3M2AvwYIAIgAigCgBkiAyACKALwCnMgBHEgA3M2AoAZIAIgAigChBkiAyACKAL0CnMgBHEgA3M2AoQZIAIgAigCiBkiAyACKAL4CnMgBHEgA3M2AogZIAIgAigCjBkiAyACKAL8CnMgBHEgA3M2AowZIAIgAigCkBkiAyACKAKAC3MgBHEgA3M2ApAZIAIgAigClBkiAyACKAKEC3MgBHEgA3M2ApQZIAIgAigCmBkiAyACKAKIC3MgBHEgA3M2ApgZIAIgAigCnBkiAyACKAKMC3MgBHEgA3M2ApwZIAIgAigCoBkiAyACKAKQC3MgBHEgA3M2AqAZIAIgCiCFASAFGygCADYCpBkgAiACKAKoGSIDIAIoApgLcyAEcSADczYCqBkgAiACKAKsGSIDIAIoApwLcyAEcSADczYCrBkgAiACKAKwGSIDIAIoAqALcyAEcSADczYCsBkgAiACKAK0GSIDIAIoAqQLcyAEcSADczYCtBkgAiACKAK4GSIDIAIoAqgLcyAEcSADczYCuBkgAiACKAK8GSIDIAIoAqwLcyAEcSADczYCvBkgAiACKALAGSIDIAIoArALcyAEcSADczYCwBkgAiACKALEGSIDIAIoArQLcyAEcSADczYCxBkgAiACKALIGSIDIAIoArgLcyAEcSADczYCyBkgAiACKALMGSIDIAIoArwLcyAEcSADczYCzBkgAiACKALQGSIDIAIoAsALcyAEcSADczYC0BkgAiACKALUGSIDIAIoAsQLcyAEcSADczYC1BkgAiACKALYGSIDIAIoAsgLcyAEcSADczYC2BkgAiACKALcGSIDIAIoAswLcyAEcSADczYC3BkgAiAJIIYBIAUbKAIANgLgGSACIAIoAuQZIgMgAigC1AtzIARxIANzNgLkGSACIAIoAugZIgMgAigC2AtzIARxIANzNgLoGSACIAIoAuwZIgMgAigC3AtzIARxIANzNgLsGSACIAIoAvAZIgMgAigC4AtzIARxIANzNgLwGSACIAIoAvQZIgMgAigC5AtzIARxIANzNgL0GSACIAIoAvgZIgMgAigC6AtzIARxIANzNgL4GSACIAIoAvwZIgMgAigC7AtzIARxIANzNgL8GSACIAIoAoAaIgMgAigC8AtzIARxIANzNgKAGiACIAIoAoQaIgMgAigC9AtzIARxIANzNgKEGiACIAIoAogaIgMgAigC+AtzIARxIANzNgKIGiACIAIoAowaIgMgAigC/AtzIARxIANzNgKMGiACIAIoApAaIgMgAigCgAxzIARxIANzNgKQGiACIAIoApQaIgMgAigChAxzIARxIANzNgKUGiACIAIoApgaIgMgAigCiAxzIARxIANzNgKYGiACIAgghwEgBRsoAgA2ApwaIAIgDUEEcyIDQQFrQR91IgQgAigCuBciBSACKAKQDHNxIAVzNgK4FyACIAIoArwXIgUgAigClAxzIARxIAVzNgK8FyACIAIoAsAXIgUgAigCmAxzIARxIAVzNgLAFyACIAIoAsQXIgUgAigCnAxzIARxIAVzNgLEFyACIAIoAsgXIgUgAigCoAxzIARxIAVzNgLIFyACIAIoAswXIgUgAigCpAxzIARxIAVzNgLMFyACIAIoAtAXIgUgAigCqAxzIARxIAVzNgLQFyACIAIoAtQXIgUgAigCrAxzIARxIAVzNgLUFyACIAIoAtgXIgUgAigCsAxzIARxIAVzNgLYFyACIAIoAtwXIgUgAigCtAxzIARxIAVzNgLcFyACIAIoAuAXIgUgAigCuAxzIARxIAVzNgLgFyACIAIoAuQXIgUgAigCvAxzIARxIAVzNgLkFyACIAIoAugXIgUgAigCwAxzIARxIAVzNgLoFyACIAIoAuwXIgUgAigCxAxzIARxIAVzNgLsFyACIAcgiAEgA0EASiIFGygCADYC8BcgAiACKAL0FyIDIAIoAswMcyAEcSADczYC9BcgAiACKAL4FyIDIAIoAtAMcyAEcSADczYC+BcgAiACKAL8FyIDIAIoAtQMcyAEcSADczYC/BcgAiACKAKAGCIDIAIoAtgMcyAEcSADczYCgBggAiACKAKEGCIDIAIoAtwMcyAEcSADczYChBggAiACKAKIGCIDIAIoAuAMcyAEcSADczYCiBggAiACKAKMGCIDIAIoAuQMcyAEcSADczYCjBggAiACKAKQGCIDIAIoAugMcyAEcSADczYCkBggAiACKAKUGCIDIAIoAuwMcyAEcSADczYClBggAiACKAKYGCIDIAIoAvAMcyAEcSADczYCmBggAiACKAKcGCIDIAIoAvQMcyAEcSADczYCnBggAiACKAKgGCIDIAIoAvgMcyAEcSADczYCoBggAiACKAKkGCIDIAIoAvwMcyAEcSADczYCpBggAiACKAKoGCIDIAIoAoANcyAEcSADczYCqBggAiAGIIkBIAUbKAIANgKsGCACIAIoArAYIgMgAigCiA1zIARxIANzNgKwGCACIAIoArQYIgMgAigCjA1zIARxIANzNgK0GCACIAIoArgYIgMgAigCkA1zIARxIANzNgK4GCACIAIoArwYIgMgAigClA1zIARxIANzNgK8GCACIAIoAsAYIgMgAigCmA1zIARxIANzNgLAGCACIAIoAsQYIgMgAigCnA1zIARxIANzNgLEGCACIAIoAsgYIgMgAigCoA1zIARxIANzNgLIGCACIAIoAswYIgMgAigCpA1zIARxIANzNgLMGCACIAIoAtAYIgMgAigCqA1zIARxIANzNgLQGCACIAIoAtQYIgMgAigCrA1zIARxIANzNgLUGCACIAIoAtgYIgMgAigCsA1zIARxIANzNgLYGCACIAIoAtwYIgMgAigCtA1zIARxIANzNgLcGCACIAIoAuAYIgMgAigCuA1zIARxIANzNgLgGCACIAIoAuQYIgMgAigCvA1zIARxIANzNgLkGCACIAsgigEgBRsoAgA2AugYIAIgAigC7BgiAyACKALEDXMgBHEgA3M2AuwYIAIgAigC8BgiAyACKALIDXMgBHEgA3M2AvAYIAIgAigC9BgiAyACKALMDXMgBHEgA3M2AvQYIAIgAigC+BgiAyACKALQDXMgBHEgA3M2AvgYIAIgAigC/BgiAyACKALUDXMgBHEgA3M2AvwYIAIgAigCgBkiAyACKALYDXMgBHEgA3M2AoAZIAIgAigChBkiAyACKALcDXMgBHEgA3M2AoQZIAIgAigCiBkiAyACKALgDXMgBHEgA3M2AogZIAIgAigCjBkiAyACKALkDXMgBHEgA3M2AowZIAIgAigCkBkiAyACKALoDXMgBHEgA3M2ApAZIAIgAigClBkiAyACKALsDXMgBHEgA3M2ApQZIAIgAigCmBkiAyACKALwDXMgBHEgA3M2ApgZIAIgAigCnBkiAyACKAL0DXMgBHEgA3M2ApwZIAIgAigCoBkiAyACKAL4DXMgBHEgA3M2AqAZIAIgCiCLASAFGygCADYCpBkgAiACKAKoGSIDIAIoAoAOcyAEcSADczYCqBkgAiACKAKsGSIDIAIoAoQOcyAEcSADczYCrBkgAiACKAKwGSIDIAIoAogOcyAEcSADczYCsBkgAiACKAK0GSIDIAIoAowOcyAEcSADczYCtBkgAiACKAK4GSIDIAIoApAOcyAEcSADczYCuBkgAiACKAK8GSIDIAIoApQOcyAEcSADczYCvBkgAiACKALAGSIDIAIoApgOcyAEcSADczYCwBkgAiACKALEGSIDIAIoApwOcyAEcSADczYCxBkgAiACKALIGSIDIAIoAqAOcyAEcSADczYCyBkgAiACKALMGSIDIAIoAqQOcyAEcSADczYCzBkgAiACKALQGSIDIAIoAqgOcyAEcSADczYC0BkgAiACKALUGSIDIAIoAqwOcyAEcSADczYC1BkgAiACKALYGSIDIAIoArAOcyAEcSADczYC2BkgAiACKALcGSIDIAIoArQOcyAEcSADczYC3BkgAiAJIIwBIAUbKAIANgLgGSACIAIoAuQZIgMgAigCvA5zIARxIANzNgLkGSACIAIoAugZIgMgAigCwA5zIARxIANzNgLoGSACIAIoAuwZIgMgAigCxA5zIARxIANzNgLsGSACIAIoAvAZIgMgAigCyA5zIARxIANzNgLwGSACIAIoAvQZIgMgAigCzA5zIARxIANzNgL0GSACIAIoAvgZIgMgAigC0A5zIARxIANzNgL4GSACIAIoAvwZIgMgAigC1A5zIARxIANzNgL8GSACIAIoAoAaIgMgAigC2A5zIARxIANzNgKAGiACIAIoAoQaIgMgAigC3A5zIARxIANzNgKEGiACIAIoAogaIgMgAigC4A5zIARxIANzNgKIGiACIAIoAowaIgMgAigC5A5zIARxIANzNgKMGiACIAIoApAaIgMgAigC6A5zIARxIANzNgKQGiACIAIoApQaIgMgAigC7A5zIARxIANzNgKUGiACIAIoApgaIgMgAigC8A5zIARxIANzNgKYGiACIAggjQEgBRsoAgA2ApwaIAIgDUEFcyIDQQFrQR91IgQgAigCuBciBSACKAL4DnNxIAVzNgK4FyACIAIoArwXIgUgAigC/A5zIARxIAVzNgK8FyACIAIoAsAXIgUgAigCgA9zIARxIAVzNgLAFyACIAIoAsQXIgUgAigChA9zIARxIAVzNgLEFyACIAIoAsgXIgUgAigCiA9zIARxIAVzNgLIFyACIAIoAswXIgUgAigCjA9zIARxIAVzNgLMFyACIAIoAtAXIgUgAigCkA9zIARxIAVzNgLQFyACIAIoAtQXIgUgAigClA9zIARxIAVzNgLUFyACIAIoAtgXIgUgAigCmA9zIARxIAVzNgLYFyACIAIoAtwXIgUgAigCnA9zIARxIAVzNgLcFyACIAIoAuAXIgUgAigCoA9zIARxIAVzNgLgFyACIAIoAuQXIgUgAigCpA9zIARxIAVzNgLkFyACIAIoAugXIgUgAigCqA9zIARxIAVzNgLoFyACIAIoAuwXIgUgAigCrA9zIARxIAVzNgLsFyACIAcgjgEgA0EASiIFGygCADYC8BcgAiACKAL0FyIDIAIoArQPcyAEcSADczYC9BcgAiACKAL4FyIDIAIoArgPcyAEcSADczYC+BcgAiACKAL8FyIDIAIoArwPcyAEcSADczYC/BcgAiACKAKAGCIDIAIoAsAPcyAEcSADczYCgBggAiACKAKEGCIDIAIoAsQPcyAEcSADczYChBggAiACKAKIGCIDIAIoAsgPcyAEcSADczYCiBggAiACKAKMGCIDIAIoAswPcyAEcSADczYCjBggAiACKAKQGCIDIAIoAtAPcyAEcSADczYCkBggAiACKAKUGCIDIAIoAtQPcyAEcSADczYClBggAiACKAKYGCIDIAIoAtgPcyAEcSADczYCmBggAiACKAKcGCIDIAIoAtwPcyAEcSADczYCnBggAiACKAKgGCIDIAIoAuAPcyAEcSADczYCoBggAiACKAKkGCIDIAIoAuQPcyAEcSADczYCpBggAiACKAKoGCIDIAIoAugPcyAEcSADczYCqBggAiAGII8BIAUbKAIANgKsGCACIAIoArAYIgMgAigC8A9zIARxIANzNgKwGCACIAIoArQYIgMgAigC9A9zIARxIANzNgK0GCACIAIoArgYIgMgAigC+A9zIARxIANzNgK4GCACIAIoArwYIgMgAigC/A9zIARxIANzNgK8GCACIAIoAsAYIgMgAigCgBBzIARxIANzNgLAGCACIAIoAsQYIgMgAigChBBzIARxIANzNgLEGCACIAIoAsgYIgMgAigCiBBzIARxIANzNgLIGCACIAIoAswYIgMgAigCjBBzIARxIANzNgLMGCACIAIoAtAYIgMgAigCkBBzIARxIANzNgLQGCACIAIoAtQYIgMgAigClBBzIARxIANzNgLUGCACIAIoAtgYIgMgAigCmBBzIARxIANzNgLYGCACIAIoAtwYIgMgAigCnBBzIARxIANzNgLcGCACIAIoAuAYIgMgAigCoBBzIARxIANzNgLgGCACIAIoAuQYIgMgAigCpBBzIARxIANzNgLkGCACIAsgkAEgBRsoAgA2AugYIAIgAigC7BgiAyACKAKsEHMgBHEgA3M2AuwYIAIgAigC8BgiAyACKAKwEHMgBHEgA3M2AvAYIAIgAigC9BgiAyACKAK0EHMgBHEgA3M2AvQYIAIgAigC+BgiAyACKAK4EHMgBHEgA3M2AvgYIAIgAigC/BgiAyACKAK8EHMgBHEgA3M2AvwYIAIgAigCgBkiAyACKALAEHMgBHEgA3M2AoAZIAIgAigChBkiAyACKALEEHMgBHEgA3M2AoQZIAIgAigCiBkiAyACKALIEHMgBHEgA3M2AogZIAIgAigCjBkiAyACKALMEHMgBHEgA3M2AowZIAIgAigCkBkiAyACKALQEHMgBHEgA3M2ApAZIAIgAigClBkiAyACKALUEHMgBHEgA3M2ApQZIAIgAigCmBkiAyACKALYEHMgBHEgA3M2ApgZIAIgAigCnBkiAyACKALcEHMgBHEgA3M2ApwZIAIgAigCoBkiAyACKALgEHMgBHEgA3M2AqAZIAIgCiCRASAFGygCADYCpBkgAiACKAKoGSIDIAIoAugQcyAEcSADczYCqBkgAiACKAKsGSIDIAIoAuwQcyAEcSADczYCrBkgAiACKAKwGSIDIAIoAvAQcyAEcSADczYCsBkgAiACKAK0GSIDIAIoAvQQcyAEcSADczYCtBkgAiACKAK4GSIDIAIoAvgQcyAEcSADczYCuBkgAiACKAK8GSIDIAIoAvwQcyAEcSADczYCvBkgAiACKALAGSIDIAIoAoARcyAEcSADczYCwBkgAiACKALEGSIDIAIoAoQRcyAEcSADczYCxBkgAiACKALIGSIDIAIoAogRcyAEcSADczYCyBkgAiACKALMGSIDIAIoAowRcyAEcSADczYCzBkgAiACKALQGSIDIAIoApARcyAEcSADczYC0BkgAiACKALUGSIDIAIoApQRcyAEcSADczYC1BkgAiACKALYGSIDIAIoApgRcyAEcSADczYC2BkgAiACKALcGSIDIAIoApwRcyAEcSADczYC3BkgAiAJIJIBIAUbKAIANgLgGSACIAIoAuQZIgMgAigCpBFzIARxIANzNgLkGSACIAIoAugZIgMgAigCqBFzIARxIANzNgLoGSACIAIoAuwZIgMgAigCrBFzIARxIANzNgLsGSACIAIoAvAZIgMgAigCsBFzIARxIANzNgLwGSACIAIoAvQZIgMgAigCtBFzIARxIANzNgL0GSACIAIoAvgZIgMgAigCuBFzIARxIANzNgL4GSACIAIoAvwZIgMgAigCvBFzIARxIANzNgL8GSACIAIoAoAaIgMgAigCwBFzIARxIANzNgKAGiACIAIoAoQaIgMgAigCxBFzIARxIANzNgKEGiACIAIoAogaIgMgAigCyBFzIARxIANzNgKIGiACIAIoAowaIgMgAigCzBFzIARxIANzNgKMGiACIAIoApAaIgMgAigC0BFzIARxIANzNgKQGiACIAIoApQaIgMgAigC1BFzIARxIANzNgKUGiACIAIoApgaIgMgAigC2BFzIARxIANzNgKYGiACIAggkwEgBRsoAgA2ApwaIAIgDUEGcyIDQQFrQR91IgQgAigCuBciBSACKALgEXNxIAVzNgK4FyACIAIoArwXIgUgAigC5BFzIARxIAVzNgK8FyACIAIoAsAXIgUgAigC6BFzIARxIAVzNgLAFyACIAIoAsQXIgUgAigC7BFzIARxIAVzNgLEFyACIAIoAsgXIgUgAigC8BFzIARxIAVzNgLIFyACIAIoAswXIgUgAigC9BFzIARxIAVzNgLMFyACIAIoAtAXIgUgAigC+BFzIARxIAVzNgLQFyACIAIoAtQXIgUgAigC/BFzIARxIAVzNgLUFyACIAIoAtgXIgUgAigCgBJzIARxIAVzNgLYFyACIAIoAtwXIgUgAigChBJzIARxIAVzNgLcFyACIAIoAuAXIgUgAigCiBJzIARxIAVzNgLgFyACIAIoAuQXIgUgAigCjBJzIARxIAVzNgLkFyACIAIoAugXIgUgAigCkBJzIARxIAVzNgLoFyACIAIoAuwXIgUgAigClBJzIARxIAVzNgLsFyACIAcglAEgA0EASiIFGygCADYC8BcgAiACKAL0FyIDIAIoApwScyAEcSADczYC9BcgAiACKAL4FyIDIAIoAqAScyAEcSADczYC+BcgAiACKAL8FyIDIAIoAqQScyAEcSADczYC/BcgAiACKAKAGCIDIAIoAqgScyAEcSADczYCgBggAiACKAKEGCIDIAIoAqwScyAEcSADczYChBggAiACKAKIGCIDIAIoArAScyAEcSADczYCiBggAiACKAKMGCIDIAIoArQScyAEcSADczYCjBggAiACKAKQGCIDIAIoArgScyAEcSADczYCkBggAiACKAKUGCIDIAIoArwScyAEcSADczYClBggAiACKAKYGCIDIAIoAsAScyAEcSADczYCmBggAiACKAKcGCIDIAIoAsQScyAEcSADczYCnBggAiACKAKgGCIDIAIoAsgScyAEcSADczYCoBggAiACKAKkGCIDIAIoAswScyAEcSADczYCpBggAiACKAKoGCIDIAIoAtAScyAEcSADczYCqBggAiAGIJUBIAUbKAIANgKsGCACIAIoArAYIgMgAigC2BJzIARxIANzNgKwGCACIAIoArQYIgMgAigC3BJzIARxIANzNgK0GCACIAIoArgYIgMgAigC4BJzIARxIANzNgK4GCACIAIoArwYIgMgAigC5BJzIARxIANzNgK8GCACIAIoAsAYIgMgAigC6BJzIARxIANzNgLAGCACIAIoAsQYIgMgAigC7BJzIARxIANzNgLEGCACIAIoAsgYIgMgAigC8BJzIARxIANzNgLIGCACIAIoAswYIgMgAigC9BJzIARxIANzNgLMGCACIAIoAtAYIgMgAigC+BJzIARxIANzNgLQGCACIAIoAtQYIgMgAigC/BJzIARxIANzNgLUGCACIAIoAtgYIgMgAigCgBNzIARxIANzNgLYGCACIAIoAtwYIgMgAigChBNzIARxIANzNgLcGCACIAIoAuAYIgMgAigCiBNzIARxIANzNgLgGCACIAIoAuQYIgMgAigCjBNzIARxIANzNgLkGCACIAsglgEgBRsoAgA2AugYIAIgAigC7BgiAyACKAKUE3MgBHEgA3M2AuwYIAIgAigC8BgiAyACKAKYE3MgBHEgA3M2AvAYIAIgAigC9BgiAyACKAKcE3MgBHEgA3M2AvQYIAIgAigC+BgiAyACKAKgE3MgBHEgA3M2AvgYIAIgAigC/BgiAyACKAKkE3MgBHEgA3M2AvwYIAIgAigCgBkiAyACKAKoE3MgBHEgA3M2AoAZIAIgAigChBkiAyACKAKsE3MgBHEgA3M2AoQZIAIgAigCiBkiAyACKAKwE3MgBHEgA3M2AogZIAIgAigCjBkiAyACKAK0E3MgBHEgA3M2AowZIAIgAigCkBkiAyACKAK4E3MgBHEgA3M2ApAZIAIgAigClBkiAyACKAK8E3MgBHEgA3M2ApQZIAIgAigCmBkiAyACKALAE3MgBHEgA3M2ApgZIAIgAigCnBkiAyACKALEE3MgBHEgA3M2ApwZIAIgAigCoBkiAyACKALIE3MgBHEgA3M2AqAZIAIgCiCXASAFGygCADYCpBkgAiACKAKoGSIDIAIoAtATcyAEcSADczYCqBkgAiACKAKsGSIDIAIoAtQTcyAEcSADczYCrBkgAiACKAKwGSIDIAIoAtgTcyAEcSADczYCsBkgAiACKAK0GSIDIAIoAtwTcyAEcSADczYCtBkgAiACKAK4GSIDIAIoAuATcyAEcSADczYCuBkgAiACKAK8GSIDIAIoAuQTcyAEcSADczYCvBkgAiACKALAGSIDIAIoAugTcyAEcSADczYCwBkgAiACKALEGSIDIAIoAuwTcyAEcSADczYCxBkgAiACKALIGSIDIAIoAvATcyAEcSADczYCyBkgAiACKALMGSIDIAIoAvQTcyAEcSADczYCzBkgAiACKALQGSIDIAIoAvgTcyAEcSADczYC0BkgAiACKALUGSIDIAIoAvwTcyAEcSADczYC1BkgAiACKALYGSIDIAIoAoAUcyAEcSADczYC2BkgAiACKALcGSIDIAIoAoQUcyAEcSADczYC3BkgAiAJIJgBIAUbKAIANgLgGSACIAIoAuQZIgMgAigCjBRzIARxIANzNgLkGSACIAIoAugZIgMgAigCkBRzIARxIANzNgLoGSACIAIoAuwZIgMgAigClBRzIARxIANzNgLsGSACIAIoAvAZIgMgAigCmBRzIARxIANzNgLwGSACIAIoAvQZIgMgAigCnBRzIARxIANzNgL0GSACIAIoAvgZIgMgAigCoBRzIARxIANzNgL4GSACIAIoAvwZIgMgAigCpBRzIARxIANzNgL8GSACIAIoAoAaIgMgAigCqBRzIARxIANzNgKAGiACIAIoAoQaIgMgAigCrBRzIARxIANzNgKEGiACIAIoAogaIgMgAigCsBRzIARxIANzNgKIGiACIAIoAowaIgMgAigCtBRzIARxIANzNgKMGiACIAIoApAaIgMgAigCuBRzIARxIANzNgKQGiACIAIoApQaIgMgAigCvBRzIARxIANzNgKUGiACIAIoApgaIgMgAigCwBRzIARxIANzNgKYGiACIAggmQEgBRsoAgA2ApwaIAIgDUEHcyINQQFrQR91IgQgAigCuBciBSACKALIFHNxIAVzNgK4FyACIAIoArwXIgUgAigCzBRzIARxIAVzNgK8FyACIAIoAsAXIgUgAigC0BRzIARxIAVzNgLAFyACIAIoAsQXIgUgAigC1BRzIARxIAVzNgLEFyACIAIoAsgXIgUgAigC2BRzIARxIAVzNgLIFyACIAIoAswXIgUgAigC3BRzIARxIAVzNgLMFyACIAIoAtAXIgUgAigC4BRzIARxIAVzNgLQFyACIAIoAtQXIgUgAigC5BRzIARxIAVzNgLUFyACIAIoAtgXIgUgAigC6BRzIARxIAVzNgLYFyACIAIoAtwXIgUgAigC7BRzIARxIAVzNgLcFyACIAIoAuAXIgUgAigC8BRzIARxIAVzNgLgFyACIAIoAuQXIgUgAigC9BRzIARxIAVzNgLkFyACIAIoAugXIgUgAigC+BRzIARxIAVzNgLoFyACIAIoAuwXIgUgAigC/BRzIARxIAVzNgLsFyACIAcgmgEgDUEASiINGygCADYC8BcgAiACKAL0FyIFIAIoAoQVcyAEcSAFczYC9BcgAiACKAL4FyIFIAIoAogVcyAEcSAFczYC+BcgAiACKAL8FyIFIAIoAowVcyAEcSAFczYC/BcgAiACKAKAGCIFIAIoApAVcyAEcSAFczYCgBggAiACKAKEGCIFIAIoApQVcyAEcSAFczYChBggAiACKAKIGCIFIAIoApgVcyAEcSAFczYCiBggAiACKAKMGCIFIAIoApwVcyAEcSAFczYCjBggAiACKAKQGCIFIAIoAqAVcyAEcSAFczYCkBggAiACKAKUGCIFIAIoAqQVcyAEcSAFczYClBggAiACKAKYGCIFIAIoAqgVcyAEcSAFczYCmBggAiACKAKcGCIFIAIoAqwVcyAEcSAFczYCnBggAiACKAKgGCIFIAIoArAVcyAEcSAFczYCoBggAiACKAKkGCIFIAIoArQVcyAEcSAFczYCpBggAiACKAKoGCIFIAIoArgVcyAEcSAFczYCqBggAiAGIJsBIA0bKAIANgKsGCACIAIoArAYIgUgAigCwBVzIARxIAVzNgKwGCACIAIoArQYIgUgAigCxBVzIARxIAVzNgK0GCACIAIoArgYIgUgAigCyBVzIARxIAVzNgK4GCACIAIoArwYIgUgAigCzBVzIARxIAVzNgK8GCACIAIoAsAYIgUgAigC0BVzIARxIAVzNgLAGCACIAIoAsQYIgUgAigC1BVzIARxIAVzNgLEGCACIAIoAsgYIgUgAigC2BVzIARxIAVzNgLIGCACIAIoAswYIgUgAigC3BVzIARxIAVzNgLMGCACIAIoAtAYIgUgAigC4BVzIARxIAVzNgLQGCACIAIoAtQYIgUgAigC5BVzIARxIAVzNgLUGCACIAIoAtgYIgUgAigC6BVzIARxIAVzNgLYGCACIAIoAtwYIgUgAigC7BVzIARxIAVzNgLcGCACIAIoAuAYIgUgAigC8BVzIARxIAVzNgLgGCACIAIoAuQYIgUgAigC9BVzIARxIAVzNgLkGCACIAsgnAEgDRsoAgA2AugYIAIgAigC7BgiBSACKAL8FXMgBHEgBXM2AuwYIAIgAigC8BgiBSACKAKAFnMgBHEgBXM2AvAYIAIgAigC9BgiBSACKAKEFnMgBHEgBXM2AvQYIAIgAigC+BgiBSACKAKIFnMgBHEgBXM2AvgYIAIgAigC/BgiBSACKAKMFnMgBHEgBXM2AvwYIAIgAigCgBkiBSACKAKQFnMgBHEgBXM2AoAZIAIgAigChBkiBSACKAKUFnMgBHEgBXM2AoQZIAIgAigCiBkiBSACKAKYFnMgBHEgBXM2AogZIAIgAigCjBkiBSACKAKcFnMgBHEgBXM2AowZIAIgAigCkBkiBSACKAKgFnMgBHEgBXM2ApAZIAIgAigClBkiBSACKAKkFnMgBHEgBXM2ApQZIAIgAigCmBkiBSACKAKoFnMgBHEgBXM2ApgZIAIgAigCnBkiBSACKAKsFnMgBHEgBXM2ApwZIAIgAigCoBkiBSACKAKwFnMgBHEgBXM2AqAZIAIgCiCdASANGygCADYCpBkgAiACKAKoGSIFIAIoArgWcyAEcSAFczYCqBkgAiACKAKsGSIFIAIoArwWcyAEcSAFczYCrBkgAiACKAKwGSIFIAIoAsAWcyAEcSAFczYCsBkgAiACKAK0GSIFIAIoAsQWcyAEcSAFczYCtBkgAiACKAK4GSIFIAIoAsgWcyAEcSAFczYCuBkgAiACKAK8GSIFIAIoAswWcyAEcSAFczYCvBkgAiACKALAGSIFIAIoAtAWcyAEcSAFczYCwBkgAiACKALEGSIFIAIoAtQWcyAEcSAFczYCxBkgAiACKALIGSIFIAIoAtgWcyAEcSAFczYCyBkgAiACKALMGSIFIAIoAtwWcyAEcSAFczYCzBkgAiACKALQGSIFIAIoAuAWcyAEcSAFczYC0BkgAiACKALUGSIFIAIoAuQWcyAEcSAFczYC1BkgAiACKALYGSIFIAIoAugWcyAEcSAFczYC2BkgAiACKALcGSIFIAIoAuwWcyAEcSAFczYC3BkgAiAJIJ4BIA0bKAIANgLgGSACIAIoAuQZIgUgAigC9BZzIARxIAVzNgLkGSACIAIoAugZIgUgAigC+BZzIARxIAVzNgLoGSACIAIoAuwZIgUgAigC/BZzIARxIAVzNgLsGSACIAIoAvAZIgUgAigCgBdzIARxIAVzNgLwGSACIAIoAvQZIgUgAigChBdzIARxIAVzNgL0GSACIAIoAvgZIgUgAigCiBdzIARxIAVzNgL4GSACIAIoAvwZIgUgAigCjBdzIARxIAVzNgL8GSACIAIoAoAaIgUgAigCkBdzIARxIAVzNgKAGiACIAIoAoQaIgUgAigClBdzIARxIAVzNgKEGiACIAIoAogaIgUgAigCmBdzIARxIAVzNgKIGiACIAIoAowaIgUgAigCnBdzIARxIAVzNgKMGiACIAIoApAaIgUgAigCoBdzIARxIAVzNgKQGiACIAIoApQaIgUgAigCpBdzIARxIAVzNgKUGiACIAIoApgaIgUgAigCqBdzIARxIAVzNgKYGiACIAggnwEgDRsoAgA2ApwaIAIgAigCuBc2AuAaIAIgAigCvBc2AuQaIAIgAigCwBc2AugaIAIgAigCxBc2AuwaIAIgAigCyBc2AvAaIAIgAigCzBc2AvQaIAIgAigC0Bc2AvgaIAIgAigC1Bc2AvwaIAIgAigC2Bc2AoAbIAIgAigC3Bc2AoQbIAIgAigC4Bc2AogbIAIgAigC5Bc2AowbIAIgAigC6Bc2ApAbIAIgAigC7Bc2ApQbIAIgAigC8Bc2ApgbIAIgAigC9Bc2ApwbIAIgAigC+Bc2AqAbIAIgAigC/Bc2AqQbIAIgAigCgBg2AqgbIAIgAigChBg2AqwbIAIgAigCiBg2ArAbIAIgAigCjBg2ArQbIAIgAigCkBg2ArgbIAIgAigClBg2ArwbIAIgAigCmBg2AsAbIAIgAigCnBg2AsQbIAIgAigCoBg2AsgbIAIgAigCpBg2AswbIAIgAigCqBg2AtAbIAIgAigCrBg2AtQbIAIgAigCsBg2AtgbIAIgAigCtBg2AtwbIAIgAigCuBg2AuAbIAIgAigCvBg2AuQbIAIgAigCwBg2AugbIAIgAigCxBg2AuwbIAIgAigCyBg2AvAbIAIgAigCzBg2AvQbIAIgAigC0Bg2AvgbIAIgAigC1Bg2AvwbIAIgAigC2Bg2AoAcIAIgAigC3Bg2AoQcIAIgAigC4Bg2AogcIAIgAigC5Bg2AowcIAIgAigC6Bg2ApAcIAIgAigC7Bg2ApQcIAIgAigC8Bg2ApgcIAIgAigC9Bg2ApwcIAIgAigC+Bg2AqAcIAIgAigC/Bg2AqQcIAIgAigCgBk2AqgcIAIgAigChBk2AqwcIAIgAigCiBk2ArAcIAIgAigCjBk2ArQcIAIgAigCkBk2ArgcIAIgAigClBk2ArwcIAIgAigCmBk2AsAcIAIgAigCnBk2AsQcIAIgAigCoBk2AsgcIAIgAigCpBk2AswcIAIgAigCqBk2AtAcIAIgAigCrBk2AtQcIAIgAigCsBk2AtgcIAIgAigCtBk2AtwcIAIgAigCuBk2AuAcIAIgAigCvBk2AuQcIAIgAigCwBk2AugcIAIgAigCxBk2AuwcIAIgAigCyBk2AvAcIAIgAigCzBk2AvQcIAIgAigC0Bk2AvgcIAIgAigC1Bk2AvwcIAIgAigC2Bk2AoAdIAIgAigC3Bk2AoQdIAIgAigC4Bk2AogdIAIgAigC5Bk2AowdIAIgAigC6Bk2ApAdIAIgAigC7Bk2ApQdIAIgAigC8Bk2ApgdIAIgAigC9Bk2ApwdIAIgAigC+Bk2AqAdIAIgAigC/Bk2AqQdIAIgAigCgBo2AqgdIAIgAigChBo2AqwdIAIgAigCiBo2ArAdIAIgAigCjBo2ArQdIAIgAigCkBo2ArgdIAIgAigClBo2ArwdIAIgAigCmBo2AsAdIAIgAigCnBo2AsQdIBIQ9gIgAiACKAKUHCIEIAIoAtgbajYChB4gAiACKAKYHCIFIAIoAtwbajYCiB4gAiACKAKcHCIDIAIoAuAbajYCjB4gAiACKAKgHCIRIAIoAuQbajYCkB4gAiACKAKkHCIQIAIoAugbajYClB4gAiACKAKoHCIUIAIoAuwbajYCmB4gAiACKAKsHCIVIAIoAvAbajYCnB4gAiACKAKwHCIOIAIoAvQbajYCoB4gAiACKAK0HCIWIAIoAvgbajYCpB4gAiACKAK4HCIXIAIoAvwbajYCqB4gAiACKAK8HCIPIAIoAoAcajYCrB4gAiACKALAHCIYIAIoAoQcajYCsB4gAiACKALEHCIZIAIoAogcajYCtB4gAiACKALIHCIaIAIoAowcajYCuB4gAiACKALMHCKgASACKAKQHGoiDTYCvB4gDUGAgIAQTgRAIAJBhB5qENICCyACQYQeaiACQYQeahDMAiACIAQgAigChB5qIg02AsgdIAIgBSACKAKIHmoiBTYCzB0gAiADIAIoAoweaiIDNgLQHSACIBEgAigCkB5qIhE2AtQdIAIgECACKAKUHmoiEDYC2B0gAiAUIAIoApgeaiIUNgLcHSACIBUgAigCnB5qIhU2AuAdIAIgDiACKAKgHmoiDjYC5B0gAiAWIAIoAqQeaiIWNgLoHSACIBcgAigCqB5qIhc2AuwdIAIgDyACKAKsHmoiDzYC8B0gAiAYIAIoArAeaiIYNgL0HSACIBkgAigCtB5qIhk2AvgdIAIgGiACKAK4HmoiGjYC/B0gAiCgASACKAK8HmoiBDYCgB4gBEGAgIAQTgRAIAJByB1qENICIAIoAoAeIQQgAigC/B0hGiACKAL4HSEZIAIoAvQdIRggAigC8B0hDyACKALsHSEXIAIoAugdIRYgAigC5B0hDiACKALgHSEVIAIoAtwdIRQgAigC2B0hECACKALUHSERIAIoAswdIQUgAigCyB0hDSACKALQHSEDCyB1IAJBhB5qIBIQ9wIgAiAENgKQHCACIBo2AowcIAIgGTYCiBwgAiAYNgKEHCACIA82AoAcIAIgFzYC/BsgAiAWNgL4GyACIA42AvQbIAIgFTYC8BsgAiAUNgLsGyACIBA2AugbIAIgETYC5BsgAiADNgLgGyACIAU2AtwbIAIgDTYC2BsgEhD2AiACIAIoArgXIgQgAigC4BpzIAFxIARzNgK4FyACIAIoArwXIgQgAigC5BpzIAFxIARzNgK8FyACIAIoAsAXIgQgAigC6BpzIAFxIARzNgLAFyACIAIoAsQXIgQgAigC7BpzIAFxIARzNgLEFyACIAIoAsgXIgQgAigC8BpzIAFxIARzNgLIFyACIAIoAswXIgQgAigC9BpzIAFxIARzNgLMFyACIAIoAtAXIgQgAigC+BpzIAFxIARzNgLQFyACIAIoAtQXIgQgAigC/BpzIAFxIARzNgLUFyACIAIoAtgXIgQgAigCgBtzIAFxIARzNgLYFyACIAIoAtwXIgQgAigChBtzIAFxIARzNgLcFyACIAIoAuAXIgQgAigCiBtzIAFxIARzNgLgFyACIAIoAuQXIgQgAigCjBtzIAFxIARzNgLkFyACIAIoAugXIgQgAigCkBtzIAFxIARzNgLoFyACIAIoAuwXIgQgAigClBtzIAFxIARzNgLsFyACIAJBmBtqIAcgE0EASCIEGygCADYC8BcgAiACKAL0FyIHIAIoApwbcyABcSAHczYC9BcgAiACKAL4FyIHIAIoAqAbcyABcSAHczYC+BcgAiACKAL8FyIHIAIoAqQbcyABcSAHczYC/BcgAiACKAKAGCIHIAIoAqgbcyABcSAHczYCgBggAiACKAKEGCIHIAIoAqwbcyABcSAHczYChBggAiACKAKIGCIHIAIoArAbcyABcSAHczYCiBggAiACKAKMGCIHIAIoArQbcyABcSAHczYCjBggAiACKAKQGCIHIAIoArgbcyABcSAHczYCkBggAiACKAKUGCIHIAIoArwbcyABcSAHczYClBggAiACKAKYGCIHIAIoAsAbcyABcSAHczYCmBggAiACKAKcGCIHIAIoAsQbcyABcSAHczYCnBggAiACKAKgGCIHIAIoAsgbcyABcSAHczYCoBggAiACKAKkGCIHIAIoAswbcyABcSAHczYCpBggAiACKAKoGCIHIAIoAtAbcyABcSAHczYCqBggAiACQdQbaiAGIAQbKAIANgKsGCACIAIoArAYIgcgAigC2BtzIAFxIAdzNgKwGCACIAIoArQYIgcgAigC3BtzIAFxIAdzNgK0GCACIAIoArgYIgcgAigC4BtzIAFxIAdzNgK4GCACIAIoArwYIgcgAigC5BtzIAFxIAdzNgK8GCACIAIoAsAYIgcgAigC6BtzIAFxIAdzNgLAGCACIAIoAsQYIgcgAigC7BtzIAFxIAdzNgLEGCACIAIoAsgYIgcgAigC8BtzIAFxIAdzNgLIGCACIAIoAswYIgcgAigC9BtzIAFxIAdzNgLMGCACIAIoAtAYIgcgAigC+BtzIAFxIAdzNgLQGCACIAIoAtQYIgcgAigC/BtzIAFxIAdzNgLUGCACIAIoAtgYIgcgAigCgBxzIAFxIAdzNgLYGCACIAIoAtwYIgcgAigChBxzIAFxIAdzNgLcGCACIAIoAuAYIgcgAigCiBxzIAFxIAdzNgLgGCACIAIoAuQYIgcgAigCjBxzIAFxIAdzNgLkGCACIAJBkBxqIAsgBBsoAgA2AugYIAIgAigC7BgiByACKAKUHHMgAXEgB3M2AuwYIAIgAigC8BgiByACKAKYHHMgAXEgB3M2AvAYIAIgAigC9BgiByACKAKcHHMgAXEgB3M2AvQYIAIgAigC+BgiByACKAKgHHMgAXEgB3M2AvgYIAIgAigC/BgiByACKAKkHHMgAXEgB3M2AvwYIAIgAigCgBkiByACKAKoHHMgAXEgB3M2AoAZIAIgAigChBkiByACKAKsHHMgAXEgB3M2AoQZIAIgAigCiBkiByACKAKwHHMgAXEgB3M2AogZIAIgAigCjBkiByACKAK0HHMgAXEgB3M2AowZIAIgAigCkBkiByACKAK4HHMgAXEgB3M2ApAZIAIgAigClBkiByACKAK8HHMgAXEgB3M2ApQZIAIgAigCmBkiByACKALAHHMgAXEgB3M2ApgZIAIgAigCnBkiByACKALEHHMgAXEgB3M2ApwZIAIgAigCoBkiByACKALIHHMgAXEgB3M2AqAZIAIgAkHMHGogCiAEGygCADYCpBkgAiACKAKoGSIHIAIoAtAccyABcSAHczYCqBkgAiACKAKsGSIHIAIoAtQccyABcSAHczYCrBkgAiACKAKwGSIHIAIoAtgccyABcSAHczYCsBkgAiACKAK0GSIHIAIoAtwccyABcSAHczYCtBkgAiACKAK4GSIHIAIoAuAccyABcSAHczYCuBkgAiACKAK8GSIHIAIoAuQccyABcSAHczYCvBkgAiACKALAGSIHIAIoAugccyABcSAHczYCwBkgAiACKALEGSIHIAIoAuwccyABcSAHczYCxBkgAiACKALIGSIHIAIoAvAccyABcSAHczYCyBkgAiACKALMGSIHIAIoAvQccyABcSAHczYCzBkgAiACKALQGSIHIAIoAvgccyABcSAHczYC0BkgAiACKALUGSIHIAIoAvwccyABcSAHczYC1BkgAiACKALYGSIHIAIoAoAdcyABcSAHczYC2BkgAiACKALcGSIHIAIoAoQdcyABcSAHczYC3BkgAiACQYgdaiAJIAQbKAIANgLgGSACIAIoAuQZIgcgAigCjB1zIAFxIAdzNgLkGSACIAIoAugZIgcgAigCkB1zIAFxIAdzNgLoGSACIAIoAuwZIgcgAigClB1zIAFxIAdzNgLsGSACIAIoAvAZIgcgAigCmB1zIAFxIAdzNgLwGSACIAIoAvQZIgcgAigCnB1zIAFxIAdzNgL0GSACIAIoAvgZIgcgAigCoB1zIAFxIAdzNgL4GSACIAIoAvwZIgcgAigCpB1zIAFxIAdzNgL8GSACIAIoAoAaIgcgAigCqB1zIAFxIAdzNgKAGiACIAIoAoQaIgcgAigCrB1zIAFxIAdzNgKEGiACIAIoAogaIgcgAigCsB1zIAFxIAdzNgKIGiACIAIoAowaIgcgAigCtB1zIAFxIAdzNgKMGiACIAIoApAaIgcgAigCuB1zIAFxIAdzNgKQGiACIAIoApQaIgcgAigCvB1zIAFxIAdzNgKUGiACIAIoApgaIgcgAigCwB1zIAFxIAdzNgKYGiACIAJBxB1qIAggBBsoAgA2ApwaIAAQiQMgABCJAyAAEIkDIAAQiQMgACACQbgXahD0AiAMQQBKIQEgDEEBayEMIAENAAsLIAIgHzYCxB0gAiAeNgLAHSACIB02ArwdIAIgHDYCuB0gAiAbNgK0HSACICA2ArAdIAIgITYCrB0gAiAiNgKoHSACICM2AqQdIAIgJDYCoB0gAiAlNgKcHSACICY2ApgdIAIgJzYClB0gAiAoNgKQHSACICk2AowdIAIgKjYCiB0gAiArNgKEHSACICw2AoAdIAIgLTYC/BwgAiAuNgL4HCACIC82AvQcIAIgMDYC8BwgAiAxNgLsHCACIDI2AugcIAIgMzYC5BwgAiA0NgLgHCACIDU2AtwcIAIgNjYC2BwgAiA3NgLUHCACIDg2AtAcIAIgOTYCzBwgAiA6NgLIHCACIDs2AsQcIAIgPDYCwBwgAiA9NgK8HCACID42ArgcIAIgPzYCtBwgAiBANgKwHCACIEE2AqwcIAIgQjYCqBwgAiBDNgKkHCACIEQ2AqAcIAIgRTYCnBwgAiBGNgKYHCACIEc2ApQcIAIgSDYCkBwgAiBJNgKMHCACIEo2AogcIAIgSzYChBwgAiBMNgKAHCACIE02AvwbIAIgTjYC+BsgAiBPNgL0GyACIFA2AvAbIAIgUTYC7BsgAiBSNgLoGyACIFM2AuQbIAIgVDYC4BsgAiBVNgLcGyACIFY2AtgbIAIgVzYC1BsgAiBYNgLQGyACIFk2AswbIAIgWjYCyBsgAiBbNgLEGyACIFw2AsAbIAIgXTYCvBsgAiBeNgK4GyACIF82ArQbIAIgYDYCsBsgAiBhNgKsGyACIGI2AqgbIAIgYzYCpBsgAiBkNgKgGyACIGU2ApwbIAIgZjYCmBsgAiBnNgKUGyACIGg2ApAbIAIgaTYCjBsgAiBqNgKIGyACIGs2AoQbIAIgbDYCgBsgAiBtNgL8GiACIG42AvgaIAIgbzYC9BogAiBwNgLwGiACIHE2AuwaIAIgcjYC6BogAiBzNgLkGiACIHQ2AuAaIAJB2BtqIgQQ9gIgAiACKAKUHCIBIAIoAtgbajYChB4gAiACKAKYHCIGIAIoAtwbajYCiB4gAiACKAKcHCILIAIoAuAbajYCjB4gAiACKAKgHCIKIAIoAuQbajYCkB4gAiACKAKkHCIJIAIoAugbajYClB4gAiACKAKoHCIIIAIoAuwbajYCmB4gAiACKAKsHCINIAIoAvAbajYCnB4gAiACKAKwHCIFIAIoAvQbajYCoB4gAiACKAK0HCIMIAIoAvgbajYCpB4gAiACKAK4HCISIAIoAvwbajYCqB4gAiACKAK8HCITIAIoAoAcajYCrB4gAiACKALAHCIDIAIoAoQcajYCsB4gAiACKALEHCIRIAIoAogcajYCtB4gAiACKALIHCIQIAIoAowcajYCuB4gAiACKALMHCIUIAIoApAcaiIHNgK8HiAHQYCAgBBOBEAgAkGEHmoQ0gILIAJBlBxqIRUgAkGEHmogAkGEHmoQzAIgAiABIAIoAoQeaiIHNgLIHSACIAYgAigCiB5qIgY2AswdIAIgCyACKAKMHmoiCzYC0B0gAiAKIAIoApAeaiIKNgLUHSACIAkgAigClB5qIgk2AtgdIAIgCCACKAKYHmoiCDYC3B0gAiANIAIoApweaiINNgLgHSACIAUgAigCoB5qIgU2AuQdIAIgDCACKAKkHmoiDDYC6B0gAiASIAIoAqgeaiISNgLsHSACIBMgAigCrB5qIhM2AvAdIAIgAyACKAKwHmoiAzYC9B0gAiARIAIoArQeaiIRNgL4HSACIBAgAigCuB5qIhA2AvwdIAIgFCACKAK8HmoiATYCgB4gAUGAgIAQTgRAIAJByB1qENICIAIoAvwdIRAgAigC+B0hESACKAL0HSEDIAIoAvAdIRMgAigC7B0hEiACKALoHSEMIAIoAuQdIQUgAigC4B0hDSACKALcHSEIIAIoAtgdIQkgAigC1B0hCiACKALQHSELIAIoAswdIQYgAigCyB0hByACKAKAHiEBCyAVIAJBhB5qIAQQ9wIgAiABNgKQHCACIBA2AowcIAIgETYCiBwgAiADNgKEHCACIBM2AoAcIAIgEjYC/BsgAiAMNgL4GyACIAU2AvQbIAIgDTYC8BsgAiAINgLsGyACIAk2AugbIAIgCjYC5BsgAiALNgLgGyACIAY2AtwbIAIgBzYC2BsgBBD2AiAAIAJB4BpqEPQCIAAQ6AILIAJBwB5qJAALmgQBBn8jAEFAaiICJAAgAkHRyik2AjAgAEH5hiogAkEwahCbAQJAAkAgAEEBQZTtKxDcASIBRQRAQcXVKSEFIABBARDIASIBRQ0BIAEoAggtAAAiBEHfAU0gBEGgAXFBIEdxRQRAIAJBATYCECAAQYm5KyACQRBqEG4LIAEQmgEMAQsgASABKALwAkEBajYC8AICfwJAAn8CfyABQQhqIgUQuAIEQEEBIAFBxABqELgCDQEaC0EACwJ/IAFB+AFqELgCBEBBASABQbQCahC4Ag0BGgtBAAtxBEAgAEEDEIYBIgRFDQIgBCgCCEH/ADoAACAEKAIIQf8AOgABIAQoAghBADoAAyAEQQI2AgBBAAwBCyAAIAEoAgRBD2oQhgEiBEUNASAEIAUQ3wEgACAEENkBQQALIQVBAQwBC0Hp2yshBUEACyEEIAEgASgC8AIiA0EBazYC8AICQCADQQFKDQACQEGkiDQoAgAiA0UNACACIAE2AjwgAygCACIGIAIoAjxLDQAgAigCPCAGIAMoAhBqTw0AIAEgAygCBDYCACADIAE2AgQgAyADKAIIQQFqNgIIIAMoAhQiA0EESQ0BIANBfHEiA0UNASABQQAgA/wLAAwBCyABECsLIAQNAQsgAiAFNgIEIAJB0copNgIAIABB/IgqIAIQbAALIAJB0copNgIgIABB4IcqIAJBIGoQmwEgAkFAayQAQQELuw0CB38BeyMAQfAFayIBJAAgAUHizyk2AkAgAEH5hiogAUFAaxCbASAAQQFBlO0rENwBIgNFBEAgAEEBEMgBIgMEQCADKAIILQAAIgRB3wFNIARBoAFxQSBHcUUEQCABQQE2AhAgAEGJuSsgAUEQahBuCyADEJoBCyABQanVKTYCBCABQeLPKTYCACAAQfyIKiABEGwACyADIAMoAvACQQFqNgLwAgJ/QcXVKSAAQeAAEIYBIgRFDQAaAn8gA0EIaiIFELgCBEBBASADQcQAahC4Ag0BGgtBAAshAgJ/IANB+AFqELgCBEBBASADQbQCahC4Ag0BGgtBAAsgAnEEQCAEQeAANgIAIAQoAghBwAE6AAAgBCgCCEEBakEAQd8A/AsAQQAMAQsgAUHIA2ogAUHQAmogBRD+AiABQcgDahDSAiABQYQEahDSAiABQawFaiICQQA2AgAgAUGMBWoiBf0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUGcBWoiByAI/QsCACABIAEoAsgDNgLABCABIAH9AALMA/0LAsQEIAEgAf0AAtwD/QsC1AQgASABKALsAzYC5AQgASABKQLwAzcD6AQgASABKAL4AzYC8AQgASAI/QsC/AQgASABKAL8AyIGQf////8BcTYC9AQgASAGQR11NgL4BCABQqO9xIDQATcD4AUgAULt05uWwabz/xI3A9gFIAFCy+6Ru+Gsl40SNwPQBSABQsO59teglJzPEDcDyAUgAULqg4n7gOueqAk3A8AFIAFC7v//p6Gs//8XNwO4BSABQqvV/v/x///7DzcDsAUgAUGQAmogAUGwBWogAUHABGoQyQIgByAI/QsCACAFIAj9CwIAIAJBADYCACABIAH9AAKEBP0LBMAEIAEgAf0AApQE/QsE0AQgASABKAKkBDYC4AQgASAB/QACqAT9CwLkBCABIAEoArgEIgZB/////wFxNgL0BCABIAZBHXU2AvgEIAEgCP0LAvwEIAFCo73EgNABNwPgBSABQu3Tm5bBpvP/EjcD2AUgAULL7pG74ayXjRI3A9AFIAFCw7n216CUnM8QNwPIBSABQuqDifuA656oCTcDwAUgAULu//+noaz//xc3A7gFIAFCq9X+//H///sPNwOwBSABQdABaiABQbAFaiABQcAEahDJAiABQdACahDSAiABQYwDahDSAiACQQA2AgAgBSAI/QsCACAHIAj9CwIAIAEgASgC0AI2AsAEIAEgAf0AAtQC/QsCxAQgASAB/QAC5AL9CwLUBCABIAEoAvQCNgLkBCABIAEpAvgCNwPoBCABIAEoAoADNgLwBCABIAj9CwL8BCABIAEoAoQDIgZB/////wFxNgL0BCABIAZBHXU2AvgEIAFCo73EgNABNwPgBSABQu3Tm5bBpvP/EjcD2AUgAULL7pG74ayXjRI3A9AFIAFCw7n216CUnM8QNwPIBSABQuqDifuA656oCTcDwAUgAULu//+noaz//xc3A7gFIAFCq9X+//H///sPNwOwBSABQZABaiABQbAFaiABQcAEahDJAiAHIAj9CwIAIAUgCP0LAgAgAkEANgIAIAEgAf0AAowD/QsEwAQgASAB/QACnAP9CwTQBCABIAEoAqwDNgLgBCABIAH9AAKwA/0LAuQEIAEgASgCwAMiAkH/////AXE2AvQEIAEgAkEddTYC+AQgASAI/QsC/AQgAUKjvcSA0AE3A+AFIAFC7dOblsGm8/8SNwPYBSABQsvukbvhrJeNEjcD0AUgAULDufbXoJSczxA3A8gFIAFC6oOJ+4DrnqgJNwPABSABQu7//6ehrP//FzcDuAUgAUKr1f7/8f//+w83A7AFIAFB0ABqIAFBsAVqIAFBwARqEMkCIAFBkAFqIAFB0ABqEOYCIQIgBCgCCEEwaiABQZACahC6AiAEKAIIIAFB0AFqELoCIARB4AA2AgAgBCgCCCIFIAUtAAAgAkEFdHJBgAFyOgAAQQALIQYgAyADKALwAiICQQFrNgLwAgJAIAJBAUoNAAJAQaSINCgCACICRQ0AIAEgAzYCyAMgAigCACIFIAEoAsgDSw0AIAEoAsgDIAUgAigCEGpPDQAgAyACKAIENgIAIAIgAzYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIANBACAC/AsADAELIAMQKwsgBEUEQCABIAY2AiQgAUHizyk2AiAgAEH8iCogAUEgahBsAAsgAUHizyk2AjAgAEHghyogAUEwahCbASABQfAFaiQAQQELkQYBA38jAEHwAmsiAyQAIANBCGogAhDkAiADQYABaiIEIAJB+ABqEOQCIANB+AFqIgUgAkHwAWoQ5AIgA0EIahDoAgJAAn8gA0EIahC4AgRAQQEgA0HEAGoQuAINARoLQQALAn8gBRC4AgRAQQEgA0G0AmoQuAINARoLQQALcQ0AIAEgBEcEQCABIAMoAoABNgIAIAEgAygChAE2AgQgASADKAKIATYCCCABIAMoAowBNgIMIAEgAygCkAE2AhAgASADKAKUATYCFCABIAMoApgBNgIYIAEgAygCnAE2AhwgASADKAKgATYCICABIAMoAqQBNgIkIAEgAygCqAE2AiggASADKAKsATYCLCABIAMoArABNgIwIAEgAygCtAE2AjQgASADKAK4ATYCOCABIAMoArwBNgI8IAEgAygCwAE2AkAgASADKALEATYCRCABIAMoAsgBNgJIIAEgAygCzAE2AkwgASADKALQATYCUCABIAMoAtQBNgJUIAEgAygC2AE2AlggASADKALcATYCXCABIAMoAuABNgJgIAEgAygC5AE2AmQgASADKALoATYCaCABIAMoAuwBNgJsIAEgAygC8AE2AnAgASADKAL0ATYCdAsgACADQQhqRg0AIAAgAygCCDYCACAAIAMoAgw2AgQgACADKAIQNgIIIAAgAygCFDYCDCAAIAMoAhg2AhAgACADKAIcNgIUIAAgAygCIDYCGCAAIAMoAiQ2AhwgACADKAIoNgIgIAAgAygCLDYCJCAAIAMoAjA2AiggACADKAI0NgIsIAAgAygCODYCMCAAIAMoAjw2AjQgACADKAJANgI4IAAgAygCRDYCPCAAIAMoAkg2AkAgACADKAJMNgJEIAAgAygCUDYCSCAAIAMoAlQ2AkwgACADKAJYNgJQIAAgAygCXDYCVCAAIAMoAmA2AlggACADKAJkNgJcIAAgAygCaDYCYCAAIAMoAmw2AmQgACADKAJwNgJoIAAgAygCdDYCbCAAIAMoAng2AnAgACADKAJ8NgJ0CyADQfACaiQAC68KAQR/IwBB0ARrIgEkACABQfrsKzYCICAAQfmGKiABQSBqEJsBAkAgASAAQQEQyAEiAwR/IABB9AJBARDaASIEQvCAgICQGDcCACAAQdjhzn1BlO0rEJABGiAAQX4Q2wEgBEEBNgLwAiABQaACaiADKAIIIgIQtAIgAUKr1Jn1wQE3A8AEIAFCvLn+6PDPrbwCNwO4BCABQpnH2dnx6NupHDcDsAQgAULby8OLkbaJxwg3A6gEIAFC0tm486C1k7QRNwOgBCABQuin9paw5JiRCTcDmAQgAUKu7/ut4aHzmBA3A5AEIAFBMGogAUGgAmogAUGQBGoQ0wIgAUKjvcSA0AE3A9ADIAFC7dOblsGm8/8SNwPIAyABQsvukbvhrJeNEjcDwAMgAULDufbXoJSczxA3A7gDIAFC6oOJ+4DrnqgJNwOwAyABQu7//6ehrP//FzcDqAMgAUKr1f7/8f//+w83A6ADIAFBqAFqIAFBoANqIAFBMGoQyQIgAUECNgLgASABQaACaiACQTBqELQCIAFCq9SZ9cEBNwPABCABQry5/ujwz628AjcDuAQgAUKZx9nZ8ejbqRw3A7AEIAFC28vDi5G2iccINwOoBCABQtLZuPOgtZO0ETcDoAQgAULop/aWsOSYkQk3A5gEIAFCru/7reGh85gQNwOQBCABQTBqIAFBoAJqIAFBkARqENMCIAFCo73EgNABNwPQAyABQu3Tm5bBpvP/EjcDyAMgAULL7pG74ayXjRI3A8ADIAFCw7n216CUnM8QNwO4AyABQuqDifuA656oCTcDsAMgAULu//+noaz//xc3A6gDIAFCq9X+//H///sPNwOgAyABQeQBaiABQaADaiABQTBqEMkCIAFBAjYCnAIgAUGgAmogAkHgAGoQtAIgAUKr1Jn1wQE3A5ADIAFCvLn+6PDPrbwCNwOIAyABQpnH2dnx6NupHDcDgAMgAULby8OLkbaJxwg3A/gCIAFC0tm486C1k7QRNwPwAiABQuin9paw5JiRCTcD6AIgAUKu7/ut4aHzmBA3A+ACIAFBoANqIAFBoAJqIAFB4AJqENMCIAFCo73EgNABNwPABCABQu3Tm5bBpvP/EjcDuAQgAULL7pG74ayXjRI3A7AEIAFCw7n216CUnM8QNwOoBCABQuqDifuA656oCTcDoAQgAULu//+noaz//xc3A5gEIAFCq9X+//H///sPNwOQBCABQTBqIAFBkARqIAFBoANqEMkCIAFBAjYCaCABQaACaiACQZABahC0AiABQqvUmfXBATcDkAMgAUK8uf7o8M+tvAI3A4gDIAFCmcfZ2fHo26kcNwOAAyABQtvLw4uRtonHCDcD+AIgAULS2bjzoLWTtBE3A/ACIAFC6Kf2lrDkmJEJNwPoAiABQq7v+63hofOYEDcD4AIgAUGgA2ogAUGgAmogAUHgAmoQ0wIgAUKjvcSA0AE3A8AEIAFC7dOblsGm8/8SNwO4BCABQsvukbvhrJeNEjcDsAQgAULDufbXoJSczxA3A6gEIAFC6oOJ+4DrnqgJNwOgBCABQu7//6ehrP//FzcDmAQgAUKr1f7/8f//+w83A5AEIAFB7ABqIAFBkARqIAFBoANqEMkCIAFBAjYCpAEgBEEIaiABQagBaiABQTBqEIADIQIgAxCaASACDQFB+u0rBUGA3CsLNgIEIAFB+uwrNgIAIABB/IgqIAEQbAALIAFB+uwrNgIQIABB4IcqIAFBEGoQmwEgAUHQBGokAEEBC+wFAgN/AXsjAEGQBWsiAyQAIAMgAhCHAyADQagCaiABEIcDIANB+ABqIANBqAJqIAEQ+QIgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAoQCIAMgBv0LApQCIANBADYCpAIgA0EENgLwASADIAb9CwL0ASADQqvUmfXBATcD0AMgA0K8uf7o8M+tvAI3A8gDIANCmcfZ2fHo26kcNwPAAyADQtvLw4uRtonHCDcDuAMgA0LS2bjzoLWTtBE3A7ADIANC6Kf2lrDkmJEJNwOoAyADQq7v+63hofOYEDcDoAMgA0HgA2ogA0HwAWogA0GgA2oQ0wIgA0KjvcSA0AE3A4AFIANC7dOblsGm8/8SNwP4BCADQsvukbvhrJeNEjcD8AQgA0LDufbXoJSczxA3A+gEIANC6oOJ+4DrnqgJNwPgBCADQu7//6ehrP//FzcD2AQgA0Kr1f7/8f//+w83A9AEIANBqAJqIANB0ARqIANB4ANqEMkCIAMgBv0LAuwCIAMgBv0LAvwCIAMgBv0LAowDIANBAjYC4AIgA0IANwLkAiADQQE2ApwDIANBqAJqEPYCIANBqAJqEMMIIANBqAJqEPYCIANB+ABqIANBqAJqIANB+ABqEPcCIANBtAFqIgQgA0HkAmogBBD3AiADQfgAahDSAiAEENICAkACQCADIANB+ABqENQCBEAgA0E8aiAEENQCDQELIAAgBv0LAgAgAEIANwI8IABBATYCOCAAQQE2AnQgAEIANwIwIAAgBv0LAiAgACAG/QsCECAAIAb9CwJEIAAgBv0LAlQgACAG/QsCZCAAQfgAahCLAyAAQgA3AqACIAAgBv0LApACIAAgBv0LAoACIAAgBv0LAvABIABCADcCrAIgAEEBNgKoAiAAIAb9CwK0AiAAIAb9CwLEAiAAIAb9CwLUAiAAQQE2AuQCDAELIAAgARDkAiAAQfgAaiACEOQCIABB8AFqEIsDQQEhBQsgA0GQBWokACAFC74BAQJ/IwBBkAJrIgEkACABQa+OKjYCECAAQfmGKiABQRBqEJsBIABB9AJBARDaASICQvCAgICQGDcCACAAQdjhzn1BlO0rEJABGiAAQX4Q2wEgAkEBNgLwAiABQZgBakHAwS8QggMgAUHUAWpBgMIvEIIDIAFBIGpBwMIvEIIDIAFB3ABqQYDDLxCCAyACQQhqIAFBmAFqIAFBIGoQgAMaIAFBr44qNgIAIABB4IcqIAEQmwEgAUGQAmokAEEBC50DAQF/IwBBsAJrIgIkACACIAEoAgA2AgAgAiABKAIENgIEIAIgASgCCDYCCCACIAEoAgw2AgwgAiABKAIQNgIQIAIgASgCFDYCFCACIAEoAhg2AhggAiABKAIcNgIcIAIgASgCIDYCICACIAEoAiQ2AiQgAiABKAIoNgIoIAIgASgCLDYCLCACIAEoAjA2AjAgAiABKAI0NgI0IAJCq9SZ9cEBNwNwIAJCvLn+6PDPrbwCNwNoIAJCmcfZ2fHo26kcNwNgIAJC28vDi5G2iccINwNYIAJC0tm486C1k7QRNwNQIAJC6Kf2lrDkmJEJNwNIIAJCru/7reGh85gQNwNAIAJBgAFqIAIgAkFAaxDTAiACQqO9xIDQATcDoAIgAkLt05uWwabz/xI3A5gCIAJCy+6Ru+Gsl40SNwOQAiACQsO59teglJzPEDcDiAIgAkLqg4n7gOueqAk3A4ACIAJC7v//p6Gs//8XNwP4ASACQqvV/v/x///7DzcD8AEgACACQfABaiACQYABahDJAiAAQQI2AjggAkGwAmokAAubMQIafwF7IwBB4A1rIgEkACABQeLdKTYCMCAAQfmGKiABQTBqEJsBAkAgAEEBEMgBIhoEfyAaKAIAIgJBwABGDQEgASACNgIgIABBlv4rIAFBIGoQbkHU4ioFQYDcKwshAiAaEJoBIAEgAjYCBCABQeLdKTYCACAAQfyIKiABEGwACyAAQfQCQQEQ2gEiGELwgICAkBg3AgAgAEHY4c59QZTtKxCQARogAEF+ENsBIBhBATYC8AIgAUGAB2ogGigCCBC0AiABQZQJav0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUGkCWogG/0LAgAgAUG0CWpBADYCACABQqO9xIDQATcD8AkgAULt05uWwabz/xI3A+gJIAFCy+6Ru+Gsl40SNwPgCSABQsO59teglJzPEDcD2AkgAULqg4n7gOueqAk3A9AJIAFC7v//p6Gs//8XNwPICSABQqvV/v/x///7DzcDwAkgAUEBNgKACSABIBv9CwKECSAYQQhqIRIgAUGAB2ogAUHACWoQ2wIgASgCtAchFCABKAKwByEVIAEoAqwHIRcgASgCqAchBCABKAKkByEFIAEoAqAHIQYgASgCnAchESABKAKYByEHIAEoApQHIQggASgCkAchCSABKAKMByEKIAEoAogHIQsgASgChAchDCABKAKAByECA0AgAUGIBmogAUGACWogAUGAB2oQhAMgEiABQYgGahCFA0UEQCABIAJB/////wFxQQFqIgM2AoAHIAEgDCACQR11aiICQf////8BcSIMNgKEByABIAsgAkEddWoiAkH/////AXEiCzYCiAcgASAKIAJBHXVqIgJB/////wFxIgo2AowHIAEgCSACQR11aiICQf////8BcSIJNgKQByABIAggAkEddWoiAkH/////AXEiCDYClAcgASAHIAJBHXVqIgJB/////wFxIgc2ApgHIAEgESACQR11aiICQf////8BcSIRNgKcByABIAYgAkEddWoiAkH/////AXEiBjYCoAcgASAFIAJBHXVqIgJB/////wFxIgU2AqQHIAEgBCACQR11aiICQf////8BcSIENgKoByABIBcgAkEddWoiAkH/////AXEiFzYCrAcgASAVIAJBHXVqIgJB/////wFxIhU2ArAHIAEgFCACQR11aiIUNgK0ByADIQIMAQsLIAFC8Pe0gsEBNwPwCCABQq3fsYTxmYO7BTcD6AggAUKDrL/4gY3YgAE3A+AIIAFCkdn36bH15dMfNwPYCCABQuee8dzQy/D1ATcD0AggAULjnoHP8diepR03A8gIIAFCuL+NkcHt650INwPACCABQrPFj/4ANwOwCCABQsD06ZHQjPDEDTcDqAggAULHwtLC0Z+/jBE3A6AIIAFCsuD+7eCetvsQNwOYCCABQoLll56wn66yBzcDkAggAUKL4f7YodPg2ho3A4gIIAFC85Xx7rCSlN4HNwOACCABQYgGaiABQcAIaiABQYAIahCEAyABQYgGaiABQYgGahCGAyABQYgGahD2AiABIBv9CwLUByABIBv9CwLkByABQTQ2AsgHIAFBADYC9AcgAUIANwLMByABQoCAhICAgICEEDcDwAcgAUGgA2ogEhDkAiABQZgEaiIUIBhBgAFqIgIQ5AIgAUGQBWoiFyAYQfgBaiIVEOQCIAFBoANqIAFBwAdqEPsCIAEgASgCoAM2AjggASAB/QACpAP9CwI8IAEgAf0AArQD/QsCTCABIAH9AALEA/0LAlwgASAB/QAC1AP9CwJsIAEgAf0AAuQD/QsCfCABIAH9AAL0A/0LAowBIAEgASkChAQ3ApwBIAEgASgCjAQ2AqQBIAEgASgCkAQ2AqgBIAEgAf0AApQE/QsCrAEgASAB/QACpAT9CwK8ASABIAH9AAK0BP0LAswBIAEgAf0AAsQE/QsC3AEgASAB/QAC1AT9CwLsASABIAH9AALkBP0LAvwBIAEgASkC9AQ3AowCIAEgASgC/AQ2ApQCIAEgASgCgAU2ApgCIAEgAf0AAoQF/QsCnAIgASAB/QAClAX9CwKsAiABIAH9AAKkBf0LArwCIAEgAf0AArQF/QsCzAIgASAB/QACxAX9CwLcAiABIAH9AALUBf0LAuwCIAEgASkC5AU3AvwCIAEgASgC7AU2AoQDIAEgASgC8AU2AogDIAEgASgC9AU2AowDIAEgASgC+AU2ApADIAEgASgC/AU2ApQDIAEgASgCgAY2ApgDIAEgASgChAY2ApwDIAFBOGogAUHAB2oQ+wIgFBD2AiABIAEoAtQEIgQgASgCmARqNgKACiABIAEoAtgEIgYgASgCnARqNgKECiABIAEoAtwEIhEgASgCoARqNgKICiABIAEoAuAEIgcgASgCpARqNgKMCiABIAEoAuQEIgggASgCqARqNgKQCiABIAEoAugEIgkgASgCrARqNgKUCiABIAEoAuwEIgogASgCsARqNgKYCiABIAEoAvAEIgsgASgCtARqNgKcCiABIAEoAvQEIgwgASgCuARqNgKgCiABIAEoAvgEIgMgASgCvARqNgKkCiABIAEoAvwEIg0gASgCwARqNgKoCiABIAEoAoAFIg4gASgCxARqNgKsCiABIAEoAoQFIg8gASgCyARqNgKwCiABIAEoAogFIhAgASgCzARqNgK0CiABIAEoAowFIhMgASgC0ARqIgU2ArgKIAVBgICAEE4EQCABQYAKahDSAgsgAUHUBGohFiABQYAKaiABQYAKahDMAiABIAQgASgCgApqIgU2AqQNIAEgBiABKAKECmoiBjYCqA0gASARIAEoAogKaiIRNgKsDSABIAcgASgCjApqIgc2ArANIAEgCCABKAKQCmoiCDYCtA0gASAJIAEoApQKaiIJNgK4DSABIAogASgCmApqIgo2ArwNIAEgCyABKAKcCmoiCzYCwA0gASAMIAEoAqAKaiIMNgLEDSABIAMgASgCpApqIgM2AsgNIAEgDSABKAKoCmoiDTYCzA0gASAOIAEoAqwKaiIONgLQDSABIA8gASgCsApqIg82AtQNIAEgECABKAK0CmoiEDYC2A0gASATIAEoArgKaiIENgLcDSAEQYCAgBBOBEAgAUGkDWoQ0gIgASgC3A0hBCABKALYDSEQIAEoAtQNIQ8gASgC0A0hDiABKALMDSENIAEoAsQNIQwgASgCwA0hCyABKAK8DSEKIAEoArgNIQkgASgCtA0hCCABKAKwDSEHIAEoAqwNIREgASgCqA0hBiABKAKkDSEFIAEoAsgNIQMLIBYgAUGACmogFBD3AiABIAQ2AtAEIAEgEDYCzAQgASAPNgLIBCABIA42AsQEIAEgDTYCwAQgASADNgK8BCABIAw2ArgEIAEgCzYCtAQgASAKNgKwBCABIAk2AqwEIAEgCDYCqAQgASAHNgKkBCABIBE2AqAEIAEgBjYCnAQgASAFNgKYBCAUEPYCIAEgASgCoAM2AoAKIAEgAf0AAqQD/QsChAogASAB/QACtAP9CwKUCiABIAEoAsQDNgKkCiABIAH9AALIA/0LAqgKIAEgASkC2AM3ArgKIAEgASgC4AM2AsAKIAEgASkC5AM3AsQKIAEgASgC7AM2AswKIAEgASgC8AM2AtAKIAEgAf0AAvQD/QsC1AogASAB/QAChAT9CwLkCiABIAH9AAKUBP0LAvQKIAEgAf0AAqQE/QsChAsgASAB/QACtAT9CwKUCyABIAH9AALEBP0LAqQLIAEgASkC1AQ3ArQLIAEgASgC3AQ2ArwLIAEgASgC4AQ2AsALIAEgAf0AAuQE/QsCxAsgASAB/QAC9AT9CwLUCyABIAH9AAKEBf0LAuQLIAEgAf0AApQF/QsC9AsgASAB/QACpAX9CwKEDCABIAH9AAK0Bf0LApQMIAEgASkCxAU3AqQMIAEgASgCzAU2AqwMIAEgASgC0AU2ArAMIAEgASgC1AU2ArQMIAEgASgC2AU2ArgMIAEgASgC3AU2ArwMIAEgASgC4AU2AsAMIAEgASgC5AU2AsQMIAEgASgC6AU2AsgMIAEgASgC7AU2AswMIAEgASgC8AU2AtAMIAEgASgC9AU2AtQMIAEgASgC+AU2AtgMIAEgASgC/AU2AtwMIAEgASgCgAY2AuAMIAEgASgChAY2AuQMIAFB+ApqIgUQ9gIgASABKAK0CyIEIAEoAvgKajYCpA0gASABKAK4CyIRIAEoAvwKajYCqA0gASABKAK8CyIHIAEoAoALajYCrA0gASABKALACyIIIAEoAoQLajYCsA0gASABKALECyIJIAEoAogLajYCtA0gASABKALICyIKIAEoAowLajYCuA0gASABKALMCyILIAEoApALajYCvA0gASABKALQCyIMIAEoApQLajYCwA0gASABKALUCyIDIAEoApgLajYCxA0gASABKALYCyINIAEoApwLajYCyA0gASABKALcCyIOIAEoAqALajYCzA0gASABKALgCyIPIAEoAqQLajYC0A0gASABKALkCyIQIAEoAqgLajYC1A0gASABKALoCyITIAEoAqwLajYC2A0gASABKALsCyIWIAEoArALaiIGNgLcDSAGQYCAgBBOBEAgAUGkDWoQ0gILIAFBtAtqIRkgAUGkDWogAUGkDWoQzAIgASAEIAEoAqQNaiIGNgLoDCABIBEgASgCqA1qIhE2AuwMIAEgByABKAKsDWoiBzYC8AwgASAIIAEoArANaiIINgL0DCABIAkgASgCtA1qIgk2AvgMIAEgCiABKAK4DWoiCjYC/AwgASALIAEoArwNaiILNgKADSABIAwgASgCwA1qIgw2AoQNIAEgAyABKALEDWoiAzYCiA0gASANIAEoAsgNaiINNgKMDSABIA4gASgCzA1qIg42ApANIAEgDyABKALQDWoiDzYClA0gASAQIAEoAtQNaiIQNgKYDSABIBMgASgC2A1qIhM2ApwNIAEgFiABKALcDWoiBDYCoA0gBEGAgIAQTgRAIAFB6AxqENICIAEoAqANIQQgASgCnA0hEyABKAKYDSEQIAEoApQNIQ8gASgCkA0hDiABKAKMDSENIAEoAoQNIQwgASgCgA0hCyABKAL8DCEKIAEoAvgMIQkgASgC9AwhCCABKALwDCEHIAEoAuwMIREgASgC6AwhBiABKAKIDSEDCyAZIAFBpA1qIAUQ9wIgASAENgKwCyABIBM2AqwLIAEgEDYCqAsgASAPNgKkCyABIA42AqALIAEgDTYCnAsgASADNgKYCyABIAw2ApQLIAEgCzYCkAsgASAKNgKMCyABIAk2AogLIAEgCDYChAsgASAHNgKACyABIBE2AvwKIAEgBjYC+AogBRD2AiABQThqIAFBgApqEPQCIAFBgApqIBIQ5AIgAUH4CmoiBCACEOQCIAFB8AtqIBUQ5AIgBBD2AiABIAEoArQLIAEoAvgKajYCpA0gASABKAK4CyIFIAEoAvwKajYCqA0gASABKAK8CyIHIAEoAoALajYCrA0gASABKALACyIIIAEoAoQLajYCsA0gASABKALECyIJIAEoAogLajYCtA0gASABKALICyIKIAEoAowLajYCuA0gASABKALMCyILIAEoApALajYCvA0gASABKALQCyIMIAEoApQLajYCwA0gASABKALUCyIDIAEoApgLajYCxA0gASABKALYCyINIAEoApwLajYCyA0gASABKALcCyIOIAEoAqALajYCzA0gASABKALgCyIPIAEoAqQLajYC0A0gASABKALkCyIQIAEoAqgLajYC1A0gASABKALoCyITIAEoAqwLajYC2A0gASABKALsCyIWIAEoArALaiIGNgLcDSAGQYCAgBBOBEAgAUGkDWoQ0gILIAFBtAtqIRkgAUGkDWogAUGkDWoQzAIgASABKAK0CyABKAKkDWoiBjYC6AwgASAFIAEoAqgNaiIRNgLsDCABIAcgASgCrA1qIgc2AvAMIAEgCCABKAKwDWoiCDYC9AwgASAJIAEoArQNaiIJNgL4DCABIAogASgCuA1qIgo2AvwMIAEgCyABKAK8DWoiCzYCgA0gASAMIAEoAsANaiIMNgKEDSABIAMgASgCxA1qIgM2AogNIAEgDSABKALIDWoiDTYCjA0gASAOIAEoAswNaiIONgKQDSABIA8gASgC0A1qIg82ApQNIAEgECABKALUDWoiEDYCmA0gASATIAEoAtgNaiITNgKcDSABIBYgASgC3A1qIgU2AqANIAVBgICAEE4EQCABQegMahDSAiABKAKgDSEFIAEoApwNIRMgASgCmA0hECABKAKUDSEPIAEoApANIQ4gASgCjA0hDSABKAKEDSEMIAEoAoANIQsgASgC/AwhCiABKAL4DCEJIAEoAvQMIQggASgC8AwhByABKALsDCERIAEoAugMIQYgASgCiA0hAwsgGSABQaQNaiAEEPcCIAEgBTYCsAsgASATNgKsCyABIBA2AqgLIAEgDzYCpAsgASAONgKgCyABIA02ApwLIAEgAzYCmAsgASAMNgKUCyABIAs2ApALIAEgCjYCjAsgASAJNgKICyABIAg2AoQLIAEgBzYCgAsgASARNgL8CiABIAY2AvgKIAQQ9gIgAUE4aiABQYAKahD0AiABQYAKaiASEOQCIAFB+ApqIgQgAhDkAiABQfALaiAVEOQCIAQQ9gIgASABKAK0CyABKAL4Cmo2AqQNIAEgASgCuAsiBSABKAL8Cmo2AqgNIAEgASgCvAsiByABKAKAC2o2AqwNIAEgASgCwAsiCCABKAKEC2o2ArANIAEgASgCxAsiCSABKAKIC2o2ArQNIAEgASgCyAsiCiABKAKMC2o2ArgNIAEgASgCzAsiCyABKAKQC2o2ArwNIAEgASgC0AsiDCABKAKUC2o2AsANIAEgASgC1AsiAyABKAKYC2o2AsQNIAEgASgC2AsiDSABKAKcC2o2AsgNIAEgASgC3AsiDiABKAKgC2o2AswNIAEgASgC4AsiDyABKAKkC2o2AtANIAEgASgC5AsiECABKAKoC2o2AtQNIAEgASgC6AsiEyABKAKsC2o2AtgNIAEgASgC7AsiFiABKAKwC2oiBjYC3A0gBkGAgIAQTgRAIAFBpA1qENICCyABQcwFaiEZIAFBpA1qIAFBpA1qEMwCIAEgASgCtAsgASgCpA1qIgY2AugMIAEgBSABKAKoDWoiETYC7AwgASAHIAEoAqwNaiIHNgLwDCABIAggASgCsA1qIgg2AvQMIAEgCSABKAK0DWoiCTYC+AwgASAKIAEoArgNaiIKNgL8DCABIAsgASgCvA1qIgs2AoANIAEgDCABKALADWoiDDYChA0gASADIAEoAsQNaiIDNgKIDSABIA0gASgCyA1qIg02AowNIAEgDiABKALMDWoiDjYCkA0gASAPIAEoAtANaiIPNgKUDSABIBAgASgC1A1qIhA2ApgNIAEgEyABKALYDWoiEzYCnA0gASAWIAEoAtwNaiIFNgKgDSAFQYCAgBBOBEAgAUHoDGoQ0gIgASgCoA0hBSABKAKcDSETIAEoApgNIRAgASgClA0hDyABKAKQDSEOIAEoAowNIQ0gASgChA0hDCABKAKADSELIAEoAvwMIQogASgC+AwhCSABKAL0DCEIIAEoAvAMIQcgASgC7AwhESABKALoDCEGIAEoAogNIQMLIAFBtAtqIAFBpA1qIAQQ9wIgASAFNgKwCyABIBM2AqwLIAEgEDYCqAsgASAPNgKkCyABIA42AqALIAEgDTYCnAsgASADNgKYCyABIAw2ApQLIAEgCzYCkAsgASAKNgKMCyABIAk2AogLIAEgCDYChAsgASAHNgKACyABIBE2AvwKIAEgBjYC+AogBBD2AiABQaADaiABQYAKahD0AiABQYAKaiABQYgGahCHAyABQaADaiABQaADahCIAyAUIBQQiAMgFyAXEIgDIBcQ0gIgGRDSAiABQaADaiABQYAKaiABQaADahD5AiAUIAFBgApqIBQQ+QIgFCABQYgGaiAUEPkCIBIQiQMgAUGACmogAUGIBmoQhwMgEiASEIgDIAIgAhCIAyAVIBUQiAMgFRDSAiAYQbQCaiIUENICIBIgAUGACmogEhD5AiACIAFBgApqIAIQ+QIgAiABQYgGaiACEPkCIAFBgApqIAFBiAZqEIcDIBIgEhCIAyACIAIQiAMgFSAVEIgDIBUQ0gIgFBDSAiASIAFBgApqIBIQ+QIgAiABQYAKaiACEPkCIAIgAUGIBmogAhD5AiASIAFBOGoQ9AIgEiABQaADahD0AiASEOgCIBoQmgEgAUHi3Sk2AhAgAEHghyogAUEQahCbASABQeANaiQAQQELhQQBAX8jAEHwAWsiAyQAIANCq9SZ9cEBNwMwIANCvLn+6PDPrbwCNwMoIANCmcfZ2fHo26kcNwMgIANC28vDi5G2iccINwMYIANC0tm486C1k7QRNwMQIANC6Kf2lrDkmJEJNwMIIANCru/7reGh85gQNwMAIANBQGsgASADENMCIANCo73EgNABNwPgASADQu3Tm5bBpvP/EjcD2AEgA0LL7pG74ayXjRI3A9ABIANCw7n216CUnM8QNwPIASADQuqDifuA656oCTcDwAEgA0Lu//+noaz//xc3A7gBIANCq9X+//H///sPNwOwASAAIANBsAFqIANBQGsQyQIgAEECNgI4IANCq9SZ9cEBNwMwIANCvLn+6PDPrbwCNwMoIANCmcfZ2fHo26kcNwMgIANC28vDi5G2iccINwMYIANC0tm486C1k7QRNwMQIANC6Kf2lrDkmJEJNwMIIANCru/7reGh85gQNwMAIANBQGsgAiADENMCIANCo73EgNABNwPgASADQu3Tm5bBpvP/EjcD2AEgA0LL7pG74ayXjRI3A9ABIANCw7n216CUnM8QNwPIASADQuqDifuA656oCTcDwAEgA0Lu//+noaz//xc3A7gBIANCq9X+//H///sPNwOwASAAQTxqIANBsAFqIANBQGsQyQIgAEECNgJ0IANB8AFqJAAL9BYDEX8BewF+IwBBsARrIgIkACACQcABaiABEIcDIAJBCGogAkHAAWogARD5AiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsClAEgAiAT/QsCpAEgAkEANgK0ASACQQQ2AoABIAIgE/0LAoQBIAJCq9SZ9cEBNwOgBCACQry5/ujwz628AjcDmAQgAkKZx9nZ8ejbqRw3A5AEIAJC28vDi5G2iccINwOIBCACQtLZuPOgtZO0ETcDgAQgAkLop/aWsOSYkQk3A/gDIAJCru/7reGh85gQNwPwAyACQcACaiACQYABaiACQfADahDTAiACQqO9xIDQATcD4AMgAkLt05uWwabz/xI3A9gDIAJCy+6Ru+Gsl40SNwPQAyACQsO59teglJzPEDcDyAMgAkLqg4n7gOueqAk3A8ADIAJC7v//p6Gs//8XNwO4AyACQqvV/v/x///7DzcDsAMgAkHAAWogAkGwA2ogAkHAAmoQyQIgAiAT/QsChAIgAiAT/QsClAIgAiAT/QsCpAIgAkECNgL4ASACQgA3AvwBIAJBATYCtAIgAkHAAWoQ9gIgAkHAAWoQwwggAkHAAWoQ9gIgAkEIaiACQcABaiACQQhqEPcCIAJBxABqIgQgAkH8AWogBBD3AiACQQhqENICIAQQ0gICfwJAAkAgAkEIahC4AgRAIAQQuAINAQsgAjQCfCIUIBR+QoCAgBBaBEAgBBDSAgsgAkHAAWogBBC0AyACQqO9xIDQATcDoAQgAkLt05uWwabz/xI3A5gEIAJCy+6Ru+Gsl40SNwOQBCACQsO59teglJzPEDcDiAQgAkLqg4n7gOueqAk3A4AEIAJC7v//p6Gs//8XNwP4AyACQqvV/v/x///7DzcD8AMgAkHAAmogAkHwA2ogAkHAAWoQyQIgAkECNgL4AiACNAJAIhQgFH5CgICAEFoEQCACQQhqENICCyACQcABaiACQQhqELQDIAJCo73EgNABNwOgBCACQu3Tm5bBpvP/EjcDmAQgAkLL7pG74ayXjRI3A5AEIAJCw7n216CUnM8QNwOIBCACQuqDifuA656oCTcDgAQgAkLu//+noaz//xc3A/gDIAJCq9X+//H///sPNwPwAyACQbADaiACQfADaiACQcABahDJAiACQQI2AugDIAJBwAJqIAJBwAJqIAJBsANqEPcCIAJBwAJqEMAIRQ0BIAJBwAJqIAJBwAJqEPEFIAIgAigCwAIgAigCCGoiAzYCsAMgAiACKALEAiACKAIMaiIFNgK0AyACIAIoAsgCIAIoAhBqIgY2ArgDIAIgAigCzAIgAigCFGoiBzYCvAMgAiACKALQAiACKAIYaiIINgLAAyACIAIoAtQCIAIoAhxqIgk2AsQDIAIgAigC2AIgAigCIGoiCjYCyAMgAiACKALcAiACKAIkaiILNgLMAyACIAIoAuACIAIoAihqIgw2AtADIAIgAigC5AIgAigCLGoiDTYC1AMgAiACKALoAiACKAIwaiIONgLYAyACIAIoAuwCIAIoAjRqIg82AtwDIAIgAigC8AIgAigCOGoiEDYC4AMgAiACKAL0AiACKAI8aiIRNgLkAyACIAIoAvgCIAIoAkBqIhI2AugDIBJBgICAEE4EQCACQbADahDSAiACKALkAyERIAIoAuADIRAgAigC3AMhDyACKALYAyEOIAIoAtQDIQ0gAigC0AMhDCACKALMAyELIAIoAsgDIQogAigCxAMhCSACKALAAyEIIAIoArwDIQcgAigCuAMhBiACKAK0AyEFIAIoArADIQMLIAIgA0H/////AXE2ArADIAIgBSADQR11aiIDQf////8BcTYCtAMgAiAGIANBHXVqIgNB/////wFxNgK4AyACIAcgA0EddWoiA0H/////AXE2ArwDIAIgCCADQR11aiIDQf////8BcTYCwAMgAiAJIANBHXVqIgNB/////wFxNgLEAyACIAogA0EddWoiA0H/////AXE2AsgDIAIgCyADQR11aiIDQf////8BcTYCzAMgAiAMIANBHXVqIgNB/////wFxNgLQAyACIA0gA0EddWoiA0H/////AXE2AtQDIAIgDiADQR11aiIDQf////8BcTYC2AMgAiAPIANBHXVqIgNB/////wFxNgLcAyACIBAgA0EddWoiA0H/////AXE2AuADIAIgESADQR11ajYC5AMgAkGwA2ogAkGwA2oQvgggAkGwA2oQwAhFBEAgAkGwA2ogAkEIaiACQcACahC9CCACIAIoArADIgNB/////wFxNgKwAyACIAIoArQDIANBHXVqIgNB/////wFxNgK0AyACIAIoArgDIANBHXVqIgNB/////wFxNgK4AyACIAIoArwDIANBHXVqIgNB/////wFxNgK8AyACIAIoAsADIANBHXVqIgNB/////wFxNgLAAyACIAIoAsQDIANBHXVqIgNB/////wFxNgLEAyACIAIoAsgDIANBHXVqIgNB/////wFxNgLIAyACIAIoAswDIANBHXVqIgNB/////wFxNgLMAyACIAIoAtADIANBHXVqIgNB/////wFxNgLQAyACIAIoAtQDIANBHXVqIgNB/////wFxNgLUAyACIAIoAtgDIANBHXVqIgNB/////wFxNgLYAyACIAIoAtwDIANBHXVqIgNB/////wFxNgLcAyACIAIoAuADIANBHXVqIgNB/////wFxNgLgAyACIAIoAuQDIANBHXVqNgLkAyACQbADaiACQbADahC+CCACQbADahDACEUNAgsgAkGwA2ogAkGwA2oQ8QUgAiACKAKwAzYCCCACIAL9AAK0A/0LAgwgAiAC/QACxAP9CwIcIAIgAv0AAtQD/QsCLCACIAIpAuQDNwI8IAJBsANqIAJBsANqIAJBsANqEPcCIAJBsANqIAJBsANqEPAFIAI0AugDIAI0Anx+QoCAgBBZBEAgBBDSAgsgAkHAAWogBCACQbADahDTAiACQqO9xIDQATcDoAQgAkLt05uWwabz/xI3A5gEIAJCy+6Ru+Gsl40SNwOQBCACQsO59teglJzPEDcDiAQgAkLqg4n7gOueqAk3A4AEIAJC7v//p6Gs//8XNwP4AyACQqvV/v/x///7DzcD8AMgBCACQfADaiACQcABahDJAiACQQI2AnwLIAAgARDkAiAAQfABaiEEIAJB8ABrIABHBEAgACACKAIINgJ4IAAgAigCDDYCfCAAIAIoAhA2AoABIAAgAigCFDYChAEgACACKAIYNgKIASAAIAIoAhw2AowBIAAgAigCIDYCkAEgACACKAIkNgKUASAAIAIoAig2ApgBIAAgAigCLDYCnAEgACACKAIwNgKgASAAIAIoAjQ2AqQBIAAgAigCODYCqAEgACACKAI8NgKsASAAIAIoAkA2ArABIAAgAigCRDYCtAEgACACKAJINgK4ASAAIAIoAkw2ArwBIAAgAigCUDYCwAEgACACKAJUNgLEASAAIAIoAlg2AsgBIAAgAigCXDYCzAEgACACKAJgNgLQASAAIAIoAmQ2AtQBIAAgAigCaDYC2AEgACACKAJsNgLcASAAIAIoAnA2AuABIAAgAigCdDYC5AEgACACKAJ4NgLoASAAIAIoAnw2AuwBCyAEEIsDQQEMAQsgAEIANwIwIAAgE/0LAiAgACAT/QsCECAAIBP9CwIAIABCADcCPCAAQQE2AjggACAT/QsCRCAAIBP9CwJUIAAgE/0LAmQgAEEBNgJ0IABB+ABqEIsDIABCADcCoAIgACAT/QsCkAIgACAT/QsCgAIgACAT/QsC8AEgAEIANwKsAiAAQQE2AqgCIAAgE/0LArQCIAAgE/0LAsQCIAAgE/0LAtQCIABBATYC5AJBAAshACACQbAEaiQAIAAL5Q0CA38BfiMAQbACayICJAAgASABKAIAIgNB/////wFxNgIAIAEgASgCBCADQR11aiIDQf////8BcTYCBCABIAEoAgggA0EddWoiA0H/////AXE2AgggASABKAIMIANBHXVqIgNB/////wFxNgIMIAEgASgCECADQR11aiIDQf////8BcTYCECABIAEoAhQgA0EddWoiA0H/////AXE2AhQgASABKAIYIANBHXVqIgNB/////wFxNgIYIAEgASgCHCADQR11aiIDQf////8BcTYCHCABIAEoAiAgA0EddWoiA0H/////AXE2AiAgASABKAIkIANBHXVqIgNB/////wFxNgIkIAEgASgCKCADQR11aiIDQf////8BcTYCKCABIAEoAiwgA0EddWoiA0H/////AXE2AiwgASABKAIwIANBHXVqIgNB/////wFxNgIwIAEgASgCNCADQR11ajYCNCABIAEoAjwiA0H/////AXE2AjwgASABKAJAIANBHXVqIgNB/////wFxNgJAIAEgASgCRCADQR11aiIDQf////8BcTYCRCABIAEoAkggA0EddWoiA0H/////AXE2AkggASABKAJMIANBHXVqIgNB/////wFxNgJMIAEgASgCUCADQR11aiIDQf////8BcTYCUCABIAEoAlQgA0EddWoiA0H/////AXE2AlQgASABKAJYIANBHXVqIgNB/////wFxNgJYIAEgASgCXCADQR11aiIDQf////8BcTYCXCABIAEoAmAgA0EddWoiA0H/////AXE2AmAgASABKAJkIANBHXVqIgNB/////wFxNgJkIAEgASgCaCADQR11aiIDQf////8BcTYCaCABIAEoAmwgA0EddWoiA0H/////AXE2AmwgASABKAJwIANBHXVqNgJwIAE0AjgiBSAFfkKAgIAQWgRAIAEQ0gILIAFBPGohAyACQYABaiABELQDIAJCo73EgNABNwMwIAJC7dOblsGm8/8SNwMoIAJCy+6Ru+Gsl40SNwMgIAJCw7n216CUnM8QNwMYIAJC6oOJ+4DrnqgJNwMQIAJC7v//p6Gs//8XNwMIIAJCq9X+//H///sPNwMAIAJBxABqIAIgAkGAAWoQyQIgAkECNgJ8IAE0AnQiBSAFfkKAgIAQWgRAIAMQ0gILIAJBgAFqIAMQtAMgAkKjvcSA0AE3A6ACIAJC7dOblsGm8/8SNwOYAiACQsvukbvhrJeNEjcDkAIgAkLDufbXoJSczxA3A4gCIAJC6oOJ+4DrnqgJNwOAAiACQu7//6ehrP//FzcD+AEgAkKr1f7/8f//+w83A/ABIAIgAkHwAWogAkGAAWoQyQIgAkECNgI4IAJBxABqIAJBxABqIAIQ9wIgAkHEAGogAkHEAGoQ8AUgAjQCfCABNAI4fkKAgIAQWQRAIAEQ0gILIAJBgAFqIAEgAkHEAGoQ0wIgAkKjvcSA0AE3A6ACIAJC7dOblsGm8/8SNwOYAiACQsvukbvhrJeNEjcDkAIgAkLDufbXoJSczxA3A4gCIAJC6oOJ+4DrnqgJNwOAAiACQu7//6ehrP//FzcD+AEgAkKr1f7/8f//+w83A/ABIAAgAkHwAWogAkGAAWoQyQIgAEECNgI4IAJBxABqIAJBxABqEMwCIAIgAigCRCIEQf////8BcTYCRCACIAIoAkggBEEddWoiBEH/////AXE2AkggAiACKAJMIARBHXVqIgRB/////wFxNgJMIAIgAigCUCAEQR11aiIEQf////8BcTYCUCACIAIoAlQgBEEddWoiBEH/////AXE2AlQgAiACKAJYIARBHXVqIgRB/////wFxNgJYIAIgAigCXCAEQR11aiIEQf////8BcTYCXCACIAIoAmAgBEEddWoiBEH/////AXE2AmAgAiACKAJkIARBHXVqIgRB/////wFxNgJkIAIgAigCaCAEQR11aiIEQf////8BcTYCaCACIAIoAmwgBEEddWoiBEH/////AXE2AmwgAiACKAJwIARBHXVqIgRB/////wFxNgJwIAIgAigCdCAEQR11aiIEQf////8BcTYCdCACIAIoAnggBEEddWo2AnggAjQCfCABNAJ0fkKAgIAQWQRAIAMQ0gILIAJBgAFqIAMgAkHEAGoQ0wIgAkKjvcSA0AE3A6ACIAJC7dOblsGm8/8SNwOYAiACQsvukbvhrJeNEjcDkAIgAkLDufbXoJSczxA3A4gCIAJC6oOJ+4DrnqgJNwOAAiACQu7//6ehrP//FzcD+AEgAkKr1f7/8f//+w83A/ABIABBPGogAkHwAWogAkGAAWoQyQIgAEECNgJ0IAJBsAJqJAALwwsBA38jAEHwAmsiAiQAIAJBhAFqIAEgAUE8aiIEEPcCIAJBDGogBBDMAiACQcgAaiABIAEQ9wIgAiACKAJIIgNB/////wFxNgJIIAIgAigCTCADQR11aiIDQf////8BcTYCTCACIAIoAlAgA0EddWoiA0H/////AXE2AlAgAiACKAJUIANBHXVqIgNB/////wFxNgJUIAIgAigCWCADQR11aiIDQf////8BcTYCWCACIAIoAlwgA0EddWoiA0H/////AXE2AlwgAiACKAJgIANBHXVqIgNB/////wFxNgJgIAIgAigCZCADQR11aiIDQf////8BcTYCZCACIAIoAmggA0EddWoiA0H/////AXE2AmggAiACKAJsIANBHXVqIgNB/////wFxNgJsIAIgAigCcCADQR11aiIDQf////8BcTYCcCACIAIoAnQgA0EddWoiA0H/////AXE2AnQgAiACKAJ4IANBHXVqIgNB/////wFxNgJ4IAIgAigCfCADQR11ajYCfCAAQTxqIQMgATQCdCACNAKAAX5CgICAEFkEQCACQcgAahDSAgsgAkHAAWogAkHIAGogBBDTAiACQqO9xIDQATcD4AIgAkLt05uWwabz/xI3A9gCIAJCy+6Ru+Gsl40SNwPQAiACQsO59teglJzPEDcDyAIgAkLqg4n7gOueqAk3A8ACIAJC7v//p6Gs//8XNwO4AiACQqvV/v/x///7DzcDsAIgAyACQbACaiACQcABahDJAiAAQQI2AnQgACABIAJBDGoQ9wIgAiACKAKEASIBQf////8BcTYChAEgAiACKAKIASABQR11aiIBQf////8BcTYCiAEgAiACKAKMASABQR11aiIBQf////8BcTYCjAEgAiACKAKQASABQR11aiIBQf////8BcTYCkAEgAiACKAKUASABQR11aiIBQf////8BcTYClAEgAiACKAKYASABQR11aiIBQf////8BcTYCmAEgAiACKAKcASABQR11aiIBQf////8BcTYCnAEgAiACKAKgASABQR11aiIBQf////8BcTYCoAEgAiACKAKkASABQR11aiIBQf////8BcTYCpAEgAiACKAKoASABQR11aiIBQf////8BcTYCqAEgAiACKAKsASABQR11aiIBQf////8BcTYCrAEgAiACKAKwASABQR11aiIBQf////8BcTYCsAEgAiACKAK0ASABQR11aiIBQf////8BcTYCtAEgAiACKAK4ASABQR11ajYCuAEgACAAKAIAIgFB/////wFxNgIAIAAgACgCBCABQR11aiIBQf////8BcTYCBCAAIAAoAgggAUEddWoiAUH/////AXE2AgggACAAKAIMIAFBHXVqIgFB/////wFxNgIMIAAgACgCECABQR11aiIBQf////8BcTYCECAAIAAoAhQgAUEddWoiAUH/////AXE2AhQgACAAKAIYIAFBHXVqIgFB/////wFxNgIYIAAgACgCHCABQR11aiIBQf////8BcTYCHCAAIAAoAiAgAUEddWoiAUH/////AXE2AiAgACAAKAIkIAFBHXVqIgFB/////wFxNgIkIAAgACgCKCABQR11aiIBQf////8BcTYCKCAAIAAoAiwgAUEddWoiAUH/////AXE2AiwgACAAKAIwIAFBHXVqIgFB/////wFxNgIwIAAgACgCNCABQR11ajYCNCAANAI4IAI0ArwBfkKAgIAQWQRAIAJBhAFqENICCyACQcABaiACQYQBaiAAENMCIAJCo73EgNABNwPgAiACQu3Tm5bBpvP/EjcD2AIgAkLL7pG74ayXjRI3A9ACIAJCw7n216CUnM8QNwPIAiACQuqDifuA656oCTcDwAIgAkLu//+noaz//xc3A7gCIAJCq9X+//H///sPNwOwAiAAIAJBsAJqIAJBwAFqEMkCIABBAjYCOCACQfACaiQAC/QDACAAIAEoAgA2AgAgACABKAIENgIEIAAgASgCCDYCCCAAIAEoAgw2AgwgACABKAIQNgIQIAAgASgCFDYCFCAAIAEoAhg2AhggACABKAIcNgIcIAAgASgCIDYCICAAIAEoAiQ2AiQgACABKAIoNgIoIAAgASgCLDYCLCAAIAEoAjA2AjAgACABKAI0NgI0IAAgASgCODYCOCAAQTxqIAFBPGoQzAIgACAAKAI8IgFB/////wFxNgI8IAAgACgCQCABQR11aiIBQf////8BcTYCQCAAIAAoAkQgAUEddWoiAUH/////AXE2AkQgACAAKAJIIAFBHXVqIgFB/////wFxNgJIIAAgACgCTCABQR11aiIBQf////8BcTYCTCAAIAAoAlAgAUEddWoiAUH/////AXE2AlAgACAAKAJUIAFBHXVqIgFB/////wFxNgJUIAAgACgCWCABQR11aiIBQf////8BcTYCWCAAIAAoAlwgAUEddWoiAUH/////AXE2AlwgACAAKAJgIAFBHXVqIgFB/////wFxNgJgIAAgACgCZCABQR11aiIBQf////8BcTYCZCAAIAAoAmggAUEddWoiAUH/////AXE2AmggACAAKAJsIAFBHXVqIgFB/////wFxNgJsIAAgACgCcCABQR11ajYCcAvYEgEkfyMAQdAFayIBJAAgAUHwAWogAEH4AGoiBxDkAiABQdgEaiAHEIcDIAFB4ANqIAFB8AFqIABB8AFqIgIQ+QIgAUHoAmogAhCHAyAAIAEoAtgEIgVBAXQ2AvABIAAgASgC3AQiCEEBdDYC9AEgACABKALgBCIJQQF0NgL4ASAAIAEoAuQEIgpBAXQ2AvwBIAAgASgC6AQiC0EBdDYCgAIgACABKALsBCIMQQF0NgKEAiAAIAEoAvAEIg1BAXQ2AogCIAAgASgC9AQiDkEBdDYCjAIgACABKAL4BCIPQQF0NgKQAiAAIAEoAvwEIhBBAXQ2ApQCIAAgASgCgAUiEUEBdDYCmAIgACABKAKEBSISQQF0NgKcAiAAIAEoAogFIhNBAXQ2AqACIAAgASgCjAUiFEEBdDYCpAIgACABKAKQBSIEQQF0NgKoAiAEQYCAgAhOBEAgAhDSAgsgACABKAKUBSIVQQF0NgKsAiAAIAEoApgFIhZBAXQ2ArACIAAgASgCnAUiF0EBdDYCtAIgACABKAKgBSIYQQF0NgK4AiAAIAEoAqQFIhlBAXQ2ArwCIAAgASgCqAUiGkEBdDYCwAIgACABKAKsBSIbQQF0NgLEAiAAIAEoArAFIhxBAXQ2AsgCIAAgASgCtAUiHUEBdDYCzAIgACABKAK4BSIeQQF0NgLQAiAAIAEoArwFIh9BAXQ2AtQCIAAgASgCwAUiIEEBdDYC2AIgACABKALEBSIhQQF0NgLcAiAAIAEoAsgFIiJBAXQ2AuACIAAgASgCzAUiBkEBdDYC5AIgAEGsAmohAyAGQYCAgAhOBEAgAxDSAgsgAhD2AiACIAIgAhD3AiADIAMgAxD3AiACIAIgAhD3AiADIAMgAxD3AiACEPYCIAFB6AJqIAFB6AJqQQwQvAggAUGkA2oiAyADQQwQvAggAUHoAmoQwwggAUHoAmoQ9gIgAUH4AGogAUHoAmogAhD5AiABIAEoAugCIiMgBWo2AgAgASABKALsAiIkIAhqNgIEIAEgASgC8AIiCCAJajYCCCABIAEoAvQCIgkgCmo2AgwgASABKAL4AiIKIAtqNgIQIAEgASgC/AIiCyAMajYCFCABIAEoAoADIgwgDWo2AhggASABKAKEAyINIA5qNgIcIAEgASgCiAMiDiAPajYCICABIAEoAowDIg8gEGo2AiQgASABKAKQAyIQIBFqNgIoIAEgASgClAMiESASajYCLCABIAEoApgDIhIgE2o2AjAgASABKAKcAyITIBRqNgI0IAEgASgCoAMiBSAEaiIENgI4IARBgICAEE4EQCABENICCyABIAEoAqQDIhQgFWo2AjwgASABKAKoAyIVIBZqNgJAIAEgASgCrAMiFiAXajYCRCABIAEoArADIhcgGGo2AkggASABKAK0AyIYIBlqNgJMIAEgASgCuAMiGSAaajYCUCABIAEoArwDIhogG2o2AlQgASABKALAAyIbIBxqNgJYIAEgASgCxAMiHCAdajYCXCABIAEoAsgDIh0gHmo2AmAgASABKALMAyIeIB9qNgJkIAEgASgC0AMiHyAgajYCaCABIAEoAtQDIiAgIWo2AmwgASABKALYAyIhICJqNgJwIAEgASgC3AMiBCAGaiIGNgJ0IAZBgICAEE4EQCABQTxqENICCyABEPYCIAIgAiABQeADahD5AiABIAVBAXQ2ApgEIAEgE0EBdDYClAQgASASQQF0NgKQBCABIBFBAXQ2AowEIAEgEEEBdDYCiAQgASAPQQF0NgKEBCABIA5BAXQ2AoAEIAEgDUEBdDYC/AMgASAMQQF0NgL4AyABIAtBAXQ2AvQDIAEgCkEBdDYC8AMgASAJQQF0NgLsAyABIAhBAXQ2AugDIAEgJEEBdDYC5AMgASAjQQF0NgLgAyAFQYCAgAhOBEAgAUHgA2oQ0gILIAEgBEEBdDYC1AQgASAhQQF0NgLQBCABICBBAXQ2AswEIAEgH0EBdDYCyAQgASAeQQF0NgLEBCABIB1BAXQ2AsAEIAEgHEEBdDYCvAQgASAbQQF0NgK4BCABIBpBAXQ2ArQEIAEgGUEBdDYCsAQgASAYQQF0NgKsBCABIBdBAXQ2AqgEIAEgFkEBdDYCpAQgASAVQQF0NgKgBCABIBRBAXQ2ApwEIAFBnARqIQIgBEGAgIAITgRAIAIQ0gILIAFB6AJqIAFB6AJqIAFB4ANqEPcCIAMgAyACEPcCIAFB6AJqEPYCIAFB2ARqIAFB2ARqIAFB6AJqEMEIIAFB2ARqEPYCIAEgASABQdgEahD5AiAAIAEoAnggASgCAGo2AnggACABKAJ8IAEoAgRqNgJ8IAAgASgCgAEgASgCCGo2AoABIAAgASgChAEgASgCDGo2AoQBIAAgASgCiAEgASgCEGo2AogBIAAgASgCjAEgASgCFGo2AowBIAAgASgCkAEgASgCGGo2ApABIAAgASgClAEgASgCHGo2ApQBIAAgASgCmAEgASgCIGo2ApgBIAAgASgCnAEgASgCJGo2ApwBIAAgASgCoAEgASgCKGo2AqABIAAgASgCpAEgASgCLGo2AqQBIAAgASgCqAEgASgCMGo2AqgBIAAgASgCrAEgASgCNGo2AqwBIAAgASgCsAEgASgCOGoiAjYCsAEgAkGAgIAQTgRAIAcQ0gILIAAgASgCtAEgASgCPGo2ArQBIAAgASgCuAEgASgCQGo2ArgBIAAgASgCvAEgASgCRGo2ArwBIAAgASgCwAEgASgCSGo2AsABIAAgASgCxAEgASgCTGo2AsQBIAAgASgCyAEgASgCUGo2AsgBIAAgASgCzAEgASgCVGo2AswBIAAgASgC0AEgASgCWGo2AtABIAAgASgC1AEgASgCXGo2AtQBIAAgASgC2AEgASgCYGo2AtgBIAAgASgC3AEgASgCZGo2AtwBIAAgASgC4AEgASgCaGo2AuABIAAgASgC5AEgASgCbGo2AuQBIAAgASgC6AEgASgCcGo2AugBIAAgASgC7AEgASgCdGoiAjYC7AEgAkGAgIAQTgRAIABBtAFqENICCyABQeADaiAAIAFB8AFqEPkCIAFB2ARqEPYCIAAgAUHYBGogAUHgA2oQ+QIgACAAIAAQ9wIgAEE8aiICIAIgAhD3AiAAEPYCIAcQ9gIgAUHQBWokAAuyAgICfwF7IwBBIGsiAiQAIAJB6acpNgIQIABB+YYqIAJBEGoQmwEgAEH0AkEBENoBIgFC8ICAgJAYNwIAIABB2OHOfUGU7SsQkAEaIABBfhDbASABQgA3AgggAUEBNgLwAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCECABIAP9CwIgIAEgA/0LAjAgAUIANwJEIAFBATYCQCABIAP9CwJMIAEgA/0LAlwgASAD/QsCbCABQQE2AnwgAUGAAWoQiwMgAUIANwKoAiABIAP9CwKYAiABIAP9CwKIAiABIAP9CwL4ASABQgA3ArQCIAFBATYCsAIgASAD/QsCvAIgASAD/QsCzAIgASAD/QsC3AIgAUEBNgLsAiACQemnKTYCACAAQeCHKiACEJsBIAJBIGokAEEBC40EAgJ/AXsjAEHwAmsiASQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwJUIAEgA/0LAmQgAUEANgJ0IAFBATYCQCABIAP9CwJEIAFCq9SZ9cEBNwOwASABQry5/ujwz628AjcDqAEgAUKZx9nZ8ejbqRw3A6ABIAFC28vDi5G2iccINwOYASABQtLZuPOgtZO0ETcDkAEgAULop/aWsOSYkQk3A4gBIAFCru/7reGh85gQNwOAASABQcABaiABQUBrIAFBgAFqENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiABQQRqIAFBsAJqIAFBwAFqEMkCIAAgASgCBDYCACAAIAEoAgg2AgQgACABKAIMNgIIIAAgASgCEDYCDCAAIAEoAhQ2AhAgACABKAIYNgIUIAAgASgCHDYCGCAAIAEoAiA2AhwgACABKAIkNgIgIAAgASgCKDYCJCAAIAEoAiw2AiggACABKAIwNgIsIAAgASgCNDYCMCABKAI4IQIgAEIANwI8IABBAjYCOCAAIAI2AjQgACAD/QsCRCAAIAP9CwJUIAAgA/0LAmQgAEEBNgJ0IAFB8AJqJAAL/wsCCH8BeyMAQdAEayIBJAAgAUGT0Ck2AiAgAEH5hiogAUEgahCbAQJAAkAgAEEBEMgBIgdFBEBB9tcpIQUMAQsgAEH0AkEBENoBIgJC8ICAgJAYNwIAIABB2OHOfUGU7SsQkAEaIABBfhDbASACQQE2AvACQdabKiEFIAcoAggtAAAiBkHfAUsNACAGQaABcUEgRg0AIAZBwABxIQQgBygCACEDAkACQAJAIAbAQQBIBEAgA0HgAEcNBCAEDQEgAEEwEJgBIgUoAggiAyAHKAIIIgT9AAAA/QsAACADIAT9AAAg/QsAICADIAT9AAAQ/QsAECADIAMtAABBH3E6AAAgBUEwNgIAIABBMBCYASIIKAIIIgMgBygCCCIE/QAAMP0LAAAgAyAE/QAAUP0LACAgAyAEQUBr/QAAAP0LABAgAyADLQAAQR9xOgAAIAhBMDYCACAAQRhBARDaASEDIABB2OHOfUGx8CoQkAEaIABBfhDbASADQQA7ARQgA0IgNwIIIANBADYCECADQQE6AAAgAEEYQQEQ2gEhBCAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgBEEAOwEUIARCIDcCCCAEQQA2AhAgBEEBOgAAIAAgAyAFEOICGiAAIAQgCBDiAhogBRCaASAIEJoBIAFBqAJqIAQoAgwgAygCDBCEAyACQQhqIgIgAUGoAmoQhQNFDQMgAUGoAmogAUGwAWogAhD+AiABQbABahDSAiABQewBahDSAiABQYwEaiIDQQA2AgAgAUHsA2oiBP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUH8A2oiBSAJ/QsCACABIAEoArABNgKgAyABIAH9AAK0Af0LAqQDIAEgAf0AAsQB/QsCtAMgASABKALUATYCxAMgASABKQLYATcDyAMgASABKALgATYC0AMgASAJ/QsC3AMgASABKALkASIIQf////8BcTYC1AMgASAIQR11NgLYAyABQqO9xIDQATcDwAQgAULt05uWwabz/xI3A7gEIAFCy+6Ru+Gsl40SNwOwBCABQsO59teglJzPEDcDqAQgAULqg4n7gOueqAk3A6AEIAFC7v//p6Gs//8XNwOYBCABQqvV/v/x///7DzcDkAQgAUHwAGogAUGQBGogAUGgA2oQyQIgBSAJ/QsCACAEIAn9CwIAIANBADYCACABIAH9AALsAf0LBKADIAEgAf0AAvwB/QsEsAMgASABKAKMAjYCwAMgASAB/QACkAL9CwLEAyABIAEoAqACIgNB/////wFxNgLUAyABIANBHXU2AtgDIAEgCf0LAtwDIAFCo73EgNABNwPABCABQu3Tm5bBpvP/EjcDuAQgAULL7pG74ayXjRI3A7AEIAFCw7n216CUnM8QNwOoBCABQuqDifuA656oCTcDoAQgAULu//+noaz//xc3A5gEIAFCq9X+//H///sPNwOQBCABQTBqIAFBkARqIAFBoANqEMkCIAFB8ABqIAFBMGoQ5gIgBkHgAXFBBXZBAXFHBEAgAhDqAgsgACgCJCIGIAAoAgxBCGsiAk8EQCAAIAJBf0EAEF4hAiAAKAIkIQYLIAAgAjYCDCAAIAJBCGsiAiAGTQR/IAAgAkF/QQAQXgUgAgs2AgwMAgtB1psqQZm0KyADQcABRyIGGyEFIARFDQMgBg0DCyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCCCACQgA3AkQgAkEBNgJAIAJBATYCfCACQgA3AjggAiAJ/QsCKCACIAn9CwIYIAIgCf0LAkwgAiAJ/QsCXCACIAn9CwJsIAJBgAFqEIsDIAJCADcCqAIgAiAJ/QsCmAIgAiAJ/QsCiAIgAiAJ/QsC+AEgAkIANwK0AiACQQE2ArACIAIgCf0LArwCIAIgCf0LAswCIAIgCf0LAtwCIAJBATYC7AILIAcQmgEgAUGT0Ck2AhAgAEHghyogAUEQahCbASABQdAEaiQAQQEPCyAHEJoBQeX4KiEFDAELIAcQmgELIAEgBTYCBCABQZPQKTYCACAAQfyIKiABEGwAC+ifAQGeAX8jAEGQH2siAyQAIANB8aQqNgJAIABB+YYqIANBQGsQmwECQCAAQQFBlO0rENwBIgwEQCAMIAwoAvACQQFqNgLwAgwBCyAAQQEQyAEiBkUNACAGKAIILQAAIgJB3wFNIAJBoAFxQSBHcUUEQCADQQE2AjAgAEGJuSsgA0EwahBuCyAGEJoBCwJAAkAgAEECELECIhIEQCAAQewFQQEQ2gEhBiAAQdjhzn1B0e4rEJABGiAAQX4Q2wEgBkLUhYCAgAQ3AhAgBkGz7CsoAAA2AAMgBkGw7CsoAAA2AAAgA0HUBTYCICAAQav4KyADQSBqEFsgDEEIaiIEEOgCIBJBCGoiBRC+AiMAQbAiayIBJAAgAUHkFmr9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFB9BZq/QwAAAAAAAAAAAAAAAAAAAAA/QsCACABQawWav0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUG8FmpCADcCACABQTQ2AtgWIAFBhBdqQQA2AgAgAUHEFmpBADYCACABQgA3AtwWIAFCgICEgICAgIQQNwPQFiABQZ0BNgKYFiABQoCAjICAgICMEDcDkBYgAf0MAAAAAAAAAAAAAAAAAAAAAP0LApwWIAFBkBZqELADIQggAUHgDGogBBDkAiABQdgNaiAEQfgAahDkAiABQdAOaiAEQfABahDkAiABIAUoAgA2AqwLIAEgBSgCBDYCsAsgASAFKAIINgK0CyABIAUoAgw2ArgLIAEgBSgCEDYCvAsgASAFKAIUNgLACyABIAUoAhg2AsQLIAEgBSgCHDYCyAsgASAFKAIgNgLMCyABIAUoAiQ2AtALIAEgBSgCKDYC1AsgASAFKAIsNgLYCyABIAUoAjA2AtwLIAEgBSgCNDYC4AsgASAFKAI4NgLkCyABIAUoAjw2AugLIAEgBSgCQDYC7AsgASAFKAJENgLwCyABIAUoAkg2AvQLIAEgBSgCTDYC+AsgASAFKAJQNgL8CyABIAUoAlQ2AoAMIAEgBSgCWDYChAwgASAFKAJcNgKIDCABIAUoAmA2AowMIAEgBSgCZDYCkAwgASAFKAJoNgKUDCABIAUoAmw2ApgMIAEgBSgCcDYCnAwgASAFKAJ0NgKgDCABIAUoAng2AqQMIAEgBSgCfDYCqAwgASAFKAKAATYCrAwgASAFKAKEATYCsAwgASAFKAKIATYCtAwgASAFKAKMATYCuAwgASAFKAKQATYCvAwgASAFKAKUATYCwAwgASAFKAKYATYCxAwgASAFKAKcATYCyAwgASAFKAKgATYCzAwgASAFKAKkATYC0AwgASAFKAKoATYC1AwgASAFKAKsATYC2AwgASAFKAKwATYC3AwgAUHgDGoQ6AIgAUGsC2oQvgIgASABKAKsCzYC1BUgASAB/QACsAv9CwLYFSABIAH9AALAC/0LAugVIAEgAf0AAtAL/QsC+BUgASABKQLgCzcCiBYgASAB/QAC6Av9CwKYFSABIAH9AAL4C/0LAqgVIAEgASkCiAw3ArgVIAEgASgCkAw2AsAVIAEgAf0AApQM/QsCxBUgASABKALgDDYCsBIgASAB/QAC5Az9CwK0EiABIAH9AAL0DP0LAsQSIAEgAf0AAoQN/QsC1BIgASAB/QAClA39CwLkEiABIAEpAqQNNwL0EiABIAEoAqwNNgL8EiABIAEoArANNgKAEyABIAEoArQNNgKEEyABIAH9AAK4Df0LAogTIAEgAf0AAsgN/QsCmBMgASAB/QAC2A39CwKoEyABIAH9AALoDf0LArgTIAEgAf0AAvgN/QsCyBMgASAB/QACiA79CwLYEyABIAEpApgONwLoEyABIAEoAqAONgLwEyABIAEoAqQONgL0EyABIAEoAqgONgL4EyABIAEoAqwONgL8EyABIAEoArAONgKAFCABIAEoArQONgKEFCABIAEoArgONgKIFCABIAEoArwONgKMFCABIAEoAsAONgKQFCABIAEoAsQONgKUFCABIAEoAsgONgKYFCABIAEoAswONgKcFCABIAEoAtAONgKgFCABIAEoAtQONgKkFCABIAEoAtgONgKoFCABIAEoAtwONgKsFCABIAEoAuAONgKwFCABIAEoAuQONgK0FCABIAEoAugONgK4FCABIAEoAuwONgK8FCABIAEoAvAONgLAFCABIAEoAvQONgLEFCABIAEoAvgONgLIFCABIAEoAvwONgLMFCABIAEoAoAPNgLQFCABIAEoAoQPNgLUFCABIAEoAogPNgLYFCABIAEoAowPNgLcFCABIAEoApAPNgLgFCABIAEoApQPNgLkFCABIAEoApgPNgLoFCABIAEoApwPNgLsFCABIAEoAqAPNgLwFCABIAEoAqQPNgL0FCABIAEoAqgPNgL4FCABIAEoAqwPNgL8FCABIAEoArAPNgKAFSABIAEoArQPNgKEFSABIAEoArgPNgKIFSABIAEoArwPNgKMFSABIAEoAsAPNgKQFSABIAEoAsQPNgKUFSABIAEoAuAMNgLIDyABIAEoAuQMNgLMDyABIAEoAugMNgLQDyABIAEoAuwMNgLUDyABIAEoAvAMNgLYDyABIAEoAvQMNgLcDyABIAEoAvgMNgLgDyABIAEoAvwMNgLkDyABIAEoAoANNgLoDyABIAEoAoQNNgLsDyABIAEoAogNNgLwDyABIAEoAowNNgL0DyABIAEoApANNgL4DyABIAEoApQNNgL8DyABIAEoApgNNgKAECABIAEoApwNNgKEECABIAEoAqANNgKIECABIAEoAqQNNgKMECABIAEoAqgNNgKQECABIAEoAqwNNgKUECABIAEoArANNgKYECABIAEoArQNNgKcECABIAEoArgNNgKgECABIAEoArwNNgKkECABIAEoAsANNgKoECABIAEoAsQNNgKsECABIAEoAsgNNgKwECABIAEoAswNNgK0ECABIAEoAtANNgK4ECABIAEoAtQNNgK8ECABIAEoAtgNNgLAECABIAEoAtwNNgLEECABIAEoAuANNgLIECABIAEoAuQNNgLMECABIAEoAugNNgLQECABIAEoAuwNNgLUECABIAEoAvANNgLYECABIAEoAvQNNgLcECABIAEoAvgNNgLgECABIAEoAvwNNgLkECABIAEoAoAONgLoECABIAEoAoQONgLsECABIAEoAogONgLwECABIAEoAowONgL0ECABIAEoApAONgL4ECABIAEoApQONgL8ECABIAEoApgONgKAESABIAEoApwONgKEESABIAEoAqAONgKIESABIAEoAqQONgKMESABIAEoAqgONgKQESABIAEoAqwONgKUESABIAEoArAONgKYESABIAEoArQONgKcESABIAEoArgONgKgESABIAEoArwONgKkESABIAEoAsAONgKoESABIAEoAsQONgKsESABIAEoAsgONgKwESABIAEoAswONgK0ESABIAEoAtAONgK4ESABIAEoAtQONgK8ESABIAEoAtgONgLAESABIAEoAtwONgLEESABIAEoAuAONgLIESABIAEoAuQONgLMESABIAEoAugONgLQESABIAEoAuwONgLUESABIAEoAvAONgLYESABIAEoAvQONgLcESABIAEoAvgONgLgESABIAEoAvwONgLkESABIAEoAoAPNgLoESABIAEoAoQPNgLsESABIAEoAogPNgLwESABIAEoAowPNgL0ESABIAEoApAPNgL4ESABIAEoApQPNgL8ESABIAEoApgPNgKAEiABIAEoApwPNgKEEiABIAEoAqAPNgKIEiABIAEoAqQPNgKMEiABIAEoAqgPNgKQEiABIAEoAqwPNgKUEiABIAEoArAPNgKYEiABIAEoArQPNgKcEiABIAEoArgPNgKgEiABIAEoArwPNgKkEiABIAEoAsAPNgKoEiABIAEoAsQPNgKsEiABQcgPahDqAiAGQRhqIgIQiwMgAkIANwKoASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCmAEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAogBIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwJ4IAJBATYCsAEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LArQBIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwLEASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsC1AEgAkIANwLkASACQQE2AuwBIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwLwASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCgAIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LApACIAJCADcCoAIgAkIANwKsAiACQQE2AqgCIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwK0AiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCxAIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAtQCIAJCADcCmAMgAkEBNgLkAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCiAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAvgCIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwLoAiACQgA3AtQDIAJBATYCoAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAsQDIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwK0AyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCpAMgAkIANwKQBCACQQE2AtwDIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwKABCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsC8AMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAuADIAJBATYCmAQgAkIANwKIBSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsC+AQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAugEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwLYBCACQoGAgIAQNwLMBSACQgA3AsQFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwK0BSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCpAUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LApQFIAJBATYCkAUgAkEBNgLUBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCvAQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAqwEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwKcBCACQgA3AswEIAJB4ANqIQ8gAkHwAWohDSAIQQNOBEAgAkGUBWohGiACQdgEaiETIAJBnARqIRsgAkGkA2ohFiACQegCaiEKIAJBrAJqIRcgAkG0AWohICACQfgAaiEcIAJBPGohISAIQQJrIQggAUHACGohLSABQcgHaiFiIAFBpBxqIR0gAUGsG2ohHiABQcQYaiEYIAFBiBhqIRAgAUHMF2ohGSABQZQeaiEfIAFB2B1qIRQgAUGcHWohCSABQYQgaiEqIAFByB9qISIgAUGMH2ohKyABQegbaiEVIAFBsApqISwgAUG4CWohYyABQbQaaiELIAFB+BlqIQcgAUG8GWohDgNAIAIgAhDaAyABQdgFaiABQbASaiABQbASaiABQdQVaiABQZgVahDLCCABQeAMaiEEAkACQAJAIAgiBUEdbSIIQQJ0IiMgAUGQFmpqKAIAIAhBY2wgBWoiCHZBAXEgAUHQFmogI2ooAgAgCHZBAXFrQQFqDgMAAgECCyABQcgPaiEECyABQQRqIAFBsBJqIAQgAUHUFWogAUGYFWoQywggAUHYBWogAUEEahDICAsCQCACKALQBSIEQQFGBEAgAUHYBWogAkYNASACIAEoAtgFNgIAIAIgASgC3AU2AgQgAiABKALgBTYCCCACIAEoAuQFNgIMIAIgASgC6AU2AhAgAiABKALsBTYCFCACIAEoAvAFNgIYIAIgASgC9AU2AhwgAiABKAL4BTYCICACIAEoAvwFNgIkIAIgASgCgAY2AiggAiABKAKEBjYCLCACIAEoAogGNgIwIAIgASgCjAY2AjQgAiABKAKQBjYCOCACIAEoApQGNgI8IAIgASgCmAY2AkAgAiABKAKcBjYCRCACIAEoAqAGNgJIIAIgASgCpAY2AkwgAiABKAKoBjYCUCACIAEoAqwGNgJUIAIgASgCsAY2AlggAiABKAK0BjYCXCACIAEoArgGNgJgIAIgASgCvAY2AmQgAiABKALABjYCaCACIAEoAsQGNgJsIAIgASgCyAY2AnAgAiABKALMBjYCdCACIAEoAtAGNgJ4IAIgASgC1AY2AnwgAiABKALYBjYCgAEgAiABKALcBjYChAEgAiABKALgBjYCiAEgAiABKALkBjYCjAEgAiABKALoBjYCkAEgAiABKALsBjYClAEgAiABKALwBjYCmAEgAiABKAL0BjYCnAEgAiABKAL4BjYCoAEgAiABKAL8BjYCpAEgAiABKAKABzYCqAEgAiABKAKEBzYCrAEgAiABKAKIBzYCsAEgAiABKAKMBzYCtAEgAiABKAKQBzYCuAEgAiABKAKUBzYCvAEgAiABKAKYBzYCwAEgAiABKAKcBzYCxAEgAiABKAKgBzYCyAEgAiABKAKkBzYCzAEgAiABKAKoBzYC0AEgAiABKAKsBzYC1AEgAiABKAKwBzYC2AEgAiABKAK0BzYC3AEgAiABKAK4BzYC4AEgAiABKAK8BzYC5AEgAiABKALABzYC6AEgAiABKALEBzYC7AEgAiABKALIBzYC8AEgAiABKALMBzYC9AEgAiABKALQBzYC+AEgAiABKALUBzYC/AEgAiABKALYBzYCgAIgAiABKALcBzYChAIgAiABKALgBzYCiAIgAiABKALkBzYCjAIgAiABKALoBzYCkAIgAiABKALsBzYClAIgAiABKALwBzYCmAIgAiABKAL0BzYCnAIgAiABKAL4BzYCoAIgAiABKAL8BzYCpAIgAiABKAKACDYCqAIgAiABKAKECDYCrAIgAiABKAKICDYCsAIgAiABKAKMCDYCtAIgAiABKAKQCDYCuAIgAiABKAKUCDYCvAIgAiABKAKYCDYCwAIgAiABKAKcCDYCxAIgAiABKAKgCDYCyAIgAiABKAKkCDYCzAIgAiABKAKoCDYC0AIgAiABKAKsCDYC1AIgAiABKAKwCDYC2AIgAiABKAK0CDYC3AIgAiABKAK4CDYC4AIgAiABKAK8CDYC5AIgAiABKALACDYC6AIgAiABKALECDYC7AIgAiABKALICDYC8AIgAiABKALMCDYC9AIgAiABKALQCDYC+AIgAiABKALUCDYC/AIgAiABKALYCDYCgAMgAiABKALcCDYChAMgAiABKALgCDYCiAMgAiABKALkCDYCjAMgAiABKALoCDYCkAMgAiABKALsCDYClAMgAiABKALwCDYCmAMgAiABKAL0CDYCnAMgAiABKAL4CDYCoAMgAiABKAL8CDYCpAMgAiABKAKACTYCqAMgAiABKAKECTYCrAMgAiABKAKICTYCsAMgAiABKAKMCTYCtAMgAiABKAKQCTYCuAMgAiABKAKUCTYCvAMgAiABKAKYCTYCwAMgAiABKAKcCTYCxAMgAiABKAKgCTYCyAMgAiABKAKkCTYCzAMgAiABKAKoCTYC0AMgAiABKAKsCTYC1AMgAiABKAKwCTYC2AMgAiABKAK0CTYC3AMgAiABKAK4CTYC4AMgAiABKAK8CTYC5AMgAiABKALACTYC6AMgAiABKALECTYC7AMgAiABKALICTYC8AMgAiABKALMCTYC9AMgAiABKALQCTYC+AMgAiABKALUCTYC/AMgAiABKALYCTYCgAQgAiABKALcCTYChAQgAiABKALgCTYCiAQgAiABKALkCTYCjAQgAiABKALoCTYCkAQgAiABKALsCTYClAQgAiABKALwCTYCmAQgAiABKAL0CTYCnAQgAiABKAL4CTYCoAQgAiABKAL8CTYCpAQgAiABKAKACjYCqAQgAiABKAKECjYCrAQgAiABKAKICjYCsAQgAiABKAKMCjYCtAQgAiABKAKQCjYCuAQgAiABKAKUCjYCvAQgAiABKAKYCjYCwAQgAiABKAKcCjYCxAQgAiABKAKgCjYCyAQgAiABKAKkCjYCzAQgAiABKAKoCjYC0AQgAiABKAKsCjYC1AQgAiABKAKwCjYC2AQgAiABKAK0CjYC3AQgAiABKAK4CjYC4AQgAiABKAK8CjYC5AQgAiABKALACjYC6AQgAiABKALECjYC7AQgAiABKALICjYC8AQgAiABKALMCjYC9AQgAiABKALQCjYC+AQgAiABKALUCjYC/AQgAiABKALYCjYCgAUgAiABKALcCjYChAUgAiABKALgCjYCiAUgAiABKALkCjYCjAUgAiABKALoCjYCkAUgAiABKALsCjYClAUgAiABKALwCjYCmAUgAiABKAL0CjYCnAUgAiABKAL4CjYCoAUgAiABKAL8CjYCpAUgAiABKAKACzYCqAUgAiABKAKECzYCrAUgAiABKAKICzYCsAUgAiABKAKMCzYCtAUgAiABKAKQCzYCuAUgAiABKAKUCzYCvAUgAiABKAKYCzYCwAUgAiABKAKcCzYCxAUgAiABKAKgCzYCyAUgAiABKAKkCzYCzAUgAiABKAKoCzYC0AUMAQsgASgCqAsiCEEBRg0AAkAgCEEDTgRAIAFBwCBqIAIgAUHYBWoQxggCQAJAAkAgCEEDRwRAIAIoAtAFQQNHDQIgFCAKIC0Q+QIgAUGQHWpCADcDACABQYAdav0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAUHwHGr9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwPgHCABQQE2ApgdIAn9DAAAAAAAAAAAAAAAAAAAAAD9CwIQIAlCADcCMCAJ/QwAAAAAAAAAAAAAAAAAAAAA/QsCICAJ/QwAAAAAAAAAAAAAAAAAAAAA/QsCACABQQE2AtQdIAFB4BxqIAogYhD5AgwBCyAUIAogLRD5AiABQZAdakIANwMAIAFBgB1q/QwAAAAAAAAAAAAAAAAAAAAA/QsDACABQfAcav0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA+AcIAFBATYCmB0gCf0MAAAAAAAAAAAAAAAAAAAAAP0LAhAgCUIANwIwIAn9DAAAAAAAAAAAAAAAAAAAAAD9CwIgIAn9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFBATYC1B0LIAIoAtAFQQNHBEAgAUHgHGogDSAtEPkCCyABQeAcahDFCAwBCyABQeAcaiANIGIQxggLIAFBgBlqIAIgDRD3AiAOICEgFxD3AiAHIBwgChD3AiALICAgFhD3AiABIAEoAsgHIgQgASgC2AUiCGo2ApAXIAEgASgCzAciIyABKALcBSJkajYClBcgASABKALQByIuIAEoAuAFImVqNgKYFyABIAEoAtQHIi8gASgC5AUiZmo2ApwXIAEgASgC2AciMCABKALoBSJnajYCoBcgASABKALcByIxIAEoAuwFImhqNgKkFyABIAEoAuAHIjIgASgC8AUiaWo2AqgXIAEgASgC5AciMyABKAL0BSJqajYCrBcgASABKALoByI0IAEoAvgFImtqNgKwFyABIAEoAuwHIjUgASgC/AUibGo2ArQXIAEgASgC8AciNiABKAKABiJtajYCuBcgASABKAL0ByI3IAEoAoQGIm5qNgK8FyABIAEoAvgHIjggASgCiAYib2o2AsAXIAEgASgC/AciOSABKAKMBiJwajYCxBcgASABKAKACCIkIAEoApAGInFqIiU2AsgXICVBgICAEE4EQCABQZAXahDSAgsgASABKAKECCIlIAEoApQGInJqNgLMFyABIAEoAogIIjogASgCmAYic2o2AtAXIAEgASgCjAgiOyABKAKcBiJ0ajYC1BcgASABKAKQCCI8IAEoAqAGInVqNgLYFyABIAEoApQIIj0gASgCpAYidmo2AtwXIAEgASgCmAgiPiABKAKoBiJ3ajYC4BcgASABKAKcCCI/IAEoAqwGInhqNgLkFyABIAEoAqAIIkAgASgCsAYieWo2AugXIAEgASgCpAgiQSABKAK0BiJ6ajYC7BcgASABKAKoCCJCIAEoArgGIntqNgLwFyABIAEoAqwIIkMgASgCvAYifGo2AvQXIAEgASgCsAgiRCABKALABiJ9ajYC+BcgASABKAK0CCJFIAEoAsQGIn5qNgL8FyABIAEoArgIIkYgASgCyAYif2o2AoAYIAEgASgCvAgiJiABKALMBiKAAWoiJzYChBggJ0GAgIAQTgRAIBkQ0gILIAEgASgCwAgiJyABKALQBiKBAWo2AogYIAEgASgCxAgiRyABKALUBiKCAWo2AowYIAEgASgCyAgiSCABKALYBiKDAWo2ApAYIAEgASgCzAgiSSABKALcBiKEAWo2ApQYIAEgASgC0AgiSiABKALgBiKFAWo2ApgYIAEgASgC1AgiSyABKALkBiKGAWo2ApwYIAEgASgC2AgiTCABKALoBiKHAWo2AqAYIAEgASgC3AgiTSABKALsBiKIAWo2AqQYIAEgASgC4AgiTiABKALwBiKJAWo2AqgYIAEgASgC5AgiTyABKAL0BiKKAWo2AqwYIAEgASgC6AgiUCABKAL4BiKLAWo2ArAYIAEgASgC7AgiUSABKAL8BiKMAWo2ArQYIAEgASgC8AgiUiABKAKAByKNAWo2ArgYIAEgASgC9AgiUyABKAKEByKOAWo2ArwYIAEgASgC+AgiKCABKAKIByKPAWoiKTYCwBggKUGAgIAQTgRAIBAQ0gILIAEgASgC/AgiKSABKAKMByKQAWo2AsQYIAEgASgCgAkiVCABKAKQByKRAWo2AsgYIAEgASgChAkiVSABKAKUByKSAWo2AswYIAEgASgCiAkiViABKAKYByKTAWo2AtAYIAEgASgCjAkiVyABKAKcByKUAWo2AtQYIAEgASgCkAkiWCABKAKgByKVAWo2AtgYIAEgASgClAkiWSABKAKkByKWAWo2AtwYIAEgASgCmAkiWiABKAKoByKXAWo2AuAYIAEgASgCnAkiWyABKAKsByKYAWo2AuQYIAEgASgCoAkiXCABKAKwByKZAWo2AugYIAEgASgCpAkiXSABKAK0ByKaAWo2AuwYIAEgASgCqAkiXiABKAK4ByKbAWo2AvAYIAEgASgCrAkiXyABKAK8ByKcAWo2AvQYIAEgASgCsAkiYCABKALAByKdAWo2AvgYIAEgASgCtAkiESABKALEByKeAWoiYTYC/BggYUGAgIAQTgRAIBgQ0gILIAFBgBlqEPYCIAcQ9gIgAUGQF2oQ9gIgEBD2AiABQdAeaiABQYAZaiABQZAXahDGCCABQYAZaiANIA8Q9wIgDiAXIBsQ9wIgByAKIBMQ9wIgCyAWIBoQ9wIgASABKAK4CSJhIARqNgKQFyABIAEoArwJIgQgI2o2ApQXIAEgASgCwAkiIyAuajYCmBcgASABKALECSIuIC9qNgKcFyABIAEoAsgJIi8gMGo2AqAXIAEgASgCzAkiMCAxajYCpBcgASABKALQCSIxIDJqNgKoFyABIAEoAtQJIjIgM2o2AqwXIAEgASgC2AkiMyA0ajYCsBcgASABKALcCSI0IDVqNgK0FyABIAEoAuAJIjUgNmo2ArgXIAEgASgC5AkiNiA3ajYCvBcgASABKALoCSI3IDhqNgLAFyABIAEoAuwJIjggOWo2AsQXIAEgASgC8AkiOSAkaiIkNgLIFyAkQYCAgBBOBEAgAUGQF2oQ0gILIAEgASgC9AkiJCAlajYCzBcgASABKAL4CSIlIDpqNgLQFyABIAEoAvwJIjogO2o2AtQXIAEgASgCgAoiOyA8ajYC2BcgASABKAKECiI8ID1qNgLcFyABIAEoAogKIj0gPmo2AuAXIAEgASgCjAoiPiA/ajYC5BcgASABKAKQCiI/IEBqNgLoFyABIAEoApQKIkAgQWo2AuwXIAEgASgCmAoiQSBCajYC8BcgASABKAKcCiJCIENqNgL0FyABIAEoAqAKIkMgRGo2AvgXIAEgASgCpAoiRCBFajYC/BcgASABKAKoCiJFIEZqNgKAGCABIAEoAqwKIkYgJmoiJjYChBggJkGAgIAQTgRAIBkQ0gILIAEgASgCsAoiJiAnajYCiBggASABKAK0CiInIEdqNgKMGCABIAEoArgKIkcgSGo2ApAYIAEgASgCvAoiSCBJajYClBggASABKALACiJJIEpqNgKYGCABIAEoAsQKIkogS2o2ApwYIAEgASgCyAoiSyBMajYCoBggASABKALMCiJMIE1qNgKkGCABIAEoAtAKIk0gTmo2AqgYIAEgASgC1AoiTiBPajYCrBggASABKALYCiJPIFBqNgKwGCABIAEoAtwKIlAgUWo2ArQYIAEgASgC4AoiUSBSajYCuBggASABKALkCiJSIFNqNgK8GCABIAEoAugKIlMgKGoiKDYCwBggKEGAgIAQTgRAIBAQ0gILIAEgASgC7AoiKCApajYCxBggASABKALwCiIpIFRqNgLIGCABIAEoAvQKIlQgVWo2AswYIAEgASgC+AoiVSBWajYC0BggASABKAL8CiJWIFdqNgLUGCABIAEoAoALIlcgWGo2AtgYIAEgASgChAsiWCBZajYC3BggASABKAKICyJZIFpqNgLgGCABIAEoAowLIlogW2o2AuQYIAEgASgCkAsiWyBcajYC6BggASABKAKUCyJcIF1qNgLsGCABIAEoApgLIl0gXmo2AvAYIAEgASgCnAsiXiBfajYC9BggASABKAKgCyJfIGBqNgL4GCABIAEoAqQLImAgEWoiETYC/BggEUGAgIAQTgRAIBgQ0gILIAFBgBlqEPYCIAcQ9gIgAUGQF2oQ9gIgEBD2AiABQfAaaiABQYAZaiABQZAXahDGCCABQYAZaiABQcAgahDHCCABQZAXaiABQeAcahDHCCABQdAeaiABQdAeaiABQYAZahD3AiArICsgDhD3AiAiICIgBxD3AiAqICogCxD3AiACIAEoApAXIAEoAtAeajYC8AEgAiABKAKUFyABKALUHmo2AvQBIAIgASgCmBcgASgC2B5qNgL4ASACIAEoApwXIAEoAtweajYC/AEgAiABKAKgFyABKALgHmo2AoACIAIgASgCpBcgASgC5B5qNgKEAiACIAEoAqgXIAEoAugeajYCiAIgAiABKAKsFyABKALsHmo2AowCIAIgASgCsBcgASgC8B5qNgKQAiACIAEoArQXIAEoAvQeajYClAIgAiABKAK4FyABKAL4Hmo2ApgCIAIgASgCvBcgASgC/B5qNgKcAiACIAEoAsAXIAEoAoAfajYCoAIgAiABKALEFyABKAKEH2o2AqQCIAIgASgCyBcgASgCiB9qIhE2AqgCIBFBgICAEE4EQCANENICCyACIAEoAswXIAEoAowfajYCrAIgAiABKALQFyABKAKQH2o2ArACIAIgASgC1BcgASgClB9qNgK0AiACIAEoAtgXIAEoApgfajYCuAIgAiABKALcFyABKAKcH2o2ArwCIAIgASgC4BcgASgCoB9qNgLAAiACIAEoAuQXIAEoAqQfajYCxAIgAiABKALoFyABKAKoH2o2AsgCIAIgASgC7BcgASgCrB9qNgLMAiACIAEoAvAXIAEoArAfajYC0AIgAiABKAL0FyABKAK0H2o2AtQCIAIgASgC+BcgASgCuB9qNgLYAiACIAEoAvwXIAEoArwfajYC3AIgAiABKAKAGCABKALAH2o2AuACIAIgASgChBggASgCxB9qIhE2AuQCIBFBgICAEE4EQCAXENICCyACIAEoAogYIAEoAsgfajYC6AIgAiABKAKMGCABKALMH2o2AuwCIAIgASgCkBggASgC0B9qNgLwAiACIAEoApQYIAEoAtQfajYC9AIgAiABKAKYGCABKALYH2o2AvgCIAIgASgCnBggASgC3B9qNgL8AiACIAEoAqAYIAEoAuAfajYCgAMgAiABKAKkGCABKALkH2o2AoQDIAIgASgCqBggASgC6B9qNgKIAyACIAEoAqwYIAEoAuwfajYCjAMgAiABKAKwGCABKALwH2o2ApADIAIgASgCtBggASgC9B9qNgKUAyACIAEoArgYIAEoAvgfajYCmAMgAiABKAK8GCABKAL8H2o2ApwDIAIgASgCwBggASgCgCBqIhE2AqADIBFBgICAEE4EQCAKENICCyACIAEoAsQYIAEoAoQgajYCpAMgAiABKALIGCABKAKIIGo2AqgDIAIgASgCzBggASgCjCBqNgKsAyACIAEoAtAYIAEoApAgajYCsAMgAiABKALUGCABKAKUIGo2ArQDIAIgASgC2BggASgCmCBqNgK4AyACIAEoAtwYIAEoApwgajYCvAMgAiABKALgGCABKAKgIGo2AsADIAIgASgC5BggASgCpCBqNgLEAyACIAEoAugYIAEoAqggajYCyAMgAiABKALsGCABKAKsIGo2AswDIAIgASgC8BggASgCsCBqNgLQAyACIAEoAvQYIAEoArQgajYC1AMgAiABKAL4GCABKAK4IGo2AtgDIAIgASgC/BggASgCvCBqIhE2AtwDIBFBgICAEE4EQCAWENICCyABQfAaaiABQfAaaiABQZAXahD3AiAeIB4gGRD3AiAVIBUgEBD3AiAdIB0gGBD3AiABQeAcaiABQeAcaiABQYAZahD3AiAJIAkgDhD3AiAUIBQgBxD3AiAfIB8gCxD3AiABQYAZaiACIA8Q9wIgDiAhIBsQ9wIgByAcIBMQ9wIgCyAgIBoQ9wIgASA4IHBqNgLEFyABIDcgb2o2AsAXIAEgNiBuajYCvBcgASA1IG1qNgK4FyABIDQgbGo2ArQXIAEgMyBrajYCsBcgASAyIGpqNgKsFyABIDEgaWo2AqgXIAEgMCBoajYCpBcgASAvIGdqNgKgFyABIC4gZmo2ApwXIAEgIyBlajYCmBcgASAEIGRqNgKUFyABIAggYWo2ApAXIAEgOSBxaiIENgLIFyAEQYCAgBBOBEAgAUGQF2oQ0gILIAEgRSB/ajYCgBggASBEIH5qNgL8FyABIEMgfWo2AvgXIAEgQiB8ajYC9BcgASBBIHtqNgLwFyABIEAgemo2AuwXIAEgPyB5ajYC6BcgASA+IHhqNgLkFyABID0gd2o2AuAXIAEgPCB2ajYC3BcgASA7IHVqNgLYFyABIDogdGo2AtQXIAEgJSBzajYC0BcgASAkIHJqNgLMFyABIEYggAFqIgQ2AoQYIARBgICAEE4EQCAZENICCyABIFIgjgFqNgK8GCABIFEgjQFqNgK4GCABIFAgjAFqNgK0GCABIE8giwFqNgKwGCABIE4gigFqNgKsGCABIE0giQFqNgKoGCABIEwgiAFqNgKkGCABIEsghwFqNgKgGCABIEoghgFqNgKcGCABIEkghQFqNgKYGCABIEgghAFqNgKUGCABIEcggwFqNgKQGCABICcgggFqNgKMGCABICYggQFqNgKIGCABIFMgjwFqIgQ2AsAYIARBgICAEE4EQCAQENICCyABIF8gnQFqNgL4GCABIF4gnAFqNgL0GCABIF0gmwFqNgLwGCABIFwgmgFqNgLsGCABIFsgmQFqNgLoGCABIFogmAFqNgLkGCABIFkglwFqNgLgGCABIFgglgFqNgLcGCABIFcglQFqNgLYGCABIFYglAFqNgLUGCABIFUgkwFqNgLQGCABIFQgkgFqNgLMGCABICkgkQFqNgLIGCABICggkAFqNgLEGCABIGAgngFqIgQ2AvwYIARBgICAEE4EQCAYENICCyABQYAZahD2AiAHEPYCIAFBkBdqEPYCIBAQ9gIgAUGAGWogAUGQF2ogAUGAGWoQxgggAUHgHGogAUHgHGogAUGAGWoQ9wIgCSAJIA4Q9wIgFCAUIAcQ9wIgHyAfIAsQ9wIgAUGAGWogDyBjEMYIIAFBkBdqIAFBgBlqEMcIIAIgASgCkBcgASgC4BxqNgLgAyACIAEoApQXIAEoAuQcajYC5AMgAiABKAKYFyABKALoHGo2AugDIAIgASgCnBcgASgC7BxqNgLsAyACIAEoAqAXIAEoAvAcajYC8AMgAiABKAKkFyABKAL0HGo2AvQDIAIgASgCqBcgASgC+BxqNgL4AyACIAEoAqwXIAEoAvwcajYC/AMgAiABKAKwFyABKAKAHWo2AoAEIAIgASgCtBcgASgChB1qNgKEBCACIAEoArgXIAEoAogdajYCiAQgAiABKAK8FyABKAKMHWo2AowEIAIgASgCwBcgASgCkB1qNgKQBCACIAEoAsQXIAEoApQdajYClAQgAiABKALIFyABKAKYHWoiBDYCmAQgBEGAgIAQTgRAIA8Q0gILIAIgASgCzBcgASgCnB1qNgKcBCACIAEoAtAXIAEoAqAdajYCoAQgAiABKALUFyABKAKkHWo2AqQEIAIgASgC2BcgASgCqB1qNgKoBCACIAEoAtwXIAEoAqwdajYCrAQgAiABKALgFyABKAKwHWo2ArAEIAIgASgC5BcgASgCtB1qNgK0BCACIAEoAugXIAEoArgdajYCuAQgAiABKALsFyABKAK8HWo2ArwEIAIgASgC8BcgASgCwB1qNgLABCACIAEoAvQXIAEoAsQdajYCxAQgAiABKAL4FyABKALIHWo2AsgEIAIgASgC/BcgASgCzB1qNgLMBCACIAEoAoAYIAEoAtAdajYC0AQgAiABKAKEGCABKALUHWoiBDYC1AQgBEGAgIAQTgRAIBsQ0gILIAIgASgCiBggASgC2B1qNgLYBCACIAEoAowYIAEoAtwdajYC3AQgAiABKAKQGCABKALgHWo2AuAEIAIgASgClBggASgC5B1qNgLkBCACIAEoApgYIAEoAugdajYC6AQgAiABKAKcGCABKALsHWo2AuwEIAIgASgCoBggASgC8B1qNgLwBCACIAEoAqQYIAEoAvQdajYC9AQgAiABKAKoGCABKAL4HWo2AvgEIAIgASgCrBggASgC/B1qNgL8BCACIAEoArAYIAEoAoAeajYCgAUgAiABKAK0GCABKAKEHmo2AoQFIAIgASgCuBggASgCiB5qNgKIBSACIAEoArwYIAEoAoweajYCjAUgAiABKALAGCABKAKQHmoiBDYCkAUgBEGAgIAQTgRAIBMQ0gILIAIgASgCxBggASgClB5qNgKUBSACIAEoAsgYIAEoApgeajYCmAUgAiABKALMGCABKAKcHmo2ApwFIAIgASgC0BggASgCoB5qNgKgBSACIAEoAtQYIAEoAqQeajYCpAUgAiABKALYGCABKAKoHmo2AqgFIAIgASgC3BggASgCrB5qNgKsBSACIAEoAuAYIAEoArAeajYCsAUgAiABKALkGCABKAK0Hmo2ArQFIAIgASgC6BggASgCuB5qNgK4BSACIAEoAuwYIAEoArweajYCvAUgAiABKALwGCABKALAHmo2AsAFIAIgASgC9BggASgCxB5qNgLEBSACIAEoAvgYIAEoAsgeajYCyAUgAiABKAL8GCABKALMHmoiBDYCzAUgBEGAgIAQTgRAIBoQ0gILIAFB8BpqIAFB8BpqIAFBkBdqEPcCIB4gHiAZEPcCIBUgFSAQEPcCIB0gHSAYEPcCIAFBgBlqEMUIDAELIARBAkYEQCACIAFB2AVqEMgIDAILIAFBwCBqIAIgAUHYBWoQxgggAUGAGWogAiANEPcCIA4gISAXEPcCIAcgHCAKEPcCIAsgICAWEPcCIAFBgBlqEPYCIAcQ9gIgAUHQHmogAUGAGWogAUHYBWoQxgggAUGAGWogDSAPEPcCIA4gFyAbEPcCIAcgCiATEPcCIAsgFiAaEPcCIAFBgBlqEPYCIAcQ9gIgAUHwGmogAUGAGWogLBD5AiAVIAcgLBD5AiABQfAaahDFCCABQYAZaiABQcAgahDHCCABQdAeaiABQdAeaiABQYAZahD3AiArICsgDhD3AiAiICIgBxD3AiAqICogCxD3AgJAIA0gAUHQHmpGDQAgAiABKALQHjYC8AEgAiABKALUHjYC9AEgAiABKALYHjYC+AEgAiABKALcHjYC/AEgAiABKALgHjYCgAIgAiABKALkHjYChAIgAiABKALoHjYCiAIgAiABKALsHjYCjAIgAiABKALwHjYCkAIgAiABKAL0HjYClAIgAiABKAL4HjYCmAIgAiABKAL8HjYCnAIgAiABKAKAHzYCoAIgAiABKAKEHzYCpAIgAiABKAKIHzYCqAIgAiABKAKMHzYCrAIgAiABKAKQHzYCsAIgAiABKAKUHzYCtAIgAiABKAKYHzYCuAIgAiABKAKcHzYCvAIgAiABKAKgHzYCwAIgAiABKAKkHzYCxAIgAiABKAKoHzYCyAIgAiABKAKsHzYCzAIgAiABKAKwHzYC0AIgAiABKAK0HzYC1AIgAiABKAK4HzYC2AIgAiABKAK8HzYC3AIgAiABKALAHzYC4AIgAiABKALEHzYC5AIgCiAiRg0AIAIgASgCyB82AugCIAIgASgCzB82AuwCIAIgASgC0B82AvACIAIgASgC1B82AvQCIAIgASgC2B82AvgCIAIgASgC3B82AvwCIAIgASgC4B82AoADIAIgASgC5B82AoQDIAIgASgC6B82AogDIAIgASgC7B82AowDIAIgASgC8B82ApADIAIgASgC9B82ApQDIAIgASgC+B82ApgDIAIgASgC/B82ApwDIAIgASgCgCA2AqADIAIgASgChCA2AqQDIAIgASgCiCA2AqgDIAIgASgCjCA2AqwDIAIgASgCkCA2ArADIAIgASgClCA2ArQDIAIgASgCmCA2ArgDIAIgASgCnCA2ArwDIAIgASgCoCA2AsADIAIgASgCpCA2AsQDIAIgASgCqCA2AsgDIAIgASgCrCA2AswDIAIgASgCsCA2AtADIAIgASgCtCA2AtQDIAIgASgCuCA2AtgDIAIgASgCvCA2AtwDCyABIAEoAoAZNgLgHCABIAH9AAKEGf0LAuQcIAEgAf0AApQZ/QsC9BwgASAB/QACpBn9CwKEHSABIAH9AAK0Gf0LApQdIAEgAf0AAsQZ/QsCpB0gASAB/QAC1Bn9CwK0HSABIAEpAuQZNwLEHSABIAEoAuwZNgLMHSABIAEoAvAZNgLQHSABIAH9AAL0Gf0LAtQdIAEgAf0AAoQa/QsC5B0gASAB/QAClBr9CwL0HSABIAH9AAKkGv0LAoQeIAEgAf0AArQa/QsClB4gASAB/QACxBr9CwKkHiABIAEpAtQaNwK0HiABIAEoAtwaNgK8HiABIAH9AALgGv0LAsAeIAFBgBlqIAIgDxD3AiAOICEgGxD3AiAHIBwgExD3AiALICAgGhD3AiABIAEoArgJIAEoAtgFajYCkBcgASABKAK8CSABKALcBWo2ApQXIAEgASgCwAkgASgC4AVqNgKYFyABIAEoAsQJIAEoAuQFajYCnBcgASABKALICSABKALoBWo2AqAXIAEgASgCzAkgASgC7AVqNgKkFyABIAEoAtAJIAEoAvAFajYCqBcgASABKALUCSABKAL0BWo2AqwXIAEgASgC2AkgASgC+AVqNgKwFyABIAEoAtwJIAEoAvwFajYCtBcgASABKALgCSABKAKABmo2ArgXIAEgASgC5AkgASgChAZqNgK8FyABIAEoAugJIAEoAogGajYCwBcgASABKALsCSABKAKMBmo2AsQXIAEgASgC8AkgASgCkAZqIgQ2AsgXIARBgICAEE4EQCABQZAXahDSAgsgASABKAL0CSABKAKUBmo2AswXIAEgASgC+AkgASgCmAZqNgLQFyABIAEoAvwJIAEoApwGajYC1BcgASABKAKACiABKAKgBmo2AtgXIAEgASgChAogASgCpAZqNgLcFyABIAEoAogKIAEoAqgGajYC4BcgASABKAKMCiABKAKsBmo2AuQXIAEgASgCkAogASgCsAZqNgLoFyABIAEoApQKIAEoArQGajYC7BcgASABKAKYCiABKAK4Bmo2AvAXIAEgASgCnAogASgCvAZqNgL0FyABIAEoAqAKIAEoAsAGajYC+BcgASABKAKkCiABKALEBmo2AvwXIAEgASgCqAogASgCyAZqNgKAGCABIAEoAqwKIAEoAswGaiIENgKEGCAEQYCAgBBOBEAgGRDSAgsgASABKAKwCiABKALQBmo2AogYIAEgASgCtAogASgC1AZqNgKMGCABIAEoArgKIAEoAtgGajYCkBggASABKAK8CiABKALcBmo2ApQYIAEgASgCwAogASgC4AZqNgKYGCABIAEoAsQKIAEoAuQGajYCnBggASABKALICiABKALoBmo2AqAYIAEgASgCzAogASgC7AZqNgKkGCABIAEoAtAKIAEoAvAGajYCqBggASABKALUCiABKAL0Bmo2AqwYIAEgASgC2AogASgC+AZqNgKwGCABIAEoAtwKIAEoAvwGajYCtBggASABKALgCiABKAKAB2o2ArgYIAEgASgC5AogASgChAdqNgK8GCABIAEoAugKIAEoAogHaiIENgLAGCAEQYCAgBBOBEAgEBDSAgsgASABKALsCiABKAKMB2o2AsQYIAEgASgC8AogASgCkAdqNgLIGCABIAEoAvQKIAEoApQHajYCzBggASABKAL4CiABKAKYB2o2AtAYIAEgASgC/AogASgCnAdqNgLUGCABIAEoAoALIAEoAqAHajYC2BggASABKAKECyABKAKkB2o2AtwYIAEgASgCiAsgASgCqAdqNgLgGCABIAEoAowLIAEoAqwHajYC5BggASABKAKQCyABKAKwB2o2AugYIAEgASgClAsgASgCtAdqNgLsGCABIAEoApgLIAEoArgHajYC8BggASABKAKcCyABKAK8B2o2AvQYIAEgASgCoAsgASgCwAdqNgL4GCABIAEoAqQLIAEoAsQHaiIENgL8GCAEQYCAgBBOBEAgGBDSAgsgAUGAGWoQ9gIgBxD2AiABQZAXahD2AiAQEPYCIAFBgBlqIAFBkBdqIAFBgBlqEMYIIAFB4BxqIAFB4BxqIAFBgBlqEPcCIAkgCSAOEPcCIBQgFCAHEPcCIB8gHyALEPcCIAFBgBlqIA8gLBD5AiAHIBMgLBD5AiABQYAZahDFCCABQZAXaiABQYAZahDHCCABQYAZahDFCCACIAEoApAXIAEoAuAcajYC4AMgAiABKAKUFyABKALkHGo2AuQDIAIgASgCmBcgASgC6BxqNgLoAyACIAEoApwXIAEoAuwcajYC7AMgAiABKAKgFyABKALwHGo2AvADIAIgASgCpBcgASgC9BxqNgL0AyACIAEoAqgXIAEoAvgcajYC+AMgAiABKAKsFyABKAL8HGo2AvwDIAIgASgCsBcgASgCgB1qNgKABCACIAEoArQXIAEoAoQdajYChAQgAiABKAK4FyABKAKIHWo2AogEIAIgASgCvBcgASgCjB1qNgKMBCACIAEoAsAXIAEoApAdajYCkAQgAiABKALEFyABKAKUHWo2ApQEIAIgASgCyBcgASgCmB1qIgQ2ApgEIARBgICAEE4EQCAPENICCyACIAEoAswXIAEoApwdajYCnAQgAiABKALQFyABKAKgHWo2AqAEIAIgASgC1BcgASgCpB1qNgKkBCACIAEoAtgXIAEoAqgdajYCqAQgAiABKALcFyABKAKsHWo2AqwEIAIgASgC4BcgASgCsB1qNgKwBCACIAEoAuQXIAEoArQdajYCtAQgAiABKALoFyABKAK4HWo2ArgEIAIgASgC7BcgASgCvB1qNgK8BCACIAEoAvAXIAEoAsAdajYCwAQgAiABKAL0FyABKALEHWo2AsQEIAIgASgC+BcgASgCyB1qNgLIBCACIAEoAvwXIAEoAswdajYCzAQgAiABKAKAGCABKALQHWo2AtAEIAIgASgChBggASgC1B1qIgQ2AtQEIARBgICAEE4EQCAbENICCyACIAEoAogYIAEoAtgdajYC2AQgAiABKAKMGCABKALcHWo2AtwEIAIgASgCkBggASgC4B1qNgLgBCACIAEoApQYIAEoAuQdajYC5AQgAiABKAKYGCABKALoHWo2AugEIAIgASgCnBggASgC7B1qNgLsBCACIAEoAqAYIAEoAvAdajYC8AQgAiABKAKkGCABKAL0HWo2AvQEIAIgASgCqBggASgC+B1qNgL4BCACIAEoAqwYIAEoAvwdajYC/AQgAiABKAKwGCABKAKAHmo2AoAFIAIgASgCtBggASgChB5qNgKEBSACIAEoArgYIAEoAogeajYCiAUgAiABKAK8GCABKAKMHmo2AowFIAIgASgCwBggASgCkB5qIgQ2ApAFIARBgICAEE4EQCATENICCyACIAEoAsQYIAEoApQeajYClAUgAiABKALIGCABKAKYHmo2ApgFIAIgASgCzBggASgCnB5qNgKcBSACIAEoAtAYIAEoAqAeajYCoAUgAiABKALUGCABKAKkHmo2AqQFIAIgASgC2BggASgCqB5qNgKoBSACIAEoAtwYIAEoAqweajYCrAUgAiABKALgGCABKAKwHmo2ArAFIAIgASgC5BggASgCtB5qNgK0BSACIAEoAugYIAEoArgeajYCuAUgAiABKALsGCABKAK8Hmo2ArwFIAIgASgC8BggASgCwB5qNgLABSACIAEoAvQYIAEoAsQeajYCxAUgAiABKAL4GCABKALIHmo2AsgFIAIgASgC/BggASgCzB5qIgQ2AswFIARBgICAEE4EQCAaENICCyABQfAaaiABQfAaaiABQZAXahD3AiAeIB4gGRD3AiAVIBUgEBD3AiAdIB0gGBD3AgsgDSANIAFBgBlqEPcCIBcgFyAOEPcCIAogCiAHEPcCIBYgFiALEPcCIAFB8BpqEPYCIBUQ9gIgAUHwGmoQxQggAiABKALwGiABKALAIGo2AgAgAiABKAL0GiABKALEIGo2AgQgAiABKAL4GiABKALIIGo2AgggAiABKAL8GiABKALMIGo2AgwgAiABKAKAGyABKALQIGo2AhAgAiABKAKEGyABKALUIGo2AhQgAiABKAKIGyABKALYIGo2AhggAiABKAKMGyABKALcIGo2AhwgAiABKAKQGyABKALgIGo2AiAgAiABKAKUGyABKALkIGo2AiQgAiABKAKYGyABKALoIGo2AiggAiABKAKcGyABKALsIGo2AiwgAiABKAKgGyABKALwIGo2AjAgAiABKAKkGyABKAL0IGo2AjQgAiABKAKoGyABKAL4IGoiBDYCOCAEQYCAgBBOBEAgAhDSAgsgAiABKAKsGyABKAL8IGo2AjwgAiABKAKwGyABKAKAIWo2AkAgAiABKAK0GyABKAKEIWo2AkQgAiABKAK4GyABKAKIIWo2AkggAiABKAK8GyABKAKMIWo2AkwgAiABKALAGyABKAKQIWo2AlAgAiABKALEGyABKAKUIWo2AlQgAiABKALIGyABKAKYIWo2AlggAiABKALMGyABKAKcIWo2AlwgAiABKALQGyABKAKgIWo2AmAgAiABKALUGyABKAKkIWo2AmQgAiABKALYGyABKAKoIWo2AmggAiABKALcGyABKAKsIWo2AmwgAiABKALgGyABKAKwIWo2AnAgAiABKALkGyABKAK0IWoiBDYCdCAEQYCAgBBOBEAgIRDSAgsgAiABKALoGyABKAK4IWo2AnggAiABKALsGyABKAK8IWo2AnwgAiABKALwGyABKALAIWo2AoABIAIgASgC9BsgASgCxCFqNgKEASACIAEoAvgbIAEoAsghajYCiAEgAiABKAL8GyABKALMIWo2AowBIAIgASgCgBwgASgC0CFqNgKQASACIAEoAoQcIAEoAtQhajYClAEgAiABKAKIHCABKALYIWo2ApgBIAIgASgCjBwgASgC3CFqNgKcASACIAEoApAcIAEoAuAhajYCoAEgAiABKAKUHCABKALkIWo2AqQBIAIgASgCmBwgASgC6CFqNgKoASACIAEoApwcIAEoAuwhajYCrAEgAiABKAKgHCABKALwIWoiBDYCsAEgBEGAgIAQTgRAIBwQ0gILIAIgASgCpBwgASgC9CFqNgK0ASACIAEoAqgcIAEoAvghajYCuAEgAiABKAKsHCABKAL8IWo2ArwBIAIgASgCsBwgASgCgCJqNgLAASACIAEoArQcIAEoAoQiajYCxAEgAiABKAK4HCABKAKIImo2AsgBIAIgASgCvBwgASgCjCJqNgLMASACIAEoAsAcIAEoApAiajYC0AEgAiABKALEHCABKAKUImo2AtQBIAIgASgCyBwgASgCmCJqNgLYASACIAEoAswcIAEoApwiajYC3AEgAiABKALQHCABKAKgImo2AuABIAIgASgC1BwgASgCpCJqNgLkASACIAEoAtgcIAEoAqgiajYC6AEgAiABKALcHCABKAKsImoiBDYC7AEgBEGAgIAQTgRAICAQ0gILIAJBBDYC0AUgAhD2AiAcEPYCIA0Q9gIgChD2AiAPEPYCIBMQ9gILIAVBAWshCCAFQQFKDQALCyACIAIQjwMgDSANEJADIA8gDxCPAyABQbAiaiQAIANB9B1qIgH9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIANBhB5qIgf9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIANBlB5qIghBADYCACADQgA3AuwdIANBNDYC6B0gA0KAgISAgICAhBA3A+AdIANBpB1qQcDDLxCCAyADQegcakGAxC8QggMgAyADKAKkHTYCmB4gAyAD/QACqB39CwKcHiADIAP9AAK4Hf0LAqweIAMgA/0AAsgd/QsCvB4gAyADKQLYHTcCzB4gAyAD/QAC6Bz9CwLUHiADIAP9AAL4HP0LAuQeIAMgAykCiB03AvQeIAMgAygCkB02AvweIAMgA/0AApQd/QsCgB8gA0GUF2ogAhCOAyACIAIQjwMgBkGIAmoiCSAJEJADIAZB+ANqIgogChCPAyACIANBlBdqEJEDIANBlBdqIAIQkgMgAiADQZgeahCTAyACIANBmB5qEJMDIAIgA0GUF2oQkQMgA0HAEWogAhCUAyADQewLaiADQcARaiADQeAdahCVAyADQewLaiADQewLahCPAyADQdwNaiIEIAQQkAMgA0HMD2oiBSAFEI8DIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAhBADYCACADQgA3AuwdIANBGjYC6B0gA0KAgIKAgICAggg3A+AdIANBmAZqIANB7AtqIANB4B1qEJUDIANBmAZqIANBmAZqEI8DIANBiAhqIgEgARCQAyADQfgJaiIHIAcQjwMgCEEANgIAIANBjB5qQgA3AgAgA0H8HWr9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwLsHSADQTQ2AugdIANCgICEgICAgIQQNwPgHSADQcQAaiACRwRAIANBxABqIAIQ5AIgA0G8AWogBkGQAWoQ5AIgCSADQbQCaiIIRwRAIAggCRDkAiADQawDaiAGQYADahDkAgsgCiADQaQEaiIIRwRAIAggChDkAiADQZwFaiAGQfAEahDkAgsgAyAGKALoBTYClAYLIANBxABqIANBxABqEI8DIANBtAJqIgggCBCQAyADQaQEaiILIAsQjwMgA0HsC2ogA0HEAGoQkQMgA0HsC2ogA0HsC2oQjwMgBCAEEJADIAUgBRCPAyADQewLaiADQZgGahCRAyADQZgGaiADQewLaiADQeAdahCVAyADQZgGaiADQZgGahCPAyABIAEQkAMgByAHEI8DIANBxABqIANBmAZqIANB4B1qEJUDIANBxABqIANBxABqEI8DIAggCBCQAyALIAsQjwMgA0HsC2ogA0HsC2oQjwMgBCAEEJADIAUgBRCPAyADQcQAaiADQewLahCRAyADQewLaiADQewLahCPAyAEIAQQkAMgBSAFEI8DIANB7AtqIANBmB5qEJMDIANB7AtqIANBmB5qEJMDIANB7AtqIANBmB5qEJMDIANBmAZqIANBmB5qEJMDIANBmAZqIANBmB5qEJMDIANB7AtqIANBmAZqEJEDIANBmAZqIANBxABqIANB4B1qEJUDIANBmAZqIANBmAZqEI8DIAEgARCQAyAHIAcQjwMgA0GYBmogA0HAEWoQkQMgA0GYBmogAhCRAyADQewLaiADQZgGahCRAyADQZgGaiADQcQAahCSAyADQZgGaiADQZgeahCTAyADQewLaiADQZgGahCRAyACIANB7AtqEJIDIAIQ0gIgBkHUAGoQ0gIgBkGQAWoQ0gIgBkHMAWoQ0gIgCRDSAiAGQcQCahDSAiAGQYADahDSAiAGQbwDahDSAiAKENICIAZBtARqENICIAZB8ARqENICIAZBrAVqENICIBIgEigCvAEiBkEBazYCvAECQCAGQQFKDQACQEGkiDQoAgAiBkUNACADIBI2ApQXIAYoAgAiAiADKAKUF0sNACADKAKUFyACIAYoAhBqTw0AIBIgBigCBDYCACAGIBI2AgQgBiAGKAIIQQFqNgIIIAYoAhQiBkEESQ0BIAZBfHEiBkUNASASQQAgBvwLAAwBCyASECsLIAwgDCgC8AIiBkEBazYC8AIgBkEBSg0CQaSINCgCACIGRQ0BIAMgDDYClBcgBigCACICIAMoApQXSw0BIAMoApQXIAIgBigCEGpPDQEgDCAGKAIENgIAIAYgDDYCBCAGIAYoAghBAWo2AgggBigCFCIGQQRJDQIgBkF8cSIGRQ0CIAxBACAG/AsADAILIAwgDCgC8AIiBkEBazYC8AICQCAGQQFKDQBBpIg0KAIAIgYEQCAGIAwQUAwBCyAMECsLIANBjNUpNgIEIANB8aQqNgIAIABB/IgqIAMQbAALIAwQKwsgA0HxpCo2AhAgAEHghyogA0EQahCbASADQZAfaiQAQQEL5AsBEn8jAEGwCmsiAiQAIAJB2AVqIAEQxAggAkHoA2ogAUHwAWoiAyABQeADaiIEEMYIIAJB6ANqEMUIIAJB2AVqIAJB2AVqIAJB6ANqEMkIIAJB2AVqEPYCIAJB0AZqEPYCIAJB6ANqIAQQxAggAkHoA2oQxQggAkH4AWogASADEMYIIAJB6ANqIAJB6ANqIAJB+AFqEMkIIAJB6ANqEPYCIAJB4ARqEPYCIAJB+AFqIAMQxAggAkEIaiABIAQQxgggAkH4AWogAkH4AWogAkEIahDJCCACQfgBahD2AiACQfACahD2AiACQQhqIAMgAkH4AWoQxgggAkEIahDFCCAAIAJB2AVqIAEQxgggAkEIaiAAIAJBCGoQ9wIgAkHEAGoiAyAAQTxqIAMQ9wIgAkGAAWoiASAAQfgAaiABEPcCIAJBvAFqIgUgAEG0AWogBRD3AiAAQeADaiISIAJB6ANqIAQQxgggEhDFCCACQQhqIBIgAkEIahD3AiADIABBnARqIAMQ9wIgASAAQdgEaiABEPcCIAUgAEGUBWogBRD3AiACQQhqEPYCIAEQ9gIgAkHACGogAkEIahCHAyACQcgHaiABEIcDIAJByAdqEMMIIAJByAdqEPYCIAJBwAhqIAJBwAhqIAJByAdqEMEIIAJBwAhqIAJBwAhqEIYDIAJBCGogAkHACGogAkEIahD5AiACIAIoAvwIIAIoAsAIajYC9AkgAiACKAKACSIDIAIoAsQIajYC+AkgAiACKAKECSIGIAIoAsgIajYC/AkgAiACKAKICSIHIAIoAswIajYCgAogAiACKAKMCSIIIAIoAtAIajYChAogAiACKAKQCSIJIAIoAtQIajYCiAogAiACKAKUCSIKIAIoAtgIajYCjAogAiACKAKYCSILIAIoAtwIajYCkAogAiACKAKcCSIMIAIoAuAIajYClAogAiACKAKgCSINIAIoAuQIajYCmAogAiACKAKkCSIOIAIoAugIajYCnAogAiACKAKoCSIPIAIoAuwIajYCoAogAiACKAKsCSIQIAIoAvAIajYCpAogAiACKAKwCSIRIAIoAvQIajYCqAogAiACKAK0CSITIAIoAvgIaiIENgKsCiAEQYCAgBBOBEAgAkH0CWoQ0gILIAJB9AlqIAJB9AlqEMwCIAIgAigC/AggAigC9AlqIgQ2ArgJIAIgAyACKAL4CWoiBTYCvAkgAiAGIAIoAvwJaiIGNgLACSACIAcgAigCgApqIgc2AsQJIAIgCCACKAKECmoiCDYCyAkgAiAJIAIoAogKaiIJNgLMCSACIAogAigCjApqIgo2AtAJIAIgCyACKAKQCmoiCzYC1AkgAiAMIAIoApQKaiIMNgLYCSACIA0gAigCmApqIg02AtwJIAIgDiACKAKcCmoiDjYC4AkgAiAPIAIoAqAKaiIPNgLkCSACIBAgAigCpApqIhA2AugJIAIgESACKAKoCmoiETYC7AkgAiATIAIoAqwKaiIDNgLwCSADQYCAgBBOBEAgAkG4CWoQ0gIgAigC7AkhESACKALoCSEQIAIoAuQJIQ8gAigC4AkhDiACKALcCSENIAIoAtgJIQwgAigC1AkhCyACKALQCSEKIAIoAswJIQkgAigCyAkhCCACKALECSEHIAIoAsAJIQYgAigCvAkhBSACKAK4CSEEIAIoAvAJIQMLIAJB/AhqIAJB9AlqIAJBwAhqEPcCIAIgAzYC+AggAiARNgL0CCACIBA2AvAIIAIgDzYC7AggAiAONgLoCCACIA02AuQIIAIgDDYC4AggAiALNgLcCCACIAo2AtgIIAIgCTYC1AggAiAINgLQCCACIAc2AswIIAIgBjYCyAggAiAFNgLECCACIAQ2AsAIIAJBwAhqEPYCIAEgAkHACGogARD5AiAAIAJB2AVqIAJBCGoQxgggAEHwAWogAkHoA2ogAkEIahDGCCASIAJB+AFqIAJBCGoQxgggAEEENgLQBSACQbAKaiQAC5cCAQJ/IwBBgAFrIgIkACAAIAEQ5AIgAkHEAGogAUH4AGoiAyABQbQBaiIBEPcCIAJBxABqIAJBxABqEMwCIAJBCGogAkHEAGogARD3AiAAQbQBaiACQcQAaiADEPcCIAAgAigCCDYCeCAAIAIoAgw2AnwgACACKAIQNgKAASAAIAIoAhQ2AoQBIAAgAigCGDYCiAEgACACKAIcNgKMASAAIAIoAiA2ApABIAAgAigCJDYClAEgACACKAIoNgKYASAAIAIoAiw2ApwBIAAgAigCMDYCoAEgACACKAI0NgKkASAAIAIoAjg2AqgBIAAgAigCPDYCrAEgACACKAJANgKwASAAEPYCIABB+ABqEPYCIAJBgAFqJAALiAIBA38jAEGAAWsiAiQAIABB+ABqIgMgAUH4AGoQ5AIgAkHEAGogASABQTxqIgQQ9wIgAkHEAGogAkHEAGoQzAIgAkEIaiACQcQAaiAEEPcCIABBPGogAkHEAGogARD3AiAAIAIoAgg2AgAgACACKAIMNgIEIAAgAigCEDYCCCAAIAIoAhQ2AgwgACACKAIYNgIQIAAgAigCHDYCFCAAIAIoAiA2AhggACACKAIkNgIcIAAgAigCKDYCICAAIAIoAiw2AiQgACACKAIwNgIoIAAgAigCNDYCLCAAIAIoAjg2AjAgACACKAI8NgI0IAAgAigCQDYCOCAAEPYCIAMQ9gIgAkGAAWokAAvGIwEffyMAQaALayICJAAgAkGwCWogACABEMYIIAJB0AVqIABB8AFqIgYgAUHwAWoiAxDGCCACQfABaiAAIAYQ9wIgAkGsAmoiByAAQTxqIhYgAEGsAmoiDRD3AiACQegCaiIEIABB+ABqIhIgAEHoAmoiCRD3AiACQaQDaiIIIABBtAFqIhcgAEGkA2oiDhD3AiACIAEgAxD3AiACQTxqIg8gAUE8aiIbIAFBrAJqIgoQ9wIgAkH4AGoiBSABQfgAaiIcIAFB6AJqIgsQ9wIgAkG0AWoiECABQbQBaiIdIAFBpANqIgwQ9wIgAkHwAWoQ9gIgBBD2AiACEPYCIAUQ9gIgAkHAB2ogAkHwAWogAhDGCCACQfABaiAGIABB4ANqIhEQ9wIgByANIABBnARqIhgQ9wIgBCAJIABB2ARqIhMQ9wIgCCAOIABBlAVqIhkQ9wIgAiADIAFB4ANqIhoQ9wIgDyAKIAFBnARqIh4Q9wIgBSALIAFB2ARqIh8Q9wIgECAMIAFBlAVqIiAQ9wIgAkHwAWoQ9gIgBBD2AiACEPYCIAUQ9gIgAkHgA2ogAkHwAWogAhDGCCACQfABaiACQbAJahDHCCACIAJB0AVqEMcIIAJBwAdqIAJBwAdqIAJB8AFqEPcCIAJB/AdqIgMgAyAHEPcCIAJBuAhqIgMgAyAEEPcCIAJB9AhqIgMgAyAIEPcCIAAgAigCACACKALAB2o2AvABIAAgAigCBCACKALEB2o2AvQBIAAgAigCCCACKALIB2o2AvgBIAAgAigCDCACKALMB2o2AvwBIAAgAigCECACKALQB2o2AoACIAAgAigCFCACKALUB2o2AoQCIAAgAigCGCACKALYB2o2AogCIAAgAigCHCACKALcB2o2AowCIAAgAigCICACKALgB2o2ApACIAAgAigCJCACKALkB2o2ApQCIAAgAigCKCACKALoB2o2ApgCIAAgAigCLCACKALsB2o2ApwCIAAgAigCMCACKALwB2o2AqACIAAgAigCNCACKAL0B2o2AqQCIAAgAigCOCACKAL4B2oiAzYCqAIgA0GAgIAQTgRAIAYQ0gILIAAgAigCPCACKAL8B2o2AqwCIAAgAigCQCACKAKACGo2ArACIAAgAigCRCACKAKECGo2ArQCIAAgAigCSCACKAKICGo2ArgCIAAgAigCTCACKAKMCGo2ArwCIAAgAigCUCACKAKQCGo2AsACIAAgAigCVCACKAKUCGo2AsQCIAAgAigCWCACKAKYCGo2AsgCIAAgAigCXCACKAKcCGo2AswCIAAgAigCYCACKAKgCGo2AtACIAAgAigCZCACKAKkCGo2AtQCIAAgAigCaCACKAKoCGo2AtgCIAAgAigCbCACKAKsCGo2AtwCIAAgAigCcCACKAKwCGo2AuACIAAgAigCdCACKAK0CGoiAzYC5AIgA0GAgIAQTgRAIA0Q0gILIAAgAigCeCACKAK4CGo2AugCIAAgAigCfCACKAK8CGo2AuwCIAAgAigCgAEgAigCwAhqNgLwAiAAIAIoAoQBIAIoAsQIajYC9AIgACACKAKIASACKALICGo2AvgCIAAgAigCjAEgAigCzAhqNgL8AiAAIAIoApABIAIoAtAIajYCgAMgACACKAKUASACKALUCGo2AoQDIAAgAigCmAEgAigC2AhqNgKIAyAAIAIoApwBIAIoAtwIajYCjAMgACACKAKgASACKALgCGo2ApADIAAgAigCpAEgAigC5AhqNgKUAyAAIAIoAqgBIAIoAugIajYCmAMgACACKAKsASACKALsCGo2ApwDIAAgAigCsAEgAigC8AhqIgM2AqADIANBgICAEE4EQCAJENICCyAAIAIoArQBIAIoAvQIajYCpAMgACACKAK4ASACKAL4CGo2AqgDIAAgAigCvAEgAigC/AhqNgKsAyAAIAIoAsABIAIoAoAJajYCsAMgACACKALEASACKAKECWo2ArQDIAAgAigCyAEgAigCiAlqNgK4AyAAIAIoAswBIAIoAowJajYCvAMgACACKALQASACKAKQCWo2AsADIAAgAigC1AEgAigClAlqNgLEAyAAIAIoAtgBIAIoApgJajYCyAMgACACKALcASACKAKcCWo2AswDIAAgAigC4AEgAigCoAlqNgLQAyAAIAIoAuQBIAIoAqQJajYC1AMgACACKALoASACKAKoCWo2AtgDIAAgAigC7AEgAigCrAlqIgM2AtwDIANBgICAEE4EQCAOENICCyACQeADaiACQeADaiACEPcCIAJBnARqIgogCiAPEPcCIAJB2ARqIgMgAyAFEPcCIAJBlAVqIgsgCyAQEPcCIAJB0AVqIAJB0AVqIAJB8AFqEPcCIAJBjAZqIgwgDCAHEPcCIAJByAZqIhQgFCAEEPcCIAJBhAdqIhUgFSAIEPcCIAJB8AFqIAAgERD3AiAHIBYgGBD3AiAEIBIgExD3AiAIIBcgGRD3AiACIAEgGhD3AiAPIBsgHhD3AiAFIBwgHxD3AiAQIB0gIBD3AiACQfABahD2AiAEEPYCIAIQ9gIgBRD2AiACQfABaiACIAJB8AFqEMYIIAJB0AVqIAJB0AVqIAJB8AFqEPcCIAwgDCAHEPcCIBQgFCAEEPcCIBUgFSAIEPcCIAJB8AFqIBEgGhDGCCACIAJB8AFqEMcIIAAgAigCACACKALQBWo2AuADIAAgAigCBCACKALUBWo2AuQDIAAgAigCCCACKALYBWo2AugDIAAgAigCDCACKALcBWo2AuwDIAAgAigCECACKALgBWo2AvADIAAgAigCFCACKALkBWo2AvQDIAAgAigCGCACKALoBWo2AvgDIAAgAigCHCACKALsBWo2AvwDIAAgAigCICACKALwBWo2AoAEIAAgAigCJCACKAL0BWo2AoQEIAAgAigCKCACKAL4BWo2AogEIAAgAigCLCACKAL8BWo2AowEIAAgAigCMCACKAKABmo2ApAEIAAgAigCNCACKAKEBmo2ApQEIAAgAigCOCACKAKIBmoiATYCmAQgAUGAgIAQTgRAIBEQ0gILIAAgAigCPCACKAKMBmo2ApwEIAAgAigCQCACKAKQBmo2AqAEIAAgAigCRCACKAKUBmo2AqQEIAAgAigCSCACKAKYBmo2AqgEIAAgAigCTCACKAKcBmo2AqwEIAAgAigCUCACKAKgBmo2ArAEIAAgAigCVCACKAKkBmo2ArQEIAAgAigCWCACKAKoBmo2ArgEIAAgAigCXCACKAKsBmo2ArwEIAAgAigCYCACKAKwBmo2AsAEIAAgAigCZCACKAK0Bmo2AsQEIAAgAigCaCACKAK4Bmo2AsgEIAAgAigCbCACKAK8Bmo2AswEIAAgAigCcCACKALABmo2AtAEIAAgAigCdCACKALEBmoiATYC1AQgAUGAgIAQTgRAIBgQ0gILIAAgAigCeCACKALIBmo2AtgEIAAgAigCfCACKALMBmo2AtwEIAAgAigCgAEgAigC0AZqNgLgBCAAIAIoAoQBIAIoAtQGajYC5AQgACACKAKIASACKALYBmo2AugEIAAgAigCjAEgAigC3AZqNgLsBCAAIAIoApABIAIoAuAGajYC8AQgACACKAKUASACKALkBmo2AvQEIAAgAigCmAEgAigC6AZqNgL4BCAAIAIoApwBIAIoAuwGajYC/AQgACACKAKgASACKALwBmo2AoAFIAAgAigCpAEgAigC9AZqNgKEBSAAIAIoAqgBIAIoAvgGajYCiAUgACACKAKsASACKAL8Bmo2AowFIAAgAigCsAEgAigCgAdqIgE2ApAFIAFBgICAEE4EQCATENICCyAAIAIoArQBIAIoAoQHajYClAUgACACKAK4ASACKAKIB2o2ApgFIAAgAigCvAEgAigCjAdqNgKcBSAAIAIoAsABIAIoApAHajYCoAUgACACKALEASACKAKUB2o2AqQFIAAgAigCyAEgAigCmAdqNgKoBSAAIAIoAswBIAIoApwHajYCrAUgACACKALQASACKAKgB2o2ArAFIAAgAigC1AEgAigCpAdqNgK0BSAAIAIoAtgBIAIoAqgHajYCuAUgACACKALcASACKAKsB2o2ArwFIAAgAigC4AEgAigCsAdqNgLABSAAIAIoAuQBIAIoArQHajYCxAUgACACKALoASACKAK4B2o2AsgFIAAgAigC7AEgAigCvAdqIgE2AswFIAFBgICAEE4EQCAZENICCyACQeADaiACQeADaiACEPcCIAogCiAPEPcCIAMgAyAFEPcCIAsgCyAQEPcCIAJB8AFqEMUIIAYgBiACQfABahD3AiANIA0gBxD3AiAJIAkgBBD3AiAOIA4gCBD3AiACQeADahD2AiADEPYCIAJB4ANqEMUIIAAgAigC4AMgAigCsAlqNgIAIAAgAigC5AMgAigCtAlqNgIEIAAgAigC6AMgAigCuAlqNgIIIAAgAigC7AMgAigCvAlqNgIMIAAgAigC8AMgAigCwAlqNgIQIAAgAigC9AMgAigCxAlqNgIUIAAgAigC+AMgAigCyAlqNgIYIAAgAigC/AMgAigCzAlqNgIcIAAgAigCgAQgAigC0AlqNgIgIAAgAigChAQgAigC1AlqNgIkIAAgAigCiAQgAigC2AlqNgIoIAAgAigCjAQgAigC3AlqNgIsIAAgAigCkAQgAigC4AlqNgIwIAAgAigClAQgAigC5AlqNgI0IAAgAigCmAQgAigC6AlqIgE2AjggAUGAgIAQTgRAIAAQ0gILIAAgAigCnAQgAigC7AlqNgI8IAAgAigCoAQgAigC8AlqNgJAIAAgAigCpAQgAigC9AlqNgJEIAAgAigCqAQgAigC+AlqNgJIIAAgAigCrAQgAigC/AlqNgJMIAAgAigCsAQgAigCgApqNgJQIAAgAigCtAQgAigChApqNgJUIAAgAigCuAQgAigCiApqNgJYIAAgAigCvAQgAigCjApqNgJcIAAgAigCwAQgAigCkApqNgJgIAAgAigCxAQgAigClApqNgJkIAAgAigCyAQgAigCmApqNgJoIAAgAigCzAQgAigCnApqNgJsIAAgAigC0AQgAigCoApqNgJwIAAgAigC1AQgAigCpApqIgE2AnQgAUGAgIAQTgRAIBYQ0gILIAAgAigC2AQgAigCqApqNgJ4IAAgAigC3AQgAigCrApqNgJ8IAAgAigC4AQgAigCsApqNgKAASAAIAIoAuQEIAIoArQKajYChAEgACACKALoBCACKAK4Cmo2AogBIAAgAigC7AQgAigCvApqNgKMASAAIAIoAvAEIAIoAsAKajYCkAEgACACKAL0BCACKALECmo2ApQBIAAgAigC+AQgAigCyApqNgKYASAAIAIoAvwEIAIoAswKajYCnAEgACACKAKABSACKALQCmo2AqABIAAgAigChAUgAigC1ApqNgKkASAAIAIoAogFIAIoAtgKajYCqAEgACACKAKMBSACKALcCmo2AqwBIAAgAigCkAUgAigC4ApqIgE2ArABIAFBgICAEE4EQCASENICCyAAIAIoApQFIAIoAuQKajYCtAEgACACKAKYBSACKALoCmo2ArgBIAAgAigCnAUgAigC7ApqNgK8ASAAIAIoAqAFIAIoAvAKajYCwAEgACACKAKkBSACKAL0Cmo2AsQBIAAgAigCqAUgAigC+ApqNgLIASAAIAIoAqwFIAIoAvwKajYCzAEgACACKAKwBSACKAKAC2o2AtABIAAgAigCtAUgAigChAtqNgLUASAAIAIoArgFIAIoAogLajYC2AEgACACKAK8BSACKAKMC2o2AtwBIAAgAigCwAUgAigCkAtqNgLgASAAIAIoAsQFIAIoApQLajYC5AEgACACKALIBSACKAKYC2o2AugBIAAgAigCzAUgAigCnAtqIgE2AuwBIAFBgICAEE4EQCAXENICCyAAQQQ2AtAFIAAQ9gIgEhD2AiAGEPYCIAkQ9gIgERD2AiATEPYCIAJBoAtqJAALaAAgACABRwRAIAAgARDkAiAAQfgAaiABQfgAahDkAiAAQfABaiABQfABahDkAiAAQegCaiABQegCahDkAiAAQeADaiABQeADahDkAiAAQdgEaiABQdgEahDkAiAAIAEoAtAFNgLQBQsLxQEBBX8jAEHwAWsiAiQAIAJB+ABqIAEQhwMgAiACQfgAaiABEPkCIAAgABCIAyAAQfgAaiIDIAMQiAMgAyACIAMQ+QIgAEHwAWoiBSAFEIgDIABB6AJqIgMgAxCIAyADIAIgAxD5AiAAQeADaiIGIAYQiAMgAEHYBGoiBCAEEIgDIAQgAiAEEPkCIAUgBSABEPkCIAMgAyABEPkCIAYgBiACQfgAahD5AiAEIAQgAkH4AGoQ+QIgAEEENgLQBSACQfABaiQAC+UUARF/IwBBwAdrIgIkACABIAJB0AVqRwRAIAJB0AVqIAEQ5AIgAkHIBmogAUH4AGoQ5AILIAAgARDECCACIAAgABD3AiACQTxqIgQgAEE8aiIKIAoQ9wIgAkH4AGoiBSAAQfgAaiIJIAkQ9wIgAkG0AWoiBiAAQbQBaiILIAsQ9wIgACACIAAQ9wIgCiAEIAoQ9wIgCSAFIAkQ9wIgCyAGIAsQ9wIgABD2AiAJEPYCIAJB0AVqIAJB0AVqEJADIAJB0AVqIAJB0AVqIAJB0AVqEPcCIAJBjAZqIgMgAyADEPcCIAJByAZqIgcgByAHEPcCIAJBhAdqIgggCCAIEPcCIAAgACACQdAFahD3AiAKIAogAxD3AiAJIAkgBxD3AiALIAsgCBD3AiACQeADaiABQeADaiIHEMQIIAJB4ANqEMUIIAIgAigC4ANBAXQ2AgAgAiACKALkA0EBdDYCBCACIAIoAugDQQF0NgIIIAIgAigC7ANBAXQ2AgwgAiACKALwA0EBdDYCECACIAIoAvQDQQF0NgIUIAIgAigC+ANBAXQ2AhggAiACKAL8A0EBdDYCHCACIAIoAoAEQQF0NgIgIAIgAigChARBAXQ2AiQgAiACKAKIBEEBdDYCKCACIAIoAowEQQF0NgIsIAIgAigCkARBAXQ2AjAgAiACKAKUBEEBdDYCNCACIAIoApgEIgNBAXQ2AjggA0GAgIAITgRAIAIQ0gILIAIgAigCnARBAXQ2AjwgAiACKAKgBEEBdDYCQCACIAIoAqQEQQF0NgJEIAIgAigCqARBAXQ2AkggAiACKAKsBEEBdDYCTCACIAIoArAEQQF0NgJQIAIgAigCtARBAXQ2AlQgAiACKAK4BEEBdDYCWCACIAIoArwEQQF0NgJcIAIgAigCwARBAXQ2AmAgAiACKALEBEEBdDYCZCACIAIoAsgEQQF0NgJoIAIgAigCzARBAXQ2AmwgAiACKALQBEEBdDYCcCACIAIoAtQEIgNBAXQ2AnQgA0GAgIAITgRAIAQQ0gILIAIgAigC2ARBAXQ2AnggAiACKALcBEEBdDYCfCACIAIoAuAEQQF0NgKAASACIAIoAuQEQQF0NgKEASACIAIoAugEQQF0NgKIASACIAIoAuwEQQF0NgKMASACIAIoAvAEQQF0NgKQASACIAIoAvQEQQF0NgKUASACIAIoAvgEQQF0NgKYASACIAIoAvwEQQF0NgKcASACIAIoAoAFQQF0NgKgASACIAIoAoQFQQF0NgKkASACIAIoAogFQQF0NgKoASACIAIoAowFQQF0NgKsASACIAIoApAFIgNBAXQ2ArABIANBgICACE4EQCAFENICCyACIAIoApQFQQF0NgK0ASACIAIoApgFQQF0NgK4ASACIAIoApwFQQF0NgK8ASACIAIoAqAFQQF0NgLAASACIAIoAqQFQQF0NgLEASACIAIoAqgFQQF0NgLIASACIAIoAqwFQQF0NgLMASACIAIoArAFQQF0NgLQASACIAIoArQFQQF0NgLUASACIAIoArgFQQF0NgLYASACIAIoArwFQQF0NgLcASACIAIoAsAFQQF0NgLgASACIAIoAsQFQQF0NgLkASACIAIoAsgFQQF0NgLoASACIAIoAswFIgNBAXQ2AuwBIANBgICACE4EQCAGENICCyACQeADaiACQeADaiACEPcCIAJBnARqIg8gDyAEEPcCIAJB2ARqIg0gDSAFEPcCIAJBlAVqIhAgECAGEPcCIAJB4ANqEPYCIA0Q9gIgAkHwAWogAUHwAWoiAxDECCACIAIoAvABQQF0NgIAIAIgAigC9AFBAXQ2AgQgAiACKAL4AUEBdDYCCCACIAIoAvwBQQF0NgIMIAIgAigCgAJBAXQ2AhAgAiACKAKEAkEBdDYCFCACIAIoAogCQQF0NgIYIAIgAigCjAJBAXQ2AhwgAiACKAKQAkEBdDYCICACIAIoApQCQQF0NgIkIAIgAigCmAJBAXQ2AiggAiACKAKcAkEBdDYCLCACIAIoAqACQQF0NgIwIAIgAigCpAJBAXQ2AjQgAiACKAKoAiIBQQF0NgI4IAFBgICACE4EQCACENICCyACIAIoAqwCQQF0NgI8IAIgAigCsAJBAXQ2AkAgAiACKAK0AkEBdDYCRCACIAIoArgCQQF0NgJIIAIgAigCvAJBAXQ2AkwgAiACKALAAkEBdDYCUCACIAIoAsQCQQF0NgJUIAIgAigCyAJBAXQ2AlggAiACKALMAkEBdDYCXCACIAIoAtACQQF0NgJgIAIgAigC1AJBAXQ2AmQgAiACKALYAkEBdDYCaCACIAIoAtwCQQF0NgJsIAIgAigC4AJBAXQ2AnAgAiACKALkAiIBQQF0NgJ0IAFBgICACE4EQCAEENICCyACIAIoAugCQQF0NgJ4IAIgAigC7AJBAXQ2AnwgAiACKALwAkEBdDYCgAEgAiACKAL0AkEBdDYChAEgAiACKAL4AkEBdDYCiAEgAiACKAL8AkEBdDYCjAEgAiACKAKAA0EBdDYCkAEgAiACKAKEA0EBdDYClAEgAiACKAKIA0EBdDYCmAEgAiACKAKMA0EBdDYCnAEgAiACKAKQA0EBdDYCoAEgAiACKAKUA0EBdDYCpAEgAiACKAKYA0EBdDYCqAEgAiACKAKcA0EBdDYCrAEgAiACKAKgAyIBQQF0NgKwASABQYCAgAhOBEAgBRDSAgsgAiACKAKkA0EBdDYCtAEgAiACKAKoA0EBdDYCuAEgAiACKAKsA0EBdDYCvAEgAiACKAKwA0EBdDYCwAEgAiACKAK0A0EBdDYCxAEgAiACKAK4A0EBdDYCyAEgAiACKAK8A0EBdDYCzAEgAiACKALAA0EBdDYC0AEgAiACKALEA0EBdDYC1AEgAiACKALIA0EBdDYC2AEgAiACKALMA0EBdDYC3AEgAiACKALQA0EBdDYC4AEgAiACKALUA0EBdDYC5AEgAiACKALYA0EBdDYC6AEgAiACKALcAyIBQQF0NgLsASABQYCAgAhOBEAgBhDSAgsgAkHwAWogAkHwAWogAhD3AiACQawCaiIRIBEgBBD3AiACQegCaiIOIA4gBRD3AiACQaQDaiISIBIgBhD3AiACQfABahD2AiAOEPYCIABB8AFqIgEgAxCPAyABIAEgARD3AiAAQawCaiIFIAUgBRD3AiAAQegCaiIGIAYgBhD3AiAAQaQDaiIDIAMgAxD3AiAAQeADaiIEIAcQkAMgBCAEIAQQ9wIgAEGcBGoiByAHIAcQ9wIgAEHYBGoiCCAIIAgQ9wIgAEGUBWoiDCAMIAwQ9wIgASACQeADaiABEPcCIAUgDyAFEPcCIAYgDSAGEPcCIAMgECADEPcCIAQgAkHwAWogBBD3AiAHIBEgBxD3AiAIIA4gCBD3AiAMIBIgDBD3AiAAQQQ2AtAFIAAQ0gIgChDSAiAJENICIAsQ0gIgARDSAiAFENICIAYQ0gIgAxDSAiAEENICIAcQ0gIgCBDSAiAMENICIAJBwAdqJAAL6CYCD38BfiMAQaAMayIDJAAgAigCNCEGIAIoAjAhBCACKAIsIQUgAigCKCEHIAIoAiQhCCACKAIgIQkgAigCHCEKIAIoAhghCyACKAIUIQwgAigCECENIAIoAgwhDiACKAIIIQ8gAigCBCEQIAMgAigCACICQQNsQf////8BcTYCACADIAJB/////wFxIhE2AkAgAyAQIAJBHXVqIgJB/////wFxIhA2AkQgAyAQQQNsrSARrUIYfkIgiHwiEqdB/////wFxNgIEIAMgDyACQR11aiICQf////8BcSIPNgJIIAMgD0EDbK0gEkIdiHwiEqdB/////wFxNgIIIAMgDiACQR11aiICQf////8BcSIONgJMIAMgDkEDbK0gEkIdiHwiEqdB/////wFxNgIMIAMgDSACQR11aiICQf////8BcSINNgJQIAMgDUEDbK0gEkIdiHwiEqdB/////wFxNgIQIAMgDCACQR11aiICQf////8BcSIMNgJUIAMgDEEDbK0gEkIdiHwiEqdB/////wFxNgIUIAMgCyACQR11aiICQf////8BcSILNgJYIAMgC0EDbK0gEkIdiHwiEqdB/////wFxNgIYIAMgCiACQR11aiICQf////8BcSIKNgJcIAMgCkEDbK0gEkIdiHwiEqdB/////wFxNgIcIAMgCSACQR11aiICQf////8BcSIJNgJgIAMgCUEDbK0gEkIdiHwiEqdB/////wFxNgIgIAMgCCACQR11aiICQf////8BcSIINgJkIAMgCEEDbK0gEkIdiHwiEqdB/////wFxNgIkIAMgByACQR11aiICQf////8BcSIHNgJoIAMgB0EDbK0gEkIdiHwiEqdB/////wFxNgIoIAMgBSACQR11aiICQf////8BcSIFNgJsIAMgBUEDbK0gEkIdiHwiEqdB/////wFxNgIsIAMgBCACQR11aiICQf////8BcSIENgJwIAMgBEEDbK0gEkIdiHwiEqdB/////wFxNgIwIAMgBiACQR11aiICNgJ0IAMgAq1CA34gEkIdiHynQf////8BcTYCNCADQfgAaiABRwRAIANB+ABqIAEQ5AIgA0HwAWogAUH4AGoQ5AIgA0HoAmogAUHwAWoQ5AIgA0HgA2ogAUHoAmoQ5AIgA0HYBGogAUHgA2oQ5AIgA0HQBWogAUHYBGoQ5AIgAyABKALQBTYCyAYLIANB+ABqEPYCIANB8AFqEPYCIANB6AJqIgQQ9gIgA0HgA2oQ9gIgA0HYBGoiBRD2AiADQdAFahD2AiADIAMoAng2AswGIAMgA/0AAnz9CwLQBiADIAP9AAKMAf0LAuAGIAMgA/0AApwB/QsC8AYgAyAD/QACrAH9CwKAByADIAP9AAK8Af0LApAHIAMgA/0AAswB/QsCoAcgAyADKQLcATcCsAcgAyADKALkATYCuAcgAyADKALoATYCvAcgAyAD/QAC7AH9CwLAByADIAP9AAL8Af0LAtAHIAMgA/0AAowC/QsC4AcgAyAD/QACnAL9CwLwByADIAP9AAKsAv0LAoAIIAMgA/0AArwC/QsCkAggAyADKQLMAjcCoAggAyADKALUAjYCqAggAyADKALYAjYCrAggAyAD/QAC3AL9CwKwCCADIAP9AALsAv0LAsAIIAMgA/0AAvwC/QsC0AggAyAD/QACjAP9CwLgCCADIAP9AAKcA/0LAvAIIAMgA/0AAqwD/QsCgAkgAyADKQK8AzcCkAkgAyADKALEAzYCmAkgAyADKALIAzYCnAkgAyADKALMAzYCoAkgAyADKALQAzYCpAkgAyADKALUAzYCqAkgAyADKALYAzYCrAkgAyADKALcAzYCsAkgAyADKALgAzYCtAkgAyADKALkAzYCuAkgAyADKALoAzYCvAkgAyADKALsAzYCwAkgAyADKALwAzYCxAkgAyADKAL0AzYCyAkgAyADKAL4AzYCzAkgAyADKAL8AzYC0AkgAyADKAKABDYC1AkgAyADKAKEBDYC2AkgAyADKAKIBDYC3AkgAyADKAKMBDYC4AkgAyADKAKQBDYC5AkgAyADKAKUBDYC6AkgAyADKAKYBDYC7AkgAyADKAKcBDYC8AkgAyADKAKgBDYC9AkgAyADKAKkBDYC+AkgAyADKAKoBDYC/AkgAyADKAKsBDYCgAogAyADKAKwBDYChAogAyADKAK0BDYCiAogAyADKAK4BDYCjAogAyADKAK8BDYCkAogAyADKALABDYClAogAyADKALEBDYCmAogAyADKALIBDYCnAogAyADKALMBDYCoAogAyADKALQBDYCpAogAyADKALUBDYCqAogAyADKALYBDYCrAogAyADKALcBDYCsAogAyADKALgBDYCtAogAyADKALkBDYCuAogAyADKALoBDYCvAogAyADKALsBDYCwAogAyADKALwBDYCxAogAyADKAL0BDYCyAogAyADKAL4BDYCzAogAyADKAL8BDYC0AogAyADKAKABTYC1AogAyADKAKEBTYC2AogAyADKAKIBTYC3AogAyADKAKMBTYC4AogAyADKAKQBTYC5AogAyADKAKUBTYC6AogAyADKAKYBTYC7AogAyADKAKcBTYC8AogAyADKAKgBTYC9AogAyADKAKkBTYC+AogAyADKAKoBTYC/AogAyADKAKsBTYCgAsgAyADKAKwBTYChAsgAyADKAK0BTYCiAsgAyADKAK4BTYCjAsgAyADKAK8BTYCkAsgAyADKALABTYClAsgAyADKALEBTYCmAsgAyADKALIBTYCnAsgAyADKALMBTYCoAsgAyADKALQBTYCpAsgAyADKALUBTYCqAsgAyADKALYBTYCrAsgAyADKALcBTYCsAsgAyADKALgBTYCtAsgAyADKALkBTYCuAsgAyADKALoBTYCvAsgAyADKALsBTYCwAsgAyADKALwBTYCxAsgAyADKAL0BTYCyAsgAyADKAL4BTYCzAsgAyADKAL8BTYC0AsgAyADKAKABjYC1AsgAyADKAKEBjYC2AsgAyADKAKIBjYC3AsgAyADKAKMBjYC4AsgAyADKAKQBjYC5AsgAyADKAKUBjYC6AsgAyADKAKYBjYC7AsgAyADKAKcBjYC8AsgAyADKAKgBjYC9AsgAyADKAKkBjYC+AsgAyADKAKoBjYC/AsgAyADKAKsBjYCgAwgAyADKAKwBjYChAwgAyADKAK0BjYCiAwgAyADKAK4BjYCjAwgAyADKAK8BjYCkAwgAyADKALABjYClAwgAyADKALEBjYCmAwgAyADKALIBjYCnAwgAxCwAyICQQNOBEAgAkECayECA0AgA0HMBmogA0HMBmoQlAMCQAJAAkAgAyACQR1tIgFBAnQiBmooAgAgAUFjbCACaiIBdkEBcSADQUBrIAZqKAIAIAF2QQFxa0EBag4DAQIAAgsgA0HMBmogA0H4AGoQkQMMAQsgA0H4AGogA0H4AGoQjwMgBCAEEJADIAUgBRCPAyADQcwGaiADQfgAahCRAyADQfgAaiADQfgAahCPAyAEIAQQkAMgBSAFEI8DCyACQQFKIQEgAkEBayECIAENAAsLIAAgA0HMBmpHBEAgACADKALMBjYCACAAIAMoAtAGNgIEIAAgAygC1AY2AgggACADKALYBjYCDCAAIAMoAtwGNgIQIAAgAygC4AY2AhQgACADKALkBjYCGCAAIAMoAugGNgIcIAAgAygC7AY2AiAgACADKALwBjYCJCAAIAMoAvQGNgIoIAAgAygC+AY2AiwgACADKAL8BjYCMCAAIAMoAoAHNgI0IAAgAygChAc2AjggACADKAKIBzYCPCAAIAMoAowHNgJAIAAgAygCkAc2AkQgACADKAKUBzYCSCAAIAMoApgHNgJMIAAgAygCnAc2AlAgACADKAKgBzYCVCAAIAMoAqQHNgJYIAAgAygCqAc2AlwgACADKAKsBzYCYCAAIAMoArAHNgJkIAAgAygCtAc2AmggACADKAK4BzYCbCAAIAMoArwHNgJwIAAgAygCwAc2AnQgACADKALEBzYCeCAAIAMoAsgHNgJ8IAAgAygCzAc2AoABIAAgAygC0Ac2AoQBIAAgAygC1Ac2AogBIAAgAygC2Ac2AowBIAAgAygC3Ac2ApABIAAgAygC4Ac2ApQBIAAgAygC5Ac2ApgBIAAgAygC6Ac2ApwBIAAgAygC7Ac2AqABIAAgAygC8Ac2AqQBIAAgAygC9Ac2AqgBIAAgAygC+Ac2AqwBIAAgAygC/Ac2ArABIAAgAygCgAg2ArQBIAAgAygChAg2ArgBIAAgAygCiAg2ArwBIAAgAygCjAg2AsABIAAgAygCkAg2AsQBIAAgAygClAg2AsgBIAAgAygCmAg2AswBIAAgAygCnAg2AtABIAAgAygCoAg2AtQBIAAgAygCpAg2AtgBIAAgAygCqAg2AtwBIAAgAygCrAg2AuABIAAgAygCsAg2AuQBIAAgAygCtAg2AugBIAAgAygCuAg2AuwBIAAgAygCvAg2AvABIAAgAygCwAg2AvQBIAAgAygCxAg2AvgBIAAgAygCyAg2AvwBIAAgAygCzAg2AoACIAAgAygC0Ag2AoQCIAAgAygC1Ag2AogCIAAgAygC2Ag2AowCIAAgAygC3Ag2ApACIAAgAygC4Ag2ApQCIAAgAygC5Ag2ApgCIAAgAygC6Ag2ApwCIAAgAygC7Ag2AqACIAAgAygC8Ag2AqQCIAAgAygC9Ag2AqgCIAAgAygC+Ag2AqwCIAAgAygC/Ag2ArACIAAgAygCgAk2ArQCIAAgAygChAk2ArgCIAAgAygCiAk2ArwCIAAgAygCjAk2AsACIAAgAygCkAk2AsQCIAAgAygClAk2AsgCIAAgAygCmAk2AswCIAAgAygCnAk2AtACIAAgAygCoAk2AtQCIAAgAygCpAk2AtgCIAAgAygCqAk2AtwCIAAgAygCrAk2AuACIAAgAygCsAk2AuQCIAAgAygCtAk2AugCIAAgAygCuAk2AuwCIAAgAygCvAk2AvACIAAgAygCwAk2AvQCIAAgAygCxAk2AvgCIAAgAygCyAk2AvwCIAAgAygCzAk2AoADIAAgAygC0Ak2AoQDIAAgAygC1Ak2AogDIAAgAygC2Ak2AowDIAAgAygC3Ak2ApADIAAgAygC4Ak2ApQDIAAgAygC5Ak2ApgDIAAgAygC6Ak2ApwDIAAgAygC7Ak2AqADIAAgAygC8Ak2AqQDIAAgAygC9Ak2AqgDIAAgAygC+Ak2AqwDIAAgAygC/Ak2ArADIAAgAygCgAo2ArQDIAAgAygChAo2ArgDIAAgAygCiAo2ArwDIAAgAygCjAo2AsADIAAgAygCkAo2AsQDIAAgAygClAo2AsgDIAAgAygCmAo2AswDIAAgAygCnAo2AtADIAAgAygCoAo2AtQDIAAgAygCpAo2AtgDIAAgAygCqAo2AtwDIAAgAygCrAo2AuADIAAgAygCsAo2AuQDIAAgAygCtAo2AugDIAAgAygCuAo2AuwDIAAgAygCvAo2AvADIAAgAygCwAo2AvQDIAAgAygCxAo2AvgDIAAgAygCyAo2AvwDIAAgAygCzAo2AoAEIAAgAygC0Ao2AoQEIAAgAygC1Ao2AogEIAAgAygC2Ao2AowEIAAgAygC3Ao2ApAEIAAgAygC4Ao2ApQEIAAgAygC5Ao2ApgEIAAgAygC6Ao2ApwEIAAgAygC7Ao2AqAEIAAgAygC8Ao2AqQEIAAgAygC9Ao2AqgEIAAgAygC+Ao2AqwEIAAgAygC/Ao2ArAEIAAgAygCgAs2ArQEIAAgAygChAs2ArgEIAAgAygCiAs2ArwEIAAgAygCjAs2AsAEIAAgAygCkAs2AsQEIAAgAygClAs2AsgEIAAgAygCmAs2AswEIAAgAygCnAs2AtAEIAAgAygCoAs2AtQEIAAgAygCpAs2AtgEIAAgAygCqAs2AtwEIAAgAygCrAs2AuAEIAAgAygCsAs2AuQEIAAgAygCtAs2AugEIAAgAygCuAs2AuwEIAAgAygCvAs2AvAEIAAgAygCwAs2AvQEIAAgAygCxAs2AvgEIAAgAygCyAs2AvwEIAAgAygCzAs2AoAFIAAgAygC0As2AoQFIAAgAygC1As2AogFIAAgAygC2As2AowFIAAgAygC3As2ApAFIAAgAygC4As2ApQFIAAgAygC5As2ApgFIAAgAygC6As2ApwFIAAgAygC7As2AqAFIAAgAygC8As2AqQFIAAgAygC9As2AqgFIAAgAygC+As2AqwFIAAgAygC/As2ArAFIAAgAygCgAw2ArQFIAAgAygChAw2ArgFIAAgAygCiAw2ArwFIAAgAygCjAw2AsAFIAAgAygCkAw2AsQFIAAgAygClAw2AsgFIAAgAygCmAw2AswFIAAgAygCnAw2AtAFCyAAENICIABBPGoQ0gIgAEH4AGoQ0gIgAEG0AWoQ0gIgAEHwAWoQ0gIgAEGsAmoQ0gIgAEHoAmoQ0gIgAEGkA2oQ0gIgAEHgA2oQ0gIgAEGcBGoQ0gIgAEHYBGoQ0gIgAEGUBWoQ0gIgA0GgDGokAAuBBwIFfwF7IwBBEGsiBSQAAkACQCABKAIQIgNFDQAgAS8BFEUNACAAQevyKkEAEFsMAQsCQAJAIAEoAgwiAkUNACABLwEURQRAIAFBATsBFAJAQaSINCgCACIDBEACfwJAIAMoAhRB8ABJDQAgAygCBCIARQ0AIAMoAhgiAiACKALAA0EBajYCwAMgAyADKAIcQQFqNgIcIAMgAygCIEHwAGo2AiAgAyADKAIsQfAAajYCLCADIAAoAgA2AgRBCCEGIAMhBEF/DAELIAMhBEHwABAqIgBFBEAQT0GkiDQoAgAhBAsgAyADKAIkQQFqNgIkIAMgAygCKEHwAGo2AihBLCEGQfAACyECIAMgBmoiAyADKAIAIAJqNgIAIAEoAgwhAgwBC0HwABAqIQALIAEgADYCECAAIAIoAgA2AgAgACACKAIENgIEIAAgAigCCDYCCCAAIAIoAgw2AgwgACACKAIQNgIQIAAgAigCFDYCFCAAIAIoAhg2AhggACACKAIcNgIcIAAgAigCIDYCICAAIAIoAiQ2AiQgACACKAIoNgIoIAAgAigCLDYCLCAAIAIoAjA2AjAgACACKAI0Qf////8BcTYCNCACKAI0IQMgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAjwgACAH/QsCTCAAIAf9CwJcIABBADYCbCAAIANBHXU2AjgCQAJAIARFDQAgBSACNgIMIAQoAgAiACAFKAIMSw0AIAUoAgwgACAEKAIQak8NACACIAQoAgQ2AgAgBCACNgIEIAQgBCgCCEEBajYCCCAEKAIUIgBBBEkNASAAQXxxIgBFDQEgAkEAIAD8CwAMAQsgAhArCyABQeAANgIEIAFBADYCDAwBCyADDQELIAFBATsBFAJAQaSINCgCACICBEACfwJAIAIoAhRB8ABJDQAgAigCBCIARQ0AIAIoAhgiAyADKALAA0EBajYCwAMgAiACKAIcQQFqNgIcIAIgAigCIEHwAGo2AiAgAiACKAIsQfAAajYCLCACIAAoAgA2AgRBCCEEQX8MAQtB8AAQKiIARQRAEE8LIAIgAigCJEEBajYCJCACIAIoAihB8ABqNgIoQSwhBEHwAAshAyACIARqIgIgAigCACADajYCAAwBC0HwABAqIQALIAFB4AA2AgQgASAANgIQDAELIABB0bIqQQAQbgsgBUEQaiQAC6AEAQJ/IABBGEEBENoBIQMgAEHY4c59QbHwKhCQARogAEF+ENsBIANBADsBFCADQiA3AgggA0EANgIQIANBAToAAAJAIAEvARQEQCAAIAMQlgMgAygCECIAIAEoAhAiAigCADYCACAAIAIoAgQ2AgQgACACKAIINgIIIAAgAigCDDYCDCAAIAIoAhA2AhAgACACKAIUNgIUIAAgAigCGDYCGCAAIAIoAhw2AhwgACACKAIgNgIgIAAgAigCJDYCJCAAIAIoAig2AiggACACKAIsNgIsIAAgAigCMDYCMCAAIAIoAjQ2AjQgACACKAI4NgI4IAAgAigCPDYCPCAAIAIoAkA2AkAgACACKAJENgJEIAAgAigCSDYCSCAAIAIoAkw2AkwgACACKAJQNgJQIAAgAigCVDYCVCAAIAIoAlg2AlggACACKAJcNgJcIAAgAigCYDYCYCAAIAIoAmQ2AmQgACACKAJoNgJoIAAgAigCbDYCbAwBCyAAIAMQyAIgAygCDCIAIAEoAgwiAigCADYCACAAIAIoAgQ2AgQgACACKAIINgIIIAAgAigCDDYCDCAAIAIoAhA2AhAgACACKAIUNgIUIAAgAigCGDYCGCAAIAIoAhw2AhwgACACKAIgNgIgIAAgAigCJDYCJCAAIAIoAig2AiggACACKAIsNgIsIAAgAigCMDYCMCAAIAIoAjQ2AjQLIAMgAS0AADoAACADC7EFAQF/IAAgACgCACIBQf////8BcTYCACAAIAAoAgQgAUEddWoiAUH/////AXE2AgQgACAAKAIIIAFBHXVqIgFB/////wFxNgIIIAAgACgCDCABQR11aiIBQf////8BcTYCDCAAIAAoAhAgAUEddWoiAUH/////AXE2AhAgACAAKAIUIAFBHXVqIgFB/////wFxNgIUIAAgACgCGCABQR11aiIBQf////8BcTYCGCAAIAAoAhwgAUEddWoiAUH/////AXE2AhwgACAAKAIgIAFBHXVqIgFB/////wFxNgIgIAAgACgCJCABQR11aiIBQf////8BcTYCJCAAIAAoAiggAUEddWoiAUH/////AXE2AiggACAAKAIsIAFBHXVqIgFB/////wFxNgIsIAAgACgCMCABQR11aiIBQf////8BcTYCMCAAIAAoAjQgAUEddWoiAUH/////AXE2AjQgACAAKAI4IAFBHXVqIgFB/////wFxNgI4IAAgACgCPCABQR11aiIBQf////8BcTYCPCAAIAAoAkAgAUEddWoiAUH/////AXE2AkAgACAAKAJEIAFBHXVqIgFB/////wFxNgJEIAAgACgCSCABQR11aiIBQf////8BcTYCSCAAIAAoAkwgAUEddWoiAUH/////AXE2AkwgACAAKAJQIAFBHXVqIgFB/////wFxNgJQIAAgACgCVCABQR11aiIBQf////8BcTYCVCAAIAAoAlggAUEddWoiAUH/////AXE2AlggACAAKAJcIAFBHXVqIgFB/////wFxNgJcIAAgACgCYCABQR11aiIBQf////8BcTYCYCAAIAAoAmQgAUEddWoiAUH/////AXE2AmQgACAAKAJoIAFBHXVqIgFB/////wFxNgJoIAAgACgCbCABQR11ajYCbAvtAgEEfyMAQRBrIgIkAAJAIABBAUGx8CoQ3AEiA0UNACAAAn8gAy8BFARAIAMoAhAiAQRAAkACQEGkiDQoAgAiAEUNACACIAE2AgggACgCACIEIAIoAghLDQAgAigCCCAEIAAoAhBqTw0AIAEgACgCBDYCACAAIAE2AgQgACAAKAIIQQFqNgIIIAAoAhQiAEEESQ0BIABBfHEiAEUNASABQQAgAPwLAAwBCyABECsLIANBADYCEAsgAygCDEUNAkG88ioMAQsgAygCDCIBBEACQAJAQaSINCgCACIARQ0AIAIgATYCDCAAKAIAIgQgAigCDEsNACACKAIMIAQgACgCEGpPDQAgASAAKAIENgIAIAAgATYCBCAAIAAoAghBAWo2AgggACgCFCIAQQRJDQEgAEF8cSIARQ0BIAFBACAA/AsADAELIAEQKwsgA0EANgIMCyADKAIQRQ0BQdXxKgtBABCcAQsgAkEQaiQAQQAL0AIBCH8jAEEwayICJAAgAkHZ4Sk2AiAgAEH5hiogAkEgahCbAQJAAkAgAEEBEM4CIghFBEBBnPMqIQMMAQsgACAIEN0BIgZFBEBBtfEqIQMMAQsgACAGKAIAIgMQhgEiBEUEQEEAIQMgAEHp2ytBABBuQQEhBwwCC0EBIQcgBCgCBCIFQQBKBEADQCAEKAIIIAFqQQA6AAAgAUEBaiIBIAQoAgQiBUgNAAsLIAQgAyAFIAMgBUgbIgE2AgAgAUEATARAQQAhAwwCCyAGKAIIIQVBACEDQQAhAQNAIAQoAgggAWogASAFai0AADoAACABQQFqIgEgBCgCAEgNAAsMAQtBACEGCyAIENACIAYQmgEgB0UEQCACIAM2AhQgAkHZ4Sk2AhAgAEH8iCogAkEQahBsAAsgAkHZ4Sk2AgAgAEHghyogAhCbASACQTBqJABBAQuyAQEFfyMAQTBrIgEkACABQd67KTYCICAAQfmGKiABQSBqEJsBAn8CQCAAQQEQzgIiBEUEQEGc8yohAgwBCyAAIAQQ3QEiA0UEQEG18SohAgwBCyAAIAMQ2QFBAQwBC0EAIQNBAAshBSADEJoBIAQQ0AIgBUUEQCABIAI2AhQgAUHeuyk2AhAgAEH8iCogAUEQahBsAAsgAUHeuyk2AgAgAEHghyogARCbASABQTBqJABBAQumEQMVfwF+AXsjAEHwAmsiASQAIAFBg+sqNgIwIABB+YYqIAFBMGoQmwECQAJAAkAgAEEBEM4CIgkEQCAJLwEUDQEgCSgCEA0BIAkoAgwiAiACKAIAIgNB/////wFxIgQ2AgAgAiACKAIEIANBHXVqIgNB/////wFxIgc2AgQgAiACKAIIIANBHXVqIgNB/////wFxIgg2AgggAiACKAIMIANBHXVqIgNB/////wFxIgU2AgwgAiACKAIQIANBHXVqIgNB/////wFxIgo2AhAgAiACKAIUIANBHXVqIgNB/////wFxIgs2AhQgAiACKAIYIANBHXVqIgNB/////wFxIg02AhggAiACKAIcIANBHXVqIgNB/////wFxIhI2AhwgAiACKAIgIANBHXVqIgNB/////wFxIgw2AiAgAiACKAIkIANBHXVqIgNB/////wFxIg42AiQgAiACKAIoIANBHXVqIgNB/////wFxIg82AiggAiACKAIsIANBHXVqIgNB/////wFxIhA2AiwgAiACKAIwIANBHXVqIgNB/////wFxIhE2AjAgAiACKAI0IANBHXVqIgM2AjQgASADNgLkAiABIBE2AuACIAEgEDYC3AIgASAPNgLYAiABIA42AtQCIAEgDDYC0AIgASASNgLMAiABIA02AsgCIAEgCzYCxAIgASAKNgLAAiABIAU2ArwCIAEgCDYCuAIgASAHNgK0AiABIAQ2ArACIAFCADcDoAIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJACIAEgF/0LBIACIAEgF/0LBPABIAFBCjYC8AEgCSgCDCIGKAI0IRJBACECQQAhB0EAIQVBACEKQQAhC0EAIQ1BACEOQQAhD0EAIRBBACERQQEhCEEAIQwDQAJAIAIhAwJAAkAgEiIEIAJHDQAgBigCMCIEIAciA0cNACAGKAIsIgQgBSIDRw0AIAYoAigiBCAKIgNHDQAgBigCJCIEIAsiA0cNACAGKAIgIgQgDSIDRw0AIAYoAhwiBCAOIgNHDQAgBigCGCIEIA8iA0cNACAGKAIUIgQgECIDRw0AIAYoAhAiBCARIgNHDQAgBigCDCIEIBMiA0cNACAGKAIIIgQgFCIDRw0AIAYoAgQiBCAVIgNHDQAgBigCACIEIAgiA0YNAQsgAyAESg0BCyAVrUIKfiAIrULQAH5CIIh8IhanQf////8BcSEVIBStQgp+IBZCHYh8IhanQf////8BcSEUIBOtQgp+IBZCHYh8IhanQf////8BcSETIBGtQgp+IBZCHYh8IhanQf////8BcSERIBCtQgp+IBZCHYh8IhanQf////8BcSEQIA+tQgp+IBZCHYh8IhanQf////8BcSEPIA6tQgp+IBZCHYh8IhanQf////8BcSEOIA2tQgp+IBZCHYh8IhanQf////8BcSENIAutQgp+IBZCHYh8IhanQf////8BcSELIAqtQgp+IBZCHYh8IhanQf////8BcSEKIAWtQgp+IBZCHYh8IhanQf////8BcSEFIAetQgp+IBZCHYh8IhanQf////8BcSEHIAKtQgp+IBZCHYh8p0H/////AXEhAiAMQQFqIQwgCEEKbEH+////AXEhCAwBCwsgDEEEaiEDAkBBpIg0KAIAIgIEQAJ/AkAgAyACKAIUSw0AIAIoAgQiBUUNACACKAIYIANBAnRqIgQgBCgCAEEBajYCACACIAIoAhxBAWo2AhwgAiACKAIgIANqNgIgIAIgAigCLCADajYCLCACIAUoAgA2AgRBfyEDQQgMAQsgAxAqIgVFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKCADajYCKEEsCyACaiICIAIoAgAgA2o2AgAMAQsgAxAqIQULIAxFDQIgAUH8AGoiB0EgaiEKIAdBEGohC0EAIQIDQAJAIAEoArQCIQMCQCABKAKwAiIIBEAgASgCuAIhBAwBCyADIAEoArgCIgRyDQBBACEEIAEoArwCDQAgASgCwAINACABKALEAg0AIAEoAsgCDQAgASgCzAINACABKALQAg0AIAEoAtQCDQAgASgC2AINACABKALcAg0AIAEoAuACDQAgASgC5AJFDQELIAEgBDYCuAEgASADNgK0ASABIAg2ArABIAEgAf0AArwC/QsCvAEgASAB/QACzAL9CwLMASABIAEpAtwCNwLcASABIAEoAuQCNgLkASABQbABaiABQfABahDbAiACIAVqIAEtALABQTBqOgAAIAEgASgCsAI2AkAgASAB/QACtAL9CwJEIAEgAf0AAsQC/QsCVCABIAEoAtQCNgJkIAEgASkD2AI3A2ggASABKALgAjYCcCABIAEoAuQCIgNB/////wFxNgJ0IAEgA0EddTYCeCAHQQA2AjAgCiAX/QsCACALIBf9CwIAIAcgF/0LAgAgAkEBaiECIAFBsAJqIAFBQGsgAUHwAWoQnQMMAQsLQQAhAyAJLQAAQf8BRgRAIAIgBWpBLToAACACQQFqIQILIAIgBWpBADoAACACQQJIDQMgAkEBayECA0AgAiAFaiIELQAAIQcgBCADIAVqIggtAAA6AAAgCCAHOgAAIANBAWoiAyACQQFrIgJIDQALDAMLIAFB0ZwqNgIEIAFBg+sqNgIAIABB/IgqIAEQbAALIAkQ0AIgAUGlsSs2AiQgAUGD6yo2AiAgAEH8iCogAUEgahBsAAsgBUEwOwAACyAAIAUQWAJAAkBBpIg0KAIAIgJFDQAgASAFNgJAIAIoAgAiAyABKAJASw0AIAEoAkAgAyACKAIQak8NACAFIAIoAgQ2AgAgAiAFNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgBUEAIAL8CwAMAQsgBRArCyAJENACIAFBg+sqNgIQIABB4IcqIAFBEGoQmwEgAUHwAmokAEEBC+0bAkd/AXsjAEHgAWsiAyQAIAEQmAMgAyACKAIAIi02AnAgAyACKAIEIhI2AnQgAyACKAIIIhM2AnggAyACKAIMIhQ2AnwgAyACKAIQIhU2AoABIAMgAigCFCIWNgKEASADIAIoAhgiFzYCiAEgAyACKAIcIhg2AowBIAMgAigCICIZNgKQASADIAIoAiQiGjYClAEgAyACKAIoIhs2ApgBIAMgAigCLCIcNgKcASADIAIoAjAiHTYCoAEgAigCNCEGIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwK8ASADIEr9CwLMAUEAIQIgA0EANgLcASADIEr9CwKsASADIAZBHXUiHjYCqAEgAyAGQf////8BcSIGNgKkASAAIEr9CwIQIABCADcCMCAAIEr9CwIgIAAgSv0LAgBBASEvA0AgASADQfAAahCgA0EASARAICwEQCADKALcASEHIAMoAtgBIQggAygC1AEhCSADKALQASEKIAMoAswBIQsgAygCyAEhDCADKALEASENIAMoAsABIQ4gAygCvAEhDyADKAK4ASEQIAMoArQBIREgAygCsAEhHyADKAKsASEwA0AgASgCbCECIAEoAmghBCABKAJkIQUgASgCYCExIAEoAlwhMiABKAJYITMgASgCVCE0IAEoAlAhNSABKAJMITYgASgCSCE3IAEoAkQhOCABKAJAITkgASgCPCE6IAEoAjghOyABKAI0ITwgASgCMCE9IAEoAiwhPiABKAIoIT8gASgCJCFAIAEoAiAhQSABKAIcIUIgASgCGCFDIAEoAhQhRCABKAIQIUUgASgCDCFGIAEoAgghRyABKAIEIUggAyABKAIAIBJBHHRBgICAgAFxIC1BAXVyIi1rIklB/////wFxNgIAIAMgSCATQRx0QYCAgIABcSASQQF1ciISayBJQR11aiJIQf////8BcTYCBCADIEcgFEEcdEGAgICAAXEgE0EBdXIiE2sgSEEddWoiR0H/////AXE2AgggAyBGIBVBHHRBgICAgAFxIBRBAXVyIhRrIEdBHXVqIkZB/////wFxNgIMIAMgRSAWQRx0QYCAgIABcSAVQQF1ciIVayBGQR11aiJFQf////8BcTYCECADIEQgF0EcdEGAgICAAXEgFkEBdXIiFmsgRUEddWoiREH/////AXE2AhQgAyBDIBhBHHRBgICAgAFxIBdBAXVyIhdrIERBHXVqIkNB/////wFxNgIYIAMgQiAZQRx0QYCAgIABcSAYQQF1ciIYayBDQR11aiJCQf////8BcTYCHCADIEEgGkEcdEGAgICAAXEgGUEBdXIiGWsgQkEddWoiQUH/////AXE2AiAgAyBAIBtBHHRBgICAgAFxIBpBAXVyIhprIEFBHXVqIkBB/////wFxNgIkIAMgPyAcQRx0QYCAgIABcSAbQQF1ciIbayBAQR11aiI/Qf////8BcTYCKCADID4gHUEcdEGAgICAAXEgHEEBdXIiHGsgP0EddWoiPkH/////AXE2AiwgAyA9IAZBHHRBgICAgAFxIB1BAXVyIh1rID5BHXVqIj1B/////wFxNgIwIAMgPCAeQRx0QYCAgIABcSAGQQF1ciIGayA9QR11aiI8Qf////8BcTYCNCADIDsgMEEcdEGAgICAAXEgHkEBdXIiHmsgPEEddWoiO0H/////AXE2AjggAyA6IB9BHHRBgICAgAFxIDBBAXVyIjBrIDtBHXVqIjpB/////wFxNgI8IAMgOSARQRx0QYCAgIABcSAfQQF1ciIfayA6QR11aiI5Qf////8BcTYCQCADIDggEEEcdEGAgICAAXEgEUEBdXIiEWsgOUEddWoiOEH/////AXE2AkQgAyA3IA9BHHRBgICAgAFxIBBBAXVyIhBrIDhBHXVqIjdB/////wFxNgJIIAMgNiAOQRx0QYCAgIABcSAPQQF1ciIPayA3QR11aiI2Qf////8BcTYCTCADIDUgDUEcdEGAgICAAXEgDkEBdXIiDmsgNkEddWoiNUH/////AXE2AlAgAyA0IAxBHHRBgICAgAFxIA1BAXVyIg1rIDVBHXVqIjRB/////wFxNgJUIAMgMyALQRx0QYCAgIABcSAMQQF1ciIMayA0QR11aiIzQf////8BcTYCWCADIDIgCkEcdEGAgICAAXEgC0EBdXIiC2sgM0EddWoiMkH/////AXE2AlwgAyAxIAlBHHRBgICAgAFxIApBAXVyIgprIDJBHXVqIjFB/////wFxNgJgIAMgBSAIQRx0QYCAgIABcSAJQQF1ciIJayAxQR11aiIFQf////8BcTYCZCADIAQgB0EcdEGAgICAAXEgCEEBdXIiCGsgBUEddWoiBEH/////AXE2AmggAyACIAdBAXUiB2sgBEEddWoiAjYCbCABIAMgAkEATiICELoIIAAgACgCACIEICtBHHRBgICAgAFxIC9BAXVyIi9qIgVB/////wFxIAQgAhs2AgAgACAAKAIEIgQgKkEcdEGAgICAAXEgK0EBdXIiK2ogBUEddWoiBUH/////AXEgBCACGzYCBCAAIAAoAggiBCApQRx0QYCAgIABcSAqQQF1ciIqaiAFQR11aiIFQf////8BcSAEIAIbNgIIIAAgACgCDCIEIChBHHRBgICAgAFxIClBAXVyIilqIAVBHXVqIgVB/////wFxIAQgAhs2AgwgACAAKAIQIgQgJ0EcdEGAgICAAXEgKEEBdXIiKGogBUEddWoiBUH/////AXEgBCACGzYCECAAIAAoAhQiBCAmQRx0QYCAgIABcSAnQQF1ciInaiAFQR11aiIFQf////8BcSAEIAIbNgIUIAAgACgCGCIEICVBHHRBgICAgAFxICZBAXVyIiZqIAVBHXVqIgVB/////wFxIAQgAhs2AhggACAAKAIcIgQgJEEcdEGAgICAAXEgJUEBdXIiJWogBUEddWoiBUH/////AXEgBCACGzYCHCAAIAAoAiAiBCAjQRx0QYCAgIABcSAkQQF1ciIkaiAFQR11aiIFQf////8BcSAEIAIbNgIgIAAgACgCJCIEICJBHHRBgICAgAFxICNBAXVyIiNqIAVBHXVqIgVB/////wFxIAQgAhs2AiQgACAAKAIoIgQgIUEcdEGAgICAAXEgIkEBdXIiImogBUEddWoiBUH/////AXEgBCACGzYCKCAAIAAoAiwiBCAgQRx0QYCAgIABcSAhQQF1ciIhaiAFQR11aiIFQf////8BcSAEIAIbNgIsIAAgACgCMCIEIC5BHHRBgICAgAFxICBBAXVyIiBqIAVBHXVqIgVB/////wFxIAQgAhs2AjAgACAAKAI0IgQgLkEBdSIuaiAFQR11aiAEIAIbNgI0ICxBAUohAiAsQQFrISwgAg0ACwsgA0HgAWokAAUgAyAfQQF0IBFBHHVyIh82AtwBIAMgEUEBdEH+////AXEgEEEcdXIiETYC2AEgAyAQQQF0Qf7///8BcSAPQRx1ciIQNgLUASADIA9BAXRB/v///wFxIA5BHHVyIg82AtABIAMgDkEBdEH+////AXEgDUEcdXIiDjYCzAEgAyANQQF0Qf7///8BcSAMQRx1ciINNgLIASADIAxBAXRB/v///wFxIAtBHHVyIgw2AsQBIAMgC0EBdEH+////AXEgCkEcdXIiCzYCwAEgAyAKQQF0Qf7///8BcSAJQRx1ciIKNgK8ASADIAlBAXRB/v///wFxIAhBHHVyIgk2ArgBIAMgCEEBdEH+////AXEgB0EcdXIiCDYCtAEgAyAHQQF0Qf7///8BcSACQRx1ciIHNgKwASADIAJBAXRB/v///wFxIB5BHHVyIgI2AqwBIAMgHkEBdEH+////AXEgBkEcdXIiHjYCqAEgAyAGQQF0Qf7///8BcSAdQRx1ciIGNgKkASADIB1BAXRB/v///wFxIBxBHHVyIh02AqABIAMgHEEBdEH+////AXEgG0EcdXIiHDYCnAEgAyAbQQF0Qf7///8BcSAaQRx1ciIbNgKYASADIBpBAXRB/v///wFxIBlBHHVyIho2ApQBIAMgGEEBdEH+////AXEgF0EcdXIiMDYCjAEgAyAZQQF0Qf7///8BcSAYQRx1ciIZNgKQASADIBdBAXRB/v///wFxIBZBHHVyIhc2AogBIAMgFkEBdEH+////AXEgFUEcdXIiFjYChAEgAyAVQQF0Qf7///8BcSAUQRx1ciIVNgKAASADIBRBAXRB/v///wFxIBNBHHVyIhQ2AnwgAyATQQF0Qf7///8BcSASQRx1ciITNgJ4IAMgEkEBdEH+////AXEgLUEcdXIiEjYCdCADIC1BAXRB/v///wFxIi02AnAgLkEBdCAgQRx2ciEuIC9BHHYhBCAgQQF0Qf7///8BcSAhQRx2ciEgICxBAWohLCAvQQF0Qf7///8BcSEvIDAhGCAhQQF0Qf7///8BcSAiQRx2ciEhICJBAXRB/v///wFxICNBHHZyISIgI0EBdEH+////AXEgJEEcdnIhIyAkQQF0Qf7///8BcSAlQRx2ciEkICVBAXRB/v///wFxICZBHHZyISUgJkEBdEH+////AXEgJ0EcdnIhJiAnQQF0Qf7///8BcSAoQRx2ciEnIChBAXRB/v///wFxIClBHHZyISggKUEBdEH+////AXEgKkEcdnIhKSAqQQF0Qf7///8BcSArQRx2ciEqIAQgK0EBdEH+////AXFyISsMAQsLC4gOAgd/AXsjAEGQAmsiAyQAIANB778rNgIgIABB+YYqIANBIGoQmwEgAEEBEM4CIQYgAEECEM4CIQcgAEEYQQEQ2gEhBSAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgBUEAOwEUIAVCIDcCCCAFQQA2AhAgBUEBOgAAAkACQAJAIAZFDQAgB0UNACAGLwEURQRAIAcvARRFDQILIABBpPcqQQAQWwJ/IAYvARQEQCAGKAIQDAELIAMgBigCDCIBKAIANgKgASADIAEoAgQ2AqQBIAMgASgCCDYCqAEgAyABKAIMNgKsASADIAEoAhA2ArABIAMgASgCFDYCtAEgAyABKAIYNgK4ASADIAEoAhw2ArwBIAMgASgCIDYCwAEgAyABKAIkNgLEASADIAEoAig2AsgBIAMgASgCLDYCzAEgAyABKAIwNgLQASABKAI0IQEgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAuwBIAMgCP0LAvwBIANBADYCjAIgAyAI/QsC3AEgAyABQR11NgLYASADIAFB/////wFxNgLUASADQaABagshAQJ/IAcvARQEQCAHKAIQDAELIAMgBygCDCICKAIANgIwIAMgAigCBDYCNCADIAIoAgg2AjggAyACKAIMNgI8IAMgAigCEDYCQCADIAIoAhQ2AkQgAyACKAIYNgJIIAMgAigCHDYCTCADIAIoAiA2AlAgAyACKAIkNgJUIAMgAigCKDYCWCADIAIoAiw2AlwgAyACKAIwNgJgIAIoAjQhAiAD/QwAAAAAAAAAAAAAAAAAAAAA/QsCfCADIAj9CwKMASADQQA2ApwBIAMgCP0LAmwgAyACQR11NgJoIAMgAkH/////AXE2AmQgA0EwagshAiAAIAUQlgMgBSgCECIEIAIoAgAgASgCAGo2AgAgBCACKAIEIAEoAgRqNgIEIAQgAigCCCABKAIIajYCCCAEIAIoAgwgASgCDGo2AgwgBCACKAIQIAEoAhBqNgIQIAQgAigCFCABKAIUajYCFCAEIAIoAhggASgCGGo2AhggBCACKAIcIAEoAhxqNgIcIAQgAigCICABKAIgajYCICAEIAIoAiQgASgCJGo2AiQgBCACKAIoIAEoAihqNgIoIAQgAigCLCABKAIsajYCLCAEIAIoAjAgASgCMGo2AjAgBCACKAI0IAEoAjRqNgI0IAQgAigCOCABKAI4ajYCOCAEIAIoAjwgASgCPGo2AjwgBCACKAJAIAEoAkBqNgJAIAQgAigCRCABKAJEajYCRCAEIAIoAkggASgCSGo2AkggBCACKAJMIAEoAkxqNgJMIAQgAigCUCABKAJQajYCUCAEIAIoAlQgASgCVGo2AlQgBCACKAJYIAEoAlhqNgJYIAQgAigCXCABKAJcajYCXCAEIAIoAmAgASgCYGo2AmAgBCACKAJkIAEoAmRqNgJkIAQgAigCaCABKAJoajYCaCAEIAIoAmwgASgCbGo2AmwgBSgCEBCYAwwCCyAHENACIAYQ0AIgA0GC/ik2AhQgA0Hvvys2AhAgAEH8iCogA0EQahBsAAsgACAFEMgCIAUoAgwiASAHKAIMIgIoAgAgBigCDCIEKAIAajYCACABIAIoAgQgBCgCBGo2AgQgASACKAIIIAQoAghqNgIIIAEgAigCDCAEKAIMajYCDCABIAIoAhAgBCgCEGo2AhAgASACKAIUIAQoAhRqNgIUIAEgAigCGCAEKAIYajYCGCABIAIoAhwgBCgCHGo2AhwgASACKAIgIAQoAiBqNgIgIAEgAigCJCAEKAIkajYCJCABIAIoAiggBCgCKGo2AiggASACKAIsIAQoAixqNgIsIAEgAigCMCAEKAIwajYCMCABIAIoAjQgBCgCNGo2AjQgBSgCDCIBIAEoAgAiAkH/////AXE2AgAgASABKAIEIAJBHXVqIgJB/////wFxNgIEIAEgASgCCCACQR11aiICQf////8BcTYCCCABIAEoAgwgAkEddWoiAkH/////AXE2AgwgASABKAIQIAJBHXVqIgJB/////wFxNgIQIAEgASgCFCACQR11aiICQf////8BcTYCFCABIAEoAhggAkEddWoiAkH/////AXE2AhggASABKAIcIAJBHXVqIgJB/////wFxNgIcIAEgASgCICACQR11aiICQf////8BcTYCICABIAEoAiQgAkEddWoiAkH/////AXE2AiQgASABKAIoIAJBHXVqIgJB/////wFxNgIoIAEgASgCLCACQR11aiICQf////8BcTYCLCABIAEoAjAgAkEddWoiAkH/////AXE2AjAgASABKAI0IAJBHXVqNgI0CyAHENACIAYQ0AIgA0Hvvys2AgAgAEHghyogAxCbASADQZACaiQAQQELyw4CIH8BeyMAQZACayIDJAAgA0HMySs2AiAgAEH5hiogA0EgahCbASAAQQEQzgIhByAAQQIQzgIhBiAAQRhBARDaASECIABB2OHOfUGx8CoQkAEaIABBfhDbASACQQA7ARQgAkIgNwIIIAJBADYCECACQQE6AABBkIQqIQECQCAHRQ0AIAZFDQACQAJ/IAcvARRFBEAgBi8BFEUNAiADIAcoAgwiASgCADYCoAEgAyABKAIENgKkASADIAEoAgg2AqgBIAMgASgCDDYCrAEgAyABKAIQNgKwASADIAEoAhQ2ArQBIAMgASgCGDYCuAEgAyABKAIcNgK8ASADIAEoAiA2AsABIAMgASgCJDYCxAEgAyABKAIoNgLIASADIAEoAiw2AswBIAMgASgCMDYC0AEgASgCNCEBIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwLsASADICH9CwL8ASADQQA2AowCIAMgIf0LAtwBIAMgAUEddTYC2AEgAyABQf////8BcTYC1AEgA0GgAWohBCAGKAIQDAELIAcoAhAhBCAGLwEUBEAgBigCEAwBCyADIAYoAgwiASgCADYCMCADIAEoAgQ2AjQgAyABKAIINgI4IAMgASgCDDYCPCADIAEoAhA2AkAgAyABKAIUNgJEIAMgASgCGDYCSCADIAEoAhw2AkwgAyABKAIgNgJQIAMgASgCJDYCVCADIAEoAig2AlggAyABKAIsNgJcIAMgASgCMDYCYCABKAI0IQEgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAnwgAyAh/QsCjAEgA0EANgKcASADICH9CwJsIAMgAUEddTYCaCADIAFB/////wFxNgJkIANBMGoLIQUgACACEJYDQQAhASAEIAUQoANBAEgEQEHS/SshAQwCCyACKAIQIAQgBRChAyACKAIQEJgDDAELIAAgAhDIAiAHKAIMIgEoAgAhEwJAIAEgBigCDCIEEKIDQQBIBEAgBCgCACEUIAEoAgQhCCAEKAIEIRUgASgCCCEJIAQoAgghFiABKAIMIQogBCgCDCEXIAEoAhAhCyAEKAIQIRggASgCFCEMIAQoAhQhGSABKAIYIQ0gBCgCGCEaIAEoAhwhDiAEKAIcIRsgASgCICEPIAQoAiAhHCABKAIkIRAgBCgCJCEdIAEoAighESAEKAIoIR4gASgCLCESIAQoAiwhHyABKAIwIQUgBCgCMCEgIAIoAgwiAiABKAI0IAQoAjRrIgQ2AjQgAiAFICBrIgU2AjAgAiASIB9rIhI2AiwgAiARIB5rIhE2AiggAiAQIB1rIhA2AiQgAiAPIBxrQafbzwNqIg82AiAgAiAOIBtrQa/nlNMAaiIONgIcIAIgDSAaa0HnmYOpAWoiDTYCGCACIAwgGWtB0ImQ4ABqIgw2AhQgAiALIBhrQbuqgewBaiILNgIQIAIgCiAXa0H/i6DaAWoiCjYCDCACIAkgFmtBv//b/AFqIgk2AgggAiAIIBVrQfj///8BaiIINgIEIAIgEyAUa0EBaiIBNgIADAELIAIoAgwiBSATIAQoAgBrNgIAIAUgASgCBCAEKAIEazYCBCAFIAEoAgggBCgCCGs2AgggBSABKAIMIAQoAgxrNgIMIAUgASgCECAEKAIQazYCECAFIAEoAhQgBCgCFGs2AhQgBSABKAIYIAQoAhhrNgIYIAUgASgCHCAEKAIcazYCHCAFIAEoAiAgBCgCIGs2AiAgBSABKAIkIAQoAiRrNgIkIAUgASgCKCAEKAIoazYCKCAFIAEoAiwgBCgCLGs2AiwgBSABKAIwIAQoAjBrNgIwIAUgASgCNCAEKAI0azYCNCAFQcDELxDbAiACKAIMIgIoAjQhBCACKAIwIQUgAigCLCESIAIoAighESACKAIkIRAgAigCICEPIAIoAhwhDiACKAIYIQ0gAigCFCEMIAIoAhAhCyACKAIMIQogAigCCCEJIAIoAgQhCCACKAIAIQELIAIgAUH/////AXE2AgAgAiAIIAFBHXVqIgFB/////wFxNgIEIAIgCSABQR11aiIBQf////8BcTYCCCACIAogAUEddWoiAUH/////AXE2AgwgAiALIAFBHXVqIgFB/////wFxNgIQIAIgDCABQR11aiIBQf////8BcTYCFCACIA0gAUEddWoiAUH/////AXE2AhggAiAOIAFBHXVqIgFB/////wFxNgIcIAIgDyABQR11aiIBQf////8BcTYCICACIBAgAUEddWoiAUH/////AXE2AiQgAiARIAFBHXVqIgFB/////wFxNgIoIAIgEiABQR11aiIBQf////8BcTYCLCACIAUgAUEddWoiAUH/////AXE2AjAgAiAEIAFBHXVqNgI0QQAhAQsgBhDQAiAHENACIAEEQCADIAE2AhQgA0HMySs2AhAgAEH8iCogA0EQahBsAAsgA0HMySs2AgAgAEHghyogAxCbASADQZACaiQAQQEL8wMBAn8CfwJAIAAoAmwiAiABKAJsIgNHDQAgACgCaCICIAEoAmgiA0cNACAAKAJkIgIgASgCZCIDRw0AIAAoAmAiAiABKAJgIgNHDQAgACgCXCICIAEoAlwiA0cNACAAKAJYIgIgASgCWCIDRw0AIAAoAlQiAiABKAJUIgNHDQAgACgCUCICIAEoAlAiA0cNACAAKAJMIgIgASgCTCIDRw0AIAAoAkgiAiABKAJIIgNHDQAgACgCRCICIAEoAkQiA0cNACAAKAJAIgIgASgCQCIDRw0AIAAoAjwiAiABKAI8IgNHDQAgACgCOCICIAEoAjgiA0cNACAAKAI0IgIgASgCNCIDRw0AIAAoAjAiAiABKAIwIgNHDQAgACgCLCICIAEoAiwiA0cNACAAKAIoIgIgASgCKCIDRw0AIAAoAiQiAiABKAIkIgNHDQAgACgCICICIAEoAiAiA0cNACAAKAIcIgIgASgCHCIDRw0AIAAoAhgiAiABKAIYIgNHDQAgACgCFCICIAEoAhQiA0cNACAAKAIQIgIgASgCECIDRw0AIAAoAgwiAiABKAIMIgNHDQAgACgCCCICIAEoAggiA0cNACAAKAIEIgIgASgCBCIDRw0AQQAgACgCACICIAEoAgAiA0YNARoLQQFBfyACIANKGwsLwgMAIAAgASgCACACKAIAazYCACAAIAEoAgQgAigCBGs2AgQgACABKAIIIAIoAghrNgIIIAAgASgCDCACKAIMazYCDCAAIAEoAhAgAigCEGs2AhAgACABKAIUIAIoAhRrNgIUIAAgASgCGCACKAIYazYCGCAAIAEoAhwgAigCHGs2AhwgACABKAIgIAIoAiBrNgIgIAAgASgCJCACKAIkazYCJCAAIAEoAiggAigCKGs2AiggACABKAIsIAIoAixrNgIsIAAgASgCMCACKAIwazYCMCAAIAEoAjQgAigCNGs2AjQgACABKAI4IAIoAjhrNgI4IAAgASgCPCACKAI8azYCPCAAIAEoAkAgAigCQGs2AkAgACABKAJEIAIoAkRrNgJEIAAgASgCSCACKAJIazYCSCAAIAEoAkwgAigCTGs2AkwgACABKAJQIAIoAlBrNgJQIAAgASgCVCACKAJUazYCVCAAIAEoAlggAigCWGs2AlggACABKAJcIAIoAlxrNgJcIAAgASgCYCACKAJgazYCYCAAIAEoAmQgAigCZGs2AmQgACABKAJoIAIoAmhrNgJoIAAgASgCbCACKAJsazYCbAuFAgECfwJ/AkAgACgCNCICIAEoAjQiA0cNACAAKAIwIgIgASgCMCIDRw0AIAAoAiwiAiABKAIsIgNHDQAgACgCKCICIAEoAigiA0cNACAAKAIkIgIgASgCJCIDRw0AIAAoAiAiAiABKAIgIgNHDQAgACgCHCICIAEoAhwiA0cNACAAKAIYIgIgASgCGCIDRw0AIAAoAhQiAiABKAIUIgNHDQAgACgCECICIAEoAhAiA0cNACAAKAIMIgIgASgCDCIDRw0AIAAoAggiAiABKAIIIgNHDQAgACgCBCICIAEoAgQiA0cNAEEAIAAoAgAiAiABKAIAIgNGDQEaC0EBQX8gAiADShsLC+kFAQd/IwBBMGsiAyQAIANB3MYqNgIgIABB+YYqIANBIGoQmwECQAJAAkAgAEEBEM4CIgRFBEBBnPMqIQUgBBDQAgwBCyAAQQJBi6cqENwBIgYEQCAELwEURQ0CQcqpKiEFIAQQ0AIMAQsCQCAAQQIQzgIiBkUEQEG94SshBQwBC0HF+SkhBSAELwEUDQAgBi8BFA0AQQEhByAAQRhBARDaASEBIABB2OHOfUGx8CoQkAEaIABBfhDbAUEAIQUgAUEAOwEUIAFCIDcCCCABQQA2AhAgAUEBOgAAIAAgARDIAiABKAIMIAQoAgwgBigCDEHAxC8QpAMgASgCDCIBIAEoAgAiAkH/////AXE2AgAgASABKAIEIAJBHXVqIgJB/////wFxNgIEIAEgASgCCCACQR11aiICQf////8BcTYCCCABIAEoAgwgAkEddWoiAkH/////AXE2AgwgASABKAIQIAJBHXVqIgJB/////wFxNgIQIAEgASgCFCACQR11aiICQf////8BcTYCFCABIAEoAhggAkEddWoiAkH/////AXE2AhggASABKAIcIAJBHXVqIgJB/////wFxNgIcIAEgASgCICACQR11aiICQf////8BcTYCICABIAEoAiQgAkEddWoiAkH/////AXE2AiQgASABKAIoIAJBHXVqIgJB/////wFxNgIoIAEgASgCLCACQR11aiICQf////8BcTYCLCABIAEoAjAgAkEddWoiAkH/////AXE2AjAgASABKAI0IAJBHXVqNgI0CyAGENACIAQQ0AIgBw0CCyADIAU2AgQgA0Hcxio2AgAgAEH8iCogAxBsAAsgAEHAAUEBENoBIgFCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASABQQE2ArwBIAFBCGoiASAGQQhqEL0CIAEgBCgCDBDPAiAEENACCyADQdzGKjYCECAAQeCHKiADQRBqEJsBIANBMGokAEEBC9wCAQF/IwBB8AFrIgQkACAEIAEoAgA2AkAgBCABKAIENgJEIAQgASgCCDYCSCAEIAEoAgw2AkwgBCABKAIQNgJQIAQgASgCFDYCVCAEIAEoAhg2AlggBCABKAIcNgJcIAQgASgCIDYCYCAEIAEoAiQ2AmQgBCABKAIoNgJoIAQgASgCLDYCbCAEIAEoAjA2AnAgBCABKAI0NgJ0IAQgAigCADYCACAEIAIoAgQ2AgQgBCACKAIINgIIIAQgAigCDDYCDCAEIAIoAhA2AhAgBCACKAIUNgIUIAQgAigCGDYCGCAEIAIoAhw2AhwgBCACKAIgNgIgIAQgAigCJDYCJCAEIAIoAig2AiggBCACKAIsNgIsIAQgAigCMDYCMCAEIAIoAjQ2AjQgBEFAayADENsCIAQgAxDbAiAEQYABaiAEQUBrIAQQ0wIgACAEQYABaiADEKYDIARB8AFqJAALygQBB38jAEGgAWsiASQAIAFByaorNgIgIABB+YYqIAFBIGoQmwFBveErIQYgAEEBEM4CIQQgAEECEM4CIQUCQCAERQ0AIAVFDQBBm/wrIQYgBS8BFA0AIAQvARQEQEEBIQcgAEEYQQEQ2gEhAyAAQdjhzn1BsfAqEJABGiAAQX4Q2wFBACEGIANBADsBFCADQiA3AgggA0EANgIQIANBAToAACAAIAMQyAIgASAEKAIQIgIoAgA2AjAgASACKAIENgI0IAEgAigCCDYCOCABIAIoAgw2AjwgASACKAIQNgJAIAEgAigCFDYCRCABIAIoAhg2AkggASACKAIcNgJMIAEgAigCIDYCUCABIAIoAiQ2AlQgASACKAIoNgJYIAEgAigCLDYCXCABIAIoAjA2AmAgASACKAI0NgJkIAEgAigCODYCaCABIAIoAjw2AmwgASACKAJANgJwIAEgAigCRDYCdCABIAIoAkg2AnggASACKAJMNgJ8IAEgAigCUDYCgAEgASACKAJUNgKEASABIAIoAlg2AogBIAEgAigCXDYCjAEgASACKAJgNgKQASABIAIoAmQ2ApQBIAEgAigCaDYCmAEgASACKAJsNgKcASADKAIMIAFBMGogBSgCDBCmAwwBCyAAIAQQlwMoAgwgBSgCDBDbAkEAIQZBASEHCyAFENACIAQQ0AIgB0UEQCABIAY2AhQgAUHJqis2AhAgAEH8iCogAUEQahBsAAsgAUHJqis2AgAgAEHghyogARCbASABQaABaiQAQQEL5RUCOX8BeyMAQeABayIDJAAgARCYAyADIAIoAgAiHjYCcCADIAIoAgQiDjYCdCADIAIoAggiDzYCeCADIAIoAgwiEDYCfCADIAIoAhAiETYCgAEgAyACKAIUIhI2AoQBIAMgAigCGCITNgKIASADIAIoAhwiBjYCjAEgAyACKAIgIhQ2ApABIAMgAigCJCIVNgKUASADIAIoAigiFjYCmAEgAyACKAIsIhc2ApwBIAMgAigCMCIYNgKgASACKAI0IQQgA/0MAAAAAAAAAAAAAAAAAAAAAP0LArwBIAMgPP0LAswBQQAhAiADQQA2AtwBIAMgPP0LAqwBIAMgBEEddSIZNgKoASADIARB/////wFxIgQ2AqQBAkAgASADQfAAahCgA0EATgRAA0AgAyAFQQF0IA1BHHVyIgU2AtwBIAMgDUEBdEH+////AXEgDEEcdXIiDTYC2AEgAyAMQQF0Qf7///8BcSALQRx1ciIMNgLUASADIAtBAXRB/v///wFxIApBHHVyIgs2AtABIAMgCkEBdEH+////AXEgCUEcdXIiCjYCzAEgAyAJQQF0Qf7///8BcSAIQRx1ciIJNgLIASADIAhBAXRB/v///wFxIAdBHHVyIgg2AsQBIAMgB0EBdEH+////AXEgHUEcdXIiBzYCwAEgAyAdQQF0Qf7///8BcSAcQRx1ciIdNgK8ASADIBxBAXRB/v///wFxIBtBHHVyIhw2ArgBIAMgG0EBdEH+////AXEgGkEcdXIiGzYCtAEgAyAaQQF0Qf7///8BcSACQRx1ciIaNgKwASADIAJBAXRB/v///wFxIBlBHHVyIgI2AqwBIAMgGUEBdEH+////AXEgBEEcdXIiGTYCqAEgAyAEQQF0Qf7///8BcSAYQRx1ciIENgKkASADIBhBAXRB/v///wFxIBdBHHVyIhg2AqABIAMgF0EBdEH+////AXEgFkEcdXIiFzYCnAEgAyAWQQF0Qf7///8BcSAVQRx1ciIWNgKYASADIBVBAXRB/v///wFxIBRBHHVyIhU2ApQBIAMgBkEBdEH+////AXEgE0EcdXIiIDYCjAEgAyAUQQF0Qf7///8BcSAGQRx1ciIUNgKQASADIBNBAXRB/v///wFxIBJBHHVyIhM2AogBIAMgEkEBdEH+////AXEgEUEcdXIiEjYChAEgAyARQQF0Qf7///8BcSAQQRx1ciIRNgKAASADIBBBAXRB/v///wFxIA9BHHVyIhA2AnwgAyAPQQF0Qf7///8BcSAOQRx1ciIPNgJ4IAMgDkEBdEH+////AXEgHkEcdXIiDjYCdCADIB5BAXRB/v///wFxIh42AnAgH0EBaiEfICAhBiABIANB8ABqEKADQQBODQALIAMoAtwBIQYgAygC2AEhByADKALUASEIIAMoAtABIQkgAygCzAEhCiADKALIASELIAMoAsQBIQwgAygCwAEhDQNAIAEoAmwhBSABKAJoISEgASgCZCEiIAEoAmAhIyABKAJcISQgASgCWCElIAEoAlQhJiABKAJQIScgASgCTCEoIAEoAkghKSABKAJEISogASgCQCErIAEoAjwhLCABKAI4IS0gASgCNCEuIAEoAjAhLyABKAIsITAgASgCKCExIAEoAiQhMiABKAIgITMgASgCHCE0IAEoAhghNSABKAIUITYgASgCECE3IAEoAgwhOCABKAIIITkgASgCBCE6IAMgASgCACAOQRx0QYCAgIABcSAeQQF2ciIeayI7Qf////8BcTYCACADIDogD0EcdEGAgICAAXEgDkEBdXIiDmsgO0EddWoiOkH/////AXE2AgQgAyA5IBBBHHRBgICAgAFxIA9BAXVyIg9rIDpBHXVqIjlB/////wFxNgIIIAMgOCARQRx0QYCAgIABcSAQQQF1ciIQayA5QR11aiI4Qf////8BcTYCDCADIDcgEkEcdEGAgICAAXEgEUEBdXIiEWsgOEEddWoiN0H/////AXE2AhAgAyA2IBNBHHRBgICAgAFxIBJBAXVyIhJrIDdBHXVqIjZB/////wFxNgIUIAMgNSAgQRx0QYCAgIABcSATQQF1ciITayA2QR11aiI1Qf////8BcTYCGCADIDQgFEEcdEGAgICAAXEgIEEBdXIiIGsgNUEddWoiNEH/////AXE2AhwgAyAzIBVBHHRBgICAgAFxIBRBAXVyIhRrIDRBHXVqIjNB/////wFxNgIgIAMgMiAWQRx0QYCAgIABcSAVQQF1ciIVayAzQR11aiIyQf////8BcTYCJCADIDEgF0EcdEGAgICAAXEgFkEBdXIiFmsgMkEddWoiMUH/////AXE2AiggAyAwIBhBHHRBgICAgAFxIBdBAXVyIhdrIDFBHXVqIjBB/////wFxNgIsIAMgLyAEQRx0QYCAgIABcSAYQQF1ciIYayAwQR11aiIvQf////8BcTYCMCADIC4gGUEcdEGAgICAAXEgBEEBdXIiBGsgL0EddWoiLkH/////AXE2AjQgAyAtIAJBHHRBgICAgAFxIBlBAXVyIhlrIC5BHXVqIi1B/////wFxNgI4IAMgLCAaQRx0QYCAgIABcSACQQF1ciICayAtQR11aiIsQf////8BcTYCPCADICsgG0EcdEGAgICAAXEgGkEBdXIiGmsgLEEddWoiK0H/////AXE2AkAgAyAqIBxBHHRBgICAgAFxIBtBAXVyIhtrICtBHXVqIipB/////wFxNgJEIAMgKSAdQRx0QYCAgIABcSAcQQF1ciIcayAqQR11aiIpQf////8BcTYCSCADICggDUEcdEGAgICAAXEgHUEBdXIiHWsgKUEddWoiKEH/////AXE2AkwgAyAnIAxBHHRBgICAgAFxIA1BAXVyIg1rIChBHXVqIidB/////wFxNgJQIAMgJiALQRx0QYCAgIABcSAMQQF1ciIMayAnQR11aiImQf////8BcTYCVCADICUgCkEcdEGAgICAAXEgC0EBdXIiC2sgJkEddWoiJUH/////AXE2AlggAyAkIAlBHHRBgICAgAFxIApBAXVyIgprICVBHXVqIiRB/////wFxNgJcIAMgIyAIQRx0QYCAgIABcSAJQQF1ciIJayAkQR11aiIjQf////8BcTYCYCADICIgB0EcdEGAgICAAXEgCEEBdXIiCGsgI0EddWoiIkH/////AXE2AmQgAyAhIAZBHHRBgICAgAFxIAdBAXVyIgdrICJBHXVqIiFB/////wFxNgJoIAMgBSAGQQF1IgZrICFBHXVqIgU2AmwgASADIAVBf3NBH3YQugggH0EBSiEFIB9BAWshHyAFDQALIAAgASgCADYCACAAIAEoAgQ2AgQgACABKAIINgIIIAAgASgCDDYCDCAAIAEoAhA2AhAgACABKAIUNgIUIAAgASgCGDYCGCAAIAEoAhw2AhwgACABKAIgNgIgIAAgASgCJDYCJCAAIAEoAig2AiggACABKAIsNgIsIAAgASgCMDYCMAwBCyAAIAEoAgA2AgAgACABKAIENgIEIAAgASgCCDYCCCAAIAEoAgw2AgwgACABKAIQNgIQIAAgASgCFDYCFCAAIAEoAhg2AhggACABKAIcNgIcIAAgASgCIDYCICAAIAEoAiQ2AiQgACABKAIoNgIoIAAgASgCLDYCLCAAIAEoAjA2AjALIAAgASgCNDYCNCADQeABaiQAC4UEAQV/IwBBoAFrIgEkACABQdTAKTYCICAAQfmGKiABQSBqEJsBQb3hKyEDIABBARDOAiEEIABBAhDOAiEFAkAgBEUNACAFRQ0AQdjtKSEDIAUvARQNACAAIAQQlwMhAwJAIAQvARQEQCABIAQoAhAiAigCADYCMCABIAIoAgQ2AjQgASACKAIINgI4IAEgAigCDDYCPCABIAIoAhA2AkAgASACKAIUNgJEIAEgAigCGDYCSCABIAIoAhw2AkwgASACKAIgNgJQIAEgAigCJDYCVCABIAIoAig2AlggASACKAIsNgJcIAEgAigCMDYCYCABIAIoAjQ2AmQgASACKAI4NgJoIAEgAigCPDYCbCABIAIoAkA2AnAgASACKAJENgJ0IAEgAigCSDYCeCABIAIoAkw2AnwgASACKAJQNgKAASABIAIoAlQ2AoQBIAEgAigCWDYCiAEgASACKAJcNgKMASABIAIoAmA2ApABIAEgAigCZDYClAEgASACKAJoNgKYASABIAIoAmw2ApwBIAMoAgwgAUEwaiAFKAIMEJ0DDAELIAMoAgwgBSgCDBCoAwtBACEDQQEhAgsgBRDQAiAEENACIAJFBEAgASADNgIUIAFB1MApNgIQIABB/IgqIAFBEGoQbAALIAFB1MApNgIAIABB4IcqIAEQmwEgAUGgAWokAEEBC8IWAlR/AXsgACAAKAIAIgJB/////wFxIjQ2AgAgACAAKAIEIAJBHXVqIgJB/////wFxIjU2AgQgAEEIaiIFIAUoAgAgAkEddWoiAkH/////AXEiNjYCACAAIAAoAgwgAkEddWoiAkH/////AXEiNzYCDCAAQRBqIgYgBigCACACQR11aiICQf////8BcSI4NgIAIAAgACgCFCACQR11aiICQf////8BcSI5NgIUIABBGGoiBSAFKAIAIAJBHXVqIgJB/////wFxIjo2AgAgACAAKAIcIAJBHXVqIgJB/////wFxIjs2AhwgAEEgaiIHIAcoAgAgAkEddWoiAkH/////AXEiPDYCACAAIAAoAiQgAkEddWoiAkH/////AXEiPTYCJCAAQShqIgUgBSgCACACQR11aiICQf////8BcSI+NgIAIAAgACgCLCACQR11aiICQf////8BcSI/NgIsIABBMGoiCCAIKAIAIAJBHXVqIgJB/////wFxIkA2AgAgACAAKAI0IAJBHXVqIkE2AjQgASgCNCEFIAEoAjAhCSABKAIsIQogASgCKCELIAEoAiQhDCABKAIgIQ0gASgCHCEOIAEoAhghDyABKAIUIRAgASgCECERIAEoAgwhEiABKAIIIRMgASgCBCECIAEoAgAhFSAIQgA3AgAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgBiBW/QsCACAAIFb9CwIAQQAhAUEBIStBACEGQQAhB0EAIQgDQCAFIQMCQAJAIEEiBCAFRw0AIAkhAyAJIEAiBEcNACAKIQMgCiA/IgRHDQAgCyEDIAsgPiIERw0AIAwhAyAMID0iBEcNACANIQMgDSA8IgRHDQAgDiEDIA4gOyIERw0AIA8hAyAPIDoiBEcNACAQIQMgECA5IgRHDQAgESEDIBEgOCIERw0AIBIhAyASIDciBEcNACATIQMgEyA2IgRHDQAgAiEDIDUiBCACRw0AIDQiBCAVIgNGDQELIAMgBEgNACAeBEAgACgCNCEEIAAoAjAhAyAAKAIsIR8gACgCKCEgIAAoAiQhISAAKAIgISIgACgCHCEjIAAoAhghJCAAKAIUISUgACgCECEmIAAoAgwhJyAAKAIIISggACgCBCEpIAAoAgAhKgNAIAZBHHQhLSAHQRx0IRQgCEEcdCEuIBZBHHQhLyAXQRx0ITAgGEEcdCExIBlBHHQhMiAaQRx0ITMgG0EcdCFCIBxBHHQhQyAdQRx0IUQgLEEcdCFFIAQgLEEBdSIsaiADIEVBgICAgAFxIB1BAXVyIh1qIB8gREGAgICAAXEgHEEBdXIiHGogICBDQYCAgIABcSAbQQF1ciIbaiAhIEJBgICAgAFxIBpBAXVyIhpqICIgM0GAgICAAXEgGUEBdXIiGWogIyAyQYCAgIABcSAYQQF1ciIYaiAkIDFBgICAgAFxIBdBAXVyIhdqICUgMEGAgICAAXEgFkEBdXIiFmogJiAvQYCAgIABcSAIQQF1ciIIaiAnIC5BgICAgAFxIAdBAXVyIgdqICggFEGAgICAAXEgBkEBdXIiBmogKSAtQYCAgIABcSABQQF1ciItaiAqIAFBHHRBgICAgAFxICtBAXVyIitqIgFBHXVqIhRBHXVqIi5BHXVqIi9BHXVqIjBBHXVqIjFBHXVqIjJBHXVqIjNBHXVqIkJBHXVqIkNBHXVqIkRBHXVqIkVBHXVqIkZBHXVqIAQgNSATQRx0QYCAgIABcSACQQF1ciJHayA0IAJBHHRBgICAgAFxIBVBAXVyIhVrIkhBHXVqIklBHXUgNiASQRx0QYCAgIABcSATQQF1ciITa2oiSkEddSA3IBFBHHRBgICAgAFxIBJBAXVyIhJraiJLQR11IDggEEEcdEGAgICAAXEgEUEBdXIiEWtqIkxBHXUgOSAPQRx0QYCAgIABcSAQQQF1ciIQa2oiTUEddSA6IA5BHHRBgICAgAFxIA9BAXVyIg9raiJOQR11IDsgDUEcdEGAgICAAXEgDkEBdXIiDmtqIk9BHXUgPCAMQRx0QYCAgIABcSANQQF1ciINa2oiUEEddSA9IAtBHHRBgICAgAFxIAxBAXVyIgxraiJRQR11ID4gCkEcdEGAgICAAXEgC0EBdXIiC2tqIlJBHXUgPyAJQRx0QYCAgIABcSAKQQF1ciIKa2oiU0EddSBAIAVBHHRBgICAgAFxIAlBAXVyIglraiJUQR11IEEgBUEBdSIFa2oiVUEATiICGyEEIEZB/////wFxIAMgAhshAyBFQf////8BcSAfIAIbIR8gREH/////AXEgICACGyEgIENB/////wFxICEgAhshISBCQf////8BcSAiIAIbISIgM0H/////AXEgIyACGyEjIDJB/////wFxICQgAhshJCAxQf////8BcSAlIAIbISUgMEH/////AXEgJiACGyEmIC9B/////wFxICcgAhshJyAuQf////8BcSAoIAIbISggFEH/////AXEgKSACGyEpIFUgQSACGyFBIFRB/////wFxIEAgAhshQCBTQf////8BcSA/IAIbIT8gUkH/////AXEgPiACGyE+IFFB/////wFxID0gAhshPSBQQf////8BcSA8IAIbITwgT0H/////AXEgOyACGyE7IE5B/////wFxIDogAhshOiBNQf////8BcSA5IAIbITkgTEH/////AXEgOCACGyE4IEtB/////wFxIDcgAhshNyBKQf////8BcSA2IAIbITYgSUH/////AXEgNSACGyE1IAFB/////wFxICogAhshKiBIQf////8BcSA0IAIbITQgHkEBSiEUIB5BAWshHiBHIQIgLSEBIBQNAAsgACAENgI0IAAgAzYCMCAAIB82AiwgACAgNgIoIAAgITYCJCAAICI2AiAgACAjNgIcIAAgJDYCGCAAICU2AhQgACAmNgIQIAAgJzYCDCAAICg2AgggACApNgIEIAAgKjYCAAsPCyAFQQF0IAlBHHVyIQUgLEEBdCAdQRx1ciEsIBVBHHUhBCACQRx1IQMgE0EcdSEfIBJBHHUhICARQRx1ISEgEEEcdSEiIA9BHHUhIyAOQRx1ISQgDUEcdSElIAxBHHUhJiALQRx1IScgCUEBdEH+////AXEgCkEcdXIhCSArQRx2ISggAUEcdSEpIAZBHHUhKiAHQRx1IS0gCEEcdSEUIBZBHHUhLiAXQRx1IS8gGEEcdSEwIBlBHHUhMSAaQRx1ITIgG0EcdSEzIB1BAXRB/v///wFxIBxBHHVyIR0gHkEBaiEeIBVBAXRB/v///wFxIRUgK0EBdEH+////AXEhKyAoIAFBAXRB/v///wFxciEBICkgBkEBdEH+////AXFyIQYgKiAHQQF0Qf7///8BcXIhByAtIAhBAXRB/v///wFxciEIIBQgFkEBdEH+////AXFyIRYgLiAXQQF0Qf7///8BcXIhFyAvIBhBAXRB/v///wFxciEYIDAgGUEBdEH+////AXFyIRkgMSAaQQF0Qf7///8BcXIhGiAyIBtBAXRB/v///wFxciEbIDMgHEEBdEH+////AXFyIRwgBCACQQF0Qf7///8BcXIhAiADIBNBAXRB/v///wFxciETIB8gEkEBdEH+////AXFyIRIgICARQQF0Qf7///8BcXIhESAhIBBBAXRB/v///wFxciEQICIgD0EBdEH+////AXFyIQ8gIyAOQQF0Qf7///8BcXIhDiAkIA1BAXRB/v///wFxciENICUgDEEBdEH+////AXFyIQwgJiALQQF0Qf7///8BcXIhCyAnIApBAXRB/v///wFxciEKDAALAAu8AQEFfyMAQTBrIgEkACABQcmjKjYCICAAQfmGKiABQSBqEJsBQZzzKiECIABBARDOAiIDQQBHIABBAhDOAiIEQQBHcSIFBEAgAyAEEKoDIQIgACgCDEEBQREgAhs6AAQgACAAKAIMQQhqNgIMQQAhAgsgBBDQAiADENACIAVFBEAgASACNgIUIAFByaMqNgIQIABB/IgqIAFBEGoQbAALIAFByaMqNgIAIABB4IcqIAEQmwEgAUEwaiQAQQELpgYBBX8gACgCDCICRQRAQQBB/e8rIAAoAhAbIQMLIAEoAgwiBEUEQCADQaftKyABKAIQGyEDCyABLwEUIQYCQCAALwEUBEAgBkUNASADDQEgASgCECECIAAoAhAiBBCYAyACEJgDIAQgAhCgAw8LIAYNACADDQAgAiACKAIAIgNB/////wFxNgIAIAIgAigCBCADQR11aiIDQf////8BcTYCBCACIAIoAgggA0EddWoiA0H/////AXE2AgggAiACKAIMIANBHXVqIgNB/////wFxNgIMIAIgAigCECADQR11aiIDQf////8BcTYCECACIAIoAhQgA0EddWoiA0H/////AXE2AhQgAiACKAIYIANBHXVqIgNB/////wFxNgIYIAIgAigCHCADQR11aiIDQf////8BcTYCHCACIAIoAiAgA0EddWoiA0H/////AXE2AiAgAiACKAIkIANBHXVqIgNB/////wFxNgIkIAIgAigCKCADQR11aiIDQf////8BcTYCKCACIAIoAiwgA0EddWoiA0H/////AXE2AiwgAiACKAIwIANBHXVqIgNB/////wFxNgIwIAIgAigCNCADQR11ajYCNCAEIAQoAgAiAkH/////AXE2AgAgBCAEKAIEIAJBHXVqIgJB/////wFxNgIEIAQgBCgCCCACQR11aiICQf////8BcTYCCCAEIAQoAgwgAkEddWoiAkH/////AXE2AgwgBCAEKAIQIAJBHXVqIgJB/////wFxNgIQIAQgBCgCFCACQR11aiICQf////8BcTYCFCAEIAQoAhggAkEddWoiAkH/////AXE2AhggBCAEKAIcIAJBHXVqIgJB/////wFxNgIcIAQgBCgCICACQR11aiICQf////8BcTYCICAEIAQoAiQgAkEddWoiAkH/////AXE2AiQgBCAEKAIoIAJBHXVqIgJB/////wFxNgIoIAQgBCgCLCACQR11aiICQf////8BcTYCLCAEIAQoAjAgAkEddWoiAkH/////AXE2AjAgBCAEKAI0IAJBHXVqNgI0IAAoAgwgASgCDBCiAyEFCyAFC78BAQV/IwBBMGsiASQAIAFBx9wpNgIgIABB+YYqIAFBIGoQmwFBnPMqIQIgAEEBEM4CIgNBAEcgAEECEM4CIgRBAEdxIgUEQCADIAQQqgMhAiAAKAIMQQFBESACQQBOGzoABCAAIAAoAgxBCGo2AgxBACECCyADENACIAQQ0AIgBUUEQCABIAI2AhQgAUHH3Ck2AhAgAEH8iCogAUEQahBsAAsgAUHH3Ck2AgAgAEHghyogARCbASABQTBqJABBAQu/AQEFfyMAQTBrIgEkACABQef+KjYCICAAQfmGKiABQSBqEJsBQZzzKiECIABBARDOAiIDQQBHIABBAhDOAiIEQQBHcSIFBEAgAyAEEKoDIQIgACgCDEEBQREgAkEAShs6AAQgACAAKAIMQQhqNgIMQQAhAgsgBBDQAiADENACIAVFBEAgASACNgIUIAFB5/4qNgIQIABB/IgqIAFBEGoQbAALIAFB5/4qNgIAIABB4IcqIAEQmwEgAUEwaiQAQQEL+wMBCn8jAEEwayIEJAAgBEGs7Ck2AiAgAEH5hiogBEEgahCbAUGc8yohASAAQQEQzgIhCCAAQQIQzgIhCQJAIAhFDQAgCUUNACAAIAgQ3QEhBiAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgACAJEN0BIQcgACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIAAgBygCACIKIAYoAgAiBWoQhgEiAUUEQEGn8iohAQwBCyABKAIEIgNBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIDSA0ACwsgASAFIAMgAyAFShsiAzYCACADQQBKBEAgBigCCCEFQQAhAgNAIAEoAgggAmogAiAFai0AADoAACACQQFqIgIgASgCACIDSA0ACwsCQCAKQQBKBH9BACECA0AgASgCACACaiIDIAEoAgQiBU4NAiABKAIIIANqIAcoAgggAmotAAA6AAAgAkEBaiICIApHDQALIAEoAgAFIAMLIApqIQULIAEgBTYCAEEAIQFBASECDAALIAcQmgEgBhCaASAJENACIAgQ0AIgAkUEQCAEIAE2AhQgBEGs7Ck2AhAgAEH8iCogBEEQahBsAAsgBEGs7Ck2AgAgAEHghyogBBCbASAEQTBqJABBAQu0AQEEfyMAQTBrIgEkACABQf7wKTYCICAAQfmGKiABQSBqEJsBAn8CQCAAQQEQzgIiAgRAIAIvARRFDQEgAigCEBCvAwwCCyABQaLZKTYCBCABQf7wKTYCACAAQfyIKiABEGwACyACKAIMELADCyEDIAAoAgwiBEEDOgAEIAQgAzYCACAAIAAoAgxBCGo2AgwgAhDQAiABQf7wKTYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC5cHARt/AkACQCAAKAJsIAAoAmggACgCZCAAKAJgIAAoAlwgACgCWCAAKAJUIAAoAlAgACgCTCAAKAJIIAAoAkQgACgCQCAAKAI8IAAoAjggACgCNCAAKAIwIAAoAiwgACgCKCAAKAIkIAAoAiAgACgCHCAAKAIYIAAoAhQgACgCECAAKAIMIAAoAgggACgCBCAAKAIAIgNBHXVqIgRBHXVqIgVBHXVqIgZBHXVqIgdBHXVqIghBHXVqIglBHXVqIgpBHXVqIgtBHXVqIgxBHXVqIg1BHXVqIg5BHXVqIg9BHXVqIhBBHXVqIhFBHXVqIhJBHXVqIhNBHXVqIhRBHXVqIhVBHXVqIhZBHXVqIhdBHXVqIhhBHXVqIhlBHXVqIhpBHXVqIhtBHXVqIgJBHXVqIgFBHXVqIgAEQEGPBiEBDAELIAFB/////wFxIgAEQEHyBSEBDAELIAJB/////wFxIgAEQEHVBSEBDAELIBtB/////wFxIgAEQEG4BSEBDAELIBpB/////wFxIgAEQEGbBSEBDAELIBlB/////wFxIgAEQEH+BCEBDAELIBhB/////wFxIgAEQEHhBCEBDAELIBdB/////wFxIgAEQEHEBCEBDAELIBZB/////wFxIgAEQEGnBCEBDAELIBVB/////wFxIgAEQEGKBCEBDAELIBRB/////wFxIgAEQEHtAyEBDAELIBNB/////wFxIgAEQEHQAyEBDAELIBJB/////wFxIgAEQEGzAyEBDAELIBFB/////wFxIgAEQEGWAyEBDAELIBBB/////wFxIgAEQEH5AiEBDAELIA9B/////wFxIgAEQEHcAiEBDAELIA5B/////wFxIgAEQEG/AiEBDAELIA1B/////wFxIgAEQEGiAiEBDAELIAxB/////wFxIgAEQEGFAiEBDAELIAtB/////wFxIgAEQEHoASEBDAELIApB/////wFxIgAEQEHLASEBDAELIAlB/////wFxIgAEQEGuASEBDAELIAhB/////wFxIgAEQEGRASEBDAELIAdB/////wFxIgAEQEH0ACEBDAELIAZB/////wFxIgAEQEHXACEBDAELIAVB/////wFxIgAEQEE6IQEMAQsgBEH/////AXEiAARAQR0hAQwBC0EAIQEgA0H/////AXEiAEUNAQsDQCABQQFqIQEgAEEBaiECIABBAm0hACACQQJLDQALCyABC9cDAQ1/AkACQCAAKAI0IAAoAjAgACgCLCAAKAIoIAAoAiQgACgCICAAKAIcIAAoAhggACgCFCAAKAIQIAAoAgwgACgCCCAAKAIEIAAoAgAiA0EddWoiBEEddWoiBUEddWoiBkEddWoiB0EddWoiCEEddWoiCUEddWoiCkEddWoiC0EddWoiDEEddWoiDUEddWoiAkEddWoiAUEddWoiAARAQfkCIQEMAQsgAUH/////AXEiAARAQdwCIQEMAQsgAkH/////AXEiAARAQb8CIQEMAQsgDUH/////AXEiAARAQaICIQEMAQsgDEH/////AXEiAARAQYUCIQEMAQsgC0H/////AXEiAARAQegBIQEMAQsgCkH/////AXEiAARAQcsBIQEMAQsgCUH/////AXEiAARAQa4BIQEMAQsgCEH/////AXEiAARAQZEBIQEMAQsgB0H/////AXEiAARAQfQAIQEMAQsgBkH/////AXEiAARAQdcAIQEMAQsgBUH/////AXEiAARAQTohAQwBCyAEQf////8BcSIABEBBHSEBDAELQQAhASADQf////8BcSIARQ0BCwNAIAFBAWohASAAQQFqIQIgAEECbSEAIAJBAksNAAsLIAELtwEBBH8jAEEwayIBJAAgAUHU/ik2AiAgAEH5hiogAUEgahCbAQJ/AkAgAEEBEM4CIgIEQCACLwEURQ0BIAIoAhAQrwMMAgsgAUGi2Sk2AgQgAUHU/ik2AgAgAEH8iCogARBsAAsgAigCDBCwAwshAyAAKAIMIgRBAzoABCAEIANBCG02AgAgACAAKAIMQQhqNgIMIAIQ0AIgAUHU/ik2AhAgAEHghyogAUEQahCbASABQTBqJABBAQupAgEHfyMAQTBrIgEkACABQYHWKTYCICAAQfmGKiABQSBqEJsBAn9BnPMqIABBARDOAiIGRQ0AGkHzlyogBi8BFA0AGiAAIAYQ3QEiBSgCCCICLAAAIQMCQCAFKAIAIgRBAkgNACACLAABIANBCHRyIQMgBEECRg0AIAIsAAIhByAEQQRJBEAgA0EQdCAHciEDDAELIAIsAAMgB0EYdHIhAyAEQQRGDQAgAEGhgCpBABCcAQsgACgCDCIEQQM6AAQgBCADNgIAIAAgACgCDEEIajYCDEEAQbXxKiAFGwshAiAFEJoBIAYQ0AIgAgRAIAEgAjYCFCABQYHWKTYCECAAQfyIKiABQRBqEGwACyABQYHWKTYCACAAQeCHKiABEJsBIAFBMGokAEEBC9wBAQN/IwBBMGsiASQAIAFBnI0qNgIgIABB+YYqIAFBIGoQmwECQCAAQQEQzgIiAwR/IAMvARRFDQFB5J0qBUG94SsLIQIgAxDQAiABIAI2AgQgAUGcjSo2AgAgAEH8iCogARBsAAsgAEEYQQEQ2gEhAiAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgAkEAOwEUIAJCIDcCCCACQQA2AhAgAkEBOgAAIAAgAhCWAyACKAIQIAMoAgwQtAMgAxDQAiABQZyNKjYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC84LAgJ+Cn8gACABNAIAIgIgAn4iAqdB/////wFxNgIAIAAgATQCACABQQRqIgQ0AgB+QgGGIAJCHYh8IgKnQf////8BcTYCBCAAIAE0AgAgATQCCH5CAYYgAkIdh3wgBDQCACICIAJ+fCICp0H/////AXE2AgggACAENAIAIAE0Agh+IAE0AgAgATQCDH58QgGGIAJCHYd8IgKnQf////8BcTYCDCAAIAQ0AgAgATQCDH4gATQCACABNAIQfnxCAYYgAkIdh3wgATQCCCICIAJ+fCICp0H/////AXE2AhAgACAENAIAIAE0AhB+IAE0AgAgATQCFH58IAE0AgggATQCDH58QgGGIAJCHYd8IgKnQf////8BcTYCFCAAIAQ0AgAgATQCFH4gATQCACABNAIYfnwgATQCCCABNAIQfnxCAYYgAkIdh3wgATQCDCICIAJ+fCICp0H/////AXE2AhggACAENAIAIAE0Ahh+IAE0AgAgATQCHH58IAE0AgggATQCFH58IAE0AgwgATQCEH58QgGGIAJCHYd8IgKnQf////8BcTYCHCAAIAQ0AgAgATQCHH4gATQCACABNAIgfnwgATQCCCABNAIYfnwgATQCDCABNAIUfnxCAYYgAkIdh3wgATQCECICIAJ+fCICp0H/////AXE2AiAgACAENAIAIAE0AiB+IAE0AgAgATQCJH58IAE0AgggATQCHH58IAE0AgwgATQCGH58IAE0AhAgATQCFH58QgGGIAJCHYd8IgKnQf////8BcTYCJCAAIAQ0AgAgATQCJH4gATQCACABNAIofnwgATQCCCABNAIgfnwgATQCDCABNAIcfnwgATQCECABNAIYfnxCAYYgAkIdh3wgATQCFCICIAJ+fCICp0H/////AXE2AiggACAENAIAIAE0Aih+IAE0AgAgATQCLH58IAE0AgggATQCJH58IAE0AgwgATQCIH58IAE0AhAgATQCHH58IAE0AhQgATQCGH58QgGGIAJCHYd8IgKnQf////8BcTYCLCAAIAQ0AgAgATQCLH4gATQCACABNAIwfnwgATQCCCABNAIofnwgATQCDCABNAIkfnwgATQCECABNAIgfnwgATQCFCABNAIcfnxCAYYgAkIdh3wgATQCGCICIAJ+fCICp0H/////AXE2AjAgAkIdhyEDQQchB0ENIQsDQCABIAsiBUECdCIIaiILQTRrNAIAIAE0AjR+IQICQCAFQQxrIgYgBUEBaiIMQQF2Ig1PBEAgBUELayEGDAELIAEgBkECdGo0AgAgATQCMH4gAnwhAiAFQQtrIgYgB0YNACABIAZBAnRqNAIAIAE0Aix+IAJ8IQIgBUEKayIJIAdGDQAgASAJQQJ0ajQCACABNAIofiACfCECIAVBCWsiCSAHRg0AIAEgCUECdGo0AgAgATQCJH4gAnwhAiAFQQhrIgkgB0YNACABIAlBAnRqNAIAIAE0AiB+IAJ8IQIgBUEHayIJIAdGDQAgASAJQQJ0ajQCACABNAIcfiACfCECCyAAIAhqIAJCAYYgA3wiAqdB/////wFxNgIAIAJCHYchAyALQTBrNAIAIAE0AjR+IQICQCAGIAVBAmoiC0EBdk8NACAKQQFxBH8gBgUgASAGQQJ0ajQCACABNAIwfiACfCECIAVBCmsLIQggCkEERg0AA0AgBCAIQQJ0IgZqNAIAIAEgBSAIa0ECdGo0AgB+IAEgBmo0AgAgASAMIAhrQQJ0ajQCAH4gAnx8IQIgCEECaiIIIAdHDQALCyAAIAxBAnRqIAJCAYYgA3wgASANQQJ0ajQCACICIAJ+fCICp0H/////AXE2AgAgAkIdhyEDIApBAWohCiAHQQFqIgdBDUcNAAsgACABNAIwIAE0AjR+QgGGIAN8IgKnQf////8BcTYCZCAAIAE0AjQiAyADfiACQh2HfCICQh2IPgJsIAAgAqdB/////wFxNgJoC+YLAwd/BnsCfiMAQaACayIDJAAgA0G/xio2AiAgAEH5hiogA0EgahCbAUG94SshBiAAQQEQzgIhBCAAQQIQzgIhBQJAIARFDQAgBUUNACAAQQNBsfAqENwBIQcgAEEYQQEQ2gEhAiAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgAkEAOwEUIAJCIDcCCCACQQA2AhAgAkEBOgAAAkAgBwRAQY74KSEGIAQvARQNAiAFLwEUDQIgBy8BFA0CIAMgBCgCDCIBKAIANgKwASADIAEoAgQ2ArQBIAMgASgCCDYCuAEgAyABKAIMNgK8ASADIAEoAhA2AsABIAMgASgCFDYCxAEgAyABKAIYNgLIASADIAEoAhw2AswBIAMgASgCIDYC0AEgAyABKAIkNgLUASADIAEoAig2AtgBIAMgASgCLDYC3AEgAyABKAIwNgLgASADIAEoAjQ2AuQBIAMgBSgCDCIBKAIANgJwIAMgASgCBDYCdCADIAEoAgg2AnggAyABKAIMNgJ8IAMgASgCEDYCgAEgAyABKAIUNgKEASADIAEoAhg2AogBIAMgASgCHDYCjAEgAyABKAIgNgKQASADIAEoAiQ2ApQBIAMgASgCKDYCmAEgAyABKAIsNgKcASADIAEoAjA2AqABIAMgASgCNDYCpAEgACACEMgCIAIoAgwgA0GwAWogA0HwAGogBygCDBCkAyACKAIMIgEgASgCACICQf////8BcTYCACABIAEoAgQgAkEddWoiAkH/////AXE2AgQgASABKAIIIAJBHXVqIgJB/////wFxNgIIIAEgASgCDCACQR11aiICQf////8BcTYCDCABIAEoAhAgAkEddWoiAkH/////AXE2AhAgASABKAIUIAJBHXVqIgJB/////wFxNgIUIAEgASgCGCACQR11aiICQf////8BcTYCGCABIAEoAhwgAkEddWoiAkH/////AXE2AhwgASABKAIgIAJBHXVqIgJB/////wFxNgIgIAEgASgCJCACQR11aiICQf////8BcTYCJCABIAEoAiggAkEddWoiAkH/////AXE2AiggASABKAIsIAJBHXVqIgJB/////wFxNgIsIAEgASgCMCACQR11aiICQf////8BcTYCMCABIAEoAjQgAkEddWo2AjQMAQsgBSgCDCIB/QACACEIIAH9AAIQIQkgAf0AAiAhCiABKQIwIQ4gBCgCDCIB/QACACELIAH9AAIQIQwgAf0AAiAhDSABKQIwIQ8gACACEMgCIAIoAgwhASADIA83A6ABIAMgDf0LBJABIAMgDP0LBIABIAMgC/0LBHAgAyAONwNgIAMgCv0LBFAgAyAJ/QsEQCADIAj9CwQwIANB8ABqQcDELxDbAiADQTBqQcDELxDbAiADQbABaiADQfAAaiADQTBqENMCIAEgA0GwAWpBwMQvEKYDIAIoAgwiAiACKAIAIgFB/////wFxNgIAIAIgAigCBCABQR11aiIBQf////8BcTYCBCACIAIoAgggAUEddWoiAUH/////AXE2AgggAiACKAIMIAFBHXVqIgFB/////wFxNgIMIAIgAigCECABQR11aiIBQf////8BcTYCECACIAIoAhQgAUEddWoiAUH/////AXE2AhQgAiACKAIYIAFBHXVqIgFB/////wFxNgIYIAIgAigCHCABQR11aiIBQf////8BcTYCHCACIAIoAiAgAUEddWoiAUH/////AXE2AiAgAiACKAIkIAFBHXVqIgFB/////wFxNgIkIAIgAigCKCABQR11aiIBQf////8BcTYCKCACIAIoAiwgAUEddWoiAUH/////AXE2AiwgAiACKAIwIAFBHXVqIgFB/////wFxNgIwIAIgAigCNCABQR11ajYCNAtBACEGQQEhAQsgBRDQAiAEENACIAFFBEAgAyAGNgIUIANBv8YqNgIQIABB/IgqIANBEGoQbAALIANBv8YqNgIAIABB4IcqIAMQmwEgA0GgAmokAEEBC4wHAwp/A3sBfiMAQeACayICJAAgAkG/wCk2AiAgAEH5hiogAkEgahCbAUG94SshCCAAQQEQzgIhBSAAQQIQzgIhBiAAQQMQzgIhBwJAIAVFDQAgBkUNACAHRQ0AQYz3KSEIIAUvARQNACAGLwEUDQAgBy8BFA0AIAUoAgwiBP0AAgAhCyAE/QACECEMIAT9AAIgIQ0gBCkCMCEOQQEhBCAAQRhBARDaASEDIABB2OHOfUGx8CoQkAEaIABBfhDbAUEAIQggA0EAOwEUIANCIDcCCCADQQA2AhAgA0EBOgAAIAAgAxDIAiADKAIMIQogBygCDCEJIAYoAgwhASACIA43A6ABIAIgDf0LBJABIAIgDP0LBIABIAIgC/0LBHAgAiABKAIANgIwIAIgASgCBDYCNCACIAEoAgg2AjggAiABKAIMNgI8IAIgASgCEDYCQCACIAEoAhQ2AkQgAiABKAIYNgJIIAIgASgCHDYCTCACIAEoAiA2AlAgAiABKAIkNgJUIAIgASgCKDYCWCACIAEoAiw2AlwgAiABKAIwNgJgIAIgASgCNDYCZCACQfAAaiAJENsCIAJBsAFqIAJBMGogCRC3AyACQfABaiACQfAAaiACQbABahDTAiAKIAJB8AFqIAkQpgMgAygCDCIBIAEoAgAiA0H/////AXE2AgAgASABKAIEIANBHXVqIgNB/////wFxNgIEIAEgASgCCCADQR11aiIDQf////8BcTYCCCABIAEoAgwgA0EddWoiA0H/////AXE2AgwgASABKAIQIANBHXVqIgNB/////wFxNgIQIAEgASgCFCADQR11aiIDQf////8BcTYCFCABIAEoAhggA0EddWoiA0H/////AXE2AhggASABKAIcIANBHXVqIgNB/////wFxNgIcIAEgASgCICADQR11aiIDQf////8BcTYCICABIAEoAiQgA0EddWoiA0H/////AXE2AiQgASABKAIoIANBHXVqIgNB/////wFxNgIoIAEgASgCLCADQR11aiIDQf////8BcTYCLCABIAEoAjAgA0EddWoiA0H/////AXE2AjAgASABKAI0IANBHXVqNgI0CyAFENACIAYQ0AIgBxDQAiAERQRAIAIgCDYCFCACQb/AKTYCECAAQfyIKiACQRBqEGwACyACQb/AKTYCACAAQeCHKiACEJsBIAJB4AJqJABBAQvZIwFdfyABIAIQ2wIgASgCNCEFIAEoAjAhBiABKAIsIS8gASgCKCEwIAEoAiQhMSABKAIgITIgASgCHCEzIAEoAhghNCABKAIUITUgASgCECE2IAEoAgwhNyABKAIIITggASgCBCE5IAEoAgAhLUEAIQEgAigCNCJFIQcgAigCMCJGIQggAigCLCJHITogAigCKCJIITsgAigCJCJJITwgAigCICJKIT0gAigCHCJLIT4gAigCGCJMIT8gAigCFCJNIUAgAigCECJOIUEgAigCDCJPIUIgAigCCCJQIUMgAigCBCJRIUQgAigCACJSIS5BASEJQQAhAgNAAkACQAJAIAUNACAGDQAgLw0AIDANACAxDQAgMg0AIDMNACA0DQAgNQ0AIDYNACA3DQAgOA0AIDkNACAtQQFGDQELIAcNASAIDQEgOg0BIDsNASA8DQEgPQ0BID4NASA/DQEgQA0BIEENASBCDQEgQw0BIEQNASAuQQFHDQEgDCEJIBwhFyAdIRYgHiEVIB8hFCAgIRMgISESICIhESAjIRAgGCEPIBkhDiAaIQ0gCyEKIAIhAQsgACABNgI0IAAgCjYCMCAAIA02AiwgACAONgIoIAAgDzYCJCAAIBA2AiAgACARNgIcIAAgEjYCGCAAIBM2AhQgACAUNgIQIAAgFTYCDCAAIBY2AgggACAXNgIEIAAgCTYCAA8LIC1BAXFFBEADQCAFQRx0QYCAgIABcSFTIAZBHHRBgICAgAFxIVQgL0EcdEGAgICAAXEhVSAwQRx0QYCAgIABcSFWIDFBHHRBgICAgAFxIVcgMkEcdEGAgICAAXEhWCAzQRx0QYCAgIABcSFZIDRBHHRBgICAgAFxIVogNUEcdEGAgICAAXEhWyA2QRx0QYCAgIABcSFcIDdBHHRBgICAgAFxIV0gOEEcdEGAgICAAXEhXiA5QRx0QYCAgIABcSFfAkAgCUEBcUUEQCAKIQMgDSEEIA4hGyAPISQgECElIBEhJiASIScgEyEoIBQhKSAVISogFiErIBchLAwBCyAXIFFqIAkgUmoiCUEddWoiA0H/////AXEhLCAWIFBqIANBHXVqIgNB/////wFxISsgFSBPaiADQR11aiIDQf////8BcSEqIBQgTmogA0EddWoiA0H/////AXEhKSATIE1qIANBHXVqIgNB/////wFxISggEiBMaiADQR11aiIDQf////8BcSEnIBEgS2ogA0EddWoiA0H/////AXEhJiAQIEpqIANBHXVqIgNB/////wFxISUgDyBJaiADQR11aiIDQf////8BcSEkIA4gSGogA0EddWoiA0H/////AXEhGyANIEdqIANBHXVqIgNB/////wFxIQQgCiBGaiADQR11aiIKQf////8BcSEDIAEgRWogCkEddWohASAJQf////8BcSEJCyBTIAZBAXVyIQYgVCAvQQF1ciEvIFUgMEEBdXIhMCBWIDFBAXVyITEgVyAyQQF1ciEyIFggM0EBdXIhMyBZIDRBAXVyITQgWiA1QQF1ciE1IFsgNkEBdXIhNiBcIDdBAXVyITcgXSA4QQF1ciE4IF4gOUEBdXIhOSAFQQF1IQUgAUEcdEGAgICAAXEgA0EBdnIhCiADQRx0QYCAgIABcSAEQQF2ciENIARBHHRBgICAgAFxIBtBAXZyIQ4gG0EcdEGAgICAAXEgJEEBdnIhDyAkQRx0QYCAgIABcSAlQQF2ciEQICVBHHRBgICAgAFxICZBAXZyIREgJkEcdEGAgICAAXEgJ0EBdnIhEiAnQRx0QYCAgIABcSAoQQF2ciETIChBHHRBgICAgAFxIClBAXZyIRQgKUEcdEGAgICAAXEgKkEBdnIhFSAqQRx0QYCAgIABcSArQQF2ciEWICtBHHRBgICAgAFxICxBAXZyIRcgLEEcdEGAgICAAXEgCUEBdnIhCSABQQF1IQEgLUECcSEDIF8gLUEBdXIhLSADRQ0ACwsgLkEBcUUEQANAIAdBHHRBgICAgAFxIVMgCEEcdEGAgICAAXEhVCA6QRx0QYCAgIABcSFVIDtBHHRBgICAgAFxIVYgPEEcdEGAgICAAXEhVyA9QRx0QYCAgIABcSFYID5BHHRBgICAgAFxIVkgP0EcdEGAgICAAXEhWiBAQRx0QYCAgIABcSFbIEFBHHRBgICAgAFxIVwgQkEcdEGAgICAAXEhXSBDQRx0QYCAgIABcSFeIERBHHRBgICAgAFxIV8CQCAMQQFxRQRAIBwhAyAdIQQgHiEbIB8hJCAgISUgISEmICIhJyAjISggGCEpIBkhKiAaISsgCyEsDAELIBwgUWogDCBSaiIMQR11aiIEQf////8BcSEDIB0gUGogBEEddWoiG0H/////AXEhBCAeIE9qIBtBHXVqIiRB/////wFxIRsgHyBOaiAkQR11aiIlQf////8BcSEkICAgTWogJUEddWoiJkH/////AXEhJSAhIExqICZBHXVqIidB/////wFxISYgIiBLaiAnQR11aiIoQf////8BcSEnICMgSmogKEEddWoiKUH/////AXEhKCAYIElqIClBHXVqIipB/////wFxISkgGSBIaiAqQR11aiIrQf////8BcSEqIBogR2ogK0EddWoiLEH/////AXEhKyALIEZqICxBHXVqIgtB/////wFxISwgAiBFaiALQR11aiECIAxB/////wFxIQwLIFMgCEEBdXIhCCBUIDpBAXVyITogVSA7QQF1ciE7IFYgPEEBdXIhPCBXID1BAXVyIT0gWCA+QQF1ciE+IFkgP0EBdXIhPyBaIEBBAXVyIUAgWyBBQQF1ciFBIFwgQkEBdXIhQiBdIENBAXVyIUMgXiBEQQF1ciFEIAdBAXUhByACQRx0QYCAgIABcSAsQQF2ciELICxBHHRBgICAgAFxICtBAXZyIRogK0EcdEGAgICAAXEgKkEBdnIhGSAqQRx0QYCAgIABcSApQQF2ciEYIClBHHRBgICAgAFxIChBAXZyISMgKEEcdEGAgICAAXEgJ0EBdnIhIiAnQRx0QYCAgIABcSAmQQF2ciEhICZBHHRBgICAgAFxICVBAXZyISAgJUEcdEGAgICAAXEgJEEBdnIhHyAkQRx0QYCAgIABcSAbQQF2ciEeIBtBHHRBgICAgAFxIARBAXZyIR0gBEEcdEGAgICAAXEgA0EBdnIhHCADQRx0QYCAgIABcSAMQQF2ciEMIAJBAXUhAiAuQQJxIQMgXyAuQQF1ciEuIANFDQALCwJAAkACQCAFIgMgByIERw0AIAYiAyAIIgRHDQAgLyIDIDoiBEcNACAwIgMgOyIERw0AIDEiAyA8IgRHDQAgMiIDID0iBEcNACAzIgMgPiIERw0AIDQiAyA/IgRHDQAgNSIDIEAiBEcNACA2IgMgQSIERw0AIDciAyBCIgRHDQAgOCIDIEMiBEcNACA5IgMgRCIERw0AIC0iAyAuIgRGDQELIAMgBEwNAQsgBiAIayAvIDprIDAgO2sgMSA8ayAyID1rIDMgPmsgNCA/ayA1IEBrIDYgQWsgNyBCayA4IENrIDkgRGsgLSAuayItQR11aiI5QR11aiI4QR11aiI3QR11aiI2QR11aiI1QR11aiI0QR11aiIzQR11aiIyQR11aiIxQR11aiIwQR11aiIvQR11aiIDQR11IQQgBSAHayEbIAEhBSACIQYCQAJAIAEgAkcNACAKIQUgCyEGIAogC0cNACANIQUgGiEGIA0gGkcNACAOIQUgGSEGIA4gGUcNACAPIQUgGCEGIA8gGEcNACAQIQUgIyEGIBAgI0cNACARIQUgIiEGIBEgIkcNACASIQUgISEGIBIgIUcNACATIQUgICEGIBMgIEcNACAUIQUgHyEGIBQgH0cNACAVIQUgHiEGIBUgHkcNACAWIQUgHSEGIBYgHUcNACAXIQUgHCEGIBcgHEcNACAJIQUgDCEGIAkgDEYNAQsgBSAGSg0AIAEgRWohASAKIEZqIQogDSBHaiENIA4gSGohDiAPIElqIQ8gECBKaiEQIBEgS2ohESASIExqIRIgEyBNaiETIBQgTmohFCAVIE9qIRUgFiBQaiEWIBcgUWohFyAJIFJqIQkLIDlB/////wFxITkgOEH/////AXEhOCA3Qf////8BcSE3IDZB/////wFxITYgNUH/////AXEhNSA0Qf////8BcSE0IDNB/////wFxITMgMkH/////AXEhMiAxQf////8BcSExIDBB/////wFxITAgL0H/////AXEhLyADQf////8BcSEGIAQgG2ohBSAtQf7///8BcSEtIBcgHGsgCSAMayIJQR11aiIDQf////8BcSEXIBYgHWsgA0EddWoiA0H/////AXEhFiAVIB5rIANBHXVqIgNB/////wFxIRUgFCAfayADQR11aiIDQf////8BcSEUIBMgIGsgA0EddWoiA0H/////AXEhEyASICFrIANBHXVqIgNB/////wFxIRIgESAiayADQR11aiIDQf////8BcSERIBAgI2sgA0EddWoiA0H/////AXEhECAPIBhrIANBHXVqIgNB/////wFxIQ8gDiAZayADQR11aiIDQf////8BcSEOIA0gGmsgA0EddWoiA0H/////AXEhDSAKIAtrIANBHXVqIgNB/////wFxIQogASACayADQR11aiEBIAlB/////wFxIQkMAQsgCCAGayA6IC9rIDsgMGsgPCAxayA9IDJrID4gM2sgPyA0ayBAIDVrIEEgNmsgQiA3ayBDIDhrIEQgOWsgLiAtayIuQR11aiJEQR11aiJDQR11aiJCQR11aiJBQR11aiJAQR11aiI/QR11aiI+QR11aiI9QR11aiI8QR11aiI7QR11aiI6QR11aiIDQR11IQQgByAFayEbIAIhByABIQgCfwJAAkACQCABIAJHDQAgCyEHIAohCCAKIAtHDQAgGiEHIA0hCCANIBpHDQAgGSEHIA4hCCAOIBlHDQAgGCEHIA8hCCAPIBhHDQAgIyEHIBAhCCAQICNHDQAgIiEHIBEhCCARICJHDQAgISEHIBIhCCASICFHDQAgICEHIBMhCCATICBHDQAgHyEHIBQhCCAUIB9HDQAgHiEHIBUhCCAVIB5HDQAgHSEHIBYhCCAWIB1HDQAgHCEHIBchCCAXIBxHDQAgDCEHIAkhCCAJIAxGDQELIAcgCEwNAQsgAiABayEkIAsgCmshJSAaIA1rISYgGSAOayEnIBggD2shKCAjIBBrISkgIiARayEqICEgEmshKyAgIBNrISwgHyAUayELIB4gFWshGiAdIBZrIRkgHCAXayEYIAwgCWsMAQsgRSABayACaiEkIEYgCmsgC2ohJSBHIA1rIBpqISYgSCAOayAZaiEnIEkgD2sgGGohKCBKIBBrICNqISkgSyARayAiaiEqIEwgEmsgIWohKyBNIBNrICBqISwgTiAUayAfaiELIE8gFWsgHmohGiBQIBZrIB1qIRkgUSAXayAcaiEYIFIgCWsgDGoLIQIgREH/////AXEhRCBDQf////8BcSFDIEJB/////wFxIUIgQUH/////AXEhQSBAQf////8BcSFAID9B/////wFxIT8gPkH/////AXEhPiA9Qf////8BcSE9IDxB/////wFxITwgO0H/////AXEhOyA6Qf////8BcSE6IANB/////wFxIQggBCAbaiEHIC5B/v///wFxIS4gAkH/////AXEhDCAYIAJBHXVqIgJB/////wFxIRwgAkEddSAZaiICQf////8BcSEdIAJBHXUgGmoiAkH/////AXEhHiACQR11IAtqIgJB/////wFxIR8gAkEddSAsaiICQf////8BcSEgIAJBHXUgK2oiAkH/////AXEhISACQR11ICpqIgJB/////wFxISIgAkEddSApaiICQf////8BcSEjIAJBHXUgKGoiAkH/////AXEhGCACQR11ICdqIgJB/////wFxIRkgAkEddSAmaiICQf////8BcSEaIAJBHXUgJWoiAkH/////AXEhCyACQR11ICRqIQIMAAsAC8QFAwh/A3sBfiMAQeABayIDJAAgA0GRjSo2AiAgAEH5hiogA0EgahCbAUG94SshByAAQQEQzgIhBSAAQQIQzgIhBgJAIAVFDQAgBkUNAEHj9ykhByAFLwEUDQAgBi8BFA0AIAUoAgwiBP0AAgAhCSAE/QACECEKIAT9AAIgIQsgBCkCMCEMQQEhBCAAQRhBARDaASEBIABB2OHOfUGx8CoQkAEaIABBfhDbAUEAIQcgAUEAOwEUIAFCIDcCCCABQQA2AhAgAUEBOgAAIAAgARDIAiABKAIMIQggBigCDCECIAMgDDcDYCADIAv9CwRQIAMgCv0LBEAgAyAJ/QsEMCADQTBqIAIQ2wIgA0HwAGogA0EwahC0AyAIIANB8ABqIAIQpgMgASgCDCIBIAEoAgAiAkH/////AXE2AgAgASABKAIEIAJBHXVqIgJB/////wFxNgIEIAEgASgCCCACQR11aiICQf////8BcTYCCCABIAEoAgwgAkEddWoiAkH/////AXE2AgwgASABKAIQIAJBHXVqIgJB/////wFxNgIQIAEgASgCFCACQR11aiICQf////8BcTYCFCABIAEoAhggAkEddWoiAkH/////AXE2AhggASABKAIcIAJBHXVqIgJB/////wFxNgIcIAEgASgCICACQR11aiICQf////8BcTYCICABIAEoAiQgAkEddWoiAkH/////AXE2AiQgASABKAIoIAJBHXVqIgJB/////wFxNgIoIAEgASgCLCACQR11aiICQf////8BcTYCLCABIAEoAjAgAkEddWoiAkH/////AXE2AjAgASABKAI0IAJBHXVqNgI0CyAGENACIAUQ0AIgBEUEQCADIAc2AhQgA0GRjSo2AhAgAEH8iCogA0EQahBsAAsgA0GRjSo2AgAgAEHghyogAxCbASADQeABaiQAQQELiQcDCH8DewF+IwBB8ABrIgMkACADQbPzKjYCICAAQfmGKiADQSBqEJsBQb3hKyEIIABBARDOAiEGIABBAhDOAiEHAkAgBkUNACAHRQ0AQeT4KSEIIAYvARQNACAHLwEUDQAgBigCDCIF/QACACEJIAX9AAIQIQogBf0AAiAhCyAFKQIwIQxBASEFIABBGEEBENoBIQQgAEHY4c59QbHwKhCQARogAEF+ENsBQQAhCCAEQQA7ARQgBEIgNwIIIARBADYCECAEQQE6AAAgACAEEMgCIAQoAgwhAiAHKAIMIQEgAyAMNwNgIAMgC/0LBFAgAyAK/QsEQCADIAn9CwQwIANBMGogARDbAiACIAEoAgAgAygCMGs2AgAgAiABKAIEIAMoAjRrNgIEIAIgASgCCCADKAI4azYCCCACIAEoAgwgAygCPGs2AgwgAiABKAIQIAMoAkBrNgIQIAIgASgCFCADKAJEazYCFCACIAEoAhggAygCSGs2AhggAiABKAIcIAMoAkxrNgIcIAIgASgCICADKAJQazYCICACIAEoAiQgAygCVGs2AiQgAiABKAIoIAMoAlhrNgIoIAIgASgCLCADKAJcazYCLCACIAEoAjAgAygCYGs2AjAgAiABKAI0IAMoAmRrNgI0IAQoAgwiASABKAIAIgJB/////wFxNgIAIAEgASgCBCACQR11aiICQf////8BcTYCBCABIAEoAgggAkEddWoiAkH/////AXE2AgggASABKAIMIAJBHXVqIgJB/////wFxNgIMIAEgASgCECACQR11aiICQf////8BcTYCECABIAEoAhQgAkEddWoiAkH/////AXE2AhQgASABKAIYIAJBHXVqIgJB/////wFxNgIYIAEgASgCHCACQR11aiICQf////8BcTYCHCABIAEoAiAgAkEddWoiAkH/////AXE2AiAgASABKAIkIAJBHXVqIgJB/////wFxNgIkIAEgASgCKCACQR11aiICQf////8BcTYCKCABIAEoAiwgAkEddWoiAkH/////AXE2AiwgASABKAIwIAJBHXVqIgJB/////wFxNgIwIAEgASgCNCACQR11ajYCNAsgBhDQAiAHENACIAVFBEAgAyAINgIUIANBs/MqNgIQIABB/IgqIANBEGoQbAALIANBs/MqNgIAIABB4IcqIAMQmwEgA0HwAGokAEEBC74OAgd/AXsjAEHAA2siASQAIAFBr8krNgIgIABB+YYqIAFBIGoQmwEgAEEBEM4CIQYgAEECEM4CIQUgAEEDEM4CIQcgAEEYQQEQ2gEhAyAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgA0EAOwEUIANCIDcCCCADQQA2AhAgA0EBOgAAAkACQAJAIAZFDQAgBUUNACAHRQ0AIAAgAxDIAgJAAn8gBi8BFEUEQCAFLwEURQ0CIAEgBigCDCICKAIANgLQAiABIAIoAgQ2AtQCIAEgAigCCDYC2AIgASACKAIMNgLcAiABIAIoAhA2AuACIAEgAigCFDYC5AIgASACKAIYNgLoAiABIAIoAhw2AuwCIAEgAigCIDYC8AIgASACKAIkNgL0AiABIAIoAig2AvgCIAEgAigCLDYC/AIgASACKAIwNgKAAyACKAI0IQIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LApwDIAEgCP0LAqwDIAFBADYCvAMgASAI/QsCjAMgASACQR11NgKIAyABIAJB/////wFxNgKEAyABQdACaiEEIAUoAhAMAQsgBigCECEEIAUvARQEQCAFKAIQDAELIAEgBSgCDCICKAIANgLgASABIAIoAgQ2AuQBIAEgAigCCDYC6AEgASACKAIMNgLsASABIAIoAhA2AvABIAEgAigCFDYC9AEgASACKAIYNgL4ASABIAIoAhw2AvwBIAEgAigCIDYCgAIgASACKAIkNgKEAiABIAIoAig2AogCIAEgAigCLDYCjAIgASACKAIwNgKQAiACKAI0IQIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAqwCIAEgCP0LArwCIAFBADYCzAIgASAI/QsCnAIgASACQR11NgKYAiABIAJB/////wFxNgKUAiABQeABagshAiAEIAIQoANBAE4NAiABQfAAaiACIAQQoQMgAUEwaiABQfAAaiAHKAIMIgIQpgMgAygCDCIDIAIoAgAgASgCMGs2AgAgAyACKAIEIAEoAjRrNgIEIAMgAigCCCABKAI4azYCCCADIAIoAgwgASgCPGs2AgwgAyACKAIQIAEoAkBrNgIQIAMgAigCFCABKAJEazYCFCADIAIoAhggASgCSGs2AhggAyACKAIcIAEoAkxrNgIcIAMgAigCICABKAJQazYCICADIAIoAiQgASgCVGs2AiQgAyACKAIoIAEoAlhrNgIoIAMgAigCLCABKAJcazYCLCADIAIoAjAgASgCYGs2AjAgAyACKAI0IAEoAmRrNgI0DAMLIAYoAgwiAiAFKAIMIgQQogNBAEgEQCABIAQoAgAgAigCAGs2AtACIAEgBCgCBCACKAIEazYC1AIgASAEKAIIIAIoAghrNgLYAiABIAQoAgwgAigCDGs2AtwCIAEgBCgCECACKAIQazYC4AIgASAEKAIUIAIoAhRrNgLkAiABIAQoAhggAigCGGs2AugCIAEgBCgCHCACKAIcazYC7AIgASAEKAIgIAIoAiBrNgLwAiABIAQoAiQgAigCJGs2AvQCIAEgBCgCKCACKAIoazYC+AIgASAEKAIsIAIoAixrNgL8AiABIAQoAjAgAigCMGs2AoADIAEgBCgCNCACKAI0azYChAMgAUHQAmogBygCDCICENsCIAMoAgwiAyACKAIAIAEoAtACazYCACADIAIoAgQgASgC1AJrNgIEIAMgAigCCCABKALYAms2AgggAyACKAIMIAEoAtwCazYCDCADIAIoAhAgASgC4AJrNgIQIAMgAigCFCABKALkAms2AhQgAyACKAIYIAEoAugCazYCGCADIAIoAhwgASgC7AJrNgIcIAMgAigCICABKALwAms2AiAgAyACKAIkIAEoAvQCazYCJCADIAIoAiggASgC+AJrNgIoIAMgAigCLCABKAL8Ams2AiwgAyACKAIwIAEoAoADazYCMCADIAIoAjQgASgChANrNgI0DAMLIAMoAgwiAyACKAIAIAQoAgBrNgIAIAMgAigCBCAEKAIEazYCBCADIAIoAgggBCgCCGs2AgggAyACKAIMIAQoAgxrNgIMIAMgAigCECAEKAIQazYCECADIAIoAhQgBCgCFGs2AhQgAyACKAIYIAQoAhhrNgIYIAMgAigCHCAEKAIcazYCHCADIAIoAiAgBCgCIGs2AiAgAyACKAIkIAQoAiRrNgIkIAMgAigCKCAEKAIoazYCKCADIAIoAiwgBCgCLGs2AiwgAyACKAIwIAQoAjBrNgIwIAMgAigCNCAEKAI0azYCNCADIAcoAgwQ2wIMAgsgBhDQAiAFENACIAcQ0AIgAUGQhCo2AhQgAUGvySs2AhAgAEH8iCogAUEQahBsAAsgAUHwAGogBCACEKEDIAMoAgwgAUHwAGogBygCDBCmAwsgBhDQAiAFENACIAcQ0AIgAUGvySs2AgAgAEHghyogARCbASABQcADaiQAQQEL6AEBBH8jAEEwayIBJAAgAUGKwCk2AiAgAEH5hiogAUEgahCbASAAQQEQzgIhAyAAQQIQzgIhBCAAQRhBARDaASECIABB2OHOfUGx8CoQkAEaIABBfhDbASACQQA7ARQgAkIgNwIIIAJBADYCECACQQE6AAAgA0EAIAQbRQRAIAMQ0AIgBBDQAiABQb3hKzYCFCABQYrAKTYCECAAQfyIKiABQRBqEGwACyAAIAIQyAIgAigCDCADKAIMIAQoAgwQtwMgAxDQAiAEENACIAFBisApNgIAIABB4IcqIAEQmwEgAUEwaiQAQQELiQIBBX8jAEEwayIBJAAgAUG4kio2AiAgAEH5hiogAUEgahCbASAAQQEQzgIhAyAAQQIQzgIhBCAAQQMQzgIhBSAAQRhBARDaASECIABB2OHOfUGx8CoQkAEaIABBfhDbASACQQA7ARQgAkIgNwIIIAJBADYCECACQQE6AAAgACACEMgCAkACQCADRQ0AIARFDQAgBQ0BCyAFENACIAQQ0AIgAxDQAiABQZCEKjYCFCABQbiSKjYCECAAQfyIKiABQRBqEGwACyACKAIMIAMoAgwgBCgCDCAFKAIMEL0DIAUQ0AIgBBDQAiADENACIAFBuJIqNgIAIABB4IcqIAEQmwEgAUEwaiQAQQEL/gcCGX8BeyMAQUBqIgQkACAAQQE2AgAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAgQgACAd/QsCFCAAIB39CwIkIABBADYCNAJAAkAgAigCACIHIAIoAgQiBXINACACKAIIBEBBACEFDAELIAIoAgwEQEEAIQUMAQsgAigCEARAQQAhBQwBCyACKAIUBEBBACEFDAELIAIoAhgEQEEAIQUMAQsgAigCHARAQQAhBQwBCyACKAIgBEBBACEFDAELIAIoAiQEQEEAIQUMAQsgAigCKARAQQAhBQwBCyACKAIsBEBBACEFDAELIAIoAjAEQEEAIQUMAQtBACEFIAIoAjRFDQELIAIoAjQhCCACKAIwIQkgAigCLCEKIAIoAighCyACKAIkIQwgAigCICENIAIoAhwhDiACKAIYIQ8gAigCFCEQIAIoAhAhESACKAIMIRIgAigCCCECIAQgASgCADYCACAEIAEoAgQ2AgQgBCABKAIINgIIIAQgASgCDDYCDCAEIAEoAhA2AhAgBCABKAIUNgIUIAQgASgCGDYCGCAEIAEoAhw2AhwgBCABKAIgNgIgIAQgASgCJDYCJCAEIAEoAig2AiggBCABKAIsNgIsIAQgASgCMDYCMCAEIAEoAjQ2AjQDQAJAQQAhAQJAIAgEQCAIIQYMAQsgCQRAIAkhBgwBCyAKBEAgCiEGDAELIAsEQCALIQYMAQsgDARAIAwhBgwBCyANBEAgDSEGDAELIA4EQCAOIQYMAQsgDwRAIA8hBgwBCyAQBEAgECEGDAELIBEEQCARIQYMAQsgEgRAIBIhBgwBCyACBEAgAiEGDAELIAUhBiAFDQBBASEBIAchBiAHQQFGDQELIAEgBk4NACAHQQFxBEAgACAAIAQgAxCkAwsgBCAEIAQgAxCkAyAIQRx0IQEgCUEcdCEGIApBHHQhEyALQRx0IRQgDEEcdCEVIA1BHHQhFiAOQRx0IRcgD0EcdCEYIBBBHHQhGSARQRx0IRogEkEcdCEbIAJBHHQhHCAFQRx0QYCAgIABcSAHQQF1ciEHIAhBAXUhCCABQYCAgIABcSAJQQF1ciEJIAZBgICAgAFxIApBAXVyIQogE0GAgICAAXEgC0EBdXIhCyAUQYCAgIABcSAMQQF1ciEMIBVBgICAgAFxIA1BAXVyIQ0gFkGAgICAAXEgDkEBdXIhDiAXQYCAgIABcSAPQQF1ciEPIBhBgICAgAFxIBBBAXVyIRAgGUGAgICAAXEgEUEBdXIhESAaQYCAgIABcSASQQF1ciESIBtBgICAgAFxIAJBAXVyIQIgHEGAgICAAXEgBUEBdXIhBQwBCwsgACAAIAQgAxCkAwsgBEFAayQAC98BAQV/IwBBMGsiASQAIAFBr9sqNgIgIABB+YYqIAFBIGoQmwFBveErIQIgAEEBEM4CIQQgAEECEM4CIQUCQCAERQ0AIAVFDQBBufgpIQIgBC8BFA0AIAUvARQNACAEKAIMIAUoAgwQvwMhAyAAKAIMIgJBAzoABCACIAM2AgAgACAAKAIMQQhqNgIMQQAhAkEBIQMLIAQQ0AIgBRDQAiADRQRAIAEgAjYCFCABQa/bKjYCECAAQfyIKiABQRBqEGwACyABQa/bKjYCACAAQeCHKiABEJsBIAFBMGokAEEBC4ATAS1/IwBBgAFrIgIkAAJAIAEoAgAiCEEBcUUNAAJAIAAoAjQiCg0AIAAoAjANACAAKAIsDQAgACgCKA0AIAAoAiQNACAAKAIgDQAgACgCHA0AIAAoAhgNACAAKAIUDQAgACgCEA0AIAAoAgwNACAAKAIIDQAgACgCBA0AIAAoAgBFDQELAkAgASgCNCIGDQAgASgCMCIGDQAgASgCLCIGDQAgASgCKCIGDQAgASgCJCIGDQAgASgCICIGDQAgASgCHCIGDQAgASgCGCIGDQAgASgCFCIGDQAgASgCECIGDQAgASgCDCIGDQAgASgCCCIGDQAgASgCBCIGDQBBASEFIAghBiAIQQFGDQELIAUgBk4NACAAIAAoAgAiBEH/////AXEiBTYCACAAIAAoAgQgBEEddWoiBEH/////AXEiBjYCBCAAIAAoAgggBEEddWoiBEH/////AXEiCDYCCCAAIAAoAgwgBEEddWoiBEH/////AXEiCzYCDCAAIAAoAhAgBEEddWoiBEH/////AXEiDDYCECAAIAAoAhQgBEEddWoiBEH/////AXEiDTYCFCAAIAAoAhggBEEddWoiBEH/////AXEiDjYCGCAAIAAoAhwgBEEddWoiBEH/////AXEiDzYCHCAAIAAoAiAgBEEddWoiBEH/////AXEiEDYCICAAIAAoAiQgBEEddWoiBEH/////AXEiETYCJCAAIAAoAiggBEEddWoiBEH/////AXEiEjYCKCAAIAAoAiwgBEEddWoiBEH/////AXEiAzYCLCAAIAAoAjAgBEEddWoiBEH/////AXEiCTYCMCAAIARBHXUgCmoiBDYCNCACIAQ2AjQgAiAJNgIwIAIgAzYCLCACIBI2AiggAiARNgIkIAIgEDYCICACIA82AhwgAiAONgIYIAIgDTYCFCACIAw2AhAgAiALNgIMIAIgCDYCCCACIAY2AgQgAiAFNgIAIAEoAjQhEiABKAIwIQkgASgCLCETIAEoAighFCABKAIkIRUgASgCICEXIAEoAhwhGCABKAIYIRkgASgCFCEaIAEoAhAhGyABKAIMIRwgASgCCCEdIAEoAgQhFiABKAIAIR4gAiABENsCIAIoAgAhACACKAIEIREgAigCCCEQIAIoAgwhDyACKAIQIQ4gAigCFCENIAIoAhghDCACKAIcIQsgAigCICEKIAIoAiQhCCACKAIoIQYgAigCLCEFIAIoAjAhBCACKAI0IQEDQAJAQQAhBwJAIBIiAw0AIAkiAw0AIBMiAw0AIBQiAw0AIBUiAw0AIBciAw0AIBgiAw0AIBkiAw0AIBoiAw0AIBsiAw0AIBwiAw0AIB0iAw0AIBYiAw0AQQEhByAeIgNBAUYNAQsgAyAHTA0AAkAgAQ0AIAQNACAFDQAgBg0AIAgNACAKDQAgCw0AIAwNACANDQAgDg0AIA8NACAQDQAgEQ0AIAANAEEAIQQMAwsgHkEHcSEgIBYgHkEddWoiA0H/////AXEhISADQR11IB1qIgNB/////wFxISIgA0EddSAcaiIDQf////8BcSEjIANBHXUgG2oiA0H/////AXEhJCADQR11IBpqIgNB/////wFxISUgA0EddSAZaiIDQf////8BcSEmIANBHXUgGGoiA0H/////AXEhJyADQR11IBdqIgNB/////wFxISggA0EddSAVaiIDQf////8BcSEpIANBHXUgFGoiA0H/////AXEhKiADQR11IBNqIgNB/////wFxISsgA0EddSAJaiIDQf////8BcSEsIANBHXUgEmohLUEAIRICQCAAQQFxBEAgACEDIBEhFiAQIQkgDyEHIA4hEyANIRQgDCEVDAELA0AgAUEcdCEDIARBHHQhCSAFQRx0IQcgBkEcdCETIAhBHHQhFCAKQRx0IRUgC0EcdCEXIAxBHHQhGCANQRx0IRkgDkEcdCEaIA9BHHQhGyARQRx0IRwgAUEBdSEBIBIiLkEBaiESIABBAnEhHSAQQRx0QYCAgIABcSARQQF1ciIWIREgA0GAgICAAXEgBEEBdXIhBCAJQYCAgIABcSAFQQF1ciEFIAdBgICAgAFxIAZBAXVyIQYgE0GAgICAAXEgCEEBdXIhCCAUQYCAgIABcSAKQQF1ciEKIBVBgICAgAFxIAtBAXVyIQsgF0GAgICAAXEgDEEBdXIiFSEMIBhBgICAgAFxIA1BAXVyIhQhDSAZQYCAgIABcSAOQQF1ciITIQ4gGkGAgICAAXEgD0EBdXIiByEPIBtBgICAgAFxIBBBAXVyIgkhECAcQYCAgIABcSAAQQF1ciIDIQAgHUUNAAsgLkEBcQ0AIB8gICAgbEEBa0EIbUH/AXFqIR8LIAIgLTYCdCACICw2AnAgAiArNgJsIAIgKjYCaCACICk2AmQgAiAoNgJgIAIgJzYCXCACICY2AlggAiAlNgJUIAIgJDYCUCACICM2AkwgAiAiNgJIIAIgITYCRCACIB5B/////wFxNgJAIAIgA0H/////AXEiHjYCACACIBYgA0EddWoiAEH/////AXEiFjYCBCACIAkgAEEddWoiAEH/////AXEiHTYCCCACIAcgAEEddWoiAEH/////AXEiHDYCDCACIBMgAEEddWoiAEH/////AXEiGzYCECACIBQgAEEddWoiAEH/////AXEiGjYCFCACIBUgAEEddWoiAEH/////AXEiGTYCGCACIAsgAEEddWoiAEH/////AXEiGDYCHCACIAogAEEddWoiAEH/////AXEiFzYCICACIAggAEEddWoiAEH/////AXEiFTYCJCACIAYgAEEddWoiAEH/////AXEiFDYCKCACIAUgAEEddWoiAEH/////AXEiEzYCLCACIAQgAEEddWoiAEH/////AXEiCTYCMCACIAEgAEEddWoiEjYCNCACQUBrIAIQ2wIgAiACKAJAIgA2AgAgAiACKAJEIhE2AgQgAiACKAJIIhA2AgggAiACKAJMIg82AgwgAiACKAJQIg42AhAgAiACKAJUIg02AhQgAiACKAJYIgw2AhggAiACKAJcIgs2AhwgAiACKAJgIgo2AiAgAiACKAJkIgg2AiQgAiACKAJoIgY2AiggAiACKAJsIgU2AiwgAiACKAJwIgQ2AjAgAiACKAJ0IgE2AjQgHyADQQNxQQFrICBBAWtsQQRtwGpBAm8hHwwBCwtBf0EBIB8bIQQLIAJBgAFqJAAgBAuVAgEGfyMAQTBrIgEkACABQYCnKTYCICAAQfmGKiABQSBqEJsBQb3hKyEEAkAgAEEBEM4CIgVFDQAgBS8BFEUEQEGqnSohBAwBCyAAQQIQzgIiA0UEQEEAIQMMAQtBta8qIQQgAy8BFA0AQQEhBiAAQRhBARDaASECIABB2OHOfUGx8CoQkAEaIABBfhDbAUEAIQQgAkEAOwEUIAJCIDcCCCACQQA2AhAgAkEBOgAAIAAgAhDIAiACKAIMIAMoAgwgBSgCEBDJAgwACyADENACIAUQ0AIgBkUEQCABIAQ2AhQgAUGApyk2AhAgAEH8iCogAUEQahBsAAsgAUGApyk2AgAgAEHghyogARCbASABQTBqJABBAQufAQECfyMAQTBrIgEkACABQcKnKTYCICAAQfmGKiABQSBqEJsBIABBARDOAiICRQRAIAFBveErNgIEIAFBwqcpNgIAIABB/IgqIAEQbAALIAAoAgxBEUEBIAIoAgwoAgBBgYCAgHhxQQFGGzoABCAAIAAoAgxBCGo2AgwgAhDQAiABQcKnKTYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC4cIAQ1/IwBBMGsiBSQAIAVBo+IpNgIgIABB+YYqIAVBIGoQmwEgACgCDCEBIAAoAhQoAgAhAwJAIABBARDOAiIKRQRAQb3hKyECDAELIAAgChDdASIIRQRAQfvgKyECDAELIAVBADYCLAJ/AkACfyAAKAIUKAIAQRBqIgIgACgCDE8EQCAAKAIQQSxqIQILIAItAARBA0YEQCACKAIADAELIAIgBUEsakEAEPwBRQ0BIAUoAiwLIQkgASADa0EIa0ERTgRAIAAoAhQoAgBBGGoiAiAAKAIMTwR/IAAoAhBBLGoFIAILLQAEIgJBAUYgAkEPcUVyIQsLAkAgCCgCACIEIAlIBEBB6OQpIAAgCRCGASICRQ0DGkEAIQECQCAEQQBMBEAgCSAEayEDDAELIARBA3EhDCAJIARrIQMgCCgCCCEHIARBBE8EQCAEQfz///8HcSENQQAhBANAIAIoAgggA2ogAWogASAHai0AADoAACABQQFyIgYgAigCCCADamogBiAHai0AADoAACABQQJyIgYgAigCCCADamogBiAHai0AADoAACABQQNyIgYgAigCCCADamogBiAHai0AADoAACABQQRqIQEgBEEEaiIEIA1HDQALCyAMRQ0AQQAhBANAIAIoAgggA2ogAWogASAHai0AADoAACABQQFqIQEgBEEBaiIEIAxHDQALC0EBIAMgA0EBTBsiBkEDcSEEQQAhB0EAIQEgA0EETgRAIAZB/P///wdxIQZBACEDA0AgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBGohASADQQRqIgMgBkcNAAsLIAQEQANAIAIoAgggAWpBADoAACABQQFqIQEgB0EBaiIHIARHDQALCyACIAk2AgAMAQsgACAEEIYBIgJFBEBBACECIABB6dsrQQAQbgwBCyACKAIEIgNBAEoEQEEAIQEDQCACKAIIIAFqQQA6AAAgAUEBaiIBIAIoAgQiA0gNAAsLIAIgBCADIAMgBEobIgE2AgAgAUEATA0AIAgoAgghA0EAIQEDQCACKAIIIAFqIAEgA2otAAA6AAAgAUEBaiIBIAIoAgBIDQALCyAIEJoBAkAgC0UNACACKAIAIgFBAkgNACABQQFrIQNBACEBA0AgAigCCCIHIANqIgQtAAAhBiAEIAEgB2otAAA6AAAgAigCCCABaiAGOgAAIAFBAWoiASADQQFrIgNIDQALCyAKENACIAVBo+IpNgIQIABB4IcqIAVBEGoQmwEgBUEwaiQAQQEPC0H9nioLIQIgCBCaAQsgChDQAiAFIAI2AgQgBUGj4ik2AgAgAEH8iCogBRBsAAujBwEOfyMAQTBrIgMkACADQemMKjYCICAAQfmGKiADQSBqEJsBAkACQCAAQQEQzgIiCAR/IANBADYCLAJAAn8gACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCAAwBCyABIANBLGpBABD8AUUNASADKAIsCyEFIAAgCBCXAyICKAIMIQEgCC8BFEUNAiABEJgDQRsgBUEdbSIHayEJIAdBY2wgBWohBiACKAIMIQQCQCAFQY8GTgRAIAQgCUECdGogBCgCbCAGdTYCAAwBC0EdIAZrIQogBCAHQQJ0aiELQQEgCSAJQQFMGyICQQFxIQxBACEBIAVB8QVMBEAgAkH+////B3EhDQNAIAQgAUECdCICaiACIAtqIg4oAgQgCnRB/////wFxIA4oAgAgBnVyNgIAIAQgAkEEciICaiACIAtqIgIoAgQgCnRB/////wFxIAIoAgAgBnVyNgIAIAFBAmoiASANRw0ACwsgDARAIAQgAUECdCIBaiABIAtqIgEoAgQgCnRB/////wFxIAEoAgAgBnVyNgIACyAEIAlBAnRqIAQoAmwgBnU2AgAgBUEdSA0ECyAHQRtBHCAHayIBIAFBG0wbakECdEHsAGsiAUUNAyAEIAdBAnRrQfAAakEAIAH8CwAMAwtB3p8qBUG94SsLIQEgCBDQAiADIAE2AgQgA0HpjCo2AgAgAEH8iCogAxBsAAsgASABKAIAIgJB/////wFxNgIAIAEgASgCBCACQR11aiICQf////8BcTYCBCABIAEoAgggAkEddWoiAkH/////AXE2AgggASABKAIMIAJBHXVqIgJB/////wFxNgIMIAEgASgCECACQR11aiICQf////8BcTYCECABIAEoAhQgAkEddWoiAkH/////AXE2AhQgASABKAIYIAJBHXVqIgJB/////wFxNgIYIAEgASgCHCACQR11aiICQf////8BcTYCHCABIAEoAiAgAkEddWoiAkH/////AXE2AiAgASABKAIkIAJBHXVqIgJB/////wFxNgIkIAEgASgCKCACQR11aiICQf////8BcTYCKCABIAEoAiwgAkEddWoiAkH/////AXE2AiwgASABKAIwIAJBHXVqIgJB/////wFxNgIwIAEgASgCNCACQR11ajYCNCABIAUQxAMLIAgQ0AIgA0HpjCo2AhAgAEHghyogA0EQahCbASADQTBqJABBAQvXAgEKf0ENIAFBHW0iBWshBiAFQWNsIAFqIQQCQAJAIAFB+AJMBEBBHSAEayEHIAAgBUECdGohCEEBIAYgBkEBTBsiA0EBcSEJIAFB2wJMBEAgA0H+////B3EhCgNAIAAgAkECdCIDaiADIAhqIgsoAgQgB3RB/////wFxIAsoAgAgBHVyNgIAIAAgA0EEciIDaiADIAhqIgMoAgQgB3RB/////wFxIAMoAgAgBHVyNgIAIAJBAmoiAiAKRw0ACwsgCQRAIAAgAkECdCICaiACIAhqIgIoAgQgB3RB/////wFxIAIoAgAgBHVyNgIACyAAIAZBAnRqIAAoAjQgBHU2AgAgAUEdTg0BDAILIAFBlQNLDQAgACAGQQJ0aiAAKAI0IAR1NgIACyAFQQ1BDiAFayICIAJBDUwbakECdEE0ayICRQ0AIAAgBUECdGtBOGpBACAC/AsACwvTBQIDfwF7IwBBMGsiAyQAIANBnvAqNgIgIABB+YYqIANBIGoQmwECfyAAQQJBsfAqENwBIgIEQCAAQc24K0EAEJwBIABBGEEBENoBIQEgAEHY4c59QbHwKhCQARogAEF+ENsBIAFBADsBFCABQiA3AgggAUEANgIQIAFBAToAACAAIAEQyAIgASgCDCACKAIMQZCWNCgCACgCJBDGA0EBDAELIANBADYCLAJAAn8gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCAAwBCyABIANBLGpBABD8AUUNASADKAIsCyECIABBGEEBENoBIQEgAEHY4c59QbHwKhCQARogAEF+ENsBIAFBADsBFCABQiA3AgggAUEANgIQIAFBAToAACAAIAEQyAIgASgCDCIA/QwAAAAAAAAAAAAAAAAAAAAA/QsCKCAAIAT9CwIYIAAgBP0LAgggACACQQAgAkEAShsiAUEddjYCBCAAIAFB/////wFxNgIAQQEMAQsCQAJ/IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQ9xIgINACABIAAoAhBBLGpHDQBBAAwBCyACQQFqC0ECdEHwsS9qKAIAIgEQJ0EGSQ0AQYagKiABQQYQxQFFBEAgAEG69ilBABBuQQAMAgtB+O0qIAFBBhDFAQ0AIAAQxwMMAQsCQCAAQQEQyAEiAgR/IAIoAgBBMUgNAUGjvysFQf/kKQshASACEJoBIAMgATYCBCADQZ7wKjYCACAAQfyIKiADEGwACyAAQRhBARDaASEBIABB2OHOfUGx8CoQkAEaIABBfhDbASABQQA7ARQgAUIgNwIIIAFBADYCECABQQE6AAAgACABIAIQ4gIaIAIQmgEgA0Ge8Co2AhAgAEHghyogA0EQahCbAUEBCyECIANBMGokACACC6sHATl/IwBB8ABrIgMkAANAICAgARCwA0EBdE5FBEACfyAhRQRAIAIQaQwBCyAiQQF2CyEiIB9BAXQgHkEcdXIhHyAEQRx2ISMgBUEcdSEkIAZBHHUhJSAHQRx1ISYgCEEcdSEnIAlBHHUhKCAKQRx1ISkgC0EcdSEqIAxBHHUhKyANQRx1ISwgDkEcdSEtIA9BHHUhLiAQQRx1IS8gEUEcdSEwIBJBHHUhMSATQRx1ITIgFEEcdSEzIBVBHHUhNCAWQRx1ITUgF0EcdSE2IBhBHHUhNyAZQRx1ITggGkEcdSE5IBtBHHUhOiAcQRx1ITsgHkEBdEH+////AXEgHUEcdXIhHiAgQQFqISAgIUEBakEHcSEhIARBAXRB/v///wFxICJBAXFyIQQgIyAFQQF0Qf7///8BcXIhBSAkIAZBAXRB/v///wFxciEGICUgB0EBdEH+////AXFyIQcgJiAIQQF0Qf7///8BcXIhCCAnIAlBAXRB/v///wFxciEJICggCkEBdEH+////AXFyIQogKSALQQF0Qf7///8BcXIhCyAqIAxBAXRB/v///wFxciEMICsgDUEBdEH+////AXFyIQ0gLCAOQQF0Qf7///8BcXIhDiAtIA9BAXRB/v///wFxciEPIC4gEEEBdEH+////AXFyIRAgLyARQQF0Qf7///8BcXIhESAwIBJBAXRB/v///wFxciESIDEgE0EBdEH+////AXFyIRMgMiAUQQF0Qf7///8BcXIhFCAzIBVBAXRB/v///wFxciEVIDQgFkEBdEH+////AXFyIRYgNSAXQQF0Qf7///8BcXIhFyA2IBhBAXRB/v///wFxciEYIDcgGUEBdEH+////AXFyIRkgOCAaQQF0Qf7///8BcXIhGiA5IBtBAXRB/v///wFxciEbIDogHEEBdEH+////AXFyIRwgOyAdQQF0Qf7///8BcXIhHQwBCwsgAyAeNgJoIAMgHzYCbCADIB02AmQgAyAcNgJgIAMgGzYCXCADIBo2AlggAyAZNgJUIAMgGDYCUCADIBc2AkwgAyAWNgJIIAMgFTYCRCADIBQ2AkAgAyATNgI8IAMgEjYCOCADIBE2AjQgAyAQNgIwIAMgDzYCLCADIA42AiggAyANNgIkIAMgCzYCHCADIAw2AiAgAyAKNgIYIAMgCTYCFCADIAg2AhAgAyAHNgIMIAMgBjYCCCADIAU2AgQgAyAENgIAIAAgAyABEKYDIANB8ABqJAALywkCFX8BeyMAQfAAayIEJAAgBEGZ6yo2AiAgAEH5hiogBEEgahCbASAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELAkACQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgEgACgCDEkNACAAKAIQQSxqIQELIAEoAgAhAkEBIRQgAEEYQQEQ2gEhBSAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgBUEAOwEUIAVCIDcCCCAFQQA2AhAgBUEBOgAAIAAgBRDIAiAFKAIMIgH9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFCADcCMCABIBb9CwIgIAEgFv0LAhAgBUF/QQEgAi0AEEEtRiITGzoAAAJAIAJBEGoiFSATaiIGLQAARQRAQQAhAgwBC0EAIQIDQCAEIAM2AmQgBCAHNgJgIAQgCDYCXCAEIAk2AlggBCAKNgJUIAQgCzYCUCAEIAw2AkwgBCANNgJIIAQgDjYCRCAEIA82AkAgBCAQNgI8IAQgETYCOCAEIBI2AjQgBCACNgIwIAEgBEEwakEKEMgDIAYtAAAiAkE6a0H/AXFB9QFNDQMgBSgCDCIBIAEoAgQgASgCACIGQR11aiIDQf////8BcSISNgIEIAEgASgCCCADQR11aiIDQf////8BcSIRNgIIIAEgASgCDCADQR11aiIDQf////8BcSIQNgIMIAEgASgCECADQR11aiIDQf////8BcSIPNgIQIAEgASgCFCADQR11aiIDQf////8BcSIONgIUIAEgASgCGCADQR11aiIDQf////8BcSINNgIYIAEgASgCHCADQR11aiIDQf////8BcSIMNgIcIAEgASgCICADQR11aiIDQf////8BcSILNgIgIAEgASgCJCADQR11aiIDQf////8BcSIKNgIkIAEgASgCKCADQR11aiIDQf////8BcSIJNgIoIAEgASgCLCADQR11aiIDQf////8BcSIINgIsIAEgASgCMCADQR11aiIDQf////8BcSIHNgIwIAEgASgCNCADQR11aiIDNgI0IAEgBkH/////AXEgAkEwa0H/AXFqIgI2AgAgFSATQQFqIhNqIgYtAAANAAsLIAEgAkH/////AXE2AgAgASASIAJBHXZqIgJB/////wFxNgIEIAEgESACQR12aiICQf////8BcTYCCCABIBAgAkEddmoiAkH/////AXE2AgwgASAPIAJBHXZqIgJB/////wFxNgIQIAEgDiACQR12aiICQf////8BcTYCFCABIA0gAkEddmoiAkH/////AXE2AhggASAMIAJBHXZqIgJB/////wFxNgIcIAEgCyACQR12aiICQf////8BcTYCICABIAogAkEddmoiAkH/////AXE2AiQgASAJIAJBHXZqIgJB/////wFxNgIoIAEgCCACQR12aiICQf////8BcTYCLCABIAcgAkEddmoiAkH/////AXE2AjAgASADIAJBHXZqNgI0IARBmesqNgIAIABB4IcqIAQQmwELIARB8ABqJAAgFA8LIAQgFTYCFCAEQZnrKjYCECAAQZeGKiAEQRBqEG4gAEGNsytBABBsAAu8AwECfiAAIAKsIgQgATQCAH4iA6dB/////wFxNgIAIAAgATQCBCAEfiADQgOGQiCHfCIDp0H/////AXE2AgQgACABNAIIIAR+IANCA4ZCIId8IgOnQf////8BcTYCCCAAIAE0AgwgBH4gA0IDhkIgh3wiA6dB/////wFxNgIMIAAgATQCECAEfiADQgOGQiCHfCIDp0H/////AXE2AhAgACABNAIUIAR+IANCA4ZCIId8IgOnQf////8BcTYCFCAAIAE0AhggBH4gA0IDhkIgh3wiA6dB/////wFxNgIYIAAgATQCHCAEfiADQgOGQiCHfCIDp0H/////AXE2AhwgACABNAIgIAR+IANCA4ZCIId8IgOnQf////8BcTYCICAAIAE0AiQgBH4gA0IDhkIgh3wiA6dB/////wFxNgIkIAAgATQCKCAEfiADQgOGQiCHfCIDp0H/////AXE2AiggACABNAIsIAR+IANCA4ZCIId8IgOnQf////8BcTYCLCAAIAE0AjAgBH4gA0IDhkIgh3wiA6dB/////wFxNgIwIAAgATQCNCAEfiADQgOGQiCHfKdB/////wFxNgI0C9QBAQR/IwBBMGsiASQAIAFB+6wrNgIgIABB+YYqIAFBIGoQmwFBkJY0KAIAIQQgAEEBEM4CIQMgAEEYQQEQ2gEhAiAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgAkEAOwEUIAJCIDcCCCACQQA2AhAgAkEBOgAAIANFBEAgAUGQhCo2AgQgAUH7rCs2AgAgAEH8iCogARBsAAsgACACEMgCIAIoAgwgAygCDCAEKAIkEMYDIAMQ0AIgAUH7rCs2AhAgAEHghyogAUEQahCbASABQTBqJABBAQubAQECfyMAQSBrIgIkACACQczEKjYCECAAQfmGKiACQRBqEJsBIABBGEEBENoBIQEgAEHY4c59QbHwKhCQARogAEF+ENsBIAFBADsBFCABQiA3AgggAUEANgIQIAFBAToAACAAIAEQyAIgASgCDEHAxC9BkJY0KAIAKAIkEMYDIAJBzMQqNgIAIABB4IcqIAIQmwEgAkEgaiQAQQEL/CcBIn8jAEHgBmsiASQAIAFBwM8pNgIgIABB+YYqIAFBIGoQmwFBveErIQIgAEEBEM4CIRggAEECEM4CIRkCQCAYRQ0AIBlFDQBBt/cpIQIgGC8BFA0AIBkvARQNAEHPpyohAiAYKAIMIBkoAgwQvwNBAUcNACAAQRhBARDaASEWIABB2OHOfUGx8CoQkAEaIABBfhDbASAWQQA7ARQgFkIgNwIIIBZBADYCECAWQQE6AAAgACAWEMgCIBYoAgwhCCAYKAIMIRsgGSgCDCEHIAFCADcD4AQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNAEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTABCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAQgAUEENgKwBCABIAcoAgAiAjYC8AQgASAHKAIEIhQ2AvQEIAEgBygCCCIPNgL4BCABIAcoAgwiCTYC/AQgASAHKAIQIhA2AoAFIAEgBygCFCIKNgKEBSABIAcoAhgiETYCiAUgASAHKAIcIgs2AowFIAEgBygCICISNgKQBSABIAcoAiQiDDYClAUgASAHKAIoIhM2ApgFIAEgBygCLCIONgKcBSABIAcoAjAiDTYCoAUgASAHKAI0IgU2AqQFIAFB8ARqIAFBsARqENsCAkACQAJAIAEoAvQEDQAgASgC+AQNACABKAL8BA0AIAEoAoAFDQAgASgChAUNACABKAKIBQ0AIAEoAowFDQAgASgCkAUNACABKAKUBQ0AIAEoApgFDQAgASgCnAUNACABKAKgBQ0AIAEoAqQFDQAgASgC8ARBAUYNAQsgASAFNgKkBiABIA02AqAGIAEgDjYCnAYgASATNgKYBiABIAw2ApQGIAEgEjYCkAYgASALNgKMBiABIBE2AogGIAEgCjYChAYgASAQNgKABiABIAk2AvwFIAEgDzYC+AUgASAUNgL0BSABIAI2AvAFIAFB8AVqIgYgBigCBCAGKAIAIgRBHXVqIgVB/////wFxNgIEIAYgBigCCCAFQR11aiIFQf////8BcTYCCCAGIAYoAgwgBUEddWoiBUH/////AXE2AgwgBiAGKAIQIAVBHXVqIgVB/////wFxNgIQIAYgBigCFCAFQR11aiIFQf////8BcTYCFCAGIAYoAhggBUEddWoiBUH/////AXE2AhggBiAGKAIcIAVBHXVqIgVB/////wFxNgIcIAYgBigCICAFQR11aiIFQf////8BcTYCICAGIAYoAiQgBUEddWoiBUH/////AXE2AiQgBiAGKAIoIAVBHXVqIgVB/////wFxNgIoIAYgBigCLCAFQR11aiIFQf////8BcTYCLCAGIAYoAjAgBUEddWoiBUH/////AXE2AjAgBiAGKAI0IAVBHXVqNgI0IAYgBEH/////AXFBAWo2AgAgAUHwBWpBAhDEAyAIIBsgAUHwBWogBxC9AwwBCyABIAJB/////wFxQQFrIgM2AvADIAEgFCACQR11aiICQf////8BcSIVNgL0AyABIA8gAkEddWoiAkH/////AXEiBDYC+AMgASAJIAJBHXVqIgJB/////wFxIhc2AvwDIAEgECACQR11aiICQf////8BcSIaNgKABCABIAogAkEddWoiAkH/////AXEiHDYChAQgASARIAJBHXVqIgJB/////wFxIh02AogEIAEgCyACQR11aiICQf////8BcSIeNgKMBCABIBIgAkEddWoiAkH/////AXEiHzYCkAQgASAMIAJBHXVqIgJB/////wFxIiA2ApQEIAEgEyACQR11aiICQf////8BcSIhNgKYBCABIA4gAkEddWoiAkH/////AXEiIjYCnAQgASANIAJBHXVqIgJB/////wFxIgY2AqAEIAEgBSACQR11aiICNgKkBEEAIQUDQCAGIRQgIiEPICEhCSAgIRAgHyEKIB4hESAdIQsgHCESIBohDCAXIRMgBCEOIBUhDSADQQFxRQRAIAJBHHRBgICAgAFxIAZBAXZyIQYgFEEcdEGAgICAAXEgD0EBdnIhIiAPQRx0QYCAgIABcSAJQQF2ciEhIAlBHHRBgICAgAFxIBBBAXZyISAgEEEcdEGAgICAAXEgCkEBdnIhHyAKQRx0QYCAgIABcSARQQF2ciEeIBFBHHRBgICAgAFxIAtBAXZyIR0gC0EcdEGAgICAAXEgEkEBdnIhHCASQRx0QYCAgIABcSAMQQF2ciEaIAxBHHRBgICAgAFxIBNBAXZyIRcgE0EcdEGAgICAAXEgBEEBdnIhBCAOQRx0QYCAgIABcSANQQF2ciEVIA1BHHRBgICAgAFxIANBAXVyIQMgBUEBaiEFIAJBAXUhAgwBCwsgASACNgKkBCABIAY2AqAEIAEgIjYCnAQgASAhNgKYBCABICA2ApQEIAEgHzYCkAQgASAeNgKMBCABIB02AogEIAEgHDYChAQgASAaNgKABCABIBc2AvwDIAEgBDYC+AMgASAVNgL0AyABIAM2AvADIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwLEAyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsC1AMgAUEANgLkAyABQQE2ArADIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwK0AwNAIAEgASgCtAMgASgCsAMiFUEddWoiBEH/////AXE2ArQDIAEgASgCuAMgBEEddWoiBEH/////AXE2ArgDIAEgASgCvAMgBEEddWoiBEH/////AXE2ArwDIAEgASgCwAMgBEEddWoiBEH/////AXE2AsADIAEgASgCxAMgBEEddWoiBEH/////AXE2AsQDIAEgASgCyAMgBEEddWoiBEH/////AXE2AsgDIAEgASgCzAMgBEEddWoiBEH/////AXE2AswDIAEgASgC0AMgBEEddWoiBEH/////AXE2AtADIAEgASgC1AMgBEEddWoiBEH/////AXE2AtQDIAEgASgC2AMgBEEddWoiBEH/////AXE2AtgDIAEgASgC3AMgBEEddWoiBEH/////AXE2AtwDIAEgASgC4AMgBEEddWoiBEH/////AXE2AuADIAEgASgC5AMgBEEddWo2AuQDIAEgFUH/////AXFBAWo2ArADIAFBsANqIAcQvwNBAUYNAAsgAUHwAmogAUGwA2ogAUHwA2ogBxC9AyABQbACaiAbIAFB8ANqIAcQvQMgASAOIA0gA0EddWoiDUEddWoiDkEcdEGAgICAAXEgDUH+////AXFBAXZyNgK0ASABIA1BHHRBgICAgAFxIANB/////wFxQQFqQQF2cjYCsAEgASATIA5BHXVqIgNBHHRBgICAgAFxIA5B/v///wFxQQF2cjYCuAEgASAMIANBHXVqIgxBHHRBgICAgAFxIANB/v///wFxQQF2cjYCvAEgASASIAxBHXVqIgNBHHRBgICAgAFxIAxB/v///wFxQQF2cjYCwAEgASALIANBHXVqIgtBHHRBgICAgAFxIANB/v///wFxQQF2cjYCxAEgASARIAtBHXVqIgNBHHRBgICAgAFxIAtB/v///wFxQQF2cjYCyAEgASAKIANBHXVqIgpBHHRBgICAgAFxIANB/v///wFxQQF2cjYCzAEgASAQIApBHXVqIgNBHHRBgICAgAFxIApB/v///wFxQQF2cjYC0AEgASAJIANBHXVqIglBHHRBgICAgAFxIANB/v///wFxQQF2cjYC1AEgASAPIAlBHXVqIgNBHHRBgICAgAFxIAlB/v///wFxQQF2cjYC2AEgASAUIANBHXVqIhRBHHRBgICAgAFxIANB/v///wFxQQF2cjYC3AEgASACIBRBHXVqIgNBAXU2AuQBIAEgA0EcdEGAgICAAXEgFEH+////AXFBAXZyNgLgASABQfABaiAbIAFBsAFqIAcQvQMCQCABKAKwAg0AIAEoArQCDQAgASgCuAINACABKAK8Ag0AIAEoAsACDQAgASgCxAINACABKALIAg0AIAEoAswCDQAgASgC0AINACABKALUAg0AIAEoAtgCDQAgASgC3AINACABKALgAg0AIAEoAuQCDQAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgCEIANwIwIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwIgIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwIQDAELA0ACQCABKAK4AiEDAkAgASgCtAIiDwRAIAEoArwCIQIMAQsgAyABKAK8AiICcg0AQQAhAiABKALAAg0AIAEoAsQCDQAgASgCyAINACABKALMAg0AIAEoAtACDQAgASgC1AINACABKALYAg0AIAEoAtwCDQAgASgC4AINACABKALkAg0AIAEoArACQQFGDQELIAEgAjYCfCABIAM2AnggASAPNgJ0IAEgASgCsAIiCTYCcCABIAEoAsACIhA2AoABIAEgASgCxAIiCjYChAEgASABKALIAiIRNgKIASABIAEoAswCIgs2AowBIAEgASgC0AIiEjYCkAEgASABKALUAiIMNgKUASABIAEoAtgCIhM2ApgBIAEgASgC3AIiDjYCnAEgASABKALgAiINNgKgASABIAEoAuQCIhU2AqQBQQAhBCAFQQJrIhohFANAIAEgFTYC5AUgASANNgLgBSABIA42AtwFIAEgEzYC2AUgASAMNgLUBSABIBI2AtAFIAEgCzYCzAUgASARNgLIBSABIAo2AsQFIAEgEDYCwAUgASACNgK8BSABIAM2ArgFIAEgDzYCtAUgASAJNgKwBSABQbAFaiAHENsCIAFB8AVqIAFBsAVqELQDIAFB8ABqIAFB8AVqIAcQpgMgBEEBaiEFIAEoAnghAwJ/AkAgASgCdCIPBEAgASgCfCECDAELIAMgASgCfCICcg0AQQAhAiABKAKAAQ0AIAEoAoQBDQAgASgCiAENACABKAKMAQ0AIAEoApABDQAgASgClAENACABKAKYAQ0AIAEoApwBDQAgASgCoAENACABKAKkAQ0AQQAhDUEAIQ5BACETQQAhDEEAIRJBACELQQAhEUEAIQpBACEQQQAhA0EAIAEoAnAiCUEBRw0BGiABIAEoAvACIhc2AjAgASABKAL0AiIVNgI0IAEgASgC+AIiDTYCOCABIAEoAvwCIg42AjwgASABKAKAAyITNgJAIAEgASgChAMiDDYCRCABIAEoAogDIhI2AkggASABKAKMAyILNgJMIAEgASgCkAMiETYCUCABIAEoApQDIgo2AlQgASABKAKYAyIQNgJYIAEgASgCnAMiCTYCXCABIAEoAqADIg82AmAgASABKAKkAyICNgJkIBogBGtBAEoEQANAIAEgASgCMDYCsAUgASAB/QACNP0LArQFIAEgAf0AAkT9CwLEBSABIAH9AAJU/QsC1AUgASABKAJkNgLkBSABQbAFaiAHENsCIAFB8AVqIAFBsAVqELQDIAFBMGogAUHwBWogBxCmAyADQQFqIgMgFEcNAAsgASgCZCECIAEoAmAhDyABKAJcIQkgASgCWCEQIAEoAlQhCiABKAJQIREgASgCTCELIAEoAkghEiABKAJEIQwgASgCQCETIAEoAjwhDiABKAI4IQ0gASgCNCEVIAEoAjAhFwsgASACNgLkBSABIA82AuAFIAEgCTYC3AUgASAQNgLYBSABIAo2AtQFIAEgETYC0AUgASALNgLMBSABIBI2AsgFIAEgDDYCxAUgASATNgLABSABIA42ArwFIAEgDTYCuAUgASAVNgK0BSABIBc2ArAFIAFBsAVqIAcQ2wIgAUHwBWogAUGwBWoQtAMgAUHwAmogAUHwBWogBxCmAyABQbACaiABQbACaiABQfACaiAHEKQDIAFB8AFqIAFB8AFqIAFBMGogBxCkAwwECyABKAKgASENIAEoApwBIQ4gASgCmAEhEyABKAKUASEMIAEoApABIRIgASgCjAEhCyABKAKIASERIAEoAoQBIQogASgCgAEhECABKAJwIQkgASgCpAELIRUgFEEBayEUIAUhBAwACwALCyAIIAEoAvABNgIAIAggASgC9AE2AgQgCCABKAL4ATYCCCAIIAEoAvwBNgIMIAggASgCgAI2AhAgCCABKAKEAjYCFCAIIAEoAogCNgIYIAggASgCjAI2AhwgCCABKAKQAjYCICAIIAEoApQCNgIkIAggASgCmAI2AiggCCABKAKcAjYCLCAIIAEoAqACNgIwIAggASgCpAI2AjQLIBYoAgwiAyADKAIAIgJB/////wFxNgIAIAMgAygCBCACQR11aiICQf////8BcTYCBCADIAMoAgggAkEddWoiAkH/////AXE2AgggAyADKAIMIAJBHXVqIgJB/////wFxNgIMIAMgAygCECACQR11aiICQf////8BcTYCECADIAMoAhQgAkEddWoiAkH/////AXE2AhQgAyADKAIYIAJBHXVqIgJB/////wFxNgIYIAMgAygCHCACQR11aiICQf////8BcTYCHCADIAMoAiAgAkEddWoiAkH/////AXE2AiAgAyADKAIkIAJBHXVqIgJB/////wFxNgIkIAMgAygCKCACQR11aiICQf////8BcTYCKCADIAMoAiwgAkEddWoiAkH/////AXE2AiwgAyADKAIwIAJBHXVqIgJB/////wFxNgIwIAMgAygCNCACQR11ajYCNEEAIQJBASEDCyAYENACIBkQ0AIgA0UEQCABIAI2AhQgAUHAzyk2AhAgAEH8iCogAUEQahBsAAsgAUHAzyk2AgAgAEHghyogARCbASABQeAGaiQAQQELxwMBA38jAEEgayIDJAAgA0H1qio2AhAgAEH5hiogA0EQahCbASAAQQBBABChASAAKAIMIgFBAzoABCABQQ42AgAgACAAKAIMIgFBCGo2AgwgAAJ/IAEgACgCFCgCACICSwRAIAJBCGoMAQsgACgCEEEsagtBq7wqEFkgACgCDCIBQQM6AAQgAUEcNgIAIAAgACgCDCIBQQhqNgIMIAACfyABIAAoAhQoAgAiAksEQCACQQhqDAELIAAoAhBBLGoLQaq8KhBZIAAoAgwiAUEDOgAEIAFBMDYCACAAIAAoAgwiAUEIajYCDCAAAn8gASAAKAIUKAIAIgJLBEAgAkEIagwBCyAAKAIQQSxqC0HL/ikQWSAAKAIMIgFBAzoABCABQTg2AgAgACAAKAIMIgFBCGo2AgwgAAJ/IAEgACgCFCgCACICSwRAIAJBCGoMAQsgACgCEEEsagtB5OArEFkgACgCDCIBQQM6AAQgAUHwADYCACAAIAAoAgwiAUEIajYCDCAAAn8gASAAKAIUKAIAIgJLBEAgAkEIagwBCyAAKAIQQSxqC0Hv4CsQWSADQfWqKjYCACAAQeCHKiADEJsBIANBIGokAEEBC7YBAQR/IwBBIGsiAiQAIAJBwbwpNgIQIABB+YYqIAJBEGoQmwEgAEEYQQEQ2gEhASAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgAUEAOwEUIAFCIDcCCCABQQA2AhAgAUEBOgAAIAAgARDIAiABKAIEQQBKBEAgASgCDCEEA0AgBCADQQJ0akF/NgIAIANBAWoiAyABKAIESA0ACwsgAkHBvCk2AgAgAEHghyogAhCbASACQSBqJABBAQvmAgEGfyMAQSBrIgMkACADQcWXKjYCECAAQfmGKiADQRBqEJsBAkACQAJAAkAgACgCFCgCAEEIaiIBIAAoAgwiBEkEQCABLQAEQQNHDQFBESECDAQLIAAoAhAtADBBA0cNAUERIQIMAwsgAS0ABEEPcUEFa0F+Tw0BQQEhAgwCCyAAKAIQLQAwQQ9xQQVrQX5JBEBBASECDAILIAAoAhBBLGohAQsCQCABLQAEQQ9xQQRGDQAgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiBEkNACAAKAIQQSxqIQELIAEoAgAiAUEQaiEFIAEtABBBLUYhAQNAIAEgBWotAAAiBkUEQEERIQIMAgtBASECIAFBAWohASAGQTprQf8BcUH1AUsNAAsLIAQgAjoABCAAIAAoAgxBCGo2AgwgA0HFlyo2AgAgAEHghyogAxCbASADQSBqJABBAQvaBwEHfyMAQTBrIgYkACAGQcm/KzYCICAAQfmGKiAGQSBqEJsBIABBARDOAiEEIABBAhDOAiEFIABBGEEBENoBIQcgAEHY4c59QbHwKhCQARogAEF+ENsBIAdBADsBFCAHQiA3AgggB0EANgIQIAdBAToAAAJ/AkACQCAERQ0AIAVFDQAgACAHEMgCIAQtAAAgBS0AAEYEQCAHKAIMIgMgBSgCDCIBKAIAIAQoAgwiAigCAGo2AgAgAyABKAIEIAIoAgRqNgIEIAMgASgCCCACKAIIajYCCCADIAEoAgwgAigCDGo2AgwgAyABKAIQIAIoAhBqNgIQIAMgASgCFCACKAIUajYCFCADIAEoAhggAigCGGo2AhggAyABKAIcIAIoAhxqNgIcIAMgASgCICACKAIgajYCICADIAEoAiQgAigCJGo2AiQgAyABKAIoIAIoAihqNgIoIAMgASgCLCACKAIsajYCLCADIAEoAjAgAigCMGo2AjAgASgCNCACKAI0aiEBIAQMAwsgBCAFEKoDIQEgBygCDCEDIAFBAEwNASADIAQoAgwiASgCACAFKAIMIgIoAgBrNgIAIAMgASgCBCACKAIEazYCBCADIAEoAgggAigCCGs2AgggAyABKAIMIAIoAgxrNgIMIAMgASgCECACKAIQazYCECADIAEoAhQgAigCFGs2AhQgAyABKAIYIAIoAhhrNgIYIAMgASgCHCACKAIcazYCHCADIAEoAiAgAigCIGs2AiAgAyABKAIkIAIoAiRrNgIkIAMgASgCKCACKAIoazYCKCADIAEoAiwgAigCLGs2AiwgAyABKAIwIAIoAjBrNgIwIAEoAjQgAigCNGshASAEDAILIAUQ0AIgBBDQAiAGQb3hKzYCFCAGQcm/KzYCECAAQfyIKiAGQRBqEGwACyADIAUoAgwiASgCACAEKAIMIgIoAgBrNgIAIAMgASgCBCACKAIEazYCBCADIAEoAgggAigCCGs2AgggAyABKAIMIAIoAgxrNgIMIAMgASgCECACKAIQazYCECADIAEoAhQgAigCFGs2AhQgAyABKAIYIAIoAhhrNgIYIAMgASgCHCACKAIcazYCHCADIAEoAiAgAigCIGs2AiAgAyABKAIkIAIoAiRrNgIkIAMgASgCKCACKAIoazYCKCADIAEoAiwgAigCLGs2AiwgAyABKAIwIAIoAjBrNgIwIAEoAjQgAigCNGshASAFCyECIAMgATYCNCAHIAItAAA6AAAgBRDQAiAEENACIAZByb8rNgIAIABB4IcqIAYQmwEgBkEwaiQAQQELtwMBCH8jAEEwayIDJAAgA0Gvqis2AiAgAEH5hiogA0EgahCbAUG94SshByAAQQEQzgIhBSAAQQIQzgIhBgJAIAVFDQAgBkUNAEHF+SkhByAFLwEUDQAgBi8BFA0AQY/5KSEHIAUtAABB/wFGDQAgBi0AAEH/AUYNAEEBIQggAEEYQQEQ2gEhBCAAQdjhzn1BsfAqEJABGiAAQX4Q2wFBACEHIARBADsBFCAEQiA3AgggBEEANgIQIARBAToAACAAIAQQyAIgBCgCDCIBIAUoAgwiAigCADYCACABIAIoAgQ2AgQgASACKAIINgIIIAEgAigCDDYCDCABIAIoAhA2AhAgASACKAIUNgIUIAEgAigCGDYCGCABIAIoAhw2AhwgASACKAIgNgIgIAEgAigCJDYCJCABIAIoAig2AiggASACKAIsNgIsIAEgAigCMDYCMCABIAIoAjQ2AjQgASAGKAIMENsCIARBAToAAAsgBhDQAiAFENACIAhFBEAgAyAHNgIUIANBr6orNgIQIABB/IgqIANBEGoQbAALIANBr6orNgIAIABB4IcqIAMQmwEgA0EwaiQAQQELhwEBA38jAEEwayIBJAAgAUGF/yo2AiAgAEH5hiogAUEgahCbASAAQQEQzgIiAkUEQCABQb3hKzYCBCABQYX/KjYCACAAQfyIKiABEGwACyAAIAIQlwMiA0EAIAMtAABrOgAAIAIQ0AIgAUGF/yo2AhAgAEHghyogAUEQahCbASABQTBqJABBAQv8BwEIfyMAQTBrIgYkACAGQZ/JKzYCICAAQfmGKiAGQSBqEJsBIABBARDOAiEFIABBAhDOAiEEIABBGEEBENoBIQcgAEHY4c59QbHwKhCQARogAEF+ENsBIAdBADsBFCAHQiA3AgggB0EANgIQIAdBAToAAEG94SshAiAFQQBHIARBAEdxIggEQCAAIAcQyAIgBEEAIAQtAABrIgI6AAACfyAFLQAAIAJB/wFxRgRAIAcoAgwiAiAEKAIMIgEoAgAgBSgCDCIDKAIAajYCACACIAEoAgQgAygCBGo2AgQgAiABKAIIIAMoAghqNgIIIAIgASgCDCADKAIMajYCDCACIAEoAhAgAygCEGo2AhAgAiABKAIUIAMoAhRqNgIUIAIgASgCGCADKAIYajYCGCACIAEoAhwgAygCHGo2AhwgAiABKAIgIAMoAiBqNgIgIAIgASgCJCADKAIkajYCJCACIAEoAiggAygCKGo2AiggAiABKAIsIAMoAixqNgIsIAIgASgCMCADKAIwajYCMCABKAI0IAMoAjRqIQEgBQwBCyAFIAQQqgMhASAHKAIMIQIgAUEASgRAIAIgBSgCDCIBKAIAIAQoAgwiAygCAGs2AgAgAiABKAIEIAMoAgRrNgIEIAIgASgCCCADKAIIazYCCCACIAEoAgwgAygCDGs2AgwgAiABKAIQIAMoAhBrNgIQIAIgASgCFCADKAIUazYCFCACIAEoAhggAygCGGs2AhggAiABKAIcIAMoAhxrNgIcIAIgASgCICADKAIgazYCICACIAEoAiQgAygCJGs2AiQgAiABKAIoIAMoAihrNgIoIAIgASgCLCADKAIsazYCLCACIAEoAjAgAygCMGs2AjAgASgCNCADKAI0ayEBIAUMAQsgAiAEKAIMIgEoAgAgBSgCDCIDKAIAazYCACACIAEoAgQgAygCBGs2AgQgAiABKAIIIAMoAghrNgIIIAIgASgCDCADKAIMazYCDCACIAEoAhAgAygCEGs2AhAgAiABKAIUIAMoAhRrNgIUIAIgASgCGCADKAIYazYCGCACIAEoAhwgAygCHGs2AhwgAiABKAIgIAMoAiBrNgIgIAIgASgCJCADKAIkazYCJCACIAEoAiggAygCKGs2AiggAiABKAIsIAMoAixrNgIsIAIgASgCMCADKAIwazYCMCABKAI0IAMoAjRrIQEgBAshAyACIAE2AjQgByADLQAAOgAAIARBACAELQAAazoAAEEAIQILIAQQ0AIgBRDQAiAIRQRAIAYgAjYCFCAGQZ/JKzYCECAAQfyIKiAGQRBqEGwACyAGQZ/JKzYCACAAQeCHKiAGEJsBIAZBMGokAEEBC5kEAQZ/IwBBoAFrIgEkACABQbTGKjYCICAAQfmGKiABQSBqEJsBQb3hKyECIABBARDOAiEEIABBAhDOAiEFAkAgBEUNACAFRQ0AQcX5KSECIAQvARQNACAFLwEUDQAgAEEYQQEQ2gEhAyAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgA0EAOwEUIANCIDcCCCADQQA2AhAgA0EBOgAAIAAgAxDIAiABQTBqIAQoAgwgBSgCDBDTAiADKAIMIgIgASgCMDYCACACIAEoAjQ2AgQgAiABKAI4NgIIIAIgASgCPDYCDCACIAEoAkA2AhAgAiABKAJENgIUIAIgASgCSDYCGCACIAEoAkw2AhwgAiABKAJQNgIgIAIgASgCVDYCJCACIAEoAlg2AiggAiABKAJcNgIsIAIgASgCYDYCMCACIAEoAmQ2AjRB5PAqIQIgASgCaA0AIAEoAmwNACABKAJwDQAgASgCdA0AIAEoAngNACABKAJ8DQAgASgCgAENACABKAKEAQ0AIAEoAogBDQAgASgCjAENACABKAKQAQ0AIAEoApQBDQAgASgCmAENACABKAKcAQ0AIAMgBS0AACAELQAAbDoAAEEAIQJBASEGCyAFENACIAQQ0AIgBkUEQCABIAI2AhQgAUG0xio2AhAgAEH8iCogAUEQahBsAAsgAUG0xio2AgAgAEHghyogARCbASABQaABaiQAQQEL8QMCBn8BeyMAQaABayIBJAAgAUGtwCk2AiAgAEH5hiogAUEgahCbAUG94SshBiAAQQEQzgIhBCAAQQIQzgIhBQJAIARFDQAgBUUNAEHF+SkhBiAELwEUDQAgBS8BFA0AIAEgBCgCDCICKAIANgIwIAEgAigCBDYCNCABIAIoAgg2AjggASACKAIMNgI8IAEgAigCEDYCQCABIAIoAhQ2AkQgASACKAIYNgJIIAEgAigCHDYCTCABIAIoAiA2AlAgASACKAIkNgJUIAEgAigCKDYCWCABIAIoAiw2AlwgASACKAIwNgJgIAIoAjQhAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCfCABIAf9CwKMAUEAIQYgAUEANgKcASABIAf9CwJsIAEgAkEddTYCaCABIAJB/////wFxNgJkQQEhAiAAQRhBARDaASEDIABB2OHOfUGx8CoQkAEaIABBfhDbASADQQA7ARQgA0IgNwIIIANBADYCECADQQE6AAAgACADEMgCIAMoAgwgAUEwaiAFKAIMEJ0DIAMgBS0AACAELQAAbDoAAAsgBRDQAiAEENACIAJFBEAgASAGNgIUIAFBrcApNgIQIABB/IgqIAFBEGoQbAALIAFBrcApNgIAIABB4IcqIAEQmwEgAUGgAWokAEEBC5UBAQJ/IwBBMGsiASQAIAFBufoqNgIgIABB+YYqIAFBIGoQmwEgAEEBEM4CIgJFBEAgAUG94Ss2AgQgAUG5+io2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAi0AAEEBRhs6AAQgACAAKAIMQQhqNgIMIAIQ0AIgAUG5+io2AhAgAEHghyogAUEQahCbASABQTBqJABBAQv/BAEFfyMAQSBrIgMkAAJAIAAgAUHR7isQ3AEiBARAAkBBpIg0KAIAIgIEQAJ/AkAgAigCFEHsBUkNACACKAIEIgFFDQAgAigCGCIFIAUoArAXQQFqNgKwFyACIAIoAhxBAWo2AhwgAiACKAIgQewFajYCICACIAIoAixB7AVqNgIsIAIgASgCADYCBEEIIQZBfwwBC0HsBRAqIgFFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKEHsBWo2AihBLCEGQewFCyEFIAIgBmoiAiACKAIAIAVqNgIADAELQewFECohAQsgAUUEQEEAIQEMAgsgASAEQewF/AoAACABKAIQQdQFRwRAAkACQEGkiDQoAgAiAkUNACADIAE2AhwgAigCACIEIAMoAhxLDQAgAygCHCAEIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASABQQAgAvwLAAwBCyABECsLIAEoAhAhASADQdQFNgIYIAMgATYCFCADQZXoKjYCECAAQbL3KyADQRBqEG5BACEBDAILIAEoAhRBIEYNAQJAAkBBpIg0KAIAIgJFDQAgAyABNgIcIAIoAgAiBCADKAIcSw0AIAMoAhwgBCACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNASACQXxxIgJFDQEgAUEAIAL8CwAMAQsgARArCyABKAIUIQEgA0EgNgIIIAMgATYCBCADQZXoKjYCACAAQYr3KyADEG5BACEBDAELQQAhASAAQYnZKUEAEG4LIANBIGokACABC4wFAQd/IwBBMGsiBCQAIARB5aMqNgIgIABB+YYqIARBIGoQmwFBASEDAkACQCAAQQEQ1gMiAkEARyAAQQIQ1gMiAUEAR3EiBgRAAkAgAkEYaiABQRhqENQCRQ0AIAJB1ABqIAFB1ABqENQCRQ0AIAJBkAFqIAFBkAFqENQCRQ0AIAJBzAFqIAFBzAFqENQCRQ0AIAJBiAJqIAFBiAJqENQCRQ0AIAJBxAJqIAFBxAJqENQCRQ0AIAJBgANqIAFBgANqENQCRQ0AIAJBvANqIAFBvANqENQCRQ0AAkAgAkH4A2ogAUH4A2oQ1AJFDQAgAkG0BGogAUG0BGoQ1AJFDQAgAkHwBGogAUHwBGoQ1AJFDQBBESEDIAJBrAVqIAFBrAVqENQCDQELQQEhAwsgACgCDCADOgAEIAAgACgCDEEIajYCDAwBC0He7ishBSABRQ0BCwJAQaSINCgCACIDRQ0AIAQgATYCLCADKAIAIgcgBCgCLEsNACAEKAIsIAcgAygCEGpPDQAgASADKAIENgIAIAMgATYCBCADIAMoAghBAWo2AgggAygCFCIDQQRJDQEgA0F8cSIDRQ0BIAFBACAD/AsADAELIAEQKwsCQCACRQ0AAkBBpIg0KAIAIgFFDQAgBCACNgIsIAEoAgAiAyAEKAIsSw0AIAQoAiwgAyABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgAkEAIAH8CwAMAQsgAhArCyAGRQRAIAQgBTYCFCAEQeWjKjYCECAAQfyIKiAEQRBqEGwACyAEQeWjKjYCACAAQeCHKiAEEJsBIARBMGokAEEBC4kEAQd/IwBBQGoiAyQAIANB88YqNgIwIABB+YYqIANBMGoQmwECQAJAIABBARDWAyIEQQBHIABBAhDWAyICQQBHcSIFBEAgAEHsBUEBENoBIQEgAEHY4c59QdHuKxCQARogAEF+ENsBIAFC1IWAgIAENwIQIAFBs+wrKAAANgADIAFBsOwrKAAANgAAIANB1AU2AiAgAEGr+CsgA0EgahBbIAFBGGoiASAEQRhqEJIDIAEgAkEYahCRAwwBC0He7ishBiACRQ0BCwJAAkBBpIg0KAIAIgFFDQAgAyACNgI8IAEoAgAiByADKAI8Sw0AIAMoAjwgByABKAIQak8NACACIAEoAgQ2AgAgASACNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgAkEAIAH8CwAMAQsgAhArCyAFIQELAkAgBEUNAAJAQaSINCgCACICRQ0AIAMgBDYCPCACKAIAIgUgAygCPEsNACADKAI8IAUgAigCEGpPDQAgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCICQQRJDQEgAkF8cSICRQ0BIARBACAC/AsADAELIAQQKwsgAUUEQCADIAY2AhQgA0Hzxio2AhAgAEH8iCogA0EQahBsAAsgA0Hzxio2AgAgAEHghyogAxCbASADQUBrJABBAQvbAgEEfyMAQUBqIgIkACACQaSNKjYCMCAAQfmGKiACQTBqEJsBAkACQCAAQQEQ1gMiAwRAIABB7AVBARDaASEBIABB2OHOfUHR7isQkAEaIABBfhDbASABQtSFgICABDcCECABQbPsKygAADYAAyABQbDsKygAADYAACACQdQFNgIgIABBq/grIAJBIGoQWyABQRhqIgEgA0EYaiIEEJIDIAEgBBDaA0GkiDQoAgAiAUUNASACIAM2AjwgASgCACIEIAIoAjxLDQEgAigCPCAEIAEoAhBqTw0BIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0CIAFBfHEiAUUNAiADQQAgAfwLAAwCCyACQd7uKzYCBCACQaSNKjYCACAAQfyIKiACEGwACyADECsLIAJBpI0qNgIQIABB4IcqIAJBEGoQmwEgAkFAayQAQQELxxUBDn8jAEHAB2siAiQAAkAgASgC0AVBAUwEQCAAIAFGDQEgACABEOQCIABB+ABqIAFB+ABqEOQCIABB8AFqIAFB8AFqEOQCIABB6AJqIAFB6AJqEOQCIABB4ANqIAFB4ANqEOQCIABB2ARqIAFB2ARqEOQCIAAgASgC0AU2AtAFDAELIAJB0AVqIAEQxAggAkHgA2ogAUHwAWoiAyABQeADaiIGEMYIIAJB4ANqIAJB4ANqIAJB4ANqEPcCIAJBnARqIgkgCSAJEPcCIAJB2ARqIgUgBSAFEPcCIAJBlAVqIgQgBCAEEPcCIAJB4ANqEPYCIAUQ9gIgAkHwAWogBhDECCACIAEgAxDGCCACIAIgAhD3AiACQTxqIgcgByAHEPcCIAJB+ABqIg4gDiAOEPcCIAJBtAFqIg8gDyAPEPcCIABB4ANqIgggASAGEPcCIABBnARqIgwgAUE8aiABQZwEahD3AiAAQdgEaiIGIAFB+ABqIAFB2ARqEPcCIABBlAVqIg0gAUG0AWogAUGUBWoQ9wIgCCADIAgQ9wIgDCABQawCaiAMEPcCIAYgAUHoAmogBhD3AiANIAFBpANqIA0Q9wIgCBD2AiAGEPYCIAggCBDECCACQdAFaiAARwRAIAAgAigC0AU2AgAgACACKALUBTYCBCAAIAIoAtgFNgIIIAAgAigC3AU2AgwgACACKALgBTYCECAAIAIoAuQFNgIUIAAgAigC6AU2AhggACACKALsBTYCHCAAIAIoAvAFNgIgIAAgAigC9AU2AiQgACACKAL4BTYCKCAAIAIoAvwFNgIsIAAgAigCgAY2AjAgACACKAKEBjYCNCAAIAIoAogGNgI4IAAgAigCjAY2AjwgACACKAKQBjYCQCAAIAIoApQGNgJEIAAgAigCmAY2AkggACACKAKcBjYCTCAAIAIoAqAGNgJQIAAgAigCpAY2AlQgACACKAKoBjYCWCAAIAIoAqwGNgJcIAAgAigCsAY2AmAgACACKAK0BjYCZCAAIAIoArgGNgJoIAAgAigCvAY2AmwgACACKALABjYCcCAAIAIoAsQGNgJ0IAAgAigCyAY2AnggACACKALMBjYCfCAAIAIoAtAGNgKAASAAIAIoAtQGNgKEASAAIAIoAtgGNgKIASAAIAIoAtwGNgKMASAAIAIoAuAGNgKQASAAIAIoAuQGNgKUASAAIAIoAugGNgKYASAAIAIoAuwGNgKcASAAIAIoAvAGNgKgASAAIAIoAvQGNgKkASAAIAIoAvgGNgKoASAAIAIoAvwGNgKsASAAIAIoAoAHNgKwASAAIAIoAoQHNgK0ASAAIAIoAogHNgK4ASAAIAIoAowHNgK8ASAAIAIoApAHNgLAASAAIAIoApQHNgLEASAAIAIoApgHNgLIASAAIAIoApwHNgLMASAAIAIoAqAHNgLQASAAIAIoAqQHNgLUASAAIAIoAqgHNgLYASAAIAIoAqwHNgLcASAAIAIoArAHNgLgASAAIAIoArQHNgLkASAAIAIoArgHNgLoASAAIAIoArwHNgLsAQsgAkHQBWogAkHQBWogAkHgA2oQ9wIgAkGMBmoiCiAKIAkQ9wIgAkHIBmoiAyADIAUQ9wIgAkGEB2oiCyALIAQQ9wIgAkHQBWoQ9gIgAxD2AiACQdAFaiACQdAFaiACQfABahD3AiAKIAogAkGsAmoQ9wIgAyADIAJB6AJqEPcCIAsgCyACQaQDahD3AiACQdAFaiACQdAFaiACEPcCIAogCiAHEPcCIAMgAyAOEPcCIAsgCyAPEPcCIAJB0AVqEPYCIAMQ9gIgAkHQBWogAkHQBWoQxwggAkHgA2oQxQggAkHwAWoQxQggACAAIAJB4ANqEPcCIABBPGoiByAHIAkQ9wIgAEH4AGoiCSAJIAUQ9wIgAEG0AWoiBSAFIAQQ9wIgACACKAIAIAIoAvABajYC8AEgACACKAIEIAIoAvQBajYC9AEgACACKAIIIAIoAvgBajYC+AEgACACKAIMIAIoAvwBajYC/AEgACACKAIQIAIoAoACajYCgAIgACACKAIUIAIoAoQCajYChAIgACACKAIYIAIoAogCajYCiAIgACACKAIcIAIoAowCajYCjAIgACACKAIgIAIoApACajYCkAIgACACKAIkIAIoApQCajYClAIgACACKAIoIAIoApgCajYCmAIgACACKAIsIAIoApwCajYCnAIgACACKAIwIAIoAqACajYCoAIgACACKAI0IAIoAqQCajYCpAIgACACKAI4IAIoAqgCaiIENgKoAiAAQfABaiEFIARBgICAEE4EQCAFENICCyAAIAIoAjwgAigCrAJqNgKsAiAAIAIoAkAgAigCsAJqNgKwAiAAIAIoAkQgAigCtAJqNgK0AiAAIAIoAkggAigCuAJqNgK4AiAAIAIoAkwgAigCvAJqNgK8AiAAIAIoAlAgAigCwAJqNgLAAiAAIAIoAlQgAigCxAJqNgLEAiAAIAIoAlggAigCyAJqNgLIAiAAIAIoAlwgAigCzAJqNgLMAiAAIAIoAmAgAigC0AJqNgLQAiAAIAIoAmQgAigC1AJqNgLUAiAAIAIoAmggAigC2AJqNgLYAiAAIAIoAmwgAigC3AJqNgLcAiAAIAIoAnAgAigC4AJqNgLgAiAAIAIoAnQgAigC5AJqIgQ2AuQCIARBgICAEE4EQCAAQawCahDSAgsgACACKAJ4IAIoAugCajYC6AIgACACKAJ8IAIoAuwCajYC7AIgACACKAKAASACKALwAmo2AvACIAAgAigChAEgAigC9AJqNgL0AiAAIAIoAogBIAIoAvgCajYC+AIgACACKAKMASACKAL8Amo2AvwCIAAgAigCkAEgAigCgANqNgKAAyAAIAIoApQBIAIoAoQDajYChAMgACACKAKYASACKAKIA2o2AogDIAAgAigCnAEgAigCjANqNgKMAyAAIAIoAqABIAIoApADajYCkAMgACACKAKkASACKAKUA2o2ApQDIAAgAigCqAEgAigCmANqNgKYAyAAIAIoAqwBIAIoApwDajYCnAMgACACKAKwASACKAKgA2oiBzYCoAMgAEHoAmohBCAHQYCAgBBOBEAgBBDSAgsgACACKAK0ASACKAKkA2o2AqQDIAAgAigCuAEgAigCqANqNgKoAyAAIAIoArwBIAIoAqwDajYCrAMgACACKALAASACKAKwA2o2ArADIAAgAigCxAEgAigCtANqNgK0AyAAIAIoAsgBIAIoArgDajYCuAMgACACKALMASACKAK8A2o2ArwDIAAgAigC0AEgAigCwANqNgLAAyAAIAIoAtQBIAIoAsQDajYCxAMgACACKALYASACKALIA2o2AsgDIAAgAigC3AEgAigCzANqNgLMAyAAIAIoAuABIAIoAtADajYC0AMgACACKALkASACKALUA2o2AtQDIAAgAigC6AEgAigC2ANqNgLYAyAAIAIoAuwBIAIoAtwDaiIHNgLcAyAHQYCAgBBOBEAgAEGkA2oQ0gILIAggCCACQdAFahD3AiAMIAwgChD3AiAGIAYgAxD3AiANIA0gCxD3AiAAQQNBBCABKALQBUECRhs2AtAFIAAQ9gIgCRD2AiAFEPYCIAQQ9gIgCBD2AiAGEPYCCyACQcAHaiQAC9sCAQR/IwBBQGoiAiQAIAJBlcApNgIwIABB+YYqIAJBMGoQmwECQAJAIABBARDWAyIDBEAgAEHsBUEBENoBIQEgAEHY4c59QdHuKxCQARogAEF+ENsBIAFC1IWAgIAENwIQIAFBs+wrKAAANgADIAFBsOwrKAAANgAAIAJB1AU2AiAgAEGr+CsgAkEgahBbIAFBGGoiASADQRhqIgQQkgMgASAEEI4DQaSINCgCACIBRQ0BIAIgAzYCPCABKAIAIgQgAigCPEsNASACKAI8IAQgASgCEGpPDQEgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIANBACAB/AsADAILIAJB3u4rNgIEIAJBlcApNgIAIABB/IgqIAIQbAALIAMQKwsgAkGVwCk2AhAgAEHghyogAkEQahCbASACQUBrJABBAQvYJQIHfwF7IwBBoAJrIgEkACABQffhKTYCICAAQfmGKiABQSBqEJsBAkACQCABIABBARDWAyICBH8gAEHUBRCGASIEBEAgBEHABDYCACABIAIoAhg2AnAgASACKAIcNgJ0IAEgAigCIDYCeCABIAIoAiQ2AnwgASACKAIoNgKAASABIAIoAiw2AoQBIAEgAigCMDYCiAEgASACKAI0NgKMASABIAIoAjg2ApABIAEgAigCPDYClAEgASACKAJANgKYASABIAIoAkQ2ApwBIAEgAigCSDYCoAEgAigCTCEDIAFBvAFqIgX9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFBzAFqIgYgCP0LAgAgAUHcAWoiB0EANgIAIAEgCP0LAqwBIAEgA0EddTYCqAEgASADQf////8BcTYCpAEgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFBMGogAUHgAWogAUHwAGoQyQIgBCgCCCABQTBqELoCIAEgAigCVDYCcCABIAIoAlg2AnQgASACKAJcNgJ4IAEgAigCYDYCfCABIAIoAmQ2AoABIAEgAigCaDYChAEgASACKAJsNgKIASABIAIoAnA2AowBIAEgAigCdDYCkAEgASACKAJ4NgKUASABIAIoAnw2ApgBIAEgAigCgAE2ApwBIAEgAigChAE2AqABIAIoAogBIQMgBSAI/QsCACAGIAj9CwIAIAdBADYCACABIAj9CwKsASABIANBHXU2AqgBIAEgA0H/////AXE2AqQBIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQTBqIAFB4AFqIAFB8ABqEMkCIAQoAghBMGogAUEwahC6AiABIAIoApABNgJwIAEgAigClAE2AnQgASACKAKYATYCeCABIAIoApwBNgJ8IAEgAigCoAE2AoABIAEgAigCpAE2AoQBIAEgAigCqAE2AogBIAEgAigCrAE2AowBIAEgAigCsAE2ApABIAEgAigCtAE2ApQBIAEgAigCuAE2ApgBIAEgAigCvAE2ApwBIAEgAigCwAE2AqABIAIoAsQBIQMgBSAI/QsCACAGIAj9CwIAIAdBADYCACABIAj9CwKsASABIANBHXU2AqgBIAEgA0H/////AXE2AqQBIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQTBqIAFB4AFqIAFB8ABqEMkCIAQoAghB4ABqIAFBMGoQugIgASACKALMATYCcCABIAIoAtABNgJ0IAEgAigC1AE2AnggASACKALYATYCfCABIAIoAtwBNgKAASABIAIoAuABNgKEASABIAIoAuQBNgKIASABIAIoAugBNgKMASABIAIoAuwBNgKQASABIAIoAvABNgKUASABIAIoAvQBNgKYASABIAIoAvgBNgKcASABIAIoAvwBNgKgASACKAKAAiEDIAUgCP0LAgAgBiAI/QsCACAHQQA2AgAgASAI/QsCrAEgASADQR11NgKoASABIANB/////wFxNgKkASABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUEwaiABQeABaiABQfAAahDJAiAEKAIIQZABaiABQTBqELoCIAEgAigCiAI2AnAgASACKAKMAjYCdCABIAIoApACNgJ4IAEgAigClAI2AnwgASACKAKYAjYCgAEgASACKAKcAjYChAEgASACKAKgAjYCiAEgASACKAKkAjYCjAEgASACKAKoAjYCkAEgASACKAKsAjYClAEgASACKAKwAjYCmAEgASACKAK0AjYCnAEgASACKAK4AjYCoAEgAigCvAIhAyAFIAj9CwIAIAYgCP0LAgAgB0EANgIAIAEgCP0LAqwBIAEgA0EddTYCqAEgASADQf////8BcTYCpAEgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFBMGogAUHgAWogAUHwAGoQyQIgBCgCCEHAAWogAUEwahC6AiABIAIoAsQCNgJwIAEgAigCyAI2AnQgASACKALMAjYCeCABIAIoAtACNgJ8IAEgAigC1AI2AoABIAEgAigC2AI2AoQBIAEgAigC3AI2AogBIAEgAigC4AI2AowBIAEgAigC5AI2ApABIAEgAigC6AI2ApQBIAEgAigC7AI2ApgBIAEgAigC8AI2ApwBIAEgAigC9AI2AqABIAIoAvgCIQMgBSAI/QsCACAGIAj9CwIAIAdBADYCACABIAj9CwKsASABIANBHXU2AqgBIAEgA0H/////AXE2AqQBIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQTBqIAFB4AFqIAFB8ABqEMkCIAQoAghB8AFqIAFBMGoQugIgASACKAKAAzYCcCABIAIoAoQDNgJ0IAEgAigCiAM2AnggASACKAKMAzYCfCABIAIoApADNgKAASABIAIoApQDNgKEASABIAIoApgDNgKIASABIAIoApwDNgKMASABIAIoAqADNgKQASABIAIoAqQDNgKUASABIAIoAqgDNgKYASABIAIoAqwDNgKcASABIAIoArADNgKgASACKAK0AyEDIAUgCP0LAgAgBiAI/QsCACAHQQA2AgAgASAI/QsCrAEgASADQR11NgKoASABIANB/////wFxNgKkASABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUEwaiABQeABaiABQfAAahDJAiAEKAIIQaACaiABQTBqELoCIAEgAigCvAM2AnAgASACKALAAzYCdCABIAIoAsQDNgJ4IAEgAigCyAM2AnwgASACKALMAzYCgAEgASACKALQAzYChAEgASACKALUAzYCiAEgASACKALYAzYCjAEgASACKALcAzYCkAEgASACKALgAzYClAEgASACKALkAzYCmAEgASACKALoAzYCnAEgASACKALsAzYCoAEgAigC8AMhAyAFIAj9CwIAIAYgCP0LAgAgB0EANgIAIAEgCP0LAqwBIAEgA0EddTYCqAEgASADQf////8BcTYCpAEgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFBMGogAUHgAWogAUHwAGoQyQIgBCgCCEHQAmogAUEwahC6AiABIAIoAvgDNgJwIAEgAigC/AM2AnQgASACKAKABDYCeCABIAIoAoQENgJ8IAEgAigCiAQ2AoABIAEgAigCjAQ2AoQBIAEgAigCkAQ2AogBIAEgAigClAQ2AowBIAEgAigCmAQ2ApABIAEgAigCnAQ2ApQBIAEgAigCoAQ2ApgBIAEgAigCpAQ2ApwBIAEgAigCqAQ2AqABIAIoAqwEIQMgBSAI/QsCACAGIAj9CwIAIAdBADYCACABIAj9CwKsASABIANBHXU2AqgBIAEgA0H/////AXE2AqQBIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQTBqIAFB4AFqIAFB8ABqEMkCIAQoAghBgANqIAFBMGoQugIgASACKAK0BDYCcCABIAIoArgENgJ0IAEgAigCvAQ2AnggASACKALABDYCfCABIAIoAsQENgKAASABIAIoAsgENgKEASABIAIoAswENgKIASABIAIoAtAENgKMASABIAIoAtQENgKQASABIAIoAtgENgKUASABIAIoAtwENgKYASABIAIoAuAENgKcASABIAIoAuQENgKgASACKALoBCEDIAUgCP0LAgAgBiAI/QsCACAHQQA2AgAgASAI/QsCrAEgASADQR11NgKoASABIANB/////wFxNgKkASABQQ02ApQCIAFBo73EADYCkAIgAUG0mv+XATYCjAIgAUHt05uWATYCiAIgAUHmuumQATYChAIgAUHL7pG7ATYCgAIgAUGi4fmEATYC/AEgAUHDufbXADYC+AEgAUHY9sHKADYC9AEgAUHqg4n7ADYC8AEgAUHi+v+/ATYC7AEgAUHu//+nATYC6AEgAUH//9//ADYC5AEgAUGr1f7/ATYC4AEgAUEwaiABQeABaiABQfAAahDJAiAEKAIIQbADaiABQTBqELoCIAEgAigC8AQ2AnAgASACKAL0BDYCdCABIAIoAvgENgJ4IAEgAigC/AQ2AnwgASACKAKABTYCgAEgASACKAKEBTYChAEgASACKAKIBTYCiAEgASACKAKMBTYCjAEgASACKAKQBTYCkAEgASACKAKUBTYClAEgASACKAKYBTYCmAEgASACKAKcBTYCnAEgASACKAKgBTYCoAEgAigCpAUhAyAFIAj9CwIAIAYgCP0LAgAgB0EANgIAIAEgCP0LAqwBIAEgA0EddTYCqAEgASADQf////8BcTYCpAEgAUENNgKUAiABQaO9xAA2ApACIAFBtJr/lwE2AowCIAFB7dOblgE2AogCIAFB5rrpkAE2AoQCIAFBy+6RuwE2AoACIAFBouH5hAE2AvwBIAFBw7n21wA2AvgBIAFB2PbBygA2AvQBIAFB6oOJ+wA2AvABIAFB4vr/vwE2AuwBIAFB7v//pwE2AugBIAFB///f/wA2AuQBIAFBq9X+/wE2AuABIAFBMGogAUHgAWogAUHwAGoQyQIgBCgCCEHgA2ogAUEwahC6AiABIAIoAqwFNgJwIAEgAigCsAU2AnQgASACKAK0BTYCeCABIAIoArgFNgJ8IAEgAigCvAU2AoABIAEgAigCwAU2AoQBIAEgAigCxAU2AogBIAEgAigCyAU2AowBIAEgAigCzAU2ApABIAEgAigC0AU2ApQBIAEgAigC1AU2ApgBIAEgAigC2AU2ApwBIAEgAigC3AU2AqABIAIoAuAFIQMgBSAI/QsCACAGIAj9CwIAIAdBADYCACABIAj9CwKsASABIANBHXU2AqgBIAEgA0H/////AXE2AqQBIAFBDTYClAIgAUGjvcQANgKQAiABQbSa/5cBNgKMAiABQe3Tm5YBNgKIAiABQea66ZABNgKEAiABQcvukbsBNgKAAiABQaLh+YQBNgL8ASABQcO59tcANgL4ASABQdj2wcoANgL0ASABQeqDifsANgLwASABQeL6/78BNgLsASABQe7//6cBNgLoASABQf//3/8ANgLkASABQavV/v8BNgLgASABQTBqIAFB4AFqIAFB8ABqEMkCIAQoAghBkARqIAFBMGoQugJBpIg0KAIAIgRFDQIgASACNgJwIAQoAgAiBSABKAJwSw0CIAEoAnAgBSAEKAIQak8NAiACIAQoAgQ2AgAgBCACNgIEIAQgBCgCCEEBajYCCCAEKAIUIgRBBEkNAyAEQXxxIgRFDQMgAkEAIAT8CwAMAwsCQEGkiDQoAgAiBEUEQCACECsMAQsgBCACEFALQd3KKQVB3u4rCzYCBCABQffhKTYCACAAQfyIKiABEGwACyACECsLIAFB9+EpNgIQIABB4IcqIAFBEGoQmwEgAUGgAmokAEEBC8qEAgE6fyMAQeAcayICJAAgAkG7vSk2AjAgAEH5hiogAkEwahCbAQJAAkAgAEEBENYDIjlFBEBB3u4rIS0MAQsCQCAAQQIQzgIiOkUEQEHS4SshLQwBCyAAQewFQQEQ2gEhBiAAQdjhzn1B0e4rEJABGiAAQX4Q2wEgBkLUhYCAgAQ3AhAgBkGz7CsoAAA2AAMgBkGw7CsoAAA2AAAgAkHUBTYCICAAQav4KyACQSBqEFsgBkEYaiIEIDlBGGoQkgMgOigCDCEGIAJB5AJqQcDDLxCCAyACQagCakGAxC8QggMgAiACKALkAjYC2AMgAiAC/QAC6AL9CwLcAyACIAL9AAL4Av0LAuwDIAIgAv0AAogD/QsC/AMgAiACKQKYAzcCjAQgAiAC/QACqAL9CwKUBCACIAL9AAK4Av0LAqQEIAIgAikCyAI3ArQEIAIgAigC0AI2ArwEIAJBADYC1AMgAkGn288DNgLAAyACQoGAgICA////HzcDoAMgAkK//9v88b+BpBs3A6gDIAJCu6qB7IGagYIMNwOwAyACQueZg6nx9cyyCjcDuAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAsQDIAIgAv0AAtQC/QsCwAQgAkG0HGr9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAJBxBxq/QwAAAAAAAAAAAAAAAAAAAAA/QsCACACQdQcakEANgIAIAJB1BtqQQA2AgAgAkIANwKsHCACQTQ2AqgcIAJCgICEgICAgIQQNwOgHCACQafbzwM2AsAbIAJC55mDqfH1zLIKNwO4GyACQruqgeyBmoGCDDcDsBsgAkK//9v88b+BpBs3A6gbIAJCgYCAgID///8fNwOgGyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCxBsgAiAGKAIAIgk2AuAbIAIgBigCBCIMNgLkGyACIAYoAggiDTYC6BsgAiAGKAIMIg42AuwbIAIgBigCECITNgLwGyACIAYoAhQiFDYC9BsgAiAGKAIYIhU2AvgbIAIgBigCHCIWNgL8GyACIAYoAiAiGDYCgBwgAiAGKAIkIhk2AoQcIAIgBigCKCIaNgKIHCACIAYoAiwiGzYCjBwgAiAGKAIwIg82ApAcIAIgBigCNCIGNgJ0IAIgDzYCcCACIBs2AmwgAiAaNgJoIAIgGTYCZCACIBg2AmAgAiAWNgJcIAIgFTYCWCACIBQ2AlQgAiATNgJQIAIgDjYCTCACIA02AkggAiAMNgJEIAIgCTYCQCACIAY2ApQcIAJBQGsgAkGgHGoQ2wIgAkHgG2ogAkGgHGoQqAMgAiACKALgGzYCeCACIAL9AALkG/0LAnwgAiAC/QAC9Bv9CwKMASACIAL9AAKEHP0LApwBIAIgAigClBw2AqwBIAJB+ABqIh4gAkGgHGoQ2wIgAkHgG2ogAkGgHGoQqAMgAiACKALgGzYCsAEgAiAC/QAC5Bv9CwK0ASACIAL9AAL0G/0LAsQBIAIgAv0AAoQc/QsC1AEgAiACKAKUHDYC5AEgAkGwAWoiICACQaAcahDbAiACQeAbaiACQaAcahCoAyACIAIoAuAbNgLoASACIAL9AALkG/0LAuwBIAIgAv0AAvQb/QsC/AEgAiAC/QAChBz9CwKMAiACIAIoApQcNgKcAiACIAL9AAN4/QsE0AQgAiAC/QADiAH9CwTgBCACIAIoApgBNgLwBCACIAIoApwBNgL0BCACIAIoAqABNgL4BCACIAIoAqQBNgL8BCACIAIoAqgBNgKABSACIAIoAqwBNgKEBSACQdAEaiACQaAbahDbAiACQQEgAigC0ARrNgJ4IAJB+P///wEgAigC1ARrNgJ8IAJBv//b/AEgAigC2ARrNgKAASACQf+LoNoBIAIoAtwEazYChAEgAkG7qoHsASACKALgBGs2AogBIAJB0ImQ4AAgAigC5ARrNgKMASACQeeZg6kBIAIoAugEazYCkAEgAkGv55TTACACKALsBGs2ApQBIAJBp9vPAyACKALwBGs2ApgBIAJBACACKAL0BGs2ApwBIAJBACACKAL4BGs2AqABIAJBACACKAL8BGs2AqQBIAJBACACKAKABWs2AqgBIAJBACACKAKEBWs2AqwBIAIgAv0AA+gB/QsE0AQgAiAC/QAD+AH9CwTgBCACIAIoAogCNgLwBCACIAIoAowCNgL0BCACIAIoApACNgL4BCACIAIoApQCNgL8BCACIAIoApgCNgKABSACIAIoApwCNgKEBSACQdAEaiACQaAbahDbAiACQQEgAigC0ARrNgLoASACQfj///8BIAIoAtQEazYC7AEgAkG//9v8ASACKALYBGs2AvABIAJB/4ug2gEgAigC3ARrNgL0ASACQbuqgewBIAIoAuAEazYC+AEgAkHQiZDgACACKALkBGs2AvwBIAJB55mDqQEgAigC6ARrNgKAAiACQa/nlNMAIAIoAuwEazYChAIgAkGn288DIAIoAvAEazYCiAIgAkEAIAIoAvQEazYCjAIgAkEAIAIoAvgEazYCkAIgAkEAIAIoAvwEazYClAIgAkEAIAIoAoAFazYCmAIgAkEAIAIoAoQFazYCnAIgAkHQBGogBBCSAyACIAIoAtAENgKkCiACIAL9AALUBP0LA6gKIAIgAv0AAuQE/QsDuAogAiAC/QAC9AT9CwPICiACIAL9AAKEBf0LA9gKIAIgAv0AApQF/QsD6AogAiAC/QACpAX9CwP4CiACIAIpArQFNwOICyACIAIoArwFNgKQCyACIAIoAsAFNgKUCyACIAL9AALEBf0LA5gLIAIgAv0AAtQF/QsDqAsgAiAC/QAC5AX9CwO4CyACIAL9AAL0Bf0LA8gLIAIgAv0AAoQG/QsD2AsgAiAC/QAClAb9CwPoCyACIAIpAqQGNwP4CyACIAIoAqwGNgKADCACIAIoArAGNgKEDCACIAL9AAK0Bv0LA4gMIAIgAv0AAsQG/QsDmAwgAiAC/QAC1Ab9CwOoDCACIAL9AALkBv0LA7gMIAIgAv0AAvQG/QsDyAwgAiAC/QAChAf9CwPYDCACIAIpApQHNwPoDCACIAIoApwHNgLwDCACIAIoAqAHNgL0DCACIAIoAqQHNgL4DCACIAIoAqgHNgL8DCACIAIoAqwHNgKADSACIAIoArAHNgKEDSACIAIoArQHNgKIDSACIAIoArgHNgKMDSACIAIoArwHNgKQDSACIAIoAsAHNgKUDSACIAIoAsQHNgKYDSACIAIoAsgHNgKcDSACIAIoAswHNgKgDSACIAIoAtAHNgKkDSACIAIoAtQHNgKoDSACIAIoAtgHNgKsDSACIAIoAtwHNgKwDSACIAIoAuAHNgK0DSACIAIoAuQHNgK4DSACIAIoAugHNgK8DSACIAIoAuwHNgLADSACIAIoAvAHNgLEDSACIAIoAvQHNgLIDSACIAIoAvgHNgLMDSACIAIoAvwHNgLQDSACIAIoAoAINgLUDSACIAIoAoQINgLYDSACIAIoAogINgLcDSACIAIoAowINgLgDSACIAIoApAINgLkDSACIAIoApQINgLoDSACIAIoApgINgLsDSACIAIoApwINgLwDSACIAIoAqAINgL0DSACIAIoAqQINgL4DSACIAIoAqgINgL8DSACIAIoAqwINgKADiACIAIoArAINgKEDiACIAIoArQINgKIDiACIAIoArgINgKMDiACIAIoArwINgKQDiACIAIoAsAINgKUDiACIAIoAsQINgKYDiACIAIoAsgINgKcDiACIAIoAswINgKgDiACIAIoAtAINgKkDiACIAIoAtQINgKoDiACIAIoAtgINgKsDiACIAIoAtwINgKwDiACIAIoAuAINgK0DiACIAIoAuQINgK4DiACIAIoAugINgK8DiACIAIoAuwINgLADiACIAIoAvAINgLEDiACIAIoAvQINgLIDiACIAIoAvgINgLMDiACIAIoAvwINgLQDiACIAIoAoAJNgLUDiACIAIoAoQJNgLYDiACIAIoAogJNgLcDiACIAIoAowJNgLgDiACIAIoApAJNgLkDiACIAIoApQJNgLoDiACIAIoApgJNgLsDiACIAIoApwJNgLwDiACIAIoAqAJNgL0DiACIAIoAqQJNgL4DiACIAIoAqgJNgL8DiACIAIoAqwJNgKADyACIAIoArAJNgKEDyACIAIoArQJNgKIDyACIAIoArgJNgKMDyACIAIoArwJNgKQDyACIAIoAsAJNgKUDyACIAIoAsQJNgKYDyACIAIoAsgJNgKcDyACIAIoAswJNgKgDyACIAIoAtAJNgKkDyACIAIoAtQJNgKoDyACIAIoAtgJNgKsDyACIAIoAtwJNgKwDyACIAIoAuAJNgK0DyACIAIoAuQJNgK4DyACIAIoAugJNgK8DyACIAIoAuwJNgLADyACIAIoAvAJNgLEDyACIAIoAvQJNgLIDyACIAIoAvgJNgLMDyACIAIoAvwJNgLQDyACIAIoAoAKNgLUDyACIAIoAoQKNgLYDyACIAIoAogKNgLcDyACIAIoAowKNgLgDyACIAIoApAKNgLkDyACIAIoApQKNgLoDyACIAIoApgKNgLsDyACIAIoApwKNgLwDyACIAIoAqAKNgL0DyACQaQKaiIdIAJB2ANqEJMDIAIgAigCpAo2AvgPIAIgAigCqAo2AvwPIAIgAigCrAo2AoAQIAIgAigCsAo2AoQQIAIgAigCtAo2AogQIAIgAigCuAo2AowQIAIgAigCvAo2ApAQIAIgAigCwAo2ApQQIAIgAigCxAo2ApgQIAIgAigCyAo2ApwQIAIgAigCzAo2AqAQIAIgAv0ABNAK/QsCpBAgAiAC/QAE4Ar9CwK0ECACIAL9AATwCv0LAsQQIAIgAv0ABIAL/QsC1BAgAiAC/QAEkAv9CwLkECACIAL9AASgC/0LAvQQIAIgAikDsAs3AoQRIAIgAigCuAs2AowRIAIgAigCvAs2ApARIAIgAv0ABMAL/QsClBEgAiAC/QAE0Av9CwKkESACIAL9AATgC/0LArQRIAIgAv0ABPAL/QsCxBEgAiAC/QAEgAz9CwLUESACIAL9AASQDP0LAuQRIAIgAikDoAw3AvQRIAIgAigCqAw2AvwRIAIgAigCrAw2AoASIAIgAigCsAw2AoQSIAIgAigCtAw2AogSIAIgAigCuAw2AowSIAIgAigCvAw2ApASIAIgAigCwAw2ApQSIAIgAigCxAw2ApgSIAIgAigCyAw2ApwSIAIgAigCzAw2AqASIAIgAigC0Aw2AqQSIAIgAigC1Aw2AqgSIAIgAigC2Aw2AqwSIAIgAigC3Aw2ArASIAIgAigC4Aw2ArQSIAIgAigC5Aw2ArgSIAIgAigC6Aw2ArwSIAIgAigC7Aw2AsASIAIgAigC8Aw2AsQSIAIgAigC9Aw2AsgSIAIgAigC+Aw2AswSIAIgAigC/Aw2AtASIAIgAigCgA02AtQSIAIgAigChA02AtgSIAIgAigCiA02AtwSIAIgAigCjA02AuASIAIgAigCkA02AuQSIAIgAigClA02AugSIAIgAigCmA02AuwSIAIgAigCnA02AvASIAIgAigCoA02AvQSIAIgAigCpA02AvgSIAIgAigCqA02AvwSIAIgAigCrA02AoATIAIgAigCsA02AoQTIAIgAigCtA02AogTIAIgAigCuA02AowTIAIgAigCvA02ApATIAIgAigCwA02ApQTIAIgAigCxA02ApgTIAIgAigCyA02ApwTIAIgAigCzA02AqATIAIgAigC0A02AqQTIAIgAigC1A02AqgTIAIgAigC2A02AqwTIAIgAigC3A02ArATIAIgAigC4A02ArQTIAIgAigC5A02ArgTIAIgAigC6A02ArwTIAIgAigC7A02AsATIAIgAigC8A02AsQTIAIgAigC9A02AsgTIAIgAigC+A02AswTIAIgAigC/A02AtATIAIgAigCgA42AtQTIAIgAigChA42AtgTIAIgAigCiA42AtwTIAIgAigCjA42AuATIAIgAigCkA42AuQTIAIgAigClA42AugTIAIgAigCmA42AuwTIAIgAigCnA42AvATIAIgAigCoA42AvQTIAIgAigCpA42AvgTIAIgAigCqA42AvwTIAIgAigCrA42AoAUIAIgAigCsA42AoQUIAIgAigCtA42AogUIAIgAigCuA42AowUIAIgAigCvA42ApAUIAIgAigCwA42ApQUIAIgAigCxA42ApgUIAIgAigCyA42ApwUIAIgAigCzA42AqAUIAIgAigC0A42AqQUIAIgAigC1A42AqgUIAIgAigC2A42AqwUIAIgAigC3A42ArAUIAIgAigC4A42ArQUIAIgAigC5A42ArgUIAIgAigC6A42ArwUIAIgAigC7A42AsAUIAIgAigC8A42AsQUIAIgAigC9A42AsgUIAIgAigC+A42AswUIAIgAigC/A42AtAUIAIgAigCgA82AtQUIAIgAigChA82AtgUIAIgAigCiA82AtwUIAIgAigCjA82AuAUIAIgAigCkA82AuQUIAIgAigClA82AugUIAIgAigCmA82AuwUIAIgAigCnA82AvAUIAIgAigCoA82AvQUIAIgAigCpA82AvgUIAIgAigCqA82AvwUIAIgAigCrA82AoAVIAIgAigCsA82AoQVIAIgAigCtA82AogVIAIgAigCuA82AowVIAIgAigCvA82ApAVIAIgAigCwA82ApQVIAIgAigCxA82ApgVIAIgAigCyA82ApwVIAIgAigCzA82AqAVIAIgAigC0A82AqQVIAIgAigC1A82AqgVIAIgAigC2A82AqwVIAIgAigC3A82ArAVIAIgAigC4A82ArQVIAIgAigC5A82ArgVIAIgAigC6A82ArwVIAIgAigC7A82AsAVIAIgAigC8A82AsQVIAIgAigC9A82AsgVIAJB+A9qIikgAkHYA2oQkwMgAiACKAL4DzYCzBUgAiACKAL8DzYC0BUgAiACKAKAEDYC1BUgAiACKAKEEDYC2BUgAiACKAKIEDYC3BUgAiACKAKMEDYC4BUgAiACKAKQEDYC5BUgAiACKAKUEDYC6BUgAiACKAKYEDYC7BUgAiACKAKcEDYC8BUgAiACKAKgEDYC9BUgAiAC/QACpBD9CwP4FSACIAL9AAK0EP0LA4gWIAIgAv0AAsQQ/QsDmBYgAiAC/QAC1BD9CwOoFiACIAL9AALkEP0LA7gWIAIgAv0AAvQQ/QsDyBYgAiACKQKEETcD2BYgAiACKAKMETYC4BYgAiACKAKQETYC5BYgAiAC/QAClBH9CwPoFiACIAL9AAKkEf0LA/gWIAIgAv0AArQR/QsDiBcgAiAC/QACxBH9CwOYFyACIAL9AALUEf0LA6gXIAIgAv0AAuQR/QsDuBcgAiACKQL0ETcDyBcgAiACKAL8ETYC0BcgAiACKAKAEjYC1BcgAiACKAKEEjYC2BcgAiACKAKIEjYC3BcgAiACKAKMEjYC4BcgAiACKAKQEjYC5BcgAiACKAKUEjYC6BcgAiACKAKYEjYC7BcgAiACKAKcEjYC8BcgAiACKAKgEjYC9BcgAiACKAKkEjYC+BcgAiACKAKoEjYC/BcgAiACKAKsEjYCgBggAiACKAKwEjYChBggAiACKAK0EjYCiBggAiACKAK4EjYCjBggAiACKAK8EjYCkBggAiACKALAEjYClBggAiACKALEEjYCmBggAiACKALIEjYCnBggAiACKALMEjYCoBggAiACKALQEjYCpBggAiACKALUEjYCqBggAiACKALYEjYCrBggAiACKALcEjYCsBggAiACKALgEjYCtBggAiACKALkEjYCuBggAiACKALoEjYCvBggAiACKALsEjYCwBggAiACKALwEjYCxBggAiACKAL0EjYCyBggAiACKAL4EjYCzBggAiACKAL8EjYC0BggAiACKAKAEzYC1BggAiACKAKEEzYC2BggAiACKAKIEzYC3BggAiACKAKMEzYC4BggAiACKAKQEzYC5BggAiACKAKUEzYC6BggAiACKAKYEzYC7BggAiACKAKcEzYC8BggAiACKAKgEzYC9BggAiACKAKkEzYC+BggAiACKAKoEzYC/BggAiACKAKsEzYCgBkgAiACKAKwEzYChBkgAiACKAK0EzYCiBkgAiACKAK4EzYCjBkgAiACKAK8EzYCkBkgAiACKALAEzYClBkgAiACKALEEzYCmBkgAiACKALIEzYCnBkgAiACKALMEzYCoBkgAiACKALQEzYCpBkgAiACKALUEzYCqBkgAiACKALYEzYCrBkgAiACKALcEzYCsBkgAiACKALgEzYCtBkgAiACKALkEzYCuBkgAiACKALoEzYCvBkgAiACKALsEzYCwBkgAiACKALwEzYCxBkgAiACKAL0EzYCyBkgAiACKAL4EzYCzBkgAiACKAL8EzYC0BkgAiACKAKAFDYC1BkgAiACKAKEFDYC2BkgAiACKAKIFDYC3BkgAiACKAKMFDYC4BkgAiACKAKQFDYC5BkgAiACKAKUFDYC6BkgAiACKAKYFDYC7BkgAiACKAKcFDYC8BkgAiACKAKgFDYC9BkgAiACKAKkFDYC+BkgAiACKAKoFDYC/BkgAiACKAKsFDYCgBogAiACKAKwFDYChBogAiACKAK0FDYCiBogAiACKAK4FDYCjBogAiACKAK8FDYCkBogAiACKALAFDYClBogAiACKALEFDYCmBogAiACKALIFDYCnBogAiACKALMFDYCoBogAiACKALQFDYCpBogAiACKALUFDYCqBogAiACKALYFDYCrBogAiACKALcFDYCsBogAiACKALgFDYCtBogAiACKALkFDYCuBogAiACKALoFDYCvBogAiACKALsFDYCwBogAiACKALwFDYCxBogAiACKAL0FDYCyBogAiACKAL4FDYCzBogAiACKAL8FDYC0BogAiACKAKAFTYC1BogAiACKAKEFTYC2BogAiACKAKIFTYC3BogAiACKAKMFTYC4BogAiACKAKQFTYC5BogAiACKAKUFTYC6BogAiACKAKYFTYC7BogAiACKAKcFTYC8BogAiACKAKgFTYC9BogAiACKAKkFTYC+BogAiACKAKoFTYC/BogAiACKAKsFTYCgBsgAiACKAKwFTYChBsgAiACKAK0FTYCiBsgAiACKAK4FTYCjBsgAiACKAK8FTYCkBsgAiACKALAFTYClBsgAiACKALEFTYCmBsgAiACKALIFTYCnBsgAkHMFWoiLiACQdgDahCTAyACQUBrELADIRcgAiACKAJANgKgHCACIAIoAkQiCTYCpBwgAiACKAJIIgw2AqgcIAIgAigCTCINNgKsHCACIAIoAlAiDjYCsBwgAiACKAJUIhM2ArQcIAIgAigCWCIUNgK4HCACIAIoAlwiFTYCvBwgAiACKAJgIhY2AsAcIAIgAigCZCIYNgLEHCACIAIoAmgiGTYCyBwgAiACKAJsIho2AswcIAIgAigCcCIbNgLQHCACIAIoAnQiDzYC1BwgAkGgHGogAkGgA2oQ2wIgAkEBIAIoAqAcayIGNgLgGyACQfj///8BIAIoAqQcayIhNgLkGyACQb//2/wBIAIoAqgcayIiNgLoGyACQf+LoNoBIAIoAqwcayIjNgLsGyACQbuqgewBIAIoArAcayIkNgLwGyACQdCJkOAAIAIoArQcayIlNgL0GyACQeeZg6kBIAIoArgcayImNgL4GyACQa/nlNMAIAIoArwcayInNgL8GyACQafbzwMgAigCwBxrIiw2AoAcIAJBACACKALEHGsiAzYChBwgAkEAIAIoAsgcayIFNgKIHCACQQAgAigCzBxrIi02AowcIAJBACACKALQHGsiHzYCkBwgAkEAIAIoAtQcayIqNgKUHAJAIAJB4BtqELADIBdOBEAgAigCQCEGDAELIAJB0ARqIAJB0ARqEI8DIAJBwAZqIgkgCRCQAyACQbAIaiIJIAkQjwMgKiEPIB8hGyAtIRogBSEZIAMhGCAsIRYgJyEVICYhFCAlIRMgJCEOICMhDSAiIQwgISEJCyACIAZB/////wFxNgJAIAIgCSAGQR11aiIGQf////8BcTYCRCACIAwgBkEddWoiBkH/////AXE2AkggAiANIAZBHXVqIgZB/////wFxNgJMIAIgDiAGQR11aiIGQf////8BcTYCUCACIBMgBkEddWoiBkH/////AXE2AlQgAiAUIAZBHXVqIgZB/////wFxNgJYIAIgFSAGQR11aiIGQf////8BcTYCXCACIBYgBkEddWoiBkH/////AXE2AmAgAiAYIAZBHXVqIgZB/////wFxNgJkIAIgGSAGQR11aiIGQf////8BcTYCaCACIBogBkEddWoiBkH/////AXE2AmwgAiAbIAZBHXVqIgZB/////wFxNgJwIAIgDyAGQR11ajYCdCAeELADIR4gAiACKAJ4IgY2AqAcIAIgAigCfCIJNgKkHCACIAIoAoABIgw2AqgcIAIgAigChAEiDTYCrBwgAiACKAKIASIONgKwHCACIAIoAowBIhM2ArQcIAIgAigCkAEiFDYCuBwgAiACKAKUASIVNgK8HCACIAIoApgBIhY2AsAcIAIgAigCnAEiGDYCxBwgAiACKAKgASIZNgLIHCACIAIoAqQBIho2AswcIAIgAigCqAEiGzYC0BwgAiACKAKsASIPNgLUHCACQaAcaiACQaADahDbAiACQQEgAigCoBxrIhc2AuAbIAJB+P///wEgAigCpBxrIiE2AuQbIAJBv//b/AEgAigCqBxrIiI2AugbIAJB/4ug2gEgAigCrBxrIiM2AuwbIAJBu6qB7AEgAigCsBxrIiQ2AvAbIAJB0ImQ4AAgAigCtBxrIiU2AvQbIAJB55mDqQEgAigCuBxrIiY2AvgbIAJBr+eU0wAgAigCvBxrIic2AvwbIAJBp9vPAyACKALAHGsiLDYCgBwgAkEAIAIoAsQcayIDNgKEHCACQQAgAigCyBxrIgU2AogcIAJBACACKALMHGsiLTYCjBwgAkEAIAIoAtAcayIfNgKQHCACQQAgAigC1BxrIio2ApQcIAJB4BtqELADIB5IBEAgAiAqNgKsASACIB82AqgBIAIgLTYCpAEgAiAFNgKgASACIAM2ApwBIAIgLDYCmAEgAiAnNgKUASACICY2ApABIAIgJTYCjAEgAiAkNgKIASACICM2AoQBIAIgIjYCgAEgAiAhNgJ8IAIgFzYCeCAdIB0QjwMgAkGUDGoiBiAGEJADIAJBhA5qIgYgBhCPAyAfIRsgLSEaIAUhGSADIRggLCEWICchFSAmIRQgJSETICQhDiAjIQ0gIiEMICEhCSAXIQYgKiEPCyACQegBaiEeIAIgBkH/////AXE2AnggAiAJIAZBHXVqIgZB/////wFxNgJ8IAIgDCAGQR11aiIGQf////8BcTYCgAEgAiANIAZBHXVqIgZB/////wFxNgKEASACIA4gBkEddWoiBkH/////AXE2AogBIAIgEyAGQR11aiIGQf////8BcTYCjAEgAiAUIAZBHXVqIgZB/////wFxNgKQASACIBUgBkEddWoiBkH/////AXE2ApQBIAIgFiAGQR11aiIGQf////8BcTYCmAEgAiAYIAZBHXVqIgZB/////wFxNgKcASACIBkgBkEddWoiBkH/////AXE2AqABIAIgGiAGQR11aiIGQf////8BcTYCpAEgAiAbIAZBHXVqIgZB/////wFxNgKoASACIA8gBkEddWo2AqwBICAQsAMhICACIAIoArABIgY2AqAcIAIgAigCtAEiCTYCpBwgAiACKAK4ASIMNgKoHCACIAIoArwBIg02AqwcIAIgAigCwAEiDjYCsBwgAiACKALEASITNgK0HCACIAIoAsgBIhQ2ArgcIAIgAigCzAEiFTYCvBwgAiACKALQASIWNgLAHCACIAIoAtQBIhg2AsQcIAIgAigC2AEiGTYCyBwgAiACKALcASIaNgLMHCACIAIoAuABIhs2AtAcIAIgAigC5AEiDzYC1BwgAkGgHGogAkGgA2oQ2wIgAkEBIAIoAqAcayIdNgLgGyACQfj///8BIAIoAqQcayIXNgLkGyACQb//2/wBIAIoAqgcayIhNgLoGyACQf+LoNoBIAIoAqwcayIiNgLsGyACQbuqgewBIAIoArAcayIjNgLwGyACQdCJkOAAIAIoArQcayIkNgL0GyACQeeZg6kBIAIoArgcayIlNgL4GyACQa/nlNMAIAIoArwcayImNgL8GyACQafbzwMgAigCwBxrIic2AoAcIAJBACACKALEHGsiLDYChBwgAkEAIAIoAsgcayIDNgKIHCACQQAgAigCzBxrIgU2AowcIAJBACACKALQHGsiLTYCkBwgAkEAIAIoAtQcayIfNgKUHCACQeAbahCwAyAgSARAIAIgHzYC5AEgAiAtNgLgASACIAU2AtwBIAIgAzYC2AEgAiAsNgLUASACICc2AtABIAIgJjYCzAEgAiAlNgLIASACICQ2AsQBIAIgIzYCwAEgAiAiNgK8ASACICE2ArgBIAIgFzYCtAEgAiAdNgKwASApICkQjwMgAkHoEWoiBiAGEJADIAJB2BNqIgYgBhCPAyAtIRsgBSEaIAMhGSAsIRggJyEWICYhFSAlIRQgJCETICMhDiAiIQ0gISEMIBchCSAdIQYgHyEPCyACIAZB/////wFxNgKwASACIAkgBkEddWoiBkH/////AXE2ArQBIAIgDCAGQR11aiIGQf////8BcTYCuAEgAiANIAZBHXVqIgZB/////wFxNgK8ASACIA4gBkEddWoiBkH/////AXE2AsABIAIgEyAGQR11aiIGQf////8BcTYCxAEgAiAUIAZBHXVqIgZB/////wFxNgLIASACIBUgBkEddWoiBkH/////AXE2AswBIAIgFiAGQR11aiIGQf////8BcTYC0AEgAiAYIAZBHXVqIgZB/////wFxNgLUASACIBkgBkEddWoiBkH/////AXE2AtgBIAIgGiAGQR11aiIGQf////8BcTYC3AEgAiAbIAZBHXVqIgZB/////wFxNgLgASACIA8gBkEddWo2AuQBIB4QsAMhHiACIAIoAugBIgY2AqAcIAIgAigC7AEiCTYCpBwgAiACKALwASIMNgKoHCACIAIoAvQBIg02AqwcIAIgAigC+AEiDjYCsBwgAiACKAL8ASITNgK0HCACIAIoAoACIhQ2ArgcIAIgAigChAIiFTYCvBwgAiACKAKIAiIWNgLAHCACIAIoAowCIhg2AsQcIAIgAigCkAIiGTYCyBwgAiACKAKUAiIaNgLMHCACIAIoApgCIhs2AtAcIAIgAigCnAIiDzYC1BwgAkGgHGogAkGgA2oQ2wIgAkEBIAIoAqAcayIgNgLgGyACQfj///8BIAIoAqQcayIdNgLkGyACQb//2/wBIAIoAqgcayIpNgLoGyACQf+LoNoBIAIoAqwcayIXNgLsGyACQbuqgewBIAIoArAcayIhNgLwGyACQdCJkOAAIAIoArQcayIiNgL0GyACQeeZg6kBIAIoArgcayIjNgL4GyACQa/nlNMAIAIoArwcayIkNgL8GyACQafbzwMgAigCwBxrIiU2AoAcQQAhLSACQQAgAigCxBxrIiY2AoQcIAJBACACKALIHGsiJzYCiBwgAkEAIAIoAswcayIsNgKMHCACQQAgAigC0BxrIgM2ApAcIAJBACACKALUHGsiBTYClBwgAkHgG2oQsAMgHkgEQCACIAU2ApwCIAIgAzYCmAIgAiAsNgKUAiACICc2ApACIAIgJjYCjAIgAiAlNgKIAiACICQ2AoQCIAIgIzYCgAIgAiAiNgL8ASACICE2AvgBIAIgFzYC9AEgAiApNgLwASACIB02AuwBIAIgIDYC6AEgLiAuEI8DIAJBvBdqIgYgBhCQAyACQawZaiIGIAYQjwMgAyEbICwhGiAnIRkgJiEYICUhFiAkIRUgIyEUICIhEyAhIQ4gFyENICkhDCAdIQkgICEGIAUhDwsgAiAGQf////8BcTYC6AEgAiAJIAZBHXVqIgZB/////wFxNgLsASACIAwgBkEddWoiBkH/////AXE2AvABIAIgDSAGQR11aiIGQf////8BcTYC9AEgAiAOIAZBHXVqIgZB/////wFxNgL4ASACIBMgBkEddWoiBkH/////AXE2AvwBIAIgFCAGQR11aiIGQf////8BcTYCgAIgAiAVIAZBHXVqIgZB/////wFxNgKEAiACIBYgBkEddWoiBkH/////AXE2AogCIAIgGCAGQR11aiIGQf////8BcTYCjAIgAiAZIAZBHXVqIgZB/////wFxNgKQAiACIBogBkEddWoiBkH/////AXE2ApQCIAIgGyAGQR11aiIGQf////8BcTYCmAIgAiAPIAZBHXVqNgKcAiMAQeA7ayIBJAAgASACQUBrIgUoAgA2AoAHIAEgBSgCBDYChAcgASAFKAIINgKIByABIAUoAgw2AowHIAEgBSgCEDYCkAcgASAFKAIUNgKUByABIAUoAhg2ApgHIAEgBSgCHDYCnAcgASAFKAIgNgKgByABIAUoAiQ2AqQHIAEgBSgCKDYCqAcgASAFKAIsNgKsByABIAUoAjA2ArAHIAEgBSgCNDYCtAcgASAFKAI4NgK4ByABIAUoAjw2ArwHIAEgBSgCQDYCwAcgASAFKAJENgLEByABIAUoAkg2AsgHIAEgBSgCTDYCzAcgASAFKAJQNgLQByABIAUoAlQ2AtQHIAEgBSgCWDYC2AcgASAFKAJcNgLcByABIAUoAmA2AuAHIAEgBSgCZDYC5AcgASAFKAJoNgLoByABIAUoAmw2AuwHIAEgBSgCcDYC8AcgASAFKAJ0NgL0ByABIAUoAng2AvgHIAEgBSgCfDYC/AcgASAFKAKAATYCgAggASAFKAKEATYChAggASAFKAKIATYCiAggASAFKAKMATYCjAggASAFKAKQATYCkAggASAFKAKUATYClAggASAFKAKYATYCmAggASAFKAKcATYCnAggASAFKAKgATYCoAggASAFKAKkATYCpAggASAFKAKoATYCqAggASAFKAKsATYCrAggASAFKAKwATYCsAggASAFKAK0ATYCtAggASAFKAK4ATYCuAggASAFKAK8ATYCvAggASAFKALAATYCwAggASAFKALEATYCxAggASAFKALIATYCyAggASAFKALMATYCzAggASAFKALQATYC0AggASAFKALUATYC1AggASAFKALYATYC2AggASAFKALcATYC3AggAUGoCGohAyABQfAHaiEoIAFBuAdqISsgAkHQBGoiHCABQcAOakcEQCABQcAOaiAcEOQCIAFBuA9qIBxB+ABqEOQCIAFBsBBqIBxB8AFqEOQCIAFBqBFqIBxB6AJqEOQCIAFBoBJqIBxB4ANqEOQCIAFBmBNqIBxB2ARqEOQCIAEgHCgC0AU2ApAUCyABIAEoAsAONgKUFCABIAH9AALEDv0LA5gUIAEgAf0AAtQO/QsDqBQgASAB/QAC5A79CwO4FCABIAH9AAL0Dv0LA8gUIAEgAf0AAoQP/QsD2BQgASAB/QAClA/9CwPoFCABIAEpAqQPNwP4FCABIAEoAqwPNgKAFSABIAEoArAPNgKEFSABIAH9AAK0D/0LA4gVIAEgAf0AAsQP/QsDmBUgASAB/QAC1A/9CwOoFSABIAH9AALkD/0LA7gVIAEgAf0AAvQP/QsDyBUgASAB/QAChBD9CwPYFSABIAEpApQQNwPoFSABIAEoApwQNgLwFSABIAEoAqAQNgL0FSABIAH9AAKkEP0LA/gVIAEgAf0AArQQ/QsDiBYgASAB/QACxBD9CwOYFiABIAH9AALUEP0LA6gWIAEgAf0AAuQQ/QsDuBYgASAB/QAC9BD9CwPIFiABIAEpAoQRNwPYFiABIAEoAowRNgLgFiABIAEoApARNgLkFiABIAEoApQRNgLoFiABIAEoApgRNgLsFiABIAEoApwRNgLwFiABIAEoAqARNgL0FiABIAEoAqQRNgL4FiABIAEoAqgRNgL8FiABIAEoAqwRNgKAFyABIAEoArARNgKEFyABIAEoArQRNgKIFyABIAEoArgRNgKMFyABIAEoArwRNgKQFyABIAEoAsARNgKUFyABIAEoAsQRNgKYFyABIAEoAsgRNgKcFyABIAEoAswRNgKgFyABIAEoAtARNgKkFyABIAEoAtQRNgKoFyABIAEoAtgRNgKsFyABIAEoAtwRNgKwFyABIAEoAuARNgK0FyABIAEoAuQRNgK4FyABIAEoAugRNgK8FyABIAEoAuwRNgLAFyABIAEoAvARNgLEFyABIAEoAvQRNgLIFyABIAEoAvgRNgLMFyABIAEoAvwRNgLQFyABIAEoAoASNgLUFyABIAEoAoQSNgLYFyABIAEoAogSNgLcFyABIAEoAowSNgLgFyABIAEoApASNgLkFyABIAEoApQSNgLoFyABIAEoApgSNgLsFyABIAEoApwSNgLwFyABIAEoAqASNgL0FyABIAEoAqQSNgL4FyABIAEoAqgSNgL8FyABIAEoAqwSNgKAGCABIAEoArASNgKEGCABIAEoArQSNgKIGCABIAEoArgSNgKMGCABIAEoArwSNgKQGCABIAEoAsASNgKUGCABIAEoAsQSNgKYGCABIAEoAsgSNgKcGCABIAEoAswSNgKgGCABIAEoAtASNgKkGCABIAEoAtQSNgKoGCABIAEoAtgSNgKsGCABIAEoAtwSNgKwGCABIAEoAuASNgK0GCABIAEoAuQSNgK4GCABIAEoAugSNgK8GCABIAEoAuwSNgLAGCABIAEoAvASNgLEGCABIAEoAvQSNgLIGCABIAEoAvgSNgLMGCABIAEoAvwSNgLQGCABIAEoAoATNgLUGCABIAEoAoQTNgLYGCABIAEoAogTNgLcGCABIAEoAowTNgLgGCABIAEoApATNgLkGCABIAEoApQTNgLoGCABIAEoApgTNgLsGCABIAEoApwTNgLwGCABIAEoAqATNgL0GCABIAEoAqQTNgL4GCABIAEoAqgTNgL8GCABIAEoAqwTNgKAGSABIAEoArATNgKEGSABIAEoArQTNgKIGSABIAEoArgTNgKMGSABIAEoArwTNgKQGSABIAEoAsATNgKUGSABIAEoAsQTNgKYGSABIAEoAsgTNgKcGSABIAEoAswTNgKgGSABIAEoAtATNgKkGSABIAEoAtQTNgKoGSABIAEoAtgTNgKsGSABIAEoAtwTNgKwGSABIAEoAuATNgK0GSABIAEoAuQTNgK4GSABIAEoAugTNgK8GSABIAEoAuwTNgLAGSABIAEoAvATNgLEGSABIAEoAvQTNgLIGSABIAEoAvgTNgLMGSABIAEoAvwTNgLQGSABIAEoAoAUNgLUGSABIAEoAoQUNgLYGSABIAEoAogUNgLcGSABIAEoAowUNgLgGSABIAEoApAUNgLkGSABQZQUaiAcQdQFahCRAyABIAH9AATADv0LA+gZIAEgAf0ABNAO/QsD+BkgASABKQPgDjcDiBogASABKALoDjYCkBogASAB/QAC7A79CwKUGiABIAH9AAL8Dv0LAqQaIAEgASkCjA83ArQaIAEgASgClA82ArwaIAEgASgCmA82AsAaIAEgASgCnA82AsQaIAEgAf0ABKAP/QsDyBogASAB/QAEsA/9CwPYGiABIAH9AATAD/0LA+gaIAEgAf0ABNAP/QsD+BogASAB/QAE4A/9CwOIGyABIAH9AATwD/0LA5gbIAEgASkDgBA3A6gbIAEgASgCiBA2ArAbIAEgASgCjBA2ArQbIAEgASgCkBA2ArgbIAEgASgClBA2ArwbIAEgASgCmBA2AsAbIAEgASgCnBA2AsQbIAEgASgCoBA2AsgbIAEgASgCpBA2AswbIAEgASgCqBA2AtAbIAEgASgCrBA2AtQbIAEgASgCsBA2AtgbIAEgASgCtBA2AtwbIAEgASgCuBA2AuAbIAEgASgCvBA2AuQbIAEgASgCwBA2AugbIAEgASgCxBA2AuwbIAEgASgCyBA2AvAbIAEgASgCzBA2AvQbIAEgASgC0BA2AvgbIAEgASgC1BA2AvwbIAEgASgC2BA2AoAcIAEgASgC3BA2AoQcIAEgASgC4BA2AogcIAEgASgC5BA2AowcIAEgASgC6BA2ApAcIAEgASgC7BA2ApQcIAEgASgC8BA2ApgcIAEgASgC9BA2ApwcIAEgASgC+BA2AqAcIAEgASgC/BA2AqQcIAEgASgCgBE2AqgcIAEgASgChBE2AqwcIAEgASgCiBE2ArAcIAEgASgCjBE2ArQcIAEgASgCkBE2ArgcIAEgASgClBE2ArwcIAEgASgCmBE2AsAcIAEgASgCnBE2AsQcIAEgASgCoBE2AsgcIAEgASgCpBE2AswcIAEgASgCqBE2AtAcIAEgASgCrBE2AtQcIAEgASgCsBE2AtgcIAEgASgCtBE2AtwcIAEgASgCuBE2AuAcIAEgASgCvBE2AuQcIAEgASgCwBE2AugcIAEgASgCxBE2AuwcIAEgASgCyBE2AvAcIAEgASgCzBE2AvQcIAEgASgC0BE2AvgcIAEgASgC1BE2AvwcIAEgASgC2BE2AoAdIAEgASgC3BE2AoQdIAEgASgC4BE2AogdIAEgASgC5BE2AowdIAEgASgC6BE2ApAdIAEgASgC7BE2ApQdIAEgASgC8BE2ApgdIAEgASgC9BE2ApwdIAEgASgC+BE2AqAdIAEgASgC/BE2AqQdIAEgASgCgBI2AqgdIAEgASgChBI2AqwdIAEgASgCiBI2ArAdIAEgASgCjBI2ArQdIAEgASgCkBI2ArgdIAEgASgClBI2ArwdIAEgASgCmBI2AsAdIAEgASgCnBI2AsQdIAEgASgCoBI2AsgdIAEgASgCpBI2AswdIAEgASgCqBI2AtAdIAEgASgCrBI2AtQdIAEgASgCsBI2AtgdIAEgASgCtBI2AtwdIAEgASgCuBI2AuAdIAEgASgCvBI2AuQdIAEgASgCwBI2AugdIAEgASgCxBI2AuwdIAEgASgCyBI2AvAdIAEgASgCzBI2AvQdIAEgASgC0BI2AvgdIAEgASgC1BI2AvwdIAEgASgC2BI2AoAeIAEgASgC3BI2AoQeIAEgASgC4BI2AogeIAEgASgC5BI2AoweIAEgASgC6BI2ApAeIAEgASgC7BI2ApQeIAEgASgC8BI2ApgeIAEgASgC9BI2ApweIAEgASgC+BI2AqAeIAEgASgC/BI2AqQeIAEgASgCgBM2AqgeIAEgASgChBM2AqweIAEgASgCiBM2ArAeIAEgASgCjBM2ArQeIAEgASgCkBM2ArgeIAEgASgClBM2ArweIAEgASgCmBM2AsAeIAEgASgCnBM2AsQeIAEgASgCoBM2AsgeIAEgASgCpBM2AsweIAEgASgCqBM2AtAeIAEgASgCrBM2AtQeIAEgASgCsBM2AtgeIAEgASgCtBM2AtweIAEgASgCuBM2AuAeIAEgASgCvBM2AuQeIAEgASgCwBM2AugeIAEgASgCxBM2AuweIAEgASgCyBM2AvAeIAEgASgCzBM2AvQeIAEgASgC0BM2AvgeIAEgASgC1BM2AvweIAEgASgC2BM2AoAfIAEgASgC3BM2AoQfIAEgASgC4BM2AogfIAEgASgC5BM2AowfIAEgASgC6BM2ApAfIAEgASgC7BM2ApQfIAEgASgC8BM2ApgfIAEgASgC9BM2ApwfIAEgASgC+BM2AqAfIAEgASgC/BM2AqQfIAEgASgCgBQ2AqgfIAEgASgChBQ2AqwfIAEgASgCiBQ2ArAfIAEgASgCjBQ2ArQfIAEgASgCkBQ2ArgfIAFB6BlqIBxBqAtqIgUQkQMgASABKAKUFDYCvB8gASABKAKYFDYCwB8gASABKAKcFDYCxB8gASABKAKgFDYCyB8gASABKAKkFDYCzB8gASABKAKoFDYC0B8gASABKAKsFDYC1B8gASABKAKwFDYC2B8gASABKAK0FDYC3B8gASABKAK4FDYC4B8gASABKAK8FDYC5B8gASAB/QAEwBT9CwPoHyABIAH9AATQFP0LA/gfIAEgAf0ABOAU/QsDiCAgASAB/QAE8BT9CwOYICABIAH9AASAFf0LA6ggIAEgAf0ABJAV/QsDuCAgASABKQOgFTcDyCAgASABKAKoFTYC0CAgASABKAKsFTYC1CAgASAB/QAEsBX9CwPYICABIAH9AATAFf0LA+ggIAEgAf0ABNAV/QsD+CAgASAB/QAE4BX9CwOIISABIAH9AATwFf0LA5ghIAEgAf0ABIAW/QsDqCEgASABKQOQFjcDuCEgASABKAKYFjYCwCEgASABKAKcFjYCxCEgASABKAKgFjYCyCEgASABKAKkFjYCzCEgASABKAKoFjYC0CEgASABKAKsFjYC1CEgASABKAKwFjYC2CEgASABKAK0FjYC3CEgASABKAK4FjYC4CEgASABKAK8FjYC5CEgASABKALAFjYC6CEgASABKALEFjYC7CEgASABKALIFjYC8CEgASABKALMFjYC9CEgASABKALQFjYC+CEgASABKALUFjYC/CEgASABKALYFjYCgCIgASABKALcFjYChCIgASABKALgFjYCiCIgASABKALkFjYCjCIgASABKALoFjYCkCIgASABKALsFjYClCIgASABKALwFjYCmCIgASABKAL0FjYCnCIgASABKAL4FjYCoCIgASABKAL8FjYCpCIgASABKAKAFzYCqCIgASABKAKEFzYCrCIgASABKAKIFzYCsCIgASABKAKMFzYCtCIgASABKAKQFzYCuCIgASABKAKUFzYCvCIgASABKAKYFzYCwCIgASABKAKcFzYCxCIgASABKAKgFzYCyCIgASABKAKkFzYCzCIgASABKAKoFzYC0CIgASABKAKsFzYC1CIgASABKAKwFzYC2CIgASABKAK0FzYC3CIgASABKAK4FzYC4CIgASABKAK8FzYC5CIgASABKALAFzYC6CIgASABKALEFzYC7CIgASABKALIFzYC8CIgASABKALMFzYC9CIgASABKALQFzYC+CIgASABKALUFzYC/CIgASABKALYFzYCgCMgASABKALcFzYChCMgASABKALgFzYCiCMgASABKALkFzYCjCMgASABKALoFzYCkCMgASABKALsFzYClCMgASABKALwFzYCmCMgASABKAL0FzYCnCMgASABKAL4FzYCoCMgASABKAL8FzYCpCMgASABKAKAGDYCqCMgASABKAKEGDYCrCMgASABKAKIGDYCsCMgASABKAKMGDYCtCMgASABKAKQGDYCuCMgASABKAKUGDYCvCMgASABKAKYGDYCwCMgASABKAKcGDYCxCMgASABKAKgGDYCyCMgASABKAKkGDYCzCMgASABKAKoGDYC0CMgASABKAKsGDYC1CMgASABKAKwGDYC2CMgASABKAK0GDYC3CMgASABKAK4GDYC4CMgASABKAK8GDYC5CMgASABKALAGDYC6CMgASABKALEGDYC7CMgASABKALIGDYC8CMgASABKALMGDYC9CMgASABKALQGDYC+CMgASABKALUGDYC/CMgASABKALYGDYCgCQgASABKALcGDYChCQgASABKALgGDYCiCQgASABKALkGDYCjCQgASABKALoGDYCkCQgASABKALsGDYClCQgASABKALwGDYCmCQgASABKAL0GDYCnCQgASABKAL4GDYCoCQgASABKAL8GDYCpCQgASABKAKAGTYCqCQgASABKAKEGTYCrCQgASABKAKIGTYCsCQgASABKAKMGTYCtCQgASABKAKQGTYCuCQgASABKAKUGTYCvCQgASABKAKYGTYCwCQgASABKAKcGTYCxCQgASABKAKgGTYCyCQgASABKAKkGTYCzCQgASABKAKoGTYC0CQgASABKAKsGTYC1CQgASABKAKwGTYC2CQgASABKAK0GTYC3CQgASABKAK4GTYC4CQgASABKAK8GTYC5CQgASABKALAGTYC6CQgASABKALEGTYC7CQgASABKALIGTYC8CQgASABKALMGTYC9CQgASABKALQGTYC+CQgASABKALUGTYC/CQgASABKALYGTYCgCUgASABKALcGTYChCUgASABKALgGTYCiCUgASABKALkGTYCjCUgAUG8H2ogBRCRAyABIAEoAsAONgKQJSABIAEoAsQONgKUJSABIAEoAsgONgKYJSABIAEoAswONgKcJSABIAEoAtAONgKgJSABIAEoAtQONgKkJSABIAEoAtgONgKoJSABIAEoAtwONgKsJSABIAEoAuAONgKwJSABIAEoAuQONgK0JSABIAEoAugONgK4JSABIAH9AALsDv0LArwlIAEgAf0AAvwO/QsCzCUgASAB/QACjA/9CwLcJSABIAH9AAKcD/0LAuwlIAEgAf0AAqwP/QsC/CUgASAB/QACvA/9CwKMJiABIAEpAswPNwKcJiABIAEoAtQPNgKkJiABIAEoAtgPNgKoJiABIAH9AALcD/0LAqwmIAEgAf0AAuwP/QsCvCYgASAB/QAC/A/9CwLMJiABIAH9AAKMEP0LAtwmIAEgAf0AApwQ/QsC7CYgASAB/QACrBD9CwL8JiABIAEpArwQNwKMJyABIAEoAsQQNgKUJyABIAEoAsgQNgKYJyABIAEoAswQNgKcJyABIAEoAtAQNgKgJyABIAEoAtQQNgKkJyABIAEoAtgQNgKoJyABIAEoAtwQNgKsJyABIAEoAuAQNgKwJyABIAEoAuQQNgK0JyABIAEoAugQNgK4JyABIAEoAuwQNgK8JyABIAEoAvAQNgLAJyABIAEoAvQQNgLEJyABIAEoAvgQNgLIJyABIAEoAvwQNgLMJyABIAEoAoARNgLQJyABIAEoAoQRNgLUJyABIAEoAogRNgLYJyABIAEoAowRNgLcJyABIAEoApARNgLgJyABIAEoApQRNgLkJyABIAEoApgRNgLoJyABIAEoApwRNgLsJyABIAEoAqARNgLwJyABIAEoAqQRNgL0JyABIAEoAqgRNgL4JyABIAEoAqwRNgL8JyABIAEoArARNgKAKCABIAEoArQRNgKEKCABIAEoArgRNgKIKCABIAEoArwRNgKMKCABIAEoAsARNgKQKCABIAEoAsQRNgKUKCABIAEoAsgRNgKYKCABIAEoAswRNgKcKCABIAEoAtARNgKgKCABIAEoAtQRNgKkKCABIAEoAtgRNgKoKCABIAEoAtwRNgKsKCABIAEoAuARNgKwKCABIAEoAuQRNgK0KCABIAEoAugRNgK4KCABIAEoAuwRNgK8KCABIAEoAvARNgLAKCABIAEoAvQRNgLEKCABIAEoAvgRNgLIKCABIAEoAvwRNgLMKCABIAEoAoASNgLQKCABIAEoAoQSNgLUKCABIAEoAogSNgLYKCABIAEoAowSNgLcKCABIAEoApASNgLgKCABIAEoApQSNgLkKCABIAEoApgSNgLoKCABIAEoApwSNgLsKCABIAEoAqASNgLwKCABIAEoAqQSNgL0KCABIAEoAqgSNgL4KCABIAEoAqwSNgL8KCABIAEoArASNgKAKSABIAEoArQSNgKEKSABIAEoArgSNgKIKSABIAEoArwSNgKMKSABIAEoAsASNgKQKSABIAEoAsQSNgKUKSABIAEoAsgSNgKYKSABIAEoAswSNgKcKSABIAEoAtASNgKgKSABIAEoAtQSNgKkKSABIAEoAtgSNgKoKSABIAEoAtwSNgKsKSABIAEoAuASNgKwKSABIAEoAuQSNgK0KSABIAEoAugSNgK4KSABIAEoAuwSNgK8KSABIAEoAvASNgLAKSABIAEoAvQSNgLEKSABIAEoAvgSNgLIKSABIAEoAvwSNgLMKSABIAEoAoATNgLQKSABIAEoAoQTNgLUKSABIAEoAogTNgLYKSABIAEoAowTNgLcKSABIAEoApATNgLgKSABIAEoApQTNgLkKSABIAEoApgTNgLoKSABIAEoApwTNgLsKSABIAEoAqATNgLwKSABIAEoAqQTNgL0KSABIAEoAqgTNgL4KSABIAEoAqwTNgL8KSABIAEoArATNgKAKiABIAEoArQTNgKEKiABIAEoArgTNgKIKiABIAEoArwTNgKMKiABIAEoAsATNgKQKiABIAEoAsQTNgKUKiABIAEoAsgTNgKYKiABIAEoAswTNgKcKiABIAEoAtATNgKgKiABIAEoAtQTNgKkKiABIAEoAtgTNgKoKiABIAEoAtwTNgKsKiABIAEoAuATNgKwKiABIAEoAuQTNgK0KiABIAEoAugTNgK4KiABIAEoAuwTNgK8KiABIAEoAvATNgLAKiABIAEoAvQTNgLEKiABIAEoAvgTNgLIKiABIAEoAvwTNgLMKiABIAEoAoAUNgLQKiABIAEoAoQUNgLUKiABIAEoAogUNgLYKiABIAEoAowUNgLcKiABIAEoApAUNgLgKiABQZAlaiAcQfwQaiIFEJEDIAEgASgClBQ2AuQqIAEgASgCmBQ2AugqIAEgASgCnBQ2AuwqIAEgASgCoBQ2AvAqIAEgASgCpBQ2AvQqIAEgASgCqBQ2AvgqIAEgASgCrBQ2AvwqIAEgASgCsBQ2AoArIAEgASgCtBQ2AoQrIAEgASgCuBQ2AogrIAEgASgCvBQ2AowrIAEgAf0ABMAU/QsEkCsgASAB/QAE0BT9CwSgKyABIAH9AATgFP0LBLArIAEgAf0ABPAU/QsEwCsgASAB/QAEgBX9CwTQKyABIAH9AASQFf0LBOArIAEgASkDoBU3A/ArIAEgASgCqBU2AvgrIAEgASgCrBU2AvwrIAEgAf0ABLAV/QsEgCwgASAB/QAEwBX9CwSQLCABIAH9AATQFf0LBKAsIAEgAf0ABOAV/QsEsCwgASAB/QAE8BX9CwTALCABIAH9AASAFv0LBNAsIAEgASkDkBY3A+AsIAEgASgCmBY2AugsIAEgASgCnBY2AuwsIAEgASgCoBY2AvAsIAEgASgCpBY2AvQsIAEgASgCqBY2AvgsIAEgASgCrBY2AvwsIAEgASgCsBY2AoAtIAEgASgCtBY2AoQtIAEgASgCuBY2AogtIAEgASgCvBY2AowtIAEgASgCwBY2ApAtIAEgASgCxBY2ApQtIAEgASgCyBY2ApgtIAEgASgCzBY2ApwtIAEgASgC0BY2AqAtIAEgASgC1BY2AqQtIAEgASgC2BY2AqgtIAEgASgC3BY2AqwtIAEgASgC4BY2ArAtIAEgASgC5BY2ArQtIAEgASgC6BY2ArgtIAEgASgC7BY2ArwtIAEgASgC8BY2AsAtIAEgASgC9BY2AsQtIAEgASgC+BY2AsgtIAEgASgC/BY2AswtIAEgASgCgBc2AtAtIAEgASgChBc2AtQtIAEgASgCiBc2AtgtIAEgASgCjBc2AtwtIAEgASgCkBc2AuAtIAEgASgClBc2AuQtIAEgASgCmBc2AugtIAEgASgCnBc2AuwtIAEgASgCoBc2AvAtIAEgASgCpBc2AvQtIAEgASgCqBc2AvgtIAEgASgCrBc2AvwtIAEgASgCsBc2AoAuIAEgASgCtBc2AoQuIAEgASgCuBc2AoguIAEgASgCvBc2AowuIAEgASgCwBc2ApAuIAEgASgCxBc2ApQuIAEgASgCyBc2ApguIAEgASgCzBc2ApwuIAEgASgC0Bc2AqAuIAEgASgC1Bc2AqQuIAEgASgC2Bc2AqguIAEgASgC3Bc2AqwuIAEgASgC4Bc2ArAuIAEgASgC5Bc2ArQuIAEgASgC6Bc2ArguIAEgASgC7Bc2ArwuIAEgASgC8Bc2AsAuIAEgASgC9Bc2AsQuIAEgASgC+Bc2AsguIAEgASgC/Bc2AswuIAEgASgCgBg2AtAuIAEgASgChBg2AtQuIAEgASgCiBg2AtguIAEgASgCjBg2AtwuIAEgASgCkBg2AuAuIAEgASgClBg2AuQuIAEgASgCmBg2AuguIAEgASgCnBg2AuwuIAEgASgCoBg2AvAuIAEgASgCpBg2AvQuIAEgASgCqBg2AvguIAEgASgCrBg2AvwuIAEgASgCsBg2AoAvIAEgASgCtBg2AoQvIAEgASgCuBg2AogvIAEgASgCvBg2AowvIAEgASgCwBg2ApAvIAEgASgCxBg2ApQvIAEgASgCyBg2ApgvIAEgASgCzBg2ApwvIAEgASgC0Bg2AqAvIAEgASgC1Bg2AqQvIAEgASgC2Bg2AqgvIAEgASgC3Bg2AqwvIAEgASgC4Bg2ArAvIAEgASgC5Bg2ArQvIAEgASgC6Bg2ArgvIAEgASgC7Bg2ArwvIAEgASgC8Bg2AsAvIAEgASgC9Bg2AsQvIAEgASgC+Bg2AsgvIAEgASgC/Bg2AswvIAEgASgCgBk2AtAvIAEgASgChBk2AtQvIAEgASgCiBk2AtgvIAEgASgCjBk2AtwvIAEgASgCkBk2AuAvIAEgASgClBk2AuQvIAEgASgCmBk2AugvIAEgASgCnBk2AuwvIAEgASgCoBk2AvAvIAEgASgCpBk2AvQvIAEgASgCqBk2AvgvIAEgASgCrBk2AvwvIAEgASgCsBk2AoAwIAEgASgCtBk2AoQwIAEgASgCuBk2AogwIAEgASgCvBk2AowwIAEgASgCwBk2ApAwIAEgASgCxBk2ApQwIAEgASgCyBk2ApgwIAEgASgCzBk2ApwwIAEgASgC0Bk2AqAwIAEgASgC1Bk2AqQwIAEgASgC2Bk2AqgwIAEgASgC3Bk2AqwwIAEgASgC4Bk2ArAwIAEgASgC5Bk2ArQwIAFB5CpqIAUQkQMgASABKALoGTYCuDAgASABKALsGTYCvDAgASABKALwGTYCwDAgASABKAL0GTYCxDAgASABKAL4GTYCyDAgASABKAL8GTYCzDAgASABKAKAGjYC0DAgASABKAKEGjYC1DAgASABKAKIGjYC2DAgASABKAKMGjYC3DAgASABKAKQGjYC4DAgASAB/QAClBr9CwLkMCABIAH9AAKkGv0LAvQwIAEgAf0AArQa/QsChDEgASAB/QACxBr9CwKUMSABIAH9AALUGv0LAqQxIAEgAf0AAuQa/QsCtDEgASABKQL0GjcCxDEgASABKAL8GjYCzDEgASABKAKAGzYC0DEgASAB/QAChBv9CwLUMSABIAH9AAKUG/0LAuQxIAEgAf0AAqQb/QsC9DEgASAB/QACtBv9CwKEMiABIAH9AALEG/0LApQyIAEgAf0AAtQb/QsCpDIgASABKQLkGzcCtDIgASABKALsGzYCvDIgASABKALwGzYCwDIgASABKAL0GzYCxDIgASABKAL4GzYCyDIgASABKAL8GzYCzDIgASABKAKAHDYC0DIgASABKAKEHDYC1DIgASABKAKIHDYC2DIgASABKAKMHDYC3DIgASABKAKQHDYC4DIgASABKAKUHDYC5DIgASABKAKYHDYC6DIgASABKAKcHDYC7DIgASABKAKgHDYC8DIgASABKAKkHDYC9DIgASABKAKoHDYC+DIgASABKAKsHDYC/DIgASABKAKwHDYCgDMgASABKAK0HDYChDMgASABKAK4HDYCiDMgASABKAK8HDYCjDMgASABKALAHDYCkDMgASABKALEHDYClDMgASABKALIHDYCmDMgASABKALMHDYCnDMgASABKALQHDYCoDMgASABKALUHDYCpDMgASABKALYHDYCqDMgASABKALcHDYCrDMgASABKALgHDYCsDMgASABKALkHDYCtDMgASABKALoHDYCuDMgASABKALsHDYCvDMgASABKALwHDYCwDMgASABKAL0HDYCxDMgASABKAL4HDYCyDMgASABKAL8HDYCzDMgASABKAKAHTYC0DMgASABKAKEHTYC1DMgASABKAKIHTYC2DMgASABKAKMHTYC3DMgASABKAKQHTYC4DMgASABKAKUHTYC5DMgASABKAKYHTYC6DMgASABKAKcHTYC7DMgASABKAKgHTYC8DMgASABKAKkHTYC9DMgASABKAKoHTYC+DMgASABKAKsHTYC/DMgASABKAKwHTYCgDQgASABKAK0HTYChDQgASABKAK4HTYCiDQgASABKAK8HTYCjDQgASABKALAHTYCkDQgASABKALEHTYClDQgASABKALIHTYCmDQgASABKALMHTYCnDQgASABKALQHTYCoDQgASABKALUHTYCpDQgASABKALYHTYCqDQgASABKALcHTYCrDQgASABKALgHTYCsDQgASABKALkHTYCtDQgASABKALoHTYCuDQgASABKALsHTYCvDQgASABKALwHTYCwDQgASABKAL0HTYCxDQgASABKAL4HTYCyDQgASABKAL8HTYCzDQgASABKAKAHjYC0DQgASABKAKEHjYC1DQgASABKAKIHjYC2DQgASABKAKMHjYC3DQgASABKAKQHjYC4DQgASABKAKUHjYC5DQgASABKAKYHjYC6DQgASABKAKcHjYC7DQgASABKAKgHjYC8DQgASABKAKkHjYC9DQgASABKAKoHjYC+DQgASABKAKsHjYC/DQgASABKAKwHjYCgDUgASABKAK0HjYChDUgASABKAK4HjYCiDUgASABKAK8HjYCjDUgASABKALAHjYCkDUgASABKALEHjYClDUgASABKALIHjYCmDUgASABKALMHjYCnDUgASABKALQHjYCoDUgASABKALUHjYCpDUgASABKALYHjYCqDUgASABKALcHjYCrDUgASABKALgHjYCsDUgASABKALkHjYCtDUgASABKALoHjYCuDUgASABKALsHjYCvDUgASABKALwHjYCwDUgASABKAL0HjYCxDUgASABKAL4HjYCyDUgASABKAL8HjYCzDUgASABKAKAHzYC0DUgASABKAKEHzYC1DUgASABKAKIHzYC2DUgASABKAKMHzYC3DUgASABKAKQHzYC4DUgASABKAKUHzYC5DUgASABKAKYHzYC6DUgASABKAKcHzYC7DUgASABKAKgHzYC8DUgASABKAKkHzYC9DUgASABKAKoHzYC+DUgASABKAKsHzYC/DUgASABKAKwHzYCgDYgASABKAK0HzYChDYgASABKAK4HzYCiDYgAUG4MGogBRCRAyABIAEoArwfNgKMNiABIAEoAsAfNgKQNiABIAEoAsQfNgKUNiABIAEoAsgfNgKYNiABIAEoAswfNgKcNiABIAEoAtAfNgKgNiABIAEoAtQfNgKkNiABIAEoAtgfNgKoNiABIAEoAtwfNgKsNiABIAEoAuAfNgKwNiABIAEoAuQfNgK0NiABIAH9AAPoH/0LA7g2IAEgAf0AA/gf/QsDyDYgASAB/QADiCD9CwPYNiABIAH9AAOYIP0LA+g2IAEgAf0AA6gg/QsD+DYgASAB/QADuCD9CwOINyABIAEpA8ggNwOYNyABIAEoAtAgNgKgNyABIAEoAtQgNgKkNyABIAH9AAPYIP0LA6g3IAEgAf0AA+gg/QsDuDcgASAB/QAD+CD9CwPINyABIAH9AAOIIf0LA9g3IAEgAf0AA5gh/QsD6DcgASAB/QADqCH9CwP4NyABIAEpA7ghNwOIOCABIAEoAsAhNgKQOCABIAEoAsQhNgKUOCABIAEoAsghNgKYOCABIAEoAswhNgKcOCABIAEoAtAhNgKgOCABIAEoAtQhNgKkOCABIAEoAtghNgKoOCABIAEoAtwhNgKsOCABIAEoAuAhNgKwOCABIAEoAuQhNgK0OCABIAEoAughNgK4OCABIAEoAuwhNgK8OCABIAEoAvAhNgLAOCABIAEoAvQhNgLEOCABIAEoAvghNgLIOCABIAEoAvwhNgLMOCABIAEoAoAiNgLQOCABIAEoAoQiNgLUOCABIAEoAogiNgLYOCABIAEoAowiNgLcOCABIAEoApAiNgLgOCABIAEoApQiNgLkOCABIAEoApgiNgLoOCABIAEoApwiNgLsOCABIAEoAqAiNgLwOCABIAEoAqQiNgL0OCABIAEoAqgiNgL4OCABIAEoAqwiNgL8OCABIAEoArAiNgKAOSABIAEoArQiNgKEOSABIAEoArgiNgKIOSABIAEoArwiNgKMOSABIAEoAsAiNgKQOSABIAEoAsQiNgKUOSABIAEoAsgiNgKYOSABIAEoAswiNgKcOSABIAEoAtAiNgKgOSABIAEoAtQiNgKkOSABIAEoAtgiNgKoOSABIAEoAtwiNgKsOSABIAEoAuAiNgKwOSABIAEoAuQiNgK0OSABIAEoAugiNgK4OSABIAEoAuwiNgK8OSABIAEoAvAiNgLAOSABIAEoAvQiNgLEOSABIAEoAvgiNgLIOSABIAEoAvwiNgLMOSABIAEoAoAjNgLQOSABIAEoAoQjNgLUOSABIAEoAogjNgLYOSABIAEoAowjNgLcOSABIAEoApAjNgLgOSABIAEoApQjNgLkOSABIAEoApgjNgLoOSABIAEoApwjNgLsOSABIAEoAqAjNgLwOSABIAEoAqQjNgL0OSABIAEoAqgjNgL4OSABIAEoAqwjNgL8OSABIAEoArAjNgKAOiABIAEoArQjNgKEOiABIAEoArgjNgKIOiABIAEoArwjNgKMOiABIAEoAsAjNgKQOiABIAEoAsQjNgKUOiABIAEoAsgjNgKYOiABIAEoAswjNgKcOiABIAEoAtAjNgKgOiABIAEoAtQjNgKkOiABIAEoAtgjNgKoOiABIAEoAtwjNgKsOiABIAEoAuAjNgKwOiABIAEoAuQjNgK0OiABIAEoAugjNgK4OiABIAEoAuwjNgK8OiABIAEoAvAjNgLAOiABIAEoAvQjNgLEOiABIAEoAvgjNgLIOiABIAEoAvwjNgLMOiABIAEoAoAkNgLQOiABIAEoAoQkNgLUOiABIAEoAogkNgLYOiABIAEoAowkNgLcOiABIAEoApAkNgLgOiABIAEoApQkNgLkOiABIAEoApgkNgLoOiABIAEoApwkNgLsOiABIAEoAqAkNgLwOiABIAEoAqQkNgL0OiABIAEoAqgkNgL4OiABIAEoAqwkNgL8OiABIAEoArAkNgKAOyABIAEoArQkNgKEOyABIAEoArgkNgKIOyABIAEoArwkNgKMOyABIAEoAsAkNgKQOyABIAEoAsQkNgKUOyABIAEoAsgkNgKYOyABIAEoAswkNgKcOyABIAEoAtAkNgKgOyABIAEoAtQkNgKkOyABIAEoAtgkNgKoOyABIAEoAtwkNgKsOyABIAEoAuAkNgKwOyABIAEoAuQkNgK0OyABIAEoAugkNgK4OyABIAEoAuwkNgK8OyABIAEoAvAkNgLAOyABIAEoAvQkNgLEOyABIAEoAvgkNgLIOyABIAEoAvwkNgLMOyABIAEoAoAlNgLQOyABIAEoAoQlNgLUOyABIAEoAoglNgLYOyABIAEoAowlNgLcOyABQYw2aiAFEJEDIAEgASgCgAciBUH/////AXEgBUECbyIsa0EBaiIHQf////8BcTYCgAcgASABKAKEByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYChAcgASABKAKIByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCiAcgASABKAKMByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCjAcgASABKAKQByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCkAcgASABKAKUByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYClAcgASABKAKYByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCmAcgASABKAKcByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCnAcgASABKAKgByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCoAcgASABKAKkByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCpAcgASABKAKoByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCqAcgASABKAKsByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCrAcgASABKAKwByAFQR11aiIFQf////8BcSAHQR12aiIHQf////8BcTYCsAcgASABKAK0ByAFQR11aiAHQR12ajYCtAcgAUIANwPwBiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AYgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNAGIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTABiABQcAGaiABQcAGaiABQYAHahC7CCABQcAGaiABQcAGaiArELsIIAFBwAZqIAFBwAZqICgQuwggAUHABmogAUHABmogAxC7CCABIAFBwAZqELADIgNqQQE6AAACQAJAIANBAEoEQEEAISggASgCtAchBSABKAKwByErIAEoAqwHIQcgASgCqAchMiABKAKkByEzIAEoAqAHITQgASgCnAchNSABKAKYByE2IAEoApQHITcgASgCkAchOCABKAKMByEeIAEoAogHIS4gASgChAchICABKAKAByEvA0AgASAoaiAvQQF1Ii9BAm9BAXRBAWs6AAAgBUEcdCEwICtBHHQhMSAHQRx0ISkgMkEcdCEdIDNBHHQhKiA0QRx0IQYgNUEcdCEXIDZBHHQhHyA3QRx0IQkgOEEcdCEMIB5BHHQhDSAuQRx0IQ4gIEEcdEGAgICAAXEgL3IhLyAFQQF1IQUgMEGAgICAAXEgK0EBdXIiMCErIDFBgICAgAFxIAdBAXVyIjEhByApQYCAgIABcSAyQQF1ciIpITIgHUGAgICAAXEgM0EBdXIiHSEzICpBgICAgAFxIDRBAXVyIiohNCAGQYCAgIABcSA1QQF1ciIGITUgF0GAgICAAXEgNkEBdXIiFyE2IB9BgICAgAFxIDdBAXVyIh8hNyAJQYCAgIABcSA4QQF1ciIJITggDEGAgICAAXEgHkEBdXIiDCEeIA1BgICAgAFxIC5BAXVyIg0hLiAOQYCAgIABcSAgQQF1ciIOISAgKEEBaiIoIANHDQALIAEgBTYCtAcgASAwNgKwByABIDE2AqwHIAEgKTYCqAcgASAdNgKkByABICo2AqAHIAEgBjYCnAcgASAXNgKYByABIB82ApQHIAEgCTYCkAcgASAMNgKMByABIA02AogHIAEgDjYChAcgASAvNgKABwwBCyADQQBIDQELQQAhBSABKALcCCEyIAEoAtgIITMgASgC1AghNCABKALQCCE1IAEoAswIITYgASgCyAghNyABKALECCE4IAEoAsAIIR4gASgCvAghLiABKAK4CCEgIAEoArQIIS8gASgCsAghMCABKAKsCCExIAEoAqgIISggASgCpAghKSABKAKgCCEdIAEoApwIISogASgCmAghBiABKAKUCCEXIAEoApAIIR8gASgCjAghCSABKAKICCEMIAEoAoQIIQ0gASgCgAghDiABKAL8ByEYIAEoAvgHIRMgASgC9AchFCABKALwByErIAEoAuwHIRkgASgC6AchGiABKALkByEbIAEoAuAHIQ8gASgC3AchISABKALYByEiIAEoAtQHISMgASgC0AchJCABKALMByElIAEoAsgHISYgASgCxAchJyABKALAByEVIAEoArwHIRYgASgCuAchBwNAIAFBoANqIAVqIAEgBWosAAAiCCArQQJvbCIKQQF0IAdBAm8gCGwiC2ogKEECbyAIbCIIQQJ0ajoAACAvQRx0QYCAgIABcSAwQQF1ciAwQRx0QYCAgIABcSAxQQF1ciAoQR51aiIwQR11aiIQQf////8BcSAwQf////8BcSAxQRx0IChBAXZyQf////8BcSAIQQF1ayIoQR11aiIxQR11aiIIQf////8BcSEwIBhBHHRBgICAgAFxIBNBAXVyIBNBHHRBgICAgAFxIBRBAXVyICtBHnVqIhNBHXVqIhFB/////wFxIBNB/////wFxIBRBHHQgK0EBdnJB/////wFxIApBAXVrIitBHXVqIhRBHXVqIgpB/////wFxIRMgJ0EcdEGAgICAAXEgFUEBdXIgFUEcdEGAgICAAXEgFkEBdXIgB0EedWoiFUEddWoiEkH/////AXEgFUH/////AXEgFkEcdCAHQQF2ckH/////AXEgC0EBdWsiB0EddWoiFkEddWoiC0H/////AXEhFSAgQRx0QYCAgIABcSAvQQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSEvIA5BHHRBgICAgAFxIBhBAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIRggJkEcdEGAgICAAXEgJ0EBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhJyAuQRx0QYCAgIABcSAgQQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSEgIA1BHHRBgICAgAFxIA5BAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIQ4gJUEcdEGAgICAAXEgJkEBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhJiAeQRx0QYCAgIABcSAuQQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSEuIAxBHHRBgICAgAFxIA1BAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIQ0gJEEcdEGAgICAAXEgJUEBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhJSA4QRx0QYCAgIABcSAeQQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSEeIAlBHHRBgICAgAFxIAxBAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIQwgI0EcdEGAgICAAXEgJEEBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhJCA3QRx0QYCAgIABcSA4QQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSE4IB9BHHRBgICAgAFxIAlBAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIQkgIkEcdEGAgICAAXEgI0EBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhIyA2QRx0QYCAgIABcSA3QQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSE3IBdBHHRBgICAgAFxIB9BAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIR8gIUEcdEGAgICAAXEgIkEBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhIiA1QRx0QYCAgIABcSA2QQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSE2IAZBHHRBgICAgAFxIBdBAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIRcgD0EcdEGAgICAAXEgIUEBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhISA0QRx0QYCAgIABcSA1QQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSE1ICpBHHRBgICAgAFxIAZBAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIQYgG0EcdEGAgICAAXEgD0EBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhDyAzQRx0QYCAgIABcSA0QQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSE0IB1BHHRBgICAgAFxICpBAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxISogGkEcdEGAgICAAXEgG0EBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhGyAyQRx0QYCAgIABcSAzQQF1ciAQQR11aiIQQf////8BcSAIQR11aiIIQf////8BcSEzIClBHHRBgICAgAFxIB1BAXVyIBFBHXVqIhFB/////wFxIApBHXVqIgpB/////wFxIR0gGUEcdEGAgICAAXEgGkEBdXIgEkEddWoiEkH/////AXEgC0EddWoiC0H/////AXEhGiAyQQF1IBBBHXVqIAhBHXVqITIgKUEBdSARQR11aiAKQR11aiEpIBlBAXUgEkEddWogC0EddWohGSAxQf////8BcSExIBRB/////wFxIRQgFkH/////AXEhFiAoQf////8BcSEoICtB/////wFxISsgB0H/////AXEhByADIAVHIQggBUEBaiEFIAgNAAsgASAyNgLcCCABIDM2AtgIIAEgNDYC1AggASA1NgLQCCABIDY2AswIIAEgNzYCyAggASA4NgLECCABIB42AsAIIAEgLjYCvAggASAgNgK4CCABIC82ArQIIAEgMDYCsAggASAxNgKsCCABICg2AqgIIAEgKTYCpAggASAdNgKgCCABICo2ApwIIAEgBjYCmAggASAXNgKUCCABIB82ApAIIAEgCTYCjAggASAMNgKICCABIA02AoQIIAEgDjYCgAggASAYNgL8ByABIBM2AvgHIAEgFDYC9AcgASArNgLwByABIBk2AuwHIAEgGjYC6AcgASAbNgLkByABIA82AuAHIAEgITYC3AcgASAiNgLYByABICM2AtQHIAEgJDYC0AcgASAlNgLMByABICY2AsgHIAEgJzYCxAcgASAVNgLAByABIBY2ArwHIAEgBzYCuAcLIAQgAUHADmogAUGgA2ogA2osAABBAXRBAXIQygggA0EASgRAA0AgAUHsCGogAUHADmogA0EBayIFIAFBoANqaiwAAEEBdCABIAVqLAAAahDKCCAEIAQQlAMgBCABQewIahCRAyADQQFLISggBSEDICgNAAsLIAFB7AhqIBxHBEAgAUHsCGogHBDkAiABQeQJaiAcQfgAahDkAiABQdwKaiAcQfABahDkAiABQdQLaiAcQegCahDkAiABQcwMaiAcQeADahDkAiABQcQNaiAcQdgEahDkAiABIBwoAtAFNgK8DgsgAUHsCGogAUHsCGoQjwMgAUHcCmoiBSAFEJADIAFBzAxqIgUgBRCPAyABQewIaiAEEJEDIAQgLEEBayIFIAQoAgAiAyABKALsCHNxIANzNgIAIAQgBCgCBCIDIAEoAvAIcyAFcSADczYCBCAEIAQoAggiAyABKAL0CHMgBXEgA3M2AgggBCAEKAIMIgMgASgC+AhzIAVxIANzNgIMIAQgBCgCECIDIAEoAvwIcyAFcSADczYCECAEIAQoAhQiAyABKAKACXMgBXEgA3M2AhQgBCAEKAIYIgMgASgChAlzIAVxIANzNgIYIAQgBCgCHCIDIAEoAogJcyAFcSADczYCHCAEIAQoAiAiAyABKAKMCXMgBXEgA3M2AiAgBCAEKAIkIgMgASgCkAlzIAVxIANzNgIkIAQgBCgCKCIDIAEoApQJcyAFcSADczYCKCAEIAQoAiwiAyABKAKYCXMgBXEgA3M2AiwgBCAEKAIwIgMgASgCnAlzIAVxIANzNgIwIAQgBCgCNCIDIAEoAqAJcyAFcSADczYCNCAEIAQoAjgiAyABKAKkCXMgBXEgA3M2AjggBCAEKAI8IgMgASgCqAlzIAVxIANzNgI8IAQgBCgCQCIDIAEoAqwJcyAFcSADczYCQCAEIAQoAkQiAyABKAKwCXMgBXEgA3M2AkQgBCAEKAJIIgMgASgCtAlzIAVxIANzNgJIIAQgBCgCTCIDIAEoArgJcyAFcSADczYCTCAEIAQoAlAiAyABKAK8CXMgBXEgA3M2AlAgBCAEKAJUIgMgASgCwAlzIAVxIANzNgJUIAQgBCgCWCIDIAEoAsQJcyAFcSADczYCWCAEIAQoAlwiAyABKALICXMgBXEgA3M2AlwgBCAEKAJgIgMgASgCzAlzIAVxIANzNgJgIAQgBCgCZCIDIAEoAtAJcyAFcSADczYCZCAEIAQoAmgiAyABKALUCXMgBXEgA3M2AmggBCAEKAJsIgMgASgC2AlzIAVxIANzNgJsIAQgBCgCcCIDIAEoAtwJcyAFcSADczYCcCAEIAQoAnQiAyABKALgCXMgBXEgA3M2AnQgBCAEKAJ4IgMgASgC5AlzIAVxIANzNgJ4IAQgBCgCfCIDIAEoAugJcyAFcSADczYCfCAEIAQoAoABIgMgASgC7AlzIAVxIANzNgKAASAEIAQoAoQBIgMgASgC8AlzIAVxIANzNgKEASAEIAQoAogBIgMgASgC9AlzIAVxIANzNgKIASAEIAQoAowBIgMgASgC+AlzIAVxIANzNgKMASAEIAQoApABIgMgASgC/AlzIAVxIANzNgKQASAEIAQoApQBIgMgASgCgApzIAVxIANzNgKUASAEIAQoApgBIgMgASgChApzIAVxIANzNgKYASAEIAQoApwBIgMgASgCiApzIAVxIANzNgKcASAEIAQoAqABIgMgASgCjApzIAVxIANzNgKgASAEIAQoAqQBIgMgASgCkApzIAVxIANzNgKkASAEIAQoAqgBIgMgASgClApzIAVxIANzNgKoASAEIAQoAqwBIgMgASgCmApzIAVxIANzNgKsASAEIAQoArABIgMgASgCnApzIAVxIANzNgKwASAEIAQoArQBIgMgASgCoApzIAVxIANzNgK0ASAEIAQoArgBIgMgASgCpApzIAVxIANzNgK4ASAEIAQoArwBIgMgASgCqApzIAVxIANzNgK8ASAEIAQoAsABIgMgASgCrApzIAVxIANzNgLAASAEIAQoAsQBIgMgASgCsApzIAVxIANzNgLEASAEIAQoAsgBIgMgASgCtApzIAVxIANzNgLIASAEIAQoAswBIgMgASgCuApzIAVxIANzNgLMASAEIAQoAtABIgMgASgCvApzIAVxIANzNgLQASAEIAQoAtQBIgMgASgCwApzIAVxIANzNgLUASAEIAQoAtgBIgMgASgCxApzIAVxIANzNgLYASAEIAQoAtwBIgMgASgCyApzIAVxIANzNgLcASAEIAQoAuABIgMgASgCzApzIAVxIANzNgLgASAEIAQoAuQBIgMgASgC0ApzIAVxIANzNgLkASAEIAQoAugBIgMgASgC1ApzIAVxIANzNgLoASAEIAQoAuwBIgMgASgC2ApzIAVxIANzNgLsASAEIAQoAvABIgMgASgC3ApzIAVxIANzNgLwASAEIAQoAvQBIgMgASgC4ApzIAVxIANzNgL0ASAEIAQoAvgBIgMgASgC5ApzIAVxIANzNgL4ASAEIAQoAvwBIgMgASgC6ApzIAVxIANzNgL8ASAEIAQoAoACIgMgASgC7ApzIAVxIANzNgKAAiAEIAQoAoQCIgMgASgC8ApzIAVxIANzNgKEAiAEIAQoAogCIgMgASgC9ApzIAVxIANzNgKIAiAEIAQoAowCIgMgASgC+ApzIAVxIANzNgKMAiAEIAQoApACIgMgASgC/ApzIAVxIANzNgKQAiAEIAQoApQCIgMgASgCgAtzIAVxIANzNgKUAiAEIAQoApgCIgMgASgChAtzIAVxIANzNgKYAiAEIAQoApwCIgMgASgCiAtzIAVxIANzNgKcAiAEIAQoAqACIgMgASgCjAtzIAVxIANzNgKgAiAEIAQoAqQCIgMgASgCkAtzIAVxIANzNgKkAiAEIAQoAqgCIgMgASgClAtzIAVxIANzNgKoAiAEIAQoAqwCIgMgASgCmAtzIAVxIANzNgKsAiAEIAQoArACIgMgASgCnAtzIAVxIANzNgKwAiAEIAQoArQCIgMgASgCoAtzIAVxIANzNgK0AiAEIAQoArgCIgMgASgCpAtzIAVxIANzNgK4AiAEIAQoArwCIgMgASgCqAtzIAVxIANzNgK8AiAEIAQoAsACIgMgASgCrAtzIAVxIANzNgLAAiAEIAQoAsQCIgMgASgCsAtzIAVxIANzNgLEAiAEIAQoAsgCIgMgASgCtAtzIAVxIANzNgLIAiAEIAQoAswCIgMgASgCuAtzIAVxIANzNgLMAiAEIAQoAtACIgMgASgCvAtzIAVxIANzNgLQAiAEIAQoAtQCIgMgASgCwAtzIAVxIANzNgLUAiAEIAQoAtgCIgMgASgCxAtzIAVxIANzNgLYAiAEIAQoAtwCIgMgASgCyAtzIAVxIANzNgLcAiAEIAQoAuACIgMgASgCzAtzIAVxIANzNgLgAiAEIAQoAuQCIgMgASgC0AtzIAVxIANzNgLkAiAEIAQoAugCIgMgASgC1AtzIAVxIANzNgLoAiAEIAQoAuwCIgMgASgC2AtzIAVxIANzNgLsAiAEIAQoAvACIgMgASgC3AtzIAVxIANzNgLwAiAEIAQoAvQCIgMgASgC4AtzIAVxIANzNgL0AiAEIAQoAvgCIgMgASgC5AtzIAVxIANzNgL4AiAEIAQoAvwCIgMgASgC6AtzIAVxIANzNgL8AiAEIAQoAoADIgMgASgC7AtzIAVxIANzNgKAAyAEIAQoAoQDIgMgASgC8AtzIAVxIANzNgKEAyAEIAQoAogDIgMgASgC9AtzIAVxIANzNgKIAyAEIAQoAowDIgMgASgC+AtzIAVxIANzNgKMAyAEIAQoApADIgMgASgC/AtzIAVxIANzNgKQAyAEIAQoApQDIgMgASgCgAxzIAVxIANzNgKUAyAEIAQoApgDIgMgASgChAxzIAVxIANzNgKYAyAEIAQoApwDIgMgASgCiAxzIAVxIANzNgKcAyAEIAQoAqADIgMgASgCjAxzIAVxIANzNgKgAyAEIAQoAqQDIgMgASgCkAxzIAVxIANzNgKkAyAEIAQoAqgDIgMgASgClAxzIAVxIANzNgKoAyAEIAQoAqwDIgMgASgCmAxzIAVxIANzNgKsAyAEIAQoArADIgMgASgCnAxzIAVxIANzNgKwAyAEIAQoArQDIgMgASgCoAxzIAVxIANzNgK0AyAEIAQoArgDIgMgASgCpAxzIAVxIANzNgK4AyAEIAQoArwDIgMgASgCqAxzIAVxIANzNgK8AyAEIAQoAsADIgMgASgCrAxzIAVxIANzNgLAAyAEIAQoAsQDIgMgASgCsAxzIAVxIANzNgLEAyAEIAQoAsgDIgMgASgCtAxzIAVxIANzNgLIAyAEIAQoAswDIgMgASgCuAxzIAVxIANzNgLMAyAEIAQoAtADIgMgASgCvAxzIAVxIANzNgLQAyAEIAQoAtQDIgMgASgCwAxzIAVxIANzNgLUAyAEIAQoAtgDIgMgASgCxAxzIAVxIANzNgLYAyAEIAQoAtwDIgMgASgCyAxzIAVxIANzNgLcAyAEIAQoAuADIgMgASgCzAxzIAVxIANzNgLgAyAEIAQoAuQDIgMgASgC0AxzIAVxIANzNgLkAyAEIAQoAugDIgMgASgC1AxzIAVxIANzNgLoAyAEIAQoAuwDIgMgASgC2AxzIAVxIANzNgLsAyAEIAQoAvADIgMgASgC3AxzIAVxIANzNgLwAyAEIAQoAvQDIgMgASgC4AxzIAVxIANzNgL0AyAEIAQoAvgDIgMgASgC5AxzIAVxIANzNgL4AyAEIAQoAvwDIgMgASgC6AxzIAVxIANzNgL8AyAEIAQoAoAEIgMgASgC7AxzIAVxIANzNgKABCAEIAQoAoQEIgMgASgC8AxzIAVxIANzNgKEBCAEIAQoAogEIgMgASgC9AxzIAVxIANzNgKIBCAEIAQoAowEIgMgASgC+AxzIAVxIANzNgKMBCAEIAQoApAEIgMgASgC/AxzIAVxIANzNgKQBCAEIAQoApQEIgMgASgCgA1zIAVxIANzNgKUBCAEIAQoApgEIgMgASgChA1zIAVxIANzNgKYBCAEIAQoApwEIgMgASgCiA1zIAVxIANzNgKcBCAEIAQoAqAEIgMgASgCjA1zIAVxIANzNgKgBCAEIAQoAqQEIgMgASgCkA1zIAVxIANzNgKkBCAEIAQoAqgEIgMgASgClA1zIAVxIANzNgKoBCAEIAQoAqwEIgMgASgCmA1zIAVxIANzNgKsBCAEIAQoArAEIgMgASgCnA1zIAVxIANzNgKwBCAEIAQoArQEIgMgASgCoA1zIAVxIANzNgK0BCAEIAQoArgEIgMgASgCpA1zIAVxIANzNgK4BCAEIAQoArwEIgMgASgCqA1zIAVxIANzNgK8BCAEIAQoAsAEIgMgASgCrA1zIAVxIANzNgLABCAEIAQoAsQEIgMgASgCsA1zIAVxIANzNgLEBCAEIAQoAsgEIgMgASgCtA1zIAVxIANzNgLIBCAEIAQoAswEIgMgASgCuA1zIAVxIANzNgLMBCAEIAQoAtAEIgMgASgCvA1zIAVxIANzNgLQBCAEIAQoAtQEIgMgASgCwA1zIAVxIANzNgLUBCAEIAQoAtgEIgMgASgCxA1zIAVxIANzNgLYBCAEIAQoAtwEIgMgASgCyA1zIAVxIANzNgLcBCAEIAQoAuAEIgMgASgCzA1zIAVxIANzNgLgBCAEIAQoAuQEIgMgASgC0A1zIAVxIANzNgLkBCAEIAQoAugEIgMgASgC1A1zIAVxIANzNgLoBCAEIAQoAuwEIgMgASgC2A1zIAVxIANzNgLsBCAEIAQoAvAEIgMgASgC3A1zIAVxIANzNgLwBCAEIAQoAvQEIgMgASgC4A1zIAVxIANzNgL0BCAEIAQoAvgEIgMgASgC5A1zIAVxIANzNgL4BCAEIAQoAvwEIgMgASgC6A1zIAVxIANzNgL8BCAEIAQoAoAFIgMgASgC7A1zIAVxIANzNgKABSAEIAQoAoQFIgMgASgC8A1zIAVxIANzNgKEBSAEIAQoAogFIgMgASgC9A1zIAVxIANzNgKIBSAEIAQoAowFIgMgASgC+A1zIAVxIANzNgKMBSAEIAQoApAFIgMgASgC/A1zIAVxIANzNgKQBSAEIAQoApQFIgMgASgCgA5zIAVxIANzNgKUBSAEIAQoApgFIgMgASgChA5zIAVxIANzNgKYBSAEIAQoApwFIgMgASgCiA5zIAVxIANzNgKcBSAEIAQoAqAFIgMgASgCjA5zIAVxIANzNgKgBSAEIAQoAqQFIgMgASgCkA5zIAVxIANzNgKkBSAEIAQoAqgFIgMgASgClA5zIAVxIANzNgKoBSAEIAQoAqwFIgMgASgCmA5zIAVxIANzNgKsBSAEIAQoArAFIgMgASgCnA5zIAVxIANzNgKwBSAEIAQoArQFIgMgASgCoA5zIAVxIANzNgK0BSAEIAQoArgFIgMgASgCpA5zIAVxIANzNgK4BSAEIAQoArwFIgMgASgCqA5zIAVxIANzNgK8BSAEIAQoAsAFIgMgASgCrA5zIAVxIANzNgLABSAEIAQoAsQFIgMgASgCsA5zIAVxIANzNgLEBSAEIAQoAsgFIgMgASgCtA5zIAVxIANzNgLIBSAEIAQoAswFIgMgASgCuA5zIAVxIANzNgLMBSAEIAQoAtAFIgMgASgCvA5zIAVxIANzNgLQBSAEENICIARBPGoQ0gIgBEH4AGoQ0gIgBEG0AWoQ0gIgBEHwAWoQ0gIgBEGsAmoQ0gIgBEHoAmoQ0gIgBEGkA2oQ0gIgBEHgA2oQ0gIgBEGcBGoQ0gIgBEHYBGoQ0gIgBEGUBWoQ0gIgAUHgO2okAAsgOhDQAkGkiDQoAgAiBgRAIAIgOTYC0AQCQAJAIAYoAgAiBCACKALQBEsNACACKALQBCAEIAYoAhBqTw0AIDkgBigCBDYCACAGIDk2AgQgBiAGKAIIQQFqNgIIIAYoAhQiBkEESQ0BIAZBfHEiBkUNASA5QQAgBvwLAAwBCyA5ECsLIDpFDQEMAgsgORArIDoNAQsgAiAtNgIEIAJBu70pNgIAIABB/IgqIAIQbAALIAJBu70pNgIQIABB4IcqIAJBEGoQmwEgAkHgHGokAEEBC5kcAQN/IwBB8AJrIgEkACABQYXiKTYCMCAAQfmGKiABQTBqEJsBIABBARDIASIDRQRAIAFB+8spNgIEIAFBheIpNgIAIABB/IgqIAEQbAALIABB7AVBARDaASECIABB2OHOfUHR7isQkAEaIABBfhDbASACQtSFgICABDcCECACQbPsKygAADYAAyACQbDsKygAADYAACABQdQFNgIgIABBq/grIAFBIGoQWyABQUBrIAMoAggQtAIgAUKr1Jn1wQE3A7ABIAFCvLn+6PDPrbwCNwOoASABQpnH2dnx6NupHDcDoAEgAULby8OLkbaJxwg3A5gBIAFC0tm486C1k7QRNwOQASABQuin9paw5JiRCTcDiAEgAUKu7/ut4aHzmBA3A4ABIAFBwAFqIAFBQGsgAUGAAWoQ0wIgAUKjvcSA0AE3A+ACIAFC7dOblsGm8/8SNwPYAiABQsvukbvhrJeNEjcD0AIgAULDufbXoJSczxA3A8gCIAFC6oOJ+4DrnqgJNwPAAiABQu7//6ehrP//FzcDuAIgAUKr1f7/8f//+w83A7ACIAJBGGogAUGwAmogAUHAAWoQyQIgAkECNgJQIAFBQGsgAygCCEEwahC0AiABQqvUmfXBATcDsAEgAUK8uf7o8M+tvAI3A6gBIAFCmcfZ2fHo26kcNwOgASABQtvLw4uRtonHCDcDmAEgAULS2bjzoLWTtBE3A5ABIAFC6Kf2lrDkmJEJNwOIASABQq7v+63hofOYEDcDgAEgAUHAAWogAUFAayABQYABahDTAiABQqO9xIDQATcD4AIgAULt05uWwabz/xI3A9gCIAFCy+6Ru+Gsl40SNwPQAiABQsO59teglJzPEDcDyAIgAULqg4n7gOueqAk3A8ACIAFC7v//p6Gs//8XNwO4AiABQqvV/v/x///7DzcDsAIgAkHUAGogAUGwAmogAUHAAWoQyQIgAkECNgKMASABQUBrIAMoAghB4ABqELQCIAFCq9SZ9cEBNwOwASABQry5/ujwz628AjcDqAEgAUKZx9nZ8ejbqRw3A6ABIAFC28vDi5G2iccINwOYASABQtLZuPOgtZO0ETcDkAEgAULop/aWsOSYkQk3A4gBIAFCru/7reGh85gQNwOAASABQcABaiABQUBrIAFBgAFqENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiACQZABaiABQbACaiABQcABahDJAiACQQI2AsgBIAFBQGsgAygCCEGQAWoQtAIgAUKr1Jn1wQE3A7ABIAFCvLn+6PDPrbwCNwOoASABQpnH2dnx6NupHDcDoAEgAULby8OLkbaJxwg3A5gBIAFC0tm486C1k7QRNwOQASABQuin9paw5JiRCTcDiAEgAUKu7/ut4aHzmBA3A4ABIAFBwAFqIAFBQGsgAUGAAWoQ0wIgAUKjvcSA0AE3A+ACIAFC7dOblsGm8/8SNwPYAiABQsvukbvhrJeNEjcD0AIgAULDufbXoJSczxA3A8gCIAFC6oOJ+4DrnqgJNwPAAiABQu7//6ehrP//FzcDuAIgAUKr1f7/8f//+w83A7ACIAJBzAFqIAFBsAJqIAFBwAFqEMkCIAJBAjYChAIgAUFAayADKAIIQcABahC0AiABQqvUmfXBATcDsAEgAUK8uf7o8M+tvAI3A6gBIAFCmcfZ2fHo26kcNwOgASABQtvLw4uRtonHCDcDmAEgAULS2bjzoLWTtBE3A5ABIAFC6Kf2lrDkmJEJNwOIASABQq7v+63hofOYEDcDgAEgAUHAAWogAUFAayABQYABahDTAiABQqO9xIDQATcD4AIgAULt05uWwabz/xI3A9gCIAFCy+6Ru+Gsl40SNwPQAiABQsO59teglJzPEDcDyAIgAULqg4n7gOueqAk3A8ACIAFC7v//p6Gs//8XNwO4AiABQqvV/v/x///7DzcDsAIgAkGIAmogAUGwAmogAUHAAWoQyQIgAkECNgLAAiABQUBrIAMoAghB8AFqELQCIAFCq9SZ9cEBNwOwASABQry5/ujwz628AjcDqAEgAUKZx9nZ8ejbqRw3A6ABIAFC28vDi5G2iccINwOYASABQtLZuPOgtZO0ETcDkAEgAULop/aWsOSYkQk3A4gBIAFCru/7reGh85gQNwOAASABQcABaiABQUBrIAFBgAFqENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiACQcQCaiABQbACaiABQcABahDJAiACQQI2AvwCIAFBQGsgAygCCEGgAmoQtAIgAUKr1Jn1wQE3A7ABIAFCvLn+6PDPrbwCNwOoASABQpnH2dnx6NupHDcDoAEgAULby8OLkbaJxwg3A5gBIAFC0tm486C1k7QRNwOQASABQuin9paw5JiRCTcDiAEgAUKu7/ut4aHzmBA3A4ABIAFBwAFqIAFBQGsgAUGAAWoQ0wIgAUKjvcSA0AE3A+ACIAFC7dOblsGm8/8SNwPYAiABQsvukbvhrJeNEjcD0AIgAULDufbXoJSczxA3A8gCIAFC6oOJ+4DrnqgJNwPAAiABQu7//6ehrP//FzcDuAIgAUKr1f7/8f//+w83A7ACIAJBgANqIAFBsAJqIAFBwAFqEMkCIAJBAjYCuAMgAUFAayADKAIIQdACahC0AiABQqvUmfXBATcDsAEgAUK8uf7o8M+tvAI3A6gBIAFCmcfZ2fHo26kcNwOgASABQtvLw4uRtonHCDcDmAEgAULS2bjzoLWTtBE3A5ABIAFC6Kf2lrDkmJEJNwOIASABQq7v+63hofOYEDcDgAEgAUHAAWogAUFAayABQYABahDTAiABQqO9xIDQATcD4AIgAULt05uWwabz/xI3A9gCIAFCy+6Ru+Gsl40SNwPQAiABQsO59teglJzPEDcDyAIgAULqg4n7gOueqAk3A8ACIAFC7v//p6Gs//8XNwO4AiABQqvV/v/x///7DzcDsAIgAkG8A2ogAUGwAmogAUHAAWoQyQIgAkECNgL0AyABQUBrIAMoAghBgANqELQCIAFCq9SZ9cEBNwOwASABQry5/ujwz628AjcDqAEgAUKZx9nZ8ejbqRw3A6ABIAFC28vDi5G2iccINwOYASABQtLZuPOgtZO0ETcDkAEgAULop/aWsOSYkQk3A4gBIAFCru/7reGh85gQNwOAASABQcABaiABQUBrIAFBgAFqENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiACQfgDaiABQbACaiABQcABahDJAiACQQI2ArAEIAFBQGsgAygCCEGwA2oQtAIgAUKr1Jn1wQE3A7ABIAFCvLn+6PDPrbwCNwOoASABQpnH2dnx6NupHDcDoAEgAULby8OLkbaJxwg3A5gBIAFC0tm486C1k7QRNwOQASABQuin9paw5JiRCTcDiAEgAUKu7/ut4aHzmBA3A4ABIAFBwAFqIAFBQGsgAUGAAWoQ0wIgAUKjvcSA0AE3A+ACIAFC7dOblsGm8/8SNwPYAiABQsvukbvhrJeNEjcD0AIgAULDufbXoJSczxA3A8gCIAFC6oOJ+4DrnqgJNwPAAiABQu7//6ehrP//FzcDuAIgAUKr1f7/8f//+w83A7ACIAJBtARqIAFBsAJqIAFBwAFqEMkCIAJBAjYC7AQgAUFAayADKAIIQeADahC0AiABQqvUmfXBATcDsAEgAUK8uf7o8M+tvAI3A6gBIAFCmcfZ2fHo26kcNwOgASABQtvLw4uRtonHCDcDmAEgAULS2bjzoLWTtBE3A5ABIAFC6Kf2lrDkmJEJNwOIASABQq7v+63hofOYEDcDgAEgAUHAAWogAUFAayABQYABahDTAiABQqO9xIDQATcD4AIgAULt05uWwabz/xI3A9gCIAFCy+6Ru+Gsl40SNwPQAiABQsO59teglJzPEDcDyAIgAULqg4n7gOueqAk3A8ACIAFC7v//p6Gs//8XNwO4AiABQqvV/v/x///7DzcDsAIgAkHwBGogAUGwAmogAUHAAWoQyQIgAkECNgKoBSABQUBrIAMoAghBkARqELQCIAFCq9SZ9cEBNwOwASABQry5/ujwz628AjcDqAEgAUKZx9nZ8ejbqRw3A6ABIAFC28vDi5G2iccINwOYASABQtLZuPOgtZO0ETcDkAEgAULop/aWsOSYkQk3A4gBIAFCru/7reGh85gQNwOAASABQcABaiABQUBrIAFBgAFqENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiACQawFaiABQbACaiABQcABahDJAiACQQI2AuQFIAMQmgEgAUGF4ik2AhAgAEHghyogAUEQahCbASABQfACaiQAQQELbwEDfyMAQSBrIgEkACABQdrlKzYCECAAQfmGKiABQRBqEJsBQZCWNCgCACgCJBBpIQIgACgCDCIDQQM6AAQgAyACNgIAIAAgACgCDEEIajYCDCABQdrlKzYCACAAQeCHKiABEJsBIAFBIGokAEEBC4ABAQR/IwBBIGsiASQAIAFB/ukrNgIQIABB+YYqIAFBEGoQmwFBkJY0KAIAIgIoAiQQaSEDIAIoAiQQaSECIAAoAgwiBEEDOgAEIAQgAyACQQh0cjYCACAAIAAoAgxBCGo2AgwgAUH+6Ss2AgAgAEHghyogARCbASABQSBqJABBAQueAQEGfyMAQSBrIgEkACABQbfuKzYCECAAQfmGKiABQRBqEJsBQZCWNCgCACICKAIkEGkhAyACKAIkEGkhBCACKAIkEGkhBSACKAIkEGkhAiAAKAIMIgZBAzoABCAGIAMgBEEIdHIgBUEQdHIgAkEYdHI2AgAgACAAKAIMQQhqNgIMIAFBt+4rNgIAIABB4IcqIAEQmwEgAUEgaiQAQQELsAMBB38jAEEwayIEJAAgBEGxvis2AiAgAEH5hiogBEEgahCbAUGQljQoAgAhBQJAIABBARDIASIGKAIAIgFBA0wEQCAEIAE2AhAgAEGD+CsgBEEQahBuIAAoAgxBADoABCAAIAAoAgxBCGo2AgwMAQsgBSgCJCABIAYoAggQegJAIAAgBigCABCGASIBRQRAIABB6dsrQQAQbgwBCyABKAIEIgNBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIDSA0ACwtBACECIAFBADYCACABIAYoAgAiByADIAMgB0obIgM2AgAgA0EATA0AA0AgASgCCCACaiAGKAIIIAJqLQAAOgAAIAJBAWoiAiABKAIASA0ACwsgACAAKAIQKAIkKAIMQQhqQc/iKxBZQQAhASAAQYACEIYBIQMDQCAFKAIkEGkhAiADKAIIIAFqIAI6AAAgAUEBaiIBQYACRw0ACyADQYACNgIAIAUoAiQQaRogBSgCJBBpGiAFKAIkEGkaIAUoAiQQaRoLIAYQmgEgBEGxvis2AgAgAEHghyogBBCbASAEQTBqJABBAQvRCwEEfyMAQRBrIgQkAAJAIABFDQAgACAAKAI8IgFBAWs2AjwgAUEBSg0AAkACQCAAKAI4IgJFDQACQEGkiDQoAgAiAQRAIAQgAjYCDCABKAIAIgMgBCgCDEsNASAEKAIMIAMgASgCEGpPDQEgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIAJBACAB/AsADAILIAIQKwwCCyACECsLQaSINCgCACEBCwJAAkACQAJAAkACQAJAAkACQAJAAkACQCAAKAIQIgJBnwFMBEAgAkECaw4HAgMBBAEIBwELIAJBoAFGDQggAkG4GUYNBCACQbgbRg0FCyABRQ0KDAkLIAAoAhghAiABBEAgAkUNCSAEIAI2AgwgASgCACIDIAQoAgxLDQggBCgCDCADIAEoAhBqTw0IIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiA0EESQ0JIANBfHEiA0UNCSACQQAgA/wLAAwJCyACECsgABArDAoLIAAoAhwhAiABBEAgAkUNCCAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQkgA0F8cSIDRQ0JIAJBACAD/AsADAkLIAIQKwwICyACECsgABArDAkLIAAoAiAhAiABBEAgAkUNByAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQggA0F8cSIDRQ0IIAJBACAD/AsADAgLIAIQKwwHCyACECsgABArDAgLIAAoAiQhAiABBEAgAkUNBiAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQcgA0F8cSIDRQ0HIAJBACAD/AsADAcLIAIQKwwGCyACECsgABArDAcLIAAoAighAiABBEAgAkUNBSAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQYgA0F8cSIDRQ0GIAJBACAD/AsADAYLIAIQKwwFCyACECsgABArDAYLIAAoAjAhAiABBEAgAkUNBCAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQUgA0F8cSIDRQ0FIAJBACAD/AsADAULIAIQKwwECyACECsgABArDAULIAAoAiwhAiABBEAgAkUNAyAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQQgA0F8cSIDRQ0EIAJBACAD/AsADAQLIAIQKwwDCyACECsgABArDAQLIAAoAjQhAiABBEAgAkUNAiAEIAI2AgwCQCABKAIAIgMgBCgCDEsNACAEKAIMIAMgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIDQQRJDQMgA0F8cSIDRQ0DIAJBACAD/AsADAMLIAIQKwwCCyACECsMAgsgAhArCyAEIAA2AgwgASgCACICIAQoAgxLDQAgBCgCDCACIAEoAhBqTw0AIAAgASgCBDYCACABIAA2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASAAQQAgAfwLAAwBCyAAECsLIARBEGokAAvqCgEFfyMAQSBrIgMkACADQaqsKTYCECAAQfmGKiADQRBqEJsBAkAgAEEBQZriKhDcASICRQ0AIAIgAigCPCIBQQFrNgI8IAFBAUoNAAJAIAIoAjgiAUUNAAJAQaSINCgCACIERQ0AIAMgATYCHCAEKAIAIgUgAygCHEsNACADKAIcIAUgBCgCEGpPDQAgASAEKAIENgIAIAQgATYCBCAEIAQoAghBAWo2AgggBCgCFCIEQQRJDQEgBEF8cSIERQ0BIAFBACAE/AsADAELIAEQKwsCQAJAAkACQAJAAkACQAJAAkAgAigCECIBQZ8BTARAIAFBAmsOBwECCQMJBwYJCyABQaABRg0HIAFBuBlGDQMgAUG4G0cNCCACKAIoIQJBpIg0KAIAIgFFDQQgAkUNCCADIAI2AhwgASgCACIEIAMoAhxLDQQgAygCHCAEIAEoAhBqTw0EIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0IIAFBfHEiAUUNCCACQQAgAfwLAAwICyACKAIYIQICQEGkiDQoAgAiAUUNACACRQ0IIAMgAjYCHCABKAIAIgQgAygCHEsNACADKAIcIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQggAUF8cSIBRQ0IIAJBACAB/AsADAgLIAIQKwwHCyACKAIcIQICQEGkiDQoAgAiAUUNACACRQ0HIAMgAjYCHCABKAIAIgQgAygCHEsNACADKAIcIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQcgAUF8cSIBRQ0HIAJBACAB/AsADAcLIAIQKwwGCyACKAIgIQICQEGkiDQoAgAiAUUNACACRQ0GIAMgAjYCHCABKAIAIgQgAygCHEsNACADKAIcIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQYgAUF8cSIBRQ0GIAJBACAB/AsADAYLIAIQKwwFCyACKAIkIQICQEGkiDQoAgAiAUUNACACRQ0FIAMgAjYCHCABKAIAIgQgAygCHEsNACADKAIcIAQgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQUgAUF8cSIBRQ0FIAJBACAB/AsADAULIAIQKwwECyACECsMAwsgAigCMCECAkBBpIg0KAIAIgFFDQAgAkUNAyADIAI2AhwgASgCACIEIAMoAhxLDQAgAygCHCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0DIAFBfHEiAUUNAyACQQAgAfwLAAwDCyACECsMAgsgAigCLCECAkBBpIg0KAIAIgFFDQAgAkUNAiADIAI2AhwgASgCACIEIAMoAhxLDQAgAygCHCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0CIAFBfHEiAUUNAiACQQAgAfwLAAwCCyACECsMAQsgAigCNCECAkBBpIg0KAIAIgFFDQAgAkUNASADIAI2AhwgASgCACIEIAMoAhxLDQAgAygCHCAEIAEoAhBqTw0AIAIgASgCBDYCACABIAI2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0BIAFBfHEiAUUNASACQQAgAfwLAAwBCyACECsLIANBqqwpNgIAIABB4IcqIAMQmwELIANBIGokAEEAC9YBAQN/IwBBQGoiASQAIAFBy+EpNgIwIABB+YYqIAFBMGoQmwECQCAAQQFBmuIqENwBIgIEQCACIAIoAjxBAWo2AjwgACACKAIUEIYBIgNFDQEgAiADEOYDIAMgAigCFDYCACACEOMDIAFBy+EpNgIgIABB4IcqIAFBIGoQmwEgAUFAayQAQQEPCyAAQdjYKUEAEG4gAUG04Cs2AgQgAUHL4Sk2AgAgAEH8iCogARBsAAsgAhDjAyABQejkKTYCFCABQcvhKTYCECAAQfyIKiABQRBqEGwAC7UGAgR/A34CQAJAAkACQAJAAkACQCAAKAIQIgJBnwFMBEAgAkECaw4GAQIHAwcFBwsgAkGgAUYNBSACQbgZRg0DIAJBuBtHDQYgACgCKCABKAIIEPcDDwsgACgCGCABKAIIEPgBDwsgACgCHCABKAIIEPgDDwsgACgCICABKAIIEPgDDwsgACgCJCABKAIIEPcDDwsgACgCLCICKQMAIAIoAtABIgCsIgeCpyIEQQN0IARBCG0iA0EGdGutIQYgAkEIaiIFIANBBW9BKGxqIARBKG1BA3RqIgMpAwAhCCABKAIIIQECQAJAIAAgBGtBAUYEQCADIAhChgEgBoaFNwMAIAIgAikDAEIBfCIGNwMAIAYgB4JQDQEMAgsgAyAIQgEgBoaFNwMAIAIgAikDAEIBfCIGNwMAIAYgB4JQBEAgAhDpAyACKQMAIQYgAigC0AEhAAsgAEEBayAGpyAAb0cEQANAIAIgBkIBfCIGNwMAIAYgAKyCUARAIAIQ6QMgAikDACEGIAIoAtABIQALIABBAWsgBqcgAG9HDQALCyAFIAYgAKwiB4KnIgBBCG0iBEEFb0EobGogAEEobUEDdGoiAyADKQMAQoABIABBA3QgBEEGdGuthoU3AwAgAiACKQMAQgF8IgY3AwAgBiAHgkIAUg0BCyACEOkDCyACIAEgAigC1AEQ6gMgAigC1AEhACACQQBB0AH8CwAgAkHIASAAQQF0azYC0AEPCyABKAIIIgIgACgCNCIAKAIAOgAAIAIgACgCAEEIdjoAASACIAAvAQI6AAIgAiAALQADOgADIAIgACgCBDoABCACIAAoAgRBCHY6AAUgAiAALwEGOgAGIAIgAC0ABzoAByACIAAoAgg6AAggAiAAKAIIQQh2OgAJIAIgAC8BCjoACiACIAAtAAs6AAsgAiAAKAIMOgAMIAIgACgCDEEIdjoADSACIAAvAQ46AA4gAiAALQAPOgAPIAIgACgCEDoAECACIAAoAhBBCHY6ABEgAiAALwESOgASIAIgAC0AEzoAEyAAQfDDy558NgIQIABC/rnrxemOlZkQNwIIIABCgcaUupbx6uZvNwIACwvPBgILfwN+IwBBMGsiAyQAIANBuPMpNgIgIABB+YYqIANBIGoQmwECfyAAQQFBmuIqENwBIgRFBEAgAEHY2ClBABBuQbTgKwwBCyAEIAQoAjxBAWo2AjwgAEECEMgBIgZFBEBBACEGQZyeKwwBCwJAAkACQAJAAkACQCAAKAIUKAIAQRhqIgEgACgCDEkEQCABLQAEQQ9xRQ0CIANBADYCLAwBCyAAKAIQLQAwQQ9xRQ0BIANBADYCLCAAKAIQQSxqIQELAkAgAS0ABEEDRgRAIAEoAgAhBwwBCyABIANBLGpBABD8ASEBIAMoAiwhByABDQAgAEEDEP0BCyAHQQBKDQELIAAgBCgCFBCGASIBDQFB6OQpDAQLIAAgBxCGASIJDQFB6OQpDAMLIAQgBhDoAyAEIAEQ5gMgASAEKAIUNgIADAELIAQgBhDoAyAEKAIQQQhGBEAgBCgCMCIBKQMAIAEoAtABIgKsIg2CpyIIQQN0IAhBCG0iBUEGdGutIQwgAUEIaiIKIAVBBW9BKGxqIAhBKG1BA3RqIgUpAwAhDiAJKAIIIQsCQAJAIAIgCGtBAUYEQCAFIA5CnwEgDIaFNwMAIAEgASkDAEIBfCIMNwMAIAwgDYJQDQEMAgsgBSAOQh8gDIaFNwMAIAEgASkDAEIBfCIMNwMAIAwgDYJQBEAgARDpAyABKQMAIQwgASgC0AEhAgsgAkEBayAMpyACb0cEQANAIAEgDEIBfCIMNwMAIAwgAqyCUARAIAEQ6QMgASkDACEMIAEoAtABIQILIAJBAWsgDKcgAm9HDQALCyAKIAwgAqwiDYKnIgJBCG0iCEEFb0EobGogAkEobUEDdGoiBSAFKQMAQoABIAJBA3QgCEEGdGuthoU3AwAgASABKQMAQgF8Igw3AwAgDCANgkIAUg0BCyABEOkDCyABIAsgBxDqAyAEKAIUIQEgBCgCMCICQQBB0AH8CwAgAiABNgLUASACQcgBIAFBAXRrNgLQAQsgCSAHNgIAC0EBIQJBAAshASAGEJoBIAQQ4wMgAkUEQCADIAE2AhQgA0G48yk2AhAgAEH8iCogA0EQahBsAAsgA0G48yk2AgAgAEHghyogAxCbASADQTBqJABBAQv3DAMIfwJ+AXsjAEGAAWsiAyQAAkACQAJAAkACQAJAAkACQCAAKAIQIgJBnwFMBEAgAkECaw4HBgcIBAgBAggLIAJBoAFGDQQgAkG4GUYNAiACQbgbRw0HIAEoAgAiBkEATA0HA0AgACgCKCICIAIpAwAgAjQC0AEiCoKnIgVBCG0iB0EFb0EobGogBUEobUEDdGpBCGoiCCAIKQMAIAEoAgggBGoxAAAgBUEDdCAHQQZ0a62GhTcDACACIAIpAwBCAXwiCzcDACALIAqCUARAIAIQ6QMgASgCACEGCyAEQQFqIgQgBkgNAAsMBwsgASgCACIGQQBMDQYDQCAAKAIsIgIgAikDACACNALQASIKgqciBUEIbSIHQQVvQShsaiAFQShtQQN0akEIaiIIIAgpAwAgASgCCCAEajEAACAFQQN0IAdBBnRrrYaFNwMAIAIgAikDAEIBfCILNwMAIAsgCoJQBEAgAhDpAyABKAIAIQYLIARBAWoiBCAGSA0ACwwGCyABKAIAIgZBAEwNBQNAIAAoAjAiAiACKQMAIAI0AtABIgqCpyIFQQhtIgdBBW9BKGxqIAVBKG1BA3RqQQhqIgggCCkDACABKAIIIARqMQAAIAVBA3QgB0EGdGuthoU3AwAgAiACKQMAQgF8Igs3AwAgCyAKglAEQCACEOkDIAEoAgAhBgsgBEEBaiIEIAZIDQALDAULIAEoAgAiBkEATA0EA0AgACgCJCICIAIpAwAgAjQC0AEiCoKnIgVBCG0iB0EFb0EobGogBUEobUEDdGpBCGoiCCAIKQMAIAEoAgggBGoxAAAgBUEDdCAHQQZ0a62GhTcDACACIAIpAwBCAXwiCzcDACALIAqCUARAIAIQ6QMgASgCACEGCyAEQQFqIgQgBkgNAAsMBAsgASgCACIHQQBMDQMDQCAAKAIgIgIgAikDACIKp0EDdkH4AHFqIgUgASgCCCAEajEAACAFKQNQQgiGhDcDUCACIApCCHwiCjcDAAJAAkAgClAEQCACQgA3AwAgAiACKQMIQgF8NwMIDAELIApC/weDQgBSDQELIAIQ+QMgASgCACEHCyAEQQFqIgQgB0gNAAsMAwsgASgCCCECIAAoAjQhByABKAIAIgZBwABPBEAgBiEBA0AgAyACKAAANgIAIAMgAigABDYCBCADIAIoAAg2AgggAyACKAAMNgIMIAMgAigAEDYCECADIAIoABQ2AhQgAyACKAAYNgIYIAMgAigAHDYCHCADIAIoACA2AiAgAyACKAAkNgIkIAMgAigAKDYCKCADIAIoACw2AiwgAyACKAAwNgIwIAMgAigANDYCNCADIAIoADg2AjggAyACKAA8NgI8IAcgAxDDASACQUBrIQIgAUFAaiIBQT9LDQALCyAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEcCADIAz9CwRgIAMgDP0LBFAgAyAM/QsEQAJAIAZBP3EiCUUNAEEAIQEgCUEBRwRAIAZBPnEhCANAIANBQGsgAUF8cWoiACAAKAIAIAItAAAgAUEDdEEQcSIEdHMiBTYCACAAIAItAAEgBEEIcnQgBXM2AgAgAkECaiECIAFBAmoiASAIRw0ACwsgBkEBcUUNACADQUBrIAFBfHFqIgAgACgCACACLQAAIAFBA3R0czYCAAsgA0FAayAGQTxxaiICIAIoAgBBgAEgBkEDdCICdHM2AgAgCUE4TwRAIAcgA0FAaxDDASADIAz9CwRwIAMgDP0LBGAgAyAM/QsEUCADIAz9CwRACyADIAI2AnggAyAGQR12NgJ8IAcgA0FAaxDDAQwCCyABKAIAQQBMDQEDQCAAKAIYIgIgAigCACIFQQN2QTxxaiIHIAEoAgggBGotAAAgBygCKEEIdHI2AiggAiAFQQhqIgU2AgACQAJAIAVFBEAgAkEANgIAIAIgAigCBEEBajYCBAwBCyAFQf8DcQ0BCyACEPcBCyAEQQFqIgQgASgCAEgNAAsMAQsgASgCACIHQQBMDQADQCAAKAIcIgIgAikDACIKp0EDdkH4AHFqIgUgASgCCCAEajEAACAFKQNQQgiGhDcDUCACIApCCHwiCjcDAAJAAkAgClAEQCACQgA3AwAgAiACKQMIQgF8NwMIDAELIApC/weDQgBSDQELIAIQ+QMgASgCACEHCyAEQQFqIgQgB0gNAAsLIANBgAFqJAALsQgCK34BfyAAKQMwIQQgACkDKCEHIAApAyAhCCAAKQMYIRMgACkDECEUIAApA8gBIRUgACkDwAEhICAAKQO4ASELIAApA7ABIRYgACkDqAEhISAAKQOgASEXIAApA5gBIQwgACkDkAEhDSAAKQOIASEOIAApA4ABIRggACkDeCEZIAApA3AhGiAAKQNoIQUgACkDYCEbIAApA1ghCSAAKQNQIQ8gACkDSCEcIAApA0AhHSAAKQM4IQYgACkDCCEKA0AgBiAKIBSFIBOFIAiFIAeFIgIgCSAbhSAFhSAahSAZhSIDQgGJhSIBhSEoIBUgDiAYhSANhSAMhSAXhSIQIAJCAYmFIgKFIR4gDiAWICGFIAuFICCFIBWFIhFCAYkgA4UiA4VCN4kiHyAJIAQgBoUgHYUgHIUgD4UiDiAQQgGJhSIGhUI+iSIQQn+FgyABIA+FQgKJIgmFIRUgAyAXhSEPIAYgG4UhKSABIASFISogByARIA5CAYmFIgSFISsgBiAZhUI9iSIHIAIgFoVCFIkiESADIBiFQhyJIiJCf4WDhSEWIAQgCIVCKYkiCCAQIAlCf4WDhSEXIAEgHIVCLYkiEiAiIAdCf4WDhSEOIAQgCoUiIyAeQg6JIh5Cf4WDIAMgDIVCFYkiCoUhGCACIAuFQieJIgsgCSAIQn+Fg4UhGSABIB2FQgqJIgEgD0I4iSIMIAYgGoVCD4kiJEJ/hYOFIRogBCAThUIDiSIlIAcgEkJ/hYOFIRsgBSAGhUIriSIFIB4gCkJ/hYOFIQkgCCALQn+FgyAfhSEPIAQgFIVCJIkiJiAkIAFCf4WDhSEcIAIgIIVCCIkiJyADIA2FQhmJIgNCf4WDIClCBokiDYUhHSASICVCf4WDIBGFIQYgKEIsiSISIAogBUJ/hYOFIQQgCyAfQn+FgyAQhSEHIAEgJkJ/hYMgAiAhhUIbiSIBhSEIICpCAYkiAiADIA1Cf4WDhSETICUgEUJ/hYMgIoUhFCAsQQN0QcDKMWopAwAgBSASQn+Fg4UgI4UhCiAmIAFCf4WDIAyFIh8hICArQhKJIgUgDSACQn+Fg4UiECELIBIgI0J/hYMgHoUiESEhIAEgDEJ/hYMgJIUiASEMIAIgBUJ/hYMgJ4UiAiENIAUgJ0J/hYMgA4UiAyEFICxBAWoiLEEYRw0ACyAAIBU3A8gBIAAgHzcDwAEgACAQNwO4ASAAIBY3A7ABIAAgETcDqAEgACAXNwOgASAAIAE3A5gBIAAgAjcDkAEgACAONwOIASAAIBg3A4ABIAAgBDcDMCAAIAc3AyggACAINwMgIAAgEzcDGCAAIBQ3AxAgACAZNwN4IAAgGjcDcCAAIAM3A2ggACAbNwNgIAAgCTcDWCAAIA83A1AgACAcNwNIIAAgHTcDQCAAIAY3AzggACAKNwMIC+QDAgZ/AX4gAEEIaiEHA0BBACEFA0AgBUEDdCEIQQAhBgJAA0AgASAEaiAHIAZBKGxqIAhqKQMAIgk8AAAgAiAEQQFqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCCIg8AAAgAiAEQQJqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCEIg8AAAgAiAEQQNqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCGIg8AAAgAiAEQQRqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCIIg8AAAgAiAEQQVqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCKIg8AAAgAiAEQQZqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCMIg8AAAgAiAEQQdqIgNMBEAgAyEEDAILIAMgACgC0AFvRQRAIAMhBAwCCyABIANqIAlCOIg8AAAgBEEIaiIEIAJODQEgBCAAKALQAW9FDQEgBkEBaiIGQQVHDQALIAVBAWoiBUEFRw0BCwsgAiAESgRAIAAQ6QMMAQsLC8YBAQV/IwBBMGsiASQAIAFB+74rNgIgIABB+YYqIAFBIGoQmwECfyAAQQFBmuIqENwBIgJFBEAgAEHY2ClBABBuQbTgKwwBCyACIAIoAjxBAWo2AjwgAEECEMgBIgNFBEBBACEDQZjvKgwBCyACIAMQ6ANBASEEQQALIQUgAxCaASACEOMDIARFBEAgASAFNgIUIAFB+74rNgIQIABB/IgqIAFBEGoQbAALIAFB+74rNgIAIABB4IcqIAEQmwEgAUEwaiQAQQAL1gEBA38jAEFAaiIBJAAgAUH1rSs2AjAgAEH5hiogAUEwahCbAQJAIABBAUGa4ioQ3AEiAgRAIAIgAigCPEEBajYCPCAAIAIoAhQQhgEiA0UNASACIAMQ5gMgAyACKAIUNgIAIAIQ4wMgAUH1rSs2AiAgAEHghyogAUEgahCbASABQUBrJABBAQ8LIABB2NgpQQAQbiABQbTgKzYCBCABQfWtKzYCACAAQfyIKiABEGwACyACEOMDIAFB6OQpNgIUIAFB9a0rNgIQIABB/IgqIAFBEGoQbAALgAQBB38jAEHQAGsiASQAIAFBlcgrNgJAIABB+YYqIAFBQGsQmwECQCAAQQFBmuIqENwBIgdFBEAgAEHY2ClBABBuQbTgKyEDDAELIAcgBygCPEEBajYCPEHk1ishAyAAQQIQyAEhBSAAQQMQyAEhBiAFRQ0AIAZFDQBBj+8rIQMCQAJAIAcoAhBBAmsOBAACAgECCyAAQSEQhgEiAkUEQEH3yikhAwwCC0EAIQNBICAGIAVBICACEO4DBEBBASEEDAILIAFBIDYCJCABQZXIKzYCICAAQZ31KyABQSBqEG4gACgCDEEIayICIAAoAiRNBEAgACACQX9BABBeIQILIAAgAjYCDEEBIQQgAkEBOgAEIAAgACgCDEEIajYCDAwBCyAAQcEAEIYBIgJFBEBB98opIQMMAQtBACEDQcAAIAYgBUHAACACEO4DBEBBASEEDAELIAFBwAA2AjQgAUGVyCs2AjAgAEGd9SsgAUEwahBuIAAoAgxBCGsiAiAAKAIkTQRAIAAgAkF/QQAQXiECCyAAIAI2AgxBASEEIAJBAToABCAAIAAoAgxBCGo2AgwLIAUQmgEgBhCaASAHEOMDIARFBEAgASADNgIUIAFBlcgrNgIQIABB/IgqIAFBEGoQbAALIAFBlcgrNgIAIABB4IcqIAEQmwEgAUHQAGokAEEBC6wJAQt/IwBBoAJrIgYkACAGQQA2AhwgBkKAgICAgBA3AhAgBiAGQaABajYCGCAGQQA2AgwgBkKAgICAgBA3AgAgBiAGQSBqNgIIAkAgA0EESA0AAkAgAigCACINQYABQcAAIABBIEobIg9MBEAgBkEgakEHciEJIAZBIGpBBnIhByAGQSBqQQVyIQogBkEgakEEciEIIAZBIGpBA3IhCyAGQSBqQQJyIQwgBkEgakEBciEOA0AgBkEgaiAFakEAOgAAIAUgDmpBADoAACAFIAxqQQA6AAAgBSALakEAOgAAIAUgCGpBADoAACAFIApqQQA6AAAgBSAHakEAOgAAIAUgCWpBADoAACAFQQhqIgVBgAFHDQALIAZBgAEgDSANQYABThsiBzYCACAGQSBqIQkgDUEATA0BIAdBA3EhDiACKAIIIQpBACEIQQAhBSANQQROBEAgB0H8AXEhAkEAIQsDQCAGQSBqIAVqIAUgCmotAAA6AAAgBUEBciIMIAZBIGpqIAogDGotAAA6AAAgBUECciIMIAZBIGpqIAogDGotAAA6AAAgBUEDciIMIAZBIGpqIAogDGotAAA6AAAgBUEEaiEFIAtBBGoiCyACRw0ACwsgDkUNAQNAIAZBIGogBWogBSAKai0AADoAACAFQQFqIQUgCEEBaiIIIA5HDQALDAELIAAgAkF/QQAgBkEAEI4EIAYoAgghCSAGKAIAIQcLIA8gB2siCkEASgRAIAcgBigCBCIFIAUgB0gbIAdrIQhBACEFA0AgBSAIRwRAIAcgCWpBADoAACAHQQFqIQcgBUEBaiIFIApHDQELCyAGIAc2AgALAkAgB0EASgRAIAdBA3EhDEEAIQpBACEFIAdBBE8EQCAJQQNqIQ4gCUECaiECIAlBAWohDSAHQfz///8HcSEPQQAhCANAIAUgCWoiCyALLQAAQTZzOgAAIAUgDWoiCyALLQAAQTZzOgAAIAIgBWoiCyALLQAAQTZzOgAAIAUgDmoiCyALLQAAQTZzOgAAIAVBBGohBSAIQQRqIgggD0cNAAsLIAwEQANAIAUgCWoiCCAILQAAQTZzOgAAIAVBAWohBSAKQQFqIgogDEcNAAsLQQAhCiAAIAZBfyABIAZBEGpBABCOBCAHQQNxIQtBACEFIAdBBE8EQCAJQQNqIQwgCUECaiEOIAlBAWohAiAHQfz///8HcSENQQAhBwNAIAUgCWoiCCAILQAAQeoAczoAACACIAVqIgggCC0AAEHqAHM6AAAgBSAOaiIIIAgtAABB6gBzOgAAIAUgDGoiCCAILQAAQeoAczoAACAFQQRqIQUgB0EEaiIHIA1HDQALCyALRQ0BA0AgBSAJaiIHIActAABB6gBzOgAAIAVBAWohBSAKQQFqIgogC0cNAAsMAQsgACAGQX8gASAGQRBqQQAQjgQLIAAgBkF/IAZBEGogBkEQaiADEI4EQQAhBSAEQQA2AgAgBigCGCEHA0AgBCgCBCAFTARAQQEhCQwCCyAEKAIIIAVqIAUgB2otAAA6AABBASEJIAQgBCgCAEEBajYCACAFQQFqIgUgA0cNAAsLIAZBoAJqJAAgCQucBAENfyMAQTBrIgQkACAEQc3tKzYCICAAQfmGKiAEQSBqEJsBAkAgAEEBQZriKhDcASIFRQRAIABB2NgpQQAQbgwBCyAFIAUoAjxBAWo2AjwLAn9BnJ4rIABBAhDIASIKRQ0AGkG+tCkgACAFKAIUQQ9qEIYBIgJFDQAaIAUoAhQhASMAQdAAayIDJAAgA0EANgIMIANCgICAgIAINwIAIAMgA0EQajYCCCACQQA2AgAgASIGQQFrIAFtIgFBAE4EQCABQQFqIQxBASEBA0AgBiAKIAEiC0EAIANBABCOBAJAIAYgAigCACIBIAZqSARAIAYgBm8iCEEATA0BQQAhByADKAIIIQkDQCABIAIoAgRODQIgAigCCCABaiAHIAlqLQAAOgAAIAIgAigCAEEBajYCACABQQFqIQEgB0EBaiIHIAhHDQALDAELAkAgAygCACIJQQBKBH9BACEBIAMoAgghDQNAIAIoAgAgAWoiByACKAIEIghODQIgAigCCCAHaiABIA1qLQAAOgAAIAFBAWoiASAJRw0ACyACKAIABSABCyAJaiEICyACIAg2AgALIAtBAWohASALIAxHDQALCyADQdAAaiQAQQEhAUEACyECIAoQmgEgBRDjAyABRQRAIAQgAjYCFCAEQc3tKzYCECAAQfyIKiAEQRBqEGwACyAEQc3tKzYCACAAQeCHKiAEEJsBIARBMGokAEEBC5EFAQl/IwBBMGsiAiQAIAJBwe0rNgIgIABB+YYqIAJBIGoQmwECQCAAQQFBmuIqENwBIgdFBEAgAEHY2ClBABBuDAELIAcgBygCPEEBajYCPAsgAEECEMgBIQgCQAJAAkACQCAAKAIUKAIAQRhqIgMgACgCDE8EfyAAKAIQQSxqBSADCy0ABEEPcUEFRwRAIABBAxDIASEDIAAoAhQoAgBBIGoiASAAKAIMSQRAIAEtAARBD3ENAgwECyAAKAIQLQAwQQ9xRQ0DIAJBADYCLCAAKAIQQSxqIQEMAgsgAEEDQbncKRCQARogAEEDQaX8KRCQARogAEEDQefgKhCQARogAEF9EMgBIQNBfyEEIAAoAgwiAUEMay0AACIGQQ9xRQRAQYgnIQUMBAsgAkEANgIsIAFBEGshASAGQQNGBEAgASgCACEFDAQLIAEgAkEsakEAEPwBIQEgAigCLCEFIAENAyAAQX4Q/QEMAwsgAkEANgIsCyABLQAEQQNGBEAgASgCACEFQQUhBAwCCyABIAJBLGpBABD8ASEBIAIoAiwhBUEFIQQgAQ0BIABBBBD9AQwBC0EFIQRBiCchBQtBACEBIAAgBCAIKAIAEPEDIQQCf0Gm3CkgA0UNABpBi6wpIAAgAygCAEEEahCGASIGRQ0AGiADKAIAIgkEQCAGKAIIIAMoAgggCfwKAAALIAYgAygCADYCAEG+tCkgACAEEIYBIglFDQAaIAcoAhQgCCAGIAUgBCAJEPIDQQEhAUEACyEEIAMQmgEgCBCaASAHEOMDIAEEQCACQcHtKzYCACAAQeCHKiACEJsBIAJBMGokAEEBDwsgAiAENgIUIAJBwe0rNgIQIABB/IgqIAJBEGoQbAAL4AEBA38jAEEQayIDJAACQAJAAkAgAUEASgRAIAAoAhQoAgAgAUEDdGoiBSAAKAIMIgRPBH8gACgCEEEsagUgBQstAARBD3FFDQMgA0EANgIMIAFBAEwNASAAKAIUKAIAIAFBA3RqIgIgBEkNAiAAKAIQQSxqIQIMAgsgACgCDCIEIAFBA3RqLQAEQQ9xRQ0CIANBADYCDAsgBCABQQN0aiECCyACLQAEQQNGBEAgAigCACECDAELIAIgA0EMakEAEPwBIQQgAygCDCECIAQNACAAIAEQ/QELIANBEGokACACC4YeASV/IwBBwANrIgckACAHQQA2AhwgB0KAgICAgAg3AhAgByAHQeAAajYCGCAHQQA2AgwgB0HAADYCBCAHIAdBIGo2AgggBUEANgIAAkAgBEEBayAAbSIGQQBIDQAgA0EBTARAIAZBAWohFiAHQSBqQQdyIQkgB0EgakEGciELIAdBIGpBBXIhCiAHQSBqQQRyIQwgB0EgakEDciENIAdBIGpBAnIhESAHQSBqQQFyIRpBASEQA0ACQCACKAIAIg5BBGoiCCACKAIESg0AIAIoAgggDmpBADoAACACKAIIIA5qQQA6AAEgAigCCCAOakEAOgACIAIoAgggDmpBADoAAyACIAg2AgAgDkF9SA0AIBAiBkEATA0AA0AgCEEBayITIAIoAghqIAY6AAAgCEECSQ0BIAZB/wFLIRQgBkEIdiEGIBMhCCAUDQALCyAAIAIgASAAIAdBEGoQ7gMaIAIgDjYCAEEAIQYDQCAHQSBqIAZqQQA6AAAgBiAaakEAOgAAIAYgEWpBADoAACAGIA1qQQA6AAAgBiAMakEAOgAAIAYgCmpBADoAACAGIAtqQQA6AAAgBiAJakEAOgAAIAZBCGoiBkHAAEcNAAsCQCAHKAIQIhJBAEoEQEHAACASIBJBwABOGyIUQQNxIRVBACETIAcoAhghCEEAIQYgEkEETgRAIBRB/ABxIRdBACEUA0AgB0EgaiAGaiAGIAhqLQAAOgAAIAZBAXIiDiAHQSBqaiAIIA5qLQAAOgAAIAZBAnIiDiAHQSBqaiAIIA5qLQAAOgAAIAZBA3IiDiAHQSBqaiAIIA5qLQAAOgAAIAZBBGohBiAUQQRqIhQgF0cNAAsLIBUEQANAIAdBIGogBmogBiAIai0AADoAACAGQQFqIQYgE0EBaiITIBVHDQALC0EAIQYgBygCGCETA0AgBSgCACAGaiIIIAUoAgQiD04NAiAFKAIIIAhqIAYgE2otAAA6AAAgBkEBaiIGIBJHDQALCyAFKAIAIBJqIQ8LIAUgDzYCACAQIBZGIQYgEEEBaiEQIAZFDQALDAELIAZBAWohHSAAQQROBEBBgAFBwAAgAEEgShshHkHAACAAQQFrIgYgBkHAAE8bIiFBAWohHyAHQcABakEHciEaIAdBwAFqQQZyIRMgB0HAAWpBBXIhFCAHQcABakEEciEOIAdBwAFqQQNyIRUgB0HAAWpBAnIhEiAHQcABakEBciEXIAdBIGpBB3IhIiAHQSBqQQZyISMgB0EgakEFciEkIAdBIGpBBHIhJSAHQSBqQQNyISYgB0EgakECciEnIAdBIGpBAXIhKEEBIRsDQAJAIAIoAgAiCkEEaiIIIAIoAgRKDQAgAigCCCAKakEAOgAAIAIoAgggCmpBADoAASACKAIIIApqQQA6AAIgAigCCCAKakEAOgADIAIgCDYCACAKQX1IDQAgGyIGQQBMDQADQCAIQQFrIgkgAigCCGogBjoAACAIQQJJDQEgBkH/AUshCyAGQQh2IQYgCSEIIAsNAAsLIAAgAiABIAAgB0EQahDuAxogAiAKNgIAQQAhBgNAIAdBIGogBmpBADoAACAGIChqQQA6AAAgBiAnakEAOgAAIAYgJmpBADoAACAGICVqQQA6AAAgBiAkakEAOgAAIAYgI2pBADoAACAGICJqQQA6AAAgBkEIaiIGQcAARw0ACyAHQcAAIAcoAhAiGSAZQcAAThsiCTYCACAHKAIYIRECQCAZQQBMIikNACAJQQNxIQpBACEIQQAhBiAZQQROBEAgCUH8AHEhDEEAIQkDQCAHQSBqIAZqIAYgEWotAAA6AAAgBkEBciILIAdBIGpqIAsgEWotAAA6AAAgBkECciILIAdBIGpqIAsgEWotAAA6AAAgBkEDciILIAdBIGpqIAsgEWotAAA6AAAgBkEEaiEGIAlBBGoiCSAMRw0ACwsgCkUNAANAIAdBIGogBmogBiARai0AADoAACAGQQFqIQYgCEEBaiIIIApHDQALCyAZQQAgGUEAShshD0ECIQYDQCAGISBBACEGIAdBADYCvAEgB0KAgICAgBA3ArABIAcgB0HAAmo2ArgBIAdBADYCrAEgB0KAgICAgBA3AqABIAcgB0HAAWo2AqgBAkAgHiABKAIAIgxIBEAgACABQX9BACAHQaABakEAEI4EIAcoAqgBIQggBygCoAEhCQwBCwNAIAdBwAFqIAZqQQA6AAAgBiAXakEAOgAAIAYgEmpBADoAACAGIBVqQQA6AAAgBiAOakEAOgAAIAYgFGpBADoAACAGIBNqQQA6AAAgBiAaakEAOgAAIAZBCGoiBkGAAUcNAAsgB0GAASAMIAxBgAFOGyIJNgKgASAHQcABaiEIIAxBAEwNACAJQQNxIRAgASgCCCELQQAhCkEAIQYgDEEETgRAIAlB/AFxIRZBACEMA0AgB0HAAWogBmogBiALai0AADoAACAGQQFyIg0gB0HAAWpqIAsgDWotAAA6AAAgBkECciINIAdBwAFqaiALIA1qLQAAOgAAIAZBA3IiDSAHQcABamogCyANai0AADoAACAGQQRqIQYgDEEEaiIMIBZHDQALCyAQRQ0AA0AgB0HAAWogBmogBiALai0AADoAACAGQQFqIQYgCkEBaiIKIBBHDQALCyAeIAlrIgtBAEoEQCAJIAcoAqQBIgYgBiAJSBsgCWshCkEAIQYDQCAGIApHBEAgCCAJakEAOgAAIAlBAWohCSAGQQFqIgYgC0cNAQsLIAcgCTYCoAELAkAgCUEASgRAIAlBA3EhC0EAIQpBACEGIAlBBEkiKkUEQCAIQQNqIRAgCEECaiEWIAhBAWohGCAJQfz///8HcSEcQQAhDANAIAYgCGoiDSANLQAAQTZzOgAAIAYgGGoiDSANLQAAQTZzOgAAIAYgFmoiDSANLQAAQTZzOgAAIAYgEGoiDSANLQAAQTZzOgAAIAZBBGohBiAMQQRqIgwgHEcNAAsLIAsEQANAIAYgCGoiDCAMLQAAQTZzOgAAIAZBAWohBiAKQQFqIgogC0cNAAsLQQAhCiAAIAdBoAFqQX8gByAHQbABakEAEI4EQQAhBiAqRQRAIAhBA2ohDSAIQQJqIRAgCEEBaiEWIAlB/P///wdxIRhBACEJA0AgBiAIaiIMIAwtAABB6gBzOgAAIAYgFmoiDCAMLQAAQeoAczoAACAGIBBqIgwgDC0AAEHqAHM6AAAgBiANaiIMIAwtAABB6gBzOgAAIAZBBGohBiAJQQRqIgkgGEcNAAsLIAtFDQEDQCAGIAhqIgkgCS0AAEHqAHM6AAAgBkEBaiEGIApBAWoiCiALRw0ACwwBCyAAIAdBoAFqQX8gByAHQbABakEAEI4ECyAAIAdBoAFqQX8gB0GwAWogB0GwAWogABCOBEEAIQYgBygCuAEhCAJAAkACQANAIAZBwABGDQEgB0EgaiAGaiAGIAhqLQAAOgAAAkAgBkEBciIJIABGDQAgB0EgaiAJaiAIIAlqLQAAOgAAIAZBAnIiCSAARg0AIAdBIGogCWogCCAJai0AADoAACAGQQNyIgkgAEYNACAHQSBqIAlqIAggCWotAAA6AAAgBkEEaiIGIABHDQELCyAHIB82AgAgHyEJDAELIAcgBjYCACAhIglBAEwNAQtBACEGA0AgBiAPRg0BIAYgEWoiCCAILQAAIAdBIGogBmotAABzOgAAIAZBAWoiBiAJRw0ACwsgIEEBaiEGIAMgIEcNAAtBACEGAkAgKUUEQANAIAUoAgAgBmoiCCAFKAIEIg9ODQIgBSgCCCAIaiAGIBFqLQAAOgAAIAZBAWoiBiAZRw0ACwsgBSgCACAZaiEPCyAFIA82AgAgGyAdRyEGIBtBAWohGyAGDQALDAELIANBAWsiBkF+cSEQIAZBAXEhHCAHQSBqQQdyIQwgB0EgakEGciENIAdBIGpBBXIhESAHQSBqQQRyIRogB0EgakEDciETIAdBIGpBAnIhFCAHQSBqQQFyIQ5BASEYA0ACQCACKAIAIgpBBGoiCCACKAIESg0AIAIoAgggCmpBADoAACACKAIIIApqQQA6AAEgAigCCCAKakEAOgACIAIoAgggCmpBADoAAyACIAg2AgAgCkF9SA0AIBgiBkEATA0AA0AgCEEBayIJIAIoAghqIAY6AAAgCEECSQ0BIAZB/wFLIQsgBkEIdiEGIAkhCCALDQALCyAAIAIgASAAIAdBEGoQ7gMaIAIgCjYCAEEAIQYDQCAHQSBqIAZqQQA6AAAgBiAOakEAOgAAIAYgFGpBADoAACAGIBNqQQA6AAAgBiAaakEAOgAAIAYgEWpBADoAACAGIA1qQQA6AAAgBiAMakEAOgAAIAZBCGoiBkHAAEcNAAtBwAAgBygCECIXIBdBwABOGyEJIAcoAhghCAJAIBdBAEwiEg0AIAlBA3EhD0EAIQtBACEGIBdBBE4EQCAJQfwAcSEWQQAhCgNAIAdBIGogBmogBiAIai0AADoAACAGQQFyIhUgB0EgamogCCAVai0AADoAACAGQQJyIhUgB0EgamogCCAVai0AADoAACAGQQNyIhUgB0EgamogCCAVai0AADoAACAGQQRqIQYgCkEEaiIKIBZHDQALCyAPRQ0AA0AgB0EgaiAGaiAGIAhqLQAAOgAAIAZBAWohBiALQQFqIgsgD0cNAAsLQQAhCiADQQJHBEADQEEAIQYgEkUEQANAIAYgCGoiCyALLQAAIAdBIGogBmotAABzOgAAIAZBAWoiBiAJRw0AC0EAIQYDQCAGIAhqIgsgCy0AACAHQSBqIAZqLQAAczoAACAGQQFqIgYgCUcNAAsLIApBAmoiCiAQRw0ACwsCQAJAAkACQCAcRQ0AQQAhBiASDQADQCAGIAhqIgsgCy0AACAHQSBqIAZqLQAAczoAACAGQQFqIgYgCUcNAAsMAQsgEg0BC0EAIQYDQCAFKAIAIAZqIgkgBSgCBCIPTg0CIAUoAgggCWogBiAIai0AADoAACAGQQFqIgYgF0cNAAsLIAUoAgAgF2ohDwsgBSAPNgIAIBggHUYhBiAYQQFqIRggBkUNAAsLIAQgD0gEQCAFIAQ2AgALIAdBwANqJAALzgMBB38jAEEwayIDJAAgA0HwrCs2AiAgAEH5hiogA0EgahCbAQJAIABBAUGa4ioQ3AEiBUUEQCAAQdjYKUEAEG4MAQsgBSAFKAI8QQFqNgI8CwJAIABBAhDIASIGRQRAQejkKSEEDAELAkAgBSgCOCICDQACQEGkiDQoAgAiAQRAAn8CQCABKAIUQYABSQ0AIAEoAgQiAkUNACABKAIYIgQgBCgCgARBAWo2AoAEIAEgASgCHEEBajYCHCABIAEoAiBBgAFqNgIgIAEgASgCLEGAAWo2AiwgASACKAIANgIEQQghB0F/DAELQYABECoiAkUEQBBPCyABIAEoAiRBAWo2AiQgASABKAIoQYABajYCKEEsIQdBgAELIQQgASAHaiIBIAEoAgAgBGo2AgAMAQtBgAEQKiECCyAFIAI2AjggAg0AQb6OKiEEQQAhAQwBCyACIAYoAgAgBigCCBB6QQAhBEEAIQIDQCAFKAI4EGkaQQEhASACQQFqIgJBhAJHDQALCyAGEJoBIAUQ4wMgAUUEQCADIAQ2AhQgA0HwrCs2AhAgAEH8iCogA0EQahBsAAsgA0HwrCs2AgAgAEHghyogAxCbASADQTBqJABBAAvFAQEEfyMAQTBrIgEkACABQeTlKzYCICAAQfmGKiABQSBqEJsBIABBAUGa4ioQ3AEiAwRAIAMgAygCPEEBajYCPEHIvishAiADKAI4IgQEQCAEEGkhAiAAKAIMIgRBAzoABCAEIAI2AgAgACAAKAIMQQhqNgIMQQAhAgsgAxDjAyABIAI2AhQgAUHk5Ss2AhAgAEH8iCogAUEQahBsAAsgAEHY2ClBABBuIAFB5OUrNgIAIABB4IcqIAEQmwEgAUEwaiQAQQEL9QEBBX8jAEFAaiIBJAAgAUGJ6is2AjAgAEH5hiogAUEwahCbAQJAIABBAUGa4ioQ3AEiAgRAIAIgAigCPEEBajYCPCACKAI4IgNFDQEgAxBpIQMgAigCOBBpIQQgACgCDCIFQQM6AAQgBSADIARBCHRyNgIAIAAgACgCDEEIajYCDCACEOMDIAFBieorNgIgIABB4IcqIAFBIGoQmwEgAUFAayQAQQEPCyAAQdjYKUEAEG4gAUG04Cs2AgQgAUGJ6is2AgAgAEH8iCogARBsAAsgAhDjAyABQci+KzYCFCABQYnqKzYCECAAQfyIKiABQRBqEGwAC5MCAQd/IwBBQGoiASQAIAFBnu4rNgIwIABB+YYqIAFBMGoQmwECQCAAQQFBmuIqENwBIgIEQCACIAIoAjxBAWo2AjwgAigCOCIDRQ0BIAMQaSEDIAIoAjgQaSEEIAIoAjgQaSEFIAIoAjgQaSEGIAAoAgwiB0EDOgAEIAcgAyAEQQh0ciAFQRB0ciAGQRh0cjYCACAAIAAoAgxBCGo2AgwgAhDjAyABQZ7uKzYCICAAQeCHKiABQSBqEJsBIAFBQGskAEEBDwsgAEHY2ClBABBuIAFBtOArNgIEIAFBnu4rNgIAIABB/IgqIAEQbAALIAIQ4wMgAUHIvis2AhQgAUGe7is2AhAgAEH8iCogAUEQahBsAAuPAwIDfgR/IAApAwAgACgC0AEiBawiA4KnIgdBA3QgB0EIbSIGQQZ0a60hAiAAQQhqIgggBkEFb0EobGogB0EobUEDdGoiBikDACEEAkACQCAFIAdrQQFGBEAgBiAEQoYBIAKGhTcDACAAIAApAwBCAXwiAjcDACACIAOCUA0BDAILIAYgBEIGIAKGhTcDACAAIAApAwBCAXwiAjcDACACIAOCUARAIAAQ6QMgACgC0AEhBSAAKQMAIQILIAVBAWsgAqcgBW9HBEADQCAAIAJCAXwiAjcDACACIAWsglAEQCAAEOkDIAAoAtABIQUgACkDACECCyAFQQFrIAKnIAVvRw0ACwsgCCACIAWsIgOCpyIFQQhtIgdBBW9BKGxqIAVBKG1BA3RqIgYgBikDAEKAASAFQQN0IAdBBnRrrYaFNwMAIAAgACkDAEIBfCICNwMAIAIgA4JCAFINAQsgABDpAwsgACABIAAoAtQBEOoDIAAoAtQBIQUgAEEAQdAB/AsAIABByAEgBUEBdGs2AtABC/8DAgR+A38gACkDCCEDIABB0ABqIgcgACkDACIEp0EDdkH4AHFqIgYgBikDAEIIhkKAAYQ3AwAgACAEQgh8IgI3AwACQAJAIAJQBEAgAEIANwMAIAAgA0IBfDcDCAwBCyACQv8HgyIFQgBSDQELIAAQ+QMgACkDACICQv8HgyEFCyAFQoAHUgRAA0AgByACp0EDdkH4AHFqIgYgBikDAEIIhjcDACAAIAJCCHwiAjcDAAJAAkAgAlAEQCAAQgA3AwAgACAAKQMIQgF8NwMIDAELIAJC/weDQgBSDQELIAAQ+QMgACkDACECCyACQv8Hg0KAB1INAAsLIAAgBDcDyAEgACADNwPAASAAEPkDIAAoAtAFQQBKBEAgAEEQaiEIQQAhBgNAIAEgBmogCCAGQXhxaikDACAGQX9zQQN0QThxrYg8AAAgBkEBaiIGIAAoAtAFSA0ACwsgB0EAQYAF/AsAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIABBwAA2AtAFIABC+cL4m5Gjs/DbADcDSCAAQuv6htq/tfbBHzcDQCAAQp/Y+dnCkdqCm383AzggAELRhZrv+s+Uh9EANwMwIABC8e30+KWn/aelfzcDKCAAQqvw0/Sv7ry3PDcDICAAQrvOqqbY0Ouzu383AxggAEKIkvOd/8z5hOoANwMQC6YDAhJ+A38gAEHQAGohFSAAKQNQIQJBECEUA0AgFSAUQQN0aiITIBNBOGspAwAgE0EQaykDACIBQi2JIAFCA4mFIAFCBoiFfCACfCATQfgAaykDACIBQj+JIAFCOImFIAFCB4iFfDcDACABIQIgFEEBaiIUQdAARw0AC0EAIRMgACkDECILIQYgACkDGCIMIQIgACkDSCINIQcgACkDQCIOIQggACkDOCIPIQkgACkDMCIQIQMgACkDKCIRIQogACkDICISIQQDQCAEIQUgAiEEIBNBA3QiFEGAxS9qKQMAIAcgAyIBQjKJIAFCLomFIAFCF4mFfCAIIgcgAUJ/hYMgCSIIIAGDhHx8IBQgFWopAwB8IgMgBiICQiSJIAJCHomFIAJCGYmFIAIgBCAFhYMgBCAFg4V8fCEGIAMgCnwhAyABIQkgBSEKIBNBAWoiE0HQAEcNAAsgACAHIA18NwNIIAAgCCAOfDcDQCAAIAEgD3w3AzggACADIBB8NwMwIAAgBSARfDcDKCAAIAQgEnw3AyAgACACIAx8NwMYIAAgBiALfDcDEAu1FAEIfyMAQdAAayIHJAAgB0Hz4So2AkAgAEH5hiogB0FAaxCbAQJAAkACfwJAIAAoAhQoAgBBCGoiAyAAKAIMSQRAIAMtAARBD3ENAUHu6SsMAgtB7ukrIAAoAhAtADBBD3FFDQEaIAAoAhBBLGohAwsCQAJAIAMtAARBD3FBA2sOAgABAwsgACADEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIDIAAoAgxJDQAgACgCEEEsaiEDCyADKAIAQRBqCyEGIABBwABBARDaASEDIABB2OHOfUGa4ioQkAEaIABBfhDbASADQQA2AjggA0EANgIgIANCADcCGAJAIAZB7ukrQQYQd0UEQCADIAZBDxDKAUKCgICAgAQ3AhACQEGkiDQoAgAiAgRAAn8CQCACKAIUQewCSQ0AIAIoAgQiAUUNACACKAIYIgQgBCgCsAtBAWo2ArALIAIgAigCHEEBajYCHCACIAIoAiBB7AJqNgIgIAIgAigCLEHsAmo2AiwgAiABKAIANgIEQQghBUF/DAELQewCECoiAUUEQBBPCyACIAIoAiRBAWo2AiQgAiACKAIoQewCajYCKEEsIQVB7AILIQQgAiAFaiICIAIoAgAgBGo2AgAMAQtB7AIQKiEBCyADIAE2AhggAUEoakEAQYAC/AsAIAFBIDYC6AIgAUKrs4/8kaOz8NsANwIgIAFC/6S5iMWR2oKbfzcCGCABQvLmu+Ojp/2npX83AhAgAULnzKfQ1tDrs7t/NwIIIAFCADcCAAwBCyAGQY3rK0EGEHdFBEAgAyAGQQ8QygFCg4CAgIAGNwIQAkBBpIg0KAIAIgIEQAJ/AkAgAigCFEHYBUkNACACKAIEIgFFDQAgAigCGCIEIAQoAuAWQQFqNgLgFiACIAIoAhxBAWo2AhwgAiACKAIgQdgFajYCICACIAIoAixB2AVqNgIsIAIgASgCADYCBEEIIQVBfwwBC0HYBRAqIgFFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKEHYBWo2AihBLCEFQdgFCyEEIAIgBWoiAiACKAIAIARqNgIADAELQdgFECohAQsgAyABNgIcIAFB0ABqQQBBgAX8CwAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAUEwNgLQBSABQqSf6ffbg9LaxwA3A0ggAUKnn+an1sGLhls3A0AgAUKRquDC9tCS2o5/NwM4IAFCsZaA/v/MyZnnADcDMCABQrmyubiPm/uXFTcDKCABQpe6w4Ojq8CskX83AyAgAUKHqvOzo6WKzeIANwMYIAFC2L2WiNyr591LNwMQDAELIAZB/+4rQQYQd0UEQCADIAZBDxDKAUKFgICAgAg3AhACQEGkiDQoAgAiAgRAAn8CQCACKAIUQdgFSQ0AIAIoAgQiAUUNACACKAIYIgQgBCgC4BZBAWo2AuAWIAIgAigCHEEBajYCHCACIAIoAiBB2AVqNgIgIAIgAigCLEHYBWo2AiwgAiABKAIANgIEQQghBUF/DAELQdgFECoiAUUEQBBPCyACIAIoAiRBAWo2AiQgAiACKAIoQdgFajYCKEEsIQVB2AULIQQgAiAFaiICIAIoAgAgBGo2AgAMAQtB2AUQKiEBCyADIAE2AiAgAUHQAGpBAEGABfwLACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDACABQcAANgLQBSABQvnC+JuRo7Pw2wA3A0ggAULr+obav7X2wR83A0AgAUKf2PnZwpHagpt/NwM4IAFC0YWa7/rPlIfRADcDMCABQvHt9Pilp/2npX83AyggAUKr8NP0r+68tzw3AyAgAUK7zqqm2NDrs7t/NwMYIAFCiJLznf/M+YTqADcDEAwBCyAGQfXpK0EIEHdFBEAgAyAGQQ8QygEiBEK4mYCAgAQ3AhACf0GkiDQoAgAiAQRAAn8CQCABKAIUQdgBSQ0AIAEoAgQiAkUNACABKAIYIgUgBSgC4AZBAWo2AuAGIAEgASgCHEEBajYCHCABIAEoAiBB2AFqNgIgIAEgASgCLEHYAWo2AiwgASACKAIANgIEQQghCEF/DAELQdgBECoiAkUEQBBPCyABIAEoAiRBAWo2AiQgASABKAIoQdgBajYCKEEsIQhB2AELIQUgASAIaiIBIAEoAgAgBWo2AgAgBCgCFAwBC0HYARAqIQJBIAshASAEIAI2AiQgAkEAQdAB/AsAIAJByAEgAUEBdGs2AtABIAIgATYC1AEMAQsgBkGG7ytBCBB3RQRAIAMgBkEPEMoBIgRCuJuAgIAINwIQAn9BpIg0KAIAIgEEQAJ/AkAgASgCFEHYAUkNACABKAIEIgJFDQAgASgCGCIFIAUoAuAGQQFqNgLgBiABIAEoAhxBAWo2AhwgASABKAIgQdgBajYCICABIAEoAixB2AFqNgIsIAEgAigCADYCBEEIIQhBfwwBC0HYARAqIgJFBEAQTwsgASABKAIkQQFqNgIkIAEgASgCKEHYAWo2AihBLCEIQdgBCyEFIAEgCGoiASABKAIAIAVqNgIAIAQoAhQMAQtB2AEQKiECQcAACyEBIAQgAjYCKCACQQBB0AH8CwAgAkHIASABQQF0azYC0AEgAiABNgLUAQwBCyAGQeXpK0EIEHdFBEAgAyAGQQ8QygEiBEKIgICAgAQ3AhACf0GkiDQoAgAiAQRAAn8CQCABKAIUQdgBSQ0AIAEoAgQiAkUNACABKAIYIgUgBSgC4AZBAWo2AuAGIAEgASgCHEEBajYCHCABIAEoAiBB2AFqNgIgIAEgASgCLEHYAWo2AiwgASACKAIANgIEQQghCEF/DAELQdgBECoiAkUEQBBPCyABIAEoAiRBAWo2AiQgASABKAIoQdgBajYCKEEsIQhB2AELIQUgASAIaiIBIAEoAgAgBWo2AgAgBCgCFAwBC0HYARAqIQJBIAshASAEIAI2AjAgAkEAQdAB/AsAIAJByAEgAUEBdGs2AtABIAIgATYC1AEMAQsgBkHb6StBCRB3RQRAIAMgBkEPEMoBIgRCh4CAgIAENwIQAn9BpIg0KAIAIgEEQCABQdgBEE4hASAEKAIUDAELQdgBECohAUEgCyECIAQgATYCLCABQQBB0AH8CwAgAUHIASACQQF0azYC0AEgASACNgLUAQwBCyAGQdnyK0EJEHcNAiADIAZBDxDKASICQqCBgIDAAjcCECACAn9BpIg0KAIAIgEEQCABQRQQTgwBC0EUECoLIgE2AjQgAUHww8uefDYCECABQv6568XpjpWZEDcCCCABQoHGlLqW8ermbzcCAAsgA0EBNgI8IAcgBjYCECAAQc+HKiAHQRBqEFsgB0Hz4So2AgAgAEHghyogBxCbASAHQdAAaiQAQQEPCyAAQQFB+O0qENQBAAsgByAGNgIwIABBt4kqIAdBMGoQbiAHQYLjKjYCJCAHQfPhKjYCICAAQfyIKiAHQSBqEGwAC9sJAQl/IwBB4AJrIgQkACAEQZS+KzYCICAAQfmGKiAEQSBqEJsBIAAoAhQoAgAiAUEIaiIDIAAoAgwiAk8EQCAAKAIQQSxqIQMLAkACQAJAAkACQCADLQAEQQ9xQQNrDgIAAQILIAAgAxBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgAiAUEIaiIDIAAoAgwiAkkNACAAKAIQQSxqIQMLIAMoAgAhAyACIAFBEGoiAU0EQCAAKAIQQSxqIQELAkACQCABLQAEQQ9xQQNrDgIAAQMLIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBEGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgA0EQaiIGECchAyABKAIAQRBqIgFBgAIQcyEHIARB0ABqQQBBiAL8CwAgBELt3JXr9s3btOMANwNQIAcEQCAEQdAAakEIciABIAf8CgAACwJAQaSINCgCACICBEACfwJAIAMgAigCFEsNACACKAIEIgVFDQAgAigCGCADQQJ0aiIBIAEoAgBBAWo2AgAgAiACKAIcQQFqNgIcIAIgAigCICADajYCICACIAIoAiwgA2o2AiwgAiAFKAIANgIEQQghCSACIQFBfwwBCyACIQEgAxAqIgVFBEAQT0GkiDQoAgAhAQsgAiACKAIkQQFqNgIkIAIgAigCKCADajYCKEEsIQkgAwshCCACIAlqIgIgAigCACAIajYCAAwBC0EAIQEgAxAqIQULIAQgBTYCSCADBEAgBSAGIAP8CgAACyAEIAM2AkAgBCADNgJEIAdBDGohAwJAIAEEQAJ/AkAgAyABKAIUSw0AIAEoAgQiAkUNACABKAIYIANBAnRqIgYgBigCAEEBajYCACABIAEoAhxBAWo2AhwgASABKAIgIANqNgIgIAEgASgCLCADajYCLCABIAIoAgA2AgRBCCEIQX8MAQsgAxAqIgJFBEAQTwsgASABKAIkQQFqNgIkIAEgASgCKCADajYCKEEsIQggAwshBiABIAhqIgEgASgCACAGajYCAAwBCyADECohAgsgBCACNgI4IAMEQCACIARB0ABqIAP8CgAACyAEIAM2AjQgBCAHQQhqNgIwIABBwAAQhgEiAwRAQcAAIARBQGsgBEEwakGAEEHAACADEPIDIANBwAA2AgALAkBBpIg0KAIAIgEEQAJAIAVFDQAgBCAFNgLcAgJAIAEoAgAiAiAEKALcAksNACAEKALcAiACIAEoAhBqTw0AIAUgASgCBDYCACABIAU2AgQgASABKAIIQQFqNgIIIAEoAhQiAkEESQ0BIAJBfHEiAkUNASAFQQAgAvwLAAwBCyAFECsLIAQoAjgiAkUNASAEIAI2AtwCAkAgASgCACIFIAQoAtwCSw0AIAQoAtwCIAUgASgCEGpPDQAgAiABKAIENgIAIAEgAjYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIAJBACAB/AsADAILIAIQKwwBCyAFECsgBCgCOBArCyADRQ0CIARBlL4rNgIQIABB4IcqIARBEGoQmwEgBEHgAmokAEEBDwsgAEEBQbK2KxCGAgALIABBAkGytisQhgIACyAEQejkKTYCBCAEQZS+KzYCACAAQfyIKiAEEGwAC60CAQV/IwBBgANrIgEkACABQea/KzYCECAAQfmGKiABQRBqEJsBQd+2KSECIABBARDIASEDIABBAhDIASEEAkAgA0UNACAERQ0AQZPYKSECIAMoAggQ/QMNACAEKAIIEP0DDQAgACADKAIAEIYBIgJFBEBBw7YpIQIMAQsgAUGcAWogAygCCBD+AxogAUEYaiAEKAIIEP4DGiABQZwBaiABQRhqEP8DIAFB0AJqIAFBoAJqIAFBnAFqEIAEIAIoAghBBDoAACACQcEANgIAQQEhBSACKAIIQQFqIAFB0AJqEIEEIAIoAghBIWogAUGgAmoQgQRBACECCyADEJoBIAQQmgEgBUUEQCABIAI2AgQgAUHmvys2AgAgAEH8iCogARBsAAsgAUGAA2okAEEBC9gYAj1/AXsjAEHwAWsiASQAIAFC//////ABNwPgASABQv/////w////DzcD2AEgAUL/////8P///w83A9ABIAFC//////D///8PNwPIASABQq/4///w/f//DzcDwAECQCABQQxqIAAQ/gNFBEBBfiEADAELIAFBwAFqEMwIIQMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAqQBIAFBtAFqIgBBADYCACABQQE2ApABIAEgPv0LApQBIABBACADQQRqIgJBOG0iBGtBAnQgAWooArQBIARBZGwgAkECbWoiAnQiBTYCAAJAAkACQCADQfMDSg0AQQghACABQQAgBGtBAnQgAWooArABQRwgAmsiB3UgBXI2ArQBIANBuwNKDQBBCEEHIAQgBEEHThtrIgVBAXEhCCADQYMDTARAIAVBfnEhC0EAIQUDQCABQZABaiAAQQJ0aiABQZABaiAAIARrQQJ0aiIGKAIAIAJ0Qf////8AcSAGQQRrKAIAIAd1cjYCACABQZABaiAAQQFrIgZBAnRqIAFBkAFqIAYgBGtBAnRqIgYoAgAgAnRB/////wBxIAZBBGsoAgAgB3VyNgIAIABBAmshACAFQQJqIgUgC0cNAAsLIAgEQCABQZABaiAAQQJ0aiABQZABaiAAIARrQQJ0aiIAKAIAIAJ0Qf////8AcSAAQQRrKAIAIAd1cjYCAAsgAUGQAWogBEECdGogASgCkAEgAnRB/////wBxNgIAIANBNEgNAgwBCyABQZABaiAEQQJ0akEBIAJ0Qf////8AcTYCAAsgBEECdCIARQ0AIAFBkAFqQQAgAPwLAAsgAUGgAWoiACgCACEEIAEoAqQBIQIgAEIANwMAIAFBqAFqIgAoAgAhByABKAKsASEFIABCADcDACABQbABaiIAKAIAIQYgASgCtAEhAyAAQgA3AwAgASgClAEhACABKAKQASEIIAFCADcDkAEgASgCnAEhCSABKAKYASEKIAFCADcDmAFB/////wAhCyAIQa/4//8AaiIIQf////8AcSEkIAAgCEEcdWpB7////wBqIgBB/////wBxISUgCiAAQRx1akH/////AGoiAEH/////AHEhJiAJIABBHHVqQf////8AaiIAQf////8AcSEnIAQgAEEcdWpB/////wBqIgBB/////wBxISggAiAAQRx1akH/////AGoiAEH/////AHEhKSAHIABBHHVqQf////8AaiIAQf////8AcSEqIAUgAEEcdWpB/////wBqIgBB/////wBxISsgBiAAQRx1akH/////AGoiAEH/////AHEhLEEPIQQgAyAAQRx1akEPaiEtQa71+v8AIQhB9NW57gAhEkG/94DFACEUQc3Rl+kAIQBBwYLZASEWQQEhH0H/////ACEGQf////8AIQVB/////wAhBwJ/AkADQAJAIAQhAwJAAkAgLSICIARHDQAgByIDICwiAkcNACAFIgMgKyICRw0AIAYiAyAqIgJHDQAgCyIDICkiAkcNACAIIgMgKCICRw0AICciAiASIgNHDQAgJiICIBQiA0cNACAAIQMgJSICIABHDQAgJCICIBYiA0YNAQsgAiADSg0AQQAhAiAeDQFBACEMQQAhDUEAIQ5BACEPQQAhEEEAIRFBACEKQQAhCUEAIQMMAwsgBEEBdCAHQRt1ciEEICBBAXQgHUEbdXIhICAWQRt2IQIgAEEbdSEDIBRBG3UhCSASQRt1IQogCEEbdSERIAtBG3UhECAGQRt1IQ8gB0EBdEH+////AHEgBUEbdXIhByAfQRt2IQ4gE0EbdSENIBdBG3UhDCAYQRt1ISEgGUEbdSEVIBpBG3UhIiAbQRt1ISMgHUEBdEH+////AHEgHEEbdXIhHSAeQQFqIR4gFkEBdEH+////AHEhFiAfQQF0Qf7///8AcSEfIA4gE0EBdEH+////AHFyIRMgDSAXQQF0Qf7///8AcXIhFyAMIBhBAXRB/v///wBxciEYICEgGUEBdEH+////AHFyIRkgFSAaQQF0Qf7///8AcXIhGiAiIBtBAXRB/v///wBxciEbICMgHEEBdEH+////AHFyIRwgAiAAQQF0Qf7///8AcXIhACADIBRBAXRB/v///wBxciEUIAkgEkEBdEH+////AHFyIRIgCiAIQQF0Qf7///8AcXIhCCARIAtBAXRB/v///wBxciELIBAgBkEBdEH+////AHFyIQYgDyAFQQF0Qf7///8AcXIhBQwBCwtBACEMQQAhDUEAIQ5BACEPQQAhEEEAIRFBACEKQQAhCUEAIQMDQCAXQRt0ISEgGEEbdCEVIBlBG3QhIiAaQRt0ISMgG0EbdCEuIBxBG3QhLyAdQRt0ITAgIEEbdCExIAIgIEEBdSIgaiAMIDFBgICAwABxIB1BAXVyIh1qIA0gMEGAgIDAAHEgHEEBdXIiHGogDiAvQYCAgMAAcSAbQQF1ciIbaiAPIC5BgICAwABxIBpBAXVyIhpqIBAgI0GAgIDAAHEgGUEBdXIiGWogESAiQYCAgMAAcSAYQQF1ciIYaiAKIBVBgICAwABxIBdBAXVyIhdqIAkgIUGAgIDAAHEgE0EBdXIiIWogAyATQRt0QYCAgMAAcSAfQQF1ciIfaiITQRx1aiIVQRx1aiIiQRx1aiIjQRx1aiIuQRx1aiIvQRx1aiIwQRx1aiIxQRx1aiIyQRx1aiACICUgFEEbdEGAgIDAAHEgAEEBdXIiM2sgJCAAQRt0QYCAgMAAcSAWQQF1ciIWayI0QRx1aiI1QRx1ICYgEkEbdEGAgIDAAHEgFEEBdXIiFGtqIjZBHHUgJyAIQRt0QYCAgMAAcSASQQF1ciISa2oiN0EcdSAoIAtBG3RBgICAwABxIAhBAXVyIghraiI4QRx1ICkgBkEbdEGAgIDAAHEgC0EBdXIiC2tqIjlBHHUgKiAFQRt0QYCAgMAAcSAGQQF1ciIGa2oiOkEcdSArIAdBG3RBgICAwABxIAVBAXVyIgVraiI7QRx1ICwgBEEbdEGAgIDAAHEgB0EBdXIiB2tqIjxBHHUgLSAEQQF1IgRraiI9QQBOIgAbIQIgMkH/////AHEgDCAAGyEMIDFB/////wBxIA0gABshDSAwQf////8AcSAOIAAbIQ4gL0H/////AHEgDyAAGyEPIC5B/////wBxIBAgABshECAjQf////8AcSARIAAbIREgIkH/////AHEgCiAAGyEKIBVB/////wBxIAkgABshCSA9IC0gABshLSA8Qf////8AcSAsIAAbISwgO0H/////AHEgKyAAGyErIDpB/////wBxICogABshKiA5Qf////8AcSApIAAbISkgOEH/////AHEgKCAAGyEoIDdB/////wBxICcgABshJyA2Qf////8AcSAmIAAbISYgNUH/////AHEgJSAAGyElIBNB/////wBxIAMgABshAyA0Qf////8AcSAkIAAbISQgHkEBSiEVIB5BAWshHiAzIQAgISETIBUNAAsgASAMNgKwASABIA02AqwBIAEgDjYCqAEgASAPNgKkASABIBA2AqABIAEgETYCnAEgASAKNgKYASABIAk2ApQBIAEgAzYCkAFBAAwBC0EBCyEAA0AgAEUEQCABIAI2ArQBQQEhAAwBCwJAIANBAXFFBEAgAUEMahDhCCABIAJBG3RBgICAwABxIAxBAXZyIgA2ArABIAEgDEEbdEGAgIDAAHEgDUEBdnIiBDYCrAEgASANQRt0QYCAgMAAcSAOQQF2ciIHNgKoASABIA5BG3RBgICAwABxIA9BAXZyIgU2AqQBIAEgD0EbdEGAgIDAAHEgEEEBdnIiBjYCoAEgASAQQRt0QYCAgMAAcSARQQF2ciILNgKcASABIBFBG3RBgICAwABxIApBAXZyIgg2ApgBIAEgCkEbdEGAgIDAAHEgCUEBdnIiEjYClAEgASAJQRt0QYCAgMAAcSADQQF2ciIDNgKQASACQQF1IQIgACEMIAQhDSAHIQ4gBSEPIAYhECALIREgCCEKIBIhCQwBCwJAAkAgCQ0AIAoNACARDQAgEA0AIA8NACAODQAgDQ0AIAwNACACDQAgA0EBRg0BCyABQQxqIAFBkAFqEOQICyABQQxqENgIRQRAQQAhAAwDC0F+QQAgAUHkAGoQ2AgbIQAMAgtBACEADAALAAsgAUHwAWokACAAC9IFAQ5/IwBB4ABrIgIkACABQQFqIQ4gAS0AACEPA0AgDUEIdCADQRR2ciENIANBCHRBgP7//wBxIARBFHZyIQMgBEEIdEGA/v//AHEgBUEUdnIhBCAFQQh0QYD+//8AcSAGQRR2ciEFIAZBCHRBgP7//wBxIAdBFHZyIQYgB0EIdEGA/v//AHEgCEEUdnIhByAIQQh0QYD+//8AcSAJQRR2ciEIIAlBCHRBgP7//wBxIApBFHZyIQkgCkEIdEGA/v//AHEgC0EUdnIhCiAMIA5qLQAAIAtBCHRBgP7//wBxciELIAxBAWoiDEEgRw0ACyACIAM2AlAgAiANNgJUIAIgBDYCTCACIAU2AkggAiAGNgJEIAIgBzYCQCACIAg2AjwgAiAJNgI4IAIgCjYCNCACIAs2AjACQAJAIA9BBEYEQCABQSFqIQ5BACEMQQAhDUEAIQNBACEEQQAhBUEAIQZBACEHQQAhCEEAIQlBACEKQQAhCwNAIA1BCHQgA0EUdnIhDSADQQh0QYD+//8AcSAEQRR2ciEDIARBCHRBgP7//wBxIAVBFHZyIQQgBUEIdEGA/v//AHEgBkEUdnIhBSAGQQh0QYD+//8AcSAHQRR2ciEGIAdBCHRBgP7//wBxIAhBFHZyIQcgCEEIdEGA/v//AHEgCUEUdnIhCCAJQQh0QYD+//8AcSAKQRR2ciEJIApBCHRBgP7//wBxIAtBFHZyIQogDCAOai0AACALQQh0QYD+//8AcXIhCyAMQQFqIgxBIEcNAAsgAiADNgIgIAIgDTYCJCACIAQ2AhwgAiAFNgIYIAIgBjYCFCACIAc2AhAgAiAINgIMIAIgCTYCCCACIAo2AgQgAiALNgIAQQEhAyAAIAJBMGogAhDeCEUNAQwCCyAPQf4BcUECRw0AQQEhAyAAIAJBMGogD0EBcRDfCA0BC0EAIQMLIAJB4ABqJAAgAwvmRQItfwN+IwBBgARrIgIkACABNAIoIAA0Aih+QoCAgAhZBEAgABDaCAsgAkGAA2ogACABEM0IIAJC//////ABNwPAAiACQv/////w////DzcDuAIgAkL/////8P///w83A7ACIAJC//////D///8PNwOoAiACQq/4///w/f//DzcDoAIgAkHUAmogAkGgAmogAkGAA2oQzwggAkECNgL8AiABQSxqIQUgAEEsaiEDIAE0AlQgADQCVH5CgICACFkEQCADENoICyACQYADaiADIAUQzQggAkL/////8AE3A5ACIAJC//////D///8PNwOIAiACQv/////w////DzcDgAIgAkL/////8P///w83A/gBIAJCr/j///D9//8PNwPwASACQaACaiACQfABaiACQYADahDPCCACQQI2AsgCIAFB2ABqIQUgAEHYAGohAyABNAKAASAANAKAAX5CgICACFkEQCADENoICyACQYADaiADIAUQzQggAkL/////8AE3A+ABIAJC//////D///8PNwPYASACQv/////w////DzcD0AEgAkL/////8P///w83A8gBIAJCr/j///D9//8PNwPAASACQfABaiACQcABaiACQYADahDPCCACQQI2ApgCIAIgACgCLCAAKAIAaiIDNgLAASACIAAoAjAgACgCBGoiBTYCxAEgAiAAKAI0IAAoAghqIgY2AsgBIAIgACgCOCAAKAIMaiIHNgLMASACIAAoAjwgACgCEGoiCDYC0AEgAiAAKAJAIAAoAhRqIgk2AtQBIAIgACgCRCAAKAIYaiIKNgLYASACIAAoAkggACgCHGoiCzYC3AEgAiAAKAJMIAAoAiBqIg02AuABIAIgACgCUCAAKAIkaiIMNgLkASACIAAoAlQgACgCKGoiBDYC6AEgBEGAgIAITgRAIAJBwAFqENoIIAIoAuQBIQwgAigC4AEhDSACKALcASELIAIoAtgBIQogAigC1AEhCSACKALQASEIIAIoAswBIQcgAigCyAEhBiACKALEASEFIAIoAsABIQMLIAIgA0H/////AHE2AsABIAIgBSADQRx1aiIDQf////8AcTYCxAEgAiAGIANBHHVqIgNB/////wBxNgLIASACIAcgA0EcdWoiA0H/////AHE2AswBIAIgCCADQRx1aiIDQf////8AcTYC0AEgAiAJIANBHHVqIgNB/////wBxNgLUASACIAogA0EcdWoiA0H/////AHE2AtgBIAIgCyADQRx1aiIDQf////8AcTYC3AEgAiANIANBHHVqIgNB/////wBxNgLgASACIAwgA0EcdWo2AuQBIAIgASgCLCABKAIAaiIDNgKUASACIAEoAjAgASgCBGoiBjYCmAEgAiABKAI0IAEoAghqIgc2ApwBIAIgASgCOCABKAIMaiIINgKgASACIAEoAjwgASgCEGoiCTYCpAEgAiABKAJAIAEoAhRqIgo2AqgBIAIgASgCRCABKAIYaiILNgKsASACIAEoAkggASgCHGoiDTYCsAEgAiABKAJMIAEoAiBqIgw2ArQBIAIgASgCUCABKAIkaiIENgK4ASACIAEoAlQgASgCKGoiBTYCvAEgBUGAgIAITgRAIAJBlAFqENoIIAIoArwBIQUgAigCuAEhBCACKAK0ASEMIAIoArABIQ0gAigCrAEhCyACKAKoASEKIAIoAqQBIQkgAigCoAEhCCACKAKcASEHIAIoApgBIQYgAigClAEhAwsgAiADQf////8AcTYClAEgAiAGIANBHHVqIgNB/////wBxNgKYASACIAcgA0EcdWoiA0H/////AHE2ApwBIAIgCCADQRx1aiIDQf////8AcTYCoAEgAiAJIANBHHVqIgNB/////wBxNgKkASACIAogA0EcdWoiA0H/////AHE2AqgBIAIgCyADQRx1aiIDQf////8AcTYCrAEgAiANIANBHHVqIgNB/////wBxNgKwASACIAwgA0EcdWoiA0H/////AHE2ArQBIAIgBCADQRx1ajYCuAEgAjQC6AEgBax+QoCAgAhZBEAgAkHAAWoQ2ggLIAJBgANqIAJBwAFqIAJBlAFqEM0IIAJC//////ABNwOAASACQv/////w////DzcDeCACQv/////w////DzcDcCACQv/////w////DzcDaCACQq/4///w/f//DzcDYCACQcABaiACQeAAaiACQYADahDPCCACQQI2AugBIAIgAigCoAIgAigC1AJqNgKUASACIAIoAqQCIAIoAtgCajYCmAEgAiACKAKoAiACKALcAmo2ApwBIAIgAigCrAIgAigC4AJqNgKgASACIAIoArACIAIoAuQCajYCpAEgAiACKAK0AiACKALoAmo2AqgBIAIgAigCuAIgAigC7AJqNgKsASACIAIoArwCIAIoAvACajYCsAEgAiACKALAAiACKAL0Amo2ArQBIAIgAigCxAIgAigC+AJqNgK4ASACIAIoAsgCIAIoAvwCaiIDNgK8ASADQYCAgAhOBEAgAkGUAWoQ2ggLIAJBwAFqIAJBwAFqIAJBlAFqEOMIIAIgAigCwAEiA0H/////AHE2AsABIAIgAigCxAEgA0EcdWoiA0H/////AHE2AsQBIAIgAigCyAEgA0EcdWoiA0H/////AHE2AsgBIAIgAigCzAEgA0EcdWoiA0H/////AHE2AswBIAIgAigC0AEgA0EcdWoiA0H/////AHE2AtABIAIgAigC1AEgA0EcdWoiA0H/////AHE2AtQBIAIgAigC2AEgA0EcdWoiA0H/////AHE2AtgBIAIgAigC3AEgA0EcdWoiA0H/////AHE2AtwBIAIgAigC4AEgA0EcdWoiA0H/////AHE2AuABIAIgAigC5AEgA0EcdWo2AuQBIAIgACgCWCAAKAIsaiIDNgKUASACIAAoAlwgACgCMGoiBTYCmAEgAiAAKAJgIAAoAjRqIgY2ApwBIAIgACgCZCAAKAI4aiIHNgKgASACIAAoAmggACgCPGoiCDYCpAEgAiAAKAJsIAAoAkBqIgk2AqgBIAIgACgCcCAAKAJEaiIKNgKsASACIAAoAnQgACgCSGoiCzYCsAEgAiAAKAJ4IAAoAkxqIg02ArQBIAIgACgCfCAAKAJQaiIMNgK4ASACIAAoAoABIAAoAlRqIgQ2ArwBIARBgICACE4EQCACQZQBahDaCCACKAK4ASEMIAIoArQBIQ0gAigCsAEhCyACKAKsASEKIAIoAqgBIQkgAigCpAEhCCACKAKgASEHIAIoApwBIQYgAigCmAEhBSACKAKUASEDCyACIANB/////wBxNgKUASACIAUgA0EcdWoiA0H/////AHE2ApgBIAIgBiADQRx1aiIDQf////8AcTYCnAEgAiAHIANBHHVqIgNB/////wBxNgKgASACIAggA0EcdWoiA0H/////AHE2AqQBIAIgCSADQRx1aiIDQf////8AcTYCqAEgAiAKIANBHHVqIgNB/////wBxNgKsASACIAsgA0EcdWoiA0H/////AHE2ArABIAIgDSADQRx1aiIDQf////8AcTYCtAEgAiAMIANBHHVqNgK4ASACIAEoAlgiDiABKAIsaiIDNgJgIAIgASgCXCIPIAEoAjBqIgY2AmQgAiABKAJgIhAgASgCNGoiBzYCaCACIAEoAmQiESABKAI4aiIINgJsIAIgASgCaCISIAEoAjxqIgk2AnAgAiABKAJsIhMgASgCQGoiCjYCdCACIAEoAnAiFCABKAJEaiILNgJ4IAIgASgCdCIVIAEoAkhqIg02AnwgAiABKAJ4IhYgASgCTGoiDDYCgAEgAiABKAJ8IhcgASgCUGoiBDYChAEgAiABKAKAASIYIAEoAlRqIgU2AogBIAVBgICACE4EQCACQeAAahDaCCACKAKIASEFIAIoAoQBIQQgAigCgAEhDCACKAJ8IQ0gAigCeCELIAIoAnQhCiACKAJwIQkgAigCbCEIIAIoAmghByACKAJkIQYgAigCYCEDCyACIANB/////wBxNgJgIAIgBiADQRx1aiIDQf////8AcTYCZCACIAcgA0EcdWoiA0H/////AHE2AmggAiAIIANBHHVqIgNB/////wBxNgJsIAIgCSADQRx1aiIDQf////8AcTYCcCACIAogA0EcdWoiA0H/////AHE2AnQgAiALIANBHHVqIgNB/////wBxNgJ4IAIgDSADQRx1aiIDQf////8AcTYCfCACIAwgA0EcdWoiA0H/////AHE2AoABIAIgBCADQRx1ajYChAEgAjQCvAEgBax+QoCAgAhZBEAgAkGUAWoQ2ggLIAJBgANqIAJBlAFqIAJB4ABqEM0IIAJC//////ABNwNQIAJC//////D///8PNwNIIAJC//////D///8PNwNAIAJC//////D///8PNwM4IAJCr/j///D9//8PNwMwIAJBlAFqIAJBMGogAkGAA2oQzwggAkECNgK8ASACIAIoAvABIgQgAigCoAIiGWo2AmAgAiACKAL0ASIaIAIoAqQCIhtqNgJkIAIgAigC+AEiHCACKAKoAiIdajYCaCACIAIoAvwBIh4gAigCrAIiH2o2AmwgAiACKAKAAiIgIAIoArACIiFqNgJwIAIgAigChAIiIiACKAK0AiIjajYCdCACIAIoAogCIiQgAigCuAIiJWo2AnggAiACKAKMAiImIAIoArwCIidqNgJ8IAIgAigCkAIiKCACKALAAiIpajYCgAEgAiACKAKUAiIqIAIoAsQCIitqNgKEASACIAIoApgCIiwgAigCyAIiLWoiAzYCiAEgA0GAgIAITgRAIAJB4ABqENoICyACQZQBaiACQZQBaiACQeAAahDjCCACIAIoApQBIgNB/////wBxNgKUASACIAIoApgBIANBHHVqIgNB/////wBxNgKYASACIAIoApwBIANBHHVqIgNB/////wBxNgKcASACIAIoAqABIANBHHVqIgNB/////wBxNgKgASACIAIoAqQBIANBHHVqIgNB/////wBxNgKkASACIAIoAqgBIANBHHVqIgNB/////wBxNgKoASACIAIoAqwBIANBHHVqIgNB/////wBxNgKsASACIAIoArABIANBHHVqIgNB/////wBxNgKwASACIAIoArQBIANBHHVqIgNB/////wBxNgK0ASACIAIoArgBIANBHHVqNgK4ASACIAAoAlggACgCAGoiAzYCYCACIAAoAlwgACgCBGoiBTYCZCACIAAoAmAgACgCCGoiBjYCaCACIAAoAmQgACgCDGoiBzYCbCACIAAoAmggACgCEGoiCDYCcCACIAAoAmwgACgCFGoiCTYCdCACIAAoAnAgACgCGGoiCjYCeCACIAAoAnQgACgCHGoiCzYCfCACIAAoAnggACgCIGoiDTYCgAEgAiAAKAJ8IAAoAiRqIgw2AoQBIAIgACgCgAEgACgCKGoiLjYCiAEgLkGAgIAITgRAIAJB4ABqENoIIAIoAoQBIQwgAigCgAEhDSACKAJ8IQsgAigCeCEKIAIoAnQhCSACKAJwIQggAigCbCEHIAIoAmghBiACKAJkIQUgAigCYCEDCyACIANB/////wBxNgJgIAIgBSADQRx1aiIDQf////8AcTYCZCACIAYgA0EcdWoiA0H/////AHE2AmggAiAHIANBHHVqIgNB/////wBxNgJsIAIgCCADQRx1aiIDQf////8AcTYCcCACIAkgA0EcdWoiA0H/////AHE2AnQgAiAKIANBHHVqIgNB/////wBxNgJ4IAIgCyADQRx1aiIDQf////8AcTYCfCACIA0gA0EcdWoiA0H/////AHE2AoABIAIgDCADQRx1ajYChAEgAiAOIAEoAgBqIgM2AjAgAiAPIAEoAgRqIgU2AjQgAiAQIAEoAghqIgY2AjggAiARIAEoAgxqIgc2AjwgAiASIAEoAhBqIgg2AkAgAiATIAEoAhRqIgk2AkQgAiAUIAEoAhhqIgo2AkggAiAVIAEoAhxqIgs2AkwgAiAWIAEoAiBqIg02AlAgAiAXIAEoAiRqIgw2AlQgAiAYIAEoAihqIgE2AlggAUGAgIAITgRAIAJBMGoQ2gggAigCVCEMIAIoAlAhDSACKAJMIQsgAigCSCEKIAIoAkQhCSACKAJAIQggAigCPCEHIAIoAjghBiACKAI0IQUgAigCMCEDIAIoAlghAQsgAiADQf////8AcTYCMCACIAUgA0EcdWoiA0H/////AHE2AjQgAiAGIANBHHVqIgNB/////wBxNgI4IAIgByADQRx1aiIDQf////8AcTYCPCACIAggA0EcdWoiA0H/////AHE2AkAgAiAJIANBHHVqIgNB/////wBxNgJEIAIgCiADQRx1aiIDQf////8AcTYCSCACIAsgA0EcdWoiA0H/////AHE2AkwgAiANIANBHHVqIgNB/////wBxNgJQIAIgDCADQRx1ajYCVCACNAKIASABrH5CgICACFkEQCACQeAAahDaCAsgAkGAA2ogAkHgAGogAkEwahDNCCACQv/////wATcDICACQv/////w////DzcDGCACQv/////w////DzcDECACQv/////w////DzcDCCACQq/4///w/f//DzcDACACQeAAaiACIAJBgANqEM8IIAJBAjYCiAEgAiAEIAIoAtQCIgNqNgIwIAIgGiACKALYAiIFajYCNCACIBwgAigC3AIiBmo2AjggAiAeIAIoAuACIgdqNgI8IAIgICACKALkAiIIajYCQCACICIgAigC6AIiCWo2AkQgAiAkIAIoAuwCIgpqNgJIIAIgJiACKALwAiILajYCTCACICggAigC9AIiDWo2AlAgAiAqIAIoAvgCIgxqNgJUIAIgLCACKAL8AiIBaiIENgJYIARBgICACE4EQCACQTBqENoICyACQTBqIAJB4ABqIAJBMGoQ4wggAiACKAIwIgRB/////wBxNgIwIAIgAigCNCAEQRx1aiIEQf////8AcTYCNCACIAIoAjggBEEcdWoiBEH/////AHE2AjggAiACKAI8IARBHHVqIgRB/////wBxNgI8IAIgAigCQCAEQRx1aiIEQf////8AcTYCQCACIAIoAkQgBEEcdWoiBEH/////AHE2AkQgAiACKAJIIARBHHVqIgRB/////wBxNgJIIAIgAigCTCAEQRx1aiIEQf////8AcTYCTCACIAIoAlAgBEEcdWoiBEH/////AHE2AlAgAiACKAJUIARBHHVqNgJUIAIgAUEBdCIENgKIASACIAxBAXQiDjYChAEgAiANQQF0Ig82AoABIAIgC0EBdCIQNgJ8IAIgCkEBdCIRNgJ4IAIgCUEBdCISNgJ0IAIgCEEBdCITNgJwIAIgB0EBdCIUNgJsIAIgBkEBdCIVNgJoIAIgBUEBdCIWNgJkIAIgA0EBdCIXNgJgIAFBgICABE4EQCACQeAAahDaCCACKAKEASEOIAIoAoABIQ8gAigCfCEQIAIoAnghESACKAJ0IRIgAigCcCETIAIoAmwhFCACKAJoIRUgAigCZCEWIAIoAmAhFyACKAKIASEECyACIAwgDmoiDDYC+AIgAiANIA9qIg02AvQCIAIgCyAQaiILNgLwAiACIAogEWoiCjYC7AIgAiAJIBJqIgk2AugCIAIgCCATaiIINgLkAiACIAcgFGoiBzYC4AIgAiAGIBVqIgY2AtwCIAIgBSAWaiIFNgLYAiACIAMgF2oiAzYC1AIgAiABIARqIgE2AvwCIAFBgICACE4EQCACQdQCahDaCCACKAL4AiEMIAIoAvQCIQ0gAigC8AIhCyACKALsAiEKIAIoAugCIQkgAigC5AIhCCACKALgAiEHIAIoAtwCIQYgAigC2AIhBSACKALUAiEDCyACIANB/////wBxNgLUAiACIAUgA0EcdWoiAUH/////AHE2AtgCIAIgBiABQRx1aiIBQf////8AcTYC3AIgAiAHIAFBHHVqIgFB/////wBxNgLgAiACIAggAUEcdWoiAUH/////AHE2AuQCIAIgCSABQRx1aiIBQf////8AcTYC6AIgAiAKIAFBHHVqIgFB/////wBxNgLsAiACIAsgAUEcdWoiAUH/////AHE2AvACIAIgDSABQRx1aiIBQf////8AcTYC9AIgAiAMIAFBHHVqNgL4AiACQfABaiACQfABahDiCCACIAIoAvABIBlqIgE2AgAgAiACKAL0ASAbaiIDNgIEIAIgAigC+AEgHWoiBTYCCCACIAIoAvwBIB9qIgY2AgwgAiACKAKAAiAhaiIHNgIQIAIgAigChAIgI2oiCDYCFCACIAIoAogCICVqIgk2AhggAiACKAKMAiAnaiIKNgIcIAIgAigCkAIgKWoiCzYCICACIAIoApQCICtqIg02AiQgAiACKAKYAiAtaiIMNgIoIAxBgICACE4EQCACENoIIAIoAiQhDSACKAIgIQsgAigCHCEKIAIoAhghCSACKAIUIQggAigCECEHIAIoAgwhBiACKAIIIQUgAigCBCEDIAIoAgAhAQsgAiABQf////8AcTYCACACIAMgAUEcdWoiAUH/////AHE2AgQgAiAFIAFBHHVqIgFB/////wBxNgIIIAIgBiABQRx1aiIBQf////8AcTYCDCACIAcgAUEcdWoiAUH/////AHE2AhAgAiAIIAFBHHVqIgFB/////wBxNgIUIAIgCSABQRx1aiIBQf////8AcTYCGCACIAogAUEcdWoiAUH/////AHE2AhwgAiALIAFBHHVqIgFB/////wBxNgIgIAIgDSABQRx1ajYCJCACQaACaiACQaACaiACQfABahDjCCACIAIoAqACIgFB/////wBxNgKgAiACIAIoAqQCIAFBHHVqIgFB/////wBxNgKkAiACIAIoAqgCIAFBHHVqIgFB/////wBxNgKoAiACIAIoAqwCIAFBHHVqIgFB/////wBxNgKsAiACIAIoArACIAFBHHVqIgFB/////wBxNgKwAiACIAIoArQCIAFBHHVqIgFB/////wBxNgK0AiACIAIoArgCIAFBHHVqIgFB/////wBxNgK4AiACIAIoArwCIAFBHHVqIgFB/////wBxNgK8AiACIAIoAsACIAFBHHVqIgFB/////wBxNgLAAiACIAIoAsQCIAFBHHVqNgLEAiACQTBqIAJBMGoQ4gggAjQCvAEiMCACNAJYfkKAgIAIWQRAIAJBMGoQ2ggLIAJBgANqIAJBMGogAkGUAWoQzQggAkL/////8AE3A/ADIAJC//////D///8PNwPoAyACQv/////w////DzcD4AMgAkL/////8P///w83A9gDIAJCr/j///D9//8PNwPQAyACQeAAaiACQdADaiACQYADahDPCCACQQI2AogBIAI0AsgCIi8gAjQC6AF+QoCAgAhZBEAgAkHAAWoQ2ggLIAJBgANqIAJBwAFqIAJBoAJqEM0IIAJC//////ABNwPwAyACQv/////w////DzcD6AMgAkL/////8P///w83A+ADIAJC//////D///8PNwPYAyACQq/4///w/f//DzcD0AMgAkHwAWogAkHQA2ogAkGAA2oQzwggAkECNgKYAiAAIAJB8AFqIAJB4ABqEOMIIAI0AvwCIjEgAjQCWH5CgICACFkEQCACQTBqENoICyACQYADaiACQTBqIAJB1AJqEM0IIAJC//////ABNwPwAyACQv/////w////DzcD6AMgAkL/////8P///w83A+ADIAJC//////D///8PNwPYAyACQq/4///w/f//DzcD0AMgAkEwaiACQdADaiACQYADahDPCCACQQI2AlggLyACNAIoIi9+QoCAgAhZBEAgAkGgAmoQ2ggLIAJBgANqIAJBoAJqIAIQzQggAkL/////8AE3A/ADIAJC//////D///8PNwPoAyACQv/////w////DzcD4AMgAkL/////8P///w83A9gDIAJCr/j///D9//8PNwPQAyACQaACaiACQdADaiACQYADahDPCCACQQI2AsgCIAAgAigCoAIgAigCMGoiATYCLCAAIAIoAqQCIAIoAjRqIgU2AjAgACACKAKoAiACKAI4aiIGNgI0IAAgAigCrAIgAigCPGoiBzYCOCAAIAIoArACIAIoAkBqIgg2AjwgACACKAK0AiACKAJEaiIJNgJAIAAgAigCuAIgAigCSGoiCjYCRCAAIAIoArwCIAIoAkxqIgs2AkggACACKALAAiACKAJQaiINNgJMIAIoAsQCIQMgAigCVCEMIABBBDYCVCAAIAMgDGoiDDYCUCACNALoASAxfkKAgIAIWQRAIAJB1AJqENoICyACQYADaiACQdQCaiACQcABahDNCCACQv/////wATcD8AMgAkL/////8P///w83A+gDIAJC//////D///8PNwPgAyACQv/////w////DzcD2AMgAkKv+P//8P3//w83A9ADIAJB1AJqIAJB0ANqIAJBgANqEM8IIC8gMH5CgICACFkEQCACENoICyACQYADaiACIAJBlAFqEM0IIAJC//////ABNwPwAyACQv/////w////DzcD6AMgAkL/////8P///w83A+ADIAJC//////D///8PNwPYAyACQq/4///w/f//DzcD0AMgAiACQdADaiACQYADahDPCCAAIAIoAtQCIAIoAgBqIgM2AlggACACKALYAiACKAIEaiIENgJcIAAgAigC3AIgAigCCGoiDjYCYCAAIAIoAuACIAIoAgxqIg82AmQgACACKALkAiACKAIQaiIQNgJoIAAgAigC6AIgAigCFGo2AmwgACACKALsAiACKAIYajYCcCAAIAIoAvACIAIoAhxqNgJ0IAAgAigC9AIgAigCIGo2AnggAigC+AIhESACKAIkIRIgAEEENgKAASAAIBEgEmo2AnwgACAQIA8gDiAEIANBHHVqIgRBHHVqIg5BHHVqIg9BHHVqIhBB/////wBxNgJoIAAgD0H/////AHE2AmQgACAOQf////8AcTYCYCAAIARB/////wBxNgJcIAAgA0H/////AHE2AlggACAMIA0gCyAKIAkgCCAHIAYgBSABQRx1aiIDQRx1aiIFQRx1aiIGQRx1aiIHQRx1aiIIQRx1aiIJQRx1aiIKQRx1aiILQRx1ajYCUCAAIAtB/////wBxNgJMIAAgCkH/////AHE2AkggACAJQf////8AcTYCRCAAIAhB/////wBxNgJAIAAgB0H/////AHE2AjwgACAGQf////8AcTYCOCAAIAVB/////wBxNgI0IAAgA0H/////AHE2AjAgACABQf////8AcTYCLCAAIAAoAgAiAUH/////AHE2AgAgACAAKAIEIAFBHHVqIgFB/////wBxNgIEIAAgACgCCCABQRx1aiIBQf////8AcTYCCCAAIAAoAgwgAUEcdWoiAUH/////AHE2AgwgACAAKAIQIAFBHHVqIgFB/////wBxNgIQIAAgACgCFCABQRx1aiIBQf////8AcTYCFCAAIAAoAhggAUEcdWoiAUH/////AHE2AhggACAAKAIcIAFBHHVqIgFB/////wBxNgIcIAAgACgCICABQRx1aiIBQf////8AcTYCICAAIAAoAiQgAUEcdWo2AiQgACAAKAJsIBBBHHVqIgFB/////wBxNgJsIAAgACgCcCABQRx1aiIBQf////8AcTYCcCAAIAAoAnQgAUEcdWoiAUH/////AHE2AnQgACAAKAJ4IAFBHHVqIgFB/////wBxNgJ4IAAgACgCfCABQRx1ajYCfCACQYAEaiQAC5gGAgN/AXsjAEGQAmsiAyQAIAMgAigCADYCDCADIAIoAgQ2AhAgAyACKAIINgIUIAMgAigCDDYCGCADIAIoAhA2AhwgAyACKAIUNgIgIAMgAigCGDYCJCADIAIoAhw2AiggAyACKAIgNgIsIAMgAigCJDYCMCADIAIoAig2AjQgAyACKAIsNgI4IAMgAigCMDYCPCADIAIoAjQ2AkAgAyACKAI4NgJEIAMgAigCPDYCSCADIAIoAkA2AkwgAyACKAJENgJQIAMgAigCSDYCVCADIAIoAkw2AlggAyACKAJQNgJcIAMgAigCVDYCYCADIAIoAlg2AmQgAyACKAJcNgJoIAMgAigCYDYCbCADIAIoAmQ2AnAgAyACKAJoNgJ0IAMgAigCbDYCeCADIAIoAnA2AnwgAyACKAJ0NgKAASADIAIoAng2AoQBIAMgAigCfDYCiAEgAyACKAKAATYCjAEgA0EMahDbCAJAIANBDGoQ2AgEQCADQeQAahDYCA0BCyADQdwBaiICQQA2AgAgA0HMAWoiBP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAyADKAI4NgKQASADIAP9AAI8/QsClAEgAyAD/QACTP0LAqQBIAMgBv0LArwBIAMgAygCXCIFQRx1NgK4ASADIAVB/////wBxNgK0ASADQv/////wATcDgAIgA0L/////8P///w83A/gBIANC//////D///8PNwPwASADQv/////w////DzcD6AEgA0Kv+P//8P3//w83A+ABIAEgA0HgAWogA0GQAWoQzwggBCAG/QsCACACQQA2AgAgAyAD/QACDP0LBJABIAMgA/0AAhz9CwSgASADIAMoAiw2ArABIAMgAygCMCICQf////8AcTYCtAEgAyACQRx1NgK4ASADIAb9CwK8ASADQv/////wATcDgAIgA0L/////8P///w83A/gBIANC//////D///8PNwPwASADQv/////w////DzcD6AEgA0Kv+P//8P3//w83A+ABIAAgA0HgAWogA0GQAWoQzwgLIANBkAJqJAALrgMBDH8gASgCACICQf////8AcSELIAEoAgQgAkEcdWoiA0H/////AHEhAiABKAIIIANBHHVqIgRB/////wBxIQMgASgCDCAEQRx1aiIFQf////8AcSEEIAEoAhAgBUEcdWoiBkH/////AHEhBSABKAIUIAZBHHVqIgdB/////wBxIQYgASgCGCAHQRx1aiIIQf////8AcSEHIAEoAhwgCEEcdWoiCUH/////AHEhCCABKAIgIAlBHHVqIgpB/////wBxIQkgASgCJCAKQRx1aiEBQR8hDANAIAAgDCIKaiALOgAAIAFBFHQhDSACQRR0QYCAwP8AcSALQQh2ciELIApBAWshDCABQQh1IQEgA0EUdEGAgMD/AHEgAkEIdnIhAiAEQRR0QYCAwP8AcSADQQh2ciEDIAVBFHRBgIDA/wBxIARBCHZyIQQgBkEUdEGAgMD/AHEgBUEIdnIhBSAHQRR0QYCAwP8AcSAGQQh2ciEGIAhBFHRBgIDA/wBxIAdBCHZyIQcgCUEUdEGAgMD/AHEgCEEIdnIhCCANQYCAwP8AcSAJQQh2ciEJIAoNAAsL7AEBA38jAEFAaiIBJAAgAUHevSo2AjAgAEH5hiogAUEwahCbASAAQQBBAhChAQJAIABBwQBBAUGQiDQtAAAbEIYBIgIEQCAAIAAoAgxBEGtB78YrEFkgAEEgQQBBkIg0LQAAGxCGASIDRQ0BIAAgACgCDEEQa0Hf/yoQWUGQljQoAgAoAiQgAyACEIMEIAFB3r0qNgIgIABB4IcqIAFBIGoQmwEgAUFAayQAQQEPCyABQcO2KTYCBCABQd69KjYCACAAQfyIKiABEGwACyABQcuxKTYCFCABQd69KjYCECAAQfyIKiABQRBqEGwAC9kFAQx/IwBB0AJrIgMkACADQv7M+c3wADcDwAIgA0LiwNbioPfyzg83A7gCIANCm4Wc2ICOuq4JNwOwAiADQtmyo/HA2+zmDzcDqAIgA0KYr+C3kLaFlA83A6ACIANC97TrwcAANwOQAiADQvvJ9qrgiI+1AjcDiAIgA0KX+qPFgKK44A83A4ACIANCnLPQqoDNoqILNwP4ASADQripw9jwn8K+BDcD8AEgA0EMaiADQaACaiADQfABahDeCBogA0L/////8AE3A+ABIANC//////D///8PNwPYASADQq71+v/w////DzcD0AEgA0K/94DFwN6a5w03A8gBIANCwYLZgdCZ+pINNwPAAQJAIAAEQCADQZABaiADQcABaiAAENQIIAEoAgghBAwBCyABKAIIIQRBACEAA0AgDUEIdCAAQRR2ciENIABBCHRBgP7//wBxIAVBFHZyIQAgBUEIdEGA/v//AHEgBkEUdnIhBSAGQQh0QYD+//8AcSAHQRR2ciEGIAdBCHRBgP7//wBxIAhBFHZyIQcgCEEIdEGA/v//AHEgCUEUdnIhCCAJQQh0QYD+//8AcSAKQRR2ciEJIApBCHRBgP7//wBxIAtBFHZyIQogC0EIdEGA/v//AHEgDEEUdnIhCyAEIA5qLQAAIAxBCHRBgP7//wBxciEMIA5BAWoiDkEgRw0ACyADIAA2ArABIAMgDTYCtAEgAyAFNgKsASADIAY2AqgBIAMgBzYCpAEgAyAINgKgASADIAk2ApwBIAMgCjYCmAEgAyALNgKUASADIAw2ApABIANBkAFqIANBwAFqENIICyABQSA2AgAgBCADQZABahCBBCADQQxqIANBkAFqEOQIIANBoAJqIANB8AFqIANBDGoQgAQgAigCCEEEOgAAIAJBwQA2AgAgAigCCEEBaiADQaACahCBBCACKAIIQSFqIANB8AFqEIEEIANB0AJqJAALzAQBCX8jAEEwayIEJAAgBEHlvio2AiAgAEH5hiogBEEgahCbAUHnsSkhAQJAAkAgAEEBEMgBIgdFDQBBIEEAQZCINC0AABsiAiAHKAIASA0AIAAgAhCGASICRQRAQYWyKSEBDAELIAIoAgQiA0EASgRAQQAhAQNAIAIoAgggAWpBADoAACABQQFqIgEgAigCBCIDSA0ACwsgAkEANgIAIAIgBygCACIBIAMgASADSBsiAzYCACADQQBKBEBBACEBA0AgAigCCCABaiAHKAIIIAFqLQAAOgAAIAFBAWoiASACKAIAIgNIDQALCwJAIANBIEEAQZCINC0AACIJGyIGSg0AIAYgAigCBEoNACADIAZGDQAgBiADayEBIANBAEoEQCAGIQUDQCACKAIIIgggBUEBayIFaiAIIAUgAWtqLQAAOgAAIAEgBUgNAAsLAkAgAUEATA0AIAFBA3EiCARAQQAhBQNAIAFBAWsiASACKAIIakEAOgAAIAVBAWoiBSAIRw0ACwsgAyAGa0F8Sw0AA0AgAigCCCABakEBa0EAOgAAIAIoAgggAWpBAmtBADoAACABQQNrIgMgAigCCGpBADoAACABQQRrIgEgAigCCGpBADoAACADQQFLDQALCyACIAY2AgALIABBwQBBASAJGxCGASIBDQFBw7YpIQELIAcQmgEgBCABNgIEIARB5b4qNgIAIABB/IgqIAQQbAALQQAgAiABEIMEIAcQmgEgBEHlvio2AhAgAEHghyogBEEQahCbASAEQTBqJABBAQvQAQECfyMAQTBrIgEkACABQfKaKjYCICAAQfmGKiABQSBqEJsBAkBBlIg0KAIABEBBnIg0LQAAQQFxDQELIAFB8poqNgIQIABB+rMrIAFBEGoQbAALIABBGEEBENoBIQIgAEHY4c59QbHwKhCQARogAEF+ENsBIAJBADsBFCACQiA3AgggAkEANgIQIAJBAToAACAAIAIQyAIgAigCDEGUiDQoAgBBIEEAQZyINC0AABsQhgQgAUHymio2AgAgAEHghyogARCbASABQTBqJABBAQuBBAIafwF7IAD9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIABCADcCMCAAQSBqIhEgHf0LAgAgAEEQaiISIB39CwIAIAJBAEoEQEEwIAIgAkEwThshE0EAIQIgAEEsaiEUIABBKGohFSAAQSRqIRYgAEEcaiEXIABBGGohGCAAQRRqIRkgAEEMaiEaIABBBGohGwNAIAAgEEEIdCAOQRV1ciIQNgI0IAAgAkEIdEGA/v//AXEiHDYCACAAIA5BCHRBgP7//wFxIA1BFXVyIg42AjAgFCANQQh0QYD+//8BcSAMQRV1ciINNgIAIBUgDEEIdEGA/v//AXEgC0EVdXIiDDYCACAWIAtBCHRBgP7//wFxIApBFXVyIgs2AgAgESAKQQh0QYD+//8BcSAJQRV1ciIKNgIAIBcgCUEIdEGA/v//AXEgCEEVdXIiCTYCACAYIAhBCHRBgP7//wFxIAdBFXVyIgg2AgAgGSAHQQh0QYD+//8BcSAGQRV1ciIHNgIAIBIgBkEIdEGA/v//AXEgBUEVdXIiBjYCACAaIAVBCHRBgP7//wFxIARBFXVyIgU2AgAgACAEQQh0QYD+//8BcSADQRV1ciIENgIIIBsgA0EIdEGA/v//AXEgAkEVdXIiAzYCACAAIBwgASAPai0AAHIiAjYCACAPQQFqIg8gE0cNAAsLC9ABAQJ/IwBBMGsiASQAIAFBmZErNgIgIABB+YYqIAFBIGoQmwECQEGYiDQoAgAEQEGciDQtAABBAXENAQsgAUGZkSs2AhAgAEG3sysgAUEQahBsAAsgAEEYQQEQ2gEhAiAAQdjhzn1BsfAqEJABGiAAQX4Q2wEgAkEAOwEUIAJCIDcCCCACQQA2AhAgAkEBOgAAIAAgAhDIAiACKAIMQZiINCgCAEEgQQBBnIg0LQAAGxCGBCABQZmRKzYCACAAQeCHKiABEJsBIAFBMGokAEEBC4MBAQJ/IwBBMGsiASQAIAFB/Y0qNgIgIABB+YYqIAFBIGoQmwFBoIg0LQAARQRAIAFB/Y0qNgIQIABB2LMrIAFBEGoQbAALIAAoAgwiAkEDOgAEIAJBATYCACAAIAAoAgxBCGo2AgwgAUH9jSo2AgAgAEHghyogARCbASABQTBqJABBAQu5AgEIfyMAQdAAayIBJAAgAUGb0ik2AkAgAEH5hiogAUFAaxCbAQJAAkAgAEEBEMgBIgQoAgAiAkEha0FuSwRAIABBAhDIASECIABBAxDIASIFKAIAIgNBC0wNASAAQQQQyAEhAwJ/QZ/JKSAAIAIoAgBBEGoQhgEiBkUNABpBxvMqIABBEBCGASIIRQ0AGiAEKAIAIAQoAgggBSgCACAFKAIIIAMgAiAGIAgQigRBASEHQQALIQYgAxCaASAFEJoBIAIQmgEgBBCaASAHRQ0CIAFBm9IpNgIgIABB4IcqIAFBIGoQmwEgAUHQAGokAEECDwsgASACNgIAIABBhcYpIAEQbgALIAEgAzYCECAAQerDKSABQRBqEG4ACyABIAY2AjQgAUGb0ik2AjAgAEH8iCogAUEwahBsAAvbBQELfyMAQcAUayIIJAAgCCAAIAEgAiADEP0IIAggBCgCCCAEKAIAEP4IIAUoAgAhDSAFKAIIIQ8gBigCCCEQAkACQAJAIAgoArAQDgIAAQILIAhBATYCsBALIA1BAEoEQCAIQYAQaiEOIAhBoBRqIREgCEG0EGohEkEAIQQDQCAIIAgoAqwUIgNBGHQgA0GA/gNxQQh0ciADQQh2QYD+A3EgA0EYdnJyQQFqIgNBGHQgA0GA/gNxQQh0ciADQQh2QYD+A3EgA0EYdnJyNgKsFCAIIBH9AAIA/QsEsBQgEiAIQbAUahD6CEEAIQMCQCAEIA1ODQADQCAEIBBqIAhBsBRqIANqLQAAIAQgD2otAABzIgI6AAAgAyAOaiIBIAEtAAAgAnM6AAAgCCAIKAKsEEEBaiICNgKsECACRQRAIAggCCgCqBBBAWo2AqgQCyAEQQFqIQQgA0EOSw0BIANBAWohAyAEIA1IDQALC0EIIQNBACEKQQAhCUEAIQtBACEMQQAhAEEAIQIDQCAAIA5qLQAAIANBAWsiA3ZBAXEEQCAIIAJBBHRqIgEoAgwgCnMhCiABKAIEIAtzIQsgASgCACAMcyEMIAEoAgggCXMhCQsCQCADRQRAQQghAyAAQQFqIgBBEEYNAQsgAkEBaiICQYABRw0BCwsgCCAMQRB2OgCBECAIIAxBGHY6AIAQIAggCzoAhxAgCCALQQh2OgCGECAIIAtBEHY6AIUQIAggC0EYdjoAhBAgCCAJOgCLECAIIAlBCHY6AIoQIAggCUEQdjoAiRAgCCAJQRh2OgCIECAIIAo6AI8QIAggCkEIdjoAjhAgCCAKQRB2OgCNECAIIApBGHY6AIwQIAggDEEIdCAMQYD+A3FBCHZyOwGCECAEIA1IDQALCyANQQ9xRQ0AIAhBAjYCsBALIAYgBSgCADYCACAIIAcoAggQ/wggB0EQNgIAIAhBwBRqJAALxQIBCH8jAEHQAGsiASQAIAFB4NIpNgJAIABB+YYqIAFBQGsQmwECQAJAIABBARDIASIEKAIAIgJBIWtBbksEQCAAQQIQyAEhAiAAQQMQyAEiBSgCACIDQQtMDQFBACEDAn9B65sqIABBBBDIASIHRQ0AGkGfySkgACACKAIAQRBqEIYBIgZFDQAaQcbzKiAAQRAQhgEiCEUNABogBCgCACAEKAIIIAUoAgAgBSgCCCAHIAIgBiAIEIwEQQEhA0EACyEGIAcQmgEgBRCaASACEJoBIAQQmgEgA0UNAiABQeDSKTYCICAAQeCHKiABQSBqEJsBIAFB0ABqJABBAg8LIAEgAjYCACAAQcPGKSABEG4ACyABIAM2AhAgAEGqxCkgAUEQahBuAAsgASAGNgI0IAFB4NIpNgIwIABB/IgqIAFBMGoQbAAL2wUBC38jAEHAFGsiCCQAIAggACABIAIgAxD9CCAIIAQoAgggBCgCABD+CCAFKAIAIQ0gBSgCCCEPIAYoAgghEAJAAkACQCAIKAKwEA4CAAECCyAIQQE2ArAQCyANQQBKBEAgCEGAEGohDiAIQaAUaiERIAhBtBBqIRJBACEEA0AgCCAIKAKsFCIDQRh0IANBgP4DcUEIdHIgA0EIdkGA/gNxIANBGHZyckEBaiIDQRh0IANBgP4DcUEIdHIgA0EIdkGA/gNxIANBGHZycjYCrBQgCCAR/QACAP0LBLAUIBIgCEGwFGoQ+ghBACEDAkAgBCANTg0AA0AgBCAQaiAEIA9qLQAAIgIgCEGwFGogA2otAABzOgAAIAMgDmoiASACIAEtAABzOgAAIAggCCgCrBBBAWoiAjYCrBAgAkUEQCAIIAgoAqgQQQFqNgKoEAsgBEEBaiEEIANBDksNASADQQFqIQMgBCANSA0ACwtBCCEDQQAhCkEAIQlBACELQQAhDEEAIQBBACECA0AgACAOai0AACADQQFrIgN2QQFxBEAgCCACQQR0aiIBKAIMIApzIQogASgCBCALcyELIAEoAgAgDHMhDCABKAIIIAlzIQkLAkAgA0UEQEEIIQMgAEEBaiIAQRBGDQELIAJBAWoiAkGAAUcNAQsLIAggDEEQdjoAgRAgCCAMQRh2OgCAECAIIAs6AIcQIAggC0EIdjoAhhAgCCALQRB2OgCFECAIIAtBGHY6AIQQIAggCToAixAgCCAJQQh2OgCKECAIIAlBEHY6AIkQIAggCUEYdjoAiBAgCCAKOgCPECAIIApBCHY6AI4QIAggCkEQdjoAjRAgCCAKQRh2OgCMECAIIAxBCHQgDEGA/gNxQQh2cjsBghAgBCANSA0ACwsgDUEPcUUNACAIQQI2ArAQCyAGIAUoAgA2AgAgCCAHKAIIEP8IIAdBEDYCACAIQcAUaiQAC40HARR/IwBBgAFrIgIkACACQbq1KjYCICAAQfmGKiACQSBqEJsBIABBARDIASETAkAgAEECEMgBIglFBEBBsrMpIQoMAQsCQCAJIgMoAggQ/QNFDQAgEyIDKAIIEP0DRQ0AQZLXKSEKDAELIABBIBCGASIERQRAQZHiKyEKDAELIABBwAAQhgEiB0UEQEHdtCkhCgwBCyATIAkgAyAJRhsoAgghFCMAQaACayIBJAADQCAGQQh0IAtBFHZyIQYgC0EIdEGA/v//AHEgDEEUdnIhCyAMQQh0QYD+//8AcSANQRR2ciEMIA1BCHRBgP7//wBxIA5BFHZyIQ0gDkEIdEGA/v//AHEgD0EUdnIhDiAPQQh0QYD+//8AcSAQQRR2ciEPIBBBCHRBgP7//wBxIBFBFHZyIRAgEUEIdEGA/v//AHEgEkEUdnIhESASQQh0QYD+//8AcSAFQRR2ciESIAggFGotAAAgBUEIdEGA/v//AHFyIQUgCEEBaiIIQSBHDQALIAEgCzYC4AEgASAGNgLkASABIAw2AtwBIAEgDTYC2AEgASAONgLUASABIA82AtABIAEgEDYCzAEgASARNgLIASABIBI2AsQBIAEgBTYCwAECQCABQQxqIAMoAggQ/gNFDQAgAUL/////8AE3A5ACIAFC//////D///8PNwOIAiABQq71+v/w////DzcDgAIgAUK/94DFwN6a5w03A/gBIAFCwYLZgdCZ+pINNwPwASABQcABaiABQfABahDSCCABQQxqIAFBwAFqEOQIIAFBDGoQ2AgEQCABQeQAahDYCA0BCyABQZABaiABQZABaiABQQxqEIAEIAdBIDYCACAHKAIIIAFBkAFqEIEECyABQaACaiQAIAJBADYCPCACQoCAgICACDcCMCACIAJBQGs2AjggBEEANgIAQQEhCEEgIAdBAUEAIAJBMGpBABCOBCAEKAIAIgNBAEoNAAJAIAIoAjAiBUEASgR/QQAhAyACKAI4IRQDQCAEKAIAIANqIgcgBCgCBCIGTg0CIAQoAgggB2ogAyAUai0AADoAACADQQFqIgMgBUcNAAsgBCgCAAUgAwsgBWohBgsgBCAGNgIACyAJEJoBIBMQmgEgCEUEQCACIAo2AhQgAkG6tSo2AhAgAEH8iCogAkEQahBsAAsgAkG6tSo2AgAgAEHghyogAhCbASACQYABaiQAQQILxRcCB38BfiMAQZAJayIGJAACQAJAAkACQCAAQTBrDhEBAwMDAwMDAwMDAwMDAwMDAgALIABBIEcNAiAGQcwGakEAQYAC/AsAIAZBIDYCjAkgBkKrs4/8kaOz8NsANwLEBiAGQv+kuYjFkdqCm383ArwGIAZC8ua746On/aelfzcCtAYgBkLnzKfQ1tDrs7t/NwKsBiAGQgA3AqQGDAILIAZBmAFqQQBBgAX8CwAgBv0MAAAAAAAAAAAAAAAAAAAAAP0LA0ggBkEwNgKYBiAGQqSf6ffbg9LaxwA3A5ABIAZCp5/mp9bBi4ZbNwOIASAGQpGq4ML20JLajn83A4ABIAZCsZaA/v/MyZnnADcDeCAGQrmyubiPm/uXFTcDcCAGQpe6w4Ojq8CskX83A2ggBkKHqvOzo6WKzeIANwNgIAZC2L2WiNyr591LNwNYDAELIAZBmAFqQQBBgAX8CwAgBv0MAAAAAAAAAAAAAAAAAAAAAP0LA0ggBkHAADYCmAYgBkL5wvibkaOz8NsANwOQASAGQuv6htq/tfbBHzcDiAEgBkKf2PnZwpHagpt/NwOAASAGQtGFmu/6z5SH0QA3A3ggBkLx7fT4paf9p6V/NwNwIAZCq/DT9K/uvLc8NwNoIAZCu86qptjQ67O7fzcDYCAGQoiS853/zPmE6gA3A1gLAkAgASgCACIHQQBMDQACQAJAAkAgAEEwaw4RAQMDAwMDAwMDAwMDAwMDAwIACyAAQSBHDQIgBkHMBmohCCABKAIIIQtBACEBA0AgCCAGKAKkBiIJQQN2QTxxaiIKIAEgC2otAAAgCigCAEEIdHI2AgAgBiAJQQhqIgk2AqQGAkACQCAJRQRAIAZBADYCpAYgBiAGKAKoBkEBajYCqAYMAQsgCUH/A3ENAQsgBkGkBmoQ9wELIAFBAWoiASAHRw0ACwwCCyAGQZgBaiEKIAEoAgghCEEAIQEDQCAKIAYpA0giDadBA3ZB+ABxaiIJIAEgCGoxAAAgCSkDAEIIhoQ3AwAgBiANQgh8Ig03A0gCQAJAIA1QBEAgBkIANwNIIAYgBikDUEIBfDcDUAwBCyANQv8Hg0IAUg0BCyAGQcgAahD5AwsgAUEBaiIBIAdHDQALDAELIAZBmAFqIQogASgCCCEIQQAhAQNAIAogBikDSCINp0EDdkH4AHFqIgkgASAIajEAACAJKQMAQgiGhDcDACAGIA1CCHwiDTcDSAJAAkAgDVAEQCAGQgA3A0ggBiAGKQNQQgF8NwNQDAELIA1C/weDQgBSDQELIAZByABqEPkDCyABQQFqIgEgB0cNAAsLAkAgAkEATA0AIAJB/wFxIQEgAkEYdiEHIAJBCHZB/wFxIQkgAkEQdkH/AXEhCgJAAkACQCAAQTBrDhEBAwMDAwMDAwMDAwMDAwMDAAILIAZBmAFqIgggBikDSCINp0EDdkH4AHFqIgIgB60gAikDAEIIhoQ3AwAgBiANQgh8Ig03A0gCQAJAIA1QBEAgBkIANwNIIAYgBikDUEIBfDcDUAwBCyANQv8Hg0IAUg0BCyAGQcgAahD5AyAGKQNIIQ0LIAggDadBA3ZB+ABxaiIHIAqtIAcpAwBCCIaENwMAIAYgDUIIfCINNwNIAkACQCANUARAIAZCADcDSCAGIAYpA1BCAXw3A1AMAQsgDUL/B4NCAFINAQsgBkHIAGoQ+QMgBikDSCENCyAIIA2nQQN2QfgAcWoiByAJrSAHKQMAQgiGhDcDACAGIA1CCHwiDTcDSAJAAkAgDVAEQCAGQgA3A0ggBiAGKQNQQgF8NwNQDAELIA1C/weDQgBSDQELIAZByABqEPkDIAYpA0ghDQsgCCANp0EDdkH4AHFqIgcgAa0gBykDAEIIhoQ3AwAgBiANQgh8Ig03A0gCQCANUARAIAZCADcDSCAGIAYpA1BCAXw3A1AMAQsgDUL/B4NCAFINAwsgBkHIAGoQ+QMMAgsgBkGYAWoiCCAGKQNIIg2nQQN2QfgAcWoiAiAHrSACKQMAQgiGhDcDACAGIA1CCHwiDTcDSAJAAkAgDVAEQCAGQgA3A0ggBiAGKQNQQgF8NwNQDAELIA1C/weDQgBSDQELIAZByABqEPkDIAYpA0ghDQsgCCANp0EDdkH4AHFqIgcgCq0gBykDAEIIhoQ3AwAgBiANQgh8Ig03A0gCQAJAIA1QBEAgBkIANwNIIAYgBikDUEIBfDcDUAwBCyANQv8Hg0IAUg0BCyAGQcgAahD5AyAGKQNIIQ0LIAggDadBA3ZB+ABxaiIHIAmtIAcpAwBCCIaENwMAIAYgDUIIfCINNwNIAkACQCANUARAIAZCADcDSCAGIAYpA1BCAXw3A1AMAQsgDUL/B4NCAFINAQsgBkHIAGoQ+QMgBikDSCENCyAIIA2nQQN2QfgAcWoiByABrSAHKQMAQgiGhDcDACAGIA1CCHwiDTcDSAJAIA1QBEAgBkIANwNIIAYgBikDUEIBfDcDUAwBCyANQv8Hg0IAUg0CCyAGQcgAahD5AwwBCyAAQSBHDQAgBkHMBmoiCCAGKAKkBiICQQN2QTxxaiILIAsoAgBBCHQgB3I2AgAgBiACQQhqIgc2AqQGAkACQCAHRQRAIAZBADYCpAYgBiAGKAKoBkEBajYCqAYMAQsgB0H/A3ENAQsgBkGkBmoQ9wEgBigCpAYhBwsgCCAHQQN2QTxxaiICIAIoAgBBCHQgCnI2AgAgBiAHQQhqIgc2AqQGAkACQCAHRQRAIAZBADYCpAYgBiAGKAKoBkEBajYCqAYMAQsgB0H/A3ENAQsgBkGkBmoQ9wEgBigCpAYhBwsgCCAHQQN2QTxxaiIKIAooAgBBCHQgCXI2AgAgBiAHQQhqIgc2AqQGAkACQCAHRQRAIAZBADYCpAYgBiAGKAKoBkEBajYCqAYMAQsgB0H/A3ENAQsgBkGkBmoQ9wEgBigCpAYhBwsgCCAHQQN2QTxxaiIJIAkoAgBBCHQgAXI2AgAgBiAHQQhqIgE2AqQGAkAgAUUEQCAGQQA2AqQGIAYgBigCqAZBAWo2AqgGDAELIAFB/wNxDQELIAZBpAZqEPcBCwJAIANFDQAgAygCACIHQQBMDQAgBkHMBmohDCAGQZgBaiEKIABBMGshCSAAQSBGIQJBACEBA0ACQAJAAkACQCAJDhEBAwMDAwMDAwMDAwMDAwMDAgALIAJFDQIgDCAGKAKkBiIIQQN2QTxxaiILIAMoAgggAWotAAAgCygCAEEIdHI2AgAgBiAIQQhqIgg2AqQGAkAgCEUEQCAGQQA2AqQGIAYgBigCqAZBAWo2AqgGDAELIAhB/wNxDQMLIAZBpAZqEPcBDAILIAogBikDSCINp0EDdkH4AHFqIgggAygCCCABajEAACAIKQMAQgiGhDcDACAGIA1CCHwiDTcDSAJAIA1QBEAgBkIANwNIIAYgBikDUEIBfDcDUAwBCyANQv8Hg0IAUg0CCyAGQcgAahD5AwwBCyAKIAYpA0giDadBA3ZB+ABxaiIIIAMoAgggAWoxAAAgCCkDAEIIhoQ3AwAgBiANQgh8Ig03A0gCQCANUARAIAZCADcDSCAGIAYpA1BCAXw3A1AMAQsgDUL/B4NCAFINAQsgBkHIAGoQ+QMLIAFBAWoiASAHRw0ACwsCQAJAAkACQCAAQTBrDhEBAwMDAwMDAwMDAwMDAwMDAgALIABBIEcNAiAGQaQGaiAGEPgBDAILIAZByABqIAYQ+AMMAQsgBkHIAGogBhD4AwtBACEBIARBADYCAAJAIAVFDQAgACAFTgRAIAUhAAwBCyAFIABrIQlBACEHA0AgByAEKAIETg0BIAQoAgggB2pBADoAACAEIAQoAgBBAWoiATYCACAHQQFqIgcgCUcNAAsLAkAgAEEATA0AQQAhBwNAIAEgBCgCBE4NASAEKAIIIAFqIAYgB2otAAA6AAAgBCAEKAIAQQFqNgIAIAFBAWohASAHQQFqIgcgAEcNAAsLIAZBkAlqJAALhAEBA38jAEEgayIBJAAgAUGv1yo2AhAgAEH5hiogAUEQahCbASAAQQEQyAEiAkUEQCAAQd+2KUEAEGwACyACKAIIEP0DIQMgACgCDEEBQREgAxs6AAQgACAAKAIMQQhqNgIMIAIQmgEgAUGv1yo2AgAgAEHghyogARCbASABQSBqJABBAQu8AwEIfyMAQTBrIgIkACACQdq6KjYCICAAQfmGKiACQSBqEJsBIABBARDIASEFIABBAhDIASEGAkACQCAAKAIUKAIAQRhqIgMgACgCDE8EfyAAKAIQQSxqBSADCy0ABEEPcUUEQEEAIQMgAEEAQQIQoQEgAEHAABCGASIERQRAQcWiKiEBQQAhBAwDCyAAIAAoAgxBEGtB/6IqEFkgAEHAABCGASIBRQRAQaaEKiEBDAILIAAgACgCDEEQa0GSjCoQWUGQljQoAgAoAiRBACAFIAYgBCABEJEEQQEhBEEAIQEMAgsgAEEDEMgBIgNFBEBB0bMpIQEMAQsgAEEAQQIQoQEgAEHAABCGASIHRQRAQcWiKiEBDAILIAAgACgCDEEQa0H/oioQWSAAQcAAEIYBIghFBEBBpoQqIQEMAgsgACAAKAIMQRBrQZKMKhBZQQAgAyAFIAYgByAIEJEEQQEhBAwBC0EAIQNBACEECyADEJoBIAYQmgEgBRCaASAERQRAIAIgATYCFCACQdq6KjYCECAAQfyIKiACQRBqEGwACyACQdq6KjYCACAAQeCHKiACEJsBIAJBMGokAEEBC/AeAR5/IwBB8AZrIgYkACAGQQA2ArwEIAZCgICAgIAQNwKwBCAGIAZBwARqNgK4BEHAACADQX9BACAGQbAEakHAABCOBCAGQv7M+c3wADcDICAGQuLA1uKg9/LODzcDGCAGQpuFnNiAjrquCTcDECAGQtmyo/HA2+zmDzcDCCAGQpiv4LeQtoWUDzcDACAGQve068HAADcDwAYgBkL7yfaq4IiPtQI3A7gGIAZCl/qjxYCiuOAPNwOwBiAGQpyz0KqAzaKiCzcDqAYgBkK4qcPY8J/CvgQ3A6AGIAZBjAFqIAYgBkGgBmoQ3ggaIAZC//////ABNwOgBCAGQv/////w////DzcDmAQgBkKu9fr/8P///w83A5AEIAZCv/eAxcDemucNNwOIBCAGQsGC2YHQmfqSDTcDgAQgAigCCCEOQQAhA0EAIQIDQCAYQQh0IBBBFHZyIRggEEEIdEGA/v//AHEgA0EUdnIhECADQQh0QYD+//8AcSACQRR2ciIbIQMgAkEIdEGA/v//AHEgB0EUdnIiHCECIAdBCHRBgP7//wBxIAhBFHZyIh0hByAIQQh0QYD+//8AcSAJQRR2ciIeIQggCUEIdEGA/v//AHEgCkEUdnIiHyEJIApBCHRBgP7//wBxIAtBFHZyIiAhCiALQQh0QYD+//8AcSAMQRR2ciIhIQsgDSAOai0AACAMQQh0QYD+//8AcXIiIiEMIA1BAWoiDUEgRw0AC0EAIQMCQCAGKAKwBCINQQBMBEBBACENDAELQSAgDSANQSBOGyEPIAYoArgEIRlBACECQQAhB0EAIQhBACEJQQAhCkEAIQtBACEMQQAhDUEAIQ4DQCAaQQh0IA1BFHVyIRogA0EUdSERIAJBFHUhEiAHQRR1IRMgCEEUdSEUIAlBFHUhFSAKQRR1IRYgC0EUdSEXIA1BCHRBgP7//wBxIAxBFHVyIQ0gDiAZai0AACADQQh0QYD+//8AcXIiIyEDIBEgAkEIdEGA/v//AHFyIhEhAiASIAdBCHRBgP7//wBxciISIQcgEyAIQQh0QYD+//8AcXIiEyEIIBQgCUEIdEGA/v//AHFyIhQhCSAVIApBCHRBgP7//wBxciIVIQogFiALQQh0QYD+//8AcXIiFiELIBcgDEEIdEGA/v//AHFyIhchDCAOQQFqIg4gD0cNAAsLAkACQCAABEADQCAGQfACaiAGQYAEaiAAENQIIAZBkAJqIAZBgARqIAAQ1AggBiAGKAKMATYCACAGIAb9AAKQAf0LAgQgBiAG/QACoAH9CwIUIAYgBv0AArAB/QsCJCAGIAb9AALAAf0LAjQgBiAG/QAC0AH9CwJEIAYgBv0AAuAB/QsCVCAGIAYpAvABNwJkIAYgBigC+AE2AmwgBiAGKAL8ATYCcCAGIAb9AAKAAv0LAnQgBiAGQfACahDkCCAGQcACaiAGQcACaiAGEIAEIAYgBigCwAI2AtADIAYgBv0AAsQC/QsC1AMgBiAG/QAC1AL9CwLkAyAGIAYoAuQCNgL0AyAGQdADaiAGQYAEahDSCCAGKALUAyEDAkACQCAGKALQAyIHBEAgBigC2AMhAgwBCyADIAYoAtgDIgJyDQBBACECIAYoAtwDDQAgBigC4AMNACAGKALkAw0AIAYoAugDDQAgBigC7AMNACAGKALwAw0AIAYoAvQDRQ0BCyAGIAb9AATwAv0LBPAFIAYgBv0ABIAD/QsEgAYgBiAGKQOQAzcDkAYgBiAG/QAEkAL9CwTABSAGIAb9AASgAv0LBNAFIAYgBikDsAI3A+AFIAZB8AVqIAZBgARqENIIIAZBwAVqIAZBgARqENIIIAZBoAZqIAZB8AVqIAZBwAVqEM0IIAZB8AJqIAZBoAZqIAZBgARqENMIIAZB8AJqIAZB8AJqIAZBgARqENYIIAYgGDYClAYgBiAQNgKQBiAGIBs2AowGIAYgHDYCiAYgBiAdNgKEBiAGIB42AoAGIAYgHzYC/AUgBiAgNgL4BSAGICE2AvQFIAYgIjYC8AUgBiACNgLIBSAGIAM2AsQFIAYgBzYCwAUgBiAGKQLcAzcCzAUgBiAGKALkAzYC1AUgBiAG/QAD6AP9CwPYBSAGQfAFaiAGQYAEahDSCCAGQcAFaiAGQYAEahDSCCAGQaAGaiAGQfAFaiAGQcAFahDNCCAGQaADaiAGQaAGaiAGQYAEahDTCCAGIAYoAqADICNqIgM2AqADIAYgBigCpAMgEWoiAjYCpAMgBiAGKAKoAyASaiIHNgKoAyAGIAYoAqwDIBNqIgg2AqwDIAYgBigCsAMgFGoiCTYCsAMgBiAGKAK0AyAVaiIKNgK0AyAGIAYoArgDIBZqIgs2ArgDIAYgBigCvAMgF2oiDDYCvAMgBiAGKALAAyANaiIONgLAAyAGIAYoAsQDIBpqIg82AsQDIAYgDzYClAYgBiAONgKQBiAGIAw2AowGIAYgCzYCiAYgBiAKNgKEBiAGIAk2AoAGIAYgCDYC/AUgBiAHNgL4BSAGIAI2AvQFIAYgAzYC8AUgBiAGKAKQAjYCwAUgBiAGKAKUAjYCxAUgBiAGKAKYAjYCyAUgBiAGKAKcAjYCzAUgBiAGKAKgAjYC0AUgBiAGKAKkAjYC1AUgBiAGKAKoAjYC2AUgBiAGKAKsAjYC3AUgBiAGKAKwAjYC4AUgBiAGKAK0AjYC5AUgBkHwBWogBkGABGoQ0gggBkHABWogBkGABGoQ0gggBkGgBmogBkHwBWogBkHABWoQzQggBkGgA2ogBkGgBmogBkGABGoQ0wggBiAGKALwAjYC8AUgBiAGKQL0AjcC9AUgBiAG/QAC/AL9CwL8BSAGIAYpAowDNwKMBiAGIAYoApQDNgKUBiAGIAYoAqADNgLABSAGIAYoAqQDNgLEBSAGIAYoAqgDNgLIBSAGIAYoAqwDNgLMBSAGIAYoArADNgLQBSAGIAYoArQDNgLUBSAGIAYoArgDNgLYBSAGIAYoArwDNgLcBSAGIAYoAsADNgLgBSAGIAYoAsQDNgLkBSAGQfAFaiAGQYAEahDSCCAGQcAFaiAGQYAEahDSCCAGQaAGaiAGQfAFaiAGQcAFahDNCCAGQaADaiAGQaAGaiAGQYAEahDTCAsgBigCoAMNAiAGKAKkAw0CIAYoAqgDDQIgBigCrAMNAiAGKAKwAw0CIAYoArQDDQIgBigCuAMNAiAGKAK8Aw0CIAYoAsADDQIgBigCxANFDQALDAELIAEoAgghGUEAIQJBACEPQQAhA0EAIQdBACEIQQAhCUEAIQpBACELQQAhDEEAIQ5BACEAA0AgD0EIdCADQRR2ciEPIANBCHRBgP7//wBxIAdBFHZyIQMgB0EIdEGA/v//AHEgCEEUdnIiASEHIAhBCHRBgP7//wBxIAlBFHZyIQggCUEIdEGA/v//AHEgCkEUdnIhCSAKQQh0QYD+//8AcSALQRR2ciEKIAtBCHRBgP7//wBxIAxBFHZyIQsgDEEIdEGA/v//AHEgDkEUdnIhDCAOQQh0QYD+//8AcSAAQRR2ciEOIAIgGWotAAAgAEEIdEGA/v//AHFyIQAgAkEBaiICQSBHDQALIAYgAzYCkAMgBiAPNgKUAyAGIAE2AowDIAYgCDYCiAMgBiAJNgKEAyAGIAo2AoADIAYgCzYC/AIgBiAMNgL4AiAGIA42AvQCIAYgADYC8AIgBkHwAmogBkGABGoQ0gggBiAGKAKMATYCACAGIAb9AAKQAf0LAgQgBiAG/QACoAH9CwIUIAYgBv0AArAB/QsCJCAGIAb9AALAAf0LAjQgBiAG/QAC0AH9CwJEIAYgBv0AAuAB/QsCVCAGIAYpAvABNwJkIAYgBigC+AE2AmwgBiAGKAL8ATYCcCAGIAb9AAKAAv0LAnQgBiAGQfACahDkCCAGQcACaiAGQcACaiAGEIAEIAYgBigCwAI2AtADIAYgBv0AAsQC/QsC1AMgBiAG/QAC1AL9CwLkAyAGIAYoAuQCNgL0AyAGQdADaiAGQYAEahDSCCAGKALUAyEDAkACQCAGKALQAyIHBEAgBigC2AMhAgwBCyADIAYoAtgDIgJyDQBBACECIAYoAtwDDQAgBigC4AMNACAGKALkAw0AIAYoAugDDQAgBigC7AMNACAGKALwAw0AIAYoAvQDRQ0BCyAGQfACaiAGQfACaiAGQYAEahDWCCAGIBg2ApQGIAYgEDYCkAYgBiAbNgKMBiAGIBw2AogGIAYgHTYChAYgBiAeNgKABiAGIB82AvwFIAYgIDYC+AUgBiAhNgL0BSAGICI2AvAFIAYgAjYCyAUgBiADNgLEBSAGIAc2AsAFIAYgBikC3AM3AswFIAYgBigC5AM2AtQFIAYgBv0AA+gD/QsD2AUgBkHwBWogBkGABGoQ0gggBkHABWogBkGABGoQ0gggBkGgBmogBkHwBWogBkHABWoQzQggBkGgA2ogBkGgBmogBkGABGoQ0wggBiAGKAKgAyAjaiIQNgKgAyAGIAYoAqQDIBFqIgM2AqQDIAYgBigCqAMgEmoiAjYCqAMgBiAGKAKsAyATaiIHNgKsAyAGIAYoArADIBRqIgg2ArADIAYgBigCtAMgFWoiCTYCtAMgBiAGKAK4AyAWaiIKNgK4AyAGIAYoArwDIBdqIgs2ArwDIAYgBigCwAMgDWoiDTYCwAMgBiAGKALEAyAaaiIMNgLEAyAGIAYoAvACNgLwBSAGIAYoAvQCNgL0BSAGIAYoAvgCNgL4BSAGIAYoAvwCNgL8BSAGIAYoAoADNgKABiAGIAYoAoQDNgKEBiAGIAYoAogDNgKIBiAGIAYoAowDNgKMBiAGIAYoApADNgKQBiAGIAYoApQDNgKUBiAGIAw2AuQFIAYgDTYC4AUgBiALNgLcBSAGIAo2AtgFIAYgCTYC1AUgBiAINgLQBSAGIAc2AswFIAYgAjYCyAUgBiADNgLEBSAGIBA2AsAFIAZB8AVqIAZBgARqENIIIAZBwAVqIAZBgARqENIIIAZBoAZqIAZB8AVqIAZBwAVqEM0IIAZBoANqIAZBoAZqIAZBgARqENMIIAYoAqADDQEgBigCpAMNASAGKAKoAw0BIAYoAqwDDQEgBigCsAMNASAGKAK0Aw0BIAYoArgDDQEgBigCvAMNASAGKALAAw0BIAYoAsQDDQELDAELIAVBIDYCACAEQSA2AgAgBCgCCCAGQdADahCBBCAFKAIIIAZBoANqEIEECyAGQfAGaiQAC+wFAQl/IwBBQGoiBCQAIARBja8pNgIwIABB+YYqIARBMGoQmwEgAEEBEMgBIQggAEECEMgBIQkCQAJAAkACQAJAAn8CQAJAAkAgACgCFCgCAEEYaiICIAAoAgxJBEAgAi0ABEEPcUEHRg0BDAMLIAAoAhAtADBBD3FBB0cNAQsgAEEDEMgBIgUoAgAiAkHBAGtBfE0EQCAEIAI2AiAgAEGM6SogBEEgahCcAUHv6ysMAwsgAEEgEJgBIQYgAEEgEJgBIQcgBSgCAEHBAGtBfU8EQEEAIQIDQAJAIAUoAgAgAkEDdCIBQfSBLWooAgAiAyABQfCBLWooAgAiAWpHDQAgAUEea0ECSw0AIANBHmtBAksNACABBEAgBigCCCAFKAIIIAH8CgAACyADBEAgBygCCCAFKAIIIAFqIAP8CgAACyAGIAE2AgAgByADNgIAQcAAIAggCSAGIAcQkwRBAE4NBwsgAkEBaiICQQhHDQALCyAGEJoBIAcQmgFBASEBIAAoAgxBAToABCAAIAAoAgxBCGo2AgwMBgsgACgCEEEsaiECCyACLQAEQQ9xQQVHBEBB+q4rIQMMBAsgAEEDQf+iKhCQARogAEEDQZKMKhCQARogAEF+EMgBIgVFBEBBpqIqIQMMBAsgAEF/EMgBIgINAUHDhCoLIQNBACECDAQLQcAAIAggCSAFIAIQkwQhASAAKAIMIQMgAUEASARAQQEhASADQQE6AAQgACAAKAIMQQhqNgIMQQAhAwwECyADQRE6AAQgACAAKAIMQQhqNgIMQQAhA0EBIQEMAwsgBhCaASAHEJoBIAAoAgxBEToABCAAIAAoAgxBCGo2AgxBASEBDAELQQAhAkEAIQUMAQtBACECQQAhAwsgAhCaASAFEJoBIAkQmgEgCBCaASABBEAgBEGNryk2AgAgAEHghyogBBCbASAEQUBrJABBAQ8LIAQgAzYCFCAEQY2vKTYCECAAQfyIKiAEQRBqEGwAC+gSAiV/AXsjAEGQBWsiBSQAIAVBADYC3AMgBUKAgICAgBA3AtADIAUgBUHgA2o2AtgDIAAgAkF/QQAgBUHQA2ogABCOBCAFQv7M+c3wADcDICAFQuLA1uKg9/LODzcDGCAFQpuFnNiAjrquCTcDECAFQtmyo/HA2+zmDzcDCCAFQpiv4LeQtoWUDzcDACAFQve068HAADcDgAUgBUL7yfaq4IiPtQI3A/gEIAVCl/qjxYCiuOAPNwPwBCAFQpyz0KqAzaKiCzcD6AQgBUK4qcPY8J/CvgQ3A+AEIAVBjAFqIAUgBUHgBGoQ3ggaIAVC//////ABNwPAAyAFQv/////w////DzcDuAMgBUKu9fr/8P///w83A7ADIAVCv/eAxcDemucNNwOoAyAFQsGC2YHQmfqSDTcDoAMgAygCACICQSFOBEAgA0EgNgIAA0AgAygCCCAGaiIAIAAgAmpBIGstAAA6AAAgBkEBaiIGIAMoAgBIDQALQSAhAgsgBCgCACIJQSFOBEAgBEEgNgIAQQAhBgNAIAQoAgggBmoiACAAIAlqQSBrLQAAOgAAIAZBAWoiBiAEKAIASA0AC0EgIQkLIAMoAgghESAFQgA3A5ADIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwSAAyAFICr9CwTwAkEAIQBBACEGIAJBAEoEQEEgIAIgAkEgThshEkEAIQNBACECA0AgCEEIdCAGQRR1ciEIIANBFHUhEyACQRR1IQcgCkEUdSEUIAtBFHUhFSAMQRR1IRYgDUEUdSEXIA5BFHUhGCAGQQh0QYD+//8AcSAPQRR1ciEGIBAgEWotAAAgA0EIdEGA/v//AHFyIiAhAyATIAJBCHRBgP7//wBxciIfIQIgByAKQQh0QYD+//8AcXIiHiEKIBQgC0EIdEGA/v//AHFyIh0hCyAVIAxBCHRBgP7//wBxciIcIQwgFiANQQh0QYD+//8AcXIiGyENIBcgDkEIdEGA/v//AHFyIhohDiAYIA9BCHRBgP7//wBxciIZIQ8gEEEBaiIQIBJHDQALIAUgBjYCkAMgBSAINgKUAyAFIBk2AowDIAUgGjYCiAMgBSAbNgKEAyAFIBw2AoADIAUgHTYC/AIgBSAeNgL4AiAFIB82AvQCIAUgIDYC8AILIAQoAgghESAFQgA3A+ACIAUgKv0LBNACIAUgKv0LBMACAkAgCUEATARAQQAhB0EAIQNBACEJDAELQSAgCSAJQSBOGyESQQAhAkEAIQpBACELQQAhDEEAIQ1BACEOQQAhD0EAIQNBACEHQQAhEANAIAdBCHQgA0EUdXIhByAAQRR1IRMgAkEUdSEUIApBFHUhFSALQRR1IRYgDEEUdSEXIA1BFHUhGCAOQRR1IQQgA0EIdEGA/v//AHEgD0EUdXIhAyAQIBFqLQAAIABBCHRBgP7//wBxciInIQAgEyACQQh0QYD+//8AcXIiJiECIBQgCkEIdEGA/v//AHFyIiUhCiAVIAtBCHRBgP7//wBxciIkIQsgFiAMQQh0QYD+//8AcXIiIyEMIBcgDUEIdEGA/v//AHFyIiIhDSAYIA5BCHRBgP7//wBxciIhIQ4gBCAPQQh0QYD+//8AcXIiCSEPIBBBAWoiECASRw0ACyAFIAM2AuACIAUgBzYC5AIgBSAJNgLcAiAFICE2AtgCIAUgIjYC1AIgBSAjNgLQAiAFICQ2AswCIAUgJTYCyAIgBSAmNgLEAiAFICc2AsACCyAFICr9CwP4BCAFQgA3A+AEIAUgKv0LA+gEIAUoAtADIgBBAEoEQEEgIAAgAEEgThshKEEAIQIgBSgC2AMhKUEAIQpBACELQQAhDEEAIQ1BACEOQQAhD0EAIRBBACEAQQAhFEEAIRMDQCAUQQh0IABBFHVyIRQgAkEUdSEVIApBFHUhFiALQRR1IRcgDEEUdSEYIA1BFHUhBCAOQRR1IREgD0EUdSESIABBCHRBgP7//wBxIBBBFHVyIQAgEyApai0AACACQQh0QYD+//8AcXIhAiAVIApBCHRBgP7//wBxciIVIQogFiALQQh0QYD+//8AcXIiFiELIBcgDEEIdEGA/v//AHFyIhchDCAYIA1BCHRBgP7//wBxciIYIQ0gBCAOQQh0QYD+//8AcXIiBCEOIBEgD0EIdEGA/v//AHFyIhEhDyASIBBBCHRBgP7//wBxciISIRAgE0EBaiITIChHDQALIAUgADYCgAUgBSAUNgKEBSAFIBI2AvwEIAUgETYC+AQgBSAENgL0BCAFIBg2AvAEIAUgFzYC7AQgBSAWNgLoBCAFIBU2AuQEIAUgAjYC4AQLQXwhAAJAAkAgIA0AIB8NACAeDQAgHQ0AIBwNACAbDQAgGg0AIBkNACAGDQAgCEUNAQtBDyECAkAgCEEPRw0AQf////8AIQIgBiEIIAZB/////wBHDQAgGSIIQf////8ARw0AIBoiCEH/////AEcNACAbIghB/////wBHDQBBrvX6/wAhAiAcIghBrvX6/wBHDQBB9NW57gAhAiAdIghB9NW57gBHDQBBv/eAxQAhAiAeIghBv/eAxQBHDQBBzdGX6QAhAiAfIghBzdGX6QBHDQBBwYLZASECICAiCEHBgtkBRg0BCyACIAhIDQACQCAnDQAgJg0AICUNACAkDQAgIw0AICINACAhDQAgCQ0AIAMNACAHRQ0BC0EPIQYCQCAHQQ9HDQBB/////wAhBiADIQcgA0H/////AEcNACAJIQcgCUH/////AEcNACAhIgdB/////wBHDQAgIiIHQf////8ARw0AQa71+v8AIQYgIyIHQa71+v8ARw0AQfTVue4AIQYgJCIHQfTVue4ARw0AQb/3gMUAIQYgJSIHQb/3gMUARw0AQc3Rl+kAIQYgJiIHQc3Rl+kARw0AQcGC2QEhBiAnIgdBwYLZAUYNAQsgBiAHSA0AIAVBwAJqIAVBwAJqIAVBoANqENYIIAVB4ARqIAVB4ARqIAVBwAJqIAVBoANqENUIIAVBkAJqIAVB8AJqIAVBwAJqIAVBoANqENUIIAUgASgCCBD+A0UEQEF9IQAMAQsgBSAFQYwBaiAFQZACaiAFQeAEahDmCCAFENcIDQAgBUHAAmogBUHAAmogBRCABCAFQcACaiAFQaADahDSCEF8QQAgBUHAAmogBUHwAmoQ0AgbIQALIAVBkAVqJAAgAAuaOwFLfyMAQTBrIhkkACAZQfrnKTYCICAAQfmGKiAZQSBqEJsBIABBARDIASEoAkAgAEECEMgBIilFBEBByp8rIQMMAQsgGUEANgIsAkACfyAAKAIUKAIAQRhqIg0gACgCDE8EQCAAKAIQQSxqIQ0LIA0tAARBA0YEQCANKAIADAELIA0gGUEsakEAEPwBRQ0BIBkoAiwLIQ0gAEEAQQIQoQEgACANEIYBIipFBEBBxaIqIQMMAgsgACAAKAIMQRBrQf+iKhBZQaaEKiEDIAAgDRCGASIrRQ0BIAAgACgCDEEQa0GSjCoQWSAAIA0QhgEiJUUNASAoIRMjAEHQB2siAyQAIAMiAUEANgKcBSABQoCAgICAEDcCkAUgASABQaAFajYCmAUgDSApQX9BACABQZAFaiANEI4EIAFC/sz5zfAANwNQIAFC4sDW4qD38s4PNwNIIAFCm4Wc2ICOuq4JNwNAIAFC2bKj8cDb7OYPNwM4IAFCmK/gt5C2hZQPNwMwIAFC97TrwcAANwOgByABQvvJ9qrgiI+1AjcDmAcgAUKX+qPFgKK44A83A5AHIAFCnLPQqoDNoqILNwOIByABQripw9jwn8K+BDcDgAcgAUG8AWogAUEwaiABQYAHahDeCBogAUL/////8AE3A4AFIAFC//////D///8PNwP4BCABQq71+v/w////DzcD8AQgAUK/94DFwN6a5w03A+gEIAFCwYLZgdCZ+pINNwPgBCABIAFB4ARqEMwIIhtBB2pBCG0iEEEPakFwcSIGayIJIgMkACADIA1BD2pBcHEiBGsiFCIDJAAgAyAEayIVIgMkACADIAZrIhwiAyQAIAMgDSAQQQF0IhhqIh9BEGpBcHFrIgYiAyQAAkAgG0EATA0AQQEgECAQQQFMGyIEQQdxIQcgG0E5TgRAIAlBB2ohBSAJQQZqIQogCUEFaiELIAlBBGohCCAJQQNqIQwgCUECaiEPIAlBAWohESAEQfj///8AcSESQQAhBANAIAIgCWpBADoAACACIBFqQQA6AAAgAiAPakEAOgAAIAIgDGpBADoAACACIAhqQQA6AAAgAiALakEAOgAAIAIgCmpBADoAACACIAVqQQA6AAAgAkEIaiECIARBCGoiBCASRw0ACwsgB0UNAEEAIQQDQCACIAlqQQA6AAAgAkEBaiECIARBAWoiBCAHRw0ACwsCQAJAIBMoAgAiDyAQIA8gEEgbIgxBAEoEQCAMQQNxIQsgEygCCCEEQQAhB0EAIQIgDEEETwRAIAxB/P///wdxIQhBACEFA0AgAiAJaiACIARqLQAAOgAAIAkgAkEBciIKaiAEIApqLQAAOgAAIAkgAkECciIKaiAEIApqLQAAOgAAIAkgAkEDciIKaiAEIApqLQAAOgAAIAJBBGohAiAFQQRqIgUgCEcNAAsLIAsEQANAIAIgCWogAiAEai0AADoAACACQQFqIQIgB0EBaiIHIAtHDQALCyAPIBBODQIgECAMayECIAxBAEwNASAQIQQDQCAJIARBAWsiBGogCSAEIAJrai0AADoAACACIARIDQALDAELIA8gEE4NASAQIAxrIQILIAJBAEwNACACQQNxIgcEQEEAIQQDQCAJIAJBAWsiAmpBADoAACAEQQFqIgQgB0cNAAsLIAwgEGtBfEsNACAJQQJrIQUgCUEBayEKA0AgAiAKakEAOgAAIAIgBWpBADoAACAJIAJBBGsiBGpBADsAACACQQNrIQcgBCECIAdBAUsNAAsLIB9BAWohDkEAIQJBACEEQQAhB0EAIQVBACEKQQAhC0EAIQhBACEMQQAhDwNAICZBCHQgI0EUdnIhJiAjQQh0QYD+//8AcSAEQRR2ciEjIARBCHRBgP7//wBxIAdBFHZyIiwhBCAHQQh0QYD+//8AcSAFQRR2ciItIQcgBUEIdEGA/v//AHEgCkEUdnIiLiEFIApBCHRBgP7//wBxIAtBFHZyIi8hCiALQQh0QYD+//8AcSAIQRR2ciIwIQsgCEEIdEGA/v//AHEgDEEUdnIiMSEIIAxBCHRBgP7//wBxIA9BFHZyIjIhDCACIAlqLQAAIA9BCHRBgP7//wBxciIzIQ8gAkEBaiICQSBHDQALIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwPIBCABQgA3A7AEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwO4BAJAIAEoApAFIhdBAEoEQEEgIBcgF0EgThshIEEAIQQgASgCmAUhJ0EAIQdBACEFQQAhCkEAIQtBACEIQQAhDEEAIQ9BACECQQAhEkEAIREDQCASQQh0IAJBFHVyIRIgBEEUdSETIAdBFHUhFiAFQRR1IRogCkEUdSEhIAtBFHUhIiAIQRR1IR0gDEEUdSEeIAJBCHRBgP7//wBxIA9BFHVyIQIgESAnai0AACAEQQh0QYD+//8AcXIiJCEEIBMgB0EIdEGA/v//AHFyIhMhByAWIAVBCHRBgP7//wBxciIWIQUgGiAKQQh0QYD+//8AcXIiGiEKICEgC0EIdEGA/v//AHFyIiEhCyAiIAhBCHRBgP7//wBxciIiIQggHSAMQQh0QYD+//8AcXIiHSEMIB4gD0EIdEGA/v//AHFyIh4hDyARQQFqIhEgIEcNAAsgASACNgLQBCABIBI2AtQEIAEgHjYCzAQgASAdNgLIBCABICI2AsQEIAEgITYCwAQgASAaNgK8BCABIBY2ArgEIAEgEzYCtAQgASAkNgKwBEEAIQQgAUEANgIsIAEgFDYCKCABQQA2AiAgASANNgIkIA1BACANQQBKGyECA0AgAiAERg0CIAQgFGpBAToAACAEQQFqIgQgF0cNAAsMAQtBACEEIAFBADYCLCABIBQ2AiggASANNgIkCyABIAQ2AiAgAUEANgIcIAEgFTYCGCABIA02AhQgAUEANgIQAkAgF0EATA0AIA0gF0gNACAXQQdxIQpBACEHQQAhAiAXQQFrQQdPBEAgFUEHaiELIBVBBmohCCAVQQVqIQwgFUEEaiEPIBVBA2ohESAVQQJqIRIgFUEBaiETIBdB+P///wdxIRZBACEFA0AgAiAVakEAOgAAIAIgE2pBADoAACACIBJqQQA6AAAgAiARakEAOgAAIAIgD2pBADoAACACIAxqQQA6AAAgAiAIakEAOgAAIAIgC2pBADoAACACQQhqIQIgBUEIaiIFIBZHDQALCyAKBEADQCACIBVqQQA6AAAgAkEBaiECIAdBAWoiByAKRw0ACwsgASAXNgIQCyAcIAFBsARqEIEEIAFBADYCDCABIAY2AgggASAONgIEAkAgDkEATA0AIA5BB3EhCkEAIQdBACECIB9BB08EQCAGQQdqIQsgBkEGaiEIIAZBBWohDCAGQQRqIQ8gBkEDaiERIAZBAmohEiAGQQFqIRMgDkH4////B3EhFkEAIQUDQCACIAZqQQA6AAAgAiATakEAOgAAIAIgEmpBADoAACACIBFqQQA6AAAgAiAPakEAOgAAIAIgDGpBADoAACACIAhqQQA6AAAgAiALakEAOgAAIAJBCGohAiAFQQhqIgUgFkcNAAsLIApFDQADQCACIAZqQQA6AAAgAkEBaiECIAdBAWoiByAKRw0ACwtBACECIAFBADYCAAJAIAQgDiAEIA5IGyIIQQBMDQAgCEEDcSEKIAhBBE8EQCAIQfz///8HcSELQQAhBwNAIAIgBmogAiAUai0AADoAACAGIAJBAXIiBWogBSAUai0AADoAACAGIAJBAnIiBWogBSAUai0AADoAACAGIAJBA3IiBWogBSAUai0AADoAACACQQRqIQIgB0EEaiIHIAtHDQALCyAKRQ0AQQAhBwNAIAIgBmogAiAUai0AADoAACACQQFqIQIgB0EBaiIHIApHDQALCyAEIA5IBEAgBiAIakEAOgAAIAhBAWohCAsCfyAbQQBKBEAgBiAIaiEHIAggDiAIIA5KGyAIayEEQQAhAgNAIA4gAiAERg0CGiACIAdqIAIgCWotAAA6AAAgAkEBaiICIBBHDQALCyAIIBBqCyEFIAECfyAbQQBKBEAgBSAGaiEHIAUgDiAFIA5KGyAFayEEQQAhAgNAIA4gAiAERg0CGiACIAdqIAIgHGotAAA6AAAgAkEBaiICIBBHDQALCyAFIBBqCzYCACANIAEgAUEQaiANIAFBEGoQ7gMaIA0gAUEgaiABQRBqIA0gAUEgahDuAxoCQCAOQQBMDQAgDkEHcSEFQQAhBEEAIQIgH0EHTwRAIAZBB2ohCiAGQQZqIQsgBkEFaiEIIAZBBGohDCAGQQNqIQ8gBkECaiEUIAZBAWohESAOQfj///8HcSESQQAhBwNAIAIgBmpBADoAACACIBFqQQA6AAAgAiAUakEAOgAAIAIgD2pBADoAACACIAxqQQA6AAAgAiAIakEAOgAAIAIgC2pBADoAACACIApqQQA6AAAgAkEIaiECIAdBCGoiByASRw0ACwsgBQRAA0AgAiAGakEAOgAAIAJBAWohAiAEQQFqIgQgBUcNAAsLIA5BB3EhBUEAIQRBACECIB9BB08EQCAGQQdqIQogBkEGaiELIAZBBWohCCAGQQRqIQwgBkEDaiEPIAZBAmohFCAGQQFqIREgDkH4////B3EhEkEAIQcDQCACIAZqQQA6AAAgAiARakEAOgAAIAIgFGpBADoAACACIA9qQQA6AAAgAiAMakEAOgAAIAIgCGpBADoAACACIAtqQQA6AAAgAiAKakEAOgAAIAJBCGohAiAHQQhqIgcgEkcNAAsLIAVFDQADQCACIAZqQQA6AAAgAkEBaiECIARBAWoiBCAFRw0ACwtBACECIAFBADYCAAJAIAEoAiAiDCAOIAwgDkgbIghBAEwNACAIQQNxIQogASgCKCEEIAhBBE8EQCAIQfz///8HcSELQQAhBwNAIAIgBmogAiAEai0AADoAACAGIAJBAXIiBWogBCAFai0AADoAACAGIAJBAnIiBWogBCAFai0AADoAACAGIAJBA3IiBWogBCAFai0AADoAACACQQRqIQIgB0EEaiIHIAtHDQALCyAKRQ0AQQAhBwNAIAIgBmogAiAEai0AADoAACACQQFqIQIgB0EBaiIHIApHDQALCyAMIA5IBEAgBiAIakEBOgAAIAhBAWohCAsCfyAbQQBKBEAgBiAIaiEHIAggDiAIIA5KGyAIayEEQQAhAgNAIA4gAiAERg0CGiACIAdqIAIgCWotAAA6AAAgAkEBaiICIBBHDQALCyAIIBBqCyEEAkAgG0EASgRAIAQgBmohAiAEIA4gBCAOShsgBGshCUEAIQYDQCAGIAlGDQIgAiAGaiAGIBxqLQAAOgAAIAZBAWoiBiAQRw0ACwsgBCAQaiEOCyABIA42AgAgDSABIAFBEGogDSABQRBqEO4DGiANIAFBIGogAUEQaiANIAFBIGoQ7gMaQSAgECAQQSBOGyEnQQEgGCAYQQFMGyIGQfj///8BcSEkIAZBB3EhHSABKAKQAiE0IAEoAowCITUgASgCiAIhNiABKAKEAiE3IAEoAoACITggASgC/AEhOSABKAL4ASE6IAEoAvQBITsgASgC8AEhPCABKALsASE9IAEoAugBIT4gASgC5AEhPyABKALgASFAIAEoAtwBIUEgASgC2AEhQiABKALUASFDIAEoAtABIUQgASgCzAEhRSABKALIASFGIAEoAsQBIUcgASgCwAEhSCABKAK8ASFJIBhBD2pBcHEhSiAbQRlIIR8gAUGwA2ohSwNAIAMhFyADIEprIgkkACANIAFBIGogAUEQaiANIAFBIGoQ7gMaAkAgG0EATCIODQBBACEGQQAhAyAfRQRAIAlBB2ohBCAJQQZqIQcgCUEFaiEFIAlBBGohCiAJQQNqIQsgCUECaiEIIAlBAWohDEEAIQIDQCADIAlqQQA6AAAgAyAMakEAOgAAIAMgCGpBADoAACADIAtqQQA6AAAgAyAKakEAOgAAIAMgBWpBADoAACADIAdqQQA6AAAgAyAEakEAOgAAIANBCGohAyACQQhqIgIgJEcNAAsLIB1FDQADQCADIAlqQQA6AAAgA0EBaiEDIAZBAWoiBiAdRw0ACwsCQCABKAIgIgYgGCAGIBhIGyIFQQBMDQAgBUEDcSELQQAhBCABKAIoIQJBACEDIAVBBE8EQCAFQfz///8HcSEIQQAhBwNAIAMgCWogAiADai0AADoAACAJIANBAXIiCmogAiAKai0AADoAACAJIANBAnIiCmogAiAKai0AADoAACAJIANBA3IiCmogAiAKai0AADoAACADQQRqIQMgB0EEaiIHIAhHDQALCyALRQ0AA0AgAyAJaiACIANqLQAAOgAAIANBAWohAyAEQQFqIgQgC0cNAAsLIAUgEEgEQANAIA0gAUEgaiABQRBqIA0gAUEgahDuAxoCfyABKAIgIgZBAEoEQCAFIAlqIQQgBSAYIAUgGEobIAVrIQJBACEDIAEoAighBwNAIBggAiADRg0CGiADIARqIAMgB2otAAA6AAAgA0EBaiIDIAZHDQALCyAFIAZqCyIFIBBIDQALCyABQgA3A8ADIEv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSgA0EAIQNBACEEQQAhB0EAIQVBACEKQQAhC0EAIQhBACEMQQAhAkEAIRRBACEPQQAhGkEAIRFBACESQQAhE0EAIRZBACEeQQAhFUEAIRxBACEgIA5FBEADQCAUQQh0IAJBFHVyIRQgA0EUdSERIARBFHUhEiAHQRR1IRMgBUEUdSEWIApBFHUhGiALQRR1ISEgCEEUdSEiIAJBCHRBgP7//wBxIAxBFHVyIQIgCSAPai0AACADQQh0QYD+//8AcXIiICEDIBEgBEEIdEGA/v//AHFyIhwhBCASIAdBCHRBgP7//wBxciIVIQcgEyAFQQh0QYD+//8AcXIiHiEFIBYgCkEIdEGA/v//AHFyIhYhCiAaIAtBCHRBgP7//wBxciITIQsgISAIQQh0QYD+//8AcXIiEiEIICIgDEEIdEGA/v//AHFyIhEhDCAPQQFqIg8gJ0cNAAsgASACNgLAAyABIBQ2AsQDIAEgETYCvAMgASASNgK4AyABIBM2ArQDIAEgFjYCsAMgASAeNgKsAyABIBU2AqgDIAEgHDYCpAMgASAgNgKgAyACIRogFCEDCyABIDQ2AoQBIAEgNTYCgAEgASA2NgJ8IAEgNzYCeCABIDg2AnQgASA5NgJwIAEgOjYCbCABIDs2AmggASA8NgJkIAEgPTYCYCABID42AlwgASA/NgJYIAEgQDYCVCABIEE2AlAgASBCNgJMIAEgQzYCSCABIEQ2AkQgASBFNgJAIAEgRjYCPCABIEc2AjggASBINgI0IAEgSTYCMCABIAEoApQCNgKIASABIAH9AAKYAv0LAowBIAEgAf0AAqgC/QsCnAEgASABKQK4AjcCrAEgAUEwaiABQaADahDkCCABQfACaiABQcACaiABQTBqEIAEIAEgASgC8AI2AoAEIAEgAf0AAvQC/QsChAQgASAB/QAChAP9CwKUBCABIAEoApQDNgKkBCABQYAEaiABQeAEahDSCAJAAkACQCAgDQAgHA0AIBUNACAeDQAgFg0AIBMNACASDQAgEQ0AIBoNACADRQ0BC0EPIQICQCADQQ9HDQBB/////wAhAiAaIgNB/////wBHDQAgESIDQf////8ARw0AIBIiA0H/////AEcNACATIgNB/////wBHDQBBrvX6/wAhAiAWIgNBrvX6/wBHDQBB9NW57gAhAiAeIgNB9NW57gBHDQBBv/eAxQAhAiAVIgNBv/eAxQBHDQBBzdGX6QAhAiAcIgNBzdGX6QBHDQBBwYLZASECICAiA0HBgtkBRg0BCyACIANIDQAgASgCgAQiAw0BIAEoAoQEDQEgASgCiAQNASABKAKMBA0BIAEoApAEDQEgASgClAQNASABKAKYBA0BIAEoApwEDQEgASgCoAQNASABKAKkBA0BCyABQQA2AowHIAEgCTYCiAcgASAYNgKEBwJAIA4NAEEAIQJBACEDIB9FBEAgCUEHaiEHIAlBBmohBSAJQQVqIQogCUEEaiELIAlBA2ohCCAJQQJqIQwgCUEBaiEPQQAhBANAIAMgCWpBADoAACADIA9qQQA6AAAgAyAMakEAOgAAIAMgCGpBADoAACADIAtqQQA6AAAgAyAKakEAOgAAIAMgBWpBADoAACADIAdqQQA6AAAgA0EIaiEDIARBCGoiBCAkRw0ACwsgHUUNAANAIAMgCWpBADoAACADQQFqIQMgAkEBaiICIB1HDQALCwJAIAYgGCAGIBhIGyIIQQBMDQAgCEEDcSEKQQAhBCABKAIoIQJBACEDIAhBBE8EQCAIQfz///8HcSELQQAhBwNAIAMgCWogAiADai0AADoAACAJIANBAXIiBWogAiAFai0AADoAACAJIANBAnIiBWogAiAFai0AADoAACAJIANBA3IiBWogAiAFai0AADoAACADQQRqIQMgB0EEaiIHIAtHDQALCyAKRQ0AA0AgAyAJaiACIANqLQAAOgAAIANBAWohAyAEQQFqIgQgCkcNAAsLIAEgBiAYSAR/IAggCWpBADoAACAIQQFqBSAICzYCgAcgDSABQYAHaiABQRBqIA0gAUEQahDuAxogDSABQSBqIAFBEGogDSABQSBqEO4DGiAXIQMMAQsLICUEQCAlIBA2AgAgJSgCCCABQaADahCBBAsgAUGgA2ogAUGgA2ogAUHgBGoQ1gggASAmNgL0BiABICM2AvAGIAEgLDYC7AYgASAtNgLoBiABIC42AuQGIAEgLzYC4AYgASAwNgLcBiABIDE2AtgGIAEgMjYC1AYgASAzNgLQBiABIAM2AqAGIAEgASgChAQ2AqQGIAEgASkDiAQ3A6gGIAEgASgCkAQ2ArAGIAEgASgClAQ2ArQGIAEgAf0AA5gE/QsDuAYgAUHQBmogAUHgBGoQ0gggAUGgBmogAUHgBGoQ0gggAUGAB2ogAUHQBmogAUGgBmoQzQggAUHQA2ogAUGAB2ogAUHgBGoQ0wggASABKALQAyABKAKwBGoiAzYC0AMgASABKALUAyABKAK0BGoiBjYC1AMgASABKALYAyABKAK4BGoiCTYC2AMgASABKALcAyABKAK8BGoiAjYC3AMgASABKALgAyABKALABGoiBDYC4AMgASABKALkAyABKALEBGoiBzYC5AMgASABKALoAyABKALIBGoiBTYC6AMgASABKALsAyABKALMBGoiCjYC7AMgASABKALwAyABKALQBGoiCzYC8AMgASABKAL0AyABKALUBGoiCDYC9AMgASABKAKgAzYC0AYgASABKAKkAzYC1AYgASABKAKoAzYC2AYgASABKAKsAzYC3AYgASABKAKwAzYC4AYgASABKAK0AzYC5AYgASABKAK4AzYC6AYgASABKAK8AzYC7AYgASABKALAAzYC8AYgASABKALEAzYC9AYgASAINgLEBiABIAs2AsAGIAEgCjYCvAYgASAFNgK4BiABIAc2ArQGIAEgBDYCsAYgASACNgKsBiABIAk2AqgGIAEgBjYCpAYgASADNgKgBiABQdAGaiABQeAEahDSCCABQaAGaiABQeAEahDSCCABQYAHaiABQdAGaiABQaAGahDNCCABQdADaiABQYAHaiABQeAEahDTCAJAAkAgASgC0AMNACABKALUAw0AIAEoAtgDDQAgASgC3AMNACABKALgAw0AIAEoAuQDDQAgASgC6AMNACABKALsAw0AIAEoAvADDQAgASgC9ANFDQELICtBIDYCACAqQSA2AgAgKigCCCABQYAEahCBBCArKAIIIAFB0ANqEIEECyABQdAHaiQAQQAhA0EBIRcMAQtBo7sqIQMLICkQmgEgKBCaASAXBEAgGUH65yk2AgAgAEHghyogGRCbASAZQTBqJABBAg8LIBkgAzYCFCAZQfrnKTYCECAAQfyIKiAZQRBqEGwAC4w7AUt/IwBBMGsiFyQAIBdB070rNgIgIABB+YYqIBdBIGoQmwEgAEEBEMgBISgCf0HKnysgAEECEMgBIiVFDQAaIBdBADYCLAJAAn8gACgCFCgCAEEYaiINIAAoAgxPBEAgACgCEEEsaiENCyANLQAEQQNGBEAgDSgCAAwBCyANIBdBLGpBABD8AUUNASAXKAIsCyENQYfmKiANICUoAgBHDQEaIABBAEECEKEBQcWiKiAAIA0QhgEiKUUNARogACAAKAIMQRBrQf+iKhBZQaaEKiAAIA0QhgEiKkUNARogACAAKAIMQRBrQZKMKhBZICghGCAlIRMgF0EoaiErIwBBwAZrIgMkACADIgFC/sz5zfAANwNQIAFC4sDW4qD38s4PNwNIIAFCm4Wc2ICOuq4JNwNAIAFC2bKj8cDb7OYPNwM4IAFCmK/gt5C2hZQPNwMwIAFC97TrwcAANwOQBiABQvvJ9qrgiI+1AjcDiAYgAUKX+qPFgKK44A83A4AGIAFCnLPQqoDNoqILNwP4BSABQripw9jwn8K+BDcD8AUgAUG8AWogAUEwaiABQfAFahDeCBogAUL/////8AE3A4AFIAFC//////D///8PNwP4BCABQq71+v/w////DzcD8AQgAUK/94DFwN6a5w03A+gEIAFCwYLZgdCZ+pINNwPgBCABIAFB4ARqEMwIIhtBB2pBCG0iEEEPakFwcSIGayIJIgMkACADIA1BD2pBcHEiAmsiFCIDJAAgAyACayIWIgMkACADIAZrIhwiAyQAIAMgDSAQQQF0IhlqIh9BEGpBcHFrIgYiAyQAAkAgG0EATA0AQQEgECAQQQFMGyIHQQdxIQVBACECIBtBOU4EQCAJQQdqIQogCUEGaiELIAlBBWohCCAJQQRqIQwgCUEDaiEPIAlBAmohESAJQQFqIRIgB0H4////AHEhFUEAIQcDQCACIAlqQQA6AAAgAiASakEAOgAAIAIgEWpBADoAACACIA9qQQA6AAAgAiAMakEAOgAAIAIgCGpBADoAACACIAtqQQA6AAAgAiAKakEAOgAAIAJBCGohAiAHQQhqIgcgFUcNAAsLIAVFDQADQCACIAlqQQA6AAAgAkEBaiECIARBAWoiBCAFRw0ACwsCQAJAIBgoAgAiDyAQIA8gEEgbIgxBAEoEQCAMQQNxIQsgGCgCCCEEQQAhB0EAIQIgDEEETwRAIAxB/P///wdxIQhBACEFA0AgAiAJaiACIARqLQAAOgAAIAkgAkEBciIKaiAEIApqLQAAOgAAIAkgAkECciIKaiAEIApqLQAAOgAAIAkgAkEDciIKaiAEIApqLQAAOgAAIAJBBGohAiAFQQRqIgUgCEcNAAsLIAsEQANAIAIgCWogAiAEai0AADoAACACQQFqIQIgB0EBaiIHIAtHDQALCyAPIBBODQIgECAMayECIAxBAEwNASAQIQQDQCAJIARBAWsiBGogCSAEIAJrai0AADoAACACIARIDQALDAELIA8gEE4NASAQIAxrIQILIAJBAEwNACACQQNxIgcEQEEAIQQDQCAJIAJBAWsiAmpBADoAACAEQQFqIgQgB0cNAAsLIAwgEGtBfEsNACAJQQJrIQUgCUEBayEKA0AgAiAKakEAOgAAIAIgBWpBADoAACAJIAJBBGsiBGpBADsAACACQQNrIQcgBCECIAdBAUsNAAsLIB9BAWohDkEAIQJBACEEQQAhB0EAIQVBACEKQQAhC0EAIQhBACEMQQAhDwNAICZBCHQgI0EUdnIhJiAjQQh0QYD+//8AcSAEQRR2ciEjIARBCHRBgP7//wBxIAdBFHZyIiwhBCAHQQh0QYD+//8AcSAFQRR2ciItIQcgBUEIdEGA/v//AHEgCkEUdnIiLiEFIApBCHRBgP7//wBxIAtBFHZyIi8hCiALQQh0QYD+//8AcSAIQRR2ciIwIQsgCEEIdEGA/v//AHEgDEEUdnIiMSEIIAxBCHRBgP7//wBxIA9BFHZyIjIhDCACIAlqLQAAIA9BCHRBgP7//wBxciIzIQ8gAkEBaiICQSBHDQALIBMoAgghICATKAIAIRogAUIANwPQBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLAEAkAgGkEASgRAQSAgGiAaQSBOGyEnQQAhBEEAIQdBACEFQQAhCkEAIQtBACEIQQAhDEEAIQ9BACECQQAhEkEAIREDQCASQQh0IAJBFHVyIRIgBEEUdSEVIAdBFHUhEyAFQRR1IRggCkEUdSEhIAtBFHUhIiAIQRR1IR0gDEEUdSEeIAJBCHRBgP7//wBxIA9BFHVyIQIgESAgai0AACAEQQh0QYD+//8AcXIiJCEEIBUgB0EIdEGA/v//AHFyIhUhByATIAVBCHRBgP7//wBxciITIQUgGCAKQQh0QYD+//8AcXIiGCEKICEgC0EIdEGA/v//AHFyIiEhCyAiIAhBCHRBgP7//wBxciIiIQggHSAMQQh0QYD+//8AcXIiHSEMIB4gD0EIdEGA/v//AHFyIh4hDyARQQFqIhEgJ0cNAAsgASACNgLQBCABIBI2AtQEIAEgHjYCzAQgASAdNgLIBCABICI2AsQEIAEgITYCwAQgASAYNgK8BCABIBM2ArgEIAEgFTYCtAQgASAkNgKwBEEAIQQgAUEANgIsIAEgFDYCKCABQQA2AiAgASANNgIkIA1BACANQQBKGyECA0AgAiAERg0CIAQgFGpBAToAACAEQQFqIgQgGkcNAAsMAQtBACEEIAFBADYCLCABIBQ2AiggASANNgIkCyABIAQ2AiAgAUEANgIcIAEgFjYCGCABIA02AhQgAUEANgIQAkAgGkEATA0AIA0gGkgNACAaQQdxIQpBACEHQQAhAiAaQQFrQQdPBEAgFkEHaiELIBZBBmohCCAWQQVqIQwgFkEEaiEPIBZBA2ohESAWQQJqIRIgFkEBaiEVIBpB+P///wdxIRNBACEFA0AgAiAWakEAOgAAIAIgFWpBADoAACACIBJqQQA6AAAgAiARakEAOgAAIAIgD2pBADoAACACIAxqQQA6AAAgAiAIakEAOgAAIAIgC2pBADoAACACQQhqIQIgBUEIaiIFIBNHDQALCyAKBEADQCACIBZqQQA6AAAgAkEBaiECIAdBAWoiByAKRw0ACwsgASAaNgIQCyAcIAFBsARqEIEEIAFBADYCDCABIAY2AgggASAONgIEAkAgDkEATA0AIA5BB3EhCkEAIQdBACECIB9BB08EQCAGQQdqIQsgBkEGaiEIIAZBBWohDCAGQQRqIQ8gBkEDaiERIAZBAmohEiAGQQFqIRUgDkH4////B3EhE0EAIQUDQCACIAZqQQA6AAAgAiAVakEAOgAAIAIgEmpBADoAACACIBFqQQA6AAAgAiAPakEAOgAAIAIgDGpBADoAACACIAhqQQA6AAAgAiALakEAOgAAIAJBCGohAiAFQQhqIgUgE0cNAAsLIApFDQADQCACIAZqQQA6AAAgAkEBaiECIAdBAWoiByAKRw0ACwtBACECIAFBADYCAAJAIAQgDiAEIA5IGyIIQQBMDQAgCEEDcSEKIAhBBE8EQCAIQfz///8HcSELQQAhBwNAIAIgBmogAiAUai0AADoAACAGIAJBAXIiBWogBSAUai0AADoAACAGIAJBAnIiBWogBSAUai0AADoAACAGIAJBA3IiBWogBSAUai0AADoAACACQQRqIQIgB0EEaiIHIAtHDQALCyAKRQ0AQQAhBwNAIAIgBmogAiAUai0AADoAACACQQFqIQIgB0EBaiIHIApHDQALCyAEIA5IBEAgBiAIakEAOgAAIAhBAWohCAsCfyAbQQBKBEAgBiAIaiEHIAggDiAIIA5KGyAIayEEQQAhAgNAIA4gAiAERg0CGiACIAdqIAIgCWotAAA6AAAgAkEBaiICIBBHDQALCyAIIBBqCyEFIAECfyAbQQBKBEAgBSAGaiEHIAUgDiAFIA5KGyAFayEEQQAhAgNAIA4gAiAERg0CGiACIAdqIAIgHGotAAA6AAAgAkEBaiICIBBHDQALCyAFIBBqCzYCACANIAEgAUEQaiANIAFBEGoQ7gMaIA0gAUEgaiABQRBqIA0gAUEgahDuAxoCQCAOQQBMDQAgDkEHcSEFQQAhBEEAIQIgH0EHTwRAIAZBB2ohCiAGQQZqIQsgBkEFaiEIIAZBBGohDCAGQQNqIQ8gBkECaiEUIAZBAWohESAOQfj///8HcSESQQAhBwNAIAIgBmpBADoAACACIBFqQQA6AAAgAiAUakEAOgAAIAIgD2pBADoAACACIAxqQQA6AAAgAiAIakEAOgAAIAIgC2pBADoAACACIApqQQA6AAAgAkEIaiECIAdBCGoiByASRw0ACwsgBQRAA0AgAiAGakEAOgAAIAJBAWohAiAEQQFqIgQgBUcNAAsLIA5BB3EhBUEAIQRBACECIB9BB08EQCAGQQdqIQogBkEGaiELIAZBBWohCCAGQQRqIQwgBkEDaiEPIAZBAmohFCAGQQFqIREgDkH4////B3EhEkEAIQcDQCACIAZqQQA6AAAgAiARakEAOgAAIAIgFGpBADoAACACIA9qQQA6AAAgAiAMakEAOgAAIAIgCGpBADoAACACIAtqQQA6AAAgAiAKakEAOgAAIAJBCGohAiAHQQhqIgcgEkcNAAsLIAVFDQADQCACIAZqQQA6AAAgAkEBaiECIARBAWoiBCAFRw0ACwtBACECIAFBADYCAAJAIAEoAiAiDCAOIAwgDkgbIghBAEwNACAIQQNxIQogASgCKCEEIAhBBE8EQCAIQfz///8HcSELQQAhBwNAIAIgBmogAiAEai0AADoAACAGIAJBAXIiBWogBCAFai0AADoAACAGIAJBAnIiBWogBCAFai0AADoAACAGIAJBA3IiBWogBCAFai0AADoAACACQQRqIQIgB0EEaiIHIAtHDQALCyAKRQ0AQQAhBwNAIAIgBmogAiAEai0AADoAACACQQFqIQIgB0EBaiIHIApHDQALCyAMIA5IBEAgBiAIakEBOgAAIAhBAWohCAsCfyAbQQBKBEAgBiAIaiEHIAggDiAIIA5KGyAIayEEQQAhAgNAIA4gAiAERg0CGiACIAdqIAIgCWotAAA6AAAgAkEBaiICIBBHDQALCyAIIBBqCyEEAkAgG0EASgRAIAQgBmohAiAEIA4gBCAOShsgBGshCUEAIQYDQCAGIAlGDQIgAiAGaiAGIBxqLQAAOgAAIAZBAWoiBiAQRw0ACwsgBCAQaiEOCyABIA42AgAgDSABIAFBEGogDSABQRBqEO4DGiANIAFBIGogAUEQaiANIAFBIGoQ7gMaQSAgECAQQSBOGyEnQQEgGSAZQQFMGyIGQfj///8BcSEkIAZBB3EhHSABKAKQAiE0IAEoAowCITUgASgCiAIhNiABKAKEAiE3IAEoAoACITggASgC/AEhOSABKAL4ASE6IAEoAvQBITsgASgC8AEhPCABKALsASE9IAEoAugBIT4gASgC5AEhPyABKALgASFAIAEoAtwBIUEgASgC2AEhQiABKALUASFDIAEoAtABIUQgASgCzAEhRSABKALIASFGIAEoAsQBIUcgASgCwAEhSCABKAK8ASFJIBlBD2pBcHEhSiAbQRlIIR8gAUGwA2ohSwNAIAMhGiADIEprIgkkACANIAFBIGogAUEQaiANIAFBIGoQ7gMaAkAgG0EATCIODQBBACEGQQAhAyAfRQRAIAlBB2ohBCAJQQZqIQcgCUEFaiEFIAlBBGohCiAJQQNqIQsgCUECaiEIIAlBAWohDEEAIQIDQCADIAlqQQA6AAAgAyAMakEAOgAAIAMgCGpBADoAACADIAtqQQA6AAAgAyAKakEAOgAAIAMgBWpBADoAACADIAdqQQA6AAAgAyAEakEAOgAAIANBCGohAyACQQhqIgIgJEcNAAsLIB1FDQADQCADIAlqQQA6AAAgA0EBaiEDIAZBAWoiBiAdRw0ACwsCQCABKAIgIgYgGSAGIBlIGyIFQQBMDQAgBUEDcSELQQAhBCABKAIoIQJBACEDIAVBBE8EQCAFQfz///8HcSEIQQAhBwNAIAMgCWogAiADai0AADoAACAJIANBAXIiCmogAiAKai0AADoAACAJIANBAnIiCmogAiAKai0AADoAACAJIANBA3IiCmogAiAKai0AADoAACADQQRqIQMgB0EEaiIHIAhHDQALCyALRQ0AA0AgAyAJaiACIANqLQAAOgAAIANBAWohAyAEQQFqIgQgC0cNAAsLIAUgEEgEQANAIA0gAUEgaiABQRBqIA0gAUEgahDuAxoCfyABKAIgIgZBAEoEQCAFIAlqIQQgBSAZIAUgGUobIAVrIQJBACEDIAEoAighBwNAIBkgAiADRg0CGiADIARqIAMgB2otAAA6AAAgA0EBaiIDIAZHDQALCyAFIAZqCyIFIBBIDQALCyABQgA3A8ADIEv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSgA0EAIQNBACEEQQAhB0EAIQVBACEKQQAhC0EAIQhBACEMQQAhAkEAIRRBACEPQQAhGEEAIRFBACESQQAhFUEAIRNBACEeQQAhFkEAIRxBACEgIA5FBEADQCAUQQh0IAJBFHVyIRQgA0EUdSERIARBFHUhEiAHQRR1IRUgBUEUdSETIApBFHUhGCALQRR1ISEgCEEUdSEiIAJBCHRBgP7//wBxIAxBFHVyIQIgCSAPai0AACADQQh0QYD+//8AcXIiICEDIBEgBEEIdEGA/v//AHFyIhwhBCASIAdBCHRBgP7//wBxciIWIQcgFSAFQQh0QYD+//8AcXIiHiEFIBMgCkEIdEGA/v//AHFyIhMhCiAYIAtBCHRBgP7//wBxciIVIQsgISAIQQh0QYD+//8AcXIiEiEIICIgDEEIdEGA/v//AHFyIhEhDCAPQQFqIg8gJ0cNAAsgASACNgLAAyABIBQ2AsQDIAEgETYCvAMgASASNgK4AyABIBU2ArQDIAEgEzYCsAMgASAeNgKsAyABIBY2AqgDIAEgHDYCpAMgASAgNgKgAyACIRggFCEDCyABIDQ2AoQBIAEgNTYCgAEgASA2NgJ8IAEgNzYCeCABIDg2AnQgASA5NgJwIAEgOjYCbCABIDs2AmggASA8NgJkIAEgPTYCYCABID42AlwgASA/NgJYIAEgQDYCVCABIEE2AlAgASBCNgJMIAEgQzYCSCABIEQ2AkQgASBFNgJAIAEgRjYCPCABIEc2AjggASBINgI0IAEgSTYCMCABIAEoApQCNgKIASABIAH9AAKYAv0LAowBIAEgAf0AAqgC/QsCnAEgASABKQK4AjcCrAEgAUEwaiABQaADahDkCCABQfACaiABQcACaiABQTBqEIAEIAEgASgC8AI2AoAEIAEgAf0AAvQC/QsChAQgASAB/QAChAP9CwKUBCABIAEoApQDNgKkBCABQYAEaiABQeAEahDSCAJAAkACQCAgDQAgHA0AIBYNACAeDQAgEw0AIBUNACASDQAgEQ0AIBgNACADRQ0BC0EPIQICQCADQQ9HDQBB/////wAhAiAYIgNB/////wBHDQAgESIDQf////8ARw0AIBIiA0H/////AEcNACAVIgNB/////wBHDQBBrvX6/wAhAiATIgNBrvX6/wBHDQBB9NW57gAhAiAeIgNB9NW57gBHDQBBv/eAxQAhAiAWIgNBv/eAxQBHDQBBzdGX6QAhAiAcIgNBzdGX6QBHDQBBwYLZASECICAiA0HBgtkBRg0BCyACIANIDQAgASgChAQhAyABKAKABCIEBEAgASgCiAQhAgwCCyABKAKIBCECIAMNASACDQEgASgCjAQNASABKAKQBA0BIAEoApQEDQEgASgCmAQNASABKAKcBA0BIAEoAqAEDQEgASgCpAQNAQsgAUEANgL8BSABIAk2AvgFIAEgGTYC9AUCQCAODQBBACECQQAhAyAfRQRAIAlBB2ohByAJQQZqIQUgCUEFaiEKIAlBBGohCyAJQQNqIQggCUECaiEMIAlBAWohD0EAIQQDQCADIAlqQQA6AAAgAyAPakEAOgAAIAMgDGpBADoAACADIAhqQQA6AAAgAyALakEAOgAAIAMgCmpBADoAACADIAVqQQA6AAAgAyAHakEAOgAAIANBCGohAyAEQQhqIgQgJEcNAAsLIB1FDQADQCADIAlqQQA6AAAgA0EBaiEDIAJBAWoiAiAdRw0ACwsCQCAGIBkgBiAZSBsiCEEATA0AIAhBA3EhCkEAIQQgASgCKCECQQAhAyAIQQRPBEAgCEH8////B3EhC0EAIQcDQCADIAlqIAIgA2otAAA6AAAgCSADQQFyIgVqIAIgBWotAAA6AAAgCSADQQJyIgVqIAIgBWotAAA6AAAgCSADQQNyIgVqIAIgBWotAAA6AAAgA0EEaiEDIAdBBGoiByALRw0ACwsgCkUNAANAIAMgCWogAiADai0AADoAACADQQFqIQMgBEEBaiIEIApHDQALCyABIAYgGUgEfyAIIAlqQQA6AAAgCEEBagUgCAs2AvAFIA0gAUHwBWogAUEQaiANIAFBEGoQ7gMaIA0gAUEgaiABQRBqIA0gAUEgahDuAxogGiEDDAELCyABQaADaiABQaADaiABQeAEahDWCCABICY2AuQFIAEgIzYC4AUgASAsNgLcBSABIC02AtgFIAEgLjYC1AUgASAvNgLQBSABIDA2AswFIAEgMTYCyAUgASAyNgLEBSABIDM2AsAFIAEgAjYCmAUgASADNgKUBSABIAQ2ApAFIAEgASkCjAQ3ApwFIAEgASgClAQ2AqQFIAEgAf0AA5gE/QsDqAUgAUHABWogAUHgBGoQ0gggAUGQBWogAUHgBGoQ0gggAUHwBWogAUHABWogAUGQBWoQzQggAUHQA2ogAUHwBWogAUHgBGoQ0wggASABKALQAyABKAKwBGoiAzYC0AMgASABKALUAyABKAK0BGoiBjYC1AMgASABKALYAyABKAK4BGoiCTYC2AMgASABKALcAyABKAK8BGoiAjYC3AMgASABKALgAyABKALABGoiBDYC4AMgASABKALkAyABKALEBGoiBzYC5AMgASABKALoAyABKALIBGoiBTYC6AMgASABKALsAyABKALMBGoiCjYC7AMgASABKALwAyABKALQBGoiCzYC8AMgASABKAL0AyABKALUBGoiCDYC9AMgASABKAKgAzYCwAUgASABKAKkAzYCxAUgASABKAKoAzYCyAUgASABKAKsAzYCzAUgASABKAKwAzYC0AUgASABKAK0AzYC1AUgASABKAK4AzYC2AUgASABKAK8AzYC3AUgASABKALAAzYC4AUgASABKALEAzYC5AUgASAINgK0BSABIAs2ArAFIAEgCjYCrAUgASAFNgKoBSABIAc2AqQFIAEgBDYCoAUgASACNgKcBSABIAk2ApgFIAEgBjYClAUgASADNgKQBSABQcAFaiABQeAEahDSCCABQZAFaiABQeAEahDSCCABQfAFaiABQcAFaiABQZAFahDNCCABQdADaiABQfAFaiABQeAEahDTCAJAAkAgASgC0AMNACABKALUAw0AIAEoAtgDDQAgASgC3AMNACABKALgAw0AIAEoAuQDDQAgASgC6AMNACABKALsAw0AIAEoAvADDQAgASgC9ANFDQELICsEQCArIAEoAsACQQJvNgIACyAqQSA2AgAgKUEgNgIAICkoAgggAUGABGoQgQQgKigCCCABQdADahCBBAsgAUHABmokAEEBIQMgACgCDEERQQEgFygCKBs6AAQgACAAKAIMQQhqNgIMQQAMAQtB8roqCyENICUQmgEgKBCaASADBEAgF0HTvSs2AgAgAEHghyogFxCbASAXQTBqJABBAg8LIBcgDTYCFCAXQdO9KzYCECAAQfyIKiAXQRBqEGwAC6gDAQh/IwBBMGsiASQAIAFB5ucpNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIQYgAEECEMgBIQcCQAJAAkAgACgCFCgCAEEYaiIDIAAoAgxPBH8gACgCEEEsagUgAwstAARBD3FBBUcEQEHKlyshAgwBCyAAQQNB/6IqEJABGiAAQQNBkowqEJABGiAAQX4QyAEiA0UEQEGmoiohAgwBCyAAQX8QyAEiBUUEQEHDhCohAgwCCyABQQA2AiwCQAJ/IAAoAhQoAgBBIGoiAiAAKAIMTwRAIAAoAhBBLGohAgsgAi0ABEEDRgRAIAIoAgAMAQsgAiABQSxqQQAQ/AFFDQEgASgCLAshBEEAIQIgBCAGIAcgAyAFEJMEIQhBASEEIAAoAgxBAUERIAhBAEgbOgAEIAAgACgCDEEIajYCDAwDC0GjuyohAgwCC0EAIQMLQQAhBQsgBRCaASADEJoBIAcQmgEgBhCaASAEBEAgAUHm5yk2AgAgAEHghyogARCbASABQTBqJABBAQ8LIAEgAjYCFCABQebnKTYCECAAQfyIKiABQRBqEGwAC70EAQh/IwBBMGsiAiQAIAJB7L0rNgIgIABB+YYqIAJBIGoQmwEgAEEBEMgBIQYgAEECEMgBIQcgAkEANgIsIAAoAhQoAgAiAUEYaiIDIAAoAgwiBU8EQCAAKAIQQSxqIQMLIAMtAARBA0cEfyADIAJBLGpBABD8ARogACgCDCEFIAJBLGohAyAAKAIUKAIABSABC0EgaiIEIAVPBEAgACgCEEEsaiEECyADKAIAIQECQAJAAkAgBC0ABEEPcUUEQEEAIQMgAEEAQQIQoQEgACABEIYBIgRFBEBBxaIqIQFBACEEDAQLIAAgACgCDEEQa0H/oioQWSAAIAEQhgEiBUUEQEGmhCohAQwDCyAAIAAoAgxBEGtBkowqEFlBkJY0KAIAKAIkQQAgBiAHIAQgBSACQShqEJgEDAELIABBBBDIASIDRQRAQdGzKSEBDAILQQAhBCAAQQBBAhChASAAIAEQhgEiBUUEQEHFoiohAQwDCyAAIAAoAgxBEGtB/6IqEFkgACABEIYBIghFBEBBpoQqIQEMAwsgACAAKAIMQRBrQZKMKhBZQQAgAyAGIAcgBSAIIAJBKGoQmAQLQQEhBCAAKAIMQRFBASACKAIoGzoABCAAIAAoAgxBCGo2AgxBACEBDAELQQAhA0EAIQQLIAMQmgEgBxCaASAGEJoBIARFBEAgAiABNgIUIAJB7L0rNgIQIABB/IgqIAJBEGoQbAALIAJB7L0rNgIAIABB4IcqIAIQmwEgAkEwaiQAQQILzx4BHn8jAEGQBmsiByQAIAdC/sz5zfAANwMgIAdC4sDW4qD38s4PNwMYIAdCm4Wc2ICOuq4JNwMQIAdC2bKj8cDb7OYPNwMIIAdCmK/gt5C2hZQPNwMAIAdC97TrwcAANwPgBSAHQvvJ9qrgiI+1AjcD2AUgB0KX+qPFgKK44A83A9AFIAdCnLPQqoDNoqILNwPIBSAHQripw9jwn8K+BDcDwAUgB0GMAWogByAHQcAFahDeCBogB0L/////8AE3A9AEIAdC//////D///8PNwPIBCAHQq71+v/w////DzcDwAQgB0K/94DFwN6a5w03A7gEIAdCwYLZgdCZ+pINNwOwBCACKAIIIRFBACECA0AgGkEIdCACQRR2ciEaIAJBCHRBgP7//wBxIAlBFHZyIQIgCUEIdEGA/v//AHEgCEEUdnIiHCEJIAhBCHRBgP7//wBxIApBFHZyIh0hCCAKQQh0QYD+//8AcSALQRR2ciIeIQogC0EIdEGA/v//AHEgDEEUdnIiHyELIAxBCHRBgP7//wBxIA1BFHZyIiAhDCANQQh0QYD+//8AcSAOQRR2ciIhIQ0gDkEIdEGA/v//AHEgD0EUdnIiIiEOIBAgEWotAAAgD0EIdEGA/v//AHFyIiMhDyAQQQFqIhBBIEcNAAtBACEJAkAgAygCACIQQQBMBEBBACEQQQAhAwwBC0EgIBAgEEEgThshEiADKAIIIRtBACEIQQAhCkEAIQtBACEMQQAhDUEAIQ5BACEPQQAhEEEAIQNBACERA0AgA0EIdCAQQRR1ciEDIAlBFHUhEyAIQRR1IRQgCkEUdSEVIAtBFHUhFiAMQRR1IRcgDUEUdSEYIA5BFHUhGSAQQQh0QYD+//8AcSAPQRR1ciEQIBEgG2otAAAgCUEIdEGA/v//AHFyIiQhCSATIAhBCHRBgP7//wBxciITIQggFCAKQQh0QYD+//8AcXIiFCEKIBUgC0EIdEGA/v//AHFyIhUhCyAWIAxBCHRBgP7//wBxciIWIQwgFyANQQh0QYD+//8AcXIiFyENIBggDkEIdEGA/v//AHFyIhghDiAZIA9BCHRBgP7//wBxciIZIQ8gEUEBaiIRIBJHDQALCwJAAkAgAARAA0AgB0GgA2ogB0GwBGogABDUCCAHQZACaiAHQbAEaiAAENQIIAcgBygCjAE2AgAgByAH/QACkAH9CwIEIAcgB/0AAqAB/QsCFCAHIAf9AAKwAf0LAiQgByAH/QACwAH9CwI0IAcgB/0AAtAB/QsCRCAHIAf9AALgAf0LAlQgByAHKQLwATcCZCAHIAcoAvgBNgJsIAcgBygC/AE2AnAgByAH/QACgAL9CwJ0IAcgB0GgA2oQ5AggB0HwAmogB0HAAmogBxCABCAHIAcoAvACNgKABCAHIAf9AAL0Av0LAoQEIAcgB/0AAoQD/QsClAQgByAHKAKUAzYCpAQgB0GABGogB0GwBGoQ0gggBygChAQhCQJAAkAgBygCgAQiCgRAIAcoAogEIQgMAQsgCSAHKAKIBCIIcg0AQQAhCCAHKAKMBA0AIAcoApAEDQAgBygClAQNACAHKAKYBA0AIAcoApwEDQAgBygCoAQNACAHKAKkBEUNAQsgByAH/QAEoAP9CwSQBSAHIAf9AASwA/0LBKAFIAcgBykDwAM3A7AFIAcgB/0ABJAC/QsE4AQgByAH/QAEoAL9CwTwBCAHIAcpA7ACNwOABSAHQZAFaiAHQbAEahDSCCAHQeAEaiAHQbAEahDSCCAHQcAFaiAHQZAFaiAHQeAEahDNCCAHQaADaiAHQcAFaiAHQbAEahDTCCAHQaADaiAHQaADaiAHQbAEahDWCCAHIBo2ArQFIAcgAjYCsAUgByAcNgKsBSAHIB02AqgFIAcgHjYCpAUgByAfNgKgBSAHICA2ApwFIAcgITYCmAUgByAiNgKUBSAHICM2ApAFIAcgCDYC6AQgByAJNgLkBCAHIAo2AuAEIAcgBykCjAQ3AuwEIAcgBygClAQ2AvQEIAcgB/0AA5gE/QsD+AQgB0GQBWogB0GwBGoQ0gggB0HgBGogB0GwBGoQ0gggB0HABWogB0GQBWogB0HgBGoQzQggB0HQA2ogB0HABWogB0GwBGoQ0wggByAHKALQAyAkaiIJNgLQAyAHIAcoAtQDIBNqIgg2AtQDIAcgBygC2AMgFGoiCjYC2AMgByAHKALcAyAVaiILNgLcAyAHIAcoAuADIBZqIgw2AuADIAcgBygC5AMgF2oiDTYC5AMgByAHKALoAyAYaiIONgLoAyAHIAcoAuwDIBlqIg82AuwDIAcgBygC8AMgEGoiETYC8AMgByAHKAL0AyADaiISNgL0AyAHIBI2ArQFIAcgETYCsAUgByAPNgKsBSAHIA42AqgFIAcgDTYCpAUgByAMNgKgBSAHIAs2ApwFIAcgCjYCmAUgByAINgKUBSAHIAk2ApAFIAcgBygCkAI2AuAEIAcgBygClAI2AuQEIAcgBygCmAI2AugEIAcgBygCnAI2AuwEIAcgBygCoAI2AvAEIAcgBygCpAI2AvQEIAcgBygCqAI2AvgEIAcgBygCrAI2AvwEIAcgBygCsAI2AoAFIAcgBygCtAI2AoQFIAdBkAVqIAdBsARqENIIIAdB4ARqIAdBsARqENIIIAdBwAVqIAdBkAVqIAdB4ARqEM0IIAdB0ANqIAdBwAVqIAdBsARqENMIIAcgBygCoAM2ApAFIAcgBykCpAM3ApQFIAcgB/0AAqwD/QsCnAUgByAHKQK8AzcCrAUgByAHKALEAzYCtAUgByAHKALQAzYC4AQgByAHKALUAzYC5AQgByAHKALYAzYC6AQgByAHKALcAzYC7AQgByAHKALgAzYC8AQgByAHKALkAzYC9AQgByAHKALoAzYC+AQgByAHKALsAzYC/AQgByAHKALwAzYCgAUgByAHKAL0AzYChAUgB0GQBWogB0GwBGoQ0gggB0HgBGogB0GwBGoQ0gggB0HABWogB0GQBWogB0HgBGoQzQggB0HQA2ogB0HABWogB0GwBGoQ0wgLIAcoAtADDQIgBygC1AMNAiAHKALYAw0CIAcoAtwDDQIgBygC4AMNAiAHKALkAw0CIAcoAugDDQIgBygC7AMNAiAHKALwAw0CIAcoAvQDRQ0ACwwBCyABKAIIIRtBACEIQQAhEkEAIQlBACEKQQAhC0EAIQxBACENQQAhDkEAIQ9BACERQQAhAANAIBJBCHQgCUEUdnIhEiAJQQh0QYD+//8AcSAKQRR2ciEJIApBCHRBgP7//wBxIAtBFHZyIgEhCiALQQh0QYD+//8AcSAMQRR2ciELIAxBCHRBgP7//wBxIA1BFHZyIQwgDUEIdEGA/v//AHEgDkEUdnIhDSAOQQh0QYD+//8AcSAPQRR2ciEOIA9BCHRBgP7//wBxIBFBFHZyIQ8gEUEIdEGA/v//AHEgAEEUdnIhESAIIBtqLQAAIABBCHRBgP7//wBxciEAIAhBAWoiCEEgRw0ACyAHIAk2AsADIAcgEjYCxAMgByABNgK8AyAHIAs2ArgDIAcgDDYCtAMgByANNgKwAyAHIA42AqwDIAcgDzYCqAMgByARNgKkAyAHIAA2AqADIAdBoANqIAdBsARqENIIIAcgBygCjAE2AgAgByAH/QACkAH9CwIEIAcgB/0AAqAB/QsCFCAHIAf9AAKwAf0LAiQgByAH/QACwAH9CwI0IAcgB/0AAtAB/QsCRCAHIAf9AALgAf0LAlQgByAHKQLwATcCZCAHIAcoAvgBNgJsIAcgBygC/AE2AnAgByAH/QACgAL9CwJ0IAcgB0GgA2oQ5AggB0HwAmogB0HAAmogBxCABCAHIAcoAvACNgKABCAHIAf9AAL0Av0LAoQEIAcgB/0AAoQD/QsClAQgByAHKAKUAzYCpAQgB0GABGogB0GwBGoQ0gggBygChAQhCQJAAkAgBygCgAQiCgRAIAcoAogEIQgMAQsgCSAHKAKIBCIIcg0AQQAhCCAHKAKMBA0AIAcoApAEDQAgBygClAQNACAHKAKYBA0AIAcoApwEDQAgBygCoAQNACAHKAKkBEUNAQsgB0GgA2ogB0GgA2ogB0GwBGoQ1gggByAaNgK0BSAHIAI2ArAFIAcgHDYCrAUgByAdNgKoBSAHIB42AqQFIAcgHzYCoAUgByAgNgKcBSAHICE2ApgFIAcgIjYClAUgByAjNgKQBSAHIAg2AugEIAcgCTYC5AQgByAKNgLgBCAHIAcpAowENwLsBCAHIAcoApQENgL0BCAHIAf9AAOYBP0LA/gEIAdBkAVqIAdBsARqENIIIAdB4ARqIAdBsARqENIIIAdBwAVqIAdBkAVqIAdB4ARqEM0IIAdB0ANqIAdBwAVqIAdBsARqENMIIAcgBygC0AMgJGoiAjYC0AMgByAHKALUAyATaiIJNgLUAyAHIAcoAtgDIBRqIgg2AtgDIAcgBygC3AMgFWoiCjYC3AMgByAHKALgAyAWaiILNgLgAyAHIAcoAuQDIBdqIgw2AuQDIAcgBygC6AMgGGoiDTYC6AMgByAHKALsAyAZaiIONgLsAyAHIAcoAvADIBBqIhA2AvADIAcgBygC9AMgA2oiDzYC9AMgByAHKAKgAzYCkAUgByAHKAKkAzYClAUgByAHKAKoAzYCmAUgByAHKAKsAzYCnAUgByAHKAKwAzYCoAUgByAHKAK0AzYCpAUgByAHKAK4AzYCqAUgByAHKAK8AzYCrAUgByAHKALAAzYCsAUgByAHKALEAzYCtAUgByAPNgKEBSAHIBA2AoAFIAcgDjYC/AQgByANNgL4BCAHIAw2AvQEIAcgCzYC8AQgByAKNgLsBCAHIAg2AugEIAcgCTYC5AQgByACNgLgBCAHQZAFaiAHQbAEahDSCCAHQeAEaiAHQbAEahDSCCAHQcAFaiAHQZAFaiAHQeAEahDNCCAHQdADaiAHQcAFaiAHQbAEahDTCCAHKALQAw0BIAcoAtQDDQEgBygC2AMNASAHKALcAw0BIAcoAuADDQEgBygC5AMNASAHKALoAw0BIAcoAuwDDQEgBygC8AMNASAHKAL0Aw0BCwwBCyAGBEAgBiAHKALAAkECbzYCAAsgBUEgNgIAIARBIDYCACAEKAIIIAdBgARqEIEEIAUoAgggB0HQA2oQgQQLIAdBkAZqJAALqxYBMH8jAEEwayIKJAAgCkG8vSs2AiAgAEH5hiogCkEgahCbASAAQQEQyAEhLyAAQQIQyAEhLAJAAkACQCAAKAIUKAIAQRhqIhsgACgCDE8EfyAAKAIQQSxqBSAbCy0ABEEPcUEFRwRAQcqXKyEIDAELIABBA0H/oioQkAEaIABBA0GSjCoQkAEaIABBfhDIASIbRQRAQeKiKiEIDAELIABBfxDIASItRQRAQcOEKiEIDAILIApBADYCLAJAAn8gACgCFCgCAEEgaiIIIAAoAgxPBEAgACgCEEEsaiEICyAILQAEQQNGBEAgCCgCAAwBCyAIIApBLGpBABD8AUUNASAKKAIsCyEuICwoAgAhCCAsIRwgLSELIwBBgARrIgEkACABQv7M+c3wADcDICABQuLA1uKg9/LODzcDGCABQpuFnNiAjrquCTcDECABQtmyo/HA2+zmDzcDCCABQpiv4LeQtoWUDzcDACABQve068HAADcD8AMgAUL7yfaq4IiPtQI3A+gDIAFCl/qjxYCiuOAPNwPgAyABQpyz0KqAzaKiCzcD2AMgAUK4qcPY8J/CvgQ3A9ADIAFBjAFqIAEgAUHQA2oQ3ggaIAFC//////ABNwPAAyABQv/////w////DzcDuAMgAUKu9fr/8P///w83A7ADIAFCv/eAxcDemucNNwOoAyABQsGC2YHQmfqSDTcDoAMgGyIGKAIAIgJBIU4EQCAGQSA2AgADQCAGKAIIIANqIgQgAiAEakEgay0AADoAACADQQFqIgMgBigCAEgNAAtBICECCyALKAIAIglBIU4EQCALQSA2AgBBACEDA0AgCygCCCADaiIEIAQgCWpBIGstAAA6AAAgA0EBaiIDIAsoAgBIDQALQSAhCQsgBigCCCETIAFCADcDkAMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBIADIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTwAkEAIQRBACEDIAJBAEoEQEEgIAIgAkEgThshFEEAIQZBACECA0AgB0EIdCADQRR1ciEHIAZBFHUhFSACQRR1IQUgDEEUdSEWIA1BFHUhFyAOQRR1IRggD0EUdSEZIBBBFHUhGiADQQh0QYD+//8AcSARQRR1ciEDIBIgE2otAAAgBkEIdEGA/v//AHFyIh0hBiAVIAJBCHRBgP7//wBxciIeIQIgBSAMQQh0QYD+//8AcXIiHyEMIBYgDUEIdEGA/v//AHFyIiAhDSAXIA5BCHRBgP7//wBxciIhIQ4gGCAPQQh0QYD+//8AcXIiIiEPIBkgEEEIdEGA/v//AHFyIiMhECAaIBFBCHRBgP7//wBxciIkIREgEkEBaiISIBRHDQALIAEgAzYCkAMgASAHNgKUAyABICQ2AowDIAEgIzYCiAMgASAiNgKEAyABICE2AoADIAEgIDYC/AIgASAfNgL4AiABIB42AvQCIAEgHTYC8AILIAsoAgghEyABQgA3A+ACIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAICQCAJQQBMBEBBACEFQQAhBkEAIQkMAQtBICAJIAlBIE4bIRRBACECQQAhDEEAIQ1BACEOQQAhD0EAIRBBACERQQAhBkEAIQVBACESA0AgBUEIdCAGQRR1ciEFIARBFHUhFSACQRR1IRYgDEEUdSEXIA1BFHUhGCAOQRR1IRkgD0EUdSEaIBBBFHUhCyAGQQh0QYD+//8AcSARQRR1ciEGIBIgE2otAAAgBEEIdEGA/v//AHFyIiUhBCAVIAJBCHRBgP7//wBxciImIQIgFiAMQQh0QYD+//8AcXIiJyEMIBcgDUEIdEGA/v//AHFyIighDSAYIA5BCHRBgP7//wBxciIpIQ4gGSAPQQh0QYD+//8AcXIiKiEPIBogEEEIdEGA/v//AHFyIishECALIBFBCHRBgP7//wBxciIJIREgEkEBaiISIBRHDQALIAEgBjYC4AIgASAFNgLkAiABIAk2AtwCIAEgKzYC2AIgASAqNgLUAiABICk2AtACIAEgKDYCzAIgASAnNgLIAiABICY2AsQCIAEgJTYCwAILIBwoAgghMCAcKAIAIQQgAUIANwPwAyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNADIARBAEoEQEEgIAQgBEEgThshHEEAIQJBACEMQQAhDUEAIQ5BACEPQQAhEEEAIRFBACESQQAhBEEAIRZBACEVA0AgFkEIdCAEQRR1ciEWIAJBFHUhFyAMQRR1IRggDUEUdSEZIA5BFHUhGiAPQRR1IQsgEEEUdSETIBFBFHUhFCAEQQh0QYD+//8AcSASQRR1ciEEIBUgMGotAAAgAkEIdEGA/v//AHFyIQIgFyAMQQh0QYD+//8AcXIiFyEMIBggDUEIdEGA/v//AHFyIhghDSAZIA5BCHRBgP7//wBxciIZIQ4gGiAPQQh0QYD+//8AcXIiGiEPIAsgEEEIdEGA/v//AHFyIgshECATIBFBCHRBgP7//wBxciITIREgFCASQQh0QYD+//8AcXIiFCESIBVBAWoiFSAcRw0ACyABIAQ2AvADIAEgFjYC9AMgASAUNgLsAyABIBM2AugDIAEgCzYC5AMgASAaNgLgAyABIBk2AtwDIAEgGDYC2AMgASAXNgLUAyABIAI2AtADC0F8IQQCQAJAIB0NACAeDQAgHw0AICANACAhDQAgIg0AICMNACAkDQAgAw0AIAdFDQELQQ8hAgJAIAdBD0cNAEH/////ACECIAMhByADQf////8ARw0AICQiB0H/////AEcNACAjIgdB/////wBHDQAgIiIHQf////8ARw0AQa71+v8AIQIgISIHQa71+v8ARw0AQfTVue4AIQIgICIHQfTVue4ARw0AQb/3gMUAIQIgHyIHQb/3gMUARw0AQc3Rl+kAIQIgHiIHQc3Rl+kARw0AQcGC2QEhAiAdIgdBwYLZAUYNAQsgAiAHSA0AAkAgJQ0AICYNACAnDQAgKA0AICkNACAqDQAgKw0AIAkNACAGDQAgBUUNAQtBDyEDAkAgBUEPRw0AQf////8AIQMgBiEFIAZB/////wBHDQAgCSEFIAlB/////wBHDQAgKyIFQf////8ARw0AICoiBUH/////AEcNAEGu9fr/ACEDICkiBUGu9fr/AEcNAEH01bnuACEDICgiBUH01bnuAEcNAEG/94DFACEDICciBUG/94DFAEcNAEHN0ZfpACEDICYiBUHN0ZfpAEcNAEHBgtkBIQMgJSIFQcGC2QFGDQELIAMgBUgNACABQcACaiABQcACaiABQaADahDWCCABQdADaiABQdADaiABQcACaiABQaADahDVCCABQZACaiABQfACaiABQcACaiABQaADahDVCCABIC8oAggQ/gNFBEBBfSEEDAELIAEgAUGMAWogAUGQAmogAUHQA2oQ5gggARDXCA0AIAFBwAJqIAFBwAJqIAEQgAQgAUHAAmogAUGgA2oQ0ghBfEEAIAFBwAJqIAFB8AJqENAIGyEECyABQYAEaiQAIAAoAgxBAUERIARBAEgbOgAEIAAgACgCDEEIajYCDCAIIC5GIS5Bh+YqIQgMAwtBo7sqIQgMAgtBACEbC0EAIS0LIC0QmgEgGxCaASAsEJoBIC8QmgEgLgRAIApBvL0rNgIAIABB4IcqIAoQmwEgCkEwaiQAQQEPCyAKIAg2AhQgCkG8vSs2AhAgAEH8iCogCkEQahBsAAvMGAEcfyMAQTBrIhYkACAWQaCqKTYCICAAQfmGKiAWQSBqEJsBIABBARDIASEbIBZBADYCLCAAKAIUKAIAQRBqIgYgACgCDE8EQCAAKAIQQSxqIQYLIAYtAARBA0cEfyAGIBZBLGpBABD8ARogFkEsagUgBgsoAgAhGSAAQQMQyAEhGgJAAkACQCAAKAIUKAIAQSBqIgYgACgCDE8EfyAAKAIQQSxqBSAGCy0ABEEPcUEFRwRAQcqXKyEZDAELIABBBEH/oioQkAEaIABBBEGSjCoQkAEaIABBfhDIASIGRQRAQeKiKiEZDAELIABBfxDIASIYRQRAQcOEKiEZDAILIABBwQBBAUGQiDQtAAAbEIYBIhxFBEBBw7YpIRkMAwsjAEHgBGsiASQAAkACQCAbIgMoAgAiBUEhTgRAIANBIDYCAANAIAMoAgggAmoiBCAEIAVqQSBrLQAAOgAAIAJBAWoiAiADKAIASA0ACyADKAIIIRdBICEFDAELIAMoAgghFyABQgA3A/ADIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTgAyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AMgBUEATA0BC0EAIQNBACEEQQAhAgNAIA1BCHQgAkEUdXIhDSADQRR1IQ8gBEEUdSEQIAdBFHUhESAIQRR1IRIgCUEUdSETIApBFHUhFCALQRR1IRUgAkEIdEGA/v//AHEgDEEUdXIhAiAOIBdqLQAAIANBCHRBgP7//wBxciEDIA8gBEEIdEGA/v//AHFyIg8hBCAQIAdBCHRBgP7//wBxciIQIQcgESAIQQh0QYD+//8AcXIiESEIIBIgCUEIdEGA/v//AHFyIhIhCSATIApBCHRBgP7//wBxciITIQogFCALQQh0QYD+//8AcXIiFCELIBUgDEEIdEGA/v//AHFyIhUhDCAOQQFqIg4gBUcNAAsgASACNgLwAyABIA02AvQDIAEgFTYC7AMgASAUNgLoAyABIBM2AuQDIAEgEjYC4AMgASARNgLcAyABIBA2AtgDIAEgDzYC1AMgASADNgLQAwsgAUGMAWogAUHQA2ogGRDfCAR/AkACQCAGKAIAIgVBIU4EQCAGQSA2AgBBACECA0AgBigCCCACaiIDIAMgBWpBIGstAAA6AAAgAkEBaiICIAYoAgBIDQALIAYoAgghF0EgIQUMAQsgBigCCCEXIAFCADcDwAMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLADIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSgAyAFQQBMDQELQQAhA0EAIQRBACEHQQAhCEEAIQlBACEKQQAhC0EAIQxBACECQQAhDUEAIQ4DQCANQQh0IAJBFHVyIQ0gA0EUdSEPIARBFHUhECAHQRR1IREgCEEUdSESIAlBFHUhEyAKQRR1IRQgC0EUdSEVIAJBCHRBgP7//wBxIAxBFHVyIQIgDiAXai0AACADQQh0QYD+//8AcXIhAyAPIARBCHRBgP7//wBxciIPIQQgECAHQQh0QYD+//8AcXIiECEHIBEgCEEIdEGA/v//AHFyIhEhCCASIAlBCHRBgP7//wBxciISIQkgEyAKQQh0QYD+//8AcXIiEyEKIBQgC0EIdEGA/v//AHFyIhQhCyAVIAxBCHRBgP7//wBxciIVIQwgDkEBaiIOIAVHDQALIAEgAjYCwAMgASANNgLEAyABIBU2ArwDIAEgFDYCuAMgASATNgK0AyABIBI2ArADIAEgETYCrAMgASAQNgKoAyABIA82AqQDIAEgAzYCoAMLAkACQCAYKAIAIgVBIU4EQCAYQSA2AgBBACECA0AgGCgCCCACaiIDIAMgBWpBIGstAAA6AAAgAkEBaiICIBgoAgBIDQALIBgoAgghF0EgIQUMAQsgGCgCCCEXIAFCADcDkAMgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBIADIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTwAiAFQQBMDQELQQAhA0EAIQRBACEHQQAhCEEAIQlBACEKQQAhC0EAIQxBACECQQAhDUEAIQ4DQCANQQh0IAJBFHVyIQ0gA0EUdSEPIARBFHUhECAHQRR1IREgCEEUdSESIAlBFHUhEyAKQRR1IRQgC0EUdSEVIAJBCHRBgP7//wBxIAxBFHVyIQIgDiAXai0AACADQQh0QYD+//8AcXIhAyAPIARBCHRBgP7//wBxciIPIQQgECAHQQh0QYD+//8AcXIiECEHIBEgCEEIdEGA/v//AHFyIhEhCCASIAlBCHRBgP7//wBxciISIQkgEyAKQQh0QYD+//8AcXIiEyEKIBQgC0EIdEGA/v//AHFyIhQhCyAVIAxBCHRBgP7//wBxciIVIQwgDkEBaiIOIAVHDQALIAEgAjYCkAMgASANNgKUAyABIBU2AowDIAEgFDYCiAMgASATNgKEAyABIBI2AoADIAEgETYC/AIgASAQNgL4AiABIA82AvQCIAEgAzYC8AILIBooAgghBSAaKAIAIQIgAUIANwPgAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMACIAJBAEoEQEEgIAIgAkEgThshF0EAIQNBACEEQQAhB0EAIQhBACEJQQAhCkEAIQtBACEMQQAhAkEAIQ1BACEOA0AgDUEIdCACQRR1ciENIANBFHUhDyAEQRR1IRAgB0EUdSERIAhBFHUhEiAJQRR1IRMgCkEUdSEUIAtBFHUhFSACQQh0QYD+//8AcSAMQRR1ciECIAUgDmotAAAgA0EIdEGA/v//AHFyIQMgDyAEQQh0QYD+//8AcXIiDyEEIBAgB0EIdEGA/v//AHFyIhAhByARIAhBCHRBgP7//wBxciIRIQggEiAJQQh0QYD+//8AcXIiEiEJIBMgCkEIdEGA/v//AHFyIhMhCiAUIAtBCHRBgP7//wBxciIUIQsgFSAMQQh0QYD+//8AcXIiFSEMIA5BAWoiDiAXRw0ACyABIAI2AuACIAEgDTYC5AIgASAVNgLcAiABIBQ2AtgCIAEgEzYC1AIgASASNgLQAiABIBE2AswCIAEgEDYCyAIgASAPNgLEAiABIAM2AsACCyABQv7M+c3wADcD0AQgAULiwNbioPfyzg83A8gEIAFCm4Wc2ICOuq4JNwPABCABQtmyo/HA2+zmDzcDuAQgAUKYr+C3kLaFlA83A7AEIAFC97TrwcAANwOgBCABQvvJ9qrgiI+1AjcDmAQgAUKX+qPFgKK44A83A5AEIAFCnLPQqoDNoqILNwOIBCABQripw9jwn8K+BDcDgAQgAUEIaiABQbAEaiABQYAEahDeCBogAUE0aiICIAIQ4AggASABKAI0IgJB/////wBxNgI0IAEgASgCOCACQRx1aiICQf////8AcTYCOCABIAEoAjwgAkEcdWoiAkH/////AHE2AjwgASABKAJAIAJBHHVqIgJB/////wBxNgJAIAEgASgCRCACQRx1aiICQf////8AcTYCRCABIAEoAkggAkEcdWoiAkH/////AHE2AkggASABKAJMIAJBHHVqIgJB/////wBxNgJMIAEgASgCUCACQRx1aiICQf////8AcTYCUCABIAEoAlQgAkEcdWoiAkH/////AHE2AlQgASABKAJYIAJBHHVqNgJYIAFBjAFqIAFBCGogAUHwAmogAUHAAmoQ5gggAUL/////8AE3A7ACIAFC//////D///8PNwOoAiABQq71+v/w////DzcDoAIgAUK/94DFwN6a5w03A5gCIAFCwYLZgdCZ+pINNwOQAiABQaADaiABQaADaiABQZACahDWCCABQYwBaiABQaADahDkCCABQbAEaiABQYAEaiABQYwBahCABCAcQQhqIgIoAgBBBDoAACAcQcEANgIAIAIoAgBBAWogAUGwBGoQgQQgAigCAEEhaiABQYAEahCBBCACKAIAEP0DBUF/CyECIAFB4ARqJAAgACgCDEEBQREgAhs6AAQgACAAKAIMQQhqNgIMQQAhGUEBIQMMAgtBACEGC0EAIRgLIBgQmgEgBhCaASAaEJoBIBsQmgEgA0UEQCAWIBk2AhQgFkGgqik2AhAgAEH8iCogFkEQahBsAAsgFkGgqik2AgAgAEHghyogFhCbASAWQTBqJABBAgvbBAEIfyMAQTBrIgUkACAFQcilKTYCICAAQfmGKiAFQSBqEJsBAkAgAEEBEMgBIgZFBEBB37YpIQEMAQsgBigCCBD9AwRAQZPYKSEBDAELIABBIUEBQZCINC0AABsQhgEiA0UEQEGzgCshAQwBC0EgQQBBkIg0LQAAIgEbIgchAiABBEBBACEBIAZBCGohBANAIAMoAgggAWogAUEBciICIAQoAgBqLQAAOgAAIAMoAgggAmogAUECciICIAQoAgBqLQAAOgAAIAMoAgggAmogAUEDciICIAQoAgBqLQAAOgAAIAMoAgggAmogAUEEaiIBIAQoAgBqLQAAOgAAQSAhAiABQSBHDQALC0EBIQEgAygCCCACakEAOgABIAMgBzYCACAGKAIAIAdBAXRKBEAgACAHQQFyEIYBIgNFBEBBlYArIQEMAgtBIEEAQZCINC0AACIBGyIIIQcCQCABRQ0AIAMoAgggBkEIaiIEKAIAIAhqLQABOgAAQQEhAQNAIAMoAgggAWogBCgCACABai0AIToAACABQQFqIgIgAygCCGogBCgCACACai0AIToAACABQQJqIgIgAygCCGogBCgCACACai0AIToAAEEgIQcgAUEDaiICQSBGDQEgAygCCCACaiAEKAIAIAJqLQAhOgAAIAFBBGohAQwACwALIAMoAgggB2pBADoAASADIAg2AgBBAiEBCyAGEJoBIAVByKUpNgIQIABB4IcqIAVBEGoQmwEgBUEwaiQAIAEPCyAGEJoBIAUgATYCBCAFQcilKTYCACAAQfyIKiAFEGwAC7MFAQl/IwBBIGsiBCQAIARB1esrNgIQIABB+YYqIARBEGoQmwEgACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCAEEQaiIBECdBAmpBARAuIQUgAUGP3ysQnQQhAiABQbniKxCdBCEBAkAgAkUNACABRQ0AIAJBChCeASIDRQ0AIANBAWoiAUG54isQnQQiBkUNACAFIQICQCABIAZPDQAgBiADa0ECayEHIANBf3MgBmpBA3EiCARAQQAhAwNAAkACQCABLQAAIglBCmsOBAEAAAEACyACIAk6AAAgAkEBaiECCyABQQFqIQEgA0EBaiIDIAhHDQALCyAHQQNJDQADQAJAAkAgAS0AACIDQQprDgQBAAABAAsgAiADOgAAIAJBAWohAgsCQAJAIAEtAAEiA0EKaw4EAQAAAQALIAIgAzoAACACQQFqIQILAkACQCABLQACIgNBCmsOBAEAAAEACyACIAM6AAAgAkEBaiECCwJAAkAgAS0AAyIDQQprDgQBAAABAAsgAiADOgAAIAJBAWohAgsgAUEEaiIBIAZHDQALCyACQQA6AAALIAAgBSAFECcQnwECQAJAQaSINCgCACIBRQ0AIAQgBTYCHCABKAIAIgIgBCgCHEsNACAEKAIcIAIgASgCEGpPDQAgBSABKAIENgIAIAEgBTYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAVBACAB/AsADAELIAUQKwsgBEHV6ys2AgAgAEHghyogBBCbASAEQSBqJABBAQ8LIABBAUH1tCsQhgIAC4ALAQx/IAEtAAAiAkUEQCAADwsCQCAAIALAEJ4BIgBFDQAgAS0AASIDRQRAIAAPCyAALQABRQ0AIAEtAAJFBEAgAyEBIAAtAAEiA0EARyEHAkAgA0UNACAALQAAQQh0IANyIgQgAUH/AXEgAkH/AXFBCHRyIgJGDQAgAEEBaiEBA0AgASIALQABIgNBAEchByADRQ0BIABBAWohASAEQQh0QYD+A3EgA3IiBCACRw0ACwsgAEEAIAcbDwsgAC0AAkUNACABLQADRQRAIABBAmohAiAALQACIgNBAEchBwJAAkAgA0UNACAALQABQRB0IAAtAABBGHRyIANBCHRyIgMgAS0AAUEQdCABLQAAQRh0ciABLQACQQh0ciIERg0AA0AgAkEBaiEBIAItAAEiAEEARyEHIABFDQIgASECIAAgA3JBCHQiAyAERw0ACwwBCyACIQELIAFBAmtBACAHGw8LIAAtAANFDQAgAS0ABEUEQCAAQQNqIQMgAC0AAyICQQBHIQcCQAJAIAJFDQAgAC0AAUEQdCAALQAAQRh0ciAALQACQQh0ciACciIEIAEoAAAiAEEYdCAAQYD+A3FBCHRyIABBCHZBgP4DcSAAQRh2cnIiAUYNAANAIANBAWohAiADLQABIgBBAEchByAARQ0CIAIhAyAEQQh0IAByIgQgAUcNAAsMAQsgAyECCyACQQNrQQAgBxsPCyAAIQRBACECIwBBoAhrIgskACALQZAIav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgC/0MAAAAAAAAAAAAAAAAAAAAAP0LBIAIAkACQAJAAkACQCABIggtAAAiAUUEQEF/IQZBASEADAELA0AgBCAFai0AAEUNAiALIAFB/wFxQQJ0aiAFQQFqIgU2AgAgC0GACGogAUEDdkEccWoiACAAKAIAQQEgAXRyNgIAIAUgCGotAAAiAQ0AC0EBIQBBfyEGIAVBAUsNAgtBfyEDQQEhCQwCC0EAIQAMAgtBASEKQQEhAQNAAn8gBiAIaiABai0AACIDIAAgCGotAAAiCUYEQCABIApGBEAgAiAKaiECQQEMAgsgAUEBagwBCyADIAlLBEAgACAGayEKIAAhAkEBDAELIAIhBiACQQFqIQJBASEKQQELIgEgAmoiACAFSQ0AC0F/IQNBACEAQQEhAkEBIQlBASEBA0ACfyADIAhqIAFqLQAAIg0gAiAIai0AACIMRgRAIAEgCUYEQCAAIAlqIQBBAQwCCyABQQFqDAELIAwgDUsEQCACIANrIQkgAiEAQQEMAQsgACEDIABBAWohAEEBIQlBAQsiASAAaiICIAVJDQALIAohAAsCfyAIIAggCSAAIANBAWogBkEBaksiARsiCmogAyAGIAEbIgxBAWoiCRCEAgRAIAwgBSAMQX9zaiIBIAEgDEkbQQFqIQpBAAwBCyAFIAprCyEHIAVBP3IhDUEAIQEgBCEAA0AgASEDAkAgBCAAIgJrIAVPDQBBACEAIARBACANEJMIIgEgBCANaiABGyEEIAFFDQAgASACayAFSQ0CC0EAIQEgC0GACGogAiAFaiIAQQFrLQAAIgZBA3ZBHHFqKAIAIAZ2QQFxRQ0AIAsgBkECdGooAgAiASAFRwRAIAIgBSABayIBIAMgASADSxtqIQBBACEBDAELAkAgCCAJIgEgAyABIANLGyIAai0AACIGBEADQCAAIAJqLQAAIAZB/wFxRw0CIAggAEEBaiIAai0AACIGDQALCwNAIAEgA00EQCACIQAMBAsgCCABQQFrIgFqLQAAIAEgAmotAABGDQALIAIgCmohACAHIQEMAQsgAiAAIAxraiEAQQAhAQwACwALIAtBoAhqJAAgACEECyAEC/cDAQh/IwBBMGsiAyQAIANBhtEpNgIgIABB+YYqIANBIGoQmwECQCAAQQEQyAEiBgRAIABBgMAAEIYBIgcNASAGEJoBCyADQcWgKjYCBCADQYbRKTYCACAAQfyIKiADEGwACwJAIAYoAggiAS0AAEEwRw0AAkACQAJAAkAgAS0AASICQYEBaw4CAAECCyABLQACIQIMAgsgASwAAiICQQBIDQIgAS0AAyACQQh0ciECDAELIALAQQBIDQELIAFBAkEDQQQgAkGAAkkbIAJBgAFJGyICaiIELQAAQTBHDQACQAJAAkACQCAELQABIgFBgQFrDgIAAgELIAQtAAIhAQwCCyABwEEATg0BDAILIAQsAAIiAUEASA0BIAQtAAMgAUEIdHIhAQtBAkEDQQQgAUGAAkkbIAFBgAFJGyIIIAFqIgUgBygCBEoNACAHIAU2AgAgASACaiAIaiACTA0AIAIhASAFQQFxBEAgBygCCCAELQAAOgAAIAFBAWohAQsgBUEBRg0AIAIgBWohBQNAIAcoAgggASACa2ogBigCCCABai0AADoAACAHKAIIIAFBAWoiBCACa2ogBigCCCAEai0AADoAACABQQJqIgEgBUcNAAsLIAYQmgEgA0GG0Sk2AhAgAEHghyogA0EQahCbASADQTBqJABBAQv4GAESfyMAQUBqIgYkACAGQYnwKjYCMCAAQfmGKiAGQTBqEJsBAkAgAEEBEMgBIgoEQCAAQYDAABCGASIFDQEgChCaAQsgBkHFoCo2AgQgBkGJ8Co2AgAgAEH8iCogBhBsAAsCQCAKKAIIIgMtAABBMEcEQAwBCwJAAkACQAJAIAMtAAEiAkGBAWsOAgABAgsgAy0AAiECDAILIAMsAAIiAkEASA0CIAMtAAMgAkEIdHIhAgwBCyACwEEASA0BCyAKKAIAQQJBA0EEIAJBgAJJGyACQYABSRsiByACakcEQAwBCyADIAdqIgQtAABBMEcEQAwBCwJAAkACQAJAIAQtAAEiAkGBAWsOAgACAQsgBC0AAiECDAILIALAQQBODQEMAgsgBCwAAiICQQBIDQEgBC0AAyACQQh0ciECCyADIAIgB2pBAkEDQQQgAkGAAkkbIAJBgAFJG2oiBGoiAi0AAEEwRwRADAELAkACQAJAAkAgAi0AASIHQYEBaw4CAAIBCyACLQACIQcMAgsgB8BBAE4NAQwCCyACLAACIgdBAEgNASACLQADIAdBCHRyIQcLIANBAkEDQQQgB0GAAkkbIAdBgAFJGyAEaiIIaiICLQAAQQZHDQACQAJAAkACQCACLQABIgRBgQFrDgIAAgELIAItAAIhBAwCCyAEwEEATg0BDAILIAIsAAIiBEEASA0BIAItAAMgBEEIdHIhBAsgBEEMSwRADAELIARFBEAMAQsgByAIaiEJQQJBA0EEIARBgAJJGyAEQYABSRsgCGoiASAEaiEHQQAhAgNAIAZBNGogAmogASADai0AADoAACACQQFqIQIgAUEBaiIBIAdIDQALQQMhBwJAIARBA0YEQCAGLQA0QStGIAYtADVB5QBGcSIBIAYtADYiAkHxAEZxDQEgASACQfAARnENAUEAIQEMAgsCQAJAAkACQCAEQQhrDgIAAQMLQQEhByAGLQA0QSpGIAYtADVBhgFGcSAGLQA2QcgARnEgBi0AN0HOAUZxIAYtADhBPUZxIAYtADlBBEZxIAYtADpBA0ZxIgEgBi0AOyICQQRGcQ0DIAEgAkEDRnENAyABIAJBAkZxIQEMAQtBAiEHQQJBAkEAIAYtADwiECIBQQtGG0EAIAYtADQiAkEqRiAGLQA1IgtBhgFGcSAGLQA2IgxByABGcSAGLQA3Ig1BhgFGcSAGLQA4Ig9B9wFGcSAGLQA5Ig5BDUZxIAYtADoiEUEBRnEgBi0AOyISQQFGcSIEGyIIIAFBDEYbIAggBBshASACQSpHDQAgC0GGAUcNACAMQf8BcUHIAEcNACANQf8BcUGGAUcNACAPQf8BcUH3AUcNACAOQf8BcUENRw0AIBFBAUcNACASQQFHDQAgEEENRg0CCyABIQcgAUUNAgwBCyAEQQtHBEBBACEBDAILIAYtADRBK0cEQEEAIQEMAgsgBi0ANUEGRwRAQQAhAQwCCyAGLQA2QQFHBEBBACEBDAILIAYtADdBBEcEQEEAIQEMAgsgBi0AOEEBRwRAQQAhAQwCCyAGLQA5QQJHBEBBACEBDAILIAYtADpBggFHBEBBACEBDAILIAYtADtBC0cEQEEAIQEMAgsgBi0APEEHRwRAQQAhAQwCCyAGLQA9QQZHBEBBACEBDAILQQQhByAGLQA+QQVGDQBBACEBDAELIAMgCWoiAi0AAEEDRwRAQQAhAQwBCwJAAkACQAJAIAItAAEiBEGBAWsOAgACAQsgAi0AAiEEDAILQQAhASAEwEEATg0BDAILQQAhASACLAACIgRBAEgNASACLQADIARBCHRyIQQLQQJBA0EEIARBgAJJGyAEQYABSRsgCWoiDUEBaiECIARBAWshCAJAAkACQAJAIAdBAmsOAwIAAwELQQAhASAIIAUoAgRKDQMgBSAINgIAIAQgDWogAkwEQCAHIQEMBAsgBEECRwRAAkAgBEEDayIMQQJJBEAMAQsgDEEBdkEBakF+cSELQQAhAwNAIAUoAgggAWogCigCCCACai0AADoAACAFKAIIIAFqIAooAgggAmotAAE6AAEgAUECciIEIAUoAghqIAJBAmoiCSAKKAIIai0AADoAACAFKAIIIARqIAooAgggCWotAAE6AAEgAkEEaiECIAFBBGohASADQQJqIgMgC0cNAAsLIAhBAXEhAyAMQQJxRQRAIAUoAgggAWogCigCCCACai0AADoAACAFKAIIIAFqIAooAgggAmotAAE6AAEgAkECaiECIAFBAmohAQsgA0UEQCAHIQEMBQsgCigCCCEDCyAFKAIIIAFqIAIgA2otAAA6AAAgByEBDAMLQQAhAUEwIAMgAhCgBCIEQQBIDQJBAiADQQJBA0EEIARBgAJJGyAEQYABSRsgAmoiAhCgBCIEQQBIDQIgBCADQQJBA0EEIARBgAJJGyAEQYABSRsgAmoiDWotAAAiDEUiD2siC0EAIAvBQQhvIgNrwWpBCGogCyADGyIJQQF0IgMgBSgCBEoNAiAFIAM2AgACQCAJIAtrIgNBAEwEQEEAIQMMAQsgA0EDcSEIQQAhAgJAIAQgCWtBAEF/IAwbakF8Sw0AAkAgA0EEayIOQQRJBEAMAQsgDkECdkEBakH+////B3EhDEEAIQkDQCAFKAIIIAFqQQA6AAAgBSgCCCABakEAOgABIAUoAgggAWpBADoAAiAFKAIIIAFqQQA6AAMgAUEEciIEIAUoAghqQQA6AAAgBSgCCCAEakEAOgABIAUoAgggBGpBADoAAiAFKAIIIARqQQA6AAMgAUEIaiEBIAlBAmoiCSAMRw0ACwsgDkEEcQ0AIAUoAgggAWpBADoAACAFKAIIIAFqQQA6AAEgBSgCCCABakEAOgACIAUoAgggAWpBADoAAyABQQRqIQELIAhFDQADQCAFKAIIIAFqQQA6AAAgAUEBaiEBIAJBAWoiAiAIRw0ACwsgDSAPaiECIAtBAEoEQCACIAtqIQEDQCAFKAIIIANqIAooAgggAmotAAA6AAAgA0EBaiEDIAJBAWoiAiABSA0ACwtBACEBQQIgCigCCCIIIAIQoAQiBEEASA0CAkAgBCAIQQJBA0EEIARBgAJJGyAEQYABSRsgAmoiC2otAABFIgxrIgjBQQhvIglFDQBBCCAJayICQf//A3EhDSADIQEgAkEDcSIEBEBBACECA0AgBSgCCCABakEAOgAAIAFBAWohASACQQFqIgIgBEcNAAsLIAMgDWohAyAJQQVrQf//A3FBA0kNAANAIAUoAgggAWpBADoAACAFKAIIIAFqQQA6AAEgBSgCCCABakEAOgACIAUoAgggAWpBADoAAyABQQRqIgEgA0cNAAsLIAhBAEwEQCAHIQEMAwsgCyAMaiIBIAhqIQIDQCAFKAIIIANqIAooAgggAWotAAA6AAAgA0EBaiEDIAFBAWoiASACSA0ACyAHIQEMAgtBACEBIAQgCEEIbyIDa0EHaiAIIAMbIgkgBSgCBEoNASAFIAk2AgACQCAJIAhrIgFBAEwEQEEAIQEMAQsgAUEDcSELQQAhCEEAIQMCQCAJIARrQQNJDQACQCABQQRrIg5BBEkEQAwBCyAOQQJ2QQFqQf7///8HcSEPQQAhDANAIAUoAgggA2pBADoAACAFKAIIIANqQQA6AAEgBSgCCCADakEAOgACIAUoAgggA2pBADoAAyADQQRyIgkgBSgCCGpBADoAACAFKAIIIAlqQQA6AAEgBSgCCCAJakEAOgACIAUoAgggCWpBADoAAyADQQhqIQMgDEECaiIMIA9HDQALCyAOQQRxDQAgBSgCCCADakEAOgAAIAUoAgggA2pBADoAASAFKAIIIANqQQA6AAIgBSgCCCADakEAOgADIANBBGohAwsgC0UNAANAIAUoAgggA2pBADoAACADQQFqIQMgCEEBaiIIIAtHDQALCyAEQQJIBEAgByEBDAILIAQgDWohAwNAIAUoAgggAWogCigCCCACai0AADoAACABQQFqIQEgAkEBaiICIANIDQALIAchAQwBC0EAIQEgCCAFKAIESg0AIAUgCDYCACAEQQJIBEAgByEBDAELIAQgDWohAUEAIQMDQCAFKAIIIANqIAooAgggAmotAAA6AAAgA0EBaiEDIAJBAWoiAiABSA0ACyAHIQELIAYgATYCICAAQbjIKSAGQSBqEFsgChCaASAGQYnwKjYCECAAQeCHKiAGQRBqEJsBIAZBQGskAEEBC1QBAX9BfyEDIAEgAmoiAi0AACAARgR/AkACQAJAIAItAAEiAUGBAWsOAgABAgsgAi0AAg8LIAItAAMgAiwAAkEIdHIPC0F/IAEgAcBBAEgbBSADCwvXFAELfyMAQdAAayIFJAAgBUHEsCk2AjAgAEH5hiogBUEwahCbAQJAIABBARDIASIKRQ0AIABBgMAAEJgBIghFDQACQAJAAkACQCAKKAIIIgItAABBMEYEQAJAAkAgAi0AASIBQYEBaw4CAAEDCyACLQACIQEMAwsgAiwAAiIBQQBIDQMgAi0AAyABQQh0ciEBDAILDAMLIAHAQQBIDQELIAooAgBBAkEDQQQgAUGAAkkbIAFBgAFJGyIGIAFqRwRADAELAkACQAJAAkAgAiAGaiIDLQABIgFBgQFrDgIAAgELIAMtAAIhAQwCCyABwEEATg0BDAILIAMsAAIiAUEASA0BIAMtAAMgAUEIdHIhAQsgAiABIAZqQQJBA0EEIAFBgAJJGyABQYABSRtqIgZqIgQtAAAiAUECRgR/AkACQAJAAkAgBC0AASIBQYEBaw4CAAECCyAELQACIQEMAgsgBC0AAyAELAACQQh0ciEBDAELQQAhBCABwEEASA0CCyABQQBMBEBBACEEDAILIAIgASAGakECQQNBBCABQYACSRsgAUGAAUkbaiIGai0AAAUgAQtB/wFxQTBHBEBBACEEDAELAkACQAJAAkAgAiAGaiIDLQABIgFBgQFrDgIAAgELIAMtAAIhAQwCC0EAIQQgAcBBAE4NAQwCC0EAIQQgAywAAiIBQQBIDQEgAy0AAyABQQh0ciEBCyACIAEgBmpBAkEDQQQgAUGAAkkbIAFBgAFJG2oiA2oiBi0AAEEwRwRAQQAhBAwBCwJAAkACQAJAIAYtAAEiAUGBAWsOAgACAQsgBi0AAiEBDAILQQAhBCABwEEATg0BDAILQQAhBCAGLAACIgFBAEgNASAGLQADIAFBCHRyIQELIAIgASADakECQQNBBCABQYACSRsgAUGAAUkbaiIDaiIGLQAAQTBHBEBBACEEDAELAkACQAJAAkAgBi0AASIBQYEBaw4CAAIBCyAGLQACIQEMAgtBACEEIAHAQQBODQEMAgtBACEEIAYsAAIiAUEASA0BIAYtAAMgAUEIdHIhAQsgAiABIANqQQJBA0EEIAFBgAJJGyABQYABSRtqIgNqIgYtAABBMEcEQEEAIQQMAQsCQAJAAkACQCAGLQABIgFBgQFrDgIAAgELIAYtAAIhAQwCC0EAIQQgAcBBAE4NAQwCC0EAIQQgBiwAAiIBQQBIDQEgBi0AAyABQQh0ciEBC0EAIQQgAiABIANqQQJBA0EEIAFBgAJJGyABQYABSRtqIgZqIgEtAABBMEcNAAJAAkACQCABLQABIgNBgQFrDgICAQALIAPAQQBODQEMAgsgASwAAkEASA0BCyAGIQQLAkACQAJAAkAgAiAEaiIELQABIgJBgQFrDgIAAgELIAQtAAIhAgwCC0EAIQEgAsBBAE4NAQwCC0EAIQEgBCwAAiICQQBIDQEgBC0AAyACQQh0ciECC0EAIQEgBEECQQNBBCACQYACSRsgAkGAAUkbIgNqIgItAABBMEcNAAJAAkACQAJAIAItAAEiBkGBAWsOAgACAQsgAi0AAiEGDAILIAbAQQBODQEMAgsgAiwAAiIGQQBIDQEgAi0AAyAGQQh0ciEGCyAEQQJBA0EEIAZBgAJJGyAGQYABSRsgA2oiB2oiAi0AAEEGRw0AAkACQAJAAkAgAi0AASIDQYEBaw4CAAIBCyACLQACIQMMAgsgA8BBAE4NAQwCCyACLAACIgNBAEgNASACLQADIANBCHRyIQMLIANBEEsEQAwBCyADRQRADAELIAYgB2ohCUECQQNBBCADQYACSRsgA0GAAUkbIAdqIgIgA2ohBgNAIAVBQGsgAWogAiAEai0AADoAACABQQFqIQEgAkEBaiICIAZIDQALAkACQCADQQdGBEAgBS0AQEEqRiAFLQBBQYYBRnEgBS0AQkHIAEZxIAUtAENBzgFGcSAFLQBEQT1GcSAFLQBFQQJGcSAFLQBGQQFGcSEGDAELQQAhBiADQQNHIgFFBEBBA0EAIAUtAEJB8ABGG0EAIAUtAEFB5QBGG0EAIAUtAEBBK0YbIQYLIAFFBEAgBS0AQEErRw0BIAUtAEFB5QBHDQEgBS0AQkHxAEcNAUEDIQZBAyEDDAILIANBCUYEQCAFLQBAQSpHDQEgBS0AQUGGAUcNASAFLQBCQcgARw0BIAUtAENBhgFHDQEgBS0AREH3AUcNASAFLQBFQQ1HDQEgBS0ARkEBRw0BIAUtAEdBAUcNASAFLQBIQQFHDQFBAiEGQQIhAwwCCyADQQtHDQAgBS0AQEErRw0AIAUtAEFBBkcNACAFLQBCQQFHDQAgBS0AQ0EERw0AIAUtAERBAUcNACAFLQBFQQJHDQAgBS0ARkGCAUcNACAFLQBHQQtHDQAgBS0ASEEHRw0AIAUtAElBBkcNACAFLQBKQQVHDQBBBCEGQQQhAwwBCwJAIAYiAyIBDgICAAELIAIgBGoiAy0AAEEGRwRAQQAhAQwCCwJAAkACQAJAIAMtAAEiB0GBAWsOAgACAQsgAy0AAiEHDAILQQAhASAHwEEATg0BDAMLQQAhASADLAACIgdBAEgNAiADLQADIAdBCHRyIQcLIAdBEEoEQEEAIQEMAgtBASEDIAdBAEwNAEECQQNBBCAHQYACSRsgB0GAAUkbIAJqIgIgB2ohB0EAIQEDQCAFQUBrIAFqIAIgBGotAAA6AAAgAUEBaiEBIAJBAWoiAiAHSA0ACwsgBCAJaiICLQAAQQNHBEBBACEBDAELAkACQAJAAkAgAi0AASIHQYEBaw4CAAIBCyACLQACIQcMAgtBACEBIAfAQQBODQEMAgtBACEBIAIsAAIiB0EASA0BIAItAAMgB0EIdHIhBwtBAkEDQQQgB0GAAkkbIAdBgAFJGyAJaiIJQQFqIQICQAJAIANBBEsNAEEBIAN0QRpxRQ0AQQAhASAHQQFrIgsgCCgCBEoNAiAIIAs2AgAgB0ECTgRAIAcgCWohByAIKAIIIQkDQCABIAlqIAIgBGotAAA6AAAgAUEBaiEBIAJBAWoiAiAHSA0ACwsgA0EERg0BCyADQQJHDQBBACEBQTAgBCACEKAEIgNBAEgNAUECIARBAkEDQQQgA0GAAkkbIANBgAFJGyACaiIDEKAEIgJBAEgNASACIARBAkEDQQQgAkGAAkkbIAJBgAFJGyADaiIHai0AAEUiCWsiAyAIKAIESg0BIAggAzYCACADQQBMDQAgByAJaiICIANqIQMgCCgCCCEHA0AgASAHaiACIARqLQAAOgAAIAFBAWohASACQQFqIgIgA0gNAAsLIAYhAQsgACAIKAIAIgQQhgEiAkUNACAEQQFrIgQEQCACKAIIIAgoAghBAWogBPwKAAALIAIgBDYCACAIEJoBIAUgATYCICAAQcXIKSAFQSBqEFsgChCaASAFQcSwKTYCECAAQeCHKiAFQRBqEJsBIAVB0ABqJABBAQ8LIAoQmgEgBUHFoCo2AgQgBUHEsCk2AgAgAEH8iCogBRBsAAvpMQERfyMAQUBqIggkACAIQbWwKTYCMCAAQfmGKiAIQTBqEJsBAkAgAEEBEMgBIgoEQCAAIAooAgAQhgEiAg0BIAoQmgELIAhBxaAqNgIEIAhBtbApNgIAIABB/IgqIAgQbAALAkAgCigCCCIBLQAAQTBHBEAMAQsCQAJAAkACQCABLQABIgNBgQFrDgIAAQILIAEtAAIhAwwCCyABLAACIgNBAEgNAiABLQADIANBCHRyIQMMAQsgA8BBAEgNAQsgCigCAEECQQNBBCADQYACSRsgA0GAAUkbIgQgA2pHBEAMAQsgASAEaiIGLQAAQQJHBEAMAQsCQAJAAkACQCAGLQABIgNBgQFrDgIAAgELIAYtAAIhAwwCCyADwEEATg0BDAILIAYsAAIiA0EASA0BIAYtAAMgA0EIdHIhAwsgASADIARqQQJBA0EEIANBgAJJGyADQYABSRtqIgZqIgMtAABBMEcEQAwBCwJAAkACQAJAIAMtAAEiBEGBAWsOAgACAQsgAy0AAiEEDAILIATAQQBODQEMAgsgAywAAiIEQQBIDQEgAy0AAyAEQQh0ciEECyABQQJBA0EEIARBgAJJGyAEQYABSRsgBmoiBGoiAy0AAEEGRw0AAkACQAJAAkAgAy0AASIFQYEBaw4CAAIBCyADLQACIQUMAgsgBcBBAE4NAQwCCyADLAACIgZBAEgNASADLQADIAZBCHRyIQULIAVBDEsNACAFRQ0AQQJBA0EEIAVBgAJJGyAFQYABSRsgBGoiAyAFaiEGQQAhBANAIAhBNGogBGogASADai0AADoAACAEQQFqIQQgA0EBaiIDIAZIDQALAkACQAJAIAVBA0YEQCAILQA0QStHDQMgCC0ANUHlAEcNAyAILQA2QfAARw0DIAEgBmoiAy0AAEEERwRADAULAkACQAJAAkAgAy0AASIEQYEBaw4CAAIBCyADLQACIQQMAgsgBMBBAE4NAQwGCyADLAACIgRBAEgNBSADLQADIARBCHRyIQQLQQQgAUECQQNBBCAEQYACSRsgBEGAAUkbIAZqIgMQoAQiBUEASA0EIAIoAgRBIEgNBCADQQJBA0EEIAVBgAJJGyAFQYABSRtqIQYgAkEgNgIAQSAgBWshASAFQR9LDQIgAUEDcSEEQQAhAyAFQRxLDQEgAigCCEEAOgAAIAIoAghBADoAASACKAIIQQA6AAIgAigCCEEAOgADQQQhByABQTxxIgtBBEYNASACKAIIQQA6AAQgAigCCEEAOgAFIAIoAghBADoABiACKAIIQQA6AAdBCCEHIAtBCEYNASACKAIIQQA6AAggAigCCEEAOgAJIAIoAghBADoACiACKAIIQQA6AAtBDCEHIAtBDEYNASACKAIIQQA6AAwgAigCCEEAOgANIAIoAghBADoADiACKAIIQQA6AA9BECEHIAtBEEYNASACKAIIQQA6ABAgAigCCEEAOgARIAIoAghBADoAEiACKAIIQQA6ABNBFCEHIAtBFEYNASACKAIIQQA6ABQgAigCCEEAOgAVIAIoAghBADoAFiACKAIIQQA6ABdBGCEHIAtBGEYNASACKAIIQQA6ABggAigCCEEAOgAZIAIoAghBADoAGiACKAIIQQA6ABtBHCEHIAtBHEYNASACKAIIQQA6ABwgAigCCEEAOgAdIAIoAghBADoAHiACKAIIQQA6AB9BICEHDAELIAVBC0cEQAJAIAVBB0cNACAILQA0QSpHDQUgCC0ANUGGAUcNBSAILQA2QcgARw0FIAgtADdBzgFHDQUgCC0AOEE9Rw0FIAgtADlBAkcNBSAILQA6QQFHDQVBBiAKKAIIIgMgBhCgBCIFQQBIDQUgBUEMSg0FQQJBA0EEIAVBgAJJGyAFQYABSRsgBmoiASAFaiEEIAUEQANAIAhBNGogB2ogASADai0AADoAACAHQQFqIQcgAUEBaiIBIARIDQALC0EAIQdBBCADIAQQoAQiAUEASA0FQTAgA0ECQQNBBCABQYACSRsgAUGAAUkbIARqIgQQoAQiAUEASA0FQQIgA0ECQQNBBCABQYACSRsgAUGAAUkbIARqIgQQoAQiAUEASA0FQQQgAyABIARqQQJBA0EEIAFBgAJJGyABQYABSRtqIg8QoAQiDUEASA0FAkAgBUEIRgRAQSAhBAwBC0EgIQQgBUEFRyIBRQRAQSBBIEEgQSBBMEEgIAgtADhBIkYbIAgtADcbIAgtADZBBEcbIAgtADVBgQFHGyAILQA0QStHGyEECyABDQAgBEHCACAEIAgtADhBI0YbIAgtADcbIAQgCC0ANkEERhsgBCAILQA1QYEBRhsgBCAILQA0QStGGyEECyACKAIEIARIBEBBASEHDAYLQQJBA0EEIA1BgAJJGyANQYABSRshESACIAQ2AgBBASEHAkAgBCANayIDQQBMDQAgA0EDcSEJQQAhBkEAIQECQCANIARrQXxLDQACQCADQQRrIg5BBEkEQAwBCyAOQQJ2QQFqQf7///8HcSEQA0AgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBHIiCyACKAIIakEAOgAAIAIoAgggC2pBADoAASACKAIIIAtqQQA6AAIgAigCCCALakEAOgADIAFBCGohASAMQQJqIgwgEEcNAAsLIA5BBHENACACKAIIIAFqQQA6AAAgAigCCCABakEAOgABIAIoAgggAWpBADoAAiACKAIIIAFqQQA6AAMgAUEEaiEBCyAJRQ0AA0AgAigCCCABakEAOgAAIAFBAWohASAGQQFqIgYgCUcNAAsLIA8gEWohBiANRQ0AA0AgAigCCCADaiAKKAIIIAZqLQAAOgAAIAZBAWohBiADQQFqIgMgBEgNAAsLIAVBCUcNBCAILQA0QSpHDQQgCC0ANUGGAUcNBCAILQA2QcgARw0EIAgtADdBhgFHDQQgCC0AOEH3AUcNBCAILQA5QQ1HDQQgCC0AOkEBRw0EIAgtADtBAUcNBCAILQA8QQFHDQRBBSAKKAIIIgEgBhCgBCIDQQBIDQRBBCABQQJBA0EEIANBgAJJGyADQYABSRsgBmoiBBCgBCIDQQBIDQRBMCABQQJBA0EEIANBgAJJGyADQYABSRsgBGoiBBCgBCIDQQBIDQRBAiABQQJBA0EEIANBgAJJGyADQYABSRsgBGoiBBCgBCIDQQBIDQRBAiABIAMgBGpBAkEDQQQgA0GAAkkbIANBgAFJG2oiBBCgBCIDQQBIDQRBAiABIAMgBGpBAkEDQQQgA0GAAkkbIANBgAFJG2oiBBCgBCIDQQBIDQRBAiABIAMgBGpBAkEDQQQgA0GAAkkbIANBgAFJG2oiBBCgBCIDQQBIDQRBAiABIAMgBGpBAkEDQQQgA0GAAkkbIANBgAFJG2oiAxCgBCIFQQBIDQQgBSABQQJBA0EEIAVBgAJJGyAFQYABSRsgA2oiEGotAAAiCUUiD2siDEEAIAzBQQhvIgFrwWpBCGogDCABGyIEQQVsIhEgAigCBEoNBAJAIAQgDGsiA0EATA0AIANBA3EhC0EAIQZBACEBAkAgBSAEa0EAQX8gCRtqQXxLDQACQCADQQRrIg5BBEkEQAwBCyAOQQJ2QQFqQf7///8HcSENQQAhCQNAIAIoAgggAWpBADoAACACKAIIIAFqQQA6AAEgAigCCCABakEAOgACIAIoAgggAWpBADoAAyABQQRyIgUgAigCCGpBADoAACACKAIIIAVqQQA6AAEgAigCCCAFakEAOgACIAIoAgggBWpBADoAAyABQQhqIQEgCUECaiIJIA1HDQALCyAOQQRxDQAgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBGohAQsgC0UNAANAIAIoAgggAWpBADoAACABQQFqIQEgBkEBaiIGIAtHDQALCyAPIBBqIQEgDEEASgRAA0AgAigCCCADaiAKKAIIIAFqLQAAOgAAIAFBAWohASADQQFqIgMgBEgNAAsLQQIgCigCCCIDIAEQoAQiBUEASA0EIAUgA0ECQQNBBCAFQYACSRsgBUGAAUkbIAFqIhBqLQAAIglFIg9rIgxBACAMwUEIbyIBa8FqQQhqIAwgARsgBEcNBAJAIAQgDGsiA0EATA0AIANBA3EhC0EAIQZBACEBAkAgBSAEa0EAQX8gCRtqQXxLDQACQCADQQRrIg5BBEkEQAwBCyAOQQJ2QQFqQf7///8HcSENQQAhCQNAIAIoAgggAWpBADoAACACKAIIIAFqQQA6AAEgAigCCCABakEAOgACIAIoAgggAWpBADoAAyABQQRyIgUgAigCCGpBADoAACACKAIIIAVqQQA6AAEgAigCCCAFakEAOgACIAIoAgggBWpBADoAAyABQQhqIQEgCUECaiIJIA1HDQALCyAOQQRxDQAgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBGohAQsgC0UNAANAIAIoAgggAWpBADoAACABQQFqIQEgBkEBaiIGIAtHDQALCyAPIBBqIQEgDEEASgRAA0AgAigCCCAEaiADaiAKKAIIIAFqLQAAOgAAIAFBAWohASADQQFqIgMgBEgNAAsLQQIgCigCCCIDIAEQoAQiBUEASA0EIAUgA0ECQQNBBCAFQYACSRsgBUGAAUkbIAFqIhBqLQAAIglFIg9rIgxBACAMwUEIbyIBa8FqQQhqIAwgARsgBEcNBAJAIAQgDGsiA0EATA0AIANBA3EhC0EAIQZBACEBAkAgBSAEa0EAQX8gCRtqQXxLDQACQCADQQRrIg5BBEkEQAwBCyAOQQJ2QQFqQf7///8HcSENQQAhCQNAIAIoAgggAWpBADoAACACKAIIIAFqQQA6AAEgAigCCCABakEAOgACIAIoAgggAWpBADoAAyABQQRyIgUgAigCCGpBADoAACACKAIIIAVqQQA6AAEgAigCCCAFakEAOgACIAIoAgggBWpBADoAAyABQQhqIQEgCUECaiIJIA1HDQALCyAOQQRxDQAgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBGohAQsgC0UNAANAIAIoAgggAWpBADoAACABQQFqIQEgBkEBaiIGIAtHDQALCyAPIBBqIQEgDEEASgRAIARBAXQhBgNAIAIoAgggBmogA2ogCigCCCABai0AADoAACABQQFqIQEgA0EBaiIDIARIDQALC0ECIAooAggiAyABEKAEIgVBAEgNBCAFIANBAkEDQQQgBUGAAkkbIAVBgAFJGyABaiIQai0AACIJRSIPayIMQQAgDMFBCG8iAWvBakEIaiAMIAEbIARHDQQCQCAEIAxrIgNBAEwNACADQQNxIQtBACEGQQAhAQJAIAUgBGtBAEF/IAkbakF8Sw0AAkAgA0EEayIOQQRJBEAMAQsgDkECdkEBakH+////B3EhDUEAIQkDQCACKAIIIAFqQQA6AAAgAigCCCABakEAOgABIAIoAgggAWpBADoAAiACKAIIIAFqQQA6AAMgAUEEciIFIAIoAghqQQA6AAAgAigCCCAFakEAOgABIAIoAgggBWpBADoAAiACKAIIIAVqQQA6AAMgAUEIaiEBIAlBAmoiCSANRw0ACwsgDkEEcQ0AIAIoAgggAWpBADoAACACKAIIIAFqQQA6AAEgAigCCCABakEAOgACIAIoAgggAWpBADoAAyABQQRqIQELIAtFDQADQCACKAIIIAFqQQA6AAAgAUEBaiEBIAZBAWoiBiALRw0ACwsgDyAQaiEBIAxBAEoEQCAEQQNsIQYDQCACKAIIIAZqIANqIAooAgggAWotAAA6AAAgAUEBaiEBIANBAWoiAyAESA0ACwtBAiAKKAIIIgMgARCgBCIGQQBIDQQgBiADQQJBA0EEIAZBgAJJGyAGQYABSRsgAWoiDWotAAAiC0UiEGsiCUEAIAnBQQhvIgFrwWpBCGogCSABGyAERw0EAkAgBCAJayIHQQBMDQAgB0EDcSEFQQAhA0EAIQECQCAGIARrQQBBfyALG2pBfEsNAAJAIAdBBGsiD0EESQRADAELIA9BAnZBAWpB/v///wdxIQxBACELA0AgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBHIiBiACKAIIakEAOgAAIAIoAgggBmpBADoAASACKAIIIAZqQQA6AAIgAigCCCAGakEAOgADIAFBCGohASALQQJqIgsgDEcNAAsLIA9BBHENACACKAIIIAFqQQA6AAAgAigCCCABakEAOgABIAIoAgggAWpBADoAAiACKAIIIAFqQQA6AAMgAUEEaiEBCyAFRQ0AA0AgAigCCCABakEAOgAAIAFBAWohASADQQFqIgMgBUcNAAsLIAlBAEoEQCANIBBqIQEgBEECdCEDA0AgAigCCCADaiAHaiAKKAIIIAFqLQAAOgAAIAFBAWohASAHQQFqIgcgBEgNAAsLIAIgETYCAEECIQcMBAsgCC0ANEErRw0DIAgtADVBBkcNAyAILQA2QQFHDQMgCC0AN0EERw0DIAgtADhBAUcNAyAILQA5QQJHDQMgCC0AOkGCAUcNAyAILQA7QQtHDQMgCC0APEEHRw0DIAgtAD1BBkcNAyAILQA+QQVHDQNBBCAKKAIIIgQgBhCgBCIBQQBIDQNBBCAEQQJBA0EEIAFBgAJJGyABQYABSRsgBmoiAxCgBCIBQQBIDQNBBCEHAkAgASACKAIEIgYgASAGSBsiCUEATA0AQQJBA0EEIAFBgAJJGyABQYABSRsgA2ohA0EAIQEgCUEBRwRAAkAgCUECayIMQQJJBEAMAQsgDEEBdkEBakF+cSELQQAhBANAIAIoAgggAWogCigCCCADai0AADoAACACKAIIIAFqIAooAgggA2otAAE6AAEgAUECciIGIAIoAghqIANBAmoiBSAKKAIIai0AADoAACACKAIIIAZqIAooAgggBWotAAE6AAEgAUEEaiEBIANBBGohAyAEQQJqIgQgC0cNAAsLIAlBAXEhBCAMQQJxRQRAIAIoAgggAWogCigCCCADai0AADoAACACKAIIIAFqIAooAgggA2otAAE6AAEgA0ECaiEDIAFBAmohAQsgBEUNASAKKAIIIQQLIAIoAgggAWogAyAEai0AADoAAAsgAiAJNgIADAMLIAQEQANAIAIoAgggB2pBADoAACAHQQFqIQcgA0EBaiIDIARHDQALCyAFDQBBAyEHDAELIAVBHyABIAFBH0wbIgRqIgNBAXFFBEAgAigCCCABaiAKKAIIIAZqLQAAOgAAIAZBAWohBkEhIAVrIQELQQMhByADQSBGDQADQCACKAIIIAFqIAooAgggBmotAAA6AAAgAUEBaiIDIAIoAghqIAooAgggBmotAAE6AAAgAUECaiEBIAZBAmohBiADIARHDQALCyAILQA0QStHDQAgCC0ANUHlAEcNACAILQA2QfEARw0AQQQgCigCCCIDIAYQoAQiAUEASA0AQQQgA0ECQQNBBCABQYACSRsgAUGAAUkbIAZqIgwQoAQiBUEASA0AIAIoAgRBOUgNACACQTk2AgBBOSAFayEDAkAgBUE4Sw0AIANBA3EhBkEAIQdBACEBAkAgBUE1Sw0AQTUgBWshDQJAIAVBMUsEQAwBCyANQQJ2QQFqQR5xIQlBACELA0AgAigCCCABakEAOgAAIAIoAgggAWpBADoAASACKAIIIAFqQQA6AAIgAigCCCABakEAOgADIAFBBHIiBCACKAIIakEAOgAAIAIoAgggBGpBADoAASACKAIIIARqQQA6AAIgAigCCCAEakEAOgADIAFBCGohASALQQJqIgsgCUcNAAsLIA1BBHENACACKAIIIAFqQQA6AAAgAigCCCABakEAOgABIAIoAgggAWpBADoAAiACKAIIIAFqQQA6AAMgAUEEaiEBCyAGBEADQCACKAIIIAFqQQA6AAAgAUEBaiEBIAdBAWoiByAGRw0ACwsgBQ0AQQMhBwwBC0ECQQNBBCAFQYACSRsgBUGAAUkbIAxqIQEgBUE4IAMgA0E4TBsiBmoiBEEBcQRAIAIoAgggA2ogCigCCCABai0AADoAAEE6IAVrIQMgAUEBaiEBC0EDIQcgBEE5Rg0AA0AgAigCCCADaiAKKAIIIAFqLQAAOgAAIANBAWoiBCACKAIIaiAKKAIIIAFqLQABOgAAIANBAmohAyABQQJqIQEgBCAGRw0ACwsgCCAHNgIgIABBrMgpIAhBIGoQWyAKEJoBIAhBtbApNgIQIABB4IcqIAhBEGoQmwEgCEFAayQAQQEL/wgBBn8jAEGgEmsiASQAIAFBmZMqNgKQAiAAQfmGKiABQZACahCbAQJAIABBARDIASICBEAgAiABQZwCahCkBCIFRQ0BIABBAEEAEKEBAkAgAkEIaiIDKAIAQYDuMygCAEGI7jMoAgAgBSABQZwCahClBCIERQ0AIAEoApwCIgZFBEAgAUHjlSo2AvABIABBxuAqIAFB8AFqEG4MAQsgAEHjlSoQWCABIAIoAgggBGo2AoACIAFBoAJqIAZBkYwqIAFBgAJqEKYEGiAAIAFBoAJqEFggAEF9EKIBCwJAIAMoAgBBxO0zKAIAQcztMygCACAFIAFBnAJqEKUEIgNFDQAgASgCnAIiBEUEQCABQeqoKTYC0AEgAEHG4CogAUHQAWoQbgwBCyAAQeqoKRBYIAEgAigCCCADajYC4AEgAUGgAmogBEGRjCogAUHgAWoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAkEIaiIDKAIAQcTuMygCAEHM7jMoAgAgBSABQZwCahClBCIERQ0AIAEoApwCIgZFBEAgAUGoyyo2ArABIABBxuAqIAFBsAFqEG4MAQsgAEGoyyoQWCABIAIoAgggBGo2AsABIAFBoAJqIAZBkYwqIAFBwAFqEKYEGiAAIAFBoAJqEFggAEF9EKIBCwJAIAMoAgBB7O0zKAIAQfTtMygCACAFIAFBnAJqEKUEIgNFDQAgASgCnAIiBEUEQCABQZDRKjYCkAEgAEHG4CogAUGQAWoQbgwBCyAAQZDRKhBYIAEgAigCCCADajYCoAEgAUGgAmogBEGRjCogAUGgAWoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAkEIaiIDKAIAQZTuMygCAEGc7jMoAgAgBSABQZwCahClBCIERQ0AIAEoApwCIgZFBEAgAUHt3Sk2AnAgAEHG4CogAUHwAGoQbgwBCyAAQe3dKRBYIAEgAigCCCAEajYCgAEgAUGgAmogBkGRjCogAUGAAWoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAygCAEGo7jMoAgBBsO4zKAIAIAUgAUGcAmoQpQQiA0UNACABKAKcAiIERQRAIAFBzJErNgJQIABBxuAqIAFB0ABqEG4MAQsgAEHMkSsQWCABIAIoAgggA2o2AmAgAUGgAmogBEGRjCogAUHgAGoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAigCCEHY7TMoAgBB4O0zKAIAIAUgAUGcAmoQpQQiBUUNACABKAKcAiIDRQRAIAFB8P8qNgIwIABBxuAqIAFBMGoQbgwBCyAAQfD/KhBYIAEgAigCCCAFajYCQCABQaACaiADQZGMKiABQUBrEKYEGiAAIAFBoAJqEFggAEF9EKIBCyACEJoBIAFBmZMqNgIgIABB4IcqIAFBIGoQmwEgAUGgEmokAEEBDwsgAUHFoCo2AgQgAUGZkyo2AgAgAEH8iCogARBsAAsgAhCaASABQfDPKjYCFCABQZmTKjYCECAAQfyIKiABQRBqEGwAC/oEAQV/IAFBADYCACAAKAIIIgMtAABBMEcEQEEADwsCQAJAAkACQAJAIAMtAAEiAkGBAWsOAgACAQsgAy0AAiECDAILIALAQQBODQEMAgsgAywAAiICQQBIDQEgAy0AAyACQQh0ciECCyAAKAIAQQJBA0EEIAJBgAJJGyACQYABSRsiBSACakcEQEEADwsCQAJAAkACQCADIAVqIgItAAEiAEGBAWsOAgACAQsgAi0AAiEADAILIADAQQBODQEMAgsgAiwAAiIAQQBIDQEgAi0AAyAAQQh0ciEACyADIAAgBWpBAkEDQQQgAEGAAkkbIABBgAFJG2oiAmoiBC0AACIAQQJGBEACQAJAAkACQCAELQABIgBBgQFrDgIAAQILIAQtAAIhAAwCCyAELQADIAQsAAJBCHRyIQAMAQtBACEEIADAQQBIDQILIABBAEwEQEEADwsgAyAAIAJqQQJBA0EEIABBgAJJGyAAQYABSRtqIgJqLQAAIQALQQAhBCAAQf8BcUEwRw0AAkACQAJAAkAgAiADaiIFLQABIgBBgQFrDgIAAgELIAUtAAIhAAwCCyAAwEEATg0BDAILIAUsAAIiAEEASA0BIAUtAAMgAEEIdHIhAAtBAiEGQX8hBQJAIAMgACACakECQQNBBCAAQYACSRsgAEGAAUkbaiIEaiIDLQAAQTBHDQACQAJAAkAgAy0AASIAQYEBaw4CAAECCyADLQACIgMhBSADwEEATg0CQQMhBgwCCyADLQADIAMtAAIiAMBBCHRyIgVB/wBMDQFBBEEDIABB/wFxGyEGDAELQX8gACAAwEEASBshBQsgASAFIAZqNgIACyAEC4UGAQZ/IwBBQGohCQJAIAAgA2oiBi0AAEEwRw0AAkACQAJAAkAgBi0AASIFQYEBaw4CAAIBCyAGLQACIQUMAgsgBcBBAE4NAQwCCyAGLAACIgVBAEgNASAGLQADIAVBCHRyIQULAkAgBUEASgRAQQJBA0EEIAVBgAJJGyAFQYABSRsgA2oiBiAFaiEKA0AgACAGaiIFLQAAQTFHBEBBAA8LAkACQAJAAkAgBS0AASIDQYEBaw4CAAIBCyAFLQACIQMMAgtBACEHIAPAQQBODQEMBQtBACEHIAUsAAIiA0EASA0EIAUtAAMgA0EIdHIhAwsgAEECQQNBBCADQYACSRsgA0GAAUkbIAZqIgZqIgUtAABBMEcEQEEADwsCQAJAAkACQCAFLQABIgNBgQFrDgIAAgELIAUtAAIhAwwCC0EAIQcgA8BBAE4NAQwFC0EAIQcgBSwAAiIDQQBIDQQgBS0AAyADQQh0ciEDCyAAQQJBA0EEIANBgAJJGyADQYABSRsgBmoiBWoiAy0AAEEGRwRAQQAPCwJAAkACQAJAIAMtAAEiBkGBAWsOAgACAQsgAy0AAiEGDAILQQAhByAGwEEATg0BDAULQQAhByADLAACIgZBAEgNBCADLQADIAZBCHRyIQYLQQAhByAGQTJKDQNBAkEDQQQgBkGAAkkbIAZBgAFJGyAFaiEDIAZBAEoEQCADIAZqIQUDQCAHIAlqIAAgA2otAAA6AAAgB0EBaiEHIANBAWoiAyAFSA0ACwsCQAJAAkACQCAAIANqIggtAAEiBUGBAWsOAgACAQsgCC0AAiEFDAILQQAhByAFwEEATg0BDAULQQAhByAILAACIgVBAEgNBCAILQADIAVBCHRyIQULQQJBA0EEIAVBgAJJGyAFQYABSRsgA2ohBwJAIAEgBkcNAEEAIQMgAUEATA0DA0AgAyAJai0AACACIANqLQAARw0BIAEgA0EBaiIDRw0ACwwDCyAFIAdqIgYgCkgNAAsLQQAhBUEAIQcLIAQgBTYCAAsgBwsqAQF/IwBBEGsiBCQAIAQgAzYCDCAAIAEgAiADEKQLIQMgBEEQaiQAIAML/wgBBn8jAEGgEmsiASQAIAFBy+kpNgKQAiAAQfmGKiABQZACahCbAQJAIABBARDIASICBEAgAiABQZwCahCoBCIFRQ0BIABBAEEAEKEBAkAgAkEIaiIDKAIAQYDuMygCAEGI7jMoAgAgBSABQZwCahClBCIERQ0AIAEoApwCIgZFBEAgAUHjlSo2AvABIABBxuAqIAFB8AFqEG4MAQsgAEHjlSoQWCABIAIoAgggBGo2AoACIAFBoAJqIAZBkYwqIAFBgAJqEKYEGiAAIAFBoAJqEFggAEF9EKIBCwJAIAMoAgBBxO0zKAIAQcztMygCACAFIAFBnAJqEKUEIgNFDQAgASgCnAIiBEUEQCABQeqoKTYC0AEgAEHG4CogAUHQAWoQbgwBCyAAQeqoKRBYIAEgAigCCCADajYC4AEgAUGgAmogBEGRjCogAUHgAWoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAkEIaiIDKAIAQcTuMygCAEHM7jMoAgAgBSABQZwCahClBCIERQ0AIAEoApwCIgZFBEAgAUGoyyo2ArABIABBxuAqIAFBsAFqEG4MAQsgAEGoyyoQWCABIAIoAgggBGo2AsABIAFBoAJqIAZBkYwqIAFBwAFqEKYEGiAAIAFBoAJqEFggAEF9EKIBCwJAIAMoAgBB7O0zKAIAQfTtMygCACAFIAFBnAJqEKUEIgNFDQAgASgCnAIiBEUEQCABQZDRKjYCkAEgAEHG4CogAUGQAWoQbgwBCyAAQZDRKhBYIAEgAigCCCADajYCoAEgAUGgAmogBEGRjCogAUGgAWoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAkEIaiIDKAIAQZTuMygCAEGc7jMoAgAgBSABQZwCahClBCIERQ0AIAEoApwCIgZFBEAgAUHt3Sk2AnAgAEHG4CogAUHwAGoQbgwBCyAAQe3dKRBYIAEgAigCCCAEajYCgAEgAUGgAmogBkGRjCogAUGAAWoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAygCAEGo7jMoAgBBsO4zKAIAIAUgAUGcAmoQpQQiA0UNACABKAKcAiIERQRAIAFBzJErNgJQIABBxuAqIAFB0ABqEG4MAQsgAEHMkSsQWCABIAIoAgggA2o2AmAgAUGgAmogBEGRjCogAUHgAGoQpgQaIAAgAUGgAmoQWCAAQX0QogELAkAgAigCCEHY7TMoAgBB4O0zKAIAIAUgAUGcAmoQpQQiBUUNACABKAKcAiIDRQRAIAFB8P8qNgIwIABBxuAqIAFBMGoQbgwBCyAAQfD/KhBYIAEgAigCCCAFajYCQCABQaACaiADQZGMKiABQUBrEKYEGiAAIAFBoAJqEFggAEF9EKIBCyACEJoBIAFBy+kpNgIgIABB4IcqIAFBIGoQmwEgAUGgEmokAEEBDwsgAUHFoCo2AgQgAUHL6Sk2AgAgAEH8iCogARBsAAsgAhCaASABQfDPKjYCFCABQcvpKTYCECAAQfyIKiABQRBqEGwAC7MCAQZ/IwBBEGsiBCQAIAFBADYCACAAIARBDGoQpAQhAgJAIAAoAggiBSACIAQoAgxqIgdqIgItAABBMEcNAAJAAkACQAJAIAItAAEiAEGBAWsOAgACAQsgAi0AAiEADAILIADAQQBODQEMAgsgAiwAAiIAQQBIDQEgAi0AAyAAQQh0ciEAC0ECIQZBfyECAkAgBSAAIAdqQQJBA0EEIABBgAJJGyAAQYABSRtqIgNqIgAtAABBMEcNAAJAAkACQCAALQABIgJBgQFrDgIAAQILIAAtAAIiACECIADAQQBODQJBAyEGDAILIAAtAAMgAC0AAiIFwEEIdHIiAkH/AEwNAUEEQQMgBUH/AXEbIQYMAQtBfyACIALAQQBIGyECCyABIAIgBmo2AgALIARBEGokACADC+MFAQZ/IwBBoBFrIgEkACABQbD8KTYCkAEgAEH5hiogAUGQAWoQmwECQCAAQQEQyAEiAwRAIAMgAUGgAWoQqAQhAiACIAEoAqABaiIEIAMoAghqIgItAABBMEcNASAEAn8CQAJAAkACQCACLQABIgVBgQFrDgIAAwELIAItAAIhAgwBCyAFwCICQQBIDQQLIAJB/wFxDAELIAIsAAIiBUEASA0CIAItAAMgBUEIdHILIgJqQQJBA0EEIAJBgAJJGyACQYABSRtqIgIgAygCAE4NASACRQ0BIABBAEEAEKEBAkAgA0EIaiIEKAIAQdjuMygCAEHg7jMoAgAgAiABQZwBahCqBCIFRQ0AIAEoApwBIgZFBEAgAUGk3ys2AnAgAEHG4CogAUHwAGoQbgwBCyAAQaTfKxBYIAEgAygCCCAFajYCgAEgAUGgAWogBkGRjCogAUGAAWoQpgQaIAAgAUGgAWoQWCAAQX0QogELAkAgBCgCAEHs7jMoAgBB9O4zKAIAIAIgAUGcAWoQqgQiBEUNACABKAKcASIFRQRAIAFBjLgpNgJQIABBxuAqIAFB0ABqEG4MAQsgAEGMuCkQWCABIAMoAgggBGo2AmAgAUGgAWogBUGRjCogAUHgAGoQpgQaIAAgAUGgAWoQWCAAQX0QogELAkAgAygCCEGA7zMoAgBBiO8zKAIAIAIgAUGcAWoQqgQiAkUNACABKAKcASIERQRAIAFB7O4pNgIwIABBxuAqIAFBMGoQbgwBCyAAQezuKRBYIAEgAygCCCACajYCQCABQaABaiAEQZGMKiABQUBrEKYEGiAAIAFBoAFqEFggAEF9EKIBCyADEJoBIAFBsPwpNgIgIABB4IcqIAFBIGoQmwEgAUGgEWokAEEBDwsgAUHFoCo2AgQgAUGw/Ck2AgAgAEH8iCogARBsAAsgAxCaASABQfDPKjYCFCABQbD8KTYCECAAQfyIKiABQRBqEGwAC4wFAQd/IwBBQGohCQJAIAAgA2oiBi0AAEGjAUcNAAJAAkACQAJAIAYtAAEiBUGBAWsOAgACAQsgBi0AAiEFDAILIAXAQQBODQEMAgsgBiwAAiIFQQBIDQEgBi0AAyAFQQh0ciEFCyAAQQJBA0EEIAVBgAJJGyAFQYABSRsgA2oiBWoiBi0AAEEwRw0AAkACQAJAAkAgBi0AASIDQYEBaw4CAAIBCyAGLQACIQMMAgsgA8BBAEgNAgwBCyAGLAACIgNBAEgNASAGLQADIANBCHRyIQMLQQJBA0EEIANBgAJJGyADQYABSRsgBWoiBiADaiELA0AgBiALTgRAIARBADYCAEEADwsgACAGaiIDLQAAQTBHBEBBAA8LAkACQAJAAkAgAy0AASIIQYEBaw4CAAIBCyADLQACIQgMAgtBACEHIAjAQQBIDQMMAQtBACEHIAMsAAIiBUEASA0CIAMtAAMgBUEIdHIhCAsgAEECQQNBBCAIQYACSRsgCEGAAUkbIAZqIgpqIgMtAABBBkcEQEEADwsCQAJAAkACQCADLQABIgVBgQFrDgIAAgELIAMtAAIhBQwCC0EAIQcgBcBBAEgNAwwBC0EAIQcgAywAAiIGQQBIDQIgAy0AAyAGQQh0ciEFC0EAIQcgBUEySg0BQQJBA0EEIAVBgAJJGyAFQYABSRsgCmohByAFQQBKBEAgBSAHaiEGQQAhAwNAIAMgCWogACAHai0AADoAACADQQFqIQMgB0EBaiIHIAZIDQALCyAIIApqIQYgASAFRw0AQQAhAyABQQBKBEADQCADIAlqLQAAIAIgA2otAABHDQIgA0EBaiIDIAFHDQALCwsgBCAGIAdrNgIAIAcPCyAHC9AGAQl/IwBB0ABrIgIkACACQZvAKjYCQCAAQfmGKiACQUBrEJsBAkAgAEEBEMgBIgYEQCAGIAJBzABqEKgEIQEgBigCCCIDIAEgAigCTGoiBGoiAS0AAEEwRw0BIAQCfwJAAkACQAJAIAEtAAEiBUGBAWsOAgADAQsgAS0AAiEBDAELIAXAIgFBAEgNBAsgAUH/AXEMAQsgASwAAiIFQQBIDQIgAS0AAyAFQQh0cgsiAWpBAkEDQQQgAUGAAkkbIAFBgAFJG2oiASAGKAIATg0BIAFFDQECQCADQdjuMygCAEHg7jMoAgAgASACQcgAahCqBCIBRQ0AIAEgA2oiAS0AAEEERw0AIAEtAAJBMEcNACABLAADIgRBARAuIQMgAEEAQQAQoQEgBEEASgRAIAFBBGoiASAEaiEJQQEhBANAIAEtAAAhCCABLAABIQUgACgCDCIHQRM6AAQgByAEszgCACAAIAAoAgxBCGo2AgwgAEEAQQAQoQEgAEH+1isQWCACIAFBAmoiBzYCMCADIAVBkYwqIAJBMGoQpgQaIAAgAxBYIABBfRCiASAAQYaMKxBYQajLKiEBAkACQAJAAkACQAJAAkACQCAIQYEBaw4gBwECAAMEBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAC0HL4itBvKsqIAhBiAFGGyEBDAYLQcj8KSEBDAULQenyKyEBDAQLQbyRKiEBDAMLQYnHKiEBDAILQcruKyEBDAELQdymKiEBCyAAIAMgARD5ARBYIABBfRCiASAAQX0QogEgBEEBaiEEIAUgB2oiASAJSQ0ACwsCQEGkiDQoAgAiAUUNACADRQ0BIAIgAzYCTCABKAIAIgQgAigCTEsNACACKAJMIAQgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIANBACAB/AsADAELIAMQKwsgBhCaASACQZvAKjYCICAAQeCHKiACQSBqEJsBIAJB0ABqJABBAQ8LIAJBxaAqNgIEIAJBm8AqNgIAIABB/IgqIAIQbAALIAYQmgEgAkHwzyo2AhQgAkGbwCo2AhAgAEH8iCogAkEQahBsAAvnCwEQfyMAQcABayICJAAgAkG/gSo2ApABIABB+YYqIAJBkAFqEJsBAkAgAEEBEMgBIgcEQCAHIAJBoAFqEKQEIAIoAqABaiIGRQ0BIABBAEEAEKEBAkAgBygCCCIEIAZqIgEtAABBMEcNAAJAAkACQAJAAkAgAS0AASIDQYEBaw4CAAIBCyABLQACIQMMAgsgA8BBAE4NAQwCCyABLAACIgNBAEgNASABLQADIANBCHRyIQMLAn8CQAJAAkACQCAEQQJBA0EEIANBgAJJGyADQYABSRsgBmoiCGoiAy0AAEEXaw4CAAEFCwJAAkAgAy0AASIFQYEBaw4CAwEACyAFwEEATg0DDAULIAMsAAIiBUEASA0EIAMtAAMgBUEIdHIhBQwCCwJAAkACQAJAIAMtAAEiBUGBAWsOAgACAQsgAy0AAiEFDAILIAXAQQBODQEMBQsgAywAAiIFQQBIDQQgAy0AAyAFQQh0ciEFCyAIQQJBA0EEIAVBgAJJGyAFQYABSRtqQQJqDAILIAMtAAIhBQtBAkEDQQQgBUGAAkkbIAVBgAFJGyAIagsiA0UNACAAQcW4KxBYIAdBCGoiBCgCACADaiIBLAAAIQMgASwAASEIIAEsAAIhBSABLAADIQkgASwABCEKIAEsAAUhCyABLAAGIQwgASwAByENIAEsAAghDiABLAAJIQ8gASwACiEQIAIgASwACzYCjAEgAiAQNgKIASACIA82AoQBIAIgDjYCgAEgAiANNgJ8IAIgDDYCeCACIAs2AnQgAiAKNgJwIAIgCTYCbCACIAU2AmggAiAINgJkIAIgAzYCYCACQaABakEUQbbIKyACQeAAahCmBBogACACQaABahBYIABBfRCiASAEKAIAIgQgBmoiAS0AAEEwRw0BCwJAAkACQAJAIAEtAAEiA0GBAWsOAgACAQsgAS0AAiEDDAILIAPAQQBODQEMAgsgASwAAiIDQQBIDQEgAS0AAyADQQh0ciEDCwJAAkACQAJAIARBAkEDQQQgA0GAAkkbIANBgAFJGyAGaiIDaiIGLQAAQRdrDgIAAQQLAkACQCAGLQABIgFBgQFrDgIDAQALIAHAQQBODQMMBAsgBiwAAiIBQQBIDQMgBi0AAyABQQh0ciEBDAILAkACQCAGLQABIgFBgQFrDgICAQALIAHAQQBODQIMAwsgBiwAAiIBQQBIDQIgBi0AAyABQQh0ciEBDAELIAYtAAIhAQsCfwJAAkACQAJAIAQgASADakECQQNBBCABQYACSRsgAUGAAUkbaiIGaiIBLQAAQRdrDgIAAQULAkACQCABLQABIgRBgQFrDgIDAQALIATAQQBODQMMBQsgASwAAiIEQQBIDQQgAS0AAyAEQQh0ciEEDAILAkACQAJAAkAgAS0AASIEQYEBaw4CAAIBCyABLQACIQQMAgsgBMBBAE4NAQwFCyABLAACIgRBAEgNBCABLQADIARBCHRyIQQLIAZBAkEDQQQgBEGAAkkbIARBgAFJG2pBAmoMAgsgAS0AAiEEC0ECQQNBBCAEQYACSRsgBEGAAUkbIAZqCyIBRQ0AIABB34EqEFggBygCCCABaiIBLAAAIQYgASwAASEEIAEsAAIhAyABLAADIQggASwABCEFIAEsAAUhCSABLAAGIQogASwAByELIAEsAAghDCABLAAJIQ0gASwACiEOIAIgASwACzYCXCACIA42AlggAiANNgJUIAIgDDYCUCACIAs2AkwgAiAKNgJIIAIgCTYCRCACQUBrIAU2AgAgAiAINgI8IAIgAzYCOCACIAQ2AjQgAiAGNgIwIAJBoAFqQRRBtsgrIAJBMGoQpgQaIAAgAkGgAWoQWCAAQX0QogELIAcQmgEgAkG/gSo2AiAgAEHghyogAkEgahCbASACQcABaiQAQQEPCyACQcWgKjYCBCACQb+BKjYCACAAQfyIKiACEGwACyAHEJoBIAJBys8qNgIUIAJBv4EqNgIQIABB/IgqIAJBEGoQbAALmQMBCH8jAEHQAGsiASQAIAFBj9IpNgJAIABB+YYqIAFBQGsQmwECQAJAAkACQCAAQQEQyAEiBUUEQEGJsykhAgwBCyAFKAIAIgNBIWtBbk0EQCABIAM2AiAgAEGFxikgAUEgahBuQcayKyECDAELIABBAhDIASIGRQRAQbvJKSECDAELIABBAxDIASIDRQRAQeLAKSECDAILIAMoAgAiBEELTARAIAEgBDYCMCAAQerDKSABQTBqEG5BxrIrIQIMAwsgAEEEEMgBIgRFBEBBhZwqIQJBACEEDAQLIAAgBigCAEEQahCGASICRQRAQZHLKSECDAQLIABBEBCGASIIRQRAQdrBKiECDAQLIAUoAgAgBSgCCCADKAIAIAMoAgggBCAGIAIgCBCKBEEAIQJBASEHDAMLQQAhBgtBACEDC0EAIQQLIAQQmgEgAxCaASAGEJoBIAUQmgEgB0UEQCABIAI2AhQgAUGP0ik2AhAgAEH8iCogAUEQahBsAAsgAUGP0ik2AgAgAEHghyogARCbASABQdAAaiQAQQILmQMBCH8jAEHQAGsiASQAIAFB1NIpNgJAIABB+YYqIAFBQGsQmwECQAJAAkACQCAAQQEQyAEiBUUEQEGJsykhAgwBCyAFKAIAIgNBIWtBbk0EQCABIAM2AiAgAEHDxikgAUEgahBuQfWyKyECDAELIABBAhDIASIGRQRAQbvJKSECDAELIABBAxDIASIDRQRAQeLAKSECDAILIAMoAgAiBEELTARAIAEgBDYCMCAAQarEKSABQTBqEG5B9bIrIQIMAwsgAEEEEMgBIgRFBEBBhZwqIQJBACEEDAQLIAAgBigCAEEQahCGASICRQRAQZHLKSECDAQLIABBEBCGASIIRQRAQdrBKiECDAQLIAUoAgAgBSgCCCADKAIAIAMoAgggBCAGIAIgCBCMBEEAIQJBASEHDAMLQQAhBgtBACEDC0EAIQQLIAQQmgEgAxCaASAGEJoBIAUQmgEgB0UEQCABIAI2AhQgAUHU0ik2AhAgAEH8iCogAUEQahBsAAsgAUHU0ik2AgAgAEHghyogARCbASABQdAAaiQAQQILiQ8BD38jAEHABGsiByQAIAdBgNIpNgJAIABB+YYqIAdBQGsQmwECQAJAIABBARDIASINRQRAQYmzKSEKDAELAkACQCANKAIAIgFBEGsOEQEAAAAAAAAAAAAAAAAAAAABAAsgByABNgIgIABBqsMpIAdBIGoQbkGKsishCgwBCyAAQQIQyAEiC0UEQEHqySkhCgwBCyAAQQMQyAEiDkUEQEHiwCkhCkEAIQ4MAgsgDigCACIBQQtMBEAgByABNgIwIABB6sQpIAdBMGoQbkGKsishCgwCCyAHQcQAakEtIA0oAgAgDSgCCCAOKAIIELAEIAAgCygCABCGASIBBEAgASgCBCIDQQBKBEADQCABKAIIIAJqQQA6AAAgAkEBaiICIAEoAgQiA0gNAAsLIAFBADYCACABIAsoAgAiAiADIAIgA0gbIgI2AgAgAkEASgRAQQAhAgNAIAEoAgggAmogCygCCCACai0AADoAACACQQFqIgIgASgCAEgNAAsLIAEoAgghAUEAIQMjAEEQayIJJAACQAJAAkACQAJAAkAgB0HEAGoiAigCCCIEDi4BAAICBQIFBQUFBQUFBQMDBQMFBQUDBQUFBQUFBQMEBAUEBQUFBAUFBQUFBQUEBQsgASABLQAAIAItAOwDczoAACABIAEtAAEgAi0A7QNzOgABIAEgAS0AAiACLQDuA3M6AAIgASABLQADIAItAO8DczoAAyABIAEtAAQgAi0A8ANzOgAEIAEgAS0ABSACLQDxA3M6AAUgASABLQAGIAItAPIDczoABiABIAEtAAcgAi0A8wNzOgAHIAEgAS0ACCACLQD0A3M6AAggASABLQAJIAItAPUDczoACSABIAEtAAogAi0A9gNzOgAKIAEgAS0ACyACLQD3A3M6AAsgASABLQAMIAItAPgDczoADCABIAEtAA0gAi0A+QNzOgANIAEgAS0ADiACLQD6A3M6AA4gASABLQAPIAItAPsDczoADyACIAEQ+gggAiABLQAAOgDsAyACIAEtAAE6AO0DIAIgAS0AAjoA7gMgAiABLQADOgDvAyACIAEtAAQ6APADIAIgAS0ABToA8QMgAiABLQAGOgDyAyACIAEtAAc6APMDIAIgAS0ACDoA9AMgAiABLQAJOgD1AyACIAEtAAo6APYDIAIgAS0ACzoA9wMgAiABLQAMOgD4AyACIAEtAA06APkDIAIgAS0ADjoA+gMgAiABLQAPOgD7AwwECyACIAEQ+ggMAwsgCSAC/QAA7AP9CwQAIAJB7ANqIQggBEEBayIGIQMDQCAIIAMgBmtqIAMgCGotAAA6AAAgA0EPSCEFIANBAWohAyAFDQALIAIgCRD6CEEAIQMgBEECRwRAIAZBAXEhDCAGQX5xIQIDQCABIANqIgUgBS0AACADIAlqLQAAcyIFOgAAIAMgBGsgCGogBToAESABIANBAXIiBWoiBiAGLQAAIAUgCWotAABzIgY6AAAgBSAEayAIaiAGOgARIANBAmoiAyACRw0ACyAMRQ0DCyABIANqIgEgAS0AACADIAlqLQAAcyIBOgAAIAMgBGsgCGogAToAEQwCCyACIAJB7ANqIggQ+gggBEENayIGQQNxIQIgBEEOa0EDTwRAIAZBfHEhDANAIAEgA2oiBCAELQAAIAMgCGotAABzOgAAIAEgA0EBciIEaiIGIAYtAAAgBCAIai0AAHM6AAAgASADQQJyIgRqIgYgBi0AACAEIAhqLQAAczoAACABIANBA3IiBGoiBiAGLQAAIAQgCGotAABzOgAAIANBBGoiAyAMRw0ACwsgAkUNAQNAIAEgA2oiBCAELQAAIAMgCGotAABzOgAAIANBAWohAyAFQQFqIgUgAkcNAAsMAQsgCSAC/QAA7AP9CwQAIAIgCRD6CCAEQR1rIgVBA3EhBiAEQR5rQQNPBEAgBUF8cSEMA0AgASADaiIFIAUtAAAgAyAJai0AAHM6AAAgASADQQFyIgVqIgQgBC0AACAFIAlqLQAAczoAACABIANBAnIiBWoiBCAELQAAIAUgCWotAABzOgAAIAEgA0EDciIFaiIEIAQtAAAgBSAJai0AAHM6AAAgA0EEaiIDIAxHDQALCyACQewDaiEEIAYEQANAIAEgA2oiBSAFLQAAIAMgCWotAABzOgAAIANBAWohAyAIQQFqIgggBkcNAAsLIAQQ/AgLIAlBEGokAEEBIQUgBygCSEECdCIGQQRqQQBMDQIgB0HQAGohAiAHQcACaiEDA0AgAyAPQQJ0IgFqQQA2AgAgASACakEANgIAIAMgAUEEciIEakEANgIAIAIgBGpBADYCACADIAFBCHIiBGpBADYCACACIARqQQA2AgAgAyABQQxyIgFqQQA2AgAgASACakEANgIAIAYgD0chASAPQQRqIQ8gAQ0ACwwCCyAAQenbK0EAEG5BkcspIQoMAQtBACELCyAOEJoBIAsQmgEgDRCaASAFBEAgB0GA0ik2AgAgAEHghyogBxCbASAHQcAEaiQAQQEPCyAHIAo2AhQgB0GA0ik2AhAgAEH8iCogB0EQahBsAAviEAEZfyACQQRtIQUCQCACQXxxQRBrIgZBEEsNAEEBIAZ0QYGCBHFFDQAgACABNgIIIAAgBTYCACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsA7AMgACAFQQZqNgIEAkAgAUUNACAERQ0AIAAgBC0AADoA7AMgACAELQABOgDtAyAAIAQtAAI6AO4DIAAgBC0AAzoA7wMgACAELQAEOgDwAyAAIAQtAAU6APEDIAAgBC0ABjoA8gMgACAELQAHOgDzAyAAIAQtAAg6APQDIAAgBC0ACToA9QMgACAELQAKOgD2AyAAIAQtAAs6APcDIAAgBC0ADDoA+AMgACAELQANOgD5AyAAIAQtAA46APoDIAAgBC0ADzoA+wMLIAVBAnQiCUEcaiEIAkAgAkEESA0AIAlFDQAgAEEMaiADIAn8CgAACyAFIAhIBEBBAiAFIAVBAkwbIQpBBiAFIAVBBkwbIQwgAEEMaiEEIAJBHEghDSAFIQMDQCAEIANBAnRqIgYgBkEEaygCAEEYdyIBQQh2Qf8BcUHw2DFqLQAAQQh0IAFB/wFxQfDYMWotAAByIAFBEHZB/wFxQfDYMWotAABBEHRyIAFBGHZB8Ngxai0AAEEYdHIgC0ECdEGAyi9qKAIAIAQgAyAFa0ECdGooAgBzcyIBNgIAAkAgDUUEQAJAIANBAWoiByAITg0AIAQgB0ECdGogASAEIAcgBWtBAnRqKAIAcyIHNgIAIANBAmoiASAITg0AIAQgAUECdGogByAEIAEgBWtBAnRqKAIAcyIHNgIAIANBA2oiASAITg0AIAQgAUECdGogByAEIAEgBWtBAnRqKAIAczYCAAsgCCADQQRqIgFKBEAgBCABQQJ0aiAEIAEgBWtBAnRqKAIAIAYoAgwiBkEIdkH/AXFB8Ngxai0AAEEIdCAGQf8BcUHw2DFqLQAAciAGQRB2Qf8BcUHw2DFqLQAAQRB0ciAGQRh2QfDYMWotAABBGHRyczYCAAtBBSEBA0AgASADaiIGIAhODQIgBCAGQQJ0aiIHIAdBBGsoAgAgBCAGIAVrQQJ0aigCAHM2AgAgAUEBaiIBIAxHDQALDAELQQEhASACQQhIDQADQCABIANqIgYgCE4NASAEIAZBAnRqIgcgB0EEaygCACAEIAYgBWtBAnRqKAIAczYCACABQQFqIgEgCkcNAAsLIAtBAWohCyADIAVqIgMgCEgNAAsLIABB/AFqIhQgCUEYaiIWQQJ0aiAAKAIMNgIAIBQgCUEZaiIaQQJ0aiAAKAIQNgIAIBQgCUEaaiIbQQJ0aiAAKAIUNgIAIBQgCUEbaiIcQQJ0aiAAKAIYNgIAIABBDGohEEEEIRUDQCAWIBVrIR1BACEGA0BBACEKIBAgBiAVckECdGooAgAiBEH/AXEiAQRAQegAQen+AyABQcDeL2otAAAiA0GXAUkbIANqQf//A3FBwNwvai0AACEKCyAEQQh2IQVBACELQQAhDSAEQYD+A3EiAwRAQe4BQe//AyAFQf8BcUHA3i9qLQAAIgdBEUkbIAdqQf//A3FBwNwvai0AACENCyAEQRB2IQggBEGAgPwHcSIHBEBBxwFByP8DIAhB/wFxQcDeL2otAAAiDEE4SRsgDGpB//8DcUHA3C9qLQAAIQsLIARBGHYhDEEAIQJBACEXIARBgICACEkiBEUEQEHfAUHg/wMgDEHA3i9qLQAAIglBIEkbIAlqQf//A3FBwNwvai0AACEXCyABBEBB7gFB7/8DIAFBwN4vai0AACICQRFJGyACakH//wNxQcDcL2otAAAhAgtBACEJQQAhDiADBEBBxwFByP8DIAVB/wFxQcDeL2otAAAiDkE4SRsgDmpB//8DcUHA3C9qLQAAIQ4LIAcEQEHfAUHg/wMgCEH/AXFBwN4vai0AACIJQSBJGyAJakH//wNxQcDcL2otAAAhCQtBACERQQAhGCAERQRAQegAQen+AyAMQcDeL2otAAAiD0GXAUkbIA9qQf//A3FBwNwvai0AACEYCyABBEBBxwFByP8DIAFBwN4vai0AACIRQThJGyARakH//wNxQcDcL2otAAAhEQtBACEPQQAhEiADBEBB3wFB4P8DIAVB/wFxQcDeL2otAAAiEkEgSRsgEmpB//8DcUHA3C9qLQAAIRILIAcEQEHoAEHp/gMgCEH/AXFBwN4vai0AACIPQZcBSRsgD2pB//8DcUHA3C9qLQAAIQ8LQQAhGUEAIRMgBEUEQEHuAUHv/wMgDEHA3i9qLQAAIhNBEUkbIBNqQf//A3FBwNwvai0AACETCyABBEBB3wFB4P8DIAFBwN4vai0AACIBQSBJGyABakH//wNxQcDcL2otAAAhGQsgCiANcyENIAIgDnMhAiARIBJzIQ5BACEBQQAhCiADBEBB6ABB6f4DIAVB/wFxQcDeL2otAAAiA0GXAUkbIANqQf//A3FBwNwvai0AACEKCyALIA1zIQMgAiAJcyEFIA4gD3MhCyAHBEBB7gFB7/8DIAhB/wFxQcDeL2otAAAiAUERSRsgAWpB//8DcUHA3C9qLQAAIQELIAMgF3MhByAFIBhzIQUgCyATcyEIQQAhAyAUIAYgHWpBAnRqIAQEfyADBUHHAUHI/wMgDEHA3i9qLQAAIgRBOEkbIARqQf//A3FBwNwvai0AAAsgCiAZcyABc3NB/wFxIAVB/wFxQRB0IAdBGHRyIAhB/wFxQQh0cnI2AgAgBkEBaiIGQQRHDQALIBVBBGoiFSAWSQ0ACyAAIBAgFkECdGooAgA2AvwBIAAgECAaQQJ0aigCADYCgAIgACAQIBtBAnRqKAIANgKEAiAAIBAgHEECdGooAgA2AogCCwvJDwEZfyMAQcAEayIIJAAgCEHF0ik2AkAgAEH5hiogCEFAaxCbAQJAAkAgAEEBEMgBIg1FBEBBibMpIQsMAQsCQAJAIA0oAgAiAUEQaw4RAQAAAAAAAAAAAAAAAAAAAAEACyAIIAE2AiAgAEGqwykgCEEgahBuQYqyKyELDAELIABBAhDIASIMRQRAQerJKSELDAELIABBAxDIASIORQRAQeLAKSELQQAhDgwCCyAOKAIAIgFBC0wEQCAIIAE2AjAgAEHqxCkgCEEwahBuQYqyKyELDAILIAhBxABqQS0gDSgCACANKAIIIA4oAggQsAQgACAMKAIAEIYBIgEEQCABKAIEIgNBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIDSA0ACwsgAUEANgIAIAEgDCgCACICIAMgAiADSBsiAjYCACACQQBKBEBBACECA0AgASgCCCACaiAMKAIIIAJqLQAAOgAAIAJBAWoiAiABKAIASA0ACwsgASgCCCEBQQAhAyMAQRBrIgkkAAJAAkACQAJAAkACQCAIQcQAaiICKAIIIgQOLgEAAgIFAgUFBQUFBQUFAwMFAwUFBQMFBQUFBQUFAwQEBQQFBQUEBQUFBQUFBQQFCyACLQDsAyEDIAIgAS0AADoA7AMgAi0A7QMhByACIAEtAAE6AO0DIAItAO4DIQUgAiABLQACOgDuAyACLQDvAyEEIAIgAS0AAzoA7wMgAi0A8AMhBiACIAEtAAQ6APADIAItAPEDIQogAiABLQAFOgDxAyACLQDyAyEPIAIgAS0ABjoA8gMgAi0A8wMhESACIAEtAAc6APMDIAItAPQDIRIgAiABLQAIOgD0AyACLQD1AyETIAIgAS0ACToA9QMgAi0A9gMhFCACIAEtAAo6APYDIAItAPcDIRUgAiABLQALOgD3AyACLQD4AyEWIAIgAS0ADDoA+AMgAi0A+QMhFyACIAEtAA06APkDIAItAPoDIRggAiABLQAOOgD6AyACLQD7AyEZIAIgAS0ADzoA+wMgAiABEPsIIAEgAyABLQAAczoAACABIAcgAS0AAXM6AAEgASAFIAEtAAJzOgACIAEgBCABLQADczoAAyABIAYgAS0ABHM6AAQgASAKIAEtAAVzOgAFIAEgDyABLQAGczoABiABIBEgAS0AB3M6AAcgASASIAEtAAhzOgAIIAEgEyABLQAJczoACSABIBQgAS0ACnM6AAogASAVIAEtAAtzOgALIAEgFiABLQAMczoADCABIBcgAS0ADXM6AA0gASAYIAEtAA5zOgAOIAEgGSABLQAPczoADwwECyACIAEQ+wgMAwsgCSAC/QAA7AP9CwQAIAJB7ANqIQcgBEEBayIGIQMDQCAHIAMgBmtqIAMgB2otAAA6AAAgA0EPSCEFIANBAWohAyAFDQALIAIgCRD6CEEAIQMgBEECRwRAIAZBAXEhDyAGQX5xIQoDQCADIARrIAdqIAEgA2oiBS0AACIGOgARIAUgBiADIAlqLQAAczoAACADQQFyIgUgBGsgB2ogASAFaiIGLQAAIgI6ABEgBiACIAUgCWotAABzOgAAIANBAmoiAyAKRw0ACyAPRQ0DCyADIARrIAdqIAEgA2oiAS0AACIHOgARIAEgByADIAlqLQAAczoAAAwCCyACIAJB7ANqIgcQ+gggBEENayIGQQNxIQIgBEEOa0EDTwRAIAZBfHEhCgNAIAEgA2oiBCAELQAAIAMgB2otAABzOgAAIAEgA0EBciIEaiIGIAYtAAAgBCAHai0AAHM6AAAgASADQQJyIgRqIgYgBi0AACAEIAdqLQAAczoAACABIANBA3IiBGoiBiAGLQAAIAQgB2otAABzOgAAIANBBGoiAyAKRw0ACwsgAkUNAQNAIAEgA2oiBCAELQAAIAMgB2otAABzOgAAIANBAWohAyAFQQFqIgUgAkcNAAsMAQsgCSAC/QAA7AP9CwQAIAIgCRD6CCAEQR1rIgVBA3EhBiAEQR5rQQNPBEAgBUF8cSEKA0AgASADaiIFIAUtAAAgAyAJai0AAHM6AAAgASADQQFyIgVqIgQgBC0AACAFIAlqLQAAczoAACABIANBAnIiBWoiBCAELQAAIAUgCWotAABzOgAAIAEgA0EDciIFaiIEIAQtAAAgBSAJai0AAHM6AAAgA0EEaiIDIApHDQALCyACQewDaiEEIAYEQANAIAEgA2oiBSAFLQAAIAMgCWotAABzOgAAIANBAWohAyAHQQFqIgcgBkcNAAsLIAQQ/AgLIAlBEGokAEEBIQUgCCgCSEECdCIGQQRqQQBMDQIgCEHQAGohAiAIQcACaiEDA0AgAyAQQQJ0IgFqQQA2AgAgASACakEANgIAIAMgAUEEciIEakEANgIAIAIgBGpBADYCACADIAFBCHIiBGpBADYCACACIARqQQA2AgAgAyABQQxyIgFqQQA2AgAgASACakEANgIAIAYgEEchASAQQQRqIRAgAQ0ACwwCCyAAQenbK0EAEG5BkcspIQsMAQtBACEMCyAOEJoBIAwQmgEgDRCaASAFBEAgCEHF0ik2AgAgAEHghyogCBCbASAIQcAEaiQAQQEPCyAIIAs2AhQgCEHF0ik2AhAgAEH8iCogCEEQahBsAAv9HAETfyMAQfChAmsiASQAIAFB6r0qNgJAIABB+YYqIAFBQGsQmwEgAEEAQQIQoQECQCAAQeATEIYBIgsEQCAAIAAoAgxBEGtB3/8qEFkgAEGgChCGASIMRQ0BIAAgACgCDEEQa0HvxisQWSALKAIIIQIgDCgCCCENIAFBIDYCMCABQekAOwDQoAEgAUGl9jMgAUHQoAFqIAFBMGoQACIDLQAAOgDwoAIgASADLQABOgDxoAIgASADLQACOgDyoAIgASADLQADOgDzoAIgASADLQAEOgD0oAIgASADLQAFOgD1oAIgASADLQAGOgD2oAIgASADLQAHOgD3oAIgASADLQAIOgD4oAIgASADLQAJOgD5oAIgASADLQAKOgD6oAIgASADLQALOgD7oAIgASADLQAMOgD8oAIgASADLQANOgD9oAIgASADLQAOOgD+oAIgASADLQAPOgD/oAIgASADLQAQOgCAoQIgASADLQAROgCBoQIgASADLQASOgCCoQIgASADLQATOgCDoQIgASADLQAUOgCEoQIgASADLQAVOgCFoQIgASADLQAWOgCGoQIgASADLQAXOgCHoQIgASADLQAYOgCIoQIgASADLQAZOgCJoQIgASADLQAaOgCKoQIgASADLQAbOgCLoQIgASADLQAcOgCMoQIgASADLQAdOgCNoQIgASADLQAeOgCOoQIgASADLQAfOgCPoQIgAxArIAFB8KACakGAASABQfCgAmpBIBCzBCABQdCgAWogAUHwoAJqELQEQQAhAyABQdCAAWogAUGQoQJqIgZBABC1BCABQdCIAWoiDiAGQQEQtQQgAUHQkAFqIg8gBkECELUEIAFB0JgBaiIQIAZBAxC1BCABQdDAAGogBkEEELUEIAFB0MgAaiIRIAZBBRC1BCABQdDQAGoiEiAGQQYQtQQgAUHQ2ABqIhMgBkEHELUEIAFB0OAAaiABQdCAAWpBgCD8CgAAIAFB0OAAahC2BCABQdAgaiABQdCgAWogAUHQ4ABqELcEA0AgAUHQIGogA0ECdGoiBiAGKAIAIghBgICAAmpBF3VB/7+AfGwgCGo2AgAgBkEEaiIGIAYoAgAiBkGAgIACakEXdUH/v4B8bCAGajYCACADQQJqIgNBgAJHDQALIAFB0ChqIQZBACEDA0AgBiADQQJ0aiIIIAgoAgAiCUGAgIACakEXdUH/v4B8bCAJajYCACAIQQRqIgggCCgCACIIQYCAgAJqQRd1Qf+/gHxsIAhqNgIAIANBAmoiA0GAAkcNAAsgAUHQMGohCEEAIQMDQCAIIANBAnRqIgkgCSgCACIFQYCAgAJqQRd1Qf+/gHxsIAVqNgIAIAlBBGoiCSAJKAIAIglBgICAAmpBF3VB/7+AfGwgCWo2AgAgA0ECaiIDQYACRw0ACyABQdA4aiEJQQAhAwNAIAkgA0ECdGoiBSAFKAIAIgRBgICAAmpBF3VB/7+AfGwgBGo2AgAgBUEEaiIFIAUoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCACADQQJqIgNBgAJHDQALIAFB0CBqELgEIAFB0CBqIAFB0CBqIAFB0MAAahC5BEEAIQVBACEEA0AgAUHQIGogBEECdGoiAyADKAIAIgdBH3VBgcD/A3EgB2o2AgAgA0EEaiIHIAcoAgAiB0EfdUGBwP8DcSAHajYCACADQQhqIgcgBygCACIHQR91QYHA/wNxIAdqNgIAIANBDGoiAyADKAIAIgNBH3VBgcD/A3EgA2o2AgAgBEEEaiIEQYACRw0ACwNAIAYgBUECdGoiAyADKAIAIgRBH3VBgcD/A3EgBGo2AgAgA0EEaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCACADQQhqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIANBDGoiAyADKAIAIgNBH3VBgcD/A3EgA2o2AgAgBUEEaiIFQYACRw0AC0EAIQUDQCAIIAVBAnRqIgMgAygCACIEQR91QYHA/wNxIARqNgIAIANBBGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgA0EIaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCACADQQxqIgMgAygCACIDQR91QYHA/wNxIANqNgIAIAVBBGoiBUGAAkcNAAtBACEFA0AgCSAFQQJ0aiIDIAMoAgAiBEEfdUGBwP8DcSAEajYCACADQQRqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIANBCGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgA0EMaiIDIAMoAgAiA0EfdUGBwP8DcSADajYCACAFQQRqIgVBgAJHDQALQQAhAwNAIANBAnQiBSABQdAgamoiBCAEKAIAIgRB/x9qIgdBDXU2AgAgAUHQAGogBWogBCAHQYBAcWs2AgAgBUEEciIFIAFB0CBqaiIEIAQoAgAiBEH/H2oiB0ENdTYCACABQdAAaiAFaiAEIAdBgEBxazYCACADQQJqIgNBgAJHDQALIAFB0AhqIQRBACEDA0AgBCADQQJ0IgVqIAUgBmoiBygCACIKIApB/x9qIgpBgEBxazYCACAHIApBDXU2AgAgBCAFQQRyIgVqIAUgBmoiBSgCACIHIAdB/x9qIgdBgEBxazYCACAFIAdBDXU2AgAgA0ECaiIDQYACRw0ACyABQdAQaiEFQQAhAwNAIAUgA0ECdCIGaiAGIAhqIgcoAgAiCiAKQf8faiIKQYBAcWs2AgAgByAKQQ11NgIAIAUgBkEEciIGaiAGIAhqIgYoAgAiByAHQf8faiIHQYBAcWs2AgAgBiAHQQ11NgIAIANBAmoiA0GAAkcNAAsgAUHQGGohCEEAIQMDQCAIIANBAnQiBmogBiAJaiIHKAIAIgogCkH/H2oiCkGAQHFrNgIAIAcgCkENdTYCACAIIAZBBHIiBmogBiAJaiIGKAIAIgcgB0H/H2oiB0GAQHFrNgIAIAYgB0ENdTYCACADQQJqIgNBgAJHDQALIA0gAUHwoAJqIAFB0CBqELoEIAFB0KACakEgIA1BoAoQswQgAiABLQDwoAI6AAAgAiABLQDxoAI6AAEgAiABLQDyoAI6AAIgAiABLQDzoAI6AAMgAiABLQD0oAI6AAQgAiABLQD1oAI6AAUgAiABLQD2oAI6AAYgAiABLQD3oAI6AAcgAiABLQD4oAI6AAggAiABLQD5oAI6AAkgAiABLQD6oAI6AAogAiABLQD7oAI6AAsgAiABLQD8oAI6AAwgAiABLQD9oAI6AA0gAiABLQD+oAI6AA4gAiABLQD/oAI6AA8gAiABLQCAoQI6ABAgAiABLQCBoQI6ABEgAiABLQCCoQI6ABIgAiABLQCDoQI6ABMgAiABLQCEoQI6ABQgAiABLQCFoQI6ABUgAiABLQCGoQI6ABYgAiABLQCHoQI6ABcgAiABLQCIoQI6ABggAiABLQCJoQI6ABkgAiABLQCKoQI6ABogAiABLQCLoQI6ABsgAiABLQCMoQI6ABwgAiABLQCNoQI6AB0gAiABLQCOoQI6AB4gAiABLQCPoQI6AB8gAiABLQDQoQI6ACAgAiABLQDRoQI6ACEgAiABLQDSoQI6ACIgAiABLQDToQI6ACMgAiABLQDUoQI6ACQgAiABLQDVoQI6ACUgAiABLQDWoQI6ACYgAiABLQDXoQI6ACcgAiABLQDYoQI6ACggAiABLQDZoQI6ACkgAiABLQDaoQI6ACogAiABLQDboQI6ACsgAiABLQDcoQI6ACwgAiABLQDdoQI6AC0gAiABLQDeoQI6AC4gAiABLQDfoQI6AC8gAiABLQDgoQI6ADAgAiABLQDhoQI6ADEgAiABLQDioQI6ADIgAiABLQDjoQI6ADMgAiABLQDkoQI6ADQgAiABLQDloQI6ADUgAiABLQDmoQI6ADYgAiABLQDnoQI6ADcgAiABLQDooQI6ADggAiABLQDpoQI6ADkgAiABLQDqoQI6ADogAiABLQDroQI6ADsgAiABLQDsoQI6ADwgAiABLQDtoQI6AD0gAiABLQDuoQI6AD4gAiABLQDvoQI6AD8gAiABLQDQoAI6AEAgAiABLQDRoAI6AEEgAiABLQDSoAI6AEIgAiABLQDToAI6AEMgAiABLQDUoAI6AEQgAiABLQDVoAI6AEUgAiABLQDWoAI6AEYgAiABLQDXoAI6AEcgAiABLQDYoAI6AEggAiABLQDZoAI6AEkgAiABLQDaoAI6AEogAiABLQDboAI6AEsgAiABLQDcoAI6AEwgAiABLQDdoAI6AE0gAiABLQDeoAI6AE4gAiABLQDfoAI6AE8gAiABLQDgoAI6AFAgAiABLQDhoAI6AFEgAiABLQDioAI6AFIgAiABLQDjoAI6AFMgAiABLQDkoAI6AFQgAiABLQDloAI6AFUgAiABLQDmoAI6AFYgAiABLQDnoAI6AFcgAiABLQDooAI6AFggAiABLQDpoAI6AFkgAiABLQDqoAI6AFogAiABLQDroAI6AFsgAiABLQDsoAI6AFwgAiABLQDtoAI6AF0gAiABLQDuoAI6AF4gAiABLQDvoAI6AF8gAkHgAGogAUHQgAFqELsEIAJBwAFqIA4QuwQgAkGgAmogDxC7BCACQYADaiAQELsEIAJB4ANqIAFB0MAAahC7BCACQcAEaiARELsEIAJBoAVqIBIQuwQgAkGABmogExC7BCACQeAGaiABQdAAahC8BCACQYAKaiAEELwEIAJBoA1qIAUQvAQgAkHAEGogCBC8BCAMQaAKNgIAIAtB4BM2AgAgAUHqvSo2AiAgAEHghyogAUEgahCbASABQfChAmokAEEBDwsgAUHysyk2AgQgAUHqvSo2AgAgAEH8iCogARBsAAsgAUHftik2AhQgAUHqvSo2AhAgAEH8iCogAUEQahBsAAv1BwEGfyMAQdABayIFJABBAUHIARAuIgQEQAJ/AkACQCADQYcBTQRAIAVBAEGIAfwLACADQQNxIQgMAQsDQCAEIAQpAwAgAikAAIU3AwAgBCAEKQMIIAIpAAiFNwMIIAQgBCkDECACKQAQhTcDECAEIAQpAxggAikAGIU3AxggBCAEKQMgIAIpACCFNwMgIAQgBCkDKCACKQAohTcDKCAEIAQpAzAgAikAMIU3AzAgBCAEKQM4IAIpADiFNwM4IAQgBCkDQCACKQBAhTcDQCAEIAQpA0ggAikASIU3A0ggBCAEKQNQIAIpAFCFNwNQIAQgBCkDWCACKQBYhTcDWCAEIAQpA2AgAikAYIU3A2AgBCAEKQNoIAIpAGiFNwNoIAQgBCkDcCACKQBwhTcDcCAEIAQpA3ggAikAeIU3A3ggBCAEKQOAASACKQCAAYU3A4ABIAQQ2AQgAkGIAWohAiADIgZBiAFrIgNBhwFLDQALIAVBAEGIAfwLAEEAIANFDQIaIAZBA3EhCEEAIQYgA0EESQ0BCyADQfwBcSEJA0AgBSAGaiACIAZqLQAAOgAAIAUgBkEBciIHaiACIAdqLQAAOgAAIAUgBkECciIHaiACIAdqLQAAOgAAIAUgBkEDciIHaiACIAdqLQAAOgAAIAZBBGoiBiAJRw0ACwsgCARAQQAhBwNAIAUgBmogAiAGai0AADoAACAGQQFqIQYgB0EBaiIHIAhHDQALCyADCyAFakEfOgAAIAUgBS0AhwFBgAFyOgCHASAEIAQpAwAgBSkDAIU3AwAgBCAEKQMIIAUpAwiFNwMIIAQgBCkDECAFKQMQhTcDECAEIAQpAxggBSkDGIU3AxggBCAEKQMgIAUpAyCFNwMgIAQgBCkDKCAFKQMohTcDKCAEIAQpAzAgBSkDMIU3AzAgBCAEKQM4IAUpAziFNwM4IAQgBCkDQCAFKQNAhTcDQCAEIAQpA0ggBSkDSIU3A0ggBCAEKQNQIAUpA1CFNwNQIAQgBCkDWCAFKQNYhTcDWCAEIAQpA2AgBSkDYIU3A2AgBCAEKQNoIAUpA2iFNwNoIAQgBCkDcCAFKQNwhTcDcCAEIAQpA3ggBSkDeIU3A3ggBCAEKQOAASAFKQOAAYU3A4ABIAFBiAFPBEAgBBDYBEEAIQIDQCAAIAJBA3QiBmogBCAGaikDADcAACACQQFqIgJBEUcNAAsLAkAgAUGIAXAiB0UNACAAIAEgB2tqIQMgBBDYBEEAIQIDQCAFIAJBA3QiBmogBCAGaikDADcDACACQQFqIgJBEUcNAAsgB0UNACADIAUgB/wKAAALIAQQKyAFQdABaiQADwtB7wAQAQAL4QEAIAAgAUEAEI0JIABBgAhqIAFBARCNCSAAQYAQaiABQQIQjQkgAEGAGGogAUEDEI0JIABBgCBqIAFBgAIQjQkgAEGAKGogAUGBAhCNCSAAQYAwaiABQYICEI0JIABBgDhqIAFBgwIQjQkgAEGAQGsgAUGABBCNCSAAQYDIAGogAUGBBBCNCSAAQYDQAGogAUGCBBCNCSAAQYDYAGogAUGDBBCNCSAAQYDgAGogAUGABhCNCSAAQYDoAGogAUGBBhCNCSAAQYDwAGogAUGCBhCNCSAAQYD4AGogAUGDBhCNCQuwAwEHfyMAQaABayIFJAAgBUEMaiABIAIQhQkgBUEQakGIASAFKAIMIgdBiAEQhAlBACECA0AgBUEQaiACai0AACIEQQR2IQEgBEEPcSIEQQ9HBEAgACADQQJ0aiAEQc0BbEEKdkEFbCAEa0ECajYCACADQQFqIQMLAkAgAUEPRg0AIANB/wFLDQAgACADQQJ0aiABQc0BbEEKdkEFbCABa0ECajYCACADQQFqIQMLIANB/wFNBEAgAkGHAUkhASACQQFqIQIgAQ0BCwsgA0H/AU0EQANAIAVBEGpBiAEgB0GIARCECUGAAiADayEIIAAgA0ECdGohCUEAIQFBACECA0AgBUEQaiABai0AACIGQQR2IQQgBkEPcSIGQQ9HBEAgCSACQQJ0aiAGQc0BbEEKdkEFbCAGa0ECajYCACACQQFqIQILAkAgBEEPRg0AIAIgCE8NACAJIAJBAnRqIARBzQFsQQp2QQVsIARrQQJqNgIAIAJBAWohAgsgAiAISQRAIAFBhwFJIQQgAUEBaiEBIAQNAQsLIAIgA2oiA0GAAkkNAAsLIAcQKyAFQaABaiQAC9YFAgd/A35BgAEhAQNAQQAhAgNAIAEgAmohBiAFQQFqIgVBAnRB4OAvajQCACIIQoCAgICQgIjAA34hCQNAIAAgAkECdGoiAyABQQJ0aiIEIAMoAgAgCSAENAIAIgp+QiCHQv+/gHx+IAggCn58QiCIpyIEazYCACADIAMoAgAgBGo2AgAgAkEBaiICIAZJDQALIAEgAmoiAkGAAkkNAAsgAUEBSyEDIAFBAXYhASADDQALIABBgAhqIQVBgAEhAQNAQQAhAgNAIAEgAmohBiAHQQFqIgdBAnRB4OAvajQCACIIQoCAgICQgIjAA34hCQNAIAUgAkECdGoiAyABQQJ0aiIEIAMoAgAgCSAENAIAIgp+QiCHQv+/gHx+IAggCn58QiCIpyIEazYCACADIAMoAgAgBGo2AgAgAkEBaiICIAZJDQALIAEgAmoiAkGAAkkNAAsgAUEBSyEDIAFBAXYhASADDQALIABBgBBqIQVBACEHQYABIQEDQEEAIQIDQCABIAJqIQYgB0EBaiIHQQJ0QeDgL2o0AgAiCEKAgICAkICIwAN+IQkDQCAFIAJBAnRqIgMgAUECdGoiBCADKAIAIAkgBDQCACIKfkIgh0L/v4B8fiAIIAp+fEIgiKciBGs2AgAgAyADKAIAIARqNgIAIAJBAWoiAiAGSQ0ACyABIAJqIgJBgAJJDQALIAFBAUshAyABQQF2IQEgAw0ACyAAQYAYaiEAQQAhBUGAASEBA0BBACECA0AgASACaiEGIAVBAWoiBUECdEHg4C9qNAIAIghCgICAgJCAiMADfiEJA0AgACACQQJ0aiIDIAFBAnRqIgQgAygCACAJIAQ0AgAiCn5CIIdC/7+AfH4gCCAKfnxCIIinIgRrNgIAIAMgAygCACAEajYCACACQQFqIgIgBkkNAAsgASACaiICQYACSQ0ACyABQQFLIQMgAUEBdiEBIAMNAAsLmx8CCX8BfiMAQYAIayIGJAADQCAAIAhBAnQiBGogAiAEajQCACABIARqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgACAEQQRyIgRqIAIgBGo0AgAgASAEajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAhBAmoiCEGAAkcNAAsgAUGACGohAyACQYAIaiEIA0AgBiAKQQJ0IgRqIAQgCGo0AgAgAyAEajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAYgBEEEciIEaiAEIAhqNAIAIAMgBGo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAKQQJqIgpBgAJHDQALA0AgACALQQJ0IgRqIgogBCAGaigCACAKKAIAajYCACAAIARBBHIiCmoiAyAGIApqKAIAIAMoAgBqNgIAIAAgBEEIciIKaiIDIAYgCmooAgAgAygCAGo2AgAgACAEQQxyIgRqIgogBCAGaigCACAKKAIAajYCACALQQRqIgtBgAJHDQALIAFBgBBqIQcgAkGAEGohC0EAIQpBACEDA0AgBiADQQJ0IgRqIAQgC2o0AgAgBCAHajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAYgBEEEciIEaiAEIAtqNAIAIAQgB2o0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACADQQJqIgNBgAJHDQALA0AgACAKQQJ0IgRqIgMgBCAGaigCACADKAIAajYCACAAIARBBHIiA2oiByADIAZqKAIAIAcoAgBqNgIAIAAgBEEIciIDaiIHIAMgBmooAgAgBygCAGo2AgAgACAEQQxyIgRqIgMgBCAGaigCACADKAIAajYCACAKQQRqIgpBgAJHDQALIAFBgBhqIQUgAkGAGGohCkEAIQNBACEHA0AgBiAHQQJ0IgRqIAQgCmo0AgAgBCAFajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAYgBEEEciIEaiAEIApqNAIAIAQgBWo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAHQQJqIgdBgAJHDQALA0AgACADQQJ0IgRqIgcgBCAGaigCACAHKAIAajYCACAAIARBBHIiB2oiBSAGIAdqKAIAIAUoAgBqNgIAIAAgBEEIciIHaiIFIAYgB2ooAgAgBSgCAGo2AgAgACAEQQxyIgRqIgcgBCAGaigCACAHKAIAajYCACADQQRqIgNBgAJHDQALIAFBgCBqIQUgAEGACGohBEEAIQcDQCAEIAdBAnQiA2ogAiADajQCACADIAVqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgBCADQQRyIgNqIAIgA2o0AgAgAyAFajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAdBAmoiB0GAAkcNAAsgAUGAKGohCUEAIQdBACEFA0AgBiAFQQJ0IgNqIAMgCGo0AgAgAyAJajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAYgA0EEciIDaiADIAhqNAIAIAMgCWo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAFQQJqIgVBgAJHDQALA0AgBCAHQQJ0IgNqIgUgAyAGaigCACAFKAIAajYCACAEIANBBHIiBWoiCSAFIAZqKAIAIAkoAgBqNgIAIAQgA0EIciIFaiIJIAUgBmooAgAgCSgCAGo2AgAgBCADQQxyIgNqIgUgAyAGaigCACAFKAIAajYCACAHQQRqIgdBgAJHDQALIAFBgDBqIQlBACEHQQAhBQNAIAYgBUECdCIDaiADIAtqNAIAIAMgCWo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAGIANBBHIiA2ogAyALajQCACADIAlqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgBUECaiIFQYACRw0ACwNAIAQgB0ECdCIDaiIFIAMgBmooAgAgBSgCAGo2AgAgBCADQQRyIgVqIgkgBSAGaigCACAJKAIAajYCACAEIANBCHIiBWoiCSAFIAZqKAIAIAkoAgBqNgIAIAQgA0EMciIDaiIFIAMgBmooAgAgBSgCAGo2AgAgB0EEaiIHQYACRw0ACyABQYA4aiEJQQAhB0EAIQUDQCAGIAVBAnQiA2ogAyAKajQCACADIAlqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgBiADQQRyIgNqIAMgCmo0AgAgAyAJajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAVBAmoiBUGAAkcNAAsDQCAEIAdBAnQiA2oiBSADIAZqKAIAIAUoAgBqNgIAIAQgA0EEciIFaiIJIAUgBmooAgAgCSgCAGo2AgAgBCADQQhyIgVqIgkgBSAGaigCACAJKAIAajYCACAEIANBDHIiA2oiBSADIAZqKAIAIAUoAgBqNgIAIAdBBGoiB0GAAkcNAAsgAUGAQGshBSAAQYAQaiEEQQAhBwNAIAQgB0ECdCIDaiACIANqNAIAIAMgBWo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAEIANBBHIiA2ogAiADajQCACADIAVqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgB0ECaiIHQYACRw0ACyABQYDIAGohCUEAIQdBACEFA0AgBiAFQQJ0IgNqIAMgCGo0AgAgAyAJajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAYgA0EEciIDaiADIAhqNAIAIAMgCWo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAFQQJqIgVBgAJHDQALA0AgBCAHQQJ0IgNqIgUgAyAGaigCACAFKAIAajYCACAEIANBBHIiBWoiCSAFIAZqKAIAIAkoAgBqNgIAIAQgA0EIciIFaiIJIAUgBmooAgAgCSgCAGo2AgAgBCADQQxyIgNqIgUgAyAGaigCACAFKAIAajYCACAHQQRqIgdBgAJHDQALIAFBgNAAaiEJQQAhB0EAIQUDQCAGIAVBAnQiA2ogAyALajQCACADIAlqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgBiADQQRyIgNqIAMgC2o0AgAgAyAJajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAVBAmoiBUGAAkcNAAsDQCAEIAdBAnQiA2oiBSADIAZqKAIAIAUoAgBqNgIAIAQgA0EEciIFaiIJIAUgBmooAgAgCSgCAGo2AgAgBCADQQhyIgVqIgkgBSAGaigCACAJKAIAajYCACAEIANBDHIiA2oiBSADIAZqKAIAIAUoAgBqNgIAIAdBBGoiB0GAAkcNAAsgAUGA2ABqIQlBACEHQQAhBQNAIAYgBUECdCIDaiADIApqNAIAIAMgCWo0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAGIANBBHIiA2ogAyAKajQCACADIAlqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgBUECaiIFQYACRw0ACwNAIAQgB0ECdCIDaiIFIAMgBmooAgAgBSgCAGo2AgAgBCADQQRyIgVqIgkgBSAGaigCACAJKAIAajYCACAEIANBCHIiBWoiCSAFIAZqKAIAIAkoAgBqNgIAIAQgA0EMciIDaiIFIAMgBmooAgAgBSgCAGo2AgAgB0EEaiIHQYACRw0ACyABQYDgAGohByAAQYAYaiEAQQAhAwNAIAAgA0ECdCIEaiACIARqNAIAIAQgB2o0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAAIARBBHIiBGogAiAEajQCACAEIAdqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgA0ECaiIDQYACRw0ACyABQYDoAGohB0EAIQJBACEDA0AgBiADQQJ0IgRqIAQgCGo0AgAgBCAHajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAYgBEEEciIEaiAEIAhqNAIAIAQgB2o0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACADQQJqIgNBgAJHDQALA0AgACACQQJ0IgRqIgggBCAGaigCACAIKAIAajYCACAAIARBBHIiCGoiAyAGIAhqKAIAIAMoAgBqNgIAIAAgBEEIciIIaiIDIAYgCGooAgAgAygCAGo2AgAgACAEQQxyIgRqIgggBCAGaigCACAIKAIAajYCACACQQRqIgJBgAJHDQALIAFBgPAAaiEDQQAhAkEAIQgDQCAGIAhBAnQiBGogBCALajQCACADIARqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgBiAEQQRyIgRqIAQgC2o0AgAgAyAEajQCAH4iDEKAgICAkICIwAN+QiCHQv+/gHx+IAx8QiCIPgIAIAhBAmoiCEGAAkcNAAsDQCAAIAJBAnQiBGoiCCAEIAZqKAIAIAgoAgBqNgIAIAAgBEEEciIIaiILIAYgCGooAgAgCygCAGo2AgAgACAEQQhyIghqIgsgBiAIaigCACALKAIAajYCACAAIARBDHIiBGoiCCAEIAZqKAIAIAgoAgBqNgIAIAJBBGoiAkGAAkcNAAsgAUGA+ABqIQtBACECQQAhCANAIAYgCEECdCIEaiAEIApqNAIAIAQgC2o0AgB+IgxCgICAgJCAiMADfkIgh0L/v4B8fiAMfEIgiD4CACAGIARBBHIiBGogBCAKajQCACAEIAtqNAIAfiIMQoCAgICQgIjAA35CIIdC/7+AfH4gDHxCIIg+AgAgCEECaiIIQYACRw0ACwNAIAAgAkECdCIEaiIIIAQgBmooAgAgCCgCAGo2AgAgACAEQQRyIghqIgsgBiAIaigCACALKAIAajYCACAAIARBCHIiCGoiCyAGIAhqKAIAIAsoAgBqNgIAIAAgBEEMciIEaiIIIAQgBmooAgAgCCgCAGo2AgAgAkEEaiICQYACRw0ACyAGQYAIaiQAC+4JAgh/A35BASEDQYACIQYDQEEAIQEDQCABIANqIQdBACAGQQFrIgZBAnRB4OAvaigCAGusIgpCgICAgJCAiMADfiELA0AgACABQQJ0aiICIAIgA0ECdGoiBCgCACIFIAIoAgAiAmo2AgAgBCALIAIgBWusIgl+QiCHQv+/gHx+IAkgCn58QiCIPgIAIAFBAWoiASAHSQ0ACyABIANqIgFBgAJJDQALIANBgAFJIQEgA0EBdCEDIAENAAsgAEEEaiEFQQAhAQNAIAAgAUECdCICaiIEIAQ0AgAiCUKAgICAoP/4v39+QiCHQv+/gHx+IAlC+scCfnxCIIg+AgAgAiAFaiICIAI0AgAiCUKAgICAoP/4v39+QiCHQv+/gHx+IAlC+scCfnxCIIg+AgAgAUECaiIBQYACRw0ACyAAQYAIaiEGQQEhA0GAAiEIA0BBACEBA0AgASADaiEHQQAgCEEBayIIQQJ0QeDgL2ooAgBrrCIKQoCAgICQgIjAA34hCwNAIAYgAUECdGoiAiACIANBAnRqIgQoAgAiBSACKAIAIgJqNgIAIAQgCyACIAVrrCIJfkIgh0L/v4B8fiAJIAp+fEIgiD4CACABQQFqIgEgB0kNAAsgASADaiIBQYACSQ0ACyADQYABSSEBIANBAXQhAyABDQALIAZBBGohBUEAIQEDQCAGIAFBAnQiAmoiBCAENAIAIglCgICAgKD/+L9/fkIgh0L/v4B8fiAJQvrHAn58QiCIPgIAIAIgBWoiAiACNAIAIglCgICAgKD/+L9/fkIgh0L/v4B8fiAJQvrHAn58QiCIPgIAIAFBAmoiAUGAAkcNAAsgAEGAEGohBkEBIQNBgAIhCANAQQAhAQNAIAEgA2ohB0EAIAhBAWsiCEECdEHg4C9qKAIAa6wiCkKAgICAkICIwAN+IQsDQCAGIAFBAnRqIgIgAiADQQJ0aiIEKAIAIgUgAigCACICajYCACAEIAsgAiAFa6wiCX5CIIdC/7+AfH4gCSAKfnxCIIg+AgAgAUEBaiIBIAdJDQALIAEgA2oiAUGAAkkNAAsgA0GAAUkhASADQQF0IQMgAQ0ACyAGQQRqIQVBACEBA0AgBiABQQJ0IgJqIgQgBDQCACIJQoCAgICg//i/f35CIIdC/7+AfH4gCUL6xwJ+fEIgiD4CACACIAVqIgIgAjQCACIJQoCAgICg//i/f35CIIdC/7+AfH4gCUL6xwJ+fEIgiD4CACABQQJqIgFBgAJHDQALIABBgBhqIQBBASEDQYACIQYDQEEAIQEDQCABIANqIQdBACAGQQFrIgZBAnRB4OAvaigCAGusIgpCgICAgJCAiMADfiELA0AgACABQQJ0aiICIAIgA0ECdGoiBCgCACIFIAIoAgAiAmo2AgAgBCALIAIgBWusIgl+QiCHQv+/gHx+IAkgCn58QiCIPgIAIAFBAWoiASAHSQ0ACyABIANqIgFBgAJJDQALIANBgAFJIQEgA0EBdCEDIAENAAsgAEEEaiEFQQAhAQNAIAAgAUECdCICaiIEIAQ0AgAiCUKAgICAoP/4v39+QiCHQv+/gHx+IAlC+scCfnxCIIg+AgAgAiAFaiICIAI0AgAiCUKAgICAoP/4v39+QiCHQv+/gHx+IAlC+scCfnxCIIg+AgAgAUECaiIBQYACRw0ACwuIAwEFfwNAIAAgBEECdCIDaiACIANqKAIAIAEgA2ooAgBqNgIAIAAgA0EEciIDaiACIANqKAIAIAEgA2ooAgBqNgIAIARBAmoiBEGAAkcNAAsgAkGACGohBSABQYAIaiEGIABBgAhqIQdBACEEA0AgByAEQQJ0IgNqIAMgBWooAgAgAyAGaigCAGo2AgAgByADQQRyIgNqIAMgBWooAgAgAyAGaigCAGo2AgAgBEECaiIEQYACRw0ACyACQYAQaiEFIAFBgBBqIQYgAEGAEGohB0EAIQQDQCAHIARBAnQiA2ogAyAFaigCACADIAZqKAIAajYCACAHIANBBHIiA2ogAyAFaigCACADIAZqKAIAajYCACAEQQJqIgRBgAJHDQALIAJBgBhqIQIgAUGAGGohASAAQYAYaiEAQQAhBANAIAAgBEECdCIDaiACIANqKAIAIAEgA2ooAgBqNgIAIAAgA0EEciIDaiACIANqKAIAIAEgA2ooAgBqNgIAIARBAmoiBEGAAkcNAAsLpwcBBn8gACABLQAAOgAAIAAgAS0AAToAASAAIAEtAAI6AAIgACABLQADOgADIAAgAS0ABDoABCAAIAEtAAU6AAUgACABLQAGOgAGIAAgAS0ABzoAByAAIAEtAAg6AAggACABLQAJOgAJIAAgAS0ACjoACiAAIAEtAAs6AAsgACABLQAMOgAMIAAgAS0ADToADSAAIAEtAA46AA4gACABLQAPOgAPIAAgAS0AEDoAECAAIAEtABE6ABEgACABLQASOgASIAAgAS0AEzoAEyAAIAEtABQ6ABQgACABLQAVOgAVIAAgAS0AFjoAFiAAIAEtABc6ABcgACABLQAYOgAYIAAgAS0AGToAGSAAIAEtABo6ABogACABLQAbOgAbIAAgAS0AHDoAHCAAIAEtAB06AB0gACABLQAeOgAeIAAgAS0AHzoAHyAAQSBqIQcDQCAHIARBBWxqIgEgAiAEQQR0aiIDKAIAOgAAIAEgA0EEaiIFKAIAQQJ0IAMoAgBBCHZyOgABIAEgA0EIaiIGKAIAQQR0IAUoAgBBBnZyOgACIAEgA0EMaiIDKAIAQQZ0IAYoAgBBBHZyOgADIAEgAygCAEECdjoABCAEQQFqIgRBwABHDQALIAJBgAhqIQcgAEHgAmohCEEAIQQDQCAIIARBBWxqIgEgByAEQQR0aiIDKAIAOgAAIAEgA0EEaiIFKAIAQQJ0IAMoAgBBCHZyOgABIAEgA0EIaiIGKAIAQQR0IAUoAgBBBnZyOgACIAEgA0EMaiIDKAIAQQZ0IAYoAgBBBHZyOgADIAEgAygCAEECdjoABCAEQQFqIgRBwABHDQALIAJBgBBqIQcgAEGgBWohCEEAIQQDQCAIIARBBWxqIgEgByAEQQR0aiIDKAIAOgAAIAEgA0EEaiIFKAIAQQJ0IAMoAgBBCHZyOgABIAEgA0EIaiIGKAIAQQR0IAUoAgBBBnZyOgACIAEgA0EMaiIDKAIAQQZ0IAYoAgBBBHZyOgADIAEgAygCAEECdjoABCAEQQFqIgRBwABHDQALIAJBgBhqIQIgAEHgB2ohAEEAIQQDQCAAIARBBWxqIgEgAiAEQQR0aiIDKAIAOgAAIAEgA0EEaiIFKAIAQQJ0IAMoAgBBCHZyOgABIAEgA0EIaiIGKAIAQQR0IAUoAgBBBnZyOgACIAEgA0EMaiIDKAIAQQZ0IAYoAgBBBHZyOgADIAEgAygCAEECdjoABCAEQQFqIgRBwABHDQALC7kBAQh/A0AgASADQQV0aiICKAIQIQYgAigCDCEHIAIoAhwhCCACKAIUIQQgAigCGCEJIAAgA0EDbGoiBUEQIAIoAgRBA3RrQQIgAigCAGtyQQIgAigCCGsiAkEGdHI6AAAgBUHAACAIQQV0a0EIIAlBAnRrQQIgBGsiBEH+AXFBAXZycjoAAiAFQSAgBkEEdGtBBCAHQQF0ayACQfwBcUECdnJyIARBB3RyOgABIANBAWoiA0EgRw0ACwuwAgELfwNAIAEgBEEFdGoiAigCCCEJIAIoAhQhCiACKAIEIQUgAigCDCEGIAIoAhAhByACKAIYIQsgAigCHCEIIAAgBEENbGoiA0GAICACKAIAayIMOgAAIANBgCAgCGsiCEEFdjoADCADQYAgIAtrIgJBAnY6AAogA0GAICAHayIHQQR2OgAHIANBgCAgBmsiBkEBdjoABSADQYAgIAVrIgVBA3Y6AAIgAyAIQQN0IAJBCnZyOgALIAMgAkEGdEGAICAKayICQQd2cjoACSADIAJBAXQgB0EMdnI6AAggAyAHQQR0IAZBCXZyOgAGIAMgBkEHdEGAICAJayICQQZ2cjoABCADIAJBAnQgBUELdnI6AAMgAyAFQQV0IAxBCHZyOgABIARBAWoiBEEgRw0ACwuNDgEMfyMAQaCBAmsiAyQAIANB8b4qNgIwIABB+YYqIANBMGoQmwECQCAAQQEQyAEiCQRAIABBoAoQhgEiC0UNASALKAIIIQwgA0GAgQJqIANBwIACaiADQeCAAmogA0HAoAFqIANBQGsgA0HA4AFqIAkoAggQvgQgA0HAIGogA0GAgQJqELQEIANBQGsQtgQgA0HAwAFqIANBwCBqIANBQGsQtwQDQCADQcDAAWogAUECdGoiBSAFKAIAIgdBgICAAmpBF3VB/7+AfGwgB2o2AgAgBUEEaiIFIAUoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCACABQQJqIgFBgAJHDQALIANBwMgBaiEFQQAhAQNAIAUgAUECdGoiByAHKAIAIghBgICAAmpBF3VB/7+AfGwgCGo2AgAgB0EEaiIHIAcoAgAiB0GAgIACakEXdUH/v4B8bCAHajYCACABQQJqIgFBgAJHDQALIANBwNABaiEHQQAhAQNAIAcgAUECdGoiCCAIKAIAIgRBgICAAmpBF3VB/7+AfGwgBGo2AgAgCEEEaiIIIAgoAgAiCEGAgIACakEXdUH/v4B8bCAIajYCACABQQJqIgFBgAJHDQALIANBwNgBaiEIQQAhAQNAIAggAUECdGoiBCAEKAIAIgJBgICAAmpBF3VB/7+AfGwgAmo2AgAgBEEEaiIEIAQoAgAiBEGAgIACakEXdUH/v4B8bCAEajYCACABQQJqIgFBgAJHDQALIANBwMABahC4BCADQcDAAWogA0HAwAFqIANBwOABahC5BEEAIQRBACECA0AgA0HAwAFqIAJBAnRqIgEgASgCACIGQR91QYHA/wNxIAZqNgIAIAFBBGoiBiAGKAIAIgZBH3VBgcD/A3EgBmo2AgAgAUEIaiIGIAYoAgAiBkEfdUGBwP8DcSAGajYCACABQQxqIgEgASgCACIBQR91QYHA/wNxIAFqNgIAIAJBBGoiAkGAAkcNAAsDQCAFIARBAnRqIgEgASgCACICQR91QYHA/wNxIAJqNgIAIAFBBGoiAiACKAIAIgJBH3VBgcD/A3EgAmo2AgAgAUEIaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACABQQxqIgEgASgCACIBQR91QYHA/wNxIAFqNgIAIARBBGoiBEGAAkcNAAtBACEEA0AgByAEQQJ0aiIBIAEoAgAiAkEfdUGBwP8DcSACajYCACABQQRqIgIgAigCACICQR91QYHA/wNxIAJqNgIAIAFBCGoiAiACKAIAIgJBH3VBgcD/A3EgAmo2AgAgAUEMaiIBIAEoAgAiAUEfdUGBwP8DcSABajYCACAEQQRqIgRBgAJHDQALQQAhBANAIAggBEECdGoiASABKAIAIgJBH3VBgcD/A3EgAmo2AgAgAUEEaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACABQQhqIgIgAigCACICQR91QYHA/wNxIAJqNgIAIAFBDGoiASABKAIAIgFBH3VBgcD/A3EgAWo2AgAgBEEEaiIEQYACRw0AC0EAIQEDQCABQQJ0IgQgA0HAwAFqaiICIAIoAgAiAkH/H2oiBkENdTYCACADQcCgAWogBGogAiAGQYBAcWs2AgAgBEEEciIEIANBwMABamoiAiACKAIAIgJB/x9qIgZBDXU2AgAgA0HAoAFqIARqIAIgBkGAQHFrNgIAIAFBAmoiAUGAAkcNAAsgA0HAqAFqIQJBACEBA0AgAiABQQJ0IgRqIAQgBWoiBigCACIKIApB/x9qIgpBgEBxazYCACAGIApBDXU2AgAgAiAEQQRyIgRqIAQgBWoiBCgCACIGIAZB/x9qIgZBgEBxazYCACAEIAZBDXU2AgAgAUECaiIBQYACRw0ACyADQcCwAWohBEEAIQEDQCAEIAFBAnQiBWogBSAHaiICKAIAIgYgBkH/H2oiBkGAQHFrNgIAIAIgBkENdTYCACAEIAVBBHIiBWogBSAHaiIFKAIAIgIgAkH/H2oiAkGAQHFrNgIAIAUgAkENdTYCACABQQJqIgFBgAJHDQALIANBwLgBaiEHQQAhAQNAIAcgAUECdCIFaiAFIAhqIgQoAgAiAiACQf8faiICQYBAcWs2AgAgBCACQQ11NgIAIAcgBUEEciIFaiAFIAhqIgUoAgAiBCAEQf8faiIEQYBAcWs2AgAgBSAEQQ11NgIAIAFBAmoiAUGAAkcNAAsgDCADQYCBAmogA0HAwAFqELoEIAtBoAo2AgAgCRCaASADQfG+KjYCICAAQeCHKiADQSBqEJsBIANBoIECaiQAQQEPCyADQaOxKTYCBCADQfG+KjYCACAAQfyIKiADEGwACyAJEJoBIANB/bUpNgIUIANB8b4qNgIQIABB/IgqIANBEGoQbAAL6ggAIAAgBi0AADoAACAAIAYtAAE6AAEgACAGLQACOgACIAAgBi0AAzoAAyAAIAYtAAQ6AAQgACAGLQAFOgAFIAAgBi0ABjoABiAAIAYtAAc6AAcgACAGLQAIOgAIIAAgBi0ACToACSAAIAYtAAo6AAogACAGLQALOgALIAAgBi0ADDoADCAAIAYtAA06AA0gACAGLQAOOgAOIAAgBi0ADzoADyAAIAYtABA6ABAgACAGLQAROgARIAAgBi0AEjoAEiAAIAYtABM6ABMgACAGLQAUOgAUIAAgBi0AFToAFSAAIAYtABY6ABYgACAGLQAXOgAXIAAgBi0AGDoAGCAAIAYtABk6ABkgACAGLQAaOgAaIAAgBi0AGzoAGyAAIAYtABw6ABwgACAGLQAdOgAdIAAgBi0AHjoAHiAAIAYtAB86AB8gAiAGLQAgOgAAIAIgBi0AIToAASACIAYtACI6AAIgAiAGLQAjOgADIAIgBi0AJDoABCACIAYtACU6AAUgAiAGLQAmOgAGIAIgBi0AJzoAByACIAYtACg6AAggAiAGLQApOgAJIAIgBi0AKjoACiACIAYtACs6AAsgAiAGLQAsOgAMIAIgBi0ALToADSACIAYtAC46AA4gAiAGLQAvOgAPIAIgBi0AMDoAECACIAYtADE6ABEgAiAGLQAyOgASIAIgBi0AMzoAEyACIAYtADQ6ABQgAiAGLQA1OgAVIAIgBi0ANjoAFiACIAYtADc6ABcgAiAGLQA4OgAYIAIgBi0AOToAGSACIAYtADo6ABogAiAGLQA7OgAbIAIgBi0APDoAHCACIAYtAD06AB0gAiAGLQA+OgAeIAIgBi0APzoAHyABIAYtAEA6AAAgASAGLQBBOgABIAEgBi0AQjoAAiABIAYtAEM6AAMgASAGLQBEOgAEIAEgBi0ARToABSABIAYtAEY6AAYgASAGLQBHOgAHIAEgBi0ASDoACCABIAYtAEk6AAkgASAGLQBKOgAKIAEgBi0ASzoACyABIAYtAEw6AAwgASAGLQBNOgANIAEgBi0ATjoADiABIAYtAE86AA8gASAGLQBQOgAQIAEgBi0AUToAESABIAYtAFI6ABIgASAGLQBTOgATIAEgBi0AVDoAFCABIAYtAFU6ABUgASAGLQBWOgAWIAEgBi0AVzoAFyABIAYtAFg6ABggASAGLQBZOgAZIAEgBi0AWjoAGiABIAYtAFs6ABsgASAGLQBcOgAcIAEgBi0AXToAHSABIAYtAF46AB4gASAGLQBfOgAfIAQgBkHgAGoQjgkgBEGACGogBkHAAWoQjgkgBEGAEGogBkGgAmoQjgkgBEGAGGogBkGAA2oQjgkgBSAGQeADahCOCSAFQYAIaiAGQcAEahCOCSAFQYAQaiAGQaAFahCOCSAFQYAYaiAGQYAGahCOCSADIAZB4AZqEI8JIANBgAhqIAZBgApqEI8JIANBgBBqIAZBoA1qEI8JIANBgBhqIAZBwBBqEI8JC5YBAQJ/IwBBMGsiASQAIAFBvdcqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUH9tSk2AgQgAUG91yo2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGgCkYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFBvdcqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQEL3wEBBX8jAEEwayIBJAAgAUHBuio2AiAgAEH5hiogAUEgahCbAQJ/IABBARDIASIERQRAQaOxKQwBCyAAQQIQyAEiAkUEQEEAIQJBjp8rDAELQfffKiAEKAIAQeATRw0AGkHAhysgAEH0EhCGASIDRQ0AGiADKAIIIAMgAigCCCACKAIAIAQoAggQwQRBASEFQQALIQMgAhCaASAEEJoBIAVFBEAgASADNgIUIAFBwboqNgIQIABB/IgqIAFBEGoQbAALIAFBwboqNgIAIABB4IcqIAEQmwEgAUEwaiQAQQEL1TwCHn8DfiMAQaCPA2siBiQAIAZBgIgDaiAGQaCIA2oiBSAGQcCIA2oiByAGQYCIAWogBkGA6AFqIAZBgOgAaiAEEL4EAkBB0AEQKiIEBEAgBEEAQdAB/AsAIARBiAEgBUEgEIMJIARBiAEgAiADEIMJIAQgBCkDyAEiI6dBeHFqIgMgAykDAEIfICNCA4aGhTcDACAEQgA3A8gBIAQgBCkDgAFCgICAgICAgICAf4U3A4ABIAZB4IgDaiIeQcAAIARBiAEQhAkgBBArIAZBoIkDaiIQQcAAIAdB4AAQswQgBkGAiAJqIAZBgIgDahC0BCAGQYDoAWoQtgQgBkGA6ABqELYEIAZBgIgBahC2BCAGQYTAAWohHyAGQYS4AWohICAGQYSwAWohISAGQYSoAWohIiAGQYAgaiERIAZBgBhqIRIgBkGAEGohEyAGQYCAAmohGyAGQYDAAWohDCAGQYD4AWohHCAGQYC4AWohCiAGQYDwAWohHSAGQYCwAWohCyAGQYBAayEYIAZBgDhqIRkgBkGAMGohGiAGQYDgAGohFCAGQYDYAGohFSAGQYDQAGohFiAGQYDgAWohDSAGQYDYAWohDiAGQYDQAWohDwNAIAZB7IkDaiAQIBdBAnQiBEH8/wNxEIUJIAZB8IkDakGoBSAGKALsiQMiA0GIARCECSADECsgBkGAyAFqIAZB8IkDahCGCSAGQeyJA2ogECAEQQFyQf3/A3EQhQkgBkHwiQNqQagFIAYoAuyJAyIDQYgBEIQJIAMQKyAPIAZB8IkDahCGCSAGQeyJA2ogECAEQQJyQf7/A3EQhQkgBkHwiQNqQagFIAYoAuyJAyIDQYgBEIQJIAMQKyAOIAZB8IkDahCGCSAGQeyJA2ogECAEQQNyQf//A3EQhQkgBkHwiQNqQagFIAYoAuyJAyIEQYgBEIQJIAQQKyANIAZB8IkDahCGCSAGQYCoAWogBkGAyAFqQYAg/AoAACAGQYCoAWoQtgQgBkGAyABqIAZBgIgCaiAGQYCoAWoQtwRBACEDQQAhBANAIAZBgMgAaiAEQQJ0aiICIAIoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCACACQQRqIgIgAigCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIARBAmoiBEGAAkcNAAsDQCAWIANBAnRqIgQgBCgCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIARBBGoiBCAEKAIAIgRBgICAAmpBF3VB/7+AfGwgBGo2AgBBACEEIANBAmoiA0GAAkcNAAtBACEDA0AgFSADQQJ0aiICIAIoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCACACQQRqIgIgAigCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIANBAmoiA0GAAkcNAAsDQCAUIARBAnRqIgMgAygCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIANBBGoiAyADKAIAIgNBgICAAmpBF3VB/7+AfGwgA2o2AgAgBEECaiIEQYACRw0ACyAGQYDIAGoQuARBACECQQAhAwNAIAZBgMgAaiADQQJ0aiIEIAQoAgAiBUEfdUGBwP8DcSAFajYCACAEQQRqIgUgBSgCACIFQR91QYHA/wNxIAVqNgIAIARBCGoiBSAFKAIAIgVBH3VBgcD/A3EgBWo2AgAgBEEMaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCACADQQRqIgNBgAJHDQALA0AgFiACQQJ0aiIEIAQoAgAiA0EfdUGBwP8DcSADajYCACAEQQRqIgMgAygCACIDQR91QYHA/wNxIANqNgIAIARBCGoiAyADKAIAIgNBH3VBgcD/A3EgA2o2AgAgBEEMaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCAEEAIQMgAkEEaiICQYACRw0AC0EAIQIDQCAVIAJBAnRqIgQgBCgCACIFQR91QYHA/wNxIAVqNgIAIARBBGoiBSAFKAIAIgVBH3VBgcD/A3EgBWo2AgAgBEEIaiIFIAUoAgAiBUEfdUGBwP8DcSAFajYCACAEQQxqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIAJBBGoiAkGAAkcNAAsDQCAUIANBAnRqIgQgBCgCACICQR91QYHA/wNxIAJqNgIAIARBBGoiAiACKAIAIgJBH3VBgcD/A3EgAmo2AgAgBEEIaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACAEQQxqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAQQAhBCADQQRqIgNBgAJHDQALQQAhAwNAIANBAnQiAiAGQYDIAGpqIgUgBSgCACIFQf8AakEHdUGL2ABsQYCAgARqQRh1IgdBACAHQStMGyIHNgIAIAZBgChqIAJqQf+/gHxBACAFIAdBgLB0bGoiAkGA4P8BShsgAmo2AgAgA0EBaiIDQYACRw0ACwNAQQAhAyAaIARBAnQiAmpB/7+AfEEAIAIgFmoiAigCACIFQf8AakEHdUGL2ABsQYCAgARqQRh1IgdBACAHQStMGyIHQYCwdGwgBWoiBUGA4P8BShsgBWo2AgAgAiAHNgIAIARBAWoiBEGAAkcNAAtBACEEA0AgGSAEQQJ0IgJqQf+/gHxBACACIBVqIgIoAgAiBUH/AGpBB3VBi9gAbEGAgIAEakEYdSIHQQAgB0ErTBsiB0GAsHRsIAVqIgVBgOD/AUobIAVqNgIAIAIgBzYCACAEQQFqIgRBgAJHDQALA0AgGCADQQJ0IgRqQf+/gHxBACAEIBRqIgQoAgAiAkH/AGpBB3VBi9gAbEGAgIAEakEYdSIFQQAgBUErTBsiBUGAsHRsIAJqIgJBgOD/AUobIAJqNgIAIAQgBTYCACADQQFqIgNBgAJHDQALIAAgBkGAyABqEIcJQdABECoiBEUNAkEAIQggBEEAQdAB/AsAIBdBAWohFyAEQYgBIB5BwAAQgwkgBEGIASAAQYAGEIMJIAQgBCkDyAEiI6dBeHFqIgMgAykDAEIfICNCA4aGhTcDACAEQgA3A8gBIAQgBCkDgAFCgICAgICAgICAf4U3A4ABIABBICAEQYgBEIQJIAQQKyAGIAAQiAlBgAEhBQNAQQAhAwNAIAMgBWohByAIQQFqIghBAnRB4OAvajQCACIkQoCAgICQgIjAA34hJQNAIAYgA0ECdGoiBCAFQQJ0aiICIAQoAgAgJSACNAIAIiN+QiCHQv+/gHx+ICMgJH58QiCIpyICazYCACAEIAQoAgAgAmo2AgAgA0EBaiIDIAdJDQALIAMgBWoiA0GAAkkNAAsgBUEBSyEDQQAhBCAFQQF2IQUgAw0AC0EAIQIDQCACQQJ0IgMgBkGAqAFqaiAGQYDoAWogA2o0AgAgAyAGajQCAH4iI0KAgICAkICIwAN+QiCHQv+/gHx+ICN8QiCIPgIAIANBBHIiAyAGQYCoAWpqIAZBgOgBaiADajQCACADIAZqNAIAfiIjQoCAgICQgIjAA35CIIdC/7+AfH4gI3xCIIg+AgAgAkECaiICQYACRw0ACwNAIAsgBEECdCIDaiADIB1qNAIAIAMgBmo0AgB+IiNCgICAgJCAiMADfkIgh0L/v4B8fiAjfEIgiD4CACALIANBBHIiA2ogAyAdajQCACADIAZqNAIAfiIjQoCAgICQgIjAA35CIIdC/7+AfH4gI3xCIIg+AgBBACEDIARBAmoiBEGAAkcNAAtBACECA0AgCiACQQJ0IgRqIAQgHGo0AgAgBCAGajQCAH4iI0KAgICAkICIwAN+QiCHQv+/gHx+ICN8QiCIPgIAIAogBEEEciIEaiAEIBxqNAIAIAQgBmo0AgB+IiNCgICAgJCAiMADfkIgh0L/v4B8fiAjfEIgiD4CACACQQJqIgJBgAJHDQALA0AgDCADQQJ0IgRqIAQgG2o0AgAgBCAGajQCAH4iI0KAgICAkICIwAN+QiCHQv+/gHx+ICN8QiCIPgIAIAwgBEEEciIEaiAEIBtqNAIAIAQgBmo0AgB+IiNCgICAgJCAiMADfkIgh0L/v4B8fiAjfEIgiD4CAEGAAiEJIANBAmoiA0GAAkcNAAtBASEHA0BBACEEA0AgBCAHaiEIQQAgCUEBayIJQQJ0QeDgL2ooAgBrrCIkQoCAgICQgIjAA34hJQNAIAZBgKgBaiAEQQJ0aiIDIAMgB0ECdGoiAigCACIFIAMoAgAiA2o2AgAgAiAlIAMgBWusIiN+QiCHQv+/gHx+ICMgJH58QiCIPgIAIARBAWoiBCAISQ0ACyAEIAdqIgRBgAJJDQALIAdBgAFJIQNBACEEIAdBAXQhByADDQALA0AgBEECdCIDIAZBgKgBamoiAiACNAIAIiNCgICAgKD/+L9/fkIgh0L/v4B8fiAjQvrHAn58QiCIPgIAIAMgImoiAyADNAIAIiNCgICAgKD/+L9/fkIgh0L/v4B8fiAjQvrHAn58QiCIPgIAQYACIQkgBEECaiIEQYACRw0AC0EBIQcDQEEAIQQDQCAEIAdqIQhBACAJQQFrIglBAnRB4OAvaigCAGusIiRCgICAgJCAiMADfiElA0AgCyAEQQJ0aiIDIAMgB0ECdGoiAigCACIFIAMoAgAiA2o2AgAgAiAlIAMgBWusIiN+QiCHQv+/gHx+ICMgJH58QiCIPgIAIARBAWoiBCAISQ0ACyAEIAdqIgRBgAJJDQALIAdBgAFJIQNBACEEIAdBAXQhByADDQALA0AgCyAEQQJ0IgNqIgIgAjQCACIjQoCAgICg//i/f35CIIdC/7+AfH4gI0L6xwJ+fEIgiD4CACADICFqIgMgAzQCACIjQoCAgICg//i/f35CIIdC/7+AfH4gI0L6xwJ+fEIgiD4CAEGAAiEJIARBAmoiBEGAAkcNAAtBASEHA0BBACEEA0AgBCAHaiEIQQAgCUEBayIJQQJ0QeDgL2ooAgBrrCIkQoCAgICQgIjAA34hJQNAIAogBEECdGoiAyADIAdBAnRqIgIoAgAiBSADKAIAIgNqNgIAIAIgJSADIAVrrCIjfkIgh0L/v4B8fiAjICR+fEIgiD4CACAEQQFqIgQgCEkNAAsgBCAHaiIEQYACSQ0ACyAHQYABSSEDQQAhBCAHQQF0IQcgAw0ACwNAIAogBEECdCIDaiICIAI0AgAiI0KAgICAoP/4v39+QiCHQv+/gHx+ICNC+scCfnxCIIg+AgAgAyAgaiIDIAM0AgAiI0KAgICAoP/4v39+QiCHQv+/gHx+ICNC+scCfnxCIIg+AgBBgAIhCSAEQQJqIgRBgAJHDQALQQEhBwNAQQAhBANAIAQgB2ohCEEAIAlBAWsiCUECdEHg4C9qKAIAa6wiJEKAgICAkICIwAN+ISUDQCAMIARBAnRqIgMgAyAHQQJ0aiICKAIAIgUgAygCACIDajYCACACICUgAyAFa6wiI35CIIdC/7+AfH4gIyAkfnxCIIg+AgAgBEEBaiIEIAhJDQALIAQgB2oiBEGAAkkNAAsgB0GAAUkhBEEAIQMgB0EBdCEHIAQNAAtBACEEA0AgDCAEQQJ0IgJqIgUgBTQCACIjQoCAgICg//i/f35CIIdC/7+AfH4gI0L6xwJ+fEIgiD4CACACIB9qIgIgAjQCACIjQoCAgICg//i/f35CIIdC/7+AfH4gI0L6xwJ+fEIgiD4CACAEQQJqIgRBgAJHDQALA0AgA0ECdCIEIAZBgKgBamoiAiAGQYDIAWogBGooAgAgAigCAGo2AgAgBEEEciICIAZBgKgBamoiBSAGQYDIAWogAmooAgAgBSgCAGo2AgAgBEEIciICIAZBgKgBamoiBSAGQYDIAWogAmooAgAgBSgCAGo2AgAgBEEMciIEIAZBgKgBamoiAiAGQYDIAWogBGooAgAgAigCAGo2AgBBACECIANBBGoiA0GAAkcNAAtBACEDA0AgCyADQQJ0IgRqIgUgBCAPaigCACAFKAIAajYCACALIARBBHIiBWoiByAFIA9qKAIAIAcoAgBqNgIAIAsgBEEIciIFaiIHIAUgD2ooAgAgBygCAGo2AgAgCyAEQQxyIgRqIgUgBCAPaigCACAFKAIAajYCACADQQRqIgNBgAJHDQALA0AgCiACQQJ0IgRqIgMgBCAOaigCACADKAIAajYCACAKIARBBHIiA2oiBSADIA5qKAIAIAUoAgBqNgIAIAogBEEIciIDaiIFIAMgDmooAgAgBSgCAGo2AgAgCiAEQQxyIgRqIgMgBCAOaigCACADKAIAajYCAEEAIQMgAkEEaiICQYACRw0AC0EAIQIDQCAMIAJBAnQiBGoiBSAEIA1qKAIAIAUoAgBqNgIAIAwgBEEEciIFaiIHIAUgDWooAgAgBygCAGo2AgAgDCAEQQhyIgVqIgcgBSANaigCACAHKAIAajYCACAMIARBDHIiBGoiBSAEIA1qKAIAIAUoAgBqNgIAIAJBBGoiAkGAAkcNAAsDQCAGQYCoAWogA0ECdGoiBCAEKAIAIgJBgICAAmpBF3VB/7+AfGwgAmo2AgAgBEEEaiIEIAQoAgAiBEGAgIACakEXdUH/v4B8bCAEajYCAEEAIQQgA0ECaiIDQYACRw0AC0EAIQMDQCALIANBAnRqIgIgAigCACIFQYCAgAJqQRd1Qf+/gHxsIAVqNgIAIAJBBGoiAiACKAIAIgJBgICAAmpBF3VB/7+AfGwgAmo2AgAgA0ECaiIDQYACRw0ACwNAIAogBEECdGoiAyADKAIAIgJBgICAAmpBF3VB/7+AfGwgAmo2AgAgA0EEaiIDIAMoAgAiA0GAgIACakEXdUH/v4B8bCADajYCACAEQQJqIgRBgAJHDQALQQAhBANAIAwgBEECdGoiAyADKAIAIgJBgICAAmpBF3VB/7+AfGwgAmo2AgAgA0EEaiIDIAMoAgAiA0GAgIACakEXdUH/v4B8bCADajYCACAEQQJqIgRBgAJHDQALIAZBgKgBahCJCQ0AIAZBgAhqIAYgBkGA6ABqEIoJIAZBgAhqELgEIAZBgChqIAZBgChqIAZBgAhqEIsJQQAhA0EAIQQDQCAGQYAoaiAEQQJ0aiICIAIoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCACACQQRqIgIgAigCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIARBAmoiBEGAAkcNAAsDQCAaIANBAnRqIgQgBCgCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIARBBGoiBCAEKAIAIgRBgICAAmpBF3VB/7+AfGwgBGo2AgBBACEEIANBAmoiA0GAAkcNAAtBACEDA0AgGSADQQJ0aiICIAIoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCACACQQRqIgIgAigCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIANBAmoiA0GAAkcNAAsDQCAYIARBAnRqIgMgAygCACICQYCAgAJqQRd1Qf+/gHxsIAJqNgIAIANBBGoiAyADKAIAIgNBgICAAmpBF3VB/7+AfGwgA2o2AgAgBEECaiIEQYACRw0ACyAGQYAoakGy5wUQjAkNACAGQYAIaiAGIAZBgIgBahCKCSAGQYAIahC4BEEAIQNBACEEA0AgBkGACGogBEECdGoiAiACKAIAIgVBgICAAmpBF3VB/7+AfGwgBWo2AgAgAkEEaiICIAIoAgAiAkGAgIACakEXdUH/v4B8bCACajYCACAEQQJqIgRBgAJHDQALA0AgEyADQQJ0aiIEIAQoAgAiAkGAgIACakEXdUH/v4B8bCACajYCACAEQQRqIgQgBCgCACIEQYCAgAJqQRd1Qf+/gHxsIARqNgIAQQAhBCADQQJqIgNBgAJHDQALQQAhAwNAIBIgA0ECdGoiAiACKAIAIgVBgICAAmpBF3VB/7+AfGwgBWo2AgAgAkEEaiICIAIoAgAiAkGAgIACakEXdUH/v4B8bCACajYCACADQQJqIgNBgAJHDQALA0AgESAEQQJ0aiIDIAMoAgAiAkGAgIACakEXdUH/v4B8bCACajYCACADQQRqIgMgAygCACIDQYCAgAJqQRd1Qf+/gHxsIANqNgIAIARBAmoiBEGAAkcNAAsgBkGACGpBgOgFEIwJDQAgBkGAKGogBkGAKGogBkGACGoQuQRBACECQQAhBANAIARBAnQiAyAGQYAIamogBkGAKGogA2ooAgAiBUGB6AVrQf+vdEkgBUGAmHpGIAZBgMgAaiADaigCAEEAR3FyIgM2AgAgAiADaiECIARBAWoiBEGAAkcNAAtBACEFQQAhBANAIBMgBEECdCIDaiADIBpqKAIAIgdBgegFa0H/r3RJIAdBgJh6RiADIBZqKAIAQQBHcXIiAzYCACADIAVqIQUgBEEBaiIEQYACRw0AC0EAIQdBACEEA0AgEiAEQQJ0IgNqIAMgGWooAgAiCEGB6AVrQf+vdEkgCEGAmHpGIAMgFWooAgBBAEdxciIDNgIAIAMgB2ohByAEQQFqIgRBgAJHDQALQQAhCEEAIQQDQCARIARBAnQiA2ogAyAYaigCACIJQYHoBWtB/690SSAJQYCYekYgAyAUaigCAEEAR3FyIgM2AgAgAyAIaiEIIARBAWoiBEGAAkcNAAsgCCAHIAIgBWpqakHQAEsNAAsgAEEgaiEJQQAhAwNAIAZBgKgBaiADQQR0aiICKAIEIQggAigCCCEHIAIoAgwhBSAJIANBCWxqIgRBgIAIIAIoAgBrIgI6AAAgBCACQQh2OgABIARBgIAIIAVrIgVBCnY6AAggBCAFQQJ2OgAHIARBgIAIIAdrIgdBBHY6AAUgBEGAgAggCGsiCEEGdjoAAyAEIAVBBnQgB0EMdnI6AAYgBCAHQQR0IAhBDnZyOgAEIAQgCEECdCACQRB2cjoAAiADQQFqIgNBwABHDQALIABB4ARqIQlBACEDA0AgCyADQQR0aiICKAIEIQggAigCCCEHIAIoAgwhBSAJIANBCWxqIgRBgIAIIAIoAgBrIgI6AAAgBCACQQh2OgABIARBgIAIIAVrIgVBCnY6AAggBCAFQQJ2OgAHIARBgIAIIAdrIgdBBHY6AAUgBEGAgAggCGsiCEEGdjoAAyAEIAVBBnQgB0EMdnI6AAYgBCAHQQR0IAhBDnZyOgAEIAQgCEECdCACQRB2cjoAAiADQQFqIgNBwABHDQALIABBoAlqIQtBACEDA0AgCiADQQR0aiICKAIEIQggAigCCCEHIAIoAgwhBSALIANBCWxqIgRBgIAIIAIoAgBrIgI6AAAgBCACQQh2OgABIARBgIAIIAVrIgVBCnY6AAggBCAFQQJ2OgAHIARBgIAIIAdrIgdBBHY6AAUgBEGAgAggCGsiCEEGdjoAAyAEIAVBBnQgB0EMdnI6AAYgBCAHQQR0IAhBDnZyOgAEIAQgCEECdCACQRB2cjoAAiADQQFqIgNBwABHDQALIABB4A1qIQpBACEDA0AgDCADQQR0aiICKAIEIQggAigCCCEHIAIoAgwhBSAKIANBCWxqIgRBgIAIIAIoAgBrIgI6AAAgBCACQQh2OgABIARBgIAIIAVrIgVBCnY6AAggBCAFQQJ2OgAHIARBgIAIIAdrIgdBBHY6AAUgBEGAgAggCGsiCEEGdjoAAyAEIAVBBnQgB0EMdnI6AAYgBCAHQQR0IAhBDnZyOgAEIAQgCEECdCACQRB2cjoAAiADQQFqIgNBwABHDQALQQAhBCAAQaASaiIDQQBB1AD8CwBBACECA0AgBkGACGogAkECdGooAgAEQCADIARqIAI6AAAgBEEBaiEECyAGQYAIaiACQQFyIgVBAnRqKAIABEAgAyAEaiAFOgAAIARBAWohBAsgAkECaiICQYACRw0ACyAAIAQ6APASQQAhAgNAIBMgAkECdGooAgAEQCADIARqIAI6AAAgBEEBaiEECyATIAJBAXIiBUECdGooAgAEQCADIARqIAU6AAAgBEEBaiEECyACQQJqIgJBgAJHDQALIAAgBDoA8RJBACECA0AgEiACQQJ0aigCAARAIAMgBGogAjoAACAEQQFqIQQLIBIgAkEBciIFQQJ0aigCAARAIAMgBGogBToAACAEQQFqIQQLIAJBAmoiAkGAAkcNAAsgACAEOgDyEkEAIQIDQCARIAJBAnRqKAIABEAgAyAEaiACOgAAIARBAWohBAsgESACQQFyIgVBAnRqKAIABEAgAyAEaiAFOgAAIARBAWohBAsgAkECaiICQYACRw0ACyAAIAQ6APMSIAFB9BI2AgAgBkGgjwNqJAAPC0HvABABAAtB7wAQAQALzwMBDn8jAEEwayICJAAgAkH2nSs2AiAgAEH5hiogAkEgahCbAQJ/IABBARDIASIJRQRAQaOxKQwBCyAAQQIQyAEiBkUEQEEAIQZBjp8rDAELQYexKSAJKAIAQeATRw0AGkHyhisgACAGKAIAQfQSahCGASIIRQ0AGiAJKAIIIQwgCCgCCCEDAkAgBigCACIERQ0AIARB8xJqIQcgBigCCCAEaiEFIARBBE8EQCADIAdqIQogBEF8cSENA0AgAyAHIAFraiAFIAFBf3MiDmotAAA6AAAgCiAOaiAFIAFBfnNqLQAAOgAAIAMgByABQQJya2ogBSABQX1zai0AADoAACADIAcgAUEDcmtqIAUgAUF8c2otAAA6AAAgAUEEaiIBIA1HDQALCyAEQQNxIgpFDQADQCADIAcgAWtqIAUgAUF/c2otAAA6AAAgAUEBaiEBIAtBAWoiCyAKRw0ACwsgAyAIIANB9BJqIAQgDBDBBCAIIAgoAgAgBGo2AgBBASEBQQALIQUgBhCaASAJEJoBIAFFBEAgAiAFNgIUIAJB9p0rNgIQIABB/IgqIAJBEGoQbAALIAJB9p0rNgIAIABB4IcqIAIQmwEgAkEwaiQAQQELlgIBBn8jAEEwayIBJAAgAUHTrik2AiAgAEH5hiogAUEgahCbAQJAAkAgAEEBEMgBIgVFBEBB1bUpIQIMAQsgAEECEMgBIgRFBEBBmYcrIQIMAQsgAEEDEMgBIgNFBEBB6Z4rIQJBACEDDAILQbm1KSECIAUoAgBBoApHDQFBASEGIAQoAgggBCgCACADKAIIIAMoAgAgBSgCCBDEBCECIAAoAgxBAUERIAIbOgAEIAAgACgCDEEIajYCDEEAIQIMAQtBACEECyADEJoBIAQQmgEgBRCaASAGRQRAIAEgAjYCFCABQdOuKTYCECAAQfyIKiABQRBqEGwACyABQdOuKTYCACAAQeCHKiABEJsBIAFBMGokAEEBC5goAip/A34jAEGgjwJrIgUkAAJAAkACf0F/IAFB9BJHDQAaIAUgBC0AADoAgIkCIAUgBC0AAToAgYkCIAUgBC0AAjoAgokCIAUgBC0AAzoAg4kCIAUgBC0ABDoAhIkCIAUgBC0ABToAhYkCIAUgBC0ABjoAhokCIAUgBC0ABzoAh4kCIAUgBC0ACDoAiIkCIAUgBC0ACToAiYkCIAUgBC0ACjoAiokCIAUgBC0ACzoAi4kCIAUgBC0ADDoAjIkCIAUgBC0ADToAjYkCIAUgBC0ADjoAjokCIAUgBC0ADzoAj4kCIAUgBC0AEDoAkIkCIAUgBC0AEToAkYkCIAUgBC0AEjoAkokCIAUgBC0AEzoAk4kCIAUgBC0AFDoAlIkCIAUgBC0AFToAlYkCIAUgBC0AFjoAlokCIAUgBC0AFzoAl4kCIAUgBC0AGDoAmIkCIAUgBC0AGToAmYkCIAUgBC0AGjoAmokCIAUgBC0AGzoAm4kCIAUgBC0AHDoAnIkCIAUgBC0AHToAnYkCIAUgBC0AHjoAnokCIAUgBC0AHzoAn4kCIARBIGohCwNAIAVBgEBrIAZBBHRqIgcgCyAGQQVsaiIBLQABIglBCHRBgAZxIAEtAAByNgIAIAcgAS0AAiIIQQZ0QcAHcSAJQQJ2cjYCBCAHIAEtAAMiCUEEdEHwB3EgCEEEdnI2AgggByABLQAEQQJ0IAlBBnZyNgIMIAZBAWoiBkHAAEcNAAsgBEHgAmohDCAFQYDIAGohC0EAIQYDQCALIAZBBHRqIgcgDCAGQQVsaiIBLQABIglBCHRBgAZxIAEtAAByNgIAIAcgAS0AAiIIQQZ0QcAHcSAJQQJ2cjYCBCAHIAEtAAMiCUEEdEHwB3EgCEEEdnI2AgggByABLQAEQQJ0IAlBBnZyNgIMIAZBAWoiBkHAAEcNAAsgBEGgBWohDSAFQYDQAGohDEEAIQYDQCAMIAZBBHRqIgcgDSAGQQVsaiIBLQABIglBCHRBgAZxIAEtAAByNgIAIAcgAS0AAiIIQQZ0QcAHcSAJQQJ2cjYCBCAHIAEtAAMiCUEEdEHwB3EgCEEEdnI2AgggByABLQAEQQJ0IAlBBnZyNgIMIAZBAWoiBkHAAEcNAAsgBEHgB2ohCiAFQYDYAGohDUEAIQYDQCANIAZBBHRqIgcgCiAGQQVsaiIBLQABIglBCHRBgAZxIAEtAAByNgIAIAcgAS0AAiIIQQZ0QcAHcSAJQQJ2cjYCBCAHIAEtAAMiCUEEdEHwB3EgCEEEdnI2AgggByABLQAEQQJ0IAlBBnZyNgIMIAZBAWoiBkHAAEcNAAsgBSAALQAAIg86AKCIAiAFIAAtAAEiEDoAoYgCIAUgAC0AAiIROgCiiAIgBSAALQADIhI6AKOIAiAFIAAtAAQiEzoApIgCIAUgAC0ABSIUOgCliAIgBSAALQAGIhU6AKaIAiAFIAAtAAciFjoAp4gCIAUgAC0ACCIXOgCoiAIgBSAALQAJIhg6AKmIAiAFIAAtAAoiGToAqogCIAUgAC0ACyIaOgCriAIgBSAALQAMIhs6AKyIAiAFIAAtAA0iHDoArYgCIAUgAC0ADiIdOgCuiAIgBSAALQAPIh46AK+IAiAFIAAtABAiHzoAsIgCIAUgAC0AESIgOgCxiAIgBSAALQASIiE6ALKIAiAFIAAtABMiIjoAs4gCIAUgAC0AFCIjOgC0iAIgBSAALQAVIiQ6ALWIAiAFIAAtABYiJToAtogCIAUgAC0AFyImOgC3iAIgBSAALQAYIic6ALiIAiAFIAAtABkiKDoAuYgCIAUgAC0AGiIpOgC6iAIgBSAALQAbIio6ALuIAiAFIAAtABwiKzoAvIgCIAUgAC0AHSIsOgC9iAIgBSAALQAeIi06AL6IAiAFIAAtAB8iLjoAv4gCIAVBgOAAaiAAQSBqEIYJIAVBgOgAaiAAQeAEahCGCSAFQYDwAGogAEGgCWoQhgkgBUGA+ABqIABB4A1qEIYJIAVBAEGACPwLAEF/IAAtAPASIgdB0ABLDQAaIABBoBJqIQkCQCAHRQ0AQQEhASAFIAktAABBAnRqQQE2AgAgB0EBRg0AA0BBfyABIAlqIggtAAAiCiAIQQFrLQAATQ0CGiAFIApBAnRqQQE2AgAgAUEBaiIBIAdHDQALCyAFQYAIakEAQYAI/AsAQX8gAC0A8RIiCEHQAEsNABpBfyAHIAhLDQAaAkAgByAITw0AIAVBgAhqIg4gByAJai0AAEECdGpBATYCACAHQQFqIgEgCE8NAANAIAEgCWoiBi0AACEKIAEgB0sEQEF/IAogBkEBay0AAE0NAxoLIA4gCkECdGpBATYCACABQQFqIgEgCEcNAAsLIAVBgBBqQQBBgAj8CwBBfyAALQDyEiIHQdAASw0AGkF/IAcgCEkNABoCQCAHIAhNDQAgBUGAEGoiDiAIIAlqLQAAQQJ0akEBNgIAIAhBAWoiASAHTw0AA0AgASAJaiIGLQAAIQogASAISwRAQX8gCiAGQQFrLQAATQ0DGgsgDiAKQQJ0akEBNgIAIAFBAWoiASAHRw0ACwsgBUGAGGpBAEGACPwLAEF/IAAtAPMSIgFB0ABLDQAaQX8gASAHSQ0AGgJAIAEgB00NACAFQYAYaiIGIAcgCWotAABBAnRqQQE2AgAgB0EBaiIIIAFPDQADQCAIIAlqIgotAAAhACAHIAhJBEBBfyAAIApBAWstAABNDQMaCyAGIABBAnRqQQE2AgAgCEEBaiIIIAFHDQALCwJAIAFB0ABPDQADQCABIAlqLQAARQRAIAFBAWoiAUHQAEcNAQwCCwtBfwwBC0F/IAVBgOAAahCJCQ0AGiAFQcCIAmpBICAEQaAKELMEQdABECoiAUUNAUEAIQAgAUEAQdAB/AsAIAFBiAEgBUHAiAJqQSAQgwkgAUGIASACIAMQgwkgASABKQPIASIvp0F4cWoiBiAGKQMAQh8gL0IDhoaFNwMAIAFCADcDyAEgASABKQOAAUKAgICAgICAgIB/hTcDgAEgBUHAiAJqQcAAIAFBiAEQhAkgARArIAVBgIACaiAFQaCIAmoQiAkgBUGAgAFqIAVBgIkCahC0BCAFQYDgAGoQtgQgBUGAIGogBUGAgAFqIAVBgOAAahC3BEGAASEJA0BBACEGA0AgBiAJaiEIIABBAWoiAEECdEHg4C9qNAIAIjBCgICAgJCAiMADfiExA0AgBUGAgAJqIAZBAnRqIgEgCUECdGoiByABKAIAIDEgBzQCACIvfkIgh0L/v4B8fiAvIDB+fEIgiKciB2s2AgAgASABKAIAIAdqNgIAIAZBAWoiBiAISQ0ACyAGIAlqIgZBgAJJDQALIAlBAUshASAJQQF2IQkgAQ0AC0EAIQYDQCAFQYBAayAGQQJ0aiIBIAEoAgBBDXQ2AgAgAUEEaiIHIAcoAgBBDXQ2AgAgAUEIaiIHIAcoAgBBDXQ2AgAgAUEMaiIBIAEoAgBBDXQ2AgAgBkEEaiIGQYACRw0AC0EAIQYDQCALIAZBAnRqIgEgASgCAEENdDYCACABQQRqIgcgBygCAEENdDYCACABQQhqIgcgBygCAEENdDYCACABQQxqIgEgASgCAEENdDYCACAGQQRqIgZBgAJHDQALQQAhBgNAIAwgBkECdGoiASABKAIAQQ10NgIAIAFBBGoiByAHKAIAQQ10NgIAIAFBCGoiByAHKAIAQQ10NgIAIAFBDGoiASABKAIAQQ10NgIAIAZBBGoiBkGAAkcNAAtBACEGA0AgDSAGQQJ0aiIBIAEoAgBBDXQ2AgAgAUEEaiIHIAcoAgBBDXQ2AgAgAUEIaiIHIAcoAgBBDXQ2AgAgAUEMaiIBIAEoAgBBDXQ2AgAgBkEEaiIGQYACRw0ACyAFQYBAaxC2BCAFQYBAayAFQYCAAmogBUGAQGsQigkgBUGAIGogBUGAIGogBUGAQGsQiwlBACEBA0AgBUGAIGogAUECdGoiBiAGKAIAIgdBgICAAmpBF3VB/7+AfGwgB2o2AgAgBkEEaiIGIAYoAgAiBkGAgIACakEXdUH/v4B8bCAGajYCACABQQJqIgFBgAJHDQALIAVBgChqIQZBACEBA0AgBiABQQJ0aiIHIAcoAgAiCUGAgIACakEXdUH/v4B8bCAJajYCACAHQQRqIgcgBygCACIHQYCAgAJqQRd1Qf+/gHxsIAdqNgIAIAFBAmoiAUGAAkcNAAsgBUGAMGohB0EAIQEDQCAHIAFBAnRqIgkgCSgCACIIQYCAgAJqQRd1Qf+/gHxsIAhqNgIAIAlBBGoiCSAJKAIAIglBgICAAmpBF3VB/7+AfGwgCWo2AgAgAUECaiIBQYACRw0ACyAFQYA4aiEJQQAhAQNAIAkgAUECdGoiCCAIKAIAIgBBgICAAmpBF3VB/7+AfGwgAGo2AgAgCEEEaiIIIAgoAgAiCEGAgIACakEXdUH/v4B8bCAIajYCACABQQJqIgFBgAJHDQALIAVBgCBqELgEQQAhCEEAIQADQCAFQYAgaiAAQQJ0aiIBIAEoAgAiBEEfdUGBwP8DcSAEajYCACABQQRqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIAFBCGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgAUEMaiIBIAEoAgAiAUEfdUGBwP8DcSABajYCACAAQQRqIgBBgAJHDQALA0AgBiAIQQJ0aiIBIAEoAgAiAEEfdUGBwP8DcSAAajYCACABQQRqIgAgACgCACIAQR91QYHA/wNxIABqNgIAIAFBCGoiACAAKAIAIgBBH3VBgcD/A3EgAGo2AgAgAUEMaiIBIAEoAgAiAUEfdUGBwP8DcSABajYCACAIQQRqIghBgAJHDQALQQAhCANAIAcgCEECdGoiASABKAIAIgBBH3VBgcD/A3EgAGo2AgAgAUEEaiIAIAAoAgAiAEEfdUGBwP8DcSAAajYCACABQQhqIgAgACgCACIAQR91QYHA/wNxIABqNgIAIAFBDGoiASABKAIAIgFBH3VBgcD/A3EgAWo2AgAgCEEEaiIIQYACRw0AC0EAIQgDQCAJIAhBAnRqIgEgASgCACIAQR91QYHA/wNxIABqNgIAIAFBBGoiACAAKAIAIgBBH3VBgcD/A3EgAGo2AgAgAUEIaiIAIAAoAgAiAEEfdUGBwP8DcSAAajYCACABQQxqIgEgASgCACIBQR91QYHA/wNxIAFqNgIAIAhBBGoiCEGAAkcNAAtBACEIA0AgCEECdCIAIAVBgCBqaiIEKAIAIgtB/wBqQQd1QYvYAGxBgICABGpBGHUiAUEAIAFBK0wbIQECQCAAIAVqKAIARQ0AQf+/gHxBACABQYCwdGwgC2oiAEGA4P8BShsgAGpBAEoEQCABQQFqQQAgAUErRxshAQwBCyABQQFrQSsgARshAQsgBCABNgIAIAhBAWoiCEGAAkcNAAsgBUGACGohDEEAIQgDQCAGIAhBAnQiAGoiBCgCACILQf8AakEHdUGL2ABsQYCAgARqQRh1IgFBACABQStMGyEBAkAgACAMaigCAEUNAEH/v4B8QQAgAUGAsHRsIAtqIgBBgOD/AUobIABqQQBKBEAgAUEBakEAIAFBK0cbIQEMAQsgAUEBa0ErIAEbIQELIAQgATYCACAIQQFqIghBgAJHDQALIAVBgBBqIQtBACEGA0AgByAGQQJ0IghqIgAoAgAiBEH/AGpBB3VBi9gAbEGAgIAEakEYdSIBQQAgAUErTBshAQJAIAggC2ooAgBFDQBB/7+AfEEAIAFBgLB0bCAEaiIIQYDg/wFKGyAIakEASgRAIAFBAWpBACABQStHGyEBDAELIAFBAWtBKyABGyEBCyAAIAE2AgAgBkEBaiIGQYACRw0ACyAFQYAYaiEEQQAhBgNAIAkgBkECdCIHaiIIKAIAIgBB/wBqQQd1QYvYAGxBgICABGpBGHUiAUEAIAFBK0wbIQECQCAEIAdqKAIARQ0AQf+/gHxBACABQYCwdGwgAGoiB0GA4P8BShsgB2pBAEoEQCABQQFqQQAgAUErRxshAQwBCyABQQFrQSsgARshAQsgCCABNgIAIAZBAWoiBkGAAkcNAAsgBUGgiQJqIAVBgCBqEIcJQdABECoiAUUNAiABQQBB0AH8CwAgAUGIASAFQcCIAmpBwAAQgwkgAUGIASAFQaCJAmpBgAYQgwkgASABKQPIASIvp0F4cWoiBiAGKQMAQh8gL0IDhoaFNwMAIAFCADcDyAEgASABKQOAAUKAgICAgICAgIB/hTcDgAEgBUGAiAJqQSAgAUGIARCECSABECtBACAPIAUtAICIAkcgECAFLQCBiAJHciARIAUtAIKIAkdyIBIgBS0Ag4gCR3IgEyAFLQCEiAJHciAUIAUtAIWIAkdyIBUgBS0AhogCR3IgFiAFLQCHiAJHciAXIAUtAIiIAkdyIBggBS0AiYgCR3IgGSAFLQCKiAJHciAaIAUtAIuIAkdyIBsgBS0AjIgCR3IgHCAFLQCNiAJHciAdIAUtAI6IAkdyIB4gBS0Aj4gCR3IgHyAFLQCQiAJHciAgIAUtAJGIAkdyICEgBS0AkogCR3IgIiAFLQCTiAJHciAjIAUtAJSIAkdyICQgBS0AlYgCR3IgJSAFLQCWiAJHciAmIAUtAJeIAkdyICcgBS0AmIgCR3IgKCAFLQCZiAJHciApIAUtAJqIAkdyICogBS0Am4gCR3IgKyAFLQCciAJHciAsIAUtAJ2IAkdyIC0gBS0AnogCR3IgLiAFLQCfiAJHcmsLIQYgBUGgjwJqJAAgBg8LQe8AEAEAC0HvABABAAucAwEKfyMAQTBrIgMkACADQYieKzYCICAAQfmGKiADQSBqEJsBAkAgAEEBEMgBIgZFBEBB1bUpIQIMAQsgAEECEMgBIgRFBEBBvZ4rIQJBACEEDAELIAYoAgBBoApHBEBBubUpIQIMAQsgACAEKAIAEIYBIgJFBEBB6Z4rIQIMAQsgAigCCCEHAkACQCAEKAIAIgFB9BJPBEAgBigCCCEIIAQoAgghBSACIAFB9BJrIgk2AgAgBUH0EiAFQfQSaiIKIAkgCBDEBARAIAJBfzYCAAwCCyACKAIARQ0CQQAhAQNAIAEgB2ogASAKai0AADoAACABQQFqIgEgAigCACIFSQ0AC0EAIQIgBUEATA0CQQEhAQwDCyACQX82AgAgAUUNAQsgAUUNACAHQQAgAfwLAAtBASEBIAAoAgxBAToABCAAIAAoAgxBCGo2AgxBACECCyAEEJoBIAYQmgEgAUUEQCADIAI2AhQgA0GInis2AhAgAEH8iCogA0EQahBsAAsgA0GInis2AgAgAEHghyogAxCbASADQTBqJABBAQtiAQJ/IwBBIGsiASQAIAFBsrwqNgIQIABB+YYqIAFBEGoQmwEgACgCDCICQQM6AAQgAkH0EjYCACAAIAAoAgxBCGo2AgwgAUGyvCo2AgAgAEHghyogARCbASABQSBqJABBAQuWAQECfyMAQTBrIgEkACABQaTYKjYCICAAQfmGKiABQSBqEJsBIABBARDIASICRQRAIAFBhIgrNgIEIAFBpNgqNgIAIABB/IgqIAEQbAALIAAoAgxBEUEBIAIoAgBB9BJGGzoABCAAIAAoAgxBCGo2AgwgAhCaASABQaTYKjYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC54XAQ1/IwBBgC1rIgIkACACQdC9KjYCMCAAQfmGKiACQTBqEJsBIABBAEECEKEBIABB4AwQhgEhDCAAIAAoAgxBEGtB3/8qEFkgAEGgBhCGASENIAAgACgCDEEQa0HvxisQWSAMKAIIIQcgDSgCCCEJIAJBIDYCICACQekAOwDAGCACQaX2MyACQcAYaiACQSBqEAAiAS0AADoAwCggAiABLQABOgDBKCACIAEtAAI6AMIoIAIgAS0AAzoAwyggAiABLQAEOgDEKCACIAEtAAU6AMUoIAIgAS0ABjoAxiggAiABLQAHOgDHKCACIAEtAAg6AMgoIAIgAS0ACToAySggAiABLQAKOgDKKCACIAEtAAs6AMsoIAIgAS0ADDoAzCggAiABLQANOgDNKCACIAEtAA46AM4oIAIgAS0ADzoAzyggAiABLQAQOgDQKCACIAEtABE6ANEoIAIgAS0AEjoA0iggAiABLQATOgDTKCACIAEtABQ6ANQoIAIgAS0AFToA1SggAiABLQAWOgDWKCACIAEtABc6ANcoIAIgAS0AGDoA2CggAiABLQAZOgDZKCACIAEtABo6ANooIAIgAS0AGzoA2yggAiABLQAcOgDcKCACIAEtAB06AN0oIAIgAS0AHjoA3iggAiABLQAfOgDfKCABECsgAkHAKGogAkHAKGpBIBDJBCACQcAYaiACQcAoakEAEMoEIAJBQGsgAkHgKGoiAUEAEMsEIAJBwARqIgsgAUEBEMsEIAJBwBBqIAFBAhDLBCACQcAUaiIFIAFBAxDLBCACQUBrEMwEIAJBwBBqEMwEIAJBwAhqIAJBwBhqIAJBQGsQzQQgAkGAKWogAkHAHGogCxDNBANAIAZBAXQiASACQcAIamoiBCACQYApaiABai8BACAELwEAajsBACABQQJyIgQgAkHACGpqIgggAkGAKWogBGovAQAgCC8BAGo7AQAgAUEEciIEIAJBwAhqaiIIIAJBgClqIARqLwEAIAgvAQBqOwEAIAFBBnIiASACQcAIamoiBCACQYApaiABai8BACAELwEAajsBACAGQQRqIgZBgAJHDQALA0AgAkHACGogA0EBdGoiASABLgEAIgZBv50BbEGAgIAQakEadUH/ZWwgBmo7AQAgAUECaiIBIAEuAQAiAUG/nQFsQYCAgBBqQRp1Qf9lbCABajsBACADQQJqIgNBgAJHDQALQQAhAQNAIAJBwAhqIAFBAXRqIgMgAy4BACIGQYCApIIFbEEQdUH/ZWwgBkHJCmxqQRB2OwEAIANBAmoiAyADLgEAIgNBgICkggVsQRB1Qf9lbCADQckKbGpBEHY7AQAgAUECaiIBQYACRw0ACyACQcAMaiIBIAJBwCBqIAJBQGsQzQQgAkGAKWogAkHAJGogCxDNBEEAIQZBACEEA0AgASAEQQF0IgNqIgggAkGAKWogA2ovAQAgCC8BAGo7AQAgASADQQJyIghqIgogAkGAKWogCGovAQAgCi8BAGo7AQAgASADQQRyIghqIgogAkGAKWogCGovAQAgCi8BAGo7AQAgASADQQZyIgNqIgggAkGAKWogA2ovAQAgCC8BAGo7AQAgBEEEaiIEQYACRw0ACwNAIAEgBkEBdGoiAyADLgEAIgRBv50BbEGAgIAQakEadUH/ZWwgBGo7AQAgA0ECaiIDIAMuAQAiA0G/nQFsQYCAgBBqQRp1Qf9lbCADajsBACAGQQJqIgZBgAJHDQALQQAhBkEAIQMDQCABIANBAXRqIgQgBC4BACIIQYCApIIFbEEQdUH/ZWwgCEHJCmxqQRB2OwEAIARBAmoiBCAELgEAIgRBgICkggVsQRB1Qf9lbCAEQckKbGpBEHY7AQAgA0ECaiIDQYACRw0ACwNAIAZBAXQiAyACQcAIamoiBCACQcAQaiADai8BACAELwEAajsBACADQQJyIgQgAkHACGpqIgggAkHAEGogBGovAQAgCC8BAGo7AQAgA0EEciIEIAJBwAhqaiIIIAJBwBBqIARqLwEAIAgvAQBqOwEAIANBBnIiAyACQcAIamoiBCACQcAQaiADai8BACAELwEAajsBACAGQQRqIgZBgAJHDQALQQAhBgNAIAEgBkEBdCIDaiIEIAMgBWovAQAgBC8BAGo7AQAgASADQQJyIgRqIgggBCAFai8BACAILwEAajsBACABIANBBHIiBGoiCCAEIAVqLwEAIAgvAQBqOwEAIAEgA0EGciIDaiIEIAMgBWovAQAgBC8BAGo7AQAgBkEEaiIGQYACRw0AC0EAIQMDQCACQcAIaiADQQF0aiIFIAUuAQAiBkG/nQFsQYCAgBBqQRp1Qf9lbCAGajsBACAFQQJqIgUgBS4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqOwEAIANBAmoiA0GAAkcNAAtBACEDA0AgASADQQF0aiIFIAUuAQAiBkG/nQFsQYCAgBBqQRp1Qf9lbCAGajsBACAFQQJqIgUgBS4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqOwEAIANBAmoiA0GAAkcNAAtBACEDA0AgAkFAayADQQJ0aiIELgECIQUgByADQQNsaiIGIAQuAQAiBEEPdkGBGnEgBGoiBDoAACAGIAUgBUEPdkGBGnFqIgVBBHY6AAIgBiAFQQR0IARBCHZyOgABIANBAWoiA0GAAUcNAAsgB0GAA2ohCkEAIQNBACEFA0AgCyAFQQJ0aiIILgECIQYgCiAFQQNsaiIEIAguAQAiCEEPdkGBGnEgCGoiCDoAACAEIAYgBkEPdkGBGnFqIgZBBHY6AAIgBCAGQQR0IAhBCHZyOgABIAVBAWoiBUGAAUcNAAsDQCACQcAIaiADQQJ0aiIELgECIQUgCSADQQNsaiIGIAQuAQAiBEEPdkGBGnEgBGoiBDoAACAGIAUgBUEPdkGBGnFqIgVBBHY6AAIgBiAFQQR0IARBCHZyOgABIANBAWoiA0GAAUcNAAsgCUGAA2ohCEEAIQMDQCABIANBAnRqIgQuAQIhBSAIIANBA2xqIgYgBC4BACIEQQ92QYEacSAEaiIEOgAAIAYgBSAFQQ92QYEacWoiBUEEdjoAAiAGIAVBBHQgBEEIdnI6AAEgA0EBaiIDQYABRw0ACyAJIAL9AATAKP0LAIAGIAkgAkHQKGr9AAQA/QsAkAYgB0GABmohA0EAIQEDQCABIANqIAEgCWotAAA6AAAgAyABQQFqIgVqIAUgCWotAAA6AAAgAyABQQJqIgVqIAUgCWotAAA6AAAgAyABQQNqIgVqIAUgCWotAAA6AAAgAyABQQRqIgVqIAUgCWotAAA6AAAgAUEFaiIBQaAGRw0ACyAHQaAMaiAJQaAGEM4EIAJBIDYCECACQekAOwDAGCAHQaX2MyACQcAYaiACQRBqEAAiAS0AADoAwAwgByABLQABOgDBDCAHIAEtAAI6AMIMIAcgAS0AAzoAwwwgByABLQAEOgDEDCAHIAEtAAU6AMUMIAcgAS0ABjoAxgwgByABLQAHOgDHDCAHIAEtAAg6AMgMIAcgAS0ACToAyQwgByABLQAKOgDKDCAHIAEtAAs6AMsMIAcgAS0ADDoAzAwgByABLQANOgDNDCAHIAEtAA46AM4MIAcgAS0ADzoAzwwgByABLQAQOgDQDCAHIAEtABE6ANEMIAcgAS0AEjoA0gwgByABLQATOgDTDCAHIAEtABQ6ANQMIAcgAS0AFToA1QwgByABLQAWOgDWDCAHIAEtABc6ANcMIAcgAS0AGDoA2AwgByABLQAZOgDZDCAHIAEtABo6ANoMIAcgAS0AGzoA2wwgByABLQAcOgDcDCAHIAEtAB06AN0MIAcgAS0AHjoA3gwgByABLQAfOgDfDCABECsgDUGgBjYCACAMQeAMNgIAIAJB0L0qNgIAIABB4IcqIAIQmwEgAkGALWokAEEBC6EDAQR/IwBBoANrIgMkACADQUBrQQBBiAH8CwAgA0HQAWpBAEHIAPwLACACQfwAcSEGA0AgA0HQAWogBGogASAEai0AADoAACAEQQFyIgUgA0HQAWpqIAEgBWotAAA6AAAgBEECciIFIANB0AFqaiABIAVqLQAAOgAAIARBA3IiBSADQdABamogASAFai0AADoAACAEQQRqIgQgBkcNAAsgAkEDcSIGBEBBACEFA0AgA0HQAWogBGogASAEai0AADoAACAEQQFqIQQgBUEBaiIFIAZHDQALCyADQdABaiACakEGOgAAIAMgAy0AlwJBgAFyOgCXAiADIAP9AATQAf0LBAAgAyAD/QAE4AH9CwQQIAMgA/0ABPAB/QsEICADIAP9AASAAv0LBDAgAyADKQOQAjcDQCADENgEQQAhBANAIARBA3QiASADQdABamogASADaikDADcDACAEQQFqIgRBCUcNAAsgACAD/QAE0AH9CwAAIAAgA/0ABIAC/QsAMCAAIAP9AATwAf0LACAgACAD/QAE4AH9CwAQIANBoANqJAALjgYBEn8jAEGQBGsiBiQAIAZB4AJqIREgBkG4AWohEkEBIQ4DQCAAIAtBCnRqIRNBASEPQQAhBQNAAkAgAgRAIAZBDGogASALIAUQgQkMAQsgBkEMaiABIAUgCxCBCQsgBigCDCIJENgEQQAhAwNAIANBA3QiBCAGQRBqaiAEIAlqKQMANwMAIANBAWoiA0EVRw0ACyAJENgEQQAhAwNAIBIgA0EDdCIEaiAEIAlqKQMANwMAIANBAWoiA0EVRw0ACyAJENgEQQAhAwNAIBEgA0EDdCIEaiAEIAlqKQMANwMAIANBAWoiA0EVRw0ACyATIAVBCXRqIQ1BACEHQQMhBEEAIQUDQCAEIQMgBkEQaiAFaiIELQACIQUgBC0AACAELQABIgpBCHRBgB5xciIEQYAaTQRAIA0gB0EBdGogBDsBACAHQQFqIQcLAkAgB0H/AUsNACAFQQR0IApBBHZyIgRBgBpLDQAgDSAHQQF0aiAEOwEAIAdBAWohBwsgB0H/AUsiCkUEQCADQQNqIQQgAyEFIANB9gNJDQELC0H4AyEMIApFBEADQCAMQQNwIggEQCAMIAhrIQRBACEDA0AgBkEQaiADaiAGQRBqIAMgBGpqLQAAOgAAIANBAWoiAyAIRw0ACwsgCRDYBCAGQRBqIAhyIQVBACEDA0AgBSADQQN0IgRqIAQgCWopAwA3AAAgA0EBaiIDQRVHDQALQYACIAdrIQogCEGoAXIhDCANIAdBAXRqIRBBACEDQQMhBEEAIQgDQCAEIQUgBkEQaiAIaiIELQACIQggBC0AACAELQABIhRBCHRBgB5xciIEQYAaTQRAIBAgA0EBdGogBDsBACADQQFqIQMLAkAgAyAKTw0AIAhBBHQgFEEEdnIiBEGAGksNACAQIANBAXRqIAQ7AQAgA0EBaiEDCyADIApJBEAgBSEIIAVBA2oiBCAMTQ0BCwsgAyAHaiIHQYACSQ0ACwsgCRArQQEhBSAPIQNBACEPIAMNAAtBASELIA4hA0EAIQ4gAw0ACyAGQZAEaiQAC+wBAQJ/IwBB8AFrIgMkACADIAH9AAAQ/QsE0AEgAyAB/QAAAP0LBMABIAMgAjoA4AEgA0HAASADQcABakEhELMEQQAhAgNAIAAgAkEDdGoiBCADIAJBA2xqIgEvAAAgAS0AAkEQdHIiAUEBdkHJpJIBcSABQcmkkgFxaiABQQJ2QcmkkgFxaiIBQQZ2QQdxIAFBCXZBB3FrOwECIAQgAUEHcSABQQN2QQdxazsBACAEIAFBDHZBB3EgAUEPdkEHcWs7AQQgBCABQRJ2QQdxIAFBFXZrOwEGIAJBAWoiAkHAAEcNAAsgA0HwAWokAAuoBAEIf0GAASEEQQEhBQNAQQAhAQNAIAEgBGohBiAFQQF0QcDIMWouAQAiB0GAgISYf2whCANAIAAgAUEBdGoiAiAEQQF0aiIDIAIvAQAgCCADLgEAIgNsQRB1Qf9lbCADIAdsakEQdiIDazsBACACIAIvAQAgA2o7AQAgAUEBaiIBIAZJDQALIAVBAWohBSABIARqIgFBgAJJDQALIARBA0shAiAEQQF2IQQgAg0AC0EAIQIDQCAAIAJBAXRqIgEgAS4BACIDQb+dAWxBgICAEGpBGnVB/2VsIANqOwEAIAFBAmoiASABLgEAIgFBv50BbEGAgIAQakEadUH/ZWwgAWo7AQAgAkECaiICQYACRw0ACyAAQYAEaiEAQYABIQRBASEFA0BBACEBA0AgASAEaiEGIAVBAXRBwMgxai4BACIHQYCAhJh/bCEIA0AgACABQQF0aiICIARBAXRqIgMgAi8BACAIIAMuAQAiA2xBEHVB/2VsIAMgB2xqQRB2IgNrOwEAIAIgAi8BACADajsBACABQQFqIgEgBkkNAAsgBUEBaiEFIAEgBGoiAUGAAkkNAAsgBEEDSyECIARBAXYhBCACDQALQQAhAgNAIAAgAkEBdGoiASABLgEAIgNBv50BbEGAgIAQakEadUH/ZWwgA2o7AQAgAUECaiIBIAEuAQAiAUG/nQFsQYCAgBBqQRp1Qf9lbCABajsBACACQQJqIgJBgAJHDQALC8MDAQh/A0AgACAJQQN0IgZqIgUgAiAGaiIELgECIAEgBmoiAy4BAmwiCEGAgISYf2xBEHVB/2VsIAhqQRB1IAlBAXRBwMkxai4BACIIbCIHQYCAhJh/bEEQdUH/ZWwgB2pBEHYiBzsBACAFIAcgBC4BACADLgEAbCIKQYCAhJh/bEEQdUH/ZWwgCmpBEHZqOwEAIAUgBC4BAiADLgEAbCIHQYCAhJh/bEEQdUH/ZWwgB2pBEHYiBzsBAiAFIAcgBC4BACADLgECbCIEQYCAhJh/bEEQdUH/ZWwgBGpBEHZqOwECIAAgBkEEciIEaiIGQQAgCGvBIAIgBGoiBS4BAiABIARqIgQuAQJsIgNBgICEmH9sQRB1Qf9lbCADakEQdWwiA0GAgISYf2xBEHVB/2VsIANqQRB2IgM7AQAgBiADIAUuAQAgBC4BAGwiCEGAgISYf2xBEHVB/2VsIAhqQRB2ajsBACAGIAUuAQIgBC4BAGwiA0GAgISYf2xBEHVB/2VsIANqQRB2IgM7AQIgBiADIAUuAQAgBC4BAmwiBUGAgISYf2xBEHVB/2VsIAVqQRB2ajsBAiAJQQFqIglBwABHDQALC9kHAQV/IwBBoANrIgMkACADQQBByAH8CwACfwJAAkAgAkGHAU0EQCADQdABakEAQYgB/AsAIAJBA3EhBgwBCwNAIAMgAykDACABKQAAhTcDACADIAMpAwggASkACIU3AwggAyADKQMQIAEpABCFNwMQIAMgAykDGCABKQAYhTcDGCADIAMpAyAgASkAIIU3AyAgAyADKQMoIAEpACiFNwMoIAMgAykDMCABKQAwhTcDMCADIAMpAzggASkAOIU3AzggAyADKQNAIAEpAECFNwNAIAMgAykDSCABKQBIhTcDSCADIAMpA1AgASkAUIU3A1AgAyADKQNYIAEpAFiFNwNYIAMgAykDYCABKQBghTcDYCADIAMpA2ggASkAaIU3A2ggAyADKQNwIAEpAHCFNwNwIAMgAykDeCABKQB4hTcDeCADIAMpA4ABIAEpAIABhTcDgAEgAUGIAWohASADENgEIAIiBEGIAWsiAkGHAUsNAAsgA0HQAWpBAEGIAfwLAEEAIAJFDQIaIARBA3EhBkEAIQQgAkEESQ0BCyACQfwBcSEHA0AgA0HQAWogBGogASAEai0AADoAACAEQQFyIgUgA0HQAWpqIAEgBWotAAA6AAAgBEECciIFIANB0AFqaiABIAVqLQAAOgAAIARBA3IiBSADQdABamogASAFai0AADoAACAEQQRqIgQgB0cNAAsLIAYEQEEAIQUDQCADQdABaiAEaiABIARqLQAAOgAAIARBAWohBCAFQQFqIgUgBkcNAAsLIAILIANB0AFqakEGOgAAIAMgAy0A1wJBgAFyOgDXAiADIAMpAwAgAykD0AGFNwMAIAMgAykDCCADKQPYAYU3AwggAyADKQMQIAMpA+ABhTcDECADIAMpAxggAykD6AGFNwMYIAMgAykDICADKQPwAYU3AyAgAyADKQMoIAMpA/gBhTcDKCADIAMpAzAgAykDgAKFNwMwIAMgAykDOCADKQOIAoU3AzggAyADKQNAIAMpA5AChTcDQCADIAMpA0ggAykDmAKFNwNIIAMgAykDUCADKQOgAoU3A1AgAyADKQNYIAMpA6gChTcDWCADIAMpA2AgAykDsAKFNwNgIAMgAykDaCADKQO4AoU3A2ggAyADKQNwIAMpA8AChTcDcCADIAMpA3ggAykDyAKFNwN4IAMgAykDgAEgAykD0AKFNwOAASADENgEQQAhAQNAIAFBA3QiBCADQdABamogAyAEaikDADcDACABQQFqIgFBEUcNAAsgACAD/QAE0AH9CwAAIAAgA/0ABOAB/QsAECADQaADaiQAC7YCAQd/IwBBQGoiASQAIAFB174qNgIwIABB+YYqIAFBMGoQmwECQCAAQQEQyAEiBgRAIABBoAYQhgEiB0UNASAGKAIIQYAGaiEEIAcoAgghBQNAIAIgBWogAiAEai0AADoAACAFIAJBAWoiA2ogAyAEai0AADoAACAFIAJBAmoiA2ogAyAEai0AADoAACAFIAJBA2oiA2ogAyAEai0AADoAACAFIAJBBGoiA2ogAyAEai0AADoAACACQQVqIgJBoAZHDQALIAdBoAY2AgAgBhCaASABQde+KjYCICAAQeCHKiABQSBqEJsBIAFBQGskAEEBDwsgAUHnsSk2AgQgAUHXvio2AgAgAEH8iCogARBsAAsgBhCaASABQfKzKTYCFCABQde+KjYCECAAQfyIKiABQRBqEGwAC5YBAQJ/IwBBMGsiASQAIAFBn9cqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUHftik2AgQgAUGf1yo2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGgBkYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFBn9cqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQELlQEBAn8jAEEwayIBJAAgAUHD1io2AiAgAEH5hiogAUEgahCbASAAQQEQyAEiAkUEQCABQcDlKTYCBCABQcPWKjYCACAAQfyIKiABEGwACyAAKAIMQRFBASACKAIAQSBGGzoABCAAIAAoAgxBCGo2AgwgAhCaASABQcPWKjYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC5YBAQJ/IwBBMGsiASQAIAFB99UqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUH9yCk2AgQgAUH31So2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGABkYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFB99UqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQEL4wUBCH8jAEHAAWsiASQAIAFBh8QrNgIwIABB+YYqIAFBMGoQmwECQAJ/Qf22KSAAQQEQyAEiA0UNABpBubUpIAMoAgBBoAZHDQAaIABBAEECEKEBQcDlKSAAQSAQhgEiBEUNABogACAAKAIMQRBrQa/mKRBZIABBgAYQhgEiBQ0BQf3IKQshAiADEJoBIAEgAjYCBCABQYfEKzYCACAAQfyIKiABEGwACyAAIAAoAgxBEGtBiZcqEFkgBCgCCCEIIAUoAgghBiADKAIIIQcgAUEgNgIgIAFB6QA7AEAgAUGl9jMgAUFAayABQSBqEAAiAi0AADoAgAEgASACLQABOgCBASABIAItAAI6AIIBIAEgAi0AAzoAgwEgASACLQAEOgCEASABIAItAAU6AIUBIAEgAi0ABjoAhgEgASACLQAHOgCHASABIAItAAg6AIgBIAEgAi0ACToAiQEgASACLQAKOgCKASABIAItAAs6AIsBIAEgAi0ADDoAjAEgASACLQANOgCNASABIAItAA46AI4BIAEgAi0ADzoAjwEgASACLQAQOgCQASABIAItABE6AJEBIAEgAi0AEjoAkgEgASACLQATOgCTASABIAItABQ6AJQBIAEgAi0AFToAlQEgASACLQAWOgCWASABIAItABc6AJcBIAEgAi0AGDoAmAEgASACLQAZOgCZASABIAItABo6AJoBIAEgAi0AGzoAmwEgASACLQAcOgCcASABIAItAB06AJ0BIAEgAi0AHjoAngEgASACLQAfOgCfASACECsgAUGAAWogAUGAAWpBIBDOBCABQaABaiAHQaAGEM4EIAFBQGsgAUGAAWpBwAAQyQQgBiABQYABaiAHIAFB4ABqIgIQ1AQgAiAGQYAGEM4EIAhBICABQUBrQcAAELMEIARBIDYCACAFQYAGNgIAIAMQmgEgAUGHxCs2AhAgAEHghyogAUEQahCbASABQcABaiQAQQELsyABC38jAEGgwABrIgckAANAIAdBgCxqIARBAnRqIgYgAiAEQQNsaiIFLQABIghBCHRBgB5xIAUtAAByOwEAIAYgBS0AAkEEdCAIQQR2cjsBAiAEQQFqIgRBgAFHDQALIAJBgANqIQwgB0GAMGohCUEAIQQDQCAJIARBAnRqIgYgDCAEQQNsaiIFLQABIghBCHRBgB5xIAUtAAByOwEAIAYgBS0AAkEEdCAIQQR2cjsBAiAEQQFqIgRBgAFHDQALIAdBkDxqIAL9AACQBv0LBAAgByAC/QAAgAb9CwSAPEEAIQYDQCAHQYAEaiAGQQR0aiIEQYENQQAgASAGaiwAACIFQQBIGzsBDiAEIAVBHnRBH3VBgQ1xOwECIARBACAFQQFxa0GBDXE7AQAgBCAFQR10QR91QYENcTsBBCAEIAVBHHRBH3VBgQ1xOwEGIAQgBUEbdEEfdUGBDXE7AQggBCAFQRp0QR91QYENcTsBCiAEIAVBGXRBH3VBgQ1xOwEMIAZBAWoiBkEgRw0ACyAHQYAUaiAHQYA8akEBEMoEQQAhBSAHQYA0aiADQQAQywQgB0GAOGoiASADQQEQywQgB0GAJGogA0ECEIIJIAdBgChqIg4gA0EDEIIJIAcgA0EEEIIJIAdBgDRqEMwEIAdBgAxqIAdBgBRqIAdBgDRqEM0EIAdBoDxqIAdBgBhqIAEQzQRBACEGA0AgBkEBdCIEIAdBgAxqaiIIIAdBoDxqIARqLwEAIAgvAQBqOwEAIARBAnIiCCAHQYAMamoiAiAHQaA8aiAIai8BACACLwEAajsBACAEQQRyIgggB0GADGpqIgIgB0GgPGogCGovAQAgAi8BAGo7AQAgBEEGciIEIAdBgAxqaiIIIAdBoDxqIARqLwEAIAgvAQBqOwEAIAZBBGoiBkGAAkcNAAsDQCAHQYAMaiAFQQF0aiIEIAQuAQAiBkG/nQFsQYCAgBBqQRp1Qf9lbCAGajsBACAEQQJqIgQgBC4BACIEQb+dAWxBgICAEGpBGnVB/2VsIARqOwEAIAVBAmoiBUGAAkcNAAsgB0GAEGoiCiAHQYAcaiAHQYA0ahDNBCAHQaA8aiAHQYAgaiABEM0EQQAhBUEAIQYDQCAKIAZBAXQiBGoiCCAHQaA8aiAEai8BACAILwEAajsBACAKIARBAnIiCGoiAiAHQaA8aiAIai8BACACLwEAajsBACAKIARBBHIiCGoiAiAHQaA8aiAIai8BACACLwEAajsBACAKIARBBnIiBGoiCCAHQaA8aiAEai8BACAILwEAajsBACAGQQRqIgZBgAJHDQALA0AgCiAFQQF0aiIEIAQuAQAiBkG/nQFsQYCAgBBqQRp1Qf9lbCAGajsBACAEQQJqIgQgBC4BACIEQb+dAWxBgICAEGpBGnVB/2VsIARqOwEAIAVBAmoiBUGAAkcNAAsgB0GACGogB0GALGogB0GANGoQzQQgB0GgPGogCSABEM0EQQAhBUEAIQYDQCAGQQF0IgQgB0GACGpqIgggB0GgPGogBGovAQAgCC8BAGo7AQAgBEECciIIIAdBgAhqaiICIAdBoDxqIAhqLwEAIAIvAQBqOwEAIARBBHIiCCAHQYAIamoiAiAHQaA8aiAIai8BACACLwEAajsBACAEQQZyIgQgB0GACGpqIgggB0GgPGogBGovAQAgCC8BAGo7AQAgBkEEaiIGQYACRw0ACwNAIAdBgAhqIAVBAXRqIgQgBC4BACIGQb+dAWxBgICAEGpBGnVB/2VsIAZqOwEAIARBAmoiBCAELgEAIgRBv50BbEGAgIAQakEadUH/ZWwgBGo7AQAgBUECaiIFQYACRw0AC0H/ACELQQIhCQNAQQAhBANAIAQgCWohASALQQF0QcDIMWouAQAiDEGAgISYf2whAwNAIAdBgAxqIARBAXRqIgUgBSAJQQF0Ig1qIgYvAQAiCCAFLwEAIgVqIgLBQb+dAWxBgICAEGpBGnVB/2VsIAJqOwEAIAYgAyAIIAVrwSIFbEEQdUH/ZWwgBSAMbGpBEHY7AQAgBEEBaiIEIAFJDQALIAtBAWshCyAEIAlqIgRBgAJJDQALIAlBwQBJIQQgDSEJIAQNAAtBAiEJIAdBggxqIQhBACEEA0AgBEEBdCIFIAdBgAxqaiIGIAYuAQAiBkGAgITFfWxBEHVB/2VsIAZBoQtsakEQdjsBACAFIAhqIgUgBS4BACIFQYCAhMV9bEEQdUH/ZWwgBUGhC2xqQRB2OwEAIARBAmoiBEGAAkcNAAtB/wAhCwNAQQAhBANAIAQgCWohASALQQF0QcDIMWouAQAiDEGAgISYf2whAwNAIAogBEEBdGoiBSAFIAlBAXQiDWoiBi8BACIIIAUvAQAiBWoiAsFBv50BbEGAgIAQakEadUH/ZWwgAmo7AQAgBiADIAggBWvBIgVsQRB1Qf9lbCAFIAxsakEQdjsBACAEQQFqIgQgAUkNAAsgC0EBayELIAQgCWoiBEGAAkkNAAsgCUHBAEkhBCANIQkgBA0AC0ECIQkgCkECaiEIQQAhBANAIAogBEEBdCIFaiIGIAYuAQAiBkGAgITFfWxBEHVB/2VsIAZBoQtsakEQdjsBACAFIAhqIgUgBS4BACIFQYCAhMV9bEEQdUH/ZWwgBUGhC2xqQRB2OwEAIARBAmoiBEGAAkcNAAtB/wAhCwNAQQAhBANAIAQgCWohASALQQF0QcDIMWouAQAiDEGAgISYf2whAwNAIAdBgAhqIARBAXRqIgUgBSAJQQF0Ig1qIgYvAQAiCCAFLwEAIgVqIgLBQb+dAWxBgICAEGpBGnVB/2VsIAJqOwEAIAYgAyAIIAVrwSIFbEEQdUH/ZWwgBSAMbGpBEHY7AQAgBEEBaiIEIAFJDQALIAtBAWshCyAEIAlqIgRBgAJJDQALIAlBwQBJIQQgDSEJIAQNAAsgB0GCCGohAkEAIQVBACEEA0AgBEEBdCIGIAdBgAhqaiIIIAguAQAiCEGAgITFfWxBEHVB/2VsIAhBoQtsakEQdjsBACACIAZqIgYgBi4BACIGQYCAhMV9bEEQdUH/ZWwgBkGhC2xqQRB2OwEAIARBAmoiBEGAAkcNAAsDQCAFQQF0IgQgB0GADGpqIgYgB0GAJGogBGovAQAgBi8BAGo7AQAgBEECciIGIAdBgAxqaiIIIAdBgCRqIAZqLwEAIAgvAQBqOwEAIARBBHIiBiAHQYAMamoiCCAHQYAkaiAGai8BACAILwEAajsBACAEQQZyIgQgB0GADGpqIgYgB0GAJGogBGovAQAgBi8BAGo7AQAgBUEEaiIFQYACRw0AC0EAIQUDQCAKIAVBAXQiBGoiBiAEIA5qLwEAIAYvAQBqOwEAIAogBEECciIGaiIIIAYgDmovAQAgCC8BAGo7AQAgCiAEQQRyIgZqIgggBiAOai8BACAILwEAajsBACAKIARBBnIiBGoiBiAEIA5qLwEAIAYvAQBqOwEAIAVBBGoiBUGAAkcNAAtBACEFA0AgBUEBdCIEIAdBgAhqaiIGIAQgB2ovAQAgBi8BAGo7AQAgBEECciIGIAdBgAhqaiIIIAYgB2ovAQAgCC8BAGo7AQAgBEEEciIGIAdBgAhqaiIIIAYgB2ovAQAgCC8BAGo7AQAgBEEGciIEIAdBgAhqaiIGIAQgB2ovAQAgBi8BAGo7AQAgBUEEaiIFQYACRw0AC0EAIQUDQCAFQQF0IgQgB0GACGpqIgYgB0GABGogBGovAQAgBi8BAGo7AQAgBEECciIGIAdBgAhqaiIIIAdBgARqIAZqLwEAIAgvAQBqOwEAIARBBHIiBiAHQYAIamoiCCAHQYAEaiAGai8BACAILwEAajsBACAEQQZyIgQgB0GACGpqIgYgB0GABGogBGovAQAgBi8BAGo7AQAgBUEEaiIFQYACRw0AC0EAIQQDQCAHQYAMaiAEQQF0aiIFIAUuAQAiBkG/nQFsQYCAgBBqQRp1Qf9lbCAGajsBACAFQQJqIgUgBS4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqOwEAIARBAmoiBEGAAkcNAAtBACEEA0AgCiAEQQF0aiIFIAUuAQAiBkG/nQFsQYCAgBBqQRp1Qf9lbCAGajsBACAFQQJqIgUgBS4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqOwEAIARBAmoiBEGAAkcNAAtBACEEA0AgB0GACGogBEEBdGoiBSAFLgEAIgZBv50BbEGAgIAQakEadUH/ZWwgBmo7AQAgBUECaiIFIAUuAQAiBUG/nQFsQYCAgBBqQRp1Qf9lbCAFajsBACAEQQJqIgRBgAJHDQALQQAhBiAAIQQDQCAHQYAMaiAGQQN0aiIFLgEEIQggBS4BAiECIAUuAQYhCSAEIAUuAQAiBUEPdkGBGnEgBWpB//8DcUEKdEGADWpBgRpuIgU6AAAgBCAJIAlBD3ZBgRpxakH//wNxQQp0QYANakGBGm4iCUECdjoABCAEIAVBCHZBA3EgAiACQQ92QYEacWpB//8DcUEKdEGADWpBgRpuIgJBAnRyOgABIAQgCCAIQQ92QYEacWpB//8DcUEKdEGADWpBgRpuIgVBBHZBP3EgCUEGdHI6AAMgBCACQQZ2QQ9xIAVBBHRyOgACIARBBWohBCAGQQFqIgZBwABHDQALQQAhBgNAIAogBkEDdGoiBS4BBCEIIAUuAQIhAiAFLgEGIQkgBCAFLgEAIgVBD3ZBgRpxIAVqQf//A3FBCnRBgA1qQYEabiIFOgAAIAQgCSAJQQ92QYEacWpB//8DcUEKdEGADWpBgRpuIglBAnY6AAQgBCAFQQh2QQNxIAIgAkEPdkGBGnFqQf//A3FBCnRBgA1qQYEabiICQQJ0cjoAASAEIAggCEEPdkGBGnFqQf//A3FBCnRBgA1qQYEabiIFQQR2QT9xIAlBBnRyOgADIAQgAkEGdkEPcSAFQQR0cjoAAiAEQQVqIQQgBkEBaiIGQcAARw0ACyAAQYAFaiEFQQAhBgNAIAdBgAhqIAZBBHRqIgQuAQIhCCAELgEAIQIgBC4BBiEJIAQuAQQhASAELgEKIQwgBC4BCCEDIAUgBC4BDiIKQQ92QYEacSAKakH//wNxQQR0QYANakGBGm5BBHQgBC4BDCIEQQ92QYEacSAEakH//wNxQQR0QYANakGBGm5BD3FyOgADIAUgAyADQQ92QYEacWpB//8DcUEEdEGADWpBgRpuQQ9xIAwgDEEPdkGBGnFqQf//A3FBBHRBgA1qQYEabkEEdHI6AAIgBSABIAFBD3ZBgRpxakH//wNxQQR0QYANakGBGm5BD3EgCSAJQQ92QYEacWpB//8DcUEEdEGADWpBgRpuQQR0cjoAASAFIAIgAkEPdkGBGnFqQf//A3FBBHRBgA1qQYEabkEPcSAIIAhBD3ZBgRpxakH//wNxQQR0QYANakGBGm5BBHRyOgAAIAVBBGohBSAGQQFqIgZBIEcNAAsgB0GgwABqJAAL5BMBEn8jAEGwHGsiBCQAIARB78crNgIgIABB+YYqIARBIGoQmwFBu64qIQMgAEEBEMgBIQsgAEECEMgBIQwCQCALRQ0AIAxFDQAgCygCAEHgDEcEQEGHsSkhAwwBCyAMKAIAQYAGRwRAQeewKSEDDAELIABBIBCGASIPRQRAQcDlKSEDDAELIAsoAgghCCAPKAIIIRAgDCgCCCIJIQEDQCABLQAAIQcgAS0AAiEFIAEtAAEhBiAEQbAQaiACQQN0aiIDIAEtAARBAnQgAS0AAyIKQQZ2ckGBGmxBgARqQQp2OwEGIAMgBUEGdEHAB3EgBkECdnJBgRpsQYAEakEKdjsBAiADIAcgBkEIdEGABnFyQYEabEGABGpBCnY7AQAgAyAKQQR0QfAHcSAFQQR2ckGBGmxBgARqQQp2OwEEIAFBBWohASACQQFqIgJBwABHDQALIARBsBRqIQ1BACECA0AgAS0AACEHIAEtAAIhBSABLQABIQYgDSACQQN0aiIDIAEtAARBAnQgAS0AAyIKQQZ2ckGBGmxBgARqQQp2OwEGIAMgBUEGdEHAB3EgBkECdnJBgRpsQYAEakEKdjsBAiADIAcgBkEIdEGABnFyQYEabEGABGpBCnY7AQAgAyAKQQR0QfAHcSAFQQR2ckGBGmxBgARqQQp2OwEEIAFBBWohASACQQFqIgJBwABHDQALIAlBgAVqIQNBACEBQQAhAgNAIARBsARqIAJBAnRqIgUgAy0AACIGQQR2QYEabEEIakEEdjsBAiAFIAZBD3FBgRpsQQhqQQR2OwEAIANBAWohAyACQQFqIgJBgAFHDQALA0AgBEGwCGogAUECdGoiAiAIIAFBA2xqIgMtAAEiBUEIdEGAHnEgAy0AAHI7AQAgAiADLQACQQR0IAVBBHZyOwECIAFBAWoiAUGAAUcNAAsgCEGAA2ohByAEQbAMaiEGQQAhAQNAIAYgAUECdGoiAiAHIAFBA2xqIgMtAAEiBUEIdEGAHnEgAy0AAHI7AQAgAiADLQACQQR0IAVBBHZyOwECIAFBAWoiAUGAAUcNAAsgBEGwEGoQzAQgBEEwaiAEQbAIaiAEQbAQahDNBCAEQbAYaiAGIA0QzQRBACEDQQAhAgNAIAJBAXQiASAEQTBqaiIFIARBsBhqIAFqLwEAIAUvAQBqOwEAIAFBAnIiBSAEQTBqaiIGIARBsBhqIAVqLwEAIAYvAQBqOwEAIAFBBHIiBSAEQTBqaiIGIARBsBhqIAVqLwEAIAYvAQBqOwEAIAFBBnIiASAEQTBqaiIFIARBsBhqIAFqLwEAIAUvAQBqOwEAIAJBBGoiAkGAAkcNAAsDQCAEQTBqIANBAXRqIgEgAS4BACICQb+dAWxBgICAEGpBGnVB/2VsIAJqOwEAIAFBAmoiASABLgEAIgFBv50BbEGAgIAQakEadUH/ZWwgAWo7AQAgA0ECaiIDQYACRw0AC0H/ACEOQQIhBwNAQQAhAQNAIAEgB2ohCiAOQQF0QcDIMWouAQAiDUGAgISYf2whEQNAIARBMGogAUEBdGoiAyADIAdBAXQiEmoiAi8BACIFIAMvAQAiA2oiBsFBv50BbEGAgIAQakEadUH/ZWwgBmo7AQAgAiARIAUgA2vBIgNsQRB1Qf9lbCADIA1sakEQdjsBACABQQFqIgEgCkkNAAsgDkEBayEOIAEgB2oiAUGAAkkNAAsgB0HBAEkhASASIQcgAQ0ACyAEQTJqIQZBACEDQQAhAQNAIAFBAXQiAiAEQTBqaiIFIAUuAQAiBUGAgITFfWxBEHVB/2VsIAVBoQtsakEQdjsBACACIAZqIgIgAi4BACICQYCAhMV9bEEQdUH/ZWwgAkGhC2xqQRB2OwEAIAFBAmoiAUGAAkcNAAsDQCADQQF0IgEgBEEwamoiAiAEQbAEaiABai8BACACLwEAazsBACABQQJyIgIgBEEwamoiBSAEQbAEaiACai8BACAFLwEAazsBACABQQRyIgIgBEEwamoiBSAEQbAEaiACai8BACAFLwEAazsBACABQQZyIgEgBEEwamoiAiAEQbAEaiABai8BACACLwEAazsBACADQQRqIgNBgAJHDQALQQAhAQNAIARBMGogAUEBdGoiAyADLgEAIgJBv50BbEGAgIAQakEadUH/ZWwgAmo7AQAgA0ECaiIDIAMuAQAiA0G/nQFsQYCAgBBqQRp1Qf9lbCADajsBACABQQJqIgFBgAJHDQALQQAhAwNAIARBsBhqIANqIARBMGogA0EEdGoiAS4BACICQQ92QYEacSACakH//wNxQQF0QYANakGBGm5BAXEgAS4BAiICQQ92QYEacSACakH//wNxQQF0QYANakGBGm5BAXRBAnFyIAEuAQQiAkEPdkGBGnEgAmpB//8DcUEBdEGADWpBgRpuQQJ0QQRxciABLgEGIgJBD3ZBgRpxIAJqQf//A3FBAXRBgA1qQYEabkEDdEEIcXIgAS4BCCICQQ92QYEacSACakH//wNxQQF0QYANakGBGm5BBHRBEHFyIAEuAQoiAkEPdkGBGnEgAmpB//8DcUEBdEGADWpBgRpuQQV0QSBxciABLgEMIgJBD3ZBgRpxIAJqQf//A3FBAXRBgA1qQYEabkEGdEHAAHFyIAEuAQ4iAUEPdkGBGnEgAWpB//8DcUEBdEGADWpBgRpuQQd0cjoAACADQQFqIgNBIEcNAAsgBEHgGGogCEGwDGr9AAAA/QsEACAEIAj9AACgDP0LBNAYIARBsAhqIARBsBhqQcAAEMkEIARBsBBqIARBsBhqIAhBgAZqIARB0AhqIgUQ1ARBACECQQAhAQNAIAFBA3IiAyAEQbAQamotAAAgAyAJai0AAHMgAUECciIDIARBsBBqai0AACADIAlqLQAAcyAEQbAQaiABai0AACABIAlqLQAAcyACciABQQFyIgMgBEGwEGpqLQAAIAMgCWotAABzcnJyIQIgAUEEaiIBQYAGRw0ACyAFIAlBgAYQzgQgCEHADGohA0EAIQEgAkH/AXEhAgNAIARBsAhqIAFqIgUgASADaiAFIAIbLQAAOgAAIAFBAXIiBSAEQbAIamoiBiADIAVqIAYgAhstAAA6AAAgAUECciIFIARBsAhqaiIGIAMgBWogBiACGy0AADoAACABQQNyIgUgBEGwCGpqIgYgAyAFaiAGIAIbLQAAOgAAIAFBBGoiAUEgRw0ACyAQQSAgBEGwCGpBwAAQswQgD0EgNgIAQQAhA0EBIQELIAsQmgEgDBCaASABRQRAIAQgAzYCFCAEQe/HKzYCECAAQfyIKiAEQRBqEGwACyAEQe/HKzYCACAAQeCHKiAEEJsBIARBsBxqJABBAQv/QgIWfwN7IwAiASESIAFBwIIBa0FgcSIBJAAgAUGuvSo2AjAgAEH5hiogAUEwahCbAQJAIAECfwJAIABBAUHB4ikQ3AEiAgRAQaX4KiACKAIAQSBHDQIaIAEgAigCCCIC/QAAEP0LBFAgASAC/QAAAP0LBEAMAQtBACECQZCWNCgCACEEA0AgAUFAayACaiAEKAIkEGk6AAAgAkEBaiICQSBHDQALCwJAIABBAkHB4ikQ3AEiAgRAQaX4KiACKAIAQSBHDQIaIAEgAigCCCIC/QAAEP0LBHAgASAC/QAAAP0LBGAMAQtBkJY0KAIAIQRBICECA0AgAUFAayACaiAEKAIkEGk6AAAgAkEBaiICQcAARw0ACwtBACEEIAAoAhQoAgBBGGoiAiAAKAIMTwRAIAAoAhBBLGohAgsCQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRhqIgIgACgCDEkNACAAKAIQQSxqIQILIAIoAgBBEGohBAsCQAJAIARB9u4rIAQbIgJB9u4rEK0BBEAgAkGN5isQrQFFDQEgAkGe7CsQrQENAkEAIQIgAEEAQQIQoQEgAEHgGBCGASEKIAAgACgCDEEQa0Hf/yoQWSAAQaAMEIYBIQwgACAAKAIMQRBrQe/GKxBZIAooAgghAyAMKAIIIQkgASAB/QAEUP0LBJAEIAEgAf0ABED9CwSABCABQQQ6AKAEIAFBwMIAakHIACABQYAEakEhQQYQ1wQgAUHAwgBqENgEA0AgAUHABWogAmogAUHAwgBqIAJqLQAAOgAAIAJBAXIiBCABQcAFamogAUHAwgBqIARqLQAAOgAAIAJBAnIiBCABQcAFamogAUHAwgBqIARqLQAAOgAAIAJBA3IiBCABQcAFamogAUHAwgBqIARqLQAAOgAAIAJBBGoiAkHAAEcNAAtBACECIAFBwMIAakEAQcgB/AsAIAEgAf0ABMAFIhf9CwTAMiABIAH9AATQBSIY/QsE0DIgASAX/QsEwCIgASAY/QsE0CIgASAY/QsE0BIgASAX/QsEwBIgASABQcAKajYCvAkgASABQcASajYCuAkgASABQcAiajYCtAkgASABQcAyajYCsAkgASAB/QAE0AX9CwTQCiABIAH9AATABf0LBMAKIAFB4DJqIgRBADsBACABQeAiaiIGQQE7AQAgAUHgEmoiBUECOwEAIAFB4ApqIghBAzsBACABQcDCAGogAUGwCWoQ2QQgBkGBAjsBACAEQYACOwEAIAVBggI7AQAgCEGDAjsBACABQcDSAGoiByABQbAJahDZBCAGQYEEOwEAIARBgAQ7AQAgBUGCBDsBACAIQYMEOwEAIAFBwOIAaiIOIAFBsAlqENkEIAZBgQY7AQAgBEGABjsBACAFQYIGOwEAIAhBgwY7AQAgAUHA8gBqIgsgAUGwCWoQ2QQgBEEAOwEAIAH9DAAAAAAAAAAAAAAAAAAAAAAiF/0LBNAyIAEgF/0LBMAyIAZBADsBACABIBf9CwTQIiABIBf9CwTAIiAFQQA7AQAgASAX/QsE0BIgASAX/QsEwBIgCEEAOwEAIAEgF/0LBNAKIAEgF/0LBMAKIAFBwBJqIAFBwBZqIAFBwBpqIAFBwB5qIAFB4AVqIgRBAEEBQQJBAxDaBCABQcAyaiABQcA2aiABQcA6aiABQcA+aiAEQQRBBUEGQQcQ2gQgAUHAEmoQ2wQgAUHAMmoQ2wQgAUHACmogAUHAEmoQ3AQgAUHAImogAUHAwgBqIAFBwBJqIAFBwApqEN0EIAFBwCZqIgUgByABQcASaiABQcAKahDdBCABQcAqaiIIIA4gAUHAEmogAUHACmoQ3QQgAUHALmoiByALIAFBwBJqIAFBwApqEN0EA0AgAUHAImogAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALQQAhAgNAIAUgAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALQQAhAgNAIAggAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALQQAhAgNAIAcgAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALIAFBwCJqIAFBwDJqEN4EIAFBwCJqEN8EIAFBwBJqEN8EIAMgAUHAEmoQ4AQgCSABQcAiahDgBCAJQZAMaiAB/QAE0AX9CwAAIAkgAf0ABMAF/QsAgAwgASAX/QsE4AUgASAX/QsE8AUgAUIANwPABSABQgA3A8gFIAFCADcD0AUgAUIANwPYBSABQQA6AKAEIAEgF/0LBJAEIAEgF/0LBIAEIAFBwMIAakEAQYDAAPwLAEEAIQIgAUHAMmpBAEGAEPwLACACRQRAIAFBwBJqQQBBgBD8CwALIAFBwApqQQBBgAj8CwAgA0GADGogCUGgDPwKAAAgAUHAwgBqQYgBIAlBoAxBBhDXBCABQcDCAGoQ2AQgAyABLQDAQjoAoBggAyABLQDBQjoAoRggAyABLQDCQjoAohggAyABLQDDQjoAoxggAyABLQDEQjoApBggAyABLQDFQjoApRggAyABLQDGQjoAphggAyABLQDHQjoApxggAyABLQDIQjoAqBggAyABLQDJQjoAqRggAyABLQDKQjoAqhggAyABLQDLQjoAqxggAyABLQDMQjoArBggAyABLQDNQjoArRggAyABLQDOQjoArhggAyABLQDPQjoArxggAyABLQDQQjoAsBggAyABLQDRQjoAsRggAyABLQDSQjoAshggAyABLQDTQjoAsxggAyABLQDUQjoAtBggAyABLQDVQjoAtRggAyABLQDWQjoAthggAyABLQDXQjoAtxggAyABLQDYQjoAuBggAyABLQDZQjoAuRggAyABLQDaQjoAuhggAyABLQDbQjoAuxggAyABLQDcQjoAvBggAyABLQDdQjoAvRggAyABLQDeQjoAvhggAyABLQDfQjoAvxggAUHAwgBqQQBByAH8CwAgA0HQGGogAf0ABHD9CwAAIAMgAf0ABGD9CwDAGCAMQaAMNgIAIApB4Bg2AgAMBAtBACECIABBAEECEKEBIABB4AwQhgEhECAAIAAoAgxBEGtB3/8qEFkgAEGgBhCGASERIAAgACgCDEEQa0HvxisQWSAQKAIIIQcgESgCCCENIAEgAf0ABFD9CwSQASABIAH9AARA/QsEgAEgAUECOgCgASABQcDCAGpByAAgAUGAAWpBIUEGENcEIAFBwMIAahDYBANAIAFBwAFqIAJqIAFBwMIAaiACai0AADoAACACQQFyIgQgAUHAAWpqIAFBwMIAaiAEai0AADoAACACQQJyIgQgAUHAAWpqIAFBwMIAaiAEai0AADoAACACQQNyIgQgAUHAAWpqIAFBwMIAaiAEai0AADoAACACQQRqIgJBwABHDQALQQAhBCABQcDCAGpBAEHIAfwLACABIAH9AATAASIX/QsEwDIgASAB/QAE0AEiGP0LBNAyIAEgF/0LBMAiIAEgGP0LBNAiIAEgGP0LBNASIAEgF/0LBMASIAEgAUHACmo2AswFIAEgAUHAEmo2AsgFIAEgAUHAImo2AsQFIAEgAUHAMmo2AsAFIAEgAf0ABNAB/QsE0AogASAB/QAEwAH9CwTACiABQeAyaiIGQQA7AQAgAUHgImoiA0EBOwEAIAFB4BJqIgJBgAI7AQAgAUHgCmoiBUGBAjsBACABQcDCAGogAUHABWoQ2QQgBkEAOwEAIAH9DAAAAAAAAAAAAAAAAAAAAAAiF/0LBNAyIAEgF/0LBMAyIANBADsBACABIBf9CwTQIiABIBf9CwTAIiACQQA7AQAgASAX/QsE0BIgASAX/QsEwBIgBUEAOwEAIAEgF/0LBNAKIAEgF/0LBMAKIAEgAf0ABOABIhj9CwTAAyABIAFB8AFqIgb9AAQAIhn9CwTQAyABIBj9CwSAAyABIBn9CwSQAyABIAH9AATgAf0LBMACIAEgBv0ABAD9CwTQAiABIAb9AAQA/QsEkAIgASAB/QAE4AH9CwSAAiABQQA6AOADIAFBAToAoAMgAUECOgDgAiABQQM6AKACQQAhBiABQcAyakEAQaAG/AsAIAFBwDJqQYgBIAFBwANqIAFBgANqIAFBwAJqIAFBgAJqQSEQ4QQgAUHAMmoQ2AQgAUGINGoiAxDYBCABQdA1aiIFENgEIAFBmDdqIggQ2AQgAUHAMmogAUHAImogAUHACmogAUHABWogAUGABGpBiAEQ4gQgAUHAMmoQ2AQgAxDYBCAFENgEIAgQ2AQgAUHAMmogAUHAEmogAUGwCWogAUGgCGogAUGQB2pBiAEQ4gQgAUH4I2ogAUHwEmopAwA3AwAgAUHoI2ogAv0ABAD9CwMAIAFB2CNqIAFB0BJq/QAEAP0LAwAgAUHQC2ogAf0AA7gJ/QsDACABQeALaiABQcgJav0AAwD9CwMAIAFB8AtqIAFB2Alq/QADAP0LAwAgASABQcAIav0ABAD9CwPoBiABIAFBsAhq/QAEAP0LA9gGIAEgAUHQCGopAwA3A/gGIAEgAf0ABMAS/QsDyCMgASABKQOwCTcDyAsgASAB/QAEoAj9CwPIBiABIAEpA8AHNwO4BSABIAH9AASwB/0LA6gFIAEgAf0ABKAH/QsDmAUgASAB/QAEkAf9CwOIBSAGRQRAIAFBwDJqQQBBoAb8CwALQQAhAiABQcASakEAQYgB/AsAIAJFBEAgAUGwCWpBAEGIAfwLAAsgAkUEQCABQaAIakEAQYgB/AsACyACRQRAIAFBkAdqQQBBiAH8CwALA0AgAUHAEmogBEEDdGoiBiABQcAiaiAEQQNsaiICLwAAIAItAAJBEHRyIgJBAXZByaSSAXEgAkHJpJIBcWogAkECdkHJpJIBcWoiAkEGdkEHcSACQQl2QQdxazsBAiAGIAJBB3EgAkEDdkEHcWs7AQAgBiACQQx2QQdxIAJBD3ZBB3FrOwEEIAYgAkESdkEHcSACQRV2azsBBiAEQQFqIgRBwABHDQALIAFBwBZqIQRBACEGQQAhAwNAIAQgA0EDdGoiBSABQcAKaiADQQNsaiICLwAAIAItAAJBEHRyIgJBAXZByaSSAXEgAkHJpJIBcWogAkECdkHJpJIBcWoiAkEGdkEHcSACQQl2QQdxazsBAiAFIAJBB3EgAkEDdkEHcWs7AQAgBSACQQx2QQdxIAJBD3ZBB3FrOwEEIAUgAkESdkEHcSACQRV2azsBBiADQQFqIgNBwABHDQALA0AgAUHAMmogBkEDdGoiAyABQcAFaiAGQQNsaiICLwAAIAItAAJBEHRyIgJBAXZByaSSAXEgAkHJpJIBcWogAkECdkHJpJIBcWoiAkEGdkEHcSACQQl2QQdxazsBAiADIAJBB3EgAkEDdkEHcWs7AQAgAyACQQx2QQdxIAJBD3ZBB3FrOwEEIAMgAkESdkEHcSACQRV2azsBBiAGQQFqIgZBwABHDQALIAFBwDZqIQVBACEGA0AgBSAGQQN0aiIDIAFBgARqIAZBA2xqIgIvAAAgAi0AAkEQdHIiAkEBdkHJpJIBcSACQcmkkgFxaiACQQJ2QcmkkgFxaiICQQZ2QQdxIAJBCXZBB3FrOwECIAMgAkEHcSACQQN2QQdxazsBACADIAJBDHZBB3EgAkEPdkEHcWs7AQQgAyACQRJ2QQdxIAJBFXZrOwEGIAZBAWoiBkHAAEcNAAtBACEDQQAhAiABQcAiakEAQcAB/AsAIAJFBEAgAUHACmpBAEHAAfwLAAsgAkUEQCABQcAFakEAQcAB/AsACyACRQRAIAFBgARqQQBBwAH8CwALIAFBADoA4AMgASAX/QsE0AMgASAX/QsEwAMgAUEAOgCgAyABIBf9CwSQAyABIBf9CwSAAyABQQA6AOACIAEgF/0LBNACIAEgF/0LBMACIAFBADoAoAIgASAX/QsEkAIgASAX/QsEgAIgAUHAEmoQ4wQgAUHAMmoQ4wQgAUHACmogAUHAEmoQ5AQgAUHAxgBqIQUDQCAEIANBAnQiAkECciIGai4BACEIIAFBwCJqIAJqIAUgBmouAQAiCiABQcAKaiADQQF0aiIJLgGAAmwgCS4BACABQcDCAGogBmouAQAiCWwgAUHAEmogAmouAQAiDCABQcDCAGogAmouAQAiDmxqaiACIARqLgEAIgsgAiAFai4BACICbGoiD0GAgISYf2xBEHVB/2VsIA9qQRB2OwEAIAFBwCJqIAZqIAkgDGwgDiABQcASaiAGai4BAGxqIAogC2xqIAIgCGxqIgJBgICEmH9sQRB1Qf9lbCACakEQdjsBACADQQFqIgNBgAFHDQALIAFBwM4AaiEJIAFBwMoAaiEKIAFBwCZqIQZBACEIQQAhBQNAIAQgBUECdCICQQJyIgNqLgEAIQwgAUHAEmogA2ouAQAhDiACIAZqIAMgCWouAQAiDyABQcAKaiAFQQF0aiILLgGAAmwgCy4BACADIApqLgEAIgtsIAFBwBJqIAJqLgEAIhMgAiAKai4BACIUbGpqIAIgBGouAQAiFSACIAlqLgEAIgJsaiIWQYCAhJh/bEEQdUH/ZWwgFmpBEHY7AQAgAyAGaiALIBNsIA4gFGxqIA8gFWxqIAIgDGxqIgJBgICEmH9sQRB1Qf9lbCACakEQdjsBACAFQQFqIgVBgAFHDQALA0AgAUHAImogCEEBdGoiAiACLgEAIgNBgICkggVsQRB1Qf9lbCADQckKbGpBEHY7AQAgAkECaiICIAIuAQAiAkGAgKSCBWxBEHVB/2VsIAJByQpsakEQdjsBACAIQQJqIghBgAJHDQALQQAhAgNAIAYgAkEBdGoiAyADLgEAIgVBgICkggVsQRB1Qf9lbCAFQckKbGpBEHY7AQAgA0ECaiIDIAMuAQAiA0GAgKSCBWxBEHVB/2VsIANByQpsakEQdjsBACACQQJqIgJBgAJHDQALIAFBwCJqIAFBwDJqEOUEQQAhCEEAIQUDQEEAIAFBwCJqIAVBAXRqIgkuAQAiAkG/nQFsQYCAgBBqQRp1Qf9lbCACaiICwUEQdmshAyAJIAJBgRpqIAJzIANBEHZxIAJzOwEAIAVBAWoiBUGAAkcNAAsDQEEAIQVBACAGIAhBAXRqIgkuAQAiAkG/nQFsQYCAgBBqQRp1Qf9lbCACaiICwUEQdmshAyAJIAJBgRpqIAJzIANBEHZxIAJzOwEAIAhBAWoiCEGAAkcNAAsDQEEAIQhBACABQcASaiAFQQF0aiIJLgEAIgJBv50BbEGAgIAQakEadUH/ZWwgAmoiAsFBEHZrIQMgCSACQYEaaiACcyADQRB2cSACczsBACAFQQFqIgVBgAJHDQALA0AgBCAIQQF0aiIJLgEAIgJBv50BbEGAgIAQakEadUH/ZWwgAmoiA8EhBUEAIQIgCSADQYEaaiADc0EAIAVBEHZrQRB2cSADczsBACAIQQFqIghBgAJHDQALA0AgAUHAEmogAkECdGoiCC8BAiEDIAcgAkEDbGoiBSAILwEAIgg6AAAgBSADQQR2OgACIAUgA0EEdCAIQQh2cjoAASACQQFqIgJBgAFHDQALIAdBgANqIQpBACECQQAhAwNAIAQgA0ECdGoiCS8BAiEFIAogA0EDbGoiCCAJLwEAIgk6AAAgCCAFQQR2OgACIAggBUEEdCAJQQh2cjoAASADQQFqIgNBgAFHDQALA0AgAUHAImogAkECdGoiBS8BAiEEIA0gAkEDbGoiAyAFLwEAIgU6AAAgAyAEQQR2OgACIAMgBEEEdCAFQQh2cjoAASACQQFqIgJBgAFHDQALIA1BgANqIQhBACECA0AgBiACQQJ0aiIFLwECIQQgCCACQQNsaiIDIAUvAQAiBToAACADIARBBHY6AAIgAyAEQQR0IAVBCHZyOgABIAJBAWoiAkGAAUcNAAsgDSAB/QAEwAH9CwCABiANIAH9AATQAf0LAJAGIAEgF/0LBOABIAEgF/0LBPABIAFCADcDwAEgAUIANwPIASABQgA3A9ABIAFCADcD2AEgAUEAOgCgASABIBf9CwSQASABIBf9CwSAASABQcDCAGpBAEGAEPwLAEEAIQIgAUHAMmpBAEGACPwLACACRQRAIAFBwBJqQQBBgAj8CwALIAFBwApqQQBBgAT8CwAgB0GABmogDUGgBvwKAAAgAUHAwgBqQYgBIA1BoAZBBhDXBCABQcDCAGoQ2AQgByABLQDAQjoAoAwgByABLQDBQjoAoQwgByABLQDCQjoAogwgByABLQDDQjoAowwgByABLQDEQjoApAwgByABLQDFQjoApQwgByABLQDGQjoApgwgByABLQDHQjoApwwgByABLQDIQjoAqAwgByABLQDJQjoAqQwgByABLQDKQjoAqgwgByABLQDLQjoAqwwgByABLQDMQjoArAwgByABLQDNQjoArQwgByABLQDOQjoArgwgByABLQDPQjoArwwgByABLQDQQjoAsAwgByABLQDRQjoAsQwgByABLQDSQjoAsgwgByABLQDTQjoAswwgByABLQDUQjoAtAwgByABLQDVQjoAtQwgByABLQDWQjoAtgwgByABLQDXQjoAtwwgByABLQDYQjoAuAwgByABLQDZQjoAuQwgByABLQDaQjoAugwgByABLQDbQjoAuwwgByABLQDcQjoAvAwgByABLQDdQjoAvQwgByABLQDeQjoAvgwgByABLQDfQjoAvwwgAUHAwgBqQQBByAH8CwAgB0HQDGogAf0ABHD9CwAAIAcgAf0ABGD9CwDADCARQaAGNgIAIBBB4Aw2AgAMAwtBACECIABBAEECEKEBIABB4BIQhgEhCSAAIAAoAgxBEGtB3/8qEFkgAEGgCRCGASEKIAAgACgCDEEQa0HvxisQWSAJKAIIIQMgCigCCCEHIAEgAf0ABFD9CwSQBCABIAH9AARA/QsEgAQgAUEDOgCgBCABQcDCAGpByAAgAUGABGpBIUEGENcEIAFBwMIAahDYBANAIAFBwAVqIAJqIAFBwMIAaiACai0AADoAACACQQFyIgQgAUHABWpqIAFBwMIAaiAEai0AADoAACACQQJyIgQgAUHABWpqIAFBwMIAaiAEai0AADoAACACQQNyIgQgAUHABWpqIAFBwMIAaiAEai0AADoAACACQQRqIgJBwABHDQALQQAhAiABQcDCAGpBAEHIAfwLACABQcDCAGogAUHABWpBABDmBCABQcASaiABQcAWaiABQcAaaiABQcAiaiABQeAFaiIEQQBBAUECQf8BENoEIAFBwDJqIAFBwDZqIAFBwDpqIAFBwCJqIARBA0EEQQVB/wEQ2gQgAUHAEmoQ5wQgAUHAMmoQ5wQgAUHACmogAUHAEmoQ6AQgAUHAImogAUHAwgBqIAFBwBJqIAFBwApqEOkEIAFBwCZqIgUgAUHAzgBqIAFBwBJqIAFBwApqEOkEIAFBwCpqIgggAUHA2gBqIAFBwBJqIAFBwApqEOkEA0AgAUHAImogAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALQQAhAgNAIAUgAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALQQAhAgNAIAggAkEBdGoiBCAELgEAIgZBgICkggVsQRB1Qf9lbCAGQckKbGpBEHY7AQAgBEECaiIEIAQuAQAiBEGAgKSCBWxBEHVB/2VsIARByQpsakEQdjsBACACQQJqIgJBgAJHDQALIAFBwCJqIAFBwDJqEOoEIAFBwCJqEOsEIAFBwBJqEOsEIAMgAUHAEmoQ7AQgByABQcAiahDsBCAHQZAJaiAB/QAE0AX9CwAAIAcgAf0ABMAF/QsAgAkgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBOAFIAEgF/0LBPAFIAFCADcDwAUgAUIANwPIBSABQgA3A9AFIAFCADcD2AUgAUEAOgCgBCABIBf9CwSQBCABIBf9CwSABCABQcDCAGpBAEGAJPwLAEEAIQIgAUHAMmpBAEGADPwLACACRQRAIAFBwBJqQQBBgAz8CwALIAFBwApqQQBBgAb8CwAgA0GACWogB0GgCfwKAAAgAUHAwgBqQYgBIAdBoAlBBhDXBCABQcDCAGoQ2AQgAyABLQDAQjoAoBIgAyABLQDBQjoAoRIgAyABLQDCQjoAohIgAyABLQDDQjoAoxIgAyABLQDEQjoApBIgAyABLQDFQjoApRIgAyABLQDGQjoAphIgAyABLQDHQjoApxIgAyABLQDIQjoAqBIgAyABLQDJQjoAqRIgAyABLQDKQjoAqhIgAyABLQDLQjoAqxIgAyABLQDMQjoArBIgAyABLQDNQjoArRIgAyABLQDOQjoArhIgAyABLQDPQjoArxIgAyABLQDQQjoAsBIgAyABLQDRQjoAsRIgAyABLQDSQjoAshIgAyABLQDTQjoAsxIgAyABLQDUQjoAtBIgAyABLQDVQjoAtRIgAyABLQDWQjoAthIgAyABLQDXQjoAtxIgAyABLQDYQjoAuBIgAyABLQDZQjoAuRIgAyABLQDaQjoAuhIgAyABLQDbQjoAuxIgAyABLQDcQjoAvBIgAyABLQDdQjoAvRIgAyABLQDeQjoAvhIgAyABLQDfQjoAvxIgAUHAwgBqQQBByAH8CwAgA0HQEmogAf0ABHD9CwAAIAMgAf0ABGD9CwDAEiAKQaAJNgIAIAlB4BI2AgAMAgsgAUGuvSo2AiBBjfkrIAIgAUEgahBuQY6QKgs2AhQgAUGuvSo2AhAgAEH8iCogAUEQahBsAAsgAUGuvSo2AgAgAEHghyogARCbASASJABBAQunBAEFfyAAQQBByAH8CwACQAJAAkAgASADTQRAIAFB/AFxIQkgAUEDcSEIA0BBACEFA0AgACAFaiIGIAYtAAAgAiAFai0AAHM6AAAgACAFQQFyIgZqIgcgBy0AACACIAZqLQAAczoAACAAIAVBAnIiBmoiByAHLQAAIAIgBmotAABzOgAAIAAgBUEDciIGaiIHIActAAAgAiAGai0AAHM6AAAgBUEEaiIFIAlHDQALQQAhBiAIBEADQCAAIAVqIgcgBy0AACACIAVqLQAAczoAACAFQQFqIQUgBkEBaiIGIAhHDQALCyAAENgEIAEgAmohAiADIAFrIgMgAU8NAAsgA0UEQEEAIQMMBAsgA0EDcSEIQQAhBSADQQRJDQIMAQsgA0EDcSEICyADQfwBcSEJA0AgACAFaiIGIAYtAAAgAiAFai0AAHM6AAAgACAFQQFyIgZqIgcgBy0AACACIAZqLQAAczoAACAAIAVBAnIiBmoiByAHLQAAIAIgBmotAABzOgAAIAAgBUEDciIGaiIHIActAAAgAiAGai0AAHM6AAAgBUEEaiIFIAlHDQALCyAIRQ0AQQAhBgNAIAAgBWoiByAHLQAAIAIgBWotAABzOgAAIAVBAWohBSAGQQFqIgYgCEcNAAsLIAFBAWsiAiADRgR/IARBgH9yBSAAIANqIgUgBS0AACAEczoAACACIQNBgAELIQUgACADaiICIAItAAAgBXM6AAAL5AwCLX4CfyAAKQPAASEVIAApA7gBIR0gACkDsAEhDCAAKQOoASENIAApA6ABIQ4gACkDmAEhDyAAKQOQASELIAApA4gBIRYgACkDgAEhBiAAKQN4IRcgACkDcCEQIAApA2ghByAAKQNgIQggACkDWCERIAApA1AhCSAAKQNIIRIgACkDQCETIAApAzghFCAAKQMwIRggACkDKCEKIAApAyAhGSAAKQMYIRogACkDECEbIAApAwghAiAAKQMAIRwDQCALIB2FIAeFIBOFIBqFIgMgDiAXhSAJhSAKhSAchSIBQgGJhSIEIBmFQhuJIh8gASAMIBaFIAiFIBSFIBuFIh5CAYmFIgEgEYVCCokiISAPIBWFIBCFIBKFIBmFIhkgBiANhSARhSAYhSAChSIgQgGJhSIFIAqFQiSJIhFCf4WDhSIiIAEgAoVCAYkiCiAeIBlCAYmFIgIgB4VCGYkiByAgIANCAYmFIgMgFIVCBokiFEJ/hYOFIiCFIAIgGoVCHIkiGSAFIAmFQgOJIgkgBCAShUIUiSISQn+Fg4UiI4UgAyAbhUI+iSIaIAQgEIVCJ4kiECACIBOFQjeJIhNCf4WDhSIkhSAFIByFIhsgLkEDdCIvQcDKMWopAwAgAyAIhUIriSIIIAEgGIVCLIkiGEJ/hYOFhSIlhSIeQgGJIAQgD4VCCIkiDyAKIAUgDoVCEokiDkJ/hYOFIiYgASAGhUItiSIGIBkgAyAMhUI9iSIMQn+Fg4UiJ4UgBSAXhUIpiSIFIBogASANhUICiSIBQn+Fg4UiKIUgAiALhUIViSINIBsgBCAVhUIOiSIVQn+Fg4UiKYUgAyAWhUIPiSIDIB8gAiAdhUI4iSICQn+Fg4UiKoUiHYUiBCABIBMgGkJ/hYOFIguFQg6JIhwgHiAOIA9Cf4WDIAeFIisgFSANQn+FgyAIhSIWIBAgASAFQn+Fg4UiLCAMIAZCf4WDIAmFIhogISACIANCf4WDhSIthYWFhSIXQgGJhSIBIBIgBiAJQn+Fg4UiBoVCLIkiHiAlIBUgGCAbQn+Fg4UiCSALhSAUIApCf4WDIA6FIguFIBIgGUJ/hYMgDIUiCoUgESAfQn+FgyAChSIbhSICIA8gB0J/hYMgFIUiByAGIBggDSAIQn+Fg4UiCIUgAyAhQn+FgyARhSIYhYUgBSAQQn+FgyAThSIDhSIVQgGJhSIFhSIfQn+Fg4UhGSABIAOFQgKJIgwgAkIBiSAXhSICICeFQjeJIg4gHUIBiSAVhSIDIBaFQj6JIg9Cf4WDhSEVIAUgIoVCKYkiDSAPIAxCf4WDhSEdIAQgC4VCJ4kiCyAMIA1Cf4WDhSEMIA0gC0J/hYMgDoUhDSALIA5Cf4WDIA+FIQ4gAiAohUI4iSIWIAUgI4VCJIkiFyAEIAmFQhuJIhBCf4WDhSEPIAMgLYVCD4kiBiAQIBZCf4WDhSELIAEgB4VCCokiByAWIAZCf4WDhSEWIAYgB0J/hYMgF4UhBiAQIAcgF0J/hYOFIRcgAyAahUIGiSIJIAEgCIVCAYkiEkJ/hYMgBSAkhUISiSIIhSEQIAQgG4VCCIkiESASIAhCf4WDhSEHIAIgJoVCGYkiEyAIIBFCf4WDhSEIIBEgE0J/hYMgCYUhESASIBMgCUJ/hYOFIQkgAyAshUI9iSIUIAQgCoVCFIkiBCACICmFQhyJIgpCf4WDhSESIAEgGIVCLYkiASAKIBRCf4WDhSETIAUgIIVCA4kiBSAUIAFCf4WDhSEUIAQgASAFQn+Fg4UhGCAFIARCf4WDIAqFIQogAiAqhUIViSIEIB8gHEJ/hYOFIRogAyArhUIriSIBIBwgBEJ/hYOFIRsgHiAEIAFCf4WDhSECIC9ByMoxaikDACABIB5Cf4WDhSAfhSEcIC5BFkkhLyAuQQJqIS4gLw0ACyAAIBU3A8ABIAAgHTcDuAEgACAMNwOwASAAIA03A6gBIAAgDjcDoAEgACAPNwOYASAAIAs3A5ABIAAgFjcDiAEgACAGNwOAASAAIBc3A3ggACAQNwNwIAAgBzcDaCAAIAg3A2AgACARNwNYIAAgCTcDUCAAIBI3A0ggACATNwNAIAAgFDcDOCAAIBg3AzAgACAKNwMoIAAgGTcDICAAIBo3AxggACAbNwMQIAAgAjcDCCAAIBw3AwALmA4BE38jACIFIRQgBUGgFmtBYHEiAyQAIAEoAgwhBSABKAIIIQQgASgCBCEGIAEoAgAhASADQQBBoAb8CwAgA0GoASABIAYgBCAFQSIQ4QQgAxDYBCADQcgBaiINENgEIANBkANqIg4Q2AQgA0HYBGoiDxDYBCADIANBoBJqIANBoA5qIANBoApqIANBoAZqQagBEOIEIAMQ2AQgDRDYBCAOENgEIA8Q2AQgAyADQcgTaiADQcgPaiADQcgLaiADQcgHakGoARDiBCADENgEIA0Q2AQgDhDYBCAPENgEIAMgA0HwFGogA0HwEGogA0HwDGogA0HwCGpBqAEQ4gRBAyEFQQAhBANAIAUhASADQaASaiAEaiIFLQABIgRBCHRBgB5xIAUtAAByIgZBgBpNBEAgACAIQQF0aiAGOwEAIAhBAWohCAsCQCAIQf8BSw0AIAUtAAJBBHQgBEEEdnIiBUGAGksNACAAIAhBAXRqIAU7AQAgCEEBaiEICyAIQf8BTQRAIAFBA2ohBSABIQQgAUH2A0kNAQsLIAhBgAJJIRAgAEGABGohCkEAIQFBAyEEQQAhBgNAIAQhBSADQaAOaiAGaiIELQABIgZBCHRBgB5xIAQtAAByIgJBgBpNBEAgCiABQQF0aiACOwEAIAFBAWohAQsCQCABQf8BSw0AIAQtAAJBBHQgBkEEdnIiBEGAGksNACAKIAFBAXRqIAQ7AQAgAUEBaiEBCyABQf8BTQRAIAVBA2ohBCAFIQYgBUH2A0kNAQsLIAFBgAJJIREgAEGACGohC0EAIQVBAyEGQQAhAgNAIAYhBCADQaAKaiACaiIGLQABIgJBCHRBgB5xIAYtAAByIgdBgBpNBEAgCyAFQQF0aiAHOwEAIAVBAWohBQsCQCAFQf8BSw0AIAYtAAJBBHQgAkEEdnIiBkGAGksNACALIAVBAXRqIAY7AQAgBUEBaiEFCyAFQf8BTQRAIARBA2ohBiAEIQIgBEH2A0kNAQsLIAVBgAJJIRIgAEGADGohDEEAIQRBAyECQQAhBwNAIAIhBiADQaAGaiAHaiICLQABIgdBCHRBgB5xIAItAAByIglBgBpNBEAgDCAEQQF0aiAJOwEAIARBAWohBAsCQCAEQf8BSw0AIAItAAJBBHQgB0EEdnIiAkGAGksNACAMIARBAXRqIAI7AQAgBEEBaiEECyAEQf8BTQRAIAZBA2ohAiAGIQcgBkH2A0kNAQsLIARBgAJJIRMCQAJAIAhBgAJJDQAgAUGAAkkNACAFQYACSQ0AIARB/wFLDQELA0AgAxDYBCANENgEIA4Q2AQgDxDYBCADIANBoBJqIANBoA5qIANBoApqIANBoAZqQagBEOIEAkAgEEUNAEEAIQJBAyEHA0AgByEGIANBoBJqIAJqIgItAAEiB0EIdEGAHnEgAi0AAHIiCUGAGk0EQCAAIAhBAXRqIAk7AQAgCEEBaiEICwJAIAhB/wFLDQAgAi0AAkEEdCAHQQR2ciICQYAaSw0AIAAgCEEBdGogAjsBACAIQQFqIQgLIAhB/wFLDQEgBkEDaiEHIAYiAkGmAUkNAAsLAkAgEUUNAEEAIQJBAyEHA0AgByEGIANBoA5qIAJqIgItAAEiB0EIdEGAHnEgAi0AAHIiCUGAGk0EQCAKIAFBAXRqIAk7AQAgAUEBaiEBCwJAIAFB/wFLDQAgAi0AAkEEdCAHQQR2ciICQYAaSw0AIAogAUEBdGogAjsBACABQQFqIQELIAFB/wFLDQEgBkEDaiEHIAYiAkGmAUkNAAsLAkAgEkUNAEEAIQJBAyEHA0AgByEGIANBoApqIAJqIgItAAEiB0EIdEGAHnEgAi0AAHIiCUGAGk0EQCALIAVBAXRqIAk7AQAgBUEBaiEFCwJAIAVB/wFLDQAgAi0AAkEEdCAHQQR2ciICQYAaSw0AIAsgBUEBdGogAjsBACAFQQFqIQULIAVB/wFLDQEgBkEDaiEHIAYiAkGmAUkNAAsLAkAgE0UNAEEAIQJBAyEHA0AgByEGIANBoAZqIAJqIgItAAEiB0EIdEGAHnEgAi0AAHIiCUGAGk0EQCAMIARBAXRqIAk7AQAgBEEBaiEECwJAIARB/wFLDQAgAi0AAkEEdCAHQQR2ciICQYAaSw0AIAwgBEEBdGogAjsBACAEQQFqIQQLIARB/wFLDQEgBkEDaiEHIAYiAkGmAUkNAAsLIARBgAJJIRMgBUGAAkkhEiABQYACSSERIAhBgAJJIhANACABQYACSQ0AIAVBgAJJDQAgBEGAAkkNAAsLIANBAEGgBvwLAEEAIQEgA0GgEmpBAEH4A/wLACABRQRAIANBoA5qQQBB+AP8CwALIAFFBEAgA0GgCmpBAEH4A/wLAAsgAUUEQCADQaAGakEAQfgD/AsACyAUJAAL6gUCBH8CeyMAIgkhCyAJQeAQa0FgcSIJJAAgCSAEQRBqIgr9AAAA/QsE0AEgCSAE/QAAAP0LBMABIAkgCv0AAAD9CwSQASAJIAT9AAAA/QsEgAEgCSAE/QAAAP0LBEAgCSAK/QAAAP0LBFAgCv0AAAAhDSAE/QAAACEOIAlB4AFqIgwgBToAACAJQaABaiIFIAY6AAAgCUHgAGoiBiAHOgAAIAlBIGoiByAIOgAAIAkgDf0LBBAgCSAO/QsEAEEAIQogCUHACmpBAEGgBvwLACAJQcAKakGIASAJQcABaiAJQYABaiAJQUBrIAlBIRDhBCAJQcAKahDYBCAJQYgMahDYBCAJQdANahDYBCAJQZgPahDYBCAJQcAKaiAJQbAJaiAJQaAIaiAJQZAHaiAJQYAGakGIARDiBEEAIQQgCUGABWogCUGwCWpBgAH8CgAAIARFBEAgCUGABGogCUGgCGpBgAH8CgAACyAERQRAIAlBgANqIAlBkAdqQYAB/AoAAAsgBEUEQCAJQYACaiAJQYAGakGAAfwKAAALIApFBEAgCUHACmpBAEGgBvwLAAsgCUGwCWpBAEGIAfwLACAKRQRAIAlBoAhqQQBBiAH8CwALIApFBEAgCUGQB2pBAEGIAfwLAAsgCkUEQCAJQYAGakEAQYgB/AsACyAAIAlBgAVqEJQJIAEgCUGABGoQlAkgAiAJQYADahCUCSADIAlBgAJqEJQJIARFBEAgCUGABWpBAEGAAfwLAAsgBEUEQCAJQYAEakEAQYAB/AsACyAERQRAIAlBgANqQQBBgAH8CwALIARFBEAgCUGAAmpBAEGAAfwLAAsgDEEAOgAAIAn9DAAAAAAAAAAAAAAAAAAAAAAiDf0LBNABIAkgDf0LBMABIAVBADoAACAJIA39CwSQASAJIA39CwSAASAGQQA6AAAgCSAN/QsEUCAJIA39CwRAIAdBADoAACAJIA39CwQQIAkgDf0LBAAgCyQAC/QFAQt/QYABIQMDQEGAAiADQQF0IgdodiEEQQAhBgNAIAMgBmohCSAEQQF0QcDIMWouAQAiCkGAgISYf2whCyAGIQUDQCAAIAVBAXRqIgEgB2oiAiABLwEAIAsgAi4BACICbEEQdUH/ZWwgAiAKbGpBEHYiAms7AQAgASABLwEAIAJqOwEAIAVBAWoiBSAJRw0ACyAEQQFqIQQgBiAHaiIGQYACSQ0ACyADQQNLIQEgA0EBdiEDIAENAAsgAEGABGohBkGAASEIA0BBgAIgCEEBdCIHaHYhA0EAIQQDQCAEIAhqIQkgA0EBdEHAyDFqLgEAIgpBgICEmH9sIQsgBCEFA0AgBiAFQQF0aiIBIAdqIgIgAS8BACALIAIuAQAiAmxBEHVB/2VsIAIgCmxqQRB2IgJrOwEAIAEgAS8BACACajsBACAFQQFqIgUgCUcNAAsgA0EBaiEDIAQgB2oiBEGAAkkNAAsgCEEDSyEBIAhBAXYhCCABDQALIABBgAhqIQZBgAEhCANAQYACIAhBAXQiB2h2IQNBACEEA0AgBCAIaiEJIANBAXRBwMgxai4BACIKQYCAhJh/bCELIAQhBQNAIAYgBUEBdGoiASAHaiICIAEvAQAgCyACLgEAIgJsQRB1Qf9lbCACIApsakEQdiICazsBACABIAEvAQAgAmo7AQAgBUEBaiIFIAlHDQALIANBAWohAyAEIAdqIgRBgAJJDQALIAhBA0shASAIQQF2IQggAQ0ACyAAQYAMaiEAQYABIQMDQEGAAiADQQF0IgdodiEEQQAhBgNAIAMgBmohCSAEQQF0QcDIMWouAQAiCkGAgISYf2whCyAGIQUDQCAAIAVBAXRqIgEgB2oiAiABLwEAIAsgAi4BACICbEEQdUH/ZWwgAiAKbGpBEHYiAms7AQAgASABLwEAIAJqOwEAIAVBAWoiBSAJRw0ACyAEQQFqIQQgBiAHaiIGQYACSQ0ACyADQQNLIQEgA0EBdiEDIAENAAsLnAQBB38DQCAAIAJBAnRqIgMgAkEBdEHAyTFqLgEAIgQgASACQQN0aiIFLgECbCIGQYCAhJh/bEEQdUH/ZWwgBmpBEHY7AQAgAyAFLgEGQQAgBGvBbCIDQYCAhJh/bEEQdUH/ZWwgA2pBEHY7AQIgAkEBaiICQcAARw0ACyABQYAEaiEHIABBgAJqIQhBACECA0AgCCACQQJ0aiIDIAJBAXRBwMkxai4BACIEIAcgAkEDdGoiBS4BAmwiBkGAgISYf2xBEHVB/2VsIAZqQRB2OwEAIAMgBS4BBkEAIARrwWwiA0GAgISYf2xBEHVB/2VsIANqQRB2OwECIAJBAWoiAkHAAEcNAAsgAUGACGohByAAQYAEaiEIQQAhAgNAIAggAkECdGoiAyACQQF0QcDJMWouAQAiBCAHIAJBA3RqIgUuAQJsIgZBgICEmH9sQRB1Qf9lbCAGakEQdjsBACADIAUuAQZBACAEa8FsIgNBgICEmH9sQRB1Qf9lbCADakEQdjsBAiACQQFqIgJBwABHDQALIAFBgAxqIQEgAEGABmohAEEAIQIDQCAAIAJBAnRqIgMgAkEBdEHAyTFqLgEAIgQgASACQQN0aiIFLgECbCIGQYCAhJh/bEEQdUH/ZWwgBmpBEHY7AQAgAyAFLgEGQQAgBGvBbCIDQYCAhJh/bEEQdUH/ZWwgA2pBEHY7AQIgAkEBaiICQcAARw0ACwuHAwEZfyACQYAMaiEIIAFBgAxqIQkgAkGACGohCiABQYAIaiELIAJBgARqIQwgAUGABGohDQNAIAggB0ECdCIEQQJyIgVqLgEAIQ4gBSAKai4BACEPIAUgDGouAQAhECACIAVqLgEAIREgACAEaiAFIAlqLgEAIhIgAyAHQQF0aiIGLgGABmwgBSALai4BACITIAYuAYAEbCAFIA1qLgEAIhQgBi4BgAJsIAYuAQAgASAFai4BACIGbCACIARqLgEAIhUgASAEai4BACIWbGpqIAQgDGouAQAiFyAEIA1qLgEAIhhsamogBCAKai4BACIZIAQgC2ouAQAiGmxqaiAEIAhqLgEAIhsgBCAJai4BACIEbGoiHEGAgISYf2xBEHVB/2VsIBxqQRB2OwEAIAAgBWogBiAVbCARIBZsaiAUIBdsaiAQIBhsaiATIBlsaiAPIBpsaiASIBtsaiAEIA5saiIEQYCAhJh/bEEQdUH/ZWwgBGpBEHY7AQAgB0EBaiIHQYABRw0ACwvQBAEGfwNAIAAgBEEBdCICaiIDIAEgAmovAQAgAy8BAGo7AQAgACACQQJyIgNqIgUgASADai8BACAFLwEAajsBACAAIAJBBHIiA2oiBSABIANqLwEAIAUvAQBqOwEAIAAgAkEGciICaiIDIAEgAmovAQAgAy8BAGo7AQAgBEEEaiIEQYACRw0ACyABQYAEaiEEIABBgARqIQNBACEFA0AgAyAFQQF0IgJqIgYgAiAEai8BACAGLwEAajsBACADIAJBAnIiBmoiByAEIAZqLwEAIAcvAQBqOwEAIAMgAkEEciIGaiIHIAQgBmovAQAgBy8BAGo7AQAgAyACQQZyIgJqIgYgAiAEai8BACAGLwEAajsBACAFQQRqIgVBgAJHDQALIAFBgAhqIQQgAEGACGohA0EAIQUDQCADIAVBAXQiAmoiBiACIARqLwEAIAYvAQBqOwEAIAMgAkECciIGaiIHIAQgBmovAQAgBy8BAGo7AQAgAyACQQRyIgZqIgcgBCAGai8BACAHLwEAajsBACADIAJBBnIiAmoiBiACIARqLwEAIAYvAQBqOwEAIAVBBGoiBUGAAkcNAAsgAUGADGohASAAQYAMaiEAQQAhBANAIAAgBEEBdCICaiIDIAEgAmovAQAgAy8BAGo7AQAgACACQQJyIgNqIgUgASADai8BACAFLwEAajsBACAAIAJBBHIiA2oiBSABIANqLwEAIAUvAQBqOwEAIAAgAkEGciICaiIDIAEgAmovAQAgAy8BAGo7AQAgBEEEaiIEQYACRw0ACwuAAwEFfwNAQQAgACACQQF0aiIDLgEAIgFBv50BbEGAgIAQakEadUH/ZWwgAWoiAcFBEHZrIQQgAyABQYEaaiABcyAEQRB2cSABczsBACACQQFqIgJBgAJHDQALIABBgARqIQVBACECA0BBACAFIAJBAXRqIgMuAQAiAUG/nQFsQYCAgBBqQRp1Qf9lbCABaiIBwUEQdmshBCADIAFBgRpqIAFzIARBEHZxIAFzOwEAIAJBAWoiAkGAAkcNAAsgAEGACGohBUEAIQIDQEEAIAUgAkEBdGoiAy4BACIBQb+dAWxBgICAEGpBGnVB/2VsIAFqIgHBQRB2ayEEIAMgAUGBGmogAXMgBEEQdnEgAXM7AQAgAkEBaiICQYACRw0ACyAAQYAMaiEAQQAhAgNAQQAgACACQQF0aiIDLgEAIgFBv50BbEGAgIAQakEadUH/ZWwgAWoiAcFBEHZrIQQgAyABQYEaaiABcyAEQRB2cSABczsBACACQQFqIgJBgAJHDQALC/QCAQZ/A0AgASACQQJ0aiIDLwECIQQgACACQQNsaiIFIAMvAQAiAzoAACAFIARBBHY6AAIgBSAEQQR0IANBCHZyOgABIAJBAWoiAkGAAUcNAAsgAUGABGohBiAAQYADaiEHQQAhAgNAIAYgAkECdGoiAy8BAiEEIAcgAkEDbGoiBSADLwEAIgM6AAAgBSAEQQR2OgACIAUgBEEEdCADQQh2cjoAASACQQFqIgJBgAFHDQALIAFBgAhqIQYgAEGABmohB0EAIQIDQCAGIAJBAnRqIgMvAQIhBCAHIAJBA2xqIgUgAy8BACIDOgAAIAUgBEEEdjoAAiAFIARBBHQgA0EIdnI6AAEgAkEBaiICQYABRw0ACyABQYAMaiEBIABBgAlqIQBBACECA0AgASACQQJ0aiIDLwECIQQgACACQQNsaiIFIAMvAQAiAzoAACAFIARBBHY6AAIgBSAEQQR0IANBCHZyOgABIAJBAWoiAkGAAUcNAAsLmhYBBX8gBkEDcSELIAAhBwJ/QQAgBkEESQ0AGiAHIActAAAgAi0AAHM6AAAgByAHLQABIAItAAFzOgABIAcgBy0AAiACLQACczoAAiAHIActAAMgAi0AA3M6AANBBCAGQTxxIghBBEYNABogByAHLQAEIAItAARzOgAEIAcgBy0ABSACLQAFczoABSAHIActAAYgAi0ABnM6AAYgByAHLQAHIAItAAdzOgAHQQggCEEIRg0AGiAHIActAAggAi0ACHM6AAggByAHLQAJIAItAAlzOgAJIAcgBy0ACiACLQAKczoACiAHIActAAsgAi0AC3M6AAtBDCAIQQxGDQAaIAcgBy0ADCACLQAMczoADCAHIActAA0gAi0ADXM6AA0gByAHLQAOIAItAA5zOgAOIAcgBy0ADyACLQAPczoAD0EQIAhBEEYNABogByAHLQAQIAItABBzOgAQIAcgBy0AESACLQARczoAESAHIActABIgAi0AEnM6ABIgByAHLQATIAItABNzOgATQRQgCEEURg0AGiAHIActABQgAi0AFHM6ABQgByAHLQAVIAItABVzOgAVIAcgBy0AFiACLQAWczoAFiAHIActABcgAi0AF3M6ABdBGCAIQRhGDQAaIAcgBy0AGCACLQAYczoAGCAHIActABkgAi0AGXM6ABkgByAHLQAaIAItABpzOgAaIAcgBy0AGyACLQAbczoAG0EcIAhBHEYNABogByAHLQAcIAItABxzOgAcIAcgBy0AHSACLQAdczoAHSAHIActAB4gAi0AHnM6AB4gByAHLQAfIAItAB9zOgAfQSALIQkgCwRAA0AgByAJaiIIIAgtAAAgAiAJai0AAHM6AAAgCUEBaiEJIApBAWoiCiALRw0ACwsgB0HIAWohAkEAIQoCf0EAIAZBBEkNABogAiACLQAAIAMtAABzOgAAIAIgAi0AASADLQABczoAASACIAItAAIgAy0AAnM6AAIgAiACLQADIAMtAANzOgADQQQgBkE8cSIIQQRGDQAaIAIgAi0ABCADLQAEczoABCACIAItAAUgAy0ABXM6AAUgAiACLQAGIAMtAAZzOgAGIAIgAi0AByADLQAHczoAB0EIIAhBCEYNABogAiACLQAIIAMtAAhzOgAIIAIgAi0ACSADLQAJczoACSACIAItAAogAy0ACnM6AAogAiACLQALIAMtAAtzOgALQQwgCEEMRg0AGiACIAItAAwgAy0ADHM6AAwgAiACLQANIAMtAA1zOgANIAIgAi0ADiADLQAOczoADiACIAItAA8gAy0AD3M6AA9BECAIQRBGDQAaIAIgAi0AECADLQAQczoAECACIAItABEgAy0AEXM6ABEgAiACLQASIAMtABJzOgASIAIgAi0AEyADLQATczoAE0EUIAhBFEYNABogAiACLQAUIAMtABRzOgAUIAIgAi0AFSADLQAVczoAFSACIAItABYgAy0AFnM6ABYgAiACLQAXIAMtABdzOgAXQRggCEEYRg0AGiACIAItABggAy0AGHM6ABggAiACLQAZIAMtABlzOgAZIAIgAi0AGiADLQAaczoAGiACIAItABsgAy0AG3M6ABtBHCAIQRxGDQAaIAIgAi0AHCADLQAcczoAHCACIAItAB0gAy0AHXM6AB0gAiACLQAeIAMtAB5zOgAeIAIgAi0AHyADLQAfczoAH0EgCyEJIAsEQANAIAIgCWoiCCAILQAAIAMgCWotAABzOgAAIAlBAWohCSAKQQFqIgogC0cNAAsLIAdBkANqIQJBACEKAn9BACAGQQRJDQAaIAIgAi0AACAELQAAczoAACACIAItAAEgBC0AAXM6AAEgAiACLQACIAQtAAJzOgACIAIgAi0AAyAELQADczoAA0EEIAZBPHEiCEEERg0AGiACIAItAAQgBC0ABHM6AAQgAiACLQAFIAQtAAVzOgAFIAIgAi0ABiAELQAGczoABiACIAItAAcgBC0AB3M6AAdBCCAIQQhGDQAaIAIgAi0ACCAELQAIczoACCACIAItAAkgBC0ACXM6AAkgAiACLQAKIAQtAApzOgAKIAIgAi0ACyAELQALczoAC0EMIAhBDEYNABogAiACLQAMIAQtAAxzOgAMIAIgAi0ADSAELQANczoADSACIAItAA4gBC0ADnM6AA4gAiACLQAPIAQtAA9zOgAPQRAgCEEQRg0AGiACIAItABAgBC0AEHM6ABAgAiACLQARIAQtABFzOgARIAIgAi0AEiAELQASczoAEiACIAItABMgBC0AE3M6ABNBFCAIQRRGDQAaIAIgAi0AFCAELQAUczoAFCACIAItABUgBC0AFXM6ABUgAiACLQAWIAQtABZzOgAWIAIgAi0AFyAELQAXczoAF0EYIAhBGEYNABogAiACLQAYIAQtABhzOgAYIAIgAi0AGSAELQAZczoAGSACIAItABogBC0AGnM6ABogAiACLQAbIAQtABtzOgAbQRwgCEEcRg0AGiACIAItABwgBC0AHHM6ABwgAiACLQAdIAQtAB1zOgAdIAIgAi0AHiAELQAeczoAHiACIAItAB8gBC0AH3M6AB9BIAshCSALBEADQCACIAlqIgggCC0AACAEIAlqLQAAczoAACAJQQFqIQkgCkEBaiIKIAtHDQALCyAHQdgEaiEHQQAhCgJ/QQAgBkEESQ0AGiAHIActAAAgBS0AAHM6AAAgByAHLQABIAUtAAFzOgABIAcgBy0AAiAFLQACczoAAiAHIActAAMgBS0AA3M6AANBBCAGQTxxIghBBEYNABogByAHLQAEIAUtAARzOgAEIAcgBy0ABSAFLQAFczoABSAHIActAAYgBS0ABnM6AAYgByAHLQAHIAUtAAdzOgAHQQggCEEIRg0AGiAHIActAAggBS0ACHM6AAggByAHLQAJIAUtAAlzOgAJIAcgBy0ACiAFLQAKczoACiAHIActAAsgBS0AC3M6AAtBDCAIQQxGDQAaIAcgBy0ADCAFLQAMczoADCAHIActAA0gBS0ADXM6AA0gByAHLQAOIAUtAA5zOgAOIAcgBy0ADyAFLQAPczoAD0EQIAhBEEYNABogByAHLQAQIAUtABBzOgAQIAcgBy0AESAFLQARczoAESAHIActABIgBS0AEnM6ABIgByAHLQATIAUtABNzOgATQRQgCEEURg0AGiAHIActABQgBS0AFHM6ABQgByAHLQAVIAUtABVzOgAVIAcgBy0AFiAFLQAWczoAFiAHIActABcgBS0AF3M6ABdBGCAIQRhGDQAaIAcgBy0AGCAFLQAYczoAGCAHIActABkgBS0AGXM6ABkgByAHLQAaIAUtABpzOgAaIAcgBy0AGyAFLQAbczoAG0EcIAhBHEYNABogByAHLQAcIAUtABxzOgAcIAcgBy0AHSAFLQAdczoAHSAHIActAB4gBS0AHnM6AB4gByAHLQAfIAUtAB9zOgAfQSALIQkgCwRAA0AgByAJaiIIIAgtAAAgBSAJai0AAHM6AAAgCUEBaiEJIApBAWoiCiALRw0ACwsgACAGaiIFIAUtAABBH3M6AAAgAEHIAWoiBSAGaiIEIAQtAABBH3M6AAAgAEGQA2oiBCAGaiIDIAMtAABBH3M6AAAgAEHYBGoiAyAGaiIGIAYtAABBH3M6AAAgACABQQFrIgZqIgAgAC0AAEGAAXM6AAAgBSAGaiIAIAAtAABBgAFzOgAAIAQgBmoiACAALQAAQYABczoAACADIAZqIgAgAC0AAEGAAXM6AAAL6QQBA38gBUG8AXEhCANAIAEgBmogACAGai0AADoAACABIAZBAXIiB2ogACAHai0AADoAACABIAZBAnIiB2ogACAHai0AADoAACABIAZBA3IiB2ogACAHai0AADoAACAGQQRqIgYgCEcNAAsgBUEDcSIHBEBBACEFA0AgASAGaiAAIAZqLQAAOgAAIAZBAWohBiAFQQFqIgUgB0cNAAsLIABByAFqIQFBACEGA0AgAiAGaiABIAZqLQAAOgAAIAIgBkEBciIFaiABIAVqLQAAOgAAIAIgBkECciIFaiABIAVqLQAAOgAAIAIgBkEDciIFaiABIAVqLQAAOgAAIAZBBGoiBiAIRw0ACyAHBEBBACEFA0AgAiAGaiABIAZqLQAAOgAAIAZBAWohBiAFQQFqIgUgB0cNAAsLIABBkANqIQJBACEGA0AgAyAGaiACIAZqLQAAOgAAIAMgBkEBciIBaiABIAJqLQAAOgAAIAMgBkECciIBaiABIAJqLQAAOgAAIAMgBkEDciIBaiABIAJqLQAAOgAAIAZBBGoiBiAIRw0ACyAHBEBBACEBA0AgAyAGaiACIAZqLQAAOgAAIAZBAWohBiABQQFqIgEgB0cNAAsLIABB2ARqIQBBACEGA0AgBCAGaiAAIAZqLQAAOgAAIAQgBkEBciIDaiAAIANqLQAAOgAAIAQgBkECciIDaiAAIANqLQAAOgAAIAQgBkEDciIDaiAAIANqLQAAOgAAIAZBBGoiBiAIRw0ACyAHBEBBACEDA0AgBCAGaiAAIAZqLQAAOgAAIAZBAWohBiADQQFqIgMgB0cNAAsLC/gCAQp/QYABIQEDQEGAAiABQQF0IgdodiEFQQAhBANAIAEgBGohCCAFQQF0QcDIMWouAQAiCUGAgISYf2whCiAEIQYDQCAAIAZBAXRqIgIgB2oiAyACLwEAIAogAy4BACIDbEEQdUH/ZWwgAyAJbGpBEHYiA2s7AQAgAiACLwEAIANqOwEAIAZBAWoiBiAIRw0ACyAFQQFqIQUgBCAHaiIEQYACSQ0ACyABQQNLIQIgAUEBdiEBIAINAAsgAEGABGohAEGAASEBA0BBgAIgAUEBdCIHaHYhBUEAIQQDQCABIARqIQggBUEBdEHAyDFqLgEAIglBgICEmH9sIQogBCEGA0AgACAGQQF0aiICIAdqIgMgAi8BACAKIAMuAQAiA2xBEHVB/2VsIAMgCWxqQRB2IgNrOwEAIAIgAi8BACADajsBACAGQQFqIgYgCEcNAAsgBUEBaiEFIAQgB2oiBEGAAkkNAAsgAUEDSyECIAFBAXYhASACDQALC4YCAQV/A0AgACACQQJ0aiIDIAJBAXRBwMkxai4BACIEIAEgAkEDdGoiBS4BAmwiBkGAgISYf2xBEHVB/2VsIAZqQRB2OwEAIAMgBS4BBkEAIARrwWwiA0GAgISYf2xBEHVB/2VsIANqQRB2OwECIAJBAWoiAkHAAEcNAAsgAUGABGohASAAQYACaiEAQQAhAgNAIAAgAkECdGoiAyACQQF0QcDJMWouAQAiBCABIAJBA3RqIgUuAQJsIgZBgICEmH9sQRB1Qf9lbCAGakEQdjsBACADIAUuAQZBACAEa8FsIgNBgICEmH9sQRB1Qf9lbCADakEQdjsBAiACQQFqIgJBwABHDQALC6ACAQR/A0AgACAEQQF0IgNqIgIgASADai8BACACLwEAajsBACAAIANBAnIiAmoiBSABIAJqLwEAIAUvAQBqOwEAIAAgA0EEciICaiIFIAEgAmovAQAgBS8BAGo7AQAgACADQQZyIgNqIgIgASADai8BACACLwEAajsBACAEQQRqIgRBgAJHDQALIAFBgARqIQEgAEGABGohAEEAIQQDQCAAIARBAXQiA2oiAiABIANqLwEAIAIvAQBqOwEAIAAgA0ECciICaiIFIAEgAmovAQAgBS8BAGo7AQAgACADQQRyIgJqIgUgASACai8BACAFLwEAajsBACAAIANBBnIiA2oiAiABIANqLwEAIAIvAQBqOwEAIARBBGoiBEGAAkcNAAsLgAsCBX8BeyMAIgMhByADQeAHa0FgcSIDJAAgAyADQSBqNgIcIAMgA0HgAGo2AhggAyADQaABajYCFCADIANB4AFqNgIQIAMgAUEQaiIE/QAAAP0LBPABIAMgAf0AAAD9CwTgASADIAT9AAAA/QsEsAEgAyAB/QAAAP0LBKABIAMgBP0AAAD9CwRwIAMgAf0AAAD9CwRgIAMgBP0AAAD9CwQwIAMgAf0AAAD9CwQgQQAhASADQQA7AYACIAMgAjoAwQEgAyACQQFzIgQ6AMABIANBAkEAIAIbIgU6AIEBIANBAEECIAIbIgY6AIABIAMgBDoAQSADIAI6AEAgACADQRBqENkEIANBAkEBIAIbIgQ6AMEBIANBAUECIAIbIgI6AMABIANBgQI7AYACIAMgBjoAgQEgAyAFOgCAASADIAI6AEEgAyAEOgBAIABBgBBqIANBEGoQ2QQgA0GCBDsBgAIgA0GYBmpBqAEgA0HgAWpBIkEfENcEIANBmAZqENgEA0AgA0GgAmogAWogA0GYBmogAWotAAA6AAAgAUEBciICIANBoAJqaiADQZgGaiACai0AADoAACABQQJyIgIgA0GgAmpqIANBmAZqIAJqLQAAOgAAIAFBA3IiAiADQaACamogA0GYBmogAmotAAA6AAAgAUEEaiIBQagBRw0ACyADQcgDaiECIANBmAZqENgEQQAhAQNAIAEgAmogA0GYBmogAWotAAA6AAAgAiABQQFyIgRqIANBmAZqIARqLQAAOgAAIAIgAUECciIEaiADQZgGaiAEai0AADoAACACIAFBA3IiBGogA0GYBmogBGotAAA6AAAgAUEEaiIBQagBRw0ACyADQfAEaiECIANBmAZqENgEQQAhAQNAIAEgAmogA0GYBmogAWotAAA6AAAgAiABQQFyIgRqIANBmAZqIARqLQAAOgAAIAIgAUECciIEaiADQZgGaiAEai0AADoAACACIAFBA3IiBGogA0GYBmogBGotAAA6AAAgAUEEaiIBQagBRw0ACyAAQYAgaiEGQQAhAkEDIQRBACEAA0AgBCEBIANBoAJqIABqIgQtAAEiAEEIdEGAHnEgBC0AAHIiBUGAGk0EQCAGIAJBAXRqIAU7AQAgAkEBaiECCwJAIAJB/wFLDQAgBC0AAkEEdCAAQQR2ciIEQYAaSw0AIAYgAkEBdGogBDsBACACQQFqIQILIAJB/wFNBEAgAUEDaiEEIAEhACABQfYDSQ0BCwsgAkH/AU0EQANAIANBmAZqENgEQQAhAEEAIQEDQCADQaACaiABaiADQZgGaiABai0AADoAACABQQFyIgQgA0GgAmpqIANBmAZqIARqLQAAOgAAIAFBAnIiBCADQaACamogA0GYBmogBGotAAA6AABBAyEEIAFBA3IiBSADQaACamogA0GYBmogBWotAAA6AAAgAUEEaiIBQagBRw0ACwNAIAQhASADQaACaiAAaiIELQACIQAgBC0AACAELQABIgVBCHRBgB5xciIEQYAaTQRAIAYgAkEBdGogBDsBACACQQFqIQILAkAgAkH/AUsNACAAQQR0IAVBBHZyIgRBgBpLDQAgBiACQQF0aiAEOwEAIAJBAWohAgsgAkH/AU0EQCABQQNqIQQgASEAIAFBpgFJDQELCyACQYACSQ0ACwsgA0GYBmpBAEHIAfwLACADQaACakEAQfgD/AsAIANBADsBgAIgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBOABIAMgCP0LBPABIANBADsBwAEgAyAI/QsEsAEgAyAI/QsEoAEgA0EAOwGAASADIAj9CwRwIAMgCP0LBGAgA0FAa0EAOwEAIAMgCP0LBDAgAyAI/QsEICAHJAALtgQBC39BgAEhAwNAQYACIANBAXQiB2h2IQRBACEFA0AgAyAFaiEIIARBAXRBwMgxai4BACIJQYCAhJh/bCEKIAUhBgNAIAAgBkEBdGoiASAHaiICIAEvAQAgCiACLgEAIgJsQRB1Qf9lbCACIAlsakEQdiICazsBACABIAEvAQAgAmo7AQAgBkEBaiIGIAhHDQALIARBAWohBCAFIAdqIgVBgAJJDQALIANBA0shASADQQF2IQMgAQ0ACyAAQYAEaiEFQYABIQsDQEGAAiALQQF0IgdodiEDQQAhBANAIAQgC2ohCCADQQF0QcDIMWouAQAiCUGAgISYf2whCiAEIQYDQCAFIAZBAXRqIgEgB2oiAiABLwEAIAogAi4BACICbEEQdUH/ZWwgAiAJbGpBEHYiAms7AQAgASABLwEAIAJqOwEAIAZBAWoiBiAIRw0ACyADQQFqIQMgBCAHaiIEQYACSQ0ACyALQQNLIQEgC0EBdiELIAENAAsgAEGACGohAEGAASEDA0BBgAIgA0EBdCIHaHYhBEEAIQUDQCADIAVqIQggBEEBdEHAyDFqLgEAIglBgICEmH9sIQogBSEGA0AgACAGQQF0aiIBIAdqIgIgAS8BACAKIAIuAQAiAmxBEHVB/2VsIAIgCWxqQRB2IgJrOwEAIAEgAS8BACACajsBACAGQQFqIgYgCEcNAAsgBEEBaiEEIAUgB2oiBUGAAkkNAAsgA0EDSyEBIANBAXYhAyABDQALC5EDAQd/A0AgACACQQJ0aiIDIAJBAXRBwMkxai4BACIEIAEgAkEDdGoiBS4BAmwiBkGAgISYf2xBEHVB/2VsIAZqQRB2OwEAIAMgBS4BBkEAIARrwWwiA0GAgISYf2xBEHVB/2VsIANqQRB2OwECIAJBAWoiAkHAAEcNAAsgAUGABGohByAAQYACaiEIQQAhAgNAIAggAkECdGoiAyACQQF0QcDJMWouAQAiBCAHIAJBA3RqIgUuAQJsIgZBgICEmH9sQRB1Qf9lbCAGakEQdjsBACADIAUuAQZBACAEa8FsIgNBgICEmH9sQRB1Qf9lbCADakEQdjsBAiACQQFqIgJBwABHDQALIAFBgAhqIQEgAEGABGohAEEAIQIDQCAAIAJBAnRqIgMgAkEBdEHAyTFqLgEAIgQgASACQQN0aiIFLgECbCIGQYCAhJh/bEEQdUH/ZWwgBmpBEHY7AQAgAyAFLgEGQQAgBGvBbCIDQYCAhJh/bEEQdUH/ZWwgA2pBEHY7AQIgAkEBaiICQcAARw0ACwu5AgETfyACQYAIaiEIIAFBgAhqIQkgAkGABGohCiABQYAEaiELA0AgCCAGQQJ0IgRBAnIiBWouAQAhDCAFIApqLgEAIQ0gAiAFai4BACEOIAAgBGogBSAJai4BACIPIAMgBkEBdGoiBy4BgARsIAUgC2ouAQAiECAHLgGAAmwgBy4BACABIAVqLgEAIgdsIAIgBGouAQAiESABIARqLgEAIhJsamogBCAKai4BACITIAQgC2ouAQAiFGxqaiAEIAhqLgEAIhUgBCAJai4BACIEbGoiFkGAgISYf2xBEHVB/2VsIBZqQRB2OwEAIAAgBWogByARbCAOIBJsaiAQIBNsaiANIBRsaiAPIBVsaiAEIAxsaiIEQYCAhJh/bEEQdUH/ZWwgBGpBEHY7AQAgBkEBaiIGQYABRw0ACwu4AwEGfwNAIAAgBEEBdCICaiIDIAEgAmovAQAgAy8BAGo7AQAgACACQQJyIgNqIgUgASADai8BACAFLwEAajsBACAAIAJBBHIiA2oiBSABIANqLwEAIAUvAQBqOwEAIAAgAkEGciICaiIDIAEgAmovAQAgAy8BAGo7AQAgBEEEaiIEQYACRw0ACyABQYAEaiEEIABBgARqIQNBACEFA0AgAyAFQQF0IgJqIgYgAiAEai8BACAGLwEAajsBACADIAJBAnIiBmoiByAEIAZqLwEAIAcvAQBqOwEAIAMgAkEEciIGaiIHIAQgBmovAQAgBy8BAGo7AQAgAyACQQZyIgJqIgYgAiAEai8BACAGLwEAajsBACAFQQRqIgVBgAJHDQALIAFBgAhqIQEgAEGACGohAEEAIQQDQCAAIARBAXQiAmoiAyABIAJqLwEAIAMvAQBqOwEAIAAgAkECciIDaiIFIAEgA2ovAQAgBS8BAGo7AQAgACACQQRyIgNqIgUgASADai8BACAFLwEAajsBACAAIAJBBnIiAmoiAyABIAJqLwEAIAMvAQBqOwEAIARBBGoiBEGAAkcNAAsLngIBBX8DQEEAIAAgAkEBdGoiAy4BACIBQb+dAWxBgICAEGpBGnVB/2VsIAFqIgHBQRB2ayEEIAMgAUGBGmogAXMgBEEQdnEgAXM7AQAgAkEBaiICQYACRw0ACyAAQYAEaiEFQQAhAgNAQQAgBSACQQF0aiIDLgEAIgFBv50BbEGAgIAQakEadUH/ZWwgAWoiAcFBEHZrIQQgAyABQYEaaiABcyAEQRB2cSABczsBACACQQFqIgJBgAJHDQALIABBgAhqIQBBACECA0BBACAAIAJBAXRqIgMuAQAiAUG/nQFsQYCAgBBqQRp1Qf9lbCABaiIBwUEQdmshBCADIAFBgRpqIAFzIARBEHZxIAFzOwEAIAJBAWoiAkGAAkcNAAsLkwIBBn8DQCABIAJBAnRqIgMvAQIhBCAAIAJBA2xqIgUgAy8BACIDOgAAIAUgBEEEdjoAAiAFIARBBHQgA0EIdnI6AAEgAkEBaiICQYABRw0ACyABQYAEaiEGIABBgANqIQdBACECA0AgBiACQQJ0aiIDLwECIQQgByACQQNsaiIFIAMvAQAiAzoAACAFIARBBHY6AAIgBSAEQQR0IANBCHZyOgABIAJBAWoiAkGAAUcNAAsgAUGACGohASAAQYAGaiEAQQAhAgNAIAEgAkECdGoiAy8BAiEEIAAgAkEDbGoiBSADLwEAIgM6AAAgBSAEQQR2OgACIAUgBEEEdCADQQh2cjoAASACQQFqIgJBgAFHDQALC94DAQR/IwBBQGoiAiQAIAJBtb4qNgIwIABB+YYqIAJBMGoQmwECQAJ/QeexKSAAQQEQyAEiA0UNABogACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBEGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCAEEQaiEECwJAAkACQCAEQfbuKyAEGyIBQfbuKxCtAQRAIAFBjeYrEK0BRQ0BIAFBnuwrEK0BDQMgAEGgDBCGASIBDQJB8rMpDAQLQfKzKSAAQaAGEIYBIgFFDQMaIAEoAgggAygCCEGABmpBoAb8CgAAIAFBoAY2AgAMBAtB8rMpIABBoAkQhgEiAUUNAhogASgCCCADKAIIQYAJakGgCfwKAAAgAUGgCTYCAAwDCyABKAIIIAMoAghBgAxqQaAM/AoAACABQaAMNgIADAILIAJBtb4qNgIgQY35KyABIAJBIGoQbkGOkCoLIQEgAxCaASACIAE2AgQgAkG1vio2AgAgAEH8iCogAhBsAAsgAxCaASACQbW+KjYCECAAQeCHKiACQRBqEJsBIAJBQGskAEEBC4gDAQV/IwBB0ABrIgEkACABQfnWKjYCQCAAQfmGKiABQUBrEJsBAkAgAEEBEMgBIgMEQCAAKAIUKAIAQRBqIgIgACgCDCIFTwRAIAAoAhBBLGohAgsCQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRBqIgIgACgCDCIFSQ0AIAAoAhBBLGohAgsgAigCAEEQaiEECyAFQRFBAQJ/QaAGIARB9u4rIAQbIgJB9u4rEK0BRQ0AGkGgCSACQY3mKxCtAUUNABogAkGe7CsQrQENAkGgDAsgAygCAEYbOgAEIAAgACgCDEEIajYCDCADEJoBIAFB+dYqNgIQIABB4IcqIAFBEGoQmwEgAUHQAGokAEEBDwsgAUHftik2AgQgAUH51io2AgAgAEH8iCogARBsAAsgAUH51io2AjBBjfkrIAIgAUEwahBuIAMQmgEgAUGOkCo2AiQgAUH51io2AiAgAEH8iCogAUEgahBsAAv/AgEFfyMAQdAAayIBJAAgAUGf1io2AkAgAEH5hiogAUFAaxCbAQJAIABBARDIASIDBEAgACgCFCgCAEEQaiICIAAoAgwiBU8EQCAAKAIQQSxqIQILAkACQAJAIAItAARBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEQaiICIAAoAgwiBUkNACAAKAIQQSxqIQILIAIoAgBBEGohBAsCQCAEQfbuKyAEGyICQfbuKxCtAUUNACACQY3mKxCtAUUNACACQZ7sKxCtAQ0CCyAFQRFBASADKAIAQSBGGzoABCAAIAAoAgxBCGo2AgwgAxCaASABQZ/WKjYCECAAQeCHKiABQRBqEJsBIAFB0ABqJABBAQ8LIAFBwOUpNgIEIAFBn9YqNgIAIABB/IgqIAEQbAALIAFBn9YqNgIwQY35KyACIAFBMGoQbiADEJoBIAFBjpAqNgIkIAFBn9YqNgIgIABB/IgqIAFBIGoQbAALiAMBBX8jAEHQAGsiASQAIAFB09UqNgJAIABB+YYqIAFBQGsQmwECQCAAQQEQyAEiAwRAIAAoAhQoAgBBEGoiAiAAKAIMIgVPBEAgACgCEEEsaiECCwJAAkACQCACLQAEQQ9xQQNrDgIAAQILIAAgAhBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBEGoiAiAAKAIMIgVJDQAgACgCEEEsaiECCyACKAIAQRBqIQQLIAVBEUEBAn9BgAYgBEH27isgBBsiAkH27isQrQFFDQAaQcAIIAJBjeYrEK0BRQ0AGiACQZ7sKxCtAQ0CQaAMCyADKAIARhs6AAQgACAAKAIMQQhqNgIMIAMQmgEgAUHT1So2AhAgAEHghyogAUEQahCbASABQdAAaiQAQQEPCyABQf3IKTYCBCABQdPVKjYCACAAQfyIKiABEGwACyABQdPVKjYCMEGN+SsgAiABQTBqEG4gAxCaASABQY6QKjYCJCABQdPVKjYCICAAQfyIKiABQSBqEGwAC5caAg9/AXsjACIBIQ4gAUHgHWtBYHEiASQAIAFBjsQrNgIwIABB+YYqIAFBMGoQmwECQAJ/Qf22KSAAQQEQyAEiCkUNABoCQCAAQQJBweIpENwBIgIEQEGl+CogAigCAEEgRw0CGiABIAIoAggiAv0AABD9CwRQIAEgAv0AAAD9CwRADAELQQAhAkGQljQoAgAhBQNAIAFBQGsgAmogBSgCJBBpOgAAIAJBAWoiAkEgRw0ACwtBACEFIAAoAhQoAgBBGGoiAiAAKAIMTwRAIAAoAhBBLGohAgsCQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRhqIgIgACgCDEkNACAAKAIQQSxqIQILIAIoAgBBEGohBQsCQAJAAkACQCAFQfbuKyAFGyICQfbuKxCtAQRAIAJBjeYrEK0BRQ0BIAJBnuwrEK0BDQMgCigCAEGgDEYNAkG5tSkMBQtBubUpIAooAgBBoAZHDQQaIABBAEECEKEBQcDlKSAAQSAQhgEiC0UNBBogACAAKAIMQRBrQa/mKRBZQf3IKSAAQYAGEIYBIgxFDQQaIAAgACgCDEEQa0GJlyoQWSAKKAIIIQUgCygCCCENIAwoAgghD0EAIQIDQCAFIAJBA2xqIgMtAAAhBiABQeANaiACQQJ0aiIEIAMtAAJBBHQgAy0AASIDQQR2cjsBAiAEIAYgA0EIdEGAHnFyOwEAIAJBAWoiAkGAAUcNAAsgBUGAA2ohCSABQeARaiEHQQAhBEEAIQIDQCAJIAJBA2xqIgMtAAAhBiAHIAJBAnRqIgggAy0AAkEEdCADLQABIgNBBHZyOwECIAggBiADQQh0QYAecXI7AQAgAkEBaiICQYABRw0ACwNAQQAhBkEAIAFB4A1qIARBAXRqIgguAQAiAkG/nQFsQYCAgBBqQRp1Qf9lbCACaiICwUEQdmshAyAIIAJBgRpqIAJzIANBEHZxIAJzOwEAIARBAWoiBEGAAkcNAAsDQCAHIAZBAXRqIgguAQAiAkG/nQFsQYCAgBBqQRp1Qf9lbCACaiIDwSEEQQAhAiAIIANBgRpqIANzQQAgBEEQdmtBEHZxIANzOwEAIAZBAWoiBkGAAkcNAAsDQCABQeANaiACQQJ0aiIELwECIQMgAUHgAWogAkEDbGoiBiAELwEAIgQ6AAAgBiADQQR2OgACIAYgA0EEdCAEQQh2cjoAASACQQFqIgJBgAFHDQALIAFB4ARqIQlBACECQQAhAwNAIAcgA0ECdGoiCC8BAiEGIAkgA0EDbGoiBCAILwEAIgg6AAAgBCAGQQR2OgACIAQgBkEEdCAIQQh2cjoAASADQQFqIgNBgAFHDQALQQAhA0EAIQYDQCACQQJqIgQgAUHgAWpqLQAAIAQgBWotAABzIgQgAkEBaiIHIAFB4AFqai0AACAFIAdqLQAAcyIHIAFB4AFqIAJqLQAAIAIgBWotAABzIgggA3NzcyEDIAQgByAGIAhycnIhBiACQQNqIgJBgAZHDQALIAFB4AFqQQBBgAb8CwAgAUHgDWpBAEGACPwLACADQQAgBkH/AXFrQRh2c0H/AXEgA0H/AXFHDQMgASAB/QAEQP0LBKABIAEgAf0ABFD9CwSwASABQeANakGIASAFQaAGQQYQ1wQgAUHgDWoQ2AQgASABLQDgDToAwAEgASABKADhDTYAwQEgASAB/QAA5Q39CwDFASABIAEpAPUNNwDVASABIAEvAP0NOwDdASABIAEtAP8NOgDfAUEAIQIgAUHgDWpBAEHIAfwLACABQeANakHIACABQaABakHAAEEGENcEIAFB4A1qENgEA0AgAUHgAGogAmogAUHgDWogAmotAAA6AAAgAkEBciIDIAFB4ABqaiABQeANaiADai0AADoAACACQQJyIgMgAUHgAGpqIAFB4A1qIANqLQAAOgAAIAJBA3IiAyABQeAAamogAUHgDWogA2otAAA6AAAgAkEEaiICQcAARw0ACyABQeANakEAQcgB/AsAIA8gAUGgAWogBSABQYABaiICEPIEIA0gAf0ABHD9CwAQIA0gAf0ABGD9CwAAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTAASABIBD9CwTQASABIBD9CwSgASABIBD9CwSwASABIBD9CwSQASACIBD9CwQAIAEgEP0LBHAgASAQ/QsEYCALQSA2AgAgDEGABjYCAAwFC0G5tSkgCigCAEGgCUcNAxogAEEAQQIQoQFBwOUpIABBIBCGASIJRQ0DGiAAIAAoAgxBEGtBr+YpEFlB/cgpIABBwAgQhgEiC0UNAxogACAAKAIMQRBrQYmXKhBZIAkoAgghDCALKAIIIQ0gAUHgDWogCigCCCIFEPMEIAFB4A1qEOsEIAFB4AFqIAFB4A1qEOwEQQAhAgNAIAJBAmoiBCABQeABamotAAAgBCAFai0AAHMiBCACQQFqIgcgAUHgAWpqLQAAIAUgB2otAABzIgcgAUHgAWogAmotAAAgAiAFai0AAHMiCCADc3NzIQMgBCAHIAYgCHJyciEGIAJBA2oiAkGACUcNAAsgAUHgAWpBAEGACfwLACABQeANakEAQYAM/AsAIANBACAGQf8BcWtBGHZzQf8BcSADQf8BcUcNAiABIAH9AARA/QsEoAEgASAB/QAEUP0LBLABIAFB4A1qQYgBIAVBoAlBBhDXBCABQeANahDYBCABIAEtAOANOgDAASABIAEoAOENNgDBASABIAH9AADlDf0LAMUBIAEgASkA9Q03ANUBIAEgAS8A/Q07AN0BIAEgAS0A/w06AN8BQQAhAiABQeANakEAQcgB/AsAIAFB4A1qQcgAIAFBoAFqQcAAQQYQ1wQgAUHgDWoQ2AQDQCABQeAAaiACaiABQeANaiACai0AADoAACACQQFyIgMgAUHgAGpqIAFB4A1qIANqLQAAOgAAIAJBAnIiAyABQeAAamogAUHgDWogA2otAAA6AAAgAkEDciIDIAFB4ABqaiABQeANaiADai0AADoAACACQQRqIgJBwABHDQALIAFB4A1qQQBByAH8CwAgDSABQaABaiAFIAFBgAFqIgIQ9AQgDCAB/QAEcP0LABAgDCAB/QAEYP0LAAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMABIAEgEP0LBNABIAEgEP0LBKABIAEgEP0LBLABIAEgEP0LBJABIAIgEP0LBAAgASAQ/QsEcCABIBD9CwRgIAlBIDYCACALQcAINgIADAQLIABBAEECEKEBQcDlKSAAQSAQhgEiCUUNAhogACAAKAIMQRBrQa/mKRBZQf3IKSAAQaAMEIYBIgtFDQIaIAAgACgCDEEQa0GJlyoQWSAJKAIIIQwgCygCCCENIAFB4A1qIAooAggiBRD1BCABQeANahDfBCABQeABaiABQeANahDgBEEAIQIDQCACQQJqIgQgAUHgAWpqLQAAIAQgBWotAABzIgQgAkEBaiIHIAFB4AFqai0AACAFIAdqLQAAcyIHIAFB4AFqIAJqLQAAIAIgBWotAABzIgggA3NzcyEDIAQgByAGIAhycnIhBiACQQNqIgJBgAxHDQALIAFB4AFqQQBBgAz8CwAgAUHgDWpBAEGAEPwLACADQQAgBkH/AXFrQRh2c0H/AXEgA0H/AXFHDQEgASAB/QAEQP0LBKABIAEgAf0ABFD9CwSwASABQeANakGIASAFQaAMQQYQ1wQgAUHgDWoQ2AQgASABLQDgDToAwAEgASABKADhDTYAwQEgASAB/QAA5Q39CwDFASABIAEpAPUNNwDVASABIAEvAP0NOwDdASABIAEtAP8NOgDfAUEAIQIgAUHgDWpBAEHIAfwLACABQeANakHIACABQaABakHAAEEGENcEIAFB4A1qENgEA0AgAUHgAGogAmogAUHgDWogAmotAAA6AAAgAkEBciIDIAFB4ABqaiABQeANaiADai0AADoAACACQQJyIgMgAUHgAGpqIAFB4A1qIANqLQAAOgAAIAJBA3IiAyABQeAAamogAUHgDWogA2otAAA6AAAgAkEEaiICQcAARw0ACyABQeANakEAQcgB/AsAIA0gAUGgAWogBSABQYABaiICEPYEIAwgAf0ABHD9CwAQIAwgAf0ABGD9CwAAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTAASABIBD9CwTQASABIBD9CwSgASABIBD9CwSwASABIBD9CwSQASACIBD9CwQAIAEgEP0LBHAgASAQ/QsEYCAJQSA2AgAgC0GgDDYCAAwDCyABQY7EKzYCIEGN+SsgAiABQSBqEG5BjpAqDAELQYvmKQshAiAKEJoBIAEgAjYCBCABQY7EKzYCACAAQfyIKiABEGwACyAKEJoBIAFBjsQrNgIQIABB4IcqIAFBEGoQmwEgDiQAQQEL/RsCEH8DeyMAIgQhDyAEQaDCAGtBYHEiBCQAA0AgAiAFQQNsaiIHLQAAIQYgBEGAMGogBUECdGoiCCAHLQACQQR0IActAAEiB0EEdnI7AQIgCCAGIAdBCHRBgB5xcjsBACAFQQFqIgVBgAFHDQALIAJBgANqIQkgBEGANGohDEEAIQUDQCAJIAVBA2xqIgctAAAhBiAMIAVBAnRqIgggBy0AAkEEdCAHLQABIgdBBHZyOwECIAggBiAHQQh0QYAecXI7AQAgBUEBaiIFQYABRw0ACyAEIAL9AACABv0LBIBAIAQgAv0AAJAG/QsEkEAgAkGABmohCUEBIQJBACEGA0AgBEGACGogBkEEdGoiB0EAIAIgASAGai0AACIFcWtBEHZBgQ1xOwEAIAdBACAFQQJxa0EQdkGBDXE7AQIgB0EAIAVBBHFrQRB2QYENcTsBBCAHQQAgBUEIcWtBEHZBgQ1xOwEGIAdBACAFQRBxa0EQdkGBDXE7AQggB0EAIAVBIHFrQRB2QYENcTsBCiAHQQAgBUHAAHFrQRB2QYENcTsBDCAHQQAgBUGAAXFrQRB2QYENcTsBDiAGQQFqIgZBIEcNAAsgBCAEQYAMajYCjAQgBCAEQYAQajYCiAQgBCAEQYAoajYChAQgBCAEQYA4ajYCgAQgBCAJQRBqIgX9AAAA/QsEkDggBCAJ/QAAAP0LBIA4IAQgBf0AAAD9CwSQKCAEIAn9AAAA/QsEgCggBCAF/QAAAP0LBJAQIAQgCf0AAAD9CwSAECAEIAX9AAAA/QsEkAwgBCAJ/QAAAP0LBIAMQQAhByAEQaA4aiIFQQA7AQAgBEGgKGoiBkGAAjsBACAEQaAQaiIIQQE7AQAgBEGgDGoiAkGBAjsBACAEQYAYaiAEQYAEahDZBCAFQQA7AQAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBJA4IAQgFP0LBIA4IAZBADsBACAEIBT9CwSQKCAEIBT9CwSAKCAIQQA7AQAgBCAU/QsEkBAgBCAU/QsEgBAgAkEAOwEAIAQgFP0LBJAMIAQgFP0LBIAMIAQgA0EQaiIF/QAAAP0LBPBBIAQgA/0AAAD9CwTgQSAEIAX9AAAA/QsEsEEgBCAD/QAAAP0LBKBBIAQgBf0AAAD9CwTwQCAEIAP9AAAA/QsE4EAgBf0AAAAhFSAD/QAAACEWIARBADoAgEIgBCAV/QsEsEAgBEEDOgDAQCAEQQE6AMBBIARBAjoAgEEgBCAW/QsEoEAgBEGAEGpBwAEgBEHgwQBqQSEQ+QQgBEGADGpBwAEgBEGgwQBqQSEQ+QQgBEGABGpBgAEgBEHgwABqQSEQ+QQgBEGAASAEQaDAAGpBIRD5BANAIARBgDhqIAdBA3RqIgYgBEGAEGogB0EDbGoiBS8AACAFLQACQRB0ciIFQQF2QcmkkgFxIAVByaSSAXFqIAVBAnZByaSSAXFqIgVBBnZBB3EgBUEJdkEHcWs7AQIgBiAFQQdxIAVBA3ZBB3FrOwEAIAYgBUEMdkEHcSAFQQ92QQdxazsBBCAGIAVBEnZBB3EgBUEVdms7AQYgB0EBaiIHQcAARw0ACyAEQYA8aiEHQQAhBgNAIAcgBkEDdGoiCCAEQYAMaiAGQQNsaiIFLwAAIAUtAAJBEHRyIgVBAXZByaSSAXEgBUHJpJIBcWogBUECdkHJpJIBcWoiBUEGdkEHcSAFQQl2QQdxazsBAiAIIAVBB3EgBUEDdkEHcWs7AQAgCCAFQQx2QQdxIAVBD3ZBB3FrOwEEIAggBUESdkEHcSAFQRV2azsBBiAGQQFqIgZBwABHDQALIARBgChqIARBgARqEJQJIARBgCxqIAQQlAlBACEIQQAhBSAEQYAQakEAQcAB/AsAIAVFBEAgBEGADGpBAEHAAfwLAAsgBUUEQCAEQYAEakEAQcAB/AsACyAFRQRAIARBAEHAAfwLAAsgBEGAwgBqQQA6AAAgBCAU/QsE8EEgBCAU/QsE4EEgBEHAwQBqQQA6AAAgBCAU/QsEsEEgBCAU/QsEoEEgBEGAwQBqQQA6AAAgBCAU/QsE8EAgBCAU/QsE4EAgBEHAwABqQQA6AAAgBCAU/QsEsEAgBCAU/QsEoEAgA/0AABAhFSAD/QAAACEWIARBoAxqIgVBBDoAACAEIBX9CwSQDCAEIBb9CwSADCAEQYAQakGAASAEQYAMakEhEPkEIARBgARqIARBgBBqEJQJIARBgBBqQQBBgAH8CwAgBUEAOgAAIAQgFP0LBJAMIAQgFP0LBIAMIARBgDhqEOMEIAQgBEGAOGoQ5AQgBEGAHGohAgNAIAcgCEECdCIFQQJyIgZqLgEAIQEgBEGAEGogBWogAiAGai4BACIDIAQgCEEBdGoiCS4BgAJsIAkuAQAgBEGAGGogBmouAQAiCWwgBEGAOGogBWouAQAiCiAEQYAYaiAFai4BACINbGpqIAUgB2ouAQAiCyACIAVqLgEAIgVsaiIOQYCAhJh/bEEQdUH/ZWwgDmpBEHY7AQAgBEGAEGogBmogCSAKbCANIARBgDhqIAZqLgEAbGogAyALbGogASAFbGoiBUGAgISYf2xBEHVB/2VsIAVqQRB2OwEAIAhBAWoiCEGAAUcNAAsgBEGAJGohCSAEQYAgaiEDIARBgBRqIQFBACEIQQAhAgNAIAcgAkECdCIFQQJyIgZqLgEAIQogBEGAOGogBmouAQAhDSABIAVqIAYgCWouAQAiDiAEIAJBAXRqIgsuAYACbCALLgEAIAMgBmouAQAiC2wgBEGAOGogBWouAQAiECADIAVqLgEAIhFsamogBSAHai4BACISIAUgCWouAQAiBWxqIhNBgICEmH9sQRB1Qf9lbCATakEQdjsBACABIAZqIAsgEGwgDSARbGogDiASbGogBSAKbGoiBUGAgISYf2xBEHVB/2VsIAVqQRB2OwEAIAJBAWoiAkGAAUcNAAsDQCAHIAhBAnQiBUECciIGai4BACECIARBgAxqIAVqIAYgDGouAQAiAyAEIAhBAXRqIgkuAYACbCAJLgEAIARBgDBqIAZqLgEAIglsIARBgDhqIAVqLgEAIgogBEGAMGogBWouAQAiDWxqaiAFIAdqLgEAIgsgBSAMai4BACIFbGoiDkGAgISYf2xBEHVB/2VsIA5qQRB2OwEAIARBgAxqIAZqIAkgCmwgDSAEQYA4aiAGai4BAGxqIAMgC2xqIAIgBWxqIgVBgICEmH9sQRB1Qf9lbCAFakEQdjsBACAIQQFqIghBgAFHDQALIARBgBBqEPgEIAEQ+AQgBEGADGoQ+AQgBEGAEGogBEGAKGoQ5QRBACEHQQAhBgNAIAZBAXQiBSAEQYAMamoiCCAEQYAEaiAFai8BACAILwEAajsBACAFQQJyIgggBEGADGpqIgIgBEGABGogCGovAQAgAi8BAGo7AQAgBUEEciIIIARBgAxqaiICIARBgARqIAhqLwEAIAIvAQBqOwEAIAVBBnIiBSAEQYAMamoiCCAEQYAEaiAFai8BACAILwEAajsBACAGQQRqIgZBgAJHDQALA0AgB0EBdCIFIARBgAxqaiIGIARBgAhqIAVqLwEAIAYvAQBqOwEAIAVBAnIiBiAEQYAMamoiCCAEQYAIaiAGai8BACAILwEAajsBACAFQQRyIgYgBEGADGpqIgggBEGACGogBmovAQAgCC8BAGo7AQAgBUEGciIFIARBgAxqaiIGIARBgAhqIAVqLwEAIAYvAQBqOwEAIAdBBGoiB0GAAkcNAAtBACEIA0BBACEGQQAgBEGAEGogCEEBdGoiAi4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqIgXBQRB2ayEHIAIgBUGBGmogBXMgB0EQdnEgBXM7AQAgCEEBaiIIQYACRw0ACwNAQQAhCEEAIAEgBkEBdGoiAi4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqIgXBQRB2ayEHIAIgBUGBGmogBXMgB0EQdnEgBXM7AQAgBkEBaiIGQYACRw0ACwNAQQAgBEGADGogCEEBdGoiBi4BACIFQb+dAWxBgICAEGpBGnVB/2VsIAVqIgXBQRB2ayEHIAYgBUGBGmogBXMgB0EQdnEgBXM7AQAgCEEBaiIIQYACRw0ACyAAIARBgBBqEJUJIABBwAJqIAEQlQkgAEGABWohCkEAIQcDQCAEQYAMaiAHQQR0aiIFLwECIQggBS8BACECIAUvAQYhASAFLwEEIQwgBS8BCiEJIAUvAQghAyAKIAdBAnRqIgYgBS8BDkGw384AbEGAgIBAa0EYdkHwAXEgBS8BDEGw384AbEGAgIBAa0EcdnI6AAMgBiAJQbDfzgBsQYCAgEBrQRh2QfABcSADQbDfzgBsQYCAgEBrQRx2cjoAAiAGIAFBsN/OAGxBgICAQGtBGHZB8AFxIAxBsN/OAGxBgICAQGtBHHZyOgABIAYgCEGw384AbEGAgIBAa0EYdkHwAXEgAkGw384AbEGAgIBAa0EcdnI6AAAgB0EBaiIHQSBHDQALIAQgFP0LBJBAIAQgFP0LBIBAQQAhByAEQYA4akEAQYAI/AsAQQAhBSAEQQBBgAT8CwAgB0UEQCAEQYAQakEAQYAI/AsACyAFRQRAIARBgAxqQQBBgAT8CwALIARBgBhqQQBBgBD8CwAgBUUEQCAEQYAIakEAQYAE/AsACyAHRQRAIARBgChqQQBBgAj8CwALIAVFBEAgBEGABGpBAEGABPwLAAsgDyQAC5wCAQZ/A0AgASACQQNsaiIDLQAAIQQgACACQQJ0aiIFIAMtAAJBBHQgAy0AASIDQQR2cjsBAiAFIAQgA0EIdEGAHnFyOwEAIAJBAWoiAkGAAUcNAAsgAUGAA2ohBiAAQYAEaiEHQQAhAgNAIAYgAkEDbGoiAy0AACEEIAcgAkECdGoiBSADLQACQQR0IAMtAAEiA0EEdnI7AQIgBSAEIANBCHRBgB5xcjsBACACQQFqIgJBgAFHDQALIAFBgAZqIQEgAEGACGohAEEAIQIDQCABIAJBA2xqIgMtAAAhBCAAIAJBAnRqIgUgAy0AAkEEdCADLQABIgNBBHZyOwECIAUgBCADQQh0QYAecXI7AQAgAkEBaiICQYABRw0ACwuzCwIIfwF7IwAiBCEJIARBoOYAa0FgcSIEJAAgBEGAzgBqIAIQ8wQgBCAC/QAAgAn9CwSAZiAEIAJBkAlq/QAAAP0LBJBmQQEhCANAIARBgApqIAVBBHRqIgZBACAIIAEgBWotAAAiAnFrQRB2QYENcTsBACAGQQAgAkECcWtBEHZBgQ1xOwECIAZBACACQQRxa0EQdkGBDXE7AQQgBkEAIAJBCHFrQRB2QYENcTsBBiAGQQAgAkEQcWtBEHZBgQ1xOwEIIAZBACACQSBxa0EQdkGBDXE7AQogBkEAIAJBwABxa0EQdkGBDXE7AQwgBkEAIAJBgAFxa0EQdkGBDXE7AQ4gBUEBaiIFQSBHDQALIARBgB5qIARBgOYAakEBEOYEQQAhBiAEQYDaAGogBEGA3gBqIARBgOIAaiAEQYASaiADQQBBAUECQf8BENoEIARBgMIAaiAEQYDGAGogBEGAygBqIARBgAZqIANBA0EEQQVBBhDaBCAEQYDaAGoQ5wQgBCAEQYDaAGoQ6AQgBEGAEmogBEGAHmogBEGA2gBqIAQQ6QQgBEGAFmoiASAEQYAqaiAEQYDaAGogBBDpBCAEQYAaaiIDIARBgDZqIARBgNoAaiAEEOkEIARBgA5qIARBgM4AaiAEQYDaAGogBBDpBCAEQYASahD4BCABEPgEIAMQ+AQgBEGADmoQ+AQgBEGAEmogBEGAwgBqEOoEQQAhBQNAIAVBAXQiAiAEQYAOamoiByAEQYAGaiACai8BACAHLwEAajsBACACQQJyIgcgBEGADmpqIgggBEGABmogB2ovAQAgCC8BAGo7AQAgAkEEciIHIARBgA5qaiIIIARBgAZqIAdqLwEAIAgvAQBqOwEAIAJBBnIiAiAEQYAOamoiByAEQYAGaiACai8BACAHLwEAajsBACAFQQRqIgVBgAJHDQALA0AgBkEBdCICIARBgA5qaiIFIARBgApqIAJqLwEAIAUvAQBqOwEAIAJBAnIiBSAEQYAOamoiByAEQYAKaiAFai8BACAHLwEAajsBACACQQRyIgUgBEGADmpqIgcgBEGACmogBWovAQAgBy8BAGo7AQAgAkEGciICIARBgA5qaiIFIARBgApqIAJqLwEAIAUvAQBqOwEAIAZBBGoiBkGAAkcNAAsgBEGAEmoQ6wRBACEFA0BBACAEQYAOaiAFQQF0aiIHLgEAIgJBv50BbEGAgIAQakEadUH/ZWwgAmoiAsFBEHZrIQYgByACQYEaaiACcyAGQRB2cSACczsBACAFQQFqIgVBgAJHDQALIAAgBEGAEmoQlQkgAEHAAmogARCVCSAAQYAFaiADEJUJIABBwAdqIQpBACEGA0AgBEGADmogBkEEdGoiAi8BAiEHIAIvAQAhCCACLwEGIQEgAi8BBCEAIAIvAQohAyACLwEIIQsgCiAGQQJ0aiIFIAIvAQ5BsN/OAGxBgICAQGtBGHZB8AFxIAIvAQxBsN/OAGxBgICAQGtBHHZyOgADIAUgA0Gw384AbEGAgIBAa0EYdkHwAXEgC0Gw384AbEGAgIBAa0EcdnI6AAIgBSABQbDfzgBsQYCAgEBrQRh2QfABcSAAQbDfzgBsQYCAgEBrQRx2cjoAASAFIAdBsN/OAGxBgICAQGtBGHZB8AFxIAhBsN/OAGxBgICAQGtBHHZyOgAAIAZBAWoiBkEgRw0ACyAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEkGYgBCAM/QsEgGZBACECIARBgNoAakEAQYAM/AsAIARBAEGABvwLACACRQRAIARBgBJqQQBBgAz8CwALQQAhBiAEQYAOakEAQYAE/AsAIARBgB5qQQBBgCT8CwAgBkUEQCAEQYAKakEAQYAE/AsACyACRQRAIARBgMIAakEAQYAM/AsACyAGRQRAIARBgAZqQQBBgAT8CwALIAkkAAuAAwEGfwNAIAEgAkEDbGoiAy0AACEEIAAgAkECdGoiBSADLQACQQR0IAMtAAEiA0EEdnI7AQIgBSAEIANBCHRBgB5xcjsBACACQQFqIgJBgAFHDQALIAFBgANqIQYgAEGABGohB0EAIQIDQCAGIAJBA2xqIgMtAAAhBCAHIAJBAnRqIgUgAy0AAkEEdCADLQABIgNBBHZyOwECIAUgBCADQQh0QYAecXI7AQAgAkEBaiICQYABRw0ACyABQYAGaiEGIABBgAhqIQdBACECA0AgBiACQQNsaiIDLQAAIQQgByACQQJ0aiIFIAMtAAJBBHQgAy0AASIDQQR2cjsBAiAFIAQgA0EIdEGAHnFyOwEAIAJBAWoiAkGAAUcNAAsgAUGACWohASAAQYAMaiEAQQAhAgNAIAEgAkEDbGoiAy0AACEEIAAgAkECdGoiBSADLQACQQR0IAMtAAEiA0EEdnI7AQIgBSAEIANBCHRBgB5xcjsBACACQQFqIgJBgAFHDQALC78QAgh/A3sjACIEIQsgBEGglAFrQWBxIgQkACAEQYD0AGogAhD1BCAEIAL9AACADP0LBICUASAEIAJBkAxq/QAAAP0LBJCUASACQYAMaiEIQQEhCQNAIARBgAxqIAVBBHRqIgZBACAJIAEgBWotAAAiAnFrQRB2QYENcTsBACAGQQAgAkECcWtBEHZBgQ1xOwECIAZBACACQQRxa0EQdkGBDXE7AQQgBkEAIAJBCHFrQRB2QYENcTsBBiAGQQAgAkEQcWtBEHZBgQ1xOwEIIAZBACACQSBxa0EQdkGBDXE7AQogBkEAIAJBwABxa0EQdkGBDXE7AQwgBkEAIAJBgAFxa0EQdkGBDXE7AQ4gBUEBaiIFQSBHDQALIAQgBDYCjBAgBCAEQYAUajYCiBAgBCAEQYDkAGo2AoQQIAQgBEGAhAFqNgKAECAEIAhBEGoiAv0AAAD9CwSQhAEgBCAI/QAAAP0LBICEASAEIAL9AAAA/QsEkGQgBCAI/QAAAP0LBIBkIAQgAv0AAAD9CwSQFCAEIAj9AAAA/QsEgBQgBCAC/QAAAP0LBBAgBCAI/QAAAP0LBABBACEGIARBoIQBaiIFQQA7AQAgBEGg5ABqIgdBgAI7AQAgBEGgFGoiCUGABDsBACAEQSBqIgJBgAY7AQAgBEGAJGogBEGAEGoQ2QQgB0GBAjsBACAFQQE7AQAgCUGBBDsBACACQYEGOwEAIARBgDRqIgEgBEGAEGoQ2QQgB0GCAjsBACAFQQI7AQAgCUGCBDsBACACQYIGOwEAIARBgMQAaiIIIARBgBBqENkEIAdBgwI7AQAgBUEDOwEAIAlBgwQ7AQAgAkGDBjsBACAEQYDUAGoiCiAEQYAQahDZBCAFQQA7AQAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBJCEASAEIAz9CwSAhAEgB0EAOwEAIAQgDP0LBJBkIAQgDP0LBIBkIAlBADsBACAEIAz9CwSQFCAEIAz9CwSAFCACQQA7AQAgBCAM/QsEECAEIAz9CwQAIARBgIQBaiAEQYCIAWogBEGAjAFqIARBgJABaiADQQBBAUECQQMQ2gQgBEGA5ABqIARBgOgAaiAEQYDsAGogBEGA8ABqIANBBEEFQQZBBxDaBCAD/QAAECENIAP9AAAAIQ4gAkEIOgAAIAQgDf0LBBAgBCAO/QsEACAEQYAUakGAASAEQSEQ+QQgBEGACGogBEGAFGoQlAkgBEGAFGpBAEGAAfwLACACQQA6AAAgBCAM/QsEECAEIAz9CwQAIARBgIQBahDbBCAEIARBgIQBahDcBCAEQYAUaiAEQYAkaiAEQYCEAWogBBDdBCAEQYAYaiIJIAEgBEGAhAFqIAQQ3QQgBEGAHGoiASAIIARBgIQBaiAEEN0EIARBgCBqIgggCiAEQYCEAWogBBDdBCAEQYAQaiAEQYD0AGogBEGAhAFqIAQQ3QQgBEGAFGoQ+AQgCRD4BCABEPgEIAgQ+AQgBEGAEGoQ+AQgBEGAFGogBEGA5ABqEN4EA0AgBkEBdCICIARBgBBqaiIFIARBgAhqIAJqLwEAIAUvAQBqOwEAIAJBAnIiBSAEQYAQamoiByAEQYAIaiAFai8BACAHLwEAajsBACACQQRyIgUgBEGAEGpqIgcgBEGACGogBWovAQAgBy8BAGo7AQAgAkEGciICIARBgBBqaiIFIARBgAhqIAJqLwEAIAUvAQBqOwEAIAZBBGoiBkGAAkcNAAtBACEGA0AgBkEBdCICIARBgBBqaiIFIARBgAxqIAJqLwEAIAUvAQBqOwEAIAJBAnIiBSAEQYAQamoiByAEQYAMaiAFai8BACAHLwEAajsBACACQQRyIgUgBEGAEGpqIgcgBEGADGogBWovAQAgBy8BAGo7AQAgAkEGciICIARBgBBqaiIFIARBgAxqIAJqLwEAIAUvAQBqOwEAIAZBBGoiBkGAAkcNAAsgBEGAFGoQ3wRBACEFA0BBACAEQYAQaiAFQQF0aiIHLgEAIgJBv50BbEGAgIAQakEadUH/ZWwgAmoiAsFBEHZrIQYgByACQYEaaiACcyAGQRB2cSACczsBACAFQQFqIgVBgAJHDQALIAAgBEGAFGoQlwkgAEHgAmogCRCXCSAAQcAFaiABEJcJIABBoAhqIAgQlwkgAEGAC2ohCkEAIQUDQCAEQYAQaiAFQQR0aiICLwEEIQcgAi8BCiEJIAIvAQIhASACLwEAIQAgAi8BCCEIIAIvAQYhAyAKIAVBBWxqIgYgAi8BDkHA384AbEGAgIAgakEYdkH4AXEgAi8BDEHA384AbEGAgIAgaiICQR12cjoABCAGIAhBwN/OAGxBgICAIGoiCEEXdkHwAXEgA0HA384AbEGAgIAgaiIDQRx2cjoAAiAGIAFBwN/OAGxBgICAIGoiAUEWdkHgAXEgAEHA384AbEGAgIAgakEbdnI6AAAgBiACQRV2QcABcSAJQcDfzgBsQYCAgCBqQRp2QT5xIAhBH3ZycjoAAyAGIANBFHZBgAFxIAdBwN/OAGxBgICAIGpBGXZB/ABxIAFBHnZycjoAASAFQQFqIgVBIEcNAAsgBCAM/QsEkJQBIAQgDP0LBICUAUEAIQIgBEGAhAFqQQBBgBD8CwAgBEEAQYAI/AsAIAJFBEAgBEGAFGpBAEGAEPwLAAtBACEGIARBgBBqQQBBgAT8CwAgBEGAJGpBAEGAwAD8CwAgBkUEQCAEQYAMakEAQYAE/AsACyACRQRAIARBgOQAakEAQYAQ/AsACyAGRQRAIARBgAhqQQBBgAT8CwALIAskAAvwOwEWfyMAIgMhFSADQeAja0FgcSIDJAAgA0H2xys2AjAgAEH5hiogA0EwahCbAUG7riohBiAAQQEQyAEhDyAAQQIQyAEhEAJAIA9FDQAgEEUNAEEAIQYgACgCFCgCAEEYaiIEIAAoAgxPBEAgACgCEEEsaiEECwJAAkACQCAELQAEQQ9xQQNrDgIAAQILIAAgBBBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBGGoiBCAAKAIMSQ0AIAAoAhBBLGohBAsgBCgCAEEQaiEGCwJAAn8CQAJAAkACQCAGQfbuKyAGGyIEQfbuKxCtAQRAIARBjeYrEK0BRQ0BIARBnuwrEK0BDQNBACEEIA8oAgBB4BhGDQJBh7EpIQYMBwtBACEEIA8oAgBB4AxHBEBBh7EpIQYMBwsgECgCAEGABkcEQEHnsCkhBgwHCyAAQSAQhgEiDUUEQEHA5SkhBgwHCyAQKAIIIQcgDSgCCCELIANB4BtqQYgBIA8oAggiCkGABmoiEUGgBkEGENcEIANB4BtqENgEIAMgAy0A4Bs6AOATIAMgAygA4Rs2AOETIAMgA/0AAOUb/QsA5RMgAyADKQD1GzcA9RMgAyADLwD9GzsA/RMgAyADLQD/GzoA/xMgA0HgG2pBAEHIAfwLACAKQaAMaiIOIANB4BNqQSAQhAIhBCAD/QwAAAAAAAAAAAAAAAAAAAAA/QsE8BMgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBOATIAQNA0EAIQYDQCAHIAZBBWxqIgQtAAAhCCAELQACIQUgBC0AASECIANB4BtqIAZBA3RqIgEgBC0ABEECdCAELQADIgRBBnZyQYEabEGABGpBCnY7AQYgASAFQQZ0QcAHcSACQQJ2ckGBGmxBgARqQQp2OwECIAEgCCACQQh0QYAGcXJBgRpsQYAEakEKdjsBACABIARBBHRB8AdxIAVBBHZyQYEabEGABGpBCnY7AQQgBkEBaiIGQcAARw0ACyAHQcACaiEMIANB4B9qIQVBACEGA0AgDCAGQQVsaiIELQAAIQkgBC0AAiECIAQtAAEhCCAFIAZBA3RqIgEgBC0ABEECdCAELQADIgRBBnZyQYEabEGABGpBCnY7AQYgASACQQZ0QcAHcSAIQQJ2ckGBGmxBgARqQQp2OwECIAEgCSAIQQh0QYAGcXJBgRpsQYAEakEKdjsBACABIARBBHRB8AdxIAJBBHZyQYEabEGABGpBCnY7AQQgBkEBaiIGQcAARw0ACyAHQYAFaiEIQQAhBEEAIQYDQCADQeAPaiAGQQJ0aiIBIAYgCGotAAAiAkEEdkGBGmxBCGpBBHY7AQIgASACQQ9xQYEabEEIakEEdjsBACAGQQFqIgZBgAFHDQALA0AgCiAEQQNsaiIGLQAAIQEgA0HgE2ogBEECdGoiAiAGLQACQQR0IAYtAAEiBkEEdnI7AQIgAiABIAZBCHRBgB5xcjsBACAEQQFqIgRBgAFHDQALIApBgANqIQkgA0HgF2ohAkEAIQQDQCAJIARBA2xqIgYtAAAhASACIARBAnRqIgggBi0AAkEEdCAGLQABIgZBBHZyOwECIAggASAGQQh0QYAecXI7AQAgBEEBaiIEQYABRw0ACyADQeAbahDjBCADQeAHaiADQeAbahDkBEEAIQEDQCAFIAFBAnQiBEECciIGai4BACEIIANB4AtqIARqIAIgBmouAQAiDCADQeAHaiABQQF0aiIJLgGAAmwgCS4BACADQeATaiAGai4BACIJbCADQeAbaiAEai4BACISIANB4BNqIARqLgEAIhNsamogBCAFai4BACIUIAIgBGouAQAiBGxqIhZBgICEmH9sQRB1Qf9lbCAWakEQdjsBACADQeALaiAGaiAJIBJsIBMgA0HgG2ogBmouAQBsaiAMIBRsaiAEIAhsaiIEQYCAhJh/bEEQdUH/ZWwgBGpBEHY7AQAgAUEBaiIBQYABRw0ACyADQeALahD4BEEAIQVBACEGA0AgBkEBdCIEIANB4A9qaiIBIAEvAQAgA0HgC2ogBGovAQBrOwEAIARBAnIiASADQeAPamoiAiACLwEAIANB4AtqIAFqLwEAazsBACAEQQRyIgEgA0HgD2pqIgIgAi8BACADQeALaiABai8BAGs7AQAgBEEGciIEIANB4A9qaiIBIAEvAQAgA0HgC2ogBGovAQBrOwEAIAZBBGoiBkGAAkcNAAsDQEEAIQZBACADQeAPaiAFQQF0aiICLgEAIgRBv50BbEGAgIAQakEadUH/ZWwgBGoiBMFBEHZrIQEgAiAEQYEaaiAEcyABQRB2cSAEczsBACAFQQFqIgVBgAJHDQALA0AgA0GgB2ogBmogA0HgD2ogBkEEdGoiBC8BAkG4384AbEGAgICABGpBHnZBAnEgBC8BAEG4384AbEGAgICABGpBH3ZyIAQvAQRBuN/OAGxBgICAgARqQR12QQRxciAELwEGQbjfzgBsQYCAgIAEakEcdkEIcXIgBC8BCEG4384AbEGAgICABGpBG3ZBEHFyIAQvAQpBuN/OAGxBgICAgARqQRp2QSBxciAELwEMQbjfzgBsQYCAgIAEakEZdkHAAHFyIAQvAQ5BuN/OAGxBgICAgARqQRh2QYABcXI6AAAgBkEBaiIGQSBHDQALQQAhBCADQeATakEAQYAI/AsAIANB4BtqQQBBgAj8CwAgA0HgB2pBAEGABPwLACADQeAPakEAQYAE/AsAIANB4AtqQQBBgAT8CwAgAyAO/QAAEP0LBNAHIAMgDv0AAAD9CwTAByADQeAbakHIACADQaAHakHAAEEGENcEIANB4BtqENgEA0AgA0HgBmogBGogA0HgG2ogBGotAAA6AAAgBEEBciIGIANB4AZqaiADQeAbaiAGai0AADoAACAEQQJyIgYgA0HgBmpqIANB4BtqIAZqLQAAOgAAIARBA3IiBiADQeAGamogA0HgG2ogBmotAAA6AAAgBEEEaiIEQcAARw0AC0EAIQQgA0HgG2pBAEHIAfwLACADQUBrIANBoAdqIBEgA0GAB2oQ8gRBACEGQQAhAQNAIARBAmoiBSADQUBrai0AACAFIAdqLQAAcyIFIARBAWoiAiADQUBrai0AACACIAdqLQAAcyICIANBQGsgBGotAAAgBCAHai0AAHMiCCAGc3NzIQYgBSACIAEgCHJyciEBIARBA2oiBEGABkcNAAsgAyAK/QAAwAz9CwRAIAMgCkHQDGr9AAAA/QsEUCADQeAAaiAHQYAG/AoAACALQSAgA0FAa0GgBhD5BEEAIQRBAEEAIAFB/wFxa0EYdmtBGHYhBgNAIAQgC2oiByADQeAGaiAEai0AACIBIActAABzIAZxIAFzOgAAIAsgBEEBciIHaiIBIANB4AZqIAdqLQAAIgcgAS0AAHMgBnEgB3M6AAAgBEECaiIEQSBHDQALIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwTQByAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAcgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBLAHIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwSgByAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAcgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBIAHIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwTwBiAD/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AZBACEGIANBQGtBAEGgBvwLACANQSA2AgBBASEEDAYLQQAhBCAPKAIAQeASRwRAQYexKSEGDAYLIBAoAgBBwAhHBEBB57ApIQYMBgsgAEEgEIYBIgZFBEBBwOUpIQYMBgsgBigCCCEHIBAoAgghCyAPKAIIIQ0jACIBIRMgAUHAJmtBYHEiASQAIAFBwBpqQYgBIA1BgAlqIhRBoAlBBhDXBCABQcAaahDYBCABIAEtAMAaOgDADiABIAEoAMEaNgDBDiABIAH9AADFGv0LAMUOIAEgASkA1Ro3ANUOIAEgAS8A3Ro7AN0OIAEgAS0A3xo6AN8OIAFBwBpqQQBByAH8CwAgDUGgEmoiEiABQcAOakEgEIQCIQUgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNAOIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTADkF/IQIgBUUEQEEAIQUDQCALIAVBBWxqIgItAAAhDCACLQACIQkgAi0AASEKIAFBwBpqIAVBA3RqIgggAi0ABEECdCACLQADIgJBBnZyQYEabEGABGpBCnY7AQYgCCAJQQZ0QcAHcSAKQQJ2ckGBGmxBgARqQQp2OwECIAggDCAKQQh0QYAGcXJBgRpsQYAEakEKdjsBACAIIAJBBHRB8AdxIAlBBHZyQYEabEGABGpBCnY7AQQgBUEBaiIFQcAARw0ACyALQcACaiEOIAFBwB5qIRFBACEFA0AgDiAFQQVsaiICLQAAIQwgAi0AAiEJIAItAAEhCiARIAVBA3RqIgggAi0ABEECdCACLQADIgJBBnZyQYEabEGABGpBCnY7AQYgCCAJQQZ0QcAHcSAKQQJ2ckGBGmxBgARqQQp2OwECIAggDCAKQQh0QYAGcXJBgRpsQYAEakEKdjsBACAIIAJBBHRB8AdxIAlBBHZyQYEabEGABGpBCnY7AQQgBUEBaiIFQcAARw0ACyALQYAFaiEOIAFBwCJqIRFBACEFA0AgDiAFQQVsaiICLQAAIQwgAi0AAiEJIAItAAEhCiARIAVBA3RqIgggAi0ABEECdCACLQADIgJBBnZyQYEabEGABGpBCnY7AQYgCCAJQQZ0QcAHcSAKQQJ2ckGBGmxBgARqQQp2OwECIAggDCAKQQh0QYAGcXJBgRpsQYAEakEKdjsBACAIIAJBBHRB8AdxIAlBBHZyQYEabEGABGpBCnY7AQQgBUEBaiIFQcAARw0ACyALQcAHaiEJQQAhAgNAIAFBwApqIAJBAnRqIgUgAiAJai0AACIIQQR2QYEabEEIakEEdjsBAiAFIAhBD3FBgRpsQQhqQQR2OwEAIAJBAWoiAkGAAUcNAAsgAUHADmogDRDzBCABQcAaahDnBCABQUBrIAFBwBpqEOgEIAFBwAZqIAFBwA5qIAFBwBpqIAFBQGsQ6QQgAUHABmoQ+ARBACEJQQAhBQNAIAVBAXQiAiABQcAKamoiCCAILwEAIAFBwAZqIAJqLwEAazsBACACQQJyIgggAUHACmpqIgogCi8BACABQcAGaiAIai8BAGs7AQAgAkEEciIIIAFBwApqaiIKIAovAQAgAUHABmogCGovAQBrOwEAIAJBBnIiAiABQcAKamoiCCAILwEAIAFBwAZqIAJqLwEAazsBACAFQQRqIgVBgAJHDQALA0BBACEFQQAgAUHACmogCUEBdGoiCi4BACICQb+dAWxBgICAEGpBGnVB/2VsIAJqIgLBQRB2ayEIIAogAkGBGmogAnMgCEEQdnEgAnM7AQAgCUEBaiIJQYACRw0ACwNAIAEgBWogAUHACmogBUEEdGoiAi8BAkG4384AbEGAgICABGpBHnZBAnEgAi8BAEG4384AbEGAgICABGpBH3ZyIAIvAQRBuN/OAGxBgICAgARqQR12QQRxciACLwEGQbjfzgBsQYCAgIAEakEcdkEIcXIgAi8BCEG4384AbEGAgICABGpBG3ZBEHFyIAIvAQpBuN/OAGxBgICAgARqQRp2QSBxciACLwEMQbjfzgBsQYCAgIAEakEZdkHAAHFyIAIvAQ5BuN/OAGxBgICAgARqQRh2QYABcXI6AAAgBUEBaiIFQSBHDQALQQAhAiABQcAOakEAQYAM/AsAIAFBwBpqQQBBgAz8CwAgAUFAa0EAQYAG/AsAIAFBwApqQQBBgAT8CwAgAUHABmpBAEGABPwLACABIBL9AAAQ/QsEMCABIBL9AAAA/QsEICABQcAaakHIACABQcAAQQYQ1wQgAUHAGmoQ2AQDQCABQUBrIAJqIAFBwBpqIAJqLQAAOgAAIAJBAXIiBSABQUBraiABQcAaaiAFai0AADoAACACQQJyIgUgAUFAa2ogAUHAGmogBWotAAA6AAAgAkEDciIFIAFBQGtqIAFBwBpqIAVqLQAAOgAAIAJBBGoiAkHAAEcNAAtBACECIAFBwBpqQQBByAH8CwAgAUHAGmogASAUIAFB4ABqEPQEQQAhBUEAIQgDQCACQQFyIgkgAUHAGmpqLQAAIAkgC2otAABzIgkgAUHAGmogAmotAAAgAiALai0AAHMiCiAFc3MhBSAJIAggCnJyIQggAkECaiICQcAIRw0ACyABIA39AADAEv0LBMAaIAEgDUHQEmr9AAAA/QsE0BogAUHgGmogC0HACPwKAAAgAUHADmpBiAEgAUHAGmpB4AhBHxDXBCABQcAOahDYBCAHIAEtAMAOOgAAIAcgAS0AwQ46AAEgByABLQDCDjoAAiAHIAEtAMMOOgADIAcgAS0AxA46AAQgByABLQDFDjoABSAHIAEtAMYOOgAGIAcgAS0Axw46AAcgByABLQDIDjoACCAHIAEtAMkOOgAJIAcgAS0Ayg46AAogByABLQDLDjoACyAHIAEtAMwOOgAMIAcgAS0AzQ46AA0gByABLQDODjoADiAHIAEtAM8OOgAPIAcgAS0A0A46ABAgByABLQDRDjoAESAHIAEtANIOOgASIAcgAS0A0w46ABMgByABLQDUDjoAFCAHIAEtANUOOgAVIAcgAS0A1g46ABYgByABLQDXDjoAFyAHIAEtANgOOgAYIAcgAS0A2Q46ABkgByABLQDaDjoAGiAHIAEtANsOOgAbIAcgAS0A3A46ABwgByABLQDdDjoAHSAHIAEtAN4OOgAeIAcgAS0A3w46AB9BACECIAFBwA5qQQBByAH8CwBBAEEAIAhB/wFxa0EYdmtBGHYhBQNAIAIgB2oiCCABQUBrIAJqLQAAIgsgCC0AAHMgBXEgC3M6AAAgByACQQFyIghqIgsgAUFAayAIai0AACIIIAstAABzIAVxIAhzOgAAIAJBAmoiAkEgRw0ACyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEMCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEICAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEcCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEYCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEUCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEQCABQcAaakEAQeAI/AsAQQAhAgsgEyQAIAIEQEHe5SkhBgwGCyAGQSA2AgAMBAsgECgCAEGgDEcEQEHnsCkhBgwFCyAAQSAQhgEiBkUEQEHA5SkhBgwFCyAGKAIIIQwgECgCCCEKIA8oAgghCyMAIgEhEyABQcAwa0FgcSIBJAAgAUHAIGpBiAEgC0GADGoiFEGgDEEGENcEIAFBwCBqENgEIAEgAS0AwCA6AMAQIAEgASgAwSA2AMEQIAEgAf0AAMUg/QsAxRAgASABKQDVIDcA1RAgASABLwDdIDsA3RAgASABLQDfIDoA3xAgAUHAIGpBAEHIAfwLACALQaAYaiISIAFBwBBqQSAQhAIhBSAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0BAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMAQQX8hAiAFRQRAIAFBwCBqIAoQlgkgAUHAJGogCkHgAmoQlgkgAUHAKGogCkHABWoQlgkgAUHALGogCkGgCGoQlgkgCkGAC2ohEQNAIBEgB0EFbGoiBS0AAiENIAUtAAMhCCAFLQABIQkgBS0ABCEOIAFBwAxqIAdBBHRqIgIgBS0AACIFQR9xQYEabEEQakEFdjsBACACIA5BA3ZBgRpsQRBqQQV2OwEOIAIgCUECdkEfcUGBGmxBEGpBBXY7AQQgAiAIQQF2QR9xQYEabEEQakEFdjsBCiACIAlBA3RBGHEgBUEFdnJBgRpsQRBqQQV2OwECIAIgDUEBdEEecSAJQQd2ckGBGmxBEGpBBXY7AQYgAiAIQQR0QRBxIA1BBHZyQYEabEEQakEFdjsBCCACIA5BAnRBHHEgCEEGdnJBgRpsQRBqQQV2OwEMIAdBAWoiB0EgRw0ACyABQcAQaiALEPUEIAFBwCBqENsEIAFBQGsgAUHAIGoQ3AQgAUHACGogAUHAEGogAUHAIGogAUFAaxDdBCABQcAIahD4BEEAIQhBACEFA0AgBUEBdCICIAFBwAxqaiIHIAcvAQAgAUHACGogAmovAQBrOwEAIAJBAnIiByABQcAMamoiCSAJLwEAIAFBwAhqIAdqLwEAazsBACACQQRyIgcgAUHADGpqIgkgCS8BACABQcAIaiAHai8BAGs7AQAgAkEGciICIAFBwAxqaiIHIAcvAQAgAUHACGogAmovAQBrOwEAIAVBBGoiBUGAAkcNAAsDQEEAIQVBACABQcAMaiAIQQF0aiIJLgEAIgJBv50BbEGAgIAQakEadUH/ZWwgAmoiAsFBEHZrIQcgCSACQYEaaiACcyAHQRB2cSACczsBACAIQQFqIghBgAJHDQALA0AgASAFaiABQcAMaiAFQQR0aiICLwECQbjfzgBsQYCAgIAEakEedkECcSACLwEAQbjfzgBsQYCAgIAEakEfdnIgAi8BBEG4384AbEGAgICABGpBHXZBBHFyIAIvAQZBuN/OAGxBgICAgARqQRx2QQhxciACLwEIQbjfzgBsQYCAgIAEakEbdkEQcXIgAi8BCkG4384AbEGAgICABGpBGnZBIHFyIAIvAQxBuN/OAGxBgICAgARqQRl2QcAAcXIgAi8BDkG4384AbEGAgICABGpBGHZBgAFxcjoAACAFQQFqIgVBIEcNAAtBACECIAFBwBBqQQBBgBD8CwAgAUHAIGpBAEGAEPwLACABQUBrQQBBgAj8CwAgAUHADGpBAEGABPwLACABQcAIakEAQYAE/AsAIAEgEv0AABD9CwQwIAEgEv0AAAD9CwQgIAFBwCBqQcgAIAFBwABBBhDXBCABQcAgahDYBANAIAFBwBBqIAJqIAFBwCBqIAJqLQAAOgAAIAJBAXIiBSABQcAQamogAUHAIGogBWotAAA6AAAgAkECciIFIAFBwBBqaiABQcAgaiAFai0AADoAACACQQNyIgUgAUHAEGpqIAFBwCBqIAVqLQAAOgAAIAJBBGoiAkHAAEcNAAtBACECIAFBwCBqQQBByAH8CwAgAUHAIGogASAUIAFB4BBqEPYEQQAhBUEAIQcDQCACQQFyIgggAUHAIGpqLQAAIAggCmotAABzIgggAUHAIGogAmotAAAgAiAKai0AAHMiCSAFc3MhBSAIIAcgCXJyIQcgAkECaiICQaAMRw0ACyABIAv9AADAGP0LBMAgIAEgC0HQGGr9AAAA/QsE0CAgAUHgIGogCkGgDPwKAAAgDEEgIAFBwCBqQcAMEPkEQQAhAkEAQQAgB0H/AXFrQRh2a0EYdiEFA0AgAiAMaiIHIAFBwBBqIAJqLQAAIgggBy0AAHMgBXEgCHM6AAAgDCACQQFyIgdqIgggAUHAEGogB2otAAAiByAILQAAcyAFcSAHczoAACACQQJqIgJBIEcNAAsgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBDAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBCAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHwEGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB4BBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0BAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMAQIAFBwCBqQQBBwAz8CwBBACECCyATJAAgAgRAQd7lKSEGDAULIAZBIDYCAAwDCyADQfbHKzYCIEGN+SsgBCADQSBqEG5BjpAqDAELQd7lKQshBkEAIQQMAQtBACEGQQEhBAsgDxCaASAQEJoBIAQEQCADQfbHKzYCACAAQeCHKiADEJsBIBUkAEEBDwsgAyAGNgIUIANB9scrNgIQIABB/IgqIANBEGoQbAALxAIBDH9BAiEDIABBAmohBQNAIAAgAkEBdCIBaiIEIAQuAQAiBEGAgITFfWxBEHVB/2VsIARBoQtsakEQdjsBACABIAVqIgEgAS4BACIBQYCAhMV9bEEQdUH/ZWwgAUGhC2xqQRB2OwEAIAJBAmoiAkGAAkcNAAsDQCADQQF0IQZBgAIgA2h2IQlBACEHIAMhCANAIAlBAWsiCUEBdEHAyDFqLgEAIgpBgICEmH9sIQsgByECA0AgACACQQF0aiIBIAEgA0EBdGoiBC8BACIFIAEvAQAiAWoiDMFBv50BbEGAgIAQakEadUH/ZWwgDGo7AQAgBCALIAUgAWvBIgFsQRB1Qf9lbCABIApsakEQdjsBACACQQFqIgIgCEcNAAsgBiAIaiEIIAYgB2oiB0GAAkkNAAsgA0HBAEkhAiAGIQMgAg0ACwuSAgEFfyMAQdABayIEJAAgBEEIakGIASACIANBHxDXBANAQYgBIAEgAUGIAU8bIgZBA3EhByAEQQhqENgEQQAhAkEAIQMgAUEETwRAIAZB/AFxIQgDQCAAIANqIARBCGogA2otAAA6AAAgACADQQFyIgVqIARBCGogBWotAAA6AAAgACADQQJyIgVqIARBCGogBWotAAA6AAAgACADQQNyIgVqIARBCGogBWotAAA6AAAgA0EEaiIDIAhHDQALCyAHBEADQCAAIANqIARBCGogA2otAAA6AAAgA0EBaiEDIAJBAWoiAiAHRw0ACwsgACAGaiEAIAEgBmsiAQ0ACyAEQQhqQQBByAH8CwAgBEHQAWokAAujKQETfyMAQdDgAGsiAyQAIANBu70qNgJQIABB+YYqIANB0ABqEJsBIABBAEECEKEBIABB4w0QhgEiEQRAIAAgACgCDEEQa0Hf/yoQWSAAQYYJEIYBIRIgACAAKAIMQRBrQe/GKxBZIBIoAgghDCARKAIIIQggA0HQyABqQQFyIQ0gA0HQPGpBAXIhEwNAIANB5Bc2AkAgA0HpADsA0EhBACEBQaX2MyADQdDIAGogA0FAaxAAIQIDQCADQeAYaiABaiABIAJqLQAAOgAAIAFBAXIiBCADQeAYamogAiAEai0AADoAACABQQJyIgQgA0HgGGpqIAIgBGotAAA6AAAgAUEDciIEIANB4BhqaiACIARqLQAAOgAAIAFBBGoiAUHkF0cNAAsgAhArQQAhAUEAIQIDQCACQfgFRkUEQCACQQhqIQIMAQsLA0AgA0HgEmogAWogA0HgGGogAUECdGooAgBB/////wNxQQNsQR52QQFrOgAAIAFB+AVGRQRAIAFBAXIiAiADQeASamogA0HgGGogAkECdGooAgBB/////wNxQQNsQR52QQFrOgAAIAFBAmohAQwBCwtBACEBQQAhAiADQdA8akEAQfoF/AsAIAJFBEAgA0HQMGpBAEH6BfwLAAsgA0EBOgDQMCADQeAYakEAQfkF/AsAIANBAToA4BggA0H//wM7AdgeA0AgAyABa0HIzgBqIANB4BJqIAFqLQAAIgJBAXEiBCAEQQF0IAJxazoAACABQfgFRkUEQCADIAFBAXIiAmtByM4AaiADQeASaiACai0AACICQQFxIgQgBEEBdCACcWs6AAAgAUECaiEBDAELC0EAIQsgA0EAOgDJTkEBIQkDQCAKRQRAIBMgA0HQPGpB+QX8CgAAC0EAIQEgA0EAOgDQPEEAIAlrIg5BEHRBH3VBACADLADQSCIPGyEEIAMsAOAYIRADQCADQeAYaiABaiICIANB0MgAaiABaiIFLQAAIgYgAi0AACICcyAEcSIHIAJzOgAAIAUgBiAHczoAACADQdA8aiABaiICIANB0DBqIAFqIgUtAAAiBiACLQAAIgJzIARxIgcgAnM6AAAgBSAGIAdzOgAAIAFBAWoiAUH6BUcNAAtBACEBQQAgDyAQbGshBUEAIQIDQCADQdDIAGogAmoiBiAGLAAAIANB4BhqIAJqLAAAIAVsaiIGwUGr1QBsQYCAAWpBD3ZB/QFsIAZqOgAAIAJBAWoiAkH6BUcNAAsDQCADQdAwaiABaiICIAIsAAAgA0HQPGogAWosAAAgBWxqIgLBQavVAGxBgIABakEPdkH9AWwgAmo6AAAgAUEBaiIBQfoFRw0ACyAKRQRAIANB0MgAaiANQfkF/AoAAAsgA0EAOgDJTiAEIAkgDnNxIAlzQQFqIQkgC0EBaiILQfELRw0AC0EAIQEgAy0A4BghAgNAIANB4ABqIAFqIAMgAWtByMIAai0AACACbDoAACABQfgFRkUEQCABQQFyIgQgA0HgAGpqIAMgBGtByMIAai0AACACbDoAACABQQJyIgQgA0HgAGpqIAMgBGtByMIAai0AACACbDoAACABQQNyIgQgA0HgAGpqIAMgBGtByMIAai0AACACbDoAACABQQRqIQEMAQsLIANBf0EAIAlB//8DcSIBGzoA2QYgAQ0ACyAIQb8BaiECIANB4ABqIQFBACEEA0AgAiABLQAAIAEtAAFBAnRqIAEtAAJBBHRqIAEtAANBBnRqQdUAajoAACACIAEtAAQgAS0ABUECdGogAS0ABkEEdGogAS0AB0EGdGpB1QBqOgABIAJBAmohAiABQQhqIQEgBEECaiIEQb4BRw0ACyACIAEtAABBAWo6AAAgA0HkFzYCMCADQekAOwDQSEEAIQFBpfYzIANB0MgAaiADQTBqEAAhAgNAIANB4BhqIAFqIAEgAmotAAA6AAAgAUEBciIEIANB4BhqaiACIARqLQAAOgAAIAFBAnIiBCADQeAYamogAiAEai0AADoAACABQQNyIgQgA0HgGGpqIAIgBGotAAA6AAAgAUEEaiIBQeQXRw0ACyACECtBACECQQAhAQNAIAFB+AVGBEADQCADQeAYaiACQQJ0aiIBIAEoAgBBfnE2AgAgAUEEaiIEIAQoAgBBfnE2AgAgAkGcAkYEQEGeAiECA0AgA0HgGGogAkECdGoiASABKAIAQXxxQQFyNgIAIAFBBGoiBCAEKAIAQXxxQQFyNgIAIAFBCGoiASABKAIAQXxxQQFyNgIAIAJBA2oiAUH5BUZFBEAgA0HgGGogAUECdGoiASABKAIAQXxxQQFyNgIAIAJBBGohAgwBCwsgA0HgGGoQ+wRBACEBA0AgA0HgDGogAWogA0HgGGogAUECdGotAABBA3FBAWs6AAAgAUH4BUZFBEAgAUEBciICIANB4AxqaiADQeAYaiACQQJ0ai0AAEEDcUEBazoAACABQQJyIgIgA0HgDGpqIANB4BhqIAJBAnRqLQAAQQNxQQFrOgAAIAFBA3IiAiADQeAMamogA0HgGGogAkECdGotAABBA3FBAWs6AAAgAUEEaiEBDAELCyADQeAMaiEBQQAhBCAIIQIDQCACIAEtAAAgAS0AAUECdGogAS0AAkEEdGogAS0AA0EGdGpB1QBqOgAAIAIgAS0ABCABLQAFQQJ0aiABLQAGQQR0aiABLQAHQQZ0akHVAGo6AAEgAkECaiECIAFBCGohASAEQQJqIgRBvgFHDQALQQEhBCACIAEtAABBAWo6AABBACEBIANB0DxqQQBB9Av8CwAgAUUEQCADQdAwakEAQfQL/AsAC0EDIQEDQCABwUEDbCIBQQx1QZFcbCABaiIBQTlsQRJ1QZFcbCABaiIBQbPkAWxBgICAIGpBG3VBkVxsIAFqIgFBs+QBbEGAgIAgakEbdUGR3ANsIAFqIQEgBEEBaiIEQe0jRw0ACyADIAE7AdAwQQAhASADQeAYakEAQfAL/AsAIANBATsB4BggA0F/NgLQJANAQQAgAWtBAXQgA2pBwNQAaiADQeAMaiABaiwAADsBACABQfgFRkUEQEEAIAFBAXIiAmtBAXQgA2pBwNQAaiADQeAMaiACaiwAADsBAEEAIAFBAnIiAmtBAXQgA2pBwNQAaiADQeAMaiACaiwAADsBAEEAIAFBA3IiAmtBAXQgA2pBwNQAaiADQeAMaiACaiwAADsBACABQQRqIQEMAQsLIANBADsBwlQgA0HQyABqQQJyIRAgA0HQPGpBAnIhDUEAIQtBASEKA0BBACEOIA0gA0HQPGpB8gv8CgAAQQAhAiADQQA7AdA8QQAgCmsiD0EQdEEfdUEAIAMvAdBIGyEFA0AgAkEBdCIBIANB4BhqaiIEIANB0MgAaiABaiIGLwEAIgcgBC8BACIEcyAFcSIJIARzOwEAIAYgByAJczsBACADQdA8aiABaiIEIANB0DBqIAFqIgEvAQAiBiAELwEAIgRzIAVxIgcgBHM7AQAgASAGIAdzOwEAIAJBAWoiAkH6BUcNAAtBACEBIAMuAdBIIQYgAy4B4BghBEEAIQIDQCACQQF0IgcgA0HQyABqaiIJIAkuAQAgBGwgA0HgGGogB2ouAQAgBmxrIgdBDHVBkVxsIAdqIgdBOWxBEnVBkVxsIAdqIgdBs+QBbEGAgIAgakEbdUGRXGwgB2oiB0Gz5AFsQYCAgCBqQRt1QZHcA2wgB2o7AQAgAkEBaiICQfoFRw0ACwNAIAFBAXQiAiADQdAwamoiByAHLgEAIARsIANB0DxqIAJqLgEAIAZsayICQQx1QZFcbCACaiICQTlsQRJ1QZFcbCACaiICQbPkAWxBgICAIGpBG3VBkVxsIAJqIgJBs+QBbEGAgIAgakEbdUGR3ANsIAJqOwEAIAFBAWoiAUH6BUcNAAsgDkUEQCADQdDIAGogEEHyC/wKAAALIANBADsBwlQgBSAKIA9zcSAKc0EBaiEKIAtBAWoiC0HxC0cNAAsgBCEBQQEhAgNAIAHBIARsIgFBDHVBkVxsIAFqIgFBOWxBEnVBkVxsIAFqIgFBs+QBbEGAgIAgakEbdUGRXGwgAWoiAUGz5AFsQYCAgCBqQRt1QZHcA2wgAWohASACQQFqIgJB7SNHDQALIAHBIQVBACEEQQAhAQNAIANB0NQAaiABQQF0aiAFQQAgAWtBAXQgA2pBwMgAai4BAGwiAkEMdUGRXGwgAmoiAkE5bEESdUGRXGwgAmoiAkGz5AFsQYCAgCBqQRt1QZFcbCACaiICQbPkAWxBgICAIGpBG3VBkdwDbCACajsBACABQQFqIgFB+QVHDQALIANB0NQAaiEBIANB4ABqIQIDQCACIAEvAQA7AAAgBEH4BUZFBEAgAiABLwECOwACIAIgAS8BBDsABCACIAEvAQY7AAYgBEEEaiEEIAJBCGohAiABQQhqIQEMAQsLQQAhASADQX9BACAKQf//A3EbOgDSDCADQeAAaiIEIQVBACECA0AgAkH4BUYEQANAIAFB+AVGRQRAIAFBBGohASAEQQhqIQQMAQsLIANB4ABqIANB4ABqIANB4BJqEPwEQQAhASADQeAAaiECA0AgAUH4BUZFBEAgAUEEaiEBIAJBCGohAgwBCwtBACECIAwhAQNAIAEgA0HgAGogAkECdGoiBC8BAkH3EWpB//8AcUHvI2wgBC8BAEH3EWpB//8AcWoiBDsAACADQeAYaiACQQF0aiAEQRB2OwEAIAFBAmohASACQQFqIgJB/AJHDQALIAMgAy8B0AxB9xFqQf//AHE7AdgeQQAhAgNAIAEgA0HgGGogAkECdGoiBC8BAkHCAmwgBC8BAGoiBDoAACADQeAYaiACQQF0aiAEQQh2OwEAIAEgA0HgGGogAkEBciIEQQJ0aiIFLwECQcICbCAFLwEAaiIFOgABIANB4BhqIARBAXRqIAVBCHY7AQAgAUECaiEBIAJBAmoiAkG+AUcNAAsgAyADLwHYHjsB3BtBACECA0AgASADQeAYaiACQQJ0aiIELwECQZYDbCAELwEAaiIEOgAAIANB4BhqIAJBAXRqIARBCHY7AQAgAkHeAEZFBEAgASADQeAYaiACQQFyIgRBAnRqIgUvAQJBlgNsIAUvAQBqIgU6AAEgA0HgGGogBEEBdGogBUEIdjsBACACQQJqIQIgAUECaiEBDAELCyABQQFqIQEgAyADLwHcGzsBnhpBACECQQAhBANAIAEgA0HgGGogBEECdGoiBS8BAkGEBWwgBS8BAGoiBToAACADQeAYaiAEQQF0aiAFQQh2OwEAIAEgA0HgGGogBEEBciIFQQJ0aiIGLwECQYQFbCAGLwEAaiIGOgABIANB4BhqIAVBAXRqIAZBCHY7AQAgAUECaiEBIARBAmoiBEEwRw0ACwNAIAEgA0HgGGogAkECdGoiBC8BAkHVDGwgBC8BAGoiBDoAACADQeAYaiACQQF0aiAEQQh2OwEAIAJBFkZFBEAgASADQeAYaiACQQFyIgRBAnRqIgUvAQJB1QxsIAUvAQBqIgU6AAEgA0HgGGogBEEBdGogBUEIdjsBACACQQJqIQIgAUECaiEBDAELCyABQQFqIQUgASADLwG8GSADLwG+GUHVDGxqIgI7AAEgAyACQRB2OwGOGSABQQNqIQRBACEBA0AgBCICIANB4BhqIAFBAnRqIgQvAQJBmdAAbCAELwEAaiIEOgAAIAUgBEEIdjoAAyADQeAYaiABQQF0aiAEQRB2OwEAIAJBAmohBCACIQUgAUEBaiIBQQtHDQALIAIgAy8BjBkgAy8BjhlBmdAAbGoiAToAAiADIAFBCHY7AfYYIAIgAy8B4BggAy8B4hhByAxsaiIBOgADIAIgAy8B5BggAy8B5hhByAxsaiIEOgAEIAIgAy8B6BggAy8B6hhByAxsaiIFOgAFIAIgAy8B7BggAy8B7hhByAxsaiIGOgAGIAMgBkEIdjsB5hggAiADLwHwGCADLwHyGEHIDGxqIgY6AAcgAyAGQQh2OwHoGCACIAMvAfQYIAMvAfYYQcgMbGoiBjsACCADIAZBEHY7AeoYIAIgBEEIdkH//wNxQfXOAGwgAUEIdkH//wNxaiIBQQh2OgALIAIgAToACiACIAMvAeYYQfXOAGwgBUEIdkH//wNxaiIEOwAMIAMvAegYIQUgAy8B6hghBiACIARBEHZBlQxsIAFBEHZqIgE6AA8gAiAFIAZB9c4AbGoiBDoADiACIARBCHZB//8DcUH+yQBsIAFBCHZqIgE6ABAgAiABQRh2OgATIAIgAUEQdjoAEiACIAFBCHY6ABEgCEH+AmohAiAIQf0CaiEFIAgtAP0CIQZBACEBA0AgASACaiABIAxqLQAAOgAAIAIgAUEBaiIEaiAEIAxqLQAAOgAAIAIgAUECaiIEaiAEIAxqLQAAOgAAIAFBA2oiAUGGCUcNAAsgCEEEOgD9AiADQeAYaiAFQYcJEP0EIAhB0w1qIANB8Bhq/QAEAP0LAAAgCCAD/QAE4Bj9CwDDDSAIIAY6AP0CIANBvwE2AiAgA0HpADsA4BggCEGEDGohBEEAIQZBpfYzIANB4BhqIANBIGoQACECQQAhAQNAIAEgBGogASACai0AADoAACAEIAFBAXIiBWogAiAFai0AADoAACAEIAFBAnIiBWogAiAFai0AADoAACAEIAFBA3IiBWogAiAFai0AADoAAEG8ASEFIAFBBGoiAUG8AUcNAAsDQCAEIAVqIAIgBWotAAA6AAAgBUEBaiEFIAZBAWoiBkEDRw0ACyACECsgEkGGCTYCACARQeMNNgIAIANBu70qNgIQIABB4IcqIANBEGoQmwEgA0HQ4ABqJABBAQ8FIAJBBGohAiAFQQhqIQUMAQsACwAFIAFBCGoiBCAEKAIAQX5xNgIAIAFBDGoiASABKAIAQX5xNgIAIAJBBGohAgwBCwALAAUgAUEIaiEBDAELAAsACyADQfKzKTYCBCADQbu9KjYCACAAQfyIKiADEGwAC5EJAg9/B34gAEEMaiEMIABBCGohDSAAQQRqIQ4DQCAAIBCnQQJ0IgJqIgEgASgCAEGAgICAeHM2AgAgAiAOaiIBIAEoAgBBgICAgHhzNgIAIAIgDWoiASABKAIAQYCAgIB4czYCACACIAxqIgIgAigCAEGAgICAeHM2AgAgEEIEfCIQQvgFUg0ACyAAIAAoAuAXQYCAgIB4czYC4BdBgAQhBANAIARBAXQiD60hFEIAIRAgBEH8Ak0EQCAAIARBAnRqIQYgBK0hEUIAIRIgFCEQA0AgECETIBIhEANAIAAgEKdBAnQiAmoiAyACIAZqIgIoAgAiASADKAIAIgNrIgUgAXMgASADcyIBcSAFc0EfdSABcSIBIANzNgIAIAIgASACKAIAczYCACAQQgF8IhAgEVINAAsgEiAUfCESIBEgFHwhESATIBR8IhBC+QVYDQALIBNC/v///w+DIRALIBBC+QUgBK0iFX0iEVMEQCAAIARBAnRqIQYDQCAAIBCnQQJ0IgJqIgMgAiAGaiICKAIAIgEgAygCACIDayIFIAFzIAEgA3MiAXEgBXNBH3UgAXEiASADczYCACACIAEgAigCAHM2AgAgEEIBfCIQIBFSDQALCyAEQf8DTQRAIAAgBEECdGohC0IAIRBBACEIQYAEIQcDQEL5BSAHrX0iEyEWAkAgCK0gEFIEQCAEIAhqrSERA0AgECATUQRAIBMhEAwDCyALIBCnQQJ0IgFqIgkoAgAhAiAEIAdJBEAgACABaiEKIAchAwNAIAogA0ECdGoiASABKAIAIgEgAmsiBSABcyABIAJzIgZxIAVzQR91IAZxIgUgAXM2AgAgAiAFcyECIANBAXYiAyAESw0ACwsgCSACNgIAIBBCAXwiECARUg0ACyAIIA9qIQgLIBYgBCAIaq0iEVkEQCAIrSESA0AgEiEQA0AgCyAQp0ECdCIBaiIJKAIAIQIgBCAHSQRAIAAgAWohCiAHIQMDQCAKIANBAnRqIgEgASgCACIBIAJrIgUgAXMgASACcyIGcSAFc0EfdSAGcSIFIAFzNgIAIAIgBXMhAiADQQF2IgMgBEsNAAsLIAkgAjYCACAQQgF8IhAgEVQNAAsgEyASIBR8IhIgFXwiEVoNAAsgEqchCAsgEyAIrSIQVw0AA0AgCyAQp0ECdCIBaiIJKAIAIQIgBCAHSQRAIAAgAWohCiAHIQMDQCAKIANBAnRqIgEgASgCACIBIAJrIgUgAXMgASACcyIGcSAFc0EfdSAGcSIFIAFzNgIAIAIgBXMhAiADQQF2IgMgBEsNAAsLIAkgAjYCACAQQgF8IhAgE1INAAsLIAdBAXYiByAESw0ACwsgBEEBSyECIARBAXYhBCACDQALQgAhEANAIAAgEKdBAnQiAmoiASABKAIAQYCAgIB4czYCACACIA5qIgEgASgCAEGAgICAeHM2AgAgAiANaiIBIAEoAgBBgICAgHhzNgIAIAIgDGoiAiACKAIAQYCAgIB4czYCACAQQgR8IhBC+AVSDQALIAAgACgC4BdBgICAgHhzNgLgFwveCAEHfyMAQfApayIFJAAgBUHwHWohAwNAIAMgAS8AADsBACAGQfgFRgRAA0AgBUHwHWogBEEBdGoiASABLgEAIgNBOWxBEnVBkVxsIANqIgNBs+QBbEGAgIAgakEbdUGR3ANsIANqOwEAIARB+AVGBEBBACEBQQEhCANAIAVB8BdqIAFqIAEgAmotAAAiA0EBcSIEIARBAXQgA3FrOgAAIAFB+AVGBEBBACEDA0ACQCADRQRAQQAhBEEAIQcMAQsgCEH+////B3EhByAIQf7///8HcSECQQAhBEEAIQEDQCAFQfAXaiADIAFraiwAACAFQfAdaiABQQF0ai4BAGwgBGogBUHwF2ogAyABQQFyIgZraiwAACAFQfAdaiAGQQF0ai4BAGxqIQQgAUECaiIBIAJHDQALCyAIQQFxBEAgBUHwF2ogAyAHa2osAAAgBUHwHWogB0EBdGouAQBsIARqIQQLIAUgA0EBdGogBEE5bEESdUGRXGwgBGoiAUGz5AFsQYCAgCBqQRt1QZHcA2wgAWo7AQAgCEEBaiEIQfkFIQQgA0EBaiIDQfkFRw0AC0EAIQcDQCAEQfgFayEBQfgFIAdrIgZBAXEhCUEAIQMgB0H3BUcEQCAGQf4HcSEIQQAhBgNAIAVB8BdqIAQgAWtqLAAAIAVB8B1qIAFBAXRqLgEAbCADaiAFQfAXaiAEIAFBAWoiAmtqLAAAIAVB8B1qIAJBAXRqLgEAbGohAyABQQJqIQEgBkECaiIGIAhHDQALCyAJBEAgBUHwF2ogBCABa2osAAAgBUHwHWogAUEBdGouAQBsIANqIQMLIAUgBEEBdGogA0E5bEESdUGRXGwgA2oiAUGz5AFsQYCAgCBqQRt1QZHcA2wgAWo7AQAgB0EBaiEHIARBAWoiBEHxC0cNAAtB8AshASAFLwHwCyEEA0AgBSABQQF0aiIDQfALayAEwSADLgEAIgRqIgZBOWxBEnVBkVxsIAZqIgZBs+QBbEGAgIAgakEbdUGR3ANsIAZqOwEAIANB8gtrIgMgBCADLgEAaiIDQTlsQRJ1QZFcbCADaiIDQbPkAWxBgICAIGpBG3VBkdwDbCADaiIEOwEAIAFB+QVLIQMgAUEBayEBIAMNAAsgBSEBQQAhAwNAIAAgAS8BADsAACADQfgFRkUEQCAAIAEvAQI7AAIgACABLwEEOwAEIAAgAS8BBjsABiADQQRqIQMgAEEIaiEAIAFBCGohAQwBCwsgBUHwKWokAAUgAUEBciIDIAVB8BdqaiACIANqLQAAIgNBAXEiBCAEQQF0IANxazoAACABQQJqIQEMAQsLBSABQQJqIgEgAS4BACIBQTlsQRJ1QZFcbCABaiIBQbPkAWxBgICAIGpBG3VBkdwDbCABajsBACAEQQJqIQQMAQsLBSADIAEvAAI7AQIgAyABLwAEOwEEIAMgAS8ABjsBBiAGQQRqIQYgAUEIaiEBIANBCGohAwwBCwsLpAQBDn8jAEGAAmsiAyQAAn8CQEHIABAqIgQEQCAEQgA3AEAgBEGQ6S/9AAQA/QsAMCAEQYDpL/0ABAD9CwAgIARB8Ogv/QAEAP0LABAgBEHg6C/9AAQA/QsAACAEIAEgAhCQCSACQf8AcSIFRQRAIANBgAE6AAAMAgsgBQRAIAMgASACaiAFayAF/AoAAAsgAyAFakGAAToAACAFQe8ATQ0BIANB/wFqIQcgA0H+AWohCCADQf0BaiEJIANB/AFqIQogA0H7AWohCyADQfoBaiEMIANB+QFqIQ0gA0H4AWohDiADQfcBaiEPQYACIRBB9gEMAgtB7wAQAQALIANB9wBqIQ8gA0H4AGohDiADQfkAaiENIANB+gBqIQwgA0H7AGohCyADQfwAaiEKIANB/QBqIQkgA0H+AGohCCADQf8AaiEHQYABIRBB9gALIQZBACEBIAYgBWsiBgRAIAMgBWpBAWpBACAG/AsACyAPQQA6AAAgDkEAOgAAIA1BADoAACAMQQA6AAAgC0EAOgAAIApBADoAACAJQQA6AAAgCCACQQV2OgAAIAcgAkEDdDoAACAEIAMgEBCQCQNAIAAgAWogASAEai0AADoAACAAIAFBAXIiAmogAiAEai0AADoAACAAIAFBAnIiAmogAiAEai0AADoAACAAIAFBA3IiAmogAiAEai0AADoAACABQQRqIgFBwABHDQALIAQQKyADQYACaiQAC4wCAQd/IwBBQGoiASQAIAFBwr4qNgIwIABB+YYqIAFBMGoQmwECQCAAQQEQyAEiAwRAIABBhgkQhgEiB0UNASADKAIIQf4CaiEEIAcoAgghBQNAIAIgBWogAiAEai0AADoAACAFIAJBAWoiBmogBCAGai0AADoAACAFIAJBAmoiBmogBCAGai0AADoAACACQQNqIgJBhglHDQALIAdBhgk2AgAgAxCaASABQcK+KjYCICAAQeCHKiABQSBqEJsBIAFBQGskAEEBDwsgAUHnsSk2AgQgAUHCvio2AgAgAEH8iCogARBsAAsgAxCaASABQd+2KTYCFCABQcK+KjYCECAAQfyIKiABQRBqEGwAC5YBAQJ/IwBBMGsiASQAIAFBiNcqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUHftik2AgQgAUGI1yo2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGGCUYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFBiNcqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQELlQEBAn8jAEEwayIBJAAgAUGt1io2AiAgAEH5hiogAUEgahCbASAAQQEQyAEiAkUEQCABQcDlKTYCBCABQa3WKjYCACAAQfyIKiABEGwACyAAKAIMQRFBASACKAIAQSBGGzoABCAAIAAoAgxBCGo2AgwgAhCaASABQa3WKjYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC5YBAQJ/IwBBMGsiASQAIAFB4dUqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUH9yCk2AgQgAUHh1So2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGPCEYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFB4dUqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQELkwgBCn8jAEHQIGsiASQAIAFBmMQrNgIwIABB+YYqIAFBMGoQmwECQCAAQQEQyAEiBUUEQEHftikhAgwBCyAFKAIAQYYJRwRAQbm1KSECDAELIABBAEECEKEBIABBIBCGASIGRQRAQcDlKSECDAELIAAgACgCDEEQa0Gv5ikQWSAAQY8IEIYBIgdFBEBB/cgpIQIMAQsgACAAKAIMQRBrQYmXKhBZIAYoAgghCCAHKAIIIQkgAUGgCGpBAXIgBSgCCCIKQYYJ/AoAACABQQQ6AKAIIAFBgAJqIAFBoAhqQYcJEP0EIAFBkAhqIAH9AASQAv0LBAAgASAB/QAEgAL9CwSACCABQeQXNgIgIAFB6QA7AIACQaX2MyABQYACaiABQSBqEAAhAwNAIAFBoAhqIAJqIAIgA2otAAA6AAAgAkEBciIEIAFBoAhqaiADIARqLQAAOgAAIAJBAnIiBCABQaAIamogAyAEai0AADoAACACQQNyIgQgAUGgCGpqIAMgBGotAAA6AAAgAkEEaiICQeQXRw0ACyADECtBACEDQQAhAgNAIAJB+AVGBEADQCABQaAIaiADQQJ0aiICIAIoAgBBfnE2AgAgAkEEaiIEIAQoAgBBfnE2AgAgA0GcAkYEQEGeAiEDA0AgAUGgCGogA0ECdGoiAiACKAIAQXxxQQFyNgIAIAJBBGoiBCAEKAIAQXxxQQFyNgIAIAJBCGoiAiACKAIAQXxxQQFyNgIAIANBA2oiAkH5BUZFBEAgAUGgCGogAkECdGoiAiACKAIAQXxxQQFyNgIAIANBBGohAwwBCwsgAUGgCGoQ+wRBACECA0AgAUGAAmogAmogAUGgCGogAkECdGotAABBA3FBAWs6AAAgAkH4BUZFBEAgAkEBciIDIAFBgAJqaiABQaAIaiADQQJ0ai0AAEEDcUEBazoAACACQQJyIgMgAUGAAmpqIAFBoAhqIANBAnRqLQAAQQNxQQFrOgAAIAJBA3IiAyABQYACamogAUGgCGogA0ECdGotAABBA3FBAWs6AAAgAkEEaiECDAELCyABQaAIaiAJIAFBQGsgAUGAAmogCiABQYAIahCDBSABQcEIaiAJQY8I/AoAACABQQE6AKAIIAFBkCBqIAFBoAhqQbAIEP0EIAggAUGgIGr9AAQA/QsAECAIIAH9AASQIP0LAAAgBkEgNgIAIAdBjwg2AgAgBRCaASABQZjEKzYCECAAQeCHKiABQRBqEJsBIAFB0CBqJABBAQ8FIAJBCGoiBCAEKAIAQX5xNgIAIAJBDGoiAiACKAIAQX5xNgIAIANBBGohAwwBCwALAAUgAkEIaiECDAELAAsACyAFEJoBIAEgAjYCBCABQZjEKzYCACAAQfyIKiABEGwAC7AoAgh/AX4jAEHwIGsiCCQAIAJBAWohBiADIQcDQCAGIActAAAgBy0AAUECdGogBy0AAkEEdGogBy0AA0EGdGpB1QBqOgAAIAYgBy0ABCAHLQAFQQJ0aiAHLQAGQQR0aiAHLQAHQQZ0akHVAGo6AAEgBkECaiEGIAdBCGohByAJQQJqIglBvgFHDQALIAYgBy0AAEEBajoAACAELQCBCSEHIAggBC0AgAkgBC0AggkgBC8AhAkiBq1Cy8HRAH5CH4inQbhzbCAGaiIGrULLwdEAfkIfiKdBf3NByAxsIAZqIgZBH3VByAxxIAZqQRB0IAQtAIMJQQh0cnIiBq1Cz+sNfkIfiKciCSAJQYK2f2wgBmoiBq1Cz+sNfkIfiKciCWogCUF/c0H+yQBsIAZqIgZBH3UiCWpBAWoiCq1C5eMLfkIfiKdBial/bCAKaiIKrULl4wt+Qh+Ip0F/c0H31gBsIApqIgpBH3VB99YAcSAKakEIdEGA/v8HcXIiCq1C+fwMfkIfiKciC0GLsX9sIApqIgqtQvn8DH5CH4inIgxBf3NB9c4AbCAKaiIKQR91Ig1B9c4AcSAKajsB/AsgCCALIAxqIA1qQQFqIgqtQtbl0AN+Qh+Ip0HmfWwgCmoiCq1C1uXQA35CH4inQX9zQZoCbCAKaiIKQR91QZoCcSAKaiIKOwH+CyAIIAQtAP4IIAQtAP8IQQh0IAcgCUH+yQBxIAZqQQh0QYD+/wdxciIHrUKsl9QAfkIfiKciBiAGQetzbCAHaiIHrUKsl9QAfkIfiKciBmogBkF/c0GVDGwgB2oiB0EfdSIGakEBaiIJrUKsl9QAfkIfiKdB63NsIAlqIgmtQqyX1AB+Qh+Ip0F/c0GVDGwgCWoiCUEfdUGVDHEgCWpBEHRyciIJrUL5/Ax+Qh+IpyILQYuxf2wgCWoiCa1C+fwMfkIfiKciDEF/c0H1zgBsIAlqIglBH3UiDUH1zgBxIAlqOwH4CyAIIAsgDGogDWpBAWoiCa1C+fwMfkIfiKdBi7F/bCAJaiIJrUL5/Ax+Qh+Ip0F/c0H1zgBsIAlqIglBH3VB9c4AcSAJajsB+gsgCCAELQD8CCAELQD9CEEIdCAGQZUMcSAHakEQdHJyIgetQvn8DH5CH4inIgZBi7F/bCAHaiIHrUL5/Ax+Qh+IpyIJQX9zQfXOAGwgB2oiB0EfdSILQfXOAHEgB2o7AfQLIAggBiAJaiALakEBaiIHrUL5/Ax+Qh+Ip0GLsX9sIAdqIgetQvn8DH5CH4inQX9zQfXOAGwgB2oiB0EfdUH1zgBxIAdqOwH2CyAIIAQtAPoIIAQtAPsIQQh0IApBEHRyciIHrULLwdEAfkIfiKciBkG4c2wgB2oiB61Cy8HRAH5CH4inIglBf3NByAxsIAdqIgdBH3UiCkHIDHEgB2o7AZQMIAggBiAJaiAKakEBaiIHrUL6tgt+Qh+Ip0G0pn9sIAdqIgetQvq2C35CH4inQX9zQczZAGwgB2oiB0EfdUHM2QBxIAdqOwGWDCAEQfoIaiEHQgQhDgNAIAhBgAxqIA6nIgZBAnRqIgkgByIMQQFrIgctAAAgCEH0C2ogBkEBdGovAQBBCHRyIgatQsvB0QB+Qh+IpyIEQbhzbCAGaiIGrULLwdEAfkIfiKciCkF/c0HIDGwgBmoiBkEfdSILQcgMcSAGajsBACAJIAQgCmogC2pBAWoiBq1Cy8HRAH5CH4inQbhzbCAGaiIGrULLwdEAfkIfiKdBf3NByAxsIAZqIgZBH3VByAxxIAZqOwECIA5CAFIhBiAOQgF9IQ4gBg0ACyAIIAxBAmsiBi0AACAILwGWDEEIdHIiB61CtOIMfkIfiKciCUHnr39sIAdqIgetQrTiDH5CH4inIgRBf3NBmdAAbCAHaiIHQR91IgpBmdAAcSAHajsBzAwgCCAEIAlqIApqQQFqIgetQsylygN+Qh+Ip0HifWwgB2oiB61CzKXKA35CH4inQX9zQZ4CbCAHaiIHQR91QZ4CcSAHajsBzgxCCiEOA0AgCEGgDGogDqciCUECdGoiBCAGIgdBAWstAABBCHQgCEGADGogCUEBdGovAQBBEHRyIAZBAmsiBi0AAHIiCa1CtOIMfkIfiKciCkHnr39sIAlqIgmtQrTiDH5CH4inIgtBf3NBmdAAbCAJaiIJQR91IgxBmdAAcSAJajsBACAEIAogC2ogDGpBAWoiCa1CtOIMfkIfiKdB569/bCAJaiIJrUK04gx+Qh+Ip0F/c0GZ0ABsIAlqIglBH3VBmdAAcSAJajsBAiAOQgBSIQkgDkIBfSEOIAkNAAsgCCAHQQNrLQAAQQh0IAgvAc4MQRB0ciAHQQRrIgctAAByIgatQvXt0AB+Qh+IpyIJQatzbCAGaiIGrUL17dAAfkIfiKciBEF/c0HVDGwgBmoiBkEfdSIKQdUMcSAGajsBrA0gCCAEIAlqIApqQQFqIgatQsmsC35CH4inQeKlf2wgBmoiBq1CyawLfkIfiKdBf3NBntoAbCAGaiIGQR91QZ7aAHEgBmo7Aa4NQhYhDgNAIAhB0AxqIA6nIgZBAnRqIgkgByIMQQFrIgctAAAgCEGgDGogBkEBdGovAQBBCHRyIgatQvXt0AB+Qh+IpyIEQatzbCAGaiIGrUL17dAAfkIfiKciCkF/c0HVDGwgBmoiBkEfdSILQdUMcSAGajsBACAJIAQgCmogC2pBAWoiBq1C9e3QAH5CH4inQatzbCAGaiIGrUL17dAAfkIfiKdBf3NB1QxsIAZqIgZBH3VB1QxxIAZqOwECIA5CAFIhBiAOQgF9IQ4gBg0ACyAIIAxBAmsiBy0AACAILwGuDUEIdHIiBq1CycPLAX5CH4inIglB/HpsIAZqIgatQsnDywF+Qh+IpyIEQX9zQYQFbCAGaiIGQR91IgpBhAVxIAZqOwHsDiAIIAQgCWogCmpBAWoiBq1Cr8YcfkIfiKdBkVxsIAZqIgatQq/GHH5CH4inQX9zQe8jbCAGaiIGQR91Qe8jcSAGajsB7g5CLiEOA0AgCEGwDWogDqciBkECdGoiCSAHQQFrIgctAAAgCEHQDGogBkEBdGovAQBBCHRyIgatQsnDywF+Qh+IpyIEQfx6bCAGaiIGrULJw8sBfkIfiKciCkF/c0GEBWwgBmoiBkEfdSILQYQFcSAGajsBACAJIAQgCmogC2pBAWoiBq1CycPLAX5CH4inQfx6bCAGaiIGrULJw8sBfkIfiKdBf3NBhAVsIAZqIgZBH3VBhAVxIAZqOwECIA5CAFIhBiAOQgF9IQ4gBg0ACyAIIAgvAe4OOwHsHULeACEOA0AgCEHwGmogDqciBkECdGoiCSAHQQFrIgctAAAgCEGwDWogBkEBdGovAQBBCHRyIgatQpjrwgJ+Qh+IpyIEQep8bCAGaiIGrUKY68ICfkIfiKciCkF/c0GWA2wgBmoiBkEfdSILQZYDcSAGajsBACAJIAQgCmogC2pBAWoiBq1CmOvCAn5CH4inQep8bCAGaiIGrUKY68ICfkIfiKdBf3NBlgNsIAZqIgZBH3VBlgNxIAZqOwECIA5CAFIhBiAOQgF9IQ4gBg0ACyAIIAgvAewdOwHoFEK9ASEOA0AgCEHwDmogDqciBkECdGoiCSAHQQFrIgctAAAgCEHwGmogBkEBdGovAQBBCHRyIgatQpOHlwN+Qh+IpyIEQb59bCAGaiIGrUKTh5cDfkIfiKciCkF/c0HCAmwgBmoiBkEfdSILQcICcSAGajsBACAJIAQgCmogC2pBAWoiBq1Ck4eXA35CH4inQb59bCAGaiIGrUKTh5cDfkIfiKdBf3NBwgJsIAZqIgZBH3VBwgJxIAZqOwECIA5CAFIhBiAOQgF9IQ4gBg0ACyAIIAgvAegUQfcRazsB8AtC+wIhDgNAIAggDqciBkECdGoiCSAHQQFrLQAAQQh0IAhB8A5qIAZBAXRqLwEAQRB0ciAHQQJrIgctAAByIgatQq/GHH5CH4inIgRBkVxsIAZqIgatQq/GHH5CH4inIgpBf3NB7yNsIAZqIgZBH3UiC0HvI3EgBmpB9xFrOwEAIAkgBCAKaiALakEBaiIGrUKvxhx+Qh+Ip0GRXGwgBmoiBq1Cr8YcfkIfiKdBf3NB7yNsIAZqIgZBH3VB7yNxIAZqQfcRazsBAiAOQgBSIQYgDkIBfSEOIAYNAAtBACEHIAghBgNAIAdB+AVGRQRAIAdBBGohByAGQQhqIQYMAQsLIAggCCADEPwEQQAhByAIIQYDQCAHQfgFRkUEQCAHQQRqIQcgBkEIaiEGDAELC0EAIQcDQCAHQQF0IgYgCEHwDmpqIAYgCGouAQBBq9UAbEGAgAFqQQ92QQNsOwEAIAdB+AVGRQRAIAZBAnIiBiAIQfAOamogBiAIai4BAEGr1QBsQYCAAWpBD3ZBA2w7AQAgB0ECaiEHDAELC0EAIQYgASEHA0AgByAIQfAOaiAGQQJ0aiIJLwECQfcRakH//wBxQavVAGxBD3ZB+wtsIAkvAQBB9xFqQf//AHFBq9UAbEEPdmoiCToAACAIQfAaaiAGQQF0aiAJQQh2OwEAIAdBAWohByAGQQFqIgZB/AJHDQALIAggCC8B4BpB9xFqQf//AHFBq9UAbEEPdjsB6CBBACEGA0AgByAIQfAaaiAGQQJ0aiIJLwECQcXHAGwgCS8BAGoiCTsAACAIQfAaaiAGQQF0aiAJQRB2OwEAIAdBAmohByAGQQFqIgZBvgFHDQALIAggCC8B6CA7AewdQQAhBgNAIAhB8BpqIAZBAnRqIgkvAQIhBCAHIAkvAQAiCToAACAIQfAaaiAGQQF0aiAJIARBgApsakEIdjsBACAGQd4ARkUEQCAIQfAaaiAGQQFyIglBAnRqIgQvAQIhCiAHIAQvAQAiBDoAASAIQfAaaiAJQQF0aiAEIApBgApsakEIdjsBACAGQQJqIQYgB0ECaiEHDAELCyAHQQFqIQcgCCAILwHsHTsBrhxBACEGQQAhCQNAIAhB8BpqIAlBAnRqIgQvAQIhCiAHIAQvAQAiBDoAACAHIAQgCkGAMmxqIgRBCHY6AAEgCEHwGmogCUEBdGogBEEQdjsBACAHQQJqIQcgCUEBaiIJQTBHDQALA0AgByIJIAhB8BpqIAZBAnRqIgcvAQJB8QRsIAcvAQBqIgc6AAAgCEHwGmogBkEBdGogB0EIdjsBACAJIAhB8BpqIAZBAXIiB0ECdGoiBC8BAkHxBGwgBC8BAGoiBDoAASAIQfAaaiAHQQF0aiAEQQh2OwEAIAlBAmohByAGQQJqIgZBGEcNAAsgCSAILwHwGiAILwHyGkH2C2xqIgc6AAIgCCAHQQh2OwHwGiAJIAgvAfQaIAgvAfYaQfYLbGoiBzoAAyAIIAdBCHY7AfIaIAkgCC8B+BogCC8B+hpB9gtsaiIHOgAEIAggB0EIdjsB9BogCSAILwH8GiAILwH+GkH2C2xqIgc6AAUgCCAHQQh2OwH2GiAJIAgvAYAbIAgvAYIbQfYLbGoiBzoABiAIIAdBCHY7AfgaIAkgCC8BhBsgCC8BhhtB9gtsaiIHOgAHIAggB0EIdjsB+hogCSAILwGIGyAILwGKG0H2C2xqIgc6AAggCCAHQQh2OwH8GiAJIAgvAYwbIAgvAY4bQfYLbGoiBzoACSAIIAdBCHY7Af4aIAkgCC8BkBsgCC8BkhtB9gtsaiIHOgAKIAggB0EIdjsBgBsgCSAILwGUGyAILwGWG0H2C2xqIgc6AAsgCCAHQQh2OwGCGyAJIAgvAZgbIAgvAZobQfYLbGoiBzoADCAIIAdBCHY7AYQbIAkgCC8BnBsgCC8BnhtB9gtsaiIHOgANIAggB0EIdjsBhhsgCSAILwHwGiAILwHyGkGJxwBsaiIHOwAOIAkgCC8B9BogCC8B9hpBiccAbGoiBjsAECAJIAgvAfgaIAgvAfoaQYnHAGxqIgQ7ABIgCSAILwH8GiAILwH+GkGJxwBsaiIKOwAUIAkgCC8BgBsgCC8BghtBiccAbGoiCzsAFiAILwGEGyEMIAgvAYYbIQMgCSAKQRB2Qe8JbCAEQRB2aiIEQQh2QdgwbCAGQRB2Qe8JbCAHQRB2aiIGQQh2aiIHOgAdIAkgBDoAGyAJIAY6ABogCSAHQQh2OgAeIAkgDCADQYnHAGxqIgY6ABggCSAGQQh2OgAZIAkgBkEQdkHvCWwgC0EQdmoiBjoAHCAJIAZBCHZB0QRsIAdBEHZqIgc6AB8gCSAHQRB2OgAhIAkgB0EIdjoAICACQQM6AAAgCEHwDmogAkHAARD9BCAAIAhBgA9qIgf9AAQA/QsAESAAIAj9AATwDv0LAAEgACAFLQAAOgAhIAAgBS0AAToAIiAAIAUtAAI6ACMgACAFLQADOgAkIAAgBS0ABDoAJSAAIAUtAAU6ACYgACAFLQAGOgAnIAAgBS0ABzoAKCAAIAUtAAg6ACkgACAFLQAJOgAqIAAgBS0ACjoAKyAAIAUtAAs6ACwgACAFLQAMOgAtIAAgBS0ADToALiAAIAUtAA46AC8gACAFLQAPOgAwIAAgBS0AEDoAMSAAIAUtABE6ADIgACAFLQASOgAzIAAgBS0AEzoANCAAIAUtABQ6ADUgACAFLQAVOgA2IAAgBS0AFjoANyAAIAUtABc6ADggACAFLQAYOgA5IAAgBS0AGToAOiAAIAUtABo6ADsgACAFLQAbOgA8IAAgBS0AHDoAPSAAIAUtAB06AD4gACAFLQAeOgA/IAUtAB8hBiAAQQI6AAAgACAGOgBAIAhB8A5qIABBwQAQ/QQgASAH/QAEAP0LAP8HIAEgCP0ABPAO/QsA7wcgCEHwIGokAAutLQIPfwF+IwBBwDZrIgQkACAEQYDIKzYCICAAQfmGKiAEQSBqEJsBQdHIKSEBIABBARDIASELIABBAhDIASEMAkAgC0UNACAMRQ0AIAsoAgBB4w1HBEBBh7EpIQEMAQsgDCgCAEGPCEcEQEHnsCkhAQwBCyAAQSAQhgEiDUUEQEHA5SkhAQwBCyALKAIIIQogDSgCCCEOIAwoAggiCS0A6gchAiAJLQDrByEBIAQgCS0A6QcgCS0A7AcgCS8A7QciA61C/NslfkIfiKdB7WRsIANqIgOtQvzbJX5CH4inQX9zQZMbbCADaiIDQR91QZMbcSADakEIdEGA/v8HcXIiA61CjITdAX5CH4inIgUgBUGve2wgA2oiA61CjITdAX5CH4inIgVqIAVBf3NB0QRsIANqIgNBH3UiBWpBAWoiBq1C57DXAH5CH4inQaR0bCAGaiIGrULnsNcAfkIfiKdBf3NB3AtsIAZqIgZBH3VB3AtxIAZqQQh0QYD+/wdxciIGrULP4+cAfkIfiKciB0GRdmwgBmoiBq1Cz+PnAH5CH4inIghBf3NB7wlsIAZqIgZBH3UiD0HvCXEgBmo7AbweIAQgByAIaiAPakEBaiIGrUKalK8DfkIfiKdB0H1sIAZqIgatQpqUrwN+Qh+Ip0F/c0GwAmwgBmoiBkEfdUGwAnEgBmoiBjsBvh4gBCAJLQDoByACIAVB0QRxIANqQRB0IAFBCHRyciICrUKNhBV+Qh+IpyIBIAFBqE9sIAJqIgKtQo2EFX5CH4inIgFqIAFBf3NB2DBsIAJqIgJBH3UiAWpBAWoiA61CjYQVfkIfiKdBqE9sIANqIgOtQo2EFX5CH4inQX9zQdgwbCADaiIDQR91QdgwcSADakEIdEGA/v8HcXIiA61Cz+PnAH5CH4inIgVBkXZsIANqIgOtQs/j5wB+Qh+IpyIHQX9zQe8JbCADaiIDQR91IghB7wlxIANqOwG4HiAEIAUgB2ogCGpBAWoiA61Cz+PnAH5CH4inQZF2bCADaiIDrULP4+cAfkIfiKdBf3NB7wlsIANqIgNBH3VB7wlxIANqOwG6HiAEIAktAOcHIAFB2DBxIAJqQQh0QYD+/wdxciICrULP4+cAfkIfiKciAUGRdmwgAmoiAq1Cz+PnAH5CH4inIgNBf3NB7wlsIAJqIgJBH3UiBUHvCXEgAmo7AbQeIAQgASADaiAFakEBaiICrULP4+cAfkIfiKdBkXZsIAJqIgKtQs/j5wB+Qh+Ip0F/c0HvCWwgAmoiAkEfdUHvCXEgAmo7AbYeIAQgCS0A5QcgCS0A5gdBCHQgBkEQdHJyIgKtQqG0Dn5CH4inIgFB97h/bCACaiICrUKhtA5+Qh+IpyIDQX9zQYnHAGwgAmoiAkEfdSIFQYnHAHEgAmo7AUQgBCABIANqIAVqQQFqIgKtQurzO35CH4inQfRubCACaiICrULq8zt+Qh+Ip0F/c0GMEWwgAmoiAkEfdUGMEXEgAmo7AUYgCUHlB2ohAkIEIRADQCAEQTBqIBCnIgNBAnRqIgUgAiIBQQFrLQAAQQh0IARBtB5qIANBAXRqLwEAQRB0ciABQQJrIgItAAByIgOtQqG0Dn5CH4inIgZB97h/bCADaiIDrUKhtA5+Qh+IpyIHQX9zQYnHAGwgA2oiA0EfdSIIQYnHAHEgA2o7AQAgBSAGIAdqIAhqQQFqIgOtQqG0Dn5CH4inQfe4f2wgA2oiA61CobQOfkIfiKdBf3NBiccAbCADaiIDQR91QYnHAHEgA2o7AQIgEEIAUiEDIBBCAX0hECADDQALIAQgAUEDayICLQAAIAQvAUZBCHRyIgGtQp/y1QB+Qh+IpyIDQYp0bCABaiIBrUKf8tUAfkIfiKciBUF/c0H2C2wgAWoiAUEfdSIGQfYLcSABajsB3AYgBCADIAVqIAZqQQFqIgGtQr6S5QJ+Qh+Ip0GRfWwgAWoiAa1CvpLlAn5CH4inQX9zQe8CbCABaiIBQR91Qe8CcSABajsB3gZCCiEQA0AgBEGwBmogEKciAUECdGoiAyACIghBAWsiAi0AACAEQTBqIAFBAXRqLwEAQQh0ciIBrUKf8tUAfkIfiKciBUGKdGwgAWoiAa1Cn/LVAH5CH4inIgZBf3NB9gtsIAFqIgFBH3UiB0H2C3EgAWo7AQAgAyAFIAZqIAdqQQFqIgGtQp/y1QB+Qh+Ip0GKdGwgAWoiAa1Cn/LVAH5CH4inQX9zQfYLbCABaiIBQR91QfYLcSABajsBAiAQQgBSIQEgEEIBfSEQIAENAAsgBCAIQQJrIgItAAAgBC8B3gZBCHRyIgGtQsXb0QF+Qh+IpyIDQY97bCABaiIBrULF29EBfkIfiKciBUF/c0HxBGwgAWoiAUEfdSIGQfEEcSABajsBjBkgBCADIAVqIAZqQQFqIgGtQo3o6QZ+Qh+Ip0HqfmwgAWoiAa1CjejpBn5CH4inQX9zQZYBbCABaiIBQR91QZYBcSABajsBjhlCFiEQA0AgBEGwGGogEKciAUECdGoiAyACIghBAWsiAi0AACAEQbAGaiABQQF0ai8BAEEIdHIiAa1CxdvRAX5CH4inIgVBj3tsIAFqIgGtQsXb0QF+Qh+IpyIGQX9zQfEEbCABaiIBQR91IgdB8QRxIAFqOwEAIAMgBSAGaiAHakEBaiIBrULF29EBfkIfiKdBj3tsIAFqIgGtQsXb0QF+Qh+Ip0F/c0HxBGwgAWoiAUEfdUHxBHEgAWo7AQIgEEIAUiEBIBBCAX0hECABDQALIAQgCEEDayICLQAAIAhBAmstAABBCHQgBC8BjhlBEHRyciIBrUK4vRR+Qh+IpyIDQYBObCABaiIBrUK4vRR+Qh+IpyIFQX9zQYAybCABaiIBQR91IgZBgDJxIAFqOwH8KyAEIAMgBWogBmpBAWoiAa1Cq87VAH5CH4inQYV0bCABaiIBrUKrztUAfkIfiKdBf3NB+wtsIAFqIgFBH3VB+wtxIAFqOwH+K0IuIRADQCAEQcAqaiAQpyIBQQJ0aiIDIAJBAWstAABBCHQgBEGwGGogAUEBdGovAQBBEHRyIAJBAmsiAi0AAHIiAa1CuL0UfkIfiKciBUGATmwgAWoiAa1CuL0UfkIfiKciBkF/c0GAMmwgAWoiAUEfdSIHQYAycSABajsBACADIAUgBmogB2pBAWoiAa1CuL0UfkIfiKdBgE5sIAFqIgGtQri9FH5CH4inQX9zQYAybCABaiIBQR91QYAycSABajsBAiAQQgBSIQEgEEIBfSEQIAENAAsgBCAELwH+KzsBvDNC3gAhEANAIARBwDBqIBCnIgFBAnRqIgMgAkEBayICLQAAIARBwCpqIAFBAXRqLwEAQQh0ciIBrUKZs+YAfkIfiKciBUGAdmwgAWoiAa1CmbPmAH5CH4inIgZBf3NBgApsIAFqIgFBH3UiB0GACnEgAWo7AQAgAyAFIAZqIAdqQQFqIgGtQpmz5gB+Qh+Ip0GAdmwgAWoiAa1CmbPmAH5CH4inQX9zQYAKbCABaiIBQR91QYAKcSABajsBAiAQQgBSIQEgEEIBfSEQIAENAAsgBCAELwG8MzsBuCRCvQEhEANAIARBwB5qIBCnIgFBAnRqIgMgAkEBay0AAEEIdCAEQcAwaiABQQF0ai8BAEEQdHIgAkECayICLQAAciIBrUKWqA5+Qh+IpyIFQbu4f2wgAWoiAa1ClqgOfkIfiKciBkF/c0HFxwBsIAFqIgFBH3UiB0HFxwBxIAFqOwEAIAMgBSAGaiAHakEBaiIBrUKWqA5+Qh+Ip0G7uH9sIAFqIgGtQpaoDn5CH4inQX9zQcXHAGwgAWoiAUEfdUHFxwBxIAFqOwECIBBCAFIhASAQQgF9IRAgAQ0ACyAEIAQvAbgkQQNsQfcRazsBoBhC+wIhEANAIARBsAxqIBCnIgFBAnRqIgMgAkEBayICLQAAIARBwB5qIAFBAXRqLwEAQQh0ciIBrUKrztUAfkIfiKciBUGFdGwgAWoiAa1Cq87VAH5CH4inIgZBf3NB+wtsIAFqIgFBH3UiB0H7C3EgAWpBA2xB9xFrOwEAIAMgBSAGaiAHakEBaiIBrUKrztUAfkIfiKdBhXRsIAFqIgGtQqvO1QB+Qh+Ip0F/c0H7C2wgAWoiAUEfdUH7C3EgAWpBA2xB9xFrOwECIBBCAFIhASAQQgF9IRAgAQ0ACyAEQcAwaiECQQAhBSAKIQMDQCACIAMtAAAiAUEGdkEBazoAAyACIAFBA3FBAWs6AAAgAiABQQR2QQNxQQFrOgACIAIgAUECdkEDcUEBazoAASACQQRqIQIgA0EBaiEDIAVBAWoiBUG+AUcNAAsgAiADLQAAQQNxQQFrOgAAQQAhAiAEQbAMaiEBA0AgAkH4BUZFBEAgAkEEaiECIAFBCGohAQwBCwsgBEGwDGogBEGwDGogBEHAMGoQ/ARBACECIARBsAxqIgMhBUEAIQEDfyABQfgFRgR/A0AgAkH4BUZFBEAgAkEEaiECIANBCGohAwwBCwtBACEDIARBwB5qIQIgBEGwDGohAUEAIQUDfyACIAEvAAA7AQAgBUH4BUYEfwN/IARBwB5qIANBAXRqIgIgAi8BAEEDbEH4EWsiAcFBD3ZB7yNxIAFqIgEgAcFBD3ZB7yNxakH3EWs7AQAgA0H4BUYEfyAEQcAeaiECQQAhAyAEQbAMaiEBA0AgASACLwEAOwAAIANB+AVGRQRAIAEgAi8BAjsAAiABIAIvAQQ7AAQgASACLwEGOwAGIANBBGohAyABQQhqIQEgAkEIaiECDAELC0EAIQIgBEGwDGohAQNAIAJB+AVGRQRAIAJBBGohAiABQQhqIQEMAQsLQQAhAgNAIARBsAZqIAJqIARBsAxqIAJBAXRqLgEAIgFBq9UAbEGAgAFqQQ92Qf0BbCABajoAACACQfgFRkUEQCACQQFyIgEgBEGwBmpqIARBsAxqIAFBAXRqLgEAIgFBq9UAbEGAgAFqQQ92Qf0BbCABajoAACACQQJqIQIMAQsLIApBvwFqIQMgBEEwaiECQQAhBQNAIAIgAy0AACIBQQZ2QQFrOgADIAIgAUEDcUEBazoAACACIAFBBHZBA3FBAWs6AAIgAiABQQJ2QQNxQQFrOgABIAJBBGohAiADQQFqIQMgBUEBaiIFQb4BRw0ACyACIAMtAABBA3FBAWs6AABBACECQQAhAQN/IARBwDBqIAFqIARBsAZqIAFqLQAAIgNBAXEiBSAFQQF0IANxazoAACABQfgFRgR/QQEhBgN/IARBwCpqIAJqIARBMGogAmotAAAiAUEBcSIDIANBAXQgAXFrOgAAIAJB+AVGBH9BACEBA0ACQCABRQRAQQAhA0EAIQcMAQsgBkH+////B3EhByAGQf7///8HcSEFQQAhA0EAIQIDQCADIARBwCpqIAEgAmtqLQAAIARBwDBqIAJqLQAAbMBqIARBwCpqIAEgAkEBciIDa2otAAAgBEHAMGogA2otAABswGohAyACQQJqIgIgBUcNAAsLIAZBAXEEQCADIARBwCpqIAEgB2tqLQAAIARBwDBqIAdqLQAAbMBqIQMLIARBwB5qIAFqIAPBQavVAGxBgIABakEPdkH9AWwgA2o6AAAgBkEBaiEGQfkFIQMgAUEBaiIBQfkFRw0AC0EAIQcDQCADQfgFayECQfgFIAdrIgVBAXEhCEEAIQEgB0H3BUcEQCAFQf4HcSEGQQAhBQNAIAEgBEHAKmogAyACa2otAAAgBEHAMGogAmotAABswGogBEHAKmogAyACQQFqIgFrai0AACAEQcAwaiABai0AAGzAaiEBIAJBAmohAiAFQQJqIgUgBkcNAAsLIAgEQCABIARBwCpqIAMgAmtqLQAAIARBwDBqIAJqLQAAbMBqIQELIARBwB5qIANqIAHBQavVAGxBgIABakEPdkH9AWwgAWo6AAAgB0EBaiEHIANBAWoiA0HxC0cNAAtB8AshAiAELQC4JCEDA0AgBEHAHmogAmoiAUH4BWsgA8AgASwAACIDaiIFQavVAGxBgIABakEPdkH9AWwgBWo6AAAgAUH5BWsiASADIAEsAABqIgFBq9UAbEGAgAFqQQ92Qf0BbCABaiIDOgAAIAJB+QVLIQEgAkEBayECIAENAAsgBEGwGGogBEHAHmpB+QX8CgAAIARBsBhqQQNyIQMgBEGwGGpBAnIhBSAEQbAYakEBciEGQQAhAkEAIQEDQCABIARBsBhqIAJqLQAAQQFxaiEBIAJB+AVGRQRAIAEgAiAGai0AAEEBcWogAiAFai0AAEEBcWogAiADai0AAEEBcWohASACQQRqIQIMAQsLIARBsBhqQQNyIQcgBEGwGGpBAnIhCCAEQbAYakEBciEFQQAhAiABQf//A3EiBkGeAkYhAQN/IARBsBhqIAJqIgMgAy0AAEEBIAEbOgAAIAIgBWoiAyADLQAAQQEgARs6AAAgAkGcAkYEfyAEQbAYakECciEFIARBsBhqQQFyIQdBngIhAgNAIARBsBhqIAJqIgEgAS0AAEEAIAZBngJGIgEbOgAAIAIgB2oiAyADLQAAQQAgARs6AAAgAiAFaiIDIAMtAABBACABGzoAACACQQNqIgNB+QVGRQRAIARBsBhqIANqIgMgAy0AAEEAIAEbOgAAIAJBBGohAgwBCwsgBEHAHmogBEGwDGogBEHAMGogBEGwGGogCkH+AmogCkHDDWoQgwVBACECQQAhAQNAIAEgBEGwDGogAmotAAAgAiAJai0AAHNyIQEgAkGOCEZFBEAgASACQQFyIgMgBEGwDGpqLQAAIAMgCWotAABzciEBIAJBAmohAgwBCwsgCkGEDGohAyABQQFrQQh2QQFxIgdBAWshAUEAIQIDQCACQQFyIgYgBEHAMGpqIgUgBS0AACIFIAIgA2otAABzIAFxIAVzOgAAIAJBvgFGRQRAIAJBAmoiAiAEQcAwamoiBSAFLQAAIgUgAyAGai0AAHMgAXEgBXM6AAAMAQsLIARBwCpqIARBwDBqQcABEP0EIARB0R5qIARB0CpqIgL9AAQA/QsAACAEIAT9AATAKv0LAMEeIARB4R5qIAlBjwj8CgAAIAQgBzoAwB4gBEHAKmogBEHAHmpBsAgQ/QQgDiAC/QAEAP0LABAgDiAE/QAEwCr9CwAAIA1BIDYCAEEAIQFBAQUgAiAIaiIDIAMtAABBASABGzoAACACIAdqIgMgAy0AAEEBIAEbOgAAIAJBBGohAgwBCwsFIAJBAXIiASAEQcAqamogBEEwaiABai0AACIBQQFxIgMgA0EBdCABcWs6AAAgAkECaiECDAELCwUgAUEBciIDIARBwDBqaiAEQbAGaiADai0AACIDQQFxIgUgBUEBdCADcWs6AAAgAUECaiEBDAELCwUgAkECaiICIAIvAQBBA2xB+BFrIgLBQQ92Qe8jcSACaiICIALBQQ92Qe8jcWpB9xFrOwEAIANBAmohAwwBCwsFIAIgAS8AAjsBAiACIAEvAAQ7AQQgAiABLwAGOwEGIAVBBGohBSABQQhqIQEgAkEIaiECDAELCwUgAUEEaiEBIAVBCGohBQwBCwshAgsgCxCaASAMEJoBIAIEQCAEQYDIKzYCACAAQeCHKiAEEJsBIARBwDZqJABBAQ8LIAQgATYCFCAEQYDIKzYCECAAQfyIKiAEQRBqEGwAC4wbARN/IwBBkKICayIBJAAgAUHckSo2AiAgAEH5hiogAUEgahCbASAAQQBBAhChAQJAIABBgBQQhgEiC0UEQEHysykhAgwBCyAAIAAoAgxBEGtB3/8qEFkgAEGgChCGASIMRQRAQd+2KSECDAELIAAgACgCDEEQa0HvxisQWQJAIABBAUHB4ikQ3AEiAgRAIAIoAgBBIEcEQEGl+CohAgwDCyABIAIoAggiAi0AADoAMCABIAItAAE6ADEgASACLQACOgAyIAEgAi0AAzoAMyABIAItAAQ6ADQgASACLQAFOgA1IAEgAi0ABjoANiABIAItAAc6ADcgASACLQAIOgA4IAEgAi0ACToAOSABIAItAAo6ADogASACLQALOgA7IAEgAi0ADDoAPCABIAItAA06AD0gASACLQAOOgA+IAEgAi0ADzoAPyABIAItABA6AEAgASACLQAROgBBIAEgAi0AEjoAQiABIAItABM6AEMgASACLQAUOgBEIAEgAi0AFToARSABIAItABY6AEYgASACLQAXOgBHIAEgAi0AGDoASCABIAItABk6AEkgASACLQAaOgBKIAEgAi0AGzoASyABIAItABw6AEwgASACLQAdOgBNIAEgAi0AHjoATiABIAItAB86AE8MAQtBACECQZCWNCgCACEFA0AgAUEwaiACaiAFKAIkEGk6AAAgAkEBaiICQSBHDQALCyALKAIIIQMgDCgCCCENIAFBoKECaiABQUBr/QAEAP0LBAAgASAB/QAEMP0LBJChAiABQYQIOwGwoQIgAUGQoQJqQYABIAFBkKECakEiELMEIAFB0KABaiABQZChAmoQtARBACECIAFB0IABaiABQbChAmoiBUEAELUEIAFB0IgBaiIOIAVBARC1BCABQdCQAWoiDyAFQQIQtQQgAUHQmAFqIhAgBUEDELUEIAFB0MAAaiAFQQQQtQQgAUHQyABqIhEgBUEFELUEIAFB0NAAaiISIAVBBhC1BCABQdDYAGoiEyAFQQcQtQQgAUHQ4ABqIAFB0IABakGAIPwKAAAgAUHQ4ABqELYEIAFB0CBqIAFB0KABaiABQdDgAGoQtwQDQCABQdAgaiACQQJ0aiIFIAUoAgAiCUGAgIACakEXdUH/v4B8bCAJajYCACAFQQRqIgUgBSgCACIFQYCAgAJqQRd1Qf+/gHxsIAVqNgIAIAJBAmoiAkGAAkcNAAsgAUHQKGohBUEAIQIDQCAFIAJBAnRqIgkgCSgCACIIQYCAgAJqQRd1Qf+/gHxsIAhqNgIAIAlBBGoiCSAJKAIAIglBgICAAmpBF3VB/7+AfGwgCWo2AgAgAkECaiICQYACRw0ACyABQdAwaiEJQQAhAgNAIAkgAkECdGoiCCAIKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgCEEEaiIIIAgoAgAiCEGAgIACakEXdUH/v4B8bCAIajYCACACQQJqIgJBgAJHDQALIAFB0DhqIQhBACECA0AgCCACQQJ0aiIGIAYoAgAiBEGAgIACakEXdUH/v4B8bCAEajYCACAGQQRqIgYgBigCACIGQYCAgAJqQRd1Qf+/gHxsIAZqNgIAIAJBAmoiAkGAAkcNAAsgAUHQIGoQuAQgAUHQIGogAUHQIGogAUHQwABqELkEQQAhBkEAIQQDQCABQdAgaiAEQQJ0aiICIAIoAgAiB0EfdUGBwP8DcSAHajYCACACQQRqIgcgBygCACIHQR91QYHA/wNxIAdqNgIAIAJBCGoiByAHKAIAIgdBH3VBgcD/A3EgB2o2AgAgAkEMaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACAEQQRqIgRBgAJHDQALA0AgBSAGQQJ0aiICIAIoAgAiBEEfdUGBwP8DcSAEajYCACACQQRqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIAJBCGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgAkEMaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACAGQQRqIgZBgAJHDQALQQAhBgNAIAkgBkECdGoiAiACKAIAIgRBH3VBgcD/A3EgBGo2AgAgAkEEaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCACACQQhqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIAJBDGoiAiACKAIAIgJBH3VBgcD/A3EgAmo2AgAgBkEEaiIGQYACRw0AC0EAIQYDQCAIIAZBAnRqIgIgAigCACIEQR91QYHA/wNxIARqNgIAIAJBBGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgAkEIaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCACACQQxqIgIgAigCACICQR91QYHA/wNxIAJqNgIAIAZBBGoiBkGAAkcNAAtBACECA0AgAkECdCIGIAFB0CBqaiIEIAQoAgAiBEH/H2oiB0ENdTYCACABQdAAaiAGaiAEIAdBgEBxazYCACAGQQRyIgYgAUHQIGpqIgQgBCgCACIEQf8faiIHQQ11NgIAIAFB0ABqIAZqIAQgB0GAQHFrNgIAIAJBAmoiAkGAAkcNAAsgAUHQCGohBEEAIQIDQCAEIAJBAnQiBmogBSAGaiIHKAIAIgogCkH/H2oiCkGAQHFrNgIAIAcgCkENdTYCACAEIAZBBHIiBmogBSAGaiIGKAIAIgcgB0H/H2oiB0GAQHFrNgIAIAYgB0ENdTYCACACQQJqIgJBgAJHDQALIAFB0BBqIQZBACECA0AgBiACQQJ0IgVqIAUgCWoiBygCACIKIApB/x9qIgpBgEBxazYCACAHIApBDXU2AgAgBiAFQQRyIgVqIAUgCWoiBSgCACIHIAdB/x9qIgdBgEBxazYCACAFIAdBDXU2AgAgAkECaiICQYACRw0ACyABQdAYaiEJQQAhAgNAIAkgAkECdCIFaiAFIAhqIgcoAgAiCiAKQf8faiIKQYBAcWs2AgAgByAKQQ11NgIAIAkgBUEEciIFaiAFIAhqIgUoAgAiByAHQf8faiIHQYBAcWs2AgAgBSAHQQ11NgIAIAJBAmoiAkGAAkcNAAsgDSABQZChAmogAUHQIGoQugQgAUHQoAJqQcAAIA1BoAoQswQgAyABLQCQoQI6AAAgAyABLQCRoQI6AAEgAyABLQCSoQI6AAIgAyABLQCToQI6AAMgAyABLQCUoQI6AAQgAyABLQCVoQI6AAUgAyABLQCWoQI6AAYgAyABLQCXoQI6AAcgAyABLQCYoQI6AAggAyABLQCZoQI6AAkgAyABLQCaoQI6AAogAyABLQCboQI6AAsgAyABLQCcoQI6AAwgAyABLQCdoQI6AA0gAyABLQCeoQI6AA4gAyABLQCfoQI6AA8gAyABLQCgoQI6ABAgAyABLQChoQI6ABEgAyABLQCioQI6ABIgAyABLQCjoQI6ABMgAyABLQCkoQI6ABQgAyABLQCloQI6ABUgAyABLQCmoQI6ABYgAyABLQCnoQI6ABcgAyABLQCooQI6ABggAyABLQCpoQI6ABkgAyABLQCqoQI6ABogAyABLQCroQI6ABsgAyABLQCsoQI6ABwgAyABLQCtoQI6AB0gAyABLQCuoQI6AB4gAyABLQCvoQI6AB8gAyABLQDwoQI6ACAgAyABLQDxoQI6ACEgAyABLQDyoQI6ACIgAyABLQDzoQI6ACMgAyABLQD0oQI6ACQgAyABLQD1oQI6ACUgAyABLQD2oQI6ACYgAyABLQD3oQI6ACcgAyABLQD4oQI6ACggAyABLQD5oQI6ACkgAyABLQD6oQI6ACogAyABLQD7oQI6ACsgAyABLQD8oQI6ACwgAyABLQD9oQI6AC0gAyABLQD+oQI6AC4gAyABLQD/oQI6AC8gAyABLQCAogI6ADAgAyABLQCBogI6ADEgAyABLQCCogI6ADIgAyABLQCDogI6ADMgAyABLQCEogI6ADQgAyABLQCFogI6ADUgAyABLQCGogI6ADYgAyABLQCHogI6ADcgAyABLQCIogI6ADggAyABLQCJogI6ADkgAyABLQCKogI6ADogAyABLQCLogI6ADsgAyABLQCMogI6ADwgAyABLQCNogI6AD0gAyABLQCOogI6AD4gAyABLQCPogI6AD8gA0FAayEFQQAhAgNAIAIgBWogAUHQoAJqIAJqLQAAOgAAIAUgAkEBciIIaiABQdCgAmogCGotAAA6AAAgBSACQQJyIghqIAFB0KACaiAIai0AADoAACAFIAJBA3IiCGogAUHQoAJqIAhqLQAAOgAAIAJBBGoiAkHAAEcNAAsgA0GAAWogAUHQgAFqELsEIANB4AFqIA4QuwQgA0HAAmogDxC7BCADQaADaiAQELsEIANBgARqIAFB0MAAahC7BCADQeAEaiARELsEIANBwAVqIBIQuwQgA0GgBmogExC7BCADQYAHaiABQdAAahC8BCADQaAKaiAEELwEIANBwA1qIAYQvAQgA0HgEGogCRC8BCAMQaAKNgIAIAtBgBQ2AgAgAUHckSo2AhAgAEHghyogAUEQahCbASABQZCiAmokAEEBDwsgASACNgIEIAFB3JEqNgIAIABB/IgqIAEQbAALjAQCCX8BeyMAQdAAayICJAAgAkHehis2AiAgAEH5hiogAkEgahCbAQJAIABBARDIASIFRQRAQaOxKSEDDAELIABBAhDIASIERQRAQY6fKyEDQQAhBAwBCyAFKAIAQYAURwRAQfffKiEDDAELIABB9BIQhgEiBkUEQEHAhyshAwwBCwJAQZCWNCgCACIHKALwAgRAIAdBKGohCQNAIAggAyAJaiIBLAAAaiABLAABaiABLAACaiABLAADaiEIIANBBGoiA0HAAEcNAAsgCEUEQCACQUBr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACIAr9CwQwDAILQQAhAQNAIAJBMGogAWogBygCJBBpOgAAIAFBAWoiAUEgRw0ACwwBCwNAIAJBMGogAWogBygCJBBpOgAAIAFBAWoiAUEgRw0ACwsCfyAAQQNBweIpENwBIgEEQCABKAIAIgNB/wFKBEBBvvcqIQNBACEBDAMLIAYoAgggBiAEKAIIIAQoAgAgASgCCCADIAUoAgggAkEwahCHBUEADAELIAYoAgggBiAEKAIIIAQoAgBBAEEAIAUoAgggAkEwahCHBUEACyEDQQEhAQsgBBCaASAFEJoBIAFFBEAgAiADNgIUIAJB3oYrNgIQIABB/IgqIAJBEGoQbAALIAJB3oYrNgIAIABB4IcqIAIQmwEgAkHQAGokAEEBC4g9Ahx/A34jAEHgjwNrIggkACAIQYCIA2ogCEGgiANqIgwgCEHgiANqIgsgCEGAiAFqIAhBgOgBaiAIQYDoAGogBhCLBSAIIAU6AKGJAyAIQQA6AKCJA0HQARAqIgkEQCAJQQBB0AH8CwAgCUGIASAMQcAAEIMJIAlBiAEgCEGgiQNqIhxBAhCDCSAJQYgBIAQgBRCDCSAJQYgBIAIgAxCDCSAJIAkpA8gBIiSnQXhxaiIFIAUpAwBCHyAkQgOGhoU3AwAgCUIANwPIASAJIAkpA4ABQoCAgICAgICAgH+FNwOAASAcQcAAIAlBiAEQhAkgCEGQiQNqIAf9AAAQ/QsEACAIIAf9AAAA/QsEgIkDIAhB4IkDaiIRQcAAIAtBgAEQswQgCEGAiAJqIAhBgIgDahC0BCAIQYDoAWoQtgQgCEGA6ABqELYEIAhBgIgBahC2BCAIQYTAAWohICAIQYS4AWohISAIQYSwAWohIiAIQYSoAWohIyAIQYAgaiESIAhBgBhqIRMgCEGAEGohFCAIQYCAAmohHSAIQYDAAWohDCAIQYD4AWohHiAIQYC4AWohCyAIQYDwAWohHyAIQYCwAWohDSAIQYBAayEZIAhBgDhqIRogCEGAMGohGyAIQYDgAGohFSAIQYDYAGohFiAIQYDQAGohFyAIQYDgAWohDiAIQYDYAWohDyAIQYDQAWohEANAIAhBrIoDaiARIBhBAnQiBUH8/wNxEIUJIAhBsIoDakGoBSAIKAKsigMiB0GIARCECSAHECsgCEGAyAFqIAhBsIoDahCGCSAIQayKA2ogESAFQQFyQf3/A3EQhQkgCEGwigNqQagFIAgoAqyKAyIHQYgBEIQJIAcQKyAQIAhBsIoDahCGCSAIQayKA2ogESAFQQJyQf7/A3EQhQkgCEGwigNqQagFIAgoAqyKAyIHQYgBEIQJIAcQKyAPIAhBsIoDahCGCSAIQayKA2ogESAFQQNyQf//A3EQhQkgCEGwigNqQagFIAgoAqyKAyIFQYgBEIQJIAUQKyAOIAhBsIoDahCGCSAIQYCoAWogCEGAyAFqQYAg/AoAACAIQYCoAWoQtgQgCEGAyABqIAhBgIgCaiAIQYCoAWoQtwRBACEHQQAhBQNAIAhBgMgAaiAFQQJ0aiIGIAYoAgAiBEGAgIACakEXdUH/v4B8bCAEajYCACAGQQRqIgYgBigCACIGQYCAgAJqQRd1Qf+/gHxsIAZqNgIAIAVBAmoiBUGAAkcNAAsDQCAXIAdBAnRqIgUgBSgCACIGQYCAgAJqQRd1Qf+/gHxsIAZqNgIAIAVBBGoiBSAFKAIAIgVBgICAAmpBF3VB/7+AfGwgBWo2AgBBACEFIAdBAmoiB0GAAkcNAAtBACEHA0AgFiAHQQJ0aiIGIAYoAgAiBEGAgIACakEXdUH/v4B8bCAEajYCACAGQQRqIgYgBigCACIGQYCAgAJqQRd1Qf+/gHxsIAZqNgIAIAdBAmoiB0GAAkcNAAsDQCAVIAVBAnRqIgcgBygCACIGQYCAgAJqQRd1Qf+/gHxsIAZqNgIAIAdBBGoiByAHKAIAIgdBgICAAmpBF3VB/7+AfGwgB2o2AgAgBUECaiIFQYACRw0ACyAIQYDIAGoQuARBACEGQQAhBwNAIAhBgMgAaiAHQQJ0aiIFIAUoAgAiBEEfdUGBwP8DcSAEajYCACAFQQRqIgQgBCgCACIEQR91QYHA/wNxIARqNgIAIAVBCGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgBUEMaiIFIAUoAgAiBUEfdUGBwP8DcSAFajYCACAHQQRqIgdBgAJHDQALA0AgFyAGQQJ0aiIFIAUoAgAiB0EfdUGBwP8DcSAHajYCACAFQQRqIgcgBygCACIHQR91QYHA/wNxIAdqNgIAIAVBCGoiByAHKAIAIgdBH3VBgcD/A3EgB2o2AgAgBUEMaiIFIAUoAgAiBUEfdUGBwP8DcSAFajYCAEEAIQcgBkEEaiIGQYACRw0AC0EAIQYDQCAWIAZBAnRqIgUgBSgCACIEQR91QYHA/wNxIARqNgIAIAVBBGoiBCAEKAIAIgRBH3VBgcD/A3EgBGo2AgAgBUEIaiIEIAQoAgAiBEEfdUGBwP8DcSAEajYCACAFQQxqIgUgBSgCACIFQR91QYHA/wNxIAVqNgIAIAZBBGoiBkGAAkcNAAsDQCAVIAdBAnRqIgUgBSgCACIGQR91QYHA/wNxIAZqNgIAIAVBBGoiBiAGKAIAIgZBH3VBgcD/A3EgBmo2AgAgBUEIaiIGIAYoAgAiBkEfdUGBwP8DcSAGajYCACAFQQxqIgUgBSgCACIFQR91QYHA/wNxIAVqNgIAQQAhBSAHQQRqIgdBgAJHDQALQQAhBwNAIAdBAnQiBiAIQYDIAGpqIgQgBCgCACIEQf8AakEHdUGL2ABsQYCAgARqQRh1IgNBACADQStMGyIDNgIAIAhBgChqIAZqQf+/gHxBACAEIANBgLB0bGoiBkGA4P8BShsgBmo2AgAgB0EBaiIHQYACRw0ACwNAQQAhByAbIAVBAnQiBmpB/7+AfEEAIAYgF2oiBigCACIEQf8AakEHdUGL2ABsQYCAgARqQRh1IgNBACADQStMGyIDQYCwdGwgBGoiBEGA4P8BShsgBGo2AgAgBiADNgIAIAVBAWoiBUGAAkcNAAtBACEFA0AgGiAFQQJ0IgZqQf+/gHxBACAGIBZqIgYoAgAiBEH/AGpBB3VBi9gAbEGAgIAEakEYdSIDQQAgA0ErTBsiA0GAsHRsIARqIgRBgOD/AUobIARqNgIAIAYgAzYCACAFQQFqIgVBgAJHDQALA0AgGSAHQQJ0IgVqQf+/gHxBACAFIBVqIgUoAgAiBkH/AGpBB3VBi9gAbEGAgIAEakEYdSIEQQAgBEErTBsiBEGAsHRsIAZqIgZBgOD/AUobIAZqNgIAIAUgBDYCACAHQQFqIgdBgAJHDQALIAAgCEGAyABqEIcJQQAhAiAJQQBB0AH8CwAgCUGIASAcQcAAEIMJIAlBiAEgAEGABhCDCSAJIAkpA8gBIiSnQXhxaiIFIAUpAwBCHyAkQgOGhoU3AwAgCUIANwPIASAJIAkpA4ABQoCAgICAgICAgH+FNwOAASAAQSAgCUGIARCECSAIIAAQiAlBgAEhBANAQQAhBwNAIAQgB2ohAyACQQFqIgJBAnRB4OAvajQCACIlQoCAgICQgIjAA34hJgNAIAggB0ECdGoiBSAEQQJ0aiIGIAUoAgAgJiAGNAIAIiR+QiCHQv+/gHx+ICQgJX58QiCIpyIGazYCACAFIAUoAgAgBmo2AgAgB0EBaiIHIANJDQALIAQgB2oiB0GAAkkNAAsgBEEBSyEHQQAhBSAEQQF2IQQgBw0AC0EAIQYDQCAGQQJ0IgcgCEGAqAFqaiAIQYDoAWogB2o0AgAgByAIajQCAH4iJEKAgICAkICIwAN+QiCHQv+/gHx+ICR8QiCIPgIAIAdBBHIiByAIQYCoAWpqIAhBgOgBaiAHajQCACAHIAhqNAIAfiIkQoCAgICQgIjAA35CIIdC/7+AfH4gJHxCIIg+AgAgBkECaiIGQYACRw0ACwNAIA0gBUECdCIHaiAHIB9qNAIAIAcgCGo0AgB+IiRCgICAgJCAiMADfkIgh0L/v4B8fiAkfEIgiD4CACANIAdBBHIiB2ogByAfajQCACAHIAhqNAIAfiIkQoCAgICQgIjAA35CIIdC/7+AfH4gJHxCIIg+AgBBACEHIAVBAmoiBUGAAkcNAAtBACEGA0AgCyAGQQJ0IgVqIAUgHmo0AgAgBSAIajQCAH4iJEKAgICAkICIwAN+QiCHQv+/gHx+ICR8QiCIPgIAIAsgBUEEciIFaiAFIB5qNAIAIAUgCGo0AgB+IiRCgICAgJCAiMADfkIgh0L/v4B8fiAkfEIgiD4CACAGQQJqIgZBgAJHDQALA0AgDCAHQQJ0IgVqIAUgHWo0AgAgBSAIajQCAH4iJEKAgICAkICIwAN+QiCHQv+/gHx+ICR8QiCIPgIAIAwgBUEEciIFaiAFIB1qNAIAIAUgCGo0AgB+IiRCgICAgJCAiMADfkIgh0L/v4B8fiAkfEIgiD4CAEGAAiEKIAdBAmoiB0GAAkcNAAtBASEDA0BBACEFA0AgAyAFaiECQQAgCkEBayIKQQJ0QeDgL2ooAgBrrCIlQoCAgICQgIjAA34hJgNAIAhBgKgBaiAFQQJ0aiIHIAcgA0ECdGoiBigCACIEIAcoAgAiB2o2AgAgBiAmIAcgBGusIiR+QiCHQv+/gHx+ICQgJX58QiCIPgIAIAVBAWoiBSACSQ0ACyADIAVqIgVBgAJJDQALIANBgAFJIQdBACEFIANBAXQhAyAHDQALA0AgBUECdCIHIAhBgKgBamoiBiAGNAIAIiRCgICAgKD/+L9/fkIgh0L/v4B8fiAkQvrHAn58QiCIPgIAIAcgI2oiByAHNAIAIiRCgICAgKD/+L9/fkIgh0L/v4B8fiAkQvrHAn58QiCIPgIAQYACIQogBUECaiIFQYACRw0AC0EBIQMDQEEAIQUDQCADIAVqIQJBACAKQQFrIgpBAnRB4OAvaigCAGusIiVCgICAgJCAiMADfiEmA0AgDSAFQQJ0aiIHIAcgA0ECdGoiBigCACIEIAcoAgAiB2o2AgAgBiAmIAcgBGusIiR+QiCHQv+/gHx+ICQgJX58QiCIPgIAIAVBAWoiBSACSQ0ACyADIAVqIgVBgAJJDQALIANBgAFJIQdBACEFIANBAXQhAyAHDQALA0AgDSAFQQJ0IgdqIgYgBjQCACIkQoCAgICg//i/f35CIIdC/7+AfH4gJEL6xwJ+fEIgiD4CACAHICJqIgcgBzQCACIkQoCAgICg//i/f35CIIdC/7+AfH4gJEL6xwJ+fEIgiD4CAEGAAiEKIAVBAmoiBUGAAkcNAAtBASEDA0BBACEFA0AgAyAFaiECQQAgCkEBayIKQQJ0QeDgL2ooAgBrrCIlQoCAgICQgIjAA34hJgNAIAsgBUECdGoiByAHIANBAnRqIgYoAgAiBCAHKAIAIgdqNgIAIAYgJiAHIARrrCIkfkIgh0L/v4B8fiAkICV+fEIgiD4CACAFQQFqIgUgAkkNAAsgAyAFaiIFQYACSQ0ACyADQYABSSEHQQAhBSADQQF0IQMgBw0ACwNAIAsgBUECdCIHaiIGIAY0AgAiJEKAgICAoP/4v39+QiCHQv+/gHx+ICRC+scCfnxCIIg+AgAgByAhaiIHIAc0AgAiJEKAgICAoP/4v39+QiCHQv+/gHx+ICRC+scCfnxCIIg+AgBBgAIhCiAFQQJqIgVBgAJHDQALQQEhAwNAQQAhBQNAIAMgBWohAkEAIApBAWsiCkECdEHg4C9qKAIAa6wiJUKAgICAkICIwAN+ISYDQCAMIAVBAnRqIgcgByADQQJ0aiIGKAIAIgQgBygCACIHajYCACAGICYgByAEa6wiJH5CIIdC/7+AfH4gJCAlfnxCIIg+AgAgBUEBaiIFIAJJDQALIAMgBWoiBUGAAkkNAAsgA0GAAUkhBUEAIQcgA0EBdCEDIAUNAAtBACEFA0AgDCAFQQJ0IgZqIgQgBDQCACIkQoCAgICg//i/f35CIIdC/7+AfH4gJEL6xwJ+fEIgiD4CACAGICBqIgYgBjQCACIkQoCAgICg//i/f35CIIdC/7+AfH4gJEL6xwJ+fEIgiD4CACAFQQJqIgVBgAJHDQALA0AgB0ECdCIFIAhBgKgBamoiBiAIQYDIAWogBWooAgAgBigCAGo2AgAgBUEEciIGIAhBgKgBamoiBCAIQYDIAWogBmooAgAgBCgCAGo2AgAgBUEIciIGIAhBgKgBamoiBCAIQYDIAWogBmooAgAgBCgCAGo2AgAgBUEMciIFIAhBgKgBamoiBiAIQYDIAWogBWooAgAgBigCAGo2AgBBACEGIAdBBGoiB0GAAkcNAAtBACEHA0AgDSAHQQJ0IgVqIgQgBSAQaigCACAEKAIAajYCACANIAVBBHIiBGoiAyAEIBBqKAIAIAMoAgBqNgIAIA0gBUEIciIEaiIDIAQgEGooAgAgAygCAGo2AgAgDSAFQQxyIgVqIgQgBSAQaigCACAEKAIAajYCACAHQQRqIgdBgAJHDQALA0AgCyAGQQJ0IgVqIgcgBSAPaigCACAHKAIAajYCACALIAVBBHIiB2oiBCAHIA9qKAIAIAQoAgBqNgIAIAsgBUEIciIHaiIEIAcgD2ooAgAgBCgCAGo2AgAgCyAFQQxyIgVqIgcgBSAPaigCACAHKAIAajYCAEEAIQcgBkEEaiIGQYACRw0AC0EAIQYDQCAMIAZBAnQiBWoiBCAFIA5qKAIAIAQoAgBqNgIAIAwgBUEEciIEaiIDIAQgDmooAgAgAygCAGo2AgAgDCAFQQhyIgRqIgMgBCAOaigCACADKAIAajYCACAMIAVBDHIiBWoiBCAFIA5qKAIAIAQoAgBqNgIAIAZBBGoiBkGAAkcNAAsDQCAIQYCoAWogB0ECdGoiBSAFKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgBUEEaiIFIAUoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCAEEAIQUgB0ECaiIHQYACRw0AC0EAIQcDQCANIAdBAnRqIgYgBigCACIEQYCAgAJqQRd1Qf+/gHxsIARqNgIAIAZBBGoiBiAGKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgB0ECaiIHQYACRw0ACwNAIAsgBUECdGoiByAHKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgB0EEaiIHIAcoAgAiB0GAgIACakEXdUH/v4B8bCAHajYCACAFQQJqIgVBgAJHDQALQQAhBQNAIAwgBUECdGoiByAHKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgB0EEaiIHIAcoAgAiB0GAgIACakEXdUH/v4B8bCAHajYCACAFQQJqIgVBgAJHDQALIBhBAWohGCAIQYCoAWoQiQkNACAIQYAIaiAIIAhBgOgAahCKCSAIQYAIahC4BCAIQYAoaiAIQYAoaiAIQYAIahCLCUEAIQdBACEFA0AgCEGAKGogBUECdGoiBiAGKAIAIgRBgICAAmpBF3VB/7+AfGwgBGo2AgAgBkEEaiIGIAYoAgAiBkGAgIACakEXdUH/v4B8bCAGajYCACAFQQJqIgVBgAJHDQALA0AgGyAHQQJ0aiIFIAUoAgAiBkGAgIACakEXdUH/v4B8bCAGajYCACAFQQRqIgUgBSgCACIFQYCAgAJqQRd1Qf+/gHxsIAVqNgIAQQAhBSAHQQJqIgdBgAJHDQALQQAhBwNAIBogB0ECdGoiBiAGKAIAIgRBgICAAmpBF3VB/7+AfGwgBGo2AgAgBkEEaiIGIAYoAgAiBkGAgIACakEXdUH/v4B8bCAGajYCACAHQQJqIgdBgAJHDQALA0AgGSAFQQJ0aiIHIAcoAgAiBkGAgIACakEXdUH/v4B8bCAGajYCACAHQQRqIgcgBygCACIHQYCAgAJqQRd1Qf+/gHxsIAdqNgIAIAVBAmoiBUGAAkcNAAsgCEGAKGpBsucFEIwJDQAgCEGACGogCCAIQYCIAWoQigkgCEGACGoQuARBACEHQQAhBQNAIAhBgAhqIAVBAnRqIgYgBigCACIEQYCAgAJqQRd1Qf+/gHxsIARqNgIAIAZBBGoiBiAGKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgBUECaiIFQYACRw0ACwNAIBQgB0ECdGoiBSAFKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgBUEEaiIFIAUoAgAiBUGAgIACakEXdUH/v4B8bCAFajYCAEEAIQUgB0ECaiIHQYACRw0AC0EAIQcDQCATIAdBAnRqIgYgBigCACIEQYCAgAJqQRd1Qf+/gHxsIARqNgIAIAZBBGoiBiAGKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgB0ECaiIHQYACRw0ACwNAIBIgBUECdGoiByAHKAIAIgZBgICAAmpBF3VB/7+AfGwgBmo2AgAgB0EEaiIHIAcoAgAiB0GAgIACakEXdUH/v4B8bCAHajYCACAFQQJqIgVBgAJHDQALIAhBgAhqQYDoBRCMCQ0AIAhBgChqIAhBgChqIAhBgAhqELkEQQAhBkEAIQUDQCAFQQJ0IgcgCEGACGpqIAhBgChqIAdqKAIAIgRBgegFa0H/r3RJIARBgJh6RiAIQYDIAGogB2ooAgBBAEdxciIHNgIAIAYgB2ohBiAFQQFqIgVBgAJHDQALQQAhBEEAIQUDQCAUIAVBAnQiB2ogByAbaigCACIDQYHoBWtB/690SSADQYCYekYgByAXaigCAEEAR3FyIgc2AgAgBCAHaiEEIAVBAWoiBUGAAkcNAAtBACEDQQAhBQNAIBMgBUECdCIHaiAHIBpqKAIAIgJBgegFa0H/r3RJIAJBgJh6RiAHIBZqKAIAQQBHcXIiBzYCACADIAdqIQMgBUEBaiIFQYACRw0AC0EAIQJBACEFA0AgEiAFQQJ0IgdqIAcgGWooAgAiCkGB6AVrQf+vdEkgCkGAmHpGIAcgFWooAgBBAEdxciIHNgIAIAIgB2ohAiAFQQFqIgVBgAJHDQALIAIgAyAEIAZqampB0ABLDQALIAkQKyAAQSBqIQpBACEHA0AgCEGAqAFqIAdBBHRqIgYoAgQhAiAGKAIIIQMgBigCDCEEIAogB0EJbGoiBUGAgAggBigCAGsiBjoAACAFIAZBCHY6AAEgBUGAgAggBGsiBEEKdjoACCAFIARBAnY6AAcgBUGAgAggA2siA0EEdjoABSAFQYCACCACayICQQZ2OgADIAUgBEEGdCADQQx2cjoABiAFIANBBHQgAkEOdnI6AAQgBSACQQJ0IAZBEHZyOgACIAdBAWoiB0HAAEcNAAsgAEHgBGohCkEAIQcDQCANIAdBBHRqIgYoAgQhAiAGKAIIIQMgBigCDCEEIAogB0EJbGoiBUGAgAggBigCAGsiBjoAACAFIAZBCHY6AAEgBUGAgAggBGsiBEEKdjoACCAFIARBAnY6AAcgBUGAgAggA2siA0EEdjoABSAFQYCACCACayICQQZ2OgADIAUgBEEGdCADQQx2cjoABiAFIANBBHQgAkEOdnI6AAQgBSACQQJ0IAZBEHZyOgACIAdBAWoiB0HAAEcNAAsgAEGgCWohDUEAIQcDQCALIAdBBHRqIgYoAgQhAiAGKAIIIQMgBigCDCEEIA0gB0EJbGoiBUGAgAggBigCAGsiBjoAACAFIAZBCHY6AAEgBUGAgAggBGsiBEEKdjoACCAFIARBAnY6AAcgBUGAgAggA2siA0EEdjoABSAFQYCACCACayICQQZ2OgADIAUgBEEGdCADQQx2cjoABiAFIANBBHQgAkEOdnI6AAQgBSACQQJ0IAZBEHZyOgACIAdBAWoiB0HAAEcNAAsgAEHgDWohC0EAIQcDQCAMIAdBBHRqIgYoAgQhAiAGKAIIIQMgBigCDCEEIAsgB0EJbGoiBUGAgAggBigCAGsiBjoAACAFIAZBCHY6AAEgBUGAgAggBGsiBEEKdjoACCAFIARBAnY6AAcgBUGAgAggA2siA0EEdjoABSAFQYCACCACayICQQZ2OgADIAUgBEEGdCADQQx2cjoABiAFIANBBHQgAkEOdnI6AAQgBSACQQJ0IAZBEHZyOgACIAdBAWoiB0HAAEcNAAtBACEFIABBoBJqIgdBAEHUAPwLAEEAIQYDQCAIQYAIaiAGQQJ0aigCAARAIAUgB2ogBjoAACAFQQFqIQULIAhBgAhqIAZBAXIiBEECdGooAgAEQCAFIAdqIAQ6AAAgBUEBaiEFCyAGQQJqIgZBgAJHDQALIAAgBToA8BJBACEGA0AgFCAGQQJ0aigCAARAIAUgB2ogBjoAACAFQQFqIQULIBQgBkEBciIEQQJ0aigCAARAIAUgB2ogBDoAACAFQQFqIQULIAZBAmoiBkGAAkcNAAsgACAFOgDxEkEAIQYDQCATIAZBAnRqKAIABEAgBSAHaiAGOgAAIAVBAWohBQsgEyAGQQFyIgRBAnRqKAIABEAgBSAHaiAEOgAAIAVBAWohBQsgBkECaiIGQYACRw0ACyAAIAU6APISQQAhBgNAIBIgBkECdGooAgAEQCAFIAdqIAY6AAAgBUEBaiEFCyASIAZBAXIiBEECdGooAgAEQCAFIAdqIAQ6AAAgBUEBaiEFCyAGQQJqIgZBgAJHDQALIAAgBToA8xIgAUH0EjYCACAIQeCPA2okAA8LQe8AEAEAC9sCAQl/IwBBMGsiAiQAIAJBuK8pNgIgIABB+YYqIAJBIGoQmwECQAJAIABBARDIASIFRQRAQdW1KSEBDAELIABBAhDIASIGRQRAQZmHKyEBDAELIABBAxDIASIERQRAQemeKyEBQQAhBAwCC0G5tSkhASAFKAIAQaAKRw0BIABBBEHB4ikQ3AEhAyAEKAIAIQEgBCgCCCEHIAYoAgAhCCAGKAIIIQkCfyADBEAgCSAIIAcgASADKAIIIAMoAgAgBSgCCBCJBQwBCyAJIAggByABQQBBACAFKAIIEIkFCyEBQQEhAyAAKAIMQQFBESABGzoABCAAIAAoAgxBCGo2AgxBACEBDAELQQAhBgsgBBCaASAGEJoBIAUQmgEgA0UEQCACIAE2AhQgAkG4ryk2AhAgAEH8iCogAkEQahBsAAsgAkG4ryk2AgAgAEHghyogAhCbASACQTBqJABBAQu9KAIqfwN+IwBBoI8CayIHJAACQAJ/QX8gAUH0EkcNABpBfyAFQf8BSw0AGiAHIAYtAAA6AICJAiAHIAYtAAE6AIGJAiAHIAYtAAI6AIKJAiAHIAYtAAM6AIOJAiAHIAYtAAQ6AISJAiAHIAYtAAU6AIWJAiAHIAYtAAY6AIaJAiAHIAYtAAc6AIeJAiAHIAYtAAg6AIiJAiAHIAYtAAk6AImJAiAHIAYtAAo6AIqJAiAHIAYtAAs6AIuJAiAHIAYtAAw6AIyJAiAHIAYtAA06AI2JAiAHIAYtAA46AI6JAiAHIAYtAA86AI+JAiAHIAYtABA6AJCJAiAHIAYtABE6AJGJAiAHIAYtABI6AJKJAiAHIAYtABM6AJOJAiAHIAYtABQ6AJSJAiAHIAYtABU6AJWJAiAHIAYtABY6AJaJAiAHIAYtABc6AJeJAiAHIAYtABg6AJiJAiAHIAYtABk6AJmJAiAHIAYtABo6AJqJAiAHIAYtABs6AJuJAiAHIAYtABw6AJyJAiAHIAYtAB06AJ2JAiAHIAYtAB46AJ6JAiAHIAYtAB86AJ+JAiAGQSBqIQ0DQCAHQYBAayAJQQR0aiIIIA0gCUEFbGoiAS0AASILQQh0QYAGcSABLQAAcjYCACAIIAEtAAIiCkEGdEHAB3EgC0ECdnI2AgQgCCABLQADIgtBBHRB8AdxIApBBHZyNgIIIAggAS0ABEECdCALQQZ2cjYCDCAJQQFqIglBwABHDQALIAZB4AJqIQ4gB0GAyABqIQ1BACEJA0AgDSAJQQR0aiIIIA4gCUEFbGoiAS0AASILQQh0QYAGcSABLQAAcjYCACAIIAEtAAIiCkEGdEHAB3EgC0ECdnI2AgQgCCABLQADIgtBBHRB8AdxIApBBHZyNgIIIAggAS0ABEECdCALQQZ2cjYCDCAJQQFqIglBwABHDQALIAZBoAVqIQ8gB0GA0ABqIQ5BACEJA0AgDiAJQQR0aiIIIA8gCUEFbGoiAS0AASILQQh0QYAGcSABLQAAcjYCACAIIAEtAAIiCkEGdEHAB3EgC0ECdnI2AgQgCCABLQADIgtBBHRB8AdxIApBBHZyNgIIIAggAS0ABEECdCALQQZ2cjYCDCAJQQFqIglBwABHDQALIAZB4AdqIQwgB0GA2ABqIQ9BACEJA0AgDyAJQQR0aiIIIAwgCUEFbGoiAS0AASILQQh0QYAGcSABLQAAcjYCACAIIAEtAAIiCkEGdEHAB3EgC0ECdnI2AgQgCCABLQADIgtBBHRB8AdxIApBBHZyNgIIIAggAS0ABEECdCALQQZ2cjYCDCAJQQFqIglBwABHDQALIAcgAC0AACIROgCgiAIgByAALQABIhI6AKGIAiAHIAAtAAIiEzoAoogCIAcgAC0AAyIUOgCjiAIgByAALQAEIhU6AKSIAiAHIAAtAAUiFjoApYgCIAcgAC0ABiIXOgCmiAIgByAALQAHIhg6AKeIAiAHIAAtAAgiGToAqIgCIAcgAC0ACSIaOgCpiAIgByAALQAKIhs6AKqIAiAHIAAtAAsiHDoAq4gCIAcgAC0ADCIdOgCsiAIgByAALQANIh46AK2IAiAHIAAtAA4iHzoArogCIAcgAC0ADyIgOgCviAIgByAALQAQIiE6ALCIAiAHIAAtABEiIjoAsYgCIAcgAC0AEiIjOgCyiAIgByAALQATIiQ6ALOIAiAHIAAtABQiJToAtIgCIAcgAC0AFSImOgC1iAIgByAALQAWIic6ALaIAiAHIAAtABciKDoAt4gCIAcgAC0AGCIpOgC4iAIgByAALQAZIio6ALmIAiAHIAAtABoiKzoAuogCIAcgAC0AGyIsOgC7iAIgByAALQAcIi06ALyIAiAHIAAtAB0iLjoAvYgCIAcgAC0AHiIvOgC+iAIgByAALQAfIjA6AL+IAiAHQYDgAGogAEEgahCGCSAHQYDoAGogAEHgBGoQhgkgB0GA8ABqIABBoAlqEIYJIAdBgPgAaiAAQeANahCGCSAHQQBBgAj8CwBBfyAALQDwEiIIQdAASw0AGiAAQaASaiELAkAgCEUNAEEBIQEgByALLQAAQQJ0akEBNgIAIAhBAUYNAANAQX8gASALaiIKLQAAIgwgCkEBay0AAE0NAhogByAMQQJ0akEBNgIAIAFBAWoiASAIRw0ACwsgB0GACGpBAEGACPwLAEF/IAAtAPESIgpB0ABLDQAaQX8gCCAKSw0AGgJAIAggCk8NACAHQYAIaiIQIAggC2otAABBAnRqQQE2AgAgCEEBaiIBIApPDQADQCABIAtqIgktAAAhDCABIAhLBEBBfyAMIAlBAWstAABNDQMaCyAQIAxBAnRqQQE2AgAgAUEBaiIBIApHDQALCyAHQYAQakEAQYAI/AsAQX8gAC0A8hIiCEHQAEsNABpBfyAIIApJDQAaAkAgCCAKTQ0AIAdBgBBqIhAgCiALai0AAEECdGpBATYCACAKQQFqIgEgCE8NAANAIAEgC2oiCS0AACEMIAEgCksEQEF/IAwgCUEBay0AAE0NAxoLIBAgDEECdGpBATYCACABQQFqIgEgCEcNAAsLIAdBgBhqQQBBgAj8CwBBfyAALQDzEiIBQdAASw0AGkF/IAEgCEkNABoCQCABIAhNDQAgB0GAGGoiCSAIIAtqLQAAQQJ0akEBNgIAIAhBAWoiCiABTw0AA0AgCiALaiIMLQAAIQAgCCAKSQRAQX8gACAMQQFrLQAATQ0DGgsgCSAAQQJ0akEBNgIAIApBAWoiCiABRw0ACwsCQCABQdAATw0AA0AgASALai0AAEUEQCABQQFqIgFB0ABHDQEMAgsLQX8MAQtBfyAHQYDgAGoQiQkNABogB0HAiAJqQcAAIAZBoAoQswRB0AEQKiIMRQ0BQQAhACAMQQBB0AH8CwAgDEGIASAHQcCIAmpBwAAQgwkgByAFOgDBiAIgB0EAOgDAiAIgDEGIASAHQcCIAmpBAhCDCSAMQYgBIAQgBRCDCSAMQYgBIAIgAxCDCSAMIAwpA8gBIjGnQXhxaiIBIAEpAwBCHyAxQgOGhoU3AwAgDEIANwPIASAMIAwpA4ABQoCAgICAgICAgH+FNwOAASAHQcCIAmpBwAAgDEGIARCECSAHQYCAAmogB0GgiAJqEIgJIAdBgIABaiAHQYCJAmoQtAQgB0GA4ABqELYEIAdBgCBqIAdBgIABaiAHQYDgAGoQtwRBgAEhCwNAQQAhCQNAIAkgC2ohCiAAQQFqIgBBAnRB4OAvajQCACIyQoCAgICQgIjAA34hMwNAIAdBgIACaiAJQQJ0aiIBIAtBAnRqIgggASgCACAzIAg0AgAiMX5CIIdC/7+AfH4gMSAyfnxCIIinIghrNgIAIAEgASgCACAIajYCACAJQQFqIgkgCkkNAAsgCSALaiIJQYACSQ0ACyALQQFLIQEgC0EBdiELIAENAAtBACEJA0AgB0GAQGsgCUECdGoiASABKAIAQQ10NgIAIAFBBGoiCCAIKAIAQQ10NgIAIAFBCGoiCCAIKAIAQQ10NgIAIAFBDGoiASABKAIAQQ10NgIAIAlBBGoiCUGAAkcNAAtBACEJA0AgDSAJQQJ0aiIBIAEoAgBBDXQ2AgAgAUEEaiIIIAgoAgBBDXQ2AgAgAUEIaiIIIAgoAgBBDXQ2AgAgAUEMaiIBIAEoAgBBDXQ2AgAgCUEEaiIJQYACRw0AC0EAIQkDQCAOIAlBAnRqIgEgASgCAEENdDYCACABQQRqIgggCCgCAEENdDYCACABQQhqIgggCCgCAEENdDYCACABQQxqIgEgASgCAEENdDYCACAJQQRqIglBgAJHDQALQQAhCQNAIA8gCUECdGoiASABKAIAQQ10NgIAIAFBBGoiCCAIKAIAQQ10NgIAIAFBCGoiCCAIKAIAQQ10NgIAIAFBDGoiASABKAIAQQ10NgIAIAlBBGoiCUGAAkcNAAsgB0GAQGsQtgQgB0GAQGsgB0GAgAJqIAdBgEBrEIoJIAdBgCBqIAdBgCBqIAdBgEBrEIsJQQAhAQNAIAdBgCBqIAFBAnRqIgkgCSgCACIIQYCAgAJqQRd1Qf+/gHxsIAhqNgIAIAlBBGoiCSAJKAIAIglBgICAAmpBF3VB/7+AfGwgCWo2AgAgAUECaiIBQYACRw0ACyAHQYAoaiEJQQAhAQNAIAkgAUECdGoiCCAIKAIAIgtBgICAAmpBF3VB/7+AfGwgC2o2AgAgCEEEaiIIIAgoAgAiCEGAgIACakEXdUH/v4B8bCAIajYCACABQQJqIgFBgAJHDQALIAdBgDBqIQhBACEBA0AgCCABQQJ0aiILIAsoAgAiCkGAgIACakEXdUH/v4B8bCAKajYCACALQQRqIgsgCygCACILQYCAgAJqQRd1Qf+/gHxsIAtqNgIAIAFBAmoiAUGAAkcNAAsgB0GAOGohC0EAIQEDQCALIAFBAnRqIgogCigCACIAQYCAgAJqQRd1Qf+/gHxsIABqNgIAIApBBGoiCiAKKAIAIgpBgICAAmpBF3VB/7+AfGwgCmo2AgAgAUECaiIBQYACRw0ACyAHQYAgahC4BEEAIQpBACEAA0AgB0GAIGogAEECdGoiASABKAIAIgZBH3VBgcD/A3EgBmo2AgAgAUEEaiIGIAYoAgAiBkEfdUGBwP8DcSAGajYCACABQQhqIgYgBigCACIGQR91QYHA/wNxIAZqNgIAIAFBDGoiASABKAIAIgFBH3VBgcD/A3EgAWo2AgAgAEEEaiIAQYACRw0ACwNAIAkgCkECdGoiASABKAIAIgBBH3VBgcD/A3EgAGo2AgAgAUEEaiIAIAAoAgAiAEEfdUGBwP8DcSAAajYCACABQQhqIgAgACgCACIAQR91QYHA/wNxIABqNgIAIAFBDGoiASABKAIAIgFBH3VBgcD/A3EgAWo2AgAgCkEEaiIKQYACRw0AC0EAIQoDQCAIIApBAnRqIgEgASgCACIAQR91QYHA/wNxIABqNgIAIAFBBGoiACAAKAIAIgBBH3VBgcD/A3EgAGo2AgAgAUEIaiIAIAAoAgAiAEEfdUGBwP8DcSAAajYCACABQQxqIgEgASgCACIBQR91QYHA/wNxIAFqNgIAIApBBGoiCkGAAkcNAAtBACEKA0AgCyAKQQJ0aiIBIAEoAgAiAEEfdUGBwP8DcSAAajYCACABQQRqIgAgACgCACIAQR91QYHA/wNxIABqNgIAIAFBCGoiACAAKAIAIgBBH3VBgcD/A3EgAGo2AgAgAUEMaiIBIAEoAgAiAUEfdUGBwP8DcSABajYCACAKQQRqIgpBgAJHDQALQQAhCgNAIApBAnQiACAHQYAgamoiBigCACINQf8AakEHdUGL2ABsQYCAgARqQRh1IgFBACABQStMGyEBAkAgACAHaigCAEUNAEH/v4B8QQAgAUGAsHRsIA1qIgBBgOD/AUobIABqQQBKBEAgAUEBakEAIAFBK0cbIQEMAQsgAUEBa0ErIAEbIQELIAYgATYCACAKQQFqIgpBgAJHDQALIAdBgAhqIQ5BACEKA0AgCSAKQQJ0IgBqIgYoAgAiDUH/AGpBB3VBi9gAbEGAgIAEakEYdSIBQQAgAUErTBshAQJAIAAgDmooAgBFDQBB/7+AfEEAIAFBgLB0bCANaiIAQYDg/wFKGyAAakEASgRAIAFBAWpBACABQStHGyEBDAELIAFBAWtBKyABGyEBCyAGIAE2AgAgCkEBaiIKQYACRw0ACyAHQYAQaiENQQAhCQNAIAggCUECdCIKaiIAKAIAIgZB/wBqQQd1QYvYAGxBgICABGpBGHUiAUEAIAFBK0wbIQECQCAKIA1qKAIARQ0AQf+/gHxBACABQYCwdGwgBmoiCkGA4P8BShsgCmpBAEoEQCABQQFqQQAgAUErRxshAQwBCyABQQFrQSsgARshAQsgACABNgIAIAlBAWoiCUGAAkcNAAsgB0GAGGohBkEAIQkDQCALIAlBAnQiCGoiCigCACIAQf8AakEHdUGL2ABsQYCAgARqQRh1IgFBACABQStMGyEBAkAgBiAIaigCAEUNAEH/v4B8QQAgAUGAsHRsIABqIghBgOD/AUobIAhqQQBKBEAgAUEBakEAIAFBK0cbIQEMAQsgAUEBa0ErIAEbIQELIAogATYCACAJQQFqIglBgAJHDQALIAdBoIkCaiAHQYAgahCHCSAMQQBB0AH8CwAgDEGIASAHQcCIAmpBwAAQgwkgDEGIASAHQaCJAmpBgAYQgwkgDCAMKQPIASIxp0F4cWoiASABKQMAQh8gMUIDhoaFNwMAIAxCADcDyAEgDCAMKQOAAUKAgICAgICAgIB/hTcDgAEgB0GAiAJqQSAgDEGIARCECSAMECtBACARIActAICIAkcgEiAHLQCBiAJHciATIActAIKIAkdyIBQgBy0Ag4gCR3IgFSAHLQCEiAJHciAWIActAIWIAkdyIBcgBy0AhogCR3IgGCAHLQCHiAJHciAZIActAIiIAkdyIBogBy0AiYgCR3IgGyAHLQCKiAJHciAcIActAIuIAkdyIB0gBy0AjIgCR3IgHiAHLQCNiAJHciAfIActAI6IAkdyICAgBy0Aj4gCR3IgISAHLQCQiAJHciAiIActAJGIAkdyICMgBy0AkogCR3IgJCAHLQCTiAJHciAlIActAJSIAkdyICYgBy0AlYgCR3IgJyAHLQCWiAJHciAoIActAJeIAkdyICkgBy0AmIgCR3IgKiAHLQCZiAJHciArIActAJqIAkdyICwgBy0Am4gCR3IgLSAHLQCciAJHciAuIActAJ2IAkdyIC8gBy0AnogCR3IgMCAHLQCfiAJHcmsLIQkgB0GgjwJqJAAgCQ8LQe8AEAEAC40OAQx/IwBBwIECayIDJAAgA0GFvyo2AjAgAEH5hiogA0EwahCbAQJAIABBARDIASIJBEAgAEGgChCGASILRQ0BIAsoAgghDCADQaCBAmogA0HAgAJqIANBgIECaiADQcCgAWogA0FAayADQcDgAWogCSgCCBCLBSADQcAgaiADQaCBAmoQtAQgA0FAaxC2BCADQcDAAWogA0HAIGogA0FAaxC3BANAIANBwMABaiABQQJ0aiIFIAUoAgAiB0GAgIACakEXdUH/v4B8bCAHajYCACAFQQRqIgUgBSgCACIFQYCAgAJqQRd1Qf+/gHxsIAVqNgIAIAFBAmoiAUGAAkcNAAsgA0HAyAFqIQVBACEBA0AgBSABQQJ0aiIHIAcoAgAiCEGAgIACakEXdUH/v4B8bCAIajYCACAHQQRqIgcgBygCACIHQYCAgAJqQRd1Qf+/gHxsIAdqNgIAIAFBAmoiAUGAAkcNAAsgA0HA0AFqIQdBACEBA0AgByABQQJ0aiIIIAgoAgAiBEGAgIACakEXdUH/v4B8bCAEajYCACAIQQRqIgggCCgCACIIQYCAgAJqQRd1Qf+/gHxsIAhqNgIAIAFBAmoiAUGAAkcNAAsgA0HA2AFqIQhBACEBA0AgCCABQQJ0aiIEIAQoAgAiAkGAgIACakEXdUH/v4B8bCACajYCACAEQQRqIgQgBCgCACIEQYCAgAJqQRd1Qf+/gHxsIARqNgIAIAFBAmoiAUGAAkcNAAsgA0HAwAFqELgEIANBwMABaiADQcDAAWogA0HA4AFqELkEQQAhBEEAIQIDQCADQcDAAWogAkECdGoiASABKAIAIgZBH3VBgcD/A3EgBmo2AgAgAUEEaiIGIAYoAgAiBkEfdUGBwP8DcSAGajYCACABQQhqIgYgBigCACIGQR91QYHA/wNxIAZqNgIAIAFBDGoiASABKAIAIgFBH3VBgcD/A3EgAWo2AgAgAkEEaiICQYACRw0ACwNAIAUgBEECdGoiASABKAIAIgJBH3VBgcD/A3EgAmo2AgAgAUEEaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACABQQhqIgIgAigCACICQR91QYHA/wNxIAJqNgIAIAFBDGoiASABKAIAIgFBH3VBgcD/A3EgAWo2AgAgBEEEaiIEQYACRw0AC0EAIQQDQCAHIARBAnRqIgEgASgCACICQR91QYHA/wNxIAJqNgIAIAFBBGoiAiACKAIAIgJBH3VBgcD/A3EgAmo2AgAgAUEIaiICIAIoAgAiAkEfdUGBwP8DcSACajYCACABQQxqIgEgASgCACIBQR91QYHA/wNxIAFqNgIAIARBBGoiBEGAAkcNAAtBACEEA0AgCCAEQQJ0aiIBIAEoAgAiAkEfdUGBwP8DcSACajYCACABQQRqIgIgAigCACICQR91QYHA/wNxIAJqNgIAIAFBCGoiAiACKAIAIgJBH3VBgcD/A3EgAmo2AgAgAUEMaiIBIAEoAgAiAUEfdUGBwP8DcSABajYCACAEQQRqIgRBgAJHDQALQQAhAQNAIAFBAnQiBCADQcDAAWpqIgIgAigCACICQf8faiIGQQ11NgIAIANBwKABaiAEaiACIAZBgEBxazYCACAEQQRyIgQgA0HAwAFqaiICIAIoAgAiAkH/H2oiBkENdTYCACADQcCgAWogBGogAiAGQYBAcWs2AgAgAUECaiIBQYACRw0ACyADQcCoAWohAkEAIQEDQCACIAFBAnQiBGogBCAFaiIGKAIAIgogCkH/H2oiCkGAQHFrNgIAIAYgCkENdTYCACACIARBBHIiBGogBCAFaiIEKAIAIgYgBkH/H2oiBkGAQHFrNgIAIAQgBkENdTYCACABQQJqIgFBgAJHDQALIANBwLABaiEEQQAhAQNAIAQgAUECdCIFaiAFIAdqIgIoAgAiBiAGQf8faiIGQYBAcWs2AgAgAiAGQQ11NgIAIAQgBUEEciIFaiAFIAdqIgUoAgAiAiACQf8faiICQYBAcWs2AgAgBSACQQ11NgIAIAFBAmoiAUGAAkcNAAsgA0HAuAFqIQdBACEBA0AgByABQQJ0IgVqIAUgCGoiBCgCACICIAJB/x9qIgJBgEBxazYCACAEIAJBDXU2AgAgByAFQQRyIgVqIAUgCGoiBSgCACIEIARB/x9qIgRBgEBxazYCACAFIARBDXU2AgAgAUECaiIBQYACRw0ACyAMIANBoIECaiADQcDAAWoQugQgC0GgCjYCACAJEJoBIANBhb8qNgIgIABB4IcqIANBIGoQmwEgA0HAgQJqJABBAQ8LIANBo7EpNgIEIANBhb8qNgIAIABB/IgqIAMQbAALIAkQmgEgA0H9tSk2AhQgA0GFvyo2AhAgAEH8iCogA0EQahBsAAuWBwEBfyAAIAYtAAA6AAAgACAGLQABOgABIAAgBi0AAjoAAiAAIAYtAAM6AAMgACAGLQAEOgAEIAAgBi0ABToABSAAIAYtAAY6AAYgACAGLQAHOgAHIAAgBi0ACDoACCAAIAYtAAk6AAkgACAGLQAKOgAKIAAgBi0ACzoACyAAIAYtAAw6AAwgACAGLQANOgANIAAgBi0ADjoADiAAIAYtAA86AA8gACAGLQAQOgAQIAAgBi0AEToAESAAIAYtABI6ABIgACAGLQATOgATIAAgBi0AFDoAFCAAIAYtABU6ABUgACAGLQAWOgAWIAAgBi0AFzoAFyAAIAYtABg6ABggACAGLQAZOgAZIAAgBi0AGjoAGiAAIAYtABs6ABsgACAGLQAcOgAcIAAgBi0AHToAHSAAIAYtAB46AB4gACAGLQAfOgAfIAIgBi0AIDoAACACIAYtACE6AAEgAiAGLQAiOgACIAIgBi0AIzoAAyACIAYtACQ6AAQgAiAGLQAlOgAFIAIgBi0AJjoABiACIAYtACc6AAcgAiAGLQAoOgAIIAIgBi0AKToACSACIAYtACo6AAogAiAGLQArOgALIAIgBi0ALDoADCACIAYtAC06AA0gAiAGLQAuOgAOIAIgBi0ALzoADyACIAYtADA6ABAgAiAGLQAxOgARIAIgBi0AMjoAEiACIAYtADM6ABMgAiAGLQA0OgAUIAIgBi0ANToAFSACIAYtADY6ABYgAiAGLQA3OgAXIAIgBi0AODoAGCACIAYtADk6ABkgAiAGLQA6OgAaIAIgBi0AOzoAGyACIAYtADw6ABwgAiAGLQA9OgAdIAIgBi0APjoAHiACIAYtAD86AB8gBkFAayECQQAhAANAIAAgAWogACACai0AADoAACABIABBAXIiB2ogAiAHai0AADoAACABIABBAnIiB2ogAiAHai0AADoAACABIABBA3IiB2ogAiAHai0AADoAACAAQQRqIgBBwABHDQALIAQgBkGAAWoQjgkgBEGACGogBkHgAWoQjgkgBEGAEGogBkHAAmoQjgkgBEGAGGogBkGgA2oQjgkgBSAGQYAEahCOCSAFQYAIaiAGQeAEahCOCSAFQYAQaiAGQcAFahCOCSAFQYAYaiAGQaAGahCOCSADIAZBgAdqEI8JIANBgAhqIAZBoApqEI8JIANBgBBqIAZBwA1qEI8JIANBgBhqIAZB4BBqEI8JC5YBAQJ/IwBBMGsiASQAIAFB6tcqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUH9tSk2AgQgAUHq1yo2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGgCkYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFB6tcqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQELlgEBAn8jAEEwayIBJAAgAUHL2Co2AiAgAEH5hiogAUEgahCbASAAQQEQyAEiAkUEQCABQYSIKzYCBCABQcvYKjYCACAAQfyIKiABEGwACyAAKAIMQRFBASACKAIAQfQSRhs6AAQgACAAKAIMQQhqNgIMIAIQmgEgAUHL2Co2AhAgAEHghyogAUEQahCbASABQTBqJABBAQujAQEFfyMAQTBrIgEkACABQYq+KjYCICAAQfmGKiABQSBqEJsBQZCWNCgCACEEIABBIBCGASIDBEADQCAEKAIkEGkhBSADKAIIIAJqIAU6AAAgAkEBaiICQSBHDQALIANBIDYCACABQYq+KjYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBDwsgAUHnsSk2AgQgAUGKvio2AgAgAEH8iCogARBsAAvNAQEDfyMAQTBrIgEkACABQaC/KjYCICAAQfmGKiABQSBqEJsBAkACf0HnsSkgAEEBEMgBIgJFDQAaIAIoAgBBIEcEQCAAKAIMQQA6AAQgACAAKAIMQQhqNgIMQaSyKQwBCyAAQSAQhgEiAw0BQd+2KQshAyACEJoBIAEgAzYCBCABQaC/KjYCACAAQfyIKiABEGwACyADQSA2AgAgAigCCCADKAIIEJAFIAIQmgEgAUGgvyo2AhAgAEHghyogAUEQahCbASABQTBqJABBAQvzAwIEfwF+IwBBgAhrIgIkACACQcABaiIEQQBBgAX8CwAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LA3AgAkHAADYCwAYgAkL5wvibkaOz8NsANwO4ASACQuv6htq/tfbBHzcDsAEgAkKf2PnZwpHagpt/NwOoASACQtGFmu/6z5SH0QA3A6ABIAJC8e30+KWn/aelfzcDmAEgAkKr8NP0r+68tzw3A5ABIAJCu86qptjQ67O7fzcDiAEgAkKIkvOd/8z5hOoANwOAAQNAIAQgAikDcCIGp0EDdkH4AHFqIgUgACADajEAACAFKQMAQgiGhDcDACACIAZCCHwiBjcDcAJAAkAgBlAEQCACQgA3A3AgAiACKQN4QgF8NwN4DAELIAZC/weDQgBSDQELIAJB8ABqEPkDCyADQQFqIgNBIEcNAAsgAkHwAGogAhD4AyACIAItAABB+AFxOgAAIAIgAi0AH0E/cUHAAHI6AB8gAkFAayACQSAQkgUgAkHwAGogAkFAaxCTBSACQfAGaiACQcABahCUBSACQdAHaiACQfAAaiACQfAGahCVBSACQaAHaiACQZgBaiACQfAGahCVBSABIAJBoAdqEJYFIAJB0AZqIAJB0AdqEJYFIAEgAS0AHyACLQDQBkEHdHM6AB8gAkGACGokAAvuGQMefxJ+AXsjAEHwCmsiASQAIAFByboqNgIgIABB+YYqIAFBIGoQmwECfyAAQQEQyAEiD0UEQEHnsSkMAQsgAEECEMgBIg1FBEBBACENQcqfKwwBCyAPKAIAQSBHBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDEGksikMAQsgDygCCCABQTBqEJAFIABBwAAQhgEiA0UEQEEAIQNB54crDAELIANBwAA2AgAgAygCCCECIA8oAgghCCANKAIAIQYgDSgCCCEHQQAhAyABQYgFaiIFQQBBgAX8CwAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7gEIAFBwAA2AogKIAFC+cL4m5Gjs/DbADcDgAUgAULr+obav7X2wR83A/gEIAFCn9j52cKR2oKbfzcD8AQgAULRhZrv+s+Uh9EANwPoBCABQvHt9Pilp/2npX83A+AEIAFCq/DT9K/uvLc8NwPYBCABQrvOqqbY0Ouzu383A9AEIAFCiJLznf/M+YTqADcDyAQDQCAFIAEpA7gEIh+nQQN2QfgAcWoiBCADIAhqMQAAIAQpAwBCCIaENwMAIAEgH0IIfCIfNwO4BAJAAkAgH1AEQCABQgA3A7gEIAEgASkDwARCAXw3A8AEDAELIB9C/weDQgBSDQELIAFBuARqEPkDCyADQQFqIgNBIEcNAAsgAUG4BGogAUHQAWoQ+AMgASABLQDQAUH4AXE6ANABIAEgAS0A7wFBP3FBwAByOgDvAUEAIQMgAUGIBWoiBUEAQYAF/AsAIAEgMf0LA7gEIAFBwAA2AogKIAFC+cL4m5Gjs/DbADcDgAUgAULr+obav7X2wR83A/gEIAFCn9j52cKR2oKbfzcD8AQgAULRhZrv+s+Uh9EANwPoBCABQvHt9Pilp/2npX83A+AEIAFCq/DT9K/uvLc8NwPYBCABQrvOqqbY0Ouzu383A9AEIAFCiJLznf/M+YTqADcDyAQgAUHwAWohCANAIAUgASkDuAQiH6dBA3ZB+ABxaiIEIAMgCGoxAAAgBCkDAEIIhoQ3AwAgASAfQgh8Ih83A7gEAkACQCAfUARAIAFCADcDuAQgASABKQPABEIBfDcDwAQMAQsgH0L/B4NCAFINAQsgAUG4BGoQ+QMLIANBAWoiA0EgRw0ACyAGBEBBACEDA0AgBSABKQO4BCIfp0EDdkH4AHFqIgQgAyAHajEAACAEKQMAQgiGhDcDACABIB9CCHwiHzcDuAQCQAJAIB9QBEAgAUIANwO4BCABIAEpA8AEQgF8NwPABAwBCyAfQv8Hg0IAUg0BCyABQbgEahD5AwsgA0EBaiIDIAZHDQALCyABQbgEaiABQZABahD4AyABQZAEaiABQZABakHAABCSBSABQZACaiABQZAEahCTBSABQZAKaiABQeACahCUBSABQdAAaiABQZACaiABQZAKahCVBSABQcAKaiABQbgCaiABQZAKahCVBSACIAFBwApqEJYFIAFB4ANqIAFB0ABqEJYFIAIgAi0AHyABLQDgA0EHdHM6AB8gAUHQAGogAiABQTBqIAcgBhCXBSABQeADaiABQdAAakHAABCSBSABQbADaiABQdABakEgEJIFIAEgATUCsAMiHyABNQLgAyIgfiIhp0H/////A3E2AsAKIAEgICABNQK0AyIofiAhQh6IfCAfIAE1AuQDIiF+fCIip0H/////A3E2AsQKIAEgICABNQK4AyIpfiAhICh+fCAfIAE1AugDIip+fCAiQh6IfCIjp0H/////A3E2AsgKIAEgKCAqfiAhICl+fCAgIAE1ArwDIiJ+fCAfIAE1AuwDIit+fCAjQh6IfCIkp0H/////A3E2AswKIAEgISAifiApICp+fCAoICt+fCAgIAE1AsADIiN+fCAfIAE1AvADIix+fCAkQh6IfCIlp0H/////A3E2AtAKIAEgKSArfiAiICp+fCAhICN+fCAoICx+fCAgIAE1AsQDIiR+fCAfIAE1AvQDIi1+fCAlQh6IfCImp0H/////A3E2AtQKIAEgIyAqfiAiICt+fCApICx+fCAhICR+fCAoIC1+fCAgIAE1AsgDIiV+fCAfIAE1AvgDIi5+fCAmQh6IfCInp0H/////A3E2AtgKIAEgIiAsfiAjICt+fCAkICp+fCApIC1+fCAhICV+fCAoIC5+fCAgIAE1AswDIiZ+fCAfIAE1AvwDIi9+fCAnQh6IfCIwp0H/////A3E2AtwKIAEgJCArfiAjICx+fCAiIC1+fCAlICp+fCApIC5+fCAhICZ+fCAoIC9+fCAgIAE1AtADIid+fCAfIAE1AoAEIiB+fCAwQh6IfCIfpyIDQf///wdxNgLgCiABICMgLX4gJCAsfnwgJSArfnwgIiAufnwgJiAqfnwgKSAvfnwgISAnfnwgICAofnwgH0IeiHwiH6ciBEEWdEGAgID+A3EgA0EIdkH///8BcXI2ApAKIAEgJSAsfiAkIC1+fCAjIC5+fCAmICt+fCAiIC9+fCAnICp+fCAgICl+fCAfQh6IfCIfpyIDQRZ0QYCAgP4DcSAEQQh2Qf///wFxcjYClAogASAkIC5+ICUgLX58ICYgLH58ICMgL358ICcgK358ICAgIn58IB9CHoh8Ih+nIgRBFnRBgICA/gNxIANBCHZB////AXFyNgKYCiABICYgLX4gJSAufnwgJCAvfnwgJyAsfnwgICAjfnwgH0IeiHwiH6ciA0EWdEGAgID+A3EgBEEIdkH///8BcXI2ApwKIAEgJSAvfiAmIC5+fCAnIC1+fCAgICR+fCAfQh6IfCIfpyIEQRZ0QYCAgP4DcSADQQh2Qf///wFxcjYCoAogASAnIC5+ICYgL358ICAgJX58IB9CHoh8Ih+nIgNBFnRBgICA/gNxIARBCHZB////AXFyNgKkCiABICAgJn4gJyAvfnwgH0IeiHwiH6ciBEEWdEGAgID+A3EgA0EIdkH///8BcXI2AqgKIAEgICAnfiAfQh6IfKciA0EIdkH///8BcTYCsAogASADQRZ0QYCAgP4DcSAEQQh2Qf///wFxcjYCrAogAUHgA2ogAUGQCmogAUHACmoQmAVBASEDIAIgASgCsAQgASgCgARqIAEoAqwEIAEoAvwDaiABKAKoBCABKAL4A2ogASgCpAQgASgC9ANqIAEoAqAEIAEoAvADaiABKAKcBCABKALsA2ogASgCmAQgASgC6AMgASgClAQgASgC5AMgASgCkAQgASgC4ANqIgRBHnZqaiILQR52amoiDEEedmoiBUEedmoiCUEedmoiCkEedmoiB0EedmoiBkEedmoiCCAGQf////8DcSIGIAdB/////wNxIgcgCkH/////A3EiCiAJQf////8DcSIJIAVB/////wNxIhAgDEH/////A3EiDCALQf////8DcSILIARB/////wNxIgVB7afX5wFrIg5BH3VqQemYpoICayIWQR91akHlmuf7AmsiF0EfdiIYQajv+b0DcmsiGUEfdiIaQRRyayIRQR92IhtrIhJBH3YiHGsiE0EfdiIdayIUQR92Ih5BgCByayIVQR92QQFrIgQgDkEBdkGAgICABHEgDmogBXNxIAVzIgU6ACAgAiAIIBVzIARxIAhzIhVBCHY6AD8gAiAEIB5BHnQgFGogBnNxIAZzIghBFnY6AD0gAiAIQQ52IhQ6ADwgAiAIQQZ2OgA7IAIgBCAdQR50IBNqIAdzcSAHcyIGQRR2OgA5IAIgBkEMdiITOgA4IAIgBkEEdjoANyACIAQgHEEedCASaiAKc3EgCnMiB0ESdjoANSACIAdBCnYiEjoANCACIAdBAnY6ADMgAiAEIBtBHnQgEWogCXNxIAlzIg5BEHY6ADEgAiAOQQh2IhE6ADAgAiAEIBpBHnQgGWogEHNxIBBzIgpBFnY6AC4gAiAKQQ52OgAtIAIgCkEGdiIQOgAsIAIgBCAYQR50IBdqIAxzcSAMcyIJQRR2OgAqIAIgCUEMdjoAKSACIAlBBHYiDDoAKCACIAQgFkEBdkGAgICABHEgFmogC3NxIAtzIgRBEnY6ACYgAiAEQQp2OgAlIAIgBEECdiILOgAkIAIgBUEQdjoAIiACIAVBCHY6ACEgAiAVQRB0IBRyQRB2OgA+IAIgCEESdCATckEQdjoAOiACIAZBFHQgEnJBEHY6ADYgAiAHQRZ0IBFyQRB2OgAyIAIgDkEYdCAQckEYdjoALyACIApBGnQgDHJBGHY6ACsgAiAJQRx0IAtyQRh2OgAnIAIgBEEedCAFckEYdjoAI0EACyEEIA0QmgEgDxCaASADRQRAIAEgBDYCFCABQcm6KjYCECAAQfyIKiABQRBqEGwACyABQcm6KjYCACAAQeCHKiABEJsBIAFB8ApqJABBAQvIBAEPfyMAQfAAayIDJABBwAAgAmtBACACQT9NGyIEBEAgA0EwaiACakEAIAT8CwALIAIEQCADQTBqIAEgAvwKAAALIAMoAlQhBCADKAJYIQUgAygCXCEGIAMoAmAhByADKAJkIQggAygCaCEJIAMoAmwhCiADKAI0IQsgAygCOCEMIAMoAjwhDSADKAJAIQ4gAygCRCEPIAMoAkghECADKAJQIQIgAygCTCEBIAAgAygCMCIRQf////8DcTYCACAAIAJBEHQgAUEQdnJB////B3E2AiAgACABQQ50IBBBEnZyQf////8DcTYCHCAAIBBBDHQgD0EUdnJB/////wNxNgIYIAAgD0EKdCAOQRZ2ckH/////A3E2AhQgACAOQQh0IA1BGHZyQf////8DcTYCECAAIA1BBnQgDEEadnJB/////wNxNgIMIAAgDEEEdCALQRx2ckH/////A3E2AgggACALQQJ0IBFBHnZyQf////8DcTYCBCADIApBCHY2AiAgAyAKQRZ0IAlBCnZyQf////8DcTYCHCADIAlBFHQgCEEMdnJB/////wNxNgIYIAMgCEESdCAHQQ52ckH/////A3E2AhQgAyAHQRB0IAZBEHZyQf////8DcTYCECADIAZBDnQgBUESdnJB/////wNxNgIMIAMgBUEMdCAEQRR2ckH/////A3E2AgggAyAEQQp0IAJBFnZyQf////8DcTYCBCADIAJBCHQgAUEYdnJB/////wNxNgIAIAAgAyAAEJgFIANB8ABqJAALvQ0CFn8BeyMAQeACayIDJAAgA0GAAWohBANAIAQiAiABIAZBAnRqIgUoAgAiBEEPcToAACACIARBGHZBD3E6AAYgAiAEQRR2QQ9xOgAFIAIgBEEQdkEPcToABCACIARBDHZBD3E6AAMgAiAEQQh2QQ9xOgACIAIgBEHwAXFBBHY6AAEgAiAFKAIEIgVBAnQiB0EcdjoADiACIAVBFnZBD3E6AA0gAiAFQRJ2QQ9xOgAMIAIgBUEOdkEPcToACyACIAVBCnZBD3E6AAogAiAFQQZ2QQ9xOgAJIAIgBUECdkEPcToACCACIAcgBEEcdnJBD3E6AAcgAkEPaiEEIAZBBkkhBSAGQQJqIQYgBQ0ACyACIAEoAiAiBEEPcToADyACIARBDHZBD3E6ABIgAiAEQQh2QQ9xOgARIAIgBEHwAXFBBHY6ABAgA0GAAWpBAXIhAUEAIQIgAy0AgAEhBUEAIQYDQCABIAJqIgQgBC0AACAFIAZqIgXAQQR1aiIGOgAAIANBgAFqIAJqIAVBD3EiBSAFQQN2IgVBBHRrOgAAIAJBPkZFBEAgAkECaiICIANBgAFqaiIHIActAAAgBSAGaiIGwEEEdWoiBToAACAEIAZBD3EiBiAGQQN2IgZBBHRrOgAADAELCyADIAMtAL8BIAVqOgC/ASADQQhqQQAgAywAgQEQkQkgACADKAI0IgUgAygCMCIGIAMoAggiB2tBtP///wBqIgFBGnZqIAMoAgwiCGtB/P//P2oiAkH///8PcTYCBCAAIAMoAjgiCSADKAIQIgprIAJBGXZqQfz///8AaiICQf///x9xNgIIIAAgAygCPCILIAMoAhQiDGsgAkEadmpB/P//P2oiAkH///8PcTYCDCAAIAMoAkAiDSADKAIYIg5rIAJBGXZqQfz///8AaiICQf///x9xNgIQIAAgAygCRCIPIAMoAhwiEGsgAkEadmpB/P//P2oiAkH///8PcTYCFCAAIAMoAkgiESADKAIgIhJrIAJBGXZqQfz///8AaiICQf///x9xNgIYIAAgAygCTCITIAMoAiQiFGsgAkEadmpB/P//P2oiAkH///8PcTYCHCAAIAMoAlAiFSADKAIoIhZrIAJBGXZqQfz///8AaiIXQf///x9xNgIgIAMoAiwhAiADKAJUIQQgACAVIBZqIBMgFGogESASaiAPIBBqIA0gDmogCyAMaiAJIApqIAggBSAGIAdqIgZBGnZqaiIFQRl2aiIHQRp2aiIIQRl2aiIJQRp2aiIKQRl2aiILQRp2aiIMQRl2aiINQf///x9xNgJIIAAgDEH///8PcTYCRCAAIAtB////H3E2AkAgACAKQf///w9xNgI8IAAgCUH///8fcTYCOCAAIAhB////D3E2AjQgACAHQf///x9xNgIwIAAgBUH///8PcTYCLCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsCVCAAIBj9CwJkIABBADYCdCAAIAIgBGogDUEadmoiBUH///8PcTYCTCAAIAQgAmsgF0EadmpB/P//P2oiAkH///8PcTYCJCAAIAVBGXZBE2wgBkH///8fcWo2AiggACACQRl2QRNsIAFB////H3FqNgIAIAAgAygCWDYCeCAAIAMoAlw2AnwgACADKAJgNgKAASAAIAMoAmQ2AoQBIAAgAygCaDYCiAEgACADKAJsNgKMASAAIAMoAnA2ApABIAAgAygCdDYClAEgACADKAJ4NgKYASADKAJ8IQIgAEECNgJQIAAgAjYCnAEgAEH4AGohCCAAQdAAaiEFIABBKGohBiADQdgAaiEBQQMhAgNAIANBCGogAkEBdiADQYABaiACaiwAABCRCSAAIANBCGoQkgkgAkE+SSEEIAJBAmohAiAEDQALIANBwAFqIAAQngUgACADQcABaiADQbgCaiICEJUFIAYgA0HoAWoiByADQZACaiIEEJUFIAUgBCACEJUFIANBwAFqIAAQngUgACADQcABaiACEJUFIAYgByAEEJUFIAUgBCACEJUFIANBwAFqIAAQngUgACADQcABaiACEJUFIAYgByAEEJUFIAUgBCACEJUFIANBwAFqIAAQngUgACADQcABaiACEJUFIAYgByAEEJUFIAUgBCACEJUFIAggA0HAAWogBxCVBSADQQhqQQAgAywAgAEQkQkgASABQaCpMRCVBSAAIANBCGoQkglBAiECA0AgA0EIaiACQQF2IANBgAFqIAJqLAAAEJEJIAAgA0EIahCSCSACQT5JIQQgAkECaiECIAQNAAsgA0HgAmokAAuHAQEBfyMAQZABayICJAAgAkHgAGogAUEBEJsFIAJBMGogAkHgAGpBAhCbBSACIAJBMGogARCVBSACQeAAaiACIAJB4ABqEJUFIAJBMGogAkHgAGpBARCbBSACIAJBMGogAhCVBSACEJwFIAIgAkEFEJsFIAAgAiACQeAAahCVBSACQZABaiQAC60IAht+Cn8gACABNQIEIgMgAigCBCIeQQF0rSIafiABNQIAIgUgAigCCCIirSIRfnwgATUCCCIGIAI1AgAiB358IAE1AgwiCCACKAIkIh9BJmytIhd+fCABNQIQIgkgAigCICIjQRNsrSIEfnwgATUCFCIKIAIoAhwiIEH/////B3EiJEEmbK0iEn58IAE1AhgiCyACKAIYIiVBE2ytIgx+fCABNQIcIg0gAigCFCIhQf////8HcSImQSZsrSIVfnwgATUCICIOIAIoAhAiJ0ETbK0iD358IAE1AiQiECACKAIMIgJB/////wdxIgFBJmytIhZ+fCADIAd+IAUgHq0iGH58IAYgH0ETbK0iG358IAQgCH58IAkgJEETbK0iFH58IAogDH58IAsgJkETbK0iGX58IA0gD358IA4gAUETbK1+fCAQICJBE2ytIhx+fCADIBd+IAUgB358IAQgBn58IAggEn58IAkgDH58IAogFX58IAsgD358IA0gFn58IA4gHH58IBAgHkEmbK1+fCIcQhqIfCIdQhmIfCITp0H///8fcTYCCCAAIAMgEX4gBSACrSIWfnwgBiAYfnwgByAIfnwgCSAbfnwgBCAKfnwgCyAUfnwgDCANfnwgDiAZfnwgDyAQfnwgE0IaiHwiE6dB////D3E2AgwgACADIAJBAXStIhl+IAUgJ60iD358IAYgEX58IAggGn58IAcgCX58IAogF358IAQgC358IA0gEn58IAwgDn58IBAgFX58IBNCGYh8IhOnQf///x9xNgIQIAAgAyAPfiAFICGtIhV+fCAGIBZ+fCAIIBF+fCAJIBh+fCAHIAp+fCALIBt+fCAEIA1+fCAOIBR+fCAMIBB+fCATQhqIfCIUp0H///8PcTYCFCAAIAMgIUEBdK0iE34gBSAlrSIMfnwgBiAPfnwgCCAZfnwgCSARfnwgCiAafnwgByALfnwgDSAXfnwgBCAOfnwgECASfnwgFEIZiHwiEqdB////H3E2AhggACADIAx+IAUgIK0iFH58IAYgFX58IAggD358IAkgFn58IAogEX58IAsgGH58IAcgDX58IA4gG358IAQgEH58IBJCGoh8IgSnQf///w9xNgIcIAAgAyAgQQF0rX4gBSAjrSISfnwgBiAMfnwgCCATfnwgCSAPfnwgCiAZfnwgCyARfnwgDSAafnwgByAOfnwgECAXfnwgBEIZiHwiBKdB////H3E2AiAgACADIBJ+IAUgH61+fCAGIBR+fCAIIAx+fCAJIBV+fCAKIA9+fCALIBZ+fCANIBF+fCAOIBh+fCAHIBB+fCAEQhqIfCIDp0H///8PcTYCJCAAIANCGYhC/////w+DQhN+IBxC////H4N8IgOnQf///x9xNgIAIAAgA0IaiKcgHadB////D3FqNgIEC9gHAQl/IAAgASgCJCABKAIgIAEoAhwgASgCGCABKAIUIAEoAhAgASgCDCABKAIIIAEoAgQgASgCACICQRp2aiIDQRl2aiIEQRp2aiIFQRl2aiIGQRp2aiIHQRl2aiIIQRp2aiIJQRl2aiIKQRp2aiIBQRl2QRNsIAJB////H3FqIgJB////H3EgAUH///8PcSAKQf///x9xIAlB////D3EgCEH///8fcSAHQf///w9xIAZB////H3EgBUH///8PcSAEQf///x9xIANB////D3EgAkEadmoiAkEZdmoiA0EadmoiBEEZdmoiBUEadmoiBkEZdmoiB0EadmoiCEEZdmoiCUEadmoiAUEZdkETbGpBE2oiCkH///8fcSABQf///w9xIAlB////H3EgCEH///8PcSAHQf///x9xIAZB////D3EgBUH///8fcSAEQf///w9xIANB////H3EgAkH///8PcSAKQRp2aiICQRl2aiIDQRp2aiIEQRl2aiIFQRp2aiIGQRl2aiIHQRp2aiIIQRl2aiIJQRp2aiIKQRl2QRNsakHt//8faiIBOgAAIAAgAUEQdjoAAiAAIAFBCHY6AAEgACACQf///w9xIAFBGnZqQf///w9qIgJBDnY6AAUgACACQQZ2OgAEIAAgAUEYdkEDcSACQQJ0cjoAAyAAIANB////H3EgAkEZdmpB////H2oiAUENdjoACCAAIAFBBXY6AAcgACACQRZ2QQdxIAFBA3RyOgAGIAAgBEH///8PcSABQRp2akH///8PaiICQQt2OgALIAAgAkEDdjoACiAAIAFBFXZBH3EgAkEFdHI6AAkgACAFQf///x9xIAJBGXZqQf///x9qIgFBEnY6AA8gACABQQp2OgAOIAAgAUECdjoADSAAIAJBE3ZBP3EgAUEGdHI6AAwgACAGQf///w9xIAFBGnZqQf///w9qIgE6ABAgACABQRB2OgASIAAgAUEIdjoAESAAIAdB////H3EgAUEZdmpB////H2oiAkEPdjoAFSAAIAJBB3Y6ABQgACABQRh2QQFxIAJBAXRyOgATIAAgCEH///8PcSACQRp2akH///8PaiIBQQ12OgAYIAAgAUEFdjoAFyAAIAJBF3ZBB3EgAUEDdHI6ABYgACAJQf///x9xIAFBGXZqQf///x9qIgJBDHY6ABsgACACQQR2OgAaIAAgAUEVdkEPcSACQQR0cjoAGSAAIAogAkEadmpB////D2oiAUEKdjoAHiAAIAFBAnY6AB0gACABQRJ2Qf8AcToAHyAAIAJBFHZBP3EgAUEGdHI6ABwLxgQCBH8BfiMAQeAFayIFJAAgBUHYAGoiCEEAQYAF/AsAIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwMIIAVBwAA2AtgFIAVC+cL4m5Gjs/DbADcDUCAFQuv6htq/tfbBHzcDSCAFQp/Y+dnCkdqCm383A0AgBULRhZrv+s+Uh9EANwM4IAVC8e30+KWn/aelfzcDMCAFQqvw0/Sv7ry3PDcDKCAFQrvOqqbY0Ouzu383AyAgBUKIkvOd/8z5hOoANwMYA0AgCCAFKQMIIgmnQQN2QfgAcWoiByABIAZqMQAAIAcpAwBCCIaENwMAIAUgCUIIfCIJNwMIAkACQCAJUARAIAVCADcDCCAFIAUpAxBCAXw3AxAMAQsgCUL/B4NCAFINAQsgBUEIahD5AwsgBkEBaiIGQSBHDQALQQAhBgNAIAggBSkDCCIJp0EDdkH4AHFqIgcgAiAGajEAACAHKQMAQgiGhDcDACAFIAlCCHwiCTcDCAJAAkAgCVAEQCAFQgA3AwggBSAFKQMQQgF8NwMQDAELIAlC/weDQgBSDQELIAVBCGoQ+QMLIAZBAWoiBkEgRw0ACyAEBEBBACEGA0AgCCAFKQMIIgmnQQN2QfgAcWoiByADIAZqMQAAIAcpAwBCCIaENwMAIAUgCUIIfCIJNwMIAkACQCAJUARAIAVCADcDCCAFIAUpAxBCAXw3AxAMAQsgCUL/B4NCAFINAQsgBUEIahD5AwsgBkEBaiIGIARHDQALCyAFQQhqIAAQ+AMgBUHgBWokAAuQCwEOfiAAIAIoAgAgATUCCCIMQv////8DfiIHIAE1AgwiBUL/////A34iAyABNQIQIg1C/////wN+Igh8IAE1AhwiBkL+tMoxfnwgATUCGCIJQsKuoQx+fCABNQIUIgpCodb//wN+fHwgATUCBCIEQv//P358IAE1AiAiDkKMrc6zA358IARC/////wN+IgQgAyAHfCAGQoytzrMDfnwgCUL+tMoxfnwgCkLCrqEMfnwgDUKh1v//A358fCABNQIAIgtC//8/fnwgDkKbprDRAH58IAQgB3wgBkKbprDRAH58IAlCjK3OswN+fCAKQv60yjF+fCANQsKuoQx+fCAFQqHW//8DfnwgC0L/////A358Qh6IfCIHQh6IfCIEQgaGQsD///8DgyAHQhiIQj+DhCIHQu2n1+cBfiILp0H/////A3FrIgFBAXZBgICAgARxIAFqNgIAIAAgAigCBCABQR91aiAHQumYpoICfiALQh6IfCAIIApC/////wN+Igt8IAZCwq6hDH58IAlCodb//wN+fCADfCAMQv//P358IA5C/rTKMX58IARCHoh8IgxCBoZCwP///wODIARCGIhCP4OEIgNC7afX5wF+fCIEp0H/////A3FrIgFBAXZBgICAgARxIAFqNgIEIAAgAigCCCABQR91aiADQumYpoICfiAHQuWa5/sCfnwgCyAJQv////8DfiIPfCILIAZCodb//wN+fCAIfCAFQv//P358IA5Cwq6hDH58IAxCHoh8IghCBoZCwP///wODIAxCGIhCP4OEIgVC7afX5wF+fCAEQh6IfCIMp0H/////A3FrIgFBAXZBgICAgARxIAFqNgIIIAAgAigCDCABQR91aiADQuWa5/sCfiAHQqjv+b0DfnwgBULpmKaCAn58IAsgBkL/////A34iEHwgDUL//z9+fCAOQqHW//8DfnwgCEIeiHwiBEIGhkLA////A4MgCEIYiEI/g4QiDULtp9fnAX58IAxCHoh8IgynQf////8DcWsiAUEBdkGAgICABHEgAWo2AgwgACACKAIQIAFBH3VqIANCqO/5vQN+IAdCFH58IAVC5Zrn+wJ+fCANQumYpoICfnwgCkL//z9+IA98IA5C/////wN+IgsgEHwiD3wgBEIeiHwiCEIGhkLA////A4MgBEIYiEI/g4QiCkLtp9fnAX58IAxCHoh8IgSnQf////8DcWsiAUEBdkGAgICABHEgAWo2AhAgACACKAIUIAVCqO/5vQN+IANCFH58IA1C5Zrn+wJ+fCAKQumYpoICfnwgDyAJQv//P358IAhCHoh8IgNCBoZCwP///wODIAhCGIhCP4OEIglC7afX5wF+fCAEQh6IfCIIp0H/////A3FrIAFBH3VqIgFBAXZBgICAgARxIAFqNgIUIAAgAigCGCANQqjv+b0DfiAFQhR+fCAKQuWa5/sCfnwgCULpmKaCAn58IAsgBkL//z9+fCADQh6IfCIGQgaGQsD///8DgyADQhiIQj+DhCIDQu2n1+cBfnwgCEIeiHwiBadB/////wNxayABQR91aiIBQQF2QYCAgIAEcSABajYCGCAAIAIoAhwgCkKo7/m9A34gDUIUfnwgCULlmuf7An58IANC6ZimggJ+fCAOQv//P34gBkIeiHwiDkIGhkLA////A4MgBkIYiEI/g4QiBkLtp9fnAX58IAVCHoh8IgWnQf////8DcWsgAUEfdWoiAUEBdkGAgICABHEgAWo2AhwgACACKAIgIApCFH4gB0IMhnwgCUKo7/kFfnwgDkIYiELtp9fnAX58IANC5ZrnA358IAZC6ZimAn58IAVCHoh8p0H///8HcWsgAUEfdWoiAUEHdkGAgIAIcSABajYCICAAEJMJIAAQkwkL3FMDKH8EfgF7IwBBwBZrIgEkACABQeyuKTYCICAAQfmGKiABQSBqEJsBAkACQCAAQQEQyAEiIUUEQEHftikhAgwBCyAAQQIQyAEiIEUEQEHnhyshAgwBCyAAQQMQyAEiH0UEQEHKnyshAkEAIR8MAgsCQCAhKAIAQSBHBEBB7rcpIQIMAQsgICgCAEHAAEcEQEHMiCshAgwBC0EBIR4Cf0EBICAoAggiCy0AP0EfSw0AGiAfKAIAIQ0gHygCCCEPICEoAggiAi0AHyEQIAI1AgQhKSACNQIIISogAjUCFCErIAI1AhghLCACKAIcIQ4gAigCACEEIAIoAgwhBiACKAIQIQwgAf0MAAAAAAAAAAAAAAAAAAAAAP0LArQCIAFBADYCxAIgAUEBNgKgAiABIC39CwKkAiABIAxB////D3E2AowCIAEgBkEGdjYCiAIgASAEQf///x9xNgL4ASABIA5BBnZB////D3E2ApwCIAEgKyAsQiCGhEITiKdB////D3E2ApQCIAEgDK0gK0IghoRCGYinQf///x9xNgKQAiABICkgKkIghoRCE4inQf///x9xNgKAAiABIAStIClCIIaEQhqIp0H///8PcTYC/AEgASAsIA6tQiCGhEIMiKdB////H3E2ApgCIAEgKiAGrUIghoRCDYinQf///w9xNgKEAiABQfACaiABQfgBaiIREJoFIAFBkAFqIAFB8AJqQaCpMRCVBSABIAEoAvQCIAEoAvACQbP///8AaiIDQRp2akH8//8/aiIEQf///w9xIg42AvQCIAEgASgC+AIgBEEZdmpB/P///wBqIgZB////H3EiBDYC+AIgASABKAL8AiAGQRp2akH8//8/aiIMQf///w9xIgY2AvwCIAEgASgCgAMgDEEZdmpB/P///wBqIghB////H3EiDDYCgAMgASABKAKEAyAIQRp2akH8//8/aiIVQf///w9xIgg2AoQDIAEgASgCiAMgFUEZdmpB/P///wBqIgVB////H3EiFTYCiAMgASABKAKMAyAFQRp2akH8//8/aiISQf///w9xIgU2AowDIAEgASgCkAMgEkEZdmpB/P///wBqIgpB////H3EiEjYCkAMgASABKAKUAyAKQRp2akH8//8/aiIJQf///w9xIgo2ApQDIAEgCUEZdkETbCADQf///x9xaiIDNgLwAiABIAEoApABQQFqNgKQASABQbATaiABQZABahCaBSABQZAWaiABQbATaiABQZABahCVBSABQdABaiABQZAWahCaBSABQdABaiABQdABaiABQZABahCVBSABQdABaiABQdABaiABQfACahCVBSABQbARaiABQdABakEBEJsFIAFBsA9qIAFBsBFqQQIQmwUgAUGwBWogAUGwD2ogAUHQAWoQlQUgAUGwEWogAUGwBWogAUGwEWoQlQUgAUGwD2ogAUGwEWpBARCbBSABQbAFaiABQbAPaiABQbAFahCVBSABQbAFahCcBSABQbAFaiABQbAFakECEJsFIAFB0AFqIAFBsAVqIAFB0AFqEJUFIAFB0AFqIAFB0AFqIAFBkBZqEJUFIAFB0AFqIAFB0AFqIAFB8AJqEJUFIAFBsBNqIAFB0AFqEJoFIAFBsBNqIAFBsBNqIAFBkAFqEJUFIAEgASgCtBMiEyAOayABKAKwEyIUIANrQbT///8AaiIJQRp2akH8//8/aiIHQf///w9xNgKUBCABIAEoArgTIhYgBGsgB0EZdmpB/P///wBqIgdB////H3E2ApgEIAEgASgCvBMiFyAGayAHQRp2akH8//8/aiIHQf///w9xNgKcBCABIAEoAsATIhggDGsgB0EZdmpB/P///wBqIgdB////H3E2AqAEIAEgASgCxBMiHSAIayAHQRp2akH8//8/aiIHQf///w9xNgKkBCABIAEoAsgTIhkgFWsgB0EZdmpB/P///wBqIgdB////H3E2AqgEIAEgASgCzBMiGiAFayAHQRp2akH8//8/aiIHQf///w9xNgKsBCABIAEoAtATIhsgEmsgB0EZdmpB/P///wBqIgdB////H3E2ArAEIAEgASgC1BMiHCAKayAHQRp2akH8//8/aiIHQf///w9xNgK0BCABIAdBGXZBE2wgCUH///8fcWo2ApAEIAFB4BVqIAFBkARqEJYFIAEtAP8VIAEtAP4VIAEtAP0VIAEtAPwVIAEtAPsVIAEtAPoVIAEtAPkVIAEtAPgVIAEtAPcVIAEtAPYVIAEtAPUVIAEtAPQVIAEtAPMVIAEtAPIVIAEtAPEVIAEtAPAVIAEtAO8VIAEtAO4VIAEtAO0VIAEtAOwVIAEtAOsVIAEtAOoVIAEtAOkVIAEtAOgVIAEtAOcVIAEtAOYVIAEtAOUVIAEtAOQVIAEtAOMVIAEtAOIVIAEtAOAVIAEtAOEVcnJycnJycnJycnJycnJycnJycnJycnJycnJycnJyckEBa0GAAnFFBEAgASAOIBNqIAMgFGoiDkEadmoiA0H///8PcTYCtBMgASAEIBZqIANBGXZqIgRB////H3E2ArgTIAEgBiAXaiAEQRp2aiIEQf///w9xNgK8EyABIAwgGGogBEEZdmoiBEH///8fcTYCwBMgASAIIB1qIARBGnZqIgRB////D3E2AsQTIAEgFSAZaiAEQRl2aiIEQf///x9xNgLIEyABIAUgGmogBEEadmoiBEH///8PcTYCzBMgASASIBtqIARBGXZqIgRB////H3E2AtATIAEgCiAcaiAEQRp2aiIEQf///w9xNgLUEyABIARBGXZBE2wgDkH///8fcWo2ArATIAFB4BVqIAFBsBNqEJYFQQEgAS0A/xUgAS0A/hUgAS0A/RUgAS0A/BUgAS0A+xUgAS0A+hUgAS0A+RUgAS0A+BUgAS0A9xUgAS0A9hUgAS0A9RUgAS0A9BUgAS0A8xUgAS0A8hUgAS0A8RUgAS0A8BUgAS0A7xUgAS0A7hUgAS0A7RUgAS0A7BUgAS0A6xUgAS0A6hUgAS0A6RUgAS0A6BUgAS0A5xUgAS0A5hUgAS0A5RUgAS0A5BUgAS0A4xUgAS0A4hUgAS0A4BUgAS0A4RVycnJycnJycnJycnJycnJycnJycnJycnJycnJycnJyQQFrQYACcUUNARogAUHQAWogAUHQAWpB0KkxEJUFCyABQeAVaiABQdABahCWBSABLQDgFUEBcSAQQQd2RgRAIAFB2v//PyABKALQAWsiDkEadiABKALUAWtB/v//H2oiBEH///8PcTYC1AEgASAEQRl2IAEoAtgBa0H+//8/aiIEQf///x9xNgLYASABIARBGnYgASgC3AFrQf7//x9qIgRB////D3E2AtwBIAEgBEEZdiABKALgAWtB/v//P2oiBEH///8fcTYC4AEgASAEQRp2IAEoAuQBa0H+//8faiIEQf///w9xNgLkASABIARBGXYgASgC6AFrQf7//z9qIgRB////H3E2AugBIAEgBEEadiABKALsAWtB/v//H2oiBEH///8PcTYC7AEgASAEQRl2IAEoAvABa0H+//8/aiIEQf///x9xNgLwASABIARBGnYgASgC9AFrQf7//x9qIgRB////D3E2AvQBIAEgBEEZdkETbCAOQf///x9xajYC0AELIAFByAJqIg4gAUHQAWogERCVBSABQZABaiALIAIgDyANEJcFIAFB4ABqIAFBkAFqQcAAEJIFIAFBMGogC0EgakEgEJIFIAFBsBFqIAFB4ABqQQUQnQUgAUGwD2ogAUEwakEHEJ0FIAFBsBNqIAFB0AFqEJ4FIAFBkARqIAFBsBNqIAFBqBRqIgIQlQUgAUG4BGogAUHYE2oiBCABQYAUaiIGEJUFIAFB4ARqIiIgBiACEJUFIAFBiAVqIiMgAUGwE2ogBBCVBSABIAEoAvgBIgIgASgC0AEiBGtB2v//P2oiBkH///8fcTYCsAUgASABKAL8ASIMIAZBGnZqIAEoAtQBIgZrQf7//x9qIghB////D3E2ArQFIAEgASgCgAIiFSABKALYASIFayAIQRl2akH+//8/aiIIQf///x9xNgK4BSABIAEoAoQCIhIgASgC3AEiCmsgCEEadmpB/v//H2oiCEH///8PcTYCvAUgASABKAKIAiIDIAEoAuABIglrIAhBGXZqQf7//z9qNgLABSABIAEoAowCIgggASgC5AEiB2tB/v//H2o2AsQFIAEgByAIajYC7AUgASADIAlqNgLoBSABIAogEmo2AuQFIAEgBSAVajYC4AUgASAGIAxqNgLcBSABIAIgBGo2AtgFIAEgASgC9AEiAiABKAKcAiIEajYC/AUgASABKALwASIGIAEoApgCIgxqNgL4BSABIAEoAuwBIgggASgClAIiFWo2AvQFIAEgASgC6AEiBSABKAKQAiISajYC8AUgASASIAVrQf7//z9qNgLIBSABIBUgCGtB/v//H2o2AswFIAEgDCAGa0H+//8/ajYC0AUgASAEIAJrQf7//x9qNgLUBSABIAEoAqACNgKABiABIAEoAqQCNgKEBiABIAEoAqgCNgKIBiABIAEoAqwCNgKMBiABIAEoArACNgKQBiABIAEoArQCNgKUBiABIAEoArgCNgKYBiABIAEoArwCNgKcBiABIAEoAsACNgKgBiABIAEoAsQCNgKkBiABQagGaiAOQYDIMRCVBUEAIQ4DQCABIAEoArgEIgIgASgCkAQiBGtB2v//P2oiBkH///8fcTYCsBMgASABKAK8BCIMIAZBGnZqIAEoApQEIgZrQf7//x9qIghB////D3E2ArQTIAEgASgCwAQiFSABKAKYBCIFayAIQRl2akH+//8/aiIIQf///x9xNgK4EyABIAEoAsQEIhIgASgCnAQiCmsgCEEadmpB/v//H2oiCEH///8PcTYCvBMgASABKALIBCIDIAEoAqAEIglrIAhBGXZqQf7//z9qNgLAEyABIAEoAswEIgggASgCpAQiB2tB/v//H2o2AsQTIAEgASgC0AQiDSABKAKoBCIPa0H+//8/ajYCyBMgASABKALUBCIQIAEoAqwEIhFrQf7//x9qNgLMEyABIAEoAtgEIhMgASgCsAQiFGtB/v//P2o2AtATIAEgASgC3AQiFiABKAK0BCIXa0H+//8fajYC1BMgASAWIBdqNgKUAyABIBMgFGo2ApADIAEgECARajYCjAMgASANIA9qNgKIAyABIAcgCGo2AoQDIAEgAyAJajYCgAMgASAKIBJqNgL8AiABIAUgFWo2AvgCIAEgBiAMajYC9AIgASACIARqNgLwAiABQbATaiABQbATaiABQbAFaiAOQaABbGoiAhCVBSABQeAVaiABQfACaiACQShqEJUFIAEgASgCsBMiBCABKALgFSIGajYCsBUgASABKAK0EyIMIAEoAuQVIghqNgK0FSABIAEoArgTIhUgASgC6BUiBWo2ArgVIAEgASgCvBMiEiABKALsFSIKajYCvBUgASABKALAEyIDIAEoAvAVIglqNgLAFSABIAEoAsQTIgcgASgC9BUiDWo2AsQVIAEgDSAHa0H+//8fajYC9BUgASAGIARrQdr//z9qIgRB////H3E2AuAVIAEgASgCyBMiBiABKAL4FSIHajYCyBUgASABKALMEyINIAEoAvwVIg9qNgLMFSABIAEoAtATIhAgASgCgBYiEWo2AtAVIAEgASgC1BMiEyABKAKEFiIUajYC1BUgASAPIA1rQf7//x9qNgL8FSABIBEgEGtB/v//P2o2AoAWIAEgFCATa0H+//8fajYChBYgASAHIAZrQf7//z9qNgL4FSABIAggBEEadmogDGtB/v//H2oiBEH///8PcTYC5BUgASAFIBVrIARBGXZqQf7//z9qIgRB////H3E2AugVIAEgCiASayAEQRp2akH+//8faiIEQf///w9xNgLsFSABIAkgA2sgBEEZdmpB/v//P2o2AvAVIAFBkBZqICMgAkH4AGoQlQUgAUHQFGogIiACQdAAahCVBSABIAEoApQWIgQgASgC1BRBAXQiBmogASgCkBYiDCABKALQFEEBdCIIaiIVQRp2aiIFQf///w9xNgKEFSABIAEoApgWIhIgASgC2BRBAXQiCmogBUEZdmoiBUH///8fcTYCiBUgASABKAKcFiIDIAEoAtwUQQF0IglqIAVBGnZqIgVB////D3E2AowVIAEgASgCoBYiByABKALgFEEBdCINaiAFQRl2aiIFQf///x9xNgKQFSABKAL0FCEPIAEoAvAUIRAgASgC7BQhESABKALoFCETIAEoAuQUIRQgASAKIBJrIAYgBGsgCCAMa0G0////AGoiBEEadmpB/P//P2oiBkEZdmpB/P///wBqIgxB////H3E2AtgUIAEgBkH///8PcTYC1BQgASAJIANrIAxBGnZqQfz//z9qIgZB////D3E2AtwUIAEgASgCpBYiDCAUQQF0IghqIAVBGnZqIgVB////D3E2ApQVIAEgDSAHayAGQRl2akH8////AGoiBkH///8fcTYC4BQgASABKAKoFiISIBNBAXQiCmogBUEZdmoiBUH///8fcTYCmBUgASAIIAxrIAZBGnZqQfz//z9qIgZB////D3E2AuQUIAEgASgCrBYiDCARQQF0IghqIAVBGnZqIgVB////D3E2ApwVIAEgASgCsBYiAyAQQQF0IglqIAVBGXZqIgVB////H3E2AqAVIAEgCiASayAGQRl2akH8////AGoiBkH///8fcTYC6BQgASABKAK0FiISIA9BAXQiCmogBUEadmoiBUH///8PcTYCpBUgASAIIAxrIAZBGnZqQfz//z9qIgZB////D3E2AuwUIAEgBUEZdkETbCAVQf///x9xajYCgBUgASAJIANrIAZBGXZqQfz///8AaiIGQf///x9xNgLwFCABIAogEmsgBkEadmpB/P//P2oiBkH///8PcTYC9BQgASAGQRl2QRNsIARB////H3FqNgLQFCACQcgBaiIEIAFB4BVqIAFB0BRqEJUFIAJBoAFqIgYgAUGwFWogAUGAFWoQlQUgAkHwAWogAUGAFWogAUHQFGoQlQUgAkGYAmoiDCABQeAVaiABQbAVahCVBSAGIAYoAgAiEiAEKAIAIgprQdr//z9qIghB////H3E2AgAgAkGkAWoiBiAGKAIAIgMgAkHMAWoiCSgCACIHayAIQRp2akH+//8faiIGQf///w9xNgIAIAJBqAFqIgggCCgCACINIAJB0AFqIg8oAgAiEGsgBkEZdmpB/v//P2oiBkH///8fcTYCACACQawBaiIIIAgoAgAiESACQdQBaiITKAIAIhRrIAZBGnZqQf7//x9qIgZB////D3E2AgAgAkGwAWoiCCAIKAIAIhYgAkHYAWoiFygCACIYayAGQRl2akH+//8/ajYCACACQcQBaiIdKAIAIQYgAkHAAWoiGSgCACEIIAJBvAFqIhooAgAhFSACQbgBaiIbKAIAIQUgAkG0AWoiHCAcKAIAIhwgAkHcAWoiJCgCACIla0H+//8fajYCACAbIAUgAkHgAWoiJigCACIna0H+//8/ajYCACAaIBUgAkHkAWoiGygCACIoa0H+//8fajYCACAZIAggAkHoAWoiGigCACIZa0H+//8/ajYCACAXIBYgGGo2AgAgCSADIAdqNgIAIA8gDSAQajYCACATIBEgFGo2AgAgJCAcICVqNgIAICYgBSAnajYCACAbIBUgKGo2AgAgGiAIIBlqNgIAIAJB7AFqIggoAgAhAiAEIAogEmo2AgAgCCACIAZqNgIAIB0gBiACa0H+//8fajYCACAMIAxBgMgxEJUFIA5BAWoiDkEHRw0ACyABQfACakEAQaAB/AsAIAFBATYCwAMgAUEBNgKYAyABQcADaiEIIAFBmANqIRJB/wEhDgNAAkACQCABQbAPaiAOai0AACABQbARaiAOai0AAHJFBEAgDkEBayICIAFBsA9qai0AACABQbARaiACai0AAHJFDQEgAiEOCyAOQQBIDQEgAUHoA2ohFSABQYAUaiEGIAFB2BNqIQwgAUGoFGohBANAIAFBsBNqIAFB8AJqEJ4FIAFBsBFqIA5qLQAAIgIEQCABQfACaiABQbATaiAEEJUFIBIgDCAGEJUFIAggBiAEEJUFIBUgAUGwE2ogDBCVBSABIAEoApgDIgUgASgC8AIiCmtB2v//P2oiA0H///8fcTYCkBYgASABKAKcAyIJIANBGnZqIAEoAvQCIgNrQf7//x9qIgdB////D3E2ApQWIAEgASgCoAMiDSABKAL4AiIPayAHQRl2akH+//8/aiIHQf///x9xNgKYFiABIAEoAqQDIhAgASgC/AIiEWsgB0EadmpB/v//H2oiB0H///8PcTYCnBYgASABKAKoAyITIAEoAoADIhRrIAdBGXZqQf7//z9qNgKgFiABIAEoAqwDIgcgASgChAMiFmtB/v//H2o2AqQWIAEgBSAKajYC4BUgASADIAlqNgLkFSABIA0gD2o2AugVIAEgECARajYC7BUgASATIBRqNgLwFSABIAcgFmo2AvQVIAEgASgCiAMiBSABKAKwAyIKajYC+BUgASABKAKMAyIDIAEoArQDIglqNgL8FSABIAEoApADIgcgASgCuAMiDWo2AoAWIAEgASgClAMiDyABKAK8AyIQajYChBYgASAKIAVrQf7//z9qNgKoFiABIAkgA2tB/v//H2o2AqwWIAEgDSAHa0H+//8/ajYCsBYgASAQIA9rQf7//x9qNgK0FiABQZAWaiABQZAWaiABQbAFaiACIALAQQd1IgVzIAVrQf4BcUEBdkGgAWxqIgUgAkEHdiIKQShsIgJqEJUFIAFBsBNqIAFB4BVqIAUgCkEBc0EobGoQlQUgASABKAKQFiIDIAEoArATIglqNgLYEyABIAEoApQWIgcgASgCtBMiDWo2AtwTIAEgASgCmBYiDyABKAK4EyIQajYC4BMgASABKAKcFiIRIAEoArwTIhNqNgLkEyABIAEoAqAWIhQgASgCwBMiFmo2AugTIAEgASgCpBYiFyABKALEEyIYajYC7BMgASAYIBdrQf7//x9qNgLEEyABIAkgA2tB2v//P2oiA0H///8fcTYCsBMgASABKAKoFiIJIAEoAsgTIhdqNgLwEyABIAEoAqwWIhggASgCzBMiHWo2AvQTIAEgASgCsBYiGSABKALQEyIaajYC+BMgASABKAK0FiIbIAEoAtQTIhxqNgL8EyABIB0gGGtB/v//H2o2AswTIAEgGiAZa0H+//8/ajYC0BMgASAcIBtrQf7//x9qNgLUEyABIBcgCWtB/v//P2o2AsgTIAEgDSADQRp2aiAHa0H+//8faiIDQf///w9xNgK0EyABIBAgD2sgA0EZdmpB/v//P2oiA0H///8fcTYCuBMgASATIBFrIANBGnZqQf7//x9qIgNB////D3E2ArwTIAEgFiAUayADQRl2akH+//8/ajYCwBMgAUGwFWogFSAFQfgAahCVBSAEIAggBUHQAGoQlQUgASABKAKsFEEBdCABKAKoFEEBdCIFQRp2aiIDQf///w9xIgk2AqwUIAEgASgCsBRBAXQgA0EZdmoiA0H///8fcSIHNgKwFCABIAEoArQUQQF0IANBGnZqIgNB////D3EiDTYCtBQgASABKAK4FEEBdCADQRl2aiIDQf///x9xIg82ArgUIAEgASgCvBRBAXQgA0EadmoiA0H///8PcSIQNgK8FCABIAEoAsAUQQF0IANBGXZqIgNB////H3EiETYCwBQgASABKALEFEEBdCADQRp2aiIDQf///w9xIhM2AsQUIAEgASgCyBRBAXQgA0EZdmoiA0H///8fcSIUNgLIFCABIAEoAswUQQF0IANBGnZqIgNB////D3EiFjYCzBQgASADQRl2QRNsIAVB/v//H3FqIgU2AqgUIAEgFjYCpBQgASAUNgKgFCABIBM2ApwUIAEgETYCmBQgASAQNgKUFCABIA82ApAUIAEgDTYCjBQgASAHNgKIFCABIAk2AoQUIAEgBTYCgBQgAUGwE2ogAmoiAiABKAKwFSIFIAIoAlBqNgJQIAIgASgCtBUiAyACKAJUajYCVCACIAEoArgVIgkgAigCWGo2AlggAiABKAK8FSIHIAIoAlxqNgJcIAIgASgCwBUiDSACKAJgajYCYCACIAEoAsQVIg8gAigCZGo2AmQgAiABKALIFSIQIAIoAmhqNgJoIAIgASgCzBUiESACKAJsajYCbCACIAEoAtAVIhMgAigCcGo2AnAgAiABKALUFSIUIAIoAnRqNgJ0IAFBsBNqIApBA3NBKGxqIgIgAigCFCAPa0H+//8fajYCFCACIAIoAhggEGtB/v//P2o2AhggAiACKAIcIBFrQf7//x9qNgIcIAIgAigCICATa0H+//8/ajYCICACIAIoAiQgFGtB/v//H2o2AiQgAiACKAIAIAVrQdr//z9qIgVB////H3E2AgAgAiACKAIEIANrIAVBGnZqQf7//x9qIgVB////D3E2AgQgAiACKAIIIAlrIAVBGXZqQf7//z9qIgVB////H3E2AgggAiACKAIMIAdrIAVBGnZqQf7//x9qIgVB////D3E2AgwgAiACKAIQIA1rIAVBGXZqQf7//z9qNgIQCyABQbAPaiAOai0AACICBEAgAUHwAmogAUGwE2ogBBCVBSASIAwgBhCVBSAIIAYgBBCVBSAVIAFBsBNqIAwQlQUgASABKAKYAyIFIAEoAvACIgprQdr//z9qIgNB////H3E2ApAWIAEgASgCnAMiCSADQRp2aiABKAL0AiIDa0H+//8faiIHQf///w9xNgKUFiABIAEoAqADIg0gASgC+AIiD2sgB0EZdmpB/v//P2oiB0H///8fcTYCmBYgASABKAKkAyIQIAEoAvwCIhFrIAdBGnZqQf7//x9qIgdB////D3E2ApwWIAEgASgCqAMiEyABKAKAAyIUayAHQRl2akH+//8/ajYCoBYgASABKAKsAyIHIAEoAoQDIhZrQf7//x9qNgKkFiABIAUgCmo2AuAVIAEgAyAJajYC5BUgASANIA9qNgLoFSABIBAgEWo2AuwVIAEgEyAUajYC8BUgASAHIBZqNgL0FSABIAEoAogDIgUgASgCsAMiCmo2AvgVIAEgASgCjAMiAyABKAK0AyIJajYC/BUgASABKAKQAyIHIAEoArgDIg1qNgKAFiABIAEoApQDIg8gASgCvAMiEGo2AoQWIAEgCiAFa0H+//8/ajYCqBYgASAJIANrQf7//x9qNgKsFiABIA0gB2tB/v//P2o2ArAWIAEgECAPa0H+//8fajYCtBYgAUGQFmogAUGQFmogAiACwEEHdSIFcyAFa0H+AXFBAXZB+ABsIgpBgKoxaiIDIAJBB3YiBUEobCICahCVBSABQbATaiABQeAVaiADIAVBAXNBKGxqEJUFIAEgASgCkBYiAyABKAKwEyIJajYC2BMgASABKAKUFiIHIAEoArQTIg1qNgLcEyABIAEoApgWIg8gASgCuBMiEGo2AuATIAEgASgCnBYiESABKAK8EyITajYC5BMgASABKAKgFiIUIAEoAsATIhZqNgLoEyABIAEoAqQWIhcgASgCxBMiGGo2AuwTIAEgGCAXa0H+//8fajYCxBMgASAJIANrQdr//z9qIgNB////H3E2ArATIAEgASgCqBYiCSABKALIEyIXajYC8BMgASABKAKsFiIYIAEoAswTIh1qNgL0EyABIAEoArAWIhkgASgC0BMiGmo2AvgTIAEgASgCtBYiGyABKALUEyIcajYC/BMgASAdIBhrQf7//x9qNgLMEyABIBogGWtB/v//P2o2AtATIAEgHCAba0H+//8fajYC1BMgASAXIAlrQf7//z9qNgLIEyABIA0gA0EadmogB2tB/v//H2oiA0H///8PcTYCtBMgASAQIA9rIANBGXZqQf7//z9qIgNB////H3E2ArgTIAEgEyARayADQRp2akH+//8faiIDQf///w9xNgK8EyABIBYgFGsgA0EZdmpB/v//P2o2AsATIAFBsBVqIBUgCkHQqjFqEJUFIAEgASgCxANBAXQgASgCwANBAXQiCkEadmoiA0H///8PcSIJNgKsFCABIAEoAsgDQQF0IANBGXZqIgNB////H3EiBzYCsBQgASABKALMA0EBdCADQRp2aiIDQf///w9xIg02ArQUIAEgASgC0ANBAXQgA0EZdmoiA0H///8fcSIPNgK4FCABIAEoAtQDQQF0IANBGnZqIgNB////D3EiEDYCvBQgASABKALYA0EBdCADQRl2aiIDQf///x9xIhE2AsAUIAEgASgC3ANBAXQgA0EadmoiA0H///8PcSITNgLEFCABIAEoAuADQQF0IANBGXZqIgNB////H3EiFDYCyBQgASABKALkA0EBdCADQRp2aiIDQf///w9xIhY2AswUIAEgCTYChBQgASAHNgKIFCABIA02AowUIAEgDzYCkBQgASAQNgKUFCABIBE2ApgUIAEgEzYCnBQgASAUNgKgFCABIBY2AqQUIAEgA0EZdkETbCAKQf7//x9xaiIKNgKAFCABIAo2AqgUIAFBsBNqIAJqIgIgASgCsBUiCiACKAJQajYCUCACIAEoArQVIgMgAigCVGo2AlQgAiABKAK4FSIJIAIoAlhqNgJYIAIgASgCvBUiByACKAJcajYCXCACIAEoAsAVIg0gAigCYGo2AmAgAiABKALEFSIPIAIoAmRqNgJkIAIgASgCyBUiECACKAJoajYCaCACIAEoAswVIhEgAigCbGo2AmwgAiABKALQFSITIAIoAnBqNgJwIAIgASgC1BUiFCACKAJ0ajYCdCABQbATaiAFQQNzQShsaiICIAIoAhQgD2tB/v//H2o2AhQgAiACKAIYIBBrQf7//z9qNgIYIAIgAigCHCARa0H+//8fajYCHCACIAIoAiAgE2tB/v//P2o2AiAgAiACKAIkIBRrQf7//x9qNgIkIAIgAigCACAKa0Ha//8/aiIFQf///x9xNgIAIAIgAigCBCADayAFQRp2akH+//8faiIFQf///w9xNgIEIAIgAigCCCAJayAFQRl2akH+//8/aiIFQf///x9xNgIIIAIgAigCDCAHayAFQRp2akH+//8faiIFQf///w9xNgIMIAIgAigCECANayAFQRl2akH+//8/ajYCEAsgAUHwAmogAUGwE2ogBBCVBSASIAwgBhCVBSAIIAYgBBCVBSAOQQBKIQIgDkEBayEOIAINAAsMAQsgDkECayEOIAINAQsLIAFBsA9qIAgQlAUgAUGwBWogAUHwAmogAUGwD2oQlQUgAUGwEWogEiABQbAPahCVBSABQZAEaiABQbARahCWBSABQbATaiABQbAFahCWBSABIAEtAK8EIAEtALATQQd0cyICOgCvBEERQQEgAS0AkAQgCy0AAHMgAS0AkQQgCy0AAXNyIAEtAJIEIAstAAJzciABLQCTBCALLQADc3IgAS0AlAQgCy0ABHNyIAEtAJUEIAstAAVzciABLQCWBCALLQAGc3IgAS0AlwQgCy0AB3NyIAEtAJgEIAstAAhzciABLQCZBCALLQAJc3IgAS0AmgQgCy0ACnNyIAEtAJsEIAstAAtzciABLQCcBCALLQAMc3IgAS0AnQQgCy0ADXNyIAEtAJ4EIAstAA5zciABLQCfBCALLQAPc3IgAS0AoAQgCy0AEHNyIAEtAKEEIAstABFzciABLQCiBCALLQASc3IgAS0AowQgCy0AE3NyIAEtAKQEIAstABRzciABLQClBCALLQAVc3IgAS0ApgQgCy0AFnNyIAEtAKcEIAstABdzciABLQCoBCALLQAYc3IgAS0AqQQgCy0AGXNyIAEtAKoEIAstABpzciABLQCrBCALLQAbc3IgAS0ArAQgCy0AHHNyIAEtAK0EIAstAB1zciABLQCuBCALLQAec3IgAiALLQAfc3JB/wFxQQFrQYACcRsLIQ5BACECDAALIAAoAgwgDjoABCAAIAAoAgxBCGo2AgwMAQtBACEgCyAfEJoBICEQmgEgIBCaASAeBEAgAUHsrik2AgAgAEHghyogARCbASABQcAWaiQAQQEPCyABIAI2AhQgAUHsrik2AhAgAEH8iCogAUEQahBsAAvJBQIRfgh/IAAgASgCCCIUrSILIAEoAgAiF0EBdK0iAn4gASgCBCITQQF0rSIHIBOtIgN+fCABKAIYIhNBE2ytIgggE60iDH58IAEoAhwiFUEmbK0iBCABKAIUIhZBAXStIg1+fCABKAIgIhhBE2ytIgUgASgCECIZQQF0rSIOfnwgASgCJCIaQSZsrSIGIAEoAgwiAUEBdK0iCn58IAggDX4gAiADfnwgBCAZrSIDfnwgBSAKfnwgBiAUQf////8Hca1+fCAWrSIPIBZBJmytfiAXrSIJIAl+fCAIIA5+fCAEIAp+fCAFIBRBAXStIgh+fCAGIAd+fCIQQhqIfCIRQhmIfCIJp0H///8fcTYCCCAAIAGtIg4gAn4gByALfnwgBCAMfnwgBSANfnwgAyAGfnwgCUIaiHwiCadB////D3E2AgwgACAHIAp+IAsgC358IAIgA358IAQgFa0iC358IAUgE0EBdK1+fCAGIA1+fCAJQhmIfCIEp0H///8fcTYCECAAIAMgB34gCCAOfnwgAiAPfnwgBSAVQQF0rSIJfnwgBiAMfnwgBEIaiHwiEqdB////D3E2AhQgACAKIA5+IAMgCH58IAcgDX58IAIgDH58IAUgGK0iBH58IAYgCX58IBJCGYh8IgWnQf///x9xNgIYIAAgCCAPfiADIAp+fCAHIAx+fCACIAt+fCAEIAZ+fCAFQhqIfCIFp0H///8PcTYCHCAAIAggDH4gAyADfnwgCiANfnwgByAJfnwgAiAEfnwgBiAarSIPfnwgBUIZiHwiBqdB////H3E2AiAgACADIA1+IAogDH58IAggC358IAQgB358IAIgD358IAZCGoh8IgKnQf///w9xNgIkIAAgAkIZiEL/////D4NCE34gEEL///8fg3wiAqdB////H3E2AgAgACACQhqIpyARp0H///8PcWo2AgQLkQYCE34JfyABKAIkIRogASgCICEbIAEoAhwhFiABKAIYIRcgASgCFCEYIAEoAhAhHCABKAIMIR0gASgCCCEZIAEoAgQhHiABKAIAIQEDQCAYQQF0rSIKIBdBE2ytIg9+IBytIgQgFkEmbK0iDX58IB1BAXStIgkgG0ETbK0iC358IBpBJmytIgUgGUH/////B3GtfnwgAUEBdK0iBiAerSISfnwgHEEBdK0iEyAPfiAYrSIQIBhBJmytfnwgCSANfnwgGUEBdK0iAyALfnwgHkEBdK0iByAFfnwgAa0iCCAIfnwiFEIaiHwiFadB////D3EgCSAXrSIIfiAEIAp+fCADIBatIhF+fCAHIButIgx+fCAGIBqtIg5+fCAEIAR+IAUgDn58IAkgCn58IAMgCH58IAcgFkEBdK0iDn58IAYgDH58IAQgCX4gBSAMfnwgAyAQfnwgByAIfnwgBiARfnwgBSAOfiALIAx+fCAJIB2tIgx+fCADIAR+fCAHIAp+fCAGIAh+fCAFIAh+IAsgDn58IAMgDH58IAQgB358IAYgEH58IBdBAXStIAt+IA0gEX58IAUgCn58IBmtIgMgA358IAcgCX58IAQgBn58IAogC34gCCANfnwgBCAFfnwgAyAHfnwgBiAMfnwgCiANfiAIIA9+fCALIBN+fCAFIAl+fCAHIBJ+fCADIAZ+fCAVQhmIfCIEQhqIfCIFQhmIfCIGQhqIfCIHQhmIfCIJQhqIfCIKQhmIfCILQhqIfCIIQhmIQv////8Pg0ITfiAUQv///x+DfCIDQhqIp2ohHiAEp0H///8fcSEZIAWnQf///w9xIR0gBqdB////H3EhHCAHp0H///8PcSEYIAmnQf///x9xIRcgCqdB////D3EhFiALp0H///8fcSEbIAinQf///w9xIRogA6dB////H3EhASACQQFrIgINAAsgACAaNgIkIAAgGzYCICAAIBY2AhwgACAXNgIYIAAgGDYCFCAAIBw2AhAgACAdNgIMIAAgGTYCCCAAIB42AgQgACABNgIAC8sBAQF/IwBB4ABrIgEkACABQTBqIABBBRCbBSAAIAFBMGogABCVBSABQTBqIABBChCbBSABIAFBMGogABCVBSABQTBqIAFBFBCbBSABQTBqIAFBMGogARCVBSABQTBqIAFBMGpBChCbBSAAIAFBMGogABCVBSABQTBqIABBMhCbBSABIAFBMGogABCVBSABQTBqIAFB5AAQmwUgAUEwaiABQTBqIAEQlQUgAUEwaiABQTBqQTIQmwUgACABQTBqIAAQlQUgAUHgAGokAAu0CQENfyAAIQMDQCADIgQgASAFQQJ0aigCACIDQQFxOgAAIAQgA0EddkEBcToAHSAEIANBHHZBAXE6ABwgBCADQRt2QQFxOgAbIAQgA0EadkEBcToAGiAEIANBGXZBAXE6ABkgBCADQRh2QQFxOgAYIAQgA0EXdkEBcToAFyAEIANBFnZBAXE6ABYgBCADQRV2QQFxOgAVIAQgA0EUdkEBcToAFCAEIANBE3ZBAXE6ABMgBCADQRJ2QQFxOgASIAQgA0ERdkEBcToAESAEIANBEHZBAXE6ABAgBCADQQ92QQFxOgAPIAQgA0EOdkEBcToADiAEIANBDXZBAXE6AA0gBCADQQx2QQFxOgAMIAQgA0ELdkEBcToACyAEIANBCnZBAXE6AAogBCADQQl2QQFxOgAJIAQgA0EIdkEBcToACCAEIANBgAFxQQd2OgAHIAQgA0EGdkEBcToABiAEIANBBXZBAXE6AAUgBCADQQR2QQFxOgAEIAQgA0EDdkEBcToAAyAEIANBAnZBAXE6AAIgBCADQQF2QQFxOgABIARBHmohAyAFQQFqIgVBCEcNAAsgBCABKAIgIgNBAXE6AB4gBCADQQ92QQFxOgAtIAQgA0EOdkEBcToALCAEIANBDXZBAXE6ACsgBCADQQx2QQFxOgAqIAQgA0ELdkEBcToAKSAEIANBCnZBAXE6ACggBCADQQl2QQFxOgAnIAQgA0EIdkEBcToAJiAEIANBgAFxQQd2OgAlIAQgA0EGdkEBcToAJCAEIANBBXZBAXE6ACMgBCADQQR2QQFxOgAiIAQgA0EDdkEBcToAISAEIANBAnZBAXE6ACAgBCADQQF2QQFxOgAfQX8gAkEBa3QiCkF/cyELA0ACQAJAIAAgBmoiAS0AACIFRQ0AIAZB/wFGDQFBB0GAAiAGayIEIARBB08bIQwgACAGQQZqIg5qIQ9BASEDA0ACQAJAIAsgACADIAZqIgRqIgIsAAAiCCADdCIJIAXAIgdqIg1OBEAgAyEFDAELAkAgCiAHIAlrIgJIBEAgAyEFDAELIAgNBCADQQFqIgUgDE8NBCAAIAUgBmoiBGoiAiwAACIIIAV0IgkgB2oiDSALTA0BIAcgCWsiAiAKSg0AIAgNBCADQQJqIgUgDE8NBCAAIAUgBmoiBGoiAiwAACIIIAV0IgkgB2oiDSALTA0BIAcgCWsiAiAKSg0AIAgNBCADQQNqIgUgDE8NBCAAIAUgBmoiBGoiAiwAACIIIAV0IgkgB2oiDSALTA0BIAcgCWsiAiAKSg0AIAgNBCADQQRqIgUgDE8NBCAAIAUgBmoiBGoiAiwAACIIIAV0IgkgB2oiDSALTA0BIAcgCWsiAiAKSg0AIAgNBCADQQVqIAxPDQRBBiEFIA8iAiwAAEEGdCIDIAdqIg0gC0wNASAOIQQgByADayICIApMDQQLIAEgAjoAACAEQf8BSw0BA0AgACAEaiIDLQAARQRAIANBAToAAAwDCyADQQA6AAAgBEEBaiIEQYACRw0ACwwBCyABIA06AAAgAkEAOgAACyAFQQFqIgMgDE8NASABLQAAIQUMAAsACyAGQQFqIgZBgAJHDQELCwuvDAEnfyMAQZABayICJAAgAkHgAGogARCaBSACQTBqIAFBKGoQmgUgAiABQdAAahCaBSACKAIkIQQgAigCICEFIAIoAhwhBiACKAIYIQcgAigCFCEIIAIoAhAhCSACKAIMIQogAigCCCELIAIoAgAhDCACKAIEIRIgACABKAIoIAEoAgBqNgIAIAAgASgCLCABKAIEajYCBCAAIAEoAjAgASgCCGo2AgggACABKAI0IAEoAgxqNgIMIAAgASgCOCABKAIQajYCECAAIAEoAjwgASgCFGo2AhQgACABKAJAIAEoAhhqNgIYIAAgASgCRCABKAIcajYCHCAAIAEoAkggASgCIGo2AiAgACABKAJMIAEoAiRqNgIkIAAgABCaBSAAIAIoAmAiDSACKAIwIg5qIgM2AiggACACKAJkIg8gAigCNCIQaiIZNgIsIAAgAigCaCITIAIoAjgiFGoiGjYCMCAAIAIoAmwiGyACKAI8IhxqIh02AjQgACACKAJwIh4gAigCQCIfaiIgNgI4IAAgAigCdCIVIAIoAkQiIWoiIjYCPCAAIAIoAngiFiACKAJIIiNqIiQ2AkAgACACKAJ8IhcgAigCTCIlaiImNgJEIAAgAigCgAEiGCACKAJQIidqIig2AkggAigChAEhASACKAJUIREgACAnIBhrQf7//z9qIhg2AnAgACAlIBdrQf7//x9qIhc2AmwgACAjIBZrQf7//z9qIhY2AmggACAhIBVrQf7//x9qIhU2AmQgACAfIB5rIBwgG2sgFCATayAQIA4gDWtB2v//P2oiDUEadmogD2tB/v//H2oiDkEZdmpB/v//P2oiD0EadmpB/v//H2oiEEEZdmpB/v//P2oiEzYCYCAAIBBB////D3EiEDYCXCAAIA9B////H3EiDzYCWCAAIA5B////D3EiDjYCVCAAIA1B////H3EiDTYCUCAAIAEgEWoiFDYCTCAAIBEgAWtB/v//H2oiATYCdCAAIAAoAgQgGWsgACgCACADa0G0////AGoiEUEadmpB/P//P2oiA0H///8PcTYCBCAAIAAoAgggGmsgA0EZdmpB/P///wBqIgNB////H3E2AgggACAAKAIMIB1rIANBGnZqQfz//z9qIgNB////D3E2AgwgACAAKAIQICBrIANBGXZqQfz///8AaiIDQf///x9xNgIQIAAgACgCFCAiayADQRp2akH8//8/aiIDQf///w9xNgIUIAAgACgCGCAkayADQRl2akH8////AGoiA0H///8fcTYCGCAAIAAoAhwgJmsgA0EadmpB/P//P2oiA0H///8PcTYCHCAAIAAoAiAgKGsgA0EZdmpB/P///wBqIgNB////H3E2AiAgACAAKAIkIBRrIANBGnZqQfz//z9qIgNB////D3E2AiQgACAEQQF0IAVBAXQgBkEBdCAHQQF0IAhBAXQgCUEBdCAKQQF0IAtBAXQgEkEBdCAMQQF0IgRBGnZqIgVBGXZqIgZBGnZqIgdBGXZqIghBGnZqIglBGXZqIgpBGnZqIgtBGXZqIgxBGnZqIhJB////D3EgAWsgDEH///8fcSAYayALQf///w9xIBdrIApB////H3EgFmsgCUH///8PcSAVayAIQf///x9xIBNrIAdB////D3EgEGsgBkH///8fcSAPayAFQf///w9xIBJBGXZBE2wgBEH+//8fcWogDWtBtP///wBqIgFBGnZqIA5rQfz//z9qIgRBGXZqQfz///8AaiIFQRp2akH8//8/aiIGQRl2akH8////AGoiB0EadmpB/P//P2oiCEEZdmpB/P///wBqIglBGnZqQfz//z9qIgpBGXZqQfz///8AaiILQRp2akH8//8/aiIMQf///w9xNgKcASAAIAtB////H3E2ApgBIAAgCkH///8PcTYClAEgACAJQf///x9xNgKQASAAIAhB////D3E2AowBIAAgB0H///8fcTYCiAEgACAGQf///w9xNgKEASAAIAVB////H3E2AoABIAAgBEH///8PcTYCfCAAIANBGXZBE2wgEUH///8fcWo2AgAgACAMQRl2QRNsIAFB////H3FqNgJ4IAJBkAFqJAALxgMBBH8jAEEQayIEJAACQEGkiDQoAgAiAgRAAn8CQCACKAIUQQRJDQAgAigCBCIDRQ0AIAIoAhgiBSAFKAIQQQFqNgIQIAIgAigCHEEBajYCHCACIAIoAiBBBGo2AiAgAiACKAIsQQRqNgIsIAIgAygCADYCBEF/IQVBCAwBC0EEECoiA0UEQBBPCyACIAIoAiRBAWo2AiRBBCEFIAIgAigCKEEEajYCKEEsCyACaiICIAIoAgAgBWo2AgAMAQtBBBAqIQMLAkAgA0UEQEEAIQIMAQsgACABQbvqKRDcASICBEAgAyACKgIAOAIAIAMhAgwBCyAAIAEQyAEiAUUEQCADIQIMAQsgAyABKAIIIARBCGoQoAU4AgACQCAEKAIILQAARQRAIAMhAgwBC0EAIQJBpIg0KAIAIgAEQCAEIAM2AgwCQCAAKAIAIgIgBCgCDEsNACAEKAIMIAIgACgCEGpPDQAgAyAAKAIENgIAIAAgAzYCBCAAIAAoAghBAWo2AghBACECIAAoAhQiAEEESQ0CIABBfHEiAEUNAiADQQAgAPwLAAwCCyADECtBACECDAELIAMQKwsgARCaAQsgBEEQaiQAIAILsDYEEn8HfgF8AXsjAEEQayISJAAjAEGgAWsiCyQAIAsgADYCPCALIAA2AhQgC0F/NgIYIAtBEGoQ5AwgC0EQaiEEIwBBMGsiDyQAA0ACfyAEKAIEIgMgBCgCaEcEQCAEIANBAWo2AgQgAy0AAAwBCyAEEOUMCyIDEOYMDQALQQEhCAJAAkAgA0Eraw4DAAEAAQtBf0EBIANBLUYbIQggBCgCBCIDIAQoAmhHBEAgBCADQQFqNgIEIAMtAAAhAwwBCyAEEOUMIQMLAkACQAJAAkACQCADQV9xIgVBzgBGBEADQCAHQQJGDQMCfyAEKAIEIgMgBCgCaEcEQCAEIANBAWo2AgQgAy0AAAwBCyAEEOUMCyEDIAdBtcAqaiEFIAdBAWohByAFLAAAIANBIHJGDQALDAELIAVByQBHDQMCQANAIAciBUEHRg0BAn8gBCgCBCIDIAQoAmhHBEAgBCADQQFqNgIEIAMtAAAMAQsgBBDlDAshAyAFQQFqIQcgBUHzpylqLAAAIANBIHJGDQALAkAgBUECRgRAQQMhBwwBCyAFQQdGDQEgBUEDSQ0CIAdBCEYNAQsgBCkDcCIUQgBZBEAgBCAEKAIEQQFrNgIECyAHQQRJDQAgFEIAUyEDA0AgA0UEQCAEIAQoAgRBAWs2AgQLIAdBAWsiB0EDSw0ACwsgD0EgaiEHQgAhFCMAQRBrIgMkACAIskMAAIB/lLwiCEH///8DcSEEAn8gCEEXdiIFQf8BcSIGBEAgBkH/AUcEQCAErUIZhiEUIAVB/wFxQYD/AGoMAgsgBK1CGYYhFEH//wEMAQtBACAERQ0AGiADIAStQgAgBGciBEHRAGoQMiADKQMIQoCAgICAgMAAhSEUIAMpAwAhFUGJ/wAgBGsLIQQgByAVNwMAIAcgBK1CMIYgCEEfdq1CP4aEIBSENwMIIANBEGokACAPKQMoIRUgDykDICEUDAQLIAcOBAIBAQABCwJAAn8gBCgCBCIDIAQoAmhHBEAgBCADQQFqNgIEIAMtAAAMAQsgBBDlDAtBKEYEQEEBIQcMAQtCgICAgICA4P//ACEVIAQpA3BCAFMNAyAEIAQoAgRBAWs2AgQMAwsDQAJ/IAQoAgQiAyAEKAJoRwRAIAQgA0EBajYCBCADLQAADAELIAQQ5QwLIgNBwQBrIQUCQAJAIANBMGtBCkkNACAFQRpJDQAgA0HhAGshBSADQd8ARg0AIAVBGk8NAQsgB0EBaiEHDAELC0KAgICAgIDg//8AIRUgA0EpRg0CIAQpA3AiF0IAWQRAIAQgBCgCBEEBazYCBAsgB0UNAgNAIBdCAFkEQCAEIAQoAgRBAWs2AgQLIAdBAWsiBw0ACwwCCyAEKQNwQgBZBEAgBCAEKAIEQQFrNgIEC0HQ+zNBHDYCACAEEOQMDAELAkAgA0EwRw0AAn8gBCgCBCIHIAQoAmhHBEAgBCAHQQFqNgIEIActAAAMAQsgBBDlDAtBX3FB2ABGBEAjAEGwA2siBSQAAn8gBCgCBCIDIAQoAmhHBEAgBCADQQFqNgIEIAMtAAAMAQsgBBDlDAshAwJAAn8DQAJAIANBMEcEQCADQS5HDQQgBCgCBCIDIAQoAmhGDQEgBCADQQFqNgIEIAMtAAAMAwsgBCgCBCIDIAQoAmhHBEBBASEMIAQgA0EBajYCBCADLQAAIQMMAgVBASEMIAQQ5QwhAwwCCwALCyAEEOUMCyIDQTBHBEBBASEJDAELA0AgF0IBfSEXAn8gBCgCBCIDIAQoAmhHBEAgBCADQQFqNgIEIAMtAAAMAQsgBBDlDAsiA0EwRg0AC0EBIQlBASEMC0KAgICAgIDA/z8hFQJAA0ACQCADIQcCQAJAIANBMGsiAkEKSQ0AIANBLkcgA0EgciIHQeEAa0EFS3ENBCADQS5HDQAgCQ0CQQEhCSAUIRcMAQsgB0HXAGsgAiADQTlKGyEDAkAgFEIHVwRAIAMgBkEEdGohBgwBCyAUQhxYBEAgBUEwaiADEEsgBUEgaiAZIBVCAEKAgICAgIDA/T8QNSAFQRBqIAUpAzAgBSkDOCAFKQMgIhkgBSkDKCIVEDUgBSAFKQMQIAUpAxggFiAYED4gBSkDCCEYIAUpAwAhFgwBCyADRQ0AIA0NACAFQdAAaiAZIBVCAEKAgICAgICA/z8QNSAFQUBrIAUpA1AgBSkDWCAWIBgQPkEBIQ0gBSkDSCEYIAUpA0AhFgsgFEIBfCEUQQEhDAsgBCgCBCIDIAQoAmhHBEAgBCADQQFqNgIEIAMtAAAhAwwCBSAEEOUMIQMMAgsACwtBLiEDCwJ+IAxFBEACQCAEKQNwQgBTDQAgBCAEKAIEIgNBAms2AgQgCUUNACAEIANBA2s2AgQLIAVB4ABqRAAAAAAAAAAAIAi3phBMIAUpA2AhFiAFKQNoDAELIBRCB1cEQCAUIRUDQCAGQQR0IQYgFUIBfCIVQghSDQALCwJAAkACQCADQV9xQdAARgRAIAQQ5wwiFUKAgICAgICAgIB/Ug0DIAQpA3BCAFkNAQwCC0IAIRUgBCkDcEIAUw0CCyAEIAQoAgRBAWs2AgQLQgAhFQsgBkUEQCAFQfAAakQAAAAAAAAAACAIt6YQTCAFKQNwIRYgBSkDeAwBCyAXIBQgCRtCAoYgFXxCIH0iFEKWAVkEQEHQ+zNBxAA2AgAgBUGgAWogCBBLIAVBkAFqIAUpA6ABIAUpA6gBQn9C////////v///ABA1IAVBgAFqIAUpA5ABIAUpA5gBQn9C////////v///ABA1IAUpA4ABIRYgBSkDiAEMAQsgFEKJfVkEQCAGQQBOBEADQCAFQaADaiAWIBhCAEKAgICAgIDA/79/ED4gFiAYQoCAgICAgID/PxAxIQMgBUGQA2ogFiAYIAUpA6ADIBYgA0EATiIDGyAFKQOoAyAYIAMbED4gBkEBdCIEIANyIQYgFEIBfSEUIAUpA5gDIRggBSkDkAMhFiAEQQBODQALCwJ+QRggFEK1AXwiF6ciA0EAIANBAEobIBdCGFkbIgNB8QBPBEAgBUGAA2ogCBBLIAUpA4gDIRUgBSkDgAMhGUIADAELIAVB4AJqRAAAAAAAAPA/QZABIANrECgQTCAFQdACaiAIEEsgBSkD0AIhGSAFQfACaiAFKQPgAiAFKQPoAiAFKQPYAiIVEOgMIAUpA/gCIRogBSkD8AILIRcgBUHAAmogBiAGQQFxRSAWIBhCAEIAEDBBAEcgA0EgSXFxIgNyEE0gBUGwAmogGSAVIAUpA8ACIAUpA8gCEDUgBUGQAmogBSkDsAIgBSkDuAIgFyAaED4gBUGgAmogGSAVQgAgFiADG0IAIBggAxsQNSAFQYACaiAFKQOgAiAFKQOoAiAFKQOQAiAFKQOYAhA+IAVB8AFqIAUpA4ACIAUpA4gCIBcgGhA/IAUpA/ABIhYgBSkD+AEiGEIAQgAQMEUEQEHQ+zNBxAA2AgALIAVB4AFqIBYgGCAUpxDpDCAFKQPgASEWIAUpA+gBDAELQdD7M0HEADYCACAFQdABaiAIEEsgBUHAAWogBSkD0AEgBSkD2AFCAEKAgICAgIDAABA1IAVBsAFqIAUpA8ABIAUpA8gBQgBCgICAgICAwAAQNSAFKQOwASEWIAUpA7gBCyEUIA8gFjcDACAPIBQ3AwggBUGwA2okACAPKQMIIRUgDykDACEUDAILIAQpA3BCAFMNACAEIAQoAgRBAWs2AgQLIA9BEGohEyAEIQYgCCENQQAhByMAQZDGAGsiAiQAAkACfwNAAkAgA0EwRwRAIANBLkcNBCAGKAIEIgMgBigCaEYNASAGIANBAWo2AgQgAy0AAAwDCyAGKAIEIgMgBigCaEcEQEEBIQcgBiADQQFqNgIEIAMtAAAhAwwCBUEBIQcgBhDlDCEDDAILAAsLIAYQ5QwLIgNBMEYEQANAIBRCAX0hFAJ/IAYoAgQiAyAGKAJoRwRAIAYgA0EBajYCBCADLQAADAELIAYQ5QwLIgNBMEYNAAtBASEHC0EBIQ4LIAJBADYCkAYgA0EwayEIIBMCfgJAAkACQAJAAkAgA0EuRiIEDQAgCEEJTQ0ADAELA0ACQCAEQQFxBEAgDkUEQCAVIRRBASEODAILIAdFIQQMBAsgFUIBfCEVIAlB/A9MBEAgDCAVpyADQTBGGyEMIAJBkAZqIAlBAnRqIgQgCgR/IAMgBCgCAEEKbGpBMGsFIAgLNgIAQQEhB0EAIApBAWoiAyADQQlGIgMbIQogAyAJaiEJDAELIANBMEYNACACIAIoAoBGQQFyNgKARkHcjwEhDAsCfyAGKAIEIgMgBigCaEcEQCAGIANBAWo2AgQgAy0AAAwBCyAGEOUMCyIDQTBrIQggA0EuRiIEDQAgCEEKSQ0ACwsgFCAVIA4bIRQCQCAHRQ0AIANBX3FBxQBHDQACQCAGEOcMIhdCgICAgICAgICAf1INAEIAIRcgBikDcEIAUw0AIAYgBigCBEEBazYCBAsgFCAXfCEUDAMLIAdFIQQgA0EASA0BCyAGKQNwQgBTDQAgBiAGKAIEQQFrNgIECyAERQ0AQdD7M0EcNgIAIAYQ5AxCACEVQgAMAQsgAigCkAYiBkUEQCACRAAAAAAAAAAAIA23phBMIAIpAwAhFSACKQMIDAELAkAgFUIJVQ0AIBQgFVINACAGQf///wdLDQAgAkEwaiANEEsgAkEgaiAGEE0gAkEQaiACKQMwIAIpAzggAikDICACKQMoEDUgAikDECEVIAIpAxgMAQsgFELLAFkEQEHQ+zNBxAA2AgAgAkHgAGogDRBLIAJB0ABqIAIpA2AgAikDaEJ/Qv///////7///wAQNSACQUBrIAIpA1AgAikDWEJ/Qv///////7///wAQNSACKQNAIRUgAikDSAwBCyAUQoh9VwRAQdD7M0HEADYCACACQZABaiANEEsgAkGAAWogAikDkAEgAikDmAFCAEKAgICAgIDAABA1IAJB8ABqIAIpA4ABIAIpA4gBQgBCgICAgICAwAAQNSACKQNwIRUgAikDeAwBCyAKBEAgCkEITARAIAJBkAZqIAlBAnRqIgMoAgAhBgNAIAZBCmwhBiAKQQFqIgpBCUcNAAsgAyAGNgIACyAJQQFqIQkLIBSnIQoCQCAMQQlODQAgFEIRVQ0AIAogDEgNACAUQglRBEAgAkHAAWogDRBLIAJBsAFqIAIoApAGEE0gAkGgAWogAikDwAEgAikDyAEgAikDsAEgAikDuAEQNSACKQOgASEVIAIpA6gBDAILIBRCCFcEQCACQZACaiANEEsgAkGAAmogAigCkAYQTSACQfABaiACKQOQAiACKQOYAiACKQOAAiACKQOIAhA1IAJB4AFqQQAgCmtBAnRBgKoyaigCABBLIAJB0AFqIAIpA/ABIAIpA/gBIAIpA+ABIAIpA+gBEDMgAikD0AEhFSACKQPYAQwCCyACKAKQBiIGIApBfWxBM2p2DQAgAkHgAmogDRBLIAJB0AJqIAYQTSACQcACaiACKQPgAiACKQPoAiACKQPQAiACKQPYAhA1IAJBsAJqIApBAnRBuKkyaigCABBLIAJBoAJqIAIpA8ACIAIpA8gCIAIpA7ACIAIpA7gCEDUgAikDoAIhFSACKQOoAgwBCwNAIAJBkAZqIAkiBEEBayIJQQJ0aigCAEUNAAtBACEMAkAgCkEJbyIGRQRAQQAhCAwBCyAGQQlqIAYgFEIAUxshEAJAIARFBEBBACEIQQAhBAwBC0GAlOvcA0EAIBBrQQJ0QYCqMmooAgAiB20hEUEAIQNBACEGQQAhCANAIAJBkAZqIAZBAnRqIgkgCSgCACIJIAduIg4gA2oiAzYCACAIQQFqQf8PcSAIIANFIAYgCEZxIgMbIQggCkEJayAKIAMbIQogESAJIAcgDmxrbCEDIAZBAWoiBiAERw0ACyADRQ0AIAJBkAZqIARBAnRqIAM2AgAgBEEBaiEECyAKIBBrQQlqIQoLA0AgAkGQBmogCEECdGohECAKQSRIIRECQANAAkAgEQ0AIApBJEcNAiAQKAIAQdDp+QRNDQBBJCEKDAILIARB/w9qIQlBACEHA0AgBCEDIAetIAJBkAZqIAlB/w9xIgZBAnRqIgQ1AgBCHYZ8IhRCgZTr3ANUBH9BAAUgFEKAlOvcA4AiFUKA7JSjfH4gFHwhFCAVpwshByAEIBQ+AgAgAyADIAYgAyAUUBsgBiAIRhsgBiADQQFrQf8PcSIORxshBCAGQQFrIQkgBiAIRw0ACyAMQR1rIQwgAyEEIAdFDQALIAhBAWtB/w9xIgggBEYEQCACQZAGaiAEQf4PakH/D3FBAnRqIgYgBigCACACQZAGaiAOQQJ0aigCAHI2AgAgDiEECyAKQQlqIQogAkGQBmogCEECdGogBzYCAAwBCwsCQANAIARBAWpB/w9xIQUgAkGQBmogBEEBa0H/D3FBAnRqIRADQEEJQQEgCkEtShshCSAKQSRHIQ4CQANAIAghB0EAIQYCQANAAkAgBiAHakH/D3EiAyAERg0AIAJBkAZqIANBAnRqKAIAIgMgBkECdEHQqTJqKAIAIghJDQAgAyAISw0CIAZBAWoiBkEERw0BCwsgDg0AQQAhBkIAIRRCACEVA0AgBCAGIAdqQf8PcSIDRgRAIARBAWpB/w9xIgRBAnQgAmpBADYCjAYLIAJBgAZqIAJBkAZqIANBAnRqKAIAEE0gAkHwBWogFCAVQgBCgICAgOWat47AABA1IAJB4AVqIAIpA/AFIAIpA/gFIAIpA4AGIAIpA4gGED4gAikD6AUhFSACKQPgBSEUIAZBAWoiBkEERw0ACyACQdAFaiANEEsgAkHABWogFCAVIAIpA9AFIAIpA9gFEDVCACEUIAIpA8gFIRUgAikDwAUhF0EYIAxBhgJqIgNBACADQQBKGyAMQZJ+ThsiBkHwAE0NAgwFCyAJIAxqIQwgBCEIIAQgB0YNAAtBgJTr3AMgCXYhDkF/IAl0QX9zIRFBACEGIAchCANAIAJBkAZqIAdBAnRqIgMgAygCACIDIAl2IAZqIgY2AgAgCEEBakH/D3EgCCAGRSAHIAhGcSIGGyEIIApBCWsgCiAGGyEKIAMgEXEgDmwhBiAHQQFqQf8PcSIHIARHDQALIAZFDQEgBSAIRwRAIAJBkAZqIARBAnRqIAY2AgAgBSEEDAMLIBAgECgCAEEBcjYCAAwBCwsLIAJBkAVqRAAAAAAAAPA/QeEBIAZrECgQTCACQbAFaiACKQOQBSACKQOYBSAVEOgMIAIpA7gFIRkgAikDsAUhGCACQYAFakQAAAAAAADwP0HxACAGaxAoEEwgAkGgBWogFyAVIAIpA4AFIAIpA4gFECkgAkHwBGogFyAVIAIpA6AFIhQgAikDqAUiFhA/IAJB4ARqIBggGSACKQPwBCACKQP4BBA+IAIpA+gEIRUgAikD4AQhFwsgDEHxAGohCAJAIAdBBGpB/w9xIgkgBEYNAAJAIAJBkAZqIAlBAnRqKAIAIglB/8m17gFNBEAgCUUEQCAHQQVqQf8PcSAERg0CCyACQfADaiANt0QAAAAAAADQP6IQTCACQeADaiAUIBYgAikD8AMgAikD+AMQPiACKQPoAyEWIAIpA+ADIRQMAQsgCUGAyrXuAUcEQCACQdAEaiANt0QAAAAAAADoP6IQTCACQcAEaiAUIBYgAikD0AQgAikD2AQQPiACKQPIBCEWIAIpA8AEIRQMAQsgDbchGyAEIAdBBWpB/w9xRgRAIAJBkARqIBtEAAAAAAAA4D+iEEwgAkGABGogFCAWIAIpA5AEIAIpA5gEED4gAikDiAQhFiACKQOABCEUDAELIAJBsARqIBtEAAAAAAAA6D+iEEwgAkGgBGogFCAWIAIpA7AEIAIpA7gEED4gAikDqAQhFiACKQOgBCEUCyAGQe8ASw0AIAJB0ANqIBQgFkIAQoCAgICAgMD/PxApIAIpA9ADIAIpA9gDQgBCABAwDQAgAkHAA2ogFCAWQgBCgICAgICAwP8/ED4gAikDyAMhFiACKQPAAyEUCyACQbADaiAXIBUgFCAWED4gAkGgA2ogAikDsAMgAikDuAMgGCAZED8gAikDqAMhFSACKQOgAyEXAkAgCEH8////B3FB/ABJBEAgDCEEDAELIAJBkANqIgQgFUL///////////8AgzcDCCAEIBc3AwAgAkGAA2ogFyAVQgBCgICAgICAgP8/EDUgAikDkAMgAikDmANCgICAgICAgLjAABAxIQggAikDiAMgFSAIQQBOIgQbIRUgAikDgAMgFyAEGyEXIBQgFkIAQgAQMCEHIAQgDGoiBEEPTARAIAMgBkcgCEEASHIgDEGSfkhxIAdBAEdxRQ0BC0HQ+zNBxAA2AgALIAJB8AJqIBcgFSAEEOkMIAIpA/ACIRUgAikD+AILNwMIIBMgFTcDACACQZDGAGokACAPKQMYIRUgDykDECEUCyALIBQ3AwAgCyAVNwMIIA9BMGokACAL/QADACEcIAEgCygCiAEgACALKAIUIAsoAjxramo2AgAgEiAc/QsDACALQaABaiQAIBIpAwAhFSASKQMIIRdBACEAIwBBIGsiCyQAIBdC////////P4MhFAJAIBdCMIhC//8BgyIWpyIBQYH/AGtB/QFNBEAgFEIZiKchAAJAIBVQIBdC////D4MiFEKAgIAIVCAUQoCAgAhRG0UEQCAAQQFqIQAMAQsgFSAUQoCAgAiFhEIAUg0AIABBAXEgAGohAAtBACAAIABB////A0siBBshAEGBgX9BgIF/IAQbIAFqIQEMAQsCQCAUIBWEUA0AIBZC//8BUg0AIBRCGYinQYCAgAJyIQBB/wEhAQwBCyABQf6AAUsEQEH/ASEBDAELQYD/AEGB/wAgFlAiBBsiByABayIAQfAASgRAQQAhAEEAIQEMAQsgC0EQaiAVIBQgFEKAgICAgIDAAIQgBBsiFEGAASAAaxAyIAsgFSAUIAAQNCALKQMIIhVCGYinIQACQCALKQMAIAEgB0cgCykDECALKQMYhEIAUnGthCIUUCAVQv///w+DIhVCgICACFQgFUKAgIAIURtFBEAgAEEBaiEADAELIBQgFUKAgIAIhYRCAFINACAAQQFxIABqIQALIABBgICABHMgACAAQf///wNLIgEbIQALIAtBIGokACASQRBqJAAgF0IgiKdBgICAgHhxIAFBF3RyIAByvgu8AwEHfyMAQTBrIgMkACADQbzhKTYCICAAQfmGKiADQSBqEJsBAkACQCAAQQEQnwUiBUUEQEG5yykhBAwBCwJAIAAgBSoCABDeASIHRQRAQejkKSEEDAELIAAgBygCACIEEIYBIgFFBEBBACEEIABB6dsrQQAQbgwBCyABKAIEIgZBAEoEQANAIAEoAgggAmpBADoAACACQQFqIgIgASgCBCIGSA0ACwsgASAEIAYgBCAGSBsiAjYCACACQQBMBEBBACEEDAELIAcoAgghBkEAIQRBACECA0AgASgCCCACaiACIAZqLQAAOgAAIAJBAWoiAiABKAIASA0ACwsCQAJAQaSINCgCACIBRQ0AIAMgBTYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBSABKAIENgIAIAEgBTYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIAVBACAB/AsADAELIAUQKwsgBxCaASAHDQELIAMgBDYCBCADQbzhKTYCACAAQfyIKiADEGwACyADQbzhKTYCECAAQeCHKiADQRBqEJsBIANBMGokAEEBC8ADAgZ/AX0jAEHQCGsiAiQAIAJB2OoqNgIwIABB+YYqIAJBMGoQmwECQAJAIAIgAEEBEJ8FIgMEfyACIAMqAgAiB7s5AyACQAJAAkAgAkFAa0GACEH5qCtBhPcqIAdDACR0SV4iBBsgAkEgahCmBCIBQf8HTQRAIAQNASABRQ0BA0ACQCABQQJrIAFBAWsiBCAEIAJBQGtqLQAAIgVBLkYiBhshBEF/IAEgBUEwRhsgBmsiBUEATg0AIAQiAUEASg0BCwsgBUEASgRAIAJBQGsgBWpBADoAAAsgBEF+Sg0BC0GkiDQoAgAiAUUNASABIAMQUAwCCyAAIAJBQGsQWEGkiDQoAgAiAUUNAyACIAM2AswIIAEoAgAiBCACKALMCEsNAyACKALMCCAEIAEoAhBqTw0DIAMgASgCBDYCACABIAM2AgQgASABKAIIQQFqNgIIIAEoAhQiAUEESQ0EIAFBfHEiAUUNBCADQQAgAfwLAAwECyADECsLQaHxKgVByeopCzYCBCACQdjqKjYCACAAQfyIKiACEGwACyADECsLIAJB2OoqNgIQIABB4IcqIAJBEGoQmwEgAkHQCGokAEEBC+IDAQV/IwBBMGsiAyQAIANBuaMqNgIgIABB+YYqIANBIGoQmwEgAEEBEJ8FIQEgAEECEJ8FIQQCQAJAAkACQCABRQ0AIARFDQAgACgCDEERQQEgASoCACAEKgIAk4u7RI3ttaD3xrA+Yxs6AAQgACAAKAIMQQhqNgIMQaSINCgCACICRQ0BIAMgATYCLAJAAkAgAigCACIFIAMoAixLDQAgAygCLCAFIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiBUEESQ0BIAVBfHEiBUUNASABQQAgBfwLAAwBCyABECsLIAMgBDYCLCACKAIAIgEgAygCLEsNAiADKAIsIAEgAigCEGpPDQIgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCIBQQRJDQMgAUF8cSIBRQ0DIARBACAB/AsADAMLAkAgAUUNAEGkiDQoAgAiAgRAIAIgARBQDAELIAEQKwsCQCAERQ0AQaSINCgCACIBBEAgASAEEFAMAQsgBBArCyADQe2cKjYCFCADQbmjKjYCECAAQfyIKiADQRBqEGwACyABECsLIAQQKwsgA0G5oyo2AgAgAEHghyogAxCbASADQTBqJABBAQvWAwEFfyMAQTBrIgMkACADQb7cKTYCICAAQfmGKiADQSBqEJsBIABBARCfBSEBIABBAhCfBSEEAkACQAJAAkAgAUUNACAERQ0AIAAoAgxBEUEBIAEqAgAgBCoCAF0bOgAEIAAgACgCDEEIajYCDEGkiDQoAgAiAkUNASADIAE2AiwCQAJAIAIoAgAiBSADKAIsSw0AIAMoAiwgBSACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgVBBEkNASAFQXxxIgVFDQEgAUEAIAX8CwAMAQsgARArCyADIAQ2AiwgAigCACIBIAMoAixLDQIgAygCLCABIAIoAhBqTw0CIAQgAigCBDYCACACIAQ2AgQgAiACKAIIQQFqNgIIIAIoAhQiAUEESQ0DIAFBfHEiAUUNAyAEQQAgAfwLAAwDCwJAIAFFDQBBpIg0KAIAIgIEQCACIAEQUAwBCyABECsLAkAgBEUNAEGkiDQoAgAiAQRAIAEgBBBQDAELIAQQKwsgA0HtnCo2AhQgA0G+3Ck2AhAgAEH8iCogA0EQahBsAAsgARArCyAEECsLIANBvtwpNgIAIABB4IcqIAMQmwEgA0EwaiQAQQEL1gMBBX8jAEEwayIDJAAgA0Hd/io2AiAgAEH5hiogA0EgahCbASAAQQEQnwUhASAAQQIQnwUhBAJAAkACQAJAIAFFDQAgBEUNACAAKAIMQRFBASABKgIAIAQqAgBfGzoABCAAIAAoAgxBCGo2AgxBpIg0KAIAIgJFDQEgAyABNgIsAkACQCACKAIAIgUgAygCLEsNACADKAIsIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCIFQQRJDQEgBUF8cSIFRQ0BIAFBACAF/AsADAELIAEQKwsgAyAENgIsIAIoAgAiASADKAIsSw0CIAMoAiwgASACKAIQak8NAiAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgFBBEkNAyABQXxxIgFFDQMgBEEAIAH8CwAMAwsCQCABRQ0AQaSINCgCACICBEAgAiABEFAMAQsgARArCwJAIARFDQBBpIg0KAIAIgEEQCABIAQQUAwBCyAEECsLIANB7ZwqNgIUIANB3f4qNgIQIABB/IgqIANBEGoQbAALIAEQKwsgBBArCyADQd3+KjYCACAAQeCHKiADEJsBIANBMGokAEEBC+cDAQV/IwBBMGsiAyQAIANB1L8rNgIgIABB+YYqIANBIGoQmwEgAEEBEJ8FIQEgAEECEJ8FIQQgAEEEQQEQ2gEiAkEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbAQJAAkACQAJAIAFFDQAgBEUNACACIAEqAgAgBCoCAJI4AgBBpIg0KAIAIgJFDQEgAyABNgIsAkACQCACKAIAIgUgAygCLEsNACADKAIsIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCIFQQRJDQEgBUF8cSIFRQ0BIAFBACAF/AsADAELIAEQKwsgAyAENgIsIAIoAgAiASADKAIsSw0CIAMoAiwgASACKAIQak8NAiAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgFBBEkNAyABQXxxIgFFDQMgBEEAIAH8CwAMAwsCQCABRQ0AQaSINCgCACICBEAgAiABEFAMAQsgARArCwJAIARFDQBBpIg0KAIAIgEEQCABIAQQUAwBCyAEECsLIANB7ZwqNgIUIANB1L8rNgIQIABB/IgqIANBEGoQbAALIAEQKwsgBBArCyADQdS/KzYCACAAQeCHKiADEJsBIANBMGokAEEBC+cDAQV/IwBBMGsiAyQAIANBuskrNgIgIABB+YYqIANBIGoQmwEgAEEBEJ8FIQEgAEECEJ8FIQQgAEEEQQEQ2gEiAkEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbAQJAAkACQAJAIAFFDQAgBEUNACACIAEqAgAgBCoCAJM4AgBBpIg0KAIAIgJFDQEgAyABNgIsAkACQCACKAIAIgUgAygCLEsNACADKAIsIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCIFQQRJDQEgBUF8cSIFRQ0BIAFBACAF/AsADAELIAEQKwsgAyAENgIsIAIoAgAiASADKAIsSw0CIAMoAiwgASACKAIQak8NAiAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgFBBEkNAyABQXxxIgFFDQMgBEEAIAH8CwAMAwsCQCABRQ0AQaSINCgCACICBEAgAiABEFAMAQsgARArCwJAIARFDQBBpIg0KAIAIgEEQCABIAQQUAwBCyAEECsLIANB7ZwqNgIUIANBuskrNgIQIABB/IgqIANBEGoQbAALIAEQKwsgBBArCyADQbrJKzYCACAAQeCHKiADEJsBIANBMGokAEEBC+cDAQV/IwBBMGsiAyQAIANBysYqNgIgIABB+YYqIANBIGoQmwEgAEEBEJ8FIQEgAEECEJ8FIQQgAEEEQQEQ2gEiAkEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbAQJAAkACQAJAIAFFDQAgBEUNACACIAEqAgAgBCoCAJQ4AgBBpIg0KAIAIgJFDQEgAyABNgIsAkACQCACKAIAIgUgAygCLEsNACADKAIsIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCIFQQRJDQEgBUF8cSIFRQ0BIAFBACAF/AsADAELIAEQKwsgAyAENgIsIAIoAgAiASADKAIsSw0CIAMoAiwgASACKAIQak8NAiAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgFBBEkNAyABQXxxIgFFDQMgBEEAIAH8CwAMAwsCQCABRQ0AQaSINCgCACICBEAgAiABEFAMAQsgARArCwJAIARFDQBBpIg0KAIAIgEEQCABIAQQUAwBCyAEECsLIANB7ZwqNgIUIANBysYqNgIQIABB/IgqIANBEGoQbAALIAEQKwsgBBArCyADQcrGKjYCACAAQeCHKiADEJsBIANBMGokAEEBC+cDAQV/IwBBMGsiAyQAIANBysApNgIgIABB+YYqIANBIGoQmwEgAEEBEJ8FIQEgAEECEJ8FIQQgAEEEQQEQ2gEiAkEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbAQJAAkACQAJAIAFFDQAgBEUNACACIAEqAgAgBCoCAJU4AgBBpIg0KAIAIgJFDQEgAyABNgIsAkACQCACKAIAIgUgAygCLEsNACADKAIsIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCIFQQRJDQEgBUF8cSIFRQ0BIAFBACAF/AsADAELIAEQKwsgAyAENgIsIAIoAgAiASADKAIsSw0CIAMoAiwgASACKAIQak8NAiAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgFBBEkNAyABQXxxIgFFDQMgBEEAIAH8CwAMAwsCQCABRQ0AQaSINCgCACICBEAgAiABEFAMAQsgARArCwJAIARFDQBBpIg0KAIAIgEEQCABIAQQUAwBCyAEECsLIANB7ZwqNgIUIANBysApNgIQIABB/IgqIANBEGoQbAALIAEQKwsgBBArCyADQcrAKTYCACAAQeCHKiADEJsBIANBMGokAEEBC+gDAQV/IwBBMGsiAyQAIANBv6orNgIgIABB+YYqIANBIGoQmwEgAEEBEJ8FIQEgAEECEJ8FIQQgAEEEQQEQ2gEiAkEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbAQJAAkACQAJAIAFFDQAgBEUNACACIAEqAgAgBCoCABBEOAIAQaSINCgCACICRQ0BIAMgATYCLAJAAkAgAigCACIFIAMoAixLDQAgAygCLCAFIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiBUEESQ0BIAVBfHEiBUUNASABQQAgBfwLAAwBCyABECsLIAMgBDYCLCACKAIAIgEgAygCLEsNAiADKAIsIAEgAigCEGpPDQIgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCIBQQRJDQMgAUF8cSIBRQ0DIARBACAB/AsADAMLAkAgAUUNAEGkiDQoAgAiAgRAIAIgARBQDAELIAEQKwsCQCAERQ0AQaSINCgCACIBBEAgASAEEFAMAQsgBBArCyADQe2cKjYCFCADQb+qKzYCECAAQfyIKiADQRBqEGwACyABECsLIAQQKwsgA0G/qis2AgAgAEHghyogAxCbASADQTBqJABBAQuGBgIFfwF9IwBBQGoiAiQAIAJBqeopNgIwIABB+YYqIAJBMGoQmwECQAJAAkAgACgCFCgCACIDQQhqIgEgACgCDCIESQRAIAEtAARBD3FBBWtBfk8NAQwCCyAAKAIQIgVBLGohASAFLQAwQQ9xQQVrQX5JDQELQQAhAwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCAEEQaiEDCyAAQQRBARDaASIBQQA2AgAgAEHY4c59QbvqKRCQARogAEF+ENsBIAEgAyACQThqEKAFIgY4AgAgAigCOC0AAEUEQCAGvEH/////B3FBgICA/AdJDQILIAIgAzYCICAAQfeFKiACQSBqEGwACwJAAkAgAS0ABCIFQRNGDQAgBUEDRg0AIAVBD3FBBEcNASABKAIAIgFBEGogAkE4ahDBASEEIAQgAS0AByIDQf8BRgR/IAEoAgwFIAMLQQFqRw0BIAAoAgwhBCAAKAIUKAIAIQMLIAQgA0EIaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEIgNBE0YEQCABKgIAIQYMAQsgA0EDRgRAIAEoAgCyIQYMAQsgA0EPcUEERw0AIAEoAgAiAUEQaiACQThqEMEBIQQgBCABLQAHIgNB/wFGBH8gASgCDAUgAwtBAWpHDQAgAigCOCIBsiABviACLQA8QQNGGyEGCyAAQQRBARDaASIBQQA2AgAgAEHY4c59QbvqKRCQARogAEF+ENsBIAEgBjgCAAwBCwJAIAIgAEEBEMgBIgEEfyAAQQRBARDaASIDQQA2AgAgAEHY4c59QbvqKRCQARogAEF+ENsBIAMgASgCCCACQTRqEKAFOAIAIAIoAjQtAAAhAyABEJoBIANFDQFBjZ0qBUH/5CkLNgIEIAJBqeopNgIAIABB/IgqIAIQbAALIAJBqeopNgIQIABB4IcqIAJBEGoQmwELIAJBQGskAEEBC5sCAQR/IwBBMGsiAiQAIAJBlf8qNgIgIABB+YYqIAJBIGoQmwEgAEEBEJ8FIQMgAEEEQQEQ2gEiAUEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbAQJAAkAgAwRAIAEgAyoCAIw4AgBBpIg0KAIAIgFFDQEgAiADNgIsIAEoAgAiBCACKAIsSw0BIAIoAiwgBCABKAIQak8NASADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNAiABQXxxIgFFDQIgA0EAIAH8CwAMAgsgAkHtnCo2AgQgAkGV/yo2AgAgAEH8iCogAhBsAAsgAxArCyACQZX/KjYCECAAQeCHKiACQRBqEJsBIAJBMGokAEEBC88DAQZ/IwBBIGsiAiQAIAJBsuopNgIQIABB+YYqIAJBEGoQmwFBESEDIAAoAhQoAgAiBUEIaiIBIAAoAgwiBk8EQCAAKAIQQSxqIQELAkAgAS0ABCIEQRNGDQAgBEEDRg0AAkAgBEEPcUEERgR/IAEoAgAiAUEQaiACQRhqEMEBIQUgBSABLQAHIgRB/wFGBH8gASgCDAUgBAtBAWpGDQIgACgCDCEGIAAoAhQoAgAFIAULQQhqIgEgBkkEQCABLQAEQQ9xQQVrQX5PDQFBASEDDAILIAAoAhAtADBBD3FBBWtBfkkEQEEBIQMMAgsgACgCEEEsaiEBC0EAIQMCQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgEgACgCDEkNACAAKAIQQSxqIQELIAEoAgBBEGohAwsgAEEEQQEQ2gEiAUEANgIAIABB2OHOfUG76ikQkAEaIABBfhDbASABIAMgAkEYahCgBTgCAEEBQREgAigCGC0AABshAwsgACgCDCADOgAEIAAgACgCDEEIajYCDCACQbLqKTYCACAAQeCHKiACEJsBIAJBIGokAEEBC7kHAgZ/AX0jAEHQCGsiAyQAAkBBpIg0KAIAIgIEQAJ/AkAgAigCFEEESQ0AIAIoAgQiBEUNACACKAIYIgUgBSgCEEEBajYCECACIAIoAhxBAWo2AhwgAiACKAIgQQRqNgIgIAIgAigCLEEEajYCLCACIAQoAgA2AgRBCCEGQX8MAQtBBBAqIgRFBEAQTwsgAiACKAIkQQFqNgIkIAIgAigCKEEEajYCKEEsIQZBBAshBSACIAZqIgIgAigCACAFajYCAAwBC0EEECohBAsCQCAERQRAQQAhBAwBCyAAIAFBgpErENwBIgIEQCAEIAIoAgA2AgAMAQsCQAJAIAAoAhQoAgAiBUEIaiICIAAoAgwiBkkEQCACLQAEQQ9xQQVrQX5PDQEMAgsgACgCECIHQSxqIQIgBy0AMEEPcUEFa0F+SQ0BC0EAIQECQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgIgACgCDEkNACAAKAIQQSxqIQILIAIoAgBBEGohAQsgASADQcwIahB2IQIgAygCzAgtAAAEQAJAQaSINCgCACICBEAgAiAEEFAMAQsgBBArCyADIAE2AjAgAEHAhiogA0EwahBsAAsgAyACNgIgIANBQGtBgAhBq64rIANBIGoQpgQaIANBQGsgARCtAQRAAkBBpIg0KAIAIgIEQCACIAQQUAwBCyAEECsLIAMgATYCECAAQcObKyADQRBqEGwACyAEIAI2AgAMAQsCQAJAIAItAAQiB0ETRg0AIAdBA0YNACAHQQ9xQQRHDQEgAigCACICQRBqIANBQGsQwQEhBiAGIAItAAciBUH/AUYEfyACKAIMBSAFC0EBakcNASAAKAIMIQYgACgCFCgCACEFCyAGIAVBCGoiAk0EQCAAKAIQQSxqIQILAkAgAi0ABCIAQRNGBEAgAioCACEIDAELIABBA0YEQCACKAIAsiEIDAELIABBD3FBBEcNACACKAIAIgJBEGogA0FAaxDBASEBIAEgAi0AByIAQf8BRgR/IAIoAgwFIAALQQFqRw0AIAMoAkAiArIgAr4gAy0AREEDRhshCAsgBCAI/AA2AgAMAQsgACABEMgBIgJFDQAgAigCAEEERwRAAkBBpIg0KAIAIgIEQCACIAQQUAwBCyAEECsLIANBjOgqNgIAIABB4YYqIAMQbkEAIQQMAQsgBCACKAIIKAAANgIAIAIQmgELIANB0AhqJAAgBAukAwEHfyMAQTBrIgMkACADQenhKTYCICAAQfmGKiADQSBqEJsBAkACQCAAQQEQrgUiBARAIAQoAgAhASAAQQQQmAEiBigCCCIHIAE2AAAgBkEENgIAAkAgAEEEEIYBIgFFBEAgAEHp2ytBABBuDAELIAEoAgQiAkEATARAIAEgAjYCAAwBC0EAIQIDQCABKAIIIAJqQQA6AAAgAkEBaiICIAEoAgQiBUgNAAsgAUEEIAUgBUEEThs2AgAgBUEATA0AQQAhAgNAIAEoAgggAmogAiAHai0AADoAACACQQFqIgIgASgCAEgNAAsLQaSINCgCACIBRQ0BIAMgBDYCLCABKAIAIgIgAygCLEsNASADKAIsIAIgASgCEGpPDQEgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQIgAUF8cSIBRQ0CIARBACAB/AsADAILIANBlMwpNgIEIANB6eEpNgIAIABB/IgqIAMQbAALIAQQKwsgBhCaASADQenhKTYCECAAQeCHKiADQRBqEJsBIANBMGokAEEBC7wCAQR/IwBB0AhrIgEkACABQejqKjYCMCAAQfmGKiABQTBqEJsBAkACQCABIABBARCuBSIDBH8gASADKAIANgIgIAFBQGtBgAhB18MrIAFBIGoQpgRB/wdNBEAgACABQUBrEFhBpIg0KAIAIgJFDQIgASADNgLMCCACKAIAIgQgASgCzAhLDQIgASgCzAggBCACKAIQak8NAiADIAIoAgQ2AgAgAiADNgIEIAIgAigCCEEBajYCCCACKAIUIgJBBEkNAyACQXxxIgJFDQMgA0EAIAL8CwAMAwsCQEGkiDQoAgAiAkUEQCADECsMAQsgAiADEFALQaHxKgVByeopCzYCBCABQejqKjYCACAAQfyIKiABEGwACyADECsLIAFB6OoqNgIQIABB4IcqIAFBEGoQmwEgAUHQCGokAEEBC9YDAQV/IwBBMGsiAyQAIANB0KMqNgIgIABB+YYqIANBIGoQmwEgAEEBEK4FIQEgAEECEK4FIQQCQAJAAkACQCABRQ0AIARFDQAgACgCDEERQQEgASgCACAEKAIARhs6AAQgACAAKAIMQQhqNgIMQaSINCgCACICRQ0BIAMgATYCLAJAAkAgAigCACIFIAMoAixLDQAgAygCLCAFIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiBUEESQ0BIAVBfHEiBUUNASABQQAgBfwLAAwBCyABECsLIAMgBDYCLCACKAIAIgEgAygCLEsNAiADKAIsIAEgAigCEGpPDQIgBCACKAIENgIAIAIgBDYCBCACIAIoAghBAWo2AgggAigCFCIBQQRJDQMgAUF8cSIBRQ0DIARBACAB/AsADAMLAkAgAUUNAEGkiDQoAgAiAgRAIAIgARBQDAELIAEQKwsCQCAERQ0AQaSINCgCACIBBEAgASAEEFAMAQsgBBArCyADQe2cKjYCFCADQdCjKjYCECAAQfyIKiADQRBqEGwACyABECsLIAQQKwsgA0HQoyo2AgAgAEHghyogAxCbASADQTBqJABBAQvWAwEFfyMAQTBrIgMkACADQc7cKTYCICAAQfmGKiADQSBqEJsBIABBARCuBSEBIABBAhCuBSEEAkACQAJAAkAgAUUNACAERQ0AIAAoAgxBEUEBIAEoAgAgBCgCAEgbOgAEIAAgACgCDEEIajYCDEGkiDQoAgAiAkUNASADIAE2AiwCQAJAIAIoAgAiBSADKAIsSw0AIAMoAiwgBSACKAIQak8NACABIAIoAgQ2AgAgAiABNgIEIAIgAigCCEEBajYCCCACKAIUIgVBBEkNASAFQXxxIgVFDQEgAUEAIAX8CwAMAQsgARArCyADIAQ2AiwgAigCACIBIAMoAixLDQIgAygCLCABIAIoAhBqTw0CIAQgAigCBDYCACACIAQ2AgQgAiACKAIIQQFqNgIIIAIoAhQiAUEESQ0DIAFBfHEiAUUNAyAEQQAgAfwLAAwDCwJAIAFFDQBBpIg0KAIAIgIEQCACIAEQUAwBCyABECsLAkAgBEUNAEGkiDQoAgAiAQRAIAEgBBBQDAELIAQQKwsgA0Gxnio2AhQgA0HO3Ck2AhAgAEH8iCogA0EQahBsAAsgARArCyAEECsLIANBztwpNgIAIABB4IcqIAMQmwEgA0EwaiQAQQEL1gMBBX8jAEEwayIDJAAgA0Hv/io2AiAgAEH5hiogA0EgahCbASAAQQEQrgUhASAAQQIQrgUhBAJAAkACQAJAIAFFDQAgBEUNACAAKAIMQQFBESABKAIAIAQoAgBKGzoABCAAIAAoAgxBCGo2AgxBpIg0KAIAIgJFDQEgAyABNgIsAkACQCACKAIAIgUgAygCLEsNACADKAIsIAUgAigCEGpPDQAgASACKAIENgIAIAIgATYCBCACIAIoAghBAWo2AgggAigCFCIFQQRJDQEgBUF8cSIFRQ0BIAFBACAF/AsADAELIAEQKwsgAyAENgIsIAIoAgAiASADKAIsSw0CIAMoAiwgASACKAIQak8NAiAEIAIoAgQ2AgAgAiAENgIEIAIgAigCCEEBajYCCCACKAIUIgFBBEkNAyABQXxxIgFFDQMgBEEAIAH8CwAMAwsCQCABRQ0AQaSINCgCACICBEAgAiABEFAMAQsgARArCwJAIARFDQBBpIg0KAIAIgEEQCABIAQQUAwBCyAEECsLIANBsZ4qNgIUIANB7/4qNgIQIABB/IgqIANBEGoQbAALIAEQKwsgBBArCyADQe/+KjYCACAAQeCHKiADEJsBIANBMGokAEEBC6QEAQd/IwBBMGsiAyQAIANB978rNgIgIABB+YYqIANBIGoQmwEgAEEBEK4FIQEgAEECEK4FIQQgAEEEQQEQ2gEiAkEANgIAIABB2OHOfUGCkSsQkAEaIABBfhDbAQJAAkACQCABRQ0AIARFDQACQCABKAIAIgVBAEoEQCAEKAIAIgZBAEwNASAFIAZB/////wdzTQ0BQfGbKyEFDAMLIAQoAgAhBiAFQQBODQAgBkEATg0AIAVBgICAgHggBmtODQBB8ZsrIQUMAgsgAiAFIAZqNgIAQQEhB0EAIQUMAQtBsZ4qIQUgAUUNAQsCQEGkiDQoAgAiAkUNACADIAE2AiwgAigCACIGIAMoAixLDQAgAygCLCAGIAIoAhBqTw0AIAEgAigCBDYCACACIAE2AgQgAiACKAIIQQFqNgIIIAIoAhQiAkEESQ0BIAJBfHEiAkUNASABQQAgAvwLAAwBCyABECsLAkAgBEUNAAJAQaSINCgCACIBRQ0AIAMgBDYCLCABKAIAIgIgAygCLEsNACADKAIsIAIgASgCEGpPDQAgBCABKAIENgIAIAEgBDYCBCABIAEoAghBAWo2AgggASgCFCIBQQRJDQEgAUF8cSIBRQ0BIARBACAB/AsADAELIAQQKwsgB0UEQCADIAU2AhQgA0H3vys2AhAgAEH8iCogA0EQahBsAAsgA0H3vys2AgAgAEHghyogAxCbASADQTBqJABBAQuCBAEGfyMAQTBrIgIkACACQdTJKzYCICAAQfmGKiACQSBqEJsBIABBARCuBSEDIABBAhCuBSEFIABBBEEBENoBIgZBADYCACAAQdjhzn1BgpErEJABGiAAQX4Q2wECfwJAIAMoAgAiAUEASgRAIAUoAgAiBEEATg0BIAEgBEH/////B2pMDQFBkZwrDAILIAUoAgAhBCABQQBODQAgBEEATA0AIAEgBEGAgICAeHJPDQBBkZwrDAELIAYgASAEazYCAEEAQbGeKiAFG0GxniogAxsLIQYCQAJAQaSINCgCACIBBEAgAiADNgIsAkACQCABKAIAIgQgAigCLEsNACACKAIsIAQgASgCEGpPDQAgAyABKAIENgIAIAEgAzYCBCABIAEoAghBAWo2AgggASgCFCIEQQRJDQEgBEF8cSIERQ0BIANBACAE/AsADAELIAMQKwsgAiAFNgIsIAEoAgAiAyACKAIsSw0BIAIoAiwgAyABKAIQak8NASAFIAEoAgQ2AgAgASAFNgIEIAEgASgCCEEBajYCCCABKAIUIgNBBEkNAiADQXxxIgNFDQIgBUEAIAP8CwAMAgsgAxArCyAFECsLIAYEQCACIAY2AhQgAkHUySs2AhAgAEH8iCogAkEQahBsAAsgAkHUySs2AgAgAEHghyogAhCbASACQTBqJABBAQudAgEEfyMAQTBrIgIkACACQaT/KjYCICAAQfmGKiACQSBqEJsBIABBARCuBSEDIABBBEEBENoBIgFBADYCACAAQdjhzn1BgpErEJABGiAAQX4Q2wECQAJAIAMEQCABQQAgAygCAGs2AgBBpIg0KAIAIgFFDQEgAiADNgIsIAEoAgAiBCACKAIsSw0BIAIoAiwgBCABKAIQak8NASADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNAiABQXxxIgFFDQIgA0EAIAH8CwAMAgsgAkGxnio2AgQgAkGk/yo2AgAgAEH8iCogAhBsAAsgAxArCyACQaT/KjYCECAAQeCHKiACQRBqEJsBIAJBMGokAEEBC4QCAQR/IwBBIGsiAiQAIAJB5JArNgIQIABB+YYqIAJBEGoQmwEgAEEEQQEQ2gEiAUEANgIAIABB2OHOfUGCkSsQkAEaIABBfhDbASAAQQEQrgUiAwRAIAEgAygCADYCAAJAAkBBpIg0KAIAIgFFDQAgAiADNgIcIAEoAgAiBCACKAIcSw0AIAIoAhwgBCABKAIQak8NACADIAEoAgQ2AgAgASADNgIEIAEgASgCCEEBajYCCCABKAIUIgFBBEkNASABQXxxIgFFDQEgA0EAIAH8CwAMAQsgAxArCyACQeSQKzYCACAAQeCHKiACEJsBIAJBIGokAEEBDwsgAEGUzClBABBsAAuaBQIFfwF9IwBBIGsiAyQAIANBzvwqNgIQIABB+YYqIANBEGoQmwEgACgCFCgCACIEQQhqIgEgACgCDCICTwRAIAAoAhBBLGohAQsCQAJAAkACQCABLQAEIgVBE0YNACAFQQNGDQAgBUEPcUEERw0BIAEoAgAiAkEQaiADQRhqEMEBIQUgAi0AByIBQf8BRgRAIAIoAgwhAQsgACgCDCECIAAoAhQoAgAhBCAFIAFBAWpHDQELIAIgBEEIaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEIgRBE0YEQCABKgIAIQYMAQsCQCAEQQNGBEAgASgCALIhBgwBCyAEQQ9xQQRHDQAgASgCACICQRBqIANBGGoQwQEhBCAEIAItAAciAUH/AUYEfyACKAIMBSABC0EBakcNACADKAIYIgKyIAK+IAMtABxBA0YbIQYLIAAoAgwhAgsgAkEEaiEBQQEhAiAGQyhr7k5fIAaLQwAAAE9fcSAGQ17Qsk5gcQ0BDAILAkACQAJAIAIgBEEIaiIBSwRAIAEtAARBD3FBBWtBfkkNAQwDCyAAKAIQLQAwQQ9xQQVrQX1LDQELIAJBBGohAUEBIQIMAwsgACgCEEEsaiEBC0EAIQICQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgEgACgCDEkNACAAKAIQQSxqIQELIAEoAgBBEGohAgsgAiADQRhqEHYhBCAAKAIMQQRqIQFBASECIAMoAhgtAABFIARBgN6gywVrQYHKte4BSXFFDQELQREhAgsgASACOgAAIAAgACgCDEEIajYCDCADQc78KjYCACAAQeCHKiADEJsBIANBIGokAEEBC6kGAQh/IwBB0ABrIgEkAAJAAn8CQCAAQf/uKxBqRQRAQQEhAEHYBSEGQdgFQQEQLiICDQEgAUH73Sk2AgBBzOMqIAEQdSABQQA6AE9Bg/UzIAFBzwBqQQAQABogAUEAOgBOQZr1MyABQc4AakEAEAAaDAMLIABB7ukrEGpFBEBBASEAQewCIQZB7AJBARAuIgJFBEAgAUH73Sk2AjBBmOMqIAFBMGoQdSABQQA6AE9Bg/UzIAFBzwBqQQAQABogAUEAOgBOQZr1MyABQc4AakEAEAAaDAQLIAJBIDYC6AIgAkKrs4/8kaOz8NsANwIgIAJC/6S5iMWR2oKbfzcCGCACQvLmu+Ojp/2npX83AhAgAkLnzKfQ1tDrs7t/NwIIQTIMAgsgASAANgJEIAFB+90pNgJAQc6KKiABQUBrEHUgAUEAOgBPQYP1MyABQc8AakEAEAAaIAFBADoATkGa9TMgAUHOAGpBABAAGkEBIQAMAgsgAkHAADYC0AUgAkL5wvibkaOz8NsANwNIIAJC6/qG2r+19sEfNwNAIAJCn9j52cKR2oKbfzcDOCACQtGFmu/6z5SH0QA3AzAgAkLx7fT4paf9p6V/NwMoIAJCq/DT9K/uvLc8NwMgIAJCu86qptjQ67O7fzcDGCACQoiS853/zPmE6gA3AxBBNAshBSAGQQF0IghBAnIQKiIDRQRAIAFBxbspNgIQQc66KSABQRBqEHUgAhArIAFBADoAT0GD9TMgAUHPAGpBABAAGiABQQA6AE5BmvUzIAFBzgBqQQAQABoMAQsgAyAFOgAAIANBAWohBUEAIQADQCAFIABBAXRqIgQgACACai0AACIHQQ9xQfDTMWotAAA6AAEgBCAHQQR2QfDTMWotAAA6AAAgBSAAQQFyIgRBAXRqIgcgAiAEai0AACIEQQ9xQfDTMWotAAA6AAEgByAEQQR2QfDTMWotAAA6AAAgAEECaiIAIAZHDQALQQAhACADIAhqQQA6AAEgASADNgIgIAFBIGoQkQEgAxArIAIQKyABQQA6AE9B7/QzIAFBzwBqQQAQABoLIAFB0ABqJAAgAAuECQILfwF+IwBBMGsiBiQAQQEhDCAALQAAIQ0CQAJAIAJBAXUiCRAqIgpFBEBBhfQqIQcMAQsCQCABLQAAIgUEQCABQQFqIQhBACECA0BB7pkqIQcgAiAIaiwAACIERQ0CIAXAQQJ0QYDZLGooAgAiBUEASA0CIARBAnRBgNksaigCACIEQQBIDQIgAyAKaiAFQQR0IARyOgAAIANBAWohAyABIAJBAmoiAmotAAAiBQ0ACwtBlbspIQcCQAJAAkACQAJAIA1BMmsOAwEFAAULQdgFECoiAkUNAyAALQABIgQEQCAAQQFqIQsgAEECaiEIQQAhAEEAIQVBACEDA0BBr7opIQcgAyAIaiwAACIBRQ0EIATAQQJ0QYDZLGooAgAiBEEASARADAULIAFBAnRBgNksaigCACIBQQBIBEAMBQsgAiAFaiAEQQR0IAFyOgAAIAVBAWohBSALIANBAmoiA2otAAAiBA0ACwtB2AUhASAJQQBMDQEgAkHQAGohBEEAIQMDQCAEIAIpAwAiDqdBA3ZB+ABxaiIFIAMgCmoxAAAgBSkDAEIIhoQ3AwAgAiAOQgh8Ig43AwACQAJAIA5QBEAgAkIANwMAIAIgAikDCEIBfDcDCAwBCyAOQv8Hg0IAUg0BCyACEPkDCyADQQFqIgMgCUcNAAsMAQtB7AIQKiICRQ0CIAAtAAEiBARAIABBAWohCyAAQQJqIQhBACEAQQAhBUEAIQMDQEGvuikhByADIAhqLAAAIgFFDQMgBMBBAnRBgNksaigCACIEQQBIBEAMBAsgAUECdEGA2SxqKAIAIgFBAEgEQAwECyACIAVqIARBBHQgAXI6AAAgBUEBaiEFIAsgA0ECaiIDai0AACIEDQALC0HsAiEBIAlBAEwNACACQShqIQdBACEDA0AgByACKAIAIgVBA3ZBPHFqIgQgAyAKai0AACAEKAIAQQh0cjYCACACIAVBCGoiBTYCAAJAAkAgBUUEQCACQQA2AgAgAiACKAIEQQFqNgIEDAELIAVB/wNxDQELIAIQ9wELIANBAWoiAyAJRw0ACwsgAUEBdCIJQQJyECoiCEUEQCAGQcW7KTYCEEHOuikgBkEQahB1QfK7KSEHQQAhAAwBCyAIIA06AAAgCEEBaiEFQQAhAwNAIAUgA0EBdGoiBCACIANqLQAAIgdBD3FB8NMxai0AADoAASAEIAdBBHZB8NMxai0AADoAACAFIANBAXIiBEEBdGoiByACIARqLQAAIgRBD3FB8NMxai0AADoAASAHIARBBHZB8NMxai0AADoAACADQQJqIgMgAUcNAAtBASEAQQAhByAIIAlqQQA6AAEgBiAINgIgIAZBIGoQkQEgCBArCyAKECsgAhArIABFDQJBACEMIAZBADoAL0Hv9DMgBkEvakEAEAAaDAMLQZ7jKiEHCyAKECsLIAYgBzYCBCAGQYyBKzYCAEH9iyogBhB1IAZBADoAL0GD9TMgBkEvakEAEAAaIAZBADoALkGa9TMgBkEuakEAEAAaCyAGQTBqJAAgDAv0BAELfyMAQTBrIgEkACAALQAAIQICfwJAQdoAECoiCUUEQEHb2ykhAwwBC0GVuykhAwJAAkACQAJAAkACQAJAAkAgAkEyaw4DAQcABwsgAUHAADYCHCABQcAAECoiBzYCJCAHRQ0FQdgFQQEQLiIIRQ0DIAAtAAEiBARAIABBAWohCiAAQQJqIQtBACECQQAhAANAQa+6KSEDIAAgC2osAAAiBkUNBCAEwEECdEGA2SxqKAIAIgRBAEgEQAwFCyAGQQJ0QYDZLGooAgAiBkEASARADAULIAIgCGogBEEEdCAGcjoAACACQQFqIQIgCiAAQQJqIgBqLQAAIgQNAAsLIAggBxD4AwwBCyABQSA2AhwgAUEgECoiBzYCJCAHRQ0EQewCQQEQLiIIRQ0CIAAtAAEiBARAIABBAWohCiAAQQJqIQtBACECQQAhAANAQa+6KSEDIAAgC2osAAAiBkUNAyAEwEECdEGA2SxqKAIAIgRBAEgEQAwECyAGQQJ0QYDZLGooAgAiBkEASARADAQLIAIgCGogBEEEdCAGcjoAACACQQFqIQIgCiAAQQJqIgBqLQAAIgQNAAsLIAggBxD4AQsgCSABQRxqEO0BIAEgCTYCECABQRBqEJEBQQAhA0EBIQULIAgQKwwBC0HS4yohAwsgBxArIAkQKyAFRQ0CIAFBADoAL0Hv9DMgAUEvakEAEAAaQQAMAwtB4cwqIQMLIAkQKwsgASADNgIEIAFB0M4qNgIAQf2LKiABEHUgAUEAOgAvQYP1MyABQS9qQQAQABogAUEAOgAuQZr1MyABQS5qQQAQABpBAQshAyABQTBqJAAgAwv5BAEJfyMAQTBrIgYkACAGQdfEKjYCICAAQfmGKiAGQSBqEJsBIABBARDIASIHKAIAIgFB/////wdHBEACQCAAIAEQhgEiAUUEQCAAQenbK0EAEG4MAQsgASgCBCIEQQBKBEADQCABKAIIIAJqQQA6AAAgAkEBaiICIAEoAgQiBEgNAAsLQQAhAiABQQA2AgAgASAHKAIAIgMgBCADIARIGyIENgIAIARBAEwNAANAIAEoAgggAmogBygCCCACai0AADoAACACQQFqIgIgASgCAEgNAAsLQZCWNCgCACIEKAIkEGkhAgJAIAEoAgAiA0H/AUwEQCAEKAIkEGkhBSACIAEoAgggBSABKAIAb2oiAy0AAEYEQANAIAQoAiQQaSICIAEoAgggBSABKAIAb2oiAy0AAEYNAAsLIAMgAjoAAAwBCyADQf7/A00EQCAEKAIkEGkhAyAEKAIkEGkhBSACIAEoAgggAyAFQQh0ciIFIAEoAgBvaiIDLQAARgRAA0AgBCgCJBBpIgIgASgCCCAFIAEoAgBvaiIDLQAARg0ACwsgAyACOgAADAELIANB/////wdGDQAgBCgCJBBpIQMgBCgCJBBpIQUgBCgCJBBpIQggBCgCJBBpIQkgAiABKAIIIAMgBUEIdHIgCEEQdHIgCUEYdHIiBSABKAIAcGoiAy0AAEYEQANAIAQoAiQQaSICIAEoAgggBSABKAIAcGoiAy0AAEYNAAsLIAMgAjoAAAsgBxCaASAGQdfEKjYCECAAQeCHKiAGQRBqEJsBIAZBMGokAEEBDwsgBxCaASAGQcvwKjYCBCAGQdfEKjYCACAAQfyIKiAGEGwAC8YDAQZ/IwBBMGsiBCQAIARBuo0qNgIgIABB+YYqIARBIGoQmwECQCAAQQEQyAEiBSgCACICQf////8HRwRAIAAgAhCGASICRQ0BIAIoAgQiA0EASgRAA0AgAigCCCABakEAOgAAIAFBAWoiASACKAIEIgNIDQALC0EAIQEgAkEANgIAIAIgBSgCACIGIAMgAyAGShsiAzYCAAJAAn8CQAJAIANBAEwEQEGQljQoAgAhAQwBCwNAIAIoAgggAWogBSgCCCABai0AADoAACABQQFqIgEgAigCACIDSA0AC0GQljQoAgAhASADQf8BSg0BCyABKAIkEGkgAigCAG8MAQsgA0H+/wNNBEAgASgCJBBpIAEoAiQQaUEIdHIgAigCAG8MAQsgA0H/////B0YNASABKAIkEGkgASgCJBBpQQh0ciABKAIkEGlBEHRyIAEoAiQQaUEYdHIgAigCAHALIAIoAghqIgIgAi0AAEF/czoAAAsgBRCaASAEQbqNKjYCECAAQeCHKiAEQRBqEJsBIARBMGokAEEBDwsgBRCaASAEQcvwKjYCBCAEQbqNKjYCACAAQfyIKiAEEGwACyAAQenbK0EAEG4AC7IEAQh/IwBBMGsiBCQAIARB/cMqNgIgIABB+YYqIARBIGoQmwECQCAAQQEQyAEiBigCACICQf////8HRwRAIAAgAhCGASICRQ0BIAIoAgQiA0EASgRAA0AgAigCCCABakEAOgAAIAFBAWoiASACKAIEIgNIDQALC0EAIQEgAkEANgIAIAIgBigCACIFIAMgAyAFShsiAzYCAAJAAkACQCADQQBMBEBBkJY0KAIAIQEMAQsDQCACKAIIIAFqIAYoAgggAWotAAA6AAAgAUEBaiIBIAIoAgAiA0gNAAtBkJY0KAIAIQEgA0H/AUoNAQsgASgCJBBpIQMgASgCJBBpIQEgAigCCCADIAIoAgBvaiICIAItAABBASABQQdxdHM6AAAMAQsgA0H+/wNNBEAgASgCJBBpIQMgASgCJBBpIQUgASgCJBBpIQEgAigCCCADIAVBCHRyIAIoAgBvaiICIAItAABBASABQQdxdHM6AAAMAQsgA0H/////B0YNACABKAIkEGkhAyABKAIkEGkhBSABKAIkEGkhByABKAIkEGkhCCABKAIkEGkhASACKAIIIAMgBUEIdHIgB0EQdHIgCEEYdHIgAigCAHBqIgIgAi0AAEEBIAFBB3F0czoAAAsgBhCaASAEQf3DKjYCECAAQeCHKiAEQRBqEJsBIARBMGokAEEBDwsgBhCaASAEQcvwKjYCBCAEQf3DKjYCACAAQfyIKiAEEGwACyAAQenbK0EAEG4AC6cFAQd/IwBBMGsiBCQAIARBrMQqNgIgIABB+YYqIARBIGoQmwECQCAAQQEQyAEiBigCACICQf////8HRwRAIAAgAhCGASICRQ0BIAIoAgQiA0EASgRAA0AgAigCCCABakEAOgAAIAFBAWoiASACKAIEIgNIDQALC0EAIQEgAkEANgIAIAIgBigCACIFIAMgAyAFShsiAzYCAAJAAkACQAJAIANBAEwEQEGQljQoAgAhAQwBCwNAIAIoAgggAWogBigCCCABai0AADoAACABQQFqIgEgAigCACIDSA0AC0GQljQoAgAhASADQf8BSg0BCyABKAIkEGkgAigCAG8iAw0BA0AgASgCJBBpIAIoAgBvIgNFDQALDAELIANB/v8DTQRAIAEoAiQQaSABKAIkEGlBCHRyIAIoAgBvIgMNAQNAIAEoAiQQaSABKAIkEGlBCHRyIAIoAgBvIgNFDQALDAELIANB/////wdGDQEgASgCJBBpIAEoAiQQaUEIdHIgASgCJBBpQRB0ciABKAIkEGlBGHRyIAIoAgBwIgMNAANAIAEoAiQQaSABKAIkEGlBCHRyIAEoAiQQaUEQdHIgASgCJBBpQRh0ciACKAIAcCIDRQ0ACwsjACEFIAIoAgAiASADTARAIAMgAW8hAwsgA0EASgRAIAUgAUEPakFwcWshByACKAIAIgFBAEoEQCABBEAgByACKAIIIAH8CgAAC0EAIQUDQCACKAIIIAVqIAcgAyAFaiABb2otAAA6AAAgBUEBaiIFIAIoAgAiAUgNAAsLCwsgBhCaASAEQazEKjYCECAAQeCHKiAEQRBqEJsBIARBMGokAEEBDwsgBhCaASAEQcvwKjYCBCAEQazEKjYCACAAQfyIKiAEEGwACyAAQenbK0EAEG4AC6wFAQp/IwBBMGsiBSQAIAVBjcQqNgIgIABB+YYqIAVBIGoQmwECQCAAQQEQyAEiCCgCACIEQf////8HRwRAIAAgBBCGASIERQ0BIAQoAgQiAkEASgRAA0AgBCgCCCABakEAOgAAIAFBAWoiASAEKAIEIgJIDQALC0EAIQEgBEEANgIAIAQgCCgCACIDIAIgAiADShsiAjYCAAJAAkACQCACQQBMBEAgAkEDdCEGQZCWNCgCACEBDAELA0AgBCgCCCABaiAIKAIIIAFqLQAAOgAAIAFBAWoiASAEKAIAIgJIDQALIAJBA3QhBkGQljQoAgAhASACQf8BSg0BCyABKAIkEGkhAiAEKAIAIQMgASgCJBBpQQdxIAIgA29BA3RyIgMgBnANAQNAIAEoAiQQaSECIAQoAgAhAyABKAIkEGlBB3EgAiADb0EDdHIiAyAGcEUNAAsMAQsgAkH+/wNNBEAgASgCJBBpIQIgASgCJBBpIQMgBCgCACEJIAEoAiQQaUEHcSACIANBCHRyIgcgCW9BA3RyIgMgBnANAQNAIAQoAgAhAiABKAIkEGlBB3EgByACb0EDdHIiAyAGcEUNAAsMAQtBACEDIAJB/////wdGDQAgASgCJBBpIQIgASgCJBBpIQMgASgCJBBpIQcgASgCJBBpIQkgBCgCACEKIAEoAiQQaUEHcSACIANBCHRyIAdBEHRyIAlBGHRyIgcgCnBBA3RyIgMgBnANAANAIAQoAgAhAiABKAIkEGlBB3EgByACcEEDdHIiAyAGcEUNAAsLIAQgAxCOAiAIEJoBIAVBjcQqNgIQIABB4IcqIAVBEGoQmwEgBUEwaiQAQQEPCyAIEJoBIAVBy/AqNgIEIAVBjcQqNgIAIABB/IgqIAUQbAALIABB6dsrQQAQbgALuQ8BAX8CQAJAAkAgAQRAQX8hACABKAIAQSBIDQMgAiABQQhqIgYoAgAtAAA6AAAgAiAGKAIALQABOgABIAIgBigCAC0AAjoAAiACIAYoAgAtAAM6AAMgAiAGKAIALQAEOgAEIAIgBigCAC0ABToABSACIAYoAgAtAAY6AAYgAiAGKAIALQAHOgAHIAIgBigCAC0ACDoACCACIAYoAgAtAAk6AAkgAiAGKAIALQAKOgAKIAIgBigCAC0ACzoACyACIAYoAgAtAAw6AAwgAiAGKAIALQANOgANIAIgBigCAC0ADjoADiACIAYoAgAtAA86AA8gAiAGKAIALQAQOgAQIAIgBigCAC0AEToAESACIAYoAgAtABI6ABIgAiAGKAIALQATOgATIAIgBigCAC0AFDoAFCACIAYoAgAtABU6ABUgAiAGKAIALQAWOgAWIAIgBigCAC0AFzoAFyACIAYoAgAtABg6ABggAiAGKAIALQAZOgAZIAIgBigCAC0AGjoAGiACIAYoAgAtABs6ABsgAiAGKAIALQAcOgAcIAIgBigCAC0AHToAHSACIAYoAgAtAB46AB4gAiAGKAIALQAfOgAfIAMgAhDCBUUNAiABKAIAQSBIDQMgAiAGKAIALQAAOgAAIAIgBigCAC0AAToAASACIAYoAgAtAAI6AAIgAiAGKAIALQADOgADIAIgBigCAC0ABDoABCACIAYoAgAtAAU6AAUgAiAGKAIALQAGOgAGIAIgBigCAC0ABzoAByACIAYoAgAtAAg6AAggAiAGKAIALQAJOgAJIAIgBigCAC0ACjoACiACIAYoAgAtAAs6AAsgAiAGKAIALQAMOgAMIAIgBigCAC0ADToADSACIAYoAgAtAA46AA4gAiAGKAIALQAPOgAPIAIgBigCAC0AEDoAECACIAYoAgAtABE6ABEgAiAGKAIALQASOgASIAIgBigCAC0AEzoAEyACIAYoAgAtABQ6ABQgAiAGKAIALQAVOgAVIAIgBigCAC0AFjoAFiACIAYoAgAtABc6ABcgAiAGKAIALQAYOgAYIAIgBigCAC0AGToAGSACIAYoAgAtABo6ABogAiAGKAIALQAbOgAbIAIgBigCAC0AHDoAHCACIAYoAgAtAB06AB0gAiAGKAIALQAeOgAeIAIgBigCAC0AHzoAHyADIAIQwgVFDQIgASgCAEEgSA0DIAIgBigCAC0AADoAACACIAYoAgAtAAE6AAEgAiAGKAIALQACOgACIAIgBigCAC0AAzoAAyACIAYoAgAtAAQ6AAQgAiAGKAIALQAFOgAFIAIgBigCAC0ABjoABiACIAYoAgAtAAc6AAcgAiAGKAIALQAIOgAIIAIgBigCAC0ACToACSACIAYoAgAtAAo6AAogAiAGKAIALQALOgALIAIgBigCAC0ADDoADCACIAYoAgAtAA06AA0gAiAGKAIALQAOOgAOIAIgBigCAC0ADzoADyACIAYoAgAtABA6ABAgAiAGKAIALQAROgARIAIgBigCAC0AEjoAEiACIAYoAgAtABM6ABMgAiAGKAIALQAUOgAUIAIgBigCAC0AFToAFSACIAYoAgAtABY6ABYgAiAGKAIALQAXOgAXIAIgBigCAC0AGDoAGCACIAYoAgAtABk6ABkgAiAGKAIALQAaOgAaIAIgBigCAC0AGzoAGyACIAYoAgAtABw6ABwgAiAGKAIALQAdOgAdIAIgBigCAC0AHjoAHiACIAYoAgAtAB86AB8gAyACEMIFRQ0CIAEoAgBBIEgNAyACIAYoAgAtAAA6AAAgAiAGKAIALQABOgABIAIgBigCAC0AAjoAAiACIAYoAgAtAAM6AAMgAiAGKAIALQAEOgAEIAIgBigCAC0ABToABSACIAYoAgAtAAY6AAYgAiAGKAIALQAHOgAHIAIgBigCAC0ACDoACCACIAYoAgAtAAk6AAkgAiAGKAIALQAKOgAKIAIgBigCAC0ACzoACyACIAYoAgAtAAw6AAwgAiAGKAIALQANOgANIAIgBigCAC0ADjoADiACIAYoAgAtAA86AA8gAiAGKAIALQAQOgAQIAIgBigCAC0AEToAESACIAYoAgAtABI6ABIgAiAGKAIALQATOgATIAIgBigCAC0AFDoAFCACIAYoAgAtABU6ABUgAiAGKAIALQAWOgAWIAIgBigCAC0AFzoAFyACIAYoAgAtABg6ABggAiAGKAIALQAZOgAZIAIgBigCAC0AGjoAGiACIAYoAgAtABs6ABsgAiAGKAIALQAcOgAcIAIgBigCAC0AHToAHSACIAYoAgAtAB46AB4gAiAGKAIALQAfOgAfDAELIAAoAiQhAQNAIAIgBmogARBpOgAAIAZBAWoiBkEgRw0ACyADIAIQwgVFDQEgACgCJCEBQQAhBgNAIAIgBmogARBpOgAAIAZBAWoiBkEgRw0ACyADIAIQwgVFDQEgACgCJCEBQQAhBgNAIAIgBmogARBpOgAAIAZBAWoiBkEgRw0ACyADIAIQwgVFDQEgACgCJCEBQQAhBgNAIAIgBmogARBpOgAAIAZBAWoiBkEgRw0ACwtBfyEAIAMgAhDCBQ0BCyAEIAVB0IotQfCKLSADEMMFQQAhAAsgAAviAgEIfiAAIAEQxgVBACAANQIcIgJCACAANQIYIgNCACAANQIUIgRCACAANQIQIgVCACAANQIMIgZCACAANQIIIgdCACAANQIEIghCACAANQIAIglC0cqM4w99QiCIfUL/////D4N9QsKV550PfUIgiH1C/////w+DfUKEvd64Cn1CIIh9Qv////8Pg31CrfWb5wt9QiCIfUL/////D4N9Qv////8PfUIgiH1C/////w+DfUL/////D31CIIh9Qv////8Pg31CIIh9Qv////8Pg31C/////w99QoCAgIAQVAR/QQEFIAJCACADQgAgBEIAIAVCACAGQgAgB0IAIAhCACAJQgF9QiCIfUL/////D4N9QiCIfUL/////D4N9QiCIfUL/////D4N9QiCIfUL/////D4N9QiCIfUL/////D4N9QiCIfUL/////D4N9QiCIfUL/////D4N9Qv////8PVgtrC8AKAx5/AX4BeyMAQaABayIFJAAgBCgCHCEIIAQoAhghCSAEKAIUIQogBCgCECELIAQoAgwhDCAEKAIIIQ0gBCgCBCEOIAQoAgAhByAFQTBqIg/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAUgJP0LBCAgBSAHQQFxIhBBAWsiBkLRyozjDyAHrX0iI6dxIAdBACAQayIEcXI2AmAgBSAGQsKV550PIA6tQgAgI0IgiH1C/////w+DfH0iI6dxIAQgDnFyNgJkIAUgBkKEvd64CiANrUIAICNCIIh9Qv////8Pg3x9IiOncSAEIA1xcjYCaCAFIAZCrfWb5wsgDK1CACAjQiCIfUL/////D4N8fSIjp3EgBCAMcXI2AmwgBSAGIAtBf3OtQgAgI0IgiH1C/////w+DfSIjp3EgBCALcXI2AnAgBSAGIApBf3OtQgAgI0IgiH1C/////w+DfSIjp3EgBCAKcXI2AnQgBSAGQgAgCa1CACAjQiCIfUL/////D4N8fSIjp3EgBCAJcXI2AnggBSAjQiCIpyAIQX9zaiAGcSAEIAhxcjYCfCAFQUBrIAVBIGogAxDHBSAAIAIoAgA2AgAgACACKAIENgIEIAAgAigCCDYCCCAAIAIoAgw2AgwgACACKAIQNgIQIAAgAigCFDYCFCAAIAIoAhg2AhggACACKAIcNgIcIAEgAygCACIHNgIAIAEgAygCBCIINgIEIAEgAygCCCIJNgIIIAEgAygCDCIKNgIMIAEgAygCECILNgIQIAEgAygCFCIMNgIUIAEgAygCGCINNgIYIAEgAygCHCIONgIcIAVBADYCHCAFQgA3AgQgBUEBNgIAIAUgJP0LAgwgBSAFQbCLLUGQiy0QxQUgASAFKAJAIhNBACAQRSIUayIGcSAEIAdxcjYCACABIAUoAkQiFSAGcSAEIAhxcjYCBCABIAUoAkgiFiAGcSAEIAlxcjYCCCABIAUoAkwiFyAGcSAEIApxcjYCDCABIAUoAlAiGCAGcSAEIAtxcjYCECABIAUoAlQiGSAGcSAEIAxxcjYCFCABIAUoAlgiGiAGcSAEIA1xcjYCGCABIAUoAlwiGyAGcSAEIA5xcjYCHCAFKAI4IQogDygCACELQf8BIQkgBSgCPCEMIAUoAjQhDSAFKAIsIQ4gBSgCKCEPIAUoAiQhEQNAIAMoAgAhHCADKAIEIR0gAygCCCEeIAMoAgwhHyADKAIQISAgAygCFCEhIAMoAhghIiAFQQAgBUHgAGogCUEDdkH8////AXFqKAIAIAl2QQFxIgcgFHMiBmsiBCADKAIccSAMIAZBAWsiBnFyIAcgEHMiCEEBayIHcSAbQQAgCGsiCHFyIgw2AjwgBSAEICJxIAYgCnFyIAdxIAggGnFyIgo2AjggBSAEICFxIAYgDXFyIAdxIAggGXFyIg02AjQgBSAEICBxIAYgC3FyIAdxIAggGHFyIgs2AjAgBSAEIB9xIAYgDnFyIAdxIAggF3FyIg42AiwgBSAEIB5xIAYgD3FyIAdxIAggFnFyIg82AiggBSAEIB1xIAYgEXFyIAdxIAggFXFyIhE2AiQgBSAGIBJxIAQgHHFyIAdxIAggE3FyIhI2AiAgACABIAUQyAUgACABIAUgAiAFQSBqEMkFIAlBAWsiCQ0ACyAFIAVBkIstEMoFIAVBgAFqIAUgBUGQiy0QxQUgACAAIAVBgAFqQZCLLRDFBSAFQYABaiAFQYABaiAFQZCLLRDFBSABIAEgBUGAAWpBkIstEMUFIAVBoAFqJAAL9wMBAX8jAEFAaiIDJAAgAyABKAIANgIAIAMgASgCBDYCBCADIAEoAgg2AgggAyABKAIMNgIMIAMgASgCEDYCECADIAEoAhQ2AhQgAyABKAIYNgIYIAMgASgCHDYCHCADQQA2AjwgA0IANwIkIANBATYCICAD/QwAAAAAAAAAAAAAAAAAAAAA/QsCLCADIAMgA0EgaiACEMUFIAAgAygCACIBQRh0IAFBgP4DcUEIdHIgAUEIdkGA/gNxIAFBGHZycjYAHCAAIAMoAgQiAUEYdCABQYD+A3FBCHRyIAFBCHZBgP4DcSABQRh2cnI2ABggACADKAIIIgFBGHQgAUGA/gNxQQh0ciABQQh2QYD+A3EgAUEYdnJyNgAUIAAgAygCDCIBQRh0IAFBgP4DcUEIdHIgAUEIdkGA/gNxIAFBGHZycjYAECAAIAMoAhAiAUEYdCABQYD+A3FBCHRyIAFBCHZBgP4DcSABQRh2cnI2AAwgACADKAIUIgFBGHQgAUGA/gNxQQh0ciABQQh2QYD+A3EgAUEYdnJyNgAIIAAgAygCGCIBQRh0IAFBgP4DcUEIdHIgAUEIdkGA/gNxIAFBGHZycjYABCAAIAMoAhwiAUEYdCABQYD+A3FBCHRyIAFBCHZBgP4DcSABQRh2cnI2AAAgA0FAayQAC6MHAxB/AX4BeyADKAJAIQ4jAEEwayIEQQA2AiAgBEEQaiIS/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAEIBX9CwQAIARBBHIhDCACKAIAIRMDQCABIAtBAnRqKAIAIg1B//8DcSEJIA1BEHYhCiAEKAIAIQ9BACEGQQAhBQNAIAQgBUECdCIHaiIIIAg1AgAgBq18IAIgB2ooAgAiBkH//wNxIgcgCWytfCAHIApsIgdBEHStfCAGQRB2IgYgCWwiCEEQdK18IhQ+AgAgFEIgiKcgBiAKbCAHQRB2aiAIQRB2amohBiAFQQFqIgVBCEcNAAsgBCAEKAIgIhAgBmoiETYCICANIBNsIA9qIA5sIgVB//8DcSEJIAVBEHYhCkEAIQZBACEFA0AgBCAFQQJ0IgdqIgggCDUCACAGrXwgAyAHaigCACIGQf//A3EiByAJbK18IAcgCmwiB0EQdK18IAZBEHYiBiAJbCIIQRB0rXwiFD4CACAUQiCIpyAGIApsIAdBEHZqIAhBEHZqaiEGIAVBAWoiBUEIRw0ACyAEIAQoAiAiBSAGaiIGNgIgIAz9AAIAIRUgEiAM/QACEP0LBAAgBCAV/QsEACAEIAUgBksgECARS2oiBTYCICALQQFqIgtBCEcNAAsgACAEKAIAIgatIAM1AgB9IhSnIgk2AgAgACAEKAIEIgqtIAM1AgRCACAUQiCIfUL/////D4N8fSIUpyIHNgIEIAAgBCgCCCIIrSADNQIIQgAgFEIgiH1C/////w+DfH0iFKciAjYCCCAAIAQoAgwiC60gAzUCDEIAIBRCIIh9Qv////8Pg3x9IhSnIg02AgwgACAEKAIQIgytIAM1AhBCACAUQiCIfUL/////D4N8fSIUpyIPNgIQIAAgBCgCFCIQrSADNQIUQgAgFEIgiH1C/////w+DfH0iFKciETYCFCAAIAQoAhgiAa0gAzUCGEIAIBRCIIh9Qv////8Pg3x9IhSnIg42AhggACAEKAIcIgStIAM1AhxCACAUQiCIfUL/////D4N8fSIUQiCIp0EBaiAFciIDQQFrIgUgBHFBACADayIEIBSncXI2AhwgACABIAVxIAQgDnFyNgIYIAAgBSAQcSAEIBFxcjYCFCAAIAUgDHEgBCAPcXI2AhAgACAFIAtxIAQgDXFyNgIMIAAgBSAIcSACIARxcjYCCCAAIAUgCnEgBCAHcXI2AgQgACAFIAZxIAQgCXFyNgIAC9wCAQF/IAAgASgAHCICQRh0IAJBgP4DcUEIdHIgAkEIdkGA/gNxIAJBGHZycjYCACAAIAEoABgiAkEYdCACQYD+A3FBCHRyIAJBCHZBgP4DcSACQRh2cnI2AgQgACABKAAUIgJBGHQgAkGA/gNxQQh0ciACQQh2QYD+A3EgAkEYdnJyNgIIIAAgASgAECICQRh0IAJBgP4DcUEIdHIgAkEIdkGA/gNxIAJBGHZycjYCDCAAIAEoAAwiAkEYdCACQYD+A3FBCHRyIAJBCHZBgP4DcSACQRh2cnI2AhAgACABKAAIIgJBGHQgAkGA/gNxQQh0ciACQQh2QYD+A3EgAkEYdnJyNgIUIAAgASgABCICQRh0IAJBgP4DcUEIdHIgAkEIdkGA/gNxIAJBGHZycjYCGCAAIAEoAAAiAUEYdCABQYD+A3FBCHRyIAFBCHZBgP4DcSABQRh2cnI2AhwLowQCCX4HfyAAIAE1AgAgAjUCAH0iA6ciDDYCACAAIAE1AgQgAjUCBEIAIANCIIh9Qv////8Pg3x9IgOnIg02AgQgACABNQIIIAI1AghCACADQiCIfUL/////D4N8fSIEpyIONgIIIAAgATUCDCACNQIMQgAgBEIgiH1C/////w+DfH0iBaciDzYCDCAAIAE1AhAgAjUCEEIAIAVCIIh9Qv////8Pg3x9IganIhA2AhAgACABNQIUIAI1AhRCACAGQiCIfUL/////D4N8fSIHpyIRNgIUIAAgATUCGCACNQIYQgAgB0IgiH1C/////w+DfH0iCKciEjYCGCAAIAhC/////w+DIAdC/////w+DIAZC/////w+DIAVC/////w+DIARC/////w+DIANC/////w+DQoCAgIAQQv////8PIAwbfCIFQiCIfEL/////D3wiBkIgiHwiB0IgiHwiCUIgiHwiCkIgiHxCAXwiC0IgiCABNQIcIAI1AhxCACAIQiCIfUL/////D4N8fSIEfKdBAWsgBEIgiCIDpyIBcSABQX9zIgIgBKdxcjYCHCAAIAMgC4OnIAIgEnFyNgIYIAAgAyAKg6cgAiARcXI2AhQgACADIAmDpyACIBBxcjYCECAAIAMgB4OnIAIgD3FyNgIMIAAgAyAGg6cgAiAOcXI2AgggACADIAWDpyACIA1xcjYCBCAAIAxBAWsgAXEgAiAMcXI2AgALyAIBAX8jAEHgAGsiAyQAIANBIGogAiACQZCLLRDFBSADQUBrIAAgA0EgakGQiy0QywUgAyAAIANBIGoQxwUgA0EgaiADQUBrIANBkIstEMUFIANBQGsgA0EgaiADQSBqQZCLLRDLBSADQUBrIANBQGsgA0EgakGQiy0QywUgAyABIAFBkIstEMUFIAMgAyADQZCLLRDLBSADQSBqIAAgA0GQiy0QxQUgA0EgaiADQSBqIANBIGpBkIstEMsFIAMgAyADQZCLLRDFBSADIAMgA0GQiy0QywUgACADQUBrIANBQGtBkIstEMUFIAAgACADQSBqEMcFIAAgACADQSBqEMcFIAIgASACQZCLLRDFBSACIAIgAkGQiy0QywUgASADQSBqIAAQxwUgASABIANBQGtBkIstEMUFIAEgASADEMcFIANB4ABqJAALqQIBAX8jAEHgAGsiBSQAIAVBQGsgAiACQZCLLRDFBSAFQSBqIAVBQGsgAkGQiy0QxQUgBUFAayAFQUBrIANBkIstEMUFIAVBIGogBUEgaiAEQZCLLRDFBSAFQUBrIAVBQGsgABDHBSAFQSBqIAVBIGogARDHBSACIAIgBUFAa0GQiy0QxQUgBSAFQUBrIAVBQGtBkIstEMUFIAVBQGsgBSAFQUBrQZCLLRDFBSAFIAUgAEGQiy0QxQUgACAFQSBqIAVBIGpBkIstEMUFIAAgACAFEMcFIAAgACAFEMcFIAAgACAFQUBrEMcFIAUgBSAAEMcFIAUgBSAFQSBqQZCLLRDFBSAFQUBrIAVBQGsgAUGQiy0QxQUgASAFIAVBQGsQxwUgBUHgAGokAAuAAgEDfyMAQSBrIgMkACADIAEoAgA2AgAgAyABKAIENgIEIAMgASgCCDYCCCADIAEoAgw2AgwgAyABKAIQNgIQIAMgASgCFDYCFCADIAEoAhg2AhggAyABKAIcNgIcIABCADcCBCAAQQE2AgAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAgwgAEEANgIcIAAgACACQSBqIAIQxQUgAigCAEECayEBA0BBACEFA0AgAUEBcQRAIAAgACADIAIQxQULIAMgAyADIAIQxQUgAUEBdiEBIAVBAWoiBUEgRw0ACyAEQQdHBEAgAiAEQQFqIgRBAnRqKAIAIQEMAQsLIANBIGokAAvcBAIIfgd/IAAgAigCACIMIAEoAgBqIg02AgAgACACNQIEIAE1AgQgDCANS618fCIEpyIMNgIEIAAgAjUCCCABNQIIIARCIIh8fCIFpyIONgIIIAAgAjUCDCABNQIMIAVCIIh8fCIGpyIPNgIMIAAgAjUCECABNQIQIAZCIIh8fCIHpyIQNgIQIAAgAjUCFCABNQIUIAdCIIh8fCIIpyIRNgIUIAAgAjUCGCABNQIYIAhCIIh8fCIJpyISNgIYIAAgAjUCHCABNQIcIAlCIIh8fCIKpyICNgIcIAAgCkIgiKcgCkL/////D4MgAzUCHEIAIAlC/////w+DIAM1AhhCACAIQv////8PgyADNQIUQgAgB0L/////D4MgAzUCEEIAIAZC/////w+DIAM1AgxCACAFQv////8PgyADNQIIQgAgBEL/////D4MgAzUCBEIAIA2tIAM1AgB9IgRCIIh9Qv////8Pg3x9IgVCIIh9Qv////8Pg3x9IgZCIIh9Qv////8Pg3x9IgdCIIh9Qv////8Pg3x9IghCIIh9Qv////8Pg3x9IglCIIh9Qv////8Pg3x9IgpCIIh9Qv////8Pg3x9IgtCIIinQQFqciIDQQFrIgEgAnFBACADayICIAuncXI2AhwgACABIBJxIAIgCqdxcjYCGCAAIAEgEXEgAiAJp3FyNgIUIAAgASAQcSACIAincXI2AhAgACABIA9xIAIgB6dxcjYCDCAAIAEgDnEgAiAGp3FyNgIIIAAgASAMcSACIAWncXI2AgQgACABIA1xIAIgBKdxcjYCAAuQAwIJfwh+IAAgARDGBSAAIAAoAhwiA61CACAAKAIYIgStQgAgACgCFCIFrUIAIAAoAhAiBq1CACAAKAIMIgetQgAgACgCCCIIrUIAIAAoAgQiCa1CACAAKAIAIgqtQtHKjOMPfSILQiCIfUL/////D4N9QsKV550PfSIMQiCIfUL/////D4N9QoS93rgKfSINQiCIfUL/////D4N9Qq31m+cLfSIOQiCIfUL/////D4N9Qv////8PfSIPQiCIfUL/////D4N9Qv////8PfSIQQiCIfUL/////D4N9IhFCIIh9Qv////8Pg31C/////w99IhJCIIinIgFBf3MiAiASp3EgASADcXI2AhwgACACIBGncSABIARxcjYCGCAAIAIgEKdxIAEgBXFyNgIUIAAgAiAPp3EgASAGcXI2AhAgACACIA6ncSABIAdxcjYCDCAAIAIgDadxIAEgCHFyNgIIIAAgAiAMp3EgASAJcXI2AgQgACACIAuncSABIApxcjYCACAAIABB9IstQdSLLRDFBQvnAQECfyMAQUBqIgMkAEF/IQQCQCAAIAIQzgUNACABIAJBIGoQzgUNACADQSBqIAEgAUGQiy0QxQUgAyAAIABBkIstEMUFIAMgAyAAQZCLLRDFBSADIAMgABDHBSADIAMgABDHBSADIAMgABDHBSADIANBoIwtQZCLLRDLBSADKAIEIAMoAiRzIAMoAgAgAygCIHNyIAMoAgggAygCKHNyIAMoAgwgAygCLHNyIAMoAhAgAygCMHNyIAMoAhQgAygCNHNyIAMoAhggAygCOHNyIAMoAhwgAygCPHNyIQQLIANBQGskACAEC9EBACAAIAEQxgVBfyEBIAA1AhxCACAANQIYIAA1AhRCACAANQIQQgAgADUCDEIAIAA1AghCACAANQIEQgAgADUCAEL/////D31CIIh9Qv////8Pg31C/////w99QiCIfUL/////D4N9Qv////8PfUIgiH1C/////w+DfUIgiH1C/////w+DfUIgiH1C/////w+DfUIgiEIBfUKAgICAcIR8QiCIfUL/////D4N9Qv////8PfUKAgICAcFoEfyAAIABBsIstQZCLLRDFBUEABSABCwtBAQF/IwBBIGsiASQAIAFBt6wpNgIQIABB+YYqIAFBEGoQmwEgAUG3rCk2AgAgAEHghyogARCbASABQSBqJABBAAucBAIDfwF7IwBBwAFrIgEkACABQf69KjYCECAAQfmGKiABQRBqEJsBQZCWNCgCACECIABBIBCGASIDQSA2AgAgAkEAIAMoAgggAUHgAGogAUFAayABQSBqEMEFIQIgAUEAOgBgIAFBADoAYSABQQA6AGIgAUEAOgBjIAFBADoAZCABQQA6AGUgAUEAOgBmIAFBADoAZyABQQA6AGggAUEAOgBpIAFBADoAaiABQQA6AGsgAUEAOgBsIAFBADoAbSABQQA6AG4gAUEAOgBvIAFBADoAcCABQQA6AHEgAUEAOgByIAFBADoAcyABQQA6AHQgAUEAOgB1IAFBADoAdiABQQA6AHcgAUEAOgB4IAFBADoAeSABQQA6AHogAUEAOgB7IAFBADoAfCABQQA6AH0gAUEAOgB+IAFBADoAfyACRQRAIAEgAf0ABED9CwSAASABIAH9AARQ/QsEkAEgAUG8AWoiAkEANgIAIAFCADcCpAEgAUEBNgKgASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCrAEgAUGAAWogAUGAAWogAUGgAWpBkIstEMUFIAEgAf0ABCD9CwSAASABIAH9AAQw/QsEkAEgAkEANgIAIAFCADcCpAEgAUEBNgKgASABIAT9CwKsASABQYABaiABQYABaiABQaABakGQiy0QxQULIAFB/r0qNgIAIABB4IcqIAEQmwEgAUHAAWokAEEBC44EAQN/IwBBkAFrIgEkACABQbW/KjYCICAAQfmGKiABQSBqEJsBAkACf0HnsSkgAEEBEMgBIgNFDQAaIAMoAgBBIEcEQCAAKAIMQQA6AAQgACAAKAIMQQhqNgIMQeiyKQwBC0HftikgAEHAABCGASICRQ0AGiACQcAANgIAIAIoAgghAiABQfAAaiADKAIIEMIFRQ0BQaW2KQshAiADEJoBIAEgAjYCBCABQbW/KjYCACAAQfyIKiABEGwACyABQdAAaiABQTBqQdCKLUHwii0gAUHwAGoQwwUgAUEAOgBwIAFBADoAcSABQQA6AHIgAUEAOgBzIAFBADoAdCABQQA6AHUgAUEAOgB2IAFBADoAdyABQQA6AHggAUEAOgB5IAFBADoAeiABQQA6AHsgAUEAOgB8IAFBADoAfSABQQA6AH4gAUEAOgB/IAFBADoAgAEgAUEAOgCBASABQQA6AIIBIAFBADoAgwEgAUEAOgCEASABQQA6AIUBIAFBADoAhgEgAUEAOgCHASABQQA6AIgBIAFBADoAiQEgAUEAOgCKASABQQA6AIsBIAFBADoAjAEgAUEAOgCNASABQQA6AI4BIAFBADoAjwEgAiABQdAAakGQiy0QxAUgAkEgaiABQTBqQZCLLRDEBSADEJoBIAFBtb8qNgIQIABB4IcqIAFBEGoQmwEgAUGQAWokAEEBC0EBAX8jAEEgayIBJAAgAUHHtSo2AhAgAEH5hiogAUEQahCbASABQce1KjYCACAAQeCHKiABEJsBIAFBIGokAEEBC80BAQN/IwBB8ABrIgEkACABQYXYKjYCICAAQfmGKiABQSBqEJsBIAFBADYCLCABQQA2AiggACABQSxqIAFBKGoQ1AUhAyABKAIsIQIgA0UEQCABQdAAaiABQTBqIAIoAggQzQUhAyAAKAIMQQFBESADGzoABCAAIAAoAgxBCGo2AgwLIAIQmgEgASgCKCICBEAgASACNgIUIAFBhdgqNgIQIABB/IgqIAFBEGoQbAALIAFBhdgqNgIAIABB4IcqIAEQmwEgAUHwAGokAEEBC8UGAQp/IwBB4ABrIgMkAEEBIQQCQCAAQQEQyAEiBUUEQCACQd+2KTYCAAwBCyABIABBwAAQmAEiBDYCAAJAAkAgBEUEQCAFEJoBIAJB+bQpNgIADAELIARBwAA2AgACQAJAAkAgBSgCACIAQUBqDgIAAQILQQAhBANAIAEoAgAoAgggBGogBSgCCCAEai0AADoAACAEQQFyIgAgASgCACgCCGogBSgCCCAAai0AADoAACAEQQJqIgRBwABHDQALDAMLIAUoAggtAABBBEYEQEEAIQQDQCABKAIAKAIIIARqIAUoAgggBGotAAE6AAAgBEEBciIAIAEoAgAoAghqIAUoAgggAGotAAE6AAAgBEECaiIEQcAARw0ACwwDCyACQfG2KzYCACAFEJoBDAELIABBIUcEQCAFEJoBIAJBj+AqNgIADAELIAUoAggiAS0AACILQf4BcUECRwRAIAJBn7crNgIAIAUQmgEMAQsgBCgCCCEKQX8hBCADQUBrIAFBAWoQzgVFBEAgAyADQUBrIANBQGtBkIstEMUFIAMgAyADQUBrQZCLLRDFBSADIAMgA0FAaxDHBSADIAMgA0FAaxDHBSADIAMgA0FAaxDHBSADIANBoIwtQZCLLRDLBUEAIQQgA0EANgI8IANCADcCJCADQQE2AiAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAiwgA0EgaiADQSBqQbCLLUGQiy0QxQVB/////wMhAUGAgICAfCEAQYCAgIAEIQJBgICAgAQhCQNAIARBAXEEQCADQSBqIANBIGogA0GQiy0QxQULIAMgAyADQZCLLRDFBSAGQR90IQwgAkEfdCAGQQF2ciIGIAwgBEEBdnIiBHIgB0EfdCACQQF2ciICciAIQR90IAdBAXZyIgdyIAlBH3QgCEEBdnIiCHIgAEEfdCAJQQF2ciIJciABQR90IABBAXZyIgByIAFBAXYiAXINAAsgAygCIEEBcSALQQFxRwRAIANBIGpBkIstIANBIGoQxwULIAogA0FAa0GQiy0QxAUgCkEgaiADQSBqQZCLLRDEBUEAIQQLIAUQmgEMAgtBASEEDAELIAUQmgFBACEECyADQeAAaiQAIAQLvA8DEH8Bewh+IwBB4ARrIgEkACABQei6KjYCICAAQfmGKiABQSBqEJsBIAAoAgwhBCAAKAIUKAIAIQVBkJY0KAIAIQYCfwJAIABBARDIASIORQRAQeexKSEDDAELIABBAhDIASINRQRAQcqfKyEDQQAhDQwBCyAOKAIAQSBHBEAgAEEMaiICKAIAQQA6AAQgAiACKAIAQQhqNgIAQcayKSEDQQAMAgsgAUH8AGoiCEEAQYAC/AsAIAFBIDYCvAMgAUKrs4/8kaOz8NsANwJ0IAFC/6S5iMWR2oKbfzcCbCABQvLmu+Ojp/2npX83AmQgAULnzKfQ1tDrs7t/NwJcIAFCADcCVCANKAIAIglBAEoEQCANKAIIIQoDQCAIIAEoAlQiAkEDdkE8cWoiAyAHIApqLQAAIAMoAgBBCHRyNgIAIAEgAkEIaiICNgJUAkACQCACRQRAIAFBADYCVCABIAEoAlhBAWo2AlgMAQsgAkH/A3ENAQsgAUHUAGoQ9wELIAdBAWoiByAJRw0ACwsgAUHUAGogAUEwahD4ASAAQcAAEIYBIgJFBEBB54crIQMMAQsgAkHAADYCAEEAIQcCQCAEIAVrQQhrQRFIDQAgAEEDEMgBIgcNAEHRsykhAwwBCyAOKAIIIQ8gAigCCCECAkACQCAGIAcgAUHAA2ogAUGABGogAUGgBGogAUHgA2oQwQUNACABQYAEaiABQYAEakH0iy1B1IstEMUFIAFBADYC3AQgAUEBNgLABCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCzAQgAUIANwLEBCABQaAEaiABQaAEaiABQcAEakGQiy0QxQUgASABKAK8BCIQrUIAIAEoArgEIgutQgAgASgCtAQiDK1CACABKAKwBCIGrUIAIAEoAqwEIgWtQgAgASgCqAQiBK1CACABKAKkBCIKrUIAIAEoAqAEIgmtQtHKjOMPfSISQiCIfUL/////D4N9QsKV550PfSITQiCIfUL/////D4N9QoS93rgKfSIUQiCIfUL/////D4N9Qq31m+cLfSIVQiCIfUL/////D4N9Qv////8PfSIWQiCIfUL/////D4N9Qv////8PfSIXQiCIfUL/////D4N9IhhCIIh9Qv////8Pg31C/////w99IhlCIIinIgNBf3MiCCASp3EgAyAJcXIiCTYCoAQgASAIIBOncSADIApxciIKNgKkBCABIAggFKdxIAMgBHFyIgQ2AqgEIAEgCCAVp3EgAyAFcXIiBTYCrAQgASAIIBancSADIAZxciIGNgKwBCABIAggF6dxIAMgDHFyIgw2ArQEIAEgCCAYp3EgAyALcXIiCzYCuAQgASAIIBmncSADIBBxciIDNgK8BCAJIApyIARyIAVyIAZyIAxyIAtyIANyRQ0AIAIgCjoAGyACIAQ6ABcgAiAFOgATIAIgBjoADyACIApBCHY6ABogAiAKQRB2OgAZIAIgCkEYdjoAGCACIARBCHY6ABYgAiAEQRB2OgAVIAIgBEEYdjoAFCACIAVBCHY6ABIgAiAFQRB2OgARIAIgBUEYdjoAECACIAZBCHY6AA4gAiAGQRB2OgANIAIgBkEYdjoADCACIAlBGHQgCUGA/gNxQQh0ciAJQQh2QYD+A3EgCUEYdnJyNgAcIAIgDDoACyACIAxBCHY6AAogAiAMQRB2OgAJIAIgDEEYdjoACCACIAs6AAcgAiALQQh2OgAGIAIgC0EQdjoABSACIAtBGHY6AAQgAiADOgADIAIgA0EIdjoAAiACIANBEHY6AAEgAiADQRh2OgAAIAFBoARqIAFBoARqQfSLLUHUiy0QxQUgAUHgA2ogAUEwahDMBSABQcADaiAPEMIFDQAgAUHAA2ogAUHAA2pB9IstQdSLLRDFBSABQYAEaiABQYAEakHUiy0QygUgAUHAA2ogAUGgBGogAUHAA2pB1IstEMUFIAFBwANqIAFB4ANqIAFBwANqQdSLLRDLBSABQcADaiABQYAEaiABQcADakHUiy0QxQVBACEDIAFBADoAgAQgAUEAOgCBBCABQQA6AIIEIAFBADoAgwQgAUEAOgCEBCABQQA6AIUEIAFBADoAhgQgAUEAOgCHBCABQQA6AIgEIAFBADoAiQQgAUEAOgCKBCABQQA6AIsEIAFBADoAjAQgAUEAOgCNBCABQQA6AI4EIAFBADoAjwQgAUEAOgCQBCABQQA6AJEEIAFBADoAkgQgAUEAOgCTBCABQQA6AJQEIAFBADoAlQQgAUEAOgCWBCABQQA6AJcEIAFBADoAmAQgAUEAOgCZBCABQQA6AJoEIAFBADoAmwQgAUEAOgCcBCABQQA6AJ0EIAFBADoAngQgAUEAOgCfBCABKALAAyABKALEAyABKALIAyABKALMAyABKALQAyABKALUAyABKALcAyABKALYA3JycnJycnINASACIBH9CwAAIAIgEf0LABALQbOfKyEDQQAMAgsgAkEgaiABQcADakHUiy0QxAVBAQwBC0EAIQdBAAshAiANEJoBIA4QmgEgBxCaASACRQRAIAEgAzYCFCABQei6KjYCECAAQfyIKiABQRBqEGwACyABQei6KjYCACAAQeCHKiABEJsBIAFB4ARqJABBAQvwEgMbfwF7CH4jAEHgBWsiASQAIAFBna8pNgIgIABB+YYqIAFBIGoQmwEgAUEANgIsIAFBADYCKAJ/IAAgAUEoaiABQSxqENQFRQRAIABBAhDIASIGRQRAQQAhBkHKnysMAgsgAEEDEMgBIgVFBEBBACEFQeeHKwwCCyAFKAIAQcAARwRAIAAoAgxBADoABCAAIAAoAgxBCGo2AgxB7YgrDAILIAFB/ABqIgdBAEGAAvwLACABQSA2ArwDIAFCq7OP/JGjs/DbADcCdCABQv+kuYjFkdqCm383AmwgAULy5rvjo6f9p6V/NwJkIAFC58yn0NbQ67O7fzcCXCABQgA3AlRBASEEIAYoAgAiCEEASgRAIAYoAgghCQNAIAcgASgCVCIDQQN2QTxxaiIKIAIgCWotAAAgCigCAEEIdHI2AgAgASADQQhqIgM2AlQCQAJAIANFBEAgAUEANgJUIAEgASgCWEEBajYCWAwBCyADQf8DcQ0BCyABQdQAahD3AQsgAkEBaiICIAhHDQALCyABQdQAaiABQTBqEPgBIAEoAigoAgghAwJAIAFBgAVqIAUoAggiAhDCBQ0AIAFB4ARqIAJBIGoQwgUNACABQcAEaiABQTBqEMwFIAFB4ARqIAFB4ARqQfSLLUHUiy0QxQUgAUHgBGogAUHgBGpB1IstEMoFIAFBoARqIAFBwARqIAFB4ARqQdSLLRDFBSABQdwFaiICQQA2AgAgAUIANwLEBSABQQE2AsAFIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwLMBSABQaAEaiABQaAEaiABQcAFakHUiy0QxQUgASABKAKABSIKNgKABCABIAEoAoQFIgc2AoQEIAEgASgCiAUiCDYCiAQgASABKAKMBSIJNgKMBCABIAEoApAFIhI2ApAEIAEgASgClAUiEzYClAQgASABKAKYBSIUNgKYBCABIAEoApwFIhU2ApwEIAFBgARqIAFBgARqQfSLLUHUiy0QxQUgAUGABGogAUGABGogAUHgBGpB1IstEMUFIAJBADYCACABQgA3AsQFIAFBATYCwAUgASAc/QsCzAUgAUGABGogAUGABGogAUHABWpB1IstEMUFIAFB4ANqIAFBwANqIAMQzQUNACABQcAEaiABQeAEaiABQeADaiABQcADaiABQYAEahDDBQJAIAEoArwEIAEoArgEIAEoArQEIAEoArAEIAEoAqwEIAEoAqgEIAEoAqQEIAEoAqAEcnJycnJyckUEQCABIAH9AATABP0LBKAEIAEgAf0ABNAE/QsEsAQMAQsgAUHgA2ogAUHAA2pB0IotQfCKLSABQaAEahDDBSABIAEoAuADIgI2AqAEIAEgASgC5AMiAzYCpAQgASABKALoAyIENgKoBCABIAEoAuwDIgs2AqwEIAEgASgC8AMiDDYCsAQgASABKAL0AyINNgK0BCABIAEoAvgDIg42ArgEIAEgASgC/AMiDzYCvAQgASABKALAAyIQNgKABCABQgA3ArQFIAFBADYCvAUgAUEBNgKgBSABIBz9CwKkBSABIAEoAsQDIhE2AoQEIAEgASgCyAMiFjYCiAQgASABKALMAyIXNgKMBCABIAEoAtADIhg2ApAEIAEgASgC1AMiGTYClAQgASABKALYAyIaNgKYBCABIAEoAtwDIhs2ApwEIAFBoAVqIAFBoAVqQbCLLUGQiy0QxQUCQAJAIAIgASgCwARHDQAgASgCxAQgA0cNACABKALIBCAERw0AIAEoAswEIAtHDQAgASgC0AQgDEcNACABKALUBCANRw0AIAEoAtgEIA5HDQAgASgC3AQgD0YNAQsgAUGgBGogAUGABGogAUGgBWogAUHABGogAUHgBGoQyQUgAUGgBWogAUGgBWpBkIstEMoFIAFBwAVqIAFBoAVqIAFBoAVqQZCLLRDFBSABQaAEaiABQaAEaiABQcAFakGQiy0QxQUgAUHABWogAUHABWogAUGgBWpBkIstEMUFIAFBgARqIAFBgARqIAFBwAVqQZCLLRDFBQwBCwJAIAEoAuAEIBBHDQAgASgC5AQgEUcNACABKALoBCAWRw0AIAEoAuwEIBdHDQAgASgC8AQgGEcNACABKAL0BCAZRw0AIAEoAvgEIBpHDQAgASgC/AQgG0cNACABQaAEaiABQYAEaiABQaAFahDIBSABQaAFaiABQaAFakGQiy0QygUgAUHABWogAUGgBWogAUGgBWpBkIstEMUFIAFBoARqIAFBoARqIAFBwAVqQZCLLRDFBSABQcAFaiABQcAFaiABQaAFakGQiy0QxQUgAUGABGogAUGABGogAUHABWpBkIstEMUFDAELIAEgHP0LBLAEIAEgHP0LBKAEIAFBoARqIAFBoARqQbCLLUGQiy0QxQUgASAc/QsEkAQgASAc/QsEgAQgAUGABGogAUGABGpBsIstQZCLLRDFBQsgAUEANgLcBSABIBz9CwLMBSABQQE2AsAFIAFCADcCxAUgAUGgBGogAUGgBGogAUHABWpBkIstEMUFQQFBAUEBQQFBAUEBQQFBEUEBIAogASgCvAQiBK1CACABKAK4BCILrUIAIAEoArQEIgytQgAgASgCsAQiDa1CACABKAKsBCIOrUIAIAEoAqgEIg+tQgAgASgCpAQiEK1CACABKAKgBCIRrULRyozjD30iHUIgiH1C/////w+DfULCleedD30iHkIgiH1C/////w+DfUKEvd64Cn0iH0IgiH1C/////w+DfUKt9ZvnC30iIEIgiH1C/////w+DfUL/////D30iIUIgiH1C/////w+DfUL/////D30iIkIgiH1C/////w+DfSIjQiCIfUL/////D4N9Qv////8PfSIkQiCIpyICQX9zIgMgHadxIAIgEXFyRhsgByADIB6ncSACIBBxckcbIAggAyAfp3EgAiAPcXJHGyAJIAMgIKdxIAIgDnFyRxsgEiADICGncSACIA1xckcbIBMgAyAip3EgAiAMcXJHGyAUIAMgI6dxIAIgC3FyRxsgFSADICSncSACIARxckcbIQQLIAAoAgwgBDoABCAAIAAoAgxBCGo2AgwLIAEoAiwLIQIgBhCaASAFEJoBIAEoAigQmgEgAgRAIAEgAjYCFCABQZ2vKTYCECAAQfyIKiABQRBqEGwACyABQZ2vKTYCACAAQeCHKiABEJsBIAFB4AVqJABBAQuBCgEDfyMAQTBrIgMkACADQdSlKTYCICAAQfmGKiADQSBqEJsBIANBADYCLCADQQA2AigCQAJAAkAgACADQShqIANBLGoQ1AUEQCADKAIoIQIMAQsgAEEhEIYBIQEgAygCKCECIAFFBEBBs4ArIQEgAhCaAQwCCyABKAIIIAIoAggtAAA6AAAgASgCCCACKAIILQABOgABIAEoAgggAigCCC0AAjoAAiABKAIIIAIoAggtAAM6AAMgASgCCCACKAIILQAEOgAEIAEoAgggAigCCC0ABToABSABKAIIIAIoAggtAAY6AAYgASgCCCACKAIILQAHOgAHIAEoAgggAigCCC0ACDoACCABKAIIIAIoAggtAAk6AAkgASgCCCACKAIILQAKOgAKIAEoAgggAigCCC0ACzoACyABKAIIIAIoAggtAAw6AAwgASgCCCACKAIILQANOgANIAEoAgggAigCCC0ADjoADiABKAIIIAIoAggtAA86AA8gASgCCCACKAIILQAQOgAQIAEoAgggAigCCC0AEToAESABKAIIIAIoAggtABI6ABIgASgCCCACKAIILQATOgATIAEoAgggAigCCC0AFDoAFCABKAIIIAIoAggtABU6ABUgASgCCCACKAIILQAWOgAWIAEoAgggAigCCC0AFzoAFyABKAIIIAIoAggtABg6ABggASgCCCACKAIILQAZOgAZIAEoAgggAigCCC0AGjoAGiABKAIIIAIoAggtABs6ABsgASgCCCACKAIILQAcOgAcIAEoAgggAigCCC0AHToAHSABKAIIIAIoAggtAB46AB4gASgCCCACKAIILQAfOgAfIAEoAghBADoAISABQSA2AgAgAEEhEIYBIgFFBEBBlYArIQEgAhCaAQwCCyABKAIIIAIoAggtACA6AAAgASgCCCACKAIILQAhOgABIAEoAgggAigCCC0AIjoAAiABKAIIIAIoAggtACM6AAMgASgCCCACKAIILQAkOgAEIAEoAgggAigCCC0AJToABSABKAIIIAIoAggtACY6AAYgASgCCCACKAIILQAnOgAHIAEoAgggAigCCC0AKDoACCABKAIIIAIoAggtACk6AAkgASgCCCACKAIILQAqOgAKIAEoAgggAigCCC0AKzoACyABKAIIIAIoAggtACw6AAwgASgCCCACKAIILQAtOgANIAEoAgggAigCCC0ALjoADiABKAIIIAIoAggtAC86AA8gASgCCCACKAIILQAwOgAQIAEoAgggAigCCC0AMToAESABKAIIIAIoAggtADI6ABIgASgCCCACKAIILQAzOgATIAEoAgggAigCCC0ANDoAFCABKAIIIAIoAggtADU6ABUgASgCCCACKAIILQA2OgAWIAEoAgggAigCCC0ANzoAFyABKAIIIAIoAggtADg6ABggASgCCCACKAIILQA5OgAZIAEoAgggAigCCC0AOjoAGiABKAIIIAIoAggtADs6ABsgASgCCCACKAIILQA8OgAcIAEoAgggAigCCC0APToAHSABKAIIIAIoAggtAD46AB4gASgCCCACKAIILQA/OgAfIAEoAghBADoAISABQSA2AgALIAMoAiwhASACEJoBIAFFDQELIAMgATYCBCADQdSlKTYCACAAQfyIKiADEGwACyADQdSlKTYCECAAQeCHKiADQRBqEJsBIANBMGokAEECC4YFAQR/IwBBkAFrIgMkACADQfvJKzYCICAAQfmGKiADQSBqEJsBIANBADYCLCADQQA2AigCQAJAIAAgA0EoaiADQSxqENQFBEAgAygCKCEEDAELIABBIRCGASEBIAMoAighBCABBH8gAUEhNgIAIAEoAgghASADQdAAaiADQTBqIAQoAggiAhDNBUUEQCADQQA2AowBIANCADcCdCAD/QwAAAAAAAAAAAAAAAAAAAAA/QsCfCADQQE2AnAgA0EwaiADQTBqIANB8ABqQZCLLRDFBSABIAMtADBBAXFBAnI6AAAgASACLQAAOgABIAEgAi0AAToAAiABIAItAAI6AAMgASACLQADOgAEIAEgAi0ABDoABSABIAItAAU6AAYgASACLQAGOgAHIAEgAi0ABzoACCABIAItAAg6AAkgASACLQAJOgAKIAEgAi0ACjoACyABIAItAAs6AAwgASACLQAMOgANIAEgAi0ADToADiABIAItAA46AA8gASACLQAPOgAQIAEgAi0AEDoAESABIAItABE6ABIgASACLQASOgATIAEgAi0AEzoAFCABIAItABQ6ABUgASACLQAVOgAWIAEgAi0AFjoAFyABIAItABc6ABggASACLQAYOgAZIAEgAi0AGToAGiABIAItABo6ABsgASACLQAbOgAcIAEgAi0AHDoAHSABIAItAB06AB4gASACLQAeOgAfIAEgAi0AHzoAIAwCC0GbtSkFQce3KQshASAEEJoBDAELIAMoAiwhASAEEJoBIAENACADQfvJKzYCECAAQeCHKiADQRBqEJsBIANBkAFqJABBAQ8LIAMgATYCBCADQfvJKzYCACAAQfyIKiADEGwAC+cOAQN/IAAoAgghAyABQQBByAD8CwAgA0HAAWohAwNAIAFBCBDaBRogASABKAIAIAIgA2otAABqNgIAIAJBAWoiAkHAAEcNAAsgACgCCCEEQQAhAyABQcgAaiICQQBByAD8CwAgBEGAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQZABaiICQQBByAD8CwAgBEFAayEEA0AgAkEIENoFGiACIAIoAgAgAyAEai0AAGo2AgAgA0EBaiIDQcAARw0ACyAAKAIIIQRBACEDIAFB2AFqIgJBAEHIAPwLAANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsCQCAAKAIAIgJBgAJMBEAgAEEANgIADAELIAAgAkGAAms2AgBBACECA0AgACgCCCACaiIDIAMtAIACOgAAIAJBAWoiAiAAKAIASA0ACwsgACgCCCEEQQAhAyABQaACaiICQQBByAD8CwAgBEHAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQegCaiICQQBByAD8CwAgBEGAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQbADaiICQQBByAD8CwAgBEFAayEEA0AgAkEIENoFGiACIAIoAgAgAyAEai0AAGo2AgAgA0EBaiIDQcAARw0ACyAAKAIIIQRBACEDIAFB+ANqIgJBAEHIAPwLAANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsCQCAAKAIAIgJBgAJMBEAgAEEANgIADAELIAAgAkGAAms2AgBBACECA0AgACgCCCACaiIDIAMtAIACOgAAIAJBAWoiAiAAKAIASA0ACwsgACgCCCEEQQAhAyABQcAEaiICQQBByAD8CwAgBEHAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQYgFaiICQQBByAD8CwAgBEGAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQdAFaiICQQBByAD8CwAgBEFAayEEA0AgAkEIENoFGiACIAIoAgAgAyAEai0AAGo2AgAgA0EBaiIDQcAARw0ACyAAKAIIIQRBACEDIAFBmAZqIgJBAEHIAPwLAANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsCQCAAKAIAIgJBgAJMBEAgAEEANgIADAELIAAgAkGAAms2AgBBACECA0AgACgCCCACaiIDIAMtAIACOgAAIAJBAWoiAiAAKAIASA0ACwsgACgCCCEEQQAhAyABQeAGaiICQQBByAD8CwAgBEHAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQagHaiICQQBByAD8CwAgBEGAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQfAHaiICQQBByAD8CwAgBEFAayEEA0AgAkEIENoFGiACIAIoAgAgAyAEai0AAGo2AgAgA0EBaiIDQcAARw0ACyAAKAIIIQRBACEDIAFBuAhqIgJBAEHIAPwLAANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsCQCAAKAIAIgJBgAJMBEAgAEEANgIADAELIAAgAkGAAms2AgBBACECA0AgACgCCCACaiIDIAMtAIACOgAAIAJBAWoiAiAAKAIASA0ACwsgACgCCCEEQQAhAyABQYAJaiICQQBByAD8CwAgBEHAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQcgJaiICQQBByAD8CwAgBEGAAWohBANAIAJBCBDaBRogAiACKAIAIAMgBGotAABqNgIAIANBAWoiA0HAAEcNAAsgACgCCCEEQQAhAyABQZAKaiICQQBByAD8CwAgBEFAayEEA0AgAkEIENoFGiACIAIoAgAgAyAEai0AAGo2AgAgA0EBaiIDQcAARw0ACyAAKAIIIQNBACECIAFB2ApqIgFBAEHIAPwLAANAIAFBCBDaBRogASABKAIAIAIgA2otAABqNgIAIAJBAWoiAkHAAEcNAAsgACgCACIBQYACTARAIABBADYCAA8LIAAgAUGAAms2AgBBACEBA0AgACgCCCABaiICIAItAIACOgAAIAFBAWoiASAAKAIASA0ACwvFBAEEfyAAIAAoAkQgAXQgACgCQCIDQR0gAWsiBXVyNgJEIAAgAyABdEH+////AXEgAEE8aiIDKAIAIgQgBXVyNgJAIAMgBCABdEH+////AXEgAEE4aiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEE0aiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgAEEwaiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEEsaiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgAEEoaiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEEkaiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgAEEgaiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEEcaiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgAEEYaiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEEUaiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgAEEQaiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEEMaiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgAEEIaiIEKAIAIgIgBXVyNgIAIAQgAiABdEH+////AXEgAEEEaiIDKAIAIgIgBXVyNgIAIAMgAiABdEH+////AXEgACgCACIEIAV1cjYCACAAIAQgAXRB/v///wFxNgIAIAAoAkRBE3ULsBABDH8jAEGQEGsiAyQAIANBwJEqNgIgIABB+YYqIANBIGoQmwECQAJAAkACQAJAAkACQAJAAkAgACgCDCIBIAAoAhQoAgBBCGoiAmtBCGsOEQADAwMDAwMDAQMDAwMDAwMCAwsgASACSwRAIAItAARBA0YNBAwHCyAAKAIQLQAwQQNHDQZBkJY0KAIAKAIkIQEgA0EANgLwBCAAKAIQQSxqIQIMBAsgAEEBQcHiKRDcASECIABBAkHB4ikQ3AEhASACRQ0EIAFFDQQgAEEEEJgBGkGU+CohBSACKAIAQYACSg0GIABBBBCYARogASgCAEGAAkoNBkEAQYGABCADQfAEaiADQSxqIAIgARDcBSACEJoBIAEQmgEMBAsCQAJAAkAgASACSwRAIAItAARBA0YNAUGM1ikhBQwJCyAAKAIQLQAwQQNGDQFBjNYpIQUMCAsgA0EANgLwBAwBCyADQQA2AvAEIAAoAhBBLGohAgsgAi0ABEEDRwR/IAIgA0HwBGpBABD8ARogA0HwBGoFIAILKAIAIQQgAEECQcHiKRDcASECIABBA0HB4ikQ3AEhASACRQ0DIAFFDQMgAEEEEJgBGkGU+CohBSACKAIAQYACSg0FIABBBBCYARogASgCAEGAAkoNBUEAIAQgA0HwBGogA0EsaiACIAEQ3AUgAhCaASABEJoBDAMLQZCWNCgCACgCJEGBgAQgA0HwBGogA0EsakEAQQAQ3AUMAgtBkJY0KAIAKAIkIQEgA0EANgLwBAsgASACLQAEQQNHBH8gAiADQfAEakEAEPwBGiADQfAEagUgAgsoAgAgA0HwBGogA0EsakEAQQAQ3AULIABBAEECEKEBIABBgAoQhgEiAkUEQEHysykhBQwCCyAAIABBDGoiASgCAEEQa0Hf/yoQWSAAQYQEEIYBIghFBEBB37YpIQUMAgsgACABKAIAQRBrQe/GKxBZIABBgAIQmAEiBCADQfAEakEEEN0FIAIoAgQiBUEASgRAQQAhAQNAIAIoAgggAWpBADoAACABQQFqIgEgAigCBCIFSA0ACwsgAiAEKAIAIgEgBSABIAVIGyIBNgIAIAFBAEoEQCAEKAIIIQVBACEBA0AgAigCCCABaiABIAVqLQAAOgAAIAFBAWoiASACKAIASA0ACwsgBCADQZAHaiIJQQQQ3QUCQCAEKAIAIgZBAEoEQEEAIQEDQCACKAIAIAFqIgUgAigCBCIHTg0CIAIoAgggBWogBCgCCCABai0AADoAACABQQFqIgEgBkcNAAsLIAIoAgAgBmohBwsgAiAHNgIAIAQgA0GwCWoiCkEEEN0FAkAgBCgCACIGQQBKBEBBACEBA0AgAigCACABaiIFIAIoAgQiB04NAiACKAIIIAVqIAQoAgggAWotAAA6AAAgAUEBaiIBIAZHDQALCyACKAIAIAZqIQcLIAIgBzYCACAEIANB0AtqIgtBBBDdBQJAIAQoAgAiBkEASgRAQQAhAQNAIAIoAgAgAWoiBSACKAIEIgdODQIgAigCCCAFaiAEKAIIIAFqLQAAOgAAIAFBAWoiASAGRw0ACwsgAigCACAGaiEHCyACIAc2AgAgBCADQfANaiIMQQQQ3QUCQCAEKAIAIgZBAEoEQEEAIQEDQCACKAIAIAFqIgUgAigCBCIHTg0CIAIoAgggBWogBCgCCCABai0AADoAACABQQFqIgEgBkcNAAsLIAIoAgAgBmohBwsgAiAHNgIAIAQQmgEgCCADQTBqQQgQ3QUCQCAIKAIAIgRBBGoiASAIKAIESg0AIAMoAiwhAiAIKAIIIARqQQA6AAAgCCgCCCAEakEAOgABIAgoAgggBGpBADoAAiAIKAIIIARqQQA6AAMgCCABNgIAIARBfUgNACACQQBMDQADQCABQQFrIgQgCCgCCGogAjoAACABQQJJDQEgAkH/AUshBSACQQh2IQIgBCEBIAUNAAsLIANB8ARqQQBByAD8CwAgA0G4BWpBAEHIAPwLACADQYAGakEAQcgA/AsAIANByAZqQQBByAD8CwAgCUEAQcgA/AsAIANB2AdqQQBByAD8CwAgA0GgCGpBAEHIAPwLACADQegIakEAQcgA/AsAIApBAEHIAPwLACADQfgJakEAQcgA/AsAIANBwApqQQBByAD8CwAgA0GIC2pBAEHIAPwLACALQQBByAD8CwAgA0GYDGpBAEHIAPwLACADQeAMakEAQcgA/AsAIANBqA1qQQBByAD8CwAgDEEAQcgA/AsAIANBuA5qQQBByAD8CwAgA0GAD2pBAEHIAPwLACADQcgPakEAQcgA/AsAIANBwJEqNgIQIABB4IcqIANBEGoQmwEgA0GQEGokAEEBDwtBtNYpIQULIANB8ARqIgFBAEHIAPwLACABQcgAakEAQcgA/AsAIAFBkAFqQQBByAD8CwAgAUHYAWpBAEHIAPwLACABQaACakEAQcgA/AsAIAFB6AJqQQBByAD8CwAgAUGwA2pBAEHIAPwLACABQfgDakEAQcgA/AsAIAFBwARqQQBByAD8CwAgAUGIBWpBAEHIAPwLACABQdAFakEAQcgA/AsAIAFBmAZqQQBByAD8CwAgAUHgBmpBAEHIAPwLACABQagHakEAQcgA/AsAIAFB8AdqQQBByAD8CwAgAUG4CGpBAEHIAPwLACABQYAJakEAQcgA/AsAIAFByAlqQQBByAD8CwAgAUGQCmpBAEHIAPwLACABQdgKakEAQcgA/AsAIAMgBTYCBCADQcCRKjYCACAAQfyIKiADEGwAC8lLAgp/AXsjAEGACWsiBiQAAkAgAARAIAJBkAFqIQcgAkHIAGohCCACQdgBaiEKIAZBsANqIQsgBkHoAmohDSAGQfgDaiEOIAJBjAFqIQUgAkHUAWohBANAIAIgABDwCANAIAIQ6QUaIAIoAgBBA3FBA0ZFBEAgAhDpBRogAiACKAIAQQFqNgIAIAIQ6QUhDCACIAIoAkQgDEETdHM2AkQgCCAMIAgoAgBqNgIAIAgQ6QUhDCAFIAUoAgAgDEETdHM2AgAgByAMIAcoAgBqNgIAIAcQ6QUhDCAEIAQoAgAgDEETdHM2AgAgCiAMIAooAgBqNgIAIAoQ6QUaDAELCwNAIAIgABD5CEUEQCACEOkFGiACIAIoAgBBBGo2AgAgAhDpBSEMIAIgAigCRCAMQRN0czYCRCAIIAwgCCgCAGo2AgAgCBDpBSEMIAUgBSgCACAMQRN0czYCACAHIAwgBygCAGo2AgAgBxDpBSEMIAQgBCgCACAMQRN0czYCACAKIAwgCigCAGo2AgAgChDpBRoMAQsLIAYgAigCADYCoAIgBiACKAIENgKkAiAGIAIoAgg2AqgCIAYgAigCDDYCrAIgBiACKAIQNgKwAiAGIAIoAhQ2ArQCIAYgAigCGDYCuAIgBiACKAIcNgK8AiAGIAIoAiA2AsACIAYgAigCJDYCxAIgBiACKAIoNgLIAiAGIAIoAiw2AswCIAYgAigCMDYC0AIgBiACKAI0NgLUAiAGIAIoAjg2AtgCIAYgAigCPDYC3AIgBiACKAJANgLgAiAGIAIoAkQ2AuQCIAYgAigCSDYC6AIgBiACKAJMNgLsAiAGIAIoAlA2AvACIAYgAigCVDYC9AIgBiACKAJYNgL4AiAGIAIoAlw2AvwCIAYgAigCYDYCgAMgBiACKAJkNgKEAyAGIAIoAmg2AogDIAYgAigCbDYCjAMgBiACKAJwNgKQAyAGIAIoAnQ2ApQDIAYgAigCeDYCmAMgBiACKAJ8NgKcAyAGIAIoAoABNgKgAyAGIAIoAoQBNgKkAyAGIAIoAogBNgKoAyAGIAIoAowBNgKsAyAGIAIoApABNgKwAyAGIAIoApQBNgK0AyAGIAIoApgBNgK4AyAGIAIoApwBNgK8AyAGIAIoAqABNgLAAyAGIAIoAqQBNgLEAyAGIAIoAqgBNgLIAyAGIAIoAqwBNgLMAyAGIAIoArABNgLQAyAGIAIoArQBNgLUAyAGIAIoArgBNgLYAyAGIAIoArwBNgLcAyAGIAIoAsABNgLgAyAGIAIoAsQBNgLkAyAGIAIoAsgBNgLoAyAGIAIoAswBNgLsAyAGIAIoAtABNgLwAyAGIAIoAtQBNgL0AyAGIAIoAtgBNgL4AyAGIAIoAtwBNgL8AyAGIAIoAuABNgKABCAGIAIoAuQBNgKEBCAGIAIoAugBNgKIBCAGIAIoAuwBNgKMBCAGIAIoAvABNgKQBCAGIAIoAvQBNgKUBCAGIAIoAvgBNgKYBCAGIAIoAvwBNgKcBCAGIAIoAoACNgKgBCAGIAIoAoQCNgKkBCAGIAIoAogCNgKoBCAGIAIoAowCNgKsBCAGIAIoApACNgKwBCAGIAIoApQCNgK0BCAGIAIoApgCNgK4BCAGIAIoApwCNgK8BCAGIAYoAqQCIAYoAqACIgxBHXVqIglB/////wFxNgKkAiAGIAYoAqgCIAlBHXVqIglB/////wFxNgKoAiAGIAYoAqwCIAlBHXVqIglB/////wFxNgKsAiAGIAYoArACIAlBHXVqIglB/////wFxNgKwAiAGIAYoArQCIAlBHXVqIglB/////wFxNgK0AiAGIAYoArgCIAlBHXVqIglB/////wFxNgK4AiAGIAYoArwCIAlBHXVqIglB/////wFxNgK8AiAGIAYoAsACIAlBHXVqIglB/////wFxNgLAAiAGIAYoAsQCIAlBHXVqIglB/////wFxNgLEAiAGIAYoAsgCIAlBHXVqIglB/////wFxNgLIAiAGIAYoAswCIAlBHXVqIglB/////wFxNgLMAiAGIAYoAtACIAlBHXVqIglB/////wFxNgLQAiAGIAYoAtQCIAlBHXVqIglB/////wFxNgLUAiAGIAYoAtgCIAlBHXVqIglB/////wFxNgLYAiAGIAYoAtwCIAlBHXVqIglB/////wFxNgLcAiAGIAYoAuACIAlBHXVqIglB/////wFxNgLgAiAGIAYoAuQCIAlBHXVqNgLkAiAGIAxB/////wFxQQFrNgKgAiAGQaACahDpBSEMIAYgBigC5AIgDEETdHM2AuQCIAYgDCAGKALoAmo2AugCIA0Q6QUhDCAGIAYoAqwDIAxBE3RzNgKsAyAGIAwgBigCsANqNgKwAyALEOkFIQwgBiAGKAL0AyAMQRN0czYC9AMgBiAMIAYoAvgDajYC+AMgDhDpBRogBkGgAmogARD4CA0ACyACQbADaiEIIAJB6AJqIQogAkH4A2ohBSACQaACaiEHIAZBkAFqIQ0gBkHIAGohDiAGQdgBaiEPIAJBrANqIQQgAkH0A2ohDANAIAcgABDwCANAIAcQ6QUaIAcoAgBBA3FBA0ZFBEAgBxDpBRogAiACKAKgAkEBajYCoAIgBxDpBSEJIAIgAigC5AIgCUETdHM2AuQCIAogCSAKKAIAajYCACAKEOkFIQkgBCAEKAIAIAlBE3RzNgIAIAggCSAIKAIAajYCACAIEOkFIQkgDCAMKAIAIAlBE3RzNgIAIAUgCSAFKAIAajYCACAFEOkFGgwBCwsDQCAHIAAQ+QhFBEAgBxDpBRogAiACKAKgAkEEajYCoAIgBxDpBSEJIAIgAigC5AIgCUETdHM2AuQCIAogCSAKKAIAajYCACAKEOkFIQkgBCAEKAIAIAlBE3RzNgIAIAggCSAIKAIAajYCACAIEOkFIQkgDCAMKAIAIAlBE3RzNgIAIAUgCSAFKAIAajYCACAFEOkFGgwBCwsgBiACKAKgAjYCACAGIAIoAqQCNgIEIAYgAigCqAI2AgggBiACKAKsAjYCDCAGIAIoArACNgIQIAYgAigCtAI2AhQgBiACKAK4AjYCGCAGIAIoArwCNgIcIAYgAigCwAI2AiAgBiACKALEAjYCJCAGIAIoAsgCNgIoIAYgAigCzAI2AiwgBiACKALQAjYCMCAGIAIoAtQCNgI0IAYgAigC2AI2AjggBiACKALcAjYCPCAGIAIoAuACNgJAIAYgAigC5AI2AkQgBiACKALoAjYCSCAGIAIoAuwCNgJMIAYgAigC8AI2AlAgBiACKAL0AjYCVCAGIAIoAvgCNgJYIAYgAigC/AI2AlwgBiACKAKAAzYCYCAGIAIoAoQDNgJkIAYgAigCiAM2AmggBiACKAKMAzYCbCAGIAIoApADNgJwIAYgAigClAM2AnQgBiACKAKYAzYCeCAGIAIoApwDNgJ8IAYgAigCoAM2AoABIAYgAigCpAM2AoQBIAYgAigCqAM2AogBIAYgAigCrAM2AowBIAYgAigCsAM2ApABIAYgAigCtAM2ApQBIAYgAigCuAM2ApgBIAYgAigCvAM2ApwBIAYgAigCwAM2AqABIAYgAigCxAM2AqQBIAYgAigCyAM2AqgBIAYgAigCzAM2AqwBIAYgAigC0AM2ArABIAYgAigC1AM2ArQBIAYgAigC2AM2ArgBIAYgAigC3AM2ArwBIAYgAigC4AM2AsABIAYgAigC5AM2AsQBIAYgAigC6AM2AsgBIAYgAigC7AM2AswBIAYgAigC8AM2AtABIAYgAigC9AM2AtQBIAYgAigC+AM2AtgBIAYgAigC/AM2AtwBIAYgAigCgAQ2AuABIAYgAigChAQ2AuQBIAYgAigCiAQ2AugBIAYgAigCjAQ2AuwBIAYgAigCkAQ2AvABIAYgAigClAQ2AvQBIAYgAigCmAQ2AvgBIAYgAigCnAQ2AvwBIAYgAigCoAQ2AoACIAYgAigCpAQ2AoQCIAYgAigCqAQ2AogCIAYgAigCrAQ2AowCIAYgAigCsAQ2ApACIAYgAigCtAQ2ApQCIAYgAigCuAQ2ApgCIAYgAigCvAQ2ApwCIAYgBigCBCAGKAIAIglBHXVqIgtB/////wFxNgIEIAYgBigCCCALQR11aiILQf////8BcTYCCCAGIAYoAgwgC0EddWoiC0H/////AXE2AgwgBiAGKAIQIAtBHXVqIgtB/////wFxNgIQIAYgBigCFCALQR11aiILQf////8BcTYCFCAGIAYoAhggC0EddWoiC0H/////AXE2AhggBiAGKAIcIAtBHXVqIgtB/////wFxNgIcIAYgBigCICALQR11aiILQf////8BcTYCICAGIAYoAiQgC0EddWoiC0H/////AXE2AiQgBiAGKAIoIAtBHXVqIgtB/////wFxNgIoIAYgBigCLCALQR11aiILQf////8BcTYCLCAGIAYoAjAgC0EddWoiC0H/////AXE2AjAgBiAGKAI0IAtBHXVqIgtB/////wFxNgI0IAYgBigCOCALQR11aiILQf////8BcTYCOCAGIAYoAjwgC0EddWoiC0H/////AXE2AjwgBiAGKAJAIAtBHXVqIgtB/////wFxNgJAIAYgBigCRCALQR11ajYCRCAGIAlB/////wFxQQFrNgIAIAYQ6QUhCSAGIAYoAkQgCUETdHM2AkQgBiAJIAYoAkhqNgJIIA4Q6QUhCSAGIAYoAowBIAlBE3RzNgKMASAGIAkgBigCkAFqNgKQASANEOkFIQkgBiAGKALUASAJQRN0czYC1AEgBiAJIAYoAtgBajYC2AEgDxDpBRogBiABEPgIDQALDAELIAQoAgghCCACQQBByAD8CwAgCEHAAWohCANAIAJBCBDaBRogAiACKAIAIAcgCGotAABqNgIAIAdBAWoiB0HAAEcNAAsgBCgCCCEKQQAhCCACQcgAaiIHQQBByAD8CwAgCkGAAWohCgNAIAdBCBDaBRogByAHKAIAIAggCmotAABqNgIAIAhBAWoiCEHAAEcNAAsgBCgCCCEKQQAhCCACQZABaiIHQQBByAD8CwAgCkFAayEKA0AgB0EIENoFGiAHIAcoAgAgCCAKai0AAGo2AgAgCEEBaiIIQcAARw0ACyAEKAIIIQpBACEIIAJB2AFqIgdBAEHIAPwLAANAIAdBCBDaBRogByAHKAIAIAggCmotAABqNgIAIAhBAWoiCEHAAEcNAAsgBSgCCCEKQQAhCCACQaACaiIHQQBByAD8CwAgCkHAAWohCgNAIAdBCBDaBRogByAHKAIAIAggCmotAABqNgIAIAhBAWoiCEHAAEcNAAsgBSgCCCEKQQAhCCACQegCaiIHQQBByAD8CwAgCkGAAWohCgNAIAdBCBDaBRogByAHKAIAIAggCmotAABqNgIAIAhBAWoiCEHAAEcNAAsgBSgCCCEKQQAhCCACQbADaiIHQQBByAD8CwAgCkFAayEKA0AgB0EIENoFGiAHIAcoAgAgCCAKai0AAGo2AgAgCEEBaiIIQcAARw0ACyAFKAIIIQpBACEIIAJB+ANqIgdBAEHIAPwLAANAIAdBCBDaBRogByAHKAIAIAggCmotAABqNgIAIAhBAWoiCEHAAEcNAAsgBiACKAIANgKgAiAGIAIoAgQ2AqQCIAYgAigCCDYCqAIgBiACKAIMNgKsAiAGIAIoAhA2ArACIAYgAigCFDYCtAIgBiACKAIYNgK4AiAGIAIoAhw2ArwCIAYgAigCIDYCwAIgBiACKAIkNgLEAiAGIAIoAig2AsgCIAYgAigCLDYCzAIgBiACKAIwNgLQAiAGIAIoAjQ2AtQCIAYgAigCODYC2AIgBiACKAI8NgLcAiAGIAIoAkA2AuACIAYgAigCRDYC5AIgBiACKAJINgLoAiAGIAIoAkw2AuwCIAYgAigCUDYC8AIgBiACKAJUNgL0AiAGIAIoAlg2AvgCIAYgAigCXDYC/AIgBiACKAJgNgKAAyAGIAIoAmQ2AoQDIAYgAigCaDYCiAMgBiACKAJsNgKMAyAGIAIoAnA2ApADIAYgAigCdDYClAMgBiACKAJ4NgKYAyAGIAIoAnw2ApwDIAYgAigCgAE2AqADIAYgAigChAE2AqQDIAYgAigCiAE2AqgDIAYgAigCjAE2AqwDIAYgAigCkAE2ArADIAYgAigClAE2ArQDIAYgAigCmAE2ArgDIAYgAigCnAE2ArwDIAYgAigCoAE2AsADIAYgAigCpAE2AsQDIAYgAigCqAE2AsgDIAYgAigCrAE2AswDIAYgAigCsAE2AtADIAYgAigCtAE2AtQDIAYgAigCuAE2AtgDIAYgAigCvAE2AtwDIAYgAigCwAE2AuADIAYgAigCxAE2AuQDIAYgAigCyAE2AugDIAYgAigCzAE2AuwDIAYgAigC0AE2AvADIAYgAigC1AE2AvQDIAYgAigC2AE2AvgDIAYgAigC3AE2AvwDIAYgAigC4AE2AoAEIAYgAigC5AE2AoQEIAYgAigC6AE2AogEIAYgAigC7AE2AowEIAYgAigC8AE2ApAEIAYgAigC9AE2ApQEIAYgAigC+AE2ApgEIAYgAigC/AE2ApwEIAYgAigCgAI2AqAEIAYgAigChAI2AqQEIAYgAigCiAI2AqgEIAYgAigCjAI2AqwEIAYgAigCkAI2ArAEIAYgAigClAI2ArQEIAYgAigCmAI2ArgEIAYgAigCnAI2ArwEIAYgBigCoAIiB0H/////AXE2AqACIAYgBigCpAIgB0EddWoiB0H/////AXE2AqQCIAYgBigCqAIgB0EddWoiB0H/////AXE2AqgCIAYgBigCrAIgB0EddWoiB0H/////AXE2AqwCIAYgBigCsAIgB0EddWoiB0H/////AXE2ArACIAYgBigCtAIgB0EddWoiB0H/////AXE2ArQCIAYgBigCuAIgB0EddWoiB0H/////AXE2ArgCIAYgBigCvAIgB0EddWoiB0H/////AXE2ArwCIAYgBigCwAIgB0EddWoiB0H/////AXE2AsACIAYgBigCxAIgB0EddWoiB0H/////AXE2AsQCIAYgBigCyAIgB0EddWoiB0H/////AXE2AsgCIAYgBigCzAIgB0EddWoiB0H/////AXE2AswCIAYgBigC0AIgB0EddWoiB0H/////AXE2AtACIAYgBigC1AIgB0EddWoiB0H/////AXE2AtQCIAYgBigC2AIgB0EddWoiB0H/////AXE2AtgCIAYgBigC3AIgB0EddWoiB0H/////AXE2AtwCIAYgBigC4AIgB0EddWoiB0H/////AXE2AuACIAYgBigC5AIgB0EddWo2AuQCIAYgBigCoAJBAWs2AqACIAZBoAJqEOkFIQcgBiAGKALkAiAHQRN0czYC5AIgBiAHIAYoAugCajYC6AIgBkHoAmoQ6QUhByAGIAYoAqwDIAdBE3RzNgKsAyAGIAcgBigCsANqNgKwAyAGQbADahDpBSEHIAYgBigC9AMgB0ETdHM2AvQDIAYgByAGKAL4A2o2AvgDIAZB+ANqEOkFGiAGIAIoAqACNgIAIAYgAigCpAI2AgQgBiACKAKoAjYCCCAGIAIoAqwCNgIMIAYgAigCsAI2AhAgBiACKAK0AjYCFCAGIAIoArgCNgIYIAYgAigCvAI2AhwgBiACKALAAjYCICAGIAIoAsQCNgIkIAYgAigCyAI2AiggBiACKALMAjYCLCAGIAIoAtACNgIwIAYgAigC1AI2AjQgBiACKALYAjYCOCAGIAIoAtwCNgI8IAYgAigC4AI2AkAgBiACKALkAjYCRCAGIAIoAugCNgJIIAYgAigC7AI2AkwgBiACKALwAjYCUCAGIAIoAvQCNgJUIAYgAigC+AI2AlggBiACKAL8AjYCXCAGIAIoAoADNgJgIAYgAigChAM2AmQgBiACKAKIAzYCaCAGIAIoAowDNgJsIAYgAigCkAM2AnAgBiACKAKUAzYCdCAGIAIoApgDNgJ4IAYgAigCnAM2AnwgBiACKAKgAzYCgAEgBiACKAKkAzYChAEgBiACKAKoAzYCiAEgBiACKAKsAzYCjAEgBiACKAKwAzYCkAEgBiACKAK0AzYClAEgBiACKAK4AzYCmAEgBiACKAK8AzYCnAEgBiACKALAAzYCoAEgBiACKALEAzYCpAEgBiACKALIAzYCqAEgBiACKALMAzYCrAEgBiACKALQAzYCsAEgBiACKALUAzYCtAEgBiACKALYAzYCuAEgBiACKALcAzYCvAEgBiACKALgAzYCwAEgBiACKALkAzYCxAEgBiACKALoAzYCyAEgBiACKALsAzYCzAEgBiACKALwAzYC0AEgBiACKAL0AzYC1AEgBiACKAL4AzYC2AEgBiACKAL8AzYC3AEgBiACKAKABDYC4AEgBiACKAKEBDYC5AEgBiACKAKIBDYC6AEgBiACKAKMBDYC7AEgBiACKAKQBDYC8AEgBiACKAKUBDYC9AEgBiACKAKYBDYC+AEgBiACKAKcBDYC/AEgBiACKAKgBDYCgAIgBiACKAKkBDYChAIgBiACKAKoBDYCiAIgBiACKAKsBDYCjAIgBiACKAKwBDYCkAIgBiACKAK0BDYClAIgBiACKAK4BDYCmAIgBiACKAK8BDYCnAIgBiAGKAIAIgdB/////wFxNgIAIAYgBigCBCAHQR11aiIHQf////8BcTYCBCAGIAYoAgggB0EddWoiB0H/////AXE2AgggBiAGKAIMIAdBHXVqIgdB/////wFxNgIMIAYgBigCECAHQR11aiIHQf////8BcTYCECAGIAYoAhQgB0EddWoiB0H/////AXE2AhQgBiAGKAIYIAdBHXVqIgdB/////wFxNgIYIAYgBigCHCAHQR11aiIHQf////8BcTYCHCAGIAYoAiAgB0EddWoiB0H/////AXE2AiAgBiAGKAIkIAdBHXVqIgdB/////wFxNgIkIAYgBigCKCAHQR11aiIHQf////8BcTYCKCAGIAYoAiwgB0EddWoiB0H/////AXE2AiwgBiAGKAIwIAdBHXVqIgdB/////wFxNgIwIAYgBigCNCAHQR11aiIHQf////8BcTYCNCAGIAYoAjggB0EddWoiB0H/////AXE2AjggBiAGKAI8IAdBHXVqIgdB/////wFxNgI8IAYgBigCQCAHQR11aiIHQf////8BcTYCQCAGIAYoAkQgB0EddWo2AkQgBiAGKAIAQQFrNgIAIAYQ6QUhByAGIAYoAkQgB0ETdHM2AkQgBiAHIAYoAkhqNgJIIAZByABqEOkFIQcgBiAGKAKMASAHQRN0czYCjAEgBiAHIAYoApABajYCkAEgBkGQAWoQ6QUhByAGIAYoAtQBIAdBE3RzNgLUASAGIAcgBigC2AFqNgLYASAGQdgBahDpBRoLIANBBGpBACACQQAgAkGgAmoiCkEAIAZBwARqQQBBBBDoBSADIAE2AgAgBiAGKAKgAjYCwAQgBiAG/QACpAL9CwLEBCAGIAb9AAK0Av0LAtQEIAYgBv0AAsQC/QsC5AQgBiAG/QAC1AL9CwL0BCAGIAb9AALkAv0LAoQFIAYgBv0AAvQC/QsClAUgBiAGKQKEAzcCpAUgBiAGKAKMAzYCrAUgBiAGKAKQAzYCsAUgBiAG/QAClAP9CwK0BSAGIAb9AAKkA/0LAsQFIAYgBv0AArQD/QsC1AUgBiAG/QACxAP9CwLkBSAGIAb9AALUA/0LAvQFIAYgBv0AAuQD/QsChAYgBiAGKQL0AzcClAYgBiAGKAL8AzYCnAYgBiAGKAKABDYCoAYgBiAG/QAChAT9CwKkBiAGIAb9AAKUBP0LArQGIAYgBv0AAqQE/QsCxAYgBiAGKQK0BDcC1AYgBiAGKAK8BDYC3AYgBkGYBmoQ6gUhByAGIAYoApQGIAdBE3RyNgKUBiAGQdAFahDqBSEHIAYgBigCzAUgB0ETdHI2AswFIAZBiAVqEOoFIQcgBiAGKAKEBSAHQRN0cjYChAUgBiAGKALEBCIHQRx0QYCAgIABcSAGKALABEEBdXI2AsAEIAYgBigCyAQiCEEcdEGAgICAAXEgB0EBdXI2AsQEIAYgBigCzAQiB0EcdEGAgICAAXEgCEEBdXI2AsgEIAYgBigC0AQiCEEcdEGAgICAAXEgB0EBdXI2AswEIAYgBigC1AQiB0EcdEGAgICAAXEgCEEBdXI2AtAEIAYgBigC2AQiCEEcdEGAgICAAXEgB0EBdXI2AtQEIAYgBigC3AQiB0EcdEGAgICAAXEgCEEBdXI2AtgEIAYgBigC4AQiCEEcdEGAgICAAXEgB0EBdXI2AtwEIAYgBigC5AQiB0EcdEGAgICAAXEgCEEBdXI2AuAEIAYgBigC6AQiCEEcdEGAgICAAXEgB0EBdXI2AuQEIAYgBigC7AQiB0EcdEGAgICAAXEgCEEBdXI2AugEIAYgBigC8AQiCEEcdEGAgICAAXEgB0EBdXI2AuwEIAYgBigC9AQiB0EcdEGAgICAAXEgCEEBdXI2AvAEIAYgBigC+AQiCEEcdEGAgICAAXEgB0EBdXI2AvQEIAYgBigC/AQiB0EcdEGAgICAAXEgCEEBdXI2AvgEIAYgBigCgAUiCEEcdEGAgICAAXEgB0EBdXI2AvwEIAYgBigChAUiB0EBdTYChAUgBiAHQRx0QYCAgIABcSAIQQF1cjYCgAUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAvgEIAIgEP0LAugEIAIgEP0LAtgEIAIgEP0LAsgEIAIgAUEddSIFNgLEBCACIAFB/////wFxIgQ2AsAEQQAhByACQYgFakEAQcgA/AsAIAdFBEAgAkHQBWpBAEHIAPwLAAsgB0UEQCACQZgGakEAQcgA/AsACyACQcAEaiIHIAcgBkHABGoQ6wUgAi0AwARBAXFFBEAgByAHIAZBwARqQQQQ7AULIAcQ6QUhByACIAIoAoQFIAdBE3RzNgKEBSACQYgFaiIIIAcgCCgCAGo2AgAgCBDpBSEHIAJBzAVqIgggCCgCACAHQRN0czYCACACQdAFaiIIIAcgCCgCAGo2AgAgCBDpBSEHIAJBlAZqIgggCCgCACAHQRN0czYCACACQZgGaiIIIAcgCCgCAGo2AgAgCBDpBRogBiAGKAIANgLABCAGIAb9AAIE/QsCxAQgBiAG/QACFP0LAtQEIAYgBv0AAiT9CwLkBCAGIAb9AAI0/QsC9AQgBiAG/QACRP0LAoQFIAYgBv0AAlT9CwKUBSAGIAYpAmQ3AqQFIAYgBigCbDYCrAUgBiAGKAJwNgKwBSAGIAb9AAJ0/QsCtAUgBiAG/QAChAH9CwLEBSAGIAb9AAKUAf0LAtQFIAYgBv0AAqQB/QsC5AUgBiAG/QACtAH9CwL0BSAGIAb9AALEAf0LAoQGIAYgBikC1AE3ApQGIAYgBigC3AE2ApwGIAYgBigC4AE2AqAGIAYgBv0AAuQB/QsCpAYgBiAG/QAC9AH9CwK0BiAGIAb9AAKEAv0LAsQGIAYgBikClAI3AtQGIAYgBigCnAI2AtwGIAZBmAZqEOoFIQcgBiAGKAKUBiAHQRN0cjYClAYgBkHQBWoQ6gUhByAGIAYoAswFIAdBE3RyNgLMBSAGQYgFahDqBSEHIAYgBigChAUgB0ETdHI2AoQFIAYgBigCxAQiB0EcdEGAgICAAXEgBigCwARBAXVyNgLABCAGIAYoAsgEIghBHHRBgICAgAFxIAdBAXVyNgLEBCAGIAYoAswEIgdBHHRBgICAgAFxIAhBAXVyNgLIBCAGIAYoAtAEIghBHHRBgICAgAFxIAdBAXVyNgLMBCAGIAYoAtQEIgdBHHRBgICAgAFxIAhBAXVyNgLQBCAGIAYoAtgEIghBHHRBgICAgAFxIAdBAXVyNgLUBCAGIAYoAtwEIgdBHHRBgICAgAFxIAhBAXVyNgLYBCAGIAYoAuAEIghBHHRBgICAgAFxIAdBAXVyNgLcBCAGIAYoAuQEIgdBHHRBgICAgAFxIAhBAXVyNgLgBCAGIAYoAugEIghBHHRBgICAgAFxIAdBAXVyNgLkBCAGIAYoAuwEIgdBHHRBgICAgAFxIAhBAXVyNgLoBCAGIAYoAvAEIghBHHRBgICAgAFxIAdBAXVyNgLsBCAGIAYoAvQEIgdBHHRBgICAgAFxIAhBAXVyNgLwBCAGIAYoAvgEIghBHHRBgICAgAFxIAdBAXVyNgL0BCAGIAYoAvwEIgdBHHRBgICAgAFxIAhBAXVyNgL4BCAGIAYoAoAFIghBHHRBgICAgAFxIAdBAXVyNgL8BCAGIAYoAoQFIgdBAXU2AoQFIAYgB0EcdEGAgICAAXEgCEEBdXI2AoAFIAIgEP0LApgHIAIgEP0LAogHIAIgEP0LAvgGIAIgEP0LAugGIAIgBTYC5AYgAiAENgLgBkEAIQcgAkGoB2pBAEHIAPwLACAHRQRAIAJB8AdqQQBByAD8CwALIAdFBEAgAkG4CGpBAEHIAPwLAAsgAkHgBmoiByAHIAZBwARqEOsFIAItAOAGQQFxRQRAIAcgByAGQcAEakEEEOwFCyAHEOkFIQcgAiACKAKkByAHQRN0czYCpAcgAkGoB2oiCCAHIAgoAgBqNgIAIAgQ6QUhByACQewHaiIIIAgoAgAgB0ETdHM2AgAgAkHwB2oiCCAHIAgoAgBqNgIAIAgQ6QUhByACQbQIaiIIIAgoAgAgB0ETdHM2AgAgAkG4CGoiCCAHIAgoAgBqNgIAIAgQ6QUaIAJBgAlqIAIgChDrBSAGQYAJaiQAC7MGARd/IAAgAkEGdDYCAANAIAEgFEHIAGxqIgMoAgQgAygCACIEQR11aiIFQf////8BcSEWIAMoAgggBUEddWoiBkH/////AXEhBSADKAIMIAZBHXVqIgdB/////wFxIQYgAygCECAHQR11aiIIQf////8BcSEHIAMoAhQgCEEddWoiCUH/////AXEhCCADKAIYIAlBHXVqIgpB/////wFxIQkgAygCHCAKQR11aiILQf////8BcSEKIAMoAiAgC0EddWoiDEH/////AXEhCyADKAIkIAxBHXVqIg1B/////wFxIQwgAygCKCANQR11aiIOQf////8BcSENIAMoAiwgDkEddWoiD0H/////AXEhDiADKAIwIA9BHXVqIhBB/////wFxIQ8gAygCNCAQQR11aiIRQf////8BcSEQIAMoAjggEUEddWoiEkH/////AXEhESADKAI8IBJBHXVqIhNB/////wFxIRIgAygCQCATQR11aiIVQf////8BcSETIAMoAkQgFUEddWohAyAEQf////8BcSEEIAAoAgggAiAUQX9zakEGdGohGEE/IRcDQCAYIBciFWogBDoAACADQRV0IRkgFkEVdEGAgID/AXEgBEEIdnIhBCAVQQFrIRcgA0EIdSEDIAVBFXRBgICA/wFxIBZBCHZyIRYgBkEVdEGAgID/AXEgBUEIdnIhBSAHQRV0QYCAgP8BcSAGQQh2ciEGIAhBFXRBgICA/wFxIAdBCHZyIQcgCUEVdEGAgID/AXEgCEEIdnIhCCAKQRV0QYCAgP8BcSAJQQh2ciEJIAtBFXRBgICA/wFxIApBCHZyIQogDEEVdEGAgID/AXEgC0EIdnIhCyANQRV0QYCAgP8BcSAMQQh2ciEMIA5BFXRBgICA/wFxIA1BCHZyIQ0gD0EVdEGAgID/AXEgDkEIdnIhDiAQQRV0QYCAgP8BcSAPQQh2ciEPIBFBFXRBgICA/wFxIBBBCHZyIRAgEkEVdEGAgID/AXEgEUEIdnIhESATQRV0QYCAgP8BcSASQQh2ciESIBlBgICA/wFxIBNBCHZyIRMgFQ0ACyAUQQFqIhQgAkcNAAsLoR0BFH8jAEHQDWsiAiQAIAJBrdIpNgIwIABB+YYqIAJBMGoQmwECfwJAIABBARDIASILRQRAQZu3KSEFDAELIAsoAgAiAUGEBEcEQCACIAE2AiQgAkGEBDYCICAAQdfFKSACQSBqEG5B3rIrIQUMAQsgAEECEMgBIg5FBEBBu8kpIQUMAQsCQCAAIAsoAgAQmAEiDCgCBCIPQQBMDQAgD0EHcSENIAwoAgghBEEAIQEgD0EITwRAIARBB2ohBiAEQQZqIQcgBEEFaiEIIARBBGohCSAEQQNqIQogBEECaiEQIARBAWohESAPQfj///8HcSESA0AgASAEakEAOgAAIAEgEWpBADoAACABIBBqQQA6AAAgASAKakEAOgAAIAEgCWpBADoAACABIAhqQQA6AAAgASAHakEAOgAAIAEgBmpBADoAACABQQhqIQEgA0EIaiIDIBJHDQALCyANRQ0AA0AgASAEakEAOgAAIAFBAWohASAFQQFqIgUgDUcNAAsLQQAhAQJAIAsoAgAiBSAPIAUgD0gbIghBAEwEQCAMKAIIIQUMAQsgCEEDcSENIAwoAgghBSAIQQRPBEAgCEH8////B3EhBkEAIQQDQCABIAVqIAsoAgggAWotAAA6AAAgBSABQQFyIgNqIAsoAgggA2otAAA6AAAgBSABQQJyIgNqIAsoAgggA2otAAA6AAAgBSABQQNyIgNqIAsoAgggA2otAAA6AAAgAUEEaiEBIARBBGoiBCAGRw0ACwsgDUUNAEEAIQQDQCABIAVqIAsoAgggAWotAAA6AAAgAUEBaiEBIARBAWoiBCANRw0ACwtBACEBIAJBQGsiDUEAQcgA/AsAIAVBwANqIQQDQCANQQgQ2gUaIAIgAigCQCABIARqLQAAajYCQCABQQFqIgFBwABHDQALQQAhASACQYgBaiIEQQBByAD8CwAgBUGAA2ohAwNAIARBCBDaBRogAiACKAKIASABIANqLQAAajYCiAEgAUEBaiIBQcAARw0AC0EAIQEgAkHQAWoiBEEAQcgA/AsAIAVBwAJqIQMDQCAEQQgQ2gUaIAIgAigC0AEgASADai0AAGo2AtABIAFBAWoiAUHAAEcNAAtBACEBIAJBmAJqIgRBAEHIAPwLACAFQYACaiEDA0AgBEEIENoFGiACIAIoApgCIAEgA2otAABqNgKYAiABQQFqIgFBwABHDQALQQAhASACQeACaiIEQQBByAD8CwAgBUHAAWohAwNAIARBCBDaBRogAiACKALgAiABIANqLQAAajYC4AIgAUEBaiIBQcAARw0AC0EAIQEgAkGoA2oiBEEAQcgA/AsAIAVBgAFqIQMDQCAEQQgQ2gUaIAIgAigCqAMgASADai0AAGo2AqgDIAFBAWoiAUHAAEcNAAtBACEBIAJB8ANqIgRBAEHIAPwLACAFQUBrIQMDQCAEQQgQ2gUaIAIgAigC8AMgASADai0AAGo2AvADIAFBAWoiAUHAAEcNAAtBACEBIAJBuARqIgRBAEHIAPwLAANAIARBCBDaBRogAiACKAK4BCABIAVqLQAAajYCuAQgAUEBaiIBQcAARw0ACwJAIAhBgARMBEAgDEEANgIADAELIAwgCEGABGsiAzYCACAIQQNxIQdBACEEQQAhASAIQYEEa0EDTwRAIANBfHEhCEEAIQMDQCABIAVqIgYgBigAgAQ2AAAgAUEEaiEBIANBBGoiAyAIRw0ACwsgB0UNAANAIAEgBWoiAyADLQCABDoAACABQQFqIQEgBEEBaiIEIAdHDQALCyACIAUtAAFBEHRBgID8B3EgBS0AAyAFLQACQQh0QYD+A3FyciAFLQAAQRh0ciITNgI8IAwQmgEgAEGABBCYASIEKAIEIQcgDigCACEKQQAhBUGQljQoAgAoAiQhBiACQQA2ApwFIAJCgICAgIDAADcCkAUgAiACQZAJajYCmAUgAkEANgKMBSACQoCAgICACDcCgAUgAiACQaAFajYCiAUCQCAEIA5GDQAgCiAHQcIAa0oNAEEAIQEgAkHMBmpBAEGAAvwLACACQSA2AowJIAJCq7OP/JGjs/DbADcCxAYgAkL/pLmIxZHagpt/NwK8BiACQvLmu+Ojp/2npX83ArQGIAJC58yn0NbQ67O7fzcCrAYgAkIANwKkBiACQaQGaiACQeAFahD4ASAEQQA2AgAgB0EAIAdBAEobIQkgB0EhayEQA0ACQCABIAlGDQAgBCgCCCIIIAFqIAJB4AVqIAFqLQAAOgAAIAQgAUEBciIDNgIAIAMgB0YEQCADIQEMAQsgAyAIaiACQeAFaiADai0AADoAACAEIAFBAmoiATYCACABQSBHDQELCwJAIAcgCmtBwgBrIghBAEwNACABIAcgASAHShsgAWshCUEAIQMDQCADIAlGDQEgBCgCCCABakEAOgAAIAQgAUEBaiIBNgIAIANBAWoiAyAIRw0ACwsgASAHSARAIAQoAgggAWpBAToAACAEIAFBAWoiATYCAAsCQCAOKAIAIghBAEoEQCABIAcgASAHShsgAWshCUEAIQMDQCADIAlGDQIgBCgCCCABaiADaiAOKAIIIANqLQAAOgAAIANBAWoiAyAOKAIAIghIDQALCyABIAhqIQcLIAJBIDYCgAVBACEBA0AgAkGgBWogAWogBhBpOgAAIAFBAWoiAUEgRw0ACyACQYAFaiAQIAJBkAVqEN8FAkAgB0EATA0AQQAhASACKAKQBSIDQQAgA0EAShshBiACKAKYBSEIA0AgASAGRg0BIAEgCGoiAyADLQAAIAQoAgggAWotAABzOgAAIAFBAWoiASAHRw0ACwsgAkGQBWpBICAEEN8FQQAhASAEKAIAIgZBACAGQQBKGyEIA0ACQCABIAhGDQAgBCgCCCIHIAFqIgMgAy0AACACQaAFaiABai0AAHM6AAAgBiABQQFyIgNGDQAgAyAHaiIHIActAAAgAkGgBWogA2otAABzOgAAIAFBAmoiAUEgRw0BCwsgBCgCBCEJAkACQCACKAKQBSIDQQBKBEAgBiAJIAYgCUobIAZrIQdBACEBIAIoApgFIQgDQCABIAdGDQIgBCgCCCAGaiABaiABIAhqLQAAOgAAIAFBAWoiASADRw0ACwsgBCADIAZqIgg2AgAgCCAJTg0BIAkgCGshASAIQQBKBEAgBCgCCCEGIAkhAwNAIAYgA0EBayIDaiAGIAMgAWtqLQAAOgAAIAEgA0gNAAsLIAFBAEwNACABQQNxIgYEQCAEKAIIIQdBACEDA0AgByABQQFrIgFqQQA6AAAgA0EBaiIDIAZHDQALCyAIIAlrQXxLDQAgBCgCCCIHQQJrIQggB0EBayEKA0AgASAKakEAOgAAIAEgCGpBADoAACAHIAFBBGsiA2pBADsAACABQQNrIQYgAyEBIAZBAUsNAAsLIAQgCTYCAAsgAkGgBWpBB3IhAyACQaAFakEGciEGIAJBoAVqQQVyIQcgAkGgBWpBBHIhCCACQaAFakEDciEJIAJBoAVqQQJyIQogAkGgBWpBAXIhEEEAIQEDQCACQaAFaiABakEAOgAAIAEgEGpBADoAACABIApqQQA6AAAgASAJakEAOgAAIAEgCGpBADoAACABIAdqQQA6AAAgASAGakEAOgAAIAEgA2pBADoAACABQQhqIgFBwABHDQALIAIoApQFIgdBAEwNACAHQQdxIQhBACEDIAIoApgFIQZBACEBIAdBCE8EQCAGQQdqIQkgBkEGaiEKIAZBBWohECAGQQRqIREgBkEDaiESIAZBAmohDCAGQQFqIQ8gB0H4////B3EhFEEAIQcDQCABIAZqQQA6AAAgASAPakEAOgAAIAEgDGpBADoAACABIBJqQQA6AAAgASARakEAOgAAIAEgEGpBADoAACABIApqQQA6AAAgASAJakEAOgAAIAFBCGohASAHQQhqIgcgFEcNAAsLIAhFDQADQCABIAZqQQA6AAAgAUEBaiEBIANBAWoiAyAIRw0ACwsgAEGABBCGASEHIAQoAgghAyACQZAJakEAQcgA/AsAIANBwANqIQEDQCACQZAJakEIENoFGiACIAIoApAJIAEgBWotAABqNgKQCSAFQQFqIgVBwABHDQALQQAhASACQdgJaiIFQQBByAD8CwAgA0GAA2ohBgNAIAVBCBDaBRogAiACKALYCSABIAZqLQAAajYC2AkgAUEBaiIBQcAARw0AC0EAIQEgAkGgCmoiBUEAQcgA/AsAIANBwAJqIQYDQCAFQQgQ2gUaIAIgAigCoAogASAGai0AAGo2AqAKIAFBAWoiAUHAAEcNAAtBACEBIAJB6ApqIgVBAEHIAPwLACADQYACaiEGA0AgBUEIENoFGiACIAIoAugKIAEgBmotAABqNgLoCiABQQFqIgFBwABHDQALQQAhASACQbALaiIFQQBByAD8CwAgA0HAAWohBgNAIAVBCBDaBRogAiACKAKwCyABIAZqLQAAajYCsAsgAUEBaiIBQcAARw0AC0EAIQEgAkH4C2oiBUEAQcgA/AsAIANBgAFqIQYDQCAFQQgQ2gUaIAIgAigC+AsgASAGai0AAGo2AvgLIAFBAWoiAUHAAEcNAAtBACEBIAJBwAxqIgVBAEHIAPwLACADQUBrIQYDQCAFQQgQ2gUaIAIgAigCwAwgASAGai0AAGo2AsAMIAFBAWoiAUHAAEcNAAtBACEBIAJBiA1qIgVBAEHIAPwLAANAIAVBCBDaBRogAiACKAKIDSABIANqLQAAajYCiA0gAUEBaiIBQcAARw0ACyACQZAJaiACQZAJaiATIA1BCBDgBSAHIAJBkAlqQQgQ3QVBACEFQQEMAQtBACEOQQALIQEgCxCaASAOEJoBIAQQmgEgAUUEQCACIAU2AhQgAkGt0ik2AhAgAEH8iCogAkEQahBsAAsgAkGt0ik2AgAgAEHghyogAhCbASACQdANaiQAQQELzAQBCn8jAEHQAGsiBSQAIAVBADYCDCAFQoCAgICACDcCACAFIAVBEGo2AgggAkEANgIAIAFBAWtBIG0hCgJAAkACQCABQWFMBEBBwAAhBCAFKAIIIQMMAQsgAUEgbyILQQBMIQcDQCAAIAMiCCAFEOMFAkAgASACKAIAIgNBIGpIBEAgBw0BQQAhBCAFKAIIIQYDQCADIAIoAgRODQIgAigCCCADaiAEIAZqLQAAOgAAIAIgAigCAEEBajYCACADQQFqIQMgBEEBaiIEIAtHDQALDAELAkAgBSgCACIJQQBKBH9BACEDIAUoAgghDANAIAIoAgAgA2oiBCACKAIEIgZODQIgAigCCCAEaiADIAxqLQAAOgAAIANBAWoiAyAJRw0ACyACKAIABSADCyAJaiEGCyACIAY2AgALIAhBAWohAyAIIApHDQALIAUoAgQiBEEATA0CIARBB3EhB0EAIQIgBSgCCCEDIARBCEkNAQsgA0EHaiEGIANBBmohCSADQQVqIQwgA0EEaiELIANBA2ohCCADQQJqIQEgA0EBaiEAIARB+P///wdxIQpBACECQQAhBANAIAIgA2pBADoAACAAIAJqQQA6AAAgASACakEAOgAAIAIgCGpBADoAACACIAtqQQA6AAAgAiAMakEAOgAAIAIgCWpBADoAACACIAZqQQA6AAAgAkEIaiECIARBCGoiBCAKRw0ACwsgB0UNAEEAIQQDQCACIANqQQA6AAAgAkEBaiECIARBAWoiBCAHRw0ACwsgBUHQAGokAAu/BQEGfyMAIgUhCiAFIARByABsQQ9qQXBxIgZrIgciBSQAIAUgBmsiCSQAIAkgAyAEEO0IA0AgByAIQcgAbCIGaiIFIAEgBmoiBigCADYCACAFIAYoAgQ2AgQgBSAGKAIINgIIIAUgBigCDDYCDCAFIAYoAhA2AhAgBSAGKAIUNgIUIAUgBigCGDYCGCAFIAYoAhw2AhwgBSAGKAIgNgIgIAUgBigCJDYCJCAFIAYoAig2AiggBSAGKAIsNgIsIAUgBigCMDYCMCAFIAYoAjQ2AjQgBSAGKAI4NgI4IAUgBigCPDYCPCAFIAYoAkA2AkAgBSAGKAJENgJEIAhBAWoiCCAERw0ACyAHIAMgBBDzCAJAIAJBAkcEQEEBIQUDQAJAIAJBgYCAgHhxQQFHBEAgBSEBDAELQQAhAUEAIQggBQRAA0AgACAIQcgAbCIGaiIFIAYgB2oiBigCADYCACAFIAYoAgQ2AgQgBSAGKAIINgIIIAUgBigCDDYCDCAFIAYoAhA2AhAgBSAGKAIUNgIUIAUgBigCGDYCGCAFIAYoAhw2AhwgBSAGKAIgNgIgIAUgBigCJDYCJCAFIAYoAig2AiggBSAGKAIsNgIsIAUgBigCMDYCMCAFIAYoAjQ2AjQgBSAGKAI4NgI4IAUgBigCPDYCPCAFIAYoAkA2AkAgBSAGKAJENgJEIAhBAWoiCCAERw0ACwwBCyMAIgUhBiAFIARBkAFsayIFJAAgByAEQcgAbEHIAGsiCGooAkRBE3VBAmogACAIaigCREETdUECamxBgQROBEAgACADIAQQ6QgLIAUgACAHIAQQ5wggACAFIAMgCSAEEPQIIAYkAAsgAkECSQ0CIAcgByADIAkgBBD3CCACQQF1IQIgASEFDAALAAsgACAHIAMgCSAEEPcICyAAIAMgCSAEEPYIIAokAAuUGwEVfyMAQbAUayICJAAgAkHy0ik2AjAgAEH5hiogAkEwahCbAQJ/AkAgAEEBEMgBIhBFBEBBkbQpIQ8MAQsgECgCACIBQYAKRwRAIAIgATYCJCACQYAKNgIgIABBqMUpIAJBIGoQbkHesishDwwBCyAAQQIQyAEiEUUEQEG7ySkhDwwBCyAQIAJBQGsQ2QUgAkFAayARIABBgAQQhgEiBhDiBSAGKAIEIQogAkEANgL8CyACQYAENgL0CyACIAJBgA1qNgL4CyACQQA2AuwLIAJCgICAgIAINwLgCyACIAJBwAxqNgLoCwJAIApBwgBIDQAgBigCACIJIApKDQAgCkEBayEFIAkgCkcEQCAKIAlrIQECQCAJQQBMDQAgCiIDIAEgBSABIAVIGyILa0EDcSIIBEADQCAGKAIIIgcgA0EBayIDaiAHIAMgAWtqLQAAOgAAIARBAWoiBCAIRw0ACwsgCyAKa0F9Tw0AA0AgBigCCCIEIANBAWsiB2ogBCAHIAFrai0AADoAACAGKAIIIgQgA0ECayIHaiAEIAcgAWtqLQAAOgAAIAYoAggiBCADQQNrIgdqIAQgByABa2otAAA6AAAgBigCCCIEIANBBGsiA2ogBCADIAFrai0AADoAACABIANIDQALCwJAIAFBAEwNACABQQNxIgQEQEEAIQMDQCABQQFrIgEgBigCCGpBADoAACADQQFqIgMgBEcNAAsLIAkgCmtBfEsNAANAIAYoAgggAWpBAWtBADoAACAGKAIIIAFqQQJrQQA6AAAgAUEDayIDIAYoAghqQQA6AAAgAUEEayIBIAYoAghqQQA6AAAgA0EBSw0ACwsgBiAKNgIAC0EAIQEgAkHoEWpBAEGAAvwLACACQSA2AqgUIAJCq7OP/JGjs/DbADcC4BEgAkL/pLmIxZHagpt/NwLYESACQvLmu+Ojp/2npX83AtARIAJC58yn0NbQ67O7fzcCyBEgAkIANwLAESACQcARaiACQYARahD4AQNAIAJBgAxqIAFqIAJBgBFqIAFqLQAAOgAAIAFBAXIiAyACQYAMamogAkGAEWogA2otAAA6AAAgAUECciIDIAJBgAxqaiACQYARaiADai0AADoAACABQQNyIgMgAkGADGpqIAJBgBFqIANqLQAAOgAAIAFBBGoiAUEgRw0ACyAGKAIIIgMtAAAhE0EgIQEgCkEDcUEBRwRAIApBAWtBA3EhByACQeAMaiEIQQAhBANAIAEgCGogAyABQQFqIgFqLQAAOgAAIARBAWoiBCAHRw0ACwsgA0EDaiEEIANBAmohByADQQFqIQggAkHjDGohCSACQeIMaiELIAJB4QxqIQwgAkHgDGohDQNAIAEgDWogASAIai0AADoAACABIAxqIAEgB2otAAA6AAAgASALaiABIARqLQAAOgAAIAEgCWogAyABQQRqIgFqLQAAOgAAIAEgBUcNAAsgAiAKQSFrIg42AvALQQAhASACQQA2AowRIAJCgICAgIAINwKAESACIAJBwBFqNgKIESACQfALakEAIAJBgBFqEOMFIAICfwJAIAIoAoARIgNBAEwNACACKAKIESEFA0BBwAAgAUHAAEYNAhogAkHADGogAWogASAFai0AADoAACABQQFyIgQgA0YNASACQcAMaiAEaiAEIAVqLQAAOgAAIAFBAnIiBCADRg0BIAJBwAxqIARqIAQgBWotAAA6AAAgAUEDciIEIANGDQEgAkHADGogBGogBCAFai0AADoAACABQQRqIgEgA0cNAAsLIAMLNgLgCwJAIAIoAoQRIgRBAEwNACAEQQdxIQdBACEDIAIoAogRIQVBACEBIARBCE8EQCAFQQdqIQggBUEGaiEJIAVBBWohCyAFQQRqIQwgBUEDaiENIAVBAmohEiAFQQFqIRQgBEH4////B3EhFUEAIQQDQCABIAVqQQA6AAAgASAUakEAOgAAIAEgEmpBADoAACABIA1qQQA6AAAgASAMakEAOgAAIAEgC2pBADoAACABIAlqQQA6AAAgASAIakEAOgAAIAFBCGohASAEQQhqIgQgFUcNAAsLIAdFDQADQCABIAVqQQA6AAAgAUEBaiEBIANBAWoiAyAHRw0ACwtBACEBA0AgAkHADGogAWoiAyADLQAAIAFBAXIiAyAGKAIIai0AAHM6AAAgAkHADGogA2oiAyADLQAAIAFBAmoiASAGKAIIai0AAHM6AAAgAUEgRw0ACyACQeALaiAOIAYQ3wUCQCAGKAIAQQBMDQBBACEBIA5BACAOQQBKGyEFA0AgASAFRg0BIAJBgA1qIAFqIgMgAy0AACAGKAIIIAFqLQAAczoAACABQQFqIgEgBigCAEgNAAsLQQAhA0EAIQEDQCADIAJBgA1qIAFqLQAAIAJBgAxqIAFqLQAAc8ByIAFBAXIiAyACQYANamotAAAgAkGADGogA2otAABzwHIhAyABQQJqIgFBIEcNAAsgCkHBAGsiDUEDcSEIQQAhBUEAIQEgCkHCAGtBA08EQCANQXxxIQlBACEEA0AgAkGADWogAWoiByAHKAIgNgIAIAFBBGohASAEQQRqIgQgCUcNAAsLIAgEQANAIAJBgA1qIAFqIgQgBC0AIDoAACABQQFqIQEgBUEBaiIFIAhHDQALCyACQcAMakEHciEFIAJBwAxqQQZyIQQgAkHADGpBBXIhByACQcAMakEEciEIIAJBwAxqQQNyIQkgAkHADGpBAnIhCyACQcAMakEBciEMQQAhAQNAIAJBwAxqIAFqQQA6AAAgASAMakEAOgAAIAEgC2pBADoAACABIAlqQQA6AAAgASAIakEAOgAAIAEgB2pBADoAACABIARqQQA6AAAgASAFakEAOgAAIAFBCGoiAUHAAEcNAAsgAkGADGpBB3IhBSACQYAMakEGciEEIAJBgAxqQQVyIQcgAkGADGpBBHIhCCACQYAMakEDciEJIAJBgAxqQQJyIQsgAkGADGpBAXIhDEEAIQEDQCACQYAMaiABakEAOgAAIAEgDGpBADoAACABIAtqQQA6AAAgASAJakEAOgAAIAEgCGpBADoAACABIAdqQQA6AAAgASAEakEAOgAAIAEgBWpBADoAACABQQhqIgFBwABHDQALQSAgDiAOQSBMG0EhayEFQQAhAQJAA0AgAkGADWogAWotAAAiBEUEQCAFQQFrIQUgAUEBaiIBIA1HDQEMAgsLIAMNACATDQAgBEEBRw0AQQAhA0EAIQcgAUEBaiIEIA1IBEBBASAFIAVBAUwbIghBA3EhCUEAIQEgBUEETgRAIAhB/P///wdxIQsgAkGADWpBA3IhDCACQYANakECciEKIAJBgA1qQQFyIRJBACEFA0AgAkGADWogAWoiCCAEIAhqLQAAOgAAIAEgEmoiCCAEIAhqLQAAOgAAIAEgCmoiCCAEIAhqLQAAOgAAIAEgDGoiCCAEIAhqLQAAOgAAIAFBBGohASAFQQRqIgUgC0cNAAsLIAkEQANAIAJBgA1qIAFqIgUgBCAFai0AADoAACABQQFqIQEgB0EBaiIHIAlHDQALCyANIARrIQcLIAYoAgQiAUEASgRAA0AgBigCCCADakEAOgAAIANBAWoiAyAGKAIEIgFIDQALCyAGIAcgASABIAdKGyIBNgIAIAFBAEwNAEEAIQEDQCAGKAIIIAFqIAJBgA1qIAFqLQAAOgAAIAFBAWoiASAGKAIASA0ACwsgAkGADWpBB3IhBiACQYANakEGciEDIAJBgA1qQQVyIQUgAkGADWpBBHIhBCACQYANakEDciEHIAJBgA1qQQJyIQggAkGADWpBAXIhCUEAIQEDQCACQYANaiABakEAOgAAIAEgCWpBADoAACABIAhqQQA6AAAgASAHakEAOgAAIAEgBGpBADoAACABIAVqQQA6AAAgASADakEAOgAAIAEgBmpBADoAACABQQhqIgFBgARHDQALC0EBDAELQQAhEUEACyEGQQAhASACQUBrQQBByAD8CwAgAUUEQCACQYgBakEAQcgA/AsACyABRQRAIAJB0AFqQQBByAD8CwALIAFFBEAgAkGYAmpBAEHIAPwLAAsgAUUEQCACQeACakEAQcgA/AsACyABRQRAIAJBqANqQQBByAD8CwALIAFFBEAgAkHwA2pBAEHIAPwLAAsgAUUEQCACQbgEakEAQcgA/AsACyABRQRAIAJBgAVqQQBByAD8CwALIAFFBEAgAkHIBWpBAEHIAPwLAAsgAUUEQCACQZAGakEAQcgA/AsACyABRQRAIAJB2AZqQQBByAD8CwALIAFFBEAgAkGgB2pBAEHIAPwLAAsgAUUEQCACQegHakEAQcgA/AsACyABRQRAIAJBsAhqQQBByAD8CwALIAFFBEAgAkH4CGpBAEHIAPwLAAsgAUUEQCACQcAJakEAQcgA/AsACyABRQRAIAJBiApqQQBByAD8CwALIAFFBEAgAkHQCmpBAEHIAPwLAAsgAUUEQCACQZgLakEAQcgA/AsACyAQEJoBIBEQmgEgBkUEQCACIA82AhQgAkHy0ik2AhAgAEH8iCogAkEQahBsAAsgAkHy0ik2AgAgAEHghyogAhCbASACQbAUaiQAQQEL8hABBH8jAEGAEmsiAyQAIAEoAgghBEEAIQEgA0GACWpBAEHIAPwLACAEQcADaiEFA0AgA0GACWpBCBDaBRogAyADKAKACSABIAVqLQAAajYCgAkgAUEBaiIBQcAARw0AC0EAIQEgA0HICWoiBUEAQcgA/AsAIARBgANqIQYDQCAFQQgQ2gUaIAMgAygCyAkgASAGai0AAGo2AsgJIAFBAWoiAUHAAEcNAAtBACEBIANBkApqIgVBAEHIAPwLACAEQcACaiEGA0AgBUEIENoFGiADIAMoApAKIAEgBmotAABqNgKQCiABQQFqIgFBwABHDQALQQAhASADQdgKaiIFQQBByAD8CwAgBEGAAmohBgNAIAVBCBDaBRogAyADKALYCiABIAZqLQAAajYC2AogAUEBaiIBQcAARw0AC0EAIQEgA0GgC2oiBUEAQcgA/AsAIARBwAFqIQYDQCAFQQgQ2gUaIAMgAygCoAsgASAGai0AAGo2AqALIAFBAWoiAUHAAEcNAAtBACEBIANB6AtqIgVBAEHIAPwLACAEQYABaiEGA0AgBUEIENoFGiADIAMoAugLIAEgBmotAABqNgLoCyABQQFqIgFBwABHDQALQQAhASADQbAMaiIFQQBByAD8CwAgBEFAayEGA0AgBUEIENoFGiADIAMoArAMIAEgBmotAABqNgKwDCABQQFqIgFBwABHDQALQQAhASADQfgMaiIFQQBByAD8CwADQCAFQQgQ2gUaIAMgAygC+AwgASAEai0AAGo2AvgMIAFBAWoiAUHAAEcNAAsgA0GgAmogA0GACWogAEEEEOwIIAMgA0GACWogAEGgAmoiBkEEEOwIIANBoAJqIANBoAJqIABBwARqIAAQ8gggAyADIABB4AZqIAYQ8ghBACEBIANBgAlqQQBByAD8CwAgAUUEQCADQcgJakEAQcgA/AsACyABRQRAIANBkApqQQBByAD8CwALIAFFBEAgA0HYCmpBAEHIAPwLAAsgAUUEQCADQaALakEAQcgA/AsACyABRQRAIANB6AtqQQBByAD8CwALIAFFBEAgA0GwDGpBAEHIAPwLAAsgAUUEQCADQfgMakEAQcgA/AsACyADIAMoAqACNgKACSADIAP9AAKkAv0LAoQJIAMgA/0AArQC/QsClAkgAyAD/QACxAL9CwKkCSADIAP9AALUAv0LArQJIAMgA/0AAuQC/QsCxAkgAyAD/QAC9AL9CwLUCSADIAMpAoQDNwLkCSADIAMoAowDNgLsCSADIAMoApADNgLwCSADIAP9AAKUA/0LAvQJIAMgA/0AAqQD/QsChAogAyAD/QACtAP9CwKUCiADIAP9AALEA/0LAqQKIAMgA/0AAtQD/QsCtAogAyAD/QAC5AP9CwLECiADIAMpAvQDNwLUCiADIAMoAvwDNgLcCiADIAMoAoAENgLgCiADIAP9AAKEBP0LAuQKIAMgA/0AApQE/QsC9AogAyAD/QACpAT9CwKECyADIAMpArQENwKUCyADIAMoArwENgKcCyADQaACaiAGQQQQ6QgCQAJAIANB+ANqIANB2AFqEOoIIgENACADQbADaiADQZABahDqCCIBDQAgA0HoAmogA0HIAGoQ6ggiAQ0AIANBoAJqIAMQ6ggiAUUNAQsgAUEATA0AIAMgAyAGQQQQ7AULQQAhBQNAIAMgBUHIAGwiBGoiASABKAIAIANBoAJqIARqIgQoAgBrNgIAIAEgASgCBCAEKAIEazYCBCABIAEoAgggBCgCCGs2AgggASABKAIMIAQoAgxrNgIMIAEgASgCECAEKAIQazYCECABIAEoAhQgBCgCFGs2AhQgASABKAIYIAQoAhhrNgIYIAEgASgCHCAEKAIcazYCHCABIAEoAiAgBCgCIGs2AiAgASABKAIkIAQoAiRrNgIkIAEgASgCKCAEKAIoazYCKCABIAEoAiwgBCgCLGs2AiwgASABKAIwIAQoAjBrNgIwIAEgASgCNCAEKAI0azYCNCABIAEoAjggBCgCOGs2AjggASABKAI8IAQoAjxrNgI8IAEgASgCQCAEKAJAazYCQCABIAEoAkQgBCgCRGs2AkQgBUEBaiIFQQRHDQALIAMQ6QUhASADIAMoAkQgAUETdHM2AkQgAyABIAMoAkhqNgJIIANByABqEOkFIQEgAyADKAKMASABQRN0czYCjAEgAyABIAMoApABajYCkAEgA0GQAWoQ6QUhASADIAMoAtQBIAFBE3RzNgLUASADIAEgAygC2AFqNgLYASADQdgBahDpBRogA0HABGpBACAAQYAJakEAIANBACADQcANakEAQQQQ6AUgAyADQcAEaiAGQQQQ7AggA0HABGpBACADQQAgAEEAIANBwA1qQQBBBBDoBSADQYAJaiADQcAEaiADQYAJakEIEOwFIANBgAlqEOkFIQEgAyADKALECSABQRN0czYCxAkgAyABIAMoAsgJajYCyAkgA0HICWoQ6QUhASADIAMoAowKIAFBE3RzNgKMCiADIAEgAygCkApqNgKQCiADQZAKahDpBSEBIAMgAygC1AogAUETdHM2AtQKIAMgASADKALYCmo2AtgKIANB2ApqEOkFIQEgAyADKAKcCyABQRN0czYCnAsgAyABIAMoAqALajYCoAsgA0GgC2oQ6QUhASADIAMoAuQLIAFBE3RzNgLkCyADIAEgAygC6AtqNgLoCyADQegLahDpBSEBIAMgAygCrAwgAUETdHM2AqwMIAMgASADKAKwDGo2ArAMIANBsAxqEOkFIQEgAyADKAL0DCABQRN0czYC9AwgAyABIAMoAvgMajYC+AwgA0H4DGoQ6QUaIAIgA0GACWpBCBDdBSADQYASaiQAC7cGAQZ/IwBBsANrIgMkACADQewAaiIFQQBBgAL8CwAgA0EgNgKsAyADQquzj/yRo7Pw2wA3AmQgA0L/pLmIxZHagpt/NwJcIANC8ua746On/aelfzcCVCADQufMp9DW0Ouzu383AkwgA0IANwJEAkAgAEUNACAAKAIAIgdBAEwNACAAKAIIIQhBACEAA0AgBSADKAJEIgRBA3ZBPHFqIgYgACAIai0AACAGKAIAQQh0cjYCACADIARBCGoiBDYCRAJAAkAgBEUEQCADQQA2AkQgAyADKAJIQQFqNgJIDAELIARB/wNxDQELIANBxABqEPcBCyAAQQFqIgAgB0cNAAsLQQAhAAJAIAFBAEgNACAFIAMoAkQiBEEDdkE8cWoiBiAGKAIAQQh0IAFBGHZyNgIAIAMgBEEIaiIENgJEIAFBEHZB/wFxIQYgAUEIdiEHAkACQCAERQRAIANBADYCRCADIAMoAkhBAWo2AkgMAQsgBEH/A3ENAQsgA0HEAGoQ9wEgAygCRCEECyAHQf8BcSEHIAUgBEEDdkE8cWoiCCAIKAIAQQh0IAZyNgIAIAMgBEEIaiIENgJEAkACQCAERQRAIANBADYCRCADIAMoAkhBAWo2AkgMAQsgBEH/A3ENAQsgA0HEAGoQ9wEgAygCRCEECyABQf8BcSEGIAUgBEEDdkE8cWoiCCAIKAIAQQh0IAdyNgIAIAMgBEEIaiIENgJEAkACQCAERQRAIANBADYCRCADIAMoAkhBAWo2AkgMAQsgBEH/A3ENAQsgA0HEAGoQ9wEgAygCRCEECyAFIARBA3ZBPHFqIgUgBSgCAEEIdCAGcjYCACADIARBCGoiBDYCRAJAIARFBEAgA0EANgJEIAMgAygCSEEBajYCSAwBCyAEQf8DcQ0BCyADQcQAahD3AQsgA0HEAGogAxD4ASACQQA2AgADQAJAIAAgAigCBE4NACACKAIIIABqIAAgA2otAAA6AAAgAiACKAIAQQFqNgIAIABBAXIiBCACKAIETg0AIAIoAgggBGogAyAEai0AADoAACACIAIoAgBBAWo2AgAgAEECaiIAQSBHDQELCyADQbADaiQAC6IFAQd/IwBB4AtrIgEkACABQdG6KjYCMCAAQfmGKiABQTBqEJsBAn8CQCAAQQEQyAEiBUUEQEGRtCkhAwwBCyAFKAIAIgJBgApHBEAgASACNgIkIAFBgAo2AiAgAEGoxSkgAUEgahBuQd6yKyEDDAELIABBAhDIASIGRQRAQbvJKSEDDAELIAUgAUFAaxDZBSAAQYAEEJgBIQQgAEGABBCGASECIAYgBBDlBSABQUBrIAQgAhDiBUEBDAELQQAhBkEACyEHQQAhAiABQUBrQQBByAD8CwAgAkUEQCABQYgBakEAQcgA/AsACyACRQRAIAFB0AFqQQBByAD8CwALIAJFBEAgAUGYAmpBAEHIAPwLAAsgAkUEQCABQeACakEAQcgA/AsACyACRQRAIAFBqANqQQBByAD8CwALIAJFBEAgAUHwA2pBAEHIAPwLAAsgAkUEQCABQbgEakEAQcgA/AsACyACRQRAIAFBgAVqQQBByAD8CwALIAJFBEAgAUHIBWpBAEHIAPwLAAsgAkUEQCABQZAGakEAQcgA/AsACyACRQRAIAFB2AZqQQBByAD8CwALIAJFBEAgAUGgB2pBAEHIAPwLAAsgAkUEQCABQegHakEAQcgA/AsACyACRQRAIAFBsAhqQQBByAD8CwALIAJFBEAgAUH4CGpBAEHIAPwLAAsgAkUEQCABQcAJakEAQcgA/AsACyACRQRAIAFBiApqQQBByAD8CwALIAJFBEAgAUHQCmpBAEHIAPwLAAsgAkUEQCABQZgLakEAQcgA/AsACyAFEJoBIAYQmgEgBBCaASAHRQRAIAEgAzYCFCABQdG6KjYCECAAQfyIKiABQRBqEGwACyABQdG6KjYCACAAQeCHKiABEJsBIAFB4AtqJABBAQuCBAEFfyMAQdAAayIEJAAgASgCBCECIARBADYCDCAEQoCAgICACDcCACAEIARBEGo2AgggAkE9TgRAIABBfyAEEOMFIAFBADYCACABKAIEQQBKBEAgASgCCEEAOgAAIAEgASgCAEEBaiIDNgIACyABKAIEIANKBEAgASgCCCADakEBOgAAIAEgASgCAEEBaiIDNgIACyACQTdrIQZBACEAIAMhAgNAIAEoAgQgAkoEQCABKAIIIAJqQf8BOgAAIAEgASgCAEEBaiIDNgIAIAJBAWohAiAAIAZHIQUgAEEBaiEAIAUNAQsLIAEoAgQgA0oEQCABKAIIIANqQQA6AAAgASABKAIAQQFqIgM2AgALQQAhACADIQIDQAJAIAIgASgCBE4NACABKAIIIAJqIABBwOAvai0AADoAACABIAEoAgBBAWoiAzYCACAAQRJGDQAgAkEBaiIFIAEoAgRODQAgASgCCCAFaiAAQcHgL2otAAA6AAAgASABKAIAQQFqIgM2AgAgAEECaiEAIAJBAmohAgwBCwsCQCAEKAIAIgVBAEoEf0EAIQIgBCgCCCEGA0AgASgCACACaiIAIAEoAgQiA04NAiABKAIIIABqIAIgBmotAAA6AAAgAkEBaiICIAVHDQALIAEoAgAFIAMLIAVqIQMLIAEgAzYCAAsgBEHQAGokAAv3EQETfyMAQcAJayICJAAgAkGCryk2AjAgAEH5hiogAkEwahCbAQJAAkACQCAAQQEQyAEiCUUEQEGbtykhAQwBCyAJKAIAIgFBhARHBEAgAiABNgIkIAJBhAQ2AiAgAEHXxSkgAkEgahBuQd6yKyEBDAELIABBAhDIASINRQRAQbvJKSEBDAELIABBAxDIASIORQRAQaGIKyEBDAILAkAgACAJKAIAEJgBIgsoAgQiDEEATA0AIAxBB3EhBSALKAIIIQZBACEBIAxBCE8EQCAGQQdqIQggBkEGaiEKIAZBBWohByAGQQRqIQ8gBkEDaiEQIAZBAmohESAGQQFqIRIgDEH4////B3EhEwNAIAEgBmpBADoAACABIBJqQQA6AAAgASARakEAOgAAIAEgEGpBADoAACABIA9qQQA6AAAgASAHakEAOgAAIAEgCmpBADoAACABIAhqQQA6AAAgAUEIaiEBIANBCGoiAyATRw0ACwsgBUUNAANAIAEgBmpBADoAACABQQFqIQEgBEEBaiIEIAVHDQALC0EAIQECQCAJKAIAIgQgDCAEIAxIGyIHQQBMBEAgCygCCCEEDAELIAdBA3EhBSALKAIIIQQgB0EETwRAIAdB/P///wdxIQhBACEGA0AgASAEaiAJKAIIIAFqLQAAOgAAIAQgAUEBciIDaiAJKAIIIANqLQAAOgAAIAQgAUECciIDaiAJKAIIIANqLQAAOgAAIAQgAUEDciIDaiAJKAIIIANqLQAAOgAAIAFBBGohASAGQQRqIgYgCEcNAAsLIAVFDQBBACEGA0AgASAEaiAJKAIIIAFqLQAAOgAAIAFBAWohASAGQQFqIgYgBUcNAAsLQQAhASACQUBrIgZBAEHIAPwLACAEQcADaiEDA0AgBkEIENoFGiACIAIoAkAgASADai0AAGo2AkAgAUEBaiIBQcAARw0AC0EAIQEgAkGIAWoiA0EAQcgA/AsAIARBgANqIQUDQCADQQgQ2gUaIAIgAigCiAEgASAFai0AAGo2AogBIAFBAWoiAUHAAEcNAAtBACEBIAJB0AFqIgNBAEHIAPwLACAEQcACaiEFA0AgA0EIENoFGiACIAIoAtABIAEgBWotAABqNgLQASABQQFqIgFBwABHDQALQQAhASACQZgCaiIDQQBByAD8CwAgBEGAAmohBQNAIANBCBDaBRogAiACKAKYAiABIAVqLQAAajYCmAIgAUEBaiIBQcAARw0AC0EAIQEgAkHgAmoiA0EAQcgA/AsAIARBwAFqIQUDQCADQQgQ2gUaIAIgAigC4AIgASAFai0AAGo2AuACIAFBAWoiAUHAAEcNAAtBACEBIAJBqANqIgNBAEHIAPwLACAEQYABaiEFA0AgA0EIENoFGiACIAIoAqgDIAEgBWotAABqNgKoAyABQQFqIgFBwABHDQALQQAhASACQfADaiIDQQBByAD8CwAgBEFAayEFA0AgA0EIENoFGiACIAIoAvADIAEgBWotAABqNgLwAyABQQFqIgFBwABHDQALQQAhASACQbgEaiIDQQBByAD8CwADQCADQQgQ2gUaIAIgAigCuAQgASAEai0AAGo2ArgEIAFBAWoiAUHAAEcNAAsCQCAHQYAETARAIAtBADYCAAwBCyALIAdBgARrIgU2AgAgB0EDcSEKQQAhA0EAIQEgB0GBBGtBA08EQCAFQXxxIQdBACEFA0AgASAEaiIIIAgoAIAENgAAIAFBBGohASAFQQRqIgUgB0cNAAsLIApFDQADQCABIARqIgUgBS0AgAQ6AAAgAUEBaiEBIANBAWoiAyAKRw0ACwsgAiAELQABQRB0QYCA/AdxIAQtAAMgBC0AAkEIdEGA/gNxcnIgBC0AAEEYdHIiBzYCPCALEJoBIA0gAEGABBCYASIKEOUFIABBgAQQmAEhCCAOKAIIIQRBACEBIAJBgAVqQQBByAD8CwAgBEHAA2ohAwNAIAJBgAVqQQgQ2gUaIAIgAigCgAUgASADai0AAGo2AoAFIAFBAWoiAUHAAEcNAAtBACEBIAJByAVqIgNBAEHIAPwLACAEQYADaiEFA0AgA0EIENoFGiACIAIoAsgFIAEgBWotAABqNgLIBSABQQFqIgFBwABHDQALQQAhASACQZAGaiIDQQBByAD8CwAgBEHAAmohBQNAIANBCBDaBRogAiACKAKQBiABIAVqLQAAajYCkAYgAUEBaiIBQcAARw0AC0EAIQEgAkHYBmoiA0EAQcgA/AsAIARBgAJqIQUDQCADQQgQ2gUaIAIgAigC2AYgASAFai0AAGo2AtgGIAFBAWoiAUHAAEcNAAtBACEBIAJBoAdqIgNBAEHIAPwLACAEQcABaiEFA0AgA0EIENoFGiACIAIoAqAHIAEgBWotAABqNgKgByABQQFqIgFBwABHDQALQQAhASACQegHaiIDQQBByAD8CwAgBEGAAWohBQNAIANBCBDaBRogAiACKALoByABIAVqLQAAajYC6AcgAUEBaiIBQcAARw0AC0EAIQEgAkGwCGoiA0EAQcgA/AsAIARBQGshBQNAIANBCBDaBRogAiACKAKwCCABIAVqLQAAajYCsAggAUEBaiIBQcAARw0AC0EAIQEgAkH4CGoiA0EAQcgA/AsAA0AgA0EIENoFGiACIAIoAvgIIAEgBGotAABqNgL4CCABQQFqIgFBwABHDQALIAJBgAVqIAJBgAVqIAcgBkEIEOAFIAggAkGABWpBCBDdBUEBIQRBASEHAkAgCCgCACIGIAooAgBHDQBBESEHIAZBAEwNACAKKAIIIQMgCCgCCCEFQQAhAQNAIAEgBWotAAAgASADai0AAEYEQCAGIAFBAWoiAUcNAQwCCwtBASEHCyAAKAIMIAc6AAQgACAAKAIMQQhqNgIMQQAhAQwCC0EAIQ0LQQAhDgsgCRCaASANEJoBIA4QmgEgChCaASAIEJoBIARFBEAgAiABNgIUIAJBgq8pNgIQIABB/IgqIAJBEGoQbAALIAJBgq8pNgIAIABB4IcqIAIQmwEgAkHACWokAEEBC48VAQt/IwBB8BZrIgEkACABQaq/KjYCICAAQfmGKiABQSBqEJsBAn8gAEEBEMgBIghFBEBB57EpDAELIAggAUEwahDZBSABQdALakEAIAFBMGpBACABQdACakEAIAFBsBJqQQBBBBDoBSABIAEoAjA2ArASIAEgAf0AAjT9CwK0EiABIAH9AAJE/QsCxBIgASAB/QACVP0LAtQSIAEgAf0AAmT9CwLkEiABIAH9AAJ0/QsC9BIgASAB/QAChAH9CwKEEyABIAEpApQBNwKUEyABIAEoApwBNgKcEyABIAEoAqABNgKgEyABIAH9AAKkAf0LAqQTIAEgAf0AArQB/QsCtBMgASAB/QACxAH9CwLEEyABIAH9AALUAf0LAtQTIAEgAf0AAuQB/QsC5BMgASAB/QAC9AH9CwL0EyABIAEpAoQCNwKEFCABIAEoAowCNgKMFCABIAEoApACNgKQFCABIAH9AAKUAv0LApQUIAEgAf0AAqQC/QsCpBQgASAB/QACtAL9CwK0FCABIAEpAsQCNwLEFCABIAEoAswCNgLMFCABIAEoArASIgJB/////wFxNgKwEiABIAEoArQSIAJBHXVqIgJB/////wFxNgK0EiABIAEoArgSIAJBHXVqIgJB/////wFxNgK4EiABIAEoArwSIAJBHXVqIgJB/////wFxNgK8EiABIAEoAsASIAJBHXVqIgJB/////wFxNgLAEiABIAEoAsQSIAJBHXVqIgJB/////wFxNgLEEiABIAEoAsgSIAJBHXVqIgJB/////wFxNgLIEiABIAEoAswSIAJBHXVqIgJB/////wFxNgLMEiABIAEoAtASIAJBHXVqIgJB/////wFxNgLQEiABIAEoAtQSIAJBHXVqIgJB/////wFxNgLUEiABIAEoAtgSIAJBHXVqIgJB/////wFxNgLYEiABIAEoAtwSIAJBHXVqIgJB/////wFxNgLcEiABIAEoAuASIAJBHXVqIgJB/////wFxNgLgEiABIAEoAuQSIAJBHXVqIgJB/////wFxNgLkEiABIAEoAugSIAJBHXVqIgJB/////wFxNgLoEiABIAEoAuwSIAJBHXVqIgJB/////wFxNgLsEiABIAEoAvASIAJBHXVqIgJB/////wFxNgLwEiABIAEoAvQSIAJBHXVqNgL0EiABIAEoArASQQFrNgKwEiABQbASahDpBSECIAEgASgC9BIgAkETdHM2AvQSIAEgAiABKAL4Emo2AvgSIAFB+BJqIgMQ6QUhAiABIAEoArwTIAJBE3RzNgK8EyABIAIgASgCwBNqNgLAEyABQcATaiIEEOkFIQIgASABKAKEFCACQRN0czYChBQgASACIAEoAogUajYCiBQgAUGIFGoiAhDpBRogAhDqBSECIAEgASgChBQgAkETdHI2AoQUIAQQ6gUhAiABIAEoArwTIAJBE3RyNgK8EyADEOoFIQIgASABKAL0EiACQRN0cjYC9BIgASABKAK0EiICQRx0QYCAgIABcSABKAKwEkEBdXI2ArASIAEgASgCuBIiA0EcdEGAgICAAXEgAkEBdXI2ArQSIAEgASgCvBIiAkEcdEGAgICAAXEgA0EBdXI2ArgSIAEgASgCwBIiA0EcdEGAgICAAXEgAkEBdXI2ArwSIAEgASgCxBIiAkEcdEGAgICAAXEgA0EBdXI2AsASIAEgASgCyBIiA0EcdEGAgICAAXEgAkEBdXI2AsQSIAEgASgCzBIiAkEcdEGAgICAAXEgA0EBdXI2AsgSIAEgASgC0BIiA0EcdEGAgICAAXEgAkEBdXI2AswSIAEgASgC1BIiAkEcdEGAgICAAXEgA0EBdXI2AtASIAEgASgC2BIiA0EcdEGAgICAAXEgAkEBdXI2AtQSIAEgASgC3BIiAkEcdEGAgICAAXEgA0EBdXI2AtgSIAEgASgC4BIiA0EcdEGAgICAAXEgAkEBdXI2AtwSIAEgASgC5BIiAkEcdEGAgICAAXEgA0EBdXI2AuASIAEgASgC6BIiA0EcdEGAgICAAXEgAkEBdXI2AuQSIAEgASgC7BIiAkEcdEGAgICAAXEgA0EBdXI2AugSIAEgASgC8BIiA0EcdEGAgICAAXEgAkEBdXI2AuwSIAEgASgC9BIiAkEBdTYC9BIgASACQRx0QYCAgIABcSADQQF1cjYC8BIgAUGQEGogAUHwBGogAUGwEmoQ6wUgAS0AkBBBAXFFBEAgAUGQEGogAUGQEGogAUGwEmpBBBDsBQsgAUGQEGoQ6QUhAiABIAEoAtQQIAJBE3RzNgLUECABIAIgASgC2BBqNgLYECABQdgQahDpBSECIAEgASgCnBEgAkETdHM2ApwRIAEgAiABKAKgEWo2AqARIAFBoBFqEOkFIQIgASABKALkESACQRN0czYC5BEgASACIAEoAugRajYC6BEgAUHoEWoQ6QUaIABBgAQQmAEiBSABQZAQakEEEN0FAkAgBSgCACIEQfwBTARAIAVBADYCAAwBCyAFIARB/AFrIgY2AgAgBEEDcSEJIAUoAgghB0EAIQNBACECIARB/QFrQQNPBEAgBkF8cSEKQQAhBANAIAIgB2oiCyALKAD8ATYAACACQQRqIQIgBEEEaiIEIApHDQALCyAJRQ0AA0AgAiAHaiIEIAQtAPwBOgAAIAJBAWohAiADQQFqIgMgCUcNAAsLIABBhAQQhgEiAyABQdALakEIEN0FAkAgBkEASgRAQQAhAgNAIAMoAgAgAmoiBCADKAIEIgdODQIgAygCCCAEaiAFKAIIIAJqLQAAOgAAIAJBAWoiAiAGRw0ACwsgAygCACAGaiEHCyADIAc2AgAgCBCaAUEACyEDIAUQmgFBACECIAFBMGpBAEHIAPwLACACRQRAIAFB+ABqQQBByAD8CwALIAJFBEAgAUHAAWpBAEHIAPwLAAsgAkUEQCABQYgCakEAQcgA/AsACyACRQRAIAFB0AJqQQBByAD8CwALIAJFBEAgAUGYA2pBAEHIAPwLAAsgAkUEQCABQeADakEAQcgA/AsACyACRQRAIAFBqARqQQBByAD8CwALIAJFBEAgAUHwBGpBAEHIAPwLAAsgAkUEQCABQbgFakEAQcgA/AsACyACRQRAIAFBgAZqQQBByAD8CwALIAJFBEAgAUHIBmpBAEHIAPwLAAsgAkUEQCABQZAHakEAQcgA/AsACyACRQRAIAFB2AdqQQBByAD8CwALIAJFBEAgAUGgCGpBAEHIAPwLAAsgAkUEQCABQegIakEAQcgA/AsACyACRQRAIAFBsAlqQQBByAD8CwALIAJFBEAgAUH4CWpBAEHIAPwLAAsgAkUEQCABQcAKakEAQcgA/AsACyACRQRAIAFBiAtqQQBByAD8CwALIAJFBEAgAUGwEmpBAEHIAPwLAAsgAkUEQCABQfgSakEAQcgA/AsACyACRQRAIAFBwBNqQQBByAD8CwALIAJFBEAgAUGIFGpBAEHIAPwLAAsgCEUEQCABIAM2AgQgAUGqvyo2AgAgAEH8iCogARBsAAsgAUGqvyo2AhAgAEHghyogAUEQahCbASABQfAWaiQAQQEL1xoCDn8DfiMAQZABayIOJAACQCAIQQFGBEAgAiADQcgAbGoiChDpBRogBCAFQcgAbGoiCxDpBRogDiALNAIAIAo0AgB+Ihg3AwAgDiALNAIEIAo0AgR+NwMIIA4gCzQCCCAKNAIIfjcDECAOIAs0AgwgCjQCDH43AxggDiALNAIQIAo0AhB+NwMgIA4gCzQCFCAKNAIUfjcDKCAOIAs0AhggCjQCGH43AzAgDiALNAIcIAo0Ahx+NwM4IA4gCzQCICAKNAIgfjcDQCAOIAs0AiQgCjQCJH43A0ggDiALNAIoIAo0Aih+NwNQIA4gCzQCLCAKNAIsfjcDWCAOIAs0AjAgCjQCMH43A2AgDiALNAI0IAo0AjR+NwNoIA4gCzQCOCAKNAI4fjcDcCAOIAs0AjwgCjQCPH43A3ggDiALNAJAIAo0AkB+Ihk3A4ABIA4gCzQCRCAKNAJEfjcDiAEgBiAHQcgAbGoiDyAYp0H/////AXE2AgAgGEIdhyEXQQEhDQNAIA1BAXYhECAOIA1BA3RqKQMAIBh8IhggF3whFyANIQkDQCALIA0gCWtBAnQiCGooAgAgCyAJQQJ0IgxqKAIAa6wgCiAMaigCACAIIApqKAIAa6x+IBd8IRcgCUEBayIJIBBKDQALIA8gDUECdGogF6dB/////wFxNgIAIBdCHYchF0ESIQkgDUEBaiINQRJHDQALA0ACfiAYIAlBA3QgDmpBkAFrKQMAfSIYIBd8IAsgCUECdCIIQcQAayIMaigCACALKAJEa6wgCigCRCAKIAxqKAIAa6x+fCIXIAlBH0sNABogCyAIQUBqIgxqKAIAIAsoAkBrrCAKKAJAIAogDGooAgBrrH4gF3wiFyAJQR1LDQAaIAsgCEE8ayIMaigCACALKAI8a6wgCigCPCAKIAxqKAIAa6x+IBd8IhcgCUEbSw0AGiALIAhBOGsiDGooAgAgCygCOGusIAooAjggCiAMaigCAGusfiAXfCIXIAlBGUsNABogCyAIQTRrIgxqKAIAIAsoAjRrrCAKKAI0IAogDGooAgBrrH4gF3wiFyAJQRdLDQAaIAsgCEEwayIMaigCACALKAIwa6wgCigCMCAKIAxqKAIAa6x+IBd8IhcgCUEVSw0AGiALIAhBLGsiDGooAgAgCygCLGusIAooAiwgCiAMaigCAGusfiAXfCIXIAlBE0sNABogCyAIQShrIgxqKAIAIAsoAihrrCAKKAIoIAogDGooAgBrrH4gF3wLIRcgCCAPaiAXp0H/////AXE2AgAgF0IdhyEXIAlBAWoiCUEiRw0ACyAPIBggGX0gF3wiF0IdiD4CjAEgDyAXp0H/////AXE2AogBIAAgAUHIAGxqIglByABqIAkgDxDoCAwBCyAIQQJtIg0gA2ohFSAIQQJOBEAgAiAVQcgAbGohECACIANByABsaiEPIAAgAUHIAGxqIREDQCARIAxByABsIgtqIgkgCyAQaiIKKAIAIAsgD2oiCygCAGo2AgAgCSAKKAIEIAsoAgRqNgIEIAkgCigCCCALKAIIajYCCCAJIAooAgwgCygCDGo2AgwgCSAKKAIQIAsoAhBqNgIQIAkgCigCFCALKAIUajYCFCAJIAooAhggCygCGGo2AhggCSAKKAIcIAsoAhxqNgIcIAkgCigCICALKAIgajYCICAJIAooAiQgCygCJGo2AiQgCSAKKAIoIAsoAihqNgIoIAkgCigCLCALKAIsajYCLCAJIAooAjAgCygCMGo2AjAgCSAKKAI0IAsoAjRqNgI0IAkgCigCOCALKAI4ajYCOCAJIAooAjwgCygCPGo2AjwgCSAKKAJAIAsoAkBqNgJAIAkgCigCRCALKAJEajYCRCAMQQFqIgwgDUcNAAsLIA0gDUEfdSIJcyAJayISQQJPBEAgEkECayEMIAAgAUHIAGxqIRBBACEJA0AgECAJQcgAbGoiChDpBSELIAogCigCRCALQRN0czYCRCAKQcgAaiIKIAsgCigCAGo2AgAgCSAMRyEKIAlBAWohCSAKDQALCyAAIAFByABsaiIQIBJByABsaiIJQcgAaxDpBSEKAkAgCEF+TARAIAlBBGsiCSAJKAIAIApBE3RzNgIAIAUgDWohFCABIA1qIRMMAQsgBSANaiEUIAEgDWohEyAIQQJIDQAgBCAUQcgAbGohDyAEIAVByABsaiERIAAgE0HIAGxqIRZBACEMA0AgFiAMQcgAbCILaiIJIAsgD2oiCigCACALIBFqIgsoAgBqNgIAIAkgCigCBCALKAIEajYCBCAJIAooAgggCygCCGo2AgggCSAKKAIMIAsoAgxqNgIMIAkgCigCECALKAIQajYCECAJIAooAhQgCygCFGo2AhQgCSAKKAIYIAsoAhhqNgIYIAkgCigCHCALKAIcajYCHCAJIAooAiAgCygCIGo2AiAgCSAKKAIkIAsoAiRqNgIkIAkgCigCKCALKAIoajYCKCAJIAooAiwgCygCLGo2AiwgCSAKKAIwIAsoAjBqNgIwIAkgCigCNCALKAI0ajYCNCAJIAooAjggCygCOGo2AjggCSAKKAI8IAsoAjxqNgI8IAkgCigCQCALKAJAajYCQCAJIAooAkQgCygCRGo2AkQgDEEBaiIMIA1HDQALCyASQQJPBEAgEkECayEMIAAgE0HIAGxqIQ9BACEJA0AgDyAJQcgAbGoiChDpBSELIAogCigCRCALQRN0czYCRCAKQcgAaiIKIAsgCigCAGo2AgAgCSAMRyEKIAlBAWohCSAKDQALCyAAIBNByABsaiIPIBJByABsaiIJQcgAaxDpBSEKIAhBfkwEQCAJQQRrIgkgCSgCACAKQRN0czYCAAsgBiAHIAAgASAAIBMgBiAHIAhqIgkgDRDoBSAAIAEgAiADIAQgBSAGIAkgDRDoBSAAIAEgCGoiESACIBUgBCAUIAYgCSANEOgFAkAgCEEASgRAIAYgB0HIAGxqIQtBACEMA0AgCyAMQcgAbCIKaiIJIAkoAgAgCiAQaiIKKAIAazYCACAJIAkoAgQgCigCBGs2AgQgCSAJKAIIIAooAghrNgIIIAkgCSgCDCAKKAIMazYCDCAJIAkoAhAgCigCEGs2AhAgCSAJKAIUIAooAhRrNgIUIAkgCSgCGCAKKAIYazYCGCAJIAkoAhwgCigCHGs2AhwgCSAJKAIgIAooAiBrNgIgIAkgCSgCJCAKKAIkazYCJCAJIAkoAiggCigCKGs2AiggCSAJKAIsIAooAixrNgIsIAkgCSgCMCAKKAIwazYCMCAJIAkoAjQgCigCNGs2AjQgCSAJKAI4IAooAjhrNgI4IAkgCSgCPCAKKAI8azYCPCAJIAkoAkAgCigCQGs2AkAgCSAJKAJEIAooAkRrNgJEIAxBAWoiDCAIRw0ACyAAIBFByABsaiERQQAhDEEAIQ0DQCALIA1ByABsIgpqIgkgCSgCACAKIBFqIgooAgBrNgIAIAkgCSgCBCAKKAIEazYCBCAJIAkoAgggCigCCGs2AgggCSAJKAIMIAooAgxrNgIMIAkgCSgCECAKKAIQazYCECAJIAkoAhQgCigCFGs2AhQgCSAJKAIYIAooAhhrNgIYIAkgCSgCHCAKKAIcazYCHCAJIAkoAiAgCigCIGs2AiAgCSAJKAIkIAooAiRrNgIkIAkgCSgCKCAKKAIoazYCKCAJIAkoAiwgCigCLGs2AiwgCSAJKAIwIAooAjBrNgIwIAkgCSgCNCAKKAI0azYCNCAJIAkoAjggCigCOGs2AjggCSAJKAI8IAooAjxrNgI8IAkgCSgCQCAKKAJAazYCQCAJIAkoAkQgCigCRGs2AkQgDUEBaiINIAhHDQALA0AgDyAMQcgAbCIKaiIJIAogC2oiCigCACAJKAIAajYCACAJIAooAgQgCSgCBGo2AgQgCSAKKAIIIAkoAghqNgIIIAkgCigCDCAJKAIMajYCDCAJIAooAhAgCSgCEGo2AhAgCSAKKAIUIAkoAhRqNgIUIAkgCigCGCAJKAIYajYCGCAJIAooAhwgCSgCHGo2AhwgCSAKKAIgIAkoAiBqNgIgIAkgCigCJCAJKAIkajYCJCAJIAooAiggCSgCKGo2AiggCSAKKAIsIAkoAixqNgIsIAkgCigCMCAJKAIwajYCMCAJIAooAjQgCSgCNGo2AjQgCSAKKAI4IAkoAjhqNgI4IAkgCigCPCAJKAI8ajYCPCAJIAooAkAgCSgCQGo2AkAgCSAKKAJEIAkoAkRqNgJEIAxBAWoiDCAIRw0ACyAIQQF0IQ0MAQtBACAIQQF0ayENIAgNACAQIA1ByABsakHIAGsQ6QUaDAELIA1BAmshDEEAIQkDQCAQIAlByABsaiIKEOkFIQsgCiAKKAJEIAtBE3RzNgJEIApByABqIgogCyAKKAIAajYCACAJIAxHIQogCUEBaiEJIAoNAAsgECANQcgAbGoiCUHIAGsQ6QUhCiAIQQBKDQAgCUEEayIJIAkoAgAgCkETdHM2AgALIA5BkAFqJAALvgMBAX8gACAAKAIAIgFB/////wFxNgIAIAAgACgCBCABQR11aiIBQf////8BcTYCBCAAIAAoAgggAUEddWoiAUH/////AXE2AgggACAAKAIMIAFBHXVqIgFB/////wFxNgIMIAAgACgCECABQR11aiIBQf////8BcTYCECAAIAAoAhQgAUEddWoiAUH/////AXE2AhQgACAAKAIYIAFBHXVqIgFB/////wFxNgIYIAAgACgCHCABQR11aiIBQf////8BcTYCHCAAIAAoAiAgAUEddWoiAUH/////AXE2AiAgACAAKAIkIAFBHXVqIgFB/////wFxNgIkIAAgACgCKCABQR11aiIBQf////8BcTYCKCAAIAAoAiwgAUEddWoiAUH/////AXE2AiwgACAAKAIwIAFBHXVqIgFB/////wFxNgIwIAAgACgCNCABQR11aiIBQf////8BcTYCNCAAIAAoAjggAUEddWoiAUH/////AXE2AjggACAAKAI8IAFBHXVqIgFB/////wFxNgI8IAAgACgCQCABQR11aiIBQf////8BcTYCQCAAIAAoAkQgAUEddWoiATYCRCABQRN1C/QDAQR/IAAgACgCBCIBQRx0QYCAgIABcSAAKAIAIgNBAXVyNgIAIAAgACgCDCICQRx0QYCAgIABcSAAKAIIIgRBAXVyNgIIIAAgBEEcdEGAgICAAXEgAUEBdXI2AgQgACAAKAIQIgFBHHRBgICAgAFxIAJBAXVyNgIMIAAgACgCFCICQRx0QYCAgIABcSABQQF1cjYCECAAIAAoAhgiAUEcdEGAgICAAXEgAkEBdXI2AhQgACAAKAIcIgJBHHRBgICAgAFxIAFBAXVyNgIYIAAgACgCICIBQRx0QYCAgIABcSACQQF1cjYCHCAAIAAoAiQiAkEcdEGAgICAAXEgAUEBdXI2AiAgACAAKAIoIgFBHHRBgICAgAFxIAJBAXVyNgIkIAAgACgCLCICQRx0QYCAgIABcSABQQF1cjYCKCAAIAAoAjAiAUEcdEGAgICAAXEgAkEBdXI2AiwgACAAKAI0IgJBHHRBgICAgAFxIAFBAXVyNgIwIAAgACgCOCIBQRx0QYCAgIABcSACQQF1cjYCNCAAIAAoAjwiAkEcdEGAgICAAXEgAUEBdXI2AjggACAAKAJAIgFBHHRBgICAgAFxIAJBAXVyNgI8IAAgACgCRCICQQF1NgJEIAAgAkEcdEGAgICAAXEgAUEBdXI2AkAgA0EBcQugZAEUfyMAQcANayIDJAAgAyABKAIANgKgCyADIAEoAgQ2AqQLIAMgASgCCDYCqAsgAyABKAIMNgKsCyADIAEoAhA2ArALIAMgASgCFDYCtAsgAyABKAIYNgK4CyADIAEoAhw2ArwLIAMgASgCIDYCwAsgAyABKAIkNgLECyADIAEoAig2AsgLIAMgASgCLDYCzAsgAyABKAIwNgLQCyADIAEoAjQ2AtQLIAMgASgCODYC2AsgAyABKAI8NgLcCyADIAEoAkA2AuALIAMgASgCRDYC5AsgAyABKAJINgLoCyADIAEoAkw2AuwLIAMgASgCUDYC8AsgAyABKAJUNgL0CyADIAEoAlg2AvgLIAMgASgCXDYC/AsgAyABKAJgNgKADCADIAEoAmQ2AoQMIAMgASgCaDYCiAwgAyABKAJsNgKMDCADIAEoAnA2ApAMIAMgASgCdDYClAwgAyABKAJ4NgKYDCADIAEoAnw2ApwMIAMgASgCgAE2AqAMIAMgASgChAE2AqQMIAMgASgCiAE2AqgMIAMgASgCjAE2AqwMIAMgASgCkAE2ArAMIAMgASgClAE2ArQMIAMgASgCmAE2ArgMIAMgASgCnAE2ArwMIAMgASgCoAE2AsAMIAMgASgCpAE2AsQMIAMgASgCqAE2AsgMIAMgASgCrAE2AswMIAMgASgCsAE2AtAMIAMgASgCtAE2AtQMIAMgASgCuAE2AtgMIAMgASgCvAE2AtwMIAMgASgCwAE2AuAMIAMgASgCxAE2AuQMIAMgASgCyAE2AugMIAMgASgCzAE2AuwMIAMgASgC0AE2AvAMIAMgASgC1AE2AvQMIAMgASgC2AE2AvgMIAMgASgC3AE2AvwMIAMgASgC4AE2AoANIAMgASgC5AE2AoQNIAMgASgC6AE2AogNIAMgASgC7AE2AowNIAMgASgC8AE2ApANIAMgASgC9AE2ApQNIAMgASgC+AE2ApgNIAMgASgC/AE2ApwNIAMgASgCgAI2AqANIAMgASgChAI2AqQNIAMgASgCiAI2AqgNIAMgASgCjAI2AqwNIAMgASgCkAI2ArANIAMgASgClAI2ArQNIAMgASgCmAI2ArgNIAMgASgCnAI2ArwNIAMgAigCADYCgAkgAyACKAIENgKECSADIAIoAgg2AogJIAMgAigCDDYCjAkgAyACKAIQNgKQCSADIAIoAhQ2ApQJIAMgAigCGDYCmAkgAyACKAIcNgKcCSADIAIoAiA2AqAJIAMgAigCJDYCpAkgAyACKAIoNgKoCSADIAIoAiw2AqwJIAMgAigCMDYCsAkgAyACKAI0NgK0CSADIAIoAjg2ArgJIAMgAigCPDYCvAkgAyACKAJANgLACSADIAIoAkQ2AsQJIAMgAigCSDYCyAkgAyACKAJMNgLMCSADIAIoAlA2AtAJIAMgAigCVDYC1AkgAyACKAJYNgLYCSADIAIoAlw2AtwJIAMgAigCYDYC4AkgAyACKAJkNgLkCSADIAIoAmg2AugJIAMgAigCbDYC7AkgAyACKAJwNgLwCSADIAIoAnQ2AvQJIAMgAigCeDYC+AkgAyACKAJ8NgL8CSADIAIoAoABNgKACiADIAIoAoQBNgKECiADIAIoAogBNgKICiADIAIoAowBNgKMCiADIAIoApABNgKQCiADIAIoApQBNgKUCiADIAIoApgBNgKYCiADIAIoApwBNgKcCiADIAIoAqABNgKgCiADIAIoAqQBNgKkCiADIAIoAqgBNgKoCiADIAIoAqwBNgKsCiADIAIoArABNgKwCiADIAIoArQBNgK0CiADIAIoArgBNgK4CiADIAIoArwBNgK8CiADIAIoAsABNgLACiADIAIoAsQBNgLECiADIAIoAsgBNgLICiADIAIoAswBNgLMCiADIAIoAtABNgLQCiADIAIoAtQBNgLUCiADIAIoAtgBNgLYCiADIAIoAtwBNgLcCiADIAIoAuABNgLgCiADIAIoAuQBNgLkCiADIAIoAugBNgLoCiADIAIoAuwBNgLsCiADIAIoAvABNgLwCiADIAIoAvQBNgL0CiADIAIoAvgBNgL4CiADIAIoAvwBNgL8CiADIAIoAoACNgKACyADIAIoAoQCNgKECyADIAIoAogCNgKICyADIAIoAowCNgKMCyADIAIoApACNgKQCyADIAIoApQCNgKUCyADIAIoApgCNgKYCyACKAKcAiEBIANBATYCACADIAE2ApwLQQQhASADQQRyQQBBxAD8CwAgA0HIAGohEyATQQBByAD8CwAgA0GQAWohFCAERQRAIBRBAEHIAPwLAAsgA0HYAWohFSAERQRAIBVBAEHIAPwLAAsgA0EBNgLgBiADIAMoAgQ2AuQGIAMgA/0AAwj9CwPoBiADIAP9AAMY/QsD+AYgAyAD/QADKP0LA4gHIAMgA/0AAzj9CwOYByADIAP9AANI/QsDqAcgAyAD/QADWP0LA7gHIAMgAykDaDcDyAcgAyADKAJwNgLQByADIAMoAnQ2AtQHIAMgA/0AA3j9CwPYByADIAP9AAOIAf0LA+gHIAMgA/0AA5gB/QsD+AcgAyAD/QADqAH9CwOICCADIAP9AAO4Af0LA5gIIAMgA/0AA8gB/QsDqAggAyADKQPYATcDuAggAyADKALgATYCwAggAyADKALkATYCxAggAyADKALoATYCyAggAyADKALsATYCzAggAyADKALwATYC0AggAyADKAL0ATYC1AggAyADKAL4ATYC2AggAyADKAL8ATYC3AggAyADKAKAAjYC4AggAyADKAKEAjYC5AggAyADKAKIAjYC6AggAyADKAKMAjYC7AggAyADKAKQAjYC8AggAyADKAKUAjYC9AggAyADKAKYAjYC+AggAyADKAKcAjYC/AggBEUEQCADQcAEakEAQcgA/AsACyADQYgFaiEIIARFBEAgCEEAQcgA/AsACyADQdAFaiEJIARFBEAgCUEAQcgA/AsACyADQZgGaiEMIARFBEAgDEEAQcgA/AsACyADQfAHaiEKIANBqAdqIQsgA0G4CGohDyADQbAMaiEQIANB6AtqIREgA0GQCmohDSADQcgJaiEOIANB2ApqIRIgA0H4DGohFgNAAkAgAUEATA0AIAFBAWsiAUHIAGwiBCADQaALamogAyAEahDqCEUNAQJAIBIgFRDqCA0AIA0gFBDqCA0AIA4gExDqCA0AIANBgAlqIAMQ6ghFDQELA0AgAy0AoAtBAXFFBEAgFhDqBSEBIAMgAygC9AwgAUETdHI2AvQMIBAQ6gUhASADIAMoAqwMIAFBE3RyNgKsDCAREOoFIQEgAyADKALkCyABQRN0cjYC5AsgAyADKAKkCyIBQRx0QYCAgIABcSADKAKgC0EBdXI2AqALIAMgAygCqAsiBEEcdEGAgICAAXEgAUEBdXI2AqQLIAMgAygCrAsiAUEcdEGAgICAAXEgBEEBdXI2AqgLIAMgAygCsAsiBEEcdEGAgICAAXEgAUEBdXI2AqwLIAMgAygCtAsiAUEcdEGAgICAAXEgBEEBdXI2ArALIAMgAygCuAsiBEEcdEGAgICAAXEgAUEBdXI2ArQLIAMgAygCvAsiAUEcdEGAgICAAXEgBEEBdXI2ArgLIAMgAygCwAsiBEEcdEGAgICAAXEgAUEBdXI2ArwLIAMgAygCxAsiAUEcdEGAgICAAXEgBEEBdXI2AsALIAMgAygCyAsiBEEcdEGAgICAAXEgAUEBdXI2AsQLIAMgAygCzAsiAUEcdEGAgICAAXEgBEEBdXI2AsgLIAMgAygC0AsiBEEcdEGAgICAAXEgAUEBdXI2AswLIAMgAygC1AsiAUEcdEGAgICAAXEgBEEBdXI2AtALIAMgAygC2AsiBEEcdEGAgICAAXEgAUEBdXI2AtQLIAMgAygC3AsiAUEcdEGAgICAAXEgBEEBdXI2AtgLIAMgAygC4AsiBEEcdEGAgICAAXEgAUEBdXI2AtwLIAMgAygC5AsiAUEBdTYC5AsgAyABQRx0QYCAgIABcSAEQQF1cjYC4AtBACEFIAMtAOAGQQFxBEADQCAFQcgAbCIEIANB4AZqaiIBIAEoAgAgAiAEaiIEKAIAajYCACABIAEoAgQgBCgCBGo2AgQgASABKAIIIAQoAghqNgIIIAEgASgCDCAEKAIMajYCDCABIAEoAhAgBCgCEGo2AhAgASABKAIUIAQoAhRqNgIUIAEgASgCGCAEKAIYajYCGCABIAEoAhwgBCgCHGo2AhwgASABKAIgIAQoAiBqNgIgIAEgASgCJCAEKAIkajYCJCABIAEoAiggBCgCKGo2AiggASABKAIsIAQoAixqNgIsIAEgASgCMCAEKAIwajYCMCABIAEoAjQgBCgCNGo2AjQgASABKAI4IAQoAjhqNgI4IAEgASgCPCAEKAI8ajYCPCABIAEoAkAgBCgCQGo2AkAgASABKAJEIAQoAkRqNgJEIAVBAWoiBUEERw0ACyADQeAGahDpBSEBIAMgAygCpAcgAUETdHM2AqQHIAMgASADKAKoB2o2AqgHIAsQ6QUhASADIAMoAuwHIAFBE3RzNgLsByADIAEgAygC8AdqNgLwByAKEOkFIQEgAyADKAK0CCABQRN0czYCtAggAyABIAMoArgIaiIBQf////8BcTYCuAggAyADKAK8CCABQR11aiIBQf////8BcTYCvAggAyADKALACCABQR11aiIBQf////8BcTYCwAggAyADKALECCABQR11aiIBQf////8BcTYCxAggAyADKALICCABQR11aiIBQf////8BcTYCyAggAyADKALMCCABQR11aiIBQf////8BcTYCzAggAyADKALQCCABQR11aiIBQf////8BcTYC0AggAyADKALUCCABQR11aiIBQf////8BcTYC1AggAyADKALYCCABQR11aiIBQf////8BcTYC2AggAyADKALcCCABQR11aiIBQf////8BcTYC3AggAyADKALgCCABQR11aiIBQf////8BcTYC4AggAyADKALkCCABQR11aiIBQf////8BcTYC5AggAyADKALoCCABQR11aiIBQf////8BcTYC6AggAyADKALsCCABQR11aiIBQf////8BcTYC7AggAyADKALwCCABQR11aiIBQf////8BcTYC8AggAyADKAL0CCABQR11aiIBQf////8BcTYC9AggAyADKAL4CCABQR11aiIBQf////8BcTYC+AggAyADKAL8CCABQR11ajYC/AgLIA8Q6gUhASADIAMoArQIIAFBE3RyNgK0CCAKEOoFIQEgAyADKALsByABQRN0cjYC7AcgCxDqBSEBIAMgAygCpAcgAUETdHI2AqQHIAMgAygC5AYiAUEcdEGAgICAAXEgAygC4AZBAXVyNgLgBiADIAMoAugGIgRBHHRBgICAgAFxIAFBAXVyNgLkBiADIAMoAuwGIgFBHHRBgICAgAFxIARBAXVyNgLoBiADIAMoAvAGIgRBHHRBgICAgAFxIAFBAXVyNgLsBiADIAMoAvQGIgFBHHRBgICAgAFxIARBAXVyNgLwBiADIAMoAvgGIgRBHHRBgICAgAFxIAFBAXVyNgL0BiADIAMoAvwGIgFBHHRBgICAgAFxIARBAXVyNgL4BiADIAMoAoAHIgRBHHRBgICAgAFxIAFBAXVyNgL8BiADIAMoAoQHIgFBHHRBgICAgAFxIARBAXVyNgKAByADIAMoAogHIgRBHHRBgICAgAFxIAFBAXVyNgKEByADIAMoAowHIgFBHHRBgICAgAFxIARBAXVyNgKIByADIAMoApAHIgRBHHRBgICAgAFxIAFBAXVyNgKMByADIAMoApQHIgFBHHRBgICAgAFxIARBAXVyNgKQByADIAMoApgHIgRBHHRBgICAgAFxIAFBAXVyNgKUByADIAMoApwHIgFBHHRBgICAgAFxIARBAXVyNgKYByADIAMoAqAHIgRBHHRBgICAgAFxIAFBAXVyNgKcByADIAMoAqQHIgFBAXU2AqQHIAMgAUEcdEGAgICAAXEgBEEBdXI2AqAHDAELCwNAIAMtAIAJQQFxRQRAIBIQ6gUhASADIAMoAtQKIAFBE3RyNgLUCiANEOoFIQEgAyADKAKMCiABQRN0cjYCjAogDhDqBSEBIAMgAygCxAkgAUETdHI2AsQJIAMgAygChAkiAUEcdEGAgICAAXEgAygCgAlBAXVyNgKACSADIAMoAogJIgRBHHRBgICAgAFxIAFBAXVyNgKECSADIAMoAowJIgFBHHRBgICAgAFxIARBAXVyNgKICSADIAMoApAJIgRBHHRBgICAgAFxIAFBAXVyNgKMCSADIAMoApQJIgFBHHRBgICAgAFxIARBAXVyNgKQCSADIAMoApgJIgRBHHRBgICAgAFxIAFBAXVyNgKUCSADIAMoApwJIgFBHHRBgICAgAFxIARBAXVyNgKYCSADIAMoAqAJIgRBHHRBgICAgAFxIAFBAXVyNgKcCSADIAMoAqQJIgFBHHRBgICAgAFxIARBAXVyNgKgCSADIAMoAqgJIgRBHHRBgICAgAFxIAFBAXVyNgKkCSADIAMoAqwJIgFBHHRBgICAgAFxIARBAXVyNgKoCSADIAMoArAJIgRBHHRBgICAgAFxIAFBAXVyNgKsCSADIAMoArQJIgFBHHRBgICAgAFxIARBAXVyNgKwCSADIAMoArgJIgRBHHRBgICAgAFxIAFBAXVyNgK0CSADIAMoArwJIgFBHHRBgICAgAFxIARBAXVyNgK4CSADIAMoAsAJIgRBHHRBgICAgAFxIAFBAXVyNgK8CSADIAMoAsQJIgFBAXU2AsQJIAMgAUEcdEGAgICAAXEgBEEBdXI2AsAJQQAhBSADLQDABEEBcQRAA0AgBUHIAGwiBCADQcAEamoiASABKAIAIAIgBGoiBCgCAGo2AgAgASABKAIEIAQoAgRqNgIEIAEgASgCCCAEKAIIajYCCCABIAEoAgwgBCgCDGo2AgwgASABKAIQIAQoAhBqNgIQIAEgASgCFCAEKAIUajYCFCABIAEoAhggBCgCGGo2AhggASABKAIcIAQoAhxqNgIcIAEgASgCICAEKAIgajYCICABIAEoAiQgBCgCJGo2AiQgASABKAIoIAQoAihqNgIoIAEgASgCLCAEKAIsajYCLCABIAEoAjAgBCgCMGo2AjAgASABKAI0IAQoAjRqNgI0IAEgASgCOCAEKAI4ajYCOCABIAEoAjwgBCgCPGo2AjwgASABKAJAIAQoAkBqNgJAIAEgASgCRCAEKAJEajYCRCAFQQFqIgVBBEcNAAsgA0HABGoQ6QUhASADIAMoAoQFIAFBE3RzNgKEBSADIAEgAygCiAVqNgKIBSAIEOkFIQEgAyADKALMBSABQRN0czYCzAUgAyABIAMoAtAFajYC0AUgCRDpBSEBIAMgAygClAYgAUETdHM2ApQGIAMgASADKAKYBmoiAUH/////AXE2ApgGIAMgAygCnAYgAUEddWoiAUH/////AXE2ApwGIAMgAygCoAYgAUEddWoiAUH/////AXE2AqAGIAMgAygCpAYgAUEddWoiAUH/////AXE2AqQGIAMgAygCqAYgAUEddWoiAUH/////AXE2AqgGIAMgAygCrAYgAUEddWoiAUH/////AXE2AqwGIAMgAygCsAYgAUEddWoiAUH/////AXE2ArAGIAMgAygCtAYgAUEddWoiAUH/////AXE2ArQGIAMgAygCuAYgAUEddWoiAUH/////AXE2ArgGIAMgAygCvAYgAUEddWoiAUH/////AXE2ArwGIAMgAygCwAYgAUEddWoiAUH/////AXE2AsAGIAMgAygCxAYgAUEddWoiAUH/////AXE2AsQGIAMgAygCyAYgAUEddWoiAUH/////AXE2AsgGIAMgAygCzAYgAUEddWoiAUH/////AXE2AswGIAMgAygC0AYgAUEddWoiAUH/////AXE2AtAGIAMgAygC1AYgAUEddWoiAUH/////AXE2AtQGIAMgAygC2AYgAUEddWoiAUH/////AXE2AtgGIAMgAygC3AYgAUEddWo2AtwGCyAMEOoFIQEgAyADKAKUBiABQRN0cjYClAYgCRDqBSEBIAMgAygCzAUgAUETdHI2AswFIAgQ6gUhASADIAMoAoQFIAFBE3RyNgKEBSADIAMoAsQEIgFBHHRBgICAgAFxIAMoAsAEQQF1cjYCwAQgAyADKALIBCIEQRx0QYCAgIABcSABQQF1cjYCxAQgAyADKALMBCIBQRx0QYCAgIABcSAEQQF1cjYCyAQgAyADKALQBCIEQRx0QYCAgIABcSABQQF1cjYCzAQgAyADKALUBCIBQRx0QYCAgIABcSAEQQF1cjYC0AQgAyADKALYBCIEQRx0QYCAgIABcSABQQF1cjYC1AQgAyADKALcBCIBQRx0QYCAgIABcSAEQQF1cjYC2AQgAyADKALgBCIEQRx0QYCAgIABcSABQQF1cjYC3AQgAyADKALkBCIBQRx0QYCAgIABcSAEQQF1cjYC4AQgAyADKALoBCIEQRx0QYCAgIABcSABQQF1cjYC5AQgAyADKALsBCIBQRx0QYCAgIABcSAEQQF1cjYC6AQgAyADKALwBCIEQRx0QYCAgIABcSABQQF1cjYC7AQgAyADKAL0BCIBQRx0QYCAgIABcSAEQQF1cjYC8AQgAyADKAL4BCIEQRx0QYCAgIABcSABQQF1cjYC9AQgAyADKAL8BCIBQRx0QYCAgIABcSAEQQF1cjYC+AQgAyADKAKABSIEQRx0QYCAgIABcSABQQF1cjYC/AQgAyADKAKEBSIBQQF1NgKEBSADIAFBHHRBgICAgAFxIARBAXVyNgKABQwBCwsCQAJAAkAgFiASEOoIIgENACAQIA0Q6ggiAQ0AIBEgDhDqCCIBDQAgA0GgC2ogA0GACWoQ6ggiAUUNAQtBACEFIAFBAEgNAQtBACEFA0AgBUHIAGwiBCADQaALamoiASABKAIAIANBgAlqIARqIgQoAgBrNgIAIAEgASgCBCAEKAIEazYCBCABIAEoAgggBCgCCGs2AgggASABKAIMIAQoAgxrNgIMIAEgASgCECAEKAIQazYCECABIAEoAhQgBCgCFGs2AhQgASABKAIYIAQoAhhrNgIYIAEgASgCHCAEKAIcazYCHCABIAEoAiAgBCgCIGs2AiAgASABKAIkIAQoAiRrNgIkIAEgASgCKCAEKAIoazYCKCABIAEoAiwgBCgCLGs2AiwgASABKAIwIAQoAjBrNgIwIAEgASgCNCAEKAI0azYCNCABIAEoAjggBCgCOGs2AjggASABKAI8IAQoAjxrNgI8IAEgASgCQCAEKAJAazYCQCABIAEoAkQgBCgCRGs2AkQgBUEBaiIFQQRHDQALIANBoAtqEOkFIQEgAyADKALkCyABQRN0czYC5AsgAyABIAMoAugLajYC6AsgERDpBSEBIAMgAygCrAwgAUETdHM2AqwMIAMgASADKAKwDGo2ArAMIBAQ6QUhASADIAMoAvQMIAFBE3RzNgL0DCADIAEgAygC+AxqIgFB/////wFxNgL4DCADIAMoAvwMIAFBHXVqIgFB/////wFxNgL8DCADIAMoAoANIAFBHXVqIgFB/////wFxNgKADSADIAMoAoQNIAFBHXVqIgFB/////wFxNgKEDSADIAMoAogNIAFBHXVqIgFB/////wFxNgKIDSADIAMoAowNIAFBHXVqIgFB/////wFxNgKMDSADIAMoApANIAFBHXVqIgFB/////wFxNgKQDSADIAMoApQNIAFBHXVqIgFB/////wFxNgKUDSADIAMoApgNIAFBHXVqIgFB/////wFxNgKYDSADIAMoApwNIAFBHXVqIgFB/////wFxNgKcDSADIAMoAqANIAFBHXVqIgFB/////wFxNgKgDSADIAMoAqQNIAFBHXVqIgFB/////wFxNgKkDSADIAMoAqgNIAFBHXVqIgFB/////wFxNgKoDSADIAMoAqwNIAFBHXVqIgFB/////wFxNgKsDSADIAMoArANIAFBHXVqIgFB/////wFxNgKwDSADIAMoArQNIAFBHXVqIgFB/////wFxNgK0DSADIAMoArgNIAFBHXVqIgFB/////wFxNgK4DSADIAMoArwNIAFBHXVqNgK8DQJAAkACQAJAIA8gDBDqCCIBDQAgCiAJEOoIIgENACALIAgQ6ggiAQ0AIANB4AZqIANBwARqEOoIIgFFDQELQQAhBkEAIQcgAUEASA0BC0EAIQUDQCAFQcgAbCIEIANB4AZqaiIBIAEoAgAgA0HABGogBGoiBCgCAGs2AgAgASABKAIEIAQoAgRrNgIEIAEgASgCCCAEKAIIazYCCCABIAEoAgwgBCgCDGs2AgwgASABKAIQIAQoAhBrNgIQIAEgASgCFCAEKAIUazYCFCABIAEoAhggBCgCGGs2AhggASABKAIcIAQoAhxrNgIcIAEgASgCICAEKAIgazYCICABIAEoAiQgBCgCJGs2AiQgASABKAIoIAQoAihrNgIoIAEgASgCLCAEKAIsazYCLCABIAEoAjAgBCgCMGs2AjAgASABKAI0IAQoAjRrNgI0IAEgASgCOCAEKAI4azYCOCABIAEoAjwgBCgCPGs2AjwgASABKAJAIAQoAkBrNgJAIAEgASgCRCAEKAJEazYCRCAFQQFqIgVBBEcNAAsMAQsDQCAHQcgAbCIFIANBoAJqaiIBIAIgBWoiBCgCACADQcAEaiAFaiIFKAIAazYCACABIAQoAgQgBSgCBGs2AgQgASAEKAIIIAUoAghrNgIIIAEgBCgCDCAFKAIMazYCDCABIAQoAhAgBSgCEGs2AhAgASAEKAIUIAUoAhRrNgIUIAEgBCgCGCAFKAIYazYCGCABIAQoAhwgBSgCHGs2AhwgASAEKAIgIAUoAiBrNgIgIAEgBCgCJCAFKAIkazYCJCABIAQoAiggBSgCKGs2AiggASAEKAIsIAUoAixrNgIsIAEgBCgCMCAFKAIwazYCMCABIAQoAjQgBSgCNGs2AjQgASAEKAI4IAUoAjhrNgI4IAEgBCgCPCAFKAI8azYCPCABIAQoAkAgBSgCQGs2AkAgASAEKAJEIAUoAkRrNgJEIAdBAWoiB0EERw0ACwNAIAZByABsIgQgA0HgBmpqIgEgA0GgAmogBGoiBCgCACABKAIAajYCACABIAQoAgQgASgCBGo2AgQgASAEKAIIIAEoAghqNgIIIAEgBCgCDCABKAIMajYCDCABIAQoAhAgASgCEGo2AhAgASAEKAIUIAEoAhRqNgIUIAEgBCgCGCABKAIYajYCGCABIAQoAhwgASgCHGo2AhwgASAEKAIgIAEoAiBqNgIgIAEgBCgCJCABKAIkajYCJCABIAQoAiggASgCKGo2AiggASAEKAIsIAEoAixqNgIsIAEgBCgCMCABKAIwajYCMCABIAQoAjQgASgCNGo2AjQgASAEKAI4IAEoAjhqNgI4IAEgBCgCPCABKAI8ajYCPCABIAQoAkAgASgCQGo2AkAgASAEKAJEIAEoAkRqNgJEIAZBAWoiBkEERw0ACwsgA0HgBmoQ6QUhASADIAMoAqQHIAFBE3RzNgKkByADIAEgAygCqAdqNgKoByALEOkFIQEgAyADKALsByABQRN0czYC7AcgAyABIAMoAvAHajYC8AcgChDpBSEBIAMgAygCtAggAUETdHM2ArQIIAMgASADKAK4CGoiAUH/////AXE2ArgIIAMgAygCvAggAUEddWoiAUH/////AXE2ArwIIAMgAygCwAggAUEddWoiAUH/////AXE2AsAIIAMgAygCxAggAUEddWoiAUH/////AXE2AsQIIAMgAygCyAggAUEddWoiAUH/////AXE2AsgIIAMgAygCzAggAUEddWoiAUH/////AXE2AswIIAMgAygC0AggAUEddWoiAUH/////AXE2AtAIIAMgAygC1AggAUEddWoiAUH/////AXE2AtQIIAMgAygC2AggAUEddWoiAUH/////AXE2AtgIIAMgAygC3AggAUEddWoiAUH/////AXE2AtwIIAMgAygC4AggAUEddWoiAUH/////AXE2AuAIIAMgAygC5AggAUEddWoiAUH/////AXE2AuQIIAMgAygC6AggAUEddWoiAUH/////AXE2AugIIAMgAygC7AggAUEddWoiAUH/////AXE2AuwIIAMgAygC8AggAUEddWoiAUH/////AXE2AvAIIAMgAygC9AggAUEddWoiAUH/////AXE2AvQIIAMgAygC+AggAUEddWoiAUH/////AXE2AvgIIAMgAygC/AggAUEddWo2AvwIQQQhAQwCCwNAIAVByABsIgQgA0GACWpqIgEgASgCACADQaALaiAEaiIEKAIAazYCACABIAEoAgQgBCgCBGs2AgQgASABKAIIIAQoAghrNgIIIAEgASgCDCAEKAIMazYCDCABIAEoAhAgBCgCEGs2AhAgASABKAIUIAQoAhRrNgIUIAEgASgCGCAEKAIYazYCGCABIAEoAhwgBCgCHGs2AhwgASABKAIgIAQoAiBrNgIgIAEgASgCJCAEKAIkazYCJCABIAEoAiggBCgCKGs2AiggASABKAIsIAQoAixrNgIsIAEgASgCMCAEKAIwazYCMCABIAEoAjQgBCgCNGs2AjQgASABKAI4IAQoAjhrNgI4IAEgASgCPCAEKAI8azYCPCABIAEoAkAgBCgCQGs2AkAgASABKAJEIAQoAkRrNgJEIAVBAWoiBUEERw0ACyADQYAJahDpBSEBIAMgAygCxAkgAUETdHM2AsQJIAMgASADKALICWo2AsgJIA4Q6QUhASADIAMoAowKIAFBE3RzNgKMCiADIAEgAygCkApqNgKQCiANEOkFIQEgAyADKALUCiABQRN0czYC1AogAyABIAMoAtgKaiIBQf////8BcTYC2AogAyADKALcCiABQR11aiIBQf////8BcTYC3AogAyADKALgCiABQR11aiIBQf////8BcTYC4AogAyADKALkCiABQR11aiIBQf////8BcTYC5AogAyADKALoCiABQR11aiIBQf////8BcTYC6AogAyADKALsCiABQR11aiIBQf////8BcTYC7AogAyADKALwCiABQR11aiIBQf////8BcTYC8AogAyADKAL0CiABQR11aiIBQf////8BcTYC9AogAyADKAL4CiABQR11aiIBQf////8BcTYC+AogAyADKAL8CiABQR11aiIBQf////8BcTYC/AogAyADKAKACyABQR11aiIBQf////8BcTYCgAsgAyADKAKECyABQR11aiIBQf////8BcTYChAsgAyADKAKICyABQR11aiIBQf////8BcTYCiAsgAyADKAKMCyABQR11aiIBQf////8BcTYCjAsgAyADKAKQCyABQR11aiIBQf////8BcTYCkAsgAyADKAKUCyABQR11aiIBQf////8BcTYClAsgAyADKAKYCyABQR11aiIBQf////8BcTYCmAsgAyADKAKcCyABQR11ajYCnAsCQAJAAkACQCAMIA8Q6ggiAQ0AIAkgChDqCCIBDQAgCCALEOoIIgENACADQcAEaiADQeAGahDqCCIBRQ0BC0EAIQZBACEHIAFBAEgNAQtBACEFA0AgBUHIAGwiBCADQcAEamoiASABKAIAIANB4AZqIARqIgQoAgBrNgIAIAEgASgCBCAEKAIEazYCBCABIAEoAgggBCgCCGs2AgggASABKAIMIAQoAgxrNgIMIAEgASgCECAEKAIQazYCECABIAEoAhQgBCgCFGs2AhQgASABKAIYIAQoAhhrNgIYIAEgASgCHCAEKAIcazYCHCABIAEoAiAgBCgCIGs2AiAgASABKAIkIAQoAiRrNgIkIAEgASgCKCAEKAIoazYCKCABIAEoAiwgBCgCLGs2AiwgASABKAIwIAQoAjBrNgIwIAEgASgCNCAEKAI0azYCNCABIAEoAjggBCgCOGs2AjggASABKAI8IAQoAjxrNgI8IAEgASgCQCAEKAJAazYCQCABIAEoAkQgBCgCRGs2AkQgBUEBaiIFQQRHDQALDAELA0AgB0HIAGwiBSADQaACamoiASACIAVqIgQoAgAgA0HgBmogBWoiBSgCAGs2AgAgASAEKAIEIAUoAgRrNgIEIAEgBCgCCCAFKAIIazYCCCABIAQoAgwgBSgCDGs2AgwgASAEKAIQIAUoAhBrNgIQIAEgBCgCFCAFKAIUazYCFCABIAQoAhggBSgCGGs2AhggASAEKAIcIAUoAhxrNgIcIAEgBCgCICAFKAIgazYCICABIAQoAiQgBSgCJGs2AiQgASAEKAIoIAUoAihrNgIoIAEgBCgCLCAFKAIsazYCLCABIAQoAjAgBSgCMGs2AjAgASAEKAI0IAUoAjRrNgI0IAEgBCgCOCAFKAI4azYCOCABIAQoAjwgBSgCPGs2AjwgASAEKAJAIAUoAkBrNgJAIAEgBCgCRCAFKAJEazYCRCAHQQFqIgdBBEcNAAsDQCAGQcgAbCIEIANBwARqaiIBIANBoAJqIARqIgQoAgAgASgCAGo2AgAgASAEKAIEIAEoAgRqNgIEIAEgBCgCCCABKAIIajYCCCABIAQoAgwgASgCDGo2AgwgASAEKAIQIAEoAhBqNgIQIAEgBCgCFCABKAIUajYCFCABIAQoAhggASgCGGo2AhggASAEKAIcIAEoAhxqNgIcIAEgBCgCICABKAIgajYCICABIAQoAiQgASgCJGo2AiQgASAEKAIoIAEoAihqNgIoIAEgBCgCLCABKAIsajYCLCABIAQoAjAgASgCMGo2AjAgASAEKAI0IAEoAjRqNgI0IAEgBCgCOCABKAI4ajYCOCABIAQoAjwgASgCPGo2AjwgASAEKAJAIAEoAkBqNgJAIAEgBCgCRCABKAJEajYCRCAGQQFqIgZBBEcNAAsLIANBwARqEOkFIQEgAyADKAKEBSABQRN0czYChAUgAyABIAMoAogFajYCiAUgCBDpBSEBIAMgAygCzAUgAUETdHM2AswFIAMgASADKALQBWo2AtAFIAkQ6QUhASADIAMoApQGIAFBE3RzNgKUBiADIAEgAygCmAZqIgFB/////wFxNgKYBiADIAMoApwGIAFBHXVqIgFB/////wFxNgKcBiADIAMoAqAGIAFBHXVqIgFB/////wFxNgKgBiADIAMoAqQGIAFBHXVqIgFB/////wFxNgKkBiADIAMoAqgGIAFBHXVqIgFB/////wFxNgKoBiADIAMoAqwGIAFBHXVqIgFB/////wFxNgKsBiADIAMoArAGIAFBHXVqIgFB/////wFxNgKwBiADIAMoArQGIAFBHXVqIgFB/////wFxNgK0BiADIAMoArgGIAFBHXVqIgFB/////wFxNgK4BiADIAMoArwGIAFBHXVqIgFB/////wFxNgK8BiADIAMoAsAGIAFBHXVqIgFB/////wFxNgLABiADIAMoAsQGIAFBHXVqIgFB/////wFxNgLEBiADIAMoAsgGIAFBHXVqIgFB/////wFxNgLIBiADIAMoAswGIAFBHXVqIgFB/////wFxNgLMBiADIAMoAtAGIAFBHXVqIgFB/////wFxNgLQBiADIAMoAtQGIAFBHXVqIgFB/////wFxNgLUBiADIAMoAtgGIAFBHXVqIgFB/////wFxNgLYBiADIAMoAtwGIAFBHXVqNgLcBkEEIQEMAQsLIAACfwJAIANB+AxqIANB2AFqEOoIDQAgA0GwDGogA0GQAWoQ6ggNACADQegLaiADQcgAahDqCA0AIANBoAtqIAMQ6ggNACADQeAGagwBCyADQcAEagsiASgCADYCACAAIAEoAgQ2AgQgACABKAIINgIIIAAgASgCDDYCDCAAIAEoAhA2AhAgACABKAIUNgIUIAAgASgCGDYCGCAAIAEoAhw2AhwgACABKAIgNgIgIAAgASgCJDYCJCAAIAEoAig2AiggACABKAIsNgIsIAAgASgCMDYCMCAAIAEoAjQ2AjQgACABKAI4NgI4IAAgASgCPDYCPCAAIAEoAkA2AkAgACABKAJENgJEIAAgASgCSDYCSCAAIAEoAkw2AkwgACABKAJQNgJQIAAgASgCVDYCVCAAIAEoAlg2AlggACABKAJcNgJcIAAgASgCYDYCYCAAIAEoAmQ2AmQgACABKAJoNgJoIAAgASgCbDYCbCAAIAEoAnA2AnAgACABKAJ0NgJ0IAAgASgCeDYCeCAAIAEoAnw2AnwgACABKAKAATYCgAEgACABKAKEATYChAEgACABKAKIATYCiAEgACABKAKMATYCjAEgACABKAKQATYCkAEgACABKAKUATYClAEgACABKAKYATYCmAEgACABKAKcATYCnAEgACABKAKgATYCoAEgACABKAKkATYCpAEgACABKAKoATYCqAEgACABKAKsATYCrAEgACABKAKwATYCsAEgACABKAK0ATYCtAEgACABKAK4ATYCuAEgACABKAK8ATYCvAEgACABKALAATYCwAEgACABKALEATYCxAEgACABKALIATYCyAEgACABKALMATYCzAEgACABKALQATYC0AEgACABKALUATYC1AEgACABKALYATYC2AEgACABKALcATYC3AEgACABKALgATYC4AEgACABKALkATYC5AEgACABKALoATYC6AEgACABKALsATYC7AEgACABKALwATYC8AEgACABKAL0ATYC9AEgACABKAL4ATYC+AEgACABKAL8ATYC/AEgACABKAKAAjYCgAIgACABKAKEAjYChAIgACABKAKIAjYCiAIgACABKAKMAjYCjAIgACABKAKQAjYCkAIgACABKAKUAjYClAIgACABKAKYAjYCmAIgACABKAKcAjYCnAIgA0HADWokAAvIAgEEfwNAIAAgB0HIAGwiBGoiBSACIARqIgYoAgAgASAEaiIEKAIAajYCACAFIAYoAgQgBCgCBGo2AgQgBSAGKAIIIAQoAghqNgIIIAUgBigCDCAEKAIMajYCDCAFIAYoAhAgBCgCEGo2AhAgBSAGKAIUIAQoAhRqNgIUIAUgBigCGCAEKAIYajYCGCAFIAYoAhwgBCgCHGo2AhwgBSAGKAIgIAQoAiBqNgIgIAUgBigCJCAEKAIkajYCJCAFIAYoAiggBCgCKGo2AiggBSAGKAIsIAQoAixqNgIsIAUgBigCMCAEKAIwajYCMCAFIAYoAjQgBCgCNGo2AjQgBSAGKAI4IAQoAjhqNgI4IAUgBigCPCAEKAI8ajYCPCAFIAYoAkAgBCgCQGo2AkAgBSAGKAJEIAQoAkRqNgJEIAdBAWoiByADRw0ACwuWAQECfyMAQTBrIgEkACABQdPXKjYCICAAQfmGKiABQSBqEJsBIABBARDIASICRQRAIAFB/bUpNgIEIAFB09cqNgIAIABB/IgqIAEQbAALIAAoAgxBEUEBIAIoAgBBhARGGzoABCAAIAAoAgxBCGo2AgwgAhCaASABQdPXKjYCECAAQeCHKiABQRBqEJsBIAFBMGokAEEBC5YBAQJ/IwBBMGsiASQAIAFBt9gqNgIgIABB+YYqIAFBIGoQmwEgAEEBEMgBIgJFBEAgAUGEiCs2AgQgAUG32Co2AgAgAEH8iCogARBsAAsgACgCDEERQQEgAigCAEGABEYbOgAEIAAgACgCDEEIajYCDCACEJoBIAFBt9gqNgIQIABB4IcqIAFBEGoQmwEgAUEwaiQAQQELr48BAxN/BHsCfiMAQZAHayIBJAAgAUGv8Cs2AiAgAEH5hiogAUEgahCbASAAQQEQzgIiCARAIAgoAgwhAiABQqvUmfXBATcD0AQgAUK8uf7o8M+tvAI3A8gEIAFCmcfZ2fHo26kcNwPABCABQtvLw4uRtonHCDcDuAQgAULS2bjzoLWTtBE3A7AEIAFC6Kf2lrDkmJEJNwOoBCABQq7v+63hofOYEDcDoAQgAUGgBmogAiABQaAEahDTAiABQqO9xIDQATcDkAUgAULt05uWwabz/xI3A4gFIAFCy+6Ru+Gsl40SNwOABSABQsO59teglJzPEDcD+AQgAULqg4n7gOueqAk3A/AEIAFC7v//p6Gs//8XNwPoBCABQqvV/v/x///7DzcD4AQgAUGkAWogAUHgBGogAUGgBmoQyQIgAUECNgLcASABQZgCaiICQQI2AgAgASABKQLUATcDkAIgASAB/QACxAH9CwOAAiABIAH9AAK0Af0LA/ABIAEgAf0AAqQB/QsD4AEgAUKr1Jn1wQE3A5AEIAFCvLn+6PDPrbwCNwOIBCABQpnH2dnx6NupHDcDgAQgAULby8OLkbaJxwg3A/gDIAFC0tm486C1k7QRNwPwAyABQuin9paw5JiRCTcD6AMgAUKu7/ut4aHzmBA3A+ADIAFBoAZqQfDTMyABQeADahDTAiABQqO9xIDQATcD0AQgAULt05uWwabz/xI3A8gEIAFCy+6Ru+Gsl40SNwPABCABQsO59teglJzPEDcDuAQgAULqg4n7gOueqAk3A7AEIAFC7v//p6Gs//8XNwOoBCABQqvV/v/x///7DzcDoAQgAUHgBGogAUGgBGogAUGgBmoQyQIgAUECNgKYBSABQqvUmfXBATcD0AMgAUK8uf7o8M+tvAI3A8gDIAFCmcfZ2fHo26kcNwPAAyABQtvLw4uRtonHCDcDuAMgAULS2bjzoLWTtBE3A7ADIAFC6Kf2lrDkmJEJNwOoAyABQq7v+63hofOYEDcDoAMgAUGgBmpBsNQzIAFBoANqENMCIAFCo73EgNABNwOQBCABQu3Tm5bBpvP/EjcDiAQgAULL7pG74ayXjRI3A4AEIAFCw7n216CUnM8QNwP4AyABQuqDifuA656oCTcD8AMgAULu//+noaz//xc3A+gDIAFCq9X+//H///sPNwPgAyABQaAEaiABQeADaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQAyABQry5/ujwz628AjcDiAMgAUKZx9nZ8ejbqRw3A4ADIAFC28vDi5G2iccINwP4AiABQtLZuPOgtZO0ETcD8AIgAULop/aWsOSYkQk3A+gCIAFCru/7reGh85gQNwPgAiABQaAGakHw1DMgAUHgAmoQ0wIgAUKjvcSA0AE3A9ADIAFC7dOblsGm8/8SNwPIAyABQsvukbvhrJeNEjcDwAMgAULDufbXoJSczxA3A7gDIAFC6oOJ+4DrnqgJNwOwAyABQu7//6ehrP//FzcDqAMgAUKr1f7/8f//+w83A6ADIAFB4ANqIAFBoANqIAFBoAZqEMkCIAFBAjYCmAQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAvQFIAEgFP0LAoQGIAFBADYClAYgAUEBNgLgBSABIBT9CwLkBSABQqvUmfXBATcD0AIgAUK8uf7o8M+tvAI3A8gCIAFCmcfZ2fHo26kcNwPAAiABQtvLw4uRtonHCDcDuAIgAULS2bjzoLWTtBE3A7ACIAFC6Kf2lrDkmJEJNwOoAiABQq7v+63hofOYEDcDoAIgAUGgBmogAUHgBWogAUGgAmoQ0wIgAUKjvcSA0AE3A5ADIAFC7dOblsGm8/8SNwOIAyABQsvukbvhrJeNEjcDgAMgAULDufbXoJSczxA3A/gCIAFC6oOJ+4DrnqgJNwPwAiABQu7//6ehrP//FzcD6AIgAUKr1f7/8f//+w83A+ACIAFBoANqIAFB4AJqIAFBoAZqEMkCIAFBAjYC2AMgAjQCACIYIBh+QoCAgBBaBEAgAUHgAWoQ0gILIAFBoAZqIAFB4AFqELQDIAFCo73EgNABNwOQAyABQu3Tm5bBpvP/EjcDiAMgAULL7pG74ayXjRI3A4ADIAFCw7n216CUnM8QNwP4AiABQuqDifuA656oCTcD8AIgAULu//+noaz//xc3A+gCIAFCq9X+//H///sPNwPgAiABQaACaiABQeACaiABQaAGahDJAiABQQI2AtgCIAFBoAZqIAFBoAJqIAFB4ANqENMCIAFCo73EgNABNwOQAyABQu3Tm5bBpvP/EjcDiAMgAULL7pG74ayXjRI3A4ADIAFCw7n216CUnM8QNwP4AiABQuqDifuA656oCTcD8AIgAULu//+noaz//xc3A+gCIAFCq9X+//H///sPNwPgAiABQaACaiABQeACaiABQaAGahDJAiABQQI2AtgCIAFBoAZqIAFBoAJqELQDIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQeACaiABQeAFaiABQaAGahDJAiABQQI2ApgDIAFB4AJqIAFB4AJqIAFBoAJqEPcCIAFB4AJqIAFB4AJqEPAFIAEgASgCoAMgASgC4AJqNgJoIAEgASgCpAMgASgC5AJqNgJsIAEgASgCqAMgASgC6AJqNgJwIAEgASgCrAMgASgC7AJqNgJ0IAEgASgCsAMgASgC8AJqNgJ4IAEgASgCtAMgASgC9AJqNgJ8IAEgASgCuAMgASgC+AJqNgKAASABIAEoArwDIAEoAvwCajYChAEgASABKALAAyABKAKAA2o2AogBIAEgASgCxAMgASgChANqNgKMASABIAEoAsgDIAEoAogDajYCkAEgASABKALMAyABKAKMA2o2ApQBIAEgASgC0AMgASgCkANqNgKYASABIAEoAtQDIAEoApQDajYCnAEgASABKALYAyABKAKYA2oiAjYCoAEgAkGAgIAQTgRAIAFB6ABqENICIAEoAqABIQILIAE0AtgEIhggAqx+QoCAgBBZBEAgAUHoAGoQ0gILIAFBoAZqIAFB6ABqIAFBoARqENMCIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQegAaiABQeAFaiABQaAGahDJAiABQQI2AqABIAFB6ABqIAFB6ABqEMwCIAFBoANqIAFB4ARqEPAFIAE0AtgDIhkgATQCoAF+QoCAgBBZBEAgAUHoAGoQ0gILIAFBoAZqIAFB6ABqIAFBoANqENMCIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQegAaiABQeAFaiABQaAGahDJAiABQQI2AqABIAFB4AJqELgCBEAgGCAZfkKAgIAQWQRAIAFBoARqENICCyABQaAGaiABQaAEaiABQaADahDTAiABQqO9xIDQATcDkAYgAULt05uWwabz/xI3A4gGIAFCy+6Ru+Gsl40SNwOABiABQsO59teglJzPEDcD+AUgAULqg4n7gOueqAk3A/AFIAFC7v//p6Gs//8XNwPoBSABQqvV/v/x///7DzcD4AUgAUHoAGogAUHgBWogAUGgBmoQyQIgAUECNgKgASABQaADaiABQeADahDwBSABKALYA0GAgIAITgRAIAFB6ABqENICCyABQaAGaiABQegAaiABQaADahDTAiABQqO9xIDQATcDkAYgAULt05uWwabz/xI3A4gGIAFCy+6Ru+Gsl40SNwOABiABQsO59teglJzPEDcD+AUgAULqg4n7gOueqAk3A/AFIAFC7v//p6Gs//8XNwPoBSABQqvV/v/x///7DzcD4AUgAUHoAGogAUHgBWogAUGgBmoQyQIgAUECNgKgAQsgAUGgBmogAUHoAGoQtAMgAUKjvcSA0AE3A5AGIAFC7dOblsGm8/8SNwOIBiABQsvukbvhrJeNEjcDgAYgAULDufbXoJSczxA3A/gFIAFC6oOJ+4DrnqgJNwPwBSABQu7//6ehrP//FzcD6AUgAUKr1f7/8f//+w83A+AFIAFBoANqIAFB4AVqIAFBoAZqEMkCIAFBAjYC2AMgAUGgA2ogAUGgA2ogAUHgBGoQ9wIgASgC2ANBgICACE4EQCABQaADahDSAgsgAUGgBmogAUGgA2ogAUHoAGoQ0wIgAUKjvcSA0AE3A5AGIAFC7dOblsGm8/8SNwOIBiABQsvukbvhrJeNEjcDgAYgAULDufbXoJSczxA3A/gFIAFC6oOJ+4DrnqgJNwPwBSABQu7//6ehrP//FzcD6AUgAUKr1f7/8f//+w83A+AFIAFBoANqIAFB4AVqIAFBoAZqEMkCIAFBAjYC2AMgAUGgA2ogAUGgA2ogAUGgBGoQ9wIgAUEoaiABQaADahDxBSABNAJgIhggGH5CgICAEFoEQCABQShqENICCyABQaAGaiABQShqELQDIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQeACaiABQeAFaiABQaAGahDJAiABQQI2ApgDIAFBoANqIAFB4AJqENQCRQRAIAEoAtgCQYCAgAhOBEAgAUHoAGoQ0gILIAFBoAZqIAFB6ABqIAFBoAJqENMCIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQegAaiABQeAFaiABQaAGahDJAiABQQI2AqABIAFBoAZqIAFB6ABqELQDIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQaADaiABQeAFaiABQaAGahDJAiABQQI2AtgDIAFBoANqIAFBoANqIAFB4ARqEPcCIAEoAtgDQYCAgAhOBEAgAUGgA2oQ0gILIAFBoAZqIAFBoANqIAFB6ABqENMCIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQaADaiABQeAFaiABQaAGahDJAiABQQI2AtgDIAFBoANqIAFBoANqIAFBoARqEPcCIAFBKGogAUGgA2oQ8QULIAH9AAMoIRUgAf0AAzghFiAB/QADSCEXIAEoAlghAyABKAJcIQIgAUHsBmoiBiAU/QsCACABQfwGaiIEIBT9CwIAIAFBjAdqIgVBADYCACABIAJBHXU2AtgGIAEgAkH/////AXE2AtQGIAEgAzYC0AYgASAX/QsEwAYgASAW/QsEsAYgASAV/QsEoAYgASAU/QsC3AYgAUKjvcSA0AE3A5AGIAFC7dOblsGm8/8SNwOIBiABQsvukbvhrJeNEjcDgAYgAULDufbXoJSczxA3A/gFIAFC6oOJ+4DrnqgJNwPwBSABQu7//6ehrP//FzcD6AUgAUKr1f7/8f//+w83A+AFIAFBoAVqIAFB4AVqIAFBoAZqEMkCIAEoAqAFIQMgAf0AA+ABIRUgAf0AA/ABIRYgAf0AA4ACIRcgASgCkAIhByABKAKUAiECIAYgFP0LAgAgBCAU/QsCACAFQQA2AgAgASACQR11NgLYBiABIAJB/////wFxNgLUBiABIAc2AtAGIAEgF/0LBMAGIAEgFv0LBLAGIAEgFf0LBKAGIAEgFP0LAtwGIAFCo73EgNABNwOQBiABQu3Tm5bBpvP/EjcDiAYgAULL7pG74ayXjRI3A4AGIAFCw7n216CUnM8QNwP4BSABQuqDifuA656oCTcD8AUgAULu//+noaz//xc3A+gFIAFCq9X+//H///sPNwPgBSABQaAFaiABQeAFaiABQaAGahDJAiADQQJvIAEoAqAFQQJvRwRAIAFBKGogAUEoahDMAgsgAEHAAUEBENoBIgZCuICAgJAMNwIAIABB2OHOfUGLpyoQkAEaIABBfhDbASAGQQE2ArwBIAFB2AJqIgIgASgCoAE2AgAgAUHQAmoiAyABKQKYATcDACABQcACaiIEIAH9AAKIAf0LAwAgAUGwAmoiBSAB/QACeP0LAwAgASAB/QACaP0LA6ACIAEgFP0LA6gEIAEgFP0LA7gEIAEgFP0LA8gEIAEgFP0LA6gDIAEgFP0LA7gDIAEgFP0LA8gDIAFCADcDoAQgAUEBNgLYBCABQgA3A6ADIAFBATYC2AMgASABKAKgAiIHNgLgAyABIAEoAqQCIgk2AuQDIAEgASgCqAIiCjYC6AMgASABKAKsAiILNgLsAyABIAUoAgAiBTYC8AMgASABKAK0AiIMNgL0AyABIAEoArgCIg02AvgDIAEgASgCvAIiDjYC/AMgASAEKAIAIgQ2AoAEIAEgASgCxAIiDzYChAQgASABKALIAiIQNgKIBCABIAEoAswCIhE2AowEIAEgAygCACIDNgKQBCABIAEoAtQCIhI2ApQEIAEgAigCACITNgKYBCABIBM2ApgDIAEgEjYClAMgASADNgKQAyABIBE2AowDIAEgEDYCiAMgASAPNgKEAyABIAQ2AoADIAEgDjYC/AIgASANNgL4AiABIAw2AvQCIAEgBTYC8AIgASALNgLsAiABIAo2AugCIAEgCTYC5AIgASAHNgLgAiABQqvUmfXBATcDkAYgAUK8uf7o8M+tvAI3A4gGIAFCmcfZ2fHo26kcNwOABiABQtvLw4uRtonHCDcD+AUgAULS2bjzoLWTtBE3A/AFIAFC6Kf2lrDkmJEJNwPoBSABQq7v+63hofOYEDcD4AUgAUGgBmpBmNozIAFB4AVqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQeAEaiABQeABaiABQaAGahDJAiABQQI2ApgFIAFBoARqIAFBoARqIAFB4ARqEPcCIAI0AgAgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakHg2TMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakGo2TMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakHw2DMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakG42DMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakGA2DMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakHI1zMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakGQ1zMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakHY1jMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakGg1jMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakHo1TMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgATQC2AIgATQC2AR+QoCAgBBZBEAgAUGgBGoQ0gILIAFBoAZqIAFBoARqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaAEaiABQeABaiABQaAGahDJAiABQQI2AtgEIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakGw1TMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgBGogAUGgBGogAUHgBGoQ9wIgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQcjeMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQZDeMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQdjdMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQaDdMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQejcMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQbDcMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQfjbMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQcDbMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQYjbMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AiABNALYAiABNAKYBH5CgICAEFkEQCABQeADahDSAgsgAUGgBmogAUHgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ANqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAQgAUKr1Jn1wQE3A5AGIAFCvLn+6PDPrbwCNwOIBiABQpnH2dnx6NupHDcDgAYgAULby8OLkbaJxwg3A/gFIAFC0tm486C1k7QRNwPwBSABQuin9paw5JiRCTcD6AUgAUKu7/ut4aHzmBA3A+AFIAFBoAZqQdDaMyABQeAFahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUHgBGogAUHgAWogAUGgBmoQyQIgAUECNgKYBSABQeADaiABQeADaiABQeAEahD3AkEPIQIgATQC2AIhGANAIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGaiACQThsQcDfM2ogAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgA2ogAUGgA2ogAUHgBGoQ9wIgGCABNALYA35CgICAEFkEQCABQaADahDSAgsgAUGgBmogAUGgA2ogAUGgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFBoANqIAFB4AFqIAFBoAZqEMkCIAFBAjYC2AMgAkEBSyEDIAJBAWshAiADDQALIAFCq9SZ9cEBNwOQBiABQry5/ujwz628AjcDiAYgAUKZx9nZ8ejbqRw3A4AGIAFC28vDi5G2iccINwP4BSABQtLZuPOgtZO0ETcD8AUgAULop/aWsOSYkQk3A+gFIAFCru/7reGh85gQNwPgBSABQaAGakHA3zMgAUHgBWoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4ARqIAFB4AFqIAFBoAZqEMkCIAFBAjYCmAUgAUGgA2ogAUGgA2ogAUHgBGoQ9wJBDiECIAE0AtgCIRgDQCABQqvUmfXBATcDkAYgAUK8uf7o8M+tvAI3A4gGIAFCmcfZ2fHo26kcNwOABiABQtvLw4uRtonHCDcD+AUgAULS2bjzoLWTtBE3A/AFIAFC6Kf2lrDkmJEJNwPoBSABQq7v+63hofOYEDcD4AUgAUGgBmogAkE4bEHA5jNqIAFB4AVqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQeAEaiABQeABaiABQaAGahDJAiABQQI2ApgFIAFB4AJqIAFB4AJqIAFB4ARqEPcCIBggATQCmAN+QoCAgBBZBEAgAUHgAmoQ0gILIAFBoAZqIAFB4AJqIAFBoAJqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQeACaiABQeABaiABQaAGahDJAiABQQI2ApgDIAJBAUshAyACQQFrIQIgAw0ACyABQqvUmfXBATcDkAYgAUK8uf7o8M+tvAI3A4gGIAFCmcfZ2fHo26kcNwOABiABQtvLw4uRtonHCDcD+AUgAULS2bjzoLWTtBE3A/AFIAFC6Kf2lrDkmJEJNwPoBSABQq7v+63hofOYEDcD4AUgAUGgBmpBwOYzIAFB4AVqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQeAEaiABQeABaiABQaAGahDJAiABQQI2ApgFIAFB4AJqIAFB4AJqIAFB4ARqEPcCIAFB4ANqIAFB4ANqEPAFIAE0ApgEIAE0AtgEfkKAgIAQWQRAIAFBoARqENICCyABQaAGaiABQaAEaiABQeADahDTAiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUGgBGogAUHgAWogAUGgBmoQyQIgAUECNgLYBCABQeACaiABQeACahDwBSABNAKYAyABNALYA35CgICAEFkEQCABQaADahDSAgsgAUGgBmogAUGgA2ogAUHgAmoQ0wIgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFBoANqIAFB4AFqIAFBoAZqEMkCIAFBAjYC2AMgASgCYEGAgIAITgRAIAFBoANqENICCyABQaAGaiABQaADaiABQShqENMCIAFCo73EgNABNwOQAiABQu3Tm5bBpvP/EjcDiAIgAULL7pG74ayXjRI3A4ACIAFCw7n216CUnM8QNwP4ASABQuqDifuA656oCTcD8AEgAULu//+noaz//xc3A+gBIAFCq9X+//H///sPNwPgASABQaADaiABQeABaiABQaAGahDJAiABQfwGaiICIBT9CwIAIAFB7AZqIgMgFP0LAgAgAUGMB2oiBEEANgIAIAEgAf0AA6AE/QsEoAYgASAB/QADsAT9CwSwBiABIAEoAsAENgLABiABIAH9AALEBP0LAsQGIAEgASgC1AQiBUH/////AXE2AtQGIAEgBUEddTYC2AYgASAU/QsC3AYgAUKjvcSA0AE3A5ACIAFC7dOblsGm8/8SNwOIAiABQsvukbvhrJeNEjcDgAIgAULDufbXoJSczxA3A/gBIAFC6oOJ+4DrnqgJNwPwASABQu7//6ehrP//FzcD6AEgAUKr1f7/8f//+w83A+ABIAFB4AVqIAFB4AFqIAFBoAZqEMkCIAIgFP0LAgAgAyAU/QsCACAEQQA2AgAgASAB/QADoAP9CwSgBiABIAH9AAOwA/0LBLAGIAEgASgCwAM2AsAGIAEgAf0AAsQD/QsCxAYgASABKALUAyICQf////8BcTYC1AYgASACQR11NgLYBiABIBT9CwLcBiABQqO9xIDQATcDkAIgAULt05uWwabz/xI3A4gCIAFCy+6Ru+Gsl40SNwOAAiABQsO59teglJzPEDcD+AEgAULqg4n7gOueqAk3A/ABIAFC7v//p6Gs//8XNwPoASABQqvV/v/x///7DzcD4AEgAUGgBWogAUHgAWogAUGgBmoQyQIgBkEIaiABQeAFaiABQaAFahC1AhogCBDQAiABQa/wKzYCECAAQeCHKiABQRBqEJsBIAFBkAdqJABBAQ8LIAFBktopNgIEIAFBr/ArNgIAIABB/IgqIAEQbAALgwEBAX8jAEFAaiICJAAgAkKjvcSA0AE3AzAgAkLt05uWwabz/xI3AyggAkLL7pG74ayXjRI3AyAgAkLDufbXoJSczxA3AxggAkLqg4n7gOueqAk3AxAgAkLu//+noaz//xc3AwggAkKp1f7/8f//+w83AwAgACABIAIQvwggAkFAayQAC/QBAQF/IwBBgAFrIgIkACACQqO9xIDQATcDMCACQu3Tm5bBpvP/EjcDKCACQsvukbvhrJeNEjcDICACQsO59teglJzPEDcDGCACQuqDifuA656oCTcDECACQu7//6ehrP//FzcDCCACQqvV/v/x///7DzcDACABIAIQ2wIgAkKoj5HAMDcDcCACQvv0xqXQ6fzfHDcDaCACQtK75K6R66XDDDcDYCACQrDO/ZWBheeTHDcDWCACQvqg4p7g2oeqGjcDUCACQvv//6mB6///FTcDSCACQqvV///x///+EzcDQCAAIAEgAkFAaxC/CCACQYABaiQAC9KfBQRGfw57B34CfSMAQeAAayIpJAAgKUHQvyo2AlAgAEH5hiogKUHQAGoQmwEgKUEANgJcAn8gACgCFCgCAEEIaiICIAAoAgxPBEAgACgCEEEsaiECCwJAAkACQCACLQAEQQNHBEAgAiApQdwAakEAEPwBIT4gKSgCXCICQQRKDQEgPg0DIABB67UqQQAQbgwCCyACKAIAIgJBBUgNAgsgKSACNgIQIABB6N4qIClBEGoQbgsgAEGV3SlBABBuQQAMAQsgKUEBNgJAICkgAkHQAGwiAkGo1jFqKAIAIj42AkQgAEGQgSogKUFAaxBbICkgAkHk1TFqIj82AjQgKUHp7ys2AjAgAEHxhSogKUEwahBbAn8gKUHcAGohQCApQdgAaiFBIwBBsLUIayIBJAACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAJB4NUxaiICBH8gAigCSCEaIAFBADYCrI4GIAFCADcCpI4GIAFB/M0Bav0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUGMzgFqQQA2AgAgAUIANwL0zQEgAUGwiDQ2AvDNASABQgo3AqjOASABQgA3AqDOASABQv////8PNwKYzgEgAUJ/NwKQzgEgAUGAwAAQogkiBDYCsM4BIAEgBEGAQGsiBjYCuM4BA0AgAyAEaiICQoCAgIBwNwI4IAJCgICAgHA3AjAgAkKAgICAcDcCKCACQoCAgIBwNwIgIAJCgICAgHA3AhggAkKAgICAcDcCECACQoCAgIBwNwIIIAJCgICAgHA3AgAgA0FAayIDQYDAAEcNAAtBACEDIAFBADYCzM4BIAFCgICAgKABNwLEzgEgAUIANwK8zgEgASAGNgK0zgEgAUGAwAAQogkiBDYC0M4BIAEgBEGAQGsiBjYC2M4BIAFBvM4BaiEKA0AgAyAEaiICQoCAgIBwNwI4IAJCgICAgHA3AjAgAkKAgICAcDcCKCACQoCAgIBwNwIgIAJCgICAgHA3AhggAkKAgICAcDcCECACQoCAgIBwNwIIIAJCgICAgHA3AgAgA0FAayIDQYDAAEcNAAsgASAGNgLUzgECQAJAAkACQAJAIAFB8M0BakGYiTQQyglFBEAgAUHwzQFqQbiJNBDKCUEBRw0BIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgASgC9M0BIgI2ArCWAiABIAJBAWo2AvTNASABQfDNAWogAUGglgJqEMsJGiABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASABQfDNAWo2AoCvCCABQbCINDYCsLIIIAEgASgC9M0BIgJBAWo2AvTNASABIAFBgK8IajYCtLIIIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFB8M0BaiABQaCWAmoQywkhEiABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASABKAL0zQEiAkEBajYC9M0BIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFB8M0BaiABQaCWAmoQywkhFSABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASABKAL0zQEiAkEBajYC9M0BIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFB8M0BaiABQaCWAmoQywkhDyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgAUGgnwdqIQQDQEEAIQMDQCABKAK0sggoAgAiAiACKAIEIgZBAWo2AgQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA9BtIAFCgICAgICAwAA3A+htIAFBfzYC5G0gASAGNgLgbSACIAFB0O0AahDLCSEGIAEoAtBtIgIEQCABIAI2AtRtIAIQKwsgBCABKAKwsggiAv0AA4gB/QsDACAEIAL9AAOYAf0LAxAgAUGQnwdqIAL9AAN4Ikf9CwMAIAEgAv0AA2giSP0LA4CfByABQbCOBmogA0HIAGxqIgIgAUGwnwdq/QADAP0LAzAgAiAE/QADAP0LAyAgAiBH/QsDECACIAY2AkAgAiBI/QsDACADQQFqIgNBgAFHDQALIAFBoJYCaiAHQYDIAGxqIAFBsI4GakGAyAD8CgAAIAdBAWoiB0EHRw0ACyABKAL4zQENAiABIAEoAvTNASICNgL4zQFB3NgAEKIJIhBBAEHc2AD8CwAgASACQQFqNgL0zQEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7COBiABQoCAgICAgMAANwPIjgYgAUF/NgLEjgYgASACNgLAjgYgAUHwzQFqIAFBsI4GahDLCSEDIAEoArCOBiICBEAgASACNgK0jgYgAhArCyAQIAM2AgAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7COBiABQoCAgICAgMAANwPIjgYgAUF/NgLEjgYgASABKAL0zQEiAjYCwI4GIAEgAkEBajYC9M0BIAFB8M0BaiABQbCOBmoQywkhAyABKAKwjgYiAgRAIAEgAjYCtI4GIAIQKwsgECADNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgASgC9M0BIgI2AsCOBiABIAJBAWo2AvTNASABQfDNAWogAUGwjgZqEMsJIQMgASgCsI4GIgIEQCABIAI2ArSOBiACECsLIBAgAzYCCCAQQQxqIgkgAUHwzQFqEMwJIBBBtCBqIgggAUHwzQFqEMwJIBBB3MAAaiIMIAFB8M0BahDNCSAQQdzIAGoiDiABQfDNAWoQzQkgEEHc0ABqIg0gAUHwzQFqEM0JIAFBoJM0NgK0jgYgASABQbCyCGo2ArCOBiABKAKwsggiAikDAEICViACKQMYIAIpAxAgAikDCISEQgBScq1QDQMgAUHIjgZq/QwAAAAAAAAAAAAAAAAAAAAA/QsDACABQgI3A7iOBiABQgA3A8COBiACIAFBuI4GaiACQUBrEKQJIAEoArCOBigCACICKQMAQgNWIAIpAxggAikDECACKQMIhIRCAFJyrVANBCABQaDGBWohCyABQaC2BGohGyABQaCmA2ohHCABQeiOBmr9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAFCADcD4I4GIAFCAzcD2I4GIAIgAUHYjgZqIAJBQGsQpAkgAUH4jgZqIQRBACECA0AgAUGAnwdqIAEoArCOBiIDKAIAIAMoAgQoAgAgAkEDdkH4////AXFB2I00aikDACACQT9xrYinQQFxEM4JIAQgAkHIAGxqIAFBgJ8HakHIAPwKAAAgAkEBaiICQYACRw0ACyABIAFBsLIIajYCkIsCIAFBgAIQogkiBzYClIsCIAEgB0GAAmoiAjYCnIsCIAdBAEGAAvwLACABIAI2ApiLAiABQdDtAGpCACABKAKwsggQtAkgAUGQnwdqIAFB4O0AaiIG/QADAP0LAwAgASAB/QAD0G39CwOAnwcgAUHQ7QBqQgEgASgCsLIIELQJIAFBsJ8HaiAG/QADAP0LAwAgASAB/QAD0G39CwOgnwcgAUHQ7QBqQgIgASgCsLIIELQJIAFB0J8HaiAG/QADAP0LAwAgASAB/QAD0G39CwPAnwcgAUHQ7QBqQgMgASgCsLIIELQJIAFB8J8HaiAG/QADAP0LAwAgASAB/QAD0G39CwPgnwcgASgCsLIIIgIpAwAiWCACKQMYIAIpAxAgAikDCISEIleEIllCAFKtUA0XIAFCADcD0A0gAUHYDWoiA0IANwMQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAIgAUHQDWogAkFAayIEEKQJIAYgAUHgDWr9AAMA/QsDACABIAH9AAPQDf0LA9BtIFdCAFIgWEIBVnKtUA0XIAFCATcD0A0gA0EQaiIGQgA3AwAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAiABQdANaiAEEKQJIAFBgO4AaiABQeANaiIY/QADAP0LAwAgASAB/QAD0A39CwPwbSBZQgBSrVANFyABQgA3A9ANIAZCADcDACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACIAFB0A1qIAQQpAkgAUGg7gBqIBj9AAMA/QsDACABIAH9AAPQDf0LA5BuIFdCAFIgWEIBVnKtUA0XIAFCATcD0A0gA0IANwMQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAIgAUHQDWogBBCkCSABQcDuAGogAUHgDWr9AAMA/QsDACABIAH9AAPQDf0LA7BuIAFB0A1qIAFB0O0AakGAAfwKAAAgAUHQDWogAUGAnwdqIAIQzwkgAUHQDWogAUGAnwdqIAIQ0AkgByABQdANakGAAfwKAAAgAikDACJZIAIpAxggAikDECACKQMIhIQiWIQiV0IAUg0FDBYLIAFBt/MrNgKgDUHkAEH0hyogAUGgDWoQmwlBkJY0KAIAKAIAIQIgAUG38ys2ApANIAJBkYwqIAFBkA1qEGwACyABQdDyKzYCgA1B5ABB9IcqIAFBgA1qEJsJQZCWNCgCACgCACECIAFB0PIrNgLwDCACQZGMKiABQfAMahBsAAsgAUGY7ik2AuAMQeQAQfSHKiABQeAMahCbCUGQljQoAgAoAgAhAiABQZjuKTYC0AwgAkGRjCogAUHQDGoQbAALIAFBgMYqNgIQQeQAQfSHKiABQRBqEJsJQZCWNCgCACgCACECIAFBgMYqNgIAIAJBkYwqIAEQbAALIAFBgMYqNgIwQeQAQfSHKiABQTBqEJsJQZCWNCgCACgCACECIAFBgMYqNgIgIAJBkYwqIAFBIGoQbAALIAFCADcD0A0gA0EQaiIGQgA3AwAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAiABQdANaiAEEKQJIAFB4O0AaiABQeANaiIY/QADAP0LAwAgASAB/QAD0A39CwPQbSBXQgBSrVANECABQgA3A9ANIAZCADcDACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACIAFB0A1qIAQQpAkgAUGA7gBqIBj9AAMA/QsDACABIAH9AAPQDf0LA/BtIFlCAVYiBiBYQgBScq1QDRAgAUIBNwPQDSADQRBqIhhCADcDACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACIAFB0A1qIAQQpAkgAUGg7gBqIAFB4A1qIhb9AAMA/QsDACABIAH9AAPQDf0LA5BuIAYgWEIAUnKtUA0QIAFCATcD0A0gGEIANwMAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAIgAUHQDWogBBCkCSABQcDuAGogFv0AAwD9CwMAIAEgAf0AA9AN/QsDsG4gAUHQDWogAUHQ7QBqQYAB/AoAACABQdANaiABQYCfB2ogAhDPCSABQdANaiABQYCfB2ogAhDQCSAHQYABaiABQdANakGAAfwKAAAgASABQbCyCGo2AqCLAiABQbCOBmogEiAVIBAoAgAgCRDRCSABQbCOBmogECgCBCAQKAIIIA8gCBDRCSAQKAIAIQIgAUHADGpB6I00/QADAP0LAwAgAUHYjTT9AAMA/QsDsAwgAUGQiwJqIAFBgJ8HaiACIAFBsAxqIAwQ0gkgAUGQiwJqIAFBoJYCaiALIAFBgJ8HaiAMENMJIBAoAgQhAiABQaAMakHojTT9AAMA/QsDACABQdiNNP0AAwD9CwOQDCABQZCLAmogAUGAnwdqIAIgAUGQDGogDhDSCSABQZCLAmogHCALIAFBgJ8HaiAOENMJIBAoAgghAiABQYAMakHojTT9AAMA/QsDACABQdiNNP0AAwD9CwPwCyABQZCLAmogAUGAnwdqIAIgAUHwC2ogDRDSCSABQZCLAmogGyALIAFBgJ8HaiANENMJIAcQKwJAAkAgASgCvM4BIgMgASgCwM4BIg5HBEAgAyECA0ACQCACLQAdQQFGBEAgESACKAIMQQFqIgQgBCARSRshEQwBCyACLQAfQQFHDQACQCACKAIEIAIoAgAiBGtBDEcNACAEKAIEDQAgESACKAIMIgQgBCARSRshEQwBCyARIAIoAgxBAWoiBCAEIBFJGyERCyACQSBqIgIgDkcNAAsgASARNgKEzgEgASgCgM4BIQYgAyECA0ACQCACLQAdDQAgAi0AH0EBRw0AIAIoAgwgEUcNACACKAIEIAIoAgAiBGtBDEcNACAEKAIEDQAgAkEAOgAfIAMgBCgCCEEFdGoiBEF/NgIUIARBAToAHSABIAZBAWoiBjYCgM4BCyACQSBqIgIgDkcNAAtBACESIAFBADYCjM4BIAMgDkYNASARQQFrISAgDiADa0EFdSENA0ACQCADIA1BAWsiDUEFdGoiAi0AHkEBRw0AIAJBAToAHCACQQEgAigCGCIEIARBAU0bNgIYIAIoAgxBf0cNACADQQE6ABwLAkAgAi0AHUEBRw0AIAJBAToAHCACIBEgAigCGCIEIAQgEUkbNgIYIBEgAigCDEEBak0NACADQQE6ABwgAyAgIAMoAhgiBCAEICBJGzYCGAsCQAJAAkAgAi0AH0EBRgRAIAJBAToAHCACIAIoAgxBAWoiBCACKAIYIgYgBCAGSxs2AhgMAQsgAi0AHEEBRw0BCyACKAIAIgQgAigCBCIMRg0BIAIoAgwiAkEBayEHA0AgAyAEKAIEQQV0aiIGQQE6ABwgBiACIAYoAhgiCyACIAtLGzYCGCAGKAIMQQFqIAJJBEAgA0EBOgAcIAMgByADKAIYIgYgBiAHSRs2AhgLIAMgBCgCCEEFdGoiBkEBOgAcIAYgAiAGKAIYIgsgAiALSxs2AhggBigCDEEBaiACSQRAIANBAToAHCADIAcgAygCGCIGIAYgB0kbNgIYCyAEQQxqIgQgDEcNAAsMAQsgASASQQFqIhI2AozOAQsgDQ0ACwwCCyABQQA2AozOASABQQA2AoTOAQsgEUEBayEgCyABQQA2AuBtIAFCADcC2G0gASAKNgLUbSABIAEoAvDNATYC0G1BzAAQogkiE0EAQcwA/AsAIBNBATYCCCATICA2AhACQAJAAkACQAJAAkACQAJAAkAgEUUEQEEAIRYMAQsgEUHWqtWqAU8NASARQQxsIgIQogkhFiACQQxrIgIgAkEMcGtBDGoiAgRAIBZBACAC/AsACyACIBZqIRcLIAMgDkYEQCABQQA2AuBtDAMLIA4gA2tBBXUiAkHWqtWqAU8NBSACQQxsIgIQogkhDCACQQxrIgIgAkEMcGtBDGoiAgRAIAxBACAC/AsACyABQQA2AuBtIAJBDG0hDiACIAxqIQggFyAWa0EMbSEPIAFBwI4GaiESQQAhCQNAAkAgAyAJQQV0aiIGLQAcQQFHDQAgBi0AHkUEQCAGKAIAIAYoAgRGDQELIAYoAgwiHCAPSSIhRQ0ZIBYgHEEMbGoiGygCBCAbKAIAa0EUbSEKIAkgDk8NBiAMIAlBDGxqIhggChDUCSABQQA2AoifByABQgA3AoCfBwJAAkACQCAGKAIAIgIgBigCBCIVRwRAIBxBAWshBwNAIAIoAgAiAyABKAKgzgEgASgCnM4BIgRrQQV1Tw0CIBIgBCADQQV0aiID/QADEP0LAwAgASAD/QADAP0LA7COBiACKAIEIgMgASgC1G0iBCgCBCAEKAIAIgRrQQV1IgtPDQMgAyAOTw0LIAcgBCADQQV0aigCDGsiDSAMIANBDGxqIgMoAgQgAygCACIDa0ECdU8NCiABIAMgDUECdGooAgA2AtCOBiACKAIIIgMgC08NAyADIA5PDQsgByAEIANBBXRqKAIMayIEIAwgA0EMbGoiAygCBCADKAIAIgNrQQJ1Tw0KIAEgAyAEQQJ0aigCADYC1I4GIAFBgJ8HaiABQbCOBmoQ1QkgAkEMaiICIBVHDQALCyAhRQ0cAkACfwJAIBwNACAGLQAeQQFxRQ0AQRAMAQtBfyECIBxBAWogEUcNASAGLQAdQQFxRQ0BQRQLIAZqKAIAIQILQQAhAyABQQA2AsCOBiABQgA3AriOBiABQQA6ALSOBiABIAI2ArCOBkEAIQQCQCABKAKEnwciAiABKAKAnwciB0cEQCACIAdrIgJBKG1B58yZM08NASABIAIQogkiBDYCuI4GIAEgAiAEaiIDNgLAjgYgAgRAIAQgByAC/AoAAAsgASADNgK8jgYLAkAgGygCBCICIBsoAghJBEAgAiABKAKwjgY2AgAgAiABQbSOBmotAAA6AAQgAiADNgIQIAIgAzYCDCACIAQ2AgggGyACQRRqNgIEDAELIBsgAUGwjgZqENYJIQMgASgCuI4GIQIgGyADNgIEIAJFDQAgAhArCyABKAKAnwciAgRAIAIQKwsgBigCDCIHQQFqIgIgBigCGE8NAwNAIAIiAyAPTw0eIBggFiACQQxsaiICKAIEIAIoAgBrQRRtIg0Q1AkgAUEANgLYDSABQgA3AtANIBIgASgC0G0iBP0AA5gB/QsDACAE/QADiAEhRyABIAo2AtSOBiABQQA2AtCOBiABIEf9CwOwjgYgAUHQDWogAUGwjgZqENUJAkACQCADDQAgBi0AHkEBcUUNACAGKAIQIQQMAQtBfyEEIAdBAmogEUcNACAGLQAdQQFxRQ0AIAYoAhQhBAtBACEHIAFBADYCkJ8HIAFCADcCiJ8HIAFBAToAhJ8HIAEgBDYCgJ8HQQAhCyABKALUDSIEIAEoAtANIgpHBEAgBCAKayIEQShtQefMmTNPDQIgASAEEKIJIgs2AoifByABIAQgC2oiBzYCkJ8HIAQEQCALIAogBPwKAAALIAEgBzYCjJ8HCwJAIAIoAgQiBCACKAIISQRAIAQgASgCgJ8HNgIAIAQgAUGEnwdqLQAAOgAEIAQgBzYCECAEIAc2AgwgBCALNgIIIAIgBEEUajYCBAwBCyACIAFBgJ8HahDWCSEHIAEoAoifByEEIAIgBzYCBCAERQ0AIAQQKwsgASABKALgbUEBajYC4G0gASgC0A0iAgRAIAIQKwsgDSEKIAMhByADQQFqIgIgBigCGEkNAAsMAwsQoAkACxCgCQALEKAJAAsgASgC1G0iCigCACEDCyAJQQFqIgkgCigCBCADa0EFdUkNAAsMAQsQoAkACyAIIAxHBEADQCAIQQxrIgIoAgAiAwRAIAhBCGsgAzYCACADECsLIAIhCCACIAxHDQALCyAMECsLIBYgF0YNFAJAAkAgFigCACICIBYoAgQiA0cEQANAIAIoAgBBf0YNAiACQRRqIgIgA0cNAAsLAkAgFyAWa0EMbSInQQJPBEBBASEiA0ACfyAWICJBDGxqIiEoAgAiGCAhKAIEIhxGBEBBACESQQAhCSAYDAELICFBDGshFSAhQQhrIQ9BACEbQQAhEkEAIQlBACEIAkACQAJAA0ACQAJAIBgoAgwiCiAYKAIIIgJGBEBBACELQQAhAwwBCyAKIAJrIgJBKG1B58yZM08NASACEKIJIgMgAmohCyAYKAIMIQogGCgCCCECCyADIQcgAiAKRwRAA0AgAigCICIMIA8oAgAgFSgCACIGa0EUbSIETw0KIAIoAiQiDiAETw0KIAYgDkEUbGooAgAhBCAGIAxBFGxqKAIAIQYgAUHAjgZqIg0gAkEQaiIO/QADAP0LAwAgASAC/QADAP0LA7COBiAGIAQgBCAGSRshDCAEIAYgBCAGSRshBgJAIAMgC0kEQCAC/QADACFHIAMgDv0AAwD9CwMQIAMgR/0LAwAgAyAMNgIkIAMgBjYCICADQShqIQMMAQsgAyAHayIEQShtQQFqIgNB58yZM08NA0HmzJkzIAsgB2tBKG0iC0EBdCIOIAMgAyAOSRsgC0Gz5swZTxsiCwR/IAtB58yZM08NISALQShsEKIJBUEACyIOIARqIgMgAf0AA7COBv0LAwAgDf0AAwAhRyADIAw2AiQgAyAGNgIgIAMgR/0LAxAgAyAEQVhtQShsaiEGIAQEQCAGIAcgBPwKAAALIANBKGohAyAOIAtBKGxqIQsgBwRAIAcQKwsgBiEHCyACQShqIgIgCkcNAAsLIAEgAUHQ7QBqNgKwjgYgByADIAFBsI4GakEAQT4gAyAHayIMQShtIgtnQQF0ayADIAdGIg4bQQEQ1wkgC0ECTwRAIAcoAiAhA0EAIQJBASEEA0AgAiEGAkAgAyAHIAQiAkEobGoiBCgCICIDRw0AIAcgBkEobGoiBigCJCAEKAIkRw0AIAYpAwAgBCkDAFINACAGKQMIIAQpAwhSDQAgBikDECAEKQMQUg0AIAYpAxggBCkDGFENBQsgAkEBaiIEIAtHDQALCyAYLQAEIQYgGCgCACENAn8gDgRAQQAhA0EADAELIAtB58yZM08NASAMEKIJIQMgDARAIAMgByAM/AoAAAsgAyAMagshAgJAIBIgG0kEQCASIAI2AhQgEiACNgIQIBIgAzYCDCASIAY6AAggEiAINgIEIBIgDTYCACASQRhqIRIMAQsgEiAJayILQRhtQQFqIgRBq9Wq1QBPDQRBqtWq1QAgGyAJa0EYbSIMQQF0Ig4gBCAEIA5JGyAMQdWq1SpPGyIEQavVqtUATw0eIARBGGwiDBCiCSIOIAtqIgQgAjYCFCAEIAI2AhAgBCADNgIMIAQgBjoACCAEIAg2AgQgBCANNgIAIAQgC0FobUEYbGoiBiEDIAkiAiASRwRAA0AgAyACKQIANwIAIAMgAi0ACDoACCADIAIoAgw2AgwgAyACKAIQNgIQIAMgAigCFDYCFCACQQA2AhQgAkIANwIMIANBGGohAyACQRhqIgIgEkcNAAsgCSECA0AgAigCDCIDBEAgAiADNgIQIAMQKwsgAkEYaiICIBJHDQALCyAMIA5qIRsgBEEYaiESIAkEQCAJECsLIAYhCQsgBwRAIAcQKwsgCEEBaiEIIBwgGEEUaiIYRw0BDAQLCxCgCQALIAFB4/sqNgLAC0HkAEH0hyogAUHAC2oQmwlBkJY0KAIAKAIAIQIgAUHj+yo2ArALIAJBkYwqIAFBsAtqEGwACxCgCQALICEoAgAhGCAhKAIECyECAkACQAJAAkAgEiAJayIDQRhtIgQgAiAYa0EUbUYEQCABIAFB0O0AajYCsI4GIAkgEiABQbCOBmpBAEE+IARnQQF0ayAJIBJGIgobQQEQ2AkgA0EYbSINQQJPBEAgCS0ACCELQQAhBkEBIQIDQCAGIQMCQCALQf8BcSAJIAIiBkEYbGoiAi0ACCILRw0AIAkgA0EYbGoiAygCECIOIAMoAgwiB2siA0EobSEEIAMgAigCECACKAIMIgxrRw0AIAcgDkYNBEEBIAQgBEEBTRshDkEAIQQDQCAHIARBKGwiA2oiAigCICADIAxqIgMoAiBHDQEgAigCJCADKAIkRw0BIAIpAwAgAykDAFINASACKQMIIAMpAwhSDQEgAikDECADKQMQUg0BIAIpAxggAykDGFINASAOIARBAWoiBEcNAAsMBAsgBkEBaiICIA1HDQALCyAKDQIgISgCBCAhKAIAIgtrQRRtIQdBACEDIAkhAgNAIAIoAgQiBCAHTw0IAkAgCyAEQRRsaiIGKAIAIgRBf0cEQCADIARGDQEgAUGPsCs2AuAKQeQAQfSHKiABQeAKahCbCUGQljQoAgAoAgAhAiABQY+wKzYC0AogAkGRjCogAUHQCmoQbAALIAYgAzYCAAsgA0EBaiEDIAJBGGoiAiASRw0ACyAJRQ0EIAoNAwNAIBJBDGsoAgAiAgRAIBJBCGsgAjYCACACECsLIBJBGGsiEiAJRw0ACwwDCyABQeP/KzYCoAtB5ABB9IcqIAFBoAtqEJsJQZCWNCgCACgCACECIAFB4/8rNgKQCyACQZGMKiABQZALahBsAAsgAUH2+yo2AoALQeQAQfSHKiABQYALahCbCUGQljQoAgAoAgAhAiABQfb7KjYC8AogAkGRjCogAUHwCmoQbAALIAlFDQELIAkQKwsgIkEBaiIiICdHDQALCyARICdGBEAgESAgTQ0YIAEgFiAgQQxsaiICKAIEIAIoAgBrQRRtIgQ2AthtIBMgBDYCAEEAIQIgBEECTwRAQQEhAwNAIAJBAWohAiADQQF0IgMgBEkNAAsLIBMgAjYCBAJAIBFBAk8EQCATQSBqIRwgAUG0jgZqIQsgESEIA0AgASAWIAhBDGxqIgJBFGsiBigCACACQRhrIgcoAgBrQRRtIgQgASgC2G1qNgLYbSABIAQ2AoCfB0EBIQNBACECIARBAk8EQANAIAJBAWohAiADQQF0IgMgBEkNAAsLIAEgAjYChJ8HIAhBAWsiCCARTw0bQQAhG0EAIQ8gFiAIQQxsaiIDKAIAIhIhAiADKAIEIhggEkcEQANAIAIoAgwgAigCCGtBKG0gD2ohDyACQRRqIgIgGEcNAAsLIAEgASgC3G0gD2o2AtxtQRAQogkiCUEANgIMIAlCADcCBCAJIA82AgBBACEVIA8EQCAPQdaq1SpPDQMgCSAPQTBsIgIQogkiFTYCBCAJIAIgFWo2AgwgAkEwayICIAJBMHBrQTBqIgIEQCAVQQAgAvwLAAsgCSACIBVqIhs2AggLIBIgGEcEQCAGKAIAIAcoAgAiB2tBFG0hBkEAIQQDQCASKAIIIgIgEigCDCIKRwRAA0AgAigCICIDIAZPDQggAigCJCIMIAZPDQggEigCACEOIAcgA0EUbGooAgAhDSAHIAxBFGxqKAIAIQwgCyAC/QACEP0LAhAgCyAC/QACAP0LAgAgFSAEQTBsaiIDIAw2AgggAyANNgIEIAMgDjYCACADIAH9AAKwjgb9CwIMIAMgAUHAjgZq/QACAP0LAhwgAyABQdCOBmooAgA2AiwgBEEBaiEEIAJBKGoiAiAKRw0ACwsgEkEUaiISIBhHDQALCwJAIA9FDQBBACEGIA9BAUcEQCAPQQFxIQwgD0F+cSEHA0AgFSAGQTBsaiICIAIoAgQiAyACKAIIIgQgAyAESxs2AgggAiAEIAMgAyAESxs2AgQgAiACKAI4IgMgAigCNCIEIAMgBEkbNgI0IAIgBCADIAMgBEkbNgI4IAZBAmoiBiAHRw0ACyAMRQ0BCyAVIAZBMGxqIgIgAigCBCIDIAIoAggiBCADIARLGzYCCCACIAQgAyADIARLGzYCBAsgASABKALQbSICNgKwjgYgFSAbIAFBsI4GakE+IBsgFWtBMG1nQQF0a0EAIBUgG0cbQQEQ2QkgCSACENoJIAEgCTYCiJ8HAkAgEygCJCICIBMoAihJBEAgASkDgJ8HIVUgAiAJNgIIIAIgVTcCACATIAJBDGo2AiQMAQsgHCABQYCfB2oQ2wkhAyABKAKInwchAiATIAM2AiQgAkUNACACKAIEIgMEQCACIAM2AgggAxArCyACECsLIAhBAUsNAAsLA0AgF0EMayIGKAIAIgQEQCAEIgMgF0EIayIHKAIAIgJHBEADQCACQQxrKAIAIgMEQCACQQhrIAM2AgAgAxArCyAEIAJBFGsiAkcNAAsgBigCACEDCyAHIAQ2AgAgAxArCyAGIRcgBiAWRw0ACyAWECsgASABKALYbTYCkM4BIAEgASkC3G03ApTOASATIAEoAvTNATYCFCATIAEoAvjNATYCGCATIAEoAvzNATYCHCATQSxqIhYgEyABKALwzQEQ3AkgAUGW8Co2AqAKQeQAQb2IKiABQaAKahCbCSABQYQKaiABKAKYzgEiAjYCACABQYgKaiABKAKUzgE2AgAgAUGMCmogASkCiM4BNwIAIAFBgApqIAEoApDOASIDIAJrNgIAIAEgASgChM4BNgLwCSABIAM2AvQJIAEgASgC9M0BNgL4CSABIAEoAoDOATYC/AlB5ABBhsEpIAFB8AlqEJsJIAFBsIg0NgK8jgYgAUEANgK4jgYgAUIANwKwjgYgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAsCOBiABQYCAgPwDNgLUjgYgAUGwiDQ2AtCOBiABQcCOBmohGwJAQegHEN0JIgIgASgCxI4GIgNNBEAgAiADTw0BIAEoAsyOBrMgASoC1I4GlY38ASEEIAICfwJAIANBA0kNACADaUEBSw0AIARBAUEgIARBAWtna3QgBEECSRsMAQsgBBDdCQsiBCACIARLGyICIANPDQELIBsgAhDeCQsCQCABKAKojgYiAiABKAKsjgYiBkkEQCACQQE6AAAgAkEBaiECDAELIAIgASgCpI4GIgNrIgRBAWoiAkEASA0XIARB/////wcgBiADayIGQQF0IgcgAiACIAdJGyAGQf////8DTxsiBgR/IAYQogkFQQALIgJqIgdBAToAACAEBEAgAiADIAT8CgAACyABIAIgBmo2AqyOBiABIAI2AqSOBiAHQQFqIQIgA0UNACADECsLIAEgAjYCqI4GIAFBADoAgp8HIAFBATsAgJ8HIAFBpI4GaiACIAFBgJ8HaiABQYOfB2oiA0EDEKcJIBMoAgAiAkH///8HSQRAIAEgAjoAgJ8HIAEgAkEQdjoAgp8HIAEgAkEIdjoAgZ8HIAFBpI4GaiABKAKojgYgAUGAnwdqIANBAxCnCSATKAIIIgJB////B0kEQCABIAI6AICfByABIAJBEHY6AIKfByABIAJBCHY6AIGfByABQaSOBmogASgCqI4GIAFBgJ8HaiABQYOfB2oiA0EDEKcJIBMoAhgiAkH///8HSQRAIAEgAjoAgJ8HIAEgAkEQdjoAgp8HIAEgAkEIdjoAgZ8HIAFBpI4GaiABKAKojgYgAUGAnwdqIANBAxCnCSATKAIcIgJB////B0kEQCABIAI6AICfByABIAJBEHY6AIKfByABIAJBCHY6AIGfByABQaSOBmogASgCqI4GIAFBgJ8HaiABQYOfB2oiA0EDEKcJIBMoAhQiAkH///8HSQRAIAEgAjoAgJ8HIAEgAkEQdjoAgp8HIAEgAkEIdjoAgZ8HIAFBpI4GaiABKAKojgYgAUGAnwdqIANBAxCnCSATKAIkIBMoAiBrQQxtIgJB////B0kEQCABIAI6AICfByABIAJBEHY6AIKfByABIAJBCHY6AIGfByABQaSOBmogASgCqI4GIAFBgJ8HaiABQYOfB2oiCUEDEKcJIAFBgICACBCiCSICNgLUDSABIAI2AtANIAEgAkGAgIAIajYC2A0gEygCICIOIBMoAiQiHEcEQCABQciOBmohCANAAkAgDigCBCICQf///wdJBEAgASACOgCAnwcgASACQRB2OgCCnwcgASACQQh2OgCBnwcgAUHQDWogASgC1A0gAUGAnwdqIAlBAxCnCSAOKAIAIgJB////B0kEQCABIAI6AICfByABIAJBEHY6AIKfByABIAJBCHY6AIGfByABQdANaiABKALUDSABQYCfB2ogCUEDEKcJIA4oAggoAgAiAkH///8HSQRAIAEgAjoAgJ8HIAEgAkEQdjoAgp8HIAEgAkEIdjoAgZ8HIAFB0A1qIAEoAtQNIAFBgJ8HaiAJQQMQpwlBACEKQQAhFUEAIQ9BACESIA4oAggiAigCAEUNAwNAIAFB0A1qIAIoAgQgEkEwbCICaigCACAKEN8JIA4oAggoAgQgAmoiAygCACEKIAFB0A1qIAMoAgQgFRDfCSAOKAIIKAIEIAJqIgMoAgQhFSABQdANaiADKAIIIA8Q3wkgDigCCCgCBCACaiIGKAIIIQ8gBv0AAxAiRyAG/QADICJIIAEoAtCOBhDgCSFVAkACQAJAAkAgASgCxI4GIgdFDQAgASgCwI4GAn8gVaciBCAHQQFrcSAHaUEBSyIMRQ0AGiAEIAQgB0kNABogBCAHcAsiC0ECdGooAgAiAkUNACACKAIAIgJFDQAgSP0dASFZIEj9HQAhVyBH/R0BIVggR/0dACFVIAdBAWshDQNAAkAgBCACKAIEIgNHBEACQCAMRQRAIAMgDXEhAwwBCyADIAdJDQAgAyAHcCEDCyADIAtGDQEMAwsgAikDCCBVUg0AIAIpAxAgWFINACACKQMYIFdSDQAgAikDICBZUQ0DCyACKAIAIgINAAsLIAZBEGohDCABKAK0jgYiAiABKAKwjgYiA2siBEEFdSEHAkAgASgCuI4GIgsgAksEQCACIAz9AAMA/QsDACACIAz9AAMQ/QsDECACQSBqIQIMAQsgB0EBaiICQYCAgMAATw0CQf///z8gCyADayILQQR1Ig0gAiACIA1JGyALQeD///8HTxsiCwR/IAtBgICAwABPDSkgC0EFdBCiCQVBAAsiDSAEaiICIAz9AAMA/QsDACACIAz9AAMQ/QsDECACIAdBBXRrIRggBARAIBggAyAE/AoAAAsgASANIAtBBXRqNgK4jgYgASACQSBqIgI2ArSOBiABIBg2ArCOBiADRQ0AIAMQKwsgASACNgK0jgYgBv0AAxAiRyAG/QADICJIIAEoAtCOBhDgCachBgJAAkAgASgCxI4GIgRFDQAgASgCwI4GAn8gBEEBayAGcSAEaUEBSyINRQ0AGiAGIAQgBksNABogBiAEcAsiC0ECdGooAgAiAkUNACACKAIAIgJFDQAgSP0dASFZIEj9HQAhVyBH/R0BIVggR/0dACFVIARBAWshGANAAkAgBiACKAIEIgNHBEACQCANRQRAIAMgGHEhAwwBCyADIARJDQAgAyAEcCEDCyADIAtGDQEMAwsgAikDCCBVUg0AIAIpAxAgWFINACACKQMYIFdSDQAgAikDICBZUQ0DCyACKAIAIgINAAsLQTAQogkiAiAGNgIEIAJBADYCACACIAz9AAMA/QsDCCACIAz9AAMQ/QsDGCACQQA2AiggASoC1I4GIVwgASgCzI4GQQFqsyFdAkAgBARAIFwgBLOUIF1dRQ0BC0ECIQMCQCAEIARBAWtxQQBHIARBA0lyIARBAXRyIgsgXSBclY38ASIMIAsgDEsbIgtBAUYNACALIAtBAWtxRQRAIAshAwwBCyALEN0JIQMgASgCxI4GIQQLAkAgAyAETQRAIAMgBE8NASABKALMjgazIAEqAtSOBpWN/AEhCyADAn8CQCAEQQNJDQAgBGlBAUsNACALQQFBICALQQFrZ2t0IAtBAkkbDAELIAsQ3QkLIgsgAyALSxsiAyAETw0BCyAbIAMQ3gkLIAEoAsSOBiIEIARBAWsiA3FFBEAgAyAGcSELDAELIAQgBksEQCAGIQsMAQsgBiAEcCELCwJAIAEoAsCOBiIMIAtBAnRqIgYoAgAiA0UEQCACIAEoAsiOBjYCACABIAI2AsiOBiAGIAg2AgAgAigCACIDRQ0BIAMoAgQhAwJAIAQgBEEBayIGcUUEQCADIAZxIQMMAQsgAyAESQ0AIAMgBHAhAwsgDCADQQJ0aiACNgIADAELIAIgAygCADYCACADIAI2AgALIAEgASgCzI4GQQFqNgLMjgYLIAIgBzYCKAwCCyACKAIoIQcMAQsQoAkACyAHQf///wdJBEAgASAHOgCAnwcgASAHQRB2OgCCnwcgASAHQQh2OgCBnwcgAUHQDWogASgC1A0gAUGAnwdqIAlBAxCnCSASQQFqIhIgDigCCCICKAIATw0FDAELCyABQZWuKjYCwAdB5ABB9IcqIAFBwAdqEJsJQZCWNCgCACgCACECIAFBla4qNgKwByACQZGMKiABQbAHahBsAAsgAUGVrio2AuAHQeQAQfSHKiABQeAHahCbCUGQljQoAgAoAgAhAiABQZWuKjYC0AcgAkGRjCogAUHQB2oQbAALIAFBla4qNgKACEHkAEH0hyogAUGACGoQmwlBkJY0KAIAKAIAIQIgAUGVrio2AvAHIAJBkYwqIAFB8AdqEGwACyABQZWuKjYCoAhB5ABB9IcqIAFBoAhqEJsJQZCWNCgCACgCACECIAFBla4qNgKQCCACQZGMKiABQZAIahBsAAsgDkEMaiIOIBxHDQALCyABKAK0jgYgASgCsI4Ga0EFdSICQf///wdJBEAgASACOgCAnwcgASACQRB2OgCCnwcgASACQQh2OgCBnwcgAUGkjgZqIAEoAqiOBiABQYCfB2ogAUGDnwdqQQMQpwkgASgCsI4GIgIgASgCtI4GIgNHBEAgAUHw7QBqIQQDQCABQYCfB2pBsIg0IAL9AAMAIAL9AAMQEJkJIAEgAf0AA4CfB/0LBNBtIAEgAf0AA5CfB/0LBOBtIAFBpI4GaiABKAKojgYgAUHQ7QBqIARBIBCnCSACQSBqIgIgA0cNAAsLIAFBpI4GaiABKAKojgYgASgC0A0iAiABKALUDSIDIAMgAmsQpgkgAUGkjgZqIAEoAqiOBiAWIBNBzABqQSAQpQkgAgRAIAIQKwsgASgCyI4GIgIEQANAIAIoAgAhAyACECsgAyICDQALCyABKALAjgYhAiABQQA2AsCOBiACBEAgAhArCyABKAKwjgYiAgRAIAEgAjYCtI4GIAIQKwsgAUGAnwdqIBNBsIg0ENwJIAFBsI4GaiABQYCfB2oQ4QkgASABKAKojgYgASgCpI4GazYCgAcgASABQbCOBmo2AoQHQeQAQbiFKiABQYAHahCbCSATKAIgIgYEQCAGIgIgEygCJCIDRwRAA0AgA0EEayIEKAIAIQIgBEEANgIAIAIEQCACKAIEIgQEQCACIAQ2AgggBBArCyACECsLIAYgA0EMayIDRw0ACyATKAIgIQILIBMgBjYCJCACECsLIBMQKyAQECsgASgC0M4BIgIEQCABIAI2AtTOASACECsLIAEoArzOASIGBEAgBiICIAEoAsDOASIDRwRAA0AgA0EgayICKAIAIgQEQCADQRxrIAQ2AgAgBBArCyACIQMgAiAGRw0ACyABKAK8zgEhAgsgASAGNgLAzgEgAhArCyABKAKwzgEiAgRAIAEgAjYCtM4BIAIQKwsgASgCnM4BIgIEQCABIAI2AqDOASACECsLIAFBkIsCahCYCSEsIAFBsIoCav0MAAAAAAAAAAAAAAAAAAAAAP0LAgBBACEDIAFBwIoCakEANgIAIAFCADcCqIoCIAEgLDYCpIoCIAFCCjcC3IoCIAFCADcC1IoCIAFC/////w83AsyKAiABQn83AsSKAiABQYDAABCiCSIENgLkigIgASAEQYBAayIGNgLsigIDQCADIARqIgJCgICAgHA3AjggAkKAgICAcDcCMCACQoCAgIBwNwIoIAJCgICAgHA3AiAgAkKAgICAcDcCGCACQoCAgIBwNwIQIAJCgICAgHA3AgggAkKAgICAcDcCACADQUBrIgNBgMAARw0AC0EAIQMgAUEANgKAiwIgAUKAgICAoAE3AviKAiABQgA3AvCKAiABIAY2AuiKAiABQYDAABCiCSIENgKEiwIgASAEQYBAayIGNgKMiwIDQCADIARqIgJCgICAgHA3AjggAkKAgICAcDcCMCACQoCAgIBwNwIoIAJCgICAgHA3AiAgAkKAgICAcDcCGCACQoCAgIBwNwIQIAJCgICAgHA3AgggAkKAgICAcDcCACADQUBrIgNBgMAARw0ACyABIAY2AoiLAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJYCIAFBpIoCaiABQaCWAmoQ4glFBEAgASAs/QAEAP0LBKCWAiABQaSKAmogAUGglgJqEOIJQQFGBEAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA6CWAiABQoCAgICAgMAANwO4lgIgAUF/NgK0lgIgASABKAKoigIiAjYCsJYCIAEgAkEBajYCqIoCIAFBpIoCaiABQaCWAmoQ4wkaIAEoAqCWAiICBEAgASACNgKklgIgAhArCyABIAFBpIoCajYCoIoCIAEgLDYCmIoCIAEgAUGgigJqNgKcigICQCAaBEAgGkGdjgdPDQEgGkGAoAJsIgIQngkiKiACaiEHICohBgNAQQAhBCAGQQBBgKAC/AsAA0AgBCAGaiIC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEMCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEYCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBMABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTwASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBNACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSAAyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBPAEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTQBSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBJAEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTgAyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAkFAa/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBHAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBKABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTQASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBLACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTgAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBLAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSABSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBNAEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSgBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBMADQYDgACEDIARBgAZqIgRBgOAARw0ACwNAIAMgBmoiAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBDAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBGAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBJABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTAASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBKACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTQAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBKAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTwBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBMAEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSQBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBLADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAJBQGv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwRwIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSgASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBIACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSwAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBJADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSwBSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBOAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTQBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBPADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTAAyADQYAGaiIDQYCgAkcNAAsgBkGAoAJqIgYgB0cNAAsLIAEgAUGYigJqNgKEigIgASABQZiKAmo2AoCKAiABIAFBmIoCajYC/IkCIAFBgAgQngkiLzYCiIoCIAEgL0GACGoiAjYCkIoCIC9BAEGACPwLACABIAI2AoyKAiABQaCWAmpBAEGAAvwLACABKAKYigIiB/0ABGAgB/0ABFAgB/0ABEAgB/0ABDD9Uf1R/VEhSSABQYCKAmohMEIAIVUDQP0MAAAAAAAAAAAAAAAAAAAAACFHIFVCAYOnBEAgB/0ABEAhRwsgVUICg0IAUgRAIAf9AARQIEf9USFHCyBVQgSDQgBSBEAgB/0ABGAgR/1RIUcLIFVCCINCAFIEQCAH/QAEcCBH/VEhRwsgVUIQg0IAUgRAIAf9AASAASBH/VEhRwsgVUIgg0IAUgRAIAf9AASQASBH/VEhRwsgVULAAINCAFIEQCAH/QAEoAEgR/1RIUcLIFVCgAGDQgBSBEAgB/0ABLABIEf9USFHCyBVQoACg0IAUgRAIAf9AATAASBH/VEhRwsgVUKABINCAFIEQCAH/QAE0AEgR/1RIUcLIFVCgAiDQgBSBEAgB/0ABOABIEf9USFHCyBVQoAQg0IAUgRAIAf9AATwASBH/VEhRwsgVUKAIINCAFIEQCAH/QAEgAIgR/1RIUcLIFVCgMAAg0IAUgRAIAf9AASQAiBH/VEhRwsgAUGglgJqIFWnQQR0aiBJIFVCgIABg0IAUgR7IAf9AASgAiBH/VEFIEcL/VH9CwQAIFVCAXwiVUIQUg0AC0EAIQsDQEEBIAt0IQICewJAAnsCewJAIAtFBEAgB/0ABDAhSP0MAAAAAAAAAAAAAAAAAAAAACJMIVIMAQsgAkECcQR7IAf9AAQwBf0MAAAAAAAAAAAAAAAAAAAAAAshUiALQQFGBEAgB/0ABDAhSP0MAAAAAAAAAAAAAAAAAAAAACFM/QwAAAAAAAAAAAAAAAAAAAAAIlMMAwv9DAAAAAAAAAAAAAAAAAAAAAAiSCFMIAJBBHEEQCAH/QAEMCFMC/0MAAAAAAAAAAAAAAAAAAAAACACQQVxRQ0BGgsgB/0ABDALIVMgAkEGcUUNASBICyFHIAf9AAQwDAELIEghR/0MAAAAAAAAAAAAAAAAAAAAAAshVP0MAAAAAAAAAAAAAAAAAAAAACFOIAtBAk0EQCAH/QAEMCFOC/0MAAAAAAAAAAAAAAAAAAAAACFPIAJBCHEEQCAH/QAEMCFPC/0MAAAAAAAAAAAAAAAAAAAAACFJIAJBCXEEQCAH/QAEMCFJC/0MAAAAAAAAAAAAAAAAAAAAACFNIAJBCnEEQCAH/QAEMCFNC/0MAAAAAAAAAAAAAAAAAAAAACFKIAJBC3EEQCAH/QAEMCFKC/0MAAAAAAAAAAAAAAAAAAAAACFLIAJBDHEEQCAH/QAEMCFLC/0MAAAAAAAAAAAAAAAAAAAAACFQIAJBDXEEQCAH/QAEMCFQC/0MAAAAAAAAAAAAAAAAAAAAACFRIAJBDnEEQCAH/QAEMCFRCyABIAf9AAQw/QsEoJAGIAEgUf0LBJCQBiABIFD9CwSAkAYgASBL/QsE8I8GIAEgSv0LBOCPBiABIE39CwTQjwYgASBJ/QsEwI8GIAEgT/0LBLCPBiABIE79CwSgjwYgASBU/QsEkI8GIAEgU/0LBICPBiABIEz9CwTwjgYgASBI/QsE4I4GIAEgUv0LBNCOBiABIEf9CwTAjgYgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLCOBkEBIQQgB/0ABAAiSyFIIEshSQNAQRAhAkEPIQMDQCACIQYgSSABQaCWAmogAyICIARrQQR0av0ABAAgAkEEdCIDIAFBoJYCamr9AAQA/VEiSv3XASJH/R0AIEf9HQGEp0EBcQRAAkAgSv0dACJYIEr9HQEiVYRQBED9DAAAAAAAAAAAAAAAAAAAAAAhSAwBCyAH/QAEICFNIAcpAyAhWiAHKQMoIVn9DAAAAAAAAAAAAAAAAAAAAAAhSSBLIUcDQCBVQj+GIFhCAYiEIVcgVUIBiCFVAkAgWEIBg1AEQCBXIVggSSFIDAELAn4gVSBZWgRAIFohViBJIUggWSBVIFlWDQEaIFkgViBXWA0BGgsgVyFWIEchSCBVCyFbIEkgR/1RIUcgVSBZhSFVIFcgWoUhWCBIIUkgViFaIFshWQsgRyBNEJoJIUcgVSBYhEIAUg0ACwsgSiFJCyABQbCOBmogA2oiAyAGQQR0IAFqQZCOBmr9AAQAIAP9AAQA/VEgSBCaCf0LBAAgAkEBayEDIAIgBEsNAAtBECEGIARBAWoiBEEQRw0AC0EPIQMDQCAGIQIgAyEGIAJBD00EQCABQaCWAmogA0EEdGr9AAQAIUcDQCABQbCOBmogAkEEdGoiA0EQayIEIAT9AAQAIAP9AAQAIEcQmgn9Uf0LBAAgAkEBaiICQRBHDQALCyAGQQFrIQMgBg0ACyAvIAtBCHRqIAFBsI4GakGAAvwKAAAgC0EBaiILQQRHDQALIAEgAUGYigJqNgKUigIgGgRAIAFB8JgCaiESIAFBwJgCaiEGIAFBkJgCaiEHIAFB4JcCaiELIAFBsJcCaiEMIAFBgJcCaiEOIAFB0JYCaiEKA0AgKiAjQYCgAmxqIR5BACEVA0AgAUGwlgJqIg/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgCv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCkEQaiIY/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAOQgA3AwAgDkEQaiIJQgA3AwAgDkEIaiIIQgA3AwAgDkEYaiIbQgA3AwAgDEIANwMAIAxBEGoiHEIANwMAIAxBCGoiFkIANwMAIAxBGGoiEUIANwMAIAtCADcDACALQRBqIiFCADcDACALQQhqIhdCADcDACALQRhqIhNCADcDACAHQgA3AwAgB0EQaiIiQgA3AwAgB0EIaiInQgA3AwAgB0EYaiIQQgA3AwAgBkIANwMAIAZBEGoiIEIANwMAIAZBCGoiH0IANwMAIAZBGGoiBUIANwMAIBJBEGoiGf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgEv0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQhHDQALIB4gFUGAA2xqIAFBoJYCakGAA/wKAABBACENIBVBAWoiFUEgRw0ACwNAIA/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgCv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgGP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDkIANwMAIAlCADcDACAIQgA3AwAgG0IANwMAIAxCADcDACAcQgA3AwAgFkIANwMAIBFCADcDACALQgA3AwAgIUIANwMAIBdCADcDACATQgA3AwAgB0IANwMAICJCADcDACAnQgA3AwAgEEIANwMAIAZCADcDACAgQgA3AwAgH0IANwMAIAVCADcDACAZ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAS/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQIDQCABKAKcigIoAgAiAyADKAIEIgRBAWo2AgQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7COBiABQoCAgICAgMAANwPIjgYgAUF/NgLEjgYgASAENgLAjgYgAyABQbCOBmoQ4wkhBCABKAKwjgYiAwRAIAEgAzYCtI4GIAMQKwsgASgCmIoC/QAEACFIIAFBoJYCaiACQTBsaiIDIAQ2AiAgAyBI/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQQFqIgJBCEcNAAsgHiANQYADbGpBgOAAaiABQaCWAmpBgAP8CgAAIA1BAWoiDUHAAEcNAAsgI0EBaiIjIBpHDQALCyABQYDOAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBsM4Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHgzgFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQZDPAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBwM8Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHwzwFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQaDQAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB0NABav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGA0QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8M0BIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSgzgEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNDOASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgM8BIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSwzwEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBODPASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkNABIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTA0AEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPDQASABQbDRAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB4NEBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGQ0gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQcDSAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB8NIBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGg0wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQdDTAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBgNQBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGw1AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoNEBIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQ0QEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBIDSASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsNIBIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTg0gEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJDTASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwNMBIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTw0wEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKDUASABQeDUAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBkNUBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHA1QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQfDVAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBoNYBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHQ1gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQYDXAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBsNcBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHg1wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0NQBIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSA1QEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLDVASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4NUBIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQ1gEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMDWASAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8NYBIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSg1wEgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNDXASABQZDYAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSA2AEgAUHA2AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsNgBIAFB8NgBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBODYASABQaDZAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQ2QEgAUHQ2QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwNkBIAFBgNoBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPDZASABQbDaAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSg2gEgAUHg2gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0NoBIAFBkNsBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBIDbASABQcDbAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSw2wEgAUHw2wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4NsBIAFBoNwBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJDcASABQdDcAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTA3AEgAUGA3QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8NwBIAFBsN0Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKDdASABQeDdAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQ3QEgAUGQ3gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgN4BIAFBwN4Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLDeASABQfDeAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTg3gEgAUGg3wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkN8BIAFB0N8Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMDfASABQYDgAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTw3wEgAUGw4AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoOABIAFB4OABav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNDgASABQZDhAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSA4QEgAUHA4QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsOEBIAFB8OEBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBODhASABQaDiAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQ4gEgAUHQ4gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwOIBIAFBgOMBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPDiASABQbDjAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSg4wEgAUHg4wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0OMBIAFBkOQBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBIDkASABQcDkAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSw5AEgAUHw5AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4OQBIAFBoOUBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJDlASABQdDlAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTA5QEgAUGA5gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8OUBIAFBsOYBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKDmASABQeDmAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQ5gEgAUGQ5wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgOcBIAFBwOcBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLDnASABQfDnAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTg5wEgAUGg6AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkOgBIAFB0OgBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMDoASABQYDpAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTw6AEgAUGw6QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoOkBIAFB4OkBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNDpASABQZDqAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSA6gEgAUHA6gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsOoBIAFB8OoBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBODqASABQaDrAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQ6wEgAUHQ6wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwOsBIAFBgOwBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPDrASABQbDsAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSg7AEgAUHg7AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0OwBIAFBkO0Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBIDtASABQcDtAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSw7QEgAUHw7QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4O0BIAFBoO4Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJDuASABQdDuAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTA7gEgAUGA7wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8O4BIAFBsO8Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKDvASABQeDvAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQ7wEgAUGQ8AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgPABIAFBwPABav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLDwASABQfDwAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTg8AEgAUGg8QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkPEBIAFB0PEBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMDxASABQYDyAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTw8QEgAUGw8gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoPIBIAFB4PIBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNDyASABQZDzAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSA8wEgAUHA8wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsPMBIAFB8PMBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBODzASABQaD0AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQ9AEgAUHQ9AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwPQBIAFBgPUBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPD0ASABQbD1AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSg9QEgAUHg9QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0PUBIAFBkPYBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBID2ASABQcD2AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSw9gEgAUHw9gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4PYBIAFBoPcBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJD3ASABQdD3AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTA9wEgAUGA+AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8PcBIAFBsPgBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKD4ASABQeD4AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQ+AEgAUGQ+QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgPkBIAFBwPkBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLD5ASABQfD5AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTg+QEgAUGg+gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkPoBIAFB0PoBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMD6ASABQYD7AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTw+gEgAUGw+wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoPsBIAFB4PsBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBND7ASABQZD8AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSA/AEgAUHA/AFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsPwBIAFB8PwBav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBOD8ASABQaD9AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQ/QEgAUHQ/QFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwP0BIAFBgP4Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPD9ASABQbD+AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSg/gEgAUHg/gFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0P4BIAFBkP8Bav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBID/ASABQcD/AWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSw/wEgAUHw/wFq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4P8BIAFBoIACav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJCAAiABQdCAAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTAgAIgAUGAgQJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8IACIAFBsIECav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKCBAiABQeCBAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQgQIgAUGQggJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgIICIAFBwIICav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLCCAiABQfCCAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTgggIgAUGggwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkIMCIAFB0IMCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMCDAiABQYCEAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTwgwIgAUGwhAJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoIQCIAFB4IQCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNCEAiABQZCFAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSAhQIgAUHAhQJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsIUCIAFB8IUCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBOCFAiABQaCGAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQhgIgAUHQhgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwIYCIAFBgIcCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPCGAiABQbCHAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSghwIgAUHghwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0IcCIAFBkIgCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBICIAiABQcCIAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSwiAIgAUHwiAJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4IgCIAFBoIkCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJCJAiABQdCJAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTAiQIgAUHwmAJqIRIgAUHAmAJqIQYgAUGQmAJqIQcgAUHglwJqIQsgAUGwlwJqIQwgAUGAlwJqIQ4gAUHQlgJqIQpBACENA0AgAUGwlgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJYCIAr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAr9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIA5CADcDACAOQgA3AxAgDkIANwMIIA5CADcDGCAMQgA3AwAgDEIANwMQIAxCADcDCCAMQgA3AxggC0IANwMAIAtCADcDECALQgA3AwggC0IANwMYIAdCADcDACAHQgA3AxAgB0IANwMIIAdCADcDGCAGQgA3AwAgBkIANwMQIAZCADcDCCAGQgA3AxggEv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgEv0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQhHDQALIAFB8M0BaiANQYADbGogAUGglgJqQYAD/AoAACANQQFqIg1BFEcNAAsgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhAyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASADNgLQzQEgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhAyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASADNgLUzQEgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhAyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASADNgLYzQEgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhAyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASADNgLczQEgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhAyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASADNgLgzQEgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhAyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASADNgLkzQEgASABKAKoigIiAkEBajYCqIoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgAjYCsJYCIAFBpIoCaiABQaCWAmoQ4wkhMiABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgASAyNgLozQECQAJAIAEoAqyKAkUEQCABIAEoAqiKAjYCrIoCIAFB0KEHaiEEIAFBoKEHaiEGIAFB8KAHaiEHIAFBwKAHaiELIAFBkKAHaiEMIAFB4J8HaiEOIAFBsJ8HaiENQQAhAgNAIAFBgJ8HaiACaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIA1qIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgDmoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiAMaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIAtqIgNCADcDACADQgA3AxAgA0IANwMIIANCADcDGCACIAdqIgNCADcDACADQgA3AxAgA0IANwMIIANCADcDGCACIAZqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAIgBGoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkGAA2oiAkGA4ABHDQALQQAhAgNAIAEoApyKAigCACIDIAMoAgQiBEEBajYCBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDoJYCIAFCgICAgICAwAA3A7iWAiABQX82ArSWAiABIAQ2ArCWAiADIAFBoJYCahDjCSEEIAEoAqCWAiIDBEAgASADNgKklgIgAxArCyABKAKYigL9AAQAIUcgAUGAnwdqIAJBMGxqIgMgBDYCICADIEf9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAJBAWoiAkGAAkcNAAsgAUGg8ABqIQQgAUHw7wBqIQYgAUHA7wBqIQcgAUGQ7wBqIQsgAUHg7gBqIQwgAUGw7gBqIQ4gAUGA7gBqIQ1BACECA0AgAUHQ7QBqIAJqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgDWoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiAOaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIAxqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgC2oiA0IANwMAIANCADcDECADQgA3AwggA0IANwMYIAIgB2oiA0IANwMAIANCADcDECADQgA3AwggA0IANwMYIAIgBmoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAiAEaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQYADaiICQYDgAEcNAAtBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgBDYCsJYCIAMgAUGglgJqEOMJIQQgASgCoJYCIgMEQCABIAM2AqSWAiADECsLIAEoApiKAv0ABAAhRyABQdDtAGogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQYACRw0ACyABQaAQaiEEIAFB8A9qIQYgAUHAD2ohByABQZAPaiELIAFB4A5qIQwgAUGwDmohDiABQYAOaiENQQAhAgNAIAFB0A1qIAJqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgDWoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiAOaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIAxqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgC2oiA0IANwMAIANCADcDECADQgA3AwggA0IANwMYIAIgB2oiA0IANwMAIANCADcDECADQgA3AwggA0IANwMYIAIgBmoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAiAEaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQYADaiICQYDgAEcNAAtBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUKAgICAgIDAADcDuJYCIAFBfzYCtJYCIAEgBDYCsJYCIAMgAUGglgJqEOMJIQQgASgCoJYCIgMEQCABIAM2AqSWAiADECsLIAEoApiKAv0ABAAhRyABQdANaiACQTBsaiIDIAQ2AiAgAyBH/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQQFqIgJBgAJHDQALQQAhA0HQn8EAEJ4JIQgDQCADIAhqIgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQwIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwRgIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSQASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBPABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSgAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBIADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSgBSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBNAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTABCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBOADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSwAyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACQUBr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEcCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBNABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSAAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBOACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSQAyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBIAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTgBSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBKAEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTwAyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAMgA0GABmoiA0GAwDRHDQALIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSAwDQgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBLDANCAI/QwAAAAAAAAAAAAAAAAAAAAA/QsE4MA0IAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSQwTQgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBMDBNCAI/QwAAAAAAAAAAAAAAAAAAAAA/QsE8ME0IAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSgwjQgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBNDCNCAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEoI1BIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTAj0EgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBJCPQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsE8I9BIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTgjkEgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBLCOQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJBBIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSAjkEgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBNCNQSAIQZDANGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAhBwMA0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHwwDRq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAIQaDBNGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAhB0ME0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGAwjRq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAIQbDCNGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAhB4MI0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGwjcEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHQj8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGgj8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGAkMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHwjsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHAjsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGwkMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGQjsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHgjcEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHgkMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBNCQQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEgJFBIAhBkJHBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSwkUEgCEHAkcEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBOCRQSAIQfCRwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEkJJBIAhBoJLBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTAkkEgCEHQksEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBPCSQSAIQYCTwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJNBIAhBsJPBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTQk0EgCEHgk8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGQlMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBICUQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEsJRBIAhBwJTBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTglEEgCEHwlMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBJCVQSAIQaCVwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEwJVBIAhB0JXBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTwlUEgCEGAlsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBKCWQSAIQbCWwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsE0JZBIAhB4JbBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSAl0EgCEGQl8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHAl8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBLCXQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsE4JdBIAhB8JfBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSQmEEgCEGgmMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBMCYQSAIQdCYwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsE8JhBIAhBgJnBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSgmUEgCEGwmcEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBNCZQSAIQeCZwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEgJpBIAhBkJrBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSwmkEgCEHAmsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEHwmsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBOCaQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEkJtBIAhBoJvBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTAm0EgCEHQm8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBPCbQSAIQYCcwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJxBIAhBsJzBAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTQnEEgCEHgnMEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBICdQSAIQZCdwQBq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEsJ1BIAhBwJ3BAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTgnUEgCEHwncEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGgnsEAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBJCeQSAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEwJ5BIAhB0J7BAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwTwnkEgCEGAn8EAav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCEGQjcEAakIANwMAIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwSAjUFBACECIAhBwJ/BAGpBADYCACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJ9BIAhBsJ/BAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAggGjYCxJ9BIBoEfyAaQZ2OxwNPDQIgGkHABGwiAxCeCSECIANBwARrIgQgBEHABHBrQcAEaiIEBEAgAkEAIAT8CwALIAggAiADajYCqJ9BIAggAiAEajYCpJ9BIAggAjYCoJ9BIAgoAqyfQSECIAgoArCfQQVBAAshAyAIQayfwQBqITcCQCADIAJrQYAJbSIDIBpJBEAgNyAaIANrEOQJDAELIAMgGk0NACAIIAIgGkGACWxqNgKwn0ELIAhBuJ/BAGohOAJAIAgoAryfQSAIKAK4n0EiA2tBgAltIgIgGkkEQCA4IBogAmsQ5AkMAQsgAiAaTQ0AIAggAyAaQYAJbGo2AryfQQsgCEGAjcEAaiEtAkAgCCgChI1BIgIgCCgCgI1BIgNrIgZBDG0iBCAaSQRAIBogBGsiBCAIKAKIjUEiByACa0EMbU0EQCAEQQxsQQxrIgMgA0EMcGtBDGoiAwRAIAJBACAD/AsACyAIIAIgA2o2AoSNQQwCC0HVqtWqASAHIANrQQxtIgJBAXQiByAaIAcgGksbIAJBqtWq1QBPGyICQdaq1aoBTw0mIAJBDGwiCxCiCSIMIAZqIQIgBEEMbEEMayIEIARBDHBrQQxqIgQEQCACQQAgBPwLAAsgAiAGQXRtQQxsaiEHIAYEQCAHIAMgBvwKAAALIAggCyAMajYCiI1BIAggAiAEajYChI1BIAggBzYCgI1BIANFDQEgAxArDAELIAQgGksEQCACIAMgGkEMbGoiBkcEQANAIAJBDGsiAygCACIEBEAgAkEIayAENgIAIAQQKwsgBiADIgJHDQALCyAIIAY2AoSNQQsgGkUNEgtBACEEA0ACQCAtKAIAIARBDGxqIgIoAgQiByACKAIAIgZrIgNBgC5tIgtBAU0EQEECIAtrIgsgAigCCCIMIAdrQYAubU0EQEGALiADayIDIANBgC5wa0GALmoiAwRAIAdBACAD/AsACyACIAMgB2o2AgQMAgsgA0GALm0gC2oiB0HlwixPDQVB5MIsIAwgBmtBgC5tIgtBAXQiDCAHIAcgDEkbIAtBsqEWTxsiCwR/IAtB5cIsTw0oIAtBgC5sEKIJBUEACyIMIANqIQdBgC4gA2siDiAOQYAucGtBgC5qIg4EQCAHQQAgDvwLAAsgByADQYBSbUGALmxqIQ0gAwRAIA0gBiAD/AoAAAsgAiAMIAtBgC5sajYCCCACIAcgDmo2AgQgAiANNgIAIAZFDQEgBhArDAELIANBgNwARg0AIAIgBkGA3ABqNgIECyAEQQFqIgQgGkcNAAsMEQsgAUGY7ik2ArAGQeQAQfSHKiABQbAGahCbCUGQljQoAgAoAgAhAiABQZjuKTYCoAYgAkGRjCogAUGgBmoQbAALEKAJAAsQoAkACxCgCQALIAFB0PIrNgLQBkHkAEH0hyogAUHQBmoQmwlBkJY0KAIAKAIAIQIgAUHQ8is2AsAGIAJBkYwqIAFBwAZqEGwACyABQbfzKzYC8AZB5ABB9IcqIAFB8AZqEJsJQZCWNCgCACgCACECIAFBt/MrNgLgBiACQZGMKiABQeAGahBsAAsgAUGVrio2AqAHQeQAQfSHKiABQaAHahCbCUGQljQoAgAoAgAhAiABQZWuKjYCkAcgAkGRjCogAUGQB2oQbAALIAFBla4qNgLACEHkAEH0hyogAUHACGoQmwlBkJY0KAIAKAIAIQIgAUGVrio2ArAIIAJBkYwqIAFBsAhqEGwACyABQZWuKjYC4AhB5ABB9IcqIAFB4AhqEJsJQZCWNCgCACgCACECIAFBla4qNgLQCCACQZGMKiABQdAIahBsAAsgAUGVrio2AoAJQeQAQfSHKiABQYAJahCbCUGQljQoAgAoAgAhAiABQZWuKjYC8AggAkGRjCogAUHwCGoQbAALIAFBla4qNgKgCUHkAEH0hyogAUGgCWoQmwlBkJY0KAIAKAIAIQIgAUGVrio2ApAJIAJBkYwqIAFBkAlqEGwACyABQZWuKjYCwAlB5ABB9IcqIAFBwAlqEJsJQZCWNCgCACgCACECIAFBla4qNgKwCSACQZGMKiABQbAJahBsAAsgAUGVrio2AuAJQeQAQfSHKiABQeAJahCbCUGQljQoAgAoAgAhAiABQZWuKjYC0AkgAkGRjCogAUHQCWoQbAALEKAJAAsgAUHJ/ys2AsAKQeQAQfSHKiABQcAKahCbCUGQljQoAgAoAgAhAiABQcn/KzYCsAogAkGRjCogAUGwCmoQbAALEKAJAAsgAUHPuis2AuALQeQAQfSHKiABQeALahCbCUGQljQoAgAoAgAhAiABQc+6KzYC0AsgAkGRjCogAUHQC2oQbAALAkACQAJAAkACQAJAIAgoApCNQSICIAgoAoyNQSIDayIGQQxtIgQgGkkEQCAaIARrIgQgCCgClI1BIgcgAmtBDG1NBEAgBEEMbEEMayIDIANBDHBrQQxqIgMEQCACQQAgA/wLAAsgCCACIANqNgKQjUEMAgsgGkHWqtWqAU8NAkHVqtWqASAHIANrQQxtIgJBAXQiByAaIAcgGksbIAJBqtWq1QBPGyICQdaq1aoBTw0ZIAJBDGwiCxCiCSIMIAZqIQIgBEEMbEEMayIEIARBDHBrQQxqIgQEQCACQQAgBPwLAAsgAiAGQXRtQQxsaiEHIAYEQCAHIAMgBvwKAAALIAggCyAMajYClI1BIAggAiAEajYCkI1BIAggBzYCjI1BIANFDQEgAxArDAELIAQgGk0NACACIAMgGkEMbGoiBkcEQANAIAJBDGsiAygCACIEBEAgAkEIayAENgIAIAQQKwsgBiADIgJHDQALCyAIIAY2ApCNQQsgCEGgn8EAaiE5IAhBkJ7BAGohOiAIQYCdwQBqITsgCEHwm8EAaiE8IAhB4JrBAGohMSAIQaCWwQBqITMgCEHgkcEAaiE0IAhBoI3BAGohNSAIQYDANGohNiABQbCWAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB4JYCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGQlwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQcCXAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB8JcCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGgmAJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQdCYAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBgJkCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKCWAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0JYCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSAlwIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLCXAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4JcCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQmAIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMCYAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8JgCQQAhAgNAIAEoApyKAigCACIDIAMoAgQiBEEBajYCBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDsI4GIAFCgICAgICAwAA3A8iOBiABQX82AsSOBiABIAQ2AsCOBiADIAFBsI4GahDjCSEEIAEoArCOBiIDBEAgASADNgK0jgYgAxArCyABKAKYigL9AAQAIUcgAUGglgJqIAJBMGxqIgMgBDYCICADIEf9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAJBAWoiAkEIRw0ACyA2IAFBoJYCakGAA/wKAAAgAUHwmAJqIRIgAUHAmAJqIQYgAUGQmAJqIQcgAUHglwJqIQsgAUGwlwJqIQwgAUGAlwJqIQ4gAUHQlgJqIQpBACENA0AgAUGwlgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJYCIAr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAr9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIA5CADcDACAOQgA3AxAgDkIANwMIIA5CADcDGCAMQgA3AwAgDEIANwMQIAxCADcDCCAMQgA3AxggC0IANwMAIAtCADcDECALQgA3AwggC0IANwMYIAdCADcDACAHQgA3AxAgB0IANwMIIAdCADcDGCAGQgA3AwAgBkIANwMQIAZCADcDCCAGQgA3AxggEv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgEv0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQhHDQALIAggDUGAA2xqIAFBoJYCakGAA/wKAAAgDUEBaiINQa4RRw0ACyAIQYDDNGohLkEAIQIDQCAuIAJBgC5saiABQaSKAmoQ5QkgAkEBaiICQSNHDQALIAFBsJYCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHglgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQZCXAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBwJcCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHwlwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQaCYAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB0JgCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGAmQJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQbCZAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNCWAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgJcCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSwlwIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBOCXAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkJgCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTAmAIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPCYAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJkCIAFB4JkCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGQmgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQcCaAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQmQIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBICaAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsJoCQQAhAgNAIAEoApyKAigCACIDIAMoAgQiBEEBajYCBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDsI4GIAFCgICAgICAwAA3A8iOBiABQX82AsSOBiABIAQ2AsCOBiADIAFBsI4GahDjCSEEIAEoArCOBiIDBEAgASADNgK0jgYgAxArCyABKAKYigL9AAQAIUcgAUGglgJqIAJBMGxqIgMgBDYCICADIEf9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAJBAWoiAkEMRw0ACyA1IAFBoJYCakHABPwKAAAgAUGwlgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQeCWAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBkJcCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHAlwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQfCXAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBoJgCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHQmAJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQYCZAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBsJkCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKCWAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0JYCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSAlwIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLCXAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE4JcCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSQmAIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBMCYAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE8JgCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSgmQIgAUHgmQJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQZCaAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBwJoCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNCZAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgJoCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSwmgJBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQxHDQALIDQgAUGglgJqQcAE/AoAACABQbCWAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB4JYCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGQlwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQcCXAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB8JcCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGgmAJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQdCYAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBgJkCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGwmQJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJYCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQlgIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBICXAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsJcCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTglwIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBJCYAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEwJgCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTwmAIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKCZAiABQeCZAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBkJoCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHAmgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsE0JkCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSAmgIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBLCaAkEAIQIDQCABKAKcigIoAgAiAyADKAIEIgRBAWo2AgQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7COBiABQoCAgICAgMAANwPIjgYgAUF/NgLEjgYgASAENgLAjgYgAyABQbCOBmoQ4wkhBCABKAKwjgYiAwRAIAEgAzYCtI4GIAMQKwsgASgCmIoC/QAEACFHIAFBoJYCaiACQTBsaiIDIAQ2AiAgAyBH/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQQFqIgJBDEcNAAsgMyABQaCWAmpBwAT8CgAAIAFBsJYCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHglgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQZCXAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBwJcCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHwlwJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQaCYAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB0JgCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGAmQJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQbCZAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBNCWAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEgJcCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSwlwIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBOCXAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEkJgCIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTAmAIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBPCYAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJkCIAFB4JkCav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUGQmgJq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQcCaAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwTQmQIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBICaAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsJoCQQAhAgNAIAEoApyKAigCACIDIAMoAgQiBEEBajYCBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDsI4GIAFCgICAgICAwAA3A8iOBiABQX82AsSOBiABIAQ2AsCOBiADIAFBsI4GahDjCSEEIAEoArCOBiIDBEAgASADNgK0jgYgAxArCyABKAKYigL9AAQAIUcgAUGglgJqIAJBMGxqIgMgBDYCICADIEf9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAJBAWoiAkEMRw0ACyAxIAFBoJYCakHABPwKAAAgCCgCxJ9BBEAgAUGwmgJqISQgAUGAmgJqISUgAUHQmQJqISggAUGgmQJqISYgAUHwmAJqIQ0gAUHAmAJqIQYgAUGQmAJqIQcgAUHglwJqIQsgAUGwlwJqIQwgAUGAlwJqIQ4gAUHQlgJqIRIDQCArQQxsIRRBACEKA0AgCCgCjI1BIRUgAUGwlgJqIhv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgEv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgEkEQaiIc/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAOQgA3AwAgDkEQaiIWQgA3AwAgDkEIaiIRQgA3AwAgDkEYaiIhQgA3AwAgDEIANwMAIAxBEGoiF0IANwMAIAxBCGoiE0IANwMAIAxBGGoiIkIANwMAIAtCADcDACALQRBqIidCADcDACALQQhqIhBCADcDACALQRhqIiBCADcDACAHQgA3AwAgB0EQaiIfQgA3AwAgB0EIaiIFQgA3AwAgB0EYaiIZQgA3AwAgBkIANwMAIAZBEGoiHUIANwMAIAZBCGoiHkIANwMAIAZBGGoiGkIANwMAIA1BEGoiI/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDf0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQhHDQALAkAgFCAVaiICKAIEIgMgAigCCCIVSQRAIAMgAUGglgJqQYAD/AoAACADQYADaiEDDAELIAMgAigCACIEayIDQYADbUEBaiIPQavVqgVPDQVBqtWqBSAVIARrQYADbSIVQQF0IhggDyAPIBhJGyAVQdWq1QJPGyIPBH8gD0Gr1aoFTw0cIA9BgANsEJ4JBUEACyIYIANqIhUgAUGglgJqQYAD/AoAACAVIANBgH1tQYADbGohCSADBEAgCSAEIAP8CgAACyACIBggD0GAA2xqNgIIIAIgFUGAA2oiAzYCBCACIAk2AgAgBEUNACAEECsLIAIgAzYCBCAKQQFqIgpBgAFHDQALIC0oAgAgFGooAgAgAUGkigJqEOUJIC0oAgAgFGooAgBBgC5qIAFBpIoCahDlCSA5KAIAIRQgG/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKCWAiAS/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAc/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAOQgA3AwAgFkIANwMAIBFCADcDACAhQgA3AwAgDEIANwMAIBdCADcDACATQgA3AwAgIkIANwMAIAtCADcDACAnQgA3AwAgEEIANwMAICBCADcDACAHQgA3AwAgH0IANwMAIAVCADcDACAZQgA3AwAgBkIANwMAIB1CADcDACAeQgA3AwAgGkIANwMAICP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIA39DAAAAAAAAAAAAAAAAAAAAAD9CwQAICZBEGoiCv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgKEEQaiIV/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAlQRBqIg/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICRBEGoiGP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJP0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQxHDQALIBQgK0HABGxqIAFBoJYCakHABPwKAAAgNygCACEUIBv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgEv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgHP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDkIANwMAIBZCADcDACARQgA3AwAgIUIANwMAIAxCADcDACAXQgA3AwAgE0IANwMAICJCADcDACALQgA3AwAgJ0IANwMAIBBCADcDACAgQgA3AwAgB0IANwMAIB9CADcDACAFQgA3AwAgGUIANwMAIAZCADcDACAdQgA3AwAgHkIANwMAIBpCADcDACAj/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAN/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAK/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAm/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAV/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAP/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAY/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAk/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQIDQCABKAKcigIoAgAiAyADKAIEIgRBAWo2AgQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7COBiABQoCAgICAgMAANwPIjgYgAUF/NgLEjgYgASAENgLAjgYgAyABQbCOBmoQ4wkhBCABKAKwjgYiAwRAIAEgAzYCtI4GIAMQKwsgASgCmIoC/QAEACFHIAFBoJYCaiACQTBsaiIDIAQ2AiAgAyBH/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQQFqIgJBDEcNAAsgFCArQYAJbCI9aiIUIAFBoJYCakHABPwKAAAgG/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBKCWAiAS/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAc/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAOQgA3AwAgFkIANwMAIBFCADcDACAhQgA3AwAgDEIANwMAIBdCADcDACATQgA3AwAgIkIANwMAIAtCADcDACAnQgA3AwAgEEIANwMAICBCADcDACAHQgA3AwAgH0IANwMAIAVCADcDACAZQgA3AwAgBkIANwMAIB1CADcDACAeQgA3AwAgGkIANwMAICP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIA39DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIBX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIA/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIBj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhAgNAIAEoApyKAigCACIDIAMoAgQiBEEBajYCBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDsI4GIAFCgICAgICAwAA3A8iOBiABQX82AsSOBiABIAQ2AsCOBiADIAFBsI4GahDjCSEEIAEoArCOBiIDBEAgASADNgK0jgYgAxArCyABKAKYigL9AAQAIUcgAUGglgJqIAJBMGxqIgMgBDYCICADIEf9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAJBAWoiAkEMRw0ACyAUQcAEaiABQaCWAmpBwAT8CgAAIDgoAgAhFCAb/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEoJYCIBL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIBz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIA5CADcDACAWQgA3AwAgEUIANwMAICFCADcDACAMQgA3AwAgF0IANwMAIBNCADcDACAiQgA3AwAgC0IANwMAICdCADcDACAQQgA3AwAgIEIANwMAIAdCADcDACAfQgA3AwAgBUIANwMAIBlCADcDACAGQgA3AwAgHUIANwMAIB5CADcDACAaQgA3AwAgI/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgKP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgD/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgGP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJP0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACECA0AgASgCnIoCKAIAIgMgAygCBCIEQQFqNgIEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOwjgYgAUKAgICAgIDAADcDyI4GIAFBfzYCxI4GIAEgBDYCwI4GIAMgAUGwjgZqEOMJIQQgASgCsI4GIgMEQCABIAM2ArSOBiADECsLIAEoApiKAv0ABAAhRyABQaCWAmogAkEwbGoiAyAENgIgIAMgR/0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkEBaiICQQxHDQALIBQgPWoiFCABQaCWAmpBwAT8CgAAIBv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSglgIgEv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgHP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDkIANwMAIBZCADcDACARQgA3AwAgIUIANwMAIAxCADcDACAXQgA3AwAgE0IANwMAICJCADcDACALQgA3AwAgJ0IANwMAIBBCADcDACAgQgA3AwAgB0IANwMAIB9CADcDACAFQgA3AwAgGUIANwMAIAZCADcDACAdQgA3AwAgHkIANwMAIBpCADcDACAj/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAN/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAK/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAm/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAV/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAP/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAY/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAk/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQIDQCABKAKcigIoAgAiAyADKAIEIgRBAWo2AgQgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA7COBiABQoCAgICAgMAANwPIjgYgAUF/NgLEjgYgASAENgLAjgYgAyABQbCOBmoQ4wkhBCABKAKwjgYiAwRAIAEgAzYCtI4GIAMQKwsgASgCmIoC/QAEACFHIAFBoJYCaiACQTBsaiIDIAQ2AiAgAyBH/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQQFqIgJBDEcNAAsgFEHABGogAUGglgJqQcAE/AoAACArQQFqIisgCCgCxJ9BSQ0ACwsgASgCsIoCBEAgAUGWpCs2ApAGQeQAQfSHKiABQZAGahCbCUGQljQoAgAoAgAhAiABQZakKzYCgAYgAkGRjCogAUGABmoQbAALIAEgASgCqIoCNgKwigIgAUGwDWogAUGkigJqEOYJIAFBsA1qQQhyIAFBpIoCahDmCSABQcANaiABQaSKAmoQ5glBACEEQYDANBCeCSIMQQBBgMA0/AsAA0AgASgCnIoCKAIAIQMgASABKAKYigL9AAQAIkf9CwSwjgYgAyABQbCOBmoQ4gkhAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDoJYCIAFCADcDuJYCIAFCfzcDsJYCIARBkM4xai0AACEGIAIEQCABQgA3ArSyCCABIAI2ArCyCCABQaCWAmogAUGwsghqEOcJCyAMIARBgANsaiECIAZBAXEhByADIAFBoJYCahDjCSELIAEoAqCWAiIDBEAgASADNgKklgIgAxArCyACIAs2AiAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiBH/QwAAAAAAAAAAAAAAAAAAAAAIAcb/QsEACABKAKcigIoAgAhByABIAEoApiKAv0ABAAiR/0LBLCOBiAHIAFBsI4GahDiCSEDIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUIANwO4lgIgAUJ/NwOwlgIgAwRAIAFCADcCtLIIIAEgAzYCsLIIIAFBoJYCaiABQbCyCGoQ5wkLIAbAIQMgByABQaCWAmoQ4wkhByABKAKglgIiBgRAIAEgBjYCpJYCIAYQKwsgAiAHNgJQIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwRAIAIgR/0MAAAAAAAAAAAAAAAAAAAAACADQQJxG/0LBDAgASgCnIoCKAIAIQYgASABKAKYigL9AAQAIkf9CwSwjgYgBiABQbCOBmoQ4gkhByAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDoJYCIAFCADcDuJYCIAFCfzcDsJYCIAcEQCABQgA3ArSyCCABIAc2ArCyCCABQaCWAmogAUGwsghqEOcJCyAGIAFBoJYCahDjCSEHIAEoAqCWAiIGBEAgASAGNgKklgIgBhArCyACIAc2AoABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwRwIAIgR/0MAAAAAAAAAAAAAAAAAAAAACADQQRxG/0LBGAgASgCnIoCKAIAIQYgASABKAKYigL9AAQAIkf9CwSwjgYgBiABQbCOBmoQ4gkhByAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDoJYCIAFCADcDuJYCIAFCfzcDsJYCIAcEQCABQgA3ArSyCCABIAc2ArCyCCABQaCWAmogAUGwsghqEOcJCyAGIAFBoJYCahDjCSEHIAEoAqCWAiIGBEAgASAGNgKklgIgBhArCyACIAc2ArABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSgASACIEf9DAAAAAAAAAAAAAAAAAAAAAAgA0EIcRv9CwSQASABKAKcigIoAgAhBiABIAEoApiKAv0ABAAiR/0LBLCOBiAGIAFBsI4GahDiCSEHIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwOglgIgAUIANwO4lgIgAUJ/NwOwlgIgBwRAIAFCADcCtLIIIAEgBzYCsLIIIAFBoJYCaiABQbCyCGoQ5wkLIAYgAUGglgJqEOMJIQcgASgCoJYCIgYEQCABIAY2AqSWAiAGECsLIAIgBzYC4AEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBNABIAIgR/0MAAAAAAAAAAAAAAAAAAAAACADQRBxG/0LBMABIAEoApyKAigCACEGIAEgASgCmIoC/QAEACJH/QsEsI4GIAYgAUGwjgZqEOIJIQcgAf0MAAAAAAAAAAAAAAAAAAAAAP0LA6CWAiABQgA3A7iWAiABQn83A7CWAiAHBEAgAUIANwK0sgggASAHNgKwsgggAUGglgJqIAFBsLIIahDnCQsgBiABQaCWAmoQ4wkhByABKAKglgIiBgRAIAEgBjYCpJYCIAYQKwsgAiAHNgKQAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAIgAiBH/QwAAAAAAAAAAAAAAAAAAAAAIANBIHEb/QsE8AEgASgCnIoCKAIAIQYgASABKAKYigL9AAQAIkf9CwSwjgYgBiABQbCOBmoQ4gkhByAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDoJYCIAFCADcDuJYCIAFCfzcDsJYCIAcEQCABQgA3ArSyCCABIAc2ArCyCCABQaCWAmogAUGwsghqEOcJCyAGIAFBoJYCahDjCSEHIAEoAqCWAiIGBEAgASAGNgKklgIgBhArCyACIAc2AsACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSwAiACIEf9DAAAAAAAAAAAAAAAAAAAAAAgA0HAAHEb/QsEoAIgASgCnIoCKAIAIQYgASABKAKYigL9AAQAIkf9CwSwjgYgBiABQbCOBmoQ4gkhByAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDoJYCIAFCADcDuJYCIAFCfzcDsJYCIAcEQCABQgA3ArSyCCABIAc2ArCyCCABQaCWAmogAUGwsghqEOcJCyAGIAFBoJYCahDjCSEHIAEoAqCWAiIGBEAgASAGNgKklgIgBhArCyACIAc2AvACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTgAiAC/QwAAAAAAAAAAAAAAAAAAAAAIEcgA0EAThv9CwTQAiAEQQFqIgRBEkcNAAsgDEGANmogCEGAijT8CgAAIDBBIyAMIC4Q6AkgDBArIDBBIyABQYCfB2ogNiAuEOkJIAFBsLIIaiABQZiKAmpCABDqCUEAIQJBgO8zEJ4JIgdBAEGA7zP8CwBBgO8zEJ4JIgQgCEGAFWoiFkGA7zP8CgAAIAFBmIoCaiAIQdCQwQBqQaURQSAgBEGABCABQbCyCGoQ6wkgAUGYigJqIAhBwI/BAGpBpRFBICAEQcAAIAFBsLIIahDrCSABQZiKAmogCEGwjsEAakGlEUEgIARBCCABQbCyCGoQ6wkgAUGYigJqIDVBpRFBICAEQQEgAUGwsghqEOsJIAcgBEGAA/wKAAAgB0GAA2ogBEGAA2pBgAP8CgAAIAdBgAZqIARBgAZqQYAD/AoAACAHQYAJaiAEQYAJakGAA/wKAAAgB0GADGogBEGADGpBgAP8CgAAIAdBgA9qIARBgA9qQYAD/AoAACAHQYASaiAEQYASakGAA/wKAAAgB0GAFWogBEGAFWpBgAP8CgAAIAdBgBhqIARBgBhqQYAD/AoAACAHQYAbaiAEQYAbakGAA/wKAAAgB0GAHmogBEGAHmpBgAP8CgAAIAdBgCFqIARBgCFqQYAD/AoAACAHQYAkaiIGIARBgCRqQYAD/AoAACAHQYAnaiAEQYAnakGAA/wKAAAgB0GAKmogBEGAKmpBgAP8CgAAIAdBgC1qIARBgC1qQYAD/AoAACAHQYAwaiAEQYAwakGAA/wKAAAgB0GAM2ogBEGAM2pBgAP8CgAAIAdBgDZqIARBgDZqQYAD/AoAACAHQYA5aiAEQYA5akGAA/wKAAAgB0GAPGogBEGAPGpBgAP8CgAAIAdBgD9qIARBgD9qQYAD/AoAACAHQYDCAGogBEGAwgBqQYAD/AoAACAHQYDFAGogBEGAxQBqQYAD/AoAACAHQYDIAGogBEGAyABqQYAD/AoAACAHQYDLAGogBEGAywBqQYAD/AoAACAHQYDOAGogBEGAzgBqQYAD/AoAACAHQYDRAGogBEGA0QBqQYAD/AoAACAHQYDUAGogBEGA1ABqQYAD/AoAACAHQYDXAGogBEGA1wBqQYAD/AoAACAHQYDaAGogBEGA2gBqQYAD/AoAACAHQYDdAGogBEGA3QBqQYAD/AoAACAEECsgAUGYigJqQQwgB0GU0DEQ7AkgAUGAsghqIAFBmIoCaiAGIAFB8M0BahDtCSABKAKYigL9AAQAIkcgAf0ABICyCBCaCSFJIAEgRyAB/QAEkLIIEJoJ/QsEsJYCIAEgSSBH/VH9CwSglgIgASABKAKgsgg2AsCWAiABQZiKAmogAUGglgJqEO4JIQMgASgCnIoCKAIAIAMQ7wlBgO8zEJ4JIgYgFkGA7zP8CgAAIAFBmIoCaiAIQZCVwQBqQaURQSEgBkGABCABQbCyCGoQ6wkgAUGYigJqIAhBgJTBAGpBpRFBISAGQcAAIAFBsLIIahDrCSABQZiKAmogCEHwksEAakGlEUEhIAZBCCABQbCyCGoQ6wkgAUGYigJqIDRBpRFBISAGQQEgAUGwsghqEOsJA0AgByACQYADbCIDaiADIAZqQYAD/AoAACAHIANBgANqIgtqIAYgC2pBgAP8CgAAIAcgA0GABmoiA2ogAyAGakGAA/wKAAAgAkEDaiICQSFHDQALIAYQKyABQZiKAmpBDSAHQaDQMRDsCSABQaCWAmogAUGYigJqIAFB8M0BaiAHQYAnahDtCSABQaCyCGoiAiABQcCWAmooAgA2AgAgAUGQsghqIgMgAUGwlgJq/QAEAP0LBAAgASAB/QAEoJYCIkn9CwSAsgggASgCmIoC/QAEACJHIEkQmgkhSSABIEcgA/0ABAAQmgn9CwSwlgIgASBJIEf9Uf0LBKCWAiABIAIoAgA2AsCWAiABQZiKAmogAUGglgJqEO4JIQIgASgCnIoCKAIAIAIQ7wlBgO8zEJ4JIgQgFkGA7zP8CgAAIAFBmIoCaiAIQdCZwQBqQaURQeQAIARBgAQgAUGwsghqEOsJIAFBmIoCaiAIQcCYwQBqQaURQeQAIARBwAAgAUGwsghqEOsJIAFBmIoCaiAIQbCXwQBqQaURQeQAIARBCCABQbCyCGoQ6wkgAUGYigJqIDNBpRFB5AAgBEEBIAFBsLIIahDrCUEAIQIDQCAHIAJBgANsIgZqIAQgBmpBgAP8CgAAIAcgAkEBckGAA2wiBmogBCAGakGAA/wKAAAgByACQQJyQYADbCIGaiAEIAZqQYAD/AoAACAHIAJBA3JBgANsIgNqIAMgBGpBgAP8CgAAIAJBBGoiAkHkAEcNAAsgBBArIAFBmIoCakEhIAdBsNAxEOwJIAFBmIoCakEDIAdBgMMBakHR0DEQ7AkgAUGwjgZqIAFB0O0AakGA4AD8CgAAIAFB8JgCaiEEIAFBwJgCaiEGIAFBkJgCaiELIAFB4JcCaiEMIAFBsJcCaiEOIAFBgJcCaiENIAFB0JYCaiESQQAhAgNAIAFBoJYCaiACaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIBJqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgDWoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiAOaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIAxqIgNCADcDACADQgA3AxAgA0IANwMIIANCADcDGCACIAtqIgNCADcDACADQgA3AxAgA0IANwMIIANCADcDGCACIAZqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAIgBGoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAkGAA2oiAkGA4ABHDQALIAdBgOMAaiEMQQAhA0EAIQIDQCABQaCWAmogAkEwbGoiBCAMQR8gAkEDdmtBgANsaiILIAJBBnFBMGxqIgb9AAQA/QsEACAEIAYoAiA2AiAgBCAG/QAEEP0LBBAgAUGglgJqIAJBAXIiBkEwbGoiBCALIAZBB3FBMGxqIgb9AAQA/QsEACAEIAb9AAQQ/QsEECAEIAYoAiA2AiAgAkECaiICQYACRw0ACwNAIAFBmIoCaiADQTBsIgIgAUGglgJqaiABQbCOBmogAmoQ8AkgA0EBaiIDQYACRw0ACyABQbCOBmogAUHQDWpBgOAA/AoAACABQfCYAmohBCABQcCYAmohBiABQZCYAmohCyABQeCXAmohDCABQbCXAmohDiABQYCXAmohDSABQdCWAmohEkEAIQIDQCABQaCWAmogAmoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiASaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIA1qIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgDmoiA/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiAMaiIDQgA3AwAgA0IANwMQIANCADcDCCADQgA3AxggAiALaiIDQgA3AwAgA0IANwMQIANCADcDCCADQgA3AxggAiAGaiID/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACIARqIgP9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAJBgANqIgJBgOAARw0ACyAHQYDMAWohDEEAIQNBACECA0AgAUGglgJqIAJBMGxqIgQgDEEfIAJBA3ZrQYADbGoiCyACQQZxQTBsaiIG/QAEAP0LBAAgBCAGKAIgNgIgIAQgBv0ABBD9CwQQIAFBoJYCaiACQQFyIgZBMGxqIgQgCyAGQQdxQTBsaiIG/QAEAP0LBAAgBCAG/QAEEP0LBBAgBCAGKAIgNgIgIAJBAmoiAkGAAkcNAAsDQCABQZiKAmogA0EwbCICIAFBoJYCamogAUGwjgZqIAJqEPAJIANBAWoiA0GAAkcNAAtBgO8zEJ4JIgMgFkGA7zP8CgAAIAFBmIoCaiA6QaURQSAgA0GABCABQbCyCGoQ6wkgAUGYigJqIDtBpRFBICADQcAAIAFBsLIIahDrCSABQZiKAmogPEGlEUEgIANBCCABQbCyCGoQ6wkgAUGYigJqIDFBpRFBICADQQEgAUGwsghqEOsJIAcgA0GAA/wKAAAgB0GAA2ogA0GAA2pBgAP8CgAAIAdBgAZqIANBgAZqQYAD/AoAACAHQYAJaiADQYAJakGAA/wKAAAgB0GADGogA0GADGpBgAP8CgAAIAdBgA9qIANBgA9qQYAD/AoAACAHQYASaiADQYASakGAA/wKAAAgB0GAFWogA0GAFWpBgAP8CgAAIAdBgBhqIANBgBhqQYAD/AoAACAHQYAbaiADQYAbakGAA/wKAAAgB0GAHmogA0GAHmpBgAP8CgAAIAdBgCFqIANBgCFqQYAD/AoAACAHQYAkaiADQYAkakGAA/wKAAAgB0GAJ2ogA0GAJ2pBgAP8CgAAIAdBgCpqIgQgA0GAKmpBgAP8CgAAIAdBgC1qIANBgC1qQYAD/AoAACAHQYAwaiADQYAwakGAA/wKAAAgB0GAM2ogA0GAM2pBgAP8CgAAIAdBgDZqIANBgDZqQYAD/AoAACAHQYA5aiADQYA5akGAA/wKAAAgB0GAPGogA0GAPGpBgAP8CgAAIAdBgD9qIANBgD9qQYAD/AoAACAHQYDCAGogA0GAwgBqQYAD/AoAACAHQYDFAGogA0GAxQBqQYAD/AoAACAHQYDIAGogA0GAyABqQYAD/AoAACAHQYDLAGogA0GAywBqQYAD/AoAACAHQYDOAGogA0GAzgBqQYAD/AoAACAHQYDRAGogA0GA0QBqQYAD/AoAACAHQYDUAGogA0GA1ABqQYAD/AoAACAHQYDXAGogA0GA1wBqQYAD/AoAACAHQYDaAGogA0GA2gBqQYAD/AoAACAHQYDdAGogA0GA3QBqQYAD/AoAACADECsgAUGYigJqQQ0gB0Hg0DEQ7AkgAUGYigJqQRIgBEHu0DEQ7AkgCCgCxJ9BBEAgB0GABmohCyABQaDzAmohESABQaDwAmohISABQaDtAmohFyABQaDqAmohEyABQaDnAmohIiABQaDkAmohJyABQaDhAmohECABQaDeAmohICABQaDbAmohHyABQaDYAmohBSABQaDVAmohGSABQaDSAmohHSABQaDPAmohHiABQaDMAmohGiABQaDJAmohIyABQaDGAmohFCABQaDDAmohJCABQaDAAmohJSABQaC9AmohKCABQaC6AmohJiABQaC3AmohKyABQaC0AmohPSABQaCxAmohLiABQaCuAmohMSABQaCrAmohMyABQaCoAmohNCABQaClAmohNSABQaCiAmohNiABQaCfAmohOiABQaCcAmohOyABQaCZAmohPCABQYCRBmohDCABQdCQBmohDiABQaCQBmohDSABQfCPBmohEiABQcCPBmohCiABQZCPBmohFSABQeCOBmohD0EAIRgDQEEAIQMDQCABQaCWAmogA2oiAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBDAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBGAgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBJABIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTAASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBKACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTQAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBKAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTwBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBMAEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSQBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AMgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBLADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAJBQGv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwRwIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSgASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBIACIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSwAiAC/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AIgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBJADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwSwBSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAUgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBOAFIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTQBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LBPADIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwTAAyADQYAGaiIDQYDAAUcNAAsgOSgCACECQYDvMxCeCSIEIBZBgO8z/AoAACABQZiKAmogAiAYQcAEbGoiAkGwA2pBpRFBIiAEQYAEIAFBsLIIahDrCSABQZiKAmogAkGgAmpBpRFBIiAEQcAAIAFBsLIIahDrCSABQZiKAmogAkGQAWpBpRFBIiAEQQggAUGwsghqEOsJIAFBmIoCaiACQaURQSIgBEEBIAFBsLIIahDrCUEAIQIDQCAHIAJBgANsIgZqIAQgBmpBgAP8CgAAIAcgAkEBckGAA2wiBmogBCAGakGAA/wKAAAgAkEgRwRAIAcgAkECckGAA2wiBmogBCAGakGAA/wKAAAgByACQQNyQYADbCIDaiADIARqQYAD/AoAACACQQRqIQIMAQsLIAQQKyABQZiKAmpBAiAHQYDRMRDsCUEAIQRBACECA0AgAUGwjgZqIAJqIgb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAb9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgD2oiBv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgBv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAiAVaiIG/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAG/QwAAAAAAAAAAAAAAAAAAAAA/QsEECACIApqIgb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAb9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAIgEmoiBkIANwMAIAZCADcDECAGQgA3AwggBkIANwMYIAIgDWoiBkIANwMAIAZCADcDECAGQgA3AwggBkIANwMYIAIgDmoiBv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgBv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAiAMaiIG/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAG/QwAAAAAAAAAAAAAAAAAAAAA/QsEACACQYADaiICQYDgAEcNAAsDQCABQbCOBmogBEEwbGoiAiALQf4BIARrQQN2QYADbGogBEEGcUEwbGoiBv0ABAD9CwQAIAIgBigCIDYCICACIAb9AAQQ/QsEECABQbCOBmogBEEBciICQTBsaiIGIAtB/wEgAmtBA3ZBgANsaiACQQdxQTBsaiIC/QAEAP0LBAAgBiAC/QAEEP0LBBAgBiACKAIgNgIgIARBAmoiBEGAAkcNAAsgAUGArwhqIAFBmIoCakICEOoJIDBBAiAYQQxsIgQgCCgCjI1BaigCACAIKAKAjUEgBGooAgAiAhDoCSAwQQIgAUGwjgZqIAFBgK8IaiACEOkJIAgoAoyNQSAEaigCACEJIAgoAqyfQSEGQYCAAxCeCSICIAlBgIAD/AoAACABQZiKAmogBiAYQYAJbCIJaiIGQbADakGAAUEgIAJBgAQgAUGwsghqEOsJIAFBmIoCaiAGQaACakGAAUEgIAJBwAAgAUGwsghqEOsJIAFBmIoCaiAGQZABakGAAUEgIAJBCCABQbCyCGoQ6wkgAUGYigJqIAZBgAFBICACQQEgAUGwsghqEOsJIAFBoJYCaiACQYAD/AoAACA8IAJBgANqQYAD/AoAACA7IAJBgAZqQYAD/AoAACA6IAJBgAlqQYAD/AoAACA2IAJBgAxqQYAD/AoAACA1IAJBgA9qQYAD/AoAACA0IAJBgBJqQYAD/AoAACAzIAJBgBVqQYAD/AoAACAxIAJBgBhqQYAD/AoAACAuIAJBgBtqQYAD/AoAACA9IAJBgB5qQYAD/AoAACArIAJBgCFqQYAD/AoAACAmIAJBgCRqQYAD/AoAACAoIAJBgCdqQYAD/AoAACAlIAJBgCpqQYAD/AoAACAkIAJBgC1qQYAD/AoAACAUIAJBgDBqQYAD/AoAACAjIAJBgDNqQYAD/AoAACAaIAJBgDZqQYAD/AoAACAeIAJBgDlqQYAD/AoAACAdIAJBgDxqQYAD/AoAACAZIAJBgD9qQYAD/AoAACAFIAJBgMIAakGAA/wKAAAgHyACQYDFAGpBgAP8CgAAICAgAkGAyABqQYAD/AoAACAQIAJBgMsAakGAA/wKAAAgJyACQYDOAGpBgAP8CgAAICIgAkGA0QBqQYAD/AoAACATIAJBgNQAakGAA/wKAAAgFyACQYDXAGpBgAP8CgAAICEgAkGA2gBqQYAD/AoAACARIAJBgN0AakGAA/wKAAAgAhArIAFB/IkCakEgIAgoAqyfQSAJakHABGogAUGglgJqICogGEGAoAJsaiIcEPEJIAgoAoyNQSAEaigCACEGIAgoArifQSECQYCAAxCeCSIEIAZBgIAD/AoAACABQZiKAmogAiAJaiICQbADakGAAUHAACAEQYAEIAFBsLIIahDrCSABQZiKAmogAkGgAmpBgAFBwAAgBEHAACABQbCyCGoQ6wkgAUGYigJqIAJBkAFqQYABQcAAIARBCCABQbCyCGoQ6wkgAUGYigJqIAJBgAFBwAAgBEEBIAFBsLIIahDrCUEAIQIDQCACQYADbCIGIAFBoJYCamogBCAGakGAA/wKAAAgAkEBckGAA2wiBiABQaCWAmpqIAQgBmpBgAP8CgAAIAJBAnJBgANsIgYgAUGglgJqaiAEIAZqQYAD/AoAACACQQNyQYADbCIGIAFBoJYCamogBCAGakGAA/wKAAAgAkEEaiICQcAARw0ACyAEECsgAUH8iQJqQcAAIAgoArifQSAJakHABGogAUGglgJqIBxBgOAAahDxCSAYQQFqIhggCCgCxJ9BSQ0ACwsgBxArIAFBmIoCaiABQdDNAWogMiABQYCfB2ogASgCsA0gASgCtA0Q8gkgAUGYigJqIAFB0M0BakEIciAyIAFB0O0AaiABKAK4DSABKAK8DRDyCSABQZiKAmogAUHgzQFqIDIgAUHQDWogASgCwA0gASgCxA0Q8glBACEXIAEoAvCKAiIDIAEoAvSKAiIORyIGRQ0CIAMhAgNAAkAgAi0AHUEBRgRAIBcgAigCDEEBaiIEIAQgF0kbIRcMAQsgAi0AH0EBRw0AAkAgAigCBCACKAIAIgRrQQxHDQAgBCgCBA0AIBcgAigCDCIEIAQgF0kbIRcMAQsgFyACKAIMQQFqIgQgBCAXSRshFwsgAkEgaiICIA5HDQALIAEgFzYCuIoCIAEoArSKAiEHIAMhAgNAAkAgAi0AHQ0AIAItAB9BAUcNACACKAIMIBdHDQAgAigCBCACKAIAIgRrQQxHDQAgBCgCBA0AIAJBADoAHyADIAQoAghBBXRqIgRBfzYCFCAEQQE6AB0gASAHQQFqIgc2ArSKAgsgAkEgaiICIA5HDQALQQAhEiABQQA2AsCKAiAGRQ0DIBdBAWshHSAOIANrQQV1IQ0DQAJAIAMgDUEBayINQQV0aiICLQAeQQFHDQAgAkEBOgAcIAJBASACKAIYIgQgBEEBTRs2AhggAigCDEF/Rw0AIANBAToAHAsCQCACLQAdQQFHDQAgAkEBOgAcIAIgFyACKAIYIgQgBCAXSRs2AhggFyACKAIMQQFqTQ0AIANBAToAHCADIB0gAygCGCIEIAQgHUkbNgIYCwJAAkACQCACLQAfQQFGBEAgAkEBOgAcIAIgAigCDEEBaiIEIAIoAhgiBiAEIAZLGzYCGAwBCyACLQAcQQFHDQELIAIoAgAiBCACKAIEIgxGDQEgAigCDCICQQFrIQcDQCADIAQoAgRBBXRqIgZBAToAHCAGIAIgBigCGCILIAIgC0sbNgIYIAYoAgxBAWogAkkEQCADQQE6ABwgAyAHIAMoAhgiBiAGIAdJGzYCGAsgAyAEKAIIQQV0aiIGQQE6ABwgBiACIAYoAhgiCyACIAtLGzYCGCAGKAIMQQFqIAJJBEAgA0EBOgAcIAMgByADKAIYIgYgBiAHSRs2AhgLIARBDGoiBCAMRw0ACwwBCyABIBJBAWoiEjYCwIoCCyANDQALDAQLEKAJAAsQoAkACyABQQA2AsCKAiABQQA2AriKAgsgF0EBayEdCyABKAKkigIhJ0EAISJBzAAQogkiEEEAQcwA/AsAIBBBATYCCCAQIB02AhACQAJAIBdFBEBBACERDAELIBdB1qrVqgFPDQEgF0EMbCICEKIJIREgAkEMayICIAJBDHBrQQxqIgIEQCARQQAgAvwLAAsgAiARaiEiCyABKALwigIiAiAORgRAQQAhIQwGCyAOIAJrQQV1IgNB1qrVqgFPDQNBACEhIANBDGwiAxCiCSEOIANBDGsiAyADQQxwa0EMaiIDBEAgDkEAIAP8CwALIANBDG0hDSADIA5qIR8gIiARa0EMbSEWQQAhIANAAkAgAiAgQQV0aiILLQAcQQFHDQAgCy0AHkUEQCALKAIAIAsoAgRGDQELIAsoAgwiGSAWSSIeRQ0WIBEgGUEMbGoiBSgCBCAFKAIAa0EUbSEbIA0gIE0NBCAOICBBDGxqIhMgGxDUCQJAAkACQCALKAIAIgIgCygCBCIcRgRAQQAhB0EAIQMMAQsgGUEBayEMQQAhB0EAIQNBACESAkADQCACKAIAIhUgASgC1IoCIAEoAtCKAiIPa0EEdUkEQCACKAIEIgQgASgC9IoCIAEoAvCKAiIGa0EFdSIKTw0CIAQgDU8NCiAMIAYgBEEFdGooAgxrIhggDiAEQQxsaiIEKAIEIAQoAgAiCWtBAnVPDQkgAigCCCIEIApPDQIgBCANTw0KIAwgBiAEQQV0aigCDGsiBiAOIARBDGxqIgQoAgQgBCgCACIEa0ECdU8NCSAPIBVBBHRq/QAEACFHIAkgGEECdGooAgAhCiAEIAZBAnRqKAIAIQQCQCADIBJJBEAgAyAENgIUIAMgCjYCECADIEf9CwQAIANBIGohAwwBCyADIAdrIgZBBXUiD0EBaiIDQYCAgMAATw0FQf///z8gEiAHayISQQR1IhUgAyADIBVJGyASQeD///8HTxsiEgR/IBJBgICAwABPDR0gEkEFdBCeCQVBAAsiFSAGaiIDIAQ2AhQgAyAKNgIQIAMgR/0LBAAgAyAPQQV0ayEEIAYEQCAEIAcgBvwKAAALIANBIGohAyAVIBJBBXRqIRIgBwRAIAcQKwsgBCEHCyAcIAJBDGoiAkcNAQwDCwsQoAkACxCgCQALIB5FDRgCQAJ/AkAgGQ0AIAstAB5BAXFFDQBBEAwBC0F/IQIgGUEBaiAXRw0BIAstAB1BAXFFDQFBFAsgC2ooAgAhAgtBACEGIAFBADYCsJYCIAFCADcCqJYCIAFBADoApJYCIAEgAjYCoJYCQQAhBCADIAdHBEAgAyAHayICQQBIDQEgASACEJ4JIgQ2AqyWAiABIAQ2AqiWAiABIAIgBGoiBjYCsJYCIAJBCGsiAgRAIAQgByAC/AoAAAsgASAGNgKslgILAkAgBSgCBCICIAUoAghJBEAgAiABKAKglgI2AgAgAiABQaSWAmotAAA6AAQgAiAGNgIQIAIgBjYCDCACIAQ2AgggBSACQRRqNgIEDAELIAUgAUGglgJqENYJIQMgASgCqJYCIQIgBSADNgIEIAJFDQAgAhArCyAHBEAgBxArCyALKAIMIgZBAWoiAiALKAIYTw0BA0AgBiEHIBshBCACIgYgFk8NGSATIBEgAkEMbGoiAygCBCADKAIAa0EUbSIbENQJICf9AAQAIUdBIBCeCSICIAQ2AhQgAkEANgIQIAIgR/0LBAACQAJAIAYNACALLQAeQQFxRQ0AIAsoAhAhBAwBC0F/IQQgB0ECaiAXRw0AIAstAB1BAXFFDQAgCygCFCEECyABQQA2ArCWAiABQgA3AqiWAiABQQE6AKSWAiABIAQ2AqCWAiABQSAQngkiBDYCrJYCIAEgBDYCqJYCIAEgBEEgaiIMNgKwlgIgBCACKQMQNwMQIAQgAv0ABAD9CwQAIAEgDDYCrJYCAkAgAygCBCIHIAMoAghJBEAgByABKAKglgI2AgAgByABQaSWAmotAAA6AAQgByAMNgIQIAcgDDYCDCAHIAQ2AgggAyAHQRRqNgIEDAELIAMgAUGglgJqENYJIQcgASgCqJYCIQQgAyAHNgIEIARFDQAgBBArCyACECsgIUEBaiEhIAZBAWoiAiALKAIYSQ0ACwwBCxCgCQALIAEoAvCKAiECCyAgQQFqIiAgASgC9IoCIAJrQQV1SQ0ACwwECxCgCQALEKAJAAsQoAkACxCgCQALIA4gH0cEQANAIB9BDGsiAigCACIDBEAgH0EIayADNgIAIAMQKwsgAiEfIAIgDkcNAAsLIA4QKwsgESAiRg0OIBEoAgAiAiARKAIEIgNHBEADQCACKAIAQX9GDQ0gAkEUaiICIANHDQALCyAiIBFrQQxtIiBBAk8EQEEBIScDQAJ/IBEgJ0EMbGoiEygCACIYIBMoAgQiFkYEQEEAIQlBACENIBgMAQsgE0EMayEKIBNBCGshFUEAIQlBACENQQAhHEEAIRsCQAJAAkADQAJAAkAgGCgCDCISIBgoAggiAkYEQEEAIQRBACELDAELIBIgAmsiAkEASA0BIAIQngkiBCACaiELIBgoAgwhEiAYKAIIIQILIAQhAyACIBJHBEADQCACKAIQIgwgFSgCACAKKAIAIgdrQRRtIgZPDRQgAigCFCIOIAZPDRQgByAMQRRsaigCACIGIAcgDkEUbGooAgAiByAGIAdLGyEMIAcgBiAGIAdLGyEGIAL9AAQAIUcCQCADIAtJBEAgAyAMNgIUIAMgBjYCECADIEf9CwQAIANBIGohAwwBCyADIARrIgdBBXUiD0EBaiIDQYCAgMAATw0DQf///z8gCyAEayILQQR1Ig4gAyADIA5JGyALQeD///8HTxsiCwR/IAtBgICAwABPDRkgC0EFdBCeCQVBAAsiDiAHaiIDIAw2AhQgAyAGNgIQIAMgR/0LBAAgAyAPQQV0ayEGIAcEQCAGIAQgB/wKAAALIANBIGohAyAOIAtBBXRqIQsgBARAIAQQKwsgBiEECyACQSBqIgIgEkcNAAsLIAQgA0EAQT4gAyAEayIMQQV1IgtnQQF0ayADIARGIg4bQQEQ8wkgC0ECTwRAIAQoAhAhA0EAIQJBASEGA0AgAiEHAkAgAyAEIAYiAkEFdGoiBigCECIDRw0AIAQgB0EFdGoiBygCFCAGKAIURw0AIAcpAwAgBikDAFINACAHKQMIIAYpAwhRDQULIAJBAWoiBiALRw0ACwsgGC0ABCEHIBgoAgAhCwJ/IA4EQEEAIQNBAAwBCyAMQQBIDQEgDBCeCSEDIAxBCGsiAgRAIAMgBCAC/AoAAAsgAyAMagshAgJAIA0gHEkEQCANIAI2AhQgDSACNgIQIA0gAzYCDCANIAc6AAggDSAbNgIEIA0gCzYCACANQRhqIQ0MAQsgDSAJayIMQRhtQQFqIgZBq9Wq1QBPDQRBqtWq1QAgHCAJa0EYbSIOQQF0IhIgBiAGIBJJGyAOQdWq1SpPGyIGQavVqtUATw0WIAZBGGwiDhCiCSISIAxqIgYgAjYCFCAGIAI2AhAgBiADNgIMIAYgBzoACCAGIBs2AgQgBiALNgIAIAYgDEFobUEYbGoiByEDIA0gCSICRwRAA0AgAyACKQIANwIAIAMgAi0ACDoACCADIAIoAgw2AgwgAyACKAIQNgIQIAMgAigCFDYCFCACQQA2AhQgAkIANwIMIANBGGohAyACQRhqIgIgDUcNAAsgCSECA0AgAigCDCIDBEAgAiADNgIQIAMQKwsgAkEYaiICIA1HDQALCyAOIBJqIRwgBkEYaiENIAkEQCAJECsLIAchCQsgBARAIAQQKwsgG0EBaiEbIBYgGEEUaiIYRw0BDAQLCxCgCQALIAFB4/sqNgLQBUHkAEH0hyogAUHQBWoQmwlBkJY0KAIAKAIAIQIgAUHj+yo2AsAFIAJBkYwqIAFBwAVqEGwACxCgCQALIBMoAgAhGCATKAIECyECAkACQAJAAkAgDSAJayIDQRhtIgQgAiAYa0EUbUYEQCAJIA1BAEE+IARnQQF0ayAJIA1GIgobQQEQ9AkgA0EYbSISQQJPBEAgCS0ACCEOQQAhC0EBIQIDQCALIQMCQCAOQf8BcSAJIAIiC0EYbGoiAi0ACCIORw0AIAkgA0EYbGoiAygCECIEIAMoAgwiBmsiAyACKAIQIAIoAgwiB2tHDQAgBCAGRg0EQQEgA0EFdSICIAJBAU0bIQxBACEEA0AgBiAEQQV0IgNqIgIoAhAgAyAHaiIDKAIQRw0BIAIoAhQgAygCFEcNASACKQMAIAMpAwBSDQEgAikDCCADKQMIUg0BIAwgBEEBaiIERw0ACwwECyALQQFqIgIgEkcNAAsLIAoNAiATKAIEIBMoAgAiC2tBFG0hB0EAIQMgCSECA0AgAigCBCIEIAdPDRICQCALIARBFGxqIgYoAgAiBEF/RwRAIAMgBEYNASABQY+wKzYC8ARB5ABB9IcqIAFB8ARqEJsJQZCWNCgCACgCACECIAFBj7ArNgLgBCACQZGMKiABQeAEahBsAAsgBiADNgIACyADQQFqIQMgAkEYaiICIA1HDQALIAlFDQQgCg0DA0AgDUEMaygCACICBEAgDUEIayACNgIAIAIQKwsgDUEYayINIAlHDQALDAMLIAFB4/8rNgKwBUHkAEH0hyogAUGwBWoQmwlBkJY0KAIAKAIAIQIgAUHj/ys2AqAFIAJBkYwqIAFBoAVqEGwACyABQfb7KjYCkAVB5ABB9IcqIAFBkAVqEJsJQZCWNCgCACgCACECIAFB9vsqNgKABSACQZGMKiABQYAFahBsAAsgCUUNAQsgCRArCyAnQQFqIicgIEcNAAsLIBcgIEcNCSAXIB1NDQ4gECARIB1BDGxqIgIoAgQgAigCAGtBFG0iEzYCAEEAISdBACECIBNBAk8EQEEBIQMDQCACQQFqIQIgA0EBdCIDIBNJDQALCyAQIAI2AgQgF0ECTwRAIBBBIGohICABQaSWAmohFSAXIRYDQCABIBEgFkEMbGoiAkEUayIHKAIAIAJBGGsiCygCAGtBFG0iGzYCsI4GQQEhA0EAIQIgG0ECTwRAA0AgAkEBaiECIANBAXQiAyAbSQ0ACwsgASACNgK0jgYgFkEBayIWIBdPDRBBACEcQQAhDyARIBZBDGxqIgIoAgAiDSACKAIEIhhGIgZFBEAgGCANIgJrQRRrIgNBzwBLBEAgA0EUbkEBaiICIAJBA3EiAkEEIAIbayEEQQAhA/0MAAAAAAAAAAAAAAAAAAAAACFHA0AgDSADQRRsaiICQcgAaiACQTRqIAJBIGogAv1cAgz9VgIAAf1WAgAC/VYCAAMgAkHEAGogAkEwaiACQRxqIAL9XAII/VYCAAH9VgIAAv1WAgAD/bEBQQX9rAEgR/2uASFHIANBBGoiAyAERw0ACyBHIEcgR/0NCAkKCwwNDg8AAQIDAAECA/2uASJHIEcgR/0NBAUGBwABAgMAAQIDAAECA/2uAf0bACEPIA0gBEEUbGohAgsDQCACKAIMIAIoAghrQQV1IA9qIQ8gAkEUaiICIBhHDQALC0EQEKIJIglBADYCDCAJQgA3AgQgCSAPNgIAQQAhCiAPBEAgD0GAgIDAAE8NCyAJIA9BBXQiAhCeCSIKNgIEIAkgAiAKaiIcNgIMIAIEQCAKQQAgAvwLAAsgCSAcNgIICyAGRQRAIAcoAgAgCygCACIHa0EUbSEGQQAhBANAIA0oAggiAiANKAIMIhJHBEADQCACKAIQIgMgBk8NECACKAIUIgsgBk8NECANKAIAIQwgByADQRRsaigCACEOIAcgC0EUbGooAgAhCyAVIAL9AAIA/QsCACAKIARBBXRqIgMgCzYCCCADIA42AgQgAyAMNgIAIAMgAf0AAqCWAv0LAgwgAyABQbCWAmooAgA2AhwgBEEBaiEEIAJBIGoiAiASRw0ACwsgDUEUaiINIBhHDQALCwJAIAkoAgAiAkUNAEEAIQYgAkEBRwRAIAJBAXEhCyACQX5xIQcDQCAKIAZBBXRqIgIgAigCBCIDIAIoAggiBCADIARLGzYCCCACIAQgAyADIARLGzYCBCACIAIoAigiAyACKAIkIgQgAyAESRs2AiQgAiAEIAMgAyAESRs2AiggBkECaiIGIAdHDQALIAtFDQELIAogBkEFdGoiAiACKAIEIgMgAigCCCIEIAMgBEsbNgIIIAIgBCADIAMgBEsbNgIEC0EBIQQgCiAcQT4gHCAKa0EFdWdBAXRrQQAgCiAcRxtBARD1CUEBIQYgCSgCACIHQQJPBEADQAJAAkAgCSgCBCIDIARBBXRqIgIoAgAgAyAGQQV0aiIDQSBrKAIARw0AIAIoAgQgA0EcaygCAEcNACACKAIIIANBGGsoAgBHDQAgA0EQayIDIAL9AAQQIAP9AAQA/VH9CwQAIAkoAgAhBwwBCyADIAL9AAQA/QsEACADIAL9AAQQ/QsEECAGQQFqIQYLIARBAWoiBCAHSQ0ACwsgCSAGNgIAIAEgCTYCuI4GAkAgECgCJCICIBAoAihJBEAgASkDsI4GIVUgAiAJNgIIIAIgVTcCACAQIAJBDGo2AiQMAQsgICABQbCOBmoQ2wkhAyABKAK4jgYhAiAQIAM2AiQgAkUNACACKAIEIgMEQCACIAM2AgggAxArCyACECsLIBMgG2ohEyAPICdqIScgFkEBSw0ACwsDQCAiQQxrIgYoAgAiBARAIAQiAyAiQQhrIgcoAgAiAkcEQANAIAJBDGsoAgAiAwRAIAJBCGsgAzYCACADECsLIAQgAkEUayICRw0ACyAGKAIAIQMLIAcgBDYCACADECsLIAYhIiAGIBFHDQALIBEQKyABICE2AsyKAiABICc2AsiKAiABIBM2AsSKAiAQIAEoAqiKAjYCFCAQIAEoAqyKAjYCGCAQIAEoArCKAjYCHCAQQSxqIhEgEBD2CSABQa7jKjYCsARB5ABBvYgqIAFBsARqEJsJIAEgASgCzIoCIgI2ApQEIAEgASgCyIoCNgKYBCABIAEpAryKAjcCnAQgASABKALEigIiAyACazYCkAQgASABKAK4igI2AoAEIAEgAzYChAQgASABKAKoigI2AogEIAEgASgCtIoCNgKMBEHkAEGGwSkgAUGABGoQmwkgASAsNgKslgIgAUEANgKolgIgAUIANwKglgIgAf0MAAAAAAAAAAAAAAAAAAAAAP0LArCWAiABQYCAgPwDNgLElgIgASAsNgLAlgIgAUGwlgJqIRwCQEHoBxDdCSICIAEoArSWAiIDTQRAIAIgA08NASABKAK8lgKzIAEqAsSWApWN/AEhBCACAn8CQCADQQNJDQAgA2lBAUsNACAEQQFBICAEQQFrZ2t0IARBAkkbDAELIAQQ3QkLIgQgAiAESxsiAiADTw0BCyAcIAIQ3gkLAkAgASgCqI4GIgIgASgCrI4GIgZJBEAgAkEBOgAAIAJBAWohAgwBCyACIAEoAqSOBiIDayIEQQFqIgJBAEgNDSAEQf////8HIAYgA2siBkEBdCIHIAIgAiAHSRsgBkH/////A08bIgYEfyAGEKIJBUEACyICaiIHQQE6AAAgBARAIAIgAyAE/AoAAAsgASACIAZqNgKsjgYgASACNgKkjgYgB0EBaiECIANFDQAgAxArCyABIAI2AqiOBiABQQA6ALKOBiABQQQ7ALCOBiABQaSOBmogAiABQbCOBmogAUGzjgZqIgNBAxCnCSAQKAIAIgJB////B08NByABIAI6ALCOBiABIAJBEHY6ALKOBiABIAJBCHY6ALGOBiABQaSOBmogASgCqI4GIAFBsI4GaiADQQMQpwkgECgCCCICQf///wdPDQYgASACOgCwjgYgASACQRB2OgCyjgYgASACQQh2OgCxjgYgAUGkjgZqIAEoAqiOBiABQbCOBmogAUGzjgZqIgNBAxCnCSAQKAIYIgJB////B08NBSABIAI6ALCOBiABIAJBEHY6ALKOBiABIAJBCHY6ALGOBiABQaSOBmogASgCqI4GIAFBsI4GaiADQQMQpwkgECgCHCICQf///wdPDQQgASACOgCwjgYgASACQRB2OgCyjgYgASACQQh2OgCxjgYgAUGkjgZqIAEoAqiOBiABQbCOBmogAUGzjgZqIgNBAxCnCSAQKAIUIgJB////B08NAyABIAI6ALCOBiABIAJBEHY6ALKOBiABIAJBCHY6ALGOBiABQaSOBmogASgCqI4GIAFBsI4GaiADQQMQpwkgECgCJCAQKAIga0EMbSICQf///wdPDQIgASACOgCwjgYgASACQRB2OgCyjgYgASACQQh2OgCxjgYgAUGkjgZqIAEoAqiOBiABQbCOBmogAUGzjgZqIglBAxCnCSABQYCAgAgQogkiAjYCtLIIIAEgAjYCsLIIIAEgAkGAgIAIajYCuLIIIBAoAiAiDCAQKAIkIhZHBEAgAUG4lgJqIRsDQAJAIAwoAgQiAkH///8HSQRAIAEgAjoAsI4GIAEgAkEQdjoAso4GIAEgAkEIdjoAsY4GIAFBsLIIaiABKAK0sgggAUGwjgZqIAlBAxCnCSAMKAIAIgJB////B0kEQCABIAI6ALCOBiABIAJBEHY6ALKOBiABIAJBCHY6ALGOBiABQbCyCGogASgCtLIIIAFBsI4GaiAJQQMQpwkgDCgCCCgCACICQf///wdJBEAgASACOgCwjgYgASACQRB2OgCyjgYgASACQQh2OgCxjgYgAUGwsghqIAEoArSyCCABQbCOBmogCUEDEKcJQQAhCkEAIRVBACEPQQAhDSAMKAIIIgIoAgBFDQMDQCABQbCyCGogAigCBCANQQV0IgJqKAIAIAoQ3wkgDCgCCCgCBCACaiIDKAIAIQogAUGwsghqIAMoAgQgFRDfCSAMKAIIKAIEIAJqIgMoAgQhFSABQbCyCGogAygCCCAPEN8JIAwoAggoAgQgAmoiDigCCCEPAkACQAJAAkAgASgCtJYCIgZFDQAgASgCsJYCIQIgAgJ/IA79AAQQIkf9FgStQv8BgyJVQiWGIFVCJIaFIFVCJ4aFIFVCKIYgR/0WA61C/wGDIlVCHYYgVUIchoUgVUIfhoUgVUIghiBH/RYCrUL/AYMiVUIVhiBVQhSGhSBVQheGhSBVQhiGIEf9FgGtQv8BgyJVQg2GIFVCDIaFIFVCD4aFIFVCEIYgR/0WAEEBc61C/wGDIlVCBYYgVUIEhoUgVUIHhoUgVUIIhoWEhYSFhIWEhSJYQgiIIEf9FgithUI4hiJVQgOIIFVCBIiFIFVCAYiFIFUgWEIQiISFIlggR/0WCa2FQjiGIlVCA4ggVUIEiIUgVUIBiIUgVSBYQgiIhIUiWCBH/RYKrYVCOIYiVUIDiCBVQgSIhSBVQgGIhSBVIFhCCIiEhSJYIEf9FguthUI4hiJVQgOIIFVCBIiFIFVCAYiFIFUgWEIIiISFIlggR/0WDK1C/wGDhSJVQh2GIFVCHIaFIFVCH4aFIFhCIIiFpyIEIAZBAWtxIAZpQQFLIgtFDQAaIAQgBCAGSQ0AGiAEIAZwCyIHQQJ0aigCACICRQ0AIAIoAgAiAkUNACBH/R0BIVggR/0dACFVIAZBAWshEgNAAkAgBCACKAIEIgNHBEACQCALRQRAIAMgEnEhAwwBCyADIAZJDQAgAyAGcCEDCyADIAdGDQEMAwsgAikDECBVUg0AIAIpAxggWFENAwsgAigCACICDQALCyAOQRBqIQ4gASgCpJYCIgIgASgCoJYCIgNrIgRBBHUhBwJAIAEoAqiWAiIGIAJLBEAgAiAO/QAEAP0LBAAgAkEQaiECDAELIAdBAWoiAkGAgICAAU8NAkH/////ACAGIANrIgZBA3UiCyACIAIgC0kbIAZB8P///wdPGyICBH8gAkGAgICAAU8NGSACQQR0EJ4JBUEACyIGIARqIgsgDv0ABAD9CwQAIAsgB0EEdGshEiAEBEAgEiADIAT8CgAACyABIAYgAkEEdGo2AqiWAiABIAtBEGoiAjYCpJYCIAEgEjYCoJYCIANFDQAgAxArCyABIAI2AqSWAiAO/QAEACJH/RYErUL/AYMiVUIlhiBVQiSGhSBVQieGhSBVQiiGIEf9FgOtQv8BgyJVQh2GIFVCHIaFIFVCH4aFIFVCIIYgR/0WAq1C/wGDIlVCFYYgVUIUhoUgVUIXhoUgVUIYhiBH/RYBrUL/AYMiVUINhiBVQgyGhSBVQg+GhSBVQhCGIEf9FgBBAXOtQv8BgyJVQgWGIFVCBIaFIFVCB4aFIFVCCIaFhIWEhYSFhIUiWEIIiCBH/RYIrYVCOIYiVUIDiCBVQgSIhSBVQgGIhSBVIFhCEIiEhSJYIEf9FgmthUI4hiJVQgOIIFVCBIiFIFVCAYiFIFUgWEIIiISFIlggR/0WCq2FQjiGIlVCA4ggVUIEiIUgVUIBiIUgVSBYQgiIhIUiWCBH/RYLrYVCOIYiVUIDiCBVQgSIhSBVQgGIhSBVIFhCCIiEhSJYIEf9FgytQv8Bg4UiVUIdhiBVQhyGhSBVQh+GhSBYQiCIhachBgJAAkAgASgCtJYCIgNFDQAgASgCsJYCAn8gA0EBayAGcSADaUEBSyISRQ0AGiAGIAMgBksNABogBiADcAsiC0ECdGooAgAiAkUNACACKAIAIgJFDQAgR/0dASFYIEf9HQAhVSADQQFrIRgDQAJAIAYgAigCBCIERwRAAkAgEkUEQCAEIBhxIQQMAQsgAyAESw0AIAQgA3AhBAsgBCALRg0BDAMLIAIpAxAgVVINACACKQMYIFhRDQMLIAIoAgAiAg0ACwtBMBCeCSICIAY2AgQgAkEANgIAIAIgDv0ABAD9CwQQIAJBADYCICABKgLElgIhXCABKAK8lgJBAWqzIV0CQCADBEAgXCADs5QgXV1FDQELQQIhBAJAIAMgA0EBa3FBAEcgA0EDSXIgA0EBdHIiCyBdIFyVjfwBIg4gCyAOSxsiC0EBRg0AIAsgC0EBa3FFBEAgCyEEDAELIAsQ3QkhBCABKAK0lgIhAwsCQCADIARPBEAgAyAETQ0BIAEoAryWArMgASoCxJYClY38ASELIAQCfwJAIANBA0kNACADaUEBSw0AIAtBAUEgIAtBAWtna3QgC0ECSRsMAQsgCxDdCQsiCyAEIAtLGyIEIANPDQELIBwgBBDeCQsgASgCtJYCIgMgA0EBayIEcUUEQCAEIAZxIQsMAQsgAyAGSwRAIAYhCwwBCyAGIANwIQsLAkAgASgCsJYCIg4gC0ECdGoiBigCACIERQRAIAIgASgCuJYCNgIAIAEgAjYCuJYCIAYgGzYCACACKAIAIgRFDQEgBCgCBCEEAkAgAyADQQFrIgZxRQRAIAQgBnEhBAwBCyADIARLDQAgBCADcCEECyAOIARBAnRqIAI2AgAMAQsgAiAEKAIANgIAIAQgAjYCAAsgASABKAK8lgJBAWo2AryWAgsgAiAHNgIgDAILIAIoAiAhBwwBCxCgCQALIAdB////B0kEQCABIAc6ALCOBiABIAdBEHY6ALKOBiABIAdBCHY6ALGOBiABQbCyCGogASgCtLIIIAFBsI4GaiAJQQMQpwkgDUEBaiINIAwoAggiAigCAE8NBQwBCwsgAUGVrio2AtABQeQAQfSHKiABQdABahCbCUGQljQoAgAoAgAhAiABQZWuKjYCwAEgAkGRjCogAUHAAWoQbAALIAFBla4qNgLwAUHkAEH0hyogAUHwAWoQmwlBkJY0KAIAKAIAIQIgAUGVrio2AuABIAJBkYwqIAFB4AFqEGwACyABQZWuKjYCkAJB5ABB9IcqIAFBkAJqEJsJQZCWNCgCACgCACECIAFBla4qNgKAAiACQZGMKiABQYACahBsAAsgAUGVrio2ArACQeQAQfSHKiABQbACahCbCUGQljQoAgAoAgAhAiABQZWuKjYCoAIgAkGRjCogAUGgAmoQbAALIAxBDGoiDCAWRw0ACwsgASgCpJYCIAEoAqCWAmtBBHUiAkH///8HTw0BIAEgAjoAsI4GIAEgAkEQdjoAso4GIAEgAkEIdjoAsY4GIAFBpI4GaiABKAKojgYgAUGwjgZqIAFBs44GakEDEKcJIAEoAqCWAiICIAEoAqSWAiIDRwRAIAFBwI4GaiEEA0AgASAC/QAEAP0LBLCOBiABQaSOBmogASgCqI4GIAFBsI4GaiAEQRAQpwkgAkEQaiICIANHDQALCyABQaSOBmogASgCqI4GIAEoArCyCCICIAEoArSyCCIDIAMgAmsQpgkgAUGkjgZqIAEoAqiOBiARIBBBzABqQSAQpQkgAgRAIAIQKwsgASgCuJYCIgIEQANAIAIoAgAhAyACECsgAyICDQALCyABKAKwlgIhAiABQQA2ArCWAiACBEAgAhArCyABKAKglgIiAgRAIAEgAjYCpJYCIAIQKwsgAUGwjgZqIBAQ9gkgAUGglgJqIAFBsI4GahDhCSABIAEoAqiOBiABKAKkjgYiC2siBzYCkAEgASABQaCWAmo2ApQBQeQAQaOFKiABQZABahCbCSAQKAIgIgYEQCAGIgIgECgCJCIDRwRAA0AgA0EEayIEKAIAIQIgBEEANgIAIAIEQCACKAIEIgQEQCACIAQ2AgggBBArCyACECsLIAYgA0EMayIDRw0ACyAQKAIgIQILIBAgBjYCJCACECsLIBAQKyA4KAIAIgIEQCAIIAI2AryfQSACECsLIDcoAgAiAgRAIAggAjYCsJ9BIAIQKwsgOSgCACICBEAgCCACNgKkn0EgAhArCyAIKAKMjUEiBgRAIAYiAiAIKAKQjUEiA0cEQANAIANBDGsiAigCACIEBEAgA0EIayAENgIAIAQQKwsgAiEDIAIgBkcNAAsgCCgCjI1BIQILIAggBjYCkI1BIAIQKwsgLSgCACIGBEAgBiICIAgoAoSNQSIDRwRAA0AgA0EMayICKAIAIgQEQCADQQhrIAQ2AgAgBBArCyACIQMgAiAGRw0ACyAtKAIAIQILIAggBjYChI1BIAIQKwsgCBArIC8QKyAqBEAgKhArCyABKAKEiwIiAgRAIAEgAjYCiIsCIAIQKwsgASgC8IoCIgYEQCAGIgIgASgC9IoCIgNHBEADQCADQSBrIgIoAgAiBARAIANBHGsgBDYCACAEECsLIAIhAyACIAZHDQALIAEoAvCKAiECCyABIAY2AvSKAiACECsLIAEoAuSKAiICBEAgASACNgLoigIgAhArCyABKALQigIiAgRAIAEgAjYC1IoCIAIQKwsgB0EDbkEBaiISECohBiABQaCWAmpBAEHYHfwLACABQaCWAmoQ9wkgAUGslgJqQQBBtAH8CwAgAUEBNgLMlgIgAUEDNgLYlgIgB0GBgBBJIAdBgYAISWogB0GBgAFJakGEBWwiA0HY4jFqKAIAIQQgA0HM4jFqIQ4gA0HI4jFqKAIAIQwgA0HA4jFqKAIAIQIgB0GAgICAAk0EQCACQQZBICAHQQFrZ2sgB0HAAEkbIg0gAiANSRshAgsgA0HU4jFqIQ0gA0HQ4jFqIQogA0HE4jFqIRUgDigCACEOIAwgAkEBaiIDIAMgDEsbIQMgBEEGayIPQX1PBEAgA0EGQQQgDiAOQQRNGyIMIAxBBk8bQRhyIgwgAyAMSRshAwsgDSgCACEYIAooAgAhCiAVKAIAIQwgAUGUmQJqIg1BAEGwAfwLACABQRA2AsCZAiABQQE2ArSZAiABIBg2AqyZAiABIAo2AqiZAiABIA42AqSZAiABIAM2AqCZAiABQQogAiACQQpNGzYCmJkCIAEgBDYCsJkCIAEgAkF/QQAgBEEFSyIDG2sgDCAMIANrIAJLGzYCnJkCAkACQCAPQXxNBEBBAiEDIAFBAjYCoJoCIARBBksNASABQQI2ApSaAgwCC0ECIQMgAUECNgKUmgIgAUEBQQIgAkEOSxs2AqCaAgwBCyABQQFBAiACQRBLGzYClJoCQQFBAiACQRpLGyEDCyABQQE2AsSaAiABQYCACDYCnJoCIAEgAzYC6JkCIAshDCAHIRpBACEVQQAhJiMAQcACayIUJAAgAUGglgJqIgVBATYC9AUgBUHAAWoiMSANQbQB/AoAACAFKALEASECIAUoApQCIgRBAUYEQCAFIAI2AqgCIAUoApgCIQkCQAJAIAUoAqQCIgNFBEAgCQRAIAIgCU0NAyAFIAIgCWs2AqQCDAMLIAVBByAFKALcAUEDbmsiAzYCpAIMAQsgCQ0BCyAFQR5BBiACIANrIgkgCUEGTRsiCSAJQR5PGyIJNgKYAgsgBSgCoAJFBEAgBUEgQcAAIAUoAtwBQQdLGzYCoAILIAUoApwCIgNFBEBBCEEEIAUoAtwBIgMgA0EETRsiAyADQQhPGyEDCyAFIAMgCSADIAlJGzYCnAILQQEhJCAFKALIAiIJQgEgAq0iVoYiVyAarSJYIFcgWFQbp0EBIBobIgMgAyAJSxsiDUEDQQNBBCAFKALsAiIZGyAFKALUASIQQQNGGyIXbiEdIARBAUYEQCANIAUoAqACbiEmCyAFKALwECAFKAL0EGtBgICA4AdNBEAgBSgC+AVFISQLIAUoAswCIQ8Cf0EAIAUoAtwBIgNBAUYNABogD0EBRgRAQQAgA0EDa0EDSQ0BGgtBBCAFKALIAXQLIQogBSgC4AUhCEEEQREgAiACQRFPG0EAIBBBA0YbIgJ0QQAgAhshECAJQYCACCAJGyICQgEgVoYiViBYIFYgWFQbp0EBIBobIgkgAiAJSRsiAiAXbiIfQQN0QT9qQUBxITNBASAFKALMASITdEE/akFAcUEAIANBBmtBfU8bQQAgD0EBRhshD0EBIAUoApgCIgkgBSgCnAJrIipBACAJICpPG3RBCCAJdGpBACAEQQFGGyEJQYCPCUGAASADQQZLGyEDQQQgE3QhEwJAIARBAUYEfyACIAUoAqACbkEMbEE/akFAcQVBAAtBuKsBQeCNASAIGyADaiAQaiACaiACQQNuIAJBCnZqQQR0Qd8AakFAcUEAIBkbaiAKaiAfQQNsaiATaiAJaiAzaiAPamoiAkGIf0sEQCACIQMMAQsgCEUEQCAFIAUoAtAEQQFqNgLQBAsCQCAFKALEBCAFKAK8BGsgAkEDbE8EfyAFKALQBEGAAUoFQQALRSAFKAK0BCIKIAUoArAEIg9rIAJPcUUEQEFAIQMgCA0CIAUoAtgFIQggBSgC1AUhCSAFQbAEaiIEQQA2AiggBEIANwIgIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwIQIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwIAAkAgD0UNACAJBEAgCCAPIAkRAwAMAQsgDxArCwJ/IAUoAtAFIgQEQCAFKALYBSACIAQRBQAMAQsgAhAqCyIERQ0CIAVBADYC2AQgBSAENgLABCAFIAQ2ArgEIAUgBDYCsAQgBUIANwLQBCAFQQA6AMwEIAUgBDYCvAQgBSACIARqIgo2ArQEIAUgCkFAcSIINgLIBCAFIAg2AsQEIAJB8yNNBEAgBUEANgLoECAFQQE6AMwEDAMLIAUgBDYC6BAgBSAEQfQjaiIJNgLABCAFIAk2ArwEIAUgCTYCuAQgAkHnxwBNBEAgBUEANgLsECAFQQE6AMwEDAMLIAUgCTYC7BAgBSAEQejHAGoiCTYCwAQgBSAJNgK8BCAFIAk2ArgEIAJBv40BTQRAIAVBADYC0BIgBUEBOgDMBAwDCyAFQcwEaiETIAVB1ARqIRAgBUHYxQA2AtQSIAUgCTYC0BIgBUEAOgDMBCAFIARBwI0BaiICNgLABCAFIAI2ArgEIAUgAjYCvARBASEkDAELIAVBADoAzAQgBSAKQUBxIgg2AsQEIAUgBSgCuAQiAjYCvAQgBUHMBGohEyAFQdQEaiEQIAUoAtQEQQJJDQAgEEEBNgIACyAFIAVBxAFqIgn9AAIA/QsCqBIgCSkCECFWIAkoAhghBCAFIAUoAuACQQFGNgLIEiAFIFhCAXw3A+AEIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwPoBCAFIA02AtwEIAVBwBJqIAQ2AgAgBUG4EmogVjcCAEEAIQ8gBUH4BGoiM0EAQdgA/AsAIAVC+erQ0OfJoeThADcDmAUgBULP1tO+0ser2UI3A4gFIAVC1uuC7ur9ifXgADcDgAUgBUIANwOoBCAFQQE2AgAgBSgC6BAiBEHgkjIpAgA3AugjIARBADYC5CMgBEIANwLcIyAEQQA2AoQIIARB8CNqQeiSMigCADYCACAFKALMAiEfAkAgBSgC3AEiBEEBRg0AIB9BAUYgBEEDa0EDSXENAEEEIAUoAsgBdCEPC0EAIQQgBSgC1AFBA0YEQEERIAkoAgAiBCAEQRFPGyEECwJ/ICRFBEAgBSgC8BAhESAFKAL0EAwBCyAFQZOJLDYC+BAgBUGTiSw2AvQQIAVBADYChBFBlYksIREgBUGViSw2AvAQIAUgAjYCwARBk4ksCyEDIAUoAswBIRkgBUEANgLMEiAFIAQ2ApARIAVBADYCpBIgBUEANgL8ESAFQQA2AogRIAUgAjYCvAQgBSARIANrIgM2AoARIAUgAzYCjBEgBSADNgL8EAJ/AkACQCAFKALUBARAIAIhAwwBCyAFIAI2AsAEIAUgCkFAcSIRNgLIBCACQQAgAmtBP3EiKmoiAyAKSw0BIAUgAzYCvAQgBSADNgK4BCAqBEAgBSADNgLABAsgBUEBNgLUBAsgBQJ/IANBBCAZdGoiAiAITSIKRQRAIAVBAToAzAQgAyECQQAMAQsgBSACNgK8BCADCzYCzBECQCAIIAIgD2oiA0kEQCAFQQE6AMwEQQAhCiACIQNBACECDAELIAUgAzYCvAQLIAUgAjYC1BEgCCADQQQgBHRBACAEG2oiAkkEQCAFQQA2AtARIAVBAToAzARBQCEDDAMLIAUgAzYC0BEgBSACNgK8BCAKRQRAQUAhAwwDCyAFQdARagwBCyAFQQA2AtQRIAUgETYCyAQgBUIANwLMESAFQdARagshQiACIAUoAsAEIgRLBEAgAiAEayICBEAgBEEAIAL8CwALIAUoAsAEIQQgBSgCvAQhAgsgAiAESwRAIAUgAjYCwAQgAiEECyAFKALcASEDAkAgH0EBRw0AIANBBmtBfUkNAAJAIAUoAtQERQRAIAUgBSgCuAQiBDYCwAQgBSAFKAK0BCIKQUBxNgLIBEEAIQggBEEAIARrQT9xIg9qIgIgCksNASAFIAI2ArwEIAUgAjYCuAQgDwRAIAUgAjYCwAQgAiEECyAFQQE2AtQECyACIAUoAsQEQQEgGXRBP2pBQHEiCmsiCEsEQCAFQQE6AMwEQQAhCAwBCyAEIAhLBEAgBSAINgLABAsgBSAINgLEBCAIIAUoAsgEIgJPDQAgAiAIayICIAogAiAKSRsiAgRAIAhBACAC/AsACyAFIAg2AsgEIAUoAtwBIQMLIAUgCDYCmBEgBSAFKALMAUEGQQQgBSgC0AEiAiACQQRNGyICIAJBBk8bazYClBEgBSAFKQPAESJWQiiJIFZCD4mFIFaFQqW+4/TRjIfZn39+IlZCI4hCCHwgVoVCpb7j9NGMh9mff34iVyBXIAU1AsgRIlZCKIkgVkIPhoUgVoVCpb7j9NGMh9mff34iVkIjiEIEfCBWhUKlvuP00YyH2Z9/fiJWhUIciIUgVoU3A8ARCyAFQagSaiECIANBB08EQAJAAkAgBSgC1AQiBEEBTQRAAkAgBA0AIAUgBSgCuAQiBDYCwAQgBSAFKAK0BCIIQUBxIgo2AsgEQQAhAyAEQQAgBGtBP3EiD2oiBCAISw0CIAUgBDYCvAQgBSAENgK4BCAPRQ0AIAUgBDYCwAQLIAVBAjYC1AQLIAUCfyAFKALEBCIKQYAIayIDIAUoArwEIgRJBEAgBUEBOgDMBCAKIQNBAAwBCyAFKALABCADSwRAIAUgAzYCwAQLIAUgAzYCxAQgAws2AuARIAUCfyAEIANBwAFrIghLBEAgBUEBOgDMBCADIQhBAAwBCyAFKALABCAISwRAIAUgCDYCwAQLIAUgCDYCxAQgCAs2AuQRIAUCfyAEIAhBgAJrIgNLBEAgBUEBOgDMBCAIIQNBAAwBCyAFKALABCADSwRAIAUgAzYCwAQLIAUgAzYCxAQgAws2AugRIAUCfyAEIANBgAFrIghLBEAgBUEBOgDMBCADIQhBAAwBCyAFKALABCAISwRAIAUgCDYCwAQLIAUgCDYCxAQgCAs2AuwRIAUCfyAEIAhBwIACayIDSwRAIAVBAToAzAQgCCEDQQAMAQsgBSgCwAQgA0sEQCAFIAM2AsAECyAFIAM2AsQEIAMLNgLwESAEIANBgIEHayIDSwRAIAVBAToAzARBACEDDAILIAUoAsAEIANLBEAgBSADNgLABAsgBSADNgLEBAwBCyAFIAo2AsgEIAVCADcD4BEgBUEANgLoESAFQgA3AuwRCyAFIAM2AvQRCyACIAn9AAIA/QsCACACIAkoAhg2AhggAiAJKQIQNwIQIAUtAMwEBEBBQCEDDAELAkAgECgCACICQQFNBEACQCACDQAgBSAFKAK4BCIJNgLABCAFIAUoArQEIgNBQHE2AsgEQQAhAkEAIQQgCUEAIAlrQT9xIghqIgkgA0sNAiAFIAk2ArwEIAUgCTYCuAQgCEUNACAFIAk2AsAECyAQQQI2AgBBAiECC0EAIQQgHUEDdEE/akFAcSIJRQ0AIAUoAsQEIAlrIgQgBSgCvARJBEAgE0EBOgAAQQAhBAwBCyAFKALABCAESwRAIAUgBDYCwAQLIAUgBDYCxAQLIAUgBDYC/AUgBSgClAJBAUYEQEEIIAUoApgCdCEEAkAgAkEBTQRAIAUgBSgCuAQiCTYCwAQgBSAFKAK0BCIDQUBxNgLIBEEAIQIgCUEAIAlrQT9xIghqIgkgA0sNASAFIAk2ArwEIAUgCTYCuAQgCARAIAUgCTYCwAQLIBBBAjYCAAtBACECIARBP2pBQHEiCUUNACAFKALEBCAJayICIAUoArwESQRAIBNBAToAAEEAIQIMAQsgBSgCwAQgAksEQCAFIAI2AsAECyAFIAI2AsQECyAFIAI2AsAGIAQEQCACQQAgBPwLAAsCQCAFKALUBCICQQFNBEACQCACDQAgBSAFKAK4BCIJNgLABCAFIAUoArQEIgNBQHE2AsgEQQAhAkEAIQQgCUEAIAlrQT9xIghqIgkgA0sNAiAFIAk2ArwEIAUgCTYCuAQgCEUNACAFIAk2AsAECyAQQQI2AgBBAiECC0EAIQQgJkEMbEE/akFAcSIJRQ0AIAUoAsQEIAlrIgQgBSgCvARJBEAgE0EBOgAAQQAhBAwBCyAFKALABCAESwRAIAUgBDYCwAQLIAUgBDYCxAQLIAUgJjYC0BAgBSAENgLMECAFQoKAgIAgNwK0BiAFQZOJLDYCsAYgBUGTiSw2AqwGIAVBADYCxAYgBUEANgK8BiAFQZWJLDYCqAYLIAUoAuwCBEAgBSANQQNuIA1BCnZqQQJqIgk2AtQdAkAgAkEBTQRAIAUgBSgCuAQiAzYCwAQgBSAFKAK0BCIIQUBxNgLIBEEAIQJBACEEIANBACADa0E/cSIKaiIDIAhLDQEgBSADNgK8BCAFIAM2ArgEIAoEQCAFIAM2AsAECyAQQQI2AgBBAiECC0EAIQQgCUEEdEE/akFAcSIJRQ0AIAUoAsQEIAlrIgQgBSgCvARJBEAgE0EBOgAAQQAhBAwBCyAFKALABCAESwRAIAUgBDYCwAQLIAUgBDYCxAQLIAUgBDYC0B0LAkACQCACQQJNBEACQCACDQAgBSAFKAK4BCIENgLABCAFIAUoArQEIglBQHEiAzYCyARBACECIARBACAEa0E/cSIIaiIEIAlLDQIgBSAENgK8BCAFIAQ2ArgEIAhFDQAgBSAENgLABAsgEEEDNgIAQQMhAgtBACEEAkAgDUFgRg0AIAUoAsQEIA1rQSBrIgQgBSgCvARJBEAgE0EBOgAAQQAhBAwBCyAFKALABCAESwRAIAUgBDYCwAQLIAUgBDYCxAQLIAVBADYC4BIgBSANNgKcBiAFIAQ2AoQGIAVBADYC9BIgBUIANwPYEgwBCyAFQQA2AuASIAUgDTYCnAYgBUEANgKEBiAFQQA2AvQSIAVCADcD2BIgBSADNgLIBAsgBUEANgLwEiAFKAKUAkEBRgRAQQEgBSgCmAIgBSgCnAJrdCEEIAJBAk0EQCAFIAUoArgEIgI2AsAEIAUgBSgCtARBQHE2AsgEIAUgAkEAIAJrQT9xIglqIgI2ArwEIAUgAjYCuAQgCQRAIAUgAjYCwAQLIBBBAzYCAAsgBSgCxAQgBGsiAiAFKALABEkEQCAFIAI2AsAECyAFIAI2AsgGIAUgAjYCxAQgBARAIAJBACAE/AsACyAFKALUBCECCyAF/QwAAAAAAAAAAAAAAAAAAAAA/QsC1BAgBSAdNgKYBiAFQeQQakEANgIAAkACQCACQQJNBEACQCACDQAgBSAFKAK4BCIENgLABCAFIAUoArQEIglBQHEiAzYCyARBACECIARBACAEa0E/cSIIaiIEIAlLDQIgBSAENgK8BCAFIAQ2ArgEIAhFDQAgBSAENgLABAsgEEEDNgIAC0EAIQJBACEEAkAgDSAXSSIJDQAgBSgCxAQgHWsiBCAFKAK8BEkEQCATQQE6AABBACEEDAELIAUoAsAEIARLBEAgBSAENgLABAsgBSAENgLEBAsgBSAENgKMBgJAIAkNACAFKALEBCAdayICIAUoArwESQRAIBNBAToAAEEAIQIMAQsgBSgCwAQgAksEQCAFIAI2AsAECyAFIAI2AsQECyAFIAI2ApAGQQAhAiAJDQEgBSgCxAQgHWsiAiAFKAK8BEkEQCATQQE6AABBACECDAILIAUoAsAEIAJLBEAgBSACNgLABAsgBSACNgLEBAwBCyAFIAM2AsgEIAVCADcCjAYLIAVBATYC+AUgBSACNgKUBiAFQgA3A6gEIBIhKiAGIRhBRCEDAkACQCAFKAIAIgIOAgIAAQsgBSkD4ARCAX0hVkEAIQIgBSgC4AEiBARAIFZC/wFWIFZC/4EEVmogVkL+////D1ZqIQILIBJBEkkEQEG6fyEDDAILQSBBACAEQQBHIFZBASAFKALEASIIdK1YcSIJG0EEQQAgBSgC5AFBAEobciACQQZ0ciEDQQAhBCAxKAIARQRAIAZBqOq+aTYAAEEEIQQLIAQgBmogAzoAACAEQQFyIRUgCUUEQCAGIBVqIAhBA3RB0ABrOgAAIARBAnIhFQsCQAJAAkACQAJAIAJBAWsOAwECAwALIAlFDQMgBiAVaiBWPAAAIBVBAWohFQwDCyAGIBVqIFanQYACazsAACAVQQJqIRUMAgsgBiAVaiBWPgAAIBVBBGohFQwBCyAGIBVqIFY3AAAgFUEIciEVC0ECIQIgBUECNgIAIAYgFWohGCASIBVrISoLIBoEQAJAIAUoAtgRQQBHIAwgBSgC8BAiAkdyIghFBEAgBSgC/BAhAiAFKAKAESEDIAUoAvgQIQQMAQsgBSAFKAL8ECIDNgKAESAFIAUoAvQQIgQ2AvgQIAUgAiAEayICNgL8ECAFIAwgAms2AvQQIAIgA2tBB0sNACAFIAI2AoARIAIhAwsgBSAMIBpqIgk2AvAQAkAgCSADIARqTQ0AIAwgAiAEak8NACAFIAkgBGsiBCACIAIgBEsbNgKAEQsgCARAIAUgAjYCjBEgBUEANgLYEQsCQCAFKAKUAkEBRw0AAkAgBSgCqAYiAiAMRgRAIAUoArQGIQIgBSgCuAYhAyAFKAKwBiEEDAELIAUgBSgCtAYiAzYCuAYgBSAFKAKsBiIENgKwBiAFIAIgBGsiAjYCtAYgBSAMIAJrNgKsBiACIANrQQdLDQAgBSACNgK4BiACIQMLIAUgCTYCqAYgCSADIARqTQ0AIAwgAiAEak8NACAFIAkgBGsiBCACIAIgBEsbNgK4BgsgBSkD8AQhViAFKQPoBCFXIAUoAsQBIQIgBSgC3AQhDiAFKALkAQRAIDMgDCAaEL4LCyAFQfwFaiErIFcgVn0hWUEBIAJ0ITUgDkEBdiFDIA5BgEBqIUQgBUHkBWohNiAFQcQUaiEwIAVBnBVqITkgDkGAgAhJIUUgBUHwFGoiMkEoaiE6IDJBIGohOyAyQRBqITwgGCENA0AgDCEXAkAgRUUgGkH//wdLcUUEQCAaIA4gDiAaSxshEQwBC0GAgAghESBZQgNTDQACfwJAAkAgBSgCxAIiAg4CAAMBCyAFKALcAUECdEHQ3jFqKAIADAELIAJBAmsLIQQgBSgC0BIhAiAERQRAQQAhBCACQQBBiMAA/AsAIBdBA2ohAyAXQQJqIQggF0EBaiEKA0AgAiAEIBdqLQAAQQJ0aiIJIAkoAgBBAWo2AgAgAiAEIApqLQAAQQJ0aiIJIAkoAgBBAWo2AgAgAiAEIAhqLQAAQQJ0aiIJIAkoAgBBAWo2AgAgAiADIARqLQAAQQJ0aiIJIAkoAgBBAWo2AgAgBEEEaiIEQYAERw0ACyACQYQgaiEEIA4gF2oiCUH9A2shCCAJQf4DayEKIAlB/wNrIQ8gCUGABGshEUEAIQkDQCAEIAkgEWotAABBAnRqIgMgAygCAEEBajYCACAEIAkgD2otAABBAnRqIgMgAygCAEEBajYCACAEIAkgCmotAABBAnRqIgMgAygCAEEBajYCACAEIAggCWotAABBAnRqIgMgAygCAEEBajYCACAJQQRqIglBgARHDQALIAJBgAQ2AoAgIAJBgAQ2AoRAQgAhVkEAIQkDQCACIAlBAnQiA0EEciIIajUCACAEIAhqNQIAfUIJhiJXIFdCP4ciV4UgV30gAiADajUCACADIARqNQIAfUIJhiJXIFdCP4ciV4UgV30gVnx8IVYgCUECaiIJQYACRw0ACyAOIREgVkKAgA5UDQEgAkGAEGohCSAXIENqIgNB/QFrIQogA0H+AWshDyADQf8BayERIANBgAJrIRlBACEDA0AgCSADIBlqLQAAQQJ0aiIIIAgoAgBBAWo2AgAgCSADIBFqLQAAQQJ0aiIIIAgoAgBBAWo2AgAgCSADIA9qLQAAQQJ0aiIIIAgoAgBBAWo2AgAgCSADIApqLQAAQQJ0aiIIIAgoAgBBAWo2AgAgA0EEaiIDQYAERw0ACyACQYAENgKAMEIAIVZBACEDA0AgAiADQQJ0IghBBHIiCmo1AgAgCSAKajUCAH1CCYYiVyBXQj+HIleFIFd9IAIgCGo1AgAgCCAJajUCAH1CCYYiVyBXQj+HIleFIFd9IFZ8fCFWIANBAmoiA0GAAkcNAAtCACFXQQAhAgNAIAQgAkECdCIDQQRyIghqNQIAIAggCWo1AgB9QgmGIlogWkI/hyJahSBafSADIARqNQIAIAMgCWo1AgB9QgmGIlogWkI/hyJahSBafSBXfHwhVyACQQJqIgJBgAJHDQALQYCABEGAgAJBgIAGIFYgV1YbIFYgV30iViBWQj+HIlaFIFZ9QtWqBVQbIREMAQsgAkEAQYjAAPwLAEGAwAAhESACIBdBgMAAIARBAnQiCUG8kjJqKAIAIh8RAQAgAkGEIGohBCAJQcySMmohE0EDIQ8DQCAEIBEgF2pBgMAAIB8RAQAgEygCACEIIAIoAoRAIhmtIVogAigCgCAiEK0hW0IAIVZBACEJA0AgAiAJQQJ0IgNqNQIAIFp+IAMgBGo1AgAgW359IlcgV0I/hyJXhSBXfSBWfCFWIAlBAWoiCSAIdkUNAAtBACEDIFYgWyAPQQ5qrH4gWn5CBIhaDQEDQCACIANBAnQiCWoiCCAIKAIAIAQgCWooAgBqNgIAIAIgCUEEciIIaiIKIAooAgAgBCAIaigCAGo2AgAgAiAJQQhyIghqIgogCigCACAEIAhqKAIAajYCACACIAlBDHIiCWoiCCAIKAIAIAQgCWooAgBqNgIAIANBBGoiA0GACEcNAAsgAiAQIBlqNgKAICAPIA9BAEprIQ8gEUGAQGsiESBETQ0ACyAOIRELQbp/IQMgKkEGSQ0CAn8gESAXaiIMIAUoAvQQIgJrIglBgICA6AdNBEAgBSgCiBEMAQsgBSAFKAK4BDYCwAQgBSAFKAKEEUEBajYChBEgBSAXQQEgBSgCxAF0IglBASAFKALIASAFKALcAUEFS2t0IgQgBCAJSRsgFyACayICIARBAWtxIglqQQIgBCAEQQJNG0EAIAlBAkkbaiIEazYC9BAgBSACIARrIgIgBSgC+BBqNgL4ECAFQQIgBSgCgBEiCSACayAJIAJBAmoiBEkbNgKAESAFQQIgBSgC/BAiCSACayAEIAlLGzYC/BAgBSgCzBFBASAFKALMAXQgAhC9CyAFKALcASEJAkACQCAFKALcEQ0AIAlBAUYNASAJQQNrQQJLDQAgBSgCzAJBAUYNAQtBASAFKALIAXQhCCAFKALUESEZIAlBBkYEQCAIQRBtIRAgCEEQSA0BIBlBPGohHyAZQThqIRMgGUE0aiEkIBlBMGohJiAZQSxqIR0gGUEoaiEeIBlBJGohIyAZQSBqIRYgGUEcaiEcIBlBGGohICAZQRRqISEgGUEQaiEsIBlBDGohLSAZQQhqISUgGUEEaiEuQQAhCEEAIQ8DQCAZIAhBAnQiCWoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgLmoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgJWoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgLWoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgLGoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgIWoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgIGoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgHGoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgFmoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgI2oiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgHmoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgHWoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgJmoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgJGoiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgE2oiCkEBIAooAgAiCiACa0EAIAQgCk0bIApBAUYbNgIAIAkgH2oiCUEBIAkoAgAiCSACa0EAIAQgCU0bIAlBAUYbNgIAIAhBEGohCCAPQQFqIg8gEEcNAAsMAQsgGSAIIAIQvQsLIAUoApARIgQEQCBCKAIAQQEgBHQgAhC9CwsgBSgCvAQiBCAFKALABEsEQCAFIAQ2AsAECyAFQQA2AqQSIAVBADYCiBEgBSAFKAKMESIJIAJrIgJBACACIAlNGzYCjBEgDCAFKAL0ECICayEJQQALIQQCQCAEIDVqIAlPBEAgBCAFKAL8EEYNAQtBACEEIAVBADYCpBIgBUEANgKIEQsCQCAXIAJrIgkgBCA1ak0EQCAFKAKAESECDAELIAUoAoARIgIgCSA1ayIESQRAIAUgBDYCgBEgBCECCyACIAUoAvwQSwRAIAUgAjYC/BALIAVBADYCpBIgBUEANgKIEQsgAiAFKAKMEUsEQCAFIAI2AowRCyARIBpGISYCQAJAAkACQAJAAkACQAJ/AkACQAJAAkACQCAFKAL0AQRAIAUgFyARELALIgNBiH9LDRAgAw0LAkAgBSgC9AUNACAFKAKABiAFKAL8BWtBH0sNACAFKAKIBiAFKAKEBmtBCUsNACAXIBEQswtFDQAgDSAXLQAAOgADIA0gEUENdjoAAiANIBFBA3QgJnJBAnI7AABBBCECDA0LICsgBSgC6BAgBSgC7BAgMSAUQQhqIAUoAtASIAUoAtQSEKULIgNBiH9LDQggFCgCCCIQQQJGIS4gDSAqaiE3IAUoAogGIj0gBSgChAYiLGshHyAFKAKUBiEcIAUoApAGISAgBSgCjAYhISAFKAIIGiAFKALsECEoIAUoAugQITggBSgCgAYiLSAFKAL8BSIbRg0BIAUoAvQBISQgLSAbayITQQN1IQogBSgC1BIhGSAFKALQEiEJIBRB/wE2ArACIB8hDwJAAkACQAJAIBAOBAMAAQECC0EBIQ8MAgsgCSAUQbACaiAsIB8gCSAZEKYLQYh/Sw0BIBQoArACIh5BAEgEf0EDBSAoQQRqIQgCQAJ/IB5FBEBBACEDQQAMAQsgHkEBakF+cSEdQQAhAkEAIQMDQCAIIAJBAnQiBEEEciIPai0AACAJIA9qKAIAbCAEIAhqLQAAIAQgCWooAgBsIANqaiEDIAJBAmoiAiAdRw0ACyAeQQFxDQEgHkEBa0F+cUECagshAiAIIAJBAnQiAmotAAAgAiAJaigCAGwgA2ohAwsgA0EDdkEDagsgFCgCjAFBACAQQQJGG2ohDwwBC0EAIQ8LIBQoApQBIQIgFEEfNgKwAiAJIBRBsAJqIBwgCiAJIBkQrQsaQQAhBAJAAkACQCACDgIACAELIBQoArACIh1BHEsNAQJAIB0EfyAdQQFqQT5xIRBBACECA0BBASACQQFyIgNBAXRBwPsxai8BACIIIAhB//8DRhvBQQV0QcDzMWooAgAgCSADQQJ0aigCAGxBASACQQF0QcD7MWovAQAiAyADQf//A0YbwUEFdEHA8zFqKAIAIAkgAkECdGooAgBsIARqaiEEIAJBAmoiAiAQRw0ACyAdQQFxDQEgHUEBa0F+cUECagVBAAshAkEBIAJBAXRBwPsxai8BACIDIANB//8DRhvBQQV0QcDzMWooAgAgCSACQQJ0aigCAGwgBGohBAsgBEEIdiEEDAcLIAJBfnFBAkcNBiAUKAKwAiIdICgvAIoISw0AIChBASAoLwCICCIeQQFrdEEBIB4bQQJ0akGMCGohI0EBIB50IRYgHkEIdEGAAmohJUEAIQNBACECA0AgCSACQQJ0aigCACIEBEAgIyACQQN0aigCBCIIQRB2QQFqIhBBCHQgEEEYdCAIIBZqQQh0ayAedmsiCCAlTw0CIAQgCGwgA2ohAwsgAiAdRyEEIAJBAWohAiAEDQALIANBCHYhBAwGCyAKQQpsDAYLIAUoAsACQQFGBEAgBSAXIBEQsAsiAkGIf0sEQCACIQMMEQsCQCACQQFGBEAgBSgC6BAiAigC3CNBAkYEQCACQQE2AtwjCyA2KAIABEBBln8hAwwTCyARQQNqIgIgKksNEiANIBFBDXY6AAIgDSARQQN0ICZyOwAAIBFFBEAgAiEDDAILIA1BA2ogFyAR/AoAACACIQMMAQsgBSgC/AUhAiAFKAKABiEEQQAhHSAUQQA2AgwgFCA5NgIIIAQgAmtBA3UiAkEFTwRAIBRBCGpBACACIAUgKxC0CyAUKAIIIBQoAgwiHUECdGogAjYCAAsgFEEQaiIhIAUoAugQIgJB8CNqIgQoAgA2AgAgFCACKQLoIzcDCCAUIAQoAgA2ArgCIBQgAikC6CM3A7ACIDpBADYCACA7QgA3AgAgPP0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgMv0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgHUUEQCAFICsgFEEIaiAUQbACaiANICogFyARICZBABC3CyEDDAELIAUoApwVIQIgMCAr/QACAP0LAgAgMEEoaiIWICsoAig2AgAgMEEgaiIcICspAiA3AgAgMEEQaiIgICv9AAIQ/QsCAAJAIAUoAqAGRQ0AIAUoAqQGIAJNDQAgBUEANgLoFAsgBSAFKAL8BSIJNgLEFCAFIAkgAkEDdGo2AsgUIAUoAoAGIAlrQQN1IAJHBEACQCACRQRAQQAhBAwBCyAFKALsFCEDQQAhCkEAIQQgAkEBRwRAIAJBAXEhDyACQX5xIQpBACECA0AgBCAJIAJBA3RqLwEEaiEEIAIgA0YEfyAEQYCABGogBCAFKALoFEEBRhsFIAQLIAkgAkEBciIIQQN0ai8BBGohBCADIAhGBEAgBEGAgARqIAQgBSgC6BRBAUYbIQQLIAJBAmoiAiAKRw0ACyAPRQ0BCyAEIAkgCkEDdGovAQRqIQQgAyAKRw0AIARBgIAEaiAEIAUoAugUQQFGGyEECyAFIAUoAswUIARqNgLQFAtBACEDICohHyANIRNBACEQQQAhJANAQQAhCSAFKALIFCICIAUoAsQUIgRHBEBBASACIARrQQN1IgIgAkEBTRsiGUEBcSEeIAUoAuwUIQlBACEPQQAhCAJAIAJBAkkiI0UEQCAZQX5xIQ9BACECA0AgCCAEIAJBA3RqLwEEaiEIIAIgCUYEfyAIQYCABGogCCAFKALoFEEBRhsFIAgLIAQgAkEBciIKQQN0ai8BBGohCCAJIApGBEAgCEGAgARqIAggBSgC6BRBAUYbIQgLIAJBAmoiAiAPRw0ACyAeRQ0BCyAIIAQgD0EDdGovAQRqIQggCSAPRw0AIAhBgIAEaiAIIAUoAugUQQFGGyEICwJAAn8gIwRAQQAhGUEDDAELIBlBfnEhGUEAIQpBACECA0AgCiAEIAJBA3RqLwEGakEDaiEKIAIgCUYEfyAKQYCABGogCiAFKALoFEECRhsFIAoLIAQgAkEBciIPQQN0ai8BBmpBA2ohCiAJIA9GBEAgCkGAgARqIAogBSgC6BRBAkYbIQoLIAJBAmoiAiAZRw0ACyAeRQ0BIApBA2oLIQIgAiAEIBlBA3RqLwEGaiEKIAkgGUcNACAKQYCABGogCiAFKALoFEECRhshCgsgCCAKaiEJCwJ/IBAgHUYEQCARICRrIQQgJgwBCyAyICsgOSAQQQJ0aiICKAIAIAIoAgQQtQsgCSEEQQALIQIgBSAwIBRBCGogFEGwAmogEyAfIBcgBCACQQEQtwsiAkGIf0sEQCACIQMMAgsgCSAkaiEkIDAgMv0AAgD9CwIAIBYgOigCADYCACAcIDspAgA3AgAgICA8/QACAP0LAgAgAiADaiEDIB8gAmshHyACIBNqIRMgBCAXaiEXIBBBAWoiECAdTQ0ACyAFKALoECICIBQpAwg3AugjIAJB8CNqICEoAgA2AgALIANBiX9JDQ0MEAsgBSAXIBEQsAsiA0GIf0sNDyANQQNqIQQgNigCACECIANBAUYEQEEAIQMgAkUNA0GWfyEDDBALIAUoAugQIQkgAgRAIDYgKyAJQegjahC5CyIDQYh/Sw0QIAUgBSkD6BBCIIk3A+gQDAQLQQAhAwJAIAQgKkEDayIIIAUoAoQGIgIgBSgCiAYgAmsgKyAJIAUoAuwQIDEgBSgC0BIgBSgC1BIgBSgCCBC4CyICRQ0AIAJBun9GIAggEU9xDQAgAkGIf0sEQCACIQMMAwsgAkEAIAIgESARQQcgBSgC3AEiCSAJQQdNG0EBa3ZrQQJrSRshAwsgBSgC9AUNASADQRhLDQEgFyARELMLRQ0BIAQgFy0AADoAAEEBIQMMAgtBACETIBRBADYCvAJBASElIBshCSAXISIgDSEWQQAhCkEAIQgMBQsgA0ECa0GGf0sNACAFIAUpA+gQQiCJNwPoEAsgBSgC6BAiAigC3CNBAkYEQCACQQE2AtwjCyADQYh/Sw0MQQIhCSARIQICQAJAIAMOAgIBAAtBBCEJIAMhAgsgDSACQQ12OgACIA0gAkEDdCAJciAmcjsAACADQQNqIQMMCQtBun8hAyARQQNqIgIgKksNCyANIBFBDXY6AAIgDSARQQN0ICZyOwAAIBEEQCAEIBcgEfwKAAALIAIhAyACQYl/SQ0IDAsLIAogHGohAyAcIQIDQCAEIAItAABqIQQgAkEBaiICIANJDQALIARBA3YLIR0gFCgCkAEhAiAUQSM2ArACIAkgFEGwAmogISAKIAkgGRCtCxpBACEEAn8CQAJAAkACQCACDgIAAwELIBQoArACIh5BI0sNAQJAIB4EfyAeQQFqQf4AcSEQQQAhAgNAQQEgAkEBciIDQQF0QYD8MWovAQAiCCAIQf//A0YbwUEEdEHA8zFqKAIAIAkgA0ECdGooAgBsQQEgAkEBdEGA/DFqLwEAIgMgA0H//wNGG8FBBHRBwPMxaigCACAJIAJBAnRqKAIAbCAEamohBCACQQJqIgIgEEcNAAsgHkEBcQ0BIB5BAWtBfnFBAmoFQQALIQJBASACQQF0QYD8MWovAQAiAyADQf//A0YbwUEEdEHA8zFqKAIAIAkgAkECdGooAgBsIARqIQQLIARBCHYhBAwCCyACQX5xQQJHDQEgFCgCsAIiHiAoLwC6GUsNACAoQQEgKC8AuBkiI0EBa3RBASAjG0ECdGpBvBlqIRZBASAjdCElICNBCHRBgAJqIS9BACEDQQAhAgNAIAkgAkECdGooAgAiBARAIBYgAkEDdGooAgQiCEEQdkEBaiIQQQh0IBBBGHQgCCAlakEIdGsgI3ZrIgggL08NAiAEIAhsIANqIQMLIAIgHkchBCACQQFqIQIgBA0ACyADQQh2IQQMAQsgCkEKbAwBCyAKICFqIQMgISECA0AgBCACLQAAQZCQMmotAABqIQQgAkEBaiICIANJDQALIARBA3YLIRAgJEG8CkshHiAUKAKYASECIBRBNDYCsAIgCSAUQbACaiAgIAogCSAZEK0LGkEAIQQCfwJAAkACQAJAIAIOAgADAQsgFCgCsAIiI0E0Sw0BAkAgIwR/ICNBAWpB/gBxIRlBACECA0BBASACQQFyIgNBAXRB0Pwxai8BACIIIAhB//8DRhvBQQR0QcDzMWooAgAgCSADQQJ0aigCAGxBASACQQF0QdD8MWovAQAiAyADQf//A0YbwUEEdEHA8zFqKAIAIAkgAkECdGooAgBsIARqaiEEIAJBAmoiAiAZRw0ACyAjQQFxDQEgI0EBa0F+cUECagVBAAshAkEBIAJBAXRB0Pwxai8BACIDIANB//8DRhvBQQR0QcDzMWooAgAgCSACQQJ0aigCAGwgBGohBAsgBEEIdiEEDAILIAJBfnFBAkcNASAUKAKwAiIjICgvAI4OSw0AIChBASAoLwCMDiIWQQFrdEEBIBYbQQJ0akGQDmohJUEBIBZ0IS8gFkEIdEGAAmohNEEAIQNBACECA0AgCSACQQJ0aigCACIEBEAgJSACQQN0aigCBCIIQRB2QQFqIhlBCHQgGUEYdCAIIC9qQQh0ayAWdmsiCCA0Tw0CIAQgCGwgA2ohAwsgAiAjRyEEIAJBAWohAiAEDQALIANBCHYhBAwBCyAKQQpsDAELIAogIGohCSAgIQIDQCAEIAItAABBgJEyai0AAGohBCACQQFqIgIgCUkNAAsgBEEDdgshAiAkQbwKIB4bIQQgFCgCpAIgDyAdaiAQaiACampBBmohAiAsID1GBH9BgAIFIA9BCHQgH24LIR0gAkEIdEEBIAIgBEEBdmogBG4iBCAEQQFNGyIEbiEeIAIgD2tBCHQgCm4hIyACIBFLDQICQCAEQQFrIkZFBEBBASElIA0hFiAXISIgGyEJDAELQQAhL0EBISUgGyEJIBchIiANIRYCQANAIAkvAQQhD0EBIRACQCAtIAlrIhNBA3UiCkECSQ0AQQBBgPABIC8bICNqIA8gHWxqIgIgHksNACAPIAkvAQZqQQNqIQQDQCAEIAkgEEEDdGoiAy8BBCIIaiADLwEGakEDaiEEIB4gAiAjaiAIIB1saiICSSACIARBCHRJcQ0BIBBBAWoiECAKRw0ACyAKIRALIAkgEEEDdGoiJyAtRg0BQQAhHyAUQQA2ArwCIBBBAXEhNCAFKAL8BSEZIAUoAqQGIQJBACEKAkAgEEEBRiITRQRAIBBBfnEhH0EAIQMDQCAJIANBA3RqIggvAQQhBCAIIBlrIg9BA3UgAkYEfyAEQYCABHIgBCAFKAKgBkEBRhsFIAQLIApqIQogCC8BDCEEIA9BCGpBA3UgAkYEfyAEQYCABHIgBCAFKAKgBkEBRhsFIAQLIApqIQogA0ECaiIDIB9HDQALIDRFDQEgCSAfQQN0ai8BBCEPCyAJIB9BA3RqIBlrQQN1IAJGBH8gD0GAgARyIA8gBSgCoAZBAUYbBSAPCyAKaiEKC0EAIQ9BACEkAkAgE0UEQCAQQX5xISRBACEEA0AgCSAEQQN0aiIDLwEGIhNBA2ohCCADIBlrIh9BA3UgAkYEfyATQYOABGogCCAFKAKgBkECRhsFIAgLIA9qIQggAy8BDiIPQQNqIQMgH0EIakEDdSACRgR/IA9Bg4AEaiADIAUoAqAGQQJGGwUgAwsgCGohDyAEQQJqIgQgJEcNAAsgNEUNAQsgCSAkQQN0aiIDLwEGIghBA2ohBCADIBlrQQN1IAJGBH8gCEGDgARqIAQgBSgCoAZBAkYbBSAECyAPaiEPCyAoIBRBCGogCSAQICwgCiAhICAgHCAxIBYgNyAWayAuICUgFEGwAmogFEG8AmpBABC/CyIDQYh/Sw0EAkAgA0UNACADIAogD2oiAk8NAEEAICUgFCgCvAIbISVBACAuIBQoArACGyEuIBAgHGohHCAQICBqISAgECAhaiEhIAMgFmohFiAKICxqISwgAiAiaiEiICchCQsgL0EBaiIvIEZHDQALIC0gCWsiE0EDdSEKCyA9ICxrIR8LQQAhCCAUQQA2ArwCIAkgLUYNACAFKAL8BSEkIAUoAqQGIQ8CQCAKQQFGBEBBACEdQQEhCgwBCyAKQQFxIR4gCkF+cSEdQQAhAgNAIAkgAkEDdGoiBC8BBiIQQQNqIQMgBCAkayIZQQN1IA9GBH8gEEGDgARqIAMgBSgCoAZBAkYbBSADCyAIaiEDIAQvAQ4iCEEDaiEEIBlBCGpBA3UgD0YEfyAIQYOABGogBCAFKAKgBkECRhsFIAQLIANqIQggAkECaiICIB1HDQALIB5FDQELIAkgHUEDdGoiBC8BBiIDQQNqIQIgBCAka0EDdSAPRgR/IANBg4AEaiACIAUoAqAGQQJGGwUgAgsgCGohCAsgKCAUQQhqIAkgCiAsIB8gISAgIBwgMSAWIDcgFmsgLiAlIBRBsAJqIBRBvAJqICYQvwsiA0GIf0sNAAJAAkAgA0UNACADIAggH2oiAk8NAEEAICUgFCgCvAIbISUgCSATaiEJIAMgFmohFiACICJqISIgFCgCsAINAQsgLkUNACAoIDhBiAj8CgAACyAlBEAgFCgCkAFBAWtBAkkNAiAUKAKYAUEBa0ECSQ0CIBQoApQBQQNrQX1LDQILAkAgDCAiTQ0AIAwgImsiAkEDaiIDIDcgFmtLDQQgFiACQQ12OgACIBYgAkEDdCAmcjsAACACBEAgFkEDaiAiIAL8CgAACyADQYh/Sw0BIAMgFmohFiAJIC1PDQAgFEG4AmoiECA4QfAjaigCADYCACAUIDgpAugjNwOwAiAJIBtLBEAgBSgC/AUhDyAFKAKkBiEZIBQoArQCIQMgFCgCuAIhCiAUKAKwAiEEA0AgGy8BBCECIBsgD2tBA3UgGUYEQCACQYCABHIgAiAFKAKgBkEBRhshAgsCQAJAIBsoAgAiCEEETwRAIBQgBDYCtAIgFCADNgK4AiAIQQNrIQIgAyEKDAELAn8CQAJAIAggAkVqQQFrIggOBAQBAQABCyAEQQFrDAELIBRBsAJqIAhBAnRqKAIACyECIBQgBDYCtAIgFCAKIAMgCEEBRhsiCjYCuAILIBQgAjYCsAIgBCEDIAIhBAsgG0EIaiIbIAlJDQALCyAoIBQpA7ACNwLoIyAoQfAjaiAQKAIANgIACyAWIA1rIQMLIANBun9GDQIgA0GIf0sNBwwBC0EAIQMLIANFDQAgAyARIBFBByAFKALcASICIAJBB00bQQFrdmtBAWpPDQAgBSAFKQPoEEIgiTcD6BAgAyECDAELQbp/IQMgEUEDaiICICpLDQQgDSARQQ12OgACIA0gEUEDdCAmcjsAACARBEAgDUEDaiAXIBH8CgAACyACIQMgAkGIf0sNBAsgBSgC6BAiBCgC3CNBAkcEQCACIQMMAQsgBEEBNgLcIyACIQMLIAVBADYC9AUgKiADayEqIAMgDWohDSBZIBGtfCADrX0hWSAaIBFrIhoNAAsgDSAYSwRAIAVBAzYCAAsgDSAYayIDQYh/Sw0BIAUgBSkD6AQgWHwiVjcD6AQgBSAFKQPwBCADIBVqIhWtfDcD8AQCQCAFKQPgBCJXUA0AIFZCAXwgV1gNAEG4fyEDDAILIBVBiH9LBEAgFSEDDAILIAUoAgAhAgsgEiAVayEEIAYgFWoiCCEJQUQhAwJAAkACQCACDgQDAAECAQsgBEESSQRAQbp/IQMMAwtBACECQSBBACAFKALgASIJG0EEQQAgBSgC5AFBAEobciEDIAUtAMQBQQN0QdAAayEKIDEoAgBFBEAgCEGo6r5pNgAAQQQhAgsgAiAIaiIaQQAgCiAJGzoAASAaIAM6AAAgBUECNgIAIAggAkECciIJaiICQQA6AAIgAkEBOwAAIAQgCWtBA2shBCACQQNqIQkMAQsgBEEDSQRAQbp/IQMMAgsgCEEAOgACIAhBATsAACAEQQNrIQQgCEEDaiEJCyAFKALkAQRAIARBBEkEQEG6fyEDDAILIAkgMxDACz4AACAJQQRqIQkLIAVBADYCACAJIAhrIgNBiH9LDQACQCAFKQPgBCJWUA0AIFYgBSkD6ARCAXxRDQBBuH8hAwwBCyADIBVqIQMLIBRBwAJqJAAgAyECIAFBoJYCahD3CSABQdiaAmr9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAFB6JoCav0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAUH4mgJqQQA2AgAgASgC0JoCIQMgAUIANwPQmgICQCADRQ0AIAEoAvSbAiIEBEAgASgC+JsCIAMgBBEDAAwBCyADECsLIAEgBzYCgAEgASACNgKEAUHkAEHUwSkgAUGAAWoQmwkgQSACNgIAIEAgBjYCACALBEAgCxArC0EABUEBCyECIAFBsLUIaiQAIAIMEQsgAUGVrio2ArABQeQAQfSHKiABQbABahCbCUGQljQoAgAoAgAhAiABQZWuKjYCoAEgAkGRjCogAUGgAWoQbAALIAFBla4qNgLQAkHkAEH0hyogAUHQAmoQmwlBkJY0KAIAKAIAIQIgAUGVrio2AsACIAJBkYwqIAFBwAJqEGwACyABQZWuKjYC8AJB5ABB9IcqIAFB8AJqEJsJQZCWNCgCACgCACECIAFBla4qNgLgAiACQZGMKiABQeACahBsAAsgAUGVrio2ApADQeQAQfSHKiABQZADahCbCUGQljQoAgAoAgAhAiABQZWuKjYCgAMgAkGRjCogAUGAA2oQbAALIAFBla4qNgKwA0HkAEH0hyogAUGwA2oQmwlBkJY0KAIAKAIAIQIgAUGVrio2AqADIAJBkYwqIAFBoANqEGwACyABQZWuKjYC0ANB5ABB9IcqIAFB0ANqEJsJQZCWNCgCACgCACECIAFBla4qNgLAAyACQZGMKiABQcADahBsAAsgAUGVrio2AvADQeQAQfSHKiABQfADahCbCUGQljQoAgAoAgAhAiABQZWuKjYC4AMgAkGRjCogAUHgA2oQbAALEKAJAAsgAUHJ/ys2AtAEQeQAQfSHKiABQdAEahCbCUGQljQoAgAoAgAhAiABQcn/KzYCwAQgAkGRjCogAUHABGoQbAALEKAJAAsgAUHPuis2AvAFQeQAQfSHKiABQfAFahCbCUGQljQoAgAoAgAhAiABQc+6KzYC4AUgAkGRjCogAUHgBWoQbAALEKAJAAsQoAkACxCgCQALEKAJAAsgAUGAxio2AnBB5ABB9IcqIAFB8ABqEJsJQZCWNCgCACgCACECIAFBgMYqNgJgIAJBkYwqIAFB4ABqEGwACyABQYDGKjYCUEHkAEH0hyogAUHQAGoQmwlBkJY0KAIAKAIAIQIgAUGAxio2AkAgAkGRjCogAUFAaxBsAAsiAgRAICkgAjYCICAAQbvdKiApQSBqEG5BAAwBCyApKAJcIQYgKSgCWCEDIABBEEEBENoBIQIgAEHY4c59QcHiKRCQARogAEF+ENsBIAJBATYCDCACIAM2AgQgAiADNgIAIAIgBjYCCCAAQenvKxBYIAAoAgwiAkETOgAEIAJBgICA/AM2AgAgACAAKAIMIgJBCGo2AgwgAkETOgAMIAIgPrM4AgggACAAKAIMQQhqNgIMIAAgPxBYQQULIQIgKUHQvyo2AgAgAEHghyogKRCbASApQeAAaiQAIAIL0QoBCn8jAEHQAGsiBCQAIARBgLArNgIgIABB+YYqIARBIGoQmwEgAEEBEMgBIQEgBEEANgIwAn8gACgCFCgCAEEQaiIDIAAoAgxPBEAgACgCEEEsaiEDCwJAAkAgAy0ABEEDRwRAIAMgBEEwakEAEPwBIQIgBCgCMCIDQQRKDQEgAg0CIABB67UqQQAQbkEADAMLIAMoAgAiA0EFSA0BCyAEIAM2AhAgAEHo3iogBEEQahBuQQAMAQsgA0HQAGxB4NUxagshAyAEQTBqIQYgASgCCCECIAEoAgAhBSMAQeAMayIBJAACQCACRQ0AIANFDQAgAUEAOgDcDCABQQA2AtgMIAFBu88BOwH0CyABQeqSmL8GNgLwCyABQa4BOgD2CyABQYX5ADsA9wsgAUHuADoA+QsgAUHz5QE7AfoLIAFBpQE6APwLIAFBz+oDOwD9CyABQTo6AP8LIAFB0Rw7AYAMIAFB0gA6AIIMIAFBBToAhQwgAUH/tgI7AIMMIAFBHzoAiAwgAUHomAI7AYYMIAEgAUHwC2oiCjYC7AsgAUGDswM7AIkMIAFBqwE6AIsMIAEoAuwLIgNBzQE6AB4gA0HbwAM7ABwgASgC7AsiA0IANwAgIANBGToAH0GAo8PHABCiCSIJQQBBgKPDxwD8CwAgCSACIAUQ0QoiAkGJf08EQCABIAIQ0go2AhBBAUGbiyogAUEQahCbCUEAIQILIAEgCTYCvAsCQCABQbwLaiACENMKIgdFBEBBAUHKuStBABCbCQwBCyABQcALaiAHQbCINBDcCSABQewLaiABQcALakEgEKoJIAEoArwLIQMgAUEgahCYCRoCQCABQbwLaiACIAlqIANrENQKIggEQAJAIAEoArwLIAlrIgMgAkcEQCABIAIgA2s2AgBBAUHe/ikgARCbCQwBCyABQcALaiAIEPYJIAFB7AtqIAFBwAtqQSAQqgkgBiABQewLaiABQZgMagJ/IAEtANwMRQRAIAEoAtgMDAELIAFB6pKYvwY2AvALIAEgCjYC7AsgCkGuAToABiAKQbvPATsABCABKALsCyICQe4AOgAJIAJBhfkAOwAHIAEoAuwLIgJBpQE6AAwgAkHz5QE7AAogASgC7AsiAkE6OgAPIAJBz+oDOwANIAEoAuwLIgJB0gA6ABIgAkHRHDsAECABKALsCyICQQU6ABUgAkH/tgI7ABMgASgC7AsiAkEfOgAYIAJB6JgCOwAWIAEoAuwLIgJBqwE6ABsgAkGDswM7ABkgASgC7AsiAkHNAToAHiACQdvAAzsAHCABKALsCyICQgA3ACAgAkEZOgAfIAFBADoA3AwgAUEANgLYDEEACxCrCSABQQE6ANwMIAFBADYC2AwLIAgoAiAiBgRAIAYiAiAIKAIkIgNHBEADQCADQQRrIgUoAgAhAiAFQQA2AgAgAgRAIAIoAgQiBQRAIAIgBTYCCCAFECsLIAIQKwsgBiADQQxrIgNHDQALIAgoAiAhAgsgCCAGNgIkIAIQKwsgCBArDAELQQFB1LkrQQAQmwkLIAcoAiAiBgRAIAYiAiAHKAIkIgNHBEADQCADQQRrIgUoAgAhAiAFQQA2AgAgAgRAIAIoAgQiBQRAIAIgBTYCCCAFECsLIAIQKwsgBiADQQxrIgNHDQALIAcoAiAhAgsgByAGNgIkIAIQKwsgBxArCyAJECsLIAFB4AxqJAAgAEEgEIYBIgMoAggiASAE/QAEMP0LAAAgASAEQUBr/QAEAP0LABAgA0EgNgIAIARBgLArNgIAIABB4IcqIAQQmwEgBEHQAGokAEEBC/wKAQt/IwBBMGsiByQAIAdB7JIrNgIgIABB+YYqIAdBIGoQmwEgB0EANgIsIAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgB0EsakEAEPwBIQIgBygCLCEBIAINACAAQQEQ/QELAkAgAUEHa0F5TQRAIABBhIMqQQAQbgwBCyAHIAE2AhAgAEGj3SogB0EQahBbIABBAEEAEKEBIABB9bopEFggAUGgL2xB8N4saiIJKAIAIQEgAEEkEIYBIQQCQCABLQACIgNFDQAgAUECaiEIIAQoAgghCiABQQNqIQVBACECQQAhAQNAIAEgBWosAAAiBkUNASADwEECdEGA2SxqKAIAIgNBAEgNASAGQQJ0QYDZLGooAgAiBkEASA0BIAIgCmogA0EEdCAGcjoAACACQQFqIQIgCCABQQJqIgFqLQAAIgMNAAsLIARBIDYCACAAQX0QogEgAEGFrikQWCAJKAIEIQEgAEEkEIYBIQQCQCABLQACIgNFDQAgAUECaiEIIAQoAgghCiABQQNqIQVBACECQQAhAQNAIAEgBWosAAAiBkUNASADwEECdEGA2SxqKAIAIgNBAEgNASAGQQJ0QYDZLGooAgAiBkEASA0BIAIgCmogA0EEdCAGcjoAACACQQFqIQIgCCABQQJqIgFqLQAAIgMNAAsLIARBIDYCACAAQX0QogEgAEGE0ykQWCAAIAkoAogIIgQQhgEhAgJAIARFDQAgCUEIaiEDIARBA3EhCEEAIQZBACEBIARBBE8EQCAEQXxxIQoDQCACKAIIIAFqIAEgA2otAAA6AAAgAUEBciIFIAIoAghqIAMgBWotAAA6AAAgAUECciIFIAIoAghqIAMgBWotAAA6AAAgAUEDciIFIAIoAghqIAMgBWotAAA6AAAgAUEEaiIBIApHDQALCyAIRQ0AA0AgAigCCCABaiABIANqLQAAOgAAIAFBAWohASAGQQFqIgYgCEcNAAsLIAIgBDYCACAAQX0QogEgAEHKvSkQWCAAQRQQhgEiASgCCCAJKAKMCCICLQAAOgAAIAEoAgggAi0AAToAASABKAIIIAItAAI6AAIgASgCCCACLQADOgADIAEoAgggAi0ABDoABCABKAIIIAItAAU6AAUgASgCCCACLQAGOgAGIAEoAgggAi0ABzoAByABKAIIIAItAAg6AAggASgCCCACLQAJOgAJIAEoAgggAi0ACjoACiABKAIIIAItAAs6AAsgASgCCCACLQAMOgAMIAEoAgggAi0ADToADSABKAIIIAItAA46AA4gASgCCCACLQAPOgAPIAEoAgggAi0AEDoAECABKAIIIAItABE6ABEgASgCCCACLQASOgASIAEoAgggAi0AEzoAEyABQRQ2AgAgAEF9EKIBIABBuYsrEFhBASELIAAgCSgCkAgiAhAnQQFqEIYBIgEoAgggAhD5ARogASABKAIEQQFrNgIAIABBfRCiASAAQfPDKxBYIAAgCSgClAgiBBCGASECAkAgBEUNACAJQZgIaiEDIARBA3EhCEEAIQZBACEBIARBBE8EQCAEQXxxIQoDQCACKAIIIAFqIAEgA2otAAA6AAAgAUEBciIFIAIoAghqIAMgBWotAAA6AAAgAUECciIFIAIoAghqIAMgBWotAAA6AAAgAUEDciIFIAIoAghqIAMgBWotAAA6AAAgAUEEaiIBIApHDQALCyAIRQ0AA0AgAigCCCABaiABIANqLQAAOgAAIAFBAWohASAGQQFqIgYgCEcNAAsLIAIgBDYCACAAQX0QogELIAdB7JIrNgIAIABB4IcqIAcQmwEgB0EwaiQAIAsLpMkDA1Z/F34TeyMAQeAAayIjJAAgI0G3+So2AkAgAEH5hiogI0FAaxCbASAAQQEQyAEhPyAAQQIQyAEhQCAAQQMQyAEhDSAAQQQQyAEhGSAAQQUQyAEhQSAAICNB2ABqEPYFITcgAEEHEMgBIUMgI0EANgJcAn8CfyAAKAIUKAIAQUBrIgcgACgCDE8EQCAAKAIQQSxqIQcLAkACQCAHLQAEQQNHBEAgByAjQdwAakEAEPwBIRIgIygCXCIHQQRKDQEgEg0CIABB67UqQQAQbkEADAMLIAcoAgAiB0EFSA0BCyAjIAc2AjAgAEHo3iogI0EwahBuQQAMAQsgB0HQAGxB4NUxagsiAigCSCIHICMoAlgiEkcEQCAjIAc2AiQgIyASNgIgIABByvorICNBIGoQbkEADAELAkACQEGkiDQoAgAiB0UEQEHEABAqIS0MAQsCQAJAIAcoAhRBxABJDQAgBygCBCItRQ0AIAcoAhgiEiASKAKQAkEBajYCkAIgByAHKAIcQQFqNgIcIAcgBygCIEHEAGo2AiAgByAHKAIsQcQAajYCLCAHIC0oAgA2AgQgByAHKAIIQQFrNgIIIAchEgwBCyAHIRJBxAAQKiItRQRAEE9BpIg0KAIAIRILIAcgBygCJEEBajYCJCAHIAcoAihBxABqNgIoIAcgBygCLEHEAGo2AiwgEkUNAQsCfwJAIBIoAhRBxABJDQAgEigCBCIuRQ0AIBIoAhgiByAHKAKQAkEBajYCkAIgEiASKAIcQQFqNgIcIBIgEigCIEHEAGo2AiAgEiASKAIsQcQAajYCLCASIC4oAgA2AgRBCCEDQX8MAQtBxAAQKiIuRQRAEE8LIBIgEigCJEEBajYCJCASIBIoAihBxABqNgIoQSwhA0HEAAshByADIBJqIhIgEigCACAHajYCAAwBC0HEABAqIS4LIC1BsPABOwAAIC1BAmohEiANKAIIIQNBACEHA0AgEiAHQQF0aiIWIAMgB2otAAAiFEEPcUHw0zFqLQAAOgABIBYgFEEEdkHw0zFqLQAAOgAAIBIgB0EBciIWQQF0aiIUIAMgFmotAAAiFkEPcUHw0zFqLQAAOgABIBQgFkEEdkHw0zFqLQAAOgAAIAdBAmoiB0EgRw0AC0EAIQcgLUEAOgBCIC5BsPABOwAAIC5BAmohEiAZKAIIIQMDQCASIAdBAXRqIhYgAyAHai0AACIUQQ9xQfDTMWotAAA6AAEgFiAUQQR2QfDTMWotAAA6AAAgEiAHQQFyIhZBAXRqIhQgAyAWai0AACIWQQ9xQfDTMWotAAA6AAEgFCAWQQR2QfDTMWotAAA6AAAgB0ECaiIHQSBHDQALIC5BADoAQiANEJoBIBkQmgECfyA/KAIIIRYgPygCACEJIEAoAgghGSBAKAIAIQwgQSgCCCEFIEEoAgAhFyAjKAJYISAgQygCCCEKICNB0ABqIUQjAEHwKWsiDSQAQQEhAwJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAW/REgGf0cASAtIhT9HAIgLiIS/RwD/QwAAAAAAAAAAAAAAAAAAAAA/Tf9DP//AAD//wAA//8AAP//AAD9TiAF/REgNyIH/RwBIAr9HAIgI0HUAGoiR/0cA/0MAAAAAAAAAAAAAAAAAAAAAP03/Qz//wAA//8AAP//AAD//wAA/U79hgH9Uw0AIAJFDQAgFCASIA1BwB5qIA1BoB5qEMgJRQRAQQFB+K0pQQAQmwlBAiEDDAELIA1B+BpqENAKIQ8gDUHgD2oQmAkhHEGAo8PHABCiCSI+QQBBgKPDxwD8CwACQCA+IBYgCRDRCiIDQYl/TwRAIA0gAxDSCjYCoAZBAUGbiyogDUGgBmoQmwlBAyEDDAELIANFBEBBAyEDDAELIA0gAzYCkAZB5ABB6sEpIA1BkAZqEJsJIA0gPjYC3A8gDUHcD2ogAxDTCiIyRQRAQQFByrkrQQAQmwlBAyEDDAELAkAgDUHcD2ogAyA+aiANKALcD2sQ1AoiM0UEQEEBQam5K0EAEJsJQQQhAwwBC0HkAEG9uCtBABCbCSAyKAIUIQMgDUEANgLYDyANQgA3AtAPIA0gAzYCzA8gDUEBNgLIDwJ/AkACQAJAIAMEQCADQYCAgMAATw0BIA0gA0EFdCIDEKIJIhQ2AtAPIA0gAyAUaiISNgLYDyADBEAgFEEAIAP8CwALIA0gEjYC1A8LIDMoAhQhAyANQQA2AsQPIA1CADcCvA8gDSADNgK4DyANQQE2ArQPIAMEQCADQYCAgIABTw0CIA0gA0EEdCIDEJ4JIhQ2ArwPIA0gAyAUaiISNgLEDyADBEAgFEEAIAP8CwALIA0gEjYCwA8LIA1BADYCrA8gDSANQcgPajYCsA8gDUEANgKkDyANIA1BtA9qNgKoDyANQajNMTYCoA8gDUHgDWoiBEEAQcAB/AsAQcDeARCiCSIWICA2AqwSIBYgHDYCBCAWQaCTNDYCACAW/QwAAAAAAAAAAAAAAAAAAAAA/QsDiN4BIBZBmN4Bav0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgFkGo3gFqQQA2AgAgFkGwEmoiBkEAQcgA/AsAQdCJBBCeCSIBQaCTNDYCtIQCIAFB+I00NgKwhAIgAUGgkzQ2AowBIAFB+I00NgKIASABIBw2AgQgAUGgkzQ2AgBBoJM0KAIAIQMgAUGQiARq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQYCIBGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFB8IcEav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBOCHBCABIBw2AqSIBCABIAM2AqCIBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEsIgEIAFBwIgEav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAUHQiARq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQeCIBGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAEgHDYC9IgEIAEgAzYC8IgEIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwSAiQQgAUGQiQRq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQaCJBGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAFBsIkEav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgASAcNgLEiQQgASADNgLAiQQgDUGkD2ogByAgIAogHBCcCSANKAKkDyIUIA0oAqgPIgMoAgRPDRQgAygCCCAUQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFEEBaiISIAMoAgRPDRQgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFEECaiISIAMoAgRPDRQgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFEEDaiISIAMoAgRPDRQgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFEEEaiISIAMoAgRPDRQgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFEEFaiISIAMoAgRPDRQgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFEEGaiISIAMoAgRPDRQgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDSAUQQdqNgKkDyAgDQIgFiAZIAxBAEEAIAoQrQkMAwsQoAkACxCgCQALICBB487YE08NBEEAIQMgIEHoAGwiFBCiCSELIBQgFEHoAGtB6ABwayIUBEAgC0EAIBT8CwALA0AgCyADQegAbCISaiIUIAcgEmoiEigCYCICNgJgIBQgEigCZCIJNgJkIAIEQCAUIBIgAvwKAAALIAkEQCAUQSBqIBJBIGogCfwKAAALIANBAWoiAyAgRw0ACyAWIBkgDCALICAgChCtCQshAyABQbCEAmohDiABQYgBaiEQIA1B8CBqQQA2AgAgDUHgIGr9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIA39DAAAAAAAAAAAAAAAAAAAAAD9CwLQICANQeAeaiAMIBkQrgkiFARAIA1B8ApqIA0oAuggIgcgDSgC7CAgB2sQqAkgASgCACgCACEHIA1BgAlqIhIgDUGAC2oiCv0AAwD9CwMAIA0gDf0AA/AK/QsD8AggByANQfAIaiAHQUBrEKQJIAEgEv0AAwD9CwMYIAEgDf0AA/AI/QsDCCANIBkgDSgCgB9qIgf9AAAQ/QwAAAAAAAAAAAAAAAAAAAAA/Q0PDg0MCwoJCAcGBQQDAgEA/QsEsAYgDUHABmoiAiAH/QAAAP0MAAAAAAAAAAAAAAAAAAAAAP0NDw4NDAsKCQgHBgUEAwIBAP0LBAAgDSAHIA0oAoQfQQF2aiIH/QAAEP0MAAAAAAAAAAAAAAAAAAAAAP0NDw4NDAsKCQgHBgUEAwIBAP0LBJAHIAf9AAAAIW4gDSANQdAeav0AAwD9CwPgBSANQaAHaiIHIG79DAAAAAAAAAAAAAAAAAAAAAD9DQ8ODQwLCgkIBwYFBAMCAQD9CwQAIA0gDf0AA8Ae/QsD0AUgDSANQbAeav0AAwD9CwPABSANIA39AAOgHv0LA7AFIA0gCv0AAwD9CwOgBSANIA39AAPwCv0LA5AFIA0gAv0ABAD9CwOABSANIA39AASwBv0LA/AEIA0gB/0ABAD9CwPgBCANIA39AASQB/0LA9AEIBAgDUHQBWogDUGwBWogDUGQBWogDUHwBGogDUHQBGoQvgkgDUHAC2ogBSAXIA0oAtwgIA0oAuAgEKMJIA0gGSANKAKUH2oiB/0AABD9DAAAAAAAAAAAAAAAAAAAAAD9DQ8ODQwLCgkIBwYFBAMCAQD9CwSADCANQZAMaiICIAf9AAAA/QwAAAAAAAAAAAAAAAAAAAAA/Q0PDg0MCwoJCAcGBQQDAgEA/QsEACANIAcgDSgCmB9BAXZqIgf9AAAQ/QwAAAAAAAAAAAAAAAAAAAAA/Q0PDg0MCwoJCAcGBQQDAgEA/QsE8AggEiAH/QAAAP0MAAAAAAAAAAAAAAAAAAAAAP0NDw4NDAsKCQgHBgUEAwIBAP0LBAAgGSANKALsHmpBBWoiCSANKAKMIGoiDP0AABAhbiABKAIAIhkoAgAhCiANQcAIaiIHIAz9AAAA/QwAAAAAAAAAAAAAAAAAAAAA/Q0PDg0MCwoJCAcGBQQDAgEA/QsEACANIG79DAAAAAAAAAAAAAAAAAAAAAD9DQ8ODQwLCgkIBwYFBAMCAQD9CwSwCCAKIA1BsAhqIApBQGsQpAkgAUHYAGoiDCAH/QAEAP0LAwAgASAN/QAEsAj9CwNIIAkgDSgCoCBqIgn9AAAQIW4gGSgCACEKIAcgCf0AAAD9DAAAAAAAAAAAAAAAAAAAAAD9DQ8ODQwLCgkIBwYFBAMCAQD9CwQAIA0gbv0MAAAAAAAAAAAAAAAAAAAAAP0NDw4NDAsKCQgHBgUEAwIBAP0LBLAIIAogDUGwCGogCkFAaxCkCSABQfgAaiIKIAf9AAQA/QsDACABIA39AASwCP0LA2ggGSgCACEZIAcgDUHQC2oiCf0AAwD9CwMAIA0gDf0AA8AL/QsDsAggGSANQbAIaiAZQUBrEKQJIAEgB/0AAwD9CwM4IAEgDf0AA7AI/QsDKCANIAz9AAMA/QsDwAQgDSAB/QADSP0LA7AEIA0gCv0AAwD9CwOgBCAB/QADaCFuIA0gCf0AAwD9CwOABCANIG79CwOQBCANIA39AAPAC/0LA/ADIA0gAv0ABAD9CwPgAyANIA39AASADP0LA9ADIA0gEv0ABAD9CwPAAyANIA39AATwCP0LA7ADIA4gDUGwBGogDUGQBGogDUHwA2ogDUHQA2ogDUGwA2oQvgkLIA0oAuggIgcEQCANIAc2AuwgIAcQKwsgDSgC3CAiBwRAIA0gBzYC4CAgBxArCyANKALQICIHBEAgDSAHNgLUICAHECsLIAMgFHEiCARAIAFBgIkEaiERIAFBsIgEaiEVIAFB4IcEaiEMIA1BrA9qIA1BwB5qIA1BoB5qIAFBKGoQoQkgDSgCrA8hByANKAKwDyEDA0AgByADKAIETw0GIAMoAgggB0EFdGoiFEGYiTT9AAMA/QsDACAUQaiJNP0AAwD9CwMQIAdBAWoiFCADKAIETw0GIAMoAgggFEEFdGoiFEGYiTT9AAMA/QsDACAUQaiJNP0AAwD9CwMQIAdBAmohByBXQgJ8IldCgAFSDQALQgAhVwNAIAcgAygCBE8NBiADKAIIIAdBBXRqIhRBmIk0/QADAP0LAwAgFEGoiTT9AAMA/QsDECAHQQFqIhQgAygCBE8NBiADKAIIIBRBBXRqIhRBmIk0/QADAP0LAwAgFEGoiTT9AAMA/QsDECAHQQJqIQcgV0ICfCJXQoABUg0AC0IAIVcDQCAHIAMoAgRPDQYgAygCCCAHQQV0aiIUQZiJNP0AAwD9CwMAIBRBqIk0/QADAP0LAxAgB0EBaiIUIAMoAgRPDQYgAygCCCAUQQV0aiIUQZiJNP0AAwD9CwMAIBRBqIk0/QADAP0LAxAgB0ECaiEHIFdCAnwiV0KAAVINAAtCACFXA0AgByADKAIETw0GIAMoAgggB0EFdGoiFEGYiTT9AAMA/QsDACAUQaiJNP0AAwD9CwMQIAdBAWoiFCADKAIETw0GIAMoAgggFEEFdGoiFEGYiTT9AAMA/QsDACAUQaiJNP0AAwD9CwMQIAdBAmohByBXQgJ8IldCgAFSDQALQgAhVwNAIAcgAygCBE8NBiADKAIIIAdBBXRqIhRBmIk0/QADAP0LAwAgFEGoiTT9AAMA/QsDECAHQQFqIhQgAygCBE8NBiADKAIIIBRBBXRqIhRBmIk0/QADAP0LAwAgFEGoiTT9AAMA/QsDECAHQQJqIQcgV0ICfCJXQoABUg0AC0IAIVcDQCAHIAMoAgRPDQYgAygCCCAHQQV0aiIUQZiJNP0AAwD9CwMAIBRBqIk0/QADAP0LAxAgB0EBaiIUIAMoAgRPDQYgAygCCCAUQQV0aiIUQZiJNP0AAwD9CwMAIBRBqIk0/QADAP0LAxAgB0ECaiEHIFdCAnwiV0KAAVINAAtCACFXA0AgByADKAIETw0GIAMoAgggB0EFdGoiFEGYiTT9AAMA/QsDACAUQaiJNP0AAwD9CwMQIAdBAWoiFCADKAIETw0GIAMoAgggFEEFdGoiFEGYiTT9AAMA/QsDACAUQaiJNP0AAwD9CwMQIAdBAmohByBXQgJ8IldCgAFSDQALIA0gBzYCrA8gDUHwHmogFkEYaiIU/QADAP0LBAAgDSAW/QADCP0LBOAeIA1BkB9qIBZBOGoiEv0AAwD9CwQAIA0gFv0AAyj9CwSAHyANQbAfaiAWQdgAaiIZ/QADAP0LBAAgDSAW/QADSP0LBKAfQQAhByANQcAfakEAQcAB/AsAIA1BgA1qIA1B4B5qQaAC/AoAACANQeAeahCYCRpB4AAQogkiA0EAQeAA/AsAIA1BoA9qIANB4AAgDSgCoA8oAggRAQAgBCADQeAA/AoAACADECsgDUGACWogFP0AAwD9CwQAIA0gFv0AAwj9CwTwCCANQaAJaiAS/QADAP0LBAAgDSAW/QADKP0LBJAJIA1BwAlqIBn9AAMA/QsEACANIBb9AANI/QsEsAkgDUHADmohEwNAIA1BgAxqQbCINCAHQQV0IhIgDUHwCGpqIgP9AAQAIAP9AAQQEJkJIA0gDf0AA4AM/QsEkAcgDSAN/QADkAz9CwSgByAMIAdB0ABsaiIDIA39AASQB/0LBCAgAyAEIBJqIhT9AAQA/QsEACADIA39AASgB/0LBDAgAyAU/QAEEP0LBBAgEiATaiIDIBT9AAQA/QsEACADIBT9AAQQ/QsEECANQaQPaiANQZAHakEgQSAgHBCdCSAHQQFqIgdBA0cNAAsgDSgCpA8iAyANKAKoDyIHKAIETw0GIAcoAgggA0EEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFigCBCIU/QAEMCAWLACoEiIZrUL/AYMiV0IBg1Ab/QsEACADQQFqIhIgBygCBE8NBiAHKAIIIBJBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFdCAoNQG/0LBAAgA0ECaiISIAcoAgRPDQYgBygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBXQgSDUBv9CwQAIANBA2oiEiAHKAIETw0GIAcoAgggEkEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgV0IIg1Ab/QsEACADQQRqIhIgBygCBE8NBiAHKAIIIBJBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFdCEINQG/0LBAAgA0EFaiISIAcoAgRPDQYgBygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBXQiCDUBv9CwQAIANBBmoiEiAHKAIETw0GIAcoAgggEkEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgV0LAAINQG/0LBAAgA0EHaiISIAcoAgRPDQYgBygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCAZQQBOG/0LBAAgFkHoAGohAiADQQhqIQNBEiESA0AgAyAHKAIETw0IIAcoAgggA0EEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFigCBCIU/QAEMCACIBJqLAAAIgqtQv8BgyJXQgGDUBv9CwQAIANBAWoiGSAHKAIETw0IIAcoAgggGUEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgV0ICg1Ab/QsEACADQQJqIhkgBygCBE8NCCAHKAIIIBlBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFdCBINQG/0LBAAgA0EDaiIZIAcoAgRPDQggBygCCCAZQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBXQgiDUBv9CwQAIANBBGoiGSAHKAIETw0IIAcoAgggGUEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgV0IQg1Ab/QsEACADQQVqIhkgBygCBE8NCCAHKAIIIBlBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFdCIINQG/0LBAAgA0EGaiIZIAcoAgRPDQggBygCCCAZQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBXQsAAg1Ab/QsEACADQQdqIhkgBygCBE8NCCAHKAIIIBlBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIApBAE4b/QsEACADQQhqIQMgEkEBaiISQcARRw0ACyANIAM2AqQPIBZB+BJqIQNBACEHA0AgFigCBCANQaQPaiADIAdB4AVsahC1CSAHQQFqIgdBI0cNAAsgFigCBCEUIBY1AujcASFYQgAhVyANKAKkDyEHIA0oAqgPIQMDQCAHIAMoAgRPDQkgAygCCCAHQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBYIFeIIllCAYNQG/0LBAAgB0EBaiISIAMoAgRPDQkgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBZQgKDUBv9CwQAIAdBAmohByBXQgJ8IldCDFINAAsgFigCBCEUIBY1AvzcASFYQgAhVwNAIAcgAygCBE8NCiADKAIIIAdBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFggV4giWUIBg1Ab/QsEACAHQQFqIhIgAygCBE8NCiADKAIIIBJBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFlCAoNQG/0LBAAgB0ECaiEHIFdCAnwiV0IMUg0ACyAWKAIEIRQgFjUCkN0BIVhCACFXA0AgByADKAIETw0LIAMoAgggB0EEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgWCBXiCJZQgGDUBv9CwQAIAdBAWoiEiADKAIETw0LIAMoAgggEkEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgWUICg1Ab/QsEACAHQQJqIQcgV0ICfCJXQgxSDQALIBYoAgQhFCAWNQLg3QEhWEIAIVcDQCAHIAMoAgRPDQwgAygCCCAHQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBYIFeIIllCAYNQG/0LBAAgB0EBaiISIAMoAgRPDQwgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBZQgKDUBv9CwQAIAdBAmohByBXQgJ8IldCDFINAAsgDSAHNgKkDyAWKAKsEgRAQQAhCQNAIA0oAqQPIQMgDSgCqA8hByAJQQxsIQJBACESA0AgAyAHKAIETw0PIAcoAgggA0EEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFigCBCIU/QAEMCAWKAKwEiACaigCACASaiwAACIKrUL/AYMiV0IBg1Ab/QsEACADQQFqIhkgBygCBE8NDyAHKAIIIBlBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFdCAoNQG/0LBAAgA0ECaiIZIAcoAgRPDQ8gBygCCCAZQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBXQgSDUBv9CwQAIANBA2oiGSAHKAIETw0PIAcoAgggGUEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgV0IIg1Ab/QsEACADQQRqIhkgBygCBE8NDyAHKAIIIBlBBHRq/QwAAAAAAAAAAAAAAAAAAAAAIBT9AAQwIFdCEINQG/0LBAAgA0EFaiIZIAcoAgRPDQ8gBygCCCAZQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBXQiCDUBv9CwQAIANBBmoiGSAHKAIETw0PIAcoAgggGUEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgFP0ABDAgV0LAAINQG/0LBAAgA0EHaiIZIAcoAgRPDQ8gBygCCCAZQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCAKQQBOG/0LBAAgA0EIaiEDIBJBAWoiEkGAAUcNAAsgDSADNgKkDyAWKAIEIA1BpA9qIBYoArwSIAJqKAIAELUJIBYoAgQgDUGkD2ogFigCvBIgAmooAgBB4AVqELUJIBYoAtQSIAlBFGxqNQIEIVggFigCBCEUQgAhVyANKAKkDyEHIA0oAqgPIQMDQCAHIAMoAgRPDRAgAygCCCAHQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBYIFeIIllCAYNQG/0LBAAgB0EBaiISIAMoAgRPDRAgAygCCCASQQR0av0MAAAAAAAAAAAAAAAAAAAAACAU/QAEMCBZQgKDUBv9CwQAIAdBAmohByBXQgJ8IldCDFINAAsgDSAHNgKkDyAWIA1BpA9qIAlBA3QiByAWKALgEmoQtgkgFiANQaQPaiAWKALsEiAHahC2CSAJQQFqIgkgFigCrBJJDQALCyATIA1BpA9qELEJIA1B4A5qIA1BpA9qELEJIA1BgA9qIA1BpA9qELEJIA0oAqwPIgMgDSgCsA8iBygCBE8NDiAHKAIIIANBBXRqIhQgAf0AAwj9CwMAIBQgAf0AAxj9CwMQIANBAWoiFCAHKAIETw0PIAcoAgggFEEFdGoiFCAB/QADSP0LAwAgFCAB/QADWP0LAxAgA0ECaiIUIAcoAgRPDRAgDSADQQNqNgKsDyAHKAIIIBRBBXRqIgcgAf0AA2j9CwMAIAcgAf0AA3j9CwMQIBAgDUGsD2oQsgkgDiANQawPahCyCSAMIA1BrA9qELMJIBUgDUGsD2oQswkgESANQawPahCzCQsgCwRAIAsQKwsgARArIBYoAqDeASIHBEAgFiAHNgKk3gEgBxArCyAWQYjeAWohAyAWKAKU3gEiBwRAIBYgBzYCmN4BIAcQKwsgAygCACIHBEAgFiAHNgKM3gEgBxArCyAWKALsEiIHBEAgFiAHNgLwEiAHECsLIBYoAuASIgcEQCAWIAc2AuQSIAcQKwsgFigC1BIiBwRAIBYgBzYC2BIgBxArCyAWKALIEiIHBEAgFiAHNgLMEiAHECsLIBYoArwSIhIEQCASIgcgFigCwBIiA0cEQANAIANBDGsiBygCACIUBEAgA0EIayAUNgIAIBQQKwsgEiAHIgNHDQALIBYoArwSIQcLIBYgEjYCwBIgBxArCyAGKAIAIhIEQCASIgcgFigCtBIiA0cEQANAIANBDGsiBygCACIUBEAgA0EIayAUNgIAIBQQKwsgEiAHIgNHDQALIAYoAgAhBwsgFiASNgK0EiAHECsLIBYQKwJAIAhFBEBBAUHfuytBABCbCUEFIQMMAQsgDUGADGogBSAXENUKIQcgDUHAC2ogDygCAEGAzDEQ1gogDUHgC2oiAyAPKAIAQdDMMRDWCiANQagLaiANQfALav0AAwD9CwMAIA1BmAtqIAP9AAMA/QsDACANQYgLaiANQdALav0AAwD9CwMAIA0gDf0AA8AL/QsD+AogDUKAgICACDcDuAsgDSAPNgL0CiANQbCINDYC8AogDUGwiDQ2AuwKIA0gDUHwCmo2AugKIA0gHDYC5AogDUHgHmogMxDXCiEUIA1B8AhqIDIQ2AohEgJ/IA1BsAhqIgogMyIBNgIEIAogHCIWNgIAIAEoAhghAiABKAIUIQMgCiANQeQKajYCECAKIBY2AgwgCiADIAJrIgk2AgggASgCECEBIApBADYCHCAKQgA3AhQCQAJAIAEEQCABQebgKE8NASAKIAFBoDJsIhkQngkiFjYCFCAKIBYgGWo2AhwgGUGgMmsiGSAZQaAycGtBoDJqIhkEQCAWQQAgGfwLAAsgCiAWIBlqNgIYCyAKQQA2AiggCkIANwIgIAIgA0cEQCAJQYCAgIABTw0CIAogCUEEdCIWEJ4JIgI2AiAgCiACIBZqIgM2AiggFgRAIAJBACAW/AsACyAKIAM2AiQLIApBADYCNCAKQgA3AiwgAQRAIAogAUEMbCIWEKIJIgE2AiwgCiABIBZqNgI0IBZBDGsiFiAWQQxwa0EMaiIWBEAgAUEAIBb8CwALIAogASAWajYCMAsgCkEANgI4IAoMAgsQoAkACxCgCQALIRYCfyANQfQHaiIKIDIiATYCBCAKQbCINDYCACABKAIYIRkgASgCFCEJIAogDUHoCmo2AhAgCkGwiDQ2AgwgCiAJIBlrIgw2AgggASgCECEBIApBADYCHCAKQgA3AhQCQAJAIAEEQCABQbOwFE8NASAKIAFBwOQAbCICEKIJIgM2AhQgCiACIANqNgIcIAJBwOQAayICIAJBwOQAcGtBwOQAaiICBEAgA0EAIAL8CwALIAogAiADajYCGAsgCkEANgIoIApCADcCICAJIBlHBEAgDEGAgIDAAE8NAiAKIAxBBXQiGRCiCSIJNgIgIAogCSAZaiIDNgIoIBkEQCAJQQAgGfwLAAsgCiADNgIkCyAKQQA2AjQgCkIANwIsIAEEQCAKIAFBDGwiGRCiCSIBNgIsIAogASAZajYCNCAZQQxrIhkgGUEMcGtBDGoiGQRAIAFBACAZ/AsACyAKIAEgGWo2AjALIApBADYCOCAKDAILEKAJAAsQoAkACyEZIA1BtA9qIQUgDUGgD2ohF0EAIQNBACEPIwBBgAFrIgkkAEHkAEGq0SlBABCbCSAWIgEoAggEQANAIANBBHQiDCABKAIgaiAFKAIIIAxqIAEoAgQoAhhBBHRq/QAEAP0LBAAgA0EBaiIDIAEoAghJDQALCyABKAIEIgwoAhghCCAMKAIcIRACQCAMKAIQRQ0AIAFBIGohAwNAQQAhCyAMKAIMBEADQCAXIAlB4ABqQRAgFygCACgCCBEBACAJIAn9AARg/QsEQCALQQZ0IgUgD0GgMmwiDCABKAIUamogCf0ABED9CwQAIAMgCUFAaxD+CSABKAIUIAxqIAVq/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAXIAlB4ABqQRAgFygCACgCCBEBACAJIAn9AARg/QsEQCABKAIUIAxqIAVqIAn9AARA/QsEICADIAlBQGsQ/gkgFyAJQeAAakEQIBcoAgAoAggRAQAgCSAJ/QAEYP0LBEAgASgCFCAMaiAFaiAJ/QAEQP0LBDAgAyAJQUBrEP4JIAtBAWoiCyABKAIEIgwoAgxJDQALC0EAIQsgD0EMbCIGIAwoAiBqKAIEBEADQCAXIAlB4ABqQRAgFygCACgCCBEBACAJIAn9AARg/QsEQCALQTBsIgUgD0GgMmwiDCABKAIUamogCf0ABED9CwSAFCADIAlBQGsQ/gkgASgCFCAMaiAFakGQFGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIBcgCUHgAGpBECAXKAIAKAIIEQEAIAkgCf0ABGD9CwRAIAEoAhQgDGogBWogCf0ABED9CwSgFCADIAlBQGsQ/gkgFyAJQeAAakEQIBcoAgAoAggRAQAgCSAJ/QAEYP0LBEAgASgCFCAMaiAFaiAJ/QAEQP0LBIAjIAMgCUFAaxD+CSABKAIUIAxqIAVqQZAjav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgFyAJQeAAakEQIBcoAgAoAggRAQAgCSAJ/QAEYP0LBEAgASgCFCAMaiAFaiAJ/QAEQP0LBKAjIAMgCUFAaxD+CSALQQFqIgsgASgCBCgCICAGaigCBEkNAAsLIBcgCUHgAGpBECAXKAIAKAIIEQEAIAkgCf0ABGD9CwRAIA9BoDJsIgwgASgCFGogCf0ABED9CwSAMiADIAlBQGsQ/gkgFyAJQeAAakEQIBcoAgAoAggRAQAgCSAJ/QAEYP0LBEAgASgCFCAMaiAJ/QAEQP0LBJAyIAMgCUFAaxD+CSAJIAEoAhQgDGoiDP0ABIAyIAz9AASQMhCaCf0LBGAgAyAJQeAAahD+CSAPQQFqIg8gASgCBCIMKAIQIgVJDQALIAVFDQAgASgCLCELIAwoAiAhDyABKAIIIQxBACEDIAVBAUcEQCAFQQFxIREgBUF+cSEOA0AgCyADQQxsIgZqIgUgBiAPaigCBEECdCAMaiIMNgIAIAUgDEECajYCCCAFIAxBAWo2AgQgCyADQQFyQQxsIgZqIgUgDCAGIA9qKAIEQQJ0aiIMQQVqNgIIIAUgDEEEajYCBCAFIAxBA2o2AgAgDEEGaiEMIANBAmoiAyAORw0ACyARRQ0BCyALIANBDGwiBWoiAyAFIA9qKAIEQQJ0IAxqIgw2AgAgAyAMQQJqNgIIIAMgDEEBajYCBAtB/AAQogkiAyAUQRBqQdAA/AoAACADQdAAaiAUKAIgIBQoAihrENwKIBQoAiAhDCAUKAJEIQUgA0EANgJ4IANCADcCcAJAAkAgBSAMbCIMBEAgDEGAgICAAU8NASADIAxBBHQiDBCeCSIFNgJwIAMgBSAMaiILNgJ4IAwEQCAFQQAgDPwLAAsgAyALNgJ0CyABKAI4IQwgASADNgI4IBAgCGsiBSAQSyELIAwEQCAMKAJwIgMEQCAMIAM2AnQgAxArCyAMKAJkIgMEQCAMIAM2AmggAxArCyAMKAJYIgMEQCAMIAM2AlwgAxArCyAMECsgASgCOCEDC0EAIAUgCxshFSABKAIMIQwgASgCECEYIAEoAiwhGyABKAIgIRECQCAIIBBJBEAgDEGwAmohDyAMQbAFaiELQQAhBgNAIAkgESAGQQR0av0ABAAibv0LBGAgbv0dASFXIG79HQAhWEEAIQEDQAJAIAsgAUECdGooAgAiBUH/AEsNACAJQeAAaiAFQQN2Qfj///8BcWopAwAgBUE/ca2IQgGDUA0AIAkgDyABQQR0aiIFKQMAIFiFIlg3A2AgCSAFKQMIIFeFIlc3A2gLIAFBAWoiAUEQRw0ACyBXIFiEQgBSDQIgBkEBaiIGIBVHDQALCyADKQIQIVcgGCgCACEBQaAgEJ4JIg8gV0IgiTcCBCAPIAE2AgAgD0EQaiABEN0KIAMoAjwhBSADKAIUIgsEQEEAIQEDQCAXIAlB4ABqQRAgFygCACgCCBEBACADKAJwIAMoAhAgBWxBBHRqIAFBBHRqIAn9AARg/QsEACABQQFqIgEgC0cNAAsgAygCPCEFCyAPIAMoAnAgAygCECAFbEEEdGoQ3gogDxArIBgoAgAhASADKAIYIQUgAygCECELQaAgEJ4JIgogCzYCCCAKIAU2AgQgCiABNgIAIApBEGogARDdCiADKAJAIQUgAygCGCILBEBBACEBA0AgFyAJQeAAakEQIBcoAgAoAggRAQAgAygCcCADKAIQIAVsQQR0aiABQQR0aiAJ/QAEYP0LBAAgAUEBaiIBIAtHDQALIAMoAkAhBQsgAygCcCADKAIQIAVsQQR0aiADKAIgQQR0aiELAkAgAygCJCICRQRA/QwAAAAAAAAAAAAAAAAAAAAAIW4MAQsgAkEDcSEGQQAhDwJ/IAJBBEkEQP0MAAAAAAAAAAAAAAAAAAAAACFuQQAMAQsgC0EwaiEOIAtBIGohECALQRBqIQggAkF8cSET/QwAAAAAAAAAAAAAAAAAAAAAIW5BACEFA0AgDiAFQQR0IgFq/QAEACABIBBq/QAEACABIAhq/QAEACABIAtq/QAEACBu/VH9Uf1R/VEhbiAFQQRqIgUgE0cNAAsgAkF8cQshASAGRQ0AA0AgCyABQQR0av0ABAAgbv1RIW4gAUEBaiEBIA9BAWoiDyAGRw0ACwsgCyAL/QAEACBu/VH9CwQAIAogAygCcCADKAIQIAMoAkBsQQR0ahDeCiADKAJEIQUgAygCGCILBH9BACEBA0AgFyAJQeAAakEQIBcoAgAoAggRAQAgAygCcCADKAIQIAVsQQR0aiABQQR0aiAJ/QAEYP0LBAAgAUEBaiIBIAtHDQALIAMoAkQFIAULIAMoAhBsIQEgAygCcCEFIAogAygCJCILBH8gC0EEdCILBEAgBSABQQR0aiADKAIgQQR0akEAIAv8CwALIAMoAnAhBSADKAIQIAMoAkRsBSABC0EEdCAFahDeCiAKECsgAykCECFXIBgoAgAhAUGgIBCeCSIaIFdCIIk3AgQgGiABNgIAIBpBEGogARDdCiADKAIoBEBBACEKA0AgAygCSCAKaiEPIAMoAiAhCwJAIBUgCkEBaiICIAMoAiRsTwRAQQAhASALRQ0BA0AgFyAJQeAAakECIBcoAgAoAggRAQAgCSwAYCIGrSJYQv8BgyFXIFhCAYNQBHv9DAAAAAAAAAAAAAAAAAAAAAAFIAz9AAQwCyFuIAksAGEhBSBXQgKDQgBSBEAgDP0ABEAgbv1RIW4LIFdCBINCAFIEQCAM/QAEUCBu/VEhbgsgV0IIg0IAUgRAIAz9AARgIG79USFuCyBXQhCDQgBSBEAgDP0ABHAgbv1RIW4LIFdCIINCAFIEQCAM/QAEgAEgbv1RIW4LIAWtIVggV0LAAINCAFIEQCAM/QAEkAEgbv1RIW4LIFhC/wGDIVcgBkEASARAIAz9AASgASBu/VEhbgsgV0IBg6cEQCAM/QAEsAEgbv1RIW4LIFdCAoNCAFIEQCAM/QAEwAEgbv1RIW4LIFdCBINCAFIEQCAM/QAE0AEgbv1RIW4LIFdCCINCAFIEQCAM/QAE4AEgbv1RIW4LIFdCEINCAFIEQCAM/QAE8AEgbv1RIW4LIFdCIINCAFIEQCAM/QAEgAIgbv1RIW4LIFdCwACDQgBSBEAgDP0ABJACIG79USFuCyADKAJwIAMoAhAgD2xBBHRqIAFBBHRqIAVBAEgEeyAM/QAEoAIgbv1RBSBuC/0LBAAgAUEBaiIBIAtHDQALDAELQQAhASALRQ0AA0AgFyAJQeAAakEQIBcoAgAoAggRAQAgAygCcCADKAIQIA9sQQR0aiABQQR0aiAJ/QAEYP0LBAAgAUEBaiIBIAtHDQALCyADKAIQIAMoAkggCmpsIQEgAygCcCEFIAMoAiAhDyADKAIkIgsEfyALQQR0IgsEQCAFIAFBBHRqIA9BBHRqQQAgC/wLAAsgAygCECADKAJIIApqbCEBIAMoAnAhBSADKAIgIQ8gAygCJAVBAAshCyAaIAMoAgAgCiALbCIQayIGIAsgBiALSRsiDgR/IAUgAUEEdGogD0EEdGohBSARIBBBBHRqIQsgDkEDcSEIQQAhBkEAIQEgDkEETwRAIA5BfHEhEwNAIAUgAUEEdCIPaiALIA9q/QAEAP0LBAAgBSAPQRByIg5qIAsgDmr9AAQA/QsEACAFIA9BIHIiDmoiECALIA5qIg4pAwA3AwAgECAOKQMINwMIIAUgD0EwciIPaiIOIAsgD2oiDykDCDcDCCAOIA8pAwA3AwAgAUEEaiIBIBNHDQALCyAIBEADQCAFIAFBBHQiD2ogCyAPav0ABAD9CwQAIAFBAWohASAGQQFqIgYgCEcNAAsLIAMoAnAhBSADKAIQIAMoAkggCmpsBSABC0EEdCAFahDeCiACIgogAygCKEkNAAsLIBoQKyADKQIQIVcgGCgCACEBQaAgEJ4JIhMgV0IgiTcCBCATIAE2AgAgE0EQaiABEN0KIAMoAiwiAQRAIAEgAygCTCIKaiICIAFqIRVBACEOA0AgCiAOaiEFQQAhAQJ/AkAgAygCICILRQRAIAIgDmohCwwBCwNAIBcgCUHgAGpBECAXKAIAKAIIEQEAIAMoAnAgAygCECAFbEEEdGogAUEEdGogCf0ABGD9CwQAIAFBAWoiASALRw0ACyACIA5qIQtBACEBIAMoAiAiD0UNAANAIBcgCUHgAGpBECAXKAIAKAIIEQEAIAMoAnAgAygCECALbEEEdGogAUEEdGogCf0ABGD9CwQAIAFBAWoiASAPRw0ACyAOIBVqIQ9BACIBIAMoAiAiBkUNARoDQCAXIAlB4ABqQRAgFygCACgCCBEBACADKAJwIAMoAhAgD2xBBHRqIAFBBHRqIAn9AARg/QsEACABQQFqIgEgBkcNAAsgAygCIAwBCyAOIBVqIQ9BAAshAQJAIAMoAiQiBkUNACAGQQR0IgYEQCADKAJwIAMoAhAgBWxBBHRqIAFBBHRqQQAgBvwLAAsgAygCJCIBRQ0AIAFBBHQiAQRAIAMoAnAgAygCECALbEEEdGogAygCIEEEdGpBACAB/AsACyADKAIkIgFFDQBBACEGIAFBBHQiAQRAIAMoAnAgAygCECAPbEEEdGogAygCIEEEdGpBACAB/AsACyADKAIkIgFFDQADQCABIA5sIAZqIgEgAygCBE8NASARIBsgAUEMbGoiASgCCEEEdGr9AAQAIBEgASgCAEEEdGoiCP0ABAAgESABKAIEQQR0av0ABAAQmgn91gEibv0dACBu/R0Bg6dBAXEEQCAGQQR0IhAgAygCcCADKAIQIAVsQQR0amogAygCIEEEdGogCP0ABAD9CwQAIAMoAnAgAygCECALbEEEdGogEGogAygCIEEEdGogESABKAIEQQR0av0ABAD9CwQAIAMoAnAgAygCECAPbEEEdGogEGogAygCIEEEdGogESABKAIIQQR0av0ABAD9CwQAIAZBAWoiBiADKAIkIgFJDQEMAgsLIAlB2u4pNgIQQeQAQfSHKiAJQRBqEJsJQZCWNCgCACgCACEXIAlB2u4pNgIAIBdBkYwqIAkQbAALIBMgAygCcCADKAIQIAVsQQR0ahDeCiATIAMoAnAgAygCECALbEEEdGoQ3gogEyADKAJwIAMoAhAgD2xBBHRqEN4KIA5BAWoiDiADKAIsSQ0ACwsgExArIAkgDDYCSCAJQcTSMTYCQCAJIAM2AkQgCSAJQUBrNgJQIAlB4ABqIANB0ABqIAlBQGsgFxDfCkEQIQMgFEHgAGoiASAJ/QAAcP0LABAgASAJ/QAAYP0LAAACQCAJKAJQIhcgCUFAa0cEQEEUIQMgF0UNAQsgFyAXKAIAIANqKAIAEQYACyAHIAFBIBDZCkHkAEGIjStBABCbCSAJQYABaiQADAILIAlBjK4rNgIwQeQAQfSHKiAJQTBqEJsJQZCWNCgCACgCACEXIAlBjK4rNgIgIBdBkYwqIAlBIGoQbAALEKAJAAsgDUHID2ohAyANQaAPaiEIQQAhCUEAIQ8jAEGAAWsiCyQAQeQAQarRKUEAEJsJIBkiASgCCARAA0AgCUEFdCIFIAEoAiBqIgwgAygCCCAFaiABKAIEKAIYQQV0aiIF/QADAP0LAwAgDCAF/QADEP0LAxAgCUEBaiIJIAEoAghJDQALCyABKAIEIgkoAhghCiAJKAIcIR4CQCAJKAIQRQ0AIAFBIGohDiALQSBqQQFyIQwgC0HgAGpBAXIhAwNAQQAhECAJKAIMBEADQEEAIQUgEEEHdCEXA0ACQCAFQQFHBEAgASgCDCEJA0AgCCALQUBrQSAgCCgCACgCCBEBACALKQNYIlkgCSkDGCJXVCBXIFlRIAspA1AiVyAJKQMQIlhUIFcgWFEgCykDSCJYIAkpAwgiWlQgWCBaUSALKQNAIlsgCSkDAFRxcnFycXKtUA0ACyALIFk3A3ggCyBXNwNwIAsgWDcDaCALIFs3A2AgCSALQeAAaiAJQUBrEKQJIAstAGAhCSAMIAMpABc3ABcgDCADKQAQNwAQIAwgA/0AAAD9CwAAIAsgCToAICABKAIUIA9BwOQAbGogF2ogBUEFdGoiCSAL/QADIP0LAwAgCSAL/QADMP0LAxAgDiALQSBqEKgKDAELIAEoAhQgD0HA5ABsaiAXaiIJIAEoAgwiBv0AA2j9CwMgIAkgBv0AA3j9CwMwCyAFQQFqIgVBBEcNAAsgEEEBaiIQIAEoAgQiCSgCDEkNAAsLQQAhFSAPQQxsIh8gCSgCIGooAgQEQANAIBVB4ABsIQZBASETQQAhCQNAIAlBgB5sIRdBACEFA0ACQCAFQQFHBEAgASgCDCEJA0AgCCALQUBrQSAgCCgCACgCCBEBACALKQNYIlkgCSkDGCJXVCBXIFlRIAspA1AiVyAJKQMQIlhUIFcgWFEgCykDSCJYIAkpAwgiWlQgWCBaUSALKQNAIlsgCSkDAFRxcnFycXKtUA0ACyALIFk3A3ggCyBXNwNwIAsgWDcDaCALIFs3A2AgCSALQeAAaiAJQUBrEKQJIAstAGAhCSAMIAMpABc3ABcgDCADKQAQNwAQIAwgA/0AAAD9CwAAIAsgCToAICABKAIUIA9BwOQAbGogF2ogBmogBUEFdGoiCSAL/QADIP0LA4AoIAlBkChqIAv9AAMw/QsDACAOIAtBIGoQqAoMAQsgASgCFCAPQcDkAGxqIBdqIAZqIglBsChqIAEoAgwiEP0AA3j9CwMAIAlBoChqIBD9AANo/QsDAAsgBUEBaiIFQQNHDQALQQEhCSATQQFxIQVBACETIAUNAAsgFUEBaiIVIAEoAgQoAiAgH2ooAgRJDQALCyABKAIMIQkDQCAIIAtBQGtBICAIKAIAKAIIEQEAIAspA1giWSAJKQMYIldUIFcgWVEgCykDUCJXIAkpAxAiWFQgVyBYUSALKQNIIlggCSkDCCJaVCBYIFpRIAspA0AiWyAJKQMAVHFycXJxcq1QDQALIAsgWTcDeCALIFc3A3AgCyBYNwNoIAsgWzcDYCAJIAtB4ABqIAlBQGsQpAkgCy0AYCEJIAxBF2oiFyADQRdqIgYpAAA3AAAgDEEQaiIQIANBEGoiEykAADcAACAMIAP9AAAA/QsAACALIAk6ACAgD0HA5ABsIgUgASgCFGoiCSAL/QADIP0LA4BkIAlBkOQAaiALQTBqIhX9AAMA/QsDACAOIAtBIGoQqAogASgCDCEJA0AgCCALQUBrQSAgCCgCACgCCBEBACALKQNYIlkgCSkDGCJXVCBXIFlRIAspA1AiVyAJKQMQIlhUIFcgWFEgCykDSCJYIAkpAwgiWlQgWCBaUSALKQNAIlsgCSkDAFRxcnFycXKtUA0ACyALIFk3A3ggCyBXNwNwIAsgWDcDaCALIFs3A2AgCSALQeAAaiAJQUBrEKQJIAstAGAhCSAXIAYpAAA3AAAgECATKQAANwAAIAwgA/0AAAD9CwAAIAsgCToAICABKAIUIAVqIgkgC/0AAyD9CwOgZCAJQbDkAGogFf0AAwD9CwMAIA4gC0EgahCoCiABKAIMIRcgC0HwAGoiBiABKAIUIAVqIglBkOQAav0AAwD9CwMAIAsgCf0AA4Bk/QsDYCAXIAtB4ABqIAlBoOQAahCkCSALIAb9AAMA/QsDUCALIAv9AANg/QsDQCAOIAtBQGsQqAogD0EBaiIPIAEoAgQiCSgCECIFSQ0ACyAFRQ0AIAEoAiwhAyAJKAIgIQ8gASgCCCEXQQAhCSAFQQFHBEAgBUEBcSEQIAVBfnEhBgNAIAMgCUEMbCIFaiIMIAUgD2ooAgRBAnQgF2oiBTYCACAMIAVBAmo2AgggDCAFQQFqNgIEIAMgCUEBckEMbCIXaiIMIAUgDyAXaigCBEECdGoiBUEFajYCCCAMIAVBBGo2AgQgDCAFQQNqNgIAIAVBBmohFyAJQQJqIgkgBkcNAAsgEEUNAQsgAyAJQQxsIgVqIgkgBSAPaigCBEECdCAXaiIFNgIAIAkgBUECajYCCCAJIAVBAWo2AgQLQfwAEKIJIgwgEkEQakHQAPwKAAAgDEHQAGogEigCICASKAIoaxDcCiASKAIgIQkgEigCRCEFIAxBADYCeCAMQgA3AnACQAJAIAUgCWwiCQRAIAlBgICAwABPDQEgDCAJQQV0IgkQogkiBTYCcCAMIAUgCWoiAzYCeCAJBEAgBUEAIAn8CwALIAwgAzYCdAsgASgCOCEJIAEgDDYCOCAJBEAgCSgCcCIFBEAgCSAFNgJ0IAUQKwsgCSgCZCIFBEAgCSAFNgJoIAUQKwsgCSgCWCIFBEAgCSAFNgJcIAUQKwsgCRArIAEoAjghDAsgASgCLCEiIAEoAiAhHyABKAIMIQkgDCgCECEFIAwoAhQhAyABKAIQIhsoAgAhASAbKAIEIQ9BKBCiCSADIAUgDyABEOAKIQUgDCAMKAI8IAwoAhQgCCAJEOEKIAUgDCgCcCAMKAIQIAwoAjxsQQV0ahDiCiAFKAIcIgEEQCAFIAE2AiAgARArCyAFKAIQIgEEQCAFIAE2AhQgARArCyAFKAIMIQEgBUEANgIMIAEEQCABKAJcIgMEQCABIAM2AmAgAxArCyABECsLIAUQKyAbKAIAIQUgGygCBCEBIAwoAhAhAyAMKAIYIQ9BKBCiCSAPIAMgASAFEOAKIRggDCAMKAJAIAwoAhggCCAJEOEKIAwoAnAgDCgCECAMKAJAbEEFdGoiFyAMKAIgQQV0aiEDIAkpA4ABIVwgCSkDeCFZIAkpA3AhVyAJKQNoIVggDCgCJCIPBEAgCSkDOCFgIAkpAzAhYSAJKQMoIWIgCSkDICFjQQAhAQNAIGAgXCADIAFBBXRqIgUpAxh8IlogWSAFKQMQfCJbIFlUIFsgVyAFKQMIfCJZIFdUIFkgWCAFKQMAfCJdIFhUrXwiVyBZVHKtfCJZIFtUcq18Ilh8IlsgWSBhfCJeIGFUIF4gVyBifCJfIGJUIF8gXSBjfCJkIGNUrXwiZSBfVHKtfCJfIF5Ucq18Il4gWCBYIFpUIFogXFRyIFsgYFQgWyBeVnJzIgUbIVwgXyBZIAUbIVkgZSBXIAUbIVcgZCBdIAUbIVggAUEBaiIBIA9HDQALCyAJQegAaiEFIAMgAykDACJbIFh9Ilg3AwAgAyADKQMIIl0gV30iWiBYIFtWrX0iVzcDCCADIAMpAxAiXiBZfSJbIFogXVYgVyBaVnKtfSJZNwMQIAMgAykDGCJdIFx9IlogWyBeViBZIFtWcq19Ilw3AxggCSkDGCFeIAkpAxAhXyAJKQMIIWAgAyBYIFggCSkDAHwiYSBaIFxUIFogXVZyrVAiARs3AwAgAyBXIFcgYHwiWiBYIGFWrXwiXSABGzcDCCADIFkgWSBffCJYIFcgWlYgWiBdVnKtfCJXIAEbNwMQIAMgXCBXIFhUIFggWVRyrSBcIF58fCABGzcDGCAYIBcQ4gogDCAMKAJEIAwoAhggCCAJEOEKIAwoAhAgDCgCRGwhASAMKAJwIQMgGCAMKAIkIg8EfyADIAFBBXRqIAwoAiBBBXRqIQYgD0EDcSEOQQAhF0EAIQEgD0EETwRAIAZB4ABqIRMgBkFAayEVIAZBIGohGiAPQXxxIR0DQCAGIAFBBXQiA2oiDyAF/QADAP0LAwAgDyAFQRBqIg/9AAMA/QsDECADIBpqIhAgD/0AAwD9CwMQIBAgBf0AAwD9CwMAIAMgFWoiECAP/QADAP0LAxAgECAF/QADAP0LAwAgAyATaiIDIA/9AAMA/QsDECADIAX9AAMA/QsDACABQQRqIgEgHUcNAAsLIA4EQANAIAYgAUEFdGoiAyAF/QADAP0LAwAgAyAF/QADEP0LAxAgAUEBaiEBIBdBAWoiFyAORw0ACwsgDCgCcCEDIAwoAhAgDCgCRGwFIAELQQV0IANqEOIKIBgoAhwiAQRAIBggATYCICABECsLIBgoAhAiAQRAIBggATYCFCABECsLIBgoAgwhASAYQQA2AgwgAQRAIAEoAlwiAwRAIAEgAzYCYCADECsLIAEQKwsgGBArIAwoAhAhASAMKAIUIQMgGygCBCEPIBsoAgAhF0EoEKIJIAMgASAPIBcQ4AohESAMKAIoRQ0BIB4gCmsiAUEAIAEgHk0bISEgCUFAayEeIAtB4ABqQQFyIQZBACEKA0AgDCgCSCAKaiEOIAwoAiAhEAJAICEgCkEBaiICIAwoAiRsTwRAQQAhAyAQRQ0BA0AgCCALQUBrQSAgCCgCACgCCBEBACALKQNYIlwgCSkDGCJZVCBZIFxRIAspA1AiWSAJKQMQIldUIFcgWVEgCykDSCJXIAkpAwgiWFQgVyBYUSALKQNAIlogCSkDAFRxcnFycXKtUA0AIAsgXDcDeCALIFk3A3AgCyBXNwNoIAsgWjcDYCAJIAtB4ABqIB4QpAkgC0EoaiIPIAb9AAAI/QsDACALQTdqIhcgBikAFzcAACALIAYpAAA3AyAgDCgCcCAMKAIQIA5sQQV0aiADQQV0aiIBIAstAGA6AAAgASALKQMgNwABIAEgD/0AAwD9CwAJIAEgFykAADcAGCADQQFqIgMgEEcNAAsMAQsgDCAOIBAgCCAJEOEKCyAMKAIgIRcgDCgCECAMKAJIIApqbCEBIAwoAnAhAyAMKAIkIg8EfyADIAFBBXRqIBdBBXRqIRAgD0EDcSETQQAhF0EAIQEgD0EETwRAIBBB4ABqIRUgEEFAayEaIBBBIGohHSAPQXxxIRgDQCAQIAFBBXQiA2oiDyAF/QADAP0LAwAgDyAFQRBqIg/9AAMA/QsDECADIB1qIg4gD/0AAwD9CwMQIA4gBf0AAwD9CwMAIAMgGmoiDiAP/QADAP0LAxAgDiAF/QADAP0LAwAgAyAVaiIDIA/9AAMA/QsDECADIAX9AAMA/QsDACABQQRqIgEgGEcNAAsLIBMEQANAIBAgAUEFdGoiAyAF/QADAP0LAwAgAyAF/QADEP0LAxAgAUEBaiEBIBdBAWoiFyATRw0ACwsgDCgCECAMKAJIIApqbCEBIAwoAnAhAyAMKAIgIRcgDCgCJAVBAAshDyARIAwoAgAgCiAPbCITayIQIA8gDyAQSxsiDgR/IAMgAUEFdGogF0EFdGohAyAfIBNBBXRqIQ8gDkEDcSEVQQAhEEEAIQEgDkEETwRAIA5BfHEhGgNAIAMgAUEFdCIXaiIOIA8gF2oiE/0AAwD9CwMAIA4gE/0AAxD9CwMQIAMgF0EgciIOaiITIA4gD2oiDv0AAxD9CwMQIBMgDv0AAwD9CwMAIAMgF0HAAHIiDmoiEyAOIA9qIg79AAMQ/QsDECATIA79AAMA/QsDACADIBdB4AByIhdqIg4gDyAXaiIX/QADEP0LAxAgDiAX/QADAP0LAwAgAUEEaiIBIBpHDQALCyAVBEADQCADIAFBBXQiF2oiDiAPIBdqIhf9AAMA/QsDACAOIBf9AAMQ/QsDECABQQFqIQEgEEEBaiIQIBVHDQALCyAMKAJwIQMgDCgCECAMKAJIIApqbAUgAQtBBXQgA2oQ4gogAiIKIAwoAihJDQALDAELEKAJAAsgESgCHCIBBEAgESABNgIgIAEQKwsgESgCECIBBEAgESABNgIUIAEQKwsgESgCDCEBIBFBADYCDCABBEAgASgCXCIDBEAgASADNgJgIAMQKwsgARArCyARECsgDCgCECEBIAwoAhQhAyAbKAIEIQ8gGygCACEXQSgQogkgAyABIA8gFxDgCiERIAwoAiwiAQRAIAEgDCgCTCIkaiIlIAFqISZBACEYIAtB+ABqIRsgC0HoAGohIQNAIAwgGCAkaiIeIAwoAiAgCCAJEOEKIAwgGCAlaiIKIAwoAiAgCCAJEOEKIAwgGCAmaiICIAwoAiAgCCAJEOEKAkAgDCgCJCIDRQ0AIAwoAnAgDCgCECAebEEFdGogDCgCIEEFdGohBiADQQNxIQ5BACEXQQAhASADQQRPBEAgBkHgAGohEyAGQUBrIRUgBkEgaiEaIANBfHEhHQNAIAYgAUEFdCIDaiIPIAX9AAMA/QsDACAPIAVBEGoiD/0AAwD9CwMQIAMgGmoiECAP/QADAP0LAxAgECAF/QADAP0LAwAgAyAVaiIQIA/9AAMA/QsDECAQIAX9AAMA/QsDACADIBNqIgMgD/0AAwD9CwMQIAMgBf0AAwD9CwMAIAFBBGoiASAdRw0ACwsgDgRAA0AgBiABQQV0aiIDIAX9AAMA/QsDACADIAX9AAMQ/QsDECABQQFqIQEgF0EBaiIXIA5HDQALCyAMKAIkIgNFDQAgDCgCcCAMKAIQIApsQQV0aiAMKAIgQQV0aiEGIANBA3EhDkEAIRdBACEBIANBBE8EQCAGQeAAaiETIAZBQGshFSAGQSBqIRogA0F8cSEdA0AgBiABQQV0IgNqIg8gBf0AAwD9CwMAIA8gBUEQaiIP/QADAP0LAxAgAyAaaiIQIA/9AAMA/QsDECAQIAX9AAMA/QsDACADIBVqIhAgD/0AAwD9CwMQIBAgBf0AAwD9CwMAIAMgE2oiAyAP/QADAP0LAxAgAyAF/QADAP0LAwAgAUEEaiIBIB1HDQALCyAOBEADQCAGIAFBBXRqIgMgBf0AAwD9CwMAIAMgBf0AAxD9CwMQIAFBAWohASAXQQFqIhcgDkcNAAsLIAwoAiQiA0UNACAMKAJwIAwoAhAgAmxBBXRqIAwoAiBBBXRqIQYgA0EDcSEOQQAhF0EAIQEgA0EETwRAIAZB4ABqIRMgBkFAayEVIAZBIGohGiADQXxxIR0DQCAGIAFBBXQiA2oiDyAF/QADAP0LAwAgDyAFQRBqIg/9AAMA/QsDECADIBpqIhAgD/0AAwD9CwMQIBAgBf0AAwD9CwMAIAMgFWoiECAP/QADAP0LAxAgECAF/QADAP0LAwAgAyATaiIDIA/9AAMA/QsDECADIAX9AAMA/QsDACABQQRqIgEgHUcNAAsLIA4EQANAIAYgAUEFdGoiAyAF/QADAP0LAwAgAyAF/QADEP0LAxAgAUEBaiEBIBdBAWoiFyAORw0ACwtBACEDIAwoAiQiAUUNAANAIAEgGGwgA2oiASAMKAIETw0BICIgAUEMbGoiASgCCCEPIAtB8ABqIgYgHyABKAIAQQV0aiIXQRBqIhD9AAMA/QsDACALIBf9AAMA/QsDYCAJIAtB4ABqIB8gASgCBEEFdGoQpAkCQCAfIA9BBXRqIg8pAwAgCykDYFINACAPKQMIICEpAwBSDQAgDykDECAGKQMAUg0AIA8pAxggGykDAFINACADQQV0Ig8gDCgCcCAMKAIQIB5sQQV0amogDCgCIEEFdGoiBiAX/QADAP0LAwAgBiAQ/QADAP0LAxAgDCgCcCAMKAIQIApsQQV0aiAPaiAMKAIgQQV0aiIXIB8gASgCBEEFdGoiBv0AAwD9CwMAIBcgBv0AAxD9CwMQIAwoAnAgDCgCECACbEEFdGogD2ogDCgCIEEFdGoiDyAfIAEoAghBBXRqIgH9AAMA/QsDACAPIAH9AAMQ/QsDECADQQFqIgMgDCgCJCIBSQ0BDAILCyALQdruKTYCEEHkAEH0hyogC0EQahCbCUGQljQoAgAoAgAhCSALQdruKTYCACAJQZGMKiALEGwACyARIAwoAnAgDCgCECAebEEFdGoQ4gogESAMKAJwIAwoAhAgCmxBBXRqEOIKIBEgDCgCcCAMKAIQIAJsQQV0ahDiCiAYQQFqIhggDCgCLEkNAAsLIBEoAhwiBQRAIBEgBTYCICAFECsLIBEoAhAiBQRAIBEgBTYCFCAFECsLIBJB4ABqIQUgESgCDCEBIBFBADYCDCABBEAgASgCXCIDBEAgASADNgJgIAMQKwsgARArCyARECsgCyAJNgJIIAtB6NIxNgJAIAsgDDYCRCALIAtBQGs2AlAgC0HgAGogDEHQAGogC0FAayAIEN8KQRAhCCAFIAv9AABw/QsAECAFIAv9AABg/QsAAAJAIAsoAlAiCSALQUBrRwRAQRQhCCAJRQ0BCyAJIAkoAgAgCGooAgARBgALIAcgBUEgENkKQeQAQYiNK0EAEJsJIAtBgAFqJAAgMygCECEDIDIoAhAhCiAUKAIkIQIgFCgCRCEFIBIoAiQhCSANIBIoAkQ2AiQgDSAJNgIgIA0gBTYCHCANIAI2AhggDSAKNgIUIA0gAzYCEEHkAEHU2CsgDUEQahCbCSAHEMcJIW4gDUGQB2pBAEHgAPwLACANQYANaiELIA1BkAdqIQkgDUGwBmohDEEAIQMjAEHAFmsiASQAIAFBkAtqEJgJGiABEJgJGgNAIAFBoBZqQbCINCALIANBBXQiCmoiAv0AAwAgAv0AAxAQmQkgASkDuBYhWCABKQOwFiFZIAkgCmoiAiAEIApqIgX9AAQAIG79USABKQOgFiJXp/0PIFdCCIin/RcBIFdCEIin/RcCIFdCGIin/RcDIFdCIIin/RcEIFdCKIin/RcFIFdCMIin/RcGIFdCOIin/RcHIAEpA6gWIlen/RcIIFdCCIin/RcJIFdCEIin/RcKIFdCGIin/RcLIFdCIIin/RcMIFdCKIin/RcNIFdCMIin/RcOIFdCOIin/RcPEJoJIm/9CwQAIAIgBf0ABBAgbv1RIFmn/Q8gWUIIiKf9FwEgWUIQiKf9FwIgWUIYiKf9FwMgWUIgiKf9FwQgWUIoiKf9FwUgWUIwiKf9FwYgWUI4iKf9FwcgWKf9FwggWEIIiKf9FwkgWEIQiKf9FwogWEIYiKf9FwsgWEIgiKf9FwwgWEIoiKf9Fw0gWEIwiKf9Fw4gWEI4iKf9Fw8Qmgn9CwQQIAogDGogb/0LAAAgDCAKQRByIgpqIAkgCmr9AAQA/QsAACADQQFqIgNBA0cNAAsgAUHAFmokACANQcgPaiEJIA1BtA9qIQwgIEGABmxBoQFyIQogDUGQB2ohBUEAIQNBBCEBA0AgBSADQQR0av0ABAAib/0dACFYIG/9HQEhWUIAIVcDQCAJKAIIIAFBBXRqIgJBmIk0QbiJNCBYIFeIIFkgV0JAfIggV0LAAFQbQgGDUBsiBP0AAwD9CwMAIAIgBP0AAxD9CwMQIAFBAWohASBXQgF8IldCgAFSDQALIAwoAgggCkEEdGogb/0LBAAgCkEBaiEKIANBAWoiA0EGRw0ACyBu/R0AIVggbv0dASFZQgAhVwNAIAkoAgggAUEFdGoiAkGYiTRBuIk0IFggV4ggWSBXQkB8iCBXQsAAVBtCAYNQGyIE/QADAP0LAwAgAiAE/QADEP0LAxAgAUEBaiEBIFdCAXwiV0KAAVINAAsgDCgCCCAKQQR0aiBu/QsEAEEGIQMgDUG0D2ohL0EAIQxBACEiQQAhBiMAQZAVayIIJAACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAWKAI4BEAgByAWKAIEIC8Q4wogCEEAOgC4FCAIQQA2ArQUIAhBvM0xNgLEEyAIIAhBzBNqNgLIEyAIQuqSmL+295nXhX83AswTIAhBvNwBOwHUEyAIQfMBOgDWEyAIQfLKAjsA1xMgCEHPADoA2RMgCEH19QA7AdoTIAhB0QA6ANwTIAhBjqQBOwDdEyAIQf8AOgDfEyAIQZsLOwHgEyAIQegAOgDiEyAIQYw/OwDjEyAIQYMBOgDlEyAIQdnXAjsB5hMgCEHbADoA6BMgCCgCyBMiBEEZOgAfIARB4JsDOwAdIAgoAsgTQgA3ACAgCEEANgK8FCAHIAhBxBNqRwRAIAgoAsgTIAcoAgQtAAA6AAAgCCgCyBMgBygCBC0AAToAASAIKALIEyAHKAIELQACOgACIAgoAsgTIAcoAgQtAAM6AAMgCCgCyBMgBygCBC0ABDoABCAIKALIEyAHKAIELQAFOgAFIAgoAsgTIAcoAgQtAAY6AAYgCCgCyBMgBygCBC0ABzoAByAIKALIEyIEIAcoAgQtAAg6AAggBCAHKAIELQAJOgAJIAgoAsgTIgQgBygCBC0ACjoACiAEIAcoAgQtAAs6AAsgCCgCyBMiBCAHKAIELQAMOgAMIAQgBygCBC0ADToADSAIKALIEyIEIAcoAgQtAA46AA4gBCAHKAIELQAPOgAPIAgoAsgTIgQgBygCBC0AEDoAECAEIAcoAgQtABE6ABEgCCgCyBMiBCAHKAIELQASOgASIAQgBygCBC0AEzoAEyAIKALIEyIEIAcoAgQtABQ6ABQgBCAHKAIELQAVOgAVIAgoAsgTIgQgBygCBC0AFjoAFiAEIAcoAgQtABc6ABcgCCgCyBMiBCAHKAIELQAYOgAYIAQgBygCBC0AGToAGSAIKALIEyIEIAcoAgQtABo6ABogBCAHKAIELQAbOgAbIAgoAsgTIgQgBygCBC0AHDoAHCAEIAcoAgQtAB06AB0gCCgCyBMiBCAHKAIELQAeOgAeIAQgBygCBC0AHzoAHyAIKALIEyIEIAcoAgQtACA6ACAgBCAHKAIELQAhOgAhIAgoAsgTIgQgBygCBC0AIjoAIiAEIAcoAgQtACM6ACMgCCgCyBMiBCAHKAIELQAkOgAkIAQgBygCBC0AJToAJSAIKALIEyIEIAcoAgQtACY6ACYgBCAHKAIELQAnOgAnAkAgBygCcCIERQ0AIARFDQAgCEH0E2ogB0EwaiAE/AoAAAsgCCAENgK0FCAIIActAHQ6ALgUCyAWKAIEIR9BFBCiCSEJIC8oAgAhBCAvKAIEIQEgCUEANgIQIAlCADcCCCAJIAE2AgQgCSAENgIAAkAgASAEbCIFRQ0AIAVBgICAgAFPDQcgCSAFQQR0IgoQngkiATYCCCAJIAEgCmoiCzYCEEEAIQQgCgRAIAFBACAK/AsACyAJIAs2AgwgBUEDcSEVIC8oAgghCiAFQQRPBEAgBUH8////AHEhGANAIAEgBEEEdCIFaiAFIApq/QAEAP0LBAAgASAFQRByIgtqIAogC2r9AAQA/QsEACABIAVBIHIiC2oiDyAKIAtqIgspAwA3AwAgDyALKQMINwMIIAEgBUEwciIFaiILIAUgCmoiBSkDCDcDCCALIAUpAwA3AwAgBEEEaiIEIBhHDQALCyAVRQ0AQQAhBQNAIAEgBEEEdCILaiAKIAtq/QAEAP0LBAAgBEEBaiEEIAVBAWoiBSAVRw0ACwsgHygCECIXRQ0BIB8oAggiJUUNAiAXQYCAgIAETw0DIBdBAnQiBBCiCSEmIAQEQCAmQQAgBPwLAAsgF0EBayIBIARBAnVPDQ8gCEHIE2ohKSAEICZqITAgJiABQQJ0aiIBKAIAIRsgASAJNgIAIARBAnUhNSAXIQEDQCAJIQ8gAUUEQCAMIQYMBwsCQCABQQFrIgIEQCAfKAIgIQVBFBCiCSEEIAUgAUECayIKQQxsaigCACEBIARBADYCECAEQgA3AgggBCABNgIEIAQgJTYCACABICVsIgEEQCABQYCAgIABTw0KIAQgAUEEdCIBEJ4JIgU2AgggBCABIAVqIgs2AhAgAQRAIAVBACAB/AsACyAEIAs2AgwLIAogNU8NEiAmIApBAnRqIgooAgAhASAKIAQ2AgAgAQRAIAEoAggiBARAIAEgBDYCDCAEECsLIAEQKwsgCigCACEJDAELQRQQogkhCSAfKAIAIQQgCUEANgIQIAlCADcCCCAJIAQ2AgQgCSAlNgIAIAQgJWwiBARAIARBgICAgAFPDQkgCSAEQQR0IgQQngkiATYCCCAJIAEgBGoiCjYCECAEBEAgAUEAIAT8CwALIAkgCjYCDAsgDARAIAwoAggiBARAIAwgBDYCDCAEECsLIAwQKwsgCSEMCyAJKAIAIgUgDygCAEcNBSAfKAIgIAJBDGxqKAIIIQsCQCAJKAIEIAVsIgRFDQAgBEEEdCIERQ0AIAkoAghBACAE/AsACyACIQEgCygCACIERQ0AQQAhHgNAIAUEQCAeQQV0IhUgCygCBGoiASgCBCAFbCEYQQAhBCABKAIIIAVsQQR0IREgASgCACAFbEEEdCEdA0AgBEEEdCIBIA8oAggiCiARamr9AAQAIW8CQCALKAIEIBVq/QAEECJu/R0AIG79HQGEUARAIG8gCiAYQQR0aiABav0ABAAQmgkibv0dACBu/R0BhFANAUEAIQQDQCAEIDVGDRYgJiAEQQJ0aiIKKAIAIQEgCkEANgIAIAEEQCABKAIIIgoEQCABIAo2AgwgChArCyABECsLIARBAWoiBCAXRw0ACyAMRQ0LIAwoAggiBARAIAwgBDYCDCAEECsLIAwQKwwLCyAJKAIIIB1qIAFqIhogGv0ABAAgbiBvEJoJIAogGEEEdGogAWr9AAQAEJoJ/VH9CwQACyAEQQFqIgQgBUcNAAsgCygCACEECyAeQQFqIh4gBEkNAAsgAiEBDAALAAsgCEHC+So2AhBB5ABB9IcqIAhBEGoQmwlBkJY0KAIAKAIAIQQgCEHC+So2AgAgBEGRjCogCBBsAAsgCEGj8is2AjBB5ABB9IcqIAhBMGoQmwlBkJY0KAIAKAIAIQQgCEGj8is2AiAgBEGRjCogCEEgahBsAAsgCEGr8is2AlBB5ABB9IcqIAhB0ABqEJsJQZCWNCgCACgCACEEIAhBq/IrNgJAIARBkYwqIAhBQGsQbAALEKAJAAsgCEGx2Cs2ApAEQeQAQfSHKiAIQZAEahCbCUGQljQoAgAoAgAhBCAIQbHYKzYCgAQgBEGRjCogCEGABGoQbAALIBsEQCAbKAIIIgQEQCAbIAQ2AgwgBBArCyAbECsLIAZFDQcCfwJAIAYoAgQiCkUNACAGKAIIIQVBACEEA0AgBSAEQQR0aiIBKQMAIAEpAwiEUARAIAogBEEBaiIERw0BDAILC0EBQaf/K0EAEJsJQQAMAQsgCEHABGoiOEEAQYAP/AsAIBYoAgQiKCgCECEEIAhBADYCrAQgCEIANwKkBCAEBEAgBEGAgICAAU8NAiAIIARBBHQiBBCeCSIqNgKkBCAIIAQgKmoiATYCrAQgBARAICpBACAE/AsACyAIIAE2AqgECyAoKAIEIiFBKU8NCSAUQQRqISsgKCgCCCEOICgoAgwhECAWKAIMISwgCCAhNgKwBCAIQdAEaiEKQQAhBANAIAhBxBNqIAhB0BRqQRAgCCgCxBMoAggRAQAgOCAEQQR0IgFqIAj9AATQFP0LBAAgCEHEE2ogCEHQFGpBECAIKALEEygCCBEBACABIApqIAj9AATQFP0LBAAgBEECaiIEQShHDQALIAhB0AlqIQogCEHACWohJ0EAIQQDQCAIQcQTaiAIQdAUakEQIAgoAsQTKAIIEQEAICcgBEEEdCIBaiAI/QAE0BT9CwQAIAhBxBNqIAhB0BRqQRAgCCgCxBMoAggRAQAgASAKaiAI/QAE0BT9CwQAIARBAmoiBEEoRw0ACwJAICFFDQAgIUEDcSEVIAhBwA5qIQFBACEFQQAhBCAhQQRPBEAgIUE8cSEYA0AgASAEQQR0IgpqIAogJ2r9AAQA/QsEACABIApBEHIiC2ogCyAnav0ABAD9CwQAIAEgCkEgciILaiIPIAsgJ2oiCykDADcDACAPIAspAwg3AwggASAKQTByIgpqIgsgCiAnaiIKKQMINwMIIAsgCikDADcDACAEQQRqIgQgGEcNAAsLIBVFDQADQCABIARBBHQiCmogCiAnav0ABAD9CwQAIARBAWohBCAFQQFqIgUgFUcNAAsLICgoAhAEQCAOQQFrITsgDkEEdCE2IAhB4BRqIR0gCEHQFGpBBHIhOSAIQZwEaiETIAhBwA5qITwgDkGAgICAAUkhPSAIQfAUaiE6A0ACQCAoKAIkICgoAiAiBGtBDG0gIksEQCAI/QwAAAAAAAAAAAAAAAAAAAAA/QsEgBUgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBMAUIAhBxBNqIAhBgBVqQRAgCCgCxBMoAggRAQAgCEHEE2ogCEHAFGpBECAIKALEEygCCBEBACA9RQ0FIDYQngkhDCA2BEAgDEEAIDb8CwALIAQgIkEMbGohESAMICz9AAQA/QsEACAQIgpFDQEDQAJAAkAgOyAKIgVBAWsiCnYiAUEBdiIEQQFqIgtBAXRBAWsgAU0EQCAIQbAEaiAFQQR0av0ABAAhcCALIQQMAQsgDCAEQQV0aiAIQbAEaiAFQQR0av0ABAAicCAMIARBBHRq/QAEACJuEJoJIG79Uf0LBAAgAUECSQ0BCwNAIAwgBEEBayIEQQV0aiIBIHAgDCAEQQR0av0ABAAibhCaCSJv/QsEECABIG8gbv1R/QsEACAEDQALCyAKDQALDAELEKAJAAsgESgCCCEKQRAQogkhGyAKKAIAIQUgG0EANgIMIBtCADcCBCAbIAU2AgACQAJAAkAgBUUNACAFQYCAgMAATw0BIBsgBUEFdCILEJ4JIgE2AgQgGyABIAtqIg82AgxBACEEIAsEQCABQQAgC/wLAAsgGyAPNgIIIAVBA3EhFSAKKAIEIQogBUEETwRAIAVB/P//P3EhGANAIAEgBEEFdCIFaiILIAUgCmoiD/0ABAD9CwQAIAsgD/0ABBD9CwQQIAEgBUEgciILaiIPIAogC2oiC/0ABBD9CwQQIA8gC/0ABAD9CwQAIAEgBUHAAHIiD2oiCyAKIA9qIg/9AAMI/QsDCCALIA8pAwA3AwAgCyAPKQMYNwMYIAEgBUHgAHIiC2oiBSAKIAtqIgspAxA3AxAgBSALKQMINwMIIAUgCykDGDcDGCAFIAspAwA3AwAgBEEEaiIEIBhHDQALC0EAIQUgFUUNAANAIAEgBEEFdCILaiIPIAogC2oiC/0ABAD9CwQAIA8gC/0ABBD9CwQQIARBAWohBCAFQQFqIgUgFUcNAAsLIBsgISAnIDwgCEGAFWogCEHAFGogLBDkCiAiIDVGDQ4gJiAiQQJ0aigCACIYKAIAIA5GBEAgESgCBCIhQSlJBEAgCCAhNgKwBCAOIgohBSAQRQ0DQQAhHgNA/QwAAAAAAAAAAAAAAAAAAAAAIXz9DAAAAAAAAAAAAAAAAAAAAAAhff0MAAAAAAAAAAAAAAAAAAAAACF+/QwAAAAAAAAAAAAAAAAAAAAAIX8gGygCACIXBEAgGygCBCEJQQAhGgNAAkAgCkUEQP0MAAAAAAAAAAAAAAAAAAAAACJyIXb9DAAAAAAAAAAAAAAAAAAAAAAheP0MAAAAAAAAAAAAAAAAAAAAACF5DAELIAogCSAaQQV0aiIEKAIIbCEVIAogBCgCBGwhESAs/QAEoAYhdCAs/QAEkAYhdUEAIQT9DAAAAAAAAAAAAAAAAAAAAAAhcv0MAAAAAAAAAAAAAAAAAAAAACF2/QwAAAAAAAAAAAAAAAAAAAAAIXj9DAAAAAAAAAAAAAAAAAAAAAAheQNA/QwAAAAAAAAAAAAAAAAAAAAAIW8gBCAFSQRAIAwgBEEEdGr9AAQAIW8L/QwAAAAAAAAAAAAAAAAAAAAAIXEgBSAEQQFyIgFLBEAgDCABQQR0av0ABAAhcQsgdSBxIG/9USJwEJoJIXcgdCBwEJoJIXP9DAAAAAAAAAAAAAAAAAAAAAAhcCAEIApPIgtFBEAgGCgCCCARQQR0aiAEQQR0av0ABAAhcAsgdyBv/VEheiBzIG/9USFz/QwAAAAAAAAAAAAAAAAAAAAAIXcgASAKTyIPRQRAIBgoAgggEUEEdGogAUEEdGr9AAQAIXcLIHUgdyBw/VEiexCaCSGAASB0IHsQmgkheyBvIHAQmgkhbiBxIHcQmgkhcSB6IIABIHD9URCaCSF3IHMgeyBw/VEQmgkhc/0MAAAAAAAAAAAAAAAAAAAAACFvIAtFBEAgGCgCCCAVQQR0aiAEQQR0av0ABAAhbwv9DAAAAAAAAAAAAAAAAAAAAAAhcCAPRQRAIBgoAgggFUEEdGogAUEEdGr9AAQAIXALIHUgcCBv/VEiehCaCSF7IHQgehCaCSF6IHkgbiBvEJoJ/VEheSB4IHEgcBCaCf1RIXggdiB3IHsgb/1REJoJ/VEhdiByIHMgeiBv/VEQmgn9USFyIARBAmoiBCAKSQ0ACwsgeSAJIBpBBXRq/QAEECJuEJoJIH/9USF/IHggbhCaCSB+/VEhfiB2IG4Qmgkgff1RIX0gfCByIG4Qmgn9USF8IBpBAWoiGiAXRw0ACwsgHkEpRwRAIB5BBnQiCiAiQaAybCIBIBYoAhRqaiIE/QAEACFuIAT9AAQQIW8gBP0ABCAhcCArKAIAIAFqIApqIgEgBP0ABDAgfP1RInH9CwQwIAEgcCB9/VEicP0LBCAgASBvIH79Uf0LBBAgASBuIH/9USJu/QsEACAIQQE6ANAUIAgoArwUIQQgCEEANgK8FCAEBEAgBBArCyApIAhB0BRqQQEQqgkgCCgCvBQhBCAIQQA2ArwUIAggbv0LBNAUIAQEQCAEECsLICkgCEHQFGpBEBCqCSAIKAK8FCEEIAhBADYCvBQgCEEBOgDQFCAEBEAgBBArCyApIAhB0BRqQQEQqgkgCCgCvBQhBCAIQQA2ArwUIAggcP0LBNAUIAQEQCAEECsLICkgCEHQFGpBEBCqCSAIKAK8FCEEIAhBADYCvBQgCEEBOgDQFCAEBEAgBBArCyApIAhB0BRqQQEQqgkgCCgCvBQhBCAIQQA2ArwUIAggcf0LBNAUIAQEQCAEECsLICkgCEHQFGpBEBCqCSAIQcQTaiAIQdAUakEQIAgoAsQTKAIIEQEAIDggHkEEdGogCP0ABNAUIm/9CwQAQQAhAQJAIAVBAkkEQEEAIQtBACEVDAELIAVBAmsiBEEBdiEPIARBfnFBAmohFUEAIQQDQCAMIARBBHRqIAwgAUEEdGoiCv0ABBAgCv0ABAAibv1RIG8Qmgkgbv1R/QsEACABQQJqIQEgBCAPRyEKIARBAWoiCyEEIAoNAAsLIAUgFUsEQCAMIAtBBHRqIAwgAUEEdGr9AAQAIm4gbxCaCSBu/VH9CwQAC0EAIQRBACEBQQAhFSAYKAIEBEADQEEAIQpBACELIBgoAgAiD0ECTwRAA0AgGCgCCCILIAFBBHRqIAsgBEEEdGoiC/0ABBAgC/0ABAAibv1RIG8Qmgkgbv1R/QsEACABQQFqIQEgBEECaiEEIBgoAgAiDyAKQQFqIgpBAXQiC0EBcksNAAsLIAsgD0kEQCAYKAIIIgogAUEEdGogCiAEQQR0av0ABAAibiBvEJoJIG79Uf0LBAAgBEEBaiEEIAFBAWohAQsgFUEBaiIVIBgoAgRJDQALCyAFQQFqQQF2IQUgGCAYKAIAQQFqQQF2Igo2AgAgHkEBaiIeIBBHDQEMBQsLIAhB7P0pNgKQA0HkAEH0hyogCEGQA2oQmwlBkJY0KAIAKAIAIQQgCEHs/Sk2AoADIARBkYwqIAhBgANqEGwACyAIQbn9KTYCsANB5ABB9IcqIAhBsANqEJsJQZCWNCgCACgCACEEIAhBuf0pNgKgAyAEQZGMKiAIQaADahBsAAsgCEHC2Cs2AtADQeQAQfSHKiAIQdADahCbCUGQljQoAgAoAgAhBCAIQcLYKzYCwAMgBEGRjCogCEHAA2oQbAALEKAJAAsCQCAFQQFGBEAgCkEBRgRAIBgoAgQiBARAIAz9AAQAIXMgGEEBNgIEIBggBDYCAEEUEKIJISAgGCgCACEEIBgoAgQhASAgQQA2AhAgIEIANwIIICAgATYCBCAgIAQ2AgACQCABIARsIgVFDQAgBUGAgICAAU8NCCAgIAVBBHQiChCeCSIBNgIIICAgASAKaiILNgIQQQAhBCAKBEAgAUEAIAr8CwALICAgCzYCDCAFQQNxIRUgGCgCCCEKIAVBBE8EQCAFQfz///8AcSERA0AgASAEQQR0IgVqIAUgCmr9AAQA/QsEACABIAVBEHIiC2ogCiALav0ABAD9CwQAIAEgBUEgciILaiIPIAogC2oiCykDADcDACAPIAspAwg3AwggASAFQTByIgVqIgsgBSAKaiIFKQMINwMIIAsgBSkDADcDACAEQQRqIgQgEUcNAAsLQQAhBSAVRQ0AA0AgASAEQQR0IgtqIAogC2r9AAQA/QsEACAEQQFqIQQgBUEBaiIFIBVHDQALCyAIICA2ApwEIAggGDYCmARBACEkICFFDQMDQCAIQZgEaiEEQQEhMSAkQTBsITRBACEJAkADQAJAIAQoAgAiCigCACIFRQRAQQAhFQwBCyAFQYCAgIABTw0LIAVBBHQiBBCeCSEVIARFDQAgFUEAIAT8CwALIAlBAXMhHyAbKAIAIhEEQCAfQQJ0IhogCEGYBGpqKAIAIRcgGygCBCEeQQAhBANAIBUgHiAEQQV0aiIBQQRqIgsgCUECdGooAgBBBHRqIg8gD/0ABAAgAf0ABBAgFygCCCALIBpqKAIAQQR0av0ABAAQmgn9Uf0LBAAgBEEBaiIEIBFHDQALCwJAIAVFBED9DAAAAAAAAAAAAAAAAAAAAAAidCF1/QwAAAAAAAAAAAAAAAAAAAAAIXIMAQsgLP0ABJAGIXYgCigCACELQQAhBP0MAAAAAAAAAAAAAAAAAAAAACF0/QwAAAAAAAAAAAAAAAAAAAAAIXX9DAAAAAAAAAAAAAAAAAAAAAAhcgNA/QwAAAAAAAAAAAAAAAAAAAAAIW4gBCALSQRAIAooAgggBEEEdGr9AAQAIW4L/QwAAAAAAAAAAAAAAAAAAAAAIXAgCyAEQQFyIgFLBEAgCigCCCABQQR0av0ABAAhcAsgdiBwIG79URCaCSBu/VEheCAVIARBBHRq/QAEACFv/QwAAAAAAAAAAAAAAAAAAAAAIXEgASAFSQRAIBUgAUEEdGr9AAQAIXELIHYgcSBv/VEQmgkheSByIG4gbxCaCf1RIXIgdSBwIHEQmgn9USF1IHQgeCB5IG/9URCaCf1RIXQgBEECaiIEIAVJDQALCyAkQSlPDQEgdCBzEJoJIW4gdSBzEJoJIW8gCCAJQYAPbCIFICJBoDJsIgEgFigCFGpqIDRqIgT9AASAFCByIHMQmgn9Uf0LBNAUIB0gbyAE/QAEkBT9Uf0LBAAgOiBuIAT9AASgFP1R/QsEACArKAIAIAFqIAVqIDRqIgQgCP0ABNAU/QsEgBQgBEGgFGogOv0ABAD9CwQAIARBkBRqIB39AAQA/QsEACAnIAlBgAVsaiAkQQR0aiAIQcQTaiAIQdAUahDlCiJv/QsEACAKKAIEBEBBACEEQQAhAUEAIREDQEEAIQVBACELIAooAgAiD0ECTwRAA0AgCigCCCILIAFBBHRqIAsgBEEEdGoiC/0ABBAgC/0ABAAibv1RIG8Qmgkgbv1R/QsEACABQQFqIQEgBEECaiEEIAooAgAiDyAFQQFqIgVBAXQiC0EBcksNAAsLIAsgD0kEQCAKKAIIIgUgAUEEdGogBSAEQQR0av0ABAAibiBvEJoJIG79Uf0LBAAgBEEBaiEEIAFBAWohAQsgEUEBaiIRIAooAgRJDQALCyAKIAooAgBBAWpBAXY2AgACQCAbKAIAIg9FBEBBACEBDAELIDkgH0ECdCIaaiEeIDkgCUECdCIXaiEfIBsoAgQhCkEAIQRBACEBA0AgCEEANgLQFCAfIAogBEEFdGoiEUEEaiIFIBdqKAIAIgtBAXY2AgAgHiAFIBpqKAIAIgk2AgACfwJAIARBAWoiBSAPTw0AIAkgCiAFQQV0aiIlQQRqIgIgGmooAgBHDQAgAiAXaigCACIJIAtBAWpHDQAgCSALc0EBSw0AIAggJf0ABBAgEf0ABBAibv1RIG8Qmgkgbv1R/QsE4BQgBEECagwBCyAR/QAEECJwIG8QmgkhbgJAIAtBAXFFBEAgCCBwIG79Uf0LBOAUDAELIAggbv0LBOAUCyAFCyEEIAogAUEFdGoiBSAI/QAE0BT9CwQAIAUgHf0ABAD9CwQQIAFBAWohASAEIA9JDQALCyAbIAE2AgAgFQRAIBUQKwtBASEJIDFBAXEhAUEAITEgEyEEIAENAAsgJEEBaiIkICFHDQEMBQsLIAhB7P0pNgKwAkHkAEH0hyogCEGwAmoQmwlBkJY0KAIAKAIAIQQgCEHs/Sk2AqACIARBkYwqIAhBoAJqEGwACyAIQYPzKzYCkAFB5ABB9IcqIAhBkAFqEJsJQZCWNCgCACgCACEEIAhBg/MrNgKAASAEQZGMKiAIQYABahBsAAsgCEHH8is2AtACQeQAQfSHKiAIQdACahCbCUGQljQoAgAoAgAhBCAIQcfyKzYCwAIgBEGRjCogCEHAAmoQbAALIAhBx/IrNgLwAkHkAEH0hyogCEHwAmoQmwlBkJY0KAIAKAIAIQQgCEHH8is2AuACIARBkYwqIAhB4AJqEGwACyAbKAIAIBsoAgQQ5goaIBgoAgBBAUcNBCAYKAIEQQFHDQUgICgCAEEBRw0GICAoAgRBAUcNByAgKAII/QAEACFuIAggIkGgMmwiBCAWKAIUaiIB/QAEgDIgGCgCCP0ABAD9Uf0LBNAUIAggbiAB/QAEkDL9Uf0LBOAUICsoAgAgBGogCP0ABNAU/QsEgDIgKygCACAEaiAd/QAEAP0LBJAyIAhBxBNqIAhB0BRqQQIQ5wogICgCCCIEBEAgICAENgIMIAQQKwsgIBArICogIkEEdGogGygCACAbKAIEEOYK/QsEACAbKAIEIgQEQCAbIAQ2AgggBBArCyAbECsgDBArICJBAWoiIiAoKAIQSQ0ACwtBACEYQeQAQa+NK0EAEJsJIAhBADYCyBQgCEIANwLAFCAIQQA2AqAEIAhCADcCmAQgFigCBCAvICsgCEGkBGogCEHAFGogCEGYBGogByAWKAIIIBYoAgwQ6AohHUHkAEGbjStBABCbCSAIQeAUakG40zH9AAAA/QsDACAIQajTMf0AAAD9CwPQFCAWKAIsIR8gFigCECEMIBYoAjghESAIKALEFCECIAgoAsAUISQgByAIQdAUakEgENkKAkAgESgCMCIBRQ0AIAFBgICAgAFPDQJBACEEIAFBBHQiChCeCSEYIAoEQCAYQQAgCvwLAAsgAUEBRwRAIAFBAXEhCyAYQRBqIQogAUH+////AHEhBQNAIAcgCEGAFWpBECAHKAIAKAIIEQEAIBggBEEEdCIBaiAI/QAEgBX9CwQAIAcgCEGAFWpBECAHKAIAKAIIEQEAIAEgCmogCP0ABIAV/QsEACAEQQJqIgQgBUcNAAsgC0UNAQsgByAIQYAVakEQIAcoAgAoAggRAQAgGCAEQQR0aiAI/QAEgBX9CwQACyAUKAKcASEFAkAgESgCFCIKRQ0AIBEoAnAgESgCECARKAI8bEEEdGohASAKQQNxIRpBACELQQAhBCAKQQRPBEAgCkF8cSEJA0AgBSAEQQR0IgpqIAEgCmr9AAQA/QsEACAFIApBEHIiD2ogASAPav0ABAD9CwQAIAUgCkEgciIPaiIVIAEgD2oiDykDADcDACAVIA8pAwg3AwggBSAKQTByIgpqIg8gASAKaiIKKQMINwMIIA8gCikDADcDACAEQQRqIgQgCUcNAAsLIBpFDQADQCAFIARBBHQiCmogASAKav0ABAD9CwQAIARBAWohBCALQQFqIgsgGkcNAAsLAkACQCARKAIwIgQEQEEAIRUDQCARKAIUIgsEQCARKAJwIBEoAhAgESgCSCAVamxBBHRqIQ8gGCAVQQR0av0ABAAhbkEAIQQDQCAFIARBBHQiAWoiCiAK/QAEACABIA9q/QAEACBuEJoJ/VH9CwQAIARBAWoiBCALRw0ACyARKAIwIQQLIBVBAWoiFSAESQ0ACwwBCyAYRQ0BCyAYECsLQQAhF0EAIQkCQCAdRQ0AIB1BgICAgAFPDQIgHUEEdCIEEJ4JIQkgBEUNACAJQQAgBPwLAAsCQCARKAIEIgFFDQAgAUHWqtUqTw0HIAFBMGwiBBCeCSEXIAQgBEEwa0EwcGsiBEUNACAXQQAgBPwLAAsCQCARKAIkIBEoAjBsIgRFBEBBACEeDAELIARBgICAgAFPDQIgBEEEdCIEEJ4JIR4gBEUNACAeQQAgBPwLAAsgAiAka0EFdSELIB0EQEEAIQQCQCAdQQFHBEAgHUEBcSEPIAlBEGohCiAdQX5xIQUDQCAHIAhBgBVqQRAgBygCACgCCBEBACAJIARBBHQiAWogCP0ABIAV/QsEACAHIAhBgBVqQRAgBygCACgCCBEBACABIApqIAj9AASAFf0LBAAgBEECaiIEIAVHDQALIA9FDQELIAcgCEGAFWpBECAHKAIAKAIIEQEAIAkgBEEEdGogCP0ABIAV/QsEAAsgESgCBCEBCwJAIAFFDQBBACEEIAFBA2wiAUEBRwRAIAFBAXEhDyAXQRBqIQogAUF+cSEFA0AgByAIQYAVakEQIAcoAgAoAggRAQAgFyAEQQR0IgFqIAj9AASAFf0LBAAgByAIQYAVakEQIAcoAgAoAggRAQAgASAKaiAI/QAEgBX9CwQAIARBAmoiBCAFRw0ACyAPRQ0BCyAHIAhBgBVqQRAgBygCACgCCBEBACAXIARBBHRqIAj9AASAFf0LBAALIB4gESAdIAsgJCAJIB8gFxDpCiAUKAKoASEFIAwoAgAhBCARKQIUIVdBoCAQngkiGiBXNwIEIBogBDYCACAaQRBqIAQQ3QoCQCARKAIYIgpFBEBBACELDAELIBEoAnAgESgCECARKAJAbEEEdGohASAKQQNxIRhBACELQQAhBCAKQQRPBEAgCkF8cSEdA0AgBSAEQQR0IgpqIAEgCmr9AAQA/QsEACAFIApBEHIiD2ogASAPav0ABAD9CwQAIAUgCkEgciIPaiIVIAEgD2oiDykDADcDACAVIA8pAwg3AwggBSAKQTByIgpqIg8gASAKaiIKKQMINwMIIA8gCikDADcDACAEQQRqIgQgHUcNAAsLIBgEQANAIAUgBEEEdCIKaiABIApq/QAEAP0LBAAgBEEBaiEEIAtBAWoiCyAYRw0ACwsgESgCGCIERQRAQQAhCwwBCyAEQYCAgIABTw0CIARBBHQiBBCeCSELIARFDQAgC0EAIAT8CwALAkACQCARKAIwBEBBACEYA0ACQCARKAIgIgRFDQAgBEEEdCIBRQ0AIAtBACAB/AsACwJAIBEoAiQiAUUNACABQQR0IgpFDQAgCyAEQQR0aiAeIAEgGGxBBHRqIAr8CgAACyAaIAsQ3gogESgCGCIPBEAgESgCcCARKAIQIBEoAkggGGpsQQR0aiEVQQAhBANAIAUgBEEEdCIBaiIKIAr9AAQAIAEgFWr9AAQAIAEgC2r9AAQAEJoJ/VH9CwQAIARBAWoiBCAPRw0ACwsgGEEBaiIYIBEoAjBJDQALDAELIAtFDQELIAsQKwsgGhArIB4QKyAXECsgCRArQQAhBEEAIQwCQCARKAIsIgpFDQAgCkGAgICAAU8NAkEAIQEgCkEEdCIFEJ4JIQwgBQRAIAxBACAF/AsACyAKQQFHBEAgCkEBcSEPIAxBEGohBSAKQf7///8AcSELA0AgByAIQYAVakEQIAcoAgAoAggRAQAgDCABQQR0IgpqIAj9AASAFf0LBAAgByAIQYAVakEQIAcoAgAoAggRAQAgBSAKaiAI/QAEgBX9CwQAIAFBAmoiASALRw0ACyAPRQ0BCyAHIAhBgBVqQRAgBygCACgCCBEBACAMIAFBBHRqIAj9AASAFf0LBAALIBQoAsABITQgFCgCtAEhMUEAIRoCQCARKAIYIgVFDQAgBUGAgICAAU8NAkEAIQEgBUEEdCIKEJ4JIRogCkUiC0UEQCAaQQAgCvwLAAsgChCeCSEEIAtFBEAgBEEAIAr8CwALIAVBA3EhFSARKAJwIBEoAhAgESgCRGxBBHRqIQogBUEETwRAIAVB/P///wBxIRgDQCAaIAFBBHQiBWogBSAKav0ABAD9CwQAIBogBUEQciILaiAKIAtq/QAEAP0LBAAgGiAFQSByIgtqIg8gCiALaiILKQMANwMAIA8gCykDCDcDCCAaIAVBMHIiBWoiCyAFIApqIgUpAwg3AwggCyAFKQMANwMAIAFBBGoiASAYRw0ACwsgFUUNAEEAIQUDQCAaIAFBBHQiC2ogCiALav0ABAD9CwQAIAFBAWohASAFQQFqIgUgFUcNAAsLIBEoAiwiAQRAIAEgESgCTCICaiIlIAFqIRtBACEdA0ACQCARKAIYIg9FDQAgESgCcCIeIBEoAhAiHyAbIB1qbEEEdGohCiAPQQNxIQlBACELQQAhASAPQQRPBEAgD0F8cSEXA0AgBCABQQR0IgVqIAUgCmr9AAQA/QsEACAEIAVBEHIiFWogCiAVav0ABAD9CwQAIAQgBUEgciIVaiIYIAogFWoiFSkDADcDACAYIBUpAwg3AwggBCAFQTByIgVqIhUgBSAKaiIFKQMINwMIIBUgBSkDADcDACABQQRqIgEgF0cNAAsLIAkEQANAIAQgAUEEdCIFaiAFIApq/QAEAP0LBAAgAUEBaiEBIAtBAWoiCyAJRw0ACwsgHiAfIB0gJWpsQQR0aiELIB4gHyACIB1qbEEEdGohFUEAIQEDQCAEIAFBBHQiCmoiBSAF/QAEACAKIAtq/QAEACAKIBVq/QAEABCaCf1R/QsEACABQQFqIgEgD0cNAAsgESgCGCILRQ0AIAwgHUEEdGr9AAQAIW5BACEBA0AgGiABQQR0IgpqIgUgBf0ABAAgBCAKav0ABAAgbhCaCf1R/QsEACABQQFqIgEgC0cNAAsLIB1BAWoiHSARKAIsSQ0ACwsgESgCICEPAkAgESgCJCIFRQ0AIBogD0EEdGohC0EAIQEDQCALIAFBBHRqIgopAwAgCikDCIRQBEAgBSABQQFqIgFHDQEMAgsLIAhBpagqNgJwQeQAQfSHKiAIQfAAahCbCUGQljQoAgAoAgAhBCAIQaWoKjYCYCAEQZGMKiAIQeAAahBsAAsCQCAPRQ0AIA9BBHQiAUUNACAxIBogAfwKAAALAkAgESgCGCIKIBEoAhQiAUYNACAKIAFrQQR0IgpFDQAgNCAaIAFBBHRqIAr8CgAACyAEBEAgBBArCyAaBEAgGhArCyAMECsgByAUKAKcASARKAIUEOcKIAcgFCgCqAEgESgCGBDnCiAHIBQoArQBIBEoAiAQ5wogByAUKALAASARKAIYIBEoAhRrEOcKAkAgESgCDCIERQRAQQAhAQwBCyAEQYCAgIAETw0IIARBAnQiBBCiCSEBIARFDQAgAUEAIAT8CwALIAEgESAHEOoKIBEoAjQiBARAQQAhFQNAIBEoAgwiCwRAIBEoAnAgESgCECAVbEEEdGogESgCGEEEdGohCiAUKALMASAUKAKUASAVbEEEdGohBUEAIQQCQCALQQFHBEAgC0EBcSEYIAtBfnEhDwNAIAUgBEEEdGogCiABIARBAnRqKAIAQQR0av0ABAD9CwQAIAUgBEEBciILQQR0aiAKIAEgC0ECdGooAgBBBHRq/QAEAP0LBAAgBEECaiIEIA9HDQALIBhFDQELIAUgBEEEdGogCiABIARBAnRqKAIAQQR0av0ABAD9CwQACyARKAI0IQQLIBVBAWoiFSAESQ0ACwsCQCARKAIMIg9FDQBBACEEIA9BAUcEQCAPQQFxIRUgD0F+cSELA0AgFCgC2AEgBEEFdGoiCiARKAJkIAEgBEECdGooAgBBBXRqIgX9AAAA/QsAACAKIAX9AAAQ/QsAECAUKALYASAEQQFyIgpBBXRqIgUgESgCZCABIApBAnRqKAIAQQV0aiIK/QAAAP0LAAAgBSAK/QAAEP0LABAgBEECaiIEIAtHDQALIBVFDQELIBQoAtgBIARBBXRqIgogESgCZCABIARBAnRqKAIAQQV0aiIE/QAAAP0LAAAgCiAE/QAAEP0LABALIBFB1ABqIBRB5AFqIAEgDxDrCiABECtB5ABB6vMqQQAQmwkgCCgCmAQiBARAIAQQKwsgJBArICoEQCAqECsLQQELIQogBigCCCIEBEAgBiAENgIMIAQQKwsgBhArDAoLEKAJAAsgCEHH8is2ApACQeQAQfSHKiAIQZACahCbCUGQljQoAgAoAgAhBCAIQcfyKzYCgAIgBEGRjCogCEGAAmoQbAALIAhBu/IrNgLwAUHkAEH0hyogCEHwAWoQmwlBkJY0KAIAKAIAIQQgCEG78is2AuABIARBkYwqIAhB4AFqEGwACyAIQcfyKzYC0AFB5ABB9IcqIAhB0AFqEJsJQZCWNCgCACgCACEEIAhBx/IrNgLAASAEQZGMKiAIQcABahBsAAsgCEG78is2ArABQeQAQfSHKiAIQbABahCbCUGQljQoAgAoAgAhBCAIQbvyKzYCoAEgBEGRjCogCEGgAWoQbAALEKAJAAsQoAkAC0EAIQpBAUGmuytBABCbCQwCCyAIQc79KTYC8ANB5ABB9IcqIAhB8ANqEJsJQZCWNCgCACgCACEEIAhBzv0pNgLgAyAEQZGMKiAIQeADahBsAAsQoAkACwNAIDBBBGsiMCgCACEEIDBBADYCACAEBEAgBCgCCCIBBEAgBCABNgIMIAEQKwsgBBArCyAmIDBHDQALICYQKyAIQbzNMTYCxBMgCCgCvBQhBCAIQQA2ArwUIAQEQCAEECsLIAhBkBVqJAACQCAKRQ0AQeQAQcCNK0EAEJsJIA1ByA9qITFBACEJQQAhKEEAIQtBACEvIwBBoCprIgYkAAJAAn8CQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgGSgCOARAIAcgGSgCBCAxIBkoAgwQ7AogBkEAOgDEIyAGQQA2AsAjIAZBvM0xNgLQIiAGIAZB2CJqNgLUIiAGQuqSmL+295nXhX83AtgiIAZBvNwBOwHgIiAGQfMBOgDiIiAGQfLKAjsA4yIgBkHPADoA5SIgBkH19QA7AeYiIAZB0QA6AOgiIAZBjqQBOwDpIiAGQf8AOgDrIiAGQZsLOwHsIiAGQegAOgDuIiAGQYw/OwDvIiAGQYMBOgDxIiAGQdnXAjsB8iIgBkHbADoA9CIgBigC1CIiAkEZOgAfIAJB4JsDOwAdIAYoAtQiQgA3ACAgBkEANgLIIyAHIAZB0CJqRwRAIAYoAtQiIAcoAgQtAAA6AAAgBigC1CIgBygCBC0AAToAASAGKALUIiAHKAIELQACOgACIAYoAtQiIAcoAgQtAAM6AAMgBigC1CIgBygCBC0ABDoABCAGKALUIiAHKAIELQAFOgAFIAYoAtQiIAcoAgQtAAY6AAYgBigC1CIgBygCBC0ABzoAByAGKALUIiICIAcoAgQtAAg6AAggAiAHKAIELQAJOgAJIAYoAtQiIgIgBygCBC0ACjoACiACIAcoAgQtAAs6AAsgBigC1CIiAiAHKAIELQAMOgAMIAIgBygCBC0ADToADSAGKALUIiICIAcoAgQtAA46AA4gAiAHKAIELQAPOgAPIAYoAtQiIgIgBygCBC0AEDoAECACIAcoAgQtABE6ABEgBigC1CIiAiAHKAIELQASOgASIAIgBygCBC0AEzoAEyAGKALUIiICIAcoAgQtABQ6ABQgAiAHKAIELQAVOgAVIAYoAtQiIgIgBygCBC0AFjoAFiACIAcoAgQtABc6ABcgBigC1CIiAiAHKAIELQAYOgAYIAIgBygCBC0AGToAGSAGKALUIiICIAcoAgQtABo6ABogAiAHKAIELQAbOgAbIAYoAtQiIgIgBygCBC0AHDoAHCACIAcoAgQtAB06AB0gBigC1CIiAiAHKAIELQAeOgAeIAIgBygCBC0AHzoAHyAGKALUIiICIAcoAgQtACA6ACAgAiAHKAIELQAhOgAhIAYoAtQiIgIgBygCBC0AIjoAIiACIAcoAgQtACM6ACMgBigC1CIiAiAHKAIELQAkOgAkIAIgBygCBC0AJToAJSAGKALUIiICIAcoAgQtACY6ACYgAiAHKAIELQAnOgAnAkAgBygCcCICRQ0AIAJFDQAgBkGAI2ogB0EwaiAC/AoAAAsgBiACNgLAIyAGIActAHQ6AMQjCyAZKAIEISFBFBCiCSEEIDEoAgAhAiAxKAIEIRAgBEEANgIQIARCADcCCCAEIBA2AgQgBCACNgIAAkAgAiAQbCIORQ0AIA5BgICAwABPDQcgBCAOQQV0IgEQogkiEDYCCCAEIAEgEGoiETYCEEEAIQIgAQRAIBBBACAB/AsACyAEIBE2AgwgDkEDcSEIIDEoAgghASAOQQRPBEAgDkH8//8/cSEYA0AgECACQQV0Ig5qIhEgASAOaiIT/QADAP0LAwAgESAT/QADEP0LAxAgECAOQSByIhFqIhMgASARaiIR/QADEP0LAxAgEyAR/QADAP0LAwAgECAOQcAAciIRaiITIAEgEWoiEf0AAxD9CwMQIBMgEf0AAwD9CwMAIBAgDkHgAHIiDmoiESABIA5qIg79AAMQ/QsDECARIA79AAMA/QsDACACQQRqIgIgGEcNAAsLIAhFDQBBACEOA0AgECACQQV0IhFqIhMgASARaiIR/QADAP0LAwAgEyAR/QADEP0LAxAgAkEBaiECIA5BAWoiDiAIRw0ACwsgISgCECIFRQ0BICEoAggiJkUNAiAFQYCAgIAETw0DIBkoAgwhECAFQQJ0IgIQogkhKSACBEAgKUEAIAL8CwALIAVBAWsiASACQQJ1Tw0OIAZB1CJqITggAiApaiE0ICkgAUECdGoiASgCACEiIAEgBDYCACAQQegAaiETIAJBAnUhOSAFIQEDQCAEIQwgAUUEQCAJIQsMBwsCQCABQQFrIgoEQCAhKAIgIRFBFBCiCSECIBEgAUECayIOQQxsaigCACEBIAJBADYCECACQgA3AgggAiABNgIEIAIgJjYCACABICZsIgEEQCABQYCAgMAATw0KIAIgAUEFdCIBEKIJIhE2AgggAiABIBFqIgg2AhAgAQRAIBFBACAB/AsACyACIAg2AgwLIA4gOU8NESApIA5BAnRqIg4oAgAhASAOIAI2AgAgAQRAIAEoAggiAgRAIAEgAjYCDCACECsLIAEQKwsgDigCACEEDAELQRQQogkhBCAhKAIAIQIgBEEANgIQIARCADcCCCAEIAI2AgQgBCAmNgIAIAIgJmwiAgRAIAJBgICAwABPDQkgBCACQQV0IgIQogkiATYCCCAEIAEgAmoiDjYCECACBEAgAUEAIAL8CwALIAQgDjYCDAsgCQRAIAkoAggiAgRAIAkgAjYCDCACECsLIAkQKwsgBCEJCyAEKAIAIgggDCgCAEcNBSAhKAIgIApBDGxqKAIIIR4CQCAEKAIEIAhsIgFFDQAgBCgCCCEYIAFBA3EhGkEAIRFBACECIAFBBE8EQCAYQeAAaiEVIBhBQGshHyAYQSBqIR0gAUF8cSEgA0AgGCACQQV0IgFqIg4gE/0AAwD9CwMAIA4gE0EQaiIO/QADAP0LAxAgASAdaiIbIA79AAMA/QsDECAbIBP9AAMA/QsDACABIB9qIhsgDv0AAwD9CwMQIBsgE/0AAwD9CwMAIAEgFWoiASAO/QADAP0LAxAgASAT/QADAP0LAwAgAkEEaiICICBHDQALCyAaRQ0AA0AgGCACQQV0aiIBIBP9AAMA/QsDACABIBP9AAMQ/QsDECACQQFqIQIgEUEBaiIRIBpHDQALCyAKIQEgHigCACIgRQ0AQQAhFQNAIAgEQCAeKAIEIBVBMGxqIgJBEGohDiACKAIEIAhsIRggAigCCCAIbCEbQQAhESACKAIAIAhsQQV0IRoDQCAGIA4pAxg3A+AEIAYgDv0AAwj9CwPQBCAGIA4pAwAiXTcDyAQCQAJAIF0gEykDAFINACAGKQPQBCJYIBApA3BSDQAgBikD2AQiVyAQKQN4Ug0AIAYpA+AEIlogECkDgAFSDQAgBkGwKWoiHSARQQV0IgEgDCgCCCICIBtBBXRqaiIf/QADEP0LAwAgBiAf/QADAP0LA6ApIBAgBkGgKWogAiAYQQV0aiABahCkCQJAIAYpA6ApIF1SDQAgBkGoKWopAwAgWFINACAdKQMAIFdSDQAgBikDuCkgWlENAgtBACECA0AgAiA5Rg0VICkgAkECdGoiASgCACEQIAFBADYCACAQBEAgECgCCCIBBEAgECABNgIMIAEQKwsgEBArCyACQQFqIgIgBUcNAAsgCUUNCyAJKAIIIgIEQCAJIAI2AgwgAhArCyAJECsMCwsgECAGQcgEaiARQQV0IgIgDCgCCCIBIBtBBXRqahCkCSAQIAZByARqIAEgGEEFdGogAmoQpAkgBCgCCCAaaiACaiICIAIpAwAiWCAGKQPIBHwiXTcDACACIAIpAwgiWyAGKQPQBHwiVyBYIF1WrXwiWDcDCCACIAIpAxAiXiAGKQPYBHwiWiBXIFtUIFcgWFZyrXwiVzcDECACIAIpAxgiYCAGKQPgBHwiWyBaIF5UIFcgWlRyrXwiWjcDGCACIBApAzgiYSBafCJeIBApAzAiXCBXfCJZIFxUIFkgECkDKCJfIFh8IlwgX1QgXCAQKQMgIl8gXXwiYiBfVK18Il8gXFRyrXwiXCBZVHKtfCJZIFogWyBgVCBaIFtUciBeIGFUIFkgXlRycyIBGzcDGCACIFwgVyABGzcDECACIF8gWCABGzcDCCACIGIgXSABGzcDAAsgEUEBaiIRIAhHDQALCyAVQQFqIhUgIEkNAAsgCiEBDAALAAsgBkHC+So2AhBB5ABB9IcqIAZBEGoQmwlBkJY0KAIAKAIAIQIgBkHC+So2AgAgAkGRjCogBhBsAAsgBkGj8is2AjBB5ABB9IcqIAZBMGoQmwlBkJY0KAIAKAIAIQIgBkGj8is2AiAgAkGRjCogBkEgahBsAAsgBkGr8is2AlBB5ABB9IcqIAZB0ABqEJsJQZCWNCgCACgCACECIAZBq/IrNgJAIAJBkYwqIAZBQGsQbAALEKAJAAsgBkGx2Cs2ArAEQeQAQfSHKiAGQbAEahCbCUGQljQoAgAoAgAhAiAGQbHYKzYCoAQgAkGRjCogBkGgBGoQbAALICIEQCAiKAIIIgIEQCAiIAI2AgwgAhArCyAiECsLAkACQCALBEAgCygCBCIRRQ0CIAsoAgghDiAZKAIMIhApA2ghXUEAIQEMAQtBACEBQQFBprsrQQAQmwkMDQsDQAJAAkAgDiABQQV0aiICKQMAIF1SDQAgAikDCCAQKQNwUg0AIAIpAxAgECkDeFENAQtBAUGn/ytBABCbCUEADA0LIAIpAxggECkDgAFSDQsgAUEBaiIBIBFHDQALCyAZKAIEIisoAhAhAiAGQQA2AsQEIAZCADcCvAQgAgRAIAJBgICAwABPDQEgBiACQQV0IgIQogkiLzYCvAQgBiACIC9qIhA2AsQEIAIEQCAvQQAgAvwLAAsgBiAQNgLABAsgKygCBCICQSlPDQcgKygCCCEPICsoAgwhOiAZKAIMIQ4gBiACNgLIBCAGQdAiaiAGQdAEaiJFQSggDhDtCiAGQdAiaiAGQdAOaiIsQSggDhDtCgJAIAYoAsgEIgFFDQAgAUEDcSEYIAZB0BhqIRBBACERQQAhAiABQQRPBEAgAUF8cSEbA0AgECACQQV0IgFqIhMgASAsaiII/QADAP0LAwAgEyAI/QADEP0LAxAgECABQSByIhNqIgggEyAsaiIT/QADEP0LAxAgCCAT/QADAP0LAwAgECABQcAAciITaiIIIBMgLGoiE/0AAxD9CwMQIAggE/0AAwD9CwMAIBAgAUHgAHIiAWoiEyABICxqIgH9AAMQ/QsDECATIAH9AAMA/QsDACACQQRqIgIgG0cNAAsLIBhFDQADQCAQIAJBBXQiAWoiEyABICxqIgH9AAMA/QsDACATIAH9AAMQ/QsDECACQQFqIQIgEUEBaiIRIBhHDQALCyASQQRqITAgKygCEARAIA5BQGshSCAOQegAaiERIA9BBXQhNSAGQcApaiE2IAZB4ChqIUkgBkHAKGohSiAGQeAmaiEbIAZBwCZqIQQgBkHgJ2ohCSAGQcAnaiEYIAZBoCVqQQFyITsgBkGgJ2pBAXIhPCAGQYAqaiFLIAZB4ClqIUwgBkGAJWohTSAGQeAkaiFOIAZBwCRqIU8gBkGAJmohUCAGQYAnaiEfIAZB4CVqIVEgBkHAJWohUiAGQaQkaiEXIAZB0BhqIVMgD0GAgIDAAEkhVCAGQbgpaiEKIAZBqClqISYDQAJAAkACQAJAAkACQAJAAkACQAJAICsoAiQgKygCICICa0EMbSAoSwRAIAZB0CJqIA4gBkGAJGogBkHgI2oQ7gogBkEBNgLQIyAGIA82AswjIFRFDQ0gAiAoQQxsaiEVIAYgNRCiCSICNgLUIyAGIAIgNWoiEDYC3CMgNQRAIAJBACA1/AsACyAGIBA2AtgjIAIgOiAPIEUgDhDvCiAVKAIIIQFBEBCiCSEkIAEoAgAhEyAkQQA2AgwgJEIANwIEICQgEzYCAAJAIBNFDQAgE0HWqtUqTw0CICQgE0EwbCIIEKIJIhA2AgQgJCAIIBBqNgIMQQAhAiAIQTBrIgggCEEwcGtBMGoiCARAIBBBACAI/AsACyAkIAggEGo2AgggE0EDcSEaIAEoAgQhASATQQRPBEAgE0H8//8/cSEMA0AgECACQTBsIghqIhMgASAIaiII/QADAP0LAwAgEyAI/QADIP0LAyAgEyAI/QADEP0LAxAgECACQQFyQTBsIghqIhMgASAIaiII/QADIP0LAyAgEyAI/QADEP0LAxAgEyAI/QADAP0LAwAgECACQQJyQTBsIghqIhMgASAIaiII/QADIP0LAyAgEyAI/QADEP0LAxAgEyAI/QADAP0LAwAgECACQQNyQTBsIghqIhMgASAIaiII/QADIP0LAyAgEyAI/QADEP0LAxAgEyAI/QADAP0LAwAgAkEEaiICIAxHDQALC0EAIQwgGkUNAANAIBAgAkEwbCIIaiITIAEgCGoiCP0AAwD9CwMAIBMgCP0AAyD9CwMgIBMgCP0AAxD9CwMQIAJBAWohAiAMQQFqIgwgGkcNAAsLICQgBigCyAQgLCBTIAZBgCRqIAZB4CNqIA4Q8AogKCA5Rg0VIA8gKSAoQQJ0aigCACInKAIARw0CIBUoAgQiPUEpTw0DIAYgPTYCyAQgDyECIDoEf0EAISIDQCAGQaAoakEAQYAB/AsAICQoAgAiVQRAICcoAgAhECAkKAIEIVZBACFCIAYoAtQjIRUgBigCzCMhBQNAIFYgQkEwbGoiRigCCCEBIEYoAgQhEyAGQaApakEAQYAB/AsAIBAEQEEAIQIgECATbEEFdCEqIAEgEGxBBXQhJQNAIAZBsCdqIgEgFSACQQV0IhNqIBEgAiAFSRsiCP0AAxD9CwMAIAYgCP0AAwD9CwOgJyAYQRBqIgggFSACQQFyIgxBBXQiGmogESAFIAxLGyId/QADEP0LAwAgGCAd/QADAP0LAwAgBkGgJmogBkGgJ2ogDhDxCiABICcoAggiHSAqaiIgIBNqIBEgAiAQSSIeGyIh/QADEP0LAwAgBiAh/QADAP0LA6AnIAggGiAgaiARIAwgEEkiDBsiIP0AAxD9CwMAIBggIP0AAwD9CwMAIAZBoCVqIAZBoCdqIA4Q8QogDiAGQaAmaiAGQaAlahCkCSAOIAQgUhCkCSAOIBsgURCkCSAOIB8gUBCkCSABIB0gJWoiHSATaiARIB4bIhP9AAMQ/QsDACAGIBP9AAMA/QsDoCcgCCAaIB1qIBEgDBsiAf0AAxD9CwMAIBggAf0AAwD9CwMAIAZBoCRqIAZBoCdqIA4Q8QogDiAGQaAmaiAGQaAkahCkCSAOIAQgTxCkCSAOIBsgThCkCSAOIB8gTRCkCSAGQaAnaiAGQaAmakGAAfwKAAAgBkGgKWogBkGgJ2ogDhDyCiACQQJqIgIgEEkNAAsLIA4gBkGgKWogRkEQaiICEKQJIA4gNiACEKQJIA4gTCACEKQJIA4gSyACEKQJIAZBoChqIAZBoClqIA4Q8gogQkEBaiJCIFVHDQALCyAGQaApaiAGQaAoakGAAfwKAAAgIkEpRg0KICJBB3QiDCAoQcDkAGwiCCAZKAIUamohEyAOKQMYIWIgDikDECFjIA4pAwghZCAOKQMAIWVBACEBA0AgAUEFdCIQIAZBoClqaiICIAIpAxgiYCAQIBNqIhApAxh9IlogAikDECJdIBApAxB9IlsgXVYgWyACKQMIIl0gECkDCH0iVyBdViBXIAIpAwAiWCAQKQMAfSJdIFhWrX0iWCBXVnKtfSJXIFtWcq19IlsgVyBjfCJeIFdUIF4gWCBkfCJZIFhUIFkgXSBlfCJhIF1UrXwiXyBZVHKtfCJZIF5Ucq0gWyBifHwgWiBbVCBaIGBWcq1QIhAbNwMYIAIgVyBZIBAbNwMQIAIgWCBfIBAbNwMIIAIgXSBhIBAbNwMAIAFBAWoiAUEERw0ACyAwKAIAIAhqIAxqIAZBoClqQYAB/AoAACAGQQE6AKAnIAYoAsgjIQIgBkEANgLIIyACBEAgAhArCyA4IAZBoCdqQQEQqgkgBkHQImogBv0ABKApIAb9AASwKSAOEPMKIAZBAToAoCcgBigCyCMhAiAGQQA2AsgjIAIEQCACECsLIDggBkGgJ2pBARCqCSAGQdAiaiAG/QAE4CkgBv0ABPApIA4Q8wogBkEBOgCgJyAGKALIIyECIAZBADYCyCMgAgRAIAIQKwsgOCAGQaAnakEBEKoJIAZB0CJqIAb9AASAKiAG/QAEkCogDhDzCgNAIAZB0CJqIAZBoCZqQSAgBigC0CIoAggRAQAgBikDuCYiXSAOKQMYIlhUIFggXVEgBikDsCYiWCAOKQMQIldUIFcgWFEgBikDqCYiVyAOKQMIIlpUIFcgWlEgBikDoCYiWyAOKQMAVHFycXJxcq1QDQALIAYgXTcDuCcgBiBYNwOwJyAGIFc3A6gnIAYgWzcDoCcgDiAGQaAnaiBIEKQJIAYtAKAnIQIgOyA8KQAXNwAXIDsgPCkAEDcAECA7IDz9AAAA/QsAACAGIAI6AKAlIEUgIkEFdGoiAiAGQbAlav0AAwD9CwMQIAIgBv0AA6Al/QsDACAGQcwjaiAGQaAlaiAOEPQKICcgBkGgJWogDhD0CiAiQQFqIiIgOkcNAAsgBigCzCMFIAILQQFHDQQgBigC0CNBAUcNBSAGQbAlaiAGKALUIyIC/QADEP0LAwAgBiAC/QADAP0LA6AlICcoAgBBAUcNBiAnKAIEIgJFDQcgJ0EBNgIEICcgAjYCAEEUEKIJISUgJygCACECICcoAgQhECAlQQA2AhAgJUIANwIIICUgEDYCBCAlIAI2AgACQCACIBBsIhNFDQAgE0GAgIDAAE8NDiAlIBNBBXQiARCiCSIQNgIIICUgASAQaiIINgIQQQAhAiABBEAgEEEAIAH8CwALICUgCDYCDCATQQNxIRogJygCCCEBIBNBBE8EQCATQfz//z9xIRUDQCAQIAJBBXQiE2oiCCABIBNqIgz9AAMA/QsDACAIIAz9AAMQ/QsDECAQIBNBIHIiCGoiDCABIAhqIgj9AAMQ/QsDECAMIAj9AAMA/QsDACAQIBNBwAByIghqIgwgASAIaiII/QADEP0LAxAgDCAI/QADAP0LAwAgECATQeAAciITaiIIIAEgE2oiE/0AAxD9CwMQIAggE/0AAwD9CwMAIAJBBGoiAiAVRw0ACwtBACETIBpFDQADQCAQIAJBBXQiCGoiDCABIAhqIgj9AAMA/QsDACAMIAj9AAMQ/QsDECACQQFqIQIgE0EBaiITIBpHDQALCyAGICU2AqQkIAYgJzYCoCRBACEiID1FDQoDQCAGQaAkaiECQQEhKkEAIR0DQAJAIAIoAgAiISgCACIMRQRAQQAhCAwBCyAMQYCAgMAATw0QQQAhAiAMQQV0IhAQogkhCCAQBEAgCEEAIBD8CwALIAxBA3EhGiAMQQRPBEAgCEHgAGohFSAIQUBrIQUgCEEgaiEgIAxB/P//P3EhHgNAIAggAkEFdCIQaiIBIBH9AAMA/QsDACABIBFBEGoiAf0AAwD9CwMQIBAgIGoiEyAB/QADAP0LAxAgEyAR/QADAP0LAwAgBSAQaiITIAH9AAMA/QsDECATIBH9AAMA/QsDACAQIBVqIhAgAf0AAwD9CwMQIBAgEf0AAwD9CwMAIAJBBGoiAiAeRw0ACwtBACEQIBpFDQADQCAIIAJBBXRqIgEgEf0AAwD9CwMAIAEgEf0AAxD9CwMQIAJBAWohAiAQQQFqIhAgGkcNAAsLICQoAgAiFQRAIB1BAXNBAnQiBSAGQaAkamooAgAoAgghICAkKAIEIR5BACEBA0AgHiABQTBsaiICQQRqIhAgHUECdGooAgAhEyAFIBBqKAIAIRAgBkGwKWoiGiAC/QADIP0LAwAgBiAC/QADEP0LA6ApIA4gBkGgKWogICAQQQV0ahCkCSAIIBNBBXRqIgIgDikDOCJgIAIpAxgiYSAKKQMAfCJdIAIpAxAiVyAaKQMAfCJYIFdUIFggAikDCCJaICYpAwB8IlcgWlQgVyACKQMAIlsgBikDoCl8IlogW1StfCJbIFdUcq18IlcgWFRyrXwiWHwiXiAOKQMwIlwgV3wiWSBcVCBZIA4pAygiXyBbfCJcIF9UIFwgDikDICJfIFp8ImIgX1StfCJfIFxUcq18IlwgWVRyrXwiWSBYIF0gYVQgWCBdVHIgXiBgVCBZIF5UcnMiEBs3AxggAiBcIFcgEBs3AxAgAiBfIFsgEBs3AwggAiBiIFogEBs3AwAgAUEBaiIBIBVHDQALCyAGQaAoakEAQeAA/AsAIAwEQCAOKQM4IWYgDikDMCFnIA4pAyghaCAOKQMgIWkgDikDGCFqIA4pAxAhayAOKQMIIWwgDikDACFtICEoAgghGiAhKAIAIRVBACETA0AgGiATQQV0IgFqIBEgEyAVSRsiAikDACFbIAIpAwghXiACKQMQIVkgAikDGCFcIBogE0EBciIQQQV0IgVqIBEgECAVSRsiAikDACFdIAIpAwghWCACKQMQIVcgBiACKQMYIlo3A9gnIAYgVzcD0CcgBiBYNwPIJyAGIF03A8AnIAYgXDcDuCcgBiBZNwOwJyAGIF43A6gnIAYgWzcDoCcgBiBmIFogWiBcfSJcIFcgWX0iYCBXViBgIFggXn0iWSBYViBZIF0gW30iWyBdVq19Il4gWVZyrX0iWSBgVnKtfSJgIFkga3wiYSBZVCBhIF4gbHwiXyBeVCBfIFsgbXwiYiBbVK18ImMgX1RyrXwiXyBhVHKtIGAganx8IFogXFQgXCBgVHKtUCICG3wiXCBXIFkgXyACG3wiWSBXVCBZIFggXiBjIAIbfCJXIFhUIFcgXSBbIGIgAht8IlggXVStfCJdIFdUcq18IlcgWVRyrXwiW3wiXiBXIGd8IlkgZ1QgWSBdIGh8ImAgaFQgYCBYIGl8ImEgaVStfCJfIGBUcq18ImAgWVRyrXwiWSBbIFsgXFQgWiBcVnIgXiBmVCBZIF5UcnMiAhs3A/gnIAYgYCBXIAIbNwPwJyAGIF8gXSACGzcD6CcgBiBhIFggAhs3A+AnIAUgCGogESAMIBBLGyICKQMAIV0gAikDCCFYIAIpAxAhVyABIAhqIhApAwAhWyAQKQMIIV4gECkDECFZIBApAxghXCAGIAIpAxgiWjcD2CYgBiBXNwPQJiAGIFg3A8gmIAYgXTcDwCYgBiBcNwO4JiAGIFk3A7AmIAYgXjcDqCYgBiBbNwOgJiAGIGYgWiBaIFx9IlwgVyBZfSJgIFdWIGAgWCBefSJZIFhWIFkgXSBbfSJbIF1WrX0iXiBZVnKtfSJZIGBWcq19ImAgWSBrfCJhIFlUIGEgXiBsfCJfIF5UIF8gWyBtfCJiIFtUrXwiYyBfVHKtfCJfIGFUcq0gYCBqfHwgWiBcVCBcIGBUcq1QIgIbfCJcIFcgWSBfIAIbfCJZIFdUIFkgWCBeIGMgAht8IlcgWFQgVyBdIFsgYiACG3wiWCBdVK18Il0gV1RyrXwiVyBZVHKtfCJbfCJeIFcgZ3wiWSBnVCBZIF0gaHwiYCBoVCBgIFggaXwiYSBpVK18Il8gYFRyrXwiYCBZVHKtfCJZIFsgWyBcVCBaIFxWciBeIGZUIFkgXlRycyICGzcD+CYgBiBgIFcgAhs3A/AmIAYgXyBdIAIbNwPoJiAGIGEgWCACGzcD4CYgDiAGQaAnaiAGQaAmahCkCSAOIBggBBCkCSAOIAkgGxCkCSAGQaApaiAGQaAnakHgAPwKAAAgDikDOCFgIA4pAzAhYSAOKQMoIV8gDikDICFiQQAhAQNAIAFBBXQiECAGQaAoamoiAiBgIAIpAxgiYyAGQaApaiAQaiIQKQMYfCJdIAIpAxAiVyAQKQMQfCJYIFdUIFggAikDCCJaIBApAwh8IlcgWlQgVyACKQMAIlsgECkDAHwiWiBbVK18IlsgV1RyrXwiVyBYVHKtfCJYfCJeIFcgYXwiWSBhVCBZIFsgX3wiXCBfVCBcIFogYnwiZCBiVK18ImUgXFRyrXwiXCBZVHKtfCJZIFggXSBjVCBYIF1UciBeIGBUIFkgXlRycyIQGzcDGCACIFwgVyAQGzcDECACIGUgWyAQGzcDCCACIGQgWiAQGzcDACABQQFqIgFBA0cNAAsgE0ECaiITIAxJDQALCyAOIAZBoChqIAZBoCVqEKQJIA4gSiAGQaAlahCkCSAOIEkgBkGgJWoQpAkgBkGgKWogBkGgKGpB4AD8CgAAICJBKU8NCyAiQeAAbCIVIB1BgB5sIhogKEHA5ABsIgwgGSgCFGpqakGAKGohEyAOKQMYIWIgDikDECFjIA4pAwghZCAOKQMAIWVBACEBA0AgAUEFdCIQIAZBoClqaiICIAIpAxgiXCAQIBNqIhApAxh9IlogAikDECJdIBApAxB9IlsgXVYgWyACKQMIIl0gECkDCH0iVyBdViBXIAIpAwAiWCAQKQMAfSJdIFhWrX0iWCBXVnKtfSJXIFtWcq19IlsgVyBjfCJeIFdUIF4gWCBkfCJZIFhUIFkgXSBlfCJgIF1UrXwiYSBZVHKtfCJZIF5Ucq0gWyBifHwgWiBbVCBaIFxWcq1QIhAbNwMYIAIgVyBZIBAbNwMQIAIgWCBhIBAbNwMIIAIgXSBgIBAbNwMAIAFBAWoiAUEDRw0ACyAwKAIAIAxqIBpqIBVqQYAoaiAGQaApakHgAPwKAAAgBkGgJ2ogBkHQImogDiAGQaApahD1CiAsIB1BgApsaiAiQQV0aiICIAZBsCdq/QADAP0LAxAgAiAG/QADoCf9CwMAICEgBkGgJ2ogDhD0CiAkIAZBoCdqIB0gDhD2CiAIBEAgCBArC0EBIR0gKkEBcSEQQQAhKiAXIQIgEA0ACyAiQQFqIiIgPUcNAAsMCgsQoAkACxCgCQALIAZBwtgrNgLwA0HkAEH0hyogBkHwA2oQmwlBkJY0KAIAKAIAIQIgBkHC2Cs2AuADIAJBkYwqIAZB4ANqEGwACyAGQbn9KTYC0ANB5ABB9IcqIAZB0ANqEJsJQZCWNCgCACgCACECIAZBuf0pNgLAAyACQZGMKiAGQcADahBsAAsgBkHH8is2ApADQeQAQfSHKiAGQZADahCbCUGQljQoAgAoAgAhAiAGQcfyKzYCgAMgAkGRjCogBkGAA2oQbAALIAZBu/IrNgLwAkHkAEH0hyogBkHwAmoQmwlBkJY0KAIAKAIAIQIgBkG78is2AuACIAJBkYwqIAZB4AJqEGwACyAGQcfyKzYC0AJB5ABB9IcqIAZB0AJqEJsJQZCWNCgCACgCACECIAZBx/IrNgLAAiACQZGMKiAGQcACahBsAAsgBkGD8ys2ApABQeQAQfSHKiAGQZABahCbCUGQljQoAgAoAgAhAiAGQYPzKzYCgAEgAkGRjCogBkGAAWoQbAALIAZB7P0pNgKwA0HkAEH0hyogBkGwA2oQmwlBkJY0KAIAKAIAIQIgBkHs/Sk2AqADIAJBkYwqIAZBoANqEGwACyAGQez9KTYCsAJB5ABB9IcqIAZBsAJqEJsJQZCWNCgCACgCACECIAZB7P0pNgKgAiACQZGMKiAGQaACahBsAAsgBkGgKWogJCgCACAkKAIEEPcKICcoAgBBAUcNAyAnKAIEQQFHDQQgJSgCAEEBRw0FICUoAgRBAUcNBiAlKAIIIQIgBkGwKWoiECAnKAIIIgH9AAMQ/QsEACAGIAH9AAMA/QsEoCkgNkEQaiIIIAL9AAMQ/QsDACA2IAL9AAMA/QsDACAOKQMYIVsgECAQKQMAImAgKEHA5ABsIhMgGSgCFGoiAikDkGR9Il4gBikDqCkiWCACKQOIZH0iWiBYViBaIAYpA6ApIlcgAikDgGR9IlggV1atfSJXIFpWcq19IlogWiAOKQMQImF8IlkgVyAOKQMIIl98IlwgV1QgXCBYIA4pAwAiYnwiYyBYVK18ImQgXFRyrXwiZSAKKQMAImYgAikDmGR9IlwgZlYgXCBeIGBWIFogXlZyrX0iXiBcVnKtUCIBGzcDACAKIF4gWSBaVCBZIGVWcq0gWyBefHwgARs3AwAgBiBXIGQgARs3A6gpIAYgWCBjIAEbNwOgKSAGIAYpA9gpImAgAikDuGR9Il4gBikD0CkiWCACKQOwZH0iWSBYViBZIAYpA8gpIlggAikDqGR9IlogWFYgWiAGKQPAKSJXIAIpA6BkfSJYIFdWrX0iVyBaVnKtfSJaIFlWcq19IlkgWSBbfCBaIGF8IlsgWlQgWyBXIF98IlwgV1QgXCBYIGJ8ImEgWFStfCJfIFxUcq18IlwgW1RyrXwgWSBeViBeIGBWcq1QIgIbNwPYKSAGIFogXCACGzcD0CkgBiBXIF8gAhs3A8gpIAYgWCBhIAIbNwPAKSAwKAIAIBNqIgIgBv0ABKAp/QsDgGQgAkGQ5ABqIBD9AAQA/QsDACAwKAIAIBNqIgIgNv0AAwD9CwOgZCACQbDkAGogCP0AAwD9CwMAIAZB0CJqIAZBoClqQQIgDhD4CiAlKAIIIgIEQCAlIAI2AgwgAhArCyAlECsgBkGgKWogJCgCACAkKAIEEPcKIC8gKEEFdGoiAiAQ/QADAP0LAxAgAiAG/QADoCn9CwMAICQoAgQiAgRAICQgAjYCCCACECsLICQQKyAGKALUIyICBEAgAhArCyAoQQFqIiggKygCEEkNAAsLQQAhGkHkAEGvjStBABCbCSAGQQA2AqgmIAZCADcCoCYgBkEANgKoJSAGQgA3AqAlIBkoAgQgMSAwIAZBvARqIAZBoCZqIAZBoCVqIAcgGSgCCCAZKAIMEPkKIR5B5ABBm40rQQAQmwkgBkGwJ2pBuNMx/QAAAP0LAwAgBkGo0zH9AAAA/QsDoCcgGSgCLCEqIBkoAhAhISAZKAIMIRAgGSgCOCEVIAYoAqQmIQIgBigCoCYhIiAHIAZBoCdqQSAQ2QogAiAia0EobSElIBUoAjAiAgRAIAJBgICAwABPDQEgAkEFdCIBEKIJIRogAQRAIBpBACAB/AsACyAHIBogAiAQEO0KCyASKAKcASETAkAgFSgCFCIORQ0AIBUoAnAgFSgCECAVKAI8bEEFdGohASAOQQNxIRtBACERQQAhAiAOQQRPBEAgDkF8cSEEA0AgEyACQQV0Ig5qIgggASAOaiIY/QADAP0LAwAgCCAY/QADEP0LAxAgEyAOQSByIghqIhggASAIaiII/QADEP0LAxAgGCAI/QADAP0LAwAgEyAOQcAAciIIaiIYIAEgCGoiCP0AAxD9CwMQIBggCP0AAwD9CwMAIBMgDkHgAHIiDmoiCCABIA5qIg79AAMQ/QsDECAIIA79AAMA/QsDACACQQRqIgIgBEcNAAsLIBtFDQADQCATIAJBBXQiDmoiCCABIA5qIg79AAMA/QsDACAIIA79AAMQ/QsDECACQQFqIQIgEUEBaiIRIBtHDQALCyAVKAIwIgUEQCAVKAJwIR8gFSgCECEdIBUoAkghICAVKAIUIQhBACEMIAZBuClqIRsgBkGoKWohBANAIAZBsChqIBogDEEFdGoiAv0AAxD9CwMAIAYgAv0AAwD9CwOgKCAIBEAgHyAdIAwgIGpsQQV0aiEYQQAhDgNAIAZBsClqIgIgGCAOQQV0IgFqIhH9AAMQ/QsDACAGIBH9AAMA/QsDoCkgECAGQaApaiAGQaAoahCkCSAbKQMAIVsgAikDACFaIAQpAwAhWCABIBNqIgIgAikDACJeIAYpA6ApfCJdNwMAIAIgWCACKQMIIll8IlcgXSBeVK18Ilg3AwggAiBaIAIpAxAiXnwiWiBXIFlUIFcgWFZyrXwiVzcDECACIFsgAikDGCJgfCJbIFogXlQgVyBaVHKtfCJaNwMYIAIgECkDOCJhIFp8Il4gECkDMCJcIFd8IlkgXFQgWSAQKQMoIl8gWHwiXCBfVCBcIBApAyAiXyBdfCJiIF9UrXwiXyBcVHKtfCJcIFlUcq18IlkgWiBbIGBUIFogW1RyIF4gYVQgWSBeVHJzIgEbNwMYIAIgXCBXIAEbNwMQIAIgXyBYIAEbNwMIIAIgYiBdIAEbNwMAIA5BAWoiDiAIRw0ACwsgDEEBaiIMIAVJDQALCyAaECtBACEmQQAhCQJAIB5FDQAgHkGAgIDAAE8NASAeQQV0IgIQogkhCSACRQ0AIAlBACAC/AsACwJAIBUoAgQiAkUNACACQavVqhVPDQYgAkHgAGwiAhCiCSEmIAIgAkHgAGtB4ABwayICRQ0AICZBACAC/AsAC0EAIQhBACEKAkAgFSgCJCAVKAIwbCICRQ0AIAJBgICAwABPDQEgAkEFdCICEKIJIQogAkUNACAKQQAgAvwLAAsgByAJIB4gEBDtCiAHICYgFSgCBEEDbCAQEO0KIAogFSAeICUgIiAJICogJiAQEPoKIBIoAqgBIR8gFSgCGCECIBUoAhQhASAhKAIEIQ4gISgCACERQSgQogkgASACIA4gERDgCiEeAkAgFSgCGCIORQ0AIBUoAnAgFSgCECAVKAJAbEEFdGohASAOQQNxIRhBACERQQAhAiAOQQRPBEAgDkF8cSEbA0AgHyACQQV0Ig5qIhMgASAOaiII/QADAP0LAwAgEyAI/QADEP0LAxAgHyAOQSByIhNqIgggASATaiIT/QADEP0LAxAgCCAT/QADAP0LAwAgHyAOQcAAciITaiIIIAEgE2oiE/0AAxD9CwMQIAggE/0AAwD9CwMAIB8gDkHgAHIiDmoiEyABIA5qIg79AAMQ/QsDECATIA79AAMA/QsDACACQQRqIgIgG0cNAAsLIBgEQANAIB8gAkEFdCIOaiITIAEgDmoiDv0AAwD9CwMAIBMgDv0AAxD9CwMQIAJBAWohAiARQQFqIhEgGEcNAAsLIBUoAhgiAkUEQEEAIQgMAQsgAkGAgIDAAE8NASACQQV0IgIQogkhCCACRQ0AIAhBACAC/AsACwJAAkAgFSgCMARAIAhB4ABqIQwgCEFAayEaIAhBIGohBSAQQegAaiECQQAhHQNAAkAgFSgCICIgRQ0AICBBA3EhG0EAIRNBACEBICBBBE8EQCAgQXxxIQQDQCAIIAFBBXQiDmoiESAC/QADAP0LAwAgESACQRBqIhH9AAMA/QsDECAFIA5qIhggEf0AAwD9CwMQIBggAv0AAwD9CwMAIA4gGmoiGCAR/QADAP0LAxAgGCAC/QADAP0LAwAgDCAOaiIOIBH9AAMA/QsDECAOIAL9AAMA/QsDACABQQRqIgEgBEcNAAsLIBtFDQADQCAIIAFBBXRqIg4gAv0AAwD9CwMAIA4gAv0AAxD9CwMQIAFBAWohASATQQFqIhMgG0cNAAsLAkAgFSgCJCIBRQ0AIAFBBXQiDkUNACAIICBBBXRqIAogASAdbEEFdGogDvwKAAALIB4gCBDiCiAVKAIYIB8gCCAVKAJwIBUoAhAgFSgCSCAdamxBBXRqIBAQ+wogHUEBaiIdIBUoAjBJDQALDAELIAhFDQELIAgQKwsgHigCHCICBEAgHiACNgIgIAIQKwsgHigCECICBEAgHiACNgIUIAIQKwsgHigCDCECQQAhISAeQQA2AgwgAgRAIAIoAlwiAQRAIAIgATYCYCABECsLIAIQKwsgHhArIAoQKyAmECsgCRArIBUoAiwiAgRAIAJBgICAwABPDQEgAkEFdCIBEKIJISEgAQRAICFBACAB/AsACyAHICEgAiAQEO0KCyASKALAASEqIBIoArQBISYCQCAVKAIYIhFFBEBBACEOQQAhGwwBCyARQYCAgMAATw0BQQAhAiARQQV0IgEQogkhGyABRSITRQRAIBtBACAB/AsACyABEKIJIQ4gE0UEQCAOQQAgAfwLAAsgEUEDcSEYIBUoAnAgFSgCECAVKAJEbEEFdGohASARQQRPBEAgEUH8//8/cSEEA0AgGyACQQV0IhFqIhMgASARaiII/QADAP0LAwAgEyAI/QADEP0LAxAgGyARQSByIhNqIgggASATaiIT/QADEP0LAxAgCCAT/QADAP0LAwAgGyARQcAAciITaiIIIAEgE2oiE/0AAxD9CwMQIAggE/0AAwD9CwMAIBsgEUHgAHIiEWoiEyABIBFqIhH9AAMQ/QsDECATIBH9AAMA/QsDACACQQRqIgIgBEcNAAsLIBhFDQBBACERA0AgGyACQQV0IhNqIgggASATaiIT/QADAP0LAwAgCCAT/QADEP0LAxAgAkEBaiECIBFBAWoiESAYRw0ACwsgFSgCLCICBEAgAiAVKAJMIh5qIgogAmohCSAVKAIYIQhBACEfIAZBuClqIQQgBkGoKWohDANAIBUoAhAhHSAVKAJwISACQCAIRQ0AICAgHSAJIB9qbEEFdGohAUEAIRNBACECIAhBBE8EQCAIQXxxIQUDQCAOIAJBBXQiEWoiGCABIBFqIhr9AAMA/QsDACAYIBr9AAMQ/QsDECAOIBFBIHIiGGoiGiABIBhqIhj9AAMQ/QsDECAaIBj9AAMA/QsDACAOIBFBwAByIhhqIhogASAYaiIY/QADEP0LAxAgGiAY/QADAP0LAwAgDiARQeAAciIRaiIYIAEgEWoiEf0AAxD9CwMQIBggEf0AAwD9CwMAIAJBBGoiAiAFRw0ACwsgCEEDcSIaRQ0AA0AgDiACQQV0IhFqIhggASARaiIR/QADAP0LAwAgGCAR/QADEP0LAxAgAkEBaiECIBNBAWoiEyAaRw0ACwsgCCAOICAgHSAeIB9qbEEFdGogICAdIAogH2psQQV0aiAQEPwKIBUoAhghCCAGQbAoaiAhIB9BBXRqIgL9AAMQ/QsDACAGIAL9AAMA/QsDoChBACERIAgEQANAIAZBsClqIgEgDiARQQV0IgJqIhP9AAMQ/QsDACAGIBP9AAMA/QsDoCkgECAGQaApaiAGQaAoahCkCSACIBtqIgIgECkDOCJgIAIpAxgiYSAEKQMAfCJdIAIpAxAiVyABKQMAfCJYIFdUIFggAikDCCJaIAwpAwB8IlcgWlQgVyACKQMAIlsgBikDoCl8IlogW1StfCJbIFdUcq18IlcgWFRyrXwiWHwiXiAQKQMwIlwgV3wiWSBcVCBZIBApAygiXyBbfCJcIF9UIFwgECkDICJfIFp8ImIgX1StfCJfIFxUcq18IlwgWVRyrXwiWSBYIF0gYVQgWCBdVHIgXiBgVCBZIF5UcnMiARs3AxggAiBcIFcgARs3AxAgAiBfIFsgARs3AwggAiBiIFogARs3AwAgEUEBaiIRIAhHDQALCyAfQQFqIh8gFSgCLEkNAAsLIBUoAiAhCAJAIBUoAiQiEUUNACAbIAhBBXRqIRMgECkDgAEhWiAQKQN4IVcgECkDcCFYIBApA2ghXUEAIQEDQAJAIBMgAUEFdGoiAikDACBdUg0AIAIpAwggWFINACACKQMQIFdSDQAgAikDGCBaUg0AIBEgAUEBaiIBRw0BDAILCyAGQaWoKjYCcEHkAEH0hyogBkHwAGoQmwlBkJY0KAIAKAIAIQIgBkGlqCo2AmAgAkGRjCogBkHgAGoQbAALAkAgCEUNACAIQQV0IgJFDQAgJiAbIAL8CgAACwJAIBUoAhgiASAVKAIUIgJGDQAgASACa0EFdCIBRQ0AICogGyACQQV0aiAB/AoAAAsgDgRAIA4QKwsgGwRAIBsQKwsgIRArIAcgEigCnAEgFSgCFCAQEPgKIAcgEigCqAEgFSgCGCAQEPgKIAcgEigCtAEgFSgCICAQEPgKIAcgEigCwAEgFSgCGCAVKAIUayAQEPgKAkAgFSgCDCICRQRAQQAhEAwBCyACQYCAgIAETw0HIAJBAnQiAhCiCSEQIAJFDQAgEEEAIAL8CwALIBAgFSAHEOoKIBUoAjQiAgRAQQAhGANAIBUoAgwiEQRAIBUoAnAgFSgCECAYbEEFdGogFSgCGEEFdGohASASKALMASASKAKUASAYbEEFdGohDkEAIQICQCARQQFHBEAgEUEBcSEbIBFBfnEhCANAIA4gAkEFdGoiESABIBAgAkECdGooAgBBBXRqIhP9AAMA/QsDACARIBP9AAMQ/QsDECAOIAJBAXIiEUEFdGoiEyABIBAgEUECdGooAgBBBXRqIhH9AAMA/QsDACATIBH9AAMQ/QsDECACQQJqIgIgCEcNAAsgG0UNAQsgDiACQQV0aiIOIAEgECACQQJ0aigCAEEFdGoiAv0AAwD9CwMAIA4gAv0AAxD9CwMQCyAVKAI0IQILIBhBAWoiGCACSQ0ACwsCQCAVKAIMIhNFDQBBACECIBNBAUcEQCATQQFxIQggE0F+cSERA0AgEigC2AEgAkEFdGoiASAVKAJkIBAgAkECdGooAgBBBXRqIg79AAAA/QsAACABIA79AAAQ/QsAECASKALYASACQQFyIgFBBXRqIg4gFSgCZCAQIAFBAnRqKAIAQQV0aiIB/QAAAP0LAAAgDiAB/QAAEP0LABAgAkECaiICIBFHDQALIAhFDQELIBIoAtgBIAJBBXRqIgEgFSgCZCAQIAJBAnRqKAIAQQV0aiIC/QAAAP0LAAAgASAC/QAAEP0LABALIBVB1ABqIBJB5AFqIBAgExDrCiAQECtB5ABB6vMqQQAQmwkgBigCoCUiAgRAIAIQKwsgIhArIC8EQCAvECsLQQEMCgsQoAkACyAGQcfyKzYCkAJB5ABB9IcqIAZBkAJqEJsJQZCWNCgCACgCACECIAZBx/IrNgKAAiACQZGMKiAGQYACahBsAAsgBkG78is2AvABQeQAQfSHKiAGQfABahCbCUGQljQoAgAoAgAhAiAGQbvyKzYC4AEgAkGRjCogBkHgAWoQbAALIAZBx/IrNgLQAUHkAEH0hyogBkHQAWoQmwlBkJY0KAIAKAIAIQIgBkHH8is2AsABIAJBkYwqIAZBwAFqEGwACyAGQbvyKzYCsAFB5ABB9IcqIAZBsAFqEJsJQZCWNCgCACgCACECIAZBu/IrNgKgASACQZGMKiAGQaABahBsAAsQoAkACxCgCQALIAZBzv0pNgKQBEHkAEH0hyogBkGQBGoQmwlBkJY0KAIAKAIAIQIgBkHO/Sk2AoAEIAJBkYwqIAZBgARqEGwACxCgCQALQQFBp/8rQQAQmwlBAAshASALKAIIIgIEQCALIAI2AgwgAhArCyALECsLA0AgNEEEayI0KAIAIQIgNEEANgIAIAIEQCACKAIIIhAEQCACIBA2AgwgEBArCyACECsLICkgNEcNAAsgKRArIAZBvM0xNgLQIiAGKALIIyECIAZBADYCyCMgAgRAIAIQKwsgBkGgKmokACABRQ0AQeQAQdONK0EAEJsJIA1BADYCrAYgDUIANwKkBgJAIBIoAgggFCgCCCAUKAIEa2ogFCgClAEgFCgCmAFBBXQgFCgCkAFBBHRqbGogEigCBGsgEigCgAFBBnRqIBQoAoABIBIoApQBIBIoApgBIBIoApABamxqQQV0akGgAWoiAyANQaQGaiICKAIIIAIoAgAiBGtNDQAgA0EATgRAIAIoAgQhASADEKIJIQogASAEayIBBEAgCiAEIAH8CgAACyACIAMgCmo2AgggAiABIApqNgIEIAIgCjYCACAERQ0BIAQQKwwBCxCgCQALIA1BpAZqIA0oAqQGIA1BsAZqIA1BkAdqQeAAEKcJQQAhBEEAIQNBACERIwBB8ABrIgwkACANQaQGaiIFKAIAIR4gBSAFKAIEIh8gFCICQeAAaiACQYABaiIKQSAQpQkCQCACKAIAKAIMRQRAIAUoAgAiFSETIAUoAgQiGCEIIAIoAgQiASACKAIIRwRAIAxB8ABqIQkDQEEAIQ8gBEEMbCIXIAIoAgAoAiBqKAIEBEADQCAMIA9BMGwiCyAEQaAybCIBIAIoAgRqav0ABIAU/QsEYCAFIAUoAgQgDEHgAGogCUEQEKcJIAwgAigCBCABaiALav0ABIAj/QsEYCAFIAUoAgQgDEHgAGogCUEQEKcJIAwgAigCBCABaiALav0ABKAU/QsEYCAFIAUoAgQgDEHgAGogCUEQEKcJIAwgAigCBCABaiALav0ABKAj/QsEYCAFIAUoAgQgDEHgAGogCUEQEKcJIA9BAWoiDyACKAIAKAIgIBdqKAIESQ0ACyACKAIEIQELIAwgASAEQaAybCILav0ABIAy/QsEYCAFIAUoAgQgDEHgAGogCUEQEKcJIAwgAigCBCALav0ABJAy/QsEYCAFIAUoAgQgDEHgAGogCUEQEKcJIARBAWoiBCACKAIIIAIoAgQiAWtBoDJtSQ0ACyAFKAIEIQggBSgCACETCyAKKAIABEAgDEHwAGohAUEAIQkDQCAMIAIoApwBIAlBBHRq/QAEAP0LBGAgBSAFKAIEIAxB4ABqIAFBEBCnCSAJQQFqIgkgAigCgAFJDQALCyACKAKEAUUEQEEAIQEMAgsgDEHwAGohC0EAIQkDQCAMIAIoAqgBIAlBBHRq/QAEAP0LBGAgBSAFKAIEIAxB4ABqIAtBEBCnCSAJQQFqIgkgAigChAEiAUkNAAsMAQsgDEHA8ys2AlBB5ABB9IcqIAxB0ABqEJsJQZCWNCgCACgCACEJIAxBwPMrNgJAIAlBkYwqIAxBQGsQbAALIAIoAogBBH8gDEHwAGohAUEAIQkDQCAMIAIoArQBIAlBBHRq/QAEAP0LBGAgBSAFKAIEIAxB4ABqIAFBEBCnCSAJQQFqIgkgAigCiAFJDQALIAIoAoQBBSABCyAKKAIARwRAIAxB8ABqIQFBACEJA0AgDCACKALAASAJQQR0av0ABAD9CwRgIAUgBSgCBCAMQeAAaiABQRAQpwkgCUEBaiIJIAIoAoQBIAIoAoABa0kNAAsLAkAgAigClAFFBEBBACEBDAELQQAhCQNAIAUgBSgCBCACKALYASAJQQV0aiIBIAFBIGpBIBClCSAJQQFqIgkgAigClAEiAUkNAAsLAkACQCACKAKQASABbCIGBEAgHEGwBGohFyAcQbACaiEPIBxBsAVqIQsgDEHgAGohGiAMQfAAaiEbA0AgAyEEIAIoAswBIRxBACEKA0AgDCAcIAQgCmoiA0EEdGr9AAQAIm79CwRgIG79HQEhVyBu/R0AIVhBACEJA0ACQCALIAlBAnRqKAIAIgFB/wBLDQAgDEHgAGogAUEDdkH4////AXFqKQMAIAFBP3GtiEIBg1ANACAMIA8gCUEEdGoiASkDACBYhSJYNwNgIAwgASkDCCBXhSJXNwNoCyAJQQFqIglBEEcNAAsCQCARQQFxIh0gVyBYhFBHBEAgCiEBDAELIApBAWoiASAEaiIDIAZPDQAgCkH///8PSSEJIAEhCiAJDQELCyAFKAIEIQlBACEGA0ACQCAFKAIIIgogCUsEQCAJIAE6AAAgCUEBaiEJDAELIAkgBSgCACIcayIJQQFqIg5BAEgNBCAJQf////8HIAogHGsiCkEBdCIQIA4gDiAQSRsgCkH/////A08bIg4EfyAOEKIJBUEACyIKaiIQIAE6AAAgCQRAIAogHCAJ/AoAAAsgBSAKIA5qNgIIIAUgEEEBaiIJNgIEIAUgCjYCACAcRQ0AIBwQKwsgBSAJNgIEIAFBCHYhASAGQQFqIgZBBEcNAAsCQCADIARNDQADQAJAIAIoAswBIARBBHRqIQkCQCAdBEAgDCAJ/QAEACJu/QsEYCBu/R0BIVcgbv0dACFYQgAhWUEAIQkDQAJAIAsgCUECdGooAgAiAUH/AEsNACAMQeAAaiABQQN2Qfj///8BcWopAwAgAUE/ca2IQgGDUA0AIAwgDyAJQQR0aiIBKQMAIFiFIlg3A2AgDCABKQMIIFeFIlc3A2ggFyAJQQN0aikDACBZhSFZCyAJQQFqIglBEEcNAAsgVyBYhEIAUg0CIAwgWT0AXiAFIAUoAgQgDEHeAGogGkECEKcJDAELIAwgCf0ABAD9CwRgIAUgBSgCBCAMQeAAaiAbQRAQpwkLIAMgBEEBaiIERw0BDAILCyAMQYClKTYCMEHkAEH0hyogDEEwahCbCUGQljQoAgAoAgAhCSAMQYClKTYCICAJQZGMKiAMQSBqEGwACyARQQFzIREgAyACKAKQASACKAKUAWwiBkkNAAsLIAIoAugBIAIoAuQBa0EFdSEBIAUoAgQhCUEAIQQDQAJAIAUoAggiCyAJSwRAIAkgAToAACAJQQFqIQkMAQsgCSAFKAIAIg9rIglBAWoiF0EASA0CQf////8HIAsgD2siC0EBdCIKIBcgCiAXSxsgC0H/////A08bIhcEfyAXEKIJBUEACyILIAlqIgogAToAACAJBEAgCyAPIAn8CgAACyAFIAsgF2o2AgggBSAKQQFqIgk2AgQgBSALNgIAIA9FDQAgDxArCyAFIAk2AgQgAUEIdiEBIARBAWoiBEEERw0AC0EAIQECQCACKALkASILIAIoAugBRgRAQQAhDwwBCwNAIAUgBSgCBCALIAFBBXRqIgkgCUEgakEgEKUJIAFBAWoiASACKALoASACKALkASILa0EFdSIPSQ0ACyAFKAIEIQkLIAIoAoABIQEgAigClAEhCyAFKAIAIQUgDCACKAKQASICNgIYIAwgDzYCFCAMIAkgBWsiCTYCHCAMIAIgC2w2AhAgDCABQQF0NgIMIAwgCCATayIBIBggFWsiC2s2AgQgDCAeIB9rIAtqNgIAIAwgCSABazYCCEHkAEHWyCsgDBCbCSAMQfAAaiQADAELEKAJAAtBACELQQAhDkEAIQkjAEGAAWsiBSQAIA1BpAZqIhwoAgAhGiAcIBwoAgQiGyASIgRB4ABqIARBgAFqIhdBIBClCQJAIAQoAgAoAgxFBEAgHCgCACIRIRMgHCgCBCIVIQggBCgCBCICIAQoAghHBEADQEEAIQogC0EMbCIPIAQoAgAoAiBqKAIEBEADQCAKQeAAbCIBIAtBwOQAbCICIAQoAgRqaiID/QADgCggA0GQKGr9AAMAIBwQ/QogBCgCBCACaiABaiID/QADgEYgA0GQxgBq/QADACAcEP0KIAQoAgQgAmogAWoiA/0AA8AoIANB0Chq/QADACAcEP0KIAQoAgQgAmogAWoiAv0AA8BGIAJB0MYAav0AAwAgHBD9CiAKQQFqIgogBCgCACgCICAPaigCBEkNAAsgBCgCBCECCyACIAtBwOQAbCIBaiIC/QADgGQgAkGQ5ABq/QADACAcEP0KIAQoAgQgAWoiAv0AA6BkIAJBsOQAav0AAwAgHBD9CiALQQFqIgsgBCgCCCAEKAIEIgJrQcDkAG1JDQALIBwoAgQhCCAcKAIAIRMLIBcoAgAEQEEAIQIDQCAEKAKcASACQQV0aiIB/QADACAB/QADECAcEP0KIAJBAWoiAiAEKAKAAUkNAAsLIAQoAoQBRQRAQQAhAQwCC0EAIQIDQCAEKAKoASACQQV0aiIB/QADACAB/QADECAcEP0KIAJBAWoiAiAEKAKEASIBSQ0ACwwBCyAFQcDzKzYCMEHkAEH0hyogBUEwahCbCUGQljQoAgAoAgAhHCAFQcDzKzYCICAcQZGMKiAFQSBqEGwACyAEKAKIAQR/QQAhAgNAIAQoArQBIAJBBXRqIgH9AAMAIAH9AAMQIBwQ/QogAkEBaiICIAQoAogBSQ0ACyAEKAKEAQUgAQsgFygCAEcEQEEAIQIDQCAEKALAASACQQV0aiIB/QADACAB/QADECAcEP0KIAJBAWoiAiAEKAKEASAEKAKAAWtJDQALCwJAIAQoApQBRQRAQQAhAQwBC0EAIQIDQCAcIBwoAgQgBCgC2AEgAkEFdGoiASABQSBqQSAQpQkgAkEBaiICIAQoApQBIgFJDQALCwJAAkAgBCgCkAEgAWwiCwRAIAVB4ABqIRgDQCAJIgMhAkEAIQoDQCACIgxBAWohAiAKIgFBAWohCiABQYCAgBBJIAEgA2oiCSALSXEgDnENAAsgHCgCBCECQQAhFyABIQoDQAJAIBwoAggiCyACSwRAIAIgCjoAACACQQFqIQIMAQsgAiAcKAIAIg9rIgJBAWoiBkEASA0EQf////8HIAsgD2siC0EBdCIQIAYgBiAQSRsgC0H/////A08bIgYEfyAGEKIJBUEACyILIAJqIhAgCjoAACACBEAgCyAPIAL8CgAACyAcIAYgC2o2AgggHCAQQQFqIgI2AgQgHCALNgIAIA9FDQAgDxArCyAcIAI2AgQgCkEIdiEKIBdBAWoiF0EERw0ACyABBEADQCAEKALMASADQQV0aiIC/QADACFuIAL9AAMQIW8CQCAOQQFxBEAgBUHgAGpBsIg0IG4gbxCZCSAFIAX9AANg/QsEQCAFIAX9AANw/QsEUCAcIBwoAgQgBUFAayAYQSAQpwkMAQsgbiBvIBwQ/QoLIANBAWoiAyAMRw0ACwsgDkEBcyEOIAkgBCgCkAEgBCgClAFsIgtJDQALCyAEKALoASAEKALkAWtBBXUhASAcKAIEIQJBACELA0ACQCAcKAIIIgogAksEQCACIAE6AAAgAkEBaiECDAELIAIgHCgCACIDayICQQFqIg9BAEgNAkH/////ByAKIANrIgpBAXQiFyAPIA8gF0kbIApB/////wNPGyIPBH8gDxCiCQVBAAsiCiACaiIXIAE6AAAgAgRAIAogAyAC/AoAAAsgHCAKIA9qNgIIIBwgF0EBaiICNgIEIBwgCjYCACADRQ0AIAMQKwsgHCACNgIEIAFBCHYhASALQQFqIgtBBEcNAAtBACEBAkAgBCgC5AEiCiAEKALoAUYEQEEAIQMMAQsDQCAcIBwoAgQgCiABQQV0aiICIAJBIGpBIBClCSABQQFqIgEgBCgC6AEgBCgC5AEiCmtBBXUiA0kNAAsgHCgCBCECCyAEKAKAASEBIAQoApQBIQogHCgCACEcIAUgBCgCkAEiBDYCGCAFIAM2AhQgBSACIBxrIhw2AhwgBSAEIApsNgIQIAUgAUEBdDYCDCAFIAggE2siAiAVIBFrIgRrNgIEIAUgGiAbayAEajYCACAFIBwgAms2AghB5ABB1sgrIAUQmwkgBUGAAWokAAwBCxCgCQALIEQgDSgCqAYgDSgCpAYiCmsiAzYCACANIAM2AgBB5ABBp4gsIA0QmwkgRyBEKAIAECoiAjYCACADBEAgAiAKIAP8CgAACyAKBEAgChArC0EAIQMLIBkoAjghASAZQQA2AjggAQRAIAEoAnAiCgRAIAEgCjYCdCAKECsLIAEoAmQiCgRAIAEgCjYCaCAKECsLIAEoAlgiCgRAIAEgCjYCXCAKECsLIAEQKwsgGSgCLCIBBEAgGSABNgIwIAEQKwsgGSgCICIBBEAgGSABNgIkIAEQKwsgGSgCFCIBBEAgGSABNgIYIAEQKwsgFigCOCEBIBZBADYCOCABBEAgASgCcCIKBEAgASAKNgJ0IAoQKwsgASgCZCIKBEAgASAKNgJoIAoQKwsgASgCWCIKBEAgASAKNgJcIAoQKwsgARArCyAWKAIsIgEEQCAWIAE2AjAgARArCyAWKAIgIgEEQCAWIAE2AiQgARArCyAWKAIUIgEEQCAWIAE2AhggARArCyASKALkASIWBEAgEiAWNgLoASAWECsLIBIoAtgBIhYEQCASIBY2AtwBIBYQKwsgEigCzAEiFgRAIBIgFjYC0AEgFhArCyASKALAASIWBEAgEiAWNgLEASAWECsLIBIoArQBIhYEQCASIBY2ArgBIBYQKwsgEigCqAEiFgRAIBIgFjYCrAEgFhArCyASKAKcASIWBEAgEiAWNgKgASAWECsLIBIoAgQiFgRAIBIgFjYCCCAWECsLIBQoAuQBIhIEQCAUIBI2AugBIBIQKwsgFCgC2AEiEgRAIBQgEjYC3AEgEhArCyAUKALMASISBEAgFCASNgLQASASECsLIBQoAsABIhIEQCAUIBI2AsQBIBIQKwsgFCgCtAEiEgRAIBQgEjYCuAEgEhArCyAUKAKoASISBEAgFCASNgKsASASECsLIBQoApwBIhIEQCAUIBI2AqABIBIQKwsgFCgCBCISBEAgFCASNgIIIBIQKwsgB0G8zTE2AgAgBygCeCEUIAdBADYCeCAURQ0AIBQQKwsgDSgCvA8iBwRAIA0gBzYCwA8gBxArCyANKALQDyIHBEAgDSAHNgLUDyAHECsLIDMoAiAiFgRAIBYiByAzKAIkIhRHBEADQCAUQQRrIhIoAgAhByASQQA2AgAgBwRAIAcoAgQiEgRAIAcgEjYCCCASECsLIAcQKwsgFiAUQQxrIhRHDQALIDMoAiAhBwsgMyAWNgIkIAcQKwsgMxArCyAyKAIgIhYEQCAWIgcgMigCJCIURwRAA0AgFEEEayISKAIAIQcgEkEANgIAIAcEQCAHKAIEIhIEQCAHIBI2AgggEhArCyAHECsLIBYgFEEMayIURw0ACyAyKAIgIQcLIDIgFjYCJCAHECsLIDIQKwsgPhArCyANQfApaiQAIAMMDgsQoAkACyANQaPYKzYCoANB5ABB9IcqIA1BoANqEJsJQZCWNCgCACgCACEHIA1Bo9grNgKQAyAHQZGMKiANQZADahBsAAsgDUGj2Cs2AoADQeQAQfSHKiANQYADahCbCUGQljQoAgAoAgAhByANQaPYKzYC8AIgB0GRjCogDUHwAmoQbAALIA1Bo9grNgLgAkHkAEH0hyogDUHgAmoQmwlBkJY0KAIAKAIAIQcgDUGj2Cs2AtACIAdBkYwqIA1B0AJqEGwACyANQaPYKzYCwAJB5ABB9IcqIA1BwAJqEJsJQZCWNCgCACgCACEHIA1Bo9grNgKwAiAHQZGMKiANQbACahBsAAsgDUGj2Cs2AqACQeQAQfSHKiANQaACahCbCUGQljQoAgAoAgAhByANQaPYKzYCkAIgB0GRjCogDUGQAmoQbAALIA1Bo9grNgKAAkHkAEH0hyogDUGAAmoQmwlBkJY0KAIAKAIAIQcgDUGj2Cs2AvABIAdBkYwqIA1B8AFqEGwACyANQaPYKzYC4AFB5ABB9IcqIA1B4AFqEJsJQZCWNCgCACgCACEHIA1Bo9grNgLQASAHQZGMKiANQdABahBsAAsgDUGj2Cs2AsABQeQAQfSHKiANQcABahCbCUGQljQoAgAoAgAhByANQaPYKzYCsAEgB0GRjCogDUGwAWoQbAALIA1Bo9grNgKgAUHkAEH0hyogDUGgAWoQmwlBkJY0KAIAKAIAIQcgDUGj2Cs2ApABIAdBkYwqIA1BkAFqEGwACyANQaPYKzYCgAFB5ABB9IcqIA1BgAFqEJsJQZCWNCgCACgCACEHIA1Bo9grNgJwIAdBkYwqIA1B8ABqEGwACyANQaPYKzYCYEHkAEH0hyogDUHgAGoQmwlBkJY0KAIAKAIAIQcgDUGj2Cs2AlAgB0GRjCogDUHQAGoQbAALIA1Bo9grNgJAQeQAQfSHKiANQUBrEJsJQZCWNCgCACgCACEHIA1Bo9grNgIwIAdBkYwqIA1BMGoQbAALIA1Bo9grNgKABkHkAEH0hyogDUGABmoQmwlBkJY0KAIAKAIAIQcgDUGj2Cs2AvAFIAdBkYwqIA1B8AVqEGwACyESAkACQEGkiDQoAgAiB0UNACAjIC02AlwgBygCACIDICMoAlxLDQAgIygCXCADIAcoAhBqTw0AIC0gBygCBDYCACAHIC02AgQgByAHKAIIQQFqNgIIIAcoAhQiB0EESQ0BIAdBfHEiB0UNASAtQQAgB/wLAAwBCyAtECsLAkACQEGkiDQoAgAiB0UNACAjIC42AlwgBygCACIDICMoAlxLDQAgIygCXCADIAcoAhBqTw0AIC4gBygCBDYCACAHIC42AgQgByAHKAIIQQFqNgIIIAcoAhQiB0EESQ0BIAdBfHEiB0UNASAuQQAgB/wLAAwBCyAuECsLIBIEQCAjIBJBAnRBgKovaigCADYCECAAQYmJKiAjQRBqEJwBIAAoAgxBADoABCAAIAAoAgxBCGo2AgxBAQwBCyAjKAJUIRYgIygCUCEDIABBEEEBENoBIRIgAEHY4c59QcHiKRCQARogAEF+ENsBIBJBATYCDCASIAM2AgQgEiADNgIAIBIgFjYCCEEBCyEHID8QmgEgQBCaASBBEJoBAkAgN0UNAAJAQaSINCgCACISRQ0AICMgNzYCXCASKAIAIgMgIygCXEsNACAjKAJcIAMgEigCEGpPDQAgNyASKAIENgIAIBIgNzYCBCASIBIoAghBAWo2AgggEigCFCISQQRJDQEgEkF8cSISRQ0BIDdBACAS/AsADAELIDcQKwsgQxCaASAjQbf5KjYCACAAQeCHKiAjEJsBICNB4ABqJAAgBwupBQIIfwF+IwBBEGsiByQAAkACQAJAAkAgACgCFCgCAEEwaiICIAAoAgxJBEAgAi0ABEEPcUEFRw0BDAMLIAAoAhAtADBBD3FBBUYNAQsgB0EGNgIAIABB1MErIAcQbgwCCyAAKAIQQSxqIQILAkACQAJ/AkACQAJAAkAgAi0ABEE/cUEEaw4RAAMFAgUFBQUFBQUFBQUFBQEFCyACKAIALQAHDAMLIAIoAgAoAgwMAgsgAigCACgCCAwBCyACKAIAEPgFCyIIDQELIAFBADYCAAwBCyAIQegAEC4iBgRAIAAoAgwhA0EBIQQDQAJAAkAgBEEBayIFIAMgACgCFCgCAEEwaiICTQR/IAAoAhBBLGoFIAILKAIAIgIoAggiCU8EQCACLAAGQQBODQEgBUEAIAlrcSAJTw0BIAIgBDYCCCAAKAIMIQMLIAIoAgwgBUEDdGohAgwBCyACKAIQIASsIgpCHoggCoVCucuT59Htkay/f34iCkIbiCAKhULro8SZsbeS6JR/fiIKQh+IIAqFp0F/IAItAAd0QX9zcUEEdGohAgNAIAItAAVBA0YEQCACKAIMIARGDQILIAIgAigCCCIFQQR0aiECIAUNAAtB1LEvIQILIAMgAi0ABEEPcQR/IAMgAigCADYCACACLQAEBUEACzoABCAAIAAoAgwiBUEIaiICNgIMIAUtAARBD3FBBUYEfyAGIARB6ABsaiICQQhrIAAgAkHoAGtBqLArQSAQ+QU2AgAgAkEEayAAIAJByABrQZj9KkHAABD5BTYCACAAKAIMBSACC0EIayIDIAAoAiRNBEAgACADQX9BABBeIQMLIAAgAzYCDCAEQQFqIgQgCE0NAAsgASAINgIADAELQQAhBiAAQYu8K0EAEG4LIAdBEGokACAGC7CqAgMzfwh7E34jAEHwAWsiJyQAICdB9q4pNgJAIABB+YYqICdBQGsQmwEgAEEBEMgBIS8gAEECEMgBITAgAEEDEMgBIRsgAEEEEMgBIRQgAEEFEMgBITEgACAnQegBahD2BSEsIABBBxDIASEyIABBCBDIASEzICdBADYC7AECQAJ/IAAoAhQoAgBByABqIgYgACgCDE8EQCAAKAIQQSxqIQYLAkACQCAGLQAEQQNHBEAgBiAnQewBakEAEPwBIQUgJygC7AEiBkEESg0BIAUNAiAAQeu1KkEAEG5BAAwDCyAGKAIAIgZBBUgNAQsgJyAGNgIwIABB6N4qICdBMGoQbkEADAELIAZB0ABsQeDVMWoLIhYoAkgiBCAnKALoASIGRwRAICcgBDYCJCAnIAY2AiAgAEHK+isgJ0EgahBuDAELICdBsPABOwGgASAnQaABakECciEFIBsoAgghB0EAIQYDQCAFIAZBAXRqIgsgBiAHai0AACIJQQ9xQfDTMWotAAA6AAEgCyAJQQR2QfDTMWotAAA6AAAgBSAGQQFyIgtBAXRqIgkgByALai0AACILQQ9xQfDTMWotAAA6AAEgCSALQQR2QfDTMWotAAA6AAAgBkECaiIGQSBHDQALICdBsPABOwFQQQAhBiAnQQA6AOIBICdB0ABqQQJyIQUgFCgCCCEHA0AgBSAGQQF0aiILIAYgB2otAAAiCUEPcUHw0zFqLQAAOgABIAsgCUEEdkHw0zFqLQAAOgAAIAUgBkEBciILQQF0aiIJIAcgC2otAAAiC0EPcUHw0zFqLQAAOgABIAkgC0EEdkHw0zFqLQAAOgAAIAZBAmoiBkEgRw0ACyAnQQA6AJIBIBsQmgEgFBCaASAvKAIIIQUgLygCACETIDEoAgghKCAxKAIAISkgBCEJIDIoAgghJCAwKAIIIQsgMCgCACEUIDMoAgghJiMAQZAYayIHJABBBiEGAkAgBf0RICdBoAFqIgT9HAEgJ0HQAGoiG/0cAiAo/RwD/QwAAAAAAAAAAAAAAAAAAAAA/Tf9DP//AAD//wAA//8AAP//AAD9TiAk/REgLP0cASAL/RwCICb9HAP9DAAAAAAAAAAAAAAAAAAAAAD9N/0M//8AAP//AAD//wAA//8AAP1O/YYB/VMNACAWRQ0AIAQgGyAHQfAXaiAHQdAXahDICUUEQEEBQfitKUEAEJsJQQchBgwBC0EIIQYgB0HADGoQmAkhAyATQdCGA0kNACApRQ0AIAlFDQAgFEGgnAFJDQAgB0GYCWoQ0AohGkGAo8PHABCiCSIuQQBBgKPDxwD8CwAgLiAFIBMQ0QoiBEGJf08EQCAHIAQQ0go2AiBBAUGbiyogB0EgahCbCUEAIQQLIAcgBDYCEEHkAEHqwSkgB0EQahCbCSAHIC42ApQJAkAgB0GUCWogBBDTCiIqRQRAQQEhBkEBQcq5K0EAEJsJDAELAkAgB0GUCWogBCAuaiAHKAKUCWsQ1AoiK0UEQEEBIQZBAUHUuStBABCbCQwBCyArKAIUIQQgByAqKAIUNgIEIAcgBDYCAEHkAEGZ2SsgBxCbCSAHQaQHaiArENcKIRsgB0G0BWogKhDYCiEiAkACQAJAAkAgFEEATgRAIBQQogkhLSAUBEAgLSALIBT8CgAACyAHQdAEaiAtQeAA/AoAACAbIC39AABg/QsCYCAbIC39AABw/QsCcCAHIC1BgAFqIgQ2ArAFIBsoAgAoAgwNAyAUIC1qIRwgGygCBCIGIBsoAghHBEBBACETA0AgHCAEayATQQxsIhcgGygCACgCIGooAgQiBUEGdEEgckkNBUEAIRYgBCELIAUEQANAIAcgBEEBaiIGNgKwBSAE/QcAACE1IAcgBEECaiIFNgKwBSAGIDX9VAAAASE1IAcgBEEDaiILNgKwBSAFIDX9VAAAAiE1IAcgBEEEaiIUNgKwBSAWQTBsIgUgE0GgMmwiBiAbKAIEamogBEEPaiAEQQ5qIARBDWogBEEMaiAEQQtqIARBCmogBEEJaiAEQQhqIARBB2ogBEEGaiAEQQVqIBQgCyA1/VQAAAP9VAAABP1UAAAF/VQAAAb9VAAAB/1UAAAI/VQAAAn9VAAACv1UAAAL/VQAAAz9VAAADf1UAAAO/VQAAA/9CwSAFCAEQR5qIARBHWogBEEcaiAEQRtqIARBGmogBEEZaiAEQRhqIARBF2ogBEEWaiAEQRVqIARBFGogBEETaiAEQRJqIARBEWogBP0HABD9VAAAAf1UAAAC/VQAAAP9VAAABP1UAAAF/VQAAAb9VAAAB/1UAAAI/VQAAAn9VAAACv1UAAAL/VQAAAz9VAAADf1UAAAOITUgByAEQSBqIgs2ArAFIBsoAgQgBmogBWogBEEfaiA1/VQAAA/9CwSAIyAbKAIEIAZqIAVqQZAUav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgGygCBCAGaiAFakGQI2r9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAcgBEEhaiIUNgKwBSAL/QcAACE1IAcgBEEiaiILNgKwBSAUIDX9VAAAASE1IAcgBEEjaiIUNgKwBSALIDX9VAAAAiE1IAcgBEEkaiILNgKwBSAbKAIEIAZqIAVqIARBL2ogBEEuaiAEQS1qIARBLGogBEEraiAEQSpqIARBKWogBEEoaiAEQSdqIARBJmogBEElaiALIBQgNf1UAAAD/VQAAAT9VAAABf1UAAAG/VQAAAf9VAAACP1UAAAJ/VQAAAr9VAAAC/1UAAAM/VQAAA39VAAADv1UAAAP/QsEoBQgBEE+aiAEQT1qIARBPGogBEE7aiAEQTpqIARBOWogBEE4aiAEQTdqIARBNmogBEE1aiAEQTRqIARBM2ogBEEyaiAEQTFqIARBMGr9BwAA/VQAAAH9VAAAAv1UAAAD/VQAAAT9VAAABf1UAAAG/VQAAAf9VAAACP1UAAAJ/VQAAAr9VAAAC/1UAAAM/VQAAA39VAAADiE1IAcgBEFAayILNgKwBSAbKAIEIAZqIAVqIARBP2ogNf1UAAAP/QsEoCMgCyEEIBZBAWoiFiAbKAIAKAIgIBdqKAIESQ0ACyAbKAIEIQYLIAcgC0EBaiIENgKwBSAL/QcAACE1IAcgC0ECaiIFNgKwBSAEIDX9VAAAASE1IAcgC0EDaiIENgKwBSAFIDX9VAAAAiE1IAcgC0EEaiIFNgKwBSAGIBNBoDJsIhZqIAtBD2ogC0EOaiALQQ1qIAtBDGogC0ELaiALQQpqIAtBCWogC0EIaiALQQdqIAtBBmogC0EFaiAFIAQgNf1UAAAD/VQAAAT9VAAABf1UAAAG/VQAAAf9VAAACP1UAAAJ/VQAAAr9VAAAC/1UAAAM/VQAAA39VAAADv1UAAAP/QsEgDIgC0EeaiALQR1qIAtBHGogC0EbaiALQRpqIAtBGWogC0EYaiALQRdqIAtBFmogC0EVaiALQRRqIAtBE2ogC0ESaiALQRFqIAv9BwAQ/VQAAAH9VAAAAv1UAAAD/VQAAAT9VAAABf1UAAAG/VQAAAf9VAAACP1UAAAJ/VQAAAr9VAAAC/1UAAAM/VQAAA39VAAADiE1IAcgC0EgaiIENgKwBSAbKAIEIBZqIAtBH2ogNf1UAAAP/QsEkDIgE0EBaiITIBsoAgggGygCBCIGa0GgMm1JDQALCyAcIARrIhYgGygCgAEiBkEEdEkNAwJAIAZFBEAgBCEGDAELQQAhBQNAIAcgBEEBaiIGNgKwBSAE/QcAACE1IAcgBEECaiILNgKwBSAGIDX9VAAAASE1IAcgBEEDaiIGNgKwBSALIDX9VAAAAiE1IAcgBEEEaiILNgKwBSAEQQ5qIARBDWogBEEMaiAEQQtqIARBCmogBEEJaiAEQQhqIARBB2ogBEEGaiAEQQVqIAsgBiA1/VQAAAP9VAAABP1UAAAF/VQAAAb9VAAAB/1UAAAI/VQAAAn9VAAACv1UAAAL/VQAAAz9VAAADf1UAAAOITUgByAEQRBqIgY2ArAFIBsoApwBIAVBBHRqIARBD2ogNf1UAAAP/QsEACAGIQQgBUEBaiIFIBsoAoABSQ0ACyAcIARrIRYLIBYgGygChAEiBEEEdEkNAwJAIARFBEBBACELDAELQQAhBANAIAcgBkEBaiIFNgKwBSAG/QcAACE1IAcgBkECaiILNgKwBSAFIDX9VAAAASE1IAcgBkEDaiIFNgKwBSALIDX9VAAAAiE1IAcgBkEEaiILNgKwBSAGQQ5qIAZBDWogBkEMaiAGQQtqIAZBCmogBkEJaiAGQQhqIAZBB2ogBkEGaiAGQQVqIAsgBSA1/VQAAAP9VAAABP1UAAAF/VQAAAb9VAAAB/1UAAAI/VQAAAn9VAAACv1UAAAL/VQAAAz9VAAADf1UAAAOITUgByAGQRBqIgU2ArAFIBsoAqgBIARBBHRqIAZBD2ogNf1UAAAP/QsEACAFIQYgBEEBaiIEIBsoAoQBIgtJDQALIBwgBWshFgsgFiAbKAKIASIEQQR0SQ0DAkAgBEUEQCAGIQQMAQtBACEFA0AgByAGQQFqIgQ2ArAFIAb9BwAAITUgByAGQQJqIgs2ArAFIAQgNf1UAAABITUgByAGQQNqIgQ2ArAFIAsgNf1UAAACITUgByAGQQRqIgs2ArAFIAZBDmogBkENaiAGQQxqIAZBC2ogBkEKaiAGQQlqIAZBCGogBkEHaiAGQQZqIAZBBWogCyAEIDX9VAAAA/1UAAAE/VQAAAX9VAAABv1UAAAH/VQAAAj9VAAACf1UAAAK/VQAAAv9VAAADP1UAAAN/VQAAA4hNSAHIAZBEGoiBDYCsAUgGygCtAEgBUEEdGogBkEPaiA1/VQAAA/9CwQAIAQhBiAFQQFqIgUgGygCiAFJDQALIBwgBGshFiAbKAKEASELCyAWIAsgGygCgAEiBmtBBHRJDQMCQCAGIAtGBEAgBCEGDAELQQAhBQNAIAcgBEEBaiIGNgKwBSAE/QcAACE1IAcgBEECaiILNgKwBSAGIDX9VAAAASE1IAcgBEEDaiIGNgKwBSALIDX9VAAAAiE1IAcgBEEEaiILNgKwBSAEQQ5qIARBDWogBEEMaiAEQQtqIARBCmogBEEJaiAEQQhqIARBB2ogBEEGaiAEQQVqIAsgBiA1/VQAAAP9VAAABP1UAAAF/VQAAAb9VAAAB/1UAAAI/VQAAAn9VAAACv1UAAAL/VQAAAz9VAAADf1UAAAOITUgByAEQRBqIgY2ArAFIBsoAsABIAVBBHRqIARBD2ogNf1UAAAP/QsEACAGIQQgBUEBaiIFIBsoAoQBIBsoAoABa0kNAAsgHCAEayEWCyAWIBsoApQBIgRBBXRJDQMgBEUEQEEAIQQMAwtBACEGA0AgGygC2AEhBCAHIAcoArAFIgVBAWo2ArAFIAQgBkEFdGoiBCAFLQAAOgAAIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgABIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgACIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgADIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAEIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAFIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAGIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAHIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAIIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAJIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAKIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgALIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAMIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgANIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAOIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAPIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAQIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgARIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgASIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgATIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAUIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAVIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAWIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAXIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAYIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAZIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAaIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAbIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAcIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAdIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAeIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAfIAZBAWoiBiAbKAKUASIESQ0ACwwBCxCgCQALIAcoArAFIQYLIBsoApABIARsIgsEQEEAIRRBACEWA0AgFiEFIBwgBmtBBEgNAiAHIAZBAWo2ArAFIAYtAAAhFiAHIAZBAmo2ArAFIAYtAAEhEyAHIAZBA2o2ArAFIAYtAAIhFyAHIAZBBGoiBDYCsAUgBi0AAyIGQQFLDQIgE0EIdCAWciAXQRB0ciAGQRh0ciIGIAVqIhYgC0sNAiAcIARrIQsCQCAUQQFxBEAgCyAGQQF0SQ0EIAQhBiAFIBZPDQEDQCAHIARBAWo2ArAFIAQsAAAhCyAHIARBAmoiBjYCsAUgGygCzAEgBUEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgA/0ABDAgC60iP0IBg1Ab/QwAAAAAAAAAAAAAAAAAAAAAIAP9AARAID9CAoNQG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AARQID9CBINQG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AARgID9CCINQG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AARwID9CEINQG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AASAASA/QiCDUBv9Uf0MAAAAAAAAAAAAAAAAAAAAACAD/QAEkAEgP0LAAINQG/1RIAP9AASgAf0MAAAAAAAAAAAAAAAAAAAAACALQQBIG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AASwASAELAABIgStIj9CAYNQG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AATAASA/QgKDUBv9Uf0MAAAAAAAAAAAAAAAAAAAAACAD/QAE0AEgP0IEg1Ab/VH9DAAAAAAAAAAAAAAAAAAAAAAgA/0ABOABID9CCINQG/1R/QwAAAAAAAAAAAAAAAAAAAAAIAP9AATwASA/QhCDUBv9Uf0MAAAAAAAAAAAAAAAAAAAAACAD/QAEgAIgP0Igg1Ab/VH9DAAAAAAAAAAAAAAAAAAAAAAgA/0ABJACID9CwACDUBv9USAD/QAEoAL9DAAAAAAAAAAAAAAAAAAAAAAgBEEASBv9Uf0LBAAgBiEEIAVBAWoiBSAWRw0ACwwBCyALIAZBBHRJDQMgBCEGIAUgFk8NAANAIAcgBEEBaiIGNgKwBSAE/QcAACE1IAcgBEECaiILNgKwBSAGIDX9VAAAASE1IAcgBEEDaiIGNgKwBSALIDX9VAAAAiE1IAcgBEEEaiILNgKwBSAEQQ5qIARBDWogBEEMaiAEQQtqIARBCmogBEEJaiAEQQhqIARBB2ogBEEGaiAEQQVqIAsgBiA1/VQAAAP9VAAABP1UAAAF/VQAAAb9VAAAB/1UAAAI/VQAAAn9VAAACv1UAAAL/VQAAAz9VAAADf1UAAAOITUgByAEQRBqIgY2ArAFIBsoAswBIAVBBHRqIARBD2ogNf1UAAAP/QsEACAGIQQgBUEBaiIFIBZHDQALCyAUQQFzIRQgFiAbKAKUASIEIBsoApABbCILSQ0ACwsgHCAGa0EESA0AIAcgBkEBajYCsAUgBi0AACEFIAcgBkECajYCsAUgBi0AASELIAcgBkEDajYCsAUgBi0AAiEWIAcgBkEEaiIUNgKwBSAGLQADIgZBAUsNACALQQh0IAVyIBZBEHRyIAZBGHRyIgsgBEkNACAcIBRrIAtBBXRJDQAgCyAbKAKYASAEbEsNACAbQeQBaiIWIAsQmgsgCwRAQQAhBgNAIBYoAgAhBCAHIAcoArAFIgVBAWo2ArAFIAQgBkEFdGoiBCAFLQAAOgAAIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgABIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgACIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgADIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAEIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAFIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAGIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAHIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAIIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAJIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAKIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgALIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAMIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgANIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAOIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAPIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAQIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgARIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgASIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgATIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAUIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAVIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAWIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAXIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAYIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAZIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAaIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAbIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAcIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAdIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAeIAcgBygCsAUiBUEBajYCsAUgBCAFLQAAOgAfIAZBAWoiBiALRw0ACwsgIiELQQAhEyMAQUBqIg4kAAJAIBwiBCAHQbAFaiICKAIAa0EgSQ0AIAIgAigCACIBQQFqNgIAIAsgAS0AADoAYCACIAIoAgAiAUEBajYCACALIAEtAAA6AGEgAiACKAIAIgFBAWo2AgAgCyABLQAAOgBiIAIgAigCACIBQQFqNgIAIAsgAS0AADoAYyACIAIoAgAiAUEBajYCACALIAEtAAA6AGQgAiACKAIAIgFBAWo2AgAgCyABLQAAOgBlIAIgAigCACIBQQFqNgIAIAsgAS0AADoAZiACIAIoAgAiAUEBajYCACALIAEtAAA6AGcgAiACKAIAIgFBAWo2AgAgCyABLQAAOgBoIAIgAigCACIBQQFqNgIAIAsgAS0AADoAaSACIAIoAgAiAUEBajYCACALIAEtAAA6AGogAiACKAIAIgFBAWo2AgAgCyABLQAAOgBrIAIgAigCACIBQQFqNgIAIAsgAS0AADoAbCACIAIoAgAiAUEBajYCACALIAEtAAA6AG0gAiACKAIAIgFBAWo2AgAgCyABLQAAOgBuIAIgAigCACIBQQFqNgIAIAsgAS0AADoAbyACIAIoAgAiAUEBajYCACALIAEtAAA6AHAgAiACKAIAIgFBAWo2AgAgCyABLQAAOgBxIAIgAigCACIBQQFqNgIAIAsgAS0AADoAciACIAIoAgAiAUEBajYCACALIAEtAAA6AHMgAiACKAIAIgFBAWo2AgAgCyABLQAAOgB0IAIgAigCACIBQQFqNgIAIAsgAS0AADoAdSACIAIoAgAiAUEBajYCACALIAEtAAA6AHYgAiACKAIAIgFBAWo2AgAgCyABLQAAOgB3IAIgAigCACIBQQFqNgIAIAsgAS0AADoAeCACIAIoAgAiAUEBajYCACALIAEtAAA6AHkgAiACKAIAIgFBAWo2AgAgCyABLQAAOgB6IAIgAigCACIBQQFqNgIAIAsgAS0AADoAeyACIAIoAgAiAUEBajYCACALIAEtAAA6AHwgAiACKAIAIgFBAWo2AgAgCyABLQAAOgB9IAIgAigCACIBQQFqNgIAIAsgAS0AADoAfiACIAIoAgAiAUEBajYCACALIAEtAAA6AH8gCygCACgCDA0AIAsoAgggCygCBEcEQCACQQRqIRcgDkEgakEBciENA0AgBCACKAIAIgFrIB9BDGwiHCALKAIAKAIgaigCBCIFQQd0QcAAckkNAkEAIRQCeyAFBEADQCAUQeAAbCEGQQAhBQNAAkACewJAIAVBAUcEQCACKAIAIgFBIGoiCCACSyABIBdJcQ0BIAFBGGr9XAAAITQgAUEUav1cAAAhOCABQRBq/VwAACE5IAFBDGr9XAAAITogAUEIav1cAAAhOyABQQRq/VwAACE3IAH9XAAAITUgAiABQRxq/RH9DAAAAAAAAAAAAAAAAAMAAAD9rgEiNv0bA0EBajYCACA2/RsA/VwAAAwCCyAfQcDkAGwiASALKAIEaiAGaiIIQbAoakGoiTT9AAMA/QsDACAIQaAoakGYiTT9AAMA/QsDACALKAIEIAFqIAZqIgFBoMYAakGYiTT9AAMA/QsDACABQbDGAGpBqIk0/QADAP0LAwAMAgsgAiABQQFqIgo2AgAgAf0HAAAhNCACIAFBAmoiGDYCACAKIDT9VAAAASE0IAIgAUEDaiIKNgIAIBggNP1UAAACITQgAiABQQRqNgIAIAogNP1UAAADITUgAiABQQVqIgo2AgAgAf0HAAQhNCACIAFBBmoiGDYCACAKIDT9VAAAASE0IAIgAUEHaiIKNgIAIBggNP1UAAACITQgAiABQQhqNgIAIAogNP1UAAADITcgAiABQQlqIgo2AgAgAf0HAAghNCACIAFBCmoiGDYCACAKIDT9VAAAASE0IAIgAUELaiIKNgIAIBggNP1UAAACITQgAiABQQxqNgIAIAogNP1UAAADITsgAiABQQ1qIgo2AgAgAf0HAAwhNCACIAFBDmoiGDYCACAKIDT9VAAAASE0IAIgAUEPaiIKNgIAIBggNP1UAAACITQgAiABQRBqNgIAIAogNP1UAAADITogAiABQRFqIgo2AgAgAf0HABAhNCACIAFBEmoiGDYCACAKIDT9VAAAASE0IAIgAUETaiIKNgIAIBggNP1UAAACITQgAiABQRRqNgIAIAogNP1UAAADITkgAiABQRVqIgo2AgAgAf0HABQhNCACIAFBFmoiGDYCACAKIDT9VAAAASE0IAIgAUEXaiIKNgIAIBggNP1UAAACITQgAiABQRhqNgIAIAogNP1UAAADITggAiABQRlqIgo2AgAgAf0HABghNCACIAFBGmoiGDYCACAKIDT9VAAAASE0IAIgAUEbaiIKNgIAIBggNP1UAAACITQgAiABQRxqNgIAIAogNP1UAAADITQgAiABQR1qIgo2AgAgAf0HABwhNiACIAFBHmoiGDYCACAKIDb9VAAAASE2IAIgAUEfaiIBNgIAIBggNv1UAAACITYgAiAINgIAIAEgNv1UAAADCyE2IDT9GwCtIDb9GwCtQiCGhCI9QciINCkDACI8VCA8ID1RIDn9GwCtIDj9GwCtQiCGhCI8QcCINCkDACI+VCA8ID5RIDv9GwCtIDr9GwCtQiCGhCI+QbiINCkDACJAVCA+IEBRIDX9GwCtIDf9GwCtQiCGhCI/QbCINCkDAFRxcnFycXKtUA0HIA4gPTcDOCAOIDw3AzAgDiA+NwMoIA4gPzcDIEGwiDQgDkEgakHwiDQQpAkgDkEIaiIIIA1BCGoiGP0AAAD9CwMAIA5BF2oiCiANQRdqIiUpAAA3AAAgDiANKQAANwMAIAVBBXQiIyAfQcDkAGwiHSALKAIEaiAGamoiASAOLQAgOgCAKCABIA4pAwA3AIEoIAFBiShqIAj9AAMA/QsAACABQZgoaiAKKQAANwAAAnsgAigCACIBQSBqIhYgAksgASAXSXFFBEAgAUEYav1cAAAhNCABQRRq/VwAACE4IAFBEGr9XAAAITkgAUEMav1cAAAhOiABQQhq/VwAACE7IAFBBGr9XAAAITcgAf1cAAAhNSACIAFBHGr9Ef0MAAAAAAAAAAAAAAAAAwAAAP2uASI2/RsDQQFqNgIAIDb9GwD9XAAADAELIAIgAUEBaiIgNgIAIAH9BwAAITQgAiABQQJqIiE2AgAgICA0/VQAAAEhNCACIAFBA2oiIDYCACAhIDT9VAAAAiE0IAIgAUEEajYCACAgIDT9VAAAAyE1IAIgAUEFaiIgNgIAIAH9BwAEITQgAiABQQZqIiE2AgAgICA0/VQAAAEhNCACIAFBB2oiIDYCACAhIDT9VAAAAiE0IAIgAUEIajYCACAgIDT9VAAAAyE3IAIgAUEJaiIgNgIAIAH9BwAIITQgAiABQQpqIiE2AgAgICA0/VQAAAEhNCACIAFBC2oiIDYCACAhIDT9VAAAAiE0IAIgAUEMajYCACAgIDT9VAAAAyE7IAIgAUENaiIgNgIAIAH9BwAMITQgAiABQQ5qIiE2AgAgICA0/VQAAAEhNCACIAFBD2oiIDYCACAhIDT9VAAAAiE0IAIgAUEQajYCACAgIDT9VAAAAyE6IAIgAUERaiIgNgIAIAH9BwAQITQgAiABQRJqIiE2AgAgICA0/VQAAAEhNCACIAFBE2oiIDYCACAhIDT9VAAAAiE0IAIgAUEUajYCACAgIDT9VAAAAyE5IAIgAUEVaiIgNgIAIAH9BwAUITQgAiABQRZqIiE2AgAgICA0/VQAAAEhNCACIAFBF2oiIDYCACAhIDT9VAAAAiE0IAIgAUEYajYCACAgIDT9VAAAAyE4IAIgAUEZaiIgNgIAIAH9BwAYITQgAiABQRpqIiE2AgAgICA0/VQAAAEhNCACIAFBG2oiIDYCACAhIDT9VAAAAiE0IAIgAUEcajYCACAgIDT9VAAAAyE0IAIgAUEdaiIgNgIAIAH9BwAcITYgAiABQR5qIiE2AgAgICA2/VQAAAEhNiACIAFBH2oiATYCACAhIDb9VAAAAiE2IAIgFjYCACABIDb9VAAAAwshNiA0/RsArSA2/RsArUIghoQiPUHIiDQpAwAiPFQgPCA9USA5/RsArSA4/RsArUIghoQiPEHAiDQpAwAiPlQgPCA+USA7/RsArSA6/RsArUIghoQiPkG4iDQpAwAiQFQgPiBAUSA1/RsArSA3/RsArUIghoQiP0GwiDQpAwBUcXJxcnFyrVANByAOID03AzggDiA8NwMwIA4gPjcDKCAOID83AyBBsIg0IA5BIGpB8Ig0EKQJIAggGP0AAAD9CwMAIAogJSkAADcAACAOIA0pAAA3AwAgCygCBCAdaiAGaiAjaiIBIA4tACA6AIBGIAEgDikDADcAgUYgAUGJxgBqIAj9AAMA/QsAACABQZjGAGogCikAADcAAAsgBUEBaiIFQQNHDQALIBRBAWoiFCALKAIAKAIgIBxqKAIESQ0ACyACKAIAIQELIAEgF0kgAUEgaiIFIAJLcUUEQCABQRhq/VwAACE0IAFBFGr9XAAAITggAUEQav1cAAAhOSABQQxq/VwAACE6IAFBCGr9XAAAITsgAUEEav1cAAAhNyAB/VwAACE1IAIgAUEcav0R/QwAAAAAAAAAAAAAAAADAAAA/a4BIjb9GwNBAWo2AgAgNv0bAP1cAAAMAQsgAiABQQFqIgY2AgAgAf0HAAAhNCACIAFBAmoiCDYCACAGIDT9VAAAASE0IAIgAUEDaiIGNgIAIAggNP1UAAACITQgAiABQQRqNgIAIAYgNP1UAAADITUgAiABQQVqIgY2AgAgAf0HAAQhNCACIAFBBmoiCDYCACAGIDT9VAAAASE0IAIgAUEHaiIGNgIAIAggNP1UAAACITQgAiABQQhqNgIAIAYgNP1UAAADITcgAiABQQlqIgY2AgAgAf0HAAghNCACIAFBCmoiCDYCACAGIDT9VAAAASE0IAIgAUELaiIGNgIAIAggNP1UAAACITQgAiABQQxqNgIAIAYgNP1UAAADITsgAiABQQ1qIgY2AgAgAf0HAAwhNCACIAFBDmoiCDYCACAGIDT9VAAAASE0IAIgAUEPaiIGNgIAIAggNP1UAAACITQgAiABQRBqNgIAIAYgNP1UAAADITogAiABQRFqIgY2AgAgAf0HABAhNCACIAFBEmoiCDYCACAGIDT9VAAAASE0IAIgAUETaiIGNgIAIAggNP1UAAACITQgAiABQRRqNgIAIAYgNP1UAAADITkgAiABQRVqIgY2AgAgAf0HABQhNCACIAFBFmoiCDYCACAGIDT9VAAAASE0IAIgAUEXaiIGNgIAIAggNP1UAAACITQgAiABQRhqNgIAIAYgNP1UAAADITggAiABQRlqIgY2AgAgAf0HABghNCACIAFBGmoiCDYCACAGIDT9VAAAASE0IAIgAUEbaiIGNgIAIAggNP1UAAACITQgAiABQRxqNgIAIAYgNP1UAAADITQgAiABQR1qIgY2AgAgAf0HABwhNiACIAFBHmoiCDYCACAGIDb9VAAAASE2IAIgAUEfaiIBNgIAIAggNv1UAAACITYgAiAFNgIAIAEgNv1UAAADCyE2IDT9GwCtIDb9GwCtQiCGhCI9QciINCkDACI8VCA8ID1RIDn9GwCtIDj9GwCtQiCGhCI8QcCINCkDACI+VCA8ID5RIDv9GwCtIDr9GwCtQiCGhCI+QbiINCkDACJAVCA+IEBRIDX9GwCtIDf9GwCtQiCGhCI/QbCINCkDAFRxcnFycXKtUA0CIA4gPTcDOCAOIDw3AzAgDiA+NwMoIA4gPzcDIEGwiDQgDkEgakHwiDQQpAkgDkEIaiIFIA1BCGoiCP0AAAD9CwMAIA5BF2oiBiANQRdqIgopAAA3AAAgDiANKQAANwMAIB9BwOQAbCIYIAsoAgRqIgEgDi0AIDoAgGQgASAOKQMANwCBZCABQYnkAGogBf0AAwD9CwAAIAFBmOQAaiAGKQAANwAAAnsgAigCACIBQSBqIiUgAksgASAXSXFFBEAgAUEYav1cAAAhNCABQRRq/VwAACE4IAFBEGr9XAAAITkgAUEMav1cAAAhOiABQQhq/VwAACE7IAFBBGr9XAAAITcgAf1cAAAhNSACIAFBHGr9Ef0MAAAAAAAAAAAAAAAAAwAAAP2uASI2/RsDQQFqNgIAIDb9GwD9XAAADAELIAIgAUEBaiIdNgIAIAH9BwAAITQgAiABQQJqIiM2AgAgHSA0/VQAAAEhNCACIAFBA2oiHTYCACAjIDT9VAAAAiE0IAIgAUEEajYCACAdIDT9VAAAAyE1IAIgAUEFaiIdNgIAIAH9BwAEITQgAiABQQZqIiM2AgAgHSA0/VQAAAEhNCACIAFBB2oiHTYCACAjIDT9VAAAAiE0IAIgAUEIajYCACAdIDT9VAAAAyE3IAIgAUEJaiIdNgIAIAH9BwAIITQgAiABQQpqIiM2AgAgHSA0/VQAAAEhNCACIAFBC2oiHTYCACAjIDT9VAAAAiE0IAIgAUEMajYCACAdIDT9VAAAAyE7IAIgAUENaiIdNgIAIAH9BwAMITQgAiABQQ5qIiM2AgAgHSA0/VQAAAEhNCACIAFBD2oiHTYCACAjIDT9VAAAAiE0IAIgAUEQajYCACAdIDT9VAAAAyE6IAIgAUERaiIdNgIAIAH9BwAQITQgAiABQRJqIiM2AgAgHSA0/VQAAAEhNCACIAFBE2oiHTYCACAjIDT9VAAAAiE0IAIgAUEUajYCACAdIDT9VAAAAyE5IAIgAUEVaiIdNgIAIAH9BwAUITQgAiABQRZqIiM2AgAgHSA0/VQAAAEhNCACIAFBF2oiHTYCACAjIDT9VAAAAiE0IAIgAUEYajYCACAdIDT9VAAAAyE4IAIgAUEZaiIdNgIAIAH9BwAYITQgAiABQRpqIiM2AgAgHSA0/VQAAAEhNCACIAFBG2oiHTYCACAjIDT9VAAAAiE0IAIgAUEcajYCACAdIDT9VAAAAyE0IAIgAUEdaiIdNgIAIAH9BwAcITYgAiABQR5qIiM2AgAgHSA2/VQAAAEhNiACIAFBH2oiATYCACAjIDb9VAAAAiE2IAIgJTYCACABIDb9VAAAAwshNiA0/RsArSA2/RsArUIghoQiPUHIiDQpAwAiPFQgPCA9USA5/RsArSA4/RsArUIghoQiPEHAiDQpAwAiPlQgPCA+USA7/RsArSA6/RsArUIghoQiPkG4iDQpAwAiQFQgPiBAUSA1/RsArSA3/RsArUIghoQiP0GwiDQpAwBUcXJxcnFyrVANAiAOID03AzggDiA8NwMwIA4gPjcDKCAOID83AyBBsIg0IA5BIGpB8Ig0EKQJIAUgCP0AAAD9CwMAIAYgCikAADcAACAOIA0pAAA3AwAgCygCBCAYaiIBIA4tACA6AKBkIAEgDikDADcAoWQgAUGp5ABqIAX9AAMA/QsAACABQbjkAGogBikAADcAACAfQQFqIh8gCygCCCALKAIEa0HA5ABtSQ0ACwsgBCACKAIAayIFIAsoAoABIgFBBXRJDQAgAQRAIAJBBGohHyAOQSBqQQFyIQVBACENA0ACeyACKAIAIgFBIGoiBiACSyABIB9JcUUEQCABQRhq/VwAACE0IAFBFGr9XAAAITggAUEQav1cAAAhOSABQQxq/VwAACE6IAFBCGr9XAAAITsgAUEEav1cAAAhNyAB/VwAACE1IAIgAUEcav0R/QwAAAAAAAAAAAAAAAADAAAA/a4BIjb9GwNBAWo2AgAgNv0bAP1cAAAMAQsgAiABQQFqIgg2AgAgAf0HAAAhNCACIAFBAmoiCjYCACAIIDT9VAAAASE0IAIgAUEDaiIINgIAIAogNP1UAAACITQgAiABQQRqNgIAIAggNP1UAAADITUgAiABQQVqIgg2AgAgAf0HAAQhNCACIAFBBmoiCjYCACAIIDT9VAAAASE0IAIgAUEHaiIINgIAIAogNP1UAAACITQgAiABQQhqNgIAIAggNP1UAAADITcgAiABQQlqIgg2AgAgAf0HAAghNCACIAFBCmoiCjYCACAIIDT9VAAAASE0IAIgAUELaiIINgIAIAogNP1UAAACITQgAiABQQxqNgIAIAggNP1UAAADITsgAiABQQ1qIgg2AgAgAf0HAAwhNCACIAFBDmoiCjYCACAIIDT9VAAAASE0IAIgAUEPaiIINgIAIAogNP1UAAACITQgAiABQRBqNgIAIAggNP1UAAADITogAiABQRFqIgg2AgAgAf0HABAhNCACIAFBEmoiCjYCACAIIDT9VAAAASE0IAIgAUETaiIINgIAIAogNP1UAAACITQgAiABQRRqNgIAIAggNP1UAAADITkgAiABQRVqIgg2AgAgAf0HABQhNCACIAFBFmoiCjYCACAIIDT9VAAAASE0IAIgAUEXaiIINgIAIAogNP1UAAACITQgAiABQRhqNgIAIAggNP1UAAADITggAiABQRlqIgg2AgAgAf0HABghNCACIAFBGmoiCjYCACAIIDT9VAAAASE0IAIgAUEbaiIINgIAIAogNP1UAAACITQgAiABQRxqNgIAIAggNP1UAAADITQgAiABQR1qIgg2AgAgAf0HABwhNiACIAFBHmoiCjYCACAIIDb9VAAAASE2IAIgAUEfaiIBNgIAIAogNv1UAAACITYgAiAGNgIAIAEgNv1UAAADCyE2IDT9GwCtIDb9GwCtQiCGhCI/QciINCkDACI9VCA9ID9RIDn9GwCtIDj9GwCtQiCGhCI9QcCINCkDACI8VCA8ID1RIDv9GwCtIDr9GwCtQiCGhCI8QbiINCkDACI+VCA8ID5RIDX9GwCtIDf9GwCtQiCGhCJAQbCINCkDAFRxcnFycXKtUA0CIA4gPzcDOCAOID03AzAgDiA8NwMoIA4gQDcDIEGwiDQgDkEgakHwiDQQpAkgDkEIaiIGIAX9AAAI/QsDACAOQRdqIgggBSkAFzcAACAOIAUpAAA3AwAgCygCnAEgDUEFdGoiASAOLQAgOgAAIAEgDikDADcAASABIAb9AAMA/QsACSABIAgpAAA3ABggDUEBaiINIAsoAoABSQ0ACyAEIAIoAgBrIQULIAUgCygChAEiDUEFdEkNAEEAIQEgDQRAIAJBBGohHyAOQSBqQQFyIQVBACENA0ACeyACKAIAIgFBIGoiBiACSyABIB9JcUUEQCABQRhq/VwAACE0IAFBFGr9XAAAITggAUEQav1cAAAhOSABQQxq/VwAACE6IAFBCGr9XAAAITsgAUEEav1cAAAhNyAB/VwAACE1IAIgAUEcav0R/QwAAAAAAAAAAAAAAAADAAAA/a4BIjb9GwNBAWo2AgAgNv0bAP1cAAAMAQsgAiABQQFqIgg2AgAgAf0HAAAhNCACIAFBAmoiCjYCACAIIDT9VAAAASE0IAIgAUEDaiIINgIAIAogNP1UAAACITQgAiABQQRqNgIAIAggNP1UAAADITUgAiABQQVqIgg2AgAgAf0HAAQhNCACIAFBBmoiCjYCACAIIDT9VAAAASE0IAIgAUEHaiIINgIAIAogNP1UAAACITQgAiABQQhqNgIAIAggNP1UAAADITcgAiABQQlqIgg2AgAgAf0HAAghNCACIAFBCmoiCjYCACAIIDT9VAAAASE0IAIgAUELaiIINgIAIAogNP1UAAACITQgAiABQQxqNgIAIAggNP1UAAADITsgAiABQQ1qIgg2AgAgAf0HAAwhNCACIAFBDmoiCjYCACAIIDT9VAAAASE0IAIgAUEPaiIINgIAIAogNP1UAAACITQgAiABQRBqNgIAIAggNP1UAAADITogAiABQRFqIgg2AgAgAf0HABAhNCACIAFBEmoiCjYCACAIIDT9VAAAASE0IAIgAUETaiIINgIAIAogNP1UAAACITQgAiABQRRqNgIAIAggNP1UAAADITkgAiABQRVqIgg2AgAgAf0HABQhNCACIAFBFmoiCjYCACAIIDT9VAAAASE0IAIgAUEXaiIINgIAIAogNP1UAAACITQgAiABQRhqNgIAIAggNP1UAAADITggAiABQRlqIgg2AgAgAf0HABghNCACIAFBGmoiCjYCACAIIDT9VAAAASE0IAIgAUEbaiIINgIAIAogNP1UAAACITQgAiABQRxqNgIAIAggNP1UAAADITQgAiABQR1qIgg2AgAgAf0HABwhNiACIAFBHmoiCjYCACAIIDb9VAAAASE2IAIgAUEfaiIBNgIAIAogNv1UAAACITYgAiAGNgIAIAEgNv1UAAADCyE2IDT9GwCtIDb9GwCtQiCGhCI/QciINCkDACI9VCA9ID9RIDn9GwCtIDj9GwCtQiCGhCI9QcCINCkDACI8VCA8ID1RIDv9GwCtIDr9GwCtQiCGhCI8QbiINCkDACI+VCA8ID5RIDX9GwCtIDf9GwCtQiCGhCJAQbCINCkDAFRxcnFycXKtUA0CIA4gPzcDOCAOID03AzAgDiA8NwMoIA4gQDcDIEGwiDQgDkEgakHwiDQQpAkgDkEIaiIGIAX9AAAI/QsDACAOQRdqIgggBSkAFzcAACAOIAUpAAA3AwAgCygCqAEgDUEFdGoiASAOLQAgOgAAIAEgDikDADcAASABIAb9AAMA/QsACSABIAgpAAA3ABggDUEBaiINIAsoAoQBIgFJDQALIAQgAigCAGshBQsgBSALKAKIASINQQV0SQ0AIA0EQCACQQRqIR8gDkEgakEBciEFQQAhDQNAAnsgAigCACIBQSBqIgYgAksgASAfSXFFBEAgAUEYav1cAAAhNCABQRRq/VwAACE4IAFBEGr9XAAAITkgAUEMav1cAAAhOiABQQhq/VwAACE7IAFBBGr9XAAAITcgAf1cAAAhNSACIAFBHGr9Ef0MAAAAAAAAAAAAAAAAAwAAAP2uASI2/RsDQQFqNgIAIDb9GwD9XAAADAELIAIgAUEBaiIINgIAIAH9BwAAITQgAiABQQJqIgo2AgAgCCA0/VQAAAEhNCACIAFBA2oiCDYCACAKIDT9VAAAAiE0IAIgAUEEajYCACAIIDT9VAAAAyE1IAIgAUEFaiIINgIAIAH9BwAEITQgAiABQQZqIgo2AgAgCCA0/VQAAAEhNCACIAFBB2oiCDYCACAKIDT9VAAAAiE0IAIgAUEIajYCACAIIDT9VAAAAyE3IAIgAUEJaiIINgIAIAH9BwAIITQgAiABQQpqIgo2AgAgCCA0/VQAAAEhNCACIAFBC2oiCDYCACAKIDT9VAAAAiE0IAIgAUEMajYCACAIIDT9VAAAAyE7IAIgAUENaiIINgIAIAH9BwAMITQgAiABQQ5qIgo2AgAgCCA0/VQAAAEhNCACIAFBD2oiCDYCACAKIDT9VAAAAiE0IAIgAUEQajYCACAIIDT9VAAAAyE6IAIgAUERaiIINgIAIAH9BwAQITQgAiABQRJqIgo2AgAgCCA0/VQAAAEhNCACIAFBE2oiCDYCACAKIDT9VAAAAiE0IAIgAUEUajYCACAIIDT9VAAAAyE5IAIgAUEVaiIINgIAIAH9BwAUITQgAiABQRZqIgo2AgAgCCA0/VQAAAEhNCACIAFBF2oiCDYCACAKIDT9VAAAAiE0IAIgAUEYajYCACAIIDT9VAAAAyE4IAIgAUEZaiIINgIAIAH9BwAYITQgAiABQRpqIgo2AgAgCCA0/VQAAAEhNCACIAFBG2oiCDYCACAKIDT9VAAAAiE0IAIgAUEcajYCACAIIDT9VAAAAyE0IAIgAUEdaiIINgIAIAH9BwAcITYgAiABQR5qIgo2AgAgCCA2/VQAAAEhNiACIAFBH2oiATYCACAKIDb9VAAAAiE2IAIgBjYCACABIDb9VAAAAwshNiA0/RsArSA2/RsArUIghoQiP0HIiDQpAwAiPVQgPSA/USA5/RsArSA4/RsArUIghoQiPUHAiDQpAwAiPFQgPCA9USA7/RsArSA6/RsArUIghoQiPEG4iDQpAwAiPlQgPCA+USA1/RsArSA3/RsArUIghoQiQEGwiDQpAwBUcXJxcnFyrVANAiAOID83AzggDiA9NwMwIA4gPDcDKCAOIEA3AyBBsIg0IA5BIGpB8Ig0EKQJIA5BCGoiBiAF/QAACP0LAwAgDkEXaiIIIAUpABc3AAAgDiAFKQAANwMAIAsoArQBIA1BBXRqIgEgDi0AIDoAACABIA4pAwA3AAEgASAG/QADAP0LAAkgASAIKQAANwAYIA1BAWoiDSALKAKIAUkNAAsgCygChAEhASAEIAIoAgBrIQULIAUgASALKAKAASINa0EFdEkNAAJAAkAgASANRwRAIAJBBGohHyAOQSBqQQFyIQVBACENA0ACeyACKAIAIgFBIGoiBiACSyABIB9JcUUEQCABQRhq/VwAACE0IAFBFGr9XAAAITggAUEQav1cAAAhOSABQQxq/VwAACE6IAFBCGr9XAAAITsgAUEEav1cAAAhNyAB/VwAACE1IAIgAUEcav0R/QwAAAAAAAAAAAAAAAADAAAA/a4BIjb9GwNBAWo2AgAgNv0bAP1cAAAMAQsgAiABQQFqIgg2AgAgAf0HAAAhNCACIAFBAmoiCjYCACAIIDT9VAAAASE0IAIgAUEDaiIINgIAIAogNP1UAAACITQgAiABQQRqNgIAIAggNP1UAAADITUgAiABQQVqIgg2AgAgAf0HAAQhNCACIAFBBmoiCjYCACAIIDT9VAAAASE0IAIgAUEHaiIINgIAIAogNP1UAAACITQgAiABQQhqNgIAIAggNP1UAAADITcgAiABQQlqIgg2AgAgAf0HAAghNCACIAFBCmoiCjYCACAIIDT9VAAAASE0IAIgAUELaiIINgIAIAogNP1UAAACITQgAiABQQxqNgIAIAggNP1UAAADITsgAiABQQ1qIgg2AgAgAf0HAAwhNCACIAFBDmoiCjYCACAIIDT9VAAAASE0IAIgAUEPaiIINgIAIAogNP1UAAACITQgAiABQRBqNgIAIAggNP1UAAADITogAiABQRFqIgg2AgAgAf0HABAhNCACIAFBEmoiCjYCACAIIDT9VAAAASE0IAIgAUETaiIINgIAIAogNP1UAAACITQgAiABQRRqNgIAIAggNP1UAAADITkgAiABQRVqIgg2AgAgAf0HABQhNCACIAFBFmoiCjYCACAIIDT9VAAAASE0IAIgAUEXaiIINgIAIAogNP1UAAACITQgAiABQRhqNgIAIAggNP1UAAADITggAiABQRlqIgg2AgAgAf0HABghNCACIAFBGmoiCjYCACAIIDT9VAAAASE0IAIgAUEbaiIINgIAIAogNP1UAAACITQgAiABQRxqNgIAIAggNP1UAAADITQgAiABQR1qIgg2AgAgAf0HABwhNiACIAFBHmoiCjYCACAIIDb9VAAAASE2IAIgAUEfaiIBNgIAIAogNv1UAAACITYgAiAGNgIAIAEgNv1UAAADCyE2IDT9GwCtIDb9GwCtQiCGhCI/QciINCkDACI9VCA9ID9RIDn9GwCtIDj9GwCtQiCGhCI9QcCINCkDACI8VCA8ID1RIDv9GwCtIDr9GwCtQiCGhCI8QbiINCkDACI+VCA8ID5RIDX9GwCtIDf9GwCtQiCGhCJAQbCINCkDAFRxcnFycXKtUA0CIA4gPzcDOCAOID03AzAgDiA8NwMoIA4gQDcDIEGwiDQgDkEgakHwiDQQpAkgDkEIaiIGIAX9AAAI/QsDACAOQRdqIgggBSkAFzcAACAOIAUpAAA3AwAgCygCwAEgDUEFdGoiASAOLQAgOgAAIAEgDikDADcAASABIAb9AAMA/QsACSABIAgpAAA3ABggDUEBaiINIAsoAoQBIAsoAoABa0kNAAsgBCACKAIAayEFCyAFIAsoApQBIgFBBXRJDQIgAUUEQEEAIQEMAgtBACEFA0AgCygC2AEhASACIAIoAgAiDUEBajYCACABIAVBBXRqIgEgDS0AADoAACACIAIoAgAiDUEBajYCACABIA0tAAA6AAEgAiACKAIAIg1BAWo2AgAgASANLQAAOgACIAIgAigCACINQQFqNgIAIAEgDS0AADoAAyACIAIoAgAiDUEBajYCACABIA0tAAA6AAQgAiACKAIAIg1BAWo2AgAgASANLQAAOgAFIAIgAigCACINQQFqNgIAIAEgDS0AADoABiACIAIoAgAiDUEBajYCACABIA0tAAA6AAcgAiACKAIAIg1BAWo2AgAgASANLQAAOgAIIAIgAigCACINQQFqNgIAIAEgDS0AADoACSACIAIoAgAiDUEBajYCACABIA0tAAA6AAogAiACKAIAIg1BAWo2AgAgASANLQAAOgALIAIgAigCACINQQFqNgIAIAEgDS0AADoADCACIAIoAgAiDUEBajYCACABIA0tAAA6AA0gAiACKAIAIg1BAWo2AgAgASANLQAAOgAOIAIgAigCACINQQFqNgIAIAEgDS0AADoADyACIAIoAgAiDUEBajYCACABIA0tAAA6ABAgAiACKAIAIg1BAWo2AgAgASANLQAAOgARIAIgAigCACINQQFqNgIAIAEgDS0AADoAEiACIAIoAgAiDUEBajYCACABIA0tAAA6ABMgAiACKAIAIg1BAWo2AgAgASANLQAAOgAUIAIgAigCACINQQFqNgIAIAEgDS0AADoAFSACIAIoAgAiDUEBajYCACABIA0tAAA6ABYgAiACKAIAIg1BAWo2AgAgASANLQAAOgAXIAIgAigCACINQQFqNgIAIAEgDS0AADoAGCACIAIoAgAiDUEBajYCACABIA0tAAA6ABkgAiACKAIAIg1BAWo2AgAgASANLQAAOgAaIAIgAigCACINQQFqNgIAIAEgDS0AADoAGyACIAIoAgAiDUEBajYCACABIA0tAAA6ABwgAiACKAIAIg1BAWo2AgAgASANLQAAOgAdIAIgAigCACINQQFqNgIAIAEgDS0AADoAHiACIAIoAgAiDUEBajYCACABIA0tAAA6AB8gBUEBaiIFIAsoApQBIgFJDQALDAELDAELIAsoApABIAFsIggEQCACQQRqIR8gDkEgakEBciENQQAhJUEAIQYDQCAGIQUgBCACKAIAIgFrQQRIDQIgAiABQQFqNgIAIAEtAAAhBiACIAFBAmo2AgAgAS0AASEKIAIgAUEDajYCACABLQACIRggAiABQQRqIh02AgAgAS0AAyIBQQFLDQIgCkEIdCAGciAYQRB0ciABQRh0ciIBIAVqIgYgCEsNAiABQQV0IQEgBCAdayEIAkAgJUEBcQRAIAEgCEsNBCAFIAZPDQEDQAJ7IAIoAgAiAUEgaiIIIAJLIAEgH0lxRQRAIAFBGGr9XAAAITQgAUEUav1cAAAhOCABQRBq/VwAACE5IAFBDGr9XAAAITogAUEIav1cAAAhOyABQQRq/VwAACE3IAH9XAAAITUgAiABQRxq/RH9DAAAAAAAAAAAAAAAAAMAAAD9rgEiNv0bA0EBajYCACA2/RsA/VwAAAwBCyACIAFBAWoiCjYCACAB/QcAACE0IAIgAUECaiIYNgIAIAogNP1UAAABITQgAiABQQNqIgo2AgAgGCA0/VQAAAIhNCACIAFBBGo2AgAgCiA0/VQAAAMhNSACIAFBBWoiCjYCACAB/QcABCE0IAIgAUEGaiIYNgIAIAogNP1UAAABITQgAiABQQdqIgo2AgAgGCA0/VQAAAIhNCACIAFBCGo2AgAgCiA0/VQAAAMhNyACIAFBCWoiCjYCACAB/QcACCE0IAIgAUEKaiIYNgIAIAogNP1UAAABITQgAiABQQtqIgo2AgAgGCA0/VQAAAIhNCACIAFBDGo2AgAgCiA0/VQAAAMhOyACIAFBDWoiCjYCACAB/QcADCE0IAIgAUEOaiIYNgIAIAogNP1UAAABITQgAiABQQ9qIgo2AgAgGCA0/VQAAAIhNCACIAFBEGo2AgAgCiA0/VQAAAMhOiACIAFBEWoiCjYCACAB/QcAECE0IAIgAUESaiIYNgIAIAogNP1UAAABITQgAiABQRNqIgo2AgAgGCA0/VQAAAIhNCACIAFBFGo2AgAgCiA0/VQAAAMhOSACIAFBFWoiCjYCACAB/QcAFCE0IAIgAUEWaiIYNgIAIAogNP1UAAABITQgAiABQRdqIgo2AgAgGCA0/VQAAAIhNCACIAFBGGo2AgAgCiA0/VQAAAMhOCACIAFBGWoiCjYCACAB/QcAGCE0IAIgAUEaaiIYNgIAIAogNP1UAAABITQgAiABQRtqIgo2AgAgGCA0/VQAAAIhNCACIAFBHGo2AgAgCiA0/VQAAAMhNCACIAFBHWoiCjYCACAB/QcAHCE2IAIgAUEeaiIYNgIAIAogNv1UAAABITYgAiABQR9qIgE2AgAgGCA2/VQAAAIhNiACIAg2AgAgASA2/VQAAAMLITYgNP0bAK0gNv0bAK1CIIaEIj9ByIg0KQMAIj1UID0gP1EgOf0bAK0gOP0bAK1CIIaEIj1BwIg0KQMAIjxUIDwgPVEgO/0bAK0gOv0bAK1CIIaEIjxBuIg0KQMAIj5UIDwgPlEgNf0bAK0gN/0bAK1CIIaEIkBBsIg0KQMAVHFycXJxcq1QDQUgDiA/NwM4IA4gPTcDMCAOIDw3AyggDiBANwMgQbCINCAOQSBqQfCINBCkCSAOQQhqIgggDf0AAAj9CwMAIA5BF2oiCiANKQAXNwAAIA4gDSkAADcDACALKALMASAFQQV0aiIBIA4tACA6AAAgASAOKQMANwABIAEgCP0AAwD9CwAJIAEgCikAADcAGCAFQQFqIgUgBkcNAAsMAQsgASAISw0DIAUgBk8NAANAAnsgAigCACIBQSBqIgggAksgASAfSXFFBEAgAUEYav1cAAAhNCABQRRq/VwAACE4IAFBEGr9XAAAITkgAUEMav1cAAAhOiABQQhq/VwAACE7IAFBBGr9XAAAITcgAf1cAAAhNSACIAFBHGr9Ef0MAAAAAAAAAAAAAAAAAwAAAP2uASI2/RsDQQFqNgIAIDb9GwD9XAAADAELIAIgAUEBaiIKNgIAIAH9BwAAITQgAiABQQJqIhg2AgAgCiA0/VQAAAEhNCACIAFBA2oiCjYCACAYIDT9VAAAAiE0IAIgAUEEajYCACAKIDT9VAAAAyE1IAIgAUEFaiIKNgIAIAH9BwAEITQgAiABQQZqIhg2AgAgCiA0/VQAAAEhNCACIAFBB2oiCjYCACAYIDT9VAAAAiE0IAIgAUEIajYCACAKIDT9VAAAAyE3IAIgAUEJaiIKNgIAIAH9BwAIITQgAiABQQpqIhg2AgAgCiA0/VQAAAEhNCACIAFBC2oiCjYCACAYIDT9VAAAAiE0IAIgAUEMajYCACAKIDT9VAAAAyE7IAIgAUENaiIKNgIAIAH9BwAMITQgAiABQQ5qIhg2AgAgCiA0/VQAAAEhNCACIAFBD2oiCjYCACAYIDT9VAAAAiE0IAIgAUEQajYCACAKIDT9VAAAAyE6IAIgAUERaiIKNgIAIAH9BwAQITQgAiABQRJqIhg2AgAgCiA0/VQAAAEhNCACIAFBE2oiCjYCACAYIDT9VAAAAiE0IAIgAUEUajYCACAKIDT9VAAAAyE5IAIgAUEVaiIKNgIAIAH9BwAUITQgAiABQRZqIhg2AgAgCiA0/VQAAAEhNCACIAFBF2oiCjYCACAYIDT9VAAAAiE0IAIgAUEYajYCACAKIDT9VAAAAyE4IAIgAUEZaiIKNgIAIAH9BwAYITQgAiABQRpqIhg2AgAgCiA0/VQAAAEhNCACIAFBG2oiCjYCACAYIDT9VAAAAiE0IAIgAUEcajYCACAKIDT9VAAAAyE0IAIgAUEdaiIKNgIAIAH9BwAcITYgAiABQR5qIhg2AgAgCiA2/VQAAAEhNiACIAFBH2oiATYCACAYIDb9VAAAAiE2IAIgCDYCACABIDb9VAAAAwshNiA0/RsArSA2/RsArUIghoQiP0HIiDQpAwAiPVQgPSA/USA5/RsArSA4/RsArUIghoQiPUHAiDQpAwAiPFQgPCA9USA7/RsArSA6/RsArUIghoQiPEG4iDQpAwAiPlQgPCA+USA1/RsArSA3/RsArUIghoQiQEGwiDQpAwBUcXJxcnFyrVANBCAOID83AzggDiA9NwMwIA4gPDcDKCAOIEA3AyBBsIg0IA5BIGpB8Ig0EKQJIA5BCGoiCCAN/QAACP0LAwAgDkEXaiIKIA0pABc3AAAgDiANKQAANwMAIAsoAswBIAVBBXRqIgEgDi0AIDoAACABIA4pAwA3AAEgASAI/QADAP0LAAkgASAKKQAANwAYIAVBAWoiBSAGRw0ACwsgJUEBcyElIAYgCygClAEiASALKAKQAWwiCEkNAAsLIAQgAigCACIFa0EESA0AIAIgBUEBajYCACAFLQAAIQ0gAiAFQQJqNgIAIAUtAAEhBiACIAVBA2o2AgAgBS0AAiEIIAIgBUEEaiIKNgIAIAUtAAMiBUEBSw0AIAZBCHQgDXIgCEEQdHIgBUEYdHIiDSABSQ0AIAQgCmsgDUEFdEkNACANIAsoApgBIAFsSw0AIAtB5AFqIgYgDRCaCyANRQRAQQEhEwwBC0EAIQsDQEEBIRMgBigCACEBIAIgAigCACIFQQFqNgIAIAEgC0EFdGoiASAFLQAAOgAAIAIgAigCACIFQQFqNgIAIAEgBS0AADoAASACIAIoAgAiBUEBajYCACABIAUtAAA6AAIgAiACKAIAIgVBAWo2AgAgASAFLQAAOgADIAIgAigCACIFQQFqNgIAIAEgBS0AADoABCACIAIoAgAiBUEBajYCACABIAUtAAA6AAUgAiACKAIAIgVBAWo2AgAgASAFLQAAOgAGIAIgAigCACIFQQFqNgIAIAEgBS0AADoAByACIAIoAgAiBUEBajYCACABIAUtAAA6AAggAiACKAIAIgVBAWo2AgAgASAFLQAAOgAJIAIgAigCACIFQQFqNgIAIAEgBS0AADoACiACIAIoAgAiBUEBajYCACABIAUtAAA6AAsgAiACKAIAIgVBAWo2AgAgASAFLQAAOgAMIAIgAigCACIFQQFqNgIAIAEgBS0AADoADSACIAIoAgAiBUEBajYCACABIAUtAAA6AA4gAiACKAIAIgVBAWo2AgAgASAFLQAAOgAPIAIgAigCACIFQQFqNgIAIAEgBS0AADoAECACIAIoAgAiBUEBajYCACABIAUtAAA6ABEgAiACKAIAIgVBAWo2AgAgASAFLQAAOgASIAIgAigCACIFQQFqNgIAIAEgBS0AADoAEyACIAIoAgAiBUEBajYCACABIAUtAAA6ABQgAiACKAIAIgVBAWo2AgAgASAFLQAAOgAVIAIgAigCACIFQQFqNgIAIAEgBS0AADoAFiACIAIoAgAiBUEBajYCACABIAUtAAA6ABcgAiACKAIAIgVBAWo2AgAgASAFLQAAOgAYIAIgAigCACIFQQFqNgIAIAEgBS0AADoAGSACIAIoAgAiBUEBajYCACABIAUtAAA6ABogAiACKAIAIgVBAWo2AgAgASAFLQAAOgAbIAIgAigCACIFQQFqNgIAIAEgBS0AADoAHCACIAIoAgAiBUEBajYCACABIAUtAAA6AB0gAiACKAIAIgVBAWo2AgAgASAFLQAAOgAeIAIgAigCACIFQQFqNgIAIAEgBS0AADoAHyALQQFqIgsgDUcNAAsLIA5BQGskACATRQRAQQFBj7orQQAQmwlBBCEGDAILQeQAQYvBK0EAEJsJIAdBkARqIBooAgBBgMwxENYKIAdBsARqIgQgGigCAEHQzDEQ1gogByAH/QADwAT9CwP4AyAHIAT9AAMA/QsD6AMgByAH/QADoAT9CwPYAyAHIAf9AAOQBP0LA8gDIAdCgICAgAg3A4gEIAcgGjYCxAMgB0GwiDQ2AsADIAdBsIg0NgK8AyAHIAdBwANqNgK4AyAHIAM2ArQDAn8gB0G0A2ohCyADIQRBACEaQQAhFP0MAAAAAAAAAAAAAAAAAAAAACE1IAdByAJqIhMgKyIGNgIAIBMgBigCFCAGKAIYayIWNgIEIBNBCGohBQJAIAYoAhAiHEUEQCAFIBZBABDaCgwBCyAGKAIgIRcgHEEFTwRAIBwgHEEDcSIUQQQgFBtrIRQDQCA1IBcgGkEDckEMbGpBBGogFyAaQQJyQQxsakEEaiAXIBpBAXJBDGxqQQRqIBcgGkEMbGr9XAIE/VYCAAH9VgIAAv1WAgADQQL9qwH9rgH9DAMAAAADAAAAAwAAAAMAAAD9rgEhNSAaQQRqIhogFEcNAAsgNSA1IDX9DQgJCgsMDQ4PAAECAwABAgP9rgEiNSA1IDX9DQQFBgcAAQIDAAECAwABAgP9rgH9GwAhGgsDQCAaIBcgFEEMbGooAgRBAnRqQQNqIRogFEEBaiIUIBxHDQALIAUgFiAaaiAcENoKCyAGKAIQIRogE0EANgJgIBNCADcCWCAaRQRAIBMgBDYCaCATIAs2AmQgEwwBCyAaQdaq1aoBSQRAIBMgGkEMbCIXEKIJIhw2AlggEyAXIBxqNgJgQQAhFCAXQQxrIhcgF0EMcGtBDGoiFwRAIBxBACAX/AsACyATIAQ2AmggEyALNgJkIBMgFyAcajYCXCATKAIEIRcgBigCICEGAkAgGkEBRwRAIBpBAXEhBCAaQf7///8BcSEFA0AgHCAUQQxsIhZqIhogBiAWaigCBEECdCAXaiIXNgIAIBogF0ECajYCCCAaIBdBAWo2AgQgHCAUQQFyQQxsIhZqIhogFyAGIBZqKAIEQQJ0aiIXQQVqNgIIIBogF0EEajYCBCAaIBdBA2o2AgAgF0EGaiEXIBRBAmoiFCAFRw0ACyAERQ0BCyAcIBRBDGwiGmoiFCAGIBpqKAIEQQJ0IBdqIhc2AgAgFCAXQQJqNgIIIBQgF0EBajYCBAsgEwwBCxCgCQALIRQCfyAHQbgDaiELQQAhGkEAIRP9DAAAAAAAAAAAAAAAAAAAAAAhNSAHQdwBaiIcICoiBDYCACAcIAQoAhQgBCgCGGsiBTYCBCAcQQhqIQYCQCAEKAIQIhZFBEAgBiAFQQAQ2woMAQsgBCgCICEXIBZBBU8EQCAWIBZBA3EiE0EEIBMbayETA0AgNSAXIBpBA3JBDGxqQQRqIBcgGkECckEMbGpBBGogFyAaQQFyQQxsakEEaiAXIBpBDGxq/VwCBP1WAgAB/VYCAAL9VgIAA0EC/asB/a4B/QwDAAAAAwAAAAMAAAADAAAA/a4BITUgGkEEaiIaIBNHDQALIDUgNSA1/Q0ICQoLDA0ODwABAgMAAQID/a4BIjUgNSA1/Q0EBQYHAAECAwABAgMAAQID/a4B/RsAIRoLA0AgGiAXIBNBDGxqKAIEQQJ0akEDaiEaIBNBAWoiEyAWRw0ACyAGIAUgGmogFhDbCgsgBCgCECEaIBxBADYCYCAcQgA3AlggGkUEQCAcQbCINDYCaCAcIAs2AmQgHAwBCyAaQdaq1aoBSQRAIBwgGkEMbCIXEKIJIhY2AlggHCAWIBdqNgJgQQAhEyAXQQxrIhcgF0EMcGtBDGoiFwRAIBZBACAX/AsACyAcQbCINDYCaCAcIAs2AmQgHCAWIBdqNgJcIBwoAgQhFyAEKAIgIQQCQCAaQQFHBEAgGkEBcSELIBpB/v///wFxIQYDQCAWIBNBDGwiBWoiGiAEIAVqKAIEQQJ0IBdqIhc2AgAgGiAXQQJqNgIIIBogF0EBajYCBCAWIBNBAXJBDGwiBWoiGiAXIAQgBWooAgRBAnRqIhdBBWo2AgggGiAXQQRqNgIEIBogF0EDajYCACAXQQZqIRcgE0ECaiITIAZHDQALIAtFDQELIBYgE0EMbCIaaiITIAQgGmooAgRBAnQgF2oiFzYCACATIBdBAmo2AgggEyAXQQFqNgIECyAcDAELEKAJAAshEyAHQeAAaiAoICkQ1QohBEHkAEGZ3ilBABCbCSAEIBtB4ABqQSAQ2QpB5ABBmd4pQQAQmwkgBCAiQeAAakEgENkKIAQQxwkhNQJ/ICsoAhghFiAHQcwAaiIFQQA2AhAgBUIANwIIIAUgFjYCBCAFQQE2AgACQCAWBEAgFkGAgICAAU8NASAFIBZBBHQiFhCeCSILNgIIIAUgCyAWaiIGNgIQIBYEQCALQQAgFvwLAAsgBSAGNgIMCyAFDAELEKAJAAshBQJ/ICooAhghHCAHQThqIhZBADYCECAWQgA3AgggFiAcNgIEIBZBATYCAAJAIBwEQCAcQYCAgMAATw0BIBYgHEEFdCIcEKIJIgs2AgggFiALIBxqIgY2AhAgHARAIAtBACAc/AsACyAWIAY2AgwLIBYMAQsQoAkACyELIAdBMGogBRCZCyEWIAdBKGogCxCZCyEXIAdB8BdqIRogB0HQF2ohHCAmIgYQJyEhIAdB0ARqISUjAEGgAWsiHyQAIBYiJiAsIAkgJCADEJwJAkACQCAWKAIAIgMgFigCBCIkKAIETw0AIBYgA0EBajYCACAkKAIIIANBBHRqICX9AAQA/QsEACAWKAIAIgMgFigCBCIkKAIETw0AIBYgA0EBajYCACAkKAIIIANBBHRqICX9AAQQ/QsEACAWKAIAIgMgFigCBCIkKAIETw0AIBYgA0EBajYCACAkKAIIIANBBHRqICX9AAQg/QsEACAWKAIAIgMgFigCBCIkKAIETw0AIBYgA0EBajYCACAkKAIIIANBBHRqICX9AAQw/QsEACAWKAIAIgMgFigCBCIkKAIETw0AIBYgA0EBajYCACAkKAIIIANBBHRqICX9AARA/QsEACAWKAIAIgMgFigCBCIkKAIETw0AIBYgA0EBajYCACAkKAIIIANBBHRqICX9AARQ/QsEACAWKAIAIgMgFigCBCIkKAIETwRAIB9Bo9grNgJQQeQAQfSHKiAfQdAAahCbCUGQljQoAgAoAgAhFyAfQaPYKzYCQCAXQZGMKiAfQUBrEGwACyAmIANBAWo2AgAgJCgCCCADQQR0aiA1/QsEAEEAISRBACEmQQAhCQJAAkACQCAhBEAgIUEASA0BICEQogkhCSAhBEAgCSAGICH8CgAACyAJICFqISYLIB9BgAFqICggKSAJICYQowlBsIg0IB9BgAFqQfCINBCkCSAXIBogHCAfQYABahChCQNAICUgJEEEdGohA0IAIT4DQCAD/QAEACI3/R0AID6IIDf9HQEgPkJAfIggPkI/WBshQCAXKAIAIiYgFygCBCIhKAIETw0DIBcgJkEBajYCACAhKAIIICZBBXRqIiZB6ABBiAEgQEIBg1AbIiFBwIg0av0AAwD9CwMQICYgIUGwiDRq/QADAP0LAwAgPkIBfCI+QoABUg0ACyAkQQFqIiRBBkcNAAsMAgsQoAkACyAfQaPYKzYCMEHkAEH0hyogH0EwahCbCUGQljQoAgAoAgAhFyAfQaPYKzYCICAXQZGMKiAfQSBqEGwACyA1/R0AIUAgNf0dASE/QgAhPgJAA0AgFygCACImIBcoAgQiISgCBE8NASAXICZBAWo2AgAgISgCCCAmQQV0aiImQegAQYgBIEAgPoggPyA+QkB8iCA+QsAAVBtCAYNQGyIhQcCINGr9AAMA/QsDECAmICFBsIg0av0AAwD9CwMAID5CAXwiPkKAAVINAAsgCQRAIAkQKwsgH0GgAWokAAwCCyAfQaPYKzYCEEHkAEH0hyogH0EQahCbCUGQljQoAgAoAgAhFyAfQaPYKzYCACAXQZGMKiAfEGwACyAfQaPYKzYCcEHkAEH0hyogH0HwAGoQmwlBkJY0KAIAKAIAIRcgH0Gj2Cs2AmAgF0GRjCogH0HgAGoQbAALQQkhBgJAIBYoAgAgKygCGEcNACAXKAIAICooAhhHDQBBACEgQQAhH0EAISVBACEXQQAhGv0MAAAAAAAAAAAAAAAAAAAAACE1IwBB4ABrIgIkAEHkAEHJrylBABCbCSAEIgMgFCgCACAFEOMKIAJBADYCPCACQgA3AjQgAkEANgIwIAJCADcCKCACQbjTMf0AAAD9CwMYIAJBqNMx/QAAAP0LAwggFCgCACAFIBsiBkEEakEAIAJBNGogAkEoaiAEIBQoAgQgFCgCaBDoCiEOIAIoAjQhISACKAI4ISYgFCgCaCEBIBQoAmQhKCAUKAJYISkgAigCKCEkAkACQAJAAkACQAJAAkAgFCgCOCIJRQ0AIAlBgICAgAFPDQEgCUEEdCIJEJ4JISUgCUUNACAlQQAgCfwLAAsCQCAORQ0AIA5BgICAgAFPDQEgDkEEdCIJEJ4JIR8gCUUNACAfQQAgCfwLAAsCQCAUKAIMIglFDQAgCUHWqtUqTw0CIAlBMGwiCRCeCSEXIAkgCUEwa0EwcGsiCUUNACAXQQAgCfwLAAsCQCAUKAI0IglFDQAgCUGAgICAAU8NASAJQQR0IgkQngkhGiAJRQ0AIBpBACAJ/AsACwJAIBQoAhQiCUUNACAJQYCAgIAETw0DIAlBAnQiCRCiCSEgIAlFDQAgIEEAIAn8CwALIAMgAkEIakEgENkKAkAgFCgCOCIMRQ0AQQAhCSAMQQFHBEAgDEEBcSEKICVBEGohESAMQX5xIRUDQCADIAJBQGtBECADKAIAKAIIEQEAICUgCUEEdCIMaiAC/QAEQP0LBAAgAyACQUBrQRAgAygCACgCCBEBACAMIBFqIAL9AARA/QsEACAJQQJqIgkgFUcNAAsgCkUNAQsgAyACQUBrQRAgAygCACgCCBEBACAlIAlBBHRqIAL9AARA/QsEAAsCQCAORQ0AQQAhCSAOQQFHBEAgDkEBcSEKIB9BEGohESAOQX5xIRUDQCADIAJBQGtBECADKAIAKAIIEQEAIB8gCUEEdCIMaiAC/QAEQP0LBAAgAyACQUBrQRAgAygCACgCCBEBACAMIBFqIAL9AARA/QsEACAJQQJqIgkgFUcNAAsgCkUNAQsgAyACQUBrQRAgAygCACgCCBEBACAfIAlBBHRqIAL9AARA/QsEAAsCQCAUKAIMIgxFDQBBACEJIAxBA2wiDEEBRwRAIAxBAXEhCiAXQRBqIREgDEF+cSEVA0AgAyACQUBrQRAgAygCACgCCBEBACAXIAlBBHQiDGogAv0ABED9CwQAIAMgAkFAa0EQIAMoAgAoAggRAQAgDCARaiAC/QAEQP0LBAAgCUECaiIJIBVHDQALIApFDQELIAMgAkFAa0EQIAMoAgAoAggRAQAgFyAJQQR0aiAC/QAEQP0LBAALIAZBgAFqIQogBkHgAGohCCAUQQhqIRwCQCAUKAI0IgxFDQBBACEJIAxBAUcEQCAMQQFxIQ0gGkEQaiERIAxBfnEhFQNAIAMgAkFAa0EQIAMoAgAoAggRAQAgGiAJQQR0IgxqIAL9AARA/QsEACADIAJBQGtBECADKAIAKAIIEQEAIAwgEWogAv0ABED9CwQAIAlBAmoiCSAVRw0ACyANRQ0BCyADIAJBQGtBECADKAIAKAIIEQEAIBogCUEEdGogAv0ABED9CwQACyADIAYoApwBIBQoAhwQ5wogAyAGKAKoASAUKAIgEOcKIAMgBigCtAEgFCgCKBDnCiADIAYoAsABIBQoAiAgFCgCHGsQ5wogICAcIAMQ6gogFCgCFCEDIBQoAiAhCSAUKAIYIQwgAiABNgJMIAIgCjYCSCACIBw2AkQgAkGM0zE2AkAgAiACQUBrNgJQIAwgCWsgCCAGQdgBaiAgIAMgAkFAaxCbCyEJAkAgAigCUCIDIAJBQGtGBH9BEAUgA0UNAUEUCyEMIAMgAygCACAMaigCABEGAAsgCUUEQEG1vCshAwwECyAoKAIAISMCQCAUKAIUIhVFBEAgBkGUAWohCiAGQcwBaiENQQAhEQwBCyAVQYCAgIABTw0BQQAhAyAVQQR0IgkQngkhESAJBEAgEUEAIAn8CwALIBVBA3EhCCAGKALMASAGKAKUASAUKAJEbEEEdGohCSAVQQRPBEAgFUH8////AHEhDQNAIBEgA0EEdCIMaiAJIAxq/QAEAP0LBAAgESAMQRByIgFqIAEgCWr9AAQA/QsEACARIAxBIHIiAWoiCiABIAlqIgEpAwA3AwAgCiABKQMINwMIIBEgDEEwciIMaiIBIAkgDGoiDCkDCDcDCCABIAwpAwA3AwAgA0EEaiIDIA1HDQALCyAGQZQBaiEKIAZBzAFqIQ0gCEUNAEEAIQwDQCARIANBBHQiAWogASAJav0ABAD9CwQAIANBAWohAyAMQQFqIgwgCEcNAAsLIBQoAjgiCARAIA0oAgAhDSAKKAIAIR0gFCgCUCEYIBQoAhQhFUEAIQoDQCAVBEAgDSAdIAogGGpsQQR0aiEBICUgCkEEdGr9AAQAITdBACEDA0AgESADQQR0IglqIgwgDP0ABAAgASAJav0ABAAgNxCaCf1R/QsEACADQQFqIgMgFUcNAAsLIApBAWoiCiAISQ0ACwtBACEDQQAhAQJAIBVFDQAgFUGAgICAAU8NASAVQQR0IgkQngkhASAJRQ0AIAFBACAJ/AsACyABIBwgFCgCHCAGKAKcASAgICMQnAsCQCAUKAIUIhUEQANAIAEgA0EEdCIJaiIMKQMAIAkgEWoiCSkDAFEgDCkDCCAJKQMIUXEiCQRAIANBAWoiAyAVRw0BCwsgARArIBEQKyAJDQFBybwrIQMMBQsgARArIBFFDQAgERArCwJAIBQoAiwgFCgCOGwiA0UEQEEAISMMAQsgA0GAgICAAU8NASADQQR0IgMQngkhIyADRQ0AICNBACAD/AsACyAjIBwgDiAmICFrQQV1ICEgHyApIBcQ6QoCQCAUKAIUIgxFBEAgBkGUAWohGCAGQcwBaiEhQQAhFQwBCyAMQYCAgIABTw0BQQAhAyAMQQR0IgkQngkhFSAJBEAgFUEAIAn8CwALIAxBA3EhCiAGKALMASAGKAKUASAUKAJIbEEEdGohCSAMQQRPBEAgDEH8////AHEhCANAIBUgA0EEdCIMaiAJIAxq/QAEAP0LBAAgFSAMQRByIhFqIAkgEWr9AAQA/QsEACAVIAxBIHIiEWoiASAJIBFqIhEpAwA3AwAgASARKQMINwMIIBUgDEEwciIMaiIRIAkgDGoiDCkDCDcDCCARIAwpAwA3AwAgA0EEaiIDIAhHDQALCyAGQZQBaiEYIAZBzAFqISEgCkUNAEEAIQwDQCAVIANBBHQiEWogCSARav0ABAD9CwQAIANBAWohAyAMQQFqIgwgCkcNAAsLIBQpAhghPyAoKAIAIQNBoCAQngkiHSA/QiCJNwIEIB0gAzYCACAdQRBqIAMQ3QpBACEMQQAhDQJAIBQoAhgiA0UNACADQYCAgIABTw0BIANBBHQiAxCeCSENIANFDQAgDUEAIAP8CwALAkAgFCgCFCIDRQ0AIANBgICAgAFPDQEgA0EEdCIDEJ4JIQwgA0UNACAMQQAgA/wLAAsgFCgCOARAQQAhCANAAkAgFCgCKCIDRQ0AIANBBHQiCUUNACANQQAgCfwLAAsCQCAUKAIsIglFDQAgCUEEdCIRRQ0AIA0gA0EEdGogIyAIIAlsQQR0aiAR/AoAAAsgHSANEN4KIBQoAhQiAQRAIA0gFCgCIEEEdGohCUEAIQMCQCABQQFHBEAgAUEBcSEmIAFBfnEhCgNAIAwgA0EEdGogCSAgIANBAnRqKAIAQQR0av0ABAD9CwQAIAwgA0EBciIRQQR0aiAJICAgEUECdGooAgBBBHRq/QAEAP0LBAAgA0ECaiIDIApHDQALICZFDQELIAwgA0EEdGogCSAgIANBAnRqKAIAQQR0av0ABAD9CwQACyAhKAIAIBgoAgAgFCgCUCAIamxBBHRqIQpBACEDA0AgFSADQQR0IglqIhEgEf0ABAAgCSAKav0ABAAgCSAMav0ABAAQmgn9Uf0LBAAgA0EBaiIDIAFHDQALCyAIQQFqIgggFCgCOEkNAAsLIAwEQCAMECsLIA0EQCANECsLIB0QK0EAIQNBACERAkAgFCgCFCIJRQ0AIAlBgICAgAFPDQEgCUEEdCIJEJ4JIREgCUUNACARQQAgCfwLAAsgESAcIBQoAiAgBigCqAEgICAoKAIAEJwLAkAgFCgCFCIBBEADQCARIANBBHQiCWoiDCkDACAJIBVqIgkpAwBRIAwpAwggCSkDCFFxIgkEQCADQQFqIgMgAUcNAQsLIBEQKyAVECsgCQ0BICMQK0GkvCshAwwFCyARECsgFUUNACAVECsL/QwAAAAAAAAAAAAAAAAAAAAAITcgDgRAQQAhAwNAICQgA0EEdCIJav0ABAAgCSAfav0ABAAQmgkgNf1RITUgA0EBaiIDIA5HDQALCwJAIBQoAiwiDkUNACAGKAKoASAUKAIoQQR0aiERIA5BA3EhFUEAIQwgDkEESQR/QQAFIBFBMGohASARQSBqIQogEUEQaiEIIA5BfHEhDUEAIQkDQCABIAlBBHQiA2r9AAQAIAMgCmr9AAQAIAMgCGr9AAQAIAMgEWr9AAQAIDf9Uf1R/VH9USE3IAlBBGoiCSANRw0ACyAOQXxxCyEDIBVFDQADQCARIANBBHRq/QAEACA3/VEhNyADQQFqIQMgDEEBaiIMIBVHDQALCyAjECsgNSA3/dcBIjf9HQAgN/0dAYSnQQFxBEBBjOgpIQMMBAsCfyAUKAIUIgxFBEAgBkHMAWohDEEAIQpBACEDIAZBlAFqDAELIAxBgICAgAFPDQFBACEDIAxBBHQiDRCeCSEKIA1FIg5FBEAgCkEAIA38CwALIAxBA3EhASAGKALMASAGKAKUASAUKAJMbEEEdGohCSAMQQRPBEAgDEH8////AHEhCANAIAogA0EEdCIMaiAJIAxq/QAEAP0LBAAgCiAMQRByIhFqIAkgEWr9AAQA/QsEACAKIAxBIHIiEWoiFSAJIBFqIhEpAwA3AwAgFSARKQMINwMIIAogDEEwciIMaiIRIAkgDGoiDCkDCDcDCCARIAwpAwA3AwAgA0EEaiIDIAhHDQALCyABBEBBACEMA0AgCiADQQR0IhFqIAkgEWr9AAQA/QsEACADQQFqIQMgDEEBaiIMIAFHDQALCyANEJ4JIQMgDkUEQCADQQAgDfwLAAsgBkHMAWohDCAGQZQBagshCSAUKAI0IiYEQCAmIBQoAlQiI2oiKSAmaiEWIBQoAhQiFUF8cSEdIBVBA3EhDiAMKAIAISQgCSgCACEhQQAhGANAIBUEQCAkICEgFiAYamxBBHRqIQxBACEBQQAhCSAVQQRPBEADQCADIAlBBHQiEWogDCARav0ABAD9CwQAIAMgEUEQciIIaiAIIAxq/QAEAP0LBAAgAyARQSByIghqIg0gCCAMaiIIKQMANwMAIA0gCCkDCDcDCCADIBFBMHIiEWoiCCAMIBFqIhEpAwg3AwggCCARKQMANwMAIAlBBGoiCSAdRw0ACwsgDgRAA0AgAyAJQQR0IhFqIAwgEWr9AAQA/QsEACAJQQFqIQkgAUEBaiIBIA5HDQALCyAkICEgGCApamxBBHRqIQEgJCAhIBggI2psQQR0aiEIQQAhCQNAIAMgCUEEdCIMaiIRIBH9AAQAIAEgDGr9AAQAIAggDGr9AAQAEJoJ/VH9CwQAIAlBAWoiCSAVRw0ACyAaIBhBBHRq/QAEACE3QQAhCQNAIAogCUEEdCIMaiIRIBH9AAQAIAMgDGr9AAQAIDcQmgn9Uf0LBAAgCUEBaiIJIBVHDQALCyAYQQFqIhggJkcNAAsLIAMEQCADECsLAkAgFCgCICIYRQRAQQAhCQwBCyAYQYCAgIABTw0BIBhBBHQiAxCeCSEJIANFDQAgCUEAIAP8CwALAkAgFCgCKCIdRQ0AIAYoArQBIQwgHUEDcSENQQAhFUEAIQMgHUEETwRAIB1BfHEhDgNAIAkgA0EEdCIRaiAMIBFq/QAEAP0LBAAgCSARQRByIgFqIAEgDGr9AAQA/QsEACAJIBFBIHIiAWoiCCABIAxqIgEpAwA3AwAgCCABKQMINwMIIAkgEUEwciIRaiIBIAwgEWoiESkDCDcDCCABIBEpAwA3AwAgA0EEaiIDIA5HDQALCyANRQ0AA0AgCSADQQR0IhFqIAwgEWr9AAQA/QsEACADQQFqIQMgFUEBaiIVIA1HDQALCwJAIBQoAiwiA0UNACADQQR0IgNFDQAgCSAdQQR0akEAIAP8CwALAkAgGCAUKAIcIhVGDQAgCSAVQQR0aiEMIAYoAsABIREgGCAVayIIQQNxIQ5BACEBQQAhAyAVIBhrQXxNBEAgCEF8cSEdA0AgDCADQQR0IhVqIBEgFWr9AAQA/QsEACAMIBVBEHIiCGogCCARav0ABAD9CwQAIAwgFUEgciIIaiINIAggEWoiCCkDADcDACANIAgpAwg3AwggDCAVQTByIhVqIgggESAVaiIVKQMINwMIIAggFSkDADcDACADQQRqIgMgHUcNAAsLIA5FDQADQCAMIANBBHQiFWogESAVav0ABAD9CwQAIANBAWohAyABQQFqIgEgDkcNAAsLQQAhA0EAIRUCQCAUKAIUIgxFDQAgDEGAgICAAU8NASAMQQR0IgwQngkhFSAMRQ0AIBVBACAM/AsACyAVIBwgGCAJICAgKCgCABCcCwJAIBQoAhQiAUUEQEEBIQwMAQsDQCAVIANBBHQiDGoiESkDACAKIAxqIgwpAwBRIBEpAwggDCkDCFFxIgxFDQEgA0EBaiIDIAFHDQALCyAVECsgCRArIAoEQCAKECsLICAQK0HM0ipB4bwrIAwbIQMMBAsQoAkACxCgCQALEKAJAAsgIBArQQAhDCAaRQ0BCyAaECsLIBcEQCAXECsLIB8EQCAfECsLICUEQCAlECsLIAIgAzYCAEHkAEHqiiogAhCbCSACKAIoIgMEQCADECsLIAIoAjQiAwRAIAMQKwsgAkHgAGokACAMIQZBACEgQQAhGkEAIRxBACEkQQAhKEEAISkjAEGAAWsiDCQAQeQAQcmvKUEAEJsJIAQiAyATKAIAIAsgEygCaBDsCiAMQQA2AjwgDEIANwI0IAxBADYCMCAMQgA3AiggDEG40zH9AAAA/QsDGCAMQajTMf0AAAD9CwMIIBMoAgAgCyAiQQRqQQAgDEE0aiAMQShqIAQgEygCBCATKAJoEPkKIR8gDCgCOCAMKAI0Ig5rQShtIRggEygCaCEJIBMoAmQhJSATKAJYIQ0gDCgCKCEWAkACQAJAIBMoAjgiEEUNACAQQYCAgMAATw0BIBBBBXQiEBCiCSEoIBBFDQAgKEEAIBD8CwALAkAgH0UNACAfQYCAgMAATw0BIB9BBXQiEBCiCSEaIBBFDQAgGkEAIBD8CwALAkACQAJAAkACQCATKAIMIhBFDQAgEEGr1aoVTw0BIBBB4ABsIhAQogkhKSAQIBBB4ABrQeAAcGsiEEUNACApQQAgEPwLAAsCQCATKAI0IhBFDQAgEEGAgIDAAE8NBSAQQQV0IhAQogkhHCAQRQ0AIBxBACAQ/AsACwJAIBMoAhQiEEUNACAQQYCAgIAETw0CIBBBAnQiEBCiCSEgIBBFDQAgIEEAIBD8CwALIAMgDEEIakEgENkKIAMgKCATKAI4IAkQ7QogAyAaIB8gCRDtCiADICkgEygCDEEDbCAJEO0KIAMgHCATKAI0IAkQ7QogAyAiKAKcASATKAIcIAkQ+AogAyAiKAKoASATKAIgIAkQ+AogAyAiKAK0ASATKAIoIAkQ+AogAyAiKALAASATKAIgIBMoAhxrIAkQ+AogICATQQhqIiYgAxDqCiATKAIUIQMgEygCICEQIBMoAhghEiAMIAk2AmwgDCAiQYABajYCaCAMICY2AmQgDEHQ0zE2AmAgDCAMQeAAajYCcCASIBBrICJB4ABqICJB2AFqICAgAyAMQeAAahCbCyEQAkAgDCgCcCIDIAxB4ABqRgR/QRAFIANFDQFBFAshEiADIAMoAgAgEmooAgARBgALIBBFBEBBACEDQbW8KyEQDAYLICUoAgQhIyAlKAIAIRcCQCATKAIUIhlFBEAgIkGUAWohAiAiQcwBaiEIDAELIBlBgICAwABPDQVBACEDIBlBBXQiEBCiCSEeIBAEQCAeQQAgEPwLAAsgGUEDcSERICIoAswBICIoApQBIBMoAkRsQQV0aiEQIBlBBE8EQCAZQfz//z9xIQIDQCAeIANBBXQiEmoiDyAQIBJqIhX9AAMA/QsDACAPIBX9AAMQ/QsDECAeIBJBIHIiD2oiFSAPIBBqIg/9AAMQ/QsDECAVIA/9AAMA/QsDACAeIBJBwAByIg9qIhUgDyAQaiIP/QADEP0LAxAgFSAP/QADAP0LAwAgHiASQeAAciISaiIPIBAgEmoiEv0AAxD9CwMQIA8gEv0AAwD9CwMAIANBBGoiAyACRw0ACwsgIkGUAWohAiAiQcwBaiEIIBFFDQBBACESA0AgHiADQQV0Ig9qIhUgDyAQaiIP/QADAP0LAwAgFSAP/QADEP0LAxAgA0EBaiEDIBJBAWoiEiARRw0ACwsgEygCOCIKBEAgCCgCACEdIAIoAgAhISATKAJQIQFBACEIIAxB+ABqIREgDEHoAGohAgNAIAwgKCAIQQV0aiID/QADEP0LA1AgDCAD/QADAP0LA0AgGQRAIB0gISABIAhqbEEFdGohFUEAIRIDQCAMQfAAaiIQIBUgEkEFdCIDaiIP/QADEP0LAwAgDCAP/QADAP0LA2AgCSAMQeAAaiAMQUBrEKQJIAMgHmoiAyAJKQM4Ik0gAykDGCJIIBEpAwB8IkogAykDECJBIBApAwB8IkMgQVQgQyADKQMIIkUgAikDAHwiQSBFVCBBIAMpAwAiQiAMKQNgfCJFIEJUrXwiQiBBVHKtfCJBIENUcq18IkN8IkcgCSkDMCJEIEF8IkkgRFQgSSAJKQMoIkYgQnwiRCBGVCBEIAkpAyAiRiBFfCJLIEZUrXwiRiBEVHKtfCJEIElUcq18IkkgQyBDIEpUIEggSlZyIEcgTVQgRyBJVnJzIhAbNwMYIAMgRCBBIBAbNwMQIAMgRiBCIBAbNwMIIAMgSyBFIBAbNwMAIBJBAWoiEiAZRw0ACwsgCEEBaiIIIApJDQALC0EAIRJBACEPAkAgGUUNACAZQYCAgMAATw0FIBlBBXQiAxCiCSEPIANFDQAgD0EAIAP8CwALIA8gJiATKAIcICIoApwBICAgFyAjEJ0LAkACQAJAIBMoAhQiGQRAA0ACQCAPIBJBBXQiEGoiAykDACAQIB5qIhApAwBSDQAgAykDCCAQKQMIUg0AIAMpAxAgECkDEFINACADKQMYIBApAxhSDQAgGSASQQFqIhJHDQEMAwsLIA8QKyAeECtBACEDQcm8KyEQDAkLIA8QKyAeDQEMAgsgDxArCyAeECsLAkAgEygCLCATKAI4bCIDRQ0AIANBgICAwABPDQUgA0EFdCIDEKIJISQgA0UNACAkQQAgA/wLAAsgJCAmIB8gGCAOIBogDSApIAkQ+goCQCATKAIUIhJFBEAgIkGUAWohIyAiQcwBaiEXQQAhAQwBCyASQYCAgMAATw0FQQAhAyASQQV0IhAQogkhASAQBEAgAUEAIBD8CwALIBJBA3EhGSAiKALMASAiKAKUASATKAJIbEEFdGohECASQQRPBEAgEkH8//8/cSEVA0AgASADQQV0IhJqIg8gECASaiIe/QADAP0LAwAgDyAe/QADEP0LAxAgASASQSByIg9qIh4gDyAQaiIP/QADEP0LAxAgHiAP/QADAP0LAwAgASASQcAAciIPaiIeIA8gEGoiD/0AAxD9CwMQIB4gD/0AAwD9CwMAIAEgEkHgAHIiEmoiDyAQIBJqIhL9AAMQ/QsDECAPIBL9AAMA/QsDACADQQRqIgMgFUcNAAsLICJBlAFqISMgIkHMAWohFyAZRQ0AQQAhEgNAIAEgA0EFdCIPaiIeIA8gEGoiD/0AAwD9CwMAIB4gD/0AAxD9CwMQIANBAWohAyASQQFqIhIgGUcNAAsLICUoAgAhAyAlKAIEIRAgEygCGCESIBMoAhwhD0EoEKIJIA8gEiAQIAMQ4AohDQJAIBMoAhgiA0UEQEEAIRkMAQsgA0GAgIDAAE8NBSADQQV0IgMQogkhGSADRQ0AIBlBACAD/AsACwJAIBMoAhQiAwRAIANBgICAwABPDQYgA0EFdCIDEKIJIRUgAwRAIBVBACAD/AsACyATKAI4DQEMBAtBACEVIBMoAjhFDQQLIBlB4ABqIQogGUFAayEdIBlBIGohISAJQegAaiEDQQAhDgNAAkAgEygCKCIYRQ0AIBhBA3EhAkEAIR5BACEQIBhBBE8EQCAYQXxxIQgDQCAZIBBBBXQiEmoiDyAD/QADAP0LAwAgDyADQRBqIg/9AAMA/QsDECASICFqIhEgD/0AAwD9CwMQIBEgA/0AAwD9CwMAIBIgHWoiESAP/QADAP0LAxAgESAD/QADAP0LAwAgCiASaiISIA/9AAMA/QsDECASIAP9AAMA/QsDACAQQQRqIhAgCEcNAAsLIAJFDQADQCAZIBBBBXRqIhIgA/0AAwD9CwMAIBIgA/0AAxD9CwMQIBBBAWohECAeQQFqIh4gAkcNAAsLAkAgEygCLCIQRQ0AIBBBBXQiEkUNACAZIBhBBXRqICQgDiAQbEEFdGogEvwKAAALIA0gGRDiCgJAIBMoAhQiAkUNACAZIBMoAiBBBXRqIRJBACEQIAJBAUcEQCACQQFxIQggAkF+cSERA0AgFSAQQQV0aiIPIBIgICAQQQJ0aigCAEEFdGoiHv0AAwD9CwMAIA8gHv0AAxD9CwMQIBUgEEEBciIPQQV0aiIeIBIgICAPQQJ0aigCAEEFdGoiD/0AAwD9CwMAIB4gD/0AAxD9CwMQIBBBAmoiECARRw0ACyAIRQ0BCyAVIBBBBXRqIg8gEiAgIBBBAnRqKAIAQQV0aiIQ/QADAP0LAwAgDyAQ/QADEP0LAxALIAIgASAVIBcoAgAgIygCACATKAJQIA5qbEEFdGogCRD7CiAOQQFqIg4gEygCOEkNAAsMAgsQoAkACxCgCQALIBUQKwsgGQRAIBkQKwsgDSgCHCIDBEAgDSADNgIgIAMQKwsgDSgCECIDBEAgDSADNgIUIAMQKwsgDSgCDCEDQQAhDyANQQA2AgwgAwRAIAMoAlwiEARAIAMgEDYCYCAQECsLIAMQKwsgDRArAkAgEygCFCIDRQ0AIANBgICAwABPDQEgA0EFdCIDEKIJIQ8gA0UNACAPQQAgA/wLAAsgDyAmIBMoAiAgIigCqAEgICAlKAIAICUoAgQQnQsCQAJAAkAgEygCFCIeBEBBACESA0ACQCAPIBJBBXQiEGoiAykDACABIBBqIhApAwBSDQAgAykDCCAQKQMIUg0AIAMpAxAgECkDEFINACADKQMYIBApAxhSDQAgHiASQQFqIhJHDQEMAwsLIA8QKyABECsgJBArQQAhA0GkvCshEAwFCyAPECsgAQ0BDAILIA8QKwsgARArCyAJKQOAASJJIUQgCSkDeCJCIUcgCSkDcCJBIUUgCSkDaCJKIUMgHwRAQQAhECAMQegAaiEeIAxB+ABqIRkDQCAMQfAAaiIDIBYgEEEFdCISaiIP/QADEP0LAwAgDCAP/QADAP0LA2AgCSAMQeAAaiASIBpqEKQJIAkpAzgiPCBEIBkpAwB8Ik0gRyADKQMAfCJIIEdUIEggRSAeKQMAfCJHIEVUIEcgQyAMKQNgfCJGIENUrXwiQyBHVHKtfCJFIEhUcq18Ikd8IkggCSkDMCJMIEV8IksgTFQgSyAJKQMoIk4gQ3wiTCBOVCBMIAkpAyAiTiBGfCI9IE5UrXwiTiBMVHKtfCJMIEtUcq18IksgRyBHIE1UIEQgTVZyIDwgSFYgSCBLVnJzIgMbIUQgTCBFIAMbIUcgTiBDIAMbIUUgPSBGIAMbIUMgEEEBaiIQIB9HDQALCyATKAIsIhIEQCAiKAKoASATKAIoQQV0aiEPIAkpAzghPCAJKQMwIU4gCSkDKCE9IAkpAyAhPkEAIRADQCA8IEkgDyAQQQV0aiIDKQMYfCJNIEIgAykDEHwiSCBCVCBIIEEgAykDCHwiQiBBVCBCIEogAykDAHwiRiBKVK18IkogQlRyrXwiQSBIVHKtfCJCfCJIIEEgTnwiSyBOVCBLID0gSnwiTCA9VCBMID4gRnwiQCA+VK18Ij8gTFRyrXwiTCBLVHKtfCJLIEIgQiBNVCBJIE1WciA8IEhWIEggS1ZycyIDGyFJIEwgQSADGyFCID8gSiADGyFBIEAgRiADGyFKIBBBAWoiECASRw0ACwsgJBArQQAhA0GM6CkhECBDIEpSDQEgQSBFUg0BIEIgR1INASBEIElSDQECQAJAAn8gEygCFCIRBEAgEUGAgIDAAE8NBCARQQV0IgIQogkhFSACRSIIRQRAIBVBACAC/AsACyARQQNxIR0gIigCzAEiDiAiKAKUASIYIBMoAkxsQQV0aiEQIBFBBE8EQCARQfz//z9xIRkDQCAVIANBBXQiEmoiDyAQIBJqIh79AAMA/QsDACAPIB79AAMQ/QsDECAVIBJBIHIiD2oiHiAPIBBqIg/9AAMQ/QsDECAeIA/9AAMA/QsDACAVIBJBwAByIg9qIh4gDyAQaiIP/QADEP0LAxAgHiAP/QADAP0LAwAgFSASQeAAciISaiIPIBAgEmoiEv0AAxD9CwMQIA8gEv0AAwD9CwMAIANBBGoiAyAZRw0ACwsgHQRAQQAhEgNAIBUgA0EFdCIPaiIeIA8gEGoiD/0AAwD9CwMAIB4gD/0AAxD9CwMQIANBAWohAyASQQFqIhIgHUcNAAsLIAIQogkhEiAIRQRAIBJBACAC/AsACyATKAI0IgNFDQIgAyATKAJUIg1qIiMgA2oMAQsgEygCNCIDRQRAQQAhFQwDCyAiKALMASEOICIoApQBIRhBACEdQQAhEkEAIRUgAyATKAJUIg1qIiMgA2oLIRdBASADIANBAU0bIR8gEUF8cSEhQQAhASARQQRJIRYgDEH4AGohAiAMQegAaiEIA0ACQCARBEAgDiAYIAEgF2psQQV0aiEQQQAhHkEAIQMgFkUEQANAIBIgA0EFdCIPaiIZIA8gEGoiCv0AAwD9CwMAIBkgCv0AAxD9CwMQIBIgD0EgciIZaiIKIBAgGWoiGf0AAxD9CwMQIAogGf0AAwD9CwMAIBIgD0HAAHIiGWoiCiAQIBlqIhn9AAMQ/QsDECAKIBn9AAMA/QsDACASIA9B4AByIg9qIhkgDyAQaiIP/QADEP0LAxAgGSAP/QADAP0LAwAgA0EEaiIDICFHDQALCyAdBEADQCASIANBBXQiD2oiGSAPIBBqIg/9AAMA/QsDACAZIA/9AAMQ/QsDECADQQFqIQMgHkEBaiIeIB1HDQALCyARIBIgDiAYIAEgDWpsQQV0aiAOIBggASAjamxBBXRqIAkQ/AogDCAcIAFBBXRqIgP9AAMQ/QsDUCAMIAP9AAMA/QsDQEEAIQ8DQCAMQfAAaiIQIBIgD0EFdCIDaiIe/QADEP0LAwAgDCAe/QADAP0LA2AgCSAMQeAAaiAMQUBrEKQJIAMgFWoiAyAJKQM4Ik0gAykDGCJIIAIpAwB8IkogAykDECJBIBApAwB8IkMgQVQgQyADKQMIIkUgCCkDAHwiQSBFVCBBIAMpAwAiQiAMKQNgfCJFIEJUrXwiQiBBVHKtfCJBIENUcq18IkN8IkcgCSkDMCJEIEF8IkkgRFQgSSAJKQMoIkYgQnwiRCBGVCBEIAkpAyAiRiBFfCJLIEZUrXwiRiBEVHKtfCJEIElUcq18IkkgQyBDIEpUIEggSlZyIEcgTVQgRyBJVnJzIhAbNwMYIAMgRCBBIBAbNwMQIAMgRiBCIBAbNwMIIAMgSyBFIBAbNwMAIA9BAWoiDyARRw0ACwwBCyARIBIgDiAYIAEgDWpsQQV0aiAOIBggASAjamxBBXRqIAkQ/AogDCAcIAFBBXRqIgP9AAMQ/QsDUCAMIAP9AAMA/QsDQAsgAUEBaiIBIB9HDQALCyASECsLAkAgEygCICIBRQRAQQAhEAwBCyABQYCAgMAATw0BIAFBBXQiAxCiCSEQIANFDQAgEEEAIAP8CwALAkAgEygCKCIKRQ0AICIoArQBIRIgCkEDcSECQQAhHkEAIQMgCkEETwRAIApBfHEhCANAIBAgA0EFdCIPaiIZIA8gEmoiEf0AAwD9CwMAIBkgEf0AAxD9CwMQIBAgD0EgciIZaiIRIBIgGWoiGf0AAxD9CwMQIBEgGf0AAwD9CwMAIBAgD0HAAHIiGWoiESASIBlqIhn9AAMQ/QsDECARIBn9AAMA/QsDACAQIA9B4AByIg9qIhkgDyASaiIP/QADEP0LAxAgGSAP/QADAP0LAwAgA0EEaiIDIAhHDQALCyACRQ0AA0AgECADQQV0Ig9qIhkgDyASaiIP/QADAP0LAwAgGSAP/QADEP0LAxAgA0EBaiEDIB5BAWoiHiACRw0ACwsCQCATKAIsIhJFDQAgCUHoAGohAyAQIApBBXRqIRkgEkEDcSECQQAhHkEAIQkgEkEETwRAIBlB4ABqIQggGUFAayEKIBlBIGohHSASQXxxISEDQCAZIAlBBXQiEmoiDyAD/QADAP0LAwAgDyADQRBqIg/9AAMA/QsDECASIB1qIhEgD/0AAwD9CwMQIBEgA/0AAwD9CwMAIAogEmoiESAP/QADAP0LAxAgESAD/QADAP0LAwAgCCASaiISIA/9AAMA/QsDECASIAP9AAMA/QsDACAJQQRqIgkgIUcNAAsLIAJFDQADQCAZIAlBBXRqIhIgA/0AAwD9CwMAIBIgA/0AAxD9CwMQIAlBAWohCSAeQQFqIh4gAkcNAAsLAkAgASATKAIcIg9GDQAgECAPQQV0aiEJICIoAsABIRIgASAPayIZQQNxIQJBACEeQQAhAyAPIAFrQXxNBEAgGUF8cSEIA0AgCSADQQV0Ig9qIhkgDyASaiIR/QADAP0LAwAgGSAR/QADEP0LAxAgCSAPQSByIhlqIhEgEiAZaiIZ/QADEP0LAxAgESAZ/QADAP0LAwAgCSAPQcAAciIZaiIRIBIgGWoiGf0AAxD9CwMQIBEgGf0AAwD9CwMAIAkgD0HgAHIiD2oiGSAPIBJqIg/9AAMQ/QsDECAZIA/9AAMA/QsDACADQQRqIgMgCEcNAAsLIAJFDQADQCAJIANBBXQiD2oiGSAPIBJqIg/9AAMA/QsDACAZIA/9AAMQ/QsDECADQQFqIQMgHkEBaiIeIAJHDQALC0EAIQ9BACEeAkAgEygCFCIDRQ0AIANBgICAwABPDQEgA0EFdCIDEKIJIR4gA0UNACAeQQAgA/wLAAsgHiAmIAEgECAgICUoAgAgJSgCBBCdCwJAIBMoAhQiGUUEQEEBIQMMAQsDQEEAIQMgHiAPQQV0IhJqIgkpAwAgEiAVaiISKQMAUg0BIAkpAwggEikDCFINASAJKQMQIBIpAxBSDQEgCSkDGCASKQMYUg0BQQEhAyAPQQFqIg8gGUcNAAsLIB4QKyAQECsgFQRAIBUQKwtBzNIqQeG8KyADGyEQDAELEKAJAAsgIBArIBwQKyApECsgGhArICgQKyAMIBA2AgBB5ABB6ooqIAwQmwkgDCgCKCIJBEAgCRArCyAMKAI0IgkEQCAJECsLIAxBgAFqJABBAEEFIAMbQQUgBhshBgsgCygCCCIWBEAgCyAWNgIMIBYQKwsgBSgCCCILBEAgBSALNgIMIAsQKwsgBEG8zTE2AgAgBCgCeCEFIARBADYCeCAFBEAgBRArCyATKAJYIgQEQCATIAQ2AlwgBBArCyAUKAJYIgRFDQEgFCAENgJcIAQQKwwBC0EBQfC5K0EAEJsJQQMhBgsgLRArICIoAuQBIgQEQCAiIAQ2AugBIAQQKwsgIigC2AEiBARAICIgBDYC3AEgBBArCyAiKALMASIEBEAgIiAENgLQASAEECsLICIoAsABIgQEQCAiIAQ2AsQBIAQQKwsgIigCtAEiBARAICIgBDYCuAEgBBArCyAiKAKoASIEBEAgIiAENgKsASAEECsLICIoApwBIgQEQCAiIAQ2AqABIAQQKwsgIigCBCIEBEAgIiAENgIIIAQQKwsgGygC5AEiBARAIBsgBDYC6AEgBBArCyAbKALYASIEBEAgGyAENgLcASAEECsLIBsoAswBIgQEQCAbIAQ2AtABIAQQKwsgGygCwAEiBARAIBsgBDYCxAEgBBArCyAbKAK0ASIEBEAgGyAENgK4ASAEECsLIBsoAqgBIgQEQCAbIAQ2AqwBIAQQKwsgGygCnAEiBARAIBsgBDYCoAEgBBArCyAbKAIEIgQEQCAbIAQ2AgggBBArCyArKAIgIgsEQCALIgQgKygCJCIbRwRAA0AgG0EEayIFKAIAIQQgBUEANgIAIAQEQCAEKAIEIgUEQCAEIAU2AgggBRArCyAEECsLIAsgG0EMayIbRw0ACyArKAIgIQQLICsgCzYCJCAEECsLICsQKwsgKigCICILBEAgCyIEICooAiQiG0cEQANAIBtBBGsiBSgCACEEIAVBADYCACAEBEAgBCgCBCIFBEAgBCAFNgIIIAUQKwsgBBArCyALIBtBDGsiG0cNAAsgKigCICEECyAqIAs2AiQgBBArCyAqECsLIC4QKwsgB0GQGGokACAGBEAgJyAGQQJ0QbCqL2ooAgA2AhAgAEGfiSogJ0EQahBuIAAoAgxBAToABCAAIAAoAgxBCGo2AgwMAQsgACgCDEEROgAEIAAgACgCDEEIajYCDAsgLxCaASAwEJoBIDEQmgEgMxCaAQJAICxFDQACQEGkiDQoAgAiBkUNACAnICw2AuwBIAYoAgAiBSAnKALsAUsNACAnKALsASAFIAYoAhBqTw0AICwgBigCBDYCACAGICw2AgQgBiAGKAIIQQFqNgIIIAYoAhQiBkEESQ0BIAZBfHEiBkUNASAsQQAgBvwLAAwBCyAsECsLIDIQmgEgJ0H2rik2AgAgAEHghyogJxCbASAnQfABaiQAQQEL/woCB38BfgJAAkAgACgCCCIDRQ0AIAAoAgwiAiADQQFrIgRBA3RqLQAEQQ9xDQAgA0EBRwRAIAIgA0EDdGpBDGstAABBD3EEQCADaUEBSyAALAAGIgFBAE5xDQMgBCADQQJrcUUNAyAAIAQ2AgggACABQYABcjoABiAEDwsgAkEEayEGIAMhAgNAIAIgASACakEBdiIEIAYgBEEDdGotAABBD3EiBRsiAiAEIAEgBRsiAWtBAUsNAAsLIANpIQICQCAALAAGIgRBAE4EQCACQQFNDQEgAQ8LIAJBAkkNACADQQF2IANyIgJBAnYgAnIiAkEEdiACciICQQh2IAJyIgJBEHYgAnJBAWohAwsgA0EBdiABTwRAIAEPCyAAIAE2AgggACAEQYABcjoABiABDwsgAyECAkAgACwABiIHQQBODQAgA2lBAkkNACAAKAIMIgEgA0EDdGotAARBD3FFBEAgAw8LIAEgA0EBdiADciICQQJ2IAJyIgJBBHYgAnIiAkEIdiACciICQRB2IAJyQQFqIgJBA3RqQQRrLQAAQQ9xDQAgAiADa0ECSQRAIAAgAyIBNgIIIAEPCyABQQRrIQUgAyEBA0AgAiABIAJqQQF2IgQgBSAEQQN0ai0AAEEPcSIDGyICIAQgASADGyIBa0EBSw0ACyAAIAE2AgggAQ8LIAAoAhRFBEAgAg8LAkACQAJAIAIgA0kEQCADIQUMAQsgAkEBaiEFIAdBAE4NASACQQAgA2txIANPDQEgACAFNgIICyAAKAIMIAJBA3RqIQEMAQsgACgCECAFrCIIQh6IIAiFQrnLk+fR7ZGsv39+IghCG4ggCIVC66PEmbG3kuiUf34iCEIfiCAIhadBfyAALQAHdEF/c3FBBHRqIQECQANAIAEtAAVBA0YEQCABKAIMIAVGDQILIAEgASgCCCIEQQR0aiEBIAQNAAtB1LEvIQELIAMhBQsgAS0ABEEPcUUEQCACDwtBASACIAJBAU0bIQQCQANAIAQiA0H/////A00EQAJAAkAgBSADQQF0IgRBAWsiAU0EQCAHQQBODQEgAUEAIAVrcSAFTw0BIAAgBDYCCCAEIQULIAAoAgwgAUEDdGohAQwBCyAAKAIQIAStIghCHoggCIRCucuT59Htkay/f34iCEIbiCAIhULro8SZsbeS6JR/fiIIQh+IIAiFp0F/IAAtAAd0QX9zcUEEdGohAQNAIAEtAAVBA0YEQCABKAIMIARGDQILIAEgASgCCCICQQR0aiEBIAINAAtB1LEvIQELIAEtAARBD3ENAQwCCwsCQAJAIAVB/v///wdNBEAgB0EATg0BQQAgBWtB/v///wdxIAVPDQEgAEH/////BzYCCEH/////ByEFCyAAKAIMQRBrIQEMAQsgACgCEEF/IAAtAAd0QX9zQYzb5R5xQQR0aiEBA0AgAS0ABUEDRgRAIAEoAgxB/////wdGDQILIAEgASgCCCICQQR0aiEBIAINAAtB1LEvIQELQf////8HIQQgAS0ABEEPcQ0BCyAEIgYgA2tBAkkEQCADDwsgAyEEA0ACQAJAIAUgBCAGakEBdiIDQQFrIgFNBEAgB0EATg0BIAFBACAFa3EgBU8NASAAIAM2AgggAyEFCyAAKAIMIAFBA3RqIQEMAQsgACgCECADrSIIQh6IIAiFQrnLk+fR7ZGsv39+IghCG4ggCIVC66PEmbG3kuiUf34iCEIfiCAIhadBfyAALQAHdEF/c3FBBHRqIQEDQCABLQAFQQNGBEAgASgCDCADRg0CCyABIAEoAggiAkEEdGohASACDQALQdSxLyEBCyAGIAMgAS0ABEEPcSIBGyIGIAMgBCABGyIEa0EBSw0ACwsgBAv/AQEDfyAAQX8gAhCQARoCQCAAQX9BweIpENwBIgQEQCAEKAIAIgIgAyACIANJGyICRQ0BIAEgBCgCCCAC/AoAAAwBC0EAIQIgACgCDCIEQQRrLQAAQQ9xIgZBBWtBfkkNACAEQQhrIQQCQAJAAkAgBkEDaw4CAAECCyAAIAQQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIMQQhrIQQLIAQoAgAiBC0AByICQf8BRgRAIAQoAgwhAgsgBEEQaiEFCyACIAMgAiADSRsiAkUNACABIAUgAvwKAAALIAAgACgCDEEIayIDIAAoAiRNBH8gACADQX9BABBeBSADCzYCDCACC7YCAQR/IAAoAgwiBEEIayEDIAFBAEoEfyAAKAIUKAIABSAECyABQQN0aiIBIAEgAkEDdCIAa0EIayADIABrIAJBAEgbIgZJBEAgASECIAYhAANAIAIoAgAhBCACIAAoAgA2AgAgAi0ABCEFIAIgAC0ABDoABCAAIAU6AAQgACAENgIAIAJBCGoiAiAAQQhrIgBJDQALCyADIAZBCGoiAksEQCADIQADQCACKAIAIQQgAiAAKAIANgIAIAItAAQhBSACIAAtAAQ6AAQgACAFOgAEIAAgBDYCACACQQhqIgIgAEEIayIASQ0ACwsgASADSQRAA0AgASgCACECIAEgAygCADYCACABLQAEIQAgASADLQAEOgAEIAMgADoABCADIAI2AgAgAUEIaiIBIANBCGsiA0kNAAsLC50FAgR/An0gACgCFCEDAkAgAUEASgRAIAMoAgAgAUEDdGoiASAAKAIMSQ0BIAAoAhBBLGohAQwBCyABQdnhzn1OBEAgACgCDCABQQN0aiEBDAELIAFB2OHOfUYEQCAAKAIQQSRqIQEMAQsgAygCACIELQAEQeYARgRAIAQoAgAiBC0ABkHY4c59IAFrTwRAIARBACABa0EDdGpBuPKJE2shAQwCCyAAKAIQQSxqIQEMAQsgACgCEEEsaiEBCwJAIAJBAEoEQCADKAIAIAJBA3RqIgIgACgCDEkNASAAKAIQQSxqIQIMAQsgAkHZ4c59TgRAIAAoAgwgAkEDdGohAgwBCyACQdjhzn1GBEAgACgCEEEkaiECDAELIAMoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSACa08EQCADQQAgAmtBA3RqQbjyiRNrIQIMAgsgACgCEEEsaiECDAELIAAoAhBBLGohAgsCQCABLQAEIgRBD3EiAw0AIAEgACgCEEEsakcNAEEADwsCQCACLQAEIgVBD3EiBg0AIAIgACgCEEEsakcNAEEADwsCQCADQQNHDQAgBkEDRw0AIARBA0YEQCABKAIAIQAgBUEDRgRAIAAgAigCAEgPCyACKgIAIQcgAEGAgIAIakGAgIAQTQRAIAcgALJeDwsgACAHjiIIQwAAgD+SIAggByAIXBsiCPwASCAHQwAAAABeIgAgCEMAAABPXRsgACAIQwAAAM9gGw8LIAEqAgAhByAFQRNGBEAgByACKgIAXQ8LIAIoAgAiAEGAgIAIakGAgIAQTQRAIAcgALJdDwsgACAHjiII/ABKIAdDAAAAAF0iACAIQwAAAE9dGyAAIAhDAAAAz2AbDwsgACABIAIQ/QULyQYCBX8BfQJAAkACQAJAAkAgAS0ABCIDQT9xIgQgAi0ABCIGQT9xRwRAIANBD3FBA0cNBCAGQQ9xQQNHDQQCQCADQQNrDhECBQUFBQUFBQUFBQUFBQUFAAULIAEqAgAiCCAIjiIIXA0EIAhDAAAAz2BFDQQgCEMAAABPXUUNBCAI/AAhAQwDC0EBIQUCQAJAAkACQAJAAkACQAJAAkACQCAEDhcNDQIABAcLBgsLCwsLCwsLCw0LAQULAwsLIAEoAgAgAigCAEYPCyABKgIAIAIqAgBbDwsgASgCACACKAIARg8LIAEoAgAgAigCAEYPCyABKAIAIAIoAgBGDwsgASgCACIBIAIoAgAiAkYNByABKAIMIgMgAigCDEcEQEEADwsgAUEQaiACQRBqIAMQhAJFDwsgASgCACIDIAIoAgAiBEYNBkEAIQUgAEUNBgJAIAMoAgwiA0UNACADLQAGQSBxDQAgAyAAKAIQKAKsARCQByIDDQMgAigCACEECyAEKAIMIgNFDQYgAy0ABkEgcUUNAQwGCyABKAIAIgMgAigCACIERg0FQQAhBSAARQ0FAkAgAygCGCIDRQ0AIAMtAAZBIHENACADIAAoAhAoAqwBEJAHIgMNAiACKAIAIQQLIAQoAhgiA0UNBSADLQAGQSBxDQULIAMgACgCECgCrAEQkAciAw0AQQAPCyAAKAIMIQYgACIEKAIcIQcgBCgCDCIFIAMoAgA2AgAgBSADLQAEOgAEIAUgASgCADYCCCAFIAEtAAQ6AAwgBSACKAIANgIQIAUgAi0ABDoAFCAEIAQoAgxBGGo2AgwCQCAEKAIULQAiQQpxRQRAIAQgBUEBEJAGDAELIAQgBUEBEJEGCyAEIAQoAgwiBUEIayIDNgIMIAQoAhwgBiAHa2oiBCADKAIANgIAIAQgBUEEay0AADoABCAAKAIMLQAEIgFBAUcgAUEPcUEAR3EhBQwDCyABKAIAIQEMAQsgASgCACACKAIARg8LAkAgBkEDaw4RAgEBAQEBAQEBAQEBAQEBAQABCyACKgIAIgggCI4iCFwNACAIQwAAAM9gRQ0AIAhDAAAAT11FDQAgASAI/ABGDwsgBQ8LIAEgAigCAEYL+QEBA38CQCABLQAEQQ9xQQRHDQAgAi0ABEEPcUEERw0AIAIoAgAhAyABKAIAIgAtAAciBEH/AUYEQCAAKAIMIQQLIAMtAAciAkH/AUYEQCADKAIMIQILIABBEGohACADQRBqIQEDQAJAIAAgARCVByIDBH8gAwUgABAnIQMgAiABECciBUYEQEEADwsgAyAERw0BQX8LQR92DwsgAiAFQQFqIgVrIQIgASAFaiEBIAQgA0EBaiIDayEEIAAgA2ohAAwACwALIAAgASACIAAoAgxBFBCRBwRAIAAoAgwtAAQiAEEBRyAAQQ9xQQBHcQ8LIAAgASACEKcGAAveAgIDfwF9IwBBEGsiBCQAIAAoAhQhAwJAIAFBAEoEQCADKAIAIAFBA3RqIgEgACgCDEkNASAAKAIQQSxqIQEMAQsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAQwBCyABQdjhzn1GBEAgACgCEEEkaiEBDAELIAMoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSABa08EQCADQQAgAWtBA3RqQbjyiRNrIQEMAgsgACgCEEEsaiEBDAELIAAoAhBBLGohAQsCQAJ9IAEtAAQiAEETRgRAIAEqAgAMAQsgAEEDRgRAIAEoAgCyDAELQQAhAyAAQQ9xQQRHDQEgASgCACIBQRBqIARBCGoQwQEhBSAFIAEtAAciAEH/AUYEfyABKAIMBSAAC0EBakcNASAEKAIIIgGyIAG+IAQtAAxBA0YbCyEGQQEhAwsgAgRAIAIgAzYCAAsgBEEQaiQAIAYLsgIBAX8gACgCFCECAkAgAUEASgRAIAIoAgAgAUEDdGoiASAAKAIMSQ0BIAAoAhBBLGohAQwBCyABQdnhzn1OBEAgACgCDCABQQN0aiEBDAELIAFB2OHOfUYEQCAAKAIQQSRqIQEMAQsgAigCACICLQAEQeYARgRAIAIoAgAiAi0ABkHY4c59IAFrTwRAIAJBACABa0EDdGpBuPKJE2shAQwCCyAAKAIQQSxqIQEMAQsgACgCEEEsaiEBCwJAAkACQAJAIAEtAAQiAkE/cUECaw4VAAEBAQEAAQEBAQEBAQEBAQEBAQECAQtBACEAAkAgAkEPcUECaw4GAgMDAwMAAwsgASgCACIBIAEvAQYiAUEDdEEYakEQIAEbag8LIAJBwABxDQBBAA8LIAEoAgAhAAsgAAuSBgEGfwJAAkACQAJAAkAgAkEoTQRAIAAoAhAiBygCNCACcyEEAkAgAkUNACABQQFrIQUgAkEBcQR/IAIgBWotAAAgBEEFdCAEQQJ2amogBHMhBCACQQFrBSACCyEDIAJBAUYNACABQQJrIQYDQCADIAZqLQAAIAMgBWotAAAgBEEFdCAEQQJ2amogBHMiBEEFdCAEQQJ2amogBHMhBCADQQJrIgMNAAsLIAcoAhggBygCICIGQQFrIARxQQJ0aiIIKAIAIgMEQANAAkAgAiADLQAHRw0AIAEgA0EQaiACEIQCDQAgAy0ABSIEIActADhBGHNxRQ0EIAMgBEEYczoABSADDwsgAygCDCIDDQALCyAGIAciBSgCHCIDTARAIANB/////wdGBEAgAEEBEJMGIAUoAhxB/////wdGDQQgBSgCICEGCyAGQf////8BTARAIAAgBkEBdBDJBiAHKAIgIQYLIAcoAhggBkEBayAEcUECdGohCCAAKAIQIQULIAUoAgRBAEEEIAJBEWoiBiAFKAIAEQIAIgNFBEAgAEEAQQQgBhCDBiIDRQ0ECyAFIAUoAgwgBmo2AgwgBS0AOCEGIANBBDoABCADIAZBGHE6AAUgAyAFKAJENgIAIAUgAzYCRCADQQA6AAYgAyAENgIIIANBEGoiBCACakEAOgAAIAMgAjoAByACBEAgBCABIAL8CgAACyADIAgoAgA2AgwgCCADNgIAIAcgBygCHEEBajYCHCADDwsgAkHr////B08NAyAAKAIQIgQoAjQhBiAEKAIEQQBBBCACQRFqIgUgBCgCABECACIDRQRAIABBAEEEIAUQgwYiA0UNBQsgBCAEKAIMIAVqNgIMIAQtADghBSADQRQ6AAQgAyAFQRhxOgAFIAMgBCgCRDYCACAEIAM2AkQgA0EAOgAGIAMgBjYCCCADQRBqIgQgAmpBADoAACADQf8BOgAHIAMgAjYCDCACRQ0AIAQgASAC/AoAAAsgAw8LIABBBBCEBgALIABBBBCEBgALIAAQ0QYACyAAQQQQhAYAC+IIAgd/AXwjAEHwAWsiAyQAIANCADcCICADIAA2AhwgA0EcaiEJIANBKGohBwNAIAFBJRCeASIGBEAgA0EcaiABIAYgAWsQ1wYCQAJAAkACQAJAAkACQAJAAkACQCAGLQABIgFBJWsOTwYHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwIHBwcHBwcHBwcHBwUHBwcHBwcHBwcHBwcHAAEHAwcHBwcHBwcHBwQHBwgHCyACKAIAIQUgAkEEaiECIAMoAiQiAUHHAU4EfyADKAIcIgQoAgwiCCAEIAcgARCABiIBNgIAIAggAS0ABEHAAHI6AAQgBCAEKAIMQQhqNgIMAkAgAygCIEUEQCADQQE2AiAMAQsgBEECEJgGCyADQQA2AiRBAAUgAQsgB2ogBToAACADIAMoAiRBAWo2AiQgBkECaiEBDAoLIAIoAgAhASADQQM6ABggAyABNgIUIAJBBGohAiADQRxqIANBFGoQ2AYgBkECaiEBDAkLIAIoAgAhASADQQM6ABggAyABNgIUIAJBBGohAiADQRxqIANBFGoQ2AYgBkECaiEBDAgLIAJBB2pBeHEiASsDACEKIANBEzoAGCADIAq2OAIUIAFBCGohAiADQRxqIANBFGoQ2AYgBkECaiEBDAcLIAMoAiQiAUG0AU4EQCADKAIcIgQoAgwiBSAEIAcgARCABiIBNgIAIAUgAS0ABEHAAHI6AAQgBCAEKAIMQQhqNgIMAkAgAygCIEUEQCADQQE2AiAMAQsgBEECEJgGCyADQQA2AiRBACEBCyADIAIoAgA2AhAgAyABIAdqQRRBzKcqIANBEGoQpgQgAygCJGo2AiQMBAtBPyEFQQEhBEEHIQggAigCACIBQYABTwRAA0AgAyAEIghrIAFBP3FBgAFyOgAcIARBAWohBCABQQZ2IgEgBUEBdiIFSw0AC0EHIAhrIQggBUF/c0EBdCABciEBCyACQQRqIQIgA0EUaiAIaiABOgAAIANBHGogCSAEayAEENcGIAZBAmohAQwFCyADKAIkIgFBxwFOBH8gAygCHCIEKAIMIgUgBCAHIAEQgAYiATYCACAFIAEtAARBwAByOgAEIAQgBCgCDEEIajYCDAJAIAMoAiBFBEAgA0EBNgIgDAELIARBAhCYBgsgA0EANgIkQQAFIAELIAdqQSU6AAAgAyADKAIkQQFqNgIkIAZBAmohAQwECyADIAHANgIAIABBkoYsIAMQlwYACyADQRxqIAIoAgAiAUHD+isgARsiASABECcQ1wYLIAJBBGohAiAGQQJqIQEMAQsLIANBHGogASABECcQ1wYgAygCHCIBKAIMIgQgASAHIAMoAiQQgAYiBTYCACAEIAUtAARBwAByOgAEIAEgASgCDEEIajYCDAJAIAMoAiBFBEAgA0EBNgIgDAELIAFBAhCYBgsgA0EANgIkIAAoAgxBCGsoAgAhASADQfABaiQAIAFBEGoLkAMBBH8gAkUEQCAAKAIMIgNBFjoABCADIAE2AgAgACAAKAIMQQhqNgIMDwsCQCAAKAIQIgMoAgRBAEEGIAJBA3QiBkEQaiIEIAMoAgARAgAiBUUEQCAAQQBBBiAEEIMGIgVFDQELIAMgAygCDCAEajYCDCADLQA4IQQgBUEmOgAEIAUgBEEYcToABSAFIAMoAkQ2AgAgAyAFNgJEIAUgATYCDCAFIAI6AAYgACAAKAIMIgQgBms2AgwgBUEQaiEBIAIiA0EBcQRAIAEgA0EBayIDQQN0aiIGIARBCGsoAgA2AgAgBiAEQQRrLQAAOgAECyACQQFHBEADQCABIANBA3RBCGsiAmoiBCAAKAIMIAJqIgIoAgA2AgAgBCACLQAEOgAEIAEgA0ECayIDQQN0IgJqIgQgACgCDCACaiICKAIANgIAIAQgAi0ABDoABCADDQALCyAAKAIMIgNB5gA6AAQgAyAFNgIAIAAgACgCDEEIajYCDCAAKAIQKAIMQQBKBEAgABBUCw8LIABBBBCEBgALOwECfwJAIAAoAhAiBC0AMEEPcQ0AIAQtADsNACAAQQEQkwYgBCgCBCABIAIgAyAEKAIAEQIAIQULIAUL3gMBBX8jAEEQayICJAACQCAAKAIwIgNFBEAgACAAQTRqNgIUIAAoAhAhAyAAKAIcQQA6AAQgAEECOwFWIABBADoABiAAIAAoAhwiBTYCNCABQQAgAUEBRxshASAALQAHIQQgACgCFCEGA0AgAiABNgIMIAIgBUEBajYCCCAAQRMgAkEIahB9IgEEQCAAIAQ6AAcgACAGNgIUIAAoAhwhBQwBCwtBCCEFIAAoAhwiAUEIaiEEAn8CQCABAn8CQAJAAkAgAigCDCIGDgYEAgICAAECCyAEIAAoAhAoApQBIgI2AgAgAi0ABEHAAHIMAgsgBCAAQcXuKkEXEIAGIgI2AgAgAi0ABEHAAHIMAQsgBCAAKAIMIgJBCGsoAgA2AgAgAkEEay0AAAs6AAxBECEFIAAgAUEQajYCDCAAKAIcDAELIAAgBDYCDCABCyECIAAgASAFakGgAWoiATYCOCAAIAEgAmtBA3VBABCrBhogAygCkAEiAigCMA0BIAMoAowBIgIEQCAAIAIRAAAaCxCsBgALIAMgATYCoAEgA0EEakEBEEYACyACIAIoAgwiAUEIajYCDCABIAAoAgwiAEEIaygCADYCACABIABBBGstAAA6AAQgAygCkAEgBhCEBgALlwIBBX8gACABEI4HIQAgAkUgAS0ABCIDQcAAcUVyIQUgA0HUAEYhBgJAA0ACQAJAAkAgAC0ABSICIANHBEAgAkELRyAFckUNAQwDCwJAAkACQAJAAkAgAw4XCQkCAAUFBQUFBQUFBQUFBQUJBQEFBQMECyABKAIAIAAoAgxHDQYMCAsgASoCACAAKgIMXA0FDAcLIAEoAgAgACgCDEcNBAwGCyABKAIAIAAoAgxHDQMMBQsgBg0BCyABKAIAIAAoAgxHDQEMAwsgASgCACICIAAoAgwiBEYNAiACKAIMIgcgBCgCDEcNACACQRBqIARBEGogBxCEAkUNAgsgACAAKAIIIgJBBHRqIQAgAg0AC0HUsS8hAAsgAAv9BAEFfwNAAkAgBEUEQCAAKAIQIQYCQAJ/AkACQAJAIAEtAARBD3EiBUEFaw4DAAIBAgsgASgCAEEYagwCCyABKAIAQQxqDAELIAAoAhAgBUECdGpB/AFqCygCACIFBEAgBSgCECAGKAKYASIEKAIIQX8gBS0AB3RBf3NxQQR0aiEFA0AgBS0ABUHEAEYEQCAFKAIMIARGDQMLIAUgBSgCCCIGQQR0aiEFIAYNAAtB1LEvIQUMAQsgBkEsaiEFCyAFLQAEIgZBD3ENASAAIAFBu7wpEJ4GAAsCQCABKAIAKAIYIgdFDQAgBy0ABiIJQQFxDQAgBygCECAAKAIQKAKYASIEKAIIQX8gBy0AB3RBf3NxQQR0aiEFAkADQCAFLQAFQcQARgRAIAUoAgwgBEYNAgsgBSAFKAIIIgZBBHRqIQUgBg0AC0HUsS8hBQsgBS0ABCIGQQ9xDQEgByAJQQFyOgAGCyADQQA6AAQPCyAGQQ9xQQZGBEAgACgCHCEEIAAoAgwiBiAFKAIANgIAIAYgBS0ABDoABCAGIAEoAgA2AgggBiABLQAEOgAMIAYgAigCADYCECAGIAItAAQ6ABQgACAAKAIMQRhqNgIMAkAgACgCFC0AIkEKcUUEQCAAIAZBARCQBgwBCyAAIAZBARCRBgsgACAAKAIMIgVBCGsiBjYCDCAAKAIcIAMgBGtqIgQgBigCADYCACAEIAVBBGstAAA6AAQPC0EAIQQCQCAGQcUARw0AIAUoAgAgAhCgASIELQAEQQ9xRQ0AIAMgBCgCADYCACADIAQtAAQ6AAQPCyAFIQEgCEEBaiIIQdAPRw0ACyAAQaylKkEAEJcGAAvwAgIGfwF+IwBBEGsiBCQAIAAoAhQoAgBBCGoiBSAAKAIMIgNPBEAgACgCEEEsaiEFCwJAAkAgBS0ABEHFAEcNAAJAAkAgAUEBayIGIAUoAgAiAigCCCIHTwRAIAIsAAZBAE4NASAGQQAgB2txIAdPDQEgAiABNgIIIAAoAgwhAwsgAigCDCAGQQN0aiECDAELIAIoAhAgAawiCEIeiCAIhUK5y5Pn0e2RrL9/fiIIQhuIIAiFQuujxJmxt5LolH9+IghCH4ggCIWnQX8gAi0AB3RBf3NxQQR0aiECA0AgAi0ABUEDRgRAIAIoAgwgAUYNAgsgAiACKAIIIgZBBHRqIQIgBg0AC0HUsS8hAgsgAi0ABEEPcUUNACADIAIoAgA2AgAgAyACLQAEOgAEDAELIARBAzoADCAEIAE2AgggACAFIARBCGogAyACEIYGCyAAIAAoAgwiAkEIajYCDCACLQAEIQIgBEEQaiQAIAJBD3ELlA0CCn8BfiMAQTBrIgckACABKAIIIQgCQCABLAAGIgRBAE4NACAIaUECSQ0AIAhBAXYgCHIiBUECdiAFciIFQQR2IAVyIgVBCHYgBXIiBUEQdiAFckEBaiEICyABIAg2AgggASAEQf8AcToABgJAAkACQCAHAn8gA0UEQCAHQQA6AA9BxLEvIQYgB0HEsS82AhhBAAwBC0EAIQQCQCADQQFrIgNBgAJJBEAgAyEGDAELA0AgBEEIaiEEIANB//8DSyEFIANBCHYiBiEDIAUNAAsLIAQgBkHwqi9qLQAAaiILQR5KDQEgC0EcTw0BQQAhAyAAKAIQIgQoAgRBAEEAQRAgC3QiBSAEKAIAEQIAIgZFBEAgAEEAQQAgBRCDBiIGRQ0DC0EBIAt0IQkgBCAEKAIMIAVqNgIMIAcgBjYCGAJAIAtBAkkEQCAJQQNxIQUDQCAGIANBBHRqIgRBADYCCCAEQRA7AQQgA0EBaiIDIAVHDQALDAELQQAhBCAJQQRrIgxBBE8EQCAMQQJ2QQFqQf7///8HcSEKQQAhBQNAIAYgBEEEdGoiA0EANgIIIANBADYCGCADQRA7AQQgA0EANgIoIANBEDsBFCADQQA2AjggA0EQOwEkIANBADYCSCADQRA7ATQgA0EANgJYIANBEDsBRCADQQA2AmggA0EQOwFUIANBEDsBZCADQQA2AnggA0EQOwF0IARBCGohBCAFQQJqIgUgCkcNAAsLIAxBBHENACAGIARBBHRqIgNBADYCCCADQQA2AhggA0EQOwEEIANBADYCKCADQRA7ARQgA0EANgI4IANBEDsBJCADQRA7ATQLIAcgCzoADyAGIAlBBHRqCyIDNgIcIAIgCEkEQCABIAI2AgggAS0AByEJIAEgCzoAByABKAIQIQwgASAGNgIQIAEoAhQhDSABIAM2AhQgAiEFA0AgBSIDQQFqIQUCQCABKAIMIANBA3RqIgYtAAQiBEEPcUUNAAJAIAEoAggiCiADSwRAIAYhAwwBCwJAIAEsAAZBAE4NACADQQAgCmtxIApPDQAgASAFNgIIIAYhAwwBCyABKAIQIAWsIg5CHoggDoVCucuT59Htkay/f34iDkIbiCAOhULro8SZsbeS6JR/fiIOQh+IIA6Fp0F/IAEtAAd0QX9zcUEEdGohAwJAA0AgAy0ABUEDRgRAIAMoAgwgBUYNAgsgAyADKAIIIgRBBHRqIQMgBA0AC0HUsS8hAwsgAy0ABCEECyAEQf8BcUEgRgRAIAdBAzoALCAHIAU2AiggACABIAdBKGogBhCNBgwBCyADIAYoAgA2AgAgAyAGLQAEOgAECyAFIAhHDQALIAEgCDYCCCABLQAHIQsgASAJOgAHIAEoAhAhBiABIAw2AhAgASgCFCEDIAEgDTYCFCAHIAM2AhwgByAGNgIYIAcgCzoADwsgACgCECIEKAIEIAEoAgwiDCAIQQN0IgkgAkEDdCIKIAQoAgARAgAhBQJAAkAgCkUNACAFDQAgACAMIAkgChCDBiIFDQBBACEFDAELIAQgBCgCDCAKIAlrajYCDAtBACACIAUbDQIgASAFNgIMIAEgAjYCCCABKAIUIQwgASADNgIUIAEoAhAhCiABIAY2AhAgAS0AByEJIAEgCzoABwJAIAIgCE0NACACIAgiBGtBB3EiBgRAQQAhAwNAIAUgBEEDdGpBEDoABCAEQQFqIQQgA0EBaiIDIAZHDQALCyAIIAJrQXhLDQADQCAFIARBA3RqIgNBEDoABCADQRA6AAwgA0EQOgAUIANBEDoAHCADQRA6ACQgA0EQOgAsIANBEDoANCADQRA6ADwgBEEIaiIEIAJHDQALCyAJQR9HBEBBAUEBIAl0IgMgA0EBTBshBkEAIQQDQAJAIAogBEEEdGoiAy0ABEEPcUUNACAHIAMoAgw2AiggByADLQAFOgAsIAEgB0EoahCgASIFLQAEQSBGBEAgACABIAdBKGogAxCNBgwBCyAFIAMoAgA2AgAgBSADLQAEOgAECyAEQQFqIgQgBkcNAAsLIAwEQCAAKAIQIgMoAgQgCkEQIAl0IgRBACADKAIAEQIAGiADIAMoAgwgBGs2AgwLIAdBMGokAA8LIABB274pQQAQlwYACyAAQQQQhAYACyAHQQhqIgIoAhQEQCAAKAIQIgEoAgQgAigCEEEQIAItAAd0IgJBACABKAIAEQIAGiABIAEoAgwgAms2AgwLIABBBBCEBgALrAEBAn9BxgEhAiABLQAFIgNBB3FBBkcEQCAAKAIQIQJBHCEAAkACQAJAAkACQAJAIAEtAARBBmsOIQQCAAMBAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDBAULQSghAAwEC0HQACEADAMLQRAhAAwCCwALQQghAAsgACABaiACKAJUNgIAIAIgATYCVEHHASECCyABIANBwAFxQQVyIAIgA3EgA0EGcRs6AAUL8QUBB38CQAJAAkADQAJAIAQEQAJAIAEoAgAiBygCGCIIRQ0AIAgtAAYiC0ECcQ0AIAgoAhAgACgCECgCnAEiCSgCCEF/IAgtAAd0QX9zcUEEdGohBQJAA0AgBS0ABUHEAEYEQCAFKAIMIAlGDQILIAUgBSgCCCIGQQR0aiEFIAYNAAtB1LEvIQULIAUtAAQiBkEPcQ0CIAggC0ECcjoABgsCQCAELQAEQSBGBEAgACAHIAIgAxCNBiADLQAEIQUMAQsgBCADKAIANgIAIAQgAy0ABCIFOgAECyAHIActAAZBwAFxOgAGIAVBwABxRQ0EIActAAVBIHFFDQQgAygCAC0ABUEYcUUNBCAAIAcQiQYPCyAAKAIQIQYCQAJ/AkACQAJAIAEtAARBD3EiBUEFaw4DAAIBAgsgASgCAEEYagwCCyABKAIAQQxqDAELIAAoAhAgBUECdGpB/AFqCygCACIFBEAgBSgCECAGKAKcASIJKAIIQX8gBS0AB3RBf3NxQQR0aiEFA0AgBS0ABUHEAEYEQCAFKAIMIAlGDQMLIAUgBSgCCCIGQQR0aiEFIAYNAAtB1LEvIQUMAQsgBkEsaiEFCyAFLQAEIgZBD3FFDQQLIAZBD3FBBkYEQCAAKAIMIgYgBSgCADYCACAGIAUtAAQ6AAQgBiABKAIANgIIIAYgAS0ABDoADCAGIAIoAgA2AhAgBiACLQAEOgAUIAYgAygCADYCGCAGIAMtAAQ6ABwgACAGQSBqNgIMIAAoAhQtACJBCnENAiAAIAZBABCQBg8LQQAhBAJAIAZBxQBHDQAgBSgCACACEKABIgQtAARBD3FFDQAgBCADKAIANgIAIAQgAy0ABCIGOgAEIAZBwABxRQ0DIAUoAgAiBS0ABUEgcUUNAyADKAIALQAFQRhxRQ0DIAAgBRCJBg8LIAUhASAKQQFqIgpB0A9HDQALIABBgaUqQQAQlwYACyAAIAZBABCRBgsPCyAAIAFBu7wpEJ4GAAuuAwIFfwF+IwBBEGsiBiQAIAAoAhQoAgAgAUEDdGoiAyAAKAIMIgVPBEAgACgCEEEsaiEDC0EAIQECQAJAIAMtAARBxQBHDQACQAJAIAJBAWsiBCADKAIAIgEoAggiB08EQCABLAAGQQBODQEgBEEAIAdrcSAHTw0BIAEgAjYCCCAAKAIMIQULIAEoAgwgBEEDdGohAQwBCyABKAIQIAKsIghCHoggCIVCucuT59Htkay/f34iCEIbiCAIhULro8SZsbeS6JR/fiIIQh+IIAiFp0F/IAEtAAd0QX9zcUEEdGohAQNAIAEtAAVBA0YEQCABKAIMIAJGDQILIAEgASgCCCIEQQR0aiEBIAQNAAtB1LEvIQELIAEtAARBD3FFDQAgASAFQQhrKAIANgIAIAEgBUEEay0AADoABCAAKAIMIgFBBGstAABBwABxRQ0BIAMoAgAiBC0ABUEgcUUNASABQQhrKAIALQAFQRhxRQ0BIAAgBBCJBgwBCyAGQQM6AAwgBiACNgIIIAAgAyAGQQhqIAVBCGsgARCKBgsgACAAKAIMQQhrNgIMIAZBEGokAAvhAQEEfyAAKAIMIgJBEGshAwJAIAFBAEoEQCAAKAIUKAIAQQhqIgEgAkkNASAAKAIQQSxqIQEMAQsgAiABQQN0aiEBCyACQQhrIQQCQCABKAIAIgEgAxCgASIFLQAEQSBGBEAgACABIAMgBBCNBgwBCyAFIAQoAgA2AgAgBSACQQRrLQAAOgAECyABIAEtAAZBwAFxOgAGAkAgACgCDCICQQRrLQAAQcAAcUUNACABLQAFQSBxRQ0AIAJBCGsoAgAtAAVBGHFFDQAgACABEIkGIAAoAgwhAgsgACACQRBrNgIMC4YMAhF/An0jAEGQAWsiCCQAAkACQAJAIAItAAQiBEEPcQRAAkAgBEETRw0AAkAgAioCACIVIBWOIhZcDQAgFkMAAADPYEUNACAWQwAAAE9dRQ0AIAhBAzoADCAIIBb8ADYCCCAIQQhqIQIMAQsgFSAVXA0CCyADLQAEQQ9xRQ0DIAEgAhCOByEGIAEoAhQhBQJAIAYtAARBD3FFBEAgBQ0BDAQLIAVFDQMgASgCECEHA0AgBSIEIAdNDQQgASAEQRBrIgU2AhQgBEELay0AAA0ACyAIIAYoAgw2AhAgCCAGLQAFOgAUIAYgASAIQRBqEI4HIgpHBEADQCAKIgcgBygCCEEEdGoiCiAGRw0ACyAHIAUgB2tBBHU2AgggBSAG/QACAP0LAgAgBigCCARAIARBCGsiBCAEKAIAIAYgBWtBBHVqNgIAIAZBADYCCAsgBkEQOgAEDAELIAYoAggiBwRAIARBCGsgBiAHQQR0aiAFa0EEdTYCAAsgBiAFIAZrQQR1NgIIIAUhBgsgBiACKAIANgIMIAYgAi0ABCIEOgAFAkAgBEHAAHFFDQAgAS0ABUEgcUUNACACKAIALQAFQRhxRQ0AIAAgARCJBgsgBiADKAIANgIAIAYgAy0ABDoABAwDCyAAQfHKKkEAEJcGAAsgAEHu3itBABCXBgALIAhBEGpBAEGAAfwLACABKAIIIQ0CQCABLAAGIgRBAE4NACANaUECSQ0AIA1BAXYgDXIiBUECdiAFciIFQQR2IAVyIgVBCHYgBXIiBUEQdiAFckEBaiENCyABIA02AgggASAEQf8AcToABkEBIQRBASEQA0ACQCAQIgYgDUsEQCANIgYgBEkNAQtBACEFIAQgBk0EQCABKAIMIgVBBGshCiAGQQFqIhMgBGsiC0EDcSEJQQAhBwJAIAYgBGtBA0kEQEEAIQUMAQsgBUEUaiEMIAVBDGohESAFQQRqIRIgC0F8cSEUQQAhBUEAIQsDQCAFIAogBEEDdCIGai0AAEEPcUEAR2ogBiASai0AAEEPcUEAR2ogBiARai0AAEEPcUEAR2ogBiAMai0AAEEPcUEAR2ohBSAEQQRqIQQgC0EEaiILIBRHDQALCyAJBEADQCAFIAogBEEDdGotAABBD3FBAEdqIQUgBEEBaiEEIAdBAWoiByAJRw0ACwsgEyEECyAIQRBqIA9BAnRqIgYgBigCACAFajYCACAQQQF0IRAgBSAOaiEOIA9BAWoiD0EgRw0BCwtBfyABLQAHdEF/cyEEIAEoAhAhC0EAIQpBACEJA0AgCyAEIgdBBHRqIgQtAARBD3EEQCAELQAFQQNGBEBBACEGIAQoAgwiBEGAgICAAmtBgYCAgH5PBH9BACEFIARBAWsiBEGAAk8EQANAIAVBCGohBSAEQf//A0shBiAEQQh2IQQgBg0ACwsgCEEQaiAFQQJ0aiAEQfCqL2otAABBAnRqIgQgBCgCAEEBajYCAEEBBSAGCyAJaiEJCyAKQQFqIQoLIAdBAWshBCAHDQALIAkgDmohCSACLQAEQQNGBEBBACEEIAIoAgAiBkGAgICAAmtBgYCAgH5PBH9BACEFAkAgBkEBayIEQYACSQRAIAQhBwwBCwNAIAVBCGohBSAEQf//A0shBiAEQQh2IgchBCAGDQALCyAIQRBqIAVBAnRqIAdB8Kovai0AAEECdGoiBSAFKAIAQQFqNgIAQQEFIAQLIAlqIQkLIAhBEGpBBHIhEkEAIQVBACEGQQAhB0EBIQRBACELA0ACQCAJIARBAXYiDE0NACALQQJ0IhEgCEEQamooAgAgB2oiByAGIAcgDEsiDBshBiAEIAUgDBshBSAJIARB/f///wdxIgxNDQAgBEEBdCAFIBEgEmooAgAgB2oiByAMSyIMGyEFIAcgBiAMGyEGIARBAnQhBCALQQJqIgtBIEcNAQsLIAAgASAFIAogDmogBmtBAWoQiAYgASACEKABIgQtAARBIEYEQCAAIAEgAiADEI0GDAELIAQgAygCADYCACAEIAMtAAQ6AAQLIAhBkAFqJAALmAIBAn9B0AAhAwJAAkACQAJAAkADQAJAIAEtAAQiAkEJRwRAAkAgAkEEaw4jAAQFAgYIBwgICAgICAgICAAICAgICAgICAgICAgICAgICAUICyABIAEtAAVBxwFxQSByOgAFDwsgASABLQAFQUdxIgJBIHIgAiABKAIIIgIgAUEMakYbOgAFIAItAARBwABxRQ0GIAIoAgAiAS0ABUEYcQ0BDAYLC0EQIQMgAS8BBg0DAkAgASgCDCICRQ0AIAItAAVBGHFFDQAgACACEI4GCyABIAEtAAVBxwFxQSByOgAFDwtBHCEDDAILQQghAwwBC0EoIQMLIAEgA2ogACgCUDYCACAAIAE2AlAgASABLQAFQccBcToABQsL2AMBBn8CQCABLQAFIghBwABxDQAgAi0ABiIGQQRxDQAgAigCECAAKAIQIgMoAqABIgcoAghBfyACLQAHdEF/c3FBBHRqIQQCQANAIAQtAAVBxABGBEAgBCgCDCAHRg0CCyAEIAQoAggiBUEEdGohBCAFDQALQdSxLyEECyAELQAEQQ9xRQRAIAIgBkEEcjoABg8LIAMtAD5BBHENAAJAIAMtADlBA2tB/wFxQQNNBEAgASADLQA4QRhxIAhBhwFxcjoABSADKAJIIgQgAUcNASAEIQUDQCAFKAIAIgIEfwJAIAItAAUiBiAAKAIQLQA4IgdBGHNxBEAgBSACKAIANgIAIAAgAhDDBgwBCyACIAZBwAFxIAdBGHFyOgAFIAIhBQsgBUEAIAUoAgAbBUEACyIFIARGDQALIAMgBTYCSAwBCyADKAJsIAFGBEAgAyABKAIANgJsCyADKAJwIAFGBEAgAyABKAIANgJwCyADKAJ0IAFGBEAgAyABKAIANgJ0CyABIAMoAnhHDQAgAyABKAIANgJ4CyADQcQAaiEEA0AgBCIFKAIAIgQgAUcNAAsgBSABKAIANgIAIAEgAygCTDYCACADIAE2AkwgASABLQAFQcAAcjoABQsLewEBfyAAIAAoAmBBAWoiAzYCYCADQfj/A3FByAFPBEAgACgCGCAAKAIMa0EHTARAIAAoAhwhAyAAQQAQrQYgACgCHCABIANraiEBCyAAELMGCyAAIAEgAhCyBiIBBEAgAUEEOwEiIAAgARC0BgsgACAAKAJgQQFrNgJgC38BAX8gACAAKAJgQYGABGoiAzYCYCADQfj/A3FByAFPBEAgACgCGCAAKAIMa0EHTARAIAAoAhwhAyAAQQAQrQYgACgCHCABIANraiEBCyAAELMGCyAAIAEgAhCyBiIBBEAgAUEEOwEiIAAgARC0BgsgACAAKAJgQYGABGs2AmALwCoCDH8BfiMAQdABayIDJABBfyEGIAEoAgAiAiACKAIAIgRBAWs2AgACQCAEBEAgAiACKAIEIgRBAWo2AgQgBC0AACEGDAELIAIoAhAgAigCDCADQYQBaiACKAIIEQQAIgRFDQAgAygChAEiBUUNACACIARBAWo2AgQgAiAFQQFrNgIAIAQtAAAhBgsgASgCNCECAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAGQRtGBEAgAgRAIAJB4gAQngFFDRcLIAEoAgAhAgJ/AkACQAJAIAEoAjgiBC0AACIFQT1rDgQAAgIAAQsgBEEBagwCC0Gx6yogBUEbRg0BGgsgBAshASADIAA2AkwgAyABNgJUIAMgAjYCUCACKAIAIQQgA0GEAWohBkEDIQUDQAJAIAQEQCACKAIEIQcMAQsgAigCECACKAIMIANBwAFqIAIoAggRBAAiB0UNFyADKALAASIERQ0XIAIgBzYCBCACIAQ2AgALIAUgBCAEIAVLGyIBBEAgBiAHIAH8CgAACyACIAIoAgAgAWsiBDYCACACIAIoAgQgAWo2AgQgASAGaiEGIAUgAWsiBQ0AC0HE1isgA0GEAWpBAxCEAg0UIAIgAigCACIBQQFrNgIAAn8gAQRAIAIgAigCBCIEQQFqIgE2AgQgBC0AAAwBCyACKAIQIAIoAgwgA0GEAWogAigCCBEEACIERQ0UIAMoAoQBIgVFDRQgAiAEQQFqIgE2AgQgAiAFQQFrNgIAIAQtAAALQf8BcUHUAEcNEiACIAIoAgAiBEEBazYCAAJ/IAQEQCACIAFBAWoiBzYCBCABLQAADAELIAIoAhAgAigCDCADQYQBaiACKAIIEQQAIgFFDRIgAygChAEiBEUNEiACIAFBAWoiBzYCBCACIARBAWs2AgAgAS0AAAtB/wFxDRAgAigCACEEIANBhAFqIQZBBiEFA0AgBEUEQCACKAIQIAIoAgwgA0HAAWogAigCCBEEACIHRQ0RIAMoAsABIgRFDREgAiAHNgIEIAIgBDYCAAsgBSAEIAQgBUsbIgEEQCAGIAcgAfwKAAALIAIgAigCACABayIENgIAIAIgAigCBCABaiIHNgIEIAEgBmohBiAFIAFrIgUNAAtBr5MsIANBhAFqQQYQhAINDiACIAIoAgAiAUEBazYCAAJ/IAEEQCACIAIoAgQiBEEBaiIBNgIEIAQtAAAMAQsgAigCECACKAIMIANBhAFqIAIoAggRBAAiBEUNDiADKAKEASIFRQ0OIAIgBEEBaiIBNgIEIAIgBUEBazYCACAELQAAC0H/AXFBBEcNDCACIAIoAgAiBEEBazYCAAJ/IAQEQCACIAFBAWoiBTYCBCABLQAADAELIAIoAhAgAigCDCADQYQBaiACKAIIEQQAIgFFDQwgAygChAEiBEUNDCACIAFBAWoiBTYCBCACIARBAWs2AgAgAS0AAAtB/wFxQQRHDQogAiACKAIAIgFBAWs2AgACfyABBEAgAiAFQQFqIgQ2AgQgBS0AAAwBCyACKAIQIAIoAgwgA0GEAWogAigCCBEEACIBRQ0KIAMoAoQBIgVFDQogAiABQQFqIgQ2AgQgAiAFQQFrNgIAIAEtAAALIQFBBCEGIAFB/wFxQQRHDQggAigCACEBIANBwAFqIQcDQCABRQRAIAIoAhAgAigCDCADQYQBaiACKAIIEQQAIgRFDQkgAygChAEiAUUNCSACIAQ2AgQgAiABNgIACyAGIAEgASAGSxsiBQRAIAcgBCAF/AoAAAsgAiAEIAVqIgQ2AgQgAiABIAVrIgE2AgAgBSAHaiEHIAYgBWsiBg0ACyADKALAAUH4rAFHDQYgA0HAAWohB0EEIQYDQCABRQRAIAIoAhAgAigCDCADQYQBaiACKAIIEQQAIgRFDQcgAygChAEiAUUNByACIAQ2AgQgAiABNgIACyAGIAEgASAGSxsiBQRAIAcgBCAF/AoAAAsgAiAEIAVqIgQ2AgQgAiABIAVrIgE2AgAgBSAHaiEHIAYgBWsiBg0ACyADKgLAAUMAQLlDXA0EIAIgAUEBazYCAAJ/IAEEQCACIARBAWo2AgQgBC0AAAwBCyACKAIQIAIoAgwgA0GEAWogAigCCBEEACIBRQ0EIAMoAoQBIgRFDQQgAiABQQFqNgIEIAIgBEEBazYCACABLQAACyEBIAAoAhAiAigCBEEAQQYgAUECdEH8B3EiBkEQaiIEIAIoAgARAgAiBUUEQCAAQQBBBiAEEIMGIgVFDQMLIAIgAigCDCAEajYCDCACLQA4IQQgBUEGOgAEIAUgBEEYcToABSAFIAIoAkQ2AgAgAiAFNgJEIAUgAToABiAFQQA2AgwCQCABQf8BcUUNACAGRQ0AIAVBEGpBACAG/AsACyAAKAIMIgJBxgA6AAQgAiAFNgIAIAAgACgCGCAAKAIMIgJrQQhMBH8gAEEBEK0GIAAoAgwFIAILQQhqNgIMIAAoAhAiASgCBEEAQQpB1AAgASgCABECACICRQRAIABBAEEKQdQAEIMGIgJFDQILIAEgASgCDEHUAGo2AgwgAS0AOCEEIAJBCjoABCACIARBGHEiBDoABSACIAEoAkQ2AgAgASACNgJEIAJBADoACCACQQA7AQYgAkEMakEAQcQA/AsAIAUgAjYCDAJAIAUtAAUiAUEgcUUNACAERQ0AAkAgACgCECIELQA5QQJNBEAgBCACEI4GIAUtAAVBBnFFDQEgAiACLQAFQfgBcUECcjoABQwBCyAELQA6DQAgBSAELQA4QRhxIAFBxwFxcjoABQsgBSgCDCECCyADQcwAaiACQQAQtwYMFwsCQCACBEAgAkH0ABCeAUUNAQsgASgCOCEHIAEoAgAhCAJAIAAoAhAiAigCBEEAQQZBFCACKAIAEQIAIgVFBEAgAEEAQQZBFBCDBiIFRQ0BCyACIAIoAgxBFGo2AgwgAi0AOCEEIAVBBjoABCAFIARBGHE6AAUgBSACKAJENgIAIAIgBTYCRCAFQQE6AAYgBUIANwIMIAAoAgwiAkHGADoABCACIAU2AgAgACAAKAIYIAAoAgwiAmtBCEwEfyAAQQEQrQYgACgCDAUgAgtBCGo2AgwCQCAAKAIQIgQoAgRBAEEFQSAgBCgCABECACICRQRAIABBAEEFQSAQgwYiAkUNAQsgBCAEKAIMQSBqNgIMIAQtADghCSACQQU6AAQgAiAJQRhxOgAFIAIgBCgCRDYCACAEIAI2AkQgAkIANwIUIAJBxLEvNgIQIAJCADcCCCACQT87AQYgAyACNgKwASAAKAIMIgRBxQA6AAQgBCACNgIAIAAgACgCGCAAKAIMIgJrQQhMBH8gAEEBEK0GIAAoAgwFIAILQQhqNgIMAkAgACgCECIEKAIEQQBBCkHUACAEKAIAEQIAIgJFBEAgAEEAQQpB1AAQgwYiAkUNAQsgBCAEKAIMQdQAajYCDCAELQA4IQkgAkEKOgAEIAIgCUEYcSIJOgAFIAIgBCgCRDYCACAEIAI2AkQgAkEAOgAIIAJBADsBBiACQQxqQQBBxAD8CwAgBSACNgIMIAMgAjYCTAJAIAUtAAUiBEEgcUUNACAJRQ0AIAAoAhAiCS0AOUECTQRAIAkgAhCOBiAFLQAFQQZxRQ0BIAIgAi0ABUH4AXFBAnI6AAUMAQsgCS0AOg0AIAUgCS0AOEEYcSAEQccBcXI6AAULAkAgByAAKAIQIAdBNXBBA3RqIgQoAqACIglBEGoQrQFFBEAgCSEEDAELIAcgBEGgAmoiCigCBCIEQRBqEK0BRQ0AIAogCTYCBCAKIAAgByAHECcQgAYiBDYCAAsgAUEQaiEHIAFBBGohCSACIAQ2AkwCQCACLQAFIgpBIHFFDQAgBC0ABUEYcUUNAAJAIAAoAhAiCy0AOUECTQRAIAsgBBCOBiACLQAFQQZxRQ0BIAQgBC0ABUH4AXFBAnI6AAUMAQsgCy0AOg0AIAIgCy0AOEEYcSAKQccBcXI6AAULIAIoAkwhBAsgAyAHNgK0ASADIAk2AqwBQQAhByABQQA2AiAgAUEANgIsIAFBADYCFCADIAA2AqQBIANBADYCkAEgAyAINgKoASADQaACNgKYASADIAY2AoQBIANBADYCoAEgAyAENgK4ASADQoGAgIAQNwKIASADIABBoNsrQQQQgAY2ArwBAkAgAygCpAEiCCgCECIBKAIEIAMoAqwBIgQoAgAiCSAEKAIIIgRBICABKAIAEQIAIgZFBEAgCCAJIARBIBCDBiIGRQ0BCyABIAEoAgwgBGtBIGo2AgwgAygCrAEiAUEgNgIIIAEgBjYCACADQQA2AlwgAyADKAKgATYCUCADIANBhAFqNgJUIAMgA0HMAGo2AqABIAIoAighASADQQA2AH8gA0EANgJwIANBADYCYCADIAE2AmQgA0EANgJ8IANCADcCaCADIAMoArQBIgEoAgQ2AnQgAyABKAIcIgQ2AnggA0EANgJYIAIgAygCuAEiCDYCTCADQYQBaiEGAn9BACACLQAFIglBIHFFDQAaIAgtAAVBGHFFBEBBAAwBCwJAIAMoAqQBKAIQIgEtADlBAk0EQCABIAgQjgYgAi0ABUEGcUUNASAIIAgtAAVB+AFxQQJyOgAFDAELIAEtADoNACACIAEtADhBGHEgCUHHAXFyOgAFCyADKAJUIgYoAjAiASgCHCEEIAMoAlghByADLQB+CyEIIAJBAjoACCADIAg6AMwBQQAhAiADQQA6AM4BIAMgBDYCxAEgASgCECEBIANBADoAzQEgAyABNgLIASAHBEAgBy0AD0EARyECCyADIAc2AsABIAMgAjoAzwEgAyADQcABajYCWCADKAJMIgJBAToAByACIAYoAiAgAigCNCADKAJcIAJBFGpBBEH/////A0HtgioQuAYiATYCNCADIAMoAlwiBEEBajYCXCABIARBAnRqQdEANgIAIAMoAlxBAWshAQJAIAMoAlQiBigCCCIHIAMoAmRrIgQgBEEfdSIIcyAIa0H/AE0EQCADIAMsAIEBIghBAWo6AIEBIAhBAE4NAQsgAiAGKAIgIAIoAkQgAygCcCACQSRqQQhB/////wFBhoIqELgGIgQ2AkQgBCADKAJwIgZBA3RqIgQgATYCACADIAZBAWo2AnAgBCAHNgIEIANBAToAgQFBgH8hBCADKAJUIQYLIAIgBigCICACKAJAIAEgAkEYakEBQf////8HQe2CKhC4BiIGNgJAIAEgBmogBDoAACADIAc2AmQgAy0AfyIBQf8BRwRAIAMoAkwiAigCDCEIIAIgAygCVCgCICACKAI8IAEgAkEMakEIQf8BQaH+KRC4BiIENgI8AkAgCCACKAIMIgdODQAgByAIIgFrQQdxIgYEQEEAIQIDQCAEIAFBA3RqQQA2AgAgAUEBaiEBIAJBAWoiAiAGRw0ACwsgCCAHa0F4Sw0AIARBOGohBiAEQTBqIQggBEEoaiEJIARBIGohCiAEQRhqIQsgBEEQaiEMIARBCGohDQNAIAQgAUEDdCICakEANgIAIAIgDWpBADYCACACIAxqQQA2AgAgAiALakEANgIAIAIgCmpBADYCACACIAlqQQA2AgAgAiAIakEANgIAIAIgBmpBADYCACABQQhqIgEgB0cNAAsLIAMgAy0AfyICQQFqOgB/IAQgAkEDdGoiAkEAOgAGIAJBATsBBCACIAMoArwBIgE2AgACQCADKAJMIgItAAUiBEEgcUUNACABLQAFQRhxRQ0AIAMoAqQBKAIQIgYtADlBAk0EQCAGIAEQjgYgAi0ABUEGcUUNASABIAEtAAVB+AFxQQJyOgAFDAELIAYtADoNACACIAYtADhBGHEgBEHHAXFyOgAFCyADIAMoAogBNgKMAQJAIAMoApgBQaACRwRAIAMpApgBIQ4gA0GgAjYCmAEgAyAONwKQASAOpyECDAELIAMgA0GEAWogA0GUAWoQuQYiAjYCkAELA0ACQAJAIAJBgwJrIgFBHUsNAEEBIAF0QYeAiIACcQR/IAIFIAFBDkcNASADQYQBahC6BiADKAKQAQtBoAJHDQEgA0GEAWoQuwYgACAAKAIMQQhrNgIMDB8LIANBhAFqELoGIAMoApABIQIMAQsLIANBhAFqQaACELwGAAsgA0HMAGpB/wFBof4pEL0GAAsgCEEEEIQGAAsgAEEEEIQGAAsgAEEEEIQGAAsgAEEEEIQGAAsgAyACNgJEIANBk8opNgJAIABBo4AsIANBQGsQoQYaIABBAxCEBgALIABBBBCEBgALIABBBBCEBgALIANBzABqQYLTKhC+BgALIANBzABqQbDlKhC+BgALIANBzABqQYLTKhC+BgALIANBzABqQcblKhC+BgALIANBzABqQYLTKhC+BgALIANBlKAqNgIAIANBzABqIABB7+UqIAMQoQYQvgYACyADQcwAakGC0yoQvgYACyADQdaYKjYCECADQcwAaiAAQe/lKiADQRBqEKEGEL4GAAsgA0HMAGpBgtMqEL4GAAsgA0Gpryo2AiAgA0HMAGogAEHv5SogA0EgahChBhC+BgALIANBzABqQYLTKhC+BgALIANBzABqQfLSKhC+BgALIANBzABqQYLTKhC+BgALIANBzABqQc7lKhC+BgALIANBzABqQYLTKhC+BgALIANBzABqQd7lKhC+BgALIANBzABqQYLTKhC+BgALIANBzABqQdTSKhC+BgALIANBzABqQYLTKhC+BgALIAMgAjYCNCADQaqrKTYCMCAAQaOALCADQTBqEKEGGiAAQQMQhAYACwJAIAUtAAYEQCAFQRBqIQhBACEEA0AgAEEQaiIHKAIAIgEoAgRBAEEJQRQgASgCABECACICRQRAIABBAEEJQRQQgwYiAkUNAwsgASABKAIMQRRqNgIMIAEtADghBiACQQk6AAQgAiAGQRhxIgY6AAUgAiABKAJENgIAIAEgAjYCRCACQQA6ABAgAiACQQxqNgIIIAggBEECdGogAjYCAAJAIAUtAAUiAUEgcUUNACAGRQ0AIAcoAgAiBi0AOUECTQRAIAYgAhCOBiAFLQAFQQZxRQ0BIAIgAi0ABUH4AXFBAnI6AAUMAQsgBi0AOg0AIAUgBi0AOEEYcSABQccBcXI6AAULIARBAWoiBCAFLQAGSQ0ACwsgA0HQAWokAA8LIABBBBCEBgAL7wQBBX8gACgCECICIAE6AD8CQCACLQA6RQRAIAIhAQJAIAItADkiA0ECTQR/IAJBAzoAOSACQcQAaiIFIQMCQANAIAAoAhAhASADKAIAIgRFBEBBACEDDAILAkAgBC0ABSIGIAEtADgiAUEYc3EEQCADIAQoAgA2AgAgACAEEMMGDAELIAQgBkHAAXEgAUEYcXI6AAUgBCEDCyADQQAgAygCABsiAyAFRg0ACyAAKAIQIQELIAIgAzYCSCABLQA5BSADC0H/AXFBCEcEQANAIAAQxAYaIAEtADlBCEcNAAsgACgCECIBLQA5RQ0BCwNAIAAQxAYaIAEtADkNAAsgACgCECEBCyACQQE6ADkCQCABLQA5QQdHBEADQCAAEMQGGiABLQA5QQdHDQALIAAoAhAiAS0AOUEIRg0BCwNAIAAQxAYaIAEtADlBCEcNAAsLIAIgAigCDCACKAIIaiIBQf////8HIAIoAhBB5ABuIgAgAi0AQEECdCIDbCADQf////8HIABuTxtrIgBBH3UgAHEiACABQf////8HayIDIAAgA0obIgA2AgwgAiABIABrNgIIDAELIAItADhBGHEhAyACKAJEIgEEQANAIAEgAS0ABUHAAXEgA3I6AAUgASgCACIBDQALCyACQQA2AnQgAkIANwJsIAIoAkwiAQRAA0AgASABLQAFQcABcSADcjoABSABKAIAIgENAAsLIAIoAmQiAQRAA0AgASABLQAFQcABcSADcjoABSABKAIAIgENAAsLIAJBADYChAEgAkIANwJ8IAJBCDsAOSACQQA2AhQgACACEJQGGgsgAkEAOgA/C5UBAQN/AkAgACgCECICLQA5QQhHBEADQCAAEMQGGiACLQA5QQhHDQALIAAoAhAiAi0AOUUNAQsDQCAAEMQGGiACLQA5DQALCyAAEMUGIQIgACABEMYGIAFBACABLQA8IAEoAgwgASgCCGoiAEHkAG5sayIDIABB/////wdrIgQgAyAEShsiAzYCDCABIAAgA2s2AgggAgt7AQN/IAAoAlwiAgRAIAAoAhwhAyAAKAIMIgEgAUEIaygCADYCACABIAFBBGstAAA6AAQgACgCDCIBQQhrIAIgA2oiAigCADYCACABQQRrIAItAAQ6AAAgACAAKAIMIgFBCGo2AgwgACABQQhrQQEQkQYLIABBAhCEBgAL8wMBCX8CQCABQQBKBEAgACgCFCgCAEEIaiIBIAAoAgwiBUkNASAAKAIQQSxqIQEMAQsgACgCDCIFIAFBA3RqIQELIAEoAgAiBCgCCCECAkAgBCwABkEATg0AIAJpQQJJDQAgAkEBdiACciIBQQJ2IAFyIgFBBHYgAXIiAUEIdiABciIBQRB2IAFyQQFqIQILIAVBCGshBgJAAkAgBUEEayIILQAAIgNBD3FFBEBBACEBDAELQQAhASADQQNGBEAgBigCACIBQQAgAUEBa0H/////AUkbIQELIAFBAWsgAkkNACAEIAZBARCFBiIBLQAEQSBGDQEgAiABIAQoAhBrQQR1akEBaiEBCwJAAkAgASACSQRAIAQoAgwhBwNAIAFBAWohAyAHIAFBA3RqLQAEQQ9xBEAgBiADNgIAIAhBAzoAACAEKAIMIAFBA3RqIQMMAwsgAyIBIAJHDQALIAIhAQtBeCEKIAEgAmsiAUEBIAQtAAd0IgJODQEgBCgCECEHA0AgByABQQR0aiIDLQAEQQ9xRQRAIAIgAUEBaiIBRw0BDAMLCyAGIAMoAgw2AgAgCCADLQAFOgAACyAFIAMoAgA2AgAgBSADLQAEOgAEQQEhCUEIIQoLIAAgACgCDCAKajYCDCAJDwsgAEGGgixBABCXBgAL3wcBCX8jAEHQAGsiAyQAIAAoAhQhBCAAKAIQKAIMQQBKBEAgABBUCyADIAI2AgwgACABIAIQgQYhCiAELQAiQQJxRQRAQX8hASAEKAIAKAIAKAIMIgIoAkwhBwJAIAIoAkAiBUUNACAEKAIQIAIoAjRrQQJ1IgRBAWshCQJ/AkAgAigCJCIBBEAgBCACKAJEIgYoAgBKDQELIAJBKGohAUF/DAELIAEgCUEHdiICIAEgAkobQQFrIQggAkEBayEBA0ACQCAIIAEiAkYEQCAIIQIMAQsgBCAGIAJBAWoiAUEDdGooAgBKDQELCyAGIAJBA3RqIgJBBGohASACKAIACyECIAEoAgAhASACIAlODQAgBCACa0ECayELIAQgAkF/c2pBA3EiCARAQQAhBCACIQYDQCABIAUgBkEBaiIGaiwAAGohASAEQQFqIgQgCEcNAAsgAiAIaiECCyALQQNJDQAgBUEDaiEEIAVBAmohBiAFQQFqIQgDQCACIARqLAAAIAIgBmosAAAgASACIAhqLAAAampqIAUgAkEEaiICaiwAAGohASACIAlHDQALCwJAIAcEQCAHQRBqIQUgBy0AByICQf8BRgRAIAcoAgwhAgsCQAJAAkAgBS0AAEE9aw4EAAICAQILIAdBEWohBSACQTxNBEAgAkUNBCADQRBqIAUgAvwKAAAMBAsgAyAFKAA3NgBHIANBQGsgBSkAMDcDACADIAX9AAAg/QsEMCADIAX9AAAQ/QsEICADIAX9AAAA/QsEECADQQA6AEsMAwsgAkE8TQRAIAJFDQMgA0EQaiAHQRFqIAL8CgAADAMLIANBy/UrLQAAOgASIANByfUrLwAAOwEQIAMgAiAHaiIC/QAAAP0LADsgAyACLQAQOgBLIAMgAkEoayIC/QAAGP0LACsgAyACKQAANwATIAMgAv0AAAj9CwAbDAILIAVBChCeASEGIANB+ocsLQAAOgAYIANB8ocsKQAANwMQIANBEGpBCXIhBAJAAkAgAkEsSw0AIAYNACACRQ0BIAQgBSAC/AoAAAwBC0EtIAYgBWsgAiAGGyICIAJBLU8bIgIEQCAEIAUgAvwKAAALIAIgBGoiBEHL9SstAAA6AAIgBEHJ9SsvAAA7AABBAyECCyACIARqIgJB9NkrLwAAOwAAIAJB9tkrLQAAOgACDAELIANBPzsBEAsgAyAKNgIIIAMgATYCBCADIANBEGo2AgAgAEG8iyogAxChBhogACgCDCICQRBrIAJBCGsoAgA2AgAgAkEMayACQQRrLQAAOgAAIAAgACgCDEEIazYCDAsgABCVBgALhgcBCX8jAEEwayIKJAACQAJAIAFBAUcEQCAAKAIMIQUDQCAFQRBrIQMCQAJAAkACQCAFQQxrIgItAABBD3FBA2tBAUsNACAFQQhrIQcgBUEEayIELQAAIghBD3FBA2sOAgECAAtBASECIAAgAyAFQQhrIgUgA0EWEJEHDQIgACAFIAMgAy0ABEEPcUEDa0ECSRtB0YArEJ4GAAsgACAHEFMgBC0AACEICwJAIAhB/wFxQcQARwRAIAItAAAhBAwBCyACLQAAIQQgBygCAC0ABw0AQQEhAiAEQQ9xQQNHDQEgACADEFMMAQsCQCAEQf8BcUHEAEcNACADKAIALQAHDQAgAyAHKAIANgIAIAIgCDoAAEEBIQIMAQsgBygCACICLQAHIgRB/wFGBEAgAigCDCEEC0EBIQgCQCABQQJIDQADQCAFIAhBA3RrIgNBCGshAgJAAkAgA0EEay0AAEEPcUEDaw4CAAEDCyAAIAIQUwsgAigCACIDLQAHIgJB/wFGBEAgAygCDCECCyACQev///8HIARrTw0FIAIgBGohBCAIQQFqIgggAUcNAAsgASEICwJAIARBKE0EQEEAIQcgCCECA0AgBSACQQN0aygCACIJLQAHIgNB/wFGBEAgCSgCDCEDCyADBEAgByAKaiAJQRBqIAP8CgAACyADIAdqIQcgAkEBSiEDIAJBAWshAiADDQALIAAgCiAEEIAGIQYMAQsgACgCECICKAI0IQkgAigCBEEAQQQgBEERaiIDIAIoAgARAgAiBkUEQCAAQQBBBCADEIMGIgZFDQYLIAIgAigCDCADajYCDCACLQA4IQMgBkEUOgAEIAYgA0EYcToABSAGIAIoAkQ2AgAgAiAGNgJEQQAhByAGQQA6AAYgBiAJNgIIIAZBEGoiCSAEakEAOgAAIAZB/wE6AAcgBiAENgIMIAghAgNAIAUgAkEDdGsoAgAiBC0AByIDQf8BRgRAIAQoAgwhAwsgAwRAIAcgCWogBEEQaiAD/AoAAAsgAyAHaiEHIAJBAUohAyACQQFrIQIgAw0ACwsgBSAIQQN0ayICIAY2AgAgAiAGLQAEQcAAcjoABCAIQQFrIQILIAAgACgCDCACQQN0ayIFNgIMIAEgAmsiAUEBSg0ACwsgCkEwaiQADwsgACAFIAFBA3RrNgIMIABBxL4pQQAQlwYACyAAQQQQhAYAC+cCAQN/AkAgAUEASgRAIAAoAhQoAgBBCGoiASAAKAIMIgVJDQEgACgCEEEsaiEBDAELIAAoAgwiBSABQQN0aiEBCwJAAn8gAS0ABEE/cSIDQQZHBEAgA0EmRw0CIAJBAWsiAyABKAIAIgItAAZPDQJBt5MsIQQgAiADQQN0akEQagwBCyACQQFrIgIgASgCACIBKAIMIgMoAgxPDQEgAygCPCACQQN0aigCACIEQRBqQZH8KyAEGyEEIAEgAkECdGooAhAiAigCCAshASAAIAVBCGsiAzYCDCABIAMoAgAiAzYCACABIAVBBGstAAAiBToABCAFQcAAcUUNACACLQAFIgFBIHFFDQAgAy0ABUEYcUUNACAAKAIQIgAtADlBAk0EQCAAIAMQjgYgAi0ABUEGcUUNASADIAMtAAVB+AFxQQJyOgAFIAQPCyAALQA6DQAgAiAALQA4QRhxIAFBxwFxcjoABQsgBAuLFgIUfwF+IwBBEGsiDiQAAkAgAS0AAEE+RgRAIAAgACgCDEEIayIQNgIMIAFBAWohAQwBCyACKAJoIggoAgAhEAsgEC0ABEEgckHmAEYEQCAQKAIAIQYLIAJBNWohESACQQRqIRIgAkEsaiIMQQhqIRQgAkEvaiIPQThqIRUgASEDQQEhEwNAAkACQAJAAkACQAJAAkACQAJAAkAgAy0AACIEQcwAaw4qCAcHBwcHBwAHBwcHBwcHBwcHBwcHBwcHBwcIBwcHBwcBBwQHBwcFBwMCBgsgAgJ/AkAgBgRAIAYtAARBBkYNAQsgAkJ/NwIcQQQhBCACQQQ2AhRB59krIQUgAkHn2Ss2AhBB3+IrDAELAkAgBigCDCIKKAJMIgcEQCACIAdBEGoiBTYCECAHLQAHIgRB/wFHDQEgBygCDCEEDAELQePjKyEFIAJB4+MrNgIQQQIhBAsgAiAENgIUIAIgCigCKCIHNgIcIAIgCigCLDYCIEHE1itBn7oqIAcbCzYCDAJAAkACQCAFLQAAQT1rDgQAAgIBAgsgBUEBaiEFIARBPE0EQCAERQ0KIAwgBSAE/AoAACADQQFqIQMMDAsgDCAF/QAAAP0LAAAgDCAFKAA3NgA3IAwgBSkAMDcAMCAMIAX9AAAg/QsAICAMIAX9AAAQ/QsAECACQQA6AGcgA0EBaiEDDAsLIARBPE0EQCAERQ0JIAwgBUEBaiAE/AoAACADQQFqIQMMCwsgDEHL9SstAAA6AAIgDEHJ9SsvAAA7AAAgDyAEIAVqIgVBOGsiBCkAADcAACAVIAUtAAA6AAAgDyAE/QAACP0LAAggDyAE/QAAGP0LABggDyAE/QAAKP0LACggA0EBaiEDDAoLIAVBChCeASEKIBRB+ocsLQAAOgAAIAxB8ocsKQAANwAAAn8CQCAEQSxLDQAgCg0AIAQEQCARIAUgBPwKAAALIAQgEWoMAQtBLSAKIAVrIAQgChsiBCAEQS1PGyIEBEAgESAFIAT8CgAACyAEIBFqIgRBy/UrLQAAOgACIARByfUrLwAAOwAAIARBA2oLIgRB9tkrLQAAOgACIARB9NkrLwAAOwAAIANBAWohAwwJC0F/IQUCQCAIRQ0AIAgtACJBAnENACAIKAIAKAIAKAIMIgQoAkAiC0UNACAIKAIQIAQoAjRrQQJ1IglBAWshDQJ/AkAgBCgCJCIFBEAgCSAEKAJEIgooAgBKDQELIARBKGohBUF/DAELIAUgDUEHdiIEIAQgBUgbQQFrIQcgBEEBayEFA0ACQCAHIAUiBEYEQCAHIQQMAQsgCSAKIARBAWoiBUEDdGooAgBKDQELCyAKIARBA3RqIgRBBGohBSAEKAIACyEEIAUoAgAhBSAEIA1ODQAgCSAEa0ECayEWQQAhCiAEIQcgCSAEQX9zakEDcSIJBEADQCAFIAsgB0EBaiIHaiwAAGohBSAKQQFqIgogCUcNAAsgBCAJaiEECyAWQQNJDQAgC0EDaiEKIAtBAmohByALQQFqIQkDQCAEIApqLAAAIAQgB2osAAAgBSAEIAlqLAAAampqIAsgBEEEaiIEaiwAAGohBSAEIA1HDQALCyACIAU2AhggA0EBaiEDDAgLIAZFBEAgAkEAOgAkIAJBgAI7ACUgA0EBaiEDDAgLIAIgBi0ABjoAJCAGLQAEQQZHBEAgAkGAAjsAJSADQQFqIQMMCAsgAiAGKAIMLQAHOgAmIAIgBigCDC0ABjoAJSADQQFqIQMMBwsgCEUEQCACQQA6ACcgA0EBaiEDDAcLIAIgCC8BIkEgcToAJyADQQFqIQMMBgsCQCAIRQ0AIAgtACJBIHENACACIAAgCCgCCCASEJsGIgQ2AgggBA0ECyACQQA2AgQgAkG3kyw2AgggA0EBaiEDDAULAkAgCARAIAgtACNBAXENAQsgAkEANgIoIANBAWohAwwFCyACIAgvARw7ASggAiAILwEeOwEqIANBAWohAwwECyAERQ0CC0EAIRMLIANBAWohAwwBCwsgAUHmABCeAQRAIAAoAgwiAyAQKAIANgIAIAMgEC0ABDoABCAAIAAoAgxBCGo2AgwLAkACQCABQcwAEJ4BRQ0AAkAgBgRAIAYtAARBBkYNAQsgACgCDEEAOgAEIAAgACgCDEEIajYCDAwBCyAGKAIMIgsoAighAiAAKAIQIgMoAgRBAEEFQSAgAygCABECACIHRQRAIABBAEEFQSAQgwYiB0UNAgsgAyADKAIMQSBqNgIMIAMtADghBCAHQQU6AAQgByAEQRhxOgAFIAcgAygCRDYCACADIAc2AkQgB0IANwIUIAdBxLEvNgIQIAdCADcCCCAHQT87AQYgACgCDCIDQcUAOgAEIAMgBzYCACAAIAAoAgxBCGo2AgwgCygCQCIERQ0AIAtBKGohDCAOQRE6AAQCQCALLQAHRQRAQQAhCQwBCyAELAAAIgNBgH9HBEAgAiADaiECQQEhCQwBCwJAAkAgCygCJCIDRQ0AIAsoAkQiBSgCAEEASg0AQX8hAiADQQAgA0EAShtBAWshCANAAkAgCCACIgNGBEAgCCEDDAELIAUgA0EBaiICQQN0aigCAEEATA0BCwsgBSADQQN0aiIDKAIEIQIgAygCACIGQQBIDQFBASEJDAILIAwoAgAhAkF/IQYLQQAhA0EAIAZrQQNxIggEfyAGIQUDQCACIAQgBUEBaiIFaiwAAGohAiADQQFqIgMgCEcNAAsgBiAIagUgBgshAyAGQXxLBEBBASEJDAELIARBA2ohBSAEQQJqIQhBASEJIARBAWohBgNAIAMgBWosAAAgAyAIaiwAACACIAMgBmosAABqamogBCADQQRqIgNqLAAAaiECIAMNAAsLIAkgCygCGE4NACAJQQFrIRJBACENIAkhBQNAAkAgCygCQCIEIAVqLAAAIgNBgH9HBEAgAiADaiECDAELQX8hAwJAIAsoAiQiBkUEQCAMIQIMAQsgDCECIAUgCygCRCIIKAIASA0AIAYgBUEHdiIDIAMgBkgbQQFrIQYgA0EBayECA0ACQCAGIAIiA0YEQCAGIQMMAQsgBSAIIANBAWoiAkEDdGooAgBODQELCyAIIANBA3RqIgNBBGohAiADKAIAIQMLIAIoAgAhAiADIAVODQAgDSASaiADayEPQQAhCCADIQYgBSADa0EDcSIKBEADQCACIAQgBkEBaiIGaiwAAGohAiAIQQFqIgggCkcNAAsgAyAJIANrQQNxaiEDCyAPQQNJDQAgBEEDaiEIIARBAmohBiAEQQFqIQoDQCADIAhqLAAAIAMgBmosAAAgAiADIApqLAAAampqIAQgA0EEaiIDaiwAAGohAiADIAVHDQALCwJAAkAgAkEBayIDIAcoAggiBE8EQCAHLAAGQQBODQEgA0EAIARrcSAETw0BIAcgAjYCCAsgBygCDCADQQN0aiEDDAELIAcoAhAgAqwiF0IeiCAXhUK5y5Pn0e2RrL9/fiIXQhuIIBeFQuujxJmxt5LolH9+IhdCH4ggF4WnQX8gBy0AB3RBf3NxQQR0aiEDA0AgAy0ABUEDRgRAIAMoAgwgAkYNAgsgAyADKAIIIgRBBHRqIQMgBA0AC0HUsS8hAwsCQCADLQAEQSBGBEAgDkEDOgAMIA4gAjYCCCAAIAcgDkEIaiAOEI0GDAELIANBEToABAsgCUEBaiEJIA1BAWohDSAFQQFqIgUgCygCGEgNAAsLIA5BEGokACATDwsgAEEEEIQGAAvbAgEDfyABLwEiIgRBCHEEQCACQeTjKzYCAEHA0ioPCwJAAkAgBEGAAXEEQCACQZnHKzYCAAwBCyAEQQJxDQECQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCABKAIAKAIAKAIMIgUoAjQiBCABKAIQIARrQQJ1QQFrIgRBAnRqKAIAIgFB/wBxQQtrDkIMDAwMAgICAg4MDg4ODg4ODg4ODg4ODg4ODg4ODg4ODg4ODgMDAwQFDgYHCw4OCAkKDg4JCgkKDg4AAAsODg4ODgEOCyAFIAQgAUEHdkH/AXEgAhCcBg8LIAJBlI4qNgIAQZSOKg8LQQEhAwwJCyABQRh2IQMMCAtBEiEDDAcLQRMhAwwGC0EEIQMMBQtBFiEDDAQLQQUhAwwDC0EUIQMMAgtBFSEDDAELQRghAwsgAiAAKAIQIANBAnRqKAKYAUESajYCAAtB16orIQMLIAML3QQBAn8jAEEQayIEJAAgBCABNgIEAkAgACAEQQRqIAIgAxCdBiIBDQBBACEBIAQoAgQiAkF/Rg0AAkACQAJAAkACQCAAKAI0IAJBAnRqKAIAIgVB/wBxQQtrDgoAAQIDBQUFBQUEBQtB5OMrIQEgAyAAKAIwIAVBFXZB+A9xaiICLQAEQQ9xQQRGBH8gAigCAEEQagUgAQs2AgBBnq4rQafRKiAAKAI8IAVBDXZB+A9xaigCACIBQRBqQeTjKyABG0Gg2ysQrQEbIQEMBAsgBCACNgIMAkAgACAEQQxqIAVBGHYgAxCdBiIBBEAgAS0AAEHjAEYNAQsgA0Hk4ys2AgALIAQgAjYCDCAAIARBDGogBUEQdkH/AXEgBEEIahCdBhogBCgCCCIBRQRAQZ6uKyEBDAQLQZ6uK0Gn0SogAUGg2ysQrQEbIQEMAwsgA0GdvCk2AgBBnq4rIQEMAgtB5OMrIQEgAyAAKAIwIAVBFXZB+A9xaiIDLQAEQQ9xQQRGBH8gAygCAEEQagUgAQs2AgAgBCACNgIMIAAgBEEMaiAFQRB2Qf8BcSAEQQhqEJ0GGiAEKAIIIgFFBEBBnq4rIQEMAgtBnq4rQafRKiABQaDbKxCtARshAQwBCyAFQRh2IQECQCAFQYCAAnEEQEHk4yshAiADIAAoAjAgAUEDdGoiAS0ABEEPcUEERgR/IAEoAgBBEGoFIAILNgIADAELIAQgAjYCDCAAIARBDGogASADEJ0GIgEEQCABLQAAQeMARg0BCyADQeTjKzYCAAtB26orIQELIARBEGokACABC54FAQl/IAEoAgAhBgJAAkACQAJAA0ACQCAAKAIgIghBAEwNACACQQFqIQkgACgCSCEHQQAhBANAIAcgBEEMbGoiBSgCBCAGSg0BIAUoAgggBkoEQCAJQQFrIglFDQcLIARBAWoiBCAIRw0ACwtBACEEIANBADYCACAGIAAoAjQiCyAGQQJ0aigCAEH/AHFB8LAvaiwAAEEHdWohCUF/IQZBACEKIAlBAEwEQCABQX82AgBBAA8LA0AgCyAEQQJ0aigCACIFQQd2IgxB/wFxIQcCQAJAAkACQAJAAkACQCAFQf8AcSIIQThrDhUCAwMDAwMDAwMDAwMEBAMDAwMDAwEACyAIQQhHDQIgAiAHSQ0FIAIgByAFQRB2Qf8BcWpNDQQMBQsgAiAHQQJqTw0DDAQLIAogBCAMakH+//8HayIFIAogBSAKShsgBSAJShshCgwDCyACIAdHDQIgCEHwsC9qLQAAQQhxDQEMAgsgAiAHSQ0BC0F/IAQgBCAKSBshBgsgBEEBaiIEIAlHDQALIAEgBjYCAEEAIQUgBkF/Rg0DAkAgCyAGQQJ0aiIIKAIAIgRB/wBxIgcEQCAHQQNrDgcDBAUFBQUBBQsgBEEQdkH/AXEiAiAEQQd2Qf8BcUkNAQwECwsgAyAAKAI8IARBDXZB+A9xaigCACIEQRBqQeTjKyAEGzYCAEHG/CoPCyAAKAIwIARBDHZB+P8/cWoiBC0ABEEPcUEERwRAIANB5OMrNgIAQQAPCyADIAQoAgBBEGo2AgBBidspDwsgAwJ/IAAoAjAgCCgCBEEEdkH4////AHFqIgQtAARBD3FBBEcEQEHk4ysMAQtBidspIQUgBCgCAEEQags2AgALIAUPCyADIAUoAgBBEGo2AgBBkNEqCxMAIAAgASACIAAgARCfBhCgBgALmwIBCH8jAEEQayIDJABBt5MsIQgCQCAAKAIUIgUtACJBAnENAAJAAkAgBSgCACIJKAIAIgYtAAYiBARAIAZBEGohBwNAIAcgAkECdGooAgAoAgggAUYNAiACQQFqIgIgBEcNAAsLIAlBCGoiBCAFKAIEIgdPDQJBACECA0AgBCACQQN0aiABRwRAIAQgAkEBaiICQQN0aiAHSQ0BDAQLCyAGKAIMIgEgBSgCECABKAI0a0ECdUEBayACIANBDGoQnAYiAkUNAiADKAIMIQEMAQsgBigCDCgCPCACQQN0aigCACICQRBqQeTjKyACGyEBQcb8KiECCyADIAE2AgQgAyACNgIAIABBzYAsIAMQoQYhCAsgA0EQaiQAIAgLNwEBfyMAQRBrIgQkACAAIAEQogYhASAEIAM2AgggBCABNgIEIAQgAjYCACAAQYCFKiAEEJcGAAsoAQF/IwBBEGsiAyQAIAMgAjYCDCAAIAEgAhCBBiECIANBEGokACACC6ICAQR/AkACQAJAAkACQCABLQAEIgJBxQBrDgMAAwEDCyABKAIAKAIYIgINAUHFACECDAILIAEoAgAoAgwiAg0AQccAIQIMAQsCQEHKkSsgACgCEEE4aiIDKAKgAiIEQRBqEK0BRQRAIAQhAwwBC0HKkSsgA0GgAmoiBSgCBCIDQRBqEK0BRQ0AIAUgBDYCBCAFIABBypErQQYQgAYiAzYCAAsgAigCECADKAIIQX8gAi0AB3RBf3NxQQR0aiECAkADQCACLQAFQcQARgRAIAIoAgwgA0YNAgsgAiACKAIIIgBBBHRqIQIgAA0AC0HUsS8hAgsgAi0ABEEPcUEERg0BIAEtAAQhAgsgAkEPcUECdEH0sS9qKAIADwsgAigCAEEQagssAQF/IwBBEGsiAyQAIAMgACABEKIGNgIEIAMgAjYCACAAQfv5KyADEJcGAAsaACAAIAIgASABLQAEQQ9xQQNGGyADEJ4GAAsyAQF/IwBBEGsiAyQAIAMgACACIAEgASADQQxqEKYGGxCfBjYCACAAQZGzKiADEJcGAAtsAgF9AX8CQAJAAkAgAC0ABEEDaw4RAQICAgICAgICAgICAgICAgACCyAAKgIAIgIgAo4iAlwNASACQwAAAE9dIAJDAAAAz2BxIgNFDQEgASAC/AA2AgAgAw8LIAEgACgCADYCAEEBIQMLIAMLiwUBBX8jAEEgayIGJAACfwJAAkACQAJAAkAgAS0ABCIDQcUAaw4DAAMBAwsgASgCACgCGCIDDQFBxQAhAwwCCyABKAIAKAIMIgMNAEHHACEDDAELAkBBypErIAAoAhBBOGoiBCgCoAIiBUEQahCtAUUEQCAFIQQMAQtBypErIARBoAJqIgcoAgQiBEEQahCtAUUNACAHIAU2AgQgByAAQcqRK0EGEIAGIgQ2AgALIAMoAhAgBCgCCEF/IAMtAAd0QX9zcUEEdGohAwJAA0AgAy0ABUHEAEYEQCADKAIMIARGDQILIAMgAygCCCIFQQR0aiEDIAUNAAtB1LEvIQMLIAMtAARBD3FBBEYNASABLQAEIQMLIANBD3FBAnRB9LEvaigCAAwBCyADKAIAQRBqCyIBAn8CQAJAAkACQAJAIAItAAQiA0HFAGsOAwADAQMLIAIoAgAoAhgiAw0BQcUAIQMMAgsgAigCACgCDCIDDQBBxwAhAwwBCwJAQcqRKyAAKAIQQThqIgQoAqACIgVBEGoQrQFFBEAgBSEEDAELQcqRKyAEQaACaiIHKAIEIgRBEGoQrQFFDQAgByAFNgIEIAcgAEHKkStBBhCABiIENgIACyADKAIQIAQoAghBfyADLQAHdEF/c3FBBHRqIQMCQANAIAMtAAVBxABGBEAgAygCDCAERg0CCyADIAMoAggiBUEEdGohAyAFDQALQdSxLyEDCyADLQAEQQ9xQQRGDQEgAi0ABCEDCyADQQ9xQQJ0QfSxL2ooAgAMAQsgAygCAEEQagsiAxCtAQRAIAYgAzYCFCAGIAE2AhAgAEGxhyogBkEQahCXBgALIAYgATYCACAAQar+KSAGEJcGAAvMCgENfyAAKAIUIQsgACgCcCICQQxxRQRAIAtBADYCFEEADwsgCygCACgCACgCDCEFIAsgAUEEaiIKNgIQAkACQAJAIAJBCHFFDQAgACAAKAJsQQFrIgE2AmwgAQ0AIAAgACgCaDYCbEEBIQ4MAQtBASEBIAJBBHFFDQELIAsvASIiAUHAAHEEQCALIAFBv/8DcTsBIkEBIQEMAQsCQCALKAIQQQRrKAIAIgFBgID8B3FFBEAgAUH/AHFB8LAvai0AAEEgcQ0BCyAAIAsoAgQ2AgwLIA4EQCAAQQNBf0EAQQAQqQYLIAJBBHEEQEF/IQcgBSgCQCEBAkACQAJAIAogBSgCNGtBAnUiDEEBayIKIAAoAmQiAkEAIAIgBSgCFEgbIgNKBEAgAUUNAwJAIAogA2tBP0oNACADIQIDQCABIAJBAWoiAmosAAAiBkGAf0YNASAEIAZqIQQgAiAKRw0ACyAEDQIMBAsCfwJAIAUoAiQiDQRAIAMgBSgCRCIGKAIATg0BCyAFQShqIQJBfwwBCyANIANBB3YiAiACIA1IG0EBayEIIAJBAWshBANAAkAgCCAEIgJGBEAgCCECDAELIAMgBiACQQFqIgRBA3RqKAIATg0BCwsgBiACQQN0aiIEQQRqIQIgBCgCAAshCSACKAIAIQQCQCADIAlMDQAgAyAJa0EDcSIIBH9BACECIAkhBgNAIAQgASAGQQFqIgZqLAAAaiEEIAJBAWoiAiAIRw0ACyAIIAlqBSAJCyECIAkgA2tBfEsNACABQQNqIQYgAUECaiEIIAFBAWohCQNAIAIgBmosAAAgAiAIaiwAACAEIAIgCWosAABqamogASACQQRqIgJqLAAAaiEEIAIgA0cNAAsLAn8CQCANBEAgDCAFKAJEIgYoAgBKDQELIAVBKGohA0F/DAELIA0gCkEHdiICIAIgDUgbQQFrIQggAkEBayEDA0ACQCAIIAMiAkYEQCAIIQIMAQsgDCAGIAJBAWoiA0EDdGooAgBKDQELCyAGIAJBA3RqIgJBBGohAyACKAIACyECIAMoAgAhAwJAIAIgCk4NACAMIAJrQQJrIQ0gDCACQX9zakEDcSIJBEBBACEGIAIhCANAIAMgASAIQQFqIghqLAAAaiEDIAZBAWoiBiAJRw0ACyACIAlqIQILIA1BA0kNACABQQNqIQYgAUECaiEIIAFBAWohCQNAIAIgBmosAAAgAiAIaiwAACADIAIgCWosAABqamogASACQQRqIgJqLAAAaiEDIAIgCkcNAAsLIAMgBEYNAwsgAUUNAQsCfwJAIAUoAiQiAgRAIAwgBSgCRCIEKAIASg0BCyAFQShqIQdBfwwBCyACIApBB3YiByACIAdKG0EBayEFIAdBAWshBwNAAkAgBSAHIgJGBEAgBSECDAELIAwgBCACQQFqIgdBA3RqKAIASg0BCwsgBCACQQN0aiICQQRqIQcgAigCAAshAiAHKAIAIQcgAiAKTg0AIAwgAmtBAmshBiAMIAJBf3NqQQNxIgMEQEEAIQUgAiEEA0AgByABIARBAWoiBGosAABqIQcgBUEBaiIFIANHDQALIAIgA2ohAgsgBkEDSQ0AIAFBA2ohBSABQQJqIQQgAUEBaiEDA0AgAiAFaiwAACACIARqLAAAIAcgAiADaiwAAGpqaiABIAJBBGoiAmosAABqIQcgAiAKRw0ACwsgAEECIAdBAEEAEKkGCyAAIAo2AmQLQQEhASAALQAGQQFHDQAgDgRAIABBATYCbAsgCyALLwEiQcAAcjsBIiAAQQEQhAYACyABC7cCAQZ/IwBB8ABrIgckAAJAIAAoAlgiCkUNACAALQAHRQ0AIAAoAhQiBSgCBCEGIAAoAhwhCCAAKAIMIQkgByAFNgJsIAcgAjYCHCAHIAE2AgQCfyAERQRAIAkhBEEIDAELIAUgBDsBHiAFIAM7ARwgACgCDCEEQYgCCyECAkAgBS0AIkECcQ0AIAQgBk8NACAAIAY2AgwgBiEECyAJIAhrIQEgBiAIayEGIAAoAhggBGtBpwFMBH8gAEEUEK0GIAAoAgwFIAQLQaABaiIEIAUoAgRLBEAgBSAENgIECyAAQQA6AAcgBSAFLwEiIAJyOwEiIAAgB0EEaiAKEQMAIABBAToAByAFIAAoAhwgBmo2AgQgACAAKAIcIAFqNgIMIAUgBS8BIiACQX9zcTsBIgsgB0HwAGokAAsTACAAIAEoAgAgASgCBEEAEF4aC4UFAQl/IAAoAhAtADshByAAIAAoAgwgACgCHCIDazYCDCAAIAAoAiQgA2s2AiQgACgCGCADayEFIAAoAiAiAwRAA0AgAyADKAIIIAAoAhxrNgIIIAMoAgwiAw0ACwsgACgCFCIDBEADQCADIAMoAgQgACgCHGs2AgQgAyADKAIAIAAoAhxrNgIAIAMoAggiAw0ACwsgACgCECIDQQE6ADsgAygCBCAAKAIcIgkgBUEDdSIKQQVqIgVBA3QiCCABQQVqIgtBA3QiBiADKAIAEQIAIQQCQAJAAkAgBkUNACAEDQAgACAJIAggBhCDBiIEDQAgACgCECAHOgA7DAELIAMgAygCDCAGIAhrajYCDCAAKAIQIAc6ADsgBA0BCyAAIAAoAhwiASAAKAIMajYCDCAAIAEgACgCJGo2AiQgACgCICIBBEADQCABIAAoAhwgASgCCGo2AgggASgCDCIBDQALCyAAKAIUIgEEQANAIAEgACgCHCABKAIEajYCBCABIAAoAhwgASgCAGo2AgAgAS0AIkECcUUEQCABQQE2AhQLIAEoAggiAQ0ACwsgAkUEQEEADwsgAEEEEIQGAAsgACAENgIcIAAgBCAAKAIMajYCDCAAIAQgACgCJGo2AiQgACgCICIDBEADQCADIAAoAhwgAygCCGo2AgggAygCDCIDDQALCyAAKAIUIgMEQANAIAMgACgCHCADKAIEajYCBCADIAAoAhwgAygCAGo2AgAgAy0AIkECcUUEQCADQQE2AhQLIAMoAggiAw0ACwsgACAAKAIcIAFBA3RqNgIYIAEgCkwEQEEBDwsDQCAEIAVBA3RqQQA6AAQgBUEBaiIFIAtIDQALQQELBQAQAwALigEBAn8gACgCGCAAKAIcIgJrIgNBgbSJE04EQCAAQQUQhAYACwJAIAFBv5axAkoNACAAKAIMIAJrQQN1IAFqIgFBwJaxAkoNACAAQcCWsQIgA0ECdSICIAJBwJaxAk4bIgIgASABIAJIG0EBEKsGGg8LIABBiJixAkEBEKsGGiAAQbW+KUEAEJcGAAvWBQEJfyABLwEgIgPBIQYCQCAAKAJwRQ0AIAZBf0gNACAAIAEgAhCvBgsgASgCACEEAkACQAJAAkACQAJAIAMOAgECAAsgA0H//wNHDQIgAiEGDAMLIAAgBDYCDAwDCyAEIAIEfyAEIAAoAgwgAkEDdGsiAigCADYCACACLQAEBUEACzoABCAAIARBCGo2AgwMAgsgBkF+Sg0AIAAoAhQiAyACNgIcIAMgAy8BIkGABHI7ASIgACAEQX9BARBeIQQgACgCFCIDIAMvASJB//sDcTsBIiAAKAJwBEAgACgCHCEFIAAgAyACEK8GIAAoAhwgBCAFa2ohBAsgAkF9IAZrIAZBfkYbIQYLAkAgAiAGIAIgBkgbIghBAEwEQEEAIQgMAQsgACgCDCACQQN0ayEDQQAhAiAIQQRPBEAgCEH8////B3EhCgNAIAQgAkEDdCIFaiIHIAMgBWoiCSgCADYCACAHIAktAAQ6AAQgBCAFQQhyIgdqIgkgAyAHaiIHKAIANgIAIAkgBy0ABDoABCAEIAVBEHIiB2oiCSADIAdqIgcoAgA2AgAgCSAHLQAEOgAEIAQgBUEYciIFaiIHIAMgBWoiBSgCADYCACAHIAUtAAQ6AAQgAkEEaiICIApHDQALCyAIQQNxIgpFDQADQCAEIAJBA3QiBWoiByADIAVqIgUoAgA2AgAgByAFLQAEOgAEIAJBAWohAiALQQFqIgsgCkcNAAsLAkAgBiAITA0AIAYgCCIDa0EHcSIFBEBBACECA0AgBCADQQN0akEAOgAEIANBAWohAyACQQFqIgIgBUcNAAsLIAggBmtBeEsNAANAIAQgA0EDdGoiAkEAOgAEIAJBADoADCACQQA6ABQgAkEAOgAcIAJBADoAJCACQQA6ACwgAkEAOgA0IAJBADoAPCADQQhqIgMgBkcNAAsLIAAgBCAGQQN0ajYCDAsgACABKAIINgIUC7YBAQR/IAAoAnBBAnEEQCAAKAIMIAJBA3RrIQUgASgCACEDAkAgAS0AIkECcQ0AIAMoAgAoAgwiBi0AB0UNACABKAIYIAYtAAZqQQFqIQQLIAEgAyAEQQN0IgRqIgM2AgAgAEEBQX8gBSADa0EDdkH//wNxIAIQqQYgASABKAIAIARrNgIACyABKAIIIgEtACJBAnFFBEAgACABKAIQIAEoAgAoAgAoAgwoAjRrQQJ1QQFrNgJkCwusAgEDfyAAKAIYIAAoAgwiBmtBpwFMBEAgASAAKAIcayEEIAAoAhAoAgxBAEoEQCAAEFQLIABBFBCtBiAAKAIMIQYgACgCHCAEaiEBCwJAIAAoAhQoAgwiBEUEQCAAKAIQIgUoAgRBAEEAQSQgBSgCABECACIERQRAIABBAEEAQSQQgwYiBEUNAgsgBSAFKAIMQSRqNgIMIAAoAhQiBSAENgIMIARBADYCFCAEQQA2AgwgBCAFNgIIIAAgAC8BCEEBajsBCAsgBEECOwEiIAQgAjsBICAEIAE2AgAgBCAGQaABajYCBCAAIAQ2AhQgACgCcEEBcQRAIABBAEF/QQEgACgCDCABa0EDdUEBaxCpBgsgACAEIAAgAxEAACIBEK4GIAEPCyAAQQQQhAYAC7oDAQN/An8gACgCGCAAKAIMa0EITARAIAEgACgCHGshAiAAKAIQKAIMQQBKBEAgABBUCyAAQQEQrQYgACgCHCACaiEBCwJAAkACQCABLQAEQQ9xIgJBBWsOAwACAQILIAEoAgBBGGoMAgsgASgCAEEMagwBCyAAKAIQIAJBAnRqQfwBagshAiAAKAIQIQMCQCACKAIAIgIEQCACKAIQIAMoAvQBIgQoAghBfyACLQAHdEF/c3FBBHRqIQMDQCADLQAFQcQARgRAIAMoAgwgBEYNAwsgAyADKAIIIgJBBHRqIQMgAg0AC0HUsS8hAwwBCyADQSxqIQMLIAMtAARBD3EEQCAAIAEgACgCDCICSQR/A0AgAiACQQhrIgQoAgA2AgAgAiACQQRrLQAAOgAEIAQiAiABSw0ACyAAKAIMBSACC0EIajYCDCABIAMoAgA2AgAgASADLQAEOgAEIAEPCyMAQRBrIgIkACAAKAIUIQQgAkEANgIMIAAgAUGuyioCfyAAIAQgAkEMahCbBiIEBEAgAiAENgIAIAIgAigCDDYCBCAAQc2ALCACEKEGDAELIAAgARCfBgsQoAYAC8sEAQd/AkACQAJAAkADQAJAIAEhAwJAAkAgAS0ABEE/cSIEQRZrDhEEAQEBAQEBAQEBAQEBAQEBAgALIARBBkYNBAsgACABELEGIQEMAQsLIAEoAgBBDGohAwsgACABIAIgAygCABCwBhpBACEEDAELIAEoAgAoAgwiBi0ABiEHIAEhBSAGLQAIIgggACgCGCAAKAIMIglrQQN1TgRAIAEgACgCHGshBCAAKAIQKAIMQQBKBEAgABBUCyAAIAgQrQYgACgCHCAEaiEFCyAAKAIUKAIMIgRFBEAgACgCECIDKAIEQQBBAEEkIAMoAgARAgAiBEUEQCAAQQBBAEEkEIMGIgRFDQMLIAMgAygCDEEkajYCDCAAKAIUIgMgBDYCDCAEQQA2AhQgBEEANgIMIAQgAzYCCCAAIAAvAQhBAWo7AQgLQQAhAyAEQQA7ASIgBCACOwEgIAQgBTYCACAEIAUgCEEDdGpBCGo2AgQgACAENgIUIAQgBigCNDYCECAHIAkgAWtBA3UiBUgNACAHIAVrIgZBAWpBA3EiAgRAA0AgACAAKAIMIgFBCGo2AgwgAUEAOgAEIANBAWoiAyACRw0ACyACIAVqIQULIAZBA0kNACAFQQFrIQEDQCAAIAAoAgwiA0EIajYCDCADQQA6AAQgACAAKAIMIgNBCGo2AgwgA0EAOgAEIAAgACgCDCIDQQhqNgIMIANBADoABCAAIAAoAgwiA0EIajYCDCADQQA6AAQgAUEEaiIBIAdHDQALCyAEDwsgAEEEEIQGAAsyAQF/AkAgAC8BYCIBQcgBRwRAIAFB3AFPDQEPCyAAQbO+KUEAEJcGAAsgAEEFEIQGAAvKrgEDE38DfQF+IwBBIGsiCyQAIABBIGohFANAIAAoAnAhAyABIQcDQCAHKAIQIQEgBygCACgCACITKAIMKAIwIQ1BACEGAkAgA0UNACAAKAIUIgMoAgAoAgAoAgwhAiADQQE2AhQCQCADKAIQIAIoAjRHDQAgAi0ABw0BIAMtACJBwABxDQAgAEEANgJkIAAoAnBBAXEEQCADKAIAKAIAKAIMIQIgAyADKAIQQQRqNgIQIAAgAy8BIkEDdkEEcUF/QQEgAi0ABhCpBiADIAMoAhBBBGs2AhALCyAAIAEQqAYhBgsgE0EQaiEQIAFBBGohAyAHKAIAQQhqIQQDQAJAAkACfwJAAkACQAJAAkACQAJAAkACQAJ/AkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCABKAIAIgFB/wBxQQJ0QZCzL2ooAgBBAmsOUgECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjJCUmJygpKissLS4vMDEyMzQ1Njc4OTo7PD0+P0BBQkNERUZHSEpLTE1OT1BRUlMACyAEIAFBBHZB+A9xaiICIAQgAUENdkH4D3FqIgEoAgA2AgAgAiABLQAEOgAEQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMegsgBCABQQR2QfgPcWoiAkEDOgAEIAIgAUEPdkH//wNrNgIAQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMeQsgBCABQQR2QfgPcWoiAkETOgAEIAIgAUEPdkH//wNrsjgCAEEAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDHgLIAQgAUEEdkH4D3FqIgIgDSABQQx2Qfj/P3FqIgEoAgA2AgAgAiABLQAEOgAEQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMdwsgBCABQQR2QfgPcWoiASANIAMoAgBBBHZB+P///wBxaiICKAIANgIAIAEgAi0ABDoABCADQQRqIQFBACECIAYEQCAAIAEQqAYhAiAHKAIAQQhqIQQLIANBCGohAyACIQYMdgsgBCABQQR2QfgPcWpBAToABEEAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDHULIAQgAUEEdkH4D3FqQQE6AAQgA0EEaiEBQQAhAiAGBEAgACABEKgGIQIgBygCAEEIaiEECyADQQhqIQMgAiEGDHQLIAQgAUEEdkH4D3FqQRE6AARBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxzCyABQRB2IgVB/wFxIQggBCABQQR2QfgPcWohAiABQYCAHHFBgIAcRgR/IAgFIAVBAWpBB3EhBUEAIQEDQCACQQA6AAQgAkEIaiECIAFBAWoiASAFRw0ACyAIIAVrCyEBAkAgCEEHSQ0AIAFBB2siBUEIcUUEQCACQQA6ADwgAkEAOgA0IAJBADoALCACQQA6ACQgAkEAOgAcIAJBADoAFCACQQA6AAwgAkEAOgAEIAJBQGshAiABQQhrIQELIAVBCEkNAANAIAJBADoAfCACQQA6AHQgAkEAOgBsIAJBADoAZCACQQA6AFwgAkEAOgBUIAJBADoATCACQQA6AEQgAkEAOgA8IAJBADoANCACQQA6ACwgAkEAOgAkIAJBADoAHCACQQA6ABQgAkEAOgAMIAJBADoABCACQYABaiECIAFBD0chBSABQRBrIQEgBQ0ACwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxyCyAEIAFBBHZB+A9xaiICIBAgAUEOdkH8B3FqKAIAKAIIIgEoAgA2AgAgAiABLQAEOgAEQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMcQsgECABQQ52QfwHcWooAgAiCCgCCCICIAQgAUEEdkH4D3FqIgEoAgA2AgAgAiABLQAEIgU6AAQCQCAFQcAAcUUNACAILQAFIgJBIHFFDQAgASgCACIBLQAFQRhxRQ0AIAAoAhAiBS0AOUECTQRAIAUgARCOBiAILQAFQQZxRQ0BIAEgAS0ABUH4AXFBAnI6AAUMAQsgBS0AOg0AIAggBS0AOEEYcSACQccBcXI6AAULQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMcAsgDSABQRV2QfgPcWohCSAEIAFBBHZB+A9xaiEIQQAhAgJ/AkAgECABQQ52QfwHcWooAgAoAggiCi0ABEHFAEcNACAKKAIAIgEoAhAgCSgCACIFKAIIQX8gAS0AB3RBf3NxQQR0aiECAkADQCACLQAFQcQARgRAIAIoAgwgBUYNAgsgAiACKAIIIgFBBHRqIQIgAQ0AC0HUsS8hAgsgAi0ABEEPcUUNACAIIAIoAgA2AgAgCCACLQAEOgAEIAYMAQsgByADNgIQIAAgBygCBDYCDCAAIAogCSAIIAIQhgYgBygCFAshAUEAIQYgAQRAIAAgAxCoBiEGIAcoAgBBCGohBAsgAyIBQQRqIQMMbwsgBCABQQ12QfgPcWohBSAEIAFBBHZB+A9xaiEIAkAgBCABQRV2QfgPcWoiCS0ABEEDRgRAIAUtAARBxQBHBEBBACEBDG8LAkACQCAJKAIAIgpBAWsiAiAFKAIAIgEoAggiDE8EQCABLAAGQQBODQEgAkEAIAxrcSAMTw0BIAEgCjYCCAsgASgCDCACQQN0aiEBDAELIAEoAhAgCqwiGEIeiCAYhUK5y5Pn0e2RrL9/fiIYQhuIIBiFQuujxJmxt5LolH9+IhhCH4ggGIWnQX8gAS0AB3RBf3NxQQR0aiEBA0AgAS0ABUEDRgRAIAEoAgwgCkYNAgsgASABKAIIIgJBBHRqIQEgAg0AC0HUsS8hAQsgAS0ABEEPcQ0BDG4LIAUtAARBxQBHBEBBACEBDG4LIAUoAgAgCRCgASIBLQAEQQ9xRQ1tCyAIIAEoAgA2AgAgCCABLQAEOgAEDG0LIAFBGHYhBSAEIAFBBHZB+A9xaiEIQQAhAgJ/AkAgBCABQQ12QfgPcWoiCS0ABEHFAEcNAAJAAkAgBUEBayICIAkoAgAiASgCCCIKTwRAIAEsAAZBAE4NASACQQAgCmtxIApPDQEgASAFNgIICyABKAIMIAJBA3RqIQIMAQsgASgCECAFrUK5y5Pn0e2RrL9/fiIYQhuIIBiFQuujxJmxt5LolH9+IhhCH4ggGIWnQX8gAS0AB3RBf3NxQQR0aiECA0AgAi0ABUEDRgRAIAIoAgwgBUYNAgsgAiACKAIIIgFBBHRqIQIgAQ0AC0HUsS8hAgsgAi0ABEEPcUUNACAIIAIoAgA2AgAgCCACLQAEOgAEIAYMAQsgC0EDOgAQIAsgBTYCDCAHIAM2AhAgACAHKAIENgIMIAAgCSALQQxqIAggAhCGBiAHKAIUCyEBQQAhBiABBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwxtCyANIAFBFXZB+A9xaiEJIAQgAUEEdkH4D3FqIQhBACECAn8CQCAEIAFBDXZB+A9xaiIKLQAEQcUARw0AIAooAgAiASgCECAJKAIAIgUoAghBfyABLQAHdEF/c3FBBHRqIQICQANAIAItAAVBxABGBEAgAigCDCAFRg0CCyACIAIoAggiAUEEdGohAiABDQALQdSxLyECCyACLQAEQQ9xRQ0AIAggAigCADYCACAIIAItAAQ6AAQgBgwBCyAHIAM2AhAgACAHKAIENgIMIAAgCiAJIAggAhCGBiAHKAIUCyEBQQAhBiABBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwxsCyABQRV2QfgPcSANIAQgAUGAgAJxG2ohCCANIAFBDXZB+A9xaiEKQQAhAgJ/AkAgECABQQV2QfwHcWooAgAoAggiCS0ABEHFAEcNACAJKAIAIgEoAhAgCigCACIFKAIIQX8gAS0AB3RBf3NxQQR0aiECAkADQCACLQAFQcQARgRAIAIoAgwgBUYNAgsgAiACKAIIIgFBBHRqIQIgAQ0AC0HUsS8hAgsgAi0ABEEPcUUNACACIAgoAgA2AgAgAiAILQAEIgE6AAQgBiABQcAAcUUNARogBiAJKAIAIgEtAAVBIHFFDQEaIAYgCCgCAC0ABUEYcUUNARogACABEIkGIAYMAQsgByADNgIQIAAgBygCBDYCDCAAIAkgCiAIIAIQigYgBygCFAshAUEAIQYgAQRAIAAgAxCoBiEGIAcoAgBBCGohBAsgAyIBQQRqIQMMawsgAUEVdkH4D3EgDSAEIAFBgIACcRtqIQggBCABQQR2QfgPcWohBQJAIAQgAUENdkH4D3FqIgktAARBA0YEQCAFLQAEQcUARwRAQQAhAQxpCwJAAkAgCSgCACIKQQFrIgIgBSgCACIBKAIIIgxPBEAgASwABkEATg0BIAJBACAMa3EgDE8NASABIAo2AggLIAEoAgwgAkEDdGohAQwBCyABKAIQIAqsIhhCHoggGIVCucuT59Htkay/f34iGEIbiCAYhULro8SZsbeS6JR/fiIYQh+IIBiFp0F/IAEtAAd0QX9zcUEEdGohAQNAIAEtAAVBA0YEQCABKAIMIApGDQILIAEgASgCCCICQQR0aiEBIAINAAtB1LEvIQELIAEtAARBD3ENAQxoCyAFLQAEQcUARwRAQQAhAQxoCyAFKAIAIAkQoAEiAS0ABEEPcUUNZwsgASAIKAIANgIAIAEgCC0ABCICOgAEAkAgAkHAAHFFDQAgBSgCACIBLQAFQSBxRQ0AIAgoAgAtAAVBGHFFDQAgACABEIkGCyAGDGcLIAFBFXZB+A9xIA0gBCABQYCAAnEbaiEIIAFBEHZB/wFxIQVBACECAn8CQCAEIAFBBHZB+A9xaiIJLQAEQcUARw0AAkACQCAFQQFrIgIgCSgCACIBKAIIIgpPBEAgASwABkEATg0BIAJBACAKa3EgCk8NASABIAU2AggLIAEoAgwgAkEDdGohAgwBCyABKAIQIAWtQrnLk+fR7ZGsv39+IhhCG4ggGIVC66PEmbG3kuiUf34iGEIfiCAYhadBfyABLQAHdEF/c3FBBHRqIQIDQCACLQAFQQNGBEAgAigCDCAFRg0CCyACIAIoAggiAUEEdGohAiABDQALQdSxLyECCyACLQAEQQ9xRQ0AIAIgCCgCADYCACACIAgtAAQiAToABCAGIAFBwABxRQ0BGiAGIAkoAgAiAS0ABUEgcUUNARogBiAIKAIALQAFQRhxRQ0BGiAAIAEQiQYgBgwBCyALQQM6AAggCyAFNgIEIAcgAzYCECAAIAcoAgQ2AgwgACAJIAtBBGogCCACEIoGIAcoAhQLIQFBACEGIAEEQCAAIAMQqAYhBiAHKAIAQQhqIQQLIAMiAUEEaiEDDGkLIAFBFXZB+A9xIA0gBCABQYCAAnEbaiEIIA0gAUENdkH4D3FqIQpBACECAn8CQCAEIAFBBHZB+A9xaiIJLQAEQcUARw0AIAkoAgAiASgCECAKKAIAIgUoAghBfyABLQAHdEF/c3FBBHRqIQICQANAIAItAAVBxABGBEAgAigCDCAFRg0CCyACIAIoAggiAUEEdGohAiABDQALQdSxLyECCyACLQAEQQ9xRQ0AIAIgCCgCADYCACACIAgtAAQiAToABCAGIAFBwABxRQ0BGiAGIAkoAgAiAS0ABUEgcUUNARogBiAIKAIALQAFQRhxRQ0BGiAAIAEQiQYgBgwBCyAHIAM2AhAgACAHKAIENgIMIAAgCSAKIAggAhCKBiAHKAIUCyEBQQAhBiABBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwxoCyABQRh2IQkgBCABQQR2QfgPcWohCCABQYCAAnEEQCADKAIAQQF0QYD+//8HcSAJciEJCyAAIAhBCGoiDDYCDCAAKAIQIgUoAgRBAEEFQSAgBSgCABECACICRQRAIAAoAhAiAi0AMEEPcQ1BIAItADsNQSAAQQEQkwYgAigCBEEAQQVBICACKAIAEQIAIgJFDUELIAUgBSgCDEEgajYCDCAFLQA4IQogAkEFOgAEIAIgCkEYcToABSACIAUoAkQ2AgAgBSACNgJEIAJCADcCFCACQcSxLzYCECACQgA3AgggAkE/OwEGIAhBxQA6AAQgCCACNgIAIAFBEHZB/wFxIgEgCXIEQCAAIAIgCUEBIAFBAWt0QQAgARsQiAYLIANBBGohAUEAIQIgACgCECgCDEEASgR/IAcgATYCECAAIAw2AgwgABBUIAcoAhQFIAYLBEAgACABEKgGIQIgBygCAEEIaiEECyADQQhqIQMgAiEGDGcLIAFBFXZB+A9xIA0gBCABQYCAAnEbaiIMKAIAIQUgBCABQQR2QfgPcWoiCCAEIAFBDXZB+A9xaiIJKAIAIgo2AgggCCAJLQAEIgI6AAxBACEBAn8CQCACQcUARw0AAkAgBS0ABCIBQQRGBEAgCigCECAFKAIIQX8gCi0AB3RBf3NxQQR0aiEBA0AgAS0ABUHEAEYEQCABKAIMIAVGDQMLIAEgASgCCCICQQR0aiEBIAINAAtB1LEvIQEMAQsgCyAFNgIYIAsgAUHAAHI6ABwgCiALQRhqQQAQhQYhAQsgAS0ABEEPcUUNACAIIAEoAgA2AgAgCCABLQAEOgAEIAYMAQsgByADNgIQIAAgBygCBDYCDCAAIAkgDCAIIAEQhgYgBygCFAshAUEAIQYgAQRAIAAgAxCoBiEGIAcoAgBBCGohBAsgAyIBQQRqIQMMZgsgAUEYdkH/AGshAgJAAn0CQAJAIAQgAUENdkH4D3FqIgUtAAQiCEEDaw4RAAMDAwMDAwMDAwMDAwMDAwEDCyAFKAIAIAJqvgwBCyAFKgIAIAKykgshFSAEIAFBBHZB+A9xaiIBIAg6AAQgASAVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxlCyANIAFBFXZB+A9xaiECAkACQAJ9AkACQAJAIAQgAUENdkH4D3FqIgUtAARBA2sOEQAFBQUFBQUFBQUFBQUFBQUBBQtBAyEIIAUoAgAhBSACLQAEIglBA0cNASACKAIAIAVqviEVDAMLIAItAAQhCSAFKgIADAELIAWyCwJ9AkACQCAJQf8BcUEDaw4RAQQEBAQEBAQEBAQEBAQEBAAECyACKgIADAELIAIoAgCyC5IhFUETIQgLIAQgAUEEdkH4D3FqIgEgCDoABCABIBU4AgAgA0EEaiEDC0EAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDGQLIA0gAUEVdkH4D3FqIQICQAJAAn0CQAJAAkAgBCABQQ12QfgPcWoiBS0ABEEDaw4RAAUFBQUFBQUFBQUFBQUFBQEFC0EDIQggBSgCACEFIAItAAQiCUEDRw0BIAUgAigCAGu+IRUMAwsgAi0ABCEJIAUqAgAMAQsgBbILAn0CQAJAIAlB/wFxQQNrDhEBBAQEBAQEBAQEBAQEBAQEAAQLIAIqAgAMAQsgAigCALILkyEVQRMhCAsgBCABQQR2QfgPcWoiASAIOgAEIAEgFTgCACADQQRqIQMLQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMYwsgDSABQRV2QfgPcWohAgJAAkACfQJAAkACQCAEIAFBDXZB+A9xaiIFLQAEQQNrDhEABQUFBQUFBQUFBQUFBQUFAQULQQMhCCAFKAIAIQUgAi0ABCIJQQNHDQEgAigCACAFbL4hFQwDCyACLQAEIQkgBSoCAAwBCyAFsgsCfQJAAkAgCUH/AXFBA2sOEQEEBAQEBAQEBAQEBAQEBAQABAsgAioCAAwBCyACKAIAsguUIRVBEyEICyAEIAFBBHZB+A9xaiIBIAg6AAQgASAVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxiCyAHIAM2AhAgACAHKAIENgIMIA0gAUEVdkH4D3FqIQICQAJAAkACQAJ9AkACQAJAIAQgAUENdkH4D3FqIgUtAARBA2sOEQAHBwcHBwcHBwcHBwcHBwcBBwsgAi0ABCIIQQNHDQEgAigCACIIQQFqQQFNBEAgCARAQQMhAkMAAAAAIRUMBwsgAEHYhyxBABCXBgALQQMhAiAFKAIAIAhvIgVFBEBDAAAAACEVDAYLIAUgCHNBH3UgCHEgBWq+IRUMBQsgAi0ABCEIIAUqAgAMAQsgBSgCALILAn0CQAJAIAhB/wFxQQNrDhEBBgYGBgYGBgYGBgYGBgYGAAYLIAIqAgAMAQsgAigCALILIhYQRCIVQwAAAABeBEAgFkMAAAAAXQ0BDAILQRMhAiAWQwAAAABeRQ0CIBVDAAAAAF1FDQILIBYgFZIhFQtBEyECCyAEIAFBBHZB+A9xaiIBIAI6AAQgASAVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxhCwJAAn0CQAJAIAQgAUENdkH4D3FqIgItAARBA2sOEQEDAwMDAwMDAwMDAwMDAwMAAwsgAioCAAwBCyACKAIAsgshFQJ9AkACQCANIAFBFXZB+A9xaiICLQAEQQNrDhEBAwMDAwMDAwMDAwMDAwMDAAMLIAIqAgAMAQsgAigCALILIRYgBCABQQR2QfgPcWohASAWQwAAAEBbBH0gFSAVlAUgFSAWENMGCyEVIANBBGohAyABQRM6AAQgASAVOAIAC0EAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDGALAkACfQJAAkAgBCABQQ12QfgPcWoiAi0ABEEDaw4RAQMDAwMDAwMDAwMDAwMDAwADCyACKgIADAELIAIoAgCyCyEVAn0CQAJAIA0gAUEVdkH4D3FqIgItAARBA2sOEQEDAwMDAwMDAwMDAwMDAwMAAwsgAioCAAwBCyACKAIAsgshFiAEIAFBBHZB+A9xaiIBQRM6AAQgASAVIBaVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxfCyAHIAM2AhAgACAHKAIENgIMIA0gAUEVdkH4D3FqIQICQAJ/An0CQAJAAkAgBCABQQ12QfgPcWoiBS0ABEEDaw4RAAUFBQUFBQUFBQUFBQUFBQEFCyAFKAIAIQUgAi0ABCIIQQNHDQECfyACKAIAIgJBAWpBAU0EQCACRQ0/QQAgBWsMAQsgBSACbSIIIAIgBXNBAE4NABogCCAFIAIgCGxHawu+IRVBAwwDCyACLQAEIQggBSoCAAwBCyAFsgsCfQJAAkAgCEH/AXFBA2sOEQEEBAQEBAQEBAQEBAQEBAQABAsgAioCAAwBCyACKAIAsguVjiEVQRMLIQIgBCABQQR2QfgPcWoiASACOgAEIAEgFTgCACADQQRqIQMLQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMXgsgDSABQRV2QfgPcWooAgAhBQJ/An8CQCAEIAFBDXZB+A9xaiICLQAEIghBA0cEQCAIQRNGDQEgAwwDCyACKAIADAELIAMgAioCACIVIBWOIhVcDQEaIAMgFUMAAADPYEUNARogAyAVQwAAAE9dRQ0BGiAV/AALIQIgBCABQQR2QfgPcWoiAUEDOgAEIAEgAiAFcTYCACADQQRqCyEBQQAhAiAGBEAgACABEKgGIQIgBygCAEEIaiEECyABQQRqIQMgAiEGDF0LIA0gAUEVdkH4D3FqKAIAIQUCfwJ/AkAgBCABQQ12QfgPcWoiAi0ABCIIQQNHBEAgCEETRg0BIAMMAwsgAigCAAwBCyADIAIqAgAiFSAVjiIVXA0BGiADIBVDAAAAz2BFDQEaIAMgFUMAAABPXUUNARogFfwACyECIAQgAUEEdkH4D3FqIgFBAzoABCABIAIgBXI2AgAgA0EEagshAUEAIQIgBgRAIAAgARCoBiECIAcoAgBBCGohBAsgAUEEaiEDIAIhBgxcCyANIAFBFXZB+A9xaigCACEFAn8CfwJAIAQgAUENdkH4D3FqIgItAAQiCEEDRwRAIAhBE0YNASADDAMLIAIoAgAMAQsgAyACKgIAIhUgFY4iFVwNARogAyAVQwAAAM9gRQ0BGiADIBVDAAAAT11FDQEaIBX8AAshAiAEIAFBBHZB+A9xaiIBQQM6AAQgASACIAVzNgIAIANBBGoLIQFBACECIAYEQCAAIAEQqAYhAiAHKAIAQQhqIQQLIAFBBGohAyACIQYMWwsCfwJ/AkAgBCABQQ12QfgPcWoiAi0ABCIFQQNHBEAgBUETRg0BIAMMAwsgAigCAAwBCyADIAIqAgAiFSAVjiIVXA0BGiADIBVDAAAAz2BFDQEaIAMgFUMAAABPXUUNARogFfwACyEIQf8AIAFBGHYiCWshBSAEIAFBBHZB+A9xaiICQQM6AAQgAiABQQBIBH8gCCAJQf8Aa3ZBACAFQWFPGwUgCCAFdEEAIAVBH00bCzYCACADQQRqCyEBQQAhAiAGBEAgACABEKgGIQIgBygCAEEIaiEECyABQQRqIQMgAiEGDFoLAn8CfwJAIAQgAUENdkH4D3FqIgItAAQiBUEDRwRAIAVBE0YNASADDAMLIAIoAgAMAQsgAyACKgIAIhUgFY4iFVwNARogAyAVQwAAAM9gRQ0BGiADIBVDAAAAT11FDQEaIBX8AAshAiABQRh2Qf8AayEJIAQgAUEEdkH4D3FqIgVBAzoABCAFAn8gAkEASARAQQAgAkFhSQ0BGiAJQQAgAmt2DAELIAkgAnRBACACQR9NGws2AgAgA0EEagshAUEAIQIgBgRAIAAgARCoBiECIAcoAgBBCGohBAsgAUEEaiEDIAIhBgxZCyAEIAFBFXZB+A9xaiECAkACQAJ9AkACQAJAIAQgAUENdkH4D3FqIgUtAARBA2sOEQAFBQUFBQUFBQUFBQUFBQUBBQtBAyEIIAUoAgAhBSACLQAEIglBA0cNASACKAIAIAVqviEVDAMLIAItAAQhCSAFKgIADAELIAWyCwJ9AkACQCAJQf8BcUEDaw4RAQQEBAQEBAQEBAQEBAQEBAAECyACKgIADAELIAIoAgCyC5IhFUETIQgLIAQgAUEEdkH4D3FqIgEgCDoABCABIBU4AgAgA0EEaiEDC0EAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDFgLIAQgAUEVdkH4D3FqIQICQAJAAn0CQAJAAkAgBCABQQ12QfgPcWoiBS0ABEEDaw4RAAUFBQUFBQUFBQUFBQUFBQEFC0EDIQggBSgCACEFIAItAAQiCUEDRw0BIAUgAigCAGu+IRUMAwsgAi0ABCEJIAUqAgAMAQsgBbILAn0CQAJAIAlB/wFxQQNrDhEBBAQEBAQEBAQEBAQEBAQEAAQLIAIqAgAMAQsgAigCALILkyEVQRMhCAsgBCABQQR2QfgPcWoiASAIOgAEIAEgFTgCACADQQRqIQMLQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMVwsgBCABQRV2QfgPcWohAgJAAkACfQJAAkACQCAEIAFBDXZB+A9xaiIFLQAEQQNrDhEABQUFBQUFBQUFBQUFBQUFAQULQQMhCCAFKAIAIQUgAi0ABCIJQQNHDQEgAigCACAFbL4hFQwDCyACLQAEIQkgBSoCAAwBCyAFsgsCfQJAAkAgCUH/AXFBA2sOEQEEBAQEBAQEBAQEBAQEBAQABAsgAioCAAwBCyACKAIAsguUIRVBEyEICyAEIAFBBHZB+A9xaiIBIAg6AAQgASAVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxWCyAHIAM2AhAgACAHKAIENgIMIAQgAUEVdkH4D3FqIQICQAJAAkACQAJ9AkACQAJAIAQgAUENdkH4D3FqIgUtAARBA2sOEQAHBwcHBwcHBwcHBwcHBwcBBwsgAi0ABCIIQQNHDQEgAigCACIIQQFqQQFNBEAgCARAQQMhAkMAAAAAIRUMBwsgAEHYhyxBABCXBgALQQMhAiAFKAIAIAhvIgVFBEBDAAAAACEVDAYLIAUgCHNBH3UgCHEgBWq+IRUMBQsgAi0ABCEIIAUqAgAMAQsgBSgCALILAn0CQAJAIAhB/wFxQQNrDhEBBgYGBgYGBgYGBgYGBgYGAAYLIAIqAgAMAQsgAigCALILIhYQRCIVQwAAAABeBEAgFkMAAAAAXQ0BDAILQRMhAiAWQwAAAABeRQ0CIBVDAAAAAF1FDQILIBYgFZIhFQtBEyECCyAEIAFBBHZB+A9xaiIBIAI6AAQgASAVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxVCwJAAn0CQAJAIAQgAUENdkH4D3FqIgItAARBA2sOEQEDAwMDAwMDAwMDAwMDAwMAAwsgAioCAAwBCyACKAIAsgshFQJ9AkACQCAEIAFBFXZB+A9xaiICLQAEQQNrDhEBAwMDAwMDAwMDAwMDAwMDAAMLIAIqAgAMAQsgAigCALILIRYgBCABQQR2QfgPcWohASAWQwAAAEBbBH0gFSAVlAUgFSAWENMGCyEVIANBBGohAyABQRM6AAQgASAVOAIAC0EAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDFQLAkACfQJAAkAgBCABQQ12QfgPcWoiAi0ABEEDaw4RAQMDAwMDAwMDAwMDAwMDAwADCyACKgIADAELIAIoAgCyCyEVAn0CQAJAIAQgAUEVdkH4D3FqIgItAARBA2sOEQEDAwMDAwMDAwMDAwMDAwMAAwsgAioCAAwBCyACKAIAsgshFiAEIAFBBHZB+A9xaiIBQRM6AAQgASAVIBaVOAIAIANBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxTCyAHIAM2AhAgACAHKAIENgIMIAQgAUEVdkH4D3FqIQICQAJ/An0CQAJAAkAgBCABQQ12QfgPcWoiBS0ABEEDaw4RAAUFBQUFBQUFBQUFBQUFBQEFCyAFKAIAIQUgAi0ABCIIQQNHDQECfyACKAIAIgJBAWpBAU0EQCACRQ00QQAgBWsMAQsgBSACbSIIIAIgBXNBAE4NABogCCAFIAIgCGxHawu+IRVBAwwDCyACLQAEIQggBSoCAAwBCyAFsgsCfQJAAkAgCEH/AXFBA2sOEQEEBAQEBAQEBAQEBAQEBAQABAsgAioCAAwBCyACKAIAsguVjiEVQRMLIQIgBCABQQR2QfgPcWoiASACOgAEIAEgFTgCACADQQRqIQMLQQAhAiAGBEAgACADEKgGIQIgBygCAEEIaiEECyACIQYgAyIBQQRqIQMMUgsCfwJ/AkAgBCABQQ12QfgPcWoiAi0ABCIFQQNHBEAgBUETRg0BIAMMAwsgAigCAAwBCyADIAIqAgAiFSAVjiIVXA0BGiADIBVDAAAAz2BFDQEaIAMgFUMAAABPXUUNARogFfwACyEFAn8CQCAEIAFBFXZB+A9xaiICLQAEIghBA0cEQCAIQRNGDQEgAwwDCyACKAIADAELIAMgAioCACIVIBWOIhVcDQEaIAMgFUMAAADPYEUNARogAyAVQwAAAE9dRQ0BGiAV/AALIQIgBCABQQR2QfgPcWoiAUEDOgAEIAEgAiAFcTYCACADQQRqCyEBQQAhAiAGBEAgACABEKgGIQIgBygCAEEIaiEECyABQQRqIQMgAiEGDFELAn8CfwJAIAQgAUENdkH4D3FqIgItAAQiBUEDRwRAIAVBE0YNASADDAMLIAIoAgAMAQsgAyACKgIAIhUgFY4iFVwNARogAyAVQwAAAM9gRQ0BGiADIBVDAAAAT11FDQEaIBX8AAshBQJ/AkAgBCABQRV2QfgPcWoiAi0ABCIIQQNHBEAgCEETRg0BIAMMAwsgAigCAAwBCyADIAIqAgAiFSAVjiIVXA0BGiADIBVDAAAAz2BFDQEaIAMgFUMAAABPXUUNARogFfwACyECIAQgAUEEdkH4D3FqIgFBAzoABCABIAIgBXI2AgAgA0EEagshAUEAIQIgBgRAIAAgARCoBiECIAcoAgBBCGohBAsgAUEEaiEDIAIhBgxQCwJ/An8CQCAEIAFBDXZB+A9xaiICLQAEIgVBA0cEQCAFQRNGDQEgAwwDCyACKAIADAELIAMgAioCACIVIBWOIhVcDQEaIAMgFUMAAADPYEUNARogAyAVQwAAAE9dRQ0BGiAV/AALIQUCfwJAIAQgAUEVdkH4D3FqIgItAAQiCEEDRwRAIAhBE0YNASADDAMLIAIoAgAMAQsgAyACKgIAIhUgFY4iFVwNARogAyAVQwAAAM9gRQ0BGiADIBVDAAAAT11FDQEaIBX8AAshAiAEIAFBBHZB+A9xaiIBQQM6AAQgASACIAVzNgIAIANBBGoLIQFBACECIAYEQCAAIAEQqAYhAiAHKAIAQQhqIQQLIAFBBGohAyACIQYMTwsCfwJ/AkAgBCABQQ12QfgPcWoiAi0ABCIFQQNHBEAgBUETRg0BIAMMAwsgAigCAAwBCyADIAIqAgAiFSAVjiIVXA0BGiADIBVDAAAAz2BFDQEaIAMgFUMAAABPXUUNARogFfwACyEIAn8CQCAEIAFBFXZB+A9xaiICLQAEIgVBA0cEQCAFQRNGDQEgAwwDCyACKAIADAELIAMgAioCACIVIBWOIhVcDQEaIAMgFUMAAADPYEUNARogAyAVQwAAAE9dRQ0BGiAV/AALIQUgBCABQQR2QfgPcWoiAkEDOgAEIAICf0EAIAVrIgFBAEgEQCAIIAV2QQAgAUFhTxsMAQsgCCABdEEAIAFBH00bCzYCACADQQRqCyEBQQAhAiAGBEAgACABEKgGIQIgBygCAEEIaiEECyABQQRqIQMgAiEGDE4LAn8CfwJAIAQgAUENdkH4D3FqIgItAAQiBUEDRwRAIAVBE0YNASADDAMLIAIoAgAMAQsgAyACKgIAIhUgFY4iFVwNARogAyAVQwAAAM9gRQ0BGiADIBVDAAAAT11FDQEaIBX8AAshCQJ/AkAgBCABQRV2QfgPcWoiAi0ABCIFQQNHBEAgBUETRg0BIAMMAwsgAigCAAwBCyADIAIqAgAiFSAVjiIVXA0BGiADIBVDAAAAz2BFDQEaIAMgFUMAAABPXUUNARogFfwACyECIAQgAUEEdkH4D3FqIgVBAzoABCAFAn8gAkEASARAQQAgAkFhSQ0BGiAJQQAgAmt2DAELIAkgAnRBACACQR9NGws2AgAgA0EEagshAUEAIQIgBgRAIAAgARCoBiECIAcoAgBBCGohBAsgAUEEaiEDIAIhBgxNCyADQQhrKAIAIQIgByADNgIQIAAgBygCBDYCDCAAIAQgAUEEdkH4D3FqIgYgBCABQQ12QfgPcWoiBSAEIAJBBHZB+A9xaiABQRh2IgEQkQdFBEAgAUETRyABQQ1rQQVPcUUEQCAGLQAEQQ9xQQNGBEAgBS0ABEEPcUEDRg0rCyAAIAYgBUHwtyoQpAYACyAAIAYgBUGNuCoQpAYAC0EAIQYgBygCFARAIAAgAxCoBiEGIAcoAgBBCGohBAsgAyIBQQRqIQMMTAsgA0EIaygCACECIAcgAzYCECAAIAcoAgQ2AgwgC0EDOgAcIAsgAUEQdkH/AXFB/wBrNgIYIAAgBCABQQR2QfgPcWogC0EYaiABQQ92QQFxIAQgAkEEdkH4D3FqIAFBGHYQkgdBACEGIAcoAhQEQCAAIAMQqAYhBiAHKAIAQQhqIQQLIAMiAUEEaiEDDEsLIANBCGsoAgAhAiAHIAM2AhAgACAHKAIENgIMIAAgBCABQQR2QfgPcWogDSABQQ12QfgPcWogAUEPdkEBcSAEIAJBBHZB+A9xaiABQRh2EJIHQQAhBiAHKAIUBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwxKCyAEIAFBBHZB+A9xaiECAn8CQAJAAkAgBCABQQ12QfgPcWoiAS0ABEEDaw4RAAICAgICAgICAgICAgICAgECCyABKAIAIQEgAkEDOgAEIAJBACABazYCACAGDAILIAEqAgAhFSACQRM6AAQgAiAVjDgCACAGDAELIAcgAzYCECAAIAcoAgQ2AgwgACABIAEgAkESEJEHRQ0nIAcoAhQLIQFBACEGIAEEQCAAIAMQqAYhBiAHKAIAQQhqIQQLIAMiAUEEaiEDDEkLIAQgAUEEdkH4D3FqIQIgBCABQQ12QfgPcWoiAS0ABCIFQQNGDSYCQCAFQRNHDQAgASoCACIVIBWOIhVcDQAgFUMAAADPYEUNACAVQwAAAE9dRQ0AIBX8ACEBDEMLIAcgAzYCECAAIAcoAgQ2AgwgACABIAEgAkETEJEHRQRAIAEtAARBD3FBA0YNKCAAIAEgAUHwtyoQpAYACyAHKAIUIQYMQwsgBCABQQR2QfgPcWpBEUEBQREgBCABQQ12QfgPcWotAAQiAUEPcRsgAUEBRhs6AARBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxHCyAHIAM2AhAgACAHKAIENgIMIAAgBCABQQR2QfgPcWogBCABQQ12QfgPcWoQlgdBACEGIAcoAhQEQCAAIAMQqAYhBiAHKAIAQQhqIQQLIAMiAUEEaiEDDEYLIAAgBCABQQR2QfgPcWogAUEQdkH/AXEiAUEDdGo2AgwgByADNgIQIAAgARCYBiAHKAIUIQFBACEGIAAoAhAoAgxBAEoEfyAHIAM2AhAgABBUIAcoAhQFIAELBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwxFCyAHIAM2AhAgACAHKAIENgIMQQAhBiAAIAQgAUEEdkH4D3FqQQBBARBeGiAHKAIUBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwxECyAHIAM2AhAgACAHKAIENgIMIAAgBCABQQR2QfgPcWoQwQZBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwxDCyADIAFBBXZB/P//P3FqIgNB/P//H2shAUEAIQYgBygCFARAIAAgARCoBiEGIAcoAgBBCGohBAsgA0H4//8fayEDDEILIAcgAzYCECAAIAcoAgQ2AgwgACAEIAFBBHZB+A9xaiAEIAFBDXZB+A9xahD8BSEGIAcoAhQhAiABQQ92QQFxIAZHBH8gA0EEagUgBygCFCECIAMgAygCAEEFdkH8//8/cWpB+P//H2sLIQFBACEGIAIEQCAAIAEQqAYhBiAHKAIAQQhqIQQLIAFBBGohAwxBCyAEIAFBDXZB+A9xaiECIAQgAUEEdkH4D3FqIgUtAAQiCEEDRgRAIAItAAQiCEEDRgRAIAUoAgAgAigCAEghAgw7CyAIQQ9xQQNHDTkgAioCACEVIAUoAgAiAkGAgIAIakGAgIAQTQRAIBUgArJeIQIMOwsgAiAVjiIWQwAAgD+SIBYgFSAWXBsiFvwASCAVQwAAAABeIgIgFkMAAABPXRsgAiAWQwAAAM9gGyECDDoLIAhBD3FBA0YNNww4CyAEIAFBDXZB+A9xaiECIAQgAUEEdkH4D3FqIgUtAAQiCEEDRgRAIAItAAQiCEEDRgRAIAUoAgAgAigCAEwhAgw3CyAIQQ9xQQNHDTUgAioCACEVIAUoAgAiAkGAgIAIakGAgIAQTQRAIBUgArJgIQIMNwsgAiAVjiIW/ABMIBVDAAAAAF4iAiAWQwAAAE9dGyACIBZDAAAAz2AbIQIMNgsgCEEPcUEDRg0zDDQLAn9BACAEIAFBBHZB+A9xaiANIAFBDXZB+A9xahD8BSABQQ92QQFxRwRAIANBBGohASAGDAELIAMgAygCAEEFdkH8//8/cWpB+P//H2shASAHKAIUCyEDQQAhBiADBEAgACABEKgGIQYgBygCAEEIaiEECyABQQRqIQMMPgsgAUEQdkH/AXFB/wBrIQICQAJAAn8CQAJAIAQgAUEEdkH4D3FqIgUtAARBA2sOEQADAwMDAwMDAwMDAwMDAwMBAwsgBSgCACACRgwBCyAFKgIAIAKyWwsgAUGAgAJxRXMNAQwxCyABQYCAAnENMAsgBygCFCEGIAMgAygCAEEFdkH8//8/cWpB+P//H2sMMAsgAUEQdkH/AXFB/wBrIQICfwJ/AkACQAJAIAQgAUEEdkH4D3FqIgUtAARBA2sOEQACAgICAgICAgICAgICAgIBAgsgBSgCACACSAwCCyAFKgIAIAKyXQwBCyAHIAM2AhAgACAHKAIEIgY2AgwgC0EDQRMgAUGAgIAISSIIGzoAHCALIAK+IAKyIAgbOAIYIAAgBSALQRhqIAZBFBCRB0UNHiAHKAIUIQYgACgCDC0ABCICQQFHIAJBD3FBAEdxCyABQYCAAnFFc0UEQCADQQRqIQEgBgwBCyADIAMoAgBBBXZB/P//P3FqQfj//x9rIQEgBygCFAshA0EAIQYgAwRAIAAgARCoBiEGIAcoAgBBCGohBAsgAUEEaiEDDDwLIAFBEHZB/wFxQf8AayECAkACQAJAAkAgBCABQQR2QfgPcWoiBS0ABEEDaw4RAAICAgICAgICAgICAgICAgECCyAFKAIAIAJMIQIMAgsgBSoCACACsl8hAgwBCyAHIAM2AhAgACAHKAIENgIMIAtBA0ETIAFBgICACEkiBhs6ABwgCyACviACsiAGGzgCGCAAIAUgC0EYahCTByECIAcoAhQhBgsCfyABQQ92QQFxIAJHBEAgA0EEaiEBIAYMAQsgAyADKAIAQQV2Qfz//z9xakH4//8fayEBIAcoAhQLIQNBACEGIAMEQCAAIAEQqAYhBiAHKAIAQQhqIQQLIAFBBGohAww7CyABQRB2Qf8BcUH/AGshAgJ/An8CQAJAAkAgBCABQQR2QfgPcWoiBS0ABEEDaw4RAAICAgICAgICAgICAgICAgECCyAFKAIAIAJKDAILIAUqAgAgArJeDAELIAcgAzYCECAAIAcoAgQiBjYCDCALQQNBEyABQYCAgAhJIggbOgAcIAsgAr4gArIgCBs4AhggACALQRhqIAUgBkEUEJEHRQ0dIAcoAhQhBiAAKAIMLQAEIgJBAUcgAkEPcUEAR3ELIAFBgIACcUVzRQRAIANBBGohASAGDAELIAMgAygCAEEFdkH8//8/cWpB+P//H2shASAHKAIUCyEDQQAhBiADBEAgACABEKgGIQYgBygCAEEIaiEECyABQQRqIQMMOgsgAUEQdkH/AXFB/wBrIQICQAJAAkACQCAEIAFBBHZB+A9xaiIFLQAEQQNrDhEAAgICAgICAgICAgICAgICAQILIAUoAgAgAk4hAgwCCyAFKgIAIAKyYCECDAELIAcgAzYCECAAIAcoAgQ2AgwgC0EDQRMgAUGAgIAISSIGGzoAHCALIAK+IAKyIAYbOAIYIAAgC0EYaiAFEJMHIQIgBygCFCEGCwJ/IAFBD3ZBAXEgAkcEQCADQQRqIQEgBgwBCyADIAMoAgBBBXZB/P//P3FqQfj//x9rIQEgBygCFAshA0EAIQYgAwRAIAAgARCoBiEGIAcoAgBBCGohBAsgAUEEaiEDDDkLAn8gAUGAgAJxRSAEIAFBBHZB+A9xai0ABCIBQQFHIAFBD3FBAEdxc0UEQCADQQRqIQEgBgwBCyADIAMoAgBBBXZB/P//P3FqQfj//x9rIQEgBygCFAshA0EAIQYgAwRAIAAgARCoBiEGIAcoAgBBCGohBAsgAUEEaiEDDDgLAn8gAUGAgAJxRSAEIAFBDXZB+A9xaiIFLQAEIgJBAUYgAkEPcUVyRwRAIANBBGohASAGDAELIAUoAgAhBiAEIAFBBHZB+A9xaiIBIAI6AAQgASAGNgIAIAMgAygCAEEFdkH8//8/cWpB+P//H2shASAHKAIUCyEDQQAhBiADBEAgACABEKgGIQYgBygCAEEIaiEECyABQQRqIQMMNwsgAUEYdkEBayEGIAQgAUEEdkH4D3FqIQIgAUEQdkH/AXEiAQRAIAAgAiABQQN0ajYCDAsgByADNgIQIAAgAiAGELIGIgENOEEAIQYgBygCFARAIAAgAxCoBiEGIAcoAgBBCGohBAsgAyIBQQRqIQMMNgsgAUEQdkH/AXEhBSABQQR2QfgPcSECQQAhCCABQYCAgAhPBEAgBygCGCABQRh2aiEICyACIARqIQICQCAFBEAgACACIAVBA3RqNgIMDAELIAAoAgwgAmtBA3UhBQsgByADNgIQIAFBgIACcQRAIAAgBBDCBgtBACEDIAUhAQJAA0ACQCACIQYCQAJAIAItAARBP3EiBEEWaw4RBAEBAQEBAQEBAQEBAQEBAQIACyAEQQZGDSoLIANBAWohAyABQQFqIQEgACACELEGIQIMAQsLIAIoAgBBDGohBgsgACACQX8gBigCABCwBiIBQQBIBEAgByEBDDgLIAcgBygCACAIQQN0azYCACAAIAcgARCuBiAHKAIUIQYMAwsgBCABQQd2Qf8BcSIFQQN0aiEGAn8gAUEQdkH/AXEiAgRAIAJBAWsMAQsgACgCDCAGa0EDdQshAiAHIAM2AhACQCABQYCAAnFFDQAgByACNgIcIAcoAgQiAyAAKAIMSwRAIAAgAzYCDAsgACAEQX9BARBeGiAHKAIURQ0AIAcoAgAgBUEDdGpBCGohBgsgAUGAgIAITwRAIAcgBygCACAHKAIYIAFBGHZqQQN0azYCAAsgACAGIAJBA3RqNgIMIAAgByACEK4GIAcoAhQhBgwCCyAAKAJwBEAgACAEIAFBBHZB+A9xajYCDCAHIAM2AhAgACAHQQAQrgZBASEGDAILIAcoAgghASAAIARBCGs2AgwgACABNgIUIAcuASAiAUEATA0BQQAhAiABQf//A3EiA0EDcSIEBEADQCAAIAAoAgwiBUEIajYCDCAFQQA6AAQgAkEBaiICIARHDQALIANB/P8BcSEDCyABQQRJDQEDQCAAIAAoAgwiAUEIajYCDCABQQA6AAQgACAAKAIMIgFBCGo2AgwgAUEAOgAEIAAgACgCDCIBQQhqNgIMIAFBADoABCAAIAAoAgwiAUEIajYCDCABQQA6AAQgA0EFayEBIANBBGshAyABQX5JDQALDAELIAAoAnAEQCAAIAQgAUEEdkH4D3FqQQhqNgIMIAcgAzYCEEEBIQYgACAHQQEQrgYMAQsgBy4BICEDIAAgBygCCDYCFCADRQRAIAAgBEEIazYCDAwBCyAEQQhrIAQgAUEEdkH4D3FqIgEoAgA2AgAgBEEEayABLQAEOgAAIAAgBDYCDCADQQJIDQADQCAAIAAoAgwiAUEIajYCDCABQQA6AAQgA0ECSyEBIANBAWshAyABDQALCyAHLQAiQQRxDR8gBygCCCEHIAYhAwwyCwJ/An8gBCABQQR2QfgPcWoiAi0AFEEDRgRAIAMgAigCCCIGRQ0CGiACIAZBAWs2AgggAiACKAIAIAIoAhBqIgY2AhggAiAGNgIAQQMMAQsgAioCECIWIAIqAgCSIRUgAioCCCEXAkAgFkMAAAAAXgRAIBUgF18NASADDAMLIBUgF2ANACADDAILIAIgFTgCGCACIBU4AgBBEwshBiACIAY6ABwgAyABQQ12Qfz/H3FrCyEBQQAhBiAHKAIUBEAgACABEKgGIQYgBygCAEEIaiEECyABQQRqIQMMMAsgByADNgIQIAAgBygCBDYCDCAEIAFBBHZB+A9xaiICQQhqIQUCQCACLQAEQQNHDQAgAi0AFEEDRw0AIAIoAhAiCEUNEiACKAIAIQkgAkEDOgAcIAIgCTYCGCAJAn8gBSALQRRqQQJBASAIQQBIGxD8AQRAIAsoAhQMAQsCfSACLQAMIgpBE0YEQCAFKgIADAELIApBA0YEQCAFKAIAsgwBCyAKQQ9xQQRHDRUgBSgCACIKQRBqIAtBGGoQwQEhDyAPIAotAAciDEH/AUYEfyAKKAIMBSAMC0EBakcNFSALKAIYIgWyIAW+IAstABxBA0YbC0MAAAAAXgRAIAhBAEgNIUH/////BwwBCyAIQQBKDSBBgICAgHgLIgVMIAUgCUwgCEEAShtBAUcNHwJ/IAhBAEoEQCAFIAlrIgEgCEEBRg0BGiABIAhuDAELIAkgBWtBACAIa24LIQEgAkEDOgAMIAIgATYCCAwgCwJ9IAItAAwiCEETRgRAIAUqAgAMAQsgCEEDRgRAIAUoAgCyDAELIAhBD3FBBEcNFCAFKAIAIghBEGogC0EYahDBASEKIAogCC0AByIJQf8BRgR/IAgoAgwFIAkLQQFqRw0UIAsoAhgiBbIgBb4gCy0AHEEDRhsLIRcgAkEQaiEFAn0gAi0AFCIIQRNGBEAgBSoCAAwBCyAIQQNGBEAgBSgCALIMAQsgCEEPcUEERw0VIAUoAgAiCEEQaiALQRhqEMEBIQogCiAILQAHIglB/wFGBH8gCCgCDAUgCQtBAWpHDRUgCygCGCIFsiAFviALLQAcQQNGGwshFQJ9IAItAAQiBUETRgRAIAIqAgAMAQsgBUEDRgRAIAIoAgCyDAELIAVBD3FBBEcNFiACKAIAIgVBEGogC0EYahDBASEJIAkgBS0AByIIQf8BRgR/IAUoAgwFIAgLQQFqRw0WIAsoAhgiBbIgBb4gCy0AHEEDRhsLIRYgFUMAAAAAWw0WAkAgFUMAAAAAXgRAIBYgF15FDQEMIAsgFiAXXQ0fCyACQRM6ABQgAiAVOAIQIAJBEzoADCACIBc4AgggAkETOgAcIAIgFjgCGCACQRM6AAQgAiAWOAIADB8LIAcgAzYCECAAIAcoAgQ2AgwgACAEIAFBBHZB+A9xakEYahDBBiADIAFBDXZB/P8fcWoiAUEEaiEDIAEoAgAhAQsgBCABQQR2QfgPcWoiAiAC/QACAP0LAiAgAiACKQIQNwIwIAAgAkE4ajYCDCAHIAM2AhAgACACQSBqIAFBGHYQkAYgBygCFCIGBEAgBygCAEEIaiEECyADKAIAIQEgA0EEaiEDCyAEIAFBBHZB+A9xaiICLQAkIgVBD3EEfyACIAU6ABQgAiACKAIgNgIQIAMgAUENdkH8/x9xawUgAwshAUEAIQIgBgRAIAAgARCoBiECIAcoAgBBCGohBAsgAUEEaiEDIAIhBgwsCyABQRh2IQIgBCABQQR2QfgPcWoiCigCACEJAkAgAUEQdkH/AXEiBUUEQCAAKAIMIAprQQN1QQFrIQUMAQsgACAHKAIENgIMCyACIAVqIQIgAUGAgAJxBH8gAygCAEEBdEGA/v//B3EgAmohAiADQQRqBSADCyEBIAkoAgghAwJAIAksAAZBAE4NACADaUECSQ0AIANBAXYgA3IiA0ECdiADciIDQQR2IANyIgNBCHYgA3IiA0EQdiADckEBaiEDCyACIANLBEAgACAJIAIgCSgCFAR/QQEgCS0AB3QFQQALEIgGCyAFQQBKBEADQCAJKAIMIAJBA3RqIghBCGsgCiAFIgNBA3RqIgUoAgA2AgAgCEEEayAFLQAEIgg6AAACQCAIQcAAcUUNACAJLQAFQSBxRQ0AIAUoAgAtAAVBGHFFDQAgACAJEIkGCyACQQFrIQIgA0EBayEFIANBAUoNAAsLQQAhAiAGBEAgACABEKgGIQIgBygCAEEIaiEECyABQQRqIQMgAiEGDCsLIBMoAgwoAjggAUENdkH8/x9xaigCACEFIAcgAzYCECAAIAcoAgQ2AgwgACgCECECIAUoAjwhDkEAIQwgBSgCDCIPQQJ0IgpBEGoiCARAIAIoAgRBAEEGIAggAigCABECACIMRQRAIAAoAhAiCS0AMEEPcQ0UIAktADsNFCAAQQEQkwYgCSgCBEEAQQYgCCAJKAIAEQIAIgxFDRQLIAIgAigCDCAIajYCDAsgBCABQQR2QfgPcWohESACLQA4IQEgDEEGOgAEIAwgAUEYcToABSAMIAIoAkQ2AgAgAiAMNgJEIAwgDzoABiAMQQA2AgwCQCAPRQRAIAwgBTYCDCARQcYAOgAEIBEgDDYCAAwBCyAMQRBqIRJBACEJIAoEQCASQQAgCvwLAAsgDCAFNgIMIBFBxgA6AAQgESAMNgIAIA9BAEwNAANAIA4gCUEDdGoiAS0ABSECAkAgAS0ABARAIAQgAkEDdGohBQJAIBQiCigCACICRQ0AIAIoAggiCCAFSQ0AAkADQCACIQEgBSAIRg0EIAEoAgwiAgRAIAIoAggiCCAFSQ0CDAELCyABQQxqIQoMAQsgAUEMaiEKCyAAQRBqIggoAgAiAigCBEEAQQlBFCACKAIAEQIAIgFFBEAgCCgCACIBLQAwQQ9xDRggAS0AOw0YIABBARCTBiABKAIEQQBBCUEUIAEoAgARAgAiAUUNGAsgAiACKAIMQRRqNgIMIAItADghCCABQQk6AAQgASAIQRhxOgAFIAEgAigCRDYCACACIAE2AkQgCigCACECIAEgCjYCECABIAI2AgwgASAFNgIIIAIEQCACIAFBDGo2AhALIAogATYCACAAKAIsIABHDQEgACAAKAIQIgIoAogBNgIsIAIgADYCiAEMAQsgECACQQJ0aigCACEBCyASIAlBAnRqIAE2AgACQCAMLQAFIgJBIHFFDQAgAS0ABUEYcUUNACAAKAIQIgUtADlBAk0EQCAFIAEQjgYgDC0ABUEGcUUNASABIAEtAAVB+AFxQQJyOgAFDAELIAUtADoNACAMIAUtADhBGHEgAkHHAXFyOgAFCyAJQQFqIgkgD0cNAAsLQQAhAiAAKAIQKAIMQQBKBH8gByADNgIQIAAgEUEIajYCDCAAEFQgBygCFAUgBgsEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwwqCyAHIAM2AhAgACAHKAIEIgU2AgwgBCABQQR2QfgPcWohBiAHKAIYIQICQCABQf///wdLBH8gAUEYdkEBawUgAiAAKAIYIgEgBWtBA3VOBEAgACgCHCEIIAAoAhAoAgxBAEwEfyAIBSAAEFQgACgCGCEBIAAoAhwLIQUgASAFayIJQYG0iRNODRYgAkG/lrECSg0XIAAoAgwgBWtBA3UgAmoiAUHBlrECTg0XIABBwJaxAiAJQQJ1IgUgBUHAlrECThsiBSABIAEgBUgbQQEQqwYaIAAoAhwgBiAIa2ohBgsgACAGIAJBA3RqNgIMIAILIgogAiACIApKGyIOQQBMBEBBACEODAELQQAhAUEAIAJrIQwgDkEBRwRAIA5BAXEhEiAOQf7///8HcSEPA0AgBiABQQN0IgJqIgUgDEEDdCIIIAcoAgBqIAJqIgkoAgA2AgAgBSAJLQAEOgAEIAYgAkEIciICaiIFIAcoAgAgCGogAmoiAigCADYCACAFIAItAAQ6AAQgAUECaiIBIA9HDQALIBJFDQELIAYgAUEDdCIBaiICIAcoAgAgDEEDdGogAWoiASgCADYCACACIAEtAAQ6AAQLAkAgCiAOTA0AQQAhASAKIA4iAmtBB3EiBQRAA0AgBiACQQN0akEAOgAEIAJBAWohAiABQQFqIgEgBUcNAAsLIA4gCmtBeEsNAANAIAYgAkEDdGoiAUEAOgAEIAFBADoADCABQQA6ABQgAUEAOgAcIAFBADoAJCABQQA6ACwgAUEAOgA0IAFBADoAPCACQQhqIgIgCkcNAAsLQQAhBiAHKAIUBEAgACADEKgGIQYgBygCAEEIaiEECyADIgFBBGohAwwpCyAHIAM2AhAgEygCDCEFIAcgAUEHdiIGQf8BcSICQX9zIAAoAgwgBygCAGsiCkEDdWo2AhggBS0ACEEBaiIFIAAoAhgiCCAAKAIMIgRrQQN1TgRAIAggACgCHCIJayIIQYG0iRNODRUgBCAJa0EDdSAFaiIEQcGWsQJODRYgAEHAlrECIAhBAnUiBSAFQcCWsQJOGyIFIAQgBCAFSBtBARCrBhogACgCDCEECyAAIARBCGo2AgwgBCAHKAIAIgUoAgA2AgAgBCAFLQAEOgAEAkACQAJAIAZB/wFxDgICAQALIAZB/gFxIQlBASECQQAhBQNAIAAgACgCDCIEQQhqNgIMIAQgAkEDdCIGIAcoAgBqIggoAgA2AgAgBCAILQAEOgAEIAcoAgAgBmpBADoABCAAIAAoAgwiBEEIajYCDCAEIAZBCGoiBiAHKAIAaiIIKAIANgIAIAQgCC0ABDoABCAHKAIAIAZqQQA6AAQgAkECaiECIAVBAmoiBSAJRw0ACwsgAUGAAXFFDQAgACAAKAIMIgFBCGo2AgwgASACQQN0IgIgBygCAGoiBCgCADYCACABIAQtAAQ6AAQgBygCACACakEAOgAECyAHIAcoAgAgCmoiATYCACAHIAcoAgQgCmo2AgRBACEGIAcoAhQEfyAAQQA2AmQgACgCcEEBcQRAIAcoAgAoAgAoAgwhASAHIAcoAhBBBGo2AhAgACAHLwEiQQN2QQRxQX9BASABLQAGEKkGIAcgBygCEEEEazYCEAsgAEEBNgJkIAAgAxCoBiEGIAcoAgAFIAELQQhqIQQgAyIBQQRqIQMMKAtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwwnCyAAQQQQhAYACyAAQb+oKkEAEJcGAAsgAEG/qCpBABCXBgALIAAgBiAFEKUGAAsgACABIAFBjbgqEKQGAAsgASgCACEBDBsLIAAgASABEKUGAAsgACAFIAtBGGoQpwYACyAAIAtBGGogBRCnBgALIABB2agqQQAQlwYACyAAIAVBuN4pEKMGAAsgACAFQbjeKRCjBgALIAAgBUHfpioQowYACyAAIAJB6fwqEKMGAAsgAEHZqCpBABCXBgALIABBBBCEBgALIABBBBCEBgALIABBBRCEBgALIABBiJixAkEBEKsGGiAAQbW+KUEAEJcGAAsgAEEFEIQGAAsgAEGImLECQQEQqwYaIABBtb4pQQAQlwYACyALQSBqJAAPCyADIAFBDXZB/P8fcWpBBGohAwtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwwPCyACKAIAKAIMIgotAAYhCSAKLQAIIgwgCGsiBCAAKAIYIAAoAgxrQQN1TgRAIAIgACgCHGshAiAAKAIQKAIMQQBKBEAgABBUCyAAIAQQrQYgACgCHCACaiECCyAHIAcoAgAgCEEDdGsiBjYCAAJAIAFBAEwNACABQQFxIQ1BACEEQQEgBWsgA0cEQCABQf7///8HcSEIA0AgBEEDdCIDIAcoAgBqIgYgAiADaiIFKAIANgIAIAYgBS0ABDoABCADQQhyIgMgBygCAGoiBiACIANqIgMoAgA2AgAgBiADLQAEOgAEIARBAmoiBCAIRw0ACyAHKAIAIQYLIA1FDQAgBiAEQQN0IgNqIgQgAiADaiIDKAIANgIAIAQgAy0ABDoABCAHKAIAIQYLIAEgCUwEQANAIAYgAUEDdGpBADoABCABIAlHIQMgAUEBaiEBIAMNAAsgCUEBaiEBCyAHIAYgDEEDdGpBCGo2AgQgByAKKAI0NgIQIAcgBy8BIkEgcjsBIiAAIAYgAUEDdGo2AgwgByEBDBALIANBBGoLIQFBACECIAYEQCAAIAEQqAYhAiAHKAIAQQhqIQQLIAFBBGohAyACIQYMDAsgAi0ABCIIQQ9xQQNHDQAgBSoCACEVIAhBE0YEQCAVIAIqAgBfIQIMAgsgAigCACICQYCAgAhqQYCAgBBNBEAgFSACsl8hAgwCCyACIBWOIhZDAACAP5IgFiAVIBZcGyIW/ABOIBVDAAAAAF0iAiAWQwAAAE9dGyACIBZDAAAAz2AbIQIMAQsgByADNgIQIAAgBygCBDYCDAJ/AkAgBS0ABEEPcUEERw0AIAItAARBD3FBBEcNACACKAIAIQYgBSgCACICLQAHIgVB/wFGBEAgAigCDCEFCyAGLQAHIghB/wFGBEAgBigCDCEICyACQRBqIQIgBkEQaiEGA0ACQAJAIAIgBhCVByIJDQAgAhAnIQkgCCAGECciCkYEQCAFIAlHIQkMAQsgBSAJRw0BQX8hCQsgCUEATAwDCyAIIApBAWoiCmshCCAGIApqIQYgBSAJQQFqIglrIQUgAiAJaiECDAALAAsgACAFIAIQkwcLIQIgBygCFCEGCwJ/IAFBD3ZBAXEgAkcEQCADQQRqIQEgBgwBCyADIAMoAgBBBXZB/P//P3FqQfj//x9rIQEgBygCFAshA0EAIQYgAwRAIAAgARCoBiEGIAcoAgBBCGohBAsgAUEEaiEDDAkLIAItAAQiCEEPcUEDRw0AIAUqAgAhFSAIQRNGBEAgFSACKgIAXSECDAILIAIoAgAiAkGAgIAIakGAgIAQTQRAIBUgArJdIQIMAgsgAiAVjiIW/ABKIBVDAAAAAF0iAiAWQwAAAE9dGyACIBZDAAAAz2AbIQIMAQsgByADNgIQIAAgBygCBDYCDCAAIAUgAhD9BSECIAcoAhQhBgsCfyABQQ92QQFxIAJHBEAgA0EEaiEBIAYMAQsgAyADKAIAQQV2Qfz//z9xakH4//8fayEBIAcoAhQLIQNBACEGIAMEQCAAIAEQqAYhBiAHKAIAQQhqIQQLIAFBBGohAwwGCyACQQM6AAQgAiABQX9zNgIAC0EAIQIgBgRAIAAgAxCoBiECIAcoAgBBCGohBAsgAiEGIAMiAUEEaiEDDAQLIAcgAzYCECAAIAcoAgQ2AgwgACAFIAkgCCABEIoGIAcoAhQLIQFBACEGIAEEQCAAIAMQqAYhBiAHKAIAQQhqIQQLIAMiAUEEaiEDDAILIAcgAzYCECAAIAcoAgQ2AgwgACAFIAkgCCABEIYGIAcoAhQhBgtBACECIAYEQCAAIAMQqAYhAiAHKAIAQQhqIQQLIAIhBiADIgFBBGohAwwACwALAAsAC+kBAQN/IAAoAgwiAiABKAIAIgRBA3RrIQMCQCAALQAGRQRAIANBCGshASAAKAJgQfj/A3FByAFPBEAgACgCGCACa0EHTARAIAAoAhwhAyAAQQAQrQYgACgCHCABIANraiEBCyAAELMGCyAAIAFBfxCyBiIBRQ0BIAFBBDsBIiAAIAEQtAYPCyAAKAIUIQEgAEEAOgAGIAEoAhAhAgJAIAEtACJBAnFFBEAgASACQQRrNgIQIAAgAzYCDCAAIAEQtAYMAQsgACABIAIEfyAAQQEgASgCGCACEQQABSAECxCuBgsgACAAELYGCwvTBQEFfyAAKAIUIgEgAEE0aiIGRwRAA0ACQCABLwEiIgNBAnEEQCADQYAEcQRAIAAgASABKAIcEK4GDAILQQEhBCABIQIgA0EQcQRAAn8gA0EKdkEHcSIERQRAQQEhBCABDAELIAEoAhwhAiAAIANBAXE6AAcgACAEIAAgAiAAKAIcaiAEQQEQXhCCASAAEIMBIAEvASJB/0dxIQMgACgCFAshAiABIANB7/8DcTsBIiAAIAEoAhQ2AlwLIAAoAgwiAyACKAIESwRAIAIgAzYCBAsgACABIAAgBCABKAIYIAEoAhARBAAQrgYMAQsgASgCAEEIaiEEAkACQAJAAkACQAJAAkAgASgCECICQQRrIgUoAgAiA0H/AHFBC2sOPAEBAQEGBgYGBgEGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGAAAAAQEGAQMEBgYCAgIGBgICAgIGBgYGBQYLIAJBCGsoAgAhAyAAIAAoAgwiAkEIayIFNgIMIAQgA0EEdkH4D3FqIgMgBSgCADYCACADIAJBBGstAAA6AAQMBQsgACAAKAIMIgJBCGsiBTYCDCAEIANBBHZB+A9xaiIDIAUoAgA2AgAgAyACQQRrLQAAOgAEDAQLIAAoAgwiAkEEay0AACEEIAAgAkEIazYCDCAEQQ9xRSAEQQFGciEEAkAgAS8BIiICQYDAAHFFBEAgBEEBcyEEDAELIAEgAkH/vwNxOwEiCyADQYCAAnFFIARzDQMgASABKAIQQQRqNgIQDAMLIAAoAgwiAkEYayACQQhrKAIANgIAIAJBFGsgAkEEay0AADoAACAAIAJBEGsiAjYCDCAAIAIgBCADQQR2QfgPcWprQQN1EJgGDAILIAEgBTYCEAwBCyAAIAQgA0EEdkH4D3FqIAEoAhxBA3RqNgIMIAEgASgCEEEEazYCEAsgACABELQGCyAAKAIUIgEgBkcNAAsLC58zAQ5/IwBBEGsiCCQAIAEgACABEJQHIgQgAiAEGzYCTEEAIQQCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkADQCAAKAIEIgIgAigCACIDQQFrNgIAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIDRQ0CIAgoAgwiBUUNAiACIANBAWo2AgQgAiAFQQFrNgIAIAMtAAALIQIgBEH///8HTw0CIAJB/wBxIARBB3RyIQQgAsBBAE4NAAsgASAENgIoQQAhBANAIAAoAgQiAiACKAIAIgNBAWs2AgACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACKAIQIAIoAgwgCEEMaiACKAIIEQQAIgNFDQQgCCgCDCIFRQ0EIAIgA0EBajYCBCACIAVBAWs2AgAgAy0AAAshAiAEQf///wdPDQQgAkH/AHEgBEEHdHIhBCACwEEATg0ACyABIAQ2AiwgACgCBCICIAIoAgAiA0EBayIENgIAAkAgAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAhAwwBCyACKAIQIAIoAgwgCEEMaiACKAIIEQQAIgRFDQUgCCgCDCIDRQ0FIAIgBEEBajYCBCACIANBAWs2AgAgBC0AACEDIAAoAgQiAigCACEECyABIAM6AAYgAiAEQQFrIgM2AgAgAQJ/IAQEQCACIAIoAgQiBEEBajYCBCAELQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiBEUNBiAIKAIMIgNFDQYgAiAEQQFqNgIEIAIgA0EBazYCACAAKAIEIgIoAgAhAyAELQAACzoAByACIANBAWs2AgAgAQJ/IAMEQCACIAIoAgQiBEEBajYCBCAELQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiBEUNByAIKAIMIgNFDQcgAiAEQQFqNgIEIAIgA0EBazYCACAELQAACzoACEEAIQQDQCAAKAIEIgIgAigCACIDQQFrNgIAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIDRQ0JIAgoAgwiBUUNCSACIANBAWo2AgQgAiAFQQFrNgIAIAMtAAALIQIgBEH///8HTw0JIAJB/wBxIARBB3RyIQQgAsBBAE4NAAsgACgCACEDIARB/////wNPDQkCQCAERQRAIAFBADYCFCABQQA2AjQMAQsgAygCECICKAIEQQBBACAEQQJ0IgUgAigCABECACIGRQRAIANBAEEAIAUQgwYiBkUNDAsgAiACKAIMIAVqNgIMIAEgBDYCFCABIAY2AjQgACgCBCICKAIAIQMDQAJAAkAgAwRAIAIoAgQhBwwBCyACKAIQIAIoAgwgCEEMaiACKAIIEQQAIgdFDQEgCCgCDCIDRQ0BIAIgBzYCBCACIAM2AgALIAUgAyADIAVLGyIEBEAgBiAHIAT8CgAACyACIAIoAgAgBGsiAzYCACACIAIoAgQgBGo2AgQgBCAGaiEGIAUgBGsiBQ0BDAILCyAFDQwLA0AgACgCBCICIAIoAgAiBEEBazYCAAJ/IAQEQCACIAIoAgQiBEEBajYCBCAELQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiBEUNDiAIKAIMIgNFDQ4gAiAEQQFqNgIEIAIgA0EBazYCACAELQAACyECIAlB////B08NDiACQf8AcSIDIAlBB3QiBXIhCSACwEEATg0ACyAAKAIAIQogCUH/////AU8NDgJAIAlFBEAgAUEANgIQIAFBADYCMAwBC0EAIQQgCigCECIHKAIEQQBBACAJQQN0IgsgBygCABECACIGRQRAIApBAEEAIAsQgwYiBkUNEQsgByAHKAIMIAtqNgIMIAEgCTYCECABIAY2AjAgAkEHcSEHIAMgBWpBAWtBB08EQCAJIAdrIQMDQCAGIARBA3RqIgJBADoABCACQQA6AAwgAkEAOgAUIAJBADoAHCACQQA6ACQgAkEAOgAsIAJBADoANCACQQA6ADwgBEEIaiIEIANHDQALCyAHBEBBACECA0AgBiAEQQN0akEAOgAEIARBAWohBCACQQFqIgIgB0cNAAsLQQAhCgNAIAEoAjAhAyAAKAIEIgIgAigCACIEQQFrNgIAAn8gBARAIAIgAigCBCIEQQFqNgIEIAQtAAAMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIERQ0TIAgoAgwiBUUNEyACIARBAWo2AgQgAiAFQQFrNgIAIAQtAAALIQIgAyAKQQN0aiELAkACQAJAAkACQCACQf8BcQ4VAwMEAQIEBAQEBAQEBAQEBAQDBAACBAsgACgCBCIDKAIAIQIgCEEIaiEHQQQhBQNAAkAgAgRAIAMoAgQhBgwBCyADKAIQIAMoAgwgCEEMaiADKAIIEQQAIgZFDRkgCCgCDCICRQ0ZIAMgBjYCBCADIAI2AgALIAUgAiACIAVLGyIEBEAgByAGIAT8CgAACyADIAQgBmo2AgQgAyACIARrIgI2AgAgBCAHaiEHIAUgBGsiBQ0ACyALIAgqAgg4AgBBEyECDAILIAAoAgQiAygCACECIAhBCGohB0EEIQUDQAJAIAIEQCADKAIEIQYMAQsgAygCECADKAIMIAhBDGogAygCCBEEACIGRQ0ZIAgoAgwiAkUNGSADIAY2AgQgAyACNgIACyAFIAIgAiAFSxsiBARAIAcgBiAE/AoAAAsgAyAEIAZqNgIEIAMgAiAEayICNgIAIAQgB2ohByAFIARrIgUNAAsgCyAIKAIINgIAQQMhAgwBCyAAIAEQlAciAkUNFyALIAI2AgAgAi0ABEHAAHIhAgsgCyACOgAECyAKQQFqIgogCUcNAAsLQQAhBANAIAAoAgQiAiACKAIAIgNBAWs2AgACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACKAIQIAIoAgwgCEEMaiACKAIIEQQAIgNFDRYgCCgCDCIFRQ0WIAIgA0EBajYCBCACIAVBAWs2AgAgAy0AAAshAiAEQf///wdPDRYgAkH/AHEiBiAEQQd0IgdyIQQgAsBBAE4NAAsgACgCACEKIARB/////wFPDRYCQCAERQRAIAFBADYCDCABQQA2AjwgAUEMaiEQDAELQQAhBSAKKAIQIgkoAgRBAEEAIARBA3QiCyAJKAIAEQIAIgNFBEAgCkEAQQAgCxCDBiIDRQ0ZCyAJIAkoAgwgC2o2AgwgASAENgIMIAEgAzYCPCACQQdxIQkgBiAHakEBa0EHTwRAIANBOGohBiADQTBqIQcgA0EoaiEKIANBIGohCyADQRhqIQwgA0EQaiENIANBCGohDiAEIAlrIQ8DQCADIAVBA3QiAmpBADYCACACIA5qQQA2AgAgAiANakEANgIAIAIgDGpBADYCACACIAtqQQA2AgAgAiAKakEANgIAIAIgB2pBADYCACACIAZqQQA2AgAgBUEIaiIFIA9HDQALCyAJBEBBACECA0AgAyAFQQN0akEANgIAIAVBAWohBSACQQFqIgIgCUcNAAsLIAFBDGohEEEAIQcDQCAAKAIEIgIgAigCACIGQQFrIgU2AgACQCAGBEAgAiACKAIEIgZBAWo2AgQgBi0AACEGDAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiA0UNGyAIKAIMIgVFDRsgAiADQQFqNgIEIAIgBUEBazYCACADLQAAIQYgASgCPCEDIAAoAgQiAigCACEFCyADIAdBA3QiCWogBjoABCACIAVBAWsiBjYCAAJAIAUEQCACIAIoAgQiBUEBajYCBCAFLQAAIQUMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIDRQ0cIAgoAgwiBUUNHCACIANBAWo2AgQgAiAFQQFrNgIAIAMtAAAhBSABKAI8IQMgACgCBCICKAIAIQYLIAMgCWogBToABSACIAZBAWs2AgACQCAGBEAgAiACKAIEIgVBAWo2AgQgBS0AACECDAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiA0UNHSAIKAIMIgVFDR0gAiADQQFqNgIEIAIgBUEBazYCACADLQAAIQIgASgCPCEDCyADIAlqIAI6AAYgB0EBaiIHIARHDQALC0EAIQMDQCADIQQgACgCBCICIAIoAgAiA0EBazYCAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiA0UNHSAIKAIMIgVFDR0gAiADQQFqNgIEIAIgBUEBazYCACADLQAACyECIARB////B08NHSACQf8AcSAEQQd0ciEDIALAQQBODQALIAAoAgAhByADQf////8DTw0dAkAgA0UEQCABQQA2AhwgAUEANgI4DAELQQAhBSAHKAIQIgYoAgRBAEEAIANBAnQiCiAGKAIAEQIAIglFBEAgB0EAQQAgChCDBiIJRQ0gCyAGIAYoAgwgCmo2AgwgASADNgIcIAEgCTYCOCACQf8BcUECdEH8A3EgBEEJdHIiAgRAIAlBACAC/AsACwNAIAAoAgAiBigCECIEKAIEQQBBCkHUACAEKAIAEQIAIgJFBEAgBkEAQQpB1AAQgwYiAkUNIgsgBCAEKAIMQdQAajYCDCAELQA4IQYgAkEKOgAEIAIgBkEYcSIGOgAFIAIgBCgCRDYCACAEIAI2AkQgAkEAOgAIIAJBADsBBiACQQxqQQBBxAD8CwAgBUECdCIEIAEoAjhqIAI2AgACQCABLQAFIgdBIHFFDQAgBkUNAAJAIAAoAgAoAhAiBi0AOUECTQRAIAYgAhCOBiABLQAFQQZxRQ0BIAIgAi0ABUH4AXFBAnI6AAUMAQsgBi0AOg0AIAEgBi0AOEEYcSAHQccBcXI6AAULIAEoAjggBGooAgAhAgsgACACIAEoAkwQtwYgBUEBaiIFIANHDQALC0EAIQIDQCAAKAIEIgQgBCgCACIDQQFrNgIAAn8gAwRAIAQgBCgCBCIDQQFqNgIEIAMtAAAMAQsgBCgCECAEKAIMIAhBDGogBCgCCBEEACIDRQ0iIAgoAgwiBUUNIiAEIANBAWo2AgQgBCAFQQFrNgIAIAMtAAALIQQgAkH///8HTw0iIARB/wBxIAJBB3RyIQIgBMBBAE4NAAsgAkUEQCABQQA2AhggAUEANgJADCQLIAAoAgAiAygCECIEKAIEQQBBACACIAQoAgARAgAiBkUEQCADQQBBACACEIMGIgZFDSMLIAQgBCgCDCACajYCDCABIAI2AhggASAGNgJAIAAoAgQiBCgCACEFA0ACQAJAIAUEQCAEKAIEIQcMAQsgBCgCECAEKAIMIAhBDGogBCgCCBEEACIHRQ0BIAgoAgwiBUUNASAEIAc2AgQgBCAFNgIACyACIAUgAiAFSRsiAwRAIAYgByAD/AoAAAsgBCAEKAIAIANrIgU2AgAgBCAEKAIEIANqNgIEIAMgBmohBiACIANrIgINAQwlCwsgAEGC0yoQvgYACyAAQYLTKhC+BgALIABBor4pEL4GAAsgAEGC0yoQvgYACyAAQaK+KRC+BgALIABBgtMqEL4GAAsgAEGC0yoQvgYACyAAQYLTKhC+BgALIABBgtMqEL4GAAsgAEGivikQvgYACyADENEGAAsgA0EEEIQGAAsgAEGC0yoQvgYACyAAQYLTKhC+BgALIABBor4pEL4GAAsgChDRBgALIApBBBCEBgALIABBgtMqEL4GAAsgAEGC0yoQvgYACyAAQYLTKhC+BgALIABBi+wqEL4GAAsgAEGC0yoQvgYACyAAQaK+KRC+BgALIAoQ0QYACyAKQQQQhAYACyAAQYLTKhC+BgALIABBgtMqEL4GAAsgAEGC0yoQvgYACyAAQYLTKhC+BgALIABBor4pEL4GAAsgBxDRBgALIAdBBBCEBgALIAZBBBCEBgALIABBgtMqEL4GAAsgAEGivikQvgYACyADQQQQhAYAC0EAIQYCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkADQCAAKAIEIgIgAigCACIEQQFrNgIAAn8gBARAIAIgAigCBCIEQQFqNgIEIAQtAAAMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIERQ0CIAgoAgwiA0UNAiACIARBAWo2AgQgAiADQQFrNgIAIAQtAAALIQIgBkH///8HTw0CIAJB/wBxIAZBB3RyIQYgAsBBAE4NAAsgACgCACEEIAZB/////wFPDQICQCAGRQRAIAFBADYCJCABQQA2AkQMAQtBACEHIAQoAhAiAigCBEEAQQAgBkEDdCIDIAIoAgARAgAiBUUEQCAEQQBBACADEIMGIgVFDQULIAIgAigCDCADajYCDCABIAY2AiQgASAFNgJEA0BBACEEA0AgACgCBCICIAIoAgAiA0EBazYCAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiA0UNCCAIKAIMIgVFDQggAiADQQFqNgIEIAIgBUEBazYCACADLQAACyECIARB////B08NCCACQf8AcSAEQQd0ciEEIALAQQBODQALIAdBA3QiCSABKAJEaiAENgIAQQAhBANAIAAoAgQiAiACKAIAIgNBAWs2AgACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACKAIQIAIoAgwgCEEMaiACKAIIEQQAIgNFDQogCCgCDCIFRQ0KIAIgA0EBajYCBCACIAVBAWs2AgAgAy0AAAshAiAEQf///wdPDQogAkH/AHEgBEEHdHIhBCACwEEATg0ACyABKAJEIAlqIAQ2AgQgB0EBaiIHIAZHDQALC0EAIQYDQCAAKAIEIgIgAigCACIEQQFrNgIAAn8gBARAIAIgAigCBCIEQQFqNgIEIAQtAAAMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIERQ0KIAgoAgwiA0UNCiACIARBAWo2AgQgAiADQQFrNgIAIAQtAAALIQIgBkH///8HTw0KIAJB/wBxIgMgBkEHdCIFciEGIALAQQBODQALIAAoAgAhCiAGQdWq1aoBTw0KAkAgBkUEQCABQQA2AiAgAUEANgJIDAELQQAhBCAKKAIQIgkoAgRBAEEAIAZBDGwiCyAJKAIAEQIAIgdFBEAgCkEAQQAgCxCDBiIHRQ0NCyAJIAkoAgwgC2o2AgwgASAGNgIgIAEgBzYCSCACQQdxIQkgAyAFakEBa0EHTwRAIAdB1ABqIQMgB0HIAGohBSAHQTxqIQogB0EwaiELIAdBJGohDCAHQRhqIQ0gB0EMaiEOIAYgCWshDwNAIAcgBEEMbCICakEANgIAIAIgDmpBADYCACACIA1qQQA2AgAgAiAMakEANgIAIAIgC2pBADYCACACIApqQQA2AgAgAiAFakEANgIAIAIgA2pBADYCACAEQQhqIgQgD0cNAAsLIAkEQEEAIQIDQCAHIARBDGxqQQA2AgAgBEEBaiEEIAJBAWoiAiAJRw0ACwtBACEHA0AgACABEJQHIQIgB0EMbCIJIAEoAkhqIAI2AgBBACEEA0AgACgCBCICIAIoAgAiA0EBazYCAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiA0UNECAIKAIMIgVFDRAgAiADQQFqNgIEIAIgBUEBazYCACADLQAACyECIARB////B08NECACQf8AcSAEQQd0ciEEIALAQQBODQALIAEoAkggCWogBDYCBEEAIQQDQCAAKAIEIgIgAigCACIDQQFrNgIAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAigCECACKAIMIAhBDGogAigCCBEEACIDRQ0SIAgoAgwiBUUNEiACIANBAWo2AgQgAiAFQQFrNgIAIAMtAAALIQIgBEH///8HTw0SIAJB/wBxIARBB3RyIQQgAsBBAE4NAAsgASgCSCAJaiAENgIIIAdBAWoiByAGRw0ACwtBACEEA0AgACgCBCICIAIoAgAiA0EBazYCAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIoAhAgAigCDCAIQQxqIAIoAggRBAAiA0UNEiAIKAIMIgVFDRIgAiADQQFqNgIEIAIgBUEBazYCACADLQAACyECIARB////B08NEiACQf8AcSAEQQd0ciEEIALAQQBODQALAkAgBEUNACAQKAIAIgNBAEwNAEEAIQIDQCAAIAEQlAchBCABKAI8IAJBA3RqIAQ2AgAgAkEBaiICIANHDQALCyAIQRBqJAAPCyAAQYLTKhC+BgALIABBor4pEL4GAAsgBBDRBgALIARBBBCEBgALIABBgtMqEL4GAAsgAEGivikQvgYACyAAQYLTKhC+BgALIABBor4pEL4GAAsgAEGC0yoQvgYACyAAQaK+KRC+BgALIAoQ0QYACyAKQQQQhAYACyAAQYLTKhC+BgALIABBor4pEL4GAAsgAEGC0yoQvgYACyAAQaK+KRC+BgALIABBgtMqEL4GAAsgAEGivikQvgYAC+ABAQN/IwBBEGsiCCQAAkACQCADKAIAIgcgAkoEQCABIQcMAQsCQCAFQQF2IAdMBEAgBSAHSg0BIAggBTYCBCAIIAY2AgAgAEHa/CsgCBCXBgALQQQgB0EBdCIFIAVBBEwbIQULIAAoAhAiBigCBCABIAQgB2wiCSAEIAVsIgIgBigCABECACEHAkACQCACRQ0AIAcNACAAIAEgCSACEIMGIgcNAEEAIQcMAQsgBiAGKAIMIAIgCWtqNgIMC0EAIAIgBxsNASADIAU2AgALIAhBEGokACAHDwsgAEEEEIQGAAuGRgEMfyMAQRBrIgskACAAKAIoQQA2AgQCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQANAAkBBoAIhAgJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAAoAgAiA0EBag6AAQ4NDQ0NDQ0NDQ0BAAEBAA0NDQ0NDQ0NDQ0NDQ0NDQ0NDQENCg0NDQ0KDQ0NDQ0CCwcMDAwMDAwMDAwMCQ0FBAYNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NAw0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0IDQsgABCCBwwQCyAAKAIkIgIgAigCACIDQQFrNgIAIAMEQCACIAIoAgQiA0EBajYCBCAAIAMtAAA2AgAMEAtBfyEDAkAgAigCECACKAIMIAtBCGogAigCCBEEACIERQ0AIAsoAggiBUUNACACIARBAWo2AgQgAiAFQQFrNgIAIAQtAAAhAwsgACADNgIADA8LIAAoAiQiAiACKAIAIgNBAWs2AgACQCADBEAgAiACKAIEIgNBAWo2AgQgAy0AACEDDAELQX8hAyACKAIQIAIoAgwgC0EIaiACKAIIEQQAIgRFDQAgCygCCCIFRQ0AIAIgBEEBajYCBCACIAVBAWs2AgAgBC0AACEDCyAAIAM2AgBBLSECIANBLUcNCyAAKAIkIgIgAigCACIDQQFrNgIAAkAgAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAhAwwBC0F/IQMgAigCECACKAIMIAtBCGogAigCCBEEACIERQ0AIAsoAggiBUUNACACIARBAWo2AgQgAiAFQQFrNgIAIAQtAAAhAwsgACADNgIAIANB2wBGBEAgABCDByECIAAoAihBADYCBCACQQFLDQ0gACgCACEDCwNAIANBAWoiAkEOTUEAQQEgAnRBgZABcRsNDyAAKAIkIgIgAigCACIDQQFrNgIAIAMEQCACIAIoAgQiA0EBajYCBCAAIAMtAAAiAzYCAAwBBUF/IQMCQCACKAIQIAIoAgwgC0EIaiACKAIIEQQAIgRFDQAgCygCCCIFRQ0AIAIgBEEBajYCBCACIAVBAWs2AgAgBC0AACEDCyAAIAM2AgAMAQsACwALIAAQgwciAkECTwRAIAAgASACEIQHQaQCIQIMCwsgAgRAQdsAIQIMCwsgAEHHlCpBpAIQgQcACyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCyIDNgIAQT0hAiADQT1HDQkgACgCJCICIAIoAgAiA0EBazYCACAAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAhCFBws2AgBBmQIhAgwJCyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCyIDNgIAQTwhAgJAAkAgA0E8aw4CAQAKCyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCzYCAEGbAiECDAkLQX8hAyAAKAIkIgIgAigCACIEQQFrNgIAAkAgBARAIAIgAigCBCIDQQFqNgIEIAMtAAAhAwwBCyACKAIQIAIoAgwgC0EIaiACKAIIEQQAIgRFDQAgCygCCCIFRQ0AIAIgBEEBajYCBCACIAVBAWs2AgAgBC0AACEDCyAAIAM2AgBBnQIhAgwICyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCyIDNgIAQT4hAgJAAkAgA0E9aw4CAAEJCyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCzYCAEGaAiECDAgLQX8hAyAAKAIkIgIgAigCACIEQQFrNgIAAkAgBARAIAIgAigCBCIDQQFqNgIEIAMtAAAhAwwBCyACKAIQIAIoAgwgC0EIaiACKAIIEQQAIgRFDQAgCygCCCIFRQ0AIAIgBEEBajYCBCACIAVBAWs2AgAgBC0AACEDCyAAIAM2AgBBngIhAgwHCyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCyIDNgIAQS8hAiADQS9HDQYgACgCJCICIAIoAgAiA0EBazYCACAAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAhCFBws2AgBBlgIhAgwGCyAAKAIkIgIgAigCACIDQQFrNgIAIAACfyADBEAgAiACKAIEIgNBAWo2AgQgAy0AAAwBCyACEIUHCyICNgIAIAJBPUcEQEH+ACECDAYLIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLNgIAQZwCIQIMBQsgACgCJCICIAIoAgAiA0EBazYCACAAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAhCFBwsiAzYCAEE6IQIgA0E6Rw0EIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLNgIAQZ8CIQIMBAsCQCAAKAIoIgIoAgQiBkEBaiIJIAIoAggiBE0EQCACKAIAIQUMAQsgBEH/////A08NBiAAKAIgIgcoAhAiBigCBCACKAIAIgggBCAEQQF0IgkgBigCABECACEFAkACQCAERQ0AIAUNACAHIAggBCAJEIMGIgUNAEEAIQUMAQsgBiAEIAYoAgxqNgIMC0EAIAQgBRsNCCACIAk2AgggAiAFNgIAIAIoAgQiBkEBaiEJCyACIAk2AgQgBSAGaiADOgAAQX8hAiAAKAIkIgQgBCgCACIFQQFrNgIAAkAgBQRAIAQgBCgCBCICQQFqNgIEIAItAAAhAgwBCyAEKAIQIAQoAgwgC0EIaiAEKAIIEQQAIgVFDQAgCygCCCIGRQ0AIAQgBUEBajYCBCAEIAZBAWs2AgAgBS0AACECCyAAIAI2AgAgAiADRwRAA0ACQAJAIAJB3ABHBEACQAJAIAJBAWoODwADAwMDAwMDAwMDAQMDAQMLIABB7+wqQaACEIEHAAsgAEHv7CpBpAIQgQcACwJAIAAoAigiAigCBCIGQQFqIgkgAigCCCIETQRAIAIoAgAhBQwBCyAEQf////8DTw0NIAAoAiAiBygCECIGKAIEIAIoAgAiCCAEIARBAXQiCSAGKAIAEQIAIQUCQAJAIARFDQAgBQ0AIAcgCCAEIAkQgwYiBQ0AQQAhBQwBCyAGIAQgBigCDGo2AgwLQQAgBCAFGw0OIAIgCTYCCCACIAU2AgAgAigCBCIGQQFqIQkLIAIgCTYCBCAFIAZqQdwAOgAAIAAoAiQiBCAEKAIAIgJBAWs2AgACQCACBEAgBCAEKAIEIgJBAWo2AgQgAi0AACECDAELQX8hAiAEKAIQIAQoAgwgC0EIaiAEKAIIEQQAIgVFDQAgCygCCCIGRQ0AIAQgBUEBajYCBCAEIAZBAWs2AgAgBS0AACECCyAAIAI2AgBBByEEAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCACQQFqDnwPCgoKCgoKCgoKCgcKCgcKCgoKCgoKCgoKCgoKCgoKCgoKCggKCgoKCAoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoICgoKCgwLCgoKAAoKCgoKCgoBCgoKAgoDBgQKBQoJCgtBDCEEDAsLQQohBAwKC0ENIQQMCQtBCSEEDAgLQQshBAwHCyAAEIYHIQIgABCGByEEIAAoAigiBSAFKAIEQQJrNgIEIAQgAkEEdGohBAwGCwJAIAAoAigiAigCBCIGQQFqIgkgAigCCCIETQRAIAIoAgAhBQwBCyAEQf////8DTw0WIAAoAiAiBygCECIGKAIEIAIoAgAiCCAEIARBAXQiCSAGKAIAEQIAIQUCQAJAIARFDQAgBQ0AIAcgCCAEIAkQgwYiBQ0AQQAhBQwBCyAGIAQgBigCDGo2AgwLQQAgBCAFGw0XIAIgCTYCCCACIAU2AgAgAigCBCIGQQFqIQkLIAIgCTYCBCAFIAZqQfUAOgAAIAAoAiQiAiACKAIAIgRBAWs2AgAgAAJ/IAQEQCACIAIoAgQiBEEBajYCBCAELQAADAELIAIQhQcLIgI2AgAgAkH7AEcEQCACQX9HBEAgACACEIcHIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLNgIACyAAQdmBLEGkAhCBBwALIAAQhgchBSAAKAIAIQJBBCENA0ACQCAAKAIoIgQoAgQiB0EBaiIIIAQoAggiBk0EQCAEKAIAIQkMAQsgBkH/////A08NGSAAKAIgIgooAhAiBygCBCAEKAIAIgwgBiAGQQF0IgggBygCABECACEJAkACQCAGRQ0AIAkNACAKIAwgBiAIEIMGIgkNAEEAIQkMAQsgByAGIAcoAgxqNgIMC0EAIAYgCRsNGiAEIAg2AgggBCAJNgIAIAQoAgQiB0EBaiEICyAEIAg2AgQgByAJaiACOgAAIAAoAiQiBCAEKAIAIgJBAWs2AgACQCACBEAgBCAEKAIEIgJBAWo2AgQgAi0AACECDAELQX8hAiAEKAIQIAQoAgwgC0EIaiAEKAIIEQQAIgZFDQAgCygCCCIJRQ0AIAQgBkEBajYCBCAEIAlBAWs2AgAgBi0AACECCyAAIAI2AgAgAkHRri9qLQAAIgRBEHEEQCAFQYCAgMAATwRAIAJBf0cEQCAAIAIQhwcgACgCJCICIAIoAgAiA0EBazYCACAAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAhCFBws2AgALIABBrZorQaQCEIEHAAsgBUEEdCACQTBrIAJBIHJB1wBrIARBAnEbaiEFIA1BAWohDQwBCwsgAkH9AEcEQCACQX9HBEAgACACEIcHIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLNgIACyAAQc2BLEGkAhCBBwALIAAoAiQiAiACKAIAIgRBAWs2AgAgAAJ/IAQEQCACIAIoAgQiBEEBajYCBCAELQAADAELIAIQhQcLNgIAIAAoAigiAiACKAIEIA1rNgIEQT8hAkEBIQQgBUGAAU8EfwNAIAsgBCIGayAFQT9xQYABcjoAECAEQQFqIQQgBUEGdiIFIAJBAXYiAksNAAsgAkF/c0EBdCAFciEFQQcgBmsFQQcLIAtBCGpqIAU6AAADQCALIARrLQAQIQgCQCAAKAIoIgIoAgQiCUEBaiIHIAIoAggiBU0EQCACKAIAIQYMAQsgBUH/////A08NGyAAKAIgIg0oAhAiCSgCBCACKAIAIgogBSAFQQF0IgcgCSgCABECACEGAkACQCAFRQ0AIAYNACANIAogBSAHEIMGIgYNAEEAIQYMAQsgCSAFIAkoAgxqNgIMC0EAIAUgBhsNHCACIAc2AgggAiAGNgIAIAIoAgQiCUEBaiEHCyACIAc2AgQgBiAJaiAIOgAAIARBAUohAiAEQQFrIQQgAg0ACwwICyAAEIIHQQohBAwFCyACIQQMAwsgACgCKCICIAIoAgRBAWs2AgQgACgCJCICIAIoAgAiBEEBazYCACAAAn8gBARAIAIgAigCBCIEQQFqNgIEIAQtAAAMAQsgAhCFBwsiAjYCACACQdGuL2otAABBCHFFDQUDQAJAAkACQCACQQprDgQAAQEAAQsgABCCByAAKAIAIQIMAQsgACgCJCIEIAQoAgAiAkEBazYCAAJAIAIEQCAEIAQoAgQiAkEBajYCBCACLQAAIQIMAQtBfyECIAQoAhAgBCgCDCALQQhqIAQoAggRBAAiBUUNACALKAIIIgZFDQAgBCAFQQFqNgIEIAQgBkEBazYCACAFLQAAIQILIAAgAjYCAAsgAkHRri9qLQAAQQhxDQALDAULQQAhBCACQdGuL2otAABBAnFFDSNBACENA0ACQCACQdGuL2otAABBAnFFBEAgDSEFDAELAkAgACgCKCIFKAIEIgdBAWoiCCAFKAIIIgZNBEAgBSgCACEJDAELIAZB/////wNPDRogACgCICIKKAIQIgcoAgQgBSgCACIMIAYgBkEBdCIIIAcoAgARAgAhCQJAAkAgBkUNACAJDQAgCiAMIAYgCBCDBiIJDQBBACEJDAELIAcgBiAHKAIMajYCDAtBACAGIAkbDRsgBSAINgIIIAUgCTYCACAFKAIEIgdBAWohCAsgAiAEQQpsaiEGIAUgCDYCBCAHIAlqIAI6AAAgACgCJCIEIAQoAgAiAkEBazYCAAJAIAIEQCAEIAQoAgQiAkEBajYCBCACLQAAIQIMAQtBfyECIAQoAhAgBCgCDCALQQhqIAQoAggRBAAiBUUNACALKAIIIglFDQAgBCAFQQFqNgIEIAQgCUEBazYCACAFLQAAIQILIAZBMGshBCAAIAI2AgBBAyEFIA1BAWoiDUEDRw0BCwsgBEGAAk4EQCACQX9HBEAgACACEIcHIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLNgIACyAAQcOaK0GkAhCBBwALIAAoAigiAiACKAIEIAVrNgIEDAILQQghBAsgACgCJCICIAIoAgAiBUEBazYCAAJAIAUEQCACIAIoAgQiBUEBajYCBCAFLQAAIQUMAQtBfyEFIAIoAhAgAigCDCALQQhqIAIoAggRBAAiBkUNACALKAIIIglFDQAgAiAGQQFqNgIEIAIgCUEBazYCACAGLQAAIQULIAAgBTYCAAsgACgCKCICIAIoAgQiBkEBayIHNgIEAkAgAigCCCIFIAZPBEAgAigCACEJDAELIAVB/////wNPDRcgACgCICIIKAIQIgYoAgQgAigCACINIAUgBUEBdCIHIAYoAgARAgAhCQJAAkAgBUUNACAJDQAgCCANIAUgBxCDBiIJDQBBACEJDAELIAYgBSAGKAIMajYCDAtBACAFIAkbDRggAiAHNgIIIAIgCTYCACACKAIEIgdBAWohBgsgAiAGNgIEIAcgCWogBDoAAAwBCwJAIAAoAigiBCgCBCIJQQFqIgcgBCgCCCIFTQRAIAQoAgAhBgwBCyAFQf////8DTw0YIAAoAiAiCCgCECIJKAIEIAQoAgAiDSAFIAVBAXQiByAJKAIAEQIAIQYCQAJAIAVFDQAgBg0AIAggDSAFIAcQgwYiBg0AQQAhBgwBCyAJIAUgCSgCDGo2AgwLQQAgBSAGGw0ZIAQgBzYCCCAEIAY2AgAgBCgCBCIJQQFqIQcLIAQgBzYCBCAGIAlqIAI6AAAgACgCJCICIAIoAgAiBEEBazYCAAJAIAQEQCACIAIoAgQiBEEBajYCBCAELQAAIQQMAQtBfyEEIAIoAhAgAigCDCALQQhqIAIoAggRBAAiBUUNACALKAIIIgZFDQAgAiAFQQFqNgIEIAIgBkEBazYCACAFLQAAIQQLIAAgBDYCAAsgACgCACICIANHDQALCwJAIAAoAigiAigCBCIGQQFqIgkgAigCCCIETQRAIAIoAgAhBQwBCyAEQf////8DTw0XIAAoAiAiBygCECIGKAIEIAIoAgAiCCAEIARBAXQiCSAGKAIAEQIAIQUCQAJAIARFDQAgBQ0AIAcgCCAEIAkQgwYiBQ0AQQAhBQwBCyAGIAQgBigCDGo2AgwLQQAgBCAFGw0YIAIgCTYCCCACIAU2AgAgAigCBCIGQQFqIQkLIAIgCTYCBCAFIAZqIAM6AABBfyEDIAAoAiQiAiACKAIAIgRBAWs2AgACQCAEBEAgAiACKAIEIgNBAWo2AgQgAy0AACEDDAELIAIoAhAgAigCDCALQQhqIAIoAggRBAAiBEUNACALKAIIIgVFDQAgAiAEQQFqNgIEIAIgBUEBazYCACAELQAAIQMLIAAgAzYCACABIAAgACgCKCICKAIAQQFqIAIoAgRBAmsQ7wY2AgBBpAIhAgwDCwJAIAAoAigiAigCBCIFQQFqIgYgAigCCCIDTQRAIAIoAgAhBAwBCyADQf////8DTw0YIAAoAiAiCSgCECIFKAIEIAIoAgAiByADIANBAXQiBiAFKAIAEQIAIQQCQAJAIANFDQAgBA0AIAkgByADIAYQgwYiBA0AQQAhBAwBCyAFIAMgBSgCDGo2AgwLQQAgAyAEGw0ZIAIgBjYCCCACIAQ2AgAgAigCBCIFQQFqIQYLIAIgBjYCBCAEIAVqQS46AAAgACgCJCICIAIoAgAiA0EBazYCACAAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAhCFBwsiAzYCAEEuIQIgA0EuRgRAIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLIgI2AgAgAkEuRwRAQZcCIQIMBAsgACgCJCICIAIoAgAiA0EBazYCACAAAn8gAwRAIAIgAigCBCIDQQFqNgIEIAMtAAAMAQsgAhCFBws2AgBBmAIhAgwDCyADQdGuL2otAABBAnFFDQILAn8jAEEQayINJAAgACgCACEGAkACQAJAAkACQAJAAkACQAJAAkAgACgCKCIHKAIEIgxBAWoiAyAHKAIIIghNBEAgBygCACEKDAELIAhB/////wNPDQEgACgCICIFKAIQIgwoAgQgBygCACICIAggCEEBdCIDIAwoAgARAgAhCgJAAkAgCEUNACAKDQAgBSACIAggAxCDBiIKDQBBACEKDAELIAwgCCAMKAIMajYCDAtBACAIIAobDQIgByADNgIIIAcgCjYCACAHKAIEIgxBAWohAwsgByADNgIEIAogDGogBjoAAEF/IQggACgCJCIHIAcoAgAiCkEBazYCAAJAIAoEQCAHIAcoAgQiCEEBajYCBCAILQAAIQgMAQsgBygCECAHKAIMIA1BCGogBygCCBEEACIKRQ0AIA0oAggiDEUNACAHIApBAWo2AgQgByAMQQFrNgIAIAotAAAhCAsgACAINgIAQfaoKyEMIAZBMEYEQEHFpypB9qgrIABBl9srEIgHGyEMCwNAIAAgDBCIBwRAIABB9PUrEIgHGgwBCwJAIAAoAgAiBkEuRwRAIAZB0a4vai0AACIHQRBxRQ0BCwJAIAAoAigiBygCBCIDQQFqIgUgBygCCCIITQRAIAcoAgAhCgwBCyAIQf////8DTw0FIAAoAiAiAigCECIDKAIEIAcoAgAiBCAIIAhBAXQiBSADKAIAEQIAIQoCQAJAIAhFDQAgCg0AIAIgBCAIIAUQgwYiCg0AQQAhCgwBCyADIAggAygCDGo2AgwLQQAgCCAKGw0GIAcgBTYCCCAHIAo2AgAgBygCBCIDQQFqIQULIAcgBTYCBCADIApqIAY6AAAgACgCJCIHIAcoAgAiCEEBazYCACAIBEAgByAHKAIEIghBAWo2AgQgACAILQAANgIADAILQX8hCAJAIAcoAhAgBygCDCANQQhqIAcoAggRBAAiCkUNACANKAIIIgZFDQAgByAKQQFqNgIEIAcgBkEBazYCACAKLQAAIQgLIAAgCDYCAAwBCwsgB0EBcQRAAkAgACgCKCIHKAIEIgxBAWoiAyAHKAIIIghNBEAgBygCACEKDAELIAhB/////wNPDQYgACgCICIFKAIQIgwoAgQgBygCACICIAggCEEBdCIDIAwoAgARAgAhCgJAAkAgCEUNACAKDQAgBSACIAggAxCDBiIKDQBBACEKDAELIAwgCCAMKAIMajYCDAtBACAIIAobDQcgByADNgIIIAcgCjYCACAHKAIEIgxBAWohAwsgByADNgIEIAogDGogBjoAAEF/IQggACgCJCIHIAcoAgAiCkEBazYCAAJAIAoEQCAHIAcoAgQiCEEBajYCBCAILQAAIQgMAQsgBygCECAHKAIMIA1BCGogBygCCBEEACIKRQ0AIA0oAggiDEUNACAHIApBAWo2AgQgByAMQQFrNgIAIAotAAAhCAsgACAINgIACwJAIAAoAigiBygCBCIMQQFqIgYgBygCCCIITQRAIAcoAgAhCgwBCyAIQf////8DTw0HIAAoAiAiAygCECIMKAIEIAcoAgAiBSAIIAhBAXQiBiAMKAIAEQIAIQoCQAJAIAhFDQAgCg0AIAMgBSAIIAYQgwYiCg0AQQAhCgwBCyAMIAggDCgCDGo2AgwLQQAgCCAKGw0IIAcgBjYCCCAHIAo2AgAgBygCBCIMQQFqIQYLIAcgBjYCBCAKIAxqQQA6AAAgACgCKCgCACANQQhqEMEBRQ0IIA0tAAwhACABIA0qAgg4AgAgDUEQaiQAQaICQaECIABBA0YbDAkLIABBsOkqQQAQgQcACyAFQQQQhAYACyAAQbDpKkEAEIEHAAsgAkEEEIQGAAsgAEGw6SpBABCBBwALIAVBBBCEBgALIABBsOkqQQAQgQcACyADQQQQhAYACyAAQdCeKkGhAhCBBwALIQIMAQsgA0HRri9qLQAAQQFxBEADQAJAIAAoAigiAigCBCIGQQFqIgkgAigCCCIETQRAIAIoAgAhBQwBCyAEQf////8DTw0aIAAoAiAiBygCECIGKAIEIAIoAgAiCCAEIARBAXQiCSAGKAIAEQIAIQUCQAJAIARFDQAgBQ0AIAcgCCAEIAkQgwYiBQ0AQQAhBQwBCyAGIAQgBigCDGo2AgwLQQAgBCAFGw0bIAIgCTYCCCACIAU2AgAgAigCBCIGQQFqIQkLIAIgCTYCBCAFIAZqIAM6AAAgACgCJCICIAIoAgAiA0EBazYCAAJAIAMEQCACIAIoAgQiA0EBajYCBCADLQAAIQMMAQtBfyEDIAIoAhAgAigCDCALQQhqIAIoAggRBAAiBEUNACALKAIIIgVFDQAgAiAEQQFqNgIEIAIgBUEBazYCACAELQAAIQMLIAAgAzYCACADQdGuL2otAABBA3ENAAsgASAAIAAoAigiAigCACACKAIEEO8GIgA2AgBBowIhAiAALQAEQQRHDQEgAC0ABiIARQ0BIABB/wFqIQIMAQsgACgCJCICIAIoAgAiBEEBazYCACAAAn8gBARAIAIgAigCBCIEQQFqNgIEIAQtAAAMAQsgAhCFBws2AgAgAyECCyALQRBqJAAgAg8LIABBACACEIQHIAAoAihBADYCBAwBCwsgAEGw6SpBABCBBwALIAdBBBCEBgALIABBsOkqQQAQgQcACyAHQQQQhAYACyAAQbDpKkEAEIEHAAsgB0EEEIQGAAsgAEGw6SpBABCBBwALIApBBBCEBgALIABBsOkqQQAQgQcACyANQQQQhAYACyAAQbDpKkEAEIEHAAsgCkEEEIQGAAsgAEGw6SpBABCBBwALIAhBBBCEBgALIABBsOkqQQAQgQcACyAIQQQQhAYACyAAQbDpKkEAEIEHAAsgB0EEEIQGAAsgAEGw6SpBABCBBwALIAlBBBCEBgALIABBsOkqQQAQgQcACyAHQQQQhAYACyACQX9HBEAgACACEIcHIAAoAiQiAiACKAIAIgNBAWs2AgAgAAJ/IAMEQCACIAIoAgQiA0EBajYCBCADLQAADAELIAIQhQcLNgIACyAAQZmlK0GkAhCBBwAL7FkCDX8BfiMAQeAAayIEJAAgACgCBCEKIAAoAiAiASABKAJgQQFqIgI2AmAgAkH4/wNxQcgBTwRAIAEQswYLAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAAoAgwiAUGBAmsOHwQLAgICAgoIAwECBwICAgkFAgICDAICAgICAgICAgYACyABQTtHDQEgACAAKAIENgIIIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMDA4LIAAgACAAQRBqELkGNgIMDA0LIABBEGohBSAAKAIcIQxBfyEJA0AgACgCHCECIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMDAELIAAgACAFELkGNgIMCyAAIARB0ABqQQAQ2gYaAkAgACgCDEGSAkYEQCAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAFELkGIgE2AgwLAn8gAUGBAkYEQCAAKAIEIQcgACgCHCAEQdAAahDbBiAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDAwBCyAAIAAgBRC5BjYCDAtBACEBIARBADoASiAEIAItADI6AEggBCACKAIIKAIwIgMoAhw2AkAgAygCECEDIARBADoASSAEIAM2AkQgAigCDCIDBEAgAy0AD0EARyEBCyAEIAM2AjwgBCABOgBLIAIgBEE8ajYCDCAAKAIgQcLaKkEFEIAGIQggBCgCWCENIAAoAjAiASAAKAIgIAEoAgwgASgCECIGIAFBFGpBEEH//wFB7fkpELgGIgM2AgwgAyAGQQR0aiIDIAc2AgggAyAINgIAIAAoAhwtADIhByADQQA6AA0gAyAHOgAMIAMgDTYCBCABIAZBAWo2AhAgACgCDCIBQTtGBEADQCAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAFELkGIgE2AgwLIAFBO0YNAAsLIAFBgwJrIgFBHU1BAEEBIAF0QYeAgIACcRtFBEAgAigCACIBIAIoAggoAiAgASgCNCACKAIQIAFBFGpBBEH/////A0HtgioQuAYiAzYCNCACIAIoAhAiBkEBajYCECADIAZBAnRqQbj+//8HNgIAIAIgASACKAIIKAIIENwGIAIoAhBBAWsMAgsgAhDdBgwDCyAAKAIcIARB0ABqEN4GQQAhASAEQQA6AEogBCACLQAyOgBIIAQgAigCCCgCMCIDKAIcNgJAIAMoAhAhAyAEQQA6AEkgBCADNgJEIAIoAgwiAwRAIAMtAA9BAEchAQsgBCADNgI8IAQgAToASyACIARBPGo2AgwgBCgCXAshDQNAAkACQCAAKAIMQYMCayIBQR1LDQBBASABdEGHgIiAAnFFBEAgAUEORw0BIAAQugYLIAIQ3QYCQCAAKAIMQYMCa0EBSw0AIAIoAgAiASACKAIIKAIgIAEoAjQgAigCECABQRRqQQRB/////wNB7YIqELgGIgM2AjQgAiACKAIQIgZBAWo2AhAgAyAGQQJ0akG4/v//BzYCACACIAEgAigCCCgCCBDcBiACKAIQIgFFDQAgAUEBayELIAlBf0YEQCALIQkMAQsgAigCACgCNCEGIAkhAQNAIAYgASIDQQJ0aiIHKAIAIghBB3ZB////B2siAUF/RwRAIAEgA2pBAWoiAUF/Rw0BCwsgCyADQX9zaiIBQf///wdqQYCAgBBPDQIgByAIQf8AcSABQQd0ckGA////B2o2AgALIAIgAigCECIBNgIUIAIgDSABQf8BIAEQ3wYMBAsgABC6BgwBCwsgAigCCEHJ6SoQ2QYACyAAQZICELwGAAsgACgCDCIBQYQCRg0ACyABQYMCRw0LIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIA6nIQEMAQsgACAAIAUQuQYiATYCDAsgACgCHCECQQAhAyAEQQA6AEogBCACLQAyOgBIIAQgAigCCCgCMCIFKAIcNgJAIAUoAhAhBSAEQQA6AEkgBCAFNgJEIAIoAgwiBQRAIAUtAA9BAEchAwsgBCAFNgI8IAQgAzoASyACIARBPGo2AgwDQAJAIAFBgwJrIgFBHUsNAEEBIAF0QYeAiIACcUUEQCABQQ5HDQEgABC6BgsgAhDdBgwNCyAAELoGIAAoAgwhAQwACwALIAAoAhwhASAAIARBQGsQ4AYCQAJAIAAoAgxBLGsOEgABAQEBAQEBAQEBAQEBAQEBAAELIARBADYCPCAAIARBPGpBARDhBgwMCyAEKAJAQRJGBEAgASgCACgCNCAEKAJEQQJ0akEBOgADDAwLIABBgY8qENkGAAsgACAAKAIEIgg2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAAQRBqELkGIgE2AgwgACgCBCEICwJAIAFBowJGBEAgACgCHCECIAAgCDYCCCAAKAIQIQMCfyAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCACDAELIAAgACAAQRBqELkGNgIMIAAoAhwLKAIsIgEgACgCMCIGKAIcIgVODQEgBigCGCEHA0AgAyAHIAFBBHRqIgYoAgBHBEAgBSABQQFqIgFHDQEMAwsLIAYtAAwhAQJ/A0BBACABQQBMDQEaIAIoAggoAjAoAgAgAigCKEEEdGogAUEBayIBQQR0aiIDLQAFQQNGDQALIAMtAAZBAWoLIQUgAi0AMiEBAkADQCABQQBMDQEgAigCCCgCMCgCACACKAIoQQR0aiABQQFrIgFBBHRqIgMtAAVBA0YNAAsgBSADLQAGSg0AIAIoAgAiAyACKAIIKAIgIAMoAjQgAigCECADQRRqQQRB/////wNB7YIqELgGIgk2AjQgAiACKAIQIgFBAWo2AhAgCSABQQJ0aiAFQQd0QTZyNgIAIAIgAyACKAIIKAIIENwGIAIoAhAaCyACKAIAIgUgAigCCCgCICAFKAI0IAIoAhAgBUEUakEEQf////8DQe2CKhC4BiIJNgI0IAIgAigCECIBQQFqNgIQIAkgAUECdGpBuP7//wc2AgAgAiAFIAIoAggoAggQ3AYgAiACKAIQQQFrIAYoAgQiAUH/ASABEN8GDAwLIABBowIQvAYACyACKAIAIgEgAigCCCgCICABKAI0IAIoAhAgAUEUakEEQf////8DQe2CKhC4BiIFNgI0IAIgAigCECIGQQFqNgIQIAUgBkECdGpBuP7//wc2AgAgAiABIAIoAggoAggQ3AYgAigCECEGIAAoAjAiASAAKAIgIAEoAgwgASgCECIFIAFBFGpBEEH//wFB7fkpELgGIgI2AgwgAiAFQQR0aiICIAg2AgggAiADNgIAIAAoAhwtADIhAyACQQA6AA0gAiADOgAMIAIgBkEBazYCBCABIAVBAWo2AhAMCgsgACAAKAIEIgU2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDAwBCyAAIAAgAEEQahC5BjYCDAsgACgCIEHC2ipBBRCABiEGIAAoAhwiASgCACICIAEoAggoAiAgAigCNCABKAIQIAJBFGpBBEH/////A0HtgioQuAYiAzYCNCABIAEoAhAiB0EBajYCECADIAdBAnRqQbj+//8HNgIAIAEgAiABKAIIKAIIENwGIAEoAhAhByAAKAIwIgIgACgCICACKAIMIAIoAhAiAyACQRRqQRBB//8BQe35KRC4BiIBNgIMIAEgA0EEdGoiASAFNgIIIAEgBjYCACAAKAIcLQAyIQUgAUEAOgANIAEgBToADCABIAdBAWs2AgQgAiADQQFqNgIQDAkLIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIA6nIQUMAQsgACAAIABBEGoQuQYiBTYCDAsgACgCHCICLQAyIQECfwNAQQAgAUEATA0BGiACKAIIKAIwKAIAIAIoAihBBHRqIAFBAWsiAUEEdGoiAy0ABUEDRg0ACyADLQAGQQFqCyEHQccAIQNBgIAEIQYCQCAFQYMCayIBQR1NQQBBASABdEGHgIiAAnEbDQAgBUE7Rg0AIAAgBEE8ahDiBiEBIAQoAjwiA0F+cUESRgRAIAIoAgAiCSgCNCAEKAJAQQJ0aiILKAIAQf///wdxQYCAgHhyQYCAgAhqIQUCQCADQRJGBEAgCyAFNgIADAELIAsgBUH/gH5xIAItADQiA0EHdHI2AgAgA0EBaiELAkAgCS0ACCADTQRAIANB/gFPDQEgCSALOgAICyACIAs6ADQMAQsgAigCCEGX9CkQ2QYAC0HGACEDQQAhBiAEKAI8QRJHDQEgAUEBRw0BIAIoAgwtAA8NASACKAIAKAI0IAQoAkBBAnRqIgEgASgCAEGAf3FBxQByNgIADAELIAFBAUcEQCACIARBPGoQ4wYgAUEQdEGAgARqIQZBxgAhAwwBC0HIACEDQYCACCEGAn8gAiAEQTxqIgwQ8wYCfwJAIAwoAgBBCEcNACAMQQRqIgUgDCgCCCAMKAIMRg0BGiACLQAyIQsgBSgCACEJAn8DQEEAIAtBAEwNARogAigCCCgCMCgCACACKAIoQQR0aiALQQFrIgtBBHRqIgEtAAVBA0YNAAsgAS0ABkEBagsgCUoNACACIAwgCRD1BiAFKAIADAILIAIgDBDjBiAMQQRqCygCAAshBwsgAigCACIBIAIoAggoAiAgASgCNCACKAIQIAFBFGpBBEH/////A0HtgioQuAYiBTYCNCACIAIoAhAiCEEBajYCECAFIAhBAnRqIAMgB0EHdHIgBnI2AgAgAiABIAIoAggoAggQ3AYgACgCDEE7Rw0IIAAgACgCBDYCCCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDAwJCyAAIAAgAEEQahC5BjYCDAwICyAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAAQRBqELkGIgE2AgwLAkAgAUGjAkYEQCAAIAAoAgQ2AgggAEEQaiECIAAoAhAhAwJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIA6nIQEMAQsgACAAIAIQuQYiATYCDAsgAUGfAkcNASAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACACELkGIgE2AgwLA0AgAUGfAkcgAUE7R3FFBEAgABC6BiAAKAIMIQEMAQsLAkAgACgCHCgCLCICIAAoAjAiBigCHCIFTg0AIAYoAhghBgNAIAMgBiACQQR0aiIHKAIARwRAIAUgAkEBaiICRw0BDAILCyAAKAIgIQEgBCAHKAIINgIkIAQgA0EQajYCICAAIAFB9cIrIARBIGoQoQYQ5AYACyAAIAMgCgJ/IAFBgwJrIgJBHU0EQEEBQQEgAnRBh4CAgAJxDQEaC0EACxDlBhoMCQsgAEGjAhC8BgALIABBnwIQvAYACyAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAAQRBqELkGIgE2AgwLAkACQAJAAkACQAJAAkAgAUGIAkYEQCAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAAQRBqELkGIgE2AgwLIAFBowJHDQEgACgCHCICLQAyIQUgACAAKAIENgIIIAAoAhAhBgJ/IAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIAIMAQsgACAAIABBEGoQuQY2AgwgACgCHAshAyAAKAIwIgEoAgRBAWoiByADKAIoa0HJAU4NAiABIAAoAiAgASgCACAHIAFBCGpBEEH//wNB1oIqELgGIgM2AgAgASABKAIEIgdBAWo2AgQgAyAHQQR0aiIBIAY2AgwgAUEAOgAFIABBARDmBiAAIARBPGpBACAAKAIEEOcGIAIoAgAoAkggAigCCCgCMCgCACACKAIoQQR0aiAFQQR0ai4BCEEMbGogAigCEDYCBAwOCwJ/AkAgAUGjAkYEQCAAQRxqIgkoAgAhAiAAQRBqIQ1BfyEDA0AgACAAKAIENgIIIAAoAhAhBwJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMDAELIAAgACANELkGNgIMCyAAKAIwIgEoAgRBAWoiCCAJKAIAIgYoAihrQckBTg0GIAEgACgCICABKAIAIAggAUEIakEQQf//A0HWgioQuAYiCDYCACABIAEoAgQiCkEBajYCBCAIIApBBHRqIgggBzYCDEEAIQcgCEEAOgAFIAEoAgQgBigCKEF/c2ohBgJAAkAgACgCDEE8RgRAIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIA6nIQEMAQsgACAAIA0QuQYiATYCDAsgAUGjAkcNCiAAIAAoAgQ2AgggACgCECEHAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwgDqchAQwBCyAAIAAgDRC5BiIBNgIMCyABQT5HDQsgB0EQaiEBIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMDAELIAAgACANELkGNgIMCyABQdnNKRCtAQ0BQQEhBwsgAigCCCgCMCgCACACKAIoQQR0aiAGQQR0aiAHOgAFDAELIAFBhYMrEK0BDQogAigCCCgCMCgCACACKAIoQQR0aiAGQQR0akECOgAFIANBf0cNCyAFIAItADJqIQMLIAVBAWohASAAKAIMIgdBLEcEQCAHQT1HDQMgABDoBiAAIARBPGoQ4gYMBAsgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwgDqchBgwBCyAAIAAgDRC5BiIGNgIMCyABIQUgBkGjAkYNAAsLIABBowIQvAYACyAEQQA2AjxBAAshBwJAAkAgASAHRw0AIAIoAggoAjAoAgAgAigCKEEEdGogBkEEdGoiBi0ABUEBRw0AIAYhCQJAIARBPGoiCigCCCAKKAIMRw0AQQEhDAJAAkACfwJAAkACQAJAAkACQCAKKAIAQQFrDgsBAAcJBQQCCQkJAwkLQREhDAwGC0EAIQwMBQsgCSAKKAIEIgo2AgAgCi0ABEHAAHIhDAwECyAJIAIoAggoAjAoAgAgCigCBEEEdGoiCigCADYCACAKLQAEIQwMAwsgCUUNA0EDDAELIAlFDQJBEwshDCAJIAoqAgQ4AgALIAkgDDoABAtBASELCyALRQ0AIAZBAzoABSAAIAUQ5gYgAiACLQAyQQFqOgAyDAELIAAoAhwgASAHIARBPGoQ6QYgACABEOYGCyADQX9GDQ0gAigCDCIBQQE6AA8gAUEBOgANIAJBAToANgJ/AkADQCADQQBMDQEgAigCCCIBKAIwKAIAIAIoAihBBHRqIANBAWsiA0EEdGoiBS0ABUEDRg0ACyAFLQAGQQd0QbcBagwBCyACKAIIIQFBNwshBSACKAIAIgMgASgCICADKAI0IAIoAhAgA0EUakEEQf////8DQe2CKhC4BiIBNgI0IAIgAigCECIGQQFqNgIQIAEgBkECdGogBTYCACACIAMgAigCCCgCCBDcBgwNCyAAQaMCELwGAAsgA0HIAUHWgioQvQYACyAGQcgBQdaCKhC9BgALIABBowIQvAYACyAAQT4QvAYACyAAKAIgIQIgBCABNgIQIAAgAkGZhCwgBEEQahChBhDkBgALIABBnc4pEOQGAAsgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwMAQsgACAAIABBEGoQuQY2AgwLIAAgBEHQAGoQ6gYgAEEQaiEDAkACQAJAAkACQANAAkAgACgCDCIBQS5HBEAgAUE6Rw0EIAAoAhwiAiAEQdAAahDrBiAAIAAoAgQ2AgggACgCFEGgAkYNASAAKQIUIQ4gAEGgAjYCFCAAIA43AgwgDqchAQwDCyAAKAIcIgIgBEHQAGoQ6wYgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwgDqchAQwBCyAAIAAgAxC5BiIBNgIMCyABQaMCRw0EIAAgACgCBDYCCCAAKAIQIQECQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDAwBCyAAIAAgAxC5BjYCDAsgBCABNgJAIARBBzYCPCAEQn83AkQgAiAEQdAAaiAEQTxqEOwGDAELCyAAIAAgAxC5BiIBNgIMCyABQaMCRw0CIAAgACgCBDYCCCAAKAIQIQECQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDAwBCyAAIAAgAxC5BjYCDAsgBCABNgJAIARBBzYCPCAEQn83AkQgAiAEQdAAaiAEQTxqEOwGQQEhBQsgACAEQTxqIAUgChDnBiAAKAIcIQECQAJAAkACQAJAIAQoAlBBCWsOAwECAAQLIAAoAjAoAgAgBCgCVEEEdGpBDGohAgwCCyABKAIIKAIwKAIAIAEoAihBBHRqIAQvAVZBBHRqIgItAAVFDQIgAkEMaiECDAELIAEoAgAoAjwgBCgCVEEDdGoiAi0ABkUNAQsgAigCACICDQMLIAEgBEHQAGogBEE8ahDtBiAAKAIcIgEoAgAiAigCQCABKAIQakEBaywAACIDQYB/RwRAIAEgASgCGCADazYCGCABIAEtADVBAWs6ADUgASACIAoQ3AYMCQsgAUGBAToANSABIAEoAiRBAWs2AiQgASACIAoQ3AYMCAsgAEGjAhC8BgALIABBowIQvAYACyAAKAIgIQEgBCACQRBqNgIAIAAgAUHOhCwgBBChBhDkBgALIAAoAhwiASABKAIQIgY2AhQgBEEBOgBeIAQgAS0AMiIHOgBcIAQgASgCCCgCMCICKAIcIgg2AlQgAigCECEDIARBADoAXSAEIAM2AlhBACECIAEoAgwiBQRAIAUtAA9BAEchAgsgBCAFNgJQIAQgAjoAXyAEIAc6ADggBCACOgA7IARBADsAOSAEIAM2AjQgBCAINgIwIAQgBEHQAGo2AiwgASAEQSxqNgIMIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIA6nIQIMAQsgACAAIABBEGoQuQYiAjYCDAsDQAJAIAJBgwJrIgJBHUsNAEEBIAJ0QYeAiIACcUUEQCACQQ5HDQEgABC6BgsgAEGUAkGQAiAKEO4GIAAgBEE8akEAENoGGiAEKAI8QQFGBEAgBEEDNgI8CyAAKAIcIARBPGoQ3gYgBCgCSCECIAEQ3QYgASAELQA5BH8gASgCACIDIAEoAggoAiAgAygCNCABKAIQIANBFGpBBEH/////A0HtgioQuAYiBTYCNCABIAEoAhAiB0EBajYCECAFIAdBAnRqQbj+//8HNgIAIAEgAyABKAIIKAIIENwGIAEgASgCECIDNgIUIAEgAiADQf8BIAMQ3wYgA0EBayEHIAQtADghAgJ/AkADQCACQQBMDQEgASgCCCIDKAIwKAIAIAEoAihBBHRqIAJBAWsiAkEEdGoiBS0ABUEDRg0ACyAFLQAGQQd0QbYBagwBCyABKAIIIQNBNgshBSABKAIAIgIgAygCICACKAI0IAEoAhAgAkEUakEEQf////8DQe2CKhC4BiIDNgI0IAEgASgCECIIQQFqNgIQIAMgCEECdGogBTYCACABIAIgASgCCCgCCBDcBiABKAIAIgIgASgCCCgCICACKAI0IAEoAhAgAkEUakEEQf////8DQe2CKhC4BiIDNgI0IAEgASgCECIFQQFqNgIQIAMgBUECdGpBuP7//wc2AgAgASACIAEoAggoAggQ3AYgASABKAIQIgI2AhQgASAHIAJB/wEgAhDfBiACQQFrBSACCyAGQf8BIAYQ3wYgARDdBgwGCyAAELoGIAAoAgwhAgwACwALIAAoAhwhDSAEQQE6AF4gBCANLQAyOgBcIAQgDSgCCCgCMCIBKAIcNgJUIAEoAhAhAkEAIQEgBEEAOgBdIAQgAjYCWCANKAIMIgIEQCACLQAPQQBHIQELIAQgAjYCUCAEIAE6AF8gDSAEQdAAajYCDCAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAAQRBqELkGIgE2AgwLAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCABQaMCRgRAIAAgACgCBDYCCCAAQRBqIQcgACgCECECAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwgDqchAQwBCyAAIAAgBxC5BiIBNgIMCwJAAkACQCABQSxrDhIKAgICAgICAgICAgICAgICAgABCyAAQRxqIgMoAgAiBS0ANCELIABBhfwrQQsQ7wYhBiAAKAIwIgEoAgRBAWoiCCADKAIAIgkoAihrQckBTg0DIAEgACgCICABKAIAIAggAUEIakEQQf//A0HWgioQuAYiCDYCACABIAEoAgQiCUEBajYCBCAIIAlBBHRqIgEgBjYCDCABQQA6AAUgAEGF/CtBCxDvBiEGIAAoAjAiASgCBEEBaiIIIAMoAgAiAygCKGtByQFODQQgASAAKAIgIAEoAgAgCCABQQhqQRBB//8DQdaCKhC4BiIDNgIAIAEgASgCBCIIQQFqNgIEIAMgCEEEdGoiASAGNgIMIAFBADoABSAAQYX8K0ELEO8GIQMgACgCMCIBKAIEQQFqIgYgAEEcaiIIKAIAIgkoAihrQckBTg0FIAEgACgCICABKAIAIAYgAUEIakEQQf//A0HWgioQuAYiBjYCACABIAEoAgQiCUEBajYCBCAGIAlBBHRqIgEgAzYCDCABQQA6AAUgACgCMCIBKAIEQQFqIgMgCCgCACIGKAIoa0HJAU4NBiABIAAoAiAgASgCACADIAFBCGpBEEH//wNB1oIqELgGIgM2AgAgASABKAIEIgZBAWo2AgQgAyAGQQR0aiIBIAI2AgwgAUEAOgAFIAAoAgxBPUcNByAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDAwBCyAAIAAgBxC5BjYCDAsgACAEQTxqQQAQ2gYaIAAoAhwgBEE8ahDjBiAAKAIMQSxHDQggACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwMAQsgACAAIAcQuQY2AgwLIAAgBEE8akEAENoGGiAAQRxqIgEoAgAgBEE8ahDjBgJAIAAoAgxBLEYEQCAAEOgGIAAgBEE8akEAENoGGiABKAIAIARBPGoQ4wYMAQsgBSAFLQA0QQEQ8AYCQAJAIAUtADRBAWoiASAFKAIAIgItAAhKBEAgAUH/AU8NASACIAE6AAgLIAUgAToANAwBCyAFKAIIQZf0KRDZBgALCyAAQQMQ5gYgACALIApBAUEAEPEGDAoLIAFBiwJGDQgLIABB27crENkGAAsgAEGjAhC8BgALIAlByAFB1oIqEL0GAAsgA0HIAUHWgioQvQYACyAJQcgBQdaCKhC9BgALIAZByAFB1oIqEL0GAAsgAEE9ELwGAAsgAEEsELwGAAsgAEEcaiIDKAIAIgktADQhCyAAQYX8K0ELEO8GIQUgACgCMCIBKAIEQQFqIgYgAygCACIIKAIoa0HJAU4NASABIAAoAiAgASgCACAGIAFBCGpBEEH//wNB1oIqELgGIgY2AgAgASABKAIEIghBAWo2AgQgBiAIQQR0aiIBIAU2AgwgAUEAOgAFIABBhfwrQQsQ7wYhBSAAKAIwIgEoAgRBAWoiBiADKAIAIgMoAihrQckBTg0CIAEgACgCICABKAIAIAYgAUEIakEQQf//A0HWgioQuAYiAzYCACABIAEoAgQiBkEBajYCBCADIAZBBHRqIgEgBTYCDCABQQA6AAUgAEGF/CtBCxDvBiEDIAAoAjAiASgCBEEBaiIFIABBHGoiBigCACIIKAIoa0HJAU4NAyABIAAoAiAgASgCACAFIAFBCGpBEEH//wNB1oIqELgGIgU2AgAgASABKAIEIghBAWo2AgQgBSAIQQR0aiIBIAM2AgwgAUEAOgAFIABBhfwrQQsQ7wYhAyAAKAIwIgEoAgRBAWoiBSAGKAIAIgYoAihrQckBTg0EIAEgACgCICABKAIAIAUgAUEIakEQQf//A0HWgioQuAYiBjYCAEEBIQUgASABKAIEIghBAWo2AgQgBiAIQQR0aiIBIAM2AgwgAUEAOgAFIAAoAjAiASgCBEEBaiIDIAAoAhwiBigCKGtByQFODQUgASAAKAIgIAEoAgAgAyABQQhqQRBB//8DQdaCKhC4BiIDNgIAIAEgASgCBCIGQQFqNgIEIAMgBkEEdGoiASACNgIMIAFBADoABSAAKAIMIgNBLEYEQEEFIQEgAEEcaiEIA0AgASECIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMIA6nIQEMAQsgACAAIAcQuQYiATYCDAsgAUGjAkcNCCAAIAAoAgQ2AgggACgCECEDAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwMAQsgACAAIAcQuQY2AgwLIAAoAjAiASgCBEEBaiIFIAgoAgAiBigCKGtByQFODQkgASAAKAIgIAEoAgAgBSABQQhqQRBB//8DQdaCKhC4BiIFNgIAIAEgASgCBCIGQQFqNgIEIAUgBkEEdGoiASADNgIMIAFBADoABSACQQFqIQEgACgCDCIDQSxGDQALIAJBA2shBQsgA0GLAkcNCCAAIAAoAgQiAzYCCAJAIAAoAhRBoAJHBEAgACkCFCEOIABBoAI2AhQgACAONwIMDAELIAAgACAHELkGNgIMIAAoAgQhAwsgACAEQTxqQQAQ2gYaQQEhASAAKAIMQSxGBEAgAEEcaiECA0AgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwMAQsgACAAIAcQuQY2AgwLIAIoAgAgBEE8ahDjBiAAIARBPGpBABDaBhogAUEBaiEBIAAoAgxBLEYNAAsLIAAoAhxBBCABIARBPGoQ6QYgAEEEEOYGIAkoAgwiAUEBOgAPIAFBAToADSAJQQE6ADYgCS0ANCIBQQNqIgIgCSgCACIGLQAISwRAIAFB/AFPDQogBiACOgAICyAAIAsgAyAFQQEQ8QYLIABBhQJBhwIgChDuBiANEN0GDAwLIAhByAFB1oIqEL0GAAsgA0HIAUHWgioQvQYACyAIQcgBQdaCKhC9BgALIAZByAFB1oIqEL0GAAsgBkHIAUHWgioQvQYACyAAQaMCELwGAAsgBkHIAUHWgioQvQYACyAAQYsCELwGAAsgCSgCCEGX9CkQ2QYACyAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDiAAQaACNgIUIAAgDjcCDCAOpyEBDAELIAAgACAAQRBqELkGIgE2AgwLIAAoAhwhAiAEQQA6AEogBCACLQAyOgBIIAQgAigCCCgCMCIFKAIcNgJAIAUoAhAhBSAEQQA6AEkgBCAFNgJEIAIoAgwiBQRAIAUtAA9BAEchAwsgBCAFNgI8IAQgAzoASyACIARBPGo2AgwDQAJAIAFBgwJrIgFBHUsNAEEBIAF0QYeAiIACcUUEQCABQQ5HDQEgABC6BgsgAhDdBiAAQYUCQYICIAoQ7gYMBAsgABC6BiAAKAIMIQEMAAsACyAAKAIcIQEgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwMAQsgACAAIABBEGoQuQY2AgwLIAEgASgCECIFNgIUQQAhAiAAIARBPGpBABDaBhogBCgCPEEBRgRAIARBAzYCPAsgACgCHCAEQTxqEN4GIARBAToAXiAEKAJIIQggBCABLQAyOgBcIAQgASgCCCgCMCIDKAIcNgJUIAMoAhAhAyAEQQA6AF0gBCADNgJYIAEoAgwiAwRAIAMtAA9BAEchAgsgBCADNgJQIAQgAjoAXyABIARB0ABqNgIMIAAoAgxBggJGBEAgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQ4gAEGgAjYCFCAAIA43AgwgDqchAgwBCyAAIAAgAEEQahC5BiICNgIMCyAAKAIcIQMgBEEAOgBKIAQgAy0AMjoASCAEIAMoAggoAjAiBygCHDYCQCAHKAIQIQcgBEEAOgBJIAQgBzYCRCADKAIMIgcEQCAHLQAPQQBHIQYLIAQgBzYCPCAEIAY6AEsgAyAEQTxqNgIMA0ACQCACQYMCayICQR1LDQBBASACdEGHgIiAAnFFBEAgAkEORw0BIAAQugYLIAMQ3QYgASgCACICIAEoAggoAiAgAigCNCABKAIQIAJBFGpBBEH/////A0HtgioQuAYiAzYCNCABIAEoAhAiBkEBajYCECADIAZBAnRqQbj+//8HNgIAIAEgAiABKAIIKAIIENwGIAEgASgCEEEBayAFQf8BIAUQ3wYgAEGFAkGVAiAKEO4GIAEQ3QYgASABKAIQIgI2AhQgASAIIAJB/wEgAhDfBgwECyAAELoGIAAoAgwhAgwACwALIABBggIQvAYACyAAQYUCQYoCIAoQ7gYgDCAMKAIQIgE2AhQgDCAJIAFB/wEgARDfBgsgACgCHCICLQAyIQEgAgJ/A0BBACABQQBMDQEaIAIoAggoAjAoAgAgAigCKEEEdGogAUEBayIBQQR0aiIDLQAFQQNGDQALIAMtAAZBAWoLOgA0IAAoAiAiACAAKAJgQQFrNgJgIARB4ABqJAAL8gsBCn8gACgCICEHIAAoAhwiCC0AMiEBIAgoAgAhBAJ/AkADQCABQQBMDQEgCCgCCCIDKAIwKAIAIAgoAihBBHRqIAFBAWsiAUEEdGoiAi0ABUEDRg0ACyACLQAGQQd0QceBBGoMAQsgCCgCCCEDQceABAshASAEIAMoAiAgBCgCNCAIKAIQIARBFGpBBEH/////A0HtgioQuAYiAzYCNCAIIAgoAhAiAkEBajYCECADIAJBAnRqIAE2AgAgCCAEIAgoAggoAggQ3AYgCBDdBgJAAkACQAJAAkACQAJAAkAgCCgCECIBQQBKBEAgCCgCACIKKAI0IQMDQEEAIQICQAJ/AkACQAJAIAMgBiIBQQJ0aiIJKAIAIgVB/wBxQThrDhECBAQEBAQEBAQEBAQEAQEAAAQLIAgtADZFBEAgCi0AB0UNBAsgCSAFQYB/cUHGAHIiBTYCAAsgCC0ANgRAIAkgBUGAgAJyIgU2AgALIAotAAdFDQIgBUH///8HcSAKLQAGQRh0ckGAgIAIagwBCwNAAkAgAyABQQJ0aigCACIFQf8AcUE4Rw0AIAMgASAFQQd2akH+//8HayIBQQJ0aigCACIFQf8AcUE4Rw0AIAEgBUEHdmpB/v//B2shASACQQJqIgJB5ABHDQELCyABIAZBf3NqIgFB////B2pBgICAEE8NBCABQQd0Qbj///8HagshASAJIAE2AgALIAZBAWoiBiAIKAIQIgFIDQALCyAHKAIQIgMoAgQgBCgCNCIJIAQoAhRBAnQiBiABQQJ0IgUgAygCABECACECAkACQCABRQ0AIAINACAHIAkgBiAFEIMGIgINAEEAIQIMAQsgAyADKAIMIAUgBmtqNgIMC0EAIAEgAhsNASAEIAI2AjQgBCABNgIUIAcoAhAiAygCBCAEKAJAIgUgBCgCGCIGIAgoAhAiASADKAIAEQIAIQICQAJAIAFFDQAgAg0AIAcgBSAGIAEQgwYiAg0AQQAhAgwBCyADIAMoAgwgASAGa2o2AgwLQQAgASACGw0CIAQgAjYCQCAEIAE2AhggBygCECIBKAIEIAQoAkQiCSAEKAIkQQN0IgYgCCgCJCIDQQN0IgUgASgCABECACECAkACQCADRQ0AIAINACAHIAkgBiAFEIMGIgINAEEAIQIMAQsgASABKAIMIAUgBmtqNgIMC0EAIAMgAhsNAyAEIAI2AkQgBCADNgIkIAcoAhAiASgCBCAEKAIwIgkgBCgCEEEDdCIGIAgoAhwiA0EDdCIFIAEoAgARAgAhAgJAAkAgA0UNACACDQAgByAJIAYgBRCDBiICDQBBACECDAELIAEgASgCDCAFIAZrajYCDAtBACADIAIbDQQgBCACNgIwIAQgAzYCECAHKAIQIgEoAgQgBCgCOCIJIAQoAhxBAnQiBiAIKAIgIgNBAnQiBSABKAIAEQIAIQICQAJAIANFDQAgAg0AIAcgCSAGIAUQgwYiAg0AQQAhAgwBCyABIAEoAgwgBSAGa2o2AgwLQQAgAyACGw0FIAQgAjYCOCAEIAM2AhwgBygCECIBKAIEIAQoAkgiCiAEKAIgQQxsIgYgCC8BMCICwSIJQQxsIgUgASgCABECACEDAkACQCACRQ0AIAMNACAHIAogBiAFEIMGIgMNAEEAIQMMAQsgASABKAIMIAUgBmtqNgIMC0EAIAIgAxsNBiAEIAM2AkggBCAJNgIgIAcoAhAiASgCBCAEKAI8IgkgBCgCDEEDdCIGIAgtADMiA0EDdCIFIAEoAgARAgAhAgJAAkAgA0UNACACDQAgByAJIAYgBRCDBiICDQBBACECDAELIAEgASgCDCAFIAZrajYCDAtBACADIAIbDQcgBCACNgI8IAQgAzYCDCAAIAgoAgQ2AhwgBygCECgCDEEASgRAIAcQVAsPCyAIKAIIQcnpKhDZBgALIAdBBBCEBgALIAdBBBCEBgALIAdBBBCEBgALIAdBBBCEBgALIAdBBBCEBgALIAdBBBCEBgALIAdBBBCEBgALMQECfyMAQRBrIgIkACAAKAIgIQMgAiAAIAEQ8gY2AgAgACADQcW1KyACEKEGENkGAAttAQR/IwBBIGsiAyQAIAAoAggoAiAhBEHoryohBSADIAAoAgAoAigiBgR/IAMgBjYCECAEQbXCKyADQRBqEKEGBSAFCzYCCCADIAE2AgQgAyACNgIAIARBkYcqIAMQoQYhAyAAKAIIIAMQ2QYAC0ABA38jAEEQayICJAAgACgCACEDIAAoAgghBCACIAE2AgQgAiAENgIAIANB8vgrIAIQoQYaIAAoAgBBAxCEBgAL/hQBCn8jAEEQayIDJAACQAJAIAAoAgxFBEAgASgCTCIEIAJHDQELIANBgAE6AAwgACgCEA0BIAAgACgCACADQQxqQQEgACgCCCAAKAIEEQIANgIQDAELIAAgBBDABgsgASgCKCECA0AgAyAFIgZrIAJB/wBxOgAMIAVBAWohBSACQf8ASyEEIAJBB3YhAiAEDQALIAMgAy0ADEGAAXI6AAxBACEEIAAoAhBFBEAgACAAKAIAIAZBf3MgA2pBDWogBSAAKAIIIAAoAgQRAgAiAjYCECACRSEHCyABKAIsIQIDQCADIAQiBWsgAkH/AHE6AAwgBUEBaiEEIAJB/wBLIQYgAkEHdiECIAYNAAsgAyADLQAMQYABcjoADAJ/AkACQCAHRQ0AIAAgACgCACAFQX9zIANqQQ1qIAQgACgCCCAAKAIEEQIAIgI2AhAgAyABLQAGOgAIIAINACAAIAAoAgAgA0EIakEBIAAoAgggACgCBBECACICNgIQIAMgAS0ABzoACCACRQ0BC0EADAELIAAgACgCACADQQhqQQEgACgCCCAAKAIEEQIAIgI2AhAgAyABLQAIOgAIQQAgAg0AGiAAIAAoAgAgA0EIakEBIAAoAgggACgCBBECACICNgIQIAJFCyEHIAEoAhQhAkEAIQQDQCADIAQiBWsgAkH/AHE6AAwgBUEBaiEEIAJB/wBLIQYgAkEHdiECIAYNAAsgAyADLQAMQYABcjoADAJAIAdFBEBBASEIDAELIAAgACgCACAFQX9zIANqQQ1qIAQgACgCCCAAKAIEEQIAIgg2AhAgCA0AIAEoAhRBAnQiAkUNACAAIAAoAgAgASgCNCACIAAoAgggACgCBBECACIINgIQC0EAIQQgASgCECIHIQIDQCADIAQiBWsgAkH/AHE6AAwgBUEBaiEEIAJB/wBLIQYgAkEHdiECIAYNAAsgAyADLQAMQYABcjoADCAIRQRAIAAgACgCACAFQX9zIANqQQ1qIAQgACgCCCAAKAIEEQIANgIQCyAHQQBKBEBBACECA0AgAyABKAIwIAJBA3RqIgUtAARBP3EiBDoACEEAIQYgACgCEEUEQCAAIAAoAgAgA0EIakEBIAAoAgggACgCBBECACIGNgIQIAZFIQYLAkACQAJAAkAgBEEDaw4SAQIDAwMDAwMDAwMDAwMDAwACAwsgAyAFKgIAOAIIIAZFDQIgACAAKAIAIANBCGpBBCAAKAIIIAAoAgQRAgA2AhAMAgsgAyAFKAIANgIIIAZFDQEgACAAKAIAIANBCGpBBCAAKAIIIAAoAgQRAgA2AhAMAQsgACAFKAIAEMAGCyACQQFqIgIgB0cNAAsLQQAhBCABKAIMIgghAgNAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMIAAoAhAiB0UEQCAAIAAoAgAgBUF/cyADakENaiAEIAAoAgggACgCBBECACIHNgIQCyAIQQBKBEBBACECA0AgAyACQQN0IgQgASgCPGotAAQ6AAgCQCAHDQAgACAAKAIAIANBCGpBASAAKAIIIAAoAgQRAgAiBzYCECADIAEoAjwgBGotAAU6AAggBw0AIAAgACgCACADQQhqQQEgACgCCCAAKAIEEQIAIgc2AhAgAyABKAI8IARqLQAGOgAIIAcNACAAIAAoAgAgA0EIakEBIAAoAgggACgCBBECACIHNgIQCyACQQFqIgIgCEcNAAsLQQAhBCABKAIcIgghAgNAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMIAdFBEAgACAAKAIAIAVBf3MgA2pBDWogBCAAKAIIIAAoAgQRAgA2AhALIAhBAEoEQEEAIQIDQCAAIAEoAjggAkECdGooAgAgASgCTBC/BiACQQFqIgIgCEcNAAsLQQAhBEEAIQggACgCDEUEQCABKAIYIQgLIAghAgNAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMAkAgACgCECIHDQAgACAAKAIAIAVBf3MgA2pBDWogBCAAKAIIIAAoAgQRAgAiBzYCECAIRQ0AIAcNACAAIAAoAgAgASgCQCAIIAAoAgggACgCBBECACIHNgIQC0EAIQQgACgCDEUEQCABKAIkIQkLIAkhAgNAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMIAdFBEAgACAAKAIAIAVBf3MgA2pBDWogBCAAKAIIIAAoAgQRAgAiBzYCEAsgCUEASgRAIANBDWohCkEAIQgDQCABKAJEIgsgCEEDdCIMaigCACECQQAhBANAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMIAcEfyALBSAAIAAoAgAgCiAFQX9zaiAEIAAoAgggACgCBBECACIHNgIQIAEoAkQLIAxqKAIEIQJBACEEA0AgAyAEIgVrIAJB/wBxOgAMIAVBAWohBCACQf8ASyEGIAJBB3YhAiAGDQALIAMgAy0ADEGAAXI6AAwgB0UEQCAAIAAoAgAgCiAFQX9zaiAEIAAoAgggACgCBBECACIHNgIQCyAIQQFqIgggCUcNAAsLQQAhBEEAIQkgACgCDEUEQCABKAIgIQkLIAkhAgNAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMIAdFBEAgACAAKAIAIAVBf3MgA2pBDWogBCAAKAIIIAAoAgQRAgAiBzYCEAsgCUEASgRAIANBDWohCkEAIQgDQCAAIAhBDGwiCyABKAJIaigCABDABiABKAJIIgwgC2ooAgQhAkEAIQQDQCADIAQiBWsgAkH/AHE6AAwgBUEBaiEEIAJB/wBLIQYgAkEHdiECIAYNAAsgAyADLQAMQYABcjoADCAAKAIQIgcEfyAMBSAAIAAoAgAgCiAFQX9zaiAEIAAoAgggACgCBBECACIHNgIQIAEoAkgLIAtqKAIIIQJBACEEA0AgAyAEIgVrIAJB/wBxOgAMIAVBAWohBCACQf8ASyEGIAJBB3YhAiAGDQALIAMgAy0ADEGAAXI6AAwgB0UEQCAAIAAoAgAgCiAFQX9zaiAEIAAoAgggACgCBBECACIHNgIQCyAIQQFqIgggCUcNAAsLQQAhBEEAIQggACgCDEUEQCABKAIMIQgLIAghAgNAIAMgBCIFayACQf8AcToADCAFQQFqIQQgAkH/AEshBiACQQd2IQIgBg0ACyADIAMtAAxBgAFyOgAMIAdFBEAgACAAKAIAIAVBf3MgA2pBDWogBCAAKAIIIAAoAgQRAgA2AhALIAhBAEoEQEEAIQIDQCAAIAEoAjwgAkEDdGooAgAQwAYgAkEBaiICIAhHDQALCyADQRBqJAAL9wEBBn8jAEEQayICJAACQCABRQRAIAJBgAE6AAogACgCEA0BIAAgACgCACACQQpqQQEgACgCCCAAKAIEEQIANgIQDAELIAEtAAciBEH/AUYEQCABKAIMIQQLIARBAWohAwNAIAIgBSIGayADQf8AcToADyAFQQFqIQUgA0H/AEshByADQQd2IQMgBw0ACyACIAItAA9BgAFyOgAPIAAoAhANACAAIAAoAgAgBkF/cyACakEQaiAFIAAoAgggACgCBBECACIDNgIQIARFDQAgAw0AIAAgACgCACABQRBqIAQgACgCCCAAKAIEEQIANgIQCyACQRBqJAALwAQBCn8jAEEQayIGJAACQAJAIAEtAAQiAkEBRg0AIAJBD3EiAkUNACAAKAIQIQMCQAJ/AkACQAJAIAJBBWsOAwACAQILIAEoAgBBGGoMAgsgASgCAEEMagwBCyAAKAIQIAJBAnRqQfwBagsoAgAiAgRAIAIoAhAgAygC+AEiBCgCCEF/IAItAAd0QX9zcUEEdGohAgNAIAItAAVBxABGBEAgAigCDCAERg0DCyACIAIoAggiA0EEdGohAiADDQALQdSxLyECDAELIANBLGohAgsgAi0ABEEPcUUNASABIAAoAiQiAmtBA3UiA0H//wNLBEADQCAAIAJB+P8fajYCJCACQQA7Af7/HyABIAAoAiQiAmtBA3UiA0H//wNLDQALCyABIAM7AQYgACABNgIkCyAGQRBqJAAPCyAGAn8gACgCFCICIQQgASACKAIAa0EDdSEBIAQoAgAhBwJAAkAgBC8BIkECcSIJDQBBACABQQBIDQIaIAcoAgAoAgwiAygCICIKQQBMDQAgBCgCECADKAI0a0ECdSEFIAMoAkghC0EAIQMgASECA0AgCyADQQxsaiIIKAIEIAVODQEgCCgCCCAFTgRAIAJBAWsiAkUNAwsgA0EBaiIDIApHDQALCyAHQQhqIQVBwPYrQbT2KyAJG0EAIAAoAhQgBEYEfyAAQQxqBSAEKAIMCygCACAFa0EDdSABThtBACABQQBKGwwBCyAIKAIAQRBqCyICQeTjKyACGzYCACAAQff8KiAGEJcGAAvwAQEFfwJAIAAoAiAiAkUNACAAQRBqIQYDQCACKAIIIAFJDQEgAigCECACKAIMIgM2AgAgAwRAIAMgAigCEDYCEAsgAiACKAIIIgMoAgAiBTYCDCACIAMtAAQiBDoAECACIAJBDGo2AggCQCACLQAFIgNBGHENACACIANBIHI6AAUgBEHAAHFFDQAgBS0ABUEYcUUNACAGKAIAIgQtADlBAk0EQCAEIAUQjgYgAi0ABUEGcUUNASAFIAUtAAVB+AFxQQJyOgAFDAELIAQtADoNACACIAQtADhBGHEgA0HHAXFyOgAFCyAAKAIgIgINAAsLC64KAQR/AkACQAJAAkACQAJAAkACQAJAAkAgAS0ABEEEaw4jBwQCBgUBAAkJCQkJCQkJCQgJCQkJCQkJCQkJCQkJCQkJCQMJCyAAQRBqIgIoAgAiAygCBCABKAI0IAEoAhRBAnQiBEEAIAMoAgARAgAaIAMgAygCDCAEazYCDCACKAIAIgMoAgQgASgCOCABKAIcQQJ0IgRBACADKAIAEQIAGiADIAMoAgwgBGs2AgwgAigCACIDKAIEIAEoAjAgASgCEEEDdCIEQQAgAygCABECABogAyADKAIMIARrNgIMIAIoAgAiAygCBCABKAJAIAEoAhgiBEEAIAMoAgARAgAaIAMgAygCDCAEazYCDCACKAIAIgMoAgQgASgCRCABKAIkQQN0IgRBACADKAIAEQIAGiADIAMoAgwgBGs2AgwgAigCACIDKAIEIAEoAkggASgCIEEMbCIEQQAgAygCABECABogAyADKAIMIARrNgIMIAIoAgAiAygCBCABKAI8IAEoAgxBA3QiBEEAIAMoAgARAgAaIAMgAygCDCAEazYCDCACKAIAIgIoAgQgAUHUAEEAIAIoAgARAgAaIAIgAigCDEHUAGs2AgwPCwJAIAEoAgggAUEMakYNACABKAIQIAEoAgwiAjYCACACRQ0AIAIgASgCEDYCEAsgACgCECICKAIEIAFBFEEAIAIoAgARAgAaIAIgAigCDEEUazYCDA8LIAAoAhAiAigCBCABIAEtAAZBAnRBEGoiA0EAIAIoAgARAgAaIAIgAigCDCADazYCDA8LIAAoAhAiAigCBCABIAEtAAZBA3RBEGoiA0EAIAIoAgARAgAaIAIgAigCDCADazYCDA8LIAEoAhQEQCAAKAIQIgIoAgQgASgCEEEQIAEtAAd0IgNBACACKAIAEQIAGiACIAIoAgwgA2s2AgwLIAEoAgwhBCABKAIIIQICQCABLAAGQQBODQAgAmlBAkkNACACQQF2IAJyIgJBAnYgAnIiAkEEdiACciICQQh2IAJyIgJBEHYgAnJBAWohAgsgAEEQaiIAKAIAIgMoAgQgBCACQQN0IgJBACADKAIAEQIAGiADIAMoAgwgAms2AgwgACgCACICKAIEIAFBIEEAIAIoAgARAgAaIAIgAigCDEEgazYCDA8LIAEgASgCHBDCBiABKAIcIgIEQCABIAFBNGo2AhQgASgCQCEDIAFBADYCQCADBEAgAUEQaiEFA0AgAygCDCEEIAUoAgAiAigCBCADQSRBACACKAIAEQIAGiACIAIoAgxBJGs2AgwgASABLwEIQQFrOwEIIAQiAw0ACyABKAIcIQILIAEoAhAiAygCBCACIAEoAhggAmtBKGoiBEEAIAMoAgARAgAaIAMgAygCDCAEazYCDAsgACgCECICKAIEIAFBBGtB+ABBACACKAIAEQIAGiACIAIoAgxB+ABrNgIMDwsgACgCECICKAIEIAEgASgCCCABLwEGIgNBA3RBGGpBECADG2oiA0EAIAIoAgARAgAaIAIgAigCDCADazYCDA8LIAAoAhAiACgCGCABKAIIIAAoAiBBAWtxQQJ0aiECA0AgAiIEKAIAIgNBDGohAiABIANHDQALIAQgAigCADYCACAAIAAoAhxBAWs2AhwgACgCBCABIAEtAAdBEWoiAkEAIAAoAgARAgAaIAAgACgCDCACazYCDA8LIAAoAhAiAigCBCABIAEoAgxBEWoiA0EAIAIoAgARAgAaIAIgAigCDCADazYCDAsLrAoBCX8gACgCECIBQQE6ADsCQAJAAkACQAJAAkACQAJAAkACQAJAIAEtADkOCQECCgMEBQYHAAoLIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwJQIAFBADYCYCABKAKQASICLQAFQRhxBEAgASACEI4GCwJAIAEtAChBwABxRQ0AIAEoAiQiAi0ABUEYcUUNACABIAIQjgYLIAEQxwYgASgCZCICBEADQCACLQAFQRhxBEAgASACEI4GCyACKAIAIgINAAsLIAFBADoAOUEBIQIMCAsgASgCUEUEQCABQQE6ADkMBwsgARDIBiECDAcLIAAQxQYhAiAAKAIQIgZBAzoAOSAGQcQAaiIIIQMDQAJAIAMoAgAiBEUEQEEAIQMMAQsCQCAELQAFIgUgACgCEC0AOCIJQRhzcQRAIAMgBCgCADYCACAAIAQQwwYMAQsgBCAFQcABcSAJQRhxcjoABSAEIQMLIANBACADKAIAGyIDIAhGDQELCyAGIAM2AkggASABKAIMIAEoAghqNgIQDAYLIAEoAkgiBQRAIAEoAgwhBwJ/IAUoAgAiA0UEQCAHDAELIAEtADgiAkEYcSEGIAJBGHMhCANAAkAgAy0ABSICIAhxBEAgBSADKAIANgIAIAAgAxDDBgwBCyADIAJBwAFxIAZyOgAFIAMhBQsgBEEBaiECIAUoAgAiAwRAIARB4wBJIQkgAiEEIAkNAQsLIAVBACADGyEEIAEoAgwLIQMgASAENgJIIAEgASgCECADIAdrajYCEAwGCyABQQQ6ADkgASABQcwAajYCSAwECyABKAJIIgUEQCABKAIMIQcCfyAFKAIAIgNFBEAgBwwBCyABLQA4IgJBGHEhBiACQRhzIQgDQAJAIAMtAAUiAiAIcQRAIAUgAygCADYCACAAIAMQwwYMAQsgAyACQcABcSAGcjoABSADIQULIARBAWohAiAFKAIAIgMEQCAEQeMASSEJIAIhBCAJDQELCyAFQQAgAxshBCABKAIMCyEDIAEgBDYCSCABIAEoAhAgAyAHa2o2AhAMBQsgAUEFOgA5IAEgAUHkAGo2AkgMAwsgASgCSCIFBEAgASgCDCEHAn8gBSgCACIDRQRAIAcMAQsgAS0AOCICQRhxIQYgAkEYcyEIA0ACQCADLQAFIgIgCHEEQCAFIAMoAgA2AgAgACADEMMGDAELIAMgAkHAAXEgBnI6AAUgAyEFCyAEQQFqIQIgBSgCACIDBEAgBEHjAEkhCSACIQQgCQ0BCwsgBUEAIAMbIQQgASgCDAshAyABIAQ2AkggASABKAIQIAMgB2tqNgIQDAQLIAFBBjoAOQwCCwJAIAEtAD8NACABKAIcIAEoAiAiAkEEbU4NACABKAIMIQMgACACQQJtEMkGIAEgASgCECABKAIMIANrajYCEAsgAUEHOgA5DAELAkAgASgCZEUNACABLQA/DQAgAUEAOgA7IAAQygYgASgCZEUEQEEyIQIMAwsgABDKBiABKAJkRQRAQeQAIQIMAwsgABDKBiABKAJkRQRAQZYBIQIMAwsgABDKBiABKAJkRQRAQcgBIQIMAwsgABDKBiABKAJkRQRAQfoBIQIMAwsgABDKBiABKAJkRQRAQawCIQIMAwsgABDKBiABKAJkRQRAQd4CIQIMAwsgABDKBiABKAJkRQRAQZADIQIMAwsgABDKBiABKAJkRQRAQcIDIQIMAwsgABDKBkH0AyECDAILIAFBCDoAOQtBACECCyABQQA6ADsLIAILtAoBDX8gACgCECIBQQI6ADkgASgCVCEDIAFBADYCVCAALQAFQRhxBEAgASAAEI4GCwJAIAEtAChBwABxRQ0AIAEoAiQiAC0ABUEYcUUNACABIAAQjgYLIAEQxwYgASgCUARAA0AgARDIBiAHaiEHIAEoAlANAAsLAkAgASgCiAEiAEUEQAwBCyABQYgBaiEEA0AgBkEBaiEGAkACQCAALQAFQRhxDQAgACgCIEUNACAAQSxqIQQMAQsgBCAAKAIsNgIAIAAgADYCLCAAKAIgIgBFDQADQAJAIAAtAAVBGHENACAAKAIIIgItAARBwABxRQ0AIAIoAgAiAi0ABUEYcUUNACABIAIQjgYLIAZBAWohBiAAKAIMIgANAAsLIAQoAgAiAA0ACyABKAJQRQ0AA0AgARDIBiAIaiEIIAEoAlANAAsLIAEgAzYCUEEAIQQgAwRAA0AgARDIBiAJaiEJIAEoAlANAAsLA0ACQCABKAJcIQJBACEDIAFBADYCXCACRQ0AA0AgAiIAIAAtAAVBIHI6AAUgACgCHCECAkAgASAAIAQQywZFDQBBASEDIAEoAlBFDQADQCABEMgGGiABKAJQDQALCyACDQALIARBAXMhBCADDQELCyABIAEoAlhBABDMBiABIAEoAmBBABDMBiABKAJgIQwgASgCWCENIAFB5ABqIgUhAANAIAAiAigCACIADQALIAEoAkwiACABKAKAASIDRwRAIAFBzABqIQQDQAJAIAAtAAVBGHFFBEAgACEEDAELIAAoAgAhAyABKAJ8IABGBEAgASADNgJ8CyAEIAM2AgAgACACKAIANgIAIAIgADYCACABKAKAASEDIAAhAgsgBCgCACIAIANHDQALCyAFKAIAIgAEQANAIAAtAAVBGHEEQCABIAAQjgYLIApBAWohCiAAKAIAIgANAAsLIAEoAlAEQANAIAEQyAYgC2ohCyABKAJQDQALC0EAIQQCQANAIAEoAlwhAiABQQA2AlxBACEDIAJFDQEDQCACIgAgAC0ABUEgcjoABSAAKAIcIQICQCABIAAgBBDLBkUNAEEBIQMgASgCUEUNAANAIAEQyAYaIAEoAlANAAsLIAINAAsgBEEBcyEEIAMNAAsgASgCXCIFRQ0AA0AgBSgCECIAQQEgBS0AB3RBBHRqIQQDQAJAIAAtAAVBwABxRQ0AIAAoAgwiAkUNACACLQAFQRhxIQMgAi0ABEEPcUEERgRAIANFDQEgASACEI4GDAELIANFDQAgAEEQOgAECwJAIAAtAARBD3ENACAALQAFQcAAcUUNACAAQQs6AAULIABBEGoiACAESQ0ACyAFKAIcIgUNAAsLIAEoAmAiBQRAA0AgBSgCECIAQQEgBS0AB3RBBHRqIQQDQAJAIAAtAAVBwABxRQ0AIAAoAgwiAkUNACACLQAFQRhxIQMgAi0ABEEPcUEERgRAIANFDQEgASACEI4GDAELIANFDQAgAEEQOgAECwJAIAAtAARBD3ENACAALQAFQcAAcUUNACAAQQs6AAULIABBEGoiACAESQ0ACyAFKAIcIgUNAAsLIAEgASgCWCANEMwGIAEgASgCYCAMEMwGIAFBpAJqIQMgAUGgAmohBUEAIQADQCAFIABBA3QiAmoiBCgCAC0ABUEYcQRAIAQgASgClAE2AgALIAIgA2oiAigCAC0ABUEYcQRAIAIgASgClAE2AgALIABBAWoiAEE1Rw0ACyABIAEtADhBGHM6ADggBiAHaiAIaiAJaiAKaiALaguwBQEGfyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCUCABQQM6ADkgAUEANgJgIAEoAkQiAgRAIAAoAhAhBSABQcQAaiIHIQMDQAJAIAItAAUiBEEYcQRAIAMgAigCADYCACAAIAIQwwYMAQsgBEHgAXEiBEEEciEDAkACQAJAAkAgAi0ABEEIaw4CAAECCyACIAUoAlQ2AiggBSACNgJUIAIgA0HEAXE6AAUMAgsgAigCCCACQQxqRg0AIAIgA0HEAXE6AAUMAQsgAiAEQSRyOgAFCyACIQMLIAMoAgAiAg0ACyAHKAIAIQMLIAFBADYCeCABIAM2AnQgASADNgJwIAEgAzYCbCABKAJMIgIEQCAAKAIQIQUgAUHMAGoiBiEDA0ACQCACLQAFIgRBGHEEQCADIAIoAgA2AgAgACACEMMGDAELIARB4AFxIgRBBHIhAwJAAkACQAJAIAItAARBCGsOAgABAgsgAiAFKAJUNgIoIAUgAjYCVCACIANBxAFxOgAFDAILIAIoAgggAkEMakYNACACIANBxAFxOgAFDAELIAIgBEEkcjoABQsgAiEDCyADKAIAIgINAAsgBigCACEGCyABIAY2AoQBIAEgBjYCgAEgASAGNgJ8IAEoAmQiAgRAIAFB5ABqIQMgACgCECEFA0ACQCACLQAFIgRBGHEEQCADIAIoAgA2AgAgACACEMMGDAELIARB4AFxIgRBBHIhAwJAAkACQAJAIAItAARBCGsOAgABAgsgAiAFKAJUNgIoIAUgAjYCVCACIANBxAFxOgAFDAILIAIoAgggAkEMakYNACACIANBxAFxOgAFDAELIAIgBEEkcjoABQsgAiEDCyADKAIAIgINAAsLIAFBADYCFCABQQE6ADogASABKAIMIAEoAghqNgIQIAAgARDNBgukAgEBfwJAIAAoAvwBIgFFDQAgAS0ABUEYcUUNACAAIAEQjgYLAkAgACgCgAIiAUUNACABLQAFQRhxRQ0AIAAgARCOBgsCQCAAKAKEAiIBRQ0AIAEtAAVBGHFFDQAgACABEI4GCwJAIAAoAogCIgFFDQAgAS0ABUEYcUUNACAAIAEQjgYLAkAgACgCjAIiAUUNACABLQAFQRhxRQ0AIAAgARCOBgsCQCAAKAKQAiIBRQ0AIAEtAAVBGHFFDQAgACABEI4GCwJAIAAoApQCIgFFDQAgAS0ABUEYcUUNACAAIAEQjgYLAkAgACgCmAIiAUUNACABLQAFQRhxRQ0AIAAgARCOBgsCQCAAKAKcAiIBRQ0AIAEtAAVBGHFFDQAgACABEI4GCwuqEAEHfyAAKAJQIgIgAi0ABSIDQSByOgAFAkACQAJAAkACQAJAAkACQAJAAkACQCACLQAEQQZrDiEEAwcBBgEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQACCyAAIAIoAgg2AlAgAi0ABiIEDQRBAQ8LAAsgACACKAIcNgJQIAIoAhgiBQ0FDAYLIAAgAigCEDYCUAJAIAIoAgwiAUUNACABLQAFQRhxRQ0AIAAgARCOBgsgAi8BBiIEBEAgAkEYaiEFQQAhAQNAAkAgBSABQQN0aiIDLQAEQcAAcUUNACADKAIAIgMtAAVBGHFFDQAgACADEI4GIAIvAQYhBAsgAUEBaiIBIARB//8DcUkNAAsLIAAgAhDQBiACLwEGQQFqDwsgACACKAIINgJQAkAgAigCDCIBRQ0AIAEtAAVBGHFFDQAgACABEI4GCyACLQAGIgRFBEBBAQ8LIAJBEGohBUEAIQEDQAJAIAUgAUECdGooAgAiA0UNACADLQAFQRhxRQ0AIAAgAxCOBiACLQAGIQQLIAFBAWoiASAEQf8BcSIDSQ0ACyADQQFqDwsgAkEQaiEFA0ACQCAFIAFBA3RqIgMtAARBwABxRQ0AIAMoAgAiAy0ABUEYcUUNACAAIAMQjgYgAi0ABiEECyABQQFqIgEgBEH/AXEiA0kNAAsgA0EBag8LIAAgAigCUDYCUAJAIAIoAkwiAUUNACABLQAFQRhxRQ0AIAAgARCOBgsgAigCECIEQQBKBEBBACEBA0ACQCACKAIwIAFBA3RqIgMtAARBwABxRQ0AIAMoAgAiAy0ABUEYcUUNACAAIAMQjgYgAigCECEECyABQQFqIgEgBEgNAAsLIAIoAgwiBEEASgRAQQAhAQNAAkAgAigCPCABQQN0aigCACIDRQ0AIAMtAAVBGHFFDQAgACADEI4GIAIoAgwhBAsgAUEBaiIBIARIDQALCyACKAIcIgRBAEoEQEEAIQEDQAJAIAIoAjggAUECdGooAgAiA0UNACADLQAFQRhxRQ0AIAAgAxCOBiACKAIcIQQLIAFBAWoiASAESA0ACwsgAigCICIFQQBKBEBBACEBA0ACQCACKAJIIAFBDGxqKAIAIgNFDQAgAy0ABUEYcUUNACAAIAMQjgYgAigCICEFCyABQQFqIgEgBUgNAAsgAigCHCEECyACKAIMIAIoAhAgBCAFampqQQFqDwsgACACKAIoNgJQIAIoAhwhAQJAIANBBnFFBEAgAC0AOQ0BCyACIAAoAlQ2AiggACACNgJUIAIgA0HHAXE6AAULIAFFBEBBAQ8LIAIoAgwiAyABSwRAA0ACQCABLQAEQcAAcUUNACABKAIAIgQtAAVBGHFFDQAgACAEEI4GIAIoAgwhAwsgAUEIaiIBIANJDQALCyACKAIgIgEEQANAIAEtAAVBGHEEQCAAIAEQjgYLIAEoAgwiAQ0ACwsCQCAALQA5QQJHDQAgAC0AP0UEQCACEIMBCyACKAIMIgEgAigCGEEoakkEQANAIAFBADoABCABQQhqIgEgAigCGEEoakkNAAsLIAIoAiwgAkcNACACKAIgRQ0AIAIgACgCiAE2AiwgACACNgKIAQsgAigCGCACKAIca0EDdUEBag8LAkAgBS0ABiIGQQhxDQAgBSgCECAAKAKkASIEKAIIQX8gBS0AB3RBf3NxQQR0aiEBAkADQCABLQAFQcQARgRAIAEoAgwgBEYNAgsgASABKAIIIgNBBHRqIQEgAw0AC0HUsS8hAQsgAS0ABEEPcQ0AIAUgBkEIcjoABkEAIQELIAUtAAVBGHEEQCAAIAUQjgYLIAFFDQAgAS0ABEHEAEcNACABKAIAQRBqIgFB6wAQngEiAyABQfYAEJ4BIgFyRQ0AIANFBEAgAigCCEEARyEEIAIoAhAiAUEBIAItAAd0QQR0aiEFA0AgAS0ABUHAAHEhAwJAIAEtAARBD3FFBEAgA0UNASABQQs6AAUMAQsCQCADRQ0AIAEoAgwiAy0ABUEYcUUNACAAIAMQjgYLIAQEQEEBIQQMAQsCQCABLQAEQcAAcUUNACABKAIAIgNFDQAgAy0ABUEYcSEGIAMtAARBD3FBBEYEQCAGRQ0BIAAgAxCOBgwBC0EBIQQgBg0BC0EAIQQLIAFBEGoiASAFSQ0ACyACIABB1ABB2ABB1AAgBBsgAC0AOUECRxtqIgAoAgA2AhwgACACNgIAIAIgAi0ABUHHAXE6AAUMAgsgAUUEQCAAIAJBABDLBhoMAgsgAiAAKAJgNgIcIAAgAjYCYCACIAItAAVBxwFxOgAFDAELQQEgAi0AB3RBBHQhAyACKAIQIQEgAigCCCEEAkAgAiwABkEATg0AIARpQQJJDQAgBEEBdiAEciIEQQJ2IARyIgRBBHYgBHIiBEEIdiAEciIEQRB2IARyQQFqIQQLIAEgA2oiBSEHIAQEQEEAIQEDQAJAIAIoAgwgAUEDdGoiAy0ABEHAAHFFDQAgAygCACIDLQAFQRhxRQ0AIAAgAxCOBgsgAUEBaiIBIARHDQALIAIoAhAhAQsgByABSwRAA0AgAS0ABUHAAHEhAwJAIAEtAAQiBEEPcUUEQCADRQ0BIAFBCzoABQwBCwJAIANFDQAgASgCDCIDLQAFQRhxRQ0AIAAgAxCOBiABLQAEIQQLIARBwABxRQ0AIAEoAgAiAy0ABUEYcUUNACAAIAMQjgYLIAFBEGoiASAFSQ0ACwsgACACENAGCyACKAIUBH9BAiACLQAHdAVBAAsgAigCCGpBAWoLvgQBCX8gACgCECIIKAIYIQkCfyAIIAEgCCgCICIETiIKDQAaIAggBEEATA0AGiABQQFrIQYDQCAJIAVBAnRqIgMoAgAhAiADQQA2AgAgAgRAA0AgAigCDCEDIAIgCSACKAIIIAZxQQJ0aiIHKAIANgIMIAcgAjYCACADIgINAAsLIAVBAWoiBSAERw0ACyAIKAIYIQkgACgCEAsiAigCBCAJIARBAnQiByABQQJ0IgMgAigCABECACEGAkACQAJAAkAgA0UNACAGDQAgACAJIAcgAxCDBiIGRQ0BIAIgAigCDCADIAdrajYCDAwCCyACIAIoAgwgAyAHa2o2AgwgBg0BCyAKDQEgCCgCGCEFQQAhCgJAIAQiACABTA0AIAQgAWtBAnQiA0UNACAFIAFBAnRqQQAgA/wLAAsgAUEASgRAIABBAWshBANAIAUgCkECdGoiAygCACEAIANBADYCACAABEADQCAAKAIMIQMgACAFIAAoAgggBHFBAnRqIgIoAgA2AgwgAiAANgIAIAMiAA0ACwsgCkEBaiIKIAFHDQALCwwBCyAIIAE2AiAgCCAGNgIYIAEgBEwNACABIARrQQJ0IgIEQCAGIAdqQQAgAvwLAAsgBEEATA0AIAFBAWshCUEAIQUDQCAGIAVBAnRqIgMoAgAhAiADQQA2AgAgAgRAA0AgAigCDCEDIAIgBiACKAIIIAlxQQJ0aiIHKAIANgIMIAcgAjYCACADIgINAAsLIAVBAWoiBSAERw0ACwsLswYBCX8gACgCECIDIAMoAmQiAigCADYCZCACIAMoAkQ2AgAgAyACNgJEIAIgAi0ABSIBQb8BcToABQJAIAMtADlBA2tB/wFxQQNNBEAgAiADLQA4QRhxIAFBhwFxcjoABQwBCyABQQdxQQNHDQAgAyACNgJ4CwJAAn8CQAJAAkAgAi0ABCIGQQ9xIgFBBWsOAwACAQILIAJBGGoMAgsgAkEMagwBCyADIAFBAnRqQfwBagsoAgAiAQRAIAEoAhAgAygCoAEiBSgCCEF/IAEtAAd0QX9zcUEEdGohAQNAIAEtAAVBxABGBEAgASgCDCAFRg0DCyABIAEoAggiBEEEdGohASAEDQALQdSxLyEBDAELIANBLGohAQsCQCABLQAEQQ9xRQ0AIAAtAAchBSADIAMtAD4iB0ECcjoAPiAAQQA6AAcgACAAKAIMIgRBCGo2AgwgBCABKAIANgIAIAQgAS0ABDoABCAAIAAoAgwiAUEIajYCDCABIAZBwAByOgAEIAEgAjYCACAAKAIUIgEgAS8BIkGAAXI7ASIgACgCXCEEIABBADYCXCAALQAHIQIgACgCHCEGIAAoAgwhCCAAQSZBABB9IgkEQCAAIAI6AAcgACABNgIUIAAgACAIIAZrQRBrIgEgCRCBASICIAAoAhwgAWoQggEgABCDASAAIAQ2AlwgACgCFCIBIAEvASJB//4DcTsBIiAAIAU6AAcgAyAHOgA+IAJFDQFBm+0qIQQgACIBKAIMIgJBBGstAABBD3FBBEYEQCACQQhrKAIAQRBqIQQLAkAgASgCECICKALIBSIDRQ0AIAIoAswFQbeILEEBIAMRAQAgASgCECICKALIBSIDRQ0AIAIoAswFQZnHK0EBIAMRAQAgASgCECICKALIBSIDRQ0AIAIoAswFQcqBLEEBIAMRAQAgASgCECICKALIBSIDRQ0AIAIoAswFIARBASADEQEAIAEoAhAiASgCyAUiBEUNACABKALMBUHIgSxBACAEEQEACyAAIAAoAgxBCGs2AgwPCyAAIAQ2AlwgACgCFCIBIAEvASJB//4DcTsBIiAAIAU6AAcgAyAHOgA+CwuRBAEJfyABKAIIIQUCQCABLAAGQQBODQAgBWlBAkkNACAFQQF2IAVyIgNBAnYgA3IiA0EEdiADciIDQQh2IANyIgNBEHYgA3JBAWohBQsgAS0AByEGIAUEQEEAIQMDQAJAIAEoAgwgA0EDdGoiBC0ABEHAAHFFDQAgBCgCACIELQAFQRhxRQ0AIAAgBBCOBkEBIQcLIANBAWoiAyAFRw0ACwtBASAGdCEFQQAhAwNAIAEoAhAiBCAFQQR0aiADQX9zQQR0aiAEIANBBHRqIAIbIgQtAAVBwABxIQYCQCAELQAEIgpBD3FFBEAgBkUNASAEQQs6AAUMAQsCQCAGRQ0AIAQoAgwiBkUNACAGLQAFQRhxIQsgBi0ABEEPcUEERgRAIAtFDQEgACAGEI4GIAQtAAQhCgwBCyALRQ0AQQEhCCAKQcAAcUUNAUEBIAkgBCgCAC0ABUEYcRshCQwBCyAKQcAAcUUNACAEKAIAIgQtAAVBGHFFDQAgACAEEI4GQQEhBwsgA0EBaiIDIAVHDQALIAAtADlFBEAgASAAKAJUNgIcIAAgATYCVCABIAEtAAVBxwFxOgAFIAcPCyAJBEAgASAAKAJcNgIcIAAgATYCXCABIAEtAAVBxwFxOgAFIAcPCyAIBEAgASAAKAJgNgIcIAAgATYCYCABIAEtAAVBxwFxOgAFIAcPCyAAIAEQ0AYgBwv/AgEGfyABIAJHBEADQEEBIAEtAAd0QQR0IQUgASgCCCEEAkAgASwABkEATg0AIARpQQJJDQAgBEEBdiAEciIDQQJ2IANyIgNBBHYgA3IiA0EIdiADciIDQRB2IANyQQFqIQQLIAEoAhAiAyAFaiEHIAQEQEEAIQMDQAJAIAEoAgwgA0EDdGoiBS0ABEHAAHFFDQAgBSgCACIGRQ0AIAYtAAVBGHEhCCAGLQAEQQ9xQQRGBEAgCEUNASAAIAYQjgYMAQsgCEUNACAFQRA6AAQLIANBAWoiAyAERw0ACyABKAIQIQMLIAMgB0kEQANAAkACQAJAIAMtAAQiBUHAAHFFDQAgAygCACIGRQ0AIAYtAAVBGHEhBCAGLQAEQQ9xQQRGBEAgBEUNASAAIAYQjgYgAy0ABCEFDAELIARFDQAgA0EQOgAEDAELIAVBD3ENAQsgAy0ABUHAAHFFDQAgA0ELOgAFCyADQRBqIgMgB0kNAAsLIAEoAhwiASACRw0ACwsL0AEBAn8gAUHUAGoQzgYiAiABKAJYNgIAIAFBADYCWCACEM4GIgIgASgCYDYCACABQQA2AmAgAhDOBiICIAEoAlw2AgAgAUEANgJcIAIQzgYaIAEtAD8EQCABQQA6ADkPCwJAAkAgASgCHCABKAIgIgJBBG1OBEAgAUEAOgA5DAELIAEoAgwhAyAAIAJBAm0QyQYgAUEAOgA5IAEgASgCECABKAIMIANrajYCECABLQA/DQELIAAoAhAiASgCZEUNAANAIAAQygYgASgCZA0ACwsL7wEBBX8gACgCACIBBEADQEEAIQICQAJAAkACQAJAAkAgAS0ABCIEQQVrDiIAAQQCBQMFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUBBQsgAUEcaiECDAQLIAFBCGohAgwDCyABQShqIQIMAgsgAUHQAGohAgwBCyABQRBqIQILAkACQCABLQAFIgNBGHFFBEAgA0EHcSIFQQVGBEAgASADQd8BcUEjczoABQwCCyAEQQhGDQEgASADQcQBcSADIAVBBkYbQSByOgAFCyAAIAIoAgAiATYCAAwBCyACKAIAIQEgAiEACyABDQALCyAACxEAIAAgACgCDEEQa0EAEJEGC6EBAQJ/QfwBIQICQAJAAkAgAS0ABSIDQQdxQQVrDgIAAQILQRwhAgJAAkACQAJAAkACQCABLQAEQQZrDiEEAgADAQMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwQFC0EoIQIMBAtB0AAhAgwDC0EQIQIMAgsAC0EIIQILIAEgAmogACgCVDYCACAAIAE2AlRBxwEhAgsgASACIANxOgAFCwsOACAAQfrwKkEAEJcGAAvUBQIDfQN/IwBBEGsiCSQAAkACQAJAAkAgAUENSw0AAn0CQAJAQQEgAXQiCEGA3wBxRQRAIAhBMHFFDQRBACEIIAItAARBA2sOEQIHBwcHBwcHBwcHBwcHBwcBBwsgAi0ABEEDRgRAIAkgAigCADYCDAwFCyACIAlBDGoQpgYNBEEAIQgMBgsgAioCAAwBCyACKAIAsgshBQJ9AkACQCADLQAEQQNrDhEBBgYGBgYGBgYGBgYGBgYGAAYLIAMqAgAMAQsgAygCALILIQYCfSAFIAaVIAFBBEcNABogBSAFlCAGQwAAAEBbDQAaIAUgBhDTBgshBSAEQRM6AAQgBCAFOAIADAILQQAhCAJ9AkACQAJAIAItAARBA2sOEQAGBgYGBgYGBgYGBgYGBgYBBgsgAigCACECIAMtAAQiCkEDRw0BIAAgASACIAMoAgAQ1AYhASAEQQM6AAQgBCABNgIADAQLIAMtAAQhCiACKgIADAELIAKyCyEGAn0CQAJAIApBA2sOEQEFBQUFBQUFBQUFBQUFBQUABQsgAyoCAAwBCyADKAIAsgshBwJAAkACQAJAAkACQAJAAkACQCABDg0AAQIHBAMFCAgICAgGCAsgBiAHkiEFDAcLIAYgB5MhBQwGCyAGIAeUIQUMBQsgBiAHlSEFDAQLIAdDAAAAQFsEQCAGIAaUIQUMBAsgBiAHENMGIQUMAwsgBiAHlY4hBQwCCyAGjCEFDAELAkAgBiAHEEQiBUMAAAAAXgRAIAdDAAAAAF0NAQwCCyAHQwAAAABeRQ0BIAVDAAAAAF1FDQELIAcgBZIhBQsgBEETOgAEIAQgBTgCAAwBCwJAIAMtAARBA0YEQCADIQIMAQsgCUEIaiECIAMgCUEIahCmBg0AQQAhCAwCCyAAIAEgCSgCDCACKAIAENQGIQEgBEEDOgAEIAQgATYCAAtBASEICyAJQRBqJAAgCAvxBAQEfwJ8AX0BfiABvCIEEIMNIQMCQAJAAkACQCAAvCICQYCAgPwHa0GAgICIeE8EQCADDQEMAwsgA0UNAQtDAACAPyEIIAJBgICA/ANGDQIgBEEBdCIDRQ0CIANBgYCAeEkgAkEBdCICQYCAgHhNcUUEQCAAIAGSDwsgAkGAgID4B0YNAkMAAAAAIAEgAZQgBEEASCACQYCAgPgHSXMbDwsgAhCDDQRAIAAgAJQhCCACQQBIBEAgCIwgCCAEEIQNQQFGGyEICyAEQQBODQJDAACAPyAIlRBIDwsgAkEASARAIAQQhA0iAkUEQCAAEEMPC0GAgARBACACQQFGGyEFIAC8Qf////8HcSECCyACQf///wNLDQAgAEMAAABLlLxB/////wdxQYCAgNwAayECCwJAIAIgAkGAgMz5A2siA0GAgIB8cWu+uyADQQ92QfABcSICQcDHMmorAwCiRAAAAAAAAPC/oCIHRAtuSckWdtI/okR6xnWgaRnXv6AgByAHoiIGIAaioiAHRN26p2wKx94/okTI9r5IRxXnv6AgBqIgB0QruCplRxX3P6IgAkHIxzJqKwMAIANBF3W3oKCgoCABu6IiBr1CgICAgICA4P//AINCgYCAgICAwK/AAFQNACAGRHHV0f///19AZARAIAUQQQ8LIAZEAAAAAADAYsBlRQ0AIAUQQg8LQYCgKSsDACAGIAZB+J8pKwMAIgagIgcgBqGhIgaiQYigKSsDAKAgBiAGoqJBkKApKwMAIAaiRAAAAAAAAPA/oKAgB70iCSAFrXxCL4YgCadBH3FBA3RB+J0paikDAHy/orYhCAsgCAu3AgEBfwJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgAQ4OAAECAwwMBAUGBwgJCgsMCyACIANqDwsgAiADaw8LIAIgA2wPCyADQQFqQQFNBEAgAw0JIABB2IcsQQAQlwYACyACIANvIgJFDQggAiADc0EfdSADcSACag8LIANBAWpBAU0EQCADRQ0JQQAgAmsPCyACIANtIQQgAiADc0EATg0HIAQgAiADIARsR2sPCyACIANxDwsgAiADcg8LIAIgA3MPCyADQQBIBEAgA0FhSQ0EIAJBACADa3YPCyACIAN0QQAgA0EfTRsPC0EAIANrIgFBAEgEQCACIAN2QQAgAUFhTxsPCyACIAF0QQAgAUEfTRsPC0EAIAJrDwsgAkF/cyEECyAEDwsgAEG/qCpBABCXBgAL0AEBA38jAEEgayIEJAACQAJAIAEsAAAiAgRAIAEtAAENAQsgACACENwMIQMMAQsgBEEAQSAQHCABLQAAIgIEQANAIAQgAkEDdkEccWoiAyADKAIAQQEgAnRyNgIAIAEtAAEhAiABQQFqIQEgAg0ACwsgACEDIAAtAAAiAkUNACAAIQEDQCAEIAJBA3ZBHHFqKAIAIAJ2QQFxBEAgASEDDAILIAEtAAEhAiABQQFqIgMhASACDQALCyAEQSBqJAAgACADIABraiIAQQAgAC0AABsL4QECA38BeyMAQSBrIgT9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAQgBf0LBAAgAS0AACICRQRAQQAPCyABLQABRQRAIAAhAQNAIAEiA0EBaiEBIAMtAAAgAkYNAAsgAyAAaw8LA0AgBCACQQN2QRxxaiIDIAMoAgBBASACdHI2AgAgAS0AASECIAFBAWohASACDQALIAAhAwJAIAAtAAAiAkUNACAAIQEDQCAEIAJBA3ZBHHFqKAIAIAJ2QQFxRQRAIAEhAwwCCyABLQABIQIgAUEBaiIDIQEgAg0ACwsgAyAAawvLAgEDfyACQccBTQRAQccBIAAoAggiA2sgAkgEQCAAKAIAIgQoAgwiBSAEIABBDGogAxCABiIDNgIAIAUgAy0ABEHAAHI6AAQgBCAEKAIMQQhqNgIMAkAgACgCBEUEQCAAQQE2AgQMAQsgBEECEJgGCyAAQQA2AghBACEDCyACBEAgACADakEMaiABIAL8CgAACyAAIAAoAgggAmo2AggPCyAAKAIAIgMoAgwiBCADIABBDGogACgCCBCABiIFNgIAIAQgBS0ABEHAAHI6AAQgAyADKAIMQQhqNgIMAkAgACgCBEUEQCAAQQE2AgQMAQsgA0ECEJgGCyAAQQA2AgggACgCACIDKAIMIgQgAyABIAIQgAYiAjYCACAEIAItAARBwAByOgAEIAMgAygCDEEIajYCDCAAKAIERQRAIABBATYCBA8LIANBAhCYBguBAgEEfyMAQSBrIgMkACAAKAIIIgJBnAFOBH8gACgCACIEKAIMIgUgBCAAQQxqIAIQgAYiAjYCACAFIAItAARBwAByOgAEIAQgBCgCDEEIajYCDAJAIAAoAgRFBEAgAEEBNgIEDAELIARBAhCYBgsgAEEANgIIQQAFIAILIABqQQxqIQICQCABLQAEQQNGBEAgAyABKAIANgIAIAJBLEHXwysgAxCmBCEBDAELIAMgASoCALs5AxAgAkEsQYD0KiADQRBqEKYEIQEgAkH75CsQ1gYgAmotAAANACABIAJqQa7gADsAACABQQJqIQELIAAgACgCCCABajYCCCADQSBqJAALDwAgACABIAAoAgwQgQcAC9s7Aw5/An0BfiMAQSBrIgUkACAAKAIgIgMgAygCYEEBaiIENgJgIARB+P8DcUHIAU8EQCADELMGC0ECIQQCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAAoAgwiA0GGAmsOHwYJCAkJCQkEAQkJCQkFCQkJCQcJCQkJCQkJCQoCCQMACwJAAkACQAJAIANBI2sOCwMMDAwMDAwMDAwBAAsgA0H7AGsOBA4LCwELC0EAIQQMAgtBASEEDAELQQMhBAsgACAAKAIEIgg2AggCQCAAKAIUQaACRwRAIAApAhQhEyAAQaACNgIUIAAgEzcCDAwBCyAAIAAgAEEQahC5BjYCDAsgACABQQwQ2gYaIAAoAhwiAyABEPMGAkACQAJAIARBAmsOAgIBAAsgAyAEQQxyIAFB1LAvEPQGDQ0LIAMgARDzBgJAAkAgASgCAEEIRw0AIAEoAgggASgCDEYNASADLQAyIQYgASgCBCELAn8DQEEAIAZBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAGQQFrIgZBBHRqIgctAAVBA0YNAAsgBy0ABkEBagsgC0oNACADIAEgCxD1BgwBCyADIAEQ4wYLIARBMWohCyABKAIEIQcCQCABKAIAQQhHDQAgAy0AMiEEAn8DQEEAIARBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAEQQFrIgRBBHRqIgYtAAVBA0YNAAsgBi0ABkEBagsgB0oNACADIAMtADRBAWs6ADQLIAMoAgAiBCADKAIIKAIgIAQoAjQgAygCECAEQRRqQQRB/////wNB7YIqELgGIgY2AjQgAyADKAIQIg9BAWo2AhAgBiAPQQJ0aiAHQRB0IAtyNgIAIAMgBCADKAIIKAIIENwGIAMoAhAhBCABQRE2AgAgASAEQQFrNgIEIAMoAgAiBCgCQCADKAIQakEBaywAACIGQYB/RwRAIAMgAygCGCAGazYCGCADIAMtADVBAWs6ADUgAyAEIAgQ3AYMDQsgA0GBAToANSADIAMoAiRBAWs2AiQgAyAEIAgQ3AYMDAsCQAJAAkACQAJAAkACQCABKAIAQQFrDhEAAQABAQEBBAYGBgYGBgYCAwYLIAFBAjYCAAwFCyABQQM2AgAMBAsgAygCACgCNCABKAIEIgZBAnRqIQQCQCAGQQBKBEAgBEEEayIGKAIAIgdB/wBxQcQAa0F0Sw0BCyAEKAIAIQcgBCEGCyAGIAdBgIACczYCAAwDCyADLQA0IgZBAWohBCADKAIAIgctAAggBk0EQCAGQf4BTw0SIAcgBDoACAsgAyAEOgA0IAMgASAEQf8BcUEBaxD2BiABKAIAQQhHDQELIAMtADIhBCABKAIEIQcCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAHSg0AIAMgAy0ANEEBazoANAsgASgCBCEGIAMoAgAiBCADKAIIKAIgIAQoAjQgAygCECAEQRRqQQRB/////wNB7YIqELgGIgc2AjQgAyADKAIQIghBAWo2AhAgByAIQQJ0aiAGQRB0QTNyNgIAIAMgBCADKAIIKAIIENwGIAMoAhAhBCABQRE2AgAgASAEQQFrNgIECyABKAIMIQQgASABKAIIIgY2AgwgASAENgIIIAZBf0cEQCADKAIAKAI0IQsDQCALIAZBAnRqIQQCQCAGQQBKBEAgBEEEayIIKAIAIgdB/wBxQcQAa0F0Sw0BCyAEKAIAIQcgBCEICyAHQf8AcUHDAEYEQCAIIAdBCXZBgP8BcSAHQcKAAnFyNgIACyAEKAIAQQd2Qf///wdrIgRBf0cEQCAEIAZqQQFqIgZBf0cNAQsLIAEoAgghBAsgBEF/Rg0LIAMoAgAoAjQhCANAIAggBEECdGohAwJAIARBAEoEQCADQQRrIgcoAgAiBkH/AHFBxABrQXRLDQELIAMoAgAhBiADIQcLIAZB/wBxQcMARgRAIAcgBkEJdkGA/wFxIAZBwoACcXI2AgALIAMoAgBBB3ZB////B2siA0F/Rg0MIAMgBGpBAWoiBEF/Rw0ACwwLCyABQgY3AgAgAUJ/NwIIIAEgACgCEDYCBAwICyABIAAoAhA2AgQgAUEHNgIAIAFCfzcCCAwHCyABQgE3AgAgAUJ/NwIIDAYLIAFCAjcCACABQn83AggMBQsgAUIDNwIAIAFCfzcCCAwECyAAKAIcIgMoAgAiBC0AB0UNByAEIAMoAggoAiAgBCgCNCADKAIQIARBFGpBBEH/////A0HtgioQuAYiBjYCNCADIAMoAhAiB0EBajYCECAGIAdBAnRqQdCAgAg2AgAgAyAEIAMoAggoAggQ3AYgAygCECEDIAFBEzYCACABQn83AgggASADQQFrNgIEDAMLIAAgACgCBCIDNgIIAkAgACgCFEGgAkcEQCAAKQIUIRMgAEGgAjYCFCAAIBM3AgwMAQsgACAAIABBEGoQuQY2AgwgACgCBCEDCyAAIAFBACADEOcGDAQLIAAgARDgBgwDCyABQgU3AgAgAUJ/NwIIIAEgACoCEDgCBAsgACAAKAIENgIIIAAoAhRBoAJHBEAgACkCFCETIABBoAI2AhQgACATNwIMDAILIAAgACAAQRBqELkGIgM2AgwMAgsgACABEPcGCyAAKAIMIQMLQRUhB0EAIQgCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIANBJWsOWgMHFhYWAhUWARYFFhYWFhYWFhYWFhYWDxYRFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFgQWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFggWCQALIANBgAJrDh8SFRUVFRUVFRUVFRUVFRUTFRUVFRUVBQsVDREPDAkKFQtBASEIDBMLQQIhCAwSC0EDIQgMEQtBBCEIDBALQQUhCAwPC0EGIQgMDgtBByEIDA0LQQghCAwMC0EJIQgMCwtBCiEIDAoLQQshCAwJC0EMIQgMCAtBECEIDAcLQQ0hCAwGC0EOIQgMBQtBDyEIDAQLQREhCAwDC0ESIQgMAgtBEyEIDAELQRQhCAsgAEEQaiEPIAJB/wFxIQsDQCAIIgdBAXRB8KwvaiIGLQAAIAtNDQEgACAAKAIEIgI2AggCQCAAKAIUQaACRwRAIAApAhQhEyAAQaACNgIUIAAgEzcCDAwBCyAAIAAgDxC5BjYCDAsgACgCHCIDIAEQ8wYCQAJAAkACQAJAAkACQCAHDhUCAgICAgICAgICAgIFAwQEAwQEAAEGCyADIAEQ3gYMBQsgAyABENsGDAQLIAEoAgggASgCDEYEQCABKAIAQQVrQQJJDQQLIAMgARDzBiABKAIAQQhHDQIgASgCCCABKAIMRg0DIAMtADIhBCABKAIEIQkCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiCC0ABUEDRg0ACyAILQAGQQFqCyAJSg0CIAMgASAJEPUGDAMLIAEoAgggASgCDEYEQCABKAIAQQVrQQJJDQMLIAMgARD4BhoMAgsCQAJ/AkACQCABKAIAQQVrDgIBAAMLIAEoAgQMAQsgASoCBCIRIBGOIhFcDQEgEUMAAADPYEUNASARQwAAAE9dRQ0BIBH8AAshBCABKAIIIAEoAgxHDQAgBEGBAWtB/31LDQILIAMgARDzBiABKAIAQQhHDQAgASgCCCABKAIMRg0BIAMtADIhBCABKAIEIQkCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiCC0ABUEDRg0ACyAILQAGQQFqCyAJSg0AIAMgASAJEPUGDAELIAMgARDjBgsgACAFIAYtAAEQ2gYhCCAAKAIcIgMgBRDzBgJAIAdBC00EQCADIAcgASAFEPQGDQELAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAcOFQMEAwUFBQUGBgYHCAIJCwsJCgoAARULIAEoAgwiCkF/Rg0TIAUoAgwiBEF/Rg0LIAMoAgAoAjQhBwNAIAcgBCIGQQJ0aiICKAIAIglBB3ZB////B2siBEF/RwRAIAQgBmpBAWoiBEF/Rw0BCwsgCiAGQX9zaiIEQf///wdqQYCAgBBPDQwgAiAJQf8AcSAEQQd0ckGA////B2o2AgAMEwsgASgCCCIKQX9GDREgBSgCCCIEQX9GDQwgAygCACgCNCEHA0AgByAEIgZBAnRqIgIoAgAiCUEHdkH///8HayIEQX9HBEAgBCAGakEBaiIEQX9HDQELCyAKIAZBf3NqIgRB////B2pBgICAEE8NDSACIAlB/wBxIARBB3RyQYD///8HajYCAAwRCyADIAUQ4wZB5LAvIQcgAygCECIGIAMoAhRKBEAgAygCACgCNCAGQQJ0akEEayEHCyAHKAIAIglB/wBxQTVGBEACQCAFKAIAQQhHDQAgAy0AMiEEAn8DQEEAIARBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAEQQFrIgRBBHRqIgYtAAVBA0YNAAsgBi0ABkEBagsgBSgCBEoNACADIAMtADRBAWs6ADQLIAcgASgCBEEHdEGA/wFxIAlBtYCCeHEgCUGAgARqQYCA/AdxcnI2AgAMEwsgASgCBCEHIAMoAgAiBCADKAIIKAIgIAQoAjQgBiAEQRRqQQRB/////wNB7YIqELgGIgY2AjQgAyADKAIQIglBAWo2AhAgBiAJQQJ0aiAHQQd0QbWACHI2AgAgAyAEIAMoAggoAggQ3AYCQCAFKAIAQQhHDQAgAy0AMiEEIAUoAgQhBwJ/A0BBACAEQQBMDQEaIAMoAggoAjAoAgAgAygCKEEEdGogBEEBayIEQQR0aiIGLQAFQQNGDQALIAYtAAZBAWoLIAdKDQAgAyADLQA0QQFrOgA0CyADKAIAIgQoAkAgAygCEGpBAWssAAAiBkGAf0cEQCADIAMoAhggBms2AhggAyADLQA1QQFrOgA1IAMgBCACENwGDBMLIANBgQE6ADUgAyADKAIkQQFrNgIkIAMgBCACENwGDBILQQAhCgJ/QQEgASgCCCABKAIMRw0AGkEBIAEoAgBBBWtBAUsNABogBSAB/QACAP0LAxAgASAFQQhqIgQpAwA3AgggASAFKQMANwIAIAQgBSkDGDcDACAFIAUpAxA3AwBBASEKQQALIQQgBwRAIAUoAgwhBiAFKAIIIQkMDQsgBSgCDCEGIAUoAgghCSAFKAIAQQZHDQwgBiAJRw0MIAUoAgQiBkGBAWtBgH5JDQ0gAyABIAVBFSAGQf8AaiAKIAJBL0EGEPkGDBELIAUoAgBBBkcNACAFKAIIIAUoAgxHDQBBgAEgBSgCBCIEa0H/ACAEayIGckH/AUsNACADIAEgBUEVIAZBACACQS9BBxD5BiADKAIAKAI0IAMoAhBBAnRqQQJrIARBEHRBgID8A2pBEHY6AAAMEAsCQCAFKAIIIAUoAgxHDQAgBSgCAEEFa0EBSw0AIAMgBRD6BkUNACADIAEgBSAHQRZqIAUoAgRBACACQTAgB0EGahD5BgwQCyADIAcgASAFIAIQ+wYMDwtBACEEIAEoAgBBBkciBkUEQCAFIAH9AAIA/QsDECABIAVBCGoiBCkDADcCCCABIAUpAwA3AgAgBCAFKQMYNwMAIAUgBSkDEDcDAEEBIQQLAkAgBSgCAEEGRw0AIAMgBRD6BkUNACADIAEgBSAHQRZqIAUoAgQgBCACQTAgB0EGahD5BgwPCyAGRQRAIAUgAf0AAgD9CwMQIAEgBUEIaiIEKQMANwIIIAEgBSkDADcCACAEIAUpAxg3AwAgBSAFKQMQNwMACyADIAcgASAFIAIQ+wYMDgsCQCABKAIAQQZHDQAgASgCCCABKAIMRw0AIAEoAgRBgQFrQYB+SQ0AIAUgAf0AAgD9CwMQIAEgBUEIaiIEKQMANwIIIAEgBSkDADcCACAEIAUpAxg3AwAgBSAFKQMQNwMAIAMgASAFQSEgBSgCBEH/AGpBASACQS9BEBD5BgwOCwJAIAUoAgBBBkcNACAFKAIIIAUoAgxHDQBBgAEgBSgCBCIEa0H/ACAEayIGckH/AUsNACADIAEgBUEgIAZBACACQS9BEBD5BiADKAIAKAI0IAMoAhBBAnRqQQJrIARBEHRBgID8A2pBEHY6AAAMDgsgA0EKIAEgBSACEPsGDA0LAkAgBSgCAEEGRw0AIAUoAgggBSgCDEcNACAFKAIEIgRBgQFrQYB+SQ0AIAMgASAFQSAgBEH/AGpBACACQS9BERD5BgwNCyADQQsgASAFIAIQ+wYMDAsgASgCAEEIRwRAIAUgAf0AAgD9CwMQIAEgBUEIaiIEKQMANwIIIAEgBSkDADcCACAEIAUpAxg3AwAgBSAFKQMQNwMACyADIAEQ8wYCQAJAIAEoAgBBCEcNACABKAIIIAEoAgxGDQEgAy0AMiEEAn8DQEEAIARBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAEQQFrIgRBBHRqIgYtAAVBA0YNAAsgBi0ABkEBagsgASgCBCICSg0AIAMgASACEPUGDAELIAMgARDjBgsgASgCBCEQQQAhDAJAAkACfwJAAkAgBSgCAEEFaw4CAQADCyAFKAIEIgQMAQsgBSoCBCIRIBGOIhJcDQEgEkMAAADPYEUNASASQwAAAE9dRQ0BIBG8IQRBASEMIBL8AAshBiAFKAIIIAUoAgxHDQBBPSENIAZB/wBqIg5BgAJJDQELIAMgBRD4BgR/QTwFIAMgBRDzBgJAAkAgBSgCAEEIRw0AIAUoAgggBSgCDEYNASADLQAyIQQCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAFKAIEIgJKDQAgAyAFIAIQ9QYMAQsgAyAFEOMGC0E5CyENIAUoAgQiBCEOC0F/IQkgASgCAEEIRgRAIAEoAgQhCQtBfyAEIAUoAgBBCEcbIQogAy0AMiIEIQYCfwNAQQAgBkEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIAZBAWsiBkEEdGoiAi0ABUEDRg0ACyACLQAGQQFqCyEGAkACQCAJIApKBEAgBiAJTARAIAMgAy0ANEEBazoANAsCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAKTA0BDAILIAYgCkwEQCADIAMtADRBAWs6ADQLAn8DQEEAIARBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAEQQFrIgRBBHRqIgYtAAVBA0YNAAsgBi0ABkEBagsgCUoNAQsgAyADLQA0QQFrOgA0CyADKAIAIgQgAygCCCgCICAEKAI0IAMoAhAgBEEUakEEQf////8DQe2CKhC4BiIGNgI0IAMgAygCECICQQFqNgIQIAYgAkECdGogDEEYdEGAgAJBACAHQQ1GG3IgDkEQdHIgDSAQQQd0cnI2AgAgAyAEIAMoAggoAggQ3AYgAygCACIEIAMoAggoAiAgBCgCNCADKAIQIARBFGpBBEH/////A0HtgioQuAYiBjYCNCADIAMoAhAiB0EBajYCECAGIAdBAnRqQbj+//8HNgIAIAMgBCADKAIIKAIIENwGIAMoAhAhAyABQRA2AgAgASADQQFrNgIEDAsLIAUgAf0AAgD9CwMQIAEgBUEIaiIEKQMANwIIIAEgBSkDADcCACAEIAUpAxg3AwAgBSAFKQMQNwMAIAdBA2shBwtBACEMAn8CQAJ/AkACQCAFKAIAQQVrDgIBAAMLIAUoAgQMAQsgBSoCBCIRIBGOIhFcDQEgEUMAAADPYEUNASARQwAAAE9dRQ0BQQEhDCAR/AALIQQgBSgCCCAFKAIMRw0AIARB/wBqIg1B/wFLDQAgAyABEPMGAkACQCABKAIAQQhHDQAgASgCCCABKAIMRg0BIAMtADIhBAJ/A0BBACAEQQBMDQEaIAMoAggoAjAoAgAgAygCKEEEdGogBEEBayIEQQR0aiIGLQAFQQNGDQALIAYtAAZBAWoLIAEoAgQiAkoNACADIAEgAhD1BgwBCyADIAEQ4wYLIAEoAgQhDkEwDAELAkACfwJAAkAgASgCAEEFaw4CAQADCyABKAIEDAELIAEqAgQiESARjiIRXA0BIBFDAAAAz2BFDQEgEUMAAABPXUUNAUEBIQwgEfwACyEEIAEoAgggASgCDEcNACAEQf8AaiINQf8BSw0AIAMgBRDzBgJAAkAgBSgCAEEIRw0AIAUoAgggBSgCDEYNASADLQAyIQQCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAFKAIEIgJKDQAgAyAFIAIQ9QYMAQsgAyAFEOMGCyAFKAIEIQ5BMgwBCyADIAEQ8wYCQAJAIAEoAgBBCEcNACABKAIIIAEoAgxGDQEgAy0AMiEEAn8DQEEAIARBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAEQQFrIgRBBHRqIgYtAAVBA0YNAAsgBi0ABkEBagsgASgCBCICSg0AIAMgASACEPUGDAELIAMgARDjBgsgASgCBCEOIAMgBRDzBgJAAkAgBSgCAEEIRw0AIAUoAgggBSgCDEYNASADLQAyIQQCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAFKAIEIgJKDQAgAyAFIAIQ9QYMAQsgAyAFEOMGCyAFKAIEIQ1BLAshEEF/IQkgASgCAEEIRgRAIAEoAgQhCQtBfyAFKAIEIAUoAgBBCEcbIQogAy0AMiIEIQYCfwNAQQAgBkEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIAZBAWsiBkEEdGoiAi0ABUEDRg0ACyACLQAGQQFqCyEGAkACQCAJIApKBEAgBiAJTARAIAMgAy0ANEEBazoANAsCfwNAQQAgBEEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIARBAWsiBEEEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAKTA0BDAILIAYgCkwEQCADIAMtADRBAWs6ADQLAn8DQEEAIARBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiAEQQFrIgRBBHRqIgYtAAVBA0YNAAsgBi0ABkEBagsgCUoNAQsgAyADLQA0QQFrOgA0CyADKAIAIgQgAygCCCgCICAEKAI0IAMoAhAgBEEUakEEQf////8DQe2CKhC4BiIGNgI0IAMgAygCECICQQFqNgIQIAYgAkECdGogByAQaiAMQRh0ciAOQQd0ciANQRB0ckGAgAJyNgIAIAMgBCADKAIIKAIIENwGIAMoAgAiBCADKAIIKAIgIAQoAjQgAygCECAEQRRqQQRB/////wNB7YIqELgGIgY2AjQgAyADKAIQIgdBAWo2AhAgBiAHQQJ0akG4/v//BzYCACADIAQgAygCCCgCCBDcBiADKAIQIQMgAUEQNgIAIAEgA0EBazYCBAwJCyAFIAo2AgwMBwsgAygCCEHJ6SoQ2QYACyAFIAo2AggMBAsgAygCCEHJ6SoQ2QYACyAGIAlHDQELIAUoAgBBBWtBAUsNACADIAUQ+gZFDQAgAyABIAUgB0EWaiAFKAIEIAogAkEwIAdBBmoQ+QYMAwsgBEUEQCAFIAH9AAIA/QsDECABIAVBCGoiBCkDADcCCCABIAUpAwA3AgAgBCAFKQMYNwMAIAUgBSkDEDcDAAsgAyAHIAEgBSACEPsGDAILIAEgBf0AAwD9CwIADAELIAEgBf0AAwD9CwIAC0EVIQcgCEEVRw0ACwsgACgCICIDIAMoAmBBAWs2AmAgBUEgaiQAIAcPCyAAQZSwKhDZBgALIAMoAghBl/QpENkGAAuHAgEGfyAAIAEQ8wYCQAJ/AkACQCABKAIAQQFrDhADAQMBAQEBAQEBAQEBAQEAAQsgASgCBAwBCyAAIAFBARCLBwsiBEF/Rg0AAkAgASgCCCICQX9HBEAgACgCACgCNCEFA0AgBSACIgNBAnRqIgYoAgAiB0EHdkH///8HayICQX9HBEAgAiADakEBaiICQX9HDQELCyAEIANBf3NqIgJB////B2pBgICAEE8NASAGIAdB/wBxIAJBB3RyQYD///8HajYCAAwCCyABIAQ2AggMAQsgACgCCEHJ6SoQ2QYACyABKAIMIQMgACAAKAIQIgI2AhQgACADIAJB/wEgAhDfBiABQX82AgwL3AEBA38gACgCEEEBayEFAkAgAiAAKAIYayIDIANBH3UiBHMgBGtB/wBNBEAgACAALAA1IgRBAWo6ADUgBEEATg0BCyABIAAoAggoAiAgASgCRCAAKAIkIAFBJGpBCEH/////AUGGgioQuAYiAzYCRCADIAAoAiQiBEEDdGoiAyAFNgIAIAAgBEEBajYCJCADIAI2AgQgAEEBOgA1QYB/IQMLIAEgACgCCCgCICABKAJAIAUgAUEYakEBQf////8HQe2CKhC4BiIENgJAIAQgBWogAzoAACAAIAI2AhgLmgYBCn8gACgCCCEDIAAoAgwiBC0ADCIHIQECfwJAA0AgAUEATA0BIAMoAjAiAigCACAAKAIoQQR0aiABQQFrIgFBBHRqIgUtAAVBA0YNAAsgBS0ABkEBagwBCyADKAIwIQJBAAshCCACIAIoAgQgByAALQAyIgFrajYCBCABIAdLBEAgAigCACAAKAIoQQR0aiEGA0AgACABQQFrIgE6ADICQCAGIAFB/wFxIgJBBHRqIgUtAAVBA0YNACAAKAIAKAJIIglFDQAgCSAFLgEIQQxsaiAAKAIQNgIICyACIAdLDQALCwJAIAQtAA4EQCADIAMoAiBBwtoqQQUQgAZBAEEAEOUGDQELIAQoAgBFDQAgBC0ADUUNACAAKAIAIgEgACgCCCgCICABKAI0IAAoAhAgAUEUakEEQf////8DQe2CKhC4BiICNgI0IAAgACgCECIFQQFqNgIQIAIgBUECdGogCEEHdEE2cjYCACAAIAEgACgCCCgCCBDcBgsgACAIOgA0IAMoAjAiAiAEKAIENgIcIAAgBCgCACIBNgIMAkAgAQRAIAQoAggiAyAAKAIIKAIwIgIoAhAiCE4NASAELQAMIQYgAigCDCEKA0AgCiADQQR0aiIHLQAMIQECfwNAQQAgAUEATA0BGiACKAIAIAAoAihBBHRqIAFBAWsiAUEEdGoiBS0ABUEDRg0ACyAFLQAGQQFqCyEJIAYhAQJ/A0BBACABQQBMDQEaIAIoAgAgACgCKEEEdGogAUEBayIBQQR0aiIFLQAFQQNGDQALIAUtAAZBAWoLIAlIBEAgByAHLQANIAQtAA1yOgANCyAHIAY6AAwgA0EBaiIDIAhHDQALDAELIAQoAggiASACKAIQTg0AIAIoAgwgAUEEdGohASMAQSBrIgAkACABKAIAIQYgAygCIEHC2ipBBRCABiEEIAMoAiAhAiAEIAZGBEAgACABKAIINgIAIAMgAkGXwisgABChBhDkBgALIAEoAgAhBiAAIAEoAgg2AhQgACAGQRBqNgIQIAMgAkHJwisgAEEQahChBhDkBgALC9YCAQZ/IAAgARDzBgJAAn8CQAJAIAEoAgBBAmsODwMBAwMDAwEBAQEBAQEBAAELIAAoAgAoAjQgASgCBCIDQQJ0aiECAkAgA0EASgRAIAJBBGsiAygCACIEQf8AcUHEAGtBdEsNAQsgAigCACEEIAIhAwsgAyAEQYCAAnM2AgAgASgCBAwBCyAAIAFBABCLBwsiBUF/Rg0AAkAgASgCDCICQX9HBEAgACgCACgCNCEEA0AgBCACIgNBAnRqIgYoAgAiB0EHdkH///8HayICQX9HBEAgAiADakEBaiICQX9HDQELCyAFIANBf3NqIgJB////B2pBgICAEE8NASAGIAdB/wBxIAJBB3RyQYD///8HajYCAAwCCyABIAU2AgwMAQsgACgCCEHJ6SoQ2QYACyABKAIIIQMgACAAKAIQIgI2AhQgACADIAJB/wEgAhDfBiABQX82AggL2AIBCX8CQAJAAkAgAUF/Rg0AIAJB////B2ohCSAEQf///wdqIQogA0EHdEGA/wFxIQsgACgCACgCNCEMIANB/wFGIQ0DQCAMIAFBAnRqIgYoAgAhBwJAIAFBAEoEQCAGQQRrIggoAgAiBUH/AHFBxABrQXRLDQELIAchBSAGIQgLIAYCfyAFQf8AcUHDAEYEQCAIAn8CQCANDQAgAyAFQRB2Qf8BcUYNACAFQcOAfnEgC3IMAQsgBUEJdkGA/wFxIAVBwoACcXILNgIAIAEgCWtB////b00NBCACIAFBf3NqIQUgBigCAAwBCyABIAprQf///29NDQQgBCABQX9zaiEFIAcLQf8AcSAFQQd0ckGA////B2o2AgAgB0EHdkH///8HayIGQX9GDQEgASAGakEBaiIBQX9HDQALCw8LIAAoAghByekqENkGAAsgACgCCEHJ6SoQ2QYAC6ULAgp/AX4jAEEQayIEJAAgACgCHCEDAkAgACgCDCICQaMCRwRAIAJBKEYEQCAAIAAoAgQiAjYCCAJAIAAoAhRBoAJHBEAgACkCFCEMIABBoAI2AhQgACAMNwIMDAELIAAgACAAQRBqELkGNgIMCyAAIAFBABDaBhogAEEpQSggAhDuBiAAKAIcIAEQ8wYMAgsgAEHMxyoQ2QYACyAAIAEQ6gYLIABBEGohBgJAAkACQAJAA0ACQAJAAkACQAJAIAAoAgwiAkHaAEwEQCACQShrDhMBBQUFBQUCBQUFBQUFBQUFBQUEBQsgAkHbAEYNAiACQfsARg0AIAJBpAJHDQQLIAMgARDjBiAAIAEQ/gYMBAsgACgCHCIFIAEQ6wYgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQwgAEGgAjYCFCAAIAw3AgwgDKchAgwBCyAAIAAgBhC5BiICNgIMCyACQaMCRw0EIAAgACgCBDYCCCAAKAIQIQICQCAAKAIUQaACRwRAIAApAhQhDCAAQaACNgIUIAAgDDcCDAwBCyAAIAAgBhC5BjYCDAsgBCACNgIEIARBBzYCACAEQn83AgggBSABIAQQ7AYMAwsgAyABEOsGIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEMIABBoAI2AhQgACAMNwIMDAELIAAgACAGELkGNgIMCyAAIARBABDaBhogACgCHCAEEP8GIAAoAgxB3QBHDQQgACAAKAIENgIIIAAoAhRBoAJHBEAgACkCFCEMIABBoAI2AhQgACAMNwIMIAMgASAEEOwGDAMLIAAgACAGELkGNgIMIAMgASAEEOwGDAILIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEMIABBoAI2AhQgACAMNwIMIAynIQIMAQsgACAAIAYQuQYiAjYCDAsgAkGjAkcNBCAAIAAoAgQ2AgggACgCECECAkAgACgCFEGgAkcEQCAAKQIUIQwgAEGgAjYCFCAAIAw3AgwMAQsgACAAIAYQuQY2AgwLIAQgAjYCBCAEQQc2AgAgBEJ/NwIIIAMgARDzBgJAAkAgASgCAEEIRw0AIAEoAgggASgCDEYNASADLQAyIQIgASgCBCEHAn8DQEEAIAJBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiACQQFrIgJBBHRqIgUtAAVBA0YNAAsgBS0ABkEBagsgB0oNACADIAEgBxD1BgwBCyADIAEQ4wYLIAEoAgQhBwJAIAEoAgBBCEcEQCADLQA0IQIMAQsgAy0AMiECAn8DQEEAIAJBAEwNARogAygCCCgCMCgCACADKAIoQQR0aiACQQFrIgJBBHRqIgUtAAVBA0YNAAsgBS0ABkEBagshBSADLQA0IQIgBSAHSg0AIAMgAkEBayICOgA0CyABQQg2AgAgASACQf8BcTYCBCADLQA0IgVBAmoiAiADKAIAIggtAAhLBEAgBUH9AU8NBiAIIAI6AAgLIAMgAjoANCABKAIEIQUgAyAEEPgGIQkgBCgCBCEIIAMoAgAiAiADKAIIKAIgIAIoAjQgAygCECACQRRqQQRB/////wNB7YIqELgGIgo2AjQgAyADKAIQIgtBAWo2AhAgCiALQQJ0aiAHQRB0IAVBB3RyIAlBD3RyIAhBGHRyQRRyNgIAIAMgAiADKAIIKAIIENwGAkAgBCgCAEEIRw0AIAMtADIhAgJ/A0BBACACQQBMDQEaIAMoAggoAjAoAgAgAygCKEEEdGogAkEBayICQQR0aiIFLQAFQQNGDQALIAUtAAZBAWoLIAhKDQAgAyADLQA0QQFrOgA0CyAAIAEQ/gYMAQsLIARBEGokAA8LIABBowIQvAYACyAAQd0AELwGAAsgAEGjAhC8BgALIAMoAghBl/QpENkGAAvCCQIIfwF+IwBBIGsiBCQAAkACQCABKAIEQQlrIgNBB0kEQCAAKAIcIQUCQAJAAkACQAJAIAMOAwECAAQLIAAoAjAoAgAgASgCCEEEdGpBDGohAwwCCyAFKAIIKAIwKAIAIAUoAihBBHRqIAEvAQpBBHRqIgMtAAVFDQIgA0EMaiEDDAELIAUoAgAoAjwgASgCCEEDdGoiAy0ABkUNAQsgAygCACIDDQILAkACQAJAAkACQCAAKAIMQSxrDhIAAQEBAQEBAQEBAQEBAQEBAQIBCyAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhCyAAQaACNgIUIAAgCzcCDAwBCyAAIAAgAEEQahC5BjYCDAsgBCABNgIMIAAgBEEQahDgBgJAIAQoAhBBfHFBDEYNACAAKAIcIgctADQhCCABIQMDQAJAIAMoAgQiBUF8cUEMRw0AIAQoAhAhBgJAIAVBDUYEQCAGQQpHDQIgBCgCFCADLQAKRw0CIAMgCDoACiADQQ82AgQMAQsgBkEJRw0BIAQtABQiBiADLQAKRgRAIAMgCDoACkEBIQkLIAVBDEcNASADLgEIIAZHDQEgAyAIOwEIC0EBIQkLIAMoAgAiAw0ACyAJRQ0AIAcoAgAiA0EUaiEFIAcoAhAhBiADKAI0IQkgBygCCCgCICEKAn8gBCgCEEEJRgRAIAhBB3QgBC0AFEEQdHIMAQsgCEEHdCAEKAIUQRB0ckEJcgshCCADIAogCSAGIAVBBEH/////A0HtgioQuAYiBTYCNCAHIAcoAhAiBkEBajYCECAFIAZBAnRqIAg2AgAgByADIAcoAggoAggQ3AYgBy0ANCIDQQFqIQUgBygCACIGLQAIIANNBEAgA0H+AU8NCCAGIAU6AAgLIAcgBToANAsgACgCICIDIAMoAmBBAWoiBTYCYCAFQfj/A3FByAFPBEAgAxCzBgsgACAEQQxqIAJBAWoQ4QYgACgCICIDIAMoAmBBAWs2AmAMAgsgAEE9ELwGAAsgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQsgAEGgAjYCFCAAIAs3AgwMAQsgACAAIABBEGoQuQY2AgwLIAAgBEEMakEAENoGGkEBIQMgACgCDEEsRgRAIABBEGohBiAAQRxqIQUDQCAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhCyAAQaACNgIUIAAgCzcCDAwBCyAAIAAgBhC5BjYCDAsgBSgCACAEQQxqEOMGIAAgBEEMakEAENoGGiADQQFqIQMgACgCDEEsRg0ACwsgACgCHCEFIAIgA0YEQAJAAkAgBCgCDEESaw4CAAEECyAEQQg2AgwgBCAFKAIAKAI0IAQoAhBBAnRqKAIAQQd2Qf8BcTYCEAwDCyAFKAIAKAI0IAQoAhBBAnRqQQI6AAMgBEERNgIMDAILIAUgAiADIARBDGoQ6QYLIAAoAhwiBS0ANCEAIARBCDYCDCAEQn83AhQgBCAAQQFrNgIQCyAFIAFBBGogBEEMahDtBiAEQSBqJAAPCyAAQYGPKhDZBgALIAAoAiAhBSAEIANBEGo2AgAgACAFQc6ELCAEEKEGEOQGAAsgBygCCEGX9CkQ2QYAC40BAgJ/AX4gACABQQAQ2gYaQQEhAiAAKAIMQSxGBEAgAEEQaiEDA0AgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQQgAEGgAjYCFCAAIAQ3AgwMAQsgACAAIAMQuQY2AgwLIAAoAhwgARDjBiAAIAFBABDaBhogAkEBaiECIAAoAgxBLEYNAAsLIAILzAEBA38gACABEPMGAkAgASgCAEEIRw0AIAAtADIhAiABKAIEIQQCfwNAQQAgAkEATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIAJBAWsiAkEEdGoiAy0ABUEDRg0ACyADLQAGQQFqCyAESg0AIAAgAC0ANEEBazoANAsgAC0ANCIDQQFqIQICQCAAKAIAIgQtAAggA00EQCADQf4BTw0BIAQgAjoACAsgACACOgA0IAAgASACQf8BcUEBaxD1Bg8LIAAoAghBl/QpENkGAAsRACAAQQA2AgwgACABENkGAAuxBQEGfyAAKAIwIQQgACgCHCIFIAUoAhAiCDYCFCAEIAAoAiAgBCgCGCAEKAIcIgYgBEEgakEQQf//AUHt+SkQuAYiBzYCGCAHIAZBBHRqIgcgAjYCCCAHIAE2AgAgACgCHCIBLQAyIQkgB0EAOgANIAcgCToADCAHIAg2AgQgBCAGQQFqNgIcIAMEQCAHIAUoAgwtAAw6AAwLAkAgASgCDCgCCCIBIAAoAjAiAygCECIESAR/QQAhCQNAAkAgAUEEdCICIAMoAgxqIggoAgAgBygCAEYEQCAAKAIwIgYoAgwgAmoiBC0ADCAHLQAMSQ0EIAgtAA0hCCAAKAIcIAQoAgQgBygCBCIEQf8BIAQQ3wYgASIEIAYoAhBBAWsiAkgEQANAIAYoAgwiAiAEQQR0aiACIARBAWoiBEEEdGr9AAIA/QsCACAEIAYoAhBBAWsiAkgNAAsLIAggCXIhCSAGIAI2AhAgAygCECEEDAELIAFBAWohAQsgASAESA0ACyAJRQRAQQAPCyAFLQAyIQQCfwJAA0AgBEEATA0BIAUoAggiBigCMCgCACAFKAIoQQR0aiAEQQFrIgRBBHRqIgItAAVBA0YNAAsgAi0ABkEHdEG2AWoMAQsgBSgCCCEGQTYLIQEgBSgCACIEIAYoAiAgBCgCNCAFKAIQIARBFGpBBEH/////A0HtgioQuAYiBjYCNCAFIAUoAhAiB0EBajYCECAGIAdBAnRqIAE2AgAgBSAEIAUoAggoAggQ3AZBAQVBAAsPCyMAQRBrIgEkACAAKAIcIgIoAggoAjAoAgAgAigCKEEEdGogBC0ADEEEdGooAgwhAiAAKAIgIQMgBCgCACEFIAEgBCgCCDYCBCABIAVBEGo2AgAgASACQRBqNgIIIAAgA0HhgywgARChBhDkBgAL6QQBEX8gACgCHCIDLQAyIQICfwNAQQAgAkEATA0BGiADKAIIKAIwKAIAIAMoAihBBHRqIAJBAWsiAkEEdGoiBC0ABUEDRg0ACyAELQAGQQFqCyEJIAFBAEoEQANAIAMgAy0AMiICQQFqOgAyIAMoAggoAjAoAgAgAygCKEEEdGogAkEEdGoiDSAJOgAGIA0oAgwhByADKAIAIgYoAiAhCCAGIAAoAiAgBigCSCADLgEwIAZBIGpBDEH//wFB1oIqELgGIgU2AkgCQCAIIAYoAiAiCk4NAEEAIQIgCiAIIgRrQQdxIgsEQANAIAUgBEEMbGpBADYCACAEQQFqIQQgAkEBaiICIAtHDQALCyAIIAprQXhLDQAgBUHUAGohCyAFQcgAaiEIIAVBPGohDiAFQTBqIQ8gBUEkaiEQIAVBGGohESAFQQxqIRIDQCAFIARBDGwiAmpBADYCACACIBJqQQA2AgAgAiARakEANgIAIAIgEGpBADYCACACIA9qQQA2AgAgAiAOakEANgIAIAIgCGpBADYCACACIAtqQQA2AgAgBEEIaiIEIApHDQALCyAFIAMuATAiAkEMbGoiBCAHNgIAIAQgAygCEDYCBAJAIAYtAAUiBEEgcUUNACAHLQAFQRhxRQ0AAkAgACgCICgCECICLQA5QQJNBEAgAiAHEI4GIAYtAAVBBnFFDQEgByAHLQAFQfgBcUECcjoABQwBCyACLQA6DQAgBiACLQA4QRhxIARBxwFxcjoABQsgAy8BMCECCyAJQQFqIQkgAyACQQFqOwEwIA0gAjsBCCAMQQFqIgwgAUcNAAsLC9sPAgh/AX4jAEHQAGsiByQAIAAoAiAhCQJAIAAoAhwiCCgCICIFIAgoAgAiBigCHCIESA0AIAYgCSAGKAI4IAUgBkEcakEEQf//B0Gb/CkQuAYiCjYCOCAGKAIcIgUgBEwNACAFIARrQQJ0IgVFDQAgCiAEQQJ0akEAIAX8CwALAkAgCSgCECIFKAIEQQBBCkHUACAFKAIAEQIAIgRFBEAgCUEAQQpB1AAQgwYiBEUNAQsgBSAFKAIMQdQAajYCDCAFLQA4IQogBEEKOgAEIAQgCkEYcSILOgAFIAQgBSgCRDYCACAFIAQ2AkQgBEEAOgAIIARBADsBBiAEQQxqQQBBxAD8CwAgBigCOCEFIAggCCgCICIKQQFqNgIgIAUgCkECdGogBDYCAAJAIAYtAAUiBUEgcUUNACALRQ0AIAkoAhAiCC0AOUECTQRAIAggBBCOBiAGLQAFQQZxRQ0BIAQgBC0ABUH4AXFBAnI6AAUMAQsgCC0AOg0AIAYgCC0AOEEYcSAFQccBcXI6AAULIAcgBDYCGCAEIAM2AiggACgCHCEFIAcgADYCICAHIAU2AhwgACAHQRhqNgIcQQAhCSAHQQA2AEsgByADNgIwIAdCADcCKCAHQQA2AjwgB0EANgJIIAdCADcCNCAHIAAoAjAiBigCBDYCQCAGKAIcIQggB0EANgIkIAcgCDYCRCAEIAAoAjQiBTYCTAJ/AkAgBC0ABSIKQSBxBEAgBS0ABUEYcQ0BC0EAIQpBAAwBCwJAIAAoAiAoAhAiBi0AOUECTQRAIAYgBRCOBiAELQAFQQZxRQ0BIAUgBS0ABUH4AXFBAnI6AAUMAQsgBi0AOg0AIAQgBi0AOEEYcSAKQccBcXI6AAULIAcoAiAoAjAiBigCHCEIIActAEohCiAHKAIkCyEFIARBAjoACCAHIAo6ABQgB0EAOgAWIAcgCDYCDCAGKAIQIQQgB0EAOgAVIAcgBDYCECAFBEAgBS0AD0EARyEJCyAHIAU2AgggByAJOgAXIAcgB0EIajYCJCAAKAIMQShGBEAgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQwgAEGgAjYCFCAAIAw3AgwgDKchBAwBCyAAIAAgAEEQahC5BiIENgIMCwJAIAIEQCAAQdP0KkEEEO8GIQUgACgCMCIEKAIEQQFqIgYgACgCHCIIKAIoa0HJAU4NASAEIAAoAiAgBCgCACAGIARBCGpBEEH//wNB1oIqELgGIgY2AgAgBCAEKAIEIghBAWo2AgQgBiAIQQR0aiIEIAU2AgwgBEEAOgAFIABBARDmBiAAKAIMIQQLIAAoAhwiAigCACELQQAhBQJAAkACQAJAAkACQCAEQSlGDQAgAEEQaiEKA0AgBEGjAkcEQCAEQZgCRg0DIABB8LcrENkGAAsgACAAKAIENgIIIAAoAhAhBgJAIAAoAhRBoAJHBEAgACkCFCEMIABBoAI2AhQgACAMNwIMDAELIAAgACAKELkGNgIMCyAAKAIwIgQoAgRBAWoiCCAAKAIcIgkoAihrQckBTg0EIAQgACgCICAEKAIAIAggBEEIakEQQf//A0HWgioQuAYiCDYCACAEIAQoAgQiCUEBajYCBCAIIAlBBHRqIgQgBjYCDCAEQQA6AAUgBUEBaiEFIAAoAgxBLEcNASAAIAAoAgQ2AgggACgCFEGgAkcEQCAAKQIUIQwgAEGgAjYCFCAAIAw3AgwgDKchBAwBBSAAIAAgChC5BiIENgIMDAELAAsACyAAIAUQ5gYgCyACLQAyIgQ6AAYMAQsgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQwgAEGgAjYCFCAAIAw3AgwMAQsgACAAIAoQuQY2AgwLIAAgBRDmBiALIAItADIiBToABiACKAIAIgRBAToAByAEIAIoAggoAiAgBCgCNCACKAIQIARBFGpBBEH/////A0HtgioQuAYiBjYCNCACIAIoAhAiCEEBajYCECAGIAhBAnRqIAVBB3RB0QByNgIAIAIgBCACKAIIKAIIENwGIAItADIhBAsgAi0ANCIFIARB/wFxaiIGIAIoAgAiCC0ACEsEQCAGQf8BTw0DIAggBjoACAsgAiAEIAVqOgA0IAAoAgxBKUcNASAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDCAAQaACNgIUIAAgDDcCDCAMpyEEDAELIAAgACAAQRBqELkGIgQ2AgwLA0ACQCAEQYMCayIEQR1LDQBBASAEdEGHgIiAAnFFBEAgBEEORw0BIAAQugYLIAcoAhggACgCBDYCLCAAQYUCQYgCIAMQ7gYgACgCHCgCBCIEKAIAIQUgBCgCICEGIAUgBCgCCCgCICAFKAI0IAQoAhAgBUEUakEEQf////8DQe2CKhC4BiIINgI0IAQgBCgCECIJQQFqNgIQIAggCUECdGogBkEPdEGx/wFrNgIAIAQgBSAEKAIIKAIIENwGIAQoAhAhBSABQRE2AgAgAUJ/NwIIIAEgBUEBazYCBCAEIAEQ4wYgABC7BiAHQdAAaiQADwsgABC6BiAAKAIMIQQMAAsACyAJQcgBQdaCKhC9BgALIABBKRC8BgALIAIoAghBl/QpENkGAAsgCEHIAUHWgioQvQYACyAAQSgQvAYACyAJQQQQhAYAC0ABAX4gACAAKAIENgIIIAAoAhRBoAJHBEAgACkCFCEBIABBoAI2AhQgACABNwIMDwsgACAAIABBEGoQuQY2AgwLwQIBAn8gASACayECAkACQAJAAkACQAJAAkAgAygCACIEDhQBAAAAAAAAAAAAAAAAAAAAAAACAgALIAAgAxDjBgsgAkEATA0CIAAgAC0ANCACEPwGIAAoAgAhAQwBCyAAKAIAIgEoAjQgAygCBEECdGoiAygCAEH///8HcUF/IAIgAkEASBtBGHRyQYCAgBBqIQUCQCAEQRJGBEAgAyAFNgIADAELIAMgBUH/gH5xIAAtADQiBEEHdHI2AgAgBEEBaiEDIAEtAAggBE0EQCAEQf4BTw0EIAEgAzoACAsgACADOgA0CyACQQBMDQELIAIgAC0ANGoiAiABLQAISgRAIAJB/wFPDQMgASACOgAICyAAIAI6ADQPCyAAIAAtADQgAmo6ADQPCyAAKAIIQZf0KRDZBgALIAAoAghBl/QpENkGAAu/AQIDfwF+IwBBEGsiAiQAIAAoAgxBowJGBEAgACAAKAIENgIIIAAoAhAhBAJAIAAoAhRBoAJHBEAgACkCFCEFIABBoAI2AhQgACAFNwIMDAELIAAgACAAQRBqELkGNgIMCyAAKAIcIgMgBCABQQEQ/QYgASgCAEUEQCADIAAoAjggAUEBEP0GIAMgARDrBiACIAQ2AgQgAkEHNgIAIAJCfzcCCCADIAEgAhDsBgsgAkEQaiQADwsgAEGjAhC8BgALpQEBA38CQCABKAIAQQpGBEAgASgCCCABKAIMRg0BCyAAIAEQ8wYCQCABKAIAQQhHDQAgASgCCCABKAIMRg0BIAAtADIhAiABKAIEIQMCfwNAQQAgAkEATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIAJBAWsiAkEEdGoiBC0ABUEDRg0ACyAELQAGQQFqCyADSg0AIAAgASADEPUGDwsgACABEOMGCwucBQEFfyMAQRBrIgUkAAJAAkACQAJAIAIoAgAiBkEHRwRAIAEoAgAiA0EKRw0EIAZBBEcNAgwBCyAFIAIoAgQiAzYCCCAFIAMtAARBwAByOgAMIAAgBUEIaiAFQQhqEIkHIQMgAkEENgIAIAIgAzYCBCABKAIAIgNBCkcNAwsgAigCCCACKAIMRw0AIAIoAgQiA0H/AUoNACAAKAIAKAIwIANBA3RqLQAEQcQARg0BCyAAIAEQ8wYCQCABKAIAQQhHDQAgASgCCCABKAIMRg0BIAAtADIhAyABKAIEIQQCfwNAQQAgA0EATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIANBAWsiA0EEdGoiBi0ABUEDRg0ACyAGLQAGQQFqCyAESg0AIAAgASAEEPUGDAELIAAgARDjBgsgASgCACEDCyABAn8gAQJ/AkACQAJAIANBCWsOAgEAAgsgASABKAIEOgAGIAIoAgQhA0ENDAMLIAEtAAQMAQsgASgCBAs6AAYCQAJAAkAgAigCAEEEaw4DAAIBAgsgAigCCCACKAIMRw0BIAIoAgQiA0H/AUoNASAAKAIAKAIwIANBA3RqLQAEQcQARw0BQQ8MAgsgAigCCCACKAIMRw0AIAIoAgQiA0GAAk8NAEEODAELIAAgAhDzBgJAAkAgAigCAEEIRw0AIAJBBGohBCACKAIIIAIoAgxGDQEgAC0AMiEDIAQoAgAhBwJ/A0BBACADQQBMDQEaIAAoAggoAjAoAgAgACgCKEEEdGogA0EBayIDQQR0aiIGLQAFQQNGDQALIAYtAAZBAWoLIAdKDQAgACACIAcQ9QYMAQsgACACEOMGIAJBBGohBAsgBCgCACEDQQwLNgIAIAEgAzsBBCAFQRBqJAALxgUBBH8CQAJ/AkACQAJAAkACQAJAIAEoAgBBCWsOBwABBwUCAwQHCwJAIAIoAgBBCEcNACAALQAyIQMgAigCBCEEAn8DQEEAIANBAEwNARogACgCCCgCMCgCACAAKAIoQQR0aiADQQFrIgNBBHRqIgUtAAVBA0YNAAsgBS0ABkEBagsgBEoNACAAIAAtADRBAWs6ADQLIAAgAiABLQAEEPUGDwsgACACEPMGAkACQCACKAIAQQhHDQAgAkEEaiEEIAIoAgggAigCDEYNASAALQAyIQMgBCgCACEGAn8DQEEAIANBAEwNARogACgCCCgCMCgCACAAKAIoQQR0aiADQQFrIgNBBHRqIgUtAAVBA0YNAAsgBS0ABkEBagsgBkoNACAAIAIgBhD1BgwBCyAAIAIQ4wYgAkEEaiEECyAEKAIAQQd0IAEoAgRBEHRyQQpyDAQLIAEvAQRBEHQgAS0ABkEHdHIgACACEPgGQQ90ciACKAIEQRh0ckEPcgwDCyABLwEEQRB0IAEtAAZBB3RyIAAgAhD4BkEPdHIgAigCBEEYdHJBEXIMAgsgAS8BBEEQdCABLQAGQQd0ciAAIAIQ+AZBD3RyIAIoAgRBGHRyQRJyDAELIAEvAQRBEHQgAS0ABkEHdHIgACACEPgGQQ90ciACKAIEQRh0ckEQcgshASAAKAIAIgMgACgCCCgCICADKAI0IAAoAhAgA0EUakEEQf////8DQe2CKhC4BiIFNgI0IAAgACgCECIEQQFqNgIQIAUgBEECdGogATYCACAAIAMgACgCCCgCCBDcBgsCQCACKAIAQQhHDQAgAC0AMiEDIAIoAgQCfwNAQQAgA0EATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIANBAWsiA0EEdGoiAi0ABUEDRg0ACyACLQAGQQFqC0gNACAAIAAtADRBAWs6ADQLC7cBAgJ/AX4jAEEQayIEJAAgACgCBCEFAkAgASAAKAIMRwRAIAMgBUYNASAAKAIgIQUgACABEPIGIQEgACACEPIGIQIgBCADNgIIIAQgAjYCBCAEIAE2AgAgACAFQfT8KyAEEKEGENkGAAsgACAFNgIIAkAgACgCFEGgAkcEQCAAKQIUIQYgAEGgAjYCFCAAIAY3AgwMAQsgACAAIABBEGoQuQY2AgwLIARBEGokAA8LIAAgARC8BgALtgIBA38jAEEQayIFJAAgACgCICIEIAEgAhCABiEDIAAoAiwhAgJAIAMtAAQiAUEERgRAIAIoAhAgAygCCEF/IAItAAd0QX9zcUEEdGohAgNAIAItAAVBxABGBEAgAigCDCADRg0DCyACIAIoAggiAUEEdGohAiABDQALQdSxLyECDAELIAUgAzYCCCAFIAFBwAByOgAMIAIgBUEIakEAEIUGIQILAkAgAi0ABEEPcQRAIAIoAgwhAwwBCyAEIAQoAgwiAUEIajYCDCABIAM2AgAgASADLQAEQcAAcjoABAJAIAItAARBIEYEQCAEIAAoAiwgASABEI0GDAELIAIgAzYCACACIAEtAAQ6AAQLIAQoAhAoAgxBAEoEQCAEEFQLIAQgBCgCDEEIazYCDAsgBUEQaiQAIAMLvAEBBH8jAEEQayIDJAACQCACQYGABGtBgIB4TwRAIAAoAgAiBCAAKAIIKAIgIAQoAjQgACgCECAEQRRqQQRB/////wNB7YIqELgGIgU2AjQgACAAKAIQIgZBAWo2AhAgBSAGQQJ0aiACQQ90QYCA/v8HaiABQQd0ckEBcjYCACAAIAQgACgCCCgCCBDcBgwBCyADQQM6AAwgAyACNgIIIAAgASAAIANBCGogA0EIahCJBxCKBwsgA0EQaiQAC+sIAgZ/AX4jAEEgayIHJAAgACgCDEGCAkYEQCAAKAIcIQUgACAAKAIENgIIAkAgACgCFEGgAkcEQCAAKQIUIQsgAEGgAjYCFCAAIAs3AgwMAQsgACAAIABBEGoQuQY2AgwLIAUoAgAiBiAFKAIIKAIgIAYoAjQgBSgCECAGQRRqQQRB/////wNB7YIqELgGIgk2AjQgBSAFKAIQIghBAWo2AhAgCSAIQQJ0aiABQQd0IgogBEECdEGcrS9qKAIAcjYCACAFIAYgBSgCCCgCCBDcBiAFKAIQIQlBACEGIAdBADoADiAHIAUtADI6AAwgByAFKAIIKAIwIgEoAhw2AgQgASgCECEBIAdBADoADSAHIAE2AgggBSgCDCIBBEAgAS0AD0EARyEGCyAHIAE2AgAgByAGOgAPIAUgBzYCDCAAIAMQ5gYCQCADIAUtADRqIgYgBSgCACIBLQAISgRAIAZB/wFPDQEgASAGOgAICyAFIAY6ADQgACgCHCEBQQAhBiAHQQA6AB4gByABLQAyOgAcIAcgASgCCCgCMCIIKAIcNgIUIAgoAhAhCCAHQQA6AB0gByAINgIYIAEoAgwiCARAIAgtAA9BAEchBgsgByAINgIQIAcgBjoAHyABIAdBEGo2AgwCQANAAkACQCAAKAIMQYMCayIGQR1LDQBBASAGdEGHgIiAAnFFBEAgBkEORw0BIAAQugYLIAEQ3QYgBRDdBiAFIAUoAhAiADYCFCAAIAlrIgFBgIAITg0BIAUoAgAiACgCNCIGIAlBAnRqQQRrIgggCCgCAEH//wFxIAFBD3RyNgIAIAQEQCAAIAUoAggoAiAgBiAFKAIQIABBFGpBBEH/////A0HtgioQuAYiBjYCNCAFIAUoAhAiAUEBajYCECAGIAFBAnRqIAogA0EYdHJBzAByNgIAIAUgACAFKAIIKAIIENwGAkAgBSgCACIAKAJAIAUoAhBqQQFrLAAAIgZBgH9HBEAgBSAFKAIYIAZrNgIYIAUgBS0ANUEBazoANQwBCyAFQYEBOgA1IAUgBSgCJEEBazYCJAsgBSAAIAIQ3AYgBSgCACIAKAI0IQYLIAAgBSgCCCgCICAGIAUoAhAgAEEUakEEQf////8DQe2CKhC4BiIGNgI0IAUgBSgCECIBQQFqNgIQIAYgAUECdGogCiAEQQJ0QaStL2ooAgByNgIAIAUgACAFKAIIKAIIENwGIAUoAhAiBiAJayIBQYCACE4NAyAFKAIAIgAoAjQgBkECdGpBBGsiBiAGKAIAQf//AXEgAUEPdHI2AgACQCAAKAJAIAUoAhBqQQFrLAAAIgZBgH9HBEAgBSAFKAIYIAZrNgIYIAUgBS0ANUEBazoANQwBCyAFQYEBOgA1IAUgBSgCJEEBazYCJAsgBSAAIAIQ3AYgB0EgaiQADwsgABC6BgwBCwsgBSgCCEHJ6SoQ2QYACyAFKAIIQcnpKhDZBgALIAUoAghBl/QpENkGAAsgAEGCAhC8BgALmgEBAn8jAEEwayICJAACfyABQf8BTQRAIAAoAiAhAyABQdGuL2otAABBBHEEQCACIAE2AhAgA0GVhywgAkEQahChBgwCCyACIAE2AgAgA0G9hywgAhChBgwBCyABQQJ0QbClL2ooAgAiAyABQZ8CSw0AGiAAKAIgIQEgAiADNgIgIAFBuoUsIAJBIGoQoQYLIQMgAkEwaiQAIAML7AsBBX8CQAJAAkACQAJAAkACQAJAAkACQCABKAIAQQlrDgsBAgAGAwQFCQkHCAkLAkACQAJAAkACQAJAIAAoAggoAjAoAgAgASgCBEEEdGoiAC0ABEE/cQ4VBAIOAAUODg4ODg4ODg4ODg4DDgEFDgsgAUEGNgIAIAEgACgCADYCBA8LIAFBBTYCACABIAAqAgA4AgQPCyABQQM2AgAPCyABQQI2AgAPCyABQQE2AgAPCyABQQc2AgAgASAAKAIANgIEDwsgAUEINgIAIAEgAS0ABDYCBA8LIAEoAgQhAyAAKAIAIgIgACgCCCgCICACKAI0IAAoAhAgAkEUakEEQf////8DQe2CKhC4BiIFNgI0IAAgACgCECIEQQFqNgIQIAUgBEECdGogA0EQdEEJcjYCACAAIAIgACgCCCgCCBDcBiAAKAIQIQAgAUERNgIAIAEgAEEBazYCBA8LIAEtAAYhAyABLwEEIQUgACgCACICIAAoAggoAiAgAigCNCAAKAIQIAJBFGpBBEH/////A0HtgioQuAYiBDYCNCAAIAAoAhAiBkEBajYCECAEIAZBAnRqIANBEHQgBUEYdHJBC3I2AgAgACACIAAoAggoAggQ3AYgACgCECEAIAFBETYCACABIABBAWs2AgQPCyAALQAyIQIgAS0ABiEEAkACQAJAA0AgAkEATA0BIAAoAggiAygCMCgCACAAKAIoQQR0aiACQQFrIgJBBHRqIgUtAAVBA0YNAAsgBS0ABiAEQf8BcUkNAQwCCyAAKAIIIQMLIAAgAC0ANEEBazoANCABLQAGIQQLIAEvAQQhBSAAKAIAIgIgAygCICACKAI0IAAoAhAgAkEUakEEQf////8DQe2CKhC4BiIDNgI0IAAgACgCECIGQQFqNgIQIAMgBkECdGogBEH/AXFBEHQgBUEYdHJBDXI2AgAgACACIAAoAggoAggQ3AYgACgCECEAIAFBETYCACABIABBAWs2AgQPCyAALQAyIQIgAS0ABiEEAkACQAJAA0AgAkEATA0BIAAoAggiAygCMCgCACAAKAIoQQR0aiACQQFrIgJBBHRqIgUtAAVBA0YNAAsgBS0ABiAEQf8BcUkNAQwCCyAAKAIIIQMLIAAgAC0ANEEBazoANCABLQAGIQQLIAEvAQQhBSAAKAIAIgIgAygCICACKAI0IAAoAhAgAkEUakEEQf////8DQe2CKhC4BiIDNgI0IAAgACgCECIGQQFqNgIQIAMgBkECdGogBEH/AXFBEHQgBUEYdHJBDnI2AgAgACACIAAoAggoAggQ3AYgACgCECEAIAFBETYCACABIABBAWs2AgQPCyABLgEEIQQgAS0ABiEGIAAtADIiAiEDAn8DQEEAIANBAEwNARogACgCCCgCMCgCACAAKAIoQQR0aiADQQFrIgNBBHRqIgUtAAVBA0YNAAsgBS0ABkEBagshAwJAAkAgBCAGSARAIAMgBk0EQCAAIAAtADRBAWs6ADQLAn8DQEEAIAJBAEwNARogACgCCCgCMCgCACAAKAIoQQR0aiACQQFrIgJBBHRqIgMtAAVBA0YNAAsgAy0ABkEBagsgBEwNAQwCCyADIARMBEAgACAALQA0QQFrOgA0CwNAIAJBAEwNASAAKAIIKAIwKAIAIAAoAihBBHRqIAJBAWsiAkEEdGoiAy0ABUEDRg0ACyADLQAGIAZPDQELIAAgAC0ANEEBazoANAsgAS0ABiEDIAEvAQQhBSAAKAIAIgIgACgCCCgCICACKAI0IAAoAhAgAkEUakEEQf////8DQe2CKhC4BiIENgI0IAAgACgCECIGQQFqNgIQIAQgBkECdGogA0EQdCAFQRh0ckEMcjYCACAAIAIgACgCCCgCCBDcBiAAKAIQIQAgAUERNgIAIAEgAEEBazYCBA8LIAFBCDYCACABIAAoAgAoAjQgASgCBEECdGooAgBBB3ZB/wFxNgIEDwsgACgCACgCNCABKAIEQQJ0akECOgADIAFBETYCAAsLqQMCBn8DfSMAQSBrIgUkAAJAIAIoAgggAigCDEcEQAwBC0EDIQYCQAJAIAIoAgBBBWsOAgABAgtBEyEGQQEhBwsgAioCBCEKIAUgBjoAHCAFIAo4AhggAygCCCADKAIMRw0AQQEhCEEDIQYCQAJAIAMoAgBBBWsOAgABAgtBEyEGQQEhBEEAIQgLIAQhCSADKgIEIQsgBSAGOgAUIAUgCzgCEAJAIAFBDUsNAEEBIAF0IgRBgN8AcUUEQCAEQegAcUUNASALvLIgCyAIG0MAAAAAXA0BQQAhBAwCCyAHBEBBACEEIAogCo4iDFwNAiAMQwAAAM9gRQ0CIAxDAAAAT11FDQILIAlFDQBBACEEIAsgC44iClwNASAKQwAAAM9gRQ0BIApDAAAAT11FDQELIAAoAggoAiAgASAFQRhqIAVBEGogBUEIahDSBhogBS0ADEEDRgRAIAJBBjYCACACIAUoAgg2AgRBASEEDAELQQEhBCAFKgIIIgpDAAAAAF4gCkMAAAAAXXJFBEBBACEEDAELIAIgCjgCBCACQQU2AgALIAVBIGokACAEC6gHAQd/IAAgASACEPYGAkAgASgCAEEQRw0AIAEoAgQiB0F/Rg0AAkAgASgCCCIDQX9HBEAgACgCACgCNCEFA0AgBSADIgRBAnRqIggoAgAiBkEHdkH///8HayIDQX9HBEAgAyAEakEBaiIDQX9HDQELCyAHIARBf3NqIgNB////B2pBgICAEE8NASAIIAZB/wBxIANBB3RyQYD///8HajYCAAwCCyABIAc2AggMAQsgACgCCEHJ6SoQ2QYACyABKAIIIgMgASgCDCIHRwRAQX8hCQJ/AkACQAJAIANBf0YNACAAKAIAIgYoAjQhCANAIAggA0ECdGohBAJAIANBAEoEQCAEQQRrKAIAIgVB/wBxQcQAa0F0Sw0BCyAEKAIAIQULIAVB/wBxQcMARw0CIAQoAgBBB3ZB////B2siBEF/Rg0BIAMgBGpBAWoiA0F/Rw0ACwtBfyEFQX8gB0F/Rg0CGiAAKAIAIgYoAjQhCCAHIQMDQCAIIANBAnRqIQQCQCADQQBKBEAgBEEEaygCACIFQf8AcUHEAGtBdEsNAQsgBCgCACEFCyAFQf8AcUHDAEcNAUF/IQUgBCgCAEEHdkH///8HayIEQX9GDQIgAyAEakEBaiIDQX9HDQALDAELAn8gASgCAEEQRgRAIAAoAhAhA0F/DAELIAYgACgCCCgCICAIIAAoAhAgBkEUakEEQf////8DQe2CKhC4BiIDNgI0IAAgACgCECIEQQFqNgIQIAMgBEECdGpBuP7//wc2AgAgACAGIAAoAggoAggQ3AYgACgCACEGIAAoAhAiA0EBawshBSAAIAM2AhQgBiAAKAIIKAIgIAYoAjQgAyAGQRRqQQRB/////wNB7YIqELgGIgM2AjQgACAAKAIQIgRBAWo2AhAgAyAEQQJ0aiACQQd0IghBBnI2AgAgACAGIAAoAggoAggQ3AYgACAAKAIQIgQ2AhQgACgCACIDIAAoAggoAiAgAygCNCAEIANBFGpBBEH/////A0HtgioQuAYiBjYCNCAAIAAoAhAiB0EBajYCECAGIAdBAnRqIAhBB3I2AgAgACADIAAoAggoAggQ3AYgACAAKAIQIgM2AhQgACAFIANB/wEgAxDfBiADQQFrIQUgASgCDCEJIARBAWsMAQsgByEJQX8LIQQgACAAKAIQIgM2AhQgACAJIAMgAiAEEN8GIAAgASgCCCADIAIgBRDfBgsgASACNgIEIAFCfzcCCCABQQg2AgAL6wYCBX8DfSMAQRBrIgQkACAAIAEQ8wYCQAJAAkACQAJAAkACQAJAAkACQAJAIAEoAgBBAWsOEQEDAgAFBgQICgoKCgoKCgoHCgsgACACIAEoAgQQigcMCAsgACACQQEQ/AYMBwsgACgCACIDIAAoAggoAiAgAygCNCAAKAIQIANBFGpBBEH/////A0HtgioQuAYiBTYCNCAAIAAoAhAiBkEBajYCECAFIAZBAnRqIAJBB3RBBXI2AgAgACADIAAoAggoAggQ3AYMBgsgACgCACIDIAAoAggoAiAgAygCNCAAKAIQIANBFGpBBEH/////A0HtgioQuAYiBTYCNCAAIAAoAhAiBkEBajYCECAFIAZBAnRqIAJBB3RBB3I2AgAgACADIAAoAggoAggQ3AYMBQsgBCABKAIEIgM2AgggBCADLQAEQcAAcjoADCAAIARBCGogBEEIahCJByEDIAFBBDYCACABIAM2AgQgACACIAMQigcMBAsCQCABKgIEIgggCI4iCVsEQAJAIAlDAAAAz2AiA0UNACAJQwAAAE9dRQ0AIAn8ACIFQYGABGtBgIB4SQ0AIAAoAgAiAyAAKAIIKAIgIAMoAjQgACgCECADQRRqQQRB/////wNB7YIqELgGIgY2AjQgACAAKAIQIgdBAWo2AhAgBiAHQQJ0aiAFQQ90QYCA/v8HaiACQQd0ckECcjYCACAAIAMgACgCCCgCCBDcBgwGCyAEQRM6AAwgBCAIOAIIIANFDQEgCUMAAABPXUUNASAEQRM6AAQgBCAIQwAAgD9BaRAlIgqUIAiSIAogCfwAGzgCACAAIAIgACAEIARBCGoQiQcQigcMBQsgBEETOgAMIAQgCDgCCAsgACACIAAgBEEIaiAEQQhqEIkHEIoHDAMLIAAgAiABKAIEEPAGDAILIAAoAgAoAjQgASgCBEECdGoiACAAKAIAQf+AfnEgAkEHdEGA/wFxcjYCAAwBCyACIAEoAgQiBUYNACAAKAIAIgMgACgCCCgCICADKAI0IAAoAhAgA0EUakEEQf////8DQe2CKhC4BiIGNgI0IAAgACgCECIHQQFqNgIQIAYgB0ECdGogBUEQdCACQQd0cjYCACAAIAMgACgCCCgCCBDcBgsgAUEINgIAIAEgAjYCBAsgBEEQaiQAC6oNAgt/AX4jAEEgayIDJAAgACgCBCEIIAAoAhwiBCgCACICIAQoAggoAiAgAigCNCAEKAIQIAJBFGpBBEH/////A0HtgioQuAYiBTYCNCAEIAQoAhAiBkEBajYCECAFIAZBAnRqQRM2AgAgBCACIAQoAggoAggQ3AYgBCgCACICIAQoAggoAiAgAigCNCAEKAIQIgogAkEUakEEQf////8DQe2CKhC4BiIFNgI0IAQgBCgCECIGQQFqNgIQIAUgBkECdGpBADYCACAEIAIgBCgCCCgCCBDcBiADQgA3AhQgA0EANgIcIAMgATYCECABIAQtADQ2AgQgAUEINgIAIAFCfzcCCCAELQA0IgJBAWohBQJAAkACQCAEKAIAIgYtAAggAk0EQCACQf4BTw0BIAYgBToACAsgBCAFOgA0IANCADcCACADQn83AgggACgCDEH7AEcNASAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDSAAQaACNgIUIAAgDTcCDCANpyECDAELIAAgACAAQRBqELkGIgI2AgwLAkAgAkH9AEYNACAAQRBqIQUgAEEYaiEGA0AgAygCAARAIAQgAxDjBiADQQA2AgAgAygCHEEyRgRAIAQgAygCECgCBCADKAIYQTIQgAcgAygCHCECIANBADYCHCADIAIgAygCGGo2AhgLIAAoAgwhAgsCQAJAAkAgAkHbAEYNACACQaMCRw0BIAAgACAGELkGIgI2AhQgAkE9Rg0AIAAgA0EAENoGGiADIAMoAhxBAWo2AhwMAgsjAEEwayICJAAgACgCHCIJLQA0IQsCQAJAAkACQCAAKAIMQaMCRgRAIAAgACgCBDYCCCAAKAIQIQwCQCAAKAIUQaACRwRAIAApAhQhDSAAQaACNgIUIAAgDTcCDCANpyEHDAELIAAgACAAQRBqELkGIgc2AgwLIAIgDDYCFCACQQc2AhAgAkJ/NwIYDAELIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCENIABBoAI2AhQgACANNwIMDAELIAAgACAAQRBqELkGNgIMCyAAIAJBEGpBABDaBhogACgCHCACQRBqEP8GIAAoAgxB3QBHDQEgACAAKAIENgIIIAAoAhRBoAJHBEAgACkCFCENIABBoAI2AhQgACANNwIMIA2nIQcMAQsgACAAIABBEGoQuQYiBzYCDAsgAyADKAIUQQFqNgIUIAdBPUcNASAAIAAoAgQ2AggCQCAAKAIUQaACRwRAIAApAhQhDSAAQaACNgIUIAAgDTcCDAwBCyAAIAAgAEEQahC5BjYCDAsgAiADKAIQ/QACAP0LAyAgCSACQSBqIAJBEGoQ7AYgACACQQAQ2gYaIAkgAkEgaiACEO0GIAkgCzoANCACQTBqJAAMAgsgAEHdABC8BgALIABBPRC8BgALDAELIAAgA0EAENoGGiADIAMoAhxBAWo2AhwLAkAgACgCDEEsaw4QAAICAgICAgICAgICAgICAAILIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCENIABBoAI2AhQgACANNwIMIA2nIQIMAQsgACAAIAUQuQYiAjYCDAsgAkH9AEcNAAsLIABB/QBB+wAgCBDuBgJ/IAMoAhwiAEUEQCADKAIYDAELAn8CQAJAAkAgAygCACICDhQCAQEBAQEBAQEBAQEBAQEBAQEAAAELIAQoAgAiBigCNCADKAIEQQJ0aiIAKAIAIQUCQCACQRJGBEAgACAFQf///wdxNgIADAELIAAgBUH/gP4HcSAELQA0IgJBB3RyNgIAIAJBAWohACAGLQAIIAJNBEAgAkH+AU8NCCAGIAA6AAgLIAQgADoANAsgBCADKAIQKAIEIAMoAhhBfxCAByADKAIYQQFrDAILIAQgAxDjBiADKAIcIQALIAQgAygCECgCBCADKAIYIAAQgAcgAygCGAsgAygCHGoLIQYgBCgCACgCNCEIIAEoAgQhAUEAIQAgAygCFCIEBEBBACECAkAgBEEBayIAQYACSQRAIAAhBQwBCwNAIAJBCGohAiAAQf//A0shBCAAQQh2IgUhACAEDQALCyACIAVB8Kovai0AAGpBEHRBgIAEaiEACyAIIApBAnRqIgIgBkGAAm1BB3RB0gByNgIAIAJBBGsgAUEHdCAGQRh0ckGAgAJBACAGQf8BShtyIAByQRNyNgIAIANBIGokAA8LIAQoAghBl/QpENkGAAsgAEH7ABC8BgALIAQoAghBl/QpENkGAAueAQEDfyAAIAEQ+gYEQEEBDwsgACABEPMGAkACQCABKAIAQQhHDQAgASgCCCABKAIMRg0BIAAtADIhAiABKAIEIQMCfwNAQQAgAkEATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIAJBAWsiAkEEdGoiBC0ABUEDRg0ACyAELQAGQQFqCyADSg0AIAAgASADEPUGQQAPCyAAIAEQ4wYLQQALlwcBBX8gACABEPMGAkACQCABKAIAQQhHDQAgASgCCCABKAIMRg0BIAAtADIhCSABKAIEIQsCfwNAQQAgCUEATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIAlBAWsiCUEEdGoiCi0ABUEDRg0ACyAKLQAGQQFqCyALSg0AIAAgASALEPUGDAELIAAgARDjBgsgASgCBCEMIAAoAgAiCSAAKAIIKAIgIAkoAjQgACgCECAJQRRqQQRB/////wNB7YIqELgGIgo2AjQgACAAKAIQIgtBAWo2AhAgCiALQQJ0aiAEQRh0IANyIAxBEHRyNgIAIAAgCSAAKAIIKAIIENwGQX8hAyABKAIAQQhGBEAgASgCBCEDCyAAKAIQIQlBfyELIAIoAgBBCEYEQCACKAIEIQsLIAlBAWshDSAALQAyIgkhCgJ/A0BBACAKQQBMDQEaIAAoAggoAjAoAgAgACgCKEEEdGogCkEBayIKQQR0aiICLQAFQQNGDQALIAItAAZBAWoLIQoCQAJAIAMgC0oEQCADIApOBEAgACAALQA0QQFrOgA0CwJ/A0BBACAJQQBMDQEaIAAoAggoAjAoAgAgACgCKEEEdGogCUEBayIJQQR0aiIKLQAFQQNGDQALIAotAAZBAWoLIAtMDQEMAgsgCiALTARAIAAgAC0ANEEBazoANAsCfwNAQQAgCUEATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIAlBAWsiCUEEdGoiCi0ABUEDRg0ACyAKLQAGQQFqCyADSg0BCyAAIAAtADRBAWs6ADQLIAFBETYCACABIA02AgQCQCAAKAIAIgkoAkAgACgCEGpBAWssAAAiCkGAf0cEQCAAIAAoAhggCms2AhggACAALQA1QQFrOgA1DAELIABBgQE6ADUgACAAKAIkQQFrNgIkCyAAIAkgBhDcBiAAKAIAIgkgACgCCCgCICAJKAI0IAAoAhAgCUEUakEEQf////8DQe2CKhC4BiIKNgI0IAAgACgCECICQQFqNgIQIAogAkECdGogBUEPdCAEQRB0ciAIQRh0ciAMQQd0IAdycjYCACAAIAkgACgCCCgCCBDcBiAAKAIAIgkoAkAgACgCEGpBAWssAAAiCkGAf0cEQCAAIAAoAhggCms2AhggACAALQA1QQFrOgA1IAAgCSAGENwGDwsgAEGBAToANSAAIAAoAiRBAWs2AiQgACAJIAYQ3AYLnQMCA38DfSMAQRBrIgIkAAJAIAEoAgggASgCDEcNAAJ/AkACQAJAAkACQAJAAkAgASgCAEEBaw4HAgABBgQDBQgLIAJBEToADCAAIAJBCGogAkEIahCJBwwGCyACQQE6AAwgACACQQhqIAJBCGoQiQcMBQsgAkEAOgAEIAAoAggoAiwhAyACQcUAOgAMIAIgAzYCCCAAIAJBCGogAhCJBwwECyABKAIEIQMgAkEDOgAMIAIgAzYCCCAAIAJBCGogAkEIahCJBwwDCyABKgIEIQUgAkETOgAMIAIgBTgCCAJAAkAgBSAFjiIGXA0AIAZDAAAAz2BFDQAgBkMAAABPXQ0BCyAAIAJBCGogAkEIahCJBwwDCyACQRM6AAQgAiAFQwAAgD9BaRAlIgeUIAWSIAcgBvwAGzgCACAAIAIgAkEIahCJBwwCCyACIAEoAgQiAzYCCCACIAMtAARBwAByOgAMIAAgAkEIaiACQQhqEIkHDAELIAEoAgQLIgBB/wFKDQAgASAANgIEIAFBBDYCAEEBIQQLIAJBEGokACAEC6wBAQN/IAAgAxDzBgJAAkAgAygCAEEIRw0AIAMoAgggAygCDEYNASAALQAyIQUgAygCBCEGAn8DQEEAIAVBAEwNARogACgCCCgCMCgCACAAKAIoQQR0aiAFQQFrIgVBBHRqIgctAAVBA0YNAAsgBy0ABkEBagsgBkoNACAAIAMgBhD1BgwBCyAAIAMQ4wYLIAAgAiADIAFBImogAygCBEEAIARBLiABQQZqEPkGC6cCAQZ/QeSwLyEDIAAoAhAiCCAAKAIUSgRAIAAoAgAoAjQgCEECdGpBBGshAwsCQCADKAIAIgVB/wBxQQhHDQAgASACaiEGIAVBB3ZB/wFxIgQgBUEQdkH/AXFqIQcgASAHQQFqTCABIAROcUUEQCABIARKDQEgBCAGSg0BCyADIAQgASABIARKGyIAQQd0QYD/AXEgBUGIgIJ4cXIgBkH/AWogByAGIAdKGyAAa0EQdEGAgPwHcXI2AgAPCyAAKAIAIgMgACgCCCgCICADKAI0IAggA0EUakEEQf////8DQe2CKhC4BiIFNgI0IAAgACgCECIEQQFqNgIQIAUgBEECdGogAkEQdEGAgARrIAFBB3RyQQhyNgIAIAAgAyAAKAIIKAIIENwGC6cHAQp/IABFBEAgAkIANwIAIAJCfzcCCA8LIAAtADIhBAJAAkACQANAIARBAEwNASABIAAoAggoAjAoAgAgACgCKCIGQQR0aiAEQQFrIgRBBHRqIgUoAgxHDQALIAUtAAVBA0YEQCACQQs2AgAgAkJ/NwIIIAIgBCAGajYCBA8LIAIgBDsBBiACQQk2AgAgAkJ/NwIIIAIgACgCCCgCMCgCACAAKAIoQQR0aiAEQQR0ai0ABjoABCADDQEgAEEMaiEBA0AgBCABKAIAIgEtAAxJDQALIAFBAToADSAAQQE6ADYPCwJAIAAtADMiBQRAIAAoAgAoAjwhBkEAIQQDQCAGIARBA3RqKAIAIAFGDQIgBEEBaiIEIAVHDQALCyAAKAIEIAEgAkEAEP0GIAIoAgBBCWtBAUsNASAALQAzIgVB/wFGDQIgACgCACIEKAIMIQcgBCAAKAIIKAIgIAQoAjwgBSAEQQxqQQhB/wFBof4pELgGIgY2AjwCQCAHIAQoAgwiCE4NACAIIAciBWtBB3EiAwRAQQAhBANAIAYgBUEDdGpBADYCACAFQQFqIQUgBEEBaiIEIANHDQALCyAHIAhrQXhLDQAgBkE4aiEDIAZBMGohByAGQShqIQkgBkEgaiEKIAZBGGohCyAGQRBqIQwgBkEIaiENA0AgBiAFQQN0IgRqQQA2AgAgBCANakEANgIAIAQgDGpBADYCACAEIAtqQQA2AgAgBCAKakEANgIAIAQgCWpBADYCACAEIAdqQQA2AgAgAyAEakEANgIAIAVBCGoiBSAIRw0ACwsgACAALQAzIgRBAWoiAzoAMyAGIARBA3RqIQQgACgCBCEFAn8gAigCAEEJRgRAIARBAToABCAEIAItAAQ6AAUgBSgCCCgCMCgCACAFKAIoQQR0aiACLwEGQQR0akEFagwBCyAEQQA6AAQgBCACKAIEOgAFIAUoAgAoAjwgAigCBEEDdGpBBmoLLQAAIQUgBCABNgIAIAQgBToABgJAIAAoAgAiBC0ABSIFQSBxRQ0AIAEtAAVBGHFFDQACQCAAKAIIKAIgKAIQIgYtADlBAk0EQCAGIAEQjgYgBC0ABUEGcUUNASABIAEtAAVB+AFxQQJyOgAFDAELIAYtADoNACAEIAYtADhBGHEgBUHHAXFyOgAFCyAALQAzIQMLIANB/wFxQQFrIQQLIAIgBDYCBCACQQo2AgAgAkJ/NwIICw8LIABB/wFBof4pEL0GAAvNBgIHfwF+IwBBEGsiBCQAIAAoAhwhAiAAKAIEIQYCQAJ/AkACQCAAKAIMIgNBpAJHBEACQCADQfsARwRAIANBKEYEQCAAIAY2AggCQCAAKAIUQaACRwRAIAApAhQhCSAAQaACNgIUIAAgCTcCDCAJpyEDDAELIAAgACAAQRBqELkGIgM2AgwLAkAgA0EpRgRAIARBADYCAAwBCyAAIARBABDaBhogACgCDEEsRgRAIABBEGohAwNAIAAgACgCBDYCCAJAIAAoAhRBoAJHBEAgACkCFCEJIABBoAI2AhQgACAJNwIMDAELIAAgACADELkGNgIMCyAAKAIcIAQQ4wYgACAEQQAQ2gYaIAAoAgxBLEYNAAsLIAQoAgAiA0F+cUESRw0AIAIoAgAiBygCNCAEKAIEQQJ0aiIFKAIAIQggA0ESRgRAIAUgCEH///8HcTYCAAwBCyAFIAhB/4D+B3EgAi0ANCIDQQd0cjYCACADQQFqIQUgBy0ACCADTQRAIANB/gFPDQkgByAFOgAICyACIAU6ADQLIABBKUEoIAYQ7gYMAgsgAEGptSsQ2QYACyAAIAQQ9wYLIAEoAgQhA0EAIAQoAgAiAEF+cUESRg0DGiAADQEMAgsgBCAAKAIQNgIEIARBBzYCACAEQn83AgggACAGNgIIAkAgACgCFEGgAkcEQCAAKQIUIQkgAEGgAjYCFCAAIAk3AgwMAQsgACAAIABBEGoQuQY2AgwLIAEoAgQhAwsgAiAEEOMGCyACLQA0IANrQRB0CyEFIAIoAgAiACACKAIIKAIgIAAoAjQgAigCECAAQRRqQQRB/////wNB7YIqELgGIgg2AjQgAiACKAIQIgdBAWo2AhAgCCAHQQJ0aiADQQd0IAVyQcSAgBByNgIAIAIgACACKAIIKAIIENwGIAIoAhAhACABQRI2AgAgAUJ/NwIIIAEgAEEBazYCBAJAIAIoAgAiACgCQCACKAIQakEBaywAACIBQYB/RwRAIAIgAigCGCABazYCGCACIAItADVBAWs6ADUMAQsgAkGBAToANSACIAIoAiRBAWs2AiQLIAIgACAGENwGIAIgA0EBajoANCAEQRBqJAAPCyACKAIIQZf0KRDZBgALogEBA38gASgCDCECIAEoAgghAyAAIAEQ8wYCQCACIANGDQACQCABKAIAQQhHDQAgASgCCCABKAIMRg0BIAAtADIhAiABKAIEIQQCfwNAQQAgAkEATA0BGiAAKAIIKAIwKAIAIAAoAihBBHRqIAJBAWsiAkEEdGoiAy0ABUEDRg0ACyADLQAGQQFqCyAESg0AIAAgASAEEPUGDwsgACABEOMGCwuTAgEDfyAAKAIAIgQgACgCCCgCICAEKAI0IAAoAhAgBEEUakEEQf////8DQe2CKhC4BiIFNgI0IAAgACgCECIGQQFqNgIQIAFBB3QgAkEYdHIgA0EQdEEAIANBf0cbciEDIAUgBkECdGohBQJAIAJB/wFMBEAgBSADQc4AcjYCAAwBCyAFIANBzoACcjYCACAAIAQgACgCCCgCCBDcBiAAKAIAIgQgACgCCCgCICAEKAI0IAAoAhAgBEEUakEEQf////8DQe2CKhC4BiIDNgI0IAAgACgCECIFQQFqNgIQIAMgBUECdGogAkEBdkGA////A3FB0gByNgIACyAAIAQgACgCCCgCCBDcBiAAIAFBAWo6ADQL0wcBB38jAEGgAWsiAyQAIAAoAgQhBiAAKAIgIQgCQCAAKAI0IgQEQCAEQRBqIQcgBC0AByIFQf8BRgRAIAQoAgwhBQsCQAJAAkAgBy0AAEE9aw4EAAICAQILIARBEWohBCAFQTxNBEAgBUUNBCADQeAAaiAEIAX8CgAADAQLIAMgBCgANzYAlwEgAyAEKQAwNwOQASADIAT9AAAg/QsEgAEgAyAE/QAAEP0LBHAgAyAE/QAAAP0LBGAgA0EAOgCbAQwDCyAFQTxNBEAgBUUNAyADQeAAaiAEQRFqIAX8CgAADAMLIANBy/UrLQAAOgBiIANByfUrLwAAOwFgIAMgBCAFaiIE/QAAAP0LAIsBIAMgBC0AEDoAmwEgAyAEQShrIgT9AAAY/QsAeyADIAQpAAA3AGMgAyAE/QAACP0LAGsMAgsgB0EKEJ4BIQQgA0H6hywtAAA6AGggA0HyhywpAAA3A2AgA0HgAGpBCXIhCQJ/AkAgBUEsSw0AIAQNACAFBEAgCSAHIAX8CgAACyAFIAlqDAELQS0gBCAHayAFIAQbIgQgBEEtTxsiBARAIAkgByAE/AoAAAsgBCAJaiIEQcv1Ky0AADoAAiAEQcn1Ky8AADsAACAEQQNqCyIEQfbZKy0AADoAAiAEQfTZKy8AADsAAAwBCyADQT87AWALIAMgATYCWCADIAY2AlQgAyADQeAAajYCUCAIQbyLKiADQdAAahChBiEEAkACQCACBEAgACgCICEBIAMCfyACQaECa0EDTQRAAkAgACgCKCICKAIEIghBAWoiBSACKAIIIgZNBEAgAigCACEHDAELIAZB/////wNPDQQgASgCECIIKAIEIAIoAgAiByAGIAZBAXQiCSAIKAIAEQIAIQVBACAGAn8CQCAGRQ0AIAUNAEEAIAEgByAGIAkQgwYiBUUNARoLIAggBiAIKAIMajYCDCAFCyIHGw0FIAIgCTYCCCACIAc2AgAgAigCBCIIQQFqIQULIAIgBTYCBCAHIAhqQQA6AAAgACgCICECIAMgACgCKCgCADYCECACQbqFLCADQRBqEKEGDAELIAJB/wFMBEAgAkHRri9qLQAAQQRxBEAgAyACNgIwIAFBlYcsIANBMGoQoQYMAgsgAyACNgIgIAFBvYcsIANBIGoQoQYMAQsgAkECdEGwpS9qKAIAIgYgAkGfAksNABogAyAGNgJAIAFBuoUsIANBQGsQoQYLNgIEIAMgBDYCACABQbWGKiADEKEGGgsgACgCIEEDEIQGAAsgAEGw6SpBABCBBwALIAFBBBCEBgAL2wIBBn8jAEEQayIEJABBfyECIAAoAgAhBSAAKAIkIgEgASgCACIDQQFrNgIAAkAgAwRAIAEgASgCBCICQQFqNgIEIAItAAAhAgwBCyABKAIQIAEoAgwgBEEIaiABKAIIEQQAIgNFDQAgBCgCCCIGRQ0AIAEgA0EBajYCBCABIAZBAWs2AgAgAy0AACECCyAAIAI2AgACQAJAIAJBCmsOBAABAQABCyACIAVGDQBBfyECIAAoAiQiASABKAIAIgNBAWs2AgACQCADBEAgASABKAIEIgJBAWo2AgQgAi0AACECDAELIAEoAhAgASgCDCAEQQxqIAEoAggRBAAiA0UNACAEKAIMIgVFDQAgASADQQFqNgIEIAEgBUEBazYCACADLQAAIQILIAAgAjYCAAsgACAAKAIEQQFqIgE2AgQgAUH/////B0YEQCAAQfOBKkEAEIEHAAsgBEEQaiQAC/0FAQp/IwBBEGsiByQAIAAoAgAhCQJAAkACQAJAAkAgACgCKCIBKAIEIgRBAWoiBSABKAIIIgJNBEAgASgCACEDDAELIAJB/////wNPDQEgACgCICIGKAIQIgQoAgQgASgCACIIIAIgAkEBdCIFIAQoAgARAgAhAwJAAkAgAkUNACADDQAgBiAIIAIgBRCDBiIDDQBBACEDDAELIAQgAiAEKAIMajYCDAtBACACIAMbDQIgASAFNgIIIAEgAzYCACABKAIEIgRBAWohBQsgASAFNgIEIAMgBGogCToAAEF/IQIgACgCJCIBIAEoAgAiA0EBazYCAAJAIAMEQCABIAEoAgQiAkEBajYCBCACLQAAIQIMAQsgASgCECABKAIMIAdBCGogASgCCBEEACIDRQ0AIAcoAggiBEUNACABIANBAWo2AgQgASAEQQFrNgIAIAMtAAAhAgsgACACNgIAQQAhBiACQT1GBEADQAJAIAAoAigiASgCBCIEQQFqIgUgASgCCCICTQRAIAEoAgAhAwwBCyACQf////8DTw0FIAAoAiAiCCgCECIEKAIEIAEoAgAiCiACIAJBAXQiBSAEKAIAEQIAIQMCQAJAIAJFDQAgAw0AIAggCiACIAUQgwYiAw0AQQAhAwwBCyAEIAIgBCgCDGo2AgwLQQAgAiADGw0GIAEgBTYCCCABIAM2AgAgASgCBCIEQQFqIQULIAEgBTYCBCADIARqQT06AAAgACgCJCIBIAEoAgAiAkEBazYCAAJAIAIEQCABIAEoAgQiAkEBajYCBCACLQAAIQIMAQtBfyECIAEoAhAgASgCDCAHQQxqIAEoAggRBAAiA0UNACAHKAIMIgRFDQAgASADQQFqNgIEIAEgBEEBazYCACADLQAAIQILIAAgAjYCACAGQQFqIQYgAkE9Rg0ACwsgB0EQaiQAIAZBAmogBkUgAiAJRhsPCyAAQbDpKkEAEIEHAAsgBkEEEIQGAAsgAEGw6SpBABCBBwALIAhBBBCEBgAL6gwBCn8jAEEQayIIJAAgACgCACEJIAAoAgQhDAJAAkACQCAAKAIoIgMoAgQiBkEBaiIHIAMoAggiBE0EQCADKAIAIQUMAQsgBEH/////A08NAiAAKAIgIgooAhAiBigCBCADKAIAIgsgBCAEQQF0IgcgBigCABECACEFAkACQCAERQ0AIAUNACAKIAsgBCAHEIMGIgUNAEEAIQUMAQsgBiAEIAYoAgxqNgIMC0EAIAQgBRsNASADIAc2AgggAyAFNgIAIAMoAgQiBkEBaiEHCyADIAc2AgQgBSAGaiAJOgAAQX8hBCAAKAIkIgMgAygCACIFQQFrNgIAAkAgBQRAIAMgAygCBCIEQQFqNgIEIAQtAAAhBAwBCyADKAIQIAMoAgwgCEEMaiADKAIIEQQAIgVFDQAgCCgCDCIGRQ0AIAMgBUEBajYCBCADIAZBAWs2AgAgBS0AACEECyAAIAQ2AgACQAJAIARBCmsOBAABAQABCyAAEIIHCwNAAkACQAJAAkACQAJAAkACQAJAIAAoAgAiA0EBag4PAAMDAwMDAwMDAwMBAwMBAgsgACgCICEDIAggDDYCBCAIQfjtKkGC2ikgARs2AgAgACADQZn9KyAIEKEGQaACEIEHAAsCQCAAKAIoIgMoAgQiBkEBaiIHIAMoAggiBE0EQCADKAIAIQUMAQsgBEH/////A08NAyAAKAIgIgkoAhAiBigCBCADKAIAIgogBCAEQQF0IgcgBigCABECACEFAkACQCAERQ0AIAUNACAJIAogBCAHEIMGIgUNAEEAIQUMAQsgBiAEIAYoAgxqNgIMC0EAIAQgBRsNBCADIAc2AgggAyAFNgIAIAMoAgQiBkEBaiEHCyADIAc2AgQgBSAGakEKOgAAIAAQggcgAQ0HIAAoAihBADYCBAwHCyADQd0ARg0FCyABBEACQCAAKAIoIgQoAgQiB0EBaiIJIAQoAggiBU0EQCAEKAIAIQYMAQsgBUH/////A08NBCAAKAIgIgooAhAiBygCBCAEKAIAIgsgBSAFQQF0IgkgBygCABECACEGAkACQCAFRQ0AIAYNACAKIAsgBSAJEIMGIgYNAEEAIQYMAQsgByAFIAcoAgxqNgIMC0EAIAUgBhsNBSAEIAk2AgggBCAGNgIAIAQoAgQiB0EBaiEJCyAEIAk2AgQgBiAHaiADOgAAIAAoAiQiAyADKAIAIgRBAWs2AgAgBARAIAMgAygCBCIEQQFqNgIEIAAgBC0AADYCAAwHC0F/IQQCQCADKAIQIAMoAgwgCEEMaiADKAIIEQQAIgVFDQAgCCgCDCIGRQ0AIAMgBUEBajYCBCADIAZBAWs2AgAgBS0AACEECyAAIAQ2AgAMBgsgACgCJCIDIAMoAgAiBEEBazYCACAEBEAgAyADKAIEIgRBAWo2AgQgACAELQAANgIADAYLQX8hBAJAIAMoAhAgAygCDCAIQQxqIAMoAggRBAAiBUUNACAIKAIMIgZFDQAgAyAFQQFqNgIEIAMgBkEBazYCACAFLQAAIQQLIAAgBDYCAAwFCyAAQbDpKkEAEIEHAAsgCUEEEIQGAAsgAEGw6SpBABCBBwALIApBBBCEBgALIAAQgwcgAkcNAAsgACgCACEJAkACQAJAIAAoAigiAygCBCIGQQFqIgcgAygCCCIETQRAIAMoAgAhBQwBCyAEQf////8DTw0BIAAoAiAiCigCECIGKAIEIAMoAgAiCyAEIARBAXQiByAGKAIAEQIAIQUCQAJAIARFDQAgBQ0AIAogCyAEIAcQgwYiBQ0AQQAhBQwBCyAGIAQgBigCDGo2AgwLQQAgBCAFGw0CIAMgBzYCCCADIAU2AgAgAygCBCIGQQFqIQcLIAMgBzYCBCAFIAZqIAk6AABBfyEEIAAoAiQiAyADKAIAIgVBAWs2AgACQCAFBEAgAyADKAIEIgRBAWo2AgQgBC0AACEEDAELIAMoAhAgAygCDCAIQQxqIAMoAggRBAAiBUUNACAIKAIMIgZFDQAgAyAFQQFqNgIEIAMgBkEBazYCACAFLQAAIQQLIAAgBDYCACABBEAgASAAIAAoAigiAygCACACaiADKAIEIAJBAXRrEO8GNgIACyAIQRBqJAAPCyAAQbDpKkEAEIEHAAsgCkEEEIQGAAsgCkEEEIQGAAsgAEGw6SpBABCBBwALXgEEfyMAQRBrIgEkAEF/IQICQCAAKAIQIAAoAgwgAUEMaiAAKAIIEQQAIgNFDQAgASgCDCIERQ0AIAAgA0EBajYCBCAAIARBAWs2AgAgAy0AACECCyABQRBqJAAgAgv2AwEJfyMAQRBrIgYkACAAKAIAIQgCQAJAAkAgACgCKCIBKAIEIgRBAWoiBSABKAIIIgJNBEAgASgCACEDDAELIAJB/////wNPDQEgACgCICIHKAIQIgQoAgQgASgCACIJIAIgAkEBdCIFIAQoAgARAgAhAwJAAkAgAkUNACADDQAgByAJIAIgBRCDBiIDDQBBACEDDAELIAQgAiAEKAIMajYCDAtBACACIAMbDQIgASAFNgIIIAEgAzYCACABKAIEIgRBAWohBQsgASAFNgIEIAMgBGogCDoAAEF/IQEgACgCJCICIAIoAgAiA0EBazYCAAJAIAMEQCACIAIoAgQiAUEBajYCBCABLQAAIQEMAQsgAigCECACKAIMIAZBDGogAigCCBEEACIDRQ0AIAYoAgwiBEUNACACIANBAWo2AgQgAiAEQQFrNgIAIAMtAAAhAQsgACABNgIAIAFB0a4vai0AACICQRBxRQRAIAFBf0cEQCAAIAEQhwcgACgCJCIBIAEoAgAiAkEBazYCACAAAn8gAgRAIAEgASgCBCICQQFqNgIEIAItAAAMAQsgARCFBws2AgALIABBjrUrQaQCEIEHAAsgBkEQaiQAIAFBMGsgAUEgckHXAGsgAkECcRsPCyAAQbDpKkEAEIEHAAsgB0EEEIQGAAvgAQEGfwJAAkACQCAAKAIoIgIoAgQiBEEBaiIFIAIoAggiA00EQCACKAIAIQAMAQsgA0H/////A08NASAAKAIgIgYoAhAiBCgCBCACKAIAIgcgAyADQQF0IgUgBCgCABECACEAAkACQCADRQ0AIAANACAGIAcgAyAFEIMGIgANAEEAIQAMAQsgBCADIAQoAgxqNgIMC0EAIAMgABsNAiACIAU2AgggAiAANgIAIAIoAgQiBEEBaiEFCyACIAU2AgQgACAEaiABOgAADwsgAEGw6SpBABCBBwALIAZBBBCEBgALlgMBCH8jAEEQayIHJAACQAJAAn8gACgCACIGIAEsAABHBEBBACAGIAEsAAFHDQEaCwJAIAAoAigiASgCBCIEQQFqIgUgASgCCCICTQRAIAEoAgAhAwwBCyACQf////8DTw0CIAAoAiAiCCgCECIEKAIEIAEoAgAiCSACIAJBAXQiBSAEKAIAEQIAIQMCQAJAIAJFDQAgAw0AIAggCSACIAUQgwYiAw0AQQAhAwwBCyAEIAIgBCgCDGo2AgwLQQAgAiADGw0DIAEgBTYCCCABIAM2AgAgASgCBCIEQQFqIQULIAEgBTYCBCADIARqIAY6AABBfyECIAAoAiQiASABKAIAIgNBAWs2AgACQCADBEAgASABKAIEIgJBAWo2AgQgAi0AACECDAELIAEoAhAgASgCDCAHQQxqIAEoAggRBAAiA0UNACAHKAIMIgZFDQAgASADQQFqNgIEIAEgBkEBazYCACADLQAAIQILIAAgAjYCAEEBCyECIAdBEGokACACDwsgAEGw6SpBABCBBwALIAhBBBCEBgAL6wQBCX8jAEEQayIHJAAgACgCACEEIAAoAggiAygCICEKAkACQAJ/AkAgAygCLCABEKABIgMtAAQiBkEDRgRAIAMoAgAiBSAAKAIcTg0BIAItAAQgBCgCMCAFQQN0aiIILQAEc0E/cQ0BQQAgCCACEPwFDQQgAy0ABCEGCyAEKAIQIQkgACgCHCEFIAdBAzoADCAHIAU2AgggBEEQaiEIIABBHGoiCyAGQf8BcUEgRw0BGiAKIAAoAggoAiwgASAHQQhqEI0GDAILIAQoAhAhCSAAKAIcIQUgB0EDOgAMIAcgBTYCCCAEQRBqIQggAEEcagshCyADQQM6AAQgAyAFNgIACyAEIAogBCgCMCAFIAhBCEH///8PQfbvKRC4BiIBNgIwAkAgCSAEKAIQIgZODQAgBiAJIgNrQQdxIggEQEEAIQADQCABIANBA3RqQQA6AAQgA0EBaiEDIABBAWoiACAIRw0ACwsgCSAGa0F4Sw0AA0AgASADQQN0aiIAQQA6AAQgAEEAOgAMIABBADoAFCAAQQA6ABwgAEEAOgAkIABBADoALCAAQQA6ADQgAEEAOgA8IANBCGoiAyAGRw0ACwsgASAFQQN0aiIAIAIoAgA2AgAgACACLQAEIgM6AAQgCyALKAIAQQFqNgIAIANBwABxRQ0AIAQtAAUiAEEgcUUNACACKAIAIgMtAAVBGHFFDQAgCigCECIBLQA5QQJNBEAgASADEI4GIAQtAAVBBnFFDQEgAyADLQAFQfgBcUECcjoABQwBCyABLQA6DQAgBCABLQA4QRhxIABBxwFxcjoABQsgB0EQaiQAIAULtQIBA38gAUEHdCEEAkAgAkH//wdMBEAgACgCACIBIAAoAggoAiAgASgCNCAAKAIQIAFBFGpBBEH/////A0HtgioQuAYiAzYCNCAAIAAoAhAiBUEBajYCECADIAVBAnRqIAQgAkEPdHJBA3I2AgAMAQsgACgCACIBIAAoAggoAiAgASgCNCAAKAIQIAFBFGpBBEH/////A0HtgioQuAYiAzYCNCAAIAAoAhAiBUEBajYCECADIAVBAnRqIARBBHI2AgAgACABIAAoAggoAggQ3AYgACgCACIBIAAoAggoAiAgASgCNCAAKAIQIAFBFGpBBEH/////A0HtgioQuAYiBDYCNCAAIAAoAhAiA0EBajYCECAEIANBAnRqIAJBB3RB0gByNgIACyAAIAEgACgCCCgCCBDcBgv+BQEEfwJAAkACQAJAAkACQAJAIAEoAgBBCGsOCgMBAQEBAQEBAQABCyAAKAIAIgMoAjQiBCABKAIEQQJ0aigCACIFQf8AcUEzRw0BAkAgACgCECIBIAMoAkBqQQFrLAAAIgZBgH9HBEAgACAAKAIYIAZrNgIYIAAgAC0ANUEBazoANQwBCyAAQYEBOgA1IAAgACgCJEEBazYCJAsgACABQQFrIgE2AhAgAyAAKAIIKAIgIAQgASADQRRqQQRB/////wNB7YIqELgGIgQ2AjQgACAAKAIQIgFBAWo2AhAgBCABQQJ0aiAFQQl2QYD/AXEgAkEPdHJBwoACczYCACAAIAMgACgCCCgCCBDcBiAAKAIAIgMgACgCCCgCICADKAI0IAAoAhAgA0EUakEEQf////8DQe2CKhC4BiIENgI0IAAgACgCECIBQQFqNgIQIAQgAUECdGpBuP7//wc2AgAMBAsgACgCACEDCyAALQA0IgVBAWohBCADLQAIIAVNBEAgBUH+AU8NBCADIAQ6AAgLIAAgBDoANCAAIAEgBEH/AXFBAWsQ9gYgASgCAEEIRw0BCyAALQAyIQMgASgCBCEFAn8DQEEAIANBAEwNARogACgCCCgCMCgCACAAKAIoQQR0aiADQQFrIgNBBHRqIgQtAAVBA0YNAAsgBC0ABkEBagsgBUoNACAAIAAtADRBAWs6ADQLIAEoAgQhBCAAKAIAIgMgACgCCCgCICADKAI0IAAoAhAgA0EUakEEQf////8DQe2CKhC4BiIBNgI0IAAgACgCECIFQQFqNgIQIAEgBUECdGogBEEQdCACQQ90ckHD/wFyNgIAIAAgAyAAKAIIKAIIENwGIAAoAgAiAyAAKAIIKAIgIAMoAjQgACgCECADQRRqQQRB/////wNB7YIqELgGIgQ2AjQgACAAKAIQIgFBAWo2AhAgBCABQQJ0akG4/v//BzYCAAsgACADIAAoAggoAggQ3AYgACgCEEEBaw8LIAAoAghBl/QpENkGAAvZBwEFfyAAKAIQIgMhAiADKAIMQQBKBEAgABBUIAAoAhAhAgsCQAJAIAIoAgRBAEEIQfgAIAIoAgARAgAiAUUEQCAAQQBBCEH4ABCDBiIBRQ0BCyACIAIoAgxB+ABqNgIMIAItADghBCABQQg6AAggASAEQRhxOgAJIAEgAigCRDYCBCACIAFBBGoiBDYCRCAAKAIMIgJByAA6AAQgAiAENgIAIAAgACgCDEEIajYCDCABQQA2AlwgASADNgIUIAFBADYCGCABIAQ2AjAgAUEANgI0IAFCADcCICAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCYCABQYACNgEKIAFBADYCdCABIAAoAnA2AnQgASAAKAJoIgI2AmwgACgCWCEFIAEgAjYCcCABIAU2AlwgASADKAKQAUEEaygAADYAACAAKAIQIgMoAgRBAEEAQegCIAMoAgARAgAiAkUEQCAAQQBBAEHoAhCDBiICRQ0CCyADIAMoAgxB6AJqNgIMIAEgAjYCKCABIAI2AiAgAkEAOgAEIAEoAiBBADoADCABKAIgQQA6ABQgASgCIEEAOgAcIAEoAiBBADoAJCABKAIgQQA6ACwgASgCIEEAOgA0IAEoAiBBADoAPCABKAIgQQA6AEQgASgCIEEAOgBMIAEoAiBBADoAVCABKAIgQQA6AFwgASgCIEEAOgBkIAEoAiBBADoAbCABKAIgQQA6AHQgASgCIEEAOgB8IAEoAiBBADoAhAEgASgCIEEAOgCMASABKAIgQQA6AJQBIAEoAiBBADoAnAEgASgCIEEAOgCkASABKAIgQQA6AKwBIAEoAiBBADoAtAEgASgCIEEAOgC8ASABKAIgQQA6AMQBIAEoAiBBADoAzAEgASgCIEEAOgDUASABKAIgQQA6ANwBIAEoAiBBADoA5AEgASgCIEEAOgDsASABKAIgQQA6APQBIAEoAiBBADoA/AEgASgCIEEAOgCEAiABKAIgQQA6AIwCIAEoAiBBADoAlAIgASgCIEEAOgCcAiABKAIgQQA6AKQCIAEoAiBBADoArAIgASgCIEEAOgC0AiABKAIgQQA6ALwCIAEoAiBBADoAxAIgASgCIEEAOgDMAiABKAIgQQA6ANQCIAEoAiBBADoA3AIgASgCIEEAOgDkAiABQgA3AkAgAUGAgAg2AlggAUEANgJIIAEgASgCICIANgIQIAEgADYCOCABIABBwAJqNgIcIABBADoABCABIAFBOGo2AhggASABKAIQIgBBqAFqNgI8IAEgAEEIajYCECAEDwsgAEEEEIQGAAsgAEEEEIQGAAv7AgEEfyMAQRBrIgQkACAAIAEEfyABLwFgBSACCzYCYCAAIABBNGo2AhQgAC0ABiEBIAAoAhxBADoABCAAQQI7AVYgAEEAOgAGIAAgACgCHCICNgI0IAFBACABQQFHGyEBIAAtAAchAyAAKAIUIQUDQCAEIAE2AgwgBCACQQFqNgIIIABBEyAEQQhqEH0iAQRAIAAgAzoAByAAIAU2AhQgACgCHCECDAELC0EIIQIgACgCHCIBQQhqIQMCfwJAIAECfwJAAkACQCAEKAIMIgUOBgQCAgIAAQILIAMgACgCECgClAEiAjYCACACLQAEQcAAcgwCCyADIABBxe4qQRcQgAYiAjYCACACLQAEQcAAcgwBCyADIAAoAgwiAkEIaygCADYCACACQQRrLQAACzoADEEQIQIgACABQRBqNgIMIAAoAhwMAQsgACADNgIMIAELIQMgACABIAJqQaABaiIBNgI4IAAgASADa0EDdUEAEKsGGiAEQRBqJAAgBQv2BAMGfwF+AX0jAEEQayIGJAACfwJAAkACQAJAAkACQAJAAkACQCABLQAEQT9xQQFrDhYEBgACCAgICAgICAgICAgIBQgBAwgHCAsgACgCECABNAIAIghCHoggCIVCucuT59Htkay/f34iCEIbiCAIhULro8SZsbeS6JR/fiIIQh+IIAiFp0F/IAAtAAd0QX9zcUEEdGoMCAsgACgCECEFAkAgASoCACAGQQxqEI8HQwAAAE+UIglDAAAAz2BFDQAgCUMAAABPXUUNACAGKAIMIAn8AGoiAUEfdSABcyEDCyAFIANBfyAALQAHdEF/c0EBcm9BBHRqDAcLIAAoAhAgASgCACgCCEF/IAAtAAd0QX9zcUEEdGoMBgsgACgCECEHAkAgASgCACIELQAGBEAgBCgCCCEBDAELIAQoAgwiAiAEKAIIcyEBAkAgAkUNACAEQQ9qIQUgAkEBcQR/IAIgBWotAAAgAUEFdCABQQJ2amogAXMhASACQQFrBSACCyEDIAJBAUYNACAEQQ5qIQIDQCACIANqLQAAIAMgBWotAAAgAUEFdCABQQJ2amogAXMiAUEFdCABQQJ2amogAXMhASADQQJrIgMNAAsLIARBAToABiAEIAE2AggLIAcgAUF/IAAtAAd0QX9zcUEEdGoMBQsgACgCEAwECyAAKAIQIAAtAAdBAEdBBHRqDAMLIAAoAhAgASgCAEF/IAAtAAd0QX9zQQFycEEEdGoMAgsgACgCECABKAIAQX8gAC0AB3RBf3NBAXJwQQR0agwBCyAAKAIQIAEoAgBBfyAALQAHdEF/c0EBcnBBBHRqCyEAIAZBEGokACAAC3EBA38gALwiAkEXdiIDQf8BcSIEQf8BRwR9IARFBEAgASAAQwAAAABbBH9BAAUgAEMAAIBflCABEI8HIQAgASgCAEFAags2AgAgAA8LIAEgA0H/AXFB/gBrNgIAIAJB////g3hxQYCAgPgDcr4FIAALC3IBAn8gACgCECABKAIIQX8gAC0AB3RBf3NxQQR0aiECAkADQCACLQAFQcQARgRAIAIoAgwgAUYNAgsgAiACKAIIIgNBBHRqIQIgAw0AC0HUsS8hAgsgAi0ABEEPcQR/IAIFIAAgAC0ABkEgcjoABkEACwuxBAEEfyAAKAIQIQcCQAJ/AkACQAJAIAEtAARBD3EiBUEFaw4DAAIBAgsgASgCAEEYagwCCyABKAIAQQxqDAELIAAoAhAgBUECdGpB/AFqCygCACIFBEAgBSgCECAHIARBAnRqKAKYASIIKAIIQX8gBS0AB3RBf3NxQQR0aiEFA0AgBS0ABUHEAEYEQCAFKAIMIAhGDQMLIAUgBSgCCCIGQQR0aiEFIAYNAAtB1LEvIQUMAQsgB0EsaiEFCwJAIAUtAARBD3ENAAJ/AkACQAJAIAItAARBD3EiBUEFaw4DAAIBAgsgAigCAEEYagwCCyACKAIAQQxqDAELIAcgBUECdGpB/AFqCygCACIFBEAgBSgCECAHIARBAnRqKAKYASIIKAIIQX8gBS0AB3RBf3NxQQR0aiEFA0AgBS0ABUHEAEYEQCAFKAIMIAhGDQMLIAUgBSgCCCIGQQR0aiEFIAYNAAtB1LEvIQUMAQsgB0EsaiEFCyAFLQAEQQ9xRQRAQQAPCyAAKAIcIQggACgCDCIGIAUoAgA2AgAgBiAFLQAEOgAEIAYgASgCADYCCCAGIAEtAAQ6AAwgBiACKAIANgIQIAYgAi0ABDoAFCAAIAAoAgxBGGo2AgwCQCAAKAIULQAiQQpxRQRAIAAgBkEBEJAGDAELIAAgBkEBEJEGCyAAIAAoAgwiBUEIayIGNgIMIAAoAhwgAyAIa2oiACAGKAIANgIAIAAgBUEEay0AADoABEEBC9UBAAJAAkACQCADBEAgACACIAEgBCAFEJEHDQEgBUETRyAFQQ1rQQVPcUUEQCACLQAEQQ9xQQNGBEAgAS0ABEEPcUEDRg0ECyAAIAIgAUHwtyoQpAYACyAAIAIgAUGNuCoQpAYACyAAIAEgAiAEIAUQkQcNACAFQRNHIAVBDWtBBU9xRQRAIAEtAARBD3FBA0YEQCACLQAEQQ9xQQNGDQQLIAAgASACQfC3KhCkBgALIAAgASACQY24KhCkBgALDwsgACACIAEQpQYACyAAIAEgAhClBgALiAEBAX8gACABIAIgACgCDEEVEJEHBEAgACgCDC0ABCIAQQFHIABBD3FBAEdxDwsgACgCFCIDIAMvASJBgMAAcjsBIiAAIAIgASAAKAIMQRQQkQcEQCAAKAIUIgIgAi8BIkGAwABzOwEiIAAoAgwtAAQiAEEBRiAAQQ9xRXIPCyAAIAEgAhCnBgALpQcBCX8jAEEwayIIJAAgACgCACEGAkACQAJAAkACQANAIAAoAgQiAiACKAIAIgRBAWs2AgACfyAEBEAgAiACKAIEIgRBAWo2AgQgBC0AAAwBCyACKAIQIAIoAgwgCCACKAIIEQQAIgRFDQIgCCgCACIHRQ0CIAIgBEEBajYCBCACIAdBAWs2AgAgBC0AAAshAiADQf///w9PDQIgAkH/AHEgA0EHdHIhAyACwEEATg0ACwJAIANFBEAMAQsgA0EBayEHAkAgA0EpTQRAIAcEQCAAKAIEIgQoAgAhAiAIIQUgByEJA0ACQCACBEAgBCgCBCEKDAELIAQoAhAgBCgCDCAIQSxqIAQoAggRBAAiCkUNCCAIKAIsIgJFDQggBCAKNgIEIAQgAjYCAAsgCSACIAIgCUsbIgMEQCAFIAogA/wKAAALIAQgAyAKajYCBCAEIAIgA2siAjYCACADIAVqIQUgCSADayIJDQALCyAGIAggBxCABiEFDAELIAYoAhAiAigCNCEEIAIoAgRBAEEEIANBEGoiAyACKAIAEQIAIgVFBEAgBkEAQQQgAxCDBiIFRQ0GCyACIAIoAgwgA2o2AgwgAi0AOCEDIAVBFDoABCAFIANBGHE6AAUgBSACKAJENgIAIAIgBTYCRCAFQQA6AAYgBSAENgIIIAVBEGoiCSAHakEAOgAAIAVB/wE6AAcgBSAHNgIMIAYoAgwiAiAFNgIAIAIgBS0ABEHAAHI6AAQgBiAGKAIYIAYoAgwiAmtBCEwEfyAGQQEQrQYgBigCDAUgAgtBCGo2AgwgACgCBCICKAIAIQQDQAJAIAQEQCACKAIEIQoMAQsgAigCECACKAIMIAggAigCCBEEACIKRQ0IIAgoAgAiBEUNCCACIAo2AgQgAiAENgIACyAHIAQgBCAHSxsiAwRAIAkgCiAD/AoAAAsgAiACKAIAIANrIgQ2AgAgAiACKAIEIANqNgIEIAMgCWohCSAHIANrIgcNAAsgBiAGKAIMQQhrNgIMCyABLQAFIgJBIHFFDQAgBS0ABUEYcUUNACAGKAIQIgMtADlBAk0EQCADIAUQjgYgAS0ABUEGcUUNASAFIAUtAAVB+AFxQQJyOgAFDAELIAMtADoNACABIAMtADhBGHEgAkHHAXFyOgAFCyAIQTBqJAAgBQ8LIABBgtMqEL4GAAsgAEGivikQvgYACyAAQYLTKhC+BgALIAZBBBCEBgALIABBgtMqEL4GAAsJACAAIAEQrQEL8wQBBn8CQAJAAkACQAJAAkAgAi0ABCIDQT9xQQRrDhEBAAMDAwMDAwMDAwMDAwMDAgMLAkAgAigCACIHKAIYIgZFDQAgBi0ABiIIQRBxDQAgBigCECAAKAIQKAKoASIFKAIIQX8gBi0AB3RBf3NxQQR0aiEDAkADQCADLQAFQcQARgRAIAMoAgwgBUYNAgsgAyADKAIIIgRBBHRqIQMgBA0AC0HUsS8hAwsgAy0ABEEPcQ0EIAYgCEEQcjoABgsgASAHEPgFNgIAIAFBAzoABA8LIAEgAigCAC0ABzYCACABQQM6AAQPCyABIAIoAgAoAgw2AgAgAUEDOgAEDwsgACgCECEEAkACfwJAAkACQCADQQ9xIgNBBWsOAwACAQILIAIoAgBBGGoMAgsgAigCAEEMagwBCyAAKAIQIANBAnRqQfwBagsoAgAiAwRAIAMoAhAgBCgCqAEiBSgCCEF/IAMtAAd0QX9zcUEEdGohAwNAIAMtAAVBxABGBEAgAygCDCAFRg0DCyADIAMoAggiBEEEdGohAyAEDQALQdSxLyEDDAELIARBLGohAwsgAy0ABEEPcUUNAQsgACgCHCEFIAAoAgwiBCADKAIANgIAIAQgAy0ABDoABCAEIAIoAgA2AgggBCACLQAEOgAMIAQgAigCADYCECAEIAItAAQ6ABQgACAAKAIMQRhqNgIMAkAgACgCFC0AIkEKcUUEQCAAIARBARCQBgwBCyAAIARBARCRBgsgACAAKAIMIgNBCGsiBDYCDCAAKAIcIAEgBWtqIgIgBCgCADYCACACIANBBGstAAA6AAQPCyAAIAJBqfQqEJ4GAAvqBQEGfyABIAAoAgQiBSAAKAIIIgNrTQRAIAAoAgAgA2oPCyAAKAIMIQQCQAJAIAFBf3MgA08EQCAFQQF2QQNsIgUgASADaiIBIAEgBUkbIQYCQCAAKAIAIABBEGpHBEAgBCgCDCACQQN0aiIBKAIAIQMgBCgCECIFKAIAIQcgAS0ABEEPcUEHRgRAIAMgAy8BBiIBQQN0QRhqQRAgARtqIQMLQQAgBiAFKAIEIAMoAgAgAygCBCAGIAcRAgAiARsNAyADIAY2AgQgAyABNgIADAELIAJBA3QhCCAEKAIMIQMgBCACQX9HBH8gA0EIayEBIAMgCGohAwNAIAMoAgAhBSADIAEoAgA2AgAgAy0ABCEHIAMgAS0ABDoABCABIAc6AAQgASAFNgIAIANBCGoiAyABQQhrIgFJDQALIAQoAgwFIAMLQQhrIgEgBCgCJE0EfyAEIAFBf0EAEF4FIAELNgIMIARBCEEAENoBQgA3AgAgBEH39SsQpAEEQCAEQeC1L0EAEGgLIARBfhDbASAEKAIMIQMgAkF/RwRAIANBCGshASADIAhqIQMDQCADKAIAIQUgAyABKAIANgIAIAMtAAQhByADIAEtAAQ6AAQgASAHOgAEIAEgBTYCACADQQhqIgMgAUEIayIBSQ0ACyAEKAIMIQMLIAQoAhQuASAhASAEIAMgAkEDdCIFahDBBiABQX9OBEAgBCgCFEF9IAFrOwEgCyAEKAIMIAVqIgEoAgAhAyAEKAIQIgUoAgAhByABLQAEQQ9xQQdGBEAgAyADLwEGIgFBA3RBGGpBECABG2ohAwtBACAGIAUoAgQgAygCACADKAIEIAYgBxECACIBGw0DIAMgBjYCBCADIAE2AgAgACgCCCIDRQ0AIAEgACgCACAD/AoAAAsgACAGNgIEIAAgATYCACABIAAoAghqDwsgBEHrmStBABClAQALIARB46kpEFggBBCXAQALIARB46kpEFggBBCXAQALpQcBBn8jAEEQayIHJAAgAEEMaiIDKAIAIQQgAEEUaiICKAIAKAIAIQYgAEGF9yogARCaBhogAEHY4c59QdfiKxCQARogAigCACECAkAgACgCGCIFIAMoAgAiAWtBMEwEQCAFIAAoAhwiA2siBUGAtIkTSg0BIAEgA2tBA3UiAUG7lrECTgRAIABBiJixAkEAEKsGGgwCCyAAQcCWsQIgBUECdSIDIANBwJaxAk4bIgMgAUEGaiIBIAEgA0gbQQAQqwZFDQEgACgCDCEBCyAEIAZrQQhrQQN1IQMgAUEwaiIBIAIoAgRLBEAgAiABNgIECwJ/IAAgA0EBaiIGQQIQmQdFBEAgAyEGQQAMAQsgACgCDCICQQhrIQECQCACQQRrLQAAQQ9xQQRHBH8gACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCDEEIawUgAQsoAgAiAS0AEEHfAEcNACABLQARQccARw0AIAEtABJBLkcNACAAIAFBE2oQWCAAKAIMIgJBEGshASACQQhrIQIDQCABKAIAIQMgASACKAIANgIAIAEtAAQhBCABIAItAAQ6AAQgAiAEOgAEIAIgAzYCACABQQhqIgEgAkEIayICSQ0ACyAAQQxqIgIoAgBBCGsiASAAKAIkTQRAIAAgAUF/QQAQXiEBCyACIAE2AgALIAAiAygCDCICQQhrIQUgACgCFCEEAkACQCAGIgFBAEoEQCAEKAIAIAFBA3RqIgEgAkkNASAAKAIQQSxqIQEMAQsgAUHZ4c59TgRAIAIgAUEDdGohAQwBCyABQdjhzn1GBEAgAygCEEEkaiEBDAELAn8CQCAEKAIAIgQtAARB5gBGBEAgBCgCACIELQAGQdjhzn0gAWtJDQEgBEEAIAFrQQN0akG48okTawwCCyADKAIQQSxqDAELIAMoAhBBLGoLIgEgBSgCADYCACABIAJBBGstAAAiAjoABAJAIAJBwABxRQ0AIAMoAhQoAgAoAgAiAS0ABUEgcUUNACAFKAIAIgItAAVBGHFFDQACQCADKAIQIgMtADlBAk0EQCADIAIQjgYgAS0ABUEGcUUNASACIAItAAVB+AFxQQJyOgAFDAELIAMtADoNACABIAMtADhBGHEgAS0ABUHHAXFyOgAFCwsMAQsgASAFKAIANgIAIAEgAkEEay0AADoABAtBAQshASAAIAYQqwEgB0EQaiQAIAEPCyAHQc3ZKjYCACAAQd74KyAHEKUBAAu9BAEJfwJAIAJFDQAgACgCDCIDQQRrLQAAQQ9xQQVHDQAgA0EAOgAEIAAgACgCDEEIajYCDEHY4c59IAFrIQcgAkEBayEIIAFBAEwhCSABQQN0IQUgAUHZ4c59SCEKQdfhzn0gAWtBA3QhCwNAIABBfhCWBkUNAQJAIAAgACgCDCICQQxrLQAAQQ9xQQRGBH8gACgCFCEDAkAgCUUEQCADKAIAIAVqIgMgAkkNASAAKAIQQSxqIQMMAQsgCkUEQCACIAVqIQMMAQsgAUHY4c59RgRAIAAoAhBBJGohAwwBCyADKAIAIgMtAARB5gBGBEAgAygCACIDLQAGIAdPBEAgAyALakEQaiEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLAkAgAy0ABEEPcUUEQCADIAAoAhBBLGpGDQELIAJBCGshBiACQQRrLQAAQQ9xRQRAIAYgACgCEEEsakYNAQtBACADIAYQ/AVFDQAgACAAKAIMQQhrIgIgACgCJE0EfyAAIAJBf0EAEF4FIAILNgIMQQEPCyAAIAEgCBCZBw0BIAAoAgwFIAILQQhrIgIgACgCJE0EfyAAIAJBf0EAEF4FIAILNgIMDAELCyAAQcv1KxBYIAAoAgwiAkEYayACQQhrKAIANgIAIAJBFGsgAkEEay0AADoAACAAIAAoAgxBCGsiAiAAKAIkTQR/IAAgAkF/QQAQXgUgAgs2AgwgAEEDEJgGQQEhBCAAKAIQKAIMQQBMDQAgABBUCyAEC38BA38gACgCFCgCAEEIaiIBIAAoAhAiAkEsaiABIAAoAgxJGyIBKAIAIQAgAigCACEDIAEtAARBD3FBB0YEQCAAIAAvAQYiAUEDdEEYakEQIAEbaiEACyACKAIEIAAoAgAgACgCBEEAIAMRAgAhAiAAQQA2AgQgACACNgIAQQALwAEBBX8gACgCDCICKAIMIgVBCGshAwJAAkACQCAFQQRrLQAAQQ9xQQNrDgIAAQILIAIgAxBTIAIoAhAoAgxBAEoEQCACEFQLIAIoAgxBCGshAwsgAygCACIDLQAHIgFB/wFGBEAgAygCDCEBCyADQRBqIQQLIAAgAUF+EJcHIQMgAQRAIAMgBCAB/AoAAAsgACAAKAIIIAFqNgIIIAIgAigCDEEIayIBIAIoAiRNBH8gAiABQX9BABBeBSABCzYCDAuKAwEDfwJ/IAAoAhQoAgAgAUEDdGoiASAAKAIMIgNPBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xIgRBBWsOAwACAQILIAEoAgBBGGoMAgsgASgCAEEMagwBCyAAKAIQIARBAnRqQfwBagsoAgAiAUUEQEEADwsgA0HFADoABCADIAE2AgAgACAAKAIMQQhqNgIMIAAgAhBYIAAoAgwiAUEQaygCACABQQhrEKABIQEgACAAKAIMIgNBCGsiAjYCDCADQQRrIAEtAARBD3EEfyACIAEoAgA2AgAgAS0ABAVBAAs6AAAgACAAKAIMIgNBCGo2AgwgA0EIayEBAkACQCADLQAEQQ9xIgUEQANAIAEoAgAhAiABIAMoAgA2AgAgAS0ABCEEIAEgAy0ABDoABCADIAQ6AAQgAyACNgIAIAFBCGoiASADQQhrIgNJDQALIAAoAgxBCGsiASAAKAIkSw0CDAELQQAhBSAAKAIkIAFJDQELIAAgAUF/QQAQXiEBCyAAIAE2AgwgBQvAAQEDfyMAQRBrIgUkAAJAAkAgAgRAIAAoAhQoAgAgAUEDdGoiBCAAKAIMTwR/IAAoAhBBLGoFIAQLLQAEQQ9xRQ0BIAAgAUEAEIgBIgINAQwCCyAAIAFBABCIASICRQ0BCwJAIAMoAgAiBARAA0AgBCACEK0BRQ0CIAMgBkEBaiIGQQJ0aigCACIEDQALCyAFIAI2AgAgACABIABBv4MsIAUQpgEQhgIACyAFQRBqJAAgBg8LIAAgAUH47SoQ1AEAC+sBAQV/IwBBEGsiBSQAIAAoAhQhBgJAIAEgACgCGCIDIAAoAgwiBGtBA3VOBH8gAyAAKAIcIgdrIgNBgLSJE0oNAQJAIAFBv5axAkwEQCAEIAdrQQN1IAFqIgRBwZaxAkgNAQsgAEGImLECQQAQqwYaDAILIABBwJaxAiADQQJ1IgMgA0HAlrECThsiAyAEIAMgBEobQQAQqwZFDQEgACgCDAUgBAsgAUEDdGoiACAGKAIESwRAIAYgADYCBAsgBUEQaiQADwsgAkUEQCAAQbW+KUEAEKUBAAsgBSACNgIAIABB3vgrIAUQpQEAC0oBAX8CQCAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELIAEtAARBD3ENACABIAAoAhBBLGpHDQAgAEEBQcK2KxCGAgALC4oCAQN/IwBBEGsiAyQAIANBADYCDCAAKAIUIQICQCABQQBKBEAgAigCACABQQN0aiICIAAoAgxJDQEgACgCEEEsaiECDAELIAFB2eHOfU4EQCAAKAIMIAFBA3RqIQIMAQsgAUHY4c59RgRAIAAoAhBBJGohAgwBCyACKAIAIgItAARB5gBGBEAgAigCACICLQAGQdjhzn0gAWtPBEAgAkEAIAFrQQN0akG48okTayECDAILIAAoAhBBLGohAgwBCyAAKAIQQSxqIQILAkAgAi0ABEEDRgRAIAIoAgAhAgwBCyACIANBDGpBABD8ASEEIAMoAgwhAiAEDQAgACABEP0BCyADQRBqJAAgAgu9AQEEfyMAQRBrIgIkACAAKAIUKAIAQQhqIgEgACgCDCIDTwRAIAAoAhBBLGohAQsgACADIAEQlgcgACAAKAIMIgFBCGoiAzYCDCACQQA2AgwCQAJ/IAEtAARBA0YEQCABKAIADAELIAEgAkEMakEAEPwBRQ0BIAAoAgwhAyACKAIMCyEEIAAgA0EIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCACQRBqJAAgBA8LIABBmZgqQQAQpQEAC4IZAQZ/IwBBQGoiBSQAAkACfwJAIAFBAWtB2OHOfU8EQCAAKAIMIAAoAhQoAgBrQQN1IAFqIgFBAWtB1+HOfUsNAQsgACgCFCEEIAEMAQsgACgCDCAAKAIUIgQoAgBrQQN1IAFqCyIGQQBKBEAgBCgCACAGQQN0aiIDIAAoAgxJDQEgACgCEEEsaiEDDAELIAZB2eHOfU4EQCAAKAIMIAZBA3RqIQMMAQsgBkHY4c59RgRAIAAoAhBBJGohAwwBCyAEKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdjhzn0gBmtPBEAgA0EAIAZrQQN0akG48okTayEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLAkACQAJAAkACQAJ/AkACQAJAIAMtAARBD3EiB0EFaw4DAAIBAgsgAygCAEEYagwCCyADKAIAQQxqDAELIAAoAhAgB0ECdGpB/AFqCygCACIDBEAgACgCDCIEQcUAOgAEIAQgAzYCACAAIAAoAgxBCGo2AgwgAEHN6ioQWCAAKAIMIgNBEGsoAgAgA0EIaxCgASEDIAAgACgCDCIEQQhrIgc2AgwgBEEEayADLQAEQQ9xBH8gByADKAIANgIAIAMtAAQFQQALOgAAIAAgACgCDCIDQQhqNgIMIANBCGshBCADLQAEQQ9xBEADQCAEKAIAIQEgBCADKAIANgIAIAQtAAQhByAEIAMtAAQ6AAQgAyAHOgAEIAMgATYCACAEQQhqIgQgA0EIayIDSQ0ACyAAKAIMQQhrIgMgACgCJE0EQCAAIANBf0EAEF4hAwsgACADNgIMIAAoAhQhBCAGQQBMDQIgBCgCACAGQQN0aiIEIANJDQMgACgCEEEsaiEEDAMLIAAgBCAAKAIkTQR/IAAgBEF/QQAQXgUgBAs2AgwgACgCFCEECyABQQBMDQIgBCgCACABQQN0aiIDIAAoAgxJDQMgACgCEEEsaiEDDAMLIAZB2eHOfU4EQCADIAZBA3RqIQQMAQsgBkHY4c59RgRAIAAoAhBBJGohBAwBCyAEKAIAIgQtAARB5gBGBEAgBCgCACIELQAGQdjhzn0gBmtPBEAgBEEAIAZrQQN0akG48okTayEEDAILIAAoAhBBLGohBAwBCyAAKAIQQSxqIQQLIAMgBCgCADYCACADIAQtAAQ6AAQgACAAKAIMIgNBCGo2AgwgACADQQhrQQEQkQYgACgCDEEEay0AAEEPcUEFa0F9Sw0CIABB3e0qQQAQpQEACyABQdnhzn1OBEAgACgCDCABQQN0aiEDDAELIAFB2OHOfUYEQCAAKAIQQSRqIQMMAQsgBCgCACIDLQAEQeYARgRAIAMoAgAiAy0ABkHY4c59IAFrTwRAIANBACABa0EDdGpBuPKJE2shAwwCCyAAKAIQQSxqIQMMAQsgACgCEEEsaiEDCwJAAkACQAJAAkACQAJAIAMtAARBD3EOBQMCBAABBAsCQAJAAkACQAJAAkAgAUEASgRAIAQoAgAgAUEDdGoiAyAAKAIMSQ0BIAAoAhBBLGohAwwBCyABQdnhzn1OBEAgACgCDCABQQN0aiEDDAELIAFB2OHOfUYNASAEKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdjhzn0gAWtPBEAgA0EAIAFrQQN0akG48okTayEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLIAMtAARBA0YNAQwKCyAAKAIQIgMtAChBA0cNCSAFQQA2AjwMAQsgBUEANgI8IAFBAEoEQCAEKAIAIAFBA3RqIgMgACgCDEkNAyAAKAIQQSxqIQMMAwsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAwwDCyABQdjhzn1HDQEgACgCECEDCyADQSRqIQMMAQsgBCgCACIDLQAEQeYARgRAIAMoAgAiAy0ABkHY4c59IAFrTwRAIANBACABa0EDdGpBuPKJE2shAwwCCyAAKAIQQSxqIQMMAQsgACgCEEEsaiEDCyAFIAMtAARBA0cEfyADIAVBPGpBABD8ARogBUE8agUgAwsoAgA2AiAgAEGx4CsgBUEgahCmARoMBgsgACgCDCEDAkAgAUEASgRAIAQoAgAgAUEDdGoiBCADSQ0BIAAoAhBBLGohBAwBCyABQdnhzn1OBEAgAyABQQN0aiEEDAELIAFB2OHOfUYEQCAAKAIQQSRqIQQMAQsgBCgCACIELQAEQeYARgRAIAQoAgAiBC0ABkHY4c59IAFrTwRAIARBACABa0EDdGpBuPKJE2shBAwCCyAAKAIQQSxqIQQMAQsgACgCEEEsaiEECyADIAQoAgA2AgAgAyAELQAEOgAEIAAgACgCDEEIajYCDAwFCwJAIAFBAEoEQCAEKAIAIAFBA3RqIgMgACgCDEkNASAAKAIQQSxqIQMMAQsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAwwBCyABQdjhzn1GBEAgACgCEEEkaiEDDAELIAQoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSABa08EQCADQQAgAWtBA3RqQbjyiRNrIQMMAgsgACgCEEEsaiEDDAELIAAoAhBBLGohAwsgAEHAhCtB1vsqQcCEKyADLQAEIgNBD3EbIANBAUYbEFgMBAsgAyAAKAIQQSxqRw0BCwJAIAFBAEoEQCAEKAIAIAFBA3RqIgMgACgCDEkNASAAKAIQQSxqIQMMAQsgAUHZ4c59TgRAIAAoAgwgAUEDdGohAwwBCyABQdjhzn1GBEAgACgCEEEkaiEDDAELIAQoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSABa08EQCADQQAgAWtBA3RqQbjyiRNrIQMMAgsgACgCEEEsaiEDDAELIAAoAhBBLGohAwsCfwJAAn8CQAJAAkAgAy0ABEEPcSIHQQVrDgMAAgECCyADKAIAQRhqDAILIAMoAgBBDGoMAQsgACgCECAHQQJ0akH8AWoLKAIAIgMEQCAAKAIMIgRBxQA6AAQgBCADNgIAIAAgACgCDEEIajYCDCAAQcqRKxBYIAAoAgwiA0EQaygCACADQQhrEKABIQMgACAAKAIMIgRBCGsiBzYCDCAEQQRrIAMtAARBD3EEfyAHIAMoAgA2AgAgAy0ABAVBAAs6AAAgACAAKAIMIgNBCGo2AgwgA0EIayEEIAMtAARBD3EiCARAA0AgBCgCACEHIAQgAygCADYCACAELQAEIQYgBCADLQAEOgAEIAMgBjoABCADIAc2AgAgBEEIaiIEIANBCGsiA0kNAAsgACAAKAIMQQhrIgMgACgCJE0EfyAAIANBf0EAEF4FIAMLNgIMIAhBBEcNAiAAQX9BABCIAQwDCyAAIAQgACgCJE0EfyAAIARBf0EAEF4FIAQLNgIMIAAoAhQhBAsCQCABQQBKBEAgBCgCACABQQN0aiIDIAAoAgxJDQEgACgCEEEsaiEDDAELIAFB2eHOfU4EQCAAKAIMIAFBA3RqIQMMAQsgAUHY4c59RgRAIAAoAhBBJGohAwwBCyAEKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdjhzn0gAWtPBEAgA0EAIAFrQQN0akG48okTayEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLAn8CQCADLQAEQQ9xIgQNACADIAAoAhBBLGpHDQBBAAwBCyAEQQFqCyEDIAUgACABEP8FNgIEIAUgA0ECdEHwsS9qKAIANgIAIABByKcqIAUQpgEaDAQLIAAgARDgAUECdEH0sS9qKAIACyEDIAUgACABEP8FNgIUIAUgAzYCECAAQcinKiAFQRBqEKYBGiAAKAIMIgRBEGshAyAEQQhrIQQDQCADKAIAIQEgAyAEKAIANgIAIAMtAAQhByADIAQtAAQ6AAQgBCAHOgAEIAQgATYCACADQQhqIgMgBEEIayIESQ0ACyAAIAAoAgxBCGsiAyAAKAIkTQR/IAAgA0F/QQAQXgUgAws2AgwMAgsgAEGAyyoQWAwBCyAFIAAgAUEAEP4FuzkDMCAAQYT3KiAFQTBqEKYBGgsgACgCDCIEQQhrIQMCQAJAAkACQCAEQQRrLQAAQQ9xQQNrDgIBAgALQQAhAyACRQ0CIAJBADYCAAwCCyAAIAMQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIMQQhrIQMLIAIEQCACIAMoAgAiAS0AByIEQf8BRgR/IAEoAgwFIAQLNgIACyADKAIAQRBqIQMLIAVBQGskACADC3IBA38gACgCFCgCAEEIaiICIQEgACgCDCIDIAJNBH8gACgCEEEsagUgAQstAAQiAUEBR0EAIAFBD3EbRQRAIAAQnwcgAEEBQX8Q+gUgAEF+EKsBIABBlYgsEFggAEEBEKsBIAAQpAcaAAsgAyACa0EDdQvQAwEEfyMAQYABayICJAACQAJAAkACQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xDQFBASEDDAQLIAAoAhAtADBBD3ENAUEBIQMMAwsgAkEANgIUDAELIAJBADYCFCAAKAIQQSxqIQELIAEtAARBA0YEQCABKAIAIQMMAQsgASACQRRqQQAQ/AEhASACKAIUIQMgAQ0AIABBAhD9AQsgAEEBEKsBAkAgACgCFCIBKAIAQQhqIgQgACgCDE8EfyAAKAIQQSxqBSAECy0ABEEPcSIERQ0AIARBBEcNACADQQBMDQACQAJAIAEgAEE0aiIERg0AA0ACQCABKAIIIQEgA0EBayIDRQ0AIAEgBEcNAQsLIAMNACABIARGDQAgAiABNgJ8IABBrtEqIAJBFGoQmgYaIAIoAiwiAUEATA0AIAIgATYCBCACIAJBQGs2AgAgAEHkiCwgAhCmARoMAQsgAEG3kyxBABCmARoLIAAoAhQoAgBBCGoiASAAKAIMIgNPBEAgACgCEEEsaiEBCyADIAEoAgA2AgAgAyABLQAEOgAEIAAgACgCDEEIajYCDCAAQQIQmAYgACgCECgCDEEATA0AIAAQVAsgABCXAQALmAwBBX8jAEFAaiICJAACQAJAAkACQAJAAkACQAJAAkAgAEEBQZbpKUHAty8QnQdBAnRB8LcvaigCACIBQQNrDgkABgECAgYDBAUGCyAAQQNBABBrIQEgAEEEQQAQayEDIAFBf0YNBiAAKAIMIgRBEzoABCAEIAOyQwAAgDqUIAGzkjgCACAAIAAoAgxBCGo2AgwMBwsCQAJAAkACQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xDQFBACEBDAQLIAAoAhAtADBBD3ENAUEAIQEMAwsgAkEANgI8DAELIAJBADYCPCAAKAIQQSxqIQELIAEtAARBA0YEQCABKAIAIQEMAQsgASACQTxqQQAQ/AEhAyACKAI8IQEgAw0AIABBAhD9AQsgAiABNgIAIABBBSACEGsiAUF/Rg0FIAAoAgxBEUEBIAEbOgAEIAAgACgCDEEIajYCDAwGCwJAAkACQAJAIAAoAhQoAgBBEGoiAyAAKAIMSQRAIAMtAARBD3ENAUEAIQMMBAsgACgCEC0AMEEPcQ0BQQAhAwwDCyACQQA2AjwMAQsgAkEANgI8IAAoAhBBLGohAwsgAy0ABEEDRgRAIAMoAgAhAwwBCyADIAJBPGpBABD8ASEEIAIoAjwhAyAEDQAgAEECEP0BCyACIAM2AhAgACABIAJBEGoQayIBQX9GDQQgACgCDCIDQQM6AAQgAyABNgIAIAAgACgCDEEIajYCDAwFCyAAQQlBABBrIgFBf0YNAyAAKAIMQRFBASABGzoABCAAIAAoAgxBCGo2AgwMBAsCQAJAAkACQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xDQEMBAsgACgCEC0AMEEPcQ0BDAMLIAJBADYCPAwBCyACQQA2AjwgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCACEDDAELIAEgAkE8akEAEPwBIQEgAigCPCEDIAENACAAQQIQ/QELAkACQAJAAkAgACgCFCgCAEEYaiIBIAAoAgxJBEAgAS0ABEEPcQ0BQQAhAQwECyAAKAIQLQAwQQ9xDQFBACEBDAMLIAJBADYCPAwBCyACQQA2AjwgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCACEBDAELIAEgAkE8akEAEPwBIQQgAigCPCEBIAQNACAAQQMQ/QELIAIgATYCJCACIAM2AiAgAEEKIAJBIGoQayIBQX9GBEAgACgCDEEAOgAEIAAgACgCDEEIajYCDAwECyAAQdHNKkG6ziogAUELRhsQWAwDCwJAAkACQAJAIAAoAhQoAgBBEGoiASAAKAIMSQRAIAEtAARBD3ENAQwECyAAKAIQLQAwQQ9xDQEMAwsgAkEANgI8DAELIAJBADYCPCAAKAIQQSxqIQELIAEtAARBA0YEQCABKAIAIQMMAQsgASACQTxqQQAQ/AEhASACKAI8IQMgAQ0AIABBAhD9AQsCQAJAAkACQCAAKAIUKAIAQRhqIgEgACgCDEkEQCABLQAEQQ9xDQEMBAsgACgCEC0AMEEPcQ0BDAMLIAJBADYCPAwBCyACQQA2AjwgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCACEEDAELIAEgAkE8akEAEPwBIQEgAigCPCEEIAENACAAQQMQ/QELAkACQAJAAkAgACgCFCgCAEEgaiIBIAAoAgxJBEAgAS0ABEEPcQ0BQQAhAQwECyAAKAIQLQAwQQ9xDQFBACEBDAMLIAJBADYCPAwBCyACQQA2AjwgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCACEBDAELIAEgAkE8akEAEPwBIQUgAigCPCEBIAUNACAAQQQQ/QELIAIgATYCOCACIAQ2AjQgAiADNgIwIABBCyACQTBqEGsiAUF/RgRAIAAoAgxBADoABCAAIAAoAgxBCGo2AgwMAwsgAEHRzSpBus4qIAFBC0YbEFgMAgsgACABQQAQayIBQX9GDQAgACgCDCIDQQM6AAQgAyABNgIAIAAgACgCDEEIajYCDAwBCyAAKAIMQQA6AAQgACAAKAIMQQhqNgIMCyACQUBrJABBAQv0AQEDfyAAKAIUKAIAIgNBCGoiASAAKAIMIgJPBEAgACgCEEEsaiEBCwJAIAEtAARBD3FFBEAgASAAKAIQQSxqRg0BCwJ/IAIgA0EIaiIBTQRAIAAoAhBBLGohAQsCQAJAAkAgAS0ABEEPcSIDQQVrDgMAAgECCyABKAIAQRhqDAILIAEoAgBBDGoMAQsgACgCECADQQJ0akH8AWoLKAIAIgFFBEAgAkEAOgAEIAAgACgCDEEIajYCDEEBDwsgAkHFADoABCACIAE2AgAgACAAKAIMQQhqNgIMIABBAUHIlisQnAcaQQEPCyAAQQFBwrYrEIYCAAvOAQECfyAAKAIUKAIAQQhqIgIgACgCDCIBTwRAIAAoAhBBLGohAgsCQCACLQAEQQ9xRQRAIAIgACgCEEEsakYNAQsgAUEWOgAEIAFBJzYCACAAIAAoAgwiAUEIajYCDCABAn8gASAAKAIUKAIAIgJLBEAgAkEIagwBCyAAKAIQQSxqCyICKAIANgIIIAEgAi0ABDoADCAAIAAoAgwiAUEIajYCDCABQQM6AAwgAUEANgIIIAAgACgCDEEIajYCDEEDDwsgAEEBQcK2KxCGAgALpwEBA38jAEEQayICJAAgAkEANgIMIAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgAkEMakEAEPwBIQMgAigCDCEBIAMNACAAQQIQ/QELIAAoAgwiA0EDOgAEIAMgAUEBaiIBNgIAIAAgACgCDEEIajYCDCAAIAEQhwYhACACQRBqJABBAkEBIAAbC/oHAQh/IwBBEGsiBSQAIAAoAhQoAgAiAkEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCACICQQhqIgEgACgCDCIDSQ0AIAAoAhBBLGohAQsgASgCACIBLQAHIgZB/wFGBEAgASgCDCEGCyABQRBqIQQLAkACQAJAAkACfwJAIAMgAkEYaiIBSwRAIAEtAARBD3ENAUGm6ikMAgtBpuopIAAoAhAtADBBD3FFDQEaIAAoAhBBLGohAQsCQAJAIAEtAARBD3FBA2sOAgABAwsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCACICQRhqIgEgACgCDCIDSQ0AIAAoAhBBLGohAQsgASgCAEEQagshBwJ/IAMgAkEgaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEQQ9xDQAgASAAKAIQQSxqRw0AQQEMAQtBAAshCCACQRBqIQECQAJ/IAQEQAJAAkAgASADSQRAIAQhAiABLQAEQQ9xDQEMAgsgBCECIAAoAhAtADBBD3FFDQEgACgCEEEsaiEBCwJAAkAgAS0ABEEPcUEDaw4CAAEHCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRBqIgEgACgCDEkNACAAKAIQQSxqIQELIAEoAgBBEGohAgsgBSAGNgIMIAUgBDYCCCAAQQogBUEIaiACIAcQcAwBCwJ/AkAgASADSQRAIAEtAARBD3ENAUHS/CsMAgtB0vwrIAAoAhAtADBBD3FFDQEaIAAoAhBBLGohAQsCQAJAIAEtAARBD3FBA2sOAgABBwsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCACICQRBqIgEgACgCDCIDSQ0AIAAoAhBBLGohAQsgASgCAEEQagshASADIAJBCGoiAk0EfyAAKAIQQSxqBSACCy0ABEEPcUEGRw0FIABBBRCrASAAQShBACABIAcQcAtFBEBBASECIAgNASAAKAIUKAIAQSBqIgIgACgCDCIDTwRAIAAoAhBBLGohAgsgAyACKAIANgIAIAMgAi0ABDoABCAAIAAoAgxBCGo2AgxBASECIABBfkEBEJkGDQEgACAAKAIMQQhrIgMgACgCJE0EfyAAIANBf0EAEF4FIAMLNgIMDAELIAAoAgxBADoABCAAIAAoAgxBCGo2AgwgAEF+QQEQ+gVBAiECCyAFQRBqJAAgAg8LIABBA0H47SoQ1AEACyAAQQJB+O0qENQBAAsgAEECQfjtKhDUAQALIABBAUG2sCoQ1AEAC8cDAQJ/IABBAkGL/CkQngcgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELIAMgASgCADYCACADIAEtAAQ6AAQgACAAKAIMIgFBCGo2AgwgACABQQEQkQYCQAJAIAAoAgwiAUEEayIELQAAQQ9xIgNFBEAgAUEIayIBIAAoAhBBLGpGDQEgACABIAAoAiRNBH8gACABQX9BABBeBSABCzYCDAwCCyADQQVrQX1NDQAgASAAKAIUKAIAQShqIgNNBEAgACgCEEEsaiEDCyADIAFBCGsoAgA2AgAgAyAELQAAOgAEIAAoAgxBCGsiAyAAKAIkTQRAIAAgA0F/QQAQXiEDCyAAIAM2AgwgAyAAKAIUKAIAQShqIgFNBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xQQNrDgIBAgALIAINA0EADwsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEoaiIBIAAoAgxJDQAgACgCEEEsaiEBCyACBEAgAiABKAIAIgMtAAciAEH/AUYEfyADKAIMBSAACzYCAAsgASgCAEEQag8LIABBuO0qQQAQpQEACyACQQA2AgBBAAtvAQF/IAAoAhQoAgBBCGoiASAAKAIMTwR/IAAoAhBBLGoFIAELLQAEQQ9xQQVGBEBBAiEBIABBAhCrASAAQQEQlgYEfyABBSAAKAIMQQA6AAQgACAAKAIMQQhqNgIMQQELDwsgAEEBQeyXKxDUAQAL3wIBAn8gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAARBD3FFBEAgASAAKAIQQSxqRg0BCyAAQQFBj/QpEJwHIQIgACgCDCEBIAJFBEAgAUEWOgAEIAFBKTYCACAAIAAoAgwiAUEIajYCDCABAn8gASAAKAIUKAIAIgJLBEAgAkEIagwBCyAAKAIQQSxqCyICKAIANgIIIAEgAi0ABDoADCAAIAAoAgwiAUEIajYCDCABQQA6AAwgACAAKAIMQQhqNgIMQQMPCyABIAAoAhQoAgBBCGoiAk0EQCAAKAIQQSxqIQILIAEgAigCADYCACABIAItAAQ6AAQgACAAKAIMIgFBCGo2AgwgAUEIayEBIAAoAmBB//8DTQRAIAAoAhRBKjYCECAAKAIUQQA2AhggACABQQMQkAZBAw8LIAAgAUEDEJEGQQMPCyAAQQFBwrYrEIYCAAsEAEEDC6MDAQZ/IAAoAhQoAgBBCGoiASAAKAIMIgJPBEAgACgCEEEsaiEBCwJAIAEtAARBD3FFBEAgASAAKAIQQSxqRg0BCyACQRE6AAQgAEEMaiIBIAEoAgAiAUEIajYCACAAKAIUKAIAQQhqIgIgAUEIayIDSQRAIAIhBANAIAQoAgAhBSAEIAMoAgA2AgAgBC0ABCEGIAQgAy0ABDoABCADIAY6AAQgAyAFNgIAIARBCGoiBCADQQhrIgNJDQALCyABIAJLBEADQCACKAIAIQMgAiABKAIANgIAIAItAAQhBCACIAEtAAQ6AAQgASAEOgAEIAEgAzYCACACQQhqIgIgAUEIayIBSQ0ACwsgACAAQQxqIgEoAgAgAEEUaiIEKAIAKAIAa0EIa0EDdUECa0EAQQBBKxBxIQIgASgCACEDIAJBAk8EQCADQQE6AAQgASABKAIAIgJBCGo2AgAgAiACQQhrKAIANgIIIAIgAkEEay0AADoADCABIAEoAgBBCGo2AgBBAg8LIAMgBCgCACgCAGtBCGtBA3UPCyAAQQFBwrYrEIYCAAtsAQJ/IABBDGoiAygCACEEIAFBAk8EQCAEQQE6AAQgAyADKAIAIgBBCGo2AgAgACAAQQhrKAIANgIIIAAgAEEEay0AADoADCADIAMoAgBBCGo2AgBBAg8LIAQgACgCFCgCAGtBCGtBA3UgAmsL9wEBBX8jAEEQayIDJAACQCAAQQxqIgEoAgAgACgCFCgCAGtBCGsiAkEDdSIFQQBMDQAgAEEBIANBDGoQogdBASADKAIMQbjxMxAjIABBDGoiBCABKAIAQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIAIAJBCEYNAEECIQEDQCAAIAEgA0EMahCiByECQQlBuPEzEB8gAkEBIAMoAgxBuPEzECMgBCAEKAIAQQhrIgIgACgCJE0EfyAAIAJBf0EAEF4FIAILNgIAIAEgBUchAiABQQFqIQEgAg0ACwtBCkG48TMQH0G48TMQVhogA0EQaiQAQQALmwIBBn8gACgCFCgCAEEIaiICIQEgAiAAKAIMIgNPBEAgACgCEEEsaiEBCwJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEATA0AIAAQVAtBAiEBIAMgAmtBA3UiAkECTgRAA0AgACABQQAQiAFFDQMgASACRyEDIAFBAWohASADDQALIABBEGohBEEBIQEDQCAAIAFBABCIASEDIAQoAgAiBSgCyAUiBgRAIAUoAswFIANBASAGEQEACyABQQFqIgEgAkcNAAsLIAAgAkEAEIgBIQEgACgCECIAKALIBSICBEAgACgCzAUgAUEAIAIRAQALQQAPCyAAQQFB+O0qENQBAAsgACABQfjtKhDUAQALrgIBA38gACgCFCgCACIBQQhqIgIgACgCDCIDTwRAIAAoAhBBLGohAgsCQAJAIAItAARBD3FFBEAgAiAAKAIQQSxqRg0BCyADIAFBEGoiAk0EQCAAKAIQQSxqIQILIAItAARBD3FFBEAgAiAAKAIQQSxqRg0CCyADIAFBCGoiAk0EQCAAKAIQQSxqIQILIAMgAUEQaiIBTQRAIAAoAhBBLGohAQsCQAJAIAItAARBD3ENACACIAAoAhBBLGpHDQBBASEBDAELAkAgAS0ABEEPcQ0AIAEgACgCEEEsakcNAEEBIQEMAQtBEUEBQQAgAiABEPwFGyEBIAAoAgwhAwsgAyABOgAEIAAgACgCDEEIajYCDEEBDwsgAEEBQcK2KxCGAgALIABBAkHCtisQhgIAC+kBAQN/AkAgACgCFCgCACICQQhqIgEgACgCDCIDTwR/IAAoAhBBLGoFIAELLQAEIgFBD3FFDQAgAUEOcUEERw0AIAMgAkEIaiIBTQRAIAAoAhBBLGohAQtBACECAkACQAJAAkACQCABLQAEQT9xQQRrDhEAAwQCBAQEBAQEBAQEBAQEAQQLIAEoAgAtAAchAgwDCyABKAIAKAIMIQIMAgsgASgCACgCCCECDAELIAEoAgAQ+AUhAiAAKAIMIQMLIANBAzoABCADIAI2AgAgACAAKAIMQQhqNgIMQQEPCyAAQQFBquwqENQBAAv9AQEDfwJAIAAoAhQoAgAiAkEIaiIBIAAoAgwiA08EfyAAKAIQQSxqBSABCy0ABEEPcUEFRgRAIAMgAkEQaiIBTQRAIAAoAhBBLGohAQsgAS0ABEEPcUUEQCABIAAoAhBBLGpGDQILIABBAhCrASAAKAIUKAIAQQhqIgEgACgCDCICTwR/IAAoAhBBLGoFIAELKAIAIAJBCGsQoAEhASAAIAAoAgwiAkEIayIDNgIMIAJBBGsgAS0ABEEPcQR/IAMgASgCADYCACABLQAEBUEACzoAACAAIAAoAgxBCGo2AgxBAQ8LIABBAUHslysQ1AEACyAAQQJBwrYrEIYCAAvQAQEDfwJAAkAgACgCFCgCACICQQhqIgEgACgCDCIDTwR/IAAoAhBBLGoFIAELLQAEQQ9xQQVGBEAgAyACQRBqIgFNBEAgACgCEEEsaiEBCyABLQAEQQ9xRQRAIAEgACgCEEEsakYNAgsgAyACQRhqIgFNBEAgACgCEEEsaiEBCyABLQAEQQ9xRQRAIAEgACgCEEEsakYNAwsgAEEDEKsBIABBARCMBkEBDwsgAEEBQeyXKxDUAQALIABBAkHCtisQhgIACyAAQQNBwrYrEIYCAAv2AgEFfyMAQRBrIgQkACAAKAIMIgIgACgCFCIFKAIAQQhqIgFrQQN1IQMCQAJ/AkACQCABIAJJBEAgAS0ABEEPcUEERg0BDAILIAAoAhAtADBBD3FBBEcNASAAKAIQQSxqIQELAkAgAS0ABEEPcUEERg0AIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiBSgCAEEIaiIBIAAoAgwiAkkNACAAKAIQQSxqIQELIAEoAgAtABBBI0cNACACQQM6AAQgAiADQQFrNgIAIABBDGoiACAAKAIAQQhqNgIAQQEMAQsgBEEANgIMIAIgBSgCAEEIaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgBEEMakEAEPwBIQIgBCgCDCEBIAINACAAQQEQ/QELIAEgA2ogASADIAEgA0gbIAFBAEgbIgFBAEwNASADIAFrCyEAIARBEGokACAADwsgAEEBQbCbKxCGAgALwgEBBH8gACgCFCgCACIDQRBqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQCABLQAEQQ9xIgINACABIAAoAhBBLGpHDQBBfyECCwJAIAQgA0EIaiIBTQR/IAAoAhBBLGoFIAELLQAEQQ9xQQVGBEACQAJAIAIOBgEAAAAAAQALIABBAkGclysQ1AEACyAAQQFByJYrEJwHDQEgAEECEKsBIABBARDbAUEBDwsgAEEBQeyXKxDUAQALIABB1JYrQQAQpQEAC/sGAQd/IwBBEGsiByQAAkACQAJAAkACQAJAAkAgACgCFCgCACICQRBqIgEgACgCDCIDSQRAIAEtAARBD3FFDQEgB0EANgIMDAMLIAAoAhAtADBBD3ENAQsgAkEIaiIBIAAoAhBBLGogASADSRsiAS0ABEEPcUEDRgRAIABBARCrAQwECwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMIgNJDQAgACgCEEEsaiEBCyABKAIAIgEtAAciAkH/AUYEQCABKAIMIQILIAFBEGogAxDBASIBBEAgACAAKAIMQQhqNgIMCyABIAJBAWpGDQQgACgCDCEDIAAoAhQoAgAhAgsgAyACQQhqIgFNBEAgACgCEEEsaiEBCyABLQAEQQ9xDQIgASAAKAIQQSxqRw0CIABBAUHCtisQhgIACyAHQQA2AgwgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQIMAQsgASAHQQxqQQAQ/AEhASAHKAIMIQIgAQ0AIABBAhD9AQsgACgCFCgCACIDQQhqIgEgACgCDCIFTwR/IAAoAhBBLGoFIAELLQAEQQ9xQQRHDQIgBSADQQhqIgFNBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCACIBLQAHIgRB/wFGBEAgASgCDCEECyABQRBqIQYLIAJBAmtBI08NA0EAIQUgBCAGagJ/QQAgBkGViSwQ1gYgBmoiASABLQAAIgZBLUYgBkErRnJqIgMtAAAiARB0RQ0AGgNAIAFB/wFxIQQgAUEwa0H/AXFBCU0EfyAEQTBrBSAEELkHQTdrCyIBIAJOBEBBACEFQQAMAgsgASACIAVsaiEFIAMtAAEhASADQQFqIgQhAyABEHQNAAtBACAFayAFIAZBLUYbIQUgBEGViSwQ1gYgBGoLRw0AIAAoAgwiAUEDOgAEIAEgBTYCACAAIAAoAgxBCGo2AgwMAQsgACgCDEEAOgAEIAAgACgCDEEIajYCDAsgB0EQaiQAQQEPCyAAQQFB+O0qENQBAAsgAEECQdqcKxCGAgALFAAgAEHfAHEgACAAQeEAa0EaSRsLVgEBfyAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELAkAgAS0ABEEPcQ0AIAEgACgCEEEsakcNACAAQQFBwrYrEIYCAAsgAEEBQQAQogcaQQELZwECfyAAAn8gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEQQ9xIgJFBEBBASABIAAoAhBBLGpHDQEaIABBAUHCtisQhgIACyACQQFqC0ECdEHwsS9qKAIAEFhBAQuwBAEHfyAAKAIUKAIAIgNBEGoiASAAKAIMIgJPBH8gACgCEEEsagUgAQstAARBD3FBBkYEQCACIANrIQQgAkEROgAEIABBDGoiASABKAIAIgJBCGo2AgAgBEEIayEGIAICfyACIABBFGoiBSgCACgCACIDSwRAIANBCGoMAQsgACgCEEEsagsiAygCADYCCCACIAMtAAQ6AAwgASABKAIAIgNBCGo2AgAgBSgCACgCAEEYaiIEIANBEGsiAUkEQCAEIQIDQCACKAIAIQUgAiABKAIANgIAIAItAAQhByACIAEtAAQ6AAQgASAHOgAEIAEgBTYCACACQQhqIgIgAUEIayIBSQ0ACwsgBkEDdSEGIANBCGshASADIQIDQCABKAIAIQUgASACKAIANgIAIAEtAAQhByABIAItAAQ6AAQgAiAHOgAEIAIgBTYCACABQQhqIgEgAkEIayICSQ0ACyADIARLBEADQCAEKAIAIQEgBCADKAIANgIAIAQtAAQhAiAEIAMtAAQ6AAQgAyACOgAEIAMgATYCACAEQQhqIgQgA0EIayIDSQ0ACwsgACAGQQJrQQJBAkErEHEhASAAQQxqIgMoAgAhAiABQQJPBEAgAkEBOgAEIAMgAygCACIBQQhqNgIAIAEgAUEIaygCADYCCCABIAFBBGstAAA6AAwgAyADKAIAQQhqNgIAQQIPCyACIAAoAhQoAgBrQQhrQQN1QQJrDwsgAEECQbawKhDUAQALwQEBA38gACgCFCgCAEEIaiICIAAoAgxPBH8gACgCEEEsagUgAgstAARBD3FBBkYEQCAAEIwHIQIgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELIAMgASgCADYCACADIAEtAAQ6AAQgACAAKAIMIgFBCGo2AgwgACACRwRAIAAgATYCDCACKAIMIgAgASgCADYCACAAIAEtAAQ6AAQgAiACKAIMQQhqNgIMC0EBDwsgAEEBQbawKhDUAQAL8gIBB38gACgCFCgCAEEIaiICIQEgACgCDCIDIAJNBEAgACgCEEEsaiEBCwJAIAEtAARByABHDQAgASgCACIBRQ0AIAAgASADIAJrQQN1QQFrEL8HIQQgAEEMaiIBKAIAIQACQAJAIARBAEgEQCAAQQE6AAQgASABKAIAIgBBCGo2AgAgAEEIayEBQQIhBQwBCyAAQRE6AAQgASABKAIAIgBBCGoiAjYCACACIARBf3NBA3QiBmohASAEQQJOBEAgAEEIayECIAEhAwNAIAMoAgAhBSADIAIoAgA2AgAgAy0ABCEHIAMgAi0ABDoABCACIAc6AAQgAiAFNgIAIANBCGoiAyACQQhrIgJJDQALCyAEQQFqIQUgBkF3Sg0BCwNAIAEoAgAhAiABIAAoAgA2AgAgAS0ABCEDIAEgAC0ABDoABCAAIAM6AAQgACACNgIAIAFBCGoiASAAQQhrIgBJDQALCyAFDwsgAEEBQf7AKxDUAQALtw4BCH8jAEEQayIJJAAgASgCFCEFAkACQCACIAEoAhgiBCABKAIMIgNrQQN1TgR/IAQgASgCHCIGayIEQYC0iRNKDQECQCACQb+WsQJMBEAgAyAGa0EDdSACaiIDQcGWsQJIDQELIAFBiJixAkEAEKsGGgwCCyABQcCWsQIgBEECdSIEIARBwJaxAk4bIgQgAyADIARIG0EAEKsGRQ0BIAEoAgwFIAMLIAJBA3RqIgMgBSgCBEsEQCAFIAM2AgQLAkAgACABRiIIDQAgACAAKAIMIAJBA3RrIgQ2AgwgAkEATA0AIAEoAgwhA0EAIQUgAkEBRwRAIAJBAXEhCiACQf7///8HcSEHA0AgAyAFQQN0IgQgACgCDGoiBigCADYCACADIAYtAAQ6AAQgASABKAIMIgNBCGo2AgwgAyAAKAIMIARqIgQoAgg2AgggAyAELQAMOgAMIAEgASgCDEEIaiIDNgIMIAVBAmoiBSAHRw0ACyAKRQ0BIAAoAgwhBAsgAyAEIAVBA3RqIgUoAgA2AgAgAyAFLQAEOgAEIAEgASgCDEEIajYCDAsgCSACNgIMAkACQAJAAkACQCABLQAGDgIAAgELIAEoAgwhAyABKAIUIgUgAUE0akcEQCABIAMgAkEDdGsiBTYCDEGZjisgASgCEEGYA2oiAygCoAIiBEEQahCtAUUEQCAEIQMMBAtBmY4rIANBoAJqIgYoAgQiA0EQahCtAUUNAyAGIAQ2AgQgBiABQZmOK0ElEIAGIgM2AgAMAwsgAyAFKAIAa0EIa0EDdSACRw0BIAEgAyACQQN0ayIFNgIMQb+OKyABKAIQQaACaiIDKAKgAiIEQRBqEK0BRQRAIAQhAwwDC0G/jisgA0GgAmoiBigCBCIDQRBqEK0BRQ0CIAYgBDYCBCAGIAFBv44rQRwQgAYiAzYCAAwCCyABIAEoAgwgAkEDdGsiBTYCDEG/jisgASgCEEGgAmoiAygCoAIiBEEQahCtAUUEQCAEIQMMAgtBv44rIANBoAJqIgYoAgQiA0EQahCtAUUNASAGIAQ2AgQgBiABQb+OK0EcEIAGIgM2AgAMAQsCQCAARQRAQQAhAwwBCyABIAAvAWAiAzYCYCADQcgBSQ0AIAEgASgCDCACQQN0ayIFNgIMQbO+KSABKAIQQTBqIgMoAqACIgRBEGoQrQFFBEAgBCEDDAILQbO+KSADQaACaiIGKAIEIgNBEGoQrQFFDQEgBiAENgIEIAYgAUGzvilBEBCABiIDNgIADAELIAEgA0EBajYCYAJ/AkACQCABQSwgCUEMahB9IgRBAk4EQANAAkAgASgCFCIDBEADQCADLwEiIgVBEHENAiADKAIIIgMNAAsLIAEgBDoABiABKAIMIQNBACEFAkACQAJAAkAgBA4GAwICAgABAgsgAyABKAIQKAKUASIFNgIAIAUtAARBwAByIQUMAgsgAyABQcXuKkEXEIAGIgU2AgAgBS0ABEHAAHIhBQwBCyADIANBCGsoAgA2AgAgA0EEay0AACEFCyADIAU6AAQgASADQQhqIgM2AgwgASgCFCADNgIEDAMLIAEgAzYCFCADIAVB/8cDcSAEQQp0cjsBIiABQS1BABB9IgRBAUoNAAsLIARBAUYNASABKAIMIQMLIARBAUsNAyADIAEoAhQoAgBrQQhrQQN1DAELIAEoAhQoAhwLIQIgACgCFCEFAkAgAkEBaiIEIAAoAhgiBiAAKAIMIgNrQQN1TgRAIAYgACgCHCIHayIGQYC0iRNKDQECQCACQb6WsQJMBEAgAyAHa0EDdSAEaiIDQcGWsQJIDQELIABBiJixAkEAEKsGGgwCCyAAQcCWsQIgBkECdSIGIAZBwJaxAk4bIgYgAyADIAZIG0EAEKsGRQ0BIAAoAgwhAwsgAyAEQQN0aiIDIAUoAgRLBEAgBSADNgIECwJAIAgNACABIAEoAgwgAkEDdGsiBDYCDCACQQBMDQAgACgCDCEDQQAhBSACQQFHBEAgAkEBcSEIIAJB/v///wdxIQcDQCADIAVBA3QiBCABKAIMaiIGKAIANgIAIAMgBi0ABDoABCAAIAAoAgwiA0EIajYCDCADIAEoAgwgBGoiBCgCCDYCCCADIAQtAAw6AAwgACAAKAIMQQhqIgM2AgwgBUECaiIFIAdHDQALIAhFDQEgASgCDCEECyADIAQgBUEDdGoiASgCADYCACADIAEtAAQ6AAQgACAAKAIMQQhqNgIMCyACIQMMBAtBfyEDIAEgAkF/cxCrASAAQZ+QKxBYDAMLIAUgAzYCACAFIAMtAARBwAByOgAEIAEgASgCDEEIajYCDAtBfyEDIAgNASABIAEoAgwiBUEIayIENgIMIAAoAgwiASAEKAIANgIAIAEgBUEEay0AADoABCAAIAAoAgxBCGo2AgwMAQsgAEGCkCsQWEF/IQMLIAlBEGokACADC0wBAX8gACgCDCIBQcgAOgAEIAEgADYCACAAIAAoAgwiAUEIajYCDCABQRFBASAAKAIQKAKQASAARhs6AAwgACAAKAIMQQhqNgIMQQILrgEBAn8gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAARByABHDQAgASgCACIBRQ0AAkAgACABRgRADAELQQIhAgJAAkAgAS0ABg4CAAIBCyABKAIUIgIgAUE0akcEQEEDIQIMAgtBAUECIAEoAgwgAigCAEEIakYbIQIMAQtBASECCyAAIAJBAnRB8LgvaigCABBYQQEPCyAAQQFB/sArENQBAAvKAQEDfyAAKAIUKAIAQQhqIgIgACgCDE8EfyAAKAIQQSxqBSACCy0ABEEPcUEGRgRAIAAQjAchAiAAKAIUKAIAQQhqIgEgACgCDCIDTwRAIAAoAhBBLGohAQsgAyABKAIANgIAIAMgAS0ABDoABCAAIAAoAgwiAUEIajYCDCAAIAJHBEAgACABNgIMIAIoAgwiAyABKAIANgIAIAMgAS0ABDoABCACIAIoAgxBCGo2AgwLIABBLkEBEIIGQQEPCyAAQQFBtrAqENQBAAuKAgEFfwJ/IAAoAhQoAgAiAi0ABEHmAEYEQCACKAIAIgEtAAYEQCABQRBqDAILIAAoAhBBLGoMAQsgACgCEEEsagshA0EAIQEgAy0ABEHIAEYEQCADKAIAIQELIAAgASAAKAIMIAJrQQhrQQN1EL8HIgJBAEgEQAJAIAEtAAZBAk8EQCABIAAQjQchAiAAIAFHBEAgASABKAIMIgNBCGsiBDYCDCAAQQxqIgEoAgAiBSAEKAIANgIAIAUgA0EEay0AADoABCABIAEoAgBBCGo2AgALIAJBBEYNAQsgACgCDEEEay0AAEEPcUEERw0AIAAQlAEgAEF+QQEQ+gUgABCWAQsgABCXAQALIAILfwECfwJAAkAgACgCYEGAgARPBEAgACAAKAIQKAKQAUcNASAAQdyOK0EAEJcGAAsgACgCFCIBKAIAIQIgAEEBOgAGIAEgACgCDCACa0EIa0EDdTYCHCABLQAiQQJxDQFBAA8LIABBv6spQQAQlwYACyABQQA2AhAgAEEBEIQGAAuhAQEFfyAAKAIUKAIAQQhqIgEhAiABIAAoAgwiBEkiBUUEQCAAKAIQQSxqIQILAkAgAi0ABEEPcUUEQCAAIQMgAiAAKAIQQSxqRg0BCyAFRQRAIAAoAhBBLGohAQsgAS0ABEHIAEYEQCABKAIAIgMNAQsgAEEBQf7AKxDUAQALIARBAUERIAMoAmBB//8DSxs6AAQgACAAKAIMQQhqNgIMQQELnQIBBH8jAEEQayIDJAAgACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkAgAS0ABEHIAEcNACABKAIAIgFFDQAgACABRgRAQQAhAQwCCwJAIAEtAAYNACABKAIUIAFBNGpGDQBBAyEBDAILIAEgABCNByEEIAAoAgwhAgJ/IARFBEAgAkEROgAEQQEMAQsgAkEBOgAEIAAgACgCDEEIajYCDCABIAEoAgwiBEEIayICNgIMIAAoAgwiASACKAIANgIAIAEgBEEEay0AADoABEECCyEBIAAgACgCDEEIajYCDCADQRBqJAAgAQ8LIABBAUH+wCsQ1AEACyADIAFBAnRB8LgvaigCADYCACAAQf2NKyADEKUBAAvrBAEHfyMAQaACayIDJAADQAJAQdiILEELQQFBkO8zECNBkO8zEFYaQfTwMygCABpB+QEhAiADQRBqIgYhBAJAA0ACQAJAAkBBrPAzKAIAIgFBsPAzKAIAIgVGDQACfyABQQogBSABaxCTCCIHBEAgB0Gs8DMoAgAiBWtBAWoMAQtBsPAzKAIAQazwMygCACIFawshASAEIAUgASACIAEgAkkbIgEQGxpBrPAzQazwMygCACABaiIFNgIAIAEgBGohBCAHDQIgAiABayICRQ0CIAVBsPAzKAIARg0AQazwMyAFQQFqNgIAIAUtAAAhAQwBC0Go8DMQ1AwiAUEATg0AQQAhAiAEIAZGDQNBqPAzLQAAQRBxDQEMAwsgBCABOgAAIARBAWohBCABQf8BcUEKRg0AIAJBAWsiAg0BCwsgBkUEQEEAIQIMAQsgBEEAOgAAIAYhAgsgAkUNACADQRBqQeaJLEEGEIQCRQ0AIAMgA0EQahAnNgKcAiADIANBEGo2ApgCAkAgAEEKIANBmAJqQcH8K0EAEHBFBEAgACgCDCECIANBADYCnAIgAyACQQhrIgY2ApgCIAAoAlwhAiAAQQA2AlwgAC0AByEBIAAoAhQhBSAAKAIcIQQgAEENIANBmAJqEH0iB0UEQCAAIAI2AlwgAEEAEKsBDAQLIAAgAToAByAAIAU2AhQgACAAIAYgBGsiBiAHEIEBIgEgACgCHCAGahCCASAAEIMBIAAgAjYCXCABRQ0BCyADIABBf0EAEKIHNgIAQdiLLCADEFVBkO8zEFYaCyAAQQAQqwEMAQsLIANBoAJqJABBAAvtAgEFfyMAQRBrIgMkAAJAAkACQAJAIAAoAhQoAgBBEGoiASAAKAIMSQRAIAEtAARBD3ENAUEBIQIMBAsgACgCEC0AMEEPcQ0BQQEhAgwDCyADQQA2AgwMAQsgA0EANgIMIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAhAgwBCyABIANBDGpBABD8ASEBIAMoAgwhAiABDQAgAEECEP0BCwJAAkACQAJAIAAoAhQoAgBBCGoiBCAAKAIMIgFJBEAgBC0ABEEPcUEHRw0BDAMLIAAoAhAtADBBD3FBB0YNAQsgAUEAOgAEQQEhBQwCCyAAKAIQQSxqIQQLQQEhBQJAIAJBAEoEQCACIAQoAgAiBC8BBk0NAQsgAUEAOgAEDAELIAEgAkEDdCAEaiIFKAIQNgIAIAEgBS0AFDoABCAAIAAoAgwiAUEIajYCDCABQRE6AAxBAiEFCyAAIAAoAgxBCGo2AgwgA0EQaiQAIAULugYBB38jAEEQayIFJAAgACgCFCgCAEEIaiIBIQICfyAAIAEgACgCDCIESSIGBH8gAgUgACgCEEEsagstAARBD3EiAkUNABogACACQQhHDQAaIAZFBEAgACgCEEEsaiEBC0EAIAEtAARByABHDQAaIAEoAgALIgMoAnAhBwJAAn8gAygCWCIBRQRAQQAhAkEBDAELAkAgAUEvRwRAIABBt9IqEFgMAQsgAEHY4c59QY7bKxCQARoCQCAAIANHBEAgAygCFCEEIAMoAhgiAiADKAIMIgFrQQhMBH8gAiADKAIcIgZrIgJBgLSJE0oNBSABIAZrQQN1IgFBwJaxAk4EQCADQYiYsQJBABCrBhoMBgsgA0HAlrECIAJBAnUiAiACQcCWsQJOGyICIAFBAWoiASABIAJIG0EAEKsGRQ0FIAMoAgwFIAELQQhqIgEgBCgCBEsEQCAEIAE2AgQLIAMoAgwiAUHIADoABCABIAM2AgAgACgCDCIBIAMoAgwiBCgCADYCACABIAQtAAQ6AAQgACAAKAIMQQhqIgE2AgwMAQsgAygCDCIBQcgAOgAEIAEgAzYCACADIAMoAgxBCGo2AgwgACgCDCEBCyABQRBrKAIAIAFBCGsQoAEhASAAIAAoAgwiBEEIayICNgIMIARBBGsgAS0ABEEPcQR/IAIgASgCADYCACABLQAEBUEACzoAACAAIAAoAgwiAUEIajYCDCABQQhrIQQDQCAEKAIAIQIgBCABKAIANgIAIAQtAAQhBiAEIAEtAAQ6AAQgASAGOgAEIAEgAjYCACAEQQhqIgQgAUEIayIBSQ0ACyAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwLQQAhASAHQQFxBEAgBUHjADoAC0EBIQELIAdBAnEEQCAFQQtqIAFqQfIAOgAAIAFBAWohAQsgB0EEcQR/IAVBC2ogAWpB7AA6AAAgAUEBagUgAQsgBUELampBADoAACAAIAVBC2oQWCAAKAIMIgQgAygCaDYCAEEDIQJBAwshASAEIAI6AAQgACAAKAIMQQhqNgIMIAVBEGokACABDwsgAEG1vilBABClAQAL7gEBA38gAEHY4c59QY7bKxCQARogACgCDCICQcgAOgAEIAIgADYCACAAIAAoAgwiAkEIajYCDCACQQhrKAIAIAIQoAEhAiAAIAAoAgwiA0EIayIENgIMIANBBGsgAi0ABEEPcQR/IAQgAigCADYCACACLQAEBUEACzoAACAAIAAoAgwiAkEIajYCDCACLQAEQQ9xQQZGBEAgACABKAIAQQJ0QZC6L2ooAgAQWEEAIQMgACgCDCICIAEoAhgiAUEATgR/IAIgATYCAEEDBSADCzoABCAAIAAoAgwiAkEIajYCDCAAIAJBEGtBABCRBgsLvRABCX8jAEHwAGsiBCQAAkACfwJAAkACQAJAIAAoAhQoAgAiAkEIaiIBIAAoAgwiBUkEQCABLQAEQQ9xQQhHDQEMAwsgACgCEC0AMEEPcUEIRg0BCwJAIAUgAkEQaiIBSwRAIAEtAARBD3ENAQwECyAAKAIQLQAwQQ9xRQ0DIAAoAhBBLGohAQsCQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRBqIgEgACgCDEkNACAAKAIQQSxqIQELQQEhCEECIQkgASgCAEEQagwECyAAQQJB+O0qENQBAAsgACgCEEEsaiEBCyABLQAEQcgARgRAIAEoAgAhAwsCQAJAAn8CQCAFIAJBGGoiAUsEQCABLQAEQQ9xDQFBlMIpDAILQZTCKSAAKAIQLQAwQQ9xRQ0BGiAAKAIQQSxqIQELAkACQCABLQAEQQ9xQQNrDgIAAQMLIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBGGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCAEEQagshB0ECIQFBAyEJIAAgA0YEQEEBIQgMBQsgAygCFCEFIAMoAhgiBiADKAIMIgJrQRhMBEAgBiADKAIcIghrIgZBgLSJE0oNAiACIAhrQQN1IgJBvpaxAk4EQCADQYiYsQJBABCrBhoMAwsgA0HAlrECIAZBAnUiBiAGQcCWsQJOGyIGIAJBA2oiAiACIAZIG0EAEKsGRQ0CIAMoAgwhAgtBACEIIAJBGGoiAiAFKAIETQ0EIAUgAjYCBAwECyAAQQNB+O0qENQBAAsgAEG1vilBABClAQALQQEhCEECIQlBlMIpCyEHIAAhA0EBIQELAkACQAJAIActAABBPkcEQAJAIAAoAhQoAgAgAUEDdGoiAiAAKAIMTwR/IAAoAhBBLGoFIAILLQAEQQ9xQQZGBEAgBCAHNgIAIABBn4UqIAQQpgEhByAAKAIUKAIAIAFBA3RqIgEgACgCDCICTwRAIAAoAhBBLGohAQsgAiABKAIANgIAIAIgAS0ABDoABCAAIAAoAgwiAUEIajYCDCAAIANGDQEgACABNgIMIAMoAgwiAiABKAIANgIAIAIgAS0ABDoABCADIAMoAgxBCGo2AgwMAQsgACABEKAHIgJBAEgNAiADKAIUIgEgA0E0aiIFRyEGAkAgAkUNACABIAVGDQADQCABKAIIIgEgBUchBiACQQFrIgJFDQEgASAFRw0ACwsgAg0CIAZFDQIgBCABNgJsCyADIAcgBEEEahCaBkUNAiAAQQBBABChASAHQdMAEJ4BBEAgACAEKAIUIAQoAhgQnwEgACAAKAIMQRBrQe+jKxBZIAAgBEEwahBYIAAgACgCDEEQa0HlwysQWSAEKAIgIQEgACgCDCICQQM6AAQgAiABNgIAIAAgACgCDCIBQQhqNgIMIAAgAUEIa0H6uisQWSAEKAIkIQEgACgCDCICQQM6AAQgAiABNgIAIAAgACgCDCIBQQhqNgIMIAAgAUEIa0H2uisQWSAAIAQoAhAQWCAAIAAoAgxBEGtB8OspEFkLIAdB7AAQngEEQCAEKAIcIQEgACgCDCICQQM6AAQgAiABNgIAIAAgACgCDCIBQQhqNgIMIAAgAUEIa0GNjysQWQsgB0H1ABCeAQRAIAQtACghASAAKAIMIgJBAzoABCACIAE2AgAgACAAKAIMIgFBCGo2AgwgACABQQhrQej5KRBZIAQtACkhASAAKAIMIgJBAzoABCACIAE2AgAgACAAKAIMIgFBCGo2AgwgACABQQhrQdL8KRBZIAAoAgxBEUEBIAQtACobOgAEIAAgACgCDCIBQQhqNgIMIAAgAUEIa0GD6CoQWQsgB0HuABCeAQRAIAAgBCgCCBBYIAAgACgCDEEQa0HMkSsQWSAAIAQoAgwQWCAAIAAoAgxBEGtB7OspEFkLIAdB8gAQngEEQCAELwEsIQEgACgCDCICQQM6AAQgAiABNgIAIAAgACgCDCIBQQhqNgIMIAAgAUEIa0GgmSoQWSAELwEuIQEgACgCDCICQQM6AAQgAiABNgIAIAAgACgCDCIBQQhqNgIMIAAgAUEIa0GWmSoQWQsgB0H0ABCeAQRAIAAoAgxBEUEBIAQtACsbOgAEIAAgACgCDCIBQQhqNgIMIAAgAUEIa0GQyioQWQsgB0HMABCeAQRAAkAgCARAIAAoAgwiAkEQayEBIAJBCGshAgNAIAEoAgAhBSABIAIoAgA2AgAgAS0ABCEGIAEgAi0ABDoABCACIAY6AAQgAiAFNgIAIAFBCGoiASACQQhrIgJJDQALDAELIAAgA0YNACADIAMoAgwiAUEIayICNgIMIAAoAgwiBSACKAIANgIAIAUgAUEEay0AADoABCAAIAAoAgxBCGo2AgwLIAAgACgCDEEQa0HngSoQWQsgB0HmABCeAUUNAwJAIAgEQCAAKAIMIgJBEGshASACQQhrIQIDQCABKAIAIQUgASACKAIANgIAIAEtAAQhBiABIAItAAQ6AAQgAiAGOgAEIAIgBTYCACABQQhqIgEgAkEIayICSQ0ACwwBCyAAIANGDQAgAyADKAIMIgFBCGsiAjYCDCAAKAIMIgUgAigCADYCACAFIAFBBGstAAA6AAQgACAAKAIMQQhqNgIMCyAAIAAoAgxBEGtB+MMrEFkMAwsgACAJQcWHLBCGAgALIAAoAgxBADoABCAAIAAoAgxBCGo2AgwMAQsgACAJQYauKhCGAgALIARB8ABqJABBAQv8CAEMfwJ/AkACQCAAKAIUKAIAQQhqIgIgACgCDEkEQCACLQAEQQ9xQQhGDQEMAgsgACgCEC0AMEEPcUEIRw0BIAAoAhBBLGohAgtBASEBQQAgAi0ABEHIAEcNARogAigCAAwBCyAACyEEIAAgAUECchCgByEFAkACQCAAKAIUKAIAIAFBAWoiCEEDdGoiASAAKAIMIgJJBEAgAS0ABEEPcUEGRg0BDAILIAAoAhAtADBBD3FBBkcNASAAKAIQQSxqIQELIAIgASgCADYCACACIAEtAAQ6AAQgACAAKAIMIgFBCGo2AgxBACEEAkAgAS0ABEHGAEcNACABKAIAKAIMIgEoAiAiBkEATA0AIAEoAkghA0EAIQEDQCADIAFBDGxqIgIoAgRBAEoNAQJAIAIoAghBAEwNACAFQQFrIgUNACAAIAIoAgBBEGoQWEEBDwsgAUEBaiIBIAZHDQALCyAAIAQQWEEBDwsCQAJ/An8CQAJAIAAgCBCgByICQQBIDQAgBCgCFCIHIARBNGoiA0chBgJAIAJFBEAgByEBDAELIAMgB0YEQCAHIQEMAQsgByEBA0AgASgCCCIBIANHIQYgAkEBayICRQ0BIAEgA0cNAAsLIAINACAGRQ0AAkAgACAERiILDQAgBCgCGCIDIAQoAgwiAmtBCEwEfyADIAQoAhwiBmsiA0GAtIkTSg0GIAIgBmtBA3UiAkHAlrECTgRAIARBiJixAkEAEKsGGgwHCyAEQcCWsQIgA0ECdSIDIANBwJaxAk4bIgMgAkEBaiICIAIgA0gbQQAQqwZFDQYgBCgCDAUgAgtBCGoiAiAHKAIETQ0AIAcgAjYCBAsgASgCACEJAkACQCABLwEiQQJxIgwNACAJKAIAKAIMIQIgBUEASARAIAItAAdFDQIgBUEAIAEoAhhrIgFIDQJBrPsrIQIgCSABQQN0aiAFQX9zQQN0agwGCyACKAIgIghBAEwNACABKAIQIAIoAjRrQQJ1IQMgAigCSCEHQQAhAiAFIQoDQCAHIAJBDGxqIgYoAgQgA04NASAGKAIIIANOBEAgCkEBayIKRQ0FCyACQQFqIgIgCEcNAAsLIAQoAhQgAUYEfyAEQQxqBSABKAIMCyEBIAVBAEwNACABKAIAIAlBCGprQQN1IAVIDQBBwPYrQbT2KyAMGwwDCyAAKAIMQQA6AAQgACAAKAIMQQhqNgIMQQEPCyAAIAhBtJwrEIYCAAsgBigCAEEQagshAiAJIAVBA3RqCyEBIAQoAgwiAyABKAIANgIAIAMgAS0ABDoABCAEIAQoAgwiAUEIajYCDCALRQRAIAQgATYCDCAAKAIMIgMgASgCADYCACADIAEtAAQ6AAQgACAAKAIMQQhqNgIMCyAAIAIQWCAAKAIMIgJBEGshASACQQhrIQIDQCABKAIAIQMgASACKAIANgIAIAEtAAQhACABIAItAAQ6AAQgAiAAOgAEIAIgAzYCACABQQhqIgEgAkEIayICSQ0AC0ECDwsgAEG1vilBABClAQALMQECfyAAKAIMIgEgACgCECICKAIkNgIAIAEgAi0AKDoABCAAIAAoAgxBCGo2AgxBAQvTAQEDfyAAKAIUKAIAIgJBCGoiASAAKAIMIgNPBEAgACgCEEEsaiEBCwJAIAEtAARBD3FFBEAgASAAKAIQQSxqRg0BCyADAn8gAyACQQhqIgFNBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xIgJBBWsOAwACAQILIAEoAgBBGGoMAgsgASgCAEEMagwBCyAAKAIQIAJBAnRqQfwBagsoAgAiAQR/IAMgATYCAEHFAAVBAAs6AAQgACAAKAIMQQhqNgIMQQEPCyAAQQFBwrYrEIYCAAvWAwEGfyMAQRBrIgUkACAFQQA2AgwgACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQMMAQsgASAFQQxqQQAQ/AEhASAFKAIMIQMgAQ0AIABBAhD9AQsgACgCFCgCACICQQhqIgEgACgCDCIETwR/IAAoAhBBLGoFIAELLQAEQQ9xQQZGBEAgBCACQQhqIgFNBEAgACgCEEEsaiEBC0EAIQICQCAEAn8gAS0ABEE/cSIGQQZHBEAgBkEmRw0CIANBAWsiAyABKAIAIgEtAAZPDQJBt5MsIQIgASADQQN0akEQagwBCyADQQFrIgMgASgCACIBKAIMIgYoAgxPDQEgBigCPCADQQN0aigCACICQRBqQZH8KyACGyECIAEgA0ECdGooAhAoAggLIgEoAgA2AgAgBCABLQAEOgAEIAAgACgCDEEIajYCDCAAIAIQWCAAKAIMIgFBEGshACABQQhrIQEDQCAAKAIAIQQgACABKAIANgIAIAAtAAQhAiAAIAEtAAQ6AAQgASACOgAEIAEgBDYCACAAQQhqIgAgAUEIayIBSQ0AC0ECIQILIAVBEGokACACDwsgAEEBQbawKhDUAQALhwgBCX8jAEEQayIHJAAgB0EANgIIIAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEEDAELIAEgB0EIakEAEPwBIQEgBygCCCEEIAENACAAQQIQ/QELAkACQAJAAkACQCAAKAIUIgIoAgAiA0EIaiIBIAAoAgwiBk8EfyAAKAIQQSxqBSABCy0ABEEPcUEGRgRAIANBCGoiAyEBIAMgBkkiCEUEQCAAKAIQQSxqIQELAkAgAS0ABEE/cSIFQSZHBEAgBUEGRw0HIAhFBEAgACgCEEEsaiEDC0Hcqi8hAQJAIARBAEwNACAEIAMoAgAiAygCDCgCDEoNACAEQQJ0IANqQQxqIQELIAEoAgANAQwHCyAEQQBMDQYgBCABKAIALQAGSw0GCyAHQQA2AgwgBiACKAIAQSBqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQMMAQsgASAHQQxqQQAQ/AEhASAHKAIMIQMgAQ0AIABBBBD9AQsgACgCFCgCACIBQRhqIgIgACgCDCIGTwR/IAAoAhBBLGoFIAILLQAEQQ9xQQZHDQEgAUEYaiIFIQIgBSAGSSIJRQRAIAAoAhBBLGohAgsCQCACLQAEQT9xIghBJkcEQCAIQQZHDQYgCUUEQCAAKAIQQSxqIQULQdyqLyECAkAgA0EATA0AIAMgBSgCACIFKAIMKAIMSg0AIANBAnQgBWpBDGohAgsgAigCAA0BDAYLIANBAEwNBSADIAIoAgAtAAZLDQULIAYgAUEIaiICTQR/IAAoAhBBLGoFIAILLQAEIgJB5gBGDQIgAkEWRg0CIAYgAUEYaiICTQR/IAAoAhBBLGoFIAILLQAEIgJB5gBGDQMgAkEWRg0DIAYgAUEIaiICTQR/IAAoAhBBLGoFIAILKAIAIQJB3KovIQUCQCAEQQBMDQAgBCACKAIMKAIMSg0AIARBAnQgAmpBDGohBQsgBiABQRhqIgRNBEAgACgCEEEsaiEEC0Hcqi8hAQJAIANBAEwNACADIAQoAgAiBCgCDCgCDEoNACADQQJ0IARqQQxqIQELIAUgASgCACIBNgIAAkAgAi0ABSIEQSBxRQ0AIAEtAAVBGHFFDQAgACgCECIALQA5QQJNBEAgACABEI4GIAItAAVBBnFFDQEgASABLQAFQfgBcUECcjoABQwBCyAALQA6DQAgAiAALQA4QRhxIARBxwFxcjoABQsgB0EQaiQAQQAPCyAAQQFBtrAqENQBAAsgAEEDQbawKhDUAQALIABBAUHRtSsQhgIACyAAQQNB0bUrEIYCAAsgAEEEQau8KRCGAgALIABBAkGrvCkQhgIAC/kCAQh/IwBBEGsiBCQAIARBADYCDCAAKAIUKAIAQRBqIgEgACgCDE8EQCAAKAIQQSxqIQELAkAgAS0ABEEDRgRAIAEoAgAhAwwBCyABIARBDGpBABD8ASEBIAQoAgwhAyABDQAgAEECEP0BCyAAKAIUKAIAIgJBCGoiASAAKAIMIgVPBH8gACgCEEEsagUgAQstAARBD3FBBkYEQCACQQhqIgIhASACIAVJIgdFBEAgACgCEEEsaiEBCwJAAkAgAS0ABEE/cSIIQSZHBEAgCEEGRw0CIAdFBEAgACgCEEEsaiECC0Hcqi8hAQJAIANBAEwNACADIAIoAgAiAigCDCgCDEoNACADQQJ0IAJqQQxqIQELIAEoAgAiAQ0BDAILIANBAEwNASADIAEoAgAiAS0ABksNASADQQN0IAFqQQhqIQELIAUgATYCAEECIQYLIAUgBjoABCAAIAAoAgxBCGo2AgwgBEEQaiQAQQEPCyAAQQFBtrAqENQBAAv8AwEFfyMAQRBrIgQkAAJAAkACQAJAIAAoAhQoAgAiAUEYaiICIAAoAgwiA0kEQCACLQAEQQ9xDQEMBAsgACgCEC0AMEEPcQ0BDAMLIARBADYCDAwBCyAEQQA2AgwgACgCEEEsaiECCwJAIAItAARBA0YEQCACKAIAIQEMAQsgAiAEQQxqQQAQ/AEhAyAEKAIMIQEgAw0AIABBAxD9AQsgAUEBayEFIAAoAgwhAyAAKAIUKAIAIQELAkAgAyABQQhqIgJNBH8gACgCEEEsagUgAgstAARBD3FBB0YEQCADIAFBEGoiAU0EQCAAKAIQQSxqIQELIAEtAARBD3FFBEAgASAAKAIQQSxqRg0CCyAAQQIQqwEgAAJ/IAAoAhQoAgBBCGoiAyAAKAIMIgFPBEAgACgCEEEsaiEDCyADKAIAIgIvAQYgBUsEQCACIAVBA3RqIgIgAUEIaygCADYCGCACIAFBBGstAAA6ABwCQCAAKAIMIgFBBGstAABBwABxRQ0AIAMoAgAiAy0ABUEgcUUNACABQQhrKAIALQAFQRhxRQ0AIAAgAxCJBiAAKAIMIQELIAFBCGsMAQsgACABQQhrNgIMIAFBBGtBADoAACAAKAIMQQhqCzYCDCAEQRBqJABBAQ8LIABBAUHcsS8Q1AEACyAAQQJBwrYrEIYCAAvfBwEJfwJ/AkACQCAAKAIUKAIAIgFBCGoiAiAAKAIMIgRJBEAgAi0ABEEPcUEIRg0BDAILIAAoAhAtADBBD3FBCEcNASAAKAIQQSxqIQILQQEhA0EAIAItAARByABHDQEaIAIoAgAMAQsgAAshAgJAAkACQAJAAkACfyAEIAEgA0EBaiIFQQN0aiIBTQR/IAAoAhBBLGoFIAELLQAEQQ9xRQRAIAAgBRCrAUEAIQRBAAwBCyAAIANBAnIiBEEAEIgBIgFFDQEgACgCFCgCACAFQQN0aiIEIAAoAgxPBH8gACgCEEEsagUgBAstAARBD3FBBkcNAiAAIANBA2pBABDxAyEEQS8hCCABQeMAEJ4BQQBHIgNBAnIgAyABQfIAEJ4BGyIDQQRyIAMgAUHsABCeARsiA0EIciADIARBAEobCyEDIABB2OHOfUGO2ysQkAFBBUcEQCAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAEEAQQAQoQEgACgCDCIBIAFBCGsoAgA2AgAgASABQQRrLQAAOgAEIAAgACgCDEEIajYCDCAAIAAoAhBBJGpBjtsrEFkgAEHZ2ioQWCAAIAAoAgxBEGtB6qErEFkgACgCDCIBIAFBCGsoAgA2AgAgASABQQRrLQAAOgAEIAAgACgCDEEIajYCDCAAQX4Q2wELIAAgAkYNAiACKAIUIQcgAigCGCIGIAIoAgwiAWtBCEwEfyAGIAIoAhwiCWsiBkGAtIkTSg0FIAEgCWtBA3UiAUHAlrECTgRAIAJBiJixAkEAEKsGGgwGCyACQcCWsQIgBkECdSIGIAZBwJaxAk4bIgYgAUEBaiIBIAEgBkgbQQAQqwZFDQUgAigCDAUgAQtBCGoiASAHKAIESwRAIAcgATYCBAsgAigCDCIBQcgAOgAEIAEgAjYCACAAKAIMIgEgAigCDCIHKAIANgIAIAEgBy0ABDoABCAAIAAoAgxBCGoiATYCDAwDCyAAIARB+O0qENQBAAsgACAFQbawKhDUAQALIAIoAgwiAUHIADoABCABIAI2AgAgAiACKAIMQQhqNgIMIAAoAgwhAQsgASAAKAIUKAIAIAVBA3RqIgVNBEAgACgCEEEsaiEFCyABIAUoAgA2AgAgASAFLQAEOgAEIAAgACgCDEEIajYCDCAAQX0QjAYgAiAIQQAgAxs2AlggAiAENgJsIAIgBDYCaCACIAM2AnACQCADRQ0AIAIoAhQiAEUNAANAIAAtACJBAnFFBEAgAEEBNgIUCyAAKAIIIgANAAsLQQAPCyAAQbW+KUEAEKUBAAvDBwELfwJ/AkACQCAAKAIUKAIAQQhqIgIgACgCDEkEQCACLQAEQQ9xQQhGDQEMAgsgACgCEC0AMEEPcUEIRw0BIAAoAhBBLGohAgtBASEGQQAgAi0ABEHIAEcNARogAigCAAwBCyAACyEDIAAgBkEBaiIJEKAHIQEgACAGQQJyEKAHIQcCQAJ/An8CQAJAAkAgAUEASA0AIAMoAhQiAiADQTRqIgRHIQUCQCABRQ0AIAIgBEYNAANAIAIoAggiAiAERyEFIAFBAWsiAUUNASACIARHDQALCyABDQAgBUUNACAAKAIUKAIAIAZBA2oiBEEDdGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABEEPcUUEQCABIAAoAhBBLGpGDQILIAAgBBCrASAAIANHBEAgAygCFCEEIAMoAhgiBSADKAIMIgFrQQhMBH8gBSADKAIcIgZrIgVBgLSJE0oNByABIAZrQQN1IgFBwJaxAk4EQCADQYiYsQJBABCrBhoMCAsgA0HAlrECIAVBAnUiBSAFQcCWsQJOGyIFIAFBAWoiASABIAVIG0EAEKsGRQ0HIAMoAgwFIAELQQhqIgEgBCgCBEsEQCAEIAE2AgQLIAAgACgCDCIBQQhrIgQ2AgwgAygCDCIFIAQoAgA2AgAgBSABQQRrLQAAOgAEIAMgAygCDEEIajYCDAsgAigCACEIAkACQCACLwEiQQJxIgsNACAIKAIAKAIMIQEgB0EASARAIAEtAAdFDQIgB0EAIAIoAhhrIgJIDQJBrPsrIQEgCCACQQN0aiAHQX9zQQN0agwHCyABKAIgIglBAEwNACACKAIQIAEoAjRrQQJ1IQQgASgCSCEGQQAhASAHIQoDQCAGIAFBDGxqIgUoAgQgBE4NASAFKAIIIAROBEAgCkEBayIKRQ0GCyABQQFqIgEgCUcNAAsLIAMoAhQgAkYEfyADQQxqBSACKAIMCyECIAdBAEwNACACKAIAIAhBCGprQQN1IAdIDQBBwPYrQbT2KyALGwwECyADIAMoAgxBCGsiAiADKAIkTQR/IAMgAkF/QQAQXgUgAgs2AgwgACgCDEEAOgAEIAAgACgCDEEIajYCDCAAKAIQKAIMQQBKBEAgABBUC0EBDwsgACAJQbScKxCGAgALIAAgBEHCtisQhgIACyAFKAIAQRBqCyEBIAggB0EDdGoLIgIgAygCDCIEQQhrKAIANgIAIAIgBEEEay0AADoABCADIAMoAgxBCGs2AgwgACABEFhBAQ8LIABBtb4pQQAQpQEAC2cBAX8gACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xDgYAAQEBAQIBCyABIAAoAhBBLGpHDQELIABBAkGclysQ1AEACyAAQQIQqwEgAEEBENsBQQELlQIBBH8jAEEQayIDJAAgACgCFCgCACICQRhqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQAJAIAEtAARBD3FFBEAgASAAKAIQQSxqRg0BCyADQQA2AgwgBCACQRBqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQIMAQsgASADQQxqQQAQ/AEhASADKAIMIQIgAQ0AIABBAhD9AQsgACgCFCgCAEEIaiIBIAAoAgxPBH8gACgCEEEsagUgAQstAARBD3FBBkcNAUEBIQECQCAAQQEgAhCZBiICRQRAQQAhAQwBCyAAIAIQWAsgA0EQaiQAIAEPCyAAQQNBwrYrEIYCAAsgAEEBQbawKhDUAQAL0BEBDX8jAEHgA2siAyQAAn8CQAJAIAAoAhQoAgBBCGoiBSAAKAIMSQRAIAUtAARBD3FBCEYNAQwCCyAAKAIQLQAwQQ9xQQhHDQEgACgCEEEsaiEFC0EBIQFBACAFLQAEQcgARw0BGiAFKAIADAELIAALIQoCQAJAIAAgAUEBaiIFQQAQiAEiCw0AAkAgACgCFCgCACAFQQN0aiIFIAAoAgwiAkkEQCAFLQAEQQ9xDQEMAgsgACgCEC0AMEEPcUUNASAAKAIQQSxqIQULIAIgBSgCADYCACACIAUtAAQ6AAQgACAAKAIMQQhqNgIMDAELIApBNGohBSAAIAFBAnIgACAKRhDxAyEIQQEhAUEBIQcDQAJAIAEiBiECIAooAhQiASAFRg0AA0ACQCABKAIIIQEgAkEBayICRQ0AIAEgBUcNAQsLIAINACABIAVGDQAgBkEBdCEBIAYhBwwBCwsgBiAHSgRAA0AgBiAHaiICQQJtIQkgAkF/SAR/IAkFIAooAhQiASAFRyEEAkAgAkECa0F8SwRAIAkhAgwBCyAJIQIgASAFRg0AA0AgASgCCCIBIAVHIQQgAkEBayICRQ0BIAEgBUcNAAsLIAlBAWogByACRSAEcSIBGyEHIAYgCSABGwshBiAGIAdKDQALCyADIAA2AtwBIANCgAI3AtQBIAMgA0HgAWoiDTYC0AEgACgCDCIBQQI6AAQgASADQdABajYCACAAIAAoAgxBCGo2AgwgCCAGa0FqSCECIAsEQAJAIAsQJyIBRQRAIAMoAtgBIQEMAQsgA0HQAWogAUF/EJcHIQQgAQRAIAQgCyAB/AoAAAsgAyADKALYASABaiIBNgLYAQsgAygC1AEgAU0EQCADQdABakEBQX8QlwcaIAMoAtgBIQELIAMgAUEBajYC2AEgAygC0AEgAWpBCjoAAAtBCkF/IAIbIQcgA0HQAWpBEEF/EJcHQdDkK/0AAAD9CwAAIAMgAygC2AFBEGo2AtgBIAZBC2shCyADQZABaiEMA0ACQCAIQQBIDQAgCigCFCIBIAVHIQQCQCAIRQRAIAghAgwBCyAIIQIgASAFRg0AA0AgASgCCCIBIAVHIQQgAkEBayICRQ0BIAEgBUcNAAsLIAINACAERQ0AIAMgATYCzAEgB0EBayEJIAdFBEAgAyALIAhBf3NqNgIAIABB6PcrIAMQpgEaIAMoAtwBIgEoAgwiCEEIayEEQQAhAkEAIQYCQAJAAkAgCEEEay0AAEEPcUEDaw4CAAECCyABIAQQUyABKAIQKAIMQQBKBEAgARBUCyABKAIMQQhrIQQLIAQoAgAiBC0AByICQf8BRgRAIAQoAgwhAgsgBEEQaiEGCyADQdABaiACQX4QlwchBCACBEAgBCAGIAL8CgAACyADIAMoAtgBIAJqNgLYASABIAEoAgxBCGsiAiABKAIkTQR/IAEgAkF/QQAQXgUgAgs2AgwgCSEHIAshCAwCCyAKQbTUKSADQeQAahCaBhoCQCADKAJ8IgFBAEwEQCADIAw2AkAgAEHBiCwgA0FAaxCmARoMAQsgAyABNgJUIAMgDDYCUCAAQcuILCADQdAAahCmARoLIAMoAtwBIgEoAgwiB0EIayEEQQAhAkEAIQYCQAJAAkAgB0EEay0AAEEPcUEDaw4CAAECCyABIAQQUyABKAIQKAIMQQBKBEAgARBUCyABKAIMQQhrIQQLIAQoAgAiBC0AByICQf8BRgRAIAQoAgwhAgsgBEEQaiEGCyADQdABaiACQX4QlwchBCACBEAgBCAGIAL8CgAACyADIAMoAtgBIAJqNgLYASABIAEoAgxBCGsiAiABKAIkTQR/IAEgAkF/QQAQXgUgAgs2AgwCQCAAIANB5ABqEJgHBEAgACgCDCIEQQhrIQJBACEBAkACQAJAIARBBGstAABBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCDEEIayECCyACKAIAQRBqIQELIAMgATYCMCAAQdODLCADQTBqEKYBGiAAKAIMIgJBEGshASACQQhrIQIDQCABKAIAIQQgASACKAIANgIAIAEtAAQhBiABIAItAAQ6AAQgAiAGOgAEIAIgBDYCACABQQhqIgEgAkEIayICSQ0ACyAAIAAoAgxBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwMAQsgAygCbCIBLQAABEAgAyABNgIgIAMgAygCaDYCJCAAQbeDLCADQSBqEKYBGgwBCyADKAJwLQAAIgFBwwBHBEAgAUHtAEYEQCAAQefSKhBYDAILIAMgDDYCECADIAMoAoABNgIUIABBj+QrIANBEGoQpgEaDAELIABB5OMrEFgLIAMoAtwBIgEoAgwiB0EIayEEQQAhAkEAIQYCQAJAAkAgB0EEay0AAEEPcUEDaw4CAAECCyABIAQQUyABKAIQKAIMQQBKBEAgARBUCyABKAIMQQhrIQQLIAQoAgAiBC0AByICQf8BRgRAIAQoAgwhAgsgBEEQaiEGCyADQdABaiACQX4QlwchBCACBEAgBCAGIAL8CgAACyADIAMoAtgBIAJqNgLYASAIQQFqIQggASABKAIMQQhrIgIgASgCJE0EfyABIAJBf0EAEF4FIAILNgIMIAkhByADLQCLAUUNASADQdABakEUQX8QlwciAUGF/ysoAAA2ABAgAUH1/iv9AAAA/QsAACADIAMoAtgBQRRqNgLYAQwBCwsgAygC3AEiBiADKALQASADKALYARCfASANIAMoAtABRwRAIAYgBigCDEEQa0F/QQAQXkEAOgAECyAGKAIMIgVBEGshASAFQQhrIQUDQCABKAIAIQIgASAFKAIANgIAIAEtAAQhBCABIAUtAAQ6AAQgBSAEOgAEIAUgAjYCACABQQhqIgEgBUEIayIFSQ0ACyAGIAYoAgxBCGsiASAGKAIkTQR/IAYgAUF/QQAQXgUgAQs2AgwLIANB4ANqJABBAQt5AQJ/IwBBEGsiAiQAIAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGDQAgASACQQxqQQAQ/AENACAAQQEQ/QELIAAoAgwiAUEDOgAEIAFByAE2AgAgACAAKAIMQQhqNgIMIAJBEGokAEEBC9AGAgZ/Bn4jAEEQayIEJAACfyAAKAIUIgMoAgAiAi0ABEHmAEYEQCACKAIAIgItAAYEQCACQRBqDAILIAAoAhBBLGoMAQsgACgCEEEsagsiASgCACECIAEtAARBD3FBB0YEQCACIAIvAQYiAUEDdEEYakEQIAEbaiECCyACIAIpAwgiByACKQMYhSIIQi2JNwMYIAIgAikDACIJIAIpAxCFIgogB0IRhoU3AxAgAiAHIAqFNwMIIAIgCCAJhTcDACAHQgV+QgeJQgl+IQcCQAJAAn8CQAJAAkACQAJAIAAoAgwiASADKAIAQQhqIgNrQQN1DgMAAQIGCyABIAdCKIi1QwAAgDOUOAIAQRMMBAsgBEEANgIEIAEgA00EQCAAKAIQQSxqIQMLAkAgAy0ABEEDRgRAIAMoAgAhAQwBCyADIARBBGpBABD8ASEDIAQoAgQhASADDQAgAEEBEP0BC0EBIQYgAQ0BIAAoAgwiASAHPgIADAILIARBADYCCCABIANNBEAgACgCEEEsaiEDCwJAIAMtAARBA0YEQCADKAIAIQYMAQsgAyAEQQhqQQAQ/AEhASAEKAIIIQYgAQ0AIABBARD9AQsgBEEANgIMIAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAhAQwBCyABIARBDGpBABD8ASEDIAQoAgwhASADDQAgAEECEP0BCyABIAZIDQMgB6chAwJAIAEgBmsiAUEBaiABcUUEQCABIANxIQMMAQsgAUEBdiABciIFQQJ2IAVyIgVBBHYgBXIiBUEIdiAFciIFQRB2IAVyIgUgA3EiAyABTQ0AIAIpAxghCSACKQMQIQogAikDCCEHIAIpAwAhCANAIAggCoUiCyAHQhGGhSEKIAcgCYUiDEItiSEJIAggDIUhCCAHQgV+IQwgByALhSILIQcgDEIHiadBCWwgBXEiAyABSw0ACyACIAk3AxggAiAKNwMQIAIgCzcDCCACIAg3AwALIAAoAgwiASADIAZqNgIAC0EDCyECIAEgAjoABCAAQQxqIgIgAigCAEEIajYCACAEQRBqJABBAQ8LIABB0u8pQQAQpQEACyAAQQFBpaYpEIYCAAvgCwIIfgV/IwBBEGsiDCQAAn8gACgCFCgCACIJLQAEQeYARgRAIAkoAgAiCi0ABgRAIApBEGoMAgsgACgCEEEsagwBCyAAKAIQQSxqCyELQQAhCgJAAkACQCALLQAEQQ9xQQJrDgYBAgICAgACCyALKAIAIgogCi8BBiIKQQN0QRhqQRAgChtqIQoMAQsgCygCACEKCyAJQQhqIgshCSALIAAoAgxJIg1FBEAgACgCEEEsaiEJCwJAAkAgCS0ABEEPcQ0AIAkgACgCEEEsakcNACAArSIBQv+B+A+FIgMQeSIGQv////8PgyABhSICQv8BhSIEQhGGhSABQoCAgICAgPgPhCIFhSIHIAMgBIUiAUIRhoUgAkL/gYCAgID4D4VCLYkgAYUiAyAFhSIChSIEIAEgB4UiAUIRhoUgA0ItiSABhSIDIAKFIgKFIgUgASAEhSIBQhGGhSADQi2JIAGFIgMgAoUiAoUiBCABIAWFIgFCEYaFIANCLYkgAYUiAyAChSIChSIFIAEgBIUiAUIRhoUgA0ItiSABhSIDIAKFIgKFIgQgASAFhSIBQhGGhSADQi2JIAGFIgMgAoUiAoUiBSABIASFIgFCEYaFIANCLYkgAYUiAyAChSIChSIEIAEgBYUiAUIRhoUgA0ItiSABhSIDIAKFIgKFIgUgASAEhSIBQhGGhSADQi2JIAGFIgMgAoUiAoUiBCABIAWFIgFCEYaFIANCLYkgAYUiAyAChSIChSIFIAEgBIUiAUIRhoUgA0ItiSABhSIDIAKFIgKFIgQgASAFhSIBQhGGhSADQi2JIAGFIgMgAoUiAoUiBSABIASFIgFCEYaFIANCLYkgAYUiBCAChSIHhSIDIAEgBYUiAkIRhoUhASACIAOFIQMgBEItiSAChSIEQi2JIQIgBCAHhSEEIAanIQsgACEJDAELIAxBADYCCCANRQRAIAAoAhBBLGohCwsCQCALLQAEQQNGBEAgCygCACELDAELIAsgDEEIakEAEPwBIQkgDCgCCCELIAkNACAAQQEQ/QELAkACQAJAAkAgACgCFCgCAEEQaiIJIAAoAgxJBEAgCS0ABEEPcQ0BQQAhCQwECyAAKAIQLQAwQQ9xDQFBACEJDAMLIAxBADYCDAwBCyAMQQA2AgwgACgCEEEsaiEJCyAJLQAEQQNGBEAgCSgCACEJDAELIAkgDEEMakEAEPwBIQ0gDCgCDCEJIA0NACAAQQIQ/QELIAtB/wFzrSIGQv+B+A+FIgMgCSALc60iAUL/gYCAgID4D4UiBEItiYUiBUItiSABQhGGIAOFIgdC/4GAgICA+A+FIgiFIgJCLYkgBSAEIAaFhSIEIAEgA4UiA0IRhoUgB4UiAYUiBkItiSADIAiFQhGGIAKFQv+BgICAgPgPhSIFIAGFIgOFIgdCLYkgBiACIASFhSICIAUgAUIRhoWFIgQgA4UiAYUiBkItiSACIAeFIgIgBCADQhGGhYUiBCABhSIDhSIFQi2JIAIgBoUiAiAEIAFCEYaFhSIEIAOFIgGFIgZCLYkgAiAFhSICIAQgA0IRhoWFIgQgAYUiA4UiBUItiSACIAaFIgIgBCABQhGGhYUiBCADhSIBhSIGQi2JIAIgBYUiAiAEIANCEYaFhSIEIAGFIgOFIgVCLYkgAiAGhSICIAQgAUIRhoWFIgQgA4UiAYUiBkItiSACIAWFIgIgBCADQhGGhYUiBCABhSIDhSIFQi2JIAIgBoUiAiAEIAFCEYaFhSIEIAOFIgGFIgZCLYkgAiAFhSICIAQgA0IRhoWFIgUgAYUiA4UiByACIAaFIgaFIQQgB0ItiSECIAUgAUIRhoUgBoUiBiADQhGGhSEBIAMgBoUhAwsgCiACNwMYIAogATcDECAKIAM3AwggCiAENwMAIAAoAgwiCkEDOgAEIAogCzYCACAAIAAoAgwiCkEIajYCDCAKQQM6AAwgCiAJNgIIIAAgACgCDEEIajYCDCAMQRBqJABBAgvnAgIEfwF9IwBBEGsiAyQAAkACQAJAAkAgACgCFCgCAEEIaiIBIAAoAgwiAkkEQCABLQAEQQNHDQEgA0EANgIEDAMLIAAoAhAtADBBA0YNASAAKAIQQSxqIQELAkACfSABLQAEIgJBE0YEQCABKgIADAELIAJBA0YEQCABKAIAsgwBCyACQQ9xQQRHDQEgASgCACIBQRBqIANBCGoQwQEhBCAEIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNASADKAIIIgGyIAG+IAMtAAxBA0YbCyEFIAAoAgwiAiAFizgCAEETIQQMAwsgAEEBQYagKhDUAQALIANBADYCBCAAKAIQQSxqIQELQQMhBCABLQAEQQNHBEAgASADQQRqQQAQ/AEaIAAoAgwhAiADQQRqIQELIAIgASgCACIBIAFBH3UiAXMgAWs2AgALIAIgBDoABCAAIAAoAgxBCGo2AgwgA0EQaiQAQQELzgMCA30EfyMAQRBrIgYkAAJAAn0gACgCFCgCAEEIaiIEIAAoAgxPBEAgACgCEEEsaiEECyAELQAEIgVBE0YEQCAEKgIADAELIAVBA0YEQCAEKAIAsgwBCyAFQQ9xQQRHDQEgBCgCACIEQRBqIAZBCGoQwQEhByAHIAQtAAciBUH/AUYEfyAEKAIMBSAFC0EBakcNASAGKAIIIgSyIAS+IAYtAAxBA0YbCyEBIAAoAgwiBEETOgAEIAQCfSABvCIHQf////8HcSIFQYCAgPwDTwRAQwAAAABD2g9JQCAHQQBOGyAFQYCAgPwDRg0BGkMAAAAAIAEgAZOVDAELAn0gBUH////3A00EQEPaD8k/IAVBgYCAlANJDQEaQ2ghojMgASABIAGUEIENlJMgAZND2g/JP5IMAgsgB0EASARAQ9oPyT8gAUMAAIA/kkMAAAA/lCIBkSICIAIgARCBDZRDaCGis5KSkyIBIAGSDAILQwAAgD8gAZNDAAAAP5QiApEiAyACEIENlCACIAO8QYBgcb4iASABlJMgAyABkpWSIAGSIgEgAZILCzgCACAAIAAoAgxBCGo2AgwgBkEQaiQAQQEPCyAAQQFBhqAqENQBAAubAwMBfQR/AXwjAEEQayIEJAACQAJ9IAAoAhQoAgBBCGoiAiAAKAIMTwRAIAAoAhBBLGohAgsgAi0ABCIDQRNGBEAgAioCAAwBCyADQQNGBEAgAigCALIMAQsgA0EPcUEERw0BIAIoAgAiAkEQaiAEQQhqEMEBIQUgBSACLQAHIgNB/wFGBH8gAigCDAUgAwtBAWpHDQEgBCgCCCICsiACviAELQAMQQNGGwshASAAKAIMIgJBEzoABCACAn0gAbwiBUH/////B3EiA0GAgID8A08EQCABu0QYLURU+yH5P6JEAAAAAAAAcDigtiADQYCAgPwDRg0BGkMAAAAAIAEgAZOVDAELAkAgA0H////3A00EQCADQYCAgARrQYCAgMgDSQ0BIAEgASABlBCBDZQgAZIMAgtEGC1EVPsh+T9DAACAPyABi5NDAAAAP5QiAbufIgYgBiABEIENu6KgIgYgBqChtiIBjCABIAVBAEgbIQELIAELOAIAIAAgACgCDEEIajYCDCAEQRBqJABBAQ8LIABBAUGGoCoQ1AEAC5EGAgV/An0jAEEQayIDJAACQAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgJBE0YEQCABKgIADAELIAJBA0YEQCABKAIAsgwBCyACQQ9xQQRHDQEgASgCACIBQRBqIANBCGoQwQEhBSAFIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNASADKAIIIgGyIAG+IAMtAAxBA0YbCyEGAn0CQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xDQFDAACAPwwCC0MAAIA/IAAoAhAtADBBD3FFDQEaIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0CIAEoAgAiAUEQaiADQQhqEMEBIQUgBSABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQIgAygCCCIBsiABviADLQAMQQNGGwshByAAKAIMIgFBEzoABCABAn0CQCAHvEH/////B3FBgICA/AdNBEAgBrxB/////wdxQYGAgPwHSQ0BCyAGIAeSDAELIAe8IgRBgICA/ANGBEAgBhCCDQwBCyAEQR52QQJxIgUgBrwiAUEfdnIhAgJAAkAgAUH/////B3EiAUUEQAJAAkAgAkECaw4CAAEDC0PbD0lADAQLQ9sPScAMAwsgBEH/////B3EiBEGAgID8B0cEQEPbD8k/IAaYIARFDQMaQ9sPyT8gBpggAUGAgID8B0cgBEGAgIDoAGogAU9xRQ0DGgJ9IAUEQEMAAAAAIAFBgICA6ABqIARJDQEaCyAGIAeVixCCDQshBgJAAkACQCACQQFrDgMAAQIECyAGjAwFC0PbD0lAIAZDLr27M5KTDAQLIAZDLr27M5JD2w9JwJIMAwsgAUGAgID8B0YNASACQQJ0QbDHMmoqAgAhBgsgBgwBCyACQQJ0QaDHMmoqAgALOAIAIAAgACgCDEEIajYCDCADQRBqJABBAQ8LIABBAUGGoCoQ1AEACyAAQQJBhqAqENQBAAvLAgIEfwF9IwBBEGsiAiQAAkACQAJAAkACQCAAKAIUKAIAQQhqIgEgACgCDEkEQCABLQAEQQNGDQEMAwsgACgCEC0AMEEDRw0BCyAAQQEQqwEMAgsgACgCEEEsaiEBCwJAAn0gAS0ABCIDQRNGBEAgASoCAAwBCyADQQNGBEAgASgCALIMAQsgA0EPcUEERw0DIAEoAgAiAUEQaiACQQhqEMEBIQQgBCABLQAHIgNB/wFGBH8gASgCDAUgAwtBAWpHDQMgAigCCCIBsiABviACLQAMQQNGGwuNIgVDAAAAz2BFDQAgBUMAAABPXUUNACAAKAIMIgFBAzoABCABIAX8ADYCACAAIAAoAgxBCGo2AgwMAQsgACgCDCIBQRM6AAQgASAFOAIAIAAgACgCDEEIajYCDAsgAkEQaiQAQQEPCyAAQQFBhqAqENQBAAvVBAMFfwF9AXwjAEEQayIEJAACQAJ9IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0BIAEoAgAiAUEQaiAEQQhqEMEBIQMgAyABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQEgBCgCCCIBsiABviAELQAMQQNGGwshBiAAKAIMIgFBEzoABCABIQUjAEEQayIDJAACfSAGvCICQf////8HcSIBQdqfpPoDTQRAQwAAgD8gAUGAgIDMA0kNARogBrsQ/AwMAQsgAUHRp+2DBE0EQCABQeSX24AETwRARBgtRFT7IQlARBgtRFT7IQnAIAJBAEgbIAa7oBD8DIwMAgsgBrshByACQQBIBEAgB0QYLURU+yH5P6AQ+wwMAgtEGC1EVPsh+T8gB6EQ+wwMAQsgAUHV44iHBE0EQCABQeDbv4UETwRARBgtRFT7IRlARBgtRFT7IRnAIAJBAEgbIAa7oBD8DAwCCyACQQBIBEBE0iEzf3zZEsAgBruhEPsMDAILIAa7RNIhM3982RLAoBD7DAwBCyAGIAaTIAFBgICA/AdPDQAaIAYgA0EIahD9DCEBIAMrAwghBwJAAkACQAJAIAFBA3FBAWsOAwECAwALIAcQ/AwMAwsgB5oQ+wwMAgsgBxD8DIwMAQsgBxD7DAshBiADQRBqJAAgBSAGOAIAIAAgACgCDEEIajYCDCAEQRBqJABBAQ8LIABBAUGGoCoQ1AEAC+cBAgR/AX0jAEEQayICJAACQAJ9IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCIDQRNGBEAgASoCAAwBCyADQQNGBEAgASgCALIMAQsgA0EPcUEERw0BIAEoAgAiAUEQaiACQQhqEMEBIQQgBCABLQAHIgNB/wFGBH8gASgCDAUgAwtBAWpHDQEgAigCCCIBsiABviACLQAMQQNGGwshBSAAKAIMIgFBEzoABCABIAVD4C5lQpQ4AgAgACAAKAIMQQhqNgIMIAJBEGokAEEBDwsgAEEBQYagKhDUAQAL5AECBH8BfSMAQRBrIgIkAAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgNBE0YEQCABKgIADAELIANBA0YEQCABKAIAsgwBCyADQQ9xQQRHDQEgASgCACIBQRBqIAJBCGoQwQEhBCAEIAEtAAciA0H/AUYEfyABKAIMBSADC0EBakcNASACKAIIIgGyIAG+IAItAAxBA0YbCyEFIAAoAgwiAUETOgAEIAEgBRDjBzgCACAAIAAoAgxBCGo2AgwgAkEQaiQAQQEPCyAAQQFBhqAqENQBAAvRAQMCfAF/AX4CfQJAIAAQ+QxB/w9xIgNDAACwQhD5DEkNAEMAAAAAIABDAACA/1sNARpDAACAfxD5DCADTQRAIAAgAJIPCyAAQxdysUJeBEBBABBBDwsgAEO08c/CXUUNAEEAEEIPC0GooCkrAwBBoKApKwMAIAC7oiIBIAFBmKApKwMAIgGgIgIgAaGhIgGiQbCgKSsDAKAgASABoqJBuKApKwMAIAGiRAAAAAAAAPA/oKAgAr0iBEIvhiAEp0EfcUEDdEH4nSlqKQMAfL+itgsLpAEBBH8jAEEQayICJAAgAkEANgIMAkACQAJ/IAAoAhQoAgBBCGoiASAAKAIMIgNPBEAgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCAAwBCyABIAJBDGpBABD8AUUNASAAKAIMIQMgAigCDAshASADIAE2AgBBAyEEDAELIAAQnwcgACgCDCEDCyADIAQ6AAQgACAAKAIMQQhqNgIMIAJBEGokAEEBC8sCAgR/AX0jAEEQayICJAACQAJAAkACQAJAIAAoAhQoAgBBCGoiASAAKAIMSQRAIAEtAARBA0YNAQwDCyAAKAIQLQAwQQNHDQELIABBARCrAQwCCyAAKAIQQSxqIQELAkACfSABLQAEIgNBE0YEQCABKgIADAELIANBA0YEQCABKAIAsgwBCyADQQ9xQQRHDQMgASgCACIBQRBqIAJBCGoQwQEhBCAEIAEtAAciA0H/AUYEfyABKAIMBSADC0EBakcNAyACKAIIIgGyIAG+IAItAAxBA0YbC44iBUMAAADPYEUNACAFQwAAAE9dRQ0AIAAoAgwiAUEDOgAEIAEgBfwANgIAIAAgACgCDEEIajYCDAwBCyAAKAIMIgFBEzoABCABIAU4AgAgACAAKAIMQQhqNgIMCyACQRBqJABBAQ8LIABBAUGGoCoQ1AEAC7QFAgZ/An0jAEEQayIDJAAgACgCFCgCACIFQQhqIgEhAgJAAkACQAJAAkAgASAAKAIMIgZJIgQEfyACBSAAKAIQQSxqCy0ABEEDRw0AIAYgBUEQaiICSwRAIAItAARBA0cNASADQQA2AggMAwsgACgCEC0AMEEDRg0BCwJAAkACfSAERQRAIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0BIAEoAgAiAkEQaiADQQhqEMEBIQQgBCACLQAHIgFB/wFGBH8gAigCDAUgAQtBAWpHDQEgAygCCCIBsiABviADLQAMQQNGGwshBwJ9IAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0CIAEoAgAiAUEQaiADQQhqEMEBIQQgBCABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQIgAygCCCIBsiABviADLQAMQQNGGwshCCAAKAIMIgEgByAIEEQ4AgBBEyECDAQLIABBAUGGoCoQ1AEACyAAQQJBhqAqENQBAAsgA0EANgIIIAAoAhBBLGohAgsgAi0ABEEDRwR/IAIgA0EIakEAEPwBGiADQQhqBSACCygCACIEQQFqQQFNBEAgBEUNAiAAKAIMIgFBADYCAEEDIQIMAQsgA0EANgIIQQMhAiAAKAIUKAIAQQhqIgUgACgCDCIBTwRAIAAoAhBBLGohBQsgBS0ABEEDRwRAIAUgA0EIakEAEPwBGiADQQhqIQUgACgCDCEBCyABIAUoAgAgBG82AgALIAEgAjoABCAAIAAoAgxBCGo2AgwgA0EQaiQAQQEPCyAAQQJBkKkqEIYCAAvxAQEEfyMAQRBrIgIkACACQQA2AgggACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQMMAQsgASACQQhqQQAQ/AEhASACKAIIIQMgAQ0AIABBARD9AQsgAkEANgIMIAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgAkEMakEAEPwBIQQgAigCDCEBIAQNACAAQQIQ/QELIAAoAgxBEUEBIAEgA0sbOgAEIAAgACgCDEEIajYCDCACQRBqJABBAQvKBQMEfwJ9AnwjAEEQayIDJAACQAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgJBE0YEQCABKgIADAELIAJBA0YEQCABKAIAsgwBCyACQQ9xQQRHDQEgASgCACIBQRBqIANBCGoQwQEhBCAEIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNASADKAIIIgGyIAG+IAMtAAxBA0YbCyEFAn0CQAJAAkAgACgCFCgCAEEQaiIBIAAoAgxJBEAgAS0ABEEPcUUNAQwDCyAAKAIQLQAwQQ9xDQELIAUQSQwCCyAAKAIQQSxqIQELAn0gAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0DIAEoAgAiAUEQaiADQQhqEMEBIQQgBCABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQMgAygCCCIBsiABviADLQAMQQNGGwsiBkMAAABAWwRAAn1DAAAAACAFvCIBQYCAgPwDRg0AGgJAIAFBgICA/AdrQf///4d4TQRAIAFBAXQiAkUEQBBHDAMLIAFBgICA/AdGDQEgAkGAgIB4SSABQQBOcUUEQCAFEEMMAwsgBUMAAABLlLxBgICA3ABrIQELQeCkKSsDACABIAFBgIDM+QNrIgJBgICAfHFrvrsgAkEPdkHwAXEiAUHgoilqKwMAokQAAAAAAADwv6AiByAHoiIIokHopCkrAwAgB6JB8KQpKwMAoKAgCKJB+KQpKwMAIAeiIAFB6KIpaisDACACQRd1t6CgoLYhBQsgBQsMAQsgBkMAACBBWwRAIAUQSgwBCyAFEEkgBhBJlQshBSAAKAIMIgFBEzoABCABIAU4AgAgACAAKAIMQQhqNgIMIANBEGokAEEBDwsgAEEBQYagKhDUAQALIABBAkGGoCoQ1AEAC8kCAQV/IAAoAgwiAiAAKAIUIgMoAgBrQQhrIgRBA3UiBUEASgRAQQEhAQJAAkAgBEEIRwRAQQIhAgNAIAIgASAAIAEgAhD7BRshASACIAVHIQMgAkEBaiECIAMNAAsgACgCFCEDIAAoAgwhAiABQQBMDQELIAMoAgAgAUEDdGoiASACSQ0BIAAoAhBBLGohAQwBCyABQdnhzn1OBEAgAiABQQN0aiEBDAELIAFB2OHOfUYEQCAAKAIQQSRqIQEMAQsgAygCACIDLQAEQeYARgRAIAMoAgAiAy0ABkHY4c59IAFrTwRAIANBACABa0EDdGpBuPKJE2shAQwCCyAAKAIQQSxqIQEMAQsgACgCEEEsaiEBCyACIAEoAgA2AgAgAiABLQAEOgAEIABBDGoiAiACKAIAQQhqNgIAQQEPCyAAQQFBwrYrEIYCAAvJAgEFfyAAKAIMIgIgACgCFCIDKAIAa0EIayIEQQN1IgVBAEoEQEEBIQECQAJAIARBCEcEQEECIQIDQCACIAEgACACIAEQ+wUbIQEgAiAFRyEDIAJBAWohAiADDQALIAAoAhQhAyAAKAIMIQIgAUEATA0BCyADKAIAIAFBA3RqIgEgAkkNASAAKAIQQSxqIQEMAQsgAUHZ4c59TgRAIAIgAUEDdGohAQwBCyABQdjhzn1GBEAgACgCEEEkaiEBDAELIAMoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB2OHOfSABa08EQCADQQAgAWtBA3RqQbjyiRNrIQEMAgsgACgCEEEsaiEBDAELIAAoAhBBLGohAQsgAiABKAIANgIAIAIgAS0ABDoABCAAQQxqIgIgAigCAEEIajYCAEEBDwsgAEEBQcK2KxCGAgALiQMCBH8CfSMAQRBrIgMkAAJAAn0CQAJAAkAgACgCFCgCAEEIaiIBIAAoAgxJBEAgAS0ABEEDRg0BDAMLIAAoAhAtADBBA0cNAQsgAEEBEKsBIAAoAgwhAUMAAAAADAILIAAoAhBBLGohAQsCfwJAAn0gAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0EIAEoAgAiAUEQaiADQQhqEMEBIQQgBCABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQQgAygCCCIBsiABviADLQAMQQNGGwsiBY0gBY4gBUMAAAAAXRsiBkMAAADPYEUNACAGQwAAAE9dRQ0AIAAoAgwiASAG/AA2AgBBAwwBCyAAKAIMIgEgBjgCAEETCyECIAEgAjoABCAAIAAoAgxBCGoiATYCDEMAAAAAIAUgBpMgBSAGWxsLIQUgAUETOgAEIAEgBTgCACAAIAAoAgxBCGo2AgwgA0EQaiQAQQIPCyAAQQFBhqAqENQBAAvnAQIEfwF9IwBBEGsiAiQAAkACfSAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELIAEtAAQiA0ETRgRAIAEqAgAMAQsgA0EDRgRAIAEoAgCyDAELIANBD3FBBEcNASABKAIAIgFBEGogAkEIahDBASEEIAQgAS0AByIDQf8BRgR/IAEoAgwFIAMLQQFqRw0BIAIoAggiAbIgAb4gAi0ADEEDRhsLIQUgACgCDCIBQRM6AAQgASAFQzX6jjyUOAIAIAAgACgCDEEIajYCDCACQRBqJABBAQ8LIABBAUGGoCoQ1AEAC+sEAwV/AX0BfCMAQRBrIgQkAAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgJBE0YEQCABKgIADAELIAJBA0YEQCABKAIAsgwBCyACQQ9xQQRHDQEgASgCACIBQRBqIARBCGoQwQEhAyADIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNASAEKAIIIgGyIAG+IAQtAAxBA0YbCyEGIAAoAgwiAUETOgAEIAEhBSMAQRBrIgMkAAJAIAa8IgJB/////wdxIgFB2p+k+gNNBEAgAUGAgIDMA0kNASAGuxD7DCEGDAELIAFB0aftgwRNBEAgBrshByABQeOX24AETQRAIAJBAEgEQCAHRBgtRFT7Ifk/oBD8DIwhBgwDCyAHRBgtRFT7Ifm/oBD8DCEGDAILRBgtRFT7IQnARBgtRFT7IQlAIAJBAE4bIAegmhD7DCEGDAELIAFB1eOIhwRNBEAgAUHf27+FBE0EQCAGuyEHIAJBAEgEQCAHRNIhM3982RJAoBD8DCEGDAMLIAdE0iEzf3zZEsCgEPwMjCEGDAILRBgtRFT7IRlARBgtRFT7IRnAIAJBAEgbIAa7oBD7DCEGDAELIAFBgICA/AdPBEAgBiAGkyEGDAELIAYgA0EIahD9DCEBIAMrAwghBwJAAkACQAJAIAFBA3FBAWsOAwECAwALIAcQ+wwhBgwDCyAHEPwMIQYMAgsgB5oQ+wwhBgwBCyAHEPwMjCEGCyADQRBqJAAgBSAGOAIAIAAgACgCDEEIajYCDCAEQRBqJABBAQ8LIABBAUGGoCoQ1AEAC+IBAgR/AX0jAEEQayICJAACQAJ9IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCIDQRNGBEAgASoCAAwBCyADQQNGBEAgASgCALIMAQsgA0EPcUEERw0BIAEoAgAiAUEQaiACQQhqEMEBIQQgBCABLQAHIgNB/wFGBH8gASgCDAUgAwtBAWpHDQEgAigCCCIBsiABviACLQAMQQNGGwshBSAAKAIMIgFBEzoABCABIAWROAIAIAAgACgCDEEIajYCDCACQRBqJABBAQ8LIABBAUGGoCoQ1AEAC6MEAwV/AX0BfCMAQRBrIgQkAAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgJBE0YEQCABKgIADAELIAJBA0YEQCABKAIAsgwBCyACQQ9xQQRHDQEgASgCACIBQRBqIARBCGoQwQEhAyADIAEtAAciAkH/AUYEfyABKAIMBSACC0EBakcNASAEKAIIIgGyIAG+IAQtAAxBA0YbCyEGIAAoAgwiAUETOgAEIAEhBSMAQRBrIgMkAAJAIAa8IgJB/////wdxIgFB2p+k+gNNBEAgAUGAgIDMA0kNASAGu0EAEP4MIQYMAQsgAUHRp+2DBE0EQCAGuyEHIAFB45fbgARNBEBEGC1EVPsh+T9EGC1EVPsh+b8gAkEASBsgB6BBARD+DCEGDAILRBgtRFT7IQlARBgtRFT7IQnAIAJBAEgbIAegQQAQ/gwhBgwBCyABQdXjiIcETQRAIAa7IQcgAUHf27+FBE0EQETSITN/fNkSQETSITN/fNkSwCACQQBIGyAHoEEBEP4MIQYMAgtEGC1EVPshGUBEGC1EVPshGcAgAkEASBsgB6BBABD+DCEGDAELIAFBgICA/AdPBEAgBiAGkyEGDAELIAYgA0EIahD9DCEBIAMrAwggAUEBcRD+DCEGCyADQRBqJAAgBSAGOAIAIAAgACgCDEEIajYCDCAEQRBqJABBAQ8LIABBAUGGoCoQ1AEAC54BAQN/AkACQCAAKAIUKAIAQQhqIgEgACgCDCICSQRAIAEtAARBD3FBA0YNAQwCCyAAKAIQIgNBLGohASADLQAwQQ9xQQNHDQELIABBzpgqQdjqKSABLQAEQQNGGxBYQQEPCwJAIAEtAARBD3ENACABIAAoAhBBLGpHDQAgAEEBQcK2KxCGAgALIAJBADoABCAAIAAoAgxBCGo2AgxBAQvTAgIEfwF9IwBBEGsiAiQAAkACfSAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELIAEtAAQiA0ETRgRAIAEqAgAMAQsgA0EDRgRAIAEoAgCyDAELIANBD3FBBEcNASABKAIAIgFBEGogAkEIahDBASEEIAQgAS0AByIDQf8BRgR/IAEoAgwFIAMLQQFqRw0BIAIoAggiAbIgAb4gAi0ADEEDRhsLIQUgACgCDCIBQRM6AAQgAQJ9IAWLIgW8IgFBluTF+QNNBEBDAACAPyABQYCAgMwDSQ0BGiAFEP8MIgUgBZQgBUMAAIA/kiIFIAWSlUMAAIA/kgwBCyABQZbkxZUETQRAIAUQ4wciBUMAAIA/IAWVkkMAAAA/lAwBCyAFQwAAgD8QgA0LOAIAIAAgACgCDEEIajYCDCACQRBqJABBAQ8LIABBAUGGoCoQ1AEAC9kCAgR/A30jAEEQayICJAACQAJ9IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCIDQRNGBEAgASoCAAwBCyADQQNGBEAgASgCALIMAQsgA0EPcUEERw0BIAEoAgAiAUEQaiACQQhqEMEBIQQgBCABLQAHIgNB/wFGBH8gASgCDAUgAwtBAWpHDQEgAigCCCIBsiABviACLQAMQQNGGwshBiAAKAIMIgFBEzoABCABAn1DAAAAPyAGmCEHAkAgBosiBbwiAUGW5MWVBE0EQCAFEP8MIQUgAUH////7A00EQCABQYCAgMwDSQ0CIAcgBSAFkiAFIAWUIAVDAACAP5KVk5QMAwsgByAFIAUgBUMAAIA/kpWSlAwCCyAFIAcgB5IQgA0hBgsgBgs4AgAgACAAKAIMQQhqNgIMIAJBEGokAEEBDwsgAEEBQYagKhDUAQALhgMCBX8CfSMAQRBrIgIkAAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgNBE0YEQCABKgIADAELIANBA0YEQCABKAIAsgwBCyADQQ9xQQRHDQEgASgCACIBQRBqIAJBCGoQwQEhBCAEIAEtAAciA0H/AUYEfyABKAIMBSADC0EBakcNASACKAIIIgGyIAG+IAItAAxBA0YbCyEHIAAoAgwiAUETOgAEIAEhBQJAIAeLIga8IgFB1b6y+ANPBEAgAUGBgICJBE8EQEMAAAAAIAaVQwAAgD+SIQYMAgtDAACAP0MAAABAIAYgBpIQ/wxDAAAAQJKVkyEGDAELIAFB+YqL9ANPBEAgBiAGkhD/DCIGIAZDAAAAQJKVIQYMAQsgAUGAgIAESQ0AIAZDAAAAwJQQ/wwiBowgBkMAAABAkpUhBgsgBSAGjCAGIAe8QQBIGzgCACAAIAAoAgxBCGo2AgwgAkEQaiQAQQEPCyAAQQFBhqAqENQBAAuOAwIEfwJ9IwBBEGsiAyQAAkACQAJ9IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0BIAEoAgAiAUEQaiADQQhqEMEBIQQgBCABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQEgAygCCCIBsiABviADLQAMQQNGGwshBQJ9IAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0CIAEoAgAiAkEQaiADQQhqEMEBIQQgBCACLQAHIgFB/wFGBH8gAigCDAUgAQtBAWpHDQIgAygCCCIBsiABviADLQAMQQNGGwshBiAAKAIMIgFBEzoABCABIAUgBhDTBjgCACAAIAAoAgxBCGo2AgwgA0EQaiQAQQEPCyAAQQFBhqAqENQBAAsgAEECQYagKhDUAQALjQICBH8BfSMAQRBrIgIkAAJAAn0gACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCyABLQAEIgNBE0YEQCABKgIADAELIANBA0YEQCABKAIAsgwBCyADQQ9xQQRHDQEgASgCACIBQRBqIAJBCGoQwQEhBCAEIAEtAAciA0H/AUYEfyABKAIMBSADC0EBakcNASACKAIIIgGyIAG+IAItAAxBA0YbCyACQQRqEI8HIQUgACgCDCIBQRM6AAQgASAFOAIAIAAgACgCDCIBQQhqNgIMIAIoAgQhAyABQQM6AAwgASADNgIIIAAgACgCDEEIajYCDCACQRBqJABBAg8LIABBAUGGoCoQ1AEAC8MCAgR/AX0jAEEQayIDJAACQAJ9IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsgAS0ABCICQRNGBEAgASoCAAwBCyACQQNGBEAgASgCALIMAQsgAkEPcUEERw0BIAEoAgAiAUEQaiADQQhqEMEBIQQgBCABLQAHIgJB/wFGBH8gASgCDAUgAgtBAWpHDQEgAygCCCIBsiABviADLQAMQQNGGwshBSADQQA2AgQgACgCFCgCAEEQaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQEMAQsgASADQQRqQQAQ/AEhAiADKAIEIQEgAg0AIABBAhD9AQsgACgCDCICQRM6AAQgAiAFIAEQJTgCACAAIAAoAgxBCGo2AgwgA0EQaiQAQQEPCyAAQQFBhqAqENQBAAvjAQIEfwF9IwBBEGsiAiQAAkACfSAAKAIUKAIAQQhqIgEgACgCDE8EQCAAKAIQQSxqIQELIAEtAAQiA0ETRgRAIAEqAgAMAQsgA0EDRgRAIAEoAgCyDAELIANBD3FBBEcNASABKAIAIgFBEGogAkEIahDBASEEIAQgAS0AByIDQf8BRgR/IAEoAgwFIAMLQQFqRw0BIAIoAggiAbIgAb4gAi0ADEEDRhsLIQUgACgCDCIBQRM6AAQgASAFEEo4AgAgACAAKAIMQQhqNgIMIAJBEGokAEEBDwsgAEEBQYagKhDUAQALMgECfxD5ByEBIAAoAgwiAkETOgAEIAIgAbJDACR0SZU4AgAgACAAKAIMQQhqNgIMQQELXAIDfwF+IwBBEGsiACQAQX8hAQJAQQIgABDSDA0AIAApAwAiA0LjEFUNACAAKAIIQegHbSICrEL/////ByADQsCEPX4iA31VDQAgAiADp2ohAQsgAEEQaiQAIAEL1ggBC38jAEGwAmsiAiQAAn8CQAJAIAAoAhQiBSgCACIEQQhqIgEgACgCDCIDSQRAIAEtAARBD3ENAQwCCyAAKAIQLQAwQQ9xRQ0BIAAoAhBBLGohAQsCQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgUoAgAiBEEIaiIBIAAoAgwiA0kNACAAKAIQQSxqIQELIAEoAgAiAS0AByIGQf8BRgRAIAEoAgwhBgsgAUEQagwCCyAAQQFB+O0qENQBAAtBAiEGQdPIKwshASACAn4gAyAEQRBqIgRNBH8gACgCEEEsagUgBAstAARBD3FFBEAQeQwBCyACQQA2AhAgAyAFKAIAQRBqIgRNBEAgACgCEEEsaiEECwJAIAQtAARBA0YEQCAEKAIAIQMMAQsgBCACQRBqQQAQ/AEhBCACKAIQIQMgBA0AIABBAhD9AQsgA6wLNwOoAgJAAkACfyABLQAAQSFGBEAQ3QwgAkGoAmopAwBBmJY0EBNBwJY0QcLbKzYCAEG4ljRCADcCAEGYljQhByABQQFqDAELEN0MIAJBqAJqKQMAQcSWNBASQeyWNEH8ljRB+JY0QeSWNCgCABsoAgA2AgBBxJY0IQcgAQsiAy0AAEEqRw0AIAMtAAFB9ABHDQAgAy0AAg0AIABBAEEJEKEBIAAgBxD7BwwBCyACQSU6AKQCIAIgADYCHCACIAJBIGoiCjYCECACQoACNwIUIAAoAgwiBEECOgAEIAQgAkEQajYCACAAIAAoAgxBCGo2AgwgASAGaiIIIANLBEAgAkGlAmohCQNAAkAgAy0AACIBQSVHBEAgAigCGCIEIAIoAhRPBEAgAkEQakEBQX8QlwcaIAIoAhghBCADLQAAIQELIAIgBEEBajYCGCACKAIQIARqIAE6AAAgA0EBaiEDDAELQQEhASACQRBqQfoBQX8QlwchCwJAIAggA0EBaiIFayIGQQBMDQBB1LkpIQNB4QAhBANAAkAgBEH/AXFB/ABGBEAgAUEBaiEBDAELIAUgAyABEIQCDQAgAQRAIAkgBSAB/AoAAAsgASAJakEAOgAAIAIgC0H6ASACQaQCaiAHEOIMIAIoAhhqNgIYIAEgBWohAwwDCyABIAZKDQEgASADaiIDLQAAIgQNAAsLIAIgBTYCACAAQQEgAEG/hSwgAhCmARCGAgALIAMgCEkNAAsLIAIoAhwiBSACKAIQIAIoAhgQnwEgCiACKAIQRwRAIAUgBSgCDEEQa0F/QQAQXkEAOgAECyAFKAIMIgNBEGshASADQQhrIQMDQCABKAIAIQQgASADKAIANgIAIAEtAAQhBiABIAMtAAQ6AAQgAyAGOgAEIAMgBDYCACABQQhqIgEgA0EIayIDSQ0ACyAFIAUoAgxBCGsiASAFKAIkTQR/IAUgAUF/QQAQXgUgAQs2AgwLIAJBsAJqJABBAQv5AwECfyABKAIUIQIgACgCDCIDQQM6AAQgAyACQewOajYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtB+aEqEFkgASgCECECIAAoAgwiA0EDOgAEIAMgAkEBajYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtB3d8qEFkgASgCDCECIAAoAgwiA0EDOgAEIAMgAjYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtBxrkpEFkgASgCCCECIAAoAgwiA0EDOgAEIAMgAjYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtBuIwqEFkgASgCBCECIAAoAgwiA0EDOgAEIAMgAjYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtB+LgqEFkgASgCACECIAAoAgwiA0EDOgAEIAMgAjYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtB4ccrEFkgASgCHCECIAAoAgwiA0EDOgAEIAMgAkEBajYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtBsrkpEFkgASgCGCECIAAoAgwiA0EDOgAEIAMgAkEBajYCACAAIAAoAgwiAkEIajYCDCAAIAJBCGtBt7kpEFkgASgCICIBQQBOBEAgACgCDEERQQEgARs6AAQgACAAKAIMIgFBCGo2AgwgACABQQhrQZPPKRBZCwv5AQEEfyMAQRBrIgIkACACQQA2AgggACgCFCgCAEEIaiIBIAAoAgxPBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQQMAQsgASACQQhqQQAQ/AEhASACKAIIIQQgAQ0AIABBARD9AQsgAkEANgIMIAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgAkEMakEAEPwBIQMgAigCDCEBIAMNACAAQQIQ/QELIAAoAgwiA0ETOgAEIAMgBKwgAax9ubY4AgAgACAAKAIMQQhqNgIMIAJBEGokAEEBC5IBAQF/IAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgEgACgCDEkNACAAKAIQQSxqIQELIAAgASgCAEEQahD+BxBYQQEPCyAAQQFB+O0qENQBAAt9AQR/IAAgAEE9ENwMIgFGBEBBAA8LAkAgACABIABrIgRqLQAADQBBlJY0KAIAIgJFDQAgAigCACIBRQ0AA0ACQCAAIAEgBBDFAUUEQCABIARqIgEtAABBPUYNAQsgAigCBCEBIAJBBGohAiABDQEMAgsLIAFBAWohAwsgAwvoBAEIfwJAAn8CQCAAKAIUKAIAQQhqIgEgACgCDEkEQCABLQAEQQ9xDQFBAAwCC0EAIAAoAhAtADBBD3FFDQEaIAAoAhBBLGohAQsCQAJAIAEtAARBD3FBA2sOAgABAwsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgxJDQAgACgCEEEsaiEBCyABKAIAQRBqCyEBIAAhCCAAQQJBtMoqQdC9LxCdB0ECdEGwvS9qKAIAIQIjAEEwayIEJAACQCACQQZLDQACQCACQQZGBEAgAUUNASAEQcClMikDADcDECAEQbClMv0ABAD9CwQAQQAhAgJAA0AgAUE7ENwMIgMgAWsiBUEXTARAIAQgASAFEBsaIAQgBWpBADoAACADQQFqIAEgAy0AABshAQsgAiAEEN4MIgNBf0YNASAEQRhqIAJBAnRqIAM2AgAgAkEBaiICQQZHDQALQeyYNCAE/QACGP0LAgBB/Jg0IAQpAig3AgAMAgtBACEDDAILAkAgAQRAIAIgARDeDCIBQX9GDQMgAkECdEHsmDRqIAE2AgAMAQsgAkECdEHsmDRqKAIAIQELIAFBCGpB3+IrIAEbIQMMAQtBkJk0IQFBACECA0BB7Jg0KAIAIQAgASACQQJ0QeyYNGooAgAiBUEIakHf4isgBRsiAyADECciBhAbGiABIAZqIgZBOzoAACAGQQFqIQEgByAAIAVGaiEHIAJBAWoiAkEGRw0ACyAGQQA6AABBkJk0IAMgB0EGRxshAwsgBEEwaiQAIAggAxBYQQEPCyAAQQFB+O0qENQBAAvpBgIEfwF+IwBB4ABrIgMkAAJAAkACQAJAAkACQAJAAkACQCAAKAIUKAIAQQhqIgEgACgCDEkEQCABLQAEQQ9xRQ0BDAMLIAAoAhAtADBBD3ENAQsQeSEFDAILIAAoAhBBLGohAQsgAS0ABEEPcUEFRw0BIABBARCrASADIABB+aEqQewOEIEINgJEIAMgAEHd3ypBARCBCDYCQCADIABBxrkpQQAQgQg2AjwgAEF/QbiMKhCQASEEIANBADYCXCAAKAIMIgFBCGshAgJAIAFBBGstAABBA0YEQCACKAIAIQIMAQsgAiADQdwAakEAEPwBBEAgAygCXCECDAELQQwhAiAEDQMLIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCADIAI2AjggAEF/Qfi4KhCQASEEIANBADYCXCAAKAIMIgFBCGshAgJAIAFBBGstAABBA0YEQCACKAIAIQIMAQsgAiADQdwAakEAEPwBBEAgAygCXCECDAELQQAhAiAEDQQLIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCADIAI2AjQgAEF/QeHHKxCQASEEIANBADYCXCAAKAIMIgFBCGshAgJAIAFBBGstAABBA0YEQCACKAIAIQIMAQsgAiADQdwAakEAEPwBBEAgAygCXCECDAELQQAhAiAEDQULIAAgACgCDEEIayIBIAAoAiRNBH8gACABQX9BABBeBSABCzYCDCADIAI2AjBBfyECIABBf0GTzykQkAEhBCAAKAIMIQEgBARAIAFBBGstAAAiAkEBRyACQQ9xQQBHcSECCyAAIAFBCGsiASAAKAIkTQR/IAAgAUF/QQAQXgUgAQs2AgwgAyACNgJQEN0MIANBMGoQESIFQn9RBEBB0PszQT02AgALIAAgA0EwahD7BwsgBUJ/UQ0EIAVCgICAgAh9Qv////9vWA0EIAAoAgwiAUEDOgAEIAEgBT4CACAAIAAoAgxBCGo2AgwgA0HgAGokAEEBDwsgAEEBQeyXKxDUAQALIANBuIwqNgIgIABBuZgqIANBIGoQpQEACyADQfi4KjYCECAAQbmYKiADQRBqEKUBAAsgA0Hhxys2AgAgAEG5mCogAxClAQALIABBxLQqQQAQpQEAC+sBAQR/IwBBMGsiAyQAIABBfyABEJABIQYgA0EANgIsIAAoAgwiBEEIayEFAkAgBEEEay0AAEEDRgRAIAUoAgAhBAwBCyAFIANBLGpBABD8AQRAIAMoAiwhBAwBCyAGRQRAIAMgATYCECAAQamXKyADQRBqEKUBAAsgAyABNgIgIABBuZgqIANBIGoQpQEACwJAIARBAE4NACACQYCAgIB4ciAETA0AIAMgATYCACAAQY+rKyADEKUBAAsgACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMIANBMGokACAEIAJrCw8AIABBAEGAwCsQgwhBAQujCAEFfyMAQRBrIgYkAAJAAkACQAJAAkACQAJAIAAoAhQoAgBBCGoiAyAAKAIMIgRJBEAgAy0ABEEPcUEDRg0BDAILIAAoAhAiBUEsaiEDIAUtADBBD3FBA0cNAQsgBCADKAIANgIAIAQgAy0ABDoABCAAIAAoAgxBCGoiBDYCDAwBCwJAAkAgAy0ABEEPcUEDaw4CAAEDCyAAIAMQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgMgACgCDCIESQ0AIAAoAhBBLGohAwsgAygCACIDLQAHIgVB/wFGBEAgAygCDCEFCyADQRBqIAQQwQEiAwRAIAAgACgCDEEIajYCDAsgAyAFQQFqRw0BIAAoAgwhBAsCQAJAAkAgBCAAKAIUKAIAQRBqIgNLBEAgAy0ABEEPcUEDRg0BDAILIAAoAhAiBUEsaiEDIAUtADBBD3FBA0cNAQsgBCADKAIANgIAIAQgAy0ABDoABCAAIAAoAgxBCGoiAzYCDAwBCwJAAkAgAy0ABEEPcUEDaw4CAAEDCyAAIAMQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRBqIgMgACgCDCIESQ0AIAAoAhBBLGohAwsgAygCACIDLQAHIgVB/wFGBEAgAygCDCEFCyADQRBqIAQQwQEiAwRAIAAgACgCDEEIajYCDAsgAyAFQQFqRw0BIAAoAgwhAwsgAUEMTwRAIAMgA0EIaygCADYCACADIANBBGstAAA6AAQgACAAKAIMQQhqIgM2AgwLAkAgACABIANBEGsiBCADQQhrIgIgBBDSBg0AIAAgBCACIAQgAUEGaiIBEJEHDQAgAUETRyABQQ1rQQVPcUUEQCADQQxrLQAAQQ9xQQNGBEAgA0EEay0AAEEPcUEDRg0FCyAAIAQgAkHwtyoQpAYACyAAIAQgAkGNuCoQpAYACyAAIAAoAgxBCGs2AgwMAQsgAEECEKsBIAAoAhQoAgBBEGoiAyAAKAIMTwR/IAAoAhBBLGoFIAMLLQAEQQ9xQQRGDQIgAEECIAIQnAdFDQIgACgCDCIFQRBrIQMgBUEYayIHIQQDQCAEKAIAIQEgBCADKAIANgIAIAQtAAQhAiAEIAMtAAQ6AAQgAyACOgAEIAMgATYCACAEQQhqIgQgA0EIayIDSQ0ACyAFQRRrIgMtAAAhBCAHKAIAIQEgByAFQQhrIgIoAgA2AgAgAiABNgIAIAVBBGsiAS0AACECIAEgBDoAACADIAI6AAAgACAAKAIMQRhrQQEQkQYLIAZBEGokAA8LIAAgBCACEKUGAAsgAEF+EOABIQMgAEF/EOABIQQgBiACQQJqNgIAIAYgA0ECdEH0sS9qKAIANgIEIAYgBEECdEH0sS9qKAIANgIIIABB94QsIAYQpQEACw8AIABBAUHdySsQgwhBAQsPACAAQQJB5MYqEIMIQQELDwAgAEEDQdGqKxCDCEEBCw8AIABBBEG1vSkQgwhBAQsPACAAQQVB3MApEIMIQQELDwAgAEEGQbjAKRCDCEEBCw8AIABBDEH/xCoQgwhBAQuTBwENfyMAQRBrIgYkACAAKAIUIgcoAgAiAkEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELAkACQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgcoAgAiAkEIaiIBIAAoAgwiA0kNACAAKAIQQSxqIQELIAEoAgAiBS0AByIEQf8BRgRAIAUoAgwhBAsgAyACQRBqIgFNBEAgACgCEEEsaiEBC0EBIQICQCABLQAEQQ9xRQRAQQEhAQwBCyAGQQA2AgggAyAHKAIAQRBqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQEMAQsgASAGQQhqQQAQ/AEhAyAGKAIIIQEgAw0AIABBAhD9AQsgAUEASgRAIAEhAgwBCyABRQ0AIAFBACAEa0gNACABIARqQQFqIQILAkACQCAAKAIUKAIAQRhqIgMgACgCDEkEQCADLQAEQQ9xRQ0CIAZBADYCDAwBCyAAKAIQLQAwQQ9xRQ0BIAZBADYCDCAAKAIQQSxqIQMLIAMtAARBA0YEQCADKAIAIQEMAQsgAyAGQQxqQQAQ/AEhAyAGKAIMIQEgAw0AIABBAxD9AQsCQAJ/IAQgASAESg0AGiABIAFBAE4NABpBACABQQAgBGtIDQAaIAEgBGpBAWoLIgMgAkkNACADIAJrIgFB/////wdPDQIgACABQQFqIghB5OkqEJ4HIAVBEGogAmoiCkEBayEHIAhBA3EhCSAAKAIMIQJBACEEAkAgAUEDSQRAQQAhAQwBCyAHQQNqIQsgB0ECaiEMIAhBfHEhDUEAIQFBACEDA0AgASAHai0AACEFIAJBAzoABCACIAU2AgAgACAAKAIMIgJBCGo2AgwgASAKai0AACEFIAJBAzoADCACIAU2AgggACAAKAIMIgJBCGo2AgwgASAMai0AACEFIAJBAzoADCACIAU2AgggACAAKAIMIgJBCGo2AgwgASALai0AACEFIAJBAzoADCACIAU2AgggACAAKAIMQQhqIgI2AgwgAUEEaiEBIANBBGoiAyANRw0ACwsgCUUNAANAIAEgB2otAAAhAyACQQM6AAQgAiADNgIAIAAgACgCDEEIaiICNgIMIAFBAWohASAEQQFqIgQgCUcNAAsLIAZBEGokACAIDwsgAEEBQfjtKhDUAQALIABB5OkqQQAQpQEAC4cDAQZ/IwBBkAJrIgMkACAAKAIUKAIAIQUgAEEMaiICKAIAIQEgAyADQRBqIgY2AgAgAyAANgIMIANCgAI3AgQgAUECOgAEIAEgAzYCACACIAIoAgBBCGo2AgAgAyABIAVrQQhrQQN1IgVBfxCXByECQQEhAQJAIAVBAEoEQCACQQFrIQQDQCAAIAEQoAciAkGAAk8NAiABIARqIAI6AAAgASAFRyECIAFBAWohASACDQALCyADIAMoAgggBWoiATYCCCADKAIMIgQgAygCACABEJ8BIAYgAygCAEcEQCAEIAQoAgxBEGtBf0EAEF5BADoABAsgBCgCDCICQRBrIQEgAkEIayECA0AgASgCACEAIAEgAigCADYCACABLQAEIQUgASACLQAEOgAEIAIgBToABCACIAA2AgAgAUEIaiIBIAJBCGsiAkkNAAsgBCAEKAIMQQhrIgEgBCgCJE0EfyAEIAFBf0EAEF4FIAELNgIMIANBkAJqJABBAQ8LIAAgAUHHnCsQhgIAC7YKAQV/IwBBsAJrIgEkACAAKAIUKAIAIgJBEGoiAyAAKAIMIgVPBEAgACgCEEEsaiEDCwJAIAUgAkEIaiICTQR/IAAoAhBBLGoFIAILLQAEQQ9xQQZGBEAgAy0ABCECIABBARCrASABQQA2AgAgACgCDCIDQQRrLQAAQcYARw0BIANBCGsoAgAoAgwhBSABIAA2AhQgAUEBNgIAIAEgAUEYaiIENgIIIAFCgAI3AgwgASACQQFHIAJBD3FBAEdxNgKkAiABQTA2ApwCIAEgADYCmAIgASABNgKgAiADQQI6AAQgAyABQQhqIgI2AgAgACAAKAIMQQhqNgIMIAJBBEF/EJcHQZuY1YsGNgAAIAEgASgCEEEEajYCECABKAIARQRAIAEgADYCFCABQQE2AgAgAUKAAjcCDCABIAQ2AgggACgCDCIDQQI6AAQgAyACNgIAIAAgACgCDEEIajYCDAsgAkEBQX8QlwdB1AA6AAAgAUEANgKoAiABIAEoAhBBAWo2AhAgASgCAEUEQCABIAA2AhQgAUEBNgIAIAFCgAI3AgwgASABQRhqNgIIIAAoAgwiA0ECOgAEIAMgAjYCACAAIAAoAgxBCGo2AgwLIAJBAUF/EJcHQQA6AAAgASABKAIQQQFqNgIQIAEoAgBFBEAgASAANgIUIAFBATYCACABQoACNwIMIAEgAUEYajYCCCAAKAIMIgNBAjoABCADIAI2AgAgACAAKAIMQQhqNgIMCyACQQZBfxCXByIDQbOTLC8AADsABCADQa+TLCgAADYAACABQQA2AqgCIAEgASgCEEEGajYCECABKAIARQRAIAEgADYCFCABQQE2AgAgAUKAAjcCDCABIAFBGGo2AgggACgCDCIDQQI6AAQgAyACNgIAIAAgACgCDEEIajYCDAsgAkEBQX8QlwdBBDoAACABIAEoAhBBAWo2AhAgASgCAEUEQCABIAA2AhQgAUEBNgIAIAFCgAI3AgwgASABQRhqNgIIIAAoAgwiA0ECOgAEIAMgAjYCACAAIAAoAgxBCGo2AgwLIAJBAUF/EJcHQQQ6AAAgAUEANgKoAiABIAEoAhBBAWo2AhAgASgCAEUEQCABIAA2AhQgAUEBNgIAIAFCgAI3AgwgASABQRhqNgIIIAAoAgwiA0ECOgAEIAMgAjYCACAAIAAoAgxBCGo2AgwLIAJBAUF/EJcHQQQ6AAAgASABKAIQQQFqNgIQIAEoAgBFBEAgASAANgIUIAFBATYCACABQoACNwIMIAEgAUEYajYCCCAAKAIMIgNBAjoABCADIAI2AgAgACAAKAIMQQhqNgIMCyACQQRBfxCXB0H4rAE2AAAgASABKAIQQQRqNgIQIAFBgIDlnQQ2AqwCIAEgACABQawCakEEIAEQjggiAjYCqAIgASAFKAIMOgCsAiACRQRAIAEgACABQawCakEBIAEQjgg2AqgCCyABQZgCaiAFQQAQvwYgASgCqAINASABKAIUIgQgASgCCCABKAIQEJ8BIAEoAgggAUEYakcEQCAEIAQoAgxBEGtBf0EAEF5BADoABAsgBCgCDCICQRBrIQAgAkEIayECA0AgACgCACEDIAAgAigCADYCACAALQAEIQUgACACLQAEOgAEIAIgBToABCACIAM2AgAgAEEIaiIAIAJBCGsiAkkNAAsgBCAEKAIMQQhrIgAgBCgCJE0EfyAEIABBf0EAEF4FIAALNgIMIAFBsAJqJABBAQ8LIABBAUG2sCoQ1AEACyAAQfavKkEAEKUBAAuBAQEBfyADKAIARQRAIAMgADYCFCADQQE2AgAgA0KAAjcCDCADIANBGGo2AgggACgCDCIEQQI6AAQgBCADQQhqNgIAIAAgACgCDEEIajYCDAsgAgRAIANBCGogAkF/EJcHIQAgAgRAIAAgASAC/AoAAAsgAyADKAIQIAJqNgIQC0EACwkAIABBARCQCAvUCwEKfyMAQaACayIEJAAgACgCFCIHKAIAIgVBCGoiAiAAKAIMIgNPBEAgACgCEEEsaiECCwJAAkACQAJAAkACQAJAAkACQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgcoAgAiBUEIaiICIAAoAgwiA0kNACAAKAIQQSxqIQILIAIoAgAiCy0AByIIQf8BRgRAIAsoAgwhCAsgAyAFQRBqIgJNBEAgACgCEEEsaiECCwJAAkAgAi0ABEEPcUEDaw4CAAEDCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgcoAgAiBUEQaiICIAAoAgwiA0kNACAAKAIQQSxqIQILIAIoAgAiCS0AByIGQf8BRgRAIAkoAgwhBgtBASECAkAgAyAFQRhqIgVNBH8gACgCEEEsagUgBQstAARBD3FFDQAgBEEANgIIIAMgBygCAEEYaiIFTQRAIAAoAhBBLGohBQsCQCAFLQAEQQNGBEAgBSgCACEDDAELIAUgBEEIakEAEPwBIQUgBCgCCCEDIAUNACAAQQMQ/QELIANBAEoEQCADIQIMAQsgA0UNACADQQAgCGtIDQAgAyAIakEBaiECCwJAIAJBAWsiCiAISwRAIAAoAgxBADoABCAAIAAoAgxBCGo2AgwMAQsgC0EQaiEHIAlBEGohBQJAAkAgAUUNAEEAIQIgACgCFCgCAEEgaiIDIAAoAgxPBH8gACgCEEEsagUgAwstAAQiA0EBR0EAIANBD3EbRQRAA0AgAiAFaiIDQc31KxDVBg0CIAMQJyACakEBaiICIAZNDQALCyAHIApqIQIgBkUEQCACIQgMCwsgBiAIIAprIgNLDQEgAyAGQQFrIgtrIgNFDQEgCUERaiEKIAksABAhCQNAIAIgCSADEJMIIghFDQIgCEEBaiIFIAogCxCEAkUNCyACIANqIAUiAmsiAw0ACwwBCyAJLQAQIQIgBEHIATYCGCAEIAA2AhQgBCAHNgIIIAQgByAIajYCDCAEIAUgCUERaiACQd4ARxsiBSAGaiACQd4ARiIGazYCECAHIApqIQIDQCAEQQA6ABwgBEEIaiACIAUQlwgiAwRAIAEEQCAAKAIMIgZBAzoABCAGIAIgB2tBAWo2AgAgACAAKAIMIgJBCGo2AgwgAkEDOgAMIAIgAyAHazYCCCAAIAAoAgxBCGo2AgwgBCgCFCAELQAcIgZBzYEqEJ4HIAZFDQkgBC0AHEUEQEEAIQBBACECDAgLIAQoAiAhAgJAIAQoAiQiAEECag4CAAwICyAEKAIIIQMgBCgCFCIAKAIMIgVBAzoABCAFIAIgA2tBAWo2AgAgACAAKAIMQQhqNgIMDAgLIAQoAhRBASAELQAcIgAgAEEBTRsiBkHNgSoQngdBACEAA0AgBEEIaiAAIAIgAxCYCCAAQQFqIgAgBkcNAAsMDAsgBg0BIAIgBCgCDEkhAyACQQFqIQIgAw0ACwsgACgCDEEAOgAEIAAgACgCDEEIajYCDAtBASEGDAgLIABBAUH47SoQ1AEACyAAQQJB+O0qENQBAAsgBCgCFCACIAAQnwELQQEhAiAGQQFGDQAgBEEgaiEHA0AgAiAELQAcTw0CIAcgAkEDdGoiACgCACEDAkACQAJAIAAoAgQiAEECag4CAAYBCyAEKAIIIQUgBCgCFCIAKAIMIghBAzoABCAIIAMgBWtBAWo2AgAgACAAKAIMQQhqNgIMDAELIAQoAhQgAyAAEJ8BCyACQQFqIgIgBkcNAAsLIAZBAmohBgwDCyAEIAJBAWo2AgAgBCgCFEG5wSsgBBClAQALIAQoAhRBgIYrQQAQpQEACyAAKAIMIgJBAzoABCACIAggB2siA0EBajYCACAAIAAoAgwiAkEIajYCDCACQQM6AAwgAiADIAZqNgIIIAAgACgCDEEIajYCDEECIQYLIARBoAJqJAAgBgvXHwIQfwF9IwBB0ARrIgEkACAAKAIUKAIAQQhqIgchBiAHIAAoAgwiC08EQCAAKAIQQSxqIQYLIAshBAJAAkACQCAGLQAEQQ9xQQNrDgIAAQILIAAgBhBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiBiAAKAIMIgRJDQAgACgCEEEsaiEGCyAGKAIAIgYtAAciAkH/AUYEQCAGKAIMIQILIAFCgAI3ArQCIAEgAUHAAmoiDjYCsAIgASAANgK8AiAEQQI6AAQgBCABQbACajYCACAAQQxqIgwgDCgCAEEIajYCACACBEAgCyAHa0EDdSEPIAZBEGoiBiACaiELIAFBkAJqQQFyIQggAEEUaiENQQEhBANAIAQhAiALAn8gBi0AACIEQSVHBEAgASgCuAIiByABKAK0Ak8EQCABQbACakEBQX8QlwcaIAEoArgCIQcgBi0AACEECyABIAdBAWo2ArgCIAEoArACIAdqIAQ6AAAgAiEEIAZBAWoMAQsgBkEBaiEHIAYtAAFBJUYEQEElIQMgASgCuAIiBCABKAK0Ak8EQCABQbACakEBQX8QlwcaIActAAAhAyABKAK4AiEECyABIARBAWo2ArgCIAEoArACIARqIAM6AAAgAiEEIAZBAmoMAQsgAkEBaiEEIAFBsAJqQfgAQX8QlwchCQJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCACIA9IBEAgB0G59SsQ1gYiA0EBaiIGQRZPDQIgAUElOgCQAiAGBEAgCCAHIAb8CgAACyAGIAhqQQA6AABB+AAhCkHsiCwhBQJAAkACQAJAAkACQAJAAkACQAJAAkAgAyAHai0AAEHBAGsOOAQKCgoGCgYKCgoKCgoKCgoKCgoKCgoKAgoKCgoKCgoKBAoAAwYFBgoDCgoKCgoCBwgKCQoBCgoCCgsgCEHW9SsQ1gYgCGoiAy0AACICQTBGDQ0gAkEwa0H/AXFBCU0EfyADQQJBASADLQABQTBrQf8BcUEKSRtqLQAABSACC0EgckHhAGtB/wFxQRpPDQ0gASAAIAQQoAc2AiAgCUH4ACABQZACaiABQSBqEKYEIQIMGQtB7vIrIQUMAQtB8fIrIQULIAAgBBCgByEKIAggBRDWBiAIaiIDLQAAIgJBMEYNCwJAIAJBMGtB/wFxQQlLBEAgAyEFDAELIANBAmogA0EBaiADLQABQTBrQf8BcUEKSSICGyEFIANBAkEBIAIbai0AACECCwJAIAJB/wFxQS5HDQAgBS0AASICQTBrQf8BcUEJSw0AIAVBA0ECIAUtAAJBMGtB/wFxQQpJG2otAAAhAgsgAkEgckHhAGtB/wFxQRpPDQsgAUGQAmoQJyABQZACampBADoAACABIAo2AkAgCUH4ACABQZACaiABQUBrEKYEIQIMFgsgCEHxiCwQ1gYgCGoiAy0AACICQTBGDQsCQCACQTBrQf8BcUEJSwRAIAMhBQwBCyADQQJqIANBAWogAy0AAUEwa0H/AXFBCkkiAhshBSADQQJBASACG2otAAAhAgsCQCACQf8BcUEuRw0AIAUtAAEiAkEwa0H/AXFBCUsNACAFQQNBAiAFLQACQTBrQf8BcUEKSRtqLQAAIQILIAJBIHJB4QBrQf8BcUEaTw0LIAFBkAJqECcgAUGQAmpqQQA6AAAgACAEIAFBxARqEP4FIREgASgCxARFDQwgASARuzkDYCAJQfgAIAFBkAJqIAFB4ABqEKYEIQIMFQtBlAEhCiABQbACakGUAUF/EJcHIQkLIAAgBCABQcQEahD+BSERIAEoAsQERQ0LIAhB8YgsENYGIAhqIgMtAAAiAkEwRg0MAkAgAkEwa0H/AXFBCUsEQCADIQUMAQsgA0ECaiADQQFqIAMtAAFBMGtB/wFxQQpJIgIbIQUgA0ECQQEgAhtqLQAAIQILAkAgAkH/AXFBLkcNACAFLQABIgJBMGtB/wFxQQlLDQAgBUEDQQIgBS0AAkEwa0H/AXFBCkkbai0AACECCyACQSByQeEAa0H/AXFBGk8NDCABQZACahAnIAFBkAJqakEAOgAAIAEgEbs5A4ABIAkgCiABQZACaiABQYABahCmBCECDBMLIAAgBBD/BSEDIAhB1vUrENYGIAhqIgUtAAAiAkEwRg0MIAJBMGtB/wFxQQlNBH8gBUECQQEgBS0AAUEwa0H/AXFBCkkbai0AAAUgAgtBIHJB4QBrQf8BcUEaTw0MIAEgAwR/IAMFIAFBkAJqECcgAWpB8wA6AI8CQcP6Kws2AqABIAlB+AAgAUGQAmogAUGgAWoQpgQhAgwSCyABLQCSAg0MIA0oAgAhAwJAIAJBAEgiCUUEQCADKAIAIARBA3RqIgMgDCgCAEkNASAAKAIQQSxqIQMMAQsgAkHY4c59TgRAIAwoAgAgBEEDdGohAwwBCyAEQdjhzn1GBEAgACgCEEEkaiEDDAELIAMoAgAiAy0ABEHmAEYEQCADKAIAIgMtAAZB1+HOfSACa08EQCADQQAgAmtBA3RqQcDyiRNrIQMMAgsgACgCEEEsaiEDDAELIAAoAhBBLGohAwsCQAJAAkACQCADLQAEQQ9xDgUCBwMBAAMLIAAgBCABQcAEahCIASECIAEoAsAEIQkgASgCuAIiAyABKAK0Ak8EQCABQbACakEBQX8QlwcaIAEoArgCIQMLIAEgA0EBajYCuAIgASgCsAIgA2pBIjoAACAJBEADQAJAAkACQCACLQAAIgNBCkYNACADQdwARg0AIANBIkcNAQsgASgCuAIiAyABKAK0Ak8EQCABQbACakEBQX8QlwcaIAEoArgCIQMLIAEgA0EBajYCuAIgASgCsAIgA2pB3AA6AAAgASgCuAIiAyABKAK0Ak8EQCABQbACakEBQX8QlwcaIAEoArgCIQMLIAItAAAhBSABIANBAWo2ArgCIAEoArACIANqIAU6AAAMAQsgAxCSCARAIAItAAEhBSABIAM2ArABIAFBxARqQQpBpsErQazBKyAFQTBrQf8BcUEKSRsgAUGwAWoQpgQaIAFBxARqECciA0UNASABQbACaiADQX8QlwchBSADBEAgBSABQcQEaiAD/AoAAAsgASABKAK4AiADajYCuAIMAQsgASgCuAIiBSABKAK0Ak8EQCABQbACakEBQX8QlwcaIAEoArgCIQUgAi0AACEDCyABIAVBAWo2ArgCIAEoArACIAVqIAM6AAALIAJBAWohAiAJQQFrIgkNAAsLIAEoArgCIgIgASgCtAJPBEAgAUGwAmpBAUF/EJcHGiABKAK4AiECCyABIAJBAWo2ArgCIAEoArACIAJqQSI6AABBACECDBQLIAFBsAJqQfgAQX8QlwchBSANKAIAIQoCQAJAAkACQCAJRQRAIAooAgAgBEEDdGoiAyAMKAIASQ0BIAAoAhBBLGohAwwBCyACQdjhzn1OBEAgDCgCACAEQQN0aiEDDAELIARB2OHOfUYNASAKKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdfhzn0gAmtPBEAgA0EAIAJrQQN0akHA8okTayEDDAILIAAoAhBBLGohAwwBCyAAKAIQQSxqIQMLIAMtAARBA0YNAQwUCyAAKAIQIgItAChBA0cNEyABQQA2AsQEIAJBJGohAgwBCyABQQA2AsQEIAlFBEAgCigCACAEQQN0aiICIAwoAgBJDQEgACgCEEEsaiECDAELIAJB2OHOfU4EQCAMKAIAIARBA3RqIQIMAQsgBEHY4c59RgRAIAAoAhBBJGohAgwBCyAKKAIAIgMtAARB5gBGBEAgAygCACIDLQAGQdfhzn0gAmtPBEAgA0EAIAJrQQN0akHA8okTayECDAILIAAoAhBBLGohAgwBCyAAKAIQQSxqIQILIAEgAi0ABEEDRwR/IAIgAUHEBGpBABD8ARogAUHEBGoFIAILKAIAIgI2AsABIAVB+ABB+bwpQdfDKyACQYCAgIB4RhsgAUHAAWoQpgQhAgwSCyADIAAoAhBBLGpHDQQLIAAgBEH3wioQhgIACyAAIAQgAUHEBGoQogchBSABLQCSAkUEQCABQbACahCbB0EAIQIMEQsgASgCxAQiECAFECdHDQwgCEHW9SsQ1gYgCGoiAy0AACICQTBGDQ0CQCACQTBrQf8BcUEJSwRAIAMhCgwBCyADQQJqIANBAWogAy0AAUEwa0H/AXFBCkkiAhshCiADQQJBASACG2otAAAhAgsCQCACQf8BcUEuRw0AIAotAAEiAkEwa0H/AXFBCUsNACAKQQNBAiAKLQACQTBrQf8BcUEKSRtqLQAAIQILIAJBIHJB4QBrQf8BcUEaTw0NAkAgAUGQAmpBLhCeAQ0AIBBB5ABJDQAgAUGwAmoQmwdBACECDBELIAEgBTYCgAIgCUH4ACABQZACaiABQYACahCmBCECIAwgDCgCAEEIayIDIAAoAiRNBH8gACADQX9BABBeBSADCzYCAAwQCyABIAFBkAJqNgIAIABB3oIsIAEQpQEACyAAIARB4PwqEIYCAAtBACECIAAgBEEAEKIHGiABQbACahCbBwwNCyAAQbX7K0EAEKUBAAsgASABQZACajYCECAAQZiFLCABQRBqEKUBAAsgASABQZACajYCMCAAQZiFLCABQTBqEKUBAAsgASABQZACajYCUCAAQZiFLCABQdAAahClAQALIAAgBEGGoCoQ1AEACyAAIARBhqAqENQBAAsgASABQZACajYCcCAAQZiFLCABQfAAahClAQALIAEgAUGQAmo2ApABIABBmIUsIAFBkAFqEKUBAAsgAEGU9ilBABClAQALIAAgBEH6+SkQhgIACyABIAFBkAJqNgLwASAAQZiFLCABQfABahClAQALAkAgAQJ/QfTkKyAAIARBABD+BSIRQwAAgH9bDQAaQfPkKyARQwAAgP9bDQAaIBEgEVsNAUHM/isLNgLQASAFQfgAQZGMKiABQdABahCmBCECDAELIAEgEbs5A+ABIAVBLiAFQfgAQaDYKyABQeABahCmBCICEJMIGgsgASABKAK4AiACajYCuAJBACECCyABIAEoArgCIAJqNgK4AiAGIAdqCyIGSw0ACwsgASgCvAIiCyABKAKwAiABKAK4AhCfASAOIAEoArACRwRAIAsgCygCDEEQa0F/QQAQXkEAOgAECyALKAIMIgRBEGshBiAEQQhrIQQDQCAGKAIAIQIgBiAEKAIANgIAIAYtAAQhByAGIAQtAAQ6AAQgBCAHOgAEIAQgAjYCACAGQQhqIgYgBEEIayIESQ0ACyALIAsoAgxBCGsiBiALKAIkTQR/IAsgBkF/QQAQXgUgBgs2AgwgAUHQBGokAEEBDwsgAEEBQfjtKhDUAQALDgAgAEH/AEYgAEEgSXIL5wEBAn8gAkEARyEDAkACQAJAIABBA3FFDQAgAkUNACABQf8BcSEEA0AgAC0AACAERg0CIAJBAWsiAkEARyEDIABBAWoiAEEDcUUNASACDQALCyADRQ0BAkAgAC0AACABQf8BcUYNACACQQRJDQAgAUH/AXFBgYKECGwhBANAQYCChAggACgCACAEcyIDayADckGAgYKEeHFBgIGChHhHDQIgAEEEaiEAIAJBBGsiAkEDSw0ACwsgAkUNAQsgAUH/AXEhAwNAIAMgAC0AAEYEQCAADwsgAEEBaiEAIAJBAWsiAg0ACwtBAAvrBAEJfyMAQRBrIgYkACAAKAIUIgUoAgAiA0EIaiIBIAAoAgwiAk8EQCAAKAIQQSxqIQELAkACQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgUoAgAiA0EIaiIBIAAoAgwiAkkNACAAKAIQQSxqIQELIAEoAgAiCC0AByIEQf8BRgRAIAgoAgwhBAsgAiADQRBqIgFNBEAgACgCEEEsaiEBCwJAAkAgAS0ABEEPcUEDaw4CAAEDCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgUoAgAiA0EQaiIBIAAoAgwiAkkNACAAKAIQQSxqIQELIAEoAgAiCS0AByIHQf8BRgRAIAkoAgwhBwsgAiADQRhqIgFNBEAgACgCEEEsaiEBCwJ/QQEgAS0ABEEPcUUNABogBkEANgIMIAIgBSgCAEEYaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgBkEMakEAEPwBIQIgBigCDCEBIAINACAAQQMQ/QELIAEgAUEASg0AGkEBIAFFDQAaQQEgAUEAIARrSA0AGiABIARqQQFqCyEDIABBAhCrASAAQaQCQQAQ2gEiAUHIATYCHCABIAA2AhggASAJQRBqIgUgB2o2AhQgASAIQRBqIgIgBGo2AhAgASACNgIMIAFBADYCCCABIAU2AgQgASACIARBAWogA0EBayIDIAMgBEsbajYCACAAQTFBAxCCBiAGQRBqJABBAQ8LIABBAUH47SoQ1AEACyAAQQJB+O0qENQBAAu0AgEEfwJ/IAAoAhQoAgAiAS0ABEHmAEYEQCABKAIAIgEtAAZBA08EQCABQSBqDAILIAAoAhBBLGoMAQsgACgCEEEsagshAkEAIQECQAJAAkAgAi0ABEEPcUECaw4GAQICAgIAAgsgAigCACIBIAEvAQYiAUEDdEEYakEQIAEbaiEBDAELIAIoAgAhAQsgASAANgIYAkAgASgCACIAIAEoAhBLDQAgAUEMaiEEA0AgAUEAOgAgAkAgBCAAIAEoAgQQlwgiAkUNACACIAEoAghGDQAgASACNgIAIAEgAjYCCCABKAIYIAEtACAiAUEBIAEbIAEgABsiAUHNgSoQngcgAUUNAgNAIAQgAyAAIAIQmAggA0EBaiIDIAFHDQALIAEPCyAAQQFqIgAgASgCEE0NAAsLIAML1BQBFX8jAEHQBGsiAiQAIAAoAhQiCigCACIDQQhqIgQgACgCDCIBTwRAIAAoAhBBLGohBAsCQAJAAkAgBC0ABEEPcUEDaw4CAAECCyAAIAQQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgooAgAiA0EIaiIEIAAoAgwiAUkNACAAKAIQQSxqIQQLIAQoAgAiBS0AByIJQf8BRgRAIAUoAgwhCQsgASADQRBqIgRNBEAgACgCEEEsaiEECwJAAkACQCAELQAEQQ9xQQNrDgIAAQILIAAgBBBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiCigCACIDQRBqIgQgACgCDCIBSQ0AIAAoAhBBLGohBAsgBCgCACIELQAHIghB/wFGBEAgBCgCDCEICyABIANBGGoiB00EQCAAKAIQQSxqIQcLAkAgBy0ABEEPcSIGDQAgByAAKAIQQSxqRw0AQX8hBgsCQCABIANBIGoiA00EfyAAKAIQQSxqBSADCy0ABEEPcUUEQCAJQQFqIQwMAQsgAkEANgK4AiABIAooAgBBIGoiA00EQCAAKAIQQSxqIQMLIAMtAARBA0YEQCADKAIAIQwMAQsgAyACQbgCakEAEPwBIQEgAigCuAIhDCABDQAgAEEEEP0BCyAGQQNrQQRJBEAgBEEQaiIBLQAAIQMgAiAANgI0IAJCgAI3AiwgAiACQThqIg82AiggACgCDCIHQQI6AAQgByACQShqNgIAIAAgACgCDEEIajYCDCACQcgBNgLIAiACIAA2AsQCIAIgBEERaiABIANB/wFxIhBB3gBGIgMbIhEgCGogA2s2AsACIAIgBUEQaiIHNgK4AiACIAcgCWo2ArwCIAJB0AJqIRIgBkEFayETQQAhAwJAA0ACQCALIAxODQAgAkEAOgDMAgJAAkACQAJAAkACQAJAIAJBuAJqIAcgERCXCCIJRQ0AIAMgCUYNACACKALEAiEFAkACQAJAIBMOAgEAAgsgBSgCFCgCAEEYaiIBIAUoAgwiA08EQCAFKAIQQSxqIQELIAMgASgCADYCACADIAEtAAQ6AAQgBSAFKAIMQQhqNgIMIAIoAsQCIAItAMwCIgFBASABGyABIAcbIgNBzYEqEJ4HQQAhASADRQRAIAUgBSgCDEEIa0EBEJEGDAcLA0AgAkG4AmogASAHIAkQmAggAUEBaiIBIANHDQALIAUgBSgCDCADQX9zQQN0akEBEJEGDAYLIAItAMwCRQRAIAkgByIBayIDQX5GDQUMBAsgAigC0AIhAQJAAkAgAigC1AIiA0ECag4CAQAFCyAFQYCGK0EAEKUBAAsgAigCuAIhAyAFKAIMIgRBAzoABCAEIAEgA2tBAWo2AgAgBSAFKAIMQQhqNgIMDAQLQQAhBEEAIQEgBSgCFCgCAEEYaiIDIAUoAgxPBEAgBSgCEEEsaiEDCwJAAkACQCADLQAEQQ9xQQNrDgIAAQILIAUgAxBTIAUoAhAoAgxBAEoEQCAFEFQLIAUoAhQoAgBBGGoiAyAFKAIMSQ0AIAUoAhBBLGohAwsgAygCACIBLQAHIgRB/wFGBEAgASgCDCEECyABQRBqIQELIAkgB2siCkF+RyEUA0AgASIDQSUgBBCTCCIBBEAgASADRwRAIAJBKGogASADayIGQX8QlwchCCAGBEAgCCADIAb8CgAACyACIAIoAjAgBmo2AjALAkACQAJAAkAgAS0AASIGQSVrDgwAAgICAgICAgICAgECC0ElIQggAigCMCIGIAIoAixPBEAgAkEoakEBQX8QlwcaIAEtAAEhCCACKAIwIQYLIAIgBkEBajYCMCACKAIoIAZqIAg6AAAMAgsgCkUNASACQShqIApBfxCXByEGIAoEQCAGIAcgCvwKAAALIAIgAigCMCAKajYCMAwBCyAGQTBrQf8BcUEJSw0EAkACQAJAIAZBMWsiCCACLQDMAk8EQCAIRQ0BIAIgBkEwazYCACACKALEAkG5wSsgAhClAQALIBIgCEEDdGoiBigCACEIAkACQCAGKAIEIgZBAmoOAgEABAsgAigCxAJBgIYrQQAQpQEACyACKAK4AiEOIAIoAsQCIgYoAgwiFUEDOgAEIBUgCCAOa0EBajYCACAGIAYoAgxBCGo2AgwMAQsgCiEGIAchCCAUDQELIAJBKGoQmwcMAQsgBkUNACACQShqIAZBfxCXByEOIAYEQCAOIAggBvwKAAALIAIgAigCMCAGajYCMAsgBCADIAFBAmoiAWtqIQQMAQsLQQEhASAERQ0FIAJBKGogBEF/EJcHIQcgBARAIAcgAyAE/AoAAAsgAiACKAIwIARqNgIwDAULIAcgAigCvAJPDQYgAigCMCIBIAIoAixPBEAgAkEoakEBQX8QlwcaIAIoAjAhAQsgBy0AACEEIAIgAUEBajYCMCACKAIoIAFqIAQ6AAAgB0EBaiEHDAULIAJBJTYCECAFQeHrKiACQRBqEKUBAAsgBSABIAMQnwELQQAhBCAFKAIUKAIAQRhqIgEgBSgCDCIDTwRAIAUoAhBBLGohAQsCQCABLQAEQcUARw0AIAEoAgAgA0EIaxCgASEEIAUoAgwhAyAELQAEQQ9xRQ0AIANBCGsgBCgCADYCACADQQRrIAQtAAQ6AAAMAQsgBSABIANBCGsiAyADIAQQhgYLAkAgBSgCDCIDQQRrLQAAIgFBAUcEQCABQQ9xIgENAQsgBSADQQhrIgEgBSgCJE0EfyAFIAFBf0EAEF4FIAELNgIMQQAhASAHIAlGDQEgAkEoaiAJIAdrIgNBfxCXByEEIAMEQCAEIAcgA/wKAAALIAIgAigCMCADajYCMAwBCyABQQVrQX1NDQQgAkEoahCbB0EBIQELIAtBAWohCyABIA1yIQ0gCSIHIQMLIBBB3gBHDQELCwJAIA1FBEAgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELIAMgASgCADYCACADIAEtAAQ6AAQgACAAKAIMQQhqIgE2AgwMAQsCQCAHIAIoArwCIgFGBEAgAigCMCEBDAELIAJBKGogASAHayIBQX8QlwchAyABBEAgAyAHIAH8CgAACyACIAIoAjAgAWoiATYCMAsgAigCNCIGIAIoAiggARCfASAPIAIoAihHBEAgBiAGKAIMQRBrQX9BABBeQQA6AAQLIAYoAgwiA0EQayEBIANBCGshAwNAIAEoAgAhBCABIAMoAgA2AgAgAS0ABCEHIAEgAy0ABDoABCADIAc6AAQgAyAENgIAIAFBCGoiASADQQhrIgNJDQALIAYgBigCDEEIayIBIAYoAiRNBH8gBiABQX9BABBeBSABCzYCDCAAKAIMIQELIAFBAzoABCABIAs2AgAgACAAKAIMQQhqNgIMIAJB0ARqJABBAg8LIAIgBUF/EOABQQJ0QfSxL2ooAgA2AiAgBUGi+isgAkEgahClAQALIABBA0GGlysQ1AEACyAAQQJB+O0qENQBAAsgAEEBQfjtKhDUAQAL6g0BEX8jAEEQayIQJAAgACAAKAIQIgNBAWs2AhACQAJAAkACQAJAAkACQAJAAkAgAwRAIABBGGohDiAAQRxqIREDQCABIgRBAWohASAEQQFrIRMgAiEGA0AgACgCCCEIAkACQAJAA0AgBiAIRgRAIAQhBwwECyAGQQFqIQIgBi0AACIDQSVHBEACQAJAAkACQCADQSRrDgYDBwcHAQIACyADQdsARw0GIAZBAmogAiAGLQABQd4ARhshAgNAIAIgCEYNEyACQQJBASACLQAAQSVGIAJBAWoiAyAISXEiBRtqIQogAkECaiADIAUbIgMhAiAKLQAAQd0ARw0ACyADQQFqIQIMBgsgAC0AFCEDIAItAABBKUYEQCADQSBPDQsgDiADQQN0aiICQX42AgQgAiAENgIAIAAgA0EBajoAFCAAIAQgBkECahCXCCIHDQcgACAALQAUQQFrOgAUQQAhBwwHCyADQSBPDQsgDiADQQN0aiIFQX82AgQgBSAENgIAIAAgA0EBajoAFCAAIAQgAhCXCCIHDQYgACAALQAUQQFrOgAUQQAhBwwGCyAALQAUIQMDQCADQQBMDQwgESADQQFrIgNBA3RqKAIAQX9HDQALIA4gA0EDdGoiAyAEIAMoAgBrNgIEIAAgBCACEJcIIgcNBSADQX82AgRBACEHDAULIAIgCEcNAyAEQQAgBCAAKAIERhshBwwECwJAIAItAAAiA0HmAEcEQAJAIANBMGsOMwICAgICAgICAgIEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEAAQLIAZBAmoiAiAIQQFrTw0MQQAhByAELQAAIgkgAi0AAEcNBSABIAAoAgQiCk8NBSAGLQADIQhBASEDA0AgASECAkAgBC0AASIFIAhB/wFxRgRAIANBAWsiAw0BIAZBBGohAiAEQQJqIQEMCgsgAyAFIAlGaiEDCyACIQQgAkEBaiIBIApHDQALDAULIAYtAAJB2wBHDQwgBkECaiEMIAZBBGogBkEDaiIPIAYtAAMiCUHeAEYiEhshAgNAIAIgCEYNDiACQQJBASACLQAAQSVGIAJBAWoiAyAISXEiBRtqIQogAkECaiADIAUbIgUhAiAKLQAAQd0ARw0AC0EAIQdBACELIAAoAgAgBEcEQCATLQAAIQsLIA8gDCAJQd4ARhsiA0EBaiIMIAVPDQQgBUEBaiEGIAlB3gBHIQ0gDCEPIAMhAgJ/A0AgAi0AAiEKAkACQCACLQABIglBJUYEQCALIAoQpQhFDQEgDQwECwJAIApBLUcNACACQQNqIgIgBU8NACAJIAtLDQIgAi0AACALSQ0CIA0MBAsgDyECIAkgC0cNASANDAMLIAJBAmohAgsgAkEBaiIPIAVJDQALIBILDQQgBC0AACEJAkADQCADLQACIQICQCADLQABIgpBJUYEQCAJIAIQpQgNAyADQQJqIQMMAQsCQCACQS1HDQAgA0EDaiIDIAVPDQAgCSAKSQ0BIAMtAAAgCUkNAQwDCyAMIQMgCSAKRg0CCyADQQFqIgwgBUkNAAsgEiENCyANDQEMBAsLIANBMUkNDCADQTFrIgIgAC0AFE8NDCARIAJBA3QiAmooAgAiBUF/Rg0MQQAhByAAKAIEIARrIAVJDQIgAiAOaigCACAEIAUQhAINAiAERQ0CIAZBAmohAiAEIAVqIQEMBAsgAiAIRg0NIAZBAmohAgsgAi0AACEDIAAoAgQiCCAEIAYgAhCmCEUEQEEAIQcgA0EqayIDQRVLDQFBASADdEGJgIABcUUNASACQQFqIQYMAgsgA0E/RwRAAkACQAJAIANBKmsOBAEABgIGCyABIQQLQQAhBQNAIAUiA0EBaiEFIAggAyAEaiAGIAIQpggNAAsgAkEBaiEFA0BBACEHIANBAEgNAyADIARqIQIgA0EBayEDIAAgAiAFEJcIIgdFDQALDAILIAJBAWohBSAAQQRqIQgDQCAAIAQgBRCXCCIHDQJBACEHIAgoAgAgBCAGIAIQpgghAyAEQQFqIQQgAw0ACwwBCyAAIAEgAkEBaiIGEJcIIgdFDQELCwsgACAAKAIQQQFqNgIQIBBBEGokACAHDwsgACgCDEGxuylBABClAQALIAAoAgxBzYEqQQAQpQEACyAAKAIMQc2BKkEAEKUBAAsgACgCDEHohStBABClAQALIAAoAgxB2IAsQQAQpQEACyAAKAIMQZmsKkEAEKUBAAsgACgCDEGHgSxBABClAQALIAAoAgwhAiAQIANBMGs2AgAgAkG5wSsgEBClAQALIAAoAgxBh4EsQQAQpQEACyAAKAIMQaeBLEEAEKUBAAvJAQEBfyMAQRBrIgQkAAJAAkACQCAALQAUIAFMBEAgAUUNASAAKAIMIQAgBCABQQFqNgIAIABBucErIAQQpQEACyAAIAFBA3RqIgEoAhghAgJAAkAgASgCHCIBQQJqDgIBAAMLIAAoAgxBgIYrQQAQpQEACyAAKAIAIQEgACgCDCIAKAIMIgNBAzoABCADIAIgAWtBAWo2AgAgACAAKAIMQQhqNgIMDAILIAMgAmsiAUF+Rg0BCyAAKAIMIAIgARCfAQsgBEEQaiQAC7wBAQN/IAAoAhQoAgBBCGoiASAAKAIMIgJPBEAgACgCEEEsaiEBCwJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMIgJJDQAgACgCEEEsaiEBCyABKAIAIgMtAAciAUH/AUYEQCADKAIMIQELIAJBAzoABCACIAE2AgAgACAAKAIMQQhqNgIMQQEPCyAAQQFB+O0qENQBAAvlAwEGfyMAQZACayICJAAgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiA0kNACAAKAIQQSxqIQELIAEoAgAiBS0AByIBQf8BRgRAIAUoAgwhAQsgAiAANgIMIAJCgAI3AgQgAiACQRBqIgY2AgAgA0ECOgAEIAMgAjYCACAAIAAoAgxBCGo2AgxBACEAIAIgAUF/EJcHIQMgAiABBH8gBUEQaiEFA0AgACADaiAAIAVqLQAAENMBOgAAIABBAWoiACABRw0ACyABBSAACyACKAIIaiIANgIIIAIoAgwiBCACKAIAIAAQnwEgBiACKAIARwRAIAQgBCgCDEEQa0F/QQAQXkEAOgAECyAEKAIMIgFBEGshACABQQhrIQEDQCAAKAIAIQMgACABKAIANgIAIAAtAAQhBSAAIAEtAAQ6AAQgASAFOgAEIAEgAzYCACAAQQhqIgAgAUEIayIBSQ0ACyAEIAQoAgxBCGsiACAEKAIkTQR/IAQgAEF/QQAQXgUgAAs2AgwgAkGQAmokAEEBDwsgAEEBQfjtKhDUAQALCQAgAEEAEJAIC7kIAQp/IwBBkAJrIgUkAAJ/IAAoAhQiASgCAEEIaiICIAAoAgwiA08EQCAAKAIQQSxqIQILAkACQAJAAkACQCACLQAEQQ9xQQNrDgIAAQILIAAgAhBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiASgCAEEIaiICIAAoAgwiA0kNACAAKAIQQSxqIQILIAIoAgAiBi0AByICQf8BRgRAIAYoAgwhAgsgBUEANgIAIAMgASgCAEEQaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEEDAELIAEgBUEAEPwBIQEgBSgCACEEIAENACAAQQIQ/QELAkAgACgCFCgCAEEYaiIBIAAoAgxJBEAgAS0ABEEPcQ0BDAQLIAAoAhAtADBBD3FFDQMgACgCEEEsaiEBCwJAAkAgAS0ABEEPcUEDaw4CAAEDCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQRhqIgEgACgCDEkNACAAKAIQQSxqIQELIAEoAgAiAy0AByIBQf8BRgRAIAMoAgwhAQsgA0EQagwDCyAAQQFB+O0qENQBAAsgAEEDQfjtKhDUAQALQQAhAUG3kywLIQgCQAJAIARBAEwEQCAAQbeTLBBYDAELIAEgAmoiAyABSQ0BIANB/////wcgBG5LDQEgBkEQaiEHIAUgADYCDCAFQoACNwIEIAUgBUEQaiIJNgIAIAAoAgwiA0ECOgAEIAMgBTYCACAAIAAoAgxBCGo2AgwgBSABIARBAWtsIAIgBGxqIgpBfxCXByEDAkAgBEEBRg0AAkAgBEEBcQRAIAQhAAwBCyACBEAgAyAHIAL8CgAACyACIANqIQMgBEEBayEAIAFFDQAgAQRAIAMgCCAB/AoAAAsgASADaiEDCyAEQQJGDQADQCACRSIERQRAIAMgByAC/AoAAAsgAiADaiEDAn8gAUUEQCAERQRAIAMgByAC/AoAAAsgAiADaiEDIABBAmsMAQsgAUUiBkUEQCADIAggAfwKAAALIAEgA2ohAyAERQRAIAMgByAC/AoAAAsgAiADaiEDIAZFBEAgAyAIIAH8CgAACyABIANqIQMgAEECawshBCAAQQRrIQYgBCEAIAZBfUkNAAsLIAIEQCADIAcgAvwKAAALIAUgBSgCCCAKaiICNgIIIAUoAgwiBCAFKAIAIAIQnwEgCSAFKAIARwRAIAQgBCgCDEEQa0F/QQAQXkEAOgAECyAEKAIMIgFBEGshAiABQQhrIQEDQCACKAIAIQAgAiABKAIANgIAIAItAAQhAyACIAEtAAQ6AAQgASADOgAEIAEgADYCACACQQhqIgIgAUEIayIBSQ0ACyAEIAQoAgxBCGsiAiAEKAIkTQR/IAQgAkF/QQAQXgUgAgs2AgwLIAVBkAJqJABBAQ8LIABBkporQQAQpQEAC5sFAQl/IwBBkAJrIgMkACAAKAIUKAIAQQhqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQAJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiBEkNACAAKAIQQSxqIQELIAEoAgAiAS0AByICQf8BRgRAIAEoAgwhAgsgAyAANgIMIANCgAI3AgQgAyADQRBqIgg2AgAgBEECOgAEIAQgAzYCACAAIAAoAgxBCGo2AgwgAyACQX8QlwchBSACDQFBACECDAILIABBAUH47SoQ1AEACyAFIAFBEGogAmoiAUEBay0AADoAAEEBIQAgAkEBRg0AIAJBAmshBiACQQNxQQFHBEAgAkEBa0EDcSEHQQAhBANAIAAgBWogASAAQX9zai0AADoAACAAQQFqIQAgBEEBaiIEIAdHDQALCyAGQQNJDQAgBUEDaiEHIAVBAmohBiAFQQFqIQkDQCAAIAVqIAEgAEF/c2otAAA6AAAgACAJaiABIABrIgRBAmstAAA6AAAgACAGaiAEQQNrLQAAOgAAIAAgB2ogBEEEay0AADoAACAAQQRqIgAgAkcNAAsLIAMgAygCCCACaiIANgIIIAMoAgwiAiADKAIAIAAQnwEgCCADKAIARwRAIAIgAigCDEEQa0F/QQAQXkEAOgAECyACKAIMIgFBEGshACABQQhrIQEDQCAAKAIAIQQgACABKAIANgIAIAAtAAQhBSAAIAEtAAQ6AAQgASAFOgAEIAEgBDYCACAAQQhqIgAgAUEIayIBSQ0ACyACIAIoAgxBCGsiACACKAIkTQR/IAIgAEF/QQAQXgUgAAs2AgwgA0GQAmokAEEBC6QEAQZ/IwBBEGsiBCQAIAAoAhQiASgCAEEIaiICIAAoAgwiA08EQCAAKAIQQSxqIQILAkACQAJAIAItAARBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCIBKAIAQQhqIgIgACgCDCIDSQ0AIAAoAhBBLGohAgsgAigCACIGLQAHIgJB/wFGBEAgBigCDCECCyAEQQA2AgggAyABKAIAQRBqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQEMAQsgASAEQQhqQQAQ/AEhAyAEKAIIIQEgAw0AIABBAhD9AQsCQCABQQBKBEAgASEDDAELQQEhAyABRQ0AIAFBACACa0gNACABIAJqQQFqIQMLAkACQAJAAkAgACgCFCgCAEEYaiIBIAAoAgxJBEAgAS0ABEEPcQ0BQX8hAQwECyAAKAIQLQAwQQ9xDQFBfyEBDAMLIARBADYCDAwBCyAEQQA2AgwgACgCEEEsaiEBCyABLQAEQQNGBEAgASgCACEBDAELIAEgBEEMakEAEPwBIQUgBCgCDCEBIAUNACAAQQMQ/QELAkACfyACIAEgAkoNABogASABQQBODQAaQQAgAUEAIAJrSA0AGiABIAJqQQFqCyIFIANPBEAgACADIAZqQQ9qIAUgA2tBAWoQnwEMAQsgAEG3kywQWAsgBEEQaiQAQQEPCyAAQQFB+O0qENQBAAvlAwEGfyMAQZACayICJAAgACgCFCgCAEEIaiIBIAAoAgwiA08EQCAAKAIQQSxqIQELAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgwiA0kNACAAKAIQQSxqIQELIAEoAgAiBS0AByIBQf8BRgRAIAUoAgwhAQsgAiAANgIMIAJCgAI3AgQgAiACQRBqIgY2AgAgA0ECOgAEIAMgAjYCACAAIAAoAgxBCGo2AgxBACEAIAIgAUF/EJcHIQMgAiABBH8gBUEQaiEFA0AgACADaiAAIAVqLQAAELkHOgAAIABBAWoiACABRw0ACyABBSAACyACKAIIaiIANgIIIAIoAgwiBCACKAIAIAAQnwEgBiACKAIARwRAIAQgBCgCDEEQa0F/QQAQXkEAOgAECyAEKAIMIgFBEGshACABQQhrIQEDQCAAKAIAIQMgACABKAIANgIAIAAtAAQhBSAAIAEtAAQ6AAQgASAFOgAEIAEgAzYCACAAQQhqIgAgAUEIayIBSQ0ACyAEIAQoAgxBCGsiACAEKAIkTQR/IAQgAEF/QQAQXgUgAAs2AgwgAkGQAmokAEEBDwsgAEEBQfjtKhDUAQALtBgEEH8BfQF+AXwjAEGwAmsiAiQAIAAoAhQoAgBBCGoiASAAKAIMIgNPBEAgACgCEEEsaiEBCwJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUKAIAQQhqIgEgACgCDCIDSQ0AIAAoAhBBLGohAQsgASgCACEBIAJCgYCAgBA3AhAgAiAANgIMIAIgAUEQajYCCCADQQA6AAQgACAAKAIMIgNBCGo2AgwgAiACQShqIg82AhggAiAANgIkIAJCgAI3AhwgA0ECOgAMIAMgAkEYajYCCCAAIAAoAgxBCGo2AgwgDyEDIAEtABAEQEEBIQcDQCACQQxqIA0gAkEIaiACQQRqIAIQoQghBSACKAIAIgMgDWohBiACKAIEIQQgA0EASgRAA0AgAigCICIBIAIoAhxPBEAgAkEYakEBQX8QlwcaIAIoAiAhAQsgAiABQQFqNgIgIAIoAhggAWpBADoAACADQQFKIQEgA0EBayEDIAENAAsLIAQgBmohDSAHQQFqIQkCQAJAAkACQAJAAkACQAJAAkACQCAFQQFrDgoBAgMEBQYHCAkJAAsgACAJEKAHIQogBEEDTARAIApBAEEBIARBA3RBAWt0IgFrSA0NIAEgCkwNDQsgAigCECEDIAJBGGogBEF/EJcHIgVBACAEQQFrIgYgAxtqIAo6AAACQCAEQQJIDQAgBkEDcSEMQQEhASAKIQcCQCAEQQJrIghBA0kNACAFQQEgCCADG2ogCkEIdjoAACAFQQIgBEEDayADG2ogCkEQdjoAACAFQQMgBEEEayADG2ogCkEYdjoAAEEEIQhBACEHIAVBBCAEQQVrIAMbakEAOgAAQQUhASAGQXxxIg5BBEYNAANAIAUgASAGIAFrIAMbakEAOgAAIAUgAUEBaiILIAYgC2sgAxtqQQA6AAAgBSABQQJqIgsgBiALayADG2pBADoAACAFIAFBA2oiCyAGIAtrIAMbakEAOgAAIAFBBGohASAIQQRqIgggDkcNAAsLQQAhCCAMBEADQCAFIAEgBiABayADG2ogB0EIdiIHOgAAIAFBAWohASAIQQFqIgggDEcNAAsLIARBBUkNACAKQQBODQAgBEEDcSEMQQQhASAEQQVrQQNPBEAgBEH8////B3FBCGshC0EAIQcDQCAFIAEgBiABayADG2pB/wE6AAAgBSABQQFyIgggBiAIayADG2pB/wE6AAAgBSABQQJyIgggBiAIayADG2pB/wE6AAAgBSABQQNyIgggBiAIayADG2pB/wE6AAAgAUEEaiEBIAcgC0chCCAHQQRqIQcgCA0ACwtBACEHIAxFDQADQCAFIAEgBiABayADG2pB/wE6AAAgAUEBaiEBIAdBAWoiByAMRw0ACwsgAiACKAIgIARqNgIgIAkhBwwICyAEQQNMQQAgACAJEKAHIgcgBEEDdHYbDQwgAigCECEDIAJBGGogBEF/EJcHIgVBACAEQQFrIgYgAxtqIAc6AAACQCAEQQJIDQAgBkEDcSEMQQEhAQJAIARBAmsiCEEDSQ0AIAVBASAIIAMbaiAHQQh2OgAAIAVBAiAEQQNrIAMbaiAHQRB2OgAAIAVBAyAEQQRrIAMbaiAHQRh2OgAAQQQhCEEAIQcgBUEEIARBBWsgAxtqQQA6AABBBSEBIAZBfHEiCkEERg0AA0AgBSABIAYgAWsgAxtqQQA6AAAgBSABQQFqIgsgBiALayADG2pBADoAACAFIAFBAmoiCyAGIAtrIAMbakEAOgAAIAUgAUEDaiILIAYgC2sgAxtqQQA6AAAgAUEEaiEBIAhBBGoiCCAKRw0ACwtBACEIIAxFDQADQCAFIAEgBiABayADG2ogB0EIdiIHOgAAIAFBAWohASAIQQFqIgggDEcNAAsLIAIgAigCICAEajYCICAJIQcMBwsgACAJIAJBrAJqEP4FIREgAigCrAJFDQwgAkEYakEEQX8QlwchAQJAIAIoAhBBAUYEQCABIBE4AAAMAQsgASARvCIDQRh0IANBgP4DcUEIdHIgA0EIdkGA/gNxIANBGHZycjYAAAsgAiACKAIgIARqNgIgIAkhBwwGCyAAIAkgAkGsAmoQ/gUhESACKAKsAkUNDCACQRhqQQRBfxCXByEBAkAgAigCEEEBRgRAIAEgETgAAAwBCyABIBG8IgNBGHQgA0GA/gNxQQh0ciADQQh2QYD+A3EgA0EYdnJyNgAACyACIAIoAiAgBGo2AiAgCSEHDAULIAAgCSACQawCahD+BSERIAIoAqwCRQ0MIAJBGGpBCEF/EJcHIQEgEbshEwJAIAIoAhBBAUYEQCABIBM5AAAMAQsgASATvSISQjiGIBJCgP4Dg0IohoQgEkKAgPwHg0IYhiASQoCAgPgPg0IIhoSEIBJCCIhCgICA+A+DIBJCGIhCgID8B4OEIBJCKIhCgP4DgyASQjiIhISENwAACyACIAIoAiAgBGo2AiAgCSEHDAQLIAAgCSACQawCahCIASIBRQ0MIAIoAqwCIgMgBEsNDSADBEAgAkEYaiADQX8QlwchBSADBEAgBSABIAP8CgAACyACIAIoAiAgA2o2AiALIAMgBEkEQANAIAIoAiAiASACKAIcTwRAIAJBGGpBAUF/EJcHGiACKAIgIQELIAIgAUEBajYCICACKAIYIAFqQQA6AAAgA0EBaiIDIARHDQALCyAJIQcMAwsgACAJIAJBrAJqEIgBIhBFDQ0gBEEDTEEAIAIoAqwCIgogBEEDdHYbDQ4gAigCECEDIAJBGGogBEF/EJcHIgVBACAEQQFrIgYgAxtqIAo6AAACQCAEQQJIDQAgBkEDcSEMQQEhASAKIQcCQCAEQQJrIghBA0kNACAFQQEgCCADG2ogCkEIdjoAACAFQQIgBEEDayADG2ogCkEQdjoAACAFQQMgBEEEayADG2ogCkEYdjoAAEEEIQhBACEHIAVBBCAEQQVrIAMbakEAOgAAQQUhASAGQXxxIg5BBEYNAANAIAUgASAGIAFrIAMbakEAOgAAIAUgAUEBaiILIAYgC2sgAxtqQQA6AAAgBSABQQJqIgsgBiALayADG2pBADoAACAFIAFBA2oiCyAGIAtrIAMbakEAOgAAIAFBBGohASAIQQRqIgggDkcNAAsLQQAhCCAMRQ0AA0AgBSABIAYgAWsgAxtqIAdBCHYiBzoAACABQQFqIQEgCEEBaiIIIAxHDQALCyACIAIoAiAgBGo2AiAgCgRAIAJBGGogCkF/EJcHIQEgCgRAIAEgECAK/AoAAAsgAiACKAIgIApqNgIgCyAKIA1qIQ0gCSEHDAILIAAgCSACQawCahCIASIDRQ0OIAMQJyIBIAIoAqwCIgRHDQ8CQCABRQRAIAIoAiAhAQwBCyACQRhqIAFBfxCXByEFIAEEQCAFIAMgAfwKAAALIAIgAigCICABaiIBNgIgCyACKAIcIAFNBEAgAkEYakEBQX8QlwcaIAIoAiAhAQsgAiABQQFqNgIgIAIoAhggAWpBADoAACAEIA1qQQFqIQ0gCSEHDAELIAIoAiAiASACKAIcTwRAIAJBGGpBAUF/EJcHGiACKAIgIQELIAIgAUEBajYCICACKAIYIAFqQQA6AAALIAIoAggtAAANAAsgAigCGCEDCyACKAIkIgYgAyACKAIgEJ8BIA8gAigCGEcEQCAGIAYoAgxBEGtBf0EAEF5BADoABAsgBigCDCIDQRBrIQEgA0EIayEDA0AgASgCACEEIAEgAygCADYCACABLQAEIQUgASADLQAEOgAEIAMgBToABCADIAQ2AgAgAUEIaiIBIANBCGsiA0kNAAsgBiAGKAIMQQhrIgEgBigCJE0EfyAGIAFBf0EAEF4FIAELNgIMIAJBsAJqJABBAQ8LIABBAUH47SoQ1AEACyAAIAlBor4pEIYCAAsgACAJQeq+KRCGAgALIAAgCUGGoCoQ1AEACyAAIAlBhqAqENQBAAsgACAJQYagKhDUAQALIAAgCUH47SoQ1AEACyAAIAlB9vcqEIYCAAsgACAJQfjtKhDUAQALIAAgCUHN9yoQhgIACyAAIAlB+O0qENQBAAsgACAJQfr5KRCGAgALwgEBAn8jAEEQayIFJAACQAJAAkAgACACIAMQpAgiBkEJRwRAIAMoAgAhAgwBCyACKAIALQAARQ0BIAAgAiAFQQxqEKQIQQVGDQEgBSgCDCICRQ0BC0EAIQMCQCAGQQVGDQAgAkECSA0AIAIgACgCCCIDIAIgA0gbIgIgAkEBayIDcQ0CIAIgASADcWsgA3EhAwsgBCADNgIAIAVBEGokACAGDwsgACgCAEEBQZqHLBCGAgALIAAoAgBBAUHA7ysQhgIAC84CAQN/IwBBIGsiAiQAIAAoAhQoAgBBCGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQAJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCgCAEEIaiIBIAAoAgxJDQAgACgCEEEsaiEBCyABKAIAIQMgAkKBgICAEDcCGCACIAA2AhQgAiADQRBqNgIQQQAhASADLQAQBEADQCACQRRqIAEgAkEQaiACQQxqIAJBCGoQoQhBCGtBfk8NAyABIAIoAgwgAigCCGoiA0H/////B3NLDQQgASADaiEBIAIoAhAtAAANAAsLIAAoAgwiA0EDOgAEIAMgATYCACAAIAAoAgxBCGo2AgwgAkEgaiQAQQEPCyAAQQFB+O0qENQBAAsgAEEBQaDrKRCGAgALIABBAUG6mSsQhgIAC4MOAw1/AX4BfCMAQTBrIgYkACAAKAIUIgEoAgBBCGoiAiAAKAIMIgNPBEAgACgCEEEsaiECCwJAAkACQAJAAkACQAJAAkACQAJAIAItAARBD3FBA2sOAgABAgsgACACEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCIBKAIAQQhqIgIgACgCDCIDSQ0AIAAoAhBBLGohAgsgBiACKAIAQRBqIgw2AiAgAyABKAIAIgRBEGoiAk0EQCAAKAIQQSxqIQILAkACQCACLQAEQQ9xQQNrDgIAAQMLIAAgAhBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiASgCACIEQRBqIgIgACgCDCIDSQ0AIAAoAhBBLGohAgsgAigCACIFLQAHIghB/wFGBEAgBSgCDCEIC0EBIQICQCADIARBGGoiBE0EfyAAKAIQQSxqBSAECy0ABEEPcUUNACAGQQA2AiQgAyABKAIAQRhqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQMMAQsgASAGQSRqQQAQ/AEhASAGKAIkIQMgAQ0AIABBAxD9AQsgA0EASgRAIAMhAgwBCyADRQ0AIANBACAIa0gNACADIAhqQQFqIQILIAJBAWsiAyAISw0CIAZCgYCAgBA3AiggBiAANgIkIAwtAAAEfyAFQRBqIQpBACEFA0AgBkEkaiADIAZBIGogBkEcaiAGQRhqEKEIIQEgBigCHCICIAYoAhgiBGogCCADa0sNBSAAQQJBgPApEJ4HIAVBAWohDCADIARqIQMCQAJAAkACQAJAAkACQAJAAkAgAUECaw4JAQIDBAUGCAgIAAsCQAJAAkAgAkEATARAQQAhBQwBCyADIApqIgdBBCACIAJBBE4bIgRBAWsiCyACIARrIAYoAigiCRtqLQAAIQUgAkEBRg0AIAcgBEECayINIAIgC2sgCRtqLQAAIAVBCHRyIQUgAkEDSA0AIAcgBEEDayILIAIgDWsgCRtqLQAAIAVBCHRyIQUgAkEDRw0BCyABDQEgBUEBIAJBA3RBAWt0IgFzIAFrIQUMAQsgBUEIdCINIAcgBEEEayACIAtrIAkbai0AAHIhBSACQQRGDQBBACANQR91Qf8BcSABGyEBA0AgASAHIAQgAiAEQX9zaiAJG2otAABHDRAgBEEBaiIEIAJIDQALCyAAKAIMIgFBAzoABCABIAU2AgAgACAAKAIMQQhqNgIMDAYLIAMgCmohAQJ/IAYoAihBAUcEQCABKAAAIgFBGHQgAUGA/gNxQQh0ciABQQh2QYD+A3EgAUEYdnJyDAELIAEoAAALIQEgACgCDCIEQRM6AAQgBCABNgIAIAAgACgCDEEIajYCDAwFCyADIApqIQECfyAGKAIoQQFHBEAgASgAACIBQRh0IAFBgP4DcUEIdHIgAUEIdkGA/gNxIAFBGHZycgwBCyABKAAACyEBIAAoAgwiBEETOgAEIAQgATYCACAAIAAoAgxBCGo2AgwMBAsgAyAKaiEBAnwgBigCKEEBRwRAIAEpAAAiDkI4hiAOQoD+A4NCKIaEIA5CgID8B4NCGIYgDkKAgID4D4NCCIaEhCAOQgiIQoCAgPgPgyAOQhiIQoCA/AeDhCAOQiiIQoD+A4MgDkI4iISEhL8MAQsgASsAAAshDyAAKAIMIgFBEzoABCABIA+2OAIAIAAgACgCDEEIajYCDAwDCyAAIAMgCmogAhCfAQwCCyADIApqIQUCQCACQQBMBEBBACEEDAELIAVBBCACIAJBBE4bIgFBAWsiCSACIAFrIAYoAigiBxtqLQAAIQQCQCACQQFGDQAgBSABQQJrIgsgAiAJayAHG2otAAAgBEEIdHIhBCACQQNIDQAgBSABQQNrIgkgAiALayAHG2otAAAgBEEIdHIhBCACQQNGDQAgBSABQQRrIAIgCWsgBxtqLQAAIARBCHRyIQQgAkEFSQ0AA0AgBSABIAIgAUF/c2ogBxtqLQAADQ0gAUEBaiIBIAJHDQALCyAEIAggAiADamtLDQwLIAAgAiAFaiAEEJ8BIAMgBGohAwwBCyADIApqIgEQJyIEIANqIgMgCE8NCyAAIAEgBBCfASADQQFqIQMLIAwhBQsgAiADaiEDIAYoAiAtAAANAAsgA0EBaiECIAVBAWoFQQELIQEgACgCDCIDQQM6AAQgAyACNgIAIAAgACgCDEEIajYCDCAGQTBqJAAgAQ8LIABBAUH47SoQ1AEACyAAQQJB+O0qENQBAAsgAEEDQbrsKhCGAgALIABBAkGs0CkQhgIACyAGIAI2AgAgAEHimCogBhClAQALIAYgAjYCECAAQeKYKiAGQRBqEKUBAAsgAEECQazQKRCGAgALIABBAkHlgSwQhgIAC4kJAQd/IwBB0ABrIgckAEEBIQMgASABKAIAIgZBAWoiBDYCACAGLQAAIQhBACEGIAJBADYCAEEEIQlBByEFAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAhBIGsOWxYSExMTExMTExMTExMTExMTExMTExMTExMTExMVFRQTExMBExMTExMDDQcTBRMTExMTExMIExMTERMTExMTExMTEwAPCxMJEwIMBhMEEwoTExMTDhMTExMQExcTCyACQQE2AgBBACEFDBYLQQEhBSACQQE2AgAMFQsgAkECNgIAQQAhBQwUCyACQQI2AgBBASEFDBMLIAJBBDYCAEEAIQUMEgsgAkEENgIAQQEhBQwRCyACQQQ2AgBBACEFDBALIAJBBDYCAEEBIQUMDwsgAkEENgIAQQEhBQwOCyACQQQ2AgBBAiEFDA0LIAJBBDYCAEEDIQUMDAsgAkEINgIAQQQhBQwLC0EEIQMgBCwAAEE6a0F2TwRAQQAhAwNAAkAgASAEQQFqIgY2AgAgBCwAACADQQpsakEwayEDIAQsAAFBMGtBCUsNACAGIQQgA0HMmbPmAEgNAQsLIANBEWtBb00NDAsgAiADNgIAQQAhBQwKC0EEIQMgBCwAAEE6a0F2TwRAQQAhAwNAAkAgASAEQQFqIgY2AgAgBCwAACADQQpsakEwayEDIAQsAAFBMGtBCUsNACAGIQQgA0HMmbPmAEgNAQsLIANBEWtBb00NDAsgAiADNgIAQQEhBQwJC0EEIQMgAiAELAAAQTprQXZPBH8DQAJAIAEgBEEBaiIDNgIAIAQsAAAgBkEKbGpBMGshBiAELAABQTBrQQlLDQAgAyEEIAZBzJmz5gBIDQELCyAGQRFrQW9NDQwgBgUgAws2AgBBBiEFDAgLAkAgBCwAAEE6a0F1SwRAQQAhAwNAAkAgASAEQQFqIgY2AgAgBCwAACADQQpsakEwayEDIAQsAAFBMGtBCUsNACAGIQQgA0HMmbPmAEgNAQsLIAIgAzYCACADQX9GDQFBBSEFDAkLIAJBfzYCAAsgACgCAEG9hixBABClAQALIAJBATYCAEEIIQUMBgtBCSEFDAULQQghCSAELAAAQTprQXZJBEBBCCEDDAMLQQAhAwNAAkAgASAEQQFqIgY2AgAgBCwAACADQQpsakEwayEDIAQsAAFBMGtBCUsNACAGIQQgA0HMmbPmAEgNAQsLIANBEWtBb0sNAiAAKAIAIQQgB0EQNgJEIAcgAzYCQCAEQb/ZKyAHQUBrEKUBAAsgACgCACEEIAcgCMA2AgAgBEHghiwgBxClAQALQQAhAwsgACAJaiADNgIAC0EKIQULIAdB0ABqJAAgBQ8LIAAoAgAhBCAHQRA2AhQgByADNgIQIARBv9krIAdBEGoQpQEACyAAKAIAIQQgB0EQNgIkIAcgAzYCICAEQb/ZKyAHQSBqEKUBAAsgACgCACEEIAdBEDYCNCAHIAY2AjAgBEG/2SsgB0EwahClAQAL1gEAAn8CQAJAAkACQAJAAkACQAJAAkACQAJAAkAgARDTAUHhAGsOGgsKAAEKCgIKCgoKAwoKCgQKCgUKBgoHCAoJCgsgABCSCAwLCyAAQTBrQQpJDAoLIABBIWtB3gBJDAkLIABB4QBrQRpJDAgLIABBIWtB3QBNBH8gABB0QQFzBUEACwwHCyAAQSBGIABBCWtBBUlyDAYLIABBwQBrQRpJDAULIAAQdAwECyAAEHgMAwsgAEUMAgsgACABRg8LIABBIHJB4QBrQRpJCyABQfsAa0FmSXMLgQIBBH8gACABTQRAQQAPCyABLQAAIQBBASEFAkACQAJAAkACQCACLQAAIgFBJWsOCgACAgICAgICAgQBCyAAIAItAAEQpQgPCyABQdsARg0BCyAAIAFGIQUMAQsgAkEBaiACIAItAAEiBEHeAEYiBRsiAUEBaiIGIANBAWsiB08NACAEQd4ARyEEA0AgAS0AAiECAkACQCABLQABIgNBJUYEQCAAIAIQpQhFDQEgBA8LAkAgAkEtRw0AIAFBA2oiASAHTw0AIAAgA0kNAiABLQAAIABJDQIgBA8LIAYhASAAIANHDQEgBA8LIAFBAmohAQsgAUEBaiIGIAdJDQALCyAFC/YHAQd/IwBBsAJrIgMkACAAQQFBBRCoCCAAEKEHIQUCfwJAAkAgACgCFCIGKAIAIgFBEGoiAiAAKAIMIgRJBEAgAi0ABEEPcQ0BDAILIAAoAhAtADBBD3FFDQEgACgCEEEsaiECCwJAAkACQCACLQAEQQ9xQQNrDgIAAQILIAAgAhBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiBigCACIBQRBqIgIgACgCDCIESQ0AIAAoAhBBLGohAgsgAigCACIHLQAHIgJB/wFGBEAgBygCDCECCyAHQRBqDAILIABBAkH47SoQ1AEAC0EAIQJBt5MsCyEHAkAgBCABQRhqIgFNBH8gACgCEEEsagUgAQstAARBD3FFBEBBASEEDAELIANBADYCICAEIAYoAgBBGGoiAU0EQCAAKAIQQSxqIQELIAEtAARBA0YEQCABKAIAIQQMAQsgASADQSBqQQAQ/AEhASADKAIgIQQgAQ0AIABBAxD9AQsCQAJAIAAoAhQoAgBBIGoiASAAKAIMSQRAIAEtAARBD3FFDQIgA0EANgIgDAELIAAoAhAtADBBD3FFDQEgA0EANgIgIAAoAhBBLGohAQsgAS0ABEEDRgRAIAEoAgAhBQwBCyABIANBIGpBABD8ASEBIAMoAiAhBSABDQAgAEEEEP0BCyADIAA2AiwgA0KAAjcCJCADIANBMGoiBjYCICAAKAIMIgFBAjoABCABIANBIGo2AgAgACAAKAIMQQhqNgIMAkACQAJAAkAgBCAFSARAA0AgACAEEIcGGiAAKAIMQQRrLQAAQQ9xQQVrQX1NDQQgA0EgahCbByACBEAgA0EgaiACQX8QlwchASACBEAgASAHIAL8CgAACyADIAMoAiggAmo2AigLIARBAWoiBCAFRw0ACwwBCyAEIAVHDQELIAAgBRCHBhogACgCDEEEay0AAEEPcUEFa0F9TQ0CIANBIGoQmwcLIAMoAiwiASADKAIgIAMoAigQnwEgBiADKAIgRwRAIAEgASgCDEEQa0F/QQAQXkEAOgAECyABKAIMIgRBEGshAiAEQQhrIQQDQCACKAIAIQAgAiAEKAIANgIAIAItAAQhBSACIAQtAAQ6AAQgBCAFOgAEIAQgADYCACACQQhqIgIgBEEIayIESQ0ACyABIAEoAgxBCGsiAiABKAIkTQR/IAEgAkF/QQAQXgUgAgs2AgwgA0GwAmokAEEBDwsgAEF/EOABIQIgAyAENgIEIAMgAkECdEH0sS9qKAIANgIAIABBgoMsIAMQpQEACyAAQX8Q4AEhAiADIAU2AhQgAyACQQJ0QfSxL2ooAgA2AhAgAEGCgywgA0EQahClAQALhgUBBH8CQAJAIAAoAhQoAgAgAUEDdGoiAyAAKAIMIgRJBEAgAy0ABEEPcUEFRw0BDAILIAAoAhAtADBBD3FBBUYNASAAKAIQQSxqIQMLAkACfwJAAkACQCADLQAEQQ9xIgVBBWsOAwACAQILIAMoAgBBGGoMAgsgAygCAEEMagwBCyAAKAIQIAVBAnRqQfwBagsoAgAiA0UNACAEQcUAOgAEIAQgAzYCACAAIAAoAgxBCGo2AgxBASEDIAJBAXEEQCAAQZW8KRBYIAAoAgwiA0EQaygCACADQQhrEKABIQMgACAAKAIMIgRBCGsiBTYCDCAEQQRrIAMtAARBD3EEfyAFIAMoAgA2AgAgAy0ABAVBAAs6AAAgACAAKAIMIgVBCGoiBDYCDEECIQMgBS0ABEEPcUUNAQsgAkECcQRAIABBirwpEFggACgCDCIEIANBf3NBA3RqKAIAIARBCGsQoAEhBCAAIAAoAgwiBUEIayIGNgIMIAVBBGsgBC0ABEEPcQR/IAYgBCgCADYCACAELQAEBUEACzoAACAAIAAoAgwiBUEIaiIENgIMIAUtAARBD3FFDQEgA0EBaiEDCyAAIAJBBE8EfyAAQcO8KhBYIAAoAgwiBCADQX9zQQN0aigCACAEQQhrEKABIQQgACAAKAIMIgJBCGsiBTYCDCACQQRrIAQtAARBD3EEfyAFIAQoAgA2AgAgBC0ABAVBAAs6AAAgACAAKAIMIgJBCGoiBDYCDCACLQAEQQ9xRQ0BIANBAWoFIAMLQX9zEKsBDwsgBCAAKAIUKAIAIAFBA3RqIgNNBH8gACgCEEEsagUgAwstAARBD3FBBUYNACAAIAFB7JcrENQBAAsLhgIBBH8jAEEQayIEJAAgAEEBQQcQqAggABChB0EBaiECAkACQAJAAkAgACgCDCIDIAAoAhQoAgAiAWtBCGtBA3VBAmsOAgEAAwsgBEEANgIMIAMgAUEQaiIBTQRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEDDAELIAEgBEEMakEAEPwBIQEgBCgCDCEDIAENACAAQQIQ/QELIANBAWsgAk8NASACIANKBEADQCAAIAJBAWsiARCHBhogAEEBIAIQiwYgASECIAEgA0oNAAsLIAMhAgsgAEEBIAIQiwYgBEEQaiQAQQAPCyAAQQJBxYMqEIYCAAsgAEGcgixBABClAQAL4AIBB38gACAAQQxqIgEoAgAgAEEUaiIDKAIAKAIAa0EIa0EDdSIFQQEQoQEgASgCACIEQQhrIQIgAygCACgCAEEIaiIBIARBEGsiA0kEQCABIQQDQCAEKAIAIQYgBCADKAIANgIAIAQtAAQhByAEIAMtAAQ6AAQgAyAHOgAEIAMgBjYCACAEQQhqIgQgA0EIayIDSQ0ACwsgASACSQRAA0AgASgCACEDIAEgAigCADYCACABLQAEIQQgASACLQAEOgAEIAIgBDoABCACIAM2AgAgAUEIaiIBIAJBCGsiAkkNAAsLIAVBAEoEQCAFIQEDQCAAQQEgARCLBiABQQFLIQIgAUEBayEBIAINAAsLIABBDGoiASgCACICQQM6AAQgAiAFNgIAIAEgASgCACICQQhqNgIAIAACfyACIAAoAhQoAgAiAUsEQCABQQhqDAELIAAoAhBBLGoLQaDBKhBZQQELwQQBCX8jAEEQayIDJAACQAJAAkACQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xDQFBASEBDAQLIAAoAhAtADBBD3ENAUEBIQEMAwsgA0EANgIIDAELIANBADYCCCAAKAIQQSxqIQELIAEtAARBA0YEQCABKAIAIQEMAQsgASADQQhqQQAQ/AEhAiADKAIIIQEgAg0AIABBAhD9AQsCQAJAAkACQCAAKAIUKAIAQRhqIgIgACgCDEkEQCACLQAEQQ9xRQ0BIANBADYCDAwDCyAAKAIQLQAwQQ9xDQELIAAQoQchAgwCCyADQQA2AgwgACgCEEEsaiECCyACLQAEQQNGBEAgAigCACECDAELIAIgA0EMakEAEPwBIQUgAygCDCECIAUNACAAQQMQ/QELQQAhBQJAIAEgAkwEQCACIAFrIgZB/v///wdLDQEgACgCFCEIIAZBAWoiBSAAKAIYIgcgACgCDCIEa0EDdU4EQCAHIAAoAhwiCWsiB0GAtIkTSg0CAkAgBkG+lrECTARAIAQgCWtBA3UgBWoiBEHBlrECSA0BCyAAQYiYsQJBABCrBhoMAwsgAEHAlrECIAdBAnUiBiAGQcCWsQJOGyIGIAQgBCAGSBtBABCrBkUNAiAAKAIMIQQLIAQgBUEDdGoiBCAIKAIESwRAIAggBDYCBAsgASACSARAA0AgACABEIcGGiABQQFqIgEgAkcNAAsLIAAgAhCHBhoLIANBEGokACAFDwsgAEHq2SpBABClAQALswIBBH8jAEEQayIDJAAgAEEBQQcQqAggABChByECAkACQAJAAkACQCAAKAIUKAIAQRBqIgEgACgCDEkEQCABLQAEQQ9xRQ0BIANBADYCDAwDCyAAKAIQLQAwQQ9xDQELIAAgAhCHBhoMAgsgA0EANgIMIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEBDAELIAEgA0EMakEAEPwBIQQgAygCDCEBIAQNACAAQQIQ/QELIAEgAkcgAUEBayACS3ENASAAIAEQhwYaIAEgAk4EQCABIQIMAQsDQCAAIAFBAWoiBBCHBhogAEEBIAEQiwYgBCIBIAJHDQALCyAAKAIMQQA6AAQgACAAKAIMQQhqNgIMIABBASACEIsGIANBEGokAEEBDwsgAEECQcWDKhCGAgAL+AUBCX8jAEEQayIEJAAgBEEANgIEIAAoAhQoAgBBEGoiASAAKAIMTwRAIAAoAhBBLGohAQsCQCABLQAEQQNGBEAgASgCACEDDAELIAEgBEEEakEAEPwBIQEgBCgCBCEDIAENACAAQQIQ/QELIARBADYCCCAAKAIUKAIAQRhqIgEgACgCDE8EQCAAKAIQQSxqIQELAkAgAS0ABEEDRgRAIAEoAgAhAQwBCyABIARBCGpBABD8ASECIAQoAgghASACDQAgAEEDEP0BCyAEQQA2AgwgACgCFCgCAEEgaiICIAAoAgxPBEAgACgCEEEsaiECCwJAIAItAARBA0YEQCACKAIAIQIMAQsgAiAEQQxqQQAQ/AEhBSAEKAIMIQIgBQ0AIABBBBD9AQsgACgCFCgCAEEoaiIFIAAoAgxPBH8gACgCEEEsagUgBQstAAQhBSAAQQFBARCoCCAAQQVBASAFQQ9xIgYbIgVBAhCoCAJAAkACQCABIANIDQAgA0EATCABIANB/////wdqTnENASACIAEgA2siCEH/////B3NKDQICQAJAIAEgAkgNACACIANMDQAgBkUNASAAKAIUKAIAIgdBCGoiBiAAKAIMIglPBEAgACgCEEEsaiEGCyAJIAdBKGoiB00EQCAAKAIQQSxqIQcLIAYtAARBD3FFBEAgBiAAKAIQQSxqRg0BCyAHLQAEQQ9xRQRAIAcgACgCEEEsakYNAQsgACAGIAcQ/AUNAQsgASADa0EBaiEIQQAhAQNAIAAgASADahCHBhogACAFIAEgAmoQiwYgAUEBaiIBIAhHDQALDAELA0AgACAIIgEgA2oQhwYaIAAgBSABIAJqEIsGIAFBAWshCCABDQALCyAAKAIUKAIAIAVBA3RqIgEgACgCDCIDTwRAIAAoAhBBLGohAQsgAyABKAIANgIAIAMgAS0ABDoABCAAIAAoAgxBCGo2AgwgBEEQaiQAQQEPCyAAQQNB5vkqEIYCAAsgAEEEQfGqKxCGAgALpQEBAn8gAEEBQQcQqAgCQAJAIAAQoQciAkECTgRAIAJB/////wdGDQECQAJAIAAoAhQoAgBBEGoiASAAKAIMSQRAIAEtAARBD3ENAQwCCyAAKAIQLQAwQQ9xRQ0BIAAoAhBBLGohAQsgAS0ABEEPcUEGRw0DCyAAQQIQqwEgAEEBIAJBABCvCAtBAA8LIABBAUG98CoQhgIACyAAQQJBtrAqENQBAAuUBgIFfwF+AkACQAJAIAEgAk8NAANAIAAgARCHBhogACACEIcGGgJAIABBf0F+ELAIBEAgAEEBIAEQiwYgAEEBIAIQiwYMAQsgACAAKAIMQRBrIgQgACgCJE0EfyAAIARBf0EAEF4FIAQLNgIMCyACIAFrIgVBAUYNASAAIAVB5ABPQQAgAxsEfyAFQQJ2IgQgAWogAyAEQQF0cGoFIAEgAmpBAXYLIgQQhwYaIAAgARCHBhoCQCAAQX5BfxCwCARAIABBASAEEIsGIABBASABEIsGDAELIAAgACgCDEEIayIGIAAoAiRNBH8gACAGQX9BABBeBSAGCzYCDCAAIAIQhwYaIABBf0F+ELAIBEAgAEEBIAQQiwYgAEEBIAIQiwYMAQsgACAAKAIMQRBrIgYgACgCJE0EfyAAIAZBf0EAEF4FIAYLNgIMCyAFQQJGDQEgACAEEIcGGiAAKAIMIgUgBUEIaygCADYCACAFIAVBBGstAAA6AAQgACAAKAIMQQhqNgIMIAAgAkEBayIIEIcGGiAIIQUgASEGA0AgAEEBIAQQiwYgAEEBIAUQiwYgBiEHA0ACQCAAIAdBAWoiBBCHBhogAEF/QX4QsAhFDQAgBCAIRg0FIAAgACgCDEEIayIGIAAoAiRNBH8gACAGQX9BABBeBSAGCzYCDCAEIQcMAQsLA0ACQCAAIAVBAWsiBRCHBhogAEF9QX8QsAhFDQAgBCAFSw0GIAAgACgCDEEIayIGIAAoAiRNBH8gACAGQX9BABBeBSAGCzYCDAwBCwsgBCEGIAQgBU0NAAsgACAAKAIMQQhrIgUgACgCJE0EfyAAIAVBf0EAEF4FIAULNgIMIABBASAIEIsGIABBASAEEIsGAkAgBCABayIFIAIgBGsiBEkEQCAAIAEgByADEK8IIAdBAmohAQwBCyAAIAdBAmogAiADEK8IIAchAiAEIQULIAUgAiABa0EHdkkEQBD5BxB5IgmnaiAJQiCIp2ohAwsgASACSQ0ACwsPCyAAQY7qKkEAEKUBAAsgAEGO6ipBABClAQALswIBBH8gACgCFCgCAEEQaiIDIQQgAyAAKAIMIgVJIgZFBEAgACgCEEEsaiEECwJAIAQtAARBD3ENACAEIAAoAhBBLGpGDQAgACABIAIQ+wUPCyAGRQRAIAAoAhBBLGohAwsgBSADKAIANgIAIAUgAy0ABDoABCAAIAAoAgwiA0EIajYCDCADIAMgAUEDdGoiBCgCADYCCCADIAQtAAQ6AAwgACAAKAIMIgNBCGoiBDYCDCADIAQgAkEDdGoiBEEQaygCADYCCCADIARBDGstAAA6AAwgACAAKAIMIgNBCGo2AgwgACADQRBrQQEQkQYgACgCDCIDQQRrLQAAIgRBAUchBSAEQQ9xQQBHIQQgACADQQhrIgMgACgCJE0EfyAAIANBf0EAEF4FIAMLNgIMIAQgBXELnAYBB38jAEEQayIFJAAgACgCFCICKAIAQQhqIgEgACgCDCIETwRAIAAoAhBBLGohAQsCQAJAAkACQAJAIAEtAARBD3FBA2sOAgABAgsgACABEFMgACgCECgCDEEASgRAIAAQVAsgACgCFCICKAIAQQhqIgEgACgCDCIESQ0AIAAoAhBBLGohAQsgASgCACIHLQAHIgZB/wFGBEAgBygCDCEGCyAFQQA2AgggBCACKAIAQRBqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQMMAQsgASAFQQhqQQAQ/AEhASAFKAIIIQMgAQ0AIABBAhD9AQtBASAGQQFqIANBAE4bIQECQAJAIAAoAhQoAgBBGGoiAiAAKAIMSQRAIAItAARBD3FFDQIgBUEANgIMDAELIAAoAhAtADBBD3FFDQEgBUEANgIMIAAoAhBBLGohAgsgAi0ABEEDRgRAIAIoAgAhAQwBCyACIAVBDGpBABD8ASECIAUoAgwhASACDQAgAEEDEP0BCyABQQBIBEAgBkEAIAFrSQ0CIAEgBmpBAWohAQsgAUEATA0BIAFBAWsiBCAGSg0BIAdBEGohAiAEIAEgAUEAShshAQJ/AkACQCADRQRAIAFBAEwNAQNAIAEgAmosAABBv39KDQIgAUEBSiEEIAFBAWshASAEDQALQQAhAQwBCyABIAJqLAAAQb9/TA0FAkACQCADQQBOBEAgA0EBayEEIANBAUYEQCAEIQMMAwsgASAGSA0BIAQhAwwCCyABQQBMDQMDQCABQQFNBEAgA0EBaiEDQQAhAQwDCyACIAFBAWsiAWosAABBQEgNACADQQFqIgMNAAsMAgsDQCACIAFBAWoiAWosAABBQEgNACAEQQFrIQMgBEECSQ0BIAMhBCABIAZIDQALCyADDQELIAAoAgwiAiABQQFqNgIAQQMMAQsgACgCDCECQQALIQEgAiABOgAEIAAgACgCDEEIajYCDCAFQRBqJABBAQ8LIABBAUH47SoQ1AEACyAAQQNBxYMqEIYCAAsgAEHj/SpBABClAQALxgcBCX8jAEEQayIGJAAgACgCFCIFKAIAIgNBCGoiASAAKAIMIgJPBEAgACgCEEEsaiEBCwJAAkACQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQiBSgCACIDQQhqIgEgACgCDCICSQ0AIAAoAhBBLGohAQsgASgCACIHLQAHIgRB/wFGBEAgBygCDCEECwJ/QQEgAiADQRBqIgFNBH8gACgCEEEsagUgAQstAARBD3FFDQAaIAZBADYCCCACIAUoAgBBEGoiAU0EQCAAKAIQQSxqIQELAkAgAS0ABEEDRgRAIAEoAgAhAgwBCyABIAZBCGpBABD8ASEBIAYoAgghAiABDQAgAEECEP0BCyACIAJBAE4NABpBACAEQQAgAmtJDQAaIAIgBGpBAWoLIQECQAJAIAAoAhQoAgBBGGoiAiAAKAIMSQRAIAEhAyACLQAEQQ9xRQ0CIAZBADYCDAwBCyABIQMgACgCEC0AMEEPcUUNASAGQQA2AgwgACgCEEEsaiECCyACLQAEQQNGBEAgAigCACEDDAELIAIgBkEMakEAEPwBIQIgBigCDCEDIAINACAAQQMQ/QELAn8gAyADQQBODQAaQQAgBEEAIANrSQ0AGiADIARqQQFqCyECIAAoAhQoAgBBIGoiAyAAKAIMTwRAIAAoAhBBLGohAwsgAUEATA0BIAIgBEoNAgJAIAEgAkoNACACIAFrIgRB/////wdGBEBB5OkqIQQMBQsgAy0ABCEDIAAgBEEBakHk6SoQngcgB0EQaiIEIAFqQQFrIgUgAiAEaiIHTw0AIANBD3FFIANBAUZyIQkDQCAFLAAAIgJB/wFxIQEgAkEASARAQQAhAkEAIQMgAUHAAHEEQANAIAUgAkEBaiICai0AACIEQcABcUGAAUcEQEHXoishBAwJCyAEQT9xIANBBnRyIQMgAUEgcSEEIAFBAXQhASAEDQALC0HXoishBCACQQVLDQYgAUE/cSACQQVsdCADciIBQQBIDQYgASACQQJ0QeDAL2ooAgBJIgMNBiAFQQAgAiADG2ohBQsgCQRAQdeiKyEEIAFB///DAEsNBiABQYDw/wBxQYCwA0YNBgsgACgCDCICQQM6AAQgAiABNgIAIAAgACgCDEEIajYCDCAIQQFqIQggBUEBaiIFIAdJDQALCyAGQRBqJAAgCA8LIABBAUH47SoQ1AEACyAAQQJBzoMqEIYCAAsgAEEDQc6DKhCGAgALIAAgBEEAEKUBAAuYBAEGfyMAQbACayIDJAACQAJAAkAgAEEMaiIEKAIAIgIgACgCFCgCAEEIaiIBayIFQQhGBEAgA0EANgIgIAEgAk8EQCAAKAIQQSxqIQELAkAgAS0ABEEDRgRAIAEoAgAhAQwBCyABIANBIGpBABD8ASECIAMoAiAhASACDQAgAEEBEP0BCyABQQBIDQIgAyABNgIAIABBpdsrIAMQpgEaDAELIANCgAI3AiQgAyADQTBqIgY2AiAgAyAANgIsIAJBAjoABCACIANBIGo2AgAgBCAEKAIAQQhqNgIAQQEhAQJ/IAVBA3UiBEEATARAQQAhASAGDAELA0AgACABEKAHIgJBAEgNBCADIAI2AhAgAEGl2ysgA0EQahCmARogASAERyECIANBIGoQmwcgAUEBaiEBIAINAAsgAygCKCEBIAMoAiwhACADKAIgCyECIAAgAiABEJ8BIAYgAygCIEcEQCAAIAAoAgxBEGtBf0EAEF5BADoABAsgACgCDCICQRBrIQEgAkEIayECA0AgASgCACEEIAEgAigCADYCACABLQAEIQUgASACLQAEOgAEIAIgBToABCACIAQ2AgAgAUEIaiIBIAJBCGsiAkkNAAsgACAAKAIMQQhrIgEgACgCJE0EfyAAIAFBf0EAEF4FIAELNgIMCyADQbACaiQAQQEPCyAAQQFBx5wrEIYCAAsgACABQcecKxCGAgAL0QcBC38jAEEQayIFJAAgACgCFCIGKAIAIgdBCGoiASAAKAIMIgJPBEAgACgCEEEsaiEBCwJAAkACQAJAAkAgAS0ABEEPcUEDaw4CAAECCyAAIAEQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgYoAgAiB0EIaiIBIAAoAgwiAkkNACAAKAIQQSxqIQELIAEoAgAiCC0AByIDQf8BRgRAIAgoAgwhAwsCf0EBIAIgB0EQaiIBTQR/IAAoAhBBLGoFIAELLQAEQQ9xRQ0AGiAFQQA2AgggAiAGKAIAQRBqIgFNBEAgACgCEEEsaiEBCwJAIAEtAARBA0YEQCABKAIAIQIMAQsgASAFQQhqQQAQ/AEhASAFKAIIIQIgAQ0AIABBAhD9AQsgAiACQQBODQAaQQAgA0EAIAJrSQ0AGiACIANqQQFqCyEBAkACQAJAAkACQCAAKAIUKAIAQRhqIgIgACgCDEkEQCACLQAEQQ9xDQFBfyEEDAQLIAAoAhAtADBBD3ENAUF/IQQMAwsgBUEANgIMDAELIAVBADYCDCAAKAIQQSxqIQILAkAgAi0ABEEDRgRAIAIoAgAhBAwBCyACIAVBDGpBABD8ASECIAUoAgwhBCACDQAgAEEDEP0BCyAEQQBODQELIAQhAkEAIQQgA0EAIAJrSQ0AIAIgA2pBAWohBAsgACgCFCgCAEEgaiICIAAoAgxPBEAgACgCEEEsaiECCyABQQBMDQEgAUEBayIHIANKDQEgAyAESA0CAkAgBCAHIAEgAUEAShsiCUwEQEEBIQFBACEIDAELIAhBEGohCiACLQAEIgFBAUYgAUEPcUVyIQtBACEIA0AgCSAKaiIGLAAAIgNB/wFxIQECQAJAIANBAEgEQEEAIQNBACECIAFBwABxBEADQCAGIANBAWoiA2otAAAiB0HAAXFBgAFHDQMgB0E/cSACQQZ0ciECIAFBIHEhByABQQF0IQEgBw0ACwsgA0EFSw0BIAFBP3EgA0EFbHQgAnIiAUEASA0BIAEgA0ECdEHgwC9qKAIASSICDQEgBkEAIAMgAhtqIQYLIAtFDQEgAUH//8MASw0AIAFBgPD/AHFBgLADRw0BCyAAKAIMQQA6AAQgACAAKAIMQQhqNgIMIAlBAWohCEECIQEMAgtBASEBIAhBAWohCCAGIAprQQFqIgkgBEgNAAsLIAAoAgwiA0EDOgAEIAMgCDYCACAAIAAoAgxBCGo2AgwgBUEQaiQAIAEPCyAAQQFB+O0qENQBAAsgAEECQb2DKhCGAgALIABBA0GggyoQhgIAC9ICAQN/IAAoAhQoAgAiAUEQaiICIAAoAgwiA08EfyAAKAIQQSxqBSACCy0ABCECIAMgAUEIaiIBTQRAIAAoAhBBLGohAQsCQAJAAkACQCABLQAEQQ9xQQNrDgIAAQILIAAgARBTIAAoAhAoAgxBAEoEQCAAEFQLIAAoAhQoAgBBCGoiASAAKAIMSQ0AIAAoAhBBLGohAQsgASgCACwAEEG/f0wNASAAKAIMIgFBFjoABCABQTJBMyACQQ9xRSACQQFGchs2AgAgACAAKAIMIgFBCGo2AgwgAQJ/IAEgACgCFCgCACICSwRAIAJBCGoMAQsgACgCEEEsagsiAigCADYCCCABIAItAAQ6AAwgACAAKAIMIgFBCGo2AgwgAUEDOgAMIAFBADYCCCAAIAAoAgxBCGo2AgxBAw8LIABBAUH47SoQ1AEACyAAQQFB16IrEIYCAAsJACAAQQEQuAgLCQAgAEEAELgIC98EAQd/IwBBEGsiCCQAIAAoAhQiAygCAEEIaiICIAAoAgwiBE8EQCAAKAIQQSxqIQILAkACQAJAAkAgAi0ABEEPcUEDaw4CAAECCyAAIAIQUyAAKAIQKAIMQQBKBEAgABBUCyAAKAIUIgMoAgBBCGoiAiAAKAIMIgRJDQAgACgCEEEsaiECCyACKAIAIgYtAAciBUH/AUYEQCAGKAIMIQULIAhBADYCDCAEIAMoAgBBEGoiAk0EQCAAKAIQQSxqIQILIAItAARBA0cEQCACIAhBDGpBABD8ARogCEEMaiECCyAGQRBqIQQCQCAFIAIoAgAiA00EQCADIQIMAQsDQCADIgJBAWohAyACIARqLAAAQUBIDQALC0EAIQMgAiAFSQRAIAIgBGoiBywAACIEQf8BcSEDIARBAEgEQEEAIQQCQCADQcAAcUUEQEEAIQUMAQtBACEFA0AgByAEQQFqIgRqLQAAIgZBwAFxQYABRw0FIAZBP3EgBUEGdHIhBSADQSBxIQYgA0EBdCEDIAYNAAsLIARBBUsNAyADQT9xIARBBWx0IAVyIgNBAEgNAyADIARBAnRB4MAvaigCAEkiBQ0DIAdBACAEIAUbaiEHCyABBEAgA0H//8MASw0DIANBgPD/AHFBgLADRg0DCyAHLAABQb9/TA0CIAAoAgwiBEEDOgAEIAQgAkEBajYCACAAIAAoAgwiAkEIajYCDCACQQM6AAwgAiADNgIIIAAgACgCDEEIajYCDEECIQMLIAhBEGokACADDwsgAEEBQfjtKhDUAQALIABB16IrQQAQpQEAC9kCAQF/IABBACACayICIAAoAgAiAyABKAIAc3EgA3M2AgAgACAAKAIEIgMgASgCBHMgAnEgA3M2AgQgACAAKAIIIgMgASgCCHMgAnEgA3M2AgggACAAKAIMIgMgASgCDHMgAnEgA3M2AgwgACAAKAIQIgMgASgCEHMgAnEgA3M2AhAgACAAKAIUIgMgASgCFHMgAnEgA3M2AhQgACAAKAIYIgMgASgCGHMgAnEgA3M2AhggACAAKAIcIgMgASgCHHMgAnEgA3M2AhwgACAAKAIgIgMgASgCIHMgAnEgA3M2AiAgACAAKAIkIgMgASgCJHMgAnEgA3M2AiQgACAAKAIoIgMgASgCKHMgAnEgA3M2AiggACAAKAIsIgMgASgCLHMgAnEgA3M2AiwgACAAKAIwIgMgASgCMHMgAnEgA3M2AjAgACABKAI0IAAoAjQiAXMgAnEgAXM2AjQLqQUBAX8gAEEAIAJrIgIgACgCACIDIAEoAgBzcSADczYCACAAIAAoAgQiAyABKAIEcyACcSADczYCBCAAIAAoAggiAyABKAIIcyACcSADczYCCCAAIAAoAgwiAyABKAIMcyACcSADczYCDCAAIAAoAhAiAyABKAIQcyACcSADczYCECAAIAAoAhQiAyABKAIUcyACcSADczYCFCAAIAAoAhgiAyABKAIYcyACcSADczYCGCAAIAAoAhwiAyABKAIccyACcSADczYCHCAAIAAoAiAiAyABKAIgcyACcSADczYCICAAIAAoAiQiAyABKAIkcyACcSADczYCJCAAIAAoAigiAyABKAIocyACcSADczYCKCAAIAAoAiwiAyABKAIscyACcSADczYCLCAAIAAoAjAiAyABKAIwcyACcSADczYCMCAAIAAoAjQiAyABKAI0cyACcSADczYCNCAAIAAoAjgiAyABKAI4cyACcSADczYCOCAAIAAoAjwiAyABKAI8cyACcSADczYCPCAAIAAoAkAiAyABKAJAcyACcSADczYCQCAAIAAoAkQiAyABKAJEcyACcSADczYCRCAAIAAoAkgiAyABKAJIcyACcSADczYCSCAAIAAoAkwiAyABKAJMcyACcSADczYCTCAAIAAoAlAiAyABKAJQcyACcSADczYCUCAAIAAoAlQiAyABKAJUcyACcSADczYCVCAAIAAoAlgiAyABKAJYcyACcSADczYCWCAAIAAoAlwiAyABKAJccyACcSADczYCXCAAIAAoAmAiAyABKAJgcyACcSADczYCYCAAIAAoAmQiAyABKAJkcyACcSADczYCZCAAIAAoAmgiAyABKAJocyACcSADczYCaCAAIAEoAmwgACgCbCIBcyACcSABczYCbAuBBwECfyABIAEoAgAiA0H/////AXE2AgAgASABKAIEIANBHXVqIgNB/////wFxNgIEIAEgASgCCCADQR11aiIDQf////8BcTYCCCABIAEoAgwgA0EddWoiA0H/////AXE2AgwgASABKAIQIANBHXVqIgNB/////wFxNgIQIAEgASgCFCADQR11aiIDQf////8BcTYCFCABIAEoAhggA0EddWoiA0H/////AXE2AhggASABKAIcIANBHXVqIgNB/////wFxNgIcIAEgASgCICADQR11aiIDQf////8BcTYCICABIAEoAiQgA0EddWoiA0H/////AXE2AiQgASABKAIoIANBHXVqIgNB/////wFxNgIoIAEgASgCLCADQR11aiIDQf////8BcTYCLCABIAEoAjAgA0EddWoiA0H/////AXE2AjAgASABKAI0IANBHXVqNgI0IAIgAigCACIDQf////8BcSIENgIAIAIgAigCBCADQR11aiIDQf////8BcTYCBCACIAIoAgggA0EddWoiA0H/////AXE2AgggAiACKAIMIANBHXVqIgNB/////wFxNgIMIAIgAigCECADQR11aiIDQf////8BcTYCECACIAIoAhQgA0EddWoiA0H/////AXE2AhQgAiACKAIYIANBHXVqIgNB/////wFxNgIYIAIgAigCHCADQR11aiIDQf////8BcTYCHCACIAIoAiAgA0EddWoiA0H/////AXE2AiAgAiACKAIkIANBHXVqIgNB/////wFxNgIkIAIgAigCKCADQR11aiIDQf////8BcTYCKCACIAIoAiwgA0EddWoiA0H/////AXE2AiwgAiACKAIwIANBHXVqIgNB/////wFxNgIwIAIgAigCNCADQR11ajYCNCAAIAQgASgCAHI2AgAgACACKAIEIAEoAgRyNgIEIAAgAigCCCABKAIIcjYCCCAAIAIoAgwgASgCDHI2AgwgACACKAIQIAEoAhByNgIQIAAgAigCFCABKAIUcjYCFCAAIAIoAhggASgCGHI2AhggACACKAIcIAEoAhxyNgIcIAAgAigCICABKAIgcjYCICAAIAIoAiQgASgCJHI2AiQgACACKAIoIAEoAihyNgIoIAAgAigCLCABKAIscjYCLCAAIAIoAjAgASgCMHI2AjAgACACKAI0IAEoAjRyNgI0C6sEAgF/AXsjAEHwAmsiAyQAAkAgASgCOCACbEH///8PTARAIAAgASACEMgDIAAgASgCOCACbDYCOAwBCyAD/QwAAAAAAAAAAAAAAAAAAAAA/QsCVCADIAT9CwJkIANBADYCdCADIAI2AkAgAyAE/QsCRCADQqvUmfXBATcDsAEgA0K8uf7o8M+tvAI3A6gBIANCmcfZ2fHo26kcNwOgASADQtvLw4uRtonHCDcDmAEgA0LS2bjzoLWTtBE3A5ABIANC6Kf2lrDkmJEJNwOIASADQq7v+63hofOYEDcDgAEgA0HAAWogA0FAayADQYABahDTAiADQqO9xIDQATcD4AIgA0Lt05uWwabz/xI3A9gCIANCy+6Ru+Gsl40SNwPQAiADQsO59teglJzPEDcDyAIgA0Lqg4n7gOueqAk3A8ACIANC7v//p6Gs//8XNwO4AiADQqvV/v/x///7DzcDsAIgA0EEaiADQbACaiADQcABahDJAiADQQI2AjwgASgCOEGAgIAITgRAIAEQ0gILIANBwAFqIAEgA0EEahDTAiADQqO9xIDQATcD4AIgA0Lt05uWwabz/xI3A9gCIANCy+6Ru+Gsl40SNwPQAiADQsO59teglJzPEDcDyAIgA0Lqg4n7gOueqAk3A8ACIANC7v//p6Gs//8XNwO4AiADQqvV/v/x///7DzcDsAIgACADQbACaiADQcABahDJAiAAQQI2AjgLIANB8AJqJAALuwcBEn8jAEFAaiIDJAAgA0Gr1f7/ASACKAI4QQFrIgRBAXYgBHIiBEECdiAEciIEQQR2IARyIgRBCHYgBHIiBEEQdiAEcmkiBHRB/////wFxIAIoAgBrIgY2AgQgA0H//9//ACAEdEH/////AXFBq9X+/wFBHSAEayIFdnIgAigCBGsiBzYCCCADQe7//6cBIAR0Qf7///8BcUH//9//ACAFdnIgAigCCGsiCDYCDCADQeL6/78BIAR0Qf7///8BcUHu//+nASAFdnIgAigCDGsiCTYCECADQeqDifsAIAR0Qf7///8BcUHi+v+/ASAFdnIgAigCEGsiCjYCFCADQdj2wcoAIAR0Qfj///8BcUHqg4n7ACAFdnIgAigCFGsiCzYCGCADQcO59tcAIAR0Qf////8BcUHY9sHKACAFdnIgAigCGGsiDDYCHCADQaLh+YQBIAR0Qf7///8BcUHDufbXACAFdnIgAigCHGsiDTYCICADQcvukbsBIAR0Qf////8BcUGi4fmEASAFdnIgAigCIGsiDjYCJCADQea66ZABIAR0Qf7///8BcUHL7pG7ASAFdnIgAigCJGsiDzYCKCADQe3Tm5YBIAR0Qf////8BcUHmuumQASAFdnIgAigCKGsiEDYCLCADQbSa/5cBIAR0Qfz///8BcUHt05uWASAFdnIgAigCLGsiETYCMCADQaO9xAAgBHRB/////wFxQbSa/5cBIAV2ciACKAIwayISNgI0IAIoAjQhEyADQQEgBHQiFEEBaiICNgI8IANBDSAEdEGjvcQAIAV2ciATayIENgI4IBRB////D04EQCADQQRqENICIAMoAjghBCADKAI0IRIgAygCMCERIAMoAiwhECADKAIoIQ8gAygCJCEOIAMoAiAhDSADKAIcIQwgAygCGCELIAMoAhQhCiADKAIQIQkgAygCDCEIIAMoAgghByADKAIEIQYgAygCPCECCyAAIAYgASgCAGo2AgAgACAHIAEoAgRqNgIEIAAgCCABKAIIajYCCCAAIAkgASgCDGo2AgwgACAKIAEoAhBqNgIQIAAgCyABKAIUajYCFCAAIAwgASgCGGo2AhggACANIAEoAhxqNgIcIAAgDiABKAIgajYCICAAIA8gASgCJGo2AiQgACAQIAEoAihqNgIoIAAgESABKAIsajYCLCAAIBIgASgCMGo2AjAgACAEIAEoAjRqNgI0IAAgAiABKAI4aiICNgI4IAJBgICAEE4EQCAAENICCyADQUBrJAALiwcBDn8gACABKAIAIgI2AgAgACABKAIEIgM2AgQgACABKAIIIgQ2AgggACABKAIMIgU2AgwgACABKAIQIgY2AhAgACABKAIUIgc2AhQgACABKAIYIgg2AhggACABKAIcIgk2AhwgACABKAIgIgo2AiAgACABKAIkIgs2AiQgACABKAIoIgw2AiggACABKAIsIg02AiwgACABKAIwIg42AjAgACABKAI0Ig82AjQgACABKAI4NgI4IAEtAABBAXEEQCAAIAhBw7n21wBqIgg2AhggACAHQdj2wcoAaiIHNgIUIAAgBkHqg4n7AGoiBjYCECAAIAVB4vr/vwFqIgU2AgwgACAEQe7//6cBaiIENgIIIAAgA0H//9//AGoiAzYCBCAAIAJBq9X+/wFqIgE2AgAgAyABQR11aiICQf////8BcSEDIAQgAkEddWoiAkH/////AXEhBCAFIAJBHXVqIgJB/////wFxIQUgBiACQR11aiICQf////8BcSEGIAcgAkEddWoiAkH/////AXEhByAIIAJBHXVqIgJB/////wFxIQggCSACQR11akGi4fmEAWoiAkH/////AXEhCSAKIAJBHXVqQcvukbsBaiICQf////8BcSEKIAsgAkEddWpB5rrpkAFqIgJB/////wFxIQsgDCACQR11akHt05uWAWoiAkH/////AXEhDCANIAJBHXVqQbSa/5cBaiICQf////8BcSENIA4gAkEddWpBo73EAGoiAkH/////AXEhDiAPIAJBHXVqQQ1qIQ8gAUH/////AXEhAgsgACAPQQF1NgI0IAAgD0EcdEGAgICAAXEgDkEBdXI2AjAgACAOQRx0QYCAgIABcSANQQF1cjYCLCAAIA1BHHRBgICAgAFxIAxBAXVyNgIoIAAgDEEcdEGAgICAAXEgC0EBdXI2AiQgACALQRx0QYCAgIABcSAKQQF1cjYCICAAIApBHHRBgICAgAFxIAlBAXVyNgIcIAAgCUEcdEGAgICAAXEgCEEBdXI2AhggACAIQRx0QYCAgIABcSAHQQF1cjYCFCAAIAdBHHRBgICAgAFxIAZBAXVyNgIQIAAgBkEcdEGAgICAAXEgBUEBdXI2AgwgACAFQRx0QYCAgIABcSAEQQF1cjYCCCAAIARBHHRBgICAgAFxIANBAXVyNgIEIAAgA0EcdEGAgICAAXEgAkEBdXI2AgALnB8DH38BfgF7IwBBoAtrIgMkACABIAEoAgAiBEH/////AXE2AgAgASABKAIEIARBHXVqIgRB/////wFxNgIEIAEgASgCCCAEQR11aiIEQf////8BcTYCCCABIAEoAgwgBEEddWoiBEH/////AXE2AgwgASABKAIQIARBHXVqIgRB/////wFxNgIQIAEgASgCFCAEQR11aiIEQf////8BcTYCFCABIAEoAhggBEEddWoiBEH/////AXE2AhggASABKAIcIARBHXVqIgRB/////wFxNgIcIAEgASgCICAEQR11aiIEQf////8BcTYCICABIAEoAiQgBEEddWoiBEH/////AXE2AiQgASABKAIoIARBHXVqIgRB/////wFxNgIoIAEgASgCLCAEQR11aiIEQf////8BcTYCLCABIAEoAjAgBEEddWoiBEH/////AXE2AjAgASABKAI0IARBHXVqNgI0IAIgAigCACIFQf////8BcSIENgIAIAIgAigCBCAFQR11aiIFQf////8BcSIGNgIEIAIgAigCCCAFQR11aiIFQf////8BcSIHNgIIIAIgAigCDCAFQR11aiIFQf////8BcSIINgIMIAIgAigCECAFQR11aiIFQf////8BcSIJNgIQIAIgAigCFCAFQR11aiIFQf////8BcSIKNgIUIAIgAigCGCAFQR11aiIFQf////8BcSILNgIYIAIgAigCHCAFQR11aiIFQf////8BcSIMNgIcIAIgAigCICAFQR11aiIFQf////8BcSINNgIgIAIgAigCJCAFQR11aiIFQf////8BcSIONgIkIAIgAigCKCAFQR11aiIFQf////8BcSIPNgIoIAIgAigCLCAFQR11aiIFQf////8BcSIQNgIsIAIgAigCMCAFQR11aiIFQf////8BcSIRNgIwIAIgAigCNCAFQR11aiIFNgI0IAMgBTYCNCADIBE2AjAgAyAQNgIsIAMgDzYCKCADIA42AiQgAyANNgIgIAMgDDYCHCADIAs2AhggAyAKNgIUIAMgCTYCECADIAg2AgwgAyAHNgIIIAMgBjYCBCADIAQ2AgAgAxCwAyITQQNqQQRtIRIgE0F6TgRAQQAhAiASQQAgEkEAShshIANAIANBgAhqIAJqIARBD3E6AAAgBUEZdCEUIBFBGXQhFSAQQRl0IRYgD0EZdCEXIA5BGXQhGCANQRl0IRkgDEEZdCEaIAtBGXQhGyAKQRl0IRwgCUEZdCEdIAhBGXQhHiAHQRl0IR8gBkEZdEGAgIDwAXEgBEEEdnIhBCAFQQR1IQUgAiAgRyEhIBRBgICA8AFxIBFBBHZyIhQhESAVQYCAgPABcSAQQQR2ciIVIRAgFkGAgIDwAXEgD0EEdnIiFiEPIBdBgICA8AFxIA5BBHZyIhchDiAYQYCAgPABcSANQQR2ciIYIQ0gGUGAgIDwAXEgDEEEdnIiGSEMIBpBgICA8AFxIAtBBHZyIhohCyAbQYCAgPABcSAKQQR2ciIbIQogHEGAgIDwAXEgCUEEdnIiHCEJIB1BgICA8AFxIAhBBHZyIh0hCCAeQYCAgPABcSAHQQR2ciIeIQcgH0GAgIDwAXEgBkEEdnIiHyEGIAJBAWohAiAhDQALIAMgBTYCNCADIBQ2AjAgAyAVNgIsIAMgFjYCKCADIBc2AiQgAyAYNgIgIAMgGTYCHCADIBo2AhggAyAbNgIUIAMgHDYCECADIB02AgwgAyAeNgIIIAMgHzYCBCADIAQ2AgALIANBhAlq/QwAAAAAAAAAAAAAAAAAAAAA/QsCACADQZQJaiAj/QsCACADQaQJakEANgIAIANBATYC8AggAyAj/QsC9AggA0Kr1Jn1wQE3A+AJIANCvLn+6PDPrbwCNwPYCSADQpnH2dnx6NupHDcD0AkgA0Lby8OLkbaJxwg3A8gJIANC0tm486C1k7QRNwPACSADQuin9paw5JiRCTcDuAkgA0Ku7/ut4aHzmBA3A7AJIANB8AlqIANB8AhqIANBsAlqENMCIANCo73EgNABNwOQCyADQu3Tm5bBpvP/EjcDiAsgA0LL7pG74ayXjRI3A4ALIANCw7n216CUnM8QNwP4CiADQuqDifuA656oCTcD8AogA0Lu//+noaz//xc3A+gKIANCq9X+//H///sPNwPgCiADQUBrIANB4ApqIANB8AlqEMkCIANBAjYCeCADIAEoAgA2AnwgAyABKAIENgKAASADIAEoAgg2AoQBIAMgASgCDDYCiAEgAyABKAIQNgKMASADIAEoAhQ2ApABIAMgASgCGDYClAEgAyABKAIcNgKYASADIAEoAiA2ApwBIAMgASgCJDYCoAEgAyABKAIoNgKkASADIAEoAiw2AqgBIAMgASgCMDYCrAEgAyABKAI0NgKwASADIAEoAjgiBDYCtAEgA0G4AWohBSADQfwAaiECIASsIiIgIn5CgICAEFoEQCACENICCyADQfAJaiACIAEQ0wIgA0KjvcSA0AE3A5ALIANC7dOblsGm8/8SNwOICyADQsvukbvhrJeNEjcDgAsgA0LDufbXoJSczxA3A/gKIANC6oOJ+4DrnqgJNwPwCiADQu7//6ehrP//FzcD6AogA0Kr1f7/8f//+w83A+AKIAUgA0HgCmogA0HwCWoQyQIgA0ECNgLwAUEDIQIgBEGAgIAISCEGA0AgA0FAayACQTxsaiIEQTxrIQUgBkUEQCAFENICCyADQfAJaiAFIAEQ0wIgA0KjvcSA0AE3A5ALIANC7dOblsGm8/8SNwOICyADQsvukbvhrJeNEjcDgAsgA0LDufbXoJSczxA3A/gKIANC6oOJ+4DrnqgJNwPwCiADQu7//6ehrP//FzcD6AogA0Kr1f7/8f//+w83A+AKIAQgA0HgCmogA0HwCWoQyQIgBEECNgI4IAJBAWoiAkEQRw0ACyAAIANBQGsgA0GACGogEmosAABBPGxqIgIoAgA2AgAgACACKAIENgIEIAAgAigCCDYCCCAAIAIoAgw2AgwgACACKAIQNgIQIAAgAigCFDYCFCAAIAIoAhg2AhggACACKAIcNgIcIAAgAigCIDYCICAAIAIoAiQ2AiQgACACKAIoNgIoIAAgAigCLDYCLCAAIAIoAjA2AjAgACACKAI0NgI0IAAgAigCOCIENgI4AkAgE0EATA0AIBJBAWshAiAErCIiICJ+QoCAgBBaBEAgABDSAgsgA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0FAayADQYAIaiACaiwAAEE8bGoiBCgCOEGAgIAITgRAIAAQ0gILIANB8AlqIAAgBBDTAiADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggE0EFSA0AA0AgA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0HwCWogABC0AyADQqO9xIDQATcDkAsgA0Lt05uWwabz/xI3A4gLIANCy+6Ru+Gsl40SNwOACyADQsO59teglJzPEDcD+AogA0Lqg4n7gOueqAk3A/AKIANC7v//p6Gs//8XNwPoCiADQqvV/v/x///7DzcD4AogACADQeAKaiADQfAJahDJAiAAQQI2AjggA0FAayACQQFrIgQgA0GACGpqLAAAQTxsaiIFKAI4QYCAgAhOBEAgABDSAgsgA0HwCWogACAFENMCIANCo73EgNABNwOQCyADQu3Tm5bBpvP/EjcDiAsgA0LL7pG74ayXjRI3A4ALIANCw7n216CUnM8QNwP4CiADQuqDifuA656oCTcD8AogA0Lu//+noaz//xc3A+gKIANCq9X+//H///sPNwPgCiAAIANB4ApqIANB8AlqEMkCIABBAjYCOCACQQFKIQUgBCECIAUNAAsLIAAQ0gIgA0GgC2okAAvzBQICfwF7IwBB8AJrIgEkACABQqO9xIDQATcDcCABQu3Tm5bBpvP/EjcDaCABQsvukbvhrJeNEjcDYCABQsO59teglJzPEDcDWCABQuqDifuA656oCTcDUCABQu7//6ehrP//FzcDSCABQqvV/v/x///7DzcDQCABIAAoAgA2AsABIAEgACgCBDYCxAEgASAAKAIINgLIASABIAAoAgw2AswBIAEgACgCEDYC0AEgASAAKAIUNgLUASABIAAoAhg2AtgBIAEgACgCHDYC3AEgASAAKAIgNgLgASABIAAoAiQ2AuQBIAEgACgCKDYC6AEgASAAKAIsNgLsASABIAAoAjA2AvABIAAoAjQhAiAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCjAIgASAD/QsCnAIgAUEANgKsAiABIAP9CwL8ASABIAJBHXU2AvgBIAEgAkH/////AXE2AvQBIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiABIAFBsAJqIAFBwAFqEMkCIAEgAUFAaxC/AyECIAFCq9SZ9cEBNwOwASABQry5/ujwz628AjcDqAEgAUKZx9nZ8ejbqRw3A6ABIAFC28vDi5G2iccINwOYASABQtLZuPOgtZO0ETcDkAEgAULop/aWsOSYkQk3A4gBIAFCru/7reGh85gQNwOAASABQcABaiABIAFBgAFqENMCIAFCo73EgNABNwPgAiABQu3Tm5bBpvP/EjcD2AIgAULL7pG74ayXjRI3A9ACIAFCw7n216CUnM8QNwPIAiABQuqDifuA656oCTcDwAIgAULu//+noaz//xc3A7gCIAFCq9X+//H///sPNwOwAiAAIAFBsAJqIAFBwAFqEMkCIABBAjYCOCABQfACaiQAIAJBAUYLrQEBAn8jAEHwAWsiAyQAIANBtAFqIAIgAkE8aiIEEPcCIANBtAFqIANBtAFqEMwCIANB+ABqIANBtAFqIAQQ9wIgA0E8aiIEIANBtAFqIAIQ9wIgAyADKAJ4NgIAIAMgA/0AAnz9CwIEIAMgA/0AAowB/QsCFCADIAP9AAKcAf0LAiQgAyADKQKsATcCNCAAIAEgAxD3AiAAQTxqIAFBPGogBBD3AiADQfABaiQAC+ICAQJ/IwBBsAFrIgMkACACNAI4IAE0Ajh+QoCAgBBZBEAgARDSAgsgAyABIAIQ0wIgA0KjvcSA0AE3A6ABIANC7dOblsGm8/8SNwOYASADQsvukbvhrJeNEjcDkAEgA0LDufbXoJSczxA3A4gBIANC6oOJ+4DrnqgJNwOAASADQu7//6ehrP//FzcDeCADQqvV/v/x///7DzcDcCAAIANB8ABqIAMQyQIgAEECNgI4IAFBPGohBCACNAI4IAE0AnR+QoCAgBBZBEAgBBDSAgsgAyAEIAIQ0wIgA0KjvcSA0AE3A6ABIANC7dOblsGm8/8SNwOYASADQsvukbvhrJeNEjcDkAEgA0LDufbXoJSczxA3A4gBIANC6oOJ+4DrnqgJNwOAASADQu7//6ehrP//FzcDeCADQqvV/v/x///7DzcDcCAAQTxqIANB8ABqIAMQyQIgAEECNgJ0IANBsAFqJAAL3wMDC38BewF+IwBBgAFrIgEkACABIAAoAgA2AgggASAAKAIENgIMIAEgACgCCDYCECABIAAoAgw2AhQgASAAKAIQNgIYIAEgACgCFDYCHCABIAAoAhg2AiAgASAAKAIcIgM2AiQgASAAKAIgIgQ2AiggASAAKAIkIgU2AiwgASAAKAIoIgY2AjAgASAAKAIsIgc2AjQgASAAKAIwIgg2AjggASAAKAI0Igk2AjwgASAAKAI4Igo2AkAgASAAKAI8NgJEIAEgACgCQDYCSCABIAAoAkQ2AkwgASAAKAJINgJQIAEgACgCTDYCVCABIAAoAlA2AlggASAAKAJUNgJcIAEgACgCWDYCYCABIAAoAlw2AmQgASAAKAJgNgJoIAEgACgCZDYCbCABIAAoAmg2AnAgASAAKAJsNgJ0IAEgACgCcDYCeCABIAAoAnQ2AnwgAP0AAgAhDCAAKQIQIQ0gACgCGCELIAAgAEE8aiICEMwCIAAgCjYCdCAAIAk2AnAgACAINgJsIAAgBzYCaCAAIAY2AmQgACAFNgJgIAAgBDYCXCAAIAM2AlggACALNgJUIAAgDTcCTCAAIAz9CwI8IAAgAUEIaiAAEPcCIAIgAUHEAGogAhD3AiABQYABaiQAC8ENARV/IwBB4ANrIgIkACACIAEgAUH4AGoiAxD5AiACQfgAaiADEOQCIAJB8AFqIAEgAxD3AiACQawCaiABQTxqIgMgAUG0AWoQ9wIgAkH4AGoQwwggAkH4AGogASACQfgAahD3AiACQbQBaiIBIAMgARD3AiACQfABahD2AiACQfgAahD2AiAAIAJB8AFqIAJB+ABqEPkCIAIgAigCADYCeCACIAL9AAIE/QsCfCACIAL9AAIU/QsCjAEgAiAC/QACJP0LApwBIAIgAv0AAjT9CwKsASACIAL9AAJE/QsCvAEgAiAC/QACVP0LAswBIAIgAigCZDYC3AEgAiACKAJoIhM2AuABIAIgAigCbCIUNgLkASACIAIoAnAiFTYC6AEgAiACKAJ0IhI2AuwBIAJB+ABqEMMIIAJB+ABqIAJB+ABqIAIQ9wIgASABIAJBPGoQ9wIgAkH4AGoQ9gIgAiACKAK0ASIDIAIoAnhqNgKkAyACIAIoArgBIgQgAigCfGo2AqgDIAIgAigCvAEiBSACKAKAAWo2AqwDIAIgAigCwAEiBiACKAKEAWo2ArADIAIgAigCxAEiByACKAKIAWo2ArQDIAIgAigCyAEiCCACKAKMAWo2ArgDIAIgAigCzAEiCSACKAKQAWo2ArwDIAIgAigC0AEiCiACKAKUAWo2AsADIAIgAigC1AEiCyACKAKYAWo2AsQDIAIgAigC2AEiDCACKAKcAWo2AsgDIAIgAigC3AEiDSACKAKgAWo2AswDIAIgAigC4AEiDiACKAKkAWo2AtADIAIgAigC5AEiDyACKAKoAWo2AtQDIAIgAigC6AEiECACKAKsAWo2AtgDIAIgAigC7AEiFiACKAKwAWoiETYC3AMgEUGAgIAQTgRAIAJBpANqENICCyACQaQDaiACQaQDahDMAiACIAMgAigCpANqIhE2AugCIAIgBCACKAKoA2oiBDYC7AIgAiAFIAIoAqwDaiIFNgLwAiACIAYgAigCsANqIgY2AvQCIAIgByACKAK0A2oiBzYC+AIgAiAIIAIoArgDaiIINgL8AiACIAkgAigCvANqIgk2AoADIAIgCiACKALAA2oiCjYChAMgAiALIAIoAsQDaiILNgKIAyACIAwgAigCyANqIgw2AowDIAIgDSACKALMA2oiDTYCkAMgAiAOIAIoAtADaiIONgKUAyACIA8gAigC1ANqIg82ApgDIAIgECACKALYA2oiEDYCnAMgAiAWIAIoAtwDaiIDNgKgAyADQYCAgBBOBEAgAkHoAmoQ0gIgAigCnAMhECACKAKYAyEPIAIoApQDIQ4gAigCkAMhDSACKAKMAyEMIAIoAogDIQsgAigChAMhCiACKAKAAyEJIAIoAvwCIQggAigC+AIhByACKAL0AiEGIAIoAvACIQUgAigC7AIhBCACKALoAiERIAIoAqADIQMLIAEgAkGkA2ogAkH4AGoQ9wIgAiADNgKwASACIBA2AqwBIAIgDzYCqAEgAiAONgKkASACIA02AqABIAIgDDYCnAEgAiALNgKYASACIAo2ApQBIAIgCTYCkAEgAiAINgKMASACIAc2AogBIAIgBjYChAEgAiAFNgKAASACIAQ2AnwgAiARNgJ4IAAgACACQfgAahD3AiAAQTxqIgMgAyABEPcCIAAgAigCAEEBdDYCeCAAIAIoAgRBAXQ2AnwgACACKAIIQQF0NgKAASAAIAIoAgxBAXQ2AoQBIAAgAigCEEEBdDYCiAEgACACKAIUQQF0NgKMASAAIAIoAhhBAXQ2ApABIAAgAigCHEEBdDYClAEgACACKAIgQQF0NgKYASAAIAIoAiRBAXQ2ApwBIAAgAigCKEEBdDYCoAEgACACKAIsQQF0NgKkASAAIAIoAjBBAXQ2AqgBIAAgAigCNEEBdDYCrAEgACACKAI4IgNBAXQ2ArABIABB+ABqIQEgA0GAgIAITgRAIAEQ0gILIAAgAigCPEEBdDYCtAEgACACKAJAQQF0NgK4ASAAIAIoAkRBAXQ2ArwBIAAgAigCSEEBdDYCwAEgACACKAJMQQF0NgLEASAAIAIoAlBBAXQ2AsgBIAAgAigCVEEBdDYCzAEgACACKAJYQQF0NgLQASAAIAIoAlxBAXQ2AtQBIAAgAigCYEEBdDYC2AEgAigCZCEDIAAgEkEBdDYC7AEgACAVQQF0NgLoASAAIBRBAXQ2AuQBIAAgE0EBdDYC4AEgACADQQF0NgLcASASQYCAgAhOBEAgAEG0AWoQ0gILIAAQ9gIgARD2AiACQeADaiQAC7sGAwx/AXsBfiMAQfABayIBJAAgASAAQfgAaiIDEOQCIAEgASkCADcCeCABIAH9AAII/QsCgAEgASABKAIYIgI2ApABIAEgASgCHCIENgKUASABIAEoAiAiBTYCmAEgASABKAIkIgY2ApwBIAEgASgCKCIHNgKgASABIAEoAiwiCDYCpAEgASABKAIwIgk2AqgBIAEgASgCNCIKNgKsASABIAEoAjgiCzYCsAEgASABKAI8NgK0ASABIAEpAkA3ArgBIAEgAf0AAkj9CwLAASABIAH9AAJY/QsC0AEgASAB/QACaP0LAuABIAH9AAJ4IQ0gASkCiAEhDiABQfgAaiABQbQBaiIMEMwCIAEgCzYC7AEgASAKNgLoASABIAk2AuQBIAEgCDYC4AEgASAHNgLcASABIAY2AtgBIAEgBTYC1AEgASAENgLQASABIAI2AswBIAEgDjcCxAEgASAN/QsCtAEgASABIAFB+ABqEPcCIAFBPGoiAiACIAwQ9wIgACAAKAIANgJ4IAAgAP0AAgT9CwJ8IAAgAP0AAhT9CwKMASAAIAD9AAIk/QsCnAEgACAA/QACNP0LAqwBIAAgAP0AAkT9CwK8ASAAIAD9AAJU/QsCzAEgACAAKQJkNwLcASAAIAAoAmw2AuQBIAAgACkCcDcC6AEgACABRwRAIAAgASgCADYCACAAIAEoAgQ2AgQgACABKAIINgIIIAAgASgCDDYCDCAAIAEoAhA2AhAgACABKAIUNgIUIAAgASgCGDYCGCAAIAEoAhw2AhwgACABKAIgNgIgIAAgASgCJDYCJCAAIAEoAig2AiggACABKAIsNgIsIAAgASgCMDYCMCAAIAEoAjQ2AjQgACABKAI4NgI4IAAgASgCPDYCPCAAIAEoAkA2AkAgACABKAJENgJEIAAgASgCSDYCSCAAIAEoAkw2AkwgACABKAJQNgJQIAAgASgCVDYCVCAAIAEoAlg2AlggACABKAJcNgJcIAAgASgCYDYCYCAAIAEoAmQ2AmQgACABKAJoNgJoIAAgASgCbDYCbCAAIAEoAnA2AnAgACABKAJ0NgJ0CyAAEPYCIAMQ9gIgAUHwAWokAAvdGQEffyMAQeAEayIDJAAgA0HwAmogASACEPkCIANB+AFqIAFB+ABqIgQgAkH4AGoiBRD5AiADQYABaiAFIAIQ9wIgA0G8AWoiBSACQbQBaiACQTxqEPcCIANBCGogBCABEPcCIANBxABqIgIgAUG0AWogAUE8ahD3AiADQQhqEPYCIANBgAFqEPYCIANBCGogA0EIaiADQYABahD5AiADIAMoAqwDIAMoAvACajYCpAQgAyADKAKwAyIBIAMoAvQCIgRqNgKoBCADIAMoArQDIgYgAygC+AIiB2o2AqwEIAMgAygCuAMiCCADKAL8AiIJajYCsAQgAyADKAK8AyIKIAMoAoADIgtqNgK0BCADIAMoAsADIgwgAygChAMiDWo2ArgEIAMgAygCxAMiDiADKAKIAyIPajYCvAQgAyADKALIAyIQIAMoAowDIhFqNgLABCADIAMoAswDIhIgAygCkAMiE2o2AsQEIAMgAygC0AMiFCADKAKUAyIVajYCyAQgAyADKALUAyIWIAMoApgDIhdqNgLMBCADIAMoAtgDIhggAygCnAMiGWo2AtAEIAMgAygC3AMiGiADKAKgAyIbajYC1AQgAyADKALgAyIcIAMoAqQDIh1qNgLYBCADIAMoAuQDIh4gAygCqAMiH2oiIDYC3AQgIEGAgIAQTgRAIANBpARqENICCyADQaQEaiADQaQEahDMAiADIAMoAqQEIiAgAygCrANqNgLoAyADIAEgAygCqAQiIWo2AuwDIAMgBiADKAKsBCIBajYC8AMgAyAIIAMoArAEIgZqNgL0AyADIAogAygCtAQiCGo2AvgDIAMgDCADKAK4BCIKajYC/AMgAyAOIAMoArwEIgxqNgKABCADIBAgAygCwAQiDmo2AoQEIAMgEiADKALEBCIQajYCiAQgAyAUIAMoAsgEIhJqNgKMBCADIBYgAygCzAQiFGo2ApAEIAMgGCADKALQBCIWajYClAQgAyAaIAMoAtQEIhhqNgKYBCADIBwgAygC2AQiGmo2ApwEIAMgHiADKALcBCIcaiIeNgKgBCAeQYCAgBBOBEAgA0HoA2oQ0gILIAMgGiAdajYC8AEgAyAYIBtqNgLsASADIBYgGWo2AugBIAMgFCAXajYC5AEgAyASIBVqNgLgASADIBAgE2o2AtwBIAMgDiARajYC2AEgAyAMIA9qNgLUASADIAogDWo2AtABIAMgCCALajYCzAEgAyAGIAlqNgLIASADIAEgB2o2AsQBIAMgBCAhajYCwAEgAyADKALwAiAgajYCvAEgAyAcIB9qIgE2AvQBIAFBgICAEE4EQCAFENICCyADIAMoAugDNgKAASADIAP9AALsA/0LAoQBIAMgA/0AAvwD/QsClAEgAyAD/QACjAT9CwKkASADIAMpApwENwK0ASADQQhqIANBCGogA0GAAWoQ9wIgAiACIAUQ9wIgA0EIahD2AiADIAMoArQCIAMoAvgBajYCpAQgAyADKAK4AiICIAMoAvwBIgFqNgKoBCADIAMoArwCIgQgAygCgAIiBmo2AqwEIAMgAygCwAIiByADKAKEAiIIajYCsAQgAyADKALEAiIJIAMoAogCIgpqNgK0BCADIAMoAsgCIgsgAygCjAIiDGo2ArgEIAMgAygCzAIiDSADKAKQAiIOajYCvAQgAyADKALQAiIPIAMoApQCIhBqNgLABCADIAMoAtQCIhEgAygCmAIiEmo2AsQEIAMgAygC2AIiEyADKAKcAiIUajYCyAQgAyADKALcAiIVIAMoAqACIhZqNgLMBCADIAMoAuACIhcgAygCpAIiGGo2AtAEIAMgAygC5AIiGSADKAKoAiIaajYC1AQgAyADKALoAiIbIAMoAqwCIhxqNgLYBCADIAMoAuwCIh0gAygCsAIiHmoiHzYC3AQgH0GAgIAQTgRAIANBpARqENICCyADQaQEaiADQaQEahDMAiADIAMoAqQEIh8gAygCtAJqNgLoAyADIAIgAygCqAQiIGo2AuwDIAMgBCADKAKsBCICajYC8AMgAyAHIAMoArAEIgRqNgL0AyADIAkgAygCtAQiB2o2AvgDIAMgCyADKAK4BCIJajYC/AMgAyANIAMoArwEIgtqNgKABCADIA8gAygCwAQiDWo2AoQEIAMgESADKALEBCIPajYCiAQgAyATIAMoAsgEIhFqNgKMBCADIBUgAygCzAQiE2o2ApAEIAMgFyADKALQBCIVajYClAQgAyAZIAMoAtQEIhdqNgKYBCADIBsgAygC2AQiGWo2ApwEIAMgHSADKALcBCIbaiIdNgKgBCAdQYCAgBBOBEAgA0HoA2oQ0gILIAMgGSAcajYC8AEgAyAXIBpqNgLsASADIBUgGGo2AugBIAMgEyAWajYC5AEgAyARIBRqNgLgASADIA8gEmo2AtwBIAMgDSAQajYC2AEgAyALIA5qNgLUASADIAkgDGo2AtABIAMgByAKajYCzAEgAyAEIAhqNgLIASADIAIgBmo2AsQBIAMgASAgajYCwAEgAyADKAL4ASAfajYCvAEgAyAbIB5qIgI2AvQBIAJBgICAEE4EQCAFENICCyADIAMoAugDIgI2AoABIAMgAygC7AMiATYChAEgAyADKALwAyIFNgKIASADIAMoAvQDIgQ2AowBIAMgAygC+AMiBjYCkAEgAyADKAL8AyIHNgKUASADIAMoAoAEIgg2ApgBIAMgAygChAQiCTYCnAEgAyADKAKIBCIKNgKgASADIAMoAowEIgs2AqQBIAMgAygCkAQiDDYCqAEgAyADKAKUBCINNgKsASADIAMoApgEIg42ArABIAMgAygCnAQiDzYCtAEgAyADKAKgBCIQNgK4ASAAIAIgAygCCGo2AnggACABIAMoAgxqNgJ8IAAgBSADKAIQajYCgAEgACAEIAMoAhRqNgKEASAAIAYgAygCGGo2AogBIAAgByADKAIcajYCjAEgACAIIAMoAiBqNgKQASAAIAkgAygCJGo2ApQBIAAgCiADKAIoajYCmAEgACALIAMoAixqNgKcASAAIAwgAygCMGo2AqABIAAgDSADKAI0ajYCpAEgACAOIAMoAjhqNgKoASAAIA8gAygCPGo2AqwBIAAgECADKAJAaiIBNgKwASAAQfgAaiECIAFBgICAEE4EQCACENICCyAAIAMoArwBIAMoAkRqNgK0ASAAIAMoAsABIAMoAkhqNgK4ASAAIAMoAsQBIAMoAkxqNgK8ASAAIAMoAsgBIAMoAlBqNgLAASAAIAMoAswBIAMoAlRqNgLEASAAIAMoAtABIAMoAlhqNgLIASAAIAMoAtQBIAMoAlxqNgLMASAAIAMoAtgBIAMoAmBqNgLQASAAIAMoAtwBIAMoAmRqNgLUASAAIAMoAuABIAMoAmhqNgLYASAAIAMoAuQBIAMoAmxqNgLcASAAIAMoAugBIAMoAnBqNgLgASAAIAMoAuwBIAMoAnRqNgLkASAAIAMoAvABIAMoAnhqNgLoASAAIAMoAvQBIAMoAnxqIgE2AuwBIAFBgICAEE4EQCAAQbQBahDSAgsgA0H4AWoQwwggACADKALwAiADKAL4AWo2AgAgACADKAL0AiADKAL8AWo2AgQgACADKAL4AiADKAKAAmo2AgggACADKAL8AiADKAKEAmo2AgwgACADKAKAAyADKAKIAmo2AhAgACADKAKEAyADKAKMAmo2AhQgACADKAKIAyADKAKQAmo2AhggACADKAKMAyADKAKUAmo2AhwgACADKAKQAyADKAKYAmo2AiAgACADKAKUAyADKAKcAmo2AiQgACADKAKYAyADKAKgAmo2AiggACADKAKcAyADKAKkAmo2AiwgACADKAKgAyADKAKoAmo2AjAgACADKAKkAyADKAKsAmo2AjQgACADKAKoAyADKAKwAmoiATYCOCABQYCAgBBOBEAgABDSAgsgACADKAKsAyADKAK0Amo2AjwgACADKAKwAyADKAK4Amo2AkAgACADKAK0AyADKAK8Amo2AkQgACADKAK4AyADKALAAmo2AkggACADKAK8AyADKALEAmo2AkwgACADKALAAyADKALIAmo2AlAgACADKALEAyADKALMAmo2AlQgACADKALIAyADKALQAmo2AlggACADKALMAyADKALUAmo2AlwgACADKALQAyADKALYAmo2AmAgACADKALUAyADKALcAmo2AmQgACADKALYAyADKALgAmo2AmggACADKALcAyADKALkAmo2AmwgACADKALgAyADKALoAmo2AnAgACADKALkAyADKALsAmoiATYCdCABQYCAgBBOBEAgAEE8ahDSAgsgABD2AiACEPYCIANB4ARqJAALkQoBFX8jAEGwAmsiAiQAIAEQ9gIgAUH4AGoiEhD2AiACQfwAaiABIBIQ9wIgAkG4AWoiESABQTxqIhQgAUG0AWoiFRD3AiACIAIoArgBIAIoAnxqNgIEIAIgAigCvAEiAyACKAKAAWo2AgggAiACKALAASIEIAIoAoQBajYCDCACIAIoAsQBIgUgAigCiAFqNgIQIAIgAigCyAEiBiACKAKMAWo2AhQgAiACKALMASIHIAIoApABajYCGCACIAIoAtABIgggAigClAFqNgIcIAIgAigC1AEiCSACKAKYAWo2AiAgAiACKALYASIKIAIoApwBajYCJCACIAIoAtwBIgsgAigCoAFqNgIoIAIgAigC4AEiDCACKAKkAWo2AiwgAiACKALkASINIAIoAqgBajYCMCACIAIoAugBIg4gAigCrAFqNgI0IAIgAigC7AEiDyACKAKwAWo2AjggAiACKALwASIWIAIoArQBaiIQNgI8IBBBgICAEE4EQCACQQRqENICCyACQQRqIAJBBGoQzAIgAiACKAK4ASACKAIEaiIQNgL0ASACIAMgAigCCGoiEzYC+AEgAiAEIAIoAgxqIgQ2AvwBIAIgBSACKAIQaiIFNgKAAiACIAYgAigCFGoiBjYChAIgAiAHIAIoAhhqIgc2AogCIAIgCCACKAIcaiIINgKMAiACIAkgAigCIGoiCTYCkAIgAiAKIAIoAiRqIgo2ApQCIAIgCyACKAIoaiILNgKYAiACIAwgAigCLGoiDDYCnAIgAiANIAIoAjBqIg02AqACIAIgDiACKAI0aiIONgKkAiACIA8gAigCOGoiDzYCqAIgAiAWIAIoAjxqIgM2AqwCIANBgICAEE4EQCACQfQBahDSAiACKAKoAiEPIAIoAqQCIQ4gAigCoAIhDSACKAKcAiEMIAIoApgCIQsgAigClAIhCiACKAKQAiEJIAIoAowCIQggAigCiAIhByACKAKEAiEGIAIoAoACIQUgAigC/AEhBCACKAL4ASETIAIoAvQBIRAgAigCrAIhAwsgESACQQRqIAJB/ABqEPcCIAIgAzYCtAEgAiAPNgKwASACIA42AqwBIAIgDTYCqAEgAiAMNgKkASACIAs2AqABIAIgCjYCnAEgAiAJNgKYASACIAg2ApQBIAIgBzYCkAEgAiAGNgKMASACIAU2AogBIAIgBDYChAEgAiATNgKAASACIBA2AnwgAkEEaiACQfwAaiASEPcCIAJBQGsgESAVEPcCIABB+ABqIgMgAkH8AGogARD3AiAAQbQBaiARIBQQ9wIgACACKAIENgIAIAAgAigCCDYCBCAAIAIoAgw2AgggACACKAIQNgIMIAAgAigCFDYCECAAIAIoAhg2AhQgACACKAIcNgIYIAAgAigCIDYCHCAAIAIoAiQ2AiAgACACKAIoNgIkIAAgAigCLDYCKCAAIAIoAjA2AiwgACACKAI0NgIwIAAgAigCODYCNCAAIAIoAjw2AjggACACKAJANgI8IAAgAigCRDYCQCAAIAIoAkg2AkQgACACKAJMNgJIIAAgAigCUDYCTCAAIAIoAlQ2AlAgACACKAJYNgJUIAAgAigCXDYCWCAAIAIoAmA2AlwgACACKAJkNgJgIAAgAigCaDYCZCAAIAIoAmw2AmggACACKAJwNgJsIAAgAigCdDYCcCAAIAIoAng2AnQgABD2AiADEPYCIAJBsAJqJAALxzUCOX8BeyMAQbAJayICJAAgAkHAB2ogACABEPkCIAJByAZqIABB+ABqIhUgAUH4AGoiEhD5AiACQdAFaiAAQdgEaiIWIAFB2ARqIhQQ+QIgAkHYBGogACAVEPcCIAJBlAVqIhogAEE8aiIXIABBtAFqIhwQ9wIgAkHgA2ogASASEPcCIAJBnARqIhsgAUE8aiIYIAFBtAFqIh0Q9wIgAkHYBGoQ9gIgAkHgA2oQ9gIgAkHoAmogAkHYBGogAkHgA2oQ+QIgAiACKALIBiACKALAB2o2AgAgAiACKALMBiACKALEB2o2AgQgAiACKALQBiACKALIB2o2AgggAiACKALUBiACKALMB2o2AgwgAiACKALYBiACKALQB2o2AhAgAiACKALcBiACKALUB2o2AhQgAiACKALgBiACKALYB2o2AhggAiACKALkBiACKALcB2o2AhwgAiACKALoBiACKALgB2o2AiAgAiACKALsBiACKALkB2o2AiQgAiACKALwBiACKALoB2o2AiggAiACKAL0BiACKALsB2o2AiwgAiACKAL4BiACKALwB2o2AjAgAiACKAL8BiACKAL0B2o2AjQgAiACKAKAByACKAL4B2oiETYCOCARQYCAgBBOBEAgAhDSAgsgAiACKAKEByACKAL8B2o2AjwgAiACKAKIByACKAKACGoiBDYCQCACIAIoAowHIAIoAoQIaiIFNgJEIAIgAigCkAcgAigCiAhqIgY2AkggAiACKAKUByACKAKMCGoiBzYCTCACIAIoApgHIAIoApAIaiIINgJQIAIgAigCnAcgAigClAhqIgk2AlQgAiACKAKgByACKAKYCGoiCjYCWCACIAIoAqQHIAIoApwIaiILNgJcIAIgAigCqAcgAigCoAhqIgw2AmAgAiACKAKsByACKAKkCGoiDTYCZCACIAIoArAHIAIoAqgIaiIONgJoIAIgAigCtAcgAigCrAhqIg82AmwgAiACKAK4ByACKAKwCGoiEDYCcCACIAIoArwHIAIoArQIaiIDNgJ0IAJBPGohESADQYCAgBBOBEAgERDSAiACKAJwIRAgAigCbCEPIAIoAmghDiACKAJkIQ0gAigCYCEMIAIoAlwhCyACKAJYIQogAigCVCEJIAIoAlAhCCACKAJMIQcgAigCSCEGIAIoAkQhBSACKAJAIQQgAigCdCEDCyACIAIoAjwiEyACKAIAajYC8AEgAiAEIAIoAgRqNgL0ASACIAUgAigCCGo2AvgBIAIgBiACKAIMajYC/AEgAiAHIAIoAhBqNgKAAiACIAggAigCFGo2AoQCIAIgCSACKAIYajYCiAIgAiAKIAIoAhxqNgKMAiACIAsgAigCIGo2ApACIAIgDCACKAIkajYClAIgAiANIAIoAihqNgKYAiACIA4gAigCLGo2ApwCIAIgDyACKAIwajYCoAIgAiAQIAIoAjRqNgKkAiACIAMgAigCOGoiGTYCqAIgGUGAgIAQTgRAIAJB8AFqENICCyACQfABaiACQfABahDMAiACIBMgAigC8AFqIhM2AnggAiAEIAIoAvQBaiIENgJ8IAIgBSACKAL4AWoiBTYCgAEgAiAGIAIoAvwBaiIGNgKEASACIAcgAigCgAJqIgc2AogBIAIgCCACKAKEAmoiCDYCjAEgAiAJIAIoAogCaiIJNgKQASACIAogAigCjAJqIgo2ApQBIAIgCyACKAKQAmoiCzYCmAEgAiAMIAIoApQCaiIMNgKcASACIA0gAigCmAJqIg02AqABIAIgDiACKAKcAmoiDjYCpAEgAiAPIAIoAqACaiIPNgKoASACIBAgAigCpAJqIhA2AqwBIAIgAyACKAKoAmoiAzYCsAEgA0GAgIAQTgRAIAJB+ABqENICIAIoAqwBIRAgAigCqAEhDyACKAKkASEOIAIoAqABIQ0gAigCnAEhDCACKAKYASELIAIoApQBIQogAigCkAEhCSACKAKMASEIIAIoAogBIQcgAigChAEhBiACKAKAASEFIAIoAnwhBCACKAJ4IRMgAigCsAEhAwsgESACQfABaiACEPcCIAIgAzYCOCACIBA2AjQgAiAPNgIwIAIgDjYCLCACIA02AiggAiAMNgIkIAIgCzYCICACIAo2AhwgAiAJNgIYIAIgCDYCFCACIAc2AhAgAiAGNgIMIAIgBTYCCCACIAQ2AgQgAiATNgIAIAJB6AJqIAJB6AJqIAIQ9wIgAkGkA2oiAyADIBEQ9wIgAkHYBGogACAWEPcCIBogFyAAQZQFaiITEPcCIAJB4ANqIAEgFBD3AiAbIBggAUGUBWoiFxD3AiACQdgEahD2AiACQeADahD2AiACQfABaiACQdgEaiACQeADahD5AiACIAIoAtAFIhggAigCwAdqNgIAIAIgAigC1AUiGSACKALEB2o2AgQgAiACKALYBSIeIAIoAsgHajYCCCACIAIoAtwFIh8gAigCzAdqNgIMIAIgAigC4AUiICACKALQB2o2AhAgAiACKALkBSIhIAIoAtQHajYCFCACIAIoAugFIiIgAigC2AdqNgIYIAIgAigC7AUiIyACKALcB2o2AhwgAiACKALwBSIkIAIoAuAHajYCICACIAIoAvQFIiUgAigC5AdqNgIkIAIgAigC+AUiJiACKALoB2o2AiggAiACKAL8BSInIAIoAuwHajYCLCACIAIoAoAGIiggAigC8AdqNgIwIAIgAigChAYiKSACKAL0B2o2AjQgAiACKAKIBiIqIAIoAvgHaiIBNgI4IAFBgICAEE4EQCACENICCyACIAIoAowGIisgAigC/AdqIgM2AjwgAiACKAKQBiIsIAIoAoAIaiIENgJAIAIgAigClAYiLSACKAKECGoiBTYCRCACIAIoApgGIi4gAigCiAhqIgY2AkggAiACKAKcBiIvIAIoAowIaiIHNgJMIAIgAigCoAYiMCACKAKQCGoiCDYCUCACIAIoAqQGIjEgAigClAhqIgk2AlQgAiACKAKoBiIyIAIoApgIaiIKNgJYIAIgAigCrAYiMyACKAKcCGoiCzYCXCACIAIoArAGIjQgAigCoAhqIgw2AmAgAiACKAK0BiI1IAIoAqQIaiINNgJkIAIgAigCuAYiNiACKAKoCGoiDjYCaCACIAIoArwGIjcgAigCrAhqIg82AmwgAiACKALABiI4IAIoArAIaiIQNgJwIAIgAigCxAYiOSACKAK0CGoiATYCdCABQYCAgBBOBEAgERDSAiACKAJwIRAgAigCbCEPIAIoAmghDiACKAJkIQ0gAigCYCEMIAIoAlwhCyACKAJYIQogAigCVCEJIAIoAlAhCCACKAJMIQcgAigCSCEGIAIoAkQhBSACKAJAIQQgAigCPCEDIAIoAnQhAQsgAiADIAIoAgBqNgJ4IAIgBCACKAIEajYCfCACIAUgAigCCGo2AoABIAIgBiACKAIMajYChAEgAiAHIAIoAhBqNgKIASACIAggAigCFGo2AowBIAIgCSACKAIYajYCkAEgAiAKIAIoAhxqNgKUASACIAsgAigCIGo2ApgBIAIgDCACKAIkajYCnAEgAiANIAIoAihqNgKgASACIA4gAigCLGo2AqQBIAIgDyACKAIwajYCqAEgAiAQIAIoAjRqNgKsASACIAEgAigCOGoiOjYCsAEgOkGAgIAQTgRAIAJB+ABqENICCyACQfgAaiACQfgAahDMAiACIAMgAigCeGoiAzYC9AggAiAEIAIoAnxqIgQ2AvgIIAIgBSACKAKAAWoiBTYC/AggAiAGIAIoAoQBaiIGNgKACSACIAcgAigCiAFqIgc2AoQJIAIgCCACKAKMAWoiCDYCiAkgAiAJIAIoApABaiIJNgKMCSACIAogAigClAFqIgo2ApAJIAIgCyACKAKYAWoiCzYClAkgAiAMIAIoApwBaiIMNgKYCSACIA0gAigCoAFqIg02ApwJIAIgDiACKAKkAWoiDjYCoAkgAiAPIAIoAqgBaiIPNgKkCSACIBAgAigCrAFqIhA2AqgJIAIgASACKAKwAWoiATYCrAkgAUGAgIAQTgRAIAJB9AhqENICIAIoAqgJIRAgAigCpAkhDyACKAKgCSEOIAIoApwJIQ0gAigCmAkhDCACKAKUCSELIAIoApAJIQogAigCjAkhCSACKAKICSEIIAIoAoQJIQcgAigCgAkhBiACKAL8CCEFIAIoAvgIIQQgAigC9AghAyACKAKsCSEBCyARIAJB+ABqIAIQ9wIgAiABNgI4IAIgEDYCNCACIA82AjAgAiAONgIsIAIgDTYCKCACIAw2AiQgAiALNgIgIAIgCjYCHCACIAk2AhggAiAINgIUIAIgBzYCECACIAY2AgwgAiAFNgIIIAIgBDYCBCACIAM2AgAgAkHwAWogAkHwAWogAhD3AiACQawCaiIBIAEgERD3AiACQdgEaiAVIBYQ9wIgGiAcIBMQ9wIgAkHgA2ogEiAUEPcCIBsgHSAXEPcCIAJB2ARqEPYCIAJB4ANqEPYCIAJB+ABqIAJB2ARqIAJB4ANqEPkCIAIgGCACKALIBmo2AgAgAiAZIAIoAswGajYCBCACIB4gAigC0AZqNgIIIAIgHyACKALUBmo2AgwgAiAgIAIoAtgGajYCECACICEgAigC3AZqNgIUIAIgIiACKALgBmo2AhggAiAjIAIoAuQGajYCHCACICQgAigC6AZqNgIgIAIgJSACKALsBmo2AiQgAiAmIAIoAvAGajYCKCACICcgAigC9AZqNgIsIAIgKCACKAL4Bmo2AjAgAiApIAIoAvwGajYCNCACICogAigCgAdqIgE2AjggAUGAgIAQTgRAIAIQ0gILIAIgKyACKAKEB2oiAzYCPCACICwgAigCiAdqIgQ2AkAgAiAtIAIoAowHaiIFNgJEIAIgLiACKAKQB2oiBjYCSCACIC8gAigClAdqIgc2AkwgAiAwIAIoApgHaiIINgJQIAIgMSACKAKcB2oiCTYCVCACIDIgAigCoAdqIgo2AlggAiAzIAIoAqQHaiILNgJcIAIgNCACKAKoB2oiDDYCYCACIDUgAigCrAdqIg02AmQgAiA2IAIoArAHaiIONgJoIAIgNyACKAK0B2oiDzYCbCACIDggAigCuAdqIhA2AnAgAiA5IAIoArwHaiIBNgJ0IAFBgICAEE4EQCARENICIAIoAnAhECACKAJsIQ8gAigCaCEOIAIoAmQhDSACKAJgIQwgAigCXCELIAIoAlghCiACKAJUIQkgAigCUCEIIAIoAkwhByACKAJIIQYgAigCRCEFIAIoAkAhBCACKAI8IQMgAigCdCEBCyACIAMgAigCAGo2AvQIIAIgBCACKAIEajYC+AggAiAFIAIoAghqNgL8CCACIAYgAigCDGo2AoAJIAIgByACKAIQajYChAkgAiAIIAIoAhRqNgKICSACIAkgAigCGGo2AowJIAIgCiACKAIcajYCkAkgAiALIAIoAiBqNgKUCSACIAwgAigCJGo2ApgJIAIgDSACKAIoajYCnAkgAiAOIAIoAixqNgKgCSACIA8gAigCMGo2AqQJIAIgECACKAI0ajYCqAkgAiABIAIoAjhqIhI2AqwJIBJBgICAEE4EQCACQfQIahDSAgsgAkGEB2ohFCACQfwHaiESIAJB9AhqIAJB9AhqEMwCIAIgAyACKAL0CGoiAzYCuAggAiAEIAIoAvgIaiIENgK8CCACIAUgAigC/AhqIgU2AsAIIAIgBiACKAKACWoiBjYCxAggAiAHIAIoAoQJaiIHNgLICCACIAggAigCiAlqIgg2AswIIAIgCSACKAKMCWoiCTYC0AggAiAKIAIoApAJaiIKNgLUCCACIAsgAigClAlqIgs2AtgIIAIgDCACKAKYCWoiDDYC3AggAiANIAIoApwJaiINNgLgCCACIA4gAigCoAlqIg42AuQIIAIgDyACKAKkCWoiDzYC6AggAiAQIAIoAqgJaiIQNgLsCCACIAEgAigCrAlqIgE2AvAIIAFBgICAEE4EQCACQbgIahDSAiACKALsCCEQIAIoAugIIQ8gAigC5AghDiACKALgCCENIAIoAtwIIQwgAigC2AghCyACKALUCCEKIAIoAtAIIQkgAigCzAghCCACKALICCEHIAIoAsQIIQYgAigCwAghBSACKAK8CCEEIAIoArgIIQMgAigC8AghAQsgESACQfQIaiACEPcCIAIgATYCOCACIBA2AjQgAiAPNgIwIAIgDjYCLCACIA02AiggAiAMNgIkIAIgCzYCICACIAo2AhwgAiAJNgIYIAIgCDYCFCACIAc2AhAgAiAGNgIMIAIgBTYCCCACIAQ2AgQgAiADNgIAIAJB+ABqIAJB+ABqIAIQ9wIgAkG0AWoiASABIBEQ9wIgAkHIBmoQwwggAkHAB2ogAkHAB2ogAkHIBmoQ9wIgEiASIBQQ9wIgAkHAB2ogAEcEQCAAIAIoAsAHNgIAIAAgAigCxAc2AgQgACACKALIBzYCCCAAIAIoAswHNgIMIAAgAigC0Ac2AhAgACACKALUBzYCFCAAIAIoAtgHNgIYIAAgAigC3Ac2AhwgACACKALgBzYCICAAIAIoAuQHNgIkIAAgAigC6Ac2AiggACACKALsBzYCLCAAIAIoAvAHNgIwIAAgAigC9Ac2AjQgACACKAL4BzYCOCAAIAIoAvwHNgI8IAAgAigCgAg2AkAgACACKAKECDYCRCAAIAIoAogINgJIIAAgAigCjAg2AkwgACACKAKQCDYCUCAAIAIoApQINgJUIAAgAigCmAg2AlggACACKAKcCDYCXCAAIAIoAqAINgJgIAAgAigCpAg2AmQgACACKAKoCDYCaCAAIAIoAqwINgJsIAAgAigCsAg2AnAgACACKAK0CDYCdAsgAEHgA2ohESAAIAIoAugCNgJ4IAAgAigC7AI2AnwgACACKALwAjYCgAEgACACKAL0AjYChAEgACACKAL4AjYCiAEgACACKAL8AjYCjAEgACACKAKAAzYCkAEgACACKAKEAzYClAEgACACKAKIAzYCmAEgACACKAKMAzYCnAEgACACKAKQAzYCoAEgACACKAKUAzYCpAEgACACKAKYAzYCqAEgACACKAKcAzYCrAEgACACKAKgAzYCsAEgACACKAKkAzYCtAEgACACKAKoAzYCuAEgACACKAKsAzYCvAEgACACKAKwAzYCwAEgACACKAK0AzYCxAEgACACKAK4AzYCyAEgACACKAK8AzYCzAEgACACKALAAzYC0AEgACACKALEAzYC1AEgACACKALIAzYC2AEgACACKALMAzYC3AEgACACKALQAzYC4AEgACACKALUAzYC5AEgACACKALYAzYC6AEgACACKALcAzYC7AEgAEHwAWohASACQdAFahDDCCACQdAFahD2AiACQegCaiAARwRAIAAgAigC0AU2AugCIAAgAigC1AU2AuwCIAAgAigC2AU2AvACIAAgAigC3AU2AvQCIAAgAigC4AU2AvgCIAAgAigC5AU2AvwCIAAgAigC6AU2AoADIAAgAigC7AU2AoQDIAAgAigC8AU2AogDIAAgAigC9AU2AowDIAAgAigC+AU2ApADIAAgAigC/AU2ApQDIAAgAigCgAY2ApgDIAAgAigChAY2ApwDIAAgAigCiAY2AqADIAAgAigCjAY2AqQDIAAgAigCkAY2AqgDIAAgAigClAY2AqwDIAAgAigCmAY2ArADIAAgAigCnAY2ArQDIAAgAigCoAY2ArgDIAAgAigCpAY2ArwDIAAgAigCqAY2AsADIAAgAigCrAY2AsQDIAAgAigCsAY2AsgDIAAgAigCtAY2AswDIAAgAigCuAY2AtADIAAgAigCvAY2AtQDIAAgAigCwAY2AtgDIAAgAigCxAY2AtwDCyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCACABQgA3AjAgASA7/QsCICABIDv9CwIQIAAgO/0LAsQCIABCADcCrAIgAEEBNgKoAiAAQQE2AuQCIAAgO/0LAtQCIAAgO/0LArQCIAJB+ABqEPYCIAJB+ABqEMMIIAJB+ABqIBFHBEAgACACKAJ4NgLgAyAAIAIoAnw2AuQDIAAgAigCgAE2AugDIAAgAigChAE2AuwDIAAgAigCiAE2AvADIAAgAigCjAE2AvQDIAAgAigCkAE2AvgDIAAgAigClAE2AvwDIAAgAigCmAE2AoAEIAAgAigCnAE2AoQEIAAgAigCoAE2AogEIAAgAigCpAE2AowEIAAgAigCqAE2ApAEIAAgAigCrAE2ApQEIAAgAigCsAE2ApgEIAAgAigCtAE2ApwEIAAgAigCuAE2AqAEIAAgAigCvAE2AqQEIAAgAigCwAE2AqgEIAAgAigCxAE2AqwEIAAgAigCyAE2ArAEIAAgAigCzAE2ArQEIAAgAigC0AE2ArgEIAAgAigC1AE2ArwEIAAgAigC2AE2AsAEIAAgAigC3AE2AsQEIAAgAigC4AE2AsgEIAAgAigC5AE2AswEIAAgAigC6AE2AtAEIAAgAigC7AE2AtQECyAAIAIoAvABNgLYBCAAIAIoAvQBNgLcBCAAIAIoAvgBNgLgBCAAIAIoAvwBNgLkBCAAIAIoAoACNgLoBCAAIAIoAoQCNgLsBCAAIAIoAogCNgLwBCAAIAIoAowCNgL0BCAAIAIoApACNgL4BCAAIAIoApQCNgL8BCAAIAIoApgCNgKABSAAIAIoApwCNgKEBSAAIAIoAqACNgKIBSAAIAIoAqQCNgKMBSAAIAIoAqgCNgKQBSAAIAIoAqwCNgKUBSAAIAIoArACNgKYBSAAIAIoArQCNgKcBSAAIAIoArgCNgKgBSAAIAIoArwCNgKkBSAAIAIoAsACNgKoBSAAIAIoAsQCNgKsBSAAIAIoAsgCNgKwBSAAIAIoAswCNgK0BSAAIAIoAtACNgK4BSAAIAIoAtQCNgK8BSAAIAIoAtgCNgLABSAAIAIoAtwCNgLEBSAAIAIoAuACNgLIBSAAIAIoAuQCNgLMBSAAEPYCIBUQ9gIgERD2AiAWEPYCIABBAzYC0AUgAkGwCWokAAuWCQEVfyMAQeADayIDJAAgAhD2AiACQfgAaiITEPYCIANB6AJqIAIgExD3AiADQaQDaiISIAJBPGoiFSACQbQBaiIWEPcCIAMgAygCpAMgAygC6AJqNgIAIAMgAygCqAMiBCADKALsAmo2AgQgAyADKAKsAyIFIAMoAvACajYCCCADIAMoArADIgYgAygC9AJqNgIMIAMgAygCtAMiByADKAL4Amo2AhAgAyADKAK4AyIIIAMoAvwCajYCFCADIAMoArwDIgkgAygCgANqNgIYIAMgAygCwAMiCiADKAKEA2o2AhwgAyADKALEAyILIAMoAogDajYCICADIAMoAsgDIgwgAygCjANqNgIkIAMgAygCzAMiDSADKAKQA2o2AiggAyADKALQAyIOIAMoApQDajYCLCADIAMoAtQDIg8gAygCmANqNgIwIAMgAygC2AMiECADKAKcA2o2AjQgAyADKALcAyIXIAMoAqADaiIRNgI4IBFBgICAEE4EQCADENICCyADIAMQzAIgAyADKAKkAyADKAIAaiIRNgLwASADIAQgAygCBGoiFDYC9AEgAyAFIAMoAghqIgU2AvgBIAMgBiADKAIMaiIGNgL8ASADIAcgAygCEGoiBzYCgAIgAyAIIAMoAhRqIgg2AoQCIAMgCSADKAIYaiIJNgKIAiADIAogAygCHGoiCjYCjAIgAyALIAMoAiBqIgs2ApACIAMgDCADKAIkaiIMNgKUAiADIA0gAygCKGoiDTYCmAIgAyAOIAMoAixqIg42ApwCIAMgDyADKAIwaiIPNgKgAiADIBAgAygCNGoiEDYCpAIgAyAXIAMoAjhqIgQ2AqgCIARBgICAEE4EQCADQfABahDSAiADKAKkAiEQIAMoAqACIQ8gAygCnAIhDiADKAKYAiENIAMoApQCIQwgAygCkAIhCyADKAKMAiEKIAMoAogCIQkgAygChAIhCCADKAKAAiEHIAMoAvwBIQYgAygC+AEhBSADKAL0ASEUIAMoAvABIREgAygCqAIhBAsgEiADIANB6AJqEPcCIAMgBDYCoAMgAyAQNgKcAyADIA82ApgDIAMgDjYClAMgAyANNgKQAyADIAw2AowDIAMgCzYCiAMgAyAKNgKEAyADIAk2AoADIAMgCDYC/AIgAyAHNgL4AiADIAY2AvQCIAMgBTYC8AIgAyAUNgLsAiADIBE2AugCIANB8AFqIANB6AJqIBMQ9wIgA0GsAmogEiAWEPcCIANB+ABqIgQgA0HoAmogAhD3AiADQbQBaiICIBIgFRD3AiADIAMoAvABNgIAIAMgA/0AAvQB/QsCBCADIAP9AAKEAv0LAhQgAyAD/QAClAL9CwIkIAMgA/0AAqQC/QsCNCADIAP9AAK0Av0LAkQgAyAD/QACxAL9CwJUIAMgAykC1AI3AmQgAyADKALcAjYCbCADIAMpAuACNwJwIAMQ9gIgBBD2AiAAIAEgAxD3AiAAQTxqIAFBPGogA0E8ahD3AiAAQfgAaiABQfgAaiAEEPcCIABBtAFqIAFBtAFqIAIQ9wIgA0HgA2okAAuSQgEdfyMAQeAFayIEJAAgACABIAJBH3UiBSACcyAFQX9zaiIDQQJtIhlBAWtBH3YiBhC5CCAAIAFBOGogAEE4aiIHIANBAkgiAxsoAgA2AjggAEE8aiIaIAFBPGogBhC5CCAAIAFB9ABqIABB9ABqIgggAxsoAgA2AnQgAEH4AGoiCSABQfgAaiAGELkIIAAgAUGwAWogAEGwAWoiCiADGygCADYCsAEgAEG0AWoiGyABQbQBaiAGELkIIAAgAUHsAWogAEHsAWoiCyADGygCADYC7AEgAEHwAWoiDCABQfABaiAGELkIIAAgAUGoAmogAEGoAmoiDSADGygCADYCqAIgAEGsAmoiHCABQawCaiAGELkIIAAgAUHkAmogAEHkAmoiDiADGygCADYC5AIgAEHoAmoiDyABQegCaiAGELkIIAAgAUGgA2ogAEGgA2oiECADGygCADYCoAMgAEGkA2oiHSABQaQDaiAGELkIIAAgAUHcA2ogAEHcA2oiESADGygCADYC3AMgAEHgA2oiEiABQeADaiAGELkIIAAgAUGYBGogAEGYBGoiEyADGygCADYCmAQgAEGcBGoiHiABQZwEaiAGELkIIAAgAUHUBGogAEHUBGoiFCADGygCADYC1AQgAEHYBGoiFSABQdgEaiAGELkIIAAgAUGQBWogAEGQBWoiFiADGygCADYCkAUgAEGUBWoiHyABQZQFaiAGELkIIAAgAUHMBWogAEHMBWoiFyADGygCADYCzAUgACABQdAFaiAAQdAFaiIYIAMbKAIANgLQBSAAIAFB1AVqIBlBAXMiA0EBa0EfdiIGELkIIAAgByABQYwGaiADQQBKIgMbKAIANgI4IBogAUGQBmogBhC5CCAAIAggAUHIBmogAxsoAgA2AnQgCSABQcwGaiAGELkIIAAgCiABQYQHaiADGygCADYCsAEgGyABQYgHaiAGELkIIAAgCyABQcAHaiADGygCADYC7AEgDCABQcQHaiAGELkIIAAgDSABQfwHaiADGygCADYCqAIgHCABQYAIaiAGELkIIAAgDiABQbgIaiADGygCADYC5AIgDyABQbwIaiAGELkIIAAgECABQfQIaiADGygCADYCoAMgHSABQfgIaiAGELkIIAAgESABQbAJaiADGygCADYC3AMgEiABQbQJaiAGELkIIAAgEyABQewJaiADGygCADYCmAQgHiABQfAJaiAGELkIIAAgFCABQagKaiADGygCADYC1AQgFSABQawKaiAGELkIIAAgFiABQeQKaiADGygCADYCkAUgHyABQegKaiAGELkIIAAgFyABQaALaiADGygCADYCzAUgACAYIAFBpAtqIAMbKAIANgLQBSAAIAFBqAtqIBlBAnMiA0EBa0EfdiIGELkIIAAgByABQeALaiADQQBKIgMbKAIANgI4IBogAUHkC2ogBhC5CCAAIAggAUGcDGogAxsoAgA2AnQgCSABQaAMaiAGELkIIAAgCiABQdgMaiADGygCADYCsAEgGyABQdwMaiAGELkIIAAgCyABQZQNaiADGygCADYC7AEgDCABQZgNaiAGELkIIAAgDSABQdANaiADGygCADYCqAIgHCABQdQNaiAGELkIIAAgDiABQYwOaiADGygCADYC5AIgDyABQZAOaiAGELkIIAAgECABQcgOaiADGygCADYCoAMgHSABQcwOaiAGELkIIAAgESABQYQPaiADGygCADYC3AMgEiABQYgPaiAGELkIIAAgEyABQcAPaiADGygCADYCmAQgHiABQcQPaiAGELkIIAAgFCABQfwPaiADGygCADYC1AQgFSABQYAQaiAGELkIIAAgFiABQbgQaiADGygCADYCkAUgHyABQbwQaiAGELkIIAAgFyABQfQQaiADGygCADYCzAUgACAYIAFB+BBqIAMbKAIANgLQBSAAIAFB/BBqIBlBA3MiA0EBa0EfdiIGELkIIAAgByABQbQRaiADQQBKIgMbKAIANgI4IBogAUG4EWogBhC5CCAAIAggAUHwEWogAxsoAgA2AnQgCSABQfQRaiAGELkIIAAgCiABQawSaiADGygCADYCsAEgGyABQbASaiAGELkIIAAgCyABQegSaiADGygCADYC7AEgDCABQewSaiAGELkIIAAgDSABQaQTaiADGygCADYCqAIgHCABQagTaiAGELkIIAAgDiABQeATaiADGygCADYC5AIgDyABQeQTaiAGELkIIAAgECABQZwUaiADGygCADYCoAMgHSABQaAUaiAGELkIIAAgESABQdgUaiADGygCADYC3AMgEiABQdwUaiAGELkIIAAgEyABQZQVaiADGygCADYCmAQgHiABQZgVaiAGELkIIAAgFCABQdAVaiADGygCADYC1AQgFSABQdQVaiAGELkIIAAgFiABQYwWaiADGygCADYCkAUgHyABQZAWaiAGELkIIAAgFyABQcgWaiADGygCADYCzAUgACAYIAFBzBZqIAMbKAIANgLQBSAAIAFB0BZqIBlBBHMiA0EBa0EfdiIGELkIIAAgByABQYgXaiADQQBKIgMbKAIANgI4IBogAUGMF2ogBhC5CCAAIAggAUHEF2ogAxsoAgA2AnQgCSABQcgXaiAGELkIIAAgCiABQYAYaiADGygCADYCsAEgGyABQYQYaiAGELkIIAAgCyABQbwYaiADGygCADYC7AEgDCABQcAYaiAGELkIIAAgDSABQfgYaiADGygCADYCqAIgHCABQfwYaiAGELkIIAAgDiABQbQZaiADGygCADYC5AIgDyABQbgZaiAGELkIIAAgECABQfAZaiADGygCADYCoAMgHSABQfQZaiAGELkIIAAgESABQawaaiADGygCADYC3AMgEiABQbAaaiAGELkIIAAgEyABQegaaiADGygCADYCmAQgHiABQewaaiAGELkIIAAgFCABQaQbaiADGygCADYC1AQgFSABQagbaiAGELkIIAAgFiABQeAbaiADGygCADYCkAUgHyABQeQbaiAGELkIIAAgFyABQZwcaiADGygCADYCzAUgACAYIAFBoBxqIAMbKAIANgLQBSAAIAFBpBxqIBlBBXMiA0EBa0EfdiIGELkIIAAgByABQdwcaiADQQBKIgMbKAIANgI4IBogAUHgHGogBhC5CCAAIAggAUGYHWogAxsoAgA2AnQgCSABQZwdaiAGELkIIAAgCiABQdQdaiADGygCADYCsAEgGyABQdgdaiAGELkIIAAgCyABQZAeaiADGygCADYC7AEgDCABQZQeaiAGELkIIAAgDSABQcweaiADGygCADYCqAIgHCABQdAeaiAGELkIIAAgDiABQYgfaiADGygCADYC5AIgDyABQYwfaiAGELkIIAAgECABQcQfaiADGygCADYCoAMgHSABQcgfaiAGELkIIAAgESABQYAgaiADGygCADYC3AMgEiABQYQgaiAGELkIIAAgEyABQbwgaiADGygCADYCmAQgHiABQcAgaiAGELkIIAAgFCABQfggaiADGygCADYC1AQgFSABQfwgaiAGELkIIAAgFiABQbQhaiADGygCADYCkAUgHyABQbghaiAGELkIIAAgFyABQfAhaiADGygCADYCzAUgACAYIAFB9CFqIAMbKAIANgLQBSAAIAFB+CFqIBlBBnMiA0EBa0EfdiIGELkIIAAgByABQbAiaiADQQBKIgMbKAIANgI4IBogAUG0ImogBhC5CCAAIAggAUHsImogAxsoAgA2AnQgCSABQfAiaiAGELkIIAAgCiABQagjaiADGygCADYCsAEgGyABQawjaiAGELkIIAAgCyABQeQjaiADGygCADYC7AEgDCABQegjaiAGELkIIAAgDSABQaAkaiADGygCADYCqAIgHCABQaQkaiAGELkIIAAgDiABQdwkaiADGygCADYC5AIgDyABQeAkaiAGELkIIAAgECABQZglaiADGygCADYCoAMgHSABQZwlaiAGELkIIAAgESABQdQlaiADGygCADYC3AMgEiABQdglaiAGELkIIAAgEyABQZAmaiADGygCADYCmAQgHiABQZQmaiAGELkIIAAgFCABQcwmaiADGygCADYC1AQgFSABQdAmaiAGELkIIAAgFiABQYgnaiADGygCADYCkAUgHyABQYwnaiAGELkIIAAgFyABQcQnaiADGygCADYCzAUgACAYIAFByCdqIAMbKAIANgLQBSAAIAFBzCdqIBlBB3MiA0EBa0EfdiIGELkIIAAgByABQYQoaiADQQBKIgMbKAIANgI4IBogAUGIKGogBhC5CCAAIAggAUHAKGogAxsoAgA2AnQgCSABQcQoaiAGELkIIAAgCiABQfwoaiADGygCADYCsAEgGyABQYApaiAGELkIIAAgCyABQbgpaiADGygCADYC7AEgDCABQbwpaiAGELkIIAAgDSABQfQpaiADGygCADYCqAIgHCABQfgpaiAGELkIIAAgDiABQbAqaiADGygCADYC5AIgDyABQbQqaiAGELkIIAAgECABQewqaiADGygCADYCoAMgHSABQfAqaiAGELkIIAAgESABQagraiADGygCADYC3AMgEiABQawraiAGELkIIAAgEyABQeQraiADGygCADYCmAQgHiABQegraiAGELkIIAAgFCABQaAsaiADGygCADYC1AQgFSABQaQsaiAGELkIIAAgFiABQdwsaiADGygCADYCkAUgHyABQeAsaiAGELkIIAAgFyABQZgtaiADGygCADYCzAUgACAYIAFBnC1qIAMbKAIAIgE2AtAFIARBDGogAEcEQCAEQQxqIAAQ5AIgBEGEAWogCRDkAiAEQfwBaiAMEOQCIARB9AJqIA8Q5AIgBEHsA2ogEhDkAiAEQeQEaiAVEOQCIAQgATYC3AULIARBDGogBEEMahCPAyAEQfwBaiIBIAEQkAMgBEHsA2oiASABEI8DIAAgACgCACIBIAQoAgxzIAVxIAFzNgIAIAAgACgCBCIBIAQoAhBzIAVxIAFzNgIEIAAgACgCCCIBIAQoAhRzIAVxIAFzNgIIIAAgACgCDCIBIAQoAhhzIAVxIAFzNgIMIAAgACgCECIBIAQoAhxzIAVxIAFzNgIQIAAgACgCFCIBIAQoAiBzIAVxIAFzNgIUIAAgACgCGCIBIAQoAiRzIAVxIAFzNgIYIAAgACgCHCIBIAQoAihzIAVxIAFzNgIcIAAgACgCICIBIAQoAixzIAVxIAFzNgIgIAAgACgCJCIBIAQoAjBzIAVxIAFzNgIkIAAgACgCKCIBIAQoAjRzIAVxIAFzNgIoIAAgACgCLCIBIAQoAjhzIAVxIAFzNgIsIAAgACgCMCIBIAQoAjxzIAVxIAFzNgIwIAAgACgCNCIBIAQoAkBzIAVxIAFzNgI0IAAgBEHEAGogByACQQBIIgEbKAIANgI4IAAgACgCPCIDIAQoAkhzIAVxIANzNgI8IAAgACgCQCIDIAQoAkxzIAVxIANzNgJAIAAgACgCRCIDIAQoAlBzIAVxIANzNgJEIAAgACgCSCIDIAQoAlRzIAVxIANzNgJIIAAgACgCTCIDIAQoAlhzIAVxIANzNgJMIAAgACgCUCIDIAQoAlxzIAVxIANzNgJQIAAgACgCVCIDIAQoAmBzIAVxIANzNgJUIAAgACgCWCIDIAQoAmRzIAVxIANzNgJYIAAgACgCXCIDIAQoAmhzIAVxIANzNgJcIAAgACgCYCIDIAQoAmxzIAVxIANzNgJgIAAgACgCZCIDIAQoAnBzIAVxIANzNgJkIAAgACgCaCIDIAQoAnRzIAVxIANzNgJoIAAgACgCbCIDIAQoAnhzIAVxIANzNgJsIAAgACgCcCIDIAQoAnxzIAVxIANzNgJwIAAgBEGAAWogCCABGygCADYCdCAAIAAoAngiAyAEKAKEAXMgBXEgA3M2AnggACAAKAJ8IgMgBCgCiAFzIAVxIANzNgJ8IAAgACgCgAEiAyAEKAKMAXMgBXEgA3M2AoABIAAgACgChAEiAyAEKAKQAXMgBXEgA3M2AoQBIAAgACgCiAEiAyAEKAKUAXMgBXEgA3M2AogBIAAgACgCjAEiAyAEKAKYAXMgBXEgA3M2AowBIAAgACgCkAEiAyAEKAKcAXMgBXEgA3M2ApABIAAgACgClAEiAyAEKAKgAXMgBXEgA3M2ApQBIAAgACgCmAEiAyAEKAKkAXMgBXEgA3M2ApgBIAAgACgCnAEiAyAEKAKoAXMgBXEgA3M2ApwBIAAgACgCoAEiAyAEKAKsAXMgBXEgA3M2AqABIAAgACgCpAEiAyAEKAKwAXMgBXEgA3M2AqQBIAAgACgCqAEiAyAEKAK0AXMgBXEgA3M2AqgBIAAgACgCrAEiAyAEKAK4AXMgBXEgA3M2AqwBIAAgBEG8AWogCiABGygCADYCsAEgACAAKAK0ASIDIAQoAsABcyAFcSADczYCtAEgACAAKAK4ASIDIAQoAsQBcyAFcSADczYCuAEgACAAKAK8ASIDIAQoAsgBcyAFcSADczYCvAEgACAAKALAASIDIAQoAswBcyAFcSADczYCwAEgACAAKALEASIDIAQoAtABcyAFcSADczYCxAEgACAAKALIASIDIAQoAtQBcyAFcSADczYCyAEgACAAKALMASIDIAQoAtgBcyAFcSADczYCzAEgACAAKALQASIDIAQoAtwBcyAFcSADczYC0AEgACAAKALUASIDIAQoAuABcyAFcSADczYC1AEgACAAKALYASIDIAQoAuQBcyAFcSADczYC2AEgACAAKALcASIDIAQoAugBcyAFcSADczYC3AEgACAAKALgASIDIAQoAuwBcyAFcSADczYC4AEgACAAKALkASIDIAQoAvABcyAFcSADczYC5AEgACAAKALoASIDIAQoAvQBcyAFcSADczYC6AEgACAEQfgBaiALIAEbKAIANgLsASAAIAAoAvABIgMgBCgC/AFzIAVxIANzNgLwASAAIAAoAvQBIgMgBCgCgAJzIAVxIANzNgL0ASAAIAAoAvgBIgMgBCgChAJzIAVxIANzNgL4ASAAIAAoAvwBIgMgBCgCiAJzIAVxIANzNgL8ASAAIAAoAoACIgMgBCgCjAJzIAVxIANzNgKAAiAAIAAoAoQCIgMgBCgCkAJzIAVxIANzNgKEAiAAIAAoAogCIgMgBCgClAJzIAVxIANzNgKIAiAAIAAoAowCIgMgBCgCmAJzIAVxIANzNgKMAiAAIAAoApACIgMgBCgCnAJzIAVxIANzNgKQAiAAIAAoApQCIgMgBCgCoAJzIAVxIANzNgKUAiAAIAAoApgCIgMgBCgCpAJzIAVxIANzNgKYAiAAIAAoApwCIgMgBCgCqAJzIAVxIANzNgKcAiAAIAAoAqACIgMgBCgCrAJzIAVxIANzNgKgAiAAIAAoAqQCIgMgBCgCsAJzIAVxIANzNgKkAiAAIARBtAJqIA0gARsoAgA2AqgCIAAgACgCrAIiAyAEKAK4AnMgBXEgA3M2AqwCIAAgACgCsAIiAyAEKAK8AnMgBXEgA3M2ArACIAAgACgCtAIiAyAEKALAAnMgBXEgA3M2ArQCIAAgACgCuAIiAyAEKALEAnMgBXEgA3M2ArgCIAAgACgCvAIiAyAEKALIAnMgBXEgA3M2ArwCIAAgACgCwAIiAyAEKALMAnMgBXEgA3M2AsACIAAgACgCxAIiAyAEKALQAnMgBXEgA3M2AsQCIAAgACgCyAIiAyAEKALUAnMgBXEgA3M2AsgCIAAgACgCzAIiAyAEKALYAnMgBXEgA3M2AswCIAAgACgC0AIiAyAEKALcAnMgBXEgA3M2AtACIAAgACgC1AIiAyAEKALgAnMgBXEgA3M2AtQCIAAgACgC2AIiAyAEKALkAnMgBXEgA3M2AtgCIAAgACgC3AIiAyAEKALoAnMgBXEgA3M2AtwCIAAgACgC4AIiAyAEKALsAnMgBXEgA3M2AuACIAAgBEHwAmogDiABGygCADYC5AIgACAAKALoAiIDIAQoAvQCcyAFcSADczYC6AIgACAAKALsAiIDIAQoAvgCcyAFcSADczYC7AIgACAAKALwAiIDIAQoAvwCcyAFcSADczYC8AIgACAAKAL0AiIDIAQoAoADcyAFcSADczYC9AIgACAAKAL4AiIDIAQoAoQDcyAFcSADczYC+AIgACAAKAL8AiIDIAQoAogDcyAFcSADczYC/AIgACAAKAKAAyIDIAQoAowDcyAFcSADczYCgAMgACAAKAKEAyIDIAQoApADcyAFcSADczYChAMgACAAKAKIAyIDIAQoApQDcyAFcSADczYCiAMgACAAKAKMAyIDIAQoApgDcyAFcSADczYCjAMgACAAKAKQAyIDIAQoApwDcyAFcSADczYCkAMgACAAKAKUAyIDIAQoAqADcyAFcSADczYClAMgACAAKAKYAyIDIAQoAqQDcyAFcSADczYCmAMgACAAKAKcAyIDIAQoAqgDcyAFcSADczYCnAMgACAEQawDaiAQIAEbKAIANgKgAyAAIAAoAqQDIgMgBCgCsANzIAVxIANzNgKkAyAAIAAoAqgDIgMgBCgCtANzIAVxIANzNgKoAyAAIAAoAqwDIgMgBCgCuANzIAVxIANzNgKsAyAAIAAoArADIgMgBCgCvANzIAVxIANzNgKwAyAAIAAoArQDIgMgBCgCwANzIAVxIANzNgK0AyAAIAAoArgDIgMgBCgCxANzIAVxIANzNgK4AyAAIAAoArwDIgMgBCgCyANzIAVxIANzNgK8AyAAIAAoAsADIgMgBCgCzANzIAVxIANzNgLAAyAAIAAoAsQDIgMgBCgC0ANzIAVxIANzNgLEAyAAIAAoAsgDIgMgBCgC1ANzIAVxIANzNgLIAyAAIAAoAswDIgMgBCgC2ANzIAVxIANzNgLMAyAAIAAoAtADIgMgBCgC3ANzIAVxIANzNgLQAyAAIAAoAtQDIgMgBCgC4ANzIAVxIANzNgLUAyAAIAAoAtgDIgMgBCgC5ANzIAVxIANzNgLYAyAAIARB6ANqIBEgARsoAgA2AtwDIAAgACgC4AMiAyAEKALsA3MgBXEgA3M2AuADIAAgACgC5AMiAyAEKALwA3MgBXEgA3M2AuQDIAAgACgC6AMiAyAEKAL0A3MgBXEgA3M2AugDIAAgACgC7AMiAyAEKAL4A3MgBXEgA3M2AuwDIAAgACgC8AMiAyAEKAL8A3MgBXEgA3M2AvADIAAgACgC9AMiAyAEKAKABHMgBXEgA3M2AvQDIAAgACgC+AMiAyAEKAKEBHMgBXEgA3M2AvgDIAAgACgC/AMiAyAEKAKIBHMgBXEgA3M2AvwDIAAgACgCgAQiAyAEKAKMBHMgBXEgA3M2AoAEIAAgACgChAQiAyAEKAKQBHMgBXEgA3M2AoQEIAAgACgCiAQiAyAEKAKUBHMgBXEgA3M2AogEIAAgACgCjAQiAyAEKAKYBHMgBXEgA3M2AowEIAAgACgCkAQiAyAEKAKcBHMgBXEgA3M2ApAEIAAgACgClAQiAyAEKAKgBHMgBXEgA3M2ApQEIAAgBEGkBGogEyABGygCADYCmAQgACAAKAKcBCIDIAQoAqgEcyAFcSADczYCnAQgACAAKAKgBCIDIAQoAqwEcyAFcSADczYCoAQgACAAKAKkBCIDIAQoArAEcyAFcSADczYCpAQgACAAKAKoBCIDIAQoArQEcyAFcSADczYCqAQgACAAKAKsBCIDIAQoArgEcyAFcSADczYCrAQgACAAKAKwBCIDIAQoArwEcyAFcSADczYCsAQgACAAKAK0BCIDIAQoAsAEcyAFcSADczYCtAQgACAAKAK4BCIDIAQoAsQEcyAFcSADczYCuAQgACAAKAK8BCIDIAQoAsgEcyAFcSADczYCvAQgACAAKALABCIDIAQoAswEcyAFcSADczYCwAQgACAAKALEBCIDIAQoAtAEcyAFcSADczYCxAQgACAAKALIBCIDIAQoAtQEcyAFcSADczYCyAQgACAAKALMBCIDIAQoAtgEcyAFcSADczYCzAQgACAAKALQBCIDIAQoAtwEcyAFcSADczYC0AQgACAEQeAEaiAUIAEbKAIANgLUBCAAIAAoAtgEIgMgBCgC5ARzIAVxIANzNgLYBCAAIAAoAtwEIgMgBCgC6ARzIAVxIANzNgLcBCAAIAAoAuAEIgMgBCgC7ARzIAVxIANzNgLgBCAAIAAoAuQEIgMgBCgC8ARzIAVxIANzNgLkBCAAIAAoAugEIgMgBCgC9ARzIAVxIANzNgLoBCAAIAAoAuwEIgMgBCgC+ARzIAVxIANzNgLsBCAAIAAoAvAEIgMgBCgC/ARzIAVxIANzNgLwBCAAIAAoAvQEIgMgBCgCgAVzIAVxIANzNgL0BCAAIAAoAvgEIgMgBCgChAVzIAVxIANzNgL4BCAAIAAoAvwEIgMgBCgCiAVzIAVxIANzNgL8BCAAIAAoAoAFIgMgBCgCjAVzIAVxIANzNgKABSAAIAAoAoQFIgMgBCgCkAVzIAVxIANzNgKEBSAAIAAoAogFIgMgBCgClAVzIAVxIANzNgKIBSAAIAAoAowFIgMgBCgCmAVzIAVxIANzNgKMBSAAIARBnAVqIBYgARsoAgA2ApAFIAAgACgClAUiAyAEKAKgBXMgBXEgA3M2ApQFIAAgACgCmAUiAyAEKAKkBXMgBXEgA3M2ApgFIAAgACgCnAUiAyAEKAKoBXMgBXEgA3M2ApwFIAAgACgCoAUiAyAEKAKsBXMgBXEgA3M2AqAFIAAgACgCpAUiAyAEKAKwBXMgBXEgA3M2AqQFIAAgACgCqAUiAyAEKAK0BXMgBXEgA3M2AqgFIAAgACgCrAUiAyAEKAK4BXMgBXEgA3M2AqwFIAAgACgCsAUiAyAEKAK8BXMgBXEgA3M2ArAFIAAgACgCtAUiAyAEKALABXMgBXEgA3M2ArQFIAAgACgCuAUiAyAEKALEBXMgBXEgA3M2ArgFIAAgACgCvAUiAyAEKALIBXMgBXEgA3M2ArwFIAAgACgCwAUiAyAEKALMBXMgBXEgA3M2AsAFIAAgACgCxAUiAyAEKALQBXMgBXEgA3M2AsQFIAAgACgCyAUiAyAEKALUBXMgBXEgA3M2AsgFIAAgBEHYBWogFyABGygCADYCzAUgACAEQdwFaiAYIAEbKAIANgLQBSAEQeAFaiQAC903AhJ/AXsjAEGwCWsiBSQAIAFB8AFqIQYgAUH4AGohBwJAIAEgAkYEQCAFQbgIaiABEOQCIAVBwAdqIAcQ5AIgBUHIBmogBhDkAiAFIAUoAsAHNgLQBSAFIAX9AALEB/0LAtQFIAUgBf0AAtQH/QsC5AUgBSAF/QAC5Af9CwL0BSAFIAX9AAL0B/0LAoQGIAUgBf0AAoQI/QsClAYgBSAF/QAClAj9CwKkBiAFIAUpAqQINwK0BiAFIAUoAqwINgK8BiAFIAUpArAINwLABiAFQdAFaiAFQdAFaiAFQcgGahD5AiAFQbgIaiAFQbgIahCHAyAFQcAHaiAFQcAHahCHAyAFQcgGaiAFQcgGahCHAyAFQdAFaiAFQdAFakEEELwIIAVBjAZqIgcgB0EEELwIIAUgBSgCjAYiAiAFKALQBWo2AuADIAUgBSgCkAYiCCAFKALUBWo2AuQDIAUgBSgClAYiCSAFKALYBWo2AugDIAUgBSgCmAYiCiAFKALcBWo2AuwDIAUgBSgCnAYiCyAFKALgBWo2AvADIAUgBSgCoAYiDCAFKALkBWo2AvQDIAUgBSgCpAYiDSAFKALoBWo2AvgDIAUgBSgCqAYiDiAFKALsBWo2AvwDIAUgBSgCrAYiDyAFKALwBWo2AoAEIAUgBSgCsAYiECAFKAL0BWo2AoQEIAUgBSgCtAYiESAFKAL4BWo2AogEIAUgBSgCuAYiEyAFKAL8BWo2AowEIAUgBSgCvAYiFCAFKAKABmo2ApAEIAUgBSgCwAYiFSAFKAKEBmo2ApQEIAUgBSgCxAYiFiAFKAKIBmoiBjYCmAQgBkGAgIAQTgRAIAVB4ANqENICCyAFQfwHaiEGIAVB4ANqIAVB4ANqEMwCIAUgAiAFKALgA2oiEjYC8AEgBSAIIAUoAuQDaiIINgL0ASAFIAkgBSgC6ANqIgk2AvgBIAUgCiAFKALsA2oiCjYC/AEgBSALIAUoAvADaiILNgKAAiAFIAwgBSgC9ANqIgw2AoQCIAUgDSAFKAL4A2oiDTYCiAIgBSAOIAUoAvwDaiIONgKMAiAFIA8gBSgCgARqIg82ApACIAUgECAFKAKEBGoiEDYClAIgBSARIAUoAogEaiIRNgKYAiAFIBMgBSgCjARqIhM2ApwCIAUgFCAFKAKQBGoiFDYCoAIgBSAVIAUoApQEaiIVNgKkAiAFIBYgBSgCmARqIgI2AqgCIAJBgICAEE4EQCAFQfABahDSAiAFKAKkAiEVIAUoAqACIRQgBSgCnAIhEyAFKAKYAiERIAUoApQCIRAgBSgCkAIhDyAFKAKMAiEOIAUoAogCIQ0gBSgChAIhDCAFKAKAAiELIAUoAvwBIQogBSgC+AEhCSAFKAL0ASEIIAUoAvABIRIgBSgCqAIhAgsgByAFQeADaiAFQdAFahD3AiAFIAI2AogGIAUgFTYChAYgBSAUNgKABiAFIBM2AvwFIAUgETYC+AUgBSAQNgL0BSAFIA82AvAFIAUgDjYC7AUgBSANNgLoBSAFIAw2AuQFIAUgCzYC4AUgBSAKNgLcBSAFIAk2AtgFIAUgCDYC1AUgBSASNgLQBSAFQdAFahD2AiAFQbgIaiAFQbgIakEGELwIIAVB9AhqIgIgAkEGELwIIAVBuAhqIAVBuAhqIAMQwgggBUHIBmogBUHIBmpBDBC8CCAFQYQHaiICIAJBDBC8CCAFQdAFaiAFQdAFaiAEEMIIIAVByAZqEMMIIAVByAZqIAVByAZqIAVByAZqEPcCIAIgAiACEPcCIAVB0AVqEMMIIAVB0AVqEPYCIAVByAZqEPYCIAVBwAdqIAVBwAdqIAVBwAdqEPcCIAYgBiAGEPcCIAVByAZqIAVByAZqIAVBwAdqEMEIIAVByAZqEPYCIAUgBSgC0AU2AuADIAUgBf0AAtQF/QsC5AMgBSAF/QAC5AX9CwL0AyAFIAX9AAL0Bf0LAoQEIAUgBf0AAoQG/QsClAQgBSAF/QAClAb9CwKkBCAFIAX9AAKkBv0LArQEIAUgBSkCtAY3AsQEIAUgBSgCvAY2AswEIAUgBSkCwAY3AtAEIAUgBSgCyAY2AtgEIAUgBSkCzAY3AtwEIAUgBf0AAtQG/QsC5AQgBSAF/QAC5Ab9CwL0BCAFIAX9AAL0Bv0LAoQFIAUgBSkChAc3ApQFIAUgBSgCjAc2ApwFIAUgBSgCkAc2AqAFIAUgBSgClAc2AqQFIAUgBSgCmAc2AqgFIAUgBSgCnAc2AqwFIAUgBSgCoAc2ArAFIAUgBSgCpAc2ArQFIAUgBSgCqAc2ArgFIAUgBSgCrAc2ArwFIAUgBSgCsAc2AsAFIAUgBSgCtAc2AsQFIAUgBSgCuAc2AsgFIAUgBSgCvAc2AswFIAVCADcDoAIgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA5ACIAUgF/0LA4ACIAUgF/0LA/ABIAVBATYCqAIgBUIANwLcAiAFIBf9CwLMAiAFIBf9CwK8AiAFIBf9CwKsAiAFQQE2AuQCIAVCADcDmAMgBSAX/QsDiAMgBSAX/QsD+AIgBSAX/QsD6AIgBUEBNgKgAyAFQgA3AtQDIAUgF/0LAsQDIAUgF/0LArQDIAUgF/0LAqQDIAVBATYC3AMgBSAFKAK4CDYCeCAFIAUoArwINgJ8IAUgBSgCwAg2AoABIAUgBSgCxAg2AoQBIAUgBSgCyAg2AogBIAUgBSgCzAg2AowBIAUgBSgC0Ag2ApABIAUgBSgC1Ag2ApQBIAUgBSgC2Ag2ApgBIAUgBSgC3Ag2ApwBIAUgBSgC4Ag2AqABIAUgBSgC5Ag2AqQBIAUgBSgC6Ag2AqgBIAUgBSgC7Ag2AqwBIAUgBSgC8Ag2ArABIAUgBSgC9Ag2ArQBIAUgBSgC+Ag2ArgBIAUgBSgC/Ag2ArwBIAUgBSgCgAk2AsABIAUgBSgChAk2AsQBIAUgBSgCiAk2AsgBIAUgBSgCjAk2AswBIAUgBSgCkAk2AtABIAUgBSgClAk2AtQBIAUgBSgCmAk2AtgBIAUgBSgCnAk2AtwBIAUgBSgCoAk2AuABIAUgBSgCpAk2AuQBIAUgBSgCqAk2AugBIAUgBSgCrAk2AuwBIAVCADcDMCAFIBf9CwMgIAUgF/0LAxAgBSAX/QsDACAFQQE2AjggBUIANwJsIAUgF/0LAlwgBSAX/QsCTCAFIBf9CwI8IAVBATYCdCABEIkDDAELIAVBuAhqIAEQ5AIgBUHAB2ogBxDkAiAFQcgGaiAGEOQCIAUgBSgCyAY2AtAFIAUgBf0AAswG/QsC1AUgBSAF/QAC3Ab9CwLkBSAFIAX9AALsBv0LAvQFIAUgBf0AAvwG/QsChAYgBSAF/QACjAf9CwKUBiAFIAX9AAKcB/0LAqQGIAUgBSkCrAc3ArQGIAUgBSgCtAc2ArwGIAUgBSkCuAc3AsAGIAVByAZqIAVByAZqIAJB+ABqIgYQ+QIgBUHQBWogBUHQBWogAhD5AiAFQbgIaiAFQbgIaiAFQdAFahDBCCAFQbgIahD2AiAFQcAHaiAFQcAHaiAFQcgGahDBCCAFQcAHahD2AiAFIAUoArgINgLIBiAFIAX9AAK8CP0LAswGIAUgBf0AAswI/QsC3AYgBSAF/QAC3Aj9CwLsBiAFIAX9AALsCP0LAvwGIAUgBf0AAvwI/QsCjAcgBSAF/QACjAn9CwKcByAFIAUpApwJNwKsByAFIAUoAqQJNgK0ByAFIAUpAqgJNwK4ByAFQbgIaiAFQbgIaiAEEMIIIAVBuAhqEMMIIAVBuAhqEPYCIAVByAZqIAVByAZqIAYQ+QIgBSAFKALABzYC0AUgBSAF/QACxAf9CwLUBSAFIAX9AALUB/0LAuQFIAUgBf0AAuQH/QsC9AUgBSAF/QAC9Af9CwKEBiAFIAX9AAKECP0LApQGIAUgBf0AApQI/QsCpAYgBSAFKQKkCDcCtAYgBSAFKAKsCDYCvAYgBSAFKQKwCDcCwAYgBUHQBWogBUHQBWogAhD5AiAFQdAFaiAFQdAFaiAFQcgGahDBCCAFQdAFahD2AiAFQcAHaiAFQcAHaiADEMIIIAUgBSgC/AciBCAFKALAB2o2AuADIAUgBSgCgAgiBiAFKALEB2o2AuQDIAUgBSgChAgiByAFKALIB2o2AugDIAUgBSgCiAgiEiAFKALMB2o2AuwDIAUgBSgCjAgiCCAFKALQB2o2AvADIAUgBSgCkAgiCSAFKALUB2o2AvQDIAUgBSgClAgiCiAFKALYB2o2AvgDIAUgBSgCmAgiCyAFKALcB2o2AvwDIAUgBSgCnAgiDCAFKALgB2o2AoAEIAUgBSgCoAgiDSAFKALkB2o2AoQEIAUgBSgCpAgiDiAFKALoB2o2AogEIAUgBSgCqAgiDyAFKALsB2o2AowEIAUgBSgCrAgiECAFKALwB2o2ApAEIAUgBSgCsAgiESAFKAL0B2o2ApQEIAUgBSgCtAgiEyAFKAL4B2oiAzYCmAQgA0GAgIAQTgRAIAVB4ANqENICCyAFQfwHaiEUIAVB4ANqIAVB4ANqEMwCIAUgBCAFKALgA2oiAzYC8AEgBSAGIAUoAuQDaiIGNgL0ASAFIAcgBSgC6ANqIgc2AvgBIAUgEiAFKALsA2oiEjYC/AEgBSAIIAUoAvADaiIINgKAAiAFIAkgBSgC9ANqIgk2AoQCIAUgCiAFKAL4A2oiCjYCiAIgBSALIAUoAvwDaiILNgKMAiAFIAwgBSgCgARqIgw2ApACIAUgDSAFKAKEBGoiDTYClAIgBSAOIAUoAogEaiIONgKYAiAFIA8gBSgCjARqIg82ApwCIAUgECAFKAKQBGoiEDYCoAIgBSARIAUoApQEaiIRNgKkAiAFIBMgBSgCmARqIgQ2AqgCIARBgICAEE4EQCAFQfABahDSAiAFKAKoAiEEIAUoAqQCIREgBSgCoAIhECAFKAKcAiEPIAUoApgCIQ4gBSgClAIhDSAFKAKQAiEMIAUoAowCIQsgBSgCiAIhCiAFKAKEAiEJIAUoAoACIQggBSgC/AEhEiAFKAL4ASEHIAUoAvQBIQYgBSgC8AEhAwsgFCAFQeADaiAFQcAHahD3AiAFIAQ2AvgHIAUgETYC9AcgBSAQNgLwByAFIA82AuwHIAUgDjYC6AcgBSANNgLkByAFIAw2AuAHIAUgCzYC3AcgBSAKNgLYByAFIAk2AtQHIAUgCDYC0AcgBSASNgLMByAFIAc2AsgHIAUgBjYCxAcgBSADNgLAByAFQcAHahD2AiAFIAUoArgINgLgAyAFIAX9AAK8CP0LAuQDIAUgBf0AAswI/QsC9AMgBSAF/QAC3Aj9CwKEBCAFIAX9AALsCP0LApQEIAUgBf0AAvwI/QsCpAQgBSAF/QACjAn9CwK0BCAFIAUpApwJNwLEBCAFIAUoAqQJNgLMBCAFIAUpAqgJNwLQBCAFIAUoAtAFNgLYBCAFIAUpAtQFNwLcBCAFIAX9AALcBf0LAuQEIAUgBf0AAuwF/QsC9AQgBSAF/QAC/AX9CwKEBSAFIAUpAowGNwKUBSAFIAUoApQGNgKcBSAFIAUoApgGNgKgBSAFIAUoApwGNgKkBSAFIAUoAqAGNgKoBSAFIAUoAqQGNgKsBSAFIAUoAqgGNgKwBSAFIAUoAqwGNgK0BSAFIAUoArAGNgK4BSAFIAUoArQGNgK8BSAFIAUoArgGNgLABSAFIAUoArwGNgLEBSAFIAUoAsAGNgLIBSAFIAUoAsQGNgLMBSAFQgA3A6ACIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOQAiAFIBf9CwOAAiAFIBf9CwPwASAFQQE2AqgCIAVCADcC3AIgBSAX/QsCzAIgBSAX/QsCvAIgBSAX/QsCrAIgBUEBNgLkAiAFQgA3A5gDIAUgF/0LA4gDIAUgF/0LA/gCIAUgF/0LA+gCIAVBATYCoAMgBUIANwLUAyAFIBf9CwLEAyAFIBf9CwK0AyAFIBf9CwKkAyAFQQE2AtwDIAUgBSgCwAc2AnggBSAFKALEBzYCfCAFIAUoAsgHNgKAASAFIAUoAswHNgKEASAFIAUoAtAHNgKIASAFIAUoAtQHNgKMASAFIAUoAtgHNgKQASAFIAUoAtwHNgKUASAFIAUoAuAHNgKYASAFIAUoAuQHNgKcASAFIAUoAugHNgKgASAFIAUoAuwHNgKkASAFIAUoAvAHNgKoASAFIAUoAvQHNgKsASAFIAUoAvgHNgKwASAFIAUoAvwHNgK0ASAFIAUoAoAINgK4ASAFIAUoAoQINgK8ASAFIAUoAogINgLAASAFIAUoAowINgLEASAFIAUoApAINgLIASAFIAUoApQINgLMASAFIAUoApgINgLQASAFIAUoApwINgLUASAFIAUoAqAINgLYASAFIAUoAqQINgLcASAFIAUoAqgINgLgASAFIAUoAqwINgLkASAFIAUoArAINgLoASAFIAUoArQINgLsASAFQgA3AzAgBSAX/QsDICAFIBf9CwMQIAUgF/0LAwAgBUEBNgI4IAVCADcCbCAFIBf9CwJcIAUgF/0LAkwgBSAX/QsCPCAFQQE2AnQgASACEPQCCyAFQeADaiAARwRAIAAgBSgC4AM2AgAgACAFKALkAzYCBCAAIAUoAugDNgIIIAAgBSgC7AM2AgwgACAFKALwAzYCECAAIAUoAvQDNgIUIAAgBSgC+AM2AhggACAFKAL8AzYCHCAAIAUoAoAENgIgIAAgBSgChAQ2AiQgACAFKAKIBDYCKCAAIAUoAowENgIsIAAgBSgCkAQ2AjAgACAFKAKUBDYCNCAAIAUoApgENgI4IAAgBSgCnAQ2AjwgACAFKAKgBDYCQCAAIAUoAqQENgJEIAAgBSgCqAQ2AkggACAFKAKsBDYCTCAAIAUoArAENgJQIAAgBSgCtAQ2AlQgACAFKAK4BDYCWCAAIAUoArwENgJcIAAgBSgCwAQ2AmAgACAFKALEBDYCZCAAIAUoAsgENgJoIAAgBSgCzAQ2AmwgACAFKALQBDYCcCAAIAUoAtQENgJ0IAAgBSgC2AQ2AnggACAFKALcBDYCfCAAIAUoAuAENgKAASAAIAUoAuQENgKEASAAIAUoAugENgKIASAAIAUoAuwENgKMASAAIAUoAvAENgKQASAAIAUoAvQENgKUASAAIAUoAvgENgKYASAAIAUoAvwENgKcASAAIAUoAoAFNgKgASAAIAUoAoQFNgKkASAAIAUoAogFNgKoASAAIAUoAowFNgKsASAAIAUoApAFNgKwASAAIAUoApQFNgK0ASAAIAUoApgFNgK4ASAAIAUoApwFNgK8ASAAIAUoAqAFNgLAASAAIAUoAqQFNgLEASAAIAUoAqgFNgLIASAAIAUoAqwFNgLMASAAIAUoArAFNgLQASAAIAUoArQFNgLUASAAIAUoArgFNgLYASAAIAUoArwFNgLcASAAIAUoAsAFNgLgASAAIAUoAsQFNgLkASAAIAUoAsgFNgLoASAAIAUoAswFNgLsAQsCQCAAIAVGDQAgACAFKALwATYC8AEgACAFKAL0ATYC9AEgACAFKAL4ATYC+AEgACAFKAL8ATYC/AEgACAFKAKAAjYCgAIgACAFKAKEAjYChAIgACAFKAKIAjYCiAIgACAFKAKMAjYCjAIgACAFKAKQAjYCkAIgACAFKAKUAjYClAIgACAFKAKYAjYCmAIgACAFKAKcAjYCnAIgACAFKAKgAjYCoAIgACAFKAKkAjYCpAIgACAFKAKoAjYCqAIgACAFKAKsAjYCrAIgACAFKAKwAjYCsAIgACAFKAK0AjYCtAIgACAFKAK4AjYCuAIgACAFKAK8AjYCvAIgACAFKALAAjYCwAIgACAFKALEAjYCxAIgACAFKALIAjYCyAIgACAFKALMAjYCzAIgACAFKALQAjYC0AIgACAFKALUAjYC1AIgACAFKALYAjYC2AIgACAFKALcAjYC3AIgACAFKALgAjYC4AIgACAFKALkAjYC5AIgACAFRg0AIAAgBSgC6AI2AugCIAAgBSgC7AI2AuwCIAAgBSgC8AI2AvACIAAgBSgC9AI2AvQCIAAgBSgC+AI2AvgCIAAgBSgC/AI2AvwCIAAgBSgCgAM2AoADIAAgBSgChAM2AoQDIAAgBSgCiAM2AogDIAAgBSgCjAM2AowDIAAgBSgCkAM2ApADIAAgBSgClAM2ApQDIAAgBSgCmAM2ApgDIAAgBSgCnAM2ApwDIAAgBSgCoAM2AqADIAAgBSgCpAM2AqQDIAAgBSgCqAM2AqgDIAAgBSgCrAM2AqwDIAAgBSgCsAM2ArADIAAgBSgCtAM2ArQDIAAgBSgCuAM2ArgDIAAgBSgCvAM2ArwDIAAgBSgCwAM2AsADIAAgBSgCxAM2AsQDIAAgBSgCyAM2AsgDIAAgBSgCzAM2AswDIAAgBSgC0AM2AtADIAAgBSgC1AM2AtQDIAAgBSgC2AM2AtgDIAAgBSgC3AM2AtwDCwJAIABB4ANqIAVGDQAgACAFKAIANgLgAyAAIAUoAgQ2AuQDIAAgBSgCCDYC6AMgACAFKAIMNgLsAyAAIAUoAhA2AvADIAAgBSgCFDYC9AMgACAFKAIYNgL4AyAAIAUoAhw2AvwDIAAgBSgCIDYCgAQgACAFKAIkNgKEBCAAIAUoAig2AogEIAAgBSgCLDYCjAQgACAFKAIwNgKQBCAAIAUoAjQ2ApQEIAAgBSgCODYCmAQgACAFKAI8NgKcBCAAIAUoAkA2AqAEIAAgBSgCRDYCpAQgACAFKAJINgKoBCAAIAUoAkw2AqwEIAAgBSgCUDYCsAQgACAFKAJUNgK0BCAAIAUoAlg2ArgEIAAgBSgCXDYCvAQgACAFKAJgNgLABCAAIAUoAmQ2AsQEIAAgBSgCaDYCyAQgACAFKAJsNgLMBCAAIAUoAnA2AtAEIAAgBSgCdDYC1AQgACAFQeADa0YNACAAIAUoAng2AtgEIAAgBSgCfDYC3AQgACAFKAKAATYC4AQgACAFKAKEATYC5AQgACAFKAKIATYC6AQgACAFKAKMATYC7AQgACAFKAKQATYC8AQgACAFKAKUATYC9AQgACAFKAKYATYC+AQgACAFKAKcATYC/AQgACAFKAKgATYCgAUgACAFKAKkATYChAUgACAFKAKoATYCiAUgACAFKAKsATYCjAUgACAFKAKwATYCkAUgACAFKAK0ATYClAUgACAFKAK4ATYCmAUgACAFKAK8ATYCnAUgACAFKALAATYCoAUgACAFKALEATYCpAUgACAFKALIATYCqAUgACAFKALMATYCrAUgACAFKALQATYCsAUgACAFKALUATYCtAUgACAFKALYATYCuAUgACAFKALcATYCvAUgACAFKALgATYCwAUgACAFKALkATYCxAUgACAFKALoATYCyAUgACAFKALsATYCzAULIABBAjYC0AUgBUGwCWokAAvXAgEJfwJAAkAgACgCJCAAKAIgIAAoAhwgACgCGCAAKAIUIAAoAhAgACgCDCAAKAIIIAAoAgQgACgCACIDQRx1aiIEQRx1aiIFQRx1aiIGQRx1aiIHQRx1aiIIQRx1aiIJQRx1aiICQRx1aiIBQRx1aiIABEBB/AEhAQwBCyABQf////8AcSIABEBB4AEhAQwBCyACQf////8AcSIABEBBxAEhAQwBCyAJQf////8AcSIABEBBqAEhAQwBCyAIQf////8AcSIABEBBjAEhAQwBCyAHQf////8AcSIABEBB8AAhAQwBCyAGQf////8AcSIABEBB1AAhAQwBCyAFQf////8AcSIABEBBOCEBDAELIARB/////wBxIgAEQEEcIQEMAQtBACEBIANB/////wBxIgBFDQELA0AgAUEBaiEBIABBAWohAiAAQQJtIQAgAkECSw0ACwsgAQvZDgEUfiACNAIkIQQgATQCJCEMIAI0AiAhDSABNAIgIQ4gAjQCHCEPIAE0AhwhBSACNAIYIRAgATQCGCEGIAI0AhQhESABNAIUIQcgAjQCECESIAE0AhAhCCACNAIMIRMgATQCDCEJIAI0AgghFCABNAIIIQogAjQCBCEVIAE0AgQhCyAAIAI0AgAgATQCAH4iA6dB/////wBxNgIAIAAgCyAVfiIVIAN8IgsgA0Ich3wgAigCACACKAIEa6wgASgCBCABKAIAa6x+fCIWp0H/////AHE2AgQgACAKIBR+IhQgC3wiCiAWQhyHfCACKAIAIAIoAghrrCABKAIIIAEoAgBrrH58IgunQf////8AcTYCCCAAIAkgE34iEyAKfCIJIAtCHId8IAIoAgAgAigCDGusIAEoAgwgASgCAGusfnwgAigCBCACKAIIa6wgASgCCCABKAIEa6x+fCIKp0H/////AHE2AgwgACAIIBJ+IhIgCXwiCCAKQhyHfCACKAIAIAIoAhBrrCABKAIQIAEoAgBrrH58IAIoAgQgAigCDGusIAEoAgwgASgCBGusfnwiCadB/////wBxNgIQIAAgByARfiIRIAh8IgcgCUIch3wgAigCACACKAIUa6wgASgCFCABKAIAa6x+fCACKAIEIAIoAhBrrCABKAIQIAEoAgRrrH58IAIoAgggAigCDGusIAEoAgwgASgCCGusfnwiCKdB/////wBxNgIUIAAgBiAQfiIQIAd8IgYgCEIch3wgAigCACACKAIYa6wgASgCGCABKAIAa6x+fCACKAIEIAIoAhRrrCABKAIUIAEoAgRrrH58IAIoAgggAigCEGusIAEoAhAgASgCCGusfnwiB6dB/////wBxNgIYIAAgBSAPfiIPIAZ8IgUgB0Ich3wgAigCACACKAIca6wgASgCHCABKAIAa6x+fCACKAIEIAIoAhhrrCABKAIYIAEoAgRrrH58IAIoAgggAigCFGusIAEoAhQgASgCCGusfnwgAigCDCACKAIQa6wgASgCECABKAIMa6x+fCIGp0H/////AHE2AhwgACANIA5+Ig0gBXwiDiAGQhyHfCACKAIAIAIoAiBrrCABKAIgIAEoAgBrrH58IAIoAgQgAigCHGusIAEoAhwgASgCBGusfnwgAigCCCACKAIYa6wgASgCGCABKAIIa6x+fCACKAIMIAIoAhRrrCABKAIUIAEoAgxrrH58IgWnQf////8AcTYCICAAIAQgDH4gDnwiBCAFQhyHfCACKAIAIAIoAiRrrCABKAIkIAEoAgBrrH58IAIoAgQgAigCIGusIAEoAiAgASgCBGusfnwgAigCCCACKAIca6wgASgCHCABKAIIa6x+fCACKAIMIAIoAhhrrCABKAIYIAEoAgxrrH58IAIoAhAgAigCFGusIAEoAhQgASgCEGusfnwiDKdB/////wBxNgIkIAAgBCADfSIDIAxCHId8IAIoAgQgAigCJGusIAEoAiQgASgCBGusfnwgAigCCCACKAIga6wgASgCICABKAIIa6x+fCACKAIMIAIoAhxrrCABKAIcIAEoAgxrrH58IAIoAhAgAigCGGusIAEoAhggASgCEGusfnwiBKdB/////wBxNgIoIAAgAyAVfSIDIARCHId8IAIoAgggAigCJGusIAEoAiQgASgCCGusfnwgAigCDCACKAIga6wgASgCICABKAIMa6x+fCACKAIQIAIoAhxrrCABKAIcIAEoAhBrrH58IAIoAhQgAigCGGusIAEoAhggASgCFGusfnwiBKdB/////wBxNgIsIAAgAyAUfSIDIARCHId8IAIoAgwgAigCJGusIAEoAiQgASgCDGusfnwgAigCECACKAIga6wgASgCICABKAIQa6x+fCACKAIUIAIoAhxrrCABKAIcIAEoAhRrrH58IgSnQf////8AcTYCMCAAIAMgE30iAyAEQhyHfCACKAIQIAIoAiRrrCABKAIkIAEoAhBrrH58IAIoAhQgAigCIGusIAEoAiAgASgCFGusfnwgAigCGCACKAIca6wgASgCHCABKAIYa6x+fCIEp0H/////AHE2AjQgACADIBJ9IgMgBEIch3wgAigCFCACKAIka6wgASgCJCABKAIUa6x+fCACKAIYIAIoAiBrrCABKAIgIAEoAhhrrH58IgSnQf////8AcTYCOCAAIAMgEX0iAyAEQhyHfCACKAIYIAIoAiRrrCABKAIkIAEoAhhrrH58IAIoAhwgAigCIGusIAEoAiAgASgCHGusfnwiBKdB/////wBxNgI8IAAgAyAQfSIDIARCHId8IAIoAhwgAigCJGusIAEoAiQgASgCHGusfnwiBKdB/////wBxNgJAIAAgAyAPfSIDIARCHId8IAIoAiAgAigCJGusIAEoAiQgASgCIGusfnwiBKdB/////wBxNgJEIAAgAyANfSAEQhyHfCIDQhyIPgJMIAAgA6dB/////wBxNgJIC+sIAgJ+CH8gACABNAIAIgIgAn4iAqdB/////wBxNgIAIAAgATQCACABQQRqIgQ0AgB+QgGGIAJCHIh8IgKnQf////8AcTYCBCAAIAE0AgAgAUEIaiIFNAIAfkIBhiACQhyHfCAENAIAIgIgAn58IgKnQf////8AcTYCCCAAIAQ0AgAgBTQCAH4gATQCACABQQxqIgY0AgB+fEIBhiACQhyHfCICp0H/////AHE2AgwgACAENAIAIAY0AgB+IAE0AgAgAUEQaiIHNAIAfnxCAYYgAkIch3wgBTQCACICIAJ+fCICp0H/////AHE2AhAgACAENAIAIAc0AgB+IAE0AgAgAUEUaiIINAIAfnwgBTQCACAGNAIAfnxCAYYgAkIch3wiAqdB/////wBxNgIUIAAgBDQCACAINAIAfiABNAIAIAFBGGoiCTQCAH58IAU0AgAgBzQCAH58QgGGIAJCHId8IAY0AgAiAiACfnwiAqdB/////wBxNgIYIAAgBDQCACAJNAIAfiABNAIAIAFBHGoiCjQCAH58IAU0AgAgCDQCAH58IAY0AgAgBzQCAH58QgGGIAJCHId8IgKnQf////8AcTYCHCAAIAQ0AgAgCjQCAH4gATQCACABNAIgfnwgBTQCACAJNAIAfnwgBjQCACAINAIAfnxCAYYgAkIch3wgBzQCACICIAJ+fCICp0H/////AHE2AiAgACAENAIAIAE0AiB+IAE0AgAgAUEkaiILNAIAfnwgBTQCACAKNAIAfnwgBjQCACAJNAIAfnwgBzQCACAINAIAfnxCAYYgAkIch3wiAqdB/////wBxNgIkIAAgBTQCACABNAIgfiAENAIAIAs0AgB+fCAGNAIAIAo0AgB+fCAHNAIAIAk0AgB+fEIBhiACQhyHfCAINAIAIgIgAn58IgKnQf////8AcTYCKCAAIAY0AgAgATQCIH4gBTQCACALNAIAfnwgBzQCACAKNAIAfnwgCDQCACAJNAIAfnxCAYYgAkIch3wiAqdB/////wBxNgIsIAAgBzQCACABNAIgfiAGNAIAIAs0AgB+fCAINAIAIAo0AgB+fEIBhiACQhyHfCAJNAIAIgIgAn58IgKnQf////8AcTYCMCAAIAg0AgAgATQCIH4gBzQCACALNAIAfnwgCTQCACAKNAIAfnxCAYYgAkIch3wiAqdB/////wBxNgI0IAAgCTQCACABNAIgfiAINAIAIAs0AgB+fEIBhiACQhyHfCAKNAIAIgIgAn58IgKnQf////8AcTYCOCAAIAo0AgAgATQCIH4gCTQCACALNAIAfnxCAYYgAkIch3wiAqdB/////wBxNgI8IAAgCjQCACALNAIAfkIBhiACQhyHfCABNAIgIgIgAn58IgKnQf////8AcTYCQCAAIAE0AiAgCzQCAH5CAYYgAkIch3wiAqdB/////wBxNgJEIAAgCzQCACIDIAN+IAJCHId8IgJCHIg+AkwgACACp0H/////AHE2AkgL7wsCDX4RfyAAIAEoAhgiHCABKAIQIhtrrCABKAIMIhogASgCBCIQa6wgAjQCBCACKAIAIhFBseqUEWxB/////wBxrSIDIAE0AgAiBH4gEax8QhyHfCAQrCIOIAN+fCIMp0Gx6pQRbEH/////AHEiESABKAIIIhkgEGusIBEgEa0iBiAOfiIOIAI0AgggBCAGfiAMfEIch3x8IBmsIgwgA358IganQbHqlBFsQf////8AcSISa6x+IBKtIgcgDH4iDCAOfCIFIAI0AgwgBCAHfiAGfEIch3x8IBqsIgYgA358fCIHp0Gx6pQRbEH/////AHEiE2usfiATrSIIIAZ+IgYgBXwiBSACNAIQIAQgCH4gB3xCHId8fCAbrCIHIAN+fHwiCKdBseqUEWxB/////wBxIhQgASgCFCIdIBBrrCARIBStIgkgB34iByAFfCIFIAI0AhQgBCAJfiAIfEIch3x8IB2sIgggA358IBsgEGusIBEgFGusfnwgGiAZa6wgEiATa6x+fCIJp0Gx6pQRbEH/////AHEiFWusfiAVrSIKIAh+IgggBXwiBSACNAIYIAQgCn4gCXxCHId8fCAcrCIJIAN+fHwgGyAZa6wgEiAUa6x+fCIKp0Gx6pQRbEH/////AHEiFmusfiABKAIcIh4gGmusIBMgFq0iCyAJfiIJIAV8IgUgAjQCHCAEIAt+IAp8QhyHfHwgHqwiCiADfnwgHCAQa6wgESAWa6x+fCAdIBlrrCASIBVrrH58IBsgGmusIBMgFGusfnwiC6dBseqUEWxB/////wBxIhdrrH4gASgCICIfIBlrrCASIBetIg0gCn4iCiAFfCIFIAI0AiAgBCANfiALfEIch3x8IB+sIgsgA358IB4gEGusIBEgF2usfnwgHCAZa6wgEiAWa6x+fCAdIBprrCATIBVrrH58Ig2nQbHqlBFsQf////8AcSIYa6x+IAEoAiQiICAQa6wgESAYrSIPIAt+IgsgBXwiBSACNAIkIAQgD34gDXxCHId8fCAgrCINIAN+fCAfIBBrrCARIBhrrH58IB4gGWusIBIgF2usfnwgHCAaa6wgEyAWa6x+fCAdIBtrrCAUIBVrrH58IgOnQbHqlBFsQf////8AcSIQa6x+IBCtIg8gDX4gBXwiBSACNAIoIAQgD34gA3xCHId8fHx8fHwiA6dB/////wBxNgIAIAAgBSAOfSIEIAI0AiwgA0Ich3x8IAEoAiQgASgCCGusIBIgEGusfnwgASgCICABKAIMa6wgEyAYa6x+fCABKAIcIAEoAhBrrCAUIBdrrH58IAEoAhggASgCFGusIBUgFmusfnwiA6dB/////wBxNgIEIAAgBCAMfSIEIAI0AjAgA0Ich3x8IAEoAiQgASgCDGusIBMgEGusfnwgASgCICABKAIQa6wgFCAYa6x+fCABKAIcIAEoAhRrrCAVIBdrrH58IgOnQf////8AcTYCCCAAIAQgBn0iBCACNAI0IANCHId8fCABKAIkIAEoAhBrrCAUIBBrrH58IAEoAiAgASgCFGusIBUgGGusfnwgASgCHCABKAIYa6wgFiAXa6x+fCIDp0H/////AHE2AgwgACAEIAd9IgQgAjQCOCADQhyHfHwgASgCJCABKAIUa6wgFSAQa6x+fCABKAIgIAEoAhhrrCAWIBhrrH58IgOnQf////8AcTYCECAAIAQgCH0iBCACNAI8IANCHId8fCABKAIkIAEoAhhrrCAWIBBrrH58IAEoAiAgASgCHGusIBcgGGusfnwiA6dB/////wBxNgIUIAAgBCAJfSIEIAI0AkAgA0Ich3x8IAEoAiQgASgCHGusIBcgEGusfnwiA6dB/////wBxNgIYIAAgBCAKfSIEIAI0AkQgA0Ich3x8IAEoAiQgASgCIGusIBggEGusfnwiA6dB/////wBxNgIcIAAgAjQCSCADQhyHfCAEIAt9fCIDp0H/////AHE2AiAgACACKAJMIANCHIinakH/////AHE2AiQLwQEBAn8CfwJAIAAoAiQiAiABKAIkIgNHDQAgACgCICICIAEoAiAiA0cNACAAKAIcIgIgASgCHCIDRw0AIAAoAhgiAiABKAIYIgNHDQAgACgCFCICIAEoAhQiA0cNACAAKAIQIgIgASgCECIDRw0AIAAoAgwiAiABKAIMIgNHDQAgACgCCCICIAEoAggiA0cNACAAKAIEIgIgASgCBCIDRw0AQQAgACgCACICIAEoAgAiA0YNARoLQQFBfyACIANKGwsL6wIBAn8CfwJAIAAoAkwiAiABKAJMIgNHDQAgACgCSCICIAEoAkgiA0cNACAAKAJEIgIgASgCRCIDRw0AIAAoAkAiAiABKAJAIgNHDQAgACgCPCICIAEoAjwiA0cNACAAKAI4IgIgASgCOCIDRw0AIAAoAjQiAiABKAI0IgNHDQAgACgCMCICIAEoAjAiA0cNACAAKAIsIgIgASgCLCIDRw0AIAAoAigiAiABKAIoIgNHDQAgACgCJCICIAEoAiQiA0cNACAAKAIgIgIgASgCICIDRw0AIAAoAhwiAiABKAIcIgNHDQAgACgCGCICIAEoAhgiA0cNACAAKAIUIgIgASgCFCIDRw0AIAAoAhAiAiABKAIQIgNHDQAgACgCDCICIAEoAgwiA0cNACAAKAIIIgIgASgCCCIDRw0AIAAoAgQiAiABKAIEIgNHDQBBACAAKAIAIgIgASgCACIDRg0BGgtBAUF/IAIgA0obCwvACgEefyABKAIgIQcgASgCHCEIIAEoAhghCSABKAIUIQogASgCECELIAEoAgwhDCABKAIIIQ0gASgCBCEFIAEoAgAhDiABKAIkIQEgACAAKAIAIgNB/////wBxIg82AgAgACAAKAIEIANBHHVqIgNB/////wBxIhA2AgQgACAAKAIIIANBHHVqIgNB/////wBxIhE2AgggACAAKAIMIANBHHVqIgNB/////wBxIhI2AgwgACAAKAIQIANBHHVqIgNB/////wBxIhM2AhAgACAAKAIUIANBHHVqIgNB/////wBxIhQ2AhQgACAAKAIYIANBHHVqIgNB/////wBxIhU2AhggACAAKAIcIANBHHVqIgNB/////wBxIhY2AhwgACAAKAIgIANBHHVqIgNB/////wBxIhc2AiAgACAAKAIkIANBHHVqIgM2AiQgAyEGIAEhAgJAAkACQCABIANHDQAgFyEGIBcgByICRw0AIBYhBiAWIAgiAkcNACAVIQYgFSAJIgJHDQAgFCEGIBQgCiICRw0AIBMhBiATIAsiAkcNACASIQYgEiAMIgJHDQAgESEGIBEgDSICRw0AIBAhBiAFIQIgBSAQRw0AIA8hBiAPIA4iAkYNAQsgAiAGTg0BC0EAIQYDQCAFIgJBAXRB/v///wBxIA5BG3VyIQUgDSIEQQF0Qf7///8AcSACQRt1ciENIAwiAkEBdEH+////AHEgBEEbdXIhDCALIgRBAXRB/v///wBxIAJBG3VyIQsgCiICQQF0Qf7///8AcSAEQRt1ciEKIAkiBEEBdEH+////AHEgAkEbdXIhCSAIIgJBAXRB/v///wBxIARBG3VyIQggByIEQQF0Qf7///8AcSACQRt1ciEHIAZBAWohBiAOQQF0Qf7///8AcSEOIAMhAiABQQF0IARBG3VyIgEhBAJAIAEgA0cNACAHIgQgFyICRw0AIAgiBCAWIgJHDQAgCSIEIBUiAkcNACAKIgQgFCICRw0AIAsiBCATIgJHDQAgDCIEIBIiAkcNACANIgQgESICRw0AIAUhBCAQIgIgBUcNACAOIgQgDyICRg0BCyACIARKDQALA0AgECANQRt0QYCAgMAAcSAFQQF1ciICayAPIAVBG3RBgICAwABxIA5BAXZyIg5rIgRBHHVqIhhBHHUgESAMQRt0QYCAgMAAcSANQQF1ciINa2oiGUEcdSASIAtBG3RBgICAwABxIAxBAXVyIgxraiIaQRx1IBMgCkEbdEGAgIDAAHEgC0EBdXIiC2tqIhtBHHUgFCAJQRt0QYCAgMAAcSAKQQF1ciIKa2oiHEEcdSAVIAhBG3RBgICAwABxIAlBAXVyIglraiIdQRx1IBYgB0EbdEGAgIDAAHEgCEEBdXIiCGtqIh5BHHUgFyABQRt0QYCAgMAAcSAHQQF1ciIHa2oiH0EcdSADIAFBAXUiAWtqIgUgAyAFQQBOIgUbIQMgH0H/////AHEgFyAFGyEXIB5B/////wBxIBYgBRshFiAdQf////8AcSAVIAUbIRUgHEH/////AHEgFCAFGyEUIBtB/////wBxIBMgBRshEyAaQf////8AcSASIAUbIRIgGUH/////AHEgESAFGyERIBhB/////wBxIBAgBRshECAEQf////8AcSAPIAUbIQ8gBkEBSiEEIAZBAWshBiACIQUgBA0ACyAAIAM2AiQgACAXNgIgIAAgFjYCHCAAIBU2AhggACAUNgIUIAAgEzYCECAAIBI2AgwgACARNgIIIAAgEDYCBCAAIA82AgALC5YUAj1/AXsjAEHQAGsiBCQAIAEgASgCACIDQf////8AcTYCACABIAEoAgQgA0EcdWoiA0H/////AHE2AgQgASABKAIIIANBHHVqIgNB/////wBxNgIIIAEgASgCDCADQRx1aiIDQf////8AcTYCDCABIAEoAhAgA0EcdWoiA0H/////AHE2AhAgASABKAIUIANBHHVqIgNB/////wBxNgIUIAEgASgCGCADQRx1aiIDQf////8AcTYCGCABIAEoAhwgA0EcdWoiA0H/////AHE2AhwgASABKAIgIANBHHVqIgNB/////wBxNgIgIAEgASgCJCADQRx1aiIDQf////8AcTYCJCABIAEoAiggA0EcdWoiA0H/////AHE2AiggASABKAIsIANBHHVqIgNB/////wBxNgIsIAEgASgCMCADQRx1aiIDQf////8AcTYCMCABIAEoAjQgA0EcdWoiA0H/////AHE2AjQgASABKAI4IANBHHVqIgNB/////wBxNgI4IAEgASgCPCADQRx1aiIDQf////8AcTYCPCABIAEoAkAgA0EcdWoiA0H/////AHE2AkAgASABKAJEIANBHHVqIgNB/////wBxNgJEIAEgASgCSCADQRx1aiIDQf////8AcTYCSCABIAEoAkwgA0EcdWo2AkwgBCACKAIAIhY2AgAgBCACKAIEIgM2AgQgBCACKAIIIgY2AgggBCACKAIMIgc2AgwgBCACKAIQIgg2AhAgBCACKAIUIgk2AhQgBCACKAIYIgo2AhggBCACKAIcIgs2AhwgBCACKAIgIgw2AiAgAigCJCEFIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwI8QQAhAiAEQQA2AkwgBCBA/QsCLCAEIAVBHHUiDTYCKCAEIAVB/////wBxIgU2AiQCQCABIAQQ0QhBAE4EQANAIAQgF0EBdCARQRt1ciIXNgJMIAQgEUEBdEH+////AHEgEEEbdXIiETYCSCAEIBBBAXRB/v///wBxIA9BG3VyIhA2AkQgBCAPQQF0Qf7///8AcSAOQRt1ciIPNgJAIAQgDkEBdEH+////AHEgAkEbdXIiDjYCPCAEIAJBAXRB/v///wBxIBRBG3VyIgI2AjggBCAUQQF0Qf7///8AcSATQRt1ciIUNgI0IAQgE0EBdEH+////AHEgEkEbdXIiEzYCMCAEIBJBAXRB/v///wBxIA1BG3VyIhI2AiwgBCANQQF0Qf7///8AcSAFQRt1ciINNgIoIAQgBUEBdEH+////AHEgDEEbdXIiBTYCJCAEIAxBAXRB/v///wBxIAtBG3VyIgw2AiAgBCALQQF0Qf7///8AcSAKQRt1ciILNgIcIAQgCkEBdEH+////AHEgCUEbdXIiCjYCGCAEIAlBAXRB/v///wBxIAhBG3VyIgk2AhQgBCAIQQF0Qf7///8AcSAHQRt1ciIINgIQIAQgB0EBdEH+////AHEgBkEbdXIiBzYCDCAEIAZBAXRB/v///wBxIANBG3VyIgY2AgggBCADQQF0Qf7///8AcSAWQRt1ciIDNgIEIAQgFkEBdEH+////AHEiFjYCACAYQQFqIRggASAEENEIQQBODQALIAEoAkwhGiABKAJIIRsgASgCRCEcIAEoAkAhHSABKAI8IR4gASgCOCEfIAEoAjQhICABKAIwISEgASgCLCEiIAEoAighIyABKAIkISQgASgCICElIAEoAhwhJiABKAIYIScgASgCFCEoIAEoAhAhKSABKAIMISogASgCCCErIAEoAgQhLCABKAIAIRUDQCAGQRt0IS0gB0EbdCEZIAhBG3QhLiAJQRt0IS8gCkEbdCEwIAtBG3QhMSAMQRt0ITIgBUEbdCEzIA1BG3QhNCASQRt0ITUgE0EbdCE2IBRBG3QhNyACQRt0ITggDkEbdCE5IA9BG3QhOiAQQRt0ITsgEUEbdCE8IBdBG3QhPSAaIBdBAXUiF2sgGyA9QYCAgMAAcSARQQF1ciIRayAcIDxBgICAwABxIBBBAXVyIhBrIB0gO0GAgIDAAHEgD0EBdXIiD2sgHiA6QYCAgMAAcSAOQQF1ciIOayAfIDlBgICAwABxIAJBAXVyIgJrICAgOEGAgIDAAHEgFEEBdXIiFGsgISA3QYCAgMAAcSATQQF1ciITayAiIDZBgICAwABxIBJBAXVyIhJrICMgNUGAgIDAAHEgDUEBdXIiDWsgJCA0QYCAgMAAcSAFQQF1ciIFayAlIDNBgICAwABxIAxBAXVyIgxrICYgMkGAgIDAAHEgC0EBdXIiC2sgJyAxQYCAgMAAcSAKQQF1ciIKayAoIDBBgICAwABxIAlBAXVyIglrICkgL0GAgIDAAHEgCEEBdXIiCGsgKiAuQYCAgMAAcSAHQQF1ciIHayArIBlBgICAwABxIAZBAXVyIgZrICwgLUGAgIDAAHEgA0EBdXIiLWsgFSADQRt0QYCAgMAAcSAWQQF2ciIWayIZQRx1aiIuQRx1aiIvQRx1aiIwQRx1aiIxQRx1aiIyQRx1aiIzQRx1aiI0QRx1aiI1QRx1aiI2QRx1aiI3QRx1aiI4QRx1aiI5QRx1aiI6QRx1aiI7QRx1aiI8QRx1aiI9QRx1aiI+QRx1aiI/QRx1aiIDIBogA0EATiIDGyEaID9B/////wBxIBsgAxshGyA+Qf////8AcSAcIAMbIRwgPUH/////AHEgHSADGyEdIDxB/////wBxIB4gAxshHiA7Qf////8AcSAfIAMbIR8gOkH/////AHEgICADGyEgIDlB/////wBxICEgAxshISA4Qf////8AcSAiIAMbISIgN0H/////AHEgIyADGyEjIDZB/////wBxICQgAxshJCA1Qf////8AcSAlIAMbISUgNEH/////AHEgJiADGyEmIDNB/////wBxICcgAxshJyAyQf////8AcSAoIAMbISggMUH/////AHEgKSADGyEpIDBB/////wBxICogAxshKiAvQf////8AcSArIAMbISsgLkH/////AHEgLCADGyEsIBlB/////wBxIBUgAxshFSAYQQFKIRkgLSEDIBhBAWshGCAZDQALIAEgGjYCTCABIBs2AkggASAcNgJEIAEgHTYCQCABIB42AjwgASAfNgI4IAEgIDYCNCABICE2AjAgASAiNgIsIAEgIzYCKCABICQ2AiQgASAlNgIgIAEgJjYCHCABICc2AhggASAoNgIUIAEgKTYCECABICo2AgwgASArNgIIIAEgLDYCBCABIBU2AgAMAQsgASgCACEVCyAAIBU2AgAgACABKAIENgIEIAAgASgCCDYCCCAAIAEoAgw2AgwgACABKAIQNgIQIAAgASgCFDYCFCAAIAEoAhg2AhggACABKAIcNgIcIAAgASgCIDYCICAAIAEoAiQ2AiQgBEHQAGokAAuvBQEofyMAQdAAayIDJAADQCAYIAEQzAhBAXRORQRAAn8gGUUEQCACEGkMAQsgGkEBdgshGiAXQQF0IBZBG3VyIRcgBEEbdiEbIAVBG3UhHCAGQRt1IR0gB0EbdSEeIAhBG3UhHyAJQRt1ISAgC0EbdSEhIAxBG3UhIiANQRt1ISMgDkEbdSEkIA9BG3UhJSAQQRt1ISYgEUEbdSEnIBJBG3UhKCATQRt1ISkgFEEbdSEqIBZBAXRB/v///wBxIBVBG3VyIRYgGEEBaiEYIBlBAWpBB3EhGSAEQQF0Qf7///8AcSAaQQFxciEEIBsgBUEBdEH+////AHFyIQUgHCAGQQF0Qf7///8AcXIhBiAdIAdBAXRB/v///wBxciEHIB4gCEEBdEH+////AHFyIQggCUEBdEH+////AHEgCkEbdXIhCSAfIApBAXRB/v///wBxciEKICAgC0EBdEH+////AHFyIQsgISAMQQF0Qf7///8AcXIhDCAiIA1BAXRB/v///wBxciENICMgDkEBdEH+////AHFyIQ4gJCAPQQF0Qf7///8AcXIhDyAlIBBBAXRB/v///wBxciEQICYgEUEBdEH+////AHFyIREgJyASQQF0Qf7///8AcXIhEiAoIBNBAXRB/v///wBxciETICkgFEEBdEH+////AHFyIRQgKiAVQQF0Qf7///8AcXIhFQwBCwsgAyAWNgJIIAMgFzYCTCADIBU2AkQgAyAUNgJAIAMgEzYCPCADIBI2AjggAyARNgI0IAMgEDYCMCADIA82AiwgAyAONgIoIAMgDTYCJCADIAw2AiAgAyALNgIcIAMgCTYCGCADIAo2AhQgAyAINgIQIAMgBzYCDCADIAY2AgggAyAFNgIEIAMgBDYCACAAIAMgARDTCCADQdAAaiQAC4wCAQF/IwBBsAFrIgQkACAEIAEoAgA2AjAgBCABKAIENgI0IAQgASgCCDYCOCAEIAEoAgw2AjwgBCABKAIQNgJAIAQgASgCFDYCRCAEIAEoAhg2AkggBCABKAIcNgJMIAQgASgCIDYCUCAEIAEoAiQ2AlQgBCACKAIANgIAIAQgAigCBDYCBCAEIAIoAgg2AgggBCACKAIMNgIMIAQgAigCEDYCECAEIAIoAhQ2AhQgBCACKAIYNgIYIAQgAigCHDYCHCAEIAIoAiA2AiAgBCACKAIkNgIkIARBMGogAxDSCCAEIAMQ0gggBEHgAGogBEEwaiAEEM0IIAAgBEHgAGogAxDTCCAEQbABaiQAC8UZAUF/IAEgAhDSCCABKAIkIQYgASgCICEHIAEoAhwhIyABKAIYISQgASgCFCElIAEoAhAhJiABKAIMIScgASgCCCEoIAEoAgQhKSABKAIAISFBACEBIAIoAiQiMSEIIAIoAiAiMiEJIAIoAhwiMyEqIAIoAhgiNCErIAIoAhQiNSEsIAIoAhAiNiEtIAIoAgwiNyEuIAIoAggiOCEvIAIoAgQiOSEwIAIoAgAiOiEiQQEhBUEAIQIDQAJAAkACQCAGDQAgBw0AICMNACAkDQAgJQ0AICYNACAnDQAgKA0AICkNACAhQQFGDQELIAgNASAJDQEgKg0BICsNASAsDQEgLQ0BIC4NASAvDQEgMA0BICJBAUcNASAMIQUgGCETIBkhEiAaIREgGyEQIBQhDyAVIQ4gFiENIAshCiACIQELIAAgATYCJCAAIAo2AiAgACANNgIcIAAgDjYCGCAAIA82AhQgACAQNgIQIAAgETYCDCAAIBI2AgggACATNgIEIAAgBTYCAA8LICFBAXFFBEADQCAGQRt0QYCAgMAAcSE7IAdBG3RBgICAwABxITwgI0EbdEGAgIDAAHEhPSAkQRt0QYCAgMAAcSE+ICVBG3RBgICAwABxIT8gJkEbdEGAgIDAAHEhQCAnQRt0QYCAgMAAcSFBIChBG3RBgICAwABxIUIgKUEbdEGAgIDAAHEhQwJAIAVBAXFFBEAgCiEDIA0hBCAOIRcgDyEcIBAhHSARIR4gEiEfIBMhIAwBCyATIDlqIAUgOmoiBUEcdWoiA0H/////AHEhICASIDhqIANBHHVqIgNB/////wBxIR8gESA3aiADQRx1aiIDQf////8AcSEeIBAgNmogA0EcdWoiA0H/////AHEhHSAPIDVqIANBHHVqIgNB/////wBxIRwgDiA0aiADQRx1aiIDQf////8AcSEXIA0gM2ogA0EcdWoiA0H/////AHEhBCAKIDJqIANBHHVqIgpB/////wBxIQMgASAxaiAKQRx1aiEBIAVB/////wBxIQULIDsgB0EBdXIhByA8ICNBAXVyISMgPSAkQQF1ciEkID4gJUEBdXIhJSA/ICZBAXVyISYgQCAnQQF1ciEnIEEgKEEBdXIhKCBCIClBAXVyISkgBkEBdSEGIAFBG3RBgICAwABxIANBAXZyIQogA0EbdEGAgIDAAHEgBEEBdnIhDSAEQRt0QYCAgMAAcSAXQQF2ciEOIBdBG3RBgICAwABxIBxBAXZyIQ8gHEEbdEGAgIDAAHEgHUEBdnIhECAdQRt0QYCAgMAAcSAeQQF2ciERIB5BG3RBgICAwABxIB9BAXZyIRIgH0EbdEGAgIDAAHEgIEEBdnIhEyAgQRt0QYCAgMAAcSAFQQF2ciEFIAFBAXUhASAhQQJxIQMgQyAhQQF1ciEhIANFDQALCyAiQQFxRQRAA0AgCEEbdEGAgIDAAHEhOyAJQRt0QYCAgMAAcSE8ICpBG3RBgICAwABxIT0gK0EbdEGAgIDAAHEhPiAsQRt0QYCAgMAAcSE/IC1BG3RBgICAwABxIUAgLkEbdEGAgIDAAHEhQSAvQRt0QYCAgMAAcSFCIDBBG3RBgICAwABxIUMCQCAMQQFxRQRAIBghAyAZIQQgGiEXIBshHCAUIR0gFSEeIBYhHyALISAMAQsgGCA5aiAMIDpqIgxBHHVqIgRB/////wBxIQMgGSA4aiAEQRx1aiIXQf////8AcSEEIBogN2ogF0EcdWoiHEH/////AHEhFyAbIDZqIBxBHHVqIh1B/////wBxIRwgFCA1aiAdQRx1aiIeQf////8AcSEdIBUgNGogHkEcdWoiH0H/////AHEhHiAWIDNqIB9BHHVqIiBB/////wBxIR8gCyAyaiAgQRx1aiILQf////8AcSEgIAIgMWogC0EcdWohAiAMQf////8AcSEMCyA7IAlBAXVyIQkgPCAqQQF1ciEqID0gK0EBdXIhKyA+ICxBAXVyISwgPyAtQQF1ciEtIEAgLkEBdXIhLiBBIC9BAXVyIS8gQiAwQQF1ciEwIAhBAXUhCCACQRt0QYCAgMAAcSAgQQF2ciELICBBG3RBgICAwABxIB9BAXZyIRYgH0EbdEGAgIDAAHEgHkEBdnIhFSAeQRt0QYCAgMAAcSAdQQF2ciEUIB1BG3RBgICAwABxIBxBAXZyIRsgHEEbdEGAgIDAAHEgF0EBdnIhGiAXQRt0QYCAgMAAcSAEQQF2ciEZIARBG3RBgICAwABxIANBAXZyIRggA0EbdEGAgIDAAHEgDEEBdnIhDCACQQF1IQIgIkECcSEDIEMgIkEBdXIhIiADRQ0ACwsCQAJAAkAgBiIDIAgiBEcNACAHIgMgCSIERw0AICMiAyAqIgRHDQAgJCIDICsiBEcNACAlIgMgLCIERw0AICYiAyAtIgRHDQAgJyIDIC4iBEcNACAoIgMgLyIERw0AICkiAyAwIgRHDQAgISIDICIiBEYNAQsgAyAETA0BCyAHIAlrICMgKmsgJCArayAlICxrICYgLWsgJyAuayAoIC9rICkgMGsgISAiayIhQRx1aiIpQRx1aiIoQRx1aiInQRx1aiImQRx1aiIlQRx1aiIkQRx1aiIjQRx1aiIDQRx1IQQgBiAIayEXIAEhBiACIQcCQAJAIAEgAkcNACAKIQYgCyEHIAogC0cNACANIQYgFiEHIA0gFkcNACAOIQYgFSEHIA4gFUcNACAPIQYgFCEHIA8gFEcNACAQIQYgGyEHIBAgG0cNACARIQYgGiEHIBEgGkcNACASIQYgGSEHIBIgGUcNACATIQYgGCEHIBMgGEcNACAFIQYgDCEHIAUgDEYNAQsgBiAHSg0AIAEgMWohASAKIDJqIQogDSAzaiENIA4gNGohDiAPIDVqIQ8gECA2aiEQIBEgN2ohESASIDhqIRIgEyA5aiETIAUgOmohBQsgKUH/////AHEhKSAoQf////8AcSEoICdB/////wBxIScgJkH/////AHEhJiAlQf////8AcSElICRB/////wBxISQgI0H/////AHEhIyADQf////8AcSEHIAQgF2ohBiAhQf7///8AcSEhIBMgGGsgBSAMayIFQRx1aiIDQf////8AcSETIBIgGWsgA0EcdWoiA0H/////AHEhEiARIBprIANBHHVqIgNB/////wBxIREgECAbayADQRx1aiIDQf////8AcSEQIA8gFGsgA0EcdWoiA0H/////AHEhDyAOIBVrIANBHHVqIgNB/////wBxIQ4gDSAWayADQRx1aiIDQf////8AcSENIAogC2sgA0EcdWoiA0H/////AHEhCiABIAJrIANBHHVqIQEgBUH/////AHEhBQwBCyAJIAdrICogI2sgKyAkayAsICVrIC0gJmsgLiAnayAvIChrIDAgKWsgIiAhayIiQRx1aiIwQRx1aiIvQRx1aiIuQRx1aiItQRx1aiIsQRx1aiIrQRx1aiIqQRx1aiIDQRx1IQQgCCAGayEXIAIhCCABIQkCfwJAAkACQCABIAJHDQAgCyEIIAohCSAKIAtHDQAgFiEIIA0hCSANIBZHDQAgFSEIIA4hCSAOIBVHDQAgFCEIIA8hCSAPIBRHDQAgGyEIIBAhCSAQIBtHDQAgGiEIIBEhCSARIBpHDQAgGSEIIBIhCSASIBlHDQAgGCEIIBMhCSATIBhHDQAgDCEIIAUhCSAFIAxGDQELIAggCUwNAQsgAiABayEcIAsgCmshHSAWIA1rIR4gFSAOayEfIBQgD2shICAbIBBrIQsgGiARayEWIBkgEmshFSAYIBNrIRQgDCAFawwBCyAxIAFrIAJqIRwgMiAKayALaiEdIDMgDWsgFmohHiA0IA5rIBVqIR8gNSAPayAUaiEgIDYgEGsgG2ohCyA3IBFrIBpqIRYgOCASayAZaiEVIDkgE2sgGGohFCA6IAVrIAxqCyECIDBB/////wBxITAgL0H/////AHEhLyAuQf////8AcSEuIC1B/////wBxIS0gLEH/////AHEhLCArQf////8AcSErICpB/////wBxISogA0H/////AHEhCSAEIBdqIQggIkH+////AHEhIiACQf////8AcSEMIBQgAkEcdWoiAkH/////AHEhGCACQRx1IBVqIgJB/////wBxIRkgAkEcdSAWaiICQf////8AcSEaIAJBHHUgC2oiAkH/////AHEhGyACQRx1ICBqIgJB/////wBxIRQgAkEcdSAfaiICQf////8AcSEVIAJBHHUgHmoiAkH/////AHEhFiACQRx1IB1qIgJB/////wBxIQsgAkEcdSAcaiECDAALAAsXACAAENgIRQRAQQAPCyAAQdgAahDYCAuwAgEKfyMAQeAAayIBJAAgAUL/////8AE3A1AgAUL/////8P///w83A0ggAUL/////8P///w83A0AgAUL/////8P///w83AzggAUKv+P//8P3//w83AzAgASAAKAIANgIAIAEgACgCBDYCBCABIAAoAgg2AgggASAAKAIMNgIMIAEgACgCEDYCECABIAAoAhQ2AhQgASAAKAIYNgIYIAEgACgCHDYCHCABIAAoAiA2AiAgASAAKAIkNgIkIAEgAUEwahDSCCABKAIEIQAgASgCACECIAEoAgghAyABKAIMIQQgASgCECEFIAEoAhQhBiABKAIYIQcgASgCHCEIIAEoAiAhCSABKAIkIQogAUHgAGokACAKIAkgCCAHIAYgBSAEIAMgACACcnJycnJycnJyRQu7BgMCfwF7AX4jAEGQAmsiAiQAIAEoAigiA6wiBSAFfkKAgIAIWgRAIAEQ2gggASgCKCEDCyACQZABaiABEM4IIAJC//////ABNwOAAiACQv/////w////DzcD+AEgAkL/////8P///w83A/ABIAJC//////D///8PNwPoASACQq/4///w/f//DzcD4AEgAkEEaiACQeABaiACQZABahDPCCACQQI2AiwgA0GAgIAETgRAIAJBBGoQ2ggLIAJBkAFqIAJBBGogARDNCCACQv/////wATcDgAIgAkL/////8P///w83A/gBIAJC//////D///8PNwPwASACQv/////w////DzcD6AEgAkKv+P//8P3//w83A+ABIAJBBGogAkHgAWogAkGQAWoQzwggACACKAIENgIAIAAgAigCCDYCBCAAIAIoAgw2AgggACACKAIQNgIMIAAgAigCFDYCECAAIAIoAhg2AhQgACACKAIcNgIYIAAgAigCIDYCHCAAIAIoAiQ2AiAgAigCKCEBIABBAjYCKCAAIAE2AiQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAkQgAkEANgJUIAJBBzYCMCACIAT9CwI0IAJBADYChAEgAkEBNgJwIAJCkJ2AkKAPNwNoIAJCgICAgICAgIgKNwNgIAIgBP0LAnQgAkGQAWogAkEwaiACQeAAahDNCCACQv/////wATcDgAIgAkL/////8P///w83A/gBIAJC//////D///8PNwPwASACQv/////w////DzcD6AEgAkKv+P//8P3//w83A+ABIAJBBGogAkHgAWogAkGQAWoQzwggACAAKAIAIAIoAgRqNgIAIAAgACgCBCACKAIIajYCBCAAIAAoAgggAigCDGo2AgggACAAKAIMIAIoAhBqNgIMIAAgACgCECACKAIUajYCECAAIAAoAhQgAigCGGo2AhQgACAAKAIYIAIoAhxqNgIYIAAgACgCHCACKAIgajYCHCAAIAAoAiAgAigCJGo2AiAgACAAKAIkIAIoAihqNgIkIAAgACgCKCIBQQJqNgIoIAFB/v//B04EQCAAENoICyAAENoIIAJBkAJqJAAL9AsCH38DfkH/////ACEDIAAgACgCACIBQf////8AcSIENgIAIAAgACgCBCABQRx1aiIBQf////8AcSICNgIEIAAgACgCCCABQRx1aiIBQf////8AcSILNgIIIAAgACgCDCABQRx1aiIBQf////8AcSIINgIMIAAgACgCECABQRx1aiIBQf////8AcSIJNgIQIAAgACgCFCABQRx1aiIBQf////8AcSIKNgIUIAAgACgCGCABQRx1aiIBQf////8AcSIMNgIYIAAgACgCHCABQRx1aiIBQf////8AcSINNgIcIABBIGoiBiAGKAIAIAFBHHVqIgFB/////wBxIgY2AgAgAEEkaiIHIAcoAgAgAUEcdWoiBzYCAAJAAn8gACgCKCIBQRFOBEAgACAEIAdBDHQgBkEQdnJBgIAEbSIFQa/4//8AbEH/////AHFrIgE2AgAgACACIAWsIiJC7////wB+ICJC8IX//w9+QiCHfCIgp0H/////AHFrIgQ2AgQgACALICJC/////wB+IiEgIEIch3wiIKdB/////wBxayICNgIIIAAgCCAhICBCHId8IiCnQf////8AcWsiCDYCDCAAIAkgISAgQhyHfCIgp0H/////AHFrIgk2AhAgACAKICEgIEIch3wiIKdB/////wBxayIKNgIUIAIgBCABQRx1aiIEQRx1aiICQf////8AcSELIAggAkEcdWoiAkH/////AHEhCCAJIAJBHHVqIgJB/////wBxIQkgCiACQRx1aiICQf////8AcSEKIAwgISAgQhyHfCIgp0H/////AHFrIAJBHHVqIgJB/////wBxIQwgDSAhICBCHId8IiCnQf////8AcWsgAkEcdWoiAkH/////AHEhDSAGICEgIEIch3wiIadB/////wBxayACQRx1aiICQf////8AcSEGIAcgIkIPfiAhQhyIfKdrIAJBHHVqIQcgBEH/////AHEhAiABQf////8AcSEEQQIhBUG/////ACEBQT8hEEH/////ACERQbzh//8ADAELIAFBAWsiAUEBdiABciIBQQJ2IAFyIgFBBHYgAXIiAUEIdiABciIBQRB2IAFyIgFFDQFB7////wAgAWkiBXRB/////wBxQa/4//8AQRwgBWsiA3ZyIQFB/////wAgBXRB/////wBxIg5B7////wAgA3ZyIRFB/////wAgA3YiA0EPIAV0ciEQIAMgDnIhA0Gv+P//ACAFdEH/////AHELIR0gAyEOIAMhEiADIRMgAyEUIAMhFQNAIBFBG3QhFiAVQRt0IQ8gFEEbdCEXIBNBG3QhGCASQRt0IRkgDkEbdCEaIANBG3QhGyAQQRt0IRwgByAQQQF1IhBrIAYgHEGAgIDAAHEgA0EBdnIiA2sgDSAbQYCAgMAAcSAOQQF2ciIOayAMIBpBgICAwABxIBJBAXZyIhJrIAogGUGAgIDAAHEgE0EBdnIiE2sgCSAYQYCAgMAAcSAUQQF2ciIUayAIIBdBgICAwABxIBVBAXZyIhVrIAsgD0GAgIDAAHEgEUEBdnIiEWsgAiAWQYCAgMAAcSABQQF2ciIWayAEIAFBG3RBgICAwABxIB1BAXZyIh1rIg9BHHVqIhdBHHVqIhhBHHVqIhlBHHVqIhpBHHVqIhtBHHVqIhxBHHVqIh5BHHVqIh9BHHVqIgEgByABQQBOIgEbIQcgH0H/////AHEgBiABGyEGIB5B/////wBxIA0gARshDSAcQf////8AcSAMIAEbIQwgG0H/////AHEgCiABGyEKIBpB/////wBxIAkgARshCSAZQf////8AcSAIIAEbIQggGEH/////AHEgCyABGyELIBdB/////wBxIAIgARshAiAPQf////8AcSAEIAEbIQQgBUEBSyEPIBYhASAFQQFrIQUgDw0ACyAAIA02AhwgACAMNgIYIAAgCjYCFCAAIAk2AhAgACAINgIMIAAgCzYCCCAAIAI2AgQgACAENgIAIAAgBzYCJCAAIAY2AiALIABBATYCKAuLBgMCfwF7AX4jAEGQAmsiASQAAkAgABDYCARAIABB2ABqENgIDQELIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwJ0IAFBADYChAEgAUEBNgJgIAEgA/0LAmQgAUEANgKEAiABQQE2AvABIAFCkJ2AkKAPNwPoASABQoCAgICAgICICjcD4AEgASAD/QsC9AEgAUGQAWogAUHgAGogAUHgAWoQzQggAUL/////8AE3AyAgAUL/////8P///w83AxggAUL/////8P///w83AxAgAUL/////8P///w83AwggAUKv+P//8P3//w83AwAgAUE0aiABIAFBkAFqEM8IIAFBAjYCXCAAQdgAaiICIAFBNGoQ3AgNACABQv/////wATcDsAEgAUL/////8P///w83A6gBIAFC//////D///8PNwOgASABQv/////w////DzcDmAEgAUKt+P//8P3//w83A5ABIAEgAiABQZABahDdCCABNAIoIgQgADQCKH5CgICACFkEQCAAENoICyABQZABaiAAIAEQzQggAUL/////8AE3A4ACIAFC//////D///8PNwP4ASABQv/////w////DzcD8AEgAUL/////8P///w83A+gBIAFCr/j///D9//8PNwPgASAAIAFB4AFqIAFBkAFqEM8IIABBAjYCKCAAQSxqIQIgBCAANAJUfkKAgIAIWQRAIAIQ2ggLIAFBkAFqIAIgARDNCCABQv/////wATcDgAIgAUL/////8P///w83A/gBIAFC//////D///8PNwPwASABQv/////w////DzcD6AEgAUKv+P//8P3//w83A+ABIAIgAUHgAWogAUGQAWoQzwggAEECNgJUIAIQ2gggABDaCCAAIAEoAjQ2AlggACABKAI4NgJcIAAgASgCPDYCYCAAIAEoAkA2AmQgACABKAJENgJoIAAgASgCSDYCbCAAIAEoAkw2AnAgACABKAJQNgJ0IAAgASgCVDYCeCABKAJYIQIgAEECNgKAASAAIAI2AnwLIAFBkAJqJAALkwMBAX8jAEHgAGsiAiQAIAIgACgCADYCNCACIAAoAgQ2AjggAiAAKAIINgI8IAIgACgCDDYCQCACIAAoAhA2AkQgAiAAKAIUNgJIIAIgACgCGDYCTCACIAAoAhw2AlAgAiAAKAIgNgJUIAIgACgCJDYCWCACIAAoAig2AlwgAiABKAIANgIIIAIgASgCBDYCDCACIAEoAgg2AhAgAiABKAIMNgIUIAIgASgCEDYCGCACIAEoAhQ2AhwgAiABKAIYNgIgIAIgASgCHDYCJCACIAEoAiA2AiggAiABKAIkNgIsIAIgASgCKDYCMCACQTRqENoIIAJBCGoQ2ggCfwJAIAIoAlggAigCLEcNACACKAJUIAIoAihHDQAgAigCUCACKAIkRw0AIAIoAkwgAigCIEcNACACKAJIIAIoAhxHDQAgAigCRCACKAIYRw0AIAIoAkAgAigCFEcNACACKAI8IAIoAhBHDQAgAigCOCACKAIMRw0AQQEgAigCNCACKAIIRg0BGgtBAAshACACQeAAaiQAIAAL5xcDF38BfgF7IwBBoAhrIgMkACABIAEoAgAiBEH/////AHE2AgAgASABKAIEIARBHHVqIgRB/////wBxNgIEIAEgASgCCCAEQRx1aiIEQf////8AcTYCCCABIAEoAgwgBEEcdWoiBEH/////AHE2AgwgASABKAIQIARBHHVqIgRB/////wBxNgIQIAEgASgCFCAEQRx1aiIEQf////8AcTYCFCABIAEoAhggBEEcdWoiBEH/////AHE2AhggASABKAIcIARBHHVqIgRB/////wBxNgIcIAEgASgCICAEQRx1aiIEQf////8AcTYCICABIAEoAiQgBEEcdWo2AiQgAiACKAIAIgVB/////wBxIgQ2AgAgAiACKAIEIAVBHHVqIgVB/////wBxIgY2AgQgAiACKAIIIAVBHHVqIgVB/////wBxIgc2AgggAiACKAIMIAVBHHVqIgVB/////wBxIgg2AgwgAiACKAIQIAVBHHVqIgVB/////wBxIgk2AhAgAiACKAIUIAVBHHVqIgVB/////wBxIgo2AhQgAiACKAIYIAVBHHVqIgVB/////wBxIgs2AhggAiACKAIcIAVBHHVqIgVB/////wBxIgw2AhwgAiACKAIgIAVBHHVqIgVB/////wBxIg02AiAgAiACKAIkIAVBHHVqIgU2AiQgAyAFNgIkIAMgDTYCICADIAw2AhwgAyALNgIYIAMgCjYCFCADIAk2AhAgAyAINgIMIAMgBzYCCCADIAY2AgQgAyAENgIAIAMQzAgiD0EDakEEbSEOIA9Bek4EQEEAIQIgDkEAIA5BAEobIRgDQCADQfAFaiACaiAEQQ9xOgAAIAVBGHQhECANQRh0IREgDEEYdCESIAtBGHQhEyAKQRh0IRQgCUEYdCEVIAhBGHQhFiAHQRh0IRcgBkEYdEGAgID4AHEgBEEEdnIhBCAFQQR1IQUgAiAYRyEZIBBBgICA+ABxIA1BBHZyIhAhDSARQYCAgPgAcSAMQQR2ciIRIQwgEkGAgID4AHEgC0EEdnIiEiELIBNBgICA+ABxIApBBHZyIhMhCiAUQYCAgPgAcSAJQQR2ciIUIQkgFUGAgID4AHEgCEEEdnIiFSEIIBZBgICA+ABxIAdBBHZyIhYhByAXQYCAgPgAcSAGQQR2ciIXIQYgAkEBaiECIBkNAAsgAyAFNgIkIAMgEDYCICADIBE2AhwgAyASNgIYIAMgEzYCFCADIBQ2AhAgAyAVNgIMIAMgFjYCCCADIBc2AgQgAyAENgIACyAD/QwAAAAAAAAAAAAAAAAAAAAA/QsC1AYgA0EANgLkBiADQQE2AsAGIAMgG/0LAsQGIANBADYClAcgA0EBNgKAByADQpCdgJCgDzcD+AYgA0KAgICAgICAiAo3A/AGIAMgG/0LAoQHIANBoAdqIANBwAZqIANB8AZqEM0IIANC//////ABNwOQCCADQv/////w////DzcDiAggA0L/////8P///w83A4AIIANC//////D///8PNwP4ByADQq/4///w/f//DzcD8AcgA0EwaiADQfAHaiADQaAHahDPCCADQQI2AlggAyABKAIANgJcIAMgASgCBDYCYCADIAEoAgg2AmQgAyABKAIMNgJoIAMgASgCEDYCbCADIAEoAhQ2AnAgAyABKAIYNgJ0IAMgASgCHDYCeCADIAEoAiA2AnwgAyABKAIkNgKAASADIAEoAigiBDYChAEgA0GIAWohBSADQdwAaiECIASsIhogGn5CgICACFoEQCACENoICyADQaAHaiACIAEQzQggA0L/////8AE3A5AIIANC//////D///8PNwOICCADQv/////w////DzcDgAggA0L/////8P///w83A/gHIANCr/j///D9//8PNwPwByAFIANB8AdqIANBoAdqEM8IIANBAjYCsAFBAyECIARBgICABEghBgNAIANBMGogAkEsbGoiBEEsayEFIAZFBEAgBRDaCAsgA0GgB2ogBSABEM0IIANC//////ABNwOQCCADQv/////w////DzcDiAggA0L/////8P///w83A4AIIANC//////D///8PNwP4ByADQq/4///w/f//DzcD8AcgBCADQfAHaiADQaAHahDPCCAEQQI2AiggAkEBaiICQRBHDQALIAAgA0EwaiADQfAFaiAOaiwAAEEsbGoiAigCADYCACAAIAIoAgQ2AgQgACACKAIINgIIIAAgAigCDDYCDCAAIAIoAhA2AhAgACACKAIUNgIUIAAgAigCGDYCGCAAIAIoAhw2AhwgACACKAIgNgIgIAAgAigCJDYCJCAAIAIoAigiBDYCKAJAIA9BAEwNACAOQQFrIQIgBKwiGiAafkKAgIAIWgRAIAAQ2ggLIANBoAdqIAAQzgggA0L/////8AE3A5AIIANC//////D///8PNwOICCADQv/////w////DzcDgAggA0L/////8P///w83A/gHIANCr/j///D9//8PNwPwByAAIANB8AdqIANBoAdqEM8IIABBAjYCKCADQaAHaiAAEM4IIANC//////ABNwOQCCADQv/////w////DzcDiAggA0L/////8P///w83A4AIIANC//////D///8PNwP4ByADQq/4///w/f//DzcD8AcgACADQfAHaiADQaAHahDPCCAAQQI2AiggA0GgB2ogABDOCCADQv/////wATcDkAggA0L/////8P///w83A4gIIANC//////D///8PNwOACCADQv/////w////DzcD+AcgA0Kv+P//8P3//w83A/AHIAAgA0HwB2ogA0GgB2oQzwggAEECNgIoIANBoAdqIAAQzgggA0L/////8AE3A5AIIANC//////D///8PNwOICCADQv/////w////DzcDgAggA0L/////8P///w83A/gHIANCr/j///D9//8PNwPwByAAIANB8AdqIANBoAdqEM8IIABBAjYCKCADQTBqIANB8AVqIAJqLAAAQSxsaiIEKAIoQYCAgAROBEAgABDaCAsgA0GgB2ogACAEEM0IIANC//////ABNwOQCCADQv/////w////DzcDiAggA0L/////8P///w83A4AIIANC//////D///8PNwP4ByADQq/4///w/f//DzcD8AcgACADQfAHaiADQaAHahDPCCAAQQI2AiggD0EFSA0AA0AgA0GgB2ogABDOCCADQv/////wATcDkAggA0L/////8P///w83A4gIIANC//////D///8PNwOACCADQv/////w////DzcD+AcgA0Kv+P//8P3//w83A/AHIAAgA0HwB2ogA0GgB2oQzwggAEECNgIoIANBoAdqIAAQzgggA0L/////8AE3A5AIIANC//////D///8PNwOICCADQv/////w////DzcDgAggA0L/////8P///w83A/gHIANCr/j///D9//8PNwPwByAAIANB8AdqIANBoAdqEM8IIABBAjYCKCADQaAHaiAAEM4IIANC//////ABNwOQCCADQv/////w////DzcDiAggA0L/////8P///w83A4AIIANC//////D///8PNwP4ByADQq/4///w/f//DzcD8AcgACADQfAHaiADQaAHahDPCCAAQQI2AiggA0GgB2ogABDOCCADQv/////wATcDkAggA0L/////8P///w83A4gIIANC//////D///8PNwOACCADQv/////w////DzcD+AcgA0Kv+P//8P3//w83A/AHIAAgA0HwB2ogA0GgB2oQzwggAEECNgIoIANBMGogAkEBayIEIANB8AVqaiwAAEEsbGoiBSgCKEGAgIAETgRAIAAQ2ggLIANBoAdqIAAgBRDNCCADQv/////wATcDkAggA0L/////8P///w83A4gIIANC//////D///8PNwOACCADQv/////w////DzcD+AcgA0Kv+P//8P3//w83A/AHIAAgA0HwB2ogA0GgB2oQzwggAEECNgIoIAJBAUohBSAEIQIgBQ0ACwsgABDaCCADQaAIaiQAC+UKAgZ/AXsjAEHAAmsiAyQAIANBADYCtAIgA0EBNgKgAiADQpCdgJCgDzcDmAIgA0KAgICAgICAiAo3A5ACIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwKkAiADQcABaiACIANBkAJqEM0IIANC//////ABNwNQIANC//////D///8PNwNIIANC//////D///8PNwNAIANC//////D///8PNwM4IANCr/j///D9//8PNwMwIANBBGogA0EwaiADQcABahDPCEECIQcgA0ECNgIsIANBwAFqIANBBGoQzgggA0L/////8AE3A1AgA0L/////8P///w83A0ggA0L/////8P///w83A0AgA0L/////8P///w83AzggA0Kv+P//8P3//w83AzAgA0EEaiADQTBqIANBwAFqEM8IIANBAjYCLCADQQRqENoIIANBtAFqIgRBADYCACADQQE2AqABIANCkJ2AkKAPNwOYASADQoCAgICAgICICjcDkAEgAyAJ/QsCpAEgA0HAAWogASADQZABahDNCCADQv/////wATcDsAIgA0L/////8P///w83A6gCIANC//////D///8PNwOgAiADQv/////w////DzcDmAIgA0Kv+P//8P3//w83A5ACIANBMGogA0GQAmogA0HAAWoQzwggA0ECNgJYIABB2ABqIQUgAEEsaiEIIANBMGogA0EwahDZCAJAIANBBGogA0EwahDcCEUEQCAAIAn9CwIAQQEhByAAQQE2AiggAEIANwIgIAAgCf0LAhAgAyAJ/QsCdCADQQA2AoQBIANBATYCYCADIAn9CwJkIARBADYCACADQQE2AqABIANCkJ2AkKAPNwOYASADQoCAgICAgICICjcDkAEgAyAJ/QsCpAEgA0HAAWogA0HgAGogA0GQAWoQzQggA0L/////8AE3A7ACIANC//////D///8PNwOoAiADQv/////w////DzcDoAIgA0L/////8P///w83A5gCIANCr/j///D9//8PNwOQAiAIIANBkAJqIANBwAFqEM8IIABBAjYCVCAFQgA3AiAgBSAJ/QsCECAFIAn9CwIADAELIARBADYCACADQQE2AqABIANCkJ2AkKAPNwOYASADQoCAgICAgICICjcDkAEgAyAJ/QsCpAEgA0HAAWogASADQZABahDNCCADQv/////wATcDsAIgA0L/////8P///w83A6gCIANC//////D///8PNwOgAiADQv/////w////DzcDmAIgA0Kv+P//8P3//w83A5ACIAAgA0GQAmogA0HAAWoQzwggAEECNgIoIARBADYCACADQQE2AqABIANCkJ2AkKAPNwOYASADQoCAgICAgICICjcDkAEgAyAJ/QsCpAEgA0HAAWogAiADQZABahDNCCADQv/////wATcDsAIgA0L/////8P///w83A6gCIANC//////D///8PNwOgAiADQv/////w////DzcDmAIgA0Kv+P//8P3//w83A5ACIAggA0GQAmogA0HAAWoQzwggAEECNgJUIAMgCf0LAnQgA0EANgKEASADQQE2AmAgAyAJ/QsCZCAEQQA2AgAgA0EBNgKgASADQpCdgJCgDzcDmAEgA0KAgICAgICAiAo3A5ABIAMgCf0LAqQBIANBwAFqIANB4ABqIANBkAFqEM0IIANC//////ABNwOwAiADQv/////w////DzcDqAIgA0L/////8P///w83A6ACIANC//////D///8PNwOYAiADQq/4///w/f//DzcDkAIgBSADQZACaiADQcABahDPCEEBIQYLIAAgBzYCgAEgA0HAAmokACAGC/IYAiN/AXsjAEHwAmsiAyQAIANC//////ABNwMgIANC//////D///8PNwMYIANC//////D///8PNwMQIANC//////D///8PNwMIIANCr/j///D9//8PNwMAIANBADYC5AEgA0EBNgLQASADQpCdgJCgDzcDyAEgA0KAgICAgICAiAo3A8ABIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwLUASADQfABaiABIANBwAFqEM0IIANC//////ABNwPgAiADQv/////w////DzcD2AIgA0L/////8P///w83A9ACIANC//////D///8PNwPIAiADQq/4///w/f//DzcDwAIgA0HkAGogA0HAAmogA0HwAWoQzwggA0ECNgKMASADQeQAaiADQeQAahDZCCADQQA2ArwCIAMgJv0LAqwCIAMgAygCZDYC8AEgAyAD/QACaP0LAvQBIAMgA/0AAnj9CwKEAiADICb9CwKcAiADIAMoAogBIgRB/////wBxNgKUAiADIARBHHU2ApgCIANC//////ABNwPgAiADQv/////w////DzcD2AIgA0L/////8P///w83A9ACIANC//////D///8PNwPIAiADQq/4///w/f//DzcDwAIgA0EwaiADQcACaiADQfABahDPCAJAAkACQAJAAkACQCADKAJUIgQNACADKAJQDQAgAygCTA0AIAMoAkgNACADKAJEDQAgAygCQA0AIAMoAjwNACADKAI4DQAgAygCNA0AIAMoAjBFDQELIAMgAygCMCIFQf////8AcSIGNgIwIAMgAygCNCAFQRx1aiIFQf////8AcSIHNgI0IAMgAygCOCAFQRx1aiIFQf////8AcSIJNgI4IAMgAygCPCAFQRx1aiIFQf////8AcSIKNgI8IAMgAygCQCAFQRx1aiIFQf////8AcSILNgJAIAMgAygCRCAFQRx1aiIFQf////8AcSIMNgJEIAMgAygCSCAFQRx1aiIFQf////8AcSINNgJIIAMgAygCTCAFQRx1aiIFQf////8AcSIONgJMIAMgAygCUCAFQRx1aiIFQf////8AcSIPNgJQIAMgBUEcdSAEaiIENgJUIAMgBDYC5AIgAyAPNgLgAiADIA42AtwCIAMgDTYC2AIgAyAMNgLUAiADIAs2AtACIAMgCjYCzAIgAyAJNgLIAiADIAc2AsQCIAMgBjYCwAIgA0HAAmogAxDSCEEPIRZB7////wAhF0Gv+P//ACERIAMoAsACIQQgAygCxAIhDiADKALIAiENIAMoAswCIQwgAygC0AIhCyADKALUAiEKIAMoAtgCIQkgAygC3AIhByADKALgAiEGIAMoAuQCIQVB/////wAhGEH/////ACEZQf////8AIRpB/////wAhG0H/////ACEcQf////8AIR1B/////wAhHgNAQQAhDwJAIBYiCEUEQCAeDQEgHQ0BIBwNASAbDQEgGg0BIBkNASAYDQEgFw0BQQEhDyARIghBAUYNBAsgCCAPTA0DCwJAIAUNACAGDQAgBw0AIAkNACAKDQAgCw0AIAwNACANDQAgDg0AIARFDQILIBFBB3EhH0EAIQ8CQCAEQQFxBEAgBCEIIA4hEiANIRMgDCEUIAshFQwBCwNAIAVBG3QhCCAGQRt0IRIgB0EbdCETIAlBG3QhFCAKQRt0IRUgC0EbdCEgIAxBG3QhISANQRt0ISIgDkEbdCEjIAVBAXUhBSAPIiRBAWohDyAEQQJxISUgCEGAgIDAAHEgBkEBdXIhBiASQYCAgMAAcSAHQQF1ciEHIBNBgICAwABxIAlBAXVyIQkgFEGAgIDAAHEgCkEBdXIhCiAVQYCAgMAAcSALQQF1ciIVIQsgIEGAgIDAAHEgDEEBdXIiFCEMICFBgICAwABxIA1BAXVyIhMhDSAiQYCAgMAAcSAOQQF1ciISIQ4gI0GAgIDAAHEgBEEBdXIiCCEEICVFDQALICRBAXENACAQIB8gH2xBAWtBCG1B/wFxaiEQCyADIBY2ApQCIAMgHjYCkAIgAyAdNgKMAiADIBw2AogCIAMgGzYChAIgAyAaNgKAAiADIBk2AvwBIAMgGDYC+AEgAyAXNgL0ASADIBE2AvABIAMgCEH/////AHEiETYCwAIgAyASIAhBHHVqIgRB/////wBxIhc2AsQCIAMgEyAEQRx1aiIEQf////8AcSIYNgLIAiADIBQgBEEcdWoiBEH/////AHEiGTYCzAIgAyAVIARBHHVqIgRB/////wBxIho2AtACIAMgCiAEQRx1aiIEQf////8AcSIbNgLUAiADIAkgBEEcdWoiBEH/////AHEiHDYC2AIgAyAHIARBHHVqIgRB/////wBxIh02AtwCIAMgBiAEQRx1aiIEQf////8AcSIeNgLgAiADIAUgBEEcdWoiFjYC5AIgA0HwAWogA0HAAmoQ0gggAyADKALwASIENgLAAiADIAMoAvQBIg42AsQCIAMgAygC+AEiDTYCyAIgAyADKAL8ASIMNgLMAiADIAMoAoACIgs2AtACIAMgAygChAIiCjYC1AIgAyADKAKIAiIJNgLYAiADIAMoAowCIgc2AtwCIAMgAygCkAIiBjYC4AIgAyADKAKUAiIFNgLkAiAQIAhBA3FBAWsgH0EBa2xBBG3AakECbyEQDAALAAsgAEEsaiEEDAELIABBLGohBCAQRQ0BCyAAICb9CwIAIABBATYCKCAAQgA3AiAgACAm/QsCECADICb9CwKkAUEAIQUgA0EANgK0ASADQQE2ApABIAMgJv0LApQBIANBADYC5AEgA0EBNgLQASADQpCdgJCgDzcDyAEgA0KAgICAgICAiAo3A8ABIAMgJv0LAtQBIANB8AFqIANBkAFqIANBwAFqEM0IIANC//////ABNwPgAiADQv/////w////DzcD2AIgA0L/////8P///w83A9ACIANC//////D///8PNwPIAiADQq/4///w/f//DzcDwAIgBCADQcACaiADQfABahDPCCAAQQI2AlQgAEIANwJ4IAAgJv0LAmggACAm/QsCWCAAQQE2AoABDAELIANB5AFqIgdBADYCAEEBIQUgA0EBNgLQASADQpCdgJCgDzcDyAEgA0KAgICAgICAiAo3A8ABIAMgJv0LAtQBIANB8AFqIAEgA0HAAWoQzQggA0L/////8AE3A+ACIANC//////D///8PNwPYAiADQv/////w////DzcD0AIgA0L/////8P///w83A8gCIANCr/j///D9//8PNwPAAiAAIANBwAJqIANB8AFqEM8IIABBAjYCKCADQv/////wATcD4AIgA0L/////8P///w83A9gCIANC//////D///8PNwPQAiADQv/////w////DzcDyAIgA0Kv+P//8P3//w83A8ACIANB5ABqIANBwAJqENIIIANC/////zA3A5ACIANC//////D///8PNwOIAiADQv/////w////DzcDgAIgA0L/////8P///w83A/gBIANCjP7//7D///8PNwPwASAEIANB5ABqIANB8AFqEN0IIAMgACgCLDYC8AEgAyAAKAIwNgL0ASADIAAoAjQ2AvgBIAMgACgCODYC/AEgAyAAKAI8NgKAAiADIAAoAkA2AoQCIAMgACgCRDYCiAIgAyAAKAJINgKMAiADIAAoAkw2ApACIAAoAlAhBiADICb9CwKsAiADQQA2ArwCIAMgJv0LApwCIAMgBkEcdTYCmAIgAyAGQf////8AcTYClAIgA0L/////8AE3A+ACIANC//////D///8PNwPYAiADQv/////w////DzcD0AIgA0L/////8P///w83A8gCIANCr/j///D9//8PNwPAAiADQTBqIANBwAJqIANB8AFqEM8IIAIgAygCMEECb0cEQCAEIAQQ4AgLIAQQ2gggAyAm/QsCpAEgA0EANgK0ASADQQE2ApABIAMgJv0LApQBIAdBADYCACADQQE2AtABIANCkJ2AkKAPNwPIASADQoCAgICAgICICjcDwAEgAyAm/QsC1AEgA0HwAWogA0GQAWogA0HAAWoQzQggA0L/////8AE3A+ACIANC//////D///8PNwPYAiADQv/////w////DzcD0AIgA0L/////8P///w83A8gCIANCr/j///D9//8PNwPAAiAAQdgAaiADQcACaiADQfABahDPCCAAQQI2AoABCyADQfACaiQAIAULswIBBH8gAEGv+P//ACABKAIoQQFrIgJBAXYgAnIiAkECdiACciICQQR2IAJyIgJBCHYgAnIiAkEQdiACcmkiAnRB/////wBxIAEoAgBrNgIAIABB7////wAgAnRB/////wBxQa/4//8AQRwgAmsiA3ZyIAEoAgRrNgIEIABB/////wAgAnRB/////wBxIgRB7////wAgA3ZyIAEoAghrNgIIIAAgBEH/////ACADdiIFciIDIAEoAgxrNgIMIAAgAyABKAIQazYCECAAIAMgASgCFGs2AhQgACADIAEoAhhrNgIYIAAgAyABKAIcazYCHCAAIAMgASgCIGs2AiAgASgCJCEBIABBASACdCIDQQFqNgIoIAAgBUEPIAJ0ciABazYCJCADQf///wdOBEAgABDaCAsL3xwCGH8CfiMAQfACayIBJAAgAEEsaiELIAA0AlQiGSAZfkKAgIAIWgRAIAsQ2gggADQCVCEZCyABQfABaiALEM4IIAFC//////ABNwOwASABQv/////w////DzcDqAEgAUL/////8P///w83A6ABIAFC//////D///8PNwOYASABQq/4///w/f//DzcDkAEgAUHEAWogAUGQAWogAUHwAWoQzwggAUECNgLsASAAQdgAaiEEIBkgADQCgAEiGn5CgICACFkEQCALENoIIAA0AoABIRoLIAFB8AFqIAsgBBDNCCABQv/////wATcDgAEgAUL/////8P///w83A3ggAUL/////8P///w83A3AgAUL/////8P///w83A2ggAUKv+P//8P3//w83A2AgAUGQAWogAUHgAGogAUHwAWoQzwggAUECNgK4ASAaIBp+QoCAgAhaBEAgBBDaCAsgAUHwAWogBBDOCCABQv/////wATcDUCABQv/////w////DzcDSCABQv/////w////DzcDQCABQv/////w////DzcDOCABQq/4///w/f//DzcDMCABQeAAaiABQTBqIAFB8AFqEM8IIAEoAsQBIQMgAUECNgKIASAAIANBAXQ2AlggACABKALIASIIQQF0IgI2AlwgACABKALMASIJQQF0IgU2AmAgACABKALQASIQQQF0Igo2AmQgACABKALUASIRQQF0IhI2AmggACABKALYASIWQQF0Ihc2AmwgACABKALcASIYQQF0Igw2AnAgACABKALgASIHQQF0Ig02AnQgACABKALkASIOQQF0Ig82AnggASgC6AEhBiAAQRA2AoABIAAgA0EDdEH4////AHE2AlggACACIANBG3VqIgJBAnRB/P///wBxIANBGXZBA3FyNgJcIAAgBSACQRx1aiIFQQJ0Qfz///8AcSACQRp2QQNxcjYCYCAAIAogBUEcdWoiAkECdEH8////AHEgBUEadkEDcXI2AmQgACASIAJBHHVqIgVBAnRB/P///wBxIAJBGnZBA3FyNgJoIAAgFyAFQRx1aiICQQJ0Qfz///8AcSAFQRp2QQNxcjYCbCAAIAwgAkEcdWoiBUECdEH8////AHEgAkEadkEDcXI2AnAgACANIAVBHHVqIgJBAnRB/P///wBxIAVBGnZBA3FyNgJ0IAAgDyACQRx1aiIFQQJ0Qfz///8AcSACQRp2QQNxcjYCeCAAIAVBGnZBA3EgBkEBdCAFQRx1akECdHI2AnwgAUHgAGogAUHgAGoQ4gggASgCiAEiAkGAgMAATgRAIAFB4ABqENoIIAEoAogBIQILIAFB8AFqIAFB4ABqIAQQzQggAUL/////8AE3A+ACIAFC//////D///8PNwPYAiABQv/////w////DzcD0AIgAUL/////8P///w83A8gCIAFCr/j///D9//8PNwPAAiABQTBqIAFBwAJqIAFB8AFqEM8IIAEgASgCYCIFIANqIgM2AgQgASABKAJkIgogCGoiDDYCCCABIAEoAmgiCCAJaiINNgIMIAEgASgCbCIJIBBqIg82AhAgASABKAJwIhAgEWoiEzYCFCABIAEoAnQiESAWaiIUNgIYIAEgASgCeCISIBhqIhU2AhwgASABKAJ8IhYgB2oiBzYCICABQQI2AlggASACQQJqNgIsIAEgASgCgAEiFyAOaiIONgIkIAEgASgChAEiGCAGaiIGNgIoIAJB/v//B04EQCABQQRqENoIIAEoAighBiABKAIkIQ4gASgCICEHIAEoAhwhFSABKAIYIRQgASgCFCETIAEoAhAhDyABKAIMIQ0gASgCCCEMIAEoAgQhAwsgASADQf////8AcTYCBCABIAwgA0EcdWoiA0H/////AHE2AgggASANIANBHHVqIgNB/////wBxNgIMIAEgDyADQRx1aiIDQf////8AcTYCECABIBMgA0EcdWoiA0H/////AHE2AhQgASAUIANBHHVqIgNB/////wBxNgIYIAEgFSADQRx1aiIDQf////8AcTYCHCABIAcgA0EcdWoiA0H/////AHE2AiAgASAOIANBHHVqIgNB/////wBxNgIkIAEgBiADQRx1ajYCKCABQfABaiAEIAFBkAFqEM0IIAFC//////ABNwPgAiABQv/////w////DzcD2AIgAUL/////8P///w83A9ACIAFC//////D///8PNwPIAiABQq/4///w/f//DzcDwAIgBCABQcACaiABQfABahDPCCAAQQI2AoABIAEgAkEBdCIENgK4ASABIBhBAXQiAzYCtAEgASAXQQF0IgY2ArABIAEgFkEBdCIMNgKsASABIBJBAXQiDTYCqAEgASARQQF0Ig82AqQBIAEgEEEBdCITNgKgASABIAlBAXQiFDYCnAEgASAIQQF0IhU2ApgBIAEgCkEBdCIHNgKUASABIAVBAXQiDjYCkAEgASACQYCAgAROBH8gAUGQAWoQ2gggASgCuAEhBCABKAKwASEGIAEoAqwBIQwgASgCqAEhDSABKAKkASEPIAEoAqABIRMgASgCnAEhFCABKAKYASEVIAEoApQBIQcgASgCkAEhDiABKAK0AQUgAwsgGGo2AoQBIAEgBiAXajYCgAEgASAMIBZqNgJ8IAEgDSASajYCeCABIA8gEWo2AnQgASAQIBNqNgJwIAEgCSAUajYCbCABIAggFWo2AmggASAHIApqNgJkIAEgBSAOajYCYCABIAIgBGoiBDYCiAEgBEGAgIAITgRAIAFB4ABqENoICyABQcQBaiABQcQBaiABQeAAahDjCCABIAEoAsQBIgRB/////wBxIgI2AsQBIAEgASgCyAEgBEEcdWoiBEH/////AHEiAzYCyAEgASABKALMASAEQRx1aiIEQf////8AcSIGNgLMASABIAEoAtABIARBHHVqIgRB/////wBxIgU2AtABIAEgASgC1AEgBEEcdWoiBEH/////AHEiCjYC1AEgASABKALYASAEQRx1aiIEQf////8AcSIINgLYASABIAEoAtwBIARBHHVqIgRB/////wBxIgk2AtwBIAEgASgC4AEgBEEcdWoiBEH/////AHEiEDYC4AEgASABKALkASAEQRx1aiIEQf////8AcSIRNgLkASABIAEoAugBIARBHHVqIhI2AugBIAE0AiwgASgC7AEiFqx+QoCAgAhZBEAgAUEEahDaCAsgAUHwAWogAUEEaiABQcQBahDNCCABQv/////wATcD4AIgAUL/////8P///w83A9gCIAFC//////D///8PNwPQAiABQv/////w////DzcDyAIgAUKv+P//8P3//w83A8ACIAFBBGogAUHAAmogAUHwAWoQzwggASABKAIwIAEoAgRqIgQ2AgQgASABKAI0IAEoAghqIhc2AgggASABKAI4IAEoAgxqIhg2AgwgASABKAI8IAEoAhBqIgw2AhAgASABKAJAIAEoAhRqIg02AhQgASABKAJEIAEoAhhqIg82AhggASABKAJIIAEoAhxqIhM2AhwgASABKAJMIAEoAiBqIhQ2AiAgASABKAJQIAEoAiRqIhU2AiQgASgCVCEHIAEoAighDiABQQQ2AiwgASAHIA5qIgc2AiggADQCVCAANAIofkKAgIAIWQRAIAAQ2ggLIAFB8AFqIAAgCxDNCCABQv/////wATcD4AIgAUL/////8P///w83A9gCIAFC//////D///8PNwPQAiABQv/////w////DzcDyAIgAUKv+P//8P3//w83A8ACIAFBkAFqIAFBwAJqIAFB8AFqEM8IIAFBAjYCuAEgASASNgLoASABIBE2AuQBIAEgEDYC4AEgASAJNgLcASABIAg2AtgBIAEgCjYC1AEgASAFNgLQASABIAY2AswBIAEgAzYCyAEgASACNgLEASAWQYCAgAROBEAgAUHEAWoQ2ggLIAFB8AFqIAFBxAFqIAFBkAFqEM0IIAFC//////ABNwPgAiABQv/////w////DzcD2AIgAUL/////8P///w83A9ACIAFC//////D///8PNwPIAiABQq/4///w/f//DzcDwAIgACABQcACaiABQfABahDPCCAAIAAoAgAiAkEBdCIDNgIAIAAgACgCBEEBdCILNgIEIAAgACgCCEEBdCIGNgIIIAAgACgCDEEBdCIFNgIMIAAgACgCEEEBdCIKNgIQIAAgACgCFEEBdCIINgIUIAAgACgCGEEBdCIJNgIYIAAgACgCHEEBdCIQNgIcIAAgACgCIEEBdCIRNgIgIAAgACgCJEEBdCISNgIkIABBBDYCKCAAIAsgAkEbdWoiAkH/////AHE2AgQgAEEENgJUIAAgA0H+////AHE2AgAgACAGIAJBHHVqIgJB/////wBxNgIIIAAgBSACQRx1aiICQf////8AcTYCDCAAIAogAkEcdWoiAkH/////AHE2AhAgACAIIAJBHHVqIgJB/////wBxNgIUIAAgCSACQRx1aiICQf////8AcTYCGCAAIBAgAkEcdWoiAkH/////AHE2AhwgACARIAJBHHVqIgJB/////wBxNgIgIAAgEiACQRx1ajYCJCAAIAcgFSAUIBMgDyANIAwgGCAXIARBHHVqIgJBHHVqIgNBHHVqIgtBHHVqIgZBHHVqIgVBHHVqIgpBHHVqIghBHHVqIglBHHVqNgJQIAAgCUH/////AHE2AkwgACAIQf////8AcTYCSCAAIApB/////wBxNgJEIAAgBUH/////AHE2AkAgACAGQf////8AcTYCPCAAIAtB/////wBxNgI4IAAgA0H/////AHE2AjQgACACQf////8AcTYCMCAAIARB/////wBxNgIsIAFB8AJqJAALugUDAn8BfgF7IwBBkAJrIgIkAAJAIAEoAigiA0HD4TBMBEAgACABKAIAIgNBFWxB/////wBxNgIAIAAgATQCBEIVfiADrELQAn5CIId8IgSnQf////8AcTYCBCAAIAE0AghCFX4gBEIch3wiBKdB/////wBxNgIIIAAgATQCDEIVfiAEQhyHfCIEp0H/////AHE2AgwgACABNAIQQhV+IARCHId8IgSnQf////8AcTYCECAAIAE0AhRCFX4gBEIch3wiBKdB/////wBxNgIUIAAgATQCGEIVfiAEQhyHfCIEp0H/////AHE2AhggACABNAIcQhV+IARCHId8IgSnQf////8AcTYCHCAAIAE0AiBCFX4gBEIch3wiBKdB/////wBxNgIgIAAgATUCJEIVfiAEQhyIfKdB/////wBxNgIkIAAgASgCKEEVbDYCKAwBCyAC/QwAAAAAAAAAAAAAAAAAAAAA/QsCRCACQQA2AlQgAkEVNgIwIAIgBf0LAjQgAkEANgKEASACQQE2AnAgAkKQnYCQoA83A2ggAkKAgICAgICAiAo3A2AgAiAF/QsCdCACQZABaiACQTBqIAJB4ABqEM0IIAJC//////ABNwOAAiACQv/////w////DzcD+AEgAkL/////8P///w83A/ABIAJC//////D///8PNwPoASACQq/4///w/f//DzcD4AEgAkEEaiACQeABaiACQZABahDPCCACQQI2AiwgA0GAgIAETgRAIAEQ2ggLIAJBkAFqIAEgAkEEahDNCCACQv/////wATcDgAIgAkL/////8P///w83A/gBIAJC//////D///8PNwPwASACQv/////w////DzcD6AEgAkKv+P//8P3//w83A+ABIAAgAkHgAWogAkGQAWoQzwggAEECNgIoCyACQZACaiQAC8oEAQ5/IwBBMGsiAyQAIANBr/j//wAgAigCKEEBayIEQQF2IARyIgRBAnYgBHIiBEEEdiAEciIEQQh2IARyIgRBEHYgBHJpIgR0Qf////8AcSACKAIAayIHNgIEIANB7////wAgBHRB/////wBxQa/4//8AQRwgBGsiBXZyIAIoAgRrIgg2AgggA0H/////ACAEdEH/////AHEiBkHv////ACAFdnIgAigCCGsiCTYCDCADIAZB/////wAgBXYiDnIiBSACKAIMayIGNgIQIAMgBSACKAIQayIKNgIUIAMgBSACKAIUayILNgIYIAMgBSACKAIYayIMNgIcIAMgBSACKAIcayINNgIgIAMgBSACKAIgayIFNgIkIAIoAiQhDyADQQEgBHQiEEEBaiICNgIsIAMgDkEPIAR0ciAPayIENgIoIBBB////B04EQCADQQRqENoIIAMoAighBCADKAIkIQUgAygCICENIAMoAhwhDCADKAIYIQsgAygCFCEKIAMoAhAhBiADKAIMIQkgAygCCCEIIAMoAgQhByADKAIsIQILIAAgByABKAIAajYCACAAIAggASgCBGo2AgQgACAJIAEoAghqNgIIIAAgBiABKAIMajYCDCAAIAogASgCEGo2AhAgACALIAEoAhRqNgIUIAAgDCABKAIYajYCGCAAIA0gASgCHGo2AhwgACAFIAEoAiBqNgIgIAAgBCABKAIkajYCJCAAIAIgASgCKGoiAjYCKCACQYCAgAhOBEAgABDaCAsgA0EwaiQAC8EsAjJ/AXsjAEHAC2siAiQAAkAgABDYCARAIABB2ABqENgIDQELAkAgASgCAA0AIAEoAgQNACABKAIIDQAgASgCDA0AIAEoAhANACABKAIUDQAgASgCGA0AIAEoAhwNACABKAIgDQAgASgCJA0AIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIABBATYCKCAAQgA3AiAgACA0/QsCECACIDT9CwIUIAJBADYCJCACQQE2AgAgAiA0/QsCBCACQZQJakEANgIAIAJBATYCgAkgAkKQnYCQoA83A/gIIAJCgICAgICAgIgKNwPwCCACIDT9CwKECSACQdAAaiACIAJB8AhqEM0IIAJC//////ABNwPQCiACQv/////w////DzcDyAogAkL/////8P///w83A8AKIAJC//////D///8PNwO4CiACQq/4///w/f//DzcDsAogAEEsaiACQbAKaiACQdAAahDPCCAAQQI2AlQgAEIANwJ4IAAgNP0LAmggACA0/QsCWCAAQQE2AoABDAELIAAQ2wggAiAAKAIANgLwCCACIAAoAgQ2AvQIIAIgACgCCDYC+AggAiAAKAIMNgL8CCACIAAoAhA2AoAJIAIgACgCFDYChAkgAiAAKAIYNgKICSACIAAoAhw2AowJIAIgACgCIDYCkAkgAiAAKAIkNgKUCSACIAAoAig2ApgJIAIgACgCLDYCnAkgAiAAKAIwNgKgCSACIAAoAjQ2AqQJIAIgACgCODYCqAkgAiAAKAI8NgKsCSACIAAoAkA2ArAJIAIgACgCRDYCtAkgAiAAKAJINgK4CSACIAAoAkw2ArwJIAIgACgCUDYCwAkgAiAAKAJUNgLECSACIAAoAlg2AsgJIAIgACgCXDYCzAkgAiAAKAJgNgLQCSACIAAoAmQ2AtQJIAIgACgCaDYC2AkgAiAAKAJsNgLcCSACIAAoAnA2AuAJIAIgACgCdDYC5AkgAiAAKAJ4NgLoCSACIAAoAnw2AuwJIAIgACgCgAEiBTYC8AkgAkHwCGoQ4QggAiAAKAIAIgM2AlAgAiAAKAIEIgQ2AlQgAiAAKAIIIgk2AlggAiAAKAIMIgo2AlwgAiAAKAIQIgs2AmAgAiAAKAIUIgw2AmQgAiAAKAIYIg02AmggAiAAKAIcIg42AmwgAiAAKAIgIg82AnAgAiAAKAIkIhA2AnQgAiAAKAIoIhE2AnggAiAAKAIsIgY2AnwgAiAAKAIwIgc2AoABIAIgACgCNCISNgKEASACIAAoAjgiEzYCiAEgAiAAKAI8IhQ2AowBIAIgACgCQCIVNgKQASACIAAoAkQiFjYClAEgAiAAKAJIIhc2ApgBIAIgACgCTCIYNgKcASACIAAoAlAiGTYCoAEgAiAAKAJUIho2AqQBIAIgACgCWCIbNgKoASACIAAoAlwiHDYCrAEgAiAAKAJgIh02ArABIAIgACgCZCIeNgK0ASACIAAoAmgiHzYCuAEgAiAAKAJsIiA2ArwBIAIgACgCcCIhNgLAASACIAAoAnQiIjYCxAEgAiAAKAJ4IiM2AsgBIAAoAnwhCCACIAU2AtQCIAIgCDYC0AIgAiAjNgLMAiACICI2AsgCIAIgITYCxAIgAiAgNgLAAiACIB82ArwCIAIgHjYCuAIgAiAdNgK0AiACIBw2ArACIAIgGzYCrAIgAiAaNgKoAiACIBk2AqQCIAIgGDYCoAIgAiAXNgKcAiACIBY2ApgCIAIgFTYClAIgAiAUNgKQAiACIBM2AowCIAIgEjYCiAIgAiAHNgKEAiACIAY2AoACIAIgETYC/AEgAiAQNgL4ASACIA82AvQBIAIgDjYC8AEgAiANNgLsASACIAw2AugBIAIgCzYC5AEgAiAKNgLgASACIAk2AtwBIAIgBDYC2AEgAiADNgLUASACIAU2AtABIAIgCDYCzAEgAkHUAWogAkHwCGoQ/wMgAiACKALUATYC2AIgAiAC/QAD2AH9CwLcAiACIAL9AAPoAf0LAuwCIAIgAv0AA/gB/QsC/AIgAiAC/QADiAL9CwKMAyACIAL9AAOYAv0LApwDIAIgAv0AA6gC/QsCrAMgAiACKQO4AjcCvAMgAiACKALAAjYCxAMgAiACKALEAjYCyAMgAiAC/QADyAL9CwLMAyACQdgCaiACQfAIahD/AyACIAIoAtgCNgLcAyACIAL9AALcAv0LBOADIAIgAv0AAuwC/QsE8AMgAiAC/QAC/AL9CwSABCACIAL9AAKMA/0LBJAEIAIgAv0AApwD/QsEoAQgAiAC/QACrAP9CwSwBCACIAIpArwDNwPABCACIAIoAsQDNgLIBCACIAIoAsgDNgLMBCACIAL9AALMA/0LBNAEIAJB3ANqIAJB8AhqEP8DIAIgAigC3AM2AuAEIAIgAv0ABOAD/QsC5AQgAiAC/QAE8AP9CwL0BCACIAL9AASABP0LAoQFIAIgAv0ABJAE/QsClAUgAiAC/QAEoAT9CwKkBSACIAL9AASwBP0LArQFIAIgAikDwAQ3AsQFIAIgAigCyAQ2AswFIAIgAigCzAQ2AtAFIAIgAv0ABNAE/QsC1AUgAkHgBGogAkHwCGoQ/wMgAiACKALgBDYC5AUgAiAC/QAC5AT9CwPoBSACIAL9AAL0BP0LA/gFIAIgAv0AAoQF/QsDiAYgAiAC/QAClAX9CwOYBiACIAL9AAKkBf0LA6gGIAIgAv0AArQF/QsDuAYgAiACKQLEBTcDyAYgAiACKALMBTYC0AYgAiACKALQBTYC1AYgAiAC/QAC1AX9CwPYBiACQeQFaiACQfAIahD/AyACIAIoAuQFNgLoBiACIAL9AAPoBf0LAuwGIAIgAv0AA/gF/QsC/AYgAiAC/QADiAb9CwKMByACIAL9AAOYBv0LApwHIAIgAv0AA6gG/QsCrAcgAiAC/QADuAb9CwK8ByACIAIpA8gGNwLMByACIAIoAtAGNgLUByACIAIoAtQGNgLYByACIAL9AAPYBv0LAtwHIAJB6AZqIAJB8AhqEP8DIAIgAv0AA+gG/QsC7AcgAiAC/QAD+Ab9CwL8ByACIAIpA4gHNwKMCCACIAIoApAHNgKUCCACIAL9AAKUB/0LA5gIIAIgAv0AAqQH/QsDqAggAiACKQK0BzcDuAggAiACKAK8BzYCwAggAiACKALABzYCxAggAiACKALEBzYCyAggAiAC/QADyAf9CwLMCCACIAL9AAPYB/0LAtwIIAIgAigC6Ac2AuwIIAJB7AdqIAJB8AhqEP8DQQAhBSABKAIkIREgASgCICEQIAEoAhwhDyABKAIYIQ4gASgCFCENIAEoAhAhDCABKAIMIQsgASgCCCEKIAEoAgQhCSACIAEoAgAiBEH/////AHFBAWoiA0H/////AHEiCEEBaiIGIANzQQAgBEECb2siAXFB/////wBxIAhzIgg2AoAKIAIgCSAEQRx1aiIHQf////8AcSADQRx2aiIEQf////8AcSIJIAZBHHZqIgYgBHMgAXFB/////wBxIAlzIgk2AoQKIAIgCiAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSIKIAZBHHZqIgYgBHMgAXFB/////wBxIApzIgo2AogKIAIgCyAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSILIAZBHHZqIgYgBHMgAXFB/////wBxIAtzIgs2AowKIAIgDCAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSIMIAZBHHZqIgYgBHMgAXFB/////wBxIAxzIgw2ApAKIAIgDSAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSINIAZBHHZqIgYgBHMgAXFB/////wBxIA1zIg02ApQKIAIgDiAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSIOIAZBHHZqIgYgBHMgAXFB/////wBxIA5zIg42ApgKIAIgDyAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSIPIAZBHHZqIgYgBHMgAXFB/////wBxIA9zIg82ApwKIAIgECAHQRx1aiIHQf////8AcSAEQRx2aiIEQf////8AcSIQIAZBHHZqIgYgBHMgAXFB/////wBxIBBzIhA2AqAKIAIgESAHQRx1aiAEQRx2aiIEIAZBHHZqIARzIAFxIARzIhE2AqQKIAJBACADQQFxayIBIAIoAvAIIgQgACgCAHNxIARzNgLwCCACIAIoAvQIIgMgACgCBHMgAXEgA3M2AvQIIAIgAigC+AgiAyAAKAIIcyABcSADczYC+AggAiACKAL8CCIDIAAoAgxzIAFxIANzNgL8CCACIAIoAoAJIgMgACgCEHMgAXEgA3M2AoAJIAIgAigChAkiAyAAKAIUcyABcSADczYChAkgAiACKAKICSIDIAAoAhhzIAFxIANzNgKICSACIAIoAowJIgMgACgCHHMgAXEgA3M2AowJIAIgAigCkAkiAyAAKAIgcyABcSADczYCkAkgAiACKAKUCSIDIAAoAiRzIAFxIANzNgKUCSACIAIoApgJIgMgACgCKHMgAXEgA3M2ApgJIAIgAigCnAkiAyAAKAIscyABcSADczYCnAkgAiACKAKgCSIDIAAoAjBzIAFxIANzNgKgCSACIAIoAqQJIgMgACgCNHMgAXEgA3M2AqQJIAIgAigCqAkiAyAAKAI4cyABcSADczYCqAkgAiACKAKsCSIDIAAoAjxzIAFxIANzNgKsCSACIAIoArAJIgMgACgCQHMgAXEgA3M2ArAJIAIgAigCtAkiAyAAKAJEcyABcSADczYCtAkgAiACKAK4CSIDIAAoAkhzIAFxIANzNgK4CSACIAIoArwJIgMgACgCTHMgAXEgA3MiBzYCvAkgAiACKALACSIDIAAoAlBzIAFxIANzIhI2AsAJIAIgAigCxAkiAyAAKAJUcyABcSADcyITNgLECSACIAIoAsgJIgMgACgCWHMgAXEgA3MiFDYCyAkgAiACKALMCSIDIAAoAlxzIAFxIANzIhU2AswJIAIgAigC0AkiAyAAKAJgcyABcSADcyIWNgLQCSACIAIoAtQJIgMgACgCZHMgAXEgA3MiFzYC1AkgAiACKALYCSIDIAAoAmhzIAFxIANzIhg2AtgJIAIgAigC3AkiAyAAKAJscyABcSADcyIZNgLcCSACIAIoAuAJIgMgACgCcHMgAXEgA3MiGjYC4AkgAiACKALkCSIDIAAoAnRzIAFxIANzIhs2AuQJIAIgAigC6AkiAyAAKAJ4cyABcSADcyIcNgLoCSACIAIoAuwJIgMgACgCfHMgAXEgA3MiHTYC7AkgAiACKALwCSIDIAAoAoABcyABcSADcyIeNgLwCSACKAK4CSEfIAIoArQJISAgAigCsAkhISACKAKsCSEiIAIoAqgJISMgAigCpAkhJCACKAKgCSElIAIoApwJISYgAigCmAkhJyACKAKUCSEoIAIoApAJISkgAigCjAkhKiACKAKICSErIAIoAoQJISwgAigCgAkhLSACKAL8CCEuIAIoAvgIIS8gAigC9AghMCACKALwCCExIAJBgApqEMwIIgNBA2pBBG0iAUEBaiEyIANBekgiM0UEQCABQQAgAUEAShshBgNAIAIgBWogCEEfcUEQayIDOgAAIAkgCCADayIIQRx1aiIDQRh0QYCAgPgAcSAIQQR2Qf///wdxciEIIAogA0EcdWoiBEEYdEGAgID4AHEgA0EEdkH///8HcXIhCSALIARBHHVqIgNBGHRBgICA+ABxIARBBHZB////B3FyIQogDCADQRx1aiIEQRh0QYCAgPgAcSADQQR2Qf///wdxciELIA0gBEEcdWoiA0EYdEGAgID4AHEgBEEEdkH///8HcXIhDCAOIANBHHVqIgRBGHRBgICA+ABxIANBBHZB////B3FyIQ0gDyAEQRx1aiIDQRh0QYCAgPgAcSAEQQR2Qf///wdxciEOIBAgA0EcdWoiBEEYdEGAgID4AHEgA0EEdkH///8HcXIhDyARIARBHHVqIgNBGHRBgICA+ABxIARBBHZB////B3FyIRAgA0EEdSERIAUgBkchAyAFQQFqIQUgAw0ACyACIBE2AqQKIAIgEDYCoAogAiAPNgKcCiACIA42ApgKIAIgDTYClAogAiAMNgKQCiACIAs2AowKIAIgCjYCiAogAiAJNgKECiACIAg2AoAKCyACIDJqIAhBH3EiBToAACAAIAJB0ABqIAVBAWtBAm1B//8DcUGEAWxqIgUoAgA2AgAgACAFKAIENgIEIAAgBSgCCDYCCCAAIAUoAgw2AgwgACAFKAIQNgIQIAAgBSgCFDYCFCAAIAUoAhg2AhggACAFKAIcNgIcIAAgBSgCIDYCICAAIAUoAiQ2AiQgACAFKAIoNgIoIAAgBSgCLDYCLCAAIAUoAjA2AjAgACAFKAI0NgI0IAAgBSgCODYCOCAAIAUoAjw2AjwgACAFKAJANgJAIAAgBSgCRDYCRCAAIAUoAkg2AkggACAFKAJMNgJMIAAgBSgCUDYCUCAAIAUoAlQ2AlQgACAFKAJYNgJYIAAgBSgCXDYCXCAAIAUoAmA2AmAgACAFKAJkNgJkIAAgBSgCaDYCaCAAIAUoAmw2AmwgACAFKAJwNgJwIAAgBSgCdDYCdCAAIAUoAng2AnggACAFKAJ8NgJ8IAAgBSgCgAE2AoABIDNFBEADQCACQfAIaiACQdAAaiABIAJqLAAAEOUIIAAQ4QggABDhCCAAEOEIIAAQ4QggACACQfAIahD/AyABQQBKIQUgAUEBayEBIAUNAAsLIAIgHjYCsAsgAiAdNgKsCyACIBw2AqgLIAIgGzYCpAsgAiAaNgKgCyACIBk2ApwLIAIgGDYCmAsgAiAXNgKUCyACIBY2ApALIAIgFTYCjAsgAiAUNgKICyACIBM2AoQLIAIgEjYCgAsgAiAHNgL8CiACIB82AvgKIAIgIDYC9AogAiAhNgLwCiACICI2AuwKIAIgIzYC6AogAiAkNgLkCiACICU2AuAKIAIgJjYC3AogAiAnNgLYCiACICg2AtQKIAIgKTYC0AogAiAqNgLMCiACICs2AsgKIAIgLDYCxAogAiAtNgLACiACIC42ArwKIAIgLzYCuAogAiAwNgK0CiACIDE2ArAKIAJB3ApqIgEgARDgCCACIAIoAtwKIgFB/////wBxNgLcCiACIAIoAuAKIAFBHHVqIgFB/////wBxNgLgCiACIAIoAuQKIAFBHHVqIgFB/////wBxNgLkCiACIAIoAugKIAFBHHVqIgFB/////wBxNgLoCiACIAIoAuwKIAFBHHVqIgFB/////wBxNgLsCiACIAIoAvAKIAFBHHVqIgFB/////wBxNgLwCiACIAIoAvQKIAFBHHVqIgFB/////wBxNgL0CiACIAIoAvgKIAFBHHVqIgFB/////wBxNgL4CiACIAIoAvwKIAFBHHVqIgFB/////wBxNgL8CiACIAIoAoALIAFBHHVqNgKACyAAIAJBsApqEP8DIAAQ2wgLIAJBwAtqJAALwD4BCX8jAEGQAWsiBiQAIAAgAkEfdSIHIAJzIAdBf3NqIghBAm0iC0EBa0EfdSIDIAAoAgAiCSABKAIAc3EgCXM2AgAgACAAKAIEIgkgASgCBHMgA3EgCXM2AgQgACAAKAIIIgkgASgCCHMgA3EgCXM2AgggACAAKAIMIgkgASgCDHMgA3EgCXM2AgwgACAAKAIQIgkgASgCEHMgA3EgCXM2AhAgACAAKAIUIgkgASgCFHMgA3EgCXM2AhQgACAAKAIYIgkgASgCGHMgA3EgCXM2AhggACAAKAIcIgkgASgCHHMgA3EgCXM2AhwgACAAKAIgIgkgASgCIHMgA3EgCXM2AiAgACAAKAIkIgkgASgCJHMgA3EgCXM2AiQgACABQShqIABBKGoiCSAIQQJIIgUbKAIANgIoIAAgACgCLCIIIAEoAixzIANxIAhzNgIsIAAgACgCMCIIIAEoAjBzIANxIAhzNgIwIAAgACgCNCIIIAEoAjRzIANxIAhzNgI0IAAgACgCOCIIIAEoAjhzIANxIAhzNgI4IAAgACgCPCIIIAEoAjxzIANxIAhzNgI8IAAgACgCQCIIIAEoAkBzIANxIAhzNgJAIAAgACgCRCIIIAEoAkRzIANxIAhzNgJEIAAgACgCSCIIIAEoAkhzIANxIAhzNgJIIAAgACgCTCIIIAEoAkxzIANxIAhzNgJMIAAgACgCUCIIIAEoAlBzIANxIAhzNgJQIAAgAUHUAGogAEHUAGoiCCAFGygCADYCVCAAIAAoAlgiCiABKAJYcyADcSAKczYCWCAAIAAoAlwiCiABKAJccyADcSAKczYCXCAAIAAoAmAiCiABKAJgcyADcSAKczYCYCAAIAAoAmQiCiABKAJkcyADcSAKczYCZCAAIAAoAmgiCiABKAJocyADcSAKczYCaCAAIAAoAmwiCiABKAJscyADcSAKczYCbCAAIAAoAnAiCiABKAJwcyADcSAKczYCcCAAIAAoAnQiCiABKAJ0cyADcSAKczYCdCAAIAAoAngiCiABKAJ4cyADcSAKczYCeCAAIAAoAnwiCiABKAJ8cyADcSAKczYCfCAAIAFBgAFqIABBgAFqIgogBRsoAgA2AoABIAAgC0EBcyIEQQFrQR91IgMgACgCACIFIAEoAoQBc3EgBXM2AgAgACAAKAIEIgUgASgCiAFzIANxIAVzNgIEIAAgACgCCCIFIAEoAowBcyADcSAFczYCCCAAIAAoAgwiBSABKAKQAXMgA3EgBXM2AgwgACAAKAIQIgUgASgClAFzIANxIAVzNgIQIAAgACgCFCIFIAEoApgBcyADcSAFczYCFCAAIAAoAhgiBSABKAKcAXMgA3EgBXM2AhggACAAKAIcIgUgASgCoAFzIANxIAVzNgIcIAAgACgCICIFIAEoAqQBcyADcSAFczYCICAAIAAoAiQiBSABKAKoAXMgA3EgBXM2AiQgACAJIAFBrAFqIARBAEoiBRsoAgA2AiggACAAKAIsIgQgASgCsAFzIANxIARzNgIsIAAgACgCMCIEIAEoArQBcyADcSAEczYCMCAAIAAoAjQiBCABKAK4AXMgA3EgBHM2AjQgACAAKAI4IgQgASgCvAFzIANxIARzNgI4IAAgACgCPCIEIAEoAsABcyADcSAEczYCPCAAIAAoAkAiBCABKALEAXMgA3EgBHM2AkAgACAAKAJEIgQgASgCyAFzIANxIARzNgJEIAAgACgCSCIEIAEoAswBcyADcSAEczYCSCAAIAAoAkwiBCABKALQAXMgA3EgBHM2AkwgACAAKAJQIgQgASgC1AFzIANxIARzNgJQIAAgCCABQdgBaiAFGygCADYCVCAAIAAoAlgiBCABKALcAXMgA3EgBHM2AlggACAAKAJcIgQgASgC4AFzIANxIARzNgJcIAAgACgCYCIEIAEoAuQBcyADcSAEczYCYCAAIAAoAmQiBCABKALoAXMgA3EgBHM2AmQgACAAKAJoIgQgASgC7AFzIANxIARzNgJoIAAgACgCbCIEIAEoAvABcyADcSAEczYCbCAAIAAoAnAiBCABKAL0AXMgA3EgBHM2AnAgACAAKAJ0IgQgASgC+AFzIANxIARzNgJ0IAAgACgCeCIEIAEoAvwBcyADcSAEczYCeCAAIAAoAnwiBCABKAKAAnMgA3EgBHM2AnwgACAKIAFBhAJqIAUbKAIANgKAASAAIAtBAnMiBEEBa0EfdSIDIAAoAgAiBSABKAKIAnNxIAVzNgIAIAAgACgCBCIFIAEoAowCcyADcSAFczYCBCAAIAAoAggiBSABKAKQAnMgA3EgBXM2AgggACAAKAIMIgUgASgClAJzIANxIAVzNgIMIAAgACgCECIFIAEoApgCcyADcSAFczYCECAAIAAoAhQiBSABKAKcAnMgA3EgBXM2AhQgACAAKAIYIgUgASgCoAJzIANxIAVzNgIYIAAgACgCHCIFIAEoAqQCcyADcSAFczYCHCAAIAAoAiAiBSABKAKoAnMgA3EgBXM2AiAgACAAKAIkIgUgASgCrAJzIANxIAVzNgIkIAAgCSABQbACaiAEQQBKIgUbKAIANgIoIAAgACgCLCIEIAEoArQCcyADcSAEczYCLCAAIAAoAjAiBCABKAK4AnMgA3EgBHM2AjAgACAAKAI0IgQgASgCvAJzIANxIARzNgI0IAAgACgCOCIEIAEoAsACcyADcSAEczYCOCAAIAAoAjwiBCABKALEAnMgA3EgBHM2AjwgACAAKAJAIgQgASgCyAJzIANxIARzNgJAIAAgACgCRCIEIAEoAswCcyADcSAEczYCRCAAIAAoAkgiBCABKALQAnMgA3EgBHM2AkggACAAKAJMIgQgASgC1AJzIANxIARzNgJMIAAgACgCUCIEIAEoAtgCcyADcSAEczYCUCAAIAggAUHcAmogBRsoAgA2AlQgACAAKAJYIgQgASgC4AJzIANxIARzNgJYIAAgACgCXCIEIAEoAuQCcyADcSAEczYCXCAAIAAoAmAiBCABKALoAnMgA3EgBHM2AmAgACAAKAJkIgQgASgC7AJzIANxIARzNgJkIAAgACgCaCIEIAEoAvACcyADcSAEczYCaCAAIAAoAmwiBCABKAL0AnMgA3EgBHM2AmwgACAAKAJwIgQgASgC+AJzIANxIARzNgJwIAAgACgCdCIEIAEoAvwCcyADcSAEczYCdCAAIAAoAngiBCABKAKAA3MgA3EgBHM2AnggACAAKAJ8IgQgASgChANzIANxIARzNgJ8IAAgCiABQYgDaiAFGygCADYCgAEgACALQQNzIgRBAWtBH3UiAyAAKAIAIgUgASgCjANzcSAFczYCACAAIAAoAgQiBSABKAKQA3MgA3EgBXM2AgQgACAAKAIIIgUgASgClANzIANxIAVzNgIIIAAgACgCDCIFIAEoApgDcyADcSAFczYCDCAAIAAoAhAiBSABKAKcA3MgA3EgBXM2AhAgACAAKAIUIgUgASgCoANzIANxIAVzNgIUIAAgACgCGCIFIAEoAqQDcyADcSAFczYCGCAAIAAoAhwiBSABKAKoA3MgA3EgBXM2AhwgACAAKAIgIgUgASgCrANzIANxIAVzNgIgIAAgACgCJCIFIAEoArADcyADcSAFczYCJCAAIAkgAUG0A2ogBEEASiIFGygCADYCKCAAIAAoAiwiBCABKAK4A3MgA3EgBHM2AiwgACAAKAIwIgQgASgCvANzIANxIARzNgIwIAAgACgCNCIEIAEoAsADcyADcSAEczYCNCAAIAAoAjgiBCABKALEA3MgA3EgBHM2AjggACAAKAI8IgQgASgCyANzIANxIARzNgI8IAAgACgCQCIEIAEoAswDcyADcSAEczYCQCAAIAAoAkQiBCABKALQA3MgA3EgBHM2AkQgACAAKAJIIgQgASgC1ANzIANxIARzNgJIIAAgACgCTCIEIAEoAtgDcyADcSAEczYCTCAAIAAoAlAiBCABKALcA3MgA3EgBHM2AlAgACAIIAFB4ANqIAUbKAIANgJUIAAgACgCWCIEIAEoAuQDcyADcSAEczYCWCAAIAAoAlwiBCABKALoA3MgA3EgBHM2AlwgACAAKAJgIgQgASgC7ANzIANxIARzNgJgIAAgACgCZCIEIAEoAvADcyADcSAEczYCZCAAIAAoAmgiBCABKAL0A3MgA3EgBHM2AmggACAAKAJsIgQgASgC+ANzIANxIARzNgJsIAAgACgCcCIEIAEoAvwDcyADcSAEczYCcCAAIAAoAnQiBCABKAKABHMgA3EgBHM2AnQgACAAKAJ4IgQgASgChARzIANxIARzNgJ4IAAgACgCfCIEIAEoAogEcyADcSAEczYCfCAAIAogAUGMBGogBRsoAgA2AoABIAAgC0EEcyIEQQFrQR91IgMgACgCACIFIAEoApAEc3EgBXM2AgAgACAAKAIEIgUgASgClARzIANxIAVzNgIEIAAgACgCCCIFIAEoApgEcyADcSAFczYCCCAAIAAoAgwiBSABKAKcBHMgA3EgBXM2AgwgACAAKAIQIgUgASgCoARzIANxIAVzNgIQIAAgACgCFCIFIAEoAqQEcyADcSAFczYCFCAAIAAoAhgiBSABKAKoBHMgA3EgBXM2AhggACAAKAIcIgUgASgCrARzIANxIAVzNgIcIAAgACgCICIFIAEoArAEcyADcSAFczYCICAAIAAoAiQiBSABKAK0BHMgA3EgBXM2AiQgACAJIAFBuARqIARBAEoiBRsoAgA2AiggACAAKAIsIgQgASgCvARzIANxIARzNgIsIAAgACgCMCIEIAEoAsAEcyADcSAEczYCMCAAIAAoAjQiBCABKALEBHMgA3EgBHM2AjQgACAAKAI4IgQgASgCyARzIANxIARzNgI4IAAgACgCPCIEIAEoAswEcyADcSAEczYCPCAAIAAoAkAiBCABKALQBHMgA3EgBHM2AkAgACAAKAJEIgQgASgC1ARzIANxIARzNgJEIAAgACgCSCIEIAEoAtgEcyADcSAEczYCSCAAIAAoAkwiBCABKALcBHMgA3EgBHM2AkwgACAAKAJQIgQgASgC4ARzIANxIARzNgJQIAAgCCABQeQEaiAFGygCADYCVCAAIAAoAlgiBCABKALoBHMgA3EgBHM2AlggACAAKAJcIgQgASgC7ARzIANxIARzNgJcIAAgACgCYCIEIAEoAvAEcyADcSAEczYCYCAAIAAoAmQiBCABKAL0BHMgA3EgBHM2AmQgACAAKAJoIgQgASgC+ARzIANxIARzNgJoIAAgACgCbCIEIAEoAvwEcyADcSAEczYCbCAAIAAoAnAiBCABKAKABXMgA3EgBHM2AnAgACAAKAJ0IgQgASgChAVzIANxIARzNgJ0IAAgACgCeCIEIAEoAogFcyADcSAEczYCeCAAIAAoAnwiBCABKAKMBXMgA3EgBHM2AnwgACAKIAFBkAVqIAUbKAIANgKAASAAIAtBBXMiBEEBa0EfdSIDIAAoAgAiBSABKAKUBXNxIAVzNgIAIAAgACgCBCIFIAEoApgFcyADcSAFczYCBCAAIAAoAggiBSABKAKcBXMgA3EgBXM2AgggACAAKAIMIgUgASgCoAVzIANxIAVzNgIMIAAgACgCECIFIAEoAqQFcyADcSAFczYCECAAIAAoAhQiBSABKAKoBXMgA3EgBXM2AhQgACAAKAIYIgUgASgCrAVzIANxIAVzNgIYIAAgACgCHCIFIAEoArAFcyADcSAFczYCHCAAIAAoAiAiBSABKAK0BXMgA3EgBXM2AiAgACAAKAIkIgUgASgCuAVzIANxIAVzNgIkIAAgCSABQbwFaiAEQQBKIgUbKAIANgIoIAAgACgCLCIEIAEoAsAFcyADcSAEczYCLCAAIAAoAjAiBCABKALEBXMgA3EgBHM2AjAgACAAKAI0IgQgASgCyAVzIANxIARzNgI0IAAgACgCOCIEIAEoAswFcyADcSAEczYCOCAAIAAoAjwiBCABKALQBXMgA3EgBHM2AjwgACAAKAJAIgQgASgC1AVzIANxIARzNgJAIAAgACgCRCIEIAEoAtgFcyADcSAEczYCRCAAIAAoAkgiBCABKALcBXMgA3EgBHM2AkggACAAKAJMIgQgASgC4AVzIANxIARzNgJMIAAgACgCUCIEIAEoAuQFcyADcSAEczYCUCAAIAggAUHoBWogBRsoAgA2AlQgACAAKAJYIgQgASgC7AVzIANxIARzNgJYIAAgACgCXCIEIAEoAvAFcyADcSAEczYCXCAAIAAoAmAiBCABKAL0BXMgA3EgBHM2AmAgACAAKAJkIgQgASgC+AVzIANxIARzNgJkIAAgACgCaCIEIAEoAvwFcyADcSAEczYCaCAAIAAoAmwiBCABKAKABnMgA3EgBHM2AmwgACAAKAJwIgQgASgChAZzIANxIARzNgJwIAAgACgCdCIEIAEoAogGcyADcSAEczYCdCAAIAAoAngiBCABKAKMBnMgA3EgBHM2AnggACAAKAJ8IgQgASgCkAZzIANxIARzNgJ8IAAgCiABQZQGaiAFGygCADYCgAEgACALQQZzIgRBAWtBH3UiAyAAKAIAIgUgASgCmAZzcSAFczYCACAAIAAoAgQiBSABKAKcBnMgA3EgBXM2AgQgACAAKAIIIgUgASgCoAZzIANxIAVzNgIIIAAgACgCDCIFIAEoAqQGcyADcSAFczYCDCAAIAAoAhAiBSABKAKoBnMgA3EgBXM2AhAgACAAKAIUIgUgASgCrAZzIANxIAVzNgIUIAAgACgCGCIFIAEoArAGcyADcSAFczYCGCAAIAAoAhwiBSABKAK0BnMgA3EgBXM2AhwgACAAKAIgIgUgASgCuAZzIANxIAVzNgIgIAAgACgCJCIFIAEoArwGcyADcSAFczYCJCAAIAkgAUHABmogBEEASiIFGygCADYCKCAAIAAoAiwiBCABKALEBnMgA3EgBHM2AiwgACAAKAIwIgQgASgCyAZzIANxIARzNgIwIAAgACgCNCIEIAEoAswGcyADcSAEczYCNCAAIAAoAjgiBCABKALQBnMgA3EgBHM2AjggACAAKAI8IgQgASgC1AZzIANxIARzNgI8IAAgACgCQCIEIAEoAtgGcyADcSAEczYCQCAAIAAoAkQiBCABKALcBnMgA3EgBHM2AkQgACAAKAJIIgQgASgC4AZzIANxIARzNgJIIAAgACgCTCIEIAEoAuQGcyADcSAEczYCTCAAIAAoAlAiBCABKALoBnMgA3EgBHM2AlAgACAIIAFB7AZqIAUbKAIANgJUIAAgACgCWCIEIAEoAvAGcyADcSAEczYCWCAAIAAoAlwiBCABKAL0BnMgA3EgBHM2AlwgACAAKAJgIgQgASgC+AZzIANxIARzNgJgIAAgACgCZCIEIAEoAvwGcyADcSAEczYCZCAAIAAoAmgiBCABKAKAB3MgA3EgBHM2AmggACAAKAJsIgQgASgChAdzIANxIARzNgJsIAAgACgCcCIEIAEoAogHcyADcSAEczYCcCAAIAAoAnQiBCABKAKMB3MgA3EgBHM2AnQgACAAKAJ4IgQgASgCkAdzIANxIARzNgJ4IAAgACgCfCIEIAEoApQHcyADcSAEczYCfCAAIAogAUGYB2ogBRsoAgA2AoABIAAgC0EHcyILQQFrQR91IgMgACgCACIFIAEoApwHc3EgBXM2AgAgACAAKAIEIgUgASgCoAdzIANxIAVzNgIEIAAgACgCCCIFIAEoAqQHcyADcSAFczYCCCAAIAAoAgwiBSABKAKoB3MgA3EgBXM2AgwgACAAKAIQIgUgASgCrAdzIANxIAVzNgIQIAAgACgCFCIFIAEoArAHcyADcSAFczYCFCAAIAAoAhgiBSABKAK0B3MgA3EgBXM2AhggACAAKAIcIgUgASgCuAdzIANxIAVzNgIcIAAgACgCICIFIAEoArwHcyADcSAFczYCICAAIAAoAiQiBSABKALAB3MgA3EgBXM2AiQgACAJIAFBxAdqIAtBAEoiCxsoAgA2AiggACAAKAIsIgUgASgCyAdzIANxIAVzNgIsIAAgACgCMCIFIAEoAswHcyADcSAFczYCMCAAIAAoAjQiBSABKALQB3MgA3EgBXM2AjQgACAAKAI4IgUgASgC1AdzIANxIAVzNgI4IAAgACgCPCIFIAEoAtgHcyADcSAFczYCPCAAIAAoAkAiBSABKALcB3MgA3EgBXM2AkAgACAAKAJEIgUgASgC4AdzIANxIAVzNgJEIAAgACgCSCIFIAEoAuQHcyADcSAFczYCSCAAIAAoAkwiBSABKALoB3MgA3EgBXM2AkwgACAAKAJQIgUgASgC7AdzIANxIAVzNgJQIAAgCCABQfAHaiALGygCADYCVCAAIAAoAlgiBSABKAL0B3MgA3EgBXM2AlggACAAKAJcIgUgASgC+AdzIANxIAVzNgJcIAAgACgCYCIFIAEoAvwHcyADcSAFczYCYCAAIAAoAmQiBSABKAKACHMgA3EgBXM2AmQgACAAKAJoIgUgASgChAhzIANxIAVzNgJoIAAgACgCbCIFIAEoAogIcyADcSAFczYCbCAAIAAoAnAiBSABKAKMCHMgA3EgBXM2AnAgACAAKAJ0IgUgASgCkAhzIANxIAVzNgJ0IAAgACgCeCIFIAEoApQIcyADcSAFczYCeCAAIAAoAnwiBSABKAKYCHMgA3EgBXMiAzYCfCAAIAogAUGcCGogCxsoAgAiATYCgAEgBiAAKAIANgIMIAYgACgCBDYCECAGIAAoAgg2AhQgBiAAKAIMNgIYIAYgACgCEDYCHCAGIAAoAhQ2AiAgBiAAKAIYNgIkIAYgACgCHDYCKCAGIAAoAiA2AiwgBiAAKAIkNgIwIAYgACgCKDYCNCAGIAAoAiw2AjggBiAAKAIwNgI8IAYgACgCNDYCQCAGIAAoAjg2AkQgBiAAKAI8NgJIIAYgACgCQDYCTCAGIAAoAkQ2AlAgBiAAKAJINgJUIAYgACgCTDYCWCAGIAAoAlA2AlwgBiAAKAJUNgJgIAYgACgCWDYCZCAGIAAoAlw2AmggBiAAKAJgNgJsIAYgACgCZDYCcCAGIAAoAmg2AnQgBiAAKAJsNgJ4IAYgACgCcDYCfCAGIAAoAnQ2AoABIAAoAnghCyAGIAE2AowBIAYgAzYCiAEgBiALNgKEASAGQThqIgEgARDgCCAGIAYoAjgiAUH/////AHE2AjggBiAGKAI8IAFBHHVqIgFB/////wBxNgI8IAYgBigCQCABQRx1aiIBQf////8AcTYCQCAGIAYoAkQgAUEcdWoiAUH/////AHE2AkQgBiAGKAJIIAFBHHVqIgFB/////wBxNgJIIAYgBigCTCABQRx1aiIBQf////8AcTYCTCAGIAYoAlAgAUEcdWoiAUH/////AHE2AlAgBiAGKAJUIAFBHHVqIgFB/////wBxNgJUIAYgBigCWCABQRx1aiIBQf////8AcTYCWCAGIAYoAlwgAUEcdWo2AlwgACAAKAIAIgEgBigCDHMgB3EgAXM2AgAgACAAKAIEIgEgBigCEHMgB3EgAXM2AgQgACAAKAIIIgEgBigCFHMgB3EgAXM2AgggACAAKAIMIgEgBigCGHMgB3EgAXM2AgwgACAAKAIQIgEgBigCHHMgB3EgAXM2AhAgACAAKAIUIgEgBigCIHMgB3EgAXM2AhQgACAAKAIYIgEgBigCJHMgB3EgAXM2AhggACAAKAIcIgEgBigCKHMgB3EgAXM2AhwgACAAKAIgIgEgBigCLHMgB3EgAXM2AiAgACAAKAIkIgEgBigCMHMgB3EgAXM2AiQgACAGQTRqIAkgAkEASCIBGygCADYCKCAAIAAoAiwiAyAGKAI4cyAHcSADczYCLCAAIAAoAjAiAyAGKAI8cyAHcSADczYCMCAAIAAoAjQiAyAGKAJAcyAHcSADczYCNCAAIAAoAjgiAyAGKAJEcyAHcSADczYCOCAAIAAoAjwiAyAGKAJIcyAHcSADczYCPCAAIAAoAkAiAyAGKAJMcyAHcSADczYCQCAAIAAoAkQiAyAGKAJQcyAHcSADczYCRCAAIAAoAkgiAyAGKAJUcyAHcSADczYCSCAAIAAoAkwiAyAGKAJYcyAHcSADczYCTCAAIAAoAlAiAyAGKAJccyAHcSADczYCUCAAIAZB4ABqIAggARsoAgA2AlQgACAAKAJYIgMgBigCZHMgB3EgA3M2AlggACAAKAJcIgMgBigCaHMgB3EgA3M2AlwgACAAKAJgIgMgBigCbHMgB3EgA3M2AmAgACAAKAJkIgMgBigCcHMgB3EgA3M2AmQgACAAKAJoIgMgBigCdHMgB3EgA3M2AmggACAAKAJsIgMgBigCeHMgB3EgA3M2AmwgACAAKAJwIgMgBigCfHMgB3EgA3M2AnAgACAAKAJ0IgMgBigCgAFzIAdxIANzNgJ0IAAgACgCeCIDIAYoAoQBcyAHcSADczYCeCAAIAAoAnwiAyAGKAKIAXMgB3EgA3M2AnwgACAGQYwBaiAKIAEbKAIANgKAASAGQZABaiQAC+RLATN/IwBBgA5rIgQkACADKAIkIRUgAygCICEbIAMoAhwhDyADKAIYIRAgAygCFCERIAMoAhAhEiADKAIMIRMgAygCCCEWIAMoAgQhFyADKAIAIQkgAigCJCEFIAIoAiAhCCACKAIcIQogAigCGCELIAIoAhQhDCACKAIQIQ0gAigCDCEOIAIoAgghFCACKAIEIRggAigCACEHIAQgACgCADYCpAMgBCAAKAIENgKoAyAEIAAoAgg2AqwDIAQgACgCDDYCsAMgBCAAKAIQNgK0AyAEIAAoAhQ2ArgDIAQgACgCGDYCvAMgBCAAKAIcNgLAAyAEIAAoAiA2AsQDIAQgACgCJDYCyAMgBCAAKAIoNgLMAyAEIAAoAiw2AtADIAQgACgCMDYC1AMgBCAAKAI0NgLYAyAEIAAoAjg2AtwDIAQgACgCPDYC4AMgBCAAKAJANgLkAyAEIAAoAkQ2AugDIAQgACgCSDYC7AMgBCAAKAJMNgLwAyAEIAAoAlA2AvQDIAQgACgCVDYC+AMgBCAAKAJYNgL8AyAEIAAoAlw2AoAEIAQgACgCYDYChAQgBCAAKAJkNgKIBCAEIAAoAmg2AowEIAQgACgCbDYCkAQgBCAAKAJwNgKUBCAEIAAoAnQ2ApgEIAQgACgCeDYCnAQgBCAAKAJ8NgKgBCAEIAAoAoABNgKkBCAEIAEoAgA2AgAgBCABKAIENgIEIAQgASgCCDYCCCAEIAEoAgw2AgwgBCABKAIQNgIQIAQgASgCFDYCFCAEIAEoAhg2AhggBCABKAIcNgIcIAQgASgCIDYCICAEIAEoAiQ2AiQgBCABKAIoNgIoIAQgASgCLDYCLCAEIAEoAjA2AjAgBCABKAI0NgI0IAQgASgCODYCOCAEIAEoAjw2AjwgBCABKAJANgJAIAQgASgCRDYCRCAEIAEoAkg2AkggBCABKAJMNgJMIAQgASgCUDYCUCAEIAEoAlQ2AlQgBCABKAJYNgJYIAQgASgCXDYCXCAEIAEoAmA2AmAgBCABKAJkNgJkIAQgASgCaDYCaCAEIAEoAmw2AmwgBCABKAJwNgJwIAQgASgCdDYCdCAEIAEoAng2AnggBCABKAJ8NgJ8IAQgASgCgAE2AoABIARBLGoiAyADEOAIIAQgBCgCLCICQf////8AcTYCLCAEIAQoAjAgAkEcdWoiAkH/////AHE2AjAgBCAEKAI0IAJBHHVqIgJB/////wBxNgI0IAQgBCgCOCACQRx1aiICQf////8AcTYCOCAEIAQoAjwgAkEcdWoiAkH/////AHE2AjwgBCAEKAJAIAJBHHVqIgJB/////wBxNgJAIAQgBCgCRCACQRx1aiICQf////8AcTYCRCAEIAQoAkggAkEcdWoiAkH/////AHE2AkggBCAEKAJMIAJBHHVqIgJB/////wBxNgJMIAQgBCgCUCACQRx1ajYCUCAEQaQDaiAEEP8DIAQgACgCADYCqAQgBCAAKAIENgKsBCAEIAAoAgg2ArAEIAQgACgCDDYCtAQgBCAAKAIQNgK4BCAEIAAoAhQ2ArwEIAQgACgCGDYCwAQgBCAAKAIcNgLEBCAEIAAoAiA2AsgEIAQgACgCJDYCzAQgBCAAKAIoNgLQBCAEIAAoAiw2AtQEIAQgACgCMDYC2AQgBCAAKAI0NgLcBCAEIAAoAjg2AuAEIAQgACgCPDYC5AQgBCAAKAJANgLoBCAEIAAoAkQ2AuwEIAQgACgCSDYC8AQgBCAAKAJMNgL0BCAEIAAoAlA2AvgEIAQgACgCVDYC/AQgBCAAKAJYNgKABSAEIAAoAlw2AoQFIAQgACgCYDYCiAUgBCAAKAJkNgKMBSAEIAAoAmg2ApAFIAQgACgCbDYClAUgBCAAKAJwNgKYBSAEIAAoAnQ2ApwFIAQgACgCeDYCoAUgBCAAKAJ8NgKkBSAEIAAoAoABNgKoBSAEQagEaiABEP8DIAQgASgCADYCzAsgBCABKAIENgLQCyAEIAEoAgg2AtQLIAQgASgCDDYC2AsgBCABKAIQNgLcCyAEIAEoAhQ2AuALIAQgASgCGDYC5AsgBCABKAIcNgLoCyAEIAEoAiA2AuwLIAQgASgCJDYC8AsgBCABKAIoNgL0CyAEIAEoAiw2AvgLIAQgASgCMDYC/AsgBCABKAI0NgKADCAEIAEoAjg2AoQMIAQgASgCPDYCiAwgBCABKAJANgKMDCAEIAEoAkQ2ApAMIAQgASgCSDYClAwgBCABKAJMNgKYDCAEIAEoAlA2ApwMIAQgASgCVDYCoAwgBCABKAJYNgKkDCAEIAEoAlw2AqgMIAQgASgCYDYCrAwgBCABKAJkNgKwDCAEIAEoAmg2ArQMIAQgASgCbDYCuAwgBCABKAJwNgK8DCAEIAEoAnQ2AsAMIAQgASgCeDYCxAwgBCABKAJ8NgLIDCAEIAEoAoABNgLMDCAEQcwLahDhCCAEIAQoAqQDNgKgAiAEIAT9AAOoA/0LAqQCIAQgBP0AA7gD/QsCtAIgBCAE/QADyAP9CwLEAiAEIAT9AAPYA/0LAtQCIAQgBP0AA+gD/QsC5AIgBCAE/QAD+AP9CwL0AiAEIAQpA4gENwKEAyAEIAQoApAENgKMAyAEIAQoApQENgKQAyAEIAT9AAOYBP0LApQDIAQgBP0AAswL/QsCACAEIAT9AALcC/0LAhAgBCAEKALsCzYCICAEIAT9AALwC/0LAiQgBCAEKQKADDcCNCAEIAQoAogMNgI8IAQgBCgCjAw2AkAgBCAEKAKQDDYCRCAEIAQoApQMNgJIIAQgBCgCmAw2AkwgBCAEKAKcDDYCUCAEIAQoAqAMNgJUIAQgBCgCpAw2AlggBCAEKAKoDDYCXCAEIAQoAqwMNgJgIAQgBCgCsAw2AmQgBCAEKAK0DDYCaCAEIAQoArgMNgJsIAQgBCgCvAw2AnAgBCAEKALADDYCdCAEIAQoAsQMNgJ4IAQgBCgCyAw2AnwgBCAEKALMDDYCgAEgAyADEOAIIAQgBCgCLCICQf////8AcTYCLCAEIAQoAjAgAkEcdWoiAkH/////AHE2AjAgBCAEKAI0IAJBHHVqIgJB/////wBxNgI0IAQgBCgCOCACQRx1aiICQf////8AcTYCOCAEIAQoAjwgAkEcdWoiAkH/////AHE2AjwgBCAEKAJAIAJBHHVqIgJB/////wBxNgJAIAQgBCgCRCACQRx1aiICQf////8AcTYCRCAEIAQoAkggAkEcdWoiAkH/////AHE2AkggBCAEKAJMIAJBHHVqIgJB/////wBxNgJMIAQgBCgCUCACQRx1ajYCUCAEQaACaiAEEP8DIAQgBCgCqAQ2AqwFIAQgBP0AAqwE/QsEsAUgBCAE/QACvAT9CwTABSAEIAT9AALMBP0LBNAFIAQgBP0AAtwE/QsE4AUgBCAE/QAC7AT9CwTwBSAEIAT9AAL8BP0LBIAGIAQgBCkCjAU3A5AGIAQgBCgClAU2ApgGIAQgBCgCmAU2ApwGIAQgBP0AApwF/QsEoAYgBEGsBWogBEHMC2oQ/wMgBCAAKAIANgLICiAEIAAoAgQ2AswKIAQgACgCCDYC0AogBCAAKAIMNgLUCiAEIAAoAhA2AtgKIAQgACgCFDYC3AogBCAAKAIYNgLgCiAEIAAoAhw2AuQKIAQgACgCIDYC6AogBCAAKAIkNgLsCiAEIAAoAig2AvAKIAQgACgCLDYC9AogBCAAKAIwNgL4CiAEIAAoAjQ2AvwKIAQgACgCODYCgAsgBCAAKAI8NgKECyAEIAAoAkA2AogLIAQgACgCRDYCjAsgBCAAKAJINgKQCyAEIAAoAkw2ApQLIAQgACgCUDYCmAsgBCAAKAJUNgKcCyAEIAAoAlg2AqALIAQgACgCXDYCpAsgBCAAKAJgNgKoCyAEIAAoAmQ2AqwLIAQgACgCaDYCsAsgBCAAKAJsNgK0CyAEIAAoAnA2ArgLIAQgACgCdDYCvAsgBCAAKAJ4NgLACyAEIAAoAnw2AsQLIAQgACgCgAE2AsgLIARByApqEOEIIAQgBP0AAqQD/QsCtAcgBCAE/QACtAP9CwLEByAEIAQpAsQDNwLUByAEIAT9AATgA/0LBPAHIAQgBP0ABPAD/QsEgAggBCAE/QAEgAT9CwSQCCAEIAT9AATQA/0LBOAHIAQgBP0ABJAE/QsEoAggBCAEKQOgBDcDsAggBCAEKALMAzYC3AcgBEG0B2ogBEHICmoQ/wMgBCAEKAKoBDYCuAggBCAEKAKsBDYCvAggBCAEKAKwBDYCwAggBCAEKAK0BDYCxAggBCAEKAK4BDYCyAggBCAEKAK8BDYCzAggBCAEKALABDYC0AggBCAEKALEBDYC1AggBCAEKALIBDYC2AggBCAEKALMBDYC3AggBCAEKALQBDYC4AggBCAE/QAC1AT9CwLkCCAEIAT9AALkBP0LAvQIIAQgBP0AAvQE/QsChAkgBCAE/QAChAX9CwKUCSAEIAT9AAKUBf0LAqQJIAQgBCkCpAU3ArQJIARBuAhqIARByApqEP8DIAQgBCgCtAc2ArAGIAQgBCgCuAc2ArQGIAQgBCgCvAc2ArgGIAQgBCgCwAc2ArwGIAQgBCgCxAc2AsAGIAQgBCgCyAc2AsQGIAQgBCgCzAc2AsgGIAQgBCgC0Ac2AswGIAQgBCgC1Ac2AtAGIAQgBCgC2Ac2AtQGIAQgBCgC3Ac2AtgGIAQgBP0ABOAH/QsC3AYgBCAE/QAE8Af9CwLsBiAEIAT9AASACP0LAvwGIAQgBP0ABJAI/QsCjAcgBCAE/QAEoAj9CwKcByAEIAQpA7AINwKsByAEIAQoAswLNgIAIAQgBCgC0As2AgQgBCAEKALUCzYCCCAEIAQoAtgLNgIMIAQgBCgC3As2AhAgBCAEKALgCzYCFCAEIAQoAuQLNgIYIAQgBCgC6As2AhwgBCAEKALsCzYCICAEIAQoAvALNgIkIAQgBCgC9As2AiggBCAEKAL4CzYCLCAEIAQoAvwLNgIwIAQgBCgCgAw2AjQgBCAEKAKEDDYCOCAEIAQoAogMNgI8IAQgBCgCjAw2AkAgBCAEKAKQDDYCRCAEIAQoApQMNgJIIAQgBCgCmAw2AkwgBCAEKAKcDDYCUCAEIAQoAqAMNgJUIAQgBCgCpAw2AlggBCAEKAKoDDYCXCAEIAQoAqwMNgJgIAQgBCgCsAw2AmQgBCAEKAK0DDYCaCAEIAQoArgMNgJsIAQgBCgCvAw2AnAgBCAEKALADDYCdCAEIAQoAsQMNgJ4IAQgBCgCyAw2AnwgBCAEKALMDDYCgAEgAyADEOAIIAQgBCgCLCIDQf////8AcTYCLCAEIAQoAjAgA0EcdWoiA0H/////AHE2AjAgBCAEKAI0IANBHHVqIgNB/////wBxNgI0IAQgBCgCOCADQRx1aiIDQf////8AcTYCOCAEIAQoAjwgA0EcdWoiA0H/////AHE2AjwgBCAEKAJAIANBHHVqIgNB/////wBxNgJAIAQgBCgCRCADQRx1aiIDQf////8AcTYCRCAEIAQoAkggA0EcdWoiA0H/////AHE2AkggBCAEKAJMIANBHHVqIgNB/////wBxNgJMIAQgBCgCUCADQRx1ajYCUCAEQbAGaiAEEP8DIAQgBCgCuAg2ArwJIAQgBCgCvAg2AsAJIAQgBCgCwAg2AsQJIAQgBCgCxAg2AsgJIAQgBCgCyAg2AswJIAQgBCgCzAg2AtAJIAQgBCgC0Ag2AtQJIAQgBCgC1Ag2AtgJIAQgBCgC2Ag2AtwJIAQgBCgC3Ag2AuAJIAQgBP0ABOAI/QsC5AkgBCAE/QAE8Aj9CwL0CSAEIAT9AASACf0LAoQKIAQgBP0ABJAJ/QsClAogBCAE/QAEoAn9CwKkCiAEIAQpA7AJNwK0CiAEIAQoArgJNgK8CiAEQbwJaiAEQcwLahD/AyAEIAUgCCAKIAsgDCANIA4gFCAYIAdBHHVqIgNBHHVqIgJBHHVqIg5BHHVqIg1BHHVqIgxBHHVqIgtBHHVqIgpBHHVqIghBHHVqIAhB/////wBxIApB/////wBxIAtB/////wBxIAxB/////wBxIA1B/////wBxIA5B/////wBxIAJB/////wBxIANB/////wBxIAdB/////wBxQQFqIgJBHHZqIgNBHHZqIgVBHHZqIhRBHHZqIg5BHHZqIg1BHHZqIgxBHHZqIgtBHHZqIgpBHHZqIgggCkH/////AHEiCiALQf////8AcSILIAxB/////wBxIgwgDUH/////AHEiDSAOQf////8AcSIOIBRB/////wBxIhQgBUH/////AHEiGCADQf////8AcSIeIAJB/////wBxIhxBAWoiA0EcdmoiBUEcdmoiHUEcdmoiGUEcdmoiGkEcdmoiH0EcdmoiIEEcdmoiIUEcdmoiIkEcdmoiIzYC9AwgBCAiQf////8AcSIiNgLwDCAEICFB/////wBxIiE2AuwMIAQgIEH/////AHEiIDYC6AwgBCAfQf////8AcSIfNgLkDCAEIBpB/////wBxIho2AuAMIAQgGUH/////AHEiGTYC3AwgBCAdQf////8AcSIdNgLYDCAEIAVB/////wBxIiQ2AtQMIAQgA0H/////AHEiJTYC0AxBACEDIARBACACQQFxayICIAQoAsgKIgUgACgCAHNxIAVzNgLICiAEIAQoAswKIgUgACgCBHMgAnEgBXM2AswKIAQgBCgC0AoiBSAAKAIIcyACcSAFczYC0AogBCAEKALUCiIFIAAoAgxzIAJxIAVzNgLUCiAEIAQoAtgKIgUgACgCEHMgAnEgBXM2AtgKIAQgBCgC3AoiBSAAKAIUcyACcSAFczYC3AogBCAEKALgCiIFIAAoAhhzIAJxIAVzNgLgCiAEIAQoAuQKIgUgACgCHHMgAnEgBXM2AuQKIAQgBCgC6AoiBSAAKAIgcyACcSAFczYC6AogBCAEKALsCiIFIAAoAiRzIAJxIAVzNgLsCiAEIAQoAvAKIgUgACgCKHMgAnEgBXM2AvAKIAQgBCgC9AoiBSAAKAIscyACcSAFczYC9AogBCAEKAL4CiIFIAAoAjBzIAJxIAVzNgL4CiAEIAQoAvwKIgUgACgCNHMgAnEgBXM2AvwKIAQgBCgCgAsiBSAAKAI4cyACcSAFczYCgAsgBCAEKAKECyIFIAAoAjxzIAJxIAVzNgKECyAEIAQoAogLIgUgACgCQHMgAnEgBXM2AogLIAQgBCgCjAsiBSAAKAJEcyACcSAFczYCjAsgBCAEKAKQCyIFIAAoAkhzIAJxIAVzNgKQCyAEIAQoApQLIgUgACgCTHMgAnEgBXM2ApQLIAQgBCgCmAsiBSAAKAJQcyACcSAFczYCmAsgBCAEKAKcCyIFIAAoAlRzIAJxIAVzNgKcCyAEIAQoAqALIgUgACgCWHMgAnEgBXM2AqALIAQgBCgCpAsiBSAAKAJccyACcSAFczYCpAsgBCAEKAKoCyIFIAAoAmBzIAJxIAVzNgKoCyAEIAQoAqwLIgUgACgCZHMgAnEgBXM2AqwLIAQgBCgCsAsiBSAAKAJocyACcSAFczYCsAsgBCAEKAK0CyIFIAAoAmxzIAJxIAVzNgK0CyAEIAQoArgLIgUgACgCcHMgAnEgBXM2ArgLIAQgBCgCvAsiBSAAKAJ0cyACcSAFczYCvAsgBCAEKALACyIFIAAoAnhzIAJxIAVzNgLACyAEIAQoAsQLIgUgACgCfHMgAnEgBXMiBTYCxAsgBCAEKALICyIGIAAoAoABcyACcSAGcyICNgLICyAEIAQoAsgKNgKcASAEIAQoAswKNgKgASAEIAQoAtAKNgKkASAEIAQoAtQKNgKoASAEIAQoAtgKNgKsASAEIAQoAtwKNgKwASAEIAQoAuAKNgK0ASAEIAQoAuQKNgK4ASAEIAQoAugKNgK8ASAEIAQoAuwKNgLAASAEIAQoAvAKNgLEASAEIAQoAvQKNgLIASAEIAQoAvgKNgLMASAEIAQoAvwKNgLQASAEIAQoAoALNgLUASAEIAQoAoQLNgLYASAEIAQoAogLNgLcASAEIAQoAowLNgLgASAEIAQoApALNgLkASAEIAQoApQLNgLoASAEIAQoApgLNgLsASAEIAQoApwLNgLwASAEIAQoAqALNgL0ASAEIAQoAqQLNgL4ASAEIAQoAqgLNgL8ASAEIAQoAqwLNgKAAiAEIAQoArALNgKEAiAEIAQoArQLNgKIAiAEIAQoArgLNgKMAiAEIAQoArwLNgKQAiAEKALACyEGIAQgAjYCnAIgBCAFNgKYAiAEIAY2ApQCIARBACAJQf////8AcUEBaiIFQQFxayICIAQoAswLIgYgASgCAHNxIAZzNgLMCyAEIAQoAtALIgYgASgCBHMgAnEgBnM2AtALIAQgBCgC1AsiBiABKAIIcyACcSAGczYC1AsgBCAEKALYCyIGIAEoAgxzIAJxIAZzNgLYCyAEIAQoAtwLIgYgASgCEHMgAnEgBnM2AtwLIAQgBCgC4AsiBiABKAIUcyACcSAGczYC4AsgBCAEKALkCyIGIAEoAhhzIAJxIAZzNgLkCyAEIAQoAugLIgYgASgCHHMgAnEgBnM2AugLIAQgBCgC7AsiBiABKAIgcyACcSAGczYC7AsgBCAEKALwCyIGIAEoAiRzIAJxIAZzNgLwCyAEIAQoAvQLIgYgASgCKHMgAnEgBnM2AvQLIAQgBCgC+AsiBiABKAIscyACcSAGczYC+AsgBCAEKAL8CyIGIAEoAjBzIAJxIAZzNgL8CyAEIAQoAoAMIgYgASgCNHMgAnEgBnM2AoAMIAQgBCgChAwiBiABKAI4cyACcSAGczYChAwgBCAEKAKIDCIGIAEoAjxzIAJxIAZzNgKIDCAEIAQoAowMIgYgASgCQHMgAnEgBnM2AowMIAQgBCgCkAwiBiABKAJEcyACcSAGczYCkAwgBCAEKAKUDCIGIAEoAkhzIAJxIAZzNgKUDCAEIAQoApgMIgYgASgCTHMgAnEgBnM2ApgMIAQgBCgCnAwiBiABKAJQcyACcSAGczYCnAwgBCAEKAKgDCIGIAEoAlRzIAJxIAZzNgKgDCAEIAQoAqQMIgYgASgCWHMgAnEgBnM2AqQMIAQgBCgCqAwiBiABKAJccyACcSAGczYCqAwgBCAEKAKsDCIGIAEoAmBzIAJxIAZzNgKsDCAEIAQoArAMIgYgASgCZHMgAnEgBnM2ArAMIAQgBCgCtAwiBiABKAJocyACcSAGczYCtAwgBCAEKAK4DCIGIAEoAmxzIAJxIAZzNgK4DCAEIAQoArwMIgYgASgCcHMgAnEgBnM2ArwMIAQgBCgCwAwiBiABKAJ0cyACcSAGczYCwAwgBCAEKALEDCIGIAEoAnhzIAJxIAZzNgLEDCAEIAQoAsgMIgYgASgCfHMgAnEgBnM2AsgMIAQgASgCgAEgBCgCzAwiAXMgAnEgAXM2AswMIARBnAFqIARBzAtqEP8DIAQgFSAbIA8gECARIBIgEyAWIBcgCUEcdWoiAUEcdWoiAkEcdWoiE0EcdWoiEkEcdWoiEUEcdWoiEEEcdWoiD0EcdWoiG0EcdWogG0H/////AHEgD0H/////AHEgEEH/////AHEgEUH/////AHEgEkH/////AHEgE0H/////AHEgAkH/////AHEgAUH/////AHEgBUEcdmoiAkEcdmoiF0EcdmoiFkEcdmoiE0EcdmoiEkEcdmoiEUEcdmoiEEEcdmoiD0EcdmoiFSAPQf////8AcSIGIBBB/////wBxIiYgEUH/////AHEiJyASQf////8AcSIoIBNB/////wBxIikgFkH/////AHEiKiAXQf////8AcSIrIAJB/////wBxIiwgBUH/////AHEiLUEBaiIuQRx2aiIvQRx2aiIwQRx2aiIxQRx2aiIyQRx2aiIzQRx2aiI0QRx2aiI1QRx2aiI2QRx2aiAVc0EAIAlBAm9rIgFxIBVzIhVBACAHQQJvayIJIAggI3NxIAhzIhtqIA8gNnMgAXFB/////wBxIAZzIg8gCiAicyAJcSAKcyIKaiAQIDVzIAFxQf////8AcSAmcyIQIAsgIXMgCXEgC3MiC2ogESA0cyABcUH/////AHEgJ3MiESAMICBzIAlxIAxzIgxqIBIgM3MgAXFB/////wBxIChzIhIgDSAfcyAJcSANcyINaiATIDJzIAFxQf////8AcSApcyITIA4gGnMgCXEgDnMiDmogFiAxcyABcUH/////AHEgKnMiFiAUIBlzIAlxIBRzIhRqIBcgMHMgAXFB/////wBxICtzIhcgGCAdcyAJcSAYcyIYaiACIC9zIAFxQf////8AcSAscyIdIB4gJHMgCXEgHnMiHmogBSAucyABcUH/////AHEgLXMiAiAcICVzIAlxIBxzIglqIgFBHHZqIgdBHHZqIgVBHHZqIghBHHZqIhxBHHZqIhlBHHZqIhpBHHZqIh9BHHZqIiBBHHZqNgL0DCAEICBB/////wBxNgLwDCAEIB9B/////wBxNgLsDCAEIBpB/////wBxNgLoDCAEIBlB/////wBxNgLkDCAEIBxB/////wBxNgLgDCAEIAhB/////wBxNgLcDCAEIAVB/////wBxNgLYDCAEIAdB/////wBxNgLUDCAEIAFB/////wBxNgLQDCAEQdAMahDMCCIHQQFqQQJtIgFBAWohGSAHQX5IIhpFBEAgAUEAIAFBAEobIRwDQCADIARqIAJBB3FBBGsiByAJQQdxQQRrIgVBAnRqOgAAIB0gAiAHayICQRx1aiIHQRp0QYCAgOAAcSACQQJ2Qf///x9xciECIB4gCSAFayIJQRx1aiIFQRp0QYCAgOAAcSAJQQJ2Qf///x9xciEJIBcgB0EcdWoiCEEadEGAgIDgAHEgB0ECdkH///8fcXIhHSAYIAVBHHVqIgdBGnRBgICA4ABxIAVBAnZB////H3FyIR4gFiAIQRx1aiIFQRp0QYCAgOAAcSAIQQJ2Qf///x9xciEXIBQgB0EcdWoiCEEadEGAgIDgAHEgB0ECdkH///8fcXIhGCATIAVBHHVqIgdBGnRBgICA4ABxIAVBAnZB////H3FyIRYgDiAIQRx1aiIFQRp0QYCAgOAAcSAIQQJ2Qf///x9xciEUIBIgB0EcdWoiCEEadEGAgIDgAHEgB0ECdkH///8fcXIhEyANIAVBHHVqIgdBGnRBgICA4ABxIAVBAnZB////H3FyIQ4gESAIQRx1aiIFQRp0QYCAgOAAcSAIQQJ2Qf///x9xciESIAwgB0EcdWoiCEEadEGAgIDgAHEgB0ECdkH///8fcXIhDSAQIAVBHHVqIgdBGnRBgICA4ABxIAVBAnZB////H3FyIREgCyAIQRx1aiIFQRp0QYCAgOAAcSAIQQJ2Qf///x9xciEMIA8gB0EcdWoiCEEadEGAgIDgAHEgB0ECdkH///8fcXIhECAKIAVBHHVqIgdBGnRBgICA4ABxIAVBAnZB////H3FyIQsgFSAIQRx1aiIFQRp0QYCAgOAAcSAIQQJ2Qf///x9xciEPIBsgB0EcdWoiCEEadEGAgIDgAHEgB0ECdkH///8fcXIhCiAFQQJ1IRUgCEECdSEbIAMgHEchByADQQFqIQMgBw0ACwsgBCAZaiAJQQJ0QRxxIAJBB3FqIgM6AAAgACAEQaACaiADQQFrQQJtQf//A3FBhAFsaiIDKAIANgIAIAAgAygCBDYCBCAAIAMoAgg2AgggACADKAIMNgIMIAAgAygCEDYCECAAIAMoAhQ2AhQgACADKAIYNgIYIAAgAygCHDYCHCAAIAMoAiA2AiAgACADKAIkNgIkIAAgAygCKDYCKCAAIAMoAiw2AiwgACADKAIwNgIwIAAgAygCNDYCNCAAIAMoAjg2AjggACADKAI8NgI8IAAgAygCQDYCQCAAIAMoAkQ2AkQgACADKAJINgJIIAAgAygCTDYCTCAAIAMoAlA2AlAgACADKAJUNgJUIAAgAygCWDYCWCAAIAMoAlw2AlwgACADKAJgNgJgIAAgAygCZDYCZCAAIAMoAmg2AmggACADKAJsNgJsIAAgAygCcDYCcCAAIAMoAnQ2AnQgACADKAJ4NgJ4IAAgAygCfDYCfCAAIAMoAoABNgKAASAaRQRAA0AgBEHICmogBEGgAmogASAEaiwAABDlCCAAEOEIIAAQ4QggACAEQcgKahD/AyABQQBKIQMgAUEBayEBIAMNAAsLIAQgBCgCnAE2AvwMIAQgBP0AAqAB/QsCgA0gBCAE/QACsAH9CwKQDSAEIAT9AALAAf0LAqANIAQgBP0AAtAB/QsCsA0gBCAE/QAC4AH9CwLADSAEIAT9AALwAf0LAtANIAQgBCkCgAI3AuANIAQgBCgCiAI2AugNIAQgBCgCjAI2AuwNIAQgBP0AApAC/QsC8A0gBEGoDWoiASABEOAIIAQgBCgCqA0iAUH/////AHE2AqgNIAQgBCgCrA0gAUEcdWoiAUH/////AHE2AqwNIAQgBCgCsA0gAUEcdWoiAUH/////AHE2ArANIAQgBCgCtA0gAUEcdWoiAUH/////AHE2ArQNIAQgBCgCuA0gAUEcdWoiAUH/////AHE2ArgNIAQgBCgCvA0gAUEcdWoiAUH/////AHE2ArwNIAQgBCgCwA0gAUEcdWoiAUH/////AHE2AsANIAQgBCgCxA0gAUEcdWoiAUH/////AHE2AsQNIAQgBCgCyA0gAUEcdWoiAUH/////AHE2AsgNIAQgBCgCzA0gAUEcdWo2AswNIAAgBEH8DGoQ/wMgABDbCCAEQYAOaiQACywBAn8jACIEIANBkAFsayIFJAAgAEEAIAFBACACQQAgBUEAIAMQ6AUgBCQAC7wFACABIAIoAgA2AgAgASACKAIENgIEIAEgAigCCDYCCCABIAIoAgw2AgwgASACKAIQNgIQIAEgAigCFDYCFCABIAIoAhg2AhggASACKAIcNgIcIAEgAigCIDYCICABIAIoAiQ2AiQgASACKAIoNgIoIAEgAigCLDYCLCABIAIoAjA2AjAgASACKAI0NgI0IAEgAigCODYCOCABIAIoAjw2AjwgASACKAJANgJAIAEgAigCREH//x9xNgJEIAAgAUcEQCAAIAIoAowBQQp0IAIoAogBIgFBE3VyNgJEIABBQGsgAUEKdEGA+P//AXEgAigChAEiAUETdXI2AgAgACABQQp0QYD4//8BcSACKAKAASIBQRN1cjYCPCAAIAFBCnRBgPj//wFxIAIoAnwiAUETdXI2AjggACABQQp0QYD4//8BcSACKAJ4IgFBE3VyNgI0IAAgAUEKdEGA+P//AXEgAigCdCIBQRN1cjYCMCAAIAFBCnRBgPj//wFxIAIoAnAiAUETdXI2AiwgACABQQp0QYD4//8BcSACKAJsIgFBE3VyNgIoIAAgAUEKdEGA+P//AXEgAigCaCIBQRN1cjYCJCAAIAFBCnRBgPj//wFxIAIoAmQiAUETdXI2AiAgACABQQp0QYD4//8BcSACKAJgIgFBE3VyNgIcIAAgAUEKdEGA+P//AXEgAigCXCIBQRN1cjYCGCAAIAFBCnRBgPj//wFxIAIoAlgiAUETdXI2AhQgACABQQp0QYD4//8BcSACKAJUIgFBE3VyNgIQIAAgAUEKdEGA+P//AXEgAigCUCIBQRN1cjYCDCAAIAFBCnRBgPj//wFxIAIoAkwiAUETdXI2AgggACABQQp0QYD4//8BcSACKAJIIgFBE3VyNgIEIAAgAUEKdEGA+P//AXEgAigCREETdXI2AgALC4UHAQl/IAJBAmshCgNAIAAgA0HIAGxqIgQQ6QUhBSAEIAQoAkQgBUETdHM2AkQgBEHIAGoiBCAFIAQoAgBqNgIAIAMgCkchBCADQQFqIQMgBA0ACyAAIAJByABsakHIAGsiCxDpBRogAiEDAkACQANAIANBAEwNASAAIANBAWsiA0HIAGwiBGogASAEahDqCCIERQ0ACyAEQQBIDQELIAEgAkEBayIJQcgAbGohBgNAQQAhB0EAIQQDQCABIARByABsaiIDQQEQ2gUhBSADIAMoAgAgB3I2AgAgAyADKAJEIAVBE3RzNgJEIAUhByAEQQFqIgQgCUcNAAsgBkEBENoFGiAGIAYoAgAgBXI2AgAgCEEBaiEIIAIhAwNAAkAgA0EATARAQQAhBAwBCyAAIANBAWsiA0HIAGwiBGogASAEahDqCCIERQ0BCwsgBEEATg0ACyABQcwAayEJA0AgCCEGIAIhAwNAIANByABsIgQgAWpByABrEOoFIQUgBCAJaiIEIAQoAgAgBUETdHI2AgAgA0ECSyEEIANBAWshAyAEDQALIAEQ6gUaIAIhAwJAAkADQCADQQBMDQEgACADQQFrIgNByABsIgRqIAEgBGoQ6ggiBEUNAAsgBEEASA0BC0EAIQVBACEHA0AgACAHQcgAbCIEaiIDIAMoAgAgASAEaiIEKAIAazYCACADIAMoAgQgBCgCBGs2AgQgAyADKAIIIAQoAghrNgIIIAMgAygCDCAEKAIMazYCDCADIAMoAhAgBCgCEGs2AhAgAyADKAIUIAQoAhRrNgIUIAMgAygCGCAEKAIYazYCGCADIAMoAhwgBCgCHGs2AhwgAyADKAIgIAQoAiBrNgIgIAMgAygCJCAEKAIkazYCJCADIAMoAiggBCgCKGs2AiggAyADKAIsIAQoAixrNgIsIAMgAygCMCAEKAIwazYCMCADIAMoAjQgBCgCNGs2AjQgAyADKAI4IAQoAjhrNgI4IAMgAygCPCAEKAI8azYCPCADIAMoAkAgBCgCQGs2AkAgAyADKAJEIAQoAkRrNgJEIAdBAWoiByACRw0ACwNAIAAgBUHIAGxqIgMQ6QUhBCADIAMoAkQgBEETdHM2AkQgA0HIAGoiAyAEIAMoAgBqNgIAIAUgCkchAyAFQQFqIQUgAw0ACyALEOkFGgsgBkEBayEIIAZBAUoNAAsLC8kCAQJ/An8CQCAAKAJEIgIgASgCRCIDRw0AIAAoAkAiAiABKAJAIgNHDQAgACgCPCICIAEoAjwiA0cNACAAKAI4IgIgASgCOCIDRw0AIAAoAjQiAiABKAI0IgNHDQAgACgCMCICIAEoAjAiA0cNACAAKAIsIgIgASgCLCIDRw0AIAAoAigiAiABKAIoIgNHDQAgACgCJCICIAEoAiQiA0cNACAAKAIgIgIgASgCICIDRw0AIAAoAhwiAiABKAIcIgNHDQAgACgCGCICIAEoAhgiA0cNACAAKAIUIgIgASgCFCIDRw0AIAAoAhAiAiABKAIQIgNHDQAgACgCDCICIAEoAgwiA0cNACAAKAIIIgIgASgCCCIDRw0AIAAoAgQiAiABKAIEIgNHDQBBACAAKAIAIgIgASgCACIDRg0BGgtBAUF/IAIgA0obCwv3FgICfgd/IAZBAUYEQCACIANByABsaiICEOkFGiAEIAVByABsaiIJIAI0AgAiByAHfiIHp0H/////AXE2AgAgCSACNAIAIAJBBGoiCjQCAH5CAYYgB0IdiHwiB6dB/////wFxNgIEIAkgAjQCACACNAIIfkIBhiAHQh2HfCAKNAIAIgcgB358IgenQf////8BcTYCCCAJIAo0AgAgAjQCCH4gAjQCACACNAIMfnxCAYYgB0Idh3wiB6dB/////wFxNgIMIAkgCjQCACACNAIMfiACNAIAIAI0AhB+fEIBhiAHQh2HfCACNAIIIgcgB358IgenQf////8BcTYCECAJIAo0AgAgAjQCEH4gAjQCACACNAIUfnwgAjQCCCACNAIMfnxCAYYgB0Idh3wiB6dB/////wFxNgIUIAkgCjQCACACNAIUfiACNAIAIAI0Ahh+fCACNAIIIAI0AhB+fEIBhiAHQh2HfCACNAIMIgcgB358IgenQf////8BcTYCGCAJIAo0AgAgAjQCGH4gAjQCACACNAIcfnwgAjQCCCACNAIUfnwgAjQCDCACNAIQfnxCAYYgB0Idh3wiB6dB/////wFxNgIcIAkgCjQCACACNAIcfiACNAIAIAI0AiB+fCACNAIIIAI0Ahh+fCACNAIMIAI0AhR+fEIBhiAHQh2HfCACNAIQIgcgB358IgenQf////8BcTYCICAJIAo0AgAgAjQCIH4gAjQCACACNAIkfnwgAjQCCCACNAIcfnwgAjQCDCACNAIYfnwgAjQCECACNAIUfnxCAYYgB0Idh3wiB6dB/////wFxNgIkIAkgCjQCACACNAIkfiACNAIAIAI0Aih+fCACNAIIIAI0AiB+fCACNAIMIAI0Ahx+fCACNAIQIAI0Ahh+fEIBhiAHQh2HfCACNAIUIgcgB358IgenQf////8BcTYCKCAJIAo0AgAgAjQCKH4gAjQCACACNAIsfnwgAjQCCCACNAIkfnwgAjQCDCACNAIgfnwgAjQCECACNAIcfnwgAjQCFCACNAIYfnxCAYYgB0Idh3wiB6dB/////wFxNgIsIAkgCjQCACACNAIsfiACNAIAIAI0AjB+fCACNAIIIAI0Aih+fCACNAIMIAI0AiR+fCACNAIQIAI0AiB+fCACNAIUIAI0Ahx+fEIBhiAHQh2HfCACNAIYIgcgB358IgenQf////8BcTYCMCAJIAo0AgAgAjQCMH4gAjQCACACNAI0fnwgAjQCCCACNAIsfnwgAjQCDCACNAIofnwgAjQCECACNAIkfnwgAjQCFCACNAIgfnwgAjQCGCACNAIcfnxCAYYgB0Idh3wiB6dB/////wFxNgI0IAkgCjQCACACNAI0fiACNAIAIAI0Ajh+fCACNAIIIAI0AjB+fCACNAIMIAI0Aix+fCACNAIQIAI0Aih+fCACNAIUIAI0AiR+fCACNAIYIAI0AiB+fEIBhiAHQh2HfCACNAIcIgcgB358IgenQf////8BcTYCOCAJIAo0AgAgAjQCOH4gAjQCACACNAI8fnwgAjQCCCACNAI0fnwgAjQCDCACNAIwfnwgAjQCECACNAIsfnwgAjQCFCACNAIofnwgAjQCGCACNAIkfnwgAjQCHCACNAIgfnxCAYYgB0Idh3wiB6dB/////wFxNgI8IAkgCjQCACACNAI8fiACNAIAIAI0AkB+fCACNAIIIAI0Ajh+fCACNAIMIAI0AjR+fCACNAIQIAI0AjB+fCACNAIUIAI0Aix+fCACNAIYIAI0Aih+fCACNAIcIAI0AiR+fEIBhiAHQh2HfCACNAIgIgcgB358IgenQf////8BcTYCQCAHQh2HIQhBCSELQREhDgNAIAIgDiIFQQJ0IgRqIg5BxABrNAIAIAI0AkR+IQcCQCAFQRBrIgMgBUEBaiIGQQF2Ig9PBEAgBUEPayEDDAELIAIgA0ECdGo0AgAgAjQCQH4gB3whByAFQQ9rIgMgC0YNACACIANBAnRqNAIAIAI0Ajx+IAd8IQcgBUEOayIMIAtGDQAgAiAMQQJ0ajQCACACNAI4fiAHfCEHIAVBDWsiDCALRg0AIAIgDEECdGo0AgAgAjQCNH4gB3whByAFQQxrIgwgC0YNACACIAxBAnRqNAIAIAI0AjB+IAd8IQcgBUELayIMIAtGDQAgAiAMQQJ0ajQCACACNAIsfiAHfCEHIAVBCmsiDCALRg0AIAIgDEECdGo0AgAgAjQCKH4gB3whByAFQQlrIgwgC0YNACACIAxBAnRqNAIAIAI0AiR+IAd8IQcLIAQgCWogB0IBhiAIfCIHp0H/////AXE2AgAgB0IdhyEIIA5BQGo0AgAgAjQCRH4hBwJAIAMgBUECaiIOQQF2Tw0AIA1BAXEEfyADBSACIANBAnRqNAIAIAI0AkB+IAd8IQcgBUEOawshBCANQQZGDQADQCAKIARBAnQiA2o0AgAgAiAFIARrQQJ0ajQCAH4gAiADajQCACACIAYgBGtBAnRqNAIAfiAHfHwhByAEQQJqIgQgC0cNAAsLIAkgBkECdGogB0IBhiAIfCACIA9BAnRqNAIAIgcgB358IgenQf////8BcTYCACAHQh2HIQggDUEBaiENIAtBAWoiC0ERRw0ACyAJIAI0AkAgAjQCRH5CAYYgCHwiB6dB/////wFxNgKEASAJIAI0AkQiCCAIfiAHQh2HfCIHQh2IPgKMASAJIAenQf////8BcTYCiAEgACABQcgAbGoiBEHIAGogBCAJEOgIDwsgACABIAIgAyAEIAUgBmoiCiAGQQF2IgsQ6wggACABIAZqIAIgAyALaiINIAQgCiALEOsIIAQgBSACIAMgAiANIAQgCiALEOgFIAAgC0HIAGxqIAFByABsaiEDIAQgBUHIAGxqIQpBACEFQQAhCwNAIAMgC0HIAGwiAmoiBCACIApqIgIoAgAgBCgCAGo2AgAgBCACKAIEIAQoAgRqNgIEIAQgAigCCCAEKAIIajYCCCAEIAIoAgwgBCgCDGo2AgwgBCACKAIQIAQoAhBqNgIQIAQgAigCFCAEKAIUajYCFCAEIAIoAhggBCgCGGo2AhggBCACKAIcIAQoAhxqNgIcIAQgAigCICAEKAIgajYCICAEIAIoAiQgBCgCJGo2AiQgBCACKAIoIAQoAihqNgIoIAQgAigCLCAEKAIsajYCLCAEIAIoAjAgBCgCMGo2AjAgBCACKAI0IAQoAjRqNgI0IAQgAigCOCAEKAI4ajYCOCAEIAIoAjwgBCgCPGo2AjwgBCACKAJAIAQoAkBqNgJAIAQgAigCRCAEKAJEajYCRCALQQFqIgsgBkcNAAsDQCADIAVByABsIgJqIgQgAiAKaiICKAIAIAQoAgBqNgIAIAQgAigCBCAEKAIEajYCBCAEIAIoAgggBCgCCGo2AgggBCACKAIMIAQoAgxqNgIMIAQgAigCECAEKAIQajYCECAEIAIoAhQgBCgCFGo2AhQgBCACKAIYIAQoAhhqNgIYIAQgAigCHCAEKAIcajYCHCAEIAIoAiAgBCgCIGo2AiAgBCACKAIkIAQoAiRqNgIkIAQgAigCKCAEKAIoajYCKCAEIAIoAiwgBCgCLGo2AiwgBCACKAIwIAQoAjBqNgIwIAQgAigCNCAEKAI0ajYCNCAEIAIoAjggBCgCOGo2AjggBCACKAI8IAQoAjxqNgI8IAQgAigCQCAEKAJAajYCQCAEIAIoAkQgBCgCRGo2AkQgBUEBaiIFIAZHDQALIAZBAmshC0EAIQQDQCADIARByABsaiICEOkFIQUgAiACKAJEIAVBE3RzNgJEIAJByABqIgIgBSACKAIAajYCACAEIAtHIQIgBEEBaiEEIAINAAsgAyAGQcgAbGpByABrEOkFGgukEgELfyMAIgQhDiAEIANBkAFsIgVrIgYiBCQAIANBAXQhCSAEIAVrIggkAANAIAggB0HIAGwiBWoiBCABIAVqIgUoAgA2AgAgBCAFKAIENgIEIAQgBSgCCDYCCCAEIAUoAgw2AgwgBCAFKAIQNgIQIAQgBSgCFDYCFCAEIAUoAhg2AhggBCAFKAIcNgIcIAQgBSgCIDYCICAEIAUoAiQ2AiQgBCAFKAIoNgIoIAQgBSgCLDYCLCAEIAUoAjA2AjAgBCAFKAI0NgI0IAQgBSgCODYCOCAEIAUoAjw2AjwgBCAFKAJANgJAIAQgBSgCRDYCRCAHQQFqIgcgCUcNAAsgCUECayEKQQAhBANAIAggBEHIAGxqIgUQ6QUhByAFIAUoAkQgB0ETdHM2AkQgBUHIAGoiBSAHIAUoAgBqNgIAIAQgCkchBSAEQQFqIQQgBQ0ACyAIIAlByABsakHIAGsiDBDpBRogBiADQcgAbGohC0EAIQcDQCALIAdByABsIgFqIgQgASACaiIFKAIANgIAIAQgBSgCBDYCBCAEIAUoAgg2AgggBCAFKAIMNgIMIAQgBSgCEDYCECAEIAUoAhQ2AhQgBCAFKAIYNgIYIAQgBSgCHDYCHCAEIAUoAiA2AiAgBCAFKAIkNgIkIAQgBSgCKDYCKCAEIAUoAiw2AiwgBCAFKAIwNgIwIAQgBSgCNDYCNCAEIAUoAjg2AjggBCAFKAI8NgI8IAQgBSgCQDYCQCAEIAUoAkQ2AkQgASAGakEAQcgA/AsAIAdBAWoiByADRw0ACwNAIAkhBAJAA0AgBEEATA0BIAggBEEBayIEQcgAbCIFaiAFIAZqEOoIIgVFDQALIAVBAE4NACAGQcwAayELIANBCXQhBANAIAQhDSAJIQQDQCAEQcgAbCIFIAZqQcgAaxDqBSEHIAUgC2oiBSAFKAIAIAdBE3RyNgIAIARBAkshBSAEQQFrIQQgBQ0ACyAGIAYoAgQiBEEcdEGAgICAAXEgBigCAEEBdXI2AgAgBiAGKAIMIgVBHHRBgICAgAFxIAYoAggiB0EBdXI2AgggBiAHQRx0QYCAgIABcSAEQQF1cjYCBCAGIAYoAhAiBEEcdEGAgICAAXEgBUEBdXI2AgwgBiAGKAIUIgVBHHRBgICAgAFxIARBAXVyNgIQIAYgBigCGCIEQRx0QYCAgIABcSAFQQF1cjYCFCAGIAYoAhwiBUEcdEGAgICAAXEgBEEBdXI2AhggBiAGKAIgIgRBHHRBgICAgAFxIAVBAXVyNgIcIAYgBigCJCIFQRx0QYCAgIABcSAEQQF1cjYCICAGIAYoAigiBEEcdEGAgICAAXEgBUEBdXI2AiQgBiAGKAIsIgVBHHRBgICAgAFxIARBAXVyNgIoIAYgBigCMCIEQRx0QYCAgIABcSAFQQF1cjYCLCAGIAYoAjQiBUEcdEGAgICAAXEgBEEBdXI2AjAgBiAGKAI4IgRBHHRBgICAgAFxIAVBAXVyNgI0IAYgBigCPCIFQRx0QYCAgIABcSAEQQF1cjYCOCAGIAYoAkAiBEEcdEGAgICAAXEgBUEBdXI2AjwgBiAGKAJEIgVBAXU2AkQgBiAFQRx0QYCAgIABcSAEQQF1cjYCQCAJIQQCQAJAA0AgBEEATA0BIAggBEEBayIEQcgAbCIFaiAFIAZqEOoIIgVFDQALIAVBAEgNAQtBACEHQQAhAQNAIAggAUHIAGwiBWoiBCAEKAIAIAUgBmoiBSgCAGs2AgAgBCAEKAIEIAUoAgRrNgIEIAQgBCgCCCAFKAIIazYCCCAEIAQoAgwgBSgCDGs2AgwgBCAEKAIQIAUoAhBrNgIQIAQgBCgCFCAFKAIUazYCFCAEIAQoAhggBSgCGGs2AhggBCAEKAIcIAUoAhxrNgIcIAQgBCgCICAFKAIgazYCICAEIAQoAiQgBSgCJGs2AiQgBCAEKAIoIAUoAihrNgIoIAQgBCgCLCAFKAIsazYCLCAEIAQoAjAgBSgCMGs2AjAgBCAEKAI0IAUoAjRrNgI0IAQgBCgCOCAFKAI4azYCOCAEIAQoAjwgBSgCPGs2AjwgBCAEKAJAIAUoAkBrNgJAIAQgBCgCRCAFKAJEazYCRCABQQFqIgEgCUcNAAsDQCAIIAdByABsaiIEEOkFIQUgBCAEKAJEIAVBE3RzNgJEIARByABqIgQgBSAEKAIAajYCACAHIApHIQQgB0EBaiEHIAQNAAsgDBDpBRoLIA1BAWshBCANQQFKDQALQQAhBwNAIAAgB0HIAGwiBWoiBCAFIAhqIgUoAgA2AgAgBCAFKAIENgIEIAQgBSgCCDYCCCAEIAUoAgw2AgwgBCAFKAIQNgIQIAQgBSgCFDYCFCAEIAUoAhg2AhggBCAFKAIcNgIcIAQgBSgCIDYCICAEIAUoAiQ2AiQgBCAFKAIoNgIoIAQgBSgCLDYCLCAEIAUoAjA2AjAgBCAFKAI0NgI0IAQgBSgCODYCOCAEIAUoAjw2AjwgBCAFKAJANgJAIAQgBSgCRDYCRCAHQQFqIgcgA0cNAAsgACACIAMQ6QggDiQADwtBACEHQQAhAQNAIAggAUHIAGwiBWoiBCAEKAIAIAUgBmoiBSgCAGs2AgAgBCAEKAIEIAUoAgRrNgIEIAQgBCgCCCAFKAIIazYCCCAEIAQoAgwgBSgCDGs2AgwgBCAEKAIQIAUoAhBrNgIQIAQgBCgCFCAFKAIUazYCFCAEIAQoAhggBSgCGGs2AhggBCAEKAIcIAUoAhxrNgIcIAQgBCgCICAFKAIgazYCICAEIAQoAiQgBSgCJGs2AiQgBCAEKAIoIAUoAihrNgIoIAQgBCgCLCAFKAIsazYCLCAEIAQoAjAgBSgCMGs2AjAgBCAEKAI0IAUoAjRrNgI0IAQgBCgCOCAFKAI4azYCOCAEIAQoAjwgBSgCPGs2AjwgBCAEKAJAIAUoAkBrNgJAIAQgBCgCRCAFKAJEazYCRCABQQFqIgEgCUcNAAsDQCAIIAdByABsaiIEEOkFIQUgBCAEKAJEIAVBE3RzNgJEIARByABqIgQgBSAEKAIAajYCACAHIApHIQQgB0EBaiEHIAQNAAsgDBDpBRoMAAsAC8RUAkx/AX4jAEHAAmsiAyEEIAMkACADIAJBkAFsayINIgMkACADIAJByABsQQ9qQXBxIgVrIgoiAyQAIAMgBWsiGyQAQQAhAyAAQQBByAD8CwAgA0UEQCAAQcgAakEAQcgA/AsACyADRQRAIABBkAFqQQBByAD8CwALIANFBEAgAEHYAWpBAEHIAPwLAAsCQCACQQRGDQAgAEGgAmpBAEHIAPwLACACQQVGDQAgAEHoAmpBAEHIAPwLACACQQZGDQAgAEGwA2pBAEHIAPwLACACQQdGDQAgAEH4A2pBAEHIAPwLAAsgCkEAQcgA/AsAIANFBEAgCkHIAGpBAEHIAPwLAAsgA0UEQCAKQZABakEAQcgA/AsACyADRQRAIApB2AFqQQBByAD8CwALAkAgAkEERg0AIApBoAJqQQBByAD8CwAgAkEFRg0AIApB6AJqQQBByAD8CwAgAkEGRg0AIApBsANqQQBByAD8CwAgAkEHRg0AIApB+ANqQQBByAD8CwALIBtBAEHIAPwLACADRQRAIBtByABqQQBByAD8CwALIANFBEAgG0GQAWpBAEHIAPwLAAsgA0UEQCAbQdgBakEAQcgA/AsACyACQQF0IQMCQCACQQRGDQAgG0GgAmpBAEHIAPwLACACQQVGDQAgG0HoAmpBAEHIAPwLACACQQZGDQAgG0GwA2pBAEHIAPwLACACQQdGDQAgG0H4A2pBAEHIAPwLAAsgDUH4A2ohCyANQbADaiEMIA1B6AJqIRkgDUGgAmohDiANQdgBaiERIA1BkAFqIRAgDUHIAGohHyADQRhxIQggA0EGcSEJA0AgB0HIAGwhBUEAIQMgBSANakEAQcgA/AsAIANFBEAgBSAfakEAQcgA/AsACyADRQRAIAUgEGpBAEHIAPwLAAsgA0UEQCAFIBFqQQBByAD8CwALIANFBEAgBSAOakEAQcgA/AsACyADRQRAIAUgGWpBAEHIAPwLAAsgA0UEQCAFIAxqQQBByAD8CwALIANFBEAgBSALakEAQcgA/AsACyAHQQhqIQcgBkEIaiIGIAhHDQALIAkEQANAIA0gB0HIAGxqQQBByAD8CwAgB0EBaiEHIANBAWoiAyAJRw0ACwsgACABKAIANgIAIAAgASgCBDYCBCAAIAEoAgg2AgggACABKAIMNgIMIAAgASgCEDYCECAAIAEoAhQ2AhQgACABKAIYNgIYIAAgASgCHDYCHCAAIAEoAiA2AiAgACABKAIkNgIkIAAgASgCKDYCKCAAIAEoAiw2AiwgACABKAIwNgIwIAAgASgCNDYCNCAAIAEoAjg2AjggACABKAI8NgI8IAAgASgCQDYCQCAAIAEoAkQ2AkQgABDpBRogACgCACIDQR50QR51QX5xIgUgBUEFaiIFIAUgA0ECdmwgBSADQQNxbEECdmpsQQJ0QQxxayIFIAVBFWoiBSAFIANBBHZsIAUgA0EPcWxBBHZqbEEEdEHwAXFrQZUCaiEDIARBoAFqQQRyITcgBEEEciE4IARB0ABqQQRyITZBCCEfQQAhBUEAIQdBACEGQQAhCEEAIQlBACELQQAhDEEAIRlBACEOQQAhEUEAIRADQCAEIANB/////wFxIjk2AvABIAQgEiADQR11aiIDQf////8BcSI6NgL0ASAEIA8gA0EddWoiA0H/////AXEiOzYC+AEgBCAdIANBHXVqIgNB/////wFxIjw2AvwBIAQgHiADQR11aiIDQf////8BcSI9NgKAAiAEIBQgA0EddWoiA0H/////AXEiPjYChAIgBCAcIANBHXVqIgNB/////wFxIj82AogCIAQgECADQR11aiIDQf////8BcSJANgKMAiAEIBEgA0EddWoiA0H/////AXEiQTYCkAIgBCAOIANBHXVqIgNB/////wFxIkI2ApQCIAQgGSADQR11aiIDQf////8BcSJDNgKYAiAEIAwgA0EddWoiA0H/////AXEiRDYCnAIgBCALIANBHXVqIgNB/////wFxIkU2AqACIAQgCSADQR11aiIDQf////8BcSJGNgKkAiAEIAggA0EddWoiA0H/////AXEiRzYCqAIgBCAGIANBHXVqIgNB/////wFxIkg2AqwCIAQgByADQR11aiIDQf////8BcSJJNgKwAiAEIAUgA0EddWoiSjYCtAIgACgCRCERIAAoAkAhDyAAKAI8IRIgACgCOCETIAAoAjQhGiAAKAIwIRUgACgCLCEgIAAoAighFiAAKAIkISEgACgCICEXIAAoAhwhIiAAKAIYIRggACgCFCEjIAAoAhAhAyAAKAIMIQUgACgCCCEHIAAoAgQhBiAEIAAoAgAiCEH/////AXE2AlAgBCAGIAhBHXVqIgZB/////wFxNgJUIAQgByAGQR11aiIHQf////8BcTYCWCAEIAUgB0EddWoiBUH/////AXE2AlwgBCADIAVBHXVqIgNB/////wFxNgJgIAQgIyADQR11aiIDQf////8BcTYCZCAEIBggA0EddWoiA0H/////AXE2AmggBCAiIANBHXVqIgNB/////wFxNgJsIAQgFyADQR11aiIDQf////8BcTYCcCAEICEgA0EddWoiA0H/////AXE2AnQgBCAWIANBHXVqIgNB/////wFxNgJ4IAQgICADQR11aiIDQf////8BcTYCfCAEIBUgA0EddWoiA0H/////AXE2AoABIAQgGiADQR11aiIDQf////8BcTYChAEgBCATIANBHXVqIgNB/////wFxNgKIASAEIBIgA0EddWoiA0H/////AXE2AowBIAQgDyADQR11aiIDQf////8BcTYCkAEgBCARIANBHXVqNgKUASAfQR1uIgxBAnQiECAEQdAAamoiHEF/IAxBY2wgH2oiCXRBf3MiHiAcKAIAcTYCACAQIDZqISxBECAMayIUQQAgFEEQTRtBAnRBBGoiAwRAICxBACAD/AsAC0EAISQgBEGgAWpBAEHIAPwLAEEAIQcDQCAEQfABaiAHQQJ0aiEIQQAhBkEAIQMDQCADIAdqIgVBEU0EQCAEQaABaiAFQQJ0aiIFIAU0AgAgBqwgBEHQAGogA0ECdGo0AgAgCDQCAH58fCJPp0H/////AXE2AgAgT0IdiKchBgsgA0EBaiIDQRJHDQALIAdBAWoiB0ESRw0AC0EdIAlrIQtBESAMayIdQX5xIQcgHUEBcSElIARBoAFqIBBqIhlBBGohDkEAIQMDQCADQQJ0IgUgBEGgAWpqIAUgGWoiBigCBCIIIAt0Qf////8BcSAGKAIAIAl1cjYCACAFQQRyIgUgBEGgAWpqIAUgDmooAgAgC3RB/////wFxIAggCXVyNgIAIANBAmoiAyAHRw0ACyAlBEAgA0ECdCIDIARBoAFqaiADIBlqIgMoAgQgC3RB/////wFxIAMoAgAgCXVyNgIACyAdQQJ0Ii0gBEGgAWpqIksgBCgC5AEgCXU2AgACQCAfQR1JIh0NAEERQRIgDGsiAyADQRFMGyAMakECdEHEAGsiA0UNACAEIBBrQegBakEAIAP8CwALIAQgACgCADYCACAEIAAoAgQ2AgQgBCAAKAIINgIIIAQgACgCDDYCDCAAKAIQIQMgBCARNgJEIAQgDzYCQCAEIBI2AjwgBCATNgI4IAQgGjYCNCAEIBU2AjAgBCAgNgIsIAQgFjYCKCAEICE2AiQgBCAXNgIgIAQgIjYCHCAEIBg2AhggBCAjNgIUIAQgAzYCECAEIBBqIg5BBGohEUEAIQMDQCAEIANBAnQiBWogBSAOaiIGKAIEIgggC3RB/////wFxIAYoAgAgCXVyNgIAIAQgBUEEciIFaiAFIBFqKAIAIAt0Qf////8BcSAIIAl1cjYCACADQQJqIgMgB0cNAAsgJQRAIAQgA0ECdCIDaiADIA5qIgMoAgQgC3RB/////wFxIAMoAgAgCXVyNgIACyAEIC1qIAQoAkQgCXU2AgACQCAdDQBBEUESIAxrIgMgA0ERTBsgDGpBAnRBxABrIgNFDQAgBCAQa0HIAGpBACAD/AsACyAEIAQoAgAiA0H/////AXE2AgAgBCAEKAIEIANBHXVqIgNB/////wFxNgIEIAQgBCgCCCADQR11aiIDQf////8BcTYCCCAEIAQoAgwgA0EddWoiA0H/////AXE2AgwgBCAEKAIQIANBHXVqIgNB/////wFxNgIQIAQgBCgCFCADQR11aiIDQf////8BcTYCFCAEIAQoAhggA0EddWoiA0H/////AXE2AhggBCAEKAIcIANBHXVqIgNB/////wFxNgIcIAQgBCgCICADQR11aiIDQf////8BcTYCICAEIAQoAiQgA0EddWoiA0H/////AXE2AiQgBCAEKAIoIANBHXVqIgNB/////wFxNgIoIAQgBCgCLCADQR11aiIDQf////8BcTYCLCAEIAQoAjAgA0EddWoiA0H/////AXE2AjAgBCAEKAI0IANBHXVqIgNB/////wFxNgI0IAQgBCgCOCADQR11aiIDQf////8BcTYCOCAEIAQoAjwgA0EddWoiA0H/////AXE2AjwgBCAEKAJAIANBHXVqIgNB/////wFxNgJAIAQgBCgCRCADQR11ajYCRCAOIA4oAgAgHnE2AgBBACEHQRAgDCAMQRBMGyAMa0ECdEEEaiIRRSIORQRAIBAgOGpBACAR/AsACyAkRQRAIARB0ABqQQBByAD8CwALA0AgBEHwAWogB0ECdGohCEEAIQZBACEDA0AgAyAHaiIFQRFNBEAgBEHQAGogBUECdGoiBSAFNAIAIAasIAQgA0ECdGo0AgAgCDQCAH58fCJPp0H/////AXE2AgAgT0IdiKchBgsgA0EBaiIDQRJHDQALIAdBAWoiB0ESRw0ACyAEIAQoAlAiA0H/////AXE2AlAgBCAEKAJUIANBHXVqIgNB/////wFxNgJUIAQgBCgCWCADQR11aiIDQf////8BcTYCWCAEIAQoAlwgA0EddWoiA0H/////AXE2AlwgBCAEKAJgIANBHXVqIgNB/////wFxNgJgIAQgBCgCZCADQR11aiIDQf////8BcTYCZCAEIAQoAmggA0EddWoiA0H/////AXE2AmggBCAEKAJsIANBHXVqIgNB/////wFxNgJsIAQgBCgCcCADQR11aiIDQf////8BcTYCcCAEIAQoAnQgA0EddWoiA0H/////AXE2AnQgBCAEKAJ4IANBHXVqIgNB/////wFxNgJ4IAQgBCgCfCADQR11aiIDQf////8BcTYCfCAEIAQoAoABIANBHXVqIgNB/////wFxNgKAASAEIAQoAoQBIANBHXVqIgNB/////wFxNgKEASAEIAQoAogBIANBHXVqIgNB/////wFxNgKIASAEIAQoAowBIANBHXVqIgNB/////wFxNgKMASAEIAQoApABIANBHXVqIgNB/////wFxNgKQASAEIAQoApQBIANBHXVqNgKUASAcIBwoAgAgHnE2AgBBACEHIA5FBEAgLEEAIBH8CwALIAQoApQBIQMgBCgC5AEhBSAEKAKQASEGIAQoAuABIQggBCgCjAEhDyAEKALcASESIAQoAogBIRMgBCgC2AEhGiAEKAKEASEVIAQoAtQBISAgBCgCgAEhFiAEKALQASEhIAQoAnwhFyAEKALMASEiIAQoAnghGCAEKALIASEjIAQoAnQhJSAEKALEASEsIAQoAnAhJiAEKALAASEuIAQoAmwhJyAEKAK8ASEvIAQoAmghKCAEKAK4ASEwIAQoAmQhKSAEKAK0ASExIAQoAmAhKiAEKAKwASEyIAQoAlwhKyAEKAKsASEzIAQoAlghNCAEKAKoASFMIAQoAlQhNSAEKAKkASFNIAQgBCgCUCAEKAKgAWoiTkH/////AXE2AqABIAQgNSBNaiBOQR11aiI1Qf////8BcTYCpAEgBCA0IExqIDVBHXVqIjRB/////wFxNgKoASAEICsgM2ogNEEddWoiK0H/////AXE2AqwBIAQgKiAyaiArQR11aiIqQf////8BcTYCsAEgBCApIDFqICpBHXVqIilB/////wFxNgK0ASAEICggMGogKUEddWoiKEH/////AXE2ArgBIAQgJyAvaiAoQR11aiInQf////8BcTYCvAEgBCAmIC5qICdBHXVqIiZB/////wFxNgLAASAEICUgLGogJkEddWoiJUH/////AXE2AsQBIAQgGCAjaiAlQR11aiIYQf////8BcTYCyAEgBCAXICJqIBhBHXVqIhdB/////wFxNgLMASAEIBYgIWogF0EddWoiFkH/////AXE2AtABIAQgFSAgaiAWQR11aiIVQf////8BcTYC1AEgBCATIBpqIBVBHXVqIhNB/////wFxNgLYASAEIA8gEmogE0EddWoiD0H/////AXE2AtwBIAQgBiAIaiAPQR11aiIGQf////8BcTYC4AEgBCADIAVqIAZBHXVqNgLkASAkRQRAIARB0ABqQQBByAD8CwALA0AgBEGgAWogB0ECdGohCEEAIQZBACEDA0AgAyAHaiIFQRFNBEAgBEHQAGogBUECdGoiBSAFNAIAIAasIARB8AFqIANBAnRqNAIAIAg0AgB+fHwiT6dB/////wFxNgIAIE9CHYinIQYLIANBAWoiA0ESRw0ACyAHQQFqIgdBEkcNAAsgBCgClAEhAyAEKAKQASEFIAQoAowBIQcgBCgCiAEhBiAEKAKEASEIIAQoAoABIQ8gBCgCfCESIAQoAnghEyAEKAJ0IRogBCgCcCEVIAQoAmwhICAEKAJoIRYgBCgCZCEhIAQoAmAhFyAEKAJcISIgBCgCWCEYIAQoAlQhIyAEIAQoAlAiJEH/////AXE2AqABIAQgIyAkQR11aiIjQf////8BcTYCpAEgBCAYICNBHXVqIhhB/////wFxNgKoASAEICIgGEEddWoiIkH/////AXE2AqwBIAQgFyAiQR11aiIXQf////8BcTYCsAEgBCAhIBdBHXVqIiFB/////wFxNgK0ASAEIBYgIUEddWoiFkH/////AXE2ArgBIAQgICAWQR11aiIgQf////8BcTYCvAEgBCAVICBBHXVqIhVB/////wFxNgLAASAEIBogFUEddWoiGkH/////AXE2AsQBIAQgEyAaQR11aiITQf////8BcTYCyAEgBCASIBNBHXVqIhJB/////wFxNgLMASAEIA8gEkEddWoiD0H/////AXE2AtABIAQgCCAPQR11aiIIQf////8BcTYC1AEgBCAGIAhBHXVqIgZB/////wFxNgLYASAEIAcgBkEddWoiB0H/////AXE2AtwBIAQgBSAHQR11aiIFQf////8BcTYC4AEgBCADIAVBHXVqNgLkASAZIBkoAgAgHnE2AgBBACEFIA5FBEAgECA3akEAIBH8CwALIARBATYCUCA2QQBBxAD8CwAgBCAEQdAAaiAtaigCACAJdCIDNgKUASAEIBRBAnQiESAEQdAAamooAgAgC3UgA3I2ApQBIBRBfnEhByAUQQFxIQhBECEDA0AgBEHQAGogA0ECdGogBEHQAGogAyAMa0ECdGoiBigCACAJdEH/////AXEgBkEEaygCACALdXI2AgAgBEHQAGogA0EBayIGQQJ0aiAEQdAAaiAGIAxrQQJ0aiIGKAIAIAl0Qf////8BcSAGQQRrKAIAIAt1cjYCACADQQJrIQMgBUECaiIFIAdHDQALIAgEQCAEQdAAaiADQQJ0aiAEQdAAaiADIAxrQQJ0aiIDKAIAIAl0Qf////8BcSADQQRrKAIAIAt1cjYCAAsgHEEBIAl0NgIAAkAgHQ0AIBBFDQAgBEHQAGpBACAQ/AsACyAEKALkASEDIAQoApQBIQUgBCgC4AEhBiAEKAKQASEcIAQoAtwBIRQgBCgCjAEhHiAEKALYASEPIAQoAogBIRIgBCgC1AEhEyAEKAKEASEaIAQoAtABIRUgBCgCgAEhICAEKALMASEWIAQoAnwhISAEKALIASEXIAQoAnghIiAEKALEASEYIAQoAnQhIyAEKALAASEkIAQoAnAhJSAEKAK8ASEtIAQoAmwhLCAEKAK4ASEmIAQoAmghLiAEKAK0ASEnIAQoAmQhLyAEKAKwASEoIAQoAmAhMCAEKAKsASEpIAQoAlwhMSAEKAKoASEqIAQoAlghMiAEKAKkASErIAQoAlQhMyAEIAQoAlAgBCgCoAFrIg5B/////wFxNgKgASAEIDMgK2sgDkEddWoiK0H/////AXE2AqQBIAQgMiAqayArQR11aiIqQf////8BcTYCqAEgBCAxIClrICpBHXVqIilB/////wFxNgKsASAEIDAgKGsgKUEddWoiKEH/////AXE2ArABIAQgLyAnayAoQR11aiInQf////8BcTYCtAEgBCAuICZrICdBHXVqIiZB/////wFxNgK4ASAEICwgLWsgJkEddWoiLUH/////AXE2ArwBIAQgJSAkayAtQR11aiIkQf////8BcTYCwAEgBCAjIBhrICRBHXVqIhhB/////wFxNgLEASAEICIgF2sgGEEddWoiF0H/////AXE2AsgBIAQgISAWayAXQR11aiIWQf////8BcTYCzAEgBCAgIBVrIBZBHXVqIhVB/////wFxNgLQASAEIBogE2sgFUEddWoiE0H/////AXE2AtQBIAQgEiAPayATQR11aiIPQf////8BcTYC2AEgBCAeIBRrIA9BHXVqIhRB/////wFxNgLcASAEIBwgBmsgFEEddWoiBkH/////AXE2AuABIAQgBSADayAGQR11ajYC5AEgBCBLKAIAIAl0IgM2AuQBIAQgBEGgAWogEWooAgAgC3UgA3I2AuQBQQAhBUEQIQMDQCAEQaABaiADQQJ0aiAEQaABaiADIAxrQQJ0aiIGKAIAIAl0Qf////8BcSAGQQRrKAIAIAt1cjYCACAEQaABaiADQQFrIgZBAnRqIARBoAFqIAYgDGtBAnRqIgYoAgAgCXRB/////wFxIAZBBGsoAgAgC3VyNgIAIANBAmshAyAFQQJqIgUgB0cNAAsgCARAIARBoAFqIANBAnRqIARBoAFqIAMgDGtBAnRqIgMoAgAgCXRB/////wFxIANBBGsoAgAgC3VyNgIACyAZIA4gCXRB/////wFxNgIAAkAgHQ0AIBBFDQAgBEGgAWpBACAQ/AsACyAEIAQoAqABIDlqIgM2AvABIAQgBCgCpAEgOmoiEjYC9AEgBCAEKAKoASA7aiIPNgL4ASAEIAQoAqwBIDxqIh02AvwBIAQgBCgCsAEgPWoiHjYCgAIgBCAEKAK0ASA+aiIUNgKEAiAEIAQoArgBID9qIhw2AogCIAQgBCgCvAEgQGoiEDYCjAIgBCAEKALAASBBaiIRNgKQAiAEIAQoAsQBIEJqIg42ApQCIAQgBCgCyAEgQ2oiGTYCmAIgBCAEKALMASBEaiIMNgKcAiAEIAQoAtABIEVqIgs2AqACIAQgBCgC1AEgRmoiCTYCpAIgBCAEKALYASBHaiIINgKoAiAEIAQoAtwBIEhqIgY2AqwCIAQgBCgC4AEgSWoiBzYCsAIgBCAEKALkASBKaiIFNgK0AiAfQQF0Ih9BgARIDQALIAAgBTYCRCAAIAc2AkAgACAGNgI8IAAgCDYCOCAAIAk2AjQgACALNgIwIAAgDDYCLCAAIBk2AiggACAONgIkIAAgETYCICAAIBA2AhwgACAcNgIYIAAgFDYCFCAAIB42AhAgACAdNgIMIAAgDzYCCCAAIBI2AgQgACADNgIAIAAQ6QUaIAAQ6QUaIAAgACgCREH//x9xNgJEIApB+ANqIRwgCkGwA2ohFCAKQegCaiEeIApBoAJqIR0gCkHYAWohDyAKQZABaiESIApByABqIRMgCkEEaiEaQQEhCQNAQQAhBgJAIAkiB0EATCIORQRAA0AgCiAGQcgAbCIFaiIDIAEgBWoiBSgCADYCACADIAUoAgQ2AgQgAyAFKAIINgIIIAMgBSgCDDYCDCADIAUoAhA2AhAgAyAFKAIUNgIUIAMgBSgCGDYCGCADIAUoAhw2AhwgAyAFKAIgNgIgIAMgBSgCJDYCJCADIAUoAig2AiggAyAFKAIsNgIsIAMgBSgCMDYCMCADIAUoAjQ2AjQgAyAFKAI4NgI4IAMgBSgCPDYCPCADIAUoAkA2AkAgAyAFKAJENgJEIAZBAWoiBiAHRw0ACyANIAAgCiAHEOcIQQAhBgNAIA0gBkHIAGxqIgMgAyAHQcgAbCILaiIFKAIANgIAIAMgBSgCBDYCBCADIAUoAgg2AgggAyAFKAIMNgIMIAMgBSgCEDYCECADIAUoAhQ2AhQgAyAFKAIYNgIYIAMgBSgCHDYCHCADIAUoAiA2AiAgAyAFKAIkNgIkIAMgBSgCKDYCKCADIAUoAiw2AiwgAyAFKAIwNgIwIAMgBSgCNDYCNCADIAUoAjg2AjggAyAFKAI8NgI8IAMgBSgCQDYCQCADIAUoAkQ2AkRBACEMIAVBAEHIAPwLACAGQQFqIgYgB0cNAAsgB0EBdCEJQQAhBkEAIQgDQCAbIAhByABsIgVqIgMgASAFaiIFKAIANgIAIAMgBSgCBDYCBCADIAUoAgg2AgggAyAFKAIMNgIMIAMgBSgCEDYCECADIAUoAhQ2AhQgAyAFKAIYNgIYIAMgBSgCHDYCHCADIAUoAiA2AiAgAyAFKAIkNgIkIAMgBSgCKDYCKCADIAUoAiw2AiwgAyAFKAIwNgIwIAMgBSgCNDYCNCADIAUoAjg2AjggAyAFKAI8NgI8IAMgBSgCQDYCQCADIAUoAkQ2AkQgCEEBaiIIIAlHDQALA0AgGyAGQcgAbGoiAyADIAtqIgUoAgA2AgAgAyAFKAIENgIEIAMgBSgCCDYCCCADIAUoAgw2AgwgAyAFKAIQNgIQIAMgBSgCFDYCFCADIAUoAhg2AhggAyAFKAIcNgIcIAMgBSgCIDYCICADIAUoAiQ2AiQgAyAFKAIoNgIoIAMgBSgCLDYCLCADIAUoAjA2AjAgAyAFKAI0NgI0IAMgBSgCODYCOCADIAUoAjw2AjwgAyAFKAJANgJAIAMgBSgCRDYCRCAMRQRAIAVBAEHIAPwLAAsgBkEBaiIGIAdHDQALIAogACAbIAcQ7ghBACEGA0AgDSAGQcgAbCIFaiIDIAUgCmoiBSgCACADKAIAajYCACADIAUoAgQgAygCBGo2AgQgAyAFKAIIIAMoAghqNgIIIAMgBSgCDCADKAIMajYCDCADIAUoAhAgAygCEGo2AhAgAyAFKAIUIAMoAhRqNgIUIAMgBSgCGCADKAIYajYCGCADIAUoAhwgAygCHGo2AhwgAyAFKAIgIAMoAiBqNgIgIAMgBSgCJCADKAIkajYCJCADIAUoAiggAygCKGo2AiggAyAFKAIsIAMoAixqNgIsIAMgBSgCMCADKAIwajYCMCADIAUoAjQgAygCNGo2AjQgAyAFKAI4IAMoAjhqNgI4IAMgBSgCPCADKAI8ajYCPCADIAUoAkAgAygCQGo2AkAgAyAFKAJEIAMoAkRqNgJEIAZBAWoiBiAHRw0ACwwBCyANIAAgCiAHEOcIIAogACAbIAcQ7gggB0EBdCEJCyAJIAlBH3UiA3MgA2siC0ECayEIQQAhAwNAIA0gA0HIAGxqIgUQ6QUhBiAFIAUoAkQgBkETdHM2AkQgBUHIAGoiBSAGIAUoAgBqNgIAIAMgCEchBSADQQFqIQMgBQ0ACyANIAtByABsaiIfQcgAayIREOkFIQMCQAJAIAdBAE4iEEUEQCAfQQRrIgUgBSgCACADQRN0czYCACAKIA0gACAHEO4IDAELIAogDSAAIAcQ7ghBACEGIA4NAANAIA0gBkHIAGwiBWoiAyAFIApqIgUoAgA2AgAgAyAFKAIENgIEIAMgBSgCCDYCCCADIAUoAgw2AgwgAyAFKAIQNgIQIAMgBSgCFDYCFCADIAUoAhg2AhggAyAFKAIcNgIcIAMgBSgCIDYCICADIAUoAiQ2AiQgAyAFKAIoNgIoIAMgBSgCLDYCLCADIAUoAjA2AjAgAyAFKAI0NgI0IAMgBSgCODYCOCADIAUoAjw2AjwgAyAFKAJANgJAIAMgBSgCRDYCRCAGQQFqIgYgB0cNAAsgCkEBNgIAIBpBAEHEAPwLAAJAIAdBAUYNACAHQQFrIgNBB3EhDEEBIQUgB0ECa0EHTwRAIANBeHEhGUEAIQsDQCAFQcgAbCEGQQAhAyAGIApqQQBByAD8CwAgA0UEQCAGIBNqQQBByAD8CwALIANFBEAgBiASakEAQcgA/AsACyADRQRAIAYgD2pBAEHIAPwLAAsgA0UEQCAGIB1qQQBByAD8CwALIANFBEAgBiAeakEAQcgA/AsACyADRQRAIAYgFGpBAEHIAPwLAAsgA0UEQCAGIBxqQQBByAD8CwALIAVBCGohBSALQQhqIgsgGUcNAAsLQQAhAyAMRQ0AA0AgCiAFQcgAbGpBAEHIAPwLACAFQQFqIQUgA0EBaiIDIAxHDQALC0EAIQZBACELA0AgCiALQcgAbGoiAyAHQcgAbGoiBSADKAIANgIAIAUgAygCBDYCBCAFIAMoAgg2AgggBSADKAIMNgIMIAUgAygCEDYCECAFIAMoAhQ2AhQgBSADKAIYNgIYIAUgAygCHDYCHCAFIAMoAiA2AiAgBSADKAIkNgIkIAUgAygCKDYCKCAFIAMoAiw2AiwgBSADKAIwNgIwIAUgAygCNDYCNCAFIAMoAjg2AjggBSADKAI8NgI8IAUgAygCQDYCQCAFIAMoAkQ2AkQgA0EAQcgA/AsAIAtBAWoiCyAHRw0ACwNAIA0gBkHIAGwiBWoiAyAFIApqIgUoAgAgAygCAGs2AgAgAyAFKAIEIAMoAgRrNgIEIAMgBSgCCCADKAIIazYCCCADIAUoAgwgAygCDGs2AgwgAyAFKAIQIAMoAhBrNgIQIAMgBSgCFCADKAIUazYCFCADIAUoAhggAygCGGs2AhggAyAFKAIcIAMoAhxrNgIcIAMgBSgCICADKAIgazYCICADIAUoAiQgAygCJGs2AiQgAyAFKAIoIAMoAihrNgIoIAMgBSgCLCADKAIsazYCLCADIAUoAjAgAygCMGs2AjAgAyAFKAI0IAMoAjRrNgI0IAMgBSgCOCADKAI4azYCOCADIAUoAjwgAygCPGs2AjwgAyAFKAJAIAMoAkBrNgJAIAMgBSgCRCADKAJEazYCRCAGQQFqIgYgCUcNAAsMAQsgCkEBNgIAIBpBAEHEAPwLAAtBACEDA0AgDSADQcgAbGoiBRDpBSEGIAUgBSgCRCAGQRN0czYCRCAFQcgAaiIFIAYgBSgCAGo2AgAgAyAIRyEFIANBAWohAyAFDQALIBEQ6QUhAwJAIBBFBEAgH0EEayIFIAUoAgAgA0ETdHM2AgAMAQtBACEGQQAhCCAODQADQCANIAhByABsaiIDIAdByABsaiIFIAMoAgA2AgAgBSADKAIENgIEIAUgAygCCDYCCCAFIAMoAgw2AgwgBSADKAIQNgIQIAUgAygCFDYCFCAFIAMoAhg2AhggBSADKAIcNgIcIAUgAygCIDYCICAFIAMoAiQ2AiQgBSADKAIoNgIoIAUgAygCLDYCLCAFIAMoAjA2AjAgBSADKAI0NgI0IAUgAygCODYCOCAFIAMoAjw2AjwgBSADKAJANgJAIAUgAygCRDYCRCADQQBByAD8CwAgCEEBaiIIIAdHDQALA0AgACAGQcgAbCIFaiIDIAUgDWoiBSgCACADKAIAajYCACADIAUoAgQgAygCBGo2AgQgAyAFKAIIIAMoAghqNgIIIAMgBSgCDCADKAIMajYCDCADIAUoAhAgAygCEGo2AhAgAyAFKAIUIAMoAhRqNgIUIAMgBSgCGCADKAIYajYCGCADIAUoAhwgAygCHGo2AhwgAyAFKAIgIAMoAiBqNgIgIAMgBSgCJCADKAIkajYCJCADIAUoAiggAygCKGo2AiggAyAFKAIsIAMoAixqNgIsIAMgBSgCMCADKAIwajYCMCADIAUoAjQgAygCNGo2AjQgAyAFKAI4IAMoAjhqNgI4IAMgBSgCPCADKAI8ajYCPCADIAUoAkAgAygCQGo2AkAgAyAFKAJEIAMoAkRqNgJEIAZBAWoiBiAJRw0ACwsgAiAJSg0ACyACQQJrIQZBACEDA0AgACADQcgAbGoiBRDpBSEHIAUgBSgCRCAHQRN0czYCRCAFQcgAaiIFIAcgBSgCAGo2AgAgAyAGRyEFIANBAWohAyAFDQALIAAgAkHIAGxqQcgAaxDpBRogBEHAAmokAAssAQJ/IwAiBCADQZABbGsiBSQAIABBACABQQAgAkEAIAVBACADEO8IIAQkAAv4CAIHfwF+AkAgCEEBRgRAIAIgA0HIAGxqIgYQ6QUaIAQgBUHIAGxqIggQ6QUaIAAgAUHIAGxqIgxBAEHIAPwLAANAIAYgC0ECdGohDUEAIQpBACEBA0AgASALaiIJQRFNBEAgDCAJQQJ0aiIJIAk0AgAgCqwgCCABQQJ0ajQCACANNAIAfnx8IhCnQf////8BcTYCACAQQh2IpyEKCyABQQFqIgFBEkcNAAsgC0EBaiILQRJHDQALDAELIAAgASACIAMgBCAFIAYgByAIaiIOIAhBAm0iChDoBSAGIAcgAiADIApqIAQgBSAGIA4gChDvCCABIApqIQ8CQCAIQQJOBEAgBiAHQcgAbGohDSAAIA9ByABsaiEMA0AgDCALQcgAbCIJaiIBIAkgDWoiCSgCACABKAIAajYCACABIAkoAgQgASgCBGo2AgQgASAJKAIIIAEoAghqNgIIIAEgCSgCDCABKAIMajYCDCABIAkoAhAgASgCEGo2AhAgASAJKAIUIAEoAhRqNgIUIAEgCSgCGCABKAIYajYCGCABIAkoAhwgASgCHGo2AhwgASAJKAIgIAEoAiBqNgIgIAEgCSgCJCABKAIkajYCJCABIAkoAiggASgCKGo2AiggASAJKAIsIAEoAixqNgIsIAEgCSgCMCABKAIwajYCMCABIAkoAjQgASgCNGo2AjQgASAJKAI4IAEoAjhqNgI4IAEgCSgCPCABKAI8ajYCPCABIAkoAkAgASgCQGo2AkAgASAJKAJEIAEoAkRqNgJEIAtBAWoiCyAKRw0ACyAGIAcgAiADIAQgBSAKaiAGIA4gChDvCEEAIQsDQCAMIAtByABsIglqIgEgCSANaiIJKAIAIAEoAgBqNgIAIAEgCSgCBCABKAIEajYCBCABIAkoAgggASgCCGo2AgggASAJKAIMIAEoAgxqNgIMIAEgCSgCECABKAIQajYCECABIAkoAhQgASgCFGo2AhQgASAJKAIYIAEoAhhqNgIYIAEgCSgCHCABKAIcajYCHCABIAkoAiAgASgCIGo2AiAgASAJKAIkIAEoAiRqNgIkIAEgCSgCKCABKAIoajYCKCABIAkoAiwgASgCLGo2AiwgASAJKAIwIAEoAjBqNgIwIAEgCSgCNCABKAI0ajYCNCABIAkoAjggASgCOGo2AjggASAJKAI8IAEoAjxqNgI8IAEgCSgCQCABKAJAajYCQCABIAkoAkQgASgCRGo2AkQgC0EBaiILIApHDQALDAELIAYgByACIAMgBCAFIApqIAYgDiAKEO8ICyAKIApBH3UiAXMgAWsiDEECTwRAIAxBAmshCiAAIA9ByABsaiENQQAhAQNAIA0gAUHIAGxqIgkQ6QUhCyAJIAkoAkQgC0ETdHM2AkQgCUHIAGoiCSALIAkoAgBqNgIAIAEgCkchCSABQQFqIQEgCQ0ACwsgACAPQcgAbGogDEHIAGxqIgFByABrEOkFIQkgCEECSA0AIAFBBGsiASABKAIAIAlBE3RzNgIACwvcBQEjfyAAIAEQ8QggAEHIAGogARDxCCAAQZABaiABEPEIIABB2AFqIgUgARDxCCAAQdwBaiEGIABB4AFqIQcgAEHkAWohCCAAQegBaiEJIABB7AFqIQogAEHwAWohCyAAQfQBaiEMIABB+AFqIQ0gAEH8AWohDiAAQYACaiEPIABBhAJqIRAgAEGIAmohESAAQYwCaiESIABBkAJqIRMgAEGUAmohFCAAQZgCaiEVIABBnAJqIRYDQAJAAkACf0HtAyAWKAIAIBUoAgAgFCgCACATKAIAIBIoAgAgESgCACAQKAIAIA8oAgAgDigCACANKAIAIAwoAgAgCygCACAKKAIAIAkoAgAgCCgCACAHKAIAIAYoAgAgBSgCACIXQR11aiIYQR11aiIZQR11aiIaQR11aiIbQR11aiIcQR11aiIdQR11aiIeQR11aiIfQR11aiIgQR11aiIhQR11aiIiQR11aiIjQR11aiIkQR11aiIDQR11aiIEQR11aiICQR11aiIADQAaQdADIAJB/////wFxIgANABpBswMgBEH/////AXEiAA0AGkGWAyADQf////8BcSIADQAaQfkCICRB/////wFxIgANABpB3AIgI0H/////AXEiAA0AGkG/AiAiQf////8BcSIADQAaQaICICFB/////wFxIgANABpBhQIgIEH/////AXEiAA0AGkHoASAfQf////8BcSIADQAaQcsBIB5B/////wFxIgANABpBrgEgHUH/////AXEiAA0AGkGRASAcQf////8BcSIADQAaQfQAIBtB/////wFxIgANABpB1wAgGkH/////AXEiAA0AGkE6IBlB/////wFxIgANABpBHSAYQf////8BcSIADQAaIBdB/////wFxIgBFDQFBAAshAgNAIAIiA0EBaiECIABBAWohBCAAQQJtIQAgBEECSw0ACyADQf4DSw0BCyAFIAEQ8QgMAQsLC9wFASR/IABBAEHIAPwLACAAQQRqIRQgAEEIaiEVIABBDGohFiAAQSxqIRcgAEEwaiEYIABBNGohGSAAQThqIRogAEE8aiEbIABBEGohHCAAQRRqIR0gAEEYaiEeIABBHGohHyAAQSBqISAgAEEkaiEhIABBKGohIgNAIAACfyATRQRAIAEQaSESIBQoAgAhAyAVKAIAIQQgFigCACEFIBcoAgAhBiAYKAIAIQcgGSgCACEIIBooAgAhCSAbKAIAIQogHCgCACELIB0oAgAhDCAeKAIAIQ0gHygCACEOICAoAgAhDyAhKAIAIRAgIigCACERIAAoAgAhAiAAKAJADAELIBJBAXYhEiAjCyIlQQF0Qf7///8BcSAKQRx1ciIjNgJAIAAgACgCREEBdCAlQRx1cjYCRCAbIApBAXRB/v///wFxIAlBHHVyIgo2AgAgGiAJQQF0Qf7///8BcSAIQRx1ciIJNgIAIBkgCEEBdEH+////AXEgB0EcdXIiCDYCACAYIAdBAXRB/v///wFxIAZBHHVyIgc2AgAgFyAGQQF0Qf7///8BcSARQRx1ciIGNgIAICIgEUEBdEH+////AXEgEEEcdXIiETYCACAhIBBBAXRB/v///wFxIA9BHHVyIhA2AgAgICAPQQF0Qf7///8BcSAOQRx1ciIPNgIAIB8gDkEBdEH+////AXEgDUEcdXIiDjYCACAeIA1BAXRB/v///wFxIAxBHHVyIg02AgAgHSAMQQF0Qf7///8BcSALQRx1ciIMNgIAIBwgC0EBdEH+////AXEgBUEcdXIiCzYCACAWIAVBAXRB/v///wFxIARBHHVyIgU2AgAgFSAEQQF0Qf7///8BcSADQRx1ciIENgIAIBQgA0EBdEH+////AXEgAkEcdXIiAzYCACAAIAJBAXRB/v///wFxIBJBAXFyIgI2AgAgE0EBakEHcSETICRBAWoiJEGABEcNAAsL2hcCCn8BfiMAQeAPayIEJAAgBCADQQQQ7QggBEEBNgLABCAEQcAEakEEckEAQcQA/AsAIARBiAVqIQcgB0EAQcgA/AsAIARB0AVqIQggBUUEQCAIQQBByAD8CwALIARBmAZqIQkgBUUEQCAJQQBByAD8CwALIAQgASgCADYCoAIgBCABKAIENgKkAiAEIAEoAgg2AqgCIAQgASgCDDYCrAIgBCABKAIQNgKwAiAEIAEoAhQ2ArQCIAQgASgCGDYCuAIgBCABKAIcNgK8AiAEIAEoAiA2AsACIAQgASgCJDYCxAIgBCABKAIoNgLIAiAEIAEoAiw2AswCIAQgASgCMDYC0AIgBCABKAI0NgLUAiAEIAEoAjg2AtgCIAQgASgCPDYC3AIgBCABKAJANgLgAiAEIAEoAkQ2AuQCIAQgASgCSDYC6AIgBCABKAJMNgLsAiAEIAEoAlA2AvACIAQgASgCVDYC9AIgBCABKAJYNgL4AiAEIAEoAlw2AvwCIAQgASgCYDYCgAMgBCABKAJkNgKEAyAEIAEoAmg2AogDIAQgASgCbDYCjAMgBCABKAJwNgKQAyAEIAEoAnQ2ApQDIAQgASgCeDYCmAMgBCABKAJ8NgKcAyAEIAEoAoABNgKgAyAEIAEoAoQBNgKkAyAEIAEoAogBNgKoAyAEIAEoAowBNgKsAyAEIAEoApABNgKwAyAEIAEoApQBNgK0AyAEIAEoApgBNgK4AyAEIAEoApwBNgK8AyAEIAEoAqABNgLAAyAEIAEoAqQBNgLEAyAEIAEoAqgBNgLIAyAEIAEoAqwBNgLMAyAEIAEoArABNgLQAyAEIAEoArQBNgLUAyAEIAEoArgBNgLYAyAEIAEoArwBNgLcAyAEIAEoAsABNgLgAyAEIAEoAsQBNgLkAyAEIAEoAsgBNgLoAyAEIAEoAswBNgLsAyAEIAEoAtABNgLwAyAEIAEoAtQBNgL0AyAEIAEoAtgBNgL4AyAEIAEoAtwBNgL8AyAEIAEoAuABNgKABCAEIAEoAuQBNgKEBCAEIAEoAugBNgKIBCAEIAEoAuwBNgKMBCAEIAEoAvABNgKQBCAEIAEoAvQBNgKUBCAEIAEoAvgBNgKYBCAEIAEoAvwBNgKcBCAEIAEoAoACNgKgBCAEIAEoAoQCNgKkBCAEIAEoAogCNgKoBCAEIAEoAowCNgKsBCAEIAEoApACNgKwBCAEIAEoApQCNgK0BCAEIAEoApgCNgK4BCAEIAEoApwCNgK8BCAEQcAEaiADQQQQ8wggBEGgAmogA0EEEPMIIARB+ANqIQogBEGwA2ohCyAEQegCaiEMQYAQIQUDQCACIAVBAWsiDUEJdkHIAGxqIA1B/wNxIgFBHW4iBkECdGooAgAgBkFjbCABanZBAXEhASAEIQYgBCgCvARBE3VBAmogBCgC3AZBE3VBAmpsQYEETgRAIARBwARqIANBBBDpCAsgBEHgBmpBACAEQcAEakEAIARBoAJqQQAgBEGgC2pBAEEEEOgFIAAgBEHgBmogAyAEQQQQ9AggBkHABGogBEGgAmogARD1CCAHIAwgARD1CCAIIAsgARD1CCAJIAogARD1CCAEKALcBkETdUECaqwiDiAOfkKBBFoEQCAEQcAEaiADQQQQ6QgLIARB4AZqQQAgBEHABGpBACAEQaALakEAQQQQ6wggBEHABGogBEHgBmogAyAEQQQQ9AggBiAAKAIANgKgAiAEIAAoAgQ2AqQCIAQgACgCCDYCqAIgBCAAKAIMNgKsAiAEIAAoAhA2ArACIAQgACgCFDYCtAIgBCAAKAIYNgK4AiAEIAAoAhw2ArwCIAQgACgCIDYCwAIgBCAAKAIkNgLEAiAEIAAoAig2AsgCIAQgACgCLDYCzAIgBCAAKAIwNgLQAiAEIAAoAjQ2AtQCIAQgACgCODYC2AIgBCAAKAI8NgLcAiAEIAAoAkA2AuACIAQgACgCRDYC5AIgBCAAKAJINgLoAiAEIAAoAkw2AuwCIAQgACgCUDYC8AIgBCAAKAJUNgL0AiAEIAAoAlg2AvgCIAQgACgCXDYC/AIgBCAAKAJgNgKAAyAEIAAoAmQ2AoQDIAQgACgCaDYCiAMgBCAAKAJsNgKMAyAEIAAoAnA2ApADIAQgACgCdDYClAMgBCAAKAJ4NgKYAyAEIAAoAnw2ApwDIAQgACgCgAE2AqADIAQgACgChAE2AqQDIAQgACgCiAE2AqgDIAQgACgCjAE2AqwDIAQgACgCkAE2ArADIAQgACgClAE2ArQDIAQgACgCmAE2ArgDIAQgACgCnAE2ArwDIAQgACgCoAE2AsADIAQgACgCpAE2AsQDIAQgACgCqAE2AsgDIAQgACgCrAE2AswDIAQgACgCsAE2AtADIAQgACgCtAE2AtQDIAQgACgCuAE2AtgDIAQgACgCvAE2AtwDIAQgACgCwAE2AuADIAQgACgCxAE2AuQDIAQgACgCyAE2AugDIAQgACgCzAE2AuwDIAQgACgC0AE2AvADIAQgACgC1AE2AvQDIAQgACgC2AE2AvgDIAQgACgC3AE2AvwDIAQgACgC4AE2AoAEIAQgACgC5AE2AoQEIAQgACgC6AE2AogEIAQgACgC7AE2AowEIAQgACgC8AE2ApAEIAQgACgC9AE2ApQEIAQgACgC+AE2ApgEIAQgACgC/AE2ApwEIAQgACgCgAI2AqAEIAQgACgChAI2AqQEIAQgACgCiAI2AqgEIAQgACgCjAI2AqwEIAQgACgCkAI2ArAEIAQgACgClAI2ArQEIAQgACgCmAI2ArgEIAQgACgCnAI2ArwEIARBwARqIARBoAJqIAEQ9QggByAMIAEQ9QggCCALIAEQ9QggCSAKIAEQ9QggBUEBSyEBIA0hBSABDQALIAAgBCgCwAQ2AgAgACAEKALEBDYCBCAAIAQoAsgENgIIIAAgBCgCzAQ2AgwgACAEKALQBDYCECAAIAQoAtQENgIUIAAgBCgC2AQ2AhggACAEKALcBDYCHCAAIAQoAuAENgIgIAAgBCgC5AQ2AiQgACAEKALoBDYCKCAAIAQoAuwENgIsIAAgBCgC8AQ2AjAgACAEKAL0BDYCNCAAIAQoAvgENgI4IAAgBCgC/AQ2AjwgACAEKAKABTYCQCAAIAQoAoQFNgJEIAAgBCgCiAU2AkggACAEKAKMBTYCTCAAIAQoApAFNgJQIAAgBCgClAU2AlQgACAEKAKYBTYCWCAAIAQoApwFNgJcIAAgBCgCoAU2AmAgACAEKAKkBTYCZCAAIAQoAqgFNgJoIAAgBCgCrAU2AmwgACAEKAKwBTYCcCAAIAQoArQFNgJ0IAAgBCgCuAU2AnggACAEKAK8BTYCfCAAIAQoAsAFNgKAASAAIAQoAsQFNgKEASAAIAQoAsgFNgKIASAAIAQoAswFNgKMASAAIAQoAtAFNgKQASAAIAQoAtQFNgKUASAAIAQoAtgFNgKYASAAIAQoAtwFNgKcASAAIAQoAuAFNgKgASAAIAQoAuQFNgKkASAAIAQoAugFNgKoASAAIAQoAuwFNgKsASAAIAQoAvAFNgKwASAAIAQoAvQFNgK0ASAAIAQoAvgFNgK4ASAAIAQoAvwFNgK8ASAAIAQoAoAGNgLAASAAIAQoAoQGNgLEASAAIAQoAogGNgLIASAAIAQoAowGNgLMASAAIAQoApAGNgLQASAAIAQoApQGNgLUASAAIAQoApgGNgLYASAAIAQoApwGNgLcASAAIAQoAqAGNgLgASAAIAQoAqQGNgLkASAAIAQoAqgGNgLoASAAIAQoAqwGNgLsASAAIAQoArAGNgLwASAAIAQoArQGNgL0ASAAIAQoArgGNgL4ASAAIAQoArwGNgL8ASAAIAQoAsAGNgKAAiAAIAQoAsQGNgKEAiAAIAQoAsgGNgKIAiAAIAQoAswGNgKMAiAAIAQoAtAGNgKQAiAAIAQoAtQGNgKUAiAAIAQoAtgGNgKYAiAAIAQoAtwGNgKcAiAAIAMgBEEEEPYIIARB4A9qJAALkQIBB38jACIDIQggAyACQZABbGsiBSACQcgAbGohCSAFJAADQCAJIAZByABsIgdqIgMgACAHaiIEKAIANgIAIAMgBCgCBDYCBCADIAQoAgg2AgggAyAEKAIMNgIMIAMgBCgCEDYCECADIAQoAhQ2AhQgAyAEKAIYNgIYIAMgBCgCHDYCHCADIAQoAiA2AiAgAyAEKAIkNgIkIAMgBCgCKDYCKCADIAQoAiw2AiwgAyAEKAIwNgIwIAMgBCgCNDYCNCADIAQoAjg2AjggAyAEKAI8NgI8IAMgBCgCQDYCQCADIAQoAkQ2AkQgBSAHakEAQcgA/AsAIAZBAWoiBiACRw0ACyAAIAUgASACEOwIIAgkAAunHwELfyMAIgUhDSAFIARBkAFsayIJIgUkACABIARByABsIgZqIQsgBSAGQQ9qQXBxayIMJAADQCAAIAdByABsIgZqIgUgBiALaiIGKAIANgIAIAUgBigCBDYCBCAFIAYoAgg2AgggBSAGKAIMNgIMIAUgBigCEDYCECAFIAYoAhQ2AhQgBSAGKAIYNgIYIAUgBigCHDYCHCAFIAYoAiA2AiAgBSAGKAIkNgIkIAUgBigCKDYCKCAFIAYoAiw2AiwgBSAGKAIwNgIwIAUgBigCNDYCNCAFIAYoAjg2AjggBSAGKAI8NgI8IAUgBigCQDYCQCAFIAYoAkQ2AkQgB0EBaiIHIARHDQALIAxBACABQQAgA0EAIAlBACAEEO8IIAIgBEEBdiIDQcgAbGohCgNAIAsgCEHIAGwiB2oiBSAHIApqIgYoAgAgAiAHaiIHKAIAajYCACAFIAYoAgQgBygCBGo2AgQgBSAGKAIIIAcoAghqNgIIIAUgBigCDCAHKAIMajYCDCAFIAYoAhAgBygCEGo2AhAgBSAGKAIUIAcoAhRqNgIUIAUgBigCGCAHKAIYajYCGCAFIAYoAhwgBygCHGo2AhwgBSAGKAIgIAcoAiBqNgIgIAUgBigCJCAHKAIkajYCJCAFIAYoAiggBygCKGo2AiggBSAGKAIsIAcoAixqNgIsIAUgBigCMCAHKAIwajYCMCAFIAYoAjQgBygCNGo2AjQgBSAGKAI4IAcoAjhqNgI4IAUgBigCPCAHKAI8ajYCPCAFIAYoAkAgBygCQGo2AkAgBSAGKAJEIAcoAkRqNgJEIAhBAWoiCCADRw0ACyAMIANByABsaiEOIAEgAyAEaiIPQcgAbGohCkEAIQgDQCAKIAhByABsIgdqIgUgByAOaiIGKAIAIAcgDGoiBygCAGo2AgAgBSAGKAIEIAcoAgRqNgIEIAUgBigCCCAHKAIIajYCCCAFIAYoAgwgBygCDGo2AgwgBSAGKAIQIAcoAhBqNgIQIAUgBigCFCAHKAIUajYCFCAFIAYoAhggBygCGGo2AhggBSAGKAIcIAcoAhxqNgIcIAUgBigCICAHKAIgajYCICAFIAYoAiQgBygCJGo2AiQgBSAGKAIoIAcoAihqNgIoIAUgBigCLCAHKAIsajYCLCAFIAYoAjAgBygCMGo2AjAgBSAGKAI0IAcoAjRqNgI0IAUgBigCOCAHKAI4ajYCOCAFIAYoAjwgBygCPGo2AjwgBSAGKAJAIAcoAkBqNgJAIAUgBigCRCAHKAJEajYCRCAIQQFqIgggA0cNAAsgA0ECayEIQQAhBQNAIAsgBUHIAGxqIgYQ6QUhByAGIAYoAkQgB0ETdHM2AkQgBkHIAGoiBiAHIAYoAgBqNgIAIAUgCEchBiAFQQFqIQUgBg0ACyALIANByABsakHIAGsQ6QUaQQAhBQNAIAogBUHIAGxqIgYQ6QUhByAGIAYoAkQgB0ETdHM2AkQgBkHIAGoiBiAHIAYoAgBqNgIAIAUgCEchBiAFQQFqIQUgBg0ACyAKIANByABsakHIAGsQ6QUaQQAhByAJQQAgASAPIAEgBCAJIAQgAxDoBSABIAQgAiADIAwgAyAJIAQgAxDoBQNAIAkgB0HIAGwiBmoiBSAFKAIAIAYgC2oiBigCAGs2AgAgBSAFKAIEIAYoAgRrNgIEIAUgBSgCCCAGKAIIazYCCCAFIAUoAgwgBigCDGs2AgwgBSAFKAIQIAYoAhBrNgIQIAUgBSgCFCAGKAIUazYCFCAFIAUoAhggBigCGGs2AhggBSAFKAIcIAYoAhxrNgIcIAUgBSgCICAGKAIgazYCICAFIAUoAiQgBigCJGs2AiQgBSAFKAIoIAYoAihrNgIoIAUgBSgCLCAGKAIsazYCLCAFIAUoAjAgBigCMGs2AjAgBSAFKAI0IAYoAjRrNgI0IAUgBSgCOCAGKAI4azYCOCAFIAUoAjwgBigCPGs2AjwgBSAFKAJAIAYoAkBrNgJAIAUgBSgCRCAGKAJEazYCRCAHQQFqIgcgBEcNAAsgASADQcgAbGohB0EAIQhBACEKA0AgByAKQcgAbCIGaiIFIAEgBmoiBigCACAFKAIAajYCACAFIAYoAgQgBSgCBGo2AgQgBSAGKAIIIAUoAghqNgIIIAUgBigCDCAFKAIMajYCDCAFIAYoAhAgBSgCEGo2AhAgBSAGKAIUIAUoAhRqNgIUIAUgBigCGCAFKAIYajYCGCAFIAYoAhwgBSgCHGo2AhwgBSAGKAIgIAUoAiBqNgIgIAUgBigCJCAFKAIkajYCJCAFIAYoAiggBSgCKGo2AiggBSAGKAIsIAUoAixqNgIsIAUgBigCMCAFKAIwajYCMCAFIAYoAjQgBSgCNGo2AjQgBSAGKAI4IAUoAjhqNgI4IAUgBigCPCAFKAI8ajYCPCAFIAYoAkAgBSgCQGo2AkAgBSAGKAJEIAUoAkRqNgJEIApBAWoiCiADRw0ACwNAIAcgCEHIAGwiBmoiBSAFKAIAIAYgCWoiBigCAGs2AgAgBSAFKAIEIAYoAgRrNgIEIAUgBSgCCCAGKAIIazYCCCAFIAUoAgwgBigCDGs2AgwgBSAFKAIQIAYoAhBrNgIQIAUgBSgCFCAGKAIUazYCFCAFIAUoAhggBigCGGs2AhggBSAFKAIcIAYoAhxrNgIcIAUgBSgCICAGKAIgazYCICAFIAUoAiQgBigCJGs2AiQgBSAFKAIoIAYoAihrNgIoIAUgBSgCLCAGKAIsazYCLCAFIAUoAjAgBigCMGs2AjAgBSAFKAI0IAYoAjRrNgI0IAUgBSgCOCAGKAI4azYCOCAFIAUoAjwgBigCPGs2AjwgBSAFKAJAIAYoAkBrNgJAIAUgBSgCRCAGKAJEazYCRCAIQQFqIgggA0cNAAsgBEECayEDQQAhBQNAIAEgBUHIAGxqIgYQ6QUhCCAGIAYoAkQgCEETdHM2AkQgBkHIAGoiBiAIIAYoAgBqNgIAIAMgBUchBiAFQQFqIQUgBg0ACyALQcgAaxDpBSEFIAtBBGsiBiAGKAIAIAVBE3RzNgIAQQAhCEEAIQoDQCAJIApByABsIgZqIgUgBSgCACABIAZqIgYoAgBrNgIAIAUgBSgCBCAGKAIEazYCBCAFIAUoAgggBigCCGs2AgggBSAFKAIMIAYoAgxrNgIMIAUgBSgCECAGKAIQazYCECAFIAUoAhQgBigCFGs2AhQgBSAFKAIYIAYoAhhrNgIYIAUgBSgCHCAGKAIcazYCHCAFIAUoAiAgBigCIGs2AiAgBSAFKAIkIAYoAiRrNgIkIAUgBSgCKCAGKAIoazYCKCAFIAUoAiwgBigCLGs2AiwgBSAFKAIwIAYoAjBrNgIwIAUgBSgCNCAGKAI0azYCNCAFIAUoAjggBigCOGs2AjggBSAFKAI8IAYoAjxrNgI8IAUgBSgCQCAGKAJAazYCQCAFIAUoAkQgBigCRGs2AkQgCkEBaiIKIARHDQALA0AgByAIQcgAbCIGaiIFIAYgCWoiBigCACAFKAIAajYCACAFIAYoAgQgBSgCBGo2AgQgBSAGKAIIIAUoAghqNgIIIAUgBigCDCAFKAIMajYCDCAFIAYoAhAgBSgCEGo2AhAgBSAGKAIUIAUoAhRqNgIUIAUgBigCGCAFKAIYajYCGCAFIAYoAhwgBSgCHGo2AhwgBSAGKAIgIAUoAiBqNgIgIAUgBigCJCAFKAIkajYCJCAFIAYoAiggBSgCKGo2AiggBSAGKAIsIAUoAixqNgIsIAUgBigCMCAFKAIwajYCMCAFIAYoAjQgBSgCNGo2AjQgBSAGKAI4IAUoAjhqNgI4IAUgBigCPCAFKAI8ajYCPCAFIAYoAkAgBSgCQGo2AkAgBSAGKAJEIAUoAkRqNgJEIAhBAWoiCCAERw0AC0EAIQUDQCAHIAVByABsaiIGEOkFIQkgBiAGKAJEIAlBE3RzNgJEIAZByABqIgYgCSAGKAIAajYCACADIAVHIQYgBUEBaiEFIAYNAAsgByAEQcgAbGpByABrEOkFGkEAIQdBACEJA0AgDCAJQcgAbCIGaiIFIAYgC2oiBigCADYCACAFIAYoAgQ2AgQgBSAGKAIINgIIIAUgBigCDDYCDCAFIAYoAhA2AhAgBSAGKAIUNgIUIAUgBigCGDYCGCAFIAYoAhw2AhwgBSAGKAIgNgIgIAUgBigCJDYCJCAFIAYoAig2AiggBSAGKAIsNgIsIAUgBigCMDYCMCAFIAYoAjQ2AjQgBSAGKAI4NgI4IAUgBigCPDYCPCAFIAYoAkA2AkAgBSAGKAJENgJEIAlBAWoiCSAERw0ACwNAIAAgB0HIAGwiBmoiBSACIAZqIgYoAgAgBSgCAGo2AgAgBSAGKAIEIAUoAgRqNgIEIAUgBigCCCAFKAIIajYCCCAFIAYoAgwgBSgCDGo2AgwgBSAGKAIQIAUoAhBqNgIQIAUgBigCFCAFKAIUajYCFCAFIAYoAhggBSgCGGo2AhggBSAGKAIcIAUoAhxqNgIcIAUgBigCICAFKAIgajYCICAFIAYoAiQgBSgCJGo2AiQgBSAGKAIoIAUoAihqNgIoIAUgBigCLCAFKAIsajYCLCAFIAYoAjAgBSgCMGo2AjAgBSAGKAI0IAUoAjRqNgI0IAUgBigCOCAFKAI4ajYCOCAFIAYoAjwgBSgCPGo2AjwgBSAGKAJAIAUoAkBqNgJAIAUgBigCRCAFKAJEajYCRCAHQQFqIgcgBEcNAAtBACEHA0AgACAHQcgAbCIGaiIFIAUoAgAgBiAMaiIGKAIAazYCACAFIAUoAgQgBigCBGs2AgQgBSAFKAIIIAYoAghrNgIIIAUgBSgCDCAGKAIMazYCDCAFIAUoAhAgBigCEGs2AhAgBSAFKAIUIAYoAhRrNgIUIAUgBSgCGCAGKAIYazYCGCAFIAUoAhwgBigCHGs2AhwgBSAFKAIgIAYoAiBrNgIgIAUgBSgCJCAGKAIkazYCJCAFIAUoAiggBigCKGs2AiggBSAFKAIsIAYoAixrNgIsIAUgBSgCMCAGKAIwazYCMCAFIAUoAjQgBigCNGs2AjQgBSAFKAI4IAYoAjhrNgI4IAUgBSgCPCAGKAI8azYCPCAFIAUoAkAgBigCQGs2AkAgBSAFKAJEIAYoAkRrNgJEIAdBAWoiByAERw0AC0EAIQUDQCAAIAVByABsaiIGEOkFIQcgBiAGKAJEIAdBE3RzNgJEIAZByABqIgYgByAGKAIAajYCACADIAVHIQYgBUEBaiEFIAYNAAsgACAEQcgAbGpByABrEOkFGiANJAALxwUBAn8gAEEAIAJrIgIgACgCACIDIAEoAgBzcSIEIANzNgIAIAEgASgCACAEczYCACAAIAAoAgQiAyABKAIEcyACcSIEIANzNgIEIAEgASgCBCAEczYCBCAAIAAoAggiAyABKAIIcyACcSIEIANzNgIIIAEgASgCCCAEczYCCCAAIAAoAgwiAyABKAIMcyACcSIEIANzNgIMIAEgASgCDCAEczYCDCAAIAAoAhAiAyABKAIQcyACcSIEIANzNgIQIAEgASgCECAEczYCECAAIAAoAhQiAyABKAIUcyACcSIEIANzNgIUIAEgASgCFCAEczYCFCAAIAAoAhgiAyABKAIYcyACcSIEIANzNgIYIAEgASgCGCAEczYCGCAAIAAoAhwiAyABKAIccyACcSIEIANzNgIcIAEgASgCHCAEczYCHCAAIAAoAiAiAyABKAIgcyACcSIEIANzNgIgIAEgASgCICAEczYCICAAIAAoAiQiAyABKAIkcyACcSIEIANzNgIkIAEgASgCJCAEczYCJCAAIAAoAigiAyABKAIocyACcSIEIANzNgIoIAEgASgCKCAEczYCKCAAIAAoAiwiAyABKAIscyACcSIEIANzNgIsIAEgASgCLCAEczYCLCAAIAAoAjAiAyABKAIwcyACcSIEIANzNgIwIAEgASgCMCAEczYCMCAAIAAoAjQiAyABKAI0cyACcSIEIANzNgI0IAEgASgCNCAEczYCNCAAIAAoAjgiAyABKAI4cyACcSIEIANzNgI4IAEgASgCOCAEczYCOCAAIAAoAjwiAyABKAI8cyACcSIEIANzNgI8IAEgASgCPCAEczYCPCAAIAAoAkAiAyABKAJAcyACcSIEIANzNgJAIAEgASgCQCAEczYCQCAAIAAoAkQiAyABKAJEcyACcSICIANzNgJEIAEgASgCRCACczYCRAulAgEHfyMAIgQhCSAEIANBkAFsayIGJAAgACABIAMQ6QggBiADQcgAbGohCgNAIAYgB0HIAGwiCGoiBCAAIAhqIgUoAgA2AgAgBCAFKAIENgIEIAQgBSgCCDYCCCAEIAUoAgw2AgwgBCAFKAIQNgIQIAQgBSgCFDYCFCAEIAUoAhg2AhggBCAFKAIcNgIcIAQgBSgCIDYCICAEIAUoAiQ2AiQgBCAFKAIoNgIoIAQgBSgCLDYCLCAEIAUoAjA2AjAgBCAFKAI0NgI0IAQgBSgCODYCOCAEIAUoAjw2AjwgBCAFKAJANgJAIAQgBSgCRDYCRCAIIApqQQBByAD8CwAgB0EBaiIHIANHDQALIAAgBiABIAIgAxD0CCAAIAEgAxDpCCAJJAALeQIEfwF+IwAiBSEGIAUgBEGQAWxrIgUkACABIARByABsakEEaygCAEETdUECaqwiCSAJfkKBBFoEQCABIAIgBBDpCAsjACIHIARBkAFsayIIJAAgBUEAIAFBACAIQQAgBBDrCCAHJAAgACAFIAIgAyAEEPQIIAYkAAujGgEJfyMAQcAEayICJAAgAkEAQcgA/AsAIAIgAUEddTYCBCACIAFB/////wFxNgIAIAJByABqIQcgA0UEQCAHQQBByAD8CwALIAJBkAFqIQggA0UEQCAIQQBByAD8CwALIAJB2AFqIQkgA0UEQCAJQQBByAD8CwALIAIgACgCADYCoAIgAiAAKAIENgKkAiACIAAoAgg2AqgCIAIgACgCDDYCrAIgAiAAKAIQNgKwAiACIAAoAhQ2ArQCIAIgACgCGDYCuAIgAiAAKAIcNgK8AiACIAAoAiA2AsACIAIgACgCJDYCxAIgAiAAKAIoNgLIAiACIAAoAiw2AswCIAIgACgCMDYC0AIgAiAAKAI0NgLUAiACIAAoAjg2AtgCIAIgACgCPDYC3AIgAiAAKAJANgLgAiACIAAoAkQ2AuQCIAIgACgCSDYC6AIgAiAAKAJMNgLsAiACIAAoAlA2AvACIAIgACgCVDYC9AIgAiAAKAJYNgL4AiACIAAoAlw2AvwCIAIgACgCYDYCgAMgAiAAKAJkNgKEAyACIAAoAmg2AogDIAIgACgCbDYCjAMgAiAAKAJwNgKQAyACIAAoAnQ2ApQDIAIgACgCeDYCmAMgAiAAKAJ8NgKcAyACIAAoAoABNgKgAyACIAAoAoQBNgKkAyACIAAoAogBNgKoAyACIAAoAowBNgKsAyACIAAoApABNgKwAyACIAAoApQBNgK0AyACIAAoApgBNgK4AyACIAAoApwBNgK8AyACIAAoAqABNgLAAyACIAAoAqQBNgLEAyACIAAoAqgBNgLIAyACIAAoAqwBNgLMAyACIAAoArABNgLQAyACIAAoArQBNgLUAyACIAAoArgBNgLYAyACIAAoArwBNgLcAyACIAAoAsABNgLgAyACIAAoAsQBNgLkAyACIAAoAsgBNgLoAyACIAAoAswBNgLsAyACIAAoAtABNgLwAyACIAAoAtQBNgL0AyACIAAoAtgBNgL4AyACIAAoAtwBNgL8AyACIAAoAuABNgKABCACIAAoAuQBNgKEBCACIAAoAugBNgKIBCACIAAoAuwBNgKMBCACIAAoAvABNgKQBCACIAAoAvQBNgKUBCACIAAoAvgBNgKYBCACIAAoAvwBNgKcBCACIAAoAoACNgKgBCACIAAoAoQCNgKkBCACIAAoAogCNgKoBCACIAAoAowCNgKsBCACIAAoApACNgKwBCACIAAoApQCNgK0BCACIAAoApgCNgK4BCACIAAoApwCNgK8BCACQaACahDpBSEAIAIgAigC5AIgAEETdHM2AuQCIAIgACACKALoAmo2AugCIAJB6AJqIgUQ6QUhACACIAIoAqwDIABBE3RzNgKsAyACIAAgAigCsANqNgKwAyACQbADaiIGEOkFIQAgAiACKAL0AyAAQRN0czYC9AMgAiAAIAIoAvgDaiIAQf////8BcTYC+AMgAiACKAL8AyAAQR11aiIAQf////8BcTYC/AMgAiACKAKABCAAQR11aiIAQf////8BcTYCgAQgAiACKAKEBCAAQR11aiIAQf////8BcTYChAQgAiACKAKIBCAAQR11aiIAQf////8BcTYCiAQgAiACKAKMBCAAQR11aiIAQf////8BcTYCjAQgAiACKAKQBCAAQR11aiIAQf////8BcTYCkAQgAiACKAKUBCAAQR11aiIAQf////8BcTYClAQgAiACKAKYBCAAQR11aiIAQf////8BcTYCmAQgAiACKAKcBCAAQR11aiIAQf////8BcTYCnAQgAiACKAKgBCAAQR11aiIAQf////8BcTYCoAQgAiACKAKkBCAAQR11aiIAQf////8BcTYCpAQgAiACKAKoBCAAQR11aiIAQf////8BcTYCqAQgAiACKAKsBCAAQR11aiIAQf////8BcTYCrAQgAiACKAKwBCAAQR11aiIAQf////8BcTYCsAQgAiACKAK0BCAAQR11aiIAQf////8BcTYCtAQgAiACKAK4BCAAQR11aiIAQf////8BcTYCuAQgAiACKAK8BCAAQR11ajYCvAQgAkH4A2ohCgNAIARByABsIgMgAkGgAmpqIgAgACgCACACIANqIgMoAgBrNgIAIAAgACgCBCADKAIEazYCBCAAIAAoAgggAygCCGs2AgggACAAKAIMIAMoAgxrNgIMIAAgACgCECADKAIQazYCECAAIAAoAhQgAygCFGs2AhQgACAAKAIYIAMoAhhrNgIYIAAgACgCHCADKAIcazYCHCAAIAAoAiAgAygCIGs2AiAgACAAKAIkIAMoAiRrNgIkIAAgACgCKCADKAIoazYCKCAAIAAoAiwgAygCLGs2AiwgACAAKAIwIAMoAjBrNgIwIAAgACgCNCADKAI0azYCNCAAIAAoAjggAygCOGs2AjggACAAKAI8IAMoAjxrNgI8IAAgACgCQCADKAJAazYCQCAAIAAoAkQgAygCRGs2AkQgBEEBaiIEQQRHDQAgAkGgAmoQ6QUhACACIAIoAuQCIABBE3RzNgLkAiACIAAgAigC6AJqNgLoAiAFEOkFIQAgAiACKAKsAyAAQRN0czYCrAMgAiAAIAIoArADajYCsAMgBhDpBSEAIAIgAigC9AMgAEETdHM2AvQDIAIgACACKAL4A2oiAEH/////AXE2AvgDIAIgAigC/AMgAEEddWoiAEH/////AXE2AvwDIAIgAigCgAQgAEEddWoiAEH/////AXE2AoAEIAIgAigChAQgAEEddWoiAEH/////AXE2AoQEIAIgAigCiAQgAEEddWoiAEH/////AXE2AogEIAIgAigCjAQgAEEddWoiAEH/////AXE2AowEIAIgAigCkAQgAEEddWoiAEH/////AXE2ApAEIAIgAigClAQgAEEddWoiAEH/////AXE2ApQEIAIgAigCmAQgAEEddWoiAEH/////AXE2ApgEIAIgAigCnAQgAEEddWoiAEH/////AXE2ApwEIAIgAigCoAQgAEEddWoiAEH/////AXE2AqAEIAIgAigCpAQgAEEddWoiAEH/////AXE2AqQEIAIgAigCqAQgAEEddWoiAEH/////AXE2AqgEIAIgAigCrAQgAEEddWoiAEH/////AXE2AqwEIAIgAigCsAQgAEEddWoiAEH/////AXE2ArAEIAIgAigCtAQgAEEddWoiAEH/////AXE2ArQEIAIgAigCuAQgAEEddWoiAEH/////AXE2ArgEIAIgAigCvAQgAEEddWo2ArwEA0BBACEAAkADQAJAIAJBoAJqIABByABsaiIDKAIADQAgAygCBA0AIAMoAggNACADKAIMDQAgAygCEA0AIAMoAhQNACADKAIYDQAgAygCHA0AIAMoAiANACADKAIkDQAgAygCKA0AIAMoAiwNACADKAIwDQAgAygCNA0AIAMoAjgNACADKAI8DQAgAygCQA0AIAMoAkQNACAAQQFqIgBBBEcNAQwCCwsgAi0AoAJBAXENACAKEOoFIQAgAiACKAL0AyAAQRN0cjYC9AMgBhDqBSEAIAIgAigCrAMgAEETdHI2AqwDIAUQ6gUhACACIAIoAuQCIABBE3RyNgLkAiACIAIoAqQCIgBBHHRBgICAgAFxIAIoAqACQQF1cjYCoAIgAiACKAKoAiIDQRx0QYCAgIABcSAAQQF1cjYCpAIgAiACKAKsAiIAQRx0QYCAgIABcSADQQF1cjYCqAIgAiACKAKwAiIDQRx0QYCAgIABcSAAQQF1cjYCrAIgAiACKAK0AiIAQRx0QYCAgIABcSADQQF1cjYCsAIgAiACKAK4AiIDQRx0QYCAgIABcSAAQQF1cjYCtAIgAiACKAK8AiIAQRx0QYCAgIABcSADQQF1cjYCuAIgAiACKALAAiIDQRx0QYCAgIABcSAAQQF1cjYCvAIgAiACKALEAiIAQRx0QYCAgIABcSADQQF1cjYCwAIgAiACKALIAiIDQRx0QYCAgIABcSAAQQF1cjYCxAIgAiACKALMAiIAQRx0QYCAgIABcSADQQF1cjYCyAIgAiACKALQAiIDQRx0QYCAgIABcSAAQQF1cjYCzAIgAiACKALUAiIAQRx0QYCAgIABcSADQQF1cjYC0AIgAiACKALYAiIDQRx0QYCAgIABcSAAQQF1cjYC1AIgAiACKALcAiIAQRx0QYCAgIABcSADQQF1cjYC2AIgAiACKALgAiIDQRx0QYCAgIABcSAAQQF1cjYC3AIgAiACKALkAiIAQQF1NgLkAiACIABBHHRBgICAgAFxIANBAXVyNgLgAgwBCwsCQAJAIAogCRDqCCIADQAgBiAIEOoIIgANACAFIAcQ6ggiAA0AIAJBoAJqIAIQ6ggiAEUNAQtBACEEIABBAEoNAQsLAkAgAigCoAIiAEUEQCABIQMMAQsDQCABIAAiA28hACADIQEgAA0ACwsgAkHABGokACADQQFKC6AfAhh/AX4jAEHAFmsiAiQAIAAQ6QUhAyAAIAAoAkQgA0ETdHM2AkQgAEHIAGoiBCADIAQoAgBqNgIAIAQQ6QUhAyAAQYwBaiIEIAQoAgAgA0ETdHM2AgAgAEGQAWoiBCADIAQoAgBqNgIAIAQQ6QUhAyAAQdQBaiIEIAQoAgAgA0ETdHM2AgAgAEHYAWoiBCADIAQoAgBqNgIAIAQQ6QUaAkAgAEG1gagCEPgIBEAMAQsgAkEBNgKgAiACQaACakEEckEAQcQA/AsAQQAhAyACQegCakEAQcgA/AsAIANFBEAgAkGwA2pBAEHIAPwLAAsgA0UEQCACQfgDakEAQcgA/AsACwNAIAIgBkHIAGwiBWoiAyAAIAVqIgQoAgAgAkGgAmogBWoiBSgCAGs2AgAgAyAEKAIEIAUoAgRrNgIEIAMgBCgCCCAFKAIIazYCCCADIAQoAgwgBSgCDGs2AgwgAyAEKAIQIAUoAhBrNgIQIAMgBCgCFCAFKAIUazYCFCADIAQoAhggBSgCGGs2AhggAyAEKAIcIAUoAhxrNgIcIAMgBCgCICAFKAIgazYCICADIAQoAiQgBSgCJGs2AiQgAyAEKAIoIAUoAihrNgIoIAMgBCgCLCAFKAIsazYCLCADIAQoAjAgBSgCMGs2AjAgAyAEKAI0IAUoAjRrNgI0IAMgBCgCOCAFKAI4azYCOCADIAQoAjwgBSgCPGs2AjwgAyAEKAJAIAUoAkBrNgJAIAMgBCgCRCAFKAJEazYCRCAGQQFqIgZBBEcNAAsgAhDpBSEDIAIgAigCRCADQRN0czYCRCACIAMgAigCSGo2AkggAkHIAGoQ6QUhAyACIAIoAowBIANBE3RzNgKMASACIAMgAigCkAFqNgKQASACQZABahDpBSEDIAIgAigC1AEgA0ETdHM2AtQBIAIgAyACKALYAWoiA0H/////AXE2AtgBIAIgAigC3AEgA0EddWoiA0H/////AXE2AtwBIAIgAigC4AEgA0EddWoiA0H/////AXE2AuABIAIgAigC5AEgA0EddWoiA0H/////AXE2AuQBIAIgAigC6AEgA0EddWoiA0H/////AXE2AugBIAIgAigC7AEgA0EddWoiA0H/////AXE2AuwBIAIgAigC8AEgA0EddWoiA0H/////AXE2AvABIAIgAigC9AEgA0EddWoiA0H/////AXE2AvQBIAIgAigC+AEgA0EddWoiA0H/////AXE2AvgBIAIgAigC/AEgA0EddWoiA0H/////AXE2AvwBIAIgAigCgAIgA0EddWoiA0H/////AXE2AoACIAIgAigChAIgA0EddWoiA0H/////AXE2AoQCIAIgAigCiAIgA0EddWoiA0H/////AXE2AogCIAIgAigCjAIgA0EddWoiA0H/////AXE2AowCIAIgAigCkAIgA0EddWoiA0H/////AXE2ApACIAIgAigClAIgA0EddWoiA0H/////AXE2ApQCIAIgAigCmAIgA0EddWoiA0H/////AXE2ApgCIAIgAigCnAIgA0EddWo2ApwCIAIgAigCADYC4AYgAiACKAIENgLkBiACIAIoAgg2AugGIAIgAigCDDYC7AYgAiACKAIQNgLwBiACIAIoAhQ2AvQGIAIgAigCGDYC+AYgAiACKAIcNgL8BiACIAIoAiA2AoAHIAIgAigCJDYChAcgAiACKAIoNgKIByACIAIoAiw2AowHIAIgAigCMDYCkAcgAiACKAI0NgKUByACIAIoAjg2ApgHIAIgAigCPDYCnAcgAiACKAJANgKgByACIAIoAkQ2AqQHIAIgAigCSDYCqAcgAiACKAJMNgKsByACIAIoAlA2ArAHIAIgAigCVDYCtAcgAiACKAJYNgK4ByACIAIoAlw2ArwHIAIgAigCYDYCwAcgAiACKAJkNgLEByACIAIoAmg2AsgHIAIgAigCbDYCzAcgAiACKAJwNgLQByACIAIoAnQ2AtQHIAIgAigCeDYC2AcgAiACKAJ8NgLcByACIAIoAoABNgLgByACIAIoAoQBNgLkByACIAIoAogBNgLoByACIAIoAowBNgLsByACIAIoApABNgLwByACIAIoApQBNgL0ByACIAIoApgBNgL4ByACIAIoApwBNgL8ByACIAIoAqABNgKACCACIAIoAqQBNgKECCACIAIoAqgBNgKICCACIAIoAqwBNgKMCCACIAIoArABNgKQCCACIAIoArQBNgKUCCACIAIoArgBNgKYCCACIAIoArwBNgKcCCACIAIoAsABNgKgCCACIAIoAsQBNgKkCCACIAIoAsgBNgKoCCACIAIoAswBNgKsCCACIAIoAtABNgKwCCACIAIoAtQBNgK0CCACIAIoAtgBNgK4CCACIAIoAtwBNgK8CCACIAIoAuABNgLACCACIAIoAuQBNgLECCACIAIoAugBNgLICCACIAIoAuwBNgLMCCACIAIoAvABNgLQCCACIAIoAvQBNgLUCCACIAIoAvgBNgLYCCACIAIoAvwBNgLcCCACIAIoAoACNgLgCCACIAIoAoQCNgLkCCACIAIoAogCNgLoCCACIAIoAowCNgLsCCACIAIoApACNgLwCCACIAIoApQCNgL0CCACIAIoApgCNgL4CCACIAIoApwCNgL8CCACQagHaiEGIAJB8AdqIQogAkG4CGohB0EAIQMDQCACLQDgBkEBcUUEQCAHEOoFIQQgAiACKAK0CCAEQRN0cjYCtAggChDqBSEEIAIgAigC7AcgBEETdHI2AuwHIAYQ6gUhBCACIAIoAqQHIARBE3RyNgKkByACIAIoAuQGIgRBHHRBgICAgAFxIAIoAuAGQQF1cjYC4AYgAiACKALoBiIFQRx0QYCAgIABcSAEQQF1cjYC5AYgAiACKALsBiIEQRx0QYCAgIABcSAFQQF1cjYC6AYgAiACKALwBiIFQRx0QYCAgIABcSAEQQF1cjYC7AYgAiACKAL0BiIEQRx0QYCAgIABcSAFQQF1cjYC8AYgAiACKAL4BiIFQRx0QYCAgIABcSAEQQF1cjYC9AYgAiACKAL8BiIEQRx0QYCAgIABcSAFQQF1cjYC+AYgAiACKAKAByIFQRx0QYCAgIABcSAEQQF1cjYC/AYgAiACKAKEByIEQRx0QYCAgIABcSAFQQF1cjYCgAcgAiACKAKIByIFQRx0QYCAgIABcSAEQQF1cjYChAcgAiACKAKMByIEQRx0QYCAgIABcSAFQQF1cjYCiAcgAiACKAKQByIFQRx0QYCAgIABcSAEQQF1cjYCjAcgAiACKAKUByIEQRx0QYCAgIABcSAFQQF1cjYCkAcgAiACKAKYByIFQRx0QYCAgIABcSAEQQF1cjYClAcgAiACKAKcByIEQRx0QYCAgIABcSAFQQF1cjYCmAcgAiACKAKgByIFQRx0QYCAgIABcSAEQQF1cjYCnAcgAiACKAKkByIEQQF1NgKkByACIARBHHRBgICAgAFxIAVBAXVyNgKgByADQQFqIQMMAQsLIANFBEBBACEFDAELIAJByABqIQsgAkGIBWohCCACQZABaiEMIAJB0AVqIQkgAkHYAWohDSACQZgGaiEHIAJB6AJqIQ4gAkGwA2ohDyACQfgDaiEQIAJB+BVqIRIgAkGwFWohEyACQegUaiEUIAJBoBRqIRUgAkHYE2ohFiACQZATaiEXIAJByBJqIRggAkHABGpBBHIhGQNAIAJBgBJqIAEQ8QggGCABEPEIIBcgARDxCCAWIAEQ8QggFSABEPEIIBQgARDxCCATIAEQ8QggEiABEPEIIAJBwARqIAJBgBJqIABBBBDsCCACQYAJaiAAQQQQ7QggAiACKALABDYCoAsgAiAC/QACxAT9CwKkCyACIAL9AALUBP0LArQLIAIgAv0AAuQE/QsCxAsgAiAC/QAC9AT9CwLUCyACIAL9AAKEBf0LAuQLIAIgAv0AApQF/QsC9AsgAiACKQKkBTcChAwgAiACKAKsBTYCjAwgAiACKAKwBTYCkAwgAiAC/QACtAX9CwKUDCACIAL9AALEBf0LAqQMIAIgAv0AAtQF/QsCtAwgAiAC/QAC5AX9CwLEDCACIAL9AAL0Bf0LAtQMIAIgAv0AAoQG/QsC5AwgAiACKQKUBjcC9AwgAiACKAKcBjYC/AwgAiACKAKgBjYCgA0gAiACKAKkBjYChA0gAiACKAKoBjYCiA0gAiACKAKsBjYCjA0gAiACKAKwBjYCkA0gAiACKAK0BjYClA0gAiACKAK4BjYCmA0gAiACKAK8BjYCnA0gAiACKALABjYCoA0gAiACKALEBjYCpA0gAiACKALIBjYCqA0gAiACKALMBjYCrA0gAiACKALQBjYCsA0gAiACKALUBjYCtA0gAiACKALYBjYCuA0gAiACKALcBjYCvA0gAkEBNgLABCAZQQBBxAD8CwBBACEEIAhBAEHIAPwLACAERQRAIAlBAEHIAPwLAAsgBEUEQCAHQQBByAD8CwALIAJBwARqIABBBBDzCCACQaALaiAAQQQQ8whBgBAhBANAIAIhBSACKALcBkETdUECaqwiGiAafkKBBFoEQCACQcAEaiAAQQQQ6QgLIAJBwA1qQQAgAkHABGpBACACQYASakEAQQQQ6wggAkHABGogAkHADWogACACQYAJakEEEPQIIAJB4AZqIQYgBiAEQQFrIgVBCXZByABsaiAFQf8DcSIGQR1uIgpBAnRqKAIAIApBY2wgBmp2QQFxBEAgAiEGIAIoArwNQRN1QQJqIAIoAtwGQRN1QQJqbEGBBE4EQCACQcAEaiAAQQQQ6QgLIAJBwA1qQQAgAkHABGpBACACQaALakEAIAJBgBJqQQBBBBDoBSACQcAEaiACQcANaiAAIAJBgAlqQQQQ9AgLIARBAUshBiAFIQQgBg0ACyACQcAEaiAAIAJBgAlqQQQQ9ggCQAJAIAcgEBDqCA0AIAkgDxDqCA0AIAggDhDqCA0AIAJBwARqIAJBoAJqEOoIRQ0BCwJAIAcgDRDqCA0AIAkgDBDqCA0AIAggCxDqCA0AIAJBwARqIAIQ6ghFDQELQQEhBEEAIQUgA0EBRg0CA0AgAkHABGogAkHABGpBAiAAQQQQ4AUCQCAHIBAQ6ggNACAJIA8Q6ggNACAIIA4Q6ggNACACQcAEaiACQaACahDqCEUNBAsCQCAHIA0Q6ggNACAJIAwQ6ggNACAIIAsQ6ggNACACQcAEaiACEOoIRQ0CCyAEQQFqIgQgA0cNAAsMAgtBASEFIBFBAWoiEUEKRw0ACwsgAkHAFmokACAFC5IIAQ1/IAAoAgwhBCABKAAAIQUjAEEgayIDIAAoAhAgASgABHMiBzYCFCADIAAoAhQgASgACHMiCDYCGCADIAAoAhggASgADHMiBjYCHCAAQQxqIQ0gBCAFcyEJIAMiAkEQaiEDAkAgACgCBEECSARAQQQhDAwBC0EBIQ4gCCEEIAchBSAJIQogAiELQQQhDANAIAMhAiALIgMgCkH/AXFBAnRBwMovaigCACANIAxBAnRqIgsoAgBzIAVBBnZB/AdxQcDKL2ooAgBBCHdzIARBDnZB/AdxQcDKL2ooAgBBEHdzIAZBFnZB/AdxQcDKL2ooAgBBGHdzIgk2AgAgAyAFQf8BcUECdEHAyi9qKAIAIAsoAgRzIARBBnZB/AdxQcDKL2ooAgBBCHdzIAZBDnZB/AdxQcDKL2ooAgBBEHdzIApBFnZB/AdxQcDKL2ooAgBBGHdzIgc2AgQgAyAEQf8BcUECdEHAyi9qKAIAIAsoAghzIAZBBnZB/AdxQcDKL2ooAgBBCHdzIApBDnZB/AdxQcDKL2ooAgBBEHdzIAVBFnZB/AdxQcDKL2ooAgBBGHdzIgg2AgggAyAGQf8BcUECdEHAyi9qKAIAIAsoAgxzIApBBnZB/AdxQcDKL2ooAgBBCHdzIAVBDnZB/AdxQcDKL2ooAgBBEHdzIARBFnZB/AdxQcDKL2ooAgBBGHdzIgY2AgwgDEEEaiEMIAghBCAHIQUgCSEKIAIhCyAOQQFqIg4gACgCBEgNAAsLIAIgDSAMQQJ0aiIEKAIAIAlB/wFxQfDYMWotAABzIgogCEEQdkH/AXFB8Ngxai0AAEEQdCAGQRh2QfDYMWotAABBGHRyIAdBCHZB/wFxQfDYMWotAABBCHRycyIFNgIAIAIgBCgCBCAHQf8BcUHw2DFqLQAAcyAIQQh2Qf8BcUHw2DFqLQAAQQh0cyAGQRB2Qf8BcUHw2DFqLQAAQRB0cyAJQRh2QfDYMWotAABBGHRzNgIEIAIgBCgCCCAIQf8BcUHw2DFqLQAAcyAGQQh2Qf8BcUHw2DFqLQAAQQh0cyAJQRB2Qf8BcUHw2DFqLQAAQRB0cyAHQRh2QfDYMWotAABBGHRzNgIIIAIgBCgCDCAGQf8BcUHw2DFqLQAAcyAJQQh2Qf8BcUHw2DFqLQAAQQh0cyAHQRB2Qf8BcUHw2DFqLQAAQRB0cyAIQRh2QfDYMWotAABBGHRzNgIMIAEgBUEYdjoAAyABIAVBEHY6AAIgASAFQQh2OgABIAEgCjoAACACQQA2AgAgA0EANgIAIAEgAigCBDYABCACQQA2AgQgA0EANgIEIAEgAigCCDYACCACQQA2AgggA0EANgIIIAEgAigCDDYADCACQQA2AgwgA0EANgIMC5cIAQ1/IAAoAvwBIQQgASgAACEFIwBBIGsiAyAAKAKAAiABKAAEcyIHNgIUIAMgACgChAIgASgACHMiCDYCGCADIAAoAogCIAEoAAxzIgY2AhwgAEH8AWohDSAEIAVzIQkgAyICQRBqIQMCQCAAKAIEQQJIBEBBBCEMDAELQQEhDiAHIQQgCCEFIAkhCiACIQtBBCEMA0AgAyECIAsiAyAKQf8BcUECdEHA0i9qKAIAIA0gDEECdGoiCygCAHMgBkEGdkH8B3FBwNIvaigCAEEId3MgBUEOdkH8B3FBwNIvaigCAEEQd3MgBEEWdkH8B3FBwNIvaigCAEEYd3MiCTYCACADIARB/wFxQQJ0QcDSL2ooAgAgCygCBHMgCkEGdkH8B3FBwNIvaigCAEEId3MgBkEOdkH8B3FBwNIvaigCAEEQd3MgBUEWdkH8B3FBwNIvaigCAEEYd3MiBzYCBCADIAVB/wFxQQJ0QcDSL2ooAgAgCygCCHMgBEEGdkH8B3FBwNIvaigCAEEId3MgCkEOdkH8B3FBwNIvaigCAEEQd3MgBkEWdkH8B3FBwNIvaigCAEEYd3MiCDYCCCADIAZB/wFxQQJ0QcDSL2ooAgAgCygCDHMgBUEGdkH8B3FBwNIvaigCAEEId3MgBEEOdkH8B3FBwNIvaigCAEEQd3MgCkEWdkH8B3FBwNIvaigCAEEYd3MiBjYCDCAMQQRqIQwgByEEIAghBSAJIQogAiELIA5BAWoiDiAAKAIESA0ACwsgAiANIAxBAnRqIgQoAgAgCUH/AXFBwNovai0AAHMiCiAIQRB2Qf8BcUHA2i9qLQAAQRB0IAdBGHZBwNovai0AAEEYdHIgBkEIdkH/AXFBwNovai0AAEEIdHJzIgU2AgAgAiAEKAIEIAdB/wFxQcDaL2otAABzIAlBCHZB/wFxQcDaL2otAABBCHRzIAZBEHZB/wFxQcDaL2otAABBEHRzIAhBGHZBwNovai0AAEEYdHM2AgQgAiAEKAIIIAhB/wFxQcDaL2otAABzIAdBCHZB/wFxQcDaL2otAABBCHRzIAlBEHZB/wFxQcDaL2otAABBEHRzIAZBGHZBwNovai0AAEEYdHM2AgggAiAEKAIMIAZB/wFxQcDaL2otAABzIAhBCHZB/wFxQcDaL2otAABBCHRzIAdBEHZB/wFxQcDaL2otAABBEHRzIAlBGHZBwNovai0AAEEYdHM2AgwgASAFQRh2OgADIAEgBUEQdjoAAiABIAVBCHY6AAEgASAKOgAAIAJBADYCACADQQA2AgAgASACKAIENgAEIAJBADYCBCADQQA2AgQgASACKAIINgAIIAJBADYCCCADQQA2AgggASACKAIMNgAMIAJBADYCDCADQQA2AgwLmgMBAX8gACAALQAAQQFqIgE6AAACQCABQf8BcSABRg0AIAAgAC0AAUEBaiIBOgABIAFB/wFxIAFGDQAgACAALQACQQFqIgE6AAIgAUH/AXEgAUYNACAAIAAtAANBAWoiAToAAyABQf8BcSABRg0AIAAgAC0ABEEBaiIBOgAEIAFB/wFxIAFGDQAgACAALQAFQQFqIgE6AAUgAUH/AXEgAUYNACAAIAAtAAZBAWoiAToABiABQf8BcSABRg0AIAAgAC0AB0EBaiIBOgAHIAFB/wFxIAFGDQAgACAALQAIQQFqIgE6AAggAUH/AXEgAUYNACAAIAAtAAlBAWoiAToACSABQf8BcSABRg0AIAAgAC0ACkEBaiIBOgAKIAFB/wFxIAFGDQAgACAALQALQQFqIgE6AAsgAUH/AXEgAUYNACAAIAAtAAxBAWoiAToADCABQf8BcSABRg0AIAAgAC0ADUEBaiIBOgANIAFB/wFxIAFGDQAgACAALQAOQQFqIgE6AA4gAUH/AXEgAUYNACAAIAAtAA9BAWo6AA8LC4YMAgl/AXsjAEEQayIKJAAgCv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgACAO/QsAgBAgAEG0EGoiBUEAIAEgAiAEELAEIAUgChD6CCAAIAooAgAiAkEYdCACQYD+A3FBCHRyIAJBCHZBgP4DcSACQRh2cnIiATYCACAAIAooAgQiAkEYdCACQYD+A3FBCHRyIAJBCHZBgP4DcSACQRh2cnIiBTYCBCAAIAooAggiAkEYdCACQYD+A3FBCHRyIAJBCHZBgP4DcSACQRh2cnIiCTYCCCAAIAooAgwiAkEYdCACQYD+A3FBCHRyIAJBCHZBgP4DcSACQRh2cnIiBzYCDCAAQYAQaiENQQEhBgNAIAAgBkEEdGoiAiAJQR90IAdBAXZyIgg2AgwgAiAFQR90IAlBAXZyIgk2AgggAiABQR90IAVBAXZyIgU2AgQgAiABQQF2IgE2AgAgB0EBcQRAIAIgAUGAgICIfnMiATYCAAsgCCEHIAZBAWoiBkGAAUcNAAsgACAO/QsCoBACQCADQQxGBEAgACAELQAAOgCgFCAAIAQtAAE6AKEUIAAgBC0AAjoAohQgACAELQADOgCjFCAAIAQtAAQ6AKQUIAAgBC0ABToApRQgACAELQAGOgCmFCAAIAQtAAc6AKcUIABBqBRqIAQtAAg6AAAgACAELQAJOgCpFCAAIAQtAAo6AKoUIAAgBC0ACzoAqxQgAEGAgIAINgCsFCAAIAD9AACgFP0LAJAQDAELIABBATYCsBAgA0EASgRAQQAhBQNAIAUgDWoiAiACLQAAIAQgDGotAABzOgAAIAAgACgCrBBBAWoiAjYCrBAgAkUEQCAAIAAoAqgQQQFqNgKoEAsgDEEBaiEMQQghAkEAIQcCQCAFQQ5LBEBBACEGQQAhCEEAIQtBACEJQQAhAQwBCyAFQQFqIQVBACEGQQAhCEEAIQtBACEJQQAhASADIAxKDQELA0AgCSANai0AACACQQFrIgJ2QQFxBEAgACABQQR0aiIFKAIMIAdzIQcgBSgCCCAGcyEGIAUoAgAgC3MhCyAFKAIEIAhzIQgLAkAgAkUEQEEIIQIgCUEBaiIJQRBGDQELIAFBAWoiAUGAAUcNAQsLIAAgCDoAhxAgACAGOgCLECAAIAc6AI8QIAAgC0EQdjoAgRAgACALQRh2OgCAECAAIAhBCHY6AIYQIAAgCEEQdjoAhRAgACAIQRh2OgCEECAAIAZBCHY6AIoQIAAgBkEQdjoAiRAgACAGQRh2OgCIECAAIAdBCHY6AI4QIAAgB0EQdjoAjRAgACAHQRh2OgCMECAAIAtBCHQgC0GA/gNxQQh2cjsAghBBACEFIAMgDEoNAAsLIABBoBBqIQEgA0EPcQRAIABBAjYCsBALIAAQgAkgACAALQCAECICOgCgFCAAIAI6AJAQIABBADoAgBAgACAALQCBECICOgChFCAAIAI6AJEQIAAtAIIQIQIgAEEAOwCBECAAIAI6AKIUIAAgAjoAkhAgACAALQCDECICOgCjFCAAIAI6AJMQIAAtAIQQIQIgAEEAOwCDECAAIAI6AKQUIAAgAjoAlBAgACAALQCFECICOgClFCAAQQA6AIUQIAAgAjoAlRAgACAALQCGECICOgCmFCAAQQA6AIYQIAAgAjoAlhAgACAALQCHECICOgCnFCAAQQA6AIcQIAAgAjoAlxAgACAALQCIECICOgCoFCAAQQA6AIgQIAAgAjoAmBAgACAALQCJECICOgCpFCAAQQA6AIkQIAAgAjoAmRAgACAALQCKECICOgCqFCAAQQA6AIoQIAAgAjoAmhAgACAALQCLECICOgCrFCAAQQA6AIsQIAAgAjoAmxAgACAALQCMECICOgCsFCAAQQA6AIwQIAAgAjoAnBAgACAALQCNECICOgCtFCAAQQA6AI0QIAAgAjoAnRAgACAALQCOECICOgCuFCAAQQA6AI4QIAAgAjoAnhAgACAALQCPECICOgCvFCAAQQA6AI8QIAAgAjoAnxAgASAO/QsCAAsgAEEANgKwECAKQRBqJAAL4wMBCn8CQCAAKAKwEA0AIAJBAEoEQCAAQYAQaiEMA0AgAyAMaiIEIAQtAAAgASAJai0AAHM6AAAgACAAKAKkEEEBaiIENgKkECAERQRAIAAgACgCoBBBAWo2AqAQCyAJQQFqIQlBCCEEQQAhCAJAIANBDksEQEEAIQVBACEGQQAhB0EAIQpBACELDAELIANBAWohA0EAIQVBACEGQQAhB0EAIQpBACELIAIgCUoNAQsDQCAKIAxqLQAAIARBAWsiBHZBAXEEQCAAIAtBBHRqIgMoAgwgCHMhCCADKAIEIAZzIQYgAygCACAHcyEHIAMoAgggBXMhBQsCQCAERQRAQQghBCAKQQFqIgpBEEYNAQsgC0EBaiILQYABRw0BCwsgACAGOgCHECAAIAU6AIsQIAAgCDoAjxAgACAHQRB2OgCBECAAIAdBGHY6AIAQIAAgBkEIdjoAhhAgACAGQRB2OgCFECAAIAZBGHY6AIQQIAAgBUEIdjoAihAgACAFQRB2OgCJECAAIAVBGHY6AIgQIAAgCEEIdjoAjhAgACAIQRB2OgCNECAAIAhBGHY6AIwQIAAgB0EIdCAHQYD+A3FBCHZyOwCCEEEAIQMgAiAJSg0ACwsgAkEPcUUNACAAQQE2ArAQCwu3BwEFfyAAEIAJIAEEQCAAQbQQaiAAQZAQahD6CCAAIAAtAJEQIAAtAIEQczoAkRAgACAALQCSECAALQCCEHM6AJIQIAAgAC0AkxAgAC0AgxBzOgCTECAAIAAtAJQQIAAtAIQQczoAlBAgACAALQCVECAALQCFEHM6AJUQIAAgAC0AlhAgAC0AhhBzOgCWECAALQCQECECIAAtAIAQIQMgACAALQCXECAALQCHEHM6AJcQIAAgAC0AmBAgAC0AiBBzOgCYECAAIAAtAJkQIAAtAIkQczoAmRAgACAALQCaECAALQCKEHM6AJoQIAAgAC0AmxAgAC0AixBzOgCbECAAIAAtAJwQIAAtAIwQczoAnBAgACAALQCdECAALQCNEHM6AJ0QIAAgAC0AnhAgAC0AjhBzOgCeECAAIAAtAJ8QIAAtAI8QczoAnxAgASACIANzOgAAIABBADoAkBAgAEEAOgCAECABIAAtAJEQOgABIABBADoAkRAgAEEAOgCBECABIAAtAJIQOgACIABBADoAkhAgAEEAOgCCECABIAAtAJMQOgADIABBADoAkxAgAEEAOgCDECABIAAtAJQQOgAEIABBADoAlBAgAEEAOgCEECABIAAtAJUQOgAFIABBADoAlRAgAEEAOgCFECABIAAtAJYQOgAGIABBADoAlhAgAEEAOgCGECABIAAtAJcQOgAHIABBADoAlxAgAEEAOgCHECABIAAtAJgQOgAIIABBADoAmBAgAEEAOgCIECABIAAtAJkQOgAJIABBADoAmRAgAEEAOgCJECABIAAtAJoQOgAKIABBADoAmhAgAEEAOgCKECABIAAtAJsQOgALIABBADoAmxAgAEEAOgCLECABIAAtAJwQOgAMIABBADoAnBAgAEEAOgCMECABIAAtAJ0QOgANIABBADoAnRAgAEEAOgCNECABIAAtAJ4QOgAOIABBADoAnhAgAEEAOgCOECABIAAtAJ8QOgAPIABBADoAnxAgAEEAOgCPEAsgAEEDNgKwECAAKAK4EEECdCIGQQRqQQBKBEAgAEHAEGohAiAAQbASaiEDA0AgAyAEQQJ0IgFqQQA2AgAgASACakEANgIAIAMgAUEEciIFakEANgIAIAIgBWpBADYCACADIAFBCHIiBWpBADYCACACIAVqQQA2AgAgAyABQQxyIgFqQQA2AgAgASACakEANgIAIAQgBkchASAEQQRqIQQgAQ0ACwsgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAKAUC/IEAQl/IAAgAC0AgBAgACgCoBAiAUEVdnM6AIAQIAAgAC0AgRAgAUENdnM6AIEQIAAgAC0AghAgAUEFdnM6AIIQIAAgAC0AhBAgACgCpBAiAkEVdnM6AIQQIAAgAC0AhRAgAkENdnM6AIUQIAAgAC0AhhAgAkEFdnM6AIYQIAAgAC0AgxAgAUEDdCACQR12cnM6AIMQIAAoAqwQIQEgACgCqBAhAyAAIAAtAIcQIAJBA3RzOgCHECAAIAAtAIgQIANBFXZzOgCIECAAIAAtAIkQIANBDXZzOgCJECAAIAAtAIoQIANBBXZzOgCKECAAIAAtAIsQIANBA3QgAUEddnJzOgCLECAAIAAtAIwQIAFBFXZzOgCMECAAIAAtAI0QIAFBDXZzOgCNECAAIAAtAI4QIAFBBXZzOgCOECAAIAAtAI8QIAFBA3RzOgCPECAAQYAQaiEJQQghAUEAIQIDQCAIIAlqLQAAIAFBAWsiAXZBAXEEQCAAIAJBBHRqIgMoAgwgBXMhBSADKAIEIAZzIQYgAygCACAHcyEHIAMoAgggBHMhBAsCQCABRQRAQQghASAIQQFqIghBEEYNAQsgAkEBaiICQYABRw0BCwsgACAGOgCHECAAIAQ6AIsQIAAgBToAjxAgACAHQRB2OgCBECAAIAdBGHY6AIAQIAAgBkEIdjoAhhAgACAGQRB2OgCFECAAIAZBGHY6AIQQIAAgBEEIdjoAihAgACAEQRB2OgCJECAAIARBGHY6AIgQIAAgBUEIdjoAjhAgACAFQRB2OgCNECAAIAVBGHY6AIwQIAAgB0EIdCAHQYD+A3FBCHZyOwCCEAvOBAEBfyMAQYACayIEJAAgBCAB/QAAEP0LBBAgBCAB/QAAAP0LBAAgBCADOgAhIAQgAjoAICAAQQFByAEQLiICNgIAIAIEQEEAIQMgBEEwakEAQagB/AsAIAQgBC0AADoAMCAEIAQoAAE2ADEgBCAE/QAABf0LADUgBCAEKQAVNwBFIAQgBC8AHTsATSAEIAQtAB86AE9BICEBA0AgBEEwaiABaiABIARqLQAAOgAAIAFBAWohASADQQFqIgNBAkcNAAsgBEEfOgBSIAQgBC0A1wFBgAFyOgDXASACIAIpAwAgBCkDMIU3AwAgAiACKQMIIAQpAziFNwMIIAIgAikDECAEKQNAhTcDECACIAIpAxggBCkDSIU3AxggAiACKQMgIAQpA1CFNwMgIAIgAikDKCAEKQNYhTcDKCACIAIpAzAgBCkDYIU3AzAgAiACKQM4IAQpA2iFNwM4IAIgAikDQCAEKQNwhTcDQCACIAIpA0ggBCkDeIU3A0ggAiACKQNQIAQpA4ABhTcDUCACIAIpA1ggBCkDiAGFNwNYIAIgAikDYCAEKQOQAYU3A2AgAiACKQNoIAQpA5gBhTcDaCACIAIpA3AgBCkDoAGFNwNwIAIgAikDeCAEKQOoAYU3A3ggAiACKQOAASAEKQOwAYU3A4ABIAIgAikDiAEgBCkDuAGFNwOIASACIAIpA5ABIAQpA8ABhTcDkAEgAiACKQOYASAEKQPIAYU3A5gBIAIgAikDoAEgBCkD0AGFNwOgASAEQYACaiQADwtB7wAQAQALqgIBAn8jAEGwAWsiAyQAIAMgAf0AABD9CwSQASADIAH9AAAA/QsEgAEgAyACOgCgASADQYABIANBgAFqQSEQswQDQCAAIARBBHRqIgIgAyAEQQJ0aigCACIBQQF2QdWq1aoFcSABQdWq1aoFcWoiAUEEdkEDcSABQQZ2QQNxazsBAiACIAFBA3EgAUECdkEDcWs7AQAgAiABQQh2QQNxIAFBCnZBA3FrOwEEIAIgAUEMdkEDcSABQQ52QQNxazsBBiACIAFBEHZBA3EgAUESdkEDcWs7AQggAiABQRR2QQNxIAFBFnZBA3FrOwEKIAIgAUEYdkEDcSABQRp2QQNxazsBDCACIAFBHHZBA3EgAUEedms7AQ4gBEEBaiIEQSBHDQALIANBsAFqJAAL/gICBn4BfyABrSIGIAApA8gBIgQgA60iB3xYBEADQEEAIQpCACEFIASnIAFHBEADQCAAIAQgBXwiBKdBeHFqIgogCikDACACIAWnajEAACAEQgOGhoU3AwAgBUIBfCIFIAEgACkDyAEiBKdrIgqtVA0ACwsgAEIANwPIASAAENgEIAIgCmohAiAAKQPIASIEIAMgCmsiA60iB3wgBloNAAsLAkAgA0UNACADrSIGQgGDIQhCACEFIANBAUcEQCAGQv7///8PgyEJA0AgACAAKQPIASAFfCIEp0F4cWoiCiAKKQMAIAIgBadqMQAAIARCA4aGhTcDACAAIAVCAYQiBCAAKQPIAXwiBqdBeHFqIgogCikDACACIASnajEAACAGQgOGhoU3AwAgBUICfCIFIAlSDQALIAApA8gBIQQLIAhQDQAgACAEIAV8IgSnQXhxaiIKIAopAwAgAiAFp2oxAAAgBEIDhoaFNwMAIAApA8gBIQQLIAAgBCAHfDcDyAELzQICBn8EfiABrSEMIAOtIQ0CQAJAA0AgCqchBCACKQPIASILIApYDQEgACAEaiACIA0gC30gCnwiC6dBeHFqKQMAIAtCA4aIPAAAIApCAXwiCiAMUg0ACyACKQPIASELIAEhBAwBCyAKQv////8PgyEMCyACIAsgDH03A8gBIAEgBGsiBQRAIAAgBGohAANAIAIQ2ARBASAFIAMgAyAFSxsiBCAEQQFNGyIGQQFxIQdBACEEIAVBAk8EQCAGQf4BcSEIA0AgACAEaiACIARBeHFqIgEpAwAgBEEDdEEwca2IPAAAIAAgBEEBciIJaiABKQMAIAlBA3RBOHGtiDwAACAEQQJqIgQgCEcNAAsLIAcEQCAAIARqIAIgBEF4cWopAwAgBEEDdEE4ca2IPAAACyACIAMgBmutNwPIASAAIAZqIQAgBSAGayIFDQALCwudAQIBfwF+IwBBEGsiAyQAIAMgAjsADiAAQdABECoiAjYCACACBEAgAkEAQdAB/AsAIAJBiAEgAUHAABCDCSACQYgBIANBDmpBAhCDCSACIAIpA8gBIgSnQXhxaiIAIAApAwBCHyAEQgOGhoU3AwAgAkIANwPIASACIAIpA4ABQoCAgICAgICAgH+FNwOAASADQRBqJAAPC0HvABABAAu2AgEKfwNAIAAgB0EEdGoiBSABIAdBCWxqIgItAAAiAzYCACAFIAMgAi0AAUEIdHIiAzYCACAFIAItAAJBEHRBgIAMcSADciIJNgIAIAVBBGoiAyACLQACQQJ2IgQ2AgAgAyACLQADQQZ0IARyIgQ2AgAgAyACLQAEQQ50QYCAD3EgBHIiCjYCACAFQQhqIgQgAi0ABEEEdiIGNgIAIAQgAi0ABUEEdCAGciIGNgIAIAQgAi0ABkEMdEGA4A9xIAZyIgs2AgAgBUEMaiIGIAItAAZBBnYiCDYCACAGIAItAAdBAnQgCHIiCDYCACACLQAIIQIgA0GAgAggCms2AgAgBUGAgAggCWs2AgAgBEGAgAggC2s2AgAgBkGAgAggAkEKdCAIcms2AgAgB0EBaiIHQcAARw0ACwvQBAEHfwNAIAAgBEEDbGoiAiABIARBBHRqIgUoAgAiAzoAACACIAMgBUEEaiIGKAIAQQZ0cjoAACACIAYoAgBBAnYiAzoAASACIAVBCGoiBigCAEEEdCADcjoAASACIAYoAgBBBHYiAzoAAiACIAUoAgxBAnQgA3I6AAIgBEEBaiIEQcAARw0ACyABQYAIaiEHIABBwAFqIQhBACEEA0AgCCAEQQNsaiICIAcgBEEEdGoiBSgCACIDOgAAIAIgAyAFQQRqIgYoAgBBBnRyOgAAIAIgBigCAEECdiIDOgABIAIgBUEIaiIGKAIAQQR0IANyOgABIAIgBigCAEEEdiIDOgACIAIgBSgCDEECdCADcjoAAiAEQQFqIgRBwABHDQALIAFBgBBqIQcgAEGAA2ohCEEAIQQDQCAIIARBA2xqIgIgByAEQQR0aiIFKAIAIgM6AAAgAiADIAVBBGoiBigCAEEGdHI6AAAgAiAGKAIAQQJ2IgM6AAEgAiAFQQhqIgYoAgBBBHQgA3I6AAEgAiAGKAIAQQR2IgM6AAIgAiAFKAIMQQJ0IANyOgACIARBAWoiBEHAAEcNAAsgAUGAGGohASAAQcAEaiEAQQAhBANAIAAgBEEDbGoiAiABIARBBHRqIgUoAgAiAzoAACACIAMgBUEEaiIGKAIAQQZ0cjoAACACIAYoAgBBAnYiAzoAASACIAVBCGoiBigCAEEEdCADcjoAASACIAYoAgBBBHYiAzoAAiACIAUoAgxBAnQgA3I6AAIgBEEBaiIEQcAARw0ACwumAgIFfwF+IwBBkAFrIgMkAEHQARAqIgIEQCACQQBB0AH8CwAgAkGIASABQSAQgwkgAiACKQPIASIHp0F4cWoiASABKQMAQh8gB0IDhoaFNwMAIAJCADcDyAEgAiACKQOAAUKAgICAgICAgIB/hTcDgAEgA0GIASACQYgBEIQJIAMpAwAhByAAQQBBgAj8CwBB2QEhBEEIIQEDQCABQYgBTwRAIANBiAEgAkGIARCECUEAIQELIAEgA2ohBSABQQFqIgYhASAEIAUtAAAiBUkNACAAIARBAnRqIAAgBUECdGoiASgCADYCACABQQEgB6dBAXRBAnFrNgIAIAdCAYghByAGIQEgBEEBaiIEQYACRw0ACyACECsgA0GQAWokAA8LQe8AEAEAC+kCAQV/AkADQEEBIQMgACACQQJ0aiIEKAIAIgEgASABQR91cUEBdGtBsv8HTg0BIAQoAgQiASABIAFBH3VxQQF0a0Gx/wdKDQEgAkECaiICQYACRw0ACyAAQYAIaiEFQQAhAgNAIAUgAkECdGoiBCgCACIBIAEgAUEfdXFBAXRrQbL/B04NASAEKAIEIgEgASABQR91cUEBdGtBsf8HSg0BIAJBAmoiAkGAAkcNAAsgAEGAEGohBUEAIQIDQCAFIAJBAnRqIgQoAgAiASABIAFBH3VxQQF0a0Gy/wdODQEgBCgCBCIBIAEgAUEfdXFBAXRrQbH/B0oNASACQQJqIgJBgAJHDQALIABBgBhqIQBBACECA0BBASEDIAAgAkECdGoiBCgCACIBIAEgAUEfdXFBAXRrQbL/B04NASAEKAIEIgEgASABQR91cUEBdGtBsf8HSg0BQQAhAyACQQJqIgJBgAJHDQALCyADC9IEAgR/AX4DQCAAIARBAnQiA2ogAiADajQCACABIANqNAIAfiIHQoCAgICQgIjAA35CIIdC/7+AfH4gB3xCIIg+AgAgACADQQRyIgNqIAIgA2o0AgAgASADajQCAH4iB0KAgICAkICIwAN+QiCHQv+/gHx+IAd8QiCIPgIAIARBAmoiBEGAAkcNAAsgAkGACGohBSAAQYAIaiEGQQAhBANAIAYgBEECdCIDaiADIAVqNAIAIAEgA2o0AgB+IgdCgICAgJCAiMADfkIgh0L/v4B8fiAHfEIgiD4CACAGIANBBHIiA2ogAyAFajQCACABIANqNAIAfiIHQoCAgICQgIjAA35CIIdC/7+AfH4gB3xCIIg+AgAgBEECaiIEQYACRw0ACyACQYAQaiEFIABBgBBqIQZBACEEA0AgBiAEQQJ0IgNqIAMgBWo0AgAgASADajQCAH4iB0KAgICAkICIwAN+QiCHQv+/gHx+IAd8QiCIPgIAIAYgA0EEciIDaiADIAVqNAIAIAEgA2o0AgB+IgdCgICAgJCAiMADfkIgh0L/v4B8fiAHfEIgiD4CACAEQQJqIgRBgAJHDQALIAJBgBhqIQIgAEGAGGohAEEAIQQDQCAAIARBAnQiA2ogAiADajQCACABIANqNAIAfiIHQoCAgICQgIjAA35CIIdC/7+AfH4gB3xCIIg+AgAgACADQQRyIgNqIAIgA2o0AgAgASADajQCAH4iB0KAgICAkICIwAN+QiCHQv+/gHx+IAd8QiCIPgIAIARBAmoiBEGAAkcNAAsLiAMBBX8DQCAAIARBAnQiA2ogASADaigCACACIANqKAIAazYCACAAIANBBHIiA2ogASADaigCACACIANqKAIAazYCACAEQQJqIgRBgAJHDQALIAJBgAhqIQUgAUGACGohBiAAQYAIaiEHQQAhBANAIAcgBEECdCIDaiADIAZqKAIAIAMgBWooAgBrNgIAIAcgA0EEciIDaiADIAZqKAIAIAMgBWooAgBrNgIAIARBAmoiBEGAAkcNAAsgAkGAEGohBSABQYAQaiEGIABBgBBqIQdBACEEA0AgByAEQQJ0IgNqIAMgBmooAgAgAyAFaigCAGs2AgAgByADQQRyIgNqIAMgBmooAgAgAyAFaigCAGs2AgAgBEECaiIEQYACRw0ACyACQYAYaiECIAFBgBhqIQEgAEGAGGohAEEAIQQDQCAAIARBAnQiA2ogASADaigCACACIANqKAIAazYCACAAIANBBHIiA2ogASADaigCACACIANqKAIAazYCACAEQQJqIgRBgAJHDQALC9kCAQV/AkADQEEBIQQgACADQQJ0aiIFKAIAIgIgAiACQR91cUEBdGsgAU4NASAFKAIEIgIgAiACQR91cUEBdGsgAU4NASADQQJqIgNBgAJHDQALIABBgAhqIQZBACEDA0AgBiADQQJ0aiIFKAIAIgIgAiACQR91cUEBdGsgAU4NASAFKAIEIgIgAiACQR91cUEBdGsgAU4NASADQQJqIgNBgAJHDQALIABBgBBqIQZBACEDA0AgBiADQQJ0aiIFKAIAIgIgAiACQR91cUEBdGsgAU4NASAFKAIEIgIgAiACQR91cUEBdGsgAU4NASADQQJqIgNBgAJHDQALIABBgBhqIQBBACEDA0BBASEEIAAgA0ECdGoiBSgCACICIAIgAkEfdXFBAXRrIAFODQEgBSgCBCICIAIgAkEfdXFBAXRrIAFODQFBACEEIANBAmoiA0GAAkcNAAsLIAQL5gMCCH8BfiMAQdAGayIGJAAgBiACOwAAQdABECoiBARAIARBAEHQAfwLACAEQagBIAFBIBCDCSAEQagBIAZBAhCDCSAEIAQpA8gBIgunQXhxaiICIAIpAwBCHyALQgOGhoU3AwAgBEIANwPIASAEIAQpA6ABQoCAgICAgICAgH+FNwOgASAGQcgGIARBqAEQhAlBAyEBA0AgASECIAMgBmoiAy8AACADLQACQRB0QYCA/ANxciIDQYDA/wNNBEAgACAFQQJ0aiADNgIAIAVBAWohBQsgAkHFBk0EQCACQQNqIQEgAiEDIAVBgAJJDQELCyAFQf8BTQRAQcgGIQcDQCAHQQNwIgMEQCAHIANrIQFBACECA0AgAiAGaiAGIAEgAmpqLQAAOgAAIAJBAWoiAiADRw0ACwsgAyAGckGoASAEQagBEIQJQYACIAVrIQkgA0GoAXIhByAAIAVBAnRqIQpBACEIQQMhAUEAIQMDQCABIQIgBiAIaiIBLwAAIAEtAAJBEHRBgID8A3FyIgFBgMD/A00EQCAKIANBAnRqIAE2AgAgA0EBaiEDCyAHIAJBA2oiAU8EQCACIQggAyAJSQ0BCwsgAyAFaiIFQYACSQ0ACwsgBBArIAZB0AZqJAAPC0HvABABAAuoAgEQfwNAIAAgBEEFdGoiAyABIARBA2xqIgItAABBB3EiBTYCACADQQRqIgYgAi0AAEEDdkEHcSIHNgIAIANBCGoiCCACLQABQQJ0QQRxIAItAABBBnZyIgk2AgAgA0EMaiIKIAItAAFBAXZBB3EiCzYCACADQRBqIgwgAi0AAUEEdkEHcSINNgIAIANBFGoiDiACLQACQQF0QQZxIAItAAFBB3ZyIg82AgAgA0EYaiIQIAItAAJBAnZBB3EiETYCACACLQACIQIgBkECIAdrNgIAIANBAiAFazYCACAIQQIgCWs2AgAgCkECIAtrNgIAIAxBAiANazYCACAOQQIgD2s2AgAgEEECIBFrNgIAIANBAiACQQV2azYCHCAEQQFqIgRBIEcNAAsLggQBEn8DQCAAIAlBBXRqIgMgASAJQQ1saiICLQAAIgc2AgAgAyAHIAItAAFBCHRBgD5xciIMNgIAIANBBGoiByACLQABQQV2IgQ2AgAgByACLQACQQN0IARyIgQ2AgAgByACLQADQQt0QYAwcSAEciINNgIAIANBCGoiCiACLQADQQJ2IgQ2AgAgCiACLQAEQQZ0QcA/cSAEciIONgIAIANBDGoiBCACLQAEQQd2IgY2AgAgBCACLQAFQQF0IAZyIgY2AgAgBCACLQAGQQl0QYA8cSAGciIPNgIAIANBEGoiBiACLQAGQQR2IgU2AgAgBiACLQAHQQR0IAVyIgU2AgAgBiACLQAIQQx0QYAgcSAFciIQNgIAIANBFGoiCyACLQAIQQF2IgU2AgAgCyACLQAJQQd0QYA/cSAFciIRNgIAIANBGGoiBSACLQAJQQZ2Igg2AgAgBSACLQAKQQJ0IAhyIgg2AgAgBSACLQALQQp0QYA4cSAIciIINgIAIANBHGoiEiACLQALQQN2IhM2AgAgAi0ADCECIAdBgCAgDWs2AgAgA0GAICAMazYCACAKQYAgIA5rNgIAIARBgCAgD2s2AgAgBkGAICAQazYCACALQYAgIBFrNgIAIAVBgCAgCGs2AgAgEkGAICACQQV0IBNyazYCACAJQQFqIglBIEcNAAsLymIBIX4gACkAOCIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEISIgACkAMCIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEISEgACkAKCIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEIR8gACkAICIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEIQcgACkAGCIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEISMgACkAECIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEISAgACkACCIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEIR4gACkAACIOQjiGIA5CgP4Dg0IohoQgDkKAgPwHg0IYhiAOQoCAgPgPg0IIhoSEIA5CCIhCgICA+A+DIA5CGIhCgID8B4OEIA5CKIhCgP4DgyAOQjiIhISEIQ4gAkGAAU8EQANAIAcgASkAACILQjiGIAtCgP4Dg0IohoQgC0KAgPwHg0IYhiALQoCAgPgPg0IIhoSEIAtCCIhCgICA+A+DIAtCGIhCgID8B4OEIAtCKIhCgP4DgyALQjiIhISEIhMgB0IyiSAHQi6JhSAHQheJhSAifCAhIAdCf4WDIAcgH4OEfHxCotyiuY3zi8XCAHwiAyAeICCFIA6DIB4gIIOFIA5CJIkgDkIeiYUgDkIZiYV8fCILQiSJIAtCHomFIAtCGYmFIAsgDiAehYMgDiAeg4V8ICEgAyAjfCIMIAeDIB8gDEJ/hYOEfCAMQjKJIAxCLomFIAxCF4mFfCABKQAIIgNCOIYgA0KA/gODQiiGhCADQoCA/AeDQhiGIANCgICA+A+DQgiGhIQgA0IIiEKAgID4D4MgA0IYiEKAgPwHg4QgA0IoiEKA/gODIANCOIiEhIQiFXxCzcu9n5KS0ZvxAHwiBHwiA0IkiSADQh6JhSADQhmJhSADIAsgDoWDIAsgDoOFfCAfIAQgIHwiBiAMgyAHIAZCf4WDhHwgBkIyiSAGQi6JhSAGQheJhXwgASkAECIEQjiGIARCgP4Dg0IohoQgBEKAgPwHg0IYhiAEQoCAgPgPg0IIhoSEIARCCIhCgICA+A+DIARCGIhCgID8B4OEIARCKIhCgP4DgyAEQjiIhISEIhZ8QtGJy52BhsGfygB9IgV8IgRCJIkgBEIeiYUgBEIZiYUgBCADIAuFgyADIAuDhXwgByAFIB58IgggBoMgDCAIQn+Fg4R8IAhCMokgCEIuiYUgCEIXiYV8IAEpABgiBUI4hiAFQoD+A4NCKIaEIAVCgID8B4NCGIYgBUKAgID4D4NCCIaEhCAFQgiIQoCAgPgPgyAFQhiIQoCA/AeDhCAFQiiIQoD+A4MgBUI4iISEhCIXfELEyNjzp4uJpRZ9IhB8IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgDCAOIBB8IhAgCIMgBiAQQn+Fg4R8IBBCMokgEEIuiYUgEEIXiYV8IAEpACAiDEI4hiAMQoD+A4NCKIaEIAxCgID8B4NCGIYgDEKAgID4D4NCCIaEhCAMQgiIQoCAgPgPgyAMQhiIQoCA/AeDhCAMQiiIQoD+A4MgDEI4iISEhCIYfEK46qKav8uwqzl8Ig18IgxCJIkgDEIeiYUgDEIZiYUgDCAEIAWFgyAEIAWDhXwgBiALIA18Ig0gEIMgCCANQn+Fg4R8IA1CMokgDUIuiYUgDUIXiYV8IAEpACgiC0I4hiALQoD+A4NCKIaEIAtCgID8B4NCGIYgC0KAgID4D4NCCIaEhCALQgiIQoCAgPgPgyALQhiIQoCA/AeDhCALQiiIQoD+A4MgC0I4iISEhCIUfEKZoJewm77E+NkAfCIGfCILQiSJIAtCHomFIAtCGYmFIAsgBSAMhYMgBSAMg4V8IAggAyAGfCIGIA2DIBAgBkJ/hYOEfCAGQjKJIAZCLomFIAZCF4mFfCABKQAwIgNCOIYgA0KA/gODQiiGhCADQoCA/AeDQhiGIANCgICA+A+DQgiGhIQgA0IIiEKAgID4D4MgA0IYiEKAgPwHg4QgA0IoiEKA/gODIANCOIiEhIQiGXxC5eCah7Wrn+DtAH0iCHwiA0IkiSADQh6JhSADQhmJhSADIAsgDIWDIAsgDIOFfCAQIAQgCHwiCCAGgyANIAhCf4WDhHwgCEIyiSAIQi6JhSAIQheJhXwgASkAOCIEQjiGIARCgP4Dg0IohoQgBEKAgPwHg0IYhiAEQoCAgPgPg0IIhoSEIARCCIhCgICA+A+DIARCGIhCgID8B4OEIARCKIhCgP4DgyAEQjiIhISEIht8Quj9yayipejx1AB9IhB8IgRCJIkgBEIeiYUgBEIZiYUgBCADIAuFgyADIAuDhXwgDSAFIBB8IhAgCIMgBiAQQn+Fg4R8IBBCMokgEEIuiYUgEEIXiYV8IAEpAEAiBUI4hiAFQoD+A4NCKIaEIAVCgID8B4NCGIYgBUKAgID4D4NCCIaEhCAFQgiIQoCAgPgPgyAFQhiIQoCA/AeDhCAFQiiIQoD+A4MgBUI4iISEhCIcfEK++/Pn9ayV/Cd9Ig18IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgBiAMIA18Ig0gEIMgCCANQn+Fg4R8IA1CMokgDUIuiYUgDUIXiYV8IAEpAEgiDEI4hiAMQoD+A4NCKIaEIAxCgID8B4NCGIYgDEKAgID4D4NCCIaEhCAMQgiIQoCAgPgPgyAMQhiIQoCA/AeDhCAMQiiIQoD+A4MgDEI4iISEhCIafEK+38GrlODWwRJ8IgZ8IgxCJIkgDEIeiYUgDEIZiYUgDCAEIAWFgyAEIAWDhXwgCCAGIAt8IgYgDYMgECAGQn+Fg4R8IAZCMokgBkIuiYUgBkIXiYV8IAEpAFAiC0I4hiALQoD+A4NCKIaEIAtCgID8B4NCGIYgC0KAgID4D4NCCIaEhCALQgiIQoCAgPgPgyALQhiIQoCA/AeDhCALQiiIQoD+A4MgC0I4iISEhCIJfEKM5ZL35LfhmCR8Igh8IgtCJIkgC0IeiYUgC0IZiYUgCyAFIAyFgyAFIAyDhXwgECADIAh8IgggBoMgDSAIQn+Fg4R8IAhCMokgCEIuiYUgCEIXiYV8IAEpAFgiA0I4hiADQoD+A4NCKIaEIANCgID8B4NCGIYgA0KAgID4D4NCCIaEhCADQgiIQoCAgPgPgyADQhiIQoCA/AeDhCADQiiIQoD+A4MgA0I4iISEhCIKfELi6f6vvbifhtUAfCIQfCIDQiSJIANCHomFIANCGYmFIAMgCyAMhYMgCyAMg4V8IA0gBCAQfCIQIAiDIAYgEEJ/hYOEfCAQQjKJIBBCLomFIBBCF4mFfCABKQBgIgRCOIYgBEKA/gODQiiGhCAEQoCA/AeDQhiGIARCgICA+A+DQgiGhIQgBEIIiEKAgID4D4MgBEIYiEKAgPwHg4QgBEIoiEKA/gODIARCOIiEhIQiB3xC75Luk8+ul9/yAHwiDXwiBEIkiSAEQh6JhSAEQhmJhSAEIAMgC4WDIAMgC4OFfCAGIAUgDXwiDSAQgyAIIA1Cf4WDhHwgDUIyiSANQi6JhSANQheJhXwgASkAaCIFQjiGIAVCgP4Dg0IohoQgBUKAgPwHg0IYhiAFQoCAgPgPg0IIhoSEIAVCCIhCgICA+A+DIAVCGIhCgID8B4OEIAVCKIhCgP4DgyAFQjiIhISEIg98Qs/SpaecwNOQ/wB9IgZ8IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgCCAGIAx8IhEgDYMgECARQn+Fg4R8IBFCMokgEUIuiYUgEUIXiYV8IAEpAHAiDEI4hiAMQoD+A4NCKIaEIAxCgID8B4NCGIYgDEKAgID4D4NCCIaEhCAMQgiIQoCAgPgPgyAMQhiIQoCA/AeDhCAMQiiIQoD+A4MgDEI4iISEhCIMfELL2+PRjav+keQAfSIIfCIGQiSJIAZCHomFIAZCGYmFIAYgBCAFhYMgBCAFg4V8IBAgCCALfCISIBGDIA0gEkJ/hYOEfCASQjKJIBJCLomFIBJCF4mFfCABKQB4IgtCOIYgC0KA/gODQiiGhCALQoCA/AeDQhiGIAtCgICA+A+DQgiGhIQgC0IIiEKAgID4D4MgC0IYiEKAgPwHg4QgC0IoiEKA/gODIAtCOIiEhIQiC3xC7LLbhLPRg7I+fSIdfCIIQiSJIAhCHomFIAhCGYmFIAggBSAGhYMgBSAGg4V8IA0gFUI/iSAVQjiJhSAVQgeIhSATfCAafCAMQi2JIAxCA4mFIAxCBoiFfCIQfCADIB18IhMgEoMgESATQn+Fg4R8IBNCMokgE0IuiYUgE0IXiYV8Qq7quojmx6WyG30iHXwiA0IkiSADQh6JhSADQhmJhSADIAYgCIWDIAYgCIOFfCARIBZCP4kgFkI4iYUgFkIHiIUgFXwgCXwgC0ItiSALQgOJhSALQgaIhXwiDXwgBCAdfCIVIBODIBIgFUJ/hYOEfCAVQjKJIBVCLomFIBVCF4mFfEKdtMO9nI/uoBB9Ih18IgRCJIkgBEIeiYUgBEIZiYUgBCADIAiFgyADIAiDhXwgEiAXQj+JIBdCOImFIBdCB4iFIBZ8IAp8IBBCLYkgEEIDiYUgEEIGiIV8IhF8IAUgHXwiFiAVgyATIBZCf4WDhHwgFkIyiSAWQi6JhSAWQheJhXxCtauz3Oi45+APfCIdfCIFQiSJIAVCHomFIAVCGYmFIAUgAyAEhYMgAyAEg4V8IBMgGEI/iSAYQjiJhSAYQgeIhSAXfCAHfCANQi2JIA1CA4mFIA1CBoiFfCISfCAGIB18IhcgFoMgFSAXQn+Fg4R8IBdCMokgF0IuiYUgF0IXiYV8QuW4sr3HuaiGJHwiHXwiBkIkiSAGQh6JhSAGQhmJhSAGIAQgBYWDIAQgBYOFfCAVIBRCP4kgFEI4iYUgFEIHiIUgGHwgD3wgEUItiSARQgOJhSARQgaIhXwiE3wgCCAdfCIYIBeDIBYgGEJ/hYOEfCAYQjKJIBhCLomFIBhCF4mFfEL1hKzJ9Y3L9C18Ih18IghCJIkgCEIeiYUgCEIZiYUgCCAFIAaFgyAFIAaDhXwgFiAZQj+JIBlCOImFIBlCB4iFIBR8IAx8IBJCLYkgEkIDiYUgEkIGiIV8IhV8IAMgHXwiFCAYgyAXIBRCf4WDhHwgFEIyiSAUQi6JhSAUQheJhXxCg8mb9aaVobrKAHwiHXwiA0IkiSADQh6JhSADQhmJhSADIAYgCIWDIAYgCIOFfCAbQj+JIBtCOImFIBtCB4iFIBl8IAt8IBNCLYkgE0IDiYUgE0IGiIV8IhYgF3wgBCAdfCIZIBSDIBggGUJ/hYOEfCAZQjKJIBlCLomFIBlCF4mFfELU94fqy7uq2NwAfCIdfCIEQiSJIARCHomFIARCGYmFIAQgAyAIhYMgAyAIg4V8IBxCP4kgHEI4iYUgHEIHiIUgG3wgEHwgFUItiSAVQgOJhSAVQgaIhXwiFyAYfCAFIB18IhsgGYMgFCAbQn+Fg4R8IBtCMokgG0IuiYUgG0IXiYV8QrWnxZiom+L89gB8Ih18IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgGkI/iSAaQjiJhSAaQgeIhSAcfCANfCAWQi2JIBZCA4mFIBZCBoiFfCIYIBR8IAYgHXwiHCAbgyAZIBxCf4WDhHwgHEIyiSAcQi6JhSAcQheJhXxC1cDkjNHV6+DnAH0iHXwiBkIkiSAGQh6JhSAGQhmJhSAGIAQgBYWDIAQgBYOFfCAJQj+JIAlCOImFIAlCB4iFIBp8IBF8IBdCLYkgF0IDiYUgF0IGiIV8IhQgGXwgCCAdfCIaIByDIBsgGkJ/hYOEfCAaQjKJIBpCLomFIBpCF4mFfELwm6+SrbKO59cAfSIdfCIIQiSJIAhCHomFIAhCGYmFIAggBSAGhYMgBSAGg4V8IApCP4kgCkI4iYUgCkIHiIUgCXwgEnwgGEItiSAYQgOJhSAYQgaIhXwiGSAbfCADIB18IgkgGoMgHCAJQn+Fg4R8IAlCMokgCUIuiYUgCUIXiYV8QsG9k7j2hrb+zwB9Ih18IgNCJIkgA0IeiYUgA0IZiYUgAyAGIAiFgyAGIAiDhXwgB0I/iSAHQjiJhSAHQgeIhSAKfCATfCAUQi2JIBRCA4mFIBRCBoiFfCIbIBx8IAQgHXwiCiAJgyAaIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxCnOLDiISHoNPAAH0iHXwiBEIkiSAEQh6JhSAEQhmJhSAEIAMgCIWDIAMgCIOFfCAPQj+JIA9COImFIA9CB4iFIAd8IBV8IBlCLYkgGUIDiYUgGUIGiIV8IhwgGnwgBSAdfCIHIAqDIAkgB0J/hYOEfCAHQjKJIAdCLomFIAdCF4mFfEK+4N2SzIH9jzl9Ih18IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgDEI/iSAMQjiJhSAMQgeIhSAPfCAWfCAbQi2JIBtCA4mFIBtCBoiFfCIaIAl8IAYgHXwiCSAHgyAKIAlCf4WDhHwgCUIyiSAJQi6JhSAJQheJhXxC27HV54bXm6wqfSIPfCIGQiSJIAZCHomFIAZCGYmFIAYgBCAFhYMgBCAFg4V8IAtCP4kgC0I4iYUgC0IHiIUgDHwgF3wgHEItiSAcQgOJhSAcQgaIhXwiDCAKfCAIIA98IgogCYMgByAKQn+Fg4R8IApCMokgCkIuiYUgCkIXiYV8Qu+EjoCe6pjlBnwiD3wiCEIkiSAIQh6JhSAIQhmJhSAIIAUgBoWDIAUgBoOFfCAQQj+JIBBCOImFIBBCB4iFIAt8IBh8IBpCLYkgGkIDiYUgGkIGiIV8IgsgB3wgAyAPfCIHIAqDIAkgB0J/hYOEfCAHQjKJIAdCLomFIAdCF4mFfELw3LnQ8KzKlBR8Ig98IgNCJIkgA0IeiYUgA0IZiYUgAyAGIAiFgyAGIAiDhXwgDUI/iSANQjiJhSANQgeIhSAQfCAUfCAMQi2JIAxCA4mFIAxCBoiFfCIQIAl8IAQgD3wiCSAHgyAKIAlCf4WDhHwgCUIyiSAJQi6JhSAJQheJhXxC/N/IttTQwtsnfCIPfCIEQiSJIARCHomFIARCGYmFIAQgAyAIhYMgAyAIg4V8IBFCP4kgEUI4iYUgEUIHiIUgDXwgGXwgC0ItiSALQgOJhSALQgaIhXwiDSAKfCAFIA98IgogCYMgByAKQn+Fg4R8IApCMokgCkIuiYUgCkIXiYV8QqaSm+GFp8iNLnwiD3wiBUIkiSAFQh6JhSAFQhmJhSAFIAMgBIWDIAMgBIOFfCASQj+JIBJCOImFIBJCB4iFIBF8IBt8IBBCLYkgEEIDiYUgEEIGiIV8IhEgB3wgBiAPfCIHIAqDIAkgB0J/hYOEfCAHQjKJIAdCLomFIAdCF4mFfELt1ZDWxb+bls0AfCIPfCIGQiSJIAZCHomFIAZCGYmFIAYgBCAFhYMgBCAFg4V8IBNCP4kgE0I4iYUgE0IHiIUgEnwgHHwgDUItiSANQgOJhSANQgaIhXwiEiAJfCAIIA98IgkgB4MgCiAJQn+Fg4R8IAlCMokgCUIuiYUgCUIXiYV8Qt/n1uy5ooOc0wB8Ig98IghCJIkgCEIeiYUgCEIZiYUgCCAFIAaFgyAFIAaDhXwgFUI/iSAVQjiJhSAVQgeIhSATfCAafCARQi2JIBFCA4mFIBFCBoiFfCITIAp8IAMgD3wiCiAJgyAHIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxC3se93cjqnIXlAHwiD3wiA0IkiSADQh6JhSADQhmJhSADIAYgCIWDIAYgCIOFfCAWQj+JIBZCOImFIBZCB4iFIBV8IAx8IBJCLYkgEkIDiYUgEkIGiIV8IhUgB3wgBCAPfCIHIAqDIAkgB0J/hYOEfCAHQjKJIAdCLomFIAdCF4mFfEKo5d7js9eCtfYAfCIPfCIEQiSJIARCHomFIARCGYmFIAQgAyAIhYMgAyAIg4V8IBdCP4kgF0I4iYUgF0IHiIUgFnwgC3wgE0ItiSATQgOJhSATQgaIhXwiFiAJfCAFIA98IgkgB4MgCiAJQn+Fg4R8IAlCMokgCUIuiYUgCUIXiYV8QpqiycCb2s2e/gB9Ig98IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgGEI/iSAYQjiJhSAYQgeIhSAXfCAQfCAVQi2JIBVCA4mFIBVCBoiFfCIXIAp8IAYgD3wiCiAJgyAHIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxCxZX3267v9MbtAH0iD3wiBkIkiSAGQh6JhSAGQhmJhSAGIAQgBYWDIAQgBYOFfCAUQj+JIBRCOImFIBRCB4iFIBh8IA18IBZCLYkgFkIDiYUgFkIGiIV8IhggB3wgCCAPfCIHIAqDIAkgB0J/hYOEfCAHQjKJIAdCLomFIAdCF4mFfEKc+buY6+uFoN0AfSIPfCIIQiSJIAhCHomFIAhCGYmFIAggBSAGhYMgBSAGg4V8IBlCP4kgGUI4iYUgGUIHiIUgFHwgEXwgF0ItiSAXQgOJhSAXQgaIhXwiFCAJfCADIA98IgkgB4MgCiAJQn+Fg4R8IAlCMokgCUIuiYUgCUIXiYV8Qv+f953Etuby1wB9Ig98IgNCJIkgA0IeiYUgA0IZiYUgAyAGIAiFgyAGIAiDhXwgG0I/iSAbQjiJhSAbQgeIhSAZfCASfCAYQi2JIBhCA4mFIBhCBoiFfCIZIAp8IAQgD3wiCiAJgyAHIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxC79Cd+PKRndo9fSIPfCIEQiSJIARCHomFIARCGYmFIAQgAyAIhYMgAyAIg4V8IBxCP4kgHEI4iYUgHEIHiIUgG3wgE3wgFEItiSAUQgOJhSAUQgaIhXwiGyAHfCAFIA98IgcgCoMgCSAHQn+Fg4R8IAdCMokgB0IuiYUgB0IXiYV8QtCDrc3Py+vJOH0iD3wiBUIkiSAFQh6JhSAFQhmJhSAFIAMgBIWDIAMgBIOFfCAaQj+JIBpCOImFIBpCB4iFIBx8IBV8IBlCLYkgGUIDiYUgGUIGiIV8IhwgCXwgBiAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfELo28LI4vzFti59Ig98IgZCJIkgBkIeiYUgBkIZiYUgBiAEIAWFgyAEIAWDhXwgDEI/iSAMQjiJhSAMQgeIhSAafCAWfCAbQi2JIBtCA4mFIBtCBoiFfCIaIAp8IAggD3wiCiAJgyAHIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxC8K3p1Lq7vrMpfSIPfCIIQiSJIAhCHomFIAhCGYmFIAggBSAGhYMgBSAGg4V8IAtCP4kgC0I4iYUgC0IHiIUgDHwgF3wgHEItiSAcQgOJhSAcQgaIhXwiDCAHfCADIA98IgcgCoMgCSAHQn+Fg4R8IAdCMokgB0IuiYUgB0IXiYV8Qta/u8Sqz/L4C30iD3wiA0IkiSADQh6JhSADQhmJhSADIAYgCIWDIAYgCIOFfCAQQj+JIBBCOImFIBBCB4iFIAt8IBh8IBpCLYkgGkIDiYUgGkIGiIV8IgsgCXwgBCAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfEK4o++Vg46otRB8Ig98IgRCJIkgBEIeiYUgBEIZiYUgBCADIAiFgyADIAiDhXwgDUI/iSANQjiJhSANQgeIhSAQfCAUfCAMQi2JIAxCA4mFIAxCBoiFfCIQIAp8IAUgD3wiCiAJgyAHIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxCyKHLxuuisNIZfCIPfCIFQiSJIAVCHomFIAVCGYmFIAUgAyAEhYMgAyAEg4V8IBFCP4kgEUI4iYUgEUIHiIUgDXwgGXwgC0ItiSALQgOJhSALQgaIhXwiDSAHfCAGIA98IgcgCoMgCSAHQn+Fg4R8IAdCMokgB0IuiYUgB0IXiYV8QtPWhoqFgdubHnwiD3wiBkIkiSAGQh6JhSAGQhmJhSAGIAQgBYWDIAQgBYOFfCASQj+JIBJCOImFIBJCB4iFIBF8IBt8IBBCLYkgEEIDiYUgEEIGiIV8IhEgCXwgCCAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfEKZ17v8zemdpCd8Ig98IghCJIkgCEIeiYUgCEIZiYUgCCAFIAaFgyAFIAaDhXwgE0I/iSATQjiJhSATQgeIhSASfCAcfCANQi2JIA1CA4mFIA1CBoiFfCISIAp8IAMgD3wiCiAJgyAHIApCf4WDhHwgCkIyiSAKQi6JhSAKQheJhXxCqJHtjN6Wr9g0fCIPfCIDQiSJIANCHomFIANCGYmFIAMgBiAIhYMgBiAIg4V8IBVCP4kgFUI4iYUgFUIHiIUgE3wgGnwgEUItiSARQgOJhSARQgaIhXwiEyAHfCAEIA98IgcgCoMgCSAHQn+Fg4R8IAdCMokgB0IuiYUgB0IXiYV8QuO0pa68loOOOXwiD3wiBEIkiSAEQh6JhSAEQhmJhSAEIAMgCIWDIAMgCIOFfCAWQj+JIBZCOImFIBZCB4iFIBV8IAx8IBJCLYkgEkIDiYUgEkIGiIV8IhUgCXwgBSAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfELLlYaarsmq7M4AfCIPfCIFQiSJIAVCHomFIAVCGYmFIAUgAyAEhYMgAyAEg4V8IBdCP4kgF0I4iYUgF0IHiIUgFnwgC3wgE0ItiSATQgOJhSATQgaIhXwiFiAKfCAGIA98IgogCYMgByAKQn+Fg4R8IApCMokgCkIuiYUgCkIXiYV8QvPGj7v3ybLO2wB8Ig98IgZCJIkgBkIeiYUgBkIZiYUgBiAEIAWFgyAEIAWDhXwgGEI/iSAYQjiJhSAYQgeIhSAXfCAQfCAVQi2JIBVCA4mFIBVCBoiFfCIXIAd8IAggD3wiByAKgyAJIAdCf4WDhHwgB0IyiSAHQi6JhSAHQheJhXxCo/HKtb3+m5foAHwiD3wiCEIkiSAIQh6JhSAIQhmJhSAIIAUgBoWDIAUgBoOFfCAUQj+JIBRCOImFIBRCB4iFIBh8IA18IBZCLYkgFkIDiYUgFkIGiIV8IhggCXwgAyAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfEL85b7v5d3gx/QAfCIPfCIDQiSJIANCHomFIANCGYmFIAMgBiAIhYMgBiAIg4V8IBlCP4kgGUI4iYUgGUIHiIUgFHwgEXwgF0ItiSAXQgOJhSAXQgaIhXwiFCAKfCAEIA98IgogCYMgByAKQn+Fg4R8IApCMokgCkIuiYUgCkIXiYV8QuDe3Jj07djS+AB8Ig98IgRCJIkgBEIeiYUgBEIZiYUgBCADIAiFgyADIAiDhXwgG0I/iSAbQjiJhSAbQgeIhSAZfCASfCAYQi2JIBhCA4mFIBhCBoiFfCIZIAd8IAUgD3wiByAKgyAJIAdCf4WDhHwgB0IyiSAHQi6JhSAHQheJhXxCjqm98LX94Zv7AH0iD3wiBUIkiSAFQh6JhSAFQhmJhSAFIAMgBIWDIAMgBIOFfCAcQj+JIBxCOImFIBxCB4iFIBt8IBN8IBRCLYkgFEIDiYUgFEIGiIV8IhsgCXwgBiAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfEKUjO+s/r6/nPMAfSIPfCIGQiSJIAZCHomFIAZCGYmFIAYgBCAFhYMgBCAFg4V8IBpCP4kgGkI4iYUgGkIHiIUgHHwgFXwgGUItiSAZQgOJhSAZQgaIhXwiHCAKfCAIIA98IgogCYMgByAKQn+Fg4R8IApCMokgCkIuiYUgCkIXiYV8QtjD8+TdgMCg7wB9Ig98IghCJIkgCEIeiYUgCEIZiYUgCCAFIAaFgyAFIAaDhXwgDEI/iSAMQjiJhSAMQgeIhSAafCAWfCAbQi2JIBtCA4mFIBtCBoiFfCIaIAd8IAMgD3wiByAKgyAJIAdCf4WDhHwgB0IyiSAHQi6JhSAHQheJhXxCl4T1i8Li5NfbAH0iD3wiA0IkiSADQh6JhSADQhmJhSADIAYgCIWDIAYgCIOFfCALQj+JIAtCOImFIAtCB4iFIAx8IBd8IBxCLYkgHEIDiYUgHEIGiIV8IgwgCXwgBCAPfCIJIAeDIAogCUJ/hYOEfCAJQjKJIAlCLomFIAlCF4mFfELrjebphIGXg8EAfSIPfCIEQiSJIARCHomFIARCGYmFIAQgAyAIhYMgAyAIg4V8IBBCP4kgEEI4iYUgEEIHiIUgC3wgGHwgGkItiSAaQgOJhSAaQgaIhXwiCyAKfCAFIA98IgogCYMgByAKQn+Fg4R8IApCMokgCkIuiYUgCkIXiYV8QtXZtuTR4aHHOX0iD3wiBUIkiSAFQh6JhSAFQhmJhSAFIAMgBIWDIAMgBIOFfCANQj+JIA1COImFIA1CB4iFIBB8IBR8IAxCLYkgDEIDiYUgDEIGiIV8IhAgB3wgBiAPfCIHIAqDIAkgB0J/hYOEfCAHQjKJIAdCLomFIAdCF4mFfELkvOaukaaw7DV9Ih18IgZCJIkgBkIeiYUgBkIZiYUgBiAEIAWFgyAEIAWDhXwgEUI/iSARQjiJhSARQgeIhSANfCAZfCALQi2JIAtCA4mFIAtCBoiFfCIPIAl8IAggHXwiDSAHgyAKIA1Cf4WDhHwgDUIyiSANQi6JhSANQheJhXxC+fv88Y3n0bwufSIdfCIIQiSJIAhCHomFIAhCGYmFIAggBSAGhYMgBSAGg4V8IBJCP4kgEkI4iYUgEkIHiIUgEXwgG3wgEEItiSAQQgOJhSAQQgaIhXwiCSAKfCADIB18IhEgDYMgByARQn+Fg4R8IBFCMokgEUIuiYUgEUIXiYV8QuKp/JCTxeCSFX0iHXwiA0IkiSADQh6JhSADQhmJhSADIAYgCIWDIAYgCIOFfCATQj+JIBNCOImFIBNCB4iFIBJ8IBx8IA9CLYkgD0IDiYUgD0IGiIV8IgogB3wgBCAdfCISIBGDIA0gEkJ/hYOEfCASQjKJIBJCLomFIBJCF4mFfEKI3cSMgZCswQp9Igd8IgRCJIkgBEIeiYUgBEIZiYUgBCADIAiFgyADIAiDhXwgFUI/iSAVQjiJhSAVQgeIhSATfCAafCAJQi2JIAlCA4mFIAlCBoiFfCITIA18IAUgB3wiDSASgyARIA1Cf4WDhHwgDUIyiSANQi6JhSANQheJhXxCut/dkKf1mfgGfCIHfCIFQiSJIAVCHomFIAVCGYmFIAUgAyAEhYMgAyAEg4V8IBZCP4kgFkI4iYUgFkIHiIUgFXwgDHwgCkItiSAKQgOJhSAKQgaIhXwiFSARfCAGIAd8IhEgDYMgEiARQn+Fg4R8IBFCMokgEUIuiYUgEUIXiYV8QqaxopbauN+xCnwiB3wiBkIkiSAGQh6JhSAGQhmJhSAGIAQgBYWDIAQgBYOFfCAXQj+JIBdCOImFIBdCB4iFIBZ8IAt8IBNCLYkgE0IDiYUgE0IGiIV8IhYgEnwgByAIfCISIBGDIA0gEkJ/hYOEfCASQjKJIBJCLomFIBJCF4mFfEKum+T3y4DmnxF8Igd8IghCJIkgCEIeiYUgCEIZiYUgCCAFIAaFgyAFIAaDhXwgGEI/iSAYQjiJhSAYQgeIhSAXfCAQfCAVQi2JIBVCA4mFIBVCBoiFfCIXIA18IAMgB3wiDSASgyARIA1Cf4WDhHwgDUIyiSANQi6JhSANQheJhXxCm47xmNHmwrgbfCIHfCIDQiSJIANCHomFIANCGYmFIAMgBiAIhYMgBiAIg4V8IBRCP4kgFEI4iYUgFEIHiIUgGHwgD3wgFkItiSAWQgOJhSAWQgaIhXwiGCARfCAEIAd8IhEgDYMgEiARQn+Fg4R8IBFCMokgEUIuiYUgEUIXiYV8QoT7kZjS/t3tKHwiB3wiBEIkiSAEQh6JhSAEQhmJhSAEIAMgCIWDIAMgCIOFfCAZQj+JIBlCOImFIBlCB4iFIBR8IAl8IBdCLYkgF0IDiYUgF0IGiIV8IhQgEnwgBSAHfCISIBGDIA0gEkJ/hYOEfCASQjKJIBJCLomFIBJCF4mFfEKTyZyGtO+q5TJ8Igl8IgVCJIkgBUIeiYUgBUIZiYUgBSADIASFgyADIASDhXwgG0I/iSAbQjiJhSAbQgeIhSAZfCAKfCAYQi2JIBhCA4mFIBhCBoiFfCIZIA18IAYgCXwiDSASgyARIA1Cf4WDhHwgDUIyiSANQi6JhSANQheJhXxCvP2mrqHBr888fCIJfCIGQiSJIAZCHomFIAZCGYmFIAYgBCAFhYMgBCAFg4V8IBxCP4kgHEI4iYUgHEIHiIUgG3wgE3wgFEItiSAUQgOJhSAUQgaIhXwiEyARfCAIIAl8IhEgDYMgEiARQn+Fg4R8IBFCMokgEUIuiYUgEUIXiYV8QsyawODJ+NmOwwB8IhR8Igh8IAMgFHwiByALIBBCP4kgEEI4iYUgEEIHiIV8IBh8IAxCP4kgDEI4iYUgDEIHiIUgGnwgFnwgE0ItiSATQgOJhSATQgaIhXwiEEItiSAQQgOJhSAQQgaIhXx8IAwgC0I/iSALQjiJhSALQgeIhXwgF3wgGkI/iSAaQjiJhSAaQgeIhSAcfCAVfCAZQi2JIBlCA4mFIBlCBoiFfCILQi2JIAtCA4mFIAtCBoiFfCARfCANIBB8IAsgEnwgByARgyANIAdCf4WDhHwgB0IyiSAHQi6JhSAHQheJhXxCtoX52eyX9eLMAHwiCyAEfCIDIAeDIBEgA0J/hYOEfCADQjKJIANCLomFIANCF4mFfEKq/JXjz7PKv9kAfCIQIAV8IgQgA4MgByAEQn+Fg4R8IARCMokgBEIuiYUgBEIXiYV8Quz129az9dvl3wB8Ig0gBnwiDCAEgyADIAxCf4WDhHwgDEIyiSAMQi6JhSAMQheJhXxCl7Cd0sSxhqLsAHwiEXwhByAIQiSJIAhCHomFIAhCGYmFIAggBSAGhYMgBSAGg4V8IAt8IgtCJIkgC0IeiYUgC0IZiYUgCyAGIAiFgyAGIAiDhXwgEHwiBUIkiSAFQh6JhSAFQhmJhSAFIAggC4WDIAggC4OFfCANfCIGIAUgC4WDIAUgC4OFIA58IAZCJIkgBkIeiYUgBkIZiYV8IBF8IQ4gDCAffCEfIAYgHnwhHiAEICF8ISEgBSAgfCEgIAMgInwhIiALICN8ISMgAUGAAWohASACQYABayICQf8ASw0ACwsgACAePAAPIAAgIDwAFyAAIA5CIIg8AAMgACAOQiiIPAACIAAgDkIwiDwAASAAIA5COIg8AAAgACAeQgiIPAAOIAAgHkIQiDwADSAAIB5CGIg8AAwgACAeQiCIPAALIAAgHkIoiDwACiAAIB5CMIg8AAkgACAeQjiIPAAIIAAgIEIIiDwAFiAAICBCEIg8ABUgACAgQhiIPAAUIAAgIEIgiDwAEyAAIA6nIgFBGHQgAUGA/gNxQQh0ciABQQh2QYD+A3EgAUEYdnJyNgAEIAAgIEIoiDwAEiAAICBCMIg8ABEgACAjPAAfIAAgIEI4iDwAECAAICNCCIg8AB4gACAjQhCIPAAdIAAgI0IYiDwAHCAAICNCIIg8ABsgACAjQiiIPAAaIAAgI0IwiDwAGSAAIAc8ACcgACAjQjiIPAAYIAAgB0IIiDwAJiAAIAdCEIg8ACUgACAHQhiIPAAkIAAgB0IgiDwAIyAAIAdCKIg8ACIgACAHQjCIPAAhIAAgHzwALyAAIAdCOIg8ACAgACAfQgiIPAAuIAAgH0IQiDwALSAAIB9CGIg8ACwgACAfQiCIPAArIAAgH0IoiDwAKiAAIB9CMIg8ACkgACAhPAA3IAAgH0I4iDwAKCAAICFCCIg8ADYgACAhQhCIPAA1IAAgIUIYiDwANCAAICFCIIg8ADMgACAhQiiIPAAyIAAgIUIwiDwAMSAAICI8AD8gACAhQjiIPAAwIAAgIkIIiDwAPiAAICJCEIg8AD0gACAiQhiIPAA8IAAgIkIgiDwAOyAAICJCKIg8ADogACAiQjCIPAA5IAAgIkI4iDwAOAvBDAIffwN+IAIgAkGAAXFBB3YiBGtBACAEayIFcyEgIAFBgAZsQaDpL2ohIUEBIQ1BASERA0AgISADQeAAbGoiAigCICAgIANBAWoiBHNBAWsiAUEfdSIDcSABQR92QQFrIgEgHiANQf8BcXJxciINQYB+cSEeIAIoAgAgA3EgASAfIBFB/wFxcnFyIhFBgH5xIR8gAigCXCADcSABIAtxciELIAIoAlggA3EgASAScXIhEiACKAJUIANxIAEgE3FyIRMgAigCUCADcSABIAdxciEHIAIoAkwgA3EgASAGcXIhBiACKAJIIANxIAEgFHFyIRQgAigCRCADcSABIBVxciEVIAIoAkAgA3EgASAIcXIhCCACKAI8IANxIAEgCnFyIQogAigCOCADcSABIBZxciEWIAIoAjQgA3EgASAXcXIhFyACKAIwIANxIAEgCXFyIQkgAigCLCADcSABIAxxciEMIAIoAiggA3EgASAYcXIhGCACKAIkIANxIAEgGXFyIRkgAigCHCADcSABIA5xciEOIAIoAhggA3EgASAacXIhGiACKAIUIANxIAEgG3FyIRsgAigCECADcSABIA9xciEPIAIoAgwgA3EgASAQcXIhECACKAIIIANxIAEgHHFyIRwgAigCBCADcSABIB1xciEdIAQiA0EIRw0ACyAAIA1B////H3EiAiARQf///x9xIgNzIAVxIgEgAnM2AiggACABIANzNgIAIAAgDEEGdiICIBBBBnYiA3MgBXEiASACczYCOCAAIAEgA3M2AhAgACAJQf///w9xIgIgD0H///8PcSIDcyAFcSIBIAJzNgI8IAAgASADczYCFCAAIApBBnZB////D3EiAiAOQQZ2Qf///w9xIgNzIAVxIgEgAnM2AkwgACABIANzNgIkIAAgDa0gGa0iIkIghoRCGoinQf///w9xIgIgEa0gHa0iI0IghoRCGoinQf///w9xIgNzIAVxIgEgAnM2AiwgACABIANzNgIEIAAgGK0iJEIghiAihEITiKdB////H3EiAiAcrSIiQiCGICOEQhOIp0H///8fcSIDcyAFcSIBIAJzNgIwIAAgASADczYCCCAAIAytQiCGICSEQg2Ip0H///8PcSICIBCtQiCGICKEQg2Ip0H///8PcSIDcyAFcSIBIAJzNgI0IAAgASADczYCDCAAIAmtIBetIiJCIIaEQhmIp0H///8fcSICIA+tIButIiNCIIaEQhmIp0H///8fcSIDcyAFcSIBIAJzNgJAIAAgASADczYCGCAAIBatIiRCIIYgIoRCE4inQf///w9xIgIgGq0iIkIghiAjhEITiKdB////D3EiA3MgBXEiASACczYCRCAAIAEgA3M2AhwgACAKrUIghiAkhEIMiKdB////H3EiAiAOrUIghiAihEIMiKdB////H3EiA3MgBXEiASACczYCSCAAIAEgA3M2AiAgACAFQf///w9xIgJB2v//PyAIQf///x9xIgNrIgpBGnYgCK0gFa0iIkIghoRCGoinIgFB////D3EiBGtB/v//H2oiCCABc3EgBHM2AlQgACAFQf///x9xIgEgCEEZdiAUrSIjQiCGICKEQhOIpyIEQf///x9xIghrQf7//z9qIgkgBHNxIAhzNgJYIAAgAiAJQRp2IAatQiCGICOEQg2IpyIEQf///w9xIghrQf7//x9qIgkgBHNxIAhzNgJcIAAgCUEZdiAGQQZ2IgRrQf7//z9qIgZB////H3EgBHMgBXEgBHM2AmAgACACIAZBGnYgB0H///8PcSIEa0H+//8faiIGIAdzcSAEczYCZCAAIAEgBkEZdiAHrSATrSIiQiCGhEIZiKciBEH///8fcSIHa0H+//8/aiIGIARzcSAHczYCaCAAIAIgBkEadiASrSIjQiCGICKEQhOIpyIEQf///w9xIgdrQf7//x9qIgYgBHNxIAdzNgJsIAAgASAGQRl2IAutQiCGICOEQgyIpyIEQf///x9xIgdrQf7//z9qIgYgBHNxIAdzNgJwIAAgAiAGQRp2IAtBBnYiAUH///8PcSIEa0H+//8faiIHIAFzcSAEczYCdCAAIAdBGXZBE2wgCkH///8fcWogA3MgBXEgA3M2AlAL3g0BF38jAEHQAmsiAiQAIAIgACgCKCIGIAAoAgAiB2tB2v//P2oiA0H///8fcTYCoAIgAiAAKAIsIgggA0EadmogACgCBCIJa0H+//8faiIDQf///w9xNgKkAiACIAAoAjAiCiAAKAIIIgtrIANBGXZqQf7//z9qIgNB////H3E2AqgCIAIgACgCNCIMIAAoAgwiDWsgA0EadmpB/v//H2oiA0H///8PcTYCrAIgAiAAKAI4Ig4gACgCECIPayADQRl2akH+//8/ajYCsAIgAiAAKAI8IhAgACgCFCIEa0H+//8fajYCtAIgAiAAKAJAIhEgACgCGCISa0H+//8/ajYCuAIgAiAAKAJEIhMgACgCHCIUa0H+//8fajYCvAIgAiAAKAJIIhUgACgCICIWa0H+//8/ajYCwAIgACgCJCEDIAAoAkwhBSACIBUgFmo2ApACIAIgEyAUajYCjAIgAiARIBJqNgKIAiACIAQgEGo2AoQCIAIgDiAPajYCgAIgAiAMIA1qNgL8ASACIAogC2o2AvgBIAIgCCAJajYC9AEgAiAGIAdqNgLwASACIAMgBWo2ApQCIAIgBSADa0H+//8fajYCxAIgAkGgAmogAkGgAmogARCVBSACQZABaiACQfABaiABQShqEJUFIAIgAigCoAIiAyACKAKQASIFajYCACACIAIoAqQCIgYgAigClAEiB2o2AgQgAiACKAKoAiIIIAIoApgBIglqNgIIIAIgAigCrAIiCiACKAKcASILajYCDCACIAIoArACIgwgAigCoAEiDWo2AhAgAiACKAK0AiIOIAIoAqQBIg9qNgIUIAIgDyAOa0H+//8fajYCpAEgAiAFIANrQdr//z9qIgNB////H3E2ApABIAIgAigCuAIiBSACKAKoASIOajYCGCACIAIoArwCIg8gAigCrAEiEGo2AhwgAiACKALAAiIEIAIoArABIhFqNgIgIAIgAigCxAIiEiACKAK0ASITajYCJCACIBAgD2tB/v//H2o2AqwBIAIgESAEa0H+//8/ajYCsAEgAiATIBJrQf7//x9qNgK0ASACIA4gBWtB/v//P2o2AqgBIAIgByADQRp2aiAGa0H+//8faiIDQf///w9xNgKUASACIAkgCGsgA0EZdmpB/v//P2oiA0H///8fcTYCmAEgAiALIAprIANBGnZqQf7//x9qIgNB////D3E2ApwBIAIgDSAMayADQRl2akH+//8/ajYCoAEgAkHAAWogAEH4AGoiAyABQdAAahCVBSAAKAJ0IQEgACgCcCEFIAAoAmwhBiAAKAJoIQcgACgCZCEIIAAoAmAhCSAAKAJcIQogACgCWCELIAIgAigCxAEiDCAAKAJUQQF0Ig1qIAIoAsABIg4gACgCUEEBdCIPaiIQQRp2aiIEQf///w9xNgI0IAIgAigCyAEiESALQQF0IgtqIARBGXZqIgRB////H3E2AjggAiACKALMASISIApBAXQiCmogBEEadmoiBEH///8PcTYCPCACIAIoAtABIhMgCUEBdCIJaiAEQRl2aiIEQf///x9xNgJAIAIgAigC1AEiFCAIQQF0IghqIARBGnZqIgRB////D3E2AkQgAiACKALYASIVIAdBAXQiB2ogBEEZdmoiBEH///8fcTYCSCACIAIoAtwBIhYgBkEBdCIGaiAEQRp2aiIEQf///w9xNgJMIAIgAigC4AEiFyAFQQF0IgVqIARBGXZqIgRB////H3E2AlAgAiACKALkASIYIAFBAXQiAWogBEEadmoiBEH///8PcTYCVCACIARBGXZBE2wgEEH///8fcWo2AjAgAiABIBhrIAUgF2sgBiAWayAHIBVrIAggFGsgCSATayAKIBJrIAsgEWsgDSAMayAPIA5rQbT///8AaiIBQRp2akH8//8/aiIFQRl2akH8////AGoiBkEadmpB/P//P2oiB0EZdmpB/P///wBqIghBGnZqQfz//z9qIglBGXZqQfz///8AaiIKQRp2akH8//8/aiILQRl2akH8////AGoiDEEadmpB/P//P2oiDUH///8PcTYChAEgAiAMQf///x9xNgKAASACIAtB////D3E2AnwgAiAKQf///x9xNgJ4IAIgCUH///8PcTYCdCACIAhB////H3E2AnAgAiAHQf///w9xNgJsIAIgBkH///8fcTYCaCACIAVB////D3E2AmQgAiANQRl2QRNsIAFB////H3FqNgJgIAAgAkGQAWogAkHgAGoQlQUgAEEoaiACIAJBMGoQlQUgAEHQAGogAkEwaiACQeAAahCVBSADIAJBkAFqIAIQlQUgAkHQAmokAAuAAwEafyAAIAAoAiAiAiAAKAIcIgMgACgCGCIEIAAoAhQiBSAAKAIQIgYgACgCDCIHIAAoAggiCCAAKAIEIgkgACgCACIKQe2n1+cBayILQR91akHpmKaCAmsiDEEfdWpB5Zrn+wJrIg1BH3YiDkGo7/m9A3JrIg9BH3YiEEEUcmsiEUEfdiISayITQR92IhRrIhVBH3YiFmsiF0EfdiIYQYAgcmsiGUEfdiIaQQFrIgEgGEEedCAXaiADc3EgA3M2AhwgACAEIAEgBCAWQR50IBVqc3FzNgIYIAAgBSABIAUgFEEedCATanNxczYCFCAAIAYgASAGIBJBHnQgEWpzcXM2AhAgACAHIAEgByAQQR50IA9qc3FzNgIMIAAgCCABIAggDkEedCANanNxczYCCCAAIAkgASAJIAxBAXZBgICAgARxIAxqc3FzNgIEIAAgCiABIAogCyALQQF2QYCAgIAEcWpzcXM2AgAgACACIAIgGkEQdCAZanMgAXFzNgIgC+YBAQN/A0AgACAEQQR0aiIDIAEgBEECdGooAAAiAkEBdkHVqtWqBXEgAkHVqtWqBXFqIgJBBHZBA3EgAkEGdkEDcWs7AQIgAyACQQNxIAJBAnZBA3FrOwEAIAMgAkEIdkEDcSACQQp2QQNxazsBBCADIAJBDHZBA3EgAkEOdkEDcWs7AQYgAyACQRB2QQNxIAJBEnZBA3FrOwEIIAMgAkEUdkEDcSACQRZ2QQNxazsBCiADIAJBGHZBA3EgAkEadkEDcWs7AQwgAyACQRx2QQNxIAJBHnZrOwEOIARBAWoiBEEgRw0ACwvdAQIDfwR+A0AgASACQQN0aiIEMwECIQUgBDMBBCEGIAQzAQYhByAAIAJBBWxqIgMgBDMBAEKA+PbrCX5CgICAgBB8IghCIYg8AAAgAyAHQoD49usJfkKAgICAEHwiB0IjiDwABCADIAdCG4inQcABcSAGQoD49usJfkKAgICAEHwiBkIliKdBP3FyOgADIAMgBkIdiKdB8AFxIAVCgPj26wl+QoCAgIAQfCIFQieIp0EPcXI6AAIgAyAFQh+Ip0H8AXEgCEIpiKdBA3FyOgABIAJBAWoiAkHAAEcNAAsL5wIBDH8DQCABIARBC2xqIgItAAghBSACLQAHIQsgAi0ABiEGIAItAAUhByACLQAEIQggAi0AAyEMIAItAAAhDSACLQACIQkgAi0AASEKIAAgBEEEdGoiAyACLQAKQQN0IAItAAkiAkEFdnJBgRpsQYAIakELdjsBDiADIAlBBXRB4A9xIApBA3ZyQYEabEGACGpBC3Y7AQIgAyANIApBCHRBgA5xckGBGmxBgAhqQQt2OwEAIAMgCEEKdEGACHEgDEECdCAJQQZ2cnJBgRpsQYAIakELdjsBBCADIAdBB3RBgA9xIAhBAXZyQYEabEGACGpBC3Y7AQYgAyAGQQR0QfAPcSAHQQR2ckGBGmxBgAhqQQt2OwEIIAMgBUEJdEGADHEgC0EBdCAGQQd2cnJBgRpsQYAIakELdjsBCiADIAJBBnRBwA9xIAVBAnZyQYEabEGACGpBC3Y7AQwgBEEBaiIEQSBHDQALC7EDAgR/CH4DQCABIARBBHRqIgMzAQIhBiADMwEGIQcgAzMBCCEIIAMzAQwhCSADMwEEIQogAzMBCiELIAMzAQ4hDCAAIARBC2xqIgIgAzMBAEKA8O3XE35CgICAgBB8Ig1CIYg8AAAgAiAMQoDw7dcTfkKAgICAEHwiDEIkiDwACiACIAtCgPDt1xN+QoCAgIAQfCILQiKIPAAHIAIgCkKA8O3XE35CgICAgBB8IgpCI4g8AAMgAiAMQhyIp0HgAXEgCUKA8O3XE35CgICAgBB8IglCJ4inQR9xcjoACSACIAhCgPDt1xN+QoCAgIAQfCIIQiWIp0H/AHEgC0IhiKciA0EHdHI6AAYgAiAIQh2Ip0HwAXEgB0KA8O3XE35CgICAgBB8IgdCKIinQQ9xcjoABSACIAZCgPDt1xN+QoCAgIAQfCIGQiaIp0E/cSAKQiGIpyIFQQZ0cjoAAiACIAZCHoinQfgBcSANQimIp0EHcXI6AAEgAiAJQh+Ip0H8AXEgA0EJdkEDcXI6AAggAiAHQiCIp0H+AXEgBUEKdkEBcXI6AAQgBEEBaiIEQSBHDQALC6YPAxB7DX8HfiMAQdAAayITJAAgAEHwBWoiGkEAQaAF/AsAIAD9DEMAAAAAAAAAAAAAAAAAAID9CwQgIAD9DAIAAAAAAAAAAAAAAAAAAAD9CwQQIAD9DAEAAAAAAAAAAAAAAAAAAAAiA/0LBAD9DAIAAAAAAAAAAAAAAAAAAAAiAiACIAIQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkQmgkiAiACIAIQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJIgEgARCaCSIBIAEQmgkiASABEJoJEJoJIgEhAgNAIAIgAhCaCSECIBFBAWoiEUHAAEcNAAsgACAD/QsEMCAA/QwBAAAAAAAAAAAAAAAAAAAAIgYgASACEJoJIgIQmgkiA/0LBEAgACADIAIQmgkiAf0LBFAgACABIAIQmgkiBP0LBGAgACAEIAIQmgkiBf0LBHAgACAFIAIQmgkiB/0LBIABIAAgByACEJoJIgj9CwSQASAAIAggAhCaCSIJ/QsEoAEgACAJIAIQmgkiCv0LBLABIAAgCiACEJoJIgv9CwTAASAAIAsgAhCaCSIM/QsE0AEgACAMIAIQmgkiDf0LBOABIAAgDSACEJoJIg79CwTwASAAIA4gAhCaCSIP/QsEgAIgACAPIAIQmgkiEP0LBJACIABCATcDsAQgACAG/QsEsAIgACAQIAIQmgkiBv0LBKACIABCAjcDuAQgACAD/QsEwAIgAEIENwPABCAAIAH9CwTQAiAAQgg3A8gEIAAgBP0LBOACIABCEDcD0AQgACAF/QsE8AIgAEIgNwPYBCAAIAf9CwSAAyAAQsAANwPgBCAAIAj9CwSQAyAAQoABNwPoBCAAIAn9CwSgAyAAQoACNwPwBCAAIAr9CwSwAyAAQoAENwP4BCAAIAv9CwTAAyAAIAz9CwTQAyAAQoAINwOABSAAIA39CwTgAyAAQoAQNwOIBSAAIA79CwTwAyAAQoAgNwOQBSAAIA/9CwSABCAAQoDAADcDmAUgACAQ/QsEkAQgAEKAgAE3A6AFIAAgBv0LBKAEIABCgIACNwOoBSAAQbAFaiEdIABBsARqIRcgAEGwAmohGANAQgEgFUE/ca2GIR4gFUEGdkEDdCEbIBQhEQJAAkADQCAYIBFBBHRqIhIgG2opAwAgHoNQBEAgEUEPRiESIBFBAWohESASRQ0BDAILCyATIBggFEEEdGoiGf0AAwD9CwNAIBkgEkEIaiIWKQMANwMIIBkgEikDADcDACAWIBMpA0g3AwAgEiATKQNANwMAIBcgFEEDdGoiFikDACEfIBYgFyARQQN0aiIRKQMANwMAIBEgHzcDACAdIBRBAnRqIBU2AgAgFEEBaiIcIREgFEEOSwRAIBwhFAwCCwNAIBggEUEEdGoiEiAbaikDACAeg0IAUgRAIBIgEv0ABAAgGf0ABAD9Uf0LBAAgFyARQQN0aiISIBIpAwAgFikDAIU3AwALIBFBAWoiEUEQRw0ACyAcIRQLIBRBD0sNACAVQf8ASSERIBVBAWohFSARDQELCyAUQRBGBEAgAEHQBmohFCAA/QwAAAAAAAAAAAAAAAAAAAAAIgX9CwTwBSAAIAD9AAQAIgP9CwSABiAAIAMgAhCaCSID/QsEkAYgACADIAIQmgkiA/0LBKAGIAAgAyACEJoJIgP9CwSwBiAAIAMgAhCaCf0LBMAGQQEhEgNAQQYhEQJAA0AgGiARQQFrIhEgEmtBBHRq/QAEACAaIBFBBHRq/QAEAP1RIgL9HQAiHyAC/R0BIh6EQgBSBEAgAP0ABCAhBCAA/QAEACECIAApAyghICAAKQMgISEgBSEDA0AgHkI/hiAfQgGIhCEiIB5CAYghHgJAIB9CAYNQBEAgIiEfIAMhAQwBCwJ+IB4gIFoEQCAgISMgAyEBICEgHiAgVg0BGiAhICEgIlgNARoLIB4hIyACIQEgIgshJCADIAL9USECIB4gIIUhHiAhICKFIR8gASEDICQhISAjISALIAIgBBCaCSECIB4gH4RCAFINAAsgFCARQeAAbGogEkEEdGogAf0LBAAgESASSw0BDAILCyATQbz/KzYCEEHkAEH0hyogE0EQahCbCUGQljQoAgAoAgAhESATQbz/KzYCACARQZGMKiATEGwACyASQQFqIhJBBkcNAAsgE0HQAGokACAADwsgE0GH8Sk2AjBB5ABB9IcqIBNBMGoQmwlBkJY0KAIAKAIAIREgE0GH8Sk2AiAgEUGRjCogE0EgahBsAAuWAwIDfwp+IwBB0ABrIgUgA/0LBBAgBSAC/QsEACAFQgA3AyADQCAFIAZBA3RqIgQpAwAhByAEQgA3AwAgBCAEKQMIIgsgB0IghiIMfCIINwMIIAQgBCkDECINIAdCIIgiD3wiCSAIIAtUrXwiCDcDECAEIAcgBCkDGCIQIAx9Igt8IgwgCCAJVCAJIA1Ucq18Ig03AxggBCAHIAogD30iCSALIBBWrX0iCHwiByALIAxWIAwgDVZyrXwiCzcDICAEIAcgCFQgByALVnKtIA4gCSAKViAIIAlWcq19fCIKNwMoIAZBAWoiBkEERw0ACyAAIAUpAzgiByAHIAEpAzgiC3wiByABKQMwIgkgBSkDMCIMfCIKIAlUIAogASkDKCIIIAUpAygiDXwiCSAIVCAJIAEpAyAiCCAFKQMgIg98IhAgCFStfCIIIAlUcq18IgkgClRyrXwiCiAFKQNAIA4gByALVCAHIApWcq18USIEGzcDGCAAIAwgCSAEGzcDECAAIA0gCCAEGzcDCCAAIA8gECAEGzcDAAvxBgENfiAA/R0AIgNCACAB/R0AIgZCAYMiBH2DIQpCASECA0AgBiACiCIHQgGDpwRAIANCwAAgAn2IIAyFIQwgAyAChiAKhSEKCyACQgF8IglCwABSBEAgB0ICg0IAUgRAIANCPyACfYggDIUhDCADIAmGIAqFIQoLIAJCAnwhAgwBCwtCACEHQgAgAf0dASIIQgGDIg59IAODIQlCASECA0AgCCACiCIFQgGDpwRAIANCwAAgAn2IIAeFIQcgAyAChiAJhSEJCyACQgF8IgtCwABSBEAgBUICg0IAUgRAIANCPyACfYggB4UhByADIAuGIAmFIQkLIAJCAnwhAgwBCwtCACEFQgAgAP0dASIDIARQGyELQgEhAgNAIAYgAogiBEIBg6cEQCADIAKGIAuFIQsgA0LAACACfYggBYUhBQsgAkIBfCINQsAAUgRAIARCAoNCAFIEQCADIA2GIAuFIQsgA0I/IAJ9iCAFhSEFCyACQgJ8IQIMAQsLQgAhBkIAIAMgDlAbIQRCASECA0AgCCACiCINQgGDpwRAIANCwAAgAn2IIAaFIQYgAyAChiAEhSEECyACQgF8Ig5CwABSBEAgDUICg0IAUgRAIANCPyACfYggBoUhBiADIA6GIASFIQQLIAJCAnwhAgwBCwtCACEIIAUgB4UgBIUiAyEHQgEhAgN7QgEgAoZChwGDQgBSBEAgAyAChiAHhSEHIANCwAAgAn2IIAiFIQgLIAJCAXwiBULAAFEEe0IAIQMgBiEFQgEhAgNAQgEgAoZChwGDQgBSBEAgBkLAACACfYggA4UhAyAGIAKGIAWFIQULAkAgAkIBfCIEQsAAUQRAQgAhBiADIQRCASECA0BCASAChkKHAYNCAFIEQCADQsAAIAJ9iCAGhSEGIAMgAoYgBIUhBAsgAkIBfCINQsAAUQ0CQgIgAoZChgGDQgBSBEAgA0I/IAJ9iCAGhSEGIAMgDYYgBIUhBAsgAkICfCECDAALAAtCAiAChkKGAYNCAFIEQCAGQj8gAn2IIAOFIQMgBiAEhiAFhSEFCyACQgJ8IQIMAQsLIAcgCoUgBIX9EiAJIAyFIAuFIAiFIAWFIAaF/R4BBUICIAKGQoYBg0IAUgRAIAMgBYYgB4UhByADQj8gAn2IIAiFIQgLIAJCAnwhAgwBCwsLfQEBfyMAQaAIayIDJAAgAyACNgKcCCADQRBqQYAIIAEgAhCkCxpB3fozIQICQAJAAkACQCAAQQFrDgoCAwMDAwMDAwMAAQtBgvszIQIMAQsgAEHkAEcNAUGm+zMhAgsgAyADQRBqNgIAIAJB7NMxIAMQABoLIANBoAhqJAAL3QECBH8BeyMAQSBrIgYkACAAKAIAIgUgACgCBCIHKAIESQRAIAT9AAQAIQkgACAFQQFqNgIAIAcoAgggBUEEdGogCf0LBAAgAgRAQQAhBwNAIAEgB0HoAGxqIgUoAmQhCCAAIAUgBSgCYEEgIAQQnQkgACAFQSBqIAhBwAAgBBCdCSAHQQFqIgcgAkcNAAsLIAAgA0EUQRQgBBCdCSAGQSBqJAAPCyAGQaPYKzYCEEHkAEH0hyogBkEQahCbCUGQljQoAgAoAgAhBSAGQaPYKzYCACAFQZGMKiAGEGwAC/UFAgV/AXsjAEEgayIIJAAgBP0ABEAhCiADQQd0IgYQngkiByEFIANBAXEEQCAHIAr9CwRwIAcgCv0LBGAgByAK/QsEUCAHIAr9CwRAIAcgCv0LBDAgByAK/QsEICAHIAr9CwQQIAcgCv0LBAAgB0GAAWohBQsgBiAHaiEGA0AgBSAK/QsE8AEgBSAK/QsE4AEgBSAK/QsE0AEgBSAK/QsEwAEgBSAK/QsEsAEgBSAK/QsEoAEgBSAK/QsEkAEgBSAK/QsEgAEgBSAK/QsEcCAFIAr9CwRgIAUgCv0LBFAgBSAK/QsEQCAFIAr9CwQwIAUgCv0LBCAgBSAK/QsEECAFIAr9CwQAIAVBgAJqIgUgBkcNAAsgAgRAIAMgAiACIANLGyEJIAT9AAQAIQpBACECA0AgByACQQd0aiIF/QwAAAAAAAAAAAAAAAAAAAAAIAogASACaiwAACIGQQBOG/0LBHAgBSAK/QwAAAAAAAAAAAAAAAAAAAAAIAZBwABxG/0LBGAgBSAK/QwAAAAAAAAAAAAAAAAAAAAAIAZBIHEb/QsEUCAFIAr9DAAAAAAAAAAAAAAAAAAAAAAgBkEQcRv9CwRAIAUgCv0MAAAAAAAAAAAAAAAAAAAAACAGQQhxG/0LBDAgBSAK/QwAAAAAAAAAAAAAAAAAAAAAIAZBBHEb/QsEICAFIAr9DAAAAAAAAAAAAAAAAAAAAAAgBkECcRv9CwQQIAUgCv0MAAAAAAAAAAAAAAAAAAAAACAGQQFxG/0LBAAgAkEBaiICIAlHDQALC0EBIANBA3QiBSAFQQFNGyEBQQAhBQJAA0AgACgCACIGIAAoAgQiAigCBE8NASAAIAZBAWo2AgAgAigCCCAGQQR0aiAHIAVBBHRq/QAEAP0LBAAgBUEBaiIFIAFHDQALIAcQKyAIQSBqJAAPCyAIQaPYKzYCEEHkAEH0hyogCEEQahCbCUGQljQoAgAoAgAhBSAIQaPYKzYCACAFQZGMKiAIEGwAC90DAQh/IwBBEGsiBSQAQQEgACAAQQFNGyIAIABBD2pBcHEiAiAAIAJLGyIAQQ9xRQRAAn8gBUEMaiEHQTAgAEGwf0sNABpBMAJ/IABBsH9PBEBB0PszQTA2AgBBAAwBC0EAQRAgAEELakF4cSAAQQtJGyIAQRxqECoiAUUNABogAUEIayECAkAgAUEPcUUEQCACIQMMAQsgAUEEayIGKAIAIghBeHEgAUEPakFwcUEIayIBQRBBACABIAJrQQ9NG2oiAyACayIBayEEIAhBA3FFBEAgAigCACECIAMgBDYCBCADIAEgAmo2AgAMAQsgAyAEIAMoAgRBAXFyQQJyNgIEIAMgBGoiBCAEKAIEQQFyNgIEIAYgASAGKAIAQQFxckECcjYCACABIAJqIgQgBCgCBEEBcjYCBCACIAEQLQsCQCADKAIEIgFBA3FFDQAgAUF4cSICIABBEGpNDQAgAyAAIAFBAXFyQQJyNgIEIAAgA2oiASACIABrIgBBA3I2AgQgAiADaiICIAIoAgRBAXI2AgQgASAAEC0LIANBCGoLIgBFDQAaIAcgADYCAEEACyEAQQAgBSgCDCAAGyEDCyAFQRBqJAAgAyIARQRAQQAhAAsgAEUEQBD4DAALIAALBgAgABArCwYAEKwGAAuVBAEDfyMAQYABayIEJAACQAJAAkAgACgCACIFIAAoAgQiBigCBEkEQCAAIAVBAWo2AgAgBigCCCAFQQV0aiIFQbiJNP0AAwD9CwMAIAVByIk0/QADAP0LAxAgACgCACIFIAAoAgQiBigCBE8NASAAIAVBAWo2AgAgBigCCCAFQQV0aiIFIAH9AAMA/QsDACAFIAH9AAMQ/QsDECAAKAIAIgUgACgCBCIBKAIETw0CIAAgBUEBajYCACABKAIIIAVBBXRqIgUgAv0AAwD9CwMAIAUgAv0AAxD9CwMQIAAoAgAiBSAAKAIEIgEoAgRPDQMgACAFQQFqNgIAIAEoAgggBUEFdGoiACAD/QADAP0LAwAgACAD/QADEP0LAxAgBEGAAWokAA8LIARBo9grNgJwQeQAQfSHKiAEQfAAahCbCUGQljQoAgAoAgAhACAEQaPYKzYCYCAAQZGMKiAEQeAAahBsAAsgBEGj2Cs2AlBB5ABB9IcqIARB0ABqEJsJQZCWNCgCACgCACEAIARBo9grNgJAIABBkYwqIARBQGsQbAALIARBo9grNgIwQeQAQfSHKiAEQTBqEJsJQZCWNCgCACgCACEAIARBo9grNgIgIABBkYwqIARBIGoQbAALIARBo9grNgIQQeQAQfSHKiAEQRBqEJsJQZCWNCgCACgCACEAIARBo9grNgIAIABBkYwqIAQQbAALLwEBfwJ/QQEgACAAQQFNGyEBIAEQKiIABH8gAAVBAAsMAAsiAEUEQBD4DAALIAAL5ggBCH8jAEFAaiIFJABBFhCiCSIJQezNMSkAADcADiAJQd7NMf0AAAD9CwAAQQQQogkiC0HYsYSCejYAAAJAIAQgA2siB0GAAkkEQAJ/AkAgB0EYTwRAIAkhCCAHQf8BRwRAIAggBzoAASAIQfgAOgAAIAhBAmohCAsgCCAJayEGDAELIAkgB0HgAHI6AABBASEGIAlBAWoiCCAHRQ0BGgsgCUEWaiAIayAHTgRAIAghBgJAIAMgBEYNAAJAIAQgA2siCkEQSQ0AIAYgA2tBEEkNACAKQXBxIQdBACEGA0AgBiAIaiADIAZq/QAAAP0LAAAgBkEQaiIGIAdHDQALIAcgCGohBiAHIApGDQEgBCADIAdqIgNrIQcLAkAgB0EHcSIMRQRAIAMhBwwBC0EAIQogAyEHA0AgBiAHLQAAOgAAIAZBAWohBiAHQQFqIQcgCkEBaiIKIAxHDQALCyADIARrQXhLDQADQCAGIActAAA6AAAgBiAHLQABOgABIAYgBy0AAjoAAiAGIActAAM6AAMgBiAHLQAEOgAEIAYgBy0ABToABSAGIActAAY6AAYgBiAHLQAHOgAHIAZBCGohBiAHQQhqIgcgBEcNAAsLIAggBiAIa2oMAQsgBiAHaiIIQQBIDQJBLCAIIAhBLE0bEKIJIgogBmohCCAHBEAgCCADIAf8CgAACyAGBEAgCiAJIAb8CgAACyAJECsgCiEJIAcgCGoLIQggBUEWEKIJIgY2AjAgBSAGQRZqIgc2AjggBkHWzTEpAAA3AA4gBkHIzTH9AAAA/QsAACAFIAc2AjQgBUEwaiAHIAEgASACaiACEKUJIAVBMGogBSgCNCAJIAggCCAJaxCmCSAFQTBqIAUoAjQgCyALQQRqQQQQpgkgBUEREKIJIgY2AiQgBSAGQRFqIgg2AiwgBkGEzjEtAAA6ABAgBkH0zTH9AAAA/QsAACAFIAg2AiggBUHYMTsBIgJAQQRBBSAFKAI0IgMgBSgCMCIHayIGQYACSRsgBmoiCkGBAk8EQCAFQdkAOgA9IAUgCjoAPyAFIApBCHY6AD4gBUEkaiAIIAVBPWogBUFAa0EDEKcJDAELIAUgCjoAPiAFQdgAOgA9IAVBJGogCCAFQT1qIAVBP2pBAhCnCQsgBUEkaiAFKAIoIAVBImogBUEkakECEKcJAkAgBkGBAk8EQCAFQdkAOgA9IAUgBjoAPyAFIAZBCHY6AD4gBUEkaiAFKAIoIAVBPWogBUFAa0EDEKcJDAELIAUgBjoAPiAFQdgAOgA9IAVBJGogBSgCKCAFQT1qIAVBP2pBAhCnCQsgBUEkaiAFKAIoIAcgAyAGEKYJIAAgBSgCJCIGIAUoAiggBmsQqAkgBgRAIAYQKwsgBwRAIAcQKwsgCxArIAkQKyAFQUBrJAAPCyAFQfyZKzYCEEHkAEH0hyogBUEQahCbCUGQljQoAgAoAgAhBiAFQfyZKzYCACAGQZGMKiAFEGwACxCgCQALjQIBBH4CQAJAIAEpAwAiAyAAKQNoIgRSDQAgASkDCCAAKQNwUg0AIAEpAxAgACkDeFINACABKQMYIAApA4ABUQ0BCwJAIAIpAwAiBSAAKQOIASIGUg0AIAIpAwggACkDkAFSDQAgAikDECAAKQOYAVINACACKQMYIAApA6ABUQ0BCwJAAkACQCAEIAVSDQAgAikDCCAAKQNwUg0AIAIpAxAgACkDeFINACACKQMYIAApA4ABUQ0BCyADIAZSDQEgASkDCCAAKQOQAVINASABKQMQIAApA5gBUg0BIAEpAxggACkDoAFSDQELIAEgAv0AAwD9CwMAIAEgAv0AAxD9CwMQDwsgACABIAIQqQkLC/kJAQh/AkAgBEEATA0AAkAgACgCCCIFIAAoAgQiB2sgBE4EQCAHIAFrIgsgBEgEQAJAIAMgAiALaiIJRgRAIAchBgwBCwJAIAEgA2ogAiAHamsiCEEQSQRAIAchBgwBCyABIAJrQRBJBEAgByEGDAELIAhBcHEhBQNAIAYgB2ogBiAJav0AAAD9CwAAIAZBEGoiBiAFRw0ACyAFIAdqIQYgBSAIRg0BIAUgCWohCQsCQCADIAlrQQdxIgpFBEAgCSEFDAELQQAhCCAJIQUDQCAGIAUtAAA6AAAgBkEBaiEGIAVBAWohBSAIQQFqIgggCkcNAAsLIAkgA2tBeEsNAANAIAYgBS0AADoAACAGIAUtAAE6AAEgBiAFLQACOgACIAYgBS0AAzoAAyAGIAUtAAQ6AAQgBiAFLQAFOgAFIAYgBS0ABjoABiAGIAUtAAc6AAcgBkEIaiEGIAVBCGoiBSADRw0ACwsgACAGNgIEIAtBAEwNAyABIARqIQogByAGIARrIgNNBEAgBiEFDAMLAkAgBCAHaiAGayIIQRBJBEAgBiEFDAELIARBEEkEQCAGIQUMAQsgCEFwcSEEQQAhBQNAIAUgBmogAyAFav0AAAD9CwAAIAVBEGoiBSAERw0ACyAEIAZqIQUgBCAIRg0DIAMgBGohAwsCQCAHIANrQQdxIglFBEAgAyEEDAELQQAhCCADIQQDQCAFIAQtAAA6AAAgBUEBaiEFIARBAWohBCAIQQFqIgggCUcNAAsLIAMgB2tBeU8NAgNAIAUgBC0AADoAACAFIAQtAAE6AAEgBSAELQACOgACIAUgBC0AAzoAAyAFIAQtAAQ6AAQgBSAELQAFOgAFIAUgBC0ABjoABiAFIAQtAAc6AAcgBUEIaiEFIARBCGoiBCAHRw0ACwwCCyABIARqIQoCQCAHIgYgBiAEayIDTQ0AIAYhDCAEQRBPBEAgBEHw////B3EhBUEAIQYDQCAGIAdqIAMgBmr9AAAA/QsAACAGQRBqIgYgBUcNAAsgBSAHaiEGIAQgBUYNASADIAVqIQMLAkAgDCADa0EHcSIJRQRAIAMhBQwBCyADIQUDQCAGIAUtAAA6AAAgBkEBaiEGIAVBAWohBSAIQQFqIgggCUcNAAsLIAMgB2tBeU8NAANAIAYgBS0AADoAACAGIAUtAAE6AAEgBiAFLQACOgACIAYgBS0AAzoAAyAGIAUtAAQ6AAQgBiAFLQAFOgAFIAYgBS0ABjoABiAGIAUtAAc6AAcgBkEIaiEGIAVBCGoiBSAHRw0ACwsgACAGNgIEAkAgByAKRg0AIAcgCmsiBkUNACAHIAZrIAEgBvwKAAALIARFDQIgASACIAT8CgAADwsgByAAKAIAIgZrIARqIgNBAE4EQCABIAZrIQggCEH/////ByAFIAZrIgVBAXQiCSADIAMgCUkbIAVB/////wNPGyIDBH8gAxCiCQVBAAsiBWohCSAEBEAgCSACIAT8CgAACyAEIAlqIQQgByABayIHBEAgBCABIAf8CgAACyAAIAE2AgQgCARAIAUgBiAI/AoAAAsgACADIAVqNgIIIAAgBCAHajYCBCAAIAU2AgAgBkUNAiAGECsMAgsQoAkACyAAIAU2AgQCQCAGIApGDQAgBiAKayIFRQ0AIAYgBWsgASAF/AoAAAsgC0UNACABIAIgC/wKAAALC8oGAQd/AkAgBEEATA0AAkACQCAAKAIIIgYgACgCBCIHayAETgRAIAcgAWsiCSAESARAIAMgAiAJaiIGayEFAkAgAyAGRg0AIAVFDQAgByAGIAX8CgAACyAAIAUgB2oiCDYCBCAJQQBMDQQgASAEaiEKIAgiBiAEayIFIAdPDQMgBEEPSyAEIAdqIAJqIAEgA2prIgNBEE9xRQ0CIANBcHEhBEEAIQYDQCAGIAhqIAUgBmr9AAAA/QsAACAGQRBqIgYgBEcNAAsgBCAIaiEGIAMgBEYNAyAEIAVqIQUMAgsgASAEaiEKAkAgByIFIAUgBGsiA00NACAFIQsgBEEQTwRAIARB8P///wdxIQZBACEFA0AgBSAHaiADIAVq/QAAAP0LAAAgBUEQaiIFIAZHDQALIAYgB2ohBSAEIAZGDQEgAyAGaiEDCwJAIAsgA2tBB3EiCUUEQCADIQYMAQsgAyEGA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgCEEBaiIIIAlHDQALCyADIAdrQXlPDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgB0cNAAsLIAAgBTYCBAJAIAcgCkYNACAHIAprIgVFDQAgByAFayABIAX8CgAACyAERQ0DIAEgAiAE/AoAAA8LIAcgACgCACIFayAEaiIDQQBOBEAgASAFayEIIAhB/////wcgBiAFayIGQQF0IgkgAyADIAlJGyAGQf////8DTxsiAwR/IAMQogkFQQALIgZqIQkgBARAIAkgAiAE/AoAAAsgBCAJaiEEIAcgAWsiBwRAIAQgASAH/AoAAAsgACABNgIEIAgEQCAGIAUgCPwKAAALIAAgAyAGajYCCCAAIAQgB2o2AgQgACAGNgIAIAVFDQMgBRArDAMLEKAJAAsDQCAGIAUtAAA6AAAgBkEBaiEGIAVBAWoiBSAHSQ0ACwsgACAGNgIEAkAgCCAKRg0AIAggCmsiBUUNACAIIAVrIAEgBfwKAAALIAlFDQAgASACIAn8CgAACwvABgEHfwJAAkACQCAAKAIIIgYgACgCBCIHayAETgRAIAcgAWsiCSAESARAIAMgAiAJaiIGayEFAkAgAyAGRg0AIAVFDQAgByAGIAX8CgAACyAAIAUgB2oiCDYCBCAJQQBMDQQgASAEaiEKIAgiBiAEayIFIAdPDQMgBEEPSyAEIAdqIAJqIAEgA2prIgNBEE9xRQ0CIANBcHEhBEEAIQYDQCAGIAhqIAUgBmr9AAAA/QsAACAGQRBqIgYgBEcNAAsgBCAIaiEGIAMgBEYNAyAEIAVqIQUMAgsgASAEaiEKAkAgByIFIAUgBGsiA00NACAFIQsgBEEQTwRAIARB8ABxIQZBACEFA0AgBSAHaiADIAVq/QAAAP0LAAAgBUEQaiIFIAZHDQALIAYgB2ohBSAEIAZGDQEgAyAGaiEDCwJAIAsgA2tBB3EiCUUEQCADIQYMAQsgAyEGA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgCEEBaiIIIAlHDQALCyADIAdrQXlPDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgB0cNAAsLIAAgBTYCBAJAIAcgCkYNACAHIAprIgVFDQAgByAFayABIAX8CgAACyAERQ0DIAEgAiAE/AoAAA8LIAcgACgCACIFayAEaiIDQQBOBEAgASAFayEIIAhB/////wcgBiAFayIGQQF0IgkgAyADIAlJGyAGQf////8DTxsiAwR/IAMQogkFQQALIgZqIQkgBARAIAkgAiAE/AoAAAsgBCAJaiEEIAcgAWsiBwRAIAQgASAH/AoAAAsgACABNgIEIAgEQCAGIAUgCPwKAAALIAAgAyAGajYCCCAAIAQgB2o2AgQgACAGNgIAIAVFDQMgBRArDAMLEKAJAAsDQCAGIAUtAAA6AAAgBkEBaiEGIAVBAWoiBSAHSQ0ACwsgACAGNgIEAkAgCCAKRg0AIAggCmsiBUUNACAIIAVrIAEgBfwKAAALIAlFDQAgASACIAn8CgAACwvUBAIEfwF7IwBBoAFrIgMkACADQQA6AHwgA0EANgJ4IANBu88BOwEUIANB6pKYvwY2AhAgAyADQRBqIgQ2AgwgA0GuAToAFiADQYX5ADsAFyADQe4AOgAZIANB8+UBOwEaIANBpQE6ABwgA0HP6gM7AB0gA0E6OgAfIANB0Rw7ASAgA0HSADoAIiADQQU6ACUgA0H/tgI7ACMgA0EfOgAoIANB6JgCOwEmIANBg7MDOwApIANBqwE6ACsgAygCDCIFQc0BOgAeIAVB28ADOwAcIAMoAgwiBUIANwAgIAVBGToAHyADQQxqIAEgAhCqCQJAIAMtAHxFBEAgAygCeCEGDAELIANB6pKYvwY2AhAgAyAENgIMIARBrgE6AAYgBEG7zwE7AAQgAygCDCIEQe4AOgAJIARBhfkAOwAHIAMoAgwiBEGlAToADCAEQfPlATsACiADKAIMIgRBOjoADyAEQc/qAzsADSADKAIMIgRB0gA6ABIgBEHRHDsAECADKAIMIgRBBToAFSAEQf+2AjsAEyADKAIMIgRBHzoAGCAEQeiYAjsAFiADKAIMIgRBqwE6ABsgBEGDswM7ABkgAygCDCIEQc0BOgAeIARB28ADOwAcIAMoAgwiBEIANwAgIARBGToAHyADQQA6AHwgA0EANgJ4CyADQYABaiADQQxqIANBOGogBhCrCSAAIAP9AASAASAD/QAEkAEiB/0NDw4NDAsKCQgHBgUEAwIBAP0LAxAgACAHIAf9DQ8ODQwLCgkIBwYFBAMCAQD9CwMAIANBoAFqJAAL8QcCAn8TfiMAQdABayIDJAAgA0FAayACKQMAIhJCACABKQMAIgVCABA2IANB0ABqIAIpAwgiE0IAIAVCABA2IANB4ABqIAIpAxAiFEIAIAVCABA2IANB8ABqIAIpAxgiFUIAIAVCABA2IAMpA1ghCSADKQNgIQYgAykDaCELIAMpA3AhByADKQN4IQ0gAyADKQNQIgggAykDSHwiCiADKQNAIgVCIIYiDnwiDzcDiAEgAyAGIAl8IgkgCCAKVq18IgggBUIgiCIRfCIMIAogD1atfCIPNwOQASADIAUgByALfCIKIAggCVQgBiAJVnKtfCIGIA59Igl8IgsgDCAPViAIIAxWcq18Igw3A5gBIAMgBSANQgB8IgggBiAKVCAHIApWcq18IgcgEX0iCiAGIAlUrX0iBnwiBSAJIAtWIAsgDFZyrXwiCTcDoAEgAyAFIAZUIAUgCVZyrSAQIAcgCFQgCCAQVHKtfCAHIApUIAYgClZyrX18Ig43A6gBQQEhBANAIAMgASAEQQN0IgJqKQMAIgVCACASQgAQNiADQRBqIAVCACATQgAQNiADQSBqIAVCACAUQgAQNiADQTBqIAVCACAVQgAQNiADQYABaiACaiICKQMAIQYgAkIANwMAIAIgAikDCCIIIAMpAxB8IgcgBiADKQMAfCIFIAZUrXwiBiADKQMIfCIKIAVCIIYiDXwiCzcDCCACIAIpAxAiDyADKQMgfCIJIAcgCFQgBiAHVHKtfCIHIAMpAxh8IgggBiAKVq18IgYgBUIgiCIRfCIMIAogC1atfCIWNwMQIAIgAikDGCIXIAMpAzB8IgogCSAPVCAHIAlUcq18IgkgAykDKHwiCyAGIAhUIAcgCFZyrXwiByANfSIIIAV8Ig0gBiAMViAMIBZWcq18Igw3AxggAiAOIAogF1QgCSAKVHKtfCIOIAMpAzh8IgYgByALVCAJIAtWcq18IgogEX0iCSAHIAhUrX0iByAFfCIFIAwgDVQgCCANVnKtfCIINwMgIAIgBSAHVCAFIAhWcq0gECAGIA5UIAYgClZyrXwgByAJViAJIApWcq19fCIONwMoIARBAWoiBEEERw0ACyABIAMpA7gBIgUgBSAAKQM4Igp8IgUgACkDMCIHIAMpA7ABIgl8IgYgB1QgBiAAKQMoIgggAykDqAEiDHwiByAIVCAHIAApAyAiCCADKQOgASILfCINIAhUrXwiCCAHVHKtfCIHIAZUcq18IgYgAykDwAEgECAFIApUIAUgBlZyrXxRIgIbNwMYIAEgCSAHIAIbNwMQIAEgDCAIIAIbNwMIIAEgCyANIAIbNwMAIANB0AFqJAALsAUCAX4DfwJAIAAtAHBBAUYEQCAAQeqSmL8GNgIEIABBu88BOwAIIABCrovy8bbe3NLPADcACiAAQfX1xPIANgASIABB0v4BOwAWIABCm4ug4/jj4OyrfzcAGCAAQdvAt84BNgAgIABCADcAJCAAQQA6AHAgAEEANgJsIAAgAEEEajYCAAwBCyAAKAJsIgVFBEAMAQsgAEEsaiEGIAJBwAAgBWsiBCACIARJGyIEBEAgBSAGaiABIAT8CgAACyAAIAAoAmwgBGoiBTYCbCAFQcAARw0AIAAoAgAiBSkAICEDIAUgBkHAABCsCSAAKAIAIANCOIYgA0KA/gODQiiGhCADQoCA/AeDQhiGIANCgICA+A+DQgiGhIQgA0IIiEKAgID4D4MgA0IYiEKAgPwHg4QgA0IoiEKA/gODIANCOIiEhIRCQH0iA0I4hiADQoD+A4NCKIaEIANCgID8B4NCGIYgA0KAgID4D4NCCIaEhCADQgiIQoCAgPgPgyADQhiIQoCA/AeDhCADQiiIQoD+A4MgA0I4iISEhDcAICAAQQA2AmwLIAIgBGsiBUHAAE8EQCAAKAIAIgYpACAhAyAGIAEgBGogBUFAcSIFEKwJIAAoAgAgBa0gA0I4hiADQoD+A4NCKIaEIANCgID8B4NCGIYgA0KAgID4D4NCCIaEhCADQgiIQoCAgPgPgyADQhiIQoCA/AeDhCADQiiIQoD+A4MgA0I4iISEhHwiA0I4hiADQoD+A4NCKIaEIANCgID8B4NCGIYgA0KAgID4D4NCCIaEhCADQgiIQoCAgPgPgyADQhiIQoCA/AeDhCADQiiIQoD+A4MgA0I4iISEhDcAICAEIAVqIQQLIAIgBEcEQCACIARrIgIEQCAAQSxqIAEgBGogAvwKAAALIAAgAjYCbAsLiAcCC38IfiMAQYABayIFJAAgASgCACIEMQAgIQ8gBDEAISEQIAQxACIhESAEMQAjIRIgBDEAJCETIAQxACUhFCAEMQAmIRUgBDEAJyEWIAQgAiADEKwJQT8hBwJAAkAgA0E/cSIERQRAIAVBgAE6AABBwAAhAkE+IQhBPSEJQTwhCkE7IQtBOiEMQTkhDUE4IQ5BNyEGDAELIAQEQCAFIAIgA2ogBGsgBPwKAAALQYABIQIgBCAFakGAAToAAEE3IQYgBEE3SwRAQf8AIQdB/gAhCEH9ACEJQfwAIQpB+wAhC0H6ACEMQfkAIQ1B+AAhDkH3ACEGDAELQcAAIQJBPiEIQT0hCUE8IQpBOyELQTohDEE5IQ1BOCEOIARBN0YNAQsgBiAEayIGRQ0AIAQgBWpBAWpBACAG/AsACyAFIA5qIAOtIBVCCIYgFoQgFEIQhoQgE0IYhoQgEkIghoQgEUIohoQgEEIwhoQgD0I4hoR8Ig9CNYg8AAAgBSANaiAPQi2IPAAAIAUgDGogD0IliDwAACAFIAtqIA9CHYg8AAAgBSAKaiAPQhWIPAAAIAUgCWogD0INiDwAACAFIAhqIA9CBYg8AAAgBSAHaiAPp0EDdDoAACABKAIAIAUgAhCsCSAAIAEoAgAtAAA6AAAgACABKAIALQABOgABIAAgASgCAC0AAjoAAiAAIAEoAgAtAAM6AAMgACABKAIALQAEOgAEIAAgASgCAC0ABToABSAAIAEoAgAtAAY6AAYgACABKAIALQAHOgAHIAAgASgCAC0ACDoACCAAIAEoAgAtAAk6AAkgACABKAIALQAKOgAKIAAgASgCAC0ACzoACyAAIAEoAgAtAAw6AAwgACABKAIALQANOgANIAAgASgCAC0ADjoADiAAIAEoAgAtAA86AA8gACABKAIALQAQOgAQIAAgASgCAC0AEToAESAAIAEoAgAtABI6ABIgACABKAIALQATOgATIAAgASgCAC0AFDoAFCAAIAEoAgAtABU6ABUgACABKAIALQAWOgAWIAAgASgCAC0AFzoAFyAAIAEoAgAtABg6ABggACABKAIALQAZOgAZIAAgASgCAC0AGjoAGiAAIAEoAgAtABs6ABsgACABKAIALQAcOgAcIAAgASgCAC0AHToAHSAAIAEoAgAtAB46AB4gACABKAIALQAfOgAfIAVBgAFqJAALjkQBIn8gACgAHCISQRh0IBJBgP4DcUEIdHIgEkEIdkGA/gNxIBJBGHZyciEiIAAoABgiEkEYdCASQYD+A3FBCHRyIBJBCHZBgP4DcSASQRh2cnIhISAAKAAUIhJBGHQgEkGA/gNxQQh0ciASQQh2QYD+A3EgEkEYdnJyIR8gACgAECISQRh0IBJBgP4DcUEIdHIgEkEIdkGA/gNxIBJBGHZyciEHIAAoAAwiEkEYdCASQYD+A3FBCHRyIBJBCHZBgP4DcSASQRh2cnIhIyAAKAAIIhJBGHQgEkGA/gNxQQh0ciASQQh2QYD+A3EgEkEYdnJyISAgACgABCISQRh0IBJBgP4DcUEIdHIgEkEIdkGA/gNxIBJBGHZyciEdIAAoAAAiEkEYdCASQYD+A3FBCHRyIBJBCHZBgP4DcSASQRh2cnIhEiACQcAATwRAA0AgByABKAAAIgNBGHQgA0GA/gNxQQh0ciADQQh2QYD+A3EgA0EYdnJyIhggB0EadyAHQRV3cyAHQQd3cyAiaiAhIAdBf3NxIAcgH3FyampBmN+olARqIgQgHSAgcyAScSAdICBxcyASQR53IBJBE3dzIBJBCndzamoiA0EedyADQRN3cyADQQp3cyADIBIgHXNxIBIgHXFzaiAhIAQgI2oiCCAHcSAfIAhBf3NxcmogASgABCIEQRh0IARBgP4DcUEIdHIgBEEIdkGA/gNxIARBGHZyciIUaiAIQRp3IAhBFXdzIAhBB3dzakGRid2JB2oiBWoiBEEedyAEQRN3cyAEQQp3cyAEIAMgEnNxIAMgEnFzaiAfIAEoAAgiBkEYdCAGQYD+A3FBCHRyIAZBCHZBgP4DcSAGQRh2cnIiFWogBSAgaiINIAhxIAcgDUF/c3FyaiANQRp3IA1BFXdzIA1BB3dzakGxiPzRBGsiDmoiBkEedyAGQRN3cyAGQQp3cyAGIAMgBHNxIAMgBHFzaiAHIAEoAAwiBUEYdCAFQYD+A3FBCHRyIAVBCHZBgP4DcSAFQRh2cnIiE2ogDiAdaiIOIA1xIAggDkF/c3FyaiAOQRp3IA5BFXdzIA5BB3dzakHbyKiyAWsiCWoiBUEedyAFQRN3cyAFQQp3cyAFIAQgBnNxIAQgBnFzaiAIIAEoABAiD0EYdCAPQYD+A3FBCHRyIA9BCHZBgP4DcSAPQRh2cnIiFmogCSASaiIPIA5xIA0gD0F/c3FyaiAPQRp3IA9BFXdzIA9BB3dzakHbhNvKA2oiCmoiCEEedyAIQRN3cyAIQQp3cyAIIAUgBnNxIAUgBnFzaiANIAEoABQiCUEYdCAJQYD+A3FBCHRyIAlBCHZBgP4DcSAJQRh2cnIiGWogAyAKaiINIA9xIA4gDUF/c3FyaiANQRp3IA1BFXdzIA1BB3dzakHxo8TPBWoiCmoiA0EedyADQRN3cyADQQp3cyADIAUgCHNxIAUgCHFzaiAOIAEoABgiCUEYdCAJQYD+A3FBCHRyIAlBCHZBgP4DcSAJQRh2cnIiGmogBCAKaiIOIA1xIA8gDkF/c3FyaiAOQRp3IA5BFXdzIA5BB3dzakHc+oHuBmsiCmoiBEEedyAEQRN3cyAEQQp3cyAEIAMgCHNxIAMgCHFzaiAPIAEoABwiCUEYdCAJQYD+A3FBCHRyIAlBCHZBgP4DcSAJQRh2cnIiG2ogBiAKaiIPIA5xIA0gD0F/c3FyaiAPQRp3IA9BFXdzIA9BB3dzakGrwo6nBWsiCmoiBkEedyAGQRN3cyAGQQp3cyAGIAMgBHNxIAMgBHFzaiABKAAgIglBGHQgCUGA/gNxQQh0ciAJQQh2QYD+A3EgCUEYdnJyIgcgDWogBSAKaiINIA9xIA4gDUF/c3FyaiANQRp3IA1BFXdzIA1BB3dzakHoquG/AmsiCmoiBUEedyAFQRN3cyAFQQp3cyAFIAQgBnNxIAQgBnFzaiABKAAkIglBGHQgCUGA/gNxQQh0ciAJQQh2QYD+A3EgCUEYdnJyIgsgDmogCCAKaiIOIA1xIA8gDkF/c3FyaiAOQRp3IA5BFXdzIA5BB3dzakGBto2UAWoiCmoiCEEedyAIQRN3cyAIQQp3cyAIIAUgBnNxIAUgBnFzaiABKAAoIglBGHQgCUGA/gNxQQh0ciAJQQh2QYD+A3EgCUEYdnJyIgwgD2ogAyAKaiIPIA5xIA0gD0F/c3FyaiAPQRp3IA9BFXdzIA9BB3dzakG+i8ahAmoiCmoiA0EedyADQRN3cyADQQp3cyADIAUgCHNxIAUgCHFzaiABKAAsIglBGHQgCUGA/gNxQQh0ciAJQQh2QYD+A3EgCUEYdnJyIhEgDWogBCAKaiIJIA9xIA4gCUF/c3FyaiAJQRp3IAlBFXdzIAlBB3dzakHD+7GoBWoiCmoiBEEedyAEQRN3cyAEQQp3cyAEIAMgCHNxIAMgCHFzaiABKAAwIg1BGHQgDUGA/gNxQQh0ciANQQh2QYD+A3EgDUEYdnJyIh4gDmogBiAKaiIKIAlxIA8gCkF/c3FyaiAKQRp3IApBFXdzIApBB3dzakH0uvmVB2oiDmoiBkEedyAGQRN3cyAGQQp3cyAGIAMgBHNxIAMgBHFzaiABKAA0Ig1BGHQgDUGA/gNxQQh0ciANQQh2QYD+A3EgDUEYdnJyIiQgD2ogBSAOaiIQIApxIAkgEEF/c3FyaiAQQRp3IBBBFXdzIBBBB3dzakGCnIX5B2siDmoiBUEedyAFQRN3cyAFQQp3cyAFIAQgBnNxIAQgBnFzaiABKAA4Ig1BGHQgDUGA/gNxQQh0ciANQQh2QYD+A3EgDUEYdnJyIg0gCWogCCAOaiIXIBBxIAogF0F/c3FyaiAXQRp3IBdBFXdzIBdBB3dzakHZ8o+hBmsiD2oiCEEedyAIQRN3cyAIQQp3cyAIIAUgBnNxIAUgBnFzaiABKAA8Ig5BGHQgDkGA/gNxQQh0ciAOQQh2QYD+A3EgDkEYdnJyIg4gCmogAyAPaiIcIBdxIBAgHEF/c3FyaiAcQRp3IBxBFXdzIBxBB3dzakGMnZDzA2siCWoiA0EedyADQRN3cyADQQp3cyADIAUgCHNxIAUgCHFzaiAUQRl3IBRBDndzIBRBA3ZzIBhqIAtqIA1BD3cgDUENd3MgDUEKdnNqIg8gEGogBCAJaiIYIBxxIBcgGEF/c3FyaiAYQRp3IBhBFXdzIBhBB3dzakG/rJLbAWsiCmoiBEEedyAEQRN3cyAEQQp3cyAEIAMgCHNxIAMgCHFzaiAVQRl3IBVBDndzIBVBA3ZzIBRqIAxqIA5BD3cgDkENd3MgDkEKdnNqIgkgF2ogBiAKaiIUIBhxIBwgFEF/c3FyaiAUQRp3IBRBFXdzIBRBB3dzakH68IaCAWsiEGoiBkEedyAGQRN3cyAGQQp3cyAGIAMgBHNxIAMgBHFzaiATQRl3IBNBDndzIBNBA3ZzIBVqIBFqIA9BD3cgD0ENd3MgD0EKdnNqIgogHGogBSAQaiIVIBRxIBggFUF/c3FyaiAVQRp3IBVBFXdzIBVBB3dzakHGu4b+AGoiF2oiBUEedyAFQRN3cyAFQQp3cyAFIAQgBnNxIAQgBnFzaiAWQRl3IBZBDndzIBZBA3ZzIBNqIB5qIAlBD3cgCUENd3MgCUEKdnNqIhAgGGogCCAXaiITIBVxIBQgE0F/c3FyaiATQRp3IBNBFXdzIBNBB3dzakHMw7KgAmoiHGoiCEEedyAIQRN3cyAIQQp3cyAIIAUgBnNxIAUgBnFzaiAZQRl3IBlBDndzIBlBA3ZzIBZqICRqIApBD3cgCkENd3MgCkEKdnNqIhcgFGogAyAcaiIWIBNxIBUgFkF/c3FyaiAWQRp3IBZBFXdzIBZBB3dzakHv2KTvAmoiGGoiA0EedyADQRN3cyADQQp3cyADIAUgCHNxIAUgCHFzaiAaQRl3IBpBDndzIBpBA3ZzIBlqIA1qIBBBD3cgEEENd3MgEEEKdnNqIhwgFWogBCAYaiIZIBZxIBMgGUF/c3FyaiAZQRp3IBlBFXdzIBlBB3dzakGqidLTBGoiFGoiBEEedyAEQRN3cyAEQQp3cyAEIAMgCHNxIAMgCHFzaiAbQRl3IBtBDndzIBtBA3ZzIBpqIA5qIBdBD3cgF0ENd3MgF0EKdnNqIhggE2ogBiAUaiIaIBlxIBYgGkF/c3FyaiAaQRp3IBpBFXdzIBpBB3dzakHc08LlBWoiFWoiBkEedyAGQRN3cyAGQQp3cyAGIAMgBHNxIAMgBHFzaiAHQRl3IAdBDndzIAdBA3ZzIBtqIA9qIBxBD3cgHEENd3MgHEEKdnNqIhQgFmogBSAVaiIbIBpxIBkgG0F/c3FyaiAbQRp3IBtBFXdzIBtBB3dzakHakea3B2oiE2oiBUEedyAFQRN3cyAFQQp3cyAFIAQgBnNxIAQgBnFzaiALQRl3IAtBDndzIAtBA3ZzIAdqIAlqIBhBD3cgGEENd3MgGEEKdnNqIhUgGWogCCATaiIHIBtxIBogB0F/c3FyaiAHQRp3IAdBFXdzIAdBB3dzakGu3Ya+BmsiFmoiCEEedyAIQRN3cyAIQQp3cyAIIAUgBnNxIAUgBnFzaiAMQRl3IAxBDndzIAxBA3ZzIAtqIApqIBRBD3cgFEENd3MgFEEKdnNqIhMgGmogAyAWaiILIAdxIBsgC0F/c3FyaiALQRp3IAtBFXdzIAtBB3dzakGT87i+BWsiGWoiA0EedyADQRN3cyADQQp3cyADIAUgCHNxIAUgCHFzaiARQRl3IBFBDndzIBFBA3ZzIAxqIBBqIBVBD3cgFUENd3MgFUEKdnNqIhYgG2ogBCAZaiIMIAtxIAcgDEF/c3FyaiAMQRp3IAxBFXdzIAxBB3dzakG4sPP/BGsiGmoiBEEedyAEQRN3cyAEQQp3cyAEIAMgCHNxIAMgCHFzaiAeQRl3IB5BDndzIB5BA3ZzIBFqIBdqIBNBD3cgE0ENd3MgE0EKdnNqIhkgB2ogBiAaaiIHIAxxIAsgB0F/c3FyaiAHQRp3IAdBFXdzIAdBB3dzakG5gJqFBGsiG2oiBkEedyAGQRN3cyAGQQp3cyAGIAMgBHNxIAMgBHFzaiAkQRl3ICRBDndzICRBA3ZzIB5qIBxqIBZBD3cgFkENd3MgFkEKdnNqIhogC2ogBSAbaiILIAdxIAwgC0F/c3FyaiALQRp3IAtBFXdzIAtBB3dzakGN6P/IA2siEWoiBUEedyAFQRN3cyAFQQp3cyAFIAQgBnNxIAQgBnFzaiANQRl3IA1BDndzIA1BA3ZzICRqIBhqIBlBD3cgGUENd3MgGUEKdnNqIhsgDGogCCARaiIMIAtxIAcgDEF/c3FyaiAMQRp3IAxBFXdzIAxBB3dzakG53eHSAmsiEWoiCEEedyAIQRN3cyAIQQp3cyAIIAUgBnNxIAUgBnFzaiAOQRl3IA5BDndzIA5BA3ZzIA1qIBRqIBpBD3cgGkENd3MgGkEKdnNqIg0gB2ogAyARaiIHIAxxIAsgB0F/c3FyaiAHQRp3IAdBFXdzIAdBB3dzakHRxqk2aiIRaiIDQR53IANBE3dzIANBCndzIAMgBSAIc3EgBSAIcXNqIA9BGXcgD0EOd3MgD0EDdnMgDmogFWogG0EPdyAbQQ13cyAbQQp2c2oiDiALaiAEIBFqIgsgB3EgDCALQX9zcXJqIAtBGncgC0EVd3MgC0EHd3NqQefSpKEBaiIRaiIEQR53IARBE3dzIARBCndzIAQgAyAIc3EgAyAIcXNqIAlBGXcgCUEOd3MgCUEDdnMgD2ogE2ogDUEPdyANQQ13cyANQQp2c2oiDyAMaiAGIBFqIgwgC3EgByAMQX9zcXJqIAxBGncgDEEVd3MgDEEHd3NqQYWV3L0CaiIRaiIGQR53IAZBE3dzIAZBCndzIAYgAyAEc3EgAyAEcXNqIApBGXcgCkEOd3MgCkEDdnMgCWogFmogDkEPdyAOQQ13cyAOQQp2c2oiCSAHaiAFIBFqIgcgDHEgCyAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQbjC7PACaiIRaiIFQR53IAVBE3dzIAVBCndzIAUgBCAGc3EgBCAGcXNqIBBBGXcgEEEOd3MgEEEDdnMgCmogGWogD0EPdyAPQQ13cyAPQQp2c2oiCiALaiAIIBFqIgsgB3EgDCALQX9zcXJqIAtBGncgC0EVd3MgC0EHd3NqQfzbsekEaiIRaiIIQR53IAhBE3dzIAhBCndzIAggBSAGc3EgBSAGcXNqIBdBGXcgF0EOd3MgF0EDdnMgEGogGmogCUEPdyAJQQ13cyAJQQp2c2oiECAMaiADIBFqIgwgC3EgByAMQX9zcXJqIAxBGncgDEEVd3MgDEEHd3NqQZOa4JkFaiIRaiIDQR53IANBE3dzIANBCndzIAMgBSAIc3EgBSAIcXNqIBxBGXcgHEEOd3MgHEEDdnMgF2ogG2ogCkEPdyAKQQ13cyAKQQp2c2oiFyAHaiAEIBFqIgcgDHEgCyAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQdTmqagGaiIRaiIEQR53IARBE3dzIARBCndzIAQgAyAIc3EgAyAIcXNqIBhBGXcgGEEOd3MgGEEDdnMgHGogDWogEEEPdyAQQQ13cyAQQQp2c2oiHCALaiAGIBFqIgsgB3EgDCALQX9zcXJqIAtBGncgC0EVd3MgC0EHd3NqQbuVqLMHaiIRaiIGQR53IAZBE3dzIAZBCndzIAYgAyAEc3EgAyAEcXNqIBRBGXcgFEEOd3MgFEEDdnMgGGogDmogF0EPdyAXQQ13cyAXQQp2c2oiGCAMaiAFIBFqIgwgC3EgByAMQX9zcXJqIAxBGncgDEEVd3MgDEEHd3NqQdLt9PEHayIRaiIFQR53IAVBE3dzIAVBCndzIAUgBCAGc3EgBCAGcXNqIBVBGXcgFUEOd3MgFUEDdnMgFGogD2ogHEEPdyAcQQ13cyAcQQp2c2oiFCAHaiAIIBFqIgcgDHEgCyAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQfumt+wGayIRaiIIQR53IAhBE3dzIAhBCndzIAggBSAGc3EgBSAGcXNqIBNBGXcgE0EOd3MgE0EDdnMgFWogCWogGEEPdyAYQQ13cyAYQQp2c2oiFSALaiADIBFqIgsgB3EgDCALQX9zcXJqIAtBGncgC0EVd3MgC0EHd3NqQd+ugOoFayIRaiIDQR53IANBE3dzIANBCndzIAMgBSAIc3EgBSAIcXNqIBZBGXcgFkEOd3MgFkEDdnMgE2ogCmogFEEPdyAUQQ13cyAUQQp2c2oiEyAMaiAEIBFqIgwgC3EgByAMQX9zcXJqIAxBGncgDEEVd3MgDEEHd3NqQbWzlr8FayIRaiIEQR53IARBE3dzIARBCndzIAQgAyAIc3EgAyAIcXNqIBlBGXcgGUEOd3MgGUEDdnMgFmogEGogFUEPdyAVQQ13cyAVQQp2c2oiFiAHaiAGIBFqIgcgDHEgCyAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQZDp0e0DayIRaiIGQR53IAZBE3dzIAZBCndzIAYgAyAEc3EgAyAEcXNqIBpBGXcgGkEOd3MgGkEDdnMgGWogF2ogE0EPdyATQQ13cyATQQp2c2oiGSALaiAFIBFqIgsgB3EgDCALQX9zcXJqIAtBGncgC0EVd3MgC0EHd3NqQd3czsQDayIRaiIFQR53IAVBE3dzIAVBCndzIAUgBCAGc3EgBCAGcXNqIBtBGXcgG0EOd3MgG0EDdnMgGmogHGogFkEPdyAWQQ13cyAWQQp2c2oiGiAMaiAIIBFqIgwgC3EgByAMQX9zcXJqIAxBGncgDEEVd3MgDEEHd3NqQeevtPMCayIRaiIIQR53IAhBE3dzIAhBCndzIAggBSAGc3EgBSAGcXNqIA1BGXcgDUEOd3MgDUEDdnMgG2ogGGogGUEPdyAZQQ13cyAZQQp2c2oiGyAHaiADIBFqIgcgDHEgCyAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQdzzm8sCayIRaiIDQR53IANBE3dzIANBCndzIAMgBSAIc3EgBSAIcXNqIA5BGXcgDkEOd3MgDkEDdnMgDWogFGogGkEPdyAaQQ13cyAaQQp2c2oiDSALaiAEIBFqIgsgB3EgDCALQX9zcXJqIAtBGncgC0EVd3MgC0EHd3NqQfuUx98AayIRaiIEQR53IARBE3dzIARBCndzIAQgAyAIc3EgAyAIcXNqIA9BGXcgD0EOd3MgD0EDdnMgDmogFWogG0EPdyAbQQ13cyAbQQp2c2oiDiAMaiAGIBFqIgwgC3EgByAMQX9zcXJqIAxBGncgDEEVd3MgDEEHd3NqQfDAqoMBaiIRaiIGQR53IAZBE3dzIAZBCndzIAYgAyAEc3EgAyAEcXNqIAlBGXcgCUEOd3MgCUEDdnMgD2ogE2ogDUEPdyANQQ13cyANQQp2c2oiDyAHaiAFIBFqIgcgDHEgCyAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQZaCk80BaiIeaiIFQR53IAVBE3dzIAVBCndzIAUgBCAGc3EgBCAGcXNqIApBGXcgCkEOd3MgCkEDdnMgCWogFmogDkEPdyAOQQ13cyAOQQp2c2oiESALaiAIIB5qIgkgB3EgDCAJQX9zcXJqIAlBGncgCUEVd3MgCUEHd3NqQYjY3fEBaiIeaiIIQR53IAhBE3dzIAhBCndzIAggBSAGc3EgBSAGcXNqIBBBGXcgEEEOd3MgEEEDdnMgCmogGWogD0EPdyAPQQ13cyAPQQp2c2oiCyAMaiADIB5qIgogCXEgByAKQX9zcXJqIApBGncgCkEVd3MgCkEHd3NqQczuoboCaiIeaiIDQR53IANBE3dzIANBCndzIAMgBSAIc3EgBSAIcXNqIBdBGXcgF0EOd3MgF0EDdnMgEGogGmogEUEPdyARQQ13cyARQQp2c2oiDCAHaiAEIB5qIhAgCnEgCSAQQX9zcXJqIBBBGncgEEEVd3MgEEEHd3NqQbX5wqUDaiIHaiIEQR53IARBE3dzIARBCndzIAQgAyAIc3EgAyAIcXNqIBxBGXcgHEEOd3MgHEEDdnMgF2ogG2ogC0EPdyALQQ13cyALQQp2c2oiFyAJaiAGIAdqIgkgEHEgCiAJQX9zcXJqIAlBGncgCUEVd3MgCUEHd3NqQbOZ8MgDaiIHaiIGQR53IAZBE3dzIAZBCndzIAYgAyAEc3EgAyAEcXNqIBhBGXcgGEEOd3MgGEEDdnMgHGogDWogDEEPdyAMQQ13cyAMQQp2c2oiHCAKaiAFIAdqIgogCXEgECAKQX9zcXJqIApBGncgCkEVd3MgCkEHd3NqQcrU4vYEaiIHaiIFQR53IAVBE3dzIAVBCndzIAUgBCAGc3EgBCAGcXNqIBRBGXcgFEEOd3MgFEEDdnMgGGogDmogF0EPdyAXQQ13cyAXQQp2c2oiGCAQaiAHIAhqIhAgCnEgCSAQQX9zcXJqIBBBGncgEEEVd3MgEEEHd3NqQc+U89wFaiIHaiIIQR53IAhBE3dzIAhBCndzIAggBSAGc3EgBSAGcXNqIBVBGXcgFUEOd3MgFUEDdnMgFGogD2ogHEEPdyAcQQ13cyAcQQp2c2oiFCAJaiADIAdqIgkgEHEgCiAJQX9zcXJqIAlBGncgCUEVd3MgCUEHd3NqQfPfucEGaiIHaiIDQR53IANBE3dzIANBCndzIAMgBSAIc3EgBSAIcXNqIBNBGXcgE0EOd3MgE0EDdnMgFWogEWogGEEPdyAYQQ13cyAYQQp2c2oiFSAKaiAEIAdqIgogCXEgECAKQX9zcXJqIApBGncgCkEVd3MgCkEHd3NqQe6FvqQHaiIHaiIEQR53IARBE3dzIARBCndzIAQgAyAIc3EgAyAIcXNqIBZBGXcgFkEOd3MgFkEDdnMgE2ogC2ogFEEPdyAUQQ13cyAUQQp2c2oiEyAQaiAGIAdqIhAgCnEgCSAQQX9zcXJqIBBBGncgEEEVd3MgEEEHd3NqQe/GlcUHaiIHaiIGQR53IAZBE3dzIAZBCndzIAYgAyAEc3EgAyAEcXNqIBlBGXcgGUEOd3MgGUEDdnMgFmogDGogFUEPdyAVQQ13cyAVQQp2c2oiFiAJaiAFIAdqIgkgEHEgCiAJQX9zcXJqIAlBGncgCUEVd3MgCUEHd3NqQeyP3tkHayIHaiIFQR53IAVBE3dzIAVBCndzIAUgBCAGc3EgBCAGcXNqIBpBGXcgGkEOd3MgGkEDdnMgGWogF2ogE0EPdyATQQ13cyATQQp2c2oiFyAKaiAHIAhqIgogCXEgECAKQX9zcXJqIApBGncgCkEVd3MgCkEHd3NqQfj745kHayITaiIIaiADIBNqIgcgDiAPQRl3IA9BDndzIA9BA3ZzaiAVaiANQRl3IA1BDndzIA1BA3ZzIBtqIBhqIBdBD3cgF0ENd3MgF0EKdnNqIg9BD3cgD0ENd3MgD0EKdnNqaiANIA5BGXcgDkEOd3MgDkEDdnNqIBRqIBtBGXcgG0EOd3MgG0EDdnMgGmogHGogFkEPdyAWQQ13cyAWQQp2c2oiA0EPdyADQQ13cyADQQp2c2ogCmogCSAPaiADIBBqIAcgCnEgCSAHQX9zcXJqIAdBGncgB0EVd3MgB0EHd3NqQYaAhPoGayIDIARqIgQgB3EgCiAEQX9zcXJqIARBGncgBEEVd3MgBEEHd3NqQZWmvt0FayIPIAZqIg0gBHEgByANQX9zcXJqIA1BGncgDUEVd3MgDUEHd3NqQYm4mYgEayIJIAVqIg4gDXEgBCAOQX9zcXJqIA5BGncgDkEVd3MgDkEHd3NqQY6OuswDayIKaiEHIAhBHncgCEETd3MgCEEKd3MgCCAFIAZzcSAFIAZxc2ogA2oiA0EedyADQRN3cyADQQp3cyADIAUgCHNxIAUgCHFzaiAPaiIGQR53IAZBE3dzIAZBCndzIAYgAyAIc3EgAyAIcXNqIAlqIgUgAyAGc3EgAyAGcXMgEmogBUEedyAFQRN3cyAFQQp3c2ogCmohEiAOIB9qIR8gBSAdaiEdIA0gIWohISAGICBqISAgBCAiaiEiIAMgI2ohIyABQUBrIQEgAkFAaiICQT9LDQALCyAAIB06AAcgACAgOgALIAAgIzoADyAAIAc6ABMgACASQRB2OgABIAAgEkEYdjoAACAAIB1BCHY6AAYgACAdQRB2OgAFIAAgHUEYdjoABCAAICBBCHY6AAogACAgQRB2OgAJIAAgIEEYdjoACCAAICNBCHY6AA4gACAjQRB2OgANIAAgI0EYdjoADCAAIAdBCHY6ABIgACAHQRB2OgARIAAgEkEIdCASQYD+A3FBCHZyOwACIAAgHzoAFyAAIAdBGHY6ABAgACAfQQh2OgAWIAAgH0EQdjoAFSAAICE6ABsgACAfQRh2OgAUIAAgIUEIdjoAGiAAICFBEHY6ABkgACAiOgAfIAAgIUEYdjoAGCAAICJBCHY6AB4gACAiQRB2OgAdIAAgIkEYdjoAHAuJHgIKfwF7IwBBQGoiCyQAAkACQAJAIABBmNwBaiACIAEQrglFBEBBACECQQFBpIMrQQAQmwkMAQsgACgCqNwBIgZBpRFPBEAgCyAGNgIAQQFB+cEpIAsQmwlBACECDAELQSQQogkiDSAGQQh2OgASIA0gBjoAEyANQZDOMf0ABAD9CwAAIA1BoM4xLwEAOwAQIA1BFGohAgJAIAZFDQAgDUEkaiEIA0ACQCABIAAoAqTcAWogB2ohCQJAIAIgCEkEQCACIAktAAA6AAAgAkEBaiECDAELIAIgDWsiAkEBaiIGQQBIDQFB/////wcgCCANayIIQQF0IgogBiAGIApJGyAIQf////8DTxsiCAR/IAgQogkFQQALIgYgAmoiCiAJLQAAOgAAIAIEQCAGIA0gAvwKAAALIAYgCGohCCAKQQFqIQIgDQRAIA0QKwsgBiENCyAHQQFqIgcgACgCqNwBSQ0BDAILCxCgCQALIAIgDWsgDUEjIABBqBJqIABB6ABqIABB+BJqIgIQrwkgAiAALQCoEkHgBWxqIgJBBGsoAgAhBiACQQhrKAIAIQggAkEMaygCACEJIAJBEGsoAgAhCiAAKAIAIg4oAgAhDyALQTBqIgcgAkEUaygCACIM/REgDEEIdv0cASAMQRB2/RwCIAxBGHb9HAP9DAAAAAAAAAAAAAAAAAAAAAD9DQAECAwAAAAAAAAAAAAAAAAgAkEYaygCACIM/REgDEEIdv0cASAMQRB2/RwCIAxBGHb9HAP9DAAAAAAAAAAAAAAAAAAAAAD9DQAECAwAAAAAAAAAAAAAAAD9DQABAgMQERITAAECAwABAgMgAkEcaygCACIM/REgDEEIdv0cASAMQRB2/RwCIAxBGHb9HAP9DAAAAAAAAAAAAAAAAAAAAAD9DQAECAwAAAAAAAAAAAAAAAAgAkEgaygCACIC/REgAkEIdv0cASACQRB2/RwCIAJBGHb9HAP9DAAAAAAAAAAAAAAAAAAAAAD9DQAECAwAAAAAAAAAAAAAAAD9DQABAgMAAQIDAAECAxAREhP9DQABAgMEBQYHGBkaGxwdHh/9CwMAIAsgBv0RIAZBCHb9HAEgBkEQdv0cAiAGQRh2/RwD/QwAAAAAAAAAAAAAAAAAAAAA/Q0ABAgMAAAAAAAAAAAAAAAAIAj9ESAIQQh2/RwBIAhBEHb9HAIgCEEYdv0cA/0MAAAAAAAAAAAAAAAAAAAAAP0NAAQIDAAAAAAAAAAAAAAAAP0NAAECAxAREhMAAQIDAAECAyAJ/REgCUEIdv0cASAJQRB2/RwCIAlBGHb9HAP9DAAAAAAAAAAAAAAAAAAAAAD9DQAECAwAAAAAAAAAAAAAAAAgCv0RIApBCHb9HAEgCkEQdv0cAiAKQRh2/RwD/QwAAAAAAAAAAAAAAAAAAAAA/Q0ABAgMAAAAAAAAAAAAAAAA/Q0AAQIDAAECAwABAgMQERIT/Q0AAQIDBAUGBxgZGhscHR4f/QsDICAPIAtBIGogD0FAaxCkCSAAIAf9AAMA/QsDGCAAIAv9AAMg/QsDCCAAQbzeAWogBSgAEDYAACAAIAX9AAAA/QsArN4BIAEgACgCpNwBakEFaiIGIAAoAsTdAWoiCP0AABAhECAOKAIAIQIgByAI/QAAACAQ/Q0PDg0MCwoJCAcGBQQDAgEA/QsEACALIBAgEP0NDw4NDAsKCQgHBgUEAwIBAP0LBCAgAiALQSBqIAJBQGsQpAkgACAH/QAEAP0LAzggACAL/QAEIP0LAyggBiAAKALY3QFqIgb9AAAQIRAgDigCACECIAcgBv0AAAAgEP0NDw4NDAsKCQgHBgUEAwIBAP0LBAAgCyAQIBD9DQ8ODQwLCgkIBwYFBAMCAQD9CwQgIAIgC0EgaiACQUBrEKQJIAAgB/0ABAD9CwNYIAAgC/0ABCD9CwNIAkAgACgCzBIiBiAAKALIEiIHayICIARJBEAgBCACayIIIAAoAtASIgkgBmtNBEAgCARAIAZBACAI/AsACyAAIAYgCGo2AswSDAILQf////8HIAkgB2siBkEBdCIJIAQgBCAJSRsgBkH/////A08bIgkQogkhBiAIBEAgAiAGakEAIAj8CwALIAIEQCAGIAcgAvwKAAALIAAgBiAJajYC0BIgACAEIAZqNgLMEiAAIAY2AsgSIAdFDQEgBxArDAELIAIgBE0NACAAIAQgB2o2AswSCwJ/AkACQAJAIAAoAtgSIgggACgC1BIiB2siAkEUbSIGIARJBEAgBCAGayIGIAAoAtwSIgkgCGtBFG1NBEAgBkEUbEEUayICIAJBFHBrQRRqIgIEQCAIQQAgAvwLAAsgACACIAhqNgLYEgwCCyACQRRtIAZqIgFBzZmz5gBPDQJBACEIQcyZs+YAIAkgB2tBFG0iCUEBdCIKIAEgASAKSRsgCUHmzJkzTxsiAQRAIAFBzZmz5gBPDQcgAUEUbBCiCSEICyACIAhqIQkgBkEUbEEUayIGIAZBFHBrQRRqIgYEQCAJQQAgBvwLAAsgCSACQWxtQRRsaiEKIAIEQCAKIAcgAvwKAAALIAAgCCABQRRsajYC3BIgACAGIAlqNgLYEiAAIAo2AtQSIAdFDQEgBxArDAELIAQgBk8NACAAIAcgBEEUbGo2AtgSCwJAIAAoAvASIAAoAuwSIgdrQQN1IgIgBEkEQCAAQewSaiAEIAJrELAJDAELIAIgBE0NACAAIAcgBEEDdGo2AvASCwJAIAAoAuQSIAAoAuASIgdrQQN1IgIgBEkEQCAAQeASaiAEIAJrELAJDAELIAIgBE0NACAAIAcgBEEDdGo2AuQSCyAAKAK0EiICIAAoArASIgdrIghBDG0iBiAESQRAIAQgBmsiBiAAKAK4EiIJIAJrQQxtTQRAIAZBDGxBDGsiByAHQQxwa0EMaiIHBEAgAkEAIAf8CwALIAAgAiAHajYCtBIMAwtB1arVqgEgCSAHa0EMbSICQQF0IgkgBCAEIAlJGyACQarVqtUATxsiAkHWqtWqAU8NBSACQQxsIgEQogkiCiAIaiECIAZBDGxBDGsiBiAGQQxwa0EMaiIGBEAgAkEAIAb8CwALIAIgCEF0bUEMbGohCSAIBEAgCSAHIAj8CgAACyAAIAEgCmo2ArgSIAAgAiAGajYCtBIgACAJNgKwEiAHRQ0CIAcQKwwCCyAEIAZJBEAgAiAHIARBDGxqIghHBEADQCACQQxrIgcoAgAiBgRAIAJBCGsgBjYCACAGECsLIAggByICRw0ACwsgACAINgK0EgsgBA0BQQEMAgsQoAkAC0EAIQcDQAJAIAAoArASIAdBDGxqIgIoAgQiCSACKAIAIghrIgZB/wBNBEBBgAEgBmsiASACKAIIIgogCWtNBEAgAQRAIAlBACAB/AsACyACIAEgCWo2AgQMAgtB/////wdBgAEgCiAIayIJQQF0IgogCkGAAU0bIAlB/////wNPGyIKEKIJIQkgAQRAIAYgCWpBACAB/AsACyAGBEAgCSAIIAb8CgAACyACIAkgCmo2AgggAiAJQYABajYCBCACIAk2AgAgCEUNASAIECsMAQsgBkGAAUYNACACIAhBgAFqNgIECyAHQQFqIgcgBEcNAAtBAAshCQJAIAAoAsASIgIgACgCvBIiB2siCEEMbSIGIARJBEAgBCAGayIGIAAoAsQSIgEgAmtBDG1NBEAgBkEMbEEMayIHIAdBDHBrQQxqIgcEQCACQQAgB/wLAAsgACACIAdqNgLAEgwCC0HVqtWqASABIAdrQQxtIgJBAXQiASAEIAEgBEsbIAJBqtWq1QBPGyICQdaq1aoBTw0DIAJBDGwiChCiCSIFIAhqIQIgBkEMbEEMayIGIAZBDHBrQQxqIgYEQCACQQAgBvwLAAsgAiAIQXRtQQxsaiEBIAgEQCABIAcgCPwKAAALIAAgBSAKajYCxBIgACACIAZqNgLAEiAAIAE2ArwSIAdFDQEgBxArDAELIAQgBk8NACACIAcgBEEMbGoiCEcEQANAIAJBDGsiBygCACIGBEAgAkEIayAGNgIAIAYQKwsgCCAHIgJHDQALCyAAIAg2AsASC0EBIQICQCAJDQBBACEGA0ACQCAAKAK8EiAGQQxsaiICKAIEIgkgAigCACIIayIHQeAFbSIBQQFNBEBBAiABayIBIAIoAggiCiAJa0HgBW1NBEBB4AUgB2siByAHQeAFcGtB4AVqIgcEQCAJQQAgB/wLAAsgAiAHIAlqNgIEDAILIAdB4AVtIAFqIglBopbkAk8NBkGhluQCIAogCGtB4AVtIgFBAXQiCiAJIAkgCkkbIAFBkIuyAU8bIgEEfyABQaKW5AJPDQYgAUHgBWwQogkFQQALIgogB2ohCUHgBSAHayIFIAVB4AVwa0HgBWoiDARAIAlBACAM/AsACyAJIAdBoHptQeAFbGohBSAHBEAgBSAIIAf8CgAACyACIAogAUHgBWxqNgIIIAIgCSAMajYCBCACIAU2AgAgCEUNASAIECsMAQsgB0HAC0YNACACIAhBwAtqNgIECyAGQQFqIgYgBEcNAAsgC0EgakEEciEPQQAhDiALQTBqIQkCQANAIAAoAojeASICIAAoAozeASIBRwRAIAMgDkHoAGxqIgwoAmAhBgNAIAIoAgwhCiACKAIIIQUgAigCACEIIAIoAgQhByAJIAIpAiA3AwAgCyAC/QACEP0LAyACQCAGIAdHDQAgDCACKAIwIgcgCGogBhCEAg0AIAIoAiwgByACKAIoIgJqQQIgACgCyBIgDmogDkEMbCIHIAAoArASaigCACAAKAK8EiAHaigCABCvCSAAKALUEiAOQRRsaiIHIA/9AAIA/QsCACAHIA8oAhA2AhAgDkEDdCIHIAAoAuASaiIBIAY2AgQgASAIIAJrNgIAIAAoAuwSIAdqIgcgCjYCBCAHIAUgAms2AgBBASECIA5BAWoiDiAERw0DDAULIAJBNGoiAiABRw0ACwwCCwsgAyAOQegAbGooAmAhBgsgCyAGNgIQIAsgAyAOQegAbGo2AhRBAUHihCogC0EQahCbCUEAIQILIA1FDQAgDRArCyALQUBrJAAgAg8LEKAJAAsQoAkAC4EcAg9/AX4jAEGQAWsiBSQAIAVBADYCjAEgBUEANgKAASAFQgA3A3gCQCAFQegAaiACIAEgBUGMAWoQtwlFBEBBAUG/0ylBABCbCQwBCyAFKAJsQQVHDQAgBSgCcCIDRQ0AIAUoAnghCAJAA0ACQCAIIARBBnRqIgEoAgRBA0cNACABKAIMQQlHDQBB7O8pIAIgASgCCGpBCRCEAkUNAgsgBEEBaiIEIANHDQALQQAhBAwBC0EAIQQgASgCJEEERw0AIAEoAixFDQAgASgCMCIKRQ0AIAooAgRBBUcNACAKKAIIIgNFDQAgCigCECEIQQAhAQNAAkACQCAIIAFBBnRqIgQoAgRBA0cNACAEKAIMQQdHDQBBi4wrIAIgBCgCCGpBBxCEAkUNAQtBACEEIAFBAWoiASADRw0BDAILCyAAQfwBaiAAKAL8ASACIAQoAihqIgEgASAEKAIsIgRqIAQQpQlBACEEIAooAgRBBUcNACAKKAIIIghFDQAgCigCECELQQAhAQNAAkACQCALIAFBBnRqIgMoAgRBA0cNACADKAIMQQxHDQBBhrsrIAIgAygCCGpBDBCEAkUNAQsgAUEBaiIBIAhHDQEMAgsLIAMoAiRBBUcNACADKAIoIghFDQAgA0EgaiENIAMoAjAhC0EAIQEDQAJAAkAgCyABQQZ0aiIDKAIEQQNHDQAgAygCDEEKRw0AQZbfKiACIAMoAghqQQoQhAJFDQELIAFBAWoiASAIRw0BDAILCyAFIAE2AmQgAygCJEEERw0AIAMoAixBA0kNACAAIAMoAjAiECgCQDYCACAAIBAoAkg2AgwgACAQKAJMNgIQIAMoAixBBEkNACAAIAMoAjAiASgCYDYCFCAAIAEoAmg2AiAgACABKAJsNgIkIA0gAkEKQfWCKiAFQeQAahC4CSIBRQ0AIAFBIGogAkERQZHyKyAFQeQAahC4CSIORQ0AIAVBHGohDAJ/QQAgDigCJEEERw0AGkEAIA4oAixFDQAaIA4oAjALIQ0gAEHwAWohBiAFQdAAaiEPIAxBEGohB0EBIREDQAJAAkAgDQRAIAVBADYCWCAFQgA3A1AgBSANKAIQIgQoAggiATYCPAJAIAVBQGsgAiABIAQoAgxqIAVBPGoQtwkEQCAFKAJEQQVGDQELIAUoAlAhAwwCC0EAIQQgBSgCUCEDIAUoAkgiCEUNAQJAA0ACQCADIARBBnRqIgEoAgRBA0cNACABKAIMQRFHDQBBopYqIAIgASgCCGpBERCEAkUNAgsgBEEBaiIEIAhHDQALQQAhAQwDCyAFIAQ2AmRBACEEAkADQAJAIAMgBEEGdGoiCygCBEEDRw0AIAsoAgxBDEcNAEGe/SogAiALKAIIakEMEIQCRQ0CCyAEQQFqIgQgCEcNAAtBACEBDAMLIAUgBDYCZEEAIQQDQAJAAkAgAyAEQQZ0aiIJKAIEQQNHDQAgCSgCDEEIRw0AQcLiKyACIAkoAghqQQgQhAJFDQELIAggBEEBaiIERw0BDAMLCyAFIAQ2AmQgBSABQSBqIgQQuQk2AgggBSAEELoJNgIMIAUgC0EgaiIEELkJNgIQIAUgBBC6CTYCFCAFIAkpAyg+AhggB0EANgIAIAz9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAUgDSgCADYCMCANKAIQKAIMIQQgBSACNgI4IAUgBEEEajYCNCAFQQhqIQgCQCAGKAIEIgQgBigCCCILSQRAIAQgCP0AAgD9CwIAIAQgCCgCMDYCMCAEIAj9AAIg/QsCICAEIAj9AAIQ/QsCECAGIARBNGo2AgQMAQsCQCAEIAYoAgAiDWsiCUE0bUEBaiIEQcWdsSdJBEBBxJ2xJyALIA1rQTRtIgtBAXQiASAEIAEgBEsbIAtB4s7YE08bIgsEfyALQcWdsSdPDQIgC0E0bBCiCQVBAAsiASAJaiIEIAj9AAIA/QsCACAEIAgoAjA2AjAgBCAI/QACIP0LAiAgBCAI/QACEP0LAhAgBCAJQUxtQTRsaiEIIAkEQCAIIA0gCfwKAAALIAYgASALQTRsajYCCCAGIARBNGoiBDYCBCAGIAg2AgAgDQRAIA0QKwsgBiAENgIEDAILEKAJAAsQoAkACyAOKAIwIBFBBXRqQQAgESAOKAIsSRtBACAOKAIkQQRGGyENQQEhASARQQFqIREMAgsgCiACQQxBk7srIAVB5ABqELgJIgFFDQMgAUEgaiACQQpBod8qIAVB5ABqELgJIgFFDQMgAUEgaiACQQ9BjYkrIAVB5ABqELgJIgFFDQMgASgCJEEERw0DIAEoAixBBEkNAyAAIAEoAjAiBCgCYDYCKCAAIAQoAmg2AjQgACAEKAJsNgI4IBAoAkghAUEAIQQgBUEANgJAIAVBADYCICAFQgA3AxgCQCAFQQhqIAEgAmpBBWoiASAQKAJMQQVrIAVBQGsQtwlFDQAgBUEIaiABQQxBos4xIABBxABqELgJIgNFDQAgACADKAIANgI8IAAgAygCIDYCQCADQSBqIQggAygCJEF+cUECRgRAIAAgAygCKDYCSCAAIAMoAiw2AkwLIAggAUEJQa7OMSAAQdgAahC4CSIDRQ0AIAAgAygCADYCUCAAIAMoAiA2AlQgAygCJEF+cUECRgRAIAAgAygCKDYCXCAAIAMoAiw2AmALIAggAUEKQbfOMSAAQewAahC4CSIDRQ0AIAAgAygCADYCZCAAIAMoAiA2AmggAygCJEF+cUECRgRAIAAgAygCKDYCcCAAIAMoAiw2AnQLIAVBCGogAUENQcHOMSAAQYABahC4CSIDRQ0AIAAgAygCADYCeCAAIAMoAiA2AnwgA0EgaiEIIAMoAiRBfnFBAkYEQCAAIAMoAig2AoQBIAAgAygCLDYCiAELIAggAUEJQc7OMSAAQZQBahC4CSIDRQ0AIAAgAygCADYCjAEgACADKAIgNgKQASADQSBqIQggAygCJEF+cUECRgRAIAAgAygCKDYCmAEgACADKAIsNgKcAQsgCEJ/IABBqAFqELsJIgNFDQAgACADKAIANgKgASAAIAMoAiA2AqQBIAMoAiRBfnFBAkYEQCAAIAMoAig2AqwBIAAgAygCLDYCsAELIAhCfiAAQbwBahC7CSIDRQ0AIAAgAygCADYCtAEgACADKAIgNgK4ASADKAIkQX5xQQJGBEAgACADKAIoNgLAASAAIAMoAiw2AsQBCyAFQQhqIAFBDEHXzjEgAEHQAWoQuAkiA0UNACAAIAMoAgA2AsgBIAAgAygCIDYCzAEgA0EgaiEIIAMoAiRBfnFBAkYEQCAAIAMoAig2AtQBIAAgAygCLDYC2AELIAggAUERQfDOMSAAQeQBahC4CSIDRQ0AIAAgAygCADYC3AEgACADKAIgNgLgASADKAIkQX5xQQJGBEAgACADKAIoNgLoASAAIAMoAiw2AuwBCyAAKALwASIBIAAoAvQBIghHBEAgA0EgaiEKA0ACfyABNQIQIRIgAUEcaiEHQQAhCQJAIAooAgRBBUcNACAKKAIIIgxFDQAgCigCECEPQQAhBgJAA0AgDyAGQQZ0aiIJKAIERQRAIAkpAwggElENAgsgBkEBaiIGIAxHDQALQQAMAgsgByAGNgIACyAJCyIDRQ0CIAEgAygCADYCFCABIAMoAiA2AhggAygCJEF+cUECRgRAIAEgAygCKDYCICABIAMoAiw2AiQLIAFBNGoiASAIRw0ACwsCQCAAQYgCaiIDIgwoAggiBiAMKAIAIgdrQRJPBEAgDCgCBCIGIAdrIglBEU0EQCAGIAdGBH8gBgUgCQRAIAdBkM4xIAn8CgAACyAMKAIECyEBIAlBkM4xaiEKAkACQCAHQaLOMWogBkGQzjFqIgZrIglBEEkEQCABIQcMAQsgASAHaiAGa0EQSQRAIAEhBwwBCyAJQXBxIQZBACEHA0AgASAHaiAHIApq/QAAAP0LAAAgB0EQaiIHIAZHDQALIAEgBmohByAGIAlGDQEgBiAKaiEKCwJAQaLOMSAKa0EHcSIPRQRAIAohBgwBC0EAIQkgCiEGA0AgByAGLQAAOgAAIAdBAWohByAGQQFqIQYgCUEBaiIJIA9HDQALCyAKQaLOMWtBeEsNAANAIAcgBi0AADoAACAHIAYtAAE6AAEgByAGLQACOgACIAcgBi0AAzoAAyAHIAYtAAQ6AAQgByAGLQAFOgAFIAcgBi0ABjoABiAHIAYtAAc6AAcgB0EIaiEHIAZBCGoiBkGizjFHDQALCyAMIAEgByABa2o2AgQMAgsgB0GgzjEvAQA7ABAgB0GQzjH9AAQA/QsAACAMIAdBEmo2AgQMAQsgBwRAIAwgBzYCBCAHECtBACEGCyAMQf////8HQRIgBkEBdCIHIAdBEk0bIAZB/////wNPGyIGEKIJIgc2AgQgDCAHNgIAIAwgBiAHajYCCCAHQaDOMS8BADsAECAHQZDOMf0ABAD9CwAAIAwgB0ESajYCBAsgAyAAKAIQQQh2ELwJIAMgACgCEBC8CSAAKAIQRQRAQQEhBAwBC0EAIQEDQCADIAIgACgCDGogAWotAAAQvAlBASEEIAFBAWoiASAAKAIQSQ0ACwsgBUEIaiIBKAIQIgAEQCABQRBqIgEgABC9CSABKAIAECsLDAMLQQAhASADDQBBACEEDAILIA8gAxC9CSAFKAJQECtBACEEIAENAAsLIAUoAngiAQRAIAVB+ABqIAEQvQkgBSgCeBArCyAFQZABaiQAIAQLmwoDDn8BewF+IwBB4AJrIgckACADIABByABqQQZ2OgAAAkACQCAABEACQAJAIABBEEkNACAEIAFrQRBJDQAgAEFwcSEJQQAhAwNAIAMgBGogASADav0AAAD9CwAAIANBEGoiAyAJRw0ACyAAIAlGDQELIAkhAyAAQQNxIgsEQANAIAMgBGogASADai0AADoAACADQQFqIQMgBkEBaiIGIAtHDQALCyAJIABrQXxLDQADQCADIARqIAEgA2otAAA6AAAgBCADQQFqIgZqIAEgBmotAAA6AAAgBCADQQJqIgZqIAEgBmotAAA6AAAgBCADQQNqIgZqIAEgBmotAAA6AAAgA0EEaiIDIABHDQALCyAAIARqQYABOgAAIABBAWoiA0E/cUE5TwRAQT4gAGtBP3EiAUEBaiIGBEAgAyAEakEAIAb8CwALIAAgAWpBAmohAwsgA0E4cUE4Rg0CDAELIARBgAE6AABBASEDCwNAIAMgBGpBADoAACADQQFqIgNBOHFBOEcNAAsLIAMgBGoiAUEANgAAIAEgAEELdEGAgPwHcSAAQRt0ciAAQQV2QYD+A3EgAEEDdEEYdnJyNgAEIANBB3FFBEACQCADQQhqIgYgAkEGdCIBTw0AIAEgA2tBCGsiA0UNACAEIAZqQQAgA/wLAAtBkNQxIQgDQCAEIA1BBnRqIQZBACEDA0AgA0ECdCIBIAdBIGpqIAEgBmr9AAAAIhQgFP0NAQUJDQAAAAAAAAAAAAAAAP2JAf2pAUEI/asBIBRBEP2rAf1QIBQgFP0NAgYKDgAAAAAAAAAAAAAAAP2JAf2pAf1QQQj9qwEgFCAU/Q0DBwsPAAAAAAAAAAAAAAAA/YkB/akB/VD9CwQAIANBBGoiA0EQRw0ACyAHIAcpA1g3A5gBIAcgB/0AA0j9CwOIASAHIAf9AAM4/QsDeCAHIAf9AAMo/QsDaCAHIAcpAyAiFTcDYCAFIA1B4AVsaiIKQUBqIQsgFachAEEQIQEDQCABQQJ0IgkgB0HgAGpqIgMgA0EcaygCACADQQhrKAIAIgZBD3cgBkENd3MgBkEKdnNqIABqIANBPGsoAgAiA0EZdyADQQ53cyADQQN2c2oiBjYCACAJIAtqIAY2AgAgAyEAIAFBAWoiAUHAAEcNAAsgCkHAA2ohEiAKQcABaiETIAgoAhwhDCAIKAIYIQ4gCCgCFCEPIAgoAhAhCyAIKAIMIQAgCCgCCCEJIAgoAgQhESAIKAIAIRBBACEGA0AgEyAGQQJ0IgFqIAdB4ABqIAFqKAIAIAFBsNQxaigCACALIgNBGncgA0EVd3MgA0EHd3MgAyAPcWogDGogA0F/cyAOcWpqaiIMIABqIgs2AgAgASASaiAQIgEgCSIAIBEiCXNxIAAgCXFzIAFBHncgAUETd3MgAUEKd3NqIAxqIhA2AgAgDiEMIA8hDiADIQ8gASERIAZBAWoiBkHAAEcNAAsgCiAIKAIAIBBqNgLABSAKIAgoAgQgAWo2AsQFIAogCCgCCCAJajYCyAUgCiAIKAIMIABqNgLMBSAKIAgoAhAgC2o2AtAFIAogCCgCFCADajYC1AUgCiAIKAIYIA5qNgLYBSAKIAgoAhwgDGo2AtwFIApBwAVqIQggDUEBaiINIAJHDQALIAdB4AJqJAAPCyAHQfnvKjYCEEHkAEH0hyogB0EQahCbCUGQljQoAgAoAgAhAyAHQfnvKjYCACADQZGMKiAHEGwAC4oCAQd/IAEgACgCCCIDIAAoAgQiAmtBA3VNBEAgACABBH8gAUEDdCIBBEAgAkEAIAH8CwALIAEgAmoFIAILNgIEDwsCQCACIAAoAgAiBWsiB0EDdSIGIAFqIgRBgICAgAJJBEBBACECQf////8BIAMgBWsiA0ECdSIIIAQgBCAISRsgA0H4////B08bIgQEQCAEQYCAgIACTw0CIARBA3QQogkhAgsgAiAHaiEDIAFBA3QiAQRAIANBACAB/AsACyADIAZBA3RrIQYgBwRAIAYgBSAH/AoAAAsgACACIARBA3RqNgIIIAAgASADajYCBCAAIAY2AgAgBQRAIAUQKwsPCxCgCQALEKAJAAvyAQEDfyMAQUBqIgIkAAJAIAEoAgAiAyABKAIEIgQoAgRJBEAgASADQQFqNgIAIAQoAgggA0EEdGogAP0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogAP0ABBD9CwQAIAJBQGskAA8LIAJBo9grNgIwQeQAQfSHKiACQTBqEJsJQZCWNCgCACgCACEBIAJBo9grNgIgIAFBkYwqIAJBIGoQbAALIAJBo9grNgIQQeQAQfSHKiACQRBqEJsJQZCWNCgCACgCACEBIAJBo9grNgIAIAFBkYwqIAIQbAAL1A4BCH8jAEHAAmsiBCQAAkACQAJAAkACQAJAAkACQAJAAkAgASgCACICIAEoAgQiAygCBEkEQCABIAJBAWo2AgAgAygCCCACQQV0aiICIAD9AAMI/QsDACACIAD9AAMY/QsDECABKAIAIgIgASgCBCIDKAIETw0BIAEgAkEBajYCACADKAIIIAJBBXRqIgIgAP0AAyj9CwMAIAIgAP0AAzj9CwMQIAEoAgAiAiABKAIEIgMoAgRPDQIgASACQQFqNgIAIAMoAgggAkEFdGoiAiAA/QADSP0LAwAgAiAA/QADWP0LAxAgASgCACICIAEoAgQiAygCBE8NAyABIAJBAWo2AgAgAygCCCACQQV0aiICIAD9AANo/QsDACACIAD9AAN4/QsDECABKAIAIgIgASgCBCIDKAIETw0EIAEgAkEBajYCACADKAIIIAJBBXRqIgIgAP0AA4gB/QsDACACIAD9AAOYAf0LAxAgASgCACICIAEoAgQiAygCBE8NBSABIAJBAWo2AgAgAygCCCACQQV0aiICIAD9AAOoAf0LAwAgAiAA/QADuAH9CwMQIAEoAgAiAiABKAIEIgMoAgRPDQUgASACQQFqNgIAIAMoAgggAkEFdGoiAiAA/QADyAH9CwMAIAIgAP0AA9gB/QsDECABKAIAIgIgASgCBCIDKAIETw0FIAEgAkEBajYCACADKAIIIAJBBXRqIgIgAP0AA+gB/QsDACACIAD9AAP4Af0LAxAgASgCACICIAEoAgQiAygCBE8NBSABIAJBAWo2AgAgAygCCCACQQV0aiICIAD9AAOIAv0LAwAgAiAA/QADmAL9CwMQIAEoAgAiAiABKAIEIgMoAgRPDQUgASACQQFqNgIAIAMoAgggAkEFdGoiAiAA/QADqAL9CwMAIAIgAP0AA7gC/QsDECABKAIAIgIgASgCBCIDKAIETw0FIAEgAkEBajYCACADKAIIIAJBBXRqIgIgAP0AA8gC/QsDACACIAD9AAPYAv0LAxAgASgCACICIAEoAgQiAygCBE8NBSABIAJBAWo2AgAgAygCCCACQQV0aiICIAD9AAPoAv0LAwAgAiAA/QAD+AL9CwMQIAEoAgAiAiABKAIEIgMoAgRPDQUgASACQQFqNgIAIAMoAgggAkEFdGoiAiAA/QADiAP9CwMAIAIgAP0AA5gD/QsDECAAQajDAWohBiAAQaiDAWohByAAQajDAGohCCAAQagDaiEJQQAhAANAIAEoAgAiAiABKAIEIgMoAgRPDQggASACQQFqNgIAIAMoAgggAkEFdGoiAyAJIABBBXQiAmoiBf0AAwD9CwMAIAMgBf0AAxD9CwMQIABB/wFGDQcgASgCACIDIAEoAgQiBSgCBE8NCSABIANBAWo2AgAgBSgCCCADQQV0aiIDIAIgCGoiBf0AAwD9CwMAIAMgBf0AAxD9CwMQIAEoAgAiAyABKAIEIgUoAgRPDQogASADQQFqNgIAIAUoAgggA0EFdGoiAyACIAdqIgX9AAMA/QsDACADIAX9AAMQ/QsDECABKAIAIgMgASgCBCIFKAIETw0LIAEgA0EBajYCACAFKAIIIANBBXRqIgMgAiAGaiIC/QADAP0LAwAgAyAC/QADEP0LAxAgAEEBaiEADAALAAsgBEGj2Cs2ArACQeQAQfSHKiAEQbACahCbCUGQljQoAgAoAgAhASAEQaPYKzYCoAIgAUGRjCogBEGgAmoQbAALIARBo9grNgKQAkHkAEH0hyogBEGQAmoQmwlBkJY0KAIAKAIAIQEgBEGj2Cs2AoACIAFBkYwqIARBgAJqEGwACyAEQaPYKzYC8AFB5ABB9IcqIARB8AFqEJsJQZCWNCgCACgCACEBIARBo9grNgLgASABQZGMKiAEQeABahBsAAsgBEGj2Cs2AtABQeQAQfSHKiAEQdABahCbCUGQljQoAgAoAgAhASAEQaPYKzYCwAEgAUGRjCogBEHAAWoQbAALIARBo9grNgKwAUHkAEH0hyogBEGwAWoQmwlBkJY0KAIAKAIAIQEgBEGj2Cs2AqABIAFBkYwqIARBoAFqEGwACyAEQaPYKzYCkAFB5ABB9IcqIARBkAFqEJsJQZCWNCgCACgCACEBIARBo9grNgKAASABQZGMKiAEQYABahBsAAsgBEHAAmokAA8LIARBo9grNgJwQeQAQfSHKiAEQfAAahCbCUGQljQoAgAoAgAhASAEQaPYKzYCYCABQZGMKiAEQeAAahBsAAsgBEGj2Cs2AlBB5ABB9IcqIARB0ABqEJsJQZCWNCgCACgCACEBIARBo9grNgJAIAFBkYwqIARBQGsQbAALIARBo9grNgIwQeQAQfSHKiAEQTBqEJsJQZCWNCgCACgCACEBIARBo9grNgIgIAFBkYwqIARBIGoQbAALIARBo9grNgIQQeQAQfSHKiAEQRBqEJsJQZCWNCgCACgCACEBIARBo9grNgIAIAFBkYwqIAQQbAALnRADB38Kewd+IwBB4BFrIgMkACAAKAJAIQcgA0HAEGpBAXIhCEEBIQYCQAJAA0AgACACQQR0aiIC/QoDCCEQ/QwGAAAAAAAAAAcAAAAAAAAAIQv9DAQAAAAAAAAABQAAAAAAAAAhDP0MAgAAAAAAAAADAAAAAAAAACEN/QwAAAAAAAAAAAEAAAAAAAAAIQ4gAv0KAwAiCv0dASEWQgAhFwNAIBenIANBwBBqaiAK/R0AIhQgDv0dACITiP0SIBYgDv0dASIViP0eASAQ/R0AIhggDv0MwP/////////A/////////yIP/c4BIgn9HQCI/RIgEP0dASIZIAn9HQGI/R4B/Qz//////////////////////QwAAAAAAAAAAAAAAAAAAAAAIBNCwABUG0J/QgAgFULAAFQb/R4B/VIgFCAN/R0AIhOI/RIgFiAN/R0BIhWI/R4BIBggDSAP/c4BIgn9HQCI/RIgGSAJ/R0BiP0eAf0M//////////////////////0MAAAAAAAAAAAAAAAAAAAAACATQsAAVBtCf0IAIBVCwABUG/0eAf1S/Q0ACBAYAAAAAAAAAAAAAAAAIBQgDP0dACITiP0SIBYgDP0dASIViP0eASAYIAwgD/3OASIJ/R0AiP0SIBkgCf0dAYj9HgH9DP/////////////////////9DAAAAAAAAAAAAAAAAAAAAAAgE0LAAFQbQn9CACAVQsAAVBv9HgH9UiIJ/RsA/RcEIAn9GwL9FwUgFCAL/R0AIhOI/RIgFiAL/R0BIhSI/R4BIBggCyAP/c4BIgn9HQCI/RIgGSAJ/R0BiP0eAf0M//////////////////////0MAAAAAAAAAAAAAAAAAAAAACATQsAAVBtCf0IAIBRCwABUG/0eAf1SIgn9GwD9FwYgCf0bAv0XB/0MAQEBAQEBAQEBAQEBAQEBASIR/U79WwMAACAO/QwIAAAAAAAAAAgAAAAAAAAAIgn9zgEhDiANIAn9zgEhDSAMIAn9zgEhDCALIAn9zgEhCyAXQgh8IhdCgAFSDQALQQAhBUEAIQIDQCADQcARaiACQQF0IgQgA0HAEGpqLQAAQQFxIAQgCGotAABBAXRBAnFyrSAHELQJIANBQGsgAkEFdGoiBCADQdARav0AAwD9CwMQIAQgA/0AA8AR/QsDACACQQFqIgJBwABHDQALA0AgASgCACICIAEoAgQiBCgCBE8NAiABIAJBAWo2AgAgBCgCCCACQQV0aiICIANBQGsgBUEFdGoiBP0AAwD9CwMAIAIgBP0AAxD9CwMQIAVBAWoiBUHAAEcNAAtBASECIAYhBUEAIQYgBQ0ACyAAQSBqIQBBACECQQEhBgNAIAAgAkEEdGoiAv0KAwghEP0MBgAAAAAAAAAHAAAAAAAAACEL/QwEAAAAAAAAAAUAAAAAAAAAIQz9DAIAAAAAAAAAAwAAAAAAAAAhDf0MAAAAAAAAAAABAAAAAAAAACEOIAL9CgMAIhL9HQEhFkIAIRcDQCAXpyADQcAQamogEv0dACIUIA79HQAiE4j9EiAWIA79HQEiFYj9HgEgEP0dACIYIA4gD/3OASIK/R0AiP0SIBD9HQEiGSAK/R0BiP0eAf0M//////////////////////0MAAAAAAAAAAAAAAAAAAAAACATQsAAVBtCf0IAIBVCwABUG/0eAf1SIBQgDf0dACITiP0SIBYgDf0dASIViP0eASAYIA0gD/3OASIK/R0AiP0SIBkgCv0dAYj9HgH9DP/////////////////////9DAAAAAAAAAAAAAAAAAAAAAAgE0LAAFQbQn9CACAVQsAAVBv9HgH9Uv0NAAgQGAAAAAAAAAAAAAAAACAUIAz9HQAiE4j9EiAWIAz9HQEiFYj9HgEgGCAMIA/9zgEiCv0dAIj9EiAZIAr9HQGI/R4B/Qz//////////////////////QwAAAAAAAAAAAAAAAAAAAAAIBNCwABUG0J/QgAgFULAAFQb/R4B/VIiCv0bAP0XBCAK/RsC/RcFIBQgC/0dACITiP0SIBYgC/0dASIUiP0eASAYIAsgD/3OASIK/R0AiP0SIBkgCv0dAYj9HgH9DP/////////////////////9DAAAAAAAAAAAAAAAAAAAAAAgE0LAAFQbQn9CACAUQsAAVBv9HgH9UiIK/RsA/RcGIAr9GwL9FwcgEf1O/VsDAAAgDiAJ/c4BIQ4gDSAJ/c4BIQ0gDCAJ/c4BIQwgCyAJ/c4BIQsgF0IIfCIXQoABUg0AC0EAIQVBACECA0AgA0HAEWogAkEBdCIEIANBwBBqai0AAEEBcSAEIAhqLQAAQQF0QQJxcq0gBxC0CSADQUBrIAJBBXRqIgQgA0HQEWr9AAMA/QsDECAEIAP9AAPAEf0LAwAgAkEBaiICQcAARw0ACwNAIAEoAgAiAiABKAIEIgQoAgRPDQMgASACQQFqNgIAIAQoAgggAkEFdGoiAiADQUBrIAVBBXRqIgT9AAMA/QsDACACIAT9AAMQ/QsDECAFQQFqIgVBwABHDQALQQEhAiAGIQVBACEGIAUNAAsgA0HgEWokAA8LIANBo9grNgIwQeQAQfSHKiADQTBqEJsJQZCWNCgCACgCACEBIANBo9grNgIgIAFBkYwqIANBIGoQbAALIANBo9grNgIQQeQAQfSHKiADQRBqEJsJQZCWNCgCACgCACEBIANBo9grNgIAIAFBkYwqIAMQbAALgwQDA38KfgF7IwBBgAFrIgMkAAJAQgAgAikDGCIMIAIpAxAiCiACKQMIIgaEhEIAUiIEIAFCAYYiASACKQMAIgtUcq1SBEAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LA3AgAyABNwNgIANCADcDaCACIANB4ABqIAJBQGsiBRCkCSANIAtCA1YgBHKtUQ0BIANB0ABqIgQgEP0LAwAgA0IANwNIIANCAzcDQCACIANBQGsgBRCkCSAAIAMpA3giDyADKQNYfSIOIAMpA3AiASAEKQMAfSIIIAFWIAggAykDaCIBIAMpA0h9IgcgAVYgByADKQNgIgkgAykDQH0iASAJVq19IgkgB1ZyrX0iByAIVnKtfSIIIAggDHwgByAKfCIKIAdUIAogBiAJfCIGIAlUIAYgASALfCILIAFUrXwiDCAGVHKtfCIGIApUcq18IA0gDiAPViAIIA5Wcq1RIgIbNwMYIAAgByAGIAIbNwMQIAAgCSAMIAIbNwMIIAAgASALIAIbNwMAIANBgAFqJAAPCyADQYDGKjYCEEHkAEH0hyogA0EQahCbCUGQljQoAgAoAgAhAiADQYDGKjYCACACQZGMKiADEGwACyADQYDGKjYCMEHkAEH0hyogA0EwahCbCUGQljQoAgAoAgAhAiADQYDGKjYCICACQZGMKiADQSBqEGwAC94XAxB/AnsBfiMAQYACayIFJAAgBUHwAWohCCAFQeABaiEJIAVB0AFqIQogBUHAAWohCyAFQbABaiEMIAVBoAFqIQ0gBUGQAWohDgJAAkACQAJAA0AgAiAGQQJ0aigCACEDIAVBgAFqQQBBgAH8CwAgAP0ABGAgAP0ABFAgAP0ABEAgAP0ABDD9Uf1R/VEhFEEAIQQDQCADQQF0QR5xIgetIhVCAoNQBHv9DAAAAAAAAAAAAAAAAAAAAAAFIAD9AARACyETIBVCBINCAFIEQCAA/QAEUCAT/VEhEwsgFUIIg0IAUgRAIAD9AARgIBP9USETCyAFQYABaiAEQQR0aiAUIAdBEE8EeyAA/QAEcCAT/VEFIBML/VH9CwQAIANBBHYhAyAEQQFqIgRBCEcNAAsgASgCACIDIAEoAgQiBCgCBE8NASABIANBAWo2AgAgBCgCCCADQQR0aiAF/QAEgAH9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogDv0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogDf0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogDP0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogC/0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogCv0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogCf0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQEgASADQQFqNgIAIAQoAgggA0EEdGogCP0ABAD9CwQAIAZBAWoiBkEwRw0ACyACQcADaiEQIAJBwAFqIREgBUHwAWohCCAFQeABaiEJIAVB0AFqIQogBUHAAWohCyAFQbABaiEMIAVBoAFqIQ0gBUGQAWohDkEAIQYDQCARIAZBAnQiD2ooAgAhAyAFQYABakEAQYAB/AsAIAD9AARgIAD9AARQIAD9AARAIAD9AAQw/VH9Uf1RIRRBACEEA0AgA0EBdEEecSIHrSIVQgKDUAR7/QwAAAAAAAAAAAAAAAAAAAAABSAA/QAEQAshEyAVQgSDQgBSBEAgAP0ABFAgE/1RIRMLIBVCCINCAFIEQCAA/QAEYCAT/VEhEwsgBUGAAWogBEEEdGogFCAHQRBPBHsgAP0ABHAgE/1RBSATC/1R/QsEACADQQR2IQMgBEEBaiIEQQhHDQALIAEoAgAiAyABKAIEIgQoAgRPDQIgASADQQFqNgIAIAQoAgggA0EEdGogBf0ABIAB/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIA79AAQA/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIA39AAQA/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIAz9AAQA/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIAv9AAQA/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIAr9AAQA/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIAn9AAQA/QsEACABKAIAIgMgASgCBCIEKAIETw0CIAEgA0EBajYCACAEKAIIIANBBHRqIAj9AAQA/QsEACAPIBBqKAIAIQNBACEEIBJFBEAgBUGAAWpBAEGAAfwLAAsgAP0ABGAgAP0ABFAgAP0ABEAgAP0ABDD9Uf1R/VEhFANAIANBAXRBHnEiB60iFUICg1AEe/0MAAAAAAAAAAAAAAAAAAAAAAUgAP0ABEALIRMgFUIEg0IAUgRAIAD9AARQIBP9USETCyAVQgiDQgBSBEAgAP0ABGAgE/1RIRMLIAVBgAFqIARBBHRqIBQgB0EQTwR7IAD9AARwIBP9UQUgEwv9Uf0LBAAgA0EEdiEDIARBAWoiBEEIRw0ACyABKAIAIgMgASgCBCIEKAIETw0DIAEgA0EBajYCACAEKAIIIANBBHRqIAX9AASAAf0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAO/QAEAP0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAN/QAEAP0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAM/QAEAP0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAL/QAEAP0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAK/QAEAP0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAJ/QAEAP0LBAAgASgCACIDIAEoAgQiBCgCBE8NAyABIANBAWo2AgAgBCgCCCADQQR0aiAI/QAEAP0LBAAgBkEBaiIGQcAARw0ACyACQcAFaiEOIAVB8AFqIQ8gBUHgAWohCCAFQdABaiEJIAVBwAFqIQogBUGwAWohCyAFQaABaiEMIAVBkAFqIQ1BACEGA0AgDiAGQQJ0aigCACEDIAVBgAFqQQBBgAH8CwAgAP0ABGAgAP0ABFAgAP0ABEAgAP0ABDD9Uf1R/VEhFEEAIQQDQCADQQF0QR5xIgetIhVCAoNQBHv9DAAAAAAAAAAAAAAAAAAAAAAFIAD9AARACyETIBVCBINCAFIEQCAA/QAEUCAT/VEhEwsgFUIIg0IAUgRAIAD9AARgIBP9USETCyAFQYABaiAEQQR0aiAUIAdBEE8EeyAA/QAEcCAT/VEFIBML/VH9CwQAIANBBHYhAyAEQQFqIgRBCEcNAAsgASgCACIDIAEoAgQiBCgCBE8NBCABIANBAWo2AgAgBCgCCCADQQR0aiAF/QAEgAH9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogDf0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogDP0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogC/0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogCv0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogCf0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogCP0ABAD9CwQAIAEoAgAiAyABKAIEIgQoAgRPDQQgASADQQFqNgIAIAQoAgggA0EEdGogD/0ABAD9CwQAIAZBAWoiBkEIRw0ACyAFQYACaiQADwsgBUGj2Cs2AnBB5ABB9IcqIAVB8ABqEJsJQZCWNCgCACgCACEAIAVBo9grNgJgIABBkYwqIAVB4ABqEGwACyAFQaPYKzYCUEHkAEH0hyogBUHQAGoQmwlBkJY0KAIAKAIAIQAgBUGj2Cs2AkAgAEGRjCogBUFAaxBsAAsgBUGj2Cs2AjBB5ABB9IcqIAVBMGoQmwlBkJY0KAIAKAIAIQAgBUGj2Cs2AiAgAEGRjCogBUEgahBsAAsgBUGj2Cs2AhBB5ABB9IcqIAVBEGoQmwlBkJY0KAIAKAIAIQAgBUGj2Cs2AgAgAEGRjCogBRBsAAvmAgMEfwJ+AnsjAEFAaiIDJAAgACgCBCEFIAI1AgAhCAJAAkADQCABKAIAIgQgASgCBCIGKAIETw0BIAX9AAQwIQkgASAEQQFqNgIAIAYoAgggBEEEdGr9DAAAAAAAAAAAAAAAAAAAAAAgCSAIIAeIQgGDUBv9CwQAIAdCAXwiB0IMUg0ACyAAKAIEIQUgAjUCBCEIQgAhBwNAIAEoAgAiBCABKAIEIgYoAgRPDQIgBf0ABDAhCSABIARBAWo2AgAgBigCCCAEQQR0aiAKIAkgCCAHiEIBg1Ab/QsEACAHQgF8IgdCDFINAAsgA0FAayQADwsgA0Gj2Cs2AjBB5ABB9IcqIANBMGoQmwlBkJY0KAIAKAIAIQEgA0Gj2Cs2AiAgAUGRjCogA0EgahBsAAsgA0Gj2Cs2AhBB5ABB9IcqIANBEGoQmwlBkJY0KAIAKAIAIQEgA0Gj2Cs2AgAgAUGRjCogAxBsAAuXBwEHfwJAAkACQAJAAkACQANAIAAgAygCACIFNgIAIAIgBU0NBiADIAVBAWoiBjYCAAJAIAEgBWotAAAiCkEfcSIEQRhJBEAgBiEFDAELAkACQAJAIARBGGsOAwABAgoLIAIgBk0NCSADIAVBAmoiBTYCACABIAZqLQAAIQQMAgsgBUECaiIEIAJPDQggASAEai0AACEEIAEgBmotAAAhBiADIAVBA2oiBTYCACAEIAZBCHRyIQQMAQsgBUEEaiIEIAJPDQcgAyAFQQJqIgg2AgAgASAGai0AACEGIAMgBUEDaiIJNgIAIAEgCGotAAAhCCADIAQ2AgAgASAJai0AACEJIAMgBUEFaiIFNgIAIAEgBGotAAAgCSAGQRB0IAhBCHRyckEIdHIhBAsCQCAKQQV2IgZBBkcEQAJAAkACQAJAIAZBAWsOBwABAQIDBwUICyAAQQE2AgQgAEIAIAStfTcDCEEBDwsgBCAFaiACSw0KIAAgBDYCDCAAIAU2AgggAEECQQMgBkECRhs2AgQgAyADKAIAIARqNgIADAcLIAQgBWogAksNCSAAIAQ2AgwgACAENgIIIABBBDYCBCAAQRBqIQUgACgCFCAAKAIQIgZrQQV1IgAgBEkEQCAFIAQgAGsQxgkMCQsgACAESwRAIAUgBiAEQQV0ahC9CQsgBA0IDAYLIAUgBEEBdCIGaiACSw0IIAAgBjYCDCAAIAQ2AgggAEEFNgIEIABBEGohBSAAKAIUIAAoAhAiBGtBBXUiACAGSQRAIAUgBiAAaxDGCQwHCyAAIAZLBEAgBSAEIAZBBXRqEL0JCyAGDQYMBQsgBEHsB0YgBUELaiACS3ENByAAQQE2AgwgACAENgIIIABBBjYCBCAAQRBqIQUgACgCFCIEIAAoAhAiAGtBBXUhBiAAIARGBEAgBUEBIAZrEMYJIAUoAgAhAAwCCyAGQQJPBEAgBSAAQSBqEL0JCyAFKAIAIQAMAQsLIABBBzYCBAJAAkACQCAEQRRrDgMAAQIICyAAQQA2AggMBAsgAEEBNgIIQQEPCyAAQQI2AggMAgsACyAAQQA2AgQgACAErTcDCAtBASEHDAILQQAhAANAIAUoAgAgAEEFdGogASACIAMQtwkiB0UNAiAAQQFqIgAgBkcNAAsMAQtBACEAA0AgBSgCACAAQQV0aiABIAIgAxC3CSIHRQ0BIABBAWoiACAERw0ACwsgBwt1AQN/AkAgACgCBEEFRw0AIAAoAggiBkUNACAAKAIQIQdBACEAAkADQAJAIAcgAEEGdGoiBSgCBEEDRw0AIAUoAgwgAkcNACADIAEgBSgCCGogAhCEAkUNAgsgAEEBaiIAIAZHDQALQQAPCyAEIAA2AgALIAULhAEBAX8jAEEgayIBJAACQAJAAkACQCAAKAIEDggDAQICAQEAAwELIAAoAhBBCGohAAwCCyABQcKLKzYCEEHkAEH0hyogAUEQahCbCUGQljQoAgAoAgAhACABQcKLKzYCACAAQZGMKiABEGwACyAAQQhqIQALIAAoAgAhACABQSBqJAAgAAuVAQECfyMAQSBrIgEkAEEBIQICQAJAAkACQAJAIAAoAgQOCAMCAAACAgEEAgsgACgCDCECDAMLIAAoAhAoAgwhAgwCCyABQeaLKzYCEEHkAEH0hyogAUEQahCbCUGQljQoAgAoAgAhACABQeaLKzYCACAAQZGMKiABEGwAC0EBQQIgACkDCEIYVBshAgsgAUEgaiQAIAILYQEDfwJAIAAoAgRBBUcNACAAKAIIIgRFDQAgACgCECEFQQAhAAJAA0AgBSAAQQZ0aiIDKAIEQQFGBEAgAykDCCABUQ0CCyAAQQFqIgAgBEcNAAtBAA8LIAIgADYCAAsgAwu9AQEFfyAAKAIEIgIgACgCCCIDSQRAIAIgAToAACAAIAJBAWo2AgQPCyACIAAoAgAiBGsiBUEBaiICQQBOBEAgBUH/////ByADIARrIgNBAXQiBiACIAIgBkkbIANB/////wNPGyIDBH8gAxCiCQVBAAsiAmoiBiABOgAAIAUEQCACIAQgBfwKAAALIAAgAiADajYCCCAAIAZBAWoiATYCBCAAIAI2AgAgBARAIAQQKwsgACABNgIEDwsQoAkAC0QBA38gACgCBCICIAFHBEADQCACQRBrIgMoAgAiBARAIAMgBBC9CSADKAIAECsLIAEgAkEgayICRw0ACwsgACABNgIEC/EkAxx/FH4EeyMAQaAKayIGJAAgACgCBCgCACEIIAAoAgAhByAGQfAJaiIKIAVBEGoiDf0AAwD9CwQAIAYgBf0AAwD9CwTgCSAHIAZB4AlqIAdBQGsiCRC/CSAGQYAKaiAHIAb9AATgCSAK/QAEABDACSAGQdAJaiIKIA39AAMA/QsDACAGIAX9AAMA/QsDwAkgByAGQcAJaiAJEL8JIAcpAxghMSAHKQOAASErIAcpAxAhMiAHKQN4ISQgBykDACEzIAcpAwghNSAHKQNoISMgBykDcCElIAZBsAlqIgUgA/0AAxD9CwQAIAYgA/0AAwD9CwSgCSAGQdgJaikDACEsIAopAwAhLiAGQcgJaikDACEvIAYpA8AJITAgByAGQaAJaiAJEL8JIAcgBkGgCWogBkGACmoQvwkgACgCACEHIAZBkAlqIgkgBP0AAxD9CwQAIAYgBP0AAwD9CwSACSAF/QAEACE2IAb9AASgCSE3IAcgBkGACWogB0FAaxC/CSAHIAZBgAlqIAZBgApqEL8JIAn9AAQAITggBv0ABIAJITkgBkHgCGogByA3IDYQwQkgBkHACGogByA5IDgQwQkgBiAAKAIEIgn9AANY/QsEkAcgBiAJ/QADSP0LBIAHIAYgCf0AA3j9CwSwByAGIAn9AANo/QsEoAcgBiAJ/QADmAH9CwTQByAGIAn9AAOIAf0LBMAHIAYgAf0AAxD9CwTwByAGIAH9AAMA/QsE4AcgBkGQCGogAv0AAxD9CwQAIAYgAv0AAwD9CwSACCAGQbAIaiAI/QADmAH9CwQAIAYgCP0AA4gB/QsEoAggBikD2AghIiAGKQP4CCEqIAYpA9AIISYgBikD8AghKCAGKQPACCE0IAYpA+AIIS0gBikDyAghJyAGKQPoCCEpIAYgCSgCACIHQfgAaiIF/QADAP0LA7AGIAYgB/0AA2j9CwOgBiAGIAf9AAOYAf0LA9AGIAYgB/0AA4gB/QsDwAYgBiAF/QADAP0LA/AGIAYgB/0AA2j9CwPgBiArICx9IiwgJCAufSIuICRWIC4gJSAvfSIvICVWIC8gIyAwfSIkICNWrX0iIyAvVnKtfSIlIC5Wcq19Ii4gLiAxfCAlIDJ8Ii8gJVQgLyAjIDV8IjEgI1QgMSAkIDN8IjIgJFStfCIzIDFUcq18IjEgL1RyrXxCACIwICsgLFQgLCAuVHKtUSIHGyEuICUgMSAHG/0SITYgIyAzIAcbIS8gJCAyIAcb/RIhNyAGQeAHaiEKAkAgJyApUSAtIDRUcSAnIClWciAmIChRcSAmIChWciAiICpRcSAiICpWcq0gMFEEQCAqISMgKCElICkhKyAtISwgIiEqICYhKCAnISkgNCEtDAELQQAhByAGQeADaiAGQYAHakHgAPwKAAAgB0UEQCAGQYAHaiAKQeAA/AoAAAsgB0UEQCAKIAZB4ANqQeAA/AoAAAsgIiEjICYhJSAnISsgNCEsCyA2IC79HgEhNiA3IC/9HgEhNyAIQYgBaiESIAZB4AZqIQwgBkHABmohCyAGQaAIaiENIAZBgAhqIQ8gBkHAB2ohByAGQaAHaiEFA0AgIyEkICUhIiArISYgLCEnAkADQAJAICdCAFINACAiICaEQgBSDQBCACEiICRQDQILIDAgKQJ+ICogJCAqfSAiICh9IisgIlYgKyAmICl9IiUgJlYgJSAnIC19IiwgJ1atfSIjICVWcq19IiUgK1ZyrX0iK1QgIyApUSAsIC1WcSAjIClWciAlIChRcSAlIChWciAqICtRcXKtIDBSBEAgIkI/hiEjICJCAYghIiAnQgGDpwRAIAkgBkGgBmogCyAMIAZBoAZqIAsgDCAGQYAHaiAFIAcQwgkLICZCP4YgJ0IBiIQhJyAkQj+GICKEISIgJEIBiCEkIAkgBkGAB2ogBSAHIAZBgAdqIAUgBxDDCSAjICZCAYiEDAELIAkgCiAPIA0gCiAPIA0gBkGAB2ogBSAHEMIJICshJCAlISIgLCEnICMLIiZRICcgLVRxICYgKVRyICIgKFFxICIgKFRyICQgKlFxICQgKlRyrVENAAsgBkHgA2ogBkGAB2pB4AD8CgAAIBFFBEAgBkGAB2ogCkHgAPwKAAALIBFFBEAgCiAGQeADakHgAPwKAAALICohIyAoISUgKSErIC0hLCAkISogIiEoICYhKSAnIS0MAQsLAkACQCAGKQPgBiAAKAIEIgcoAgAiBSkDaFINACAGKQPoBiAFKQNwUg0AIAYpA/AGIAUpA3hSDQAgBikD+AYgBSkDgAFRDQELIAwgBSAG/QAD4AYgBv0AA/AGEMQJIAUgBkGgBmogDBCkCSAFIAsgDBCkCSAMIAX9AAOYAf0LAxAgDCAF/QADiAH9CwMACyAGQfADaiIFIAT9AAMQ/QsDACAGIAT9AAMA/QsD4AMgCCAGQeADaiAIQUBrIg8QpAkgACAF/QADAP0LAxggACAG/QAD4AP9CwMIIAAgC/0AAxD9CwM4IAAgC/0AAwD9CwMoIABBCGohEAJAAkACQAJAAkAgACkDCCAIKQNoUg0AIAApAxAgCCkDcFINACAAKQMYIAgpA3hSDQAgACkDICAIKQOAAVENAQsgBkHgA2ogCCAA/QADCCAA/QADGBDECSAAIAX9AAMA/QsDWCAAIAb9AAPgA/0LA0ggBSAQ/QADEP0LAwAgBiAQ/QADAP0LA+ADIAggBkHgA2ogAEHIAGoQpAkgBikD4AMgCCkDiAFSDQEgBikD6AMgCCkDkAFSDQEgBSkDACAIKQOYAVINASAGKQP4AyAIKQOgAVINAQsgBkHgA2ogACgCACIFIDcgNhDBCSAIIAZB4ANqIA8QpAkgACAGQfADaiIJ/QADAP0LA3ggACAG/QAD4AP9CwNoAkACQCAAKQNoIiIgCCkDaFINACAAKQNwIAgpA3BSDQAgACkDeCAIKQN4Ug0AIAApA4ABIAgpA4ABUQ0BCyAGQeADaiAIIAD9AANoIAD9AAN4EMQJIABB6ABqIgogCf0AAwD9CwMQIAogBv0AA+AD/QsDACAIKQNoISILAkACQCABKQMAICJSDQAgASkDCCAIKQNwUg0AIAEpAxAgCCkDeFINACABKQMYIAgpA4ABUQ0BCyAGQeADaiAIIAH9AAMAIAH9AAMQEMQJIAAgBv0AA/AD/QsDmAEgACAG/QAD4AP9CwOIAQsgCEHoAGohDiAAQShqIRUgBkGABmogBSA3IDYQwQkgBiAS/QADEP0LA/AFIAYgEv0AAwD9CwPgBSAGIAdB2ABqIgX9AAMA/QsD0AUgBiAH/QADSP0LA8AFIAYgB0H4AGoiCf0AAwD9CwOwBSAGIAf9AANo/QsDoAUgBiAF/QADAP0LBPADIAYgB/0AA0j9CwTgAyAGIAn9AAMA/QsEkAQgBiAH/QADaP0LBIAEIAYgBf0AAwD9CwSwBCAGIAf9AANI/QsEoAQgBiAJ/QADAP0LBNAEIAYgB/0AA2j9CwTABCAGIAFBEGoiB/0AAwD9CwTwBCAGIAH9AAMA/QsE4AQgBiACQRBqIgX9AAMA/QsEkAUgBiAC/QADAP0LBIAFIAYgB/0AAwD9CwSwAiAGIAH9AAMA/QsEoAIgBiAF/QADAP0LBNACIAYgAv0AAwD9CwTAAiAGIBBBEGoiB/0AAwD9CwTwAiAGIBD9AAMA/QsE4AIgBiALQRBqIgX9AAMA/QsEkAMgBiAL/QADAP0LBIADIAYgB/0AAwD9CwSwAyAGIBD9AAMA/QsEoAMgBiAF/QADAP0LBNADIAYgC/0AAwD9CwTAAyAAQagBaiENQQAhBQNAIAAoAgQgDSAFQQZ0IgdqIgogDSAHQSByIglqIgsgBkGAAmogBkHgA2ogB2ogBkHgA2ogCWogBkHgBWogBkGgAmogB2ogBkGgAmogCWogBkHgBWoQwgkCQAJAIAYpA4ACIA4pAwBSDQAgBikDiAIgCCkDcFINACAGKQOQAiAIKQN4Ug0AIAYpA5gCIAgpA4ABUQ0BCyAGQYACaiAIIAb9AASAAiAG/QAEkAIQxAkLIAggCiAGQYACahCkCSAIIAsgBkGAAmoQpAkgBUEBaiIFQQNHDQALIAAoAgQgAEHoAmoiEyAAQYgDaiIUIAZBgAJqIABB6AFqIhYgAEGIAmoiFyAGQeAFaiABIAIgBkHgBWoQwgkCQAJAIAYpA4ACIA4pAwBSDQAgBikDiAIgCCkDcFINACAGKQOQAiAIKQN4Ug0AIAYpA5gCIAgpA4ABUQ0BCyAGQYACaiAIIAb9AASAAiAG/QAEkAIQxAkLIAggEyAGQYACahCkCSAIIBQgBkGAAmoQpAkgBkHwAWoiGCAOQRBqIgf9AAMA/QsDACAGIA79AAMA/QsD4AEgBkHQAWoiGSAG/QAD8AX9CwMAIAYgBv0AA+AF/QsDwAEgBkGwAWoiGiAH/QADAP0LAwAgBiAO/QADAP0LA6ABIABBqMMBaiEbIABBqIMBaiEcIABBqMMAaiEdIABByAFqIR4gAEHIAmohHyAAQagCaiEgIABBqANqISEgBkHoAGohDCAGQYgBaiELQQAhBwNAIDAgBEH/ASAHayIJQQN2QRhxIgVqKQMAIAlBP3GtIiKIQgGGQgKDIAMgBWopAwAgIohCAYOEIAZBgAZqIAVqKQMAICKIQgKGQgSDhCImQgGGIiIgCCkDACIkVCAIKQMYIiUgCCkDECIpIAgpAwgiI4SEQgBSIgVyrVENAiAGICI3A4ABIAtCADcDECAL/QwAAAAAAAAAAAAAAAAAAAAAIjb9CwMAIAggBkGAAWogDxCkCSAwICRCB1YgBXKtUQ0DICanIREgBkIHNwNgIAxCADcDECAMIDb9CwMAIAggBkHgAGogDxCkCSAhIAdBBXQiBWoiCSAGKQOYASItIAYpA3h9IiogBikDkAEiIiAGKQNwfSIoICJWICggBikDiAEiIiAGKQNofSInICJWICcgBikDgAEiJiAGKQNgfSIiICZWrX0iJiAnVnKtfSInIChWcq19IiggJSAofCAnICl8IikgJ1QgKSAjICZ8IiMgJlQgIyAiICR8IiQgIlStfCIlICNUcq18IiMgKVRyrXwgMCAoICpWICogLVZyrVEiChs3AxggCSAnICMgChs3AxAgCSAmICUgChs3AwggCSAiICQgChs3AwAgBwRAIAAoAgQgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWoQwwkLIAAoAgQhCQJAAkACQAJAAkACQAJAAkACQCARQQFrDgcBAgMEBQYHAAsgCSAGQeABaiAGQcABaiAGQaABaiAGQeABaiAGQcABaiAGQaABaiAOIBIgDhDCCQwHCyAJIAZB4AFqIAZBwAFqIAZBoAFqIAZB4AFqIAZBwAFqIAZBoAFqIAZBwAVqIAZBoAVqIAZB4AVqEMIJDAYLIAkgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWogASACIAZB4AVqEMIJDAULIAkgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWogDSAeIAZB4AVqEMIJDAQLIAkgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWogECAVIAZB4AVqEMIJDAMLIAkgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWogFiAXIAZB4AVqEMIJDAILIAkgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWogICAfIAZB4AVqEMIJDAELIAkgBkHgAWogBkHAAWogBkGgAWogBkHgAWogBkHAAWogBkGgAWogEyAUIAZB4AVqEMIJCyAFIB1qIgkgBv0AA+AB/QsDACAJIBj9AAMA/QsDECAFIBxqIgkgGf0AAwD9CwMQIAkgBv0AA8AB/QsDACAFIBtqIgUgGv0AAwD9CwMQIAUgBv0AA6AB/QsDACAHQQFqIgdBgAJHDQALIAZBoApqJAAPCyAGQZ7AKTYCUEHkAEH0hyogBkHQAGoQmwlBkJY0KAIAKAIAIQggBkGewCk2AkAgCEGRjCogBkFAaxBsAAsgBkGAxio2AhBB5ABB9IcqIAZBEGoQmwlBkJY0KAIAKAIAIQggBkGAxio2AgAgCEGRjCogBhBsAAsgBkGAxio2AjBB5ABB9IcqIAZBMGoQmwlBkJY0KAIAKAIAIQggBkGAxio2AiAgCEGRjCogBkEgahBsAAuNAgEEfgJAAkAgASkDACIDIAApA2giBFINACABKQMIIAApA3BSDQAgASkDECAAKQN4Ug0AIAEpAxggACkDgAFRDQELAkAgAikDACIFIAApA4gBIgZSDQAgAikDCCAAKQOQAVINACACKQMQIAApA5gBUg0AIAIpAxggACkDoAFRDQELAkACQAJAIAQgBVINACACKQMIIAApA3BSDQAgAikDECAAKQN4Ug0AIAIpAxggACkDgAFRDQELIAMgBlINASABKQMIIAApA5ABUg0BIAEpAxAgACkDmAFSDQEgASkDGCAAKQOgAVINAQsgASAC/QADAP0LAwAgASAC/QADEP0LAxAPCyAAIAEgAhDFCQsLggoCJX4CfyMAQSBrIikkACApIAEgAiADEMEJIAEpA6ABIQcgASkDmAEhBCABKQOQASEGIAEpA4gBIQggASkDGCEgIAEpAxAhISABKQMIISIgASkDACEjIABBEGoiKiAB/QADeP0LAwAgACAB/QADaP0LAwAgACkDGCELICopAwAhDSAAKQMIIQ8gASkDOCEaIAEpAzAhGyABKQMoIRwgASkDICEdIAEpA4ACISQgASkD+AEhJSABKQPwASEmIAEpA+gBIScgACkDACEQICkpAxghBSApKQMQIQkgKSkDCCEKICkpAwAhDiAjIR4gIiEWICEhFyAgIRgDQAJAAkAgDlAEQCAKQgBSDQEgCUIAUg0BIAVCAFINASAAIAs3AxggACANNwMQIAAgDzcDCCAAIBA3AwAgKUEgaiQADwsgDqdBAXENAQsgBkI/hiAIQgGIhCEMIARCP4YgBkIBiIQhBiAHQj+GIARCAYiEIQQgCkI/hiAOQgGIhCEOIAlCP4YgCkIBiIQhCiAFQj+GIAlCAYiEIQkgB0IBiCEHIAhCAYNQBEAgDCEIIAVCAYghBQwCCyAaIAcgJHwiCCAEICV8IhIgBFQgEiAGICZ8IgQgBlQgBCAMICd8IhUgDFStfCIGIARUcq18IgQgElRyrXwiDHwiEiAEIBt8IhMgG1QgEyAGIBx8IhEgHFQgESAVIB18IhQgHVStfCIZIBFUcq18IhEgE1RyrXwiEyAMIAcgCFYgCCAMVnIgEiAaVCASIBNWcnMiARshByARIAQgARshBCAZIAYgARshBiAUIBUgARshCCAFQgGIIQUMAQsCQEIAIgwgCiAWUSAOIB5UcSAKIBZUciAJIBdRcSAJIBdUciAFIBhRcSAFIBhUcq1RBEAgCyESIA0hFSAPIRMgBSEoIAkhESAKIRQgECEZIA4hHyAHIQsgBCENIAYhDyAIIRAMAQsgByESIAQhFSAGIRMgGCEoIBchESAWIRQgCCEZIB4hHyAOIR4gCiEWIAkhFyAFIRgLIAsgEn0iBCANIBV9IgUgDVYgBSAPIBN9IgcgD1YgByAQIBl9Ig4gEFatfSIGIAdWcq19IgcgBVZyrX0iBSAHICF8IgogB1QgCiAGICJ8IgkgBlQgCSAOICN8IgggDlStfCINIAlUcq18IgkgClRyrSAFICB8fCAMIAQgBVQgBCALVnKtUSIBGyIFQj+GIAcgCSABGyIKQgGIhCEEIAVCAYghByAKQj+GIAYgDSABGyILQgGIhCEGIBEgF30iBSAUIBZ9IgogFFYgCiAfIB59Ig0gH1atfSIMIApWcq19IglCP4YgDEIBiIQhCiAoIBh9IAUgCVQgBSARVnKtfSIFQj+GIAlCAYiEIQkgC0I/hiAOIAggARsiC0IBiIQhCCAMQj+GIA1CAYiEIQ4gC0IBg6cEQCAaIAcgJHwiDCAEICV8IgsgBFQgCyAGICZ8IgQgBlQgBCAIICd8Ig0gCFStfCIGIARUcq18IgQgC1RyrXwiCHwiCyAEIBt8Ig8gG1QgDyAGIBx8IhAgHFQgECANIB18IhEgHVStfCIUIBBUcq18IhAgD1RyrXwiDyAIIAggDFQgByAMVnIgCyAaVCALIA9WcnMiARshByAQIAQgARshBCAUIAYgARshBiARIA0gARshCAsgEiELIBUhDSATIQ8gGSEQIAVCAYghBQwACwALxAQCA38PfiMAQZABayIEJAAgBCAD/QsEUCAEIAL9CwRAIARCADcDYCABKQMYIREgASkDECESIAEpAwghEyABKQMAIRQgASkDYCEVA0AgBEEwaiAUQgAgBEFAayAGQQN0aiIFKQMAIgcgFX4iCEIAEDYgBEEgaiATQgAgCEIAEDYgBEEQaiASQgAgCEIAEDYgBCARQgAgCEIAEDYgBSAHIAQpAzB8Igk3AwAgBSAFKQMIIgwgBCkDIHwiCCAHIAlWrXwiByAEKQM4fCIKNwMIIAUgBSkDECIOIAQpAxB8IgkgCCAMVCAHIAhUcq18IgggBCkDKHwiDCAHIApWrXwiDzcDECAFIAUpAxgiECAEKQMAfCIHIAkgDlQgCCAJVHKtfCIJIAQpAxh8IgogCCAMViAMIA9Wcq18Igw3AxggBSALIAcgEFQgByAJVnKtfCIIIAQpAwh8IgcgCiAMViAJIApWcq18Igk3AyAgBSAHIAhUIAcgCVZyrSANIAggC1StfHwiCzcDKCAGQQFqIgZBBEcNAAsgACAEKQN4IgggCCABKQM4Igl8IgggASkDMCIHIAQpA3AiDHwiCyAHVCALIAEpAygiCiAEKQNoIg58IgcgClQgByABKQMgIgogBCkDYCIPfCIQIApUrXwiCiAHVHKtfCIHIAtUcq18IgsgBCkDgAEgDSAIIAlUIAggC1ZyrXxRIgUbNwMYIAAgDCAHIAUbNwMQIAAgDiAKIAUbNwMIIAAgDyAQIAUbNwMAIARBkAFqJAALtmMDFn8vfgJ7IwBBgAVrIgokAAJAIAAtAOgCQQFGBEAgACgCACEPIApB8ARqIgsgB0EQaiIS/QADAP0LAwAgCiAH/QADAP0LA+AEIA8gCkHgBGogBRCkCSAKQfgEaiINKQMAITEgCykDACEiIApB6ARqIg4pAwAhICAKKQPgBCEhIAsgBEEQaiIU/QADAP0LAwAgCiAE/QADAP0LA+AEIA8gCkHgBGogCBCkCSAKIA8pAzgiLiAxIA0pAwAiM3wiMSAiIAspAwAiJHwiIiAkVCAiICAgDikDACIkfCIgICRUICAgISAKKQPgBCIkfCIhICRUrXwiJCAgVHKtfCIgICJUcq18IiJ8IiogDykDMCImICB8Ii0gJlQgLSAPKQMoIjIgJHwiJiAyVCAmIA8pAyAiMiAhfCI1IDJUrXwiMiAmVHKtfCImIC1Ucq18Ii0gIiAxIDNUICIgMVRyICogLlQgKiAtVnJzIhAbNwPYAyAKQdADaiIVICYgICAQGzcDACAKIDIgJCAQGzcDyAMgCiA1ICEgEBs3A8ADIAsgBUEQaiIQ/QADAP0LAwAgCiAF/QADAP0LA+AEIA8gCkHgBGogCBCkCSANKQMAITEgCykDACEiIA4pAwAhICAKKQPgBCEhIAAoAgAhDyAKIAb9AAMQ/QsDsAIgCiAG/QADAP0LA6ACIA8gCkGgAmogCRCkCSALIBD9AAMA/QsDACAKIAX9AAMA/QsD4AQgDyAKQeAEaiAJEKQJIA0pAwAhLSALKQMAISYgDikDACEuIAopA+AEITMgCyAI/QADEP0LAwAgCiAI/QADAP0LA+AEIA8gCkHgBGogBhCkCSANKQMAIT4gCykDACE/IA4pAwAhQCAKKQPgBCFCIA8pAzghMiAPKQMwITUgDykDICE3IA8pAyghKCALIBT9AAMA/QsDACAKIAT9AAMA/QsD4AQgDyAKQeAEaiAJEKQJIA0pAwAhJCALKQMAISogDikDACEjIAopA+AEISUgACgCACEIIAsgEv0AAwD9CwMAIAogB/0AAwD9CwPgBCAIIApB4ARqIAYQpAkgCiAIKQM4IkEgJCANKQMAfCIpICogCykDAHwiJyAqVCAnICMgDikDAHwiKiAjVCAqICUgCikD4AR8IiMgJVStfCIlICpUcq18IiogJ1RyrXwiJ3wiKyAIKQMwIjAgKnwiLCAwVCAsIAgpAygiPSAlfCIwID1UIDAgCCkDICI9ICN8IkMgPVStfCI9IDBUcq18IjAgLFRyrXwiLCAnICcgKVQgJCApVnIgKyBBVCArICxWcnMiCRs3A7gDIAogMCAqIAkbNwOwAyAKID0gJSAJGzcDqAMgCiBDICMgCRs3A6ADIApB0AJqIgYgFP0AAwD9CwMAIAogBP0AAwD9CwPAAiAIIApBwAJqIAcQpAkgCyAAQZgCaiIE/QADAP0LAwAgCiAA/QADiAL9CwPgBCAIIApB4ARqIApBoAJqEKQJIAogACgCACIHKQM4IjAgMSANKQMAIkF8IiQgIiALKQMAIj18IiogIlQgKiAgIA4pAwAiQ3wiIyAgVCAjICEgCikD4AQiRXwiJSAhVK18IikgI1RyrXwiIyAqVHKtfCIqfCInIAcpAzAiLCAjfCIrICxUICsgBykDKCIvICl8IiwgL1QgLCAHKQMgIi8gJXwiNiAvVK18Ii8gLFRyrXwiLCArVHKtfCIrICogJCAxVCAkICpWciAnIDBUICcgK1ZycyIIGzcDmAIgCkGQAmoiBSAsICMgCBs3AwAgCiAvICkgCBs3A4gCIAogNiAlIAgbNwOAAiAHKQMYISkgBykDECEnIAcpAwghKyAKICEgRX0iKiAqIAcpAwB8IixCACIkIDEgQX0iIyAxViAjICIgPX0iJSAiViAlICAgQ30iIiAgViAiICEgKlStfSIxICJWcq19IiIgJVZyrX0iICAjVnKtUSIIGzcD4AEgCiAxICsgMXwiISAqICxWrXwiIyAIGzcD6AEgCiAiICIgJ3wiKiAhIDFUICEgI1ZyrXwiMSAIGzcD8AEgCiAgICogMVYgIiAqVnKtICAgKXx8IAgbNwP4ASALIBX9AAMA/QsDACAKIAr9AAPAA/0LA+AEIAcgCkHgBGogCkHgAWoQpAkgDSkDACEhIAspAwAhMSAOKQMAISIgCikD4AQhICAAKAIAIQkgCyAE/QADAP0LAwAgAP0AA4gCIU8gCiAyIC0gPnwiKiAmID98IiMgJlQgIyAuIEB8IiYgLlQgJiAzIEJ8Ii4gM1StfCIzICZUcq18IiYgI1RyrXwiI3wiJSAmIDV8IikgNVQgKSAoIDN8IjUgKFQgNSAuIDd8IiggN1StfCI3IDVUcq18IjUgKVRyrXwiKSAjICogLVQgIyAqVHIgJSAyVCAlIClWcnMiCBsiMjcD+AIgCiA1ICYgCBsiNTcD8AIgCiA3IDMgCBsiMzcD6AIgCiAoIC4gCBsiNzcD4AIgCiBP/QsD4AQgCSAKQeACaiAKQaADahCkCSAJIApB4ARqIApB4AJqEKQJIAEgISANKQMAfSIqIDEgCykDAH0iLSAxViAtICIgDikDAH0iJiAiViAmICAgCikD4AR9IjEgIFatfSIiICZWcq19IiAgLVZyrX0iLSAgIAcpAxB8IiYgIFQgJiAiIAcpAwh8Ii4gIlQgLiAxIAcpAwB8IiggMVStfCIjIC5Ucq18Ii4gJlRyrSAtIAcpAxh8fCAkICEgKlQgKiAtVHKtUSIHGzcDGCABICAgLiAHGzcDECABICIgIyAHGzcDCCABIDEgKCAHGzcDACAAKAIAIQcgCyAF/QADAP0LAwAgCiAK/QADgAL9CwPgBCAHIApB4ARqIApB4AFqEKQJIA0pAwAhMSALKQMAISIgDikDACEgIAopA+AEISEgAP0AA7gCIU8gAP0AA6gCIVAgCiAG/QADAP0LA5ADIAsgT/0LAwAgCiAK/QADwAL9CwOAAyAKIFD9CwPgBCAHIApBgANqIApBoANqEKQJIAcgCkHgBGogCkGAA2oQpAkgAiAHKQM4IiggMSANKQMAfCIkICIgCykDAHwiKiAiVCAqICAgDikDAHwiIiAgVCAiICEgCikD4AR8IiAgIVStfCIhICJUcq18IiIgKlRyrXwiKnwiLSAHKQMwIi4gInwiJiAuVCAmIAcpAygiIyAhfCIuICNUIC4gBykDICIjICB8IiUgI1StfCIjIC5Ucq18Ii4gJlRyrXwiJiAqICQgMVQgJCAqVnIgJiAtVCAoIC1WcnMiBxs3AxggAiAuICIgBxs3AxAgAiAjICEgBxs3AwggAiAlICAgBxs3AwAgACgCACEHIAogMjcD+AQgCiA1NwPwBCAKIDM3A+gEIAogNzcD4AQgByAKQeAEaiAKQYACahCkCSAKKQP4BCExIAopA/AEISIgCikD4AQhICAKKQPoBCEhIAsgAP0AA9gB/QsDACAKIAD9AAPIAf0LA+AEIAcgCkHAAmogCkHAA2oQpAkgByAKQeAEaiAKQcACahCkCSADIAcpAzgiMyAxIA0pAwB8IiQgIiALKQMAfCIqICJUICogISAOKQMAfCIiICFUICIgICAKKQPgBHwiISAgVK18IiAgIlRyrXwiIiAqVHKtfCIqfCItIAcpAzAiLiAifCImIC5UICYgBykDKCIyICB8Ii4gMlQgLiAHKQMgIjIgIXwiNSAyVK18IjIgLlRyrXwiLiAmVHKtfCImICogJCAxVCAkICpWciAmIC1UIC0gM1RycyIAGzcDGCADIC4gIiAAGzcDECADIDIgICAAGzcDCCADIDUgISAAGzcDAAwBCyAAKAIAIQsgAC0A6QJBAUYEQCAKQZAEaiISIARBEGoiFv0AAwD9CwMAIAogBP0AAwD9CwOABCALIApBgARqIAcQpAkgCkHwBGoiDSAFQRBqIhP9AAMA/QsDACAKIAX9AAMA/QsD4AQgCyAKQeAEaiAIEKQJIApB+ARqIg4pAwAhKiANKQMAIS0gCkHoBGoiDykDACEmIAopA+AEIS4gCkGwBGoiFSAGQRBqIgz9AAMA/QsDACAKIAb9AAMA/QsDoAQgCyAKQaAEaiAJEKQJIAVBGGoiFykDACEwIARBGGoiGCkDACEkIBMpAwAhPiAWKQMAITMgBUEIaiIRKQMAIT8gBEEIaiIdKQMAITIgBSkDACFAIAQpAwAhNSAKQfgDaiIZIAspAzgiMSAHKQMYIkIgCCkDGHwiNyAHKQMQIiAgCCkDEHwiIiAgVCAiIAcpAwgiISAIKQMIfCIgICFUICAgBykDACIhIAgpAwB8IiggIVStfCIjICBUcq18IiUgIlRyrXwiKXwiJyALKQMwIiIgJXwiKyAiVCArIAspAygiICAjfCIsICBUICwgCykDICIhICh8IkEgIVStfCI9ICxUcq18IiwgK1RyrXwiKyApIDcgQlQgKSA3VHIgJyAxVCAnICtWcnMiEBs3AwAgCkHwA2oiFCAsICUgEBs3AwAgCkHoA2oiGiA9ICMgEBs3AwAgCiBBICggEBs3A+ADIAogMSAkIDB8IjcgMyA+fCIoIDNUICggMiA/fCIzIDJUIDMgNSBAfCIyIDVUrXwiNSAzVHKtfCIzIChUcq18Iih8IiMgIiAzfCIlICJUICUgICA1fCIiICBUICIgISAyfCIgICFUrXwiISAiVHKtfCIiICVUcq18IiUgKCAoIDdUICQgN1ZyICMgMVQgIyAlVnJzIhAbNwP4BCAKICIgMyAQGzcD8AQgCiAhIDUgEBs3A+gEIAogICAyIBAbNwPgBCALIApB4ARqIApB4ANqEKQJIAopA/gEIT4gCikD4AQhPyAKKQPoBCFAIAopA/AEIUIgACgCACILKQMYIUcgCykDACFIIAspAwghSSALKQMQIUogCkGYBGoiGykDACFBIBIpAwAhPSAKQYgEaiIcKQMAIUMgCikDgAQhRSAaIAspAygiMyARKQMAIjcgBkEIaiIeKQMAfCIxIAUpAwAiICAGKQMAfCIiICBUrXwiIHwiISALKQMgIjIgInwiJSAyVK18IikgICAXKQMAIjUgBkEYaiIfKQMAfCIkIDVUICQgEykDACIoIAwpAwB8IjUgKFQgNSAxIDdUICAgMVRyrXwiMSA1VHKtfCIoICRUciALKQM4IjUgKHwiJCA1VCAkIAspAzAiNyAxfCIjIDdUICMgISAzVCAhIClWcq18IiEgI1RyrXwiIyAkVHJzIgUbNwMAIBkgIyAoIAUbNwMAIBQgISAxIAUbNwMAIAogJSAiIAUbNwPgAyAKQdgDaiIFIDUgCCkDGCIpIAkpAxh8IjEgCCkDECIgIAkpAxB8IiIgIFQgIiAIKQMIIiEgCSkDCHwiICAhVCAgIAgpAwAiJCAJKQMAfCIhICRUrXwiJCAgVHKtfCIgICJUcq18IiJ8IiggICA3fCIjIDdUICMgJCAzfCIlIDNUICUgISAyfCInIDJUrXwiKyAlVHKtfCIlICNUcq18IiMgIiAiIDFUICkgMVZyICggNVQgIyAoVHJzIhMbNwMAIApB0ANqIgggJSAgIBMbNwMAIApByANqIhAgKyAkIBMbNwMAIAogJyAhIBMbNwPAAyANIBT9AAMA/QsDACAKIAr9AAPgA/0LA+AEIAsgCkHgBGogCkHAA2oQpAkgGSAOKQMAIiU3AwAgFCANKQMAIik3AwAgGiAPKQMAIic3AwAgCiAKKQPgBCIjNwPgAyAAKAIAIgspAxghOCALKQMQITsgGiAnIAspAygiIiAmIApBqARqIhMpAwB8IiEgLiAKKQOgBHwiKCAuVK18Iit8IiwgCykDICIgICh8IjogIFStfCI5ICsgKiAKQbgEaiIXKQMAfCIkICpUICQgLSAVKQMAfCIwIC1UIDAgISAmVCAhICtWcq18Ii8gMFRyrXwiMCAkVHIgCykDOCIhIDB8IjYgIVQgNiALKQMwIiQgL3wiNCAkVCA0ICIgLFYgLCA5VnKtfCI5IDRUcq18IjQgNlRycyIRG30iKyAjIDogKCARG30iKCAjVq19IiMgIyALKQMIfCIsICggCykDAHwiNiAoVK18IjpCACIxICUgNCAwIBEbfSIwICVWIDAgKSA5IC8gERt9Ii8gKVYgLyAnICtUICMgK1ZyrX0iJSAvVnKtfSIpIDBWcq1RIhEbNwMAIBkgKSAlIDt8IicgJVQgJyAjICxWICwgOlZyrXwiIyAnVHKtICkgOHx8IBEbNwMAIBQgJSAjIBEbNwMAIAogKCA2IBEbNwPgAyAFICEgGCkDACIvIB8pAwB8IiggFikDACIlIAwpAwB8IiMgJVQgIyAdKQMAIikgHikDAHwiJSApVCAlIAQpAwAiJyAGKQMAfCIpICdUrXwiJyAlVHKtfCIlICNUcq18IiN8IisgJCAlfCIsICRUICwgIiAnfCIwICJUIDAgICApfCI2ICBUrXwiNCAwVHKtfCIwICxUcq18IiwgIyAoIC9UICMgKFRyICEgK1YgKyAsVnJzIgQbNwMAIAggMCAlIAQbNwMAIBAgNCAnIAQbNwMAIAogNiApIAQbNwPAAyAKQbgDaiIEICEgBykDGCIwIAkpAxh8IiggBykDECIlIAkpAxB8IiMgJVQgIyAHKQMIIikgCSkDCHwiJSApVCAlIAcpAwAiJyAJKQMAfCIpICdUrXwiJyAlVHKtfCIlICNUcq18IiN8IisgJCAlfCIsICRUICwgIiAnfCIkICJUICQgICApfCIiICBUrXwiICAkVHKtfCIkICxUcq18IiwgIyAoIDBUICMgKFRyICEgK1YgKyAsVnJzIgkbNwMAIApBsANqIgcgJCAlIAkbNwMAIApBqANqIgYgICAnIAkbNwMAIAogIiApIAkbNwOgAyANIAj9AAMA/QsDACAKIAr9AAPAA/0LA+AEIAsgCkHgBGogCkGgA2oQpAkgBSAOKQMAIiQ3AwAgCCANKQMAIiI3AwAgECAPKQMAIiA3AwAgCiAKKQPgBCIhNwPAAyAEICQgACgCACILKQM4Ii8gGykDACI2IBcpAwB8IiggEikDACIlIBUpAwB8IiMgJVQgIyAcKQMAIikgEykDAHwiJSApVCAlIAopA4AEIicgCikDoAR8IikgJ1StfCInICVUcq18IiUgI1RyrXwiI3wiKyALKQMwIjAgJXwiLCAwVCAsIAspAygiNCAnfCIwIDRUIDAgCykDICI0ICl8IjggNFStfCI0IDBUcq18IjAgLFRyrXwiLCAjICggNlQgIyAoVHIgKyAvVCArICxWcnMiCRt9IiggIiAwICUgCRt9IiMgIlYgIyAgIDQgJyAJG30iJSAgViAlICEgOCApIAkbfSIiICFWrX0iICAlVnKtfSIhICNWcq19IiMgISALKQMQfCIlICFUICUgICALKQMIfCIpICBUICkgIiALKQMAfCInICJUrXwiKyApVHKtfCIpICVUcq0gIyALKQMYfHwgMSAkIChUICMgKFZyrVEiCRsiJDcDACAHICEgKSAJGyIoNwMAIAYgICArIAkbIiM3AwAgCiAiICcgCRsiITcDoAMgCkHQBGoiCSAAQThqIh39AAMA/QsDACAKIAD9AAMo/QsDwAQgCyAKQcAEaiAKQaAEahCkCSAKQcgEaiIRICYgACgCACILKQMoIiIgIyARKQMAfSIlICEgCikDwAR9IiAgIVatfSIhICEgCykDCCI4fCIpICAgCykDACI7fCIsICBUrXwiNiAxICQgCkHYBGoiFikDAH0iJyAkViAnICggCSkDAH0iKyAoViArICMgJVQgISAlVnKtfSIkICtWcq19IiUgJ1ZyrVEiDBsiKCAiICggKHwiJyAgICwgDBsiIyAjfCIrICNUrXwiLHwiMCALKQMgIiAgK3wiOiAgVK18IjkgLCAlICQgCykDECJEfCIvICRUIC8gISApViApIDZWcq18IikgL1RyrSAlIAspAxgiPHx8IAwbIiUgJXwiISAlVCAhICQgKSAMGyIpICl8IiQgKVQgJCAnIChUICcgLFZyrXwiJyAkVHKtfCIvICFUciALKQM4IiEgL3wiNiAhVCA2IAspAzAiJCAnfCI0ICRUIDQgIiAwViAwIDlWcq18IjkgNFRyrXwiNCA2VHJzIgwbfCIsICMgOiArIAwbfCIrICNUrXwiI3wiMCAgICt8IjYgIFStfCI6ICMgJSA0IC8gDBt8Ii8gJVQgLyApIDkgJyAMG3wiJSApVCAlICMgLFQgKCAsVnKtfCIpICVUcq18IiUgL1RyICEgJXwiKCAhVCAoICQgKXwiJyAkVCAnICIgMFYgMCA6VnKtfCIwICdUcq18IiwgKFRycyIMGyIvfSInIC4gNiArIAwbIjZ9IiggLlatfSIjICMgOHwiKyAoIDt8IjQgKFStfCI4IDEgKiAsICUgDBsiO30iLCAqViAsIC0gMCApIAwbIjB9IikgLVYgKSAmICdUICMgJ1ZyrX0iJSApVnKtfSIpICxWcq1RIgwbNwMAIAkgJSAlIER8IicgIyArViArIDhWcq18IiMgDBs3AwAgFiApICMgJ1QgJSAnVnKtICkgPHx8IAwbNwMAIBAgIiAmIC98IiMgLiA2fCIlIC5UrXwiKXwiJyAgICV8IiwgIFStfCIvICkgKiA7fCIgICpUICAgLSAwfCIrIC1UICsgIyAmVCAjIClWcq18IiMgK1RyrXwiKyAgVHIgISArfCIgICFUICAgIyAkfCIhICRUICEgIiAnViAnIC9Wcq18IiIgIVRyrXwiISAgVHJzIhgbNwMAIAggIiAjIBgbNwMAIAUgISArIBgbNwMAIAogKCA0IAwbNwPABCAKICwgJSAYGzcDwAMgDSAd/QADAP0LAwAgCiAA/QADKP0LA+AEIAsgCkHgBGogCkGgA2oQpAkgBCAOKQMAIic3AwAgByANKQMAIis3AwAgBiAPKQMAIiw3AwAgCiAKKQPgBCIwNwOgAyAEIAAoAgAiCykDOCIiICIgJyAiICIgFykDACIoICh8Ii8gFSkDACIjICN8IiAgI1QgICATKQMAIiUgJXwiISAlVCAhIAopA6AEIikgKXwiNiApVK18IjQgIVRyrXwiOCAgVHKtfCI7fCI6IAspAzAiICA4fCI5ICBUIDkgCykDKCIhIDR8IjwgIVQgPCALKQMgIiQgNnwiRCAkVK18IkYgPFRyrXwiPCA5VHKtfCI5IDsgKCAvViAvIDtWciA5IDpUICIgOlZycyIMGyI7ICh8IiggPCA4IAwbIi8gI3wiIyAvVCAjIEYgNCAMGyIvICV8IiUgL1QgJSBEIDYgDBsiLyApfCIpIC9UrXwiLyAlVHKtfCIlICNUcq18IiN8IjYgICAlfCI0ICBUIDQgISAvfCI4ICFUIDggJCApfCI6ICRUrXwiOSA4VHKtfCI4IDRUcq18IjQgIyAoIDtUICMgKFRyIDQgNlQgIiA2VnJzIgwbIkR9IiggKyA4ICUgDBsiRn0iNiArViA2ICwgOSAvIAwbIkt9IiMgLFYgIyAwIDogKSAMGyJMfSIpIDBWrX0iJSAjVnKtfSIjIDZWcq19IisgIyALKQMQIjR8IiwgI1QgLCAlIAspAwgiOHwiMCAlVCAwICkgCykDACI7fCI6IClUrXwiOSAwVHKtfCIvICxUcq0gKyALKQMYIjZ8fCAxICggK1QgJyAoVHKtUSIMGyI8IBspAwAiKH0iMCAjIC8gDBsiJyASKQMAIiN9Ii8gJ1YgLyAlIDkgDBsiJyAcKQMAIiV9IiwgJ1YgLCApIDogDBsiKyAKKQOABCIpfSInICtWrX0iKyAsVnKtfSIsIC9Wcq19Ii8gLyA2fCAsIDR8IjYgLFQgNiArIDh8IjQgK1QgNCAnIDt8IjggJ1StfCI7IDRUcq18IjQgNlRyrXwgMSAvIDBWIDAgPFZyrVEiDBsiMCAwfCIvICwgNCAMGyIsICx8IjYgLFQgNiArIDsgDBsiKyArfCI0ICtUIDQgJyA4IAwbIicgJ3wiOCAnVK18IjsgNFRyrXwiNCA2VHKtfCI2fCI6ICAgNHwiOSAgVCA5ICEgO3wiPCAhVCA8ICQgOHwiTSAkVK18Ik4gPFRyrXwiPCA5VHKtfCI5IDYgLyAwVCAvIDZWciA5IDpUICIgOlZycyIMGyI6IDB8IjAgPCA0IAwbIi8gLHwiLCAvVCAsIE4gOyAMGyIvICt8IisgL1QgKyBNIDggDBsiLyAnfCInIC9UrXwiLyArVHKtfCIrICxUcq18Iix8IjYgICArfCI0ICBUIDQgISAvfCI4ICFUIDggJCAnfCI7ICRUrXwiOSA4VHKtfCI4IDRUcq18IjQgLCAwIDpUICwgMFRyIDQgNlQgIiA2VnJzIgwbNwMAIAcgOCArIAwbNwMAIAYgOSAvIAwbNwMAIAogOyAnIAwbNwOgAyALKQMYITggCykDECE7IBwgISAlICEgJSAlfCInICkgKXwiKyApVK18Iix8IjAgJCArfCI6ICRUrXwiOSAsICggKHwiLyAoVCAvICMgI3wiNiAjVCA2ICUgJ1YgJyAsVnKtfCInIDZUcq18IjYgL1RyICIgNnwiLyAiVCAvICAgJ3wiNCAgVCA0ICEgMFYgMCA5VnKtfCIwIDRUcq18IjQgL1RycyIMGyIvfCIlICkgOiArIAwbIit8IikgK1StfCIrfCIsICQgKXwiOiAkVK18IjkgKyAoIDQgNiAMGyI2fCIkIDZUICQgIyAwICcgDBsiJ3wiKCAnVCAoICUgL1QgJSArVnKtfCIjIChUcq18IiggJFRyICIgKHwiJCAiVCAkICAgI3wiIiAgVCAiICEgLFYgLCA5VnKtfCIlICJUcq18IicgJFRycyIMGyIrIEt9IiEgOiApIAwbIiAgTH0iIiAgVq19IiAgICALKQMIfCIkICIgCykDAHwiKSAiVK18IiwgMSAnICggDBsiJyBEfSIoICdWICggJSAjIAwbIiUgRn0iIyAlViAjICEgK1YgICAhVnKtfSIhICNWcq19IiMgKFZyrVEiDBs3AwAgEiAhICEgO3wiKCAgICRWICQgLFZyrXwiICAMGzcDACAbICMgICAoVCAhIChWcq0gIyA4fHwgDBs3AwAgCiAiICkgDBs3A4AEIA4gGSkDADcDACANIBQpAwA3AwAgDyAaKQMANwMAIAogCikD4AM3A+AEIAsgCkHgBGogCkGgA2oQpAkgDikDACErIA0pAwAhLCAPKQMAITAgCikD4AQhLyAAKAIAIQsgDiAbKQMANwMAIA0gEikDADcDACAPIBwpAwA3AwAgCiAKKQOABDcD4AQgCyAKQeAEaiAKQaADahCkCSAXIA4pAwA3AwAgFSANKQMANwMAIBMgDykDADcDACAKIAopA+AENwOgBCAOIAUpAwA3AwAgDSAIKQMANwMAIA8gECkDADcDACAKIAopA8ADNwPgBCALIApB4ARqIApBwARqEKQJIAQgDikDACIiNwMAIAcgDSkDACIgNwMAIAYgDykDACIhNwMAIAogCikD4AQiJDcDoAMgBCALKQM4IjYgIiAXKQMAfCIoICAgFSkDAHwiIyAgVCAjICEgEykDAHwiICAhVCAgICQgCikDoAR8IiEgJFStfCIkICBUcq18IiAgI1RyrXwiI3wiJSALKQMwIicgIHwiKSAnVCApIAspAygiNCAkfCInIDRUICcgCykDICI0ICF8IjggNFStfCI0ICdUcq18IicgKVRyrXwiKSAjICMgKFQgIiAoVnIgJSA2VCAlIClWcnMiEhs3AwAgByAnICAgEhs3AwAgBiA0ICQgEhs3AwAgCiA4ICEgEhs3A6ADIA4gPiA1ICogQXwiIiAtID18IiAgPVQgICAmIEN8IiEgQ1QgISAuIEV8IiQgRVStfCIqICFUcq18IiEgIFRyrXwiIHwiLSAhIDd8IiYgN1QgJiAqIDN8Ii4gM1QgLiAkIDJ8IjMgMlStfCIyIC5Ucq18Ii4gJlRyrXwiJiAgICIgQVQgICAiVHIgLSA1VCAmIC1UcnMiBBt9Ii0gQiAuICEgBBt9IiYgQlYgJiBAIDIgKiAEG30iISBAViAhID8gMyAkIAQbfSIiID9WrX0iICAhVnKtfSIhICZWcq19IiQgISBKfCIqICFUICogICBJfCImICBUICYgIiBIfCIuICJUrXwiMyAmVHKtfCImICpUcq0gJCBHfHwgMSAtID5WICQgLVZyrVEiBBsiMjcDACANICEgJiAEGyI1NwMAIA8gICAzIAQbIjM3AwAgCiAiIC4gBBsiNzcD4AQgCyAKQeAEaiAKQcADahCkCSAFIA4pAwAiJDcDACAIIA0pAwAiIjcDACAQIA8pAwAiIDcDACAKIAopA+AEIiE3A8ADIAUgJCArfSIqICIgLH0iLSAiViAtICAgMH0iJiAgViAmICEgL30iIiAhVq19IiAgJlZyrX0iISAtVnKtfSItIC0gACgCACIAKQMYfCAhIAApAxB8IiYgIVQgJiAgIAApAwh8Ii4gIFQgLiAiIAApAwB8IiggIlStfCIjIC5Ucq18Ii4gJlRyrXwgMSAkICpUICogLVRyrVEiCxs3AwAgCCAhIC4gCxs3AwAgECAgICMgCxs3AwAgCiAiICggCxs3A8ADIAAgCkHgA2ogCkHABGoQpAkgFiAZKQMANwMAIAkgFCkDADcDACARIBopAwA3AwAgCiAKKQPgAzcDwAQgCiAyNwP4BCAKIDU3A/AEIAogMzcD6AQgCiA3NwPgBCAAIApB4ARqIApBgARqEKQJIBYgACkDOCIuIBYpAwAiMyAKKQP4BHwiMSAJKQMAIiAgCikD8AR8IiIgIFQgIiARKQMAIiEgCikD6AR8IiAgIVQgICAKKQPABCIkIAopA+AEfCIhICRUrXwiJCAgVHKtfCIgICJUcq18IiJ8IiogACkDMCImICB8Ii0gJlQgLSAAKQMoIjIgJHwiJiAyVCAmIAApAyAiMiAhfCI1IDJUrXwiMiAmVHKtfCImIC1Ucq18Ii0gIiAxIDNUICIgMVRyICogLlQgKiAtVnJzIgAbNwMAIAkgJiAgIAAbNwMAIBEgMiAkIAAbNwMAIAogNSAhIAAbNwPABCABIAUpAwA3AxggASAIKQMANwMQIAEgECkDADcDCCABIAopA8ADNwMAIAIgB/0AAwD9CwMQIAIgCv0AA6AD/QsDACADIAn9AAMA/QsDECADIAr9AAPABP0LAwAMAQsCQCAEKQMAIiIgCykDaCIxUg0AIAQpAwgiICALKQNwUg0AIAQpAxAiISALKQN4Ug0AIAQpAxgiJCALKQOAAVINACAG/QADACAi/RIgIP0eAf3WASAG/QADECAh/RIgJP0eAf3WAf0NAAECAwgJCgsQERITGBkaG/2kAUEPRw0AIAEgB/0AAwD9CwMAIAEgB/0AAxD9CwMQIAIgCP0AAxD9CwMQIAIgCP0AAwD9CwMAIAMgCf0AAxD9CwMQIAMgCf0AAwD9CwMADAELAkAgBykDACAxUg0AIAcpAwgiIiALKQNwUg0AIAcpAxAiICALKQN4Ug0AIAcpAxgiISALKQOAAVINACAJ/QADACAx/RIgIv0eAf3WASAJ/QADECAg/RIgIf0eAf3WAf0NAAECAwgJCgsQERITGBkaG/2kAUEPRw0AIAEgBP0AAwD9CwMAIAEgBP0AAxD9CwMQIAIgBf0AAxD9CwMQIAIgBf0AAwD9CwMAIAMgBv0AAxD9CwMQIAMgBv0AAwD9CwMADAELIApBEGoiDiAF/QADEP0LAwAgCiAF/QADAP0LAwAgCyAKIAkQpAkgCkEwaiIPIAT9AAMQ/QsDACAKIAT9AAMA/QsDICALIApBIGogCRCkCSAKQfAEaiINIAj9AAMQ/QsDACAKIAj9AAMA/QsD4AQgCyAKQeAEaiAGEKQJIAogCkH4BGoiCCkDACIuIAopAxh9IiQgDSkDACIiIA4pAwB9IiogIlYgKiAKQegEaiIOKQMAIiIgCikDCH0iISAiViAhIAopA+AEIiAgCikDAH0iIiAgVq19IiAgIVZyrX0iISAqVnKtfSIqICEgCykDEHwiLSAhVCAtICAgCykDCHwiJiAgVCAmICIgCykDAHwiMyAiVK18IjIgJlRyrXwiJiAtVHKtICogCykDGHx8QgAiMSAkICpUICQgLlZyrVEiCxsiKzcD2AMgCiAhICYgCxsiJzcD0AMgCiAgIDIgCxsiKTcDyAMgCiAiIDMgCxsiLjcDwAMgACgCACELIA0gB/0AAxD9CwMAIAogB/0AAwD9CwPgBCALIApB4ARqIAYQpAkgCiAIKQMAIjMgCikDOH0iJCANKQMAIiIgDykDAH0iKiAiViAqIA4pAwAiIiAKKQMofSIhICJWICEgCikD4AQiICAKKQMgfSIiICBWrX0iICAhVnKtfSIhICpWcq19IiogISALKQMQIih8Ii0gIVQgLSAgIAspAwgiI3wiJiAgVCAmICIgCykDACIlfCIyICJUrXwiNSAmVHKtfCImIC1Ucq0gKiALKQMYIjd8fCAxICQgKlQgJCAzVnKtUSINGyIqNwO4AyAKICEgJiANGyIkNwOwAyAKICAgNSANGyIhNwOoAyAKICIgMiANGyIiNwOgAwJAIC4gCykDaCIgUg0AICkgCykDcFINACAnIAspA3hSDQAgKyALKQOAAVINACAAIAEgAiADIAQgBSAGEMMJDAELAkAgICAiUg0AICEgCykDcFINACAkIAspA3hSDQAgKiALKQOAAVINACABIAtB6ABqIgv9AAMA/QsDACABIAv9AAMQ/QsDECACIAAoAgAiC/0AA4gB/QsDACACIAv9AAOYAf0LAxAgAyAAKAIAIgD9AANo/QsDACADIAD9AAN4/QsDEAwBCyAKIAb9AAMQ/QsDUCAKIAb9AAMA/QsDQCALIApBQGsgCRCkCSAKQfAAaiINIApB0ANqIgT9AAMA/QsDACAKIAr9AAPAA/0LA2AgCyAKQeAAaiAKQcADahCkCSAKQZABaiIGIApBsANqIgf9AAMA/QsDACAKIAr9AAOgA/0LA4ABIAsgCkGAAWogCkGgA2oQpAkgCkHwBGoiDiAH/QADAP0LAwAgCiAK/QADoAP9CwPgBCALIApB4ARqIApBgAFqEKQJIApB+ARqIggpAwAhIiAOKQMAISAgCkHoBGoiCSkDACEhIAopA+AEISQgCyAKQYABaiAKQSBqEKQJIAsgCkHgAGogCkFAaxCkCSAKKQN4IS4gDSkDACEqIAopA2ghLSAAKAIAIQ0gCikDYCEmIA4gAP0AA7gB/QsDACAKIAD9AAOoAf0LA+AEIA0gCkHgBGogCkGAAWoQpAkgCCkDACEpIA4pAwAhJyAJKQMAISsgCikD4AQhLCALKQMYITAgCykDACE+IAspAwghPyALKQMQIUAgCkGwAWoiBSAH/QADAP0LAwAgCiAK/QADoAP9CwOgASAKIC4gIn0iMyAqICB9IjIgKlYgMiAtICF9IjUgLVYgNSAmICR9IiogJlatfSItIDVWcq19IiYgMlZyrX0iMiAyIDd8ICYgKHwiNSAmVCA1ICMgLXwiNyAtVCA3ICUgKnwiKCAqVK18IiMgN1RyrXwiNyA1VHKtfCAxIC4gM1QgMiAzVnKtUSILGyIlICl9Ii4gJiA3IAsbIiYgJ30iMyAmViAzIC0gIyALGyItICt9IiYgLVYgJiAqICggCxsiLSAsfSIqIC1WrX0iLSAmVnKtfSImIDNWcq19IjMgJiBAfCIyICZUIDIgLSA/fCI1IC1UIDUgKiA+fCI3ICpUrXwiKCA1VHKtfCI1IDJUcq0gMCAzfHwgMSAuIDNUICUgLlRyrVEiCxsiLjcDmAIgCiAmIDUgCxsiJjcDkAIgCiAqIDcgCxsiKjcDgAIgCiAtICggCxsiLTcDiAIgDSAKQaABaiAKQYACahCkCSAOIAT9AAMA/QsDACAKIAr9AAPAA/0LA+AEIAogCikDmAEiNyAufSIuIAYpAwAiMiAmfSIzIDJWIDMgCikDiAEiMiAtfSImIDJWICYgCikDgAEiLSAqfSIqIC1WrX0iLSAmVnKtfSImIDNWcq19IjMgJiANKQMQIiN8IjIgJlQgMiAtIA0pAwgiJXwiNSAtVCA1ICogDSkDACIpfCInICpUrXwiKyA1VHKtfCI1IDJUcq0gMyANKQMYIih8fCAxIC4gM1QgLiA3VnKtUSILGzcD+AEgCiAmIDUgCxs3A/ABIAogLSArIAsbNwPoASAKICogJyALGzcD4AEgDSAKQeAEaiAKQeABahCkCSAIKQMAISogDikDACEtIAkpAwAhJiAKKQPgBCEuIAAoAgAhACAKICI3A/gEIAogIDcD8AQgCiAhNwPoBCAKICQ3A+AEIAAgCkHgBGogChCkCSAKICI3A9gBIApB0AFqIgsgIDcDACAKICE3A8gBIAogJDcDwAEgCikD+AQhIiAKKQPwBCEgIAopA+AEITIgCikD6AQhISAAIApBwAFqIApBQGsQpAkgASAF/QADAP0LAxAgASAK/QADoAH9CwMAIAIgKiAifSIkIC0gIH0iMyAtViAzICYgIX0iISAmViAhIC4gMn0iIiAuVq19IiAgIVZyrX0iISAzVnKtfSItICEgI3wiJiAhVCAmICAgJXwiLiAgVCAuICIgKXwiMyAiVK18IjIgLlRyrXwiLiAmVHKtICggLXx8IDEgJCAtVCAkICpWcq1RIgAbNwMYIAIgISAuIAAbNwMQIAIgICAyIAAbNwMIIAIgIiAzIAAbNwMAIAMgC/0AAwD9CwMQIAMgCv0AA8AB/QsDAAsgCkGABWokAAvUUAMPfyZ+AXsjAEGgBWsiByQAAkAgAC0A6AJBAUYEQCAAKAIAIQggByAE/QADEP0LA5ACIAcgBP0AAwD9CwOAAiAIIAdBgAJqIAUQpAkgB0GQBWoiBCAFQRBqIgz9AAMA/QsDACAHIAX9AAMA/QsDgAUgCCAHQYAFaiAFEKQJIAdBmAVqIgopAwAhKyAEKQMAISIgB0GIBWoiCykDACEXIAcpA4AFIRggByAG/QADEP0LA7ACIAcgBv0AAwD9CwOgAiAIIAdBoAJqIAYQpAkgByAM/QADAP0LA9ACIAcgBf0AAwD9CwPAAiAIIAdBwAJqIAYQpAkgBCAA/QADuAL9CwMAIAcgAP0AA6gC/QsDgAUgCCAHQYAFaiAHQaACahCkCSAHICsgCikDAH0iIyAiIAQpAwB9IiAgIlYgICAXIAspAwB9IhkgF1YgGSAYIAcpA4AFfSIdIBhWrX0iGiAZVnKtfSIZICBWcq19IiAgGSAIKQMQfCIeIBlUIB4gGiAIKQMIfCIbIBpUIBsgHSAIKQMAfCIcIB1UrXwiHyAbVHKtfCIbIB5Ucq0gICAIKQMYfHwgIyArViAgICNWcq1QIgUbNwP4ASAHIBkgGyAFGzcD8AEgByAaIB8gBRs3A+gBIAcgHSAcIAUbNwPgASAEIAD9AAOYAv0LAwAgByAA/QADiAL9CwOABSAIIAdBgAVqIAdBoAJqEKQJIAcgACgCACIIKQM4IhwgKyAKKQMAfCIWICIgBCkDAHwiHSAiVCAdIBcgCykDAHwiGiAXVCAaIBggBykDgAV8IhkgGFStfCIjIBpUcq18IhogHVRyrXwiHXwiICAIKQMwIhsgGnwiHiAbVCAeIAgpAygiHyAjfCIbIB9UIBsgCCkDICIfIBl8IiEgH1StfCIfIBtUcq18IhsgHlRyrXwiHiAdIBYgK1QgFiAdVnIgHiAgVCAcICBWcnMiBRs3A9gBIAcgGyAaIAUbNwPQASAHIB8gIyAFGzcDyAEgByAhIBkgBRs3A8ABIAdB8AJqIgUgAP0AA7gB/QsDACAHIAD9AAOoAf0LA+ACIAggB0GAAmogB0HgAWoQpAkgCCAHQeACaiAHQYACahCkCSABIAX9AAMA/QsDECABIAf9AAPgAv0LAwAgACgCACIIIAdB4AFqIAdBwAFqEKQJIAcpA/gBIRYgBykD8AEhHSAHKQPgASEaIAcpA+gBIRkgBCAA/QAD2AL9CwMAIAD9AAPIAiE8IAcgKzcDmAMgByAiNwOQAyAHIBc3A4gDIAcgGDcDgAMgByA8/QsDgAUgCCAHQYADaiAHQaACahCkCSAIIAdBgAVqIAdBgANqEKQJIAIgCCkDOCIfIBYgCikDAHwiIyAdIAQpAwB8IiAgHVQgICAZIAspAwB8Ih0gGVQgHSAaIAcpA4AFfCIZIBpUrXwiGiAdVHKtfCIdICBUcq18IiB8Ih4gCCkDMCIcIB18IhsgHFQgGyAIKQMoIiEgGnwiHCAhVCAcIAgpAyAiISAZfCInICFUrXwiISAcVHKtfCIcIBtUcq18IhsgICAgICNUIBYgI1ZyIB4gH1QgGyAeVHJzIggbNwMYIAIgHCAdIAgbNwMQIAIgISAaIAgbNwMIIAIgJyAZIAgbNwMAIAAoAgAhCCAHQdADaiIFIAD9AAP4Af0LAwAgByAA/QAD6AH9CwPAAyAHICs3A7gDIAcgIjcDsAMgByAXNwOoAyAHIBg3A6ADIAggB0GgA2ogB0HAAmoQpAkgCCAHQcADaiAHQaADahCkCSADIAX9AAMA/QsDECADIAf9AAPAA/0LAwAMAQsgACgCACEIIAAtAOkCQQFGBEAgB0GQBWoiCiAEQRBqIg79AAMA/QsDACAHIAT9AAMA/QsDgAUgCCAHQYAFaiAEEKQJIAdBmAVqIgwpAwAhHSAKKQMAIRogB0GIBWoiDykDACEZIAcpA4AFISMgB0HwA2oiEiAFQRBqIhP9AAMA/QsDACAHIAX9AAMA/QsD4AMgCCAHQeADaiAFEKQJIAdBkARqIhQgBv0AAxD9CwMAIAcgBv0AAwD9CwOABCAIIAdBgARqIAYQpAkgB0GwBGoiDSAO/QADAP0LAwAgByAE/QADAP0LA6AEIAggB0GgBGogBRCkCSAHQbgEaiILIAgpAzgiHyALKQMAIisgK3wiIiANKQMAIhcgF3wiGCAXVCAYIAdBqARqIhApAwAiFyAXfCIWIBdUIBYgBykDoAQiFyAXfCIgIBdUrXwiFyAWVHKtfCIWIBhUcq18Ihh8Ih4gCCkDMCIcIBZ8IhsgHFQgGyAIKQMoIiEgF3wiHCAhVCAcIAgpAyAiISAgfCInICFUrXwiISAcVHKtfCIcIBtUcq18IhsgGCAiICtUIBggIlRyIB4gH1QgGyAeVHJzIgsbNwMAIA0gHCAWIAsbNwMAIBAgISAXIAsbNwMAIAcgJyAgIAsbNwOgBCAHQdAEaiILIA79AAMA/QsDACAHIAT9AAMA/QsDwAQgCCAHQcAEaiAGEKQJIAdB2ARqIgQgACgCACIIKQM4Ih8gBCkDACIrICt8IiIgCykDACIXIBd8IhggF1QgGCAHQcgEaiIOKQMAIhcgF3wiFiAXVCAWIAcpA8AEIhcgF3wiICAXVK18IhcgFlRyrXwiFiAYVHKtfCIYfCIeIAgpAzAiHCAWfCIbIBxUIBsgCCkDKCIhIBd8IhwgIVQgHCAIKQMgIiEgIHwiJyAhVK18IiEgHFRyrXwiHCAbVHKtfCIbIBggIiArVCAYICJUciAeIB9UIBsgHlRycyINGyIeNwMAIAsgHCAWIA0bIhs3AwAgDiAhIBcgDRsiFzcDACAHICcgICANGyIYNwPABCAHQfAEaiINIABBOGoiFf0AAwD9CwMAIAcgAP0AAyj9CwPgBCAIIAdB4ARqIAdBgARqEKQJIAdB6ARqIhAgCCkDKCIiIAcpA+gDIiAgIiAiIBApAwAiHyAXfSIWIAcpA+AEIhwgGH0iFyAcVq19IhggGCAIKQMIIix8IhwgFyAIKQMAIiR8IicgF1StfCItQgAiKyAHQfgEaiIRKQMAIiEgHn0iHiAhViAeIA0pAwAiISAbfSIbICFWIBsgFiAYVCAWIB9Wcq19IhYgG1ZyrX0iHyAeVnKtUSIJGyIeIB58IiEgFyAnIAkbIhsgG3wiJyAbVK18Iip8IjcgCCkDICIXICd8IiUgF1StfCIpICogHyAWIAgpAxAiNHwiLiAWVCAuIBggHFYgHCAtVnKtfCItIC5Ucq0gHyAIKQMYIjB8fCAJGyIcIBx8IhggHFQgGCAWIC0gCRsiHyAffCIWIB9UIBYgHiAhViAhICpWcq18IiEgFlRyrXwiLiAYVHIgCCkDOCIYIC58Ii0gGFQgLSAIKQMwIhYgIXwiMSAWVCAxICkgN1QgIiA3VnKtfCI3IDFUcq18IjEgLVRycyIJGyItIB58Ih4gJSAnIAkbIicgG3wiGyAnVK18Iid8IiogFyAbfCIlIBdUrXwiKSAnIDEgLiAJGyIuIBx8IhwgLlQgHCA3ICEgCRsiISAffCIfICFUIB8gHiAtVCAeICdWcq18IiEgH1RyrXwiHyAcVHIgGCAffCIeIBhUIB4gFiAhfCIcIBZUIBwgKSAqVCAiICpWcq18Ii4gHFRyrXwiLSAeVHJzIgkbIjF8IhwgBykD4AMiHiAlIBsgCRsiJXwiJyAeVK18Iip8IjcgFyAnfCIpIBdUrXwiLyAqIAcpA/gDIhcgLSAfIAkbIi18Ih8gF1QgHyASKQMAIhsgLiAhIAkbIi58IiEgG1QgISAcICBUIBwgKlZyrXwiHCAhVHKtfCIhIB9UciAYICF8Ih8gGFQgHyAWIBx8IhggFlQgGCAvIDdUICIgN1ZyrXwiIiAYVHKtfCIYIB9UcnMiCRs3AwAgDSAiIBwgCRs3AwAgESAYICEgCRs3AwAgByApICcgCRs3A+AEIAwgFyAtfSIcIBsgLn0iHyAbViAfICAgMX0iFiAgViAWIB4gJX0iIiAeVq19IhggFlZyrX0iFiAfVnKtfSIgIBYgNHwiHiAWVCAeIBggLHwiGyAYVCAbICIgJHwiHyAiVK18IiEgG1RyrXwiGyAeVHKtICAgMHx8ICsgFyAcVCAcICBUcq1RIgkbIhc3AwAgCiAWIBsgCRsiFjcDACAPIBggISAJGyIYNwMAIAcgIiAfIAkbIiI3A4AFIAggB0GABWogB0HgBGoQpAkgDSAK/QADAP0LAwAgByAH/QADgAX9CwPgBCAAKAIAIQggByAXNwOYBSAHIBY3A5AFIAcgGDcDiAUgByAiNwOABSAIIAdBgAVqIAdBoARqEKQJIAcpA5gFISEgBykDkAUhJyAHKQOABSEqIAcpA4gFITcgCCkDOCEeIAcpA5gEIRcgCCkDICEbIAgpAyghHCAIKQMwIR8gFCkDACEYIAcpA4gEIRYgBykDgAQhICAKIBX9AAMA/QsDACAHIAD9AAMo/QsDgAUgCCAHQYAFaiAHQcAEahCkCSAEIAwpAwAiLjcDACALIAopAwAiLTcDACAOIA8pAwAiMTcDACAHIAcpA4AFIiw3A8AEIAQgACgCACIIKQM4IiIgLiAeIBcgHiAXIBd8IiQgGCAYfCIlIBhUICUgFiAWfCIpIBZUICkgICAgfCIwICBUrXwiNCApVHKtfCIpICVUcq18IiV8Ii8gHyApfCIyIB9UIDIgHCA0fCIoIBxUICggGyAwfCImIBtUrXwiNSAoVHKtfCIoIDJUcq18IjIgJSAXICRWICQgJVZyIB4gL1YgLyAyVnJzIgkbfCIkIBggKCApIAkbfCIlIBhUICUgFiA1IDQgCRt8IhggFlQgGCAgICYgMCAJG3wiFiAgVK18IiAgGFRyrXwiGCAlVHKtfCIlfCIpIBggH3wiMCAfVCAwIBwgIHwiHyAcVCAfIBYgG3wiHCAbVK18IjQgH1RyrXwiGyAwVHKtfCIfICUgFyAkViAkICVWciAfIClUIB4gKVZycyIJGyIwfSIeIC0gGyAYIAkbIi99IhsgLVYgGyAxIDQgICAJGyI0fSIgIDFWICAgLCAcIBYgCRsiMn0iFyAsVq19IhggIFZyrX0iFiAbVnKtfSIgIBYgCCkDECItfCIbIBZUIBsgGCAIKQMIIjF8IhwgGFQgHCAXIAgpAwAiLHwiJCAXVK18IiUgHFRyrXwiHCAbVHKtICAgCCkDGCIffHwgKyAeICBUIB4gLlZyrVEiCRsiLiAdfSIgIBYgHCAJGyIWIBp9Ih4gFlYgHiAYICUgCRsiGCAZfSIWIBhWIBYgFyAkIAkbIhggI30iFyAYVq19IhggFlZyrX0iFiAeVnKtfSIeIBYgLXwiGyAWVCAbIBggMXwiHCAYVCAcIBcgLHwiLSAXVK18IjEgHFRyrXwiHCAbVHKtIB4gH3x8ICsgHiAgViAgIC5Wcq1RIgkbIiAgIiAgICB8Ih8gFiAcIAkbIh4gHnwiFiAeVCAWIBggMSAJGyIbIBt8IhggG1QgGCAXIC0gCRsiHCAcfCIuIBxUrXwiLSAYVHKtfCIxIBZUcq18Iix8IiQgCCkDMCIXIDF8IiUgF1QgJSAIKQMoIhggLXwiKSAYVCApIAgpAyAiFiAufCIoIBZUrXwiJiApVHKtfCIpICVUcq18IiUgLCAfICBUIB8gLFZyICIgJFYgJCAlVnJzIgkbfCIfIB4gKSAxIAkbfCIxIB5UIDEgGyAmIC0gCRt8Ih4gG1QgHiAcICggLiAJG3wiGyAcVK18IhwgHlRyrXwiHiAxVHKtfCIufCItIBcgHnwiMSAXVCAxIBggHHwiLCAYVCAsIBYgG3wiJCAWVK18IiUgLFRyrXwiLCAxVHKtfCIxIC4gHyAgVCAfIC5WciAiIC1WIC0gMVZycyIJGzcDACALICwgHiAJGzcDACAOICUgHCAJGzcDACAHICQgGyAJGzcDwAQgCCkDGCExIAgpAxAhLCAIKQMIISQgByAWICMgFiAjICN8IiB8IiUgICAdIB18Ih4gHVQgHiAaIBp8IhsgGlQgGyAZIBl8IhwgGVQgHCAgICNUrXwiHyAcVHKtfCIcIBtUcq18IhsgHlRyIBsgInwiHiAiVCAeIBcgHHwiLiAXVCAuIBggH3wiLSAYVCAtIBYgJVatfCIlIC1Ucq18Ii0gLlRyrXwiLiAeVHJzIgkbIiB8IiN8Ih4gIyAdIC4gGyAJGyIbfCIdIBtUIB0gGiAtIBwgCRsiG3wiGiAbVCAaIBkgJSAfIAkbIht8IhkgG1QgGSAgICNWrXwiICAZVHKtfCIZIBpUcq18IhogHVRyIBogInwiHSAiVCAdIBcgGXwiIiAXVCAiIBggIHwiFyAYVCAXIBYgHlatfCIYIBdUcq18IhcgIlRyrXwiFiAdVHJzIgkbIiMgMn0iIiAiIAgpAwB8Ih4gKyAWIBogCRsiHSAwfSIWIB1WIBYgFyAZIAkbIhcgL30iHSAXViAdIBggICAJGyIXIDR9IhggF1YgGCAiICNWrX0iFyAYVnKtfSIYIB1Wcq19Ih0gFlZyrVEiCRs3A4AFIAcgFyAXICR8IhYgHiAiVK18IhogCRs3A4gFIAcgGCAYICx8IiIgFiAXVCAWIBpWcq18IhcgCRs3A5AFIAcgHSAXICJUIBggIlZyrSAdIDF8fCAJGzcDmAUgCCAHQYAFaiAHQcAEahCkCSARIAAoAgAiCCkDOCIiIBEpAwAiHyAHKQOYBXwiHSANKQMAIhggBykDkAV8IhcgGFQgFyAQKQMAIhYgBykDiAV8IhggFlQgGCAHKQPgBCIWIAcpA4AFfCIaIBZUrXwiGSAYVHKtfCIjIBdUcq18IiB8Ih4gCCkDMCIXICN8IhsgF1QgGyAIKQMoIhggGXwiHCAYVCAcIAgpAyAiFiAafCIuIBZUrXwiLSAcVHKtfCIcIBtUcq18IhsgICAdIB9UIB0gIFZyIB4gIlQgGyAeVHJzIgkbNwMAIA0gHCAjIAkbNwMAIBAgLSAZIAkbNwMAIAcgLiAaIAkbNwPgBCAKIBP9AAMA/QsDACAHIAX9AAMA/QsDgAUgCCAHQYAFaiAGEKQJIAwgIiAMKQMAIh0gHXwiGiAKKQMAIhkgGXwiIyAZVCAjIA8pAwAiGSAZfCIgIBlUICAgBykDgAUiGSAZfCIeIBlUrXwiGSAgVHKtfCIgICNUcq18IiN8IhsgFyAgfCIcIBdUIBwgGCAZfCIXIBhUIBcgFiAefCIYIBZUrXwiFiAXVHKtfCIXIBxUcq18IhwgIyAaIB1UIBogI1ZyIBsgIlQgGyAcVnJzIgUbIiI3AwAgCiAXICAgBRsiFzcDACAPIBYgGSAFGyIWNwMAIAcgGCAeIAUbIhg3A4AFIAggB0GABWogB0HABGoQpAkgBCAMKQMAIi43AwAgCyAKKQMAIi03AwAgDiAPKQMAIjE3AwAgByAHKQOABSIsNwPABCAAKAIAIgApAxghJCAAKQMQISUgACkDACEpIAApAwghMCAMICI3AwAgCiAXNwMAIA8gFjcDACAHIBg3A4AFIAAgB0GABWogB0HgA2oQpAkgBCAMKQMAIiI3AwAgCyAKKQMAIhc3AwAgDiAPKQMAIhg3AwAgByAHKQOABSIWNwPABCAEIAApAzgiHSAdICIgInwiGiAXIBd8IhkgF1QgGSAYIBh8IhcgGFQgFyAWIBZ8IiMgFlStfCIgIBdUcq18Ih4gGVRyrXwiGXwiGyAAKQMwIhcgHnwiHCAXVCAcIAApAygiGCAgfCIfIBhUIB8gACkDICIWICN8IjQgFlStfCIvIB9Ucq18Ih8gHFRyrXwiHCAZIBkgGlQgGiAiVHIgGyAdVCAbIBxWcnMiABsiIiAifCIaIB8gHiAAGyIZIBl8Ih4gGVQgHiAvICAgABsiGSAZfCIgIBlUICAgNCAjIAAbIhkgGXwiIyAZVK18IhkgIFRyrXwiICAeVHKtfCIefCIbIBcgIHwiHCAXVCAcIBggGXwiFyAYVCAXIBYgI3wiGCAWVK18IhYgF1RyrXwiFyAcVHKtfCIcIB4gGiAiVCAaIB5WciAbIB1UIBsgHFZycyIAGzcDACALIBcgICAAGzcDACAOIBYgGSAAGzcDACAHIBggIyAAGzcDwAQgASAhIC59IhYgJyAtfSIdICdWIB0gNyAxfSIYIDdWIBggKiAsfSIiICpWrX0iFyAYVnKtfSIYIB1Wcq19Ih0gGCAlfCIaIBhUIBogFyAwfCIZIBdUIBkgIiApfCIjICJUrXwiICAZVHKtfCIZIBpUcq0gHSAkfHwgKyAWIB1UIBYgIVZyrVEiABs3AxggASAYIBkgABs3AxAgASAXICAgABs3AwggASAiICMgABs3AwAgAiAN/QADAP0LAxAgAiAH/QAD4AT9CwMAIAMgC/0AAwD9CwMQIAMgB/0AA8AE/QsDAAwBCwJAIAQpAwAiKyAIKQNoUg0AIAQpAwgiIiAIKQNwUg0AIAQpAxAiFyAIKQN4Ug0AIAQpAxgiGCAIKQOAAVINACAG/QADACAr/RIgIv0eAf3WASAG/QADECAX/RIgGP0eAf3WAf0NAAECAwgJCgsQERITGBkaG/2kAUEPRw0AIAEgBP0AAwD9CwMAIAEgBP0AAxD9CwMQIAIgACgCACIA/QADiAH9CwMAIAIgAP0AA5gB/QsDECADIAb9AAMQ/QsDECADIAb9AAMA/QsDAAwBCyAHIAb9AAMQ/QsDMCAHIAb9AAMA/QsDICAIIAdBIGogBhCkCSAHQZAFaiIKIARBEGoiDf0AAwD9CwMAIAcgBP0AAwD9CwOABSAIIAdBgAVqIAQQpAkgB0GYBWoiCykDACErIAopAwAhIiAHQYgFaiIMKQMAIRcgBykDgAUhGCAIKQM4IRYgCCkDICEdIAgpAyghGiAIKQMwIRkgB0HQAGoiDyAFQRBqIhD9AAMA/QsDACAHIAX9AAMA/QsDQCAIIAdBQGsgBhCkCSAAKAIAIQggByAP/QADAP0LA3AgByAH/QADQP0LA2AgCCAHQeAAaiAHQUBrEKQJIAogD/0AAwD9CwMAIAcgB/0AA0D9CwOABSAIIAdBgAVqIAdB4ABqEKQJIAspAwAhNyAKKQMAIS4gDCkDACEtIAcpA4AFITEgCCkDMCEgIAgpAyAhHiAIKQMoIRsgCCkDOCEcIAogAP0AAxj9CwMAIAcgAP0AAwj9CwOABSAIIAdBgAVqIAdBIGoQpAkgB0EYaiIRIBwgCykDACIpIBYgKyAWICsgK3wiIyAiICJ8Ih8gIlQgHyAXIBd8IiEgF1QgISAYIBh8IicgGFStfCIqICFUcq18IiEgH1RyrXwiH3wiLCAZICF8IiQgGVQgJCAaICp8IiUgGlQgJSAdICd8IjAgHVStfCI0ICVUcq18IiUgJFRyrXwiJCAfICMgK1QgHyAjVHIgJCAsVCAWICxWcnMiCBsiLHwiKyAiICUgISAIGyIjfCIiICNUICIgFyA0ICogCBsiI3wiFyAjVCAXIBggMCAnIAgbIiN8IhggI1StfCIjIBdUcq18IhcgIlRyrXwiInwiHyAXIBl8IiEgGVQgISAaICN8IhkgGlQgGSAYIB18IhogHVStfCIdIBlUcq18IhkgIVRyrXwiISAiICsgLFQgIiArVHIgFiAfViAfICFWcnMiCBt8IisgCikDACIWIBkgFyAIG3wiIiAWVCAiIAwpAwAiFiAdICMgCBt8IhcgFlQgFyAHKQOABSIWIBogGCAIG3wiGCAWVK18IhYgF1RyrXwiFyAiVHKtfCIifCIdIBcgIHwiGiAgVCAaIBYgG3wiGSAbVCAZIBggHnwiIyAeVK18Ih8gGVRyrXwiGSAaVHKtfCIaICIgIiArVCApICtWciAaIB1UIBwgHVZycyIIGzcDACAHQRBqIg4gGSAXIAgbNwMAIAdBCGoiCSAfIBYgCBs3AwAgByAjIBggCBs3AwAgACgCACEIIAdBkAFqIgYgEP0AAwD9CwMAIAcgBf0AAwD9CwOAASAIIAdBgAFqIAdBQGsQpAkgCCkDOCErIAgpAyAhIiAIKQMoIRcgCCkDMCEYIAogDf0AAwD9CwMAIAcgBP0AAwD9CwOABSAIIAdBgAVqIAdBgAFqEKQJIAspAwAhHyAKKQMAISEgDCkDACEnIAcpA4AFISogCiAG/QADAP0LAwAgByAH/QADgAH9CwOABSAIIAdBgAVqIAdBgAFqEKQJIAspAwAhLCAKKQMAISQgDCkDACElIAcpA4AFISkgACgCACIIKQMgIRYgCCkDKCEdIAgpAzAhGiAIKQM4IRkgCiAO/QADAP0LAwAgByAH/QADAP0LA4AFIAggB0GABWogBxCkCSAAKAIAIggpAzghMCAIKQMgITQgCCkDKCEvIAgpAzAhMiAHIAspAwAiOiAZIBkgKyAfIB98IiggISAhfCImICFUICYgJyAnfCIhICdUICEgKiAqfCInICpUrXwiKiAhVHKtfCIhICZUcq18IiZ8IjUgGCAhfCIzIBhUIDMgFyAqfCI2IBdUIDYgIiAnfCI4ICJUrXwiOSA2VHKtfCI2IDNUcq18IjMgJiAmIChUIB8gKFZyIDMgNVQgKyA1VnJzIgUbIh8gH3wiKCA2ICEgBRsiISAhfCImICFUICYgOSAqIAUbIiEgIXwiKiAhVCAqIDggJyAFGyIhICF8IjUgIVStfCInICpUcq18IiEgJlRyrXwiKnwiJiAaICF8IjMgGlQgMyAdICd8IjYgHVQgNiAWIDV8IjggFlStfCI5IDZUcq18IjYgM1RyrXwiMyAqICggKlYgHyAoVnIgGSAmViAmIDNWcnMiBRsiHyAffCIoIDYgISAFGyIhICF8IiYgIVQgJiA5ICcgBRsiJyAnfCIzICdUIDMgOCA1IAUbIiogKnwiNSAqVK18IjYgM1RyrXwiMyAmVHKtfCImfCI4IBogM3wiOSAaVCA5IB0gNnwiGiAdVCAaIBYgNXwiHSAWVK18IhYgGlRyrXwiGiA5VHKtfCI5ICYgJiAoVCAfIChWciAZIDhWIDggOVZycyIFG30iGSAKKQMAIiYgGiAzIAUbfSIoICZWICggDCkDACImIBYgNiAFG30iGiAmViAaIAcpA4AFIiYgHSA1IAUbfSIWICZWrX0iHSAaVnKtfSIaIChWcq19IiggGiAIKQMQfCImIBpUICYgHSAIKQMIfCI1IB1UIDUgFiAIKQMAfCI4IBZUrXwiMyA1VHKtfCI1ICZUcq0gKCAIKQMYfHxCACIjIBkgKFQgGSA6VnKtUSIFGyI5NwO4ASAHQbABaiIEIBogNSAFGyI6NwMAIAcgHSAzIAUbIjs3A6gBIAcgMCAHKQNYIh0gHXwiGiAPKQMAIhkgGXwiKCAZVCAoIAcpA0giGSAZfCImIBlUICYgBykDQCIZIBl8IjUgGVStfCIZICZUcq18IiYgKFRyrXwiKHwiMyAmIDJ8IjYgMlQgNiAZIC98IjIgL1QgMiA0IDV8Ii8gNFStfCI0IDJUcq18IjIgNlRyrXwiNiAoIBogHVQgGiAoVnIgMCAzViAzIDZWcnMiBhs3A5gFIAcgMiAmIAYbNwOQBSAHIDQgGSAGGzcDiAUgByAvIDUgBhs3A4AFIAcgFiA4IAUbIjI3A6ABIAggB0GgAWogB0GABWoQpAkgACgCACIAKQM4IRYgACkDICEdIAApAyghGiAAKQMwIRkgACkDGCE0IAcgISA6fSIvICcgO30iMCAnViAwICogMn0iJyAqVq19IiogMFZyrX0iMCAwIAApAxAiNXwiMiAqIAApAwgiM3wiKCAqVCAoICcgACkDACI2fCImICdUrXwiOCAoVHKtfCI6ICMgHyA5fSIoIB9WICggISAvVCAvIDBUcq19Ih8gKFZyrVEiCBs3A9ABIAcgKiA4IAgbNwPIASAHICcgJiAIGzcDwAEgByAfIDAgMlYgMiA6VnKtIB8gNHx8IAgbNwPYASAAIAcgB0HAAWoQpAkgESkDACEfIA4pAwAhISAJKQMAIScgBykDACEqIAEgBP0AAwD9CwMQIAEgB/0AA6AB/QsDACACIB8gFiAWIBYgLCAsfCIwICQgJHwiLyAkVCAvICUgJXwiJCAlVCAkICkgKXwiJSApVK18IikgJFRyrXwiJCAvVHKtfCIvfCIyIBkgJHwiKCAZVCAoIBogKXwiJiAaVCAmIB0gJXwiOCAdVK18IjkgJlRyrXwiJiAoVHKtfCIoIC8gLyAwVCAsIDBWciAoIDJUIBYgMlZycyIAGyIsICx8IjAgJiAkIAAbIiQgJHwiLyAkVCAvIDkgKSAAGyIkICR8IikgJFQgKSA4ICUgABsiJCAkfCIlICRUrXwiJCApVHKtfCIpIC9Ucq18Ii98IjIgGSApfCIoIBlUICggGiAkfCImIBpUICYgHSAlfCI4IB1UrXwiOSAmVHKtfCImIChUcq18IiggLyAvIDBUICwgMFZyICggMlQgFiAyVnJzIgAbIiwgLHwiMCAmICkgABsiKSApfCIvIClUIC8gOSAkIAAbIiQgJHwiKSAkVCApIDggJSAAGyIkICR8IiUgJFStfCIkIClUcq18IikgL1RyrXwiL3wiMiAZICl8IiggGVQgKCAaICR8IhkgGlQgGSAdICV8IiYgHVStfCIdIBlUcq18IhogKFRyrXwiGSAvIC8gMFQgLCAwVnIgGSAyVCAWIDJWcnMiABt9IhkgISAaICkgABt9IiwgIVYgLCAnIB0gJCAAG30iGiAnViAaICogJiAlIAAbfSIWICpWrX0iHSAaVnKtfSIaICxWcq19IiEgGiA1fCInIBpUICcgHSAzfCIqIB1UICogFiA2fCIsIBZUrXwiJCAqVHKtfCIqICdUcq0gISA0fHwgIyAZICFUIBkgH1ZyrVEiABs3AxggAiAaICogABs3AxAgAiAdICQgABs3AwggAiAWICwgABs3AwAgAyArICsgHCA3IDd8IhYgLiAufCIdIC5UIB0gLSAtfCIaIC1UIBogMSAxfCIZIDFUrXwiIyAaVHKtfCIaIB1Ucq18Ih18Ih8gGiAgfCIhICBUICEgGyAjfCIgIBtUICAgGSAefCIbIB5UrXwiHiAgVHKtfCIgICFUcq18IiEgHSAWIDdUIBYgHVZyIBwgH1YgHyAhVnJzIgAbIhYgFnwiHSAgIBogABsiGiAafCIgIBpUICAgHiAjIAAbIhogGnwiIyAaVCAjIBsgGSAAGyIaIBp8IhkgGlStfCIaICNUcq18IiMgIFRyrXwiIHwiHiAYICN8IhsgGFQgGyAXIBp8IhwgF1QgHCAZICJ8Ih8gIlStfCIhIBxUcq18IhwgG1RyrXwiGyAgIB0gIFYgFiAdVnIgHiArVCAbIB5UcnMiABsiFiAWfCIdIBwgIyAAGyIjICN8IiAgI1QgICAhIBogABsiGiAafCIjIBpUICMgHyAZIAAbIhogGnwiGSAaVK18IhogI1RyrXwiIyAgVHKtfCIgfCIeIBggI3wiGyAYVCAbIBcgGnwiGCAXVCAYIBkgInwiFyAiVK18IiIgGFRyrXwiGCAbVHKtfCIbICAgHSAgViAWIB1WciAeICtUIBsgHlRycyIAGzcDGCADIBggIyAAGzcDECADICIgGiAAGzcDCCADIBcgGSAAGzcDAAsgB0GgBWokAAuCCgIlfgJ/IwBBIGsiKSQAICkgASACIAMQmQkgASkDoAEhByABKQOYASEEIAEpA5ABIQYgASkDiAEhCCABKQMYISAgASkDECEhIAEpAwghIiABKQMAISMgAEEQaiIqIAH9AAN4/QsDACAAIAH9AANo/QsDACAAKQMYIQsgKikDACENIAApAwghDyABKQM4IRogASkDMCEbIAEpAyghHCABKQMgIR0gASkDgAIhJCABKQP4ASElIAEpA/ABISYgASkD6AEhJyAAKQMAIRAgKSkDGCEFICkpAxAhCSApKQMIIQogKSkDACEOICMhHiAiIRYgISEXICAhGANAAkACQCAOUARAIApCAFINASAJQgBSDQEgBUIAUg0BIAAgCzcDGCAAIA03AxAgACAPNwMIIAAgEDcDACApQSBqJAAPCyAOp0EBcQ0BCyAGQj+GIAhCAYiEIQwgBEI/hiAGQgGIhCEGIAdCP4YgBEIBiIQhBCAKQj+GIA5CAYiEIQ4gCUI/hiAKQgGIhCEKIAVCP4YgCUIBiIQhCSAHQgGIIQcgCEIBg1AEQCAMIQggBUIBiCEFDAILIBogByAkfCIIIAQgJXwiEiAEVCASIAYgJnwiBCAGVCAEIAwgJ3wiFSAMVK18IgYgBFRyrXwiBCASVHKtfCIMfCISIAQgG3wiEyAbVCATIAYgHHwiESAcVCARIBUgHXwiFCAdVK18IhkgEVRyrXwiESATVHKtfCITIAwgByAIViAIIAxWciASIBpUIBIgE1ZycyIBGyEHIBEgBCABGyEEIBkgBiABGyEGIBQgFSABGyEIIAVCAYghBQwBCwJAQgAiDCAKIBZRIA4gHlRxIAogFlRyIAkgF1FxIAkgF1RyIAUgGFFxIAUgGFRyrVEEQCALIRIgDSEVIA8hEyAFISggCSERIAohFCAQIRkgDiEfIAchCyAEIQ0gBiEPIAghEAwBCyAHIRIgBCEVIAYhEyAYISggFyERIBYhFCAIIRkgHiEfIA4hHiAKIRYgCSEXIAUhGAsgCyASfSIEIA0gFX0iBSANViAFIA8gE30iByAPViAHIBAgGX0iDiAQVq19IgYgB1ZyrX0iByAFVnKtfSIFIAcgIXwiCiAHVCAKIAYgInwiCSAGVCAJIA4gI3wiCCAOVK18Ig0gCVRyrXwiCSAKVHKtIAUgIHx8IAwgBCAFVCAEIAtWcq1RIgEbIgVCP4YgByAJIAEbIgpCAYiEIQQgBUIBiCEHIApCP4YgBiANIAEbIgtCAYiEIQYgESAXfSIFIBQgFn0iCiAUViAKIB8gHn0iDSAfVq19IgwgClZyrX0iCUI/hiAMQgGIhCEKICggGH0gBSAJVCAFIBFWcq19IgVCP4YgCUIBiIQhCSALQj+GIA4gCCABGyILQgGIhCEIIAxCP4YgDUIBiIQhDiALQgGDpwRAIBogByAkfCIMIAQgJXwiCyAEVCALIAYgJnwiBCAGVCAEIAggJ3wiDSAIVK18IgYgBFRyrXwiBCALVHKtfCIIfCILIAQgG3wiDyAbVCAPIAYgHHwiECAcVCAQIA0gHXwiESAdVK18IhQgEFRyrXwiECAPVHKtfCIPIAggCCAMVCAHIAxWciALIBpUIAsgD1ZycyIBGyEHIBAgBCABGyEEIBQgBiABGyEGIBEgDSABGyEICyASIQsgFSENIBMhDyAZIRAgBUIBiCEFDAALAAvIEAIBfx1+IwBBgARrIgMkACADQYACaiACKQMAIgtCACABKQMAIgVCABA2IANBkAJqIAIpAwgiBEIAIAVCABA2IANBoAJqIAIpAxAiBkIAIAVCABA2IANBsAJqIAIpAxgiCUIAIAVCABA2IANB8AFqIAApAwAiBUIAIAApA2AiDyADKQOAAiIHfiIIQgAQNiADQeABaiAAKQMIIhBCACAIQgAQNiADQZABaiAAKQMQIhNCACAIQgAQNiADQUBrIAApAxgiEUIAIAhCABA2IANBwAJqIAtCACABKQMIIghCABA2IANB8AJqIARCACAIQgAQNiADQaADaiAGQgAgCEIAEDYgA0HQA2ogCUIAIAhCABA2IANB0AFqIAVCACAPIAMpA5ACIhIgAykDiAJ8IgwgAykD4AF8Ig0gByADKQPwAXwgB1StfCIKIAMpA/gBfCIOIAMpA8ACfCIIfiIHQgAQNiADQcABaiAQQgAgB0IAEDYgA0GwAWogE0IAIAdCABA2IANBoAFqIBFCACAHQgAQNiADQdACaiALQgAgASkDECIHQgAQNiADQYADaiAEQgAgB0IAEDYgA0GwA2ogBkIAIAdCABA2IANB4ANqIAlCACAHQgAQNiADQYABaiAFQgAgDyADKQOgAiIcIAMpA5gCfCIVIAwgElStfCISIAMpA5ABfCIWIAogDVQgDCANVnKtfCIMIAMpA+gBfCINIAogDlatfCIKIAMpA/ACfCIXIAggDlStfCIOIAMpA8gCfCIYIAMpA8ABfCIZIAggAykD0AF8IAhUrXwiGiADKQPYAXwiGyADKQPQAnwiCH4iB0IAEDYgA0HwAGogEEIAIAdCABA2IANB4ABqIBNCACAHQgAQNiADQdAAaiARQgAgB0IAEDYgA0HgAmogC0IAIAEpAxgiB0IAEDYgA0GQA2ogBEIAIAdCABA2IANBwANqIAZCACAHQgAQNiADQfADaiAJQgAgB0IAEDYgA0EwaiAFQgAgDyADKQOwAiIgIAMpA6gCfCIGIBIgFVQgFSAcVHKtfCIJIAMpA0B8IgcgDCAWVCASIBZWcq18IhUgAykDmAF8IhIgCiANVCAMIA1Wcq18IgwgAykDoAN8Ig0gDiAXVCAKIBdWcq18IgogAykD+AJ8IhYgDiAYVq18Ig4gAykDsAF8IhcgGCAZViAZIBpWcq18IhggAykDyAF8IhkgGiAbVq18IhogAykDgAN8IhwgCCAbVK18IhsgAykD2AJ8Ih0gAykDcHwiHiAIIAMpA4ABfCAIVK18IgggAykDiAF8Ih8gAykD4AJ8Igt+IgRCABA2IANBIGogEEIAIARCABA2IANBEGogE0IAIARCABA2IAMgEUIAIARCABA2IAFCACAUIAMpA7gCfCIFViAFIAYgIFQgBiAJVnKtfCIEIAVUcq0gFHwgBCAHIAlUIAcgFVZyrXwiBSAEVK18IAUgAykDSHwiBCAFVCAEIBIgFVQgDCASVHKtfCIFIARUcq18IAUgAykD0AN8IgQgBVQgBCAKIA1UIAwgDVZyrXwiBSAEVHKtfCIGIAMpA9gDfCIEIAZUIAQgBSADKQOoA3wiBiAFVCAGIA4gFlQgCiAWVnKtfCIFIAZUcq18IgYgBFRyrSAUfCAGIAUgAykDoAF8IgQgBVQgBCAOIBdWIBcgGFZyrXwiBSAEVHKtfCIEIAZUrXwgBCADKQOoAXwiBiAEVCAGIAUgAykDuAF8IgQgBVQgBCAYIBlWIBkgGlZyrXwiBSAEVHKtfCIEIAZUcq18IAQgAykD4AN8IgYgBFQgBiAFIAMpA7ADfCIEIAVUIAQgGyAcVCAaIBxWcq18IgUgBFRyrXwiBCAGVHKtfCIJIAMpA+gDfCIGIAlUIAYgBCADKQO4A3wiCSAEVCAJIAUgAykDiAN8IgQgBVQgBCAbIB1WrXwiBSAEVHKtfCIEIAlUcq18IgkgBlRyrSAUfCAJIAQgAykDUHwiBiAEVCAGIAUgAykDYHwiBCAFVCAEIAggHlQgHSAeVnKtfCIFIARUcq18IgQgBlRyrXwiBiAJVK18IAYgAykDWHwiCSAGVCAJIAQgAykDaHwiBiAEVCAGIAUgAykDeHwiBCAFVCAEIAggH1atfCIFIARUcq18IgQgBlRyrXwiBiAJVHKtfCAGIAMpA/ADfCIJIAZUIAkgBCADKQPAA3wiBiAEVCAGIAUgAykDkAN8IgQgBVQgBCALIB9UrXwiBSAEVHKtfCIEIAZUcq18IgYgCVRyrXwiDCADKQP4A3wiCSAGIAMpA8gDfCIPIAZUIA8gBCADKQOYA3wiBiAEVCAGIAUgAykD6AJ8IgQgBVStfCIFIAZUcq18IgYgD1RyrXwiDyAGIAMpAwB8IgggBlQgCCAFIAMpAxB8IgYgBVQgBiAEIAMpAyB8IgUgBFQgBSALIAMpAzB8IAtUrXwiCyAFVHKtfCIFIAZUcq18IgQgCFRyrXwiBiADKQMIfCIIIAQgAykDGHwiECAEVCAQIAUgAykDKHwiBCAFVCAEIAsgAykDOHwiBSALVK18IgsgBFRyrXwiBCAQVHKtfCIQIBAgACkDOCINfCITIAApAzAiByAEfCIRIAdUIBEgACkDKCIKIAt8IgcgClQgByAAKQMgIgogBXwiDiAKVK18IgogB1RyrXwiByARVHKtfCIRIAYgCFYgCCAQVnKtIAYgD1StIBQgCSAMVCAJIA9Wcq18fHwgFCARIBNUIA0gE1ZyrXxRIgAbNwMYIAEgBCAHIAAbNwMQIAEgCyAKIAAbNwMIIAEgBSAOIAAbNwMAIANBgARqJAALkwMBCH8gASAAKAIIIgQgACgCBCIGa0EFdU0EQCAAIAEEfyABQQV0IgEEQCAGQQAgAfwLAAsgASAGagUgBgs2AgQPCwJAIAYgACgCACICayIHQQV1IgggAWoiBUGAgIDAAEkEQCAHIQlB////PyAEIAJrIgRBBHUiByAFIAUgB0kbIARB4P///wdPGyIFBEAgBUGAgIDAAE8NAiAFQQV0EKIJIQMLIAkgA2ohBCABQQV0IgEEQCAEQQAgAfwLAAsgBCAIQQV0ayEHIAEgBGohBCADIAVBBXRqIQUgAiAGRwRAIAIhASAHIQMDQCADIAH9AAMA/QsDACADIAEoAhA2AhAgAyABKAIUNgIUIAMgASgCGDYCGCABQQA2AhggAUIANwIQIANBIGohAyABQSBqIgEgBkcNAAsDQCACKAIQIgEEQCACQRBqIgMgARC9CSADKAIAECsLIAJBIGoiAiAGRw0ACyAAKAIAIQILIAAgBTYCCCAAIAQ2AgQgACAHNgIAIAIEQCACECsLDwsQoAkACxCgCQALPAIBfwF7IwBBoAtrIgEkACABQRBqEJgJGiAAIAFBECAAKAIAKAIIEQEAIAH9AAQAIQIgAUGgC2okACACC5cEAgR/An4jAEGQAWsiBCQAIARB6ABqIAAQyQkCf0EAIAQtAIgBQQFHDQAaQQAgBCkDgAEiCEHIiDQpAwAiCVQgCCAJUSAEKQN4IghBwIg0KQMAIglUIAggCVEgBCkDcCIIQbiINCkDACIJVCAIIAlRIAQpA2hBsIg0KQMAVHFycXJxcq1QDQAaIAQgBP0AA3j9CwNYIAQgBP0AA2j9CwNIQbCINCAEQcgAakHwiDQQpAkgBCAE/QAAUf0LAzAgBCAEKQBgNwA/IAQgBCkASTcDKEEBIQUgBC0ASAshBiAEQegAaiABEMkJAkACQCAELQCIAUEBRgRAQQAhACAEKQOAASIIQciINCkDACIJVCAIIAlRIAQpA3giCEHAiDQpAwAiCVQgCCAJUSAEKQNwIghBuIg0KQMAIglUIAggCVEgBCkDaEGwiDQpAwBUcXJxcnFyDQELQQAhAAwBCyAEIAT9AAN4/QsDWCAEIAT9AANo/QsDSEGwiDQgBEHIAGpB8Ig0EKQJIARBEGoiASAE/QAAUf0LAwAgBEEfaiIHIAQpAGA3AAAgBCAEKQBJNwMIIAVFDQAgBC0ASCEAIAIgBjoAACACIAQpAyg3AAEgAiAE/QADMP0LAAkgAiAEKQA/NwAYIAMgADoAACADIAQpAwg3AAEgAyAB/QADAP0LAAkgAyAHKQAANwAYQQEhAAsgBEGQAWokACAAC5oDAgV/B34jAEFAaiICJABCCiELAkAgAS0AAEEwRw0AIAEtAAFBIHJB+ABHDQAgAUECaiEBQhAhC0EBIQMLIANBAXMhBiABIQMgAAJ/AkACQANAIAMsAAAiBEUNAiAEENMBwCIFQTBrIgRBCk8EQCAGIAVB4QBrQQVLcg0CIAVB1wBrIQQLIAJBMGogDEIAIAtCABA2IAJBIGogB0IAIAtCABA2IAJBEGogCEIAIAtCABA2IAIgCUIAIAtCABA2QgAgAikDACIKIAIpAxh8IgcgClQgByACKQMQIgggAikDKHwiCiAIVCAKIAIpAyAiCSACKQM4fCIIIAlUrXwiCSAKVHKtfCIKIAdUcq18QgAgAikDCH1SDQEgDUIAIAogCSAIIAIpAzAiByAErXwiDCAHVK18IgcgCFStfCIIIAlUrXwiCSAKVK19Ug0BIANBAWoiAyABa0HRAEkNAAsgAS0AUUUNAQsgAEEAOgAAQQAMAQsgACAJNwMYIAAgCDcDECAAIAc3AwggACAMNwMAQQELOgAgIAJBQGskAAv8AgIGfwR+IwBBIGsiAyQAIAH9AAMAIAH9AAMQIAAoAgAQ4AkhCCADIAA2AhAgAyABNgIMIANBjM8xNgIIIAMgA0EIajYCGCAAQThqIgUgCCADQQhqEPgJIQYCQCADKAIYIgIgA0EIakYEf0EQBSACRQ0BQRQLIQQgAiACKAIAIARqKAIAEQYACyAGQX9GBEAgACgCLCECIAAoAjAhBCAAQSxqIAEQqAogBCACa0EFdSEGIAAoAjxBAXRBASAAKAI4IgJ0SwRAIAUQ+QkgBSgCACECCyAIQiCIIAh8IglC/////w+DIgggAq0iCohCA34gCHwgCCACQQF0rSILiEIHfnwiCCAKiEIDfiAIfCAIIAuIQgd+fKdBAXRBAXIhBCAIpyEBQX8gAnRBf3MhBSAAKAJAIQcDQCABIAVxIQIgASAEaiEBIAcgAkEDdGoiAigCBEF/Rw0ACyACIAY2AgQgAiAJPgIAIAAgACgCPEEBajYCPAsgA0EgaiQAIAYL7gsCBH4MfyMAQSBrIgskACABKAIEIgcgASgCACIIa0EMbSIGrSABMQAdIAExAB4gATUCFCABNQIQQgGFIgJCPIYgAkI/hoUgAkKBgICAgICAgCB+hSICQgOIhSACQgGIhSACQgSIhSAChSICQj+GIAJCPYaFIAJCPIaFIAKFIgJCA4iFIAJCAYiFIAJCBIiFIAKFIgJCP4YgAkI9hoUgAkI8hoUgAoUiAkIDiIUgAkIBiIUgAkIEiIUgAoUiAkI/hiACQj2GhSACQjyGhSAChSICQgOIhSACQgGIhSACQgSIhSAChSICQj+GIAJCPYaFIAJCPIaFIAKFIgJCA4ggAkIBiIUgAkIEiIUgAoUhAiAHIAhHBEBBASAGIAZBAU0bIQlBACEGA0AgAiAIIAZBDGxqIgc1AgCFIgJCP4YgAkI9hoUgAkI8hoUgAoUiAkIDiCAHNQIEhSACQgGIhSACQgSIhSAChSICQj+GIAJCPYaFIAJCPIaFIAKFIgJCA4ggBzUCCIUgAkIBiIUgAkIEiIUgAoUiAkI/hiACQj2GhSACQjyGhSAChSICQgOIIAJCAYiFIAJCBIiFIAKFIQIgBkEBaiIGIAlHDQALCyALIAE2AgwgC0GwzzE2AgggCyAANgIQIAsgC0EIajYCGCAAQdgAaiIQIAIgC0EIahD4CSENAkAgCygCGCIGIAtBCGpGBH9BEAUgBkUNAUEUCyEHIAYgBigCACAHaigCABEGAAsCQAJAAkACQCANQX9HBEAgASgCBCABKAIAIgZrQQxGBEAgBigCBEUNAgsgACAAKAIYQQFqNgIYDAELQQAhCCABQQA2AgwgAUEMaiEOIAAoAkwhByABKAIAIg8gASgCBCIMRwRAIA8hBgNAIA4gCCAHIAYoAgRBBXRqKAIMIgkgByAGKAIIQQV0aigCDCIKIAkgCksbQQFqIgkgCCAJSxsiCDYCACAGQQxqIgYgDEcNAAsLIAAoAlAiCSAHayIIQQV1IQ0CQCAAKAJUIgYgCUsEQCAJQQA2AgggCUIANwIAIAEoAgQiBiABKAIAIghHBEAgBiAIayIGQQxtQdaq1aoBTw0EIAkgBhCiCSIHNgIEIAkgBzYCACAJIAYgB2oiCjYCCCAGBEAgByAIIAb8CgAACyAJIAo2AgQLIAkgDv0AAgD9CwIMIAkgDigCEDYCHCAJQSBqIQoMAQsgDUEBaiIKQYCAgMAATw0DQf///z8gBiAHayIGQQR1IgEgCiABIApLGyAGQeD///8HTxsiBkGAgIDAAE8NBCAGQQV0IgoQogkiASAIaiIGQQA2AgggBkIANwIAIAwgD0cEQCAMIA9rIghBDG1B1qrVqgFPDQMgBiAIEKIJIgw2AgAgBiAIIAxqIhE2AgggCARAIAwgDyAI/AoAAAsgBiARNgIECyABIApqIQwgBiAO/QACAP0LAgwgBiAOKAIQNgIcIAZBIGohCiAGIA1BBXRrIQEgByAJRwRAIAchBiABIQgDQCAIIAYoAgA2AgAgCCAGKAIENgIEIAggBigCCDYCCCAGQQA2AgggBkIANwIAIAggBigCHDYCHCAIIAb9AAIM/QsCDCAIQSBqIQggBkEgaiIGIAlHDQALA0AgBygCACIGBEAgByAGNgIEIAYQKwsgB0EgaiIHIAlHDQALIAAoAkwhBwsgACAMNgJUIAAgCjYCUCAAIAE2AkwgB0UNACAHECsLIAAgCjYCUCAAKAJcQQF0QQEgACgCWCIHdEsEQCAQEPkJIBAoAgAhBwsgAkIgiCACfCIDQv////8PgyICIAetIgSIQgN+IAJ8IAIgB0EBdK0iBYhCB358IgIgBIhCA34gAnwgAiAFiEIHfnynQQF0QQFyIQggAqchBkF/IAd0QX9zIQkgACgCYCEKA0AgBiAJcSEHIAYgCGohBiAKIAdBA3RqIgcoAgRBf0cNAAsgByANNgIEIAcgAz4CACAAIAAoAlxBAWo2AlwLIAtBIGokACANDwsQoAkACxCgCQALEKAJAAuNCQEIfyMAQSBrIgIkACABIAEoAgQiA0EBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQoCAgICAgMAANwMYIAJBfzYCFCACIAM2AhAgASACEMsJIQQgAigCACIDBEAgAiADNgIEIAMQKwsgACAENgIAIAEgASgCBCIDQQFqNgIEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAJCgICAgICAwAA3AxggAkF/NgIUIAIgAzYCECABIAIQywkhBCACKAIAIgMEQCACIAM2AgQgAxArCyAAIAQ2AgQgASABKAIEIgNBAWo2AgQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAkKAgICAgIDAADcDGCACQX82AhQgAiADNgIQIAEgAhDLCSEEIAIoAgAiAwRAIAIgAzYCBCADECsLIAAgBDYCKCABIAEoAgQiA0EBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQoCAgICAgMAANwMYIAJBfzYCFCACIAM2AhAgASACEMsJIQQgAigCACIDBEAgAiADNgIEIAMQKwsgACAENgIsIAEgASgCBCIDQQFqNgIEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAJCgICAgICAwAA3AxggAkF/NgIUIAIgAzYCECABIAIQywkhBCACKAIAIgMEQCACIAM2AgQgAxArCyAAIAQ2AjAgAEEIaiEGQQAhAwNAIAEgASgCBCIEQQFqNgIEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAJCgICAgICAwAA3AxggAkF/NgIUIAIgBDYCECABIAIQywkhBSACKAIAIgQEQCACIAQ2AgQgBBArCyAGIANBAnRqIAU2AgAgA0EBaiIDQQhHDQALIABBrBhqIQcgAEGwEGohCCAAQbQIaiEJIABBNGohAEEAIQMDQCABIAEoAgQiBEEBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQoCAgICAgMAANwMYIAJBfzYCFCACIAQ2AhAgASACEMsJIQUgAigCACIEBEAgAiAENgIEIAQQKwsgACADQQJ0IgRqIAU2AgAgA0H/AUcEQCABIAEoAgQiBUEBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQoCAgICAgMAANwMYIAJBfzYCFCACIAU2AhAgASACEMsJIQYgAigCACIFBEAgAiAFNgIEIAUQKwsgBCAJaiAGNgIAIAEgASgCBCIFQQFqNgIEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAJCgICAgICAwAA3AxggAkF/NgIUIAIgBTYCECABIAIQywkhBiACKAIAIgUEQCACIAU2AgQgBRArCyAEIAhqIAY2AgAgASABKAIEIgVBAWo2AgQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAkKAgICAgIDAADcDGCACQX82AhQgAiAFNgIQIAEgAhDLCSEGIAIoAgAiBQRAIAIgBTYCBCAFECsLIAQgB2ogBjYCACADQQFqIQMMAQsLIAJBIGokAAvfAwEEfyMAQaAEayICJAADQCABIAEoAgQiA0EBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDgAQgAkKAgICAgIDAADcDmAQgAkF/NgKUBCACIAM2ApAEIAEgAkGABGoQywkhBSACKAKABCIDBEAgAiADNgKEBCADECsLIAIgBEECdGogBTYCACAEQQFqIgRBwABHDQALIAAgAkGAAvwKAABBACEEA0AgASABKAIEIgNBAWo2AgQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LA4AEIAJCgICAgICAwAA3A5gEIAJBfzYClAQgAiADNgKQBCABIAJBgARqEMsJIQUgAigCgAQiAwRAIAIgAzYChAQgAxArCyACIARBAnRqIAU2AgAgBEEBaiIEQcAARw0ACyAAQYACaiACQYAC/AoAAEEAIQQDQCABIAEoAgQiA0EBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDgAQgAkKAgICAgIDAADcDmAQgAkF/NgKUBCACIAM2ApAEIAEgAkGABGoQywkhBSACKAKABCIDBEAgAiADNgKEBCADECsLIAIgBEECdGogBTYCACAEQQFqIgRBgAFHDQALIABBgARqIAJBgAT8CgAAIAJBoARqJAALngICAX8BeyMAQZABayIEJAAgBCABQYgBQegAIAMbaiID/QADEP0LA1AgBCAD/QADAP0LA0AgBCAB/QADeP0LAzAgBCAB/QADaP0LAyAgBCAB/QADmAH9CwMQIAQgAf0AA4gB/QsDACACIAQQygkhASAE/QwAAAAAAAAAAAAAAAAAAAAA/QsDYCAEQgA3A3ggBEJ/NwNwIAEEQCAEQgA3AogBIAQgATYChAEgBEHgAGogBEGEAWoQ5wkLIAIgBEHgAGoQywkhAiAEKAJgIgEEQCAEIAE2AmQgARArCyAAIAT9AANA/QsDACAAIAT9AANQ/QsDECAAIAT9AAMg/QsDICAE/QADMCEFIAAgAjYCQCAAIAX9CwMwIARBkAFqJAAL6wUDE34HfwJ7IwBB4ABrIhckACACQZgBaiIZKQMAIQ0gAikDoAEhDiACKQOQASEPIAIpA4gBIRAgFyAZ/QADAP0LAzAgFyAC/QADiAH9CwMgQQEhGgNAQQMhFkEEIRsDQCABIBYiGUEFdCIcaiIWKQMYIgogASAZIBprQQV0aiIYKQMYfSIHIBYpAxAiAyAYKQMQfSIGIANWIAYgFikDCCIDIBgpAwh9IgQgA1YgBCAWKQMAIgUgGCkDAH0iAyAFVq19IgUgBFZyrX0iBCAGVnKtfSIGIAQgAikDECILfCIJIARUIAkgBSACKQMIIhJ8IgggBVQgCCADIAIpAwAiE3wiFCADVK18IhUgCFRyrXwiCCAJVHKtIAYgAikDGCIMfHwgESAHIApWIAYgB1ZyrVEiFhshByAEIAggFhshBCAFIBUgFhshBQJAAkAgAyAUIBYbIgMgEFINACAFIA9SDQAgBCANUg0AIAcgDlENAQsgF0EgaiACIAP9EiAF/R4BIAT9EiAH/R4BEMQJIAMhECAFIQ8gBCENIAchDgsgFyAAIBxqIhYpAxgiCiAbQQV0IABqQUBqIhgpAxh9IgcgFkEQaiIbKQMAIgMgGCkDEH0iBiADViAGIBYpAwgiAyAYKQMIfSIEIANWIAQgFikDACIFIBgpAwB9IgMgBVatfSIFIARWcq19IgQgBlZyrX0iBiAGIAx8IAQgC3wiCSAEVCAJIAUgEnwiCCAFVCAIIAMgE3wiDCADVK18IgsgCFRyrXwiCCAJVHKtfCARIAcgClYgBiAHVnKtUSIYGzcDWCAXQdAAaiIcIAQgCCAYGzcDACAXIAUgCyAYGzcDSCAXIAMgDCAYGzcDQCACIBdBQGsgF0EgahCkCSAXIBz9AAMAIh39CwMQIBcgF/0AA0AiHv0LAwAgGyAd/QsDACAWIB79CwMAIBlBAWshFiAZIRsgGSAaSw0ACyAaQQFqIhpBBEcNAAsgF0HgAGokAAv5AgIJfwp+IwBBIGsiBCQAIARBCGohCCAEQRhqIQlBAyEDQQQhBgNAIAYhByADIQYgB0EDTQRAIAEgA0EFdGohCgNAIAAgB0EFdGoiBUEgayIDKQMYIRIgAykDECEMIAMpAwAhDSADKQMIIQ4gBEEQaiILIAX9AAMQ/QsDACAEIAX9AAMA/QsDACACIAQgChCkCSADIBIgCSkDAH0iEyAMIAspAwB9Ig8gDFYgDyAOIAgpAwB9IhAgDlYgECANIAQpAwB9IgwgDVatfSINIBBWcq19Ig4gD1ZyrX0iDyAOIAIpAxB8IhAgDlQgECANIAIpAwh8IhEgDVQgESAMIAIpAwB8IhQgDFStfCIVIBFUcq18IhEgEFRyrSAPIAIpAxh8fCASIBNUIA8gE1ZyrVAiBRs3AxggAyAOIBEgBRs3AxAgAyANIBUgBRs3AwggAyAMIBQgBRs3AwAgB0EBaiIHQQRHDQALCyAGQQFrIQMgBg0ACyAEQSBqJAAL9iUCIX8CeyMAQYClAmsiBSQAIAUgAzYCrKQCIAUgACgCACIDKAIAIgb9AAN4/QsDoAEgBSAG/QADaP0LA5ABIAMoAgQoAgAiBiAFQZABahDKCSEDIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOQkQEgBUIANwOokQEgBUJ/NwOgkQEgAwRAIAVCADcCtKQCIAUgAzYCsKQCIAVBkJEBaiAFQbCkAmoQ5wkLIAYgBUGQkQFqEMsJIQsgBSgCkJEBIgMEQCAFIAM2ApSRASADECsLIAUgACgCACIDKAIAIgb9AAOYAf0LA6ABIAUgBv0AA4gB/QsDkAEgAygCBCgCACIGIAVBkAFqEMoJIQMgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA5CRASAFQgA3A6iRASAFQn83A6CRASADBEAgBUIANwK0pAIgBSADNgKwpAIgBUGQkQFqIAVBsKQCahDnCQsgBiAFQZCRAWoQywkhAyAFKAKQkQEiBgRAIAUgBjYClJEBIAYQKwsgBSADNgKopAIgACgCACgCBCgCACIMIAAoAgRByABqEMoJIQYgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA5CRASAFQgA3A6iRASAFQn83A6CRASAGBEAgBUIANwKUASAFIAY2ApABIAVBkJEBaiAFQZABahDnCQsgDCAFQZCRAWoQywkhBiAFKAKQkQEiDARAIAUgDDYClJEBIAwQKwsgACgCACgCBCgCACIJIAAoAgRB6ABqEMoJIQwgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA5CRASAFQgA3A6iRASAFQn83A6CRASAMBEAgBUIANwKUASAFIAw2ApABIAVBkJEBaiAFQZABahDnCQsgCSAFQZCRAWoQywkhDCAFKAKQkQEiCQRAIAUgCTYClJEBIAkQKwsgBSALNgKkpAIgBSADNgKgpAIgBSALNgKcpAIgACAFQZikAmogBUGUpAJqIAVBkKQCaiAGIAwgAyABIAIgAxC2CiAAIAVBgKQCaiAFQfyjAmogBUH4owJqIAQoAgAgBCgCBCADIAYgDCADELYKIAAgBUGMpAJqIAVBiKQCaiAFQYSkAmogBCgCACAEKAIEIAMgASACIAMQtgogACAFQfSjAmogBUHwowJqIAVB7KMCaiAGIAwgAyAEKAIYIAQoAhwgAxC2CiAEKAIMIQggBSgClKQCIREgBSgCmKQCIQcgBSAAKAIAIgkoAgQoAgAiCiAKKAIAQYgBaiAFKAKQpAIiCiAEKAIIELcKNgKQkQEgCSgCBCAHIAVBkJEBahC4CiEHIAkoAgQoAgAgBxC5CiAFIAAoAgAiCSgCBCgCACIHIAcoAgBBiAFqIAogCBC3CjYCkJEBIAkoAgQgESAFQZCRAWoQuAohCCAJKAIEKAIAIAgQuQogBCgCFCEIIAUoAvyjAiERIAUoAoCkAiEHIAUgACgCACIJKAIEKAIAIgogCigCAEGIAWogBSgC+KMCIgogBCgCEBC3CjYCkJEBIAkoAgQgByAFQZCRAWoQuAohByAJKAIEKAIAIAcQuQogBSAAKAIAIgkoAgQoAgAiByAHKAIAQYgBaiAKIAgQtwo2ApCRASAJKAIEIBEgBUGQkQFqELgKIQggCSgCBCgCACAIELkKIAQoAhwhCCAFKAKIpAIhESAFKAKMpAIhByAFIAAoAgAiCSgCBCgCACIKIAooAgBBiAFqIAUoAoSkAiIKIAQoAhgQtwo2ApCRASAJKAIEIAcgBUGQkQFqELgKIQcgCSgCBCgCACAHELkKIAUgACgCACIJKAIEKAIAIgcgBygCAEGIAWogCiAIELcKNgKQkQEgCSgCBCARIAVBkJEBahC4CiEIIAkoAgQoAgAgCBC5CiAEKAIkIQggBSgC8KMCIREgBSgC9KMCIQcgBSAAKAIAIgkoAgQoAgAiCiAKKAIAQYgBaiAFKALsowIiCiAEKAIgELcKNgKQkQEgCSgCBCAHIAVBkJEBahC4CiEHIAkoAgQoAgAgBxC5CiAFIAAoAgAiCSgCBCgCACIHIAcoAgBBiAFqIAogCBC3CjYCkJEBIAkoAgQgESAFQZCRAWoQuAohCCAJKAIEKAIAIAgQuQogBSABNgLIowIgBSAGNgLEowIgBSALNgLAowIgBSAEKAIINgLMowIgBSAEKAIANgLQowIgBSAEKAIQNgLUowIgBSAEKAIYNgLYowIgBSAEKAIgNgLcowIgBSACNgKoowIgBSAMNgKkowIgBSADNgKgowIgBSAEKAIMNgKsowIgBSAEKAIENgKwowIgBSAEKAIUNgK0owIgBSAEKAIcNgK4owIgBSAEKAIkNgK8owIgBSADNgKcowIgBSADNgKYowIgBSADNgKUowIgBSADNgKQowIgBSADNgKMowIgBSADNgKIowIgBSADNgKEowIgBSALNgKAowIgBSADNgL8ogIgBSALNgL4ogIgBSADNgL0ogIgBSALNgLwogIgBSADNgLsogIgBSALNgLoogIgBSADNgLkogIgBSALNgLgogIgBSADNgLcogIgBSADNgLYogIgBSALNgLUogIgBSALNgLQogIgBSADNgLMogIgBSADNgLIogIgBSALNgLEogIgBSALNgLAogIgBSADNgK8ogIgBSADNgK4ogIgBSADNgK0ogIgBSADNgKwogIgBSALNgKsogIgBSALNgKoogIgBSALNgKkogIgBSALNgKgogIgBSADNgKcogIgBSADNgKYogIgBSADNgKUogIgBSADNgKQogIgBSADNgKMogIgBSADNgKIogIgBSADNgKEogIgBSADNgKAogIgBEGsGGohHiAEQbAQaiEfIARBtAhqISAgAEEIaiEhIARBNGohIiAFQfChAmogACgCACAFQcCjAmoQugohFSAFQeChAmogACgCACAFQaCjAmoQugohFiAFQdChAmogACgCACAFQYCjAmoQugohFyAFQcChAmogACgCACAFQeCiAmoQugohGCAFQbChAmogACgCACAFQcCiAmoQugohGSAFQaChAmogACgCACAFQaCiAmoQugohGiAFQZChAmogACgCACAFQYCiAmoQugohGyAFQdCkAmohCUEAIQwgCyEUIAshHANAIBUoAgAgFSgCBCAiIAxBAnQiEWoiAxC7CiEjIBYoAgAgFigCBCADELsKISQgFygCACAXKAIEIAMQuwohJSAYKAIAIBgoAgQgAxC7CiENIBkoAgAgGSgCBCADELsKIQcgGigCACAaKAIEIAMQuwohCiAAKAIAKAIEKAIAIgggIRDKCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOwpAIgBUIANwPIpAIgBUJ/NwPApAIgBgRAIAVCADcCTCAFIAY2AkggBUGwpAJqIAVByABqEOcJCyAIIAVBsKQCahDLCSEGIAUoArCkAiIIBEAgBSAINgK0pAIgCBArCyAAKAIAIggoAgQoAgAiDiAOKAIAQYgBaiAGIAsQtwohCyAIKAIEKAIAIA0gCxC8CiELIAAoAgAiCCgCBCgCACINIA0oAgBBiAFqIAYgFBC3CiEUIAgoAgQoAgAgByAUELwKIRQgACgCACIIKAIEKAIAIg0gDSgCAEGIAWogBiAcELcKIQYgCCgCBCgCACAKIAYQvAohHCAJIAAoAgQoAgAiBv0AA4gB/QsDACAJQRBqIg0gBkGYAWoiDv0AAwD9CwMAIAVBwKQCaiIPIAZB+ABqIhD9AAMAIib9CwMAIAUgBv0AA2giJ/0LA7CkAkH/ASAMa0HIAGwiEyAFQZCRAWpqIgggBUHgpAJqIhL9AAMA/QsDMCAIIAn9AAMA/QsDICAIICb9CwMQIAggBzYCQCAIICf9CwMAIA0gDv0AAwD9CwMAIAkgBv0AA4gB/QsDACAPIBD9AAMAIib9CwMAIAUgBv0AA2giJ/0LA7CkAiAFQZABaiATaiIGIBL9AAMA/QsDMCAGIAn9AAMA/QsDICAGICb9CwMQIAYgCjYCQCAGICf9CwMAIBsoAgAgGygCBCADELsKIQMgACgCACIGKAIEIAMgBUGopAJqELgKIQMgBigCBCgCACADELkKIAUoApykAiEDIAUoAqCkAiEIIAUoAqSkAiEGAkAgDEUEQCAIIQcMAQsgBSAAKAIAKAIEKAIAIgcgBygCAEGIAWogBiAGELcKIgc2AgAgACgCACgCBCgCACIKIAooAgBBiAFqIAggCBC3CiEKIAUgACgCACgCBCgCACINIA0oAgBBiAFqIAMgAxC3CiINNgL8pAIgACgCACgCBCgCACIOIA4oAgBBiAFqIAYgCBC3CiEOIAAoAgAoAgQoAgAgDiAOELwKIRMgACgCACgCBCgCACIOIA4oAgBBiAFqIAYgAxC3CiEGIAAoAgAoAgQoAgAgBiAGELwKIQ4gACgCACgCBCgCACIPIAAoAgRBCGoQygkhBiAF/QwAAAAAAAAAAAAAAAAAAAAA/QsDsKQCIAVCADcDyKQCIAVCfzcDwKQCIAYEQCAFQgA3AkwgBSAGNgJIIAVBsKQCaiAFQcgAahDnCQsgDyAFQbCkAmoQywkhBiAFKAKwpAIiDwRAIAUgDzYCtKQCIA8QKwsgACgCACgCBCgCACIQIAAoAgRBiAJqEMoJIQ8gBf0MAAAAAAAAAAAAAAAAAAAAAP0LA7CkAiAFQgA3A8ikAiAFQn83A8CkAiAPBEAgBUIANwJMIAUgDzYCSCAFQbCkAmogBUHIAGoQ5wkLIBAgBUGwpAJqEMsJIQ8gBSgCsKQCIhAEQCAFIBA2ArSkAiAQECsLIAAoAgAoAgQoAgAiECAQKAIAQYgBaiAGIA4QtwohECAAKAIAKAIEKAIAIhIgEigCAEGIAWogDyANELcKIRIgBSAAKAIAKAIEKAIAIBAgEhC8CiISNgKwpAIgACgCACgCBCAKIAVBsKQCahC4CiEQIAAoAgAoAgQoAgAgCiASELwKIRIgACgCACgCBCgCACIdIB0oAgBBiAFqIBAgEhC3CiESIAAoAgAoAgQoAgAiHSAdKAIAQYgBaiATIBAQtwohECAAKAIAKAIEKAIAIhMgEygCAEGIAWogDyAOELcKIQ4gBSAAKAIAKAIEKAIAIg8gDygCAEGIAWogBiANELcKIg02AvykAiAAKAIAKAIEIAcgBUH8pAJqELgKIQ8gACgCACgCBCgCACITIBMoAgBBiAFqIAYgDxC3CiEGIAAoAgAoAgQoAgAgBiAOELwKIQYgACgCACgCBCgCACAHIAcQvAohDiAAKAIAKAIEKAIAIA4gBxC8CiEHIAAoAgAoAgQoAgAgByANELwKIQcgACgCACgCBCgCACINIA0oAgBBiAFqIAcgBhC3CiEHIAAoAgAoAgQoAgAgEiAHELwKIQcgACgCACgCBCgCACINIA0oAgBBiAFqIAggAxC3CiEDIAAoAgAoAgQoAgAgAyADELwKIQMgBSAAKAIAKAIEKAIAIgggCCgCAEGIAWogAyAGELcKNgIAIAAoAgAoAgQgECAFELgKIQYgACgCACgCBCgCACIIIAgoAgBBiAFqIAMgChC3CiEDIAAoAgAoAgQoAgAgAyADELwKIQMgACgCACgCBCgCACADIAMQvAohAyAFIAc2AqCkAiAFIAY2AqSkAiAFIAM2ApykAgsgACAFQaSkAmogBUGgpAJqIAVBnKQCaiAGIAcgAyAjICQgJRC2CiAAKAIAIQMgBSgCpKQCIQYgDEH/AUcEQCADKAIEIAYgESAgaiIIELgKIQYgAygCBCgCACAGELkKIAAoAgAiAygCBCAFKAKgpAIgESAfaiIGELgKIQcgAygCBCgCACAHELkKIAAoAgAiAygCBCAFKAKcpAIgESAeaiIRELgKIQcgAygCBCgCACAHELkKIAUgCCgCADYCpKQCIAUgBigCADYCoKQCIAUgESgCADYCnKQCIAxBAWohDAwBCwsgAygCBCgCACAGELkKIAAoAgAoAgQoAgAgBSgCnKQCELkKIAAoAgAiAygCBCALIAVBrKQCahC4CiEGIAMoAgQoAgAgBhC5CiAAKAIAIgMoAgQgFCAEELgKIQYgAygCBCgCACAGELkKIAAgASACEL0KIAAgBCgCACAEKAIEEL0KIAAgBCgCACAEKAIoEL4KIAAgHCAEKAIsEL4KIAAgASAEKAIwEL4KIAAoAgBBAEGAAiAFQbCkAmogBUHIAGogBUGQkQFqIABByABqIgMQvwogACgCAEEAQYACIAVBsKQCaiAFIAVBkAFqIAMQvwogACgCACAFQcgAahDACiAAKAIAIAUQwAogGygCBCIABEAgABArCyAaKAIEIgAEQCAAECsLIBkoAgQiAARAIAAQKwsgGCgCBCIABEAgABArCyAXKAIEIgAEQCAAECsLIBYoAgQiAARAIAAQKwsgFSgCBCIABEAgABArCyAFQYClAmokAAvLBwICfwx+IwBBsKECayIFJAAgBSACNgLUoAIgBEGABGohBEEAIQIDQCAFQdAAaiAAIAQgAkECdGoQwQogBUHQkAFqIAJBkAFsaiAFQdAAakGQAfwKAAAgAkEBaiICQYABRw0AC0EAIQIgASAFQdCQAWpBgMgA/AoAACABQYDIAGogBUHQ2AFqQYDIAPwKAAADQCAFQdigAmogACgCECIEKAIAIAQoAgQoAgAgAyACQQN2Qfj///8BcWopAwAgAkE/ca2Ip0EBcRDOCSAFQdAAaiACQcgAbGogBUHYoAJqQcgA/AoAACACQQFqIgJBgAJHDQALIAAoAhAiAkEAQYACIAVB2KACaiAFQQhqIAVB0JABaiAFQdAAahC/CiACIAVBCGoQwAogBSAAKAIQIgIoAgAiBP0AA3j9CwMYIAUgBP0AA2j9CwMIIAIoAgQoAgAiBCAFQQhqEMoJIQIgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA9igAiAFQgA3A/CgAiAFQn83A+igAiACBEAgBUIANwKooQIgBSACNgKkoQIgBUHYoAJqIAVBpKECahDnCQsgBCAFQdigAmoQywkhASAFKALYoAIiAgRAIAUgAjYC3KACIAIQKwsgBUHooAJqIAAoAhAiBCgCACIC/QADmAH9CwMAIAUgAv0AA4gB/QsD2KACQQAhAwNAIAQgBUHQkAFqIANByABsahDCCiEGAkACQCAFKQPYoAIiCCAEKAIEKAIAIgIoAgAiBCkDaFINACAFKQPgoAIiCSAEKQNwUg0AIAUpA+igAiIHIAQpA3hSDQAgBSkD8KACIg0gBCkDgAFRDQELIAIgASACIAVB2KACakEAIAYQtwoQvAohASAFKQPwoAIhDSAFKQPooAIhByAFKQPgoAIhCSAFKQPYoAIhCAsgBSAAKAIQIgQoAgAiAikDOCIRIA0gDXwiDyAHIAd8IgsgB1QgCyAJIAl8IgcgCVQgByAIIAh8IgkgCFStfCIIIAdUcq18IgcgC1RyrXwiC3wiECACKQMwIgogB3wiDiAKVCAOIAIpAygiDCAIfCIKIAxUIAogAikDICIMIAl8IhIgDFStfCIMIApUcq18IgogDlRyrXwiDiALIAsgD1QgDSAPVnIgECARVCAOIBBUcnMiAhs3A/CgAiAFIAogByACGzcD6KACIAUgDCAIIAIbNwPgoAIgBSASIAkgAhs3A9igAiADQQFqIgNBgAJHDQALIAQoAgQgASAFQdSgAmoQuAohAiAEKAIEKAIAIAIQuQogBUGwoQJqJAALoAUBBH8jAEHQ+ANrIgUkAANAIAVBiKACaiAAIAQgBkECdGoQwQogBUGI6AJqIAZBkAFsaiAFQYigAmpBkAH8CgAAIAZBAWoiBkHAAEcNAAsgACgCECEIQQAhBgNAIAVBiPgDaiAIIAIgBkHIAGwiB2ogBUGI6AJqIAdqEMMKIAVBiKACaiAHaiAFQYj4A2pByAD8CgAAIAZBAWoiBkGAAUcNAAsgACgCECEGQQAhByAFQYjYAWogBUGIoAJqQYDIAPwKAAAgB0UEQCAFQYiQAWogA0GAyAD8CgAACyAGIAVBiLADaiAFQYjYAWogBUGIkAFqEMQKIAAoAhAhBgNAIAVBiPgDaiAGIAEgB0HIAGwiCGogBUGIsANqIAhqEMMKIAYgBUGI+ANqEMIKIQggBigCBCgCACAIELkKIAdBAWoiB0GAAUcNAAsgBEGAAmohB0EAIQYDQCAFQYigAmogACAHIAZBAnRqEMEKIAVBiOgCaiAGQZABbGogBUGIoAJqQZAB/AoAACAGQQFqIgZBwABHDQALIAAoAhAhCEEAIQYDQCAFQYj4A2ogCCACIAZByABsIgdqIAVBiOgCaiAHahDDCiAFQYigAmogB2ogBUGI+ANqQcgA/AoAACAGQQFqIgZBgAFHDQALIAAoAhAhBkEAIQcgBUGIyABqIAVBiKACakGAyAD8CgAAIAdFBEAgBUEIaiADQYDIAGpBgMgA/AoAAAsgBiAFQYiwA2ogBUGIyABqIAVBCGoQxAogAUGAyABqIQIgACgCECEGA0AgBUGI+ANqIAYgAiAHQcgAbCIAaiAFQYiwA2ogAGoQwwogBiAFQYj4A2oQwgohACAGKAIEKAIAIAAQuQogB0EBaiIHQYABRw0ACyAFQdD4A2okAAvoAQEGfyAAKAIEIgIgACgCCCIDSQRAIAIgATYCACAAIAJBBGo2AgQPCwJAIAIgACgCACIEayICQQJ1IgdBAWoiBUGAgICABEkEQEH/////AyADIARrIgNBAXUiBiAFIAUgBkkbIANB/P///wdPGyIDBH8gA0GAgICABE8NAiADQQJ0EKIJBUEACyIFIAJqIgYgATYCACAGIAdBAnRrIQEgAgRAIAEgBCAC/AoAAAsgACAFIANBAnRqNgIIIAAgBkEEaiICNgIEIAAgATYCACAEBEAgBBArCyAAIAI2AgQPCxCgCQALEKAJAAueAgEFfyAAKAIEIgIgACgCCCIDSQRAIAIgAf0AAwD9CwMAIAIgASkDIDcDICACIAH9AAMQ/QsDECAAIAJBKGo2AgQPCwJAIAIgACgCACIEayIFQShtQQFqIgJB58yZM0kEQEHmzJkzIAMgBGtBKG0iA0EBdCIGIAIgAiAGSRsgA0Gz5swZTxsiAwR/IANB58yZM08NAiADQShsEKIJBUEACyIGIAVqIgIgAf0AAwD9CwMAIAIgASkDIDcDICACIAH9AAMQ/QsDECACIAVBWG1BKGxqIQEgBQRAIAEgBCAF/AoAAAsgACAGIANBKGxqNgIIIAAgAkEoaiICNgIEIAAgATYCACAEBEAgBBArCyAAIAI2AgQPCxCgCQALEKAJAAuCAwEGfwJAIAAoAgQiByAAKAIAIgNrIgVBFG1BAWoiAkHNmbPmAEkEQEHMmbPmACAAKAIIIANrQRRtIgRBAXQiBiACIAIgBkkbIARB5syZM08bIgJBzZmz5gBPDQEgAkEUbCIEEKIJIgYgBWoiAiABKAIANgIAIAIgAS0ABDoABCACIAEoAgg2AgggAiABKAIMNgIMIAIgASgCEDYCECABQQA2AhAgAUIANwIIIAQgBmohBiACIAVBbG1BFGxqIQQgAkEUaiEFIAMgB0cEQCADIQEgBCECA0AgAiABKAIANgIAIAIgAS0ABDoABCACIAEoAgg2AgggAiABKAIMNgIMIAIgASgCEDYCECABQQA2AhAgAUIANwIIIAJBFGohAiABQRRqIgEgB0cNAAsDQCADKAIIIgEEQCADIAE2AgwgARArCyADQRRqIgMgB0cNAAsgACgCACEDCyAAIAY2AgggACAFNgIEIAAgBDYCACADBEAgAxArCyAFDwsQoAkACxCgCQALkC0CEn8CeyMAQTBrIgskAANAIAFBGGshEyABQQRrIRQgAUEIayESIAFB+ABrIREgAUHQAGshFSABQShrIQwgACEGAkADQAJAAkACQAJAAkACQAJAAkAgASAGayIAQShtIggOBgkJAAQBAgMLAkAgEigCACIFIAYoAiAiAEkNACAAIAVJDQkgFCgCACIFIAYoAiQiAEkNACAAIAVJDQkgDP0AAwAgE/0AAwAgBv0AAwAgBv0AAxAgAigCACgCABCpCkUNCQsgC0EoaiIFIAZBIGoiACkDADcDACALQRhqIgggBkEQaiIH/QADAP0LAwAgCyAG/QADAP0LAwggACAMQSBqIgkpAwA3AwAgBiAMQRhqIgApAwA3AxggByAMQRBqIgopAwA3AwAgBiAMQQhqIgcpAwA3AwggBiAMKQMANwMAIAkgBSkDADcDACAAIAspAyA3AwAgCiAIKQMANwMAIAcgCykDEDcDACAMIAspAwg3AwAMCAsgBiAGQShqIgAgBkHQAGoiBSACELMKAkAgEigCACIIIAYoAnAiB0kNACAHIAhJDQggFCgCACIIIAYoAnQiB0kNACAHIAhJDQggDP0AAwAgE/0AAwAgBv0AA1AgBv0AA2AgAigCACgCABCpCkUNCAsgC0EoaiIIIAVBIGoiBykDADcDACALQRhqIgkgBUEQaiIK/QADAP0LAwAgCyAF/QADAP0LAwggByAMQSBqIg4pAwA3AwAgBUEYaiIPIAxBGGoiECkDADcDACAKIAxBEGoiASkDADcDACAFQQhqIg0gDEEIaiIDKQMANwMAIAUgDCkDADcDACAOIAgpAwA3AwAgECALQSBqIg4pAwA3AwAgASAJKQMANwMAIAMgC0EQaiIQKQMANwMAIAwgCykDCDcDAAJAIAYoAnAiASAGKAJIIgxJDQAgASAMSw0IIAYoAnQiASAGKAJMIgxJDQAgASAMSw0IIAb9AANQIAb9AANgIAb9AAMoIAb9AAM4IAIoAgAoAgAQqQpFDQgLIAggAEEgaiIBKQMANwMAIAkgAEEQaiIM/QADAP0LAwAgCyAA/QADAP0LAwggASAHKQMANwMAIAAgDykDADcDGCAMIAopAwA3AwAgACANKQMANwMIIAAgBSkDADcDACAHIAgpAwA3AwAgDyAOKQMANwMAIAogCSkDADcDACANIBApAwA3AwAgBSALKQMINwMAAkAgBigCSCIFIAYoAiAiCEkNACAFIAhLDQggBigCTCIFIAYoAiQiCEkNACAFIAhLDQggBv0AAyggBv0AAzggBv0AAwAgBv0AAxAgAigCACgCABCpCkUNCAsgC0EoaiIFIAZBIGoiCCkDADcDACALQRhqIgcgBkEQaiIJ/QADAP0LAwAgCyAG/QADAP0LAwggCCAAQSBqIgopAwA3AwAgBiAAQRhqIggpAwA3AxggCSAAQRBqIg8pAwA3AwAgBiAAQQhqIgkpAwA3AwggBiAAKQMANwMAIAogBSkDADcDACAIIAspAyA3AwAgDyAHKQMANwMAIAkgCykDEDcDACAAIAspAwg3AwAMBwsgBiAGQShqIAZB0ABqIAZB+ABqIAwgAhC0CgwGCyAAQb8HTARAIAEgBkYgBkEoaiIAIAFGciEFIARBAXEEQCAFDQcgBiEKA0AgCiEFIAAhCgJAAkAgBSgCSCIAIAUoAiAiCEkNACAAIAhLDQEgBSgCTCIAIAUoAiQiCEkNACAAIAhLDQEgCv0AAwAgCv0AAxAgBf0AAwAgBf0AAxAgAigCACgCABCpCkUNAQsgBf0AAyghFyAKIAX9AAMA/QsDACAKQRBqIgD9AAMAIRggACAF/QADEP0LAwAgCkEgaiIAKAIAIQggCigCJCEJIAAgBSkDIDcDACAGIQACQCAFIAZGDQADQCAFIgBBKGshBQJAIAggAEEIaygCACIHSQ0AIAcgCEkNAiAJIABBBGsoAgAiB0kNACAHIAlJDQIgFyAYIAX9AAMAIABBGGv9AAMAIAIoAgAoAgAQqQpFDQILIAAgBf0AAwD9CwMAIAAgBSkDIDcDICAAIAX9AAMQ/QsDECAFIAZHDQALIAYhAAsgACAJNgIkIAAgCDYCICAAIBj9CwMQIAAgF/0LAwALIApBKGoiACABRw0ACwwHCyAFDQYDQCAGIQggACEGAkACQCAIKAJIIgUgCCgCICIASQ0AIAAgBUkNASAIKAJMIgUgCCgCJCIASQ0AIAAgBUkNASAG/QADACAG/QADECAI/QADACAI/QADECACKAIAKAIAEKkKRQ0BCyAGKAIkIQogBigCICEHIAb9AAMQIRcgBv0AAwAhGCAGIQADQCAAIAgiBf0AAwD9CwMAIAAgBSkDIDcDICAAIAX9AAMQ/QsDECAFQShrIQggBSEAIAcgBUEIaygCACIJSQ0AAkAgByAJSw0AIAogBUEEaygCACIJSQ0BIAkgCkkNACAYIBcgCP0AAwAgBUEYa/0AAwAgAigCACgCABCpCg0BCwsgBSAKNgIkIAUgBzYCICAFIBf9CwMQIAUgGP0LAwALIAZBKGoiACABRw0ACwwGCyADRQRAIAEgBkYNBiAIQQJrQQF2Ig0hBQNAAkAgDSAFIgpIDQAgBiAFQShsaiEJIAYgBUEBdCIHQQFyIg9BKGxqIQUgAigCACgCACEMAkAgCCAHQQJqIgdMBEAgDyEHDAELAkAgBSgCICIOIAUoAkgiEEkNACAOIBBLBEAgDyEHDAILIAUoAiQiDiAFKAJMIhBJDQAgDiAQSwRAIA8hBwwCCyAF/QADACAF/QADECAF/QADKCAF/QADOCAMEKkKDQAgDyEHDAELIAVBKGohBQsgBSgCICIOIAkoAiAiD0kNAAJAIA4gD0sEQCAJKAIkIRAgCf0AAwAhFwwBCyAFKAIkIg4gCSgCJCIQSQ0BIAn9AAMAIRcgDiAQSw0AIAX9AAMAIAX9AAMQIBcgCf0AAxAgDBCpCg0BCyAJIAX9AAMA/QsDACAJIAUpAyA3AyAgCUEQaiIJ/QADACEYIAkgBf0AAxD9CwMAAkAgByANSg0AA0AgBSEJIAYgB0EBdCIHQQFyIg5BKGxqIQUgAigCACgCACEMAkAgCCAHQQJqIgdMBEAgDiEHDAELAkAgBSgCICIDIAUoAkgiBEkNACADIARLBEAgDiEHDAILIAUoAiQiAyAFKAJMIgRJDQAgAyAESwRAIA4hBwwCCyAF/QADACAF/QADECAF/QADKCAF/QADOCAMEKkKDQAgDiEHDAELIAVBKGohBQsgDyAFKAIgIg5LBEAgCSEFDAILAkAgDiAPSw0AIBAgBSgCJCIOSwRAIAkhBQwDCyAOIBBLDQAgBf0AAwAgBf0AAxAgFyAYIAwQqQpFDQAgCSEFDAILIAkgBf0AAwD9CwMAIAkgBSkDIDcDICAJIAX9AAMQ/QsDECAHIA1MDQALCyAFIBA2AiQgBSAPNgIgIAUgGP0LAxAgBSAX/QsDAAsgCkEBayEFIAoNAAsgAEEobiEFA0AgC0EoaiIQIAYpAyA3AwAgC0EYaiIMIAb9AAMQ/QsDACALIAb9AAMA/QsDCCAFIg9BAmtBAXYhDUEAIQAgBiEFA0AgAEEBdCIJQQFyIQogBSIIIABBKGxqIgdBKGohBQJ/IAogDyAJQQJqIglMDQAaAkAgBygCSCIAIAcoAnAiDkkNACAKIAAgDksNARogBygCTCIAIAcoAnQiDkkNACAKIAAgDksNARogCiAH/QADKCAH/QADOCAH/QADUCAH/QADYCACKAIAKAIAEKkKRQ0BGgsgB0HQAGohBSAJCyEAIAggBf0AAwD9CwMAIAggBUEgaiIHKQMANwMgIAggBUEQaiII/QADAP0LAxAgACANTA0ACwJAIAFBKGsiASAFRgRAIAUgC/0AAwj9CwMAIAcgECkDADcDACAIIAz9AAMA/QsDAAwBCyAFIAH9AAMA/QsDACAHIAFBIGoiACkDADcDACAIIAFBEGoiB/0AAwD9CwMAIAEgCykDCDcDACABIAspAxA3AwggByAMKQMANwMAIAEgCykDIDcDGCAAIBApAwA3AwAgBSAGa0EoaiIAQSlIDQACQCAGIABBKG5BAmsiCkEBdiIHQShsaiIAKAIgIg0gBSgCICIJSQRAIAUoAiQhDQwBCyAJIA1JDQEgACgCJCIOIAUoAiQiDUkNACANIA5JDQEgAP0AAwAgAP0AAxAgBf0AAwAgCP0AAwAgAigCACgCABCpCkUNAQsgBf0AAwAhFyAFIAApAwA3AwAgCP0AAwAhGCAFIAD9AAMI/QsDCCAFIAD9AAMY/QsDGAJAIApBAkkNAANAIAAhBQJAIAYgB0EBayIIQQF2IgdBKGxqIgAoAiAiCiAJSQ0AIAkgCkkEQCAFIQAMAwsgACgCJCIKIA1JDQAgCiANSwRAIAUhAAwDCyAA/QADACAA/QADECAXIBggAigCACgCABCpCg0AIAUhAAwCCyAFIAD9AAMA/QsDACAFIAApAyA3AyAgBSAA/QADEP0LAxAgCEEBSw0ACwsgACANNgIkIAAgCTYCICAAIBj9CwMQIAAgF/0LAwALIA9BAWshBSAPQQJKDQALDAYLIAYgCEEBdkEobGohBQJAIABBgShPBEAgBiAFIAwgAhCzCiAGQShqIAVBKGsiACAVIAIQswogBkHQAGogBUEoaiIIIBEgAhCzCiAAIAUgCCACELMKIAtBKGoiACAGQSBqIggpAwA3AwAgC0EYaiIHIAZBEGoiCf0AAwD9CwMAIAsgBv0AAwD9CwMIIAggBUEgaiIKKQMANwMAIAYgBUEYaiIIKQMANwMYIAkgBUEQaiIPKQMANwMAIAYgBUEIaiIJKQMANwMIIAYgBSkDADcDACAKIAApAwA3AwAgCCALKQMgNwMAIA8gBykDADcDACAJIAspAxA3AwAgBSALKQMINwMADAELIAUgBiAMIAIQswoLIANBAWshAyAEQQFxIhYEQCAGKAIgIQggAigCACgCACENDAQLIAIoAgAoAgAhDSAGQQhrKAIAIgUgBigCICIISQ0DAkAgBSAISwRAIAYoAiQhCSAG/QADACEXDAELIAZBBGsoAgAiBSAGKAIkIglJDQQgBv0AAwAhFyAFIAlLDQAgBkEoa/0AAwAgBkEYa/0AAwAgFyAG/QADECANEKkKDQQLIAb9AAMQIRggCCASKAIAIgdJDQECQCAHIAhJDQAgCSAUKAIAIgVJDQIgBSAJSQ0AIBcgGCAM/QADACAT/QADACANEKkKDQILIAYiBUEoaiIKIAFPDQIDQCAFIQAgCiEFIAAoAkgiCiAISwRAIAUhCgwECwJAIAggCksNACAAKAJMIgAgCUsEQCAFIQoMBQsgACAJSQ0AIBcgGCAF/QADACAF/QADECANEKkKRQ0AIAUhCgwECyAFQShqIgogAUkNAAsMAgsgBiAGQShqIAwgAhCzCgwECyAGQShqIQogCCAGIgUoAkgiAEkNAANAIAUhDyAKIQUCQCAAIAhJDQAgDygCTCIAIAlLDQIgACAJSQ0AIBcgGCAF/QADACAF/QADECANEKkKRQ0ADAILIAVBKGohCiAIIAUoAkgiAE8NAAsLIAEiBSEAAkAgBSAKTQ0AA0AgBUEoayEAAkAgByAISw0AIAcgCEkNAiAJIAVBBGsoAgAiB0kNACAHIAlJDQIgFyAYIAD9AAMAIAVBGGv9AAMAIA0QqQpFDQILIAVBMGsoAgAhByAAIQUMAAsACyAAIApLBEADQCALQShqIgcgCiIFQSBqIgopAwA3AwAgC0EYaiIPIAVBEGoiDf0AAwD9CwMAIAsgBf0AAwD9CwMIIAogAEEgaiIOKQMANwMAIAUgAEEYaiIKKQMANwMYIA0gAEEQaiIQKQMANwMAIAUgAEEIaiINKQMANwMIIAUgACkDADcDACAOIAcpAwA3AwAgCiALKQMgNwMAIBAgDykDADcDACANIAspAxA3AwAgACALKQMINwMAIAVBKGohCiACKAIAKAIAIQ0CQCAIIAUoAkgiB0kNAANAIAUhDyAKIQUCQCAHIAhJDQAgDygCTCIHIAlLDQIgByAJSQ0AIBcgGCAF/QADACAF/QADECANEKkKRQ0ADAILIAVBKGohCiAIIAUoAkgiB08NAAsLA0AgACIFQShrIQAgCCAFQQhrKAIAIgdJDQACQCAHIAhJDQAgCSAFQQRrKAIAIgdJDQEgByAJSQ0AIBcgGCAA/QADACAFQRhr/QADACANEKkKDQELCyAAIApLDQALCyAKQShrIgUgBkcEQCAGIAX9AAMA/QsDACAGIAUpAyA3AyAgBiAF/QADEP0LAxALIAUgF/0LAwAgCkEEayAJNgIAIApBCGsgCDYCACAKQRhrIBj9CwMAQQAhBCAKIQYMAQsLIAYoAiQhCiAG/QADECEXIAb9AAMAIRggBiEQA0AgECIFQShqIRAgBSgCSCIAIAhJDQACQCAAIAhLDQAgBSgCTCIAIApJDQEgACAKSw0AIAX9AAMoIAX9AAM4IBggFyANEKkKDQELCwJAIAUgBkcEQCAMIREgASEAIBIoAgAiByAISQ0BA0AgACEJIBEhAAJAIAcgCEsNACAKIAlBBGsoAgAiB0sNAyAHIApLDQAgAP0AAwAgAP0AAxAgGCAXIA0QqQpFDQAMAwsgAEEoayERIABBCGsoAgAiByAITw0ACwwBCyABIREgASAQTQ0AIAwhESABIQkgEigCACIHIAhJDQADQCARIQACQAJAIAcgCEsNACAKIAlBBGsoAgAiB0sNAyAHIApLDQAgAP0AAwAgAP0AAxAgGCAXIA0QqQoEQAwECyAAIBBLDQEMAwsgACAQSw0AIAAhEQwCCyAAQShrIREgACEJIABBCGsoAgAiByAITw0ACwsgESIJIBAiAEsEQANAIAtBKGoiBSAAQSBqIg8pAwA3AwAgC0EYaiINIABBEGoiDv0AAwD9CwMAIAsgAP0AAwD9CwMIIA8gCSIHQSBqIgkpAwA3AwAgACAHQRhqIg8pAwA3AxggDiAHQRBqIgwpAwA3AwAgACAHQQhqIg4pAwA3AwggACAHKQMANwMAIAkgBSkDADcDACAPIAspAyA3AwAgDCANKQMANwMAIA4gCykDEDcDACAHIAspAwg3AwAgAigCACgCACEOA0AgACIFQShqIQAgBSgCSCIJIAhJDQACQCAIIAlJDQAgBSgCTCIJIApJDQEgCSAKSw0AIAX9AAMoIAX9AAM4IBggFyAOEKkKDQELCyAHQShrIQkCQCAHQQhrKAIAIg8gCEkNAANAIAchDSAJIQcCQCAIIA9JDQAgCiANQQRrKAIAIglLBEAgByEJDAMLIAkgCksNACAH/QADACAH/QADECAYIBcgDhCpCkUNACAHIQkMAgsgB0EoayEJIAdBCGsoAgAiDyAITw0ACwsgACAJSQ0ACwsgBSAGRwRAIAYgBf0AAwD9CwMAIAYgBSkDIDcDICAGIAX9AAMQ/QsDEAsgBSAKNgIkIAUgCDYCICAFIBf9CwMQIAUgGP0LAwAgECARTwRAIAYgBSACELUKIQggBUEoaiIAIAEgAhC1CgRAIAUhASAGIQAgCEUNAwwCCyAIDQILIAYgBSACIAMgFhDXCSAFQShqIQBBACEEDAELCyALQTBqJAAL3R8CD38CfiMAQTBrIggkAAJAA0AgAUHIAGshDiABQTBrIQ8gAUEYayELIAAhBQJAA0ACQAJAAkACQCABIAVrIg1BGG0iDA4GBwcABQECAwsgCyAFIAIoAgAoAgAQrgpFDQYgCEEQaiIAIAVBCGoiBi0AADoAACAIIAUpAgA3AwggBSgCFCEHIAVBADYCFCAFKQIMIRQgBUIANwIMIAUgCykCADcCACAGIAtBCGoiAi0AADoAACAFIAFBDGsiBigCADYCDCAFIAFBCGsoAgA2AhAgBSABQQRrIgkoAgA2AhQgAiAALQAAOgAAIAsgCCkDCDcCACAJIAc2AgAgBiAUNwIADAYLIAUgBUEYaiAFQTBqIAsgAhCvCgwFCyAFIAVBGGogBUEwaiAFQcgAaiALIAIQsAoMBAsgDUG/BEwEQCAEQQFxBEAgASAFRg0FIAVBGGoiACABRg0FIAUhBgNAIAAiByAGIAIoAgAoAgAQrgoEQCAIQRBqIgogAEEIaiIALQAAOgAAIAggBykCADcDCCAIIAYoAiQiDDYCFCAIIAYoAigiCzYCGCAIIAYoAiwiDTYCHCAGQQA2AiwgBkIANwIkIAcgBikCADcCACAAIAYtAAg6AAAgBygCDCIABEAgByAANgIQIAAQKwsgByAGKAIMNgIMIAcgBigCEDYCECAHIAYoAhQ2AhQgBkEANgIUIAZCADcCDAJAIAYgBSIARg0AIAhBCGogBiIAQRhrIgkgAigCACgCABCuCkUNAANAIAYgCSIAKQIANwIAIAYgAC0ACDoACCAGIAAoAgw2AgwgBiAAKAIQNgIQIAYgACgCFDYCFCAAQQA2AhQgAEIANwIMIAAgBUYEQCAFIQAMAgsgACEGIAhBCGogAEEYayIJIAIoAgAoAgAQrgoNAAsLIAAgCCkDCDcCACAAIAotAAA6AAggACANNgIUIAAgCzYCECAAIAw2AgwLIAciBkEYaiIAIAFHDQALDAULIAEgBUYNBCAFQRhqIgAgAUYNBANAIAAiByAFIAIoAgAoAgAQrgoEQCAIQRBqIgkgAEEIaiIALQAAOgAAIAggBykCADcDCCAIIAUoAiQiCjYCFCAIIAUoAigiDDYCGCAIIAUoAiwiCzYCHCAFQQA2AiwgBUIANwIkIAcgBSkCADcCACAAIAUtAAg6AAAgBygCDCIABEAgByAANgIQIAAQKwsgByAFKAIMNgIMIAcgBSgCEDYCECAHIAUoAhQ2AhQgBUEANgIUIAVCADcCDCAIQQhqIAVBGGsiBiACKAIAKAIAEK4KBEADQCAFIAYiACkCADcCACAFIAAtAAg6AAggBSAAKAIMNgIMIAUgACgCEDYCECAFIAAoAhQ2AhQgAEEANgIUIABCADcCDCAAIQUgCEEIaiAAQRhrIgYgAigCACgCABCuCg0ACwsgBSAIKQMINwIAIAUgCS0AADoACCAFIAs2AhQgBSAMNgIQIAUgCjYCDAsgByIFQRhqIgAgAUcNAAsMBAsgA0UEQCABIAVGDQQgDEECa0EBdiIDIQADQAJAIAMgACIOSA0AIAUgAEEYbGohBiAFIABBAXQiCkEBciIJQRhsaiEHIAIoAgAoAgAhACAMIApBAmoiCkoEQCAHQRhqIgsgByAHIAsgABCuCiIEGyEHIAogCSAEGyEJCyAHIAYgABCuCg0AIAhBEGoiECAGLQAIOgAAIAggBikCADcDCCAIIAYoAgwiETYCFCAIIAYoAhAiEjYCGCAIIAYoAhQiEzYCHCAGQQA2AhQgBkIANwIMA0ACQCAGIAciACkCADcCACAGIABBCGoiBC0AADoACCAAKQIMIRQgBiAAKAIUNgIUIAYgFDcCDCAAQQA2AhQgAEIANwIMIAMgCUgNACAFIAlBAXQiBkEBciIJQRhsaiEHIAIoAgAoAgAhCiAMIAZBAmoiBkoEQCAHQRhqIgsgByAHIAsgChCuCiIPGyEHIAYgCSAPGyEJCyAAIQYgByAIQQhqIAoQrgpFDQELCyAAIAgpAwg3AgAgBCAQLQAAOgAAIAAgEzYCFCAAIBI2AhAgACARNgIMCyAOQQFrIQAgDg0ACyANQRhuIQwDQAJAIAxBAkgNACAIQShqIgMgBS0ACDoAACAIIAUpAgA3AyAgBSgCDCEEIAUoAhAhDiAFQgA3AgwgBSgCFCEPQQAhByAFQQA2AhQgDEECa0EBdiELIAUhBgNAIAdBAXQiCUEBciEKIAYgB0EYbGoiB0EYaiEAAn8gDCAJQQJqIglMBEAgBiAAKQIANwIAIAYgAC0ACDoACCAKDAELIAYgB0EwaiIHIAAgACAHIAIoAgAoAgAQrgoiDRsiACkCADcCACAGIAAtAAg6AAggCSAKIA0bCyEHIAYgACgCDDYCDCAGIAAoAhA2AhAgBiAAKAIUNgIUIABBADYCFCAAQgA3AgwgACEGIAcgC0wNAAsgAUEYayIGIABGBEAgACAIKQMgNwIAIAAgAy0AADoACCAAIA82AhQgACAONgIQIAAgBDYCDAwBCyAAIAYpAgA3AgAgAEEIaiINIAZBCGoiBy0AADoAACAAIAFBDGsiCSgCADYCDCAAIAFBCGsiCigCADYCECAAIAFBBGsiCygCADYCFCAHIAMtAAA6AAAgBiAIKQMgNwIAIAsgDzYCACAKIA42AgAgCSAENgIAIAAgBWtBGGoiBkEZSA0AIAUgBkEYbkECa0EBdiIHQRhsaiIJIAAgAigCACgCABCuCkUNACAIQRBqIgsgDS0AADoAACAIIAApAgA3AwggCCAAKAIMIg02AhQgCCAAKAIQIgM2AhggCCAAKAIUIgQ2AhwgAEEANgIUIABCADcCDANAAkAgACAJIgYpAgA3AgAgACAGQQhqIgotAAA6AAggBikCDCEUIAAgBigCFDYCFCAAIBQ3AgwgBkEANgIUIAZCADcCDCAHRQ0AIAYhACAFIAdBAWtBAXYiB0EYbGoiCSAIQQhqIAIoAgAoAgAQrgoNAQsLIAYgCCkDCDcCACAKIAstAAA6AAAgBiAENgIUIAYgAzYCECAGIA02AgwLIAFBGGshASAMQQJLIQAgDEEBayEMIAANAAsMBAsgBSAMQQF2QRhsaiEAAkAgDUGBGE8EQCAFIAAgCyACELEKIAVBGGogAEEYayIGIA8gAhCxCiAFQTBqIABBGGoiByAOIAIQsQogBiAAIAcgAhCxCiAIQRBqIgYgBUEIaiIHLQAAOgAAIAggBSkCADcDCCAFKAIUIQkgBUEANgIUIAUpAgwhFCAFQgA3AgwgBSAAKQIANwIAIAcgAEEIaiIKLQAAOgAAIAUgACgCDDYCDCAFIAAoAhA2AhAgBSAAKAIUNgIUIAYtAAAhBiAIKQMIIRUgACAJNgIUIAAgFDcCDCAAIBU3AgAgCiAGOgAADAELIAAgBSALIAIQsQoLIANBAWshAyACKAIAKAIAIQACQCAEQQFxIhANACAFQRhrIAUgABCuCg0AIAhBEGoiDSAFQQhqIhItAAA6AAAgCCAFKQIANwMIIAggBSgCDCIENgIUIAggBSgCECIQNgIYIAggBSgCFCIRNgIcIAVBADYCFCAFQgA3AgwgCEEIaiALIAAQrgohBiACKAIAIQcgBSEAAkAgBgRAIAcoAgAhBgNAIAhBCGogAEEYaiIAIAYQrgpFDQALDAELA0AgAEEYaiIAIAFPDQEgCEEIaiAAIAcoAgAQrgpFDQALCyABIgYgAEsEQCAHKAIAIQcDQCAIQQhqIAZBGGsiBiAHEK4KDQALCyAAIAZJBEADQCAIQShqIgcgAEEIaiIJLQAAOgAAIAggACkCADcDICAAKAIUIQogAEEANgIUIAApAgwhFCAAQgA3AgwgACAGKQIANwIAIAkgBkEIaiIMLQAAOgAAIAAgBigCDDYCDCAAIAYoAhA2AhAgACAGKAIUNgIUIAwgBy0AADoAACAGIAgpAyA3AgAgBiAKNgIUIAYgFDcCDCACKAIAKAIAIQcDQCAIQQhqIABBGGoiACAHEK4KRQ0ACwNAIAhBCGogBkEYayIGIAcQrgoNAAsgACAGSQ0ACwsCQCAAQRhrIgYgBUcEQCAFIAYpAgA3AgAgEiAGQQhqIgktAAA6AAAgBSgCDCIHBEAgBSAHNgIQIAcQKyAFQQA2AhQgBUIANwIMCyAFIABBDGsiBygCADYCDCAFIABBCGsoAgA2AhAgBSAAQQRrIgooAgA2AhQgCkEANgIAIAdCADcCACAJIA0tAAA6AAAgBiAIKQMINwIADAELIABBDGsiBygCACEFIAYgDS0AADoACCAGIAgpAwg3AgAgBUUNACAAQQhrIAU2AgAgBRArIAdBADYCAAsgByAENgIAIABBBGsgETYCACAAQQhrIBA2AgBBACEEIAAhBQwBCwsgCEEQaiIOIAVBCGoiEy0AADoAACAIIAUpAgA3AwggCCAFKAIMIg82AhQgCCAFKAIQIhE2AhggCCAFKAIUIhI2AhwgBUEANgIUIAVCADcCDCAFIQkDQCAJIgZBGGoiCSAIQQhqIAAQrgoNAAsgASEKAkAgBSAGRgRAIAIoAgAhAANAIAkgCk8NAiAKQRhrIgogCEEIaiAAKAIAEK4KRQ0ACwwBCwNAIApBGGsiCiAIQQhqIAAQrgpFDQALCyAJIgAgCiIGSQRAA0AgCEEoaiIHIABBCGoiDC0AADoAACAIIAApAgA3AyAgACgCFCELIABBADYCFCAAKQIMIRQgAEIANwIMIAAgBikCADcCACAMIAZBCGoiDS0AADoAACAAIAYoAgw2AgwgACAGKAIQNgIQIAAgBigCFDYCFCANIActAAA6AAAgBiAIKQMgNwIAIAYgCzYCFCAGIBQ3AgwgAigCACgCACEHA0AgAEEYaiIAIAhBCGogBxCuCg0ACwNAIAZBGGsiBiAIQQhqIAcQrgpFDQALIAAgBkkNAAsLAkAgAEEYayIGIAVHBEAgBSAGKQIANwIAIBMgBkEIaiIMLQAAOgAAIAUoAgwiBwRAIAUgBzYCECAHECsgBUEANgIUIAVCADcCDAsgBSAAQQxrIgcoAgA2AgwgBSAAQQhrKAIANgIQIAUgAEEEayILKAIANgIUIAtBADYCACAHQgA3AgAgDCAOLQAAOgAAIAYgCCkDCDcCAAwBCyAAQQxrIgcoAgAhDCAGIA4tAAA6AAggBiAIKQMINwIAIAxFDQAgAEEIayAMNgIAIAwQKyAHQQA2AgALIAcgDzYCACAAQQRrIBI2AgAgAEEIayARNgIAIAkgCk8EQCAFIAYgAhCyCiEHIAAgASACELIKBEAgBiEBIAUhACAHRQ0DDAQLIAcNAgsgBSAGIAIgAyAQENgJQQAhBAwBCwsgBSAFQRhqIAsgAhCxCgsgCEEwaiQAC6Q1Ahh/AnsjAEEwayISJAADQCABQRBrIRogAUEgayEbIAFBKGshFiABQSxrIRcgAUGQAWshGCABQeAAayEZIAFBMGshFCAAIQcCQANAAkACQAJAAkACQAJAAkACQCABIAdrIgVBMG0iCA4GCQkABAECAwsCQCAHKAIEIgUgFygCACIMQX9zIgpxIgYgBiAHKAIIIgggFigCACINQX9zIgtzIgBxIAggC3FzIgYgACAFIApzIgpxcyAGaiAAcyAKcXMgAHNBAE4NACAFIAxHDQkgCCANRw0JIBQoAgAiACAHKAIAIgVJDQAgACAFSw0JIBv9AAMAIBr9AAMAIAf9AAMQIAf9AAMgIAIoAgAQqQpFDQkLIBJBIGoiACAHQSBqIgX9AAMA/QsDACASQRBqIgggB0EQaiIK/QADAP0LAwAgEiAH/QADAP0LAwAgByAUQShqIgYpAwA3AyggBSAUQSBqIgspAwA3AwAgByAUQRhqIgUpAwA3AxggCiAUQRBqIgwpAwA3AwAgByAUQQhqIgopAwA3AwggByAUKQMANwMAIAYgEikDKDcDACALIAApAwA3AwAgBSASKQMYNwMAIAwgCCkDADcDACAKIBIpAwg3AwAgFCASKQMANwMADAgLIAcgB0EwaiAHQeAAaiAUIAIQqgoMBwsgByAHQTBqIAdB4ABqIAdBkAFqIBQgAhCrCgwGCyAFQf8ITARAIAEgB0YgB0EwaiIFIAFGciEAIARBAXEEQCAADQcgByEJA0AgCSEAIAUhCQJAAkAgACgCBCIIIAAoAjQiDUF/cyIGcSILIAsgACgCCCIKIAAoAjgiD0F/cyIMcyIFcSAKIAxxcyILIAUgBiAIcyIGcXMgC2ogBXMgBnFzIAVzQQBOBEAgCSgCACEODAELIAggDUcNASAKIA9HDQEgCSgCACIOIAAoAgAiBUkNACAFIA5JDQEgAP0AA0AgAP0AA1AgAP0AAxAgAP0AAyAgAigCABCpCkUNAQsgCSgCBCERIAkgACkDADcDACAJQQhqIgUoAgAhECAJKAIMIRMgBSAAKQMINwMAIAlBEGoiBf0AAwAhHSAFIAD9AAMQ/QsDACAJQSBqIgX9AAMAIR4gBSAA/QADIP0LAwACQCAHIgUgAEYNACAQQX9zIQsgEUF/cyEMA0AgACIFQTBrIQACQCAFQSxrKAIAIgogDHEiDSANIAVBKGsoAgAiBiALcyIIcSAGIAtxcyINIAggCiAMcyIPcXMgDWogCHMgD3FzIAhzQQBODQAgCiARRw0CIAYgEEcNAiAOIAAoAgAiCEkNACAIIA5JDQIgHSAeIAVBIGv9AAMAIAVBEGv9AAMAIAIoAgAQqQpFDQILIAUgAP0AAwD9CwMAIAUgAP0AAyD9CwMgIAUgAP0AAxD9CwMQIAAgB0cNAAsgByEFCyAFIB79CwMgIAUgHf0LAxAgBSATNgIMIAUgEDYCCCAFIBE2AgQgBSAONgIACyAJQTBqIgUgAUcNAAsMBwsgAA0GA0AgByEKIAUhBwJAAkAgCigCBCIFIAooAjQiDUF/cyIGcSILIAsgCigCCCIIIAooAjgiD0F/cyIMcyIAcSAIIAxxcyILIAAgBSAGcyIGcXMgC2ogAHMgBnFzIABzQQBOBEAgBygCACEODAELIAUgDUcNASAIIA9HDQEgBygCACIOIAooAgAiAEkNACAAIA5JDQEgCv0AA0AgCv0AA1AgCv0AAxAgCv0AAyAgAigCABCpCkUNAQsgBygCCCIQQX9zIQwgBygCBCIRQX9zIQ0gB/0AAyAhHSAH/QADECEeIAcoAgwhEyAHIQUDQCAFIAoiAP0AAwD9CwMAIAUgAP0AAyD9CwMgIAUgAP0AAxD9CwMQIABBMGshCiAAIQUgAEEsaygCACIGIA1xIg8gDyAAQShrKAIAIgsgDHMiCHEgCyAMcXMiDyAIIAYgDXMiCXFzIA9qIAhzIAlxcyAIc0EATg0AAkAgBiARRw0AIAsgEEcNACAOIAooAgAiCEkNASAIIA5JDQAgHiAdIABBIGv9AAMAIABBEGv9AAMAIAIoAgAQqQoNAQsLIAAgHf0LAyAgACAe/QsDECAAIBM2AgwgACAQNgIIIAAgETYCBCAAIA42AgALIAdBMGoiBSABRw0ACwwGCyADRQRAIAEgB0YNBiAIQQJrQQF2IhEhAANAAkAgESAAIgpIDQAgByAAQTBsaiENIAcgAEEBdCIGQQFyIgxBMGxqIQAgAigCACEDAkAgCCAGQQJqIgZMBEAgDCEGDAELAkAgACgCNCIPIAAoAgQiFUF/cyIOcSIQIBAgACgCOCIJIAAoAggiFEF/cyITcyILcSAJIBNxcyIQIAsgDiAPcyIOcXMgEGogC3MgDnFzIAtzQQBODQAgDyAVRwRAIAwhBgwCCyAJIBRHBEAgDCEGDAILIAAoAgAiCyAAKAIwIg9JDQAgCyAPSwRAIAwhBgwCCyAA/QADECAA/QADICAA/QADQCAA/QADUCADEKkKDQAgDCEGDAELIABBMGohAAsgDSgCBCILIAAoAgQiE0F/cyIJcSIOIA4gDSgCCCIMIAAoAggiFEF/cyIQcyIPcSAMIBBxcyIOIA8gCSALcyIJcXMgDmogD3MgCXFzIA9zQQBODQAgDSgCACEVAkAgCyATRw0AIAwgFEcNACAAKAIAIg8gFUkNASAPIBVLDQAgAP0AAxAgAP0AAyAgDf0AAxAgDf0AAyAgAxCpCg0BCyANKAIMIRkgDSAA/QADAP0LAwAgDUEQaiIP/QADACEdIA8gAP0AAxD9CwMAIA1BIGoiDf0AAwAhHiANIAD9AAMg/QsDAAJAIAYgEUoNACALQX9zIQMDQCAAIQ8gByAGQQF0IgZBAXIiCUEwbGohACACKAIAIRQCQCAIIAZBAmoiBkwEQCAJIQYMAQsCQCAAKAI0Ig4gACgCBCIXQX9zIhNxIhYgFiAAKAI4IhAgACgCCCIYQX9zIgRzIg1xIAQgEHFzIhYgDSAOIBNzIhNxcyAWaiANcyATcXMgDXNBAE4NACAOIBdHBEAgCSEGDAILIBAgGEcEQCAJIQYMAgsgACgCACINIAAoAjAiDkkNACANIA5LBEAgCSEGDAILIAD9AAMQIAD9AAMgIAD9AANAIAD9AANQIBQQqQoNACAJIQYMAQsgAEEwaiEACyALIAAoAgQiDUF/c3EiECAQIAwgACgCCCIOcyIJQX9zIhNxIAwgDkF/c3FzIhAgEyADIA1zcXMgEGogCXMgCyANc3JzIAlzQQBOBEAgDyEADAILAkAgCyANRw0AIAwgDkcNACAVIAAoAgAiDUsEQCAPIQAMAwsgDSAVSw0AIAD9AAMQIAD9AAMgIB0gHiAUEKkKRQ0AIA8hAAwCCyAPIAD9AAMA/QsDACAPIAD9AAMg/QsDICAPIAD9AAMQ/QsDECAGIBFMDQALCyAAIB79CwMgIAAgHf0LAxAgACAZNgIMIAAgDDYCCCAAIAs2AgQgACAVNgIACyAKQQFrIQAgCg0ACyAFQTBuIQADQCASQSBqIgMgB/0AAyD9CwMAIBJBEGoiFiAH/QADEP0LAwAgEiAH/QADAP0LAwAgACIPQQJrQQF2IQkgByEAQQAhBQNAIAVBAXQiBkEBciELIAAiCCAFQTBsaiIKQTBqIQACfyALIA8gBkECaiIGTA0AGiAKQeAAaiETAkAgCigCZCIMIAooAjQiFUF/cyIOcSIRIBEgCigCaCINIAooAjgiFEF/cyIQcyIFcSANIBBxcyIRIAUgDCAOcyIOcXMgEWogBXMgDnFzIAVzQQBODQAgCyAMIBVHDQEaIAsgDSAURw0BGiAAKAIAIgUgEygCACIMSQ0AIAsgBSAMSw0BGiALIApBQGv9AAMAIAr9AANQIAr9AANwIAr9AAOAASACKAIAEKkKRQ0BGgsgEyEAIAYLIQUgCCAA/QADAP0LAwAgCCAAQSBqIgr9AAMA/QsDICAIIABBEGoiCP0AAwD9CwMQIAUgCUwNAAsCQCABQTBrIgEgAEYEQCAAIBL9AAMA/QsDACAKIAP9AAMA/QsDACAIIBb9AAMA/QsDAAwBCyAAIAH9AAMA/QsDACAKIAFBIGoiBf0AAwD9CwMAIAggAUEQaiIG/QADAP0LAwAgASASKQMANwMAIAEgEikDCDcDCCAGIBYpAwA3AwAgASASKQMYNwMYIAUgAykDADcDACABIBIpAyg3AyggACAHa0EwaiIFQTFIDQACQCAAKAIEIgYgByAFQTBuQQJrIhBBAXYiDUEwbGoiBSgCBCITQX9zIglxIg4gDiAAKAIIIgsgBSgCCCIVQX9zIhFzIgxxIAsgEXFzIg4gDCAGIAlzIglxcyAOaiAMcyAJcXMgDHNBAE4EQCAAKAIAIRMMAQsgBiATRw0BIAsgFUcNASAFKAIAIgwgACgCACITSQ0AIAwgE0sNASAF/QADECAF/QADICAA/QADECAK/QADACACKAIAEKkKRQ0BCyAAKAIMIRUgACAF/QADAP0LAwAgCP0AAwAhHSAIIAX9AAMQ/QsDACAK/QADACEeIAogBf0AAyD9CwMAAkAgEEECSQ0AIAZBf3MhEANAIAUhAAJAIAYgByANQQFrIhFBAXYiDUEwbGoiBSgCBCIIQX9zcSIJIAkgCyAFKAIIIgxzIgpBf3MiDnEgCyAMQX9zcXMiCSAOIAggEHNxcyAJaiAKcyAGIAhzcnMgCnNBAE4NACAGIAhHBEAgACEFDAMLIAsgDEcEQCAAIQUMAwsgBSgCACIIIBNJDQAgCCATSwRAIAAhBQwDCyAF/QADECAF/QADICAdIB4gAigCABCpCg0AIAAhBQwCCyAAIAX9AAMA/QsDACAAIAX9AAMg/QsDICAAIAX9AAMQ/QsDECARQQFLDQALCyAFIB79CwMgIAUgHf0LAxAgBSAVNgIMIAUgCzYCCCAFIAY2AgQgBSATNgIACyAPQQFrIQAgD0ECSg0ACwwGCyAHIAhBAXZBMGxqIQACQCAFQYEwTwRAIAcgACAUIAIQrAogB0EwaiAAQTBrIgUgGSACEKwKIAdB4ABqIABBMGoiCCAYIAIQrAogBSAAIAggAhCsCiASQSBqIgUgB0EgaiII/QADAP0LAwAgEkEQaiIKIAdBEGoiBv0AAwD9CwMAIBIgB/0AAwD9CwMAIAcgAEEoaiILKQMANwMoIAggAEEgaiIMKQMANwMAIAcgAEEYaiIIKQMANwMYIAYgAEEQaiINKQMANwMAIAcgAEEIaiIGKQMANwMIIAcgACkDADcDACALIBIpAyg3AwAgDCAFKQMANwMAIAggEikDGDcDACANIAopAwA3AwAgBiASKQMINwMAIAAgEikDADcDAAwBCyAAIAcgFCACEKwKCyADQQFrIQMgBEEBcSIcBEAgAigCACEVIAcoAgghECAHKAIEIREgBygCACEODAQLIAcoAgAhDiACKAIAIRUgBygCBCIRIAdBLGsoAgAiBkF/cyIFcSIIIAggBygCCCIQIAdBKGsoAgAiC0F/cyIKcyIAcSAKIBBxcyIIIAAgBSARcyIFcXMgCGogAHMgBXFzIABzQQBODQMCQCAGIBFHDQAgCyAQRw0AIAdBMGsoAgAiACAOSQ0EIAAgDksNACAHQSBr/QADACAHQRBr/QADACAH/QADECAH/QADICAVEKkKDQQLIAf9AAMgIR0gB/0AAxAhHiAHKAIMIQQgByEJIBcoAgAiCyARQX9zIghxIgUgBSAWKAIAIgwgEEF/cyIKcyIAcSAKIAxxcyIFIAAgCCALcyIGcXMgBWogAHMgBnFzIABzQQBODQECQCALIBFHDQAgDCAQRw0AIA4gFCgCACIASQ0CIAAgDkkNACAeIB0gG/0AAwAgGv0AAwAgFRCpCg0CCyAHIgVBMGoiCSABTw0CA0AgBSEGIAkhBSAGKAI0Ig0gCHEiCSAJIAYoAjgiDyAKcyIAcSAKIA9xcyIJIAAgCCANcyITcXMgCWogAHMgE3FzIABzQQBOBEAgBSEJDAQLAkAgDSARRw0AIA8gEEcNACAFKAIAIgAgDksEQCAFIQkMBQsgACAOSQ0AIB4gHSAG/QADQCAG/QADUCAVEKkKRQ0AIAUhCQwECyAFQTBqIgkgAUkNAAsMAgsgByAHQTBqIBQgAhCsCgwECwNAIAkiBUEwaiEJIAUoAjQiBiAIcSIPIA8gBSgCOCINIApzIgBxIAogDXFzIg8gACAGIAhzIhNxcyAPaiAAcyATcXMgAHNBAE4NASAGIBFHDQAgDSAQRw0AIA4gCSgCACIASQ0BIAAgDkkNACAeIB0gBf0AA0AgBf0AA1AgFRCpCkUNAAsLIAEiACEGAkAgACAJTQ0AA0AgAEEwayEGAkAgCCALcSINIA0gCiAMcyIFcSAKIAxxcyINIAUgCCALcyIPcXMgDWogBXMgD3FzIAVzQQBODQAgCyARRw0CIAwgEEcNAiAOIAYoAgAiBUkNACAFIA5JDQIgHiAdIABBIGv9AAMAIABBEGv9AAMAIBUQqQpFDQILIABB2ABrKAIAIQwgAEHcAGsoAgAhCyAGIQAMAAsACyAGIAlLBEADQCASQSBqIgAgCUEgaiIF/QADAP0LAwAgEkEQaiILIAlBEGoiDP0AAwD9CwMAIBIgCf0AAwD9CwMAIAkgBkEoaiINKQMANwMoIAUgBkEgaiIPKQMANwMAIAkgBkEYaiIFKQMANwMYIAwgBkEQaiITKQMANwMAIAkgBkEIaiIMKQMANwMIIAkgBikDADcDACANIBIpAyg3AwAgDyAAKQMANwMAIAUgEikDGDcDACATIAspAwA3AwAgDCASKQMINwMAIAYgEikDADcDACACKAIAIRMDQAJAIAkiBUEwaiEJIAUoAjQiCyAIcSINIA0gBSgCOCIMIApzIgBxIAogDHFzIg0gACAIIAtzIg9xcyANaiAAcyAPcXMgAHNBAE4NACALIBFHDQEgDCAQRw0BIA4gCSgCACIASQ0AIAAgDkkNASAeIB0gBf0AA0AgBf0AA1AgExCpCkUNAQsLA0AgBiIFQTBrIQYgBUEsaygCACILIAhxIg0gDSAFQShrKAIAIgwgCnMiAHEgCiAMcXMiDSAAIAggC3MiD3FzIA1qIABzIA9xcyAAc0EATg0AAkAgCyARRw0AIAwgEEcNACAOIAYoAgAiAEkNASAAIA5JDQAgHiAdIAVBIGv9AAMAIAVBEGv9AAMAIBMQqQoNAQsLIAYgCUsNAAsLIAlBMGsiACAHRwRAIAcgAP0AAwD9CwMAIAcgAP0AAyD9CwMgIAcgAP0AAxD9CwMQCyAAIA42AgAgCUEQayAd/QsDACAJQSBrIB79CwMAIAlBJGsgBDYCACAJQShrIBA2AgAgCUEsayARNgIAQQAhBCAJIQcMAQsLIBBBf3MhDSARQX9zIQ8gB/0AAyAhHSAH/QADECEeIAcoAgwhFyAHIRQDQCAUIgVBMGohFCARIAUoAjQiCEF/c3EiBiAGIAUoAjgiCiANcyIAcSAQIApBf3NxcyIGIAAgCCAPcyILcXMgBmogAHMgC3FzIABzQQBODQACQCAIIBFHDQAgCiAQRw0AIBQoAgAiACAOSQ0BIAAgDksNACAF/QADQCAF/QADUCAeIB0gFRCpCg0BCwsgASEWAkAgBSAHRgRAIBQgASIATw0BA0AgAEEwayEWIBEgAEEsaygCACIKQX9zcSILIAsgAEEoaygCACIGIA1zIghxIBAgBkF/c3FzIgsgCCAKIA9zIgxxcyALaiAIcyAMcXMgCHNBAE4NAgJAIAogEUcNACAGIBBHDQAgFigCACIIIA5JDQMgCCAOSw0AIABBIGv9AAMAIABBEGv9AAMAIB4gHSAVEKkKDQMgFCAWIgBJDQEMAwsgFCAWIgBJDQALDAELA0AgFiIIQTBrIRYgESAIQSxrKAIAIgpBf3NxIgsgCyAIQShrKAIAIgYgDXMiAHEgECAGQX9zcXMiCyAAIAogD3MiDHFzIAtqIABzIAxxcyAAc0EATg0BIAogEUcNACAGIBBHDQAgFigCACIAIA5JDQEgACAOSw0AIAhBIGv9AAMAIAhBEGv9AAMAIB4gHSAVEKkKRQ0ACwsgFiIJIBQiCEsEQANAIBJBIGoiACAIQSBqIgX9AAMA/QsDACASQRBqIgogCEEQaiIG/QADAP0LAwAgEiAI/QADAP0LAwAgCCAJQShqIgspAwA3AyggBSAJQSBqIgwpAwA3AwAgCCAJQRhqIgUpAwA3AxggBiAJQRBqIhMpAwA3AwAgCCAJQQhqIgYpAwA3AwggCCAJKQMANwMAIAsgEikDKDcDACAMIAApAwA3AwAgBSASKQMYNwMAIBMgCikDADcDACAGIBIpAwg3AwAgCSASKQMANwMAIAIoAgAhFQNAIAgiBUEwaiEIIBEgBSgCNCIKQX9zcSILIAsgBSgCOCIGIA1zIgBxIBAgBkF/c3FzIgsgACAKIA9zIgxxcyALaiAAcyAMcXMgAHNBAE4NAAJAIAogEUcNACAGIBBHDQAgCCgCACIAIA5JDQEgACAOSw0AIAX9AANAIAX9AANQIB4gHSAVEKkKDQELCwNAAkAgCSIKQTBrIQkgESAKQSxrKAIAIgZBf3NxIgwgDCAKQShrKAIAIgsgDXMiAHEgECALQX9zcXMiDCAAIAYgD3MiE3FzIAxqIABzIBNxcyAAc0EATg0AIAYgEUcNASALIBBHDQEgCSgCACIAIA5JDQAgACAOSw0BIApBIGv9AAMAIApBEGv9AAMAIB4gHSAVEKkKRQ0BCwsgCCAJSQ0ACwsgBSAHRwRAIAcgBf0AAwD9CwMAIAcgBf0AAyD9CwMgIAcgBf0AAxD9CwMQCyAFIB39CwMgIAUgHv0LAxAgBSAXNgIMIAUgEDYCCCAFIBE2AgQgBSAONgIAIBQgFk8EQCAHIAUgAhCtCiEIIAVBMGoiACABIAIQrQoEQCAFIQEgByEAIAhFDQMMAgsgCA0CCyAHIAUgAiADIBwQ2QkgBUEwaiEAQQAhBAwBCwsgEkEwaiQAC9EDAgh/DH5BASEEIAAoAgAiBkECTwRAQQEhBQNAAkACQCAAKAIEIgIgBUEwbGoiAygCACACIARBMGxqIgJBMGsoAgBHDQAgAygCBCACQSxrKAIARw0AIAMoAgggAkEoaygCAEcNACACQSBrIgcgBykDACINIAMpAxB8IhI3AwAgAkEYayIIIAgpAwAiDyADKQMYfCIKIA0gElatfCINNwMAIAJBEGsiCSAJKQMAIhAgAykDIHwiCyAKIA9UIAogDVZyrXwiCjcDACACQQhrIgIgAikDACITIAMpAyh8Ig8gCiALVCALIBBUcq18Igs3AwAgAiABKQM4IhQgC3wiECABKQMwIgwgCnwiESAMVCARIAEpAygiDiANfCIMIA5UIAwgASkDICIOIBJ8IhUgDlStfCIOIAxUcq18IgwgEVRyrXwiESALIA8gE1QgCyAPVHIgECAUVCAQIBFWcnMiAxs3AwAgCSAMIAogAxs3AwAgCCAOIA0gAxs3AwAgByAVIBIgAxs3AwAMAQsgAiAD/QADAP0LAwAgAiAD/QADIP0LAyAgAiAD/QADEP0LAxAgBEEBaiEEIAAoAgAhBgsgBUEBaiIFIAZJDQALCyAAIAQ2AgAL2AIBB38CQCAAKAIEIgcgACgCACIDayIGQQxtQQFqIgJB1qrVqgFJBEBB1arVqgEgACgCCCADa0EMbSIEQQF0IgUgAiACIAVJGyAEQarVqtUATxsiAkHWqtWqAU8NASACQQxsIgQQogkiBSAGaiICIAEpAgA3AgAgASgCCCEIIAFBADYCCCACIAg2AgggBCAFaiEIIAIgBkF0bUEMbGohBSACQQxqIQQgAyAHRwRAIAMhASAFIQIDQCACIAEpAgA3AgAgASgCCCEGIAFBADYCCCACIAY2AgggAkEMaiECIAFBDGoiASAHRw0ACwNAIAMoAgghASADQQA2AgggAQRAIAEoAgQiAgRAIAEgAjYCCCACECsLIAEQKwsgA0EMaiIDIAdHDQALIAAoAgAhAwsgACAINgIIIAAgBDYCBCAAIAU2AgAgAwRAIAMQKwsgBA8LEKAJAAsQoAkAC4sOAQZ/IwBBwAFrIgMkACADQQA6AJwBIANBADYCmAEgA0G7zwE7ATQgA0Hqkpi/BjYCMCADQa4BOgA2IANBhfkAOwA3IANB7gA6ADkgA0Hz5QE7ATogA0GlAToAPCADQc/qAzsAPSADQTo6AD8gA0HRHDsBQCADQdIAOgBCIANBBToARSADQf+2AjsAQyADQR86AEggA0HomAI7AUYgAyADQTBqIgU2AiwgA0GDswM7AEkgA0GrAToASyADKAIsIgRBzQE6AB4gBEHbwAM7ABwgAygCLCIEQgA3ACAgBEEZOgAfIANBADYApAEgA0EANgChASADQQE6AKABIANBLGogA0GgAWpBCBCqCSADQaABaiACIAL9AAOIAiAC/QADmAIQmQkgAyAD/QADoAH9CwQAIAMgA/0AA7AB/QsEECADQSxqIANBIBCqCSABKAIAIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIEIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIIIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIMIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIQIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIUIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIYIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIcIQQgA0EANgCkASADIARBGHY6AKMBIAMgBEEQdjoAogEgAyAEQQh2OgChASADIAQ6AKABIANBLGogA0GgAWpBCBCqCSABKAIgIgQgASgCJCIIRwRAA0AgBCgCACEBQQAhBiADQQA2AKQBIAMgAUEYdjoAowEgAyABQRB2OgCiASADIAFBCHY6AKEBIAMgAToAoAEgA0EsaiADQaABakEIEKoJIAQoAgQhASADQQA2AKQBIAMgAUEYdjoAowEgAyABQRB2OgCiASADIAFBCHY6AKEBIAMgAToAoAEgA0EsaiADQaABakEIEKoJIAQoAggoAgAhASADQQA2AKQBIAMgAUEYdjoAowEgAyABQRB2OgCiASADIAFBCHY6AKEBIAMgAToAoAEgA0EsaiADQaABakEIEKoJIAQoAggiASgCAARAA0AgBkEwbCIHIAEoAgRqKAIAIQEgA0EANgCkASADIAFBGHY6AKMBIAMgAUEQdjoAogEgAyABQQh2OgChASADIAE6AKABIANBLGogA0GgAWpBCBCqCSAEKAIIKAIEIAdqKAIEIQEgA0EANgCkASADIAFBGHY6AKMBIAMgAUEQdjoAogEgAyABQQh2OgChASADIAE6AKABIANBLGogA0GgAWpBCBCqCSAEKAIIKAIEIAdqKAIIIQEgA0EANgCkASADIAFBGHY6AKMBIAMgAUEQdjoAogEgAyABQQh2OgChASADIAE6AKABIANBLGogA0GgAWpBCBCqCSADQaABaiACIAQoAggoAgQgB2oiAf0AAxAgAf0AAyAQmQkgAyAD/QADoAH9CwQAIAMgA/0AA7AB/QsEECADQSxqIANBIBCqCSAGQQFqIgYgBCgCCCIBKAIASQ0ACwsgBEEMaiIEIAhHDQALCyAAIANBLGogA0HYAGoCfyADLQCcAUUEQCADKAKYAQwBCyADQeqSmL8GNgIwIAMgBTYCLCAFQa4BOgAGIAVBu88BOwAEIAMoAiwiAUHuADoACSABQYX5ADsAByADKAIsIgFBpQE6AAwgAUHz5QE7AAogAygCLCIBQTo6AA8gAUHP6gM7AA0gAygCLCIBQdIAOgASIAFB0Rw7ABAgAygCLCIBQQU6ABUgAUH/tgI7ABMgAygCLCIBQR86ABggAUHomAI7ABYgAygCLCIBQasBOgAbIAFBg7MDOwAZIAMoAiwiAUHNAToAHiABQdvAAzsAHCADKAIsIgFCADcAICABQRk6AB8gA0EAOgCcASADQQA2ApgBQQALEKsJIANBwAFqJAALigwBBX8CQCAAQdMBTQRAQeCtMkGgrzIgABD3DCgCACECDAELIABBfE8EQBCgCQALQaCvMkHgsDIgACAAQdIBbiIFQdIBbCICaxD3DEGgrzJrQQJ1IQQDQCAEQQJ0QaCvMmooAgAgAmohAkEFIQADQAJAIABBL0YEQEHTASEAA0AgAiAAbiIBIABJDQUgAiAAIAFsRg0CIAIgAEEKaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEMaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEQaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEESaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEWaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEcaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEeaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEkaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEoaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEqaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEEuaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEE0aiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEE6aiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEE8aiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEHCAGoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBxgBqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQcgAaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEHOAGoiAW4iAyABSQ0FIAIgASADbEYNAiACIABB0gBqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQdgAaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEHgAGoiAW4iAyABSQ0FIAIgASADbEYNAiACIABB5ABqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQeYAaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEHqAGoiAW4iAyABSQ0FIAIgASADbEYNAiACIABB7ABqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQfAAaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEH4AGoiAW4iAyABSQ0FIAIgASADbEYNAiACIABB/gBqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQYIBaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEGIAWoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBigFqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQY4BaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEGUAWoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBlgFqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQZwBaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEGiAWoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBpgFqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQagBaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEGsAWoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBsgFqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQbQBaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEG6AWoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBvgFqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQcABaiIBbiIDIAFJDQUgAiABIANsRg0CIAIgAEHEAWoiAW4iAyABSQ0FIAIgASADbEYNAiACIABBxgFqIgFuIgMgAUkNBSACIAEgA2xGDQIgAiAAQdABaiIBbiIDIAFJDQUgAEHSAWohACACIAEgA2xHDQALDAELIAIgAEECdEHgrTJqKAIAIgFuIgMgAUkNAyAAQQFqIQAgAiABIANsRw0BCwtBACAEQQFqIgAgAEEwRiIAGyEEIAAgBWoiBUHSAWwhAgwACwALIAIL6gIBB38CQAJAIAEEQCABQYCAgIAETw0CIAFBAnQiAxCiCSEFIAAoAgAhAiAAIAU2AgAgAgRAIAIQKyAAKAIAIQULIAAgATYCBCADBEAgBUEAIAP8CwALIAAoAggiA0UNASAAQQhqIQAgAygCBCEEAkAgAWkiBkEBTQRAIAQgAUEBa3EhBAwBCyABIARLDQAgBCABcCEECyAFIARBAnRqIAA2AgAgAygCACICRQ0BIAFBAWshByAGQQFLIQgDQCACKAIEIQACQCAIRQRAIAAgB3EhAAwBCyAAIAFJDQAgACABcCEACwJAIAAgBEYEQCACIQMMAQsgBSAAQQJ0aiIGKAIARQRAIAYgAzYCACACIQMgACEEDAELIAMgAigCADYCACACIAYoAgAoAgA2AgAgBigCACACNgIACyADKAIAIgINAAsMAQsgACgCACECIABBADYCACACBEAgAhArCyAAQQA2AgQLDwsQoAkAC6YCAQF/IwBBQGoiAyQAAkACQAJAIAEgAk8EQCABIAJrQQF0IgJB////B08NAiADIAI6AD0gAyACQRB2OgA/IAMgAkEIdjoAPiAAIAAoAgQgA0E9aiADQUBrQQMQpwkMAQsgAiABa0EBdCICQQFyIgFB////B08NAiADIAE6AD0gAyACQRB2OgA/IAMgAkEIdjoAPiAAIAAoAgQgA0E9aiADQUBrQQMQpwkLIANBQGskAA8LIANBla4qNgIwQeQAQfSHKiADQTBqEJsJQZCWNCgCACgCACECIANBla4qNgIgIAJBkYwqIANBIGoQbAALIANBla4qNgIQQeQAQfSHKiADQRBqEJsJQZCWNCgCACgCACECIANBla4qNgIAIAJBkYwqIAMQbAALpgECA34CfyMAQUBqIgYkACAGQSBqIAIgACABEJkJIAYgBv0AAyD9CwQAIAYgBv0AAzD9CwQQQQAhAkIBIQMDQCADQgiIIgUgAiAGaiIHMQABhUI4hiIEIAMgBzEAAIVCOIYiA0IDiCADQgSIhSADIAWEIANCAYiFhUIIiIQgBEIBiIUgBEIDiIUgBEIEiIUhAyACQQJqIgJBIEcNAAsgBkFAayQAIAMLxQkCB3sTfyAAQUBrIQz9DAwAAAANAAAADgAAAA8AAAAhBf0MCAAAAAkAAAAKAAAACwAAACEG/QwEAAAABQAAAAYAAAAHAAAAIQf9DAAAAAABAAAAAgAAAAMAAAAhCAJAAkAgACABQSBqTw0AIAEgDE8NAANAIAAgCUEBdGoiCiABIAlqIgstAABBBHZB8NMxai0AADoAACAKIAstAABBD3FB8NMxai0AADoAASAJQQFqIglBIEcNAAsMAQsDQCAAIAhBAf2rASIC/RsAaiIKIAEgCWoiC/0AAABBBP1tIgP9iQH9qQEiBP0bAEHw0zFqLQAAOgAAIAAgAv0bAWoiDSAE/RsBQfDTMWotAAA6AAAgACAC/RsCaiIOIAT9GwJB8NMxai0AADoAACAAIAL9GwNqIg8gBP0bA0Hw0zFqLQAAOgAAIAAgB0EB/asBIgL9GwBqIhAgAyAC/Q0EBQYHAAAAAAAAAAAAAAAA/YkB/akBIgT9GwBB8NMxai0AADoAACAAIAL9GwFqIhEgBP0bAUHw0zFqLQAAOgAAIAAgAv0bAmoiEiAE/RsCQfDTMWotAAA6AAAgACAC/RsDaiITIAT9GwNB8NMxai0AADoAACAAIAZBAf2rASIC/RsAaiIUIAMgAv0NCAkKCwAAAAAAAAAAAAAAAP2JAf2pASIE/RsAQfDTMWotAAA6AAAgACAC/RsBaiIVIAT9GwFB8NMxai0AADoAACAAIAL9GwJqIhYgBP0bAkHw0zFqLQAAOgAAIAAgAv0bA2oiFyAE/RsDQfDTMWotAAA6AAAgACAFQQH9qwEiAv0bAGoiGCADIAL9DQwNDg8AAAAAAAAAAAAAAAD9iQH9qQEiA/0bAEHw0zFqLQAAOgAAIAAgAv0bAWoiGSAD/RsBQfDTMWotAAA6AAAgACAC/RsCaiIaIAP9GwJB8NMxai0AADoAACAAIAL9GwNqIhsgA/0bA0Hw0zFqLQAAOgAAIAogC/0AAAD9DA8PDw8PDw8PDw8PDw8PDw/9TiIC/YkB/akBIgP9GwBB8NMxai0AADoAASANIAP9GwFB8NMxai0AADoAASAOIAP9GwJB8NMxai0AADoAASAPIAP9GwNB8NMxai0AADoAASAQIAIgAv0NBAUGBwAAAAAAAAAAAAAAAP2JAf2pASID/RsAQfDTMWotAAA6AAEgESAD/RsBQfDTMWotAAA6AAEgEiAD/RsCQfDTMWotAAA6AAEgEyAD/RsDQfDTMWotAAA6AAEgFCACIAL9DQgJCgsAAAAAAAAAAAAAAAD9iQH9qQEiA/0bAEHw0zFqLQAAOgABIBUgA/0bAUHw0zFqLQAAOgABIBYgA/0bAkHw0zFqLQAAOgABIBcgA/0bA0Hw0zFqLQAAOgABIBggAiAC/Q0MDQ4PAAAAAAAAAAAAAAAA/YkB/akBIgL9GwBB8NMxai0AADoAASAZIAL9GwFB8NMxai0AADoAASAaIAL9GwJB8NMxai0AADoAASAbIAL9GwNB8NMxai0AADoAASAI/QwQAAAAEAAAABAAAAAQAAAAIgL9rgEhCCAHIAL9rgEhByAGIAL9rgEhBiAFIAL9rgEhBSAJQRBqIglBIEcNAAsLIAxBADoAAAu4BwMIfgF7Bn8jAEEgayIMJAAgAf0ABAAhCiAMIAA2AhAgDCABNgIMIAxB1M8xNgIIIAwgDEEIajYCGCAAQThqIg4gCv0WAEEBc61C/wGDIgJCBYYgAkIEhoUgAkIIhiACQgeGhYUiCSAK/RYHrYVCOIYiAkIDiCACQgSIhSACIAr9FgatIgNC/wGDIghCNYYgCEI0hoUgA0I4hiAK/RYFrUL/AYMiA0IthiADQiyGhSAK/RYErUL/AYMiBEIlhiAEQiSGhSAK/RYDrUL/AYMiBUIdhiAFQhyGhSAK/RYCrUL/AYMiBkIVhiAGQhSGhSAK/RYBrUL/AYMiB0INhiAHQgyGhSAHQhCGIAmEIAdCD4aFhSAGQhiGhCAGQheGhYUgBUIghoQgBUIfhoWFIARCKIaEIARCJ4aFhSADQjCGhCADQi+GhYWEIAhCN4aFhUIIiCIDhCACQgGIhYVCCIgiBCAK/RYJrYVCOIYiAkIDiCACQgSIhSACIAMgCv0WCK2FQjiGIgNCA4ggA0IEiIUgAyAEhCADQgGIhYVCCIgiA4QgAkIBiIWFQgiIIgQgCv0WC62FQjiGIgJCA4ggAkIEiIUgAiADIAr9FgqthUI4hiIDQgOIIANCBIiFIAMgBIQgA0IBiIWFQgiIIgOEIAJCAYiFhUIIiCIEIAr9Fg2thUI4hiICQgOIIAJCBIiFIAIgAyAK/RYMrYVCOIYiA0IDiCADQgSIhSADIASEIANCAYiFhUIIiCIDhCACQgGIhYVCCIgiBCAK/RYPrYVCOIYiAiADIAr9Fg6thUI4hiIDQgOIIANCBIiFIAMgBIQgA0IBiIWFQgiIhCACQgGIhSACQgOIhSACQgSIhSICIAxBCGoQ+AkhDwJAIAwoAhgiCyAMQQhqRgR/QRAFIAtFDQFBFAshDSALIAsoAgAgDWooAgARBgALIA9Bf0YEQCAAKAIsIQsgACgCMCENIABBLGogARD+CSANIAtrQQR1IQ8gACgCPEEBdEEBIAAoAjgiC3RLBEAgDhD5CSAOKAIAIQsLIAJCIIggAnwiA0L/////D4MiAiALrSIEiEIDfiACfCACIAtBAXStIgWIQgd+fCICIASIQgN+IAJ8IAIgBYhCB358p0EBdEEBciENIAKnIQFBfyALdEF/cyEOIAAoAkAhEANAIAEgDnEhCyABIA1qIQEgECALQQN0aiILKAIEQX9HDQALIAsgDzYCBCALIAM+AgAgACAAKAI8QQFqNgI8CyAMQSBqJAAgDwvuCwIEfgx/IwBBIGsiCyQAIAEoAgQiByABKAIAIghrQQxtIgatIAExAB0gATEAHiABNQIUIAE1AhBCAYUiAkI8hiACQj+GhSACQoGAgICAgICAIH6FIgJCA4iFIAJCAYiFIAJCBIiFIAKFIgJCP4YgAkI9hoUgAkI8hoUgAoUiAkIDiIUgAkIBiIUgAkIEiIUgAoUiAkI/hiACQj2GhSACQjyGhSAChSICQgOIhSACQgGIhSACQgSIhSAChSICQj+GIAJCPYaFIAJCPIaFIAKFIgJCA4iFIAJCAYiFIAJCBIiFIAKFIgJCP4YgAkI9hoUgAkI8hoUgAoUiAkIDiCACQgGIhSACQgSIhSAChSECIAcgCEcEQEEBIAYgBkEBTRshCUEAIQYDQCACIAggBkEMbGoiBzUCAIUiAkI/hiACQj2GhSACQjyGhSAChSICQgOIIAc1AgSFIAJCAYiFIAJCBIiFIAKFIgJCP4YgAkI9hoUgAkI8hoUgAoUiAkIDiCAHNQIIhSACQgGIhSACQgSIhSAChSICQj+GIAJCPYaFIAJCPIaFIAKFIgJCA4ggAkIBiIUgAkIEiIUgAoUhAiAGQQFqIgYgCUcNAAsLIAsgATYCDCALQfjPMTYCCCALIAA2AhAgCyALQQhqNgIYIABB2ABqIhAgAiALQQhqEPgJIQ0CQCALKAIYIgYgC0EIakYEf0EQBSAGRQ0BQRQLIQcgBiAGKAIAIAdqKAIAEQYACwJAAkACQAJAIA1Bf0cEQCABKAIEIAEoAgAiBmtBDEYEQCAGKAIERQ0CCyAAIAAoAhhBAWo2AhgMAQtBACEIIAFBADYCDCABQQxqIQ4gACgCTCEHIAEoAgAiDyABKAIEIgxHBEAgDyEGA0AgDiAIIAcgBigCBEEFdGooAgwiCSAHIAYoAghBBXRqKAIMIgogCSAKSxtBAWoiCSAIIAlLGyIINgIAIAZBDGoiBiAMRw0ACwsgACgCUCIJIAdrIghBBXUhDQJAIAAoAlQiBiAJSwRAIAlBADYCCCAJQgA3AgAgASgCBCIGIAEoAgAiCEcEQCAGIAhrIgZBDG1B1qrVqgFPDQQgCSAGEKIJIgc2AgQgCSAHNgIAIAkgBiAHaiIKNgIIIAYEQCAHIAggBvwKAAALIAkgCjYCBAsgCSAO/QACAP0LAgwgCSAOKAIQNgIcIAlBIGohCgwBCyANQQFqIgpBgICAwABPDQNB////PyAGIAdrIgZBBHUiASAKIAEgCksbIAZB4P///wdPGyIGQYCAgMAATw0EIAZBBXQiChCiCSIBIAhqIgZBADYCCCAGQgA3AgAgDCAPRwRAIAwgD2siCEEMbUHWqtWqAU8NAyAGIAgQogkiDDYCACAGIAggDGoiETYCCCAIBEAgDCAPIAj8CgAACyAGIBE2AgQLIAEgCmohDCAGIA79AAIA/QsCDCAGIA4oAhA2AhwgBkEgaiEKIAYgDUEFdGshASAHIAlHBEAgByEGIAEhCANAIAggBigCADYCACAIIAYoAgQ2AgQgCCAGKAIINgIIIAZBADYCCCAGQgA3AgAgCCAGKAIcNgIcIAggBv0AAgz9CwIMIAhBIGohCCAGQSBqIgYgCUcNAAsDQCAHKAIAIgYEQCAHIAY2AgQgBhArCyAHQSBqIgcgCUcNAAsgACgCTCEHCyAAIAw2AlQgACAKNgJQIAAgATYCTCAHRQ0AIAcQKwsgACAKNgJQIAAoAlxBAXRBASAAKAJYIgd0SwRAIBAQ+QkgECgCACEHCyACQiCIIAJ8IgNC/////w+DIgIgB60iBIhCA34gAnwgAiAHQQF0rSIFiEIHfnwiAiAEiEIDfiACfCACIAWIQgd+fKdBAXRBAXIhCCACpyEGQX8gB3RBf3MhCSAAKAJgIQoDQCAGIAlxIQcgBiAIaiEGIAogB0EDdGoiBygCBEF/Rw0ACyAHIA02AgQgByADPgIAIAAgACgCXEEBajYCXAsgC0EgaiQAIA0PCxCgCQALEKAJAAsQoAkAC7ECAQZ/IAEgACgCCCIDIAAoAgQiAmtBgAltTQRAIAAgAQR/IAFBgAlsQYAJayIBIAFBgAlwa0GACWoiAQRAIAJBACAB/AsACyABIAJqBSACCzYCBA8LAkAgAiAAKAIAIgVrIgJBgAltIAFqIgRBj8fjAUkEQEGOx+MBIAMgBWtBgAltIgNBAXQiBiAEIAQgBkkbIANBx+PxAE8bIgQEQCAEQY/H4wFPDQIgBEGACWwQngkhBwsgAiAHaiEDIAFBgAlsQYAJayIBIAFBgAlwa0GACWoiAQRAIANBACAB/AsACyADIAJBgHdtQYAJbGohBiACBEAgBiAFIAL8CgAACyAAIAcgBEGACWxqNgIIIAAgASADajYCBCAAIAY2AgAgBQRAIAUQKwsPCxCgCQALEKAJAAv2BQEJfyMAQUBqIgIkAANAQQAhAwNAIAEgASgCBCIEQQFqNgIEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwMgIAJCgICAgICAwAA3AzggAkF/NgI0IAIgBDYCMCABIAJBIGoQ4wkhBiACKAIgIgQEQCACIAQ2AiQgBBArCyACIANBAnRqIAY2AgAgA0EBaiIDQQhHDQALIAAgBUEFdGoiAyAC/QACAP0LAgAgAyAC/QACEP0LAhAgBUEBaiIFQTBHDQALIABBgBxqIQggAEGADGohCUEAIQUDQEEAIQMDQCABIAEoAgQiBEEBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDICACQoCAgICAgMAANwM4IAJBfzYCNCACIAQ2AjAgASACQSBqEOMJIQYgAigCICIEBEAgAiAENgIkIAQQKwsgAiADQQJ0aiAGNgIAIANBAWoiA0EIRw0ACyAJIAVBBXQiB2oiAyAC/QACAP0LAgAgAyACQRBqIgr9AAIA/QsCEEEAIQMDQCABIAEoAgQiBEEBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDICACQoCAgICAgMAANwM4IAJBfzYCNCACIAQ2AjAgASACQSBqEOMJIQYgAigCICIEBEAgAiAENgIkIAQQKwsgAiADQQJ0aiAGNgIAIANBAWoiA0EIRw0ACyAHIAhqIgMgAv0AAgD9CwIAIAMgCv0AAgD9CwIQIAVBAWoiBUHAAEcNAAsgAEGALGohB0EAIQUDQEEAIQMDQCABIAEoAgQiBEEBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDICACQoCAgICAgMAANwM4IAJBfzYCNCACIAQ2AjAgASACQSBqEOMJIQYgAigCICIEBEAgAiAENgIkIAQQKwsgAiADQQJ0aiAGNgIAIANBAWoiA0EIRw0ACyAHIAVBBXRqIgMgAv0AAgD9CwIAIAMgAv0AAhD9CwIQIAVBAWoiBUEIRw0ACyACQUBrJAAL5AEBA38jAEEgayICJAAgASABKAIEIgNBAWo2AgQgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAkKAgICAgIDAADcDGCACQX82AhQgAiADNgIQIAEgAhDjCSEEIAIoAgAiAwRAIAIgAzYCBCADECsLIAAgBDYCACABIAEoAgQiA0EBajYCBCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQoCAgICAgMAANwMYIAJBfzYCFCACIAM2AhAgASACEOMJIQMgAigCACIBBEAgAiABNgIEIAEQKwsgACADNgIEIAJBIGokAAuGAgEFfyAAKAIEIgIgACgCCCIDSQRAIAIgASkCADcCACACIAEoAgg2AgggACACQQxqNgIEDwsCQCACIAAoAgAiBWsiAkEMbUEBaiIEQdaq1aoBSQRAQdWq1aoBIAMgBWtBDG0iA0EBdCIGIAQgBCAGSRsgA0Gq1arVAE8bIgQEfyAEQdaq1aoBTw0CIARBDGwQogkFQQALIgYgAmoiAyABKQIANwIAIAMgASgCCDYCCCADIAJBdG1BDGxqIQEgAgRAIAEgBSAC/AoAAAsgACAGIARBDGxqNgIIIAAgA0EMaiICNgIEIAAgATYCACAFBEAgBRArCyAAIAI2AgQPCxCgCQALEKAJAAvDLANKfwJ+AXsjAEHA7ABrIgUkAEGAwAEQngkiDEEAQYDAAfwLACAAQQRqIQcgA0GALGohSyADQYAcaiFMIANBgAxqIU0gBUHQ6wBqITEgBUGg6wBqITIgBUHw6gBqITMgBUHA6gBqITQgBUGQ6gBqITUgBUHg6QBqITYgBUGw6QBqITcgBUGA6QBqITggBUHQ6ABqITkgBUGg6ABqITogBUHw5wBqITsgBUHA5wBqITwgBUGQ5wBqIT0gBUHg5gBqIT4gBUGw5gBqIT8gBUGA5gBqIUAgBUHQ5QBqIUEgBUGg5QBqIUIgBUHw5ABqIUMgBUHA5ABqIUQgBUGQ5ABqIUUgBUHg4wBqIUYgBUGw4wBqIUcgBUGA4wBqIUggBUHQ4gBqIUkgBUGg4gBqIQ0gBUHw4QBqIQ4gBUHA4QBqIQ8gBUGQ4QBqIRAgBUHg4ABqIREgBUGw4ABqIUogBUHQC2ohFCAFQaALaiEVIAVB8ApqIRYgBUHACmohFyAFQZAKaiEYIAVB4AlqIRkgBUGwCWohGiAFQYAJaiEbIAVB0AhqIRwgBUGgCGohHSAFQfAHaiEeIAVBwAdqIR8gBUGQB2ohICAFQeAGaiEhIAVBsAZqISIgBUGABmohIyAFQdAFaiEkIAVBoAVqISUgBUHwBGohJiAFQcAEaiEnIAVBkARqISggBUHgA2ohKSAFQbADaiEqIAVBgANqISsgBUHQAmohLCAFQaACaiEtIAVB8AFqIS4gBUHAAWohLyAFQZABaiEKIAVB4ABqIRIgBUEwaiEwA0AgAiALQYDAAWxqIQlBACEGA0AgBSAJIAZBgAxsIhNqIgRBoAlqKAIANgIgIAUgBEGQCWr9AAQA/QsEECAFIAT9AASACf0LBAAgMCAEQdAJaigCADYCICAwIARBwAlq/QAEAP0LBBAgMCAE/QAEsAn9CwQAIBIgBEGACmooAgA2AiAgEiAEQegJav0AAwD9CwMIIBIgBCkD4Ak3AwAgEiAEQfgJaikDADcDGCAKIARBoApqKQMANwMQIAogBEGwCmooAgA2AiAgCiAEKQOQCjcDACAKIARBmApqKQMANwMIIAogBEGoCmopAwA3AxggLyAEQeAKaigCADYCICAvIARB0Apq/QAEAP0LBBAgLyAE/QAEwAr9CwQAIC4gBEGQC2ooAgA2AiAgLiAEQYALav0ABAD9CwQQIC4gBP0ABPAK/QsEACAtIARBwAtqKAIANgIgIC0gBEGwC2r9AAQA/QsEECAtIAT9AASgC/0LBAAgLCAEQfALaigCADYCICAsIARB4Atq/QAEAP0LBBAgLCAE/QAE0Av9CwQAICsgBCgCoAY2AiAgKyAE/QAEkAb9CwQQICsgBP0ABIAG/QsEACAqIAT9AATABv0LBBAgKiAEKALQBjYCICAqIAT9AASwBv0LBAAgKSAEKAKABzYCICApIAT9AATwBv0LBBAgKSAE/QAE4Ab9CwQAICggBCgCsAc2AiAgKCAE/QAEoAf9CwQQICggBP0ABJAH/QsEACAnIAQoAuAHNgIgICcgBP0ABNAH/QsEECAnIAT9AATAB/0LBAAgJiAEQZAIaigCADYCICAmIARBgAhq/QAEAP0LBBAgJiAE/QAE8Af9CwQAICUgBEHACGooAgA2AiAgJSAEQbAIav0ABAD9CwQQICUgBP0ABKAI/QsEACAkIARB8AhqKAIANgIgICQgBEHgCGr9AAQA/QsEECAkIAT9AATQCP0LBAAgIyAEKAKgAzYCICAjIAT9AASQA/0LBBAgIyAE/QAEgAP9CwQAICIgBCgC0AM2AiAgIiAE/QAEwAP9CwQQICIgBP0ABLAD/QsEACAhIAQoAoAENgIgICEgBP0ABPAD/QsEECAhIAT9AATgA/0LBAAgICAEKAKwBDYCICAgIAT9AASgBP0LBBAgICAE/QAEkAT9CwQAIB8gBCgC4AQ2AiAgHyAE/QAE0AT9CwQQIB8gBP0ABMAE/QsEACAeIAQoApAFNgIgIB4gBP0ABIAF/QsEECAeIAT9AATwBP0LBAAgHSAEKALABTYCICAdIAT9AASwBf0LBBAgHSAE/QAEoAX9CwQAIBwgBCgC8AU2AiAgHCAE/QAE4AX9CwQQIBwgBP0ABNAF/QsEACAbIAQoAiA2AiAgGyAE/QAEEP0LBBAgGyAE/QAEAP0LBAAgGiAEKAJQNgIgIBogBEFAa/0ABAD9CwQQIBogBP0ABDD9CwQAIBkgBCgCgAE2AiAgGSAE/QAEcP0LBBAgGSAE/QAEYP0LBAAgGCAEKAKwATYCICAYIAT9AASgAf0LBBAgGCAE/QAEkAH9CwQAIBcgBCgC4AE2AiAgFyAE/QAE0AH9CwQQIBcgBP0ABMAB/QsEACAWIAQoApACNgIgIBYgBP0ABIAC/QsEECAWIAT9AATwAf0LBAAgFSAEKALAAjYCICAVIAT9AASwAv0LBBAgFSAE/QAEoAL9CwQAIBQgBCgC8AI2AiAgFCAE/QAE4AL9CwQQIBQgBP0ABNAC/QsEACAMIBNqIAVBgAz8CgAAIAZBAWoiBkEQRw0ACwJAIAtFBEBBACEJQQAhBgNAIAUgBmoiBP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBDAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBGAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBJABIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTAASAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AEgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBKACIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTQAiAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAMgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBKAFIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTwBCAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AUgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBMAEIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwSQBCAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAYgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBOADIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwSwAyAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAEQUBr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEcCAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAEgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBNABIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwSAAiAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAIgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBOACIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwSQAyAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAUgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBIAFIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTgBSAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AQgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBKAEIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwSQBiAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AMgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBMADIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTABiAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAYgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBOAGIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTwBiAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAcgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBKAHIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTAByAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AcgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBPAHIARBgAhq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAggBEGwCGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTQCCAEQeAIav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBIAJIARBkAlq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAkgBEHACWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIARB8Alq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AkgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBJAKIARBoApq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAogBEHQCmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwTwCiAEQYALav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBKALIARBsAtq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AsgBEHgC2r9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAZBgAxqIgZBgOAARw0ACwNAIAAoAgAhEyAFQZDgAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwSAYCBK/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBK/QwAAAAAAAAAAAAAAAAAAAAA/QsEEEIAIU4gEUIANwMAIBFCADcDECARQgA3AwggEUIANwMYIBBCADcDACAQQgA3AxAgEEIANwMIIBBCADcDGCAPQgA3AwAgD0IANwMQIA9CADcDCCAPQgA3AxggDkIANwMAIA5CADcDECAOQgA3AwggDkIANwMYIA1CADcDACANQgA3AxAgDUIANwMIIA1CADcDGCBJ/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBJ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBI/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBI/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBH/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBH/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBG/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBG/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBF/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBF/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBE/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBE/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBD/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBA/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBA/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA//QwAAAAAAAAAAAAAAAAAAAAA/QsEECA//QwAAAAAAAAAAAAAAAAAAAAA/QsEACA+/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA+/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA9/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA9/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA8/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA8/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA7/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA7/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA6/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA6/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA5/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA5/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA4/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA4/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA3/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA3/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA2/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA2/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA1/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA1/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA0/QwAAAAAAAAAAAAAAAAAAAAA/QsEECA0/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAz/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAz/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAy/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAy/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAx/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAx/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAJQQN0QZDRMWopAwAhTwNAIBMoAgQoAgAhBCAFIBMoAgD9AAQAIlD9CwSAbCAEIAVBgOwAahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOQbCAFQgA3A6hsIAVCfzcDoGwgBgRAIAVCADcCuGwgBSAGNgK0bCAFQZDsAGogBUG07ABqEOcJCyAEIAVBkOwAahDjCSEGIAUoApBsIgQEQCAFIAQ2ApRsIAQQKwsgBUGA4ABqIE6nQTBsaiIEIAY2AiAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgBP0MAAAAAAAAAAAAAAAAAAAAACBQIE8gTohCAYNQG/0LBAAgTkIBfCJOQiBSDQALIAUgCUGADGxqIAVBgOAAakGADPwKAAAgCUEBaiIJQQhHDQALIAAgDCAFIAMgTSBMIEsQlwoMAQtBgOAAEJ4JIgRBAEGA4AD8CwAgBSAHIAgQkwogBCAFQYAM/AoAACAFIAcgCEEgahCTCiAEQYAMaiAFQYAM/AoAACAFIAcgCEFAaxCTCiAEQYAYaiAFQYAM/AoAACAFIAcgCEHgAGoQkwogBEGAJGogBUGADPwKAAAgBSAHIAhBgAFqEJMKIARBgDBqIAVBgAz8CgAAIAUgByAIQaABahCTCiAEQYA8aiAFQYAM/AoAACAFIAcgCEHAAWoQkwogBEGAyABqIAVBgAz8CgAAIAUgByAIQeABahCTCiAEQYDUAGogBUGADPwKAAAgACAMIAQgAyALQYAubGoiBiAGQYAMaiAGQYAcaiAGQYAsahCXCiAEECsLIAMgC0GALmxqQYAsaiEIIAtBAWoiCyABRw0ACyAMECsgBUHA7ABqJAALigcDC38BewN+IwBBgO4AayIGJAAgBEGALGohDiABrSESA0AgBkGADGogACgCACIBIBFCAXwiExDqCUEAIQsgBiABQQBBCCADIAZBgAxqEJIKIAAoAgAgBhDuCSEKIAQgEadBgC5saiEPA0AgDyALQQV0IgFqQYAsaiEMIAEgDmohDSAGQYDsAGogAWohCEEAIQEDQCAAKAIAKAIEKAIAIQUCQCARUARAIA0gAUECdCIHaigCACEJIAYgBSgCAP0ABAD9CwSADCAHIAhqIAUgBkGADGogCiAJEPsJNgIADAELIAwgAUECdCIHaigCACEJIAYgBSgCAP0ABAD9CwSADCAFIAZBgAxqIAogCRD7CSEFIAcgCGoiByAAKAIAKAIEKAIAIAcoAgAgBRD8CTYCAAsgAUEBaiIBQQhHDQALIAtBAWoiC0EIRw0ACyATIhEgElINAAsgBkHQDmohByAGQaAOaiEJIAZB8A1qIQggBkHADWohCiAGQZANaiEMIAZB4AxqIQ0gBkGwDGohC0EAIQEDQCAGQYAMaiABaiIF/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAFIBD9CwQQIAEgC2oiBSAQ/QsEACAFIBD9CwQQIAEgDWoiBSAQ/QsEACAFIBD9CwQQIAEgDGoiBSAQ/QsEACAFIBD9CwQQIAEgCmoiBUIANwMAIAVCADcDECAFQgA3AwggBUIANwMYIAEgCGoiBUIANwMAIAVCADcDECAFQgA3AwggBUIANwMYIAEgCWoiBSAQ/QsEECAFIBD9CwQAIAEgB2oiBSAQ/QsEECAFIBD9CwQAIAFBgANqIgFBgOAARw0ACyAAQQRqIQpBACEIA0AgBiAKIAhBBXQiCSAGQYDsAGpqEJMKQQAhAQNAIAZBgAxqIAEgCWtBMGxqIgVBoNQAaiAGIAFBMGxqIgcoAiA2AgAgBUGQ1ABqIAf9AAQQ/QsEACAFQYDUAGogB/0ABAD9CwQAIAZBgAxqIAFBAXIiByAJa0EwbGoiBUGA1ABqIAYgB0EwbGoiB/0ABAD9CwQAIAVBkNQAaiAH/QAEEP0LBAAgBUGg1ABqIAcoAiA2AgAgAUECaiIBQSBHDQALIAhBAWoiCEEIRw0ACyAAKAIAIQdBACEBA0AgByABQTBsIgUgBkGADGpqIAIgBWoQ8AkgAUEBaiIBQYACRw0ACyAGQYDuAGokAAuADQIDfwF7IwBBQGoiAyQAIAEoAgQoAgAhBCADIAEoAgD9AAQAIgb9CwQAIAQgAxDiCSEFIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMQIANCADcDKCADQn83AyAgBQRAIANCADcCOCADIAU2AjQgA0EQaiADQTRqEOcJCyAEIANBEGoQ4wkhBSADKAIQIgQEQCADIAQ2AhQgBBArCyAAIAU2AiAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAP0MAAAAAAAAAAAAAAAAAAAAACAGIAJCAYNQG/0LBAAgASgCBCgCACEEIAMgASgCAP0ABAAiBv0LBAAgBCADEOIJIQUgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAxAgA0IANwMoIANCfzcDICAFBEAgA0IANwI4IAMgBTYCNCADQRBqIANBNGoQ5wkLIAQgA0EQahDjCSEFIAMoAhAiBARAIAMgBDYCFCAEECsLIAAgBTYCUCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEQCAA/QwAAAAAAAAAAAAAAAAAAAAAIAYgAkICg1Ab/QsEMCABKAIEKAIAIQQgAyABKAIA/QAEACIG/QsEACAEIAMQ4gkhBSAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDECADQgA3AyggA0J/NwMgIAUEQCADQgA3AjggAyAFNgI0IANBEGogA0E0ahDnCQsgBCADQRBqEOMJIQUgAygCECIEBEAgAyAENgIUIAQQKwsgACAFNgKAASAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEcCAA/QwAAAAAAAAAAAAAAAAAAAAAIAYgAkIEg1Ab/QsEYCABKAIEKAIAIQQgAyABKAIA/QAEACIG/QsEACAEIAMQ4gkhBSAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDECADQgA3AyggA0J/NwMgIAUEQCADQgA3AjggAyAFNgI0IANBEGogA0E0ahDnCQsgBCADQRBqEOMJIQUgAygCECIEBEAgAyAENgIUIAQQKwsgACAFNgKwASAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAEgAP0MAAAAAAAAAAAAAAAAAAAAACAGIAJCCINQG/0LBJABIAEoAgQoAgAhBCADIAEoAgD9AAQAIgb9CwQAIAQgAxDiCSEFIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMQIANCADcDKCADQn83AyAgBQRAIANCADcCOCADIAU2AjQgA0EQaiADQTRqEOcJCyAEIANBEGoQ4wkhBSADKAIQIgQEQCADIAQ2AhQgBBArCyAAIAU2AuABIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTQASAA/QwAAAAAAAAAAAAAAAAAAAAAIAYgAkIQg1Ab/QsEwAEgASgCBCgCACEEIAMgASgCAP0ABAAiBv0LBAAgBCADEOIJIQUgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAxAgA0IANwMoIANCfzcDICAFBEAgA0IANwI4IAMgBTYCNCADQRBqIANBNGoQ5wkLIAQgA0EQahDjCSEFIAMoAhAiBARAIAMgBDYCFCAEECsLIAAgBTYCkAIgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBIACIAD9DAAAAAAAAAAAAAAAAAAAAAAgBiACQiCDUBv9CwTwASABKAIEKAIAIQQgAyABKAIA/QAEACIG/QsEACAEIAMQ4gkhBSAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDECADQgA3AyggA0J/NwMgIAUEQCADQgA3AjggAyAFNgI0IANBEGogA0E0ahDnCQsgBCADQRBqEOMJIQUgAygCECIEBEAgAyAENgIUIAQQKwsgACAFNgLAAiAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAIgAP0MAAAAAAAAAAAAAAAAAAAAACAGIAJCwACDUBv9CwSgAiABKAIEKAIAIQQgAyABKAIA/QAEACIG/QsEACAEIAMQ4gkhASAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDECADQgA3AyggA0J/NwMgIAEEQCADQgA3AjggAyABNgI0IANBEGogA0E0ahDnCQsgBCADQRBqEOMJIQQgAygCECIBBEAgAyABNgIUIAEQKwsgACAENgLwAiAA/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AIgAP0MAAAAAAAAAAAAAAAAAAAAACAGIAJCgAGDUBv9CwTQAiADQUBrJAALng0DEX8CewF+IwBBgAFrIgckAEGAAxCeCSIOQQBBgAP8CwBBkAEQngkiC0EAQZAB/AsAIABBBGohCgNAIAooAgAoAgAhCCAHIAAoAgD9AAQAIhj9CwQAIAggBxDiCSEJIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwMwIAdCADcDSCAHQn83A0AgCQRAIAdCADcCZCAHIAk2AmAgB0EwaiAHQeAAahDnCQsgCCAHQTBqEOMJIQkgBygCMCIIBEAgByAINgI0IAgQKwsgCyAJNgIgIAv9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAv9DAAAAAAAAAAAAAAAAAAAAAAgGCAaQgGDUBv9CwQAIAooAgAoAgAhCCAHIAAoAgD9AAQAIhj9CwQAIAggBxDiCSEJIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwMwIAdCADcDSCAHQn83A0AgCQRAIAdCADcCZCAHIAk2AmAgB0EwaiAHQeAAahDnCQsgCCAHQTBqEOMJIQkgBygCMCIIBEAgByAINgI0IAgQKwsgCyAJNgJQIAv9DAAAAAAAAAAAAAAAAAAAAAD9CwRAIAv9DAAAAAAAAAAAAAAAAAAAAAAgGCAaQgKDUBv9CwQwIAooAgAoAgAhCCAHIAAoAgD9AAQAIhj9CwQAIAggBxDiCSEJIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwMwIAdCADcDSCAHQn83A0AgCQRAIAdCADcCZCAHIAk2AmAgB0EwaiAHQeAAahDnCQsgCCAHQTBqEOMJIQkgBygCMCIIBEAgByAINgI0IAgQKwsgCyAJNgKAASAL/QwAAAAAAAAAAAAAAAAAAAAA/QsEcCAL/QwAAAAAAAAAAAAAAAAAAAAAIBggGkIEg1Ab/QsEYCAHQTBqIABBAEEDIAsgARCSCiAOIBqnQTBsaiIIIAcoAlA2AiAgCCAHQUBr/QAEAP0LBBAgCCAH/QAEMP0LBAAgGkIBfCIaQghSDQALIAIgAyAFaiIKIAIgCkkbIRMgB0EQaiEQIAdBQGshDSAHQRBqIRFBACEDIABBBGohAQNAIAQgA0GAA2xqIRRBACEPA0AgASgCACgCACEKIAcgACgCAP0ABAD9CwRgIAogB0HgAGoQ4gkhCCAH/QwAAAAAAAAAAAAAAAAAAAAA/QsDACAHQgA3AxggB0J/NwMQIAgEQCAHQgA3AnggByAINgJ0IAcgB0H0AGoQ5wkLIAogBxDjCSEIIAcoAgAiCgRAIAcgCjYCBCAKECsLIAdBQGsiFf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBDAgByAINgJQIAYgD0EwbCISaiEWIAQgEmohF0EAIQoDQCAOIApBMGxqIQgCQCACIAUgCmwgA2oiCUsEQCAHIAAgCCAXIAlBgANsahCUCgJAAkACfyAHKQNAIAcpA0iEUARAIAchCCAHQTBqIQwgEAwBCyAHKQMQIAcpAxiEQgBSDQEgB0EwaiEIIAchDCANCyEJIAj9AAQAIAz9AAQA/VEhGCAIKAIgIQgMAQsgASgCACgCACANIAcoAlAQjQohCCABKAIAKAIAIBAgBygCIBCNCiEJIAEoAgAoAgAgCCAJEPwJIQggByAH/QAEACAH/QAEMP1R/QsEYCABKAIAKAIAIAggB0HgAGoQlQohCCAAKAIAIQn9DAAAAAAAAAAAAAAAAAAAAAAhGAsgCf0ABAAhGSAHIAg2AlAgByAZ/QsEQCAHIBj9CwQwDAELIAcgACAIIBYQlAoCQAJAAn8gBykDQCAHKQNIhFAEQCAHIQggB0EwaiEMIBEMAQsgBykDECAHKQMYhEIAUg0BIAdBMGohCCAHIQwgDQshCSAI/QAEACAM/QAEAP1RIRggCCgCICEIDAELIAEoAgAoAgAgDSAHKAJQEI0KIQggASgCACgCACARIAcoAiAQjQohCSABKAIAKAIAIAggCRD8CSEIIAcgB/0ABAAgB/0ABDD9Uf0LBGAgASgCACgCACAIIAdB4ABqEJUKIQggACgCACEJ/QwAAAAAAAAAAAAAAAAAAAAAIRgLIAn9AAQAIRkgByAINgJQIAcgGf0LBEAgByAY/QsEMAsgCkEBaiIKQQhHDQALIBIgFGoiCiAH/QAEMP0LBAAgCiAHKAJQNgIgIAogFf0ABAD9CwQQIA9BAWoiD0EIRw0ACyADQQFqIgMgE0cNAAsgCxArIA4QKyAHQYABaiQAC9cBAQp/IwBBgANrIgQkACAEQdACaiEHIARBoAJqIQggBEHwAWohCSAEQcABaiEKIARBkAFqIQsgBEHgAGohDCAEQTBqIQ0DQCAEIAAgAyAGajEAABDqCSAAIAIgBkGAA2xqIgUgBBDwCSAAIAVBMGogDRDwCSAAIAVB4ABqIAwQ8AkgACAFQZABaiALEPAJIAAgBUHAAWogChDwCSAAIAVB8AFqIAkQ8AkgACAFQaACaiAIEPAJIAAgBUHQAmogBxDwCSAGQQFqIgYgAUcNAAsgBEGAA2okAAvIBgIHfwJ7IwBB4ABrIgYkAEGAPBCeCSIHQQBBgDz8CwBBgDwQngkiCEEAQYA8/AsAQRQhCUEUIQogByEEA0AgBCACIApBAWsiCkGAA2xqIgX9AAQA/QsEACAEIAUoAiA2AiAgBCAF/QAEEP0LBBAgBCAFKAJQNgJQIARBQGsgBUFAa/0ABAD9CwQAIAQgBf0ABDD9CwQwIAQgBSgCgAE2AoABIAQgBf0ABHD9CwRwIAQgBf0ABGD9CwRgIAQgBSgCsAE2ArABIAQgBf0ABJAB/QsEkAEgBCAF/QAEoAH9CwSgASAEIAX9AATQAf0LBNABIAQgBf0ABMAB/QsEwAEgBCAFKALgATYC4AEgBCAF/QAEgAL9CwSAAiAEIAX9AATwAf0LBPABIAQgBSgCkAI2ApACIAQgBf0ABLAC/QsEsAIgBCAF/QAEoAL9CwSgAiAEIAUoAsACNgLAAiAEIAX9AATgAv0LBOACIAQgBf0ABNAC/QsE0AIgBCAFKALwAjYC8AIgBEGAA2ohBCAKDQALIAghBANAIAQgAyAJQQFrIglBgANsaiIF/QAEAP0LBAAgBCAFKAIgNgIgIAQgBf0ABBD9CwQQIAQgBSgCUDYCUCAEQUBrIAVBQGv9AAQA/QsEACAEIAX9AAQw/QsEMCAEIAUoAoABNgKAASAEIAX9AARw/QsEcCAEIAX9AARg/QsEYCAEIAUoArABNgKwASAEIAX9AASQAf0LBJABIAQgBf0ABKAB/QsEoAEgBCAF/QAE0AH9CwTQASAEIAX9AATAAf0LBMABIAQgBSgC4AE2AuABIAQgBf0ABIAC/QsEgAIgBCAF/QAE8AH9CwTwASAEIAUoApACNgKQAiAEIAX9AASwAv0LBLACIAQgBf0ABKAC/QsEoAIgBCAFKALAAjYCwAIgBCAF/QAE4AL9CwTgAiAEIAX9AATQAv0LBNACIAQgBSgC8AI2AvACIARBgANqIQQgCQ0ACyABQQBBoAEgBkEwaiAGIAggBxCWCiABKAIA/QAEACILIAb9AAQAEJoJIQwgACALIAb9AAQQEJoJ/QsEECAAIAwgC/1R/QsEACAAIAYoAiA2AiAgCBArIAcQKyAGQeAAaiQAC8EBAQN/IwBBMGsiAiQAIAAoAgQoAgAgAUEQaiABKAIgEI0KIQMgASkDACABKQMIhEIAUgRAIAAoAgQoAgAiBCABEOIJIQEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAkIANwMYIAJCfzcDECABBEAgAkIANwIoIAIgATYCJCACIAJBJGoQ5wkLIAQgAhDjCSEEIAIoAgAiAQRAIAIgATYCBCABECsLIAAoAgQoAgAgBCADEPwJIQMLIAJBMGokACADC+0CAQV/IwBBQGoiAiQAIAAoAkwiBiABQQV0aiIFKAIEIQMCQAJAIAUtAB5FIAUoAgAiBCADRnENAANAAkAgAyAEa0EMRw0AIAQoAgQNACAEKAIARQ0CIAYgBCgCCCIBQQV0aiIFKAIEIQMgBSgCACEEIAUtAB4NASADIARHDQEMAgsLIAJBADYCPCACQgA3AjQgAiABNgIwIAJCADcCKCACQTRqIAJBKGoQ5wkgAkEANgIQIAJCADcCCCACKAI4IgMgAigCNCIERwRAIAMgBGsiA0EMbUHWqtWqAU8NAiACIAMQogkiBTYCCCACIAMgBWoiATYCECADBEAgBSAEIAP8CgAACyACIAE2AgwLIAJCADcCICACQX82AhwgAkKAgICAcDcCFCAAIAJBCGoQ4wkhBSACKAIIIgMEQCACIAM2AgwgAxArCyAAKAJMIAVBBXRqQQE6AB8gBEUNACAEECsLIAJBQGskAA8LEKAJAAusAgIDfwJ7IwBBMGsiAyQAAkACQAJAIAEpAxAgASkDGIRQBEAgASEEDAELIAIpAxAgAikDGIRCAFINASACIQQgASECCyAC/QAEACEGIAT9AAQAIQcgAyAC/QAEEP0LBBAgAyAGIAf9Uf0LBAAgAyACKAIgNgIgDAELIAAoAgQoAgAgAUEQaiABKAIgEI0KIQQgACgCBCgCACACQRBqIAIoAiAQjQohBSAAKAIEKAIAIAQgBRD8CSEEIAMgAv0ABAAgAf0ABAD9Uf0LBAAgACgCBCgCACAEIAMQlQohAiAAKAIA/QAEACEGIAMgAjYCICADIAb9CwQQIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwQACyAAIAMQ7gkhAiAAKAIEKAIAIAIQ7wkgA0EwaiQAC+kYAwl/BHsCfiMAQdAFayIFJAAgBSAAKAIAIgcoAgD9AARA/QsEoAUgBygCBCgCACIGIAVBoAVqEOIJIQcgBf0MAAAAAAAAAAAAAAAAAAAAAP0LAzAgBUIANwNIIAVCfzcDQCAHBEAgBUIANwL0BCAFIAc2AvAEIAVBMGogBUHwBGoQ5wkLIAYgBUEwahDjCSEJIAUoAjAiBwRAIAUgBzYCNCAHECsLIAGtIRMDQCAAKAIAIgcoAgQoAgAhASAFIAcoAgD9AAQAIg79CwTwBCABIAVB8ARqEOIJIQYgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA6AFIAVCADcDuAUgBUJ/NwOwBSAGBEAgBUIANwI0IAUgBjYCMCAFQaAFaiAFQTBqEOcJCyABIAVBoAVqEOMJIQYgBSgCoAUiAQRAIAUgATYCpAUgARArCyAFIAY2AlAgBf0MAAAAAAAAAAAAAAAAAAAAAP0LBEAgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCAYNQG/0LBDAgBygCBCgCACEBIAUgBygCAP0ABAAiDv0LBPAEIAEgBUHwBGoQ4gkhBiAF/QwAAAAAAAAAAAAAAAAAAAAA/QsDoAUgBUIANwO4BSAFQn83A7AFIAYEQCAFQgA3AgQgBSAGNgIAIAVBoAVqIAUQ5wkLIAEgBUGgBWoQ4wkhBiAFKAKgBSIBBEAgBSABNgKkBSABECsLIAUgBjYCgAEgBf0MAAAAAAAAAAAAAAAAAAAAAP0LBHAgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCAoNQG/0LBGAgBygCBCgCACEBIAUgBygCAP0ABAAiDv0LBPAEIAEgBUHwBGoQ4gkhBiAF/QwAAAAAAAAAAAAAAAAAAAAA/QsDoAUgBUIANwO4BSAFQn83A7AFIAYEQCAFQgA3AgQgBSAGNgIAIAVBoAVqIAUQ5wkLIAEgBUGgBWoQ4wkhBiAFKAKgBSIBBEAgBSABNgKkBSABECsLIAUgBjYCsAEgBf0MAAAAAAAAAAAAAAAAAAAAAP0LBKABIAX9DAAAAAAAAAAAAAAAAAAAAAAgDiASQgSDUBv9CwSQASAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgLgASAF/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AEgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCCINQG/0LBMABIAcoAgQoAgAhASAFIAcoAgD9AAQAIg79CwTwBCABIAVB8ARqEOIJIQYgBf0MAAAAAAAAAAAAAAAAAAAAAP0LA6AFIAVCADcDuAUgBUJ/NwOwBSAGBEAgBUIANwIEIAUgBjYCACAFQaAFaiAFEOcJCyABIAVBoAVqEOMJIQYgBSgCoAUiAQRAIAUgATYCpAUgARArCyAFIAY2ApACIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwSAAiAF/QwAAAAAAAAAAAAAAAAAAAAAIA4gEkIQg1Ab/QsE8AEgBygCBCgCACEBIAUgBygCAP0ABAAiDv0LBPAEIAEgBUHwBGoQ4gkhBiAF/QwAAAAAAAAAAAAAAAAAAAAA/QsDoAUgBUIANwO4BSAFQn83A7AFIAYEQCAFQgA3AgQgBSAGNgIAIAVBoAVqIAUQ5wkLIAEgBUGgBWoQ4wkhBiAFKAKgBSIBBEAgBSABNgKkBSABECsLIAUgBjYCwAIgBf0MAAAAAAAAAAAAAAAAAAAAAP0LBLACIAX9DAAAAAAAAAAAAAAAAAAAAAAgDiASQiCDUBv9CwSgAiAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgLwAiAF/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AIgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCwACDUBv9CwTQAiAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgKgAyAF/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAMgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCgAGDUBv9CwSAAyAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgLQAyAF/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAMgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCgAKDUBv9CwSwAyAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgKABCAF/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AMgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCgASDUBv9CwTgAyAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgKwBCAF/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAQgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCgAiDUBv9CwSQBCAHKAIEKAIAIQEgBSAHKAIA/QAEACIO/QsE8AQgASAFQfAEahDiCSEGIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwOgBSAFQgA3A7gFIAVCfzcDsAUgBgRAIAVCADcCBCAFIAY2AgAgBUGgBWogBRDnCQsgASAFQaAFahDjCSEGIAUoAqAFIgEEQCAFIAE2AqQFIAEQKwsgBSAGNgLgBCAF/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AQgBf0MAAAAAAAAAAAAAAAAAAAAACAOIBJCgBCDUBv9CwTABEEAIQEgB0EAQQwgBUGgBWogBSAFQTBqIAIQlgogBCASp0GAA2wiB2ohCiADIAdqIQsgBSgCICEMIAX9AAQQIQ8gBf0ABAAhEANAIAAoAgAgCyABQTBsIgZqEO4JIQggACgCACIHKAIA/QAEACEOIAUgCDYCwAUgBSAO/QsEsAUgBf0MAAAAAAAAAAAAAAAAAAAAAP0LBKAFIAVBMGogByAFIAVBoAVqEJQKIAcgBUEwahDuCSEIIAcoAgD9AAQAIg4gEBCaCSERIAUgDDYCkAUgBSAOIA8Qmgn9CwSABSAFIBEgDv1R/QsE8AQgBSAJNgLABSAFIA79CwSwBSAF/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAUgBUEwaiAHIAVB8ARqIAVBoAVqEJQKIAcgBUEwahDuCSENIAUgBygCBCgCACAIIA0Q/Ak2AjAgACgCACAGIApqEO4JIQcgACgCACIGKAIEIAVBMGogBxD9CSEHIAYoAgQoAgAgBxDvCSABQQFqIgFBCEcNAAsgEkIBfCISIBNSDQALIAVB0AVqJAAL4AMCCH8BeyMAQRBrIgckACAAKAIAIgb9AAQQIQ4gByAG/QAEAP0LBAAgAEEEaiIIKAIAIQwgDBD6CSEKQQAhBgNAIAAgAyAGQTBsahDuCSEJIAcpAwAgBykDCIRCAFIEQCAIKAIAKAIAIgsgCiALIAdBACAJEPsJEPwJIQoLIAcgB/0ABAAgDhCaCf0LBAAgBkEBaiIGQYABRw0ACyAAQQRqIggoAgAoAgAgAiAEEPwJIQYgByAIKAIAKAIAIgkoAgD9AAQA/QsEACAJIAcgBiAKEPsJIQYgCCgCACABIAYQ/QkhBiAIKAIAKAIAIAYQ7wkgACgCACIG/QAEECEOIAcgBv0ABAD9CwQAIANBgDBqIQogCCgCACENIA0Q+gkhA0EAIQYDQCAAIAogBkEwbGoQ7gkhCSAHKQMAIAcpAwiEQgBSBEAgCCgCACgCACILIAMgCyAHQQAgCRD7CRD8CSEDCyAHIAf9AAQAIA4Qmgn9CwQAIAZBAWoiBkGAAUcNAAsgAEEEaiIGKAIAKAIAIAIgBRD8CSEAIAcgBigCACgCACIJKAIA/QAEAP0LBAAgCSAHIAAgAxD7CSEAIAYoAgAgAUEEaiAAEP0JIQAgBigCACgCACAAEO8JIAdBEGokAAuMHwIPfwF+IwBBQGoiByQAA0AgAUEMayEQIAFBEGshDyABQeAAayENIAFBQGohDiABQSBrIQsgACEGA0ACQAJAAkACQAJAAkACQAJAAkACQCABIAZrQQV1IgQOBgcHAAQBAgMLAkAgDygCACIEIAYoAhAiAEkNACAAIARJDQcgECgCACIEIAYoAhQiAEkNACAAIARJDQcgCyAGEP8JRQ0HCyAHQTBqIgQgBkEQaiIA/QAEAP0LBAAgByAG/QAEAP0LBCAgACALQRBqIgUpAwA3AwAgBiAL/QAEAP0LBAAgBSAEKQMANwMAIAsgBykDIDcDACALIAcpAyg3AwgMBgsgBiAGQSBqIAZBQGsgCxCJCgwFCyAGIAZBIGogBkFAayAGQeAAaiALEIoKDAQLIARBF0wEQCADQQFxBEAgASAGRg0FIAZBIGoiACABRg0FIAYhCgNAIAohBCAAIQoCQAJAIAQoAjAiACAEKAIQIgVJDQAgACAFSw0BIAQoAjQiACAEKAIUIgVJDQAgACAFSw0BIAogBBD/CUUNAQsgB0EwaiIMIApBEGoiAP0ABAD9CwQAIAcgCv0ABAD9CwQgIAogBP0ABAD9CwQAIAAgBCkDEDcDAAJAIAQgBiIARg0AIAcoAjQhCCAHKAIwIQUDQCAEIgBBIGshBAJAIAUgAEEQaygCACIJSQ0AIAUgCUsNAiAIIABBDGsoAgAiCUkNACAIIAlLDQIgB0EgaiAEEP8JRQ0CCyAAIAT9AAQA/QsEACAAIAQpAxA3AxAgBCAGRw0ACyAGIQALIAAgB/0ABCD9CwQAIAAgDCkDADcDEAsgCkEgaiIAIAFHDQALDAULIAEgBkYNBCAGQSBqIgQgAUYNBANAIAYhBSAEIQYCQAJAIAUoAjAiBCAFKAIQIgBJDQAgACAESQ0BIAUoAjQiBCAFKAIUIgBJDQAgACAESQ0BIAYgBRD/CUUNAQsgB0EwaiILIAYpAxAiEzcDACAHIAYpAxg3AzggByAG/QAEAP0LBCAgE6chCSAHKAI0IQwgBiEAA0AgACAFIgT9AAQA/QsEACAAIARBEGoiCikDADcDECAEQSBrIQUgCSAEIgBBEGsoAgAiCEkNAAJAIAggCUkNACAMIABBDGsoAgAiCEkNASAIIAxJDQAgB0EgaiAFEP8JDQELCyAEIAf9AAQg/QsEACAKIAspAwA3AwALIAZBIGoiBCABRw0ACwwECyACRQRAIAEgBkYNBCAEQQJrQQF2IgohAANAAkAgCiAAIglIDQAgBiAAQQV0aiEIIAYgAEEBdCIMQQFyIgVBBXRqIQACQCAMQQJqIgwgBE4NACAAQSBqIQsCQCAAKAIQIg0gACgCMCICSQ0AIAIgDUkNASAAKAIUIg0gACgCNCICSQ0AIAIgDUkNASAAIAsQ/wlFDQELIAshACAMIQULIAAoAhAiDCAIKAIQIgtJDQACQCALIAxJDQAgACgCFCIMIAgoAhQiC0kNASALIAxJDQAgACAIEP8JDQELIAdBMGoiDiAIQRBqIgz9AAQA/QsEACAHIAj9AAQA/QsEICAIIAD9AAQA/QsEACAMIAApAxA3AwACQCAFIApKDQAgBygCNCENIAcoAjAhDANAIAAhCCAGIAVBAXQiC0EBciIFQQV0aiEAAkAgC0ECaiILIARODQAgAEEgaiECAkAgACgCECIDIAAoAjAiD0kNACADIA9LDQEgACgCFCIDIAAoAjQiD0kNACADIA9LDQEgACACEP8JRQ0BCyACIQAgCyEFCyAMIAAoAhAiC0sEQCAIIQAMAgsCQCALIAxLDQAgDSAAKAIUIgtLBEAgCCEADAMLIAsgDUsNACAAIAdBIGoQ/wlFDQAgCCEADAILIAggAP0ABAD9CwQAIAggACkDEDcDECAFIApMDQALCyAAIAf9AAQg/QsEACAAIA4pAwA3AxALIAlBAWshACAJDQALA0AgB0EQaiIDIAb9AAQQ/QsEACAHIAb9AAQA/QsEACAEIgpBAmtBAXYhDEEAIQAgBiEEA0AgAEEBdCIJQQFyIQggBCIFIABBBXRqIgBBIGohBAJ/IAggCiAJQQJqIglMDQAaIABBQGshCwJAIAAoAjAiDSAAKAJQIgJJDQAgCCACIA1JDQEaIAAoAjQiDSAAKAJUIgBJDQAgCCAAIA1JDQEaIAggBCALEP8JRQ0BGgsgCyEEIAkLIQAgBSAE/QAEAP0LBAAgBSAEQRBqIgUpAwA3AxAgACAMTA0ACwJAIAFBIGsiASAERgRAIAQgB/0ABAD9CwQAIAUgAykDADcDAAwBCyAEIAH9AAQA/QsEACAFIAFBEGoiACkDADcDACABIAcpAwA3AwAgASAHKQMINwMIIAAgAykDADcDACAEIAZrQSBqQQV1IgBBAkgNAAJAIAYgAEECayIIQQF2IglBBXRqIgAoAhAiDCAEKAIQIgtJDQAgCyAMSQ0BIAAoAhQiDCAEKAIUIgtJDQAgCyAMSQ0BIAAgBBD/CUUNAQsgB0EwaiINIAX9AAQA/QsEACAHIAT9AAQA/QsEICAEIAD9AAQA/QsEACAFIAApAxA3AwACQCAIQQJJDQAgBygCNCELIAcoAjAhCANAIAAhBAJAIAYgCUEBayIFQQF2IglBBXRqIgAoAhAiDCAISQ0AIAggDEkEQCAEIQAMAwsgACgCFCIMIAtJDQAgCyAMSQRAIAQhAAwDCyAAIAdBIGoQ/wkNACAEIQAMAgsgBCAA/QAEAP0LBAAgBCAAKQMQNwMQIAVBAUsNAAsLIAAgB/0ABCD9CwQAIAAgDSkDADcDEAsgCkEBayEEIApBAkoNAAsMBAsgBiAEQQR0QWBxaiEAAkAgBEGBAU8EQCAGIAAgCxCLCiAGQSBqIABBIGsiBCAOEIsKIAZBQGsgAEEgaiIFIA0QiwogBCAAIAUQiwogB0EwaiIEIAZBEGoiBf0ABAD9CwQAIAcgBv0ABAD9CwQgIAUgAEEQaiIJKQMANwMAIAYgAP0ABAD9CwQAIAkgBCkDADcDACAAIAcpAyA3AwAgACAHKQMoNwMIDAELIAAgBiALEIsKCyACQQFrIQICQCADQQFxIhENACAGQRBrKAIAIgQgBigCECIASQ0AAkAgACAESQ0AIAZBDGsoAgAiBCAGKAIUIgBJDQEgACAESQ0AIAZBIGsgBhD/CQ0BCyAHIAYpAxg3AxggB0EQaiIDIAZBEGoiESkDACITNwMAIAcgBv0ABAD9CwQAIBOnIgUgDygCACIJSQ0FAkAgBSAJSw0AIAcoAhQiBCAQKAIAIgBJDQYgACAESQ0AIAcgCxD/CQ0GCyAGQSBqIgogAU8NBiAHKAIUIQwgBiEEA0AgBCEAIAohBCAAKAIwIgggBUsNBwJAIAUgCEsNACAAKAI0IgAgDEsEQAwJCyAAIAxJDQAgByAEEP8JRQ0ADAgLIARBIGoiCiABSQ0ACwwGCyAHQRBqIhAgBkEQaiISKQMAIhM3AwAgByAGKQMYNwMYIAcgBv0ABAD9CwQAIBOnIQAgBygCFCEJIAYhDQNAIA0iBEEgaiENIAQoAjAiBSAASQ0AAkAgACAFSQ0AIAQoAjQiBSAJSQ0BIAUgCUsNACANIAcQ/wkNAQsLIAQgBkYNASALIQ4gASEFIA8oAgAiCCAASQ0CA0AgBSEKIA4hBQJAIAAgCEkNACAJIApBDGsoAgAiCEsNBCAIIAlLDQAgBSAHEP8JRQ0ADAQLIAVBIGshDiAFQRBrKAIAIgggAE8NAAsMAgsgBiAGQSBqIAsQiwoMAgsgASEOIAEgDU0NACALIQ4gASEKIA8oAgAiCCAASQ0AA0AgDiEFAkACQCAAIAhJDQAgCSAKQQxrKAIAIghLDQMgCCAJSw0AIAUgBxD/CQRADAQLIAUgDUsNAQwDCyAFIA1LDQAgBSEODAILIAVBIGshDiAFIQogBUEQaygCACIIIABPDQALCyANIgAgDiIJSQRAA0AgB0EwaiIEIABBEGoiBf0ABAD9CwQAIAcgAP0ABAD9CwQgIAUgCSIIQRBqIgkpAwA3AwAgACAI/QAEAP0LBAAgCSAEKQMANwMAIAggBykDIDcDACAIIAcpAyg3AwggBygCFCEKIAcoAhAhBQNAIAAiBEEgaiEAIAQoAjAiCSAFSQ0AAkAgBSAJSQ0AIAQoAjQiCSAKSQ0BIAkgCksNACAAIAcQ/wkNAQsLIAhBIGshCQJAIAhBEGsoAgAiDCAFSQ0AA0AgCCELIAkhCAJAIAUgDEkNACAKIAtBDGsoAgAiCUsEQCAIIQkMAwsgCSAKSw0AIAggBxD/CUUNACAIIQkMAgsgCEEgayEJIAhBEGsoAgAiDCAFTw0ACwsgACAJSQ0ACwsgBCAGRwRAIAYgBP0ABAD9CwQAIBIgBCkDEDcDAAsgBCAH/QAEAP0LBAAgBCAQKQMANwMQIA0gDk8EQCAGIAQQjAohBSAEQSBqIgAgARCMCgRAIAQhASAGIQAgBUUNBgwCCyAFDQULIAYgBCACIBEQ8wkgBEEgaiEAQQAhAwwECyAHQUBrJAAPCyAGQSBqIQogBSAGKAIwIgBJDQAgBygCFCEMIAYhBANAIAQhCCAKIQQCQCAAIAVJDQAgCCgCNCIAIAxLDQIgACAMSQ0AIAcgBBD/CUUNAAwCCyAEQSBqIQogBSAEKAIwIgBPDQALCwJAIAogASIATw0AIAcoAhQhCCAAIQQDQCAEQSBrIQACQCAFIAlJDQAgBSAJSw0CIAggBEEMaygCACIJSQ0AIAggCUsNAiAHIAAQ/wlFDQILIARBMGsoAgAhCSAAIQQMAAsACyAAIApLBEADQCAHQTBqIgUgCiIEQRBqIgn9AAQA/QsEACAHIAT9AAQA/QsEICAJIABBEGoiCCkDADcDACAEIAD9AAQA/QsEACAIIAUpAwA3AwAgACAHKQMgNwMAIAAgBykDKDcDCCAEQSBqIQogBygCFCEIAkAgBygCECIFIAQoAjAiCUkNAANAIAQhDCAKIQQCQCAFIAlLDQAgDCgCNCIJIAhLDQIgCCAJSw0AIAcgBBD/CUUNAAwCCyAEQSBqIQogBSAEKAIwIglPDQALCwNAIAAiBEEgayEAIAUgBEEQaygCACIJSQ0AAkAgBSAJSw0AIAggBEEMaygCACIESQ0BIAQgCEkNACAHIAAQ/wkNAQsLIAAgCksNAAsLIApBIGsiBCAGRwRAIAYgBP0ABAD9CwQAIBEgBCkDEDcDAAsgBCAH/QAEAP0LBAAgBCADKQMANwMQQQAhAyAKIQYMAAsACwAL/x0CD38CfiMAQTBrIgYkAAJAA0AgAUHIAGshDCABQTBrIQ0gAUEYayEKIAAhBAJAA0ACQAJAAkACQCABIARrIgtBGG0iCQ4GBwcABQECAwsgCiAEEIQKRQ0GIAZBEGoiACAEQQhqIgUtAAA6AAAgBiAEKQIANwMIIAQoAhQhByAEQQA2AhQgBCkCDCETIARCADcCDCAEIAopAgA3AgAgBSAKQQhqIggtAAA6AAAgBCABQQxrIgUoAgA2AgwgBCABQQhrKAIANgIQIAQgAUEEayIJKAIANgIUIAggAC0AADoAACAKIAYpAwg3AgAgCSAHNgIAIAUgEzcCAAwGCyAEIARBGGogBEEwaiAKEIUKDAULIAQgBEEYaiAEQTBqIARByABqIAoQhgoMBAsgC0G/BEwEQCADQQFxBEAgASAERg0FIARBGGoiACABRg0FIAQhBQNAIAAiByAFEIQKBEAgBkEQaiIJIABBCGoiAC0AADoAACAGIAcpAgA3AwggBiAFKAIkIgs2AhQgBiAFKAIoIgo2AhggBiAFKAIsIgI2AhwgBUEANgIsIAVCADcCJCAHIAUpAgA3AgAgACAFLQAIOgAAIAcoAgwiAARAIAcgADYCECAAECsLIAcgBSgCDDYCDCAHIAUoAhA2AhAgByAFKAIUNgIUIAVBADYCFCAFQgA3AgwCQCAFIAQiAEYNACAGQQhqIAUiAEEYayIIEIQKRQ0AA0AgBSAIIgApAgA3AgAgBSAALQAIOgAIIAUgACgCDDYCDCAFIAAoAhA2AhAgBSAAKAIUNgIUIABBADYCFCAAQgA3AgwgACAERgRAIAQhAAwCCyAAIQUgBkEIaiAAQRhrIggQhAoNAAsLIAAgBikDCDcCACAAIAktAAA6AAggACACNgIUIAAgCjYCECAAIAs2AgwLIAciBUEYaiIAIAFHDQALDAULIAEgBEYNBCAEQRhqIgAgAUYNBANAIAAiByAEEIQKBEAgBkEQaiIIIABBCGoiAC0AADoAACAGIAcpAgA3AwggBiAEKAIkIgk2AhQgBiAEKAIoIgs2AhggBiAEKAIsIgo2AhwgBEEANgIsIARCADcCJCAHIAQpAgA3AgAgACAELQAIOgAAIAcoAgwiAARAIAcgADYCECAAECsLIAcgBCgCDDYCDCAHIAQoAhA2AhAgByAEKAIUNgIUIARBADYCFCAEQgA3AgwgBkEIaiAEQRhrIgUQhAoEQANAIAQgBSIAKQIANwIAIAQgAC0ACDoACCAEIAAoAgw2AgwgBCAAKAIQNgIQIAQgACgCFDYCFCAAQQA2AhQgAEIANwIMIAAhBCAGQQhqIABBGGsiBRCECg0ACwsgBCAGKQMINwIAIAQgCC0AADoACCAEIAo2AhQgBCALNgIQIAQgCTYCDAsgByIEQRhqIgAgAUcNAAsMBAsgAkUEQCABIARGDQQgCUECa0EBdiICIQADQAJAIAIgACIMSA0AIAQgAEEYbGohBSAEIABBAXQiAEEBciIIQRhsaiEHIAkgAEECaiIASgRAIAdBGGoiCiAHIAcgChCECiIDGyEHIAAgCCADGyEICyAHIAUQhAoNACAGQRBqIg4gBS0ACDoAACAGIAUpAgA3AwggBiAFKAIMIg82AhQgBiAFKAIQIhA2AhggBiAFKAIUIhE2AhwgBUEANgIUIAVCADcCDANAAkAgBSAHIgApAgA3AgAgBSAAQQhqIgMtAAA6AAggACkCDCETIAUgACgCFDYCFCAFIBM3AgwgAEEANgIUIABCADcCDCACIAhIDQAgBCAIQQF0IgVBAXIiCEEYbGohByAJIAVBAmoiBUoEQCAHQRhqIgogByAHIAoQhAoiDRshByAFIAggDRshCAsgACEFIAcgBkEIahCECkUNAQsLIAAgBikDCDcCACADIA4tAAA6AAAgACARNgIUIAAgEDYCECAAIA82AgwLIAxBAWshACAMDQALIAtBGG4hCwNAAkAgC0ECSA0AIAZBKGoiAyAELQAIOgAAIAYgBCkCADcDICAEKAIMIQwgBCgCECENIARCADcCDCAEKAIUIQ5BACEHIARBADYCFCALQQJrQQF2IQogBCEFA0AgB0EBdCIIQQFyIQkgBSAHQRhsaiIHQRhqIQACfyALIAhBAmoiCEwEQCAFIAApAgA3AgAgBSAALQAIOgAIIAkMAQsgBSAHQTBqIgcgACAAIAcQhAoiAhsiACkCADcCACAFIAAtAAg6AAggCCAJIAIbCyEHIAUgACgCDDYCDCAFIAAoAhA2AhAgBSAAKAIUNgIUIABBADYCFCAAQgA3AgwgACEFIAcgCkwNAAsgAUEYayIFIABGBEAgACAGKQMgNwIAIAAgAy0AADoACCAAIA42AhQgACANNgIQIAAgDDYCDAwBCyAAIAUpAgA3AgAgAEEIaiICIAVBCGoiBy0AADoAACAAIAFBDGsiCCgCADYCDCAAIAFBCGsiCSgCADYCECAAIAFBBGsiCigCADYCFCAHIAMtAAA6AAAgBSAGKQMgNwIAIAogDjYCACAJIA02AgAgCCAMNgIAIAAgBGtBGGoiBUEZSA0AIAQgBUEYbkECa0EBdiIHQRhsaiIIIAAQhApFDQAgBkEQaiIKIAItAAA6AAAgBiAAKQIANwMIIAYgACgCDCICNgIUIAYgACgCECIDNgIYIAYgACgCFCIMNgIcIABBADYCFCAAQgA3AgwDQAJAIAAgCCIFKQIANwIAIAAgBUEIaiIJLQAAOgAIIAUpAgwhEyAAIAUoAhQ2AhQgACATNwIMIAVBADYCFCAFQgA3AgwgB0UNACAFIQAgBCAHQQFrQQF2IgdBGGxqIgggBkEIahCECg0BCwsgBSAGKQMINwIAIAkgCi0AADoAACAFIAw2AhQgBSADNgIQIAUgAjYCDAsgAUEYayEBIAtBAkshACALQQFrIQsgAA0ACwwECyAEIAlBAXZBGGxqIQACQCALQYEYTwRAIAQgACAKEIcKIARBGGogAEEYayIFIA0QhwogBEEwaiAAQRhqIgcgDBCHCiAFIAAgBxCHCiAGQRBqIgUgBEEIaiIHLQAAOgAAIAYgBCkCADcDCCAEKAIUIQggBEEANgIUIAQpAgwhEyAEQgA3AgwgBCAAKQIANwIAIAcgAEEIaiIJLQAAOgAAIAQgACgCDDYCDCAEIAAoAhA2AhAgBCAAKAIUNgIUIAUtAAAhBSAGKQMIIRQgACAINgIUIAAgEzcCDCAAIBQ3AgAgCSAFOgAADAELIAAgBCAKEIcKCyACQQFrIQICQCADQQFxIg4NACAEQRhrIAQQhAoNACAGQRBqIgMgBEEIaiIRLQAAOgAAIAYgBCkCADcDCCAGIAQoAgwiDjYCFCAGIAQoAhAiDzYCGCAGIAQoAhQiEDYCHCAEQQA2AhQgBEIANwIMIAQhAAJAIAZBCGogChCECgRAA0AgBkEIaiAAQRhqIgAQhApFDQALDAELA0AgAEEYaiIAIAFPDQEgBkEIaiAAEIQKRQ0ACwsgASIFIABLBEADQCAGQQhqIAVBGGsiBRCECg0ACwsgACAFSQRAA0AgBkEoaiIHIABBCGoiCC0AADoAACAGIAApAgA3AyAgACgCFCEJIABBADYCFCAAKQIMIRMgAEIANwIMIAAgBSkCADcCACAIIAVBCGoiCy0AADoAACAAIAUoAgw2AgwgACAFKAIQNgIQIAAgBSgCFDYCFCALIActAAA6AAAgBSAGKQMgNwIAIAUgCTYCFCAFIBM3AgwDQCAGQQhqIABBGGoiABCECkUNAAsDQCAGQQhqIAVBGGsiBRCECg0ACyAAIAVJDQALCwJAIABBGGsiBSAERwRAIAQgBSkCADcCACARIAVBCGoiCC0AADoAACAEKAIMIgcEQCAEIAc2AhAgBxArIARBADYCFCAEQgA3AgwLIAQgAEEMayIHKAIANgIMIAQgAEEIaygCADYCECAEIABBBGsiCSgCADYCFCAJQQA2AgAgB0IANwIAIAggAy0AADoAACAFIAYpAwg3AgAMAQsgAEEMayIHKAIAIQQgBSADLQAAOgAIIAUgBikDCDcCACAERQ0AIABBCGsgBDYCACAEECsgB0EANgIACyAHIA42AgAgAEEEayAQNgIAIABBCGsgDzYCAEEAIQMgACEEDAELCyAGQRBqIg0gBEEIaiISLQAAOgAAIAYgBCkCADcDCCAGIAQoAgwiDzYCFCAGIAQoAhAiEDYCGCAGIAQoAhQiETYCHCAEQQA2AhQgBEIANwIMIAQhBwNAIAciAEEYaiIHIAZBCGoQhAoNAAsgASEIAkAgACAERgRAA0AgByAITw0CIAhBGGsiCCAGQQhqEIQKRQ0ACwwBCwNAIAhBGGsiCCAGQQhqEIQKRQ0ACwsgByIAIAgiBUkEQANAIAZBKGoiCSAAQQhqIgstAAA6AAAgBiAAKQIANwMgIAAoAhQhCiAAQQA2AhQgACkCDCETIABCADcCDCAAIAUpAgA3AgAgCyAFQQhqIgwtAAA6AAAgACAFKAIMNgIMIAAgBSgCEDYCECAAIAUoAhQ2AhQgDCAJLQAAOgAAIAUgBikDIDcCACAFIAo2AhQgBSATNwIMA0AgAEEYaiIAIAZBCGoQhAoNAAsDQCAFQRhrIgUgBkEIahCECkUNAAsgACAFSQ0ACwsCQCAAQRhrIgUgBEcEQCAEIAUpAgA3AgAgEiAFQQhqIgstAAA6AAAgBCgCDCIJBEAgBCAJNgIQIAkQKyAEQQA2AhQgBEIANwIMCyAEIABBDGsiCSgCADYCDCAEIABBCGsoAgA2AhAgBCAAQQRrIgooAgA2AhQgCkEANgIAIAlCADcCACALIA0tAAA6AAAgBSAGKQMINwIADAELIABBDGsiCSgCACELIAUgDS0AADoACCAFIAYpAwg3AgAgC0UNACAAQQhrIAs2AgAgCxArIAlBADYCAAsgCSAPNgIAIABBBGsgETYCACAAQQhrIBA2AgAgByAITwRAIAQgBRCICiEHIAAgARCICgRAIAUhASAEIQAgB0UNAwwECyAHDQILIAQgBSACIA4Q9AlBACEDDAELCyAEIARBGGogChCHCgsgBkEwaiQAC5ktAhd/An4jAEFAaiILJAAgC0EQaiERA0AgAUEQayEXIAFBGGshFSABQRxrIRYgAUHgAGshGCABQUBqIRkgAUEgayETIAAhCANAAkACQAJAAkACQAJAAkACQCABIAhrQQV1IgAOBgUFAAQBAgMLAkAgCCgCBCIEIBYoAgAiCkF/cyIFcSIGIAYgCCgCCCIHIBUoAgAiDUF/cyIJcyIAcSAHIAlxcyIGIAAgBCAFcyIFcXMgBmogAHMgBXFzIABzQQBODQAgBCAKRw0FIAcgDUcNBSATKAIAIgAgCCgCACIESQ0AIAAgBEsNBSAXIAhBEGoQ/wlFDQULIAtBMGoiACAIQRBqIgT9AAQA/QsEACALIAj9AAQA/QsEICAEIBNBEGoiB/0ABAD9CwQAIAggE/0ABAD9CwQAIAcgACkDADcDACATIAspAyA3AwAgEyALKQM4NwMYIBMgCykDKDcDCAwECyAIIAhBIGogCEFAayATEIAKDAMLIAggCEEgaiAIQUBrIAhB4ABqIBMQgQoMAgsgAEEXTARAIANBAXEEQCABIAhGDQMgCEEgaiIEIAFGDQMgC0EwaiERIAghDANAIAwhACAEIQwCQAJAIAAoAgQiByAAKAIkIg1Bf3MiBnEiCSAJIAAoAggiBSAAKAIoIg5Bf3MiCnMiBHEgBSAKcXMiCSAEIAYgB3MiBnFzIAlqIARzIAZxcyAEc0EATg0AIAcgDUcNASAFIA5HDQEgDCgCACIEIAAoAgAiB0kNACAEIAdLDQEgAEEwaiAAQRBqEP8JRQ0BCyARIAxBEGoiBP0ABAD9CwQAIAsgDP0ABAD9CwQgIAwgAP0ABAD9CwQAIAQgAP0ABBD9CwQAAkAgCCIEIABGDQAgCygCKCISQX9zIQkgCygCJCIPQX9zIQogCygCICEQA0AgACIEQSBrIQACQCAEQRxrKAIAIgUgCnEiDSANIARBGGsoAgAiBiAJcyIHcSAGIAlxcyINIAcgBSAKcyIOcXMgDWogB3MgDnFzIAdzQQBODQAgBSAPRw0CIAYgEkcNAiAQIAAoAgAiB0kNACAHIBBJDQIgESAEQRBrEP8JRQ0CCyAEIAD9AAQA/QsEACAEIAD9AAQQ/QsEECAAIAhHDQALIAghBAsgBCAL/QAEIP0LBAAgBCAR/QAEAP0LBBALIAxBIGoiBCABRw0ACwwDCyABIAhGDQIgCEEgaiIAIAFGDQIgC0EwaiEUA0AgCCEFIAAhCAJAAkAgBSgCBCIEIAUoAiQiDUF/cyIGcSIJIAkgBSgCCCIHIAUoAigiDkF/cyIKcyIAcSAHIApxcyIJIAAgBCAGcyIGcXMgCWogAHMgBnFzIABzQQBODQAgBCANRw0BIAcgDkcNASAIKAIAIgAgBSgCACIESQ0AIAAgBEsNASAFQTBqIAVBEGoQ/wlFDQELIBQgCP0ABBD9CwQAIAsgCCkDACIbNwMgIAsgCCkDCCIcNwMoIBynIhFBf3MhCiALKAIkIhJBf3MhDSAbpyEPIAghBwNAIAcgBSIA/QAEAP0LBAAgByAAQRBqIhD9AAQA/QsEECAAQSBrIQUgACEHIABBHGsoAgAiBiANcSIOIA4gAEEYaygCACIJIApzIgRxIAkgCnFzIg4gBCAGIA1zIgxxcyAOaiAEcyAMcXMgBHNBAE4NAAJAIAYgEkcNACAJIBFHDQAgDyAFKAIAIgRJDQEgBCAPSQ0AIBQgAEEQaxD/CQ0BCwsgACAL/QAEIP0LBAAgECAU/QAEAP0LBAALIAhBIGoiACABRw0ACwwCCyACRQRAIAEgCEYNAiALQTBqIRYgAEECa0EBdiIQIQQDQAJAIBAgBCIHSA0AIAggBEEFdGohBiAIIARBAXQiBUEBciIKQQV0aiEEAkAgACAFQQJqIgVMBEAgCiEFDAELAkAgBCgCJCINIAQoAgQiEUF/cyIMcSIPIA8gBCgCKCIOIAQoAggiFEF/cyIScyIJcSAOIBJxcyIPIAkgDCANcyIMcXMgD2ogCXMgDHFzIAlzQQBODQAgDSARRwRAIAohBQwCCyAOIBRHBEAgCiEFDAILIAQoAgAiCSAEKAIgIg1JDQAgCSANSwRAIAohBQwCCyAEQRBqIARBMGoQ/wkNACAKIQUMAQsgBEEgaiEECyAGKAIEIgogBCgCBCISQX9zIg5xIgwgDCAGKAIIIg0gBCgCCCIRQX9zIg9zIglxIA0gD3FzIgwgCSAKIA5zIg5xcyAMaiAJcyAOcXMgCXNBAE4NAAJAIAogEkcNACANIBFHDQAgBCgCACIJIAYoAgAiCkkNASAJIApLDQAgBEEQaiAGQRBqEP8JDQELIBYgBkEQaiIJ/QAEAP0LBAAgCyAG/QAEAP0LBCAgBiAE/QAEAP0LBAAgCSAE/QAEEP0LBAACQCAFIBBKDQAgCygCJCIJQX9zIREgCygCICEUIAsoAighDgNAIAQhDSAIIAVBAXQiBUEBciIKQQV0aiEEAkAgACAFQQJqIgVMBEAgCiEFDAELAkAgBCgCJCIMIAQoAgQiFUF/cyIScSITIBMgBCgCKCIPIAQoAggiA0F/cyICcyIGcSACIA9xcyITIAYgDCAScyIScXMgE2ogBnMgEnFzIAZzQQBODQAgDCAVRwRAIAohBQwCCyADIA9HBEAgCiEFDAILIAQoAgAiBiAEKAIgIgxJDQAgBiAMSwRAIAohBQwCCyAEQRBqIARBMGoQ/wkNACAKIQUMAQsgBEEgaiEECyAJIAQoAgQiBkF/c3EiDyAPIA4gBCgCCCIMcyIKQX9zIhJxIA4gDEF/c3FzIg8gEiAGIBFzcXMgD2ogCnMgBiAJc3JzIApzQQBOBEAgDSEEDAILAkAgBiAJRw0AIAwgDkcNACAUIAQoAgAiBksEQCANIQQMAwsgBiAUSw0AIARBEGogFhD/CUUNACANIQQMAgsgDSAE/QAEAP0LBAAgDSAE/QAEEP0LBBAgBSAQTA0ACwsgBCAL/QAEIP0LBAAgBCAW/QAEAP0LBBALIAdBAWshBCAHDQALIAtBMGohFQNAIAtBEGoiAiAI/QAEEP0LBAAgCyAI/QAEAP0LBAAgACIOQQJrQQF2IQxBACEEIAghAANAIARBAXQiBkEBciEJIAAiBSAEQQV0aiIHQSBqIQACfyAJIA4gBkECaiIGTA0AGiAHQUBrIRECQCAHKAJEIgogBygCJCIUQX9zIhBxIg8gDyAHKAJIIg0gBygCKCITQX9zIhJzIgRxIA0gEnFzIg8gBCAKIBBzIhBxcyAPaiAEcyAQcXMgBHNBAE4NACAJIAogFEcNARogCSANIBNHDQEaIAAoAgAiBCARKAIAIgpJDQAgCSAEIApLDQEaIAkgB0EwaiAHQdAAahD/CUUNARoLIBEhACAGCyEEIAUgAP0ABAD9CwQAIAUgAEEQaiIH/QAEAP0LBBAgBCAMTA0ACwJAIAFBIGsiASAARgRAIAAgC/0ABAD9CwQAIAcgAv0ABAD9CwQADAELIAAgAf0ABAD9CwQAIAcgAUEQaiIE/QAEAP0LBAAgASAL/QAEAP0LBAAgBCAC/QAEAP0LBAAgACAIa0EgakEFdSIEQQJIDQACQCAAKAIEIgYgCCAEQQJrIg9BAXYiDUEFdGoiBCgCBCISQX9zIgpxIgwgDCAAKAIIIgkgBCgCCCIRQX9zIhBzIgVxIAkgEHFzIgwgBSAGIApzIgpxcyAMaiAFcyAKcXMgBXNBAE4NACAGIBJHDQEgCSARRw0BIAQoAgAiBSAAKAIAIgZJDQAgBSAGSw0BIARBEGogBxD/CUUNAQsgFSAH/QAEAP0LBAAgCyAA/QAEAP0LBCAgACAE/QAEAP0LBAAgByAE/QAEEP0LBAACQCAPQQJJDQAgCygCJCIGQX9zIRIgCygCICERIAsoAighCQNAIAQhBQJAIAYgCCANQQFrIg9BAXYiDUEFdGoiBCgCBCIAQX9zcSIMIAwgCSAEKAIIIgpzIgdBf3MiEHEgCSAKQX9zcXMiDCAQIAAgEnNxcyAMaiAHcyAAIAZzcnMgB3NBAE4NACAAIAZHBEAgBSEEDAMLIAkgCkcEQCAFIQQMAwsgBCgCACIAIBFJDQAgACARSwRAIAUhBAwDCyAEQRBqIBUQ/wkNACAFIQQMAgsgBSAE/QAEAP0LBAAgBSAE/QAEEP0LBBAgD0EBSw0ACwsgBCAL/QAEIP0LBAAgBCAV/QAEAP0LBBALIA5BAWshACAOQQJKDQALDAILIAggAEEEdEFgcWohBAJAIABBgQFPBEAgCCAEIBMQggogCEEgaiAEQSBrIgAgGRCCCiAIQUBrIARBIGoiByAYEIIKIAAgBCAHEIIKIAtBMGoiACAIQRBqIgf9AAQA/QsEACALIAj9AAQA/QsEICAHIARBEGoiBf0ABAD9CwQAIAggBP0ABAD9CwQAIAUgACkDADcDACAEIAspAyA3AwAgBCALKQM4NwMYIAQgCykDKDcDCAwBCyAEIAggExCCCgsgAkEBayECAkAgA0EBcSIaDQAgCCgCBCIEIAhBHGsoAgAiCkF/cyIFcSIGIAYgCCgCCCIHIAhBGGsoAgAiDUF/cyIJcyIAcSAHIAlxcyIGIAAgBCAFcyIFcXMgBmogAHMgBXFzIABzQQBODQACQCAEIApHDQAgByANRw0AIAhBIGsoAgAiACAIKAIAIgRJDQEgACAESw0AIAhBEGsgCEEQahD/CQ0BCyARIAhBEGoiA/0ABAD9CwQAIAsgCCkDADcDACALIAgpAwgiGzcDCCAWKAIAIgkgCygCBCIPQX9zIgdxIgQgBCAVKAIAIgogG6ciEkF/cyIFcyIAcSAFIApxcyIEIAAgByAJcyIGcXMgBGogAHMgBnFzIABzQQBOBEAgCygCACEUDAQLAkAgCSAPRw0AIAogEkcNACALKAIAIhQgEygCACIASQ0EIAAgFEkNACARIBcQ/wkNBAsgCEEgaiIMIAFPDQQgCygCACEUIAghBANAIAQhBiAMIQQgBigCJCINIAdxIgwgDCAGKAIoIg4gBXMiAHEgBSAOcXMiDCAAIAcgDXMiEHFzIAxqIABzIBBxcyAAc0EATgRAIAQhDAwGCwJAIA0gD0cNACAOIBJHDQAgBCgCACIAIBRLBEAgBCEMDAcLIAAgFEkNACARIAZBMGoQ/wlFDQAgBCEMDAYLIARBIGoiDCABSQ0ACwwECyARIAhBEGoiFv0ABAD9CwQAIAsgCCkDACIbNwMAIAsgCCkDCCIcNwMIIBynIg1Bf3MhDiALKAIEIgZBf3MhDCAbpyEQIAghEwNAIBMiBEEgaiETIAYgBCgCJCIHQX9zcSIJIAkgBCgCKCIFIA5zIgBxIA0gBUF/c3FzIgkgACAHIAxzIgpxcyAJaiAAcyAKcXMgAHNBAE4NAAJAIAYgB0cNACAFIA1HDQAgEygCACIAIBBJDQEgACAQSw0AIARBMGogERD/CQ0BCwsgASEVAkAgBCAIRgRAIBMgASIATw0BA0AgAEEgayEVIAYgAEEcaygCACIFQX9zcSIKIAogAEEYaygCACIJIA5zIgdxIA0gCUF/c3FzIgogByAFIAxzIg9xcyAKaiAHcyAPcXMgB3NBAE4NAgJAIAUgBkcNACAJIA1HDQAgFSgCACIHIBBJDQMgByAQSw0AIABBEGsgERD/CQ0DIBMgFSIASQ0BDAMLIBMgFSIASQ0ACwwBCwNAIBUiB0EgayEVIAYgB0EcaygCACIFQX9zcSIKIAogB0EYaygCACIJIA5zIgBxIA0gCUF/c3FzIgogACAFIAxzIg9xcyAKaiAAcyAPcXMgAHNBAE4NASAFIAZHDQAgCSANRw0AIBUoAgAiACAQSQ0BIAAgEEsNACAHQRBrIBEQ/wlFDQALCyAVIg8gEyIHSwRAA0AgC0EwaiIAIAdBEGoiBP0ABAD9CwQAIAsgB/0ABAD9CwQgIAQgD0EQaiIF/QAEAP0LBAAgByAP/QAEAP0LBAAgBSAAKQMANwMAIA8gCykDIDcDACAPIAspAzg3AxggDyALKQMoNwMIIAsoAggiCkF/cyEMIAsoAgQiCUF/cyEQIAsoAgAhEgNAIAciBEEgaiEHIAkgBCgCJCIFQX9zcSINIA0gBCgCKCIGIAxzIgBxIAogBkF/c3FzIg0gACAFIBBzIg5xcyANaiAAcyAOcXMgAHNBAE4NAAJAIAUgCUcNACAGIApHDQAgBygCACIAIBJJDQEgACASSw0AIARBMGogERD/CQ0BCwsDQAJAIA8iBUEgayEPIAkgBUEcaygCACIGQX9zcSIOIA4gBUEYaygCACINIAxzIgBxIAogDUF/c3FzIg4gACAGIBBzIhRxcyAOaiAAcyAUcXMgAHNBAE4NACAGIAlHDQEgCiANRw0BIA8oAgAiACASSQ0AIAAgEksNASAFQRBrIBEQ/wlFDQELCyAHIA9JDQALCyAEIAhHBEAgCCAE/QAEAP0LBAAgFiAE/QAEEP0LBAALIAQgC/0ABAD9CwQAIAQgEf0ABAD9CwQQIBMgFU8EQCAIIAQQgwohByAEQSBqIgAgARCDCgRAIAQhASAIIQAgB0UNBwwDCyAHDQYLIAggBCACIBoQ9QkgBEEgaiEAQQAhAwwFCyAIIAhBIGogExCCCgsgC0FAayQADwsgCCEMA0AgDCIEQSBqIQwgBCgCJCIGIAdxIg4gDiAEKAIoIg0gBXMiAHEgBSANcXMiDiAAIAYgB3MiEHFzIA5qIABzIBBxcyAAc0EATg0BIAYgD0cNACANIBJHDQAgFCAMKAIAIgBJDQEgACAUSQ0AIBEgBEEwahD/CUUNAAsLAkAgDCABIgZPDQAgCygCACEQIAYhAANAIABBIGshBgJAIAcgCXEiDSANIAUgCnMiBHEgBSAKcXMiDSAEIAcgCXMiDnFzIA1qIARzIA5xcyAEc0EATg0AIAkgD0cNAiAKIBJHDQIgECAGKAIAIgRJDQAgBCAQSQ0CIBEgAEEQaxD/CUUNAgsgAEE4aygCACEKIABBPGsoAgAhCSAGIQAMAAsACyAGIAxLBEADQCALQTBqIgAgDEEQaiIE/QAEAP0LBAAgCyAM/QAEAP0LBCAgBCAGQRBqIgf9AAQA/QsEACAMIAb9AAQA/QsEACAHIAApAwA3AwAgBiALKQMgNwMAIAYgCykDODcDGCAGIAspAyg3AwggCygCCCISQX9zIQcgCygCBCIPQX9zIQUgCygCACEQA0ACQCAMIgRBIGohDCAEKAIkIgkgBXEiDSANIAQoAigiCiAHcyIAcSAHIApxcyINIAAgBSAJcyIOcXMgDWogAHMgDnFzIABzQQBODQAgCSAPRw0BIAogEkcNASAQIAwoAgAiAEkNACAAIBBJDQEgESAEQTBqEP8JRQ0BCwsDQCAGIgRBIGshBiAEQRxrKAIAIgkgBXEiDSANIARBGGsoAgAiCiAHcyIAcSAHIApxcyINIAAgBSAJcyIOcXMgDWogAHMgDnFzIABzQQBODQACQCAJIA9HDQAgCiASRw0AIBAgBigCACIASQ0BIAAgEEkNACARIARBEGsQ/wkNAQsLIAYgDEsNAAsLIAxBIGsiACAIRwRAIAggAP0ABAD9CwQAIAMgAP0ABBD9CwQACyAAIAv9AAQA/QsEACAAIBH9AAQA/QsEEEEAIQMgDCEIDAALAAsAC/wMAQZ/IwBBkAFrIgIkACACQQA6AIQBIAJBADYCgAEgAkG7zwE7ARwgAkHqkpi/BjYCGCACQa4BOgAeIAJBhfkAOwAfIAJB7gA6ACEgAkHz5QE7ASIgAkGlAToAJCACQc/qAzsAJSACQTo6ACcgAkHRHDsBKCACQdIAOgAqIAJBBToALSACQf+2AjsAKyACQR86ADAgAkHomAI7AS4gAiACQRhqIgQ2AhQgAkGDswM7ADEgAkGrAToAMyACKAIUIgNBzQE6AB4gA0HbwAM7ABwgAigCFCIDQgA3ACAgA0EZOgAfIAJBBGoiA0EANgAAIAJBADYAASACQQI6AAAgAkEUaiACQQgQqgkgA0EANgAAIAJBADYAASACQYABOgAAIAJBFGogAkEIEKoJIAEoAgAhAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAgQhAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAgghAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAgwhAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAhAhAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAhQhAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAhghAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAhwhAyACQQA2AAQgAiADQRh2OgADIAIgA0EQdjoAAiACIANBCHY6AAEgAiADOgAAIAJBFGogAkEIEKoJIAEoAiAiAyABKAIkIgdHBEADQCADKAIAIQFBACEFIAJBADYAjAEgAiABQRh2OgCLASACIAFBEHY6AIoBIAIgAUEIdjoAiQEgAiABOgCIASACQRRqIAJBiAFqQQgQqgkgAygCBCEBIAJBADYAjAEgAiABQRh2OgCLASACIAFBEHY6AIoBIAIgAUEIdjoAiQEgAiABOgCIASACQRRqIAJBiAFqQQgQqgkgAygCCCgCACEBIAJBADYAjAEgAiABQRh2OgCLASACIAFBEHY6AIoBIAIgAUEIdjoAiQEgAiABOgCIASACQRRqIAJBiAFqQQgQqgkgAygCCCIBKAIABEADQCAFQQV0IgYgASgCBGooAgAhASACQQA2AIwBIAIgAUEYdjoAiwEgAiABQRB2OgCKASACIAFBCHY6AIkBIAIgAToAiAEgAkEUaiACQYgBakEIEKoJIAMoAggoAgQgBmooAgQhASACQQA2AIwBIAIgAUEYdjoAiwEgAiABQRB2OgCKASACIAFBCHY6AIkBIAIgAToAiAEgAkEUaiACQYgBakEIEKoJIAMoAggoAgQgBmooAgghASACQQA2AIwBIAIgAUEYdjoAiwEgAiABQRB2OgCKASACIAFBCHY6AIkBIAIgAToAiAEgAkEUaiACQYgBakEIEKoJIAIgAygCCCgCBCAGav0ABBD9CwQAIAJBFGogAkEQEKoJIAVBAWoiBSADKAIIIgEoAgBJDQALCyADQQxqIgMgB0cNAAsLIAAgAkEUaiACQUBrAn8gAi0AhAFFBEAgAigCgAEMAQsgAkHqkpi/BjYCGCACIAQ2AhQgBEGuAToABiAEQbvPATsABCACKAIUIgFB7gA6AAkgAUGF+QA7AAcgAigCFCIBQaUBOgAMIAFB8+UBOwAKIAIoAhQiAUE6OgAPIAFBz+oDOwANIAIoAhQiAUHSADoAEiABQdEcOwAQIAIoAhQiAUEFOgAVIAFB/7YCOwATIAIoAhQiAUEfOgAYIAFB6JgCOwAWIAIoAhQiAUGrAToAGyABQYOzAzsAGSACKAIUIgFBzQE6AB4gAUHbwAM7ABwgAigCFCIBQgA3ACAgAUEZOgAfIAJBADoAhAEgAkEANgKAAUEACxCrCSACQZABaiQAC4oCAgZ/AXsCQCAAKAKcEyIBRQ0AIAAoAtQFIgIEQCAAKALYBSABIAIRAwAMAQsgARArCyAAQZwTaiEBAkAgACgCrBMiAEUNACAAQRBqIQJBASEDIAAgACgCECIFTwRAIAAgACgCFE8hAwsgACgCnCYhBiAAKAKYJiEEIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAJBADYCKCACQgA3AiAgAiAH/QsCEAJAAkAgBQRAIARFDQEgBiAFIAQRAwALIANFDQIgBEUNASAGIAAgBBEDAAwCCyAFECsgA0UNAQsgABArCyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsCACABQQA2AiAgASAH/QsCEAuEAgIJfwN+IwBBEGsiBSQAQX8hBgJAIAAoAggiByABQiCIIAF8IgxC/////w+DIgEgACgCACIDrSINiEIDfiABfCABIANBAXStIg6IQgd+fCIBpyIIQX8gA3RBf3MiCXFBA3RqIgMoAgQiBEF/Rg0AIAEgDYhCA34gAXwgASAOiEIHfnynQQF0QQFyIQogDKchCwJAA0ACQCALIAMoAgBGBEAgBSAENgIMIAIoAhAiBEUNASAEIAVBDGogBCgCACgCGBEFAA0DIAAoAgghBwsgByAIIApqIgggCXFBA3RqIgMoAgQiBEF/Rw0BDAMLCxCgCQALIAMoAgQhBgsgBUEQaiQAIAYL3QMCC38DfiAAIAAoAgBBAWoiAjYCACACQR1JBEBBCCACdCIDEKIJIgdBASACdEEDdGohBCAHIQECQCADQQhrIgVBOHFBOEcEQCAFQQN2QQFqQQdxIQhBACEDA0AgAUKAgICAcDcCACABQQhqIQEgA0EBaiIDIAhHDQALIAVBOEkNAQsDQCABQoCAgIBwNwI4IAFCgICAgHA3AjAgAUKAgICAcDcCKCABQoCAgIBwNwIgIAFCgICAgHA3AhggAUKAgICAcDcCECABQoCAgIBwNwIIIAFCgICAgHA3AgAgAUFAayIBIARHDQALCyAAIAQ2AhAgACgCCCEGIAAgBzYCCCAAKAIMIQkgACAENgIMIAYgCUcEQEF/IAJ0QX9zIQggAkEBdK0hDSAAKAIEIQogAq0hDiAGIQIDQCACKAIEIgVBf0cEQCACKAIAIgutIgwgDohCA34gDHwgDCANiEIHfnwiDCAOiEIDfiAMfCAMIA2IQgd+fKdBAXRBAXIhBCAMpyEBA0AgASAIcSEDIAEgBGohASAHIANBA3RqIgMoAgRBf0cNAAsgAyAFNgIEIAMgCzYCACAAIApBAWoiCjYCBAsgAkEIaiICIAlHDQALCyAGBEAgBhArCw8LEKAJAAujAQECfyMAQUBqIgEkACAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAAKAIAIgIgARDiCSEAIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwMQIAFCADcDKCABQn83AyAgAARAIAFCADcCOCABIAA2AjQgAUEQaiABQTRqEOcJCyACIAFBEGoQ4wkhAiABKAIQIgAEQCABIAA2AhQgABArCyABQUBrJAAgAguNAwEFfyMAQTBrIgQkACAAKAJMIgggAkEFdGoiBigCBCEHAkAgBi0AHkUgBigCACIFIAdGcQ0AA0AgAiEGIAMhAgJAIAcgBWtBDEcNACAFKAIEIgcgBSgCCCIDckUEQCAEIAH9AAQAIAAoAiwgBSgCAEEEdGr9AAQAEJoJ/QsEICAAIARBIGogAhCNCiECDAMLIAcNACAEIAH9AAQAIAAoAiwgBSgCAEEEdGr9AAQAEJoJ/QsEICAAIARBIGogAyACEPsJIQIMAgsgCCACQQV0aiIDKAIEIQcgAy0AHkUgAygCACIFIAdGcQ0BIAcgBWtBDEYEQCAGIQMgBSgCBEUNAQsLIAAgARDiCSEFIAT9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIARCADcDGCAEQn83AxAgBQRAIAQgBTYCICAEIAYgAiACIAZJGzYCKCAEIAIgBiACIAZJGzYCJCAEIARBIGoQ5wkLIAAgBBDjCSECIAQoAgAiBUUNACAEIAU2AgQgBRArCyAEQTBqJAAgAgvBCgIMfwF+IwBBkAFrIgMkAAJAAkAgACgCTCIFIAFBBXRqIgQtAB5FBEAgBCgCACAEKAIERg0BCwJAIAUgAkEFdGoiBS0AHg0AIAUoAgAgBSgCBEcNACABIQIMAQsCQCAEKAIMIgQgBSgCDCIFSQRAIAMgACgCAP0ABAD9CwRwIAAgA0HwAGpBACABEPsJIQEMAQsgBCAFTQ0AIAMgACgCAP0ABAD9CwRwIAAgA0HwAGpBACACEPsJIQILAkAgACgCTCIFIAFBBXRqIgQtAB5BAUYEQCAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDcCADQgA3A4gBIANCfzcDgAEgAyABNgJYIANCATcCUCADQfAAaiADQdAAahDnCSAAKAJMIQUMAQsgA0EANgJ4IANCADcCcCAEKAIEIgEgBCgCACIGRwRAIAEgBmsiAUEMbUHWqtWqAU8NAyADIAEQogkiBzYCcCADIAEgB2oiCDYCeCABBEAgByAGIAH8CgAACyADIAg2AnQLIAMgBCgCHDYCjAEgAyAE/QACDP0LAnwLAkAgBSACQQV0aiIBLQAeQQFGBEAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LA1AgA0IANwNoIANCfzcDYCADIAI2AiggA0IBNwIgIANB0ABqIANBIGoQ5wkMAQsgA0EANgJYIANCADcCUCABKAIEIgIgASgCACIERwRAIAIgBGsiAkEMbUHWqtWqAU8NAyADIAIQogkiBTYCUCADIAIgBWoiBjYCWCACBEAgBSAEIAL8CgAACyADIAY2AlQLIAMgASgCHDYCbCADIAH9AAIM/QsCXAtBACECIANBADYCTCADQgA3AkQCQCADKAJ0IgkgAygCcCIFRgRAQQAhAQwBC0EAIQEgAygCVCIEIAMoAlAiCkYNACAEIAprQQxtIQ0gCSAFa0EMbSEOA0AgCiABQQxsaiIGKAIEIQcgBSACQQxsaiIEKAIEIQgCQAJAIAQoAggiCyAGKAIIIgxHDQAgByAIRw0AIANBQGsgBCgCCDYCACADIAQpAgAiDzcDOCADIAAoAiwiBCAGKAIAQQR0av0ABAAgBCAPp0EEdGr9AAQA/VH9CwQgIAMgACADQSBqEOIJIgQ2AjggAUEBaiEBIAJBAWohAgwBCwJAAkAgCyAMTwRAIAsgDEsNASAHIAhNDQELIAJBAWohAgwBCyABQQFqIQEgBiEECyADQUBrIAQoAgg2AgAgAyAEKQIAIg83AzggD6chBAsgBARAIANBxABqIANBOGoQ5wkLIAIgDk8NASABIA1JDQALCyAJIAVrIgRBDG0iCCACSwRAIARBDG0hBwNAIAchBCAFIAJBDGxqIgYoAgAEfyADQcQAaiAGEOcJIAgFIAQLIAJBAWoiAksNAAsLIAMoAlQgAygCUCIGayICQQxtIgggAUsEQCACQQxtIQcDQCAHIQIgBiABQQxsaiIEKAIABH8gA0HEAGogBBDnCSAIBSACCyABQQFqIgFLDQALCyADQQA2AgggA0IANwIAIAMoAkgiASADKAJEIgJHBEAgASACayIBQQxtQdaq1aoBTw0CIAMgARCiCSIENgIAIAMgASAEaiIHNgIIIAEEQCAEIAIgAfwKAAALIAMgBzYCBAsgA0IANwIYIANBfzYCFCADQoCAgIBwNwIMIAIEQCACECsLIAYEQCADIAY2AlQgBhArIAMoAnAhBQsgBQRAIAUQKwsgACADEOMJIQIgAygCACIBRQ0AIAMgATYCBCABECsLIANBkAFqJAAgAg8LEKAJAAvPAQEDfyMAQUBqIgMkACADIAAoAgAiBCgCAP0ABAD9CwQAIAQgAxDiCSEFIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMQIANCADcDKCADQn83AyAgBQRAIANCADcCOCADIAU2AjQgA0EQaiADQTRqEOcJCyAEIANBEGoQ4wkhBSADKAIQIgQEQCADIAQ2AhQgBBArCyADIAAoAgAiBCgCAP0ABAD9CwQQIAQgA0EQaiAFIAIQ+wkhBCAAKAIAIAEoAgAgBBD8CSEAIANBQGskACAAC/IBAQZ/IAAoAgQiAiAAKAIIIgNJBEAgAiAB/QAEAP0LBAAgACACQRBqNgIEDwsCQCACIAAoAgAiBGsiAkEEdSIHQQFqIgVBgICAgAFJBEBB/////wAgAyAEayIDQQN1IgYgBSAFIAZJGyADQfD///8HTxsiAwR/IANBgICAgAFPDQIgA0EEdBCeCQVBAAsiBSACaiIGIAH9AAQA/QsEACAGIAdBBHRrIQEgAgRAIAEgBCAC/AoAAAsgACAFIANBBHRqNgIIIAAgBkEQaiICNgIEIAAgATYCACAEBEAgBBArCyAAIAI2AgQPCxCgCQALEKAJAAvDAwECfyAALQAAIgIgAS0AACIDSQRAQQEPCwJAIAIgA0sNACAALQABIgIgAS0AASIDSQRAQQEPCyACIANLDQAgAC0AAiICIAEtAAIiA0kEQEEBDwsgAiADSw0AIAAtAAMiAiABLQADIgNJBEBBAQ8LIAIgA0sNACAALQAEIgIgAS0ABCIDSQRAQQEPCyACIANLDQAgAC0ABSICIAEtAAUiA0kEQEEBDwsgAiADSw0AIAAtAAYiAiABLQAGIgNJBEBBAQ8LIAIgA0sNACAALQAHIgIgAS0AByIDSQRAQQEPCyACIANLDQAgAC0ACCICIAEtAAgiA0kEQEEBDwsgAiADSw0AIAAtAAkiAiABLQAJIgNJBEBBAQ8LIAIgA0sNACAALQAKIgIgAS0ACiIDSQRAQQEPCyACIANLDQAgAC0ACyICIAEtAAsiA0kEQEEBDwsgAiADSw0AIAAtAAwiAiABLQAMIgNJBEBBAQ8LIAIgA0sNACAALQANIgIgAS0ADSIDSQRAQQEPCyACIANLDQAgAC0ADiICIAEtAA4iA0kEQEEBDwsgAiADSw0AIAAtAA8iACABLQAPIgFHIAAgAUlxDwtBAAvSBQEKfyMAQSBrIgckACAAIAEgAhCCCgJAAkAgAigCBCIGIAMoAgQiC0F/cyIJcSIIIAggAigCCCIFIAMoAggiDEF/cyIKcyIEcSAFIApxcyIIIAQgBiAJcyIJcXMgCGogBHMgCXFzIARzQQBODQAgBiALRw0BIAUgDEcNASADKAIAIgQgAigCACIGSQ0AIAQgBksNASADQRBqIAJBEGoQ/wlFDQELIAdBEGoiBCACQRBqIgb9AAQA/QsEACAHIAL9AAQA/QsEACAGIANBEGoiBf0ABAD9CwQAIAIgA/0ABAD9CwQAIAUgBP0ABAD9CwQAIAMgB/0ABAD9CwQAAkAgASgCBCIFIAIoAgQiDEF/cyIIcSIKIAogASgCCCIJIAIoAggiDUF/cyILcyIDcSAJIAtxcyIKIAMgBSAIcyIIcXMgCmogA3MgCHFzIANzQQBODQAgBSAMRw0BIAkgDUcNASACKAIAIgMgASgCACIFSQ0AIAMgBUsNASACQRBqIAFBEGoQ/wlFDQELIAQgAUEQaiID/QAEAP0LBAAgByAB/QAEAP0LBAAgAyAG/QAEAP0LBAAgASAC/QAEAP0LBAAgBiAE/QAEAP0LBAAgAiAH/QAEAP0LBAACQCAAKAIEIgMgASgCBCIIQX9zIgZxIgUgBSAAKAIIIgQgASgCCCIKQX9zIglzIgJxIAQgCXFzIgUgAiADIAZzIgZxcyAFaiACcyAGcXMgAnNBAE4NACADIAhHDQEgBCAKRw0BIAEoAgAiAiAAKAIAIgNJDQAgAiADSw0BIAFBEGogAEEQahD/CUUNAQsgB0EQaiICIABBEGoiA/0ABAD9CwQAIAcgAP0ABAD9CwQAIAMgAUEQaiIE/QAEAP0LBAAgACAB/QAEAP0LBAAgBCACKQMANwMAIAEgBykDADcDACABIAcpAxg3AxggASAHKQMINwMICyAHQSBqJAALswcBCn8jAEEgayIIJAAgACABIAIgAxCACgJAAkAgAygCBCIHIAQoAgQiDEF/cyIJcSIKIAogAygCCCIFIAQoAggiDUF/cyILcyIGcSAFIAtxcyIKIAYgByAJcyIJcXMgCmogBnMgCXFzIAZzQQBODQAgByAMRw0BIAUgDUcNASAEKAIAIgYgAygCACIHSQ0AIAYgB0sNASAEQRBqIANBEGoQ/wlFDQELIAhBEGoiBiADQRBqIgf9AAQA/QsEACAIIAP9AAQA/QsEACAHIARBEGoiBf0ABAD9CwQAIAMgBP0ABAD9CwQAIAUgBv0ABAD9CwQAIAQgCP0ABAD9CwQAAkAgAigCBCIFIAMoAgQiDUF/cyIKcSILIAsgAigCCCIJIAMoAggiDkF/cyIMcyIEcSAJIAxxcyILIAQgBSAKcyIKcXMgC2ogBHMgCnFzIARzQQBODQAgBSANRw0BIAkgDkcNASADKAIAIgQgAigCACIFSQ0AIAQgBUsNASADQRBqIAJBEGoQ/wlFDQELIAYgAkEQaiIE/QAEAP0LBAAgCCAC/QAEAP0LBAAgBCAH/QAEAP0LBAAgAiAD/QAEAP0LBAAgByAG/QAEAP0LBAAgAyAI/QAEAP0LBAACQCABKAIEIgQgAigCBCIKQX9zIgdxIgUgBSABKAIIIgYgAigCCCILQX9zIglzIgNxIAYgCXFzIgUgAyAEIAdzIgdxcyAFaiADcyAHcXMgA3NBAE4NACAEIApHDQEgBiALRw0BIAIoAgAiAyABKAIAIgRJDQAgAyAESw0BIAJBEGogAUEQahD/CUUNAQsgCEEQaiIEIAFBEGoiBv0ABAD9CwQAIAggAf0ABAD9CwQAIAYgAkEQaiID/QAEAP0LBAAgASAC/QAEAP0LBAAgAyAE/QAEAP0LBAAgAiAI/QAEAP0LBAACQCAAKAIEIgIgASgCBCIMQX9zIgVxIgkgCSAAKAIIIgcgAUEIaiILKAIAIg1Bf3MiCnMiA3EgByAKcXMiCSADIAIgBXMiBXFzIAlqIANzIAVxcyADc0EATg0AIAIgDEcNASAHIA1HDQEgASgCACIDIAAoAgAiAkkNACACIANJDQEgAUEQaiAAQRBqEP8JRQ0BCyAEIABBEGoiA/0ABAD9CwQAIAggAP0ABAD9CwQAIAMgBv0ABAD9CwQAIAAgAf0ABAD9CwQAIAYgBCkDADcDACABIAgpAwA3AwAgASAIKQMYNwMYIAsgCCkDCDcDAAsgCEEgaiQAC6EJAQt/IwBBIGsiBiQAAkACQCAAKAIEIgcgASgCBCIEQX9zIglxIgogCiAAKAIIIgggASgCCCIFQX9zIgtzIgNxIAggC3FzIgogAyAHIAlzIglxcyAKaiADcyAJcXMgA3NBAE4NAAJAIAQgB0cNACAFIAhHDQAgASgCACIDIAAoAgAiB0kNASADIAdLDQAgAUEQaiAAQRBqEP8JDQELAkAgBCACKAIEIgpBf3MiB3EiCCAIIAUgAigCCCILQX9zIglzIgNxIAUgCXFzIgggAyAEIAdzIgdxcyAIaiADcyAHcXMgA3NBAE4NACAEIApHDQIgBSALRw0CIAIoAgAiAyABKAIAIgRJDQAgAyAESw0CIAJBEGogAUEQahD/CUUNAgsgBkEQaiIDIAFBEGoiBP0ABAD9CwQAIAYgAf0ABAD9CwQAIAQgAkEQaiIF/QAEAP0LBAAgASAC/QAEAP0LBAAgBSAD/QAEAP0LBAAgAiAG/QAEAP0LBAACQCAAKAIEIgUgASgCBCIMQX9zIghxIgkgCSAAKAIIIgcgAUEIaiILKAIAIg1Bf3MiCnMiAnEgByAKcXMiCSACIAUgCHMiCHFzIAlqIAJzIAhxcyACc0EATg0AIAUgDEcNAiAHIA1HDQIgASgCACICIAAoAgAiBUkNACACIAVLDQIgAUEQaiAAQRBqEP8JRQ0CCyADIABBEGoiAv0ABAD9CwQAIAYgAP0ABAD9CwQAIAIgBP0ABAD9CwQAIAAgAf0ABAD9CwQAIAQgAykDADcDACABIAYpAwA3AwAgASAGKQMYNwMYIAsgBikDCDcDAAwBCwJAAkAgBCACKAIEIgpBf3MiB3EiCCAIIAUgAigCCCILQX9zIglzIgNxIAUgCXFzIgggAyAEIAdzIgdxcyAIaiADcyAHcXMgA3NBAE4NACAEIApHDQEgBSALRw0BIAIoAgAiAyABKAIAIgRJDQAgAyAESw0BIAJBEGogAUEQahD/CUUNAQsgBkEQaiIBIABBEGoiA/0ABAD9CwQAIAYgAP0ABAD9CwQAIAMgAkEQaiIE/QAEAP0LBAAgACAC/QAEAP0LBAAgBCABKQMANwMAIAIgBikDADcDACACIAYpAxg3AxggAiAGKQMINwMIDAELIAZBEGoiAyAAQRBqIgX9AAQA/QsEACAGIAD9AAQA/QsEACAFIAFBEGoiBP0ABAD9CwQAIAAgAf0ABAD9CwQAIAQgA/0ABAD9CwQAIAEgBv0ABAD9CwQAAkAgASgCBCIFIAIoAgQiC0F/cyIIcSIJIAkgASgCCCIHIAIoAggiDEF/cyIKcyIAcSAHIApxcyIJIAAgBSAIcyIIcXMgCWogAHMgCHFzIABzQQBODQAgBSALRw0BIAcgDEcNASACKAIAIgAgASgCACIFSQ0AIAAgBUsNASACQRBqIAFBEGoQ/wlFDQELIAMgBP0ABAD9CwQAIAYgAf0ABAD9CwQAIAQgAkEQaiIA/QAEAP0LBAAgASAC/QAEAP0LBAAgACADKQMANwMAIAIgBikDADcDACACIAYpAxg3AxggAiAGKQMINwMICyAGQSBqJAAL/AYBEH8jAEEgayIFJABBASEEAkACQAJAAkACQAJAIAEgAGtBBXUOBgUFAAECAwQLIAFBIGshAwJAIAAoAgQiBiABQRxrKAIAIgxBf3MiCHEiCSAJIAAoAggiByABQRhrKAIAIg1Bf3MiCnMiAnEgByAKcXMiCSACIAYgCHMiCHFzIAlqIAJzIAhxcyACc0EATg0AIAYgDEcNBSAHIA1HDQUgAygCACICIAAoAgAiBkkNACACIAZLDQUgAUEQayAAQRBqEP8JRQ0FCyAFQRBqIgIgAEEQaiIG/QAEAP0LBAAgBSAA/QAEAP0LBAAgBiADQRBqIgf9AAQA/QsEACAAIAP9AAQA/QsEACAHIAIpAwA3AwAgAyAFKQMANwMAIAMgBSkDGDcDGCADIAUpAwg3AwgMBAsgACAAQSBqIAFBIGsQggoMAwsgACAAQSBqIABBQGsgAUEgaxCACgwCCyAAIABBIGogAEFAayAAQeAAaiABQSBrEIEKDAELIAAgAEEgaiAAQUBrIgMQggogAEHgAGoiAiABRg0AIAVBEGohDgNAAkACQCADKAIEIgQgAiILKAIEIgpBf3MiB3EiCCAIIAMoAggiBiACKAIIIgxBf3MiCXMiAnEgBiAJcXMiCCACIAQgB3MiB3FzIAhqIAJzIAdxcyACc0EATg0AIAQgCkcNASAGIAxHDQEgCygCACICIAMoAgAiBEkNACACIARLDQEgC0EQaiADQRBqEP8JRQ0BCyAOIAtBEGoiAv0ABAD9CwQAIAUgC/0ABAD9CwQAIAIgA/0ABBD9CwQAIAsgA/0ABAD9CwQAIAUoAggiEEF/cyEIIAUoAgQiEUF/cyEJIAUoAgAhDQJAA0AgAyICQSBrIQMCQCACQRxrKAIAIgYgCXEiCiAKIAJBGGsoAgAiByAIcyIEcSAHIAhxcyIKIAQgBiAJcyIMcXMgCmogBHMgDHFzIARzQQBODQAgBiARRw0CIAcgEEcNAiANIAMoAgAiBEkNACAEIA1JDQIgDiACQRBrEP8JRQ0CCyACIAP9AAQA/QsEACACIAP9AAQQ/QsEECAAIANHDQALIAAhAgsgAiAF/QAEAP0LBAAgAiAO/QAEAP0LBBAgD0EBaiIPQQhHDQAgC0EgaiABRiEEDAILIAsiA0EgaiICIAFHDQALQQEhBAsgBUEgaiQAIAQLtAIBC38gASgCACECAkAgACgCACIDQX9HBEAgAiADSyECDAELIAJBf0cEQEEAIQIMAQsgASgCECABKAIMIgxrQQV1IQYCQCAAKAIQIgIgACgCDCILRgRADAELIAIgC2tBBXUiByEIIAYhCQNAIAlFDQFBASECIAsgCEEBayIIQQV0aiIDKAIQIgQgDCAJQQFrIglBBXRqIgUoAhAiCkkNAiAEIApLBEBBACECDAMLIAMoAhQiBCAFKAIUIgpJDQIgBCAKTQRAIAMgBRD/CQ0DCyAFKAIUIgIgAygCFCIESQRAQQAhAgwDCyACIARNBEBBACECIAUgAxD/CQ0DCyAIDQALCyAGIAdLBEBBASECDAELIAYgB0kEQEEAIQIMAQsgAS0ACCAALQAIQQFzcSECCyACQQFxC+8DAgV/AX4jAEEQayIEJAAgACABIAIQhwoCQCADIAIQhApFDQAgBEEIaiIFIAJBCGoiBi0AADoAACAEIAIpAgA3AwAgAigCFCEHIAJBADYCFCACKQIMIQkgAkIANwIMIAIgAykCADcCACAGIANBCGoiCC0AADoAACACIAMoAgw2AgwgAiADKAIQNgIQIAIgAygCFDYCFCAIIAUtAAA6AAAgAyAEKQMANwIAIAMgBzYCFCADIAk3AgwgAiABEIQKRQ0AIAUgAUEIaiIDLQAAOgAAIAQgASkCADcDACABKAIUIQcgAUEANgIUIAEpAgwhCSABQgA3AgwgASACKQIANwIAIAMgBi0AADoAACABIAIoAgw2AgwgASACKAIQNgIQIAEgAigCFDYCFCAGIAUtAAA6AAAgAiAEKQMANwIAIAIgBzYCFCACIAk3AgwgASAAEIQKRQ0AIARBCGoiAiAAQQhqIgMtAAA6AAAgBCAAKQIANwMAIAAoAhQhBSAAQQA2AhQgACkCDCEJIABCADcCDCAAIAEpAgA3AgAgAyABQQhqIgYtAAA6AAAgACABKAIMNgIMIAAgASgCEDYCECAAIAEoAhQ2AhQgBiACLQAAOgAAIAEgBCkDADcCACABIAU2AhQgASAJNwIMCyAEQRBqJAALhAUCBX8BfiMAQRBrIgUkACAAIAEgAiADEIUKAkAgBCADEIQKRQ0AIAVBCGoiBiADQQhqIgctAAA6AAAgBSADKQIANwMAIAMoAhQhCCADQQA2AhQgAykCDCEKIANCADcCDCADIAQpAgA3AgAgByAEQQhqIgktAAA6AAAgAyAEKAIMNgIMIAMgBCgCEDYCECADIAQoAhQ2AhQgCSAGLQAAOgAAIAQgBSkDADcCACAEIAg2AhQgBCAKNwIMIAMgAhCECkUNACAGIAJBCGoiBC0AADoAACAFIAIpAgA3AwAgAigCFCEIIAJBADYCFCACKQIMIQogAkIANwIMIAIgAykCADcCACAEIActAAA6AAAgAiADKAIMNgIMIAIgAygCEDYCECACIAMoAhQ2AhQgByAGLQAAOgAAIAMgBSkDADcCACADIAg2AhQgAyAKNwIMIAIgARCECkUNACAFQQhqIgMgAUEIaiIELQAAOgAAIAUgASkCADcDACABKAIUIQYgAUEANgIUIAEpAgwhCiABQgA3AgwgASACKQIANwIAIAQgAkEIaiIHLQAAOgAAIAEgAigCDDYCDCABIAIoAhA2AhAgASACKAIUNgIUIAcgAy0AADoAACACIAUpAwA3AgAgAiAGNgIUIAIgCjcCDCABIAAQhApFDQAgAyAAQQhqIgItAAA6AAAgBSAAKQIANwMAIAAoAhQhBiAAQQA2AhQgACkCDCEKIABCADcCDCAAIAEpAgA3AgAgAiAELQAAOgAAIAAgASgCDDYCDCAAIAEoAhA2AhAgACABKAIUNgIUIAQgAy0AADoAACABIAUpAwA3AgAgASAGNgIUIAEgCjcCDAsgBUEQaiQAC6UGAgZ/AX4jAEEQayIDJAAgASAAEIQKIQUgAiABEIQKIQQCQCAFRQRAIARFDQEgA0EIaiIFIAFBCGoiBC0AADoAACADIAEpAgA3AwAgASgCFCEGIAFBADYCFCABKQIMIQkgAUIANwIMIAEgAikCADcCACAEIAJBCGoiBy0AADoAACABIAIoAgw2AgwgASACKAIQNgIQIAEgAigCFDYCFCAHIAUtAAA6AAAgAiADKQMANwIAIAIgBjYCFCACIAk3AgwgASAAEIQKRQ0BIAUgAEEIaiICLQAAOgAAIAMgACkCADcDACAAKAIUIQYgAEEANgIUIAApAgwhCSAAQgA3AgwgACABKQIANwIAIAIgBC0AADoAACAAIAEoAgw2AgwgACABKAIQNgIQIAAgASgCFDYCFCAEIAUtAAA6AAAgASADKQMANwIAIAEgBjYCFCABIAk3AgwMAQsgBARAIANBCGoiASAAQQhqIgUtAAA6AAAgAyAAKQIANwMAIAAoAhQhBCAAQQA2AhQgACkCDCEJIABCADcCDCAAIAIpAgA3AgAgBSACQQhqIgYtAAA6AAAgACACKAIMNgIMIAAgAigCEDYCECAAIAIoAhQ2AhQgBiABLQAAOgAAIAIgAykDADcCACACIAQ2AhQgAiAJNwIMDAELIANBCGoiBSAAQQhqIgQtAAA6AAAgAyAAKQIANwMAIAAoAgwhBiAAKAIQIQcgAEIANwIMIAAoAhQhCCAAQQA2AhQgACABKQIANwIAIAQgAUEIaiIELQAAOgAAIAAgASgCDDYCDCAAIAEoAhA2AhAgACABKAIUNgIUIAQgBS0AADoAACABIAMpAwA3AgAgASAINgIUIAEgBzYCECABIAY2AgwgAiABEIQKRQ0AIAUgBC0AADoAACADIAEpAgA3AwAgAUEANgIUIAFCADcCDCABIAIpAgA3AgAgBCACQQhqIgAtAAA6AAAgASACKAIMNgIMIAEgAigCEDYCECABIAIoAhQ2AhQgACAFLQAAOgAAIAIgAykDADcCACACIAg2AhQgAiAHNgIQIAIgBjYCDAsgA0EQaiQAC+4EAgp/AX4jAEEgayIEJABBASECAkACQAJAAkACQAJAIAEgAGtBGG0OBgUFAAECAwQLIAFBGGsiBSAAEIQKRQ0EIARBEGoiBiAAQQhqIgMtAAA6AAAgBCAAKQIANwMIIAAoAhQhByAAQQA2AhQgACkCDCEMIABCADcCDCAAIAUpAgA3AgAgAyAFQQhqIggtAAA6AAAgACABQQxrIgMoAgA2AgwgACABQQhrKAIANgIQIAAgAUEEayIBKAIANgIUIAggBi0AADoAACAFIAQpAwg3AgAgASAHNgIAIAMgDDcCAAwECyAAIABBGGogAUEYaxCHCgwDCyAAIABBGGogAEEwaiABQRhrEIUKDAILIAAgAEEYaiAAQTBqIABByABqIAFBGGsQhgoMAQsgACAAQRhqIABBMGoiBhCHCiAAQcgAaiIDIAFGDQADQAJAIAMgBhCECkUNACAEQRBqIgggAy0ACDoAACAEIAMpAgA3AwggBCADKAIMIgk2AhQgBCADKAIQIgo2AhggBCADKAIUIgs2AhwgA0EANgIUIANCADcCDCADIQUDQAJAIAUgBiICKQIANwIAIAUgAi0ACDoACCACKQIMIQwgBSACKAIUNgIUIAUgDDcCDCACQQA2AhQgAkIANwIMIAAgAkYEQCAAIQIMAQsgAiEFIARBCGogAkEYayIGEIQKDQELCyACIAQpAwg3AgAgAiAILQAAOgAIIAIgCzYCFCACIAo2AhAgAiAJNgIMIAdBAWoiB0EIRw0AIANBGGogAUYhAgwCCyADIQYgA0EYaiICIQMgASACRw0AC0EBIQILIARBIGokACACC94DAQR/IwBBIGsiBCQAIAAgASACEIsKAkACQCADKAIQIgUgAigCECIGSQ0AIAUgBksNASADKAIUIgUgAigCFCIGSQ0AIAUgBksNASADIAIQ/wlFDQELIARBEGoiBiACQRBqIgX9AAQA/QsEACAEIAL9AAQA/QsEACAFIANBEGoiBykDADcDACACIAP9AAQA/QsEACAHIAYpAwA3AwAgAyAEKQMANwMAIAMgBCkDCDcDCAJAIAUoAgAiAyABKAIQIgdJDQAgAyAHSw0BIAIoAhQiAyABKAIUIgdJDQAgAyAHSw0BIAIgARD/CUUNAQsgBiABQRBqIgP9AAQA/QsEACAEIAH9AAQA/QsEACADIAUpAwA3AwAgASAC/QAEAP0LBAAgBSAGKQMANwMAIAIgBCkDADcDACACIAQpAwg3AwgCQCADKAIAIgIgACgCECIDSQ0AIAIgA0sNASABKAIUIgIgACgCFCIDSQ0AIAIgA0sNASABIAAQ/wlFDQELIARBEGoiAiAAQRBqIgP9AAQA/QsEACAEIAD9AAQA/QsEACADIAFBEGoiBSkDADcDACAAIAH9AAQA/QsEACAFIAIpAwA3AwAgASAEKQMANwMAIAEgBCkDCDcDCAsgBEEgaiQAC+4EAQR/IwBBIGsiBSQAIAAgASACIAMQiQoCQAJAIAQoAhAiBiADKAIQIgdJDQAgBiAHSw0BIAQoAhQiBiADKAIUIgdJDQAgBiAHSw0BIAQgAxD/CUUNAQsgBUEQaiIHIANBEGoiBv0ABAD9CwQAIAUgA/0ABAD9CwQAIAYgBEEQaiIIKQMANwMAIAMgBP0ABAD9CwQAIAggBykDADcDACAEIAUpAwA3AwAgBCAFKQMINwMIAkAgBigCACIEIAIoAhAiCEkNACAEIAhLDQEgAygCFCIEIAIoAhQiCEkNACAEIAhLDQEgAyACEP8JRQ0BCyAHIAJBEGoiBP0ABAD9CwQAIAUgAv0ABAD9CwQAIAQgBikDADcDACACIAP9AAQA/QsEACAGIAcpAwA3AwAgAyAFKQMANwMAIAMgBSkDCDcDCAJAIAQoAgAiAyABKAIQIgRJDQAgAyAESw0BIAIoAhQiAyABKAIUIgRJDQAgAyAESw0BIAIgARD/CUUNAQsgBUEQaiIEIAFBEGoiA/0ABAD9CwQAIAUgAf0ABAD9CwQAIAMgAkEQaiIGKQMANwMAIAEgAv0ABAD9CwQAIAYgBCkDADcDACACIAUpAwA3AwAgAiAFKQMINwMIAkAgAygCACICIAAoAhAiBkkNACACIAZLDQEgASgCFCICIAAoAhQiBkkNACACIAZLDQEgASAAEP8JRQ0BCyAEIABBEGoiAv0ABAD9CwQAIAUgAP0ABAD9CwQAIAIgAykDADcDACAAIAH9AAQA/QsEACADIAQpAwA3AwAgASAFKQMANwMAIAEgBSkDCDcDCAsgBUEgaiQAC/oFAQR/IwBBIGsiBSQAAkACQCABKAIQIgMgACgCECIESQ0AAkAgAyAESw0AIAEoAhQiBCAAKAIUIgZJDQEgBCAGSw0AIAEgABD/CQ0BCwJAIAIoAhAiBCADSQ0AIAMgBEkNAiACKAIUIgMgASgCFCIESQ0AIAMgBEsNAiACIAEQ/wlFDQILIAVBEGoiBCABQRBqIgP9AAQA/QsEACAFIAH9AAQA/QsEACADIAJBEGoiBikDADcDACABIAL9AAQA/QsEACAGIAQpAwA3AwAgAiAFKQMANwMAIAIgBSkDCDcDCAJAIAMoAgAiAiAAKAIQIgZJDQAgAiAGSw0CIAEoAhQiAiAAKAIUIgZJDQAgAiAGSw0CIAEgABD/CUUNAgsgBCAAQRBqIgL9AAQA/QsEACAFIAD9AAQA/QsEACACIAMpAwA3AwAgACAB/QAEAP0LBAAgAyAEKQMANwMAIAEgBSkDADcDACABIAUpAwg3AwgMAQsCQAJAIAIoAhAiBCADSQ0AIAMgBEkNASACKAIUIgMgASgCFCIESQ0AIAMgBEsNASACIAEQ/wlFDQELIAVBEGoiASAAQRBqIgP9AAQA/QsEACAFIAD9AAQA/QsEACADIAJBEGoiBCkDADcDACAAIAL9AAQA/QsEACAEIAEpAwA3AwAgAiAFKQMANwMAIAIgBSkDCDcDCAwBCyAFQRBqIgQgAEEQaiIG/QAEAP0LBAAgBSAA/QAEAP0LBAAgBiABQRBqIgMpAwA3AwAgACAB/QAEAP0LBAAgAyAEKQMANwMAIAEgBSkDADcDACABIAUpAwg3AwgCQCACKAIQIgAgAygCACIGSQ0AIAAgBksNASACKAIUIgAgASgCFCIGSQ0AIAAgBksNASACIAEQ/wlFDQELIAQgA/0ABAD9CwQAIAUgAf0ABAD9CwQAIAMgAkEQaiIAKQMANwMAIAEgAv0ABAD9CwQAIAAgBCkDADcDACACIAUpAwA3AwAgAiAFKQMINwMICyAFQSBqJAAL+QQBCX8jAEEgayIEJABBASEFAkACQAJAAkACQAJAIAEgAGtBBXUOBgUFAAECAwQLIAFBIGshAwJAIAFBEGsoAgAiAiAAKAIQIgZJDQAgAiAGSw0FIAFBDGsoAgAiAiAAKAIUIgZJDQAgAiAGSw0FIAMgABD/CUUNBQsgBEEQaiICIABBEGoiBv0ABAD9CwQAIAQgAP0ABAD9CwQAIAYgA0EQaiIIKQMANwMAIAAgA/0ABAD9CwQAIAggAikDADcDACADIAQpAwA3AwAgAyAEKQMINwMIDAQLIAAgAEEgaiABQSBrEIsKDAMLIAAgAEEgaiAAQUBrIAFBIGsQiQoMAgsgACAAQSBqIABBQGsgAEHgAGogAUEgaxCKCgwBCyAAIABBIGogAEFAayIDEIsKIABB4ABqIgIgAUYNAANAAkACQCACIgcoAhAiAiADKAIQIgVJDQAgAiAFSw0BIAcoAhQiAiADKAIUIgVJDQAgAiAFSw0BIAcgAxD/CUUNAQsgBEEQaiIKIAdBEGoiAv0ABAD9CwQAIAQgB/0ABAD9CwQAIAIgAykDEDcDACAHIAP9AAQA/QsEACAKKAIAIQUgBCgCFCEIAkADQCADIgJBIGshAwJAIAUgAkEQaygCACIGSQ0AIAUgBksNAiAIIAJBDGsoAgAiBkkNACAGIAhJDQIgBCADEP8JRQ0CCyACIAP9AAQA/QsEACACIAMpAxA3AxAgACADRw0ACyAAIQILIAIgBP0ABAD9CwQAIAIgCikDADcDECAJQQFqIglBCEcNACAHQSBqIAFGIQUMAgsgByIDQSBqIgIgAUcNAAtBASEFCyAEQSBqJAAgBQucBAIFfwJ+IwBB0ABrIgMkAAJAAkAgASkDACIIIAEpAwgiCYRQBEAgACABEOIJIQIgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAyAgA0IANwM4IANCfzcDMCACBEAgA0IANwJIIAMgAjYCRCADQSBqIANBxABqEOcJCyAAIANBIGoQ4wkhAiADKAIgIgBFDQEgAyAANgIkIAAQKwwBCyAAKAIAIgQpAwAgCFEEQCAJIAQpAwhRDQELIAAoAkwgAkEFdGoiBigCBCEFIAYtAB4iBEUgBigCACIHIAVGcQ0AAkAgBARAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIANCADcDGCADQn83AxAgAyACNgIoIANCATcCICADIANBIGoQ5wkgAygCBCEEIAMoAgAhAgwBC0EAIQQgA0EANgIIIANCADcCAEEAIQIgBSAHRwRAIAUgB2siBUEMbUHWqtWqAU8NAyADIAUQogkiAjYCACADIAIgBWoiBDYCCCAFBEAgAiAHIAX8CgAACyADIAQ2AgQLIAMgBigCHDYCHCADIAb9AAIM/QsCDAsgAiAERwRAA0AgAyAAKAIsIAIoAgBBBHRq/QAEACAB/QAEABCaCf0LBCAgAiAAIANBIGoQ4gk2AgAgAkEMaiICIARHDQALCyAAIAMQ4wkhAiADKAIAIgBFDQAgAyAANgIEIAAQKwsgA0HQAGokACACDwsQoAkACwQAIAALHgEBf0EMEKIJIgFB1M8xNgIAIAEgACkCBDcCBCABCxUAIAFB1M8xNgIAIAEgACkCBDcCBAsxAQF/IAAoAgQiAikDACAAKAIIKAIsIAEoAgBBBHRqIgApAwBRIAIpAwggACkDCFFxC8EEAgF/A3sjAEHwAGsiBiQAAkAgAiADTwRAIAEoAgQoAgAhAiAGIAEoAgD9AAQAIgf9CwQAIAIgBhDiCSEBIAb9DAAAAAAAAAAAAAAAAAAAAAD9CwMwIAZCADcDSCAGQn83A0AgAQRAIAZCADcCaCAGIAE2AmQgBkEwaiAGQeQAahDnCQsgAiAGQTBqEOMJIQEgBigCMCICBEAgBiACNgI0IAIQKwsgACABNgIgIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIAAgB/0LBAAMAQsgAkEBaiADRgRAIAUgAkEwbCIDaiECAnsCQAJAIAMgBGoiAykDECADKQMYhFAEQCADIQUMAQsgAikDECACKQMYhEIAUg0BIAIhBSADIQILIAIoAiAhAyAC/QAEECEJIAEoAgD9AAQAIQcgAv0ABAAgBf0ABAD9UQwBCyABKAIEKAIAIANBEGogAygCIBCNCiEFIAEoAgQoAgAgAkEQaiACKAIgEI0KIQQgASgCBCgCACAFIAQQ/AkhBSAGIAL9AAQAIAP9AAQA/VH9CwQwIAEoAgQoAgAgBSAGQTBqEJUKIQMgASgCAP0ABAAiByEJ/QwAAAAAAAAAAAAAAAAAAAAACyEIIAcgCBCaCSEIIAAgAzYCICAAIAcgCRCaCf0LBBAgACAIIAf9Uf0LBAAMAQsgBkEwaiABIAIgAyACa0EBdiACaiICIAQgBRCSCiAGIAEgAiADIAQgBRCSCiAAIAEgBkEwaiAGEJQKCyAGQfAAaiQAC+oUAhZ/AXsjAEGwAmsiBCQAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwQwIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwRgIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSQASAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAEgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBPABIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSgAiAA/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AIgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBIADIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSgBSAA/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AQgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBNAFIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTABCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAQgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBIAGIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTgAyAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEsAMgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgAEFAa/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBHAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBKABIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTQASAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAIgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBLACIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTgAiAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAMgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBLAFIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSABSAA/QwAAAAAAAAAAAAAAAAAAAAA/QsE4AUgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBNAEIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSgBCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAYgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBPADIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTAAyAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAYgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBLAGIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTgBiAA/QwAAAAAAAAAAAAAAAAAAAAA/QsE8AYgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBJAHIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSgByAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEwAcgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBNAHIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTwByAAQYAIav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBKAIIABBsAhq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsE0AggAEHgCGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwSACSAAQZAJav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBLAJIABBwAlq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAAQfAJav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBOAJIABBoApq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEkAogAEHQCmr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTACiAAQYALav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LBPAKIABBsAtq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEoAsgAEHgC2r9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwTQCyAEQZABaiEIIARB4ABqIQkgBEEwaiEKIAEoAgAhCwNAIARBEGoiD/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgBP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgCkEQaiIQ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAJQgA3AwAgCUIANwMQIAlBCGoiEUIANwMAIAlBGGoiEkIANwMAIAhCADcDACAIQRBqIhNCADcDACAIQQhqIhRCADcDACAIQRhqIhVCADcDACACIA1BAnQiDmohFiALQQRqIQdBACEMA0AgASgCBCEFIAQgCygCAP0ABDD9CwSAAiAHKAIAKAIAIgYgBEGAAmoQ4gkhAyAE/QwAAAAAAAAAAAAAAAAAAAAA/QsDkAIgBEIANwOoAiAEQn83A6ACIAMEQCAEQgA3AsQBIAQgAzYCwAEgBEGQAmogBEHAAWoQ5wkLIAYgBEGQAmoQ4wkhBiAEKAKQAiIDBEAgBCADNgKUAiADECsLIAUgDEEIdGohFyAEIAY2AsABIAQgFigCADYCxAFBAiEDA0AgBEHAAWogA0EBdiIFQQJ0aigCACEGIARBwAFqIAMgBWtBAnRqKAIAIQUgBCAHKAIAKAIAIhgoAgD9AAQA/QsEkAIgBEHAAWogA0ECdGogGCAEQZACaiAFIAYQ+wk2AgAgA0EBaiIDQRBHDQALQQAhAyALKAIAGiAHKAIAEPoJIQUDQCAHKAIAKAIAIBcgA0EEdGogBEHAAWogA0ECdGooAgAQjQohBiAHKAIAKAIAIAUgBhD8CSEFIANBAWoiBiEDIAZBEEcNAAsgBCAFNgKQAiAEIAcoAgAoAgAiAygCAP0ABAD9CwTAASADIARBwAFqIAUgBRD7CSEDIAcoAgAgBEGQAmogAxD9CSEDIAcoAgAoAgAgAxDvCSABKAIAIgYoAgD9AAQAIRkgBCAMQTBsaiIDIAU2AiAgAyAZ/QsEECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAMQQFqIgxBBEcNAAsgACANQcABbGoiAyAE/QAEAP0LBAAgAyAEKAIgNgIgIAMgD/0ABAD9CwQQIAAgDkEBckEwbGoiAyAKKAIgNgIgIAMgEP0ABAD9CwQQIAMgCv0ABAD9CwQAIAAgDkECckEwbGoiAyAJKAIgNgIgIAMgEf0AAwD9CwMIIAMgCSkDADcDACADIBIpAwA3AxggACAOQQNyQTBsaiIDIAgpAwA3AwAgAyAUKQMANwMIIAMgEykDADcDECADIBUpAwA3AxggAyAIKAIgNgIgIAYhCyANQQFqIg1BCEcNAAsgBEGwAmokAAueAwIDfwJ7IwBBEGsiBCQAAkACQAJAIAIpAxAgAikDGIRQBEAgAiEBDAELIAMpAxAgAykDGIRCAFINASADIQEgAiEDCyAB/QAEACIHIAP9AAQAEJoJIQggACAHIAP9AAQQEJoJ/QsEECAAIAj9CwQAIAAgAygCIDYCIAwBCyAEIAL9AAQQIAP9AAQQEJoJ/QsEACABKAIEKAIAIAQgAigCICADKAIgEPsJIQUgBCAC/QAEACAD/QAEEBCaCSIH/QsEACAH/R0AIAf9HQGEQgBSBEAgASgCBCgCACIGIAUgBiAEQQAgAygCIBD7CRD8CSEFCyAEIAL9AAQQIAP9AAQAIggQmgkiB/0LBAAgB/0dACAH/R0BhEIAUgRAIAEoAgQoAgAiBiAFIAYgBEEAIAIoAiAQ+wkQ/AkhBSAD/QAEACEICyAEIAL9AAQAIAgQmgn9CwQAIAEoAgQoAgAgBSAEEJUKIQMgASgCAP0ABAAhByAAIAM2AiAgACAH/QsEECAA/QwAAAAAAAAAAAAAAAAAAAAA/QsEAAsgBEEQaiQAC5wBAQJ/IwBBMGsiAyQAIAIpAwAgAikDCIRCAFIEQCAAIAIQ4gkhAiAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDACADQgA3AxggA0J/NwMQIAIEQCADQgA3AiggAyACNgIkIAMgA0EkahDnCQsgACADEOMJIQQgAygCACICBEAgAyACNgIEIAIQKwsgACABIAQQ/AkhAQsgA0EwaiQAIAELogYCA38DeyMAQYACayIHJAACQCACIAFrIglBAk8EQCAHQRBqIQggACABIAlBAXYgAWoiCSAHQcABaiAHQeAAaiAFIAYQlgogACAJIAIgB0GQAWogB0EwaiAFIAYQlgogByAAIAdBkAFqIAdBwAFqEJQKIAMgBygCIDYCICADIAf9AAQQ/QsEECADIAf9AAQA/QsEACAHIAAgB0GQAWogB0HgAGoQlAoCQAJAAn8gBykDQCAHKQNIhFAEQCAHQTBqIQMgBwwBCyAHQUBrIQEgBykDECAHKQMYhEIAUg0BIAchAyABIQggB0EwagsiAP0ABAAgA/0ABAD9USEKIAAoAiAhAwwBCyAAKAIEKAIAIAEgBygCUBCNCiEDIAAoAgQoAgAgCCAHKAIgEI0KIQEgACgCBCgCACADIAEQ/AkhAyAHIAf9AAQAIAf9AAQw/VH9CwTwASAAKAIEKAIAIAMgB0HwAWoQlQohAyAAKAIAIQgLIAj9AAQAIQsgBCADNgIgIAQgC/0LBBAgBCAK/QsEAAwBCyAFIAFBMGwiAmoiASEFIAIgBmoiAiEGAnsCQCABKQMQIAEpAxiEQgBSBEAgAiEFIAEhBiACKQMQIAIpAxiEQgBSDQELIAb9AAQAIAX9AAQA/VEhCyAGKAIgIQUgACgCAP0ABAAhCiAG/QAEEAwBCyAAKAIEKAIAIAFBEGogASgCIBCNCiEGIAAoAgQoAgAgAkEQaiACKAIgEI0KIQUgACgCBCgCACAGIAUQ/AkhBiAHIAL9AAQAIAH9AAQA/VH9CwTAASAAKAIEKAIAIAYgB0HAAWoQlQohBSAAKAIA/QAEACIKCyEMIAogCxCaCSELIAMgBTYCICADIAogDBCaCf0LBBAgAyALIAr9Uf0LBAAgACgCAP0ABAAiCiAB/QAEABCaCSELIAcgCiAB/QAEEBCaCf0LBNABIAcgCyAK/VH9CwTAASAHIAEoAiA2AuABIAdBkAFqIAAgB0HAAWogAhCUCiAEIAcoArABNgIgIAQgB/0ABKAB/QsEECAEIAf9AASQAf0LBAALIAdBgAJqJAAL2bYCA/gCfwJ7An4jAEHw6AFrIgckAEGA4AAQngkiFEEAQYDgAPwLAEGAwAQQngkimAJBAEGAwAT8CwBBgIAGEJ4JIpkCQQBBgIAG/AsAQYCABhCeCSKaAkEAQYCABvwLACAHQYAMaiAAQQRqIgggBhCTCiAUIAdBgAxqQYAM/AoAACAHQYAMaiAIIAZBIGoQkwogFEGADGoisQIgB0GADGpBgAz8CgAAIAdBgAxqIAggBkFAaxCTCiAUQYAYaiKyAiAHQYAMakGADPwKAAAgB0GADGogCCAGQeAAahCTCiAUQYAkaiKzAiAHQYAMakGADPwKAAAgB0GADGogCCAGQYABahCTCiAUQYAwaiK0AiAHQYAMakGADPwKAAAgB0GADGogCCAGQaABahCTCiAUQYA8aiK1AiAHQYAMakGADPwKAAAgB0GADGogCCAGQcABahCTCiAUQYDIAGoitgIgB0GADGpBgAz8CgAAIAdBgAxqIAggBkHgAWoQkwogFEGA1ABqIrcCIAdBgAxqQYAM/AoAAANAIAdBgAxqIAggAyAKQQV0ahCTCiCYAiAKQYAMbGogB0GADGpBgAz8CgAAIApBAWoiCkEwRw0AC0EAIQoDQCAHQYAMaiAIIAQgCkEFdCIDahCTCiCZAiAKQYAMbCIGaiAHQYAMakGADPwKAAAgB0GADGogCCADIAVqEJMKIAYgmgJqIAdBgAxqQYAM/AoAACAKQQFqIgpBwABHDQALIAcgACgCACIKNgKQzAFBACEIIAdBoMwBaiIDQQBBkAT8CwAgCigCAP0ABBAh/wIDQCADIAhBBHRqIP8C/QsEACD/AiD/AhCaCSH/AiAIQQFqIghBIEcNAAsgByD/Av0LBLDQAUGAgAYQngkiH0GAwAFqQQBBgMAE/AsAIB8gAUGAwAH8CgAAIB9BgNQAayGbAiAfQYC0AWshnAIgH0GAGGshnQIgB0HgvwFqIXQgB0GwvwFqIXUgB0GAvwFqIXYgB0HQvgFqIXcgB0GgvgFqIXggB0HwvQFqIXkgB0HAvQFqIXogB0GQvQFqIXsgB0HgvAFqIXwgB0GwvAFqIX0gB0GAvAFqIX4gB0HQuwFqIX8gB0GguwFqIYABIAdB8LoBaiGBASAHQcC6AWohggEgB0GQugFqIYMBIAdB4LkBaiGEASAHQbC5AWohhQEgB0GAuQFqIYYBIAdB0LgBaiGHASAHQaC4AWohiAEgB0HwtwFqIYkBIAdBwLcBaiGKASAHQZC3AWohiwEgB0HgtgFqIYwBIAdBsLYBaiGNASAHQYC2AWohFSAHQdC1AWohFiAHQaC1AWohFyAHQfC0AWohGCAHQcC0AWohjgEgB0GQ3AFqISAgB0Hg2wFqISEgB0Gw2wFqISIgB0GA2wFqISMgB0HQ2gFqISQgB0Gg2gFqISUgB0Hw2QFqISYgB0HA2QFqIScgB0GQ2QFqISggB0Hg2AFqISkgB0Gw2AFqISogB0GA2AFqISsgB0HQ1wFqISwgB0Gg1wFqIS0gB0Hw1gFqIS4gB0HA1gFqIS8gB0GQ1gFqITAgB0Hg1QFqITEgB0Gw1QFqITIgB0GA1QFqITMgB0HQ1AFqITQgB0Gg1AFqITUgB0Hw0wFqITYgB0HA0wFqITcgB0GQ0wFqITggB0Hg0gFqIRkgB0Gw0gFqITkgB0GA0gFqITogB0HQ0QFqITsgB0Gg0QFqITwgB0Hw0AFqIT0gB0GQ6AFqIT4gB0Hg5wFqIT8gB0Gw5wFqIUAgB0GA5wFqIUEgB0HQ5gFqIUIgB0Gg5gFqIUMgB0Hw5QFqIUQgB0HA5QFqIUUgB0GQ5QFqIUYgB0Hg5AFqIUcgB0Gw5AFqIUggB0GA5AFqIUkgB0HQ4wFqIUogB0Gg4wFqIUsgB0Hw4gFqIUwgB0HA4gFqIU0gB0GQ4gFqIU4gB0Hg4QFqIU8gB0Gw4QFqIVAgB0GA4QFqIVEgB0HQ4AFqIVIgB0Gg4AFqIVMgB0Hw3wFqIVQgB0HA3wFqIVUgB0GQ3wFqIVYgB0Hg3gFqIVcgB0Gw3gFqIQsgB0GA3gFqIQwgB0HQ3QFqIQ0gB0Gg3QFqIQ4gB0Hw3AFqIVggB0HQF2ohWSAHQaAXaiFaIAdB8BZqIVsgB0HAFmohXCAHQZAWaiFdIAdB4BVqIV4gB0GwFWohXyAHQYAVaiFgIAdB0BRqIWEgB0GgFGohYiAHQfATaiFjIAdBwBNqIWQgB0GQE2ohZSAHQeASaiFmIAdBsBJqIWcgB0GAEmohaCAHQdARaiFpIAdBoBFqIWogB0HwEGohayAHQcAQaiFsIAdBkBBqIW0gB0HgD2ohbiAHQbAPaiFvIAdBgA9qIXAgB0HQDmohcSAHQaAOaiEPIAdB8A1qIRAgB0HADWohESAHQZANaiESIAdB4AxqIRMgB0GwDGohciAHQeDLAWohjwEgB0GwywFqIZABIAdBgMsBaiGRASAHQdDKAWohkgEgB0GgygFqIZMBIAdB8MkBaiGUASAHQcDJAWohlQEgB0GQyQFqIZYBIAdB4MgBaiGXASAHQbDIAWohmAEgB0GAyAFqIZkBIAdB0McBaiGaASAHQaDHAWohmwEgB0HwxgFqIZwBIAdBwMYBaiGdASAHQZDGAWohngEgB0HgxQFqIZ8BIAdBsMUBaiGgASAHQYDFAWohoQEgB0HQxAFqIaIBIAdBoMQBaiGjASAHQfDDAWohpAEgB0HAwwFqIaUBIAdBkMMBaiGmASAHQeDCAWohpwEgB0GwwgFqIagBIAdBgMIBaiEaIAdB0MEBaiEcIAdBoMEBaiEdIAdB8MABaiEeIAdBwMABaiGpASAHQYAwaiGeAiAHQYAkaiGfAiAHQYAYaiGgAkEQIXMDQCAAKAIAIQUgB0GQDGoiqwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwSADCBy/QwAAAAAAAAAAAAAAAAAAAAA/QsEACByQRBqIqwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACATQgA3AwAgE0EQaiKtAUIANwMAIBNBCGoirgFCADcDACATQRhqIq8BQgA3AwAgEkIANwMAIBJBEGoisAFCADcDACASQQhqIrEBQgA3AwAgEkEYaiKyAUIANwMAIBFCADcDACARQRBqIrMBQgA3AwAgEUEIaiK0AUIANwMAIBFBGGoitQFCADcDACAQQgA3AwAgEEEQaiK2AUIANwMAIBBBCGoitwFCADcDACAQQRhqIrgBQgA3AwAgD0IANwMAIA9BEGoiuQFCADcDACAPQQhqIroBQgA3AwAgD0EYaiK7AUIANwMAIHFBEGoivAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHBBEGoivQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG9BEGoivgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG5BEGoivwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG1BEGoiwAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG39DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGxBEGoiwQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGtBEGoiwgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGpBEGoiwwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGlBEGoixAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGhBEGoixQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGdBEGoixgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGZBEGoixwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGVBEGoiyAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGRBEGoiyQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGNBEGoiygH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGJBEGoiywH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGFBEGoizAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGBBEGoizQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF9BEGoizgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF5BEGoizwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF1BEGoi0AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF39DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFxBEGoi0QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFtBEGoi0gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFpBEGoi0wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFlBEGoi1AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJ0CIHNBgAxsIhtqIQNBACEIA0AgB0GADGogCEEwbGoiBiADIAhBEWpBH3FBMGxqIgn9AAQA/QsEACAGIAkoAiA2AiAgBiAJ/QAEEP0LBBAgB0GADGogCEEBckEwbGoiBiADIAhBEmpBHnFBMGxqIgn9AAQA/QsEACAGIAn9AAQQ/QsEECAGIAkoAiA2AiAgCEECaiIIQSBHDQALIAdB0NwBaiLVAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBMDcASBY/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBYQRBqItYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAOQgA3AwAgDkEQaiLXAUIANwMAIA5BCGoi2AFCADcDACAOQRhqItkBQgA3AwAgDUIANwMAIA1BEGoi2gFCADcDACANQQhqItsBQgA3AwAgDUEYaiLcAUIANwMAIAxCADcDACAMQRBqIt0BQgA3AwAgDEEIaiLeAUIANwMAIAxBGGoi3wFCADcDACALQgA3AwAgC0EQaiLgAUIANwMAIAtBCGoi4QFCADcDACALQRhqIuIBQgA3AwAgV0IANwMAIFdBEGoi4wFCADcDACBXQQhqIuQBQgA3AwAgV0EYaiLlAUIANwMAIFZBEGoi5gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFVBEGoi5wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFRBEGoi6AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFNBEGoi6QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFJBEGoi6gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFFBEGoi6wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFBBEGoi7AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE9BEGoi7QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE5BEGoi7gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE1BEGoi7wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE39DAAAAAAAAAAAAAAAAAAAAAD9CwQAIExBEGoi8AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEtBEGoi8QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEpBEGoi8gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIElBEGoi8wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEhBEGoi9AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEdBEGoi9QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEZBEGoi9gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEVBEGoi9wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIERBEGoi+AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIET9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIENBEGoi+QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEJBEGoi+gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEFBEGoi+wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEBBEGoi/AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIED9DAAAAAAAAAAAAAAAAAAAAAD9CwQAID9BEGoi/QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAID/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAID5BEGoi/gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAID79DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhCANAIAdBwNwBaiAIQTBsaiIGIAMgCEETakEfcUEwbGoiCf0ABAD9CwQAIAYgCSgCIDYCICAGIAn9AAQQ/QsEECAHQcDcAWogCEEBckEwbGoiBiADIAhBFGpBHnFBMGxqIgn9AAQA/QsEACAGIAn9AAQQ/QsEECAGIAkoAiA2AiAgCEECaiIIQSBHDQALIAdB0NABaiL/Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBMDQASA9/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA9QRBqIoAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA8QgA3AwAgPEEQaiKBAkIANwMAIDxBCGoiggJCADcDACA8QRhqIoMCQgA3AwAgO0IANwMAIDtBEGoihAJCADcDACA7QQhqIoUCQgA3AwAgO0EYaiKGAkIANwMAIDpCADcDACA6QRBqIocCQgA3AwAgOkEIaiKIAkIANwMAIDpBGGoiiQJCADcDACA5QgA3AwAgOUEQaiKKAkIANwMAIDlBCGoiiwJCADcDACA5QRhqIowCQgA3AwAgGUIANwMAIBlBEGoijQJCADcDACAZQQhqIo4CQgA3AwAgGUEYaiKPAkIANwMAIDhBEGoikAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDdBEGoikQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDZBEGoikgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDVBEGoikwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDRBEGoilAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDNBEGoilQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDJBEGoilgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDFBEGoilwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDBBEGoiqgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC9BEGoioQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC5BEGoiogL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC1BEGoiowL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC39DAAAAAAAAAAAAAAAAAAAAAD9CwQAICxBEGoipAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICtBEGoipQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICpBEGoipgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIClBEGoipwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIChBEGoiqAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICdBEGoiqQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICZBEGoiqgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICVBEGoiqwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICRBEGoirAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICNBEGoirQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICJBEGoirgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICFBEGoirwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICBBEGoisAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhCANAIAhBMGwiCSAHQcDQAWpqIQYCQCAIQRVNBEAgBiADIAlqIgkoAoAENgIgIAYgCf0ABPAD/QsEECAGIAn9AATgA/0LBAAMAQsgBSgCBCgCACEJIAcgBSgCAP0ABAD9CwSQqAEgCSAHQZCoAWoQ4gkhBCAH/QwAAAAAAAAAAAAAAAAAAAAA/QsDkLQBIAdCADcDqLQBIAdCfzcDoLQBIAQEQCAHQgA3ApScASAHIAQ2ApCcASAHQZC0AWogB0GQnAFqEOcJCyAJIAdBkLQBahDjCSEEIAcoApC0ASIJBEAgByAJNgKUtAEgCRArCyAG/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAG/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAGIAQ2AiALIAhBAWoiCEEgRw0ACyAHQaDAAWr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwSQwAEgqQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAeQgA3AwAgHkIANwMQIB5CADcDCCAeQgA3AxggHUIANwMAIB1CADcDECAdQgA3AwggHUIANwMYIBxCADcDACAcQgA3AxAgHEIANwMIIBxCADcDGCAaQgA3AwAgGkIANwMQIBpCADcDCCAaQgA3AxggqAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIKgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCnAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgpwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCmAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgpQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIKUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCkAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgpAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCjAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgogH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIKIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACChAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgoQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgnwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJ8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCeAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgngH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJ0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCdAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgnAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCbAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgmwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCaAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgmQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCYAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgmAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCXAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAglgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCVAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAglQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCUAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgkwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCSAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgkgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCRAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgkAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCPAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgjwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhAwNAIAdBkLQBaiAFIANBMGwiCCAHQYAMamogB0HA3AFqIAhqIAdBwNABaiAIahCYCiAHQZDAAWogCGoiCCAHQbC0AWooAgA2AiAgCCAHQaC0AWoiAf0ABAD9CwQQIAggB/0ABJC0Af0LBAAgA0EBaiIDQSBHDQALIAAoAgAhBSCrAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBIAMIHL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACATQgA3AwAgrQFCADcDACCuAUIANwMAIK8BQgA3AwAgEkIANwMAILABQgA3AwAgsQFCADcDACCyAUIANwMAIBFCADcDACCzAUIANwMAILQBQgA3AwAgtQFCADcDACAQQgA3AwAgtgFCADcDACC3AUIANwMAILgBQgA3AwAgD0IANwMAILkBQgA3AwAgugFCADcDACC7AUIANwMAILwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBx/QwAAAAAAAAAAAAAAAAAAAAA/QsEACC9Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgcP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgvgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIL8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBu/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDAAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgbf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgwQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDDAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgav0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgxAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDGAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgZ/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgxwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDJAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgZP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgygH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBi/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDMAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgYf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgzQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIM4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBf/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDPAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgXv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg0AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF39DAAAAAAAAAAAAAAAAAAAAAD9CwQAINEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBc/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDSAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgW/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg0wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAINQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBZ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAbIJwCaiEDQQAhCANAIAdBgAxqIAhBMGxqIgYgAyAIQQdqQR9xQTBsaiIJ/QAEAP0LBAAgBiAJKAIgNgIgIAYgCf0ABBD9CwQQIAdBgAxqIAhBAXJBMGxqIgYgAyAIQQhqQR5xQTBsaiIJ/QAEAP0LBAAgBiAJ/QAEEP0LBBAgBiAJKAIgNgIgIAhBAmoiCEEgRw0ACyDVAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBMDcASBY/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDWAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgDkIANwMAINcBQgA3AwAg2AFCADcDACDZAUIANwMAIA1CADcDACDaAUIANwMAINsBQgA3AwAg3AFCADcDACAMQgA3AwAg3QFCADcDACDeAUIANwMAIN8BQgA3AwAgC0IANwMAIOABQgA3AwAg4QFCADcDACDiAUIANwMAIFdCADcDACDjAUIANwMAIOQBQgA3AwAg5QFCADcDACDmAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgVv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg5wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBU/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDpAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgU/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg6gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBR/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDsAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgUP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg7QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIO4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBO/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDvAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgTf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg8AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBL/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDyAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgSv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg8wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBI/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD1Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgR/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg9gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBF/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD4Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgRP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg+QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIEP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD7Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgQf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg/AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIED9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIP0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA//QwAAAAAAAAAAAAAAAAAAAAA/QsEACD+Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgPv0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACEIA0AgB0HA3AFqIAhBMGxqIgYgAyAIQRJqQR5xQTBsaiIJ/QAEAP0LBAAgBiAJKAIgNgIgIAYgCf0ABBD9CwQQIAdBwNwBaiAIQQFyQTBsaiIGIAMgCEETakEfcUEwbGoiCf0ABAD9CwQAIAYgCf0ABBD9CwQQIAYgCSgCIDYCICAIQQJqIghBIEcNAAsg/wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwTA0AEgPf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAggAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDxCADcDACCBAkIANwMAIIICQgA3AwAggwJCADcDACA7QgA3AwAghAJCADcDACCFAkIANwMAIIYCQgA3AwAgOkIANwMAIIcCQgA3AwAgiAJCADcDACCJAkIANwMAIDlCADcDACCKAkIANwMAIIsCQgA3AwAgjAJCADcDACAZQgA3AwAgjQJCADcDACCOAkIANwMAII8CQgA3AwAgkAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJEC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA3/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCSAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgNv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgkwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJQC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA0/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCVAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgM/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAglgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJcC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAx/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCqAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgMP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgoQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKIC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAu/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCjAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgLf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgpAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKUC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCmAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgKv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgpwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKgC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCpAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJ/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgqgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKsC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCsAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgrQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIK4C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAi/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCvAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgIf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgsAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhCANAIAhBMGwiCSAHQcDQAWpqIQYCQCAIQRxNBEAgBiADIAlqIgkoArABNgIgIAYgCf0ABKAB/QsEECAGIAn9AASQAf0LBAAMAQsgBSgCBCgCACEJIAcgBSgCAP0ABAD9CwSQnAEgCSAHQZCcAWoQ4gkhBCAH/QwAAAAAAAAAAAAAAAAAAAAA/QsDkKgBIAdCADcDqKgBIAdCfzcDoKgBIAQEQCAHQgA3ApSQASAHIAQ2ApCQASAHQZCoAWogB0GQkAFqEOcJCyAJIAdBkKgBahDjCSEEIAcoApCoASIJBEAgByAJNgKUqAEgCRArCyAG/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAG/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAGIAQ2AiALIAhBAWoiCEEgRw0ACyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAH/QwAAAAAAAAAAAAAAAAAAAAA/QsEkLQBII4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCOAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgGEIANwMAIBhCADcDECAYQgA3AwggGEIANwMYIBdCADcDACAXQgA3AxAgF0IANwMIIBdCADcDGCAWQgA3AwAgFkIANwMQIBZCADcDCCAWQgA3AxggFUIANwMAIBVCADcDECAVQgA3AwggFUIANwMYII0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCNAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgjAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCLAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgiwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCKAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgiQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCIAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgiAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCHAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAghgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCFAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAghQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCEAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAggwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCCAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgggH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCBAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAggAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB//QwAAAAAAAAAAAAAAAAAAAAA/QsEECB//QwAAAAAAAAAAAAAAAAAAAAA/QsEACB+/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB+/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB9/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB9/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB8/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB8/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB7/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB7/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB6/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB6/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB5/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB5/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB4/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB4/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB3/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB3/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB2/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB2/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB1/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB1/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB0/QwAAAAAAAAAAAAAAAAAAAAA/QsEECB0/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQMDQCAHQZCoAWogBSADQTBsIgggB0GADGpqIAdBwNwBaiAIaiAHQcDQAWogCGoQmAogB0GQtAFqIAhqIgggB0GwqAFqKAIANgIgIAggB0GgqAFq/QAEAP0LBBAgCCAH/QAEkKgB/QsEACADQQFqIgNBIEcNAAsgB0GADGogB0GQwAFqQYAM/AoAACCgAiAbIJsCakGADPwKAAAgnwIgB0GQtAFqQYAM/AoAACCeAiAfIBtBgMABayIGakGADPwKAAAgB0GAMBCeCSIDNgLA3AEgByADQYAwaiIJNgLI3AEgAyAHQYAMakGAMPwKAAAgByAJNgLE3AEgGyAfaiIDIAYgmAJqQYAM/AoAACAHKAKQzAEhCCAHQfzRMTYCgAwgByAHQYAMajYCkAwgByAHQcDcAWo2AogMIAcgB0GQzAFqNgKEDCAIQQBBBCAHQYAMahCZCiEGAkAgBygCkAwiCCAHQYAMakYEf0EQBSAIRQ0BQRQLIQkgCCAIKAIAIAlqKAIAEQYACyAHIAY2AsDQASAHQZDMAWogAyAHQcDQAWpBBBCaCiAHKALA3AEiCARAIAcgCDYCxNwBIAgQKwsgc0EBaiJzQcAARw0ACyAHQZDAAWogAkGADPwKAAAgB0GQtAFqIAJBgAxqIldBgAz8CgAAIAdBkKgBaiACQYAYaiK4AkGADPwKAAAgB0GQnAFqIAJBgCRqIrkCQYAM/AoAACAHQZCQAWogAkGAMGoiugJBgAz8CgAAIAdBkIQBaiACQYA8aiK7AkGADPwKAAAgB0GQ+ABqIAJBgMgAaiK8AkGADPwKAAAgB0GQ7ABqIAJBgNQAaiK9AkGADPwKAAAgB0HQ0AFqITsgB0EQaiE5IAdB0AtqIa4BIAdBoAtqIa8BIAdB8ApqIbABIAdBwApqIbEBIAdBkApqIbIBIAdB4AlqIbMBIAdBsAlqIbQBIAdBgAlqIbUBIAdB0AhqIbYBIAdBoAhqIbcBIAdB8AdqIbgBIAdBwAdqIbkBIAdBkAdqIboBIAdB4AZqIbsBIAdBsAZqIbwBIAdBgAZqIb0BIAdB0AVqIb4BIAdBoAVqIb8BIAdB8ARqIcABIAdBwARqIcEBIAdBkARqIcIBIAdB4ANqIcMBIAdBsANqIcQBIAdBgANqIcUBIAdB0AJqIcYBIAdBoAJqIccBIAdB8AFqIRwgB0HAAWohHSAHQZABaiEeIAdB4ABqISAgB0EwaiHIASAHQZDcAWohTiAHQeDbAWohTyAHQbDbAWohUCAHQYDbAWohUSAHQdDaAWohUiAHQaDaAWohUyAHQfDZAWohVCAHQcDZAWohVSAHQZDZAWohViAHQeDYAWohWCAHQbDYAWohWSAHQYDYAWohWiAHQdDXAWohWyAHQaDXAWohXCAHQfDWAWohXSAHQcDWAWohXiAHQZDWAWohXyAHQeDVAWohYCAHQbDVAWohYSAHQYDVAWohYiAHQdDUAWohYyAHQaDUAWohZCAHQfDTAWohZSAHQcDTAWohZiAHQZDTAWohZyAHQeDSAWohECAHQbDSAWohESAHQYDSAWohEiAHQdDRAWohEyAHQaDRAWohGyAHQfDQAWohaCAHQZDoAWohaSAHQeDnAWohaiAHQbDnAWohayAHQYDnAWohbCAHQdDmAWohbSAHQaDmAWohbiAHQfDlAWohbyAHQcDlAWohcCAHQZDlAWohcSAHQeDkAWohciAHQbDkAWohcyAHQYDkAWohdCAHQdDjAWohdSAHQaDjAWohdiAHQfDiAWohdyAHQcDiAWoheCAHQZDiAWoheSAHQeDhAWoheiAHQbDhAWoheyAHQYDhAWohfCAHQdDgAWohfSAHQaDgAWohfiAHQfDfAWohfyAHQcDfAWohgAEgB0GQ3wFqIYEBIAdB4N4BaiEVIAdBsN4BaiEWIAdBgN4BaiEXIAdB0N0BaiEYIAdBoN0BaiEaIAdB8NwBaiGCASAHQdAXaiEhIAdBoBdqISIgB0HwFmohIyAHQcAWaiEkIAdBkBZqISUgB0HgFWohJiAHQbAVaiEnIAdBgBVqISggB0HQFGohKSAHQaAUaiEqIAdB8BNqISsgB0HAE2ohLCAHQZATaiEtIAdB4BJqIS4gB0GwEmohLyAHQYASaiEwIAdB0BFqITEgB0GgEWohMiAHQfAQaiEzIAdBwBBqITQgB0GQEGohNSAHQeAPaiE2IAdBsA9qITcgB0GAD2ohOCAHQdAOaiE9IAdBoA5qIQsgB0HwDWohDCAHQcANaiENIAdBkA1qIQ4gB0HgDGohDyAHQbAMaiE+IAdB0NABaiE6IAdBkAxqITwgB0Hg6wBqIckBIAdBsOsAaiHKASAHQYDrAGohywEgB0HQ6gBqIcwBIAdBoOoAaiHNASAHQfDpAGohzgEgB0HA6QBqIc8BIAdBkOkAaiHQASAHQeDoAGoh0QEgB0Gw6ABqIdIBIAdBgOgAaiHTASAHQdDnAGoh1AEgB0Gg5wBqIdUBIAdB8OYAaiHWASAHQcDmAGoh1wEgB0GQ5gBqIdgBIAdB4OUAaiHZASAHQbDlAGoh2gEgB0GA5QBqIdsBIAdB0OQAaiHcASAHQaDkAGoh3QEgB0Hw4wBqId4BIAdBwOMAaiHfASAHQZDjAGoh4AEgB0Hg4gBqIeEBIAdBsOIAaiHiASAHQYDiAGohPyAHQdDhAGohQCAHQaDhAGohQSAHQfDgAGohQiAHQcDgAGoh4wEgB0GAPGohvgIgB0GAMGohvwIgB0GAJGohwAIgB0GAGGohwQIgB0Hg0wBqIeQBIAdBsNMAaiHlASAHQYDTAGoh5gEgB0HQ0gBqIecBIAdBoNIAaiHoASAHQfDRAGoh6QEgB0HA0QBqIeoBIAdBkNEAaiHrASAHQeDQAGoh7AEgB0Gw0ABqIe0BIAdBgNAAaiHuASAHQdDPAGoh7wEgB0GgzwBqIfABIAdB8M4AaiHxASAHQcDOAGoh8gEgB0GQzgBqIfMBIAdB4M0AaiH0ASAHQbDNAGoh9QEgB0GAzQBqIfYBIAdB0MwAaiH3ASAHQaDMAGoh+AEgB0HwywBqIfkBIAdBwMsAaiH6ASAHQZDLAGoh+wEgB0HgygBqIfwBIAdBsMoAaiFDIAdBgMoAaiFEIAdB0MkAaiFFIAdBoMkAaiFGIAdB8MgAaiFHIAdBwMgAaiH9ASAHQeDfAGoh/gEgB0Gw3wBqIf8BIAdBgN8AaiGAAiAHQdDeAGohgQIgB0Gg3gBqIYICIAdB8N0AaiGDAiAHQcDdAGohhAIgB0GQ3QBqIYUCIAdB4NwAaiGGAiAHQbDcAGohhwIgB0GA3ABqIYgCIAdB0NsAaiGJAiAHQaDbAGohigIgB0Hw2gBqIYsCIAdBwNoAaiGMAiAHQZDaAGohjQIgB0Hg2QBqIY4CIAdBsNkAaiGPAiAHQYDZAGohkAIgB0HQ2ABqIZECIAdBoNgAaiGSAiAHQfDXAGohkwIgB0HA1wBqIZQCIAdBkNcAaiGVAiAHQeDWAGohlgIgB0Gw1gBqIUggB0GA1gBqIUkgB0HQ1QBqIUogB0Gg1QBqIUsgB0Hw1ABqIUwgB0HA1ABqIZcCIApBBGohBkEAIU0DQCAAKAIAIQUgB0GQDGoiAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBIAMID79DAAAAAAAAAAAAAAAAAAAAAD9CwQAID5BEGoiGf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgD0IANwMAIA9BEGoigwFCADcDACAPQQhqIoQBQgA3AwAgD0EYaiKFAUIANwMAIA5CADcDACAOQRBqIoYBQgA3AwAgDkEIaiKHAUIANwMAIA5BGGoiiAFCADcDACANQgA3AwAgDUEQaiKJAUIANwMAIA1BCGoiigFCADcDACANQRhqIosBQgA3AwAgDEIANwMAIAxBEGoijAFCADcDACAMQQhqIo0BQgA3AwAgDEEYaiKOAUIANwMAIAtCADcDACALQRBqIo8BQgA3AwAgC0EIaiKQAUIANwMAIAtBGGoikQFCADcDACA9QRBqIpIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA9/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA4QRBqIpMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA4/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA3QRBqIpQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA3/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA2QRBqIpUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA2/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA1QRBqIpYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA1/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA0QRBqIpcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA0/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAzQRBqIpgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAz/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAyQRBqIpkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAy/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAxQRBqIpoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAx/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAwQRBqIpsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAw/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAvQRBqIpwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAv/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAuQRBqIp0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAu/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAtQRBqIp4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAt/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAsQRBqIp8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAs/QwAAAAAAAAAAAAAAAAAAAAA/QsEACArQRBqIqAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAqQRBqIqEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACApQRBqIqIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAp/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAoQRBqIqMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAnQRBqIqQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAn/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAmQRBqIqUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAm/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAlQRBqIqYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAkQRBqIqcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAk/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAjQRBqIqgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAj/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAiQRBqIqkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAi/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAhQRBqIqsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAh/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQgDQCAHQYAMaiAIQTBsaiIDIAdBkJABaiAIQQZqQR5xQTBsaiIJ/QAEAP0LBAAgAyAJKAIgNgIgIAMgCf0ABBD9CwQQIAdBgAxqIAhBAXJBMGxqIgMgB0GQkAFqIAhBB2pBH3FBMGxqIgn9AAQA/QsEACADIAn9AAQQ/QsEECADIAkoAiA2AiAgCEECaiIIQSBHDQALIAdB0NwBaiKqAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBMDcASCCAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgggFBEGoioQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIBpCADcDACAaQRBqIqICQgA3AwAgGkEIaiKjAkIANwMAIBpBGGoipAJCADcDACAYQgA3AwAgGEEQaiKlAkIANwMAIBhBCGoipgJCADcDACAYQRhqIqcCQgA3AwAgF0IANwMAIBdBEGoiqAJCADcDACAXQQhqIqkCQgA3AwAgF0EYaiKqAkIANwMAIBZCADcDACAWQRBqIqsCQgA3AwAgFkEIaiKsAkIANwMAIBZBGGoirQJCADcDACAVQgA3AwAgFUEQaiKuAkIANwMAIBVBCGoirwJCADcDACAVQRhqIrACQgA3AwAggQFBEGoinAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCAAUEQaiKdAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAggAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH9BEGoimwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH5BEGoingL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH1BEGoinwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH39DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHxBEGoioAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHtBEGoiwgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHpBEGoiwwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHlBEGoixAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHhBEGoixQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHdBEGoixgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHZBEGoixwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHVBEGoiyAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHRBEGoiyQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHNBEGoiygL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHJBEGoiywL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHFBEGoizAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHBBEGoizQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG9BEGoizgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG5BEGoizwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG1BEGoi0AL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG39DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGxBEGoi0QL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGtBEGoi0gL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGpBEGoi0wL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGlBEGoi1AL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhCANAIAdBwNwBaiAIQTBsaiIDIAdBkJABaiAIQQtqQR9xQTBsaiIJ/QAEAP0LBAAgAyAJKAIgNgIgIAMgCf0ABBD9CwQQIAdBwNwBaiAIQQFyQTBsaiIDIAdBkJABaiAIQQxqQR5xQTBsaiIJ/QAEAP0LBAAgAyAJ/QAEEP0LBBAgAyAJKAIgNgIgIAhBAmoiCEEgRw0ACyAHQdDQAWoi1QL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwTA0AEgaP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgaEEQaiLWAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgG0IANwMAIBtBEGoi1wJCADcDACAbQQhqItgCQgA3AwAgG0EYaiLZAkIANwMAIBNCADcDACATQRBqItoCQgA3AwAgE0EIaiLbAkIANwMAIBNBGGoi3AJCADcDACASQgA3AwAgEkEQaiLdAkIANwMAIBJBCGoi3gJCADcDACASQRhqIt8CQgA3AwAgEUIANwMAIBFBEGoi4AJCADcDACARQQhqIuECQgA3AwAgEUEYaiLiAkIANwMAIBBCADcDACAQQRBqIuMCQgA3AwAgEEEIaiLkAkIANwMAIBBBGGoi5QJCADcDACBnQRBqIuYC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBn/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBmQRBqIucC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBm/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBlQRBqIugC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBkQRBqIukC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBk/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBjQRBqIuoC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBj/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBiQRBqIusC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBi/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBhQRBqIuwC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBh/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBgQRBqIu0C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBg/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBfQRBqIu4C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBf/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBeQRBqIu8C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBe/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBdQRBqIvAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBd/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBcQRBqIvEC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBc/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBbQRBqIvIC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBb/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBaQRBqIvMC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBa/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBZQRBqIvQC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBZ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBYQRBqIvUC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBY/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBWQRBqIvYC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBW/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBVQRBqIvcC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBV/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBUQRBqIvgC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBU/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBTQRBqIvkC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBT/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBSQRBqIvoC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBS/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBRQRBqIvsC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBR/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBQQRBqIvwC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBQ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBPQRBqIv0C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBP/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBOQRBqIv4C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBO/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQgDQCAHQcDQAWogCEEwbGoiAyAHQZCQAWogCEEZakEfcUEwbGoiCf0ABAD9CwQAIAMgCSgCIDYCICADIAn9AAQQ/QsEECAHQcDQAWogCEEBckEwbGoiAyAHQZCQAWogCEEaakEecUEwbGoiCf0ABAD9CwQAIAMgCf0ABBD9CwQQIAMgCSgCIDYCICAIQQJqIghBIEcNAAsgB0Gg4ABq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAH/QwAAAAAAAAAAAAAAAAAAAAA/QsEkGAg4wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECBCQgA3AwAgQkIANwMQIEJCADcDCCBCQgA3AxggQUIANwMAIEFCADcDECBBQgA3AwggQUIANwMYIEBCADcDACBAQgA3AxAgQEIANwMIIEBCADcDGCA/QgA3AwAgP0IANwMQID9CADcDCCA/QgA3Axgg4gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIOIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDhAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg4QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDgAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg3wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIN8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDeAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg3gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIN0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDdAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg3AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQINwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDbAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg2wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAINoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDaAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg2QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQINkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDYAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg2AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAINcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDXAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg1gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQINYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDVAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg1QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAINQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDUAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg0wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQINMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDSAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg0gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAINEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDRAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg0AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQINAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDPAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgzwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIM4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDOAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgzQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIM0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDMAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgzAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDLAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgygH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIMoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDJAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgyQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhAwNAIAdBkNQAaiAFIANBMGwiCCAHQYAMamogB0HA3AFqIAhqIAdBwNABaiAIahCYCiAHQZDgAGogCGoiCCAHQbDUAGooAgA2AiAgCCAHQaDUAGoiCf0ABAD9CwQQIAggB/0ABJBU/QsEACADQQFqIgNBIEcNAAsgCf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LBJBUIJcC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCXAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgTEIANwMAIExCADcDECBMQgA3AwggTEIANwMYIEtCADcDACBLQgA3AxAgS0IANwMIIEtCADcDGCBKQgA3AwAgSkIANwMQIEpCADcDCCBKQgA3AxggSUIANwMAIElCADcDECBJQgA3AwggSUIANwMYIEhCADcDACBIQgA3AxAgSEIANwMIIEhCADcDGCCWAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAglgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJUC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCVAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAglAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJQC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCTAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgkwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJIC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCSAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgkQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIJEC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCQAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgkAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAII8C/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCPAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgjgL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQII4C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCNAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgjQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIwC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCMAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgiwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIsC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCKAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgigL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIkC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCJAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgiAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIgC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCHAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAghwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIYC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCGAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAghQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIUC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCEAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAghAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIMC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCDAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgggL9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIIIC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCBAv0MAAAAAAAAAAAAAAAAAAAAAP0LBBAggQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIIAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCAAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg/wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIP8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD+Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg/gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhCQNAIAdBgAxqIAogCUEwbCIIIAdBkJABamoiAyAHQZCEAWogCGoQlAogCigCAP0ABAAigAMgA/0ABAAQmgkh/wIgByCAAyAD/QAEEBCaCf0LBNDcASAHIP8CIIAD/VH9CwTA3AEgByADKAIgNgLg3AEgB0HA0AFqIAogB0HA3AFqIAdBkPgAaiAIahCUCgJAAkACfyAHKQOQDCAHKQOYDIRQBEAgB0GADGohBCA6IQUgB0HA0AFqDAELIAcpA9DQASAHKQPY0AGEQgBSDQEgB0HA0AFqIQQgPCEFIAdBgAxqCyID/QAEACAE/QAEAP1RIYADIAMoAiAhAwwBCyAGKAIAKAIAIDwgBygCoAwQjQohAyAGKAIAKAIAIDogBygC4NABEI0KIQUgBigCACgCACADIAUQ/AkhAyAHIAf9AATA0AEgB/0ABIAM/VH9CwSQSCAGKAIAKAIAIAMgB0GQyABqEJUKIQMgCigCACEF/QwAAAAAAAAAAAAAAAAAAAAAIYADCyAF/QAEACH/AiAHQZDUAGogCGoiCCADNgIgIAgg/wL9CwQQIAgggAP9CwQAIAlBAWoiCUEgRw0ACyAHQaDIAGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwSQSCD9Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg/QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQQgAhgQMgR0IANwMAIEdCADcDECBHQgA3AwggR0IANwMYIEZCADcDACBGQgA3AxAgRkIANwMIIEZCADcDGCBFQgA3AwAgRUIANwMQIEVCADcDCCBFQgA3AxggREIANwMAIERCADcDECBEQgA3AwggREIANwMYIENCADcDACBDQgA3AxAgQ0IANwMIIENCADcDGCD8Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg/AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECD7Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg+gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIPoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD5Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg+QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECD4Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg9wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIPcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD2Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg9gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECD1Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg9AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIPQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDzAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg8wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDyAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg8QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIPEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDwAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg8AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIO8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDvAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg7gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIO4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDtAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg7QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDsAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg6wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIOsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDqAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg6gH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDpAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg6AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIOgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDnAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg5wH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDmAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg5QH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIOUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDkAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAg5AH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE1BAnRBsNQxajUCACGCAwNAIAYoAgAoAgAhCCAHIAooAgD9AAQAIv8C/QsEwNwBIAggB0HA3AFqEOIJIQMgB/0MAAAAAAAAAAAAAAAAAAAAAP0LA4AMIAdCADcDmAwgB0J/NwOQDCADBEAgB0IANwLE0AEgByADNgLA0AEgB0GADGogB0HA0AFqEOcJCyAIIAdBgAxqEOMJIQMgBygCgAwiCARAIAcgCDYChAwgCBArCyAHQZDIAGoggQOnQTBsaiIIIAM2AiAgCP0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgCP0MAAAAAAAAAAAAAAAAAAAAACD/AiCCAyCBA4hCAYNQG/0LBAAggQNCAXwigQNCIFINAAsgB0GADGogB0GQ7ABqQYAM/AoAACDBAiAHQZDgAGpBgAz8CgAAIMACIAdBkNQAakGADPwKAAAgvwIgB0GQyABqQYAM/AoAACC+AiBNQYAMbCKtASAfakGADPwKAAAgB0GAPBCeCSIINgKESCAHIAhBgDxqIgM2AoxIIAggB0GADGpBgDz8CgAAIAcgAzYCiEggBygCkMwBIQggB0H80TE2AoAMIAcgB0GADGo2ApAMIAcgB0GEyABqNgKIDCAHIAdBkMwBajYChAwgCEEAQQUgB0GADGoQmQohrAECQCAHKAKQDCIIIAdBgAxqRgR/QRAFIAhFDQFBFAshAyAIIAgoAgAgA2ooAgARBgALIAAoAgAhBCAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAH/QwAAAAAAAAAAAAAAAAAAAAA/QsEgAwgPv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgGf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgD0IANwMAIIMBQgA3AwAghAFCADcDACCFAUIANwMAIA5CADcDACCGAUIANwMAIIcBQgA3AwAgiAFCADcDACANQgA3AwAgiQFCADcDACCKAUIANwMAIIsBQgA3AwAgDEIANwMAIIwBQgA3AwAgjQFCADcDACCOAUIANwMAIAtCADcDACCPAUIANwMAIJABQgA3AwAgkQFCADcDACCSAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgPf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgkwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA3/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCVAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgNv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAglgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA0/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCYAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgM/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgmQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAx/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCbAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgMP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgnAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJ0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAu/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCeAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgLf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgnwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAr/QwAAAAAAAAAAAAAAAAAAAAA/QsEACChAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgKv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgogH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAo/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCkAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJ/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgpQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAl/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCnAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgqAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAi/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCrAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgIf0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACEIA0AgB0GADGogCEEwbGoiAyAHQZDAAWogCEECaiIJQR5xQTBsaiIF/QAEAP0LBAAgAyAFKAIgNgIgIAMgBf0ABBD9CwQQIAdBgAxqIAhBAXJBMGxqIgMgB0GQwAFqIAhBA2pBH3FBMGxqIgj9AAQA/QsEACADIAj9AAQQ/QsEECADIAgoAiA2AiAgCSIIQSBHDQALIKoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAH/QwAAAAAAAAAAAAAAAAAAAAA/QsEwNwBIIIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACChAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgGkIANwMAIKICQgA3AwAgowJCADcDACCkAkIANwMAIBhCADcDACClAkIANwMAIKYCQgA3AwAgpwJCADcDACAXQgA3AwAgqAJCADcDACCpAkIANwMAIKoCQgA3AwAgFkIANwMAIKsCQgA3AwAgrAJCADcDACCtAkIANwMAIBVCADcDACCuAkIANwMAIK8CQgA3AwAgsAJCADcDACCcAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAggQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJ0C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCAAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgmwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIH/9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJ4C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB+/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCfAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgff0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgoAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHz9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMIC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB7/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDDAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgev0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgxAL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHn9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMUC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB4/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDGAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgd/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgxwL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHb9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMgC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACB1/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDJAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgdP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgygL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHP9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMsC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBy/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDMAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgcf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgzQL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIHD9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIM4C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBv/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDPAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgbv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg0AL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIG39DAAAAAAAAAAAAAAAAAAAAAD9CwQAINEC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBs/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDSAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAga/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg0wL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGr9DAAAAAAAAAAAAAAAAAAAAAD9CwQAINQC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBp/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQgDQCAHQcDcAWogCEEwbGoiAyAHQZDAAWogCEENakEfcUEwbGoiCf0ABAD9CwQAIAMgCSgCIDYCICADIAn9AAQQ/QsEECAHQcDcAWogCEEBckEwbGoiAyAHQZDAAWogCEEOakEecUEwbGoiCf0ABAD9CwQAIAMgCf0ABBD9CwQQIAMgCSgCIDYCICAIQQJqIghBIEcNAAsg1QL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwTA0AEgaP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg1gL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIBtCADcDACDXAkIANwMAINgCQgA3AwAg2QJCADcDACATQgA3AwAg2gJCADcDACDbAkIANwMAINwCQgA3AwAgEkIANwMAIN0CQgA3AwAg3gJCADcDACDfAkIANwMAIBFCADcDACDgAkIANwMAIOECQgA3AwAg4gJCADcDACAQQgA3AwAg4wJCADcDACDkAkIANwMAIOUCQgA3AwAg5gL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOcC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBm/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDoAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgZf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg6QL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIOoC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBj/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDrAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgYv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg7AL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIGH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIO0C/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBg/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDuAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgX/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg7wL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIF79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBd/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDxAv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgXP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg8gL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPMC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBa/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD0Av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgWf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg9QL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPYC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBW/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD3Av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgVf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg+AL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPkC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBT/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD6Av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgUv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg+wL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIFH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIPwC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACBQ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACD9Av0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgT/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAg/gL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIE79DAAAAAAAAAAAAAAAAAAAAAD9CwQAQQAhCANAIAdBwNABaiAIQTBsaiIDIAdBkMABaiAIQRZqQR5xQTBsaiIJ/QAEAP0LBAAgAyAJKAIgNgIgIAMgCf0ABBD9CwQQIAdBwNABaiAIQQFyQTBsaiIDIAdBkMABaiAIQRdqQR9xQTBsaiIJ/QAEAP0LBAAgAyAJ/QAEEP0LBBAgAyAJKAIgNgIgIAhBAmoiCEEgRw0ACyAH/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAH/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDIAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgyAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQICBCADcDACAgQgA3AxAgIEIANwMIICBCADcDGCAeQgA3AwAgHkIANwMQIB5CADcDCCAeQgA3AxggHUIANwMAIB1CADcDECAdQgA3AwggHUIANwMYIBxCADcDACAcQgA3AxAgHEIANwMIIBxCADcDGCDHAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgxwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDGAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgxQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIMUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDEAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgxAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDDAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgwgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIMIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACDBAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgwQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIMAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECDAAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgvwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQIL8B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACC+Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgvgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIL0B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECC9Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgvAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQILwB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACC7Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAguwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAILoB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECC6Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAguQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQILkB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACC4Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAguAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAILcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECC3Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgtgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQILYB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACC1Af0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgtQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAILQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECC0Af0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgswH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQILMB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCyAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgsgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAILEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCxAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgsAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQQILAB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCvAf0MAAAAAAAAAAAAAAAAAAAAAP0LBBAgrwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIK4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEECCuAf0MAAAAAAAAAAAAAAAAAAAAAP0LBABBACEDA0AgB0HA6AFqIAQgA0EwbCIIIAdBgAxqaiAHQcDcAWogCGogB0HA0AFqIAhqEJgKIAcgCGoiCCAHQeDoAWooAgA2AiAgCCAHQdDoAWr9AAQA/QsEECAIIAf9AATA6AH9CwQAIANBAWoiA0EgRw0ACyAHIAcoApDMASIINgKEDCAHQaDSMTYCgAwgByAHQYAMajYCkAwgByAHNgKMDCAHIAdBkMwBajYCiAwgCEEAQSAgB0GADGoQmQohqgECQCAHKAKQDCIIIAdBgAxqRgR/QRAFIAhFDQFBFAshAyAIIAgoAgAgA2ooAgARBgALIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwSADCA+/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAZ/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAPQgA3AwAggwFCADcDACCEAUIANwMAIIUBQgA3AwAgDkIANwMAIIYBQgA3AwAghwFCADcDACCIAUIANwMAIA1CADcDACCJAUIANwMAIIoBQgA3AwAgiwFCADcDACAMQgA3AwAgjAFCADcDACCNAUIANwMAII4BQgA3AwAgC0IANwMAII8BQgA3AwAgkAFCADcDACCRAUIANwMAIJIB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA9/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCTAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgOP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAglAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDf9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJUB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACA2/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCWAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgNf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAglwH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDT9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJgB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAz/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCZAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgMv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgmgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIDH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAw/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCcAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgL/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgnQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIC79DAAAAAAAAAAAAAAAAAAAAAD9CwQAIJ4B/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAt/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCfAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgLP0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgoAH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICv9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKEB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAq/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCiAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgKf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgowH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKQB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAn/QwAAAAAAAAAAAAAAAAAAAAA/QsEACClAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgJv0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgpgH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICX9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKcB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAk/QwAAAAAAAAAAAAAAAAAAAAA/QsEACCoAf0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgI/0MAAAAAAAAAAAAAAAAAAAAAP0LBAAgqQH9DAAAAAAAAAAAAAAAAAAAAAD9CwQAICL9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIKsB/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAh/QwAAAAAAAAAAAAAAAAAAAAA/QsEAEEAIQQDQCAEQTBsIgkgB0GQqAFqaiEZIAdBkMABaiAJaiIIIQEgB0GQtAFqIAlqIgMhBQJAAkAgCCkDECAIKQMYhEIAUgRAIAMhASAIIQUgAykDECADKQMYhEIAUg0BCyAF/QAEACH/AiAB/QAEACGAAyAHIAX9AAQQ/QsE0NwBIAcg/wIggAP9Uf0LBMDcASAFKAIgIQUMAQsgBigCACgCACAIQRBqIAgoAiAQjQohBSAGKAIAKAIAIANBEGogAygCIBCNCiEBIAYoAgAoAgAgBSABEPwJIQUgByAD/QAEACAI/QAEAP1R/QsEwNwBIAYoAgAoAgAgBSAHQcDcAWoQlQohBSAHIAooAgD9AAQA/QsE0NwBIAf9DAAAAAAAAAAAAAAAAAAAAAD9CwTA3AELIAcgBTYC4NwBIAdBwNABaiAKIAggAxCUCiAHIAogB0HA3AFqIBkQlAoCQAJAAn8gBykD0NABIAcpA9jQAYRQBEAgByEIIAdBwNABaiEFIDkMAQsgBykDECAHKQMYhEIAUg0BIAdBwNABaiEIIAchBSA7CyEDIAj9AAQAIAX9AAQA/VEh/wIgCCgCICEFDAELIAYoAgAoAgAgOyAHKALg0AEQjQohCCAGKAIAKAIAIDkgBygCIBCNCiEDIAYoAgAoAgAgCCADEPwJIQggByAH/QAEACAH/QAEwNAB/VH9CwTA6AEgBigCACgCACAIIAdBwOgBahCVCiEFIAooAgAhA/0MAAAAAAAAAAAAAAAAAAAAACH/AgsgA/0ABAAhgAMgB0GADGogCWoiCCAFNgIgIAgggAP9CwQQIAgg/wL9CwQAIARBAWoiBEEgRw0ACyAHIAcoApDMASIINgLE3AEgB0Gg0jE2AsDcASAHIAdBwNwBajYC0NwBIAcgB0GADGo2AszcASAHIAdBkMwBajYCyNwBIAhBAEEgIAdBwNwBahCZCiEDAkAgBygC0NwBIgggB0HA3AFqRgR/QRAFIAhFDQFBFAshCSAIIAgoAgAgCWooAgARBgALIAcgBygCkMwBKAIEKAIAIggoAgD9AAQA/QsEgAwgCCAHQYAMaiCqASADEPsJIQMgB0GQ7ABqIAdBkPgAakGADPwKAAAgB0GQ+ABqIAdBkIQBakGADPwKAAAgB0GQhAFqIAdBkJABakGADPwKAAAgB0GQkAFqIK0BIJkCakGADPwKAAAgByAHKAKQzAEiCDYChAwgB0Gg0jE2AoAMIAcgB0GADGo2ApAMIAcgB0GQnAFqNgKMDCAHIAdBkMwBajYCiAwgCEEAQSAgB0GADGoQmQohCQJAIAcoApAMIgggB0GADGpGBH9BEAUgCEUNAUEUCyEFIAggCCgCACAFaigCABEGAAsgByAHKAKQzAEoAgQoAgAiCCgCAP0ABAD9CwSADCAHIAggB0GADGogrAEgCRD7CTYCwNwBIAdBkMwBaiAHQZCQAWogB0HA3AFqQQYQmgogB0GQnAFqIAdBkKgBakGADPwKAAAgB0GQqAFqIAdBkLQBakGADPwKAAAgB0GQtAFqIAdBkMABakGADPwKAAAgB0GQwAFqIK0BIJoCakGADPwKAAAgByAHKAKQzAEoAgQoAgAiCCgCAP0ABAD9CwSADCAHIAggB0GADGogrAEgAxD7CTYCwNwBIAdBkMwBaiAHQZDAAWogB0HA3AFqQQcQmgogBygChEgiCARAIAcgCDYCiEggCBArCyBNQQFqIk1BwABHDQALIAcgB0GQzAFqIAIgB0GQwAFqEJsKNgKADCAHQZDMAWogFCAHQYAMakECEJoKIAcgB0GQzAFqIFcgB0GQtAFqEJsKNgKADCAHQZDMAWogsQIgB0GADGpBAhCaCiAHIAdBkMwBaiC4AiAHQZCoAWoQmwo2AoAMIAdBkMwBaiCyAiAHQYAMakECEJoKIAcgB0GQzAFqILkCIAdBkJwBahCbCjYCgAwgB0GQzAFqILMCIAdBgAxqQQIQmgogByAHQZDMAWogugIgB0GQkAFqEJsKNgKADCAHQZDMAWogtAIgB0GADGpBAhCaCiAHIAdBkMwBaiC7AiAHQZCEAWoQmwo2AoAMIAdBkMwBaiC1AiAHQYAMakECEJoKIAcgB0GQzAFqILwCIAdBkPgAahCbCjYCgAwgB0GQzAFqILYCIAdBgAxqQQIQmgogByAHQZDMAWogvQIgB0GQ7ABqEJsKNgKADCAHQZDMAWogtwIgB0GADGpBAhCaCiAfECsgmgIQKyCZAhArIJgCECsgFBArIAdB8OgBaiQAC40EAgN/A3sjAEFAaiIFJAACQAJAAkAgAikDECACKQMYhFAEQCACIQYMAQsgAykDECADKQMYhEIAUg0BIAMhBiACIQMLIAP9AAQAIQkgBv0ABAAhCiAFIAP9AAQQIgj9CwQQIAUgCSAK/VEiCf0LBAAgAygCICEDDAELIAEoAgQoAgAgAkEQaiACKAIgEI0KIQYgASgCBCgCACADQRBqIAMoAiAQjQohByABKAIEKAIAIAYgBxD8CSEGIAUgA/0ABAAgAv0ABAD9Uf0LBDAgASgCBCgCACAGIAVBMGoQlQohAyAFIAEoAgD9AAQAIgj9CwQQIAX9DAAAAAAAAAAAAAAAAAAAAAD9CwQACyAFIAM2AiACQAJAIAj9HQAgCP0dAYRCAFIEQCAEKQMQIAQpAxiEQgBSDQEgBP0ABAAhCSAFIQQLIAT9AAQAIQggACAE/QAEEP0LBBAgACAIIAn9Uf0LBAAgACAEKAIgNgIgDAELIAEoAgQoAgAgBUEQaiADEI0KIQMgASgCBCgCACAEQRBqIAQoAiAQjQohAiABKAIEKAIAIAMgAhD8CSEDIAUgBP0ABAAgBf0ABAD9Uf0LBDAgASgCBCgCACADIAVBMGoQlQohBCABKAIA/QAEACEIIAAgBDYCICAAIAj9CwQQIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwQACyAFQUBrJAALsQIBAn8jAEFAaiIEJAACQCABIAJPBEAgBCAAKAIA/QAEMP0LBAAgACgCBCgCACICIAQQ4gkhASAE/QwAAAAAAAAAAAAAAAAAAAAA/QsDECAEQgA3AyggBEJ/NwMgIAEEQCAEQgA3AjggBCABNgI0IARBEGogBEE0ahDnCQsgAiAEQRBqEOMJIQEgBCgCECICRQ0BIAQgAjYCFCACECsMAQsCQCABQQFqIAJGBEAgBCABNgIQIAMoAhAiAUUNASABIARBEGogASgCACgCGBEFACEBDAILIAAgASACIAFrQQF2IAFqIgUgAxCZCiEBIAAgBSACIAMQmQohAiAEIAAoAgQoAgAiACgCAP0ABAD9CwQQIAAgBEEQaiABIAIQ+wkhAQwBCxCgCQALIARBQGskACABC7IDAgZ/AXsjAEEwayIFJAAgACgCACIIKAIAIQcgBSADQQR0IgQQngkiBjYCDCAFIAQgBmoiCTYCFCAEBEAgBkEAIAT8CwALIAUgCTYCECAGIAf9AAQA/QsEACAGQRBrIQkgAP0ABKAEIQpBASEEA0AgBiAEQQR0IgdqIAogByAJav0ABAAQmgn9CwQAIARBAWoiBCADRw0ACyAAKAIAIQQgBSABNgIkIAUgADYCICAFIAQ2AhwgBUGg0jE2AhggBSAFQRhqNgIoIARBAEEgIAVBGGoQmQohBwJAIAUoAigiBCAFQRhqRgR/QRAFIARFDQFBFAshBiAEIAQoAgAgBmooAgARBgALIAUgBzYCCEEUIQdBFBCiCSIEIAI2AgwgBCAINgIEIARB2NExNgIAIAQgBUEIajYCECAEIAVBDGo2AgggBSAENgIoIAhBACADIAVBGGoQmQohBgJAAkAgBSgCKCIEIAVBGGpGBEBBECEHDAELIARFDQELIAQgBCgCACAHaigCABEGAAsgCCgCBCgCACAGEO8JIAUoAgwiBARAIAUgBDYCECAEECsLIAVBMGokAAuHAgEDfyMAQSBrIgMkACAAKAIAIQQgAyABNgIMIAMgADYCCCADIAQ2AgQgA0Gg0jE2AgAgAyADNgIQIARBAEEgIAMQmQohAQJAIAMgAygCECIERgR/QRAFIARFDQFBFAshBSAEIAQoAgAgBWooAgARBgALIAAoAgAhBCADIAI2AgwgAyAANgIIIAMgBDYCBCADQaDSMTYCACADIAM2AhAgBEEAQSAgAxCZCiECAkAgAyADKAIQIgRGBH9BEAUgBEUNAUEUCyEFIAQgBCgCACAFaigCABEGAAsgAyAAKAIAKAIEKAIAIgAoAgD9AAQA/QsEACAAIAMgASACEPsJIQAgA0EgaiQAIAALKAEBf0EQEKIJIgFBoNIxNgIAIAEgACkCBDcCBCABIAAoAgw2AgwgAQsfACABQaDSMTYCACABIAApAgQ3AgQgASAAKAIMNgIMC7EEAgV/AnsjAEGgAWsiAiQAIAAoAgQoAgQoAgAiAyAAKAIIIAEoAgAiBUEEdGpBEGoQ4gkhASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDcCACQgA3A4gBIAJCfzcDgAEgAQRAIAJCADcCRCACIAE2AkAgAkHwAGogAkFAaxDnCQsgAyACQfAAahDjCSEDIAIoAnAiAQRAIAIgATYCdCABECsLIAAoAgwhBiACIAAoAgQiACgCAP0ABAD9CwQAIAAoAgQoAgAiBCACEOIJIQEgAv0MAAAAAAAAAAAAAAAAAAAAAP0LA3AgAkIANwOIASACQn83A4ABIAEEQCACQgA3AkQgAiABNgJAIAJB8ABqIAJBQGsQ5wkLIAQgAkHwAGoQ4wkhBCACKAJwIgEEQCACIAE2AnQgARArCyAAKAIA/QAEACEHIAIgAzYCYCACIAf9CwRQIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwRAIAJB8ABqIAAgBiAFQTBsaiIBIAJBQGsQlAogACACQfAAahDuCSEDIAAoAgD9AAQAIgcgAf0ABAAQmgkhCCACIAcgAf0ABBAQmgn9CwQgIAIgCCAH/VH9CwQQIAIgASgCIDYCMCACIAQ2AmAgAiAH/QsEUCAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEQCACQfAAaiAAIAJBEGogAkFAaxCUCiAAIAJB8ABqEO4JIQEgACgCBCgCACADIAEQ/AkhACACQaABaiQAIAALIAEBf0EUEKIJIgFB2NExNgIAIAEgAP0AAgT9CwIEIAELFwAgAUHY0TE2AgAgASAA/QACBP0LAgQL4gEBBH8jAEEwayICJAAgACgCBCgCBCgCACIDIAAoAggoAgAgASgCAEEEdGoQ4gkhASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQgA3AxggAkJ/NwMQIAEEQCACQgA3AiggAiABNgIkIAIgAkEkahDnCQsgAyACEOMJIQMgAigCACIBBEAgAiABNgIEIAEQKwsgACgCDCEBIAAoAhAoAgAhBCACIAAoAgQiACgCBCgCACIFKAIA/QAEAP0LBAAgBSACIAMgBBD7CSEDIAAoAgQgASADEP0JIQAgAkEwaiQAIAALHgEBf0EMEKIJIgFB/NExNgIAIAEgACkCBDcCBCABCxUAIAFB/NExNgIAIAEgACkCBDcCBAuZAQEDfyMAQSBrIgIkACAAKAIEIgQoAgAhAyACIAAoAggoAgAgASgCAEGADGxqNgIUIAIgBDYCECACIAM2AgwgAkGg0jE2AgggAiACQQhqNgIYIANBAEEgIAJBCGoQmQohAwJAIAIoAhgiACACQQhqRgR/QRAFIABFDQFBFAshASAAIAAoAgAgAWooAgARBgALIAJBIGokACADCx4BAX9BDBCiCSIBQfjPMTYCACABIAApAgQ3AgQgAQsVACABQfjPMTYCACABIAApAgQ3AgQL6AEBBX8CQCAAKAIEIgItAB4gACgCCCgCTCABKAIAQQV0aiIALQAeRw0AIAIoAhAgACgCEEcNACACLQAdIAAtAB1HDQAgAigCFCAAKAIURw0AIAIoAgQiBSACKAIAIgJrIgFBDG0hBCABIAAoAgQgACgCACIGa0cNACACIAVGBEBBAQ8LQQEgBCAEQQFNGyEEQQAhAANAAkAgAiAAQQxsIgFqIgMoAgAgASAGaiIBKAIARw0AIAMoAgQgASgCBEcNACADKAIIIAEoAghHDQBBASEDIAQgAEEBaiIARw0BDAILC0EAIQMLIAMLiQIBBn8gACgCBCICIAAoAggiA0kEQCACIAH9AAMA/QsDACACIAH9AAMQ/QsDECAAIAJBIGo2AgQPCwJAIAIgACgCACIEayIFQQV1IgdBAWoiAkGAgIDAAEkEQEH///8/IAMgBGsiA0EEdSIGIAIgAiAGSRsgA0Hg////B08bIgMEfyADQYCAgMAATw0CIANBBXQQogkFQQALIgYgBWoiAiAB/QADAP0LAwAgAiAB/QADEP0LAxAgAiAHQQV0ayEBIAUEQCABIAQgBfwKAAALIAAgBiADQQV0ajYCCCAAIAJBIGoiAjYCBCAAIAE2AgAgBARAIAQQKwsgACACNgIEDwsQoAkACxCgCQAL2gEBBX8jAEHgAGsiBSQAIAVBQGsgBCAAIAEQmQkgBSAF/QADQP0LBCAgBSAF/QADUP0LBDAgBUFAayAEIAIgAxCZCSAFIAX9AANA/QsEACAFIAX9AANQ/QsEEEEAIQQCQANAQQEhByAFQSBqIARqLQAAIgYgBCAFai0AACIISQRAQQEhCQwCCyAGIAhLDQEgBEEBciIGIAVBIGpqLQAAIgggBSAGai0AACIGSQRAQQEhCQwCCyAGIAhJDQEgBEECaiIEQSBHDQALQQAhBwsgBUHgAGokACAHIAlxC90IARJ/IwBBMGsiBSQAIAAgASACIAQQrAoCQAJAIAIoAgQiBiADKAIEIg9Bf3MiCnEiCyALIAIoAggiCCADKAIIIglBf3MiDHMiB3EgCCAMcXMiCyAHIAYgCnMiCnFzIAtqIAdzIApxcyAHc0EATg0AIAYgD0cNASAIIAlHDQEgAygCACIHIAIoAgAiBkkNACAGIAdJDQEgA/0AAxAgA/0AAyAgAv0AAxAgAv0AAyAgBCgCABCpCkUNAQsgBUEgaiIHIAJBIGoiBv0AAwD9CwMAIAVBEGoiCCACQRBqIgr9AAMA/QsDACAFIAL9AAMA/QsDACACQShqIgwgA0EoaiIJKQMANwMAIAYgA0EgaiIQKQMANwMAIAJBGGoiDyADQRhqIg0pAwA3AwAgCiADQRBqIg4pAwA3AwAgAkEIaiILIANBCGoiESkDADcDACACIAMpAwA3AwAgCSAFQShqIhIpAwA3AwAgECAHKQMANwMAIA0gBUEYaiITKQMANwMAIA4gCCkDADcDACARIAVBCGoiFCkDADcDACADIAUpAwA3AwACQCABKAIEIgkgAigCBCIVQX9zIg1xIg4gDiABKAIIIhAgCygCACIWQX9zIhFzIgNxIBAgEXFzIg4gAyAJIA1zIg1xcyAOaiADcyANcXMgA3NBAE4NACAJIBVHDQEgECAWRw0BIAIoAgAiAyABKAIAIglJDQAgAyAJSw0BIAL9AAMQIAL9AAMgIAH9AAMQIAH9AAMgIAQoAgAQqQpFDQELIAcgAUEgaiID/QADAP0LAwAgCCABQRBqIgn9AAMA/QsDACAFIAH9AAMA/QsDACABIAwpAwA3AyggAyAGKQMANwMAIAEgDykDADcDGCAJIAopAwA3AwAgAUEIaiIJIAspAwA3AwAgASACKQMANwMAIAwgEikDADcDACAGIAcpAwA3AwAgDyATKQMANwMAIAogCCkDADcDACALIBQpAwA3AwAgAiAFKQMANwMAAkAgACgCBCIDIAEoAgQiC0F/cyIGcSIIIAggACgCCCIHIAkoAgAiDEF/cyIKcyICcSAHIApxcyIIIAIgAyAGcyIGcXMgCGogAnMgBnFzIAJzQQBODQAgAyALRw0BIAcgDEcNASABKAIAIgIgACgCACIDSQ0AIAIgA0sNASAB/QADECAB/QADICAA/QADECAA/QADICAEKAIAEKkKRQ0BCyAFQSBqIgIgAEEgaiID/QADAP0LAwAgBUEQaiIHIABBEGoiBv0AAwD9CwMAIAUgAP0AAwD9CwMAIAAgAUEoaiIIKQMANwMoIAMgAUEgaiIKKQMANwMAIAAgAUEYaiIDKQMANwMYIAYgAUEQaiILKQMANwMAIAAgAUEIaiIGKQMANwMIIAAgASkDADcDACAIIAUpAyg3AwAgCiACKQMANwMAIAMgBSkDGDcDACALIAcpAwA3AwAgBiAFKQMINwMAIAEgBSkDADcDAAsgBUEwaiQAC8MLARJ/IwBBMGsiBiQAIAAgASACIAMgBRCqCgJAAkAgAygCBCIIIAQoAgQiDkF/cyILcSIMIAwgAygCCCIKIAQoAggiB0F/cyIPcyIJcSAKIA9xcyIMIAkgCCALcyILcXMgDGogCXMgC3FzIAlzQQBODQAgCCAORw0BIAcgCkcNASAEKAIAIgkgAygCACIISQ0AIAggCUkNASAE/QADECAE/QADICAD/QADECAD/QADICAFKAIAEKkKRQ0BCyAGQSBqIgkgA0EgaiII/QADAP0LAwAgBkEQaiIKIANBEGoiC/0AAwD9CwMAIAYgA/0AAwD9CwMAIANBKGoiDyAEQShqIgcpAwA3AwAgCCAEQSBqIg0pAwA3AwAgA0EYaiIOIARBGGoiECkDADcDACALIARBEGoiESkDADcDACADQQhqIgwgBEEIaiISKQMANwMAIAMgBCkDADcDACAHIAZBKGoiEykDADcDACANIAkpAwA3AwAgECAGQRhqIhQpAwA3AwAgESAKKQMANwMAIBIgBkEIaiIVKQMANwMAIAQgBikDADcDAAJAIAIoAgQiByADKAIEIhZBf3MiEHEiESARIAIoAggiDSAMKAIAIhdBf3MiEnMiBHEgDSAScXMiESAEIAcgEHMiEHFzIBFqIARzIBBxcyAEc0EATg0AIAcgFkcNASANIBdHDQEgAygCACIEIAIoAgAiB0kNACAEIAdLDQEgA/0AAxAgA/0AAyAgAv0AAxAgAv0AAyAgBSgCABCpCkUNAQsgCSACQSBqIgT9AAMA/QsDACAKIAJBEGoiB/0AAwD9CwMAIAYgAv0AAwD9CwMAIAIgDykDADcDKCAEIAgpAwA3AwAgAiAOKQMANwMYIAcgCykDADcDACACQQhqIgcgDCkDADcDACACIAMpAwA3AwAgDyATKQMANwMAIAggCSkDADcDACAOIBQpAwA3AwAgCyAKKQMANwMAIAwgFSkDADcDACADIAYpAwA3AwACQCABKAIEIgQgAigCBCIMQX9zIghxIgogCiABKAIIIgkgBygCACIPQX9zIgtzIgNxIAkgC3FzIgogAyAEIAhzIghxcyAKaiADcyAIcXMgA3NBAE4NACAEIAxHDQEgCSAPRw0BIAIoAgAiAyABKAIAIgRJDQAgAyAESw0BIAL9AAMQIAL9AAMgIAH9AAMQIAH9AAMgIAUoAgAQqQpFDQELIAZBIGoiBCABQSBqIgn9AAMA/QsDACAGQRBqIgggAUEQaiIK/QADAP0LAwAgBiAB/QADAP0LAwAgAUEoaiIMIAJBKGoiAykDADcDACAJIAJBIGoiDikDADcDACABQRhqIg8gAkEYaiIHKQMANwMAIAogAkEQaiINKQMANwMAIAFBCGoiCyACQQhqIhApAwA3AwAgASACKQMANwMAIAMgBkEoaiIRKQMANwMAIA4gBCkDADcDACAHIAZBGGoiEikDADcDACANIAgpAwA3AwAgECAGQQhqIhMpAwA3AwAgAiAGKQMANwMAAkAgACgCBCICIAEoAgQiFEF/cyIHcSINIA0gACgCCCIOIAsoAgAiFUF/cyIQcyIDcSAOIBBxcyINIAMgAiAHcyIHcXMgDWogA3MgB3FzIANzQQBODQAgAiAURw0BIA4gFUcNASABKAIAIgMgACgCACICSQ0AIAIgA0kNASAB/QADECAB/QADICAA/QADECAA/QADICAFKAIAEKkKRQ0BCyAEIABBIGoiA/0AAwD9CwMAIAggAEEQaiIC/QADAP0LAwAgBiAA/QADAP0LAwAgACAMKQMANwMoIAMgCSkDADcDACAAIA8pAwA3AxggAiAKKQMANwMAIAAgCykDADcDCCAAIAEpAwA3AwAgDCARKQMANwMAIAkgBCkDADcDACAPIBIpAwA3AwAgCiAIKQMANwMAIAsgEykDADcDACABIAYpAwA3AwALIAZBMGokAAuNDgESfyMAQTBrIgUkACADKAIAIQ0CQAJAIAAoAgQiBiABKAIEIghBf3MiC3EiDCAMIAAoAggiByABKAIIIglBf3MiCnMiBHEgByAKcXMiDCAEIAYgC3MiC3FzIAxqIARzIAtxcyAEc0EATg0AAkAgBiAIRw0AIAcgCUcNACABKAIAIgQgACgCACIGSQ0BIAQgBksNACAB/QADECAB/QADICAA/QADECAA/QADICANEKkKDQELAkAgCCACKAIEIgxBf3MiBnEiByAHIAkgAigCCCIKQX9zIgtzIgRxIAkgC3FzIgcgBCAGIAhzIgZxcyAHaiAEcyAGcXMgBHNBAE4NACAIIAxHDQIgCSAKRw0CIAIoAgAiBCABKAIAIghJDQAgBCAISw0CIAL9AAMQIAL9AAMgIAH9AAMQIAH9AAMgIA0QqQpFDQILIAVBIGoiBCABQSBqIgj9AAMA/QsDACAFQRBqIgkgAUEQaiIG/QADAP0LAwAgBSAB/QADAP0LAwAgAUEoaiILIAJBKGoiCikDADcDACAIIAJBIGoiDSkDADcDACABQRhqIgwgAkEYaiIOKQMANwMAIAYgAkEQaiIPKQMANwMAIAFBCGoiByACQQhqIhApAwA3AwAgASACKQMANwMAIAogBUEoaiIRKQMANwMAIA0gBCkDADcDACAOIAVBGGoiEikDADcDACAPIAkpAwA3AwAgECAFQQhqIhMpAwA3AwAgAiAFKQMANwMAAkAgACgCBCIKIAEoAgQiFEF/cyIOcSIPIA8gACgCCCINIAcoAgAiFUF/cyIQcyICcSANIBBxcyIPIAIgCiAOcyIOcXMgD2ogAnMgDnFzIAJzQQBODQAgCiAURw0CIA0gFUcNAiABKAIAIgIgACgCACIKSQ0AIAIgCksNAiAB/QADECAB/QADICAA/QADECAA/QADICADKAIAEKkKRQ0CCyAEIABBIGoiAv0AAwD9CwMAIAkgAEEQaiID/QADAP0LAwAgBSAA/QADAP0LAwAgACALKQMANwMoIAIgCCkDADcDACAAIAwpAwA3AxggAyAGKQMANwMAIAAgBykDADcDCCAAIAEpAwA3AwAgCyARKQMANwMAIAggBCkDADcDACAMIBIpAwA3AwAgBiAJKQMANwMAIAcgEykDADcDACABIAUpAwA3AwAMAQsCQAJAIAggAigCBCIMQX9zIgZxIgcgByAJIAIoAggiCkF/cyILcyIEcSAJIAtxcyIHIAQgBiAIcyIGcXMgB2ogBHMgBnFzIARzQQBODQAgCCAMRw0BIAkgCkcNASACKAIAIgQgASgCACIISQ0AIAQgCEsNASAC/QADECAC/QADICAB/QADECAB/QADICANEKkKRQ0BCyAFQSBqIgEgAEEgaiIE/QADAP0LAwAgBUEQaiIIIABBEGoiCf0AAwD9CwMAIAUgAP0AAwD9CwMAIAAgAkEoaiIGKQMANwMoIAQgAkEgaiIHKQMANwMAIAAgAkEYaiIEKQMANwMYIAkgAkEQaiIDKQMANwMAIAAgAkEIaiIJKQMANwMIIAAgAikDADcDACAGIAUpAyg3AwAgByABKQMANwMAIAQgBSkDGDcDACADIAgpAwA3AwAgCSAFKQMINwMAIAIgBSkDADcDAAwBCyAFQSBqIgggAEEgaiIE/QADAP0LAwAgBUEQaiIJIABBEGoiCv0AAwD9CwMAIAUgAP0AAwD9CwMAIAAgAUEoaiILKQMANwMoIAQgAUEgaiIGKQMANwMAIAAgAUEYaiIMKQMANwMYIAogAUEQaiIHKQMANwMAIAAgAUEIaiIEKQMANwMIIAAgASkDADcDACALIAVBKGoiESkDADcDACAGIAgpAwA3AwAgDCAFQRhqIhIpAwA3AwAgByAJKQMANwMAIAQgBUEIaiITKQMANwMAIAEgBSkDADcDAAJAIAEoAgQiCiACKAIEIhRBf3MiDnEiDyAPIAQoAgAiDSACKAIIIhVBf3MiEHMiAHEgDSAQcXMiDyAAIAogDnMiDnFzIA9qIABzIA5xcyAAc0EATg0AIAogFEcNASANIBVHDQEgAigCACIAIAEoAgAiCkkNACAAIApLDQEgAv0AAxAgAv0AAyAgAf0AAxAgAf0AAyAgAygCABCpCkUNAQsgCCAG/QADAP0LAwAgCSAH/QADAP0LAwAgBSAB/QADAP0LAwAgCyACQShqIgApAwA3AwAgBiACQSBqIgMpAwA3AwAgDCACQRhqIgYpAwA3AwAgByACQRBqIgspAwA3AwAgBCACQQhqIgcpAwA3AwAgASACKQMANwMAIAAgESkDADcDACADIAgpAwA3AwAgBiASKQMANwMAIAsgCSkDADcDACAHIBMpAwA3AwAgAiAFKQMANwMACyAFQTBqJAALvwgCEH8CeyMAQTBrIgwkAEEBIQYCQAJAAkACQAJAAkAgASAAa0EwbQ4GBQUAAQIDBAsgAUEwayEEAkAgACgCBCIFIAFBLGsoAgAiDkF/cyIHcSIKIAogACgCCCIIIAFBKGsoAgAiDUF/cyILcyIDcSAIIAtxcyIKIAMgBSAHcyIHcXMgCmogA3MgB3FzIANzQQBODQAgBSAORw0FIAggDUcNBSAEKAIAIgMgACgCACIFSQ0AIAMgBUsNBSABQSBr/QADACABQRBr/QADACAA/QADECAA/QADICACKAIAEKkKRQ0FCyAMQSBqIgMgAEEgaiIF/QADAP0LAwAgDEEQaiIIIABBEGoiB/0AAwD9CwMAIAwgAP0AAwD9CwMAIAAgBEEoaiIKKQMANwMoIAUgBEEgaiILKQMANwMAIAAgBEEYaiIFKQMANwMYIAcgBEEQaiIOKQMANwMAIAAgBEEIaiIHKQMANwMIIAAgBCkDADcDACAKIAwpAyg3AwAgCyADKQMANwMAIAUgDCkDGDcDACAOIAgpAwA3AwAgByAMKQMINwMAIAQgDCkDADcDAAwECyAAIABBMGogAUEwayACEKwKDAMLIAAgAEEwaiAAQeAAaiABQTBrIAIQqgoMAgsgACAAQTBqIABB4ABqIABBkAFqIAFBMGsgAhCrCgwBCyAAIABBMGogAEHgAGoiBCACEKwKIABBkAFqIgMgAUYNAANAAkACQCAEKAIEIgYgAyIJKAIEIg9Bf3MiB3EiCCAIIAQoAggiBSADKAIIIhBBf3MiCnMiA3EgBSAKcXMiCCADIAYgB3MiC3FzIAhqIANzIAtxcyADc0EATgRAIAkoAgAhDQwBCyAGIA9HDQEgBSAQRw0BIAkoAgAiDSAEKAIAIgNJDQAgAyANSQ0BIAn9AAMQIAn9AAMgIAT9AAMQIAT9AAMgIAIoAgAQqQpFDQELIAkoAgwhEiAJIAT9AAMA/QsDACAJQRBqIgP9AAMAIRMgAyAE/QADEP0LAwAgCUEgaiID/QADACEUIAMgBP0AAyD9CwMAAkADQCAEIgNBMGshBAJAIANBLGsoAgAiBSAHcSILIAsgA0EoaygCACIIIApzIgZxIAggCnFzIgsgBiAFIAdzIg5xcyALaiAGcyAOcXMgBnNBAE4NACAFIA9HDQIgCCAQRw0CIA0gBCgCACIGSQ0AIAYgDUkNAiATIBQgA0Ega/0AAwAgA0EQa/0AAwAgAigCABCpCkUNAgsgAyAE/QADAP0LAwAgAyAE/QADIP0LAyAgAyAE/QADEP0LAxAgACAERw0ACyAAIQMLIAMgFP0LAyAgAyAT/QsDECADIBI2AgwgAyAQNgIIIAMgDzYCBCADIA02AgAgEUEBaiIRQQhHDQAgCUEwaiABRiEGDAILIAkiBEEwaiIDIAFHDQALQQEhBgsgDEEwaiQAIAYL4AIBC38gASgCACEDAkAgACgCACIEQX9HBEAgAyAESyEDDAELIANBf0cEQEEAIQMMAQsgASgCECABKAIMIg1rQShtIQcCQCAAKAIQIgMgACgCDCIMRgRADAELIAMgDGtBKG0iCCEJIAchCgNAIApFDQFBASEDIAwgCUEBayIJQShsaiIEKAIgIgYgDSAKQQFrIgpBKGxqIgUoAiAiC0kNAiAGIAtLBEBBACEDDAMLIAQoAiQiBiAFKAIkIgtJDQIgBiALTQRAIAT9AAMAIAT9AAMQIAX9AAMAIAX9AAMQIAIQqQoNAwsgBSgCJCIDIAQoAiQiBkkEQEEAIQMMAwsgAyAGTQRAQQAhAyAF/QADACAF/QADECAE/QADACAE/QADECACEKkKDQMLIAkNAAsLIAcgCEsEQEEBIQMMAQsgByAISQRAQQAhAwwBCyABLQAIIAAtAAhBAXNxIQMLIANBAXELiQQCBX8BfiMAQRBrIgUkACAAIAEgAiAEELEKAkAgAyACIAQoAgAoAgAQrgpFDQAgBUEIaiIGIAJBCGoiBy0AADoAACAFIAIpAgA3AwAgAigCFCEIIAJBADYCFCACKQIMIQogAkIANwIMIAIgAykCADcCACAHIANBCGoiCS0AADoAACACIAMoAgw2AgwgAiADKAIQNgIQIAIgAygCFDYCFCAJIAYtAAA6AAAgAyAFKQMANwIAIAMgCDYCFCADIAo3AgwgAiABIAQoAgAoAgAQrgpFDQAgBiABQQhqIgMtAAA6AAAgBSABKQIANwMAIAEoAhQhCCABQQA2AhQgASkCDCEKIAFCADcCDCABIAIpAgA3AgAgAyAHLQAAOgAAIAEgAigCDDYCDCABIAIoAhA2AhAgASACKAIUNgIUIAcgBi0AADoAACACIAUpAwA3AgAgAiAINgIUIAIgCjcCDCABIAAgBCgCACgCABCuCkUNACAFQQhqIgIgAEEIaiIDLQAAOgAAIAUgACkCADcDACAAKAIUIQQgAEEANgIUIAApAgwhCiAAQgA3AgwgACABKQIANwIAIAMgAUEIaiIGLQAAOgAAIAAgASgCDDYCDCAAIAEoAhA2AhAgACABKAIUNgIUIAYgAi0AADoAACABIAUpAwA3AgAgASAENgIUIAEgCjcCDAsgBUEQaiQAC6YFAgV/AX4jAEEQayIGJAAgACABIAIgAyAFEK8KAkAgBCADIAUoAgAoAgAQrgpFDQAgBkEIaiIHIANBCGoiCC0AADoAACAGIAMpAgA3AwAgAygCFCEJIANBADYCFCADKQIMIQsgA0IANwIMIAMgBCkCADcCACAIIARBCGoiCi0AADoAACADIAQoAgw2AgwgAyAEKAIQNgIQIAMgBCgCFDYCFCAKIActAAA6AAAgBCAGKQMANwIAIAQgCTYCFCAEIAs3AgwgAyACIAUoAgAoAgAQrgpFDQAgByACQQhqIgQtAAA6AAAgBiACKQIANwMAIAIoAhQhCSACQQA2AhQgAikCDCELIAJCADcCDCACIAMpAgA3AgAgBCAILQAAOgAAIAIgAygCDDYCDCACIAMoAhA2AhAgAiADKAIUNgIUIAggBy0AADoAACADIAYpAwA3AgAgAyAJNgIUIAMgCzcCDCACIAEgBSgCACgCABCuCkUNACAGQQhqIgMgAUEIaiIELQAAOgAAIAYgASkCADcDACABKAIUIQcgAUEANgIUIAEpAgwhCyABQgA3AgwgASACKQIANwIAIAQgAkEIaiIILQAAOgAAIAEgAigCDDYCDCABIAIoAhA2AhAgASACKAIUNgIUIAggAy0AADoAACACIAYpAwA3AgAgAiAHNgIUIAIgCzcCDCABIAAgBSgCACgCABCuCkUNACADIABBCGoiAi0AADoAACAGIAApAgA3AwAgACgCFCEFIABBADYCFCAAKQIMIQsgAEIANwIMIAAgASkCADcCACACIAQtAAA6AAAgACABKAIMNgIMIAAgASgCEDYCECAAIAEoAhQ2AhQgBCADLQAAOgAAIAEgBikDADcCACABIAU2AhQgASALNwIMCyAGQRBqJAALwQYCBn8BfiMAQRBrIgQkACABIAAgAygCACgCACIFEK4KIQYgAiABIAUQrgohBQJAIAZFBEAgBUUNASAEQQhqIgUgAUEIaiIGLQAAOgAAIAQgASkCADcDACABKAIUIQcgAUEANgIUIAEpAgwhCiABQgA3AgwgASACKQIANwIAIAYgAkEIaiIILQAAOgAAIAEgAigCDDYCDCABIAIoAhA2AhAgASACKAIUNgIUIAggBS0AADoAACACIAQpAwA3AgAgAiAHNgIUIAIgCjcCDCABIAAgAygCACgCABCuCkUNASAFIABBCGoiAi0AADoAACAEIAApAgA3AwAgACgCFCEDIABBADYCFCAAKQIMIQogAEIANwIMIAAgASkCADcCACACIAYtAAA6AAAgACABKAIMNgIMIAAgASgCEDYCECAAIAEoAhQ2AhQgBiAFLQAAOgAAIAEgBCkDADcCACABIAM2AhQgASAKNwIMDAELIAUEQCAEQQhqIgEgAEEIaiIDLQAAOgAAIAQgACkCADcDACAAKAIUIQUgAEEANgIUIAApAgwhCiAAQgA3AgwgACACKQIANwIAIAMgAkEIaiIGLQAAOgAAIAAgAigCDDYCDCAAIAIoAhA2AhAgACACKAIUNgIUIAYgAS0AADoAACACIAQpAwA3AgAgAiAFNgIUIAIgCjcCDAwBCyAEQQhqIgUgAEEIaiIGLQAAOgAAIAQgACkCADcDACAAKAIMIQcgACgCECEIIABCADcCDCAAKAIUIQkgAEEANgIUIAAgASkCADcCACAGIAFBCGoiBi0AADoAACAAIAEoAgw2AgwgACABKAIQNgIQIAAgASgCFDYCFCAGIAUtAAA6AAAgASAEKQMANwIAIAEgCTYCFCABIAg2AhAgASAHNgIMIAIgASADKAIAKAIAEK4KRQ0AIAUgBi0AADoAACAEIAEpAgA3AwAgAUEANgIUIAFCADcCDCABIAIpAgA3AgAgBiACQQhqIgAtAAA6AAAgASACKAIMNgIMIAEgAigCEDYCECABIAIoAhQ2AhQgACAFLQAAOgAAIAIgBCkDADcCACACIAk2AhQgAiAINgIQIAIgBzYCDAsgBEEQaiQAC44FAgp/AX4jAEEgayIFJABBASEDAkACQAJAAkACQAJAIAEgAGtBGG0OBgUFAAECAwQLIAFBGGsiBiAAIAIoAgAoAgAQrgpFDQQgBUEQaiIHIABBCGoiAi0AADoAACAFIAApAgA3AwggACgCFCEEIABBADYCFCAAKQIMIQ0gAEIANwIMIAAgBikCADcCACACIAZBCGoiCC0AADoAACAAIAFBDGsiAigCADYCDCAAIAFBCGsoAgA2AhAgACABQQRrIgEoAgA2AhQgCCAHLQAAOgAAIAYgBSkDCDcCACABIAQ2AgAgAiANNwIADAQLIAAgAEEYaiABQRhrIAIQsQoMAwsgACAAQRhqIABBMGogAUEYayACEK8KDAILIAAgAEEYaiAAQTBqIABByABqIAFBGGsgAhCwCgwBCyAAIABBGGogAEEwaiIHIAIQsQogAEHIAGoiBCABRg0AA0ACQCAEIAcgAigCACgCABCuCkUNACAFQRBqIgkgBC0ACDoAACAFIAQpAgA3AwggBSAEKAIMIgo2AhQgBSAEKAIQIgs2AhggBSAEKAIUIgw2AhwgBEEANgIUIARCADcCDCAEIQYDQAJAIAYgByIDKQIANwIAIAYgAy0ACDoACCADKQIMIQ0gBiADKAIUNgIUIAYgDTcCDCADQQA2AhQgA0IANwIMIAAgA0YEQCAAIQMMAQsgAyEGIAVBCGogA0EYayIHIAIoAgAoAgAQrgoNAQsLIAMgBSkDCDcCACADIAktAAA6AAggAyAMNgIUIAMgCzYCECADIAo2AgwgCEEBaiIIQQhHDQAgBEEYaiABRiEDDAILIAQhByAEQRhqIgMhBCABIANHDQALQQEhAwsgBUEgaiQAIAMLnQoBC38jAEEwayIFJAAgAygCACgCACEIAkACQCABKAIgIgQgACgCICIGSQ0AAkAgBCAGSw0AIAEoAiQiBiAAKAIkIgdJDQEgBiAHSw0AIAH9AAMAIAH9AAMQIAD9AAMAIAD9AAMQIAgQqQoNAQsCQCACKAIgIgYgBEkNACAEIAZJDQIgAigCJCIEIAEoAiQiBkkNACAEIAZLDQIgAv0AAwAgAv0AAxAgAf0AAwAgAf0AAxAgCBCpCkUNAgsgBUEoaiIGIAFBIGoiBCkDADcDACAFQRhqIgggAUEQaiIH/QADAP0LAwAgBSAB/QADAP0LAwggBCACQSBqIg0pAwA3AwAgAUEYaiIKIAJBGGoiCykDADcDACAHIAJBEGoiCSkDADcDACABQQhqIgwgAkEIaiIOKQMANwMAIAEgAikDADcDACANIAYpAwA3AwAgCyAFQSBqIg0pAwA3AwAgCSAIKQMANwMAIA4gBUEQaiILKQMANwMAIAIgBSkDCDcDAAJAIAQoAgAiAiAAKAIgIglJDQAgAiAJSw0CIAEoAiQiAiAAKAIkIglJDQAgAiAJSw0CIAH9AAMAIAH9AAMQIAD9AAMAIAD9AAMQIAMoAgAoAgAQqQpFDQILIAYgAEEgaiICKQMANwMAIAggAEEQaiID/QADAP0LAwAgBSAA/QADAP0LAwggAiAEKQMANwMAIAAgCikDADcDGCADIAcpAwA3AwAgACAMKQMANwMIIAAgASkDADcDACAEIAYpAwA3AwAgCiANKQMANwMAIAcgCCkDADcDACAMIAspAwA3AwAgASAFKQMINwMADAELAkACQCACKAIgIgYgBEkNACAEIAZJDQEgAigCJCIEIAEoAiQiBkkNACAEIAZLDQEgAv0AAwAgAv0AAxAgAf0AAwAgAf0AAxAgCBCpCkUNAQsgBUEoaiIBIABBIGoiBCkDADcDACAFQRhqIgMgAEEQaiIG/QADAP0LAwAgBSAA/QADAP0LAwggBCACQSBqIggpAwA3AwAgACACQRhqIgQpAwA3AxggBiACQRBqIgcpAwA3AwAgACACQQhqIgYpAwA3AwggACACKQMANwMAIAggASkDADcDACAEIAUpAyA3AwAgByADKQMANwMAIAYgBSkDEDcDACACIAUpAwg3AwAMAQsgBUEoaiIGIABBIGoiBykDADcDACAFQRhqIgggAEEQaiIM/QADAP0LAwAgBSAA/QADAP0LAwggByABQSBqIgQpAwA3AwAgACABQRhqIgopAwA3AxggDCABQRBqIgcpAwA3AwAgACABQQhqIgwpAwA3AwggACABKQMANwMAIAQgBikDADcDACAKIAVBIGoiACkDADcDACAHIAgpAwA3AwAgDCAFQRBqIg0pAwA3AwAgASAFKQMINwMAAkAgAigCICILIAQoAgAiCUkNACAJIAtJDQEgAigCJCILIAEoAiQiCUkNACAJIAtJDQEgAv0AAwAgAv0AAxAgAf0AAwAgAf0AAxAgAygCACgCABCpCkUNAQsgBiAEKQMANwMAIAggB/0AAwD9CwMAIAUgAf0AAwD9CwMIIAQgAkEgaiIDKQMANwMAIAogAkEYaiIEKQMANwMAIAcgAkEQaiIKKQMANwMAIAwgAkEIaiIHKQMANwMAIAEgAikDADcDACADIAYpAwA3AwAgBCAAKQMANwMAIAogCCkDADcDACAHIA0pAwA3AwAgAiAFKQMINwMACyAFQTBqJAALyA4BDH8jAEEwayIGJAAgACABIAIgBRCzCgJAAkAgAygCICIHIAIoAiAiCEkNACAFKAIAKAIAIQkgByAISw0BIAMoAiQiByACKAIkIghJDQAgByAISw0BIAP9AAMAIAP9AAMQIAL9AAMAIAL9AAMQIAkQqQpFDQELIAZBKGoiCCACQSBqIgcpAwA3AwAgBkEYaiIMIAJBEGoiC/0AAwD9CwMAIAYgAv0AAwD9CwMIIAcgA0EgaiIJKQMANwMAIAJBGGoiDiADQRhqIg8pAwA3AwAgCyADQRBqIgopAwA3AwAgAkEIaiINIANBCGoiECkDADcDACACIAMpAwA3AwAgCSAIKQMANwMAIA8gBkEgaiIRKQMANwMAIAogDCkDADcDACAQIAZBEGoiDykDADcDACADIAYpAwg3AwACQCAHKAIAIgogASgCICIQSQ0AIAUoAgAoAgAhCSAKIBBLDQEgAigCJCIKIAEoAiQiEEkNACAKIBBLDQEgAv0AAwAgAv0AAxAgAf0AAwAgAf0AAxAgCRCpCkUNAQsgCCABQSBqIgkpAwA3AwAgDCABQRBqIgr9AAMA/QsDACAGIAH9AAMA/QsDCCAJIAcpAwA3AwAgASAOKQMANwMYIAogCykDADcDACABIA0pAwA3AwggASACKQMANwMAIAcgCCkDADcDACAOIBEpAwA3AwAgCyAMKQMANwMAIA0gDykDADcDACACIAYpAwg3AwACQCAJKAIAIgcgACgCICIISQ0AIAUoAgAoAgAhCSAHIAhLDQEgASgCJCIHIAAoAiQiCEkNACAHIAhLDQEgAf0AAwAgAf0AAxAgAP0AAwAgAP0AAxAgCRCpCkUNAQsgBkEoaiIHIABBIGoiCCkDADcDACAGQRhqIgwgAEEQaiIL/QADAP0LAwAgBiAA/QADAP0LAwggCCABQSBqIgkpAwA3AwAgACABQRhqIggpAwA3AxggCyABQRBqIg4pAwA3AwAgACABQQhqIgspAwA3AwggACABKQMANwMAIAkgBykDADcDACAIIAYpAyA3AwAgDiAMKQMANwMAIAsgBikDEDcDACABIAYpAwg3AwAgBSgCACgCACEJCwJAAkAgBCgCICIHIAMoAiAiCEkNACAHIAhLDQEgBCgCJCIHIAMoAiQiCEkNACAHIAhLDQEgBP0AAwAgBP0AAxAgA/0AAwAgA/0AAxAgCRCpCkUNAQsgBkEoaiIIIANBIGoiBykDADcDACAGQRhqIgwgA0EQaiIL/QADAP0LAwAgBiAD/QADAP0LAwggByAEQSBqIg0pAwA3AwAgA0EYaiIJIARBGGoiDykDADcDACALIARBEGoiCikDADcDACADQQhqIg4gBEEIaiIQKQMANwMAIAMgBCkDADcDACANIAgpAwA3AwAgDyAGQSBqIg0pAwA3AwAgCiAMKQMANwMAIBAgBkEQaiIPKQMANwMAIAQgBikDCDcDAAJAIAcoAgAiBCACKAIgIgpJDQAgBCAKSw0BIAMoAiQiBCACKAIkIgpJDQAgBCAKSw0BIAP9AAMAIAP9AAMQIAL9AAMAIAL9AAMQIAUoAgAoAgAQqQpFDQELIAggAkEgaiIEKQMANwMAIAwgAkEQaiIK/QADAP0LAwAgBiAC/QADAP0LAwggBCAHKQMANwMAIAIgCSkDADcDGCAKIAspAwA3AwAgAiAOKQMANwMIIAIgAykDADcDACAHIAgpAwA3AwAgCSANKQMANwMAIAsgDCkDADcDACAOIA8pAwA3AwAgAyAGKQMINwMAAkAgBCgCACIDIAEoAiAiBEkNACADIARLDQEgAigCJCIDIAEoAiQiBEkNACADIARLDQEgAv0AAwAgAv0AAxAgAf0AAwAgAf0AAxAgBSgCACgCABCpCkUNAQsgBkEoaiIEIAFBIGoiAykDADcDACAGQRhqIgcgAUEQaiII/QADAP0LAwAgBiAB/QADAP0LAwggAyACQSBqIgkpAwA3AwAgAUEYaiIMIAJBGGoiDikDADcDACAIIAJBEGoiDSkDADcDACABQQhqIgsgAkEIaiIPKQMANwMAIAEgAikDADcDACAJIAQpAwA3AwAgDiAGQSBqIgkpAwA3AwAgDSAHKQMANwMAIA8gBkEQaiIOKQMANwMAIAIgBikDCDcDAAJAIAMoAgAiAiAAKAIgIg1JDQAgAiANSw0BIAEoAiQiAiAAKAIkIg1JDQAgAiANSw0BIAH9AAMAIAH9AAMQIAD9AAMAIAD9AAMQIAUoAgAoAgAQqQpFDQELIAQgAEEgaiICKQMANwMAIAcgAEEQaiIF/QADAP0LAwAgBiAA/QADAP0LAwggAiADKQMANwMAIAAgDCkDADcDGCAFIAgpAwA3AwAgACALKQMANwMIIAAgASkDADcDACADIAQpAwA3AwAgDCAJKQMANwMAIAggBykDADcDACALIA4pAwA3AwAgASAGKQMINwMACyAGQTBqJAALzwwCDn8CeyMAQTBrIgckAEEBIQkCQAJAAkACQAJAAkAgASAAa0EobQ4GBQUAAQIDBAsgAUEoayEDAkAgAUEIaygCACIEIAAoAiAiBUkNACAEIAVLDQUgAUEEaygCACIEIAAoAiQiBUkNACAEIAVLDQUgA/0AAwAgAUEYa/0AAwAgAP0AAwAgAP0AAxAgAigCACgCABCpCkUNBQsgB0EoaiIEIABBIGoiBSkDADcDACAHQRhqIgggAEEQaiIG/QADAP0LAwAgByAA/QADAP0LAwggBSADQSBqIgIpAwA3AwAgACADQRhqIgUpAwA3AxggBiADQRBqIgEpAwA3AwAgACADQQhqIgYpAwA3AwggACADKQMANwMAIAIgBCkDADcDACAFIAcpAyA3AwAgASAIKQMANwMAIAYgBykDEDcDACADIAcpAwg3AwAMBAsgACAAQShqIAFBKGsgAhCzCgwDCyAAIABBKGoiBCAAQdAAaiIDIAIQswogAUEoayEFAkAgAUEIaygCACIIIAAoAnAiBkkNACAGIAhJDQMgAUEEaygCACIIIAAoAnQiBkkNACAGIAhJDQMgBf0AAwAgAUEYa/0AAwAgAP0AA1AgAP0AA2AgAigCACgCABCpCkUNAwsgB0EoaiIIIANBIGoiBikDADcDACAHQRhqIgEgA0EQaiIL/QADAP0LAwAgByAD/QADAP0LAwggBiAFQSBqIgwpAwA3AwAgA0EYaiIOIAVBGGoiDSkDADcDACALIAVBEGoiCikDADcDACADQQhqIg8gBUEIaiIQKQMANwMAIAMgBSkDADcDACAMIAgpAwA3AwAgDSAHQSBqIgwpAwA3AwAgCiABKQMANwMAIBAgB0EQaiINKQMANwMAIAUgBykDCDcDAAJAIAAoAnAiBSAAKAJIIgpJDQAgBSAKSw0DIAAoAnQiBSAAKAJMIgpJDQAgBSAKSw0DIAD9AANQIAD9AANgIAD9AAMoIAD9AAM4IAIoAgAoAgAQqQpFDQMLIAggBEEgaiIFKQMANwMAIAEgBEEQaiIK/QADAP0LAwAgByAE/QADAP0LAwggBSAGKQMANwMAIAQgDikDADcDGCAKIAspAwA3AwAgBCAPKQMANwMIIAQgAykDADcDACAGIAgpAwA3AwAgDiAMKQMANwMAIAsgASkDADcDACAPIA0pAwA3AwAgAyAHKQMINwMAAkAgACgCSCIDIAAoAiAiBUkNACADIAVLDQMgACgCTCIDIAAoAiQiBUkNACADIAVLDQMgAP0AAyggAP0AAzggAP0AAwAgAP0AAxAgAigCACgCABCpCkUNAwsgB0EoaiIDIABBIGoiBSkDADcDACAHQRhqIgggAEEQaiIG/QADAP0LAwAgByAA/QADAP0LAwggBSAEQSBqIgIpAwA3AwAgACAEQRhqIgUpAwA3AxggBiAEQRBqIgEpAwA3AwAgACAEQQhqIgYpAwA3AwggACAEKQMANwMAIAIgAykDADcDACAFIAcpAyA3AwAgASAIKQMANwMAIAYgBykDEDcDACAEIAcpAwg3AwAMAgsgACAAQShqIABB0ABqIABB+ABqIAFBKGsgAhC0CgwBCyAAIABBKGogAEHQAGoiAyACELMKIABB+ABqIgQgAUYNAANAAkACQCAEIgYoAiAiCSADKAIgIgRJBEAgBigCJCEIDAELIAQgCUkNASAGKAIkIgggAygCJCIESQ0AIAQgCEkNASAG/QADACAG/QADECAD/QADACAD/QADECACKAIAKAIAEKkKRQ0BCyAG/QADACERIAYgAykDADcDACAG/QADECESIAYgA/0AAwj9CwMIIAYgA/0AAxj9CwMYAkADQCADIgRBKGshAwJAIAkgBEEIaygCACIFSQ0AIAUgCUkNAiAIIARBBGsoAgAiBUkNACAFIAhJDQIgESASIAP9AAMAIARBGGv9AAMAIAIoAgAoAgAQqQpFDQILIAQgA/0AAwD9CwMAIAQgAykDIDcDICAEIAP9AAMQ/QsDECAAIANHDQALIAAhBAsgBCAINgIkIAQgCTYCICAEIBL9CwMQIAQgEf0LAwAgC0EBaiILQQhHDQAgBkEoaiABRiEJDAILIAYiA0EoaiIEIAFHDQALQQEhCQsgB0EwaiQAIAkLtQoBB38jAEHQAGsiCiQAIAogACgCACgCBCgCACILIAsoAgBBiAFqIAQgBxC3CiILNgIcIAAoAgAoAgQoAgAiDSANKAIAQYgBaiAFIAgQtwohDSAKIAAoAgAoAgQoAgAiDCAMKAIAQYgBaiAGIAkQtwoiDDYCGCAAKAIAKAIEKAIAIAQgBRC8CiEPIAAoAgAoAgQoAgAgByAIELwKIQ4gACgCACgCBCgCACIQIBAoAgBBiAFqIA8gDhC3CiEPIAogACgCACgCBCgCACALIA0QvAo2AhQgACgCACgCBCAPIApBFGoQuAohDyAAKAIAKAIEKAIAIAQgBhC8CiEEIAAoAgAoAgQoAgAgByAJELwKIQcgACgCACgCBCgCACIOIA4oAgBBiAFqIAQgBxC3CiEHIAogACgCACgCBCgCACALIAwQvAo2AhAgCiAAKAIAKAIEIAcgCkEQahC4CiIENgIUIAAoAgAoAgQoAgAgBSAGELwKIQcgACgCACgCBCgCACAIIAkQvAohCCAAKAIAKAIEKAIAIgUgBSgCAEGIAWogByAIELcKIQcgCiAAKAIAKAIEKAIAIA0gDBC8CjYCDCAKIAAoAgAoAgQgByAKQQxqELgKIgg2AhAgACgCACgCBCgCACIFIAAoAgRBCGoQygkhByAK/QwAAAAAAAAAAAAAAAAAAAAA/QsDICAKQgA3AzggCkJ/NwMwIAcEQCAKQgA3AkggCiAHNgJEIApBIGogCkHEAGoQ5wkLIAUgCkEgahDLCSEHIAooAiAiBQRAIAogBTYCJCAFECsLIAAoAgAoAgQoAgAiBSAFKAIAQYgBaiAHIAQQtwohBiAAKAIAKAIEKAIAIgkgACgCBEGIAmoQygkhBSAK/QwAAAAAAAAAAAAAAAAAAAAA/QsDICAKQgA3AzggCkJ/NwMwIAUEQCAKQgA3AkggCiAFNgJEIApBIGogCkHEAGoQ5wkLIAkgCkEgahDLCSEFIAooAiAiCQRAIAogCTYCJCAJECsLIAAoAgAoAgQoAgAiCSAJKAIAQYgBaiAFIAwQtwohCSAKIAAoAgAoAgQoAgAgCSAGELwKIgY2AiAgACgCACgCBCANIApBIGoQuAohCSAAKAIAKAIEKAIAIA0gBhC8CiENIAAoAgAoAgQoAgAiBiAGKAIAQYgBaiAJIA0QtwohBiAAKAIAKAIEKAIAIAsgCxC8CiEOIAAoAgAoAgQoAgAgDiALELwKIQ4gCiAAKAIAKAIEKAIAIhAgECgCAEGIAWogByAMELcKIgw2AhggACgCACgCBCgCACIQIBAoAgBBiAFqIAUgBBC3CiEEIAAoAgAoAgQoAgAgDiAMELwKIQwgACgCACgCBCALIApBGGoQuAohCyAAKAIAKAIEKAIAIgUgBSgCAEGIAWogByALELcKIQsgACgCACgCBCgCACAEIAsQvAohCyAAKAIAKAIEKAIAIgcgBygCAEGIAWogDCALELcKIQcgACgCACgCBCgCACAGIAcQvAohByAKIAAoAgAoAgQoAgAiBCAEKAIAQYgBaiAIIAsQtwo2AhwgACgCACgCBCgCACILIAsoAgBBiAFqIA8gCRC3CiELIAAoAgAoAgQgCyAKQRxqELgKIQsgACgCACgCBCgCACIEIAQoAgBBiAFqIA8gDBC3CiEMIAAoAgAoAgQoAgAiBCAEKAIAQYgBaiAIIA0QtwohDSAAKAIAKAIEKAIAIA0gDBC8CiEAIAEgCzYCACACIAc2AgAgAyAANgIAIApB0ABqJAAL+AMBBX8jAEHgAGsiBCQAIAAoAkwiCCACQQV0aiIHKAIEIQYCQCAHLQAeRSAHKAIAIgUgBkZxDQADQCACIQcgAyECAkAgBiAFa0EMRw0AIAUoAgQiBiAFKAIIckUEQCAAKAIAIQYgBEHQAGoiAyAB/QADEP0LAwAgBCAB/QADAP0LA0AgBiAEQUBrIAAoAiwgBSgCAEEFdGoQpAkgBCAD/QADAP0LAzAgBCAE/QADQP0LAyAgACAEQSBqIAIQyAohAgwDCyAGDQAgACgCACEGIARB0ABqIgMgAf0AAxD9CwMAIAQgAf0AAwD9CwNAIAYgBEFAayAAKAIsIAUoAgBBBXRqEKQJIAQgA/0AAwD9CwMwIAQgBP0AA0D9CwMgIAAgBEEgaiAFKAIIIAIQtwohAgwCCyAIIAJBBXRqIgMoAgQhBiADLQAeRSADKAIAIgUgBkZxDQEgBiAFa0EMRgRAIAchAyAFKAIERQ0BCwsgACABEMoJIQUgBP0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgBEIANwMYIARCfzcDECAFBEAgBCAFNgJAIAQgByACIAIgB0kbNgJIIAQgAiAHIAIgB0kbNgJEIAQgBEFAaxDnCQsgACAEEMsJIQIgBCgCACIFRQ0AIAQgBTYCBCAFECsLIARB4ABqJAAgAgu2AQEDfyMAQTBrIgMkACAAKAIAIgQgBCgCAEGIAmoQygkhBSAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDACADQgA3AxggA0J/NwMQIAUEQCADQgA3AiggAyAFNgIkIAMgA0EkahDnCQsgBCADEMsJIQUgAygCACIEBEAgAyAENgIEIAQQKwsgACgCACIEIAQoAgBBiAFqIAUgAigCABC3CiEEIAAoAgAgASAEELwKIQAgA0EwaiQAIAAL7QIBBX8jAEFAaiICJAAgACgCTCIGIAFBBXRqIgUoAgQhAwJAAkAgBS0AHkUgBSgCACIEIANGcQ0AA0ACQCADIARrQQxHDQAgBCgCBA0AIAQoAgBFDQIgBiAEKAIIIgFBBXRqIgUoAgQhAyAFKAIAIQQgBS0AHg0BIAMgBEcNAQwCCwsgAkEANgI8IAJCADcCNCACIAE2AjAgAkIANwIoIAJBNGogAkEoahDnCSACQQA2AhAgAkIANwIIIAIoAjgiAyACKAI0IgRHBEAgAyAEayIDQQxtQdaq1aoBTw0CIAIgAxCiCSIFNgIIIAIgAyAFaiIBNgIQIAMEQCAFIAQgA/wKAAALIAIgATYCDAsgAkIANwIgIAJBfzYCHCACQoCAgIBwNwIUIAAgAkEIahDLCSEFIAIoAggiAwRAIAIgAzYCDCADECsLIAAoAkwgBUEFdGpBAToAHyAERQ0AIAQQKwsgAkFAayQADwsQoAkAC7UTAgt/E34jAEHAB2siAyQAIAAgATYCACAAQSAQogkiBDYCBCAAIARBIGoiBTYCDCAE/QwAAAAAAAAAAAAAAAAAAAAA/QsCECAE/QwAAAAAAAAAAAAAAAAAAAAA/QsCACAAIAU2AgggASgCACABKAIEQgAQzQohASAAKAIEIAE2AgAgACgCACIBKAIAIAEoAgRCABDNCiEBIAAoAgQgATYCBCAAKAIAIgEoAgAgASgCBEIAEM0KIQEgACgCBCABNgIIIAAoAgAiASgCACABKAIEQgAQzQohASAAKAIEIAE2AgwgACgCACIBKAIAIAEoAgRCABDNCiEBIAAoAgQgATYCECAAKAIAIgEoAgAgASgCBEIAEM0KIQEgACgCBCABNgIUIAAoAgAiASgCACABKAIEQgAQzQohASAAKAIEIAE2AhggACgCACIBKAIAIAEoAgRCABDNCiEBIAAoAgQgATYCHCADQagHaiEJIANB6ABqIQsDQCAAKAIAKAIAIgEpAwAiE0IHViABKQMYIhggASkDECIaIAEpAwgiGYSEQgBSIgpyrSEbIAFBQGshBkIAIQ8CQAJAAkACQANAIA9CAYYiDiATVCAKcq1QDQMgAyAONwNgIAtBEGoiCEIANwMAIAv9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAEgA0HgAGogBhCkCSAbUA0CIANCBzcDoAcgCUIANwMQIAn9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAEgA0GgB2ogBhCkCSAPp0EFdCIHIANB4ARqaiIEIAMpA3giFyADKQO4B30iFCADKQNwIg4gAykDsAd9IhEgDlYgESADKQNoIg4gAykDqAd9IhIgDlYgEiADKQNgIhAgAykDoAd9Ig4gEFatfSIQIBJWcq19IhIgEVZyrX0iESASIBp8IhUgElQgFSAQIBl8IhYgEFQgFiAOIBN8IhwgDlStfCIdIBZUcq18IhYgFVRyrSARIBh8fCAUIBdWIBEgFFZyrVAiBRs3AxggBCASIBYgBRs3AxAgBCAQIB0gBRs3AwggBCAOIBwgBRs3AwAgEyAPIB5RrSIOViAKcq1QDQEgAyAONwNgIAhCADcDACAL/QwAAAAAAAAAAAAAAAAAAAAA/QsDACABIANB4ABqIAYQpAkgA0HgAmogB2oiBCAD/QADcP0LAxAgBCAD/QADYP0LAwAgD0IBfCIPQghSDQALIANB4ABqIANB4AJqQYAC/AoAACABQZgBaiIEKQMAIR8gASkDoAEhICABKQOQASEYIAEpA4gBIRkgAyAE/QADAP0LA5AHIAMgAf0AA4gB/QsDgAdBASEIA0BBCCEHQQchBQNAIAUiBEEFdCIMIANB4ARqaiIFKQMYIhUgA0HgBGogBCAIa0EFdGoiBikDGH0iEiAFKQMQIg8gBikDEH0iEyAPViATIAUpAwgiDyAGKQMIfSIQIA9WIBAgBSkDACIOIAYpAwB9Ig8gDlatfSIOIBBWcq19IhAgE1ZyrX0iEyAQIAEpAxAiF3wiFCAQVCAUIA4gASkDCCIcfCIRIA5UIBEgDyABKQMAIh18IhsgD1StfCIaIBFUcq18IhEgFFRyrSATIAEpAxgiFnx8IBIgE1QgEiAVVnKtUCIFGyESIBAgESAFGyEQIA4gGiAFGyEOAkACQCAPIBsgBRsiDyAZUg0AIA4gGFINACAQIB9SDQAgEiAgUQ0BCyADQYAHaiABIA/9EiAO/R4BIBD9EiAS/R4BEMQJIA8hGSAOIRggECEfIBIhIAsgA0G4B2oiCiADQeAAaiAMaiIFQRhqIgwpAwAiFSAHQQV0IANqQSBqIgYpAxh9IhIgBSkDECIPIAYpAxB9IhMgD1YgEyAFQQhqIgcpAwAiDyAGKQMIfSIQIA9WIBAgBSkDACIOIAYpAwB9Ig8gDlatfSIOIBBWcq19IhAgE1ZyrX0iEyATIBZ8IBAgF3wiFCAQVCAUIA4gHHwiESAOVCARIA8gHXwiFiAPVK18IhcgEVRyrXwiESAUVHKtfCASIBNUIBIgFVZyrVAiBhs3AwAgA0GwB2oiDSAQIBEgBhs3AwAgCSAOIBcgBhs3AwAgAyAPIBYgBhs3A6AHIAEgA0GgB2ogA0GAB2oQpAkgBSADKQOgByIPNwMAIAcgCf0AAwD9CwMAIAwgCikDADcDACADIA83A+AGIARBAWshBSAEIQcgBCAISw0ACyAIQQFqIghBCEcNAAtBCCEHQQchBANAIAchBiAEIQcgBkEHTQRAIANB4ARqIARBBXRqIQgDQCADQeAAaiAGQQV0aiIFQSBrIgQpAxghEiAEKQMQIQ8gBCkDACEOIAQpAwghECANIAX9AAMQ/QsDACADIAX9AAMA/QsDoAcgASADQaAHaiAIEKQJIAQgEiAKKQMAfSITIA8gDSkDAH0iFCAPViAUIBAgCSkDAH0iESAQViARIA4gAykDoAd9Ig8gDlatfSIOIBFWcq19IhAgFFZyrX0iFCAQIAEpAxB8IhEgEFQgESAOIAEpAwh8IhUgDlQgFSAPIAEpAwB8IhYgD1StfCIXIBVUcq18IhUgEVRyrSAUIAEpAxh8fCATIBRUIBIgE1RyrVAiBRs3AxggBCAQIBUgBRs3AxAgBCAOIBcgBRs3AwggBCAPIBYgBRs3AwAgBkEBaiIGQQhHDQALCyAHQQFrIQQgBw0ACyACIB6nQQJ0aiEGQQAhAQNAIAAoAgAoAgQoAgAiBSADQeAAaiABQQV0ahDKCSEEIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwPgBCADQgA3A/gEIANCfzcD8AQgBARAIANCADcC5AIgAyAENgLgAiADQeAEaiADQeACahDnCQsgBSADQeAEahDLCSEFIAMoAuAEIgQEQCADIAQ2AuQEIAQQKwsgACgCACgCBCgCACIEIAQoAgBBiAFqIAUgBigCABC3CiEEIAAoAgAoAgQoAgAgAUECdCIFIAAoAgRqKAIAIAQQvAohBCAAKAIEIAVqIAQ2AgAgAUEBaiIBQQhHDQALDAMLIANBgMYqNgJQQeQAQfSHKiADQdAAahCbCUGQljQoAgAoAgAhASADQYDGKjYCQCABQZGMKiADQUBrEGwACyADQYDGKjYCMEHkAEH0hyogA0EwahCbCUGQljQoAgAoAgAhASADQYDGKjYCICABQZGMKiADQSBqEGwACyADQYDGKjYCEEHkAEH0hyogA0EQahCbCUGQljQoAgAoAgAhASADQYDGKjYCACABQZGMKiADEGwACyAeQgF8Ih5CCFINAAsgA0HAB2okACAAC+ECAQV/IwBBIGsiBCQAIAQgACgCACAAQQRqIgUoAgBCARDNCjYCACAEIAIoAgAiAzYCBCAEIAUoAgAoAgAiAiACKAIAQYgBaiADIAMQtwoiAjYCCCAEIAUoAgAoAgAiBiAGKAIAQYgBaiACIAMQtwoiAzYCDCAEIAUoAgAoAgAiBiAGKAIAQYgBaiACIAIQtwoiBjYCECAEIAUoAgAoAgAiByAHKAIAQYgBaiADIAIQtwo2AhQgBCAFKAIAKAIAIgIgAigCAEGIAWogAyADELcKNgIYIAQgBSgCACgCACICIAIoAgBBiAFqIAYgAxC3CjYCHEEAIQIgACgCACAFKAIAQgAQzQohAwNAIAUoAgAoAgAiACAAKAIAQYgBaiABIAJBAnQiAGooAgAgACAEaigCABC3CiEAIAUoAgAoAgAgAyAAELwKIQMgAkEBaiIAIQIgAEEIRw0ACyAEQSBqJAAgAwuhDAIMfwx+IwBBoAFrIgMkAAJAAkAgACgCTCIGIAFBBXRqIgUtAB5FBEAgBSgCACAFKAIERg0BCwJAIAYgAkEFdGoiBi0AHg0AIAYoAgAgBigCBEcNACABIQIMAQsCQCAFKAIMIgUgBigCDCIGSQRAIAAgACgCAEGIAWpBACABELcKIQEMAQsgBSAGTQ0AIAAgACgCAEGIAWpBACACELcKIQILAkAgACgCTCIGIAFBBXRqIgUtAB5BAUYEQCAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDgAEgA0IANwOYASADQn83A5ABIAMgATYCaCADQgE3AmAgA0GAAWogA0HgAGoQ5wkgACgCTCEGDAELIANBADYCiAEgA0IANwKAASAFKAIEIgEgBSgCACIERwRAIAEgBGsiAUEMbUHWqtWqAU8NAyADIAEQogkiBzYCgAEgAyABIAdqIgg2AogBIAEEQCAHIAQgAfwKAAALIAMgCDYChAELIAMgBSgCHDYCnAEgAyAF/QACDP0LAowBCwJAIAYgAkEFdGoiAS0AHkEBRgRAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwNgIANCADcDeCADQn83A3AgAyACNgIwIANCATcCKCADQeAAaiADQShqEOcJDAELIANBADYCaCADQgA3AmAgASgCBCICIAEoAgAiBUcEQCACIAVrIgJBDG1B1qrVqgFPDQMgAyACEKIJIgY2AmAgAyACIAZqIgQ2AmggAgRAIAYgBSAC/AoAAAsgAyAENgJkCyADIAEoAhw2AnwgAyAB/QACDP0LAmwLQQAhAiADQQA2AlwgA0IANwJUAkAgAygChAEiBiADKAKAASIFRgRAQQAhAQwBC0EAIQEgAygCZCIEIAMoAmAiCkYNACAEIAprQQxtIQ0gBiAFa0EMbSEOA0AgCiABQQxsaiIHKAIEIQggBSACQQxsaiIEKAIEIQkCQAJAIAQoAggiCyAHKAIIIgxHDQAgCCAJRw0AIAMgBCgCCDYCUCADIAQpAgAiEDcDSCADIAAoAgAiBCkDOCIYIAAoAiwiCSAQp0EFdGoiCCkDGCIZIAkgBygCAEEFdGoiBykDGHwiECAIKQMQIg8gBykDEHwiEiAPVCASIAgpAwgiFCAHKQMIfCIPIBRUIA8gCCkDACIVIAcpAwB8IhQgFVStfCIVIA9Ucq18Ig8gElRyrXwiEnwiFyAEKQMwIhEgD3wiFiARVCAWIAQpAygiEyAVfCIRIBNUIBEgBCkDICITIBR8IhogE1StfCITIBFUcq18IhEgFlRyrXwiFiASIBAgGVQgECASVnIgFyAYVCAWIBdUcnMiBBs3A0AgAyARIA8gBBs3AzggAyATIBUgBBs3AzAgAyAaIBQgBBs3AyggAyAAIANBKGoQygkiBDYCSCABQQFqIQEgAkEBaiECDAELAkACQCALIAxPBEAgCyAMSw0BIAggCU0NAQsgAkEBaiECDAELIAFBAWohASAHIQQLIAMgBCgCCDYCUCADIAQpAgAiEDcDSCAQpyEECyAEBEAgA0HUAGogA0HIAGoQ5wkLIAIgDk8NASABIA1JDQALCyAGIAVrQQxtIAJLBEAgAygCgAEhByADKAKEASEIA0AgBSACQQxsaiIEKAIABEAgA0HUAGogBBDnCSAIIQYgByEFCyACQQFqIgIgBiAFa0EMbUkNAAsLIAMoAmQgAygCYCIGayICQQxtIgcgAUsEQCACQQxtIQQDQCAEIQIgBiABQQxsaiIFKAIABH8gA0HUAGogBRDnCSAHBSACCyABQQFqIgFLDQALCyADQQA2AhAgA0IANwIIIAMoAlgiASADKAJUIgJHBEAgASACayIBQQxtQdaq1aoBTw0CIAMgARCiCSIFNgIIIAMgASAFaiIENgIQIAEEQCAFIAIgAfwKAAALIAMgBDYCDAsgA0IANwIgIANBfzYCHCADQoCAgIBwNwIUIAIEQCACECsLIAYEQCADIAY2AmQgBhArCyADKAKAASICBEAgAhArCyAAIANBCGoQywkhAiADKAIIIgFFDQAgAyABNgIMIAEQKwsgA0GgAWokACACDwsQoAkAC9ECAQR/IwBBMGsiAyQAIAAoAgAoAgQoAgAiBCAEKAIAQYgBaiACIAIQtwohAiAAKAIAKAIEKAIAIgQgBCgCAEGIAWogASABELcKIQQgACgCACgCBCgCACIFIAUoAgBBiAFqIAEgBBC3CiEEIAAoAgAoAgQoAgAgACgCBEEIaiABEMgKIQUgACgCACgCBCgCACIGIAAoAgRBKGoQygkhASAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDACADQgA3AxggA0J/NwMQIAEEQCADQgA3AiggAyABNgIkIAMgA0EkahDnCQsgBiADEMsJIQYgAygCACIBBEAgAyABNgIEIAEQKwsgACgCACgCBCgCACAFIAYQvAohASADIAAoAgAoAgQoAgAgASAEELwKNgIAIAAoAgAiACgCBCACIAMQuAohASAAKAIEKAIAIAEQuQogA0EwaiQAC/0BAQJ/IwBB0ABrIgMkACAAKAIAKAIEKAIAIgQgBCgCAEGIAWogASACELcKIQEgAyAAKAIAIgIoAgAiBP0AA5gB/QsDECADIAT9AAOIAf0LAwAgAigCBCgCACIEIAMQygkhAiAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDICADQgA3AzggA0J/NwMwIAIEQCADQgA3AkggAyACNgJEIANBIGogA0HEAGoQ5wkLIAQgA0EgahDLCSEEIAMoAiAiAgRAIAMgAjYCJCACECsLIAMgBDYCRCAAKAIAIgAoAgQgASADQcQAahC4CiECIAAoAgQoAgAgAhC5CiADQdAAaiQAC84PAwV/DH4CeyMAQbADayIHJAACQCACIAFrIghBAk8EQCAAIAEgCEEBdiABaiIIIAdBqAJqIAdBmAFqIAUgBhC/CiAAIAggAiAHQeABaiAHQdAAaiAFIAYQvwogB0EIaiAAIAdB4AFqIAdBqAJqEMYKIAMgB0EIakHIAPwKAAAgB0EoaiECIAdBCGogACAHQeABaiAHQZgBahDGCgJAAkACfyAH/QADcCAAKAIAIgH9AANoIhj91gEgB/0AA4ABIAH9AAN4Ihn91gH9DQABAgMICQoLEBESExgZGhv9owEEQCAHQdAAaiEDIAdBCGoMAQsgB0HwAGohBiAH/QADKCAY/dYBIAf9AAM4IBn91gH9DQABAgMICQoLEBESExgZGhv9owFFDQEgB0EIaiEDIAYhAiAHQdAAagshACABKQM4IRcgACkDGCEVIAMpAxghDSABKQMwIQwgACkDECEPIAMpAxAhDiABKQMgIRYgASkDKCEQIAApAwAhEyADKQMAIRQgACkDCCERIAMpAwghEiAHIAL9AAMQ/QsDoAMgByAC/QADAP0LA5ADIBcgDSAVfCIVIA4gD3wiDyAOVCAPIBEgEnwiDiASVCAOIBMgFHwiEiAUVK18IhQgDlRyrXwiDiAPVHKtfCIPfCITIAwgDnwiESAMVCARIBAgFHwiDCAQVCAMIBIgFnwiECAWVK18IhYgDFRyrXwiDCARVHKtfCIRIA8gDyAVVCANIBVWciATIBdUIBEgE1RycyIBGyEXIAwgDiABGyENIBYgFCABGyEMIBAgEiABGyEOIAAoAkAhAQwBCyAAKAIEKAIAIAYgBygCkAEQyAohASAAKAIEKAIAIAIgBygCSBDICiEDIAAoAgQoAgAgASADELwKIQMgByAAKAIAIgEpAzgiFSAHKQNoIg8gBykDIHwiFyAHKQNgIgwgBykDGHwiDSAMVCANIAcpA1giDiAHKQMQfCIMIA5UIAwgBykDUCIWIAcpAwh8Ig4gFlStfCIWIAxUcq18IgwgDVRyrXwiDXwiECABKQMwIhIgDHwiFCASVCAUIAEpAygiEyAWfCISIBNUIBIgASkDICITIA58IhEgE1StfCITIBJUcq18IhIgFFRyrXwiFCANIA0gF1QgDyAXVnIgECAVVCAQIBRWcnMiARs3A6gDIAcgEiAMIAEbNwOgAyAHIBMgFiABGzcDmAMgByARIA4gARs3A5ADIAAoAgQoAgAgAyAHQZADahDMCiEBIAcgACgCACIA/QADmAH9CwOgAyAHIAD9AAOIAf0LA5ADIAApA4ABIRcgACkDeCENIAApA3AhDCAAKQNoIQ4LIAQgFzcDGCAEIA03AxAgBCAMNwMIIAQgDjcDACAEIAf9AAOQA/0LAyAgBCAH/QADoAP9CwMwIAQgATYCQAwBCyAHQagCaiAAIAUgAUHIAGwiAWoiAiABIAZqIgUQwwogACgCACIBKQOgASEXIAEpA5gBIQ0gASkDiAEhDCABKQOQASEOIAdBgANqIgggAUGYAmoiCf0AAwD9CwMAIAcgAf0AA4gC/QsD8AIgB0HwAWoiBiAJ/QADAP0LAwAgByAB/QADiAL9CwPgASABIAdB4AFqIAdBqAJqEKQJIAdB+AFqIgkpAwAhFSAGKQMAIQ8gB0HoAWoiCikDACETIAcpA+ABIREgASkDOCEWIAEpAzAhECABKQMgIRQgASkDKCESIAEgB0HwAmogB0HIAmoQpAkgBygC6AIhCyADIBYgFSAXfCIVIA0gD3wiDyANVCAPIA4gE3wiDSAOVCANIAwgEXwiDiAMVK18IgwgDVRyrXwiDSAPVHKtfCIPfCITIA0gEHwiESAQVCARIAwgEnwiECASVCAQIA4gFHwiEiAUVK18IhQgEFRyrXwiECARVHKtfCIRIA8gFSAXVCAPIBVUciATIBZUIBEgE1RycyIBGzcDGCADIBAgDSABGzcDECADIBQgDCABGzcDCCADIBIgDiABGzcDACADIAf9AAPwAv0LAyAgAyAI/QADAP0LAzAgAyALNgJAIAAoAgAiASkDoAEhFyABKQOYASENIAEpA4gBIQwgASkDkAEhDiAHQagBaiIDIAFBmAJqIgj9AAMA/QsDACAHIAH9AAOIAv0LA5gBIAYgCP0AAwD9CwMAIAcgAf0AA4gC/QsD4AEgASAHQeABaiACEKQJIAkpAwAhFSAGKQMAIQ8gCikDACETIAcpA+ABIREgASkDOCEWIAEpAzAhECABKQMgIRQgASkDKCESIAEgB0GYAWogAkEgahCkCSAHIAP9AAMA/QsDkAIgByAH/QADmAH9CwOAAiAHIBYgFSAXfCIVIA0gD3wiDyANVCAPIA4gE3wiDSAOVCANIAwgEXwiDiAMVK18IgwgDVRyrXwiDSAPVHKtfCIPfCITIA0gEHwiESAQVCARIAwgEnwiECASVCAQIA4gFHwiEiAUVK18IhQgEFRyrXwiECARVHKtfCIRIA8gFSAXVCAPIBVUciATIBZUIBEgE1RycyIBGzcD+AEgByAQIA0gARs3A/ABIAcgFCAMIAEbNwPoASAHIBIgDiABGzcD4AEgByACKAJANgKgAiAHQZgBaiAAIAdB4AFqIAUQxgogBCAHQZgBakHIAPwKAAALIAdBsANqJAALzAMCBX8MfiMAQfAAayICJAAgACgCACIDKQOgASERIAMpA5gBIQcgAykDiAEhCyADKQOQASEMIAJB4ABqIgQgA0GYAmoiBf0AAwD9CwMAIAIgA/0AA4gC/QsDUCACQRhqIgYgBf0AAwD9CwMAIAIgA/0AA4gC/QsDCCADIAJBCGogARCkCSACKQMgIQ0gBikDACEIIAIpAxAhDiACKQMIIQogAykDOCESIAMpAzAhCSADKQMgIQ8gAykDKCEQIAMgAkHQAGogAUEgahCkCSACIAT9AAMA/QsDOCACIAL9AANQ/QsDKCACIBIgDSARfCINIAcgCHwiCCAHVCAIIAwgDnwiByAMVCAHIAogC3wiDCALVK18IgsgB1RyrXwiByAIVHKtfCIIfCIOIAcgCXwiCiAJVCAKIAsgEHwiCSAQVCAJIAwgD3wiECAPVK18Ig8gCVRyrXwiCSAKVHKtfCIKIAggDSARVCAIIA1UciAOIBJUIAogDlRycyIDGzcDICACIAkgByADGzcDGCACIA8gCyADGzcDECACIBAgDCADGzcDCCACIAEoAkA2AkggACACQQhqEMIKIQMgACgCBCgCACADELkKIAJB8ABqJAALqQMCB38CeyMAQUBqIgMkACABKAIAIgQgASgCBCACEMUKIQUgAyAEKAIEKAIAIgYgBigCAEGIAWogBSAFELcKNgIAIAQoAgQgBSADELgKIQYgBCgCBCgCACAGELkKIANBEGoiBiABKAIAKAIAIgf9AAN4/QsDACADIAf9AANo/QsDACADQTBqIgggB/0AA5gB/QsDACADQSBqIgkgB/0AA4gB/QsDACAAIAP9AAMA/QsDACAAIAb9AAMA/QsDECAAIAj9AAMA/QsDMCAAIAn9AAMA/QsDICAAIAU2AkAgBCABKAIEQYABaiACEMUKIQUgAyAEKAIEKAIAIgcgBygCAEGIAWogBSAFELcKNgIAIAQoAgQgBSADELgKIQcgBCgCBCgCACAHELkKIAYgASgCACgCACIE/QADeP0LAwAgAyAE/QADaP0LAwAgCCAE/QADmAH9CwMAIAkgBP0AA4gB/QsDACAAIAP9AAMA/QsDSCAAIAb9AAMA/QsDWCAI/QADACEKIAn9AAMAIQsgACAFNgKIASAAIAv9CwNoIAAgCv0LA3ggA0FAayQAC+oBAQN/IwBBMGsiAiQAIAAoAgQoAgAgAUEgaiABKAJAEMgKIQQgAf0AAwAgACgCACID/QADaP3XASAB/QADECAD/QADeP3XAf0NAAECAwgJCgsQERITGBkaG/1TBEAgACgCBCgCACIDIAEQygkhASAC/QwAAAAAAAAAAAAAAAAAAAAA/QsDACACQgA3AxggAkJ/NwMQIAEEQCACQgA3AiggAiABNgIkIAIgAkEkahDnCQsgAyACEMsJIQMgAigCACIBBEAgAiABNgIEIAEQKwsgACgCBCgCACADIAQQvAohBAsgAkEwaiQAIAQLiw0CA38dfiMAQYACayIEJAAgASgCACIFKQPgASEfIAUpA9gBIRYgBSkDyAEhGyAFKQPQASEcIAUpA6ABIRcgBSkDmAEhCiAFKQOIASEOIAUpA5ABIQ8gBCAFKQOAASITIAUpA8ABfSIMIAUpA3giECAFKQO4AX0iFCAQViAUIAUpA3AiESAFKQOwAX0iByARViAHIAUpA2giEiAFKQOoAX0iCSASVq19IgggB1ZyrX0iByAUVnKtfSIUIAcgBSkDECIgfCILIAdUIAsgCCAFKQMIIiF8Ig0gCFQgDSAJIAUpAwAiInwiFSAJVK18IhkgDVRyrXwiDSALVHKtIBQgBSkDGCIjfHxCACAMIBRUIAwgE1ZyrVEiBhsiDDcDsAEgBCAHIA0gBhsiBzcDqAEgBCAIIBkgBhsiCDcDoAEgBCAJIBUgBhsiCTcDmAEgBSAEQZgBaiACEKQJIAQpA7ABIRkgBCkDqAEhGCAEKQOYASEdIAQpA6ABIRogASgCACIFKQM4IRQgBSkDMCELIAUpAyAhDSAFKQMoIRUgBCAMNwNoIARB4ABqIgYgBzcDACAEIAg3A1ggBCAJNwNQIAUgBEHQAGogAkEgahCkCSAEIAb9AAMA/QsDyAEgBCAE/QADUP0LA7gBIAQgFCAXIBl8IhkgCiAYfCIYIApUIBggDyAafCIKIA9UIAogDiAdfCIPIA5UrXwiDiAKVHKtfCIKIBhUcq18Ihh8Ih0gCiALfCIaIAtUIBogDiAVfCILIBVUIAsgDSAPfCIVIA1UrXwiDSALVHKtfCILIBpUcq18IhogGCAYIBlUIBcgGVZyIBogHVQgFCAdVnJzIgYbNwOwASAEIAsgCiAGGzcDqAEgBCANIA4gBhs3A6ABIAQgFSAPIAYbNwOYASAEIAIoAkA2AtgBIAUpA6ABIRcgBSkDmAEhCiAFKQOIASEOIAUpA5ABIQ8gBCAMNwNoIAQgBzcDYCAEIAg3A1ggBCAJNwNQIAUgBEHQAGogAxCkCSAEKQNoIRkgBCkDYCEYIAQpA1AhHSAEKQNYIRogASgCACIFKQM4IRQgBSkDMCELIAUpAyAhDSAFKQMoIRUgBCAMNwMgIARBGGoiAiAHNwMAIAQgCDcDECAEIAk3AwggBSAEQQhqIANBIGoQpAkgBCAC/QADAP0LA4ABIAQgBP0AAwj9CwNwIAQgFCAXIBl8IgkgCiAYfCIIIApUIAggDyAafCIHIA9UIAcgDiAdfCIMIA5UrXwiCiAHVHKtfCIHIAhUcq18Igh8Ig4gByALfCIPIAtUIA8gCiAVfCILIBVUIAsgDCANfCIVIA1UrXwiDSALVHKtfCILIA9Ucq18Ig8gCCAJIBdUIAggCVRyIA4gFFQgDiAPVnJzIgUbNwNoIAQgCyAHIAUbNwNgIAQgDSAKIAUbNwNYIAQgFSAMIAUbNwNQIAQgAygCQDYCkAEgBEEIaiABIARBmAFqIARB0ABqEMYKIAEoAgAhBSAEIBMgH30iCSAQIBZ9IgggEFYgCCARIBx9IgcgEVYgByASIBt9IhAgElatfSIRIAdWcq19IhIgCFZyrX0iCCASICB8IgcgElQgByARICF8IgwgEVQgDCAQICJ8IhcgEFStfCIKIAxUcq18IgwgB1RyrSAIICN8fCAeIAkgE1YgCCAJVnKtUSIBGyIJNwP4ASAEIBIgDCABGyISNwPwASAEIBEgCiABGyIINwPoASAEIBAgFyABGyIHNwPgASAFIARB4AFqIARBCGoQpAkgBCkD+AEhDCAEKQPwASEXIAQpA+ABIQogBCkD6AEhDiAFKQM4IR4gBSkDMCETIAUpAyAhECAFKQMoIREgBCAJNwP4ASAEQfABaiIBIBI3AwAgBCAINwPoASAEIAc3A+ABIAUgBEHgAWogBEEoahCkCSAAIAH9AAMA/QsDMCAAIAT9AAPgAf0LAyAgACAeIAwgH3wiEiAWIBd8IgkgFlQgCSAOIBx8IhYgHFQgFiAKIBt8IhwgG1StfCIbIBZUcq18IhYgCVRyrXwiCXwiCCATIBZ8IgcgE1QgByARIBt8IhMgEVQgEyAQIBx8IhEgEFStfCIQIBNUcq18IhMgB1RyrXwiByAJIBIgH1QgCSASVHIgByAIVCAIIB5UcnMiBRs3AxggACATIBYgBRs3AxAgACAQIBsgBRs3AwggACARIBwgBRs3AwAgACAEKAJINgJAIARBgAJqJAAL8EUBB38jAEHgDGsiBSQAIAVBCBCiCSIENgIAIAUgBEEIaiIGNgIIIARCgICAhJCfgP8ANwEAIAUgBjYCBCAFQQwQogkiBDYCDCAFIARBDGoiBjYCFCAEQfqB+Ac2AQggBEKBgICEkJDA/AA3AQAgBSAGNgIQIAVBEBCiCSIENgIYIAUgBEEQaiIGNgIgIAT9DAIAgACBAIIA+QD6APsA/gD9CwEAIAUgBjYCHCAFQQ4QogkiBDYCJCAFIARBDmoiBjYCLCAEQfwBOwEMIARB+oHsBzYBCCAEQoOAhISgkMDBADcBACAFIAY2AiggBUEOEKIJIgQ2AjAgBSAEQQ5qIgY2AjggBEH9ATsBDCAEQfuB8Ac2AQggBEKEgIiEsJCAwgA3AQAgBSAGNgI0IAVBDhCiCSIENgI8IAUgBEEOaiIGNgJEIARB/gE7AQwgBEH8gfQHNgEIIARChYCMhMCQwMIANwEAIAUgBjYCQCAFQQwQogkiBDYCSCAFIARBDGoiBjYCUCAEQf2B+Ac2AQggBEKGgJCE0JCAwwA3AQAgBSAGNgJMIAVBDBCiCSIENgJUIAUgBEEMaiIGNgJcIARBh4HkBzYBCCAEQoeAgITQkIDDADcBACAFIAY2AlggBUEMEKIJIgQ2AmAgBSAEQQxqIgY2AmggBEGIgegHNgEIIARCiICEhOCQwMMANwEAIAUgBjYCZCAFQQwQogkiBDYCbCAFIARBDGoiBjYCdCAEQYmB7Ac2AQggBEKJgIiE8JCAxAA3AQAgBSAGNgJwIAVBDBCiCSIENgJ4IAUgBEEMaiIGNgKAASAEQYqB8Ac2AQggBEKKgIyEgJHAxAA3AQAgBSAGNgJ8IAVBDBCiCSIENgKEASAFIARBDGoiBjYCjAEgBEGLgfQHNgEIIARCi4CQhJCRgMUANwEAIAUgBjYCiAEgBUEMEKIJIgQ2ApABIAUgBEEMaiIGNgKYASAEQYyB+Ac2AQggBEKMgJSEoJHAxQA3AQAgBSAGNgKUASAFQQoQogkiBDYCnAEgBSAEQQpqIgY2AqQBIARBjQE7AQggBEKNgJiEsJGAxgA3AQAgBSAGNgKgASAFQQoQogkiBDYCqAEgBSAEQQpqIgY2ArABIARBjgE7AQggBEKOgJyEwJHAxgA3AQAgBSAGNgKsASAFQQoQogkiBDYCtAEgBSAEQQpqIgY2ArwBIARBjwE7AQggBEKPgKCE0JGAxwA3AQAgBSAGNgK4ASAFQQoQogkiBDYCwAEgBSAEQQpqIgY2AsgBIARBkAE7AQggBEKQgKSE4JHAxwA3AQAgBSAGNgLEASAFQQoQogkiBDYCzAEgBSAEQQpqIgY2AtQBIARBkQE7AQggBEKRgKiE8JGAyAA3AQAgBSAGNgLQASAFQQoQogkiBDYC2AEgBSAEQQpqIgY2AuABIARBkgE7AQggBEKSgKyEgJLAyAA3AQAgBSAGNgLcASAFQQoQogkiBDYC5AEgBSAEQQpqIgY2AuwBIARBkwE7AQggBEKTgLCEkJKAyQA3AQAgBSAGNgLoASAFQQoQogkiBDYC8AEgBSAEQQpqIgY2AvgBIARBlAE7AQggBEKUgLSEoJLAyQA3AQAgBSAGNgL0ASAFQQoQogkiBDYC/AEgBSAEQQpqIgY2AoQCIARBlQE7AQggBEKVgLiEsJKAygA3AQAgBSAGNgKAAiAFQQoQogkiBDYCiAIgBSAEQQpqIgY2ApACIARBlgE7AQggBEKWgLyEwJLAygA3AQAgBSAGNgKMAiAFQQoQogkiBDYClAIgBSAEQQpqIgY2ApwCIARBlwE7AQggBEKXgMCE0JKAywA3AQAgBSAGNgKYAiAFQQoQogkiBDYCoAIgBSAEQQpqIgY2AqgCIARBmAE7AQggBEKYgMSE4JLAywA3AQAgBSAGNgKkAiAFQQoQogkiBDYCrAIgBSAEQQpqIgY2ArQCIARBmQE7AQggBEKZgMiE8JKAzAA3AQAgBSAGNgKwAiAFQQoQogkiBDYCuAIgBSAEQQpqIgY2AsACIARBmgE7AQggBEKagMyEgJPAzAA3AQAgBSAGNgK8AiAFQQoQogkiBDYCxAIgBSAEQQpqIgY2AswCIARBmwE7AQggBEKbgNCEkJOAzQA3AQAgBSAGNgLIAiAFQQoQogkiBDYC0AIgBSAEQQpqIgY2AtgCIARBnAE7AQggBEKcgNSEoJPAzQA3AQAgBSAGNgLUAiAFQQoQogkiBDYC3AIgBSAEQQpqIgY2AuQCIARBnQE7AQggBEKdgNiEsJOAzgA3AQAgBSAGNgLgAiAFQQoQogkiBDYC6AIgBSAEQQpqIgY2AvACIARBngE7AQggBEKegNyEwJPAzgA3AQAgBSAGNgLsAiAFQQoQogkiBDYC9AIgBSAEQQpqIgY2AvwCIARBnwE7AQggBEKfgOCE0JOAzwA3AQAgBSAGNgL4AiAFQQoQogkiBDYCgAMgBSAEQQpqIgY2AogDIARBoAE7AQggBEKggOSE4JPAzwA3AQAgBSAGNgKEAyAFQQoQogkiBDYCjAMgBSAEQQpqIgY2ApQDIARBoQE7AQggBEKhgOiE8JOA0AA3AQAgBSAGNgKQAyAFQQoQogkiBDYCmAMgBSAEQQpqIgY2AqADIARBogE7AQggBEKigOyEgJTA0AA3AQAgBSAGNgKcAyAFQQoQogkiBDYCpAMgBSAEQQpqIgY2AqwDIARBowE7AQggBEKjgPCEkJSA0QA3AQAgBSAGNgKoAyAFQQoQogkiBDYCsAMgBSAEQQpqIgY2ArgDIARBpAE7AQggBEKkgPSEoJTA0QA3AQAgBSAGNgK0AyAFQQoQogkiBDYCvAMgBSAEQQpqIgY2AsQDIARBpQE7AQggBEKlgPiEsJSA0gA3AQAgBSAGNgLAAyAFQQoQogkiBDYCyAMgBSAEQQpqIgY2AtADIARBpgE7AQggBEKmgPyEwJTA0gA3AQAgBSAGNgLMAyAFQQoQogkiBDYC1AMgBSAEQQpqIgY2AtwDIARBpwE7AQggBEKngICF0JSA0wA3AQAgBSAGNgLYAyAFQQoQogkiBDYC4AMgBSAEQQpqIgY2AugDIARBqAE7AQggBEKogISF4JTA0wA3AQAgBSAGNgLkAyAFQQoQogkiBDYC7AMgBSAEQQpqIgY2AvQDIARBqQE7AQggBEKpgIiF8JSA1AA3AQAgBSAGNgLwAyAFQQoQogkiBDYC+AMgBSAEQQpqIgY2AoAEIARBqgE7AQggBEKqgIyFgJXA1AA3AQAgBSAGNgL8AyAFQQoQogkiBDYChAQgBSAEQQpqIgY2AowEIARBqwE7AQggBEKrgJCFkJWA1QA3AQAgBSAGNgKIBCAFQQoQogkiBDYCkAQgBSAEQQpqIgY2ApgEIARBrAE7AQggBEKsgJSFoJXA1QA3AQAgBSAGNgKUBCAFQQoQogkiBDYCnAQgBSAEQQpqIgY2AqQEIARBrQE7AQggBEKtgJiFsJWA1gA3AQAgBSAGNgKgBCAFQQoQogkiBDYCqAQgBSAEQQpqIgY2ArAEIARBrgE7AQggBEKugJyFwJXA1gA3AQAgBSAGNgKsBCAFQQoQogkiBDYCtAQgBSAEQQpqIgY2ArwEIARBrwE7AQggBEKvgKCF0JWA1wA3AQAgBSAGNgK4BCAFQQoQogkiBDYCwAQgBSAEQQpqIgY2AsgEIARBsAE7AQggBEKwgKSF4JXA1wA3AQAgBSAGNgLEBCAFQQoQogkiBDYCzAQgBSAEQQpqIgY2AtQEIARBsQE7AQggBEKxgKiF8JWA2AA3AQAgBSAGNgLQBCAFQQoQogkiBDYC2AQgBSAEQQpqIgY2AuAEIARBsgE7AQggBEKygKyFgJbA2AA3AQAgBSAGNgLcBCAFQQoQogkiBDYC5AQgBSAEQQpqIgY2AuwEIARBswE7AQggBEKzgLCFkJaA2QA3AQAgBSAGNgLoBCAFQQoQogkiBDYC8AQgBSAEQQpqIgY2AvgEIARBtAE7AQggBEK0gLSFoJbA2QA3AQAgBSAGNgL0BCAFQQoQogkiBDYC/AQgBSAEQQpqIgY2AoQFIARBtQE7AQggBEK1gLiFsJaA2gA3AQAgBSAGNgKABSAFQQoQogkiBDYCiAUgBSAEQQpqIgY2ApAFIARBtgE7AQggBEK2gLyFwJbA2gA3AQAgBSAGNgKMBSAFQQoQogkiBDYClAUgBSAEQQpqIgY2ApwFIARBtwE7AQggBEK3gMCF0JaA2wA3AQAgBSAGNgKYBSAFQQoQogkiBDYCoAUgBSAEQQpqIgY2AqgFIARBuAE7AQggBEK4gMSF4JbA2wA3AQAgBSAGNgKkBSAFQQoQogkiBDYCrAUgBSAEQQpqIgY2ArQFIARBuQE7AQggBEG4ATsBBiAEQbcBOwEEIARBsgE7AQIgBEE5OwEAIAUgBjYCsAUgBUEKEKIJIgQ2ArgFIAUgBEEKaiIGNgLABSAEQboBOwEIIARBuQE7AQYgBEG4ATsBBCAEQbMBOwECIARBOjsBACAFIAY2ArwFIAVBChCiCSIENgLEBSAFIARBCmoiBjYCzAUgBEG7ATsBCCAEQboBOwEGIARBuQE7AQQgBEG0ATsBAiAEQTs7AQAgBSAGNgLIBSAFQQoQogkiBDYC0AUgBSAEQQpqIgY2AtgFIARBvAE7AQggBEG7ATsBBiAEQboBOwEEIARBtQE7AQIgBEE8OwEAIAUgBjYC1AUgBUEKEKIJIgQ2AtwFIAUgBEEKaiIGNgLkBSAEQb0BOwEIIARBvAE7AQYgBEG7ATsBBCAEQbYBOwECIARBPTsBACAFIAY2AuAFIAVBChCiCSIENgLoBSAFIARBCmoiBjYC8AUgBEG+ATsBCCAEQb0BOwEGIARBvAE7AQQgBEG3ATsBAiAEQT47AQAgBSAGNgLsBSAFQQoQogkiBDYC9AUgBSAEQQpqIgY2AvwFIARBvwE7AQggBEG+ATsBBiAEQb0BOwEEIARBuAE7AQIgBEE/OwEAIAUgBjYC+AUgBUEKEKIJIgQ2AoAGIAUgBEEKaiIGNgKIBiAEQcABOwEIIARBvwE7AQYgBEG+ATsBBCAEQbkBOwECIARBwAA7AQAgBSAGNgKEBiAFQQoQogkiBDYCjAYgBSAEQQpqIgY2ApQGIARBwQE7AQggBEHAATsBBiAEQb8BOwEEIARBugE7AQIgBEHBADsBACAFIAY2ApAGIAVBChCiCSIENgKYBiAFIARBCmoiBjYCoAYgBEHCATsBCCAEQcEBOwEGIARBwAE7AQQgBEG7ATsBAiAEQcIAOwEAIAUgBjYCnAYgBUEKEKIJIgQ2AqQGIAUgBEEKaiIGNgKsBiAEQcMBOwEIIARBwgE7AQYgBEHBATsBBCAEQbwBOwECIARBwwA7AQAgBSAGNgKoBiAFQQoQogkiBDYCsAYgBSAEQQpqIgY2ArgGIARBxAE7AQggBEHDATsBBiAEQcIBOwEEIARBvQE7AQIgBEHEADsBACAFIAY2ArQGIAVBChCiCSIENgK8BiAFIARBCmoiBjYCxAYgBEHFATsBCCAEQcQBOwEGIARBwwE7AQQgBEG+ATsBAiAEQcUAOwEAIAUgBjYCwAYgBUEKEKIJIgQ2AsgGIAUgBEEKaiIGNgLQBiAEQcYBOwEIIARBxQE7AQYgBEHEATsBBCAEQb8BOwECIARBxgA7AQAgBSAGNgLMBiAFQQoQogkiBDYC1AYgBSAEQQpqIgY2AtwGIARBxwE7AQggBEHGATsBBiAEQcUBOwEEIARBwAE7AQIgBEHHADsBACAFIAY2AtgGIAVBChCiCSIENgLgBiAFIARBCmoiBjYC6AYgBEHIATsBCCAEQccBOwEGIARBxgE7AQQgBEHBATsBAiAEQcgAOwEAIAUgBjYC5AYgBUEKEKIJIgQ2AuwGIAUgBEEKaiIGNgL0BiAEQckBOwEIIARByAE7AQYgBEHHATsBBCAEQcIBOwECIARByQA7AQAgBSAGNgLwBiAFQQoQogkiBDYC+AYgBSAEQQpqIgY2AoAHIARBygE7AQggBEHJATsBBiAEQcgBOwEEIARBwwE7AQIgBEHKADsBACAFIAY2AvwGIAVBChCiCSIENgKEByAFIARBCmoiBjYCjAcgBEHLATsBCCAEQcoBOwEGIARByQE7AQQgBEHEATsBAiAEQcsAOwEAIAUgBjYCiAcgBUEKEKIJIgQ2ApAHIAUgBEEKaiIGNgKYByAEQcwBOwEIIARBywE7AQYgBEHKATsBBCAEQcUBOwECIARBzAA7AQAgBSAGNgKUByAFQQoQogkiBDYCnAcgBSAEQQpqIgY2AqQHIARBzQE7AQggBEHMATsBBiAEQcsBOwEEIARBxgE7AQIgBEHNADsBACAFIAY2AqAHIAVBChCiCSIENgKoByAFIARBCmoiBjYCsAcgBEHOATsBCCAEQc0BOwEGIARBzAE7AQQgBEHHATsBAiAEQc4AOwEAIAUgBjYCrAcgBUEKEKIJIgQ2ArQHIAUgBEEKaiIGNgK8ByAEQc8BOwEIIARBzgE7AQYgBEHNATsBBCAEQcgBOwECIARBzwA7AQAgBSAGNgK4ByAFQQoQogkiBDYCwAcgBSAEQQpqIgY2AsgHIARB0AE7AQggBEHPATsBBiAEQc4BOwEEIARByQE7AQIgBEHQADsBACAFIAY2AsQHIAVBChCiCSIENgLMByAFIARBCmoiBjYC1AcgBEHRATsBCCAEQdABOwEGIARBzwE7AQQgBEHKATsBAiAEQdEAOwEAIAUgBjYC0AcgBUEKEKIJIgQ2AtgHIAUgBEEKaiIGNgLgByAEQdIBOwEIIARB0QE7AQYgBEHQATsBBCAEQcsBOwECIARB0gA7AQAgBSAGNgLcByAFQQoQogkiBDYC5AcgBSAEQQpqIgY2AuwHIARB0wE7AQggBEHSATsBBiAEQdEBOwEEIARBzAE7AQIgBEHTADsBACAFIAY2AugHIAVBChCiCSIENgLwByAFIARBCmoiBjYC+AcgBEHUATsBCCAEQdMBOwEGIARB0gE7AQQgBEHNATsBAiAEQdQAOwEAIAUgBjYC9AcgBUEKEKIJIgQ2AvwHIAUgBEEKaiIGNgKECCAEQdUBOwEIIARB1AE7AQYgBEHTATsBBCAEQc4BOwECIARB1QA7AQAgBSAGNgKACCAFQQoQogkiBDYCiAggBSAEQQpqIgY2ApAIIARB1gE7AQggBEHVATsBBiAEQdQBOwEEIARBzwE7AQIgBEHWADsBACAFIAY2AowIIAVBChCiCSIENgKUCCAFIARBCmoiBjYCnAggBEHXATsBCCAEQdYBOwEGIARB1QE7AQQgBEHQATsBAiAEQdcAOwEAIAUgBjYCmAggBUEKEKIJIgQ2AqAIIAUgBEEKaiIGNgKoCCAEQdgBOwEIIARB1wE7AQYgBEHWATsBBCAEQdEBOwECIARB2AA7AQAgBSAGNgKkCCAFQQoQogkiBDYCrAggBSAEQQpqIgY2ArQIIARB2QE7AQggBEHYATsBBiAEQdcBOwEEIARB0gE7AQIgBEHZADsBACAFIAY2ArAIIAVBChCiCSIENgK4CCAFIARBCmoiBjYCwAggBEHaATsBCCAEQdkBOwEGIARB2AE7AQQgBEHTATsBAiAEQdoAOwEAIAUgBjYCvAggBUEKEKIJIgQ2AsQIIAUgBEEKaiIGNgLMCCAEQdsBOwEIIARB2gE7AQYgBEHZATsBBCAEQdQBOwECIARB2wA7AQAgBSAGNgLICCAFQQoQogkiBDYC0AggBSAEQQpqIgY2AtgIIARB3AE7AQggBEHbATsBBiAEQdoBOwEEIARB1QE7AQIgBEHcADsBACAFIAY2AtQIIAVBChCiCSIENgLcCCAFIARBCmoiBjYC5AggBEHdATsBCCAEQdwBOwEGIARB2wE7AQQgBEHWATsBAiAEQd0AOwEAIAUgBjYC4AggBUEKEKIJIgQ2AugIIAUgBEEKaiIGNgLwCCAEQd4BOwEIIARB3QE7AQYgBEHcATsBBCAEQdcBOwECIARB3gA7AQAgBSAGNgLsCCAFQQoQogkiBDYC9AggBSAEQQpqIgY2AvwIIARB3wE7AQggBEHeATsBBiAEQd0BOwEEIARB2AE7AQIgBEHfADsBACAFIAY2AvgIIAVBChCiCSIENgKACSAFIARBCmoiBjYCiAkgBEHgATsBCCAEQd8BOwEGIARB3gE7AQQgBEHZATsBAiAEQeAAOwEAIAUgBjYChAkgBUEKEKIJIgQ2AowJIAUgBEEKaiIGNgKUCSAEQeEBOwEIIARB4AE7AQYgBEHfATsBBCAEQdoBOwECIARB4QA7AQAgBSAGNgKQCSAFQQoQogkiBDYCmAkgBSAEQQpqIgY2AqAJIARB4gE7AQggBEHhATsBBiAEQeABOwEEIARB2wE7AQIgBEHiADsBACAFIAY2ApwJIAVBChCiCSIENgKkCSAFIARBCmoiBjYCrAkgBEHjATsBCCAEQeIBOwEGIARB4QE7AQQgBEHcATsBAiAEQeMAOwEAIAUgBjYCqAkgBUEKEKIJIgQ2ArAJIAUgBEEKaiIGNgK4CSAEQeQBOwEIIARB4wE7AQYgBEHiATsBBCAEQd0BOwECIARB5AA7AQAgBSAGNgK0CSAFQQoQogkiBDYCvAkgBSAEQQpqIgY2AsQJIARB5QE7AQggBEHkATsBBiAEQeMBOwEEIARB3gE7AQIgBEHlADsBACAFIAY2AsAJIAVBChCiCSIENgLICSAFIARBCmoiBjYC0AkgBEHmATsBCCAEQeUBOwEGIARB5AE7AQQgBEHfATsBAiAEQeYAOwEAIAUgBjYCzAkgBUEKEKIJIgQ2AtQJIAUgBEEKaiIGNgLcCSAEQecBOwEIIARB5gE7AQYgBEHlATsBBCAEQeABOwECIARB5wA7AQAgBSAGNgLYCSAFQQoQogkiBDYC4AkgBSAEQQpqIgY2AugJIARB6AE7AQggBEHnATsBBiAEQeYBOwEEIARB4QE7AQIgBEHoADsBACAFIAY2AuQJIAVBChCiCSIENgLsCSAFIARBCmoiBjYC9AkgBEHpATsBCCAEQegBOwEGIARB5wE7AQQgBEHiATsBAiAEQekAOwEAIAUgBjYC8AkgBUEKEKIJIgQ2AvgJIAUgBEEKaiIGNgKACiAEQeoBOwEIIARB6QE7AQYgBEHoATsBBCAEQeMBOwECIARB6gA7AQAgBSAGNgL8CSAFQQoQogkiBDYChAogBSAEQQpqIgY2AowKIARB6wE7AQggBEHqATsBBiAEQekBOwEEIARB5AE7AQIgBEHrADsBACAFIAY2AogKIAVBChCiCSIENgKQCiAFIARBCmoiBjYCmAogBEHsATsBCCAEQesBOwEGIARB6gE7AQQgBEHlATsBAiAEQewAOwEAIAUgBjYClAogBUEKEKIJIgQ2ApwKIAUgBEEKaiIGNgKkCiAEQe0BOwEIIARB7AE7AQYgBEHrATsBBCAEQeYBOwECIARB7QA7AQAgBSAGNgKgCiAFQQoQogkiBDYCqAogBSAEQQpqIgY2ArAKIARB7gE7AQggBEHtATsBBiAEQewBOwEEIARB5wE7AQIgBEHuADsBACAFIAY2AqwKIAVBChCiCSIENgK0CiAFIARBCmoiBjYCvAogBEHvATsBCCAEQe4BOwEGIARB7QE7AQQgBEHoATsBAiAEQe8AOwEAIAUgBjYCuAogBUEKEKIJIgQ2AsAKIAUgBEEKaiIGNgLICiAEQfABOwEIIARB7wE7AQYgBEHuATsBBCAEQekBOwECIARB8AA7AQAgBSAGNgLECiAFQQoQogkiBDYCzAogBSAEQQpqIgY2AtQKIARB8QE7AQggBEHwATsBBiAEQe8BOwEEIARB6gE7AQIgBEHxADsBACAFIAY2AtAKIAVBChCiCSIENgLYCiAFIARBCmoiBjYC4AogBEHyATsBCCAEQfEBOwEGIARB8AE7AQQgBEHrATsBAiAEQfIAOwEAIAUgBjYC3AogBUEKEKIJIgQ2AuQKIAUgBEEKaiIGNgLsCiAEQfMBOwEIIARB8gE7AQYgBEHxATsBBCAEQewBOwECIARB8wA7AQAgBSAGNgLoCiAFQQoQogkiBDYC8AogBSAEQQpqIgY2AvgKIARB9AE7AQggBEHzATsBBiAEQfIBOwEEIARB7QE7AQIgBEH0ADsBACAFIAY2AvQKIAVBChCiCSIENgL8CiAFIARBCmoiBjYChAsgBEH1ATsBCCAEQfQBOwEGIARB8wE7AQQgBEHuATsBAiAEQfUAOwEAIAUgBjYCgAsgBUEKEKIJIgQ2AogLIAUgBEEKaiIGNgKQCyAEQfYBOwEIIARB9QE7AQYgBEH0ATsBBCAEQe8BOwECIARB9gA7AQAgBSAGNgKMCyAFQQoQogkiBDYClAsgBSAEQQpqIgY2ApwLIARB9wE7AQggBEH2ATsBBiAEQfUBOwEEIARB8AE7AQIgBEH3ADsBACAFIAY2ApgLIAVBChCiCSIENgKgCyAFIARBCmoiBjYCqAsgBEH4ATsBCCAEQfcBOwEGIARB9gE7AQQgBEHxATsBAiAEQfgAOwEAIAUgBjYCpAsgBUEKEKIJIgQ2AqwLIAUgBEEKaiIGNgK0CyAEQfkBOwEIIARB+AE7AQYgBEH3ATsBBCAEQfIBOwECIARB+QA7AQAgBSAGNgKwCyAFQQoQogkiBDYCuAsgBSAEQQpqIgY2AsALIARB+gE7AQggBEH5ATsBBiAEQfgBOwEEIARB8wE7AQIgBEH6ADsBACAFIAY2ArwLIAVBChCiCSIENgLECyAFIARBCmoiBjYCzAsgBEH7ATsBCCAEQfoBOwEGIARB+QE7AQQgBEH0ATsBAiAEQfsAOwEAIAUgBjYCyAsgBUEKEKIJIgQ2AtALIAUgBEEKaiIGNgLYCyAEQfwBOwEIIARB+wE7AQYgBEH6ATsBBCAEQfUBOwECIARB/AA7AQAgBSAGNgLUCyAFQQoQogkiBDYC3AsgBSAEQQpqIgY2AuQLIARB/QE7AQggBEH8ATsBBiAEQfsBOwEEIARB9gE7AQIgBEH9ADsBACAFIAY2AuALIAVBChCiCSIENgLoCyAFIARBCmoiBjYC8AsgBEH+ATsBCCAEQf0BOwEGIARB/AE7AQQgBEH3ATsBAiAEQf4AOwEAIAUgBjYC7AsgBUEIEKIJIgQ2AvQLIAUgBEEIaiIHNgL8CyAEQv+A4IfQn4D/ADcBAEEAIQYgBUEANgKIDCAFQQA2AoQMIAVBADYCgAwgBSAHNgL4C0GAkAEQogkiCUEAQYCQAfwLAEGAyAAQogkiCkEAQYDIAPwLAANAQQAhBEEAIQgDQAJAIAQgBksNACAGIARrIgdB/wBLDQAgBUGYDGogACACIARByABsaiADIAdByABsahDGCiAKIAhByABsaiAFQZgMakHIAPwKAAAgCEEBaiEICyAEQQFqIgRBgAFHDQALIAVBmAxqIABBACAIIAoQxwogCSAGQcgAbGogBUGYDGpByAD8CgAAIAZBAWoiBkGAAkcNAAsgChArQQAhA0GAyAAQogkiCEEAQYDIAPwLAANAQQAhBCAFIANBDGxqIgcoAgAiBiAHKAIEIgdHBEADQCAIIARByABsaiAJIAYvAQBByABsakHIAPwKAAAgBEEBaiEEIAZBAmoiBiAHRw0ACwsgBUGYDGogAEEAIAQgCBDHCiABIANByABsaiAFQZgMakHIAPwKAAAgA0EBaiIDQYABRw0ACyAIECsgCRArIAVBjAxqIQYDQCAGQQxrIgQoAgAiBwRAIAZBCGsgBzYCACAHECsLIAQhBiAEIAVHDQALIAVB4AxqJAAL+AEBBH8gACgCACAAQQRqIgMoAgBCARDNCiEFIAMoAgAoAgAiBCAEKAIAQYgBaiACKAIAIgIgAhC3CiEEIAMoAgAoAgAiBiAGKAIAQYgBaiAEIAIQtwohBiAAKAIAIAMoAgBCABDNCiEAIAMoAgAoAgAgASAFEMgKIQUgAygCACgCACAAIAUQvAohACADKAIAKAIAIAFBIGogAhDICiECIAMoAgAoAgAgACACELwKIQAgAygCACgCACABQUBrIAQQyAohAiADKAIAKAIAIAAgAhC8CiEAIAMoAgAoAgAgAUHgAGogBhDICiEBIAMoAgAoAgAgACABELwKC+AJAwh/DH4CeyMAQUBqIgQkACABKAIAIgb9AAN4Ihj9HQEhEiAY/R0AIQ0gBv0AA2giGf0dASEMAkACQAJAIBn9HQAiESACKQMgUg0AIAIpAyggDFINACACKQMwIA1SDQAgAikDOCASUQ0BCwJAIAP9AAMgIBn91gEgA/0AAzAgGP3WAf0NAAECAwgJCgsQERITGBkaG/2jAUUEQCADIQUMAQsDQCACIQUCQCADIgIpAyggDFINACACKQMwIA1SDQAgAikDOCASUg0AIAUhAwwDCyAFIQMgBf0AAyAgGf3WASAF/QADMCAY/dYB/Q0AAQIDCAkKCxAREhMYGRob/aMBDQALCyAEQTBqIgggAv0AAzD9CwMAIAQgAv0AAyD9CwMgIAYgBEEgaiAFQSBqIgcQpAkgBCAI/QADAP0LAxAgBCAE/QADIP0LAwAgASgCBCgCACAEIAIoAkAgBSgCQBC3CiEGIAEoAgAhAyAIIAL9AAMQ/QsDACAEIAL9AAMA/QsDICADIARBIGogBxCkCSAEIAQpAzg3AxggBCAE/QADKP0LAwggBCAEKQMgIgw3AwAgAkEgaiEHIAUoAkAhCQJAAkAgDCABKAIEIggoAgAiCigCACILKQNoUg0AIAQpAwggCykDcFINACAEKQMQIAspA3hSDQAgBCkDGCALKQOAAVENAQsgCiAGIAogBEEAIAkQtwoQvAohBiABKAIEIQggASgCACEDCyAEIAf9AAMQ/QsDMCAEIAf9AAMA/QsDICADIARBIGogBRCkCSAEIAQpAzg3AxggBCAE/QADKP0LAwggBCAEKQMgIgw3AwAgAigCQCEKAkACQCAMIAgoAgAiBygCACIJKQNoUg0AIAQpAwggCSkDcFINACAEKQMQIAkpA3hSDQAgBCkDGCAJKQOAAVENAQsgByAGIAcgBEEAIAoQtwoQvAohBiABKAIEIQggASgCACEDCyAEQTBqIgcgAv0AAxD9CwMAIAQgAv0AAwD9CwMgIAMgBEEgaiAFEKQJIAQgB/0AAwD9CwMQIAQgBP0AAyD9CwMAIAgoAgAgBiAEEMwKIQIgACABKAIAIgX9AAOIAf0LAyAgACAF/QADmAH9CwMwIAAgBf0AA2j9CwMAIAX9AAN4IRggACACNgJAIAAgGP0LAxAMAQsgBEEwaiIFIAJBEGoiAf0AAwD9CwMAIAQgAv0AAwD9CwMgIAYgBEEgaiADEKQJIAQpAzghEyAFKQMAIQ4gBCkDKCEUIAQpAyAhECAGKQM4IRcgBikDMCEPIAYpAyAhFSAGKQMoIRYgBSAB/QADAP0LAwAgBCAC/QADAP0LAyAgBiAEQSBqIANBIGoQpAkgACAF/QADAP0LAzAgACAE/QADIP0LAyAgACAXIBIgE3wiEyANIA58Ig4gDVQgDiAMIBR8Ig0gDFQgDSAQIBF8IgwgEVStfCIRIA1Ucq18Ig0gDlRyrXwiDnwiFCANIA98IhAgD1QgECARIBZ8Ig8gFlQgDyAMIBV8IhYgFVStfCIVIA9Ucq18Ig8gEFRyrXwiECAOIA4gE1QgEiATVnIgFCAXVCAQIBRUcnMiBRs3AxggACAPIA0gBRs3AxAgACAVIBEgBRs3AwggACAWIAwgBRs3AwAgACADKAJANgJACyAEQUBrJAALjgEBAX8jAEGQAWsiBSQAAkAgAiADTwRAIAAgASgCACABKAIEKAIAQQAQzgkMAQsgAkEBaiADRgRAIAAgBCACQcgAbGpByAD8CgAADAELIAVByABqIAEgAiADIAJrQQF2IAJqIgIgBBDHCiAFIAEgAiADIAQQxwogACABIAVByABqIAUQwwoLIAVBkAFqJAALlwUCBn8BfiMAQeAAayIDJAACQAJAAkAgASkDACIJIAAoAgAiBCkDaFINACABKQMIIAQpA3BSDQAgASkDECAEKQN4Ug0AIAEpAxggBCkDgAFSDQAgACABEMoJIQQgA/0MAAAAAAAAAAAAAAAAAAAAAP0LA0AgA0IANwNYIANCfzcDUCAEBEAgA0IANwIkIAMgBDYCICADQUBrIANBIGoQ5wkLIAAgA0FAaxDLCSECIAMoAkAiBEUNASADIAQ2AkQgBBArDAELAkAgCSAEKQOIAVINACABKQMIIAQpA5ABUg0AIAEpAxAgBCkDmAFSDQAgASkDGCAEKQOgAVENAQsgACgCTCACQQV0aiIFKAIEIQggBS0AHiIERSAFKAIAIgYgCEZxDQACQCAEBEAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgA0IANwMYIANCfzcDECADIAI2AkggA0IBNwJAIAMgA0FAaxDnCSADKAIEIQcgAygCACEEDAELIANBADYCCCADQgA3AgBBACEEIAYgCEcEQCAIIAZrIgJBDG1B1qrVqgFPDQMgAyACEKIJIgQ2AgAgAyACIARqIgc2AgggAgRAIAQgBiAC/AoAAAsgAyAHNgIECyADIAUoAhw2AhwgAyAF/QACDP0LAgwLIAQgB0cEQANAIAAoAgAhAiADQdAAaiIFIAAoAiwgBCgCAEEFdGoiBv0AAxD9CwMAIAMgBv0AAwD9CwNAIAIgA0FAayABEKQJIAMgBf0AAwD9CwMwIAMgA/0AA0D9CwMgIAQgACADQSBqEMoJNgIAIARBDGoiBCAHRw0ACwsgACADEMsJIQIgAygCACIERQ0AIAMgBDYCBCAEECsLIANB4ABqJAAgAg8LEKAJAAseAQF/QQwQogkiAUGMzzE2AgAgASAAKQIENwIEIAELFQAgAUGMzzE2AgAgASAAKQIENwIEC1MBAn8CQCAAKAIEIgIpAwAgACgCCCgCLCABKAIAQQV0aiIAKQMAUg0AIAIpAwggACkDCFINACACKQMQIAApAxBSDQAgAikDGCAAKQMYUSEDCyADC8sBAQJ/IwBBMGsiAyQAAkACQCACKQMAIAAoAgAiBCkDaFINACACKQMIIAQpA3BSDQAgAikDECAEKQN4Ug0AIAIpAxggBCkDgAFRDQELIAAgAhDKCSECIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIANCADcDGCADQn83AxAgAgRAIANCADcCKCADIAI2AiQgAyADQSRqEOcJCyAAIAMQywkhBCADKAIAIgIEQCADIAI2AgQgAhArCyAAIAEgBBC8CiEBCyADQTBqJAAgAQufAgEBfyMAQfAAayIDJAAgACkDGCAAKQMQIAApAwiEhEIAUiACIAApAwBUcgRAIAP9DAAAAAAAAAAAAAAAAAAAAAD9CwMwIANCADcDKCADIAI3AyAgACADQSBqIABBQGsQpAkgASgCACIBIANBIGoQygkhACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDQCADQgA3A1ggA0J/NwNQIAAEQCADQgA3AmggAyAANgJkIANBQGsgA0HkAGoQ5wkLIAEgA0FAaxDLCSEBIAMoAkAiAARAIAMgADYCRCAAECsLIANB8ABqJAAgAQ8LIANBgMYqNgIQQeQAQfSHKiADQRBqEJsJQZCWNCgCACgCACEAIANBgMYqNgIAIABBkYwqIAMQbAALHgEBf0EMEKIJIgFBsM8xNgIAIAEgACkCBDcCBCABCxUAIAFBsM8xNgIAIAEgACkCBDcCBAuTCAMIfwR7A34jAEGgAWsiASQAIABBsIg0NgIAIABByIo0/QADAP0LAxggAEG4ijT9AAMA/QsDCCABQZABaiIEQciJNP0AAwAiCf0LAwAgAUGAAWoiA0G4iTT9AAMAIgr9CwMAIAFB8ABqIgJBqIk0/QADACIL/QsDACABQZiJNP0AAwAiDP0LA2AgACAK/QsDiAIgACAM/QsD6AEgACAL/QsD+AEgACAJ/QsDmAICQAJAQgBBsIg0KQMAIg5ByIg0KQMAQcCINCkDAEG4iDQpAwCEhCIPhEIAUq1SBEAgAv0MAAAAAAAAAAAAAAAAAAAAACIJ/QsDACABIAn9CwNgQbCINCABQeAAakHwiDQQpAkgA0GoiTT9AAMA/QsDECADQZiJNP0AAwD9CwMAIAAgBP0AAwD9CwNYIAAgA/0AAwD9CwNIIAAgAv0AAwD9CwM4IAAgAf0AA2D9CwMoIA0gD0IAUiAOQgFWcq1RDQEgAUIBNwNgIAFB6ABqIgZBEGoiB0IANwMAIAYgCf0LAwBBsIg0IAFB4ABqQfCINBCkCSADQRBqIghBqIk0/QADAP0LAwAgA0GYiTT9AAMA/QsDACAAIAFBkAFqIgT9AAMA/QsDmAEgACABQYABaiIC/QADAP0LA4gBIAAgAUHwAGoiBf0AAwD9CwN4IAAgAf0AA2D9CwNoIA0gD0IAUiAOQgJWcq1RDQIgAUICNwNgIAdCADcDACAGIAn9CwMAQbCINCABQeAAakHwiDQQpAkgCEGoiTT9AAMA/QsDACADQZiJNP0AAwD9CwMAIAAgAv0AAwD9CwPIASAAIAX9AAMA/QsDuAEgACAB/QADYP0LA6gBIAAgBP0AAwD9CwPYASAFQYiKNP0AAwAiCf0LAwAgAUH4iTT9AAMAIgr9CwNgIARBqIk0/QADACIL/QsDACACQZiJNP0AAwD9CwMAIAAgCv0LA6gCIAAgC/0LA9gCIAAgCf0LA7gCIAAgAv0AAwD9CwPIAiAFQciKNP0AAwAiCf0LAwAgAUG4ijT9AAMAIgr9CwNgIARBqIk0/QADACIL/QsDACACQZiJNP0AAwAiDP0LAwAgACAL/QsDmAMgACAK/QsD6AIgACAJ/QsD+AIgACAM/QsDiAMgAUGgAWokACAADwsgAUGAxio2AhBB5ABB9IcqIAFBEGoQmwlBkJY0KAIAKAIAIQAgAUGAxio2AgAgAEGRjCogARBsAAsgAUGAxio2AjBB5ABB9IcqIAFBMGoQmwlBkJY0KAIAKAIAIQAgAUGAxio2AiAgAEGRjCogAUEgahBsAAsgAUGAxio2AlBB5ABB9IcqIAFB0ABqEJsJQZCWNCgCACgCACEAIAFBgMYqNgJAIABBkYwqIAFBQGsQbAALhtsBAkZ/An4jAEGQAmsiEiQAAkBBwOwFECoiDUUEQEFAIRkMAQsgDUEANgKE6wEgDUIANwL86gEgDUEANgLU6wEgDUIANwPA6wEgDUEANgKk6wEgDUEANgK46QEgDUEANgK87AUgDUKAgICAEDcDkOsBIA1CADcD6OsBIA1BgYCAwAA2AszrASAN/QwAAAAAAAAAAAAAAAAAAAAA/QsDsOsBIA1CADcC7OoBIA1CADcDqOsBIA1CADcDmOsBAkACQCACQQVJBEAgACEvDAELIA1BmOwBaiE4IA1BiOwFaiE3IA1BrNUBaiEoIA1BiOwBaiEwIA1BwOkBaiE5IA1BkOoBaiE+IA1BCGohOiANQZggaiE/IA1BBGohQCANQaAwaiFBIA1BrNABaiE7IA1BqNAAaiE0IA1BEGohQiANQazpAWohRSANQfDpAWohRiASQZQBaiE2QYCjw8cAITxBBSEDQQEhGSAAIS8DQCAZQX9zIQwDQAJAIAJBBEkgDHJBAXENACABKAAAQXBxQdDUtMIBRw0AIAJBCEkEQEG4fyEZDAULIAEoAAQiGUF3SwRAQXIhGQwFC0G4fyAZQQhqIhkgAiAZSRsiGUGIf0sNBCABIBlqIQEgAiAZayICIANPDQEMAwsLIA1BADYChOoBIA0gAzYCvOkBIEX9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIEb9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIA1BjICA4AA2AqhQIA1BADYCoOsBIA1CADcDiOoBIA1BATYClOsBIA1BAzYCgOoBIDtBCGoiQ0HokjIoAgA2AgAgO0HgkjIpAgA3AgAgDSA0NgIMIA0gPzYCCCANIEE2AgQgDSBCNgIAIDwEQCANIC82ArDpASANIC82ArTpASANIC82AqzpAQtBuH8hGUEFQQkgIBsgAksNAgJAIAFBAUEFICAbIgRqIh5BAWsiBi0AACIMQQNxQQJ0QfCSMmooAgAgBGogDEEEdkEMcUGAkzJqKAIAaiAMQSBxIgNFaiADQQV2IAxBwABJcWoiA0GIf0sEQCADIQwMAQsgA0EDaiACSw0DIAMgBEkEQCADRQ0EICBBAUYNBCASQajqvmk2AqABIANFIhlFBEAgEkGgAWogASAD/AoAAAsCQCASKAKgAUGo6r5pRwRAIBJB0NS0wgE2AqABIBlFBEAgEkGgAWogASAD/AoAAAsgEigCoAFBcHFB0NS0wgFHDQELQbh/IRkMBQtBdiEMDAELIDn9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIDn9DAAAAAAAAAAAAAAAAAAAAAD9CwMgIDn9DAAAAAAAAAAAAAAAAAAAAAD9CwMQAkACQAJAICBBAUYNACABKAAAIiBBqOq+aUYNAEF2IQwgIEFwcUHQ1LTCAUcNAyADQQhPDQEMBgsgBi0AACIMQQNxQQJ0QfCSMmooAgAgBGogDEEEdkEMcUGAkzJqKAIAaiAMQSBxIiBFaiAgQQV2IAxBwABJcWoiDCADTQRAIA0gDDYC2OkBIAYtAAAiGUEIcQRAQXIhGQwHC0IAIUkgGUEgcSIgRQRAIB4tAAAiDEGnAUsEQEFwIRkMCAsgDEEHca1CASAMQQN2QQpqrYYiSkIDiH4gSnwhSSAEQQFqIQQLIBlBBnYhBiAZQQJ2IR4CQAJAAkACQCAZQQNxIgxBAWsOAwABAgMLIAEgBGotAAAhDCAEQQFqIQQMAgsgASAEai8AACEMIARBAmohBAwBCyABIARqKAAAIQwgBEEEaiEECyAeQQFxIRkCfgJAAkACQAJAIAZBAWsOAwECAwALQn8gIEUNAxogASAEajEAAAwDCyABIARqMwAAQoACfAwCCyABIARqNQAADAELIAEgBGopAAALIUogDSAZNgLg6QEgDSAMNgLc6QEgDSBKNwPA6QEgDUEANgLU6QEgDSBKIEkgIBsiSjcDyOkBIA1CgIAIIEogSkKAgAhaGz4C0OkBDAILIAxBiX9PDQIMBQsgDUEBNgLU6QEgASgAACEZIA1BCDYC2OkBIA0gGUHQ1LTCAWsiDDYC3OkBIA0gATUABDcDwOkBCwJAAkAgDSgCsOsBQQFHDQAgDSgCrOsBIiBFDQAgDSgCnOsBRQ0AIBIgDDYCoAEgICgCBEEBayIeIBJBoAFqQQQQsguncSEZICAoAgAhBgNAIAYgGUECdGooAgAiIEUNASAMICAoAqjVASIERwRAIBkgHnFBAWohGSAEDQELCwJAIA0oApjrASIZRQ0AIBkoArjVASEEIBkoArTVASEMAkACQCAZKAIAIgYEQCAMRQ0BIAQgBiAMEQMAIAQgGSAMEQMADAMLIAxFDQEgBCAZIAwRAwAMAgsgBhArCyAZECsLIA1BADYCmOsBIA1BfzYCqOsBIA0gIDYCnOsBIA0gDSgC3OkBNgKg6wEMAQsgDEUNAEFgIRkMBAsCQCANKALg6QEEQCANIA0oAvDqASIZRTYC9OoBIBkNASA+QQBB2AD8CwAgDUL56tDQ58mh5OEANwOw6gEgDULP1tO+0ser2UI3A6DqASANQtbrgu7q/Yn14AA3A5jqAQwBCyANQQA2AvTqAQsgDSANKQPw6QEgA618NwPw6QEgDSgCuOsBIhkEQCANIA0oAtDpASIMIBkgDCAZSRs2AtDpAQsgLyA8aiE9IAIgA2shBCABIANqIQMgLyEeA0AgBEEDSQRAQbh/IRkMBQsgAy8AACJEIAMtAAJBEHRyQQN2IQxBbCEZIERBAXZBA3EiBiEgAkACQCAGQQFrDgMBAAYACyAMISALICAgBEEDayJHSwRAQbh/IRkMBQsgA0EDaiIuID0gLiA9SRsgPSAeIC5NGyEEAkACQAJAAkACQAJAAkAgBkEBaw4DAgALAQsgDSgClOsBIgYEfyANKALQ6QEFQYCACAsgIEkEQEG4fyEZDAsLICBBAkkNCiAuLQAAIgxBA3EhFiAGBH8gDSgC0OkBBUGAgAgLIQUgBCAeayEOAkACQAJAAkAgFkEBaw4DAwEAAgsgDSgCiOoBDQBBYiEZDA0LICBBBUkNDCAuKAAAIQYCfwJ/AkACQAJAIAxBAnZBA3EiDEECaw4CAQIACyAGQQ52Qf8HcSEHIAZBBHZB/wdxIQZBAyEPIAxBAEcMAwsgBkESdiEHQQQhDyAGQQR2Qf//AHEMAQsgAy0AB0EKdCAGQRZ2ciEHQQUhDyAGQQR2Qf//D3ELIQZBAQshCyAFIAZJDQwgBkEGSSALcQRAQWghGQwNCyAHIA9qIgwgIEsNDCAGIAUgDiAFIA5JGyIDSwRAQbp/IRkMDQsgDQJ/IAYiBSANKAKU6wEEfyANKALQ6QEFQYCACAsiCmpBQGsgDkkEQCANIAogHmpBIGoiCjYC/OsBIAUgCmohBUEBDAELIAVBgIAETQRAIA0gDUGI7AFqIgo2AvzrASAFIApqIQVBAAwBCyANIAMgHmoiCiAFazYC/OsBIAohBUECCzYChOwBIA0gBTYCgOwBAkAgDSgCpOsBRQ0AIAZBgQZJDQBBACEDA0AgA0HD/wBLDQEgA0GABGohAwwACwALIA8gLmohAyANKAL86wEhBQJ/IBZBA0YEQCANKAIMIQ8gC0UEQAJ/IAUhFEEAIRgCQAJAAn8gDygCACImQYD+A3EEQEG4fyAHRQ0EGgJAAkACQCAHQQRPBEBBfyADIAdqQQFrLQAAIhVFDQUaIAdBiH9NDQEgBwwICyADLQAAIRUCQAJAAkAgB0ECaw4CAQACCyADLQACQRB0IBVyIRULIAMtAAFBCHQgFWohFQsgAyAHakEBay0AACIKDQFBbAwHC0EIIBVnQR9zayERIAMgB0EEayIYaiIKKAAAIRUgBiAUaiEdICZBEHYhIiAPQQRqIQsgBkEDTQ0BIBEhBwwECyAGIBRqIR0gJkEQdiEiIA9BBGohCyAKZyAHQQN0a0EJaiEHIAZBBE8NAyADIQoMBAsCfyAHQQhOBEAgEUEHcSEHIAogEUEDdmsMAQsgGEUEQCARIQcMBQsgESAYIBFBA3YiByAKIAdrIANJGyIVQQN0ayEHIAogFWsLIgooAAAhFQwDCyAUIAYgAyAHIA8QzQwLDAILIA9BBGohJkEAICJrQR9xIREgBiAUakEDayEFA0ACfyAYQQROBEAgB0EDdiEKQQEhCSAHQQdxDAELIAMgGGohCiAYRQ0CIAcgB0EDdiIVIBggCiAVayADTyIJGyIKQQN0awshDyADIBggCmsiGGoiCigAACEVIAUgFE0EQCAPIQcMAgsgCUUEQCAPIQcMAgsgFCAmIBUgD3QgEXZBAnRqIgcvAQA7AAAgFCAHLQADaiIUICYgFSAPIActAAJqIgp0IBF2QQJ0aiIHLwEAOwAAIBQgBy0AA2ohFCAKIActAAJqIgdBIE0NAAtBkJUyIQoLIB0gFGtBAk8EQCAdQQJrISZBACAia0EfcSERQZCVMiEFAkAgB0EgSw0AIANBBGohCQNAAn8gCSAKTQRAIAdBA3YhFUEBIQ8gB0EHcQwBCyADIApGBEAgAyEFDAMLIAcgB0EDdiIVIAogA2sgCiAVayADTyIPGyIVQQN0awshGCAKIBVrIgooAAAhFSAUICZNQQAgDxtFBEAgGCEHIAohBQwCCyAUIAsgFSAYdCARdkECdGoiBy8BADsAACAUIActAANqIRQgGCAHLQACaiIHQSBNDQALCyAUICZNBEADQCAUIAsgFSAHdCARdkECdGoiCi8BADsAACAHIAotAAJqIQcgFCAKLQADaiIUICZNDQALCyAFIQoLAkAgFCAdTw0AIBQgCyAVIAd0QQAgImt2QQJ0aiIVLQAAOgAAIBUtAANBAUYEQCAHIBUtAAJqIQcMAQsgB0EfSw0AQSAgByAVLQACaiIUIBRBIE8bIQcLQWxBbCAGIAdBIEcbIAMgCkcbCwwCCwJ/IA8tAAEEQCAFIAYgAyAHIA8QzgwMAQsgBSAGIAMgByAPEM8MCwwBCyALRQRAAn8gNCADIAcgKBDLDCIKQYh/SwRAIAoMAQsgByAKSwR/IAUgBiADIApqIAcgCmsgNBDNDAVBuH8LCwwBCyAFIREgAyEJIAchHUEAIRpBACEFQQAhF0EAIRMjAEEQayIsJAACQCAGRQRAQbp/IQMMAQsgHUUEQEFsIQMMAQsgBkEIdiIDIAYgHUsEfyAdQQR0IAZuBUEPC0EEdCIKQZyTMmooAgBsIApBmJMyaigCAGoiJEEFdiAkaiAKQZCTMmooAgAgCkGUkzJqKAIAIANsakkEQCA0KAIAISEgKEHwBGoiCkEAQfAA/AsAQVQhAyAhQf8BcSIpQQxLDQEgKEHgB2oiECAKICxBCGogLEEMaiAJIB0gKEHgCWoQywsiC0GIf0sEQCALIQMMAgsgLCgCDCImIClLDQEgKEGoBWohAyAoQaQFaiEkICFBgICAeHEhMyAmIQcDQCAFIhVBAWohBSAaIiJBAWshGiAHIipBAWshByAKICpBAnRqKAIARQ0ACyAhQf8BcUEMRiExQQAhGgJAICpBAWoiJ0ECSQ0AICpBA3EhJUEBIQcgFSAma0F8TQRAICpBfHEhKwNAIAogB0ECdCIhaigCACEfIAMgIWogGjYCACAKICFBBGoiCGooAgAhGyADIAhqIBogH2oiGjYCACAKICFBCGoiH2ooAgAhCCADIB9qIBogG2oiGjYCACAKICFBDGoiIWooAgAhHyADICFqIAggGmoiGjYCACAaIB9qIRogB0EEaiEHIBNBBGoiEyArRw0ACwsgJUUNAANAIAogB0ECdCIhaigCACETIAMgIWogGjYCACAHQQFqIQcgEyAaaiEaIBdBAWoiFyAlRw0ACwtBCyApIDEbIR8gJkEMSSEIIAMgGjYCACADICdBAnRqIBo2AgACQCAsKAIIIiFFDQAgKEHgBWohB0EAIRogIUEBRwRAICFBAXEhGyAhQX5xIRMDQCADIBAgGmotAABBAnRqIiEgISgCACIhQQFqNgIAIAcgIWogGjoAACADIBAgGkEBciIhai0AAEECdGoiFyAXKAIAIhdBAWo2AgAgByAXaiAhOgAAIBpBAmoiGiATRw0ACyAbRQ0BCyADIBAgGmotAABBAnRqIiEgISgCACIhQQFqNgIAIAcgIWogGjoAAAsgHyApIAgbIRAgJkEBaiEtQQAhGiADQQA2AgACQCAnQQJJDQBBASEDICpBAXEhGyAFICZHBEAgECAmQX9zaiEFICpBfnEhCEEAIQcDQCAKIANBAnQiIWooAgAhFyAhIChqIBo2AgAgCiADQQFqIiFBAnQiE2ooAgAhHyATIChqIBcgAyAFanQgGmoiGjYCACAfIAUgIWp0IBpqIRogA0ECaiEDIAdBAmoiByAIRw0ACwsgG0UNACAoIANBAnRqIBo2AgALQQEhGCAtICprIg8gECAPa0EBakkEQCAqQXxxIRMgKkEDcSEXIBAgImohIiAnQQJJIR8gFSAma0F8SyEVIA8hAwNAAkAgHw0AICggA0E0bGohBUEAIQdBASEKIBVFBEADQCAFIApBAnQiGmogGiAoaigCACADdjYCACAFIBpBBGoiIWogISAoaigCACADdjYCACAFIBpBCGoiIWogISAoaigCACADdjYCACAFIBpBDGoiGmogGiAoaigCACADdjYCACAKQQRqIQogB0EEaiIHIBNHDQALC0EAIRogF0UNAANAIAUgCkECdCIHaiAHIChqKAIAIAN2NgIAIApBAWohCiAaQQFqIhogF0cNAAsLIANBAWoiAyAiRw0ACwsgKkEASgRAIDRBBGohMiAtIBBrITUgKEHgBWohAwNAICQgGCIUQQJ0IgVqKAIAIRUgJCAUQQFqIhhBAnRqKAIAISUCQCAPIBAgLSAUayIKayIaTQRAIBUgJUYNASAoIApBNGxqIhdBASAKIDVqIisgK0EBTBsiH0ECdGohHCAKIC1qIRMgCkEQdEGAgIAIaiExIAUgKGooAgAhIkEBIBp0IiZBAmshIwNAIDIgIkECdGohByADIBVqLQAAISECQCArQQJIDQAgISAxcq1CgYCAgBB+IUkCQAJAAkAgIw4DAgABAAsgHCgCACIKQQBMDQIgCkEBa0EDdkEBaiIIQQNxIRtBACEaQQAhBSAKQRlPBEAgCEH8////A3EhJ0EAIQgDQCAHIAVBAnRqIgogSTcBeCAKIEk3AXAgCiBJNwFoIAogSTcBYCAKIEk3AVggCiBJNwFQIAogSTcBSCAKIEk3AUAgCiBJNwE4IAogSTcBMCAKIEk3ASggCiBJNwEgIAogSTcBGCAKIEk3ARAgCiBJNwEIIAogSTcBACAFQSBqIQUgCEEEaiIIICdHDQALCyAbRQ0CA0AgByAFQQJ0aiIKIEk3ARggCiBJNwEQIAogSTcBCCAKIEk3AQAgBUEIaiEFIBpBAWoiGiAbRw0ACwwCCyAHIEk3AQgLIAcgSTcBAAsgHyIKICpMBEADQCAHIBcgCkECdCIFaigCAEECdGogAyAFICRqKAIAaiADICQgCkEBaiIFQQJ0aigCAGogEyAKayAQICFBAhDMDCAKICpHIRogBSEKIBoNAAsLICIgJmohIiAVQQFqIhUgJUcNAAsMAQsgMiAFIChqKAIAQQJ0aiADIBVqIAMgJWogCiAQQQBBARDMDAsgFCAqRw0ACwsgNCAQQRB0IDNyIClyQYACcjYCACALIB1PBEBBuH8hAwwCCyARIAYgCSALaiAdIAtrIDQQzgwhAwwBCyA0IAkgHSAoEMsMIgNBiH9LDQAgAyAdTwRAQbh/IQMMAQsgESAGIAMgCWogHSADayA0EM8MIQMLICxBEGokACADCyEDIA0oAoTsAUECRgRAIDAgDSgCgOwBQYCABGtBgIAE/AoAACAGQYCABGsiBQRAIA0oAvzrASILQeD/A2ogCyAF/AoAAAsgDSANKAL86wFB4P8DajYC/OsBIA0gDSgCgOwBQSBrNgKA7AELIANBiH9LDQwgDSAGNgKI6wEgDUEBNgKI6gEgDSANKAL86wE2AvjqASAWQQJGBEAgDSA0NgIMCyAMQYh/Sw0JIA0oApTrASEGDAYLIAUCfwJAAkACQCAMQQJ2QQNxQQFrDgMBAAIAC0EBIRYgDEEDdgwCC0ECIRYgLi8AAEEEdgwBCyAgQQJGDQxBAyEWIAMvAAMgAy0ABUEQdHJBBHYLIgNJDQsgAyAOSwRAQbp/IRkMDAsCfyAGBH8gDSgC0OkBBUGAgAgLIgwgA2pBQGsgDkkEQCANIAwgHmpBIGoiBTYC/OsBIAMgBWohDEEBIQtBAAwBCyADQYCABE0EQCANIDA2AvzrASADIDBqIQwgMCEFQQAhC0EADAELIA0gHiAFIA4gBSAOSRtqIANrQeD/A2oiBTYC/OsBIAMgBWpBgIAEayEMQQIhC0EBCyEHIA0gCzYChOwBIA0gDDYCgOwBICAgAyAWaiIMQSBqSQRAIAwgIEsNDCAWIC5qIRYCQCAHBEAgA0GAgARrIgsEQCAFIBYgC/wKAAALIDAgCyAWakGAgAT8CgAADAELIANFDQAgBSAWIAP8CgAACyANIAM2AojrASANIAU2AvjqAQwGCyANQQA2AoTsASANIAM2AojrASANIBYgLmoiBTYC+OoBIA0gAyAFajYCgOwBDAULIAUCfwJAAkACQCAMQQJ2QQNxQQFrDgMBAAIAC0EBIRYgDEEDdgwCCyAgQQJGDQxBAiEWIC4vAABBBHYMAQsgIEEESQ0LQQMhFiADLwADIAMtAAVBEHRyQQR2CyIMSQ0KIAwgDksEQEG6fyEZDAsLIAwgBgR/IA0oAtDpAQVBgIAICyIDakFAayAOSQRAIAMgHmpBIGohA0EBIQsMAwtBACELIDAhAyAMQYGABEkNAiANQQI2AoTsASANIB4gBSAOIAUgDkkbaiAMa0Hg/wNqIgM2AvzrASANIAxBgIAEayIFIANqNgKA7AEgFiAuaiELIAUEQCADIAstAAAgBfwLAAsgMCALLQAAQYCABPwLAAwDCyA9IB5rICBJBEBBun8hGQwKCyAgIgxFDQQgHiAuIAz8CgAADAQLIAQgHmsgDEkEQEG6fyEZDAkLIAxFDQMgHiAuLQAAIAz8CwAMAwsgDSALNgKE7AEgDSADNgL86wEgDSADIAxqNgKA7AEgDEUNACADIBYgLmotAAAgDPwLAAsgDSAMNgKI6wEgDSADNgL46gEgFkEBaiEMCyAGBH8gDSgC0OkBBUGAgAgLIQYgDCAgRgRAQbh/IRkMBgsgICAMayEjIA0oArTpASEWICAgLmohCSANKAKk6wEhGAJ/AkACQAJ/IAwgLmoiAy0AACIPwCIMQQBOBEAgA0EBagwBCyAMQX9GBEAgI0EDTw0CQbh/IRkMCgsgI0EBRgRAQbh/IRkMCgsgAy0AASAPQQh0ckGAgAJrIQ8gA0ECagshBSAPDQFBACEPICMgBSAJRg0CGgwICyADQQNqIQUgAy8AAUGA/gFqIQ8LIAkgBUEBaiIMSQRAQbh/IRkMBwsgBS0AACIFQQNxDQYgQiANIAVBBnZBI0EJIAwgCSAMa0GglTJBkJAyQbCWMiANKAKM6gEgDSgCpOsBIA8gKBDIDCILQYh/Sw0GID8gOiAFQQR2QQNxQR9BCCALIAxqIgwgCSAMa0HAmjJBwJsyQeCbMiANKAKM6gEgDSgCpOsBIA8gKBDIDCILQYh/Sw0GIEEgQCAFQQJ2QQNxQTRBCSALIAxqIgwgCSAMa0HwnTJBgJEyQdCfMiANKAKM6gEgDSgCpOsBIA8gKBDIDCIFQYh/Sw0GIAUgDGogA2sLIgxBiH9LDQICQCAEIB5HDQAgD0EATA0AQbp/IRkMBgsgIyAMayEKIAMgDGohCwJAAkACQAJAAkACQAJAIB4gDiAGIAYgDksbIgNBACADQQBKG2ogFmsiA0H8//8fTQRAQQAhJiAYDQIgA0GBgIAISQ0CIA9BCUgNAiA6KAIAIgNBCmohBSADKAIEIQZBACEDQQAhBANAIAQgBSADQQN0ai0AAEEWS2ohBCADQQFqIgMgBnZFDQALIARBCCAGa3QhAwwBCwJ/IA9FBEBBACEmQQAMAQsgOigCACIDQQpqIQcgAygCBCEWQQAhA0EAIQRBACEFA0AgAyAHIARBA3RqLQAAIgYgAyAGSxshAyAFIAZBFktqIQUgBEEBaiIEIBZ2RQ0ACyADQRlLISYgBUEIIBZrdAshAyAYRQ0AIA1BADYCpOsBIA0oAoTsASEDDAILIANBE0shGAsgDUEANgKk6wEgDSgChOwBIQMgGA0AIANBAkcNASAKIREjAEGAAWsiCCQAIAggDSgC+OoBIgk2AmwgHiAOIgNBACADQQBKG2ohJSANKAKA7AEhDAJAAkAgDyIiRQRAIB4hBwwBCyANKAK46QEhJyANKAK06QEhKyANKAKw6QEhCiANQQE2AozqASAIIA1BtNABaigCADYCaCAIIA1BrNABaiIcKQIANwJgIBFFBEBBbCEUDAILIAggCzYCQCAIIAtBBGoiGzYCRAJAAkAgEUEETwRAIAggCyARQQRrIgNqIgk2AjwgCCAJKAAAIhM2AjQgE0GAgIAITw0BQWwhFAwECyAIIAs2AjwgCCALLQAAIhM2AjQCQAJAAkAgEUECaw4CAQACCyALLQACQRB0IBNyIRMLIAggCy0AAUEIdCATaiITNgI0CyALIBFqQQFrLQAAIgNFBEBBbCEUDAQLIANnIBFBA3RrQQlqIRFBACEDIAshCQwBCyARQYh/SwRAQWwhFAwDC0EIIBNBGHZnQR9zayERCyAIIBNBACANKAIAIgQoAgQiDyARaiIRa3YgD0ECdEHgozJqKAIAcSIsNgJIAn8gEUEhTwRAQeCkMiEJIAhB4KQyNgI8QeCkMgwBCyADIAtqIQ8gA0EETgRAIAggEUEHcSIHNgI4IAggDyARQQN2ayIJNgI8IAggCSgAACITNgI0IAchESAJDAELIAsgA0UNABogCCAPIAMgEUEDdiIJIA8gCWsgC0kbIgNrIgk2AjwgCCARIANBA3RrIhE2AjggCCAJKAAAIhM2AjQgCQshAyAIIARBCGoiIzYCTCAIIBNBACANKAIIIg8oAgQiBCARaiIRa3YgBEECdEHgozJqKAIAcSIxNgJQAkAgEUEhTwRAQeCkMiEJIAhB4KQyNgI8QeCkMiEDDAELAn8gAyAbTwRAIAggAyARQQN2ayIJNgI8IAggCSgAACITNgI0IBFBB3EMAQsgAyALRg0BIAggAyADIAtrIBFBA3YiCSADIAlrIAtJGyIEayIJNgI8IAggCSgAACITNgI0IBEgBEEDdGsLIREgCSEDCyAIIA9BCGoiGjYCVCAIIA0oAgQiDygCBCIHIBFqIgQ2AjggCCAHQQJ0QeCjMmooAgAgE0EAIARrdnEiMjYCWAJAIARBIU8EQEHgpDIhCSAIQeCkMjYCPAwBCyADIBtPBEAgCCAEQQdxIhE2AjggCCADIARBA3ZrIgk2AjwgCCAJKAAAIhM2AjQgESEEDAELIAMgC0YNACAIIAMgAyALayAEQQN2IhEgAyARayALSRsiEWsiCTYCPCAIIAQgEUEDdGsiBDYCOCAIIAkoAAAiEzYCNAsgCEHgAGohKSAIIA9BCGoiKjYCXCAeIQcDQCAjICxBA3RqIgMtAAIhFCAqIDJBA3RqIhEtAAIhFSAaIDFBA3RqIg8tAAMhDiARLQADISQgAy0AAyEdIA8vAQAhGCARLwEAIS0gAy8BACE1IA8oAgQhBSADKAIEIQMgESgCBCERAn8CQCAPLQACIg9BAk8EQCAEIA9qIQYgEyAEdCEEAkACQCAmRQ0AIA9BGUkNACAEQQUgD2t2QQV0IAVqIQQCQCAGQQVrIg9BIU8EQEHgpDIhCSAIQeCkMjYCPAwBCyAJIBtPBEAgCCAPQQdxIgU2AjggCCAJIA9BA3ZrIgk2AjwgCCAJKAAAIhM2AjQgBSEPDAELIAkgC0YNACAIIAkgCSALayAPQQN2IhMgCSATayALSRsiE2siCTYCPCAIIA8gE0EDdGsiDzYCOCAIIAkoAAAiEzYCNAsgCCAPQQVqIgY2AjggBCATIA90QRt2aiEPDAELIARBACAPa3YgBWohDyAIIAY2AjggBkEhTwRAQeCkMiEJIAhB4KQyNgI8DAELIAkgG08EQCAIIAZBB3EiBDYCOCAIIAkgBkEDdmsiCTYCPCAIIAkoAAAiEzYCNCAEIQYMAQsgCSALRg0AIAggCSAJIAtrIAZBA3YiBCAJIARrIAtJGyIEayIJNgI8IAggBiAEQQN0ayIGNgI4IAggCSgAACITNgI0CyAIIAgoAmQ2AmgMAQsgA0UhMyAPRQRAICkgM0ECdGooAgAhDyAEIQYgKSADQQBHQQJ0aigCAAwCCyAIIARBAWoiBjYCOAJAIAUgEyAEdEEfdmogM2oiBEEDRgRAIAgoAmBBAWsiD0F/IA8bIQ8MAQsgKSAEQQJ0aigCACIPQX8gDxshDyAEQQFGDQELIAggCCgCZDYCaAsgCCgCYAshBSAUIBVqIQQgCCAPNgJgIAggBTYCZAJAIBVFBEAgBiEFDAELIAggBiAVaiIFNgI4IBMgBnRBACAVa3YgEWohEQsCQCAEQRRJDQAgBUEhTwRAQeCkMiEJIAhB4KQyNgI8DAELIAkgG08EQCAIIAVBB3EiBDYCOCAIIAkgBUEDdmsiCTYCPCAIIAkoAAAiEzYCNCAEIQUMAQsgCSALRg0AIAggCSAJIAtrIAVBA3YiBCAJIARrIAtJGyIEayIJNgI8IAggBSAEQQN0ayIFNgI4IAggCSgAACITNgI0CwJAIBRFBEAgBSEEDAELIAggBSAUaiIENgI4IBMgBXRBACAUa3YgA2ohAwsCQCAEQSFPBEBB4KQyIQkgCEHgpDI2AjwMAQsgCSAbTwRAIAggBEEHcSIFNgI4IAggCSAEQQN2ayIJNgI8IAggCSgAACITNgI0IAUhBAwBCyAJIAtGDQAgCCAJIAkgC2sgBEEDdiITIAkgE2sgC0kbIhNrIgk2AjwgCCAEIBNBA3RrIgQ2AjggCCAJKAAAIhM2AjQLAkACQAJAAkAgIkEBRwRAIAggHUECdEHgozJqKAIAIBNBACAEIB1qIgRrdnEgNWoiLDYCSCAIICRBAnRB4KMyaigCACATQQAgBCAkaiIEa3ZxIC1qIjI2AlgCQCAEQSFPBEBB4KQyIQkgCEHgpDI2AjwMAQsgCSAbTwRAIAggBEEHcSIFNgI4IAggCSAEQQN2ayIJNgI8IAggCSgAACITNgI0IAUhBAwBCyAJIAtGDQAgCCAJIAkgC2sgBEEDdiITIAkgE2sgC0kbIhNrIgk2AjwgCCAEIBNBA3RrIgQ2AjggCCAJKAAAIhM2AjQLIAggBCAOaiIENgI4IAggDkECdEHgozJqKAIAIBNBACAEa3ZxIBhqIjE2AlACQCAEQSFPBEBB4KQyIQkgCEHgpDI2AjwMAQsgCSAbTwRAIAggBEEHcSIFNgI4IAggCSAEQQN2ayIJNgI8IAggCSgAACITNgI0IAUhBAwBCyAJIAtGDQAgCCAJIAkgC2sgBEEDdiITIAkgE2sgC0kbIhNrIgk2AjwgCCAEIBNBA3RrIgQ2AjggCCAJKAAAIhM2AjQLIAgoAmwiBiADaiIVIA0oAoDsASIFSw0BDAMLIAgoAmwiBiADaiIVIA0oAoDsASIFTQ0CQQEhIgwBCyAiQQBKDQBBbCEUDAULAkAgBSAGRgRAIAchFQwBC0G6fyEUIAUgBmsiJCAlIAdrSw0FIAcgJGohFQJAIAcgBmsiFEF4TCAkQQdKcUUEQCAkQQBMDQEDQCAHIAYtAAA6AAAgBkEBaiEGIAdBAWoiByAVSQ0ACwwBCwJ/IBRBb0sEQCAGIRQgByEMIAcMAQsgBiEUIAchDCAHIAcgFUEgayIdSw0AGiAHIAb9AAAA/QsAACAdIAdrIgxBEU4EQCAHQRBqIRQgBiEOA0AgFCAO/QAAEP0LAAAgFCAO/QAAIP0LABAgDkEgaiEOIBRBIGoiFCAdSQ0ACwsgBiAMaiEUIB0iDAshGCAFIAdqIR0CQCAHICRqIAxrIi1BB3EiDkUEQCAYIQcMAQtBACEFIBghBwNAIAcgFC0AADoAACAHQQFqIQcgFEEBaiEUIAVBAWoiBSAORw0ACwsgDCAdayAGakF4Sw0AIBggLWohBQNAIAcgFC0AADoAACAHIBQtAAE6AAEgByAULQACOgACIAcgFC0AAzoAAyAHIBQtAAQ6AAQgByAULQAFOgAFIAcgFC0ABjoABiAHIBQtAAc6AAcgFEEIaiEUIAdBCGoiByAFRw0ACwsgAyAkayEDCyAIIA1BiOwBaiIFNgJsIA1BADYChOwBIA1BiOwFaiEMIAggAzYCcCAIIBE2AnQgCCAPNgJ4AkACQAJAIANBgIAESg0AIBUgAyARaiIUaiAlQSBrSw0AIBRBIGogJSAVa00NAQsgCCAIKAJ4NgIgIAggCCkDcDcDGCAVICUgCEEYaiAIQewAaiAMIAogKyAnEMkMIRQMAQsgAyAFaiEGIAMgFWohByAVIAX9AAAA/QsAAAJAIANBEUkNACAVIA39AACY7AH9CwAQIANBEGtBEUgNACANQZjsAWohAyAVQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAdJDQALCyAHIA9rIQMgCCAGNgJsIAcgCmsgD0kEQCAHICtrIA9JBEBBbCEUDAcLICcgJyADIAprIgNqIgUgEWpPBEAgEUUNAiAHIAUgEfwKAAAMAgtBACADayIGBEAgByAFIAb8CgAACyAIIAMgEWoiETYCdCAHIANrIQcgCiEDCyAPQRBPBEAgByAD/QAAAP0LAAAgEUERSA0BIAcgEWohDyAHQRBqIREDQCARIAP9AAAQ/QsAACARIAP9AAAg/QsAECADQSBqIQMgEUEgaiIRIA9JDQALDAELAkAgD0EHTQRAIAcgAy0AADoAACAHIAMtAAE6AAEgByADLQACOgACIAcgAy0AAzoAAyAHIAMgD0ECdCIPQfCkMmooAgBqIgMoAAA2AAQgAyAPQZClMmooAgBrIQMMAQsgByADKQAANwAACyARQQlJDQAgByARaiEFIAdBCGoiDyADQQhqIgNrQQ9MBEADQCAPIAMpAAA3AAAgA0EIaiEDIA9BCGoiDyAFSQ0ACwwBCyAPIAP9AAAA/QsAACARQRlIDQAgB0EYaiERA0AgESAD/QAAEP0LAAAgESAD/QAAIP0LABAgA0EgaiEDIBFBIGoiESAFSQ0ACwsgFEGIf0sNBCAUIBVqIQcgIkEBayIiRQ0BICVBIGshMwNAICMgLEEDdGoiAy0AAiEUICogMkEDdGoiES0AAiEVIBogMUEDdGoiDy0AAyEOIBEtAAMhJCADLQADIR0gDy8BACEYIBEvAQAhLSADLwEAITUgDygCBCEFIAMoAgQhAyARKAIEIRECfwJAIA8tAAIiD0ECTwRAIAQgD2ohBiATIAR0IQQCQAJAICZFDQAgD0EZSQ0AIARBBSAPa3ZBBXQgBWohBAJAIAZBBWsiD0EhTwRAQeCkMiEJIAhB4KQyNgI8DAELIAkgG08EQCAIIA9BB3EiBTYCOCAIIAkgD0EDdmsiCTYCPCAIIAkoAAAiEzYCNCAFIQ8MAQsgCSALRg0AIAggCSAJIAtrIA9BA3YiEyAJIBNrIAtJGyITayIJNgI8IAggDyATQQN0ayIPNgI4IAggCSgAACITNgI0CyAIIA9BBWoiBjYCOCAEIBMgD3RBG3ZqIQ8MAQsgBEEAIA9rdiAFaiEPIAggBjYCOCAGQSFPBEBB4KQyIQkgCEHgpDI2AjwMAQsgCSAbTwRAIAggBkEHcSIENgI4IAggCSAGQQN2ayIJNgI8IAggCSgAACITNgI0IAQhBgwBCyAJIAtGDQAgCCAJIAkgC2sgBkEDdiIEIAkgBGsgC0kbIgRrIgk2AjwgCCAGIARBA3RrIgY2AjggCCAJKAAAIhM2AjQLIAggCCgCZDYCaAwBCyADRSEfIA9FBEAgKSAfQQJ0aigCACEPIAQhBiApIANBAEdBAnRqKAIADAILIAggBEEBaiIGNgI4AkAgBSATIAR0QR92aiAfaiIEQQNGBEAgCCgCYEEBayIPQX8gDxshDwwBCyApIARBAnRqKAIAIg9BfyAPGyEPIARBAUYNAQsgCCAIKAJkNgJoCyAIKAJgCyEFIBQgFWohBCAIIA82AmAgCCAFNgJkAkAgFUUEQCAGIQUMAQsgCCAGIBVqIgU2AjggEyAGdEEAIBVrdiARaiERCwJAIARBFEkNACAFQSFPBEBB4KQyIQkgCEHgpDI2AjwMAQsgCSAbTwRAIAggBUEHcSIENgI4IAggCSAFQQN2ayIJNgI8IAggCSgAACITNgI0IAQhBQwBCyAJIAtGDQAgCCAJIAkgC2sgBUEDdiIEIAkgBGsgC0kbIgRrIgk2AjwgCCAFIARBA3RrIgU2AjggCCAJKAAAIhM2AjQLAkAgFEUEQCAFIQQMAQsgCCAFIBRqIgQ2AjggEyAFdEEAIBRrdiADaiEDCwJAIARBIU8EQEHgpDIhCSAIQeCkMjYCPAwBCyAJIBtPBEAgCCAEQQdxIgU2AjggCCAJIARBA3ZrIgk2AjwgCCAJKAAAIhM2AjQgBSEEDAELIAkgC0YNACAIIAkgCSALayAEQQN2IhMgCSATayALSRsiE2siCTYCPCAIIAQgE0EDdGsiBDYCOCAIIAkoAAAiEzYCNAsCQCAiQQFGDQAgCCAdQQJ0QeCjMmooAgAgE0EAIAQgHWoiBGt2cSA1aiIsNgJIIAggJEECdEHgozJqKAIAIBNBACAEICRqIgRrdnEgLWoiMjYCWAJAIARBIU8EQEHgpDIhCSAIQeCkMjYCPAwBCyAJIBtPBEAgCCAEQQdxIgU2AjggCCAJIARBA3ZrIgk2AjwgCCAJKAAAIhM2AjQgBSEEDAELIAkgC0YNACAIIAkgCSALayAEQQN2IhMgCSATayALSRsiE2siCTYCPCAIIAQgE0EDdGsiBDYCOCAIIAkoAAAiEzYCNAsgCCAEIA5qIgQ2AjggCCAOQQJ0QeCjMmooAgAgE0EAIARrdnEgGGoiMTYCUCAEQSFPBEBB4KQyIQkgCEHgpDI2AjwMAQsgCSAbTwRAIAggBEEHcSIFNgI4IAggCSAEQQN2ayIJNgI8IAggCSgAACITNgI0IAUhBAwBCyAJIAtGDQAgCCAJIAkgC2sgBEEDdiITIAkgE2sgC0kbIhNrIgk2AjwgCCAEIBNBA3RrIgQ2AjggCCAJKAAAIhM2AjQLIAggAzYCcCAIIBE2AnQgCCAPNgJ4AkACQAJAIAgoAmwiFSADaiIGIAxLDQAgByADIBFqIhRqIDNLDQAgFEEgaiAlIAdrTQ0BCyAIIAgoAng2AhAgCCAIKQNwNwMIIAcgJSAIQQhqIAhB7ABqIAwgCiArICcQyQwhFAwBCyADIAdqIQUgByAV/QAAAP0LAAACQCADQRFJDQAgByAV/QAAEP0LABAgA0EQa0ERSA0AIBVBEGohAyAHQSBqIRUDQCAVIAP9AAAQ/QsAACAVIAP9AAAg/QsAECADQSBqIQMgFUEgaiIVIAVJDQALCyAFIA9rIQMgCCAGNgJsIAUgCmsgD0kEQCAFICtrIA9JBEBBbCEUDAgLICcgJyADIAprIgNqIhUgEWpPBEAgEUUNAiAFIBUgEfwKAAAMAgtBACADayIGBEAgBSAVIAb8CgAACyAIIAMgEWoiETYCdCAFIANrIQUgCiEDCyAPQRBPBEAgBSAD/QAAAP0LAAAgEUERSA0BIAUgEWohDyAFQRBqIREDQCARIAP9AAAQ/QsAACARIAP9AAAg/QsAECADQSBqIQMgEUEgaiIRIA9JDQALDAELAkAgD0EHTQRAIAUgAy0AADoAACAFIAMtAAE6AAEgBSADLQACOgACIAUgAy0AAzoAAyAFIAMgD0ECdCIPQfCkMmooAgBqIgMoAAA2AAQgAyAPQZClMmooAgBrIQMMAQsgBSADKQAANwAACyARQQlJDQAgBSARaiEVIAVBCGoiDyADQQhqIgNrQQ9MBEADQCAPIAMpAAA3AAAgA0EIaiEDIA9BCGoiDyAVSQ0ACwwBCyAPIAP9AAAA/QsAACARQRlIDQAgBUEYaiERA0AgESAD/QAAEP0LAAAgESAD/QAAIP0LABAgA0EgaiEDIBFBIGoiESAVSQ0ACwsgFEGIf0sNBSAHIBRqIQcgIkEBayIiDQALDAELIBVBIGshBSAIIAM2AnAgCCARNgJ0IAggDzYCeAJAAkACQCAMIBVJDQAgByADIBFqIhRqIAVLDQAgFEEgaiAlIAdrTQ0BCyAIIAgoAng2AjAgCCAIKQNwNwMoIAcgJSAFIAhBKGogCEHsAGogDCAKICsgJxDKDCEUDAELIAMgB2ohBSAHIAb9AAAA/QsAAAJAIANBEUkNACAHIAb9AAAQ/QsAECADQRBrQRFIDQAgBkEQaiEDIAdBIGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgBUkNAAsLIAUgD2shAyAIIBU2AmwgBSAKayAPSQRAIAUgK2sgD0kEQEFsIRQMBgsgJyAnIAMgCmsiA2oiFSARak8EQCARRQ0CIAUgFSAR/AoAAAwCC0EAIANrIgYEQCAFIBUgBvwKAAALIAggAyARaiIRNgJ0IAUgA2shBSAKIQMLIA9BEE8EQCAFIAP9AAAA/QsAACARQRFIDQEgBSARaiEPIAVBEGohEQNAIBEgA/0AABD9CwAAIBEgA/0AACD9CwAQIANBIGohAyARQSBqIhEgD0kNAAsMAQsCQCAPQQdNBEAgBSADLQAAOgAAIAUgAy0AAToAASAFIAMtAAI6AAIgBSADLQADOgADIAUgAyAPQQJ0Ig9B8KQyaigCAGoiAygAADYABCADIA9BkKUyaigCAGshAwwBCyAFIAMpAAA3AAALIBFBCUkNACAFIBFqIRUgBUEIaiIPIANBCGoiA2tBD0wEQANAIA8gAykAADcAACADQQhqIQMgD0EIaiIPIBVJDQALDAELIA8gA/0AAAD9CwAAIBFBGUgNACAFQRhqIREDQCARIAP9AAAQ/QsAACARIAP9AAAg/QsAECADQSBqIQMgEUEgaiIRIBVJDQALCyAUQYh/Sw0DIAcgFGohByAiQQFrIiINAQsLIAkgC0cEQEFsIRQMAgtBbCEUIARBIEcNASAcICkpAgA3AgAgHCApKAIINgIIIAgoAmwhCQsgDSgChOwBQQJGBEAgDCAJayIDICUgB2tLBEBBun8hFAwCCyADBEAgByAJIAP8CgAACyANQQA2AoTsASANQYjsBWohDCANQYjsAWohCSADIAdqIQcLIAwgCWsiAyAlIAdrSwRAQbp/IRQMAQsgAwRAIAcgCSAD/AoAAAsgAyAHaiAeayEUCyAIQYABaiQAIBQhDAwECwJ/IANBAUYEQCANKAL86wEMAQsgHiAOQQAgDkEAShtqCyEIIBIgDSgC+OoBIgQ2AowCIA0oAoDsASEdIA9FBEAgHiEHDAMLIA0oArjpASETIA0oArTpASEbIA0oArDpASERIA1BATYCjOoBIDZBCGoiNSBDKAIANgIAIDYgOykCADcCACAMICNGIQNBbCEMIAMNAyASIAs2AnQgEiALQQRqIg42AngCQCAKQQRPBEAgCyAKQQRrIgNqKAAAIhZBgICACEkNBSAKQYh/Sw0FQQggFkEYdmdBH3NrIQQMAQsgCy0AACEWAkACQAJAIApBAmsOAgEAAgsgCy0AAkEQdCAWciEWCyASIAstAAFBCHQgFmoiFjYCaAsgCUEBay0AACIDRQ0EIANnIApBA3RrQQlqIQRBACEDCyASIBZBACANKAIAIgUoAgQiBiAEaiIEa3YgBkECdEHgozJqKAIAcSIkNgJ8AkAgBEEgSwRAQeCkMiEDDAELIAMgC2ohBgJ/IANBBE4EQCASIAYgBEEDdmsiAzYCcCAEQQdxDAELIANFBEAgCyEDDAILIBIgBiADIARBA3YiFiAGIBZrIAtJGyIWayIDNgJwIAQgFkEDdGsLIQQgAygAACEWCyASIAVBCGoiMTYCgAEgEiAWQQAgOigCACIGKAIEIgUgBGoiBGt2IAVBAnRB4KMyaigCAHEiJTYChAECQCAEQSBLBEBB4KQyIQMMAQsgAyAOTwRAIBIgAyAEQQN2ayIDKAAAIhY2AmggBEEHcSEEDAELIAMgC0YNACAEIAMgC2sgBEEDdiIFIAMgBWsgC0kbIgVBA3RrIQQgAyAFayIDKAAAIRYLIA9BCEghBSASIAZBCGoiMjYCiAEgEiBAKAIAIgYoAgQiByAEaiIENgJsIBZBACAEa3YhCSAHQQJ0QeCjMmooAgAhBwJAIARBIEsEQEHgpDIhAwwBCyADIA5PBEAgEiAEQQdxIiM2AmwgAyAEQQN2ayIDKAAAIRYgIyEEDAELIAMgC0YNACASIAQgAyALayAEQQN2IhYgAyAWayALSRsiFkEDdGsiBDYCbCADIBZrIgMoAAAhFgsgD0EIIAUbISogHiARayEnIAcgCXEhKSASIAZBCGoiMzYCkAEgD0EATARAQQAhGAwCCyAPQQFrIS1BACEKIBIoApgBIR8gEigClAEhFANAIBQhFSAxICRBA3RqIgYtAAIhByAzIClBA3RqIgUtAAIhCSAyICVBA3RqIhgtAAMhECAFLQADIRcgBi0AAyEcIBgvAQAhIiAFLwEAIRogBi8BACEsIBgoAgQhFCAGKAIEIQYgBSgCBCEjAkACQCAYLQACIgVBAk8EQCAEIAVqIRggFiAEdCEEAkAgJkUNACAFQRlJDQAgBEEFIAVrdkEFdCAUaiEFAkAgGEEFayIEQSBLBEBB4KQyIQMMAQsgAyAOTwRAIBIgBEEHcSIYNgJsIAMgBEEDdmsiAygAACEWIBghBAwBCyADIAtGDQAgEiAEIAMgC2sgBEEDdiIWIAMgFmsgC0kbIhZBA3RrIgQ2AmwgAyAWayIDKAAAIRYLIBIgBEEFaiIYNgJsIAUgFiAEdEEbdmohFAwCCyAEQQAgBWt2IBRqIRQgEiAYNgJsIBhBIEsEQEHgpDIhAwwCCyADIA5PBEAgEiAYQQdxIgQ2AmwgAyAYQQN2ayIDKAAAIRYgBCEYDAILIAMgC0YNASASIBggAyALayAYQQN2IgQgAyAEayALSRsiBEEDdGsiGDYCbCADIARrIgMoAAAhFgwBCyAGRSErIAVFBEAgNiArQQJ0aigCACEUIDYgBkEAR0ECdGooAgAhFSAEIRgMAgsgEiAEQQFqIhg2AmwgFCAWIAR0QR92aiAraiIEQQNGBEAgFUEBayIEQX8gBBshFAwBCyA2IARBAnRqKAIAIgVBfyAFGyEUIARBAUYNAQsgEiAfNgKcAQsgByAJaiEEIBIgFDYClAEgEiAVIh82ApgBAkAgCUUEQCAYIQUMAQsgEiAJIBhqIgU2AmwgFiAYdEEAIAlrdiAjaiEjCwJAIARBFEkNACAFQSBLBEBB4KQyIQMMAQsgAyAOTwRAIBIgBUEHcSIENgJsIAMgBUEDdmsiAygAACEWIAQhBQwBCyADIAtGDQAgEiAFIAMgC2sgBUEDdiIEIAMgBGsgC0kbIgRBA3RrIgU2AmwgAyAEayIDKAAAIRYLAkAgB0UEQCAFIQQMAQsgEiAFIAdqIgQ2AmwgFiAFdEEAIAdrdiAGaiEGCwJAIARBIEsEQEHgpDIhAwwBCyADIA5PBEAgEiAEQQdxIgU2AmwgAyAEQQN2ayIDKAAAIRYgBSEEDAELIAMgC0YNACASIAQgAyALayAEQQN2IgUgAyAFayALSRsiBUEDdGsiBDYCbCADIAVrIgMoAAAhFgsCQCAKIC1GDQAgHEECdEHgozJqKAIAIBZBACAEIBxqIgRrdnEhBSAXQQJ0QeCjMmooAgAgFkEAIAQgF2oiBGt2cSEHAkAgBEEgSwRAQeCkMiEDIAQhCQwBCwJ/IAMgDk8EQCASIARBB3EiCTYCbCADIARBA3ZrDAELIAMgC0YEQCAEIQkMAgsgEiAEIAMgC2sgBEEDdiIWIAMgFmsgC0kbIhZBA3RrIgk2AmwgAyAWawsiAygAACEWCyAFICxqISQgByAaaiEpIBIgCSAQaiIFNgJsIBBBAnRB4KMyaigCACAWQQAgBWt2cSAiaiElIAVBIEsEQEHgpDIhAyAFIQQMAQsCfyADIA5PBEAgEiAFQQdxIgQ2AmwgAyAFQQN2awwBCyADIAtGBEAgBSEEDAILIBIgBSADIAtrIAVBA3YiBCADIARrIAtJGyIWQQN0ayIENgJsIAMgFmsLIgMoAAAhFgsgEkGgAWogCkEMbGoiBSAUNgIIIAUgIzYCBCAFIAY2AgAgBiAnaiAjaiEnIApBAWoiCiAqRw0ACyAqIRgMAQtBACEEIwBB4ABrIhAkACANIgwoAoTsAQR/IA0oAvzrAQUgHiAOQQAgDkEAShtqCyElIBAgDCgC+OoBIg42AkwgDiAMKAKI6wFqIScCQAJAIA9FBEAgHiEDDAELIAwoArjpASEpIAwoArTpASErIAwoArDpASEYIAxBATYCjOoBIBAgDEG00AFqKAIANgJIIBAgDEGs0AFqIi0pAgA3AkBBbCERIApFDQEgECALNgIgIBAgC0EEaiIbNgIkAkAgCkEETwRAIBAgCyAKQQRrIgRqIg42AhwgECAOKAAAIgg2AhQgCEGAgIAISQ0DIApBiH9LDQNBCCAIQRh2Z0Efc2shCgwBCyAQIAs2AhwgECALLQAAIgg2AhQCQAJAAkAgCkECaw4CAQACCyALLQACQRB0IAhyIQgLIBAgCy0AAUEIdCAIaiIINgIUCyAKIAtqQQFrLQAAIg5FDQIgDmcgCkEDdGtBCWohCiALIQ4LIBAgCEEAIAwoAgAiAygCBCIFIApqIgdrdiAFQQJ0QeCjMmooAgBxIiw2AigCfyAHQSFPBEBB4KQyIQ4gEEHgpDI2AhxB4KQyDAELIAQgC2ohCiAEQQROBEAgECAHQQdxIgQ2AhggECAKIAdBA3ZrIg42AhwgECAOKAAAIgg2AhQgBCEHIA4MAQsgCyAERQ0AGiAQIAogBCAHQQN2Ig4gCiAOayALSRsiBGsiDjYCHCAQIAcgBEEDdGsiBzYCGCAQIA4oAAAiCDYCFCAOCyEKIBAgA0EIaiIaNgIsIBAgCEEAIAwoAggiBCgCBCIDIAdqIgdrdiADQQJ0QeCjMmooAgBxIjE2AjACQCAHQSFPBEBB4KQyIQ4gEEHgpDI2AhxB4KQyIQoMAQsCfyAKIBtPBEAgECAKIAdBA3ZrIg42AhwgECAOKAAAIgg2AhQgB0EHcQwBCyAKIAtGDQEgECAKIAogC2sgB0EDdiIOIAogDmsgC0kbIgNrIg42AhwgECAOKAAAIgg2AhQgByADQQN0awshByAOIQoLIBAgBEEIaiIqNgI0IBAgDCgCBCIMKAIEIgMgB2oiBDYCGCAQIANBAnRB4KMyaigCACAIQQAgBGt2cSIyNgI4AkAgBEEhTwRAQeCkMiEOIBBB4KQyNgIcDAELIAogG08EQCAQIARBB3EiBzYCGCAQIAogBEEDdmsiDjYCHCAQIA4oAAAiCDYCFCAHIQQMAQsgCiALRg0AIBAgCiAKIAtrIARBA3YiDiAKIA5rIAtJGyIHayIONgIcIBAgBCAHQQN0ayIENgIYIBAgDigAACIINgIUCyAQQUBrISQgECAMQQhqIh82AjwgJUEgayEVIB4hAwNAIBogLEEDdGoiDC0AAiEUIB8gMkEDdGoiCi0AAiETICogMUEDdGoiBy0AAyEzIAotAAMhNSAMLQADIRwgBy8BACEdIAovAQAhIiAMLwEAIQkgBygCBCEFIAwoAgQhDCAKKAIEIQoCfwJAIActAAIiB0ECTwRAIAQgB2ohBiAIIAR0IQQCQAJAICZFDQAgB0EZSQ0AIARBBSAHa3ZBBXQgBWohBAJAIAZBBWsiB0EhTwRAQeCkMiEOIBBB4KQyNgIcDAELIA4gG08EQCAQIAdBB3EiBTYCGCAQIA4gB0EDdmsiDjYCHCAQIA4oAAAiCDYCFCAFIQcMAQsgCyAORg0AIBAgDiAOIAtrIAdBA3YiCCAOIAhrIAtJGyIIayIONgIcIBAgByAIQQN0ayIHNgIYIBAgDigAACIINgIUCyAQIAdBBWoiBjYCGCAEIAggB3RBG3ZqIQcMAQsgBEEAIAdrdiAFaiEHIBAgBjYCGCAGQSFPBEBB4KQyIQ4gEEHgpDI2AhwMAQsgDiAbTwRAIBAgBkEHcSIENgIYIBAgDiAGQQN2ayIONgIcIBAgDigAACIINgIUIAQhBgwBCyALIA5GDQAgECAOIA4gC2sgBkEDdiIEIA4gBGsgC0kbIgRrIg42AhwgECAGIARBA3RrIgY2AhggECAOKAAAIgg2AhQLIBAgECgCRDYCSAwBCyAMRSEjIAdFBEAgJCAjQQJ0aigCACEHIAQhBiAkIAxBAEdBAnRqKAIADAILIBAgBEEBaiIGNgIYAkAgBSAIIAR0QR92aiAjaiIEQQNGBEAgECgCQEEBayIHQX8gBxshBwwBCyAkIARBAnRqKAIAIgdBfyAHGyEHIARBAUYNAQsgECAQKAJENgJICyAQKAJACyEFIBMgFGohBCAQIAc2AkAgECAFNgJEAkAgE0UEQCAGIQUMAQsgECAGIBNqIgU2AhggCCAGdEEAIBNrdiAKaiEKCwJAIARBFEkNACAFQSFPBEBB4KQyIQ4gEEHgpDI2AhwMAQsgDiAbTwRAIBAgBUEHcSIENgIYIBAgDiAFQQN2ayIONgIcIBAgDigAACIINgIUIAQhBQwBCyALIA5GDQAgECAOIA4gC2sgBUEDdiIEIA4gBGsgC0kbIgRrIg42AhwgECAFIARBA3RrIgU2AhggECAOKAAAIgg2AhQLAkAgFEUEQCAFIQQMAQsgECAFIBRqIgQ2AhggCCAFdEEAIBRrdiAMaiEMCwJAIARBIU8EQEHgpDIhDiAQQeCkMjYCHAwBCyAOIBtPBEAgECAEQQdxIgU2AhggECAOIARBA3ZrIg42AhwgECAOKAAAIgg2AhQgBSEEDAELIAsgDkYNACAQIA4gDiALayAEQQN2IgggDiAIayALSRsiCGsiDjYCHCAQIAQgCEEDdGsiBDYCGCAQIA4oAAAiCDYCFAsCQCAPQQFGDQAgECAcQQJ0QeCjMmooAgAgCEEAIAQgHGoiBGt2cSAJaiIsNgIoIBAgNUECdEHgozJqKAIAIAhBACAEIDVqIgRrdnEgImoiMjYCOAJAIARBIU8EQEHgpDIhDiAQQeCkMjYCHAwBCyAOIBtPBEAgECAEQQdxIgU2AhggECAOIARBA3ZrIg42AhwgECAOKAAAIgg2AhQgBSEEDAELIAsgDkYNACAQIA4gDiALayAEQQN2IgggDiAIayALSRsiCGsiDjYCHCAQIAQgCEEDdGsiBDYCGCAQIA4oAAAiCDYCFAsgECAEIDNqIgQ2AhggECAzQQJ0QeCjMmooAgAgCEEAIARrdnEgHWoiMTYCMCAEQSFPBEBB4KQyIQ4gEEHgpDI2AhwMAQsgDiAbTwRAIBAgBEEHcSIFNgIYIBAgDiAEQQN2ayIONgIcIBAgDigAACIINgIUIAUhBAwBCyALIA5GDQAgECAOIA4gC2sgBEEDdiIIIA4gCGsgC0kbIghrIg42AhwgECAEIAhBA3RrIgQ2AhggECAOKAAAIgg2AhQLIBAgDDYCUCAQIAo2AlQgECAHNgJYAkACQAJAIBAoAkwiEyAMaiIGICdLDQAgAyAKIAxqIhRqIBVLDQAgFEEgaiAlIANrTQ0BCyAQIBAoAlg2AhAgECAQKQNQNwMIIAMgJSAQQQhqIBBBzABqICcgGCArICkQyQwhFAwBCyADIAxqIQUgAyAT/QAAAP0LAAACQCAMQRFJDQAgAyAT/QAAEP0LABAgDEEQa0ERSA0AIBNBEGohDCADQSBqIRMDQCATIAz9AAAQ/QsAACATIAz9AAAg/QsAECAMQSBqIQwgE0EgaiITIAVJDQALCyAFIAdrIQwgECAGNgJMIAUgGGsgB0kEQCAHIAUgK2tLDQQgKSApIAwgGGsiDGoiEyAKak8EQCAKRQ0CIAUgEyAK/AoAAAwCC0EAIAxrIgYEQCAFIBMgBvwKAAALIBAgCiAMaiIKNgJUIAUgDGshBSAYIQwLIAdBEE8EQCAFIAz9AAAA/QsAACAKQRFIDQEgBSAKaiEHIAVBEGohCgNAIAogDP0AABD9CwAAIAogDP0AACD9CwAQIAxBIGohDCAKQSBqIgogB0kNAAsMAQsCQCAHQQdNBEAgBSAMLQAAOgAAIAUgDC0AAToAASAFIAwtAAI6AAIgBSAMLQADOgADIAUgDCAHQQJ0IgdB8KQyaigCAGoiDCgAADYABCAMIAdBkKUyaigCAGshDAwBCyAFIAwpAAA3AAALIApBCUkNACAFIApqIRMgBUEIaiIHIAxBCGoiDGtBD0wEQANAIAcgDCkAADcAACAMQQhqIQwgB0EIaiIHIBNJDQALDAELIAcgDP0AAAD9CwAAIApBGUgNACAFQRhqIQoDQCAKIAz9AAAQ/QsAACAKIAz9AAAg/QsAECAMQSBqIQwgCkEgaiIKIBNJDQALCyAUQYh/SwRAIBQhEQwDCyADIBRqIQMgD0EBayIPDQALIAsgDkcNASAEQSBHDQEgLSAkKQIANwIAIC0gJCgCCDYCCCAQKAJMIQ4LQbp/IREgJyAOayIMICUgA2tLDQAgDARAIAMgDiAM/AoAAAsgAyAMaiAeayERCyAQQeAAaiQAIBEhDAwCCyASICk2AowBIBIgJDYCfCASICU2AoQBIBIgAzYCcCASIBY2AmgCQCAPIBhMBEAgHiEHDAELIAhBIGshKyAPQQFrIS0gHiEHA0AgMSAkQQN0aiIGLQACIQUgMyApQQN0aiIKLQACIQkgMiAlQQN0aiIVLQADIRAgCi0AAyEXIAYtAAMhHCAVLwEAISIgCi8BACEaIAYvAQAhLCAVKAIEIR8gBigCBCEjIAooAgQhFAJ/AkAgFS0AAiIGQQJPBEAgBCAGaiEKIBYgBHQhBAJAAkAgJkUNACAGQRlJDQAgBEEFIAZrdkEFdCAfaiEGAkAgCkEFayIEQSFPBEBB4KQyIQMgEkHgpDI2AnAMAQsgAyAOTwRAIBIgBEEHcSIKNgJsIBIgAyAEQQN2ayIDNgJwIBIgAygAACIWNgJoIAohBAwBCyADIAtGDQAgEiADIAMgC2sgBEEDdiIWIAMgFmsgC0kbIhZrIgM2AnAgEiAEIBZBA3RrIgQ2AmwgEiADKAAAIhY2AmgLIBIgBEEFaiIKNgJsIAYgFiAEdEEbdmohFQwBCyAEQQAgBmt2IB9qIRUgEiAKNgJsIApBIU8EQEHgpDIhAyASQeCkMjYCcAwBCyADIA5PBEAgEiAKQQdxIgQ2AmwgEiADIApBA3ZrIgM2AnAgEiADKAAAIhY2AmggBCEKDAELIAMgC0YNACASIAMgAyALayAKQQN2IgQgAyAEayALSRsiBGsiAzYCcCASIAogBEEDdGsiCjYCbCASIAMoAAAiFjYCaAsgEiASKAKYATYCnAEMAQsgI0UhFSAGRQRAIDYgFUECdGooAgAhFSAEIQogNiAjQQBHQQJ0aigCAAwCCyASIARBAWoiCjYCbAJAIB8gFiAEdEEfdmogFWoiBEEDRgRAIBIoApQBQQFrIgRBfyAEGyEVDAELIDYgBEECdGooAgAiBkF/IAYbIRUgBEEBRg0BCyASIBIoApgBNgKcAQsgEigClAELIQYgBSAJaiEEIBIgFTYClAEgEiAGNgKYAQJAIAlFBEAgCiEGDAELIBIgCSAKaiIGNgJsIBYgCnRBACAJa3YgFGohFAsCQCAEQRRJDQAgBkEhTwRAQeCkMiEDIBJB4KQyNgJwDAELIAMgDk8EQCASIAZBB3EiBDYCbCASIAMgBkEDdmsiAzYCcCASIAMoAAAiFjYCaCAEIQYMAQsgAyALRg0AIBIgAyADIAtrIAZBA3YiBCADIARrIAtJGyIEayIDNgJwIBIgBiAEQQN0ayIGNgJsIBIgAygAACIWNgJoCwJAIAVFBEAgBiEEDAELIBIgBSAGaiIENgJsIBYgBnRBACAFa3YgI2ohIwsCQCAEQSFPBEBB4KQyIQMgEkHgpDI2AnAMAQsgAyAOTwRAIBIgBEEHcSIGNgJsIBIgAyAEQQN2ayIDNgJwIBIgAygAACIWNgJoIAYhBAwBCyADIAtGDQAgEiADIAMgC2sgBEEDdiIGIAMgBmsgC0kbIgZrIgM2AnAgEiAEIAZBA3RrIgQ2AmwgEiADKAAAIhY2AmgLAkAgGCAtRg0AIBIgHEECdEHgozJqKAIAIBZBACAEIBxqIgRrdnEgLGoiJDYCfCASIBdBAnRB4KMyaigCACAWQQAgBCAXaiIEa3ZxIBpqIik2AowBAkAgBEEhTwRAQeCkMiEDIBJB4KQyNgJwDAELIAMgDk8EQCASIARBB3EiBjYCbCASIAMgBEEDdmsiAzYCcCASIAMoAAAiFjYCaCAGIQQMAQsgAyALRg0AIBIgAyADIAtrIARBA3YiBiADIAZrIAtJGyIGayIDNgJwIBIgBCAGQQN0ayIENgJsIBIgAygAACIWNgJoCyASIAQgEGoiBDYCbCASIBBBAnRB4KMyaigCACAWQQAgBGt2cSAiaiIlNgKEASAEQSFPBEBB4KQyIQMgEkHgpDI2AnAMAQsgAyAOTwRAIBIgBEEHcSIGNgJsIBIgAyAEQQN2ayIDNgJwIBIgAygAACIWNgJoIAYhBAwBCyADIAtGDQAgEiADIAMgC2sgBEEDdiIGIAMgBmsgC0kbIgZrIgM2AnAgEiAEIAZBA3RrIgQ2AmwgEiADKAAAIhY2AmgLAn8CQCANKAKE7AFBAkYEQCASKAKMAiIFIBJBoAFqIBhBB3FBDGxqIhAoAgAiBmoiCSANKAKA7AEiF0sEQAJAIAUgF0YEQCAHIQoMAQsgFyAFayIfIAggB2tLBEBBun8hDAwJCyAHIB9qIQoCQCAHIAVrIgZBeEwgH0EHSnFFBEAgH0EATA0BA0AgByAFLQAAOgAAIAVBAWohBSAHQQFqIgcgCkkNAAsMAQsCfyAGQW9LBEAgBSEGIAchIiAHDAELIAUhBiAHISIgByAHIApBIGsiHEsNABogByAF/QAAAP0LAAAgHCAHayIiQRFOBEAgB0EQaiEGIAUhCQNAIAYgCf0AABD9CwAAIAYgCf0AACD9CwAQIAlBIGohCSAGQSBqIgYgHEkNAAsLIAUgImohBiAcISIgHAshGiAHIBdqIAUgImpBf3NqIRdBACEJIBohBSAHIB9qICJrIhxBB3EiBwRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgCUEBaiIJIAdHDQALCyAXQQdJDQAgGiAcaiEHA0AgBSAGLQAAOgAAIAUgBi0AAToAASAFIAYtAAI6AAIgBSAGLQADOgADIAUgBi0ABDoABCAFIAYtAAU6AAUgBSAGLQAGOgAGIAUgBi0ABzoAByAGQQhqIQYgBUEIaiIFIAdHDQALCyAQIBAoAgAgH2siBjYCAAsgEiAwNgKMAiANQQA2AoTsAQJAAkACQCAGQYCABEoNACAKIBAoAgQiFyAGaiIJaiArSw0AIAlBIGogCCAKa00NAQsgEkFAayAQKAIINgIAIBIgECkCADcDOCAKIAggEkE4aiASQYwCaiA3IBEgGyATEMkMIQkMAQsgBiAwaiEcIAYgCmohBSAQKAIIIQcgCiAw/QAAAP0LAAACQCAGQRFJDQAgCiA4/QAAAP0LABAgBkEQa0ERSA0AIApBIGohBiA4IR8DQCAGIB/9AAAQ/QsAACAGIB/9AAAg/QsAECAfQSBqIR8gBkEgaiIGIAVJDQALCyAFIAdrIQYgEiAcNgKMAiAFIBFrIAdJBEAgByAFIBtrSw0JIBMgEyAGIBFrIgZqIhwgF2pPBEAgF0UNAiAFIBwgF/wKAAAMAgtBACAGayIfBEAgBSAcIB/8CgAACyAGIBdqIRcgBSAGayEFIBEhBgsgB0EQTwRAIAUgBv0AAAD9CwAAIBdBEUgNASAFIBdqIQcgBUEQaiEFA0AgBSAG/QAAEP0LAAAgBSAG/QAAIP0LABAgBkEgaiEGIAVBIGoiBSAHSQ0ACwwBCwJAIAdBB00EQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGIAdBAnQiB0HwpDJqKAIAaiIGKAAANgAEIAYgB0GQpTJqKAIAayEGDAELIAUgBikAADcAAAsgF0EJSQ0AIAUgF2ohHCAFQQhqIgcgBkEIaiIGa0EPTARAA0AgByAGKQAANwAAIAZBCGohBiAHQQhqIgcgHEkNAAsMAQsgByAG/QAAAP0LAAAgF0EZSA0AIAVBGGohBQNAIAUgBv0AABD9CwAAIAUgBv0AACD9CwAQIAZBIGohBiAFQSBqIgUgHEkNAAsLIAlBiH9LBEAgCSEMDAgLIBAgFTYCCCAQIBQ2AgQgECAjNgIAICMgJ2ohBiA3IR0gCSAKagwDCyAJQSBrIRcCQAJAIAkgHUsNACAHIBAoAgQiHCAGaiIKaiAXSw0AIApBIGogCCAHa00NAQsgEiAQKAIINgJQIBIgECkCADcDSCAHIAggFyASQcgAaiASQYwCaiAdIBEgGyATEMoMIQoMAgsgBiAHaiEXIBAoAgghECAHIAX9AAAA/QsAAAJAIAZBEUkNACAHIAX9AAAQ/QsAECAGQRBrQRFIDQAgBUEQaiEGIAdBIGohBQNAIAUgBv0AABD9CwAAIAUgBv0AACD9CwAQIAZBIGohBiAFQSBqIgUgF0kNAAsLIBcgEGshBiASIAk2AowCIBcgEWsgEEkEQCAQIBcgG2tLDQcgEyATIAYgEWsiBmoiBSAcak8EQCAcRQ0DIBcgBSAc/AoAAAwDC0EAIAZrIgkEQCAXIAUgCfwKAAALIAYgHGohHCAXIAZrIRcgESEGCyAQQRBPBEAgFyAG/QAAAP0LAAAgHEERSA0CIBcgHGohCSAXQRBqIQUDQCAFIAb9AAAQ/QsAACAFIAb9AAAg/QsAECAGQSBqIQYgBUEgaiIFIAlJDQALDAILAkAgEEEHTQRAIBcgBi0AADoAACAXIAYtAAE6AAEgFyAGLQACOgACIBcgBi0AAzoAAyAXIAYgEEECdCIFQfCkMmooAgBqIgYoAAA2AAQgBiAFQZClMmooAgBrIQYMAQsgFyAGKQAANwAACyAcQQlJDQEgFyAcaiEJIBdBCGoiBSAGQQhqIgZrQQ9MBEADQCAFIAYpAAA3AAAgBkEIaiEGIAVBCGoiBSAJSQ0ACwwCCyAFIAb9AAAA/QsAACAcQRlIDQEgF0EYaiEFA0AgBSAG/QAAEP0LAAAgBSAG/QAAIP0LABAgBkEgaiEGIAVBIGoiBSAJSQ0ACwwBCwJAAkAgEigCjAIiFyASQaABaiAYQQdxQQxsaiIJKAIAIgZqIhwgHUsNACAHIAkoAgQiECAGaiIKaiArSw0AIApBIGogCCAHa00NAQsgEiAJKAIINgJgIBIgCSkCADcDWCAHIAggEkHYAGogEkGMAmogHSARIBsgExDJDCEKDAELIAYgB2ohBSAJKAIIIQkgByAX/QAAAP0LAAACQCAGQRFJDQAgByAX/QAAEP0LABAgBkEQa0ERSA0AIBdBEGohBiAHQSBqIRcDQCAXIAb9AAAQ/QsAACAXIAb9AAAg/QsAECAGQSBqIQYgF0EgaiIXIAVJDQALCyAFIAlrIQYgEiAcNgKMAiAFIBFrIAlJBEAgCSAFIBtrSw0GIBMgEyAGIBFrIgZqIhcgEGpPBEAgEEUNAiAFIBcgEPwKAAAMAgtBACAGayIcBEAgBSAXIBz8CgAACyAGIBBqIRAgBSAGayEFIBEhBgsgCUEQTwRAIAUgBv0AAAD9CwAAIBBBEUgNASAFIBBqIQkgBUEQaiEFA0AgBSAG/QAAEP0LAAAgBSAG/QAAIP0LABAgBkEgaiEGIAVBIGoiBSAJSQ0ACwwBCwJAIAlBB00EQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGIAlBAnQiCUHwpDJqKAIAaiIGKAAANgAEIAYgCUGQpTJqKAIAayEGDAELIAUgBikAADcAAAsgEEEJSQ0AIAUgEGohFyAFQQhqIgkgBkEIaiIGa0EPTARAA0AgCSAGKQAANwAAIAZBCGohBiAJQQhqIgkgF0kNAAsMAQsgCSAG/QAAAP0LAAAgEEEZSA0AIAVBGGohBQNAIAUgBv0AABD9CwAAIAUgBv0AACD9CwAQIAZBIGohBiAFQSBqIgUgF0kNAAsLIApBiH9LBEAgCiEMDAULIBJBoAFqIBhBB3FBDGxqIgYgFTYCCCAGIBQ2AgQgBiAjNgIAICMgJ2ohBiAHIApqCyEHIAYgFGohJyAYQQFqIhggD0cNAAsgDyEYCyAEQSBHDQEgAyALRw0BIA8gGCAqayIWSgRAIAhBIGshIwNAIBJBoAFqIBZBB3FBDGxqIQYCfwJAIA0oAoTsAUECRgRAIBIoAowCIgQgBigCACIDaiIOIA0oAoDsASIJSwRAAkAgBCAJRgRAIAchCwwBCyAJIARrIhggCCAHa0sEQEG6fyEMDAkLIAcgGGohCwJAIAcgBGsiA0F4TCAYQQdKcUUEQCAYQQBMDQEDQCAHIAQtAAA6AAAgBEEBaiEEIAdBAWoiByALSQ0ACwwBCyAHIAlqAn8gA0FvSwRAIAchFCAEIQMgBwwBCyAHIRQgBCEDIAcgByALQSBrIg5LDQAaIAcgA/0AAAD9CwAAIA4gB2siCkERTgRAIAdBEGohAyAEIQUDQCADIAX9AAAQ/QsAACADIAX9AAAg/QsAECAFQSBqIQUgA0EgaiIDIA5JDQALCyAEIApqIQMgDiEUIA4LIgogBGpBf3NqIQ5BACEFIBQhBCAHIBhqIAprIglBB3EiBwRAA0AgBCADLQAAOgAAIARBAWohBCADQQFqIQMgBUEBaiIFIAdHDQALCyAOQQdJDQAgCSAUaiEFA0AgBCADLQAAOgAAIAQgAy0AAToAASAEIAMtAAI6AAIgBCADLQADOgADIAQgAy0ABDoABCAEIAMtAAU6AAUgBCADLQAGOgAGIAQgAy0ABzoAByADQQhqIQMgBEEIaiIEIAVHDQALCyAGIAYoAgAgGGsiAzYCAAsgEiAwNgKMAiANQQA2AoTsAQJAAkACQCADQYCABEoNACALIAYoAgQiByADaiIFaiAjSw0AIAVBIGogCCALa00NAQsgEiAGKAIINgIQIBIgBikCADcDCCALIAggEkEIaiASQYwCaiA3IBEgGyATEMkMIQUMAQsgAyAwaiEOIAMgC2ohBCAGKAIIIQYgCyAw/QAAAP0LAAACQCADQRFJDQAgCyA4/QAAAP0LABAgA0EQa0ERSA0AIAtBIGohAyA4IQkDQCADIAn9AAAQ/QsAACADIAn9AAAg/QsAECAJQSBqIQkgA0EgaiIDIARJDQALCyAEIAZrIQMgEiAONgKMAiAEIBFrIAZJBEAgBiAEIBtrSw0JIBMgEyADIBFrIgNqIg4gB2pPBEAgB0UNAiAEIA4gB/wKAAAMAgtBACADayIJBEAgBCAOIAn8CgAACyADIAdqIQcgBCADayEEIBEhAwsgBkEQTwRAIAQgA/0AAAD9CwAAIAdBEUgNASAEIAdqIQYgBEEQaiEEA0AgBCAD/QAAEP0LAAAgBCAD/QAAIP0LABAgA0EgaiEDIARBIGoiBCAGSQ0ACwwBCwJAIAZBB00EQCAEIAMtAAA6AAAgBCADLQABOgABIAQgAy0AAjoAAiAEIAMtAAM6AAMgBCADIAZBAnQiBkHwpDJqKAIAaiIDKAAANgAEIAMgBkGQpTJqKAIAayEDDAELIAQgAykAADcAAAsgB0EJSQ0AIAQgB2ohDiAEQQhqIgYgA0EIaiIDa0EPTARAA0AgBiADKQAANwAAIANBCGohAyAGQQhqIgYgDkkNAAsMAQsgBiAD/QAAAP0LAAAgB0EZSA0AIARBGGohBANAIAQgA/0AABD9CwAAIAQgA/0AACD9CwAQIANBIGohAyAEQSBqIgQgDkkNAAsLIAVBiX9PBEAgBSEMDAgLIDchHSAFIAtqDAMLIA5BIGshCwJAAkAgDiAdSw0AIAcgBigCBCIJIANqIgVqIAtLDQAgBUEgaiAIIAdrTQ0BCyASIAYoAgg2AiAgEiAGKQIANwMYIAcgCCALIBJBGGogEkGMAmogHSARIBsgExDKDCEFDAILIAMgB2ohCyAGKAIIIQYgByAE/QAAAP0LAAACQCADQRFJDQAgByAE/QAAEP0LABAgA0EQa0ERSA0AIARBEGohAyAHQSBqIQQDQCAEIAP9AAAQ/QsAACAEIAP9AAAg/QsAECADQSBqIQMgBEEgaiIEIAtJDQALCyALIAZrIQMgEiAONgKMAiALIBFrIAZJBEAgBiALIBtrSw0HIBMgEyADIBFrIgNqIgQgCWpPBEAgCUUNAyALIAQgCfwKAAAMAwtBACADayIOBEAgCyAEIA78CgAACyADIAlqIQkgCyADayELIBEhAwsgBkEQTwRAIAsgA/0AAAD9CwAAIAlBEUgNAiAJIAtqIQYgC0EQaiEEA0AgBCAD/QAAEP0LAAAgBCAD/QAAIP0LABAgA0EgaiEDIARBIGoiBCAGSQ0ACwwCCwJAIAZBB00EQCALIAMtAAA6AAAgCyADLQABOgABIAsgAy0AAjoAAiALIAMtAAM6AAMgCyADIAZBAnQiBEHwpDJqKAIAaiIDKAAANgAEIAMgBEGQpTJqKAIAayEDDAELIAsgAykAADcAAAsgCUEJSQ0BIAkgC2ohBiALQQhqIgQgA0EIaiIDa0EPTARAA0AgBCADKQAANwAAIANBCGohAyAEQQhqIgQgBkkNAAsMAgsgBCAD/QAAAP0LAAAgCUEZSA0BIAtBGGohBANAIAQgA/0AABD9CwAAIAQgA/0AACD9CwAQIANBIGohAyAEQSBqIgQgBkkNAAsMAQsCQAJAIBIoAowCIg4gBigCACIDaiIJIB1LDQAgByAGKAIEIgsgA2oiBWogI0sNACAFQSBqIAggB2tNDQELIBIgBigCCDYCMCASIAYpAgA3AyggByAIIBJBKGogEkGMAmogHSARIBsgExDJDCEFDAELIAMgB2ohBCAGKAIIIQYgByAO/QAAAP0LAAACQCADQRFJDQAgByAO/QAAEP0LABAgA0EQa0ERSA0AIA5BEGohAyAHQSBqIQ4DQCAOIAP9AAAQ/QsAACAOIAP9AAAg/QsAECADQSBqIQMgDkEgaiIOIARJDQALCyAEIAZrIQMgEiAJNgKMAiAEIBFrIAZJBEAgBiAEIBtrSw0GIBMgEyADIBFrIgNqIg4gC2pPBEAgC0UNAiAEIA4gC/wKAAAMAgtBACADayIJBEAgBCAOIAn8CgAACyADIAtqIQsgBCADayEEIBEhAwsgBkEQTwRAIAQgA/0AAAD9CwAAIAtBEUgNASAEIAtqIQYgBEEQaiEEA0AgBCAD/QAAEP0LAAAgBCAD/QAAIP0LABAgA0EgaiEDIARBIGoiBCAGSQ0ACwwBCwJAIAZBB00EQCAEIAMtAAA6AAAgBCADLQABOgABIAQgAy0AAjoAAiAEIAMtAAM6AAMgBCADIAZBAnQiBkHwpDJqKAIAaiIDKAAANgAEIAMgBkGQpTJqKAIAayEDDAELIAQgAykAADcAAAsgC0EJSQ0AIAQgC2ohDiAEQQhqIgYgA0EIaiIDa0EPTARAA0AgBiADKQAANwAAIANBCGohAyAGQQhqIgYgDkkNAAsMAQsgBiAD/QAAAP0LAAAgC0EZSA0AIARBGGohBANAIAQgA/0AABD9CwAAIAQgA/0AACD9CwAQIANBIGohAyAEQSBqIgQgDkkNAAsLIAVBiH9LBEAgBSEMDAULIAUgB2oLIQcgFkEBaiIWIA9HDQALCyA7IDYpAgA3AgAgQyA1KAIANgIAIA0oAoTsASEDIBIoAowCIQQLIANBAkYEQCAdIARrIgwgCCAHa0sEQEG6fyEMDAILIAwEQCAHIAQgDPwKAAALIAcgDGohByA3IR0gMCEECyAdIARrIgwgCCAHa0sEQEG6fyEMDAELIAwEQCAHIAQgDPwKAAALIAcgDGogHmshDAsgDEGIf0sNAgsgREEBcSEGIA0oAvTqAQRAID4gHiAMEL4LCyBHICBrIQQgICAuaiEDIAwgHmohHiAGRQ0ACyA5KQMAIkpCf1IgSiAeIC9rrFJxDQMCfyANKALg6QFFBEAgBCECIAMMAQtBaiEZIARBBEkNBCANKALw6gFFBEAgAygAACA+EMALp0cNBQsgBEEEayECIANBBGoLIQEgHiAvayEMC0G4fyEZIEggDEF2RnENAiAMQYh/SwRAIAwhGQwDC0EBIUggPCAMayE8IAwgL2ohLyANKALs6gEiIEUhGSACQQFBBSAgGyIDTw0ACwsgAgRAQbh/IRkMAQsgLyAAayEZCyANKAKQ6wENACANKAKE6wEhDCANKAKA6wEhAgJAIA0oApjrASIBRQ0AIAEoArjVASEAIAEoArTVASEDAkACQCABKAIAIi8EQCADRQ0BIAAgLyADEQMAIAAgASADEQMADAMLIANFDQEgACABIAMRAwAMAgsgLxArCyABECsLIA1BADYCqOsBIA1CADcDmOsBAkAgDSgCwOsBIgFFDQAgAgRAIAwgASACEQMADAELIAEQKwsgDUEANgLA6wEgDSgCrOsBIgEEQAJAAkACQCABKAIAIgMEQCACRQ0BIAwgAyACEQMAIAwgASACEQMADAMLIAJFDQEgDCABIAIRAwAMAgsgAxArCyABECsLIA1BADYCrOsBCyACBEAgDCANIAIRAwAMAQsgDRArCyASQZACaiQAIBkLpQMBAX9BrbQrIQECQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkBBACAAa0EAIABBiX9PGw5sIwAiIiIiIiIiIgEiAiIDIgQiIiIFIgYiByIiIiIiFCIVIhYiIiIiIggJCiIPIhAiERITIiIiIiIiIiIiDiILIgwiDSIiIhciGCIZIiIiIiIaIhsiIiIiIiIiIiIiIiIiIiIiIhwiHSIeHyAhIgtBwv0rDwtBz40qDwtB9LErDwtB7pQqDwtBve8qDwtBv7QrDwtBtcEqDwtB+7QqDwtBipUqDwtBx/QpDwtBqqsrDwtBmc0pDwtB0KkpDwtB9eMqDwtBsZ0rDwtBxLErDwtB3JorDwtBzskqDwtBv9QqDwtBibgrDwtBn7MrDwtBg+UqDwtBjIIqDwtBrskqDwtB0+gpDwtBi5oqDwtB9ccqDwtBt6YpDwtB0pkrDwtB5e4qDwtBzOgqDwtB6OgqDwtBgqIrDwtBqq8rDwtBwKIrIQELIAELqiADHH8Iewh+IwBB0ABrIgckAAJAIAFBGUkNACAAIAAoAgAiAkEBajYCACACLQAAQQFHDQAgACACQQJqNgIAIAItAAEhFCAAIAJBA2o2AgAgAi0AAiEJIAAgAkEEajYCACACLQADIQsgACACQQVqNgIAIAItAAQhFiAAIAJBBmo2AgAgAi0ABSEXIAAgAkEHajYCACACLQAGIRggACACQQhqNgIAIAItAAchGSAAIAJBCWo2AgAgAi0ACCEaIAAgAkEKajYCACACLQAJIRsgACACQQtqNgIAIAItAAohBSAAIAJBDGo2AgAgAi0ACyEKIAAgAkENajYCACACLQAMIQYgACACQQ5qNgIAIAItAA0hECAAIAJBD2o2AgAgAi0ADiETIAAgAkEQajYCACACLQAPIRUgACACQRFqNgIAIAItABAhDiAAIAJBEmo2AgAgAi0AESEIIAAgAkETajYCACACLQASIREgACACQRRqNgIAIAItABMhEiAAIAJBFWo2AgAgAi0AFCENIAAgAkEWajYCACACLQAVIRwgACACQRdqNgIAIAItABYhDyAAIAJBGGo2AgAgAi0AFyEMIAAgAkEZaiIDNgIAIAUgCkEIdHIgBkEQdHIiHSAOIAhBCHRyIBFBEHRyIghLDQAgCUEIdCAUciALQRB0ckEBRw0AIBNBCHQgEHIgFUEQdHIiEyAISw0AIA1BCHQiDSAcQRB0IBJyciIQQZDOAEsNACACLQAYQRB0IgIgDEEIdCIFIA9yciIUQQV0IQsgFEEAIAFBGWsiFSALSRsNAEEAIQpBACEOAkACQAJAAkAgFARAQQAhASALEKIJIQ4gCwRAIA5BACAL/AsACyAAQQRqIQkgAiAFciAPciERIAdBCGpBAXIhBUHIiDQpAwAhJkHAiDQpAwAhJ0G4iDQpAwAhKEGwiDQpAwAhLANAAnsgAyAJSSADQSBqIgQgAEtxRQRAIANBGGr9XAAAIR4gA0EUav1cAAAhICADQRBq/VwAACEhIANBDGr9XAAAISIgA0EIav1cAAAhIyADQQRq/VwAACEkIAP9XAAAISUgACADQRxq/RH9DAAAAAAAAAAAAAAAAAMAAAD9rgEiH/0bA0EBaiIENgIAIB/9GwD9XAAADAELIAAgA0EBaiICNgIAIAP9BwAAIR4gACADQQJqIgY2AgAgAiAe/VQAAAEhHiAAIANBA2oiAjYCACAGIB79VAAAAiEeIAAgA0EEajYCACACIB79VAAAAyElIAAgA0EFaiICNgIAIAP9BwAEIR4gACADQQZqIgY2AgAgAiAe/VQAAAEhHiAAIANBB2oiAjYCACAGIB79VAAAAiEeIAAgA0EIajYCACACIB79VAAAAyEkIAAgA0EJaiICNgIAIAP9BwAIIR4gACADQQpqIgY2AgAgAiAe/VQAAAEhHiAAIANBC2oiAjYCACAGIB79VAAAAiEeIAAgA0EMajYCACACIB79VAAAAyEjIAAgA0ENaiICNgIAIAP9BwAMIR4gACADQQ5qIgY2AgAgAiAe/VQAAAEhHiAAIANBD2oiAjYCACAGIB79VAAAAiEeIAAgA0EQajYCACACIB79VAAAAyEiIAAgA0ERaiICNgIAIAP9BwAQIR4gACADQRJqIgY2AgAgAiAe/VQAAAEhHiAAIANBE2oiAjYCACAGIB79VAAAAiEeIAAgA0EUajYCACACIB79VAAAAyEhIAAgA0EVaiICNgIAIAP9BwAUIR4gACADQRZqIgY2AgAgAiAe/VQAAAEhHiAAIANBF2oiAjYCACAGIB79VAAAAiEeIAAgA0EYajYCACACIB79VAAAAyEgIAAgA0EZaiICNgIAIAP9BwAYIR4gACADQRpqIgY2AgAgAiAe/VQAAAEhHiAAIANBG2oiAjYCACAGIB79VAAAAiEeIAAgA0EcajYCACACIB79VAAAAyEeIAAgA0EdaiICNgIAIAP9BwAcIR8gACADQR5qIgY2AgAgAiAf/VQAAAEhHyAAIANBH2oiAjYCACAGIB/9VAAAAiEfIAAgBDYCACACIB/9VAAAAwshHyAe/RsArSAf/RsArUIghoQiKSAmVCAh/RsArSAg/RsArUIghoQiKiAnVCAj/RsArSAi/RsArUIghoQiKyAoVCAoICtRICX9GwCtICT9GwCtQiCGhCItICxUcXIgJyAqUXFyICYgKVFxcq1QDQIgByApNwMgIAcgKjcDGCAHICs3AxAgByAtNwMIQbCINCAHQQhqQfCINBCkCSAHQThqIgMgBf0AAAj9CwMAIAdBxwBqIgYgBSkAFzcAACAHIAUpAAA3AzAgDiABQQV0aiICIActAAg6AAAgAiAHKQMwNwABIAIgA/0AAwD9CwAJIAIgBikAADcAGCAEIQMgAUEBaiIBIBFHDQALCyAaQQh0IBlyIBtBEHRyIQVBzAAQogkiBP0MAAAAAAAAAAAAAAAAAAAAAP0LAyAgBEEANgJIIARBQGtCADcDACAE/QwAAAAAAAAAAAAAAAAAAAAA/QsDMCAXQQh0IBZyIBhBEHRyIgFBAk8EQEEBIQIDQCAKQQFqIQogAkEBdCICIAFJDQALCyAEQSBqIQ9BACECIAVBAk8EQEEBIQMDQCACQQFqIQIgA0EBdCIDIAVJDQALCyAVIAtrIQMgBCATNgIcIAQgHTYCGCAEIAg2AhQgBCAQNgIQIAQgAjYCDCAEIAU2AgggBCAKNgIEIAQgATYCACAPQQA2AiggD0IANwIgIA/9DAAAAAAAAAAAAAAAAAAAAAD9CwIQIA/9DAAAAAAAAAAAAAAAAAAAAAD9CwIAAkACQCAQBEAgBCAQQQxsIgIQogkiDDYCJCAEIAw2AiAgBCACIAxqNgIoIA0gEnIhHSAHQQxqIRMgB0EoaiEcQQAhFgNAIAEhDSADQQlJDQMgACAAKAIAIgJBAWo2AgAgAi0AACEXIAAgAkECajYCACACLQABIRggACACQQNqNgIAIAItAAIhGSAAIAJBBGo2AgAgAi0AAyEKIAAgAkEFajYCACACLQAEIQYgACACQQZqNgIAIAItAAUhCCAAIAJBB2o2AgAgAi0ABiEBIAAgAkEIajYCACACLQAHIQUgACACQQlqNgIAIANBCWsiGiABIAVBCHRyIAItAAhBEHRyIhJBDGwiG0kNAyAGQQh0IApyIAhBEHRyIQFBEBCiCSIJQQA2AgwgCUIANwIEIAkgEjYCACASBEAgCSASQTBsIgUQogkiAjYCBCAJIAIgBWo2AgxBACEDIAVBMGsiBSAFQTBwa0EwaiIFBEAgAkEAIAX8CwALIAkgAiAFajYCCEEAIRFBACEGQQAhCgNAIAAgACgCACICQQFqNgIAIAItAAAhBSAAIAJBAmo2AgAgAi0AASEIIAAgAkEDajYCAEEAIAUgCEEIdCACLQACQRB0cnJBAXYiCGsgCCAFQQFxGyADaiIDIA1LDQQgACACQQRqNgIAIAItAAMhBSAAIAJBBWo2AgAgAi0ABCELIAAgAkEGajYCACACLQAFIRAgACACQQdqNgIAIAItAAYhCCAAIAJBCGo2AgAgAi0AByEVIAAgAkEJajYCAEEAIAUgC0EIdCAQQRB0cnJBAXYiC2sgCyAFQQFxGyAKaiIKIAFLDQRBACAVQQh0IAItAAhBEHRyIAhyQQF2IgVrIAUgCEEBcRsgBmoiBiABSw0EIAAgAkEKajYCACACLQAJIQUgACACQQtqNgIAIAItAAohCCAAIAJBDGo2AgAgBSAIQQh0ciACLQALQRB0ciICIBRPDQQgEyAOIAJBBXRqIgL9AAIA/QsCACATIAL9AAIQ/QsCECAJKAIEIBFBMGxqIgIgCjYCBCACIAM2AgAgAiAGNgIIIAIgB/0AAgj9CwIMIAIgB/0AAhj9CwIcIAIgHCgCADYCLCARQQFqIhEgEkcNAAsLIAcgCTYCECAHIBhBCHQgF3IgGUEQdHI2AgwgByABNgIIAkAgBCgCKCAMSwRAIAwgBykDCDcCACAMIAcoAhA2AgggBCAMQQxqIgw2AiQMAQsgDyAHQQhqENsJIQwgBygCECECIAQgDDYCJCACRQ0AIAIoAgQiAwRAIAIgAzYCCCADECsLIAIQKwsgGiAbayEDIBZBAWoiFiAdRw0ACwsgA0EgSQ0BIAAoAgAiAkEgaiEDIARBLGoiCiAAQQRqIgFJIAAgBEHMAGoiBUlxDQMgACADSSABIAJLcQ0DIAIgBUkgAyAKS3ENAyAEIAIoAAA2ACwgBCACKAAENgAwIAQgAigACDYANCAEIAIoAAw2ADggBCACKAAQNgA8IAQgAigAFDYAQCAEIAIoABg2AEQgACACQRxq/RH9DAAAAAAAAAAAAAAAAAMAAAD9rgEiHv0bA0EBajYCACAEIB79GwAoAAA2AEgMBAsgCSgCBCIABEAgCSAANgIIIAAQKwsgCRArCyAEKAIgIgAEQCAAIgEgBCgCJCINRwRAA0AgDUEEayIDKAIAIQEgA0EANgIAIAEEQCABKAIEIgMEQCABIAM2AgggAxArCyABECsLIAAgDUEMayINRw0ACyAEKAIgIQELIAQgADYCJCABECsLIAQQK0EAIQQMAgtBACEEDAILIAAgAkEBajYCACAEIAItAAA6ACwgACACQQJqNgIAIAQgAi0AAToALSAAIAJBA2o2AgAgBCACLQACOgAuIAAgAkEEajYCACAEIAItAAM6AC8gACACQQVqNgIAIAQgAi0ABDoAMCAAIAJBBmo2AgAgBCACLQAFOgAxIAAgAkEHajYCACAEIAItAAY6ADIgACACQQhqNgIAIAQgAi0ABzoAMyAAIAJBCWo2AgAgBCACLQAIOgA0IAAgAkEKajYCACAEIAItAAk6ADUgACACQQtqNgIAIAQgAi0ACjoANiAAIAJBDGo2AgAgBCACLQALOgA3IAAgAkENajYCACAEIAItAAw6ADggACACQQ5qNgIAIAQgAi0ADToAOSAAIAJBD2o2AgAgBCACLQAOOgA6IAAgAkEQajYCACAEIAItAA86ADsgACACQRFqNgIAIAQgAi0AEDoAPCAAIAJBEmo2AgAgBCACLQAROgA9IAAgAkETajYCACAEIAItABI6AD4gACACQRRqNgIAIAQgAi0AEzoAPyAAIAJBFWo2AgAgBCACLQAUOgBAIAAgAkEWajYCACAEIAItABU6AEEgACACQRdqNgIAIAQgAi0AFjoAQiAAIAJBGGo2AgAgBCACLQAXOgBDIAAgAkEZajYCACAEIAItABg6AEQgACACQRpqNgIAIAQgAi0AGToARSAAIAJBG2o2AgAgBCACLQAaOgBGIAAgAkEcajYCACAEIAItABs6AEcgACACQR1qNgIAIAQgAi0AHDoASCAAIAJBHmo2AgAgBCACLQAdOgBJIAAgAkEfajYCACAEIAItAB46AEogACADNgIAIAQgAi0AHzoASwsgDkUNAQsgDhArCyAHQdAAaiQAIAQL5xkCG38BeyMAQSBrIgokAAJAIAFBGUkNACAAIAAoAgAiAkEBajYCACACLQAAQQFHDQAgACACQQJqNgIAIAItAAEhBiAAIAJBA2o2AgAgAi0AAiEMIAAgAkEEajYCACACLQADIQggACACQQVqNgIAIAItAAQhFSAAIAJBBmo2AgAgAi0ABSEWIAAgAkEHajYCACACLQAGIRcgACACQQhqNgIAIAItAAchGCAAIAJBCWo2AgAgAi0ACCEZIAAgAkEKajYCACACLQAJIRogACACQQtqNgIAIAItAAohBCAAIAJBDGo2AgAgAi0ACyEFIAAgAkENajYCACACLQAMIQkgACACQQ5qNgIAIAItAA0hDiAAIAJBD2o2AgAgAi0ADiERIAAgAkEQajYCACACLQAPIRIgACACQRFqNgIAIAItABAhDyAAIAJBEmo2AgAgAi0AESEHIAAgAkETajYCACACLQASIQsgACACQRRqNgIAIAItABMhECAAIAJBFWo2AgAgAi0AFCETIAAgAkEWajYCACACLQAVIRQgACACQRdqNgIAIAItABYhDSAAIAJBGGo2AgAgAi0AFyEbIAAgAkEZajYCACAEIAVBCHRyIAlBEHRyIhwgDyAHQQh0ciALQRB0ciILSw0AIAxBCHQgBnIgCEEQdHJBBEcNACARQQh0IA5yIBJBEHRyIgggC0sNACATQQh0IhEgFEEQdCAQcnIiDEGQzgBLDQAgAUEZayEOIAItABhBEHQiAiAbQQh0IgEgDXJyIhNBBHQhBiATQQAgBiAOSxsNACAWQQh0IBVyIBdBEHRyIQkgGUEIdCAYciESIBpBEHQhFEEAIQVBACEPIBMEQCAGEJ4JIQ8gBgRAIA9BACAG/AsACyABIAJyIA1yIQcgACgCACECA0AgACACQQFqIgE2AgAgAv0HAAAhHSAAIAJBAmoiBDYCACABIB39VAAAASEdIAAgAkEDaiIBNgIAIAQgHf1UAAACIR0gACACQQRqIgQ2AgAgASAd/VQAAAMhHSAAIAJBBWoiATYCACAEIB39VAAABCEdIAAgAkEGaiIENgIAIAEgHf1UAAAFIR0gACACQQdqIgE2AgAgBCAd/VQAAAYhHSAAIAJBCGoiBDYCACABIB39VAAAByEdIAAgAkEJaiIBNgIAIAQgHf1UAAAIIR0gACACQQpqIgQ2AgAgASAd/VQAAAkhHSAAIAJBC2oiATYCACAEIB39VAAACiEdIAAgAkEMaiIENgIAIAEgHf1UAAALIR0gACACQQ1qIgE2AgAgBCAd/VQAAAwhHSAAIAJBDmoiBDYCACABIB39VAAADSEdIAAgAkEPaiIBNgIAIAQgHf1UAAAOIR0gACACQRBqIgI2AgAgDyADQQR0aiABIB39VAAAD/0LBAAgA0EBaiIDIAdHDQALCyASIBRyIQdBzAAQogkiA/0MAAAAAAAAAAAAAAAAAAAAAP0LAyAgA0EANgJIIANBQGtCADcDACAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDMCAJQQJPBEBBASECA0AgBUEBaiEFIAJBAXQiAiAJSQ0ACwsgA0EgaiENQQAhAUEAIQIgB0ECTwRAQQEhBANAIAJBAWohAiAEQQF0IgQgB0kNAAsLIA4gBmshBCADIAg2AhwgAyAcNgIYIAMgCzYCFCADIAw2AhAgAyACNgIMIAMgBzYCCCADIAU2AgQgAyAJNgIAIA1BADYCKCANQgA3AiAgDf0MAAAAAAAAAAAAAAAAAAAAAP0LAhAgDf0MAAAAAAAAAAAAAAAAAAAAAP0LAgACQAJAAkACQCAMBEAgAyAMQQxsIgIQogkiATYCJCADIAE2AiAgAyABIAJqNgIoIBAgEXIhHCAKQQxqIRtBACEVA0AgCSEUIARBCUkNAyAAIAAoAgAiAkEBajYCACACLQAAIRYgACACQQJqNgIAIAItAAEhFyAAIAJBA2o2AgAgAi0AAiEYIAAgAkEEajYCACACLQADIQcgACACQQVqNgIAIAItAAQhCyAAIAJBBmo2AgAgAi0ABSEGIAAgAkEHajYCACACLQAGIQUgACACQQhqNgIAIAItAAchCSAAIAJBCWo2AgAgBEEJayIZIAUgCUEIdHIgAi0ACEEQdHIiEEEMbCIaSQ0DIAtBCHQgB3IgBkEQdHIhCUEQEKIJIghBADYCDCAIQgA3AgQgCCAQNgIAIBAEQCAIIBBBBXQiAhCeCSIFNgIEIAggAiAFaiIHNgIMQQAhBCACBEAgBUEAIAL8CwALIAggBzYCCEEAIQxBACELQQAhBwNAIAAgACgCACICQQFqNgIAIAItAAAhBSAAIAJBAmo2AgAgAi0AASEGIAAgAkEDajYCAEEAIAUgBkEIdCACLQACQRB0cnJBAXYiBmsgBiAFQQFxGyAEaiIEIBRLDQQgACACQQRqNgIAIAItAAMhBSAAIAJBBWo2AgAgAi0ABCEOIAAgAkEGajYCACACLQAFIREgACACQQdqNgIAIAItAAYhBiAAIAJBCGo2AgAgAi0AByESIAAgAkEJajYCAEEAIAUgDkEIdCARQRB0cnJBAXYiDmsgDiAFQQFxGyAHaiIHIAlLDQRBACASQQh0IAItAAhBEHRyIAZyQQF2IgVrIAUgBkEBcRsgC2oiCyAJSw0EIAAgAkEKajYCACACLQAJIQUgACACQQtqNgIAIAItAAohBiAAIAJBDGo2AgAgBSAGQQh0ciACLQALQRB0ciICIBNPDQQgGyAPIAJBBHRq/QACAP0LAgAgCCgCBCAMQQV0aiICIAc2AgQgAiAENgIAIAIgCzYCCCACIAr9AAII/QsCDCACIAooAhg2AhwgDEEBaiIMIBBHDQALCyAKIAg2AhAgCiAXQQh0IBZyIBhBEHRyNgIMIAogCTYCCAJAIAMoAiggAUsEQCABIAopAwg3AgAgASAKKAIQNgIIIAMgAUEMaiIBNgIkDAELIA0gCkEIahDbCSEBIAooAhAhAiADIAE2AiQgAkUNACACKAIEIgQEQCACIAQ2AgggBBArCyACECsLIBkgGmshBCAVQQFqIhUgHEcNAAsLIARBIEkNASAAKAIAIgJBIGohASADQSxqIgkgAEEEaiIESSAAIANBzABqIgVJcQ0CIAAgAUkgAiAESXENAiACIAVJIAEgCUtxDQIgAyACKAAANgAsIAMgAigABDYAMCADIAIoAAg2ADQgAyACKAAMNgA4IAMgAigAEDYAPCADIAIoABQ2AEAgAyACKAAYNgBEIAAgAkEcav0R/QwAAAAAAAAAAAAAAAADAAAA/a4BIh39GwNBAWo2AgAgAyAd/RsAKAAANgBIDAMLIAgoAgQiAARAIAggADYCCCAAECsLIAgQKwsgDSgCACIEBEAgASAERwRAA0AgAUEEayICKAIAIQAgAkEANgIAIAAEQCAAKAIEIgIEQCAAIAI2AgggAhArCyAAECsLIAQgAUEMayIBRw0ACwsgAyAENgIkIAQQKwsgAxArQQAhAwwBCyAAIAJBAWo2AgAgAyACLQAAOgAsIAAgAkECajYCACADIAItAAE6AC0gACACQQNqNgIAIAMgAi0AAjoALiAAIAJBBGo2AgAgAyACLQADOgAvIAAgAkEFajYCACADIAItAAQ6ADAgACACQQZqNgIAIAMgAi0ABToAMSAAIAJBB2o2AgAgAyACLQAGOgAyIAAgAkEIajYCACADIAItAAc6ADMgACACQQlqNgIAIAMgAi0ACDoANCAAIAJBCmo2AgAgAyACLQAJOgA1IAAgAkELajYCACADIAItAAo6ADYgACACQQxqNgIAIAMgAi0ACzoANyAAIAJBDWo2AgAgAyACLQAMOgA4IAAgAkEOajYCACADIAItAA06ADkgACACQQ9qNgIAIAMgAi0ADjoAOiAAIAJBEGo2AgAgAyACLQAPOgA7IAAgAkERajYCACADIAItABA6ADwgACACQRJqNgIAIAMgAi0AEToAPSAAIAJBE2o2AgAgAyACLQASOgA+IAAgAkEUajYCACADIAItABM6AD8gACACQRVqNgIAIAMgAi0AFDoAQCAAIAJBFmo2AgAgAyACLQAVOgBBIAAgAkEXajYCACADIAItABY6AEIgACACQRhqNgIAIAMgAi0AFzoAQyAAIAJBGWo2AgAgAyACLQAYOgBEIAAgAkEaajYCACADIAItABk6AEUgACACQRtqNgIAIAMgAi0AGjoARiAAIAJBHGo2AgAgAyACLQAbOgBHIAAgAkEdajYCACADIAItABw6AEggACACQR5qNgIAIAMgAi0AHToASSAAIAJBH2o2AgAgAyACLQAeOgBKIAAgATYCACADIAItAB86AEsLIA9FDQAgDxArCyAKQSBqJAAgAwuPAQAgAEEAOgB0IABBADYCcCAAQbzNMTYCACAAQeqSmL8GNgIIIABBu88BOwAMIABCrovy8bbe3NLPADcADiAAQfX1xPIANgAWIABC0v7trICN44+DfzcAGiAAQdnXAjsAIiAAQtvAt84BNwAkIABBADYALCAAQQA2AnggACAAQQhqNgIEIAAgASACENkKIAAL2AcDBX8SfgF7IwBBwAFrIgMkACAAIAH9AANo/QsDACAAIAH9AAN4/QsDEAJAAkACQEIAIAEpAxggASkDECABKQMIhIQiEEIAUiABKQMAIhFCClZyrVIEQCAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDsAEgA0IANwOoASADQgo3A6ABIAEgA0GgAWogAUFAayIGEKQJAkACQCACLQAAIgRBMEcEfyACBSACLQABQSByQfgARwRAIAIhBUEwIQQMAgsgDyAQQgBSIBFCEFZyrVENBCADQgA3A4gBIANBkAFqIgQgGv0LAwAgA0IQNwOAASABIANBgAFqIAYQpAkgAyAE/QADAP0LA7ABIAMgA/0AA4AB/QsDoAEgAi0AAiEEIAJBAmoLIQUgBEH/AXFFDQELIAEpAzghEiABKQMwIRMgASkDKCEUIAEpAyAhFSADQYgBaiICQRBqIQcDQCAPIBBCAFIgEQJ+QtD///8PIARBMGtB/wFxQQpJDQAaQqn///8PIARB4QBrQf8BcUEGSQ0AGiAEQcEAa0H/AXFBBk8NBULJ////DwsgBK3CfEL/////D4MiClZyrVENBSADIAo3A4ABIAdCADcDACACIBr9CwMAIAEgA0GAAWogBhCkCSABIAAgA0GgAWoQpAkgACASIAApAxgiFyADKQOYAXwiCiAAKQMQIgggAykDkAF8IgkgCFQgCSAAKQMIIgsgAykDiAF8IgggC1QgCCAAKQMAIgwgAykDgAF8IgsgDFStfCIMIAhUcq18IgggCVRyrXwiCXwiFiAIIBN8Ig0gE1QgDSAMIBR8Ig4gFFQgDiALIBV8IhggFVStfCIZIA5Ucq18Ig4gDVRyrXwiDSAJIAogF1QgCSAKVHIgDSAWVCASIBZWcnMiBBs3AxggACAOIAggBBs3AxAgACAZIAwgBBs3AwggACAYIAsgBBs3AwAgBS0AASEEIAVBAWohBSAEDQALCyADQcABaiQADwsgA0GAxio2AhBB5ABB9IcqIANBEGoQmwlBkJY0KAIAKAIAIQAgA0GAxio2AgAgAEGRjCogAxBsAAsgA0GAxio2AnBB5ABB9IcqIANB8ABqEJsJQZCWNCgCACgCACEAIANBgMYqNgJgIABBkYwqIANB4ABqEGwACyADQYr/KzYCUEHkAEH0hyogA0HQAGoQmwlBkJY0KAIAKAIAIQAgA0GK/ys2AkAgAEGRjCogA0FAaxBsAAsgA0GAxio2AjBB5ABB9IcqIANBMGoQmwlBkJY0KAIAKAIAIQAgA0GAxio2AiAgAEGRjCogA0EgahBsAAu1CAIHfwF7IAAgATYCACABKAIQIQUgAEEANgIMIABCADcCBAJAAkACQAJAIAVFBEAgAEEQaiABKAIUIAEoAhhrQQAQ2goMAQsgBUHm4ChPDQEgACAFQaAybCIDEJ4JIgQ2AgQgACADIARqNgIMIANBoDJrIgMgA0GgMnBrQaAyaiIDBEAgBEEAIAP8CwALIAAgAyAEajYCCCABKAIgIQRBACEDIAVBBU8EQCAFIAVBA3EiAkEEIAIbayECA0AgCSAEIANBA3JBDGxqQQRqIAQgA0ECckEMbGpBBGogBCADQQFyQQxsakEEaiAEIANBDGxq/VwCBP1WAgAB/VYCAAL9VgIAA0EC/asB/a4B/QwDAAAAAwAAAAMAAAADAAAA/a4BIQkgA0EEaiIDIAJHDQALIAkgCSAJ/Q0ICQoLDA0ODwABAgMAAQID/a4BIgkgCSAJ/Q0EBQYHAAECAwABAgMAAQID/a4B/RsAIQMLIAEoAhghByABKAIUIQEDQCADIAQgAkEMbGooAgRBAnRqQQNqIQMgAkEBaiICIAVHDQALIABBEGogAyABIAdraiAFENoKCyAAQQA2AqQBIABCADcCnAEgACAAKAIkIgI2AoABIAAgACgCKCIENgKEASAAIAAoAjAiBTYCiAEgACAAKAIgNgKMASAAIAAoAkQiBzYCkAEgACAAKAIcIgM2ApQBIAAgACgCSDYCmAEgAgRAIAJBgICAgAFPDQIgACACQQR0IgEQngkiBjYCnAEgACABIAZqIgg2AqQBIAEEQCAGQQAgAfwLAAsgACAINgKgAQsgAEEANgKwASAAQgA3AqgBIAQEQCAEQYCAgIABTw0CIAAgBEEEdCIBEJ4JIgY2AqgBIAAgASAGaiIINgKwASABBEAgBkEAIAH8CwALIAAgCDYCrAELIABBADYCvAEgAEIANwK0ASAFBEAgBUGAgICAAU8NAiAAIAVBBHQiBRCeCSIBNgK0ASAAIAEgBWoiBjYCvAEgBQRAIAFBACAF/AsACyAAIAY2ArgBCyAAQQA2AsgBIABCADcCwAEgAiAERwRAIAQgAmsiAkGAgICAAU8NAiAAIAJBBHQiAhCeCSIENgLAASAAIAIgBGoiBTYCyAEgAgRAIARBACAC/AsACyAAIAU2AsQBCyAAQQA2AtQBIABCADcCzAEgAyAHbCICBEAgAkGAgICAAU8NAiAAIAJBBHQiAhCeCSIENgLMASAAIAIgBGoiBTYC1AEgAgRAIARBACAC/AsACyAAIAU2AtABCyAAQQA2AuABIABCADcC2AEgAwRAIANBgICAwABPDQMgACADQQV0IgIQogkiBDYC2AEgACACIARqIgM2AuABIAIEQCAEQQAgAvwLAAsgACADNgLcAQsgAEEANgLsASAAQgA3AuQBIAAPCxCgCQALEKAJAAsQoAkAC7kIAgd/AXsgACABNgIAIAEoAhAhBSAAQQA2AgwgAEIANwIEAkACQAJAAkAgBUUEQCAAQRBqIAEoAhQgASgCGGtBABDbCgwBCyAFQbOwFE8NASAAIAVBwOQAbCIDEKIJIgQ2AgQgACADIARqNgIMIANBwOQAayIDIANBwOQAcGtBwOQAaiIDBEAgBEEAIAP8CwALIAAgAyAEajYCCCABKAIgIQRBACEDIAVBBU8EQCAFIAVBA3EiAkEEIAIbayECA0AgCSAEIANBA3JBDGxqQQRqIAQgA0ECckEMbGpBBGogBCADQQFyQQxsakEEaiAEIANBDGxq/VwCBP1WAgAB/VYCAAL9VgIAA0EC/asB/a4B/QwDAAAAAwAAAAMAAAADAAAA/a4BIQkgA0EEaiIDIAJHDQALIAkgCSAJ/Q0ICQoLDA0ODwABAgMAAQID/a4BIgkgCSAJ/Q0EBQYHAAECAwABAgMAAQID/a4B/RsAIQMLIAEoAhghByABKAIUIQEDQCADIAQgAkEMbGooAgRBAnRqQQNqIQMgAkEBaiICIAVHDQALIABBEGogAyABIAdraiAFENsKCyAAQQA2AqQBIABCADcCnAEgACAAKAIkIgI2AoABIAAgACgCKCIENgKEASAAIAAoAjAiBTYCiAEgACAAKAIgNgKMASAAIAAoAkQiBzYCkAEgACAAKAIcIgM2ApQBIAAgACgCSDYCmAEgAgRAIAJBgICAwABPDQIgACACQQV0IgEQogkiBjYCnAEgACABIAZqIgg2AqQBIAEEQCAGQQAgAfwLAAsgACAINgKgAQsgAEEANgKwASAAQgA3AqgBIAQEQCAEQYCAgMAATw0CIAAgBEEFdCIBEKIJIgY2AqgBIAAgASAGaiIINgKwASABBEAgBkEAIAH8CwALIAAgCDYCrAELIABBADYCvAEgAEIANwK0ASAFBEAgBUGAgIDAAE8NAiAAIAVBBXQiBRCiCSIBNgK0ASAAIAEgBWoiBjYCvAEgBQRAIAFBACAF/AsACyAAIAY2ArgBCyAAQQA2AsgBIABCADcCwAEgAiAERwRAIAQgAmsiAkGAgIDAAE8NAiAAIAJBBXQiAhCiCSIENgLAASAAIAIgBGoiBTYCyAEgAgRAIARBACAC/AsACyAAIAU2AsQBCyAAQQA2AtQBIABCADcCzAEgAyAHbCICBEAgAkGAgIDAAE8NAiAAIAJBBXQiAhCiCSIENgLMASAAIAIgBGoiBTYC1AEgAgRAIARBACAC/AsACyAAIAU2AtABCyAAQQA2AuABIABCADcC2AEgAwRAIANBgICAwABPDQMgACADQQV0IgIQogkiBDYC2AEgACACIARqIgM2AuABIAIEQCAEQQAgAvwLAAsgACADNgLcAQsgAEEANgLsASAAQgA3AuQBIAAPCxCgCQALEKAJAAsQoAkAC7IBAQN/IwBBEGsiAyQAIANBADoAByAAKAJ4IQQgAEEANgJ4IAQEQCAEECsLIABBBGoiBCADQQdqQQEQqgkgA0EANgAMIAMgAjoACCADIAJBGHY6AAsgAyACQRB2OgAKIAMgAkEIdjoACSAAKAJ4IQUgAEEANgJ4IAUEQCAFECsLIAQgA0EIakEIEKoJIAAoAnghBSAAQQA2AnggBQRAIAUQKwsgBCABIAIQqgkgA0EQaiQAC8ACAQN/IwBBQGoiAyQAIABBgAE2AiAgAEKEgICAgBA3AgggACACNgIEIAAgATYCAEF/IQFBASECQQEhBQNAIAAgAhCXCyIEIAEgASAESyIEGyEBIAIgBSAEGyEFIAJBgYCAwABJIQQgAkEBdCECIAQNAAsgACAFEJcLGgJAIAAoAhAgACgCFEsEQCAA/QwAAAAAAQAAAAIAAAADAAAA/QsCPCAAIAAoAihBA2oiAjYCTCAAKAI0IAAoAixBA2wgAmpHDQEgA0FAayQADwsgA0Hv1Co2AjBB5ABB9IcqIANBMGoQmwlBkJY0KAIAKAIAIQIgA0Hv1Co2AiAgAkGRjCogA0EgahBsAAsgA0G7gio2AhBB5ABB9IcqIANBEGoQmwlBkJY0KAIAKAIAIQIgA0G7gio2AgAgAkGRjCogAxBsAAvAAgEDfyMAQUBqIgMkACAAQYABNgIgIABChICAgIAQNwIIIAAgAjYCBCAAIAE2AgBBfyEBQQEhAkEBIQUDQCAAIAIQlgsiBCABIAEgBEsiBBshASACIAUgBBshBSACQYGAgMAASSEEIAJBAXQhAiAEDQALIAAgBRCWCxoCQCAAKAIQIAAoAhRLBEAgAP0MAAAAAAEAAAACAAAAAwAAAP0LAjwgACAAKAIoQQNqIgI2AkwgACgCNCAAKAIsQQNsIAJqRw0BIANBQGskAA8LIANB79QqNgIwQeQAQfSHKiADQTBqEJsJQZCWNCgCACgCACECIANB79QqNgIgIAJBkYwqIANBIGoQbAALIANBu4IqNgIQQeQAQfSHKiADQRBqEJsJQZCWNCgCACgCACECIANBu4IqNgIAIAJBkYwqIAMQbAALygEBA38gAEEANgIQIABCADcCCCAAIAE2AgQgACABNgIAAkACQCABQQF0IgIEQCACQYCAgMAATw0BIAAgAUEGdCIDEKIJIgQ2AgggACAEIAJBBXRqNgIQIAMEQCAEQQAgA/wLAAsgACADIARqNgIMCyAAQQA2AhwgAEIANwIUIAEEQCABQYCAgMAATw0CIAAgAUEFdCIBEKIJIgI2AhQgACABIAJqIgM2AhwgAQRAIAJBACAB/AsACyAAIAM2AhgLDwsQoAkACxCgCQALxggDFH8Eewd+IAAgATYCACAAQRBqIgRBAEGAIPwLACAAIAH9AAQw/QsEECAAIAH9AARA/QsEICAAIAH9AARQ/QsEMCAAIAH9AARg/QsEQCAAIAH9AARw/QsEUCAAIAH9AASAAf0LBGAgACAB/QAEkAH9CwRwIAAgAf0ABKAB/QsEgAEgACAB/QAEsAH9CwSQASAAIAH9AATAAf0LBKABIAAgAf0ABNAB/QsEsAEgACAB/QAE4AH9CwTAASAAIAH9AATwAf0LBNABIAAgAf0ABIAC/QsE4AEgACAB/QAEkAL9CwTwASAAIAH9AASgAv0LBIACIABBgAJqIQYgAEHwAWohByAAQeABaiEIIABB0AFqIQkgAEHAAWohCiAAQbABaiELIABBoAFqIQwgAEGQAWohDSAAQYABaiEOIABB8ABqIQ8gAEHgAGohECAAQdAAaiERIABBQGshEiAAQTBqIRMgAEEgaiEUQQEhAANAIAIhAyAAIQIgBCADQQh0aiIFIANBBHRqIRVBACEDA0AgA0EEdCIAIAQgAkEIdGpqIAAgBWr9AAQAIhcgFyAV/QAEAP1REJoJ/QsEACADQQFqIgNBEEcNAAsgAkEBaiIAQRBHDQALQQAhAANAAkAgBCAAQQh0IgNqIgIgAEEEdGoiBSkDACIcIAUpAwgiGoRQBED9DAAAAAAAAAAAAAAAAAAAAAAhFgwBCyAB/QAEICEZIAEpAyAhHSABKQMoIRsgAf0ABAAhF/0MAAAAAAAAAAAAAAAAAAAAACEYA0AgGkI/hiAcQgGIhCEeIBpCAYghGgJAIBxCAYNQBEAgHiEcIBghFgwBCwJ+IBogG1oEQCAdIR8gGCEWIBsgGiAbVg0BGiAbIB0gHlgNARoLIB4hHyAXIRYgGgshICAYIBf9USEXIBogG4UhGiAdIB6FIRwgFiEYIB8hHSAgIRsLIBcgGRCaCSEXIBogHIRCAFINAAsLIAIgFiAC/QAEABCaCf0LBAAgAyAUaiICIBYgAv0ABAAQmgn9CwQAIAMgE2oiAiAWIAL9AAQAEJoJ/QsEACADIBJqIgIgFiAC/QAEABCaCf0LBAAgAyARaiICIBYgAv0ABAAQmgn9CwQAIAMgEGoiAiAWIAL9AAQAEJoJ/QsEACADIA9qIgIgFiAC/QAEABCaCf0LBAAgAyAOaiICIBYgAv0ABAAQmgn9CwQAIAMgDWoiAiAWIAL9AAQAEJoJ/QsEACADIAxqIgIgFiAC/QAEABCaCf0LBAAgAyALaiICIBYgAv0ABAAQmgn9CwQAIAMgCmoiAiAWIAL9AAQAEJoJ/QsEACADIAlqIgIgFiAC/QAEABCaCf0LBAAgAyAIaiICIBYgAv0ABAAQmgn9CwQAIAMgB2oiAiAWIAL9AAQAEJoJ/QsEACADIAZqIgMgFiAD/QAEABCaCf0LBAAgAEEBaiIAQRBHDQALC7gEAQx/IwBBIGsiCCQAQQEhBAJAAkAgACgCBCICQQJPBEADQCAHQQFqIQcgBEEBdCIEIAJJDQALIARBgICAgAFPDQELIARBBHQiCRCeCSEFIAlFIgxFBEAgBUEAIAn8CwALAkAgAkUNACACQQR0IgNFDQAgBSABIAP8CgAACwJAIAIgBE8NACAEIAJrQQR0IgNFDQAgBSACQQR0akEAIAP8CwALIAdBEU8NASAAQRBqIgogB0EAIAIgBRCNCyAAKAIEIgIgBCAAKAIIIgYgBCAGSRtJBEADQCABIAJBBHQiA2ogAyAFav0ABAD9CwQAIAJBAWoiAiAEIAAoAggiBiAEIAZJG0kNAAsgACgCBCECCwJAIAIgBE8NACAEIAJrQQR0IgNFDQAgBSACQQR0akEAIAP8CwALQQEhCyAGQQEgB3QiA0sEQANAAkAgBiADIARqTwRAIAEgA0EEdGohAiAMRQRAIAIgBSAJ/AoAAAsgCiAHIAMgAhCOCyAAKAIIIQYMAQsgCiAHIAMgBRCOCyADIAAoAggiBk8NACADQQFqIQ1BACECA0AgASADQQR0aiAFIAJBBHRq/QAEAP0LBAAgAiANaiEDIAJBAWohAiADIAAoAggiBkkNAAsLIAtBAWoiCyAHdCIDIAZJDQALCyAFECsgCEEgaiQADwsQoAkACyAIQZzxKTYCEEHkAEH0hyogCEEQahCbCUGQljQoAgAoAgAhAiAIQZzxKTYCACACQZGMKiAIEGwAC8gLAQZ/IwBBsAFrIgQkAAJAIAEoAgBFDQAgBEHoAGohCSAEQUBrIQgCQANAAkAgBEEAOgCsASAEQQA2AqgBIARB6pKYvwY2AkAgBCAINgI8IAhBrgE6AAYgCEG7zwE7AAQgBCgCPCIFQe4AOgAJIAVBhfkAOwAHIAQoAjwiBUGlAToADCAFQfPlATsACiAEKAI8IgVBOjoADyAFQc/qAzsADSAEKAI8IgVB0gA6ABIgBUHRHDsAECAEKAI8IgVBBToAFSAFQf+2AjsAEyAEKAI8IgVBHzoAGCAFQeiYAjsAFiAEKAI8IgVBqwE6ABsgBUGDswM7ABkgBCgCPCIFQc0BOgAeIAVB28ADOwAcIAQoAjwiBUIANwAgIAVBGToAHyADIAdBBXQiBSABKAIUakEgIAMoAgAoAggRAQAgBEE8aiABKAIUIAVqQSAQqgkgBCAHNgIcIAIoAhAiBkUNACAGIARBHGogBEE8aiAGKAIAKAIYEQEAIARBHGogBEE8aiAJAn8gBC0ArAFFBEAgBCgCqAEMAQsgBEHqkpi/BjYCQCAEIAg2AjwgCEGuAToABiAIQbvPATsABCAEKAI8IgZB7gA6AAkgBkGF+QA7AAcgBCgCPCIGQaUBOgAMIAZB8+UBOwAKIAQoAjwiBkE6OgAPIAZBz+oDOwANIAQoAjwiBkHSADoAEiAGQdEcOwAQIAQoAjwiBkEFOgAVIAZB/7YCOwATIAQoAjwiBkEfOgAYIAZB6JgCOwAWIAQoAjwiBkGrAToAGyAGQYOzAzsAGSAEKAI8IgZBzQE6AB4gBkHbwAM7ABwgBCgCPCIGQgA3ACAgBkEZOgAfIARBADoArAEgBEEANgKoAUEACxCrCSAEQQE6AKwBIARBADYCqAEgByABKAIEIgZPDQIgASgCCCAFaiAGQQV0aiIFIAT9AAAc/QsAACAFIAT9AAAs/QsAECAHQQFqIgcgASgCAEkNAQwDCwsQoAkACyAEQeagKzYCEEHkAEH0hyogBEEQahCbCUGQljQoAgAoAgAhASAEQeagKzYCACABQZGMKiAEEGwACyABKAIEIghBAk8EQCAEQegAaiEDIARBQGshBwNAIAEoAgghBSAEQQA6AKwBIARBADYCqAEgBEHqkpi/BjYCQCAEIAc2AjwgB0GuAToABiAHQbvPATsABCAEKAI8IgZB7gA6AAkgBkGF+QA7AAcgBCgCPCIGQaUBOgAMIAZB8+UBOwAKIAQoAjwiBkE6OgAPIAZBz+oDOwANIAQoAjwiBkHSADoAEiAGQdEcOwAQIAQoAjwiBkEFOgAVIAZB/7YCOwATIAQoAjwiBkEfOgAYIAZB6JgCOwAWIAQoAjwiBkGrAToAGyAGQYOzAzsAGSAEKAI8IgZBzQE6AB4gBkHbwAM7ABwgBCgCPEEZOgAfIAQoAjxCADcAICAEQTxqIAUgCEEBayIIQQZ0aiIFQSAQqgkgBEE8aiAFQSBqQSAQqgkgBEEcaiAEQTxqIAMCfyAELQCsAUUEQCAEKAKoAQwBCyAEQeqSmL8GNgJAIAQgBzYCPCAHQa4BOgAGIAdBu88BOwAEIAQoAjwiBUHuADoACSAFQYX5ADsAByAEKAI8IgVBpQE6AAwgBUHz5QE7AAogBCgCPCIFQTo6AA8gBUHP6gM7AA0gBCgCPCIFQdIAOgASIAVB0Rw7ABAgBCgCPCIFQQU6ABUgBUH/tgI7ABMgBCgCPCIFQR86ABggBUHomAI7ABYgBCgCPCIFQasBOgAbIAVBg7MDOwAZIAQoAjwiBUHNAToAHiAFQdvAAzsAHCAEKAI8IgVCADcAICAFQRk6AB8gBEEAOgCsASAEQQA2AqgBQQALEKsJIAEoAgggCEEFdGoiBSAE/QAAHP0LAAAgBSAE/QAALP0LABAgCEEBSw0ACwsgACABKAIIIgH9AAAg/QsAACAAIAH9AAAw/QsAECAEQbABaiQAC+kcAwx/E34EeyMAQaACayIFJAAgACACNgIIIAAgAzYCACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsCDCAAIAFBAWs2AgQCQAJAAkACQAJAIAIgAWtBAWoiBgRAIAZBgICAwABPDQEgACAGQQV0IgYQogkiCjYCECAAIAYgCmoiBzYCGCAGBEAgCkEAIAb8CwALIAAgBzYCFAsgAEEANgIkIABCADcCHCABBEAgAUGAgIDAAE8NASAAIAFBBXQiBhCiCSIKNgIcIAAgBiAKaiIHNgIkIAYEQCAKQQAgBvwLAAsgACAHNgIgCyACQYCAgMAATw0AIAJBBXQiBhCiCSEKIAZBIGsiBgRAIApBIGpBACAG/AsACyAKIANB+ABqIgb9AAMA/QsDECAKIAP9AANo/QsDACAFQZACaiIIIAP9AAOYAf0LBAAgBSAD/QADiAH9CwSAAiAFIAb9AAMA/QsD8AEgBSAD/QADaP0LA+ABAkAgAkEBRgRAIAMpA6ABIR4gAykDmAEhHyADKQOQASEgIAMpA4gBISEgBSkD+AEhGCAFKQPwASERIAUpA+gBIRIgBSkD4AEhEwwBCyADKQM4IRkgAykDMCEaIAMpAyghHCADKQMgIR0gAykDoAEhHiADKQOYASEfIAMpA5ABISAgAykDiAEhISAFKQP4ASEYIAUpA/ABIREgBSkD6AEhEiAFKQPgASETQQEhBwNAIAUgGSAYIB58IhsgESAffCIUIBFUIBQgEiAgfCIRIBJUIBEgEyAhfCIXIBNUrXwiEiARVHKtfCIRIBRUcq18IhN8IhQgESAafCIVIBpUIBUgEiAcfCIWIBxUIBYgFyAdfCIiIB1UrXwiIyAWVHKtfCIWIBVUcq18IhUgEyATIBtUIBggG1ZyIBQgGVQgFCAVVnJzIgYbIhg3A/gBIAUgFiARIAYbIhE3A/ABIAUgIyASIAYbIhI3A+gBIAUgIiAXIAYbIhM3A+ABIAogB0EFdGoiBiAI/QAEAP0LAxAgBiAF/QAEgAL9CwMAIAMgBUGAAmogBUHgAWoQpAkgB0EBaiIHIAJHDQALCyAFQYACaiADIAX9AASAAiAF/QAEkAIQxAkgAykDGCEcIAMpAxAhHSADKQMIISIgAykDACEjIAIhBwNAIAMgCiAHQQFrIgdBBXRqIAVBgAJqEKQJIAMgBUGAAmogBUHgAWoQpAkgBSAYIB59IhcgESAffSIVIBFWIBUgEiAgfSIRIBJWIBEgEyAhfSIUIBNWrX0iEiARVnKtfSIRIBVWcq19IhMgESAdfCIVIBFUIBUgEiAifCIWIBJUIBYgFCAjfCIZIBRUrXwiGiAWVHKtfCIWIBVUcq0gEyAcfHwgFyAYViATIBdWcq1QIgYbIhg3A/gBIAUgESAWIAYbIhE3A/ABIAUgEiAaIAYbIhI3A+gBIAUgFCAZIAYbIhM3A+ABIAcNAAsgBCgCACEHIAQoAgQhD0HoABCiCSEJIAQpA0ghGCAE/QADGCEkIAT9AAMoISUgBP0AAzghJiAE/QADCCEnIAkgAjYCVCAJIAE2AlAgCSAYNwNIIAkgDzYCBCAJIAc2AgAgCSAm/QsDOCAJICX9CwMoIAkgJP0LAxggCSAn/QsDCEEBIQYDQCAGIgRBAXQhBiACIARLDQALIAlBADYCZCAJQgA3AlwgCSAENgJYIARBgICAwABPDQAgB0HoAGohByAJIARBBXQiBhCiCSIINgJcIAkgBiAIaiINNgJkIARBAWtB////P3EhDiAIIQYgBEEDcSILBEADQCAGIAf9AAMA/QsDACAGIAf9AAMQ/QsDECAGQSBqIQYgDEEBaiIMIAtHDQALCyAOQQNPBEADQCAGIAf9AAMA/QsDACAGIAdBEGoiDP0AAwD9CwMQIAYgDP0AAwD9CwMwIAYgB/0AAwD9CwMgIAYgB/0AAwD9CwNAIAYgDP0AAwD9CwNQIAYgB/0AAwD9CwNgIAYgDP0AAwD9CwNwIAZBgAFqIgYgDUcNAAsLIAkgDTYCYCACQQNxIQ5BACEMQQAhBiACQQRPBEAgAkH8//8/cSEQA0AgCCAGQQV0IgdqIgsgByAKaiIN/QADAP0LAwAgCyAN/QADEP0LAxAgCCAHQSByIgtqIg0gCiALaiIL/QADEP0LAxAgDSAL/QADAP0LAwAgCCAHQcAAciILaiINIAogC2oiC/0AAxD9CwMQIA0gC/0AAwD9CwMAIAggB0HgAHIiB2oiCyAHIApqIgf9AAMQ/QsDECALIAf9AAMA/QsDACAGQQRqIgYgEEcNAAsLIA4EQANAIAggBkEFdCIHaiILIAcgCmoiB/0AAwD9CwMAIAsgB/0AAxD9CwMQIAZBAWohBiAMQQFqIgwgDkcNAAsLIAggBCAJQQhqIBggDxCHCyAJKAJYIgitIhEgCSgCACIHKQMAVCAHKQMYIAcpAxAgBykDCISEQgBScq1QDQEgCSgCXCEEIAVB8AFqIgb9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAVCADcD6AEgBSARNwPgASAHIAVB4AFqIAdBQGsQpAkgBUGAAmogByAF/QAE4AEgBv0ABAAQxAkgCARAQQAhBgNAIAcgBCAGQQV0aiAFQYACahCkCSAGQQFqIgYgCEcNAAsLIABBDGoiBCgCACEGIAQgCTYCACAGBEAgBigCXCIHBEAgBiAHNgJgIAcQKwsgBhArCyAAKAIQIgYgA/0AA4gB/QsDACAGIANBmAFqIgb9AAMA/QsDECAAKAIcIgcgA/0AA4gB/QsDACAHIAb9AAMA/QsDECACIAAoAgQiBkEBaiIISwRAIANBQGshCyAFQagBaiEEQQEhBwNAIAMpAxggAykDECADKQMIhIRCAFIgCK0iESADKQMAVHKtUA0EIAAoAhAhCCAFIBE3A6ABIARCADcDECAE/QwAAAAAAAAAAAAAAAAAAAAA/QsDACADIAVBoAFqIAsQpAkgBUGQAmoiBiAF/QADsAH9CwMAIAUgBf0AA6AB/QsDgAIgAyAFQYACaiAKIAdBBXQiDGoQpAkgBSAG/QADAP0LA9ABIAUgBf0AA4AC/QsDwAEgBiAIIAxqIghBIGsiDP0AAxD9CwMAIAUgDP0AAwD9CwOAAiADIAVBgAJqIAVBwAFqEKQJIAUgBv0AAwAiJP0LA/ABIAUgBf0AA4ACIiX9CwPgASAIICT9CwMQIAggJf0LAwAgACgCBCIGIAdBAWoiB2oiCCACSQ0ACwsgAiAGSwRAIANBQGshBCAFQYgCaiIMQRBqIQsDQCADKQMYIAMpAxAgAykDCISEQgBSIAYgACgCBGsiB60iESADKQMAVHKtUA0FIAAoAhAhCCAFIBE3A4ACIAtCADcDACAM/QwAAAAAAAAAAAAAAAAAAAAA/QsDACADIAVBgAJqIAQQpAkgAyAIIAdBBXRqIAVBgAJqEKQJIAAoAgQiB0EBcQRAIAAoAhAgBiAHa0EFdGoiByADKQOAASIWIAcpAxh9IhsgAykDeCIRIAcpAxB9IhQgEVYgFCADKQNwIhEgBykDCH0iEyARViATIAMpA2giEiAHKQMAfSIRIBJWrX0iEiATVnKtfSITIBRWcq19IhQgEyADKQMQfCIXIBNUIBcgEiADKQMIfCIVIBJUIBUgESADKQMAfCIZIBFUrXwiGiAVVHKtfCIVIBdUcq0gFCADKQMYfHwgFiAbVCAUIBtWcq1QIggbNwMYIAcgEyAVIAgbNwMQIAcgEiAaIAgbNwMIIAcgESAZIAgbNwMACyAGQQFqIgYgAkcNAAsLIAFBAk8EQCADQUBrIQQgAa0hEiAFQYgBaiECQgEhEQNAIAMpAxggAykDECADKQMIhIRCAFIgEiARfSITIAMpAwBUcq1QDQYgACgCHCEHIAUgEzcDgAEgAkIANwMQIAL9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAMgBUGAAWogBBCkCSAFQZACaiIGIAX9AAOQAf0LAwAgBSAF/QADgAH9CwOAAiADIAVBgAJqIAogEadBBXQiCGoQpAkgBSAG/QADAP0LA9ABIAUgBf0AA4AC/QsDwAEgBiAHIAhqIgdBIGsiCP0AAxD9CwMAIAUgCP0AAwD9CwOAAiADIAVBgAJqIAVBwAFqEKQJIAUgBv0AAwAiJP0LA/ABIAUgBf0AA4ACIiX9CwPgASAHICT9CwMQIAcgJf0LAwAgEUIBfCIRIBJSDQALQQEhAgNAIAAoAhwgAkEFdGoiBiADKQOAASIWIAYpAxh9IhsgAykDeCIRIAYpAxB9IhQgEVYgFCADKQNwIhEgBikDCH0iEyARViATIAMpA2giEiAGKQMAfSIRIBJWrX0iEiATVnKtfSITIBRWcq19IhQgEyADKQMQfCIXIBNUIBcgEiADKQMIfCIVIBJUIBUgESADKQMAfCIZIBFUrXwiGiAVVHKtfCIVIBdUcq0gFCADKQMYfHwgFiAbVCAUIBtWcq1QIgcbNwMYIAYgEyAVIAcbNwMQIAYgEiAaIAcbNwMIIAYgESAZIAcbNwMAIAJBAmoiAiABSQ0ACwsgChArIAVBoAJqJAAgAA8LEKAJAAsgBUGAxio2AhBB5ABB9IcqIAVBEGoQmwlBkJY0KAIAKAIAIQMgBUGAxio2AgAgA0GRjCogBRBsAAsgBUGAxio2AjBB5ABB9IcqIAVBMGoQmwlBkJY0KAIAKAIAIQMgBUGAxio2AiAgA0GRjCogBUEgahBsAAsgBUGAxio2AlBB5ABB9IcqIAVB0ABqEJsJQZCWNCgCACgCACEDIAVBgMYqNgJAIANBkYwqIAVBQGsQbAALIAVBgMYqNgJwQeQAQfSHKiAFQfAAahCbCUGQljQoAgAoAgAhAyAFQYDGKjYCYCADQZGMKiAFQeAAahBsAAu3AgIHfwR+IwBB4ABrIgUkACACBEAgBEFAayEJIAVBQGtBAXIhBgNAIAMgBUEgakEgIAMoAgAoAggRAQAgBSkDOCIPIAQpAxgiDFQgDCAPUSAFKQMwIgwgBCkDECINVCAMIA1RIAUpAygiDSAEKQMIIg5UIA0gDlEgBSkDICIOIAQpAwBUcXJxcnFyrVANACAFIA83A1ggBSAMNwNQIAUgDTcDSCAFIA43A0AgBCAFQUBrIAkQpAkgBUEIaiIKIAb9AAAI/QsDACAFQRdqIgsgBikAFzcAACAFIAYpAAA3AwAgACgCcCAAKAIQIAFsQQV0aiAHQQV0aiIIIAUtAEA6AAAgCCAFKQMANwABIAggCv0AAwD9CwAJIAggCykAADcAGCAHQQFqIgcgAkcNAAsLIAVB4ABqJAALzxoDGX8bfgJ7IwBBoAFrIgQkACAAKAIAIRUCQAJAAkAgACgCBCIHQQFqIg4EQCAOQYCAgMAATw0BIA5BBXQiAxCiCSEQIAMEQCAQQQAgA/wLAAsgACgCHCEKA0AgBEHQAGoiBSAKIAJBBXQiA2oiBv0AAxD9CwMAIAQgBv0AAwD9CwNAIBUgBEFAayABIANqEKQJIAQgBf0AAwAiNv0LAxAgBCAE/QADQCI3/QsDACADIBBqIgMgNv0LAxAgAyA3/QsDACACIAdGIQMgAkEBaiECIANFDQALCwJAIAAoAggiAkUNACACQYCAgMAATw0BIAJBBXQiAhCiCSERIAJFDQAgEUEAIAL8CwALAkAgACgCDCIIKAJYIgdFDQAgB0GAgIDAAE8NASAIKAIAQegAaiEDIAdBAWtB////P3EhCiAHQQV0IgkQogkiCyECIAdBA3EiBgRAQQAhBQNAIAIgA/0AAwD9CwMAIAIgA/0AAxD9CwMQIAJBIGohAiAFQQFqIgUgBkcNAAsLIApBA0kNACAJIAtqIQYDQCACIAP9AAMA/QsDACACIANBEGoiBf0AAwD9CwMQIAIgBf0AAwD9CwMwIAIgA/0AAwD9CwMgIAIgA/0AAwD9CwNAIAIgBf0AAwD9CwNQIAIgA/0AAwD9CwNgIAIgBf0AAwD9CwNwIAJBgAFqIgIgBkcNAAsLAkAgCCgCUCICRQ0AIAJBBXQiAkUNACALIBAgAvwKAAALIAsgByAIQQhqIgkgCCkDSCAIKAIEEIcLIAgoAgAgCyAIKAJcEKQJQQEhAiAIKAJYIgNBA08EQANAIAsgAkEFdCIFaiIGIAsgAyACa0EFdCIDaiIHIAYgByAIKAJcIgogBWogAyAKaiAIKAIAEIgLIAgoAlgiAyACQQFqIgJBAXRLDQALCyAIKAIAIAsgAkEFdCICaiAIKAJcIAJqEKQJIAgpA0ghHSAIKAJYIQwgCSAIKAIEIgYQiQsgDEECSQ0CIAYoAgAhAiAEIAn9AAMw/QsDMCAEIAn9AAMg/QsDICAEIAn9AAMQ/QsDECAEIAn9AAMA/QsDACAMrSIlIB1UBEADQCAGIAQgBBCKCyAlQgGGIiUgHVQNAAsLIAxBgICAwABJBEBBACEFIAxBBXRBQHEiAxCiCSEPIAMEQCAPQQAgA/wLAAsgBEHwAGoiByAG/QADmAH9CwMAIARB4ABqIgogBv0AA4gB/QsDACAEQdAAaiIJIAb9AAN4/QsDACAEIAb9AANo/QsDQANAIA8gBUEGdGoiAyAE/QADQP0LAwAgAyAH/QADAP0LAzAgAyAK/QADAP0LAyAgAyAJ/QADAP0LAxAgBiAEQUBrIAQQigsgBUEBaiIFQQF0IAxJDQALIAxBA0sEQCAMIQ0DQEEEIA0iFEEBdiINIA1BBE0bQQNrQQF2QQJqIRYgDCAUQf7//z9xIhhuIRdBACESIBRBBkkhGQNAIAsgEkEFdGoiEyANIAIQiwtBASEGIBlFBEAgDSASaiEaA0AgEyAGQQV0aiIDIA1BBXQiCmoiBykDGCEpIAsgGiAGa0EFdGoiBSAKaiIKKQMYISUgBykDECEuIAopAxAhHSAHKQMAIS8gCikDACEgIAcpAwghMCAKKQMIIR8gAyACKQM4Ii0gAykDGCIhIAUpAxgiMXwiGyADKQMQIhwgBSkDECIyfCIiIBxUICIgAykDCCIkIAUpAwgiM3wiHiAkVCAeIAMpAwAiIyAFKQMAIjR8IiYgI1StfCInIB5Ucq18Ih4gIlRyrXwiInwiKyACKQMwIiggHnwiKiAoVCAqIAIpAygiLCAnfCIoICxUICggAikDICIsICZ8IjUgLFStfCIsIChUcq18IiggKlRyrXwiKiAiIBsgIVQgGyAiVnIgKyAtVCAqICtUcnMiCRs3AxggAyAoIB4gCRs3AxAgAyAsICcgCRs3AwggAyA1ICYgCRs3AwAgAikDGCErIAIpAxAhKiACKQMIISggBSAgIC99IhsgGyACKQMAfCItICUgKX0iJiAlViAmIB0gLn0iJyAdViAnIB8gMH0iHiAfViAeIBsgIFatfSIiIB5Wcq19Ih4gJ1ZyrX0iJyAmVnKtUCIDGzcDACAFICIgIiAofCImIBsgLVatfCIoIAMbNwMIIAUgHiAeICp8IhsgIiAmViAmIChWcq18IiIgAxs3AxAgBSAnIBsgHlQgGyAiVnKtICcgK3x8IAMbNwMYIAIpAxghJiACKQMQIScgAikDCCErIAQgIyA0fSIbIBsgAikDAHwiKiAhIDF9IiIgIVYgIiAcIDJ9Ih4gHFYgHiAkIDN9IhwgJFYgHCAbICNWrX0iISAcVnKtfSIcIB5Wcq19IiQgIlZyrVAiAxs3A0AgBCAhICEgK3wiIyAbICpWrXwiIiADGzcDSCAEIBwgHCAnfCIbICIgI1QgISAjVnKtfCIhIAMbNwNQIAQgJCAbIBxUIBsgIVZyrSAkICZ8fCADGzcDWCAEIAIpAzgiIiAlICl8IiEgHSAufCIcIB1UIBwgHyAwfCIdIB9UIB0gICAvfCIfICBUrXwiICAdVHKtfCIdIBxUcq18Ihx8IiQgAikDMCIbIB18IiMgG1QgIyACKQMoIh4gIHwiGyAeVCAbIAIpAyAiHiAffCIpIB5UrXwiHiAbVHKtfCIbICNUcq18IiMgHCAhICVUIBwgIVRyICMgJFQgIiAkVnJzIgMbNwOYASAEIBsgHSADGzcDkAEgBCAeICAgAxs3A4gBIAQgKSAfIAMbNwOAASAHIAogBEFAayAEQYABaiAPIAYgF2xBBnRqIgMgA0EgaiACEIgLIAZBAWoiBiAWRw0ACyAWIQYLIBMgBkEFdGoiAyADKQMAIh0gHXwiJTcDACADIAMpAwgiICAgfCIfIB0gJVatfCIdNwMIIAMgAykDECIhICF8IhwgHSAfVCAfICBUcq18IiA3AxAgAyADKQMYIiQgJHwiIyAcICFUIBwgIFZyrXwiHzcDGCADIAIpAzgiIiAffCIhIAIpAzAiGyAgfCIcIBtUIBwgAikDKCIeIB18IhsgHlQgGyACKQMgIh4gJXwiKSAeVK18Ih4gG1RyrXwiGyAcVHKtfCIcIB8gHyAjVCAjICRUciAhICJUIBwgIVRycyIFGzcDGCADIBsgICAFGzcDECADIB4gHSAFGzcDCCADICkgJSAFGzcDACADIA1BBXRqIgMgAykDACIdIB18IiU3AwAgAyADKQMIIiAgIHwiHyAdICVWrXwiHTcDCCADIAMpAxAiISAhfCIcIB0gH1QgHyAgVHKtfCIgNwMQIAMgAykDGCIkICR8IiMgHCAhVCAcICBWcq18Ih83AxggAyACKQM4IiIgH3wiISACKQMwIhsgIHwiHCAbVCAcIAIpAygiHiAdfCIbIB5UIBsgAikDICIeICV8IikgHlStfCIeIBtUcq18IhsgHFRyrXwiHCAfIB8gI1QgIyAkVHIgISAiVCAcICFUcnMiBRs3AxggAyAbICAgBRs3AxAgAyAeIB0gBRs3AwggAyApICUgBRs3AwAgBCACKQOAASIbIA8gBiAXbEEGdGoiBSkDOH0iISACKQN4Ih0gBSkDMH0iHCAdViAcIAIpA3AiHSAFKQMofSIfIB1WIB8gAikDaCIgIAUpAyB9Ih0gIFatfSIgIB9Wcq19Ih8gHFZyrX0iHCAfIAIpAxB8IiQgH1QgJCAgIAIpAwh8IiMgIFQgIyAdIAIpAwB8IiIgHVStfCIeICNUcq18IiMgJFRyrSAcIAIpAxh8fCAbICFUIBwgIVZyrVAiBRs3A1ggBCAfICMgBRs3A1AgBCAgIB4gBRs3A0ggBCAdICIgBRs3A0AgAiADIARBQGsQpAkgEiAYaiISIAxJDQALIBRBCE8NAAsLQQAhAwNAIAsgA0EFdGpBASACEIsLIANBAmoiAyAMSQ0ACwwCCxCgCQALEKAJAAsgDEECayEHQQAhBUEAIQMDQCADIAVLBEAgBEHQAGoiCiALIAVBBXRqIgJBEGoiCf0AAwD9CwMAIAQgAv0AAwD9CwNAIAIgCyADQQV0aiIGQRhqIg0pAwA3AxggCSAGQRBqIhMpAwA3AwAgAiAGQQhqIgkpAwA3AwggAiAGKQMANwMAIA0gBCkDWDcDACATIAopAwA3AwAgCSAEKQNINwMAIAYgBCkDQDcDAAsgDCECA0AgAkEBdiICIANzIgMgAnFFDQALIAUgB0chAiAFQQFqIQUgAg0ACyAPECsLAkAgCCgCVCICRQ0AIAJBBXQiAkUNACARIAsgAvwKAAALIAsQKyAAKAIIIA5LBEADQCAEQdAAaiICIAAoAhAgDiAAKAIEa0EFdGoiA/0AAxD9CwMAIAQgA/0AAwD9CwNAIBUgBEFAayARIA5BBXQiA2oQpAkgBCAC/QADACI2/QsDECAEIAT9AANAIjf9CwMAIAEgA2oiAiA2/QsDECACIDf9CwMAIA5BAWoiDiAAKAIISQ0ACwsgERArIBAQKyAEQaABaiQAC7kEAgh/AXsjAEEQayIFJAAgACABQSxqQSAQ2QogASgCGARAIABBBGohBgNAIAIoAgggBEEEdGr9AAQAIQsgBUEBOgAAIAAoAnghAyAAQQA2AnggAwRAIAMQKwsgBiAFQQEQqgkgBSAL/QsEACAAKAJ4IQMgAEEANgJ4IAMEQCADECsLIAYgBUEQEKoJIARBAWoiBCABKAIYSQ0ACwsgBUEBOgAAIAAoAnghBCAAQQA2AnggBARAIAQQKwsgAEEEaiIDIAVBARCqCSAF/QwAAAAAAAAAAAAAAAAAAAAA/QsEACAAKAJ4IQQgAEEANgJ4IAQEQCAEECsLIAMgBUEQEKoJAkAgASgCICIEIAEoAiQiAUYEQEEAIQMMAQtBACEDIAEgBGtBDGsiBkEwTwRAIAZBDG5BAWoiAyADQQNxIgNBBCADG2shAiAEQSxqIQcgBEEgaiEIIARBFGohCSAEQQhqIQr9DAAAAAAAAAAAAAAAAAAAAAAhC0EAIQYDQCAHIAZBDGwiA2ooAgAgAyAIaigCACADIAlqKAIAIAMgCmooAgD9XAIA/VYCAAH9VgIAAv1WAgADIAv9rgEhCyAGQQRqIgYgAkcNAAsgBCACQQxsaiEEIAsgCyAL/Q0ICQoLDA0ODwABAgMAAQID/a4BIgsgCyAL/Q0EBQYHAAECAwABAgMAAQID/a4B/RsAIQMLA0AgBCgCCCgCACADaiEDIARBDGoiBCABRw0ACwsgACADEIELIAVBEGokAAv3BgIHfwR7AkAgAUEcSQRAQRAgAXQiBxCeCSEJIAdFIgpFBEAgCUEAIAf8CwALIAcQngkhCCAKRQRAIAhBACAH/AsAC0EBIAF0IQsgCSAG/QAEACIR/QsEACABRQRAIAggEf0LBAAMAgsgC0EBayEMIAEhCgNAAkACQCAMIApBAWsiCnYiBkEBdiIHQQFqIg1BAXRBAWsgBk0EQCACIApBBHRq/QAEACEPIA0hBwwBCyAJIAdBBXRqIAIgCkEEdGr9AAQAIg8gCSAHQQR0av0ABAAiDhCaCSAO/VH9CwQAIAZBAkkNAQsDQCAJIAdBAWsiB0EFdGoiBiAPIAkgB0EEdGr9AAQAIg4QmgkiEP0LBBAgBiAQIA79Uf0LBAAgBw0ACwsgCg0ACyAIIBH9CwQAA0ACQAJAIAwgAUEBayIBdiIGQQF2IgdBAWoiCkEBdEEBayAGTQRAIAMgAUEEdGr9AAQAIQ8gCiEHDAELIAggB0EFdGogAyABQQR0av0ABAAiDyAIIAdBBHRq/QAEACIOEJoJIA79Uf0LBAAgBkECSQ0BCwNAIAggB0EBayIHQQV0aiIGIA8gCCAHQQR0av0ABAAiDhCaCSIQ/QsEECAGIBAgDv1R/QsEACAHDQALCyABDQALDAELEKAJAAsgBP0ABAAhDkEAIQcDQCAJIAdBBHQiBmoiASAB/QAEACAGIAhq/QAEACAOEJoJ/VH9CwQAIAdBAWoiByALRw0ACyAIECsCQCAAKAIARQRAQQEhAQwBCyAAKAIEIQdBACEIA0AgByAIQQV0IgZqIgEpAxAgASkDGIRQBEAgASAF/QAEAP0LBBAgACgCBCEHCyAGIAdqIgcgB/0ABBAgCSAHKAIAQQR0av0ABAAQmgn9CwQQIAAoAgQiByAGakEANgIAIAhBAWoiCCAAKAIAIgFJDQALQQEhBiABQQJJBEBBASEBDAELQQEhAQNAAkACQCAAKAIEIgcgBkEFdGoiCCgCACAHIAFBBXRqIgdBIGsoAgBHDQAgCCgCBCAHQRxrKAIARw0AIAgoAgggB0EYaygCAEcNACAHQRBrIgcgCP0ABBAgB/0ABAD9Uf0LBAAMAQsgByAI/QAEAP0LBAAgByAI/QAEEP0LBBAgAUEBaiEBCyAGQQFqIgYgACgCAEkNAAsLIAAgATYCACAJECsL3AECA38BeyMAQRBrIgIkACACQQE6AAAgACgCeCEDIABBADYCeCADBEAgAxArCyAAQQRqIgMgAkEBEKoJIAIgAf0ABAD9CwQAIAAoAnghBCAAQQA2AnggBARAIAQQKwsgAyACQRAQqgkgAkEBOgAAIAAoAnghBCAAQQA2AnggBARAIAQQKwsgAyACQQEQqgkgAiAB/QAEIP0LBAAgACgCeCEBIABBADYCeCABBEAgARArCyADIAJBEBCqCSAAIAJBECAAKAIAKAIIEQEAIAL9AAQAIQUgAkEQaiQAIAULtQICAX8BeyMAQYABayICJAACQAJAAkAgAEEBRgRAIAEoAgANASABKAIEDQIgASgCCA0DIAH9AAQQIQMgAkGAAWokACADDwsgAkGz8is2AnBB5ABB9IcqIAJB8ABqEJsJQZCWNCgCACgCACEBIAJBs/IrNgJgIAFBkYwqIAJB4ABqEGwACyACQYrzKzYCUEHkAEH0hyogAkHQAGoQmwlBkJY0KAIAKAIAIQEgAkGK8ys2AkAgAUGRjCogAkFAaxBsAAsgAkGn8ys2AjBB5ABB9IcqIAJBMGoQmwlBkJY0KAIAKAIAIQEgAkGn8ys2AiAgAUGRjCogAkEgahBsAAsgAkGX8ys2AhBB5ABB9IcqIAJBEGoQmwlBkJY0KAIAKAIAIQEgAkGX8ys2AgAgAUGRjCogAhBsAAvWAQEEfyMAQRBrIgMkACADQQE6AAAgACgCeCEEIABBADYCeCAEBEAgBBArCyAAQQRqIgUgA0EBEKoJIANBADYABCADIAI6AAAgAyACQRh2OgADIAMgAkEQdjoAAiADIAJBCHY6AAEgACgCeCEEIABBADYCeCAEBEAgBBArCyAFIANBCBCqCSACBEBBACEEA0AgAyABIARBBHRq/QAEAP0LBAAgACgCeCEGIABBADYCeCAGBEAgBhArCyAFIANBEBCqCSAEQQFqIgQgAkcNAAsLIANBEGokAAvoHgIjfw57IwBBoAtrIgokACAAKAIYISMgACgCFCEaIAAoAhAhCSAKQeAAakEAQYwK/AsAAkACQAJAAkACQCAJBEAgCUHjpYYBTw0BIAogCUGgD2wiDRCeCSIJNgLgCiAKIAkgDWo2AugKIA1BoA9rIg0gDUGgD3BrQaAPaiINBEAgCUEAIA38CwALIAogCSANajYC5AoLIApB8ABqIQ5BACEJA0AgBiAKQfAKakEQIAYoAgAoAggRAQAgCUEEdCINIApB4ABqaiAK/QAE8Ar9CwQAIAYgCkHwCmpBECAGKAIAKAIIEQEAIA0gDmogCv0ABPAK/QsEACAJQQJqIglBKEcNAAsgCkHwBWohDiAKQeAFaiEWQQAhCQNAIAYgCkHwCmpBECAGKAIAKAIIEQEAIBYgCUEEdCINaiAK/QAE8Ar9CwQAIAYgCkHwCmpBECAGKAIAKAIIEQEAIA0gDmogCv0ABPAK/QsEACAJQQJqIglBKEcNAAsgACgCBCES/QwAAAAAAAAAAAAAAAAAAAAAIAj9AASgCCItEJoJIAj9AAQAIjQgCP0ABMAHIi8QmgkiMv1RIAj9AASwCCIsEJoJITYgMiA0IC0QmgkiLf1RICwQmgkhNyAt/QwAAAAAAAAAAAAAAAAAAAAAIC8QmgkiOP1RICwQmgkhOSAAKAIMRQRAIAAoAhBFBEAgFiEYDAMLIApBgAtqISQgCkHwCmpBBHIhJSAKKALgCiEo/QwAAAAAAAAAAAAAAAAAAAAAIS0gFiEYA0ACQAJAAkACQCAAKAIkIAAoAiAiCWtBDG0gFEsEQCACKAIAIQ0gBiAKQfAKakEQIAYoAgAoAggRAQAgKCAUQaAPbGoiFyAK/QAE8Ar9CwQAIAYgCkHwCmpBECAGKAIAKAIIEQEAIBcgCv0ABPAK/QsEECAJIBRBDGxqIhkoAgQiJkUNASAmQQJ0IilBBmoiH0GAgICAAU8NCSAfQQR0IhsQngkhFSAbRSIqRQRAIBVBACAb/AsACyANIBRBoDJsaiEcIBf9AAQAISwgFSAV/QAEACAI/QAEACIv/VH9CwQAIBUgLCAV/QAEEP1R/QsEECAvIC4QmgkgLCAtEJoJ/VEhMSAZKAIEBEAgFSAbaiENIBVBMGohHSAVQUBrIR4gF0GgBWohICAcQYAUaiEhQQAhDANAIAxBAnQhE0EBIQ9BACEJA0AgICAJQYAFbGogDEEEdGogBiAhIAlBgA9saiAMQTBsaiIOEOUKIiz9CwQAIDIgNiAsIAj9AASABv1RIi4Qmgn9USAsIAj9AATwBf1RIi0QmgkhMCAyIDcgLhCaCf1RIC0QmgkhLCA4IDkgLhCaCf1RIC0QmgkhLiAO/QAEACEzIB0gEyAJQQF0ckEEdCIQaiILIAv9AAQAIAj9AAQAIi/9Uf0LBAAgNCAw/VEhLSAxIC8gMxCaCf1RICwQmgkhMSAVIQkDQCAJIAn9AAQAICwQmgn9CwQAIAlBEGoiCSANRw0ACyAO/QAEACEsIAsgLSAL/QAEAP1R/QsEACAO/QAEICEwIBAgHmoiCSAuIAn9AAQA/VH9CwQAIDEgLSAsEJoJ/VEgLiAwEJoJ/VEhMUEBIQkgD0EBcSEOQQAhDyAODQALIAxBAWoiDCAZKAIESQ0ACwsgA0UEQCAZKAIIIQ5BEBCiCSERIA4oAgAhCyARQQA2AgwgEUIANwIEIBEgCzYCAAJAIAtFDQAgC0GAgIDAAE8NBCARIAtBBXQiDBCeCSINNgIEIBEgDCANaiIPNgIMQQAhCSAMBEAgDUEAIAz8CwALIBEgDzYCCCALQQNxIRAgDigCBCEOIAtBBE8EQCALQfz//z9xIRMDQCANIAlBBXQiC2oiDCALIA5qIg/9AAQA/QsEACAMIA/9AAQQ/QsEECANIAtBIHIiDGoiDyAMIA5qIgz9AAQQ/QsEECAPIAz9AAQA/QsEACANIAtBwAByIg9qIgwgDiAPaiIP/QADCP0LAwggDCAPKQMANwMAIAwgDykDGDcDGCANIAtB4AByIgxqIgsgDCAOaiIMKQMQNwMQIAsgDCkDCDcDCCALIAwpAxg3AxggCyAMKQMANwMAIAlBBGoiCSATRw0ACwtBACELIBBFDQADQCANIAlBBXQiDGoiDyAMIA5qIgz9AAQA/QsEACAPIAz9AAQQ/QsEECAJQQFqIQkgC0EBaiILIBBHDQALCyARIBIgFiAYIBcgF0EQaiAIEOQKIBEoAgAhDyAZKAIERQRAIA8hDQwFCyAXQaAFaiErQQAhIgNAQQEhJ0EAIQkDQEEAIQ0gDwRAICsgCUGABWxqICJBBHRqIRIgJSAJQQJ0Ih5qISAgJSAJQQFzQQJ0IhNqISEgESgCBCEOQQAhCQNAIApBADYC8AogICAOIAlBBXRqIhBBBGoiCyAeaigCACIMQQF2NgIAICEgCyATaigCACIdNgIAAn8CQCAJQQFqIgsgD08NACAdIA4gC0EFdGoiGEEEaiIWIBNqKAIARw0AIBYgHmooAgAiHSAMQQFqRw0AIAwgHXNBAUsNACAKIBj9AAQQIBD9AAQQIiz9USAS/QAEABCaCSAs/VH9CwSACyAJQQJqDAELIBD9AAQQIi4gEv0ABAAQmgkhLAJAIAxBAXFFBEAgCiAuICz9Uf0LBIALDAELIAogLP0LBIALCyALCyEJIA4gDUEFdGoiCyAK/QAE8Ar9CwQAIAsgJP0ABAD9CwQQIA1BAWohDSAJIA9JDQALCyARIA02AgBBASEJICchDiANIQ9BACEnIA4NAAsgIkEBaiIiIBkoAgRJDQALDAQLIAMoAgAgFEEEdGr9AAQAITUMBAsQoAkACyAKQfXyKzYCMEHkAEH0hyogCkEwahCbCUGQljQoAgAoAgAhCSAKQfXyKzYCICAJQZGMKiAKQSBqEGwACxCgCQALIA0gESgCBBDmCiE1IBEoAgQiCQRAIBEgCTYCCCAJECsLIBEQKyAI/QAEACEvCwJAIAAoAgwiC0UEQCAvITAMAQsgF0EgaiEMIAAoAgghCUEAIQ0gLyIuITADQCANQQR0Ig4gCkHgAGpq/QAEACItIC/9USAMIA5q/QAEACIzIC/9URCaCSEsIC0gMxCaCSEtAnsgCUEBcUUEQCAwIC0QmgkgLiAsEJoJ/VEMAQsgMCAsEJoJCyEwIAlBAWpBAXYhCSAuIC0gLP1REJoJIS4gDUEBaiINIAtHDQALCyAKIDEgMCA1EJoJIiwgHP0ABIAyIi4gHEGQMmoiC/0ABAAiLRCaCRCaCf1R/QsEkAsgGxCeCSENICpFBEAgDSAVIBv8CgAACyANICZBBnRqIgkgCf0ABDAgLCAtEJoJ/VH9CwQwIAlBQGsiDiAO/QAEACAsIC4Qmgn9Uf0LBAAgCUHQAGoiCSAsIAn9AAQA/VH9CwQAIAUgCkGQC2oQ/gkgHEGAMmohDCAfQQBBAyAUGyIJSwRAIAdBA2shDgNAIAogFDYC8AogCiAJIA5qNgL0CiAkIA0gCUEEdGr9AAQA/QsEACAEIApB8ApqEIwLIAlBAWoiCSAfRw0ACwsgDRArIAYgDEECEOcKIAv9AAQAIS0gHP0ABIAyIS4gGSgCBCESIBUQKyAXQaAKaiEYIBdBoAVqIRYgByApakEDaiEHIBRBAWoiFCAAKAIQSQ0ACwwCCyAKQb/wKzYCUEHkAEH0hyogCkHQAGoQmwlBkJY0KAIAKAIAIQkgCkG/8Cs2AkAgCUGRjCogCkFAaxBsAAsQoAkACyAGIApBkAtqQRAgBigCACgCCBEBACAK/QAEkAsiLyACKAIAIAAoAhBBoDJsaiIJQRBr/QAEABCaCSExIBpBgICAgAFPDQAgCUEga/0ABAAhMiAaQQR0IhAQngkhDSAQRSITRQRAIA1BACAQ/AsACyANIAj9AAQA/QsEACASBEAgGkEBayEPIBIhDANAAkAgDyAMQQFrIgx2Ig5BAXYiC0EBaiIJQQF0QQFrIA5LBEAgDSALQQV0aiAWIAxBBHRq/QAEACANIAtBBHRq/QAEACIsEJoJICz9Uf0LBAAgCyEJIA5BAkkNAQsgFiAMQQR0aiELA0AgDSAJQQFrIglBBXRqIg4gC/0ABAAgDSAJQQR0av0ABAAiLBCaCSIu/QsEECAOIC4gLP1R/QsEACAJDQALCyAMDQALCyAQEJ4JIQ4gE0UEQCAOQQAgEPwLAAsgDiAI/QAEAP0LBAAgEgRAIBpBAWshDwNAAkACQCAPIBJBAWsiEnYiC0EBdiIJQQFqIgxBAXRBAWsgC00EQCAYIBJBBHRq/QAEACEtIAwhCQwBCyAOIAlBBXRqIBggEkEEdGr9AAQAIi0gDiAJQQR0av0ABAAiLBCaCSAs/VH9CwQAIAtBAkkNAQsDQCAOIAlBAWsiCUEFdGoiCyAtIA4gCUEEdGr9AAQAIiwQmgkiLv0LBBAgCyAuICz9Uf0LBAAgCQ0ACwsgEg0ACwsgMiAx/VEhLf0MAAAAAAAAAAAAAAAAAAAAACEuQQAhCQNAIC8gDiAJQQR0Igtq/QAEABCaCSALIA1q/QAEAP1RISwCQCAJICNJBEAgLCABKAIIIAtq/QAEABCaCSAu/VEhLgwBCyAKICz9CwSACyAKIBQ2AvAKIAogCSAjazYC9AogBCAKQfAKahCMCwsgCUEBaiIJIBpHDQALIAdBAk0NASAKIBQ2AvAKIAogB0EDazYC9AogCiAI/QAEAP0LBIALIAQgCkHwCmoQjAsgCiAv/QsEgAsgCiAHQQJrNgL0CiAKIBQ2AvAKIAQgCkHwCmoQjAsgLiAt/VEhLAJAIAUoAgQiCSAFKAIIIgxJBEAgCSAs/QsEACAJQRBqIQkMAQsgCSAFKAIAIgtrIglBBHUiE0EBaiIPQYCAgIABTw0BQf////8AIAwgC2siDEEDdSIQIA8gDyAQSRsgDEHw////B08bIgwEfyAMQYCAgIABTw0EIAxBBHQQngkFQQALIg8gCWoiECAs/QsEACAQIBNBBHRrIRMgCQRAIBMgCyAJ/AoAAAsgBSAPIAxBBHRqNgIIIAUgEEEQaiIJNgIEIAUgEzYCACALRQ0AIAsQKwsgBSAJNgIEIA4QKyANECsgCigC4AoiCQRAIAkQKwsgCkGgC2okACAUQQFqDwsQoAkACyAKQdn+KzYCEEHkAEH0hyogCkEQahCbCUGQljQoAgAoAgAhCSAKQdn+KzYCACAJQZGMKiAKEGwACxCgCQAL3QQBBn8jAEFAaiILJAACQCABKAIkIAEoAjBsIghFDQAgCEEEdCIIRQ0AIABBACAI/AsACwJAAkAgAwRAQQAhCANAIAQgCEEFdGoiCSgCBCIMIAEoAgBPDQMgCSgCACIKIAJPDQIgACAMQQR0aiIMIAz9AAQAIAn9AAQQIAUgCkEEdGr9AAQAEJoJ/VH9CwQAIAhBAWoiCCADRw0ACwsgASgCLCIKBEAgACABKAIkIgggASgCKGxBBHRqIgIgCCAKbEEEdCIJaiIFIAlqIQ1BACEEA0BBACEMQQAhCSAIBH8DQCAEIAhsIAxqIgkgASgCBEkEQCACIAlBBHQiCmoiAyAHIAlBMGxqIgj9AAQAIAP9AAQA/VH9CwQAIAAgBiAJQQxsaiIJKAIAQQR0aiIDIAj9AAQAIAP9AAQA/VH9CwQAIAUgCmoiAyAI/QAEECAD/QAEAP1R/QsEACAAIAkoAgRBBHRqIgMgCP0ABBAgA/0ABAD9Uf0LBAAgCiANaiIKIAj9AAQgIAr9AAQA/VH9CwQAIAAgCSgCCEEEdGoiCSAI/QAEICAJ/QAEAP1R/QsEACAMQQFqIgwgASgCJCIISQ0BCwsgASgCLCEKIAgFIAkLIQggBEEBaiIEIApJDQALCyALQUBrJAAPCyALQd7HKjYCEEHkAEH0hyogC0EQahCbCUGQljQoAgAoAgAhCCALQd7HKjYCACAIQZGMKiALEGwACyALQc+/KTYCMEHkAEH0hyogC0EwahCbCUGQljQoAgAoAgAhCCALQc+/KTYCICAIQZGMKiALQSBqEGwAC80HAhF/AXsjAEFAaiIGJAACQCABKAIQIgUgASgCGCIHTwRAIAUgB2siBSABKAIMIgFJDQEgAiEOIAAhESMAQeAAayIEJAACQAJAAkACQCABIg8gBU0EQCAFRQ0EIAVBgICAgARPDQEgBUECdCIAEKIJIQkgAARAIAlBACAA/AsACyAFQQNNDQIgBUH8////A3EhA/0MAAAAAAEAAAACAAAAAwAAACEUQQAhAANAIAkgAEECdGogFP0LAgAgFP0MBAAAAAQAAAAEAAAABAAAAP2uASEUIABBBGoiACADRw0ACyADIAVHDQIMAwsgBEHU2io2AhBB5ABB9IcqIARBEGoQmwlBkJY0KAIAKAIAIQMgBEHU2io2AgAgA0GRjCogBBBsAAsQoAkACwNAIAkgA0ECdGogAzYCACADQQFqIgMgBUcNAAsLAkAgD0UNAANAQQAhAUF9IQBBASECIAUgC2siCiEDIApFBEAgBEHS/is2AjBB5ABB9IcqIARBMGoQmwlBkJY0KAIAKAIAIQMgBEHS/is2AiAgA0GRjCogBEEgahBsAAsDQCAAIgxBAWohACACIgdBAWohAiABIhBBAWohASADQf8BSyEIIANBCHYhAyAIDQALQQAhDSAQQQRJBEADQCANQQF0QQFyIg0gCnEgCkcNAAsgAUEDcSEIIARB3ABqIAcgB0EEcUEEayIAa2oiA0EDayEHIANBAmshEiADQQFrIRMgBEHcAGogDCAAa2ohDANAIA4gBEHcAGogASAOKAIAKAIIEQEAAkAgEEEDRgRAIAwtAAAgBy0AACATLQAAQRB0IBItAABBCHRyckEIdHIhAwwBC0EAIQMgASEAQQAhAiAIRQ0AA0AgAEEBayIAIARB3ABqai0AACADQQh0ciEDIAJBAWoiAiAIRw0ACwsgAyANcSIDIApPDQALIAkgC0ECdCICaiIAKAIAIQggACAAIANBAnRqIgMoAgA2AgAgAyAINgIAIAIgEWogACgCADYCACALQQFqIgsgD0cNAQwCCwsgBEHU9ys2AlBB5ABB9IcqIARB0ABqEJsJQZCWNCgCACgCACEDIARB1PcrNgJAIANBkYwqIARBQGsQbAALIAkQKwsgBEHgAGokACAGQUBrJAAPCyAGQafUKjYCEEHkAEH0hyogBkEQahCbCUGQljQoAgAoAgAhASAGQafUKjYCACABQZGMKiAGEGwACyAGQYejKjYCMEHkAEH0hyogBkEwahCbCUGQljQoAgAoAgAhASAGQYejKjYCICABQZGMKiAGQSBqEGwAC7cDAQh/IwBBEGsiCCQAIAhBBGogACgCACACIAMQhgsgCCgCBCECAkACQCAAKAIAIgNBAk8EQAJAA0ACQAJAIAIgA0EBayIDQQN2Qfz///8BcWooAgAgA3ZBAXFFDQAgAiADQQJ2Qfz///8BcWooAgAiBCAEIANBAXQiBXZBAXEgBXIiBHZBAXENACAAKAIEIARBBXRqIQUCQCABKAIEIgQgASgCCCIGSQRAIAQgBf0AAAD9CwAAIAQgBf0AABD9CwAQIARBIGohBAwBCyAEIAEoAgAiB2siCUEFdSILQQFqIgRBgICAwABPDQJB////PyAGIAdrIgZBBHUiCiAEIAQgCkkbIAZB4P///wdPGyIGBH8gBkGAgIDAAE8NBSAGQQV0EKIJBUEACyIKIAlqIgQgBf0AAAD9CwAAIAQgBf0AABD9CwAQIAQgC0EFdGshBSAJBEAgBSAHIAn8CgAACyABIAogBkEFdGo2AgggASAEQSBqIgQ2AgQgASAFNgIAIAdFDQAgBxArCyABIAQ2AgQLIANBAUsNAQwECwsQoAkACxCgCQALIAJFDQELIAIQKwsgCEEQaiQAC/wDAgd/AnsjAEEQayIGJAAgACABQSxqQSAQ2QogASgCGARAIABBBGohBwNAIAIoAgggBUEFdGoiBP0AAxAhCyAE/QADACEMIAZBAToADyAAKAJ4IQQgAEEANgJ4IAQEQCAEECsLIAcgBkEPakEBEKoJIAAgDCALIAMQ8wogBUEBaiIFIAEoAhhJDQALCyAGQQE6AA4gACgCeCEFQQAhBCAAQQA2AnggBQRAIAUQKwsgAEEEaiAGQQ5qQQEQqgkgACAD/QADaCAD/QADeCADEPMKIAEoAiAiBSABKAIkIgNHBEAgAyAFa0EMayIBQTBPBEAgAUEMbkEBaiIEIARBA3EiBEEEIAQbayECIAVBLGohByAFQSBqIQggBUEUaiEJIAVBCGohCv0MAAAAAAAAAAAAAAAAAAAAACELQQAhAQNAIAcgAUEMbCIEaigCACAEIAhqKAIAIAQgCWooAgAgBCAKaigCAP1cAgD9VgIAAf1WAgAC/VYCAAMgC/2uASELIAFBBGoiASACRw0ACyAFIAJBDGxqIQUgCyALIAv9DQgJCgsMDQ4PAAECAwABAgP9rgEiCyALIAv9DQQFBgcAAQIDAAECAwABAgP9rgH9GwAhBAsDQCAFKAIIKAIAIARqIQQgBUEMaiIFIANHDQALCyAAIAQQgQsgBkEQaiQAC6gCAgd/BH4jAEHgAGsiBCQAIAIEQCADQUBrIQggBEFAa0EBciEFA0AgACAEQSBqQSAgACgCACgCCBEBACAEKQM4Ig4gAykDGCILVCALIA5RIAQpAzAiCyADKQMQIgxUIAsgDFEgBCkDKCIMIAMpAwgiDVQgDCANUSAEKQMgIg0gAykDAFRxcnFycXKtUA0AIAQgDjcDWCAEIAs3A1AgBCAMNwNIIAQgDTcDQCADIARBQGsgCBCkCSAEQQhqIgkgBf0AAAj9CwMAIARBF2oiCiAFKQAXNwAAIAQgBSkAADcDACABIAZBBXRqIgcgBC0AQDoAACAHIAQpAwA3AAEgByAJ/QADAP0LAAkgByAKKQAANwAYIAZBAWoiBiACRw0ACwsgBEHgAGokAAv5AwIFfwV+IwBB4ABrIgQkAANAIAAgBEEgakEgIAAoAgAoAggRAQBCACAEKQM4IgwgASkDGCIJVCAJIAxRIAQpAzAiCSABKQMQIgpUIAkgClEgBCkDKCIKIAEpAwgiC1QgCiALUSAEKQMgIgsgASkDAFRxcnFycXKtUQ0ACyAEQdgAaiIFIAw3AwAgBCAJNwNQIAQgCjcDSCAEIAs3A0AgASAEQUBrIAFBQGsiBhCkCSAEQQhqIgcgBP0AAEn9CwMAIARBF2oiCCAFKQAANwAAIAQgBCkAQTcDACACIAQtAEA6AAAgAiAEKQMANwABIAIgB/0AAwD9CwAJIAIgCCkAADcAGANAIAAgBEEgakEgIAAoAgAoAggRAQAgDSAEKQM4IgwgASkDGCIJVCAJIAxRIAQpAzAiCSABKQMQIgpUIAkgClEgBCkDKCIKIAEpAwgiC1QgCiALUSAEKQMgIgsgASkDAFRxcnFycXKtUQ0ACyAEQdgAaiIAIAw3AwAgBCAJNwNQIAQgCjcDSCAEIAs3A0AgASAEQUBrIAYQpAkgBEEIaiIBIAT9AABJ/QsDACAEQRdqIgIgACkAADcAACAEIAQpAEE3AwAgAyAELQBAOgAAIAMgBCkDADcAASADIAH9AAMA/QsACSADIAIpAAA3ABggBEHgAGokAAvzBgMKfgl/AXsjAEEgayIPJAAgACAE/QADiAH9CwMAIAAgBP0AA5gB/QsDECABBEAgAkEBayEXA0ACQCAXIAFBAWsiAXYiEUEBdiITQQFqIhBBAXRBAWsgEUsEQCAPQRBqIhIgAyABQQV0aiIC/QADEP0LAwAgDyAC/QADAP0LAwAgBCAPIAAgE0EFdGoiEBCkCSAQ/QADECEYIAAgE0EGdGoiAiAQ/QADAP0LAwAgAkEQaiIQIBj9CwMAIAIgAikDACIFIA8pAwB9IgY3AwAgAkEIaiIUIBQpAwAiCCAPKQMIfSIHIAUgBlStfSIFNwMAIBAgECkDACILIBIpAwB9IgkgByAIViAFIAdWcq19Igc3AwAgAkEYaiIVIBUpAwAiCCAPKQMYfSIKIAkgC1YgByAJVnKtfSIJNwMAIAQpAxghCyAEKQMQIQwgBCkDCCENIAIgBiAGIAQpAwB8Ig4gCCAKVCAJIApWcq1QIhIbNwMAIBQgBSAFIA18IgggBiAOVq18IgogEhs3AwAgECAHIAcgDHwiBiAFIAhWIAggClZyrXwiBSASGzcDACAVIAkgBiAHVCAFIAZUcq0gCSALfHwgEhs3AwAgEyEQIBFBAkkNAQsgAyABQQV0aiEWA0AgD0EQaiISIBb9AAMQ/QsDACAPIBb9AAMA/QsDACAEIA8gACAQQQFrIhBBBXRqIhEQpAkgEf0AAxAhGCAAIBBBBnRqIgIgEf0AAwD9CwMAIAJBEGoiESAY/QsDACACIAIpAwAiBSAPKQMAfSIGNwMAIAJBCGoiFCAUKQMAIgggDykDCH0iByAFIAZUrX0iBTcDACARIBEpAwAiCyASKQMAfSIJIAcgCFYgBSAHVnKtfSIHNwMAIAJBGGoiFSAVKQMAIgggDykDGH0iCiAJIAtWIAcgCVZyrX0iCTcDACAEKQMYIQsgBCkDECEMIAQpAwghDSACIAYgBiAEKQMAfCIOIAggClQgCSAKVnKtUCITGzcDACAUIAUgBSANfCIIIAYgDlatfCIKIBMbNwMAIBEgByAHIAx8IgYgBSAIViAIIApWcq18IgUgExs3AwAgFSAJIAYgB1QgBSAGVHKtIAkgC3x8IBMbNwMAIAIgD/0AAwD9CwMgIAIgEv0AAwD9CwMwIBANAAsLIAENAAsLIA9BIGokAAuEBQIHfw9+IwBBIGsiCCQAIAFBG0kEQEEgIAF0IgcQogkhCSAHRSIMRQRAIAlBACAH/AsACyAHEKIJIQsgDEUEQCALQQAgB/wLAAsgCSABQQEgAXQiDSACIAYQ7wogCyABIA0gAyAGEO8KIAYpAzghFCAGKQMwIRUgBikDKCEWIAYpAyAhFyAIQRhqIQIgCEEIaiEMA0AgCEEQaiIHIAsgCkEFdCIBaiID/QADEP0LAwAgCCAD/QADAP0LAwAgBiAIIAQQpAkgASAJaiIBIBQgASkDGCIaIAIpAwB8IhggASkDECIOIAcpAwB8Ig8gDlQgDyABKQMIIhAgDCkDAHwiDiAQVCAOIAEpAwAiESAIKQMAfCIQIBFUrXwiESAOVHKtfCIOIA9Ucq18Ig98IhkgDiAVfCISIBVUIBIgESAWfCITIBZUIBMgECAXfCIbIBdUrXwiHCATVHKtfCITIBJUcq18IhIgDyAYIBpUIA8gGFRyIBIgGVQgFCAZVnJzIgcbNwMYIAEgEyAOIAcbNwMQIAEgHCARIAcbNwMIIAEgGyAQIAcbNwMAIApBAWoiCiANRw0ACyALECsgACgCAARAIAAoAgQhAUEAIQcDQAJAIAEgB0EwbCIKaiIDKQMQIAYpA2hSDQAgA0EQaiIDKQMIIAYpA3BSDQAgAykDECAGKQN4Ug0AIAMpAxggBikDgAFSDQAgAyAF/QADAP0LAwAgAyAF/QADEP0LAxAgACgCBCEBCyAGIAEgCmoiAUEQaiAJIAEoAgBBBXRqEKQJIAAoAgQiASAKakEANgIAIAdBAWoiByAAKAIASQ0ACwsgACAGENoJIAkQKyAIQSBqJAAPCxCgCQALvwUCE34EfyAAIAH9AAMA/QsDACAAIAFBEGoiFv0AAwD9CwMQIAAgAUE4aiIXKQMAIg43AzggACABQTBqIhgpAwAiCDcDMCAAIAFBKGoiGSkDACIENwMoIAAgASkDICINNwMgIAAgAikDOCIPIA4gFykDACIQIAEpAxh9IgkgGCkDACIGIBYpAwB9IgogBlYgCiAZKQMAIgYgASkDCH0iAyAGViADIAEpAyAiBSABKQMAfSIGIAVWrX0iBSADVnKtfSIDIApWcq19IgogAyACKQMQfCIHIANUIAcgBSACKQMIfCIMIAVUIAwgBiACKQMAfCIRIAZUrXwiEiAMVHKtfCIMIAdUcq0gCiACKQMYfHwgCSAKVCAJIBBWcq1QIgEbIhB8IgkgCCADIAwgARsiE3wiCyAIVCALIAQgBSASIAEbIhJ8IgUgBFQgBSANIAYgESABGyIRfCIDIA1UrXwiCCAFVHKtfCIEIAtUcq18Ig18IgogAikDMCILIAR8IgcgC1QgByACKQMoIgYgCHwiDCAGVCAMIAIpAyAiBSADfCIUIAVUrXwiFSAMVHKtfCIMIAdUcq18IgcgDSAJIA5UIAkgDVZyIAogD1QgByAKVHJzIgEbIg43A1ggACAMIAQgARsiBDcDUCAAIBUgCCABGyIINwNIIAAgFCADIAEbIgM3A0AgACAPIA4gEHwiDSAEIBN8IgkgBFQgCSAIIBJ8IgQgCFQgBCADIBF8IgggA1StfCIDIARUcq18IgQgCVRyrXwiCXwiCiAEIAt8IgcgC1QgByADIAZ8IgsgBlQgCyAFIAh8IgYgBVStfCIFIAtUcq18IgsgB1RyrXwiByAJIA0gDlQgCSANVHIgCiAPVCAHIApUcnMiARs3A3ggACALIAQgARs3A3AgACAFIAMgARs3A2ggACAGIAggARs3A2ALsQICA38MfgNAIAAgBUEFdCIEaiIDIAMpAwAiCSABIARqIgQpAwB8Ig43AwAgAyADKQMIIgsgBCkDCHwiBiAJIA5WrXwiCTcDCCADIAMpAxAiDCAEKQMQfCIHIAYgC1QgBiAJVnKtfCIGNwMQIAMgAykDGCIPIAQpAxh8IgsgBiAHVCAHIAxUcq18Igc3AxggAyACKQM4IhAgB3wiDCACKQMwIgggBnwiDSAIVCANIAIpAygiCiAJfCIIIApUIAggAikDICIKIA58IhEgClStfCIKIAhUcq18IgggDVRyrXwiDSAHIAsgD1QgByALVHIgDCAQVCAMIA1WcnMiBBs3AxggAyAIIAYgBBs3AxAgAyAKIAkgBBs3AwggAyARIA4gBBs3AwAgBUEBaiIFQQRHDQALC10BAX8jAEFAaiIEJAAgBEEgaiADIAEgAhCZCSAEIAT9AAMg/QsEACAEIAT9AAMw/QsEECAAKAJ4IQMgAEEANgJ4IAMEQCADECsLIABBBGogBEEgEKoJIARBQGskAAvTCQILfxF+IwBBIGsiBCQAIAAoAgQEQCACQegAaiELIARBGGohByAEQRBqIQggBEEIaiEJA0ACQCAAKAIAIgNBAkkEQEEAIQUMAQtCACEbQQAhDQNAIAAoAgggCkEFdGoiAykDGCEZIAMpAxAhEiADKQMAIRQgAykDCCEVIAcgAykDOCIRNwMAIAggAykDMCIONwMAIAkgAykDKCIPNwMAIAQgAykDICIQNwMAIAIpAxghGiACKQMQIRwgCSAPIBV9IhcgECAUfSIWIBBWrX0iECAQIAIpAwh8IhMgFiACKQMAfCIdIBZUrXwiHiAbIBEgGX0iGCARViAYIA4gDiASfSIOVCAOIA8gF1QgECAXVnKtfSIRIA5Wcq19Ig4gGFZyrVEiAxs3AwAgCCARIBEgHHwiDyAQIBNWIBMgHlZyrXwiECADGzcDACAHIA4gDyARVCAPIBBWcq0gDiAafHwgAxs3AwAgBCAWIB0gAxs3AwAgAiAEIAEQpAkgACgCCCAGQQV0aiIDIAIpAzgiFyAZIAcpAwB8IhYgEiAIKQMAfCIQIBJUIBAgFSAJKQMAfCISIBVUIBIgFCAEKQMAfCIVIBRUrXwiFCASVHKtfCISIBBUcq18IhB8IhEgAikDMCIPIBJ8Ig4gD1QgDiACKQMoIhMgFHwiDyATVCAPIAIpAyAiEyAVfCIYIBNUrXwiEyAPVHKtfCIPIA5Ucq18Ig4gECAQIBZUIBYgGVRyIBEgF1QgDiARVHJzIgUbNwMYIAMgDyASIAUbNwMQIAMgEyAUIAUbNwMIIAMgGCAVIAUbNwMAIAZBAWohBiAKQQJqIQogACgCACIDIA1BAWoiDUEBdCIFQQFySw0ACwsgAyAFSwRAIAAoAgggCkEFdGoiAykDGCEZIAMpAxAhEiADKQMAIRQgAykDCCEVIAcgCykDGCIONwMAIAggCykDECIPNwMAIAkgCykDCCIXNwMAIAQgCykDACIRNwMAIAIpAxghHCACKQMQIR0gCSAXIBV9IhMgESAUfSIQIBFWrX0iESARIAIpAwh8IhggECACKQMAfCIeIBBUrXwiGyAOIA4gGX0iDlQgDiAOIA8gEn0iGiAPViAaIBMgF1YgESATVnKtfSIOIBpWcq19Ig9Ucq1QIgMbNwMAIAggDiAOIB18IhYgGCAbViARIBhWcq18IhEgAxs3AwAgByAPIBEgFlQgDiAWVnKtIA8gHHx8IAMbNwMAIAQgECAeIAMbNwMAIAIgBCABEKQJIAAoAgggBkEFdGoiAyACKQM4IhcgGSAHKQMAfCIWIBIgCCkDAHwiECASVCAQIBUgCSkDAHwiEiAVVCASIBQgBCkDAHwiFSAUVK18IhQgElRyrXwiEiAQVHKtfCIQfCIRIAIpAzAiDyASfCIOIA9UIA4gAikDKCITIBR8Ig8gE1QgDyACKQMgIhMgFXwiGCATVK18IhMgD1RyrXwiDyAOVHKtfCIOIBAgECAWVCAWIBlUciARIBdUIA4gEVRycyIFGzcDGCADIA8gEiAFGzcDECADIBMgFCAFGzcDCCADIBggFSAFGzcDACAKQQFqIQogBkEBaiEGCyAMQQFqIgwgACgCBEkNAAsLIAAgACgCAEEBakEBdjYCACAEQSBqJAAL2gICA38EfiMAQUBqIgQkACAEQQE6ACAgASgCeCEFIAFBADYCeCAFBEAgBRArCyABQQRqIgYgBEEgakEBEKoJIAEgA/0AAwAgA/0AAxAgAhDzCiAEQQE6ACAgASgCeCEFIAFBADYCeCAFBEAgBRArCyAGIARBIGpBARCqCSABIAP9AANAIAP9AANQIAIQ8woDQCABIARBICABKAIAKAIIEQEAIAQpAxgiCiACKQMYIgdUIAcgClEgBCkDECIHIAIpAxAiCFQgByAIUSAEKQMIIgggAikDCCIJVCAIIAlRIAQpAwAiCSACKQMAVHFycXJxcq1QDQALIARBOGoiASAKNwMAIAQgBzcDMCAEIAg3AyggBCAJNwMgIAIgBEEgaiACQUBrEKQJIAQtACAhAiAAIAEpAAA3ABggACAEKQAxNwARIAAgBP0AACH9CwABIAAgAjoAACAEQUBrJAALlwkCD38PfiMAQdAAayIEJAACQCAAKAIAIgZFBEAMAQsgBEEEciIFIAJBAnQiDmohECAFIAJBAXNBAnQiD2ohESAEQRBqIQogBEE4aiELQQAhAgNAIARBADYCACAQIAAoAgQiCCACQTBsaiIFQQRqIgcgDmooAgAiDEEBdjYCACARIAcgD2ooAgAiDTYCAAJ/AkAgAkEBaiIHIAZPDQAgDSAIIAdBMGxqIgZBBGoiEiAPaigCAEcNACAOIBJqKAIAIg0gDEEBakcNACAMIA1zQQFLDQAgBSkDKCEZIAUpAyAhFCAFKQMQIRUgBSkDGCEcIARByABqIgggBikDKCIWNwMAIARBQGsiByAGKQMgIhM3AwAgCyAGKQMYIh03AwAgBCAGKQMQIhc3AzAgAykDGCEfIAMpAxAhGiALIB0gHH0iGyAXIBV9IhggF1atfSIXIBcgAykDCHwiHiAYIAMpAwB8IiAgGFStfCIhIBYgFiAZfSIWVCAWIBYgEyATIBR9IhNUIBMgGyAdViAXIBtWcq19IhYgE1ZyrX0iE1RyrVAiBRs3AwAgByAWIBYgGnwiGiAXIB5WIB4gIVZyrXwiFyAFGzcDACAIIBMgFyAaVCAWIBpWcq0gEyAffHwgBRs3AwAgBCAYICAgBRs3AzAgAyAEQTBqIAEQpAkgBCADKQM4Ih0gGSAIKQMAfCIaIBQgBykDAHwiGCAUVCAYIBwgCykDAHwiFCAcVCAUIBUgBCkDMHwiHCAVVK18IhUgFFRyrXwiFCAYVHKtfCIYfCIXIAMpAzAiEyAUfCIWIBNUIBYgAykDKCIbIBV8IhMgG1QgEyADKQMgIhsgHHwiHiAbVK18IhsgE1RyrXwiEyAWVHKtfCIWIBggGCAaVCAZIBpWciAWIBdUIBcgHVRycyIFGzcDKCAEIBMgFCAFGzcDICAEIBsgFSAFGzcDGCAEIB4gHCAFGzcDECAAKAIEIQggAkECagwBCwJAIAxBAXFFBEAgBSkDECEZIAUpAxghFCAFKQMgIRUgBCAFKQMoIho3A0ggBCAVNwNAIAQgFDcDOCAEIBk3AzAgAyAEQTBqIAEQpAkgBCAaIAQpA0h9IhggFSAEKQNAfSIXIBVWIBcgFCAEKQM4fSIVIBRWIBUgGSAEKQMwfSIUIBlWrX0iGSAVVnKtfSIVIBdWcq19IhcgFSADKQMQfCIWIBVUIBYgGSADKQMIfCITIBlUIBMgFCADKQMAfCIdIBRUrXwiGyATVHKtfCITIBZUcq0gFyADKQMYfHwgGCAaViAXIBhWcq1QIgIbNwMoIAQgFSATIAIbNwMgIAQgGSAbIAIbNwMYIAQgFCAdIAIbNwMQDAELIARBQGsiAiAFQRBqIgX9AAMQ/QsDACAEIAX9AAMA/QsDMCADIARBMGogARCkCSAKIAL9AAMA/QsDECAKIAT9AAMw/QsDAAsgBwshAiAIIAlBMGxqIgUgBP0AAwD9CwMAIAUgBP0AAyD9CwMgIAUgCv0AAwD9CwMQIAlBAWohCSACIAAoAgAiBkkNAAsLIAAgCTYCACAEQdAAaiQAC8ECAQF/IwBBgAFrIgMkAAJAAkACQCABQQFGBEAgAigCAA0BIAIoAgQNAiACKAIIDQMgACAC/QADEP0LAwAgACAC/QADIP0LAxAgA0GAAWokAA8LIANBs/IrNgJwQeQAQfSHKiADQfAAahCbCUGQljQoAgAoAgAhAiADQbPyKzYCYCACQZGMKiADQeAAahBsAAsgA0GK8ys2AlBB5ABB9IcqIANB0ABqEJsJQZCWNCgCACgCACECIANBivMrNgJAIAJBkYwqIANBQGsQbAALIANBp/MrNgIwQeQAQfSHKiADQTBqEJsJQZCWNCgCACgCACECIANBp/MrNgIgIAJBkYwqIANBIGoQbAALIANBl/MrNgIQQeQAQfSHKiADQRBqEJsJQZCWNCgCACgCACECIANBl/MrNgIAIAJBkYwqIAMQbAALxQEBA38jAEEQayIEJAAgBEEBOgAHIAAoAnghBSAAQQA2AnggBQRAIAUQKwsgAEEEaiIGIARBB2pBARCqCSAEQQA2AAwgBCACOgAIIAQgAkEYdjoACyAEIAJBEHY6AAogBCACQQh2OgAJIAAoAnghBSAAQQA2AnggBQRAIAUQKwsgBiAEQQhqQQgQqgkgAgRAQQAhBQNAIAAgASAFQQV0aiIG/QADACAG/QADECADEPMKIAVBAWoiBSACRw0ACwsgBEEQaiQAC9Y8AiV/G34jAEHQGmsiCSQAIAAoAhghJSAAKAIUIRwgACgCECEMIAlBADYCyBkgCUIANwPAGQJAAkACQAJAAkACQAJAAkACQCAMBEAgDEHyksMATw0BIAkgDEHAHmwiChCiCSIMNgLAGSAJIAogDGo2AsgZIApBwB5rIgogCkHAHnBrQcAeaiIKBEAgDEEAIAr8CwALIAkgCiAMajYCxBkLIAYgCUHABWpBKCAIEO0KIAYgCUHAD2oiGEEoIAgQ7QogCSAAKAIEIh02AugEIAkgCEH4AGoiDP0AAwD9CwOABSAJIAj9AANo/QsD8AQgCSAM/QADAP0LA6AFIAkgCP0AA2j9CwOQBSAJIBg2ArQFIAkgGDYCuAUgCSAJQcAFajYCsAUgCSAIQZgBaiIK/QADAP0LA9gCIAkgCP0AA4gB/QsDyAIgCSAM/QADAP0LA/gCIAkgCP0AA2j9CwPoAiAJIAz9AAMA/QsDmAMgCSAI/QADaP0LA4gDIAlByAJqIAgQggsgCSAM/QADAP0LA7gDIAkgCP0AA2j9CwOoAyAJIAr9AAMA/QsD2AMgCSAI/QADiAH9CwPIAyAJIAz9AAMA/QsD+AMgCSAI/QADaP0LA+gDIAlBqANqIiYgCBCCCyAJIAz9AAMA/QsDmAQgCSAI/QADaP0LA4gEIAkgDP0AAwD9CwO4BCAJIAj9AANo/QsDqAQgCSAK/QADAP0LA9gEIAkgCP0AA4gB/QsDyAQgCUGIBGoiJyAIEIILIAAoAgwNASAAKAIQRQRAIBghHgwGCyAIQYgBaiEfIAhB6ABqIREgCUGQBWohISAJQfAEaiEpIAlBqAFqIRMgCUHoBGpBBHIhIiAJQaQBaiEoIAlB4AFqISMgCUHAAWohFSAJQbgBaiEgIBghHgNAIBQgACgCJCAAKAIgIgxrQQxtTw0DIAIoAgAhCyAGIAggCSgCwBkgFEHAHmxqIhYgFkEgaiIqEO4KIAwgFEEMbGoiGigCBCINRQ0EIAkgDTYCxAIgCSARQRBqIgr9AAMA/QsDkAIgCSAR/QADAP0LA4ACIA1BAnRBBmoiDEGAgIDAAE8NByALIBRBwOQAbGohGyAJIAxBBXQiCxCiCSIMNgKgAiAJIAsgDGoiDjYCqAJBACELA0AgDCAR/QADAP0LAwAgDCAK/QADAP0LAxAgDEEgaiEMIAtBAWoiC0ECRw0ACyANQQd0QaABakHgAE8EQANAIAwgEf0AAwD9CwMAIAwgCv0AAwD9CwMQIAwgCv0AAwD9CwMwIAwgEf0AAwD9CwMgIAwgEf0AAwD9CwNAIAwgCv0AAwD9CwNQIAwgEf0AAwD9CwNgIAwgCv0AAwD9CwNwIAxBgAFqIgwgDkcNAAsLIAkgCDYCtAIgCSAINgKsAiAJIA42AqQCIAkgCUHEAmo2ArACIAlBsAFqIgwgFv0AAxD9CwMAIAkgFv0AAwD9CwOgASAJQYACakEAICkgHxCDCyAJQYACakEBICEgCUGgAWoQgwsgGigCBARAIBZBwBRqISQgG0GAxgBqISsgFkHACmohLCAbQYAoaiEtQQAhCwNAIAlBoAFqIAYgCCAtIAtB4ABsIg1qIg8Q9QogLCALQQV0IhBqIg4gDP0AAwD9CwMQIA4gCf0AA6AB/QsDACAJQbAaaiAJQcgCaiAOIAgQhAsgDCAJQcAaaiIK/QADAP0LAwAgCSAJ/QADsBr9CwOgASAJQbAaaiAmIA4gCBCECyAVQRBqIhIgCv0AAwD9CwMAIBUgCf0AA7Aa/QsDACAJQbAaaiAnIA4gCBCECyAjQRBqIhcgCv0AAwD9CwMAICMgCf0AA7Aa/QsDACAJQYACaiALQQF0IhkgCUGgAWogDxCFCyAJQaABaiAGIAggDSAraiINEPUKIBAgJGoiDiAM/QADAP0LAxAgDiAJ/QADoAH9CwMAIAlBsBpqIAlByAJqIA4gCBCECyAMIAr9AAMA/QsDACAJIAn9AAOwGv0LA6ABIAlBsBpqICYgDiAIEIQLIBIgCv0AAwD9CwMAIBUgCf0AA7Aa/QsDACAJQbAaaiAnIA4gCBCECyAXIAr9AAMA/QsDACAjIAn9AAOwGv0LAwAgCUGAAmogGUEBciAJQaABaiANEIULIAtBAWoiCyAaKAIESQ0ACwsCQCADRQRAIBooAgghDkEQEKIJIQ0gDigCACEPIA1BADYCDCANQgA3AgQgDSAPNgIAAkAgD0UNACAPQdaq1SpPDQggDSAPQTBsIhAQogkiCzYCBCANIAsgEGo2AgxBACEKIBBBMGsiECAQQTBwa0EwaiIQBEAgC0EAIBD8CwALIA0gCyAQajYCCCAPQQNxIRcgDigCBCEOIA9BBE8EQCAPQfz//z9xIRIDQCALIApBMGwiEGoiDyAOIBBqIhD9AAMA/QsDACAPIBD9AAMg/QsDICAPIBD9AAMQ/QsDECALIApBAXJBMGwiEGoiDyAOIBBqIhD9AAMg/QsDICAPIBD9AAMQ/QsDECAPIBD9AAMA/QsDACALIApBAnJBMGwiEGoiDyAOIBBqIhD9AAMg/QsDICAPIBD9AAMQ/QsDECAPIBD9AAMA/QsDACALIApBA3JBMGwiEGoiDyAOIBBqIhD9AAMg/QsDICAPIBD9AAMQ/QsDECAPIBD9AAMA/QsDACAKQQRqIgogEkcNAAsLQQAhEiAXRQ0AA0AgCyAKQTBsIhBqIg8gDiAQaiIQ/QADAP0LAwAgDyAQ/QADIP0LAyAgDyAQ/QADEP0LAxAgCkEBaiEKIBJBAWoiEiAXRw0ACwsgDSAdIB4gGCAWICogCBDwCiAaKAIEBEAgFkHAFGohDiAWQcAKaiEPQQAhCgNAIA0gDyAKQQV0IgtqQQAgCBD2CiANIAsgDmpBASAIEPYKIApBAWoiCiAaKAIESQ0ACwsgCUGAAWogDSgCACANKAIEEPcKIA0oAgQiCgRAIA0gCjYCCCAKECsLIA0QKwwBCyAJIAMoAgAgFEEFdGoiCv0AAxD9CwOQASAJIAr9AAMA/QsDgAELIAAoAgghDiAAKAIMIQ8gCUHAGmoiEiAfQRBqIgr9AAMA/QsDACAJIB/9AAMA/QsDsBogCUHwAGoiFyAK/QADAP0LAwAgCSAf/QADAP0LA2AgFkFAayEQIA8EQCAIKQM4ITggCCkDMCEzIAgpAyghNiAIKQMgITcgCCkDGCFBIAgpAxAhQiAIKQMIIUMgCCkDACFGIAgpA6ABIT0gCCkDmAEhNCAIKQOQASEyIAgpA4gBITFBACENA0AgDUEFdCILIAlBwAVqaiIKKQMYITUgCikDECE6IAopAwAhOSAKKQMIITsgCSA9IAsgEGoiCikDGH0iPiA0IAopAxB9IjwgNFYgPCAyIAopAwh9Ii4gMlYgLiAxIAopAwB9Ii8gMVatfSIwIC5Wcq19Ii4gPFZyrX0iPCAuIEJ8IkAgLlQgQCAwIEN8Ij8gMFQgPyAvIEZ8IkQgL1StfCJFID9Ucq18Ij8gQFRyrSA8IEF8fCA9ID5UIDwgPlZyrVAiCxs3A6gaIAkgLiA/IAsbNwOgGiAJIDAgRSALGzcDmBogCSAvIEQgCxs3A5AaICAgPSA1fSI+IDQgOn0iPCA0ViA8IDIgO30iLiAyViAuIDEgOX0iLyAxVq19IjAgLlZyrX0iLiA8VnKtfSI8IC4gQnwiQCAuVCBAIDAgQ3wiPyAwVCA/IC8gRnwiRCAvVK18IkUgP1RyrXwiPyBAVHKtIDwgQXx8ID0gPlQgPCA+VnKtUCILGzcDACAMIC4gPyALGzcDACATIDAgRSALGzcDACAJIC8gRCALGzcDoAEgCCAJQaABaiAJQZAaahCkCSAJQYAaaiAM/QADAP0LAwAgCSAJ/QADoAH9CwPwGSAgIDU3AwAgDCA6NwMAIBMgOzcDACAJIDk3A6ABIAggCUGgAWogChCkCSAJQeAZaiAM/QADAP0LAwAgCSAJ/QADoAH9CwPQGQJAIA5BAXFFBEAgCCAJQeAAaiAJQdAZahCkCSAMIBL9AAMA/QsDACAJIAn9AAOwGv0LA6ABIAggCUGgAWogCUHwGWoQpAkgCSA3IAkpA2AiOiAJKQOgAXwiL3wiPiAvIAkpA3giLiAgKQMAfCIwIC5UIDAgCSkDcCI1IAwpAwB8Ii4gNVQgLiAJKQNoIjkgEykDAHwiNSA5VCA1IC8gOlStfCI6IDVUcq18IjUgLlRyrXwiLiAwVHIgLiA4fCIwIDhUIDAgMyA1fCI5IDNUIDkgNiA6fCI7IDZUIDsgNyA+Vq18Ij4gO1RyrXwiOyA5VHKtfCI5IDBUcnMiChs3A2AgCSA+IDogChs3A2ggCSA7IDUgChs3A3AgCSA5IC4gChs3A3gMAQsgCCAJQeAAaiAJQfAZahCkCQsgCSA4IAkpA4gaIjwgCSkD6Bl8Ii8gCSkDgBoiLiAJKQPgGXwiMCAuVCAwIAkpA/gZIjUgCSkD2Bl8Ii4gNVQgLiAJKQPwGSI6IAkpA9AZfCI1IDpUrXwiOiAuVHKtfCIuIDBUcq18IjB8IjkgLiAzfCI7IDNUIDsgNiA6fCI+IDZUID4gNSA3fCJAIDdUrXwiPyA+VHKtfCI+IDtUcq18IjsgMCAvIDxUIC8gMFZyIDggOVYgOSA7VnJzIgobNwO4ASAJID4gLiAKGzcDsAEgCSA/IDogChs3A6gBIAkgQCA1IAobNwOgASAIIAlBsBpqIAlBoAFqEKQJIA5BAWpBAXYhDiANQQFqIg0gD0cNAAsLIAwgF/0AAwD9CwMAIAkgCf0AA2D9CwOgASAIIAlBoAFqIAlBgAFqEKQJIBMpAwAhNCAMKQMAITIgCSkDoAEhMSAJKAK0AiEKIAkgICkDACI4NwO4ASAJIDI3A7ABIAkgNDcDqAEgCSAxNwOgASASIBtBkOQAav0AAwD9CwMAIAkgG/0AA4Bk/QsDsBogCiAJQbAaaiAbQaDkAGoiFxCkCSAJQaAaaiAS/QADAP0LAwAgCSAJ/QADsBr9CwOQGiAKIAlBoAFqIAlBkBpqEKQJIAkgCSkDuAEiOiAJKQOYAn0iMyAJKQOwASIvIAkpA5ACfSI2IC9WIDYgCSkDqAEiLyAJKQOIAn0iLiAvViAuIAkpA6ABIjAgCSkDgAJ9Ii8gMFatfSIwIC5Wcq19Ii4gNlZyrX0iNiAuIAopAxB8IjcgLlQgNyAwIAopAwh8IjUgMFQgNSAvIAopAwB8IjkgL1StfCI7IDVUcq18IjUgN1RyrSA2IAopAxh8fCAzIDZUIDMgOlZyrVAiCxs3A8gaIAkgLiA1IAsbNwPAGiAJIDAgOyALGzcDuBogCSAvIDkgCxs3A7AaAn8gCSgCpAIiCyAJKAKgAiINRgRAQQAhDkEADAELIAsgDWsiC0EASA0IIAsQogkhDiALBEAgDiANIAv8CgAACyALIA5qCyEkIAkoArACKAIAIQsgCSA4NwO4ASAJIDI3A7ABIAkgNDcDqAEgCSAxNwOgASAKIAlBoAFqIBcQpAkgCSkDuAEhNiAJKQOwASEzIAkpA6gBITAgDiALQQd0aiILIAspA2AiNyAJKQOgAX0iLzcDYCALIAspA2giNSAwfSIuIC8gN1atfSIwNwNoIAsgCykDcCI3IDN9IjMgLiAwVCAuIDVWcq19Ii43A3AgCyALKQN4IjUgNn0iNiAuIDNWIDMgN1ZyrX0iMzcDeCAKKQMYITcgCikDECE6IAopAwghOSALIC8gLyAKKQMAfCI7IDUgNlQgMyA2VnKtUCINGzcDYCALIDAgMCA5fCI2IC8gO1atfCI1IA0bNwNoIAsgLiAuIDp8Ii8gNSA2VCAwIDZWcq18IjAgDRs3A3AgCyAzIC4gL1YgLyAwVnKtIDMgN3x8IA0bNwN4IAkgODcDuAEgCSAyNwOwASAJIDQ3A6gBIAkgMTcDoAEgCiAJQaABaiAbQYDkAGoiEhCkCSAJKQO4ASE2IAkpA7ABITMgCSkDqAEhMCALQYABaiINIA0pAwAiNyAJKQOgAX0iLzcDACALQYgBaiIPIA8pAwAiNSAwfSIuIC8gN1atfSIwNwMAIAtBkAFqIhkgGSkDACI3IDN9IjMgLiAwVCAuIDVWcq19Ii43AwAgC0GYAWoiCyALKQMAIjUgNn0iNiAuIDNWIDMgN1ZyrX0iMzcDACAKKQMYITcgCikDECE6IAopAwghOSANIC8gLyAKKQMAfCI7IDUgNlQgMyA2VnKtUCIKGzcDACAPIDAgMCA5fCI2IC8gO1atfCI1IAobNwMAIBkgLiAuIDp8Ii8gNSA2VCAwIDZWcq18IjAgChs3AwAgCyAzIC4gL1YgLyAwVnKtIDMgN3x8IAobNwMAIAkoArQCIQogDiAJKAKwAigCAEEHdGoiC0GgAWoiDSANKQMAIjAgMX0iMTcDACALQagBaiIPIA8pAwAiLiA0fSIvIDAgMVStfSI0NwMAIAtBsAFqIhkgGSkDACIzIDJ9IjAgLiAvVCAvIDRUcq19IjI3AwAgC0G4AWoiCyALKQMAIjYgOH0iLiAwIDJUIDAgM1ZyrX0iLzcDACAKKQMYITAgCikDECE4IAopAwghMyANIDEgMSAKKQMAfCI3IC4gL1QgLiA2VnKtUCIKGzcDACAPIDQgMyA0fCI9IDEgN1atfCIuIAobNwMAIBkgMiAyIDh8IjEgLiA9VCA0ID1Wcq18Ij0gChs3AwAgCyAvIDEgMlQgMSA9VnKtIC8gMHx8IAobNwMAIAUgCUGwGmoQqApBAEEDIBQbIgogJCAOa0EFdSINSQRAIAdBA2shDwNAIAkgFDYCoAEgCSAKIA9qNgKkASATIA4gCkEFdGoiC/0AAwD9CwMAIBMgC/0AAxD9CwMQIAQgCUGgAWoQ1QkgCkEBaiIKIA1HDQALCyAOECsgBiASQQIgCBD4CiAaKAIEIR0gKCAS/QACEP0LAhAgKCAS/QACAP0LAgAgISAX/QADEP0LAxAgISAX/QADAP0LAwAgCSAdNgLoBCAiIBUoAgA2AiAgIiAM/QACAP0LAhAgIiAJ/QACoAH9CwIAIAkgFkHAFGoiGDYCuAUgCSAWQcAKaiIeNgK0BSAJIBA2ArAFIAcgCSgCxAJBAnRqIQogCSgCoAIiDARAIAkgDDYCpAIgDBArCyAKQQNqIQcgFEEBaiIUIAAoAhBJDQALDAULEKAJAAsgCUG/8Cs2AlBB5ABB9IcqIAlB0ABqEJsJQZCWNCgCACgCACEIIAlBv/ArNgJAIAhBkYwqIAlBQGsQbAALEKAJAAsgCUH18is2AjBB5ABB9IcqIAlBMGoQmwlBkJY0KAIAKAIAIQggCUH18is2AiAgCEGRjCogCUEgahBsAAsQoAkACwNAIAYgCUGAAmpBICAGKAIAKAIIEQEAIAkpA5gCIjQgCCkDGCIyVCAyIDRRIAkpA5ACIjIgCCkDECIxVCAxIDJRIAkpA4gCIjEgCCkDCCIvVCAvIDFRIAkpA4ACIjAgCCkDAFRxcnFycXKtUA0ACyAJIDQ3A7gBIAkgMjcDsAEgCSAxNwOoASAJIDA3A6ABIAggCUGgAWogCEFAaxCkCSAJLQCgASEKIAkpA6gBIUEgCSkDsAEhQiAJKQO4ASFDIAk1AKEBITQgCTMApQEhMiACKAIAIAAoAhBBwOQAbGoiDEEoaykDACExIAxBMGspAwAhLyAMQUBqKQMAITAgDEE4aykDACEuIAkgCTEApwEiOjwApwEgCSAyPQClASAJIDQ+AKEBIAkgQzcDuAEgCSBCNwOwASAJIEE3A6gBIAkgCjoAoAEgCCAJQaABaiAMQSBrEKQJIBxBgICAwABPDQAgCCkDOCI3IDEgCSkDuAF8IjggLyAJKQOwAXwiMyAvVCAzIC4gCSkDqAF8Ii8gLlQgLyAwIAkpA6ABfCIuIDBUrXwiMCAvVHKtfCIvIDNUcq18IjN8IjYgN1QgNiAIKQMwIjUgL3wiNyA1VCA3IAgpAygiOSAwfCI1IDlUIDUgCCkDICI5IC58IjsgOVStfCI5IDVUcq18IjUgN1RyrXwiNyA2VHIhESAzIDhUIDEgOFZyIRMgOkIwhiAyQiCGhCEyIAqtITFBACEMIBxBBXQiCxCiCSEOIAtFIhVFBEAgDkEAIAv8CwALIBEgE3MhCiAyIDSEITQgMUL/AYMhMiAOIB0gHCAeIAgQ7wogCxCiCSERIBVFBEAgEUEAIAv8CwALIDcgMyAKGyFEIDUgLyAKGyFFIDkgMCAKGyFHIDsgLiAKGyFIIBEgHSAcIBggCBDvCiA0QgiGIDKEIUYgCCkDgAEhPCAIKQN4IUAgCCkDcCE/IAgpA2ghPQNAIA4gDEEFdCILaiIKKQMYITQgCikDECEyIAopAwAhMSAKKQMIIS8gCSBDNwO4ASAJIEI3A7ABIAkgQTcDqAEgCSBGNwOgASAIIAlBoAFqIAsgEWoQpAkgCCkDOCIwIDQgCSkDuAF8Ii4gMiAJKQOwAXwiOCAyVCA4IC8gCSkDqAF8IjIgL1QgMiAxIAkpA6ABfCIvIDFUrXwiMSAyVHKtfCIyIDhUcq18Ijh8IjMgCCkDMCI2IDJ8IjcgNlQgNyAIKQMoIjUgMXwiOiA1VCA6IAgpAyAiOSAvfCI7IDlUrXwiPiA6VHKtfCI6IDdUcq18IjcgOCAuIDRUIC4gOFZyIDAgM1YgMyA3VnJzIgobITQgOiAyIAobITIgPiAxIAobITEgOyAvIAobIS8CQCAMICVJBEAgASgCCCEKIAkgNDcDuAEgCSAyNwOwASAJIDE3A6gBIAkgLzcDoAEgCCAJQaABaiAKIAtqEKQJIDAgPCAJKQO4AXwiNCBAIAkpA7ABfCIyIEBUIDIgPyAJKQOoAXwiMSA/VCAxID0gCSkDoAF8Ii8gPVStfCIuIDFUcq18IjEgMlRyrXwiMnwiOCAxIDZ8IjMgNlQgMyAuIDV8IjYgNVQgNiAvIDl8IjcgOVStfCI1IDZUcq18IjYgM1RyrXwiMyAyIDQgPFQgMiA0VHIgMyA4VCAwIDhWcnMiChshPCA2IDEgChshQCA1IC4gChshPyA3IC8gChshPQwBCyAJIDQ3A8ABIAkgMjcDuAEgCSAxNwOwASAJIC83A6gBIAkgFDYCoAEgCSAMICVrNgKkASAEIAlBoAFqENUJCyAMQQFqIgwgHEcNAAsgB0ECTQ0BIAkgFDYCoAEgCSAHQQNrNgKkASAJIAj9AAOYAv0LA7gBIAkgCP0AA4gC/QsDqAEgBCAJQaABahDVCSAJIAdBAms2AqQBIAkgFDYCoAEgCSAIKQOAASIzIEN9Ii8gCCkDeCI0IEJ9IjAgNFYgMCAIKQNwIjQgQX0iMSA0ViAxIAgpA2giMiBGfSI0IDJWrX0iMiAxVnKtfSIxIDBWcq19IjAgMSAIKQMQfCIuIDFUIC4gMiAIKQMIfCI4IDJUIDggNCAIKQMAfCI2IDRUrXwiNyA4VHKtfCI4IC5Ucq0gMCAIKQMYfHwgLyAwVCAvIDNWcq1QIgwbNwPAASAJIDEgOCAMGzcDuAEgCSAyIDcgDBs3A7ABIAkgNCA2IAwbNwOoASAEIAlBoAFqENUJIEUgQH0iLyBHID99IjEgR1YgMSBIID19IjQgSFatfSIyIDFWcq19IjEgMSAIKQMQfCIwIDIgCCkDCHwiLiAyVCAuIDQgCCkDAHwiOCA0VK18IjMgLlRyrXwiNiBEIDx9Ii4gRFYgLiAvIDFUIC8gRVZyrX0iLyAuVnKtUCIMGyE9IC8gMCAxVCAwIDZWcq0gLyAIKQMYfHwgDBshMSAyIDMgDBshMiA0IDggDBshNAJAIAUoAgQiCCAFKAIIIgtJBEAgCCAxNwMYIAggPTcDECAIIDI3AwggCCA0NwMAIAhBIGohCAwBCyAIIAUoAgAiDGsiCkEFdSIVQQFqIghBgICAwABPDQFB////PyALIAxrIgtBBHUiEyAIIAggE0kbIAtB4P///wdPGyILBH8gC0GAgIDAAE8NBCALQQV0EKIJBUEACyITIApqIgggMTcDGCAIID03AxAgCCAyNwMIIAggNDcDACAIIBVBBXRrIRUgCgRAIBUgDCAK/AoAAAsgBSATIAtBBXRqNgIIIAUgCEEgaiIINgIEIAUgFTYCACAMRQ0AIAwQKwsgBSAINgIEIBEQKyAOECsgCSgCwBkiCARAIAkgCDYCxBkgCBArCyAJQdAaaiQAIBRBAWoPCxCgCQALIAlB2f4rNgIQQeQAQfSHKiAJQRBqEJsJQZCWNCgCACgCACEIIAlB2f4rNgIAIAhBkYwqIAkQbAALEKAJAAuyFAIMfw1+IwBB4ABrIgwkAAJAIAEoAiQgASgCMGwiC0UNACALQQNxIRAgCEHoAGohCiALQQRPBEAgAEHgAGohEyAAQUBrIREgAEEgaiESIAtBfHEhFANAIAAgCUEFdCILaiINIAr9AAMA/QsDACANIApBEGoiDf0AAwD9CwMQIAsgEmoiDyAN/QADAP0LAxAgDyAK/QADAP0LAwAgCyARaiIPIA39AAMA/QsDECAPIAr9AAMA/QsDACALIBNqIgsgDf0AAwD9CwMQIAsgCv0AAwD9CwMAIAlBBGoiCSAURw0ACwsgEEUNAANAIAAgCUEFdGoiCyAK/QADAP0LAwAgCyAK/QADEP0LAxAgCUEBaiEJIA5BAWoiDiAQRw0ACwsCQAJAIAMEQCABKAIAIQ9BACELIAxB0ABqIQ0gDEHIAGohEANAIAQgC0EobGoiCigCBCIJIA9PDQMgCigCACIOIAJPDQIgDSAK/QADGP0LAwAgDCAK/QADCP0LA0AgCCAMQUBrIAUgDkEFdGoQpAkgDCkDWCEXIA0pAwAhFSAQKQMAIRggACAJQQV0aiIKIAopAwAiGSAMKQNAfCIeNwMAIAogGCAKKQMIIhp8IhYgGSAeVq18Ihg3AwggCiAVIAopAxAiGXwiFSAWIBpUIBYgGFZyrXwiFjcDECAKIBcgCikDGCIcfCIXIBUgGVQgFSAWVnKtfCIVNwMYIAogCCkDOCIgIBV8IhkgCCkDMCIbIBZ8IhogG1QgGiAIKQMoIh0gGHwiGyAdVCAbIAgpAyAiHSAefCIfIB1UrXwiHSAbVHKtfCIbIBpUcq18IhogFSAXIBxUIBUgF1RyIBkgIFQgGSAaVnJzIgkbNwMYIAogGyAWIAkbNwMQIAogHSAYIAkbNwMIIAogHyAeIAkbNwMAIAtBAWoiCyADRw0ACwsgASgCLCISBEAgACABKAIkIgQgASgCKGxBBXRqIg8gBCASbEEFdCIKaiIQIApqIRMgASgCBCEFQQAhEQNAAkAgBEUNACAEIBFsIQJBACEOA0AgAiAOaiILIAVPDQEgDyALQQV0IgNqIgkgCSkDACIYIAcgC0HgAGxqIgopAwB8Ih43AwAgCSAJKQMIIhcgCikDCHwiFiAYIB5WrXwiGDcDCCAJIAkpAxAiGSAKKQMQfCIVIBYgF1QgFiAYVnKtfCIWNwMQIAkgCSkDGCIcIAopAxh8IhcgFSAZVCAVIBZWcq18IhU3AxggCSAIKQM4IiAgFXwiGSAIKQMwIhsgFnwiGiAbVCAaIAgpAygiHSAYfCIbIB1UIBsgCCkDICIdIB58Ih8gHVStfCIdIBtUcq18IhsgGlRyrXwiGiAVIBcgHFQgFSAXVHIgGSAgVCAZIBpWcnMiDRs3AxggCSAbIBYgDRs3AxAgCSAdIBggDRs3AwggCSAfIB4gDRs3AwAgACAGIAtBDGxqIg0oAgBBBXRqIgkgCSkDACIWIAopAwB9Ihg3AwAgCSAJKQMIIhUgCikDCH0iHiAWIBhUrX0iFjcDCCAJIAkpAxAiGiAKKQMQfSIXIBUgHlQgFiAeVnKtfSIVNwMQIAkgCSkDGCIbIAopAxh9IhkgFSAXViAXIBpWcq19Ihc3AxggCCkDGCEaIAgpAxAhHCAIKQMIISAgCSAYIBggCCkDAHwiHUIAIh4gGSAbViAXIBlWcq1RIgsbNwMAIAkgFiAWICB8IhkgGCAdVq18IhsgCxs3AwggCSAVIBUgHHwiGCAWIBlWIBkgG1ZyrXwiFiALGzcDECAJIBcgFiAYVCAVIBhWcq0gFyAafHwgCxs3AxggAyAQaiIJIAkpAwAiFiAKKQMgfCIYNwMAIAkgCSkDCCIZIAopAyh8IhUgFiAYVq18IhY3AwggCSAJKQMQIhogCikDMHwiFyAVIBlUIBUgFlZyrXwiFTcDECAJIAkpAxgiICAKKQM4fCIZIBcgGlQgFSAXVHKtfCIXNwMYIAkgCCkDOCIdIBd8IhogCCkDMCIcIBV8IhsgHFQgGyAIKQMoIh8gFnwiHCAfVCAcIAgpAyAiHyAYfCIhIB9UrXwiHyAcVHKtfCIcIBtUcq18IhsgFyAZICBUIBcgGVRyIBogHVQgGiAbVnJzIgsbNwMYIAkgHCAVIAsbNwMQIAkgHyAWIAsbNwMIIAkgISAYIAsbNwMAIAAgDSgCBEEFdGoiCSAJKQMAIhYgCikDIH0iGDcDACAJIAkpAwgiGSAKKQMofSIVIBYgGFStfSIWNwMIIAkgCSkDECIaIAopAzB9IhcgFSAWVCAVIBlWcq19IhU3AxAgCSAJKQMYIhsgCikDOH0iGSAVIBdWIBcgGlZyrX0iFzcDGCAIKQMYIRogCCkDECEcIAgpAwghICAJIBggGCAIKQMAfCIdIB4gGSAbViAXIBlWcq1RIgsbNwMAIAkgFiAWICB8IhkgGCAdVq18IhsgCxs3AwggCSAVIBUgHHwiGCAWIBlWIBkgG1ZyrXwiFiALGzcDECAJIBcgFiAYVCAVIBhWcq0gFyAafHwgCxs3AxggAyATaiIJIAkpAwAiFiAKKQNAfCIYNwMAIAkgCSkDCCIZIAopA0h8IhUgFiAYVq18IhY3AwggCSAJKQMQIhogCikDUHwiFyAVIBlUIBUgFlZyrXwiFTcDECAJIAkpAxgiICAKKQNYfCIZIBcgGlQgFSAXVHKtfCIXNwMYIAkgCCkDOCIdIBd8IhogCCkDMCIcIBV8IhsgHFQgGyAIKQMoIh8gFnwiHCAfVCAcIAgpAyAiHyAYfCIhIB9UrXwiHyAcVHKtfCIcIBtUcq18IhsgFyAZICBUIBcgGVRyIBogHVQgGiAbVnJzIgsbNwMYIAkgHCAVIAsbNwMQIAkgHyAWIAsbNwMIIAkgISAYIAsbNwMAIAAgDSgCCEEFdGoiCSAJKQMAIhYgCikDQH0iGDcDACAJIAkpAwgiGSAKKQNIfSIVIBYgGFStfSIWNwMIIAkgCSkDECIaIAopA1B9IhcgFSAWVCAVIBlWcq19IhU3AxAgCSAJKQMYIhsgCikDWH0iGSAVIBdWIBcgGlZyrX0iFzcDGCAIKQMYIRogCCkDECEcIAgpAwghICAJIBggGCAIKQMAfCIdIB4gGSAbViAXIBlWcq1RIgobNwMAIAkgFiAWICB8Ih4gGCAdVq18IhkgChs3AwggCSAVIBUgHHwiGCAZIB5UIBYgHlZyrXwiHiAKGzcDECAJIBcgFSAYViAYIB5Wcq0gFyAafHwgChs3AxggDkEBaiIOIARHDQALCyARQQFqIhEgEkcNAAsLIAxB4ABqJAAPCyAMQd7HKjYCEEHkAEH0hyogDEEQahCbCUGQljQoAgAoAgAhCCAMQd7HKjYCACAIQZGMKiAMEGwACyAMQc+/KTYCMEHkAEH0hyogDEEwahCbCUGQljQoAgAoAgAhCCAMQc+/KTYCICAIQZGMKiAMQSBqEGwAC4kDAgd/DH4jAEEgayIGJAAgAARAIAZBGGohCSAGQQhqIQoDQCAGQRBqIgcgAyAIQQV0IgVqIgv9AAMQ/QsDACAGIAv9AAMA/QsDACAEIAYgAiAFahCkCSAJKQMAIRMgBykDACEMIAopAwAhESABIAVqIgUgBSkDACINIAYpAwB8IhQ3AwAgBSARIAUpAwgiDnwiDyANIBRWrXwiETcDCCAFIAwgBSkDECINfCIMIA8gEVYgDiAPVnKtfCIPNwMQIAUgEyAFKQMYIhV8IhMgDCANVCAMIA9Wcq18Igw3AxggBSAEKQM4IhYgDHwiDSAEKQMwIhAgD3wiDiAQVCAOIAQpAygiEiARfCIQIBJUIBAgBCkDICISIBR8IhcgElStfCISIBBUcq18IhAgDlRyrXwiDiAMIBMgFVQgDCATVHIgDSAWVCANIA5WcnMiBxs3AxggBSAQIA8gBxs3AxAgBSASIBEgBxs3AwggBSAXIBQgBxs3AwAgCEEBaiIIIABHDQALCyAGQSBqJAAL/wICB38KfiMAQSBrIgYkACAABEAgBkEYaiEJIAZBCGohCgNAIAZBEGoiByADIAhBBXQiBWoiC/0AAxD9CwMAIAYgC/0AAwD9CwMAIAQgBiACIAVqEKQJIAkpAwAhECAHKQMAIQwgCikDACENIAEgBWoiBSAFKQMAIhEgBikDAH0iDjcDACAFIAUpAwgiEiANfSIPIA4gEVatfSINNwMIIAUgBSkDECITIAx9IgwgDyASViANIA9Wcq19Ig83AxAgBSAFKQMYIhIgEH0iESAMIA9UIAwgE1ZyrX0iDDcDGCAEKQMYIRMgBCkDECEUIAQpAwghECAFIA4gDiAEKQMAfCIVIBEgElYgDCARVnKtUCIHGzcDACAFIA0gDSAQfCIQIA4gFVatfCIRIAcbNwMIIAUgDyAPIBR8Ig4gDSAQViAQIBFWcq18Ig0gBxs3AxAgBSAMIA4gD1QgDSAOVHKtIAwgE3x8IAcbNwMYIAhBAWoiCCAARw0ACwsgBkEgaiQAC08BAX8jAEFAaiIDJAAgA0EgakGwiDQgACABEJkJIAMgA/0AAyD9CwQAIAMgA/0AAzD9CwQQIAIgAigCBCADIANBIGpBIBCnCSADQUBrJAALJgEBfyAAQbzNMTYCACAAKAJ4IQEgAEEANgJ4IAEEQCABECsLIAALKAEBfyAAQbzNMTYCACAAKAJ4IQEgAEEANgJ4IAEEQCABECsLIAAQKwuAGgMTfwJ7AX4jAEGgAWsiBCQAAkAgACgCeCIDDQAgBEEAOgCcASAEQQA2ApgBIARBu88BOwE0IARB6pKYvwY2AjAgBCAEQTBqIgU2AiwgBEGuAToANiAEQYX5ADsANyAEQe4AOgA5IARB8+UBOwE6IARBpQE6ADwgBEHP6gM7AD0gBEE6OgA/IARB0Rw7AUAgBEHSADoAQiAEQQU6AEUgBEH/tgI7AEMgBEEfOgBIIARB6JgCOwFGIARBg7MDOwBJIARBqwE6AEsgBCgCLCIDQc0BOgAeIANB28ADOwAcIAQoAiwiA0IANwAgIANBGToAHwJAAkAgAEEoayAERgRAIAQtAJwBDQEgBCgCmAEhAwwCCyAEKAIsIAAoAgQtAAA6AAAgBCgCLCAAKAIELQABOgABIAQoAiwgACgCBC0AAjoAAiAEKAIsIAAoAgQtAAM6AAMgBCgCLCIDIAAoAgQtAAQ6AAQgAyAAKAIELQAFOgAFIAQoAiwiAyAAKAIELQAGOgAGIAMgACgCBC0ABzoAByAEKAIsIgMgACgCBC0ACDoACCADIAAoAgQtAAk6AAkgBCgCLCIDIAAoAgQtAAo6AAogAyAAKAIELQALOgALIAQoAiwiAyAAKAIELQAMOgAMIAMgACgCBC0ADToADSAEKAIsIgMgACgCBC0ADjoADiADIAAoAgQtAA86AA8gBCgCLCIDIAAoAgQtABA6ABAgAyAAKAIELQAROgARIAQoAiwiAyAAKAIELQASOgASIAMgACgCBC0AEzoAEyAEKAIsIgMgACgCBC0AFDoAFCADIAAoAgQtABU6ABUgBCgCLCIDIAAoAgQtABY6ABYgAyAAKAIELQAXOgAXIAQoAiwiAyAAKAIELQAYOgAYIAMgACgCBC0AGToAGSAEKAIsIgMgACgCBC0AGjoAGiADIAAoAgQtABs6ABsgBCgCLCIDIAAoAgQtABw6ABwgAyAAKAIELQAdOgAdIAQoAiwiAyAAKAIELQAeOgAeIAMgACgCBC0AHzoAHyAEKAIsIgMgACgCBC0AIDoAICADIAAoAgQtACE6ACEgBCgCLCIDIAAoAgQtACI6ACIgAyAAKAIELQAjOgAjIAQoAiwiAyAAKAIELQAkOgAkIAMgACgCBC0AJToAJSAEKAIsIgMgACgCBC0AJjoAJiADIAAoAgQtACc6ACcCQCAAKAJwIgNFDQAgA0UNACAEQdgAaiAAQTBqIAP8CgAACyAEIAM2ApgBIAQgAC0AdCIGOgCcASAGQQFHDQELIARB6pKYvwY2AjAgBCAFNgIsIAVBrgE6AAYgBUG7zwE7AAQgBCgCLCIDQe4AOgAJIANBhfkAOwAHIAQoAiwiA0GlAToADCADQfPlATsACiAEKAIsIgNBOjoADyADQc/qAzsADSAEKAIsIgNB0gA6ABIgA0HRHDsAECAEKAIsIgNBBToAFSADQf+2AjsAEyAEKAIsIgNBHzoAGCADQeiYAjsAFiAEKAIsIgNBqwE6ABsgA0GDswM7ABkgBCgCLCIDQc0BOgAeIANB28ADOwAcIAQoAiwiA0IANwAgIANBGToAH0EAIQMgBEEAOgCcASAEQQA2ApgBCyAEIARBLGogBEHYAGogAxCrCUGQAhCiCSIDIAQtAAA6AAAgAyAELQABOgABIAMgBC0AAjoAAiADIAQtAAM6AAMgAyAELQAEOgAEIAMgBC0ABToABSADIAQtAAY6AAYgAyAELQAHOgAHIAMgBC0ACDoACCADIAQtAAk6AAkgAyAELQAKOgAKIAMgBC0ACzoACyADIAQtAAw6AAwgAyAELQANOgANIAMgBC0ADjoADiADIAQtAA86AA8gAyAELQAQOgAQIAMgBC0AEToAESADIAQtABI6ABIgAyAELQATOgATIAMgBC0AFDoAFCADIAQtABU6ABUgAyAELQAWOgAWIAMgBC0AFzoAFyADIAQtABg6ABggAyAELQAZOgAZIAMgBC0AGjoAGiADIAQtABs6ABsgAyAELQAcOgAcIAMgBC0AHToAHSADIAQtAB46AB4gAyAELQAfOgAfQQghBgNAIAMgBkECdGoiBUEBay0AACEHIAVBAmstAAAhCCAFQQNrLQAAIQkgBUEEay0AACEKAkACQAJAIAZBB3EOBQACAgIBAgsgCUHw2DFqIQsgB0Hw2DFqIQwgCEHw2DFqLQAAIQkgCkHw2DFqLQAAIQcgDC0AACEIIAZBA3ZB8Noxai0AACALLQAAcyEKDAELIAdB8Ngxai0AACEHIAhB8Ngxai0AACEIIAlB8Ngxai0AACEJIApB8Ngxai0AACEKCyAFIAVBIGstAAAgCnM6AAAgBSAFQR9rLQAAIAlzOgABIAUgBUEeay0AACAIczoAAiAFIAVBHWstAAAgB3M6AAMgBkEBaiIGQTxHDQALIANBEDYC+AEgA0IANwPwASAAKAJ4IQUgACADNgJ4IAVFDQAgBRArIAAoAnghAwsgAgRAIANB/AFqIRUDQCADAn8gAygC+AEiBUEQRwRAIAUgFWotAAAhDSAFQQFqDAELIANCADcAhAIgAyADKQPwASIYQgF8NwPwASADIBhCOIinIgU6AIMCIAMgAy0AACAYp3MiDToA/AEgAyADLQABIBhCCIincyIOOgD9ASADIAMtAAIgGEIQiKdzIgw6AP4BIAMgAy0AAyAYQhiIp3MiCToA/wEgAyADLQAEIBhCIIincyIPOgCAAiADIAMtAAUgGEIoiKdzIhA6AIECIAMgAy0ABiAYQjCIp3MiCzoAggIgAy0AByAFcyEIIAMtAA8hBSADLQAOIQogAy0ADSERIAMtAAwhEiADLQALIQcgAy0ACiEAIAMtAAkhEyADLQAIIRRBASEGA0AgBUH/AXFB8Ngxai0AACEFIAdB/wFxQfDYMWotAAAhByAIQf8BcUHw2DFqLQAAIQggCUH/AXFB8Ngxai0AACEJIApB/wFxQfDYMWotAAAhCiAAQf8BcUHw2DFqLQAAIQAgC0H/AXFB8Ngxai0AACELIAxB/wFxQfDYMWotAAAhDCARQf8BcUHw2DFqLQAAIREgE0H/AXFB8Ngxai0AACETIBBB/wFxQfDYMWotAAAhECAOQf8BcUHw2DFqLQAAIQ4gEkH/AXFB8Ngxai0AACESIBRB/wFxQfDYMWotAAAhFCAPQf8BcUHw2DFqLQAAIQ8gDUH/AXFB8Ngxai0AACENIAZBDkcEQCADIBD9DyAF/RcBIBP9FwIgCf0XAyAR/RcEIAj9FwUgDv0XBiAH/RcHIBb9DQAAAQECAgMDBAQFBQYGBwcgDf0PIhcgAP0XASAP/RcCIAr9FwMgFP0XBCAM/RcFIBL9FwYgC/0XByAW/Q0AAQEAAgMDAgQFBQQGBwcG/VEiFkEB/WsgFkEH/Wz9DBsbGxsbGxsbGxsbGxsbGxv9Tv1RIBcgEP0XASAA/RcCIAX9FwMgD/0XBCAT/RcFIAr9FwYgCf0XByAU/RcIIBH9FwkgDP0XCiAI/RcLIBL9FwwgDv0XDSAL/RcOIAf9Fw/9USAWIBb9DQICAgIGBgYGCgoKCg4ODg4gFiAW/Q0AAAAABAQEBAgICAgMDAwM/VH9USIW/QsA/AEgAyADIAZBBHRqIgUtAAAgFv0WAHMiDToA/AEgAyAFLQABIBb9FgFzIg46AP0BIAMgBS0AAiAW/RYCcyIMOgD+ASADIAUtAAMgFv0WA3MiCToA/wEgAyAFLQAEIBb9FgRzIg86AIACIAMgBS0ABSAW/RYFcyIQOgCBAiADIAUtAAYgFv0WBnMiCzoAggIgAyAFLQAHIBb9FgdzIgg6AIMCIAMgBS0ACCAW/RYIcyIUOgCEAiADIAUtAAkgFv0WCXMiEzoAhQIgAyAFLQAKIBb9FgpzIgA6AIYCIAMgBS0ACyAW/RYLcyIHOgCHAiADIAUtAAwgFv0WDHMiEjoAiAIgAyAFLQANIBb9Fg1zIhE6AIkCIAMgBS0ADiAW/RYOcyIKOgCKAiADIAUtAA8gFv0WD3MiBToAiwIgBkEBaiEGDAELCyADIAMtAOABIA1zIg06APwBIAMgAy0A4QEgEHM6AP0BIAMgAy0A4gEgAHM6AP4BIAMgAy0A4wEgBXM6AP8BIAMgAy0A5AEgD3M6AIACIAMgAy0A5QEgE3M6AIECIAMgAy0A5gEgCnM6AIICIAMgAy0A5wEgCXM6AIMCIAMgAy0A6AEgFHM6AIQCIAMgAy0A6QEgEXM6AIUCIAMgAy0A6gEgDHM6AIYCIAMgAy0A6wEgCHM6AIcCIAMgAy0A7AEgEnM6AIgCIAMgAy0A7QEgDnM6AIkCIAMgAy0A7gEgC3M6AIoCIAMgAy0A7wEgB3M6AIsCQQELNgL4ASABIA06AAAgAUEBaiEBIAJBAWsiAg0ACwsgBEGgAWokAAuTAgEDfyMAQSBrIgIkACACQQA6AAAgACgCeCEDIABBADYCeCADBEAgAxArCyAAQQRqIgQgAkEBEKoJIAJBADYABCACIAE6AAAgAiABQRh2OgADIAIgAUEQdjoAAiACIAFBCHY6AAEgACgCeCEDIABBADYCeCADBEAgAxArCyAEIAJBCBCqCSAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEECAC/QwAAAAAAAAAAAAAAAAAAAAA/QsEACABQSFPBEADQCAAKAJ4IQMgAEEANgJ4IAMEQCADECsLIAQgAkEgEKoJIAFBIGsiAUEgSw0ACwsgACgCeCEDIABBADYCeCADBEAgAxArCyAEIAIgARCqCSACQSBqJAALkAMCCH8LfiMAQSBrIgQkACABQegDaiEJQQEhBgNAIAkgBkEFdGohCEEDIQUDQCAFQQV0IQMgACAFQQFrIgVBBXRqIgIgAikDACIKIAAgA2pBQGoiAykDAH0iCzcDACACIAIpAwgiDCADKQMIfSINIAogC1StfSIKNwMIIAIgAikDECIPIAMpAxB9Ig4gDCANVCAKIA1Wcq19Ig03AxAgAiACKQMYIhAgAykDGH0iDCAOIA9WIA0gDlZyrX0iDjcDGCABKQMYIQ8gASkDECESIAEpAwghEyACIAsgCyABKQMAfCIUIBEgDCAOVCAMIBBWcq1RIgMbNwMAIAIgCiAKIBN8IgwgCyAUVq18IhAgAxs3AwggAiANIA0gEnwiCyAKIAxWIAwgEFZyrXwiCiADGzcDECACIA4gCyANVCAKIAtUcq0gDiAPfHwgAxs3AxggBCAI/QADEP0LAxAgBCAI/QADAP0LAwAgASACIAQQpAkgBSAGSw0ACyAHIQJBAiEGQQEhByACRQ0ACyAEQSBqJAAL+QQCDH4EfyMAQSBrIhEkACAAKAIsIRAgEUEQaiISIANBEGoiE/0AAwD9CwMAIBEgA/0AAwD9CwMAIBAgESACEKQJIBEpAxghCyASKQMAIQQgESkDCCEHIAAgACkDACIIIBEpAwB8Igw3AwAgACAHIAApAwgiCXwiBSAIIAxWrXwiBzcDCCAAIAQgACkDECIIfCIEIAUgCVQgBSAHVnKtfCIFNwMQIAAgCyAAKQMYIg18IgsgBCAIVCAEIAVWcq18IgQ3AxggACAQKQM4Ig4gBHwiCCAQKQMwIgYgBXwiCSAGVCAJIBApAygiCiAHfCIGIApUIAYgECkDICIKIAx8Ig8gClStfCIKIAZUcq18IgYgCVRyrXwiCSAEIAsgDVQgBCALVHIgCCAOVCAIIAlWcnMiAhs3AxggACAGIAUgAhs3AxAgACAKIAcgAhs3AwggACAPIAwgAhs3AwAgACgCICABQQV0aiIAIAApAwAiByADKQMAfCIMNwMAIAAgACkDCCILIAMpAwh8IgUgByAMVq18Igc3AwggACAAKQMQIgggEykDAHwiBCAFIAtUIAUgB1ZyrXwiBTcDECAAIAApAxgiDSADKQMYfCILIAQgCFQgBCAFVnKtfCIENwMYIAAgECkDOCIOIAR8IgggECkDMCIGIAV8IgkgBlQgCSAQKQMoIgogB3wiBiAKVCAGIBApAyAiCiAMfCIPIApUrXwiCiAGVHKtfCIGIAlUcq18IgkgBCALIA1UIAQgC1RyIAggDlQgCCAJVnJzIhAbNwMYIAAgBiAFIBAbNwMQIAAgCiAHIBAbNwMIIAAgDyAMIBAbNwMAIBFBIGokAAvMBAIYfgR/IwBBIGsiHCQAIAAgAf0AA0D9CwMAIAAgAf0AA1D9CwMQIANBqAJqIR4gAykDOCENIAMpAzAhDiADKQMoIQ8gAykDICEQIAMpAxghFSADKQMQIRYgAykDCCEXIAMpAwAhGCACKQMYIREgAikDECESIAIpAwghEyACKQMAIRRBAiEdA0AgHCARIB4gHUEBayIdQQV0Ih9qIgIpAxh9IgggEiACKQMQfSIFIBJWIAUgEyACKQMIfSIEIBNWIAQgFCACKQMAfSIJIBRWrX0iBiAEVnKtfSIEIAVWcq19IgUgBCAWfCILIARUIAsgBiAXfCIHIAZUIAcgCSAYfCIKIAlUrXwiDCAHVHKtfCIHIAtUcq0gBSAVfHwgGSAIIBFWIAUgCFZyrVEiAhs3AxggHCAEIAcgAhs3AxAgHCAGIAwgAhs3AwggHCAJIAogAhs3AwAgAyAAIBwQpAkgACANIAApAxgiDCABIB9qIgIpAxh8IgkgACkDECIEIAIpAxB8IgYgBFQgBiAAKQMIIgggAikDCHwiBCAIVCAEIAApAwAiBSACKQMAfCIIIAVUrXwiBSAEVHKtfCIEIAZUcq18IgZ8IgsgBCAOfCIHIA5UIAcgBSAPfCIKIA9UIAogCCAQfCIaIBBUrXwiGyAKVHKtfCIKIAdUcq18IgcgBiAJIAxUIAYgCVRyIAsgDVQgByALVHJzIgIbNwMYIAAgCiAEIAIbNwMQIAAgGyAFIAIbNwMIIAAgGiAIIAIbNwMAIB0NAAsgHEEgaiQAC9wFAgZ/C34jAEEgayIGJAAgACgCLCEFIAZBEGoiBCAAKAI0IgdBmAFqIgj9AAMA/QsDACAGIAf9AAOIAf0LAwAgBSAGIAMQpAkgBikDGCEOIAQpAwAhDyAGKQMIIQogACAAKQMAIg0gBikDAH0iCzcDACAAIAApAwgiECAKfSIMIAsgDVatfSIKNwMIIAAgACkDECIRIA99Ig8gDCAQViAKIAxWcq19Igw3AxAgACAAKQMYIhAgDn0iDSAMIA9WIA8gEVZyrX0iDjcDGCAFKQMYIREgBSkDECESIAUpAwghEyAAIAsgCyAFKQMAfCIUQgAiDyANIA5UIA0gEFZyrVEiBBs3AwAgACAKIAogE3wiDSALIBRWrXwiECAEGzcDCCAAIAwgDCASfCILIAogDVYgDSAQVnKtfCIKIAQbNwMQIAAgDiALIAxUIAogC1RyrSAOIBF8fCAEGzcDGCAAKAIgIAFBAXQiAUEDaiIJQQV0aiIEIAQpAwAiCiAHKQOIAX0iCzcDACAEIAQpAwgiDSAHKQOQAX0iDCAKIAtUrX0iCjcDCCAEIAQpAxAiECAIKQMAfSIOIAwgDVYgCiAMVnKtfSIMNwMQIAQgBCkDGCIRIAcpA6ABfSINIAwgDlYgDiAQVnKtfSIONwMYIAUpAxghECAFKQMQIRIgBSkDCCETIAQgCyALIAUpAwB8IhQgDyANIA5UIA0gEVZyrVEiBRs3AwAgBCAKIAogE3wiDyALIBRWrXwiDSAFGzcDCCAEIAwgDCASfCILIA0gD1QgCiAPVnKtfCIKIAUbNwMQIAQgDiALIAxUIAogC1RyrSAOIBB8fCAFGzcDGCAAKAIsIAAgAkEgaiIFEKQJIAAoAiAiBCAAKAIkIgdHBEADQCAAKAIsIAQgBRCkCSAEQSBqIgQgB0cNAAsLIAAgCSADIAIQgwsgACABQQRqIANBQGsgAkFAaxCDCyAGQSBqJAALjAUBBn8jAEHgAGsiBSQAAkACQAJAIAMEQCAAQQA2AgggAEIANwIAAkAgAUEBdCIERQ0AIARBAEgNAiAEQQFrQQV2IglBAWoiCEECdBCiCSEGIAAgCDYCCCAAIAY2AgAgACAENgIEAkACQCAEQSFPBEAgBiAJQQJ0akEANgIAIARBBXYhAAwBCyAGQQA2AgAgBEEFdiEAIARBIEcNAQsgAEECdCIIRQ0AIAZBACAI/AsACyAEQR5xIgRFDQAgBiAAQQJ0aiIAIAAoAgBBf0EgIARrdkF/c3E2AgALA0AgAiAHQQJ0aigCACIEIAFPDQMgBiABIARqIgRBA3ZB/P///wFxaiIAIAAoAgBBASAEdHI2AgAgB0EBaiIHIANHDQALIAFBAU0NAwNAAkACQAJAIAYgAUEBayIBQQJ2Qfz///8BcWooAgAiACABQQF0IgN2QQFxBEBBASABdCEEIAYgAUEDdkH8////AXFqIQcMAQtBASABdCEEIAYgAUEDdkH8////AXFqIQcgACADQR5xdkECcUUNAQsgByAHKAIAIARyNgIADAELIAcgBygCACAEQX9zcTYCAAsgAUEBSw0ACwwDCyAFQbb0KzYCEEHkAEH0hyogBUEQahCbCUGQljQoAgAoAgAhASAFQbb0KzYCACABQZGMKiAFEGwACxCgCQALIAVB5qArNgJQQeQAQfSHKiAFQdAAahCbCUGQljQoAgAoAgAhASAFQeagKzYCQCABQZGMKiAFQUBrEGwACyAGLQAAQQJxBEAgBUHgAGokAA8LIAVB7NkrNgIwQeQAQfSHKiAFQTBqEJsJQZCWNCgCACgCACEBIAVB7NkrNgIgIAFBkYwqIAVBIGoQbAALhhgCFn8pfiMAQaABayIFJAAgAiAEEIkLAkAgAUECTwRAIAQoAgAhBiAFIAL9AAMw/QsDMCAFIAL9AAMg/QsDICAFIAL9AAMQ/QsDECAFIAL9AAMA/QsDACABrSIlIANUBEADQCAEIAUgBRCKCyAlQgGGIiUgA1QNAAsLIAFBgICAwABPDQEgAUEFdEFAcSICEKIJIQ0gAgRAIA1BACAC/AsACyAFQfAAaiIIIAT9AAOYAf0LAwAgBUHgAGoiCSAE/QADiAH9CwMAIAVB0ABqIgsgBP0AA3j9CwMAIAUgBP0AA2j9CwNAA0AgDSAHQQZ0aiICIAX9AANA/QsDACACIAj9AAMA/QsDMCACIAn9AAMA/QsDICACIAv9AAMA/QsDECAEIAVBQGsgBRCKCyAHQQFqIgdBAXQgAUkNAAsgAUECayEJQQAhBEEAIQcDQCAEIAdJBEAgBUHQAGoiCyAAIARBBXRqIgJBEGoiCv0AAwD9CwMAIAUgAv0AAwD9CwNAIAIgACAHQQV0aiIIQRhqIg4pAwA3AxggCiAIQRBqIg8pAwA3AwAgAiAIQQhqIgopAwA3AwggAiAIKQMANwMAIA4gBSkDWDcDACAPIAspAwA3AwAgCiAFKQNINwMAIAggBSkDQDcDAAsgASECA0AgAkEBdiICIAdzIgcgAnFFDQALIAQgCUYhAiAEQQFqIQQgAkUNAAtBACECA0AgACACQQV0akEBIAYQiwsgAkECaiICIAFJDQALIAFBAkcEQEECIRADQCAQIgxBA2tBAXZBAmohFCABIAxBAXQiEGh2IRVBACERIAxBA0khFwNAIAAgEUEFdGoiFiAMIAYQiwtBASEHIBdFBEAgDCARaiEYQQEhCwNAIAVB0ABqIgogFiALQQV0aiIHIAxBBXQiCWoiCEEQaiIO/QADAP0LAwAgBSAI/QADAP0LA0AgBiAFQUBrIA0gCyAVbEEGdGoiAhCkCSAFQdgAaiISKQMAIQMgCikDACEhIAVByABqIhMpAwAhICAFKQNAISYgCiAAIBggC2tBBXRqIgQgCWoiCUEQaiIP/QADAP0LAwAgBSAJ/QADAP0LA0AgBiAFQUBrIAJBIGoQpAkgEikDACEzIAopAwAhNCATKQMAITUgBSkDQCE2IAUgBikDOCIcIAhBGGoiEikDACItIAlBGGoiEykDAHwiJSAOKQMAIhsgDykDAHwiHSAbVCAdIAhBCGoiGSkDACIfIAlBCGoiGikDAHwiGyAfVCAbIAgpAwAiHyAJKQMAfCIkIB9UrXwiHiAbVHKtfCIiIB1Ucq18Iid8IiMgBikDMCIdICJ8IiggHVQgKCAGKQMoIhsgHnwiKSAbVCApIAYpAyAiHyAkfCIuIB9UrXwiLyApVHKtfCIpIChUcq18IiggJyAlIC1UICUgJ1ZyIBwgI1YgIyAoVnJzIgobNwNYIAUgKSAiIAobNwNQIAUgLyAeIAobNwNIIAUgLiAkIAobNwNAIAUgAikDGCItIAIpAzh9IicgAikDECIkIAIpAzB9IiMgJFYgIyACKQMIIiQgAikDKH0iIiAkViAiIAIpAwAiHiACKQMgfSIkIB5WrX0iHiAiVnKtfSIiICNWcq19IiMgIiAGKQMQfCIoICJUICggHiAGKQMIfCIpIB5UICkgJCAGKQMAfCIuICRUrXwiLyApVHKtfCIpIChUcq0gIyAGKQMYfHwgJyAtViAjICdWcq1QIgIbNwOYASAFICIgKSACGzcDkAEgBSAeIC8gAhs3A4gBIAUgJCAuIAIbNwOAASAGIAVBQGsgBUGAAWoQpAkgBikDGCE6IAYpAxAhOyAGKQMAITwgBikDCCE9IAUpA1ghKCAFKQNQISkgBSkDQCEtIAUpA0ghLiAEKQMYIS8gBCkDECE3IAQpAwAhOCAEKQMIITkgByAGKQM4IiQgBykDGCIeIBwgAyAzfCIiICEgNHwiJyAhVCAnICAgNXwiIyAgVCAjICYgNnwiJSAmVK18IiogI1RyrXwiIyAnVHKtfCInfCIrIB0gI3wiLCAdVCAsIBsgKnwiHSAbVCAdIB8gJXwiMCAfVK18IhsgHVRyrXwiHSAsVHKtfCIfICcgAyAiViAiICdWciAfICtUIBwgK1ZycyICGyI+fCIrIAcpAxAiHCAdICMgAhsiP3wiHyAcVCAfIAcpAwgiHSAbICogAhsiQHwiIiAdVCAiIAcpAwAiGyAwICUgAhsiQXwiIyAbVK18IiUgIlRyrXwiKiAfVHKtfCIsfCIwIAYpAzAiHyAqfCIxIB9UIDEgBikDKCIiICV8IjIgIlQgMiAGKQMgIicgI3wiQiAnVK18IkMgMlRyrXwiMiAxVHKtfCIxICwgHiArViArICxWciAkIDBWIDAgMVZycyICGzcDGCAHIDIgKiACGzcDECAHIEMgJSACGzcDCCAHIEIgIyACGzcDACAGKQMYISsgBikDECEsIAYpAwghMCAEIBsgQX0iIyAjIAYpAwB8IjEgHiA+fSIlIB5WICUgHCA/fSIeIBxWIB4gHSBAfSIqIB1WICogGyAjVK19IhwgKlZyrX0iHSAeVnKtfSIbICVWcq1QIgIbNwMAIAQgHCAcIDB8Ih4gIyAxVq18IiUgAhs3AwggBCAdIB0gLHwiIyAcIB5WIB4gJVZyrXwiHCACGzcDECAEIBsgHCAjVCAdICNWcq0gGyArfHwgAhs3AxggEiAkIDMgKCADfSIcICkgIX0iHSApViAdIC4gIH0iICAuViAgIC0gJn0iAyAtVq19IiEgIFZyrX0iICAdVnKtfSImICAgO3wiHSAgVCAdICEgPXwiGyAhVCAbIAMgPHwiHiADVK18IiMgG1RyrXwiGyAdVHKtICYgOnx8IBwgJlQgHCAoVnKtUCICGyIofCImIDQgICAbIAIbIhx8IiAgHFQgICA1ICEgIyACGyIcfCIhIBxUICEgNiADIB4gAhsiA3wiHCADVK18Ih0gIVRyrXwiISAgVHKtfCIDfCIgIB8gIXwiGyAfVCAbIB0gInwiHyAiVCAfIBwgJ3wiHiAnVK18IiIgH1RyrXwiJyAbVHKtfCIbIAMgJiAoVCADICZUciAgICRUIBsgIFRycyICGyIDIC99Ih8gJyAhIAIbIiEgN30iJCAhViAkICIgHSACGyIgIDl9IhsgIFYgGyAeIBwgAhsiJiA4fSIcICZWrX0iHSAbVnKtfSIbICRWcq19IiQgGyAGKQMQfCIeIBtUIB4gHSAGKQMIfCIiIB1UICIgHCAGKQMAfCInIBxUrXwiIyAiVHKtfCIiIB5Ucq0gJCAGKQMYfHwgAyAfVCAfICRUcq1QIgIbNwMAIA4gGyAiIAIbNwMAIBkgHSAjIAIbNwMAIAggHCAnIAIbNwMAIBMgBikDOCIkIAMgL3wiJSAhIDd8IhwgIVQgHCAgIDl8IiEgIFQgISAmIDh8IiAgJlStfCImICFUcq18IiEgHFRyrXwiHHwiHSAGKQMwIh8gIXwiGyAfVCAbIAYpAygiHiAmfCIfIB5UIB8gBikDICIeICB8IiIgHlStfCIeIB9Ucq18Ih8gG1RyrXwiGyAcIBwgJVQgAyAlVnIgHSAkVCAbIB1UcnMiAhs3AwAgDyAfICEgAhs3AwAgGiAeICYgAhs3AwAgCSAiICAgAhs3AwAgC0EBaiILIBRHDQALIBQhBwsgBSAGKQOAASIfIA0gByAVbEEGdGoiAikDOH0iJiAGKQN4IgMgAikDMH0iHCADViAcIAYpA3AiAyACKQMofSIgIANWICAgBikDaCIhIAIpAyB9IgMgIVatfSIhICBWcq19IiAgHFZyrX0iHCAgIAYpAxB8Ih0gIFQgHSAhIAYpAwh8IhsgIVQgGyADIAYpAwB8IiQgA1StfCIeIBtUcq18IhsgHVRyrSAcIAYpAxh8fCAfICZUIBwgJlZyrVAiAhs3A1ggBSAgIBsgAhs3A1AgBSAhIB4gAhs3A0ggBSADICQgAhs3A0AgBiAWIAdBBXRqIAxBBXRqIAVBQGsQpAkgECARaiIRIAFJDQALIAEgEEsNAAsLIA0QKwsgBUGgAWokAA8LEKAJAAviCQIXfgZ/IwBBQGoiHiQAIB5BMGoiHyACQRBqIiL9AAMA/QsDACAeIAL9AAMA/QsDICAGIB5BIGogBBCkCSAeQThqIiApAwAhDSAfKQMAIQsgHkEoaiIhKQMAIQogHikDICETIB8gA0EQaiIj/QADAP0LAwAgHiAD/QADAP0LAyAgBiAeQSBqIAUQpAkgICkDACEXIB8pAwAhGCAhKQMAIRkgHikDICEaICAgBikDOCIVIAIpAxgiGyADKQMYfCIOICIpAwAiCSAjKQMAfCIHIAlUIAcgAikDCCIIIAMpAwh8IgkgCFQgCSACKQMAIgggAykDAHwiDCAIVK18Ig8gCVRyrXwiESAHVHKtfCIQfCIUIAYpAzAiByARfCISIAdUIBIgBikDKCIJIA98IhYgCVQgFiAGKQMgIgggDHwiHCAIVK18Ih0gFlRyrXwiFiASVHKtfCISIBAgDiAbVCAOIBBWciAUIBVUIBIgFFRycyICGzcDACAfIBYgESACGzcDACAhIB0gDyACGzcDACAeIBwgDCACGzcDICAeIBUgBCkDGCIWIAUpAxh8Ig4gBCkDECIPIAUpAxB8IgwgD1QgDCAEKQMIIhEgBSkDCHwiDyARVCAPIAQpAwAiECAFKQMAfCIRIBBUrXwiECAPVHKtfCIPIAxUcq18Igx8IhQgByAPfCISIAdUIBIgCSAQfCIHIAlUIAcgCCARfCIJIAhUrXwiCCAHVHKtfCIHIBJUcq18IhIgDCAOIBZUIAwgDlRyIBQgFVQgEiAUVHJzIgIbNwMYIB4gByAPIAIbNwMQIB4gCCAQIAIbNwMIIB4gCSARIAIbNwMAIAYpAxghDyAGKQMQIREgBikDCCEQIAAgEyAafSIHIAcgBikDAHwiFEIAIhUgDSAXfSIOIA1WIA4gCyAYfSIMIAtWIAwgCiAZfSIIIApWIAggByATVq19IgkgCFZyrX0iCCAMVnKtfSIMIA5Wcq1RIgIbNwMAIAAgCSAJIBB8Ig4gByAUVq18IhAgAhs3AwggACAIIAggEXwiByAJIA5WIA4gEFZyrXwiCSACGzcDECAAIAwgByAIVCAHIAlWcq0gDCAPfHwgAhs3AxggBiAeQSBqIB4QpAkgICAgKQMAIg4gDX0iByAfKQMAIg0gC30iCSANViAJICEpAwAiDSAKfSIKIA1WIAogHikDICILIBN9Ig0gC1atfSILIApWcq19IgogCVZyrX0iEyAKIAYpAxAiD3wiCSAKVCAJIAsgBikDCCIRfCIIIAtUIAggDSAGKQMAIhB8IhQgDVStfCISIAhUcq18IgggCVRyrSATIAYpAxgiDHx8IBUgByATVCAHIA5Wcq1RIgYbIg4gF30iEyAKIAggBhsiCiAYfSIHIApWIAcgCyASIAYbIgsgGX0iCiALViAKIA0gFCAGGyILIBp9Ig0gC1atfSILIApWcq19IgogB1ZyrX0iByAKIA98IgkgClQgCSALIBF8IgggC1QgCCANIBB8IhcgDVStfCIYIAhUcq18IgggCVRyrSAHIAx8fCAVIA4gE1QgByATVnKtUSIGGzcDACAfIAogCCAGGzcDACAhIAsgGCAGGzcDACAeIA0gFyAGGzcDICABIB/9AAMA/QsDECABIB79AAMg/QsDACAeQUBrJAALqAQDB38JfgF7IwBBoAFrIgIkACACQZABaiIEIABBMGoiBf0AAwD9CwMAIAJBgAFqIgYgAEEgaiIH/QADAP0LAwAgAkHwAGoiCCAAQRBqIgP9AAMA/QsDACACIAD9AAMA/QsDYCACIAP9AAMA/QsDMCACIAD9AAMA/QsDICABKAIAIgMpAxghDyADKQMQIRAgAykDCCELIAIgAykDaCINIAcpAwB9IgwgDCADKQMAfCIRIAMpA4ABIgkgACkDOH0iDiAJViAOIAMpA3giCSAFKQMAfSIKIAlWIAogCiADKQNwIgogACkDKH0iCSAKViAJIAwgDVatfSINIAlWcq19IglUcq19IgogDlZyrVAiABs3A0AgAiANIAsgDXwiCyAMIBFWrXwiDiAAGzcDSCACIAkgCSAQfCIMIAsgDVQgCyAOVnKtfCILIAAbNwNQIAIgCiALIAxUIAkgDFZyrSAKIA98fCAAGzcDWCABIAJB4ABqIAJBIGoQigsgAv0AA2AgAf0AA2j91gH9DP//AAAAAAAA//8AAAAAAAAiEv1OIAj9AAMAIAH9AAN4/dYBIBL9Tv2GASAG/QADACAB/QADiAH91gEgEv1OIAT9AAMAIAH9AAOYAf3WASAS/U79hgH9hgH9gwFFBEAgAkGKlSs2AhBB5ABB9IcqIAJBEGoQmwlBkJY0KAIAKAIAIQAgAkGKlSs2AgAgAEGRjCogAhBsAAsgAkGgAWokAAv7CQIXfgp/IwBBQGoiGiQAIAAoAgAhGyAaQTBqIhwgAUEQaiIg/QADAP0LAwAgGiAB/QADAP0LAyAgGyAaQSBqIAIQpAkgGkE4aiIdKQMAIQkgHCkDACEHIBpBKGoiHikDACEGIBopAyAhDyAcIAFBMGoiIf0AAwD9CwMAIBogAf0AAyD9CwMgIBsgGkEgaiACQSBqEKQJIB0pAwAhEyAcKQMAIRQgHikDACEVIBopAyAhFiAdIBspAzgiESABQRhqIiIpAwAiFyABKQM4fCIKICApAwAiBSAhKQMAfCIDIAVUIAMgAUEIaiIjKQMAIgQgASkDKHwiBSAEVCAFIAEpAwAiBCABKQMgfCIIIARUrXwiCyAFVHKtfCINIANUcq18Igx8IhAgGykDMCIDIA18Ig4gA1QgDiAbKQMoIgUgC3wiEiAFVCASIBspAyAiBCAIfCIYIARUrXwiGSASVHKtfCISIA5Ucq18Ig4gDCAKIBdUIAogDFZyIBAgEVQgDiAQVHJzIh8bNwMAIBwgEiANIB8bNwMAIB4gGSALIB8bNwMAIBogGCAIIB8bNwMgIBogESACKQMYIhIgAikDOHwiCiACKQMQIgsgAikDMHwiCCALVCAIIAIpAwgiDSACKQMofCILIA1UIAsgAikDACIMIAIpAyB8Ig0gDFStfCIMIAtUcq18IgsgCFRyrXwiCHwiECADIAt8Ig4gA1QgDiAFIAx8IgMgBVQgAyAEIA18IgUgBFStfCIEIANUcq18IgMgDlRyrXwiDiAIIAogElQgCCAKVHIgECARVCAOIBBUcnMiAhs3AxggGiADIAsgAhs3AxAgGiAEIAwgAhs3AwggGiAFIA0gAhs3AwAgGykDGCELIBspAxAhDSAbKQMIIQwgASAPIBZ9IgMgAyAbKQMAfCIQQgAiESAJIBN9IgogCVYgCiAHIBR9IgggB1YgCCAGIBV9IgQgBlYgBCADIA9WrX0iBSAEVnKtfSIEIAhWcq19IgggClZyrVEiAhs3AwAgIyAFIAUgDHwiCiADIBBWrXwiDCACGzcDACAgIAQgBCANfCIDIAUgClYgCiAMVnKtfCIFIAIbNwMAICIgCCADIARUIAMgBVZyrSAIIAt8fCACGzcDACAAKAIAIgIgGkEgaiAaEKQJIB0gHSkDACIKIAl9IgMgHCkDACIJIAd9IgUgCVYgBSAeKQMAIgkgBn0iBiAJViAGIBopAyAiByAPfSIJIAdWrX0iByAGVnKtfSIGIAVWcq19Ig8gBiACKQMQIgt8IgUgBlQgBSAHIAIpAwgiDXwiBCAHVCAEIAkgAikDACIMfCIQIAlUrXwiDiAEVHKtfCIEIAVUcq0gDyACKQMYIgh8fCARIAMgD1QgAyAKVnKtUSICGyIKIBN9Ig8gBiAEIAIbIgYgFH0iAyAGViADIAcgDiACGyIHIBV9IgYgB1YgBiAJIBAgAhsiByAWfSIJIAdWrX0iByAGVnKtfSIGIANWcq19IgMgBiALfCIFIAZUIAUgByANfCIEIAdUIAQgCSAMfCITIAlUrXwiFCAEVHKtfCIEIAVUcq0gAyAIfHwgESAKIA9UIAMgD1ZyrVEiAhs3AwAgHCAGIAQgAhs3AwAgHiAHIBQgAhs3AwAgGiAJIBMgAhs3AyAgISAc/QADAP0LAwAgASAa/QADIP0LAyAgGkFAayQAC9gEAhB+Bn8gACABQQV0aiIBQQhqIhUpAwAhCCABKQMAIQcgASAA/QADAP0LAwAgAUEYaiIWKQMAIQ4gAUEQaiIUKQMAIQ8gFCAAQRBqIhf9AAMA/QsDACAAIAcgACkDACIDfCIGNwMAIABBCGoiGCAIIBgpAwAiCXwiBCADIAZWrXwiAzcDACAXIA8gFykDACIKfCIFIAMgBFQgBCAJVHKtfCIENwMAIABBGGoiEyAOIBMpAwAiEHwiCSAEIAVUIAUgClRyrXwiBTcDACATIAIpAzgiESAFfCIKIAIpAzAiCyAEfCIMIAtUIAwgAikDKCINIAN8IgsgDVQgCyACKQMgIg0gBnwiEiANVK18Ig0gC1RyrXwiCyAMVHKtfCIMIAUgCSAQVCAFIAlUciAKIBFUIAogDFZycyITGzcDACAXIAsgBCATGzcDACAYIA0gAyATGzcDACAAIBIgBiATGzcDACABIAEpAwAiAyAHfSIGNwMAIBUgFSkDACIHIAh9IgQgAyAGVK19IgM3AwAgFCAUKQMAIgggD30iBSAEIAdWIAMgBFZyrX0iBDcDACAWIBYpAwAiDyAOfSIHIAUgCFYgBCAFVnKtfSIFNwMAIAIpAxghDiACKQMQIQkgAikDCCEKIAEgBiAGIAIpAwB8IgwgBSAHViAHIA9Wcq1QIgAbNwMAIBUgAyADIAp8IgggBiAMVq18IgcgABs3AwAgFCAEIAQgCXwiBiAHIAhUIAMgCFZyrXwiAyAAGzcDACAWIAUgAyAGVCAEIAZWcq0gBSAOfHwgABs3AwALiQIBBn8gACgCBCICIAAoAggiA0kEQCACIAH9AAQA/QsEACACIAH9AAQQ/QsEECAAIAJBIGo2AgQPCwJAIAIgACgCACIEayIFQQV1IgdBAWoiAkGAgIDAAEkEQEH///8/IAMgBGsiA0EEdSIGIAIgAiAGSRsgA0Hg////B08bIgMEfyADQYCAgMAATw0CIANBBXQQngkFQQALIgYgBWoiAiAB/QAEAP0LBAAgAiAB/QAEEP0LBBAgAiAHQQV0ayEBIAUEQCABIAQgBfwKAAALIAAgBiADQQV0ajYCCCAAIAJBIGoiAjYCBCAAIAE2AgAgBARAIAQQKwsgACACNgIEDwsQoAkACxCgCQALpAkCE38DeyMAQSBrIg0kAAJAAkAgAUUNAEEBIAFBAWsiCnQhCSACBEAgAEEQaiAKQQh0aiEIIAIhBQNAIAVBAXEEQCAIIAZBBHRq/QAEACAZ/VEhGQsgBkEBaiEGIAVBAUshByAFQQF2IQUgBw0ACwsgAyAJSQRAIAMhBgNAIAQgBkEEdGoiBSAF/QAEACAZIAUgCUEEdGoiB/0ABAAQmgn9USIY/QsEACAHIAf9AAQAIBj9Uf0LBAAgBkEBaiIGIAlHDQALIAAgCiACIAMgBBCNCyADBEBBACEGA0AgBCAGQQR0aiIFIAlBBHRqIgcgBf0ABAAgB/0ABAAiGP1R/QsEACAFIAX9AAQAIBkgGBCaCf1R/QsEACAGQQFqIgYgA0cNAAsLIAAgCiACIAlqIAQgCUEEdGoQjgsMAQsgAUERSw0BIAoEQEEEIAF0IgUQngkhCyAFBEAgC0EAIAX8CwALIABBEGohESALQTBqIRIgC0EgaiETIAtBEGohFANAQQAhBv0MAAAAAAAAAAAAAAAAAAAAACEYIAIiBQRAA0AgBUEBcQRAIBEgDEEIdGogBkEEdGr9AAQAIBj9USEYCyAGQQFqIQYgBUEBSyEHIAVBAXYhBSAHDQALCyALIBj9CwQAIAogDEEBaiIQSwRAIAxBAmohFSAKIAxBf3NqIRZBACEOIBEgDEEIdGohFyAQIQUDQCAXIAVBBHRq/QAEACEYQQEgDnQhCAJAIA5BAkkEQCAIQQNxIQdBACEFA0AgCyAFQQR0aiIGIAhBBHRqIAb9AAQAIBj9Uf0LBAAgBUEBaiIFIAdHDQALDAELIAhBfHEhD0EAIQcDQCALIAdBBHQiBWoiASAIQQR0IgZqIAH9AAQAIBj9Uf0LBAAgBSAUaiIBIAZqIAH9AAQAIBj9Uf0LBAAgBSATaiIBIAZqIAH9AAQAIBj9Uf0LBAAgBSASaiIFIAZqIAX9AAQAIBj9Uf0LBAAgB0EEaiIHIA9HDQALCyAOIBVqIQUgDkEBaiIOIBZHDQALC0EBIAx0IQdBACEFQQAhDwNAIAQgBUEEdGohASALIA9BBHRq/QAEACEaQQAhBgNAIAEgBkEEdGoiBSAHQQR0aiIIIAX9AAQAIAj9AAQA/VEiGP0LBAAgBSAF/QAEACAaIBgQmgn9Uf0LBAAgBkEBaiIGIAdHDQALIA9BAWoiDyAQdCIFIAp2RQ0ACyAQIgwgCkcNAAsgCxArCyAJIAMgCWsiCEsEQCAIIQYDQCAEIAZBBHRqIgUgCUEEdGoiByAF/QAEACAH/QAEACIY/VH9CwQAIAUgBf0ABAAgGSAYEJoJ/VH9CwQAIAZBAWoiBiAJRw0ACwsgACAKIAIgCWogCCAEIAlBBHQiAWoQjQsgCEUNAEEAIQYDQCAEIAZBBHRqIgUgAWoiByAF/QAEACAH/QAEAP1RIhj9CwQAIAUgBf0ABAAgGSAYEJoJ/VH9CwQAIAZBAWoiBiAIRw0ACwsgDUEgaiQADwsgDUGc8Sk2AhBB5ABB9IcqIA1BEGoQmwlBkJY0KAIAKAIAIQUgDUGc8Sk2AgAgBUGRjCogDRBsAAuzBQIRfwJ7IwBBIGsiCiQAIAFBEE0EQCABBEBBCCABdCIEEJ4JIQYgBARAIAZBACAE/AsACyAAQRBqIQ4gBkEwaiEPIAZBIGohECAGQRBqIREgASEHA0AgB0EBayENQQAhBP0MAAAAAAAAAAAAAAAAAAAAACEVIAIiAARAA0AgAEEBcQRAIA4gDUEIdGogBEEEdGr9AAQAIBX9USEVCyAEQQFqIQQgAEEBSyEFIABBAXYhACAFDQALCyAGIBX9CwQAIAEgB0sEQCABIAdrIRIgB0EBaiETQQAhCyAOIA1BCHRqIRQgByEAA0AgFCAAQQR0av0ABAAhFUEBIAt0IQgCQCALQQJJBEAgCEEDcSEFQQAhAANAIAYgAEEEdGoiBCAIQQR0aiAE/QAEACAV/VH9CwQAIABBAWoiACAFRw0ACwwBCyAIQXxxIQxBACEFA0AgBiAFQQR0IgBqIgkgCEEEdCIEaiAJ/QAEACAV/VH9CwQAIAAgEWoiCSAEaiAJ/QAEACAV/VH9CwQAIAAgEGoiCSAEaiAJ/QAEACAV/VH9CwQAIAAgD2oiACAEaiAA/QAEACAV/VH9CwQAIAVBBGoiBSAMRw0ACwsgCyATaiEAIAtBAWoiCyASRw0ACwtBASANdCEIQQAhAEEAIQwDQCADIABBBHRqIQkgBiAMQQR0av0ABAAhFkEAIQQDQCAJIARBBHRqIgAgAP0ABAAgFiAAIAhBBHRqIgX9AAQAEJoJ/VEiFf0LBAAgBSAF/QAEACAV/VH9CwQAIARBAWoiBCAIRw0ACyAMQQFqIgwgB3QiACABdkUNAAsgDSIHDQALIAYQKwsgCkEgaiQADwsgCkGc8Sk2AhBB5ABB9IcqIApBEGoQmwlBkJY0KAIAKAIAIQAgCkGc8Sk2AgAgAEGRjCogChBsAAseAQF/QQwQogkiAUHo0jE2AgAgASAAKQIENwIEIAELFQAgAUHo0jE2AgAgASAAKQIENwIECzQBAX8gACgCBCIDKAI0IAMoAnAgASgCAEEFdGogAygCGEEFdGogAygCECACIAAoAggQkgsLagEDfyMAQUBqIgUkACAABEADQCAFQSBqIAQgASACIAZsQQV0aiIH/QADACAH/QADEBCZCSAFIAX9AAMg/QsEACAFIAX9AAMw/QsEECADIAVBIBCqCSAGQQFqIgYgAEcNAAsLIAVBQGskAAseAQF/QQwQogkiAUHE0jE2AgAgASAAKQIENwIEIAELFQAgAUHE0jE2AgAgASAAKQIENwIEC3QBA38jAEEQayIDJAAgACgCBCIAKAI0IgQEQCAAKAJwIAEoAgBBBHRqIAAoAhhBBHRqIQEgACgCECEFQQAhAANAIAMgASAAIAVsQQR0av0ABAD9CwQAIAIgA0EQEKoJIABBAWoiACAERw0ACwsgA0EQaiQAC9cCAgd/AX4gACABNgIQQX8hAwJAIAFBgICAgAFLDQAgACgCCCIEQYCAgIABSw0AIAFBAWoiAiAEQQJqIgRJDQAgACACIARuIgQ2AhQgBCAAKAIgIgJJDQAgACAEIAJrIgU2AiQgAiAFSw0AIAAgBEEBdEEBayIGNgIYIAEgBkkNACAAIAEgBmsiCDYCHCAAIAVBAWsiAiAAKAIAaiAFbiIHNgIoIAAgAiAAKAIEaiAFbiICNgIsIAAgAkEDbCAHaiICNgIwIAAgAkEDaiIHNgI0IAdBgICAgAEgAW5PDQBBASEDIAhBAXRBAWsiAUEBRwRAA0AgA0EBaiEDIAFBA0shAiABQQF2IQEgAg0ACwsgACADNgI4Qv////8PIAA1AgwiCSAGIAVrrSAGrSAErXx8fCADQQF2rSAHrXwgCX58QgWGQiB8IgkgCUL/////D1obpyEDCyADC9kCAgd/AX4gACABNgIQQX8hAwJAIAFB//8DSw0AIAAoAggiBEGAgICAAUsNACABQQFqIgIgBEECaiIESQ0AIAAgAiAEbiIENgIUIAQgACgCICICSQ0AIAAgBCACayIFNgIkIAIgBUsNACAAIARBAXRBAWsiBjYCGCABIAZJDQAgACABIAZrIgg2AhwgACAFQQFrIgIgACgCAGogBW4iBzYCKCAAIAIgACgCBGogBW4iAjYCLCAAIAJBA2wgB2oiAjYCMCAAIAJBA2oiBzYCNCAHQYCAgIABIAFuTw0AQQEhAyAIQQF0QQFrIgFBAUcEQANAIANBAWohAyABQQNLIQIgAUEBdiEBIAINAAsLIAAgAzYCOEL/////DyAANQIMIAetQgGGIANBAXatQgWGfEIgfH4gBiAFa60gBq0gBK18fEIEhnxCIHwiCSAJQv////8PWhunIQMLIAML3gEBBX9BACEAIwBBEGsiBCQAIAIEQCAEQekAOwAOIAQgAjYCACACQQNxIQZBpfYzIARBDmogBBAAIQMgAkEETwRAIAJBfHEhBwNAIAAgAWogACADai0AADoAACABIABBAXIiAmogAiADai0AADoAACABIABBAnIiAmogAiADai0AADoAACABIABBA3IiAmogAiADai0AADoAACAAQQRqIgAgB0cNAAsLIAYEQANAIAAgAWogACADai0AADoAACAAQQFqIQAgBUEBaiIFIAZHDQALCyADECsLIARBEGokAAtnAQF/IwBBIGsiAiQAIAAgATYCBCAAQQA2AgAgASgCAEEBRwRAIAJBxPIrNgIQQeQAQfSHKiACQRBqEJsJQZCWNCgCACgCACEAIAJBxPIrNgIAIABBkYwqIAIQbAALIAJBIGokACAAC5cCAQd/AkACQAJAIAAoAgQiAiAAKAIAIgRrIgZBBXUiAyABSQRAIAEgA2siByAAKAIIIgUgAmtBBXVNBEAgB0EFdCIBBEAgAkEAIAH8CwALIAAgASACajYCBA8LIAFBgICAwABPDQJB////PyAFIARrIgJBBHUiBSABIAEgBUkbIAJB4P///wdPGyIBQYCAgMAATw0DIAFBBXQiBRCiCSIIIAZqIQEgB0EFdCICBEAgAUEAIAL8CwALIAEgA0EFdGshAyAGBEAgAyAEIAb8CgAACyAAIAUgCGo2AgggACABIAJqNgIEIAAgAzYCACAERQ0BIAQQKw8LIAEgA08NACAAIAQgAUEFdGo2AgQLDwsQoAkACxCgCQALmxEBC38jAEHAAWsiBiQAAkACQCAERQ0AIARBgICAwABPDQEgBEEFdCIHEKIJIQ0gBwRAIA1BACAH/AsACyAGQfgAaiEMIAZB0ABqIQcDQAJAIAZBADoAvAEgBkEANgK4ASAGQeqSmL8GNgJQIAYgBzYCTCAHQa4BOgAGIAdBu88BOwAEIAYoAkwiCUHuADoACSAJQYX5ADsAByAGKAJMIglBpQE6AAwgCUHz5QE7AAogBigCTCIJQTo6AA8gCUHP6gM7AA0gBigCTCIJQdIAOgASIAlB0Rw7ABAgBigCTCIJQQU6ABUgCUH/tgI7ABMgBigCTCIJQR86ABggCUHomAI7ABYgBigCTCIJQasBOgAbIAlBg7MDOwAZIAYoAkwiCUHNAToAHiAJQdvAAzsAHCAGKAJMIglCADcAICAJQRk6AB8gBkHMAGogCkEFdCIIIAIoAgBqQSAQqgkgBiAKNgIIIAUoAhAiCUUNACAJIAZBCGogBkHMAGogCSgCACgCGBEBACAIIA1qIAZBzABqIAwCfyAGLQC8AUUEQCAGKAK4AQwBCyAGQeqSmL8GNgJQIAYgBzYCTCAHQa4BOgAGIAdBu88BOwAEIAYoAkwiCEHuADoACSAIQYX5ADsAByAGKAJMIghBpQE6AAwgCEHz5QE7AAogBigCTCIIQTo6AA8gCEHP6gM7AA0gBigCTCIIQdIAOgASIAhB0Rw7ABAgBigCTCIIQQU6ABUgCEH/tgI7ABMgBigCTCIIQR86ABggCEHomAI7ABYgBigCTCIIQasBOgAbIAhBg7MDOwAZIAYoAkwiCEHNAToAHiAIQdvAAzsAHCAGKAJMIghCADcAICAIQRk6AB8gBkEAOgC8ASAGQQA2ArgBQQALEKsJIApBAWoiCiAERw0BDAILCxCgCQALIAYgADYCCCAGIAH9AAAQ/QsCHCAGIAH9AAAA/QsCDCACKAIMIQ4gAigCECEFAkAgAEEBdCIIRQRAQQAhCQwBCyAIQYCAgMAATw0BIABBBnQiBxCiCSIJIQAgB0EgayILQQV2QQFqQQZxIgoEQEEAIQcDQCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsAACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsAECAAQSBqIQAgB0EBaiIHIApHDQALCyALQeABTwRAIAkgCEEFdGohBwNAIABBAEGAAvwLACAAQYACaiIAIAdHDQALCyAIQQFrQQV2QQJ0IgBBBGoQogkhCwJAAkAgCEEhTwRAIAAgC2pBADYCACAIQQV2IQAMAQsgC0EANgIAIAhBBXYhACAIQSBHDQELIABBAnQiB0UNACALQQAgB/wLAAsgCEEecSIHBEAgCyAAQQJ0aiIAIAAoAgBBf0EgIAdrdkF/c3E2AgALIAYoAgghAAsgBkHMAGogACADIAQQhgsgBigCTCECAkACQAJAAkACQCAAQQJPBEAgBSAOa0EFdSEPQQAhDCAAIQcDQAJAIAIgByIKQQFrIgdBA3ZB/P///wFxaigCACAHdkEBcUUNAEEBIAIgB0EBdCIIQQV2QQJ0IgFqKAIAIgUgCHZBAXEgCHIiCHQiECAFcQ0AIAwgD08NBSAJIAhBBXRqIgggDiAMQQV0aiIF/QAAAP0LAAAgCCAF/QAAEP0LABAgASALaiIIIAgoAgAgEHI2AgAgDEEBaiEMCyAKQQNPDQALDAELIAJFDQELIAIQKwsgBARAQQAhBwNAIAkgACADIAdBAnRqKAIAaiIKQQV0aiIIIA0gB0EFdGoiAv0AAAD9CwAAIAggAv0AABD9CwAQIAsgCkEDdkH8////AXFqIgggCCgCAEEBIAp0cjYCACAHQQFqIgcgBEcNAAsLIABBAk8EQCAGQfgAaiECIAZB0ABqIQoDQAJAIAsgAEEBayIAQQJ2Qfz///8BcWooAgAiBCAAQQF0Igd2QQFxRQ0AIAQgB0EBciIIdkEBcUUNACAGQQA6ALwBIAZBADYCuAEgBkHqkpi/BjYCUCAGIAo2AkwgCkGuAToABiAKQbvPATsABCAGKAJMIgRB7gA6AAkgBEGF+QA7AAcgBigCTCIEQaUBOgAMIARB8+UBOwAKIAYoAkwiBEE6OgAPIARBz+oDOwANIAYoAkwiBEHSADoAEiAEQdEcOwAQIAYoAkwiBEEFOgAVIARB/7YCOwATIAYoAkwiBEEfOgAYIARB6JgCOwAWIAYoAkwiBEGrAToAGyAEQYOzAzsAGSAGKAJMIgRBzQE6AB4gBEHbwAM7ABwgBigCTCIEQgA3ACAgBEEZOgAfIAZBzABqIAkgB0EFdGpBIBCqCSAGQcwAaiAJIAhBBXRqQSAQqgkgBkEsaiAGQcwAaiACAn8gBi0AvAFFBEAgBigCuAEMAQsgBkHqkpi/BjYCUCAGIAo2AkwgCkGuAToABiAKQbvPATsABCAGKAJMIgdB7gA6AAkgB0GF+QA7AAcgBigCTCIHQaUBOgAMIAdB8+UBOwAKIAYoAkwiB0E6OgAPIAdBz+oDOwANIAYoAkwiB0HSADoAEiAHQdEcOwAQIAYoAkwiB0EFOgAVIAdB/7YCOwATIAYoAkwiB0EfOgAYIAdB6JgCOwAWIAYoAkwiB0GrAToAGyAHQYOzAzsAGSAGKAJMIgdBzQE6AB4gB0HbwAM7ABwgBigCTCIHQgA3ACAgB0EZOgAfIAZBADoAvAEgBkEANgK4AUEACxCrCSAJIABBBXRqIgcgBv0AACz9CwAAIAcgBv0AADz9CwAQIAsgAEEDdkH8////AXFqIgcgBygCAEEBIAB0cjYCAAsgAEEBSw0ACwtBACEAIAstAABBAnFFDQEgBkEMaiAJQSBqQSAQhAJFIQAMAQsgAhArQQAhACALRQ0BCyALECsLIAkEQCAJECsLIA0QKyAGQcABaiQAIAAPCxCgCQALxQIBA38gASgCECEIQaAgEJ4JIgYgCDYCCCAGIAI2AgQgBiAFNgIAIAZBEGogBRDdCgJAAkAgASgCECIFRQ0AIAVBgICAgAFPDQEgBUEEdCIFEJ4JIQcgBUUNACAHQQAgBfwLAAsCQCACRQ0AIAJBBHQiAkUNACAHIAMgAvwKAAALIAYgBxDeCgJAIAEoAgwiBUUNACAHIAEoAhhBBHRqIQJBACEBIAVBAUcEQCAFQQFxIQMgBUF+cSEIA0AgACABQQR0aiACIAQgAUECdGooAgBBBHRq/QAEAP0LBAAgACABQQFyIgVBBHRqIAIgBCAFQQJ0aigCAEEEdGr9AAQA/QsEACABQQJqIgEgCEcNAAsgA0UNAQsgACABQQR0aiACIAQgAUECdGooAgBBBHRq/QAEAP0LBAALIAcQKyAGECsPCxCgCQALuAMBA38gASgCECEJQSgQogkgAiAJIAYgBRDgCiEHAkACQCABKAIQIgVFDQAgBUGAgIDAAE8NASAFQQV0IgUQogkhCCAFRQ0AIAhBACAF/AsACwJAIAJFDQAgAkEFdCICRQ0AIAggAyAC/AoAAAsgByAIEOIKAkAgASgCDCIFRQ0AIAggASgCGEEFdGohAkEAIQEgBUEBRwRAIAVBAXEhAyAFQX5xIQkDQCAAIAFBBXRqIgUgAiAEIAFBAnRqKAIAQQV0aiIG/QADAP0LAwAgBSAG/QADEP0LAxAgACABQQFyIgVBBXRqIgYgAiAEIAVBAnRqKAIAQQV0aiIF/QADAP0LAwAgBiAF/QADEP0LAxAgAUECaiIBIAlHDQALIANFDQELIAAgAUEFdGoiACACIAQgAUECdGooAgBBBXRqIgH9AAMA/QsDACAAIAH9AAMQ/QsDEAsgCBArIAcoAhwiAQRAIAcgATYCICABECsLIAcoAhAiAQRAIAcgATYCFCABECsLIAcoAgwhASAHQQA2AgwgAQRAIAEoAlwiBARAIAEgBDYCYCAEECsLIAEQKwsgBxArDwsQoAkACygBAX9BEBCiCSIBQdDTMTYCACABIAApAgQ3AgQgASAAKAIMNgIMIAELHwAgAUHQ0zE2AgAgASAAKQIENwIEIAEgACgCDDYCDAsuAQF/IAAoAgQiAygCNCAAKAIIKAJMIAEoAgBBBXRqIAMoAgwgAiAAKAIMEJILCygBAX9BEBCiCSIBQYzTMTYCACABIAApAgQ3AgQgASAAKAIMNgIMIAELHwAgAUGM0zE2AgAgASAAKQIENwIEIAEgACgCDDYCDAtuAQN/IwBBEGsiAyQAIAAoAgQiBCgCNCIFBEAgACgCCCgCTCABKAIAQQR0aiEBIAQoAgwhBEEAIQADQCADIAEgACAEbEEEdGr9AAQA/QsEACACIANBEBCqCSAAQQFqIgAgBUcNAAsLIANBEGokAAuLAQECfyMAQaABayIEJAAgBCAAIARBngFqIAEbIgA2ApQBIAQgAUEBayIFQQAgASAFTxs2ApgBIARBAEGQAfwLACAEQX82AkwgBEE0NgIkIARBfzYCUCAEIARBnwFqNgIsIAQgBEGUAWo2AlQgAEEAOgAAIAQgAiADQTtBPBDrDCEBIARBoAFqJAAgAQvqBQEIfyMAQSBrIgkkACADKAIcIQsgACgCCCEHIAAoAgwhCgJAAkACQAJAAkACQAJ/AkACQAJAAkAgAygCQEEBaw4CAgABCwwECyALQQFGDQELIAlB/wE2AgggASgChAghDCACIAFBiAj8CgAAIAFBhAhqDAELIAMoAhghCCAJQf8BNgIIIAEoAoQIIQwgAiABQYgI/AoAACAIBEBBACEIDAMLIAFBhAhqCyENQQAhCCAKIAdrIgpBBkE/IA0oAgBBAkYbTQ0BIAUgCUEIaiAHIAogBSAGEKYLIgdBiH9LDQIgByAKRgRAQQEhCAwCCyAHIApBB3ZBBGpNDQEgC0EHSyEHIAkoAgghCCAMQQFGBEAgASAFIAgQpwshDAsgAkEAQYQI/AsAIAIgBSAIQQsgCiAIIAVBgAhqIg0gBkGACGsiCyACIAVBAkEAIAcbEKgLIA0gCxCpCyIHQYh/Sw0CIAIgBSAIEKoLIQ4gBEEEakGAASACIAggByANIAsQqwshBwJAIAxFDQAgASAFIAgQqgsiCyAKTw0AQQMhCCAHQQxqIApPDQEgCyAHIA5qTQ0BC0EAIQggByAOaiAKSQ0DCyACIAFBiAj8CgAACyAEIAg2AgAgBEEANgKEAQwCCyAEIAc2AoQBDAILIARBAjYCACACQQE2AoQIIAQgBzYChAEgB0GIf0sNAQsCQAJ/IAAoAgQiByAAKAIAIghGBEAgAkIANwLcI0EAIQMgAkEANgLkI0EAIQJBACEAQQAhBUEADAELIAlBCGogACAHIAhrQQN1IAFBiAhqIAJBiAhqIARBlAFqIARBmQJqIAMoAhwgBSAFQdQBaiAGQdQBaxCsCyAJKAIUIgBBiH9LDQEgCSgCGCEFIAkoAhAhAiAJKAIIIQMgCSgCDAshASAEIAU2AqACIAQgAjYCkAEgBCABNgKMASAEIAM2AogBCyAEIAA2ApwCIABBACAAQYl/TxshBwsgCUEgaiQAIAcLtwMBB38gBEEDcQRAQX8PCyAFQYAgSQRAQb5/DwsgASgCAEH+AU0EQCAAIAEgAiADQQEgBBDNCw8LIAFB/wE2AgAgA0HbC00EQCAAQQBBgAj8CwAgAwRAIAIgA2ohBQNAIAAgAi0AAEECdGoiBCAEKAIAQQFqNgIAIAJBAWoiAiAFSQ0AC0H/ASECQYACIQRBACEFA0AgBSIGQQFqIQUgBCIHQQFrIQQgAiIDQQFrIQIgACADQQJ0aigCAEUNAAsgASADNgIAQQAhA0EAIQRBACECIAZB/QFrQQNPBEAgAEEMaiEIIABBCGohCSAAQQRqIQogB0F8cSELQQAhBQNAIAggBUECdCIEaigCACIBIAQgCWooAgAiBiAEIApqKAIAIgwgACAEaigCACIEIAIgAiAESRsiAiACIAxJGyICIAIgBkkbIgIgASACSxshAiAFQQRqIgUgC0cNAAsgB0F8cSEECyAHQQNxIgEEQANAIAAgBEECdGooAgAiBSACIAIgBUkbIQIgBEEBaiEEIANBAWoiAyABRw0ACwsgAg8LIAFBADYCAEEADwsgACABIAIgA0EAIAQQzQsLrQEBBH8gAC0AASACTwR/IABBBGohBUEAIQACQCABIAIEfyACQQFqQX5xIQYDQCAEIAEgAEECdCIDaigCAEEARyADIAVqLQAARXFyIAEgA0EEciIDaigCAEEARyADIAVqLQAARXFyIQQgAEECaiIAIAZHDQALIAJBAXENASACQQFrQX5xQQJqBSAAC0ECdCIAaigCAEEARyAAIAVqLQAARXEgBHIhBAsgBEUFIAMLC4YFAQ1/IAdBAnFFBEBBDEEFQSAgAWdrIgZBISACZ2siByAGIAdJGyIGQR4gAUEBa2drIgcgAEELIAAbIgEgASAHSxsiByAGIAdLGyIGIAZBBU0bIgYgBkEMTxsPCwJAIAJBf0YEQEEAIQcMAQsgAkEBaiIIQQNxIQxBACEBQQAhByACQQNPBEAgBkEMaiEJIAZBCGohDSAGQQRqIQsgCEF8cSEOQQAhCANAIAcgBiAIQQJ0IgFqKAIAQQBHaiABIAtqKAIAQQBHaiABIA1qKAIAQQBHaiABIAlqKAIAQQBHaiEHIAhBBGoiCCAORw0ACyACQQNrQXxxQQRqIQELIAxFDQADQCAHIAYgAUECdGooAgBBAEdqIQcgAUEBaiEBIApBAWoiCiAMRw0ACwsgAEEgIAdnayIQSQRAIAAPCyAEQewFayERIANB7AVqIRIgAkEBcSETIAVBBGohCkF+IQsgAkEBakF+cSENIAJBAWtBfnFBAmohFCAQIQcgACEPA0ACQAJAIAUgBiACIAciCSADIAQQqQsiB0GIf0sNACAHIAlJIAkgEEtxDQEgEiARIAUgAiAHIAMgBBCrCyIOQYh/Sw0AQQAhByACQQBOBH9BACEIQQAhAQJAIAIEQANAIAogB0ECdCIBQQRyIgxqLQAAIAYgDGooAgBsIAEgCmotAAAgASAGaigCAGwgCGpqIQggB0ECaiIHIA1HDQALIAghByAUIQEgEw0BCyAKIAFBAnQiAWotAAAgASAGaigCAGwgB2ohCAsgCEEDdgUgBwsgDmoiByALQQFqSw0BIAkgDyAHIAtJIgEbIQ8gByALIAEbIQsLIAlBAWohByAAIAlHDQELCyAPC8QgAhN/AXsjAEHgAGsiCCQAAkAgBUEAIARrQQNxIgdrIgZBACAFIAZPG0GAJkkEQEG+fyEKDAELIAJB/wFLBEBBUiEKDAELIAQgB2oiDkEAIAUgB08bIRFBACEEIA5BAEGAIPwLACARQYAgaiIFQQBBgAb8CwAgAkEBaiESAkAgAgRAIAFBBGohCSASQf4DcSEKA0AgBSABIARBAnQiB2ooAgAiBkG9ASAGZ2sgBkGlAUkbQQJ0aiIGIAYvAQBBAWo7AQAgBSAHIAlqKAIAIgZBvQEgBmdrIAZBpQFJG0ECdGoiBiAGLwEAQQFqOwEAIARBAmoiBCAKRw0ACyACQQFxDQELIAUgASAEQQJ0aigCACIEQb0BIARnayAEQaUBSRtBAnRqIgQgBC8BAEEBajsBAAsgEUEIaiEEQb8BIQYDQCAFIAZBAnRqIgdBAmsgB0EEayIJLwEAIAcvAQBqIgc7AQAgCSAHOwEAIAZBAWsiCQRAIAUgCUECdGoiCUECayAJQQRrIgkvAQAgB2oiBzsBACAJIAc7AQAgBkECayEGDAELCyARQYYgaiEJAkACQCACRQRAQQAhBgwBCyASQf4DcSEMQQAhBgNAIAkgASAGQQJ0aigCACIHQb0BIAdnayAHQaUBSRtBAnRqIgogCi8BACIKQQFqOwEAIAQgCkEDdGoiCiAGOgAGIAogBzYCACAJIAEgBkEBciIKQQJ0aigCACIHQb0BIAdnayAHQaUBSRtBAnRqIgsgCy8BACILQQFqOwEAIAQgC0EDdGoiCyAKOgAGIAsgBzYCACAGQQJqIgYgDEcNAAsgAkEBcQ0BCyAJIAEgBkECdGooAgAiB0G9ASAHZ2sgB0GlAUkbQQJ0aiIBIAEvAQAiAUEBajsBACAEIAFBA3RqIgEgBjoABiABIAc2AgALQaUBIQYDQCAFIAZBAnRqIgcvAQIgBy8BACIHayIBQQJOBEAgBCAHQQN0akEAIAFBAWsQxAsLIAZBAWoiBkG/AUcNAAsgAkH/AWohBSASIQYgAiEHA0AgBiITQQFrIQYgBSIMQQFrIQUgByILQQFrIQcgBCALQQN0aiIBKAIAIglFDQALIA4gAUEIaygCACAJajYCiBAgAUGAAjsBBCABQQRrQYACOwEAIAtB/wFqIRUgA0ELIAMbIQoCQAJAAkAgC0ECTgRAQYECIQZBgQIgDCAMQYECTBsiFkEHcSEBIAxBiAJOBEAgDkFAayEJIA5BOGohAyAOQTBqIQ0gDkEoaiEPIA5BIGohECAOQRhqIRQgDkEQaiEXIBZB+P///wdxQYgCayEYQQAhBwNAIAQgBkEDdCIFakGAgICABDYCACAFIBdqQYCAgIAENgIAIAUgFGpBgICAgAQ2AgAgBSAQakGAgICABDYCACAFIA9qQYCAgIAENgIAIAUgDWpBgICAgAQ2AgAgAyAFakGAgICABDYCACAFIAlqQYCAgIAENgIAIAZBCGohBiAHIBhHIQUgB0EIaiEHIAUNAAsLIAEEQEEAIQUDQCAEIAZBA3RqQYCAgIAENgIAIAZBAWohBiAFQQFqIgUgAUcNAAsLIAtBAmshBiAOQYCAgIB4NgIAQYECIQVBgAIhBwNAIAQgBUEDdGogBCAHIAQgBkEDdGooAgAiCSAEIAdBA3RqKAIAIgNPIg1qIgEgBiADIAlLayIJIAQgCUEDdGooAgAiAyAEIAFBA3RqKAIAIg9PIhAbQQN0aiIUKAIAIAQgByAGIA0bQQN0aiIGKAIAajYCACAUIAU7AQQgBiAFOwEEIAkgAyAPSWshBiABIBBqIQcgBSAWRyEBIAVBAWohBSABDQALIAQgFUEDdGpBADoAByAOQQ9qIQkgC0H+AWohBSAMQQFxBEAgBCAFQQN0aiIFIAkgBS8BBEEDdGotAABBAWo6AAcgC0H9AWohBQsgC0ECRwRAA0AgBCAFQQN0IgZqIgcgCSAHLwEEQQN0ai0AAEEBajoAByAGIBFqIgYgCSAGLwEEQQN0ai0AAEEBajoAByAFQYICayEGIAVBAmshBSAGQf99SQ0ACwsgE0EBcSENDAELIA5BgICAgHg2AgBBACEHIAQgFUEDdGpBADoAByALQQBIDQIgE0EBcSENIA5BD2ohCSALRQ0BCwJAIBNBAmsiA0ECSQRAQQAhBwwBCyAOQQ9qIQYgA0EBdkEBakF+cSEMQQAhB0EAIQEDQCAEIAdBA3RqIgUgBiAFLwEEQQN0ai0AAEEBajoAByAFIAYgBS8BDEEDdGotAABBAWo6AA8gBSAGIAUvARRBA3RqLQAAQQFqOgAXIAUgBiAFLwEcQQN0ai0AAEEBajoAHyAHQQRqIQcgAUECaiIBIAxHDQALCyADQQJxDQAgBCAHQQN0aiIFIA5BD2oiBiAFLwEEQQN0ai0AAEEBajoAByAFIAYgBS8BDEEDdGotAABBAWo6AA8gB0ECaiEHCyANRQ0AIAQgB0EDdGoiBSAJIAUvAQRBA3RqLQAAQQFqOgAHCwJAIAogBCALQQN0akEHaiIGLQAAIgxPBEAgDCEKDAELIBFBD2ohEEEBIAwgCmsiDXQhA0EAIQEgDCEJQQAhByALIQUDQCAGIAo6AAAgAyAHakF/IAwgCWt0aiEHIAEiFEEBaiEBIAogECAFQQFrIgVBA3RqIgYtAAAiCUkNAAsgDkEPaiEPQQAhBgNAIAYiAUEBaiEGIAUiA0EBayEFIAogDyADQQN0ai0AACIJRg0ACyAIQvDhw4ePnrz4cDcDMCAIQvDhw4ePnrz4cDcDKCAIQvDhw4ePnrz4cDcDICAIQvDhw4ePnrz4cDcDGCAIQvDhw4ePnrz4cDcDECAIQvDhw4ePnrz4cDcDCCAIQvDhw4ePnrz4cDcDACAHIA11IQ0CQCADQQBIDQAgCiEHAn8gAyALIAEgFGprQQFxRQ0AGiAFIAcgCU0NABogCCAKIAlrQQJ0aiADNgIAIAkhByAFCyEGIANFDQADQCAPIAZBA3RqLQAAIgUgB0kEQCAIIAogBWtBAnRqIAY2AgAgBSEHCyAPIAZBAWsiAUEDdGotAAAiBSAHSQRAIAggCiAFa0ECdGogATYCACAFIQcLIAZBAUohBSAGQQJrIQYgBQ0ACwsgDUEASgRAA0BBASEFAkACQCANZyIGQR9GDQAgCEEgIAZrIgZBAnRqKAIAIQkDQCAIIAZBAWsiB0ECdGooAgAhAQJAIAlB8OHDh39GDQBB8OHDh38hDCABQfDhw4d/RwRAIAQgCUEDdGooAgAgBCABQQN0aigCAEEBdEsNASABIQwLIAYiBUEMTQ0CDAMLIAEhCSAHIgZBAUsNAAsLA0ACQCAIIAVBAnRqKAIAQfDhw4d/RwRAIAUhBgwBC0ENIQYgBUEBaiIFQQ1HDQELCyAIIAZBAWsiB0ECdGooAgAhDAsgECAIIAZBAnRqIgkoAgAiBUEDdGoiASABLQAAQQFqOgAAQfDhw4d/IQEgCCAHQQJ0aiAFIAwgDEHw4cOHf0YbNgIAQX8gB3QgDWohDSAJIAUEf0Hw4cOHfyAFQQFrIgUgDyAFQQN0ai0AACAKIAZrRxsFIAELNgIAIA1BAEoNAAsLIA1BAE4NACARQRdqIQEgCCgCBCEFIA0hBgNAIAVB8OHDh39GBEAgAyEFA0AgBSIDQQFrIQUgCiAPIANBA3RqLQAARg0ACyAQIANBAWoiBUEDdGoiByAHLQAAQQFrOgAAIAZBAWohByAGQX5KDQIgByEGDAELIAEgBUEDdGoiByAHLQAAQQFrOgAAIAVBAWohBSAGQX9HIQcgBkEBaiEGIAcNAAsLQQAhBSAIQQA7ARggCEIANwMQIAj9DAAAAAAAAAAAAAAAAAAAAAD9CwQAIAhBADsBWCAIQgA3A1AgCCAZ/QsEQAJAIAtBAEgNACATQQFxIQMgDkEPaiEHIAsEQCAOQRdqIQECQCATQQJrIg1BAkkEQAwBCyANQQF2QQFqQX5xIQxBACEJA0AgCCAHIAVBA3QiBmotAABBAXRqIgsgCy8BAEEBajsBACAIIAEgBmotAABBAXRqIgsgCy8BAEEBajsBACAIIAcgBkEQciIGai0AAEEBdGoiCyALLwEAQQFqOwEAIAggASAGai0AAEEBdGoiBiAGLwEAQQFqOwEAIAVBBGohBSAJQQJqIgkgDEcNAAsLIA1BAnEEfyAFBSAIIAcgBUEDdCIGai0AAEEBdGoiCSAJLwEAQQFqOwEAIAggASAGai0AAEEBdGoiBiAGLwEAQQFqOwEAIAVBAmoLQQN0IQULIANFDQAgCCAFIAdqLQAAQQF0aiIFIAUvAQBBAWo7AQALAkAgCkUNACAKQQNxIQlBACEHQQAhBQJAIAoiBkEESQ0AIAZBAXQiASAIQUBrakEAOwEAIAFBAmsiBSAIQUBraiABIAhqLwEAQQF2IgY7AQAgAUEEayILIAhBQGtqIAUgCGovAQAgBmpB/v8DcUEBdiIFOwEAIAFBBmsiBiAIQUBraiAIIAtqLwEAIAVqQf7/A3FBAXYiBTsBACAGIAhqLwEAIAVqQf7/A3FBAXYhBSAKQQRrIQYgCkEMcSILQQRGDQAgBkEBdCIGIAhBQGtqIAU7AQAgAUEKayIMIAhBQGtqIAYgCGovAQAgBWpB/v8DcUEBdiIFOwEAIAFBDGsiBiAIQUBraiAIIAxqLwEAIAVqQf7/A3FBAXYiBTsBACABQQ5rIgEgCEFAa2ogBiAIai8BACAFakH+/wNxQQF2IgU7AQAgASAIai8BACAFakH+/wNxQQF2IQUgCkEIayEGIAtBCEYNACAGQQF0IgEgCEFAa2ogBTsBACAKQQF0IgZBEmsiCyAIQUBraiABIAhqLwEAIAVqQf7/A3FBAXYiBTsBACAGQRRrIgEgCEFAa2ogCCALai8BACAFakH+/wNxQQF2IgU7AQAgBkEWayIGIAhBQGtqIAEgCGovAQAgBWpB/v8DcUEBdiIFOwEAIAYgCGovAQAgBWpB/v8DcUEBdiEFIApBDGshBgsgCUUNAANAIAZBAXQiASAIQUBraiAFOwEAIAZBAWshBiABIAhqLwEAIAVqQf7/A3FBAXYhBSAHQQFqIgcgCUcNAAsLIABBBGohBiASQQNxIQlBACEBQQAhByACQQNPBEAgEkH8A3EhCwNAIAYgBCAHQQN0aiIFLQAGQQJ0aiAFLQAHNgIAIAYgBS0ADkECdGogBS0ADzYCACAGIAUtABZBAnRqIAUtABc2AgAgBiAFLQAeQQJ0aiAFLQAfNgIAIAdBBGoiByALRw0ACwsgCQRAA0AgBiAEIAdBA3RqIgUtAAZBAnRqIAUtAAc2AgAgB0EBaiEHIAFBAWoiASAJRw0ACwtBACEFA0AgCEFAayAGIAVBAnRqIgEoAgAiCUH/AXEiBEEBdGoiByAHLwEAIgdBAWo7AQAgBARAIAEgB0EgIARrdCAJcjYCAAsgAiAFRyEEIAVBAWohBSAEDQALIABBADsBAiAAIAI6AAEgACAKOgAACyAIQeAAaiQAIAoLpQEBBX8gAkEATgR/IABBBGohBQJAAn8gAkUEQEEADAELIAJBAWpBfnEhBgNAIAUgA0ECdCIAQQRyIgdqLQAAIAEgB2ooAgBsIAAgBWotAAAgACABaigCAGwgBGpqIQQgA0ECaiIDIAZHDQALIAJBAXENASACQQFrQX5xQQJqCyEDIAUgA0ECdCIDai0AACABIANqKAIAbCAEaiEECyAEQQN2BSADCwu9EQEQfyAGQQAgBWtBA3EiCGsiCUEAIAYgCU8bQewFSQRAQX8PCyADQf8BSwRAQVIPCyAFIAhqIgxBACAGIAhPGyIKQQA6AOADIApB4ANqIQUCQCAERQ0AQQEhBiAEQQFqIQkgBEEDcSENIARBBE8EQCAEQXxxIQ5BACEIA0AgBSAGaiIHIAQgBms6AAEgByAJIAZrOgAAIAUgBkEDaiIHaiAJIAdrOgAAIAUgBkECaiIHaiAJIAdrOgAAIAZBBGohBiAIQQRqIgggDkcNAAsLIA1FDQBBACEIA0AgBSAGaiAJIAZrOgAAIAZBAWohBiAIQQFqIgggDUcNAAsLAkAgA0UNACACQQRqIQkgDEHtA2ohCEEAIQYgA0EBRwRAIANBAXEhDSADQf4BcSEEA0AgBiAIaiAFIAkgBkECdGotAABqLQAAOgAAIAggBkEBciIHaiAFIAkgB0ECdGotAABqLQAAOgAAIAZBAmoiBiAERw0ACyANRQ0BCyAGIAhqIAUgCSAGQQJ0ai0AAGotAAA6AAALQbp/IQUCQCABRQ0AQX8hBUEAIAprQQNxIgYNACAKQe0DaiEPIABBAWohEgJAIANBAkkNACAGIApqIgv9DAAAAAAAAAAAAAAAAAAAAAD9CwKQA0EAIQggC0EANgLAAyAL/QwAAAAAAAAAAAAAAAAAAAAA/QsCsAMgC/0MAAAAAAAAAAAAAAAAAAAAAP0LAqADIAMgD2ohByALQZADaiEFIA8hBgNAIAUgBi0AAEECdGoiCSAJKAIAQQFqNgIAIAZBAWoiBiAHSQ0AC0EMIQZBDSEHA0AgByINQQFrIQcgCCIEQQFqIQggBiIJQQFrIQYgBSAJQQJ0aigCAEUNAAtBDSAEayIHQQNxIQxBACEEQQAhCEEAIQYgCUEDTwRAIAtBnANqIRAgC0GYA2ohESALQZQDaiETIAdBfHEhFEEAIQcDQCAQIAdBAnQiCGooAgAiDiAIIBFqKAIAIgIgCCATaigCACIKIAUgCGooAgAiCCAGIAYgCEkbIgYgBiAKSRsiBiACIAZLGyIGIAYgDkkbIQYgB0EEaiIHIBRHDQALIA1BfHEhCAsgDARAA0AgBSAIQQJ0aigCACIHIAYgBiAHSRshBiAIQQFqIQggBEEBaiIEIAxHDQALCyABQQFrIQICQCADIAZGDQAgBkEBRg0AIAtBxANqIgdBDEEFQSAgA2drIgZBISAJZ2siCCAGIAhJGyIGQQZBHSADQQFrZ2siCCAIQQZPGyIIIAYgCEsbIgYgBkEFTRsiBiAGQQxPGyIGIAUgAyAJQQAQwQsiBUGIf0sNAiASIAIgByAJIAYQwgsiCEGIf0sEQCAIDwsgCyAHIAkgBiALQewBakGkARDDCyIFQYh/Sw0CIAggEmohBiACIAhrIRQgCyECAkAgAyIEQQNJDQAgFEEFSQ0AIAQgBEEHdmpBCGohFiAGIBRqQQRrIQwgAkEEaiIOIA5BASACLwAAIhNBAWt0QQEgExtBAnRqIhAgBCAPaiIHQQFrLQAAQQN0aiICKAIEIgpBgIACaiIJQYCAfHEgCmsgCUEQdnVBAXRqIAIoAgBBAXRqLwEAIQICfyAEQQFxBEAgDiACIBAgB0EDayIJLQAAQQN0aiIKKAIEIAJqIhFBEHYiBHZBAXRqIAooAgBBAXRqLwEAIQ0gDiAQIAdBAmstAABBA3RqIgcoAgQiCkGAgAJqIgtBgIB8cSAKayALQRB2dUEBdGogBygCAEEBdGovAQAhCyAGIARBAnRB4KMyaigCACACcSICNgAAIAYgEUETdmohByAUIBZPBEAgBEEHcSEKIAIgBEH4/wNxdgwCCyAMIAcgByAMSxshByAEQQdxIQogAiAEQfj/A3F2DAELIA4gECAHQQJrIgktAABBA3RqIgQoAgQiB0GAgAJqIgpBgIB8cSAHayAKQRB2dUEBdGogBCgCAEEBdGovAQAhDUEAIQogBiEHIAIhC0EACyERIA1B//8DcSEEIAtB//8DcSECAkAgCSAPTQRAIAIhBSAEIQgMAQsDQCAOIAQgECAJQQJrIg0tAABBA3RqIgUoAgQgBGpBEHYiC3ZBAXRqIAUoAgBBAXRqLwEAIQggDiACIBAgCUEBay0AAEEDdGoiBSgCBCACakEQdiIJdkEBdGogBSgCAEEBdGovAQAhBSAHIAlBAnRB4KMyaigCACACcSAKdCARciALQQJ0QeCjMmooAgAgBHEgCSAKaiIEdHIiCjYAACAMIAcgBCALaiIEQQN2aiICIAIgDEsbIAIgFCAWSRshByAKIARBeHF2IREgBEEHcSEKIAghBCAFIQIgDSIJIA9LDQALCyAHIBNBAnRB4KMyaigCACICIAVxIAp0IBFyIgk2AAAgDCAHIAogE2oiBEEDdmoiByAHIAxLGyIHIAkgBEH4/wdxdiACIAhxIARBB3EiBHRyIgI2AAAgDCAHIAQgE2oiBEEDdmoiByAHIAxLGyIHIAIgBEH4/wdxdkEBIARBB3EiBHRyNgAAIAwgByAEQQFqIgJBA3ZqIgQgBCAMSxsiBCAMTw0AIAJBB3FBAEcgBmsgBGohFQsgFSIFQYh/Sw0CIAVFDQAgBSAGaiASayIFQYh/Sw0CIAVBAkkNACAFIANBAXZPDQAgACAFOgAAIAVBAWoPCyADQYABTQ0AQX8PC0G6fyEFIANBAWpBAXYiBiABTw0AIAZBAWohBSAAIANB/wBqOgAAQQAhBiADIA9qQQA6AAAgA0UNACADQQFrIQ0gA0EDTwRAIA1BAXZBAWpBfnEhBEEAIQgDQCASIAZBAXZqIAYgD2oiCS0AAEEEdCAJLQABajoAACASIAZBAnIiB0EBdmogCS0AAyAHIA9qLQAAQQR0ajoAACAGQQRqIQYgCEECaiIIIARHDQALCyANQQJxDQAgEiAGQQF2aiAGIA9qIgYtAABBBHQgBi0AAWo6AAALIAULtgYBC38jAEEQayIOJAAgASgCFCESIAEoAhAhECABKAIYIRMgAEEANgIQIAEoAgQiCyABKAIAIhRHBEBBASALIBRrQQN1IgsgC0EBTRshFUEAIQsDQEEfIBQgC0EDdGoiDCgCAGdrIQ0gDC8BBiEPIAsgEGoCfyAMLwEEIgxBwABPBEBBMiAMZ2sMAQsgDEHAkDJqLQAACzoAACALIBNqIA06AAAgCyASaiAPQYABTwR/QcMAIA9nawUgD0HAkTJqLQAACzoAAEEBIBEgDUEYSxshESALQQFqIgsgFUcNAAsLIARBsBFqIQwgASgCJCILQQFGBH8gECABKAIoakEjOgAAIAEoAiQFIAsLQQJGBEAgEiABKAIoakE0OgAACyAAIBE2AhQgDkEjNgIMIAggDkEMaiAQIAIgCSAKEK0LIQsgBCADKALcGzYC3BsgACAEQdwbaiAIIA4oAgwiDSALIAJBCSADQbARaiIPQdDcMUEGQQEgBxCuCyILNgIAAkACQAJAIAUgBiAFayAMQQkgCyAIIA0gECACQdDcMUEGQSMgD0GkCiAJIAoQrwsiDEGIf00EQCALQQJGBEAgACAMNgIQCyAOQR82AgggCCAOQQhqIBMgAiAJIAoQrQshDSAOKAIIIQsgBCADKALUGzYC1BsgACAEQdQbaiAIIAsgDSACQQggA0Gg3TFBBSALQR1JIAcQrgsiDTYCBCAFIAxqIgwgBiAMayAEQQggDSAIIAsgEyACQaDdMUEFQRwgA0GEBiAJIAoQrwsiC0GIf0sNASAEQYQGaiEPIA1BAkYEQCAAIAs2AhALIA5BNDYCBCAIIA5BBGogEiACIAkgChCtCyENIAQgAygC2Bs2AtgbIAAgBEHYG2ogCCAOKAIEIhEgDSACQQkgA0GEBmoiEEHg3TFBBkEBIAcQrgsiDTYCCCALIAxqIgsgBiALayAPQQkgDSAIIBEgEiACQeDdMUEGQTQgEEGsCyAJIAoQrwsiDEGIf0sNAiANQQJGBEAgACAMNgIQCyAAIAsgDGogBWs2AgwMAwsgACAMNgIMDAILIAAgCzYCDAwBCyAAIAw2AgwLIA5BEGokAAutAwEHfwJAAkAgA0HbC00EQCABKAIAIgZBAnRBBGoiBARAIABBACAE/AsACyADRQ0CIAIgA2ohBANAIAAgAi0AAEECdGoiAyADKAIAQQFqNgIAIAJBAWoiAiAESQ0ACyAGQQFqIQJBACEDIAYhBANAIAMiB0EBaiEDIAIiCEEBayECIAQiBUEBayEEIAAgBUECdGooAgBFDQALIAEgBTYCAEEAIQVBACEDQQAhAiAGIAdrQQNPBEAgAEEMaiEJIABBCGohCiAAQQRqIQsgCEF8cSEMQQAhBANAIAkgBEECdCIDaigCACIHIAMgCmooAgAiASADIAtqKAIAIgYgACADaigCACIDIAIgAiADSRsiAiACIAZJGyICIAEgAksbIgIgAiAHSRshAiAEQQRqIgQgDEcNAAsgCEF8cSEDCyAIQQNxIgFFDQEDQCAAIANBAnRqKAIAIgQgAiACIARJGyECIANBAWohAyAFQQFqIgUgAUcNAAsMAQsgBEEDcQRAQX8PCyAFQYAgSQRAQb5/DwsgACABIAIgA0EAIAQQzQshAgsgAg8LIAFBADYCAEEAC9cGAQZ/IwBB8ARrIg4kAAJAIAMgBEYEQCAAQQA2AgAgCUUgA0ECS3IhBwwBCwJAAkAgCkEDTQRAIAlFDQEgBEHnB00EQEEDIQcgACgCAEECRg0ECyAEQQogCmsgCHRBA3ZJDQIgAyAEIAhBAWt2Tw0BDAILQX8hD0F/IQ0gCQRAQQEgAkEBaiIDIANBAU0bIhBBAXEhDUEIIAhrIQoCfyADQQJJBEBBACEJQQAMAQsgEEF+cSEMQQAhCUEAIQMDQEEBIAcgA0EBciIIQQF0ai8BACILIAtB//8DRhvBIAp0QQJ0QcDzMWooAgAgASAIQQJ0aigCAGxBASAHIANBAXRqLwEAIgggCEH//wNGG8EgCnRBAnRBwPMxaigCACABIANBAnRqKAIAbCAJamohCSADQQJqIgMgDEcNAAsgEEF+cQshAyANBH9BASAHIANBAXRqLwEAIgcgB0H//wNGG8EgCnRBAnRBwPMxaigCACABIANBAnRqKAIAbCAJagUgCQtBCHYhDQsCQCAAKAIARQ0AIAIgBi8AAksNACAGQQEgBi8AACILQQFrdEEBIAsbQQJ0akEEaiEMQQEgC3QhBiALQQh0QYACaiEQQQAhCUEAIQMDQCABIANBAnRqKAIAIgcEQCAMIANBA3RqKAIEIgpBEHZBAWoiCEEIdCAIQRh0IAYgCmpBCHRrIAt2ayIKIBBPDQIgByAKbCAJaiEJCyACIANHIQcgA0EBaiEDIAcNAAsgCUEIdiEPCyAOQQxBBUEgIARnayIDQSEgAmdrIgcgAyAHSRsiA0EdIARBAWtnayIHIAUgBSAHSxsiByADIAdLGyIDIANBBU0bIgMgA0EMTxsiAyABIAQgAiAEQf8PSxDBCyIMQYh/TQRAIA5B8ABqQYAEIA4gAiADEMILIQwLQQEgAkEBaiIDIANBAU0bIQtBACEJQQAhAwNAQQEgASADQQJ0aigCACIHQQh0IgogBG4iCCAEIApLGyAIIAcbQQJ0QcDzMWooAgAgB2wgCWohCSADQQFqIgMgC0cNAAtBAyEHIA0gD00gDSAMQQN0IAlBCHZqIgNNcQ0BIAMgD08NAgsgAEEBNgIAQQIhBwwBC0EAIQcgAEEANgIACyAOQfAEaiQAIAcL0wIBAX8CQAJAAkACQCAEQQFrDgMAAwECCyACQQA2AQQgAkEAOwEAIAIgBkH/AXEiCDsBAiACIAhBA3RqQgA3AgggAUUEQEG6fw8LIAAgBy0AADoAAEEBDwsgDQRAIAIgDCAN/AoAAAtBAA8LIAIgCSALIAogDiAPEMMLIgJBACACQYl/TxsPCwJAIA5BDEEFQSAgCGdrIgRBISAGZ2siDSAEIA1JGyIEQR0gCEEBayINZ2siDyADIAMgD0sbIgMgAyAESRsiBCAEQQVNGyIEIARBDE8bIgQgBSEQIAUgByANai0AAEECdGoiAygCACIHQQJPBEAgAyAHQQFrNgIAIA0hCAsgECAIIAYgCEH/D0sQwQsiCEGIf0sNACAAIAEgDiAGIAQQwgsiCEGIf0sNACAIIAIgDiAGIAQgDkHsAGpB9AgQwwsiAiACQYl/SRshCAsgCAvZLAI4fwN+IwBBIGsiFCQAAkAgAkEGTQRAIAAoAtwBQQdPBEACQCAAKALcECACaiIDRQ0AIAAoAtgQIgQgACgC4BAiBiAEIAZLGyEHA0ACQAJAIAQgB0YEQCAHIQQMAQsgAyAAKALUECAEQQxsaiIFKAIIIAUoAgRqIgVPDQEgACADNgLcEAsgBCAGRg0CQQEhBQwFCyAAIARBAWoiBDYC2BAgAyAFayIDDQALCyAAQQA2AtwQQQEhBQwCCyACRQRAQQEhBQwCCyAAKALUASEVIAAoAtgQIgQgACgC4BAiCSAEIAlLGyENA0AgBCANRgRAQQEhBQwDCyAAKALUECAEQQxsaiIDKAIEIgUgAk8EQCADIAUgAms2AgRBASEFDAMLIANBADYCBCACIAVrIgcgAygCCCIGSQRAIAMgBiAHayIHNgIIQQEhBSAHIBVPDQMgCSAEQQFqIgRLBEAgAyADKAIQIAdqNgIQCyAAIAQ2AtgQDAMLIANBADYCCEEBIQUgACAEQQFqIgQ2AtgQIAcgBmsiAg0ACwwBCyAAQQA2AqAGIAAgACgChAY2AogGIAAgACgC/AU2AoAGIAAgACgC6BAiAzYCnBIgACAAKAKAAjYCoBIgASAAKAL0EGsiBCAAKAKMESIFQYADaksEQCAAIARBwAEgBCAFa0GAA2siBSAFQcABTxtrNgKMEQsCf0EBIAAoAoARIAAoAvwQSQ0AGkEAIAAoAqQSIgRFDQAaQQNBAiAEKAJsGwshByAAQfAQaiEGIABB/AVqIQogACgC7BAiBCADKALoIzYC6CMgBCADKALsIzYC7CMgBCADKALwIzYC8CMgBEHoI2ohAwJ/IAAoAtgQIAAoAuAQSQRAIAAoAuwCBEBBVyEFDAMLIABB1BBqIAYgCiADIAAoAswCIAEgAhCxCwwBCyAAKAKUAkEBRgRAIBRBADYCFCAUQgA3AgwgACgC7AIEQEFXIQUMAwsgFCAAKALMECIqNgIIIBQgACgC0BAiKzYCGCAUQQhqIAYgCiACQRR2IAJB//8/cUEAR2oiMgR/IAEgAmohM0EBIAAoAqgCdCEhIABBzAhqISwgAEHMBmohHANAIA4gK0kEQAJ/IDMgASAtQRR0IgRqIg1BgIBAayACIARrQYCAwABJGyIdIAAoAqwGIh5rIgNBgICA6AdNBEAgACgCxAYMAQsgACANQQJrIgQgIWs2AqwGIAAgACgCvAZBAWo2ArwGIAAgBCAeICFqayIEIAAoArAGajYCsAYgAEECIAAoArgGIgMgBGsgAyAEQQJqIgVJGzYCuAYgAEECIAAoArQGIgMgBGsgAyAFSRs2ArQGQQEgACgCmAIiA3QhBSAAKALABiEHAkAgA0ECSQRAIAVBA3EhCUEAIQMDQCAHIANBA3RqIgUgBSgCACIFIARrIgZBACAFIAZPGzYCACADQQFqIgMgCUcNAAsMAQsgB0EYaiEVIAdBEGohCyAHQQhqIQwgBUF8cSEKQQAhBQNAIAcgBUEDdCIDaiIGIAYoAgAiBiAEayIJQQAgBiAJTxs2AgAgAyAMaiIGIAYoAgAiBiAEayIJQQAgBiAJTxs2AgAgAyALaiIGIAYoAgAiBiAEayIJQQAgBiAJTxs2AgAgAyAVaiIDIAMoAgAiAyAEayIGQQAgAyAGTxs2AgAgBUEEaiIFIApHDQALCyAAQQA2AsQGIB0gACgCrAYiHmshA0EACyEFIAAoArgGIQQCQCAFICFqIANPBEAgACgCtAYhEgwBCyADICFrIgMgBEsEQCAAIAM2ArgGIAMhBAsgBCAAKAK0BiISSwRAIAAgBDYCtAYgBCESCyAAQQA2AsQGCyAAKAKcAiEDIAAoApgCIQcgACgCoAIhFkEAISIgEiIQIARNIjRFBEAgACgCsAYhIiAEIRALIA4hCCAdIA1rIichBQJAIBYgJ0sNACANIBZqIhMgDSAnaiIjQQhrIi5PDQAgEiAiaiI1QQAgBCASSSIEGyEfIBAgImpBACAEGyEkIBIgHmohF0J/IAAoAqQCIgSthkJ/hUHAACAWIBZBwABPGyIFIARrQQAgBEEBayAFSRuthiE8ICNBAWshLyAjQQNrISVBACAWayE2QX8gByADa3RBf3MhN0L/////DyE7QQEgA3RBA3QhOANAQQAhD0EAIQoCQAJAAkAgLiATayIEQQNNDQADQCAKQQFyIQMCQCAKIBNqLQAAQQN0QdD9MWopAwAgO0IBhnwiOyA8g0IAUg0AIBwgD0ECdGogAzYCACAPQQFqIg9BwABHDQAgAyEKQcAAIQ8MAwsgCkECciEFAkAgAyATai0AAEEDdEHQ/TFqKQMAIDtCAYZ8IjsgPINCAFINACAcIA9BAnRqIAU2AgAgD0EBaiIPQcAARw0AIAUhCkHAACEPDAMLIApBA3IhAwJAIAUgE2otAABBA3RB0P0xaikDACA7QgGGfCI7IDyDQgBSDQAgHCAPQQJ0aiADNgIAIA9BAWoiD0HAAEcNACADIQpBwAAhDwwDCyAKQQRqIQoCQCADIBNqLQAAQQN0QdD9MWopAwAgO0IBhnwiOyA8g1AEQCAcIA9BAnRqIAo2AgAgD0EBaiIPQcAARg0BCyAKQQNyIARPDQIMAQsLQcAAIQ8MAQsCQCAEIApNDQADQCAKIBNqIQMgCkEBaiEKIAMtAABBA3RB0P0xaikDACA7QgGGfCI7IDyDUARAIBwgD0ECdGogCjYCACAPQQFqIg9BwABGDQIgBCAKSw0BDAILIAQgCksNAAsLIA9FDQELIBMgNmohByAAKALABiEGIAAoApwCIQlBACEEA0AgByAcIARBAnRqKAIAaiIFIBYQsgshPSAsIARBBHRqIgMgBTYCACADID1CIIg+AgggAyA9pyA3cSIFNgIEIAMgBiAFIAl0QQN0ajYCDCAEQQFqIgQgD0cNAAsgCiATaiE5QQAhKANAICwgKEEEdGoiBCgCACIGIB5rISkgBCgCBCEmIAQoAgghCQJAAkAgBiANSQ0AIAQoAgwiBCA4aiEVQQAhGEEAIRlBACEaQQAhIANAAkAgBCgCBCAJRw0AIAQoAgAiDCAQTQ0AAkAgNEUEQCAiIB4gDCASSSIwGyAMaiIRIQUgEQJ/AkAgBiIDIDUgIyAwGyI6IBFraiIHICMgByAdSRsiG0EDayIHIANNDQAgESgAACILIAMoAAAiDEcEQCALIAxzaEEDdgwCCwNAIAVBBGohBSADQQRqIgMgB08NASAFKAAAIgsgAygAACIMRg0ACyADIAsgDHNoQQN2aiAGawwBCwJAIAMgG0EBa08NACAFLwAAIAMvAABHDQAgBUECaiEFIANBAmohAwsgAyAbSQR/IAMgBS0AACADLQAARmoFIAMLIAZrCyILaiA6RgRAIBchBSAGIAtqIhshAwJ/AkAgGyAlTw0AIAUoAAAiByAbKAAAIgxHBEAgByAMc2hBA3YMAgsDQCAFQQRqIQUgA0EEaiIDICVPDQEgBSgAACIHIAMoAAAiDEYNAAsgAyAHIAxzaEEDdmogG2sMAQsCQCADIC9PDQAgBS8AACADLwAARw0AIAVBAmohBSADQQJqIQMLIAMgHUkEfyADIAUtAAAgAy0AAEZqBSADCyAbawsgC2ohCwsgCyAWSQ0CICQgFyAwGyEMQQAhAwJAIAYgDU0NACAGIQUgESIHIAxNDQADQCAFQQFrIgUtAAAgB0EBayIHLQAARw0BIANBAWohAyAFIA1NDQEgByAMSw0ACwsgDCAkRg0BIBEgA2sgDEcNAUEAIQwCQCAfICRNDQAgHyEHIAYgA2siBSANTQ0AA0AgBUEBayIFLQAAIAdBAWsiBy0AAEcNASAMQQFqIQwgBSANTQ0BIAcgJEsNAAsLIAMgDGohAwwBCyAMIB5qIgchBSAWAn8CQCAlIAYiA00NACAHKAAAIgsgAygAACIRRwRAIAsgEXNoQQN2DAILA0AgBUEEaiEFIANBBGoiAyAlTw0BIAUoAAAiCyADKAAAIhFGDQALIAMgCyARc2hBA3ZqIAZrDAELAkAgAyAvTw0AIAUvAAAgAy8AAEcNACAFQQJqIQUgA0ECaiEDCyADIB1JBH8gAyAFLQAAIAMtAABGagUgAwsgBmsLIgtLDQFBACEDIAYgDU0NACAGIQUgDCASTQ0AA0AgBUEBayIFLQAAIAdBAWsiBy0AAEcNASADQQFqIQMgBSANTQ0BIAcgF0sNAAsLIAMgC2oiBSAgTQ0AIAUhICAEIRogAyEZIAshGAsgBEEIaiIEIBVJDQALIBpFDQAgCCArRgRAQbp/IQUMDAsgGigCACEDICogCEEMbGoiBCAYIBlqNgIIIAQgBiAZayANazYCBCAEICkgA2s2AgAgFCAIQQFqIgg2AhQgACgCwAYgJiAAKAKcAiIEdEEDdGogACgCyAYgJmoiAy0AACIFQQN0aiAprSAJrUIghoQ3AgAgAyAFQQFqQX8gBHRBf3NxOgAAIAYgGGoiDSA5TQ0BIA0gCmshEwwDCyAAKALABiAmIAAoApwCIgR0QQN0aiAAKALIBiAmaiIDLQAAIgVBA3RqICmtIAmtQiCGhDcCACADIAVBAWpBfyAEdEF/c3E6AAALIChBAWoiKCAPRw0ACwsgCiATaiITIC5JDQALIB0gDWshBQsgBUGIf0sNBQJ/IAggDksEQCAqIA5BDGxqIgQgBCgCBCAxajYCBCAFDAELICcgMWoLITEgCCEOIC1BAWoiLSAyRw0BCwsgACgC7BAFIAQLQegjaiAAKALMAiABIAIQsQsMAQsgACgC7AIiBARAQZZ/IQUCQAJAIAAoAugCIAAoAtAdIAAoAtQdIAEgAkEAQQAgACgC7AFBASAAKALEAXQgBBEXACIJQQFrIAAoAtQdIgRPDQAgACgC0B0gCUEEdGoiA0EQaygCACADQQhrKAIAcgRAIAQgCUYNASAD/QwAAAAAAAAAAAAAAAAAAAAA/QsCACAJQQFqIQkLIAlBiH9NDQEgCSEFCyAAKALkAkUNAyAAQQA2AsQSIAYgCiAAKALsEEHoI2ogASACIAdBKGwgACgC3AEiBEECdGpBgNsxaiIDIAMgB0EMbCAEQQNrIgRBAnRqQaDcMWogACgCzAJBAUcbIARBAksbKAIAEQgADAILQQAhBCAUQQA2AhAgFEIANwMIIAAoAtAdIQ0gCQRAIAlBA3EhFUEAIQZBACEDQQAhByAJQQRPBEAgCUF8cSELQQAhBQNAIA0gBUEEdGoiBCgCOCAEKAIoIAQoAhggBCgCCCAHampqaiEHIAQoAjQgBCgCJCAEKAIUIAQoAgQgA2pqamohAyAFQQRqIgUgC0cNAAsgCUF8cSEECyAVBEADQCANIARBBHRqIgUoAgggB2ohByAFKAIEIANqIQMgBEEBaiEEIAZBAWoiBiAVRw0ACwtBlX8hBSAJIQQgAyAHaiACSw0DCyAEIRIgASEEIAIhByAAKALwAiEMIwBBEGshDiAUQQhqIhEoAgAhBgJ/IAAoArATIgEEQCABKAIEDAELQQAgACgCtBNFDQAaIAAoArgTCyEPIAQgB2ohICAOIAAoAugQIgFB8CNqKAIANgIIIA4gASkC6CM3AwACQAJAIAYgEk8EQCAGIQMMAQsgIEEgayEXIA4oAgghGCAOKAIEIQogDigCACEFIAxBAkchEyAGIQMDQCANIANBBHRqIgEoAggiGUUEQCABKAIARQ0CCyABKAIEIRACQCATRQRAIAEoAgBBA2ohCwwBCyABKAIAIQECfwJAAkAgEEUNACABIAVHDQBBASELDAELIAEgCkYEQEECQQEgEBshCwwBCyABIBhGBEAgEEVBA3MhCwwBCwJAIBANACABIAVBAWtHDQBBAyELDAELIAFBA2oiC0EDTQ0AIAoMAQsCfwJAAkAgCyAQQQBHayIIDgQEAQEAAQsgBUEBawwBCyAOIAhBAnRqKAIACyEBIBggCiAIQQFGGwshGCAOIAU2AgQgDiAYNgIIIA4gATYCACAFIQogASEFCyAAKAK8AgRAIBEgESgCCCAQIBlqaiIBNgIIQZV/IQkgC0EBIAAoAsQBdCIIIAEgD2ogASAISxtBA2pLDQMgGUEDQQNBBCAAKALUAUEDRhsgACgC7AIbSQ0DC0GVfyEJIAAoApgGIAMgESgCAGtNDQIgACgCiAYhAgJAAkAgFyAEIBBqIhpPBEAgAiAE/QAAAP0LAAAgACgCiAYhCCAQQRBNBEAgACAIIBBqNgKIBiAAKAKABiEBDAMLIAggBP0AABD9CwAQIBBBIUgNASAIIBBqIQIgBEEQaiEBIAhBIGohCANAIAggAf0AABD9CwAAIAggAf0AACD9CwAQIAFBIGohASAIQSBqIgggAkkNAAsMAQsgGgJ/IAQgF0sEQCACIQEgBAwBCyACIAT9AAAA/QsAACACIBcgBGsiCGohASAIQRFOBEAgAkEQaiEIIAQhAgNAIAggAv0AABD9CwAAIAggAv0AACD9CwAQIAJBIGohAiAIQSBqIgggAUkNAAsLIBcLIghNDQAgGiAIayIfQQFrIRVBACECIB9BB3EiHwRAA0AgASAILQAAOgAAIAFBAWohASAIQQFqIQggAkEBaiICIB9HDQALCyAVQQdJDQADQCABIAgtAAA6AAAgASAILQABOgABIAEgCC0AAjoAAiABIAgtAAM6AAMgASAILQAEOgAEIAEgCC0ABToABSABIAgtAAY6AAYgASAILQAHOgAHIAFBCGohASAIQQhqIgggGkcNAAsLIAAgACgCiAYgEGo2AogGIAAoAoAGIQEgEEGAgARJDQAgAEEBNgKgBiAAIAEgACgC/AVrQQN1NgKkBgsgASALNgIAIAEgEDsBBCAZQQNrIghBgIAETwRAIABBAjYCoAYgACABIAAoAvwFa0EDdTYCpAYLIAEgCDsBBiAAIAFBCGo2AoAGIAQgGWogEGohBCADQQFqIgMgEkcNAAsMAQtBlX8hCSADIBJGDQACQCAMQQJHDQAgAyAGRg0AAkAgA0EBayIBIAZBAmoiCE8EQCAOIA0gA0EEdGoiCEEwaygCADYCCCAOIAhBIGsoAgA2AgQMAQsgAyAIRgRAIA4gDigCADYCCCAOIA0gA0EEdGpBIGsoAgA2AgQMAQsgDiAOKQMANwIECyAOIA0gAUEEdGooAgA2AgALIAAoAuwQIgEgDikDADcC6CMgAUHwI2ogDigCCDYCACANIANBBHRqIggoAgQiAQR/IAhBBGohCCABBEAgACgCiAYgBCAB/AoAAAsgACAAKAKIBiABajYCiAYgESAIKAIAIgEgESgCCGo2AgggASAEagUgBAsgIEcNACARIANBAWo2AgAgByEJCyAJIgVBiH9LDQJBACEFIABBADYCxBIMAgsgAEEANgLEEiAGIAogAyABIAIgB0EobCAAKALcASIEQQJ0akGA2zFqIgUgBSAHQQxsIARBA2siBEECdGpBoNwxaiAAKALMAkEBRxsgBEECSxsoAgARCAALIgQEQCAAKAKIBiABIAJqIARrIAT8CgAACyAAIAAoAogGIARqNgKIBkEAIQULIBRBIGokACAFC58TAg5/A34gASgC0AEhBwJ/QQEgASgCECABKAIMSQ0AGkEAIAEoArQBIghFDQAaQQNBAiAIKAJsGwsiCEEobCAHQQJ0akGA2zFqIgkgCSAIQQxsIAdBA2siCEECdGpBoNwxaiAEQQFHGyAIQQJLGygCACEQAkAgB0EGTQRAIAUgBmohDQJAIAAoAgQiByAAKAIMIglPDQAgASgCyAEhEyANQSBrIQ4gA0EEaiEUA0AgACgCACIKIAdBDGxqIggoAgAhDAJAIA0gBWsiBiAIKAIIIhEgCCgCBCIPak8EQCAAIAdBAWo2AgQMAQsCQCAGIA9LBEAgDEEAIAYgD2siESATTxshDAwBC0EAIQwgBkUNAwsDQCAHIAlGDQEgCiAHQQxsaiIIKAIEIgQgBk8EQCAIIAQgBms2AgQMAgsgCEEANgIEIAYgBGsiBiAIKAIIIgRJBEAgCCAEIAZrIgY2AgggBiATTw0CIAkgB0EBaiIHSwRAIAggCCgCECAGajYCEAsgACAHNgIEDAILIAhBADYCCCAAIAdBAWoiBzYCBCAGIARrIgYNAAsLIAxFDQEgBSABKAIEIgZrIgggASgCHCIHQYAIaksEQCABIAhBgAQgCCAHa0GACGsiByAHQYAETxtrIgc2AhwLAkACQAJAIAEoAtABQQFrDgIAAQILIAYgB2oiB0EDaiIIIAVBBmsiCU8NASABKAJcIQpBICABKALAASIEayESQcAAIARrrSEVIAEoAsgBQQVrIQsDQCAKAn8CQAJAAkACQAJAIAsOBAECAwQACyAHKAAAQbHz3fF5bCASdgwECyAHKQAAQoCAgNjLm++NT34gFYinDAMLIAcpAABCgIDs/Mub741PfiAViKcMAgsgBykAAEKAxpX9y5vvjU9+IBWIpwwBCyAHKQAAQuPIlb3Lm++NT34gFYinC0ECdGogByAGazYCACAIIgdBA2oiCCAJSQ0ACwwBCyAFQQhrIgQgBiAHaiIHQQJqSQ0AIAEoAmQhCSABKAJcIQpBICABKAK8ASIIayESQcAAIAEoAsABa60hF0HAACAIa60hFiABKALIAUEFayELA0AgCQJ/AkACQAJAAkACQCALDgQCAQADBAsgBykAACIVQoDGlf3Lm++NT34gFoinDAQLIAcpAAAiFUKAgOz8y5vvjU9+IBaIpwwDCyAHKQAAIhVCgICA2Mub741PfiAWiKcMAgsgBykAACIVQuPIlb3Lm++NT34gFoinDAELIAcpAAAhFSAHKAAAQbHz3fF5bCASdgtBAnRqIAcgBmsiCDYCACAKIBVC48iVvcub741PfiAXiKdBAnRqIAg2AgAgB0EFaiEIIAdBA2ohByAEIAhPDQALCyABIAIgAyAFIA8gEBEIACEJIAMpAgAhFSADIAw2AgAgFCAVNwIAIAUgD2oiBCAJayEHIAxBA2ohCiACKAIMIQgCQAJAIAQgDk0EQCAIIAf9AAAA/QsAACACKAIMIQggCUEQTQRAIAIgCCAJajYCDCACKAIEIQcMAwsgCCAH/QAAEP0LABAgCUEhSA0BIAggCWohBiAHQRBqIQcgCEEgaiEIA0AgCCAH/QAAEP0LAAAgCCAH/QAAIP0LABAgB0EgaiEHIAhBIGoiCCAGSQ0ACwwBCyAHIA5NBEAgCCAH/QAAAP0LAAAgCCAOIAdrIgVqIQYgBUERTgRAIAhBEGohCANAIAggB/0AABD9CwAAIAggB/0AACD9CwAQIAdBIGohByAIQSBqIgggBkkNAAsLIAYhCCAOIQcLIAQgB00NACAEIAdrIgVBAWshC0EAIQYgBUEHcSIFBEADQCAIIActAAA6AAAgCEEBaiEIIAdBAWohByAGQQFqIgYgBUcNAAsLIAtBB0kNAANAIAggBy0AADoAACAIIActAAE6AAEgCCAHLQACOgACIAggBy0AAzoAAyAIIActAAQ6AAQgCCAHLQAFOgAFIAggBy0ABjoABiAIIActAAc6AAcgCEEIaiEIIAdBCGoiByAERw0ACwsgAiACKAIMIAlqNgIMIAIoAgQhByAJQYCABEkNACACQQE2AiQgAiAHIAIoAgBrQQN1NgIoCyAHIAo2AgAgByAJOwEEIBFBA2siCEGAgARPBEAgAkECNgIkIAIgByACKAIAa0EDdTYCKAsgByAIOwEGIAIgB0EIajYCBCAEIBFqIQUgACgCBCIHIAAoAgwiCU8NASAFIA1JDQALCyAFIAEoAgQiBmsiCCABKAIcIgdBgAhqSwRAIAEgCEGABCAIIAdrQYAIayIHIAdBgARPG2siBzYCHAsCQAJAAkAgASgC0AFBAWsOAgABAgsgBiAHaiIHQQNqIgggBUEGayIATw0BIAEoAlwhCUEgIAEoAsABIgRrIQtBwAAgBGutIRUgASgCyAFBBWshCgNAIAkCfwJAAkACQAJAAkAgCg4EAQIDBAALIAcoAABBsfPd8XlsIAt2DAQLIAcpAABCgICA2Mub741PfiAViKcMAwsgBykAAEKAgOz8y5vvjU9+IBWIpwwCCyAHKQAAQoDGlf3Lm++NT34gFYinDAELIAcpAABC48iVvcub741PfiAViKcLQQJ0aiAHIAZrNgIAIAgiB0EDaiIIIABJDQALDAELIAVBCGsiBCAGIAdqIgdBAmpJDQAgASgCZCEAIAEoAlwhCUEgIAEoArwBIghrIQtBwAAgASgCwAFrrSEXQcAAIAhrrSEWIAEoAsgBQQVrIQoDQCAAAn8CQAJAAkACQAJAIAoOBAIBAAMECyAHKQAAIhVCgMaV/cub741PfiAWiKcMBAsgBykAACIVQoCA7PzLm++NT34gFoinDAMLIAcpAAAiFUKAgIDYy5vvjU9+IBaIpwwCCyAHKQAAIhVC48iVvcub741PfiAWiKcMAQsgBykAACEVIAcoAABBsfPd8XlsIAt2C0ECdGogByAGayIINgIAIAkgFULjyJW9y5vvjU9+IBeIp0ECdGogCDYCACAHQQVqIQggB0EDaiEHIAQgCE8NAAsLIAEgAiADIAUgDSAFayAQEQgAIQEMAQsgASAANgLUASABIAIgAyAFIAYgEBEIACEBAkAgACgCCCAGaiIIRQ0AIAAoAgQiByAAKAIMIgUgBSAHSRshBANAAkACQCAEIAdGBEAgBCEHDAELIAggACgCACAHQQxsaiIGKAIIIAYoAgRqIgZPDQEgACAINgIICyAFIAdGDQIMAwsgACAHQQFqIgc2AgQgCCAGayIIDQALCyAAQQA2AgggAQ8LIAEL7A0CCH4BfwJAIABBB3FFBEAgAEUEQELFz9my8eW66ichAgwCCwJ+IAFBIE8EQCAAIAFqQR9rIQpC+erQ0OfJoeThACECQtbrgu7q/Yn14AAhBELP1tO+0ser2UIhBQNAIAApAxhCz9bTvtLHq9lCfiACfEIfiSIGQoeVr6+Ytt6bnn9+IQIgACkDEELP1tO+0ser2UJ+IAN8Qh+JIgdCh5Wvr5i23puef34hAyAAKQMIQs/W077Sx6vZQn4gBXxCH4kiCEKHla+vmLbem55/fiEFIAApAwBCz9bTvtLHq9lCfiAEfEIfiSIJQoeVr6+Ytt6bnn9+IQQgAEEgaiIAIApJDQALIAGtIAVCB4kgBEIBiXwgA0IMiXwgAkISiXwgCUKp2eX7kODW+V5+Qh+JQoeVr6+Ytt6bnn9+hUKHla+vmLbem55/fkKdo7Xqg7GNivoAfSAIQqnZ5fuQ4Nb5Xn5CH4lCh5Wvr5i23puef36FQoeVr6+Ytt6bnn9+Qp2jteqDsY2K+gB9IAdCqdnl+5Dg1vlefkIfiUKHla+vmLbem55/foVCh5Wvr5i23puef35CnaO16oOxjYr6AH0gBkKp2eX7kODW+V5+Qh+JQoeVr6+Ytt6bnn9+hUKHla+vmLbem55/fnxCnaO16oOxjYr6AH0MAQsgAa1Cxc/ZsvHluuonfAshAgJAIAFBH3EiCkEISQRAIAAhAQwBCwNAIAApAABCz9bTvtLHq9lCfkIfiUKHla+vmLbem55/fiAChUIbiUKHla+vmLbem55/fkKdo7Xqg7GNivoAfSECIABBCGoiASEAIApBCGsiCkEHSw0ACwsgCkEESQR/IAEFIApBBGshCiABNQAAQoeVr6+Ytt6bnn9+IAKFQheJQs/W077Sx6vZQn5C+fPd8Zn2masWfCECIAFBBGoLIQAgCkUNAQJ/IApBAXFFBEAgCiEBIAAMAQsgCkEBayEBIAAxAABCxc/ZsvHluuonfiAChUILiUKHla+vmLbem55/fiECIABBAWoLIQAgCkEBRg0BA0AgADEAAULFz9my8eW66id+IAAxAABCxc/ZsvHluuonfiAChUILiUKHla+vmLbem55/foVCC4lCh5Wvr5i23puef34hAiAAQQJqIQAgAUECayIBDQALDAELIABFBEBCxc/ZsvHluuonIQIMAQsCfiABQSBPBEAgACABakEfayEKQvnq0NDnyaHk4QAhAkLW64Lu6v2J9eAAIQRCz9bTvtLHq9lCIQUDQCAAKQAYQs/W077Sx6vZQn4gAnxCH4kiBkKHla+vmLbem55/fiECIAApABBCz9bTvtLHq9lCfiADfEIfiSIHQoeVr6+Ytt6bnn9+IQMgACkACELP1tO+0ser2UJ+IAV8Qh+JIghCh5Wvr5i23puef34hBSAAKQAAQs/W077Sx6vZQn4gBHxCH4kiCUKHla+vmLbem55/fiEEIABBIGoiACAKSQ0ACyABrSAFQgeJIARCAYl8IANCDIl8IAJCEol8IAlCqdnl+5Dg1vlefkIfiUKHla+vmLbem55/foVCh5Wvr5i23puef35CnaO16oOxjYr6AH0gCEKp2eX7kODW+V5+Qh+JQoeVr6+Ytt6bnn9+hUKHla+vmLbem55/fkKdo7Xqg7GNivoAfSAHQqnZ5fuQ4Nb5Xn5CH4lCh5Wvr5i23puef36FQoeVr6+Ytt6bnn9+Qp2jteqDsY2K+gB9IAZCqdnl+5Dg1vlefkIfiUKHla+vmLbem55/foVCh5Wvr5i23puef358Qp2jteqDsY2K+gB9DAELIAGtQsXP2bLx5brqJ3wLIQICQCABQR9xIgpBCEkEQCAAIQEMAQsDQCAAKQAAQs/W077Sx6vZQn5CH4lCh5Wvr5i23puef34gAoVCG4lCh5Wvr5i23puef35CnaO16oOxjYr6AH0hAiAAQQhqIgEhACAKQQhrIgpBB0sNAAsLIApBBEkEfyABBSAKQQRrIQogATUAAEKHla+vmLbem55/fiAChUIXiULP1tO+0ser2UJ+Qvnz3fGZ9pmrFnwhAiABQQRqCyEAIApFDQACfyAKQQFxRQRAIAohASAADAELIApBAWshASAAMQAAQsXP2bLx5brqJ34gAoVCC4lCh5Wvr5i23puef34hAiAAQQFqCyEAIApBAUYNAANAIAAxAAFCxc/ZsvHluuonfiAAMQAAQsXP2bLx5brqJ34gAoVCC4lCh5Wvr5i23puef36FQguJQoeVr6+Ytt6bnn9+IQIgAEECaiEAIAFBAmsiAQ0ACwsgAkIhiCAChULP1tO+0ser2UJ+IgJCHYggAoVC+fPd8Zn2masWfiICQiCIIAKFC84CAQl/AkACQCABQQFGDQAgAC0AACEIIAFBD3EiBARAIAAgBGohBiAAIgNBAWoiByECAn8CQAJAIARBBUkNACADKAAAIgIgAygAASIDRw0BIAZBA2shBSAAIQMgByECA0AgA0EEaiEDIAJBBGoiAiAFTw0BIAMoAAAiCSACKAAAIgpGDQALIAIgCSAKc2hBA3ZqIAdrDAILAkAgAiAGQQFrTw0AIAMvAAAgAi8AAEcNACADQQJqIQMgAkECaiECCyACIAZJBH8gAiADLQAAIAItAABGagUgAgsgB2sMAQsgAiADc2hBA3YLIQJBACEFIAIgBEEBa0cNAgsgAUEQSQ0AIAhBgYKECGwhAgNAIAAgBGoiAygAACACRw0CIAMoAAQgAkcNAiADKAAIIAJHDQIgAygADCACRw0CIARBEGoiBCABRw0ACwtBASEFCyAFC90BAQd/AkAgAiABa0GsAkkNACADQZgUaiEHIANB7BNqIQggA0HAE2ohCSAAKAIEIQUDQCAFQcMBSw0BIAkgBCABIAIQtQsgCCAEIAEgASACakEBdiIGELULIAcgBCAGIAIQtQsgCSADELYLIQUgCCADELYLIQogByADELYLIQsgBUGIf0sNASAKQYh/Sw0BIAtBiH9LDQEgCiALaiAFTw0BIAAgASAGIAMgBBC0CyAAKAIAIAAoAgQiAUECdGogBjYCACAAIAFBAWoiBTYCBCACIAYiAWtBqwJLDQALCwvQBQEIfyAAIAH9AAIA/QsCACAAIAEoAig2AiggACABKQIgNwIgIAAgAf0AAhD9CwIQIAIEQAJAIAEoAgAgAkEDdGoiBSAAKAIAIgZGBEAMAQtBASAFIAZrQQN1IgUgBUEBTRsiCkEBcSELIAAoAighBwJ/IAVBAkkEQEEADAELIApBfnEhCEEAIQUDQCAEIAYgBUEDdGovAQRqIQQgBSAHRgR/IARBgIAEaiAEIAAoAiRBAUYbBSAECyAGIAVBAXIiCUEDdGovAQRqIQQgByAJRgRAIARBgIAEaiAEIAAoAiRBAUYbIQQLIAVBAmoiBSAIRw0ACyAKQX5xCyEFIAtFDQAgBCAGIAVBA3RqLwEEaiEEIAUgB0cNACAEQYCABGogBCAAKAIkQQFGGyEECyAAIAAoAgggBGo2AggLAkAgASgCJEUNACACIAEoAigiBU0gAyAFT3FFBEAgAEEANgIkDAELIAAgACgCKCACazYCKAsgACABKAIAIAJBA3RqIgY2AgAgACABKAIAIgUgA0EDdGoiBDYCBCABKAIEIAVrQQN1IANHBEACQCAEIAZGBEBBACEEDAELQQEgBCAGa0EDdSIFIAVBAU0bIghBAXEhAyAAKAIoIQcCfyAFQQJJBEBBACEEQQAMAQsgCEF+cSEBQQAhBEEAIQUDQCAEIAYgBUEDdGovAQRqIQQgBSAHRgR/IARBgIAEaiAEIAAoAiRBAUYbBSAECyAGIAVBAXIiCUEDdGovAQRqIQQgByAJRgRAIARBgIAEaiAEIAAoAiRBAUYbIQQLIAVBAmoiBSABRw0ACyAIQX5xCyEFIANFDQAgBCAGIAVBA3RqLwEEaiEEIAUgB0cNACAEQYCABGogBCAAKAIkQQFGGyEECyAAIAAoAgggBGo2AgwLIAAgACgCECACajYCECAAIAAoAhQgAmo2AhQgACAAKAIYIAJqNgIYC4sRARR/IwBBEGsiCSQAIAAgASgC6BAgASgC7BAgAUHAAWogAUGsG2ogASgC0BIgASgC1BIQpQsiDkGIf00EQCABKALUEiEPIAEoAtASIQYgASgC7BAhCyAAKAIUIQ4gACgCECEEIAAoAhghAiAAKAIAIRQgACgCBCEVIAEoAqwbIQcgACgCDCEDIAAoAgghACAJQf8BNgIMIAMgAGshECAVIBRrQQN1IQwCQAJAAkACQCAHDgQDAAEBAgtBASEQDAILIAYgCUEMaiAAIBAgBiAPEKYLQYh/Sw0BQQRBAyAQQf8HSxshEiAQQf//AEshE0EAIQAgCSgCDCINQQBOBEAgC0EEaiEKAkACfyANRQRAQQAMAQsgDUEBakF+cSEIA0AgCiAAQQJ0IgNBBHIiEWotAAAgBiARaigCAGwgAyAKai0AACADIAZqKAIAbCAFamohBSAAQQJqIgAgCEcNAAsgDUEBcQ0BIA1BAWtBfnFBAmoLIQAgCiAAQQJ0IgBqLQAAIAAgBmooAgBsIAVqIQULIAVBA3YhAAsgEiATaiEDIAdBAkYEQCABKAKwHCAAaiEACyADIAAgAEEGaiAQQYACSRtqIRAMAQtBACEQCyABKAK4HCEDIAlBHzYCDCAGIAlBDGogAiAMIAYgDxCtCxpBACEAAn8CQAJAAkACQCADDgIAAgELQQEgCSgCDEEBaiIAIABBAU0bIghBAXEhBwJ/IABBAkkEQEEAIQNBAAwBCyAIQX5xIRFBACEDQQAhAANAQQEgAEEBciIFQQF0QaDdMWovAQAiCiAKQf//A0YbwUEFdEHA8zFqKAIAIAYgBUECdGooAgBsQQEgAEEBdEGg3TFqLwEAIgUgBUH//wNGG8FBBXRBwPMxaigCACAGIABBAnRqKAIAbCADamohAyAAQQJqIgAgEUcNAAsgCEF+cQshACAHBH9BASAAQQF0QaDdMWovAQAiBSAFQf//A0YbwUEFdEHA8zFqKAIAIAYgAEECdGooAgBsIANqBSADC0EIdiEADAELIANBfnFBAkcNACAJKAIMIgggCy8AighLDQEgC0EBIAsvAIgIIgdBAWt0QQEgBxtBAnRqQYwIaiENQQEgB3QhEiAHQQh0QYACaiETQQAhBQNAIAYgAEECdGooAgAiAwRAIA0gAEEDdGooAgQiCkEQdkEBaiIRQQh0IBFBGHQgCiASakEIdGsgB3ZrIgogE08NAyADIApsIAVqIQULIAAgCEchAyAAQQFqIQAgAw0ACyAFQQh2IQALIBQgFUcEQCACIAxqIQMDQCAAIAItAABqIQAgAkEBaiICIANJDQALCyAAQQN2DAELIAxBCmwLIREgASgCtBwhACAJQSM2AgwgBiAJQQxqIAQgDCAGIA8QrQsaQQAhAgJ/AkACQAJAAkAgAA4CAAIBC0EBIAkoAgxBAWoiAiACQQFNGyIIQQFxIQcCfyACQQJJBEBBACEAQQAMAQsgCEF+cSEKQQAhAEEAIQIDQEEBIAJBAXIiA0EBdEHQ3DFqLwEAIgUgBUH//wNGG8FBBHRBwPMxaigCACAGIANBAnRqKAIAbEEBIAJBAXRB0Nwxai8BACIDIANB//8DRhvBQQR0QcDzMWooAgAgBiACQQJ0aigCAGwgAGpqIQAgAkECaiICIApHDQALIAhBfnELIQIgBwR/QQEgAkEBdEHQ3DFqLwEAIgMgA0H//wNGG8FBBHRBwPMxaigCACAGIAJBAnRqKAIAbCAAagUgAAtBCHYhAgwBCyAAQX5xQQJHDQAgCSgCDCIIIAsvALoZSw0BIAtBASALLwC4GSIHQQFrdEEBIAcbQQJ0akG8GWohDUEBIAd0IRIgB0EIdEGAAmohE0EAIQMDQCAGIAJBAnRqKAIAIgAEQCANIAJBA3RqKAIEIgVBEHZBAWoiCkEIdCAKQRh0IAUgEmpBCHRrIAd2ayIFIBNPDQMgACAFbCADaiEDCyACIAhHIQAgAkEBaiECIAANAAsgA0EIdiECCyAUIBVHBEAgBCAMaiEAA0AgAiAELQAAQZCQMmotAABqIQIgBEEBaiIEIABJDQALCyACQQN2DAELIAxBCmwLIQogASgCvBwhAiAJQTQ2AgwgBiAJQQxqIA4gDCAGIA8QrQsaQQAhBCABKALIHQJ/AkACQAJAAkAgAg4CAAIBC0EBIAkoAgxBAWoiBCAEQQFNGyIPQQFxIQgCfyAEQQJJBEBBACECQQAMAQsgD0F+cSEFQQAhAkEAIQQDQEEBIARBAXIiAEEBdEHg3TFqLwEAIgMgA0H//wNGG8FBBHRBwPMxaigCACAGIABBAnRqKAIAbEEBIARBAXRB4N0xai8BACIAIABB//8DRhvBQQR0QcDzMWooAgAgBiAEQQJ0aigCAGwgAmpqIQIgBEECaiIEIAVHDQALIA9BfnELIQQgCAR/QQEgBEEBdEHg3TFqLwEAIgAgAEH//wNGG8FBBHRBwPMxaigCACAGIARBAnRqKAIAbCACagUgAgtBCHYhBAwBCyACQX5xQQJHDQAgCSgCDCIPIAsvAI4OSw0BIAtBASALLwCMDiIIQQFrdEEBIAgbQQJ0akGQDmohB0EBIAh0IQsgCEEIdEGAAmohDUEAIQADQCAGIARBAnRqKAIAIgIEQCAHIARBA3RqKAIEIgNBEHZBAWoiBUEIdCAFQRh0IAMgC2pBCHRrIAh2ayIDIA1PDQMgAiADbCAAaiEACyAEIA9HIQIgBEEBaiEEIAINAAsgAEEIdiEECyAUIBVHBEAgDCAOaiECA0AgBCAOLQAAQYCRMmotAABqIQQgDkEBaiIOIAJJDQALCyAEQQN2DAELIAxBCmwLQQRBAyAMQf/9AUsbQQNBAiAMQf8ASxtqIBBqIBFqIApqamohDgsgCUEQaiQAIA4L8wcBD38jAEEQayIMJAAgDCACKAIINgIIIAwgAikCADcDAAJAIAlFDQAgASgCBCIJIAEoAgAiEWtBA3UiFyEQIAEoAiRBAUYEQCABKAIoIRALIAkgEUYNACADQQhqIRIgA0EEaiETIAJBCGohFCACQQRqIRVBACEJA0AgESAJQQN0aiIPLwEERSAJIBBHcSENIA8oAgAiCiELAkACQAJAIApBAWsiFkECTQRAAn8gDSAWaiILQQNGBEAgAygCAEEBayEOIAIoAgBBAWsMAQsgAyALQQJ0IgtqKAIAIQ4gAiALaigCAAshGCAKIQsgDiAYRg0BIA8gDkEDaiILNgIACyALQQRJDQAgAiACKQIANwIEIAtBA2shCwwBCwJ/AkACQCALIA1BAXNrIg8OBAQBAQABCyACKAIAIg5BAWsMAQsgAigCACEOIAIgD0ECdGooAgALIQsgFCAUIBUgD0EBRhsoAgA2AgAgFSAONgIACyACIAs2AgALAkACQCAKQQRPBEAgAyADKQIANwIEIApBA2shCgwBCwJ/AkACQCANIBZqIgsOBAQBAQABCyADKAIAIg1BAWsMAQsgAygCACENIAMgC0ECdGooAgALIQogEiASIBMgC0EBRhsoAgA2AgAgEyANNgIACyADIAo2AgALIAlBAWoiCSAXRw0ACwtBun8hCQJAIAVBA0kNAEEAIQoCQCAEQQNqIg0gBUEDayIDIAEoAggiCyABKAIMIAtrIAEgACgC6BAgACgC7BAgAEHAAWogACgC0BIgACgC1BIgACgCCBC4CyILRQ0AIAtBun9GIAMgB09xDQAgC0GIf0sEQCALIQkMAgsgC0EAIAsgByAHQQcgACgC3AEiCiAKQQdNG0EBa3ZrQQJrSRshCgsCQCAKQRhLDQAgACgC9AUNAEEBIAogBiAHELMLGyEKCyAAKALkBQRAIABB5AVqIAEgDBC5CyIJQYh/Sw0BIAAgACkD6BBCIIk3A+gQQQAhCQwBCwJAAkACQAJAAkAgCg4CAAECCyAHQQNqIgogBUsNBCAEIAdBDXY6AAIgBCAIIAdBA3RyOwAAIAcEQCANIAYgB/wKAAALIApBiH9LDQMgAiAMKQMANwIAIAIgDCgCCDYCCAwCCyAFQQNGDQMgBCAGLQAAOgADIAQgB0ENdjoAAiAEIAggB0EDdHJBAnI7AAAgAiAMKAIINgIIIAIgDCkDADcCAEEEIQoMAQsgACAAKQPoEEIgiTcD6BAgBCAKQQ12OgACIAQgCkEDdCAIckEEcjsAACAKQQNqIQoLIAAoAugQIgkoAtwjQQJHDQAgCUEBNgLcIwsgCiEJCyAMQRBqJAAgCQvpCwEYfyMAQSBrIgwkACAEKAIEIhIgBCgCACIRa0EDdSENIAQoAhQhFCAEKAIQIRUgBCgCGCEWIAcoAhwhDiARIBJGBH9BCAVBCEEAIAMgDW5BFE8bCyEPQQEhCwJAAkACQCAHKAJAQQFrDgICAAELQQAhCwwBCyAOQQFHDQAgBygCGEUhCwsgBiAFQYgI/AoAACAJQdQBayEJIAhB1AFqIRMCQAJAAkAgC0UEQCABIANB/x9LQQJBASADQR9LG2oiCyADaiIHSQRAQbp/IQcMBAsCQAJAAkACQCALQQJrDgIBAgALIAAgA0EDdDoAAAwCCyAAIANBBHRBBHI7AAAMAQsgACADQQR0QQxyNgAACyADRQ0BIAAgC2ogAiAD/AoAAAwBC0EGQQhBA0EJIA5rIgcgB0EDTht0IAUoAoQIIgtBAkYbIANLBEAgASADQf8fS0ECQQEgA0EfSxtqIgsgA2oiB0kEQEG6fyEHDAQLAkACQAJAAkAgC0ECaw4CAQIACyAAIANBA3Q6AAAMAgsgACADQQR0QQRyOwAADAELIAAgA0EEdEEMcjYAAAsgA0UNAiAAIAtqIAIgA/wKAAAMAgtBun8hByABIANB//8AS0EEQQMgA0H/B0sbaiIQTQ0CIAwgCzYCCCAAIBBqIRggASAQayEZIAIhGiADIRtB/wEhHEELIR0gEyEeIAkhHyAGISAgDEEIaiEhIA9BBEEAIA5BBEkbQQAgA0GBCEkbQQJBACAOQQdLIg8bcnIgCkEAR3IhIgJAIAtBAkcgEEEDR3IgA0H/AUtxIhcEfyAYIBkgGiAbIBwgHSAeIB8gICAhICIQugsFIBggGSAaIBsgHCAdIB4gHyAgICEgIhC7CwsiC0EBa0GHf00EQCALIAMgAyAOQQcgDxtBAWt2a0ECa0kNAQsgBiAFQYgI/AoAACADQf8fS0ECQQEgA0EfSxtqIgsgA2oiCiABSw0DAkACQAJAAkAgC0ECaw4CAQIACyAAIANBA3Q6AAAMAgsgACADQQR0QQRyOwAADAELIAAgA0EEdEEMcjYAAAsgA0UEQCAKIQcMAgsgACALaiACIAP8CgAAIAohBwwBCyAMKAIIIQ8CQAJAAkACQAJAAkAgC0EBRw0AIANBB0sNASACLQAAIQpBASEHA0AgAiAHai0AACAKRw0BIAMgB0EBaiIHRw0ACwwBCyAPRQRAIAZBATYChAgLQQNBAiAPGyEHIBBBBGsOAgIDAQsgBiAFQYgI/AoAAAJAAkACQAJAIANB/x9LQQJBASADQR9LG2oiB0ECaw4CAQIACyAAIANBA3RBAXI6AAAMAgsgACADQQR0QQVyOwAADAELIAAgA0EEdEENcjYAAAsgACAHaiACLQAAOgAAIAdBAWohBwwFCyAAIANBBHRBBEEAIBcbciALQQ50aiIDQRB2OgACIAAgAyAHcjsAAAwCCyAAIAtBEnQgA0EEdGogB3JBCHI2AAAMAQsgACALQQp2OgAEIAAgC0EWdCADQQR0aiAHckEMcjYAAAsgCyAQaiEHCyAHQYh/Sw0BCyABIAdrQQRIBEBBun8hBwwBCyAAIAdqIQMCfyANQf8ATQRAIAMgDToAACADQQFqDAELIA1B//0BTQRAIAMgDToAASADIA1BCHZBgAFyOgAAIANBAmoMAQsgA0H/AToAACADIA1BgP4BazsAASADQQNqCyEDIAZBiAhqIQsgESASRgRAIAsgBUGICGpB4Bv8CgAAIAMgAGshBwwBCyAMQQhqIAQgDSAFQYgIaiALIANBAWoiBSAAIAFqIgEgDiAIIBMgCRCsCyAMKAIUIgdBiX9PDQAgAyAMKAIMQQR0IAwoAghBBnRqIAwoAhBBAnRqOgAAIAwoAhghBCAFIAdqIgMgASADayAGQYwOaiAUIAsgFiAGQbgZaiAVIBEgDSAMKAIcELwLIgdBiH9LDQACQCAERQ0AIAQgB2pBBE8NAEEAIQcMAQsgAyAHaiAAayEHCyAMQSBqJAAgBwunBAEUf0G6fyEOIAEoAgQiAyABKAIAIg9rQQN1IgtBAWoiEiAAKAIMIAAoAggiEGtNBEAgASgCCCETIAEoAgwhFCAAKAIEIBBBBHRqIREjAEEQayIEIAIoAgg2AgggBCACKQIANwMAQQAhDiADIA9HBEBBASALIAtBAU0bIRUgASgCKCEWIAQoAgghDCAEKAIEIQ0gBCgCACEHQQAhAgNAIBEgAkEEdGoiAyAPIAJBA3RqIgUvAQQiCTYCBCAFLwEGIQYgA0EANgIMIAMgBkEDajYCCAJAIAIgFkYEQCAJIQoCQAJAIAEoAiRBAWsOAgABAwsgAyAJQYCABHIiCjYCBAwCCyADIAZBg4AEajYCCAsgCSEKCwJAAn8CQAJAIAUoAgAiBUEBayIGQQJNBEAgAyAFNgIMIAoEQCADIAQgBkECdGooAgA2AgAMAwsgBUEDRw0BIAMgB0EBazYCAAwCCyADIAVBA2siBjYCACAFQQNNDQEgDQwCCyADIAQgBUECdGooAgA2AgALAn8CQAJAIAUgCUEAR2siAw4EBAEBAAELIAdBAWsMAQsgBCADQQJ0aigCAAshBiAMIA0gA0EBRhsLIQwgBCAHNgIEIAQgDDYCCCAEIAY2AgAgByENIAYhBwsgCCAKaiEIIAJBAWoiAiAVRw0ACwsgESALQQR0aiICQQA2AgggAiAUIAggE2prNgIEIAJBADYCACAAIBAgEmo2AggLIA4LHQAgACABIAIgAyAEIAVBASAGIAcgCCAJIAoQxwsLHQAgACABIAIgAyAEIAVBACAGIAcgCCAJIAoQxwsL+w0BFH9Bun8hCwJAIAFBBUkNACAGQQRqIhggGEEBIAYvAAAiE0EBa3RBASATG0ECdGoiGyAHIAlBAWsiC2otAAAiDEEDdGoiBigCBCIQQYCAAmoiDUGAgHxxIBBrIA1BEHZ1QQF0aiAGKAIAQQF0ai8BACEQIARBBGoiGSAZQQEgBC8AACIUQQFrdEEBIBQbQQJ0aiIcIAUgC2oiDy0AAEEDdGoiBigCBCIEQYCAAmoiDUGAgHxxIARrIA1BEHZ1QQF0aiAGKAIAQQF0ai8BACEGIAJBBGoiGiAaQQEgAi8AACIVQQFrdEEBIBUbQQJ0aiIdIAMgC2oiDi0AAEEDdGoiBCgCBCICQYCAAmoiDUGAgHxxIAJrIA1BEHZ1QQF0aiAEKAIAQQF0ai8BACEEIAAgDEGQkDJqLQAAIgJBAnRB4KMyaigCACAIIAtBA3RqIg0vAQRxIgw2AAAgACABakEEayILIAAgAkEDdmoiASABIAtLGyIRIA4tAABBgJEyai0AACIBQQJ0QeCjMmooAgAgDS8BBnEgAkEHcSIOdCAMIAJB+AFxdnIiDDYAACALIBEgASAOaiIBQQN2aiICIAIgC0sbIQIgDCABQfgDcXYhDiABQQdxIQwCQCAKBEBBGCEBQQAhEQJAIA8tAAAiD0EYSQRAIA8hAQwBCyAPQRhGDQAgAiAPQRhrIhFBAnRB4KMyaigCACANKAIAcSAMdCAOciIONgAAIAsgAiAMIBFqIgxBA3ZqIgIgAiALSxshAiAOIAxBeHF2IQ4gDEEHcSEMCyABQQJ0QeCjMmooAgAgDSgCACARdnEgDHQgDnIhDSABIAxqIQEMAQsgDCAPLQAAIg9qIQEgD0ECdEHgozJqKAIAIA0oAgBxIAx0IA5yIQ0LIAIgDTYAACALIAIgAUEDdmoiAiACIAtLGyECIAFBB3EhDCANIAFB+ANxdiESAkAgCUECSQRAIAYhFiAEIRcMAQsgCUECayEBA0AgGiAEIB0gASADai0AACIeQQN0aiINKAIEIARqQRB2Ig52QQF0aiANKAIAQQF0ai8BACEXIBkgBiAcIAEgBWotAAAiDUEDdGoiESgCBCAGakEQdiIPdkEBdGogESgCAEEBdGovAQAhFiABIAdqLQAAIREgAiAPQQJ0QeCjMmooAgAgBnEgDHQgEnIgDkECdEHgozJqKAIAIARxIAwgD2oiBHRyIgw2AAAgGyARQQN0aiIPKAIEIBBqQRB2IgZBAnRB4KMyaigCACAQcSESIBggECAGdkEBdGogDygCAEEBdGovAQAhECALIAIgBCAOaiIEQQN2aiICIAIgC0sbIgIgEiAEQQdxIg50IAwgBEH4/w9xdnIiDzYAACALIAIgBiAOaiIEQQN2aiIGIAYgC0sbIQYgEUGQkDJqLQAAIgJBAnRB4KMyaigCACAIIAFBA3RqIgwvAQRxIARBB3EiDnQgDyAEQfj/B3F2ciEEIAIgDmohDiAeQYCRMmotAAAiDyACakEZSQR/IA4FIAYgBDYAACALIAYgDkEDdmoiBiAGIAtLGyEGIAQgDkH4A3F2IQQgDkEHcQshAiAGIA9BAnRB4KMyaigCACAMLwEGcSACdCAEciIONgAAIAsgBiACIA9qIgJBA3ZqIgYgBiALSxshBCAOIAJB+AdxdiEOIAJBB3EhAgJAIAoEQEEAIQ8CQCANQRhJBEAgDSEGDAELQRghBiANQRhGDQAgBCANQRhrIg9BAnRB4KMyaigCACAMKAIAcSACdCAOciINNgAAIAsgBCACIA9qIgJBA3ZqIgQgBCALSxshBCANIAJBeHF2IQ4gAkEHcSECCyAGQQJ0QeCjMmooAgAgDCgCACAPdnEgAnQgDnIhDSACIAZqIQYMAQsgAiANaiEGIA1BAnRB4KMyaigCACAMKAIAcSACdCAOciENCyAEIA02AAAgCyAEIAZBA3ZqIgQgBCALSxshAiAGQQdxIQwgDSAGQfgDcXYhEiAXIQQgFiEGIAFBAWsiASAJSQ0ACwsgAiAVQQJ0QeCjMmooAgAgF3EgDHQgEnIiBjYAACALIAIgDCAVaiIBQQN2aiIEIAQgC0sbIgQgBiABQfj/B3F2IBRBAnRB4KMyaigCACAWcSABQQdxIgF0ciIGNgAAIAsgBCABIBRqIgFBA3ZqIgQgBCALSxsiBCAGIAFB+P8HcXYgE0ECdEHgozJqKAIAIBBxIAFBB3EiAXRyIgY2AAAgCyAEIAEgE2oiAUEDdmoiECALIBBJGyIQIAYgAUH4/wdxdkEBIAFBB3EiAXRyNgAAIAsgCyAQIAFBAWoiBkEDdmoiASABIAtLGyIBSwRAIAEgBkEHcUEAR2ogAGsiCw0BC0G6fyELCyALC94EARR/IAFBEE4EQCABQRBtIQcgAkECaiEBIABBPGohCCAAQThqIQkgAEE0aiEKIABBMGohCyAAQSxqIQwgAEEoaiENIABBJGohDiAAQSBqIQ8gAEEcaiEQIABBGGohESAAQRRqIRIgAEEQaiETIABBDGohFCAAQQhqIRUgAEEEaiEWA0AgACAFQQJ0IgRqIgMgAygCACIDIAJrQQAgASADTRs2AgAgBCAWaiIDIAMoAgAiAyACa0EAIAEgA00bNgIAIAQgFWoiAyADKAIAIgMgAmtBACABIANNGzYCACAEIBRqIgMgAygCACIDIAJrQQAgASADTRs2AgAgBCATaiIDIAMoAgAiAyACa0EAIAEgA00bNgIAIAQgEmoiAyADKAIAIgMgAmtBACABIANNGzYCACAEIBFqIgMgAygCACIDIAJrQQAgASADTRs2AgAgBCAQaiIDIAMoAgAiAyACa0EAIAEgA00bNgIAIAQgD2oiAyADKAIAIgMgAmtBACABIANNGzYCACAEIA5qIgMgAygCACIDIAJrQQAgASADTRs2AgAgBCANaiIDIAMoAgAiAyACa0EAIAEgA00bNgIAIAQgDGoiAyADKAIAIgMgAmtBACABIANNGzYCACAEIAtqIgMgAygCACIDIAJrQQAgASADTRs2AgAgBCAKaiIDIAMoAgAiAyACa0EAIAEgA00bNgIAIAQgCWoiAyADKAIAIgMgAmtBACABIANNGzYCACAEIAhqIgQgBCgCACIEIAJrQQAgASAETRs2AgAgBUEQaiEFIAZBAWoiBiAHRw0ACwsLuwQCAn8EfgJAIAFFDQAgACAAKQMAIAKtfDcDACAAKAJIIgMgAmpBH00EQCACBEAgACADakEoaiABIAL8CgAACyAAIAAoAkggAmo2AkgPCyABIAJqIQQgAwRAQSAgA2siAgRAIABBKGogA2ogASAC/AoAAAsgACgCSCECIABBADYCSCAAIAApAwggACkAKELP1tO+0ser2UJ+fEIfiUKHla+vmLbem55/fjcDCCAAIAApAxAgACkAMELP1tO+0ser2UJ+fEIfiUKHla+vmLbem55/fjcDECAAIAApAxggACkAOELP1tO+0ser2UJ+fEIfiUKHla+vmLbem55/fjcDGCAAIAApAyAgACkAQELP1tO+0ser2UJ+fEIfiUKHla+vmLbem55/fjcDICABIAJrQSBqIQELIAQgAUEgak8EQCAEQSBrIQIgACkDICEFIAApAxghBiAAKQMQIQcgACkDCCEIA0AgACABKQAAQs/W077Sx6vZQn4gCHxCH4lCh5Wvr5i23puef34iCDcDCCAAIAEpAAhCz9bTvtLHq9lCfiAHfEIfiUKHla+vmLbem55/fiIHNwMQIAAgASkAEELP1tO+0ser2UJ+IAZ8Qh+JQoeVr6+Ytt6bnn9+IgY3AxggACABKQAYQs/W077Sx6vZQn4gBXxCH4lCh5Wvr5i23puef34iBTcDICABQSBqIgEgAk0NAAsLIAEgBE8NACAEIAFrIgIEQCAAQShqIAEgAvwKAAALIAAgAjYCSAsLoQoBB39BAyEVIAwEQCABKAIAIRULIApBA2ohESALQQNrIRQgCiALaiEWIA5BADYCAAJAAkACQCAFRQRAIBQNAUG6fw8LAkACQAJAAkAgASgCACILDgIAAQILIBQgBUH/H0tBAkEBIAVBH0sbaiIMIAVqIgtJBEBBun8PCwJAAkACQAJAIAxBAmsOAgECAAsgESAFQQN0OgAADAILIBEgBUEEdEEEcjsAAAwBCyARIAVBBHRBDHI2AAALIAVFDQIgDCARaiAEIAX8CgAADAILAkACQAJAAkAgBUH/H0tBAkEBIAVBH0sbaiILQQJrDgIBAgALIBEgBUEDdEEBcjoAAAwCCyARIAVBBHRBBXI7AAAMAQsgESAFQQR0QQ1yNgAACyALIBFqIAQtAAA6AAAgC0EBaiELDAMLIBFBA0EEIAVBgAhByAFBACAMGyISa0kbIAVBgIABIBJrT2oiF2ohEgJAIAxFDQAgC0ECRw0AIAEoAoQBIgsEQCASIAFBBGogC/wKAAALIBIgASgChAEiE2ohEgsgFiASayELAn8gF0EDRgRAIBIgCyAEIAUgABDFCwwBCyASIAsgBCAFIAAQxgsLIgtBAWtBh39LBEBBAA8LIAsgE2ohEwJAIAwNACAFIBNLDQAgFCAFQf8fS0ECQQEgBUEfSxtqIgwgBWoiC0kEQEG6fw8LAkACQAJAAkAgDEECaw4CAQIACyARIAVBA3Q6AAAMAgsgESAFQQR0QQRyOwAADAELIBEgBUEEdEEMcjYAAAsgBUUNASAMIBFqIAQgBfwKAAAMAQsgE0H//wBLQQRBAyATQf8HSxtqIBdLBEAgFCAFQf8fS0ECQQEgBUEfSxtqIgwgBWoiC0kEQEG6fw8LAkACQAJAAkAgDEECaw4CAQIACyARIAVBA3Q6AAAMAgsgESAFQQR0QQRyOwAADAELIBEgBUEEdEEMcjYAAAsgBUUNASAMIBFqIAQgBfwKAAAMAQsgCyASaiELIAVBBHQhBQJAAkACQAJAIBdBBGsOAgECAAsgCiAFIBVqIBNBDnRqIgU7AAMgCiAFQRB2OgAFDAILIBEgBSAVaiATQRJ0akEIajYAAAwBCyAKIBNBCnY6AAcgCiAFIBVqIBNBFnRqQQxqNgADCyAOQQE2AgAgCyARayELCyALQYh/Sw0CIAsNAUEADwsgEUEAOgAAQQEhCwsgCSgCBCEMIA9BADYCACAWIAsgEWoiBWtBBEgEQEG6fw8LAkACfyADQYABTwRAIANB//0BTQRAIAUgAzoAASAFIANBCHZBgAFyOgAAIAVBAmoMAgsgBUH/AToAACAFIANBgP4BazsAASAFQQNqDAELIAUgAzoAAEEBIREgA0UNASAFQQFqCyEOIABBiAhqIQsgDEEZSyEMIA5BAWohEQJAIA0EQCAOIAEoAowBQQR0IAEoAogBQQZ0aiABKAKQAUECdGo6AAAgASgCnAIiFARAIBEgAUGUAWogFPwKAAALIBEgASgCnAJqIREMAQsgDkH8AToAAAsgESAWIBFrIABBjA5qIAcgCyAIIABBuBlqIAYgAiADIAwQvAsiC0GIf0sNAQJAIA1FDQAgASgCoAIiAUUNACABIAtqQQRPDQBBAA8LIAsgEWohAUEAIQsgASAOa0EESA0BIA9BATYCACABIAVrIhFBiH9LBEAgEQ8LIBFFDQELIAogBSARaiAKayILQQN0IBBqQRRrIgU7AAAgCiAFQRB2OgACCyALC8cFAgV+An8CfiAAKQMAIgJCIFoEQCAAKQMQIgFCB4kgACkDCCIDQgGJfCAAKQMYIgRCDIl8IAApAyAiBUISiXwgA0LP1tO+0ser2UJ+Qh+JQoeVr6+Ytt6bnn9+hUKHla+vmLbem55/fkKdo7Xqg7GNivoAfSABQs/W077Sx6vZQn5CH4lCh5Wvr5i23puef36FQoeVr6+Ytt6bnn9+Qp2jteqDsY2K+gB9IARCz9bTvtLHq9lCfkIfiUKHla+vmLbem55/foVCh5Wvr5i23puef35CnaO16oOxjYr6AH0gBULP1tO+0ser2UJ+Qh+JQoeVr6+Ytt6bnn9+hUKHla+vmLbem55/fkKdo7Xqg7GNivoAfQwBCyAAKQMYQsXP2bLx5brqJ3wLIQEgAEEoaiEAIAEgAnwhAQJAIAKnQR9xIgZBCEkEQCAAIQcMAQsDQCAAKQAAQs/W077Sx6vZQn5CH4lCh5Wvr5i23puef34gAYVCG4lCh5Wvr5i23puef35CnaO16oOxjYr6AH0hASAAQQhqIgchACAGQQhrIgZBB0sNAAsLIAZBBEkEfyAHBSAGQQRrIQYgBzUAAEKHla+vmLbem55/fiABhUIXiULP1tO+0ser2UJ+Qvnz3fGZ9pmrFnwhASAHQQRqCyEAAkAgBkUNAAJ/IAZBAXFFBEAgBiEHIAAMAQsgBkEBayEHIAAxAABCxc/ZsvHluuonfiABhUILiUKHla+vmLbem55/fiEBIABBAWoLIQAgBkEBRg0AA0AgADEAAULFz9my8eW66id+IAAxAABCxc/ZsvHluuonfiABhUILiUKHla+vmLbem55/foVCC4lCh5Wvr5i23puef34hASAAQQJqIQAgB0ECayIHDQALCyABQiGIIAGFQs/W077Sx6vZQn4iAUIdiCABhUL5893xmfaZqxZ+IgFCIIggAYUL9wkCDH8FfkEgIANnayIGQSEgBGdrIgcgBiAHSRsgAUsEQEF/DwtBf0EBIAUbIQ4gAyABdiEMQoCAgICAgICAwAAgA62AIRRBPiABa60iE0IUfSEVQQEgAXQiDSEFQQAhBgNAIAMgAiAGQQJ0aigCACIHRgRAQQAPCwJAIAdFBEAgACAGQQF0akEAOwEADAELIAcgDE0EQCAAIAZBAXRqIA47AQAgBUEBayEFDAELIAAgBkEBdGoCfyAUIAetfiIWIBOIIhJCB1YEQCASpwwBCyAWIBIgE4Z9IBKnIgdBAnRBoPMxajUCACAVhlYgB2oLIgc7AQAgB0H//wNxIgcgCUH//wNxIgkgByAJSyILGyEJIAYgCCALGyEIIAUgB2shBQsgBkEBaiIGIARNDQALAkBBACAFayAAIAhBAXRqIgYuAQAiB0EBdU4EQCADQQNsIAFBAWp2IQlBACEHQQAhBQNAAkAgAiAHIgZBAnRqKAIAIgdFBEAgACAGQQF0akEAOwEADAELAkACQCAHIAxNBEAgACAGQQF0aiAOOwEADAELIAAgBkEBdGohCCAHIAlLDQEgCEEBOwEACyADIAdrIQMgBUEBaiEFDAELIAhB/v8DOwEACyAGQQFqIQcgBCAGRw0ACyANIAVrIgpFDQEgBEEBaiELIAkgAyAKbkkEQCADQQNsIApBAXRuIQgCQAJAIARFBEBBACEGDAELIAtBfnEhCUEAIQYDQAJAIAAgBkEBdGoiBy8BAEH+/wNHDQAgAiAGQQJ0aigCACIMIAhLDQAgB0EBOwEAIAMgDGshAyAFQQFqIQULAkAgACAGQQFyIgdBAXRqIgwvAQBB/v8DRw0AIAIgB0ECdGooAgAiByAISw0AIAxBATsBACADIAdrIQMgBUEBaiEFCyAGQQJqIgYgCUcNAAsgBEEBcQ0BCyAAIAZBAXRqIgcvAQBB/v8DRw0AIAIgBkECdGooAgAiBiAISw0AIAdBATsBACADIAZrIQMgBUEBaiEFCyANIAVrIQoLIAUgC0YEQCALQQNxIRBBACEFQQAhBkEAIQdBACEDIARBA08EQCALQXxxIREDQCACIAZBA3IiDEECdGooAgAiCCACIAZBAnIiCUECdGooAgAiCyACIAZBAXIiDkECdGooAgAiDSACIAZBAnRqKAIAIg8gByAHIA9JIg8bIgcgByANSSINGyIHIAcgC0kiCxsiByAHIAhJIggbIQcgDCAJIA4gBiADIA8bIA0bIAsbIAgbIQMgBkEEaiIGIBFHDQALIARBA2tBfHFBBGohBgsgEARAA0AgAiAGQQJ0aigCACIEIAcgBCAHSyIEGyEHIAYgAyAEGyEDIAZBAWohBiAFQQFqIgUgEEcNAAsLIAAgA0EBdGoiBiAGLwEAIApqOwEAIAEPCyADRQRAIApFDQJBACEGA0AgACAGQQF0aiIHLgEAIgJBAEoEQCAHIAJBAWo7AQAgCkEBayEKCyAGQQFqQQAgBCAGRxshBiAKDQALDAILQn8gE0IBfYZCf4UiEiAKrSAThnwgA62AIRVBACEGA0AgACAGQQF0aiIHLwEAQf7/A0YEQCASIBOIIhYgFSACIAZBAnRqNQIAfiASfCISIBOIIhRRBEBBfw8LIAcgFKcgFqdrOwEACyAGQQFqIgYgBE0NAAsMAQsgBiAFIAdqOwEACyABC5sFAQ1/IANBAWoiDEUEQEF/DwsgBCAMbEEGakEDdkEDakGABCADGyENIARBAWohECAEQQVrIQUgACABakECayEOQQEgBHQiCkEBciELQQQhCEEBIQQgACEJAn8DQAJAAkAgBEEBcQRAIAYhBAwBCwJAIAYiBCAMTw0AA0AgAiAEQQF0ai8BAA0BIAMgBEYhByAEQQFqIQQgB0UNAAsgCyEHDAILIAQgDEYEQCALIQcMAgsgBkEYaiIHIARNBEBB//8DIAh0IREDQAJAIAEgDU8NACAJIA5NDQBBun8PCyAJIAUgEWoiBTsAACAJQQJqIQkgBUEQdiEFIAciBkEYaiIPIQcgBCAPTw0ACwsgBkEDaiIHIARNBEADQEEDIAh0IAVqIQUgCEECaiEIIAQgByIGQQNqIgdPDQALCyAEIAZrIAh0IAVqIQUgCEEPSARAIAhBAmohCAwBCwJAIAEgDU8NACAJIA5NDQBBun8PCyAJIAU7AAAgCEEOayEIIAVBEHYhBSAJQQJqIQkLQX8gCyACIARBAXRqLgEAIgZBH3UiByAGIAdza2oiB0EATA0CGiAIIBBqIAtBf3MgCkEBdGoiEUEAIAZBAWoiBiAKThsgBmoiDyARSGshBiAPIAh0IQggByAKSARAA0AgEEEBayEQIAcgCkEBdSIKSA0ACwsgBSAIaiEFIAZBEUgEfyAGBQJAIAEgDU8NACAJIA5NDQBBun8PCyAJIAU7AAAgBUEQdiEFIAlBAmohCSAGQRBrCyEIIARBAWoiBiAMTw0AIA9BAUchBCAHIQsgB0EBRw0BCwsgCEEHakEIbSEEIAdBAUcEQEF/DwsCQCABIA1PDQAgCSAOTQ0AQbp/DwsgCSAFOwAAIAQgCWogAGsLC78JAhV/AX4gBa0gAkECaiIGrUIBIAOthnxCAYZC/P///z+DQgh8VARAQVQPCyAAQQRqIQ5BASADdCIJQQF0IRUgCUEDdiAJQQF2akEDaiEMIAlBAWshBSAEIAJBAXRqQQRqIQogACACOwECIAAgAzsBACAEQQA7AQACQAJAIAJBAWoiD0UEQCAEIAlBAXI7AQAMAQtBAiAGIAZBAk0bIRAgBSEGQQEhAANAIAQgAEEBdGohByAEIABBAWsiDUEBdCIIai8BACELAkAgASAIai8BACIIQf//A0YEQCAHIAtBAWo7AQAgBiAKaiANOgAAIAZBAWshBgwBCyAHIAggC2o7AQALIABBAWoiACAQRw0ACyAEIA9BAXRqIAlBAXI7AQAgBSAGRwRAQQAhCEEAIQADQAJAIAEgCCIHQQF0ai4BACINQQBMDQAgDUEBRwRAIA1B/v8BcSELQQAhCANAIAAgCmogBzoAAANAIAAgDGogBXEiACAGSw0ACyAAIApqIAc6AAADQCAAIAxqIAVxIgAgBksNAAsgCEECaiIIIAtHDQALIA1BAXFFDQELIAAgCmogBzoAAANAIAAgDGogBXEiACAGSw0ACwsgB0EBaiEIIAIgB0cNAAsMAgsgCSAKaiEWQQAhAANAIAEgACIUQQF0ai4BACESIBEgFmoiBiAbNwAAAkAgEkEJSA0AIBJBCWsiB0EDdkEBaiITQQdxIQhBCCEAIAdBOE8EQCAGQThqIQsgBkEwaiENIAZBKGohECAGQSBqIRcgBkEYaiEYIAZBEGohGSAGQQhqIRogE0H4////A3EhE0EAIQcDQCAAIAZqIBs3AAAgACAaaiAbNwAAIAAgGWogGzcAACAAIBhqIBs3AAAgACAXaiAbNwAAIAAgEGogGzcAACAAIA1qIBs3AAAgACALaiAbNwAAIABBQGshACAHQQhqIgcgE0cNAAsLQQAhByAIRQ0AA0AgACAGaiAbNwAAIABBCGohACAHQQFqIgcgCEcNAAsLIBtCgYKEiJCgwIABfCEbIBRBAWohACARIBJqIREgAiAURw0ACwsgCSAKaiEIIAxBAXQhC0EAIQZBACEAA0AgCiAAIAVxaiAGIAhqIgctAAA6AAAgCiAAIAxqIAVxaiAHLQABOgAAIAAgC2ogBXEhACAGQQJqIgYgCUkNAAsLIA4gFWohDEEAIQADQCAEIAAgCmotAABBAXRqIgUgBS8BACIFQQFqOwEAIA4gBUEBdGogACAJajsBACAEIAogAEEBciIFai0AAEEBdGoiBiAGLwEAIgZBAWo7AQAgDiAGQQF0aiAFIAlqOwEAIABBAmoiACAJRw0AC0EBIA8gD0EBTRshCiADQR9rIQsgA0EQdCAJayIHQYCABGohCEEAIQBBACEFA0ACQAJAAkACQAJAIAEgAEEBdGovAQAiBg4CAAIBCyAMIABBA3RqIAg2AgQMAwsgBkH//wNHDQELIAwgAEEDdGoiBiAFQQFrNgIAIAYgBzYCBCAFQQFqIQUMAQsgDCAAQQN0aiIJIAUgBsEiBms2AgAgCSALIAZBAWtnaiIEQRB0IAYgBHRrNgIEIAUgBmohBQsgAEEBaiIAIApHDQALQQAL5gMCCH8BfgJAIAIgAWsiA0EITgRAIABBCGohCANAIAFBAWohBSABQQFrIQQgACACQQN0aiIJKAIAIQYgAiABa0EBcQR/IAEgBCAAIAFBA3RqKAIAIAZLGyEEIAUFIAELIQMgAiAFRwRAA0AgBiAAIANBA3QiBWoiBygCAEkEQCAAIARBAWoiBEEDdGoiCikCACELIAogBykCADcCACAHIAs3AgALIAYgBSAIaiIFKAIASQRAIAAgBEEBaiIEQQN0aiIHKQIAIQsgByAFKQIANwIAIAUgCzcCAAsgA0ECaiIDIAJHDQALCyAAIARBAWoiA0EDdGoiBikCACELIAYgCSkCADcCACAJIAs3AgACQCADIAFrIAIgA2tIBEAgACABIAQQxAsgBEECaiEBDAELIAAgBEECaiACEMQLIAQhAgsgASACSA0ACwwBCyADQQBMDQAgACABQQN0aiEEIANBAWohCEEBIQcDQCAEIAdBA3RqIgMoAgQhAiADKAIAIQUgByEDAkADQCAEIANBAWsiAEEDdGoiBigCACAFTw0BIAQgA0EDdGogBikCADcCACADQQFKIQYgACEDIAYNAAtBACEDCyAEIANBA3RqIgMgAjYCBCADIAU2AgAgB0EBaiIHIAhHDQALCwuuEAEMfwJAIAFBCEkNACAEQQRqIQcgACABakEEayEJAkAgBC0AACIEIANsQQN2QQhqIAFNIARBDElxRQRAQQAhBAJ/IANBgYCAgHhxQQFHBEAgAAwBCyAAIAcgAiADQQFrIgNqLQAAQQJ0aigCACIEQYB+cSIGQSAgBEH/AXEiAWt2NgAAIARBB3EhBCAJIAAgAUEDdmoiASABIAlLGwshASADQQNxBEAgASAGIAcgAiADakEBay0AAEECdGooAgAiBXYgBXIgByACIANBAmsiA2otAABBAnRqKAIAIgh2IAhBgH5xciIGQSAgCCAEIAVqaiIEQf8BcSIFa3Y2AAAgBEEHcSEEIAkgASAFQQN2aiIBIAEgCUsbIQELIANBAEwNASACQQRrIQsDQCABIAYgByACIANqIgVBAWstAABBAnRqKAIAIgh2IAhyIAcgBUECay0AAEECdGooAgAiBnYgBkGAfnFyIgpBICAGIAQgCGpqIgRB/wFxIgZrdjYAACAJIAEgBkEDdmoiASABIAlLGyIIIAcgBUEDay0AAEECdGooAgAiBiAHIAMgC2otAABBAnRqKAIAIgF2IAFBgH5xciAKIAEgBmoiAXZyIgZBICABIARBB3FqIgRB/wFxIgFrdjYAACAJIAggAUEDdmoiASABIAlLGyEBIARBB3EhBCADQQRLIQUgA0EEayEDIAUNAAsMAQsCQAJAAkAgBEEIaw4EAQEBAAILQQAhBAJ/IANBgYCAgHhxQQFHBEAgAAwBCyAAIAcgAiADQQFrIgNqLQAAQQJ0aigCACIBQYB+cSIGQSAgAUH/AXEiBWt2NgAAIAFBB3EhBCAAIAVBA3ZqCyEBIANBA3EEQCABIAYgByACIANqQQFrLQAAQQJ0aigCACIFdiAFciAHIAIgA0ECayIDai0AAEECdGooAgAiCHYgCEGAfnFyIgZBICAIIAQgBWpqIgRB/wFxIgVrdjYAACAEQQdxIQQgASAFQQN2aiEBCyADQQBMDQIgAkEEayELA0AgASAGIAcgAiADaiIFQQFrLQAAQQJ0aigCACIIdiAIciAHIAVBAmstAABBAnRqKAIAIgZ2IAZBgH5xciIKQSAgBiAEIAhqaiIEQf8BcSIGa3Y2AAAgASAGQQN2aiIIIAcgBUEDay0AAEECdGooAgAiBiAHIAMgC2otAABBAnRqKAIAIgF2IAFBgH5xciAKIAEgBmoiAXZyIgZBICABIARBB3FqIgFB/wFxIgVrdjYAACABQQdxIQQgCCAFQQN2aiEBIANBBEshBSADQQRrIQMgBQ0ACwwCC0EAIQQCfyADQYGAgIB4cUEBRwRAIAAMAQsgACAHIAIgA0EBayIDai0AAEECdGooAgAiAUGAfnEiBkEgIAFB/wFxIgVrdjYAACABQQdxIQQgACAFQQN2agshASADQQNxBEAgASAGIAcgAiADakEBay0AAEECdGooAgAiBXYgBXIgByACIANBAmsiA2otAABBAnRqKAIAIgh2IAhyIgZBICAIIAQgBWpqIgRB/wFxIgVrdjYAACAEQQdxIQQgASAFQQN2aiEBCyADQQBMDQEgAkEEayELA0AgASAGIAcgAiADaiIFQQFrLQAAQQJ0aigCACIIdiAIciAHIAVBAmstAABBAnRqKAIAIgZ2IAZyIgpBICAGIAQgCGpqIgRB/wFxIgZrdjYAACABIAZBA3ZqIgggByAFQQNrLQAAQQJ0aigCACIGIAcgAyALai0AAEECdGooAgAiAXYgCiABIAZqIgV2ciABciIGQSAgBSAEQQdxaiIBQf8BcSIFa3Y2AAAgAUEHcSEEIAggBUEDdmohASADQQRLIQUgA0EEayEDIAUNAAsMAQsCfyADQQNvIgFBAEwEQEEAIQQgAAwBCyAAAn8gAUEBRwRAIAcgAiADaiIEQQJrLQAAQQJ0aigCACIGIAcgBEEBay0AAEECdGooAgAiBWohBCAGQYB+cSAFQYB+cSAGdnIMAQsgByACIANqQQFrLQAAQQJ0aigCACIEQYB+cQsiBkEgIARB/wFxIgVrdjYAACAEQQdxIQQgAyABayEDIAAgBUEDdmoLIQEgA0EGbwRAIAEgBiAHIAIgA2oiCEEBay0AAEECdGooAgAiBXYgBXIgByAIQQJrLQAAQQJ0aigCACIIdiAIciAHIAIgA0EDayIDai0AAEECdGooAgAiCnYgCnIiBkEgIAogCCAEIAVqamoiBEH/AXEiBWt2NgAAIARBB3EhBCABIAVBA3ZqIQELIANBAEwNACACQQZrIQogAkEFayELIAJBBGshDSACQQNrIQ4gAkECayEPIAJBAWshEANAIAEgBiAHIAMgEGotAABBAnRqKAIAIgV2IAVyIAcgAyAPai0AAEECdGooAgAiBnYgBnIgByADIA5qLQAAQQJ0aigCACIIdiAIciICQSAgCCAGIAQgBWpqaiIFQf8BcSIEa3Y2AAAgASAEQQN2aiIIIAcgAyANai0AAEECdGooAgAiBiAHIAMgC2otAABBAnRqKAIAIgF2IAFyIAcgAyAKai0AAEECdGooAgAiBHYgAiAEIAEgBmpqIgF2ciAEciIGQSAgASAFQQdxaiIBQf8BcSIFa3Y2AAAgAUEHcSEEIAggBUEDdmohASADQQZLIQUgA0EGayEDIAUNAAsLIAEgBkEBdkGAgICAeHJBICAEQf////8HayIHQQ9xIgNrdjYAACAJIAEgA0EDdmoiAyADIAlLGyIDIAlPDQAgB0EHcUEARyAAayADaiEMCyAMC5QCAQV/AkAgAUERSQ0AIANBDEkNACAAQQZqIgcgAUEGayACIANBA2pBAnYiBiAEEMULIgVBiH9LBEAgBQ8LIAVBgIAEa0GBgHxJDQAgACAFOwAAIAUgB2oiBSAAIAFqIgcgBWsgAiAGaiIIIAYgBBDFCyIBQYh/SwRAIAEPCyABQYCABGtBgYB8SQ0AIAAgATsAAiABIAVqIgUgByAFayAGIAhqIgggBiAEEMULIgFBiH9LBEAgAQ8LIAFBgIAEa0GBgHxJDQAgACABOwAEIAEgBWoiASAHIAFrIAYgCGoiBSACIANqIAVrIAQQxQsiA0GIf0sEQCADDwsgA0GAgARrQYGAfEkNACABIANqIABrIQkLIAkLnAgBCX8jAEEQayIPJAAgDyAENgIMAkAgCEEAIAdrQQNxIg1rIhFBACAIIBFPG0GENkkEQEG+fyEMDAELIAFFDQAgA0UNACADQYCACEsEQEG4fyEMDAELIAVBDEsEQEFUIQwMAQsgBEH/AUsEQEFSIQwMAQsgBEUEQCAPQf8BNgIMQf8BIQQLIAAgAWohEQJAIApFIAtBBHFFciIQDQAgCigCAEECRw0AIAAgACARIAIgAyAGIAkQyAshDAwBCyAHIA1qIgdBACAIIA1PGyEIAkAgA0GAwAJJDQAgC0EIcUUNACAPIAQ2AgggCCAPQQhqIAIQyQsiDUGIf0sEQCANIQwMAgsgDyAENgIEIAggD0EEaiACIANqQYAgaxDJCyIEQYh/SwRAIAQhDAwCCyAEIA1qQcUASQ0BCyAIIA9BDGogAiADIAhBhBBqIg1BgCAQpgsiBEGIf0sEQCAEIQwMAQsgAyAERgRAIAAgAi0AADoAAEEBIQwMAQsgBCADQQd2QQRqTQ0AAkACQCAKBEAgCigCACIEQQFGBEAgCSAHIA8oAgwiDhCnC0UEQCAKQQA2AgAMAwsgEA0CDAMLIBAgBEVyRQ0CCyAPKAIMIQ4LIAhBgAhqIhAgByAOIAVBCyAFGyADIA4gDUGAJiAQIAcgCxCoCyANQYAmEKkLIghBiH9LBEAgCCEMDAILIAAgASAQIA4gCCANQewFEKsLIhJBiH9LBEAgEiEMDAILAkACQAJAAkACQAJAAkAgCgRAIAooAgBFBEAgEkEMaiEIDAcLIA5BAEgNBSAJQQRqIQEgDkEBaiELQQAhCCAOBEAgC0F+cSENA0AgASAIQQJ0IgRBBHIiBWotAAAgBSAHaigCAGwgASAEai0AACAEIAdqKAIAbCATamohEyAIQQJqIgggDUcNAAsgDkEBcQ0CIA5BAWtBfnFBAmohCAsgASAIQQJ0IghqLQAAIAcgCGooAgBsIBNqIRMgB0GECGohFCAORQRAQQAhAUEAIQ0MBAsgC0F+cSENDAILIBJBDGogA08NCAwGCyAHQYQIaiEUCyAHQYQIaiEFQQAhCEEAIQEDQCAFIAhBAnQiBEEEciILai0AACAHIAtqKAIAbCAEIAVqLQAAIAQgB2ooAgBsIAFqaiEBIAhBAmoiCCANRw0ACyAOQQFxDQELIBQgDUECdCIIai0AACAHIAhqKAIAbCABaiEBCyASQQxqIgggA08NACABQQN2IBJqIBNBA3ZJDQELIAAgACARIAIgAyAGIAkQyAshDAwDCyADIAhNDQIgCkEANgIACyAAIBJqIQggCQRAIAkgEEGECPwKAAALIAAgCCARIAIgAyAGIBAQyAshDAwBCyAAIAAgESACIAMgBiAJEMgLIQwLIA9BEGokACAMC1gAIAIgAWshAgJ/IAVFBEAgASACIAMgBCAGEMULDAELIAEgAiADIAQgBhDGCwsiAkGIf00EfyACRQRAQQAPCyABIAJqIABrIgJBACACIARBAWtJGwUgAgsL6AIBC38gASgCACIFQQJ0QQRqIgMEQCAAQQAgA/wLAAsgAkGAIGohAwNAIAAgAi0AAEECdGoiBCAEKAIAQQFqNgIAIAJBAWoiAiADSQ0ACyAFQQFqIQJBACEDIAUhBgNAIAIiCUEBayECIAMiB0EBaiEDIAYiBEEBayEGIAAgBEECdGooAgBFDQALIAEgBDYCACAFIAdrQQFqIgdBA3EhCEEAIQZBACEDQQAhAiAEQQNPBEAgAEEMaiEKIABBCGohCyAAQQRqIQwgB0F8cSENA0AgCiADQQJ0IgRqKAIAIgcgBCALaigCACIBIAQgDGooAgAiBSAAIARqKAIAIgQgAiACIARJGyICIAIgBUkbIgIgASACSxsiAiACIAdJGyECIANBBGoiAyANRw0ACyAJQXxxIQMLIAgEQANAIAAgA0ECdGooAgAiBCACIAIgBEkbIQIgA0EBaiEDIAZBAWoiBiAIRw0ACwsgAgvRBQEMfyMAQRBrIgwkAAJAIARBB00EQCAMQgA3AwggBARAIAxBCGogAyAE/AoAAAtBbCAAIAEgAiAMQQhqQQgQygsiAiACIARLGyACIAJBiX9JGyEGDAELIAEoAgBBAWoiDkEBdCIFBEAgAEEAIAX8CwALIAMoAAAiBkEPcSIHQQpLBEBBVCEGDAELIAIgB0EFajYCACADIARqIgRBBGshCCAEQQdrIQ0gB0EGaiEPQQQhBSAGQQR2IQZBICAHdCIJQQFyIQpBACECQQEhByADIQQDQAJAIAdBAXFFBEAgBkF/c0GAgICAeHJoIgdBGE8EQANAIAJBJGohAiAEIA1NBH8gBEEDagUgBCANa0EDdCAFakEfcSEFIAgLIgQoAAAgBXYiBkF/c0GAgICAeHJoIgdBF0sNAAsLIAUgB0EecSILakECaiEFIAdBAXZBA2wgAmogBiALdkEDcWoiAiAOTw0BAn8gBCANSyAFQQN2IgYgBGogCEtxRQRAIAVBB3EhBSAEIAZqDAELIAQgCGtBA3QgBWpBH3EhBSAICyIEKAAAIAV2IQYLIAYgCUEBa3EiByAJQQF0QQFrIgsgCmsiEEkEfyAPQQFrBSAGIAtxIgYgEEEAIAYgCU4bayEHIA8LIQsgACACQQF0aiAHQQFrIgY7AQAgAkEBaiECIAUgC2ohBSAJQQEgB2sgBiAHQQBKGyAKaiIKSgRAIApBAkgNAUEgIApnIgdrIQ9BASAHQR9zdCEJCyACIA5PDQACfyAEIA1LIAVBA3UiByAEaiAIS3FFBEAgBUEHcSEFIAQgB2oMAQsgBSAEIAhrQQN0akEfcSEFIAgLIQQgBkEARyEHIAQoAAAgBXYhBgwBCwtBbCEGIApBAUcNACACIA5LBEBBUCEGDAELIAVBIEoNACABIAJBAWs2AgAgBCAFQQdqQQN1aiADayEGCyAMQRBqJAAgBguwJwMcfwF+AXsjAEEwayIJJABBuH8hBwJAIAVFDQAgBCwAACIIQf8BcSETAkACQAJAAkACQAJAAkACQAJAIAhBAEgEQCATQf4Aa0EBdiILIAVPDQpBbCEHIBNB/wBrIg1B/wFLDQogDUUNASAEQQFqIQRBACEFIBNBgAFrIgdBAk8EQCAHQQF2QQFqQf4AcSEMQQAhBwNAIAAgBWoiCCAEIAVBAXZqIgotAABBBHY6AAAgCCAKLQAAQQ9xOgABIAAgBUECciIIaiIKIAQgCEEBdmoiCC0AAEEEdjoAACAKIAgtAABBD3E6AAEgBUEEaiEFIAdBAmoiByAMRw0ACwsgE0ECcUUEQCAAIAVqIgcgBCAFQQF2aiIFLQAAQQR2OgAAIAcgBS0AAEEPcToAAQsgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUEANgIwIAEgJP0LAiAgASAk/QsCEAwJCyAFIBNNDQkgCUH/ATYCBCAGIAlBBGogCUEIaiAEQQFqIhsgExDKCyIFQYh/SwRAIAUhBwwKC0FUIQcgCSgCCCIaQQZLDQkgCSgCBCILQQF0IghBAmqtQgEgGq2GIiNBBCAadCIEQQhqrXx8Qgt8Qvz//////////wCDQugCVg0JQVIhByALQf8BSw0JQegCIARrrSALQQFqIhBBAXStICN8Qgh8VA0JIBMgBWshDSAFIBtqIRQgBkGABGoiHCAEakEEaiIXIAhqQQJqISAgBkGEBGohISAGQYYEaiEMQYCAAiAadEEQdiEOQQEgGnQiGUEBayIEIQdBASEdQQAhBQNAAkAgBiAFQQF0IgpqLwEAIghB//8DRgRAIAwgB0ECdGogBToAACAHQQFrIQdBASEIDAELIB1BACAOIAjBShshHQsgCiAXaiAIOwEAIAUgC0chCCAFQQFqIQUgCA0ACyAGIB07AYIEIAYgGjsBgARBASAQIBBBAU0bISICQCAEIAdGBEBCACEjA0AgBiAfQQF0ai4BACEYIB4gIGoiByAjNwAAAkAgGEEJSA0AIBhBCWsiCEEDdkEBaiIVQQdxIQpBCCEFIAhBOE8EQCAHQThqIQsgB0EwaiEOIAdBKGohECAHQSBqIQ8gB0EYaiEWIAdBEGohESAHQQhqIRIgFUH4////A3EhFUEAIQgDQCAFIAdqICM3AAAgBSASaiAjNwAAIAUgEWogIzcAACAFIBZqICM3AAAgBSAPaiAjNwAAIAUgEGogIzcAACAFIA5qICM3AAAgBSALaiAjNwAAIAVBQGshBSAIQQhqIgggFUcNAAsLQQAhCCAKRQ0AA0AgBSAHaiAjNwAAIAVBCGohBSAIQQFqIgggCkcNAAsLICNCgYKEiJCgwIABfCEjIBggHmohHiAfQQFqIh8gIkcNAAsgGUEDdiAZQQF2akEDaiIKQQF0IQtBACEHQQAhBQNAIAwgBCAFcUECdGogByAgaiIILQAAOgAAIAwgBSAKaiAEcUECdGogCC0AAToAACAFIAtqIARxIQUgB0ECaiIHIBlJDQALDAELIBlBA3YgGUEBdmpBA2ohCEEAIQVBACEKA0ACQCAGIApBAXRqLgEAIhBBAEwNACAQQQFHBEAgEEH+/wFxIQ5BACELA0AgDCAFQQJ0aiAKOgAAA0AgBSAIaiAEcSIFIAdLDQALIAwgBUECdGogCjoAAANAIAUgCGogBHEiBSAHSw0ACyALQQJqIgsgDkcNAAsgEEEBcUUNAQsgDCAFQQJ0aiAKOgAAA0AgBSAIaiAEcSIFIAdLDQALCyAKQQFqIgogIkcNAAtBfyEHIAUNCgsgGkEfayEIAkAgBEUEQEEAIQQMAQsgGUH+AXEhDEEAIQQDQCAXICEgBEECdGoiBS0AAkEBdGoiByAHLwEAIgdBAWo7AQAgBSAIIAdnaiIKOgADIAUgByAKdCAZazsBACAXIAUtAAZBAXRqIgcgBy8BACIHQQFqOwEAIAUgCCAHZ2oiCjoAByAFIAcgCnQgGWs7AQQgBEECaiIEIAxHDQALCyAaRQRAIBcgISAEQQJ0aiIFLQACQQF0aiIEIAQvAQAiBEEBajsBACAFIAggBGdqIgc6AAMgBSAEIAd0QQFrOwEACyAdQf//A3FFDQEgDUUEQEG4fyENDAgLIAkgFDYCKCAJIBRBBGo2AiwCQAJAIA1BBE8EQCAJIBMgG2pBBGsiBTYCJCAJIAUoAAAiBTYCHCAFQYCAgAhPDQFBfyENDAoLIAkgFDYCJCAJIBQtAAAiBTYCHAJAAkACQCANQQJrDgIBAAILIBQtAAJBEHQgBXIhBQsgCSAULQABQQh0IAVqNgIcCyATIBtqQQFrLQAAIgVFBEBBbCENDAoLIAkgBWcgDUEDdGtBCWo2AiAMAQsgCUEIIAVBGHZnQR9zazYCICANQYh/Sw0ICyAJQRRqIAlBHGogHBDMCyAJQQxqIAlBHGogHBDMCyAJKAIgIgRBIEsEQEFsIQ0MCAsCQAJAAn8gCSgCJCILIAkoAiwiEE8EQCAEQQdxIQYgCyAEQQN2ayEHIAkoAighCyAHDAELIAsgCSgCKCIGRw0BIAlBHGohByAEIQYgCwshBSAHKAAAIQggCSgCDCEMIAkoAhQhCgwBCyALIAsgBmsgBEEDdiIFIAsgBWsgBkkbIgdrIgUoAAAhCCAJKAIMIQwgCSgCFCEKIAQgB0EDdGsiBEEhTw0DIAYhCyAEIQYLIAkoAhAhESAJKAIYIRZBACEHA0AgCQJ/IAUgEE8EQCAGQQN2IQhBASEOIAZBB3EMAQsgBSALRgRAIAYhBAwGCyAGIAZBA3YiBCAFIAtrIAUgBGsgC08iDhsiCEEDdGsLIgQ2AiAgBSAIayIFKAAAIQggB0H7AUsNBCAORQ0EIBYgCkECdGoiCi8BACESIAotAAMhBiAAIAdqIg4gCi0AAjoAACARIAxBAnRqIgovAQAhDCAKLQADIQ8gDiAKLQACOgABIBIgCCAEdEEAIAZrdmohCiAMIAggBCAGaiIEdEEAIA9rdmohDAJAAkAgBCAPaiIGQSBLBEBBkPMxIQUgBiEEDAELIAUgEE8EQCAJIAZBB3EiBDYCICAFIAZBA3ZrIgUoAAAhCAwCCwJAIAUgC0YEQCAGIQQMAQsgCSAGIAUgC2sgBkEDdiIEIAUgBGsiDyALSRsiCEEDdGsiBDYCICAFIAhrIgUoAAAhCCALIA9NDQILIAkgBTYCJAsgCSAKNgIUIAkgCDYCHCAJIAw2AgwgB0ECciEHDAgLIBYgCkECdGoiCi8BACESIAotAAMhDyAOIAotAAI6AAIgESAMQQJ0aiIKLwEAIQwgCi0AAiEVIAkgBCAPaiINIAotAAMiF2oiBjYCICAOIBU6AAMgEiAIIAR0QQAgD2t2aiEKIAwgCCANdEEAIBdrdmohDCAHQQRqIQcgBkEgTQ0AC0GQ8zEhBSAGIQQMBAsgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUEANgIwIAEgJP0LAiAgASAk/QsCEAwICyANRQRAQbh/IQ0MBgsgCSAUNgIoIAkgFEEEajYCLAJAAkAgDUEETwRAIAkgEyAbakEEayIFNgIkIAkgBSgAACIFNgIcIAVBgICACE8NAUF/IQ0MCAsgCSAUNgIkIAkgFC0AACIFNgIcAkACQAJAIA1BAmsOAgEAAgsgFC0AAkEQdCAFciEFCyAJIBQtAAFBCHQgBWo2AhwLIBMgG2pBAWstAAAiBUUEQEFsIQ0MCAsgCSAFZyANQQN0a0EJajYCIAwBCyAJQQggBUEYdmdBH3NrNgIgIA1BiH9LDQYLIAlBFGogCUEcaiAcEMwLIAlBDGogCUEcaiAcEMwLIAkoAiAiBEEgSwRAQWwhDQwGCwJAAkACQAJAAkACQAJAAkACfyAJKAIkIgsgCSgCLCIQTwRAIAkgBEEHcSIINgIgIAsgBEEDdmshBSAJKAIoIQsgBQwBCyALIAkoAigiBkcNASALIQUgBCEIIAlBHGoLKAAAIQcgCSgCDCEMIAkoAhQhCgwBCyAJIAQgCyAGayAEQQN2IgUgCyAFayAGSRsiBUEDdGsiCDYCICALIAVrIgUoAAAhByAJKAIMIQwgCSgCFCEKIAhBIU8NASAGIQsLIAkoAhAhFiAJKAIYIQ9BACEEA0ACfyAFIBBPBEAgCEEDdiEHQQEhDiAIQQdxDAELIAUgC0YNBCAIIAhBA3YiByAFIAtrIAUgB2sgC08iDhsiB0EDdGsLIQYgBSAHayIFKAAAIQcgBEH7AUsNAiAORQ0CIA8gCkECdGoiCC8BACERIAgtAAMhCiAAIARqIg4gCC0AAjoAACAWIAxBAnRqIggvAQAhEiAILQADIQwgDiAILQACOgABIBEgCkECdEHgozJqKAIAIAdBACAGIApqIghrdnFqIQogEiAMQQJ0QeCjMmooAgAgB0EAIAggDGoiBmt2cWohDAJAAkAgBkEgSwRAQZDzMSEFIAYhCAwBCyAFIBBPBEAgBkEHcSEIIAUgBkEDdmsiBSgAACEHDAILAkAgBSALRgRAIAYhCAwBCyAGIAUgC2sgBkEDdiIHIAUgB2siESALSRsiB0EDdGshCCAFIAdrIgUoAAAhByALIBFNDQILIAkgBTYCJAsgCSAHNgIcIAkgCDYCICAJIAo2AhQgCSAMNgIMIARBAnIhBAwHCyAPIApBAnRqIgovAQAhESAKLQADIQYgDiAKLQACOgACIBYgDEECdGoiCi8BACESIAotAAMhDCAOIAotAAI6AAMgESAGQQJ0QeCjMmooAgAgB0EAIAYgCGoiCGt2cWohCiASIAxBAnRB4KMyaigCACAHQQAgCCAMaiIIa3ZxaiEMIARBBGohBCAIQSBNDQALQZDzMSEFDAMLIAkgCjYCFCAJIAc2AhwgCSAMNgIMQZDzMSEFQQAhBCAGIQsMAwsgBiEICyAJIAU2AiQLIAkgCjYCFCAJIAc2AhwgCSAMNgIMIARB/QFMDQBBun8hDQwHCyAJKAIQIRYgCSgCGCEPCyAAQQFqIRcCfwNAIA8gCkECdGoiCi8BACESIAotAAMhBiAAIARqIhggCi0AAjoAACAEIBdqIRECfwJ/AkAgBiAIaiIIQSBNBEAgBSAQTwRAIAhBA3YhCiAIQQdxDAMLIAUgC0cNASAIIRUgBwwDCyARIAkoAhAgDEECdGotAAI6AAAgGEECagwECyAIIAUgC2sgCEEDdiIKIAUgCmsgC0kbIgpBA3RrCyEVIAUgCmsiBSgAAAshDkG6fyENIARB/AFLDQcgBkECdEHgozJqKAIAIAdBACAIa3ZxIBJqIQogFiAMQQJ0aiIHLwEAIRIgBy0AAyEIIBEgBy0AAjoAACAEQQJqIQYgCCAVaiIMQSBNBEAgCEECdEHgozJqKAIAIA5BACAMa3ZxIRECfwJ/IAUgEE8EQCAMQQN2IQcgDEEHcQwBCyAFIAtGBEAgDCEIIA4MAgsgDCAFIAtrIAxBA3YiByAFIAdrIAtJGyIHQQN0awshCCAFIAdrIgUoAAALIQcgESASaiEMIARB/AFGIQ4gBiEEIA5FDQEMCAsLIAAgBmogDyAKQQJ0ai0AAjoAACAYQQNqCyAAayENDAULIAkgDDYCDCAJIAo2AhRBkPMxIQVBACEHIAYhCwwCCyAJIAU2AiQLIAkgCjYCFCAJIAg2AhwgCSAMNgIMIAdB/QFMDQBBun8hDQwCCyAJKAIQIREgCSgCGCEWCyAAQQFqIRcDQCAWIApBAnRqIgovAQAhFSAKLQADIQYgACAHaiIYIAotAAI6AAAgByAXaiESAn8CfwJAIAQgBmoiCkEgTQRAIAUgEE8EQCAKQQN2IQ8gCkEHcQwDCyAFIAtHDQEgCiEOIAgMAwsgEiAJKAIQIAxBAnRqLQACOgAAIBhBAmogAGshDQwECyAKIAUgC2sgCkEDdiIOIAUgDmsgC0kbIg9BA3RrCyEOIAUgD2siBSgAAAshD0G6fyENIAdB/AFLDQEgCCAEdEEAIAZrdiAVaiEKIBEgDEECdGoiBC8BACEVIAQtAAMhCCASIAQtAAI6AAAgB0ECaiEGIAggDmoiDEEgTQRAIA8gDnRBACAIa3YhDgJ/An8gBSAQTwRAIAxBA3YhCCAMQQdxDAELIAUgC0YEQCAMIQQgDwwCCyAMIAUgC2sgDEEDdiIEIAUgBGsgC0kbIghBA3RrCyEEIAUgCGsiBSgAAAshCCAOIBVqIQwgB0H8AUYhDiAGIQcgDkUNAQwCCwsgACAGaiAWIApBAnRqLQACOgAAIBhBA2ogAGshDQsgDUGJf08EQCANIQcMAgsgAf0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUEANgIwIAEgJP0LAiAgASAk/QsCECATIQsgDQ0AQWwhBwwBC0EAIQRBACEFA0BBbCEHIAAgBWoiCC0AACIKQQxLDQEgASAKQQJ0aiIKIAooAgBBAWo2AgBBASAILQAAdEEBdSAEaiEEIAVBAWoiBSANRw0ACyAERQ0AIARnIgVBHHNBC0sNACADQSAgBWsiBTYCAEGAgICAeEEBIAV0IARrIgVnIgR2IAVHDQAgACANakEgIARrIgU6AAAgASAFQQJ0aiIFIAUoAgBBAWo2AgAgASgCBCIFQQJJDQAgBUEBcQ0AIAIgDUEBajYCACALQQFqIQcLIAlBMGokACAHC88BAQR/IAEgAi8BACIDIAEoAgRqIgQ2AgQgACADQQJ0QeCjMmooAgAgASgCAEEAIARrdnE2AgACQCAEQSFPBEAgAUGQ8zE2AggMAQsgASgCCCIDIAEoAhBPBEAgASAEQQdxNgIEIAEgAyAEQQN2ayIENgIIIAEgBCgAADYCAAwBCyADIAEoAgwiBUYNACABIAMgAyAFayAEQQN2IgYgAyAGayAFSRsiBWsiAzYCCCABIAQgBUEDdGs2AgQgASADKAAANgIACyAAIAJBBGo2AgQLtQcBCX8gASgCAEECdEEEaiELAkAgA0UEQCALBEAgAEEAIAv8CwALIAFBADYCAAwBCyAFQQBBgCD8CwAgAiADaiEMIAVBgBhqIQggBUGAEGohCSAFQYAIaiEKAkAgA0EUSARAIAIhBgwBCyAMQQ9rIQ0gAkEEaiEHIAIoAAAhAwNAIAcoAAAhByAFIANB/wFxQQJ0aiIGIAYoAgBBAWo2AgAgCiADQQZ2QfwHcWoiBiAGKAIAQQFqNgIAIAkgA0EOdkH8B3FqIgYgBigCAEEBajYCACAIIANBFnZB/AdxaiIDIAMoAgBBAWo2AgAgAigACCEDIAUgB0H/AXFBAnRqIgYgBigCAEEBajYCACAKIAdBBnZB/AdxaiIGIAYoAgBBAWo2AgAgCSAHQQ52QfwHcWoiBiAGKAIAQQFqNgIAIAggB0EWdkH8B3FqIgcgBygCAEEBajYCACACKAAMIQcgBSADQf8BcUECdGoiBiAGKAIAQQFqNgIAIAogA0EGdkH8B3FqIgYgBigCAEEBajYCACAJIANBDnZB/AdxaiIGIAYoAgBBAWo2AgAgCCADQRZ2QfwHcWoiAyADKAIAQQFqNgIAIAIoABAhAyAFIAdB/wFxQQJ0aiIGIAYoAgBBAWo2AgAgCiAHQQZ2QfwHcWoiBiAGKAIAQQFqNgIAIAkgB0EOdkH8B3FqIgYgBigCAEEBajYCACAIIAdBFnZB/AdxaiIHIAcoAgBBAWo2AgAgAkEUaiEHIAJBEGoiBiECIAcgDUkNAAsLAkAgBiAMTw0AIAwgBiICayIOQQNxIg0EQEEAIQMDQCAFIAItAABBAnRqIgcgBygCAEEBajYCACACQQFqIQIgA0EBaiIDIA1HDQALCyAGIAxrQXxLDQAgBiAOaiEHA0AgBSACLQAAQQJ0aiIDIAMoAgBBAWo2AgAgBSACLQABQQJ0aiIDIAMoAgBBAWo2AgAgBSACLQACQQJ0aiIDIAMoAgBBAWo2AgAgBSACLQADQQJ0aiIDIAMoAgBBAWo2AgAgAkEEaiICIAdHDQALC0EAIQdBACEDA0AgBSAHQQJ0IgJqIgYgBigCACACIAhqKAIAIAIgCWooAgAgAiAKaigCAGpqaiICNgIAIAIgAyACIANLGyEDIAdBAWoiB0GAAkcNAAtB/wEhCANAIAgiAkEBayEIIAUgAkECdGooAgBFDQALIAQEQEFQIQggAiABKAIASw0BCyABIAI2AgAgCwRAIAAgBSAL/AoAAAsgAw8LIAgLsWUCHX8DfiMAQRBrIRlBACACKAIAIh0gHSADIAMgACgCBCIRIAAoAgwiDSADIBFrIARqIgVBASAAKAK4AXQiBmsgDSAFIA1rIAZLGyAAKAIYIhgbIhtqIhpGaiIFIBFrIhUgDSAVIAZrIA0gFSANayAGSxsgGBtrIgZLIh4bIQ1BACACKAIEIh8gBiAfSSIgGyEHIAVBAWohBiADIARqIhJBCGshFSAAKAK8ASEKIAAoAmQhGCAAKALAASELIAAoAlwhBAJAAkACQAJAIAAoAsgBQQVrDgMDAgEACyAZQcL9MS8AADsBCCAZQbr9MSkAADcDAAJAIAYgFUsNACASQSBrIRAgEkEBayEWIBJBA2shAEEgIAprIRNBwAAgC2utISMDQEEAIA1rIRQgBUGAAmohDiARIAQgBSkAACIiQuPIlb3Lm++NT34gI4inIgtBAnRqKAIAIg9qIQpBASEXAkACQAJ/AkACQAJ/AkADQCAYICKnQbHz3fF5bCATdkECdGoiCCgCACEJIAggBSARayIcNgIAIAQgC0ECdGogHDYCAAJAIA1FDQAgBUEBaiIIIBRqKAAAIAUoAAFHDQAgBUEFaiILIBRqIQogACALTQRAIAshBgwGCyAKKAAAIgkgCyIGKAAAIgxHBEAgCSAMc2hBA3YMBwsDQCAKQQRqIQogBkEEaiIGIABPDQYgCigAACIJIAYoAAAiDEYNAAsgBiAJIAxzaEEDdmogC2sMBgsgBikAACIiQuPIlb3Lm++NT34gI4inIQsCQCAFKQAAIiQgGSAKIA8gG0kbIggpAABSDQAgCCAKRw0AIApBCGohCSAAIAVBCGoiD00EQCAPIQcMAwsgCSgAACIIIA8iBygAACIMRwRAIAggDHNoQQN2DAQLA0AgCUEEaiEJIAdBBGoiByAATw0DIAkoAAAiCCAHKAAAIgxGDQALIAcgCCAMc2hBA3ZqIA9rDAMLIBEgBCALQQJ0aigCACIPaiEKIBkgCSARaiIMIAkgG0kbIgkoAAAgJKdGIAkgDEZxRQRAIAYgDk8EQCAXQQFqIRcgDkGAAmohDgsgFyAGIgVqIgkhBiAJIBVNDQEMCgsLIAxBBGohCQJ/AkAgACAFQQRqIhRNBEAgFCEHDAELIBQhByAJKAAAIgggJEIgiKciDkcEQCAIIA5zaEEDdgwCCwNAIAlBBGohCSAHQQRqIgcgAE8NASAJKAAAIgggBygAACIORg0ACyAHIAggDnNoQQN2aiAUawwBCwJAIAcgFk8NACAJLwAAIAcvAABHDQAgCUECaiEJIAdBAmohBwsgByASSQR/IAcgCS0AACAHLQAARmoFIAcLIBRrCyEHIAUgDGshDiAHQQRqIQkCQCAPIBtNDQAgCikAACAiUg0AIApBCGohCAJ/AkAgACAGQQhqIiFNBEAgISEHDAELIAgoAAAiDyAhIgcoAAAiFEcEQCAPIBRzaEEDdgwCCwNAIAhBBGohCCAHQQRqIgcgAE8NASAIKAAAIg8gBygAACIURg0ACyAHIA8gFHNoQQN2aiAhawwBCwJAIAcgFk8NACAILwAAIAcvAABHDQAgCEECaiEIIAdBAmohBwsgByASSQR/IAcgCC0AACAHLQAARmoFIAcLICFrC0EIaiIHIAlNDQAgBiAKayEOIAohDCAGIQUgByEJCyAMIBpNBEAgBSEIDAMLIAMgBU8EQCAFIQgMAwsDQCAFQQFrIggtAAAgDEEBayIMLQAARwRAIAUhCAwECyAJQQFqIQkgAyAITw0DIAghBSAMIBpLDQALDAILAkAgByAWTw0AIAkvAAAgBy8AAEcNACAJQQJqIQkgB0ECaiEHCyAHIBJJBH8gByAJLQAAIActAABGagUgBwsgD2sLIQcgBSAKayEOIAdBCGohCSAKIBpNBEAgBSEIDAELIAMgBU8EQCAFIQgMAQsDQCAFQQFrIggtAAAgCkEBayIKLQAARwRAIAUhCAwCCyAJQQFqIQkgAyAITw0BIAghBSAKIBpLDQALCyAXQQNNBEAgBCALQQJ0aiAGIBFrNgIACyAOQQNqIQwgCCADayELIAEoAgwhBQJAAkAgCCAQTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSALQRBNBEAgASAFIAtqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECALQSFIDQEgBSALaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgEE0EQCAFIAP9AAAA/QsAACAFIBAgA2siCmohBiAKQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBAhAwsgAyAITw0AQQAhCiADIQYgCCADa0EHcSIHBEADQCAFIAYtAAA6AAAgBUEBaiEFIAZBAWohBiAKQQFqIgogB0cNAAsLIAMgCGtBeEsNAANAIAUgBi0AADoAACAFIAYtAAE6AAEgBSAGLQACOgACIAUgBi0AAzoAAyAFIAYtAAQ6AAQgBSAGLQAFOgAFIAUgBi0ABjoABiAFIAYtAAc6AAcgBUEIaiEFIAZBCGoiBiAIRw0ACwsgASABKAIMIAtqNgIMIAEoAgQhAyALQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAw2AgAgAyALOwEEIA0hByAOIQ0gCUEDayIFQYCABEkNAwwCCwJAIAYgFk8NACAKLwAAIAYvAABHDQAgCkECaiEKIAZBAmohBgsgBiASSQR/IAYgCi0AACAGLQAARmoFIAYLIAtrCyEMIAggA2shCyABKAIMIQYCQAJAIAggEE0EQCAGIAP9AAAA/QsAACABKAIMIQUgC0EQTQRAIAEgBSALajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgC0EhSA0BIAUgC2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBBNBEAgBiAD/QAAAP0LAAAgBiAQIANrIglqIQogCUERTgRAIAZBEGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgCkkNAAsLIAohBiAQIQMLIAMgCE8NACAFIANrIg9BB3FBB0cEQCAPQQFqQQdxIQlBACEKA0AgBiADLQAAOgAAIAZBAWohBiADQQFqIQMgCkEBaiIKIAlHDQALIA9BB0kNAQsDQCAGIAMtAAA6AAAgBiADLQABOgABIAYgAy0AAjoAAiAGIAMtAAM6AAMgBiADLQAEOgAEIAYgAy0ABToABSAGIAMtAAY6AAYgBiADLQAHOgAHIAZBCGohBiADQQdqIQogA0EIaiEDIAUgCkcNAAsLIAEgASgCDCALajYCDCABKAIEIQMgC0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgDEEEaiEJIANBATYCACADIAs7AQQgDSEOIAxBAWoiBUH//wNNDQELIAFBAjYCJCABIAMgASgCAGtBA3U2AiggDiENCyADIAU7AQYgASADQQhqIgo2AgQCQCAIIAlqIgMgFUsNACAEIBEgHEECaiIFaiIGKQAAQuPIlb3Lm++NT34gI4inQQJ0aiAFNgIAIAQgA0ECayILKQAAQuPIlb3Lm++NT34gI4inQQJ0aiALIBFrNgIAIBggBigAAEGx893xeWwgE3ZBAnRqIAU2AgAgGCADQQFrIgUoAABBsfPd8XlsIBN2QQJ0aiAFIBFrNgIAIA0hBiAHIQgDQAJAIAghDSAGIQggDUUNACADKAAAIgwgAyANaygAAEcNACADQQRqIgcgDWshBgJ/AkAgACAHTQRAIAchBQwBCyAGKAAAIgsgByIFKAAAIglHBEAgCSALc2hBA3YMAgsDQCAGQQRqIQYgBUEEaiIFIABPDQEgBigAACILIAUoAAAiCUYNAAsgBSAJIAtzaEEDdmogB2sMAQsCQCAFIBZPDQAgBi8AACAFLwAARw0AIAZBAmohBiAFQQJqIQULIAUgEkkEfyAFIAYtAAAgBS0AAEZqBSAFCyAHawshBSAYIAxBsfPd8XlsIBN2QQJ0aiADIBFrIgY2AgAgBCADKQAAQuPIlb3Lm++NT34gI4inQQJ0aiAGNgIAIAMgEE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQoLIApBATYCACAKQQA7AQQgBUEBaiIGQYCABE8EQCABQQI2AiQgASAKIAEoAgBrQQN1NgIoCyAKIAY7AQYgASAKQQhqIgo2AgQgDSEGIAghByADIAVqQQRqIgMgFU0NAQwCCwsgDSEHIAghDQsgAyIFQQFqIgYgFU0NAAsLIAIgDSAdQQAgHhsgDRs2AgAgAiAHIB0gH0EAICAbIgUgDRsgBSAeGyAHGzYCBCASIANrDwsgGUHC/TEvAAA7AQggGUG6/TEpAAA3AwACQCAGIBVLDQAgEkEgayETIBJBAWshFCASQQNrIQBBwAAgCmutISRBwAAgC2utISMDQEEAIA1rIRAgBUGAAmohDiARIAQgBSkAACIiQuPIlb3Lm++NT34gI4inIgtBAnRqKAIAIg9qIQpBASEXAkACQAJ/AkACQAJ/AkADQCAYICJCgMaV/cub741PfiAkiKdBAnRqIggoAgAhCSAIIAUgEWsiHDYCACAEIAtBAnRqIBw2AgACQCANRQ0AIAVBAWoiCCAQaigAACAFKAABRw0AIAVBBWoiCyAQaiEKIAAgC00EQCALIQYMBgsgCigAACIJIAsiBigAACIMRwRAIAkgDHNoQQN2DAcLA0AgCkEEaiEKIAZBBGoiBiAATw0GIAooAAAiCSAGKAAAIgxGDQALIAYgCSAMc2hBA3ZqIAtrDAYLIBkgCiAPIBtJGyIMKQAAICJSIQggBikAACIiQuPIlb3Lm++NT34gI4inIQsCQCAIDQAgCiAMRw0AIApBCGohCSAAIAVBCGoiD00EQCAPIQcMAwsgCSgAACIIIA8iBygAACIMRwRAIAggDHNoQQN2DAQLA0AgCUEEaiEJIAdBBGoiByAATw0DIAkoAAAiCCAHKAAAIgxGDQALIAcgCCAMc2hBA3ZqIA9rDAMLIBEgBCALQQJ0aigCACIPaiEKIBkgCSARaiIMIAkgG0kbIgkoAAAgBSgAAEYgCSAMRnFFBEAgBiAOTwRAIBdBAWohFyAOQYACaiEOCyAXIAYiBWoiCSEGIAkgFU0NAQwKCwsgDEEEaiEJAn8CQCAAIAVBBGoiEE0EQCAQIQcMAQsgCSgAACIIIBAiBygAACIORwRAIAggDnNoQQN2DAILA0AgCUEEaiEJIAdBBGoiByAATw0BIAkoAAAiCCAHKAAAIg5GDQALIAcgCCAOc2hBA3ZqIBBrDAELAkAgByAUTw0AIAkvAAAgBy8AAEcNACAJQQJqIQkgB0ECaiEHCyAHIBJJBH8gByAJLQAAIActAABGagUgBwsgEGsLIQcgBSAMayEOIAdBBGohCQJAIA8gG00NACAKKQAAICJSDQAgCkEIaiEIAn8CQCAAIAZBCGoiFk0EQCAWIQcMAQsgCCgAACIPIBYiBygAACIQRwRAIA8gEHNoQQN2DAILA0AgCEEEaiEIIAdBBGoiByAATw0BIAgoAAAiDyAHKAAAIhBGDQALIAcgDyAQc2hBA3ZqIBZrDAELAkAgByAUTw0AIAgvAAAgBy8AAEcNACAIQQJqIQggB0ECaiEHCyAHIBJJBH8gByAILQAAIActAABGagUgBwsgFmsLQQhqIgcgCU0NACAGIAprIQ4gCiEMIAYhBSAHIQkLIAwgGk0EQCAFIQgMAwsgAyAFTwRAIAUhCAwDCwNAIAVBAWsiCC0AACAMQQFrIgwtAABHBEAgBSEIDAQLIAlBAWohCSADIAhPDQMgCCEFIAwgGksNAAsMAgsCQCAHIBRPDQAgCS8AACAHLwAARw0AIAlBAmohCSAHQQJqIQcLIAcgEkkEfyAHIAktAAAgBy0AAEZqBSAHCyAPawshByAFIAprIQ4gB0EIaiEJIAogGk0EQCAFIQgMAQsgAyAFTwRAIAUhCAwBCwNAIAVBAWsiCC0AACAKQQFrIgotAABHBEAgBSEIDAILIAlBAWohCSADIAhPDQEgCCEFIAogGksNAAsLIBdBA00EQCAEIAtBAnRqIAYgEWs2AgALIA5BA2ohDCAIIANrIQsgASgCDCEFAkACQCAIIBNNBEAgBSAD/QAAAP0LAAAgASgCDCEFIAtBEE0EQCABIAUgC2o2AgwgASgCBCEDDAMLIAUgA/0AABD9CwAQIAtBIUgNASAFIAtqIQYgA0EQaiEDIAVBIGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsMAQsgAyATTQRAIAUgA/0AAAD9CwAAIAUgEyADayIKaiEGIApBEU4EQCAFQRBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALCyAGIQUgEyEDCyADIAhPDQBBACEKIAMhBiAIIANrQQdxIgcEQANAIAUgBi0AADoAACAFQQFqIQUgBkEBaiEGIApBAWoiCiAHRw0ACwsgAyAIa0F4Sw0AA0AgBSAGLQAAOgAAIAUgBi0AAToAASAFIAYtAAI6AAIgBSAGLQADOgADIAUgBi0ABDoABCAFIAYtAAU6AAUgBSAGLQAGOgAGIAUgBi0ABzoAByAFQQhqIQUgBkEIaiIGIAhHDQALCyABIAEoAgwgC2o2AgwgASgCBCEDIAtBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgDDYCACADIAs7AQQgDSEHIA4hDSAJQQNrIgVBgIAESQ0DDAILAkAgBiAUTw0AIAovAAAgBi8AAEcNACAKQQJqIQogBkECaiEGCyAGIBJJBH8gBiAKLQAAIAYtAABGagUgBgsgC2sLIQwgCCADayELIAEoAgwhBgJAAkAgCCATTQRAIAYgA/0AAAD9CwAAIAEoAgwhBSALQRBNBEAgASAFIAtqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECALQSFIDQEgBSALaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgE00EQCAGIAP9AAAA/QsAACAGIBMgA2siCWohCiAJQRFOBEAgBkEQaiEGA0AgBiAD/QAAEP0LAAAgBiAD/QAAIP0LABAgA0EgaiEDIAZBIGoiBiAKSQ0ACwsgCiEGIBMhAwsgAyAITw0AIAUgA2siD0EHcUEHRwRAIA9BAWpBB3EhCUEAIQoDQCAGIAMtAAA6AAAgBkEBaiEGIANBAWohAyAKQQFqIgogCUcNAAsgD0EHSQ0BCwNAIAYgAy0AADoAACAGIAMtAAE6AAEgBiADLQACOgACIAYgAy0AAzoAAyAGIAMtAAQ6AAQgBiADLQAFOgAFIAYgAy0ABjoABiAGIAMtAAc6AAcgBkEIaiEGIANBB2ohCiADQQhqIQMgBSAKRw0ACwsgASABKAIMIAtqNgIMIAEoAgQhAyALQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyAMQQRqIQkgA0EBNgIAIAMgCzsBBCANIQ4gDEEBaiIFQf//A00NAQsgAUECNgIkIAEgAyABKAIAa0EDdTYCKCAOIQ0LIAMgBTsBBiABIANBCGoiCjYCBAJAIAggCWoiAyAVSw0AIAQgESAcQQJqIgVqKQAAIiJC48iVvcub741PfiAjiKdBAnRqIAU2AgAgBCADQQJrIgYpAABC48iVvcub741PfiAjiKdBAnRqIAYgEWs2AgAgGCAiQoDGlf3Lm++NT34gJIinQQJ0aiAFNgIAIBggA0EBayIFKQAAQoDGlf3Lm++NT34gJIinQQJ0aiAFIBFrNgIAIA0hBiAHIQgDQAJAIAghDSAGIQggDUUNACADKAAAIAMgDWsoAABHDQAgA0EEaiIHIA1rIQYCfwJAIAAgB00EQCAHIQUMAQsgBigAACILIAciBSgAACIJRwRAIAkgC3NoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAATw0BIAYoAAAiCyAFKAAAIglGDQALIAUgCSALc2hBA3ZqIAdrDAELAkAgBSAUTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBJJBH8gBSAGLQAAIAUtAABGagUgBQsgB2sLIQUgGCADKQAAIiJCgMaV/cub741PfiAkiKdBAnRqIAMgEWsiBjYCACAEICJC48iVvcub741PfiAjiKdBAnRqIAY2AgAgAyATTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhCgsgCkEBNgIAIApBADsBBCAFQQFqIgZBgIAETwRAIAFBAjYCJCABIAogASgCAGtBA3U2AigLIAogBjsBBiABIApBCGoiCjYCBCANIQYgCCEHIAMgBWpBBGoiAyAVTQ0BDAILCyANIQcgCCENCyADIgVBAWoiBiAVTQ0ACwsgAiANIB1BACAeGyANGzYCACACIAcgHSAfQQAgIBsiBSANGyAFIB4bIAcbNgIEIBIgA2sPCyAZQcL9MS8AADsBCCAZQbr9MSkAADcDAAJAIAYgFUsNACASQSBrIRMgEkEBayEUIBJBA2shAEHAACAKa60hJEHAACALa60hIwNAQQAgDWshECAFQYACaiEOIBEgBCAFKQAAIiJC48iVvcub741PfiAjiKciC0ECdGooAgAiD2ohCkEBIRcCQAJAAn8CQAJAAn8CQANAIBggIkKAgOz8y5vvjU9+ICSIp0ECdGoiCCgCACEJIAggBSARayIcNgIAIAQgC0ECdGogHDYCAAJAIA1FDQAgBUEBaiIIIBBqKAAAIAUoAAFHDQAgBUEFaiILIBBqIQogACALTQRAIAshBgwGCyAKKAAAIgkgCyIGKAAAIgxHBEAgCSAMc2hBA3YMBwsDQCAKQQRqIQogBkEEaiIGIABPDQYgCigAACIJIAYoAAAiDEYNAAsgBiAJIAxzaEEDdmogC2sMBgsgGSAKIA8gG0kbIgwpAAAgIlIhCCAGKQAAIiJC48iVvcub741PfiAjiKchCwJAIAgNACAKIAxHDQAgCkEIaiEJIAAgBUEIaiIPTQRAIA8hBwwDCyAJKAAAIgggDyIHKAAAIgxHBEAgCCAMc2hBA3YMBAsDQCAJQQRqIQkgB0EEaiIHIABPDQMgCSgAACIIIAcoAAAiDEYNAAsgByAIIAxzaEEDdmogD2sMAwsgESAEIAtBAnRqKAIAIg9qIQogGSAJIBFqIgwgCSAbSRsiCSgAACAFKAAARiAJIAxGcUUEQCAGIA5PBEAgF0EBaiEXIA5BgAJqIQ4LIBcgBiIFaiIJIQYgCSAVTQ0BDAoLCyAMQQRqIQkCfwJAIAAgBUEEaiIQTQRAIBAhBwwBCyAJKAAAIgggECIHKAAAIg5HBEAgCCAOc2hBA3YMAgsDQCAJQQRqIQkgB0EEaiIHIABPDQEgCSgAACIIIAcoAAAiDkYNAAsgByAIIA5zaEEDdmogEGsMAQsCQCAHIBRPDQAgCS8AACAHLwAARw0AIAlBAmohCSAHQQJqIQcLIAcgEkkEfyAHIAktAAAgBy0AAEZqBSAHCyAQawshByAFIAxrIQ4gB0EEaiEJAkAgDyAbTQ0AIAopAAAgIlINACAKQQhqIQgCfwJAIAAgBkEIaiIWTQRAIBYhBwwBCyAIKAAAIg8gFiIHKAAAIhBHBEAgDyAQc2hBA3YMAgsDQCAIQQRqIQggB0EEaiIHIABPDQEgCCgAACIPIAcoAAAiEEYNAAsgByAPIBBzaEEDdmogFmsMAQsCQCAHIBRPDQAgCC8AACAHLwAARw0AIAhBAmohCCAHQQJqIQcLIAcgEkkEfyAHIAgtAAAgBy0AAEZqBSAHCyAWawtBCGoiByAJTQ0AIAYgCmshDiAKIQwgBiEFIAchCQsgDCAaTQRAIAUhCAwDCyADIAVPBEAgBSEIDAMLA0AgBUEBayIILQAAIAxBAWsiDC0AAEcEQCAFIQgMBAsgCUEBaiEJIAMgCE8NAyAIIQUgDCAaSw0ACwwCCwJAIAcgFE8NACAJLwAAIAcvAABHDQAgCUECaiEJIAdBAmohBwsgByASSQR/IAcgCS0AACAHLQAARmoFIAcLIA9rCyEHIAUgCmshDiAHQQhqIQkgCiAaTQRAIAUhCAwBCyADIAVPBEAgBSEIDAELA0AgBUEBayIILQAAIApBAWsiCi0AAEcEQCAFIQgMAgsgCUEBaiEJIAMgCE8NASAIIQUgCiAaSw0ACwsgF0EDTQRAIAQgC0ECdGogBiARazYCAAsgDkEDaiEMIAggA2shCyABKAIMIQUCQAJAIAggE00EQCAFIAP9AAAA/QsAACABKAIMIQUgC0EQTQRAIAEgBSALajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgC0EhSA0BIAUgC2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBNNBEAgBSAD/QAAAP0LAAAgBSATIANrIgpqIQYgCkERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSATIQMLIAMgCE8NAEEAIQogAyEGIAggA2tBB3EiBwRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgCkEBaiIKIAdHDQALCyADIAhrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCEcNAAsLIAEgASgCDCALajYCDCABKAIEIQMgC0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAMNgIAIAMgCzsBBCANIQcgDiENIAlBA2siBUGAgARJDQMMAgsCQCAGIBRPDQAgCi8AACAGLwAARw0AIApBAmohCiAGQQJqIQYLIAYgEkkEfyAGIAotAAAgBi0AAEZqBSAGCyALawshDCAIIANrIQsgASgCDCEGAkACQCAIIBNNBEAgBiAD/QAAAP0LAAAgASgCDCEFIAtBEE0EQCABIAUgC2o2AgwgASgCBCEDDAMLIAUgA/0AABD9CwAQIAtBIUgNASAFIAtqIQYgA0EQaiEDIAVBIGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsMAQsgAyATTQRAIAYgA/0AAAD9CwAAIAYgEyADayIJaiEKIAlBEU4EQCAGQRBqIQYDQCAGIAP9AAAQ/QsAACAGIAP9AAAg/QsAECADQSBqIQMgBkEgaiIGIApJDQALCyAKIQYgEyEDCyADIAhPDQAgBSADayIPQQdxQQdHBEAgD0EBakEHcSEJQQAhCgNAIAYgAy0AADoAACAGQQFqIQYgA0EBaiEDIApBAWoiCiAJRw0ACyAPQQdJDQELA0AgBiADLQAAOgAAIAYgAy0AAToAASAGIAMtAAI6AAIgBiADLQADOgADIAYgAy0ABDoABCAGIAMtAAU6AAUgBiADLQAGOgAGIAYgAy0ABzoAByAGQQhqIQYgA0EHaiEKIANBCGohAyAFIApHDQALCyABIAEoAgwgC2o2AgwgASgCBCEDIAtBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAxBBGohCSADQQE2AgAgAyALOwEEIA0hDiAMQQFqIgVB//8DTQ0BCyABQQI2AiQgASADIAEoAgBrQQN1NgIoIA4hDQsgAyAFOwEGIAEgA0EIaiIKNgIEAkAgCCAJaiIDIBVLDQAgBCARIBxBAmoiBWopAAAiIkLjyJW9y5vvjU9+ICOIp0ECdGogBTYCACAEIANBAmsiBikAAELjyJW9y5vvjU9+ICOIp0ECdGogBiARazYCACAYICJCgIDs/Mub741PfiAkiKdBAnRqIAU2AgAgGCADQQFrIgUpAABCgIDs/Mub741PfiAkiKdBAnRqIAUgEWs2AgAgDSEGIAchCANAAkAgCCENIAYhCCANRQ0AIAMoAAAgAyANaygAAEcNACADQQRqIgcgDWshBgJ/AkAgACAHTQRAIAchBQwBCyAGKAAAIgsgByIFKAAAIglHBEAgCSALc2hBA3YMAgsDQCAGQQRqIQYgBUEEaiIFIABPDQEgBigAACILIAUoAAAiCUYNAAsgBSAJIAtzaEEDdmogB2sMAQsCQCAFIBRPDQAgBi8AACAFLwAARw0AIAZBAmohBiAFQQJqIQULIAUgEkkEfyAFIAYtAAAgBS0AAEZqBSAFCyAHawshBSAYIAMpAAAiIkKAgOz8y5vvjU9+ICSIp0ECdGogAyARayIGNgIAIAQgIkLjyJW9y5vvjU9+ICOIp0ECdGogBjYCACADIBNNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEKCyAKQQE2AgAgCkEAOwEEIAVBAWoiBkGAgARPBEAgAUECNgIkIAEgCiABKAIAa0EDdTYCKAsgCiAGOwEGIAEgCkEIaiIKNgIEIA0hBiAIIQcgAyAFakEEaiIDIBVNDQEMAgsLIA0hByAIIQ0LIAMiBUEBaiIGIBVNDQALCyACIA0gHUEAIB4bIA0bNgIAIAIgByAdIB9BACAgGyIFIA0bIAUgHhsgBxs2AgQgEiADaw8LIBlBwv0xLwAAOwEIIBlBuv0xKQAANwMAAkAgBiAVSw0AIBJBIGshEyASQQFrIRQgEkEDayEAQcAAIAprrSEkQcAAIAtrrSEjA0BBACANayEQIAVBgAJqIQ4gESAEIAUpAAAiIkLjyJW9y5vvjU9+ICOIpyILQQJ0aigCACIPaiEKQQEhFwJAAkACfwJAAkACfwJAA0AgGCAiQoCAgNjLm++NT34gJIinQQJ0aiIIKAIAIQkgCCAFIBFrIhw2AgAgBCALQQJ0aiAcNgIAAkAgDUUNACAFQQFqIgggEGooAAAgBSgAAUcNACAFQQVqIgsgEGohCiAAIAtNBEAgCyEGDAYLIAooAAAiCSALIgYoAAAiDEcEQCAJIAxzaEEDdgwHCwNAIApBBGohCiAGQQRqIgYgAE8NBiAKKAAAIgkgBigAACIMRg0ACyAGIAkgDHNoQQN2aiALawwGCyAZIAogDyAbSRsiDCkAACAiUiEIIAYpAAAiIkLjyJW9y5vvjU9+ICOIpyELAkAgCA0AIAogDEcNACAKQQhqIQkgACAFQQhqIg9NBEAgDyEHDAMLIAkoAAAiCCAPIgcoAAAiDEcEQCAIIAxzaEEDdgwECwNAIAlBBGohCSAHQQRqIgcgAE8NAyAJKAAAIgggBygAACIMRg0ACyAHIAggDHNoQQN2aiAPawwDCyARIAQgC0ECdGooAgAiD2ohCiAZIAkgEWoiDCAJIBtJGyIJKAAAIAUoAABGIAkgDEZxRQRAIAYgDk8EQCAXQQFqIRcgDkGAAmohDgsgFyAGIgVqIgkhBiAJIBVNDQEMCgsLIAxBBGohCQJ/AkAgACAFQQRqIhBNBEAgECEHDAELIAkoAAAiCCAQIgcoAAAiDkcEQCAIIA5zaEEDdgwCCwNAIAlBBGohCSAHQQRqIgcgAE8NASAJKAAAIgggBygAACIORg0ACyAHIAggDnNoQQN2aiAQawwBCwJAIAcgFE8NACAJLwAAIAcvAABHDQAgCUECaiEJIAdBAmohBwsgByASSQR/IAcgCS0AACAHLQAARmoFIAcLIBBrCyEHIAUgDGshDiAHQQRqIQkCQCAPIBtNDQAgCikAACAiUg0AIApBCGohCAJ/AkAgACAGQQhqIhZNBEAgFiEHDAELIAgoAAAiDyAWIgcoAAAiEEcEQCAPIBBzaEEDdgwCCwNAIAhBBGohCCAHQQRqIgcgAE8NASAIKAAAIg8gBygAACIQRg0ACyAHIA8gEHNoQQN2aiAWawwBCwJAIAcgFE8NACAILwAAIAcvAABHDQAgCEECaiEIIAdBAmohBwsgByASSQR/IAcgCC0AACAHLQAARmoFIAcLIBZrC0EIaiIHIAlNDQAgBiAKayEOIAohDCAGIQUgByEJCyAMIBpNBEAgBSEIDAMLIAMgBU8EQCAFIQgMAwsDQCAFQQFrIggtAAAgDEEBayIMLQAARwRAIAUhCAwECyAJQQFqIQkgAyAITw0DIAghBSAMIBpLDQALDAILAkAgByAUTw0AIAkvAAAgBy8AAEcNACAJQQJqIQkgB0ECaiEHCyAHIBJJBH8gByAJLQAAIActAABGagUgBwsgD2sLIQcgBSAKayEOIAdBCGohCSAKIBpNBEAgBSEIDAELIAMgBU8EQCAFIQgMAQsDQCAFQQFrIggtAAAgCkEBayIKLQAARwRAIAUhCAwCCyAJQQFqIQkgAyAITw0BIAghBSAKIBpLDQALCyAXQQNNBEAgBCALQQJ0aiAGIBFrNgIACyAOQQNqIQwgCCADayELIAEoAgwhBQJAAkAgCCATTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSALQRBNBEAgASAFIAtqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECALQSFIDQEgBSALaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgE00EQCAFIAP9AAAA/QsAACAFIBMgA2siCmohBiAKQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBMhAwsgAyAITw0AQQAhCiADIQYgCCADa0EHcSIHBEADQCAFIAYtAAA6AAAgBUEBaiEFIAZBAWohBiAKQQFqIgogB0cNAAsLIAMgCGtBeEsNAANAIAUgBi0AADoAACAFIAYtAAE6AAEgBSAGLQACOgACIAUgBi0AAzoAAyAFIAYtAAQ6AAQgBSAGLQAFOgAFIAUgBi0ABjoABiAFIAYtAAc6AAcgBUEIaiEFIAZBCGoiBiAIRw0ACwsgASABKAIMIAtqNgIMIAEoAgQhAyALQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAw2AgAgAyALOwEEIA0hByAOIQ0gCUEDayIFQYCABEkNAwwCCwJAIAYgFE8NACAKLwAAIAYvAABHDQAgCkECaiEKIAZBAmohBgsgBiASSQR/IAYgCi0AACAGLQAARmoFIAYLIAtrCyEMIAggA2shCyABKAIMIQYCQAJAIAggE00EQCAGIAP9AAAA/QsAACABKAIMIQUgC0EQTQRAIAEgBSALajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgC0EhSA0BIAUgC2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBNNBEAgBiAD/QAAAP0LAAAgBiATIANrIglqIQogCUERTgRAIAZBEGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgCkkNAAsLIAohBiATIQMLIAMgCE8NACAFIANrIg9BB3FBB0cEQCAPQQFqQQdxIQlBACEKA0AgBiADLQAAOgAAIAZBAWohBiADQQFqIQMgCkEBaiIKIAlHDQALIA9BB0kNAQsDQCAGIAMtAAA6AAAgBiADLQABOgABIAYgAy0AAjoAAiAGIAMtAAM6AAMgBiADLQAEOgAEIAYgAy0ABToABSAGIAMtAAY6AAYgBiADLQAHOgAHIAZBCGohBiADQQdqIQogA0EIaiEDIAUgCkcNAAsLIAEgASgCDCALajYCDCABKAIEIQMgC0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgDEEEaiEJIANBATYCACADIAs7AQQgDSEOIAxBAWoiBUH//wNNDQELIAFBAjYCJCABIAMgASgCAGtBA3U2AiggDiENCyADIAU7AQYgASADQQhqIgo2AgQCQCAIIAlqIgMgFUsNACAEIBEgHEECaiIFaikAACIiQuPIlb3Lm++NT34gI4inQQJ0aiAFNgIAIAQgA0ECayIGKQAAQuPIlb3Lm++NT34gI4inQQJ0aiAGIBFrNgIAIBggIkKAgIDYy5vvjU9+ICSIp0ECdGogBTYCACAYIANBAWsiBSkAAEKAgIDYy5vvjU9+ICSIp0ECdGogBSARazYCACANIQYgByEIA0ACQCAIIQ0gBiEIIA1FDQAgAygAACADIA1rKAAARw0AIANBBGoiByANayEGAn8CQCAAIAdNBEAgByEFDAELIAYoAAAiCyAHIgUoAAAiCUcEQCAJIAtzaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgAE8NASAGKAAAIgsgBSgAACIJRg0ACyAFIAkgC3NoQQN2aiAHawwBCwJAIAUgFE8NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSASSQR/IAUgBi0AACAFLQAARmoFIAULIAdrCyEFIBggAykAACIiQoCAgNjLm++NT34gJIinQQJ0aiADIBFrIgY2AgAgBCAiQuPIlb3Lm++NT34gI4inQQJ0aiAGNgIAIAMgE00EQCABKAIMIAP9AAAA/QsAACABKAIEIQoLIApBATYCACAKQQA7AQQgBUEBaiIGQYCABE8EQCABQQI2AiQgASAKIAEoAgBrQQN1NgIoCyAKIAY7AQYgASAKQQhqIgo2AgQgDSEGIAghByADIAVqQQRqIgMgFU0NAQwCCwsgDSEHIAghDQsgAyIFQQFqIgYgFU0NAAsLIAIgDSAdQQAgHhsgDRs2AgAgAiAHIB0gH0EAICAbIgUgDRsgBSAeGyAHGzYCBCASIANrC8tuAh9/B34gAyAAKAIEIg8gACgCDCIOIAMgD2sgBGoiDEEBIAAoArgBdCIRayAOIAwgDmsgEUsbIAAoAhgbIg5qIhFrIRBBACAAKAK0ASIFKAIEIhQgBSgCACIVayAOaiIYayELIAMgBGoiDEEIayEZIBQgBSgCDCIdaiIaIBVrIRYgACgC2AEhEyACKAIEIQggAigCACEEIAAoArwBIQkgACgCZCEbIAAoAsABIQogACgCXCEXIAUoArwBIQYgBSgCwAEhByAFKAJkISEgBSgCXCEgAkACQAJAAkACQCAAKALIAUEFaw4DAwIBAAsCQCATRQ0AIAdBHkkEQEEEIAd0IQVBACEAA0AgAEFAayIAIAVJDQALCyAGQR1LDQBBBCAGdCEFQQAhAANAIABBQGsiACAFSQ0ACwsgAyAQIBZGaiIFIBlPDQMgCyAUaiETIAxBAWshIiAMQQNrIR4gDEEgayEWQRggBmshI0EgIAlrIRBBOCAHa60hJkHAACAKa60hJANAIBcgBSkAACIlQuPIlb3Lm++NT34iJyAkiKdBAnRqIgAoAgAhCSAbICWnQbHz3fF5bCIGIBB2QQJ0aiIHKAIAIQogICAnICaIpyISQQZ2Qfz//x9xaigCACENICEgBiAjdiIfQQZ2Qfz//x9xaigCACEGIAcgBSAPayILNgIAIAAgCzYCAAJAAkACQAJAIAtBAWoiHCAEayIAIA5rQXxLDQAgFCAAIBhraiAAIA9qIAAgDkkiABsiBygAACAFKAABRw0AIAVBBWogB0EEaiAMIBUgDCAAGyARENALIRIgBUEBaiIGIANrIQogASgCDCEAAkACQCAGIBZNBEAgACAD/QAAAP0LAAAgASgCDCEAIApBEE0EQCABIAAgCmo2AgwgASgCBCEDDAMLIAAgA/0AABD9CwAQIApBIUgNASAAIApqIQUgA0EQaiEDIABBIGohAANAIAAgA/0AABD9CwAAIAAgA/0AACD9CwAQIANBIGohAyAAQSBqIgAgBUkNAAsMAQsgAyAWTQRAIAAgA/0AAAD9CwAAIAAgFiADayIJaiEHIAlBEU4EQCAAQRBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAdJDQALCyAWIQMgByEACyADIAZPDQBBACEHIAUgA2siDUEBakEHcSIJBEADQCAAIAMtAAA6AAAgAEEBaiEAIANBAWohAyAHQQFqIgcgCUcNAAsLIA1BB0kNAANAIAAgAy0AADoAACAAIAMtAAE6AAEgACADLQACOgACIAAgAy0AAzoAAyAAIAMtAAQ6AAQgACADLQAFOgAFIAAgAy0ABjoABiAAIAMtAAc6AAcgAEEIaiEAIANBB2ohByADQQhqIQMgBSAHRw0ACwsgASABKAIMIApqNgIMIAEoAgQhAyAKQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyASQQRqIQcgA0EBNgIAIAMgCjsBBCAEIQ0gEkEBaiIAQf//A0sNAQwCCwJAAn8CQAJAIAkgDkkNACAJIA9qIgApAAAgJVINACAAQQhqIQYgHiAFQQhqIg1NBEAgDSEIDAILIAYoAAAiByANIggoAAAiCkcEQCAHIApzaEEDdgwDCwNAIAZBBGohBiAIQQRqIgggHk8NAiAGKAAAIgcgCCgAACIKRg0ACyAIIAcgCnNoQQN2aiANawwCCwJAIA0gEnNB/wFxDQAgDUEIdiIJIB1NDQAgCSAUaiIAKQAAICVSDQAgBUEIaiAAQQhqIAwgFSARENALQQhqIQcgCyAJIBhqayENIAMgBU8EQCAFIQYMBAsDQCAFQQFrIgYtAAAgAEEBayIALQAARwRAIAUhBgwFCyAHQQFqIQcgAyAGTw0EIAYhBSAAIBpLDQALDAMLAkACQCAKIA5LBEAgCiAPaiIAKAAAIAUoAABGDQEMAgsgBiAfc0H/AXENASAGQQh2IgYgHU0NASAGIBRqIgAoAAAgBSgAAEcNASAGIBhqIQoLIBcgBSkAASInQuPIlb3Lm++NT34iJSAkiKdBAnRqIggoAgAhCSAgICUgJoinIg1BBnZB/P//H3FqKAIAIQcgCCAcNgIAIAVBAWohBgJ/AkACQCAJIA5JDQAgCSAPaiIIKQAAICdSDQAgCEEIaiEHIB4gBUEJaiINTQRAIA0hAAwCCyAHKAAAIgUgDSIAKAAAIgpHBEAgBSAKc2hBA3YMAwsDQCAHQQRqIQcgAEEEaiIAIB5PDQIgBygAACIFIAAoAAAiCkYNAAsgACAFIApzaEEDdmogDWsMAgsCQCAHIA1zQf8BcQ0AIAdBCHYiCSAdTQ0AIAkgFGoiCCkAACAnUg0AIAVBCWogCEEIaiAMIBUgERDQC0EIaiEHIBwgCSAYamshDSADIAZPDQYDQCAGQQFrIgAtAAAgCEEBayIILQAARw0HIAdBAWohByAAIANNBEAgACEGDAgLIAAhBiAIIBpLDQALDAYLIABBBGohBiAFQQRqIQcgCiAOSQRAIAcgBiAMIBUgERDQC0EEaiEHIAsgCmshDSADIAVPBEAgBSEGDAcLIAAgGk0EQCAFIQYMBwsDQCAFQQFrIgYtAAAgAEEBayIALQAARwRAIAUhBgwICyAHQQFqIQcgAyAGTw0HIAYhBSAAIBpLDQALDAYLIAUgAGshDQJ/AkAgByAeTwRAIAchCAwBCyAHIQggBigAACIJICdCGIinIgpHBEAgCSAKc2hBA3YMAgsDQCAGQQRqIQYgCEEEaiIIIB5PDQEgBigAACIJIAgoAAAiCkYNAAsgCCAJIApzaEEDdmogB2sMAQsCQCAIICJPDQAgBi8AACAILwAARw0AIAZBAmohBiAIQQJqIQgLIAggDEkEfyAIIAYtAAAgCC0AAEZqBSAICyAHawtBBGohByADIAVPBEAgBSEGDAYLIAAgEU0EQCAFIQYMBgsDQCAFQQFrIgYtAAAgAEEBayIALQAARwRAIAUhBgwHCyAHQQFqIQcgAyAGTw0GIAYhBSAAIBFLDQALDAULAkAgACAiTw0AIAcvAAAgAC8AAEcNACAHQQJqIQcgAEECaiEACyAAIAxJBH8gACAHLQAAIAAtAABGagUgAAsgDWsLIQAgBiAIayENIABBCGohByADIAZPDQMgCSAOTQ0DA0AgBkEBayIALQAAIAhBAWsiCC0AAEcNBCAHQQFqIQcgACADTQRAIAAhBgwFCyAAIQYgCCARSw0ACwwDCyAFIAUgA2tBCHVqQQFqIQUMBQsCQCAIICJPDQAgBi8AACAILwAARw0AIAZBAmohBiAIQQJqIQgLIAggDEkEfyAIIAYtAAAgCC0AAEZqBSAICyANawshCCAFIABrIQ0gCEEIaiEHIAMgBU8EQCAFIQYMAQsgCSAOTQRAIAUhBgwBCwNAIAVBAWsiBi0AACAAQQFrIgAtAABHBEAgBSEGDAILIAdBAWohByADIAZPDQEgBiEFIAAgEUsNAAsLIA1BA2ohEiAGIANrIQogASgCDCEAAkACQCAGIBZNBEAgACAD/QAAAP0LAAAgASgCDCEAIApBEE0EQCABIAAgCmo2AgwgASgCBCEDDAMLIAAgA/0AABD9CwAQIApBIUgNASAAIApqIQUgA0EQaiEDIABBIGohAANAIAAgA/0AABD9CwAAIAAgA/0AACD9CwAQIANBIGohAyAAQSBqIgAgBUkNAAsMAQsgAyAWTQRAIAAgA/0AAAD9CwAAIAAgFiADayIIaiEFIAhBEU4EQCAAQRBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALCyAWIQMgBSEACyADIAZPDQBBACEIIAMhBSAGIANrQQdxIgkEQANAIAAgBS0AADoAACAAQQFqIQAgBUEBaiEFIAhBAWoiCCAJRw0ACwsgAyAGa0F4Sw0AA0AgACAFLQAAOgAAIAAgBS0AAToAASAAIAUtAAI6AAIgACAFLQADOgADIAAgBS0ABDoABCAAIAUtAAU6AAUgACAFLQAGOgAGIAAgBS0ABzoAByAAQQhqIQAgBUEIaiIFIAZHDQALCyABIAEoAgwgCmo2AgwgASgCBCEDIApBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgEjYCACADIAo7AQQgBCEIIA0hBCAHQQNrIgBBgIAESQ0BCyABQQI2AiQgASADIAEoAgBrQQN1NgIoIA0hBAsgAyAAOwEGIAEgA0EIaiIANgIEIBkgBiAHaiIDSQRAIAMhBQwBCyAXIA8gC0ECaiIFaiIGKQAAQuPIlb3Lm++NT34gJIinQQJ0aiAFNgIAIBcgA0ECayIHKQAAQuPIlb3Lm++NT34gJIinQQJ0aiAHIA9rNgIAIBsgBigAAEGx893xeWwgEHZBAnRqIAU2AgAgGyADQQFrIgUoAABBsfPd8XlsIBB2QQJ0aiAFIA9rNgIAIAQhByAIIQYDQAJAIAYhBCAHIQYgAyAPayIIIARrIgUgDmtBfEsNACATIA8gBSAOSSIHGyAFaiIFKAAAIAMoAABHDQAgA0EEaiAFQQRqIAwgFSAMIAcbIBEQ0AshBSADIBZNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEACyAAQQE2AgAgAEEAOwEEIAVBAWoiB0GAgARPBEAgAUECNgIkIAEgACABKAIAa0EDdTYCKAsgACAHOwEGIAEgAEEIaiIANgIEIBsgAygAAEGx893xeWwgEHZBAnRqIAg2AgAgFyADKQAAQuPIlb3Lm++NT34gJIinQQJ0aiAINgIAIAQhByAGIQggAyAFakEEaiIDIQUgAyAZTQ0BDAILCyAEIQggBiEEIAMhBQsgBSAZSQ0ACwwDCwJAIBNFDQAgB0EeSQRAQQQgB3QhBUEAIQADQCAAQUBrIgAgBUkNAAsLIAZBHUsNAEEEIAZ0IQVBACEAA0AgAEFAayIAIAVJDQALCyADIBAgFkZqIgUgGU8NAiALIBRqIRYgDEEBayEcIAxBA2shDSAMQSBrIRBBOCAGa60hKUE4IAdrrSEoQcAAIAlrrSEnQcAAIAprrSElA0AgFyAFKQAAIiRC48iVvcub741PfiImICWIp0ECdGoiACgCACELIBsgJEKAxpX9y5vvjU9+IiogJ4inQQJ0aiIGKAIAIQkgICAmICiIpyIKQQZ2Qfz//x9xaigCACEHICEgKiApiKciHkEGdkH8//8fcWooAgAhEiAGIAUgD2siEzYCACAAIBM2AgACQAJAAkACQCATQQFqIh8gBGsiACAOa0F8Sw0AIBQgACAYa2ogACAPaiAAIA5JIgAbIgYoAAAgBSgAAUcNACAFQQVqIAZBBGogDCAVIAwgABsgERDQCyESIAVBAWoiBiADayEJIAEoAgwhAAJAAkAgBiAQTQRAIAAgA/0AAAD9CwAAIAEoAgwhACAJQRBNBEAgASAAIAlqNgIMIAEoAgQhAwwDCyAAIAP9AAAQ/QsAECAJQSFIDQEgACAJaiEFIANBEGohAyAAQSBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALDAELIAMgEE0EQCAAIAP9AAAA/QsAACAAIBAgA2siC2ohByALQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAHSQ0ACwsgECEDIAchAAsgAyAGTw0AQQAhByAFIANrIgpBAWpBB3EiCwRAA0AgACADLQAAOgAAIABBAWohACADQQFqIQMgB0EBaiIHIAtHDQALCyAKQQdJDQADQCAAIAMtAAA6AAAgACADLQABOgABIAAgAy0AAjoAAiAAIAMtAAM6AAMgACADLQAEOgAEIAAgAy0ABToABSAAIAMtAAY6AAYgACADLQAHOgAHIABBCGohACADQQdqIQcgA0EIaiEDIAUgB0cNAAsLIAEgASgCDCAJajYCDCABKAIEIQMgCUGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgEkEEaiEHIANBATYCACADIAk7AQQgBCEKIBJBAWoiAEH//wNLDQEMAgsCQAJ/AkACQCALIA5JDQAgCyAPaiIAKQAAICRSDQAgAEEIaiEGIA0gBUEIaiIKTQRAIAohCAwCCyAGKAAAIgcgCiIIKAAAIglHBEAgByAJc2hBA3YMAwsDQCAGQQRqIQYgCEEEaiIIIA1PDQIgBigAACIHIAgoAAAiCUYNAAsgCCAHIAlzaEEDdmogCmsMAgsCQCAHIApzQf8BcQ0AIAdBCHYiBiAdTQ0AIAYgFGoiACkAACAkUg0AIAVBCGogAEEIaiAMIBUgERDQC0EIaiEHIBMgBiAYamshCiADIAVPBEAgBSEGDAQLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMBQsgB0EBaiEHIAMgBk8NBCAGIQUgACAaSw0ACwwDCwJAAkAgCSAOSwRAIAkgD2oiACgAACAFKAAARg0BDAILIBIgHnNB/wFxDQEgEkEIdiIGIB1NDQEgBiAUaiIAKAAAIAUoAABHDQEgBiAYaiEJCyAXIAUpAAEiJkLjyJW9y5vvjU9+IiQgJYinQQJ0aiIIKAIAIQsgICAkICiIpyIKQQZ2Qfz//x9xaigCACEHIAggHzYCACAFQQFqIQYCfwJAAkAgCyAOSQ0AIAsgD2oiCCkAACAmUg0AIAhBCGohByANIAVBCWoiCk0EQCAKIQAMAgsgBygAACIFIAoiACgAACIJRwRAIAUgCXNoQQN2DAMLA0AgB0EEaiEHIABBBGoiACANTw0CIAcoAAAiBSAAKAAAIglGDQALIAAgBSAJc2hBA3ZqIAprDAILAkAgByAKc0H/AXENACAHQQh2IgsgHU0NACALIBRqIggpAAAgJlINACAFQQlqIAhBCGogDCAVIBEQ0AtBCGohByAfIAsgGGprIQogAyAGTw0GA0AgBkEBayIALQAAIAhBAWsiCC0AAEcNByAHQQFqIQcgACADTQRAIAAhBgwICyAAIQYgCCAaSw0ACwwGCyAAQQRqIQYgBUEEaiEHIAkgDkkEQCAHIAYgDCAVIBEQ0AtBBGohByATIAlrIQogAyAFTwRAIAUhBgwHCyAAIBpNBEAgBSEGDAcLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMCAsgB0EBaiEHIAMgBk8NByAGIQUgACAaSw0ACwwGCyAFIABrIQoCfwJAIAcgDU8EQCAHIQgMAQsgByEIIAYoAAAiCyAmQhiIpyIJRwRAIAkgC3NoQQN2DAILA0AgBkEEaiEGIAhBBGoiCCANTw0BIAYoAAAiCyAIKAAAIglGDQALIAggCSALc2hBA3ZqIAdrDAELAkAgCCAcTw0AIAYvAAAgCC8AAEcNACAGQQJqIQYgCEECaiEICyAIIAxJBH8gCCAGLQAAIAgtAABGagUgCAsgB2sLQQRqIQcgAyAFTwRAIAUhBgwGCyAAIBFNBEAgBSEGDAYLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMBwsgB0EBaiEHIAMgBk8NBiAGIQUgACARSw0ACwwFCwJAIAAgHE8NACAHLwAAIAAvAABHDQAgB0ECaiEHIABBAmohAAsgACAMSQR/IAAgBy0AACAALQAARmoFIAALIAprCyEAIAYgCGshCiAAQQhqIQcgAyAGTw0DIAsgDk0NAwNAIAZBAWsiAC0AACAIQQFrIggtAABHDQQgB0EBaiEHIAAgA00EQCAAIQYMBQsgACEGIAggEUsNAAsMAwsgBSAFIANrQQh1akEBaiEFDAULAkAgCCAcTw0AIAYvAAAgCC8AAEcNACAGQQJqIQYgCEECaiEICyAIIAxJBH8gCCAGLQAAIAgtAABGagUgCAsgCmsLIQggBSAAayEKIAhBCGohByADIAVPBEAgBSEGDAELIAsgDk0EQCAFIQYMAQsDQCAFQQFrIgYtAAAgAEEBayIALQAARwRAIAUhBgwCCyAHQQFqIQcgAyAGTw0BIAYhBSAAIBFLDQALCyAKQQNqIRIgBiADayEJIAEoAgwhAAJAAkAgBiAQTQRAIAAgA/0AAAD9CwAAIAEoAgwhACAJQRBNBEAgASAAIAlqNgIMIAEoAgQhAwwDCyAAIAP9AAAQ/QsAECAJQSFIDQEgACAJaiEFIANBEGohAyAAQSBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALDAELIAMgEE0EQCAAIAP9AAAA/QsAACAAIBAgA2siCGohBSAIQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAFSQ0ACwsgECEDIAUhAAsgAyAGTw0AQQAhCCADIQUgBiADa0EHcSILBEADQCAAIAUtAAA6AAAgAEEBaiEAIAVBAWohBSAIQQFqIgggC0cNAAsLIAMgBmtBeEsNAANAIAAgBS0AADoAACAAIAUtAAE6AAEgACAFLQACOgACIAAgBS0AAzoAAyAAIAUtAAQ6AAQgACAFLQAFOgAFIAAgBS0ABjoABiAAIAUtAAc6AAcgAEEIaiEAIAVBCGoiBSAGRw0ACwsgASABKAIMIAlqNgIMIAEoAgQhAyAJQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIBI2AgAgAyAJOwEEIAQhCCAKIQQgB0EDayIAQYCABEkNAQsgAUECNgIkIAEgAyABKAIAa0EDdTYCKCAKIQQLIAMgADsBBiABIANBCGoiADYCBCAZIAYgB2oiA0kEQCADIQUMAQsgFyAPIBNBAmoiBWopAAAiJELjyJW9y5vvjU9+ICWIp0ECdGogBTYCACAXIANBAmsiBikAAELjyJW9y5vvjU9+ICWIp0ECdGogBiAPazYCACAbICRCgMaV/cub741PfiAniKdBAnRqIAU2AgAgGyADQQFrIgUpAABCgMaV/cub741PfiAniKdBAnRqIAUgD2s2AgAgBCEHIAghBgNAAkAgBiEEIAchBiADIA9rIgggBGsiBSAOa0F8Sw0AIBYgDyAFIA5JIgcbIAVqIgUoAAAgAygAAEcNACADQQRqIAVBBGogDCAVIAwgBxsgERDQCyEFIAMgEE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQALIABBATYCACAAQQA7AQQgBUEBaiIHQYCABE8EQCABQQI2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAc7AQYgASAAQQhqIgA2AgQgGyADKQAAIiRCgMaV/cub741PfiAniKdBAnRqIAg2AgAgFyAkQuPIlb3Lm++NT34gJYinQQJ0aiAINgIAIAQhByAGIQggAyAFakEEaiIDIQUgAyAZTQ0BDAILCyAEIQggBiEEIAMhBQsgBSAZSQ0ACwwCCwJAIBNFDQAgB0EeSQRAQQQgB3QhBUEAIQADQCAAQUBrIgAgBUkNAAsLIAZBHUsNAEEEIAZ0IQVBACEAA0AgAEFAayIAIAVJDQALCyADIBAgFkZqIgUgGU8NASALIBRqIRYgDEEBayEcIAxBA2shDSAMQSBrIRBBOCAGa60hKUE4IAdrrSEoQcAAIAlrrSEnQcAAIAprrSElA0AgFyAFKQAAIiRC48iVvcub741PfiImICWIp0ECdGoiACgCACELIBsgJEKAgOz8y5vvjU9+IiogJ4inQQJ0aiIGKAIAIQkgICAmICiIpyIKQQZ2Qfz//x9xaigCACEHICEgKiApiKciHkEGdkH8//8fcWooAgAhEiAGIAUgD2siEzYCACAAIBM2AgACQAJAAkACQCATQQFqIh8gBGsiACAOa0F8Sw0AIBQgACAYa2ogACAPaiAAIA5JIgAbIgYoAAAgBSgAAUcNACAFQQVqIAZBBGogDCAVIAwgABsgERDQCyESIAVBAWoiBiADayEJIAEoAgwhAAJAAkAgBiAQTQRAIAAgA/0AAAD9CwAAIAEoAgwhACAJQRBNBEAgASAAIAlqNgIMIAEoAgQhAwwDCyAAIAP9AAAQ/QsAECAJQSFIDQEgACAJaiEFIANBEGohAyAAQSBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALDAELIAMgEE0EQCAAIAP9AAAA/QsAACAAIBAgA2siC2ohByALQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAHSQ0ACwsgECEDIAchAAsgAyAGTw0AQQAhByAFIANrIgpBAWpBB3EiCwRAA0AgACADLQAAOgAAIABBAWohACADQQFqIQMgB0EBaiIHIAtHDQALCyAKQQdJDQADQCAAIAMtAAA6AAAgACADLQABOgABIAAgAy0AAjoAAiAAIAMtAAM6AAMgACADLQAEOgAEIAAgAy0ABToABSAAIAMtAAY6AAYgACADLQAHOgAHIABBCGohACADQQdqIQcgA0EIaiEDIAUgB0cNAAsLIAEgASgCDCAJajYCDCABKAIEIQMgCUGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgEkEEaiEHIANBATYCACADIAk7AQQgBCEKIBJBAWoiAEH//wNLDQEMAgsCQAJ/AkACQCALIA5JDQAgCyAPaiIAKQAAICRSDQAgAEEIaiEGIA0gBUEIaiIKTQRAIAohCAwCCyAGKAAAIgcgCiIIKAAAIglHBEAgByAJc2hBA3YMAwsDQCAGQQRqIQYgCEEEaiIIIA1PDQIgBigAACIHIAgoAAAiCUYNAAsgCCAHIAlzaEEDdmogCmsMAgsCQCAHIApzQf8BcQ0AIAdBCHYiBiAdTQ0AIAYgFGoiACkAACAkUg0AIAVBCGogAEEIaiAMIBUgERDQC0EIaiEHIBMgBiAYamshCiADIAVPBEAgBSEGDAQLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMBQsgB0EBaiEHIAMgBk8NBCAGIQUgACAaSw0ACwwDCwJAAkAgCSAOSwRAIAkgD2oiACgAACAFKAAARg0BDAILIBIgHnNB/wFxDQEgEkEIdiIGIB1NDQEgBiAUaiIAKAAAIAUoAABHDQEgBiAYaiEJCyAXIAUpAAEiJkLjyJW9y5vvjU9+IiQgJYinQQJ0aiIIKAIAIQsgICAkICiIpyIKQQZ2Qfz//x9xaigCACEHIAggHzYCACAFQQFqIQYCfwJAAkAgCyAOSQ0AIAsgD2oiCCkAACAmUg0AIAhBCGohByANIAVBCWoiCk0EQCAKIQAMAgsgBygAACIFIAoiACgAACIJRwRAIAUgCXNoQQN2DAMLA0AgB0EEaiEHIABBBGoiACANTw0CIAcoAAAiBSAAKAAAIglGDQALIAAgBSAJc2hBA3ZqIAprDAILAkAgByAKc0H/AXENACAHQQh2IgsgHU0NACALIBRqIggpAAAgJlINACAFQQlqIAhBCGogDCAVIBEQ0AtBCGohByAfIAsgGGprIQogAyAGTw0GA0AgBkEBayIALQAAIAhBAWsiCC0AAEcNByAHQQFqIQcgACADTQRAIAAhBgwICyAAIQYgCCAaSw0ACwwGCyAAQQRqIQYgBUEEaiEHIAkgDkkEQCAHIAYgDCAVIBEQ0AtBBGohByATIAlrIQogAyAFTwRAIAUhBgwHCyAAIBpNBEAgBSEGDAcLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMCAsgB0EBaiEHIAMgBk8NByAGIQUgACAaSw0ACwwGCyAFIABrIQoCfwJAIAcgDU8EQCAHIQgMAQsgByEIIAYoAAAiCyAmQhiIpyIJRwRAIAkgC3NoQQN2DAILA0AgBkEEaiEGIAhBBGoiCCANTw0BIAYoAAAiCyAIKAAAIglGDQALIAggCSALc2hBA3ZqIAdrDAELAkAgCCAcTw0AIAYvAAAgCC8AAEcNACAGQQJqIQYgCEECaiEICyAIIAxJBH8gCCAGLQAAIAgtAABGagUgCAsgB2sLQQRqIQcgAyAFTwRAIAUhBgwGCyAAIBFNBEAgBSEGDAYLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMBwsgB0EBaiEHIAMgBk8NBiAGIQUgACARSw0ACwwFCwJAIAAgHE8NACAHLwAAIAAvAABHDQAgB0ECaiEHIABBAmohAAsgACAMSQR/IAAgBy0AACAALQAARmoFIAALIAprCyEAIAYgCGshCiAAQQhqIQcgAyAGTw0DIAsgDk0NAwNAIAZBAWsiAC0AACAIQQFrIggtAABHDQQgB0EBaiEHIAAgA00EQCAAIQYMBQsgACEGIAggEUsNAAsMAwsgBSAFIANrQQh1akEBaiEFDAULAkAgCCAcTw0AIAYvAAAgCC8AAEcNACAGQQJqIQYgCEECaiEICyAIIAxJBH8gCCAGLQAAIAgtAABGagUgCAsgCmsLIQggBSAAayEKIAhBCGohByADIAVPBEAgBSEGDAELIAsgDk0EQCAFIQYMAQsDQCAFQQFrIgYtAAAgAEEBayIALQAARwRAIAUhBgwCCyAHQQFqIQcgAyAGTw0BIAYhBSAAIBFLDQALCyAKQQNqIRIgBiADayEJIAEoAgwhAAJAAkAgBiAQTQRAIAAgA/0AAAD9CwAAIAEoAgwhACAJQRBNBEAgASAAIAlqNgIMIAEoAgQhAwwDCyAAIAP9AAAQ/QsAECAJQSFIDQEgACAJaiEFIANBEGohAyAAQSBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALDAELIAMgEE0EQCAAIAP9AAAA/QsAACAAIBAgA2siCGohBSAIQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAFSQ0ACwsgECEDIAUhAAsgAyAGTw0AQQAhCCADIQUgBiADa0EHcSILBEADQCAAIAUtAAA6AAAgAEEBaiEAIAVBAWohBSAIQQFqIgggC0cNAAsLIAMgBmtBeEsNAANAIAAgBS0AADoAACAAIAUtAAE6AAEgACAFLQACOgACIAAgBS0AAzoAAyAAIAUtAAQ6AAQgACAFLQAFOgAFIAAgBS0ABjoABiAAIAUtAAc6AAcgAEEIaiEAIAVBCGoiBSAGRw0ACwsgASABKAIMIAlqNgIMIAEoAgQhAyAJQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIBI2AgAgAyAJOwEEIAQhCCAKIQQgB0EDayIAQYCABEkNAQsgAUECNgIkIAEgAyABKAIAa0EDdTYCKCAKIQQLIAMgADsBBiABIANBCGoiADYCBCAZIAYgB2oiA0kEQCADIQUMAQsgFyAPIBNBAmoiBWopAAAiJELjyJW9y5vvjU9+ICWIp0ECdGogBTYCACAXIANBAmsiBikAAELjyJW9y5vvjU9+ICWIp0ECdGogBiAPazYCACAbICRCgIDs/Mub741PfiAniKdBAnRqIAU2AgAgGyADQQFrIgUpAABCgIDs/Mub741PfiAniKdBAnRqIAUgD2s2AgAgBCEHIAghBgNAAkAgBiEEIAchBiADIA9rIgggBGsiBSAOa0F8Sw0AIBYgDyAFIA5JIgcbIAVqIgUoAAAgAygAAEcNACADQQRqIAVBBGogDCAVIAwgBxsgERDQCyEFIAMgEE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQALIABBATYCACAAQQA7AQQgBUEBaiIHQYCABE8EQCABQQI2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAc7AQYgASAAQQhqIgA2AgQgGyADKQAAIiRCgIDs/Mub741PfiAniKdBAnRqIAg2AgAgFyAkQuPIlb3Lm++NT34gJYinQQJ0aiAINgIAIAQhByAGIQggAyAFakEEaiIDIQUgAyAZTQ0BDAILCyAEIQggBiEEIAMhBQsgBSAZSQ0ACwwBCwJAIBNFDQAgB0EeSQRAQQQgB3QhBUEAIQADQCAAQUBrIgAgBUkNAAsLIAZBHUsNAEEEIAZ0IQVBACEAA0AgAEFAayIAIAVJDQALCyADIBAgFkZqIgUgGU8NACALIBRqIRYgDEEBayEcIAxBA2shDSAMQSBrIRBBOCAGa60hKUE4IAdrrSEoQcAAIAlrrSEnQcAAIAprrSElA0AgFyAFKQAAIiRC48iVvcub741PfiImICWIp0ECdGoiACgCACELIBsgJEKAgIDYy5vvjU9+IiogJ4inQQJ0aiIGKAIAIQkgICAmICiIpyIKQQZ2Qfz//x9xaigCACEHICEgKiApiKciHkEGdkH8//8fcWooAgAhEiAGIAUgD2siEzYCACAAIBM2AgACQAJAAkACQCATQQFqIh8gBGsiACAOa0F8Sw0AIBQgACAYa2ogACAPaiAAIA5JIgAbIgYoAAAgBSgAAUcNACAFQQVqIAZBBGogDCAVIAwgABsgERDQCyESIAVBAWoiBiADayEJIAEoAgwhAAJAAkAgBiAQTQRAIAAgA/0AAAD9CwAAIAEoAgwhACAJQRBNBEAgASAAIAlqNgIMIAEoAgQhAwwDCyAAIAP9AAAQ/QsAECAJQSFIDQEgACAJaiEFIANBEGohAyAAQSBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALDAELIAMgEE0EQCAAIAP9AAAA/QsAACAAIBAgA2siC2ohByALQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAHSQ0ACwsgECEDIAchAAsgAyAGTw0AQQAhByAFIANrIgpBAWpBB3EiCwRAA0AgACADLQAAOgAAIABBAWohACADQQFqIQMgB0EBaiIHIAtHDQALCyAKQQdJDQADQCAAIAMtAAA6AAAgACADLQABOgABIAAgAy0AAjoAAiAAIAMtAAM6AAMgACADLQAEOgAEIAAgAy0ABToABSAAIAMtAAY6AAYgACADLQAHOgAHIABBCGohACADQQdqIQcgA0EIaiEDIAUgB0cNAAsLIAEgASgCDCAJajYCDCABKAIEIQMgCUGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgEkEEaiEHIANBATYCACADIAk7AQQgBCEKIBJBAWoiAEH//wNLDQEMAgsCQAJ/AkACQCALIA5JDQAgCyAPaiIAKQAAICRSDQAgAEEIaiEGIA0gBUEIaiIKTQRAIAohCAwCCyAGKAAAIgcgCiIIKAAAIglHBEAgByAJc2hBA3YMAwsDQCAGQQRqIQYgCEEEaiIIIA1PDQIgBigAACIHIAgoAAAiCUYNAAsgCCAHIAlzaEEDdmogCmsMAgsCQCAHIApzQf8BcQ0AIAdBCHYiBiAdTQ0AIAYgFGoiACkAACAkUg0AIAVBCGogAEEIaiAMIBUgERDQC0EIaiEHIBMgBiAYamshCiADIAVPBEAgBSEGDAQLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMBQsgB0EBaiEHIAMgBk8NBCAGIQUgACAaSw0ACwwDCwJAAkAgCSAOSwRAIAkgD2oiACgAACAFKAAARg0BDAILIBIgHnNB/wFxDQEgEkEIdiIGIB1NDQEgBiAUaiIAKAAAIAUoAABHDQEgBiAYaiEJCyAXIAUpAAEiJkLjyJW9y5vvjU9+IiQgJYinQQJ0aiIIKAIAIQsgICAkICiIpyIKQQZ2Qfz//x9xaigCACEHIAggHzYCACAFQQFqIQYCfwJAAkAgCyAOSQ0AIAsgD2oiCCkAACAmUg0AIAhBCGohByANIAVBCWoiCk0EQCAKIQAMAgsgBygAACIFIAoiACgAACIJRwRAIAUgCXNoQQN2DAMLA0AgB0EEaiEHIABBBGoiACANTw0CIAcoAAAiBSAAKAAAIglGDQALIAAgBSAJc2hBA3ZqIAprDAILAkAgByAKc0H/AXENACAHQQh2IgsgHU0NACALIBRqIggpAAAgJlINACAFQQlqIAhBCGogDCAVIBEQ0AtBCGohByAfIAsgGGprIQogAyAGTw0GA0AgBkEBayIALQAAIAhBAWsiCC0AAEcNByAHQQFqIQcgACADTQRAIAAhBgwICyAAIQYgCCAaSw0ACwwGCyAAQQRqIQYgBUEEaiEHIAkgDkkEQCAHIAYgDCAVIBEQ0AtBBGohByATIAlrIQogAyAFTwRAIAUhBgwHCyAAIBpNBEAgBSEGDAcLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMCAsgB0EBaiEHIAMgBk8NByAGIQUgACAaSw0ACwwGCyAFIABrIQoCfwJAIAcgDU8EQCAHIQgMAQsgByEIIAYoAAAiCyAmQhiIpyIJRwRAIAkgC3NoQQN2DAILA0AgBkEEaiEGIAhBBGoiCCANTw0BIAYoAAAiCyAIKAAAIglGDQALIAggCSALc2hBA3ZqIAdrDAELAkAgCCAcTw0AIAYvAAAgCC8AAEcNACAGQQJqIQYgCEECaiEICyAIIAxJBH8gCCAGLQAAIAgtAABGagUgCAsgB2sLQQRqIQcgAyAFTwRAIAUhBgwGCyAAIBFNBEAgBSEGDAYLA0AgBUEBayIGLQAAIABBAWsiAC0AAEcEQCAFIQYMBwsgB0EBaiEHIAMgBk8NBiAGIQUgACARSw0ACwwFCwJAIAAgHE8NACAHLwAAIAAvAABHDQAgB0ECaiEHIABBAmohAAsgACAMSQR/IAAgBy0AACAALQAARmoFIAALIAprCyEAIAYgCGshCiAAQQhqIQcgAyAGTw0DIAsgDk0NAwNAIAZBAWsiAC0AACAIQQFrIggtAABHDQQgB0EBaiEHIAAgA00EQCAAIQYMBQsgACEGIAggEUsNAAsMAwsgBSAFIANrQQh1akEBaiEFDAULAkAgCCAcTw0AIAYvAAAgCC8AAEcNACAGQQJqIQYgCEECaiEICyAIIAxJBH8gCCAGLQAAIAgtAABGagUgCAsgCmsLIQggBSAAayEKIAhBCGohByADIAVPBEAgBSEGDAELIAsgDk0EQCAFIQYMAQsDQCAFQQFrIgYtAAAgAEEBayIALQAARwRAIAUhBgwCCyAHQQFqIQcgAyAGTw0BIAYhBSAAIBFLDQALCyAKQQNqIRIgBiADayEJIAEoAgwhAAJAAkAgBiAQTQRAIAAgA/0AAAD9CwAAIAEoAgwhACAJQRBNBEAgASAAIAlqNgIMIAEoAgQhAwwDCyAAIAP9AAAQ/QsAECAJQSFIDQEgACAJaiEFIANBEGohAyAAQSBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALDAELIAMgEE0EQCAAIAP9AAAA/QsAACAAIBAgA2siCGohBSAIQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAFSQ0ACwsgECEDIAUhAAsgAyAGTw0AQQAhCCADIQUgBiADa0EHcSILBEADQCAAIAUtAAA6AAAgAEEBaiEAIAVBAWohBSAIQQFqIgggC0cNAAsLIAMgBmtBeEsNAANAIAAgBS0AADoAACAAIAUtAAE6AAEgACAFLQACOgACIAAgBS0AAzoAAyAAIAUtAAQ6AAQgACAFLQAFOgAFIAAgBS0ABjoABiAAIAUtAAc6AAcgAEEIaiEAIAVBCGoiBSAGRw0ACwsgASABKAIMIAlqNgIMIAEoAgQhAyAJQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIBI2AgAgAyAJOwEEIAQhCCAKIQQgB0EDayIAQYCABEkNAQsgAUECNgIkIAEgAyABKAIAa0EDdTYCKCAKIQQLIAMgADsBBiABIANBCGoiADYCBCAZIAYgB2oiA0kEQCADIQUMAQsgFyAPIBNBAmoiBWopAAAiJELjyJW9y5vvjU9+ICWIp0ECdGogBTYCACAXIANBAmsiBikAAELjyJW9y5vvjU9+ICWIp0ECdGogBiAPazYCACAbICRCgICA2Mub741PfiAniKdBAnRqIAU2AgAgGyADQQFrIgUpAABCgICA2Mub741PfiAniKdBAnRqIAUgD2s2AgAgBCEHIAghBgNAAkAgBiEEIAchBiADIA9rIgggBGsiBSAOa0F8Sw0AIBYgDyAFIA5JIgcbIAVqIgUoAAAgAygAAEcNACADQQRqIAVBBGogDCAVIAwgBxsgERDQCyEFIAMgEE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQALIABBATYCACAAQQA7AQQgBUEBaiIHQYCABE8EQCABQQI2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAc7AQYgASAAQQhqIgA2AgQgGyADKQAAIiRCgICA2Mub741PfiAniKdBAnRqIAg2AgAgFyAkQuPIlb3Lm++NT34gJYinQQJ0aiAINgIAIAQhByAGIQggAyAFakEEaiIDIQUgAyAZTQ0BDAILCyAEIQggBiEEIAMhBQsgBSAZSQ0ACwsgAiAINgIEIAIgBDYCACAMIANrC5sDAQV/IAMgAQJ/AkACQCAAIgUgAyABIgZraiIHIAIgAiAHSxsiCUEDayIHIAVNDQAgBigAACIFIAAoAAAiBkcNASABIQYgACEFA0AgBkEEaiEGIAVBBGoiBSAHTw0BIAYoAAAiCCAFKAAAIgFGDQALIAUgASAIc2hBA3ZqIABrDAILAkAgBSAJQQFrTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIAlJBH8gBSAGLQAAIAUtAABGagUgBQsgAGsMAQsgBSAGc2hBA3YLIgZqRgR/An8CQCAAIAZqIgggAkEDayIATwRAIAghBQwBCyAEKAAAIgUgCCgAACIHRgRAIAghBQNAIARBBGohBCAFQQRqIgUgAE8NAiAEKAAAIgcgBSgAACIBRg0ACyAFIAEgB3NoQQN2aiAIawwCCyAFIAdzaEEDdgwBCwJAIAUgAkEBa08NACAELwAAIAUvAABHDQAgBEECaiEEIAVBAmohBQsgAiAFSwR/IAUgBC0AACAFLQAARmoFIAULIAhrCyAGagUgBgsLzxsCF38DfgJAAkAgACgCECIJIAMgACgCBCIPayAEaiIFQQEgACgCuAF0IgZrIAkgBSAJayAGSxsgACgCGBsiECAAKAIMIgVJBEAgAigCBCEHIAIoAgAhCSADIAMgBGoiDUEIayIZSQ0BIAMhAAwCCyAAIAEgAiADIAQQzgsPCyAAKAIIIhUgBSAQIAUgEEsbIhFqIRYgDyARaiESIBAgFWohGiAAKAJkIRQgACgCXCEXIA1BIGshDEEgIAAoArwBIgRrIRhBwAAgACgCwAFrrSEeQcAAIARrrSEdQQQgACgCyAEiACAAQQVrQQNPG0EEayEbIAMhAANAAn8CQAJAAkACQCAbQQFrDgMBAgMACyADKQAAIRwgAygAAEGx893xeWwgGHYMAwsgAykAACIcQoCAgNjLm++NT34gHYinDAILIAMpAAAiHEKAgOz8y5vvjU9+IB2IpwwBCyADKQAAIhxCgMaV/cub741PfiAdiKcLIQQgFyAcQuPIlb3Lm++NT34gHoinQQJ0aiIGKAIAIQUgFCAEQQJ0aiIEKAIAIQogBiADIA9rIg42AgAgBCAONgIAAkACQAJAAkACQAJAIAkgDkEBaiILIBBrSw0AIAsgCWsiBCARa0F8Sw0AIBUgDyAEIBFJIgYbIARqIgQoAAAgAygAAUcNACADQQVqIARBBGogDSAWIA0gBhsgEhDQCyEIIANBAWoiBSAAayELIAEoAgwhBAJAAkAgBSAMTQRAIAQgAP0AAAD9CwAAIAEoAgwhBCALQRBNBEAgASAEIAtqNgIMIAEoAgQhAAwDCyAEIAD9AAAQ/QsAECALQSFIDQEgBCALaiEDIABBEGohACAEQSBqIQQDQCAEIAD9AAAQ/QsAACAEIAD9AAAg/QsAECAAQSBqIQAgBEEgaiIEIANJDQALDAELIAAgDE0EQCAEIAD9AAAA/QsAACAEIAwgAGsiCmohBiAKQRFOBEAgBEEQaiEEA0AgBCAA/QAAEP0LAAAgBCAA/QAAIP0LABAgAEEgaiEAIARBIGoiBCAGSQ0ACwsgBiEEIAwhAAsgACAFTw0AQQAhBiADIABrIhNBAWpBB3EiCgRAA0AgBCAALQAAOgAAIARBAWohBCAAQQFqIQAgBkEBaiIGIApHDQALCyATQQdJDQADQCAEIAAtAAA6AAAgBCAALQABOgABIAQgAC0AAjoAAiAEIAAtAAM6AAMgBCAALQAEOgAEIAQgAC0ABToABSAEIAAtAAY6AAYgBCAALQAHOgAHIARBCGohBCAAQQdqIQYgAEEIaiEAIAMgBkcNAAsLIAEgASgCDCALajYCDCABKAIEIQAgC0GAgARJDQAgAUEBNgIkIAEgACABKAIAa0EDdTYCKAsgCEEEaiEGIABBATYCACAAIAs7AQQgCSEKIAhBAWoiBEH//wNLDQEMAgsCQCAFIBBNDQAgFSAPIAUgEUkiCBsgBWoiBCkAACAcUg0AIANBCGogBEEIaiANIBYgDSAIGyASENALQQhqIQYgDiAFayEKAkAgGiASIAgbIgcgBE8EQCADIQUMAQsgAyEFIAAgA08NAANAIANBAWsiBS0AACAEQQFrIgQtAABHBEAgAyEFDAILIAZBAWohBiAEIAdNDQEgBSIDIABLDQALCyAKQQNqIRMgBSAAayEIIAEoAgwhBAJAAkAgBSAMTQRAIAQgAP0AAAD9CwAAIAEoAgwhBCAIQRBNBEAgASAEIAhqNgIMIAEoAgQhAAwDCyAEIAD9AAAQ/QsAECAIQSFIDQEgBCAIaiEDIABBEGohACAEQSBqIQQDQCAEIAD9AAAQ/QsAACAEIAD9AAAg/QsAECAAQSBqIQAgBEEgaiIEIANJDQALDAELIAAgDE0EQCAEIAD9AAAA/QsAACAEIAwgAGsiB2ohAyAHQRFOBEAgBEEQaiEEA0AgBCAA/QAAEP0LAAAgBCAA/QAAIP0LABAgAEEgaiEAIARBIGoiBCADSQ0ACwsgAyEEIAwhAAsgACAFTw0AQQAhByAAIQMgBSAAa0EHcSILBEADQCAEIAMtAAA6AAAgBEEBaiEEIANBAWohAyAHQQFqIgcgC0cNAAsLIAAgBWtBeEsNAANAIAQgAy0AADoAACAEIAMtAAE6AAEgBCADLQACOgACIAQgAy0AAzoAAyAEIAMtAAQ6AAQgBCADLQAFOgAFIAQgAy0ABjoABiAEIAMtAAc6AAcgBEEIaiEEIANBCGoiAyAFRw0ACwsgASABKAIMIAhqNgIMIAEoAgQhACAIQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAAIBM2AgAgACAIOwEEIAkhByAKIQkgBkEDayIEQf//A0sNAQwCCyAKIBBNDQIgFSAPIAogEUkiBRsgCmoiBCgAACADKAAARw0CIBcgAykAASIcQuPIlb3Lm++NT34gHoinQQJ0aiIGKAIAIQggBiALNgIAAkACQCAIIBBNDQAgFSAPIAggEUkiExsgCGoiBykAACAcUg0AIANBAWohBSADQQlqIAdBCGogDSAWIA0gExsgEhDQC0EIaiEGIAsgCGshCiAHIBogEiATGyIDTQ0BIAAgBU8NAQNAIAVBAWsiBC0AACAHQQFrIgctAABHDQIgBkEBaiEGIAMgB08EQCAEIQUMAwsgBCEFIAAgBEkNAAsMAQsgA0EEaiAEQQRqIA0gFiANIAUbIBIQ0AtBBGohBiAOIAprIQogGiASIAUbIgcgBE8EQCADIQUMAQsgACADTwRAIAMhBQwBCwNAIANBAWsiBS0AACAEQQFrIgQtAABHBEAgAyEFDAILIAZBAWohBiAEIAdNDQEgBSIDIABLDQALCyAKQQNqIRMgBSAAayEIIAEoAgwhBAJAAkAgBSAMTQRAIAQgAP0AAAD9CwAAIAEoAgwhBCAIQRBNBEAgASAEIAhqNgIMIAEoAgQhAAwDCyAEIAD9AAAQ/QsAECAIQSFIDQEgBCAIaiEDIABBEGohACAEQSBqIQQDQCAEIAD9AAAQ/QsAACAEIAD9AAAg/QsAECAAQSBqIQAgBEEgaiIEIANJDQALDAELIAAgDE0EQCAEIAD9AAAA/QsAACAEIAwgAGsiB2ohAyAHQRFOBEAgBEEQaiEEA0AgBCAA/QAAEP0LAAAgBCAA/QAAIP0LABAgAEEgaiEAIARBIGoiBCADSQ0ACwsgAyEEIAwhAAsgACAFTw0AQQAhByAAIQMgBSAAa0EHcSILBEADQCAEIAMtAAA6AAAgBEEBaiEEIANBAWohAyAHQQFqIgcgC0cNAAsLIAAgBWtBeEsNAANAIAQgAy0AADoAACAEIAMtAAE6AAEgBCADLQACOgACIAQgAy0AAzoAAyAEIAMtAAQ6AAQgBCADLQAFOgAFIAQgAy0ABjoABiAEIAMtAAc6AAcgBEEIaiEEIANBCGoiAyAFRw0ACwsgASABKAIMIAhqNgIMIAEoAgQhACAIQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAAIBM2AgAgACAIOwEEIAkhByAKIQkgBkEDayIEQf//A00NAQsgAUECNgIkIAEgACABKAIAa0EDdTYCKCAKIQkLIAAgBDsBBiABIABBCGoiBDYCBCAZIAUgBmoiAEkEQCAAIQMMAwsgFyAPIA5BAmoiA2oiBikAACIcQuPIlb3Lm++NT34gHoinQQJ0aiADNgIAIBcgAEECayIFKQAAQuPIlb3Lm++NT34gHoinQQJ0aiAFIA9rNgIAIBQCfwJAAkACQAJAIBtBAWsOAwABAgMLIBQgHEKAgIDYy5vvjU9+IB2Ip0ECdGogAzYCACAAQQFrIgMpAABCgICA2Mub741PfiAdiKcMAwsgFCAcQoCA7PzLm++NT34gHYinQQJ0aiADNgIAIABBAWsiAykAAEKAgOz8y5vvjU9+IB2IpwwCCyAUIBxCgMaV/cub741PfiAdiKdBAnRqIAM2AgAgAEEBayIDKQAAQoDGlf3Lm++NT34gHYinDAELIBQgBigAAEGx893xeWwgGHZBAnRqIAM2AgAgAEEBayIDKAAAQbHz3fF5bCAYdgtBAnRqIAMgD2s2AgAgCSEOIAchBQNAIAUhCSAOIQUgCSAAIA9rIgMgEGtLDQIgAyAJayIGIBFrQXxLDQIgFSAPIAYgEUkiDhsgBmoiBigAACAAKAAARw0CIABBBGogBkEEaiANIBYgDSAOGyASENALIQYgACAMTQRAIAEoAgwgAP0AAAD9CwAAIAEoAgQhBAsgBEEBNgIAIARBADsBBCAGQQFqIg5BgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgDjsBBiABIARBCGoiBDYCBCAUAn8CQAJAAkACQCAbQQFrDgMBAgMACyAAKQAAIRwgACgAAEGx893xeWwgGHYMAwsgACkAACIcQoCAgNjLm++NT34gHYinDAILIAApAAAiHEKAgOz8y5vvjU9+IB2IpwwBCyAAKQAAIhxCgMaV/cub741PfiAdiKcLQQJ0aiADNgIAIBcgHELjyJW9y5vvjU9+IB6Ip0ECdGogAzYCACAJIQ4gBSEHIAAgBmpBBGoiACEDIAAgGU0NAAsMAgsgAyADIABrQQh1akEBaiEDDAELIAkhByAFIQkgACEDCyADIBlJDQALCyACIAc2AgQgAiAJNgIAIA0gAGsL7HgCHn8CfkEAIAIoAgAiHyAfIAMgAyAAKAIEIg8gACgCDCIOIAMgD2sgBGoiBUEBIAAoArgBIgl0IgZrIA4gBSAOayAGSxsgACgCGCINGyIVaiIbRmoiBSAPayIMIA4gDCAGayAOIAwgDmsgBksbIA0bayIOSyIgGyEMQQAgAigCBCIhIA4gIUkiIhshECAFQQEgACgCzAEiDiAOQQFNG0EBaiIZaiINQQFqIQYgD0ECaiEcIAMgBGoiEUEIayEEIAAoAlwhDiAAKALIASEHAkACQAJAAkAgCUESTQRAAkAgB0EFaw4DBAMCAAsgBCAGTQ0EIBFBIGshGiARQQFrIR0gEUEDayEWQSAgACgCwAFrIRMDQEEAIAxrIRcgBUGAAWohGCAFQQFqIQggDiAFKAAAQbHz3fF5bCATdiIJQQJ0aigCACEAIAUoAAEhFCAZIQsCQAJAA0ACQCAGIQogDSIHIBdqIh4oAAAhEiAOIAlBAnRqIAUgD2siDTYCACAUQbHz3fF5bCATdiEJAn8CQCAMQQAgEiAHKAAAIgZGG0UEQAJAAkACQCAFKAAAQcT9MSAAIA9qIAAgFUkbKAAARgRAIAAgFU8EQCAIIQcgBSEIDAILIAcoAAAhBgsgDiAJQQJ0aiIFKAIAIQAgBSAIIA9rIg02AgAgBkGx893xeWwgE3YhCSAIKAAAQcT9MSAAIA9qIAAgFUkiBRsoAABHDQIgBQ0CIAtBBU8NAQsgDiAJQQJ0aiAHIA9rNgIACyAIIAAgD2oiC2siB0EDaiEKQQQhCSAAIBVLDQQMBgsgDiAJQQJ0aiEFIAcgC2oiDSAYTw0BIAsMAgsgHkEBay0AACEFIAdBAWstAAAhBiAOIAlBAnRqIAggD2s2AgBBBUEEIAUgBkYiBRshCSAeIAVrIQsgByAFayEIQQEhCgwFCyAYQYABaiEYIAtBAWoLIQggCiALaiEGIAUoAgAhACAKKAAAIRQgCCELIAohCCAHIQUgBCAGSw0BDAkLCyADIAhPDQADQCAIQQFrIgUtAAAgC0EBayIGLQAARw0BIAlBAWohCSADIAVJBEAgBSEIIAYhCyAGIBtLDQELCyAMIRAgBiELIAchDCAFIQgMAQsgDCEQIAchDAsgCSALaiEGAn8CQCAWIAggCWoiC00EQCALIQUMAQsgBigAACIAIAsiBSgAACIHRwRAIAAgB3NoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAWTw0BIAYoAAAiACAFKAAAIgdGDQALIAUgACAHc2hBA3ZqIAtrDAELAkAgBSAdTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgC2sLIQUgCCADayEHIAUgCWohCyABKAIMIQUCQAJAIAggGk0EQCAFIAP9AAAA/QsAACABKAIMIQUgB0EQTQRAIAEgBSAHajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgB0EhSA0BIAUgB2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBpNBEAgBSAD/QAAAP0LAAAgBSAaIANrIgBqIQYgAEERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSAaIQMLIAMgCE8NAEEAIQAgAyEGIAggA2tBB3EiCQRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgAEEBaiIAIAlHDQALCyADIAhrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCEcNAAsLIAEgASgCDCAHajYCDCABKAIEIQMgB0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAKNgIAIAMgBzsBBCALQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiADYCBAJAIAggC2oiAyAESw0AIA4gDSAcaigAAEGx893xeWwgE3ZBAnRqIA1BAmo2AgAgDiADQQJrIgUoAABBsfPd8XlsIBN2QQJ0aiAFIA9rNgIAIBAEQCAMIQUgECEIA0AgCCEMIAUhCCADKAAAIhAgAyAMaygAAEcEQCAMIRAgBSEMDAMLIANBBGoiDSAMayEGAn8CQCANIBZPBEAgDSEFDAELIAYoAAAiCSANIgUoAAAiB0cEQCAHIAlzaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgFk8NASAGKAAAIgkgBSgAACIHRg0ACyAFIAcgCXNoQQN2aiANawwBCwJAIAUgHU8NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSARSQR/IAUgBi0AACAFLQAARmoFIAULIA1rCyEFIA4gEEGx893xeWwgE3ZBAnRqIAMgD2s2AgAgAyAFaiEGIAMgGk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQALIAZBBGohAyAAQQE2AgAgAEEAOwEEIAVBAWoiBUGAgARPBEAgAUECNgIkIAEgACABKAIAa0EDdTYCKAsgACAFOwEGIAEgAEEIaiIANgIEIAwhBSAIIRAgAyAETQ0ACwwBC0EAIRALIBkgAyIFaiINQQFqIgYgBEkNAAsMBAsCQAJAAkACQCAHQQVrDgMDAgEACyAEIAZNDQYgEUEgayEaIBFBAWshHSARQQNrIRZBICAAKALAAWshEwNAQQAgDGshFyAFQYABaiEYIAVBAWohCiAOIAUoAABBsfPd8XlsIBN2IgBBAnRqKAIAIQkgBSgAASEUIBkhCAJAAkADQAJAIAYhCyANIgcgF2oiHigAACESIA4gAEECdGogBSAPayINNgIAIBRBsfPd8XlsIBN2IQACfwJAIAxBACASIAcoAAAiBkYbRQRAAkACQAJAAkAgCSAVSQ0AIAUoAAAgCSAPaigAAEcNACAKIQcgBSEKDAELIA4gAEECdGoiBSgCACEJIAUgCiAPayINNgIAIAZBsfPd8XlsIBN2IQAgCSAVSQ0CIAooAAAgCSAPaigAAEcNAiAIQQVPDQELIA4gAEECdGogByAPazYCAAsgCiAJIA9qIghrIgdBA2ohC0EEIQAgCSAVSw0EDAYLIA4gAEECdGohBSAHIAhqIg0gGE8NASAIDAILIB5BAWstAAAhBSAHQQFrLQAAIQYgDiAAQQJ0aiAKIA9rNgIAQQVBBCAFIAZGIgUbIQAgHiAFayEIIAcgBWshCkEBIQsMBQsgGEGAAWohGCAIQQFqCyEKIAggC2ohBiAFKAIAIQkgCygAACEUIAohCCALIQogByEFIAQgBksNAQwLCwsgAyAKTw0AA0AgCkEBayIFLQAAIAhBAWsiBi0AAEcNASAAQQFqIQAgAyAFSQRAIAUhCiAGIQggBiAbSw0BCwsgDCEQIAYhCCAHIQwgBSEKDAELIAwhECAHIQwLIAAgCGohBgJ/AkAgFiAAIApqIghNBEAgCCEFDAELIAYoAAAiCSAIIgUoAAAiB0cEQCAHIAlzaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgFk8NASAGKAAAIgkgBSgAACIHRg0ACyAFIAcgCXNoQQN2aiAIawwBCwJAIAUgHU8NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSARSQR/IAUgBi0AACAFLQAARmoFIAULIAhrCyEFIAogA2shByAAIAVqIQggASgCDCEFAkACQCAKIBpNBEAgBSAD/QAAAP0LAAAgASgCDCEFIAdBEE0EQCABIAUgB2o2AgwgASgCBCEDDAMLIAUgA/0AABD9CwAQIAdBIUgNASAFIAdqIQYgA0EQaiEDIAVBIGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsMAQsgAyAaTQRAIAUgA/0AAAD9CwAAIAUgGiADayIAaiEGIABBEU4EQCAFQRBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALCyAGIQUgGiEDCyADIApPDQBBACEAIAMhBiAKIANrQQdxIgkEQANAIAUgBi0AADoAACAFQQFqIQUgBkEBaiEGIABBAWoiACAJRw0ACwsgAyAKa0F4Sw0AA0AgBSAGLQAAOgAAIAUgBi0AAToAASAFIAYtAAI6AAIgBSAGLQADOgADIAUgBi0ABDoABCAFIAYtAAU6AAUgBSAGLQAGOgAGIAUgBi0ABzoAByAFQQhqIQUgBkEIaiIGIApHDQALCyABIAEoAgwgB2o2AgwgASgCBCEDIAdBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgCzYCACADIAc7AQQgCEEDayIFQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAU7AQYgASADQQhqIgA2AgQCQCAIIApqIgMgBEsNACAOIA0gHGooAABBsfPd8XlsIBN2QQJ0aiANQQJqNgIAIA4gA0ECayIFKAAAQbHz3fF5bCATdkECdGogBSAPazYCACAQBEAgDCEFIBAhCANAIAghDCAFIQggAygAACIQIAMgDGsoAABHBEAgDCEQIAUhDAwDCyADQQRqIg0gDGshBgJ/AkAgDSAWTwRAIA0hBQwBCyAGKAAAIgkgDSIFKAAAIgdHBEAgByAJc2hBA3YMAgsDQCAGQQRqIQYgBUEEaiIFIBZPDQEgBigAACIJIAUoAAAiB0YNAAsgBSAHIAlzaEEDdmogDWsMAQsCQCAFIB1PDQAgBi8AACAFLwAARw0AIAZBAmohBiAFQQJqIQULIAUgEUkEfyAFIAYtAAAgBS0AAEZqBSAFCyANawshBSAOIBBBsfPd8XlsIBN2QQJ0aiADIA9rNgIAIAMgBWohBiADIBpNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEACyAGQQRqIQMgAEEBNgIAIABBADsBBCAFQQFqIgVBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBTsBBiABIABBCGoiADYCBCAMIQUgCCEQIAMgBE0NAAsMAQtBACEQCyAZIAMiBWoiDUEBaiIGIARJDQALDAYLIAQgBk0NBSARQSBrIRIgEUEBayEXIBFBA2shFEHAACAAKALAAWutISMDQEEAIAxrIRggBUGAAWohEyAFQQFqIQogDiAFKQAAQoDGlf3Lm++NT34gI4inIgBBAnRqKAIAIQkgBSkAASEkIBkhCAJAAkADQAJAIAYhCyANIgcgGGoiFigAACEGIA4gAEECdGogBSAPayINNgIAICRCgMaV/cub741PfiAjiKchAAJ/AkACQCAMBEAgBygAACAGRg0BCwJAAkACQAJAIAkgFUkNACAFKAAAIAkgD2ooAABHDQAgCiEHIAUhCgwBCyAOIABBAnRqIgUoAgAhCSAHKQAAISQgBSAKIA9rIg02AgAgJEKAxpX9y5vvjU9+ICOIpyEAIAkgFUkNAiAKKAAAIAkgD2ooAABHDQIgCEEFTw0BCyAOIABBAnRqIAcgD2s2AgALIAogCSAPaiIIayIHQQNqIQtBBCEAIAkgFUsNBAwGCyAOIABBAnRqIQUgByAIaiINIBNPDQEgCAwCCyAWQQFrLQAAIQUgB0EBay0AACEGIA4gAEECdGogCiAPazYCAEEFQQQgBSAGRiIFGyEAIBYgBWshCCAHIAVrIQpBASELDAULIBNBgAFqIRMgCEEBagshCiAIIAtqIQYgBSgCACEJIAspAAAhJCAKIQggCyEKIAchBSAEIAZLDQEMCgsLIAMgCk8NAANAIApBAWsiBS0AACAIQQFrIgYtAABHDQEgAEEBaiEAIAMgBUkEQCAFIQogBiEIIAYgG0sNAQsLIAwhECAGIQggByEMIAUhCgwBCyAMIRAgByEMCyAAIAhqIQYCfwJAIBQgACAKaiIITQRAIAghBQwBCyAGKAAAIgkgCCIFKAAAIgdHBEAgByAJc2hBA3YMAgsDQCAGQQRqIQYgBUEEaiIFIBRPDQEgBigAACIJIAUoAAAiB0YNAAsgBSAHIAlzaEEDdmogCGsMAQsCQCAFIBdPDQAgBi8AACAFLwAARw0AIAZBAmohBiAFQQJqIQULIAUgEUkEfyAFIAYtAAAgBS0AAEZqBSAFCyAIawshBSAKIANrIQcgACAFaiEIIAEoAgwhBQJAAkAgCiASTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSAHQRBNBEAgASAFIAdqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECAHQSFIDQEgBSAHaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgEk0EQCAFIAP9AAAA/QsAACAFIBIgA2siAGohBiAAQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBIhAwsgAyAKTw0AQQAhACADIQYgCiADa0EHcSIJBEADQCAFIAYtAAA6AAAgBUEBaiEFIAZBAWohBiAAQQFqIgAgCUcNAAsLIAMgCmtBeEsNAANAIAUgBi0AADoAACAFIAYtAAE6AAEgBSAGLQACOgACIAUgBi0AAzoAAyAFIAYtAAQ6AAQgBSAGLQAFOgAFIAUgBi0ABjoABiAFIAYtAAc6AAcgBUEIaiEFIAZBCGoiBiAKRw0ACwsgASABKAIMIAdqNgIMIAEoAgQhAyAHQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAs2AgAgAyAHOwEEIAhBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIANgIEAkAgCCAKaiIDIARLDQAgDiANIBxqKQAAQoDGlf3Lm++NT34gI4inQQJ0aiANQQJqNgIAIA4gA0ECayIFKQAAQoDGlf3Lm++NT34gI4inQQJ0aiAFIA9rNgIAIBAEQCAMIQUgECEIA0AgCCEMIAUhCCADKAAAIAMgDGsoAABHBEAgDCEQIAUhDAwDCyADQQRqIg0gDGshBgJ/AkAgDSAUTwRAIA0hBQwBCyAGKAAAIgkgDSIFKAAAIgdHBEAgByAJc2hBA3YMAgsDQCAGQQRqIQYgBUEEaiIFIBRPDQEgBigAACIJIAUoAAAiB0YNAAsgBSAHIAlzaEEDdmogDWsMAQsCQCAFIBdPDQAgBi8AACAFLwAARw0AIAZBAmohBiAFQQJqIQULIAUgEUkEfyAFIAYtAAAgBS0AAEZqBSAFCyANawshBSAOIAMpAABCgMaV/cub741PfiAjiKdBAnRqIAMgD2s2AgAgAyAFaiEGIAMgEk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQALIAZBBGohAyAAQQE2AgAgAEEAOwEEIAVBAWoiBUGAgARPBEAgAUECNgIkIAEgACABKAIAa0EDdTYCKAsgACAFOwEGIAEgAEEIaiIANgIEIAwhBSAIIRAgAyAETQ0ACwwBC0EAIRALIBkgAyIFaiINQQFqIgYgBEkNAAsMBQsgBCAGTQ0EIBFBIGshEiARQQFrIRcgEUEDayEUQcAAIAAoAsABa60hIwNAQQAgDGshGCAFQYABaiETIAVBAWohCiAOIAUpAABCgIDs/Mub741PfiAjiKciAEECdGooAgAhCSAFKQABISQgGSEIAkACQANAAkAgBiELIA0iByAYaiIWKAAAIQYgDiAAQQJ0aiAFIA9rIg02AgAgJEKAgOz8y5vvjU9+ICOIpyEAAn8CQAJAIAwEQCAHKAAAIAZGDQELAkACQAJAAkAgCSAVSQ0AIAUoAAAgCSAPaigAAEcNACAKIQcgBSEKDAELIA4gAEECdGoiBSgCACEJIAcpAAAhJCAFIAogD2siDTYCACAkQoCA7PzLm++NT34gI4inIQAgCSAVSQ0CIAooAAAgCSAPaigAAEcNAiAIQQVPDQELIA4gAEECdGogByAPazYCAAsgCiAJIA9qIghrIgdBA2ohC0EEIQAgCSAVSw0EDAYLIA4gAEECdGohBSAHIAhqIg0gE08NASAIDAILIBZBAWstAAAhBSAHQQFrLQAAIQYgDiAAQQJ0aiAKIA9rNgIAQQVBBCAFIAZGIgUbIQAgFiAFayEIIAcgBWshCkEBIQsMBQsgE0GAAWohEyAIQQFqCyEKIAggC2ohBiAFKAIAIQkgCykAACEkIAohCCALIQogByEFIAQgBksNAQwJCwsgAyAKTw0AA0AgCkEBayIFLQAAIAhBAWsiBi0AAEcNASAAQQFqIQAgAyAFSQRAIAUhCiAGIQggBiAbSw0BCwsgDCEQIAYhCCAHIQwgBSEKDAELIAwhECAHIQwLIAAgCGohBgJ/AkAgFCAAIApqIghNBEAgCCEFDAELIAYoAAAiCSAIIgUoAAAiB0cEQCAHIAlzaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgFE8NASAGKAAAIgkgBSgAACIHRg0ACyAFIAcgCXNoQQN2aiAIawwBCwJAIAUgF08NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSARSQR/IAUgBi0AACAFLQAARmoFIAULIAhrCyEFIAogA2shByAAIAVqIQggASgCDCEFAkACQCAKIBJNBEAgBSAD/QAAAP0LAAAgASgCDCEFIAdBEE0EQCABIAUgB2o2AgwgASgCBCEDDAMLIAUgA/0AABD9CwAQIAdBIUgNASAFIAdqIQYgA0EQaiEDIAVBIGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsMAQsgAyASTQRAIAUgA/0AAAD9CwAAIAUgEiADayIAaiEGIABBEU4EQCAFQRBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALCyAGIQUgEiEDCyADIApPDQBBACEAIAMhBiAKIANrQQdxIgkEQANAIAUgBi0AADoAACAFQQFqIQUgBkEBaiEGIABBAWoiACAJRw0ACwsgAyAKa0F4Sw0AA0AgBSAGLQAAOgAAIAUgBi0AAToAASAFIAYtAAI6AAIgBSAGLQADOgADIAUgBi0ABDoABCAFIAYtAAU6AAUgBSAGLQAGOgAGIAUgBi0ABzoAByAFQQhqIQUgBkEIaiIGIApHDQALCyABIAEoAgwgB2o2AgwgASgCBCEDIAdBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgCzYCACADIAc7AQQgCEEDayIFQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAU7AQYgASADQQhqIgA2AgQCQCAIIApqIgMgBEsNACAOIA0gHGopAABCgIDs/Mub741PfiAjiKdBAnRqIA1BAmo2AgAgDiADQQJrIgUpAABCgIDs/Mub741PfiAjiKdBAnRqIAUgD2s2AgAgEARAIAwhBSAQIQgDQCAIIQwgBSEIIAMoAAAgAyAMaygAAEcEQCAMIRAgBSEMDAMLIANBBGoiDSAMayEGAn8CQCANIBRPBEAgDSEFDAELIAYoAAAiCSANIgUoAAAiB0cEQCAHIAlzaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgFE8NASAGKAAAIgkgBSgAACIHRg0ACyAFIAcgCXNoQQN2aiANawwBCwJAIAUgF08NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSARSQR/IAUgBi0AACAFLQAARmoFIAULIA1rCyEFIA4gAykAAEKAgOz8y5vvjU9+ICOIp0ECdGogAyAPazYCACADIAVqIQYgAyASTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhAAsgBkEEaiEDIABBATYCACAAQQA7AQQgBUEBaiIFQYCABE8EQCABQQI2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAU7AQYgASAAQQhqIgA2AgQgDCEFIAghECADIARNDQALDAELQQAhEAsgGSADIgVqIg1BAWoiBiAESQ0ACwwECyAEIAZNDQMgEUEgayESIBFBAWshFyARQQNrIRRBwAAgACgCwAFrrSEjA0BBACAMayEYIAVBgAFqIRMgBUEBaiEKIA4gBSkAAEKAgIDYy5vvjU9+ICOIpyIAQQJ0aigCACEJIAUpAAEhJCAZIQgCQAJAA0ACQCAGIQsgDSIHIBhqIhYoAAAhBiAOIABBAnRqIAUgD2siDTYCACAkQoCAgNjLm++NT34gI4inIQACfwJAAkAgDARAIAcoAAAgBkYNAQsCQAJAAkACQCAJIBVJDQAgBSgAACAJIA9qKAAARw0AIAohByAFIQoMAQsgDiAAQQJ0aiIFKAIAIQkgBykAACEkIAUgCiAPayINNgIAICRCgICA2Mub741PfiAjiKchACAJIBVJDQIgCigAACAJIA9qKAAARw0CIAhBBU8NAQsgDiAAQQJ0aiAHIA9rNgIACyAKIAkgD2oiCGsiB0EDaiELQQQhACAJIBVLDQQMBgsgDiAAQQJ0aiEFIAcgCGoiDSATTw0BIAgMAgsgFkEBay0AACEFIAdBAWstAAAhBiAOIABBAnRqIAogD2s2AgBBBUEEIAUgBkYiBRshACAWIAVrIQggByAFayEKQQEhCwwFCyATQYABaiETIAhBAWoLIQogCCALaiEGIAUoAgAhCSALKQAAISQgCiEIIAshCiAHIQUgBCAGSw0BDAgLCyADIApPDQADQCAKQQFrIgUtAAAgCEEBayIGLQAARw0BIABBAWohACADIAVJBEAgBSEKIAYhCCAGIBtLDQELCyAMIRAgBiEIIAchDCAFIQoMAQsgDCEQIAchDAsgACAIaiEGAn8CQCAUIAAgCmoiCE0EQCAIIQUMAQsgBigAACIJIAgiBSgAACIHRwRAIAcgCXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiCSAFKAAAIgdGDQALIAUgByAJc2hBA3ZqIAhrDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgCGsLIQUgCiADayEHIAAgBWohCCABKAIMIQUCQAJAIAogEk0EQCAFIAP9AAAA/QsAACABKAIMIQUgB0EQTQRAIAEgBSAHajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgB0EhSA0BIAUgB2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBJNBEAgBSAD/QAAAP0LAAAgBSASIANrIgBqIQYgAEERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSASIQMLIAMgCk8NAEEAIQAgAyEGIAogA2tBB3EiCQRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgAEEBaiIAIAlHDQALCyADIAprQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCkcNAAsLIAEgASgCDCAHajYCDCABKAIEIQMgB0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyALNgIAIAMgBzsBBCAIQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiADYCBAJAIAggCmoiAyAESw0AIA4gDSAcaikAAEKAgIDYy5vvjU9+ICOIp0ECdGogDUECajYCACAOIANBAmsiBSkAAEKAgIDYy5vvjU9+ICOIp0ECdGogBSAPazYCACAQBEAgDCEFIBAhCANAIAghDCAFIQggAygAACADIAxrKAAARwRAIAwhECAFIQwMAwsgA0EEaiINIAxrIQYCfwJAIA0gFE8EQCANIQUMAQsgBigAACIJIA0iBSgAACIHRwRAIAcgCXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiCSAFKAAAIgdGDQALIAUgByAJc2hBA3ZqIA1rDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgDWsLIQUgDiADKQAAQoCAgNjLm++NT34gI4inQQJ0aiADIA9rNgIAIAMgBWohBiADIBJNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEACyAGQQRqIQMgAEEBNgIAIABBADsBBCAFQQFqIgVBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBTsBBiABIABBCGoiADYCBCAMIQUgCCEQIAMgBE0NAAsMAQtBACEQCyAZIAMiBWoiDUEBaiIGIARJDQALDAMLIAQgBk0NAiARQSBrIRIgEUEBayEXIBFBA2shFEHAACAAKALAAWutISMDQEEAIAxrIRggBUGAAWohEyAFQQFqIQggDiAFKQAAQoDGlf3Lm++NT34gI4inIglBAnRqKAIAIQAgBSkAASEkIBkhCwJAAkADQAJAIAYhCiANIgcgGGoiFigAACEGIA4gCUECdGogBSAPayINNgIAICRCgMaV/cub741PfiAjiKchCQJ/AkACQCAMBEAgBygAACAGRg0BCwJAAkACQAJAIAUoAABBxP0xIAAgD2ogACAVSRsoAABHDQAgACAVSQ0AIAghByAFIQgMAQsgDiAJQQJ0aiIFKAIAIQAgBykAACEkIAUgCCAPayINNgIAICRCgMaV/cub741PfiAjiKchCSAIKAAAQcT9MSAAIA9qIAAgFUkiBRsoAABHDQIgBQ0CIAtBBU8NAQsgDiAJQQJ0aiAHIA9rNgIACyAIIAAgD2oiC2siB0EDaiEKQQQhCSAAIBVLDQQMBgsgDiAJQQJ0aiEFIAcgC2oiDSATTw0BIAsMAgsgFkEBay0AACEFIAdBAWstAAAhBiAOIAlBAnRqIAggD2s2AgBBBUEEIAUgBkYiBRshCSAWIAVrIQsgByAFayEIQQEhCgwFCyATQYABaiETIAtBAWoLIQggCiALaiEGIAUoAgAhACAKKQAAISQgCCELIAohCCAHIQUgBCAGSw0BDAcLCyADIAhPDQADQCAIQQFrIgUtAAAgC0EBayIGLQAARw0BIAlBAWohCSADIAVJBEAgBSEIIAYhCyAGIBtLDQELCyAMIRAgBiELIAchDCAFIQgMAQsgDCEQIAchDAsgCSALaiEGAn8CQCAUIAggCWoiC00EQCALIQUMAQsgBigAACIAIAsiBSgAACIHRwRAIAAgB3NoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiACAFKAAAIgdGDQALIAUgACAHc2hBA3ZqIAtrDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgC2sLIQUgCCADayEHIAUgCWohCyABKAIMIQUCQAJAIAggEk0EQCAFIAP9AAAA/QsAACABKAIMIQUgB0EQTQRAIAEgBSAHajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgB0EhSA0BIAUgB2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBJNBEAgBSAD/QAAAP0LAAAgBSASIANrIgBqIQYgAEERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSASIQMLIAMgCE8NAEEAIQAgAyEGIAggA2tBB3EiCQRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgAEEBaiIAIAlHDQALCyADIAhrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCEcNAAsLIAEgASgCDCAHajYCDCABKAIEIQMgB0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAKNgIAIAMgBzsBBCALQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiADYCBAJAIAggC2oiAyAESw0AIA4gDSAcaikAAEKAxpX9y5vvjU9+ICOIp0ECdGogDUECajYCACAOIANBAmsiBSkAAEKAxpX9y5vvjU9+ICOIp0ECdGogBSAPazYCACAQBEAgDCEFIBAhCANAIAghDCAFIQggAygAACADIAxrKAAARwRAIAwhECAFIQwMAwsgA0EEaiINIAxrIQYCfwJAIA0gFE8EQCANIQUMAQsgBigAACIJIA0iBSgAACIHRwRAIAcgCXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiCSAFKAAAIgdGDQALIAUgByAJc2hBA3ZqIA1rDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgDWsLIQUgDiADKQAAQoDGlf3Lm++NT34gI4inQQJ0aiADIA9rNgIAIAMgBWohBiADIBJNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEACyAGQQRqIQMgAEEBNgIAIABBADsBBCAFQQFqIgVBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBTsBBiABIABBCGoiADYCBCAMIQUgCCEQIAMgBE0NAAsMAQtBACEQCyAZIAMiBWoiDUEBaiIGIARJDQALDAILIAQgBk0NASARQSBrIRIgEUEBayEXIBFBA2shFEHAACAAKALAAWutISMDQEEAIAxrIRggBUGAAWohEyAFQQFqIQggDiAFKQAAQoCA7PzLm++NT34gI4inIglBAnRqKAIAIQAgBSkAASEkIBkhCwJAAkADQAJAIAYhCiANIgcgGGoiFigAACEGIA4gCUECdGogBSAPayINNgIAICRCgIDs/Mub741PfiAjiKchCQJ/AkACQCAMBEAgBygAACAGRg0BCwJAAkACQAJAIAUoAABBxP0xIAAgD2ogACAVSRsoAABHDQAgACAVSQ0AIAghByAFIQgMAQsgDiAJQQJ0aiIFKAIAIQAgBykAACEkIAUgCCAPayINNgIAICRCgIDs/Mub741PfiAjiKchCSAIKAAAQcT9MSAAIA9qIAAgFUkiBRsoAABHDQIgBQ0CIAtBBU8NAQsgDiAJQQJ0aiAHIA9rNgIACyAIIAAgD2oiC2siB0EDaiEKQQQhCSAAIBVLDQQMBgsgDiAJQQJ0aiEFIAcgC2oiDSATTw0BIAsMAgsgFkEBay0AACEFIAdBAWstAAAhBiAOIAlBAnRqIAggD2s2AgBBBUEEIAUgBkYiBRshCSAWIAVrIQsgByAFayEIQQEhCgwFCyATQYABaiETIAtBAWoLIQggCiALaiEGIAUoAgAhACAKKQAAISQgCCELIAohCCAHIQUgBCAGSw0BDAYLCyADIAhPDQADQCAIQQFrIgUtAAAgC0EBayIGLQAARw0BIAlBAWohCSADIAVJBEAgBSEIIAYhCyAGIBtLDQELCyAMIRAgBiELIAchDCAFIQgMAQsgDCEQIAchDAsgCSALaiEGAn8CQCAUIAggCWoiC00EQCALIQUMAQsgBigAACIAIAsiBSgAACIHRwRAIAAgB3NoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiACAFKAAAIgdGDQALIAUgACAHc2hBA3ZqIAtrDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgC2sLIQUgCCADayEHIAUgCWohCyABKAIMIQUCQAJAIAggEk0EQCAFIAP9AAAA/QsAACABKAIMIQUgB0EQTQRAIAEgBSAHajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgB0EhSA0BIAUgB2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBJNBEAgBSAD/QAAAP0LAAAgBSASIANrIgBqIQYgAEERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSASIQMLIAMgCE8NAEEAIQAgAyEGIAggA2tBB3EiCQRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgAEEBaiIAIAlHDQALCyADIAhrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCEcNAAsLIAEgASgCDCAHajYCDCABKAIEIQMgB0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAKNgIAIAMgBzsBBCALQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiADYCBAJAIAggC2oiAyAESw0AIA4gDSAcaikAAEKAgOz8y5vvjU9+ICOIp0ECdGogDUECajYCACAOIANBAmsiBSkAAEKAgOz8y5vvjU9+ICOIp0ECdGogBSAPazYCACAQBEAgDCEFIBAhCANAIAghDCAFIQggAygAACADIAxrKAAARwRAIAwhECAFIQwMAwsgA0EEaiINIAxrIQYCfwJAIA0gFE8EQCANIQUMAQsgBigAACIJIA0iBSgAACIHRwRAIAcgCXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiCSAFKAAAIgdGDQALIAUgByAJc2hBA3ZqIA1rDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgDWsLIQUgDiADKQAAQoCA7PzLm++NT34gI4inQQJ0aiADIA9rNgIAIAMgBWohBiADIBJNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEACyAGQQRqIQMgAEEBNgIAIABBADsBBCAFQQFqIgVBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBTsBBiABIABBCGoiADYCBCAMIQUgCCEQIAMgBE0NAAsMAQtBACEQCyAZIAMiBWoiDUEBaiIGIARJDQALDAELIAQgBk0NACARQSBrIRIgEUEBayEXIBFBA2shFEHAACAAKALAAWutISMDQEEAIAxrIRggBUGAAWohEyAFQQFqIQggDiAFKQAAQoCAgNjLm++NT34gI4inIglBAnRqKAIAIQAgBSkAASEkIBkhCwJAAkADQAJAIAYhCiANIgcgGGoiFigAACEGIA4gCUECdGogBSAPayINNgIAICRCgICA2Mub741PfiAjiKchCQJ/AkACQCAMBEAgBygAACAGRg0BCwJAAkACQAJAIAUoAABBxP0xIAAgD2ogACAVSRsoAABHDQAgACAVSQ0AIAghByAFIQgMAQsgDiAJQQJ0aiIFKAIAIQAgBykAACEkIAUgCCAPayINNgIAICRCgICA2Mub741PfiAjiKchCSAIKAAAQcT9MSAAIA9qIAAgFUkiBRsoAABHDQIgBQ0CIAtBBU8NAQsgDiAJQQJ0aiAHIA9rNgIACyAIIAAgD2oiC2siB0EDaiEKQQQhCSAAIBVLDQQMBgsgDiAJQQJ0aiEFIAcgC2oiDSATTw0BIAsMAgsgFkEBay0AACEFIAdBAWstAAAhBiAOIAlBAnRqIAggD2s2AgBBBUEEIAUgBkYiBRshCSAWIAVrIQsgByAFayEIQQEhCgwFCyATQYABaiETIAtBAWoLIQggCiALaiEGIAUoAgAhACAKKQAAISQgCCELIAohCCAHIQUgBCAGSw0BDAULCyADIAhPDQADQCAIQQFrIgUtAAAgC0EBayIGLQAARw0BIAlBAWohCSADIAVJBEAgBSEIIAYhCyAGIBtLDQELCyAMIRAgBiELIAchDCAFIQgMAQsgDCEQIAchDAsgCSALaiEGAn8CQCAUIAggCWoiC00EQCALIQUMAQsgBigAACIAIAsiBSgAACIHRwRAIAAgB3NoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiACAFKAAAIgdGDQALIAUgACAHc2hBA3ZqIAtrDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgC2sLIQUgCCADayEHIAUgCWohCyABKAIMIQUCQAJAIAggEk0EQCAFIAP9AAAA/QsAACABKAIMIQUgB0EQTQRAIAEgBSAHajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgB0EhSA0BIAUgB2ohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBJNBEAgBSAD/QAAAP0LAAAgBSASIANrIgBqIQYgAEERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSASIQMLIAMgCE8NAEEAIQAgAyEGIAggA2tBB3EiCQRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgAEEBaiIAIAlHDQALCyADIAhrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCEcNAAsLIAEgASgCDCAHajYCDCABKAIEIQMgB0GAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAKNgIAIAMgBzsBBCALQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiADYCBAJAIAggC2oiAyAESw0AIA4gDSAcaikAAEKAgIDYy5vvjU9+ICOIp0ECdGogDUECajYCACAOIANBAmsiBSkAAEKAgIDYy5vvjU9+ICOIp0ECdGogBSAPazYCACAQBEAgDCEFIBAhCANAIAghDCAFIQggAygAACADIAxrKAAARwRAIAwhECAFIQwMAwsgA0EEaiINIAxrIQYCfwJAIA0gFE8EQCANIQUMAQsgBigAACIJIA0iBSgAACIHRwRAIAcgCXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAUTw0BIAYoAAAiCSAFKAAAIgdGDQALIAUgByAJc2hBA3ZqIA1rDAELAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIBFJBH8gBSAGLQAAIAUtAABGagUgBQsgDWsLIQUgDiADKQAAQoCAgNjLm++NT34gI4inQQJ0aiADIA9rNgIAIAMgBWohBiADIBJNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEACyAGQQRqIQMgAEEBNgIAIABBADsBBCAFQQFqIgVBgIAETwRAIAFBAjYCJCABIAAgASgCAGtBA3U2AigLIAAgBTsBBiABIABBCGoiADYCBCAMIQUgCCEQIAMgBE0NAAsMAQtBACEQCyAZIAMiBWoiDUEBaiIGIARJDQALCyACIAwgH0EAICAbIAwbNgIAIAIgECAfICFBACAiGyIPIAwbIA8gIBsgEBs2AgQgESADawuiXQIffwN+QQEgACgCzAEiECAQQQFNGyEaIAMgBGoiD0EIayETIAAoArQBIhcoAgQiGCAXKAIMIiBqIR0gFygCACIZIAMgACgCBCIQIAAoAgwiBGoiFWtqIQdBACAYIBlrIARqIh5rIREgACgC2AEhBSACKAIEIRIgAigCACEMIAAoAsABIQkgACgCXCEWIBcoAsABIQYgFygCXCEXAkACQAJAAkACQCAAKALIAUEFaw4DAwIBAAsCQCAFRQ0AIAZBHUsNAEEEIAZ0IQVBACEAA0AgAEFAayIAIAVJDQALCyATIAMgGmoiCEkEQCADIQAMBAsgEEECaiEiIBEgGGohHyAPQQFrISMgD0EDayEhIA9BIGshFEEYIAZrIRtBICAJayEcIAMgByAdRmohAANAIAAoAABBsfPd8XlsIgYgG3YiBSAXIAVBBnZB/P//H3FqKAIAIg1zIQsgAEGAAmohByAaIQoCQAJAAn8DQCAWIAYgHHZBAnRqIgkoAgAhBiAIIgUoAAAhDiAJIAAgEGsiETYCAAJAIBEgDGtBAWoiCCAEa0F8Sw0AIBggCCAea2ogCCAQaiAEIAhLIggbIgkoAAAgACgAAUcNACAAQQVqIAlBBGogDyAZIA8gCBsgFRDQCyEKIABBAWoiByADayEJIAEoAgwhBQJAAkAgByAUTQRAIAUgA/0AAAD9CwAAIAEoAgwhBiAJQRBNBEAgASAGIAlqNgIMIAEoAgQhAAwDCyAGIAP9AAAQ/QsAECAJQSFIDQEgBiAJaiEFIANBEGohACAGQSBqIQMDQCADIAD9AAAQ/QsAACADIAD9AAAg/QsAECAAQSBqIQAgA0EgaiIDIAVJDQALDAELIAMgFE0EQCAFIAP9AAAA/QsAACAFIBQgA2siCGohBiAIQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBQhAwsgAyAHTw0AIAAgA2siC0EHcUEHRwRAIAtBAWpBB3EhCEEAIQYDQCAFIAMtAAA6AAAgBUEBaiEFIANBAWohAyAGQQFqIgYgCEcNAAsgC0EHSQ0BCwNAIAUgAy0AADoAACAFIAMtAAE6AAEgBSADLQACOgACIAUgAy0AAzoAAyAFIAMtAAQ6AAQgBSADLQAFOgAFIAUgAy0ABjoABiAFIAMtAAc6AAcgBUEIaiEFIANBB2ohBiADQQhqIQMgACAGRw0ACwsgASABKAIMIAlqNgIMIAEoAgQhACAJQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAKQQRqIQggAEEBNgIAIAAgCTsBBCAMIQ4gCkEBaiIDQf//A00NBAwDCwJAIAtB/wFxBEAgACgAACEIDAELIAAoAAAhCCANQQh2IgkgIE0NACAJIBhqIgsoAAAgCEcNACAEIAZJDQAgAEEEaiALQQRqIA8gGSAVENALQQRqIQggESAJIB5qayEOIAAhBwJAIAAgA00NAANAIABBAWsiBy0AACALQQFrIgstAABHBEAgACEHDAILIAhBAWohCCADIAdPDQEgByEAIAsgHUsNAAsLIA5BA2ohCyAHIANrIQogASgCDCEAAkACQCAHIBRNBEAgACAD/QAAAP0LAAAgASgCDCEGIApBEE0EQCABIAYgCmo2AgwgASgCBCEADAMLIAYgA/0AABD9CwAQIApBIUgNASAGIApqIQUgA0EQaiEAIAZBIGohAwNAIAMgAP0AABD9CwAAIAMgAP0AACD9CwAQIABBIGohACADQSBqIgMgBUkNAAsMAQsgAyAUTQRAIAAgA/0AAAD9CwAAIAAgFCADayIGaiEFIAZBEU4EQCAAQRBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALCyAUIQMgBSEACyADIAdPDQBBACEGIAMhBSAHIANrQQdxIgkEQANAIAAgBS0AADoAACAAQQFqIQAgBUEBaiEFIAZBAWoiBiAJRw0ACwsgAyAHa0F4Sw0AA0AgACAFLQAAOgAAIAAgBS0AAToAASAAIAUtAAI6AAIgACAFLQADOgADIAAgBS0ABDoABCAAIAUtAAU6AAUgACAFLQAGOgAGIAAgBS0ABzoAByAAQQhqIQAgBUEIaiIFIAdHDQALCyABIAEoAgwgCmo2AgwgASgCBCEAIApBgIAESQ0AIAFBATYCJCABIAAgASgCAGtBA3U2AigLIAAgCzYCACAAIAo7AQQgDCESIA4hDCAIQQNrIgNB//8DSw0DDAQLAkACQCAIQcT9MSAGIBBqIgsgBCAGSyIJGygAAEcNACAJDQAgC0EEaiEHICEgAEEEaiIKTQRAIAohBQwCCyAHKAAAIgggCiIFKAAAIglHBEAgCCAJc2hBA3YMBAsDQCAHQQRqIQcgBUEEaiIFICFPDQIgBygAACIIIAUoAAAiCUYNAAsgBSAIIAlzaEEDdmogCmsMAwsgEyAFIAogBSAHTyIAaiIKaiIISQRAIAMhAAwKCyAHQYACQQAgABtqIQcgFyAOQbHz3fF5bCIGIBt2IgBBBnZB/P//H3FqKAIAIg0gAHMhCyAFIQAMAQsLAkAgBSAjTw0AIAcvAAAgBS8AAEcNACAHQQJqIQcgBUECaiEFCyAFIA9JBH8gBSAHLQAAIAUtAABGagUgBQsgCmsLQQRqIQgCQCAAIANNBEAgACEHDAELIAAhCSALIQUgACEHIAQgBk8NAANAIAlBAWsiBy0AACAFQQFrIgUtAABHBEAgCSEHDAILIAhBAWohCCADIAdPDQEgByEJIAUgFUsNAAsLIAAgC2siDkEDaiELIAcgA2shCiABKAIMIQACQAJAIAcgFE0EQCAAIAP9AAAA/QsAACABKAIMIQYgCkEQTQRAIAEgBiAKajYCDCABKAIEIQAMAwsgBiAD/QAAEP0LABAgCkEhSA0BIAYgCmohBSADQRBqIQAgBkEgaiEDA0AgAyAA/QAAEP0LAAAgAyAA/QAAIP0LABAgAEEgaiEAIANBIGoiAyAFSQ0ACwwBCyADIBRNBEAgACAD/QAAAP0LAAAgACAUIANrIgZqIQUgBkERTgRAIABBEGohAANAIAAgA/0AABD9CwAAIAAgA/0AACD9CwAQIANBIGohAyAAQSBqIgAgBUkNAAsLIBQhAyAFIQALIAMgB08NAEEAIQYgAyEFIAcgA2tBB3EiCQRAA0AgACAFLQAAOgAAIABBAWohACAFQQFqIQUgBkEBaiIGIAlHDQALCyADIAdrQXhLDQADQCAAIAUtAAA6AAAgACAFLQABOgABIAAgBS0AAjoAAiAAIAUtAAM6AAMgACAFLQAEOgAEIAAgBS0ABToABSAAIAUtAAY6AAYgACAFLQAHOgAHIABBCGohACAFQQhqIgUgB0cNAAsLIAEgASgCDCAKajYCDCABKAIEIQAgCkGAgARJDQAgAUEBNgIkIAEgACABKAIAa0EDdTYCKAsgACALNgIAIAAgCjsBBCAMIRIgDiEMIAhBA2siA0H//wNNDQELIAFBAjYCJCABIAAgASgCAGtBA3U2AiggDiEMCyAAIAM7AQYgASAAQQhqIgM2AgQCQCAHIAhqIgAgE0sNACAWIBEgImooAABBsfPd8XlsIBx2QQJ0aiARQQJqNgIAIBYgAEECayIFKAAAQbHz3fF5bCAcdkECdGogBSAQazYCACAMIQcgEiEFA0ACQCAFIQwgByEFIAAgEGsiByAMayIGIARrQXxLDQAgHyAQIAQgBksiCBsgBmoiBigAACAAKAAARw0AIABBBGogBkEEaiAPIBkgDyAIGyAVENALIQYgACAUTQRAIAEoAgwgAP0AAAD9CwAAIAEoAgQhAwsgA0EBNgIAIANBADsBBCAGQQFqIghBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCDsBBiABIANBCGoiAzYCBCAWIAAoAABBsfPd8XlsIBx2QQJ0aiAHNgIAIAwhByAFIRIgACAGakEEaiIAIBNNDQEMAgsLIAwhEiAFIQwLIAAhAyAAIBpqIgggE00NAAsMAwsCQCAFRQ0AIAZBHUsNAEEEIAZ0IQVBACEAA0AgAEFAayIAIAVJDQALCyATIAMgGmoiCEkEQCADIQAMAwsgEEECaiEUIBEgGGohHCAPQQFrIR8gD0EDayEbIA9BIGshDSADIAcgHUZqIQBBOCAGa60hJkHAACAJa60hJANAIBcgACkAAEKAxpX9y5vvjU9+IiUgJoinIgVBBnZB/P//H3FqKAIAIg4gBXMhCyAAQYACaiEHIBohCgJAAkACfwNAIBYgJSAkiKdBAnRqIgkoAgAhBiAIIgUpAAAhJSAJIAAgEGsiETYCAAJAIBEgDGtBAWoiCCAEa0F8Sw0AIBggCCAea2ogCCAQaiAEIAhLIggbIgkoAAAgACgAAUcNACAAQQVqIAlBBGogDyAZIA8gCBsgFRDQCyEKIABBAWoiByADayEJIAEoAgwhBQJAAkAgByANTQRAIAUgA/0AAAD9CwAAIAEoAgwhBiAJQRBNBEAgASAGIAlqNgIMIAEoAgQhAAwDCyAGIAP9AAAQ/QsAECAJQSFIDQEgBiAJaiEFIANBEGohACAGQSBqIQMDQCADIAD9AAAQ/QsAACADIAD9AAAg/QsAECAAQSBqIQAgA0EgaiIDIAVJDQALDAELIAMgDU0EQCAFIAP9AAAA/QsAACAFIA0gA2siCGohBiAIQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIA0hAwsgAyAHTw0AIAAgA2siC0EHcUEHRwRAIAtBAWpBB3EhCEEAIQYDQCAFIAMtAAA6AAAgBUEBaiEFIANBAWohAyAGQQFqIgYgCEcNAAsgC0EHSQ0BCwNAIAUgAy0AADoAACAFIAMtAAE6AAEgBSADLQACOgACIAUgAy0AAzoAAyAFIAMtAAQ6AAQgBSADLQAFOgAFIAUgAy0ABjoABiAFIAMtAAc6AAcgBUEIaiEFIANBB2ohBiADQQhqIQMgACAGRw0ACwsgASABKAIMIAlqNgIMIAEoAgQhACAJQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAKQQRqIQggAEEBNgIAIAAgCTsBBCAMIQ4gCkEBaiIDQf//A00NBAwDCwJAIAtB/wFxBEAgACgAACEIDAELIAAoAAAhCCAOQQh2IgkgIE0NACAJIBhqIgsoAAAgCEcNACAEIAZJDQAgAEEEaiALQQRqIA8gGSAVENALQQRqIQggESAJIB5qayEOIAAhBwJAIAAgA00NAANAIABBAWsiBy0AACALQQFrIgstAABHBEAgACEHDAILIAhBAWohCCADIAdPDQEgByEAIAsgHUsNAAsLIA5BA2ohCyAHIANrIQogASgCDCEAAkACQCAHIA1NBEAgACAD/QAAAP0LAAAgASgCDCEGIApBEE0EQCABIAYgCmo2AgwgASgCBCEADAMLIAYgA/0AABD9CwAQIApBIUgNASAGIApqIQUgA0EQaiEAIAZBIGohAwNAIAMgAP0AABD9CwAAIAMgAP0AACD9CwAQIABBIGohACADQSBqIgMgBUkNAAsMAQsgAyANTQRAIAAgA/0AAAD9CwAAIAAgDSADayIGaiEFIAZBEU4EQCAAQRBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALCyANIQMgBSEACyADIAdPDQBBACEGIAMhBSAHIANrQQdxIgkEQANAIAAgBS0AADoAACAAQQFqIQAgBUEBaiEFIAZBAWoiBiAJRw0ACwsgAyAHa0F4Sw0AA0AgACAFLQAAOgAAIAAgBS0AAToAASAAIAUtAAI6AAIgACAFLQADOgADIAAgBS0ABDoABCAAIAUtAAU6AAUgACAFLQAGOgAGIAAgBS0ABzoAByAAQQhqIQAgBUEIaiIFIAdHDQALCyABIAEoAgwgCmo2AgwgASgCBCEAIApBgIAESQ0AIAFBATYCJCABIAAgASgCAGtBA3U2AigLIAAgCzYCACAAIAo7AQQgDCESIA4hDCAIQQNrIgNB//8DSw0DDAQLAkACQCAIQcT9MSAGIBBqIgsgBCAGSyIJGygAAEcNACAJDQAgC0EEaiEHIBsgAEEEaiIKTQRAIAohBQwCCyAHKAAAIgggCiIFKAAAIglHBEAgCCAJc2hBA3YMBAsDQCAHQQRqIQcgBUEEaiIFIBtPDQIgBygAACIIIAUoAAAiCUYNAAsgBSAIIAlzaEEDdmogCmsMAwsgEyAFIAogBSAHTyIAaiIKaiIISQRAIAMhAAwJCyAHQYACQQAgABtqIQcgFyAlQoDGlf3Lm++NT34iJSAmiKciAEEGdkH8//8fcWooAgAiDiAAcyELIAUhAAwBCwsCQCAFIB9PDQAgBy8AACAFLwAARw0AIAdBAmohByAFQQJqIQULIAUgD0kEfyAFIActAAAgBS0AAEZqBSAFCyAKawtBBGohCAJAIAAgA00EQCAAIQcMAQsgACEJIAshBSAAIQcgBCAGTw0AA0AgCUEBayIHLQAAIAVBAWsiBS0AAEcEQCAJIQcMAgsgCEEBaiEIIAMgB08NASAHIQkgBSAVSw0ACwsgACALayIOQQNqIQsgByADayEKIAEoAgwhAAJAAkAgByANTQRAIAAgA/0AAAD9CwAAIAEoAgwhBiAKQRBNBEAgASAGIApqNgIMIAEoAgQhAAwDCyAGIAP9AAAQ/QsAECAKQSFIDQEgBiAKaiEFIANBEGohACAGQSBqIQMDQCADIAD9AAAQ/QsAACADIAD9AAAg/QsAECAAQSBqIQAgA0EgaiIDIAVJDQALDAELIAMgDU0EQCAAIAP9AAAA/QsAACAAIA0gA2siBmohBSAGQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAFSQ0ACwsgDSEDIAUhAAsgAyAHTw0AQQAhBiADIQUgByADa0EHcSIJBEADQCAAIAUtAAA6AAAgAEEBaiEAIAVBAWohBSAGQQFqIgYgCUcNAAsLIAMgB2tBeEsNAANAIAAgBS0AADoAACAAIAUtAAE6AAEgACAFLQACOgACIAAgBS0AAzoAAyAAIAUtAAQ6AAQgACAFLQAFOgAFIAAgBS0ABjoABiAAIAUtAAc6AAcgAEEIaiEAIAVBCGoiBSAHRw0ACwsgASABKAIMIApqNgIMIAEoAgQhACAKQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAs2AgAgACAKOwEEIAwhEiAOIQwgCEEDayIDQf//A00NAQsgAUECNgIkIAEgACABKAIAa0EDdTYCKCAOIQwLIAAgAzsBBiABIABBCGoiAzYCBAJAIAcgCGoiACATSw0AIBYgESAUaikAAEKAxpX9y5vvjU9+ICSIp0ECdGogEUECajYCACAWIABBAmsiBSkAAEKAxpX9y5vvjU9+ICSIp0ECdGogBSAQazYCACAMIQcgEiEFA0ACQCAFIQwgByEFIAAgEGsiByAMayIGIARrQXxLDQAgHCAQIAQgBksiCBsgBmoiBigAACAAKAAARw0AIABBBGogBkEEaiAPIBkgDyAIGyAVENALIQYgACANTQRAIAEoAgwgAP0AAAD9CwAAIAEoAgQhAwsgA0EBNgIAIANBADsBBCAGQQFqIghBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgCDsBBiABIANBCGoiAzYCBCAWIAApAABCgMaV/cub741PfiAkiKdBAnRqIAc2AgAgDCEHIAUhEiAAIAZqQQRqIgAgE00NAQwCCwsgDCESIAUhDAsgACEDIAAgGmoiCCATTQ0ACwwCCwJAIAVFDQAgBkEdSw0AQQQgBnQhBUEAIQADQCAAQUBrIgAgBUkNAAsLIBMgAyAaaiIISQRAIAMhAAwCCyAQQQJqIRQgESAYaiEcIA9BAWshHyAPQQNrIRsgD0EgayENIAMgByAdRmohAEE4IAZrrSEmQcAAIAlrrSEkA0AgFyAAKQAAQoCA7PzLm++NT34iJSAmiKciBUEGdkH8//8fcWooAgAiDiAFcyELIABBgAJqIQcgGiEKAkACQAJ/A0AgFiAlICSIp0ECdGoiCSgCACEGIAgiBSkAACElIAkgACAQayIRNgIAAkAgESAMa0EBaiIIIARrQXxLDQAgGCAIIB5raiAIIBBqIAQgCEsiCBsiCSgAACAAKAABRw0AIABBBWogCUEEaiAPIBkgDyAIGyAVENALIQogAEEBaiIHIANrIQkgASgCDCEFAkACQCAHIA1NBEAgBSAD/QAAAP0LAAAgASgCDCEGIAlBEE0EQCABIAYgCWo2AgwgASgCBCEADAMLIAYgA/0AABD9CwAQIAlBIUgNASAGIAlqIQUgA0EQaiEAIAZBIGohAwNAIAMgAP0AABD9CwAAIAMgAP0AACD9CwAQIABBIGohACADQSBqIgMgBUkNAAsMAQsgAyANTQRAIAUgA/0AAAD9CwAAIAUgDSADayIIaiEGIAhBEU4EQCAFQRBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALCyAGIQUgDSEDCyADIAdPDQAgACADayILQQdxQQdHBEAgC0EBakEHcSEIQQAhBgNAIAUgAy0AADoAACAFQQFqIQUgA0EBaiEDIAZBAWoiBiAIRw0ACyALQQdJDQELA0AgBSADLQAAOgAAIAUgAy0AAToAASAFIAMtAAI6AAIgBSADLQADOgADIAUgAy0ABDoABCAFIAMtAAU6AAUgBSADLQAGOgAGIAUgAy0ABzoAByAFQQhqIQUgA0EHaiEGIANBCGohAyAAIAZHDQALCyABIAEoAgwgCWo2AgwgASgCBCEAIAlBgIAESQ0AIAFBATYCJCABIAAgASgCAGtBA3U2AigLIApBBGohCCAAQQE2AgAgACAJOwEEIAwhDiAKQQFqIgNB//8DTQ0EDAMLAkAgC0H/AXEEQCAAKAAAIQgMAQsgACgAACEIIA5BCHYiCSAgTQ0AIAkgGGoiCygAACAIRw0AIAQgBkkNACAAQQRqIAtBBGogDyAZIBUQ0AtBBGohCCARIAkgHmprIQ4gACEHAkAgACADTQ0AA0AgAEEBayIHLQAAIAtBAWsiCy0AAEcEQCAAIQcMAgsgCEEBaiEIIAMgB08NASAHIQAgCyAdSw0ACwsgDkEDaiELIAcgA2shCiABKAIMIQACQAJAIAcgDU0EQCAAIAP9AAAA/QsAACABKAIMIQYgCkEQTQRAIAEgBiAKajYCDCABKAIEIQAMAwsgBiAD/QAAEP0LABAgCkEhSA0BIAYgCmohBSADQRBqIQAgBkEgaiEDA0AgAyAA/QAAEP0LAAAgAyAA/QAAIP0LABAgAEEgaiEAIANBIGoiAyAFSQ0ACwwBCyADIA1NBEAgACAD/QAAAP0LAAAgACANIANrIgZqIQUgBkERTgRAIABBEGohAANAIAAgA/0AABD9CwAAIAAgA/0AACD9CwAQIANBIGohAyAAQSBqIgAgBUkNAAsLIA0hAyAFIQALIAMgB08NAEEAIQYgAyEFIAcgA2tBB3EiCQRAA0AgACAFLQAAOgAAIABBAWohACAFQQFqIQUgBkEBaiIGIAlHDQALCyADIAdrQXhLDQADQCAAIAUtAAA6AAAgACAFLQABOgABIAAgBS0AAjoAAiAAIAUtAAM6AAMgACAFLQAEOgAEIAAgBS0ABToABSAAIAUtAAY6AAYgACAFLQAHOgAHIABBCGohACAFQQhqIgUgB0cNAAsLIAEgASgCDCAKajYCDCABKAIEIQAgCkGAgARJDQAgAUEBNgIkIAEgACABKAIAa0EDdTYCKAsgACALNgIAIAAgCjsBBCAMIRIgDiEMIAhBA2siA0H//wNLDQMMBAsCQAJAIAhBxP0xIAYgEGoiCyAEIAZLIgkbKAAARw0AIAkNACALQQRqIQcgGyAAQQRqIgpNBEAgCiEFDAILIAcoAAAiCCAKIgUoAAAiCUcEQCAIIAlzaEEDdgwECwNAIAdBBGohByAFQQRqIgUgG08NAiAHKAAAIgggBSgAACIJRg0ACyAFIAggCXNoQQN2aiAKawwDCyATIAUgCiAFIAdPIgBqIgpqIghJBEAgAyEADAgLIAdBgAJBACAAG2ohByAXICVCgIDs/Mub741PfiIlICaIpyIAQQZ2Qfz//x9xaigCACIOIABzIQsgBSEADAELCwJAIAUgH08NACAHLwAAIAUvAABHDQAgB0ECaiEHIAVBAmohBQsgBSAPSQR/IAUgBy0AACAFLQAARmoFIAULIAprC0EEaiEIAkAgACADTQRAIAAhBwwBCyAAIQkgCyEFIAAhByAEIAZPDQADQCAJQQFrIgctAAAgBUEBayIFLQAARwRAIAkhBwwCCyAIQQFqIQggAyAHTw0BIAchCSAFIBVLDQALCyAAIAtrIg5BA2ohCyAHIANrIQogASgCDCEAAkACQCAHIA1NBEAgACAD/QAAAP0LAAAgASgCDCEGIApBEE0EQCABIAYgCmo2AgwgASgCBCEADAMLIAYgA/0AABD9CwAQIApBIUgNASAGIApqIQUgA0EQaiEAIAZBIGohAwNAIAMgAP0AABD9CwAAIAMgAP0AACD9CwAQIABBIGohACADQSBqIgMgBUkNAAsMAQsgAyANTQRAIAAgA/0AAAD9CwAAIAAgDSADayIGaiEFIAZBEU4EQCAAQRBqIQADQCAAIAP9AAAQ/QsAACAAIAP9AAAg/QsAECADQSBqIQMgAEEgaiIAIAVJDQALCyANIQMgBSEACyADIAdPDQBBACEGIAMhBSAHIANrQQdxIgkEQANAIAAgBS0AADoAACAAQQFqIQAgBUEBaiEFIAZBAWoiBiAJRw0ACwsgAyAHa0F4Sw0AA0AgACAFLQAAOgAAIAAgBS0AAToAASAAIAUtAAI6AAIgACAFLQADOgADIAAgBS0ABDoABCAAIAUtAAU6AAUgACAFLQAGOgAGIAAgBS0ABzoAByAAQQhqIQAgBUEIaiIFIAdHDQALCyABIAEoAgwgCmo2AgwgASgCBCEAIApBgIAESQ0AIAFBATYCJCABIAAgASgCAGtBA3U2AigLIAAgCzYCACAAIAo7AQQgDCESIA4hDCAIQQNrIgNB//8DTQ0BCyABQQI2AiQgASAAIAEoAgBrQQN1NgIoIA4hDAsgACADOwEGIAEgAEEIaiIDNgIEAkAgByAIaiIAIBNLDQAgFiARIBRqKQAAQoCA7PzLm++NT34gJIinQQJ0aiARQQJqNgIAIBYgAEECayIFKQAAQoCA7PzLm++NT34gJIinQQJ0aiAFIBBrNgIAIAwhByASIQUDQAJAIAUhDCAHIQUgACAQayIHIAxrIgYgBGtBfEsNACAcIBAgBCAGSyIIGyAGaiIGKAAAIAAoAABHDQAgAEEEaiAGQQRqIA8gGSAPIAgbIBUQ0AshBiAAIA1NBEAgASgCDCAA/QAAAP0LAAAgASgCBCEDCyADQQE2AgAgA0EAOwEEIAZBAWoiCEGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAIOwEGIAEgA0EIaiIDNgIEIBYgACkAAEKAgOz8y5vvjU9+ICSIp0ECdGogBzYCACAMIQcgBSESIAAgBmpBBGoiACATTQ0BDAILCyAMIRIgBSEMCyAAIQMgACAaaiIIIBNNDQALDAELAkAgBUUNACAGQR1LDQBBBCAGdCEFQQAhAANAIABBQGsiACAFSQ0ACwsgEyADIBpqIghJBEAgAyEADAELIBBBAmohFCARIBhqIRwgD0EBayEfIA9BA2shGyAPQSBrIQ0gAyAHIB1GaiEAQTggBmutISZBwAAgCWutISQDQCAXIAApAABCgICA2Mub741PfiIlICaIpyIFQQZ2Qfz//x9xaigCACIOIAVzIQsgAEGAAmohByAaIQoCQAJAAn8DQCAWICUgJIinQQJ0aiIJKAIAIQYgCCIFKQAAISUgCSAAIBBrIhE2AgACQCARIAxrQQFqIgggBGtBfEsNACAYIAggHmtqIAggEGogBCAISyIIGyIJKAAAIAAoAAFHDQAgAEEFaiAJQQRqIA8gGSAPIAgbIBUQ0AshCiAAQQFqIgcgA2shCSABKAIMIQUCQAJAIAcgDU0EQCAFIAP9AAAA/QsAACABKAIMIQYgCUEQTQRAIAEgBiAJajYCDCABKAIEIQAMAwsgBiAD/QAAEP0LABAgCUEhSA0BIAYgCWohBSADQRBqIQAgBkEgaiEDA0AgAyAA/QAAEP0LAAAgAyAA/QAAIP0LABAgAEEgaiEAIANBIGoiAyAFSQ0ACwwBCyADIA1NBEAgBSAD/QAAAP0LAAAgBSANIANrIghqIQYgCEERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSANIQMLIAMgB08NACAAIANrIgtBB3FBB0cEQCALQQFqQQdxIQhBACEGA0AgBSADLQAAOgAAIAVBAWohBSADQQFqIQMgBkEBaiIGIAhHDQALIAtBB0kNAQsDQCAFIAMtAAA6AAAgBSADLQABOgABIAUgAy0AAjoAAiAFIAMtAAM6AAMgBSADLQAEOgAEIAUgAy0ABToABSAFIAMtAAY6AAYgBSADLQAHOgAHIAVBCGohBSADQQdqIQYgA0EIaiEDIAAgBkcNAAsLIAEgASgCDCAJajYCDCABKAIEIQAgCUGAgARJDQAgAUEBNgIkIAEgACABKAIAa0EDdTYCKAsgCkEEaiEIIABBATYCACAAIAk7AQQgDCEOIApBAWoiA0H//wNNDQQMAwsCQCALQf8BcQRAIAAoAAAhCAwBCyAAKAAAIQggDkEIdiIJICBNDQAgCSAYaiILKAAAIAhHDQAgBCAGSQ0AIABBBGogC0EEaiAPIBkgFRDQC0EEaiEIIBEgCSAeamshDiAAIQcCQCAAIANNDQADQCAAQQFrIgctAAAgC0EBayILLQAARwRAIAAhBwwCCyAIQQFqIQggAyAHTw0BIAchACALIB1LDQALCyAOQQNqIQsgByADayEKIAEoAgwhAAJAAkAgByANTQRAIAAgA/0AAAD9CwAAIAEoAgwhBiAKQRBNBEAgASAGIApqNgIMIAEoAgQhAAwDCyAGIAP9AAAQ/QsAECAKQSFIDQEgBiAKaiEFIANBEGohACAGQSBqIQMDQCADIAD9AAAQ/QsAACADIAD9AAAg/QsAECAAQSBqIQAgA0EgaiIDIAVJDQALDAELIAMgDU0EQCAAIAP9AAAA/QsAACAAIA0gA2siBmohBSAGQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAFSQ0ACwsgDSEDIAUhAAsgAyAHTw0AQQAhBiADIQUgByADa0EHcSIJBEADQCAAIAUtAAA6AAAgAEEBaiEAIAVBAWohBSAGQQFqIgYgCUcNAAsLIAMgB2tBeEsNAANAIAAgBS0AADoAACAAIAUtAAE6AAEgACAFLQACOgACIAAgBS0AAzoAAyAAIAUtAAQ6AAQgACAFLQAFOgAFIAAgBS0ABjoABiAAIAUtAAc6AAcgAEEIaiEAIAVBCGoiBSAHRw0ACwsgASABKAIMIApqNgIMIAEoAgQhACAKQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAs2AgAgACAKOwEEIAwhEiAOIQwgCEEDayIDQf//A0sNAwwECwJAAkAgCEHE/TEgBiAQaiILIAQgBksiCRsoAABHDQAgCQ0AIAtBBGohByAbIABBBGoiCk0EQCAKIQUMAgsgBygAACIIIAoiBSgAACIJRwRAIAggCXNoQQN2DAQLA0AgB0EEaiEHIAVBBGoiBSAbTw0CIAcoAAAiCCAFKAAAIglGDQALIAUgCCAJc2hBA3ZqIAprDAMLIBMgBSAKIAUgB08iAGoiCmoiCEkEQCADIQAMBwsgB0GAAkEAIAAbaiEHIBcgJUKAgIDYy5vvjU9+IiUgJoinIgBBBnZB/P//H3FqKAIAIg4gAHMhCyAFIQAMAQsLAkAgBSAfTw0AIAcvAAAgBS8AAEcNACAHQQJqIQcgBUECaiEFCyAFIA9JBH8gBSAHLQAAIAUtAABGagUgBQsgCmsLQQRqIQgCQCAAIANNBEAgACEHDAELIAAhCSALIQUgACEHIAQgBk8NAANAIAlBAWsiBy0AACAFQQFrIgUtAABHBEAgCSEHDAILIAhBAWohCCADIAdPDQEgByEJIAUgFUsNAAsLIAAgC2siDkEDaiELIAcgA2shCiABKAIMIQACQAJAIAcgDU0EQCAAIAP9AAAA/QsAACABKAIMIQYgCkEQTQRAIAEgBiAKajYCDCABKAIEIQAMAwsgBiAD/QAAEP0LABAgCkEhSA0BIAYgCmohBSADQRBqIQAgBkEgaiEDA0AgAyAA/QAAEP0LAAAgAyAA/QAAIP0LABAgAEEgaiEAIANBIGoiAyAFSQ0ACwwBCyADIA1NBEAgACAD/QAAAP0LAAAgACANIANrIgZqIQUgBkERTgRAIABBEGohAANAIAAgA/0AABD9CwAAIAAgA/0AACD9CwAQIANBIGohAyAAQSBqIgAgBUkNAAsLIA0hAyAFIQALIAMgB08NAEEAIQYgAyEFIAcgA2tBB3EiCQRAA0AgACAFLQAAOgAAIABBAWohACAFQQFqIQUgBkEBaiIGIAlHDQALCyADIAdrQXhLDQADQCAAIAUtAAA6AAAgACAFLQABOgABIAAgBS0AAjoAAiAAIAUtAAM6AAMgACAFLQAEOgAEIAAgBS0ABToABSAAIAUtAAY6AAYgACAFLQAHOgAHIABBCGohACAFQQhqIgUgB0cNAAsLIAEgASgCDCAKajYCDCABKAIEIQAgCkGAgARJDQAgAUEBNgIkIAEgACABKAIAa0EDdTYCKAsgACALNgIAIAAgCjsBBCAMIRIgDiEMIAhBA2siA0H//wNNDQELIAFBAjYCJCABIAAgASgCAGtBA3U2AiggDiEMCyAAIAM7AQYgASAAQQhqIgM2AgQCQCAHIAhqIgAgE0sNACAWIBEgFGopAABCgICA2Mub741PfiAkiKdBAnRqIBFBAmo2AgAgFiAAQQJrIgUpAABCgICA2Mub741PfiAkiKdBAnRqIAUgEGs2AgAgDCEHIBIhBQNAAkAgBSEMIAchBSAAIBBrIgcgDGsiBiAEa0F8Sw0AIBwgECAEIAZLIggbIAZqIgYoAAAgACgAAEcNACAAQQRqIAZBBGogDyAZIA8gCBsgFRDQCyEGIAAgDU0EQCABKAIMIAD9AAAA/QsAACABKAIEIQMLIANBATYCACADQQA7AQQgBkEBaiIIQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAg7AQYgASADQQhqIgM2AgQgFiAAKQAAQoCAgNjLm++NT34gJIinQQJ0aiAHNgIAIAwhByAFIRIgACAGakEEaiIAIBNNDQEMAgsLIAwhEiAFIQwLIAAhAyAAIBpqIgggE00NAAsLIAIgEjYCBCACIAw2AgAgDyAAawuGFAIifwF+IAAoAhAiCSADIAAoAgQiDGsiBSAEaiIGQQEgACgCuAF0IgprIAkgBiAJayAKSxsgACgCGBsiEyAAKAIMIhxPBEAgACABIAIgAyAEENILDwsgAigCACIJQQAgCSAFIBNrIgZJIgobIQhBACAJIAobIR0gAigCBCIJQQAgBiAJSyIGGyEUQQAgCSAGGyEgAkAgA0EBIAAoAswBIgkgCUEBTRtBAWoiIWoiD0EBaiILIAMgBGoiEEEIayIZTw0AIAAoAggiFSAcIBMgEyAcSRsiCWohHiAJIAxqIR8gEyAVaiEjIAAoAlwhDSAMQQJqISQgEEEgayEXQSAgACgCwAEiBGshEUHAACAEa60hJ0EEIAAoAsgBIgAgAEEFa0EDTxtBBGshGANAAn8CQAJAAkACQCAYQQFrDgMAAQIDCyADKQAAQoCAgNjLm++NT34gJ4inIQcgAykAAUKAgIDYy5vvjU9+ICeIpwwDCyADKQAAQoCA7PzLm++NT34gJ4inIQcgAykAAUKAgOz8y5vvjU9+ICeIpwwCCyADKQAAQoDGlf3Lm++NT34gJ4inIQcgAykAAUKAxpX9y5vvjU9+ICeIpwwBCyADKAAAQbHz3fF5bCARdiEHIAMoAAFBsfPd8XlsIBF2CyEaIANBgAFqIRYgA0EBaiEOIBUgDCANIAdBAnRqKAIAIgAgCUkbIRIgCCAMaiElICEhBiADIQUCfwNAIAshCiAVIAwgCSAPIgQgJWsiC0siJhshIgJ/AkAgCEUNACAJIAtrQQRJDQAgCyAiaigAAAwBCyAEKAAAQQFzCyEbIA0gB0ECdGogBSAMayIPNgIAIBsgBCgAACIHRgRAQQVBBCAEQQFrLQAAIAsgImoiBkEBay0AAEYiABshByAGIABrIQsgBCAAayEFIB4gECAmGyEbQQEhFiAIIQogFAwCCwJAAkAgACATSQ0AIAUoAAAgACASaigAAEcNACAOIQQMAQsgDSAaQQJ0aiIFKAIAIQACfwJAAkACQAJAIBhBAWsOAwECAwALIAdBsfPd8XlsIBF2DAMLIAQpAABCgICA2Mub741PfiAniKcMAgsgBCkAAEKAgOz8y5vvjU9+ICeIpwwBCyAEKQAAQoDGlf3Lm++NT34gJ4inCyEHIAUgDiAMayIPNgIAAkAgACATSQ0AIA4oAAAgFSAMIAAgCUkbIhIgAGooAABHDQAgByEaIA4hBQwBCyANIAdBAnRqKAIAIQACfwJAAkACQAJAIBhBAWsOAwECAwALIAooAABBsfPd8XlsIBF2DAMLIAopAABCgICA2Mub741PfiAniKcMAgsgCikAAEKAgOz8y5vvjU9+ICeIpwwBCyAKKQAAQoDGlf3Lm++NT34gJ4inCyEaIBUgDCAAIAlJGyESIAYgCmohCyAEIAZqIg8gFk8EQCAWQYABaiEWIAZBAWohBgsgCiEOIAQhBSALIBlJDQEMBAsLIB4gECAAIBxJIgYbIRsgDyAAayIKQQNqIRZBBCEHAn8CQCAAIBJqIgsgIyAfIAYbIg5NDQAgAyAFTw0AA0AgBUEBayIGLQAAIAtBAWsiAC0AAEcNASAHQQFqIQcgACAOSwRAIAAhCyAGIgUgA0sNAQsLIAAhCyAGIQUgBAwBCyAECyEOIAgLIQYgBSAHaiAHIAtqIBAgGyAfENALIAdqIRIgBSADayEIIAEoAgwhAAJAAkAgBSAXTQRAIAAgA/0AAAD9CwAAIAEoAgwhBCAIQRBNBEAgASAEIAhqNgIMIAEoAgQhAAwDCyAEIAP9AAAQ/QsAECAIQSFIDQEgBCAIaiEHIANBEGohACAEQSBqIQQDQCAEIAD9AAAQ/QsAACAEIAD9AAAg/QsAECAAQSBqIQAgBEEgaiIEIAdJDQALDAELIAMgF00EQCAAIAP9AAAA/QsAACAAIBcgA2siB2ohBCAHQRFOBEAgAEEQaiEAA0AgACAD/QAAEP0LAAAgACAD/QAAIP0LABAgA0EgaiEDIABBIGoiACAESQ0ACwsgFyEDIAQhAAsgAyAFTw0AQQAhByADIQQgBSADa0EHcSILBEADQCAAIAQtAAA6AAAgAEEBaiEAIARBAWohBCAHQQFqIgcgC0cNAAsLIAMgBWtBeEsNAANAIAAgBC0AADoAACAAIAQtAAE6AAEgACAELQACOgACIAAgBC0AAzoAAyAAIAQtAAQ6AAQgACAELQAFOgAFIAAgBC0ABjoABiAAIAQtAAc6AAcgAEEIaiEAIARBCGoiBCAFRw0ACwsgASABKAIMIAhqNgIMIAEoAgQhACAIQYCABEkNACABQQE2AiQgASAAIAEoAgBrQQN1NgIoCyAAIBY2AgAgACAIOwEEIBJBA2siBEGAgARPBEAgAUECNgIkIAEgACABKAIAa0EDdTYCKAsgACAEOwEGIAEgAEEIaiIANgIEIAUgEmoiAyAOSwRAIA0gGkECdGogDiAMazYCAAsCQCADIBlLBEAgBiEUIAohCAwBCyAPICRqIQQgD0ECaiEFIA0CfwJAAkACQAJAIBhBAWsOAwABAgMLIA0gBCkAAEKAgIDYy5vvjU9+ICeIp0ECdGogBTYCACADQQJrIgQpAABCgICA2Mub741PfiAniKcMAwsgDSAEKQAAQoCA7PzLm++NT34gJ4inQQJ0aiAFNgIAIANBAmsiBCkAAEKAgOz8y5vvjU9+ICeIpwwCCyANIAQpAABCgMaV/cub741PfiAniKdBAnRqIAU2AgAgA0ECayIEKQAAQoDGlf3Lm++NT34gJ4inDAELIA0gBCgAAEGx893xeWwgEXZBAnRqIAU2AgAgA0ECayIEKAAAQbHz3fF5bCARdgtBAnRqIAQgDGs2AgADQAJAIAYhCCAKIQYgCEUNACADIAxrIgogCGsiBCAJa0F8Sw0AIBUgDCAEIAlJIgUbIARqIgQoAAAgAygAAEcNACADQQRqIARBBGogECAeIBAgBRsgHxDQCyEEIAMgF00EQCABKAIMIAP9AAAA/QsAACABKAIEIQALIABBATYCACAAQQA7AQQgBEEBaiIFQYCABE8EQCABQQI2AiQgASAAIAEoAgBrQQN1NgIoCyAAIAU7AQYgASAAQQhqIgA2AgQgDQJ/AkACQAJAAkAgGEEBaw4DAQIDAAsgAygAAEGx893xeWwgEXYMAwsgAykAAEKAgIDYy5vvjU9+ICeIpwwCCyADKQAAQoCA7PzLm++NT34gJ4inDAELIAMpAABCgMaV/cub741PfiAniKcLQQJ0aiAKNgIAIAghCiAGIRQgAyAEakEEaiIDIBlNDQEMAgsLIAghFCAGIQgLIAMgIWoiD0EBaiILIBlJDQALCyACIAggHSAIGzYCACACIBQgHSAgIAgbICAgHRsgFBs2AgQgECADawvGDQEVfyMAQRBrIg8kACACKAIEIRMgAigCACERIABBADYC3AFBACARIBEgAyADIAAoAgQiByAAKAIMIgZqIhVGaiIFIAdrIgcgBiAHQQEgACgCuAF0IglrIAYgByAGayAJSxsgACgCGBtrIgZLIhYbIQlBACATIAYgE0kiGBshDCADIARqIg1BCGsiFCAFSwRAIA1BIGshECANQQFrIRcgDUEDayEEQQZBBCAAKALIASIGIAZBBE0bIgYgBkEGTxtBBGshGQNAAkACfwJ/AkACQCAJRQ0AIAVBAWoiCCAJaygAACAFKAABRw0AIAVBBWoiByAJayEGIAQgB00EQCAHIQUMAgsgBigAACIKIAciBSgAACILRwRAIAogC3NoQQN2DAMLA0AgBkEEaiEGIAVBBGoiBSAETw0CIAYoAAAiCiAFKAAAIgtGDQALIAUgCiALc2hBA3ZqIAdrDAILIA9B/5Pr3AM2AgwCfwJAAkACQCAZQQFrDgIBAgALIAAgBSANIA9BDGoQ1gsMAgsgACAFIA0gD0EMahDXCwwBCyAAIAUgDSAPQQxqENgLCyILQQNNBEAgACAFIANrIgZB/w9LNgLcASAFIAZBCHZqQQFqIQUMBAsgDygCDCISQQRJBEAgBSEIIAkMAwsCQCADIAVPBEAgBSEIDAELIAUhCCAFQQMgEmsiB2ogFU0NAANAIAVBAWsiCC0AACAHIAhqIgYtAABHBEAgBSEIDAILIAtBAWohCyADIAhPDQEgCCEFIAYgFUsNAAsLIAkhDCASQQNrDAILAkAgBSAXTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIA1JBH8gBSAGLQAAIAUtAABGagUgBQsgB2sLQQRqIQtBASESIAkLIQogCCADayEOIAEoAgwhBQJAAkAgCCAQTQRAIAUgA/0AAAD9CwAAIAEoAgwhBiAOQRBNBEAgASAGIA5qNgIMIAEoAgQhBQwDCyAGIAP9AAAQ/QsAECAOQSFIDQEgBiAOaiEHIANBEGohBSAGQSBqIQYDQCAGIAX9AAAQ/QsAACAGIAX9AAAg/QsAECAFQSBqIQUgBkEgaiIGIAdJDQALDAELIAMgEE0EQCAFIAP9AAAA/QsAACAFIBAgA2siB2ohBiAHQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBAhAwsgAyAITw0AQQAhByAIIAMiBmtBB3EiCQRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgB0EBaiIHIAlHDQALCyADIAhrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCEcNAAsLIAEgASgCDCAOajYCDCABKAIEIQUgDkGAgARJDQAgAUEBNgIkIAEgBSABKAIAa0EDdTYCKAsgBSASNgIAIAUgDjsBBCALQQNrIgZBgIAETwRAIAFBAjYCJCABIAUgASgCAGtBA3U2AigLIAUgBjsBBiABIAVBCGoiBzYCBCAAKALcAQRAIABBADYC3AELIAggC2ohAyAMRQRAIAohCSADIQUMAQsgDCEIIAohCSAUIAMiBUkNAANAIAghCSAKIQggAygAACADIAlrKAAARwRAIAkhDCAIIQkgAyEFDAILIANBBGoiCiAJayEGAn8CQCAEIApNBEAgCiEFDAELIAYoAAAiDCAKIgUoAAAiC0cEQCALIAxzaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgBE8NASAGKAAAIgwgBSgAACILRg0ACyAFIAsgDHNoQQN2aiAKawwBCwJAIAUgF08NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSANSQR/IAUgBi0AACAFLQAARmoFIAULIAprCyEFIAMgEE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQcLIAdBATYCACAHQQA7AQQgBUEBaiIGQYCABE8EQCABQQI2AiQgASAHIAEoAgBrQQN1NgIoCyAHIAY7AQYgASAHQQhqIgc2AgQgAyAFakEEaiEDIAhFBEAgCCEMIAMhBQwCCyAJIQogCCEMIBQgAyIFTw0ACwsgBSAUSQ0ACwsgAiAJIBFBACAWGyAJGzYCACACIAwgESATQQAgGBsiBSAJGyAFIBYbIAwbNgIEIA9BEGokACANIANrC9YEAQ9/IAEgACgCBCIMayIIQQEgACgCvAEiBXQiBmsiBEEAIAQgCE0bIRAgACgCECIEIAhBASAAKAK4AXQiB2sgBCAIIARrIAdLGyAAKAIYGyENIAAoAhwiBCAIIAQgCEsbIQtBICAAKALAAWshB0EBIAAoAsQBdCEOQX8gBXRBf3MhCSAGQQFrIREgACgCXCEGIAAoAtwBIQogACgCZCEPA0AgBCALRwRAIA8gBCAJcUECdGogBiAEIAxqKAAAQbHz3fF5bCAHdkECdGoiBSgCADYCACAFIAQ2AgAgBEEBaiEEIApFDQELCyAAIAg2AhxBAyEEAkAgBiABKAAAQbHz3fF5bCAHdkECdGooAgAiByANSQ0AIAFBA2shACAIQQNqIRIgAkEBayEIIAJBA2shC0EDIQYDQAJAIAcgDGoiBSAGakEDaygAACAAIAZqKAAARw0AAn8CQCABIAtPBEAgASEEDAELIAUoAAAiCSABIgQoAAAiCkcEQCAJIApzaEEDdgwCCwNAIAVBBGohBSAEQQRqIgQgC08NASAFKAAAIgkgBCgAACIKRg0ACyAEIAkgCnNoQQN2aiABawwBCwJAIAQgCE8NACAFLwAAIAQvAABHDQAgBUECaiEFIARBAmohBAsgAiAESwR/IAQgBS0AACAELQAARmoFIAQLIAFrCyIEIAZNDQAgAyASIAdrNgIAIAQhBiABIARqIAJGDQILIAcgEE0EQCAGDwsgDkEBayIORQRAIAYPCyAGIQQgDyAHIBFxQQJ0aigCACIHIA1PDQALCyAEC+QEAg9/AX4gASAAKAIEIgtrIghBASAAKAK8ASIFdCIHayIEQQAgBCAITRshDyAAKAIQIgQgCEEBIAAoArgBdCIGayAEIAggBGsgBksbIAAoAhgbIQwgACgCHCIEIAggBCAISxshBkEBIAAoAsQBdCENQX8gBXRBf3MhCiAHQQFrIRBBwAAgACgCwAFrrSETIAAoAlwhByAAKALcASEJIAAoAmQhDgNAIAQgBkcEQCAOIAQgCnFBAnRqIAcgBCALaikAAEKAgIDYy5vvjU9+IBOIp0ECdGoiBSgCADYCACAFIAQ2AgAgBEEBaiEEIAlFDQELCyAAIAg2AhxBAyEEAkAgByABKQAAQoCAgNjLm++NT34gE4inQQJ0aigCACIHIAxJDQAgAUEDayERIAhBA2ohEiACQQFrIQggAkEDayEKQQMhBgNAAkAgByALaiIFIAZqQQNrKAAAIAYgEWooAABHDQAgBgJ/AkAgASAKTwRAIAEhBAwBCyAFKAAAIgkgASIEKAAAIgBHBEAgACAJc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIApPDQEgBSgAACIJIAQoAAAiAEYNAAsgBCAAIAlzaEEDdmogAWsMAQsCQCAEIAhPDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBIgB2s2AgAgBCEGIAEgBGogAkYNAgsgByAPTQRAIAYPCyANQQFrIg1FBEAgBg8LIAYhBCAOIAcgEHFBAnRqKAIAIgcgDE8NAAsLIAQL5AQCD38BfiABIAAoAgQiC2siCEEBIAAoArwBIgV0IgdrIgRBACAEIAhNGyEPIAAoAhAiBCAIQQEgACgCuAF0IgZrIAQgCCAEayAGSxsgACgCGBshDCAAKAIcIgQgCCAEIAhLGyEGQQEgACgCxAF0IQ1BfyAFdEF/cyEKIAdBAWshEEHAACAAKALAAWutIRMgACgCXCEHIAAoAtwBIQkgACgCZCEOA0AgBCAGRwRAIA4gBCAKcUECdGogByAEIAtqKQAAQoCA7PzLm++NT34gE4inQQJ0aiIFKAIANgIAIAUgBDYCACAEQQFqIQQgCUUNAQsLIAAgCDYCHEEDIQQCQCAHIAEpAABCgIDs/Mub741PfiATiKdBAnRqKAIAIgcgDEkNACABQQNrIREgCEEDaiESIAJBAWshCCACQQNrIQpBAyEGA0ACQCAHIAtqIgUgBmpBA2soAAAgBiARaigAAEcNACAGAn8CQCABIApPBEAgASEEDAELIAUoAAAiCSABIgQoAAAiAEcEQCAAIAlzaEEDdgwCCwNAIAVBBGohBSAEQQRqIgQgCk8NASAFKAAAIgkgBCgAACIARg0ACyAEIAAgCXNoQQN2aiABawwBCwJAIAQgCE8NACAFLwAAIAQvAABHDQAgBUECaiEFIARBAmohBAsgAiAESwR/IAQgBS0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgEiAHazYCACAEIQYgASAEaiACRg0CCyAHIA9NBEAgBg8LIA1BAWsiDUUEQCAGDwsgBiEEIA4gByAQcUECdGooAgAiByAMTw0ACwsgBAuFCwEWfyMAQRBrIgwkACACKAIEIQogAigCACEHIAAoArQBIgUoAgAhESAFKAIEIRIgBSgCDCEFIABBADYC3AEgAyADIAAoAgQiDSAAKAIMIg5qIhVrIAUgEmoiGCARa0ZqIgYgAyAEaiIJQQhrIhZJBEAgCUEgayEPIBIgEiARayAOaiIZayEXQQZBBCAAKALIASIFIAVBBE0bIgUgBUEGTxtBBGshGgNAAkACfwJAAkACQCAGIAcgDWprQQFqIgUgDmtBfEsNACASIAUgGWtqIAUgDWogBSAOSSIFGyIEKAAAIAZBAWoiCCgAAEcNACAGQQVqIARBBGogCSARIAkgBRsgFRDQC0EEaiEQQQEhEwwBCyAMQf+T69wDNgIMAn8CQAJAAkAgGkEBaw4CAQIACyAAIAYgCSAMQQxqENoLDAILIAAgBiAJIAxBDGoQ2wsMAQsgACAGIAkgDEEMahDcCwsiEEEDTQRAIAAgBiADayIFQf8PSzYC3AEgBiAFQQh2akEBaiEGDAQLIAwoAgwiE0EETw0BIAYhCAsgByEUIAoMAQsgE0EDayEUAkACQCADIAZPDQAgFyANIAYgDSATamtBA2oiBSAOSSIEGyAFaiIFIBggFSAEGyIETQ0AA0AgBkEBayIILQAAIAVBAWsiBS0AAEcNASAQQQFqIRAgAyAITw0CIAghBiAEIAVJDQALDAELIAYhCAsgBwshBCAIIANrIQsgASgCDCEFAkACQCAIIA9NBEAgBSAD/QAAAP0LAAAgASgCDCEFIAtBEE0EQCABIAUgC2o2AgwgASgCBCEDDAMLIAUgA/0AABD9CwAQIAtBIUgNASAFIAtqIQcgA0EQaiEDIAVBIGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgB0kNAAsMAQsgAyAPTQRAIAUgA/0AAAD9CwAAIAUgDyADayIGaiEHIAZBEU4EQCAFQRBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAdJDQALCyAHIQUgDyEDCyADIAhPDQBBACEGIAMhByAIIANrQQdxIgoEQANAIAUgBy0AADoAACAFQQFqIQUgB0EBaiEHIAZBAWoiBiAKRw0ACwsgAyAIa0F4Sw0AA0AgBSAHLQAAOgAAIAUgBy0AAToAASAFIActAAI6AAIgBSAHLQADOgADIAUgBy0ABDoABCAFIActAAU6AAUgBSAHLQAGOgAGIAUgBy0ABzoAByAFQQhqIQUgB0EIaiIHIAhHDQALCyABIAEoAgwgC2o2AgwgASgCBCEDIAtBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgEzYCACADIAs7AQQgEEEDayIFQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAU7AQYgASADQQhqIgU2AgQgCCAQaiEDIAAoAtwBBEAgAEEANgLcAQsgBCEKIBQhByADIQYgAyAWSw0AA0ACQCAEIQcgFCEEIAMgByANamsiBiAOa0F8Sw0AIBcgDSAGIA5JIggbIAZqIgYoAAAgAygAAEcNACADQQRqIAZBBGogCSARIAkgCBsgFRDQCyEGIAMgD00EQCABKAIMIAP9AAAA/QsAACABKAIEIQULIAVBATYCACAFQQA7AQQgBkEBaiIIQYCABE8EQCABQQI2AiQgASAFIAEoAgBrQQN1NgIoCyAFIAg7AQYgASAFQQhqIgU2AgQgByEUIAQhCiADIAZqQQRqIgMhBiADIBZNDQEMAgsLIAchCiAEIQcgAyEGCyAGIBZJDQALCyACIAo2AgQgAiAHNgIAIAxBEGokACAJIANrC9gGARV/IAEgACgCBCIKayIJQQEgACgCvAEiBXQiDmsiBEEAIAQgCU0bIREgACgCECIEIAlBASAAKAK4AXQiBmsgBCAJIARrIAZLGyAAKAIYGyEQIAAoAhwiBCAJIAQgCUsbIQZBICAAKALAAWshB0EBIAAoAsQBdCEPIAogACgCDCISaiETQX8gBXRBf3MhCyAOQQFrIRQgACgCXCEIIAAoAtwBIQwgACgCtAEhDSAAKAJkIQ4DQCAEIAZHBEAgDiAEIAtxQQJ0aiAIIAQgCmooAABBsfPd8XlsIAd2QQJ0aiIFKAIANgIAIAUgBDYCACAEQQFqIQQgDEUNAQsLIAAgCTYCHEEDIQYCQCAIIAEoAAAiAEGx893xeWwiFSAHdkECdGooAgAiByAQSQ0AIAFBA2shFiAJQQNqIRcgAkEBayEYIAJBA2shCANAAkAgByAKaiIFIAZqQQNrKAAAIAYgFmooAABHDQAgBgJ/AkAgASAITwRAIAEhBAwBCyAFKAAAIgsgASIEKAAAIgxHBEAgCyAMc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIAhPDQEgBSgAACILIAQoAAAiDEYNAAsgBCALIAxzaEEDdmogAWsMAQsCQCAEIBhPDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBcgB2s2AgAgBCEGIAEgBGogAkcNAAwCCyAHIBFNDQEgD0EBayIPRQ0BIA4gByAUcUECdGooAgAiByAQTw0ACwsgD0UEQCAGDwsgDSgCXCAVQSAgDSgCwAFrdkECdGooAgAiBCANKAIMIg5JBEAgBg8LIA0oAgAiDCANKAIEIgdrIgVBASANKAK8AXQiCGsiCkEAIAUgCk8bIQogCEEBayEIIA0oAmQhCyABQQRqIRAgBSAJakEDaiERA0ACQAJAIAQgB2oiBSgAACAARw0AIBAgBUEEaiACIAwgExDQC0EEaiIFIAZNDQAgAyARIAQgEmprNgIAIAUhBiABIAVqIAJGDQELIAQgCk0EQCAGDwsgD0EBayIPRQRAIAYPCyAGIQUgCyAEIAhxQQJ0aigCACIEIA5PDQELCyAFC+4GAhN/An4gASAAKAIEIglrIghBASAAKAK8ASIFdCIHayIEQQAgBCAITRshECAAKAIQIgQgCEEBIAAoArgBdCIGayAEIAggBGsgBksbIAAoAhgbIQ8gACgCHCIEIAggBCAISxshBkEBIAAoAsQBdCEOIAkgACgCDCIRaiESQX8gBXRBf3MhDCAHQQFrIRNBwAAgACgCwAFrrSEXIAAoAlwhByAAKALcASEKIAAoArQBIQsgACgCZCENA0AgBCAGRwRAIA0gBCAMcUECdGogByAEIAlqKQAAQoCAgNjLm++NT34gF4inQQJ0aiIFKAIANgIAIAUgBDYCACAEQQFqIQQgCkUNAQsLIAAgCDYCHEEDIQYCQCAHIAEpAABCgICA2Mub741PfiIYIBeIp0ECdGooAgAiByAPSQ0AIAFBA2shFCAIQQNqIRUgAkEBayEWIAJBA2shDANAAkAgByAJaiIFIAZqQQNrKAAAIAYgFGooAABHDQAgBgJ/AkAgASAMTwRAIAEhBAwBCyAFKAAAIgogASIEKAAAIgBHBEAgACAKc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIAxPDQEgBSgAACIKIAQoAAAiAEYNAAsgBCAAIApzaEEDdmogAWsMAQsCQCAEIBZPDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBUgB2s2AgAgBCEGIAEgBGogAkcNAAwCCyAHIBBNDQEgDkEBayIORQ0BIA0gByATcUECdGooAgAiByAPTw0ACwsgDkUEQCAGDwsgCygCXCAYQcAAIAsoAsABa62Ip0ECdGooAgAiBCALKAIMIgxJBEAgBg8LIAsoAgAiDyALKAIEIgdrIgVBASALKAK8AXQiCWsiDUEAIAUgDU8bIQ0gCUEBayEKIAsoAmQhACABQQRqIRAgBSAIakEDaiEIIAEoAAAhCQNAAkACQCAEIAdqIgUoAAAgCUcNACAQIAVBBGogAiAPIBIQ0AtBBGoiBSAGTQ0AIAMgCCAEIBFqazYCACAFIQYgASAFaiACRg0BCyAEIA1NBEAgBg8LIA5BAWsiDkUEQCAGDwsgBiEFIAAgBCAKcUECdGooAgAiBCAMTw0BCwsgBQvuBgITfwJ+IAEgACgCBCIJayIIQQEgACgCvAEiBXQiB2siBEEAIAQgCE0bIRAgACgCECIEIAhBASAAKAK4AXQiBmsgBCAIIARrIAZLGyAAKAIYGyEPIAAoAhwiBCAIIAQgCEsbIQZBASAAKALEAXQhDiAJIAAoAgwiEWohEkF/IAV0QX9zIQwgB0EBayETQcAAIAAoAsABa60hFyAAKAJcIQcgACgC3AEhCiAAKAK0ASELIAAoAmQhDQNAIAQgBkcEQCANIAQgDHFBAnRqIAcgBCAJaikAAEKAgOz8y5vvjU9+IBeIp0ECdGoiBSgCADYCACAFIAQ2AgAgBEEBaiEEIApFDQELCyAAIAg2AhxBAyEGAkAgByABKQAAQoCA7PzLm++NT34iGCAXiKdBAnRqKAIAIgcgD0kNACABQQNrIRQgCEEDaiEVIAJBAWshFiACQQNrIQwDQAJAIAcgCWoiBSAGakEDaygAACAGIBRqKAAARw0AIAYCfwJAIAEgDE8EQCABIQQMAQsgBSgAACIKIAEiBCgAACIARwRAIAAgCnNoQQN2DAILA0AgBUEEaiEFIARBBGoiBCAMTw0BIAUoAAAiCiAEKAAAIgBGDQALIAQgACAKc2hBA3ZqIAFrDAELAkAgBCAWTw0AIAUvAAAgBC8AAEcNACAFQQJqIQUgBEECaiEECyACIARLBH8gBCAFLQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAVIAdrNgIAIAQhBiABIARqIAJHDQAMAgsgByAQTQ0BIA5BAWsiDkUNASANIAcgE3FBAnRqKAIAIgcgD08NAAsLIA5FBEAgBg8LIAsoAlwgGEHAACALKALAAWutiKdBAnRqKAIAIgQgCygCDCIMSQRAIAYPCyALKAIAIg8gCygCBCIHayIFQQEgCygCvAF0IglrIg1BACAFIA1PGyENIAlBAWshCiALKAJkIQAgAUEEaiEQIAUgCGpBA2ohCCABKAAAIQkDQAJAAkAgBCAHaiIFKAAAIAlHDQAgECAFQQRqIAIgDyASENALQQRqIgUgBk0NACADIAggBCARams2AgAgBSEGIAEgBWogAkYNAQsgBCANTQRAIAYPCyAOQQFrIg5FBEAgBg8LIAYhBSAAIAQgCnFBAnRqKAIAIgQgDE8NAQsLIAULhQsBFn8jAEEQayIMJAAgAigCBCEKIAIoAgAhByAAKAK0ASIFKAIAIREgBSgCBCESIAUoAgwhBSAAQQA2AtwBIAMgAyAAKAIEIg0gACgCDCIOaiIVayAFIBJqIhggEWtGaiIGIAMgBGoiCUEIayIWSQRAIAlBIGshDyASIBIgEWsgDmoiGWshF0EGQQQgACgCyAEiBSAFQQRNGyIFIAVBBk8bQQRrIRoDQAJAAn8CQAJAAkAgBiAHIA1qa0EBaiIFIA5rQXxLDQAgEiAFIBlraiAFIA1qIAUgDkkiBRsiBCgAACAGQQFqIggoAABHDQAgBkEFaiAEQQRqIAkgESAJIAUbIBUQ0AtBBGohEEEBIRMMAQsgDEH/k+vcAzYCDAJ/AkACQAJAIBpBAWsOAgECAAsgACAGIAkgDEEMahDeCwwCCyAAIAYgCSAMQQxqEN8LDAELIAAgBiAJIAxBDGoQ4AsLIhBBA00EQCAAIAYgA2siBUH/D0s2AtwBIAYgBUEIdmpBAWohBgwECyAMKAIMIhNBBE8NASAGIQgLIAchFCAKDAELIBNBA2shFAJAAkAgAyAGTw0AIBcgDSAGIA0gE2prQQNqIgUgDkkiBBsgBWoiBSAYIBUgBBsiBE0NAANAIAZBAWsiCC0AACAFQQFrIgUtAABHDQEgEEEBaiEQIAMgCE8NAiAIIQYgBCAFSQ0ACwwBCyAGIQgLIAcLIQQgCCADayELIAEoAgwhBQJAAkAgCCAPTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSALQRBNBEAgASAFIAtqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECALQSFIDQEgBSALaiEHIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAdJDQALDAELIAMgD00EQCAFIAP9AAAA/QsAACAFIA8gA2siBmohByAGQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAHSQ0ACwsgByEFIA8hAwsgAyAITw0AQQAhBiADIQcgCCADa0EHcSIKBEADQCAFIActAAA6AAAgBUEBaiEFIAdBAWohByAGQQFqIgYgCkcNAAsLIAMgCGtBeEsNAANAIAUgBy0AADoAACAFIActAAE6AAEgBSAHLQACOgACIAUgBy0AAzoAAyAFIActAAQ6AAQgBSAHLQAFOgAFIAUgBy0ABjoABiAFIActAAc6AAcgBUEIaiEFIAdBCGoiByAIRw0ACwsgASABKAIMIAtqNgIMIAEoAgQhAyALQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIBM2AgAgAyALOwEEIBBBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIFNgIEIAggEGohAyAAKALcAQRAIABBADYC3AELIAQhCiAUIQcgAyEGIAMgFksNAANAAkAgBCEHIBQhBCADIAcgDWprIgYgDmtBfEsNACAXIA0gBiAOSSIIGyAGaiIGKAAAIAMoAABHDQAgA0EEaiAGQQRqIAkgESAJIAgbIBUQ0AshBiADIA9NBEAgASgCDCAD/QAAAP0LAAAgASgCBCEFCyAFQQE2AgAgBUEAOwEEIAZBAWoiCEGAgARPBEAgAUECNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAIOwEGIAEgBUEIaiIFNgIEIAchFCAEIQogAyAGakEEaiIDIQYgAyAWTQ0BDAILCyAHIQogBCEHIAMhBgsgBiAWSQ0ACwsgAiAKNgIEIAIgBzYCACAMQRBqJAAgCSADawuqCAEVfyABIAAoAgQiB2siC0EBIAAoArwBIgV0IghrIgRBACAEIAtNGyEOIAAoAhAiBCALQQEgACgCuAF0IgZrIAQgCyAEayAGSxsgACgCGBshDyAAKAIcIgQgCyAEIAtLGyEQIAAoArQBIhEoAlwgASgAAEGx893xeWxBIiARKALAAWt2QQR0aiESQSAgACgCwAFrIQZBASAAKALEAXQhDCAHIAAoAgwiFWohFEF/IAV0QX9zIQkgCEEBayETIAAoAlwhCCAAKALcASENIAAoAmQhCgNAIAQgEEcEQCAKIAQgCXFBAnRqIAggBCAHaigAAEGx893xeWwgBnZBAnRqIgUoAgA2AgAgBSAENgIAIARBAWohBCANRQ0BCwsgACALNgIcAkAgDyAIIAEoAAAiEEGx893xeWwgBnZBAnRqKAIAIghLBEBBAyEGDAELIAFBA2shFiALQQNqIRcgAkEBayEYIAJBA2shCUEDIQYDQAJAIAcgCGoiBSAGakEDaygAACAGIBZqKAAARw0AIAYCfwJAIAEgCU8EQCABIQQMAQsgBSgAACINIAEiBCgAACIARwRAIAAgDXNoQQN2DAILA0AgBUEEaiEFIARBBGoiBCAJTw0BIAUoAAAiDSAEKAAAIgBGDQALIAQgACANc2hBA3ZqIAFrDAELAkAgBCAYTw0AIAUvAAAgBC8AAEcNACAFQQJqIQUgBEECaiEECyACIARLBH8gBCAFLQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAXIAhrNgIAIAQhBiABIARqIAJHDQAMAgsgCCAOTQ0BIAxBAWsiDEUNASAKIAggE3FBAnRqKAIAIgggD08NAAsLIBEoAgAiACAVIBEoAgQiCGprIRMgEigCDCEOIBEoAmQhDQJAAkAgDEUEQEEAIQcMAQtBAyAMIAxBA08bIQcgAUEEaiEJIAsgE2pBA2ohD0EAIQQgBiEKA0AgEiAEQQJ0aigCACIFRQRAIAoPCwJAIAUgCGoiBigAACAQRw0AIAkgBkEEaiACIAAgFBDQC0EEaiIGIApNDQAgAyAPIAVrNgIAIAYhCiABIAZqIAJGDQMLIARBAWoiBCAHRw0ACyAKIQYLIAwgB2siBCAOQf8BcSIFIAQgBUkbIglFDQAgCUEDcSEHQQAhBUEAIQQgCUEETwRAIAlB/AFxIQoDQCAEQQRqIgQgCkcNAAsLIAcEQANAIARBAWohBCAFQQFqIgUgB0cNAAsLIA5BCHYhBCABQQRqIQwgCyATakEDaiESQQAhBQNAAkAgCCANIARBAnRqKAIAIgpqIgcoAAAgEEcNACAMIAdBBGogAiAAIBQQ0AtBBGoiByAGTQ0AIAMgEiAKazYCACAHIgYgAWogAkYNAgsgBEEBaiEEIAVBAWoiBSAJRw0ACwsgBgu7CAIUfwJ+IAEgACgCBCIHayILQQEgACgCvAEiBXQiBmsiBEEAIAQgC00bIQ8gACgCECIEIAtBASAAKAK4AXQiCGsgBCALIARrIAhLGyAAKAIYGyEOIAAoAhwiBCALIAQgC0sbIQggACgCtAEiECgCXCABKQAAQoCAgNjLm++NT34iGUHCACAQKALAAWutiKdBBHRqIRFBASAAKALEAXQhDCAHIAAoAgwiFGohE0F/IAV0QX9zIQkgBkEBayESQcAAIAAoAsABa60hGCAAKAJcIQYgACgC3AEhDSAAKAJkIQoDQCAEIAhHBEAgCiAEIAlxQQJ0aiAGIAQgB2opAABCgICA2Mub741PfiAYiKdBAnRqIgUoAgA2AgAgBSAENgIAIARBAWohBCANRQ0BCwsgACALNgIcAkAgDiAGIBkgGIinQQJ0aigCACIISwRAQQMhBgwBCyABQQNrIRUgC0EDaiEWIAJBAWshFyACQQNrIQlBAyEGA0ACQCAHIAhqIgUgBmpBA2soAAAgBiAVaigAAEcNAAJ/AkAgASAJTwRAIAEhBAwBCyAFKAAAIg0gASIEKAAAIgBHBEAgACANc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIAlPDQEgBSgAACINIAQoAAAiAEYNAAsgBCAAIA1zaEEDdmogAWsMAQsCQCAEIBdPDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBCAGTQ0AIAMgFiAIazYCACAEIQYgASAEaiACRw0ADAILIAggD00NASAMQQFrIgxFDQEgCiAIIBJxQQJ0aigCACIIIA5PDQALCyAQKAIAIgAgFCAQKAIEIghqayESIBEoAgwhDyAQKAJkIQ0CQAJAIAxFBEBBACEHDAELQQMgDCAMQQNPGyEHIAFBBGohCSALIBJqQQNqIQ5BACEEIAYhCgNAIBEgBEECdGooAgAiBUUEQCAKDwsCQCAFIAhqIgYoAAAgASgAAEcNACAJIAZBBGogAiAAIBMQ0AtBBGoiBiAKTQ0AIAMgDiAFazYCACAGIQogASAGaiACRg0DCyAEQQFqIgQgB0cNAAsgCiEGCyAMIAdrIgQgD0H/AXEiBSAEIAVJGyIJRQ0AIAlBA3EhB0EAIQVBACEEIAlBBE8EQCAJQfwBcSEKA0AgBEEEaiIEIApHDQALCyAHBEADQCAEQQFqIQQgBUEBaiIFIAdHDQALCyAPQQh2IQQgAUEEaiERIAsgEmpBA2ohDiABKAAAIQxBACEFA0ACQCAIIA0gBEECdGooAgAiCmoiBygAACAMRw0AIBEgB0EEaiACIAAgExDQC0EEaiIHIAZNDQAgAyAOIAprNgIAIAciBiABaiACRg0CCyAEQQFqIQQgBUEBaiIFIAlHDQALCyAGC7sIAhR/An4gASAAKAIEIgdrIgtBASAAKAK8ASIFdCIGayIEQQAgBCALTRshDyAAKAIQIgQgC0EBIAAoArgBdCIIayAEIAsgBGsgCEsbIAAoAhgbIQ4gACgCHCIEIAsgBCALSxshCCAAKAK0ASIQKAJcIAEpAABCgIDs/Mub741PfiIZQcIAIBAoAsABa62Ip0EEdGohEUEBIAAoAsQBdCEMIAcgACgCDCIUaiETQX8gBXRBf3MhCSAGQQFrIRJBwAAgACgCwAFrrSEYIAAoAlwhBiAAKALcASENIAAoAmQhCgNAIAQgCEcEQCAKIAQgCXFBAnRqIAYgBCAHaikAAEKAgOz8y5vvjU9+IBiIp0ECdGoiBSgCADYCACAFIAQ2AgAgBEEBaiEEIA1FDQELCyAAIAs2AhwCQCAOIAYgGSAYiKdBAnRqKAIAIghLBEBBAyEGDAELIAFBA2shFSALQQNqIRYgAkEBayEXIAJBA2shCUEDIQYDQAJAIAcgCGoiBSAGakEDaygAACAGIBVqKAAARw0AAn8CQCABIAlPBEAgASEEDAELIAUoAAAiDSABIgQoAAAiAEcEQCAAIA1zaEEDdgwCCwNAIAVBBGohBSAEQQRqIgQgCU8NASAFKAAAIg0gBCgAACIARg0ACyAEIAAgDXNoQQN2aiABawwBCwJAIAQgF08NACAFLwAAIAQvAABHDQAgBUECaiEFIARBAmohBAsgAiAESwR/IAQgBS0AACAELQAARmoFIAQLIAFrCyIEIAZNDQAgAyAWIAhrNgIAIAQhBiABIARqIAJHDQAMAgsgCCAPTQ0BIAxBAWsiDEUNASAKIAggEnFBAnRqKAIAIgggDk8NAAsLIBAoAgAiACAUIBAoAgQiCGprIRIgESgCDCEPIBAoAmQhDQJAAkAgDEUEQEEAIQcMAQtBAyAMIAxBA08bIQcgAUEEaiEJIAsgEmpBA2ohDkEAIQQgBiEKA0AgESAEQQJ0aigCACIFRQRAIAoPCwJAIAUgCGoiBigAACABKAAARw0AIAkgBkEEaiACIAAgExDQC0EEaiIGIApNDQAgAyAOIAVrNgIAIAYhCiABIAZqIAJGDQMLIARBAWoiBCAHRw0ACyAKIQYLIAwgB2siBCAPQf8BcSIFIAQgBUkbIglFDQAgCUEDcSEHQQAhBUEAIQQgCUEETwRAIAlB/AFxIQoDQCAEQQRqIgQgCkcNAAsLIAcEQANAIARBAWohBCAFQQFqIgUgB0cNAAsLIA9BCHYhBCABQQRqIREgCyASakEDaiEOIAEoAAAhDEEAIQUDQAJAIAggDSAEQQJ0aigCACIKaiIHKAAAIAxHDQAgESAHQQRqIAIgACATENALQQRqIgcgBk0NACADIA4gCms2AgAgByIGIAFqIAJGDQILIARBAWohBCAFQQFqIgUgCUcNAAsLIAYLtBICGn8CfiMAQRBrIg4kACACKAIEIRUgAigCACETIABBADYC3AEgEyADIAMgACgCBCIQIAAoAgwiBmoiGUZqIgUgEGsiByAGIAdBASAAKAK4AXQiCGsgBiAHIAZrIAhLGyAAKAIYG2siBkshFiAGIBVJIRogACgCxAEiD0EESyEXQQZBBCAAKALIASIGIAZBBE0bIgYgBkEGTxshCiAAKAIcIgYgBkEIIAMgBGoiC0EPayIcIAYgEGoiB2siBCAEQQhPG0EAIAcgC0EQayIRTRtqIgRJBEAgAEEsaiEIQRggACgCJCIHayEJQTggB2utIR8gACkDUCIgpyENIApBBWshDANAIAYgEGohByAIIAZBB3FBAnRqAn8CQAJAAkAgDA4CAQIACyAHKAAAQbHz3fF5bCANcyAJdgwCCyAHKQAAQoCAgNjLm++NT34gIIUgH4inDAELIAcpAABCgIDs/Mub741PfiAghSAfiKcLNgIAIAZBAWoiBiAERw0ACwtBACATIBYbIQhBACAVIBobIQ0gBSARSQRAQQYgD0EEIBcbIgYgBkEGTxshGCAAQSxqIRcgC0EgayESIAtBAWshGyALQQNrIQQgCkEFayEdIApBBGshHgNAAkACfwJ/AkACQCAIRQ0AIAVBAWoiCSAIaygAACAFKAABRw0AIAVBBWoiByAIayEGIAQgB00EQCAHIQUMAgsgBigAACIMIAciBSgAACIKRwRAIAogDHNoQQN2DAMLA0AgBkEEaiEGIAVBBGoiBSAETw0CIAYoAAAiDCAFKAAAIgpGDQALIAUgCiAMc2hBA3ZqIAdrDAILIA5B/5Pr3AM2AgwCfwJAAkACQCAeQQFrDgIBAgALAkACQAJAIBhBBWsOAgECAAsgACAFIAsgDkEMahDiCwwECyAAIAUgCyAOQQxqEOMLDAMLIAAgBSALIA5BDGoQ5AsMAgsCQAJAAkAgGEEFaw4CAQIACyAAIAUgCyAOQQxqEOULDAMLIAAgBSALIA5BDGoQ5gsMAgsgACAFIAsgDkEMahDnCwwBCwJAAkACQCAYQQVrDgIBAgALIAAgBSALIA5BDGoQ6AsMAgsgACAFIAsgDkEMahDpCwwBCyAAIAUgCyAOQQxqEOoLCyIKQQNNBEAgACAFIANrIgZB/w9LNgLcASAFIAZBCHZqQQFqIQUMBAsgDigCDCIUQQRJBEAgBSEJIAgMAwsCQCADIAVPBEAgBSEJDAELIAUhCSAFQQMgFGsiB2ogGU0NAANAIAVBAWsiCS0AACAHIAlqIgYtAABHBEAgBSEJDAILIApBAWohCiADIAlPDQEgCSEFIAYgGUsNAAsLIAghDSAUQQNrDAILAkAgBSAbTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIAtJBH8gBSAGLQAAIAUtAABGagUgBQsgB2sLQQRqIQpBASEUIAgLIQwgCSADayEPIAEoAgwhBQJAAkAgCSASTQRAIAUgA/0AAAD9CwAAIAEoAgwhBiAPQRBNBEAgASAGIA9qNgIMIAEoAgQhBQwDCyAGIAP9AAAQ/QsAECAPQSFIDQEgBiAPaiEHIANBEGohBSAGQSBqIQYDQCAGIAX9AAAQ/QsAACAGIAX9AAAg/QsAECAFQSBqIQUgBkEgaiIGIAdJDQALDAELIAMgEk0EQCAFIAP9AAAA/QsAACAFIBIgA2siB2ohBiAHQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBIhAwsgAyAJTw0AQQAhByAJIAMiBmtBB3EiCARAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgB0EBaiIHIAhHDQALCyADIAlrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCUcNAAsLIAEgASgCDCAPajYCDCABKAIEIQUgD0GAgARJDQAgAUEBNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAUNgIAIAUgDzsBBCAKQQNrIgZBgIAETwRAIAFBAjYCJCABIAUgASgCAGtBA3U2AigLIAUgBjsBBiABIAVBCGoiBzYCBCAAKALcAQRAIAAoAhwiBSAFQQggHCAFIBBqIgZrIgMgA0EITxtBACAGIBFNG2oiA0kEQEEYIAAoAiQiBmshCEE4IAZrrSEfIAApA1AiIKchDwNAIAUgEGohBiAXIAVBB3FBAnRqAn8CQAJAAkAgHQ4CAQIACyAGKAAAQbHz3fF5bCAPcyAIdgwCCyAGKQAAQoCAgNjLm++NT34gIIUgH4inDAELIAYpAABCgIDs/Mub741PfiAghSAfiKcLNgIAIAVBAWoiBSADRw0ACwsgAEEANgLcAQsgCSAKaiEDIA1FBEAgDCEIIAMhBQwBCyANIQkgDCEIIBEgAyIFSQ0AA0AgCSEIIAwhCSADKAAAIAMgCGsoAABHBEAgCCENIAkhCCADIQUMAgsgA0EEaiIMIAhrIQYCfwJAIAQgDE0EQCAMIQUMAQsgBigAACINIAwiBSgAACIKRwRAIAogDXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAETw0BIAYoAAAiDSAFKAAAIgpGDQALIAUgCiANc2hBA3ZqIAxrDAELAkAgBSAbTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIAtJBH8gBSAGLQAAIAUtAABGagUgBQsgDGsLIQUgAyASTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBwsgB0EBNgIAIAdBADsBBCAFQQFqIgZBgIAETwRAIAFBAjYCJCABIAcgASgCAGtBA3U2AigLIAcgBjsBBiABIAdBCGoiBzYCBCADIAVqQQRqIQMgCUUEQCAJIQ0gAyEFDAILIAghDCAJIQ0gESADIgVPDQALCyAFIBFJDQALCyACIAggE0EAIBYbIAgbNgIAIAIgDSATIBVBACAaGyIFIAgbIAUgFhsgDRs2AgQgDkEQaiQAIAsgA2sL/AsCFH8BfiMAQYACayIRJAAgASAAKAIEIg1rIQggACgCuAEhFiAAKAIQIRIgACgCGCEXIAAoAsQBIRUgACkDUCEYIAAoAiQhEyAAKAIoIQ8gACgCXCEQAkAgACgC3AFFBEAgAEEsaiEJAkAgCCAAKAIcIgRrQYEDSQRAIA8hDCAQIQoMAQsgDyEMIBAhCiAEQZ9/TQRAIA1BCGohDCAEQd8AaiEKQRggE2shDgNAIAkgBEEHcUECdGoiBigCACEFIAYgACgCUCAEIAxqKAAAQbHz3fF5bHMgDnY2AgAgDyAFQQR2QfD///8AcSILaiIGQQ9BACAGLQAAIgdBD3FBAUYbIAdBAWtBD3FqIgc6AAAgBiAHaiAFOgAAIBAgC0ECdGogB0ECdGogBDYCACAEIApHIQUgBEEBaiEEIAUNAAsgACgCKCEMIAAoAlwhCgsgCEEgayIEIARBCCABQQFqIgUgBCANaiIGa0EBaiIHIAdBCE8bQQAgBSAGTxtqIgZPDQBBGCAAKAIkayEHIAAoAlAhCyAEIQUDQCAJIAVBB3FBAnRqIAUgDWooAABBsfPd8XlsIAtzIAd2NgIAIAVBAWoiBSAGRw0ACwsgBCAISQRAIAAoAgRBCGohDkEYIAAoAiRrIRQDQCAJIARBB3FBAnRqIgYoAgAhBSAGIAAoAlAgBCAOaigAAEGx893xeWxzIBR2NgIAIAwgBUEEdkHw////AHEiC2oiBkEPQQAgBi0AACIHQQ9xQQFGGyAHQQFrQQ9xaiIHOgAAIAYgB2ogBToAACAKIAtBAnRqIAdBAnRqIAQ2AgAgBEEBaiIEIAhJDQALCyAAIAg2AhwgCSAIQQdxQQJ0aiIEKAIAIQogBCAYpyAIIA1qKAAIQbHz3fF5bHNBGCATa3Y2AgAMAQsgASgAACEEIAAgCDYCHCAYpyAEQbHz3fF5bHNBGCATa3YhCgsgACAAKAJYIApqNgJYIA8gCkEEdkHw////AHEiBGoiCS0AACEGIBAgBEECdGohB0EAIQsCQCAKQf8BcUGBgoQIbCIEIAkoAAxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCSgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAkoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCSgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVB//8DRg0AIBIgCEEBIBZ0IgRrIBIgCCASayAESxsgFxshDEEBQQQgFSAVQQRPG3QhBCAFQX9zIgVB//8DcSAGQQ9xdiAFQQAgBmtBD3F0cq1C//8DgyEYA0BBACAYp2ggGFAbIAZqQQ9xIgUEQCAHIAVBAnRqKAIAIgUgDEkNAiARIAtBAnRqIAU2AgAgC0EBaiELIARBAWshBAsgGEIBfSAYgyIYUA0BIAQNAAsLIAkgBkEBa0EPcUEPQQAgBkEPcUEBRhtqIgQ6AAAgBCAJaiAKOgAAIAAgACgCHCIFQQFqNgIcIAcgBEECdGogBTYCAAJAIAtFBEBBAyEGDAELIAFBA2shCiAIQQNqIRQgAkEBayEOIAJBA2shB0EAIQVBAyEGA0ACQCANIBEgBUECdGooAgAiDGoiACAGakEDaygAACAGIApqKAAARw0AIAYCfwJAIAEgB08EQCABIQQMAQsgACgAACIIIAEiBCgAACIJRwRAIAggCXNoQQN2DAILA0AgAEEEaiEAIARBBGoiBCAHTw0BIAAoAAAiCCAEKAAAIglGDQALIAQgCCAJc2hBA3ZqIAFrDAELAkAgBCAOTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAUIAxrNgIAIAQhBiABIARqIAJGDQILIAVBAWoiBSALRw0ACwsgEUGAAmokACAGC5INAhR/AX4jAEGAAmsiESQAIAEgACgCBCIOayEJIAAoArgBIRYgACgCECESIAAoAhghFyAAKALEASEVIAApA1AhGCAAKAIkIRMgACgCKCEPIAAoAlwhEAJAIAAoAtwBRQRAIABBLGohCAJAIAkgACgCHCIEa0GBA0kEQCAPIQsgECENDAELIA8hCyAQIQ0gBEGff00EQCAOQQhqIQsgBEHfAGohDUEYIBNrIQwDQCAIIARBB3FBAnRqIgcoAgAhBSAHIAAoAlAgBCALaigAAEGx893xeWxzIAx2NgIAIA8gBUEDdkHg////AXEiCmoiB0EfQQAgBy0AACIGQR9xQQFGGyAGQQFrQR9xaiIGOgAAIAYgB2ogBToAACAQIApBAnRqIAZBAnRqIAQ2AgAgBCANRyEFIARBAWohBCAFDQALIAAoAlwhDSAAKAIoIQsLIAlBIGsiBCAEQQggAUEBaiIFIAQgDmoiB2tBAWoiBiAGQQhPG0EAIAUgB08baiIHTw0AQRggACgCJGshBiAAKAJQIQogBCEFA0AgCCAFQQdxQQJ0aiAFIA5qKAAAQbHz3fF5bCAKcyAGdjYCACAFQQFqIgUgB0cNAAsLIAQgCUkEQCAAKAIEQQhqIQxBGCAAKAIkayEUA0AgCCAEQQdxQQJ0aiIHKAIAIQUgByAAKAJQIAQgDGooAABBsfPd8XlscyAUdjYCACALIAVBA3ZB4P///wFxIgpqIgdBH0EAIActAAAiBkEfcUEBRhsgBkEBa0EfcWoiBjoAACAGIAdqIAU6AAAgDSAKQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAJSQ0ACwsgACAJNgIcIAggCUEHcUECdGoiBCgCACEMIAQgGKcgCSAOaigACEGx893xeWxzQRggE2t2NgIADAELIAEoAAAhBCAAIAk2AhwgGKcgBEGx893xeWxzQRggE2t2IQwLIAAgACgCWCAMajYCWEEDIQcgDyAMQQN2QeD///8BcSIEaiIILQAAIQYgECAEQQJ0aiELQQAhCgJAIAxB/wFxQYGChAhsIgQgCCgAHHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAIKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCCgAFCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAIKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCCgADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAIKAAIIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCCgABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAIKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBUF/Rg0AIBIgCUEBIBZ0IgRrIBIgCSASayAESxsgFxshDUEBQQUgFSAVQQVPG3QhBCAFQX9zIAZ4rSEYA0BBACAYp2ggGFAbIAZqQR9xIgUEQCALIAVBAnRqKAIAIgUgDUkNAiARIApBAnRqIAU2AgAgCkEBaiEKIARBAWshBAsgGEIBfSAYgyIYUA0BIAQNAAsLIAggBkEBa0EfcUEfQQAgBkEfcUEBRhtqIgQ6AAAgBCAIaiAMOgAAIAAgACgCHCIFQQFqNgIcIAsgBEECdGogBTYCAAJAIApFDQAgAUEDayENIAlBA2ohFCACQQFrIQwgAkEDayEGQQAhBQNAAkAgDiARIAVBAnRqKAIAIgtqIgAgB2pBA2soAAAgByANaigAAEcNACAHAn8CQCABIAZPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiCEcEQCAIIAlzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgBk8NASAAKAAAIgkgBCgAACIIRg0ACyAEIAggCXNoQQN2aiABawwBCwJAIAQgDE8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgFCALazYCACAEIQcgASAEaiACRg0CCyAFQQFqIgUgCkcNAAsLIBFBgAJqJAAgBwuhEAIUfwF+IwBBgAJrIhEkACABIAAoAgQiDWshCCAAKAK4ASEWIAAoAhAhEiAAKAIYIRcgACgCxAEhFSAAKQNQIRggACgCJCETIAAoAighDyAAKAJcIRACQCAAKALcAUUEQCAAQSxqIQsCQCAIIAAoAhwiBGtBgQNJBEAgDyEMIBAhCQwBCyAPIQwgECEJIARBn39NBEAgDUEIaiEMIARB3wBqIQlBGCATayEOA0AgCyAEQQdxQQJ0aiIGKAIAIQUgBiAAKAJQIAQgDGooAABBsfPd8XlscyAOdjYCACAPIAVBAnZBwP///wNxIgpqIgZBP0EAIAYtAAAiB0E/cUEBRhsgB0EBa0E/cWoiBzoAACAGIAdqIAU6AAAgECAKQQJ0aiAHQQJ0aiAENgIAIAQgCUchBSAEQQFqIQQgBQ0ACyAAKAIoIQwgACgCXCEJCyAIQSBrIgQgBEEIIAFBAWoiBSAEIA1qIgZrQQFqIgcgB0EITxtBACAFIAZPG2oiBk8NAEEYIAAoAiRrIQcgACgCUCEKIAQhBQNAIAsgBUEHcUECdGogBSANaigAAEGx893xeWwgCnMgB3Y2AgAgBUEBaiIFIAZHDQALCyAEIAhJBEAgACgCBEEIaiEOQRggACgCJGshFANAIAsgBEEHcUECdGoiBigCACEFIAYgACgCUCAEIA5qKAAAQbHz3fF5bHMgFHY2AgAgDCAFQQJ2QcD///8DcSIKaiIGQT9BACAGLQAAIgdBP3FBAUYbIAdBAWtBP3FqIgc6AAAgBiAHaiAFOgAAIAkgCkECdGogB0ECdGogBDYCACAEQQFqIgQgCEkNAAsLIAAgCDYCHCALIAhBB3FBAnRqIgQoAgAhCSAEIBinIAggDWooAAhBsfPd8Xlsc0EYIBNrdjYCAAwBCyABKAAAIQQgACAINgIcIBinIARBsfPd8Xlsc0EYIBNrdiEJCyAAIAAoAlggCWo2AlggDyAJQQJ2QcD///8DcSIEaiIGLQAAIQcgECAEQQJ0aiELQQAhCgJAIAlB/wFxQYGChAhsIgQgBigAPHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAGKAA4IARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigANCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAwIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigALCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAoIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnKtQgiGIAYoACQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoACAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigAHCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAGCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAUIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoAAwgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoAAggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHathCIYQn9RDQAgEiAIQQEgFnQiBGsgEiAIIBJrIARLGyAXGyEMQQFBBiAVIBVBBk8bdCEEIBhCf4UgB62KIRgDQCAYpyIFaCAYQiCIp2hBIHMgBRsgB2pBP3EiBQRAIAsgBUECdGooAgAiBSAMSQ0CIBEgCkECdGogBTYCACAKQQFqIQogBEEBayEECyAYQgF9IBiDIhhQDQEgBA0ACwsgBiAHQQFrQT9xQT9BACAHQT9xQQFGG2oiBDoAACAEIAZqIAk6AAAgACAAKAIcIgVBAWo2AhwgCyAEQQJ0aiAFNgIAAkAgCkUEQEEDIQYMAQsgAUEDayEJIAhBA2ohFCACQQFrIQ4gAkEDayEHQQAhAEEDIQYDQAJAIA0gESAAQQJ0aigCACIMaiIFIAZqQQNrKAAAIAYgCWooAABHDQAgBgJ/AkAgASAHTwRAIAEhBAwBCyAFKAAAIgggASIEKAAAIgtHBEAgCCALc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIAdPDQEgBSgAACIIIAQoAAAiC0YNAAsgBCAIIAtzaEEDdmogAWsMAQsCQCAEIA5PDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBQgDGs2AgAgBCEGIAEgBGogAkYNAgsgAEEBaiIAIApHDQALCyARQYACaiQAIAYLlAwCE38DfiMAQYACayIRJAAgASAAKAIEIg1rIQggACgCuAEhFSAAKAIQIQ4gACgCGCEWIAAoAsQBIRQgACkDUCEYIAAoAiQhEiAAKAIoIQ8gACgCXCEQAkAgACgC3AFFBEAgAEEsaiEJAkAgCCAAKAIcIgRrQYEDSQRAIA8hDCAQIQoMAQsgDyEMIBAhCiAEQZ9/TQRAIA1BCGohDCAEQd8AaiEKQTggEmutIRcDQCAJIARBB3FBAnRqIgYoAgAhBSAGIAApA1AgBCAMaikAAEKAgIDYy5vvjU9+hSAXiD4CACAPIAVBBHZB8P///wBxIgtqIgZBD0EAIAYtAAAiB0EPcUEBRhsgB0EBa0EPcWoiBzoAACAGIAdqIAU6AAAgECALQQJ0aiAHQQJ0aiAENgIAIAQgCkchBSAEQQFqIQQgBQ0ACyAAKAIoIQwgACgCXCEKCyAIQSBrIgQgBEEIIAFBAWoiBSAEIA1qIgZrQQFqIgcgB0EITxtBACAFIAZPG2oiBk8NAEE4IAAoAiRrrSEXIAApA1AhGSAEIQUDQCAJIAVBB3FBAnRqIAUgDWopAABCgICA2Mub741PfiAZhSAXiD4CACAFQQFqIgUgBkcNAAsLIAQgCEkEQCAAKAIEQQhqIRNBOCAAKAIka60hFwNAIAkgBEEHcUECdGoiBigCACEFIAYgACkDUCAEIBNqKQAAQoCAgNjLm++NT36FIBeIPgIAIAwgBUEEdkHw////AHEiC2oiBkEPQQAgBi0AACIHQQ9xQQFGGyAHQQFrQQ9xaiIHOgAAIAYgB2ogBToAACAKIAtBAnRqIAdBAnRqIAQ2AgAgBEEBaiIEIAhJDQALCyAAIAg2AhwgCSAIQQdxQQJ0aiIEKAIAIQogBCAIIA1qKQAIQoCAgNjLm++NT34gGIVBOCASa62IPgIADAELIAEpAAAhFyAAIAg2AhwgF0KAgIDYy5vvjU9+IBiFQTggEmutiKchCgsgACAAKAJYIApqNgJYIA8gCkEEdkHw////AHEiBGoiCS0AACEGIBAgBEECdGohB0EAIQsCQCAKQf8BcUGBgoQIbCIEIAkoAAxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCSgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAkoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCSgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVB//8DRg0AIA4gCEEBIBV0IgRrIA4gCCAOayAESxsgFhshDEEBQQQgFCAUQQRPG3QhBCAFQX9zIgVB//8DcSAGQQ9xdiAFQQAgBmtBD3F0cq1C//8DgyEXA0BBACAXp2ggF1AbIAZqQQ9xIgUEQCAHIAVBAnRqKAIAIgUgDEkNAiARIAtBAnRqIAU2AgAgC0EBaiELIARBAWshBAsgF0IBfSAXgyIXUA0BIAQNAAsLIAkgBkEBa0EPcUEPQQAgBkEPcUEBRhtqIgQ6AAAgBCAJaiAKOgAAIAAgACgCHCIFQQFqNgIcIAcgBEECdGogBTYCAAJAIAtFBEBBAyEGDAELIAFBA2shCiAIQQNqIQ4gAkEBayETIAJBA2shB0EAIQVBAyEGA0ACQCANIBEgBUECdGooAgAiDGoiACAGakEDaygAACAGIApqKAAARw0AIAYCfwJAIAEgB08EQCABIQQMAQsgACgAACIIIAEiBCgAACIJRwRAIAggCXNoQQN2DAILA0AgAEEEaiEAIARBBGoiBCAHTw0BIAAoAAAiCCAEKAAAIglGDQALIAQgCCAJc2hBA3ZqIAFrDAELAkAgBCATTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAOIAxrNgIAIAQhBiABIARqIAJGDQILIAVBAWoiBSALRw0ACwsgEUGAAmokACAGC6oNAhN/A34jAEGAAmsiEiQAIAEgACgCBCIOayEJIAAoArgBIRUgACgCECEPIAAoAhghFiAAKALEASEUIAApA1AhGCAAKAIkIRMgACgCKCEQIAAoAlwhEQJAIAAoAtwBRQRAIABBLGohBwJAIAkgACgCHCIEa0GBA0kEQCAQIQogESEMDAELIBAhCiARIQwgBEGff00EQCAOQQhqIQogBEHfAGohDEE4IBNrrSEXA0AgByAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgCmopAABCgICA2Mub741PfoUgF4g+AgAgECAFQQN2QeD///8BcSILaiIGQR9BACAGLQAAIghBH3FBAUYbIAhBAWtBH3FqIgg6AAAgBiAIaiAFOgAAIBEgC0ECdGogCEECdGogBDYCACAEIAxHIQUgBEEBaiEEIAUNAAsgACgCXCEMIAAoAighCgsgCUEgayIEIARBCCABQQFqIgUgBCAOaiIGa0EBaiIIIAhBCE8bQQAgBSAGTxtqIgZPDQBBOCAAKAIka60hFyAAKQNQIRkgBCEFA0AgByAFQQdxQQJ0aiAFIA5qKQAAQoCAgNjLm++NT34gGYUgF4g+AgAgBUEBaiIFIAZHDQALCyAEIAlJBEAgACgCBEEIaiENQTggACgCJGutIRcDQCAHIARBB3FBAnRqIgYoAgAhBSAGIAApA1AgBCANaikAAEKAgIDYy5vvjU9+hSAXiD4CACAKIAVBA3ZB4P///wFxIgtqIgZBH0EAIAYtAAAiCEEfcUEBRhsgCEEBa0EfcWoiCDoAACAGIAhqIAU6AAAgDCALQQJ0aiAIQQJ0aiAENgIAIARBAWoiBCAJSQ0ACwsgACAJNgIcIAcgCUEHcUECdGoiBCgCACENIAQgCSAOaikACEKAgIDYy5vvjU9+IBiFQTggE2utiD4CAAwBCyABKQAAIRcgACAJNgIcIBdCgICA2Mub741PfiAYhUE4IBNrrYinIQ0LIAAgACgCWCANajYCWEEDIQYgECANQQN2QeD///8BcSIEaiIHLQAAIQggESAEQQJ0aiEKQQAhCwJAIA1B/wFxQYGChAhsIgQgBygAHHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAHKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygAFCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAIIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBUF/Rg0AIA8gCUEBIBV0IgRrIA8gCSAPayAESxsgFhshDEEBQQUgFCAUQQVPG3QhBCAFQX9zIAh4rSEXA0BBACAXp2ggF1AbIAhqQR9xIgUEQCAKIAVBAnRqKAIAIgUgDEkNAiASIAtBAnRqIAU2AgAgC0EBaiELIARBAWshBAsgF0IBfSAXgyIXUA0BIAQNAAsLIAcgCEEBa0EfcUEfQQAgCEEfcUEBRhtqIgQ6AAAgBCAHaiANOgAAIAAgACgCHCIFQQFqNgIcIAogBEECdGogBTYCAAJAIAtFDQAgAUEDayEMIAlBA2ohDyACQQFrIQ0gAkEDayEIQQAhBQNAAkAgDiASIAVBAnRqKAIAIgpqIgAgBmpBA2soAAAgBiAMaigAAEcNACAGAn8CQCABIAhPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiB0cEQCAHIAlzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgCE8NASAAKAAAIgkgBCgAACIHRg0ACyAEIAcgCXNoQQN2aiABawwBCwJAIAQgDU8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgDyAKazYCACAEIQYgASAEaiACRg0CCyAFQQFqIgUgC0cNAAsLIBJBgAJqJAAgBgu5EAITfwN+IwBBgAJrIhEkACABIAAoAgQiDWshCCAAKAK4ASEVIAAoAhAhDiAAKAIYIRYgACgCxAEhFCAAKQNQIRggACgCJCESIAAoAighDyAAKAJcIRACQCAAKALcAUUEQCAAQSxqIQoCQCAIIAAoAhwiBGtBgQNJBEAgDyEMIBAhCQwBCyAPIQwgECEJIARBn39NBEAgDUEIaiEMIARB3wBqIQlBOCASa60hFwNAIAogBEEHcUECdGoiBigCACEFIAYgACkDUCAEIAxqKQAAQoCAgNjLm++NT36FIBeIPgIAIA8gBUECdkHA////A3EiC2oiBkE/QQAgBi0AACIHQT9xQQFGGyAHQQFrQT9xaiIHOgAAIAYgB2ogBToAACAQIAtBAnRqIAdBAnRqIAQ2AgAgBCAJRyEFIARBAWohBCAFDQALIAAoAighDCAAKAJcIQkLIAhBIGsiBCAEQQggAUEBaiIFIAQgDWoiBmtBAWoiByAHQQhPG0EAIAUgBk8baiIGTw0AQTggACgCJGutIRcgACkDUCEZIAQhBQNAIAogBUEHcUECdGogBSANaikAAEKAgIDYy5vvjU9+IBmFIBeIPgIAIAVBAWoiBSAGRw0ACwsgBCAISQRAIAAoAgRBCGohE0E4IAAoAiRrrSEXA0AgCiAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgE2opAABCgICA2Mub741PfoUgF4g+AgAgDCAFQQJ2QcD///8DcSILaiIGQT9BACAGLQAAIgdBP3FBAUYbIAdBAWtBP3FqIgc6AAAgBiAHaiAFOgAAIAkgC0ECdGogB0ECdGogBDYCACAEQQFqIgQgCEkNAAsLIAAgCDYCHCAKIAhBB3FBAnRqIgQoAgAhCSAEIAggDWopAAhCgICA2Mub741PfiAYhUE4IBJrrYg+AgAMAQsgASkAACEXIAAgCDYCHCAXQoCAgNjLm++NT34gGIVBOCASa62IpyEJCyAAIAAoAlggCWo2AlggDyAJQQJ2QcD///8DcSIEaiIGLQAAIQcgECAEQQJ0aiEKQQAhCwJAIAlB/wFxQYGChAhsIgQgBigAPHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAGKAA4IARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigANCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAwIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigALCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAoIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnKtQgiGIAYoACQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoACAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigAHCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAGCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAUIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoAAwgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoAAggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHathCIXQn9RDQAgDiAIQQEgFXQiBGsgDiAIIA5rIARLGyAWGyEMQQFBBiAUIBRBBk8bdCEEIBdCf4UgB62KIRcDQCAXpyIFaCAXQiCIp2hBIHMgBRsgB2pBP3EiBQRAIAogBUECdGooAgAiBSAMSQ0CIBEgC0ECdGogBTYCACALQQFqIQsgBEEBayEECyAXQgF9IBeDIhdQDQEgBA0ACwsgBiAHQQFrQT9xQT9BACAHQT9xQQFGG2oiBDoAACAEIAZqIAk6AAAgACAAKAIcIgVBAWo2AhwgCiAEQQJ0aiAFNgIAAkAgC0UEQEEDIQYMAQsgAUEDayEJIAhBA2ohDiACQQFrIRMgAkEDayEHQQAhAEEDIQYDQAJAIA0gESAAQQJ0aigCACIMaiIFIAZqQQNrKAAAIAYgCWooAABHDQAgBgJ/AkAgASAHTwRAIAEhBAwBCyAFKAAAIgggASIEKAAAIgpHBEAgCCAKc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIAdPDQEgBSgAACIIIAQoAAAiCkYNAAsgBCAIIApzaEEDdmogAWsMAQsCQCAEIBNPDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBE8NACADIA4gDGs2AgAgBCEGIAEgBGogAkYNAgsgAEEBaiIAIAtHDQALCyARQYACaiQAIAYLlAwCE38DfiMAQYACayIRJAAgASAAKAIEIg1rIQggACgCuAEhFSAAKAIQIQ4gACgCGCEWIAAoAsQBIRQgACkDUCEYIAAoAiQhEiAAKAIoIQ8gACgCXCEQAkAgACgC3AFFBEAgAEEsaiEJAkAgCCAAKAIcIgRrQYEDSQRAIA8hDCAQIQoMAQsgDyEMIBAhCiAEQZ9/TQRAIA1BCGohDCAEQd8AaiEKQTggEmutIRcDQCAJIARBB3FBAnRqIgYoAgAhBSAGIAApA1AgBCAMaikAAEKAgOz8y5vvjU9+hSAXiD4CACAPIAVBBHZB8P///wBxIgtqIgZBD0EAIAYtAAAiB0EPcUEBRhsgB0EBa0EPcWoiBzoAACAGIAdqIAU6AAAgECALQQJ0aiAHQQJ0aiAENgIAIAQgCkchBSAEQQFqIQQgBQ0ACyAAKAIoIQwgACgCXCEKCyAIQSBrIgQgBEEIIAFBAWoiBSAEIA1qIgZrQQFqIgcgB0EITxtBACAFIAZPG2oiBk8NAEE4IAAoAiRrrSEXIAApA1AhGSAEIQUDQCAJIAVBB3FBAnRqIAUgDWopAABCgIDs/Mub741PfiAZhSAXiD4CACAFQQFqIgUgBkcNAAsLIAQgCEkEQCAAKAIEQQhqIRNBOCAAKAIka60hFwNAIAkgBEEHcUECdGoiBigCACEFIAYgACkDUCAEIBNqKQAAQoCA7PzLm++NT36FIBeIPgIAIAwgBUEEdkHw////AHEiC2oiBkEPQQAgBi0AACIHQQ9xQQFGGyAHQQFrQQ9xaiIHOgAAIAYgB2ogBToAACAKIAtBAnRqIAdBAnRqIAQ2AgAgBEEBaiIEIAhJDQALCyAAIAg2AhwgCSAIQQdxQQJ0aiIEKAIAIQogBCAIIA1qKQAIQoCA7PzLm++NT34gGIVBOCASa62IPgIADAELIAEpAAAhFyAAIAg2AhwgF0KAgOz8y5vvjU9+IBiFQTggEmutiKchCgsgACAAKAJYIApqNgJYIA8gCkEEdkHw////AHEiBGoiCS0AACEGIBAgBEECdGohB0EAIQsCQCAKQf8BcUGBgoQIbCIEIAkoAAxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCSgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAkoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCSgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVB//8DRg0AIA4gCEEBIBV0IgRrIA4gCCAOayAESxsgFhshDEEBQQQgFCAUQQRPG3QhBCAFQX9zIgVB//8DcSAGQQ9xdiAFQQAgBmtBD3F0cq1C//8DgyEXA0BBACAXp2ggF1AbIAZqQQ9xIgUEQCAHIAVBAnRqKAIAIgUgDEkNAiARIAtBAnRqIAU2AgAgC0EBaiELIARBAWshBAsgF0IBfSAXgyIXUA0BIAQNAAsLIAkgBkEBa0EPcUEPQQAgBkEPcUEBRhtqIgQ6AAAgBCAJaiAKOgAAIAAgACgCHCIFQQFqNgIcIAcgBEECdGogBTYCAAJAIAtFBEBBAyEGDAELIAFBA2shCiAIQQNqIQ4gAkEBayETIAJBA2shB0EAIQVBAyEGA0ACQCANIBEgBUECdGooAgAiDGoiACAGakEDaygAACAGIApqKAAARw0AIAYCfwJAIAEgB08EQCABIQQMAQsgACgAACIIIAEiBCgAACIJRwRAIAggCXNoQQN2DAILA0AgAEEEaiEAIARBBGoiBCAHTw0BIAAoAAAiCCAEKAAAIglGDQALIAQgCCAJc2hBA3ZqIAFrDAELAkAgBCATTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAOIAxrNgIAIAQhBiABIARqIAJGDQILIAVBAWoiBSALRw0ACwsgEUGAAmokACAGC6oNAhN/A34jAEGAAmsiEiQAIAEgACgCBCIOayEJIAAoArgBIRUgACgCECEPIAAoAhghFiAAKALEASEUIAApA1AhGCAAKAIkIRMgACgCKCEQIAAoAlwhEQJAIAAoAtwBRQRAIABBLGohBwJAIAkgACgCHCIEa0GBA0kEQCAQIQogESEMDAELIBAhCiARIQwgBEGff00EQCAOQQhqIQogBEHfAGohDEE4IBNrrSEXA0AgByAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgCmopAABCgIDs/Mub741PfoUgF4g+AgAgECAFQQN2QeD///8BcSILaiIGQR9BACAGLQAAIghBH3FBAUYbIAhBAWtBH3FqIgg6AAAgBiAIaiAFOgAAIBEgC0ECdGogCEECdGogBDYCACAEIAxHIQUgBEEBaiEEIAUNAAsgACgCXCEMIAAoAighCgsgCUEgayIEIARBCCABQQFqIgUgBCAOaiIGa0EBaiIIIAhBCE8bQQAgBSAGTxtqIgZPDQBBOCAAKAIka60hFyAAKQNQIRkgBCEFA0AgByAFQQdxQQJ0aiAFIA5qKQAAQoCA7PzLm++NT34gGYUgF4g+AgAgBUEBaiIFIAZHDQALCyAEIAlJBEAgACgCBEEIaiENQTggACgCJGutIRcDQCAHIARBB3FBAnRqIgYoAgAhBSAGIAApA1AgBCANaikAAEKAgOz8y5vvjU9+hSAXiD4CACAKIAVBA3ZB4P///wFxIgtqIgZBH0EAIAYtAAAiCEEfcUEBRhsgCEEBa0EfcWoiCDoAACAGIAhqIAU6AAAgDCALQQJ0aiAIQQJ0aiAENgIAIARBAWoiBCAJSQ0ACwsgACAJNgIcIAcgCUEHcUECdGoiBCgCACENIAQgCSAOaikACEKAgOz8y5vvjU9+IBiFQTggE2utiD4CAAwBCyABKQAAIRcgACAJNgIcIBdCgIDs/Mub741PfiAYhUE4IBNrrYinIQ0LIAAgACgCWCANajYCWEEDIQYgECANQQN2QeD///8BcSIEaiIHLQAAIQggESAEQQJ0aiEKQQAhCwJAIA1B/wFxQYGChAhsIgQgBygAHHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAHKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygAFCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAIIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBUF/Rg0AIA8gCUEBIBV0IgRrIA8gCSAPayAESxsgFhshDEEBQQUgFCAUQQVPG3QhBCAFQX9zIAh4rSEXA0BBACAXp2ggF1AbIAhqQR9xIgUEQCAKIAVBAnRqKAIAIgUgDEkNAiASIAtBAnRqIAU2AgAgC0EBaiELIARBAWshBAsgF0IBfSAXgyIXUA0BIAQNAAsLIAcgCEEBa0EfcUEfQQAgCEEfcUEBRhtqIgQ6AAAgBCAHaiANOgAAIAAgACgCHCIFQQFqNgIcIAogBEECdGogBTYCAAJAIAtFDQAgAUEDayEMIAlBA2ohDyACQQFrIQ0gAkEDayEIQQAhBQNAAkAgDiASIAVBAnRqKAIAIgpqIgAgBmpBA2soAAAgBiAMaigAAEcNACAGAn8CQCABIAhPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiB0cEQCAHIAlzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgCE8NASAAKAAAIgkgBCgAACIHRg0ACyAEIAcgCXNoQQN2aiABawwBCwJAIAQgDU8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgDyAKazYCACAEIQYgASAEaiACRg0CCyAFQQFqIgUgC0cNAAsLIBJBgAJqJAAgBgu5EAITfwN+IwBBgAJrIhEkACABIAAoAgQiDWshCCAAKAK4ASEVIAAoAhAhDiAAKAIYIRYgACgCxAEhFCAAKQNQIRggACgCJCESIAAoAighDyAAKAJcIRACQCAAKALcAUUEQCAAQSxqIQoCQCAIIAAoAhwiBGtBgQNJBEAgDyEMIBAhCQwBCyAPIQwgECEJIARBn39NBEAgDUEIaiEMIARB3wBqIQlBOCASa60hFwNAIAogBEEHcUECdGoiBigCACEFIAYgACkDUCAEIAxqKQAAQoCA7PzLm++NT36FIBeIPgIAIA8gBUECdkHA////A3EiC2oiBkE/QQAgBi0AACIHQT9xQQFGGyAHQQFrQT9xaiIHOgAAIAYgB2ogBToAACAQIAtBAnRqIAdBAnRqIAQ2AgAgBCAJRyEFIARBAWohBCAFDQALIAAoAighDCAAKAJcIQkLIAhBIGsiBCAEQQggAUEBaiIFIAQgDWoiBmtBAWoiByAHQQhPG0EAIAUgBk8baiIGTw0AQTggACgCJGutIRcgACkDUCEZIAQhBQNAIAogBUEHcUECdGogBSANaikAAEKAgOz8y5vvjU9+IBmFIBeIPgIAIAVBAWoiBSAGRw0ACwsgBCAISQRAIAAoAgRBCGohE0E4IAAoAiRrrSEXA0AgCiAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgE2opAABCgIDs/Mub741PfoUgF4g+AgAgDCAFQQJ2QcD///8DcSILaiIGQT9BACAGLQAAIgdBP3FBAUYbIAdBAWtBP3FqIgc6AAAgBiAHaiAFOgAAIAkgC0ECdGogB0ECdGogBDYCACAEQQFqIgQgCEkNAAsLIAAgCDYCHCAKIAhBB3FBAnRqIgQoAgAhCSAEIAggDWopAAhCgIDs/Mub741PfiAYhUE4IBJrrYg+AgAMAQsgASkAACEXIAAgCDYCHCAXQoCA7PzLm++NT34gGIVBOCASa62IpyEJCyAAIAAoAlggCWo2AlggDyAJQQJ2QcD///8DcSIEaiIGLQAAIQcgECAEQQJ0aiEKQQAhCwJAIAlB/wFxQYGChAhsIgQgBigAPHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAGKAA4IARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigANCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAwIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigALCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAoIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnKtQgiGIAYoACQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoACAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigAHCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAGCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAUIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoAAwgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoAAggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHathCIXQn9RDQAgDiAIQQEgFXQiBGsgDiAIIA5rIARLGyAWGyEMQQFBBiAUIBRBBk8bdCEEIBdCf4UgB62KIRcDQCAXpyIFaCAXQiCIp2hBIHMgBRsgB2pBP3EiBQRAIAogBUECdGooAgAiBSAMSQ0CIBEgC0ECdGogBTYCACALQQFqIQsgBEEBayEECyAXQgF9IBeDIhdQDQEgBA0ACwsgBiAHQQFrQT9xQT9BACAHQT9xQQFGG2oiBDoAACAEIAZqIAk6AAAgACAAKAIcIgVBAWo2AhwgCiAEQQJ0aiAFNgIAAkAgC0UEQEEDIQYMAQsgAUEDayEJIAhBA2ohDiACQQFrIRMgAkEDayEHQQAhAEEDIQYDQAJAIA0gESAAQQJ0aigCACIMaiIFIAZqQQNrKAAAIAYgCWooAABHDQAgBgJ/AkAgASAHTwRAIAEhBAwBCyAFKAAAIgggASIEKAAAIgpHBEAgCCAKc2hBA3YMAgsDQCAFQQRqIQUgBEEEaiIEIAdPDQEgBSgAACIIIAQoAAAiCkYNAAsgBCAIIApzaEEDdmogAWsMAQsCQCAEIBNPDQAgBS8AACAELwAARw0AIAVBAmohBSAEQQJqIQQLIAIgBEsEfyAEIAUtAAAgBC0AAEZqBSAECyABawsiBE8NACADIA4gDGs2AgAgBCEGIAEgBGogAkYNAgsgAEEBaiIAIAtHDQALCyARQYACaiQAIAYL6g8CGn8CfiMAQRBrIgskACACKAIEIQwgAigCACEGIAAoArQBIgUoAgAhEyAFKAIEIRQgBSgCDCEFIABBADYC3AEgACgCxAEiDUEESyEPQQZBBCAAKALIASIKIApBBE0bIgogCkEGTxshFiADIAMgACgCBCIKIAAoAgwiEGoiF2sgBSAUaiIcIBNrRmohByAAKAIcIgUgBUEIIAMgBGoiCUEPayIdIAUgCmoiBGsiCCAIQQhPG0EAIAQgCUEQayISTRtqIghJBEAgAEEsaiERQRggACgCJCIEayEYQTggBGutIR8gACkDUCIgpyEOIBZBBWshGQNAIAUgCmohBCARIAVBB3FBAnRqAn8CQAJAAkAgGQ4CAQIACyAEKAAAQbHz3fF5bCAOcyAYdgwCCyAEKQAAQoCAgNjLm++NT34gIIUgH4inDAELIAQpAABCgIDs/Mub741PfiAghSAfiKcLNgIAIAVBAWoiBSAIRw0ACwsgByASSQRAQQYgDUEEIA8bIgUgBUEGTxshGiAAQSxqIRkgCUEgayEPIBQgFCATayAQaiIeayEbIBZBBWshGANAAkACfwJAAkACQCAHIAYgCmprQQFqIgUgEGtBfEsNACAUIAUgHmtqIAUgCmogBSAQSSIFGyIEKAAAIAdBAWoiCCgAAEcNACAHQQVqIARBBGogCSATIAkgBRsgFxDQC0EEaiEOQQEhFQwBCyALQf+T69wDNgIMAn8CQAJAAkAgFkEFaw4CAQIACwJAAkACQCAaQQVrDgIBAgALIAAgByAJIAtBDGoQ7AsMBAsgACAHIAkgC0EMahDtCwwDCyAAIAcgCSALQQxqEO4LDAILAkACQAJAIBpBBWsOAgECAAsgACAHIAkgC0EMahDvCwwDCyAAIAcgCSALQQxqEPALDAILIAAgByAJIAtBDGoQ8QsMAQsCQAJAAkAgGkEFaw4CAQIACyAAIAcgCSALQQxqEPILDAILIAAgByAJIAtBDGoQ8wsMAQsgACAHIAkgC0EMahD0CwsiDkEDTQRAIAAgByADayIFQf8PSzYC3AEgByAFQQh2akEBaiEHDAQLIAsoAgwiFUEETw0BIAchCAsgBiERIAwMAQsgFUEDayERAkACQCADIAdPDQAgGyAKIAcgCiAVamtBA2oiBSAQSSIEGyAFaiIFIBwgFyAEGyIETQ0AA0AgB0EBayIILQAAIAVBAWsiBS0AAEcNASAOQQFqIQ4gAyAITw0CIAghByAEIAVJDQALDAELIAchCAsgBgshBCAIIANrIQ0gASgCDCEGAkACQCAIIA9NBEAgBiAD/QAAAP0LAAAgASgCDCEGIA1BEE0EQCABIAYgDWo2AgwgASgCBCEDDAMLIAYgA/0AABD9CwAQIA1BIUgNASAGIA1qIQUgA0EQaiEDIAZBIGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgBUkNAAsMAQsgAyAPTQRAIAYgA/0AAAD9CwAAIAYgDyADayIHaiEFIAdBEU4EQCAGQRBqIQYDQCAGIAP9AAAQ/QsAACAGIAP9AAAg/QsAECADQSBqIQMgBkEgaiIGIAVJDQALCyAFIQYgDyEDCyADIAhPDQBBACEHIAMhBSAIIANrQQdxIgwEQANAIAYgBS0AADoAACAGQQFqIQYgBUEBaiEFIAdBAWoiByAMRw0ACwsgAyAIa0F4Sw0AA0AgBiAFLQAAOgAAIAYgBS0AAToAASAGIAUtAAI6AAIgBiAFLQADOgADIAYgBS0ABDoABCAGIAUtAAU6AAUgBiAFLQAGOgAGIAYgBS0ABzoAByAGQQhqIQYgBUEIaiIFIAhHDQALCyABIAEoAgwgDWo2AgwgASgCBCEDIA1BgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgFTYCACADIA07AQQgDkEDayIGQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAY7AQYgASADQQhqIgU2AgQgCCAOaiEDIAAoAtwBBEAgACgCHCIGIAZBCCAdIAYgCmoiB2siCCAIQQhPG0EAIAcgEk0baiIISQRAQRggACgCJCIHayEOQTggB2utIR8gACkDUCIgpyEMA0AgBiAKaiEHIBkgBkEHcUECdGoCfwJAAkACQCAYDgIBAgALIAcoAABBsfPd8XlsIAxzIA52DAILIAcpAABCgICA2Mub741PfiAghSAfiKcMAQsgBykAAEKAgOz8y5vvjU9+ICCFIB+Ipws2AgAgBkEBaiIGIAhHDQALCyAAQQA2AtwBCyAEIQwgESEGIAMhByADIBJLDQADQAJAIAQhBiARIQQgAyAGIApqayIHIBBrQXxLDQAgGyAKIAcgEEkiCBsgB2oiBygAACADKAAARw0AIANBBGogB0EEaiAJIBMgCSAIGyAXENALIQcgAyAPTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBQsgBUEBNgIAIAVBADsBBCAHQQFqIghBgIAETwRAIAFBAjYCJCABIAUgASgCAGtBA3U2AigLIAUgCDsBBiABIAVBCGoiBTYCBCAGIREgBCEMIAMgB2pBBGoiAyEHIAMgEk0NAQwCCwsgBiEMIAQhBiADIQcLIAcgEkkNAAsLIAIgDDYCBCACIAY2AgAgC0EQaiQAIAkgA2sLyhACGn8BfiMAQYACayISJAAgASAAKAIEIg5rIQwgACgCuAEhFyAAKAIQIRMgACgCGCEYIAEoAABBsfPd8XlsIgVBGCAAKAK0ASIUKAIka3YiGUEEdiEaIBQoAighGyAUKAJcIRwgACgCDCEWQQQgACgCxAEiBCAEQQRPGyEdIAApA1AhHiAAKAIkIRAgACgCKCENIAAoAlwhEQJAIAAoAtwBRQRAIABBLGohBwJAIAwgACgCHCIEa0GBA0kEQCANIQsgESEJDAELIA0hCyARIQkgBEGff00EQCAOQQhqIQsgBEHfAGohCUEYIBBrIQ8DQCAHIARBB3FBAnRqIgYoAgAhBSAGIAAoAlAgBCALaigAAEGx893xeWxzIA92NgIAIA0gBUEEdkHw////AHEiCmoiBkEPQQAgBi0AACIIQQ9xQQFGGyAIQQFrQQ9xaiIIOgAAIAYgCGogBToAACARIApBAnRqIAhBAnRqIAQ2AgAgBCAJRyEFIARBAWohBCAFDQALIAAoAighCyAAKAJcIQkLIAxBIGsiBCAEQQggAUEBaiIFIAQgDmoiBmtBAWoiCCAIQQhPG0EAIAUgBk8baiIGTw0AQRggACgCJGshCCAAKAJQIQogBCEFA0AgByAFQQdxQQJ0aiAFIA5qKAAAQbHz3fF5bCAKcyAIdjYCACAFQQFqIgUgBkcNAAsLIAQgDEkEQCAAKAIEQQhqIQ9BGCAAKAIkayEVA0AgByAEQQdxQQJ0aiIGKAIAIQUgBiAAKAJQIAQgD2ooAABBsfPd8XlscyAVdjYCACALIAVBBHZB8P///wBxIgpqIgZBD0EAIAYtAAAiCEEPcUEBRhsgCEEBa0EPcWoiCDoAACAGIAhqIAU6AAAgCSAKQQJ0aiAIQQJ0aiAENgIAIARBAWoiBCAMSQ0ACwsgACAMNgIcIAcgDEEHcUECdGoiBCgCACEJIAQgHqcgDCAOaigACEGx893xeWxzQRggEGt2NgIADAELIAAgDDYCHCAFIB6nc0EYIBBrdiEJCyAaQfD///8AcSEQQQEgHXQhCCAAIAAoAlggCWo2AlggDSAJQQR2QfD///8AcSIEaiIKLQAAIQUgESAEQQJ0aiEGAkAgCUH/AXFBgYKECGwiBCAKKAAMcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxIAooAAggBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2ckEIdCAKKAAEIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAooAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQf//A0YEQEEAIQcMAQsgEyAMQQEgF3QiB2sgEyAMIBNrIAdLGyAYGyELIARBf3MiBEH//wNxIAVBD3F2IARBACAFa0EPcXRyrUL//wODIR5BACEHA0BBACAep2ggHlAbIAVqQQ9xIgQEQCAGIARBAnRqKAIAIgQgC0kNAiASIAdBAnRqIAQ2AgAgCEEBayEIIAdBAWohBwsgHkIBfSAegyIeUA0BIAgNAAsLIBAgG2ohDSAKIAVBAWtBD3FBD0EAIAVBD3FBAUYbaiIEOgAAIAQgCmogCToAACAAIAAoAhwiBUEBajYCHCAGIARBAnRqIAU2AgACQCAHRQRAQQMhBQwBCyABQQNrIRUgDEEDaiERIAJBAWshEyACQQNrIQpBACEGQQMhBQNAAkAgDiASIAZBAnRqKAIAIg9qIgAgBWpBA2soAAAgBSAVaigAAEcNAAJ/AkAgASAKTwRAIAEhBAwBCyAAKAAAIgsgASIEKAAAIglHBEAgCSALc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIApPDQEgACgAACILIAQoAAAiCUYNAAsgBCAJIAtzaEEDdmogAWsMAQsCQCAEIBNPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBCAFTQ0AIAMgESAPazYCACAEIQUgASAEaiACRg0CCyAGQQFqIgYgB0cNAAsLAkAgGUH/AXFBgYKECGwiBCANKAAMcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBGHZB8AFxIA0oAAggBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCANKAAEIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIA0oAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQf//A0YNACAIRQ0AIBwgEEECdGohByAOIBZqIQ8gFCgCACEJIBQoAgQhCiAUKAIMIQsgBEF/cyIEQf//A3EgDS0AACIGQQ9xdiAEQQAgBmtBD3F0cq1C//8DgyEeQQAhBANAAkBBACAep2ggHlAbIAZqQQ9xIgAEQCAHIABBAnRqKAIAIgAgC0kNASASIARBAnRqIAA2AgAgCEEBayEIIARBAWohBAsgHkIBfSAegyIeUA0AIAgNAQsLIARFDQAgCiAWaiEOIAFBBGohCyAJIAxqQQNqIRUgASgAACEHQQAhAANAAkAgCiASIABBAnRqKAIAIghqIgYoAAAgB0cNACALIAZBBGogAiAJIA8Q0AtBBGoiBiAFTQ0AIAMgFSAIIA5qazYCACAGIgUgAWogAkYNAgsgAEEBaiIAIARHDQALCyASQYACaiQAIAUL/xICGn8BfiMAQYACayITJAAgASAAKAIEIg9rIQ4gACgCuAEhFyAAKAIQIQwgACgCGCEYIAEoAABBsfPd8XlsIghBGCAAKAK0ASIUKAIka3YiGUEDdiEaIBQoAighGyAUKAJcIRwgACgCDCEWQQUgACgCxAEiBCAEQQVPGyEdIAApA1AhHiAAKAIkIRAgACgCKCERIAAoAlwhEgJAIAAoAtwBRQRAIABBLGohBQJAIA4gACgCHCIEa0GBA0kEQCARIQogEiELDAELIBEhCiASIQsgBEGff00EQCAPQQhqIQogBEHfAGohC0EYIBBrIQ0DQCAFIARBB3FBAnRqIgcoAgAhCCAHIAAoAlAgBCAKaigAAEGx893xeWxzIA12NgIAIBEgCEEDdkHg////AXEiCWoiB0EfQQAgBy0AACIGQR9xQQFGGyAGQQFrQR9xaiIGOgAAIAYgB2ogCDoAACASIAlBAnRqIAZBAnRqIAQ2AgAgBCALRyEIIARBAWohBCAIDQALIAAoAlwhCyAAKAIoIQoLIA5BIGsiBCAEQQggAUEBaiIIIAQgD2oiB2tBAWoiBiAGQQhPG0EAIAcgCE0baiIHTw0AQRggACgCJGshBiAAKAJQIQkgBCEIA0AgBSAIQQdxQQJ0aiAIIA9qKAAAQbHz3fF5bCAJcyAGdjYCACAIQQFqIgggB0cNAAsLIAQgDkkEQCAAKAIEQQhqIQ1BGCAAKAIkayEVA0AgBSAEQQdxQQJ0aiIHKAIAIQggByAAKAJQIAQgDWooAABBsfPd8XlscyAVdjYCACAKIAhBA3ZB4P///wFxIglqIgdBH0EAIActAAAiBkEfcUEBRhsgBkEBa0EfcWoiBjoAACAGIAdqIAg6AAAgCyAJQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAOSQ0ACwsgACAONgIcIAUgDkEHcUECdGoiBCgCACENIAQgHqcgDiAPaigACEGx893xeWxzQRggEGt2NgIADAELIAAgDjYCHCAIIB6nc0EYIBBrdiENCyAaQeD///8BcSEQQQEgHXQhByAAIAAoAlggDWo2AlhBAyEIIBEgDUEDdkHg////AXEiBGoiCS0AACEGIBIgBEECdGohCgJAIA1B/wFxQYGChAhsIgQgCSgAHHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAJKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgAFCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAIIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEF/RgRAQQAhBQwBCyAMIA5BASAXdCIFayAMIA4gDGsgBUsbIBgbIQsgBEF/cyAGeK0hHkEAIQUDQEEAIB6naCAeUBsgBmpBH3EiBARAIAogBEECdGooAgAiBCALSQ0CIBMgBUECdGogBDYCACAFQQFqIQUgB0EBayEHCyAeQgF9IB6DIh5QDQEgBw0ACwsgECAbaiEMIAkgBkEBa0EfcUEfQQAgBkEfcUEBRhtqIgQ6AAAgBCAJaiANOgAAIAAgACgCHCIGQQFqNgIcIAogBEECdGogBjYCAAJAIAVFDQAgAUEDayEVIA5BA2ohEiACQQFrIREgAkEDayEJQQAhBgNAAkAgDyATIAZBAnRqKAIAIg1qIgAgCGpBA2soAAAgCCAVaigAAEcNAAJ/AkAgASAJTwRAIAEhBAwBCyAAKAAAIgogASIEKAAAIgtHBEAgCiALc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIAlPDQEgACgAACIKIAQoAAAiC0YNAAsgBCAKIAtzaEEDdmogAWsMAQsCQCAEIBFPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBCAITQ0AIAMgEiANazYCACAEIQggASAEaiACRg0CCyAGQQFqIgYgBUcNAAsLAkAgGUH/AXFBgYKECGwiBCAMKAAccyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBGHZB8AFxIAwoABggBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCAMKAAUIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAwoABAgBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCAMKAAMIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAwoAAggBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCAMKAAEIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAwoAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQX9GDQAgB0UNACAcIBBBAnRqIQUgDyAWaiENIBQoAgAhCyAUKAIEIQkgFCgCDCEKIARBf3MgDC0AACIGeK0hHkEAIQQDQAJAQQAgHqdoIB5QGyAGakEfcSIABEAgBSAAQQJ0aigCACIAIApJDQEgEyAEQQJ0aiAANgIAIAdBAWshByAEQQFqIQQLIB5CAX0gHoMiHlANACAHDQELCyAERQ0AIAkgFmohDyABQQRqIQogCyAOakEDaiEVIAEoAAAhBUEAIQADQAJAIAkgEyAAQQJ0aigCACIGaiIHKAAAIAVHDQAgCiAHQQRqIAIgCyANENALQQRqIgcgCE0NACADIBUgBiAPams2AgAgByEIIAEgB2ogAkYNAgsgAEEBaiIAIARHDQALCyATQYACaiQAIAgLohkCGn8CfiMAQYACayITJAAgASAAKAIEIg5rIQ0gACgCuAEhFyAAKAIQIRQgACgCGCEYIAEoAABBsfPd8XlsIgZBGCAAKAK0ASIVKAIka3YiGUECdiEaIBUoAighGyAVKAJcIRwgACgCDCEWQQYgACgCxAEiBCAEQQZPGyEdIAApA1AhHiAAKAIkIRAgACgCKCERIAAoAlwhEgJAIAAoAtwBRQRAIABBLGohBwJAIA0gACgCHCIEa0GBA0kEQCARIQsgEiEKDAELIBEhCyASIQogBEGff00EQCAOQQhqIQsgBEHfAGohCkEYIBBrIQ8DQCAHIARBB3FBAnRqIggoAgAhBiAIIAAoAlAgBCALaigAAEGx893xeWxzIA92NgIAIBEgBkECdkHA////A3EiDGoiCEE/QQAgCC0AACIFQT9xQQFGGyAFQQFrQT9xaiIFOgAAIAUgCGogBjoAACASIAxBAnRqIAVBAnRqIAQ2AgAgBCAKRyEGIARBAWohBCAGDQALIAAoAighCyAAKAJcIQoLIA1BIGsiBCAEQQggAUEBaiIGIAQgDmoiCGtBAWoiBSAFQQhPG0EAIAYgCE8baiIITw0AQRggACgCJGshBSAAKAJQIQwgBCEGA0AgByAGQQdxQQJ0aiAGIA5qKAAAQbHz3fF5bCAMcyAFdjYCACAGQQFqIgYgCEcNAAsLIAQgDUkEQCAAKAIEQQhqIQ9BGCAAKAIkayEJA0AgByAEQQdxQQJ0aiIIKAIAIQYgCCAAKAJQIAQgD2ooAABBsfPd8XlscyAJdjYCACALIAZBAnZBwP///wNxIgxqIghBP0EAIAgtAAAiBUE/cUEBRhsgBUEBa0E/cWoiBToAACAFIAhqIAY6AAAgCiAMQQJ0aiAFQQJ0aiAENgIAIARBAWoiBCANSQ0ACwsgACANNgIcIAcgDUEHcUECdGoiBCgCACEKIAQgHqcgDSAOaigACEGx893xeWxzQRggEGt2NgIADAELIAAgDTYCHCAGIB6nc0EYIBBrdiEKCyAaQcD///8DcSEQQQEgHXQhCCAAIAAoAlggCmo2AlggESAKQQJ2QcD///8DcSIEaiIGLQAAIQUgEiAEQQJ0aiEMAkAgCkH/AXFBgYKECGwiBCAGKAA8cyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxIAYoADggBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAA0IARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoADAgBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAAsIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoACggBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2cq1CCIYgBigAJCAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAICAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAcIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAYIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoABQgBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoABAgBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigADCAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigACCAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAEIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdq2EIh5Cf1EEQEEAIQcMAQsgFCANQQEgF3QiBGsgFCANIBRrIARLGyAYGyELIB5Cf4UgBa2KIR5BACEHA0AgHqciBGggHkIgiKdoQSBzIAQbIAVqQT9xIgQEQCAMIARBAnRqKAIAIgQgC0kNAiATIAdBAnRqIAQ2AgAgB0EBaiEHIAhBAWshCAsgHkIBfSAegyIeUA0BIAgNAAsLIBAgG2ohCSAGIAVBAWtBP3FBP0EAIAVBP3FBAUYbaiIEOgAAIAQgBmogCjoAACAAIAAoAhwiBkEBajYCHCAMIARBAnRqIAY2AgACQCAHRQRAQQMhBgwBCyABQQNrIRQgDUEDaiESIAJBAWshESACQQNrIQxBACEFQQMhBgNAAkAgDiATIAVBAnRqKAIAIg9qIgAgBmpBA2soAAAgBiAUaigAAEcNAAJ/AkAgASAMTwRAIAEhBAwBCyAAKAAAIgsgASIEKAAAIgpHBEAgCiALc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIAxPDQEgACgAACILIAQoAAAiCkYNAAsgBCAKIAtzaEEDdmogAWsMAQsCQCAEIBFPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBCAGTQ0AIAMgEiAPazYCACAEIQYgASAEaiACRg0CCyAFQQFqIgUgB0cNAAsLQQAhBAJAIBlB/wFxQYGChAhsIgAgCSgAPHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAJKAA4IABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgANCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAwIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgALCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAoIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnKtQgiGIAkoACQgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAkoACAgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgCSgAHCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgCSgAGCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAJKAAUIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAJKAAQIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAkoAAwgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAkoAAggAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgCSgABCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgCSgAACAAcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBHHathEJ/hSIeQQAgCTEAACIfQj+DpyIFa0E/ca2GIB4gH4iEIh5QDQAgCEUNACAcIBBBAnRqIQcgDiAWaiEPIBUoAgAhCiAVKAIEIQwgFSgCDCELA0ACQCAepyIAaCAeQiCIp2hBIHMgABsgBWpBP3EiAARAIAcgAEECdGooAgAiACALSQ0BIBMgBEECdGogADYCACAIQQFrIQggBEEBaiEECyAeQgF9IB6DIh5QDQAgCA0BCwsgBEUNACAMIBZqIQkgAUEEaiELIAogDWpBA2ohDiABKAAAIQdBACEAA0ACQCAMIBMgAEECdGooAgAiBWoiCCgAACAHRw0AIAsgCEEEaiACIAogDxDQC0EEaiIIIAZNDQAgAyAOIAUgCWprNgIAIAgiBiABaiACRg0CCyAAQQFqIgAgBEcNAAsLIBNBgAJqJAAgBgvkEAIZfwN+IwBBgAJrIhEkACABIAAoAgQiDmshDCAAKAK4ASEXIAAoAhAhDyAAKAIYIRggASkAAEKAgIDYy5vvjU9+Ih1BOCAAKAK0ASISKAIka62IpyIZQQR2IRUgEigCKCEaIBIoAlwhGyAAKAIMIRZBBCAAKALEASIEIARBBE8bIRwgACkDUCEeIAAoAiQhEyAAKAIoIRAgACgCXCENAkAgACgC3AFFBEAgAEEsaiEHAkAgDCAAKAIcIgRrQYEDSQRAIBAhCyANIQkMAQsgECELIA0hCSAEQZ9/TQRAIA5BCGohCyAEQd8AaiEJQTggE2utIR0DQCAHIARBB3FBAnRqIgYoAgAhBSAGIAApA1AgBCALaikAAEKAgIDYy5vvjU9+hSAdiD4CACAQIAVBBHZB8P///wBxIgpqIgZBD0EAIAYtAAAiCEEPcUEBRhsgCEEBa0EPcWoiCDoAACAGIAhqIAU6AAAgDSAKQQJ0aiAIQQJ0aiAENgIAIAQgCUchBSAEQQFqIQQgBQ0ACyAAKAIoIQsgACgCXCEJCyAMQSBrIgQgBEEIIAFBAWoiBSAEIA5qIgZrQQFqIgggCEEITxtBACAFIAZPG2oiBk8NAEE4IAAoAiRrrSEdIAApA1AhHyAEIQUDQCAHIAVBB3FBAnRqIAUgDmopAABCgICA2Mub741PfiAfhSAdiD4CACAFQQFqIgUgBkcNAAsLIAQgDEkEQCAAKAIEQQhqIRRBOCAAKAIka60hHQNAIAcgBEEHcUECdGoiBigCACEFIAYgACkDUCAEIBRqKQAAQoCAgNjLm++NT36FIB2IPgIAIAsgBUEEdkHw////AHEiCmoiBkEPQQAgBi0AACIIQQ9xQQFGGyAIQQFrQQ9xaiIIOgAAIAYgCGogBToAACAJIApBAnRqIAhBAnRqIAQ2AgAgBEEBaiIEIAxJDQALCyAAIAw2AhwgByAMQQdxQQJ0aiIEKAIAIQkgBCAMIA5qKQAIQoCAgNjLm++NT34gHoVBOCATa62IPgIADAELIAAgDDYCHCAdIB6FQTggE2utiKchCQsgFUHw////AHEhFUEBIBx0IQggACAAKAJYIAlqNgJYIBAgCUEEdkHw////AHEiBGoiCi0AACEFIA0gBEECdGohBgJAIAlB/wFxQYGChAhsIgQgCigADHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRh2QfABcSAKKAAIIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCigABCAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxciAKKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEH//wNGBEBBACEHDAELIA8gDEEBIBd0IgdrIA8gDCAPayAHSxsgGBshCyAEQX9zIgRB//8DcSAFQQ9xdiAEQQAgBWtBD3F0cq1C//8DgyEdQQAhBwNAQQAgHadoIB1QGyAFakEPcSIEBEAgBiAEQQJ0aigCACIEIAtJDQIgESAHQQJ0aiAENgIAIAhBAWshCCAHQQFqIQcLIB1CAX0gHYMiHVANASAIDQALCyAVIBpqIQ0gCiAFQQFrQQ9xQQ9BACAFQQ9xQQFGG2oiBDoAACAEIApqIAk6AAAgACAAKAIcIgVBAWo2AhwgBiAEQQJ0aiAFNgIAAkAgB0UEQEEDIQUMAQsgAUEDayEPIAxBA2ohEyACQQFrIRAgAkEDayEKQQAhBkEDIQUDQAJAIA4gESAGQQJ0aigCACIUaiIAIAVqQQNrKAAAIAUgD2ooAABHDQAgBQJ/AkAgASAKTwRAIAEhBAwBCyAAKAAAIgsgASIEKAAAIglHBEAgCSALc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIApPDQEgACgAACILIAQoAAAiCUYNAAsgBCAJIAtzaEEDdmogAWsMAQsCQCAEIBBPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBMgFGs2AgAgBCEFIAEgBGogAkYNAgsgBkEBaiIGIAdHDQALCwJAIBlB/wFxQYGChAhsIgQgDSgADHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRh2QfABcSANKAAIIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEcdnJBCHQgDSgABCAEcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBGHZB8AFxciANKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEH//wNGDQAgCEUNACAbIBVBAnRqIQcgDiAWaiEUIBIoAgAhCSASKAIEIQogEigCDCELIARBf3MiBEH//wNxIA0tAAAiBkEPcXYgBEEAIAZrQQ9xdHKtQv//A4MhHUEAIQQDQAJAQQAgHadoIB1QGyAGakEPcSIABEAgByAAQQJ0aigCACIAIAtJDQEgESAEQQJ0aiAANgIAIAhBAWshCCAEQQFqIQQLIB1CAX0gHYMiHVANACAIDQELCyAERQ0AIAogFmohDiABQQRqIQsgCSAMakEDaiEPIAEoAAAhB0EAIQADQAJAIAogESAAQQJ0aigCACIIaiIGKAAAIAdHDQAgCyAGQQRqIAIgCSAUENALQQRqIgYgBU0NACADIA8gCCAOams2AgAgBiIFIAFqIAJGDQILIABBAWoiACAERw0ACwsgEUGAAmokACAFC5kTAhl/A34jAEGAAmsiEiQAIAEgACgCBCIPayENIAAoArgBIRcgACgCECEQIAAoAhghGCABKQAAQoCAgNjLm++NT34iHUE4IAAoArQBIhMoAiRrrYinIhlBA3YhFSATKAIoIRogEygCXCEbIAAoAgwhFkEFIAAoAsQBIgQgBEEFTxshHCAAKQNQIR4gACgCJCEUIAAoAighCyAAKAJcIRECQCAAKALcAUUEQCAAQSxqIQUCQCANIAAoAhwiBGtBgQNJBEAgCyEKIBEhDAwBCyALIQogESEMIARBn39NBEAgD0EIaiEKIARB3wBqIQxBOCAUa60hHQNAIAUgBEEHcUECdGoiBigCACEIIAYgACkDUCAEIApqKQAAQoCAgNjLm++NT36FIB2IPgIAIAsgCEEDdkHg////AXEiCWoiBkEfQQAgBi0AACIHQR9xQQFGGyAHQQFrQR9xaiIHOgAAIAYgB2ogCDoAACARIAlBAnRqIAdBAnRqIAQ2AgAgBCAMRyEIIARBAWohBCAIDQALIAAoAlwhDCAAKAIoIQoLIA1BIGsiBCAEQQggAUEBaiIIIAQgD2oiBmtBAWoiByAHQQhPG0EAIAYgCE0baiIGTw0AQTggACgCJGutIR0gACkDUCEfIAQhCANAIAUgCEEHcUECdGogCCAPaikAAEKAgIDYy5vvjU9+IB+FIB2IPgIAIAhBAWoiCCAGRw0ACwsgBCANSQRAIAAoAgRBCGohDkE4IAAoAiRrrSEdA0AgBSAEQQdxQQJ0aiIGKAIAIQggBiAAKQNQIAQgDmopAABCgICA2Mub741PfoUgHYg+AgAgCiAIQQN2QeD///8BcSIJaiIGQR9BACAGLQAAIgdBH3FBAUYbIAdBAWtBH3FqIgc6AAAgBiAHaiAIOgAAIAwgCUECdGogB0ECdGogBDYCACAEQQFqIgQgDUkNAAsLIAAgDTYCHCAFIA1BB3FBAnRqIgQoAgAhDiAEIA0gD2opAAhCgICA2Mub741PfiAehUE4IBRrrYg+AgAMAQsgACANNgIcIB0gHoVBOCAUa62IpyEOCyAVQeD///8BcSEVQQEgHHQhBiAAIAAoAlggDmo2AlhBAyEIIAsgDkEDdkHg////AXEiBGoiCS0AACEHIBEgBEECdGohCgJAIA5B/wFxQYGChAhsIgQgCSgAHHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcSAJKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgAFCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAQIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAIIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdnJBCHQgCSgABCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxciAJKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEF/RgRAQQAhBQwBCyAQIA1BASAXdCIFayAQIA0gEGsgBUsbIBgbIQwgBEF/cyAHeK0hHUEAIQUDQEEAIB2naCAdUBsgB2pBH3EiBARAIAogBEECdGooAgAiBCAMSQ0CIBIgBUECdGogBDYCACAFQQFqIQUgBkEBayEGCyAdQgF9IB2DIh1QDQEgBg0ACwsgFSAaaiELIAkgB0EBa0EfcUEfQQAgB0EfcUEBRhtqIgQ6AAAgBCAJaiAOOgAAIAAgACgCHCIHQQFqNgIcIAogBEECdGogBzYCAAJAIAVFDQAgAUEDayEQIA1BA2ohFCACQQFrIREgAkEDayEJQQAhBwNAAkAgDyASIAdBAnRqKAIAIg5qIgAgCGpBA2soAAAgCCAQaigAAEcNACAIAn8CQCABIAlPBEAgASEEDAELIAAoAAAiCiABIgQoAAAiDEcEQCAKIAxzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgCU8NASAAKAAAIgogBCgAACIMRg0ACyAEIAogDHNoQQN2aiABawwBCwJAIAQgEU8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgFCAOazYCACAEIQggASAEaiACRg0CCyAHQQFqIgcgBUcNAAsLAkAgGUH/AXFBgYKECGwiBCALKAAccyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBGHZB8AFxIAsoABggBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCALKAAUIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAsoABAgBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCALKAAMIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAsoAAggBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCALKAAEIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAsoAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQX9GDQAgBkUNACAbIBVBAnRqIQUgDyAWaiEOIBMoAgAhDCATKAIEIQkgEygCDCEKIARBf3MgCy0AACIHeK0hHUEAIQQDQAJAQQAgHadoIB1QGyAHakEfcSIABEAgBSAAQQJ0aigCACIAIApJDQEgEiAEQQJ0aiAANgIAIAZBAWshBiAEQQFqIQQLIB1CAX0gHYMiHVANACAGDQELCyAERQ0AIAkgFmohDyABQQRqIQogDCANakEDaiEQIAEoAAAhBUEAIQADQAJAIAkgEiAAQQJ0aigCACIHaiIGKAAAIAVHDQAgCiAGQQRqIAIgDCAOENALQQRqIgYgCE0NACADIBAgByAPams2AgAgBiEIIAEgBmogAkYNAgsgAEEBaiIAIARHDQALCyASQYACaiQAIAgLvBkCGX8DfiMAQYACayIRJAAgASAAKAIEIg5rIQwgACgCuAEhFyAAKAIQIQkgACgCGCEYIAEpAABCgICA2Mub741PfiIdQTggACgCtAEiEigCJGutiKciGUECdiEVIBIoAighGiASKAJcIRsgACgCDCEWQQYgACgCxAEiBCAEQQZPGyEcIAApA1AhHiAAKAIkIRMgACgCKCEPIAAoAlwhEAJAIAAoAtwBRQRAIABBLGohBgJAIAwgACgCHCIEa0GBA0kEQCAPIQsgECEKDAELIA8hCyAQIQogBEGff00EQCAOQQhqIQsgBEHfAGohCkE4IBNrrSEdA0AgBiAEQQdxQQJ0aiIIKAIAIQcgCCAAKQNQIAQgC2opAABCgICA2Mub741PfoUgHYg+AgAgDyAHQQJ2QcD///8DcSINaiIIQT9BACAILQAAIgVBP3FBAUYbIAVBAWtBP3FqIgU6AAAgBSAIaiAHOgAAIBAgDUECdGogBUECdGogBDYCACAEIApHIQcgBEEBaiEEIAcNAAsgACgCKCELIAAoAlwhCgsgDEEgayIEIARBCCABQQFqIgcgBCAOaiIIa0EBaiIFIAVBCE8bQQAgByAITxtqIghPDQBBOCAAKAIka60hHSAAKQNQIR8gBCEHA0AgBiAHQQdxQQJ0aiAHIA5qKQAAQoCAgNjLm++NT34gH4UgHYg+AgAgB0EBaiIHIAhHDQALCyAEIAxJBEAgACgCBEEIaiEUQTggACgCJGutIR0DQCAGIARBB3FBAnRqIggoAgAhByAIIAApA1AgBCAUaikAAEKAgIDYy5vvjU9+hSAdiD4CACALIAdBAnZBwP///wNxIg1qIghBP0EAIAgtAAAiBUE/cUEBRhsgBUEBa0E/cWoiBToAACAFIAhqIAc6AAAgCiANQQJ0aiAFQQJ0aiAENgIAIARBAWoiBCAMSQ0ACwsgACAMNgIcIAYgDEEHcUECdGoiBCgCACEKIAQgDCAOaikACEKAgIDYy5vvjU9+IB6FQTggE2utiD4CAAwBCyAAIAw2AhwgHSAehUE4IBNrrYinIQoLIBVBwP///wNxIRVBASAcdCEIIAAgACgCWCAKajYCWCAPIApBAnZBwP///wNxIgRqIgctAAAhBSAQIARBAnRqIQ0CQCAKQf8BcUGBgoQIbCIEIAcoADxzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXEgBygAOCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAcoADQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBygAMCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAcoACwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBygAKCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyrUIIhiAHKAAkIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAHKAAgIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAcoABwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAcoABggBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBygAFCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBygAECAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHathEIIhiAHKAAMIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAHKAAIIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAcoAAQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAcoAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2rYQiHUJ/UQRAQQAhBgwBCyAJIAxBASAXdCIEayAJIAwgCWsgBEsbIBgbIQsgHUJ/hSAFrYohHUEAIQYDQCAdpyIEaCAdQiCIp2hBIHMgBBsgBWpBP3EiBARAIA0gBEECdGooAgAiBCALSQ0CIBEgBkECdGogBDYCACAGQQFqIQYgCEEBayEICyAdQgF9IB2DIh1QDQEgCA0ACwsgFSAaaiEJIAcgBUEBa0E/cUE/QQAgBUE/cUEBRhtqIgQ6AAAgBCAHaiAKOgAAIAAgACgCHCIHQQFqNgIcIA0gBEECdGogBzYCAAJAIAZFBEBBAyEHDAELIAFBA2shDyAMQQNqIRMgAkEBayEQIAJBA2shDUEAIQVBAyEHA0ACQCAOIBEgBUECdGooAgAiFGoiACAHakEDaygAACAHIA9qKAAARw0AIAcCfwJAIAEgDU8EQCABIQQMAQsgACgAACILIAEiBCgAACIKRwRAIAogC3NoQQN2DAILA0AgAEEEaiEAIARBBGoiBCANTw0BIAAoAAAiCyAEKAAAIgpGDQALIAQgCiALc2hBA3ZqIAFrDAELAkAgBCAQTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyATIBRrNgIAIAQhByABIARqIAJGDQILIAVBAWoiBSAGRw0ACwtBACEEAkAgGUH/AXFBgYKECGwiACAJKAA8cyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxIAkoADggAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAJKAA0IABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAkoADAgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAJKAAsIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAkoACggAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2cq1CCIYgCSgAJCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgCSgAICAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAJKAAcIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAJKAAYIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAkoABQgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAkoABAgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgCSgADCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgCSgACCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAJKAAEIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAJKAAAIABzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEcdq2EQn+FIh1BACAJMQAAIh5CP4OnIgVrQT9xrYYgHSAeiIQiHVANACAIRQ0AIBsgFUECdGohBiAOIBZqIRQgEigCACEKIBIoAgQhDSASKAIMIQsDQAJAIB2nIgBoIB1CIIinaEEgcyAAGyAFakE/cSIABEAgBiAAQQJ0aigCACIAIAtJDQEgESAEQQJ0aiAANgIAIAhBAWshCCAEQQFqIQQLIB1CAX0gHYMiHVANACAIDQELCyAERQ0AIA0gFmohCSABQQRqIQsgCiAMakEDaiEOIAEoAAAhBkEAIQADQAJAIA0gESAAQQJ0aigCACIFaiIIKAAAIAZHDQAgCyAIQQRqIAIgCiAUENALQQRqIgggB00NACADIA4gBSAJams2AgAgCCIHIAFqIAJGDQILIABBAWoiACAERw0ACwsgEUGAAmokACAHC+QQAhl/A34jAEGAAmsiESQAIAEgACgCBCIOayEMIAAoArgBIRcgACgCECEPIAAoAhghGCABKQAAQoCA7PzLm++NT34iHUE4IAAoArQBIhIoAiRrrYinIhlBBHYhFSASKAIoIRogEigCXCEbIAAoAgwhFkEEIAAoAsQBIgQgBEEETxshHCAAKQNQIR4gACgCJCETIAAoAighECAAKAJcIQ0CQCAAKALcAUUEQCAAQSxqIQcCQCAMIAAoAhwiBGtBgQNJBEAgECELIA0hCQwBCyAQIQsgDSEJIARBn39NBEAgDkEIaiELIARB3wBqIQlBOCATa60hHQNAIAcgBEEHcUECdGoiBigCACEFIAYgACkDUCAEIAtqKQAAQoCA7PzLm++NT36FIB2IPgIAIBAgBUEEdkHw////AHEiCmoiBkEPQQAgBi0AACIIQQ9xQQFGGyAIQQFrQQ9xaiIIOgAAIAYgCGogBToAACANIApBAnRqIAhBAnRqIAQ2AgAgBCAJRyEFIARBAWohBCAFDQALIAAoAighCyAAKAJcIQkLIAxBIGsiBCAEQQggAUEBaiIFIAQgDmoiBmtBAWoiCCAIQQhPG0EAIAUgBk8baiIGTw0AQTggACgCJGutIR0gACkDUCEfIAQhBQNAIAcgBUEHcUECdGogBSAOaikAAEKAgOz8y5vvjU9+IB+FIB2IPgIAIAVBAWoiBSAGRw0ACwsgBCAMSQRAIAAoAgRBCGohFEE4IAAoAiRrrSEdA0AgByAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgFGopAABCgIDs/Mub741PfoUgHYg+AgAgCyAFQQR2QfD///8AcSIKaiIGQQ9BACAGLQAAIghBD3FBAUYbIAhBAWtBD3FqIgg6AAAgBiAIaiAFOgAAIAkgCkECdGogCEECdGogBDYCACAEQQFqIgQgDEkNAAsLIAAgDDYCHCAHIAxBB3FBAnRqIgQoAgAhCSAEIAwgDmopAAhCgIDs/Mub741PfiAehUE4IBNrrYg+AgAMAQsgACAMNgIcIB0gHoVBOCATa62IpyEJCyAVQfD///8AcSEVQQEgHHQhCCAAIAAoAlggCWo2AlggECAJQQR2QfD///8AcSIEaiIKLQAAIQUgDSAEQQJ0aiEGAkAgCUH/AXFBgYKECGwiBCAKKAAMcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxIAooAAggBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2ckEIdCAKKAAEIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAooAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQf//A0YEQEEAIQcMAQsgDyAMQQEgF3QiB2sgDyAMIA9rIAdLGyAYGyELIARBf3MiBEH//wNxIAVBD3F2IARBACAFa0EPcXRyrUL//wODIR1BACEHA0BBACAdp2ggHVAbIAVqQQ9xIgQEQCAGIARBAnRqKAIAIgQgC0kNAiARIAdBAnRqIAQ2AgAgCEEBayEIIAdBAWohBwsgHUIBfSAdgyIdUA0BIAgNAAsLIBUgGmohDSAKIAVBAWtBD3FBD0EAIAVBD3FBAUYbaiIEOgAAIAQgCmogCToAACAAIAAoAhwiBUEBajYCHCAGIARBAnRqIAU2AgACQCAHRQRAQQMhBQwBCyABQQNrIQ8gDEEDaiETIAJBAWshECACQQNrIQpBACEGQQMhBQNAAkAgDiARIAZBAnRqKAIAIhRqIgAgBWpBA2soAAAgBSAPaigAAEcNACAFAn8CQCABIApPBEAgASEEDAELIAAoAAAiCyABIgQoAAAiCUcEQCAJIAtzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgCk8NASAAKAAAIgsgBCgAACIJRg0ACyAEIAkgC3NoQQN2aiABawwBCwJAIAQgEE8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgEyAUazYCACAEIQUgASAEaiACRg0CCyAGQQFqIgYgB0cNAAsLAkAgGUH/AXFBgYKECGwiBCANKAAMcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBGHZB8AFxIA0oAAggBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2ckEIdCANKAAEIARzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXFyIA0oAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQf//A0YNACAIRQ0AIBsgFUECdGohByAOIBZqIRQgEigCACEJIBIoAgQhCiASKAIMIQsgBEF/cyIEQf//A3EgDS0AACIGQQ9xdiAEQQAgBmtBD3F0cq1C//8DgyEdQQAhBANAAkBBACAdp2ggHVAbIAZqQQ9xIgAEQCAHIABBAnRqKAIAIgAgC0kNASARIARBAnRqIAA2AgAgCEEBayEIIARBAWohBAsgHUIBfSAdgyIdUA0AIAgNAQsLIARFDQAgCiAWaiEOIAFBBGohCyAJIAxqQQNqIQ8gASgAACEHQQAhAANAAkAgCiARIABBAnRqKAIAIghqIgYoAAAgB0cNACALIAZBBGogAiAJIBQQ0AtBBGoiBiAFTQ0AIAMgDyAIIA5qazYCACAGIgUgAWogAkYNAgsgAEEBaiIAIARHDQALCyARQYACaiQAIAULmRMCGX8DfiMAQYACayISJAAgASAAKAIEIg9rIQ0gACgCuAEhFyAAKAIQIRAgACgCGCEYIAEpAABCgIDs/Mub741PfiIdQTggACgCtAEiEygCJGutiKciGUEDdiEVIBMoAighGiATKAJcIRsgACgCDCEWQQUgACgCxAEiBCAEQQVPGyEcIAApA1AhHiAAKAIkIRQgACgCKCELIAAoAlwhEQJAIAAoAtwBRQRAIABBLGohBQJAIA0gACgCHCIEa0GBA0kEQCALIQogESEMDAELIAshCiARIQwgBEGff00EQCAPQQhqIQogBEHfAGohDEE4IBRrrSEdA0AgBSAEQQdxQQJ0aiIGKAIAIQggBiAAKQNQIAQgCmopAABCgIDs/Mub741PfoUgHYg+AgAgCyAIQQN2QeD///8BcSIJaiIGQR9BACAGLQAAIgdBH3FBAUYbIAdBAWtBH3FqIgc6AAAgBiAHaiAIOgAAIBEgCUECdGogB0ECdGogBDYCACAEIAxHIQggBEEBaiEEIAgNAAsgACgCXCEMIAAoAighCgsgDUEgayIEIARBCCABQQFqIgggBCAPaiIGa0EBaiIHIAdBCE8bQQAgBiAITRtqIgZPDQBBOCAAKAIka60hHSAAKQNQIR8gBCEIA0AgBSAIQQdxQQJ0aiAIIA9qKQAAQoCA7PzLm++NT34gH4UgHYg+AgAgCEEBaiIIIAZHDQALCyAEIA1JBEAgACgCBEEIaiEOQTggACgCJGutIR0DQCAFIARBB3FBAnRqIgYoAgAhCCAGIAApA1AgBCAOaikAAEKAgOz8y5vvjU9+hSAdiD4CACAKIAhBA3ZB4P///wFxIglqIgZBH0EAIAYtAAAiB0EfcUEBRhsgB0EBa0EfcWoiBzoAACAGIAdqIAg6AAAgDCAJQQJ0aiAHQQJ0aiAENgIAIARBAWoiBCANSQ0ACwsgACANNgIcIAUgDUEHcUECdGoiBCgCACEOIAQgDSAPaikACEKAgOz8y5vvjU9+IB6FQTggFGutiD4CAAwBCyAAIA02AhwgHSAehUE4IBRrrYinIQ4LIBVB4P///wFxIRVBASAcdCEGIAAgACgCWCAOajYCWEEDIQggCyAOQQN2QeD///8BcSIEaiIJLQAAIQcgESAEQQJ0aiEKAkAgDkH/AXFBgYKECGwiBCAJKAAccyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxIAkoABggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAJKAAUIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAkoABAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAJKAAMIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAkoAAggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAJKAAEIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAkoAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQX9GBEBBACEFDAELIBAgDUEBIBd0IgVrIBAgDSAQayAFSxsgGBshDCAEQX9zIAd4rSEdQQAhBQNAQQAgHadoIB1QGyAHakEfcSIEBEAgCiAEQQJ0aigCACIEIAxJDQIgEiAFQQJ0aiAENgIAIAVBAWohBSAGQQFrIQYLIB1CAX0gHYMiHVANASAGDQALCyAVIBpqIQsgCSAHQQFrQR9xQR9BACAHQR9xQQFGG2oiBDoAACAEIAlqIA46AAAgACAAKAIcIgdBAWo2AhwgCiAEQQJ0aiAHNgIAAkAgBUUNACABQQNrIRAgDUEDaiEUIAJBAWshESACQQNrIQlBACEHA0ACQCAPIBIgB0ECdGooAgAiDmoiACAIakEDaygAACAIIBBqKAAARw0AIAgCfwJAIAEgCU8EQCABIQQMAQsgACgAACIKIAEiBCgAACIMRwRAIAogDHNoQQN2DAILA0AgAEEEaiEAIARBBGoiBCAJTw0BIAAoAAAiCiAEKAAAIgxGDQALIAQgCiAMc2hBA3ZqIAFrDAELAkAgBCARTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAUIA5rNgIAIAQhCCABIARqIAJGDQILIAdBAWoiByAFRw0ACwsCQCAZQf8BcUGBgoQIbCIEIAsoABxzIgBBgIGChHhyQYGChAhrIAByQYCBgoR4cUGBgYEBbEEYdkHwAXEgCygAGCAEcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBHHZyQQh0IAsoABQgBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRh2QfABcXIgCygAECAEcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBHHZyQQh0IAsoAAwgBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRh2QfABcXIgCygACCAEcyIAQYCBgoR4ckGBgoQIayAAckGAgYKEeHFBgYGBAWxBHHZyQQh0IAsoAAQgBHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRh2QfABcXIgCygAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgRBf0YNACAGRQ0AIBsgFUECdGohBSAPIBZqIQ4gEygCACEMIBMoAgQhCSATKAIMIQogBEF/cyALLQAAIgd4rSEdQQAhBANAAkBBACAdp2ggHVAbIAdqQR9xIgAEQCAFIABBAnRqKAIAIgAgCkkNASASIARBAnRqIAA2AgAgBkEBayEGIARBAWohBAsgHUIBfSAdgyIdUA0AIAYNAQsLIARFDQAgCSAWaiEPIAFBBGohCiAMIA1qQQNqIRAgASgAACEFQQAhAANAAkAgCSASIABBAnRqKAIAIgdqIgYoAAAgBUcNACAKIAZBBGogAiAMIA4Q0AtBBGoiBiAITQ0AIAMgECAHIA9qazYCACAGIQggASAGaiACRg0CCyAAQQFqIgAgBEcNAAsLIBJBgAJqJAAgCAu8GQIZfwN+IwBBgAJrIhEkACABIAAoAgQiDmshDCAAKAK4ASEXIAAoAhAhCSAAKAIYIRggASkAAEKAgOz8y5vvjU9+Ih1BOCAAKAK0ASISKAIka62IpyIZQQJ2IRUgEigCKCEaIBIoAlwhGyAAKAIMIRZBBiAAKALEASIEIARBBk8bIRwgACkDUCEeIAAoAiQhEyAAKAIoIQ8gACgCXCEQAkAgACgC3AFFBEAgAEEsaiEGAkAgDCAAKAIcIgRrQYEDSQRAIA8hCyAQIQoMAQsgDyELIBAhCiAEQZ9/TQRAIA5BCGohCyAEQd8AaiEKQTggE2utIR0DQCAGIARBB3FBAnRqIggoAgAhByAIIAApA1AgBCALaikAAEKAgOz8y5vvjU9+hSAdiD4CACAPIAdBAnZBwP///wNxIg1qIghBP0EAIAgtAAAiBUE/cUEBRhsgBUEBa0E/cWoiBToAACAFIAhqIAc6AAAgECANQQJ0aiAFQQJ0aiAENgIAIAQgCkchByAEQQFqIQQgBw0ACyAAKAIoIQsgACgCXCEKCyAMQSBrIgQgBEEIIAFBAWoiByAEIA5qIghrQQFqIgUgBUEITxtBACAHIAhPG2oiCE8NAEE4IAAoAiRrrSEdIAApA1AhHyAEIQcDQCAGIAdBB3FBAnRqIAcgDmopAABCgIDs/Mub741PfiAfhSAdiD4CACAHQQFqIgcgCEcNAAsLIAQgDEkEQCAAKAIEQQhqIRRBOCAAKAIka60hHQNAIAYgBEEHcUECdGoiCCgCACEHIAggACkDUCAEIBRqKQAAQoCA7PzLm++NT36FIB2IPgIAIAsgB0ECdkHA////A3EiDWoiCEE/QQAgCC0AACIFQT9xQQFGGyAFQQFrQT9xaiIFOgAAIAUgCGogBzoAACAKIA1BAnRqIAVBAnRqIAQ2AgAgBEEBaiIEIAxJDQALCyAAIAw2AhwgBiAMQQdxQQJ0aiIEKAIAIQogBCAMIA5qKQAIQoCA7PzLm++NT34gHoVBOCATa62IPgIADAELIAAgDDYCHCAdIB6FQTggE2utiKchCgsgFUHA////A3EhFUEBIBx0IQggACAAKAJYIApqNgJYIA8gCkECdkHA////A3EiBGoiBy0AACEFIBAgBEECdGohDQJAIApB/wFxQYGChAhsIgQgBygAPHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcSAHKAA4IARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygANCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAwIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBygALCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAHKAAoIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnKtQgiGIAcoACQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAcoACAgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBygAHCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBygAGCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHathEIIhiAHKAAUIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAHKAAQIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAcoAAwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAcoAAggBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBygABCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBygAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHathCIdQn9RBEBBACEGDAELIAkgDEEBIBd0IgRrIAkgDCAJayAESxsgGBshCyAdQn+FIAWtiiEdQQAhBgNAIB2nIgRoIB1CIIinaEEgcyAEGyAFakE/cSIEBEAgDSAEQQJ0aigCACIEIAtJDQIgESAGQQJ0aiAENgIAIAZBAWohBiAIQQFrIQgLIB1CAX0gHYMiHVANASAIDQALCyAVIBpqIQkgByAFQQFrQT9xQT9BACAFQT9xQQFGG2oiBDoAACAEIAdqIAo6AAAgACAAKAIcIgdBAWo2AhwgDSAEQQJ0aiAHNgIAAkAgBkUEQEEDIQcMAQsgAUEDayEPIAxBA2ohEyACQQFrIRAgAkEDayENQQAhBUEDIQcDQAJAIA4gESAFQQJ0aigCACIUaiIAIAdqQQNrKAAAIAcgD2ooAABHDQAgBwJ/AkAgASANTwRAIAEhBAwBCyAAKAAAIgsgASIEKAAAIgpHBEAgCiALc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIA1PDQEgACgAACILIAQoAAAiCkYNAAsgBCAKIAtzaEEDdmogAWsMAQsCQCAEIBBPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBMgFGs2AgAgBCEHIAEgBGogAkYNAgsgBUEBaiIFIAZHDQALC0EAIQQCQCAZQf8BcUGBgoQIbCIAIAkoADxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCSgAOCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAkoADQgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCSgAMCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAkoACwgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCSgAKCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyrUIIhiAJKAAkIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAJKAAgIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAkoABwgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAkoABggAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgCSgAFCAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgCSgAECAAcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAJKAAMIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAJKAAIIABzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAkoAAQgAHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAkoAAAgAHMiAEGAgYKEeHJBgYKECGsgAHJBgIGChHhxQYGBgQFsQRx2rYRCf4UiHUEAIAkxAAAiHkI/g6ciBWtBP3GthiAdIB6IhCIdUA0AIAhFDQAgGyAVQQJ0aiEGIA4gFmohFCASKAIAIQogEigCBCENIBIoAgwhCwNAAkAgHaciAGggHUIgiKdoQSBzIAAbIAVqQT9xIgAEQCAGIABBAnRqKAIAIgAgC0kNASARIARBAnRqIAA2AgAgCEEBayEIIARBAWohBAsgHUIBfSAdgyIdUA0AIAgNAQsLIARFDQAgDSAWaiEJIAFBBGohCyAKIAxqQQNqIQ4gASgAACEGQQAhAANAAkAgDSARIABBAnRqKAIAIgVqIggoAAAgBkcNACALIAhBBGogAiAKIBQQ0AtBBGoiCCAHTQ0AIAMgDiAFIAlqazYCACAIIgcgAWogAkYNAgsgAEEBaiIAIARHDQALCyARQYACaiQAIAcL6g8CGn8CfiMAQRBrIgskACACKAIEIQwgAigCACEGIAAoArQBIgUoAgAhEyAFKAIEIRQgBSgCDCEFIABBADYC3AEgACgCxAEiDUEESyEPQQZBBCAAKALIASIKIApBBE0bIgogCkEGTxshFiADIAMgACgCBCIKIAAoAgwiEGoiF2sgBSAUaiIcIBNrRmohByAAKAIcIgUgBUEIIAMgBGoiCUEPayIdIAUgCmoiBGsiCCAIQQhPG0EAIAQgCUEQayISTRtqIghJBEAgAEEsaiERQRggACgCJCIEayEYQTggBGutIR8gACkDUCIgpyEOIBZBBWshGQNAIAUgCmohBCARIAVBB3FBAnRqAn8CQAJAAkAgGQ4CAQIACyAEKAAAQbHz3fF5bCAOcyAYdgwCCyAEKQAAQoCAgNjLm++NT34gIIUgH4inDAELIAQpAABCgIDs/Mub741PfiAghSAfiKcLNgIAIAVBAWoiBSAIRw0ACwsgByASSQRAQQYgDUEEIA8bIgUgBUEGTxshGiAAQSxqIRkgCUEgayEPIBQgFCATayAQaiIeayEbIBZBBWshGANAAkACfwJAAkACQCAHIAYgCmprQQFqIgUgEGtBfEsNACAUIAUgHmtqIAUgCmogBSAQSSIFGyIEKAAAIAdBAWoiCCgAAEcNACAHQQVqIARBBGogCSATIAkgBRsgFxDQC0EEaiEOQQEhFQwBCyALQf+T69wDNgIMAn8CQAJAAkAgFkEFaw4CAQIACwJAAkACQCAaQQVrDgIBAgALIAAgByAJIAtBDGoQ9gsMBAsgACAHIAkgC0EMahD3CwwDCyAAIAcgCSALQQxqEPgLDAILAkACQAJAIBpBBWsOAgECAAsgACAHIAkgC0EMahD5CwwDCyAAIAcgCSALQQxqEPoLDAILIAAgByAJIAtBDGoQ+wsMAQsCQAJAAkAgGkEFaw4CAQIACyAAIAcgCSALQQxqEPwLDAILIAAgByAJIAtBDGoQ/QsMAQsgACAHIAkgC0EMahD+CwsiDkEDTQRAIAAgByADayIFQf8PSzYC3AEgByAFQQh2akEBaiEHDAQLIAsoAgwiFUEETw0BIAchCAsgBiERIAwMAQsgFUEDayERAkACQCADIAdPDQAgGyAKIAcgCiAVamtBA2oiBSAQSSIEGyAFaiIFIBwgFyAEGyIETQ0AA0AgB0EBayIILQAAIAVBAWsiBS0AAEcNASAOQQFqIQ4gAyAITw0CIAghByAEIAVJDQALDAELIAchCAsgBgshBCAIIANrIQ0gASgCDCEGAkACQCAIIA9NBEAgBiAD/QAAAP0LAAAgASgCDCEGIA1BEE0EQCABIAYgDWo2AgwgASgCBCEDDAMLIAYgA/0AABD9CwAQIA1BIUgNASAGIA1qIQUgA0EQaiEDIAZBIGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgBUkNAAsMAQsgAyAPTQRAIAYgA/0AAAD9CwAAIAYgDyADayIHaiEFIAdBEU4EQCAGQRBqIQYDQCAGIAP9AAAQ/QsAACAGIAP9AAAg/QsAECADQSBqIQMgBkEgaiIGIAVJDQALCyAFIQYgDyEDCyADIAhPDQBBACEHIAMhBSAIIANrQQdxIgwEQANAIAYgBS0AADoAACAGQQFqIQYgBUEBaiEFIAdBAWoiByAMRw0ACwsgAyAIa0F4Sw0AA0AgBiAFLQAAOgAAIAYgBS0AAToAASAGIAUtAAI6AAIgBiAFLQADOgADIAYgBS0ABDoABCAGIAUtAAU6AAUgBiAFLQAGOgAGIAYgBS0ABzoAByAGQQhqIQYgBUEIaiIFIAhHDQALCyABIAEoAgwgDWo2AgwgASgCBCEDIA1BgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgFTYCACADIA07AQQgDkEDayIGQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAY7AQYgASADQQhqIgU2AgQgCCAOaiEDIAAoAtwBBEAgACgCHCIGIAZBCCAdIAYgCmoiB2siCCAIQQhPG0EAIAcgEk0baiIISQRAQRggACgCJCIHayEOQTggB2utIR8gACkDUCIgpyEMA0AgBiAKaiEHIBkgBkEHcUECdGoCfwJAAkACQCAYDgIBAgALIAcoAABBsfPd8XlsIAxzIA52DAILIAcpAABCgICA2Mub741PfiAghSAfiKcMAQsgBykAAEKAgOz8y5vvjU9+ICCFIB+Ipws2AgAgBkEBaiIGIAhHDQALCyAAQQA2AtwBCyAEIQwgESEGIAMhByADIBJLDQADQAJAIAQhBiARIQQgAyAGIApqayIHIBBrQXxLDQAgGyAKIAcgEEkiCBsgB2oiBygAACADKAAARw0AIANBBGogB0EEaiAJIBMgCSAIGyAXENALIQcgAyAPTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBQsgBUEBNgIAIAVBADsBBCAHQQFqIghBgIAETwRAIAFBAjYCJCABIAUgASgCAGtBA3U2AigLIAUgCDsBBiABIAVBCGoiBTYCBCAGIREgBCEMIAMgB2pBBGoiAyEHIAMgEk0NAQwCCwsgBiEMIAQhBiADIQcLIAcgEkkNAAsLIAIgDDYCBCACIAY2AgAgC0EQaiQAIAkgA2sLkxACGn8BfiMAQYACayIXJAAgASAAKAIEIg9rIQwgACgCuAEhGSAAKAIQIRMgACgCGCEaIAAoAsQBIhBBBGshGyABKAAAQbHz3fF5bCERQSIgACgCtAEiFSgCwAFrIRwgACgCDCEUQQQgECAQQQRPGyEdIAApA1AhHiAAKAIkIRggACgCKCESIAAoAlwhFgJAIAAoAtwBRQRAIABBLGohCQJAIAwgACgCHCIEa0GBA0kEQCASIQogFiELDAELIBIhCiAWIQsgBEGff00EQCAPQQhqIQogBEHfAGohC0EYIBhrIQ4DQCAJIARBB3FBAnRqIggoAgAhBSAIIAAoAlAgBCAKaigAAEGx893xeWxzIA52NgIAIBIgBUEEdkHw////AHEiB2oiCEEPQQAgCC0AACIGQQ9xQQFGGyAGQQFrQQ9xaiIGOgAAIAYgCGogBToAACAWIAdBAnRqIAZBAnRqIAQ2AgAgBCALRyEFIARBAWohBCAFDQALIAAoAighCiAAKAJcIQsLIAxBIGsiBCAEQQggAUEBaiIFIAQgD2oiCGtBAWoiBiAGQQhPG0EAIAUgCE8baiIITw0AQRggACgCJGshBiAAKAJQIQcgBCEFA0AgCSAFQQdxQQJ0aiAFIA9qKAAAQbHz3fF5bCAHcyAGdjYCACAFQQFqIgUgCEcNAAsLIAQgDEkEQCAAKAIEQQhqIQ5BGCAAKAIkayENA0AgCSAEQQdxQQJ0aiIIKAIAIQUgCCAAKAJQIAQgDmooAABBsfPd8XlscyANdjYCACAKIAVBBHZB8P///wBxIgdqIghBD0EAIAgtAAAiBkEPcUEBRhsgBkEBa0EPcWoiBjoAACAGIAhqIAU6AAAgCyAHQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAMSQ0ACwsgACAMNgIcIAkgDEEHcUECdGoiBCgCACEKIAQgHqcgDCAPaigACEGx893xeWxzQRggGGt2NgIADAELIAAgDDYCHCARIB6nc0EYIBhrdiEKCyAQQQRLIQ5BASAbdCENIBEgHHYhEEEBIB10IQsgACAAKAJYIApqNgJYIBIgCkEEdkHw////AHEiBGoiBi0AACEFIBYgBEECdGohCAJAIApB/wFxQYGChAhsIgQgBigADHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRh2QfABcSAGKAAIIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigABCAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEH//wNGBEBBACEHDAELIBMgDEEBIBl0IgdrIBMgDCATayAHSxsgGhshCSAEQX9zIgRB//8DcSAFQQ9xdiAEQQAgBWtBD3F0cq1C//8DgyEeQQAhBwNAQQAgHqdoIB5QGyAFakEPcSIEBEAgCCAEQQJ0aigCACIEIAlJDQIgFyAHQQJ0aiAENgIAIAdBAWohByALQQFrIQsLIB5CAX0gHoMiHlANASALDQALCyANQQAgDhshEyAQQQJ0IRIgBiAFQQFrQQ9xQQ9BACAFQQ9xQQFGG2oiBDoAACAEIAZqIAo6AAAgACAAKAIcIgVBAWo2AhwgCCAEQQJ0aiAFNgIAAkAgB0UEQEEDIQUMAQsgAUEDayENIAxBA2ohESACQQFrIRAgAkEDayEGQQAhCEEDIQUDQAJAIA8gFyAIQQJ0aigCACIOaiIAIAVqQQNrKAAAIAUgDWooAABHDQAgBQJ/AkAgASAGTwRAIAEhBAwBCyAAKAAAIgkgASIEKAAAIgpHBEAgCSAKc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIAZPDQEgACgAACIJIAQoAAAiCkYNAAsgBCAJIApzaEEDdmogAWsMAQsCQCAEIBBPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBEgDms2AgAgBCEFIAEgBGogAkYNAgsgCEEBaiIIIAdHDQALCyAPIBRqIQ4gFSgCACIPIBQgFSgCBCIIamshFCAVKAJcIBJBAnRqIgcoAgwhESAVKAJkIQoCQAJAIAsgE2oiDUUEQEEAIQYMAQtBAyANIA1BA08bIQYgAUEEaiELIAwgFGpBA2ohEEEAIQQgBSEJA0AgByAEQQJ0aigCACIARQRAIAkhBQwDCwJAIAAgCGoiBSgAACABKAAARw0AIAsgBUEEaiACIA8gDhDQC0EEaiIFIAlNDQAgAyAQIABrNgIAIAUhCSABIAVqIAJGDQMLIARBAWoiBCAGRw0ACyAJIQULIA0gBmsiBCARQf8BcSIAIAAgBEsbIglFDQAgCUEDcSEGQQAhAEEAIQQgCUEETwRAIAlB/AFxIQcDQCAEQQRqIgQgB0cNAAsLIAYEQANAIARBAWohBCAAQQFqIgAgBkcNAAsLIBFBCHYhBCABQQRqIQ0gDCAUakEDaiEMIAEoAAAhC0EAIQADQAJAIAggCiAEQQJ0aigCACIHaiIGKAAAIAtHDQAgDSAGQQRqIAIgDyAOENALQQRqIgYgBU0NACADIAwgB2s2AgAgBiIFIAFqIAJGDQILIARBAWohBCAAQQFqIgAgCUcNAAsLIBdBgAJqJAAgBQurEQIafwF+IwBBgAJrIhckACABIAAoAgQiD2shCyAAKAK4ASEZIAAoAhAhESAAKAIYIRogACgCxAEiEEEFayEbIAEoAABBsfPd8XlsIRJBIiAAKAK0ASIVKALAAWshHCAAKAIMIRRBBSAQIBBBBU8bIR0gACkDUCEeIAAoAiQhGCAAKAIoIRMgACgCXCEWAkAgACgC3AFFBEAgAEEsaiEJAkAgCyAAKAIcIgRrQYEDSQRAIBMhDSAWIQoMAQsgEyENIBYhCiAEQZ9/TQRAIA9BCGohDSAEQd8AaiEKQRggGGshDANAIAkgBEEHcUECdGoiCCgCACEHIAggACgCUCAEIA1qKAAAQbHz3fF5bHMgDHY2AgAgEyAHQQN2QeD///8BcSIGaiIIQR9BACAILQAAIgVBH3FBAUYbIAVBAWtBH3FqIgU6AAAgBSAIaiAHOgAAIBYgBkECdGogBUECdGogBDYCACAEIApHIQcgBEEBaiEEIAcNAAsgACgCKCENIAAoAlwhCgsgC0EgayIEIARBCCABQQFqIgcgBCAPaiIIa0EBaiIFIAVBCE8bQQAgByAITxtqIghPDQBBGCAAKAIkayEFIAAoAlAhBiAEIQcDQCAJIAdBB3FBAnRqIAcgD2ooAABBsfPd8XlsIAZzIAV2NgIAIAdBAWoiByAIRw0ACwsgBCALSQRAIAAoAgRBCGohDEEYIAAoAiRrIQ4DQCAJIARBB3FBAnRqIggoAgAhByAIIAAoAlAgBCAMaigAAEGx893xeWxzIA52NgIAIA0gB0EDdkHg////AXEiBmoiCEEfQQAgCC0AACIFQR9xQQFGGyAFQQFrQR9xaiIFOgAAIAUgCGogBzoAACAKIAZBAnRqIAVBAnRqIAQ2AgAgBEEBaiIEIAtJDQALCyAAIAs2AhwgCSALQQdxQQJ0aiIEKAIAIQwgBCAepyALIA9qKAAIQbHz3fF5bHNBGCAYa3Y2AgAMAQsgACALNgIcIBIgHqdzQRggGGt2IQwLIBBBBUshDkEBIBt0IRAgEiAcdiESQQEgHXQhCiAAIAAoAlggDGo2AlhBAyEHIBMgDEEDdkHg////AXEiBGoiBS0AACEIIBYgBEECdGohCQJAIAxB/wFxQYGChAhsIgQgBSgAHHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcSAFKAAYIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgAFCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAQIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgADCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAIIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgABCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEF/RgRAQQAhBgwBCyARIAtBASAZdCIGayARIAsgEWsgBksbIBobIQ0gBEF/cyAIeK0hHkEAIQYDQEEAIB6naCAeUBsgCGpBH3EiBARAIAkgBEECdGooAgAiBCANSQ0CIBcgBkECdGogBDYCACAGQQFqIQYgCkEBayEKCyAeQgF9IB6DIh5QDQEgCg0ACwsgEEEAIA4bIRMgEkECdCESIAUgCEEBa0EfcUEfQQAgCEEfcUEBRhtqIgQ6AAAgBCAFaiAMOgAAIAAgACgCHCIIQQFqNgIcIAkgBEECdGogCDYCAAJAIAZFDQAgAUEDayEOIAtBA2ohESACQQFrIRAgAkEDayEFQQAhCANAAkAgDyAXIAhBAnRqKAIAIgxqIgAgB2pBA2soAAAgByAOaigAAEcNACAHAn8CQCABIAVPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiDUcEQCAJIA1zaEEDdgwCCwNAIABBBGohACAEQQRqIgQgBU8NASAAKAAAIgkgBCgAACINRg0ACyAEIAkgDXNoQQN2aiABawwBCwJAIAQgEE8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgESAMazYCACAEIQcgASAEaiACRg0CCyAIQQFqIgggBkcNAAsLIA8gFGohDCAVKAIAIg8gFCAVKAIEIghqayEUIBUoAlwgEkECdGoiBigCDCERIBUoAmQhDQJAAkAgCiATaiIORQRAQQAhBQwBC0EDIA4gDkEDTxshBSABQQRqIQogCyAUakEDaiEQQQAhBCAHIQkDQCAGIARBAnRqKAIAIgBFBEAgCSEHDAMLAkAgACAIaiIHKAAAIAEoAABHDQAgCiAHQQRqIAIgDyAMENALQQRqIgcgCU0NACADIBAgAGs2AgAgByEJIAEgB2ogAkYNAwsgBEEBaiIEIAVHDQALIAkhBwsgDiAFayIEIBFB/wFxIgAgACAESxsiCUUNACAJQQNxIQVBACEAQQAhBCAJQQRPBEAgCUH8AXEhBgNAIARBBGoiBCAGRw0ACwsgBQRAA0AgBEEBaiEEIABBAWoiACAFRw0ACwsgEUEIdiEEIAFBBGohDiALIBRqQQNqIQsgASgAACEKQQAhAANAAkAgCCANIARBAnRqKAIAIgZqIgUoAAAgCkcNACAOIAVBBGogAiAPIAwQ0AtBBGoiBSAHTQ0AIAMgCyAGazYCACAFIQcgASAFaiACRg0CCyAEQQFqIQQgAEEBaiIAIAlHDQALCyAXQYACaiQAIAcLuBQCGn8BfiMAQYACayIXJAAgASAAKAIEIg9rIQwgACgCuAEhGSAAKAIQIREgACgCGCEaIAAoAsQBIhBBBmshGyABKAAAQbHz3fF5bCEUQSIgACgCtAEiFSgCwAFrIRwgACgCDCETQQYgECAQQQZPGyEdIAApA1AhHiAAKAIkIRggACgCKCESIAAoAlwhFgJAIAAoAtwBRQRAIABBLGohCQJAIAwgACgCHCIEa0GBA0kEQCASIQogFiELDAELIBIhCiAWIQsgBEGff00EQCAPQQhqIQogBEHfAGohC0EYIBhrIQ4DQCAJIARBB3FBAnRqIggoAgAhBSAIIAAoAlAgBCAKaigAAEGx893xeWxzIA52NgIAIBIgBUECdkHA////A3EiBmoiCEE/QQAgCC0AACIHQT9xQQFGGyAHQQFrQT9xaiIHOgAAIAcgCGogBToAACAWIAZBAnRqIAdBAnRqIAQ2AgAgBCALRyEFIARBAWohBCAFDQALIAAoAighCiAAKAJcIQsLIAxBIGsiBCAEQQggAUEBaiIFIAQgD2oiCGtBAWoiByAHQQhPG0EAIAUgCE8baiIITw0AQRggACgCJGshByAAKAJQIQYgBCEFA0AgCSAFQQdxQQJ0aiAFIA9qKAAAQbHz3fF5bCAGcyAHdjYCACAFQQFqIgUgCEcNAAsLIAQgDEkEQCAAKAIEQQhqIQ5BGCAAKAIkayENA0AgCSAEQQdxQQJ0aiIIKAIAIQUgCCAAKAJQIAQgDmooAABBsfPd8XlscyANdjYCACAKIAVBAnZBwP///wNxIgZqIghBP0EAIAgtAAAiB0E/cUEBRhsgB0EBa0E/cWoiBzoAACAHIAhqIAU6AAAgCyAGQQJ0aiAHQQJ0aiAENgIAIARBAWoiBCAMSQ0ACwsgACAMNgIcIAkgDEEHcUECdGoiBCgCACEKIAQgHqcgDCAPaigACEGx893xeWxzQRggGGt2NgIADAELIAAgDDYCHCAUIB6nc0EYIBhrdiEKCyAQQQZLIQ5BASAbdCENIBQgHHYhEEEBIB10IQsgACAAKAJYIApqNgJYIBIgCkECdkHA////A3EiBGoiBS0AACEIIBYgBEECdGohBwJAIApB/wFxQYGChAhsIgQgBSgAPHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcSAFKAA4IARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgANCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAwIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgALCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAoIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnKtQgiGIAUoACQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAUoACAgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBSgAHCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBSgAGCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHathEIIhiAFKAAUIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAFKAAQIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAUoAAwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAUoAAggBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBSgABCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBSgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHathCIeQn9RBEBBACEGDAELIBEgDEEBIBl0IgRrIBEgDCARayAESxsgGhshCSAeQn+FIAitiiEeQQAhBgNAIB6nIgRoIB5CIIinaEEgcyAEGyAIakE/cSIEBEAgByAEQQJ0aigCACIEIAlJDQIgFyAGQQJ0aiAENgIAIAZBAWohBiALQQFrIQsLIB5CAX0gHoMiHlANASALDQALCyANQQAgDhshFCAQQQJ0IRIgBSAIQQFrQT9xQT9BACAIQT9xQQFGG2oiBDoAACAEIAVqIAo6AAAgACAAKAIcIgVBAWo2AhwgByAEQQJ0aiAFNgIAAkAgBkUEQEEDIQUMAQsgAUEDayENIAxBA2ohESACQQFrIRAgAkEDayEHQQAhCEEDIQUDQAJAIA8gFyAIQQJ0aigCACIOaiIAIAVqQQNrKAAAIAUgDWooAABHDQAgBQJ/AkAgASAHTwRAIAEhBAwBCyAAKAAAIgkgASIEKAAAIgpHBEAgCSAKc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIAdPDQEgACgAACIJIAQoAAAiCkYNAAsgBCAJIApzaEEDdmogAWsMAQsCQCAEIBBPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBEgDms2AgAgBCEFIAEgBGogAkYNAgsgCEEBaiIIIAZHDQALCyAPIBNqIQ4gFSgCACIPIBMgFSgCBCIIamshEyAVKAJcIBJBAnRqIgYoAgwhESAVKAJkIQoCQAJAIAsgFGoiDUUEQEEAIQcMAQtBAyANIA1BA08bIQcgAUEEaiELIAwgE2pBA2ohEEEAIQQgBSEJA0AgBiAEQQJ0aigCACIARQRAIAkhBQwDCwJAIAAgCGoiBSgAACABKAAARw0AIAsgBUEEaiACIA8gDhDQC0EEaiIFIAlNDQAgAyAQIABrNgIAIAUhCSABIAVqIAJGDQMLIARBAWoiBCAHRw0ACyAJIQULIA0gB2siBCARQf8BcSIAIAAgBEsbIglFDQAgCUEDcSEHQQAhAEEAIQQgCUEETwRAIAlB/AFxIQYDQCAEQQRqIgQgBkcNAAsLIAcEQANAIARBAWohBCAAQQFqIgAgB0cNAAsLIBFBCHYhBCABQQRqIQ0gDCATakEDaiEMIAEoAAAhC0EAIQADQAJAIAggCiAEQQJ0aigCACIGaiIHKAAAIAtHDQAgDSAHQQRqIAIgDyAOENALQQRqIgcgBU0NACADIAwgBms2AgAgByIFIAFqIAJGDQILIARBAWohBCAAQQFqIgAgCUcNAAsLIBdBgAJqJAAgBQusEAIXfwR+IwBBgAJrIhYkACABIAAoAgQiDmshDCAAKAK4ASEXIAAoAhAhESAAKAIYIRggACgCxAEiDUEEayEZIAEpAABCgICA2Mub741PfiIbQcIAIAAoArQBIhUoAsABa62IIR0gACgCDCEUQQQgDSANQQRPGyEaIAApA1AhHCAAKAIkIRIgACgCKCEPIAAoAlwhEwJAIAAoAtwBRQRAIABBLGohCQJAIAwgACgCHCIEa0GBA0kEQCAPIQogEyELDAELIA8hCiATIQsgBEGff00EQCAOQQhqIQogBEHfAGohC0E4IBJrrSEbA0AgCSAEQQdxQQJ0aiIIKAIAIQUgCCAAKQNQIAQgCmopAABCgICA2Mub741PfoUgG4g+AgAgDyAFQQR2QfD///8AcSIHaiIIQQ9BACAILQAAIgZBD3FBAUYbIAZBAWtBD3FqIgY6AAAgBiAIaiAFOgAAIBMgB0ECdGogBkECdGogBDYCACAEIAtHIQUgBEEBaiEEIAUNAAsgACgCKCEKIAAoAlwhCwsgDEEgayIEIARBCCABQQFqIgUgBCAOaiIIa0EBaiIGIAZBCE8bQQAgBSAITxtqIghPDQBBOCAAKAIka60hGyAAKQNQIR4gBCEFA0AgCSAFQQdxQQJ0aiAFIA5qKQAAQoCAgNjLm++NT34gHoUgG4g+AgAgBUEBaiIFIAhHDQALCyAEIAxJBEAgACgCBEEIaiEQQTggACgCJGutIRsDQCAJIARBB3FBAnRqIggoAgAhBSAIIAApA1AgBCAQaikAAEKAgIDYy5vvjU9+hSAbiD4CACAKIAVBBHZB8P///wBxIgdqIghBD0EAIAgtAAAiBkEPcUEBRhsgBkEBa0EPcWoiBjoAACAGIAhqIAU6AAAgCyAHQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAMSQ0ACwsgACAMNgIcIAkgDEEHcUECdGoiBCgCACEKIAQgDCAOaikACEKAgIDYy5vvjU9+IByFQTggEmutiD4CAAwBCyAAIAw2AhwgGyAchUE4IBJrrYinIQoLIA1BBEshEEEBIBl0IQ0gHachEkEBIBp0IQsgACAAKAJYIApqNgJYIA8gCkEEdkHw////AHEiBGoiBi0AACEFIBMgBEECdGohCAJAIApB/wFxQYGChAhsIgQgBigADHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRh2QfABcSAGKAAIIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBigABCAEcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxciAGKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEH//wNGBEBBACEHDAELIBEgDEEBIBd0IgdrIBEgDCARayAHSxsgGBshCSAEQX9zIgRB//8DcSAFQQ9xdiAEQQAgBWtBD3F0cq1C//8DgyEbQQAhBwNAQQAgG6doIBtQGyAFakEPcSIEBEAgCCAEQQJ0aigCACIEIAlJDQIgFiAHQQJ0aiAENgIAIAdBAWohByALQQFrIQsLIBtCAX0gG4MiG1ANASALDQALCyANQQAgEBshEyASQQJ0IRIgBiAFQQFrQQ9xQQ9BACAFQQ9xQQFGG2oiBDoAACAEIAZqIAo6AAAgACAAKAIcIgVBAWo2AhwgCCAEQQJ0aiAFNgIAAkAgB0UEQEEDIQUMAQsgAUEDayENIAxBA2ohDyACQQFrIREgAkEDayEGQQAhCEEDIQUDQAJAIA4gFiAIQQJ0aigCACIQaiIAIAVqQQNrKAAAIAUgDWooAABHDQAgBQJ/AkAgASAGTwRAIAEhBAwBCyAAKAAAIgkgASIEKAAAIgpHBEAgCSAKc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIAZPDQEgACgAACIJIAQoAAAiCkYNAAsgBCAJIApzaEEDdmogAWsMAQsCQCAEIBFPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIA8gEGs2AgAgBCEFIAEgBGogAkYNAgsgCEEBaiIIIAdHDQALCyAOIBRqIRAgFSgCACIOIBQgFSgCBCIIamshFCAVKAJcIBJBAnRqIgcoAgwhDyAVKAJkIQoCQAJAIAsgE2oiDUUEQEEAIQYMAQtBAyANIA1BA08bIQYgAUEEaiELIAwgFGpBA2ohEUEAIQQgBSEJA0AgByAEQQJ0aigCACIARQRAIAkhBQwDCwJAIAAgCGoiBSgAACABKAAARw0AIAsgBUEEaiACIA4gEBDQC0EEaiIFIAlNDQAgAyARIABrNgIAIAUhCSABIAVqIAJGDQMLIARBAWoiBCAGRw0ACyAJIQULIA0gBmsiBCAPQf8BcSIAIAAgBEsbIglFDQAgCUEDcSEGQQAhAEEAIQQgCUEETwRAIAlB/AFxIQcDQCAEQQRqIgQgB0cNAAsLIAYEQANAIARBAWohBCAAQQFqIgAgBkcNAAsLIA9BCHYhBCABQQRqIQ0gDCAUakEDaiEMIAEoAAAhC0EAIQADQAJAIAggCiAEQQJ0aigCACIHaiIGKAAAIAtHDQAgDSAGQQRqIAIgDiAQENALQQRqIgYgBU0NACADIAwgB2s2AgAgBiIFIAFqIAJGDQILIARBAWohBCAAQQFqIgAgCUcNAAsLIBZBgAJqJAAgBQvEEQIXfwR+IwBBgAJrIhYkACABIAAoAgQiD2shCyAAKAK4ASEYIAAoAhAhESAAKAIYIRkgACgCxAEiDEEFayEXIAEpAABCgICA2Mub741PfiIbQcIAIAAoArQBIhUoAsABa62IIR0gACgCDCEUQQUgDCAMQQVPGyEaIAApA1AhHCAAKAIkIRIgACgCKCEQIAAoAlwhEwJAIAAoAtwBRQRAIABBLGohCQJAIAsgACgCHCIEa0GBA0kEQCAQIQ0gEyEKDAELIBAhDSATIQogBEGff00EQCAPQQhqIQ0gBEHfAGohCkE4IBJrrSEbA0AgCSAEQQdxQQJ0aiIIKAIAIQcgCCAAKQNQIAQgDWopAABCgICA2Mub741PfoUgG4g+AgAgECAHQQN2QeD///8BcSIGaiIIQR9BACAILQAAIgVBH3FBAUYbIAVBAWtBH3FqIgU6AAAgBSAIaiAHOgAAIBMgBkECdGogBUECdGogBDYCACAEIApHIQcgBEEBaiEEIAcNAAsgACgCKCENIAAoAlwhCgsgC0EgayIEIARBCCABQQFqIgcgBCAPaiIIa0EBaiIFIAVBCE8bQQAgByAITxtqIghPDQBBOCAAKAIka60hGyAAKQNQIR4gBCEHA0AgCSAHQQdxQQJ0aiAHIA9qKQAAQoCAgNjLm++NT34gHoUgG4g+AgAgB0EBaiIHIAhHDQALCyAEIAtJBEAgACgCBEEIaiEOQTggACgCJGutIRsDQCAJIARBB3FBAnRqIggoAgAhByAIIAApA1AgBCAOaikAAEKAgIDYy5vvjU9+hSAbiD4CACANIAdBA3ZB4P///wFxIgZqIghBH0EAIAgtAAAiBUEfcUEBRhsgBUEBa0EfcWoiBToAACAFIAhqIAc6AAAgCiAGQQJ0aiAFQQJ0aiAENgIAIARBAWoiBCALSQ0ACwsgACALNgIcIAkgC0EHcUECdGoiBCgCACEOIAQgCyAPaikACEKAgIDYy5vvjU9+IByFQTggEmutiD4CAAwBCyAAIAs2AhwgGyAchUE4IBJrrYinIQ4LIAxBBUshDEEBIBd0IRIgHachF0EBIBp0IQogACAAKAJYIA5qNgJYQQMhByAQIA5BA3ZB4P///wFxIgRqIgUtAAAhCCATIARBAnRqIQkCQCAOQf8BcUGBgoQIbCIEIAUoABxzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXEgBSgAGCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAUoABQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBSgAECAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAUoAAwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBSgACCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAUoAAQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBSgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgRBf0YEQEEAIQYMAQsgESALQQEgGHQiBmsgESALIBFrIAZLGyAZGyENIARBf3MgCHitIRtBACEGA0BBACAbp2ggG1AbIAhqQR9xIgQEQCAJIARBAnRqKAIAIgQgDUkNAiAWIAZBAnRqIAQ2AgAgBkEBaiEGIApBAWshCgsgG0IBfSAbgyIbUA0BIAoNAAsLIBJBACAMGyETIBdBAnQhEiAFIAhBAWtBH3FBH0EAIAhBH3FBAUYbaiIEOgAAIAQgBWogDjoAACAAIAAoAhwiCEEBajYCHCAJIARBAnRqIAg2AgACQCAGRQ0AIAFBA2shDCALQQNqIRAgAkEBayERIAJBA2shBUEAIQgDQAJAIA8gFiAIQQJ0aigCACIOaiIAIAdqQQNrKAAAIAcgDGooAABHDQAgBwJ/AkAgASAFTwRAIAEhBAwBCyAAKAAAIgkgASIEKAAAIg1HBEAgCSANc2hBA3YMAgsDQCAAQQRqIQAgBEEEaiIEIAVPDQEgACgAACIJIAQoAAAiDUYNAAsgBCAJIA1zaEEDdmogAWsMAQsCQCAEIBFPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBAgDms2AgAgBCEHIAEgBGogAkYNAgsgCEEBaiIIIAZHDQALCyAPIBRqIQ4gFSgCACIPIBQgFSgCBCIIamshFCAVKAJcIBJBAnRqIgYoAgwhECAVKAJkIQ0CQAJAIAogE2oiDEUEQEEAIQUMAQtBAyAMIAxBA08bIQUgAUEEaiEKIAsgFGpBA2ohEUEAIQQgByEJA0AgBiAEQQJ0aigCACIARQRAIAkhBwwDCwJAIAAgCGoiBygAACABKAAARw0AIAogB0EEaiACIA8gDhDQC0EEaiIHIAlNDQAgAyARIABrNgIAIAchCSABIAdqIAJGDQMLIARBAWoiBCAFRw0ACyAJIQcLIAwgBWsiBCAQQf8BcSIAIAAgBEsbIglFDQAgCUEDcSEFQQAhAEEAIQQgCUEETwRAIAlB/AFxIQYDQCAEQQRqIgQgBkcNAAsLIAUEQANAIARBAWohBCAAQQFqIgAgBUcNAAsLIBBBCHYhBCABQQRqIQwgCyAUakEDaiELIAEoAAAhCkEAIQADQAJAIAggDSAEQQJ0aigCACIGaiIFKAAAIApHDQAgDCAFQQRqIAIgDyAOENALQQRqIgUgB00NACADIAsgBms2AgAgBSEHIAEgBWogAkYNAgsgBEEBaiEEIABBAWoiACAJRw0ACwsgFkGAAmokACAHC9EUAhd/BH4jAEGAAmsiFiQAIAEgACgCBCIOayEMIAAoArgBIRcgACgCECERIAAoAhghGCAAKALEASINQQZrIRkgASkAAEKAgIDYy5vvjU9+IhtBwgAgACgCtAEiFSgCwAFrrYghHSAAKAIMIRRBBiANIA1BBk8bIRogACkDUCEcIAAoAiQhEiAAKAIoIQ8gACgCXCETAkAgACgC3AFFBEAgAEEsaiEJAkAgDCAAKAIcIgRrQYEDSQRAIA8hCiATIQsMAQsgDyEKIBMhCyAEQZ9/TQRAIA5BCGohCiAEQd8AaiELQTggEmutIRsDQCAJIARBB3FBAnRqIggoAgAhBSAIIAApA1AgBCAKaikAAEKAgIDYy5vvjU9+hSAbiD4CACAPIAVBAnZBwP///wNxIgZqIghBP0EAIAgtAAAiB0E/cUEBRhsgB0EBa0E/cWoiBzoAACAHIAhqIAU6AAAgEyAGQQJ0aiAHQQJ0aiAENgIAIAQgC0chBSAEQQFqIQQgBQ0ACyAAKAIoIQogACgCXCELCyAMQSBrIgQgBEEIIAFBAWoiBSAEIA5qIghrQQFqIgcgB0EITxtBACAFIAhPG2oiCE8NAEE4IAAoAiRrrSEbIAApA1AhHiAEIQUDQCAJIAVBB3FBAnRqIAUgDmopAABCgICA2Mub741PfiAehSAbiD4CACAFQQFqIgUgCEcNAAsLIAQgDEkEQCAAKAIEQQhqIRBBOCAAKAIka60hGwNAIAkgBEEHcUECdGoiCCgCACEFIAggACkDUCAEIBBqKQAAQoCAgNjLm++NT36FIBuIPgIAIAogBUECdkHA////A3EiBmoiCEE/QQAgCC0AACIHQT9xQQFGGyAHQQFrQT9xaiIHOgAAIAcgCGogBToAACALIAZBAnRqIAdBAnRqIAQ2AgAgBEEBaiIEIAxJDQALCyAAIAw2AhwgCSAMQQdxQQJ0aiIEKAIAIQogBCAMIA5qKQAIQoCAgNjLm++NT34gHIVBOCASa62IPgIADAELIAAgDDYCHCAbIByFQTggEmutiKchCgsgDUEGSyEQQQEgGXQhDSAdpyESQQEgGnQhCyAAIAAoAlggCmo2AlggDyAKQQJ2QcD///8DcSIEaiIFLQAAIQggEyAEQQJ0aiEHAkAgCkH/AXFBgYKECGwiBCAFKAA8cyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxIAUoADggBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2ckEIdCAFKAA0IARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAUoADAgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2ckEIdCAFKAAsIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAUoACggBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2cq1CCIYgBSgAJCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBSgAICAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHathEIIhiAFKAAcIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAFKAAYIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAUoABQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAUoABAgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBSgADCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBSgACCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHathEIIhiAFKAAEIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAFKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdq2EIhtCf1EEQEEAIQYMAQsgESAMQQEgF3QiBGsgESAMIBFrIARLGyAYGyEJIBtCf4UgCK2KIRtBACEGA0AgG6ciBGggG0IgiKdoQSBzIAQbIAhqQT9xIgQEQCAHIARBAnRqKAIAIgQgCUkNAiAWIAZBAnRqIAQ2AgAgBkEBaiEGIAtBAWshCwsgG0IBfSAbgyIbUA0BIAsNAAsLIA1BACAQGyETIBJBAnQhEiAFIAhBAWtBP3FBP0EAIAhBP3FBAUYbaiIEOgAAIAQgBWogCjoAACAAIAAoAhwiBUEBajYCHCAHIARBAnRqIAU2AgACQCAGRQRAQQMhBQwBCyABQQNrIQ0gDEEDaiEPIAJBAWshESACQQNrIQdBACEIQQMhBQNAAkAgDiAWIAhBAnRqKAIAIhBqIgAgBWpBA2soAAAgBSANaigAAEcNACAFAn8CQCABIAdPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiCkcEQCAJIApzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgB08NASAAKAAAIgkgBCgAACIKRg0ACyAEIAkgCnNoQQN2aiABawwBCwJAIAQgEU8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgDyAQazYCACAEIQUgASAEaiACRg0CCyAIQQFqIgggBkcNAAsLIA4gFGohECAVKAIAIg4gFCAVKAIEIghqayEUIBUoAlwgEkECdGoiBigCDCEPIBUoAmQhCgJAAkAgCyATaiINRQRAQQAhBwwBC0EDIA0gDUEDTxshByABQQRqIQsgDCAUakEDaiERQQAhBCAFIQkDQCAGIARBAnRqKAIAIgBFBEAgCSEFDAMLAkAgACAIaiIFKAAAIAEoAABHDQAgCyAFQQRqIAIgDiAQENALQQRqIgUgCU0NACADIBEgAGs2AgAgBSEJIAEgBWogAkYNAwsgBEEBaiIEIAdHDQALIAkhBQsgDSAHayIEIA9B/wFxIgAgACAESxsiCUUNACAJQQNxIQdBACEAQQAhBCAJQQRPBEAgCUH8AXEhBgNAIARBBGoiBCAGRw0ACwsgBwRAA0AgBEEBaiEEIABBAWoiACAHRw0ACwsgD0EIdiEEIAFBBGohDSAMIBRqQQNqIQwgASgAACELQQAhAANAAkAgCCAKIARBAnRqKAIAIgZqIgcoAAAgC0cNACANIAdBBGogAiAOIBAQ0AtBBGoiByAFTQ0AIAMgDCAGazYCACAHIgUgAWogAkYNAgsgBEEBaiEEIABBAWoiACAJRw0ACwsgFkGAAmokACAFC6wQAhd/BH4jAEGAAmsiFiQAIAEgACgCBCIOayEMIAAoArgBIRcgACgCECERIAAoAhghGCAAKALEASINQQRrIRkgASkAAEKAgOz8y5vvjU9+IhtBwgAgACgCtAEiFSgCwAFrrYghHSAAKAIMIRRBBCANIA1BBE8bIRogACkDUCEcIAAoAiQhEiAAKAIoIQ8gACgCXCETAkAgACgC3AFFBEAgAEEsaiEJAkAgDCAAKAIcIgRrQYEDSQRAIA8hCiATIQsMAQsgDyEKIBMhCyAEQZ9/TQRAIA5BCGohCiAEQd8AaiELQTggEmutIRsDQCAJIARBB3FBAnRqIggoAgAhBSAIIAApA1AgBCAKaikAAEKAgOz8y5vvjU9+hSAbiD4CACAPIAVBBHZB8P///wBxIgdqIghBD0EAIAgtAAAiBkEPcUEBRhsgBkEBa0EPcWoiBjoAACAGIAhqIAU6AAAgEyAHQQJ0aiAGQQJ0aiAENgIAIAQgC0chBSAEQQFqIQQgBQ0ACyAAKAIoIQogACgCXCELCyAMQSBrIgQgBEEIIAFBAWoiBSAEIA5qIghrQQFqIgYgBkEITxtBACAFIAhPG2oiCE8NAEE4IAAoAiRrrSEbIAApA1AhHiAEIQUDQCAJIAVBB3FBAnRqIAUgDmopAABCgIDs/Mub741PfiAehSAbiD4CACAFQQFqIgUgCEcNAAsLIAQgDEkEQCAAKAIEQQhqIRBBOCAAKAIka60hGwNAIAkgBEEHcUECdGoiCCgCACEFIAggACkDUCAEIBBqKQAAQoCA7PzLm++NT36FIBuIPgIAIAogBUEEdkHw////AHEiB2oiCEEPQQAgCC0AACIGQQ9xQQFGGyAGQQFrQQ9xaiIGOgAAIAYgCGogBToAACALIAdBAnRqIAZBAnRqIAQ2AgAgBEEBaiIEIAxJDQALCyAAIAw2AhwgCSAMQQdxQQJ0aiIEKAIAIQogBCAMIA5qKQAIQoCA7PzLm++NT34gHIVBOCASa62IPgIADAELIAAgDDYCHCAbIByFQTggEmutiKchCgsgDUEESyEQQQEgGXQhDSAdpyESQQEgGnQhCyAAIAAoAlggCmo2AlggDyAKQQR2QfD///8AcSIEaiIGLQAAIQUgEyAEQQJ0aiEIAkAgCkH/AXFBgYKECGwiBCAGKAAMcyIHQYCBgoR4ckGBgoQIayAHckGAgYKEeHFBgYGBAWxBGHZB8AFxIAYoAAggBHMiB0GAgYKEeHJBgYKECGsgB3JBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAAEIARzIgdBgIGChHhyQYGChAhrIAdyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2ciIEQf//A0YEQEEAIQcMAQsgESAMQQEgF3QiB2sgESAMIBFrIAdLGyAYGyEJIARBf3MiBEH//wNxIAVBD3F2IARBACAFa0EPcXRyrUL//wODIRtBACEHA0BBACAbp2ggG1AbIAVqQQ9xIgQEQCAIIARBAnRqKAIAIgQgCUkNAiAWIAdBAnRqIAQ2AgAgB0EBaiEHIAtBAWshCwsgG0IBfSAbgyIbUA0BIAsNAAsLIA1BACAQGyETIBJBAnQhEiAGIAVBAWtBD3FBD0EAIAVBD3FBAUYbaiIEOgAAIAQgBmogCjoAACAAIAAoAhwiBUEBajYCHCAIIARBAnRqIAU2AgACQCAHRQRAQQMhBQwBCyABQQNrIQ0gDEEDaiEPIAJBAWshESACQQNrIQZBACEIQQMhBQNAAkAgDiAWIAhBAnRqKAIAIhBqIgAgBWpBA2soAAAgBSANaigAAEcNACAFAn8CQCABIAZPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiCkcEQCAJIApzaEEDdgwCCwNAIABBBGohACAEQQRqIgQgBk8NASAAKAAAIgkgBCgAACIKRg0ACyAEIAkgCnNoQQN2aiABawwBCwJAIAQgEU8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgDyAQazYCACAEIQUgASAEaiACRg0CCyAIQQFqIgggB0cNAAsLIA4gFGohECAVKAIAIg4gFCAVKAIEIghqayEUIBUoAlwgEkECdGoiBygCDCEPIBUoAmQhCgJAAkAgCyATaiINRQRAQQAhBgwBC0EDIA0gDUEDTxshBiABQQRqIQsgDCAUakEDaiERQQAhBCAFIQkDQCAHIARBAnRqKAIAIgBFBEAgCSEFDAMLAkAgACAIaiIFKAAAIAEoAABHDQAgCyAFQQRqIAIgDiAQENALQQRqIgUgCU0NACADIBEgAGs2AgAgBSEJIAEgBWogAkYNAwsgBEEBaiIEIAZHDQALIAkhBQsgDSAGayIEIA9B/wFxIgAgACAESxsiCUUNACAJQQNxIQZBACEAQQAhBCAJQQRPBEAgCUH8AXEhBwNAIARBBGoiBCAHRw0ACwsgBgRAA0AgBEEBaiEEIABBAWoiACAGRw0ACwsgD0EIdiEEIAFBBGohDSAMIBRqQQNqIQwgASgAACELQQAhAANAAkAgCCAKIARBAnRqKAIAIgdqIgYoAAAgC0cNACANIAZBBGogAiAOIBAQ0AtBBGoiBiAFTQ0AIAMgDCAHazYCACAGIgUgAWogAkYNAgsgBEEBaiEEIABBAWoiACAJRw0ACwsgFkGAAmokACAFC8QRAhd/BH4jAEGAAmsiFiQAIAEgACgCBCIPayELIAAoArgBIRggACgCECERIAAoAhghGSAAKALEASIMQQVrIRcgASkAAEKAgOz8y5vvjU9+IhtBwgAgACgCtAEiFSgCwAFrrYghHSAAKAIMIRRBBSAMIAxBBU8bIRogACkDUCEcIAAoAiQhEiAAKAIoIRAgACgCXCETAkAgACgC3AFFBEAgAEEsaiEJAkAgCyAAKAIcIgRrQYEDSQRAIBAhDSATIQoMAQsgECENIBMhCiAEQZ9/TQRAIA9BCGohDSAEQd8AaiEKQTggEmutIRsDQCAJIARBB3FBAnRqIggoAgAhByAIIAApA1AgBCANaikAAEKAgOz8y5vvjU9+hSAbiD4CACAQIAdBA3ZB4P///wFxIgZqIghBH0EAIAgtAAAiBUEfcUEBRhsgBUEBa0EfcWoiBToAACAFIAhqIAc6AAAgEyAGQQJ0aiAFQQJ0aiAENgIAIAQgCkchByAEQQFqIQQgBw0ACyAAKAIoIQ0gACgCXCEKCyALQSBrIgQgBEEIIAFBAWoiByAEIA9qIghrQQFqIgUgBUEITxtBACAHIAhPG2oiCE8NAEE4IAAoAiRrrSEbIAApA1AhHiAEIQcDQCAJIAdBB3FBAnRqIAcgD2opAABCgIDs/Mub741PfiAehSAbiD4CACAHQQFqIgcgCEcNAAsLIAQgC0kEQCAAKAIEQQhqIQ5BOCAAKAIka60hGwNAIAkgBEEHcUECdGoiCCgCACEHIAggACkDUCAEIA5qKQAAQoCA7PzLm++NT36FIBuIPgIAIA0gB0EDdkHg////AXEiBmoiCEEfQQAgCC0AACIFQR9xQQFGGyAFQQFrQR9xaiIFOgAAIAUgCGogBzoAACAKIAZBAnRqIAVBAnRqIAQ2AgAgBEEBaiIEIAtJDQALCyAAIAs2AhwgCSALQQdxQQJ0aiIEKAIAIQ4gBCALIA9qKQAIQoCA7PzLm++NT34gHIVBOCASa62IPgIADAELIAAgCzYCHCAbIByFQTggEmutiKchDgsgDEEFSyEMQQEgF3QhEiAdpyEXQQEgGnQhCiAAIAAoAlggDmo2AlhBAyEHIBAgDkEDdkHg////AXEiBGoiBS0AACEIIBMgBEECdGohCQJAIA5B/wFxQYGChAhsIgQgBSgAHHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcSAFKAAYIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgAFCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAQIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgADCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAIIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdnJBCHQgBSgABCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxciAFKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdnIiBEF/RgRAQQAhBgwBCyARIAtBASAYdCIGayARIAsgEWsgBksbIBkbIQ0gBEF/cyAIeK0hG0EAIQYDQEEAIBunaCAbUBsgCGpBH3EiBARAIAkgBEECdGooAgAiBCANSQ0CIBYgBkECdGogBDYCACAGQQFqIQYgCkEBayEKCyAbQgF9IBuDIhtQDQEgCg0ACwsgEkEAIAwbIRMgF0ECdCESIAUgCEEBa0EfcUEfQQAgCEEfcUEBRhtqIgQ6AAAgBCAFaiAOOgAAIAAgACgCHCIIQQFqNgIcIAkgBEECdGogCDYCAAJAIAZFDQAgAUEDayEMIAtBA2ohECACQQFrIREgAkEDayEFQQAhCANAAkAgDyAWIAhBAnRqKAIAIg5qIgAgB2pBA2soAAAgByAMaigAAEcNACAHAn8CQCABIAVPBEAgASEEDAELIAAoAAAiCSABIgQoAAAiDUcEQCAJIA1zaEEDdgwCCwNAIABBBGohACAEQQRqIgQgBU8NASAAKAAAIgkgBCgAACINRg0ACyAEIAkgDXNoQQN2aiABawwBCwJAIAQgEU8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgECAOazYCACAEIQcgASAEaiACRg0CCyAIQQFqIgggBkcNAAsLIA8gFGohDiAVKAIAIg8gFCAVKAIEIghqayEUIBUoAlwgEkECdGoiBigCDCEQIBUoAmQhDQJAAkAgCiATaiIMRQRAQQAhBQwBC0EDIAwgDEEDTxshBSABQQRqIQogCyAUakEDaiERQQAhBCAHIQkDQCAGIARBAnRqKAIAIgBFBEAgCSEHDAMLAkAgACAIaiIHKAAAIAEoAABHDQAgCiAHQQRqIAIgDyAOENALQQRqIgcgCU0NACADIBEgAGs2AgAgByEJIAEgB2ogAkYNAwsgBEEBaiIEIAVHDQALIAkhBwsgDCAFayIEIBBB/wFxIgAgACAESxsiCUUNACAJQQNxIQVBACEAQQAhBCAJQQRPBEAgCUH8AXEhBgNAIARBBGoiBCAGRw0ACwsgBQRAA0AgBEEBaiEEIABBAWoiACAFRw0ACwsgEEEIdiEEIAFBBGohDCALIBRqQQNqIQsgASgAACEKQQAhAANAAkAgCCANIARBAnRqKAIAIgZqIgUoAAAgCkcNACAMIAVBBGogAiAPIA4Q0AtBBGoiBSAHTQ0AIAMgCyAGazYCACAFIQcgASAFaiACRg0CCyAEQQFqIQQgAEEBaiIAIAlHDQALCyAWQYACaiQAIAcL0RQCF38EfiMAQYACayIWJAAgASAAKAIEIg5rIQwgACgCuAEhFyAAKAIQIREgACgCGCEYIAAoAsQBIg1BBmshGSABKQAAQoCA7PzLm++NT34iG0HCACAAKAK0ASIVKALAAWutiCEdIAAoAgwhFEEGIA0gDUEGTxshGiAAKQNQIRwgACgCJCESIAAoAighDyAAKAJcIRMCQCAAKALcAUUEQCAAQSxqIQkCQCAMIAAoAhwiBGtBgQNJBEAgDyEKIBMhCwwBCyAPIQogEyELIARBn39NBEAgDkEIaiEKIARB3wBqIQtBOCASa60hGwNAIAkgBEEHcUECdGoiCCgCACEFIAggACkDUCAEIApqKQAAQoCA7PzLm++NT36FIBuIPgIAIA8gBUECdkHA////A3EiBmoiCEE/QQAgCC0AACIHQT9xQQFGGyAHQQFrQT9xaiIHOgAAIAcgCGogBToAACATIAZBAnRqIAdBAnRqIAQ2AgAgBCALRyEFIARBAWohBCAFDQALIAAoAighCiAAKAJcIQsLIAxBIGsiBCAEQQggAUEBaiIFIAQgDmoiCGtBAWoiByAHQQhPG0EAIAUgCE8baiIITw0AQTggACgCJGutIRsgACkDUCEeIAQhBQNAIAkgBUEHcUECdGogBSAOaikAAEKAgOz8y5vvjU9+IB6FIBuIPgIAIAVBAWoiBSAIRw0ACwsgBCAMSQRAIAAoAgRBCGohEEE4IAAoAiRrrSEbA0AgCSAEQQdxQQJ0aiIIKAIAIQUgCCAAKQNQIAQgEGopAABCgIDs/Mub741PfoUgG4g+AgAgCiAFQQJ2QcD///8DcSIGaiIIQT9BACAILQAAIgdBP3FBAUYbIAdBAWtBP3FqIgc6AAAgByAIaiAFOgAAIAsgBkECdGogB0ECdGogBDYCACAEQQFqIgQgDEkNAAsLIAAgDDYCHCAJIAxBB3FBAnRqIgQoAgAhCiAEIAwgDmopAAhCgIDs/Mub741PfiAchUE4IBJrrYg+AgAMAQsgACAMNgIcIBsgHIVBOCASa62IpyEKCyANQQZLIRBBASAZdCENIB2nIRJBASAadCELIAAgACgCWCAKajYCWCAPIApBAnZBwP///wNxIgRqIgUtAAAhCCATIARBAnRqIQcCQCAKQf8BcUGBgoQIbCIEIAUoADxzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXEgBSgAOCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAUoADQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBSgAMCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyQQh0IAUoACwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABcXIgBSgAKCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHZyrUIIhiAFKAAkIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAFKAAgIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAUoABwgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAUoABggBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBSgAFCAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBSgAECAEcyIGQYCBgoR4ckGBgoQIayAGckGAgYKEeHFBgYGBAWxBHHathEIIhiAFKAAMIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAFKAAIIARzIgZBgIGChHhyQYGChAhrIAZyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAUoAAQgBHMiBkGAgYKEeHJBgYKECGsgBnJBgIGChHhxQYGBgQFsQRh2QfABca2EIAUoAAAgBHMiBEGAgYKEeHJBgYKECGsgBHJBgIGChHhxQYGBgQFsQRx2rYQiG0J/UQRAQQAhBgwBCyARIAxBASAXdCIEayARIAwgEWsgBEsbIBgbIQkgG0J/hSAIrYohG0EAIQYDQCAbpyIEaCAbQiCIp2hBIHMgBBsgCGpBP3EiBARAIAcgBEECdGooAgAiBCAJSQ0CIBYgBkECdGogBDYCACAGQQFqIQYgC0EBayELCyAbQgF9IBuDIhtQDQEgCw0ACwsgDUEAIBAbIRMgEkECdCESIAUgCEEBa0E/cUE/QQAgCEE/cUEBRhtqIgQ6AAAgBCAFaiAKOgAAIAAgACgCHCIFQQFqNgIcIAcgBEECdGogBTYCAAJAIAZFBEBBAyEFDAELIAFBA2shDSAMQQNqIQ8gAkEBayERIAJBA2shB0EAIQhBAyEFA0ACQCAOIBYgCEECdGooAgAiEGoiACAFakEDaygAACAFIA1qKAAARw0AIAUCfwJAIAEgB08EQCABIQQMAQsgACgAACIJIAEiBCgAACIKRwRAIAkgCnNoQQN2DAILA0AgAEEEaiEAIARBBGoiBCAHTw0BIAAoAAAiCSAEKAAAIgpGDQALIAQgCSAKc2hBA3ZqIAFrDAELAkAgBCARTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAPIBBrNgIAIAQhBSABIARqIAJGDQILIAhBAWoiCCAGRw0ACwsgDiAUaiEQIBUoAgAiDiAUIBUoAgQiCGprIRQgFSgCXCASQQJ0aiIGKAIMIQ8gFSgCZCEKAkACQCALIBNqIg1FBEBBACEHDAELQQMgDSANQQNPGyEHIAFBBGohCyAMIBRqQQNqIRFBACEEIAUhCQNAIAYgBEECdGooAgAiAEUEQCAJIQUMAwsCQCAAIAhqIgUoAAAgASgAAEcNACALIAVBBGogAiAOIBAQ0AtBBGoiBSAJTQ0AIAMgESAAazYCACAFIQkgASAFaiACRg0DCyAEQQFqIgQgB0cNAAsgCSEFCyANIAdrIgQgD0H/AXEiACAAIARLGyIJRQ0AIAlBA3EhB0EAIQBBACEEIAlBBE8EQCAJQfwBcSEGA0AgBEEEaiIEIAZHDQALCyAHBEADQCAEQQFqIQQgAEEBaiIAIAdHDQALCyAPQQh2IQQgAUEEaiENIAwgFGpBA2ohDCABKAAAIQtBACEAA0ACQCAIIAogBEECdGooAgAiBmoiBygAACALRw0AIA0gB0EEaiACIA4gEBDQC0EEaiIHIAVNDQAgAyAMIAZrNgIAIAciBSABaiACRg0CCyAEQQFqIQQgAEEBaiIAIAlHDQALCyAWQYACaiQAIAULthEBF38jAEEQayIOJAAgAigCBCEUIAIoAgAhEyAAQQA2AtwBQQAgEyATIAMgAyAAKAIEIg8gACgCDCIFaiIYRmoiBiAPayIPIAUgD0EBIAAoArgBdCIJayAFIA8gBWsgCUsbIAAoAhgbayIFSyIZGyEJQQAgFCAFIBRJIhsbIRAgAyAEaiIMQQhrIhEgBksEQCAMQSBrIRIgDEEBayEVIAxBA2shD0EGQQQgACgCyAEiBSAFQQRNGyIFIAVBBk8bQQRrIRoDQEEAIQVBACAJayENIAZBAWohCgJAIAlFDQAgCiAJaygAACAGKAABRw0AIAZBBWoiCCANaiEEAn8CQCAIIA9PBEAgCCEFDAELIAQoAAAiByAIIgUoAAAiC0cEQCAHIAtzaEEDdgwCCwNAIARBBGohBCAFQQRqIgUgD08NASAEKAAAIgcgBSgAACILRg0ACyAFIAcgC3NoQQN2aiAIawwBCwJAIAUgFU8NACAELwAAIAUvAABHDQAgBEECaiEEIAVBAmohBQsgBSAMSQR/IAUgBC0AACAFLQAARmoFIAULIAhrC0EEaiEFCyAOQf+T69wDNgIMAkACfwJAAkACQCAaQQFrDgIBAgALIAAgBiAMIA5BDGoQ1gsMAgsgACAGIAwgDkEMahDXCwwBCyAAIAYgDCAOQQxqENgLCyIEIAUgBCAFSyIIGyIHQQRPBEAgBiAKIAgbIgshBSAOKAIMQQEgCBsiCiEEIAchCAJAIAYgEU8NAANAIAZBAWohBQJAIApFBEBBACEKDAELIAlFDQAgBSgAACAFIA1qKAAARw0AIAZBBWoiCCANaiEEIApnIAdBA2xqQR5rAn8CQAJAIAggD08EQCAIIQYMAQsgBCgAACIWIAgiBigAACIXRwRAIBYgF3NoQQN2QQRyDAMLA0AgBEEEaiEEIAZBBGoiBiAPTw0BIAQoAAAiFiAGKAAAIhdGDQALIAYgFiAXc2hBA3ZqIQYMAQsCQCAGIBVPDQAgBC8AACAGLwAARw0AIARBAmohBCAGQQJqIQYLIAYgDE8NACAGIAQtAAAgBi0AAEZqIQYLIAYgCGsiBkF7Sw0BIAZBBGoLIgZBA2xODQBBASEKIAUhCyAGIQcLIA5B/5Pr3AM2AggCQAJ/AkACQAJAIBpBAWsOAgECAAsgACAFIAwgDkEIahDWCwwCCyAAIAUgDCAOQQhqENcLDAELIAAgBSAMIA5BCGoQ2AsLIghBBEkNACAOKAIIIgRnIAhBAnRqQR9rIApnIAdBAnRqQRtrTA0AIAUhBiAIIQcgBCEKIAUhCyAFIBFJDQEMAgsLIAshBSAKIQQgByEICwJ/IARBBEkEQCAFIQcgCSENIBAMAQsCQCADIAVPBEAgBSEHDAELIAUhByAFQQMgBGsiCmogGE0NAANAIAVBAWsiBy0AACAHIApqIgYtAABHBEAgBSEHDAILIAhBAWohCCADIAdPDQEgByEFIAYgGEsNAAsLIARBA2shDSAJCyEKIAcgA2shCyABKAIMIQUCQAJAIAcgEk0EQCAFIAP9AAAA/QsAACABKAIMIQYgC0EQTQRAIAEgBiALajYCDCABKAIEIQUMAwsgBiAD/QAAEP0LABAgC0EhSA0BIAYgC2ohCSADQRBqIQUgBkEgaiEGA0AgBiAF/QAAEP0LAAAgBiAF/QAAIP0LABAgBUEgaiEFIAZBIGoiBiAJSQ0ACwwBCyADIBJNBEAgBSAD/QAAAP0LAAAgBSASIANrIglqIQYgCUERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSASIQMLIAMgB08NAEEAIQkgByADIgZrQQdxIhAEQANAIAUgBi0AADoAACAFQQFqIQUgBkEBaiEGIAlBAWoiCSAQRw0ACwsgAyAHa0F4Sw0AA0AgBSAGLQAAOgAAIAUgBi0AAToAASAFIAYtAAI6AAIgBSAGLQADOgADIAUgBi0ABDoABCAFIAYtAAU6AAUgBSAGLQAGOgAGIAUgBi0ABzoAByAFQQhqIQUgBkEIaiIGIAdHDQALCyABIAEoAgwgC2o2AgwgASgCBCEFIAtBgIAESQ0AIAFBATYCJCABIAUgASgCAGtBA3U2AigLIAUgBDYCACAFIAs7AQQgCEEDayIGQYCABE8EQCABQQI2AiQgASAFIAEoAgBrQQN1NgIoCyAFIAY7AQYgASAFQQhqIgQ2AgQgACgC3AEEQCAAQQA2AtwBCyAHIAhqIQMgCkUEQCAKIRAgDSEJIAMhBgwCCyAKIRAgDSEJIBEgAyIGSQ0BA0AgCiEJIA0hCiADKAAAIAMgCWsoAABHBEAgCSEQIAohCSADIQYMAwsgA0EEaiIIIAlrIQYCfwJAIAggD08EQCAIIQUMAQsgBigAACIHIAgiBSgAACINRwRAIAcgDXNoQQN2DAILA0AgBkEEaiEGIAVBBGoiBSAPTw0BIAYoAAAiByAFKAAAIg1GDQALIAUgByANc2hBA3ZqIAhrDAELAkAgBSAVTw0AIAYvAAAgBS8AAEcNACAGQQJqIQYgBUECaiEFCyAFIAxJBH8gBSAGLQAAIAUtAABGagUgBQsgCGsLIQUgAyASTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBAsgBEEBNgIAIARBADsBBCAFQQFqIgZBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBjsBBiABIARBCGoiBDYCBCADIAVqQQRqIQMgCkUEQCAKIRAgAyEGDAMLIAkhDSAKIRAgESADIgZPDQALDAELIAAgBiADayIFQf8PSzYC3AEgBiAFQQh2akEBaiEGCyAGIBFJDQALCyACIAkgE0EAIBkbIAkbNgIAIAIgECATIBRBACAbGyIFIAkbIAUgGRsgEBs2AgQgDkEQaiQAIAwgA2sLvA0BF38jAEEQayILJAAgAigCBCERIAIoAgAhCSAAKAK0ASIFKAIAIRIgBSgCBCETIAUoAgwhBSAAQQA2AtwBIAMgAyAAKAIEIg8gACgCDCINaiIWayAFIBNqIhogEmtGaiIFIAMgBGoiCkEIayIUSQRAQQZBBCAAKALIASIEIARBBE0bIgQgBEEGTxshGyAKQSBrIRUgEyATIBJrIA1qIhhrIRkDQCAFQQFqIQhBACEEAkAgBSAJIA9qIhBrQQFqIgYgDWtBfEsNACATIAYgGGtqIAYgD2ogBiANSSIGGyIHKAAAIAgoAABHDQAgBUEFaiAHQQRqIAogEiAKIAYbIBYQ0AtBBGohBAsgC0H/k+vcAzYCDAJAAkACfwJAAkACQCAbQQRrIhdBAWsOAgECAAsgACAFIAogC0EMahDaCwwCCyAAIAUgCiALQQxqENsLDAELIAAgBSAKIAtBDGoQ3AsLIgYgBCAEIAZJIgcbIgRBBE8EQCAFIAggBxshDCALKAIMQQEgBxshBwJAAkAgBSAUTw0AA0ACQCAFQQFqIgYgEGsiCCANa0F8Sw0AIBMgCCAYa2ogCCAPaiAIIA1JIggbIg4oAAAgBigAAEcNACAFQQVqIA5BBGogCiASIAogCBsgFhDQCyIFQXtLDQAgB2cgBEEDbGpBHmsgBUEEaiIFQQNsTg0AQQEhByAGIQwgBSEECyALQf+T69wDNgIIAn8CQAJAAkAgF0EBaw4CAQIACyAAIAYgCiALQQhqENoLDAILIAAgBiAKIAtBCGoQ2wsMAQsgACAGIAogC0EIahDcCwsiCEEESQ0BIAsoAggiDmcgCEECdGpBH2sgB2cgBEECdGpBG2tMDQEgCCEEIA4hByAGIgUhDCAFIBRHDQALDAELIAwhBiAHIQ4gBCEICwJ/IA5BBEkEQCAJIRAgEQwBCyAOQQNrIRACQCADIAZPDQAgGSAPIAYgDiAPamtBA2oiBSANSSIEGyAFaiIFIBogFiAEGyIHTQ0AA0AgBkEBayIELQAAIAVBAWsiBS0AAEcNASAIQQFqIQggAyAESQRAIAQhBiAFIAdLDQELCyAEIQYLIAkLIQcgBiADayEMIAEoAgwhBQJAAkAgBiAVTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSAMQRBNBEAgASAFIAxqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECAMQSFIDQEgBSAMaiEEIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIARJDQALDAELIAMgFU0EQCAFIAP9AAAA/QsAACAFIBUgA2siCWohBCAJQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAESQ0ACwsgBCEFIBUhAwsgAyAGTw0AQQAhCSADIQQgBiADa0EHcSIXBEADQCAFIAQtAAA6AAAgBUEBaiEFIARBAWohBCAJQQFqIgkgF0cNAAsLIAMgBmtBeEsNAANAIAUgBC0AADoAACAFIAQtAAE6AAEgBSAELQACOgACIAUgBC0AAzoAAyAFIAQtAAQ6AAQgBSAELQAFOgAFIAUgBC0ABjoABiAFIAQtAAc6AAcgBUEIaiEFIARBCGoiBCAGRw0ACwsgASABKAIMIAxqNgIMIAEoAgQhAyAMQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIA42AgAgAyAMOwEEIAhBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIENgIEIAYgCGohAyAAKALcAQRAIABBADYC3AELIAchESAQIQkgFCADIgVJDQIDQCAHIQkgECEHIAMgCSAPamsiBSANa0F8Sw0CIBkgDyAFIA1JIgYbIAVqIgUoAAAgAygAAEcNAiADQQRqIAVBBGogCiASIAogBhsgFhDQCyEFIAMgFU0EQCABKAIMIAP9AAAA/QsAACABKAIEIQQLIARBATYCACAEQQA7AQQgBUEBaiIGQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAY7AQYgASAEQQhqIgQ2AgQgCSEQIAchESADIAVqQQRqIgMhBSADIBRNDQALDAILIAAgBSADayIEQf8PSzYC3AEgBSAEQQh2akEBaiEFDAELIAkhESAHIQkgAyEFCyAFIBRJDQALCyACIBE2AgQgAiAJNgIAIAtBEGokACAKIANrC7wNARd/IwBBEGsiCyQAIAIoAgQhESACKAIAIQkgACgCtAEiBSgCACESIAUoAgQhEyAFKAIMIQUgAEEANgLcASADIAMgACgCBCIPIAAoAgwiDWoiFmsgBSATaiIaIBJrRmoiBSADIARqIgpBCGsiFEkEQEEGQQQgACgCyAEiBCAEQQRNGyIEIARBBk8bIRsgCkEgayEVIBMgEyASayANaiIYayEZA0AgBUEBaiEIQQAhBAJAIAUgCSAPaiIQa0EBaiIGIA1rQXxLDQAgEyAGIBhraiAGIA9qIAYgDUkiBhsiBygAACAIKAAARw0AIAVBBWogB0EEaiAKIBIgCiAGGyAWENALQQRqIQQLIAtB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgG0EEayIXQQFrDgIBAgALIAAgBSAKIAtBDGoQ3gsMAgsgACAFIAogC0EMahDfCwwBCyAAIAUgCiALQQxqEOALCyIGIAQgBCAGSSIHGyIEQQRPBEAgBSAIIAcbIQwgCygCDEEBIAcbIQcCQAJAIAUgFE8NAANAAkAgBUEBaiIGIBBrIgggDWtBfEsNACATIAggGGtqIAggD2ogCCANSSIIGyIOKAAAIAYoAABHDQAgBUEFaiAOQQRqIAogEiAKIAgbIBYQ0AsiBUF7Sw0AIAdnIARBA2xqQR5rIAVBBGoiBUEDbE4NAEEBIQcgBiEMIAUhBAsgC0H/k+vcAzYCCAJ/AkACQAJAIBdBAWsOAgECAAsgACAGIAogC0EIahDeCwwCCyAAIAYgCiALQQhqEN8LDAELIAAgBiAKIAtBCGoQ4AsLIghBBEkNASALKAIIIg5nIAhBAnRqQR9rIAdnIARBAnRqQRtrTA0BIAghBCAOIQcgBiIFIQwgBSAURw0ACwwBCyAMIQYgByEOIAQhCAsCfyAOQQRJBEAgCSEQIBEMAQsgDkEDayEQAkAgAyAGTw0AIBkgDyAGIA4gD2prQQNqIgUgDUkiBBsgBWoiBSAaIBYgBBsiB00NAANAIAZBAWsiBC0AACAFQQFrIgUtAABHDQEgCEEBaiEIIAMgBEkEQCAEIQYgBSAHSw0BCwsgBCEGCyAJCyEHIAYgA2shDCABKAIMIQUCQAJAIAYgFU0EQCAFIAP9AAAA/QsAACABKAIMIQUgDEEQTQRAIAEgBSAMajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgDEEhSA0BIAUgDGohBCADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAESQ0ACwwBCyADIBVNBEAgBSAD/QAAAP0LAAAgBSAVIANrIglqIQQgCUERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBEkNAAsLIAQhBSAVIQMLIAMgBk8NAEEAIQkgAyEEIAYgA2tBB3EiFwRAA0AgBSAELQAAOgAAIAVBAWohBSAEQQFqIQQgCUEBaiIJIBdHDQALCyADIAZrQXhLDQADQCAFIAQtAAA6AAAgBSAELQABOgABIAUgBC0AAjoAAiAFIAQtAAM6AAMgBSAELQAEOgAEIAUgBC0ABToABSAFIAQtAAY6AAYgBSAELQAHOgAHIAVBCGohBSAEQQhqIgQgBkcNAAsLIAEgASgCDCAMajYCDCABKAIEIQMgDEGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAONgIAIAMgDDsBBCAIQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiBDYCBCAGIAhqIQMgACgC3AEEQCAAQQA2AtwBCyAHIREgECEJIBQgAyIFSQ0CA0AgByEJIBAhByADIAkgD2prIgUgDWtBfEsNAiAZIA8gBSANSSIGGyAFaiIFKAAAIAMoAABHDQIgA0EEaiAFQQRqIAogEiAKIAYbIBYQ0AshBSADIBVNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEECyAEQQE2AgAgBEEAOwEEIAVBAWoiBkGAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAGOwEGIAEgBEEIaiIENgIEIAkhECAHIREgAyAFakEEaiIDIQUgAyAUTQ0ACwwCCyAAIAUgA2siBEH/D0s2AtwBIAUgBEEIdmpBAWohBQwBCyAJIREgByEJIAMhBQsgBSAUSQ0ACwsgAiARNgIEIAIgCTYCACALQRBqJAAgCiADawu7FwIcfwJ+IwBBEGsiDCQAIAIoAgQhFiACKAIAIRUgAEEANgLcASAVIAMgAyAAKAIEIhMgACgCDCIFaiIcRmoiBiATayINIAUgDUEBIAAoArgBdCIIayAFIA0gBWsgCEsbIAAoAhgbayIFSyEXIAUgFkkhHSAAKALEASIOQQRLIQ9BBkEEIAAoAsgBIgUgBUEETRsiBSAFQQZPGyEYIAAoAhwiBSAFQQggAyAEaiIKQQ9rIh8gBSATaiINayIEIARBCE8bQQAgDSAKQRBrIhFNG2oiBEkEQCAAQSxqIQhBGCAAKAIkIg1rIQlBOCANa60hISAAKQNQIiKnIQcgGEEFayELA0AgBSATaiENIAggBUEHcUECdGoCfwJAAkACQCALDgIBAgALIA0oAABBsfPd8XlsIAdzIAl2DAILIA0pAABCgICA2Mub741PfiAihSAhiKcMAQsgDSkAAEKAgOz8y5vvjU9+ICKFICGIpws2AgAgBUEBaiIFIARHDQALC0EAIBUgFxshCEEAIBYgHRshECAGIBFJBEBBBiAOQQQgDxsiBSAFQQZPGyESIABBLGohICAKQSBrIRQgCkEBayEZIApBA2shDSAYQQRrIR4DQEEAIAhrIQ8gBkEBaiELAn9BACAIRQ0AGkEAIAsgCGsoAAAgBigAAUcNABogBkEFaiIJIA9qIQQCfwJAIAkgDU8EQCAJIQUMAQsgBCgAACIHIAkiBSgAACIORwRAIAcgDnNoQQN2DAILA0AgBEEEaiEEIAVBBGoiBSANTw0BIAQoAAAiByAFKAAAIg5GDQALIAUgByAOc2hBA3ZqIAlrDAELAkAgBSAZTw0AIAQvAAAgBS8AAEcNACAEQQJqIQQgBUECaiEFCyAFIApJBH8gBSAELQAAIAUtAABGagUgBQsgCWsLQQRqCyEFIAxB/5Pr3AM2AgwCQAJ/AkACQAJAIB5BAWsOAgECAAsCQAJAAkAgEkEFaw4CAQIACyAAIAYgCiAMQQxqEOILDAQLIAAgBiAKIAxBDGoQ4wsMAwsgACAGIAogDEEMahDkCwwCCwJAAkACQCASQQVrDgIBAgALIAAgBiAKIAxBDGoQ5QsMAwsgACAGIAogDEEMahDmCwwCCyAAIAYgCiAMQQxqEOcLDAELAkACQAJAIBJBBWsOAgECAAsgACAGIAogDEEMahDoCwwCCyAAIAYgCiAMQQxqEOkLDAELIAAgBiAKIAxBDGoQ6gsLIgQgBSAEIAVLIgkbIgdBBE8EQCAGIAsgCRsiDiEFIAwoAgxBASAJGyILIQQgByEJAkAgBiARTw0AA0AgBkEBaiEFAkAgC0UEQEEAIQsMAQsgCEUNACAFKAAAIAUgD2ooAABHDQAgBkEFaiIJIA9qIQQgC2cgB0EDbGpBHmsCfwJAAkAgCSANTwRAIAkhBgwBCyAEKAAAIhogCSIGKAAAIhtHBEAgGiAbc2hBA3ZBBHIMAwsDQCAEQQRqIQQgBkEEaiIGIA1PDQEgBCgAACIaIAYoAAAiG0YNAAsgBiAaIBtzaEEDdmohBgwBCwJAIAYgGU8NACAELwAAIAYvAABHDQAgBEECaiEEIAZBAmohBgsgBiAKTw0AIAYgBC0AACAGLQAARmohBgsgBiAJayIGQXtLDQEgBkEEagsiBkEDbE4NAEEBIQsgBSEOIAYhBwsgDEH/k+vcAzYCCAJAAn8CQAJAAkAgHkEBaw4CAQIACwJAAkACQCASQQVrDgIBAgALIAAgBSAKIAxBCGoQ4gsMBAsgACAFIAogDEEIahDjCwwDCyAAIAUgCiAMQQhqEOQLDAILAkACQAJAIBJBBWsOAgECAAsgACAFIAogDEEIahDlCwwDCyAAIAUgCiAMQQhqEOYLDAILIAAgBSAKIAxBCGoQ5wsMAQsCQAJAAkAgEkEFaw4CAQIACyAAIAUgCiAMQQhqEOgLDAILIAAgBSAKIAxBCGoQ6QsMAQsgACAFIAogDEEIahDqCwsiCUEESQ0AIAwoAggiBGcgCUECdGpBH2sgC2cgB0ECdGpBG2tMDQAgBSEGIAkhByAEIQsgBSEOIAUgEUkNAQwCCwsgDiEFIAshBCAHIQkLAn8gBEEESQRAIAUhByAIIQ8gEAwBCwJAIAMgBU8EQCAFIQcMAQsgBSEHIAVBAyAEayILaiAcTQ0AA0AgBUEBayIHLQAAIAcgC2oiBi0AAEcEQCAFIQcMAgsgCUEBaiEJIAMgB08NASAHIQUgBiAcSw0ACwsgBEEDayEPIAgLIQsgByADayEOIAEoAgwhBQJAAkAgByAUTQRAIAUgA/0AAAD9CwAAIAEoAgwhBiAOQRBNBEAgASAGIA5qNgIMIAEoAgQhBQwDCyAGIAP9AAAQ/QsAECAOQSFIDQEgBiAOaiEIIANBEGohBSAGQSBqIQYDQCAGIAX9AAAQ/QsAACAGIAX9AAAg/QsAECAFQSBqIQUgBkEgaiIGIAhJDQALDAELIAMgFE0EQCAFIAP9AAAA/QsAACAFIBQgA2siCGohBiAIQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBQhAwsgAyAHTw0AQQAhCCAHIAMiBmtBB3EiEARAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgCEEBaiIIIBBHDQALCyADIAdrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgB0cNAAsLIAEgASgCDCAOajYCDCABKAIEIQUgDkGAgARJDQAgAUEBNgIkIAEgBSABKAIAa0EDdTYCKAsgBSAENgIAIAUgDjsBBCAJQQNrIgZBgIAETwRAIAFBAjYCJCABIAUgASgCAGtBA3U2AigLIAUgBjsBBiABIAVBCGoiBDYCBCAAKALcAQRAIAAoAhwiBSAFQQggHyAFIBNqIgZrIgMgA0EITxtBACAGIBFNG2oiA0kEQEEYIAAoAiQiBmshCEE4IAZrrSEhIAApA1AiIqchEANAIAUgE2ohBiAgIAVBB3FBAnRqAn8CQAJAAkAgGEEFaw4CAQIACyAGKAAAQbHz3fF5bCAQcyAIdgwCCyAGKQAAQoCAgNjLm++NT34gIoUgIYinDAELIAYpAABCgIDs/Mub741PfiAihSAhiKcLNgIAIAVBAWoiBSADRw0ACwsgAEEANgLcAQsgByAJaiEDIAtFBEAgCyEQIA8hCCADIQYMAgsgCyEQIA8hCCARIAMiBkkNAQNAIAshCCAPIQsgAygAACADIAhrKAAARwRAIAghECALIQggAyEGDAMLIANBBGoiCSAIayEGAn8CQCAJIA1PBEAgCSEFDAELIAYoAAAiByAJIgUoAAAiD0cEQCAHIA9zaEEDdgwCCwNAIAZBBGohBiAFQQRqIgUgDU8NASAGKAAAIgcgBSgAACIPRg0ACyAFIAcgD3NoQQN2aiAJawwBCwJAIAUgGU8NACAGLwAAIAUvAABHDQAgBkECaiEGIAVBAmohBQsgBSAKSQR/IAUgBi0AACAFLQAARmoFIAULIAlrCyEFIAMgFE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQQLIARBATYCACAEQQA7AQQgBUEBaiIGQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAY7AQYgASAEQQhqIgQ2AgQgAyAFakEEaiEDIAtFBEAgCyEQIAMhBgwDCyAIIQ8gCyEQIBEgAyIGTw0ACwwBCyAAIAYgA2siBUH/D0s2AtwBIAYgBUEIdmpBAWohBgsgBiARSQ0ACwsgAiAIIBVBACAXGyAIGzYCACACIBAgFSAWQQAgHRsiBSAIGyAFIBcbIBAbNgIEIAxBEGokACAKIANrC7sTAhp/An4jAEEQayIJJAAgAigCBCETIAIoAgAhCyAAKAK0ASIFKAIAIRQgBSgCBCEVIAUoAgwhBSAAQQA2AtwBIAAoAsQBIgxBBEshD0EGQQQgACgCyAEiBiAGQQRNGyIGIAZBBk8bIRggAyADIAAoAgQiDiAAKAIMIhBqIhdrIAUgFWoiHSAUa0ZqIQUgACgCHCIGIAZBCCADIARqIgdBD2siHiAGIA5qIgRrIgggCEEITxtBACAEIAdBEGsiEk0baiIISQRAIABBLGohCkEYIAAoAiQiBGshEUE4IARrrSEfIAApA1AiIKchGSAYQQVrIQ0DQCAGIA5qIQQgCiAGQQdxQQJ0agJ/AkACQAJAIA0OAgECAAsgBCgAAEGx893xeWwgGXMgEXYMAgsgBCkAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAEKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAGQQFqIgYgCEcNAAsLIAUgEkkEQEEGIAxBBCAPGyIGIAZBBk8bIQ8gAEEsaiEZIAdBIGshFiAVIBUgFGsgEGoiG2shHANAIAVBAWohCAJ/QQAgBSALIA5qIhFrQQFqIgQgEGtBfEsNABpBACAVIAQgG2tqIAQgDmogBCAQSSIEGyIKKAAAIAgoAABHDQAaIAVBBWogCkEEaiAHIBQgByAEGyAXENALQQRqCyEGIAlB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgGEEEayIaQQFrDgIBAgALAkACQAJAIA9BBWsOAgECAAsgACAFIAcgCUEMahDsCwwECyAAIAUgByAJQQxqEO0LDAMLIAAgBSAHIAlBDGoQ7gsMAgsCQAJAAkAgD0EFaw4CAQIACyAAIAUgByAJQQxqEO8LDAMLIAAgBSAHIAlBDGoQ8AsMAgsgACAFIAcgCUEMahDxCwwBCwJAAkACQCAPQQVrDgIBAgALIAAgBSAHIAlBDGoQ8gsMAgsgACAFIAcgCUEMahDzCwwBCyAAIAUgByAJQQxqEPQLCyIEIAYgBCAGSyIKGyIGQQRPBEAgBSAIIAobIQwgCSgCDEEBIAobIQoCQAJAIAUgEk8NAANAAkAgBUEBaiIEIBFrIgggEGtBfEsNACAVIAggG2tqIAggDmogCCAQSSIIGyINKAAAIAQoAABHDQAgBUEFaiANQQRqIAcgFCAHIAgbIBcQ0AsiBUF7Sw0AIApnIAZBA2xqQR5rIAVBBGoiBUEDbE4NAEEBIQogBCEMIAUhBgsgCUH/k+vcAzYCCAJ/AkACQAJAIBpBAWsOAgECAAsCQAJAAkAgD0EFaw4CAQIACyAAIAQgByAJQQhqEOwLDAQLIAAgBCAHIAlBCGoQ7QsMAwsgACAEIAcgCUEIahDuCwwCCwJAAkACQCAPQQVrDgIBAgALIAAgBCAHIAlBCGoQ7wsMAwsgACAEIAcgCUEIahDwCwwCCyAAIAQgByAJQQhqEPELDAELAkACQAJAIA9BBWsOAgECAAsgACAEIAcgCUEIahDyCwwCCyAAIAQgByAJQQhqEPMLDAELIAAgBCAHIAlBCGoQ9AsLIghBBEkNASAJKAIIIg1nIAhBAnRqQR9rIApnIAZBAnRqQRtrTA0BIAghBiANIQogBCIFIQwgBSASRw0ACwwBCyAMIQQgCiENIAYhCAsCfyANQQRJBEAgCyERIBMMAQsgDUEDayERAkAgAyAETw0AIBwgDiAEIA0gDmprQQNqIgUgEEkiBhsgBWoiBSAdIBcgBhsiCk0NAANAIARBAWsiBi0AACAFQQFrIgUtAABHDQEgCEEBaiEIIAMgBkkEQCAGIQQgBSAKSw0BCwsgBiEECyALCyEKIAQgA2shDCABKAIMIQUCQAJAIAQgFk0EQCAFIAP9AAAA/QsAACABKAIMIQUgDEEQTQRAIAEgBSAMajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgDEEhSA0BIAUgDGohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBZNBEAgBSAD/QAAAP0LAAAgBSAWIANrIgtqIQYgC0ERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSAWIQMLIAMgBE8NAEEAIQsgAyEGIAQgA2tBB3EiGgRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgC0EBaiILIBpHDQALCyADIARrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgBEcNAAsLIAEgASgCDCAMajYCDCABKAIEIQMgDEGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyANNgIAIAMgDDsBBCAIQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiBjYCBCAEIAhqIQMgACgC3AEEQCAAKAIcIgUgBUEIIB4gBSAOaiIEayIIIAhBCE8bQQAgBCASTRtqIghJBEBBGCAAKAIkIgRrIQtBOCAEa60hHyAAKQNQIiCnIQ0DQCAFIA5qIQQgGSAFQQdxQQJ0agJ/AkACQAJAIBhBBWsOAgECAAsgBCgAAEGx893xeWwgDXMgC3YMAgsgBCkAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAEKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAFQQFqIgUgCEcNAAsLIABBADYC3AELIAohEyARIQsgEiADIgVJDQIDQCAKIQsgESEKIAMgCyAOamsiBSAQa0F8Sw0CIBwgDiAFIBBJIgQbIAVqIgUoAAAgAygAAEcNAiADQQRqIAVBBGogByAUIAcgBBsgFxDQCyEFIAMgFk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQYLIAZBATYCACAGQQA7AQQgBUEBaiIEQYCABE8EQCABQQI2AiQgASAGIAEoAgBrQQN1NgIoCyAGIAQ7AQYgASAGQQhqIgY2AgQgCyERIAohEyADIAVqQQRqIgMhBSADIBJNDQALDAILIAAgBSADayIGQf8PSzYC3AEgBSAGQQh2akEBaiEFDAELIAshEyAKIQsgAyEFCyAFIBJJDQALCyACIBM2AgQgAiALNgIAIAlBEGokACAHIANrC7sTAhp/An4jAEEQayIJJAAgAigCBCETIAIoAgAhCyAAKAK0ASIFKAIAIRQgBSgCBCEVIAUoAgwhBSAAQQA2AtwBIAAoAsQBIgxBBEshD0EGQQQgACgCyAEiBiAGQQRNGyIGIAZBBk8bIRggAyADIAAoAgQiDiAAKAIMIhBqIhdrIAUgFWoiHSAUa0ZqIQUgACgCHCIGIAZBCCADIARqIgdBD2siHiAGIA5qIgRrIgggCEEITxtBACAEIAdBEGsiEk0baiIISQRAIABBLGohCkEYIAAoAiQiBGshEUE4IARrrSEfIAApA1AiIKchGSAYQQVrIQ0DQCAGIA5qIQQgCiAGQQdxQQJ0agJ/AkACQAJAIA0OAgECAAsgBCgAAEGx893xeWwgGXMgEXYMAgsgBCkAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAEKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAGQQFqIgYgCEcNAAsLIAUgEkkEQEEGIAxBBCAPGyIGIAZBBk8bIQ8gAEEsaiEZIAdBIGshFiAVIBUgFGsgEGoiG2shHANAIAVBAWohCAJ/QQAgBSALIA5qIhFrQQFqIgQgEGtBfEsNABpBACAVIAQgG2tqIAQgDmogBCAQSSIEGyIKKAAAIAgoAABHDQAaIAVBBWogCkEEaiAHIBQgByAEGyAXENALQQRqCyEGIAlB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgGEEEayIaQQFrDgIBAgALAkACQAJAIA9BBWsOAgECAAsgACAFIAcgCUEMahD2CwwECyAAIAUgByAJQQxqEPcLDAMLIAAgBSAHIAlBDGoQ+AsMAgsCQAJAAkAgD0EFaw4CAQIACyAAIAUgByAJQQxqEPkLDAMLIAAgBSAHIAlBDGoQ+gsMAgsgACAFIAcgCUEMahD7CwwBCwJAAkACQCAPQQVrDgIBAgALIAAgBSAHIAlBDGoQ/AsMAgsgACAFIAcgCUEMahD9CwwBCyAAIAUgByAJQQxqEP4LCyIEIAYgBCAGSyIKGyIGQQRPBEAgBSAIIAobIQwgCSgCDEEBIAobIQoCQAJAIAUgEk8NAANAAkAgBUEBaiIEIBFrIgggEGtBfEsNACAVIAggG2tqIAggDmogCCAQSSIIGyINKAAAIAQoAABHDQAgBUEFaiANQQRqIAcgFCAHIAgbIBcQ0AsiBUF7Sw0AIApnIAZBA2xqQR5rIAVBBGoiBUEDbE4NAEEBIQogBCEMIAUhBgsgCUH/k+vcAzYCCAJ/AkACQAJAIBpBAWsOAgECAAsCQAJAAkAgD0EFaw4CAQIACyAAIAQgByAJQQhqEPYLDAQLIAAgBCAHIAlBCGoQ9wsMAwsgACAEIAcgCUEIahD4CwwCCwJAAkACQCAPQQVrDgIBAgALIAAgBCAHIAlBCGoQ+QsMAwsgACAEIAcgCUEIahD6CwwCCyAAIAQgByAJQQhqEPsLDAELAkACQAJAIA9BBWsOAgECAAsgACAEIAcgCUEIahD8CwwCCyAAIAQgByAJQQhqEP0LDAELIAAgBCAHIAlBCGoQ/gsLIghBBEkNASAJKAIIIg1nIAhBAnRqQR9rIApnIAZBAnRqQRtrTA0BIAghBiANIQogBCIFIQwgBSASRw0ACwwBCyAMIQQgCiENIAYhCAsCfyANQQRJBEAgCyERIBMMAQsgDUEDayERAkAgAyAETw0AIBwgDiAEIA0gDmprQQNqIgUgEEkiBhsgBWoiBSAdIBcgBhsiCk0NAANAIARBAWsiBi0AACAFQQFrIgUtAABHDQEgCEEBaiEIIAMgBkkEQCAGIQQgBSAKSw0BCwsgBiEECyALCyEKIAQgA2shDCABKAIMIQUCQAJAIAQgFk0EQCAFIAP9AAAA/QsAACABKAIMIQUgDEEQTQRAIAEgBSAMajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgDEEhSA0BIAUgDGohBiADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwwBCyADIBZNBEAgBSAD/QAAAP0LAAAgBSAWIANrIgtqIQYgC0ERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBkkNAAsLIAYhBSAWIQMLIAMgBE8NAEEAIQsgAyEGIAQgA2tBB3EiGgRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgC0EBaiILIBpHDQALCyADIARrQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgBEcNAAsLIAEgASgCDCAMajYCDCABKAIEIQMgDEGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyANNgIAIAMgDDsBBCAIQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiBjYCBCAEIAhqIQMgACgC3AEEQCAAKAIcIgUgBUEIIB4gBSAOaiIEayIIIAhBCE8bQQAgBCASTRtqIghJBEBBGCAAKAIkIgRrIQtBOCAEa60hHyAAKQNQIiCnIQ0DQCAFIA5qIQQgGSAFQQdxQQJ0agJ/AkACQAJAIBhBBWsOAgECAAsgBCgAAEGx893xeWwgDXMgC3YMAgsgBCkAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAEKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAFQQFqIgUgCEcNAAsLIABBADYC3AELIAohEyARIQsgEiADIgVJDQIDQCAKIQsgESEKIAMgCyAOamsiBSAQa0F8Sw0CIBwgDiAFIBBJIgQbIAVqIgUoAAAgAygAAEcNAiADQQRqIAVBBGogByAUIAcgBBsgFxDQCyEFIAMgFk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQYLIAZBATYCACAGQQA7AQQgBUEBaiIEQYCABE8EQCABQQI2AiQgASAGIAEoAgBrQQN1NgIoCyAGIAQ7AQYgASAGQQhqIgY2AgQgCyERIAohEyADIAVqQQRqIgMhBSADIBJNDQALDAILIAAgBSADayIGQf8PSzYC3AEgBSAGQQh2akEBaiEFDAELIAshEyAKIQsgAyEFCyAFIBJJDQALCyACIBM2AgQgAiALNgIAIAlBEGokACAHIANrC74UARh/IwBBEGsiDSQAIAIoAgQhFyACKAIAIRUgAEEANgLcAUEAIBUgFSADIAMgACgCBCIOIAAoAgwiBWoiGkZqIgYgDmsiDiAFIA5BASAAKAK4AXQiCWsgBSAOIAVrIAlLGyAAKAIYG2siBUsiGxshCUEAIBcgBSAXSSIcGyEQIAMgBGoiDEEIayITIAZLBEAgDEEgayEUIAxBAWshFiAMQQNrIQ5BBkEEIAAoAsgBIgUgBUEETRsiBSAFQQZPG0EEayEYA0BBACEFQQAgCWshDyAGQQFqIQgCQCAJRQ0AIAggCWsoAAAgBigAAUcNACAGQQVqIgogD2ohBAJ/AkAgCiAOTwRAIAohBQwBCyAEKAAAIgcgCiIFKAAAIgtHBEAgByALc2hBA3YMAgsDQCAEQQRqIQQgBUEEaiIFIA5PDQEgBCgAACIHIAUoAAAiC0YNAAsgBSAHIAtzaEEDdmogCmsMAQsCQCAFIBZPDQAgBC8AACAFLwAARw0AIARBAmohBCAFQQJqIQULIAUgDEkEfyAFIAQtAAAgBS0AAEZqBSAFCyAKawtBBGohBQsgDUH/k+vcAzYCDAJAAn8CQAJAAkAgGEEBaw4CAQIACyAAIAYgDCANQQxqENYLDAILIAAgBiAMIA1BDGoQ1wsMAQsgACAGIAwgDUEMahDYCwsiBCAFIAQgBUsiBxsiCkEETwRAIAYgCCAHGyELIA0oAgxBASAHGyEEAkAgBiATTw0AA0AgBkEBaiEHAkAgBEUEQEEAIQQMAQsgCUUNACAHKAAAIAcgD2ooAABHDQAgBkEFaiIRIA9qIQggBGcgCkEDbGpBHmsCfwJAAkAgDiARTQRAIBEhBQwBCyAIKAAAIhIgESIFKAAAIhlHBEAgEiAZc2hBA3ZBBHIMAwsDQCAIQQRqIQggBUEEaiIFIA5PDQEgCCgAACISIAUoAAAiGUYNAAsgBSASIBlzaEEDdmohBQwBCwJAIAUgFk8NACAILwAAIAUvAABHDQAgCEECaiEIIAVBAmohBQsgBSAMTw0AIAUgCC0AACAFLQAARmohBQsgBSARayIFQXtLDQEgBUEEagsiBUEDbE4NAEEBIQQgByELIAUhCgsgDUH/k+vcAzYCCAJ/AkACfwJAAkACQCAYQQFrDgIBAgALIAAgByAMIA1BCGoQ1gsMAgsgACAHIAwgDUEIahDXCwwBCyAAIAcgDCANQQhqENgLCyIFQQRJDQAgDSgCCCIIZyAFQQJ0akEfayAEZyAKQQJ0akEba0wNACAHIQYgBSEKIAgMAQsgByATTw0CIAZBAmohCAJAIARFBEBBACEEDAELIAlFDQAgCCgAACAIIA9qKAAARw0AIAZBBmoiByAPaiEFIARnIApBAnRqQR5rAn8CQAJAIAcgDk8EQCAHIQYMAQsgBSgAACIRIAciBigAACISRwRAIBEgEnNoQQN2QQRyDAMLA0AgBUEEaiEFIAZBBGoiBiAOTw0BIAUoAAAiESAGKAAAIhJGDQALIAYgESASc2hBA3ZqIQYMAQsCQCAGIBZPDQAgBS8AACAGLwAARw0AIAVBAmohBSAGQQJqIQYLIAYgDE8NACAGIAUtAAAgBi0AAEZqIQYLIAYgB2siBkF7Sw0BIAZBBGoLIgZBAnRODQBBASEEIAghCyAGIQoLIA1B/5Pr3AM2AgQCfwJAAkACQCAYQQFrDgIBAgALIAAgCCAMIA1BBGoQ1gsMAgsgACAIIAwgDUEEahDXCwwBCyAAIAggDCANQQRqENgLCyIFQQRJDQIgDSgCBCIHZyAFQQJ0akEfayAEZyAKQQJ0akEYa0wNAiAIIQYgBSEKIAcLIQQgBiELIAYgE0kNAAsLAn8gBEEESQRAIAshByAQIQggCQwBCwJAIAMgC08EQCALIQcMAQtBAyAEayIFIAsiB2ogGk0NAANAIAtBAWsiBy0AACAFIAdqIgYtAABHBEAgCyEHDAILIApBAWohCiADIAdPDQEgByELIAYgGksNAAsLIAkhCCAEQQNrCyELIAcgA2shDyABKAIMIQYCQAJAIAcgFE0EQCAGIAP9AAAA/QsAACABKAIMIQUgD0EQTQRAIAEgBSAPajYCDCABKAIEIQYMAwsgBSAD/QAAEP0LABAgD0EhSA0BIAUgD2ohCSADQRBqIQYgBUEgaiEFA0AgBSAG/QAAEP0LAAAgBSAG/QAAIP0LABAgBkEgaiEGIAVBIGoiBSAJSQ0ACwwBCyADIBRNBEAgBiAD/QAAAP0LAAAgBiAUIANrIglqIQUgCUERTgRAIAZBEGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgBUkNAAsLIAUhBiAUIQMLIAMgB08NAEEAIQkgByADIgVrQQdxIhAEQANAIAYgBS0AADoAACAGQQFqIQYgBUEBaiEFIAlBAWoiCSAQRw0ACwsgAyAHa0F4Sw0AA0AgBiAFLQAAOgAAIAYgBS0AAToAASAGIAUtAAI6AAIgBiAFLQADOgADIAYgBS0ABDoABCAGIAUtAAU6AAUgBiAFLQAGOgAGIAYgBS0ABzoAByAGQQhqIQYgBUEIaiIFIAdHDQALCyABIAEoAgwgD2o2AgwgASgCBCEGIA9BgIAESQ0AIAFBATYCJCABIAYgASgCAGtBA3U2AigLIAYgBDYCACAGIA87AQQgCkEDayIFQYCABE8EQCABQQI2AiQgASAGIAEoAgBrQQN1NgIoCyAGIAU7AQYgASAGQQhqIgQ2AgQgACgC3AEEQCAAQQA2AtwBCyAHIApqIQMgCEUEQCAIIRAgCyEJIAMhBgwCCyAIIRAgCyEJIBMgAyIGSQ0BA0AgCCEJIAshCCADKAAAIAMgCWsoAABHBEAgCSEQIAghCSADIQYMAwsgA0EEaiIKIAlrIQUCfwJAIAogDk8EQCAKIQYMAQsgBSgAACIHIAoiBigAACILRwRAIAcgC3NoQQN2DAILA0AgBUEEaiEFIAZBBGoiBiAOTw0BIAUoAAAiByAGKAAAIgtGDQALIAYgByALc2hBA3ZqIAprDAELAkAgBiAWTw0AIAUvAAAgBi8AAEcNACAFQQJqIQUgBkECaiEGCyAGIAxJBH8gBiAFLQAAIAYtAABGagUgBgsgCmsLIQYgAyAUTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBAsgBEEBNgIAIARBADsBBCAGQQFqIgVBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBTsBBiABIARBCGoiBDYCBCADIAZqQQRqIQMgCEUEQCAIIRAgAyEGDAMLIAkhCyAIIRAgEyADIgZPDQALDAELIAAgBiADayIFQf8PSzYC3AEgBiAFQQh2akEBaiEGCyAGIBNJDQALCyACIAkgFUEAIBsbIAkbNgIAIAIgECAVIBdBACAcGyIGIAkbIAYgGxsgEBs2AgQgDUEQaiQAIAwgA2sLtQ8BF38jAEEQayIKJAAgAigCBCEMIAIoAgAhCyAAKAK0ASIFKAIAIRIgBSgCBCETIAUoAgwhBSAAQQA2AtwBIAMgAyAAKAIEIg8gACgCDCIOaiIVayAFIBNqIhogEmtGaiIFIAMgBGoiCEEIayIUSQRAQQZBBCAAKALIASIEIARBBE0bIgQgBEEGTxshGyAIQSBrIRYgEyATIBJrIA5qIhhrIRkDQCAFQQFqIQlBACEEAkAgBSALIA9qIhBrQQFqIgcgDmtBfEsNACATIAcgGGtqIAcgD2ogByAOSSIHGyIGKAAAIAkoAABHDQAgBUEFaiAGQQRqIAggEiAIIAcbIBUQ0AtBBGohBAsgCkH/k+vcAzYCDAJAAkACfwJAAkACQCAbQQRrIhdBAWsOAgECAAsgACAFIAggCkEMahDaCwwCCyAAIAUgCCAKQQxqENsLDAELIAAgBSAIIApBDGoQ3AsLIgcgBCAEIAdJIgYbIgdBBE8EQCAFIAkgBhshCSAKKAIMQQEgBhshDQJAIAUgFE8NAANAAkAgBUEBaiIEIBBrIgYgDmtBfEsNACATIAYgGGtqIAYgD2ogBiAOSSIGGyIRKAAAIAQoAABHDQAgBUEFaiARQQRqIAggEiAIIAYbIBUQ0AsiBkF7Sw0AIA1nIAdBA2xqQR5rIAZBBGoiBkEDbE4NAEEBIQ0gBCEJIAYhBwsgCkH/k+vcAzYCCAJ/AkACfwJAAkACQCAXQQFrDgIBAgALIAAgBCAIIApBCGoQ2gsMAgsgACAEIAggCkEIahDbCwwBCyAAIAQgCCAKQQhqENwLCyIGQQRJDQAgCigCCCIRZyAGQQJ0akEfayANZyAHQQJ0akEba0wNACARIQ0gBiEHIAQMAQsgBCAUTw0CAkAgBUECaiIGIBBrIgQgDmtBfEsNACATIAQgGGtqIAQgD2ogBCAOSSIEGyIRKAAAIAYoAABHDQAgBUEGaiARQQRqIAggEiAIIAQbIBUQ0AsiBUF7Sw0AIA1nIAdBAnRqQR5rIAVBBGoiBUECdE4NAEEBIQ0gBiEJIAUhBwsgCkH/k+vcAzYCBAJ/AkACQAJAIBdBAWsOAgECAAsgACAGIAggCkEEahDaCwwCCyAAIAYgCCAKQQRqENsLDAELIAAgBiAIIApBBGoQ3AsLIgRBBEkNAiAKKAIEIhFnIARBAnRqQR9rIA1nIAdBAnRqQRhrTA0CIBEhDSAEIQcgBgsiBSEJIAUgFEkNAAsLAn8gDUEESQRAIAshECAMDAELIA1BA2shEAJAIAMgCU8NACAZIA8gCSANIA9qa0EDaiIFIA5JIgQbIAVqIgUgGiAVIAQbIgZNDQADQCAJQQFrIgQtAAAgBUEBayIFLQAARw0BIAdBAWohByADIARJBEAgBCEJIAUgBksNAQsLIAQhCQsgCwshBiAJIANrIQwgASgCDCEFAkACQCAJIBZNBEAgBSAD/QAAAP0LAAAgASgCDCEFIAxBEE0EQCABIAUgDGo2AgwgASgCBCEDDAMLIAUgA/0AABD9CwAQIAxBIUgNASAFIAxqIQQgA0EQaiEDIAVBIGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBEkNAAsMAQsgAyAWTQRAIAUgA/0AAAD9CwAAIAUgFiADayILaiEEIAtBEU4EQCAFQRBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIARJDQALCyAEIQUgFiEDCyADIAlPDQBBACELIAkgAyIEa0EHcSIXBEADQCAFIAQtAAA6AAAgBUEBaiEFIARBAWohBCALQQFqIgsgF0cNAAsLIAMgCWtBeEsNAANAIAUgBC0AADoAACAFIAQtAAE6AAEgBSAELQACOgACIAUgBC0AAzoAAyAFIAQtAAQ6AAQgBSAELQAFOgAFIAUgBC0ABjoABiAFIAQtAAc6AAcgBUEIaiEFIARBCGoiBCAJRw0ACwsgASABKAIMIAxqNgIMIAEoAgQhAyAMQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIA02AgAgAyAMOwEEIAdBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIENgIEIAcgCWohAyAAKALcAQRAIABBADYC3AELIAYhDCAQIQsgFCADIgVJDQIDQCAGIQsgECEGIAMgCyAPamsiBSAOa0F8Sw0CIBkgDyAFIA5JIgcbIAVqIgUoAAAgAygAAEcNAiADQQRqIAVBBGogCCASIAggBxsgFRDQCyEFIAMgFk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQQLIARBATYCACAEQQA7AQQgBUEBaiIHQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAc7AQYgASAEQQhqIgQ2AgQgCyEQIAYhDCADIAVqQQRqIgMhBSADIBRNDQALDAILIAAgBSADayIEQf8PSzYC3AEgBSAEQQh2akEBaiEFDAELIAshDCAGIQsgAyEFCyAFIBRJDQALCyACIAw2AgQgAiALNgIAIApBEGokACAIIANrC7UPARd/IwBBEGsiCiQAIAIoAgQhDCACKAIAIQsgACgCtAEiBSgCACESIAUoAgQhEyAFKAIMIQUgAEEANgLcASADIAMgACgCBCIPIAAoAgwiDmoiFWsgBSATaiIaIBJrRmoiBSADIARqIghBCGsiFEkEQEEGQQQgACgCyAEiBCAEQQRNGyIEIARBBk8bIRsgCEEgayEWIBMgEyASayAOaiIYayEZA0AgBUEBaiEJQQAhBAJAIAUgCyAPaiIQa0EBaiIHIA5rQXxLDQAgEyAHIBhraiAHIA9qIAcgDkkiBxsiBigAACAJKAAARw0AIAVBBWogBkEEaiAIIBIgCCAHGyAVENALQQRqIQQLIApB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgG0EEayIXQQFrDgIBAgALIAAgBSAIIApBDGoQ3gsMAgsgACAFIAggCkEMahDfCwwBCyAAIAUgCCAKQQxqEOALCyIHIAQgBCAHSSIGGyIHQQRPBEAgBSAJIAYbIQkgCigCDEEBIAYbIQ0CQCAFIBRPDQADQAJAIAVBAWoiBCAQayIGIA5rQXxLDQAgEyAGIBhraiAGIA9qIAYgDkkiBhsiESgAACAEKAAARw0AIAVBBWogEUEEaiAIIBIgCCAGGyAVENALIgZBe0sNACANZyAHQQNsakEeayAGQQRqIgZBA2xODQBBASENIAQhCSAGIQcLIApB/5Pr3AM2AggCfwJAAn8CQAJAAkAgF0EBaw4CAQIACyAAIAQgCCAKQQhqEN4LDAILIAAgBCAIIApBCGoQ3wsMAQsgACAEIAggCkEIahDgCwsiBkEESQ0AIAooAggiEWcgBkECdGpBH2sgDWcgB0ECdGpBG2tMDQAgESENIAYhByAEDAELIAQgFE8NAgJAIAVBAmoiBiAQayIEIA5rQXxLDQAgEyAEIBhraiAEIA9qIAQgDkkiBBsiESgAACAGKAAARw0AIAVBBmogEUEEaiAIIBIgCCAEGyAVENALIgVBe0sNACANZyAHQQJ0akEeayAFQQRqIgVBAnRODQBBASENIAYhCSAFIQcLIApB/5Pr3AM2AgQCfwJAAkACQCAXQQFrDgIBAgALIAAgBiAIIApBBGoQ3gsMAgsgACAGIAggCkEEahDfCwwBCyAAIAYgCCAKQQRqEOALCyIEQQRJDQIgCigCBCIRZyAEQQJ0akEfayANZyAHQQJ0akEYa0wNAiARIQ0gBCEHIAYLIgUhCSAFIBRJDQALCwJ/IA1BBEkEQCALIRAgDAwBCyANQQNrIRACQCADIAlPDQAgGSAPIAkgDSAPamtBA2oiBSAOSSIEGyAFaiIFIBogFSAEGyIGTQ0AA0AgCUEBayIELQAAIAVBAWsiBS0AAEcNASAHQQFqIQcgAyAESQRAIAQhCSAFIAZLDQELCyAEIQkLIAsLIQYgCSADayEMIAEoAgwhBQJAAkAgCSAWTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSAMQRBNBEAgASAFIAxqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECAMQSFIDQEgBSAMaiEEIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIARJDQALDAELIAMgFk0EQCAFIAP9AAAA/QsAACAFIBYgA2siC2ohBCALQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAESQ0ACwsgBCEFIBYhAwsgAyAJTw0AQQAhCyAJIAMiBGtBB3EiFwRAA0AgBSAELQAAOgAAIAVBAWohBSAEQQFqIQQgC0EBaiILIBdHDQALCyADIAlrQXhLDQADQCAFIAQtAAA6AAAgBSAELQABOgABIAUgBC0AAjoAAiAFIAQtAAM6AAMgBSAELQAEOgAEIAUgBC0ABToABSAFIAQtAAY6AAYgBSAELQAHOgAHIAVBCGohBSAEQQhqIgQgCUcNAAsLIAEgASgCDCAMajYCDCABKAIEIQMgDEGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyANNgIAIAMgDDsBBCAHQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiBDYCBCAHIAlqIQMgACgC3AEEQCAAQQA2AtwBCyAGIQwgECELIBQgAyIFSQ0CA0AgBiELIBAhBiADIAsgD2prIgUgDmtBfEsNAiAZIA8gBSAOSSIHGyAFaiIFKAAAIAMoAABHDQIgA0EEaiAFQQRqIAggEiAIIAcbIBUQ0AshBSADIBZNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEECyAEQQE2AgAgBEEAOwEEIAVBAWoiB0GAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAHOwEGIAEgBEEIaiIENgIEIAshECAGIQwgAyAFakEEaiIDIQUgAyAUTQ0ACwwCCyAAIAUgA2siBEH/D0s2AtwBIAUgBEEIdmpBAWohBQwBCyALIQwgBiELIAMhBQsgBSAUSQ0ACwsgAiAMNgIEIAIgCzYCACAKQRBqJAAgCCADawvaGwIdfwJ+IwBBEGsiCyQAIAIoAgQhGSACKAIAIRcgAEEANgLcASAXIAMgAyAAKAIEIhUgACgCDCIFaiIeRmoiBiAVayIOIAUgDkEBIAAoArgBdCIJayAFIA4gBWsgCUsbIAAoAhgbayIFSyEaIAUgGUkhHyAAKALEASIRQQRLIQ1BBkEEIAAoAsgBIgUgBUEETRsiBSAFQQZPGyEbIAAoAhwiBSAFQQggAyAEaiIKQQ9rIiAgBSAVaiIOayIEIARBCE8bQQAgDiAKQRBrIhNNG2oiBEkEQCAAQSxqIQlBGCAAKAIkIg5rIQxBOCAOa60hIiAAKQNQIiOnIQcgG0EFayEIA0AgBSAVaiEOIAkgBUEHcUECdGoCfwJAAkACQCAIDgIBAgALIA4oAABBsfPd8XlsIAdzIAx2DAILIA4pAABCgICA2Mub741PfiAjhSAiiKcMAQsgDikAAEKAgOz8y5vvjU9+ICOFICKIpws2AgAgBUEBaiIFIARHDQALC0EAIBcgGhshBEEAIBkgHxshECAGIBNJBEBBBiARQQQgDRsiBSAFQQZPGyESIABBLGohISAKQSBrIRYgCkEBayEYIApBA2shDiAbQQRrIRwDQEEAIARrIQ8gBkEBaiEIAn9BACAERQ0AGkEAIAggBGsoAAAgBigAAUcNABogBkEFaiIMIA9qIQkCfwJAIAwgDk8EQCAMIQUMAQsgCSgAACIHIAwiBSgAACINRwRAIAcgDXNoQQN2DAILA0AgCUEEaiEJIAVBBGoiBSAOTw0BIAkoAAAiByAFKAAAIg1GDQALIAUgByANc2hBA3ZqIAxrDAELAkAgBSAYTw0AIAkvAAAgBS8AAEcNACAJQQJqIQkgBUECaiEFCyAFIApJBH8gBSAJLQAAIAUtAABGagUgBQsgDGsLQQRqCyEFIAtB/5Pr3AM2AgwCQAJ/AkACQAJAIBxBAWsOAgECAAsCQAJAAkAgEkEFaw4CAQIACyAAIAYgCiALQQxqEOILDAQLIAAgBiAKIAtBDGoQ4wsMAwsgACAGIAogC0EMahDkCwwCCwJAAkACQCASQQVrDgIBAgALIAAgBiAKIAtBDGoQ5QsMAwsgACAGIAogC0EMahDmCwwCCyAAIAYgCiALQQxqEOcLDAELAkACQAJAIBJBBWsOAgECAAsgACAGIAogC0EMahDoCwwCCyAAIAYgCiALQQxqEOkLDAELIAAgBiAKIAtBDGoQ6gsLIgkgBSAFIAlJIgcbIgxBBE8EQCAGIAggBxshDSALKAIMQQEgBxshCQJAIAYgE08NAANAIAZBAWohBwJAIAlFBEBBACEJDAELIARFDQAgBygAACAHIA9qKAAARw0AIAZBBWoiESAPaiEIIAlnIAxBA2xqQR5rAn8CQAJAIA4gEU0EQCARIQUMAQsgCCgAACIUIBEiBSgAACIdRwRAIBQgHXNoQQN2QQRyDAMLA0AgCEEEaiEIIAVBBGoiBSAOTw0BIAgoAAAiFCAFKAAAIh1GDQALIAUgFCAdc2hBA3ZqIQUMAQsCQCAFIBhPDQAgCC8AACAFLwAARw0AIAhBAmohCCAFQQJqIQULIAUgCk8NACAFIAgtAAAgBS0AAEZqIQULIAUgEWsiBUF7Sw0BIAVBBGoLIgVBA2xODQBBASEJIAchDSAFIQwLIAtB/5Pr3AM2AggCfwJAAn8CQAJAAkAgHEEBaw4CAQIACwJAAkACQCASQQVrDgIBAgALIAAgByAKIAtBCGoQ4gsMBAsgACAHIAogC0EIahDjCwwDCyAAIAcgCiALQQhqEOQLDAILAkACQAJAIBJBBWsOAgECAAsgACAHIAogC0EIahDlCwwDCyAAIAcgCiALQQhqEOYLDAILIAAgByAKIAtBCGoQ5wsMAQsCQAJAAkAgEkEFaw4CAQIACyAAIAcgCiALQQhqEOgLDAILIAAgByAKIAtBCGoQ6QsMAQsgACAHIAogC0EIahDqCwsiBUEESQ0AIAsoAggiCGcgBUECdGpBH2sgCWcgDEECdGpBG2tMDQAgCCEJIAUhDCAHDAELIAcgE08NAiAGQQJqIQgCQCAJRQRAQQAhCQwBCyAERQ0AIAgoAAAgCCAPaigAAEcNACAGQQZqIgcgD2ohBSAJZyAMQQJ0akEeawJ/AkACQCAHIA5PBEAgByEGDAELIAUoAAAiESAHIgYoAAAiFEcEQCARIBRzaEEDdkEEcgwDCwNAIAVBBGohBSAGQQRqIgYgDk8NASAFKAAAIhEgBigAACIURg0ACyAGIBEgFHNoQQN2aiEGDAELAkAgBiAYTw0AIAUvAAAgBi8AAEcNACAFQQJqIQUgBkECaiEGCyAGIApPDQAgBiAFLQAAIAYtAABGaiEGCyAGIAdrIgZBe0sNASAGQQRqCyIGQQJ0Tg0AQQEhCSAIIQ0gBiEMCyALQf+T69wDNgIEAn8CQAJAAkAgHEEBaw4CAQIACwJAAkACQCASQQVrDgIBAgALIAAgCCAKIAtBBGoQ4gsMBAsgACAIIAogC0EEahDjCwwDCyAAIAggCiALQQRqEOQLDAILAkACQAJAIBJBBWsOAgECAAsgACAIIAogC0EEahDlCwwDCyAAIAggCiALQQRqEOYLDAILIAAgCCAKIAtBBGoQ5wsMAQsCQAJAAkAgEkEFaw4CAQIACyAAIAggCiALQQRqEOgLDAILIAAgCCAKIAtBBGoQ6QsMAQsgACAIIAogC0EEahDqCwsiBUEESQ0CIAsoAgQiB2cgBUECdGpBH2sgCWcgDEECdGpBGGtMDQIgByEJIAUhDCAICyIGIQ0gBiATSQ0ACwsCfyAJQQRJBEAgDSEHIBAhCCAEDAELAkAgAyANTwRAIA0hBwwBC0EDIAlrIgUgDSIHaiAeTQ0AA0AgDUEBayIHLQAAIAUgB2oiBi0AAEcEQCANIQcMAgsgDEEBaiEMIAMgB08NASAHIQ0gBiAeSw0ACwsgBCEIIAlBA2sLIQ0gByADayEPIAEoAgwhBgJAAkAgByAWTQRAIAYgA/0AAAD9CwAAIAEoAgwhBSAPQRBNBEAgASAFIA9qNgIMIAEoAgQhBgwDCyAFIAP9AAAQ/QsAECAPQSFIDQEgBSAPaiEEIANBEGohBiAFQSBqIQUDQCAFIAb9AAAQ/QsAACAFIAb9AAAg/QsAECAGQSBqIQYgBUEgaiIFIARJDQALDAELIAMgFk0EQCAGIAP9AAAA/QsAACAGIBYgA2siBGohBSAEQRFOBEAgBkEQaiEGA0AgBiAD/QAAEP0LAAAgBiAD/QAAIP0LABAgA0EgaiEDIAZBIGoiBiAFSQ0ACwsgBSEGIBYhAwsgAyAHTw0AQQAhBCAHIAMiBWtBB3EiEARAA0AgBiAFLQAAOgAAIAZBAWohBiAFQQFqIQUgBEEBaiIEIBBHDQALCyADIAdrQXhLDQADQCAGIAUtAAA6AAAgBiAFLQABOgABIAYgBS0AAjoAAiAGIAUtAAM6AAMgBiAFLQAEOgAEIAYgBS0ABToABSAGIAUtAAY6AAYgBiAFLQAHOgAHIAZBCGohBiAFQQhqIgUgB0cNAAsLIAEgASgCDCAPajYCDCABKAIEIQYgD0GAgARJDQAgAUEBNgIkIAEgBiABKAIAa0EDdTYCKAsgBiAJNgIAIAYgDzsBBCAMQQNrIgVBgIAETwRAIAFBAjYCJCABIAYgASgCAGtBA3U2AigLIAYgBTsBBiABIAZBCGoiCTYCBCAAKALcAQRAIAAoAhwiBiAGQQggICAGIBVqIgVrIgMgA0EITxtBACAFIBNNG2oiA0kEQEEYIAAoAiQiBWshBEE4IAVrrSEiIAApA1AiI6chEANAIAYgFWohBSAhIAZBB3FBAnRqAn8CQAJAAkAgG0EFaw4CAQIACyAFKAAAQbHz3fF5bCAQcyAEdgwCCyAFKQAAQoCAgNjLm++NT34gI4UgIoinDAELIAUpAABCgIDs/Mub741PfiAjhSAiiKcLNgIAIAZBAWoiBiADRw0ACwsgAEEANgLcAQsgByAMaiEDIAhFBEAgCCEQIA0hBCADIQYMAgsgCCEQIA0hBCATIAMiBkkNAQNAIAghBCANIQggAygAACADIARrKAAARwRAIAQhECAIIQQgAyEGDAMLIANBBGoiDCAEayEFAn8CQCAMIA5PBEAgDCEGDAELIAUoAAAiByAMIgYoAAAiDUcEQCAHIA1zaEEDdgwCCwNAIAVBBGohBSAGQQRqIgYgDk8NASAFKAAAIgcgBigAACINRg0ACyAGIAcgDXNoQQN2aiAMawwBCwJAIAYgGE8NACAFLwAAIAYvAABHDQAgBUECaiEFIAZBAmohBgsgBiAKSQR/IAYgBS0AACAGLQAARmoFIAYLIAxrCyEGIAMgFk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQkLIAlBATYCACAJQQA7AQQgBkEBaiIFQYCABE8EQCABQQI2AiQgASAJIAEoAgBrQQN1NgIoCyAJIAU7AQYgASAJQQhqIgk2AgQgAyAGakEEaiEDIAhFBEAgCCEQIAMhBgwDCyAEIQ0gCCEQIBMgAyIGTw0ACwwBCyAAIAYgA2siBUH/D0s2AtwBIAYgBUEIdmpBAWohBgsgBiATSQ0ACwsgAiAEIBdBACAaGyAEGzYCACACIBAgFyAZQQAgHxsiBiAEGyAGIBobIBAbNgIEIAtBEGokACAKIANrC80WAhp/An4jAEEQayIJJAAgAigCBCENIAIoAgAhCyAAKAK0ASIFKAIAIRQgBSgCBCEVIAUoAgwhBSAAQQA2AtwBIAAoAsQBIhFBBEshFkEGQQQgACgCyAEiBiAGQQRNGyIGIAZBBk8bIRkgAyADIAAoAgQiDiAAKAIMIhBqIhdrIAUgFWoiHCAUa0ZqIQUgACgCHCIGIAZBCCADIARqIgRBD2siHSAGIA5qIgdrIgogCkEITxtBACAHIARBEGsiE00baiIKSQRAIABBLGohCEEYIAAoAiQiB2shEkE4IAdrrSEfIAApA1AiIKchDyAZQQVrIQwDQCAGIA5qIQcgCCAGQQdxQQJ0agJ/AkACQAJAIAwOAgECAAsgBygAAEGx893xeWwgD3MgEnYMAgsgBykAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAHKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAGQQFqIgYgCkcNAAsLIAUgE0kEQEEGIBFBBCAWGyIGIAZBBk8bIQ8gAEEsaiEeIARBIGshGCAVIBUgFGsgEGoiGmshGwNAIAVBAWohCgJ/QQAgBSALIA5qIhJrQQFqIgcgEGtBfEsNABpBACAVIAcgGmtqIAcgDmogByAQSSIHGyIIKAAAIAooAABHDQAaIAVBBWogCEEEaiAEIBQgBCAHGyAXENALQQRqCyEGIAlB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgGUEEayIWQQFrDgIBAgALAkACQAJAIA9BBWsOAgECAAsgACAFIAQgCUEMahDsCwwECyAAIAUgBCAJQQxqEO0LDAMLIAAgBSAEIAlBDGoQ7gsMAgsCQAJAAkAgD0EFaw4CAQIACyAAIAUgBCAJQQxqEO8LDAMLIAAgBSAEIAlBDGoQ8AsMAgsgACAFIAQgCUEMahDxCwwBCwJAAkACQCAPQQVrDgIBAgALIAAgBSAEIAlBDGoQ8gsMAgsgACAFIAQgCUEMahDzCwwBCyAAIAUgBCAJQQxqEPQLCyIHIAYgBiAHSSIIGyIHQQRPBEAgBSAKIAgbIQogCSgCDEEBIAgbIQwCQCAFIBNPDQADQAJAIAVBAWoiBiASayIIIBBrQXxLDQAgFSAIIBpraiAIIA5qIAggEEkiCBsiESgAACAGKAAARw0AIAVBBWogEUEEaiAEIBQgBCAIGyAXENALIghBe0sNACAMZyAHQQNsakEeayAIQQRqIghBA2xODQBBASEMIAYhCiAIIQcLIAlB/5Pr3AM2AggCfwJAAn8CQAJAAkAgFkEBaw4CAQIACwJAAkACQCAPQQVrDgIBAgALIAAgBiAEIAlBCGoQ7AsMBAsgACAGIAQgCUEIahDtCwwDCyAAIAYgBCAJQQhqEO4LDAILAkACQAJAIA9BBWsOAgECAAsgACAGIAQgCUEIahDvCwwDCyAAIAYgBCAJQQhqEPALDAILIAAgBiAEIAlBCGoQ8QsMAQsCQAJAAkAgD0EFaw4CAQIACyAAIAYgBCAJQQhqEPILDAILIAAgBiAEIAlBCGoQ8wsMAQsgACAGIAQgCUEIahD0CwsiCEEESQ0AIAkoAggiEWcgCEECdGpBH2sgDGcgB0ECdGpBG2tMDQAgESEMIAghByAGDAELIAYgE08NAgJAIAVBAmoiCCASayIGIBBrQXxLDQAgFSAGIBpraiAGIA5qIAYgEEkiBhsiESgAACAIKAAARw0AIAVBBmogEUEEaiAEIBQgBCAGGyAXENALIgVBe0sNACAMZyAHQQJ0akEeayAFQQRqIgVBAnRODQBBASEMIAghCiAFIQcLIAlB/5Pr3AM2AgQCfwJAAkACQCAWQQFrDgIBAgALAkACQAJAIA9BBWsOAgECAAsgACAIIAQgCUEEahDsCwwECyAAIAggBCAJQQRqEO0LDAMLIAAgCCAEIAlBBGoQ7gsMAgsCQAJAAkAgD0EFaw4CAQIACyAAIAggBCAJQQRqEO8LDAMLIAAgCCAEIAlBBGoQ8AsMAgsgACAIIAQgCUEEahDxCwwBCwJAAkACQCAPQQVrDgIBAgALIAAgCCAEIAlBBGoQ8gsMAgsgACAIIAQgCUEEahDzCwwBCyAAIAggBCAJQQRqEPQLCyIGQQRJDQIgCSgCBCIRZyAGQQJ0akEfayAMZyAHQQJ0akEYa0wNAiARIQwgBiEHIAgLIgUhCiAFIBNJDQALCwJ/IAxBBEkEQCALIRIgDQwBCyAMQQNrIRICQCADIApPDQAgGyAOIAogDCAOamtBA2oiBSAQSSIGGyAFaiIFIBwgFyAGGyIITQ0AA0AgCkEBayIGLQAAIAVBAWsiBS0AAEcNASAHQQFqIQcgAyAGSQRAIAYhCiAFIAhLDQELCyAGIQoLIAsLIQggCiADayENIAEoAgwhBQJAAkAgCiAYTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSANQRBNBEAgASAFIA1qNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECANQSFIDQEgBSANaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgGE0EQCAFIAP9AAAA/QsAACAFIBggA2siC2ohBiALQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBghAwsgAyAKTw0AQQAhCyAKIAMiBmtBB3EiFgRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgC0EBaiILIBZHDQALCyADIAprQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCkcNAAsLIAEgASgCDCANajYCDCABKAIEIQMgDUGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAMNgIAIAMgDTsBBCAHQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiBjYCBCAHIApqIQMgACgC3AEEQCAAKAIcIgUgBUEIIB0gBSAOaiIHayIKIApBCE8bQQAgByATTRtqIgpJBEBBGCAAKAIkIgdrIQtBOCAHa60hHyAAKQNQIiCnIQwDQCAFIA5qIQcgHiAFQQdxQQJ0agJ/AkACQAJAIBlBBWsOAgECAAsgBygAAEGx893xeWwgDHMgC3YMAgsgBykAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAHKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAFQQFqIgUgCkcNAAsLIABBADYC3AELIAghDSASIQsgEyADIgVJDQIDQCAIIQsgEiEIIAMgCyAOamsiBSAQa0F8Sw0CIBsgDiAFIBBJIgcbIAVqIgUoAAAgAygAAEcNAiADQQRqIAVBBGogBCAUIAQgBxsgFxDQCyEFIAMgGE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQYLIAZBATYCACAGQQA7AQQgBUEBaiIHQYCABE8EQCABQQI2AiQgASAGIAEoAgBrQQN1NgIoCyAGIAc7AQYgASAGQQhqIgY2AgQgCyESIAghDSADIAVqQQRqIgMhBSADIBNNDQALDAILIAAgBSADayIGQf8PSzYC3AEgBSAGQQh2akEBaiEFDAELIAshDSAIIQsgAyEFCyAFIBNJDQALCyACIA02AgQgAiALNgIAIAlBEGokACAEIANrC80WAhp/An4jAEEQayIJJAAgAigCBCENIAIoAgAhCyAAKAK0ASIFKAIAIRQgBSgCBCEVIAUoAgwhBSAAQQA2AtwBIAAoAsQBIhFBBEshFkEGQQQgACgCyAEiBiAGQQRNGyIGIAZBBk8bIRkgAyADIAAoAgQiDiAAKAIMIhBqIhdrIAUgFWoiHCAUa0ZqIQUgACgCHCIGIAZBCCADIARqIgRBD2siHSAGIA5qIgdrIgogCkEITxtBACAHIARBEGsiE00baiIKSQRAIABBLGohCEEYIAAoAiQiB2shEkE4IAdrrSEfIAApA1AiIKchDyAZQQVrIQwDQCAGIA5qIQcgCCAGQQdxQQJ0agJ/AkACQAJAIAwOAgECAAsgBygAAEGx893xeWwgD3MgEnYMAgsgBykAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAHKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAGQQFqIgYgCkcNAAsLIAUgE0kEQEEGIBFBBCAWGyIGIAZBBk8bIQ8gAEEsaiEeIARBIGshGCAVIBUgFGsgEGoiGmshGwNAIAVBAWohCgJ/QQAgBSALIA5qIhJrQQFqIgcgEGtBfEsNABpBACAVIAcgGmtqIAcgDmogByAQSSIHGyIIKAAAIAooAABHDQAaIAVBBWogCEEEaiAEIBQgBCAHGyAXENALQQRqCyEGIAlB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgGUEEayIWQQFrDgIBAgALAkACQAJAIA9BBWsOAgECAAsgACAFIAQgCUEMahD2CwwECyAAIAUgBCAJQQxqEPcLDAMLIAAgBSAEIAlBDGoQ+AsMAgsCQAJAAkAgD0EFaw4CAQIACyAAIAUgBCAJQQxqEPkLDAMLIAAgBSAEIAlBDGoQ+gsMAgsgACAFIAQgCUEMahD7CwwBCwJAAkACQCAPQQVrDgIBAgALIAAgBSAEIAlBDGoQ/AsMAgsgACAFIAQgCUEMahD9CwwBCyAAIAUgBCAJQQxqEP4LCyIHIAYgBiAHSSIIGyIHQQRPBEAgBSAKIAgbIQogCSgCDEEBIAgbIQwCQCAFIBNPDQADQAJAIAVBAWoiBiASayIIIBBrQXxLDQAgFSAIIBpraiAIIA5qIAggEEkiCBsiESgAACAGKAAARw0AIAVBBWogEUEEaiAEIBQgBCAIGyAXENALIghBe0sNACAMZyAHQQNsakEeayAIQQRqIghBA2xODQBBASEMIAYhCiAIIQcLIAlB/5Pr3AM2AggCfwJAAn8CQAJAAkAgFkEBaw4CAQIACwJAAkACQCAPQQVrDgIBAgALIAAgBiAEIAlBCGoQ9gsMBAsgACAGIAQgCUEIahD3CwwDCyAAIAYgBCAJQQhqEPgLDAILAkACQAJAIA9BBWsOAgECAAsgACAGIAQgCUEIahD5CwwDCyAAIAYgBCAJQQhqEPoLDAILIAAgBiAEIAlBCGoQ+wsMAQsCQAJAAkAgD0EFaw4CAQIACyAAIAYgBCAJQQhqEPwLDAILIAAgBiAEIAlBCGoQ/QsMAQsgACAGIAQgCUEIahD+CwsiCEEESQ0AIAkoAggiEWcgCEECdGpBH2sgDGcgB0ECdGpBG2tMDQAgESEMIAghByAGDAELIAYgE08NAgJAIAVBAmoiCCASayIGIBBrQXxLDQAgFSAGIBpraiAGIA5qIAYgEEkiBhsiESgAACAIKAAARw0AIAVBBmogEUEEaiAEIBQgBCAGGyAXENALIgVBe0sNACAMZyAHQQJ0akEeayAFQQRqIgVBAnRODQBBASEMIAghCiAFIQcLIAlB/5Pr3AM2AgQCfwJAAkACQCAWQQFrDgIBAgALAkACQAJAIA9BBWsOAgECAAsgACAIIAQgCUEEahD2CwwECyAAIAggBCAJQQRqEPcLDAMLIAAgCCAEIAlBBGoQ+AsMAgsCQAJAAkAgD0EFaw4CAQIACyAAIAggBCAJQQRqEPkLDAMLIAAgCCAEIAlBBGoQ+gsMAgsgACAIIAQgCUEEahD7CwwBCwJAAkACQCAPQQVrDgIBAgALIAAgCCAEIAlBBGoQ/AsMAgsgACAIIAQgCUEEahD9CwwBCyAAIAggBCAJQQRqEP4LCyIGQQRJDQIgCSgCBCIRZyAGQQJ0akEfayAMZyAHQQJ0akEYa0wNAiARIQwgBiEHIAgLIgUhCiAFIBNJDQALCwJ/IAxBBEkEQCALIRIgDQwBCyAMQQNrIRICQCADIApPDQAgGyAOIAogDCAOamtBA2oiBSAQSSIGGyAFaiIFIBwgFyAGGyIITQ0AA0AgCkEBayIGLQAAIAVBAWsiBS0AAEcNASAHQQFqIQcgAyAGSQRAIAYhCiAFIAhLDQELCyAGIQoLIAsLIQggCiADayENIAEoAgwhBQJAAkAgCiAYTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSANQRBNBEAgASAFIA1qNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECANQSFIDQEgBSANaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgGE0EQCAFIAP9AAAA/QsAACAFIBggA2siC2ohBiALQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBghAwsgAyAKTw0AQQAhCyAKIAMiBmtBB3EiFgRAA0AgBSAGLQAAOgAAIAVBAWohBSAGQQFqIQYgC0EBaiILIBZHDQALCyADIAprQXhLDQADQCAFIAYtAAA6AAAgBSAGLQABOgABIAUgBi0AAjoAAiAFIAYtAAM6AAMgBSAGLQAEOgAEIAUgBi0ABToABSAFIAYtAAY6AAYgBSAGLQAHOgAHIAVBCGohBSAGQQhqIgYgCkcNAAsLIAEgASgCDCANajYCDCABKAIEIQMgDUGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAMNgIAIAMgDTsBBCAHQQNrIgVBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBTsBBiABIANBCGoiBjYCBCAHIApqIQMgACgC3AEEQCAAKAIcIgUgBUEIIB0gBSAOaiIHayIKIApBCE8bQQAgByATTRtqIgpJBEBBGCAAKAIkIgdrIQtBOCAHa60hHyAAKQNQIiCnIQwDQCAFIA5qIQcgHiAFQQdxQQJ0agJ/AkACQAJAIBlBBWsOAgECAAsgBygAAEGx893xeWwgDHMgC3YMAgsgBykAAEKAgIDYy5vvjU9+ICCFIB+IpwwBCyAHKQAAQoCA7PzLm++NT34gIIUgH4inCzYCACAFQQFqIgUgCkcNAAsLIABBADYC3AELIAghDSASIQsgEyADIgVJDQIDQCAIIQsgEiEIIAMgCyAOamsiBSAQa0F8Sw0CIBsgDiAFIBBJIgcbIAVqIgUoAAAgAygAAEcNAiADQQRqIAVBBGogBCAUIAQgBxsgFxDQCyEFIAMgGE0EQCABKAIMIAP9AAAA/QsAACABKAIEIQYLIAZBATYCACAGQQA7AQQgBUEBaiIHQYCABE8EQCABQQI2AiQgASAGIAEoAgBrQQN1NgIoCyAGIAc7AQYgASAGQQhqIgY2AgQgCyESIAghDSADIAVqQQRqIgMhBSADIBNNDQALDAILIAAgBSADayIGQf8PSzYC3AEgBSAGQQh2akEBaiEFDAELIAshDSAIIQsgAyEFCyAFIBNJDQALCyACIA02AgQgAiALNgIAIAlBEGokACAEIANrC74UARh/IwBBEGsiDSQAIAIoAgQhFyACKAIAIRUgAEEANgLcAUEAIBUgFSADIAMgACgCBCIOIAAoAgwiBWoiGkZqIgYgDmsiDiAFIA5BASAAKAK4AXQiCWsgBSAOIAVrIAlLGyAAKAIYG2siBUsiGxshCUEAIBcgBSAXSSIcGyEQIAMgBGoiDEEIayITIAZLBEAgDEEgayEUIAxBAWshFiAMQQNrIQ5BBkEEIAAoAsgBIgUgBUEETRsiBSAFQQZPG0EEayEYA0BBACEFQQAgCWshDyAGQQFqIQgCQCAJRQ0AIAggCWsoAAAgBigAAUcNACAGQQVqIgogD2ohBAJ/AkAgCiAOTwRAIAohBQwBCyAEKAAAIgcgCiIFKAAAIgtHBEAgByALc2hBA3YMAgsDQCAEQQRqIQQgBUEEaiIFIA5PDQEgBCgAACIHIAUoAAAiC0YNAAsgBSAHIAtzaEEDdmogCmsMAQsCQCAFIBZPDQAgBC8AACAFLwAARw0AIARBAmohBCAFQQJqIQULIAUgDEkEfyAFIAQtAAAgBS0AAEZqBSAFCyAKawtBBGohBQsgDUH/k+vcAzYCDAJAAn8CQAJAAkAgGEEBaw4CAQIACyAAIAYgDCANQQxqEIwMDAILIAAgBiAMIA1BDGoQjQwMAQsgACAGIAwgDUEMahCODAsiBCAFIAQgBUsiBxsiCkEETwRAIAYgCCAHGyELIA0oAgxBASAHGyEEAkAgBiATTw0AA0AgBkEBaiEHAkAgBEUEQEEAIQQMAQsgCUUNACAHKAAAIAcgD2ooAABHDQAgBkEFaiIRIA9qIQggBGcgCkEDbGpBHmsCfwJAAkAgDiARTQRAIBEhBQwBCyAIKAAAIhIgESIFKAAAIhlHBEAgEiAZc2hBA3ZBBHIMAwsDQCAIQQRqIQggBUEEaiIFIA5PDQEgCCgAACISIAUoAAAiGUYNAAsgBSASIBlzaEEDdmohBQwBCwJAIAUgFk8NACAILwAAIAUvAABHDQAgCEECaiEIIAVBAmohBQsgBSAMTw0AIAUgCC0AACAFLQAARmohBQsgBSARayIFQXtLDQEgBUEEagsiBUEDbE4NAEEBIQQgByELIAUhCgsgDUH/k+vcAzYCCAJ/AkACfwJAAkACQCAYQQFrDgIBAgALIAAgByAMIA1BCGoQjAwMAgsgACAHIAwgDUEIahCNDAwBCyAAIAcgDCANQQhqEI4MCyIFQQRJDQAgDSgCCCIIZyAFQQJ0akEfayAEZyAKQQJ0akEba0wNACAHIQYgBSEKIAgMAQsgByATTw0CIAZBAmohCAJAIARFBEBBACEEDAELIAlFDQAgCCgAACAIIA9qKAAARw0AIAZBBmoiByAPaiEFIARnIApBAnRqQR5rAn8CQAJAIAcgDk8EQCAHIQYMAQsgBSgAACIRIAciBigAACISRwRAIBEgEnNoQQN2QQRyDAMLA0AgBUEEaiEFIAZBBGoiBiAOTw0BIAUoAAAiESAGKAAAIhJGDQALIAYgESASc2hBA3ZqIQYMAQsCQCAGIBZPDQAgBS8AACAGLwAARw0AIAVBAmohBSAGQQJqIQYLIAYgDE8NACAGIAUtAAAgBi0AAEZqIQYLIAYgB2siBkF7Sw0BIAZBBGoLIgZBAnRODQBBASEEIAghCyAGIQoLIA1B/5Pr3AM2AgQCfwJAAkACQCAYQQFrDgIBAgALIAAgCCAMIA1BBGoQjAwMAgsgACAIIAwgDUEEahCNDAwBCyAAIAggDCANQQRqEI4MCyIFQQRJDQIgDSgCBCIHZyAFQQJ0akEfayAEZyAKQQJ0akEYa0wNAiAIIQYgBSEKIAcLIQQgBiELIAYgE0kNAAsLAn8gBEEESQRAIAshByAQIQggCQwBCwJAIAMgC08EQCALIQcMAQtBAyAEayIFIAsiB2ogGk0NAANAIAtBAWsiBy0AACAFIAdqIgYtAABHBEAgCyEHDAILIApBAWohCiADIAdPDQEgByELIAYgGksNAAsLIAkhCCAEQQNrCyELIAcgA2shDyABKAIMIQYCQAJAIAcgFE0EQCAGIAP9AAAA/QsAACABKAIMIQUgD0EQTQRAIAEgBSAPajYCDCABKAIEIQYMAwsgBSAD/QAAEP0LABAgD0EhSA0BIAUgD2ohCSADQRBqIQYgBUEgaiEFA0AgBSAG/QAAEP0LAAAgBSAG/QAAIP0LABAgBkEgaiEGIAVBIGoiBSAJSQ0ACwwBCyADIBRNBEAgBiAD/QAAAP0LAAAgBiAUIANrIglqIQUgCUERTgRAIAZBEGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgBUkNAAsLIAUhBiAUIQMLIAMgB08NAEEAIQkgByADIgVrQQdxIhAEQANAIAYgBS0AADoAACAGQQFqIQYgBUEBaiEFIAlBAWoiCSAQRw0ACwsgAyAHa0F4Sw0AA0AgBiAFLQAAOgAAIAYgBS0AAToAASAGIAUtAAI6AAIgBiAFLQADOgADIAYgBS0ABDoABCAGIAUtAAU6AAUgBiAFLQAGOgAGIAYgBS0ABzoAByAGQQhqIQYgBUEIaiIFIAdHDQALCyABIAEoAgwgD2o2AgwgASgCBCEGIA9BgIAESQ0AIAFBATYCJCABIAYgASgCAGtBA3U2AigLIAYgBDYCACAGIA87AQQgCkEDayIFQYCABE8EQCABQQI2AiQgASAGIAEoAgBrQQN1NgIoCyAGIAU7AQYgASAGQQhqIgQ2AgQgACgC3AEEQCAAQQA2AtwBCyAHIApqIQMgCEUEQCAIIRAgCyEJIAMhBgwCCyAIIRAgCyEJIBMgAyIGSQ0BA0AgCCEJIAshCCADKAAAIAMgCWsoAABHBEAgCSEQIAghCSADIQYMAwsgA0EEaiIKIAlrIQUCfwJAIAogDk8EQCAKIQYMAQsgBSgAACIHIAoiBigAACILRwRAIAcgC3NoQQN2DAILA0AgBUEEaiEFIAZBBGoiBiAOTw0BIAUoAAAiByAGKAAAIgtGDQALIAYgByALc2hBA3ZqIAprDAELAkAgBiAWTw0AIAUvAAAgBi8AAEcNACAFQQJqIQUgBkECaiEGCyAGIAxJBH8gBiAFLQAAIAYtAABGagUgBgsgCmsLIQYgAyAUTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBAsgBEEBNgIAIARBADsBBCAGQQFqIgVBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBTsBBiABIARBCGoiBDYCBCADIAZqQQRqIQMgCEUEQCAIIRAgAyEGDAMLIAkhCyAIIRAgEyADIgZPDQALDAELIAAgBiADayIFQf8PSzYC3AEgBiAFQQh2akEBaiEGCyAGIBNJDQALCyACIAkgFUEAIBsbIAkbNgIAIAIgECAVIBdBACAcGyIGIAkbIAYgGxsgEBs2AgQgDUEQaiQAIAwgA2sL3gIBCn8gACgCBCIHIAAoAhwiBGoiBiABTQR/AkAgBCABIAdrIg1PDQBBfyAAKAK8AUEBa3RBf3MhCCAAKAJkIQkgACgCXCEKIARBf3MgAWohBUEgIAAoAsABayELIAEgBmtBAXEEQCAKIAYoAABBsfPd8XlsIAt2QQJ0aiIGKAIAIQwgBiAENgIAIAkgBCAIcUEDdGoiBkEBNgIEIAYgDDYCACAEQQFqIQQLIAUgB0YNAANAIAogBCAHaigAAEGx893xeWwgC3ZBAnRqIgUoAgAhBiAFIAQ2AgAgCSAEIAhxQQN0aiIFQQE2AgQgBSAGNgIAIAogByAEQQFqIgVqKAAAQbHz3fF5bCALdkECdGoiBigCACEMIAYgBTYCACAJIAUgCHFBA3RqIgVBATYCBCAFIAw2AgAgBEECaiIEIA1JDQALCyAAIA02AhwgACABIAIgA0EEQQAQjwwFIAULC/ECAgl/AX4gACgCBCIHIAAoAhwiBGoiBiABTQR/AkAgBCABIAdrIgxPDQBBfyAAKAK8AUEBa3RBf3MhCCAAKAJkIQkgACgCXCEKIARBf3MgAWohBUHAACAAKALAAWutIQ0gASAGa0EBcQRAIAogBikAAEKAgIDYy5vvjU9+IA2Ip0ECdGoiBigCACELIAYgBDYCACAJIAQgCHFBA3RqIgZBATYCBCAGIAs2AgAgBEEBaiEECyAFIAdGDQADQCAKIAQgB2opAABCgICA2Mub741PfiANiKdBAnRqIgUoAgAhBiAFIAQ2AgAgCSAEIAhxQQN0aiIFQQE2AgQgBSAGNgIAIAogByAEQQFqIgVqKQAAQoCAgNjLm++NT34gDYinQQJ0aiIGKAIAIQsgBiAFNgIAIAkgBSAIcUEDdGoiBUEBNgIEIAUgCzYCACAEQQJqIgQgDEkNAAsLIAAgDDYCHCAAIAEgAiADQQVBABCPDAUgBQsL8QICCX8BfiAAKAIEIgcgACgCHCIEaiIGIAFNBH8CQCAEIAEgB2siDE8NAEF/IAAoArwBQQFrdEF/cyEIIAAoAmQhCSAAKAJcIQogBEF/cyABaiEFQcAAIAAoAsABa60hDSABIAZrQQFxBEAgCiAGKQAAQoCA7PzLm++NT34gDYinQQJ0aiIGKAIAIQsgBiAENgIAIAkgBCAIcUEDdGoiBkEBNgIEIAYgCzYCACAEQQFqIQQLIAUgB0YNAANAIAogBCAHaikAAEKAgOz8y5vvjU9+IA2Ip0ECdGoiBSgCACEGIAUgBDYCACAJIAQgCHFBA3RqIgVBATYCBCAFIAY2AgAgCiAHIARBAWoiBWopAABCgIDs/Mub741PfiANiKdBAnRqIgYoAgAhCyAGIAU2AgAgCSAFIAhxQQN0aiIFQQE2AgQgBSALNgIAIARBAmoiBCAMSQ0ACwsgACAMNgIcIAAgASACIANBBkEAEI8MBSAFCwvNEAElfyMAQRBrIh4kACAAKALAASEGIAAoAlwhCEEBIAAoAsQBdCEXIAAoAmQhGAJAAkAgCAJ/AkACQAJAIARBBWsOAgECAAsgASgAAEGx893xeWxBICAGa3YMAgsgASkAAEKAgIDYy5vvjU9+QcAAIAZrrYinDAELIAEpAABCgIDs/Mub741PfkHAACAGa62IpwtBAnRqIiUoAgAiBiABIAAoAgQiC2siG0F/IAAoArwBQQFrdEF/cyIgayIIQQAgCCAbTRsiISAAKAIQIgggG0EBIAAoArgBdCIJayAIIBsgCGsgCUsbIAAoAhgbIiIgISAiSxsiI0sEQCAXIRwDQAJAIBggBiIfICBxQQN0aiIGKAIEIghBAUcNACAcQQJJDQAgBiAHNgIEIBxBAWshHCAfIQcgBigCACIGICNLDQEMAwsLIAhBAUYEQCAGQgA3AgALIAchHyAHDQELIAAoAgghGQwBCyAYQQRqISYgACgCCCEZA0AgJiAfIhEgIHFBA3RqKAIAIR8gGCARQX8gACgCvAFBAWt0QX9zIiRxQQN0aiISQQRqIR0CQCAcRQ0AIBIoAgAiCCARQQEgACgCuAF0IgZrIAAoAhAiByARIAdrIAZLGyInTQ0AIAsgACgCDCINaiEoIBkgCyANIBFLIgYbIBFqIRAgDSAZaiIpIAIgBhsiE0EBayEqIBNBA2shCkEAIQwgHCEUQQAhGgNAAkACQCAFQQFHIAggDCAaIAwgGkkbIglqIA1PciIGRSANIBFNcUUEQCALIBkgBhsgCGoiFSAJaiEHIAogCSAQaiIOTQRAIA4hBgwCCyAHKAAAIg8gDiIGKAAAIhZHBEAgDyAWc2hBA3YgCWohBgwDCwNAIAdBBGohByAGQQRqIgYgCk8NAiAHKAAAIg8gBigAACIWRg0ACyAGIA8gFnNoQQN2aiAOayAJaiEGDAILIAggGWoiByAIIAtqIAkgEGogByAJaiATICkgKBDQCyAJaiIGIAhqIA1JGyEVDAELAkAgBiAqTw0AIAcvAAAgBi8AAEcNACAHQQJqIQcgBkECaiEGCyAGIBNJBH8gBiAHLQAAIAYtAABGagUgBgsgDmsgCWohBgsgBiAQaiIJIBNGDQEgGCAIICRxQQN0aiEHAkACQCAGIBVqLQAAIAktAABJBEAgEiAINgIAIAggI0sNASAeQQxqIRIMBAsgHSAINgIAIAggI0sEQCAHIR0gBiEaDAILIB5BDGohHQwDCyAHQQRqIgchEiAGIQwLIBRBAWsiFEUNASAHKAIAIgggJ0sNAAsLIB1BADYCACASQQA2AgAgHEEBaiEcIB8NAAsLIAAoAgwhFSAlKAIAIQYgJSAbNgIAIBtBCWohEyAYIBsgIHFBA3RqIg5BBGohFAJAIAYgIk0EQEEAIQwMAQsgCyAVaiESIBUgGWohHSACQQFrISQgAkEDayEaQQAhDCAFQQFHIRFBACENQQAhEANAIAEgECANIA0gEEsbIglqIQoCfwJAIBFFIAYgCWogFUlxRQRAIAYgC2ogCWohCCAKIBpPBEAgCiEHDAILIAgoAAAiDyAKIgcoAAAiFkcEQCAPIBZzaEEDdiAJaiEHIAsMAwsDQCAIQQRqIQggB0EEaiIHIBpPDQIgCCgAACIPIAcoAAAiFkYNAAsgByAPIBZzaEEDdmogCmsgCWohByALDAILIBkgCyAKIAYgGWogCWogAiAdIBIQ0AsgCWoiByAGaiAVSRsMAQsCQCAHICRPDQAgCC8AACAHLwAARw0AIAhBAmohCCAHQQJqIQcLIAIgB0sEfyAHIAgtAAAgBy0AAEZqBSAHCyAKayAJaiEHIAsLIQkCQCAHIAxNDQAgBiAHaiEIIAcgEyAGa0shCiADKAIAZyAbIAZrIg9BAWpnayAHIAxrQQJ0SARAIAMgD0EDajYCACAHIQwLIAggEyAKGyETIAEgB2ogAkcNACAXQQAgBUECRxshFwwCCyAYIAYgIHFBA3RqIQgCQAJAIAYgCWogB2otAAAgASAHai0AAEkEQCAOIAY2AgAgBiAhSw0BIB5BCGohDgwECyAUIAY2AgAgBiAhSwRAIAchDSAIIRQMAgsgHkEIaiEUDAMLIAchECAIQQRqIg4hCAsgF0EBayIXRQ0BIAgoAgAiBiAiSw0ACwsgFEEANgIAIA5BADYCAAJAIAVBAkcNACAXRQ0AIAAoArQBIgYoAsABIQcgBigCXCEIIAgCfwJAAkACQCAEQQVrDgIBAgALIAEoAABBsfPd8XlsQSAgB2t2DAILIAEpAABCgICA2Mub741PfkHAACAHa62IpwwBCyABKQAAQoCA7PzLm++NT35BwAAgB2utiKcLQQJ0aigCACIHIAYoAhAiDU0NACAGKAIAIhYgBigCBCIVayIQQX8gBigCvAFBAWt0QX9zIg9rIA0gECANayAPSxshDiALIAAoAgxqIRQgBigCZCERIAEgCyAAKAIQIBBraiISayIGQQNqIQsgBkEBaiEYQQAhCEEAIQoDQCAMIAEgCiAIIAggCksbIgZqIAcgFWoiGiAGaiACIBYgFBDQCyAGaiIGSQRAIAMoAgBBAWpnIBggB2tnayAGIAxrQQJ0SARAIAMgCyAHazYCACAGIQwLIAEgBmogAkYNAgsgESAHIA9xQQN0aiEJAkAgGiAHIBJqIAYgB2ogEEkbIAZqLQAAIAEgBmotAABJBEAgByAOTQ0DIAlBBGohCSAGIQogCCEGDAELIAcgDk0NAgsgF0EBayIXRQ0BIAYhCCAJKAIAIgcgDUsNAAsLIAAgE0EIazYCHCAeQRBqJAAgDAu1DwEXfyMAQRBrIgokACACKAIEIQwgAigCACELIAAoArQBIgUoAgAhEiAFKAIEIRMgBSgCDCEFIABBADYC3AEgAyADIAAoAgQiDyAAKAIMIg5qIhVrIAUgE2oiGiASa0ZqIgUgAyAEaiIIQQhrIhRJBEBBBkEEIAAoAsgBIgQgBEEETRsiBCAEQQZPGyEbIAhBIGshFiATIBMgEmsgDmoiGGshGQNAIAVBAWohCUEAIQQCQCAFIAsgD2oiEGtBAWoiByAOa0F8Sw0AIBMgByAYa2ogByAPaiAHIA5JIgcbIgYoAAAgCSgAAEcNACAFQQVqIAZBBGogCCASIAggBxsgFRDQC0EEaiEECyAKQf+T69wDNgIMAkACQAJ/AkACQAJAIBtBBGsiF0EBaw4CAQIACyAAIAUgCCAKQQxqEJEMDAILIAAgBSAIIApBDGoQkgwMAQsgACAFIAggCkEMahCTDAsiByAEIAQgB0kiBhsiB0EETwRAIAUgCSAGGyEJIAooAgxBASAGGyENAkAgBSAUTw0AA0ACQCAFQQFqIgQgEGsiBiAOa0F8Sw0AIBMgBiAYa2ogBiAPaiAGIA5JIgYbIhEoAAAgBCgAAEcNACAFQQVqIBFBBGogCCASIAggBhsgFRDQCyIGQXtLDQAgDWcgB0EDbGpBHmsgBkEEaiIGQQNsTg0AQQEhDSAEIQkgBiEHCyAKQf+T69wDNgIIAn8CQAJ/AkACQAJAIBdBAWsOAgECAAsgACAEIAggCkEIahCRDAwCCyAAIAQgCCAKQQhqEJIMDAELIAAgBCAIIApBCGoQkwwLIgZBBEkNACAKKAIIIhFnIAZBAnRqQR9rIA1nIAdBAnRqQRtrTA0AIBEhDSAGIQcgBAwBCyAEIBRPDQICQCAFQQJqIgYgEGsiBCAOa0F8Sw0AIBMgBCAYa2ogBCAPaiAEIA5JIgQbIhEoAAAgBigAAEcNACAFQQZqIBFBBGogCCASIAggBBsgFRDQCyIFQXtLDQAgDWcgB0ECdGpBHmsgBUEEaiIFQQJ0Tg0AQQEhDSAGIQkgBSEHCyAKQf+T69wDNgIEAn8CQAJAAkAgF0EBaw4CAQIACyAAIAYgCCAKQQRqEJEMDAILIAAgBiAIIApBBGoQkgwMAQsgACAGIAggCkEEahCTDAsiBEEESQ0CIAooAgQiEWcgBEECdGpBH2sgDWcgB0ECdGpBGGtMDQIgESENIAQhByAGCyIFIQkgBSAUSQ0ACwsCfyANQQRJBEAgCyEQIAwMAQsgDUEDayEQAkAgAyAJTw0AIBkgDyAJIA0gD2prQQNqIgUgDkkiBBsgBWoiBSAaIBUgBBsiBk0NAANAIAlBAWsiBC0AACAFQQFrIgUtAABHDQEgB0EBaiEHIAMgBEkEQCAEIQkgBSAGSw0BCwsgBCEJCyALCyEGIAkgA2shDCABKAIMIQUCQAJAIAkgFk0EQCAFIAP9AAAA/QsAACABKAIMIQUgDEEQTQRAIAEgBSAMajYCDCABKAIEIQMMAwsgBSAD/QAAEP0LABAgDEEhSA0BIAUgDGohBCADQRBqIQMgBUEgaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAESQ0ACwwBCyADIBZNBEAgBSAD/QAAAP0LAAAgBSAWIANrIgtqIQQgC0ERTgRAIAVBEGohBQNAIAUgA/0AABD9CwAAIAUgA/0AACD9CwAQIANBIGohAyAFQSBqIgUgBEkNAAsLIAQhBSAWIQMLIAMgCU8NAEEAIQsgCSADIgRrQQdxIhcEQANAIAUgBC0AADoAACAFQQFqIQUgBEEBaiEEIAtBAWoiCyAXRw0ACwsgAyAJa0F4Sw0AA0AgBSAELQAAOgAAIAUgBC0AAToAASAFIAQtAAI6AAIgBSAELQADOgADIAUgBC0ABDoABCAFIAQtAAU6AAUgBSAELQAGOgAGIAUgBC0ABzoAByAFQQhqIQUgBEEIaiIEIAlHDQALCyABIAEoAgwgDGo2AgwgASgCBCEDIAxBgIAESQ0AIAFBATYCJCABIAMgASgCAGtBA3U2AigLIAMgDTYCACADIAw7AQQgB0EDayIFQYCABE8EQCABQQI2AiQgASADIAEoAgBrQQN1NgIoCyADIAU7AQYgASADQQhqIgQ2AgQgByAJaiEDIAAoAtwBBEAgAEEANgLcAQsgBiEMIBAhCyAUIAMiBUkNAgNAIAYhCyAQIQYgAyALIA9qayIFIA5rQXxLDQIgGSAPIAUgDkkiBxsgBWoiBSgAACADKAAARw0CIANBBGogBUEEaiAIIBIgCCAHGyAVENALIQUgAyAWTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhBAsgBEEBNgIAIARBADsBBCAFQQFqIgdBgIAETwRAIAFBAjYCJCABIAQgASgCAGtBA3U2AigLIAQgBzsBBiABIARBCGoiBDYCBCALIRAgBiEMIAMgBWpBBGoiAyEFIAMgFE0NAAsMAgsgACAFIANrIgRB/w9LNgLcASAFIARBCHZqQQFqIQUMAQsgCyEMIAYhCyADIQULIAUgFEkNAAsLIAIgDDYCBCACIAs2AgAgCkEQaiQAIAggA2sL3gIBCn8gACgCBCIHIAAoAhwiBGoiBiABTQR/AkAgBCABIAdrIg1PDQBBfyAAKAK8AUEBa3RBf3MhCCAAKAJkIQkgACgCXCEKIARBf3MgAWohBUEgIAAoAsABayELIAEgBmtBAXEEQCAKIAYoAABBsfPd8XlsIAt2QQJ0aiIGKAIAIQwgBiAENgIAIAkgBCAIcUEDdGoiBkEBNgIEIAYgDDYCACAEQQFqIQQLIAUgB0YNAANAIAogBCAHaigAAEGx893xeWwgC3ZBAnRqIgUoAgAhBiAFIAQ2AgAgCSAEIAhxQQN0aiIFQQE2AgQgBSAGNgIAIAogByAEQQFqIgVqKAAAQbHz3fF5bCALdkECdGoiBigCACEMIAYgBTYCACAJIAUgCHFBA3RqIgVBATYCBCAFIAw2AgAgBEECaiIEIA1JDQALCyAAIA02AhwgACABIAIgA0EEQQIQjwwFIAULC/ECAgl/AX4gACgCBCIHIAAoAhwiBGoiBiABTQR/AkAgBCABIAdrIgxPDQBBfyAAKAK8AUEBa3RBf3MhCCAAKAJkIQkgACgCXCEKIARBf3MgAWohBUHAACAAKALAAWutIQ0gASAGa0EBcQRAIAogBikAAEKAgIDYy5vvjU9+IA2Ip0ECdGoiBigCACELIAYgBDYCACAJIAQgCHFBA3RqIgZBATYCBCAGIAs2AgAgBEEBaiEECyAFIAdGDQADQCAKIAQgB2opAABCgICA2Mub741PfiANiKdBAnRqIgUoAgAhBiAFIAQ2AgAgCSAEIAhxQQN0aiIFQQE2AgQgBSAGNgIAIAogByAEQQFqIgVqKQAAQoCAgNjLm++NT34gDYinQQJ0aiIGKAIAIQsgBiAFNgIAIAkgBSAIcUEDdGoiBUEBNgIEIAUgCzYCACAEQQJqIgQgDEkNAAsLIAAgDDYCHCAAIAEgAiADQQVBAhCPDAUgBQsL8QICCX8BfiAAKAIEIgcgACgCHCIEaiIGIAFNBH8CQCAEIAEgB2siDE8NAEF/IAAoArwBQQFrdEF/cyEIIAAoAmQhCSAAKAJcIQogBEF/cyABaiEFQcAAIAAoAsABa60hDSABIAZrQQFxBEAgCiAGKQAAQoCA7PzLm++NT34gDYinQQJ0aiIGKAIAIQsgBiAENgIAIAkgBCAIcUEDdGoiBkEBNgIEIAYgCzYCACAEQQFqIQQLIAUgB0YNAANAIAogBCAHaikAAEKAgOz8y5vvjU9+IA2Ip0ECdGoiBSgCACEGIAUgBDYCACAJIAQgCHFBA3RqIgVBATYCBCAFIAY2AgAgCiAHIARBAWoiBWopAABCgIDs/Mub741PfiANiKdBAnRqIgYoAgAhCyAGIAU2AgAgCSAFIAhxQQN0aiIFQQE2AgQgBSALNgIAIARBAmoiBCAMSQ0ACwsgACAMNgIcIAAgASACIANBBkECEI8MBSAFCwu5CwEVfyMAQRBrIgwkACACKAIEIQogAigCACEGIABBADYC3AEgAyADIAAoAgQiDSAAKAIMIg5qIhVGaiIFIAMgBGoiCUEIayIWSQRAIAAoAggiESAAKAIQaiEYIA4gEWohFyAJQSBrIQ9BASAAKAK4AXQhEkEGQQQgACgCyAEiBCAEQQRNGyIEIARBBk8bQQRrIRkDQAJAAn8CQAJAAkAgBiAFIA1rQQFqIgQgACgCECIIIAQgEmsgCCAEIAhrIBJLGyAAKAIYG2tLDQAgBCAGayIEIA5rQXxLDQAgBUEBaiIHKAAAIBEgDSAEIA5JIggbIARqIgQoAABHDQAgBUEFaiAEQQRqIAkgFyAJIAgbIBUQ0AtBBGohEEEBIRMMAQsgDEH/k+vcAzYCDAJ/AkACQAJAIBlBAWsOAgECAAsgACAFIAkgDEEMahCVDAwCCyAAIAUgCSAMQQxqEJYMDAELIAAgBSAJIAxBDGoQlwwLIhBBA00EQCAAIAUgA2siBEH/EUs2AtwBIAUgBEEIdmpBAWohBQwECyAMKAIMIhNBBE8NASAFIQcLIAYhFCAKDAELIBNBA2shFAJAAkAgAyAFTw0AIBEgDSAFIA0gE2prQQNqIgQgDkkiCBsgBGoiBCAYIBUgCBsiCE0NAANAIAVBAWsiBy0AACAEQQFrIgQtAABHDQEgEEEBaiEQIAMgB08NAiAHIQUgBCAISw0ACwwBCyAFIQcLIAYLIQggByADayELIAEoAgwhBAJAAkAgByAPTQRAIAQgA/0AAAD9CwAAIAEoAgwhBCALQRBNBEAgASAEIAtqNgIMIAEoAgQhAwwDCyAEIAP9AAAQ/QsAECALQSFIDQEgBCALaiEGIANBEGohAyAEQSBqIQQDQCAEIAP9AAAQ/QsAACAEIAP9AAAg/QsAECADQSBqIQMgBEEgaiIEIAZJDQALDAELIAMgD00EQCAEIAP9AAAA/QsAACAEIA8gA2siBWohBiAFQRFOBEAgBEEQaiEEA0AgBCAD/QAAEP0LAAAgBCAD/QAAIP0LABAgA0EgaiEDIARBIGoiBCAGSQ0ACwsgBiEEIA8hAwsgAyAHTw0AQQAhBSADIQYgByADa0EHcSIKBEADQCAEIAYtAAA6AAAgBEEBaiEEIAZBAWohBiAFQQFqIgUgCkcNAAsLIAMgB2tBeEsNAANAIAQgBi0AADoAACAEIAYtAAE6AAEgBCAGLQACOgACIAQgBi0AAzoAAyAEIAYtAAQ6AAQgBCAGLQAFOgAFIAQgBi0ABjoABiAEIAYtAAc6AAcgBEEIaiEEIAZBCGoiBiAHRw0ACwsgASABKAIMIAtqNgIMIAEoAgQhAyALQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIBM2AgAgAyALOwEEIBBBA2siBEGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAEOwEGIAEgA0EIaiIENgIEIAcgEGohAyAAKALcAQRAIABBADYC3AELIAghCiAUIQYgAyEFIAMgFksNAANAAkAgCCEGIBQhCCAGIAMgDWsiBSAAKAIQIgcgBSASayAHIAUgB2sgEksbIAAoAhgba0sNACAFIAZrIgUgDmtBfEsNACADKAAAIBEgDSAFIA5JIgcbIAVqIgUoAABHDQAgA0EEaiAFQQRqIAkgFyAJIAcbIBUQ0AshBSADIA9NBEAgASgCDCAD/QAAAP0LAAAgASgCBCEECyAEQQE2AgAgBEEAOwEEIAVBAWoiB0GAgARPBEAgAUECNgIkIAEgBCABKAIAa0EDdTYCKAsgBCAHOwEGIAEgBEEIaiIENgIEIAYhFCAIIQogAyAFakEEaiIDIQUgAyAWTQ0BDAILCyAGIQogCCEGIAMhBQsgBSAWSQ0ACwsgAiAKNgIEIAIgBjYCACAMQRBqJAAgCSADawujBQEVfyABIAAoAgQiDWsiCEEBIAAoArwBIgR0IgtrIgVBACAFIAhNGyERIAAoAhAiBSAIQQEgACgCuAF0IgZrIAUgCCAFayAGSxsgACgCGBshDiAAKAIcIgUgCCAFIAhLGyEMQSAgACgCwAFrIQZBASAAKALEAXQhDyAAKAIIIhIgACgCDCIQaiETIA0gEGohFEF/IAR0QX9zIQkgC0EBayEVIAAoAlwhByAAKALcASEKIAAoAmQhCwNAIAUgDEcEQCALIAUgCXFBAnRqIAcgBSANaigAAEGx893xeWwgBnZBAnRqIgQoAgA2AgAgBCAFNgIAIAVBAWohBSAKRQ0BCwsgACAINgIcQQMhBAJAIAcgASgAACIAQbHz3fF5bCAGdkECdGooAgAiBSAOSQ0AIAFBA2shFiAIQQNqIQggAUEEaiEXIAJBAWshGCACQQNrIQxBAyEHA0ACQCAHAn8CQCAFIBBPBEAgBSANaiIGIAdqQQNrKAAAIAcgFmooAABHDQMgASAMTwRAIAEhBAwCCyAGKAAAIgkgASIEKAAAIgpHBEAgCSAKc2hBA3YMAwsDQCAGQQRqIQYgBEEEaiIEIAxPDQIgBigAACIJIAQoAAAiCkYNAAsgBCAJIApzaEEDdmogAWsMAgsgBSASaiIEKAAAIABHDQIgFyAEQQRqIAIgEyAUENALQQRqDAELAkAgBCAYTw0AIAYvAAAgBC8AAEcNACAGQQJqIQYgBEECaiEECyACIARLBH8gBCAGLQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAIIAVrNgIAIAQhByABIARqIAJGDQILIAUgEU0EQCAHDwsgD0EBayIPRQRAIAcPCyAHIQQgCyAFIBVxQQJ0aigCACIFIA5PDQALCyAEC7IFAhR/AX4gASAAKAIEIgxrIgdBASAAKAK8ASIEdCIGayIFQQAgBSAHTRshECAAKAIQIgUgB0EBIAAoArgBdCIKayAFIAcgBWsgCksbIAAoAhgbIQ0gACgCHCIFIAcgBSAHSxshCEEBIAAoAsQBdCEOIAAoAggiESAAKAIMIg9qIRIgDCAPaiETQX8gBHRBf3MhCyAGQQFrIRRBwAAgACgCwAFrrSEYIAAoAlwhBiAAKALcASEJIAAoAmQhCgNAIAUgCEcEQCAKIAUgC3FBAnRqIAYgBSAMaikAAEKAgIDYy5vvjU9+IBiIp0ECdGoiBCgCADYCACAEIAU2AgAgBUEBaiEFIAlFDQELCyAAIAc2AhxBAyEEAkAgBiABKQAAQoCAgNjLm++NT34gGIinQQJ0aigCACIFIA1JDQAgAUEDayEVIAdBA2ohByABQQRqIRYgAkEBayEXIAJBA2shC0EDIQgDQAJAIAgCfwJAIAUgD08EQCAFIAxqIgYgCGpBA2soAAAgCCAVaigAAEcNAyABIAtPBEAgASEEDAILIAYoAAAiCSABIgQoAAAiAEcEQCAAIAlzaEEDdgwDCwNAIAZBBGohBiAEQQRqIgQgC08NAiAGKAAAIgkgBCgAACIARg0ACyAEIAAgCXNoQQN2aiABawwCCyAFIBFqIgQoAAAgASgAAEcNAiAWIARBBGogAiASIBMQ0AtBBGoMAQsCQCAEIBdPDQAgBi8AACAELwAARw0AIAZBAmohBiAEQQJqIQQLIAIgBEsEfyAEIAYtAAAgBC0AAEZqBSAECyABawsiBE8NACADIAcgBWs2AgAgBCEIIAEgBGogAkYNAgsgBSAQTQRAIAgPCyAOQQFrIg5FBEAgCA8LIAghBCAKIAUgFHFBAnRqKAIAIgUgDU8NAAsLIAQLsgUCFH8BfiABIAAoAgQiDGsiB0EBIAAoArwBIgR0IgZrIgVBACAFIAdNGyEQIAAoAhAiBSAHQQEgACgCuAF0IgprIAUgByAFayAKSxsgACgCGBshDSAAKAIcIgUgByAFIAdLGyEIQQEgACgCxAF0IQ4gACgCCCIRIAAoAgwiD2ohEiAMIA9qIRNBfyAEdEF/cyELIAZBAWshFEHAACAAKALAAWutIRggACgCXCEGIAAoAtwBIQkgACgCZCEKA0AgBSAIRwRAIAogBSALcUECdGogBiAFIAxqKQAAQoCA7PzLm++NT34gGIinQQJ0aiIEKAIANgIAIAQgBTYCACAFQQFqIQUgCUUNAQsLIAAgBzYCHEEDIQQCQCAGIAEpAABCgIDs/Mub741PfiAYiKdBAnRqKAIAIgUgDUkNACABQQNrIRUgB0EDaiEHIAFBBGohFiACQQFrIRcgAkEDayELQQMhCANAAkAgCAJ/AkAgBSAPTwRAIAUgDGoiBiAIakEDaygAACAIIBVqKAAARw0DIAEgC08EQCABIQQMAgsgBigAACIJIAEiBCgAACIARwRAIAAgCXNoQQN2DAMLA0AgBkEEaiEGIARBBGoiBCALTw0CIAYoAAAiCSAEKAAAIgBGDQALIAQgACAJc2hBA3ZqIAFrDAILIAUgEWoiBCgAACABKAAARw0CIBYgBEEEaiACIBIgExDQC0EEagwBCwJAIAQgF08NACAGLwAAIAQvAABHDQAgBkECaiEGIARBAmohBAsgAiAESwR/IAQgBi0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgByAFazYCACAEIQggASAEaiACRg0CCyAFIBBNBEAgCA8LIA5BAWsiDkUEQCAIDwsgCCEEIAogBSAUcUECdGooAgAiBSANTw0ACwsgBAulEAIZfwJ+IwBBEGsiCiQAIAIoAgQhDSACKAIAIQYgAEEANgLcASAAKALEASIOQQRLIQ9BBkEEIAAoAsgBIgUgBUEETRsiBSAFQQZPGyELIAMgAyAAKAIEIgwgACgCDCIQaiIWRmohByAAKAIcIgUgBUEIIAMgBGoiCUEPayIbIAUgDGoiBGsiCCAIQQhPG0EAIAQgCUEQayITTRtqIghJBEAgAEEsaiERQRggACgCJCIEayEXQTggBGutIR4gACkDUCIfpyEYIAtBBWshEgNAIAUgDGohBCARIAVBB3FBAnRqAn8CQAJAAkAgEg4CAQIACyAEKAAAQbHz3fF5bCAYcyAXdgwCCyAEKQAAQoCAgNjLm++NT34gH4UgHoinDAELIAQpAABCgIDs/Mub741PfiAfhSAeiKcLNgIAIAVBAWoiBSAIRw0ACwsgByATSQRAQQYgDkEEIA8bIgUgBUEGTxshGSAAKAIIIhQgACgCEGohHCAQIBRqIRogAEEsaiEXIAlBIGshD0EBIAAoArgBdCERIAtBBGshHSALQQVrIRgDQAJAAn8CQAJAAkAgBiAHIAxrQQFqIgUgACgCECIEIAUgEWsgBCAFIARrIBFLGyAAKAIYG2tLDQAgBSAGayIFIBBrQXxLDQAgB0EBaiIIKAAAIBQgDCAFIBBJIgQbIAVqIgUoAABHDQAgB0EFaiAFQQRqIAkgGiAJIAQbIBYQ0AtBBGohC0EBIRUMAQsgCkH/k+vcAzYCDAJ/AkACQAJAIB1BAWsOAgECAAsCQAJAAkAgGUEFaw4CAQIACyAAIAcgCSAKQQxqEJkMDAQLIAAgByAJIApBDGoQmgwMAwsgACAHIAkgCkEMahCbDAwCCwJAAkACQCAZQQVrDgIBAgALIAAgByAJIApBDGoQnAwMAwsgACAHIAkgCkEMahCdDAwCCyAAIAcgCSAKQQxqEJ4MDAELAkACQAJAIBlBBWsOAgECAAsgACAHIAkgCkEMahCfDAwCCyAAIAcgCSAKQQxqEKAMDAELIAAgByAJIApBDGoQoQwLIgtBA00EQCAAIAcgA2siBUH/EUs2AtwBIAcgBUEIdmpBAWohBwwECyAKKAIMIhVBBE8NASAHIQgLIAYhEiANDAELIBVBA2shEgJAAkAgAyAHTw0AIBQgDCAHIAwgFWprQQNqIgUgEEkiBBsgBWoiBSAcIBYgBBsiBE0NAANAIAdBAWsiCC0AACAFQQFrIgUtAABHDQEgC0EBaiELIAMgCE8NAiAIIQcgBCAFSQ0ACwwBCyAHIQgLIAYLIQQgCCADayEOIAEoAgwhBgJAAkAgCCAPTQRAIAYgA/0AAAD9CwAAIAEoAgwhBiAOQRBNBEAgASAGIA5qNgIMIAEoAgQhAwwDCyAGIAP9AAAQ/QsAECAOQSFIDQEgBiAOaiEFIANBEGohAyAGQSBqIQYDQCAGIAP9AAAQ/QsAACAGIAP9AAAg/QsAECADQSBqIQMgBkEgaiIGIAVJDQALDAELIAMgD00EQCAGIAP9AAAA/QsAACAGIA8gA2siB2ohBSAHQRFOBEAgBkEQaiEGA0AgBiAD/QAAEP0LAAAgBiAD/QAAIP0LABAgA0EgaiEDIAZBIGoiBiAFSQ0ACwsgBSEGIA8hAwsgAyAITw0AQQAhByADIQUgCCADa0EHcSINBEADQCAGIAUtAAA6AAAgBkEBaiEGIAVBAWohBSAHQQFqIgcgDUcNAAsLIAMgCGtBeEsNAANAIAYgBS0AADoAACAGIAUtAAE6AAEgBiAFLQACOgACIAYgBS0AAzoAAyAGIAUtAAQ6AAQgBiAFLQAFOgAFIAYgBS0ABjoABiAGIAUtAAc6AAcgBkEIaiEGIAVBCGoiBSAIRw0ACwsgASABKAIMIA5qNgIMIAEoAgQhAyAOQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIBU2AgAgAyAOOwEEIAtBA2siBkGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAGOwEGIAEgA0EIaiIFNgIEIAggC2ohAyAAKALcAQRAIAAoAhwiBiAGQQggGyAGIAxqIgdrIgggCEEITxtBACAHIBNNG2oiCEkEQEEYIAAoAiQiB2shC0E4IAdrrSEeIAApA1AiH6chDQNAIAYgDGohByAXIAZBB3FBAnRqAn8CQAJAAkAgGA4CAQIACyAHKAAAQbHz3fF5bCANcyALdgwCCyAHKQAAQoCAgNjLm++NT34gH4UgHoinDAELIAcpAABCgIDs/Mub741PfiAfhSAeiKcLNgIAIAZBAWoiBiAIRw0ACwsgAEEANgLcAQsgBCENIBIhBiADIQcgAyATSw0AA0ACQCAEIQYgEiEEIAYgAyAMayIHIAAoAhAiCCAHIBFrIAggByAIayARSxsgACgCGBtrSw0AIAcgBmsiByAQa0F8Sw0AIAMoAAAgFCAMIAcgEEkiCBsgB2oiBygAAEcNACADQQRqIAdBBGogCSAaIAkgCBsgFhDQCyEHIAMgD00EQCABKAIMIAP9AAAA/QsAACABKAIEIQULIAVBATYCACAFQQA7AQQgB0EBaiIIQYCABE8EQCABQQI2AiQgASAFIAEoAgBrQQN1NgIoCyAFIAg7AQYgASAFQQhqIgU2AgQgBiESIAQhDSADIAdqQQRqIgMhByADIBNNDQEMAgsLIAYhDSAEIQYgAyEHCyAHIBNJDQALCyACIA02AgQgAiAGNgIAIApBEGokACAJIANrC84MAhZ/AX4jAEGAAmsiEiQAIAEgACgCBCINayEKIAAoArgBIRggACgCECEQIAAoAhghGSAAKAIMIRMgACgCCCEWIAAoAsQBIRcgACkDUCEaIAAoAiQhFCAAKAIoIQ4gACgCXCEPAkAgACgC3AFFBEAgAEEsaiEIAkAgCiAAKAIcIgRrQYEDSQRAIA4hDCAPIQsMAQsgDiEMIA8hCyAEQZ9/TQRAIA1BCGohDCAEQd8AaiELQRggFGshEQNAIAggBEEHcUECdGoiBygCACEFIAcgACgCUCAEIAxqKAAAQbHz3fF5bHMgEXY2AgAgDiAFQQR2QfD///8AcSIJaiIHQQ9BACAHLQAAIgZBD3FBAUYbIAZBAWtBD3FqIgY6AAAgBiAHaiAFOgAAIA8gCUECdGogBkECdGogBDYCACAEIAtHIQUgBEEBaiEEIAUNAAsgACgCKCEMIAAoAlwhCwsgCkEgayIEIARBCCABQQFqIgUgBCANaiIHa0EBaiIGIAZBCE8bQQAgBSAHTxtqIgdPDQBBGCAAKAIkayEGIAAoAlAhCSAEIQUDQCAIIAVBB3FBAnRqIAUgDWooAABBsfPd8XlsIAlzIAZ2NgIAIAVBAWoiBSAHRw0ACwsgBCAKSQRAIAAoAgRBCGohEUEYIAAoAiRrIRUDQCAIIARBB3FBAnRqIgcoAgAhBSAHIAAoAlAgBCARaigAAEGx893xeWxzIBV2NgIAIAwgBUEEdkHw////AHEiCWoiB0EPQQAgBy0AACIGQQ9xQQFGGyAGQQFrQQ9xaiIGOgAAIAYgB2ogBToAACALIAlBAnRqIAZBAnRqIAQ2AgAgBEEBaiIEIApJDQALCyAAIAo2AhwgCCAKQQdxQQJ0aiIEKAIAIQsgBCAapyAKIA1qKAAIQbHz3fF5bHNBGCAUa3Y2AgAMAQsgASgAACEEIAAgCjYCHCAapyAEQbHz3fF5bHNBGCAUa3YhCwsgACAAKAJYIAtqNgJYIA4gC0EEdkHw////AHEiBGoiCC0AACEGIA8gBEECdGohCUEAIQcCQCALQf8BcUGBgoQIbCIEIAgoAAxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCCgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVB//8DRg0AIBAgCkEBIBh0IgRrIBAgCiAQayAESxsgGRshDEEBQQQgFyAXQQRPG3QhBCAFQX9zIgVB//8DcSAGQQ9xdiAFQQAgBmtBD3F0cq1C//8DgyEaA0BBACAap2ggGlAbIAZqQQ9xIgUEQCAJIAVBAnRqKAIAIgUgDEkNAiASIAdBAnRqIAU2AgAgB0EBaiEHIARBAWshBAsgGkIBfSAagyIaUA0BIAQNAAsLIAggBkEBa0EPcUEPQQAgBkEPcUEBRhtqIgQ6AAAgBCAIaiALOgAAIAAgACgCHCIFQQFqNgIcIAkgBEECdGogBTYCAAJAIAdFBEBBAyEJDAELIBMgFmohESANIBNqIRUgAUEDayELIApBA2ohECABQQRqIQ4gAkEBayEPIAJBA2shCkEAIQVBAyEJA0ACQCAJAn8CQCATIBIgBUECdGooAgAiBk0EQCAGIA1qIgAgCWpBA2soAAAgCSALaigAAEcNAyABIApPBEAgASEEDAILIAAoAAAiCCABIgQoAAAiDEcEQCAIIAxzaEEDdgwDCwNAIABBBGohACAEQQRqIgQgCk8NAiAAKAAAIgggBCgAACIMRg0ACyAEIAggDHNoQQN2aiABawwCCyAGIBZqIgQoAAAgASgAAEcNAiAOIARBBGogAiARIBUQ0AtBBGoMAQsCQCAEIA9PDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIBAgBms2AgAgBCEJIAEgBGogAkYNAgsgBUEBaiIFIAdHDQALCyASQYACaiQAIAkL5A0CFn8BfiMAQYACayISJAAgASAAKAIEIg5rIQkgACgCuAEhGCAAKAIQIREgACgCGCEZIAAoAgwhEyAAKAIIIRYgACgCxAEhFyAAKQNQIRogACgCJCEUIAAoAighDyAAKAJcIRACQCAAKALcAUUEQCAAQSxqIQgCQCAJIAAoAhwiBGtBgQNJBEAgDyEKIBAhDQwBCyAPIQogECENIARBn39NBEAgDkEIaiEKIARB3wBqIQ1BGCAUayEMA0AgCCAEQQdxQQJ0aiIHKAIAIQUgByAAKAJQIAQgCmooAABBsfPd8XlscyAMdjYCACAPIAVBA3ZB4P///wFxIgtqIgdBH0EAIActAAAiBkEfcUEBRhsgBkEBa0EfcWoiBjoAACAGIAdqIAU6AAAgECALQQJ0aiAGQQJ0aiAENgIAIAQgDUchBSAEQQFqIQQgBQ0ACyAAKAJcIQ0gACgCKCEKCyAJQSBrIgQgBEEIIAFBAWoiBSAEIA5qIgdrQQFqIgYgBkEITxtBACAFIAdPG2oiB08NAEEYIAAoAiRrIQYgACgCUCELIAQhBQNAIAggBUEHcUECdGogBSAOaigAAEGx893xeWwgC3MgBnY2AgAgBUEBaiIFIAdHDQALCyAEIAlJBEAgACgCBEEIaiEMQRggACgCJGshFQNAIAggBEEHcUECdGoiBygCACEFIAcgACgCUCAEIAxqKAAAQbHz3fF5bHMgFXY2AgAgCiAFQQN2QeD///8BcSILaiIHQR9BACAHLQAAIgZBH3FBAUYbIAZBAWtBH3FqIgY6AAAgBiAHaiAFOgAAIA0gC0ECdGogBkECdGogBDYCACAEQQFqIgQgCUkNAAsLIAAgCTYCHCAIIAlBB3FBAnRqIgQoAgAhDCAEIBqnIAkgDmooAAhBsfPd8Xlsc0EYIBRrdjYCAAwBCyABKAAAIQQgACAJNgIcIBqnIARBsfPd8Xlsc0EYIBRrdiEMCyAAIAAoAlggDGo2AlhBAyELIA8gDEEDdkHg////AXEiBGoiCC0AACEGIBAgBEECdGohCkEAIQcCQCAMQf8BcUGBgoQIbCIEIAgoABxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCCgAGCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoABQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAECAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAwgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVBf0YNACARIAlBASAYdCIEayARIAkgEWsgBEsbIBkbIQ1BAUEFIBcgF0EFTxt0IQQgBUF/cyAGeK0hGgNAQQAgGqdoIBpQGyAGakEfcSIFBEAgCiAFQQJ0aigCACIFIA1JDQIgEiAHQQJ0aiAFNgIAIAdBAWohByAEQQFrIQQLIBpCAX0gGoMiGlANASAEDQALCyAIIAZBAWtBH3FBH0EAIAZBH3FBAUYbaiIEOgAAIAQgCGogDDoAACAAIAAoAhwiBUEBajYCHCAKIARBAnRqIAU2AgACQCAHRQ0AIBMgFmohDCAOIBNqIRUgAUEDayENIAlBA2ohESABQQRqIQ8gAkEBayEQIAJBA2shCUEAIQUDQAJAIAsCfwJAIBMgEiAFQQJ0aigCACIGTQRAIAYgDmoiACALakEDaygAACALIA1qKAAARw0DIAEgCU8EQCABIQQMAgsgACgAACIIIAEiBCgAACIKRwRAIAggCnNoQQN2DAMLA0AgAEEEaiEAIARBBGoiBCAJTw0CIAAoAAAiCCAEKAAAIgpGDQALIAQgCCAKc2hBA3ZqIAFrDAILIAYgFmoiBCgAACABKAAARw0CIA8gBEEEaiACIAwgFRDQC0EEagwBCwJAIAQgEE8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgESAGazYCACAEIQsgASAEaiACRg0CCyAFQQFqIgUgB0cNAAsLIBJBgAJqJAAgCwvzEAIWfwF+IwBBgAJrIhIkACABIAAoAgQiDWshCSAAKAK4ASEYIAAoAhAhECAAKAIYIRkgACgCDCETIAAoAgghFiAAKALEASEXIAApA1AhGiAAKAIkIRQgACgCKCEOIAAoAlwhDwJAIAAoAtwBRQRAIABBLGohCwJAIAkgACgCHCIEa0GBA0kEQCAOIQwgDyEKDAELIA4hDCAPIQogBEGff00EQCANQQhqIQwgBEHfAGohCkEYIBRrIREDQCALIARBB3FBAnRqIgcoAgAhBSAHIAAoAlAgBCAMaigAAEGx893xeWxzIBF2NgIAIA4gBUECdkHA////A3EiCGoiB0E/QQAgBy0AACIGQT9xQQFGGyAGQQFrQT9xaiIGOgAAIAYgB2ogBToAACAPIAhBAnRqIAZBAnRqIAQ2AgAgBCAKRyEFIARBAWohBCAFDQALIAAoAighDCAAKAJcIQoLIAlBIGsiBCAEQQggAUEBaiIFIAQgDWoiB2tBAWoiBiAGQQhPG0EAIAUgB08baiIHTw0AQRggACgCJGshBiAAKAJQIQggBCEFA0AgCyAFQQdxQQJ0aiAFIA1qKAAAQbHz3fF5bCAIcyAGdjYCACAFQQFqIgUgB0cNAAsLIAQgCUkEQCAAKAIEQQhqIRFBGCAAKAIkayEVA0AgCyAEQQdxQQJ0aiIHKAIAIQUgByAAKAJQIAQgEWooAABBsfPd8XlscyAVdjYCACAMIAVBAnZBwP///wNxIghqIgdBP0EAIActAAAiBkE/cUEBRhsgBkEBa0E/cWoiBjoAACAGIAdqIAU6AAAgCiAIQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAJSQ0ACwsgACAJNgIcIAsgCUEHcUECdGoiBCgCACEKIAQgGqcgCSANaigACEGx893xeWxzQRggFGt2NgIADAELIAEoAAAhBCAAIAk2AhwgGqcgBEGx893xeWxzQRggFGt2IQoLIAAgACgCWCAKajYCWCAOIApBAnZBwP///wNxIgRqIgYtAAAhCCAPIARBAnRqIQtBACEHAkAgCkH/AXFBgYKECGwiBCAGKAA8cyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxIAYoADggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAA0IARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoADAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAAsIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoACggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2cq1CCIYgBigAJCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAICAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAcIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoABQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoABAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAEIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdq2EIhpCf1ENACAQIAlBASAYdCIEayAQIAkgEGsgBEsbIBkbIQxBAUEGIBcgF0EGTxt0IQQgGkJ/hSAIrYohGgNAIBqnIgVoIBpCIIinaEEgcyAFGyAIakE/cSIFBEAgCyAFQQJ0aigCACIFIAxJDQIgEiAHQQJ0aiAFNgIAIAdBAWohByAEQQFrIQQLIBpCAX0gGoMiGlANASAEDQALCyAGIAhBAWtBP3FBP0EAIAhBP3FBAUYbaiIEOgAAIAQgBmogCjoAACAAIAAoAhwiBUEBajYCHCALIARBAnRqIAU2AgACQCAHRQRAQQMhCAwBCyATIBZqIREgDSATaiEVIAFBA2shCiAJQQNqIRAgAUEEaiEOIAJBAWshDyACQQNrIQlBACEFQQMhCANAAkAgCAJ/AkAgEyASIAVBAnRqKAIAIgZNBEAgBiANaiIAIAhqQQNrKAAAIAggCmooAABHDQMgASAJTwRAIAEhBAwCCyAAKAAAIgsgASIEKAAAIgxHBEAgCyAMc2hBA3YMAwsDQCAAQQRqIQAgBEEEaiIEIAlPDQIgACgAACILIAQoAAAiDEYNAAsgBCALIAxzaEEDdmogAWsMAgsgBiAWaiIEKAAAIAEoAABHDQIgDiAEQQRqIAIgESAVENALQQRqDAELAkAgBCAPTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAQIAZrNgIAIAQhCCABIARqIAJGDQILIAVBAWoiBSAHRw0ACwsgEkGAAmokACAIC+YMAhV/A34jAEGAAmsiEiQAIAEgACgCBCINayEJIAAoArgBIRcgACgCECEQIAAoAhghGCAAKAIMIRMgACgCCCEVIAAoAsQBIRYgACkDUCEaIAAoAiQhESAAKAIoIQ4gACgCXCEPAkAgACgC3AFFBEAgAEEsaiEIAkAgCSAAKAIcIgRrQYEDSQRAIA4hDCAPIQoMAQsgDiEMIA8hCiAEQZ9/TQRAIA1BCGohDCAEQd8AaiEKQTggEWutIRkDQCAIIARBB3FBAnRqIgcoAgAhBSAHIAApA1AgBCAMaikAAEKAgIDYy5vvjU9+hSAZiD4CACAOIAVBBHZB8P///wBxIgtqIgdBD0EAIActAAAiBkEPcUEBRhsgBkEBa0EPcWoiBjoAACAGIAdqIAU6AAAgDyALQQJ0aiAGQQJ0aiAENgIAIAQgCkchBSAEQQFqIQQgBQ0ACyAAKAIoIQwgACgCXCEKCyAJQSBrIgQgBEEIIAFBAWoiBSAEIA1qIgdrQQFqIgYgBkEITxtBACAFIAdPG2oiB08NAEE4IAAoAiRrrSEZIAApA1AhGyAEIQUDQCAIIAVBB3FBAnRqIAUgDWopAABCgICA2Mub741PfiAbhSAZiD4CACAFQQFqIgUgB0cNAAsLIAQgCUkEQCAAKAIEQQhqIRRBOCAAKAIka60hGQNAIAggBEEHcUECdGoiBygCACEFIAcgACkDUCAEIBRqKQAAQoCAgNjLm++NT36FIBmIPgIAIAwgBUEEdkHw////AHEiC2oiB0EPQQAgBy0AACIGQQ9xQQFGGyAGQQFrQQ9xaiIGOgAAIAYgB2ogBToAACAKIAtBAnRqIAZBAnRqIAQ2AgAgBEEBaiIEIAlJDQALCyAAIAk2AhwgCCAJQQdxQQJ0aiIEKAIAIQogBCAJIA1qKQAIQoCAgNjLm++NT34gGoVBOCARa62IPgIADAELIAEpAAAhGSAAIAk2AhwgGUKAgIDYy5vvjU9+IBqFQTggEWutiKchCgsgACAAKAJYIApqNgJYIA4gCkEEdkHw////AHEiBGoiCC0AACEGIA8gBEECdGohC0EAIQcCQCAKQf8BcUGBgoQIbCIEIAgoAAxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCCgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVB//8DRg0AIBAgCUEBIBd0IgRrIBAgCSAQayAESxsgGBshDEEBQQQgFiAWQQRPG3QhBCAFQX9zIgVB//8DcSAGQQ9xdiAFQQAgBmtBD3F0cq1C//8DgyEZA0BBACAZp2ggGVAbIAZqQQ9xIgUEQCALIAVBAnRqKAIAIgUgDEkNAiASIAdBAnRqIAU2AgAgB0EBaiEHIARBAWshBAsgGUIBfSAZgyIZUA0BIAQNAAsLIAggBkEBa0EPcUEPQQAgBkEPcUEBRhtqIgQ6AAAgBCAIaiAKOgAAIAAgACgCHCIFQQFqNgIcIAsgBEECdGogBTYCAAJAIAdFBEBBAyELDAELIBMgFWohFCANIBNqIRAgAUEDayEKIAlBA2ohDiABQQRqIQ8gAkEBayERIAJBA2shCUEAIQVBAyELA0ACQCALAn8CQCATIBIgBUECdGooAgAiBk0EQCAGIA1qIgAgC2pBA2soAAAgCiALaigAAEcNAyABIAlPBEAgASEEDAILIAAoAAAiCCABIgQoAAAiDEcEQCAIIAxzaEEDdgwDCwNAIABBBGohACAEQQRqIgQgCU8NAiAAKAAAIgggBCgAACIMRg0ACyAEIAggDHNoQQN2aiABawwCCyAGIBVqIgQoAAAgASgAAEcNAiAPIARBBGogAiAUIBAQ0AtBBGoMAQsCQCAEIBFPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIA4gBms2AgAgBCELIAEgBGogAkYNAgsgBUEBaiIFIAdHDQALCyASQYACaiQAIAsL/A0CFX8DfiMAQYACayITJAAgASAAKAIEIg5rIQkgACgCuAEhFyAAKAIQIREgACgCGCEYIAAoAgwhFCAAKAIIIRYgACgCxAEhEiAAKQNQIRogACgCJCEVIAAoAighDyAAKAJcIRACQCAAKALcAUUEQCAAQSxqIQgCQCAJIAAoAhwiBGtBgQNJBEAgDyEKIBAhDAwBCyAPIQogECEMIARBn39NBEAgDkEIaiEKIARB3wBqIQxBOCAVa60hGQNAIAggBEEHcUECdGoiBigCACEFIAYgACkDUCAEIApqKQAAQoCAgNjLm++NT36FIBmIPgIAIA8gBUEDdkHg////AXEiC2oiBkEfQQAgBi0AACIHQR9xQQFGGyAHQQFrQR9xaiIHOgAAIAYgB2ogBToAACAQIAtBAnRqIAdBAnRqIAQ2AgAgBCAMRyEFIARBAWohBCAFDQALIAAoAlwhDCAAKAIoIQoLIAlBIGsiBCAEQQggAUEBaiIFIAQgDmoiBmtBAWoiByAHQQhPG0EAIAUgBk8baiIGTw0AQTggACgCJGutIRkgACkDUCEbIAQhBQNAIAggBUEHcUECdGogBSAOaikAAEKAgIDYy5vvjU9+IBuFIBmIPgIAIAVBAWoiBSAGRw0ACwsgBCAJSQRAIAAoAgRBCGohDUE4IAAoAiRrrSEZA0AgCCAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgDWopAABCgICA2Mub741PfoUgGYg+AgAgCiAFQQN2QeD///8BcSILaiIGQR9BACAGLQAAIgdBH3FBAUYbIAdBAWtBH3FqIgc6AAAgBiAHaiAFOgAAIAwgC0ECdGogB0ECdGogBDYCACAEQQFqIgQgCUkNAAsLIAAgCTYCHCAIIAlBB3FBAnRqIgQoAgAhDSAEIAkgDmopAAhCgICA2Mub741PfiAahUE4IBVrrYg+AgAMAQsgASkAACEZIAAgCTYCHCAZQoCAgNjLm++NT34gGoVBOCAVa62IpyENCyAAIAAoAlggDWo2AlhBAyELIA8gDUEDdkHg////AXEiBGoiCC0AACEHIBAgBEECdGohCkEAIQYCQCANQf8BcUGBgoQIbCIEIAgoABxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCCgAGCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoABQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAECAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAwgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVBf0YNACARIAlBASAXdCIEayARIAkgEWsgBEsbIBgbIQxBAUEFIBIgEkEFTxt0IQQgBUF/cyAHeK0hGQNAQQAgGadoIBlQGyAHakEfcSIFBEAgCiAFQQJ0aigCACIFIAxJDQIgEyAGQQJ0aiAFNgIAIAZBAWohBiAEQQFrIQQLIBlCAX0gGYMiGVANASAEDQALCyAIIAdBAWtBH3FBH0EAIAdBH3FBAUYbaiIEOgAAIAQgCGogDToAACAAIAAoAhwiBUEBajYCHCAKIARBAnRqIAU2AgACQCAGRQ0AIBQgFmohDSAOIBRqIREgAUEDayEMIAlBA2ohDyABQQRqIRAgAkEBayESIAJBA2shCUEAIQUDQAJAIAsCfwJAIBQgEyAFQQJ0aigCACIHTQRAIAcgDmoiACALakEDaygAACALIAxqKAAARw0DIAEgCU8EQCABIQQMAgsgACgAACIIIAEiBCgAACIKRwRAIAggCnNoQQN2DAMLA0AgAEEEaiEAIARBBGoiBCAJTw0CIAAoAAAiCCAEKAAAIgpGDQALIAQgCCAKc2hBA3ZqIAFrDAILIAcgFmoiBCgAACABKAAARw0CIBAgBEEEaiACIA0gERDQC0EEagwBCwJAIAQgEk8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgDyAHazYCACAEIQsgASAEaiACRg0CCyAFQQFqIgUgBkcNAAsLIBNBgAJqJAAgCwuLEQIVfwN+IwBBgAJrIhIkACABIAAoAgQiDWshCSAAKAK4ASEXIAAoAhAhECAAKAIYIRggACgCDCETIAAoAgghFiAAKALEASERIAApA1AhGiAAKAIkIRQgACgCKCEOIAAoAlwhDwJAIAAoAtwBRQRAIABBLGohCwJAIAkgACgCHCIEa0GBA0kEQCAOIQwgDyEKDAELIA4hDCAPIQogBEGff00EQCANQQhqIQwgBEHfAGohCkE4IBRrrSEZA0AgCyAEQQdxQQJ0aiIHKAIAIQUgByAAKQNQIAQgDGopAABCgICA2Mub741PfoUgGYg+AgAgDiAFQQJ2QcD///8DcSIIaiIHQT9BACAHLQAAIgZBP3FBAUYbIAZBAWtBP3FqIgY6AAAgBiAHaiAFOgAAIA8gCEECdGogBkECdGogBDYCACAEIApHIQUgBEEBaiEEIAUNAAsgACgCKCEMIAAoAlwhCgsgCUEgayIEIARBCCABQQFqIgUgBCANaiIHa0EBaiIGIAZBCE8bQQAgBSAHTxtqIgdPDQBBOCAAKAIka60hGSAAKQNQIRsgBCEFA0AgCyAFQQdxQQJ0aiAFIA1qKQAAQoCAgNjLm++NT34gG4UgGYg+AgAgBUEBaiIFIAdHDQALCyAEIAlJBEAgACgCBEEIaiEVQTggACgCJGutIRkDQCALIARBB3FBAnRqIgcoAgAhBSAHIAApA1AgBCAVaikAAEKAgIDYy5vvjU9+hSAZiD4CACAMIAVBAnZBwP///wNxIghqIgdBP0EAIActAAAiBkE/cUEBRhsgBkEBa0E/cWoiBjoAACAGIAdqIAU6AAAgCiAIQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAJSQ0ACwsgACAJNgIcIAsgCUEHcUECdGoiBCgCACEKIAQgCSANaikACEKAgIDYy5vvjU9+IBqFQTggFGutiD4CAAwBCyABKQAAIRkgACAJNgIcIBlCgICA2Mub741PfiAahUE4IBRrrYinIQoLIAAgACgCWCAKajYCWCAOIApBAnZBwP///wNxIgRqIgYtAAAhCCAPIARBAnRqIQtBACEHAkAgCkH/AXFBgYKECGwiBCAGKAA8cyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxIAYoADggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAA0IARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoADAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAAsIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoACggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2cq1CCIYgBigAJCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAICAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAcIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoABQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoABAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAEIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdq2EIhlCf1ENACAQIAlBASAXdCIEayAQIAkgEGsgBEsbIBgbIQxBAUEGIBEgEUEGTxt0IQQgGUJ/hSAIrYohGQNAIBmnIgVoIBlCIIinaEEgcyAFGyAIakE/cSIFBEAgCyAFQQJ0aigCACIFIAxJDQIgEiAHQQJ0aiAFNgIAIAdBAWohByAEQQFrIQQLIBlCAX0gGYMiGVANASAEDQALCyAGIAhBAWtBP3FBP0EAIAhBP3FBAUYbaiIEOgAAIAQgBmogCjoAACAAIAAoAhwiBUEBajYCHCALIARBAnRqIAU2AgACQCAHRQRAQQMhCAwBCyATIBZqIRUgDSATaiEQIAFBA2shCiAJQQNqIQ4gAUEEaiEPIAJBAWshESACQQNrIQlBACEFQQMhCANAAkAgCAJ/AkAgEyASIAVBAnRqKAIAIgZNBEAgBiANaiIAIAhqQQNrKAAAIAggCmooAABHDQMgASAJTwRAIAEhBAwCCyAAKAAAIgsgASIEKAAAIgxHBEAgCyAMc2hBA3YMAwsDQCAAQQRqIQAgBEEEaiIEIAlPDQIgACgAACILIAQoAAAiDEYNAAsgBCALIAxzaEEDdmogAWsMAgsgBiAWaiIEKAAAIAEoAABHDQIgDyAEQQRqIAIgFSAQENALQQRqDAELAkAgBCARTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAOIAZrNgIAIAQhCCABIARqIAJGDQILIAVBAWoiBSAHRw0ACwsgEkGAAmokACAIC+YMAhV/A34jAEGAAmsiEiQAIAEgACgCBCINayEJIAAoArgBIRcgACgCECEQIAAoAhghGCAAKAIMIRMgACgCCCEVIAAoAsQBIRYgACkDUCEaIAAoAiQhESAAKAIoIQ4gACgCXCEPAkAgACgC3AFFBEAgAEEsaiEIAkAgCSAAKAIcIgRrQYEDSQRAIA4hDCAPIQoMAQsgDiEMIA8hCiAEQZ9/TQRAIA1BCGohDCAEQd8AaiEKQTggEWutIRkDQCAIIARBB3FBAnRqIgcoAgAhBSAHIAApA1AgBCAMaikAAEKAgOz8y5vvjU9+hSAZiD4CACAOIAVBBHZB8P///wBxIgtqIgdBD0EAIActAAAiBkEPcUEBRhsgBkEBa0EPcWoiBjoAACAGIAdqIAU6AAAgDyALQQJ0aiAGQQJ0aiAENgIAIAQgCkchBSAEQQFqIQQgBQ0ACyAAKAIoIQwgACgCXCEKCyAJQSBrIgQgBEEIIAFBAWoiBSAEIA1qIgdrQQFqIgYgBkEITxtBACAFIAdPG2oiB08NAEE4IAAoAiRrrSEZIAApA1AhGyAEIQUDQCAIIAVBB3FBAnRqIAUgDWopAABCgIDs/Mub741PfiAbhSAZiD4CACAFQQFqIgUgB0cNAAsLIAQgCUkEQCAAKAIEQQhqIRRBOCAAKAIka60hGQNAIAggBEEHcUECdGoiBygCACEFIAcgACkDUCAEIBRqKQAAQoCA7PzLm++NT36FIBmIPgIAIAwgBUEEdkHw////AHEiC2oiB0EPQQAgBy0AACIGQQ9xQQFGGyAGQQFrQQ9xaiIGOgAAIAYgB2ogBToAACAKIAtBAnRqIAZBAnRqIAQ2AgAgBEEBaiIEIAlJDQALCyAAIAk2AhwgCCAJQQdxQQJ0aiIEKAIAIQogBCAJIA1qKQAIQoCA7PzLm++NT34gGoVBOCARa62IPgIADAELIAEpAAAhGSAAIAk2AhwgGUKAgOz8y5vvjU9+IBqFQTggEWutiKchCgsgACAAKAJYIApqNgJYIA4gCkEEdkHw////AHEiBGoiCC0AACEGIA8gBEECdGohC0EAIQcCQCAKQf8BcUGBgoQIbCIEIAgoAAxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCCgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVB//8DRg0AIBAgCUEBIBd0IgRrIBAgCSAQayAESxsgGBshDEEBQQQgFiAWQQRPG3QhBCAFQX9zIgVB//8DcSAGQQ9xdiAFQQAgBmtBD3F0cq1C//8DgyEZA0BBACAZp2ggGVAbIAZqQQ9xIgUEQCALIAVBAnRqKAIAIgUgDEkNAiASIAdBAnRqIAU2AgAgB0EBaiEHIARBAWshBAsgGUIBfSAZgyIZUA0BIAQNAAsLIAggBkEBa0EPcUEPQQAgBkEPcUEBRhtqIgQ6AAAgBCAIaiAKOgAAIAAgACgCHCIFQQFqNgIcIAsgBEECdGogBTYCAAJAIAdFBEBBAyELDAELIBMgFWohFCANIBNqIRAgAUEDayEKIAlBA2ohDiABQQRqIQ8gAkEBayERIAJBA2shCUEAIQVBAyELA0ACQCALAn8CQCATIBIgBUECdGooAgAiBk0EQCAGIA1qIgAgC2pBA2soAAAgCiALaigAAEcNAyABIAlPBEAgASEEDAILIAAoAAAiCCABIgQoAAAiDEcEQCAIIAxzaEEDdgwDCwNAIABBBGohACAEQQRqIgQgCU8NAiAAKAAAIgggBCgAACIMRg0ACyAEIAggDHNoQQN2aiABawwCCyAGIBVqIgQoAAAgASgAAEcNAiAPIARBBGogAiAUIBAQ0AtBBGoMAQsCQCAEIBFPDQAgAC8AACAELwAARw0AIABBAmohACAEQQJqIQQLIAIgBEsEfyAEIAAtAAAgBC0AAEZqBSAECyABawsiBE8NACADIA4gBms2AgAgBCELIAEgBGogAkYNAgsgBUEBaiIFIAdHDQALCyASQYACaiQAIAsL/A0CFX8DfiMAQYACayITJAAgASAAKAIEIg5rIQkgACgCuAEhFyAAKAIQIREgACgCGCEYIAAoAgwhFCAAKAIIIRYgACgCxAEhEiAAKQNQIRogACgCJCEVIAAoAighDyAAKAJcIRACQCAAKALcAUUEQCAAQSxqIQgCQCAJIAAoAhwiBGtBgQNJBEAgDyEKIBAhDAwBCyAPIQogECEMIARBn39NBEAgDkEIaiEKIARB3wBqIQxBOCAVa60hGQNAIAggBEEHcUECdGoiBigCACEFIAYgACkDUCAEIApqKQAAQoCA7PzLm++NT36FIBmIPgIAIA8gBUEDdkHg////AXEiC2oiBkEfQQAgBi0AACIHQR9xQQFGGyAHQQFrQR9xaiIHOgAAIAYgB2ogBToAACAQIAtBAnRqIAdBAnRqIAQ2AgAgBCAMRyEFIARBAWohBCAFDQALIAAoAlwhDCAAKAIoIQoLIAlBIGsiBCAEQQggAUEBaiIFIAQgDmoiBmtBAWoiByAHQQhPG0EAIAUgBk8baiIGTw0AQTggACgCJGutIRkgACkDUCEbIAQhBQNAIAggBUEHcUECdGogBSAOaikAAEKAgOz8y5vvjU9+IBuFIBmIPgIAIAVBAWoiBSAGRw0ACwsgBCAJSQRAIAAoAgRBCGohDUE4IAAoAiRrrSEZA0AgCCAEQQdxQQJ0aiIGKAIAIQUgBiAAKQNQIAQgDWopAABCgIDs/Mub741PfoUgGYg+AgAgCiAFQQN2QeD///8BcSILaiIGQR9BACAGLQAAIgdBH3FBAUYbIAdBAWtBH3FqIgc6AAAgBiAHaiAFOgAAIAwgC0ECdGogB0ECdGogBDYCACAEQQFqIgQgCUkNAAsLIAAgCTYCHCAIIAlBB3FBAnRqIgQoAgAhDSAEIAkgDmopAAhCgIDs/Mub741PfiAahUE4IBVrrYg+AgAMAQsgASkAACEZIAAgCTYCHCAZQoCA7PzLm++NT34gGoVBOCAVa62IpyENCyAAIAAoAlggDWo2AlhBAyELIA8gDUEDdkHg////AXEiBGoiCC0AACEHIBAgBEECdGohCkEAIQYCQCANQf8BcUGBgoQIbCIEIAgoABxzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXEgCCgAGCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoABQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAECAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAwgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHZyQQh0IAgoAAQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABcXIgCCgAACAEcyIEQYCBgoR4ckGBgoQIayAEckGAgYKEeHFBgYGBAWxBHHZyIgVBf0YNACARIAlBASAXdCIEayARIAkgEWsgBEsbIBgbIQxBAUEFIBIgEkEFTxt0IQQgBUF/cyAHeK0hGQNAQQAgGadoIBlQGyAHakEfcSIFBEAgCiAFQQJ0aigCACIFIAxJDQIgEyAGQQJ0aiAFNgIAIAZBAWohBiAEQQFrIQQLIBlCAX0gGYMiGVANASAEDQALCyAIIAdBAWtBH3FBH0EAIAdBH3FBAUYbaiIEOgAAIAQgCGogDToAACAAIAAoAhwiBUEBajYCHCAKIARBAnRqIAU2AgACQCAGRQ0AIBQgFmohDSAOIBRqIREgAUEDayEMIAlBA2ohDyABQQRqIRAgAkEBayESIAJBA2shCUEAIQUDQAJAIAsCfwJAIBQgEyAFQQJ0aigCACIHTQRAIAcgDmoiACALakEDaygAACALIAxqKAAARw0DIAEgCU8EQCABIQQMAgsgACgAACIIIAEiBCgAACIKRwRAIAggCnNoQQN2DAMLA0AgAEEEaiEAIARBBGoiBCAJTw0CIAAoAAAiCCAEKAAAIgpGDQALIAQgCCAKc2hBA3ZqIAFrDAILIAcgFmoiBCgAACABKAAARw0CIBAgBEEEaiACIA0gERDQC0EEagwBCwJAIAQgEk8NACAALwAAIAQvAABHDQAgAEECaiEAIARBAmohBAsgAiAESwR/IAQgAC0AACAELQAARmoFIAQLIAFrCyIETw0AIAMgDyAHazYCACAEIQsgASAEaiACRg0CCyAFQQFqIgUgBkcNAAsLIBNBgAJqJAAgCwuLEQIVfwN+IwBBgAJrIhIkACABIAAoAgQiDWshCSAAKAK4ASEXIAAoAhAhECAAKAIYIRggACgCDCETIAAoAgghFiAAKALEASERIAApA1AhGiAAKAIkIRQgACgCKCEOIAAoAlwhDwJAIAAoAtwBRQRAIABBLGohCwJAIAkgACgCHCIEa0GBA0kEQCAOIQwgDyEKDAELIA4hDCAPIQogBEGff00EQCANQQhqIQwgBEHfAGohCkE4IBRrrSEZA0AgCyAEQQdxQQJ0aiIHKAIAIQUgByAAKQNQIAQgDGopAABCgIDs/Mub741PfoUgGYg+AgAgDiAFQQJ2QcD///8DcSIIaiIHQT9BACAHLQAAIgZBP3FBAUYbIAZBAWtBP3FqIgY6AAAgBiAHaiAFOgAAIA8gCEECdGogBkECdGogBDYCACAEIApHIQUgBEEBaiEEIAUNAAsgACgCKCEMIAAoAlwhCgsgCUEgayIEIARBCCABQQFqIgUgBCANaiIHa0EBaiIGIAZBCE8bQQAgBSAHTxtqIgdPDQBBOCAAKAIka60hGSAAKQNQIRsgBCEFA0AgCyAFQQdxQQJ0aiAFIA1qKQAAQoCA7PzLm++NT34gG4UgGYg+AgAgBUEBaiIFIAdHDQALCyAEIAlJBEAgACgCBEEIaiEVQTggACgCJGutIRkDQCALIARBB3FBAnRqIgcoAgAhBSAHIAApA1AgBCAVaikAAEKAgOz8y5vvjU9+hSAZiD4CACAMIAVBAnZBwP///wNxIghqIgdBP0EAIActAAAiBkE/cUEBRhsgBkEBa0E/cWoiBjoAACAGIAdqIAU6AAAgCiAIQQJ0aiAGQQJ0aiAENgIAIARBAWoiBCAJSQ0ACwsgACAJNgIcIAsgCUEHcUECdGoiBCgCACEKIAQgCSANaikACEKAgOz8y5vvjU9+IBqFQTggFGutiD4CAAwBCyABKQAAIRkgACAJNgIcIBlCgIDs/Mub741PfiAahUE4IBRrrYinIQoLIAAgACgCWCAKajYCWCAOIApBAnZBwP///wNxIgRqIgYtAAAhCCAPIARBAnRqIQtBACEHAkAgCkH/AXFBgYKECGwiBCAGKAA8cyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxIAYoADggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAA0IARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoADAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2ckEIdCAGKAAsIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXFyIAYoACggBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2cq1CCIYgBigAJCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigAICAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAcIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAYIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEcdq2EQgiGIAYoABQgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRh2QfABca2EIAYoABAgBHMiBUGAgYKEeHJBgYKECGsgBXJBgIGChHhxQYGBgQFsQRx2rYRCCIYgBigADCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBGHZB8AFxrYQgBigACCAEcyIFQYCBgoR4ckGBgoQIayAFckGAgYKEeHFBgYGBAWxBHHathEIIhiAGKAAEIARzIgVBgIGChHhyQYGChAhrIAVyQYCBgoR4cUGBgYEBbEEYdkHwAXGthCAGKAAAIARzIgRBgIGChHhyQYGChAhrIARyQYCBgoR4cUGBgYEBbEEcdq2EIhlCf1ENACAQIAlBASAXdCIEayAQIAkgEGsgBEsbIBgbIQxBAUEGIBEgEUEGTxt0IQQgGUJ/hSAIrYohGQNAIBmnIgVoIBlCIIinaEEgcyAFGyAIakE/cSIFBEAgCyAFQQJ0aigCACIFIAxJDQIgEiAHQQJ0aiAFNgIAIAdBAWohByAEQQFrIQQLIBlCAX0gGYMiGVANASAEDQALCyAGIAhBAWtBP3FBP0EAIAhBP3FBAUYbaiIEOgAAIAQgBmogCjoAACAAIAAoAhwiBUEBajYCHCALIARBAnRqIAU2AgACQCAHRQRAQQMhCAwBCyATIBZqIRUgDSATaiEQIAFBA2shCiAJQQNqIQ4gAUEEaiEPIAJBAWshESACQQNrIQlBACEFQQMhCANAAkAgCAJ/AkAgEyASIAVBAnRqKAIAIgZNBEAgBiANaiIAIAhqQQNrKAAAIAggCmooAABHDQMgASAJTwRAIAEhBAwCCyAAKAAAIgsgASIEKAAAIgxHBEAgCyAMc2hBA3YMAwsDQCAAQQRqIQAgBEEEaiIEIAlPDQIgACgAACILIAQoAAAiDEYNAAsgBCALIAxzaEEDdmogAWsMAgsgBiAWaiIEKAAAIAEoAABHDQIgDyAEQQRqIAIgFSAQENALQQRqDAELAkAgBCARTw0AIAAvAAAgBC8AAEcNACAAQQJqIQAgBEECaiEECyACIARLBH8gBCAALQAAIAQtAABGagUgBAsgAWsLIgRPDQAgAyAOIAZrNgIAIAQhCCABIARqIAJGDQILIAVBAWoiBSAHRw0ACwsgEkGAAmokACAIC6gOARV/IwBBEGsiDCQAIAIoAgQhECACKAIAIQYgAEEANgLcASADIAMgACgCBCIRIAAoAgwiD2oiFkZqIgUgAyAEaiIKQQhrIhNJBEAgACgCCCIUIAAoAhBqIRkgDyAUaiEXIApBIGshFUEBIAAoArgBdCESQQZBBCAAKALIASIEIARBBE0bIgQgBEEGTxtBBGshGANAIAVBAWohC0EAIQkCQCAGIAUgEWsiB0EBaiIEIAAoAhAiCCAEIBJrIAggBCAIayASSxsgACgCGBtrSw0AIAQgBmsiBCAPa0F8Sw0AIAsoAAAgFCARIAQgD0kiCBsgBGoiBCgAAEcNACAFQQVqIARBBGogCiAXIAogCBsgFhDQC0EEaiEJCyAMQf+T69wDNgIMAkACQAJ/AkACQAJAIBhBAWsOAgECAAsgACAFIAogDEEMahCVDAwCCyAAIAUgCiAMQQxqEJYMDAELIAAgBSAKIAxBDGoQlwwLIgQgCSAEIAlLIggbIg1BBE8EQCAFIAsgCBsiDiEEIAwoAgxBASAIGyIIIQsgDSEJAkAgBSATTw0AA0AgB0EBaiEHIAVBAWohBAJAIAhFBEBBACEIDAELIAYgByAAKAIQIgkgByASayAJIAcgCWsgEksbIAAoAhgba0sNACAHIAZrIgkgD2tBfEsNACAEKAAAIBQgESAJIA9JIgsbIAlqIgkoAABHDQAgBUEFaiAJQQRqIAogFyAKIAsbIBYQ0AsiBUF7Sw0AIAhnIA1BA2xqQR5rIAVBBGoiBUEDbE4NAEEBIQggBCEOIAUhDQsgDEH/k+vcAzYCCAJAAn8CQAJAAkAgGEEBaw4CAQIACyAAIAQgCiAMQQhqEJUMDAILIAAgBCAKIAxBCGoQlgwMAQsgACAEIAogDEEIahCXDAsiCUEESQ0AIAwoAggiC2cgCUECdGpBH2sgCGcgDUECdGpBG2tMDQAgCSENIAshCCAEIgUhDiAFIBNJDQEMAgsLIA4hBCAIIQsgDSEJCwJ/IAtBBEkEQCAGIQ0gEAwBCyALQQNrIQ0CQCADIARPDQAgFCARIAQgCyARamtBA2oiBSAPSSIHGyAFaiIFIBkgFiAHGyIITQ0AA0AgBEEBayIHLQAAIAVBAWsiBS0AAEcNASAJQQFqIQkgAyAHSQRAIAchBCAFIAhLDQELCyAHIQQLIAYLIQggBCADayEOIAEoAgwhBgJAAkAgBCAVTQRAIAYgA/0AAAD9CwAAIAEoAgwhBiAOQRBNBEAgASAGIA5qNgIMIAEoAgQhAwwDCyAGIAP9AAAQ/QsAECAOQSFIDQEgBiAOaiEFIANBEGohAyAGQSBqIQYDQCAGIAP9AAAQ/QsAACAGIAP9AAAg/QsAECADQSBqIQMgBkEgaiIGIAVJDQALDAELIAMgFU0EQCAGIAP9AAAA/QsAACAGIBUgA2siB2ohBSAHQRFOBEAgBkEQaiEGA0AgBiAD/QAAEP0LAAAgBiAD/QAAIP0LABAgA0EgaiEDIAZBIGoiBiAFSQ0ACwsgBSEGIBUhAwsgAyAETw0AQQAhByAEIAMiBWtBB3EiEARAA0AgBiAFLQAAOgAAIAZBAWohBiAFQQFqIQUgB0EBaiIHIBBHDQALCyADIARrQXhLDQADQCAGIAUtAAA6AAAgBiAFLQABOgABIAYgBS0AAjoAAiAGIAUtAAM6AAMgBiAFLQAEOgAEIAYgBS0ABToABSAGIAUtAAY6AAYgBiAFLQAHOgAHIAZBCGohBiAFQQhqIgUgBEcNAAsLIAEgASgCDCAOajYCDCABKAIEIQMgDkGAgARJDQAgAUEBNgIkIAEgAyABKAIAa0EDdTYCKAsgAyALNgIAIAMgDjsBBCAJQQNrIgZBgIAETwRAIAFBAjYCJCABIAMgASgCAGtBA3U2AigLIAMgBjsBBiABIANBCGoiBzYCBCAEIAlqIQMgACgC3AEEQCAAQQA2AtwBCyAIIRAgDSEGIBMgAyIFSQ0CA0AgCCEGIA0hCCAGIAMgEWsiBSAAKAIQIgQgBSASayAEIAUgBGsgEksbIAAoAhgba0sNAiAFIAZrIgUgD2tBfEsNAiADKAAAIBQgESAFIA9JIgQbIAVqIgUoAABHDQIgA0EEaiAFQQRqIAogFyAKIAQbIBYQ0AshBSADIBVNBEAgASgCDCAD/QAAAP0LAAAgASgCBCEHCyAHQQE2AgAgB0EAOwEEIAVBAWoiBEGAgARPBEAgAUECNgIkIAEgByABKAIAa0EDdTYCKAsgByAEOwEGIAEgB0EIaiIHNgIEIAYhDSAIIRAgAyAFakEEaiIDIQUgAyATTQ0ACwwCCyAAIAUgA2siBEH/EUs2AtwBIAUgBEEIdmpBAWohBQwBCyAGIRAgCCEGIAMhBQsgBSATSQ0ACwsgAiAQNgIEIAIgBjYCACAMQRBqJAAgCiADawuuFAIZfwJ+IwBBEGsiCyQAIAIoAgQhEiACKAIAIQYgAEEANgLcASAAKALEASINQQRLIRhBBkEEIAAoAsgBIgUgBUEETRsiBSAFQQZPGyEZIAMgAyAAKAIEIg8gACgCDCIQaiIXRmohBSAAKAIcIgcgB0EIIAMgBGoiCUEPayIcIAcgD2oiBGsiCCAIQQhPG0EAIAQgCUEQayITTRtqIghJBEAgAEEsaiERQRggACgCJCIEayEMQTggBGutIR4gACkDUCIfpyEOIBlBBWshCgNAIAcgD2ohBCARIAdBB3FBAnRqAn8CQAJAAkAgCg4CAQIACyAEKAAAQbHz3fF5bCAOcyAMdgwCCyAEKQAAQoCAgNjLm++NT34gH4UgHoinDAELIAQpAABCgIDs/Mub741PfiAfhSAeiKcLNgIAIAdBAWoiByAIRw0ACwsgBSATSQRAQQYgDUEEIBgbIgcgB0EGTxshFCAAKAIIIhUgACgCEGohHSAQIBVqIRogAEEsaiEYIAlBIGshFkEBIAAoArgBdCERIBlBBGshGwNAIAVBAWohDAJ/QQAgBiAFIA9rIghBAWoiBCAAKAIQIgogBCARayAKIAQgCmsgEUsbIAAoAhgba0sNABpBACAEIAZrIgQgEGtBfEsNABpBACAMKAAAIBUgDyAEIBBJIgobIARqIgQoAABHDQAaIAVBBWogBEEEaiAJIBogCSAKGyAXENALQQRqCyEHIAtB/5Pr3AM2AgwCQAJAAn8CQAJAAkAgG0EBaw4CAQIACwJAAkACQCAUQQVrDgIBAgALIAAgBSAJIAtBDGoQmQwMBAsgACAFIAkgC0EMahCaDAwDCyAAIAUgCSALQQxqEJsMDAILAkACQAJAIBRBBWsOAgECAAsgACAFIAkgC0EMahCcDAwDCyAAIAUgCSALQQxqEJ0MDAILIAAgBSAJIAtBDGoQngwMAQsCQAJAAkAgFEEFaw4CAQIACyAAIAUgCSALQQxqEJ8MDAILIAAgBSAJIAtBDGoQoAwMAQsgACAFIAkgC0EMahChDAsiBCAHIAQgB0siChsiDkEETwRAIAUgDCAKGyINIQcgCygCDEEBIAobIgohDCAOIQQCQCAFIBNPDQADQCAIQQFqIQggBUEBaiEHAkAgCkUEQEEAIQoMAQsgBiAIIAAoAhAiBCAIIBFrIAQgCCAEayARSxsgACgCGBtrSw0AIAggBmsiBCAQa0F8Sw0AIAcoAAAgFSAPIAQgEEkiDBsgBGoiBCgAAEcNACAFQQVqIARBBGogCSAaIAkgDBsgFxDQCyIFQXtLDQAgCmcgDkEDbGpBHmsgBUEEaiIFQQNsTg0AQQEhCiAHIQ0gBSEOCyALQf+T69wDNgIIAkACfwJAAkACQCAbQQFrDgIBAgALAkACQAJAIBRBBWsOAgECAAsgACAHIAkgC0EIahCZDAwECyAAIAcgCSALQQhqEJoMDAMLIAAgByAJIAtBCGoQmwwMAgsCQAJAAkAgFEEFaw4CAQIACyAAIAcgCSALQQhqEJwMDAMLIAAgByAJIAtBCGoQnQwMAgsgACAHIAkgC0EIahCeDAwBCwJAAkACQCAUQQVrDgIBAgALIAAgByAJIAtBCGoQnwwMAgsgACAHIAkgC0EIahCgDAwBCyAAIAcgCSALQQhqEKEMCyIEQQRJDQAgCygCCCIMZyAEQQJ0akEfayAKZyAOQQJ0akEba0wNACAEIQ4gDCEKIAciBSENIAUgE0kNAQwCCwsgDSEHIAohDCAOIQQLAn8gDEEESQRAIAYhDiASDAELIAxBA2shDgJAIAMgB08NACAVIA8gByAMIA9qa0EDaiIFIBBJIggbIAVqIgUgHSAXIAgbIgpNDQADQCAHQQFrIggtAAAgBUEBayIFLQAARw0BIARBAWohBCADIAhJBEAgCCEHIAUgCksNAQsLIAghBwsgBgshCiAHIANrIQ0gASgCDCEGAkACQCAHIBZNBEAgBiAD/QAAAP0LAAAgASgCDCEGIA1BEE0EQCABIAYgDWo2AgwgASgCBCEDDAMLIAYgA/0AABD9CwAQIA1BIUgNASAGIA1qIQUgA0EQaiEDIAZBIGohBgNAIAYgA/0AABD9CwAAIAYgA/0AACD9CwAQIANBIGohAyAGQSBqIgYgBUkNAAsMAQsgAyAWTQRAIAYgA/0AAAD9CwAAIAYgFiADayIIaiEFIAhBEU4EQCAGQRBqIQYDQCAGIAP9AAAQ/QsAACAGIAP9AAAg/QsAECADQSBqIQMgBkEgaiIGIAVJDQALCyAFIQYgFiEDCyADIAdPDQBBACEIIAcgAyIFa0EHcSISBEADQCAGIAUtAAA6AAAgBkEBaiEGIAVBAWohBSAIQQFqIgggEkcNAAsLIAMgB2tBeEsNAANAIAYgBS0AADoAACAGIAUtAAE6AAEgBiAFLQACOgACIAYgBS0AAzoAAyAGIAUtAAQ6AAQgBiAFLQAFOgAFIAYgBS0ABjoABiAGIAUtAAc6AAcgBkEIaiEGIAVBCGoiBSAHRw0ACwsgASABKAIMIA1qNgIMIAEoAgQhAyANQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAw2AgAgAyANOwEEIARBA2siBkGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAGOwEGIAEgA0EIaiIINgIEIAQgB2ohAyAAKALcAQRAIAAoAhwiBiAGQQggHCAGIA9qIgVrIgcgB0EITxtBACAFIBNNG2oiB0kEQEEYIAAoAiQiBWshBEE4IAVrrSEeIAApA1AiH6chDANAIAYgD2ohBSAYIAZBB3FBAnRqAn8CQAJAAkAgGUEFaw4CAQIACyAFKAAAQbHz3fF5bCAMcyAEdgwCCyAFKQAAQoCAgNjLm++NT34gH4UgHoinDAELIAUpAABCgIDs/Mub741PfiAfhSAeiKcLNgIAIAZBAWoiBiAHRw0ACwsgAEEANgLcAQsgCiESIA4hBiATIAMiBUkNAgNAIAohBiAOIQogBiADIA9rIgUgACgCECIHIAUgEWsgByAFIAdrIBFLGyAAKAIYG2tLDQIgBSAGayIFIBBrQXxLDQIgAygAACAVIA8gBSAQSSIHGyAFaiIFKAAARw0CIANBBGogBUEEaiAJIBogCSAHGyAXENALIQUgAyAWTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhCAsgCEEBNgIAIAhBADsBBCAFQQFqIgdBgIAETwRAIAFBAjYCJCABIAggASgCAGtBA3U2AigLIAggBzsBBiABIAhBCGoiCDYCBCAGIQ4gCiESIAMgBWpBBGoiAyEFIAMgE00NAAsMAgsgACAFIANrIgdB/xFLNgLcASAFIAdBCHZqQQFqIQUMAQsgBiESIAohBiADIQULIAUgE0kNAAsLIAIgEjYCBCACIAY2AgAgC0EQaiQAIAkgA2sL1xABFn8jAEEQayIOJAAgAigCBCEPIAIoAgAhBiAAQQA2AtwBIAMgAyAAKAIEIhEgACgCDCIQaiIVRmoiBSADIARqIg1BCGsiE0kEQCAAKAIIIhQgACgCEGohGiAQIBRqIRcgDUEgayEWQQEgACgCuAF0IRJBBkEEIAAoAsgBIgQgBEEETRsiBCAEQQZPG0EEayEYA0AgBUEBaiEHQQAhCQJAIAYgBSARayIKQQFqIgQgACgCECILIAQgEmsgCyAEIAtrIBJLGyAAKAIYG2tLDQAgBCAGayIEIBBrQXxLDQAgBygAACAUIBEgBCAQSSILGyAEaiIEKAAARw0AIAVBBWogBEEEaiANIBcgDSALGyAVENALQQRqIQkLIA5B/5Pr3AM2AgwCQAJAAn8CQAJAAkAgGEEBaw4CAQIACyAAIAUgDSAOQQxqEJUMDAILIAAgBSANIA5BDGoQlgwMAQsgACAFIA0gDkEMahCXDAsiBCAJIAQgCUsiCBsiCUEETwRAIAUgByAIGyELIA4oAgxBASAIGyEEAkAgBSATTw0AA0AgCkEBaiEHIAVBAWohCAJAIARFBEBBACEEDAELIAYgByAAKAIQIgwgByASayAMIAcgDGsgEksbIAAoAhgba0sNACAHIAZrIgwgEGtBfEsNACAIKAAAIBQgESAMIBBJIhkbIAxqIgwoAABHDQAgBUEFaiAMQQRqIA0gFyANIBkbIBUQ0AsiDEF7Sw0AIARnIAlBA2xqQR5rIAxBBGoiDEEDbE4NAEEBIQQgCCELIAwhCQsgDkH/k+vcAzYCCAJ/AkACfwJAAkACQCAYQQFrDgIBAgALIAAgCCANIA5BCGoQlQwMAgsgACAIIA0gDkEIahCWDAwBCyAAIAggDSAOQQhqEJcMCyIMQQRJDQAgDigCCCIZZyAMQQJ0akEfayAEZyAJQQJ0akEba0wNACAHIQogCCEFIAwhCSAZDAELIAggE08NAiAKQQJqIQogBUECaiEIAkAgBEUEQEEAIQQMAQsgBiAKIAAoAhAiByAKIBJrIAcgCiAHayASSxsgACgCGBtrSw0AIAogBmsiByAQa0F8Sw0AIAgoAAAgFCARIAcgEEkiDBsgB2oiBygAAEcNACAFQQZqIAdBBGogDSAXIA0gDBsgFRDQCyIFQXtLDQAgBGcgCUECdGpBHmsgBUEEaiIFQQJ0Tg0AQQEhBCAIIQsgBSEJCyAOQf+T69wDNgIEAn8CQAJAAkAgGEEBaw4CAQIACyAAIAggDSAOQQRqEJUMDAILIAAgCCANIA5BBGoQlgwMAQsgACAIIA0gDkEEahCXDAsiB0EESQ0CIA4oAgQiDGcgB0ECdGpBH2sgBGcgCUECdGpBGGtMDQIgCCEFIAchCSAMCyEEIAUhCyAFIBNJDQALCwJ/IARBBEkEQCAGIQcgDwwBCyAEQQNrIQcCQCADIAtPDQAgFCARIAsgBCARamtBA2oiBSAQSSIKGyAFaiIFIBogFSAKGyIITQ0AA0AgC0EBayIKLQAAIAVBAWsiBS0AAEcNASAJQQFqIQkgAyAKSQRAIAohCyAFIAhLDQELCyAKIQsLIAYLIQogCyADayEPIAEoAgwhBQJAAkAgCyAWTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSAPQRBNBEAgASAFIA9qNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECAPQSFIDQEgBSAPaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgFk0EQCAFIAP9AAAA/QsAACAFIBYgA2siCGohBiAIQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBYhAwsgAyALTw0AQQAhCCADIQYgCyADa0EHcSIMBEADQCAFIAYtAAA6AAAgBUEBaiEFIAZBAWohBiAIQQFqIgggDEcNAAsLIAMgC2tBeEsNAANAIAUgBi0AADoAACAFIAYtAAE6AAEgBSAGLQACOgACIAUgBi0AAzoAAyAFIAYtAAQ6AAQgBSAGLQAFOgAFIAUgBi0ABjoABiAFIAYtAAc6AAcgBUEIaiEFIAZBCGoiBiALRw0ACwsgASABKAIMIA9qNgIMIAEoAgQhAyAPQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAQ2AgAgAyAPOwEEIAlBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIENgIEIAkgC2ohAyAAKALcAQRAIABBADYC3AELIAohDyAHIQYgEyADIgVJDQIDQCAKIQYgByEKIAYgAyARayIFIAAoAhAiCSAFIBJrIAkgBSAJayASSxsgACgCGBtrSw0CIAUgBmsiBSAQa0F8Sw0CIAMoAAAgFCARIAUgEEkiCRsgBWoiBSgAAEcNAiADQQRqIAVBBGogDSAXIA0gCRsgFRDQCyEFIAMgFk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQQLIARBATYCACAEQQA7AQQgBUEBaiIJQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAk7AQYgASAEQQhqIgQ2AgQgBiEHIAohDyADIAVqQQRqIgMhBSADIBNNDQALDAILIAAgBSADayIEQf8RSzYC3AEgBSAEQQh2akEBaiEFDAELIAYhDyAKIQYgAyEFCyAFIBNJDQALCyACIA82AgQgAiAGNgIAIA5BEGokACANIANrC/QXAhp/An4jAEEQayILJAAgAigCBCEQIAIoAgAhBiAAQQA2AtwBIAAoAsQBIhZBBEshD0EGQQQgACgCyAEiBSAFQQRNGyIFIAVBBk8bIRogAyADIAAoAgQiESAAKAIMIhJqIhdGaiEFIAAoAhwiCCAIQQggAyAEaiIJQQ9rIhwgCCARaiIEayINIA1BCE8bQQAgBCAJQRBrIhRNG2oiDUkEQCAAQSxqIQpBGCAAKAIkIgRrIQxBOCAEa60hHyAAKQNQIiCnIQcgGkEFayEOA0AgCCARaiEEIAogCEEHcUECdGoCfwJAAkACQCAODgIBAgALIAQoAABBsfPd8XlsIAdzIAx2DAILIAQpAABCgICA2Mub741PfiAghSAfiKcMAQsgBCkAAEKAgOz8y5vvjU9+ICCFIB+Ipws2AgAgCEEBaiIIIA1HDQALCyAFIBRJBEBBBiAWQQQgDxsiCCAIQQZPGyETIAAoAggiFSAAKAIQaiEdIBIgFWohGSAAQSxqIR4gCUEgayEYQQEgACgCuAF0IQQgGkEEayEbA0AgBUEBaiEMAn9BACAGIAUgEWsiDUEBaiIKIAAoAhAiDiAKIARrIA4gCiAOayAESxsgACgCGBtrSw0AGkEAIAogBmsiCiASa0F8Sw0AGkEAIAwoAAAgFSARIAogEkkiDhsgCmoiCigAAEcNABogBUEFaiAKQQRqIAkgGSAJIA4bIBcQ0AtBBGoLIQggC0H/k+vcAzYCDAJAAkACfwJAAkACQCAbQQFrDgIBAgALAkACQAJAIBNBBWsOAgECAAsgACAFIAkgC0EMahCZDAwECyAAIAUgCSALQQxqEJoMDAMLIAAgBSAJIAtBDGoQmwwMAgsCQAJAAkAgE0EFaw4CAQIACyAAIAUgCSALQQxqEJwMDAMLIAAgBSAJIAtBDGoQnQwMAgsgACAFIAkgC0EMahCeDAwBCwJAAkACQCATQQVrDgIBAgALIAAgBSAJIAtBDGoQnwwMAgsgACAFIAkgC0EMahCgDAwBCyAAIAUgCSALQQxqEKEMCyIKIAggCCAKSSIHGyIKQQRPBEAgBSAMIAcbIQ4gCygCDEEBIAcbIQgCQCAFIBRPDQADQCANQQFqIQwgBUEBaiEHAkAgCEUEQEEAIQgMAQsgBiAMIAAoAhAiDyAMIARrIA8gDCAPayAESxsgACgCGBtrSw0AIAwgBmsiDyASa0F8Sw0AIAcoAAAgFSARIA8gEkkiFhsgD2oiDygAAEcNACAFQQVqIA9BBGogCSAZIAkgFhsgFxDQCyIPQXtLDQAgCGcgCkEDbGpBHmsgD0EEaiIPQQNsTg0AQQEhCCAHIQ4gDyEKCyALQf+T69wDNgIIAn8CQAJ/AkACQAJAIBtBAWsOAgECAAsCQAJAAkAgE0EFaw4CAQIACyAAIAcgCSALQQhqEJkMDAQLIAAgByAJIAtBCGoQmgwMAwsgACAHIAkgC0EIahCbDAwCCwJAAkACQCATQQVrDgIBAgALIAAgByAJIAtBCGoQnAwMAwsgACAHIAkgC0EIahCdDAwCCyAAIAcgCSALQQhqEJ4MDAELAkACQAJAIBNBBWsOAgECAAsgACAHIAkgC0EIahCfDAwCCyAAIAcgCSALQQhqEKAMDAELIAAgByAJIAtBCGoQoQwLIg9BBEkNACALKAIIIhZnIA9BAnRqQR9rIAhnIApBAnRqQRtrTA0AIAwhDSAWIQggDyEKIAcMAQsgByAUTw0CIA1BAmohDSAFQQJqIQcCQCAIRQRAQQAhCAwBCyAGIA0gACgCECIMIA0gBGsgDCANIAxrIARLGyAAKAIYG2tLDQAgDSAGayIMIBJrQXxLDQAgBygAACAVIBEgDCASSSIPGyAMaiIMKAAARw0AIAVBBmogDEEEaiAJIBkgCSAPGyAXENALIgVBe0sNACAIZyAKQQJ0akEeayAFQQRqIgVBAnRODQBBASEIIAchDiAFIQoLIAtB/5Pr3AM2AgQCfwJAAkACQCAbQQFrDgIBAgALAkACQAJAIBNBBWsOAgECAAsgACAHIAkgC0EEahCZDAwECyAAIAcgCSALQQRqEJoMDAMLIAAgByAJIAtBBGoQmwwMAgsCQAJAAkAgE0EFaw4CAQIACyAAIAcgCSALQQRqEJwMDAMLIAAgByAJIAtBBGoQnQwMAgsgACAHIAkgC0EEahCeDAwBCwJAAkACQCATQQVrDgIBAgALIAAgByAJIAtBBGoQnwwMAgsgACAHIAkgC0EEahCgDAwBCyAAIAcgCSALQQRqEKEMCyIMQQRJDQIgCygCBCIPZyAMQQJ0akEfayAIZyAKQQJ0akEYa0wNAiAPIQggDCEKIAcLIgUhDiAFIBRJDQALCwJ/IAhBBEkEQCAGIQwgEAwBCyAIQQNrIQwCQCADIA5PDQAgFSARIA4gCCARamtBA2oiBSASSSINGyAFaiIFIB0gFyANGyIHTQ0AA0AgDkEBayINLQAAIAVBAWsiBS0AAEcNASAKQQFqIQogAyANSQRAIA0hDiAFIAdLDQELCyANIQ4LIAYLIQ0gDiADayEQIAEoAgwhBQJAAkAgDiAYTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSAQQRBNBEAgASAFIBBqNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECAQQSFIDQEgBSAQaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgGE0EQCAFIAP9AAAA/QsAACAFIBggA2siB2ohBiAHQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBghAwsgAyAOTw0AQQAhByADIQYgDiADa0EHcSIPBEADQCAFIAYtAAA6AAAgBUEBaiEFIAZBAWohBiAHQQFqIgcgD0cNAAsLIAMgDmtBeEsNAANAIAUgBi0AADoAACAFIAYtAAE6AAEgBSAGLQACOgACIAUgBi0AAzoAAyAFIAYtAAQ6AAQgBSAGLQAFOgAFIAUgBi0ABjoABiAFIAYtAAc6AAcgBUEIaiEFIAZBCGoiBiAORw0ACwsgASABKAIMIBBqNgIMIAEoAgQhAyAQQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAg2AgAgAyAQOwEEIApBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIINgIEIAogDmohAyAAKALcAQRAIAAoAhwiBSAFQQggHCAFIBFqIgZrIgogCkEITxtBACAGIBRNG2oiCkkEQEEYIAAoAiQiBmshDkE4IAZrrSEfIAApA1AiIKchBwNAIAUgEWohBiAeIAVBB3FBAnRqAn8CQAJAAkAgGkEFaw4CAQIACyAGKAAAQbHz3fF5bCAHcyAOdgwCCyAGKQAAQoCAgNjLm++NT34gIIUgH4inDAELIAYpAABCgIDs/Mub741PfiAghSAfiKcLNgIAIAVBAWoiBSAKRw0ACwsgAEEANgLcAQsgDSEQIAwhBiAUIAMiBUkNAgNAIA0hBiAMIQ0gBiADIBFrIgUgACgCECIKIAUgBGsgCiAFIAprIARLGyAAKAIYG2tLDQIgBSAGayIFIBJrQXxLDQIgAygAACAVIBEgBSASSSIKGyAFaiIFKAAARw0CIANBBGogBUEEaiAJIBkgCSAKGyAXENALIQUgAyAYTQRAIAEoAgwgA/0AAAD9CwAAIAEoAgQhCAsgCEEBNgIAIAhBADsBBCAFQQFqIgpBgIAETwRAIAFBAjYCJCABIAggASgCAGtBA3U2AigLIAggCjsBBiABIAhBCGoiCDYCBCAGIQwgDSEQIAMgBWpBBGoiAyEFIAMgFE0NAAsMAgsgACAFIANrIghB/xFLNgLcASAFIAhBCHZqQQFqIQUMAQsgBiEQIA0hBiADIQULIAUgFEkNAAsLIAIgEDYCBCACIAY2AgAgC0EQaiQAIAkgA2sL1xABFn8jAEEQayIOJAAgAigCBCEPIAIoAgAhBiAAQQA2AtwBIAMgAyAAKAIEIhEgACgCDCIQaiIVRmoiBSADIARqIg1BCGsiE0kEQCAAKAIIIhQgACgCEGohGiAQIBRqIRcgDUEgayEWQQEgACgCuAF0IRJBBkEEIAAoAsgBIgQgBEEETRsiBCAEQQZPG0EEayEYA0AgBUEBaiEHQQAhCQJAIAYgBSARayIKQQFqIgQgACgCECILIAQgEmsgCyAEIAtrIBJLGyAAKAIYG2tLDQAgBCAGayIEIBBrQXxLDQAgBygAACAUIBEgBCAQSSILGyAEaiIEKAAARw0AIAVBBWogBEEEaiANIBcgDSALGyAVENALQQRqIQkLIA5B/5Pr3AM2AgwCQAJAAn8CQAJAAkAgGEEBaw4CAQIACyAAIAUgDSAOQQxqEKcMDAILIAAgBSANIA5BDGoQqAwMAQsgACAFIA0gDkEMahCpDAsiBCAJIAQgCUsiCBsiCUEETwRAIAUgByAIGyELIA4oAgxBASAIGyEEAkAgBSATTw0AA0AgCkEBaiEHIAVBAWohCAJAIARFBEBBACEEDAELIAYgByAAKAIQIgwgByASayAMIAcgDGsgEksbIAAoAhgba0sNACAHIAZrIgwgEGtBfEsNACAIKAAAIBQgESAMIBBJIhkbIAxqIgwoAABHDQAgBUEFaiAMQQRqIA0gFyANIBkbIBUQ0AsiDEF7Sw0AIARnIAlBA2xqQR5rIAxBBGoiDEEDbE4NAEEBIQQgCCELIAwhCQsgDkH/k+vcAzYCCAJ/AkACfwJAAkACQCAYQQFrDgIBAgALIAAgCCANIA5BCGoQpwwMAgsgACAIIA0gDkEIahCoDAwBCyAAIAggDSAOQQhqEKkMCyIMQQRJDQAgDigCCCIZZyAMQQJ0akEfayAEZyAJQQJ0akEba0wNACAHIQogCCEFIAwhCSAZDAELIAggE08NAiAKQQJqIQogBUECaiEIAkAgBEUEQEEAIQQMAQsgBiAKIAAoAhAiByAKIBJrIAcgCiAHayASSxsgACgCGBtrSw0AIAogBmsiByAQa0F8Sw0AIAgoAAAgFCARIAcgEEkiDBsgB2oiBygAAEcNACAFQQZqIAdBBGogDSAXIA0gDBsgFRDQCyIFQXtLDQAgBGcgCUECdGpBHmsgBUEEaiIFQQJ0Tg0AQQEhBCAIIQsgBSEJCyAOQf+T69wDNgIEAn8CQAJAAkAgGEEBaw4CAQIACyAAIAggDSAOQQRqEKcMDAILIAAgCCANIA5BBGoQqAwMAQsgACAIIA0gDkEEahCpDAsiB0EESQ0CIA4oAgQiDGcgB0ECdGpBH2sgBGcgCUECdGpBGGtMDQIgCCEFIAchCSAMCyEEIAUhCyAFIBNJDQALCwJ/IARBBEkEQCAGIQcgDwwBCyAEQQNrIQcCQCADIAtPDQAgFCARIAsgBCARamtBA2oiBSAQSSIKGyAFaiIFIBogFSAKGyIITQ0AA0AgC0EBayIKLQAAIAVBAWsiBS0AAEcNASAJQQFqIQkgAyAKSQRAIAohCyAFIAhLDQELCyAKIQsLIAYLIQogCyADayEPIAEoAgwhBQJAAkAgCyAWTQRAIAUgA/0AAAD9CwAAIAEoAgwhBSAPQRBNBEAgASAFIA9qNgIMIAEoAgQhAwwDCyAFIAP9AAAQ/QsAECAPQSFIDQEgBSAPaiEGIANBEGohAyAFQSBqIQUDQCAFIAP9AAAQ/QsAACAFIAP9AAAg/QsAECADQSBqIQMgBUEgaiIFIAZJDQALDAELIAMgFk0EQCAFIAP9AAAA/QsAACAFIBYgA2siCGohBiAIQRFOBEAgBUEQaiEFA0AgBSAD/QAAEP0LAAAgBSAD/QAAIP0LABAgA0EgaiEDIAVBIGoiBSAGSQ0ACwsgBiEFIBYhAwsgAyALTw0AQQAhCCADIQYgCyADa0EHcSIMBEADQCAFIAYtAAA6AAAgBUEBaiEFIAZBAWohBiAIQQFqIgggDEcNAAsLIAMgC2tBeEsNAANAIAUgBi0AADoAACAFIAYtAAE6AAEgBSAGLQACOgACIAUgBi0AAzoAAyAFIAYtAAQ6AAQgBSAGLQAFOgAFIAUgBi0ABjoABiAFIAYtAAc6AAcgBUEIaiEFIAZBCGoiBiALRw0ACwsgASABKAIMIA9qNgIMIAEoAgQhAyAPQYCABEkNACABQQE2AiQgASADIAEoAgBrQQN1NgIoCyADIAQ2AgAgAyAPOwEEIAlBA2siBUGAgARPBEAgAUECNgIkIAEgAyABKAIAa0EDdTYCKAsgAyAFOwEGIAEgA0EIaiIENgIEIAkgC2ohAyAAKALcAQRAIABBADYC3AELIAohDyAHIQYgEyADIgVJDQIDQCAKIQYgByEKIAYgAyARayIFIAAoAhAiCSAFIBJrIAkgBSAJayASSxsgACgCGBtrSw0CIAUgBmsiBSAQa0F8Sw0CIAMoAAAgFCARIAUgEEkiCRsgBWoiBSgAAEcNAiADQQRqIAVBBGogDSAXIA0gCRsgFRDQCyEFIAMgFk0EQCABKAIMIAP9AAAA/QsAACABKAIEIQQLIARBATYCACAEQQA7AQQgBUEBaiIJQYCABE8EQCABQQI2AiQgASAEIAEoAgBrQQN1NgIoCyAEIAk7AQYgASAEQQhqIgQ2AgQgBiEHIAohDyADIAVqQQRqIgMhBSADIBNNDQALDAILIAAgBSADayIEQf8RSzYC3AEgBSAEQQh2akEBaiEFDAELIAYhDyAKIQYgAyEFCyAFIBNJDQALCyACIA82AgQgAiAGNgIAIA5BEGokACANIANrC94CAQp/IAAoAgQiByAAKAIcIgRqIgYgAU0EfwJAIAQgASAHayINTw0AQX8gACgCvAFBAWt0QX9zIQggACgCZCEJIAAoAlwhCiAEQX9zIAFqIQVBICAAKALAAWshCyABIAZrQQFxBEAgCiAGKAAAQbHz3fF5bCALdkECdGoiBigCACEMIAYgBDYCACAJIAQgCHFBA3RqIgZBATYCBCAGIAw2AgAgBEEBaiEECyAFIAdGDQADQCAKIAQgB2ooAABBsfPd8XlsIAt2QQJ0aiIFKAIAIQYgBSAENgIAIAkgBCAIcUEDdGoiBUEBNgIEIAUgBjYCACAKIAcgBEEBaiIFaigAAEGx893xeWwgC3ZBAnRqIgYoAgAhDCAGIAU2AgAgCSAFIAhxQQN0aiIFQQE2AgQgBSAMNgIAIARBAmoiBCANSQ0ACwsgACANNgIcIAAgASACIANBBEEBEI8MBSAFCwvxAgIJfwF+IAAoAgQiByAAKAIcIgRqIgYgAU0EfwJAIAQgASAHayIMTw0AQX8gACgCvAFBAWt0QX9zIQggACgCZCEJIAAoAlwhCiAEQX9zIAFqIQVBwAAgACgCwAFrrSENIAEgBmtBAXEEQCAKIAYpAABCgICA2Mub741PfiANiKdBAnRqIgYoAgAhCyAGIAQ2AgAgCSAEIAhxQQN0aiIGQQE2AgQgBiALNgIAIARBAWohBAsgBSAHRg0AA0AgCiAEIAdqKQAAQoCAgNjLm++NT34gDYinQQJ0aiIFKAIAIQYgBSAENgIAIAkgBCAIcUEDdGoiBUEBNgIEIAUgBjYCACAKIAcgBEEBaiIFaikAAEKAgIDYy5vvjU9+IA2Ip0ECdGoiBigCACELIAYgBTYCACAJIAUgCHFBA3RqIgVBATYCBCAFIAs2AgAgBEECaiIEIAxJDQALCyAAIAw2AhwgACABIAIgA0EFQQEQjwwFIAULC/ECAgl/AX4gACgCBCIHIAAoAhwiBGoiBiABTQR/AkAgBCABIAdrIgxPDQBBfyAAKAK8AUEBa3RBf3MhCCAAKAJkIQkgACgCXCEKIARBf3MgAWohBUHAACAAKALAAWutIQ0gASAGa0EBcQRAIAogBikAAEKAgOz8y5vvjU9+IA2Ip0ECdGoiBigCACELIAYgBDYCACAJIAQgCHFBA3RqIgZBATYCBCAGIAs2AgAgBEEBaiEECyAFIAdGDQADQCAKIAQgB2opAABCgIDs/Mub741PfiANiKdBAnRqIgUoAgAhBiAFIAQ2AgAgCSAEIAhxQQN0aiIFQQE2AgQgBSAGNgIAIAogByAEQQFqIgVqKQAAQoCA7PzLm++NT34gDYinQQJ0aiIGKAIAIQsgBiAFNgIAIAkgBSAIcUEDdGoiBUEBNgIEIAUgCzYCACAEQQJqIgQgDEkNAAsLIAAgDDYCHCAAIAEgAiADQQZBARCPDAUgBQsL9QYBGH8jAEEQayIRJAAgACgCwAEhBiAAKAJcIQcgBwJ/AkACQAJAIARBBWsOAgECAAsgASgAAEGx893xeWxBICAGa3YMAgsgASkAAEKAgIDYy5vvjU9+QcAAIAZrrYinDAELIAEpAABCgIDs/Mub741PfkHAACAGa62IpwtBAnRqIgcoAgAhBCAAKAIIIRIgACgCDCENIAAoAmQhFiAAKAK8ASEJIAAoAsQBIQsgACgCGCEIIAAoArgBIQ4gACgCECEGIAcgASAAKAIEIg9rIgw2AgAgFiAMQX8gCUEBa3RBf3MiF3FBA3RqIQpBASEAAkAgBiADQQEgDnQiB2sgBiADIAZrIAdLGyAIGyIaIARLBEAgCkIANwIADAELIAwgF2siAEEAIAAgDE0bIRggCkEEaiEQIA0gD2ohGyANIBJqIRwgDEEJaiEDIAJBAWshHSACQQNrIQ5BASALdCEZQQghCUEAIQsDQCABIBMgCyALIBNLGyIHaiEIAn8CfwJAIAVBACAEIAdqIA1JG0UEQCAEIA9qIAdqIQYgCCAOTwRAIAghAAwCCyAGKAAAIhQgCCIAKAAAIhVHBEAgFCAVc2hBA3YMAwsDQCAGQQRqIQYgAEEEaiIAIA5PDQIgBigAACIUIAAoAAAiFUYNAAsgACAUIBVzaEEDdmogCGsMAgsgEiAPIAggBCASaiAHaiACIBwgGxDQCyAHaiIAIARqIgYgDUkbDAILAkAgACAdTw0AIAYvAAAgAC8AAEcNACAGQQJqIQYgAEECaiEACyAAIAJJBH8gACAGLQAAIAAtAABGagUgAAsgCGsLIAdqIgAgBGohBiAPCyEHIAYgAyAAIAMgBGtLGyADIAAgCUsiBhshAyAAIAkgBhshCQJAIAAgAWoiCCACRg0AIBYgBCAXcUEDdGohBgJAAkAgBCAHaiAAai0AACAILQAASQRAIAogBDYCACAEIBhLDQEgEUEMaiEKDAMLIBAgBDYCACAEIBhLBEAgACELIAYhEAwCCyARQQxqIRAMAgsgACETIAZBBGoiCiEGCyAZQQFrIhlFDQAgBigCACIEIBpPDQELCyAQQQA2AgAgCkEANgIAIAMgDGtBCGshACAJQYEDSQ0AQcABIAlBgANrIgQgBEHAAU8bIgQgACAAIARJGyEACyARQRBqJAAgAAsRACAAIAEgAiADIARBABCsDAuPIAImfwF+IwBBQGoiCCQAIAAoAgwhByAAKAIEIQkgACgCzAEhCiAAKALIASEGIAggACgCHDYCPCAAKAKAASETIAAoAoQBIQ0gCEEANgI4IAhCADcDMCAFQQR0QQYgBiAGQQZPG0EDa0EAIAZBA08bQQJ0akHQjTJqIQsgAEHwAGohHyAHIAlqIQcgAyAEaiIUQQhrIRsCQCAAKALUASIFBEAgCCAFKAIQNgIgIAggBf0AAgD9CwMQDAELIAhBADYCICAI/QwAAAAAAAAAAAAAAAAAAAAA/QsDEAsgCygCACEgIAhCADcCJCAIQQA2AiwgCEEQakEAIAQQrQwgHyADIARBABCuDCAbIAMgAyAHRmoiEUsEQEH/HyAKIApB/x9PGyEhQQNBBCAGQQNGGyIVQQNxISUgFEEgayEYIA1BHGohJiANQRBqISIgFUEBa0EDcSEnIAMhCwNAIAggEyAAIAhBPGogESAUIAIgCyARRiAVICARCgA2AgAgCEEQaiATIAggESADayAUIBFrIBUQrwwCQCAIKAIAIhlFBEAgEUEBaiERDAELIA0gESALayIHNgIMIA1BADYCCCANAn9BgD4gB0EBamdBCHRrIAAoAqgBQQFGDQAaIAdBgIAIRgRAIAAoApwBIAAoAnQoAowBQQFqZ0EIdGpBgBxrDAELIAAoApwBIAdBwABPBH9BMiAHZ2sFIAdBwJAyai0AAAsiBkGQkDJqLQAAIAAoAnQgBkECdGooAgBBAWpnakEIdGpBgD5rCzYCACAiIAJBCGoiIygCADYCCCAiIAIpAgA3AgACQCANAn8CQCAhIBMgGUEDdGoiBEEEaygCACIGSQRAIARBCGsoAgAhCUEAIQ4MAQtBASEGQQAhBSAlQQFHBEADQCANIAZBHGxqIgQgBiAHajYCDCAEQQA2AgggBEGAgICABDYCACAGQQFqIQYgBUEBaiIFICdHDQALC0EAIRYgFSEGA0AgEyAWQQN0aiIEKAIEIgogBk8EQEGzhH9BHyAEKAIAIgxnayIJQQl0Qc3HAWsgCUETTRshHSAAKAKoAUEBRiEQA0ACfwJ/AkAgEEUEQCAAKAJ8IAlBAnRqKAIAQQFqZyEHIAZBA2siBEGAAUkNAUHDACAEZ2sMAgsgDSgCACEHIA0gBkEcbGoiBEEANgIMIAQgDDYCBCAEIAY2AgggByAJIAZBAmtna0EIdGpBgN4AaiEHQQAMAgsgBEHAkTJqLQAACyEFIAAoAqQBIQ8gACgCeCAFQQJ0aigCACEOIA0oAgAhEiAAKAKgASEXIA0gBkEcbGoiBEEANgIMIAQgDDYCBCAEIAY2AgggEiAXIA8gHWpqaiAOQQFqZyAFQYCRMmotAAAgByAJampqQQh0aiEHIAAoApwBIAAoAnQoAgBBAWpnQQh0akGAPmsLIQUgBCAFIAdqNgIAIAZBAWoiBiAKTQ0ACwsgFkEBaiIWIBlHDQALIA0gBkEcbGpBgICAgAQ2AgBBASEOQQAhHkEAIQUCQAJAAkAgBkEBayIERQ0AA0AgDiARaiEHIA0gDkEcbGoiBkEQaygCACIKQQFqIQUgBkEcayIJKAIAIQwgACgCqAEhEAJ/AkACQCAAKAKwAUECRwRAIBBBAUYEQCAMQYAMaiEMDAMLQYA+IAAoAnAgB0EBay0AAEECdGooAgBBAWpnQQh0ayIQIAAoApgBIg9BgAJrIhJLBEAgEiEQCyAPIBBrIAxqIQwMAQsgDEGAEGohDCAQQQFGDQELAn8CQAJAIAVBgIAIRgRAIAAoApwBIg9BgD5rIRIgDyAAKAJ0IhAoAowBQQFqZ0EIdGpBgBxrIQ8MAQsgACgCnAEiF0GAPmsiEiAFQcAATwR/QTIgBWdrBSAFQcCQMmotAAALIg9BkJAyai0AACAAKAJ0IhAgD0ECdGooAgBBAWpnakEIdGohDyAKQYCACEYEQCAXIBAoAowBQQFqZ0EIdGpBgBxrDAULIApBwABJDQELQTIgCmdrDAELIApBwJAyai0AAAsiCkGQkDJqLQAAIBAgCkECdGooAgBBAWpnakEIdCASagwBC0GAPiAKQQJqZ0EIdGshD0GAPiAFZ0EIdGsLIRACQCAMIA8gEGtqIgwgBigCACIKSgRAIAYoAgwhBQwBCyAGIAn9AAIA/QsCACAGIAkoAhg2AhggBiAJKQIQNwIQIAYgBTYCDCAGIAw2AgAgDCEKCyAFRQRAIA0gDiAGKAIIa0EcbGoiCSgCDCEPIAYoAgQhDCAIQQhqIhAgCSgCGDYCACAIIAkpAhA3AwACQAJAIAxBBE8EQCAIIAgpAwA3AgQgDEEDayEJDAELAn8CQAJAIAwgD0VqQQFrIgwOBAQBAQABCyAIKAIAIg9BAWsMAQsgCCgCACEPIAggDEECdGooAgALIQkgCCAQIAhBBHIgDEEBRhsoAgA2AgggCCAPNgIECyAIIAk2AgALIAYgCCkDADcCECAGIBAoAgA2AhgLAkAgByAbSw0AIAQgDkYEQCAOIQUMAwsgBigCHCAKQYABakwNACAFRSEFQQAhCSAAKAKoAUEBRwRAIAAoApwBIAAoAnQoAgBBAWpnQQh0akGAPmshCQsgCCATIAAgCEE8aiAHIBQgBkEQaiAFIBUgIBEKADYCACAIQRBqIBMgCCAHIANrIBQgB2sgFRCvDCAIKAIAIiRFDQAgEyAkQQN0aiIMQQRrKAIAIgYgDmohBSAGICFLDQMgBUH/H0sNAyAGIAdqIBRPDQMgCSAKaiEWQQAhGgNAIBUhEiATIBpBA3RqIgYoAgQiCiErIBoEQCAGQQRrKAIAQQFqIRILAkAgKyASSQ0AQbOEf0EfIAYoAgAiHWdrIg9BCXRBzccBayAPQRNNGyEoIAogHmohKSAKIA5qISpBACEMIAAoAqgBQQFHIRcDQCAXBH8gACgCfCAPQQJ0aigCAEEBamchBSAAKAKgASAoIAAoAqQBamogACgCeAJ/IApBA2siBkGAAU8EQEHDACAGZ2sMAQsgBkHAkTJqLQAACyIGQQJ0aigCAEEBamcgBkGAkTJqLQAAIAUgD2pqakEIdGoFIA8gCkECa2drQQh0QYDeAGoLIBZqIRACQCAEIAogDmoiCUkEQCApIAQgDGoiBWshGUEAIQYgKiAFa0EDcSIHBEADQCANIARBAWoiBEEcbGoiBUEBNgIMIAVBgICAgAQ2AgAgBkEBaiIGIAdHDQALCyAZQQNJDQEDQCANIARBHGxqIgZBATYCYCAGQYCAgIAENgJUIAZBATYCRCAGQYCAgIAENgI4IAZBATYCKCAGQYCAgIAENgIcIAZBgICAgAQ2AnAgBkEBNgJ8IARBBGoiBCAJSQ0ACwwBCyAQIA0gCUEcbGooAgBODQILIA0gCUEcbGoiBkEANgIMIAYgHTYCBCAGIAo2AgggBiAQNgIAIAxBAWohDCAKQQFrIgogEk8NAAsLIBpBAWoiGiAkRw0ACyAmIARBHGxqQYCAgIAENgIACyAeQQFqIR4gBCEFIA5BAWoiDiAETQ0ACwsgDSAFQRxsaiIEKAIMIQcgBCgCBCEJIAQoAgAhHCAEKAIIIQYgCEE4aiIKIAQoAhg2AgAgCCAEKQIQNwMwIAZFDQQgBSAGayEOIAdFDQEgBEEQaiIEKQIAISwgIyAEKAIINgIAIAIgLDcCACANIA4gB2siDkEcbGoiBEFAa0EANgIAIAQgBzYCRCAEIBw2AhwgBCAJNgIgIAQgBjYCJCAEIAc2AiggBCAIKQMwNwIsIAQgCigCADYCNCAOQQJqDAMLIAZFDQMgDEEIaygCACEJCyANIA5BHGxqKAIMIQcLIAhBCGoiBCANIA5BHGxqIgUoAhg2AgAgCCAFKQIQNwMAAkACQCAJQQRPBEAgCCAIKQMANwIEIAlBA2shBQwBCwJ/AkACQCAJIAdFakEBayIHDgQEAQEAAQsgCCgCACIKQQFrDAELIAgoAgAhCiAIIAdBAnRqKAIACyEFIAggBCAIQQRyIAdBAUYbKAIANgIIIAggCjYCBAsgCCAFNgIACyACIAgpAwA3AgAgIyAEKAIANgIAQQAhByAOQQJqCyIPQRxsaiIEIAc2AgwgBCAGNgIIIAQgCTYCBCAEIBw2AgAgBCAIKQMwNwIQIAQgCCgCODYCGCANIA5BHGxqIgYoAgghByAGKQIAISwgBigCDCEJIAhBCGoiCiAGKAIYNgIAIAggBikCEDcDACAEIAk2AgwgDyEFAkAgBwRAA0AgDSAFQQFrIgVBHGxqIgYgCTYCDCAGIAc2AgggBiAsNwIAIAYgCCkDADcCECAGIAooAgA2AhggDSAOIAcgCWprIg5BHGxqIgQoAgghByAEKQIAISwgBCgCDCEJIAogBCgCGDYCACAIIAQpAhA3AwAgBiAJNgIMIAcNAAsgBSAPSw0BCwNAIA0gBUEcbGoiBigCDCEHIAYoAggiDAR/IB8gByALIAYoAgQiECAMELAMIAEoAgwhBgJAAkAgGCAHIAtqIglPBEAgBiAL/QAAAP0LAAAgASgCDCEEIAdBEE0EQCABIAQgB2o2AgwgASgCBCEGDAMLIAQgC/0AABD9CwAQIAdBIUgNASAEIAdqIQogC0EQaiEGIARBIGohBANAIAQgBv0AABD9CwAAIAQgBv0AACD9CwAQIAZBIGohBiAEQSBqIgQgCkkNAAsMAQsgCyAYTQRAIAYgC/0AAAD9CwAAIAYgGCALayIKaiEEIApBEU4EQCAGQRBqIQYDQCAGIAv9AAAQ/QsAACAGIAv9AAAg/QsAECALQSBqIQsgBkEgaiIGIARJDQALCyAEIQYgGCELCyAJIAtNDQAgCSALayIKQQFrIQ5BACEEIApBB3EiCgRAA0AgBiALLQAAOgAAIAZBAWohBiALQQFqIQsgBEEBaiIEIApHDQALCyAOQQdJDQADQCAGIAstAAA6AAAgBiALLQABOgABIAYgCy0AAjoAAiAGIAstAAM6AAMgBiALLQAEOgAEIAYgCy0ABToABSAGIAstAAY6AAYgBiALLQAHOgAHIAZBCGohBiALQQhqIgsgCUcNAAsLIAEgASgCDCAHajYCDCABKAIEIQYgB0GAgARJDQAgAUEBNgIkIAEgBiABKAIAa0EDdTYCKAsgBiAQNgIAIAYgBzsBBCAMQQNrIgRBgIAETwRAIAFBAjYCJCABIAYgASgCAGtBA3U2AigLIAYgBDsBBiABIAZBCGo2AgQgCSAMaiILBSAHIAtqCyERIAVBAWoiBSAPTQ0ACwsgACgCsAFBAkcEQCAAQYA+IAAoAogBQQFqZ0EIdGs2ApgBCyAAQYA+IAAoApQBQQFqZ0EIdGs2AqQBIABBgD4gACgCkAFBAWpnQQh0azYCoAEgAEGAPiAAKAKMAUEBamdBCHRrNgKcAQwBCyAFIBFqIRELIBEgG0kNAAsgCyEDCyAIQUBrJAAgFCADawu2AwEIfwJAIAAoAgwiBgRAIAAoAgQiAyAGSQ0BCyAAQn83AhQPCwJAAkACQCACIAAoAgAiCSADQQxsaiIHKAIEIgQgACgCCCIFayIIQQAgBCAITxsiCE0EQCAAQn83AhQCQCACIAVqIgJFDQADQCADIAZGDQEgAiAJIANBDGxqIgEoAgggASgCBGoiAUkNAyAAIANBAWoiAzYCBCACIAFrIgINAAsLIABBADYCCA8LIAcoAgghCiAAIAcoAgA2AhwgACABIAhqIgc2AhQgACAHIAogBSAEayIEQQAgBCAFTRtrIgpqIgQ2AhggASACaiIBIARJBEAgACABNgIYAkAgAiAFaiICRQ0AA0AgAyAGRg0BIAIgCSADQQxsaiIBKAIIIAEoAgRqIgFJDQQgACADQQFqIgM2AgQgAiABayICDQALCyAAQQA2AggPCwJAIAUgCGogCmoiAkUNAANAIAMgBkYNASACIAkgA0EMbGoiASgCCCABKAIEaiIBSQ0EIAAgA0EBaiIDNgIEIAIgAWsiAg0ACwsgAEEANgIIDwsgACACNgIIDwsgACACNgIIDwsgACACNgIIC/MgASN/IABBADYCOCAAKAJAIQQCQAJAIAAoAhxFBEAgAkEITQRAIABBATYCOAsgACgCPCIGKAKECEECRgRAQQAhASAAQQA2AjggBEECRwRAIABBADYCGCAGQQRqIQUgACgCACECA0AgAiABQQJ0agJ/AkAgASAGLQABSw0AIAUgAUECdGooAgBB/wFxIgRFDQBBAUELIARrdAwBC0EBCyIENgIAIAAgACgCGCAEajYCGCABQQFqIgFBgAJHDQALCyAGLwC4GSEEQQAhASAAQQA2AhwgBkEBIARBAWt0QQEgBBtBAnRqQbwZaiEEIAAoAgQhAgNAIAIgAUECdGpBAUEBQQogBCABQQN0aigCBEH//wNqIgVBEHZrdCAFQYCABEkbIgU2AgAgACAFIAAoAhxqNgIcIAIgAUEBciIFQQJ0akEBQQFBCiAEIAVBA3RqKAIEQf//A2oiBUEQdmt0IAVBgIAESRsiBTYCACAAIAUgACgCHGo2AhwgAUECaiIBQSRHDQALIAYvAIwOIQRBACEBIABBADYCICAGQQEgBEEBa3RBASAEG0ECdGpBkA5qIQQgACgCCCECA0AgAiABQQJ0akEBQQFBCiAEIAFBA3RqKAIEQf//A2oiBUEQdmt0IAVBgIAESRsiBTYCACAAIAUgACgCIGo2AiAgAUE0RkUEQCACIAFBAXIiBUECdGpBAUEBQQogBCAFQQN0aigCBEH//wNqIgVBEHZrdCAFQYCABEkbIgU2AgAgACAFIAAoAiBqNgIgIAFBAmohAQwBCwsgBi8AiAghBEEAIQEgAEEANgIkIAZBASAEQQFrdEEBIAQbQQJ0akGMCGohBCAAKAIMIQIDQCACIAFBAnRqQQFBAUEKIAQgAUEDdGooAgRB//8DaiIFQRB2a3QgBUGAgARJGyIFNgIAIAAgBSAAKAIkajYCJCACIAFBAXIiBUECdGpBAUEBQQogBCAFQQN0aigCBEH//wNqIgVBEHZrdCAFQYCABEkbIgU2AgAgACAFIAAoAiRqIgU2AiQgAUECaiIBQSBHDQALDAMLIARBAkcEQCAAKAIAIgRBAEGACPwLAAJAIAJFDQAgASACaiEFA0AgBCABLQAAQQJ0aiICIAIoAgBBAWo2AgAgAUEBaiIBIAVJDQALQf8BIQFBACECA0AgAiIGQQFqIQIgASIFQQFrIQEgBCAFQQJ0aigCAEUNAAsgBUEDSQ0AQYACIAZrQXxxIQRBACEBA0AgAUEEaiIBIARHDQALCyAAKAIAIgZBBGohCUEAIQFBACEEA0AgBiABQQJ0IgJqIgUgBSgCACIFQQh2IAVBAEdqIgU2AgAgAiAJaiICIAIoAgAiAkEIdiACQQBHaiICNgIAIAIgBCAFamohBCABQf4BRyECIAFBAmohASACDQALIAAgBDYCGAsgACgCBEGAjjJBkAH8CgAAIABBKDYCHCAAKAIIIgFBATYC0AEgAUKBgICAEDcCyAEgAUKBgICAEDcCwAEgAUKBgICAEDcCuAEgAUKBgICAEDcCsAEgAUKBgICAEDcCqAEgAUKBgICAEDcCoAEgAUKBgICAEDcCmAEgAUKBgICAEDcCkAEgAUKBgICAEDcCiAEgAUKBgICAEDcCgAEgAUKBgICAEDcCeCABQoGAgIAQNwJwIAFCgYCAgBA3AmggAUKBgICAEDcCYCABQoGAgIAQNwJYIAFCgYCAgBA3AlAgAUKBgICAEDcCSCABQoGAgIAQNwJAIAFCgYCAgBA3AjggAUKBgICAEDcCMCABQoGAgIAQNwIoIAFCgYCAgBA3AiAgAUKBgICAEDcCGCABQoGAgIAQNwIQIAFCgYCAgBA3AgggAUKBgICAEDcCAEE1IQUgAEE1NgIgIAAoAgxBkI8yQYAB/AoAAAwBCyAEQQJHBEAgACgCACIGQQxqIQkgBkEIaiEKIAZBBGohB0EAIQQDQCAJIARBAnQiAUEQciICaigCACACIApqKAIAIAIgB2ooAgAgAiAGaigCACABIAlqKAIAIAEgCmooAgAgASAHaigCACABIAZqKAIAIAVqampqampqaiEFIARB+AFHIQEgBEEIaiEEIAENAAsgBUGAwABPBEAgBUEMdmdBH3MhAUEAIQRBACEFA0AgBiAEQQJ0IgJqIgggCCgCACABdkEBaiIINgIAIAIgB2oiCyALKAIAIAF2QQFqIgs2AgAgAiAKaiIMIAwoAgAgAXZBAWoiDDYCACACIAlqIgIgAigCACABdkEBaiICNgIAIAIgDCALIAUgCGpqamohBSAEQfwBRyECIARBBGohBCACDQALCyAAIAU2AhgLIAAgACgCBCIBKAKMASABKAKIASABKAKEASABKAKAASABKAJ8IAEoAnggASgCdCABKAJwIAEoAmwgASgCaCABKAJkIAEoAmAgASgCXCABKAJYIAEoAlQgASgCUCABKAJMIAEoAkggASgCRCABKAJAIAEoAjwgASgCOCABKAI0IAEoAjAgASgCLCABKAIoIAEoAiQgASgCICABKAIcIAEoAhggASgCFCABKAIQIAEoAgwgASgCCCABKAIEIAEoAgBqampqampqampqampqampqampqampqampqampqampqampqaiIEQYAgTwR/IAEgASgCACAEQQt2Z0EfcyIEdkEBaiICNgIAIAEgASgCBCAEdkEBaiIFNgIEIAEgASgCCCAEdkEBaiIGNgIIIAEgASgCDCAEdkEBaiIJNgIMIAEgASgCECAEdkEBaiIKNgIQIAEgASgCFCAEdkEBaiIHNgIUIAEgASgCGCAEdkEBaiIINgIYIAEgASgCHCAEdkEBaiILNgIcIAEgASgCICAEdkEBaiIMNgIgIAEgASgCJCAEdkEBaiINNgIkIAEgASgCKCAEdkEBaiIONgIoIAEgASgCLCAEdkEBaiIPNgIsIAEgASgCMCAEdkEBaiIQNgIwIAEgASgCNCAEdkEBaiIRNgI0IAEgASgCOCAEdkEBaiISNgI4IAEgASgCPCAEdkEBaiITNgI8IAEgASgCQCAEdkEBaiIUNgJAIAEgASgCRCAEdkEBaiIVNgJEIAEgASgCSCAEdkEBaiIWNgJIIAEgASgCTCAEdkEBaiIXNgJMIAEgASgCUCAEdkEBaiIYNgJQIAEgASgCVCAEdkEBaiIZNgJUIAEgASgCWCAEdkEBaiIaNgJYIAEgASgCXCAEdkEBaiIbNgJcIAEgASgCYCAEdkEBaiIcNgJgIAEgASgCZCAEdkEBaiIdNgJkIAEgASgCaCAEdkEBaiIeNgJoIAEgASgCbCAEdkEBaiIfNgJsIAEgASgCcCAEdkEBaiIgNgJwIAEgASgCdCAEdkEBaiIhNgJ0IAEgASgCeCAEdkEBaiIiNgJ4IAEgASgCfCAEdkEBaiIjNgJ8IAEgASgCgAEgBHZBAWoiJDYCgAEgASABKAKEASAEdkEBaiIlNgKEASABIAEoAogBIAR2QQFqIiY2AogBIAEgASgCjAEgBHZBAWoiBDYCjAEgBCAmICUgJCAjICIgISAgIB8gHiAdIBwgGyAaIBkgGCAXIBYgFSAUIBMgEiARIBAgDyAOIA0gDCALIAggByAKIAkgBiACIAVqampqampqampqampqampqampqampqampqampqampqampqagUgBAs2AhwgACgCCCIFQQxqIQYgBUEIaiEJIAVBBGohCkEAIQdBACEBA0AgBSABQQRyQQJ0IgJqKAIAIAYgAUECdCIEaigCACAEIAlqKAIAIAQgCmooAgAgBCAFaigCACAHampqamohBCABQTBGRQRAIAIgBmooAgAgAiAJaigCACACIApqKAIAIARqamohByABQQhqIQEMAQsLAkAgBEGAIEkNACAEQQt2Z0EfcyECQQAhAUEAIQQDQCAFIAFBAnQiB2oiCCAIKAIAIAJ2QQFqIgg2AgAgBCAIaiEEIAFBNEYNASAHIApqIgggCCgCACACdkEBaiIINgIAIAcgCWoiCyALKAIAIAJ2QQFqIgs2AgAgBiAHaiIHIAcoAgAgAnZBAWoiBzYCACAHIAsgBCAIampqIQQgAUEEaiEBDAALAAsgACAENgIgIAAoAgwiASgCfCABKAJ4IAEoAnQgASgCcCABKAJsIAEoAmggASgCZCABKAJgIAEoAlwgASgCWCABKAJUIAEoAlAgASgCTCABKAJIIAEoAkQgASgCQCABKAI8IAEoAjggASgCNCABKAIwIAEoAiwgASgCKCABKAIkIAEoAiAgASgCHCABKAIYIAEoAhQgASgCECABKAIMIAEoAgggASgCBCABKAIAampqampqampqampqampqampqampqampqampqampqaiIFQYAgSQ0AIAEgASgCACAFQQt2Z0EfcyIEdkEBaiICNgIAIAEgASgCBCAEdkEBaiIFNgIEIAEgASgCCCAEdkEBaiIGNgIIIAEgASgCDCAEdkEBaiIJNgIMIAEgASgCECAEdkEBaiIKNgIQIAEgASgCFCAEdkEBaiIHNgIUIAEgASgCGCAEdkEBaiIINgIYIAEgASgCHCAEdkEBaiILNgIcIAEgASgCICAEdkEBaiIMNgIgIAEgASgCJCAEdkEBaiINNgIkIAEgASgCKCAEdkEBaiIONgIoIAEgASgCLCAEdkEBaiIPNgIsIAEgASgCMCAEdkEBaiIQNgIwIAEgASgCNCAEdkEBaiIRNgI0IAEgASgCOCAEdkEBaiISNgI4IAEgASgCPCAEdkEBaiITNgI8IAEgASgCQCAEdkEBaiIUNgJAIAEgASgCRCAEdkEBaiIVNgJEIAEgASgCSCAEdkEBaiIWNgJIIAEgASgCTCAEdkEBaiIXNgJMIAEgASgCUCAEdkEBaiIYNgJQIAEgASgCVCAEdkEBaiIZNgJUIAEgASgCWCAEdkEBaiIaNgJYIAEgASgCXCAEdkEBaiIbNgJcIAEgASgCYCAEdkEBaiIcNgJgIAEgASgCZCAEdkEBaiIdNgJkIAEgASgCaCAEdkEBaiIeNgJoIAEgASgCbCAEdkEBaiIfNgJsIAEgASgCcCAEdkEBaiIgNgJwIAEgASgCdCAEdkEBaiIhNgJ0IAEgASgCeCAEdkEBaiIiNgJ4IAEgASgCfCAEdkEBaiIENgJ8IAQgIiAhICAgHyAeIB0gHCAbIBogGSAYIBcgFiAVIBQgEyASIBEgECAPIA4gDSAMIAsgCCAHIAogCSAGIAIgBWpqampqampqampqampqampqampqampqampqampqamohBQsgACAFNgIkCyAAKAJAQQJHBEAgACgCGEEBaiIEZyEBIAACfyADBEBBHyABayIBQQh0IARBCHQgAXZqDAELQYA+IAFBCHRrCzYCKAsgACgCHEEBaiIEZyEBAn8gAwRAQR8gAWsiAUEIdCAEQQh0IAF2aiEBQR8gBUEBaiIEZ2siAkEIdCAEQQh0IAJ2aiEEQR8gACgCIEEBaiICZ2siBUEIdCACQQh0IAV2agwBC0GAPiABQQh0ayEBQYA+IAVBAWpnQQh0ayEEQYA+IAAoAiBBAWpnQQh0awshAiAAIAQ2AjQgACACNgIwIAAgATYCLAuVAgEFfwJAIAAoAgwiCUUNACAAKAIEIgcgCU8NACAAKAIYIgYgA00EQCADIAZLBEACQCAAKAIIIAMgBmtqIgZFDQADQCAHIAlGDQEgACgCACAHQQxsaiIIKAIIIAgoAgRqIgggBksEQCAGIQoMAgsgACAHQQFqIgc2AgQgBiAIayIGDQALCyAAIAo2AggLIAAgAyAEEK0MIAAoAhghBgsgAyAAKAIUSQ0AIAMgBk8NACAGIANrIgMgBUkNACACKAIAIgcEQCAHQf8fSw0BIAMgASAHQQN0akEEaygCAE0NAQsgACgCHCEAIAEgB0EDdGogAzYCBCABIAIoAgBBA3RqIABBA2o2AgAgAiACKAIAQQFqNgIACwu1AwEIfyAAKAJAQQJHBEACQCABRQ0AIAAoAgAhByABQQRPBEAgAkEDaiEIIAJBAmohCiACQQFqIQsgAUF8cSEMA0AgByACIAVqLQAAQQJ0aiIGIAYoAgBBAmo2AgAgByAFIAtqLQAAQQJ0aiIGIAYoAgBBAmo2AgAgByAFIApqLQAAQQJ0aiIGIAYoAgBBAmo2AgAgByAFIAhqLQAAQQJ0aiIGIAYoAgBBAmo2AgAgBUEEaiIFIAxHDQALCyABQQNxIghFDQADQCAHIAIgBWotAABBAnRqIgYgBigCAEECajYCACAFQQFqIQUgCUEBaiIJIAhHDQALCyAAIAAoAhggAUEBdGo2AhgLIAAoAgQgAUHAAE8Ef0EyIAFnawUgAUHAkDJqLQAAC0ECdGoiBSAFKAIAQQFqNgIAIAAgACgCHEEBajYCHCAAKAIMQR8gA2drQQJ0aiIFIAUoAgBBAWo2AgAgACAAKAIkQQFqNgIkIAAoAggCfyAEQQNrIgVBgAFPBEBBwwAgBWdrDAELIAVBwJEyai0AAAtBAnRqIgUgBSgCAEEBajYCACAAIAAoAiBBAWo2AiAL6Q0BFX8jAEEQayIZJAACQCADIAEoAgQiDyABKAIcIghqSQ0AAn8gAyAPayIJIAhNBEAgCQwBCwNAIAEgCCAPaiAEIAlBA0EAEKoMIAhqIgggCUkNAAsgAyABKAIEIg9rCyEKIAEgCTYCHCABKAIQIgggCkEBIAEoArgBdCIJayAIIAogCGsgCUsbIAEoAhgbIREgASgCvAEhFyABKAJcIAMoAABBsfPd8XlsQSAgASgCwAFrdkECdGoiGigCACEOQf8fIAEoAswBIgggCEH/H08bIRIgB0EBayETIAEoAmQhHCABKALEASEbAkAgBkF8SwRADAELIAZBAmohFSAEQQFrIRggBEEDayELIANBA2ohDCAKIAEoAgxrIRAgBiEIA0ACQAJ/IAgiB0EDRgRAIAUoAgBBAWsMAQsgBSAHQQJ0aigCAAsiCEEBayAQTw0AIAogCGsgEUkNACADIAhrKAAAIAMoAABzQf///wdxDQAgDCAIayEJAn8CQCALIAxNBEAgDCEIDAELIAkoAAAiFiAMIggoAAAiFEcEQCAUIBZzaEEDdgwCCwNAIAlBBGohCSAIQQRqIgggC08NASAJKAAAIhYgCCgAACIURg0ACyAIIBQgFnNoQQN2aiAMawwBCwJAIAggGE8NACAJLwAAIAgvAABHDQAgCUECaiEJIAhBAmohCAsgBCAISwR/IAggCS0AACAILQAARmoFIAgLIAxrC0EDaiIIIBNNDQAgACANQQN0aiIJIAg2AgQgCSAHIAZrQQFqNgIAIA1BAWohDSAIIBJLDQMgCCETIAMgCGogBEYNAwsgB0EBaiEIIAcgFUcNAAsLQQEgESARQQFNGyEGIAECfwJAIBNBAksNAEEgIAEoAiBrIQkgAygAACEQIAEoAmAhBwJAIAIoAgAiDCAKTw0AIAogDCIIa0EDcSIFBEBBACELA0AgByAIIA9qKAAAQYD6nq0DbCAJdkECdGogCDYCACAIQQFqIQggC0EBaiILIAVHDQALCyAMIAprQXxLDQADQCAHIAggD2ooAABBgPqerQNsIAl2QQJ0aiAINgIAIAcgDyAIQQFqIgtqKAAAQYD6nq0DbCAJdkECdGogCzYCACAHIA8gCEECaiILaigAAEGA+p6tA2wgCXZBAnRqIAs2AgAgByAPIAhBA2oiC2ooAABBgPqerQNsIAl2QQJ0aiALNgIAIAhBBGoiCCAKSQ0ACwsgAiAKNgIAIAcgEEGA+p6tA2wgCXZBAnRqKAIAIgggBkkNACAKIAhrIgxB//8PSw0AIAggD2ohCQJ/AkAgBEEDayIHIANNBEAgAyEIDAELIBAgCSgAACIIRgRAIAMhCANAIAlBBGohCSAIQQRqIgggB08NAiAJKAAAIgsgCCgAACIFRg0ACyAIIAUgC3NoQQN2aiADawwCCyAIIBBzaEEDdgwBCwJAIAggBEEBa08NACAJLwAAIAgvAABHDQAgCUECaiEJIAhBAmohCAsgBCAISwR/IAggCS0AACAILQAARmoFIAgLIANrCyIIQQNJDQAgACAINgIEIAAgDEEDajYCACAIIBJNBEBBASENIAghEyADIAhqIARHDQELQQEhDSAKQQFqDAELIApBCWohESAcIApBfyAXQQFrdEF/cyIYcUEDdGoiAkEEaiESIBogCjYCAAJAIAYgDksNACAKIBhrIghBACAIIApNGyEXQQEgG3QhFCAKQQNqIRsgBEEBayEaIARBA2shB0EAIRBBACEVA0AgDiAPaiIWIBAgFSAQIBVJGyIMaiEJIBMCfwJAIAcgAyAMaiIFTQRAIAUhCAwBCyAJKAAAIgogBSIIKAAAIgtHBEAgCiALc2hBA3YMAgsDQCAJQQRqIQkgCEEEaiIIIAdPDQEgCSgAACIKIAgoAAAiC0YNAAsgCCAKIAtzaEEDdmogBWsMAQsCQCAIIBpPDQAgCS8AACAILwAARw0AIAlBAmohCSAIQQJqIQgLIAQgCEsEfyAIIAktAAAgCC0AAEZqBSAICyAFawsgDGoiCEkEQCAAIA1BA3RqIgkgCDYCBCAJIBsgDms2AgAgCCAOaiARIAggESAOa0sbIREgDUEBaiENIAhBgCBLDQIgCCETIAMgCGogBEYNAgsgHCAOIBhxQQN0aiEJAkACQCAIIBZqLQAAIAMgCGotAABJBEAgAiAONgIAIA4gF0sNASAZQQxqIQIMBAsgEiAONgIAIA4gF0sEQCAJIRIgCCEVDAILIBlBDGohEgwDCyAIIRAgCUEEaiICIQkLIBRBAWsiFEUNASAJKAIAIg4gBk8NAAsLIBJBADYCACACQQA2AgAgEUEIaws2AhwLIBlBEGokACANC6UJARV/IwBBEGsiGSQAAkAgAyABKAIEIhUgASgCHCICakkNAAJ/IAMgFWsiCCACTQRAIAgMAQsDQCABIAIgFWogBCAIQQRBABCqDCACaiICIAhJDQALIAMgASgCBCIVawshCSABIAg2AhwgASgCECICIAlBASABKAK4AXQiCGsgAiAJIAJrIAhLGyABKAIYGyERIAEoArwBIRYgASgCXCADKAAAQbHz3fF5bEEgIAEoAsABa3ZBAnRqIhcoAgAhCiAHQQFrIRggASgCZCEbIAEoAsQBIRoCQCAGQXxLBEAMAQtB/x8gASgCzAEiAiACQf8fTxshDSAGQQJqIRIgBEEBayEOIARBA2shDyADQQRqIQsgCSABKAIMayETIAYhAgNAAkACfyACIgdBA0YEQCAFKAIAQQFrDAELIAUgB0ECdGooAgALIgJBAWsgE08NACAJIAJrIBFJDQAgAygAACADIAJrKAAARw0AIAsgAmshCAJ/AkAgCyAPTwRAIAshAgwBCyAIKAAAIhQgCyICKAAAIhBHBEAgECAUc2hBA3YMAgsDQCAIQQRqIQggAkEEaiICIA9PDQEgCCgAACIUIAIoAAAiEEYNAAsgAiAQIBRzaEEDdmogC2sMAQsCQCACIA5PDQAgCC8AACACLwAARw0AIAhBAmohCCACQQJqIQILIAIgBEkEfyACIAgtAAAgAi0AAEZqBSACCyALawtBBGoiAiAYTQ0AIAAgDEEDdGoiCCACNgIEIAggByAGa0EBajYCACAMQQFqIQwgAiANSw0DIAIhGCACIANqIARGDQMLIAdBAWohAiAHIBJHDQALCyAJQQlqIQYgGyAJQX8gFkEBa3RBf3MiFnFBA3RqIg5BBGohDSAXIAk2AgACQCAKQQEgESARQQFNGyIRSQ0AIAkgFmsiAkEAIAIgCU0bIRdBASAadCEQIAlBA2ohHCAEQQFrIRogBEEDayEHQQAhE0EAIRIDQCAKIBVqIhQgEyASIBIgE0sbIglqIQggGAJ/AkAgByADIAlqIgtNBEAgCyECDAELIAgoAAAiDyALIgIoAAAiBUcEQCAFIA9zaEEDdgwCCwNAIAhBBGohCCACQQRqIgIgB08NASAIKAAAIg8gAigAACIFRg0ACyACIAUgD3NoQQN2aiALawwBCwJAIAIgGk8NACAILwAAIAIvAABHDQAgCEECaiEIIAJBAmohAgsgAiAESQR/IAIgCC0AACACLQAARmoFIAILIAtrCyAJaiICSQRAIAAgDEEDdGoiCCACNgIEIAggHCAKazYCACACIApqIAYgAiAGIAprSxshBiAMQQFqIQwgAkGAIEsNAiACIRggAiADaiAERg0CCyAbIAogFnFBA3RqIQgCQAJAIAIgFGotAAAgAiADai0AAEkEQCAOIAo2AgAgCiAXSw0BIBlBDGohDgwECyANIAo2AgAgCiAXSwRAIAghDSACIRIMAgsgGUEMaiENDAMLIAIhEyAIQQRqIg4hCAsgEEEBayIQRQ0BIAgoAgAiCiARTw0ACwsgDUEANgIAIA5BADYCACABIAZBCGs2AhwLIBlBEGokACAMC7UJAhV/AX4jAEEQayIYJAACQCADIAEoAgQiEyABKAIcIgJqSQ0AAn8gAyATayIIIAJNBEAgCAwBCwNAIAEgAiATaiAEIAhBBUEAEKoMIAJqIgIgCEkNAAsgAyABKAIEIhNrCyEJIAEgCDYCHCABKAIQIgIgCUEBIAEoArgBdCIIayACIAkgAmsgCEsbIAEoAhgbIREgASgCvAEhFCABKAJcIAMpAAAiHUKAgIDYy5vvjU9+QcAAIAEoAsABa62Ip0ECdGoiGSgCACEKIAdBAWshFSABKAJkIRwgASgCxAEhGgJAIAZBfEsEQAwBC0H/HyABKALMASICIAJB/x9PGyEWIB1CIIinIQ0gBkECaiESIARBAWshDyAEQQNrIRAgA0EEaiEMIAkgASgCDGshFyAGIQIDQAJAAn8gAiIHQQNGBEAgBSgCAEEBawwBCyAFIAdBAnRqKAIACyICQQFrIBdPDQAgCSACayARSQ0AIAMoAAAgAyACaygAAEcNACAMIAJrIQgCfwJAIAwgEE8EQCAMIQIMAQsgDCECIA0gCCgAACIORwRAIA0gDnNoQQN2DAILA0AgCEEEaiEIIAJBBGoiAiAQTw0BIAgoAAAiDiACKAAAIhtGDQALIAIgDiAbc2hBA3ZqIAxrDAELAkAgAiAPTw0AIAgvAAAgAi8AAEcNACAIQQJqIQggAkECaiECCyACIARJBH8gAiAILQAAIAItAABGagUgAgsgDGsLQQRqIgIgFU0NACAAIAtBA3RqIgggAjYCBCAIIAcgBmtBAWo2AgAgC0EBaiELIAIgFksNAyACIRUgAiADaiAERg0DCyAHQQFqIQIgByASRw0ACwsgCUEJaiEGIBwgCUF/IBRBAWt0QX9zIhZxQQN0aiINQQRqIQ8gGSAJNgIAAkAgCkEBIBEgEUEBTRsiEUkNACAJIBZrIgJBACACIAlNGyEUQQEgGnQhDCAJQQNqIRogBEEBayEZIARBA2shB0EAIRJBACEOA0AgCiATaiIbIBIgDiAOIBJLGyIXaiEIIBUCfwJAIAcgAyAXaiIJTQRAIAkhAgwBCyAIKAAAIhAgCSICKAAAIgVHBEAgBSAQc2hBA3YMAgsDQCAIQQRqIQggAkEEaiICIAdPDQEgCCgAACIQIAIoAAAiBUYNAAsgAiAFIBBzaEEDdmogCWsMAQsCQCACIBlPDQAgCC8AACACLwAARw0AIAhBAmohCCACQQJqIQILIAIgBEkEfyACIAgtAAAgAi0AAEZqBSACCyAJawsgF2oiAkkEQCAAIAtBA3RqIgggAjYCBCAIIBogCms2AgAgAiAKaiAGIAIgBiAKa0sbIQYgC0EBaiELIAJBgCBLDQIgAiEVIAIgA2ogBEYNAgsgHCAKIBZxQQN0aiEIAkACQCACIBtqLQAAIAIgA2otAABJBEAgDSAKNgIAIAogFEsNASAYQQxqIQ0MBAsgDyAKNgIAIAogFEsEQCAIIQ8gAiEODAILIBhBDGohDwwDCyACIRIgCEEEaiINIQgLIAxBAWsiDEUNASAIKAIAIgogEU8NAAsLIA9BADYCACANQQA2AgAgASAGQQhrNgIcCyAYQRBqJAAgCwu1CQIVfwF+IwBBEGsiGCQAAkAgAyABKAIEIhMgASgCHCICakkNAAJ/IAMgE2siCCACTQRAIAgMAQsDQCABIAIgE2ogBCAIQQZBABCqDCACaiICIAhJDQALIAMgASgCBCITawshCSABIAg2AhwgASgCECICIAlBASABKAK4AXQiCGsgAiAJIAJrIAhLGyABKAIYGyERIAEoArwBIRQgASgCXCADKQAAIh1CgIDs/Mub741PfkHAACABKALAAWutiKdBAnRqIhkoAgAhCiAHQQFrIRUgASgCZCEcIAEoAsQBIRoCQCAGQXxLBEAMAQtB/x8gASgCzAEiAiACQf8fTxshFiAdQiCIpyENIAZBAmohEiAEQQFrIQ8gBEEDayEQIANBBGohDCAJIAEoAgxrIRcgBiECA0ACQAJ/IAIiB0EDRgRAIAUoAgBBAWsMAQsgBSAHQQJ0aigCAAsiAkEBayAXTw0AIAkgAmsgEUkNACADKAAAIAMgAmsoAABHDQAgDCACayEIAn8CQCAMIBBPBEAgDCECDAELIAwhAiANIAgoAAAiDkcEQCANIA5zaEEDdgwCCwNAIAhBBGohCCACQQRqIgIgEE8NASAIKAAAIg4gAigAACIbRg0ACyACIA4gG3NoQQN2aiAMawwBCwJAIAIgD08NACAILwAAIAIvAABHDQAgCEECaiEIIAJBAmohAgsgAiAESQR/IAIgCC0AACACLQAARmoFIAILIAxrC0EEaiICIBVNDQAgACALQQN0aiIIIAI2AgQgCCAHIAZrQQFqNgIAIAtBAWohCyACIBZLDQMgAiEVIAIgA2ogBEYNAwsgB0EBaiECIAcgEkcNAAsLIAlBCWohBiAcIAlBfyAUQQFrdEF/cyIWcUEDdGoiDUEEaiEPIBkgCTYCAAJAIApBASARIBFBAU0bIhFJDQAgCSAWayICQQAgAiAJTRshFEEBIBp0IQwgCUEDaiEaIARBAWshGSAEQQNrIQdBACESQQAhDgNAIAogE2oiGyASIA4gDiASSxsiF2ohCCAVAn8CQCAHIAMgF2oiCU0EQCAJIQIMAQsgCCgAACIQIAkiAigAACIFRwRAIAUgEHNoQQN2DAILA0AgCEEEaiEIIAJBBGoiAiAHTw0BIAgoAAAiECACKAAAIgVGDQALIAIgBSAQc2hBA3ZqIAlrDAELAkAgAiAZTw0AIAgvAAAgAi8AAEcNACAIQQJqIQggAkECaiECCyACIARJBH8gAiAILQAAIAItAABGagUgAgsgCWsLIBdqIgJJBEAgACALQQN0aiIIIAI2AgQgCCAaIAprNgIAIAIgCmogBiACIAYgCmtLGyEGIAtBAWohCyACQYAgSw0CIAIhFSACIANqIARGDQILIBwgCiAWcUEDdGohCAJAAkAgAiAbai0AACACIANqLQAASQRAIA0gCjYCACAKIBRLDQEgGEEMaiENDAQLIA8gCjYCACAKIBRLBEAgCCEPIAIhDgwCCyAYQQxqIQ8MAwsgAiESIAhBBGoiDSEICyAMQQFrIgxFDQEgCCgCACIKIBFPDQALCyAPQQA2AgAgDUEANgIAIAEgBkEIazYCHAsgGEEQaiQAIAsLqg8BGn8jAEEQayIaJAACQCADIAEoAgQiDiABKAIcIghqSQ0AAn8gAyAOayILIAhNBEAgCwwBCwNAIAEgCCAOaiAEIAtBA0EBEKoMIAhqIgggC0kNAAsgAyABKAIEIg5rCyEKIAEgCzYCHCABKAIQIgggCkEBIAEoArgBdCILayAIIAogCGsgC0sbIAEoAhgbIREgASgCvAEhGyABKAJcIAMoAABBsfPd8XlsQSAgASgCwAFrdkECdGoiICgCACELQf8fIAEoAswBIgggCEH/H08bIRYgB0EBayETIA4gASgCDCIUaiEcIAEoAggiGCAUaiEdIAEoAmQhHyABKALEASEhAkAgBkF8SwRADAELIAZBAmohGSAEQQFrIR4gBEEDayEQIANBA2ohDSAKIBFrIRUgCiAUayEXIAYhCANAIAoCfyAIIgdBA0YEQCAFKAIAQQFrDAELIAUgB0ECdGooAgALIghrIQkCQAJ/AkAgFyAIQQFrIgxLBEAgCSARSQ0DIAMgCGsoAAAgAygAAHNB////B3ENAyANIAhrIQkgDSAQTwRAIA0hCAwCCyAJKAAAIgwgDSIIKAAAIhJHBEAgDCASc2hBA3YMAwsDQCAJQQRqIQkgCEEEaiIIIBBPDQIgCSgAACIMIAgoAAAiEkYNAAsgCCAMIBJzaEEDdmogDWsMAgsgDCAVTw0CIAkgFGtBfEsNAiAJIBhqIggoAAAgAygAAHNB////B3ENAiANIAhBA2ogBCAdIBwQ0AsMAQsCQCAIIB5PDQAgCS8AACAILwAARw0AIAlBAmohCSAIQQJqIQgLIAQgCEsEfyAIIAktAAAgCC0AAEZqBSAICyANawtBA2oiCCATTQ0AIAAgD0EDdGoiCSAINgIEIAkgByAGa0EBajYCACAPQQFqIQ8gCCAWSw0DIAghEyADIAhqIARGDQMLIAdBAWohCCAHIBlHDQALC0EBIBEgEUEBTRshESABAn8CQCATQQJLDQBBICABKAIgayEHIAMoAAAhBSABKAJgIQkCQCACKAIAIg0gCk8NACAKIA0iCGtBA3EiEARAQQAhDANAIAkgCCAOaigAAEGA+p6tA2wgB3ZBAnRqIAg2AgAgCEEBaiEIIAxBAWoiDCAQRw0ACwsgDSAKa0F8Sw0AA0AgCSAIIA5qKAAAQYD6nq0DbCAHdkECdGogCDYCACAJIA4gCEEBaiIMaigAAEGA+p6tA2wgB3ZBAnRqIAw2AgAgCSAOIAhBAmoiDGooAABBgPqerQNsIAd2QQJ0aiAMNgIAIAkgDiAIQQNqIgxqKAAAQYD6nq0DbCAHdkECdGogDDYCACAIQQRqIgggCkkNAAsLIAIgCjYCACAJIAVBgPqerQNsIAd2QQJ0aigCACIIIBFJDQAgCiAIayINQf//D0sNAAJ/AkACQCAIIBRPBEAgCCAOaiEHIARBA2siCSADTQRAIAMhCAwDCyAHKAAAIgggBUcNASADIQgDQCAHQQRqIQcgCEEEaiIIIAlPDQMgBygAACIMIAgoAAAiEEYNAAsgCCAMIBBzaEEDdmogA2sMAwsgAyAIIBhqIAQgHSAcENALDAILIAUgCHNoQQN2DAELAkAgCCAEQQFrTw0AIAcvAAAgCC8AAEcNACAHQQJqIQcgCEECaiEICyAEIAhLBH8gCCAHLQAAIAgtAABGagUgCAsgA2sLIghBA0kNACAAIAg2AgQgACANQQNqNgIAIAggFk0EQEEBIQ8gCCETIAMgCGogBEcNAQtBASEPIApBAWoMAQsgCkEJaiESIB8gCkF/IBtBAWt0QX9zIhZxQQN0aiIVQQRqIQYgICAKNgIAAkAgCyARSQ0AIAogFmsiCEEAIAggCk0bIQJBASAhdCEZIApBA2ohHiAEQQFrIRsgBEEDayEMQQAhEEEAIQ0DQCADIBAgDSANIBBLGyIJaiEKAn8CQCAUIAkgC2pNBEAgCyAOaiAJaiEHIAogDE8EQCAKIQgMAgsgBygAACIFIAoiCCgAACIXRwRAIAUgF3NoQQN2IAlqIQggDgwDCwNAIAdBBGohByAIQQRqIgggDE8NAiAHKAAAIgUgCCgAACIXRg0ACyAIIAUgF3NoQQN2aiAKayAJaiEIIA4MAgsgGCAOIAogCyAYaiAJaiAEIB0gHBDQCyAJaiIIIAtqIBRJGwwBCwJAIAggG08NACAHLwAAIAgvAABHDQAgB0ECaiEHIAhBAmohCAsgBCAISwR/IAggBy0AACAILQAARmoFIAgLIAprIAlqIQggDgshCSAIIBNLBEAgACAPQQN0aiIHIAg2AgQgByAeIAtrNgIAIAggC2ogEiAIIBIgC2tLGyESIA9BAWohDyAIQYAgSw0CIAghEyADIAhqIARGDQILIB8gCyAWcUEDdGohBwJAAkAgCSALaiAIai0AACADIAhqLQAASQRAIBUgCzYCACACIAtJDQEgGkEMaiEVDAQLIAYgCzYCACACIAtJBEAgByEGIAghDQwCCyAaQQxqIQYMAwsgCCEQIAdBBGoiFSEHCyAZQQFrIhlFDQEgBygCACILIBFPDQALCyAGQQA2AgAgFUEANgIAIBJBCGsLNgIcCyAaQRBqJAAgDwvECgEZfyMAQRBrIhkkAAJAIAMgASgCBCINIAEoAhwiAmpJDQACfyADIA1rIgkgAk0EQCAJDAELA0AgASACIA1qIAQgCUEEQQEQqgwgAmoiAiAJSQ0ACyADIAEoAgQiDWsLIQogASAJNgIcIAEoAhAiAiAKQQEgASgCuAF0IglrIAIgCiACayAJSxsgASgCGBshECABKAK8ASEaIAEoAlwgAygAAEGx893xeWxBICABKALAAWt2QQJ0aiIbKAIAIQkgB0EBayEVIA0gASgCDCITaiEdIAEoAggiHCATaiEeIAEoAmQhHyABKALEASEgAkAgBkF8SwRADAELQf8fIAEoAswBIgIgAkH/H08bIRYgBkECaiEXIARBAWshGCAEQQNrIREgA0EEaiELIAogEGshEiAKIBNrIRQgBiECA0AgCgJ/IAIiB0EDRgRAIAUoAgBBAWsMAQsgBSAHQQJ0aigCAAsiAmshCAJAAn8CQCAUIAJBAWsiDksEQCAIIBBJDQMgAygAACADIAJrKAAARw0DIAsgAmshCCALIBFPBEAgCyECDAILIAgoAAAiDiALIgIoAAAiD0cEQCAOIA9zaEEDdgwDCwNAIAhBBGohCCACQQRqIgIgEU8NAiAIKAAAIg4gAigAACIPRg0ACyACIA4gD3NoQQN2aiALawwCCyAOIBJPDQIgCCATa0F8Sw0CIAMoAAAgCCAcaiICKAAARw0CIAsgAkEEaiAEIB4gHRDQCwwBCwJAIAIgGE8NACAILwAAIAIvAABHDQAgCEECaiEIIAJBAmohAgsgAiAESQR/IAIgCC0AACACLQAARmoFIAILIAtrC0EEaiICIBVNDQAgACAMQQN0aiIIIAI2AgQgCCAHIAZrQQFqNgIAIAxBAWohDCACIBZLDQMgAiEVIAIgA2ogBEYNAwsgB0EBaiECIAcgF0cNAAsLIApBCWohDyAfIApBfyAaQQFrdEF/cyIWcUEDdGoiEkEEaiEGIBsgCjYCAAJAIAlBASAQIBBBAU0bIhBJDQAgCiAWayICQQAgAiAKTRshGEEBICB0IRcgCkEDaiEaIARBAWshGyAEQQNrIQ5BACERQQAhCwNAIAMgESALIAsgEUsbIghqIQoCfwJAIBMgCCAJak0EQCAJIA1qIAhqIQcgCiAOTwRAIAohAgwCCyAHKAAAIgUgCiICKAAAIhRHBEAgBSAUc2hBA3YgCGohAiANDAMLA0AgB0EEaiEHIAJBBGoiAiAOTw0CIAcoAAAiBSACKAAAIhRGDQALIAIgBSAUc2hBA3ZqIAprIAhqIQIgDQwCCyAcIA0gCiAJIBxqIAhqIAQgHiAdENALIAhqIgIgCWogE0kbDAELAkAgAiAbTw0AIAcvAAAgAi8AAEcNACAHQQJqIQcgAkECaiECCyACIARJBH8gAiAHLQAAIAItAABGagUgAgsgCmsgCGohAiANCyEIIAIgFUsEQCAAIAxBA3RqIgcgAjYCBCAHIBogCWs2AgAgAiAJaiAPIAIgDyAJa0sbIQ8gDEEBaiEMIAJBgCBLDQIgAiEVIAIgA2ogBEYNAgsgHyAJIBZxQQN0aiEHAkACQCAIIAlqIAJqLQAAIAIgA2otAABJBEAgEiAJNgIAIAkgGEsNASAZQQxqIRIMBAsgBiAJNgIAIAkgGEsEQCAHIQYgAiELDAILIBlBDGohBgwDCyACIREgB0EEaiISIQcLIBdBAWsiF0UNASAHKAIAIgkgEE8NAAsLIAZBADYCACASQQA2AgAgASAPQQhrNgIcCyAZQRBqJAAgDAvUCgIafwF+IwBBEGsiGSQAAkAgAyABKAIEIg0gASgCHCICakkNAAJ/IAMgDWsiCSACTQRAIAkMAQsDQCABIAIgDWogBCAJQQVBARCqDCACaiICIAlJDQALIAMgASgCBCINawshCiABIAk2AhwgASgCECICIApBASABKAK4AXQiCWsgAiAKIAJrIAlLGyABKAIYGyEPIAEoArwBIRogASgCXCADKQAAIiJCgICA2Mub741PfkHAACABKALAAWutiKdBAnRqIiAoAgAhCSAHQQFrIRYgDSABKAIMIhNqIR0gASgCCCIbIBNqIR4gASgCZCEfIAEoAsQBISECQCAGQXxLBEAMAQtB/x8gASgCzAEiAiACQf8fTxshFyAiQiCIpyEUIAZBAmohGCAEQQFrIRwgBEEDayEQIANBBGohCyAKIA9rIREgCiATayEVIAYhAgNAIAoCfyACIgdBA0YEQCAFKAIAQQFrDAELIAUgB0ECdGooAgALIgJrIQgCQAJ/AkAgFSACQQFrIg5LBEAgCCAPSQ0DIAMoAAAgAyACaygAAEcNAyALIAJrIQggCyAQTwRAIAshAgwCCyALIQIgFCAIKAAAIg5HBEAgDiAUc2hBA3YMAwsDQCAIQQRqIQggAkEEaiICIBBPDQIgCCgAACIOIAIoAAAiEkYNAAsgAiAOIBJzaEEDdmogC2sMAgsgDiARTw0CIAggE2tBfEsNAiADKAAAIAggG2oiAigAAEcNAiALIAJBBGogBCAeIB0Q0AsMAQsCQCACIBxPDQAgCC8AACACLwAARw0AIAhBAmohCCACQQJqIQILIAIgBEkEfyACIAgtAAAgAi0AAEZqBSACCyALawtBBGoiAiAWTQ0AIAAgDEEDdGoiCCACNgIEIAggByAGa0EBajYCACAMQQFqIQwgAiAXSw0DIAIhFiACIANqIARGDQMLIAdBAWohAiAHIBhHDQALCyAKQQlqIRIgHyAKQX8gGkEBa3RBf3MiFHFBA3RqIhFBBGohBiAgIAo2AgACQCAJQQEgDyAPQQFNGyIPSQ0AIAogFGsiAkEAIAIgCk0bIRdBASAhdCEYIApBA2ohHCAEQQFrIRogBEEDayEOQQAhEEEAIQUDQCADIBAgBSAFIBBLGyIIaiEKAn8CQCATIAggCWpNBEAgCSANaiAIaiEHIAogDk8EQCAKIQIMAgsgBygAACILIAoiAigAACIVRwRAIAsgFXNoQQN2IAhqIQIgDQwDCwNAIAdBBGohByACQQRqIgIgDk8NAiAHKAAAIgsgAigAACIVRg0ACyACIAsgFXNoQQN2aiAKayAIaiECIA0MAgsgGyANIAogCSAbaiAIaiAEIB4gHRDQCyAIaiICIAlqIBNJGwwBCwJAIAIgGk8NACAHLwAAIAIvAABHDQAgB0ECaiEHIAJBAmohAgsgAiAESQR/IAIgBy0AACACLQAARmoFIAILIAprIAhqIQIgDQshCCACIBZLBEAgACAMQQN0aiIHIAI2AgQgByAcIAlrNgIAIAIgCWogEiACIBIgCWtLGyESIAxBAWohDCACQYAgSw0CIAIhFiACIANqIARGDQILIB8gCSAUcUEDdGohBwJAAkAgCCAJaiACai0AACACIANqLQAASQRAIBEgCTYCACAJIBdLDQEgGUEMaiERDAQLIAYgCTYCACAJIBdLBEAgByEGIAIhBQwCCyAZQQxqIQYMAwsgAiEQIAdBBGoiESEHCyAYQQFrIhhFDQEgBygCACIJIA9PDQALCyAGQQA2AgAgEUEANgIAIAEgEkEIazYCHAsgGUEQaiQAIAwL1AoCGn8BfiMAQRBrIhkkAAJAIAMgASgCBCINIAEoAhwiAmpJDQACfyADIA1rIgkgAk0EQCAJDAELA0AgASACIA1qIAQgCUEGQQEQqgwgAmoiAiAJSQ0ACyADIAEoAgQiDWsLIQogASAJNgIcIAEoAhAiAiAKQQEgASgCuAF0IglrIAIgCiACayAJSxsgASgCGBshDyABKAK8ASEaIAEoAlwgAykAACIiQoCA7PzLm++NT35BwAAgASgCwAFrrYinQQJ0aiIgKAIAIQkgB0EBayEWIA0gASgCDCITaiEdIAEoAggiGyATaiEeIAEoAmQhHyABKALEASEhAkAgBkF8SwRADAELQf8fIAEoAswBIgIgAkH/H08bIRcgIkIgiKchFCAGQQJqIRggBEEBayEcIARBA2shECADQQRqIQsgCiAPayERIAogE2shFSAGIQIDQCAKAn8gAiIHQQNGBEAgBSgCAEEBawwBCyAFIAdBAnRqKAIACyICayEIAkACfwJAIBUgAkEBayIOSwRAIAggD0kNAyADKAAAIAMgAmsoAABHDQMgCyACayEIIAsgEE8EQCALIQIMAgsgCyECIBQgCCgAACIORwRAIA4gFHNoQQN2DAMLA0AgCEEEaiEIIAJBBGoiAiAQTw0CIAgoAAAiDiACKAAAIhJGDQALIAIgDiASc2hBA3ZqIAtrDAILIA4gEU8NAiAIIBNrQXxLDQIgAygAACAIIBtqIgIoAABHDQIgCyACQQRqIAQgHiAdENALDAELAkAgAiAcTw0AIAgvAAAgAi8AAEcNACAIQQJqIQggAkECaiECCyACIARJBH8gAiAILQAAIAItAABGagUgAgsgC2sLQQRqIgIgFk0NACAAIAxBA3RqIgggAjYCBCAIIAcgBmtBAWo2AgAgDEEBaiEMIAIgF0sNAyACIRYgAiADaiAERg0DCyAHQQFqIQIgByAYRw0ACwsgCkEJaiESIB8gCkF/IBpBAWt0QX9zIhRxQQN0aiIRQQRqIQYgICAKNgIAAkAgCUEBIA8gD0EBTRsiD0kNACAKIBRrIgJBACACIApNGyEXQQEgIXQhGCAKQQNqIRwgBEEBayEaIARBA2shDkEAIRBBACEFA0AgAyAQIAUgBSAQSxsiCGohCgJ/AkAgEyAIIAlqTQRAIAkgDWogCGohByAKIA5PBEAgCiECDAILIAcoAAAiCyAKIgIoAAAiFUcEQCALIBVzaEEDdiAIaiECIA0MAwsDQCAHQQRqIQcgAkEEaiICIA5PDQIgBygAACILIAIoAAAiFUYNAAsgAiALIBVzaEEDdmogCmsgCGohAiANDAILIBsgDSAKIAkgG2ogCGogBCAeIB0Q0AsgCGoiAiAJaiATSRsMAQsCQCACIBpPDQAgBy8AACACLwAARw0AIAdBAmohByACQQJqIQILIAIgBEkEfyACIActAAAgAi0AAEZqBSACCyAKayAIaiECIA0LIQggAiAWSwRAIAAgDEEDdGoiByACNgIEIAcgHCAJazYCACACIAlqIBIgAiASIAlrSxshEiAMQQFqIQwgAkGAIEsNAiACIRYgAiADaiAERg0CCyAfIAkgFHFBA3RqIQcCQAJAIAggCWogAmotAAAgAiADai0AAEkEQCARIAk2AgAgCSAXSw0BIBlBDGohEQwECyAGIAk2AgAgCSAXSwRAIAchBiACIQUMAgsgGUEMaiEGDAMLIAIhECAHQQRqIhEhBwsgGEEBayIYRQ0BIAcoAgAiCSAPTw0ACwsgBkEANgIAIBFBADYCACABIBJBCGs2AhwLIBlBEGokACAMC9sRASF/IwBBEGsiHCQAAkAgAyABKAIEIg0gASgCHCIIakkNAAJ/IAMgDWsiCSAITQRAIAkMAQsDQCABIAggDWogBCAJQQNBABCqDCAIaiIIIAlJDQALIAMgASgCBCINawshCyABIAk2AhwgASgCXCADKAAAQbHz3fF5bEEgIAEoAsABa3ZBAnRqIh0oAgAhDiABKAJkISEgASgCvAEhJSABKAK0ASIXKAIQIRkgFygCvAEhJiABKAIQIgggC0EBIAEoArgBdCIJayAIIAsgCGsgCUsbIAEoAhgbIhYgFygCACIiIBcoAgQiI2siHmshGkH/HyABKALMASIIIAhB/x9PGyEVIAdBAWshESANIAEoAgwiEmohJCABKALEASEnIBcoAsABISgCQCAGQXxLBEAMAQsgIyAaayEbIAZBAmohEyAEQQFrIR8gBEEDayEQIANBA2ohDCALIBJrIRggCyAZIBpqayEgIAYhCANAIAsCfyAIIglBA0YEQCAFKAIAQQFrDAELIAUgCUECdGooAgALIghrIQcCQAJ/AkAgGCAIQQFrIgpLBEAgByAWSQ0DIAMgCGsoAAAgAygAAHNB////B3ENAyAMIAhrIQcgDCAQTwRAIAwhCAwCCyAHKAAAIgogDCIIKAAAIhRHBEAgCiAUc2hBA3YMAwsDQCAHQQRqIQcgCEEEaiIIIBBPDQIgBygAACIKIAgoAAAiFEYNAAsgCCAKIBRzaEEDdmogDGsMAgsgCiAgTw0CIAcgEmtBfEsNAiAHIBtqIggoAAAgAygAAHNB////B3ENAiAMIAhBA2ogBCAiICQQ0AsMAQsCQCAIIB9PDQAgBy8AACAILwAARw0AIAdBAmohByAIQQJqIQgLIAQgCEsEfyAIIActAAAgCC0AAEZqBSAICyAMawtBA2oiCCARTQ0AIAAgD0EDdGoiByAINgIEIAcgCSAGa0EBajYCACAPQQFqIQ8gCCAVSw0DIAghESADIAhqIARGDQMLIAlBAWohCCAJIBNHDQALC0EBIBYgFkEBTRshBiABAn8CQCARQQJLDQBBICABKAIgayEJIAMoAAAhBSABKAJgIQcCQCACKAIAIgwgC08NACALIAwiCGtBA3EiEARAQQAhCgNAIAcgCCANaigAAEGA+p6tA2wgCXZBAnRqIAg2AgAgCEEBaiEIIApBAWoiCiAQRw0ACwsgDCALa0F8Sw0AA0AgByAIIA1qKAAAQYD6nq0DbCAJdkECdGogCDYCACAHIA0gCEEBaiIKaigAAEGA+p6tA2wgCXZBAnRqIAo2AgAgByANIAhBAmoiCmooAABBgPqerQNsIAl2QQJ0aiAKNgIAIAcgDSAIQQNqIgpqKAAAQYD6nq0DbCAJdkECdGogCjYCACAIQQRqIgggC0kNAAsLIAIgCzYCACAHIAVBgPqerQNsIAl2QQJ0aigCACIIIAZJDQAgCyAIayIMQf//D0sNACAIIA1qIQkCfwJAIARBA2siByADTQRAIAMhCAwBCyAFIAkoAAAiCEYEQCADIQgDQCAJQQRqIQkgCEEEaiIIIAdPDQIgCSgAACIKIAgoAAAiEEYNAAsgCCAKIBBzaEEDdmogA2sMAgsgBSAIc2hBA3YMAQsCQCAIIARBAWtPDQAgCS8AACAILwAARw0AIAlBAmohCSAIQQJqIQgLIAQgCEsEfyAIIAktAAAgCC0AAEZqBSAICyADawsiCEEDSQ0AIAAgCDYCBCAAIAxBA2o2AgAgCCAVTQRAQQEhDyAIIREgAyAIaiAERw0BC0EBIQ8gC0EBagwBCyALQQlqIRMgISALQX8gJUEBa3RBf3MiG3FBA3RqIRJBASAndCEMIB0gCzYCAAJAAkACQCAGIA5LBEAgEkIANwIADAELIAsgG2siCEEAIAggC00bIQIgEkEEaiEVIAtBA2ohHSAEQQFrIR8gBEEDayEHQQAhFEEAIRYDQCANIA5qIiAgFCAWIBQgFkkbIhhqIQkgEQJ/AkAgByADIBhqIgVNBEAgBSEIDAELIAkoAAAiCiAFIggoAAAiEEcEQCAKIBBzaEEDdgwCCwNAIAlBBGohCSAIQQRqIgggB08NASAJKAAAIgogCCgAACIQRg0ACyAIIAogEHNoQQN2aiAFawwBCwJAIAggH08NACAJLwAAIAgvAABHDQAgCUECaiEJIAhBAmohCAsgBCAISwR/IAggCS0AACAILQAARmoFIAgLIAVrCyAYaiIISQRAIAAgD0EDdGoiCSAINgIEIAkgHSAOazYCACAIIA5qIBMgCCATIA5rSxshEyAPQQFqIQ8gCEGAIEsNAyADIAhqIARGDQMgCCERCyAhIA4gG3FBA3RqIQkCQAJAAkAgCCAgai0AACADIAhqLQAASQRAIBIgDjYCACACIA5JDQEgHEEMaiESDAMLIBUgDjYCACACIA5JBEAgCSEVIAghFgwCCyAcQQxqIRUMAgsgCCEUIAlBBGoiEiEJCyAMQQFrIgxFDQAgCSgCACIOIAZPDQELCyAVQQA2AgAgEkEANgIAIAxFDQILIBcoAlwgAygAAEGx893xeWxBICAoa3ZBAnRqKAIAIgkgGU0NASAeQX8gJkEBa3RBf3MiCmsgGSAeIBlrIApLGyEQIA0gGmohBSAXKAJkIRggC0EDaiEUQQAhB0EAIQ0DQCARIAMgByANIAcgDUkbIghqIAkgI2oiDiAIaiAEICIgJBDQCyAIaiIISQRAIAAgD0EDdGoiESAINgIEIBEgFCAJIBpqIgtrNgIAIAggC2ogEyAIIBMgC2tLGyETIA9BAWohDyAIQYAgSw0DIAghESADIAhqIARGDQMLIAkgEE0NAiAMQQFrIgxFDQIgCCAHIA4gBSAJaiAIIAlqIB5JGyAIai0AACADIAhqLQAASSIOGyEHIA0gCCAOGyENIBggCSAKcUEDdGpBBEEAIA4baigCACIJIBlLDQALDAELIBVBADYCACASQQA2AgALIBNBCGsLNgIcCyAcQRBqJAAgDwuRDQEgfyMAQRBrIhskAAJAIAMgASgCBCIOIAEoAhwiAmpJDQACfyADIA5rIgggAk0EQCAIDAELA0AgASACIA5qIAQgCEEEQQAQqgwgAmoiAiAISQ0ACyADIAEoAgQiDmsLIQogASAINgIcIAEoAlwgAygAAEGx893xeWxBICABKALAAWt2QQJ0aiIcKAIAIQkgASgCZCEhIAEoArwBIR0gASgCtAEiFigCECEYIBYoArwBISUgASgCECICIApBASABKAK4AXQiCGsgAiAKIAJrIAhLGyABKAIYGyIUIBYoAgAiIiAWKAIEIiNrIh5rIRkgB0EBayEQIA4gASgCDCIPaiEkIAEoAsQBISYgFigCwAEhJwJAIAZBfEsEQAwBCyAjIBlrIRVB/x8gASgCzAEiAiACQf8fTxshHyAGQQJqIREgBEEBayEaIARBA2shEiADQQRqIQsgCiAPayEXIAogGCAZamshICAGIQIDQCAKAn8gAiIIQQNGBEAgBSgCAEEBawwBCyAFIAhBAnRqKAIACyICayEHAkACfwJAIBcgAkEBayINSwRAIAcgFEkNAyADKAAAIAMgAmsoAABHDQMgCyACayEHIAsgEk8EQCALIQIMAgsgBygAACINIAsiAigAACITRwRAIA0gE3NoQQN2DAMLA0AgB0EEaiEHIAJBBGoiAiASTw0CIAcoAAAiDSACKAAAIhNGDQALIAIgDSATc2hBA3ZqIAtrDAILIA0gIE8NAiAHIA9rQXxLDQIgAygAACAHIBVqIgIoAABHDQIgCyACQQRqIAQgIiAkENALDAELAkAgAiAaTw0AIAcvAAAgAi8AAEcNACAHQQJqIQcgAkECaiECCyACIARJBH8gAiAHLQAAIAItAABGagUgAgsgC2sLQQRqIgIgEE0NACAAIAxBA3RqIgcgAjYCBCAHIAggBmtBAWo2AgAgDEEBaiEMIAIgH0sNAyACIRAgAiADaiAERg0DCyAIQQFqIQIgCCARRw0ACwsgCkEJaiERICEgCkF/IB1BAWt0QX9zIgZxQQN0aiEPQQEgJnQhCyAcIAo2AgACQAJAAkBBASAUIBRBAU0bIh8gCUsEQCAPQgA3AgAMAQsgCiAGayICQQAgAiAKTRshGiAPQQRqIRUgCkEDaiEdIARBAWshHCAEQQNrIQdBACETQQAhFANAIAkgDmoiICATIBQgEyAUSRsiF2ohCCAQAn8CQCAHIAMgF2oiBU0EQCAFIQIMAQsgCCgAACINIAUiAigAACISRwRAIA0gEnNoQQN2DAILA0AgCEEEaiEIIAJBBGoiAiAHTw0BIAgoAAAiDSACKAAAIhJGDQALIAIgDSASc2hBA3ZqIAVrDAELAkAgAiAcTw0AIAgvAAAgAi8AAEcNACAIQQJqIQggAkECaiECCyACIARJBH8gAiAILQAAIAItAABGagUgAgsgBWsLIBdqIgJJBEAgACAMQQN0aiIIIAI2AgQgCCAdIAlrNgIAIAIgCWogESACIBEgCWtLGyERIAxBAWohDCACQYAgSw0DIAIgA2ogBEYNAyACIRALICEgBiAJcUEDdGohCAJAAkACQCACICBqLQAAIAIgA2otAABJBEAgDyAJNgIAIAkgGksNASAbQQxqIQ8MAwsgFSAJNgIAIAkgGksEQCAIIRUgAiEUDAILIBtBDGohFQwCCyACIRMgCEEEaiIPIQgLIAtBAWsiC0UNACAIKAIAIgkgH08NAQsLIBVBADYCACAPQQA2AgAgC0UNAgsgFigCXCADKAAAQbHz3fF5bEEgICdrdkECdGooAgAiCCAYTQ0BIB5BfyAlQQFrdEF/cyISayAYIB4gGGsgEksbIQUgDiAZaiEXIBYoAmQhEyAKQQNqIQpBACEHQQAhCQNAIBAgAyAHIAkgByAJSRsiAmogCCAjaiIOIAJqIAQgIiAkENALIAJqIgJJBEAgACAMQQN0aiIQIAI2AgQgECAKIAggGWoiDWs2AgAgAiANaiARIAIgESANa0sbIREgDEEBaiEMIAJBgCBLDQMgAiEQIAIgA2ogBEYNAwsgBSAITw0CIAtBAWsiC0UNAiACIAcgDiAIIBdqIAIgCGogHkkbIAJqLQAAIAIgA2otAABJIg4bIQcgCSACIA4bIQkgEyAIIBJxQQN0akEEQQAgDhtqKAIAIgggGEsNAAsMAQsgFUEANgIAIA9BADYCAAsgASARQQhrNgIcCyAbQRBqJAAgDAucDQIhfwJ+IwBBEGsiHCQAAkAgAyABKAIEIg4gASgCHCICakkNAAJ/IAMgDmsiCCACTQRAIAgMAQsDQCABIAIgDmogBCAIQQVBABCqDCACaiICIAhJDQALIAMgASgCBCIOawshCiABIAg2AhwgASgCXCADKQAAIilCgICA2Mub741PfiIqQcAAIAEoAsABa62Ip0ECdGoiHSgCACEJIAEoAmQhISABKAK8ASElIAEoArQBIhYoAhAhGCAWKAK8ASEmIAEoAhAiAiAKQQEgASgCuAF0IghrIAIgCiACayAISxsgASgCGBsiEyAWKAIAIiIgFigCBCIjayIeayEZIAdBAWshECAOIAEoAgwiD2ohJCABKALEASEnIBYoAsABISgCQCAGQXxLBEAMAQsgIyAZayEUQf8fIAEoAswBIgIgAkH/H08bIRogKUIgiKchGyAGQQJqIREgBEEBayEfIARBA2shEiADQQRqIQsgCiAPayEXIAogGCAZamshICAGIQIDQCAKAn8gAiIIQQNGBEAgBSgCAEEBawwBCyAFIAhBAnRqKAIACyICayEHAkACfwJAIBcgAkEBayINSwRAIAcgE0kNAyADKAAAIAMgAmsoAABHDQMgCyACayEHIAsgEk8EQCALIQIMAgsgCyECIBsgBygAACINRwRAIA0gG3NoQQN2DAMLA0AgB0EEaiEHIAJBBGoiAiASTw0CIAcoAAAiDSACKAAAIhVGDQALIAIgDSAVc2hBA3ZqIAtrDAILIA0gIE8NAiAHIA9rQXxLDQIgAygAACAHIBRqIgIoAABHDQIgCyACQQRqIAQgIiAkENALDAELAkAgAiAfTw0AIAcvAAAgAi8AAEcNACAHQQJqIQcgAkECaiECCyACIARJBH8gAiAHLQAAIAItAABGagUgAgsgC2sLQQRqIgIgEE0NACAAIAxBA3RqIgcgAjYCBCAHIAggBmtBAWo2AgAgDEEBaiEMIAIgGksNAyACIRAgAiADaiAERg0DCyAIQQFqIQIgCCARRw0ACwsgCkEJaiERICEgCkF/ICVBAWt0QX9zIgZxQQN0aiEPQQEgJ3QhBSAdIAo2AgACQAJAAkBBASATIBNBAU0bIhsgCUsEQCAPQgA3AgAMAQsgCiAGayICQQAgAiAKTRshGiAPQQRqIRQgCkEDaiEdIARBAWshHyAEQQNrIQdBACEVQQAhEwNAIAkgDmoiICAVIBMgEyAVSxsiF2ohCCAQAn8CQCAHIAMgF2oiC00EQCALIQIMAQsgCCgAACINIAsiAigAACISRwRAIA0gEnNoQQN2DAILA0AgCEEEaiEIIAJBBGoiAiAHTw0BIAgoAAAiDSACKAAAIhJGDQALIAIgDSASc2hBA3ZqIAtrDAELAkAgAiAfTw0AIAgvAAAgAi8AAEcNACAIQQJqIQggAkECaiECCyACIARJBH8gAiAILQAAIAItAABGagUgAgsgC2sLIBdqIgJJBEAgACAMQQN0aiIIIAI2AgQgCCAdIAlrNgIAIAIgCWogESACIBEgCWtLGyERIAxBAWohDCACQYAgSw0DIAIgA2ogBEYNAyACIRALICEgBiAJcUEDdGohCAJAAkACQCACICBqLQAAIAIgA2otAABJBEAgDyAJNgIAIAkgGksNASAcQQxqIQ8MAwsgFCAJNgIAIAkgGksEQCAIIRQgAiETDAILIBxBDGohFAwCCyACIRUgCEEEaiIPIQgLIAVBAWsiBUUNACAIKAIAIgkgG08NAQsLIBRBADYCACAPQQA2AgAgBUUNAgsgFigCXCAqQcAAIChrrYinQQJ0aigCACIIIBhNDQEgHkF/ICZBAWt0QX9zIhJrIBggHiAYayASSxshCyAOIBlqIRcgFigCZCEVIApBA2ohCkEAIQdBACEJA0AgECADIAcgCSAHIAlJGyICaiAIICNqIg4gAmogBCAiICQQ0AsgAmoiAkkEQCAAIAxBA3RqIhAgAjYCBCAQIAogCCAZaiINazYCACACIA1qIBEgAiARIA1rSxshESAMQQFqIQwgAkGAIEsNAyACIRAgAiADaiAERg0DCyAIIAtNDQIgBUEBayIFRQ0CIAIgByAOIAggF2ogAiAIaiAeSRsgAmotAAAgAiADai0AAEkiDhshByAJIAIgDhshCSAVIAggEnFBA3RqQQRBACAOG2ooAgAiCCAYSw0ACwwBCyAUQQA2AgAgD0EANgIACyABIBFBCGs2AhwLIBxBEGokACAMC5wNAiF/An4jAEEQayIcJAACQCADIAEoAgQiDiABKAIcIgJqSQ0AAn8gAyAOayIIIAJNBEAgCAwBCwNAIAEgAiAOaiAEIAhBBkEAEKoMIAJqIgIgCEkNAAsgAyABKAIEIg5rCyEKIAEgCDYCHCABKAJcIAMpAAAiKUKAgOz8y5vvjU9+IipBwAAgASgCwAFrrYinQQJ0aiIdKAIAIQkgASgCZCEhIAEoArwBISUgASgCtAEiFigCECEYIBYoArwBISYgASgCECICIApBASABKAK4AXQiCGsgAiAKIAJrIAhLGyABKAIYGyITIBYoAgAiIiAWKAIEIiNrIh5rIRkgB0EBayEQIA4gASgCDCIPaiEkIAEoAsQBIScgFigCwAEhKAJAIAZBfEsEQAwBCyAjIBlrIRRB/x8gASgCzAEiAiACQf8fTxshGiApQiCIpyEbIAZBAmohESAEQQFrIR8gBEEDayESIANBBGohCyAKIA9rIRcgCiAYIBlqayEgIAYhAgNAIAoCfyACIghBA0YEQCAFKAIAQQFrDAELIAUgCEECdGooAgALIgJrIQcCQAJ/AkAgFyACQQFrIg1LBEAgByATSQ0DIAMoAAAgAyACaygAAEcNAyALIAJrIQcgCyASTwRAIAshAgwCCyALIQIgGyAHKAAAIg1HBEAgDSAbc2hBA3YMAwsDQCAHQQRqIQcgAkEEaiICIBJPDQIgBygAACINIAIoAAAiFUYNAAsgAiANIBVzaEEDdmogC2sMAgsgDSAgTw0CIAcgD2tBfEsNAiADKAAAIAcgFGoiAigAAEcNAiALIAJBBGogBCAiICQQ0AsMAQsCQCACIB9PDQAgBy8AACACLwAARw0AIAdBAmohByACQQJqIQILIAIgBEkEfyACIActAAAgAi0AAEZqBSACCyALawtBBGoiAiAQTQ0AIAAgDEEDdGoiByACNgIEIAcgCCAGa0EBajYCACAMQQFqIQwgAiAaSw0DIAIhECACIANqIARGDQMLIAhBAWohAiAIIBFHDQALCyAKQQlqIREgISAKQX8gJUEBa3RBf3MiBnFBA3RqIQ9BASAndCEFIB0gCjYCAAJAAkACQEEBIBMgE0EBTRsiGyAJSwRAIA9CADcCAAwBCyAKIAZrIgJBACACIApNGyEaIA9BBGohFCAKQQNqIR0gBEEBayEfIARBA2shB0EAIRVBACETA0AgCSAOaiIgIBUgEyATIBVLGyIXaiEIIBACfwJAIAcgAyAXaiILTQRAIAshAgwBCyAIKAAAIg0gCyICKAAAIhJHBEAgDSASc2hBA3YMAgsDQCAIQQRqIQggAkEEaiICIAdPDQEgCCgAACINIAIoAAAiEkYNAAsgAiANIBJzaEEDdmogC2sMAQsCQCACIB9PDQAgCC8AACACLwAARw0AIAhBAmohCCACQQJqIQILIAIgBEkEfyACIAgtAAAgAi0AAEZqBSACCyALawsgF2oiAkkEQCAAIAxBA3RqIgggAjYCBCAIIB0gCWs2AgAgAiAJaiARIAIgESAJa0sbIREgDEEBaiEMIAJBgCBLDQMgAiADaiAERg0DIAIhEAsgISAGIAlxQQN0aiEIAkACQAJAIAIgIGotAAAgAiADai0AAEkEQCAPIAk2AgAgCSAaSw0BIBxBDGohDwwDCyAUIAk2AgAgCSAaSwRAIAghFCACIRMMAgsgHEEMaiEUDAILIAIhFSAIQQRqIg8hCAsgBUEBayIFRQ0AIAgoAgAiCSAbTw0BCwsgFEEANgIAIA9BADYCACAFRQ0CCyAWKAJcICpBwAAgKGutiKdBAnRqKAIAIgggGE0NASAeQX8gJkEBa3RBf3MiEmsgGCAeIBhrIBJLGyELIA4gGWohFyAWKAJkIRUgCkEDaiEKQQAhB0EAIQkDQCAQIAMgByAJIAcgCUkbIgJqIAggI2oiDiACaiAEICIgJBDQCyACaiICSQRAIAAgDEEDdGoiECACNgIEIBAgCiAIIBlqIg1rNgIAIAIgDWogESACIBEgDWtLGyERIAxBAWohDCACQYAgSw0DIAIhECACIANqIARGDQMLIAggC00NAiAFQQFrIgVFDQIgAiAHIA4gCCAXaiACIAhqIB5JGyACai0AACACIANqLQAASSIOGyEHIAkgAiAOGyEJIBUgCCAScUEDdGpBBEEAIA4baigCACIIIBhLDQALDAELIBRBADYCACAPQQA2AgALIAEgEUEIazYCHAsgHEEQaiQAIAwLEQAgACABIAIgAyAEQQAQvgwL8CgCKH8BfiMAQUBqIgckACAAKAIMIQkgACgCBCEIIAAoAswBIQsgACgCyAEhBiAHIAAoAhw2AjwgACgCgAEhGCAAKAKEASEQIAdBADYCOCAHQgA3AzAgBUEEdEEGIAYgBkEGTxtBA2tBACAGQQNPG0ECdGpB0I0yaiEMIABB8ABqISMgCCAJaiEJIAMgBGoiGUEIayEgAkAgACgC1AEiBQRAIAcgBSgCEDYCICAHIAX9AAIA/QsDEAwBCyAHQQA2AiAgB/0MAAAAAAAAAAAAAAAAAAAAAP0LAxALIAwoAgAhJCAHQgA3AiQgB0EANgIsIAdBEGpBACAEEK0MICMgAyAEQQIQrgwgICADIAMgCUZqIhRLBEBB/x8gCyALQf8fTxshJUEDQQQgBkEDRhsiHEEDcSEpIBlBIGshHiAQQRxqISogEEEQaiEmIBxBAWtBA3EhKyADIQ8DQCAHIBggACAHQTxqIBQgGSACIA8gFEYgHCAkEQoANgIAIAdBEGogGCAHIBQgA2sgGSAUayAcEK8MAkAgBygCACIVRQRAIBRBAWohFAwBCyAQIBQgD2siCTYCDCAQQQA2AgggEAJ/IAAoAqgBQQFGBEBBHyAJQQFqIgZnayIEQQh0IAZBCHQgBHZqDAELIAlBgIAIRgRAIAAoApwBIAAoAnQoAowBQQFqIgZnIgRBCHRqIAZBCHRBHyAEa3ZrQYAcawwBCyAAKAKcASAAKAJ0IAlBwABPBH9BMiAJZ2sFIAlBwJAyai0AAAsiBkECdGooAgBBAWoiBEEIdEEfIARnIgRrdmsgBCAGQZCQMmotAABqQQh0akGAPmsLNgIAICYgAkEIaiInKAIANgIIICYgAikCADcCAAJAIBACfwJAICUgGCAVQQN0aiIEQQRrKAIAIgZJBEAgBEEIaygCACEIQQAhEQwBC0EBIQZBACEFIClBAUcEQANAIBAgBkEcbGoiBCAGIAlqNgIMIARBADYCCCAEQYCAgIAENgIAIAZBAWohBiAFQQFqIgUgK0cNAAsLQQAhGiAcIQYDQCAYIBpBA3RqIgQoAgQiCCAGTwRAQR8gBCgCACILZyIWayEMIAAoAqgBQQFGIQ0DQAJ/An8CQCANRQRAIAAoAnwgDEECdGooAgBBAWoiBEEIdEEfIARnIglrdiEKIAZBA2siBEGAAUkNAUHDACAEZ2sMAgsgECgCACEFIBAgBkEcbGoiBEEANgIMIAQgCzYCBCAEIAY2AgggBSAGQQJrIglBCHRBHyAJZ2siCXYgCSAMakEIdGpqQYAgaiEFQYACDAILIARBwJEyai0AAAshBSAAKAKkASERIAAoAnggBUECdGooAgAhDiAQKAIAIRMgACgCoAEhGyAQIAZBHGxqIgRBADYCDCAEIAs2AgQgBCAGNgIIIA5BAWoiDmciEiAFQYCRMmotAAAgCSAWa2pqQQh0IBMgGyARIApramogDkEIdEEfIBJrdmtqQc09ayEFIAAoApwBIAAoAnQoAgBBAWoiCWciCkEIdGogCUEIdEEfIAprdmtBgD5rCyEJIAQgBSAJajYCACAGQQFqIgYgCE0NAAsLIBpBAWoiGiAVRw0ACyAQIAZBHGxqQYCAgIAENgIAQQEhEUEAISJBACEFAkACQAJAIAZBAWsiBEUNAANAIBEgFGohCSAQIBFBHGxqIgZBEGsoAgAiDEEBaiEFIAZBHGsiCCgCACELIAAoAqgBIQ0CfwJAAkAgACgCsAFBAkcEQCANQQFGBEAgC0GADGohCwwDC0EfIAAoAnAgCUEBay0AAEECdGooAgBBAWoiDWdrIgpBCHQgDUEIdCAKdmoiDSAAKAKYASIKQYACayIOSwRAIA4hDQsgCiANayALaiELDAELIAtBgBBqIQsgDUEBRg0BCwJ/AkACQCAFQYCACEYEQCAAKAKcASINIAAoAnQiDigCjAFBAWoiCmciE0EIdGogCkEIdEEfIBNrdmtBgBxrIQogDUGAPmshEwwBCyAAKAKcASIbQYA+ayITIAAoAnQiDiAFQcAATwR/QTIgBWdrBSAFQcCQMmotAAALIg1BAnRqKAIAQQFqIgpBCHRBHyAKZyIKa3ZrIAogDUGQkDJqLQAAakEIdGohCiAMQYCACEYEQCAbIA4oAowBQQFqIg1nIg5BCHRqIA1BCHRBHyAOa3ZrQYAcawwFCyAMQcAASQ0BC0EyIAxnawwBCyAMQcCQMmotAAALIQ0gEyAOIA1BAnRqKAIAQQFqIg5BCHRBHyAOZyIOa3ZrIA4gDUGQkDJqLQAAakEIdGoMAQtBHyAMQQJqIgpnayIOQQh0IApBCHQgDnZqIQpBHyAFZ2siDUEIdCAFQQh0IA12agshDQJAIAsgCiANa2oiCyAGKAIAIg1KBEAgBigCDCEFIA0hCwwBCyAGKAIEIRMgBiAIKQIANwIAIAZBCGoiCigCACEbIAYoAgwhDiAKIAgpAgg3AgAgCCgCGCEKIAgpAhAhLiAGIAs2AgAgBiAuNwIQIAYgCjYCGCAGIAU2AgwgDg0AIAAoAqgBQQFGDQAgACgCnAEiH0GAPmsiCiAAKAJ0IggoAgRBAWoiEmciDkEIdGogEkEIdEEfIA5rdiIaayAKIAgoAgBBAWoiFmciEkEIdGogFkEIdEEfIBJrdiIWa04NACAJIBlPDQACfyAAKAKwAUECRgRAQYAQIRUgDSAaayAWaiAOIBJrQQh0akGAEGoMAQtBHyAAKAJwIAktAABBAnRqKAIAQQFqIhVnayIXQQh0IBVBCHQgF3ZqIhUhHSAVIAAoApgBIhdBgAJrIihNIixFBEAgKCEdCyANIBdqIBogHWprIBZqIQ0gDiASa0EIdCEOIBcgFSAoICwbayEVIA0gDmoLIQ0gDQJ/An8CQAJAIAxBAmoiDEGAgAhGBEAgHyAIKAKMAUEBaiIMZyIOQQh0aiAMQQh0QR8gDmt2a0GAHGshDgwBCyAKIAggDEHAAE8Ef0EyIAxnawUgDEHAkDJqLQAACyIMQQJ0aigCAEEBaiIOQQh0QR8gDmciDmt2ayAOIAxBkJAyai0AAGpBCHRqIQ4gBUGAgAhGBEAgCCgCjAFBAWoiCEEIdEEfIAhnIghrdiAfIAhBCHRqa0GAHGoMBAsgBUHAAEkNAQtBMiAFZ2sMAQsgBUHAkDJqLQAACyIMQQJ0IAhqKAIAQQFqIghBCHRBHyAIZyIIa3YgCiAIIAxBkJAyai0AAGpBCHRqawsgCyAVaiAOampODQAgDSAQIBFBAWoiDEEcbGoiCCgCAE4NACAQIBEgG2tBHGxqIgooAgwhEiAHQQhqIg4gCigCGDYCACAHIAopAhA3AwACQAJAIBNBBE8EQCAHIAcpAwA3AgQgE0EDayEKDAELAn8CQAJAIBMgEkVqQQFrIhIOBAQBAQABCyAHKAIAIhZBAWsMAQsgBygCACEWIAcgEkECdGooAgALIQogByAOIAdBBHIgEkEBRhsoAgA2AgggByAWNgIECyAHIAo2AgALIAggGzYCCCAIIBM2AgQgCCAHKQMANwIQIAggDigCADYCGCAIQQE2AgwgCCANNgIAIAQgDCAEIAxLGyEECyAFRQRAIBAgESAGKAIIa0EcbGoiCCgCDCEKIAYoAgQhDCAHQQhqIg0gCCgCGDYCACAHIAgpAhA3AwACQAJAIAxBBE8EQCAHIAcpAwA3AgQgDEEDayEIDAELAn8CQAJAIAwgCkVqQQFrIgwOBAQBAQABCyAHKAIAIgpBAWsMAQsgBygCACEKIAcgDEECdGooAgALIQggByANIAdBBHIgDEEBRhsoAgA2AgggByAKNgIECyAHIAg2AgALIAYgBykDADcCECAGIA0oAgA2AhgLAkAgCSAgSw0AIAQgEUYEQCARIQUMAwsgBUUhBUGAAiEIIAAoAqgBQQFHBEAgACgCnAEgACgCdCgCAEEBaiIIZyIMQQh0aiAIQQh0QR8gDGt2a0GAPmshCAsgByAYIAAgB0E8aiAJIBkgBkEQaiAFIBwgJBEKADYCACAHQRBqIBggByAJIANrIBkgCWsgHBCvDCAHKAIAIh1FDQAgGCAdQQN0aiIMQQRrKAIAIgYgEWohBSAGICVLDQMgBUH/H0sNAyAGIAlqIBlPDQMgCCALaiEbQQAhFwNAIBwhCiAYIBdBA3RqIgYoAgQiCyEtIBcEQCAGQQRrKAIAQQFqIQoLIC0gCk8EQCALICJqIRogCyARaiEVQR8gBigCACIWZyIfayEOQQAhDCAAKAKoAUEBRyETA0ACfyATRQRAIAtBAmsiBkEIdEEfIAZnayIGdiAGIA5qQQh0akGAIGoMAQsgACgCfCAOQQJ0aigCAEEBaiIGQQh0QR8gBmciBWt2IQkgACgCeAJ/IAtBA2siBkGAAU8EQEHDACAGZ2sMAQsgBkHAkTJqLQAACyIGQQJ0aigCAEEBaiIIZyINIAZBgJEyai0AACAFIB9rampBCHQgACgCpAEgACgCoAFqIAkgCEEIdEEfIA1rdmprakHNPWsLIBtqIQ0CQAJAIAQgCyARaiIISQRAIBogBCAMaiIFayESQQAhBiAVIAVrQQNxIgkEQANAIBAgBEEBaiIEQRxsaiIFQQE2AgwgBUGAgICABDYCACAGQQFqIgYgCUcNAAsLIBJBA0kNAQNAIBAgBEEcbGoiBkEBNgJgIAZBgICAgAQ2AlQgBkEBNgJEIAZBgICAgAQ2AjggBkEBNgIoIAZBgICAgAQ2AhwgBkGAgICABDYCcCAGQQE2AnwgBEEEaiIEIAhJDQALDAELIA0gECAIQRxsaigCAE4NAQsgECAIQRxsaiIGQQA2AgwgBiAWNgIEIAYgCzYCCCAGIA02AgALIAxBAWohDCALQQFrIgsgCk8NAAsLIBdBAWoiFyAdRw0ACyAqIARBHGxqQYCAgIAENgIACyAiQQFqISIgBCEFIBFBAWoiESAETQ0ACwsgECAFQRxsaiIEKAIMIQkgBCgCBCEIIAQoAgAhISAEKAIIIQYgB0E4aiILIAQoAhg2AgAgByAEKQIQNwMwIAZFDQQgBSAGayERIAlFDQEgBEEQaiIEKQIAIS4gJyAEKAIINgIAIAIgLjcCACAQIBEgCWsiEUEcbGoiBEFAa0EANgIAIAQgCTYCRCAEICE2AhwgBCAINgIgIAQgBjYCJCAEIAk2AiggBCAHKQMwNwIsIAQgCygCADYCNCARQQJqDAMLIAZFDQMgDEEIaygCACEICyAQIBFBHGxqKAIMIQkLIAdBCGoiBCAQIBFBHGxqIgUoAhg2AgAgByAFKQIQNwMAAkACQCAIQQRPBEAgByAHKQMANwIEIAhBA2shBQwBCwJ/AkACQCAIIAlFakEBayIJDgQEAQEAAQsgBygCACILQQFrDAELIAcoAgAhCyAHIAlBAnRqKAIACyEFIAcgBCAHQQRyIAlBAUYbKAIANgIIIAcgCzYCBAsgByAFNgIACyACIAcpAwA3AgAgJyAEKAIANgIAQQAhCSARQQJqCyIKQRxsaiIEIAk2AgwgBCAGNgIIIAQgCDYCBCAEICE2AgAgBCAHKQMwNwIQIAQgBygCODYCGCAQIBFBHGxqIgYoAgghCSAGKQIAIS4gBigCDCEIIAdBCGoiCyAGKAIYNgIAIAcgBikCEDcDACAEIAg2AgwgCiEFAkAgCQRAA0AgECAFQQFrIgVBHGxqIgYgCDYCDCAGIAk2AgggBiAuNwIAIAYgBykDADcCECAGIAsoAgA2AhggECARIAggCWprIhFBHGxqIgQoAgghCSAEKQIAIS4gBCgCDCEIIAsgBCgCGDYCACAHIAQpAhA3AwAgBiAINgIMIAkNAAsgBSAKSw0BCwNAIBAgBUEcbGoiBigCDCEJIAYoAggiDAR/ICMgCSAPIAYoAgQiDSAMELAMIAEoAgwhBgJAAkAgHiAJIA9qIghPBEAgBiAP/QAAAP0LAAAgASgCDCEEIAlBEE0EQCABIAQgCWo2AgwgASgCBCEGDAMLIAQgD/0AABD9CwAQIAlBIUgNASAEIAlqIQsgD0EQaiEGIARBIGohBANAIAQgBv0AABD9CwAAIAQgBv0AACD9CwAQIAZBIGohBiAEQSBqIgQgC0kNAAsMAQsgDyAeTQRAIAYgD/0AAAD9CwAAIAYgHiAPayILaiEEIAtBEU4EQCAGQRBqIQYDQCAGIA/9AAAQ/QsAACAGIA/9AAAg/QsAECAPQSBqIQ8gBkEgaiIGIARJDQALCyAEIQYgHiEPCyAIIA9NDQAgCCAPayILQQFrIRFBACEEIAtBB3EiCwRAA0AgBiAPLQAAOgAAIAZBAWohBiAPQQFqIQ8gBEEBaiIEIAtHDQALCyARQQdJDQADQCAGIA8tAAA6AAAgBiAPLQABOgABIAYgDy0AAjoAAiAGIA8tAAM6AAMgBiAPLQAEOgAEIAYgDy0ABToABSAGIA8tAAY6AAYgBiAPLQAHOgAHIAZBCGohBiAPQQhqIg8gCEcNAAsLIAEgASgCDCAJajYCDCABKAIEIQYgCUGAgARJDQAgAUEBNgIkIAEgBiABKAIAa0EDdTYCKAsgBiANNgIAIAYgCTsBBCAMQQNrIgRBgIAETwRAIAFBAjYCJCABIAYgASgCAGtBA3U2AigLIAYgBDsBBiABIAZBCGo2AgQgCCAMaiIPBSAJIA9qCyEUIAVBAWoiBSAKTQ0ACwsgACgCsAFBAkcEQCAAQR8gACgCiAFBAWoiBmdrIgRBCHQgBkEIdCAEdmo2ApgBCyAAQR8gACgClAFBAWoiBmdrIgRBCHQgBkEIdCAEdmo2AqQBIABBHyAAKAKQAUEBaiIGZ2siBEEIdCAGQQh0IAR2ajYCoAEgAEEfIAAoAowBQQFqIgZnayIEQQh0IAZBCHQgBHZqNgKcAQwBCyAFIBRqIRQLIBQgIEkNAAsgDyEDCyAHQUBrJAAgGSADawvLAQECfyMAQRBrIgUkAAJAIAAoAowBDQAgASgCBCABKAIARw0AIAAoAgwiBiAAKAIQRw0AIARBCUkNACADIAAoAgRrIAZHDQAgBSACKAIINgIIIAUgAikCADcDACAAIAEgBSADIARBABC+DBogAUEANgIkIAEgASgCADYCBCABIAEoAgg2AgwgACAAKAIMIARqIgY2AgwgACAGNgIcIAAgBjYCECAAIAAoAgQgBGs2AgQLIAAgASACIAMgBEEAEL4MIQAgBUEQaiQAIAALEQAgACABIAIgAyAEQQIQrAwLEQAgACABIAIgAyAEQQEQrAwLEQAgACABIAIgAyAEQQIQvgwLEQAgACABIAIgAyAEQQEQvgwLVQECfyAAQQBBgAj8CwAgAEEANgKAICACQQFrIgQEQANAIAAgASADai0AAEECdGoiAiACKAIAQQFqNgIAIANBK2oiAyAESQ0ACwsgACAEQStuNgKAIAtYAQJ/IABBAEGAEPwLACACQQFrIgQEQANAIAAgASADai8AAEG5893xeWxBFXZB/A9xaiICIAIoAgBBAWo2AgAgA0ELaiIDIARJDQALCyAAIARBC242AoAgC1gBAn8gAEEAQYQg/AsAIAJBAWsiBARAA0AgACABIANqLwAAQbnz3fF5bEEUdkH8H3FqIgIgAigCAEEBajYCACADQQVqIgMgBEkNAAsLIAAgBEEFbjYCgCALxgEBBX8gAEEAQYQg/AsAAkAgAkEBayIERQ0AIAJBAkcEQCAEQQFxIQUgAUEBaiEGIARBfnEhBwNAIAAgASADai8AAEG5893xeWxBFHZB/B9xaiICIAIoAgBBAWo2AgAgACADIAZqLwAAQbnz3fF5bEEUdkH8H3FqIgIgAigCAEEBajYCACADQQJqIgMgB0cNAAsgBUUNAQsgACABIANqLwAAQbnz3fF5bEEUdkH8H3FqIgMgAygCAEEBajYCAAsgACAENgKAIAvlCQIBfg5/IwBBgAFrIg8kACAPIAM2AnwCQAJAAkACQAJAAkAgAkEBaw4DAAIBAwsgBkUEQEG4fyEDDAULIAUtAAAiAiADSwRAQWwhAwwFCyACIAhqLQAAIQMgByACQQJ0aigCACECIABBADoACyAAQgA3AgAgACACNgIMIAAgAzoACiAAQQA7AQggASAANgIAQQEhAwwECyAKRQRAQWwhAwwEC0EAIQMgC0UNAyAMQRlJDQNBCCAEdEEGdiEGQQAhAgNAIANBgARqIQMgAkEIaiICIAZHDQALDAILQWwhAyAPIA9B/ABqIA9B+ABqIAUgBhDKCyIYQYh/Sw0CIA8oAngiECAESw0CIABBDGohBiANQeoAaiEWQQEgEHQiDEEBayECAkACQAJAIA8oAnwiEkF/RgRAIAAgEDYCBCAAQQE2AgAMAQtBgIACIBB0QRB2IQsgAiEKQQEhBEEAIQMDQAJAIA8gA0EBdCIJai8BACIFQf//A0YEQCAGIApBA3RqIAM2AgAgCkEBayEKQQEhBQwBCyAEQQAgCyAFwUobIQQLIAkgDWogBTsBACADIBJHIQUgA0EBaiEDIAUNAAsgACAQNgIEIAAgBDYCACACIApHDQFBACEDA0AgDyADIhdBAXRqLgEAIRQgEyAWaiIFIA43AAACQCAUQQlIDQAgFEEJayIKQQN2QQFqIhVBB3EhCUEIIQMgCkE4TwRAIAVBOGohBCAFQTBqIQsgBUEoaiERIAVBIGohGSAFQRhqIRogBUEQaiEbIAVBCGohHCAVQfj///8DcSEVQQAhCgNAIAMgBWogDjcAACADIBxqIA43AAAgAyAbaiAONwAAIAMgGmogDjcAACADIBlqIA43AAAgAyARaiAONwAAIAMgC2ogDjcAACADIARqIA43AAAgA0FAayEDIApBCGoiCiAVRw0ACwtBACEKIAlFDQADQCADIAVqIA43AAAgA0EIaiEDIApBAWoiCiAJRw0ACwsgDkKBgoSIkKDAgAF8IQ4gF0EBaiEDIBMgFGohEyASIBdHDQALCyAMQQN2IAxBAXZqQQNqIglBAXQhBEEAIQVBACEDA0AgBiACIANxQQN0aiAFIBZqIgotAAA2AgAgBiADIAlqIAJxQQN0aiAKLQABNgIAIAMgBGogAnEhAyAFQQJqIgUgDEkNAAsMAQsgDEEDdiAMQQF2akEDaiEJQQAhA0EAIQQDQAJAIA8gBCIFQQF0ai4BACIRQQBMDQAgEUEBRwRAIBFB/v8BcSELQQAhBANAIAYgA0EDdGogBTYCAANAIAMgCWogAnEiAyAKSw0ACyAGIANBA3RqIAU2AgADQCADIAlqIAJxIgMgCksNAAsgBEECaiIEIAtHDQALIBFBAXFFDQELIAYgA0EDdGogBTYCAANAIAMgCWogAnEiAyAKSw0ACwsgBUEBaiEEIAUgEkcNAAsLIABBCGohCSAQQR9rIQRBACECA0AgDSAJIAJBA3RqIgMoAgQiBkEBdGoiBSAFLwEAIgVBAWo7AQAgAyAEIAVnaiIKOgADIAMgBSAKdCAMazsBACADIAYgCGotAAA6AAIgAyAHIAZBAnRqKAIANgIEIAJBAWoiAiAMRw0ACyABIAA2AgAgGCEDDAILIAEgCTYCAAtBACEDCyAPQYABaiQAIAML7gMBB39Bun8hCwJAIAIoAgQiCiACKAIAIglqIg0gASAAa0sNAEFsIQsgCSAEIAMoAgAiCGtLDQAgAUEgayEEIAggCWohDiAAIAlqIQEgAigCCCEMAkAgCUEHTARAIAlBAEwNAQNAIAAgCC0AADoAACAIQQFqIQggAEEBaiIAIAFJDQALDAELIAEgBE0EQCAAIAj9AAAA/QsAACAJQRFJDQEgAEEQaiEAA0AgACAI/QAAEP0LAAAgACAI/QAAIP0LABAgCEEgaiEIIABBIGoiACABSQ0ACwwBCyAAIARNBEAgACAI/QAAAP0LAAAgBCAAayIJQRFOBEAgAEEQaiEAIAghAgNAIAAgAv0AABD9CwAAIAAgAv0AACD9CwAQIAJBIGohAiAAQSBqIgAgBEkNAAsLIAggCWohCCAEIQALIAAgAU8NAANAIAAgCC0AADoAACAIQQFqIQggAEEBaiIAIAFJDQALCyABIAxrIQggAyAONgIAAkACQCABIAVrIAxPBEAgCCEFDAELIAwgASAGa0sNAiAHIAcgCCAFayIIaiIAIApqTwRAIApFDQIgASAAIAr8CgAADAILQQAgCGsiAgRAIAEgACAC/AoAAAsgCCAKaiEKIAEgCGshAQsgASAEIAUgChDRDAsgDSELCyALC+gEAQh/Qbp/IQkCQCADKAIEIgwgAygCACILaiIPIAEgAGtLDQAgBSAEKAIAIgFrIAtJBEBBbA8LIAMoAgghDSAAIAFLIAEgC2oiECAAS3ENACAAIAtqIQUCQAJAIAtBCE4EQCAAIAFrIgNBeUgNAQsgC0EATA0BA0AgACABLQAAOgAAIAFBAWohASAAQQFqIgAgBUkNAAsMAQsCQCAFQSBrIgogAEkEQCAAIQoMAQsgA0FvSwRAIAAhCgwBCyAAIAH9AAAA/QsAACAKIABrIg5BEU4EQCAAQRBqIQMgASEJA0AgAyAJ/QAAEP0LAAAgAyAJ/QAAIP0LABAgCUEgaiEJIANBIGoiAyAKSQ0ACwsgASAOaiEBCwJAIAAgC2oiCSAKayIOQQdxIgtFBEAgCiEADAELQQAhAyAKIQADQCAAIAEtAAA6AAAgAEEBaiEAIAFBAWohASADQQFqIgMgC0cNAAsLIAogCWtBeEsNACAKIA5qIQMDQCAAIAEtAAA6AAAgACABLQABOgABIAAgAS0AAjoAAiAAIAEtAAM6AAMgACABLQAEOgAEIAAgAS0ABToABSAAIAEtAAY6AAYgACABLQAHOgAHIAFBCGohASAAQQhqIgAgA0cNAAsLIAUgDWshASAEIBA2AgACQAJAIAUgBmsgDU8EQCABIQYMAQtBbCEJIA0gBSAHa0sNAiAIIAggASAGayIBaiIAIAxqTwRAIAxFDQIgBSAAIAz8CgAADAILQQAgAWsiAwRAIAUgACAD/AoAAAsgASAMaiEMIAUgAWshBQsgBSACIAYgDBDRDAsgDyEJCyAJC8ATAhN/An4jAEEQayIQJAAgEEEANgIMIBBBADYCCAJ/IANB1AlqIgcgAyAQQQhqIBBBDGogASACIANB6ABqEMsLIhRBiH9NBEAgECgCCCELAkBBCiAAKAIAIhJB/wFxIgkgCUEKTxtBAWoiDiAQKAIMIg9JBEAgDyEODAELIA4gD00NACAOIA9rIQECQCALRQ0AIAtBA3EhBkEAIQIgC0EETwRAIANB1wlqIQogA0HWCWohDSADQdUJaiEMIAtBfHEhCANAIAIgB2oiBCABQQAgBC0AACIEGyAEajoAACACIAxqIgQgAUEAIAQtAAAiBBsgBGo6AAAgAiANaiIEIAFBACAELQAAIgQbIARqOgAAIAIgCmoiBCABQQAgBC0AACIEGyAEajoAACACQQRqIgIgCEcNAAsLIAZFDQADQCACIAdqIgQgAUEAIAQtAAAiBBsgBGo6AAAgAkEBaiECIAVBAWoiBSAGRw0ACwsgDwRAIA4hAgNAIAMgAkECdGogAyACIAFrQQJ0aigCADYCACACQQFrIgIgAUsNAAsLIAFBAnQiAkUNACADQQRqQQAgAvwLAAtBVCAOIAlBAWpLDQEaIAAgEkH/gYB4cSAOQRB0QYCA/AdxcjYCACADQTRqIQIgDkEBaiITQQNxIQxBACEGQQAhAUEAIQUgDkEDTwRAIBNBfHEhCANAIAMgAUECdCIEaigCACEJIAIgBGogBTYCACADIARBBHIiCmooAgAhDSACIApqIAUgCWoiBTYCACADIARBCHIiCWooAgAhCiACIAlqIAUgDWoiBTYCACADIARBDHIiBGooAgAhCSACIARqIAUgCmoiBTYCACAFIAlqIQUgAUEEaiIBIAhHDQALCyAMBEADQCADIAFBAnQiBGooAgAhCSACIARqIAU2AgAgAUEBaiEBIAUgCWohBSAGQQFqIgYgDEcNAAsLQQAhASALQQROBEAgC0EDayEJIANB1AdqIQUDQCACIAEgB2otAABBAnRqIgQgBCgCACIEQQFqNgIAIAQgBWogAToAACACIAcgAUEBciIEai0AAEECdGoiBiAGKAIAIgZBAWo2AgAgBSAGaiAEOgAAIAIgByABQQJyIgRqLQAAQQJ0aiIGIAYoAgAiBkEBajYCACAFIAZqIAQ6AAAgAiAHIAFBA3IiBGotAABBAnRqIgYgBigCACIGQQFqNgIAIAUgBmogBDoAACABQQRqIgEgCUgNAAsLAkAgASALTg0AIAFBAWohBCADQdQHaiEFIAsgAWtBAXEEQCACIAEgB2otAABBAnRqIgYgBigCACIGQQFqNgIAIAUgBmogAToAACAEIQELIAQgC0YNAANAIAIgASAHai0AAEECdGoiBCAEKAIAIgRBAWo2AgAgBCAFaiABOgAAIAIgByABQQFqIgRqLQAAQQJ0aiIGIAYoAgAiBkEBajYCACAFIAZqIAQ6AAAgAUECaiIBIAtHDQALCyAAQQRqIQ0gAEEMaiEVIANB1AdqIQwgAygCACEKQQEhAgNAIBMgAiISayEBIAMgAkECdGooAgAhCAJAAkACQAJAAkACQEEBIAJ0QQF1IgtBAWsiAg4IAwIEAQQEBAAECyAIQQBMDQQgAUH/AXGtIRdBACEBIBEhBSAIQQFHBEAgCEEBcSEGIAhB/v///wdxIQQDQCANIAVBAXRqIgIgDCABIApqaiIHMQAAQgiGIBeEQoGAhICQgMAAfiIYNwAIIAIgGDcAACACIAcxAAFCCIYgF4RCgYCEgJCAwAB+Ihg3ABggAiAYNwAQIAVBEGohBSABQQJqIgEgBEcNAAsgBkUNBQsgDSAFQQF0aiICIAwgASAKamoxAABCCIYgF4RCgYCEgJCAwAB+Ihc3AAggAiAXNwAADAQLIAhBAEwNAyABQf8Bca0hF0EAIQIgESEBIAhBAUcEQCAIQQFxIQYgCEH+////B3EhBANAIA0gAUEBdCIFaiAMIAIgCmpqIgcxAABCCIYgF4RCgYCEgJCAwAB+NwAAIAUgFWogBzEAAUIIhiAXhEKBgISAkIDAAH43AAAgAUEIaiEBIAJBAmoiAiAERw0ACyAGRQ0ECyANIAFBAXRqIAwgAiAKamoxAABCCIYgF4RCgYCEgJCAwAB+NwAADAMLIAhBAEwNAkEAIQUgESEHIAhBAUcEQCAIQQFxIQAgCEH+////B3EhCQNAIA0gB0EBdGoiAiAMIAUgCmpqIgQtAAAiBjoAAyACIAE6AAIgAiAGOgABIAIgAToAACACIAQtAAEiBDoAByACIAE6AAYgAiAEOgAFIAIgAToABCAHQQRqIQcgBUECaiIFIAlHDQALIABFDQMLIA0gB0EBdGoiAiAMIAUgCmpqLQAAIgU6AAMgAiABOgACIAIgBToAASACIAE6AAAMAgsgCEEATA0BQQAhByARIQQgCEEBRwRAIAhBAmsiAEECTwRAIABBAXZBAWpBfnEhCUEAIQYDQCANIARBAXRqIgIgDCAHIApqaiIFLQAAOgABIAIgAToAACACIAUtAAE6AAMgAiABOgACIAIgBS0AAjoABSACIAE6AAQgAiAFLQADOgAHIAIgAToABiAHQQRqIQcgBEEEaiEEIAZBAmoiBiAJRw0ACwsgCEEBcSECIABBAnFFBEAgDSAEQQF0aiIFIAwgByAKamoiBi0AADoAASAFIAE6AAAgBSAGLQABOgADIAUgAToAAiAHQQJqIQcgBEECaiEECyACRQ0CCyANIARBAXRqIgIgDCAHIApqai0AADoAASACIAE6AAAMAQsgCEEATA0AIAJBBHZBAWoiAkH8////AXEhCSACQQNxIQYgAUH/AXGtIRhBACEAIAtBMUkhFiARIQ8DQAJAIAtBAEwNACAMIAAgCmpqMQAAQgiGIBiEQoGAhICQgMAAfiEXIA0gD0EBdGohB0EAIQVBACEBQQAhBCAWRQRAA0AgByABQQF0aiICIBc3AHggAiAXNwBwIAIgFzcAaCACIBc3AGAgAiAXNwBYIAIgFzcAUCACIBc3AEggAiAXNwBAIAIgFzcAOCACIBc3ADAgAiAXNwAoIAIgFzcAICACIBc3ABggAiAXNwAQIAIgFzcACCACIBc3AAAgAUFAayEBIARBBGoiBCAJRw0ACwsgBkUNAANAIAcgAUEBdGoiAiAXNwAYIAIgFzcAECACIBc3AAggAiAXNwAAIAFBEGohASAFQQFqIgUgBkcNAAsLIAsgD2ohDyAAQQFqIgAgCEcNAAsLIBJBAWohAiAIIApqIQogCCALbCARaiERIA4gEkcNAAsLIBQLIQIgEEEQaiQAIAIL+goCAX4FfwJAAkACQAJAAkACQEEBIAQgA2siBHQiCUEBaw4IAwIEAQQEBAAECyABIAJGDQQgBkEYdCADQRB0aiEEIAIgAWtBAXEEfyAAIAEtAAAiAyADQQh0IAVyIAZBAUYbIARyrUKBgICAEH4iBzcBGCAAIAc3ARAgACAHNwEIIAAgBzcBACAAQSBqIQAgAUEBagUgAQshAyACQQFrIAFGDQQgBkEBRiEIA0AgACADLQAAIgEgAUEIdCAFciAIGyAEcq1CgYCAgBB+Igc3ARggACAHNwEQIAAgBzcBCCAAIAc3AQAgACADLQABIgEgAUEIdCAFciAIGyAEcq1CgYCAgBB+Igc3ATggACAHNwEwIAAgBzcBKCAAIAc3ASAgAEFAayEAIANBAmoiAyACRw0ACwwECyABIAJGDQMgBkEYdCADQRB0aiEEIAIgAWtBAXEEfyAAIAEtAAAiAyADQQh0IAVyIAZBAUYbIARyrUKBgICAEH4iBzcBCCAAIAc3AQAgAEEQaiEAIAFBAWoFIAELIQMgAkEBayABRg0DIAZBAUYhCANAIAAgAy0AACIBIAFBCHQgBXIgCBsgBHKtQoGAgIAQfiIHNwEIIAAgBzcBACAAIAMtAAEiASABQQh0IAVyIAgbIARyrUKBgICAEH4iBzcBGCAAIAc3ARAgAEEgaiEAIANBAmoiAyACRw0ACwwDCyABIAJGDQIgBkEYdCADQRB0aiEEAkAgAiABa0EDcSIJRQRAIAEhAwwBCyABIQMDQCAAIAMtAAAiCiAKQQh0IAVyIAZBAUYbIARyIgo2AQQgACAKNgEAIANBAWohAyAAQQhqIQAgCEEBaiIIIAlHDQALCyABIAJrQXxLDQIgBkEBRiEIA0AgACADLQAAIgEgAUEIdCAFciAIGyAEciIBNgEEIAAgATYBACAAIAMtAAEiASABQQh0IAVyIAgbIARyIgE2AQwgACABNgEIIAAgAy0AAiIBIAFBCHQgBXIgCBsgBHIiATYBFCAAIAE2ARAgACADLQADIgEgAUEIdCAFciAIGyAEciIBNgEcIAAgATYBGCAAQSBqIQAgA0EEaiIDIAJHDQALDAILIAEgAkYNASAGQRh0IANBEHRqIQQCQCACIAFrQQNxIglFBEAgASEDDAELIAEhAwNAIAAgAy0AACIKIApBCHQgBXIgBkEBRhsgBHI2AQAgA0EBaiEDIABBBGohACAIQQFqIgggCUcNAAsLIAEgAmtBfEsNASAGQQFGIQgDQCAAIAMtAAAiASABQQh0IAVyIAgbIARyNgEAIAAgAy0AASIBIAFBCHQgBXIgCBsgBHI2AQQgACADLQACIgEgAUEIdCAFciAIGyAEcjYBCCAAIAMtAAMiASABQQh0IAVyIAgbIARyNgEMIABBEGohACADQQRqIgMgAkcNAAsMAQsgASACRg0AIAZBGHQgA0EQdGohCkEEIAR0QSBrIgtBBXZBAWpBA3EhCCAJQQJ0IQwgC0HgAHFB4ABGIQkgACEDA0AgAS0AACIEIARBCHQgBXIgBkEBRhsgCnKtQoGAgIAQfiEHQQAhBAJAIAlFBEADQCADIAc3ARggAyAHNwEQIAMgBzcBCCADIAc3AQAgA0EgaiEDIARBAWoiBCAIRw0ACyALQeAASQ0BCyAAIAxqIQADQCADIAc3AXggAyAHNwFwIAMgBzcBaCADIAc3AWAgAyAHNwFYIAMgBzcBUCADIAc3AUggAyAHNwFAIAMgBzcBOCADIAc3ATAgAyAHNwEoIAMgBzcBICADIAc3ARggAyAHNwEQIAMgBzcBCCADIAc3AQAgA0GAAWoiAyAARw0ACwsgAyEAIAFBAWoiASACRw0ACwsLvwYBCX8gA0UEQEG4fw8LIARBBGohCSAAIAFqIQogBC8BAiEMAn8CQAJAAkACQAJAIANBBE8EQEF/IAIgA2pBAWstAAAiBUUNBhogA0GIf00NASADDwsgAi0AACEHAkACQAJAIANBAmsOAgEAAgsgAi0AAkEQdCAHciEHCyACLQABQQh0IAdqIQcLIAIgA2pBAWstAAAiBA0BQWwPC0EIIAVnQR9zayEGIAIgA0EEayIFaiIEKAAAIQcgAUEDTQ0BIAYhAwwCCyAEZyADQQN0a0EJaiEDIAFBBE8NASACIQQMAgsCfyADQQhOBEAgBkEHcSEDIAQgBkEDdmsMAQsgBUUEQCAGIQMMAwsgBiAFIAZBA3YiAyAEIANrIAJJGyIFQQN0ayEDIAQgBWsLIgQoAAAhBwwBCyAKQQNrIQ1BACAMa0EfcSEIA0ACfyAFQQROBEAgA0EDdiEEQQEhCyADQQdxDAELIAIgBWohBCAFRQ0CIAMgA0EDdiIHIAUgBCAHayACTyILGyIEQQN0awshBiACIAUgBGsiBWoiBCgAACEHIAAgDU8EQCAGIQMMAgsgC0UEQCAGIQMMAgsgCSAHIAZ0IAh2QQF0aiIELQAAIQMgACAELQABOgAAIAkgByADIAZqIgR0IAh2QQF0aiIDLQAAIQYgACADLQABOgABIABBAmohACAEIAZqIgNBIE0NAAtBkJUyIQQLQQAgDGtBH3EhCAJAAkACfyADQSBNBEAgAkEEaiELA0ACfyAEIAtPBEAgA0EDdiEHQQEhBiADQQdxDAELIAIgBEYEQCADIQUgAgwECyADIANBA3YiBSAEIAJrIAQgBWsgAk8iBhsiB0EDdGsLIQUgBCAHayIEKAAAIQcgACAKTyIDQQEgBhsEQCADDQUMBAsgCSAHIAV0IAh2QQF0aiIDLQAAIQYgACADLQABOgAAIABBAWohACAFIAZB/wFxaiIDQSBNDQALCyADIQVBkJUyCyEEIAAgCk8NAQsDQCAJIAcgBXQgCHZBAXRqIgMtAAAhBiAAIAMtAAE6AAAgBSAGQf8BcWohBSAAQQFqIgAgCkkNAAsLQWxBbCABIAVBIEcbIAIgBEcbCwvGJAEmfyMAQSBrIgckAEFsIQUCQCABQQZJDQAgA0EKSQ0AIAIvAAQiCiACLwAAIgUgAi8AAiIIampBBmoiDyADSwRAQWwhBQwBCyAAIAFBA2pBAnYiBmoiFCAGaiIaIAZqIhggACABaiIcSwRAQWwhBQwBCyAFRQRAQbh/IQUMAQsgAkEGaiIZIAVqIREgBC8BAiEXAkAgBUEETwRAQX8hBSARQQFrLQAAIgZFDQJBCCAGZ0Efc2shCSARQQRrIg0oAAAhBgwBCyAZLQAAIQYCQAJAAkAgBUECaw4CAQACCyACLQAIQRB0IAZyIQYLIAItAAdBCHQgBmohBgsgEUEBay0AACINRQRAQWwhBQwCCyANZyAFQQN0a0EJaiEJIBkhDQsgCEUEQEG4fyEFDAELIAggEWohEgJ/IAhBBE8EQEF/IQUgEkEBay0AACIIRQ0CIBJBBGsiDigAACEQQQggCGdBH3NrDAELIBEtAAAhEAJAAkACQCAIQQJrDgIBAAILIBEtAAJBEHQgEHIhEAsgES0AAUEIdCAQaiEQCyASQQFrLQAAIgVFBEBBbCEFDAILIBEhDiAFZyAIQQN0a0EJagshDEG4fyEFIApFDQAgCiASaiEIAkAgCkEETwRAQX8hBSAIQQFrLQAAIgpFDQJBCCAKZ0Efc2shCyAIQQRrIgooAAAhFQwBCyASLQAAIRUCQAJAAkAgCkECaw4CAQACCyASLQACQRB0IBVyIRULIBItAAFBCHQgFWohFQsgCEEBay0AACIFRQRAQWwhBQwCCyAFZyAKQQN0a0EJaiELIBIhCgsgB0EMaiAIIAMgD2sQ0AwiBUGIf0sNACAEQQRqIQMgHEEDayEjIAJBCmohICARQQRqISEgEkEEaiEiAkAgHCAYa0EESQRAIBghAiAaIQggFCEEDAELIAcoAgwhFgJAIBggI08EQCAYIQIgGiEIIBQhBAwBC0EAIBdrQR9xIQUgBygCFCEbIAcoAhAhDyAHKAIcIScgFCEEIBohCCAYIQIDQCAAIAMgBiAJdCAFdkECdGoiEy8BADsAACATLQACIR0gEy0AAyEkIAQgAyAQIAx0IAV2QQJ0aiITLwEAOwAAIBMtAAIhHiATLQADISUgCCADIBUgC3QgBXZBAnRqIhMvAQA7AAAgEy0AAiEfIBMtAAMhJiACIAMgFiAPdCAFdkECdGoiEy8BADsAACATLQACISggEy0AAyETIAAgJGoiJCADIAYgCSAdaiIJdCAFdkECdGoiAC8BADsAACAALQACIR0gAC0AAyEpIAQgJWoiBCADIBAgDCAeaiIMdCAFdkECdGoiAC8BADsAACAALQACIR4gAC0AAyElIAggJmoiCCADIBUgCyAfaiILdCAFdkECdGoiAC8BADsAACAALQACIR8gAC0AAyEmIAIgE2oiKiADIBYgDyAoaiIAdCAFdkECdGoiAi8BADsAACAHIAAgAi0AAmoiDzYCECAJIB1qIQACfyANICBJBEBBAyEdIAAMAQsgDSAAQQN2ayINKAAAIQZBACEdIABBB3ELIQkgAi0AAyEAIAwgHmohAkEDIRMCfyAOICFJBEBBAyEeIAIMAQsgDiACQQN2ayIOKAAAIRBBACEeIAJBB3ELIQwgCyAfaiECIAogIkkEfyACBSAKIAJBA3ZrIgooAAAhFUEAIRMgAkEHcQshCyAAICpqIQIgGyAnSQR/QQMFIAcgD0EHcSIANgIQIBsgD0EDdmsiGygAACEWIAAhD0EACyEfICQgKWohACAEICVqIQQgCCAmaiEIIB0gHnIgE3IgH3JFIAIgI0lxDQALIAcgGzYCFAsgByAWNgIMCyAAIBRLBEBBbCEFDAELIAQgGksEQEFsIQUMAQtBbCEFIAggGEsNAAJAAkACQCAUIABrIgVBBE8EQCAJQSFPBEAgFEECayEWQQAgF2tBH3EhG0GQlTIhEwwDCyAUQQNrIRtBACAXa0EfcSEPA0ACfyANICBPBEAgCUEDdiEGQQEhFiAJQQdxDAELIA0gGUYEQCAZIQ0gFCAAayEFDAQLIAkgCUEDdiIFIA0gGWsgDSAFayAZTyIWGyIGQQN0awshBSANIAZrIg0oAAAhBiAAIBtPBEAgBSEJIBQgAGshBQwDCyAWRQRAIAUhCSAUIABrIQUMAwsgACADIAYgBXQgD3ZBAnRqIgkvAQA7AAAgACAJLQADaiIAIAMgBiAFIAktAAJqIgl0IA92QQJ0aiIFLwEAOwAAIAAgBS0AA2ohACAJIAUtAAJqIglBIE0NAAtBkJUyIQ0gFCAAayEFDAELIAlBIEsEQEGQlTIhDQwBCyANICBPBEAgDSAJQQN2ayINKAAAIQYgCUEHcSEJDAELIA0gGUYEQCAZIQ0MAQsgCSANIBlrIAlBA3YiBiANIAZrIBlJGyIGQQN0ayEJIA0gBmsiDSgAACEGCyAFQQJJDQEgFEECayEWQQAgF2tBH3EhG0GQlTIhEyAJQSBLDQADQAJ/IA0gIE8EQCAJQQN2IQZBASEPIAlBB3EMAQsgDSAZRgRAIBkhEwwDCyAJIAlBA3YiBSANIBlrIA0gBWsgGU8iDxsiBkEDdGsLIQUgDSAGayINKAAAIQYgACAWTUEAIA8bRQRAIAUhCSANIRMMAgsgACADIAYgBXQgG3ZBAnRqIgkvAQA7AAAgACAJLQADaiEAIAUgCS0AAmoiCUEgTQ0ACwsgACAWTQRAA0AgACADIAYgCXQgG3ZBAnRqIgUvAQA7AAAgCSAFLQACaiEJIAAgBS0AA2oiACAWTQ0ACwsgEyENCwJAIAAgFE8NACAAIAMgBiAJdEEAIBdrdkECdGoiBS0AADoAACAFLQADQQFGBEAgCSAFLQACaiEJDAELIAlBH0sNAEEgIAkgBS0AAmoiBSAFQSBPGyEJCwJAAkACQCAaIARrIgVBBE8EQCAMQSFPBEAgGkECayEPQQAgF2tBH3EhFEGQlTIhFgwDCyAaQQNrIRRBACAXa0EfcSEGA0ACfyAOICFPBEAgDEEDdiEAQQEhDyAMQQdxDAELIA4gEUYEQCARIQ4gGiAEayEFDAQLIAwgDEEDdiIFIA4gEWsgDiAFayARTyIPGyIAQQN0awshBSAOIABrIg4oAAAhECAEIBRPBEAgBSEMIBogBGshBQwDCyAPRQRAIAUhDCAaIARrIQUMAwsgBCADIBAgBXQgBnZBAnRqIgAvAQA7AAAgBCAALQADaiIEIAMgECAFIAAtAAJqIgB0IAZ2QQJ0aiIFLwEAOwAAIAQgBS0AA2ohBCAAIAUtAAJqIgxBIE0NAAtBkJUyIQ4gGiAEayEFDAELIAxBIEsEQEGQlTIhDgwBCyAOICFPBEAgDiAMQQN2ayIOKAAAIRAgDEEHcSEMDAELIA4gEUYEQCARIQ4MAQsgDCAOIBFrIAxBA3YiACAOIABrIBFJGyIAQQN0ayEMIA4gAGsiDigAACEQCyAFQQJJDQEgGkECayEPQQAgF2tBH3EhFEGQlTIhFiAMQSBLDQADQAJ/IA4gIU8EQCAMQQN2IQBBASEGIAxBB3EMAQsgDiARRgRAIBEhFgwDCyAMIAxBA3YiBSAOIBFrIA4gBWsgEU8iBhsiAEEDdGsLIQUgDiAAayIOKAAAIRAgBCAPTUEAIAYbRQRAIA4hFiAFIQwMAgsgBCADIBAgBXQgFHZBAnRqIgAvAQA7AAAgBCAALQADaiEEIAUgAC0AAmoiDEEgTQ0ACwsgBCAPTQRAA0AgBCADIBAgDHQgFHZBAnRqIgUvAQA7AAAgDCAFLQACaiEMIAQgBS0AA2oiBCAPTQ0ACwsgFiEOCwJAIAQgGk8NACAEIAMgECAMdEEAIBdrdkECdGoiBS0AADoAACAFLQADQQFGBEAgDCAFLQACaiEMDAELIAxBH0sNAEEgIAwgBS0AAmoiBSAFQSBPGyEMCwJAAkACQCAYIAhrIgVBBE8EQCALQSFPBEAgGEECayEGQQAgF2tBH3EhEEGQlTIhDwwDCyAYQQNrIRBBACAXa0EfcSEEA0ACfyAKICJPBEAgC0EDdiEAQQEhBiALQQdxDAELIAogEkYEQCASIQogGCAIayEFDAQLIAsgC0EDdiIFIAogEmsgCiAFayASTyIGGyIAQQN0awshBSAKIABrIgooAAAhFSAIIBBPBEAgBSELIBggCGshBQwDCyAGRQRAIAUhCyAYIAhrIQUMAwsgCCADIBUgBXQgBHZBAnRqIgAvAQA7AAAgCCAALQADaiIGIAMgFSAFIAAtAAJqIgB0IAR2QQJ0aiIFLwEAOwAAIAYgBS0AA2ohCCAAIAUtAAJqIgtBIE0NAAtBkJUyIQogGCAIayEFDAELIAtBIEsEQEGQlTIhCgwBCyAKICJPBEAgCiALQQN2ayIKKAAAIRUgC0EHcSELDAELIAogEkYEQCASIQoMAQsgCyAKIBJrIAtBA3YiACAKIABrIBJJGyIAQQN0ayELIAogAGsiCigAACEVCyAFQQJJDQEgGEECayEGQQAgF2tBH3EhEEGQlTIhDyALQSBLDQADQAJ/IAogIk8EQCALQQN2IQBBASEEIAtBB3EMAQsgCiASRgRAIBIhDwwDCyALIAtBA3YiBSAKIBJrIAogBWsgEk8iBBsiAEEDdGsLIQUgCiAAayIKKAAAIRUgBiAIT0EAIAQbRQRAIAohDyAFIQsMAgsgCCADIBUgBXQgEHZBAnRqIgAvAQA7AAAgCCAALQADaiEIIAUgAC0AAmoiC0EgTQ0ACwsgBiAITwRAA0AgCCADIBUgC3QgEHZBAnRqIgUvAQA7AAAgCyAFLQACaiELIAggBS0AA2oiCCAGTQ0ACwsgDyEKCwJAIAggGE8NACAIIAMgFSALdEEAIBdrdkECdGoiBS0AADoAACAFLQADQQFGBEAgCyAFLQACaiELDAELIAtBH0sNAEEgIAsgBS0AAmoiBSAFQSBPGyELCyAHKAIQIQUCQCAcIAJrQQRPBEAgBUEgTQRAQQAgF2tBH3EhBANAIAcCfyAHKAIUIgAgBygCHE8EQCAHIAAgBUEDdmsiADYCFEEBIQYgBUEHcQwBCyAAIAcoAhgiBkYNBCAHIAAgBUEDdiIIIAAgBmsgACAIayAGTyIGGyIIayIANgIUIAUgCEEDdGsLIgU2AhAgByAAKAAAIgA2AgwgAiAjTw0DIAZFDQMgAiADIAAgBXQgBHZBAnRqIgUvAQA7AAAgByAHKAIQIAUtAAJqIgA2AhAgAiAFLQADaiIGIAMgBygCDCAAdCAEdkECdGoiAi8BADsAACAHIAcoAhAgAi0AAmoiBTYCECAGIAItAANqIQIgBUEgTQ0ACwsgB0GQlTI2AhQMAQsgBUEhTwRAIAdBkJUyNgIUDAELIAcoAhQiACAHKAIcTwRAIAcgBUEHcSIENgIQIAcgACAFQQN2ayIFNgIUIAcgBSgAADYCDCAEIQUMAQsgACAHKAIYIgRGDQAgByAFIAAgBGsgBUEDdiIGIAAgBmsgBEkbIgRBA3RrIgU2AhAgByAAIARrIgA2AhQgByAAKAAANgIMCwJAIBwgAmtBAkkNACAcQQJrIQZBACAXa0EfcSEIAkAgBUEhSQRAA0AgBwJ/IAcoAhQiACAHKAIcTwRAIAcgACAFQQN2ayIANgIUQQEhBCAFQQdxDAELIAAgBygCGCIERg0DIAcgACAFQQN2IhAgACAEayAAIBBrIARPIgQbIhBrIgA2AhQgBSAQQQN0awsiBTYCECAHIAAoAAAiADYCDCACIAZLDQIgBEUNAiACIAMgACAFdCAIdkECdGoiAC8BADsAACAHIAcoAhAgAC0AAmoiBTYCECACIAAtAANqIQIgBUEgTQ0ACwsgB0GQlTI2AhQLIAIgBksNAANAIAIgAyAHKAIMIAV0IAh2QQJ0aiIALwEAOwAAIAcgBygCECAALQACaiIFNgIQIAIgAC0AA2oiAiAGTQ0ACwsCQCACIBxPDQAgAiADIAcoAgwgBXRBACAXa3ZBAnRqIgAtAAA6AAAgAC0AA0EBRgRAIAcoAhAgAC0AAmohBQwBCyAHKAIQIgVBH0sNAEEgIAUgAC0AAmoiAiACQSBPGyEFC0FsQWxBbEFsQWxBbEFsQWwgASAFQSBHGyAHKAIUIAcoAhhHGyALQSBHGyAKIBJHGyAMQSBHGyAOIBFHGyAJQSBHGyANIBlHGyEFCyAHQSBqJAAgBQunHwEifyMAQSBrIgckAEFsIQYCQCABQQZJDQAgA0EKSQ0AIAIvAAQiCSACLwAAIgYgAi8AAiIIampBBmoiDCADSwRAQWwhBgwBCyAAIAFBA2pBAnYiC2oiFiALaiIZIAtqIhggACABaiIaSwRAQWwhBgwBCyAGRQRAQbh/IQYMAQsgAkEGaiIXIAZqIRAgBC8BAiEgAn8gBkEETwRAQX8hBiAQQQFrLQAAIgtFDQIgEEEEayINKAAAIQVBCCALZ0Efc2sMAQsgFy0AACEFAkACQAJAIAZBAmsOAgEAAgsgAi0ACEEQdCAFciEFCyACLQAHQQh0IAVqIQULIBBBAWstAAAiC0UEQEFsIQYMAgsgFyENIAtnIAZBA3RrQQlqCyEKIAhFBEBBuH8hBgwBCyAIIBBqIRECfyAIQQRPBEBBfyEGIBFBAWstAAAiC0UNAiARQQRrIg4oAAAhEkEIIAtnQR9zawwBCyAQLQAAIRICQAJAAkAgCEECaw4CAQACCyAQLQACQRB0IBJyIRILIBAtAAFBCHQgEmohEgsgEUEBay0AACIGRQRAQWwhBgwCCyAQIQ4gBmcgCEEDdGtBCWoLIQhBuH8hBiAJRQ0AIAkgEWohCwJ/IAlBBE8EQEF/IQYgC0EBay0AACIJRQ0CIAtBBGsiDygAACEUQQggCWdBH3NrDAELIBEtAAAhFAJAAkACQCAJQQJrDgIBAAILIBEtAAJBEHQgFHIhFAsgES0AAUEIdCAUaiEUCyALQQFrLQAAIgZFBEBBbCEGDAILIBEhDyAGZyAJQQN0a0EJagshCSAHQQxqIAsgAyAMaxDQDCIGQYh/Sw0AIARBBGohAyAaQQNrISMgAkEKaiEbIBBBBGohISARQQRqISICQCAaIBhrQQRJBEAgGCELIBkhBCAWIQIMAQsgBygCDCEVAkAgGCAjTwRAIBghCyAZIQQgFiECDAELQQAgIGtBH3EhBiAHKAIUIRwgBygCECEMIAcoAhwhJSAWIQIgGSEEIBghCwNAIAMgBSAKdCAGdkEBdGoiEy0AACEdIAAgEy0AAToAACADIBIgCHQgBnZBAXRqIhMtAAAhHiACIBMtAAE6AAAgAyAUIAl0IAZ2QQF0aiITLQAAISQgBCATLQABOgAAIAMgFSAMdCAGdkEBdGoiEy0AACEfIAsgEy0AAToAACADIAUgCiAdaiIKdCAGdkEBdGoiEy0AACEdIAAgEy0AAToAASADIBIgCCAeaiITdCAGdkEBdGoiCC0AACEeIAIgCC0AAToAASADIBQgCSAkaiIkdCAGdkEBdGoiCC0AACEmIAQgCC0AAToAASADIBUgDCAfaiIIdCAGdkEBdGoiCS0AASEfIAcgCCAJLQAAaiIMNgIQIAsgHzoAASAKIB1qIQgCfyANIBtJBEBBAyEfIAgMAQsgDSAIQQN2ayINKAAAIQVBACEfIAhBB3ELIQogEyAeaiEJQQMhHQJ/IA4gIUkEQEEDIR4gCQwBCyAOIAlBA3ZrIg4oAAAhEkEAIR4gCUEHcQshCCAkICZqIRMgDyAiSQR/IBMFIA8gE0EDdmsiDygAACEUQQAhHSATQQdxCyEJIARBAmohBCACQQJqIQIgAEECaiEAIBwgJUkEf0EDBSAHIAxBB3EiEzYCECAcIAxBA3ZrIhwoAAAhFSATIQxBAAsgHiAfciAdcnJFICMgC0ECaiILS3ENAAsgByAcNgIUCyAHIBU2AgwLIAAgFksEQEFsIQYMAQsgAiAZSwRAQWwhBgwBC0FsIQYgBCAYSw0AAkACQAJ/AkACfwJAAkACQAJAIBYgAGtBBE4EQCAKQSBLDQIgFkEDayEcQQAgIGtBH3EhBgNAAn8gDSAbTwRAIApBA3YhBUEBIRUgCkEHcQwBCyANIBdGDQYgCiAKQQN2IgUgDSAXayANIAVrIBdPIhUbIgVBA3RrCyEMIA0gBWsiDSgAACEFIAAgHE8EQCAMIQoMAwsgFUUEQCAMIQoMAwsgAyAFIAx0IAZ2QQF0aiIKLQAAIRUgACAKLQABOgAAIAMgBSAMIBVqIgp0IAZ2QQF0aiIMLQAAIRUgACAMLQABOgABIABBAmohACAKIBVqIgpBIE0NAAsMAgsgCkEgSw0BIA0gG08EQCANIApBA3ZrIg0oAAAhBSAKQQdxDAULIA0gF0YNAyAKIA0gF2sgCkEDdiIGIA0gBmsgF0kbIgZBA3RrIQogDSAGayINKAAAIQVBACAga0EfcSEGCyAKQSBLDQEgCiEMDAQLQQAgIGtBH3EhBgtBkJUyDAMLIBchDSAKCyEMQQAgIGtBH3EhBgsDQAJ/IA0gG08EQCAMQQN2IQVBASEVIAxBB3EMAQsgDSAXRgRAIAwhCiAXDAMLIAwgDEEDdiIKIA0gF2sgDSAKayAXTyIVGyIFQQN0awshCiANIAVrIg0oAAAhBSAAIBZPIgxBASAVGwRAIAwNBAwDCyADIAUgCnQgBnZBAXRqIgwtAAAhFSAAIAwtAAE6AAAgAEEBaiEAIAogFWoiDEEgTQ0ACyAMIQpBkJUyCyENIAAgFk8NAQsDQCADIAUgCnQgBnZBAXRqIgwtAAAhGyAAIAwtAAE6AAAgCiAbaiEKIABBAWoiACAWSQ0ACwsCQAJAAn8CQAJ/AkACQAJAAkAgGSACa0EETgRAIAhBIEsNBiAZQQNrIQwDQAJ/IA4gIU8EQCAIQQN2IQVBASEWIAhBB3EMAQsgDiAQRg0DIAggCEEDdiIAIA4gEGsgDiAAayAQTyIWGyIFQQN0awshACAOIAVrIg4oAAAhEiACIAxPBEAgACEIDAULIBZFBEAgACEIDAULIAMgEiAAdCAGdkEBdGoiBS0AACEIIAIgBS0AAToAACADIBIgACAIaiIAdCAGdkEBdGoiBS0AACEIIAIgBS0AAToAASACQQJqIQIgACAIaiIIQSBNDQALDAYLIAhBIEsNBSAOICFPBEAgDiAIQQN2ayIOKAAAIRIgCEEHcQwFCyAOIBBHDQELIBAhDgwCCyAIIA4gEGsgCEEDdiIAIA4gAGsgEEkbIgBBA3RrIQggDiAAayIOKAAAIRILIAhBIEsNAgsgCAshAANAAn8gDiAhTwRAIABBA3YhBUEBIRYgAEEHcQwBCyAOIBBGBEAgACEIIBAMBAsgACAAQQN2IgUgDiAQayAOIAVrIBBPIhYbIgVBA3RrCyEIIA4gBWsiDigAACESIAIgGU8iAEEBIBYbBEAgAA0FDAQLIAMgEiAIdCAGdkEBdGoiAC0AACEFIAIgAC0AAToAACACQQFqIQIgBSAIaiIAQSBNDQALIAAhCEGQlTIMAQtBkJUyCyEOIAIgGU8NAQsDQCADIBIgCHQgBnZBAXRqIgAtAAAhBSACIAAtAAE6AAAgBSAIaiEIIAJBAWoiAiAZSQ0ACwsCQAJAAn8CQAJ/AkACQAJAAkAgGCAEa0EETgRAIAlBIEsNBiAYQQNrIRIDQAJ/IA8gIk8EQCAJQQN2IQBBASEFIAlBB3EMAQsgDyARRg0DIAkgCUEDdiICIA8gEWsgDyACayARTyIFGyIAQQN0awshAiAPIABrIg8oAAAhFCAEIBJPBEAgAiEJDAULIAVFBEAgAiEJDAULIAMgFCACdCAGdkEBdGoiAC0AACEFIAQgAC0AAToAACADIBQgAiAFaiICdCAGdkEBdGoiAC0AACEFIAQgAC0AAToAASAEQQJqIQQgAiAFaiIJQSBNDQALDAYLIAlBIEsNBSAPICJPBEAgDyAJQQN2ayIPKAAAIRQgCUEHcQwFCyAPIBFHDQELIBEhDwwCCyAJIA8gEWsgCUEDdiICIA8gAmsgEUkbIgJBA3RrIQkgDyACayIPKAAAIRQLIAlBIEsNAgsgCQshAgNAAn8gDyAiTwRAIAJBA3YhAEEBIQUgAkEHcQwBCyAPIBFGBEAgAiEJIBEMBAsgAiACQQN2IgAgDyARayAPIABrIBFPIgUbIgBBA3RrCyEJIA8gAGsiDygAACEUIAQgGE8iAkEBIAUbBEAgAg0FDAQLIAMgFCAJdCAGdkEBdGoiAi0AACEAIAQgAi0AAToAACAEQQFqIQQgACAJaiICQSBNDQALIAIhCUGQlTIMAQtBkJUyCyEPIAQgGE8NAQsDQCADIBQgCXQgBnZBAXRqIgItAAAhACAEIAItAAE6AAAgACAJaiEJIARBAWoiBCAYSQ0ACwsgBygCECECAkACQAJAAkACQAJAIBogC2tBBE4EQCACQSBNBEADQCAHAn8gBygCFCIAIAcoAhxPBEAgByAAIAJBA3ZrIgA2AhRBASEEIAJBB3EMAQsgACAHKAIYIgRGDQUgByAAIAJBA3YiBSAAIARrIAAgBWsgBE8iBBsiBWsiADYCFCACIAVBA3RrCyICNgIQIAcgACgAACIANgIMIAsgI08NAyAERQ0DIAMgACACdCAGdkEBdGoiAC0AASEEIAcgAiAALQAAajYCECALIAQ6AAAgAyAHKAIMIAcoAhAiAnQgBnZBAXRqIgAtAAEhBCAHIAIgAC0AAGo2AhAgCyAEOgABIAtBAmohCyAHKAIQIgJBIE0NAAsLIAdBkJUyNgIUDAMLIAJBIU8EQCAHQZCVMjYCFAwDCyAHKAIUIgAgBygCHE8EQCAHIAJBB3EiBDYCECAHIAAgAkEDdmsiAjYCFCAHIAIoAAA2AgwgBCECDAILIAAgBygCGCIERg0BIAcgAiAAIARrIAJBA3YiBSAAIAVrIARJGyIEQQN0ayICNgIQIAcgACAEayIANgIUIAcgACgAADYCDAsgAkEgSw0BCwNAIAcCfyAHKAIUIgAgBygCHE8EQCAHIAAgAkEDdmsiADYCFEEBIQQgAkEHcQwBCyAAIAcoAhgiBEYNAyAHIAAgAkEDdiIFIAAgBGsgACAFayAETyIEGyIFayIANgIUIAIgBUEDdGsLIgI2AhAgByAAKAAAIgU2AgwgCyAaTyISQQEgBBsEQCASDQUMBAsgAyAFIAJ0IAZ2QQF0aiIALQABIQQgByACIAAtAABqNgIQIAsgBDoAACALQQFqIQsgBygCECICQSBNDQALC0GQlTIhACAHQZCVMjYCFAsgCyAaTw0BCwNAIAMgBygCDCAHKAIQIgJ0IAZ2QQF0aiIALQABIQQgByACIAAtAABqNgIQIAsgBDoAACALQQFqIgsgGkkNAAsgBygCECECIAcoAhQhAAtBbEFsQWxBbEFsQWxBbEFsIAEgAkEgRxsgACAHKAIYRxsgCUEgRxsgDyARRxsgCEEgRxsgDiAQRxsgCkEgRxsgDSAXRxshBgsgB0EgaiQAIAYL/wEBAX8gAkUEQCAA/QwAAAAAAAAAAAAAAAAAAAAA/QsCACAAQQA2AhBBuH8PCyAAIAE2AgwgACABQQRqNgIQIAJBBE8EQCAAIAEgAmoiAUEEayIDNgIIIAAgAygAADYCACABQQFrLQAAIgEEQCAAQQggAWdBH3NrNgIEIAIPCyAAQQA2AgRBfw8LIAAgATYCCCAAIAEtAAAiAzYCAAJAAkACQCACQQJrDgIBAAILIAAgAS0AAkEQdCADciIDNgIACyAAIAEtAAFBCHQgA2o2AgALIAEgAmpBAWstAAAiAUUEQCAAQQA2AgRBbA8LIAAgAWcgAkEDdGtBCWo2AgQgAguEBAECfyAAIANqIQUCQCADQQdMBEAgA0EATA0BA0AgACACLQAAOgAAIAJBAWohAiAAQQFqIgAgBUkNAAsMAQsCQCAAIAJrIgRBB00EQCAAIAItAAA6AAAgACACLQABOgABIAAgAi0AAjoAAiAAIAItAAM6AAMgACACIARBAnQiBEHwpDJqKAIAaiICKAAANgAEIAIgBEGQpTJqKAIAayECDAELIAAgAikAADcAAAsgAEEIaiEEIAJBCGohAiABIAVPBEAgBCACa0EPTARAA0AgBCACKQAANwAAIAJBCGohAiAEQQhqIgQgBUkNAAsMAgsgBCAC/QAAAP0LAAAgA0EIa0ERSQ0BIABBGGohAANAIAAgAv0AABD9CwAAIAAgAv0AACD9CwAQIAJBIGohAiAAQSBqIgAgBUkNAAsMAQsCQCABIARJBEAgBCEBDAELIAEgBGshAwJAIAQgAmtBD0wEQCACIQADQCAEIAApAAA3AAAgAEEIaiEAIARBCGoiBCABSQ0ACwwBCyAEIAL9AAAA/QsAACADQRFIDQAgAEEYaiEAIAIhBANAIAAgBP0AABD9CwAAIAAgBP0AACD9CwAQIARBIGohBCAAQSBqIgAgAUkNAAsLIAIgA2ohAgsgASAFTw0AA0AgASACLQAAOgAAIAJBAWohAiABQQFqIgEgBUkNAAsLC4cBAgF/An4jAEEgayICJAACfyAAQQRPBEBB0PszQRw2AgBBfwwBC0F/IABCASACQRhqEAQQ0wwNABogAikDGCEDIAJBCGoiAEEANgIMIAAgA0KAlOvcA4AiBDcDACAAIARCgOyUowx+IAN8PgIIIAEgAv0AAwj9CwMAQQALIQAgAkEgaiQAIAALFgAgAEUEQEEADwtB0PszIAA2AgBBfwtBAQJ/IwBBEGsiASQAQX8hAgJAIAAQ1QwNACAAIAFBD2pBASAAKAIgEQQAQQFHDQAgAS0ADyECCyABQRBqJAAgAgt8AQJ/IAAgACgCSCIBQQFrIAFyNgJIIAAoAhQgACgCHEcEQCAAQQBBACAAKAIkEQQAGgsgAEEANgIcIABCADcDECAAKAIAIgFBBHEEQCAAIAFBIHI2AgBBfw8LIAAgACgCLCAAKAIwaiICNgIIIAAgAjYCBCABQRt0QR91C3MBAX9BAiEBIABBKxCeAUUEQCAALQAAQfIARyEBCyABQYABciABIABB+AAQngEbIgFBgIAgciABIABB5QAQngEbIgEgAUHAAHIgAC0AACIAQfIARhsiAUGABHIgASAAQfcARhsiAUGACHIgASAAQeEARhsLHAAgAEGBYE8Ef0HQ+zNBACAAazYCAEF/BSAACws/AQF/IAAoAjwhAyMAQRBrIgAkACADIAEgAkH/AXEgAEEIahAPENMMIQIgACkDCCEBIABBEGokAEJ/IAEgAhsLwAIBB38jAEEgayIDJAAgAyAAKAIcIgQ2AhAgACgCFCEFIAMgAjYCHCADIAE2AhggAyAFIARrIgE2AhQgASACaiEGQQIhByADQRBqIQECfwNAAkACQAJAIAAoAjwgASAHIANBDGoQChDTDEUEQCAGIAMoAgwiBEYNASAEQQBODQIMAwsgBkF/Rw0CCyAAIAAoAiwiATYCHCAAIAE2AhQgACABIAAoAjBqNgIQIAIMAwsgAUEIQQAgBCABKAIEIghLIgUbaiIJIAQgCEEAIAUbayIIIAkoAgBqNgIAIAFBDEEEIAUbaiIBIAEoAgAgCGs2AgAgBiAEayEGIAcgBWshByAJIQEMAQsLIABBADYCHCAAQgA3AxAgACAAKAIAQSByNgIAQQAgB0ECRg0AGiACIAEoAgRrCyEEIANBIGokACAEC9kBAQR/IwBBIGsiAyQAIAMgATYCECADIAIgACgCMCIEQQBHazYCFCAAKAIsIQYgAyAENgIcIAMgBjYCGEEgIQQCQAJAIAAgACgCPCADQRBqQQIgA0EMahAJENMMBH8gBAUgAygCDCIEQQBKDQFBIEEQIAQbCyAAKAIAcjYCAAwBCyAEIQUgBCADKAIUIgZNDQAgACAAKAIsIgU2AgQgACAFIAQgBmtqNgIIIAAoAjAEQCAAIAVBAWo2AgQgASACakEBayAFLQAAOgAACyACIQULIANBIGokACAFCwwAIAAoAjwQCxDTDAvxAQEDfwJAAkACQCABQf8BcSIEBEAgAEEDcQRAIAFB/wFxIQIDQCAALQAAIgNFDQUgAiADRg0FIABBAWoiAEEDcQ0ACwtBgIKECCAAKAIAIgJrIAJyQYCBgoR4cUGAgYKEeEcNASAEQYGChAhsIQQDQEGAgoQIIAIgBHMiA2sgA3JBgIGChHhxQYCBgoR4Rw0CIAAoAgQhAiAAQQRqIgMhACACQYCChAggAmtyQYCBgoR4cUGAgYKEeEYNAAsMAgsgABAnIABqDwsgACEDCwNAIAMiAC0AACICRQ0BIABBAWohAyACIAFB/wFxRw0ACwsgAAtOAAJAQYCXNC0AAEEBcQ0AQYCXNC0AAEEBcQ0AQfCWNEH0ljRBkJc0QbCXNBAQQfyWNEGwlzQ2AgBB+JY0QZCXNDYCAEGAlzRBAToAAAsL8AIBA38CQCABLQAADQBBwt8rEP4HIgEEQCABLQAADQELIABBDGxB0KUyahD+ByIBBEAgAS0AAA0BC0Hf4CsQ/gciAQRAIAEtAAANAQtB7OcrIQELAkADQAJAIAEgAmotAAAiBEUNACAEQS9GDQBBFyEEIAJBAWoiAkEXRw0BDAILCyACIQQLQeznKyEDAkACQAJAAkACQCABLQAAIgJBLkYNACABIARqLQAADQAgASEDIAJBwwBHDQELIAMtAAFFDQELIANB7OcrEK0BRQ0AIANBmtsrEK0BDQELIABFBEBBtKYyIQIgAy0AAUEuRg0CC0EADwtBoJo0KAIAIgIEQANAIAMgAkEIahCtAUUNAiACKAIgIgINAAsLQSQQKiICBEAgAkEUNgIEIAJBoKYyNgIAIAJBCGoiASADIAQQGxogASAEakEAOgAAIAJBoJo0KAIANgIgQaCaNCACNgIACyACQbSmMiAAIAJyGyECCyACCwQAQgALngEBA39BNSEBAkAgACgCHCICIAAoAhgiA0EGakEHcGtBB2pBB24gAyACayIDQfECakEHcEEDSWoiAkE1RwRAIAIhASACDQFBNCEBAkACQCADQQZqQQdwQQRrDgIBAAMLIAAoAhRBkANvQQFrEOMMRQ0CC0E1DwsCQAJAIANB8wJqQQdwQQNrDgIAAgELIAAoAhQQ4wwNAQtBASEBCyABC0oBA39Bt5MsIQEgAEE/cSICQTFNBEBBkKcyIQAgAkUEQEGQpzIPCwNAIAAtAAAhAyAAQQFqIgEhACADDQAgAkEBayICDQALCyABC9MSAhJ/BH4jAEGAAWsiDCQAAn8DQAJAAn8CQAJAAkAgAi0AACIFQSVHBEAgBQ0BIAgMBwtBACEKQQEhBwJAIAItAAEiBEEtaw4EAgMDAgALIARB3wBGDQEgBA0CCyAAIAhqIAU6AAAgCEEBagwCCyAEIQogAi0AAiEEQQIhBwtBACEQAkACfyACIAdqIARB/wFxIhVBK0ZqIgQsAABBMGtBCU0EQCAEIAxBDGpC/////w8Q6gynIQcgDCgCDAwBCyAMIAQ2AgxBACEHIAQLIhEtAAAiBUHDAGsiAkEWSw0AQQEgAnRBmYCAAnFFDQAgByEQIAcNACAEIBFHIRALAn8gBUHPAEcEQCARIAVBxQBHDQEaCyARLQABIQUgEUEBagshAiAMQRBqIQcgAyEGQQAhBEEAIRJBACETIwBB0ABrIgskAEGiuikhDkEwIRRBqIAIIQ8CQCAMQfwAaiINAn8CQAJAAkACQAJAAkACQAJ/AkACQAJAAkACQAJAAkACQAJAAn4CQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAXAIglBJWsOViEtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0BAwQnLQcICQotLS0NLS0tLRASFBYYFxweIC0tLS0tLQACJgYFLQgCLQstLQwOLQ8tJRETFS0ZGx0fLQsgBigCGCIEQQZNDSIMKgsgBigCGCIEQQZLDSkgBEGHgAhqDCILIAYoAhAiBEELSw0oIARBjoAIagwhCyAGKAIQIgRBC0sNJyAEQZqACGoMIAsgBjQCFELsDnxC5AB/IRYMIwtB3wAhFAsgBjQCDCEWDCELQbDBKyEODB8LIAY0AhQiF0LsDnwhFgJAIAYoAhwiBEECTARAIBYgF0LrDnwgBhDgDEEBRhshFgwBCyAEQekCSQ0AIBdC7Q58IBYgBhDgDEEBRhshFgsgCUHnAEYNGQwgCyAGNAIIIRYMHgtBAiEEIAYoAggiBkUEQEIMIRYMIAsgBqwiFkIMfSAWIAZBDEobIRYMHwsgBigCHEEBaqwhFkEDIQQMHgsgBigCEEEBaqwhFgwbCyAGNAIEIRYMGgsgDUEBNgIAQbSTLCEEDB4LQaeACEGmgAggBigCCEELShsMFAtBvN8rIQ4MFgsjAEEQayIOJAAgBjQCFCEWAn4gDkEMaiEFIAYoAhAiBEEMTwRAIARBDG0iD0F0bCAEaiIJQQxqIAkgCUEASBshBCAPIAlBH3VqrCAWfCEWCyAWQgJ9QogBWARAIAUgFqciBUEDcUUiCTYCACAFQYDnhA9sIAVBxABrQQJ2IAlrQYCjBWxqQYDWr+MHaqwMAQsgFkLkAH0iFkKQA38iGULwfH4gFnwiGEI/h6cgGadqIQkgBQJ/QQEgGKciBUGQA2ogBSAYQgBTGyIFRQ0AGkEAAn8gBUHIAU4EQCAFQawCTwRAQQMhEiAFQawCawwCC0ECIRIgBUHIAWsMAQsgBUHkAGsgBSAFQeMASiISGwsiBUUNABogBUECdiETIAVBA3FFCyIFNgIAIBZCgOeED34gEyASQRhsIAlB4QBsamogBWusQoCjBX58QoCqusMDfAshFiAEQQJ0QeCmMmooAgAiCUGAowVqIAkgDigCDBsgCSAEQQFKGyEEIAYoAgwhCSAGNAIIIRcgBjQCBCEYIAY0AgAhGSAOQRBqJAAgGSAWIASsfCAJQQFrrEKAowV+fCAXQpAcfnwgGEI8fnx8IAY0AiR9DAgLIAY0AgAhFgwVCyANQQE2AgBBtpMsIQQMGQtBsd0rIQ4MEgsgBigCGCIEQQcgBBusDAQLIAYoAhwgBigCGGtBB2pBB26tIRYMEQsgBigCHCAGKAIYQQZqQQdwa0EHakEHbq0hFgwQCyAGEOAMrSEWDA8LIAY0AhgLIRZBASEEDA8LQamACCEPDAoLQaqACCEPDAkLIAY0AhRC7A58QuQAgSIWIBZCP4ciFoUgFn0hFgwKCyAGNAIUIhdC7A58IRYgF0KkP1MNCiALIBY3AzAgDSAHQeQAQdytKyALQTBqEKYENgIAIAchBAwOCyAGKAIgQQBIBEAgDUEANgIAQbeTLCEEDA4LIAsgBigCJCIEQZAcbSIGQeQAbCAGQfDjA2wgBGrBQTxtwWo2AkAgDSAHQeQAQaSuKyALQUBrEKYENgIAIAchBAwNCyAGKAIgQQBIBEAgDUEANgIAQbeTLCEEDA0LIAYoAighBxDdDCAHDAsLIA1BATYCAEH8hywhBAwLCyAWQuQAgSEWDAULIARBgIAIcgsQ4QwMBwtBq4AIIQ8LIA8Q4QwhDgsgDSAHQeQAIA4gBhDiDCIENgIAIAdBACAEGyEEDAULQQIhBAwBC0EEIQQLAkAgCiAUIAobIgZB3wBHBEAgBkEtRw0BIAsgFjcDECANIAdB5ABB3a0rIAtBEGoQpgQ2AgAgByEEDAQLIAsgFjcDKCALIAQ2AiAgDSAHQeQAQdatKyALQSBqEKYENgIAIAchBAwDCyALIBY3AwggCyAENgIAIA0gB0HkAEHPrSsgCxCmBDYCACAHIQQMAgtB1vUrCyIEECc2AgALIAtB0ABqJAAgBCIKRQ0BAkAgEEUEQCAMKAJ8IQcMAQsCfwJAAkAgCi0AACIFQStrDgMBAAEACyAMKAJ8DAELIAotAAEhBSAKQQFqIQogDCgCfEEBawshBwJAIAVB/wFxQTBHDQADQCAKLAABIgVBMGtBCUsNASAKQQFqIQogB0EBayEHIAVBMEYNAAsLIAwgBzYCfEEAIQUDQCAFIgRBAWohBSAEIApqLAAAQTBrQQpJDQALIBAgByAHIBBJGyEFAkAgACAIaiADKAIUQZRxSAR/QS0FIBVBK0cNASAFIAdrIARqQQNBBSARLQAAQcMARhtJDQFBKws6AAAgBUEBayEFIAhBAWohCAsgBSAHTQ0AIAEgCE0NAANAIAAgCGpBMDoAACAIQQFqIQggBUEBayIFIAdNDQEgASAISw0ACwsgDCAHIAEgCGsiBSAFIAdLGyIFNgJ8IAAgCGogCiAFEBsaIAwoAnwgCGoLIQggAkEBaiECIAEgCEsNAQsLIAFBAWsgCCABIAhGGyEIQQALIQUgACAIakEAOgAAIAxBgAFqJAAgBQs4ACAAQdAPayAAIABBk/H//wdKGyIAQQNxBEBBAA8LIABB7A5qIgBB5ABvBEBBAQ8LIABBkANvRQskACAAQgA3A3AgACAAKAIINgJoIAAgACgCLCAAKAIEa6w3A3gL1AECA38CfgJAIAApA3AiBEIAUiAEIAApA3ggACgCBCIBIAAoAiwiAmusfCIFV3FFBEAgABDUDCICQQBODQEgACgCLCECIAAoAgQhAQsgAEJ/NwNwIAAgATYCaCAAIAUgAiABa6x8NwN4QX8PCyAFQgF8IQUgACgCBCEBIAAoAgghAwJAIAApA3AiBFANACAEIAV9IgQgAyABa6xZDQAgASAEp2ohAwsgACADNgJoIAAgBSAAKAIsIgMgAWusfDcDeCABIANNBEAgAUEBayACOgAACyACCxAAIABBIEYgAEEJa0EFSXIL9gMCBH8BfgJAAkACQAJAAkACQAJ/IAAoAgQiASAAKAJoRwRAIAAgAUEBajYCBCABLQAADAELIAAQ5QwLIgFBK2sOAwABAAELAn8gACgCBCICIAAoAmhHBEAgACACQQFqNgIEIAItAAAMAQsgABDlDAsiAkE6a0F1SwRAIAFBLUYhAyACIQEMBQsgACkDcEIAWQ0BDAMLIAFBOmtBdUsNAyAAKQNwQgBTDQIMAQsgACAAKAIEQQFrNgIECyAAIAAoAgRBAWs2AgQLQoCAgICAgICAgH8PCwJAIAFBMGtBCk8NAEEAIQIDQCABIAJBCmxqIQIgAkEwayICQcyZs+YASAJ/IAAoAgQiASAAKAJoRwRAIAAgAUEBajYCBCABLQAADAELIAAQ5QwLIgFBMGsiBEEJTXENAAsgAqwhBSAEQQpPDQADQCABrSAFQgp+fCEFAn8gACgCBCIBIAAoAmhHBEAgACABQQFqNgIEIAEtAAAMAQsgABDlDAsiAUEwayICQQlNIAVCMH0iBUKuj4XXx8LrowFTcQ0ACyACQQpPDQADQAJ/IAAoAgQiASAAKAJoRwRAIAAgAUEBajYCBCABLQAADAELIAAQ5QwLQTBrQQpJDQALCyAAKQNwQgBZBEAgACAAKAIEQQFrNgIEC0IAIAV9IAUgAxsLPAAgACABNwMAIAAgAkL///////8/gyACQoCAgICAgMD//wCDQjCIpyADQjCIp0GAgAJxcq1CMIaENwMIC7cCAQF/IwBB0ABrIgQkAAJAIANBgIABTgRAIARBIGogASACQgBCgICAgICAgP//ABA1IAQpAyghAiAEKQMgIQEgA0H//wFJBEAgA0H//wBrIQMMAgsgBEEQaiABIAJCAEKAgICAgICA//8AEDVB/f8CIAMgA0H9/wJPG0H+/wFrIQMgBCkDGCECIAQpAxAhAQwBCyADQYGAf0oNACAEQUBrIAEgAkIAQoCAgICAgIA5EDUgBCkDSCECIAQpA0AhASADQfSAfksEQCADQY3/AGohAwwBCyAEQTBqIAEgAkIAQoCAgICAgIA5EDVB6IF9IAMgA0HogX1NG0Ga/gFqIQMgBCkDOCECIAQpAzAhAQsgBCABIAJCACADQf//AGqtQjCGEDUgACAE/QAEAP0LAwAgBEHQAGokAAvBAgIGfwN+AkAgACIDLQAAIgRFDQACQANAIATAEOYMRQ0BIAMtAAEhBCADQQFqIQMgBA0ACwwBCwJAIARB/wFxIgRBK2sOAwABAAELQX9BACAEQS1GGyEFIANBAWohAwsCQAJAA0AgAy0AAEEwayIHQf8BcUEKTwRAAkAgASADIAAgCBs2AgAgBkUNAEHQ+zNBxAA2AgAgBUEAIAJCAYMiCVAbIQUgAiEKDAMLBUEBIQQCQCAKQpmz5syZs+bMGVYNACAKQgp+IgkgB61C/wGDIgtCf4VWDQAgCSALfCEKQQEhCCAGIQQLIANBAWohAyAEIQYMAQsLIAIgClYNASACQgGDIQkLAkAgCacNACAFDQBB0PszQcQANgIAIAJCAX0PCyACIApaDQBB0PszQcQANgIAIAIPCyAKIAWsIgmFIAl9C8sCAQR/IwBB0AFrIgUkACAFIAI2AswBIAVBoAFqQQBBKPwLACAFIAUoAswBNgLIAQJAQQAgASAFQcgBaiAFQdAAaiAFQaABaiADIAQQ7AxBAEgEQEF/IQQMAQsgACgCTEEASCEHIAAgACgCACIIQV9xNgIAAn8CQAJAIAAoAjBFBEAgAEHQADYCMCAAQQA2AhwgAEIANwMQIAAoAiwhBiAAIAU2AiwMAQsgACgCEA0BC0F/IAAQHQ0BGgsgACABIAVByAFqIAVB0ABqIAVBoAFqIAMgBBDsDAshAiAIQSBxIQQgBgRAIABBAEEAIAAoAiQRBAAaIABBADYCMCAAIAY2AiwgAEEANgIcIAAoAhQhAyAAQgA3AxAgAkF/IAMbIQILIAAgACgCACIDIARyNgIAQX8gAiADQSBxGyEEIAcNAAsgBUHQAWokACAEC5ITAhJ/An4jAEFAaiIIJAAgCCABNgI8IAhBJ2ohGCAIQShqIRMCQAJAAkACQANAQQAhBwNAIAEhDSAHIA5B/////wdzSg0CIAcgDmohDgJAAkACQAJAIAEiBy0AACIMBEADQAJAAkAgDEH/AXEiDEUEQCAHIQEMAQsgDEElRw0BIAchDANAIAwtAAFBJUcEQCAMIQEMAgsgB0EBaiEHIAwtAAIhCSAMQQJqIgEhDCAJQSVGDQALCyAHIA1rIgcgDkH/////B3MiDEoNCSAABEAgACANIAcQ7QwLIAcNByAIIAE2AjwgAUEBaiEHQX8hEAJAIAEsAAFBMGsiCUEJSw0AIAEtAAJBJEcNACABQQNqIQdBASEUIAkhEAsgCCAHNgI8QQAhCwJAIAcsAAAiEkEgayIBQR9LBEAgByEJDAELIAchCUEBIAF0IgFBidEEcUUNAANAIAggB0EBaiIJNgI8IAEgC3IhCyAHLAABIhJBIGsiAUEgTw0BIAkhB0EBIAF0IgFBidEEcQ0ACwsCQCASQSpGBEACfwJAIAksAAFBMGsiB0EJSw0AIAktAAJBJEcNAAJ/IABFBEAgBCAHQQJ0akEKNgIAQQAMAQsgAyAHQQN0aigCAAshDyAJQQNqIQFBAQwBCyAUDQYgCUEBaiEBIABFBEAgCCABNgI8QQAhFEEAIQ8MAwsgAiACKAIAIgdBBGo2AgAgBygCACEPQQALIRQgCCABNgI8IA9BAE4NAUEAIA9rIQ8gC0GAwAByIQsMAQsgCEE8ahDuDCIPQQBIDQogCCgCPCEBC0EAIQdBfyEKAn9BACABLQAAQS5HDQAaIAEtAAFBKkYEQAJ/AkAgASwAAkEwayIJQQlLDQAgAS0AA0EkRw0AIAFBBGohAQJ/IABFBEAgBCAJQQJ0akEKNgIAQQAMAQsgAyAJQQN0aigCAAsMAQsgFA0GIAFBAmohAUEAIABFDQAaIAIgAigCACIJQQRqNgIAIAkoAgALIQogCCABNgI8IApBAE4MAQsgCCABQQFqNgI8IAhBPGoQ7gwhCiAIKAI8IQFBAQshFQNAIAchCUEcIREgASISLAAAIgdB+wBrQUZJDQsgAUEBaiEBIAcgCUE6bGpBv6kyai0AACIHQQFrQf8BcUEISQ0ACyAIIAE2AjwCQCAHQRtHBEAgB0UNDCAQQQBOBEAgAEUEQCAEIBBBAnRqIAc2AgAMDAsgCCADIBBBA3RqKQMANwMwDAILIABFDQggCEEwaiAHIAIgBhDvDAwBCyAQQQBODQtBACEHIABFDQgLIAAtAABBIHENCyALQf//e3EiFiALIAtBgMAAcRshC0EAIRBB3LwpIRcgEyERAkACQAJ/AkACQAJAAkACQAJAAn8CQAJAAkACQAJAAkACQCASLQAAIhLAIgdBU3EgByASQQ9xQQNGGyAHIAkbIgdB2ABrDiEEFhYWFhYWFhYQFgkGEBAQFgYWFhYWAgUDFhYKFgEWFgQACwJAIAdBwQBrDgcQFgsWEBAQAAsgB0HTAEYNCwwVCyAIKQMwIRlB3LwpDAULQQAhBwJAAkACQAJAAkACQAJAIAkOCAABAgMEHAUGHAsgCCgCMCAONgIADBsLIAgoAjAgDjYCAAwaCyAIKAIwIA6sNwMADBkLIAgoAjAgDjsBAAwYCyAIKAIwIA46AAAMFwsgCCgCMCAONgIADBYLIAgoAjAgDqw3AwAMFQtBCCAKIApBCE0bIQogC0EIciELQfgAIQcLIBMhASAHQSBxIQ0gCCkDMCIZIhpCAFIEQANAIAFBAWsiASAap0EPcUHQrTJqLQAAIA1yOgAAIBpCD1YhCSAaQgSIIRogCQ0ACwsgASENIBlQDQMgC0EIcUUNAyAHQQR2Qdy8KWohF0ECIRAMAwsgEyEBIAgpAzAiGSIaQgBSBEADQCABQQFrIgEgGqdBB3FBMHI6AAAgGkIHViEHIBpCA4ghGiAHDQALCyABIQ0gC0EIcUUNAiAKIBMgAWsiB0EBaiAHIApIGyEKDAILIAgpAzAiGUIAUwRAIAhCACAZfSIZNwMwQQEhEEHcvCkMAQsgC0GAEHEEQEEBIRBB3bwpDAELQd68KUHcvCkgC0EBcSIQGwshFyAZIBMQ8AwhDQsgFSAKQQBIcQ0RIAtB//97cSALIBUbIQsCQCAZQgBSDQAgCg0AIBMhDUEAIQoMDgsgCiAZUCATIA1raiIHIAcgCkgbIQoMDQsgCC0AMCEHDAsLIAgoAjAiB0HD+isgBxsiDUH/////ByAKIApB/////wdPGxBzIgcgDWohESAKQQBOBEAgFiELIAchCgwMCyAWIQsgByEKIBEtAAANDwwLCyAIKQMwIhlCAFINAUEAIQcMCQsgCgRAIAgoAjAMAgtBACEHIABBICAPQQAgCxDxDAwCCyAIQQA2AgwgCCAZPgIIIAggCEEIajYCMEF/IQogCEEIagshDEEAIQcDQAJAIAwoAgAiCUUNACAIQQRqIAkQ8gwiCUEASA0PIAkgCiAHa0sNACAMQQRqIQwgByAJaiIHIApJDQELC0E9IREgB0EASA0MIABBICAPIAcgCxDxDCAHRQRAQQAhBwwBC0EAIQkgCCgCMCEMA0AgDCgCACINRQ0BIAhBBGogDRDyDCINIAlqIgkgB0sNASAAIAhBBGogDRDtDCAMQQRqIQwgByAJSw0ACwsgAEEgIA8gByALQYDAAHMQ8QwgDyAHIAcgD0gbIQcMCAsgFSAKQQBIcQ0JQT0hESAAIAgrAzAgDyAKIAsgByAFESQAIgdBAE4NBwwKCyAHLQABIQwgB0EBaiEHDAALAAsgAA0JIBRFDQNBASEHA0AgBCAHQQJ0aigCACIMBEAgAyAHQQN0aiAMIAIgBhDvDEEBIQ4gB0EBaiIHQQpHDQEMCwsLIAdBCk8EQEEBIQ4MCgsDQCAEIAdBAnRqKAIADQFBASEOIAdBAWoiB0EKRw0ACwwJC0EcIREMBgsgCCAHOgAnQQEhCiAYIQ0gFiELCyAKIBEgDWsiASABIApIGyISIBBB/////wdzSg0DQT0hESAPIBAgEmoiCSAJIA9IGyIHIAxKDQQgAEEgIAcgCSALEPEMIAAgFyAQEO0MIABBMCAHIAkgC0GAgARzEPEMIABBMCASIAFBABDxDCAAIA0gARDtDCAAQSAgByAJIAtBgMAAcxDxDCAIKAI8IQEMAQsLC0EAIQ4MAwtBPSERC0HQ+zMgETYCAAtBfyEOCyAIQUBrJAAgDgsXACAALQAAQSBxRQRAIAEgAiAAECIaCwtzAQV/IAAoAgAiAywAAEEwayICQQlLBEBBAA8LA0BBfyEEIAFBzJmz5gBNBEBBfyACIAFBCmwiAWogAiABQf////8Hc0sbIQQLIAAgA0EBaiICNgIAIAMsAAEhBSAEIQEgAiEDIAVBMGsiAkEKSQ0ACyABC7YEAAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAIAFBCWsOEgABAgUDBAYHCAkKCwwNDg8QERILIAIgAigCACIBQQRqNgIAIAAgASgCADYCAA8LIAIgAigCACIBQQRqNgIAIAAgATQCADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATUCADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATQCADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATUCADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASkDADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATIBADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATMBADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATAAADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATEAADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASkDADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATUCADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASkDADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASkDADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATQCADcDAA8LIAIgAigCACIBQQRqNgIAIAAgATUCADcDAA8LIAIgAigCAEEHakF4cSIBQQhqNgIAIAAgASsDADkDAA8LIAAgAiADEQMACwuKAQIDfwF+AkAgAEKAgICAEFQEQCAAIQUMAQsDQCABQQFrIgEgAEIKgCIFQvYBfiAAfKdBMHI6AAAgAEL/////nwFWIQIgBSEAIAINAAsLIAVCAFIEQCAFpyECA0AgAUEBayIBIAJBCm4iA0H2AWwgAmpBMHI6AAAgAkEJSyEEIAMhAiAEDQALCyABC2wBAX8jAEGAAmsiBSQAAkAgAiADTA0AIARBgMAEcQ0AIAUgASACIANrIgNBgAIgA0GAAkkiAhsQHCACRQRAA0AgACAFQYACEO0MIANBgAJrIgNB/wFLDQALCyAAIAUgAxDtDAsgBUGAAmokAAuRAgACfwJAIAFB/wBNDQACQEGomDQoAgAoAgBFBEAgAUGAf3FBgL8DRg0CQdD7M0EZNgIADAELIAFB/w9NBEAgACABQT9xQYABcjoAASAAIAFBBnZBwAFyOgAAQQIMAwsgAUGAQHFBgMADRyABQYCwA09xRQRAIAAgAUE/cUGAAXI6AAIgACABQQx2QeABcjoAACAAIAFBBnZBP3FBgAFyOgABQQMMAwsgAUGAgARrQf//P00EQCAAIAFBP3FBgAFyOgADIAAgAUESdkHwAXI6AAAgACABQQZ2QT9xQYABcjoAAiAAIAFBDHZBP3FBgAFyOgABQQQMAwtB0PszQRk2AgALQX8MAQsgACABOgAAQQELC/EXAxJ/AXwDfiMAQbAEayIMJAAgDEEANgIsAkAgAb0iGUIAUwRAQQEhEUHmvCkhEyABmiIBvSEZDAELIARBgBBxBEBBASERQem8KSETDAELQey8KUHnvCkgBEEBcSIRGyETIBFFIRcLAkAgGUKAgICAgICA+P8Ag0KAgICAgICA+P8AUQRAIABBICACIBFBA2oiBiAEQf//e3EQ8QwgACATIBEQ7QwgAEG0wCpBqN8rIAVBIHEiBxtByPQqQfzhKyAHGyABIAFiG0EDEO0MIABBICACIAYgBEGAwABzEPEMIAIgBiACIAZKGyEKDAELIAxBEGohEgJAAn8CQCABIAxBLGoQ9QwiASABoCIBRAAAAAAAAAAAYgRAIAwgDCgCLCIGQQFrNgIsIAVBIHIiFUHhAEcNAQwDCyAFQSByIhVB4QBGDQIgDCgCLCEUQQYgAyADQQBIGwwBCyAMIAZBHWsiFDYCLCABRAAAAAAAALBBoiEBQQYgAyADQQBIGwshCyAMQTBqQaACQQAgFEEAThtqIhAhBwNAIAcgAfwDIgY2AgAgB0EEaiEHIAEgBrihRAAAAABlzc1BoiIBRAAAAAAAAAAAYg0ACwJAIBRBAEwEQCAUIQggByEGIBAhCQwBCyAQIQkgFCEIA0BBHSAIIAhBHU8bIQgCQCAHQQRrIgYgCUkNACAIrSEbQgAhGQNAIAYgBjUCACAbhiAZfCIaIBpCgJTr3AOAIhlCgOyUowx+fD4CACAGQQRrIgYgCU8NAAsgGkKAlOvcA1QNACAJQQRrIgkgGT4CAAsDQCAJIAciBkkEQCAGQQRrIgcoAgBFDQELCyAMIAwoAiwgCGsiCDYCLCAGIQcgCEEASg0ACwsgCEEASARAIAtBGWpBCW5BAWohDiAVQeYARiEWA0BBCUEAIAhrIgcgB0EJTxshCgJAIAYgCU0EQEEAQQQgCSgCABshBwwBC0GAlOvcAyAKdiENQX8gCnRBf3MhD0EAIQggCSEHA0AgByAHKAIAIgMgCnYgCGo2AgAgAyAPcSANbCEIIAdBBGoiByAGSQ0AC0EAQQQgCSgCABshByAIRQ0AIAYgCDYCACAGQQRqIQYLIAwgDCgCLCAKaiIINgIsIBAgByAJaiIJIBYbIgcgDkECdGogBiAGIAdrQQJ1IA5KGyEGIAhBAEgNAAsLQQAhCAJAIAYgCU0NACAQIAlrQQJ1QQlsIQhBCiEHIAkoAgAiA0EKSQ0AA0AgCEEBaiEIIAMgB0EKbCIHTw0ACwsgCyAIQQAgFUHmAEcbayAVQecARiALQQBHcWsiByAGIBBrQQJ1QQlsQQlrSARAIAxBMGpBhGBBpGIgFEEASBtqIAdBgMgAaiIDQQltIg1BAnRqIQpBCiEHIA1Bd2wgA2oiA0EHTARAA0AgB0EKbCEHIANBAWoiA0EIRw0ACwsCQCAKKAIAIgMgAyAHbiIOIAdsIg1GIApBBGoiDyAGRnENACADIA1rIQMCQCAOQQFxRQRARAAAAAAAAEBDIQEgB0GAlOvcA0cNASAJIApPDQEgCkEEay0AAEEBcUUNAQtEAQAAAAAAQEMhAQtEAAAAAAAA4D9EAAAAAAAA8D9EAAAAAAAA+D8gBiAPRhtEAAAAAAAA+D8gAyAHQQF2Ig9GGyADIA9JGyEYAkAgFw0AIBMtAABBLUcNACAYmiEYIAGaIQELIAogDTYCACABIBigIAFhDQAgCiAHIA1qIgc2AgAgB0GAlOvcA08EQANAIApBADYCACAJIApBBGsiCksEQCAJQQRrIglBADYCAAsgCiAKKAIAQQFqIgc2AgAgB0H/k+vcA0sNAAsLIBAgCWtBAnVBCWwhCEEKIQcgCSgCACIDQQpJDQADQCAIQQFqIQggAyAHQQpsIgdPDQALCyAKQQRqIgcgBiAGIAdLGyEGCwNAIAYiByAJTSIDRQRAIAZBBGsiBigCAEUNAQsLAkAgFUHnAEcEQCAEQQhxIQ0MAQsgCEF/c0F/IAtBASALGyIGIAhKIAhBe0pxIgobIAZqIQtBf0F+IAobIAVqIQUgBEEIcSINDQBBdyEGAkAgAw0AIAdBBGsoAgAiCkUNAEEKIQNBACEGIApBCnANAANAIAYiDUEBaiEGIAogA0EKbCIDcEUNAAsgDUF/cyEGCyAHIBBrQQJ1QQlsIQMgBUFfcUHGAEYEQEEAIQ0gCyADIAZqQQlrIgZBACAGQQBKGyIGIAYgC0obIQsMAQtBACENIAsgAyAIaiAGakEJayIGQQAgBkEAShsiBiAGIAtKGyELC0F/IQogC0H9////B0H+////ByALIA1yIg8bSg0BIAsgD0EAR2pBAWohAwJAIAVBX3EiFkHGAEYEQCAIIANB/////wdzSg0DIAhBACAIQQBKGyEGDAELIBIgCCAIQR91IgZzIAZrrSASEPAMIgZrQQFMBEADQCAGQQFrIgZBMDoAACASIAZrQQJIDQALCyAGQQJrIg4gBToAACAGQQFrQS1BKyAIQQBIGzoAACASIA5rIgYgA0H/////B3NKDQILIAMgBmoiBiARQf////8Hc0oNASAAQSAgAiAGIBFqIgUgBBDxDCAAIBMgERDtDCAAQTAgAiAFIARBgIAEcxDxDAJAAkACQCAWQcYARgRAIAxBEGpBCXIhCCAQIAkgCSAQSxsiAyEJA0AgCTUCACAIEPAMIQYCQCADIAlHBEAgBiAMQRBqTQ0BA0AgBkEBayIGQTA6AAAgBiAMQRBqSw0ACwwBCyAGIAhHDQAgBkEBayIGQTA6AAALIAAgBiAIIAZrEO0MIAlBBGoiCSAQTQ0ACyAPBEAgAEHL9StBARDtDAsgByAJTQ0BIAtBAEwNAQNAIAk1AgAgCBDwDCIGIAxBEGpLBEADQCAGQQFrIgZBMDoAACAGIAxBEGpLDQALCyAAIAZBCSALIAtBCU4bEO0MIAtBCWshBiAJQQRqIgkgB08NAyALQQlKIQMgBiELIAMNAAsMAgsCQCALQQBIDQAgByAJQQRqIAcgCUsbIQogDEEQakEJciEIIAkhBwNAIAggBzUCACAIEPAMIgZGBEAgBkEBayIGQTA6AAALAkAgByAJRwRAIAYgDEEQak0NAQNAIAZBAWsiBkEwOgAAIAYgDEEQaksNAAsMAQsgACAGQQEQ7QwgBkEBaiEGIAsgDXJFDQAgAEHL9StBARDtDAsgACAGIAggBmsiAyALIAMgC0gbEO0MIAsgA2shCyAHQQRqIgcgCk8NASALQQBODQALCyAAQTAgC0ESakESQQAQ8QwgACAOIBIgDmsQ7QwMAgsgCyEGCyAAQTAgBkEJakEJQQAQ8QwLIABBICACIAUgBEGAwABzEPEMIAIgBSACIAVKGyEKDAELIBMgBUEadEEfdUEJcWohDgJAIANBC0sNAEEMIANrIQZEAAAAAAAAMEAhGANAIBhEAAAAAAAAMECiIRggBkEBayIGDQALIA4tAABBLUYEQCAYIAGaIBihoJohAQwBCyABIBigIBihIQELIBIgDCgCLCIHIAdBH3UiBnMgBmutIBIQ8AwiBkYEQCAGQQFrIgZBMDoAACAMKAIsIQcLIBFBAnIhDSAFQSBxIQkgBkECayIPIAVBD2o6AAAgBkEBa0EtQSsgB0EASBs6AAAgBEEIcUUgA0EATHEhCCAMQRBqIQcDQCAHIgYgAfwCIgdB0K0yai0AACAJcjoAACABIAe3oUQAAAAAAAAwQKIhAQJAIAZBAWoiByAMQRBqa0EBRw0AIAFEAAAAAAAAAABhIAhxDQAgBkEuOgABIAZBAmohBwsgAUQAAAAAAAAAAGINAAtBfyEKIANB/f///wcgDSASIA9rIglqIghrSg0AIABBICACIAggA0ECaiAHIAxBEGprIgYgBkECayADSBsgBiADGyIDaiIHIAQQ8QwgACAOIA0Q7QwgAEEwIAIgByAEQYCABHMQ8QwgACAMQRBqIAYQ7QwgAEEwIAMgBmtBAEEAEPEMIAAgDyAJEO0MIABBICACIAcgBEGAwABzEPEMIAIgByACIAdKGyEKCyAMQbAEaiQAIAoLnwQCBH4EfyABIAEoAgBBB2pBeHEiAUEQajYCACAAIQkgASkDACECIAEpAwghBSMAQSBrIgEkACAFQv///////z+DIQMCfiAFQjCIQv//AYMiBKciAEGB+ABrQf0PTQRAIANCBIYgAkI8iIQhAyAAQYD4AGutIQQCQCACQv//////////D4MiAkKBgICAgICAgAhaBEAgA0IBfCEDDAELIAJCgICAgICAgIAIUg0AIANCAYMgA3whAwtCACADIANC/////////wdWIgAbIQIgAK0gBHwMAQsCQCACIAOEUA0AIARC//8BUg0AIANCBIYgAkI8iIRCgICAgICAgASEIQJC/w8MAQsgAEH+hwFLBEBCACECQv8PDAELQYD4AEGB+AAgBFAiBxsiCCAAayIGQfAASgRAQgAhAkIADAELIAFBEGogAiADIANCgICAgICAwACEIAcbIgNBgAEgBmsQMiABIAIgAyAGEDQgASkDCEIEhiABKQMAIgNCPIiEIQICQCAAIAhHIAEpAxAgASkDGIRCAFJxrSADQv//////////D4OEIgNCgYCAgICAgIAIWgRAIAJCAXwhAgwBCyADQoCAgICAgICACFINACACQgGDIAJ8IQILIAJCgICAgICAgAiFIAIgAkL/////////B1YiABshAiAArQshAyABQSBqJAAgCSAFQoCAgICAgICAgH+DIANCNIaEIAKEvzkDAAt/AgF/AX4gAL0iA0I0iKdB/w9xIgJB/w9HBHwgAkUEQCABIABEAAAAAAAAAABhBH9BAAUgAEQAAAAAAADwQ6IgARD1DCEAIAEoAgBBQGoLNgIAIAAPCyABIAJB/gdrNgIAIANC/////////4eAf4NCgICAgICAgPA/hL8FIAALC6gBAQV/IAAoAlQiAygCACEFIAMoAgQiBCAAKAIUIAAoAhwiB2siBiAEIAZJGyIGBEAgBSAHIAYQGxogAyADKAIAIAZqIgU2AgAgAyADKAIEIAZrIgQ2AgQLIAQgAiACIARLGyIEBEAgBSABIAQQGxogAyADKAIAIARqIgU2AgAgAyADKAIEIARrNgIECyAFQQA6AAAgACAAKAIsIgM2AhwgACADNgIUIAILcwEDfyABIABrQQJ1IQEjAEEQayIEJAADQCABBEAgBCAANgIMIARBDGoiAyADKAIAIAFBAXYiBUECdGo2AgAgBCgCDCIDQQRqIAAgAiADKAIASyIDGyEAIAEgBUF/c2ogBSADGyEBDAELCyAEQRBqJAAgAAsGABCgCQALCAAgALxBFHYLDwAgASABjCABIAAbEEiUC0sBAnwgACAAIACiIgGiIgIgASABoqIgAUSnRjuMh83GPqJEdOfK4vkAKr+goiACIAFEsvtuiRARgT+iRHesy1RVVcW/oKIgAKCgtgtPAQF8IAAgAKIiACAAIACiIgGiIABEaVDu4EKT+T6iRCceD+iHwFa/oKIgAURCOgXhU1WlP6IgAESBXgz9///fv6JEAAAAAAAA8D+goKC2C8sOAhN/A3wjAEEQayIKJAACQCAAvCIRQf////8HcSICQdqfpO4ETQRAIAEgALsiFSAVRIPIyW0wX+Q/okQAAAAAAAA4Q6BEAAAAAAAAOMOgIhZEAAAAUPsh+b+ioCAWRGNiGmG0EFG+oqAiFzkDACAW/AIhAiAXRAAAAGD7Iem/YwRAIAEgFSAWRAAAAAAAAPC/oCIWRAAAAFD7Ifm/oqAgFkRjYhphtBBRvqKgOQMAIAJBAWshAgwCCyAXRAAAAGD7Iek/ZEUNASABIBUgFkQAAAAAAADwP6AiFkQAAABQ+yH5v6KgIBZEY2IaYbQQUb6ioDkDACACQQFqIQIMAQsgAkGAgID8B08EQCABIAAgAJO7OQMAQQAhAgwBCyAKIAIgAkEXdkGWAWsiAkEXdGu+uzkDCAJ/IApBCGohDSMAQbAEayIFJAAgAkEDa0EYbSIEQQAgBEEAShsiDkFobCACaiEHQeCwMigCACIIQQBOBEAgCEEBaiEDIA4hAkEAIQQDQCAFQcACaiAEQQN0aiACQQBIBHxEAAAAAAAAAAAFIAJBAnRB8LAyaigCALcLOQMAIAJBAWohAiAEQQFqIgQgA0cNAAsLIAdBGGshCUEAIQMgCEEAIAhBAEobIQYDQCADIQRBACECRAAAAAAAAAAAIRUDQCANIAJBA3RqKwMAIAVBwAJqIAQgAmtBA3RqKwMAoiAVoCEVIAJBAWoiAkEBRw0ACyAFIANBA3RqIBU5AwAgAyAGRiECIANBAWohAyACRQ0AC0EvIAdrIRJBMCAHayEPIAdBGUghECAHQRlrIRMgCCEDA0AgBSADQQN0aisDACEVQQAhAiADIQQgA0EASgRAA0AgBUHgA2ogAkECdGogFUQAAAAAAABwPqL8ArciF0QAAAAAAABwwaIgFaD8AjYCACAFIARBAWsiBEEDdGorAwAgF6AhFSACQQFqIgIgA0cNAAsLIBUgCRAoIhUgFUQAAAAAAADAP6KcRAAAAAAAACDAoqAiFSAV/AIiC7ehIRUCQAJAAkACfyAQRQRAIANBAnQgBWpB3ANqIgIgAigCACICIAIgD3UiAiAPdGsiBDYCACACIAtqIQsgBCASdQwBCyAJDQEgA0ECdCAFaigC3ANBF3ULIgxBAEwNAgwBC0ECIQwgFUQAAAAAAADgP2YNAEEAIQwMAQtBACECQQAhBkEBIQQgA0EASgRAA0AgBUHgA2ogAkECdGoiFCgCACEEAn8CQCAUIAYEf0H///8HBSAERQ0BQYCAgAgLIARrNgIAQQEhBkEADAELQQAhBkEBCyEEIAJBAWoiAiADRw0ACwsCQCAQDQBB////AyECAkACQCATDgIBAAILQf///wEhAgsgA0ECdCAFakHcA2oiBiAGKAIAIAJxNgIACyALQQFqIQsgDEECRw0ARAAAAAAAAPA/IBWhIRVBAiEMIAQNACAVRAAAAAAAAPA/IAkQKKEhFQsCQAJAIBVEAAAAAAAAAABhBEBBACEEIAMiAiAITA0CA0AgBUHgA2ogAkEBayICQQJ0aigCACAEciEEIAIgCEoNAAsgBEUNAgNAIAlBGGshCSAFQeADaiADQQFrIgNBAnRqKAIARQ0ACwwBCwJAIBVBGCAHaxAoIhVEAAAAAAAAcEFmBEAgBUHgA2ogA0ECdGogFUQAAAAAAABwPqL8AiICt0QAAAAAAABwwaIgFaD8AjYCACADQQFqIQMgByEJDAELIBX8AiECCyAFQeADaiADQQJ0aiACNgIAC0QAAAAAAADwPyAJECghFSADQQBOBEAgAyEHA0AgBSAHIgJBA3RqIBUgBUHgA2ogAkECdGooAgC3ojkDACACQQFrIQcgFUQAAAAAAABwPqIhFSACDQALIAMhBANARAAAAAAAAAAAIRVBACECIAggAyAEayIGIAYgCEobIg1BAE4EQANAIAJBA3RBwMYyaisDACAFIAIgBGpBA3RqKwMAoiAVoCEVIAIgDUchByACQQFqIQIgBw0ACwsgBUGgAWogBkEDdGogFTkDACAEQQBKIQIgBEEBayEEIAINAAsLRAAAAAAAAAAAIRUgA0EATgRAA0AgAyICQQFrIQMgFSAFQaABaiACQQN0aisDAKAhFSACDQALCyAKIBWaIBUgDBs5AwAgBUGwBGokACALQQdxDAILQQEhAgNAIAIiBEEBaiECIAVB4ANqIAggBGtBAnRqKAIARQ0ACyADIARqIQYDQCAFQcACaiADQQFqIgRBA3RqIANBAWoiAyAOakECdEHwsDJqKAIAtzkDAEEAIQJEAAAAAAAAAAAhFQNAIA0gAkEDdGorAwAgBUHAAmogBCACa0EDdGorAwCiIBWgIRUgAkEBaiICQQFHDQALIAUgA0EDdGogFTkDACADIAZIDQALIAYhAwwACwALIQIgCisDACEWIBFBAEgEQCABIBaaOQMAQQAgAmshAgwBCyABIBY5AwALIApBEGokACACC3gBA3xEAAAAAAAA8L8gACAAIACiIgKiIgMgAiACoiIEoiAEIAJEzRuXv7ligz+iRE707PytXWg/oKIgAkTOM4yQ8x2ZP6JE/lqGHclUqz+goKIgAyACRHKfmTj9EsE/okSfyRg0TVXVP6CiIACgoCICoyACIAEbtguiBAICfwR9AkACQAJAAn0CQCAAvCICQf////8HcSIBQcTw1owETwRAIAFBgICA/AdLDQUgAkEASARAQwAAgL8PCyABQZjkxZUESQ0BIABDAAAAf5QPCyABQZnkxfUDSQ0CIAFBkauU/ANLDQAgAkEATgRAQQEhAUPR9xc3IQQgAEOAcTG/kgwCC0F/IQFD0fcXtyEEIABDgHExP5IMAQsgAEM7qrg/lEMAAAA/IACYkvwAIgGyIgND0fcXN5QhBCAAIANDgHExv5SSCyIDIAMgBJMiAJMgBJMhBAwBCyABQYCAgJgDSQ0BQQAhAQsgACAAQwAAAD+UIgWUIgMgAyADQxAwzzqUQ2iICL2SlEMAAIA/kiIGQwAAQEAgBiAFlJMiBZNDAADAQCAAIAWUk5WUIQUgAUUEQCAAIAAgBZQgA5OTDwsgACAFIASTlCAEkyADkyEDAkACQAJAIAFBAWoOAwACAQILIAAgA5NDAAAAP5RDAAAAv5IPCyAAQwAAgL5dBEAgAyAAQwAAAD+Sk0MAAADAlA8LIAAgA5MiACAAkkMAAIA/kg8LIAFBF3QiAkGAgID8A2q+IQQgAUE5TwRAIAAgA5NDAACAP5IiACAAkkMAAAB/lCAAIASUIAFBgAFGG0MAAIC/kg8LQYCAgPwDIAJrviEFIAFBFk0EfUMAAIA/IAWTIAAgA5OSBSAAIAMgBZKTQwAAgD+SCyAElCEACyAACxwAIAFDAAAAepQgAEO84yLDkhDjB5RDAAAAepQLKwAgACAAIABDa9MNvJRDuhMvvZKUQ3WqKj6SlCAAQ67lNL+UQwAAgD+SlQvoAgIDfwN9IAC8IgJB/////wdxIgFBgICA5ARPBEAgAEPaD8k/IACYIAC8Qf////8HcUGAgID8B0sbDwsCQAJ/IAFB////9gNNBEBBfyABQYCAgMwDTw0BGgwCCyAAiyEAIAFB///f/ANNBEAgAUH//7/5A00EQCAAIACSQwAAgL+SIABDAAAAQJKVIQBBAAwCCyAAQwAAgL+SIABDAACAP5KVIQBBAQwBCyABQf//74AETQRAIABDAADAv5IgAEMAAMA/lEMAAIA/kpUhAEECDAELQwAAgL8gAJUhAEEDCyEDIAAgAJQiBSAFlCIEIARDRxLavZRDmMpMvpKUIQYgBSAEIARDJax8PZRDDfURPpKUQ6mqqj6SlCEEIAFB////9gNNBEAgACAAIAYgBJKUkw8LIANBAnQiAUGAxzJqKgIAIAAgBiAEkpQgAUGQxzJqKgIAkyAAk5MiAIwgACACQQBIGyEACyAACxMAIABBAXRBgICACGpBgYCACEkLRgEBfwJ/QQAgAEEXdkH/AXEiAUH/AEkNABpBAiABQZYBSw0AGkEAQQFBlgEgAWt0IgFBAWsgAHENABpBAUECIAAgAXEbCwtsAQF/IABEAAAAAAAAAAAQFRoCQEHIqjQoAgBBG0EaQQ4gAEEBRhsgAEECRhsiAEEBa3ZBAXEEQEHIqzRByKs0KAIAQQEgAEEBa3RyNgIADAELIABBAnRB8MkyaigCACICBEAgACACEQYACwsLBgAQrAYACw0AEBYgAEGAAWoQFwAL5CcCB38PfkHE8ygQAiMAQRBrIgAkAAJAIABBDGogAEEIahANDQBBlJY0IAAoAgxBAnRBBGoQKiIBNgIAIAFFDQAgACgCCBAqIgEEQEGUljQoAgAiAiAAKAIMQQJ0akEANgIAIAIgARAORQ0BC0GUljRBADYCAAsgAEEQaiQAIwBBEGsiACQAQQEgABDSDARAEKAJAAsgAEEQaiQAIwBBgAVrIgAkAEHoiDRC/v///w83AwBB4Ig0Qn83AwBB2Ig0QoCAgIBwNwMAQdCINEIBNwMAQcCINP0MAAAAAAAAAAABAAAA//////0LBABBsIg0/Qz///////////////8AAAAA/QsEAEGwijRCgICAgPj/////ADcDAEGoijRCgICAgICAgICAfzcDAEGgijRCgICAgAg3AwBBmIo0QgA3AwBBkIk0QgE3AwBBgAQhAUIBIQcDQCAIIAh8IgwgCiAKIAp8IgpWIAogCyALfCIJIAtUIAkgCSAHIAd8Ig0gB1StfCIJVnKtfCIHIApUcq18IgtC/v///w98IgogB0IAUiAHQgF9Ig8gCUKAgICAEH0iDiAJVCAOIA4gDUIBfCIQUK18Ig5Wcq18IhEgD1RyrXwiDyALIAsgDFQgCCAMVnIgCiALVCAKIA9WcnMiAhshCCARIAcgAhshCiAOIAkgAhshCyAQIA0gAhshByABQQFrIgENAAtBiIk0IAg3AwBBgIk0IAo3AwBB+Ig0IAs3AwBB8Ig0IAc3AwBBmIk0/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEGoiTT9DAAAAAAAAAAAAAAAAAAAAAD9CwMAQbCINEGYiTRB8Ig0EKkJQcCJNEIANwMAQbiJNEIBNwMAQciJNP0MAAAAAAAAAAAAAAAAAAAAAP0LAwBBsIg0QbiJNEHwiDQQqQlB4Ik0QgA3AwBB2Ik0QgI3AwBB6Ik0/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEGwiDRB2Ik0QfCINBCpCUHQijRBsIk0KQMAIg9B0Ik0KQMAfSILQaiJNCkDACIJQciJNCkDAH0iCCAJViAIIAhBoIk0KQMAIglBwIk0KQMAfSIIIAlWIAggCEGYiTQpAwAiCUG4iTQpAwB9IgggCVatfSIJVHKtfSIHVHKtfSIKIAdBwIg0KQMAIhB8IgwgB1QgDCAMIAlBuIg0KQMAIhF8Ig0gCVQgDSANIAhBsIg0KQMAIg58IhIgCFStfCINVnKtfCIMVnKtIApByIg0KQMAIhN8fCAKIAtWIAsgD1ZyrVAiARs3AwBByIo0IAcgDCABGzcDAEHAijQgCSANIAEbNwMAQbiKNCAIIBIgARs3AwAgAEHgBGoiAkGwiDRB2Ik0/QADAEHoiTT9AAMAEMQJQYiKNCAAQfAEaiIB/QADAP0LAwBB+Ik0IAD9AAPgBP0LAwACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgDiATIBAgEYSEIgiEQgBSBEAgAEHoBGohAyAB/QwAAAAAAAAAAAAAAAAAAAAA/QsDACAA/QwAAAAAAAAAAAAAAAAAAAAA/QsD4ARBsIg0IAJB8Ig0EKQJQeiKNCAB/QADAP0LAwBB2Io0IAD9AAPgBP0LAwBBmIw0QZiJNP0AAwD9CwMAQaiMNEGoiTT9AAMA/QsDAEIBIQcDQCAIQgBSIAcgDlRyrVANAiAAIAc3A+AEIANCADcDECAD/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEGwiDQgAEHgBGoiBEHwiDQQpAkgB6dBBXQiAkHoijRqIgUgAf0AAwD9CwMAIAJB2Io0aiIGIAD9AAPgBP0LAwAgBEGwiDQgBv0AAwAgBf0AAwAQxAkgAkGojDRqIAH9AAMA/QsDACACQZiMNGogAP0AA+AE/QsDACAHQgF8IgdCBlINAAtB6I00/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEHYjTT9DAAAAAAAAAAAAAAAAAAAAAD9CwMAQa3xKyEBQeYAIQJCACEIQgAhB0IAIQtCACEKA0ACfkLQ////DyACQTBrQf8BcUEKSQ0AGkKp////DyACQeEAa0H/AXFBBkkNABogAkHBAGtB/wFxQQZPDQRCyf///w8LIQxB2I00IApCBIYiDTcDAEHwjTQgCEIEhiAHQjyIhCIJNwMAQeiNNCAHQgSGIAtCPIiEIgc3AwBB4I00IAtCBIYgCkI8iIQiCzcDACAIQjyIQgBSDQRB8I00IAk3AwBB6I00IAc3AwBB4I00IAs3AwBB2I00IA0gDCACrcJ8Qv////8Pg4QiCjcDACABLQABIQIgCSEIIAFBAWoiAUHt8StHDQALQZCONEHwjTQpAwAiCTcDAEGIjjRB6I00KQMAIgc3AwBBgI40QeCNNCkDACIKNwMAQfiNNEHYjTQpAwAiCDcDAEGYjjRCACAIfSIMNwMAQgEhC0HgjzQgCkI/hiAIQgGIhEIBfCIPNwMAQaCONEIAIAp9Ig4gDEIAUq19Ig03AwBB6I80IAdCP4YgCkIBiIQiECAPUK18Ig83AwBBqI40QgAgB30iCiAOQgBSIA0gDlZyrX0iDjcDAEHwjzQgCUI/hiAHQgGIhCIHIA8gEFStfCIPNwMAQfiPNCAHIA9WrSAJQgGIfDcDAEGwjjRCACAJIApCAFIgCiAOVHKtfH0iCTcDACAIp0EBcUUNBCAIQgFSBEBCASAIfSEHA0AgB0IBfCALfiELIAcgB34iB0IAUg0ACwtCACEHQdiONEIAIAt9NwMAQgEhC0GABCEBQgAhCkIAIQgDQCAJIAggCHwiDyAKIAogCnwiClYgCiAKIAcgByAHfCIHViAHIAcgCyALIAt8IgtWrXwiB1ZyrXwiClZyrXwiEHwiESAKIA58IhIgDlQgEiASIAcgDXwiEyANVCATIBMgCyAMfCIVIAxUrXwiE1ZyrXwiElZyrXwiFCAQIA8gEFYgCCAPVnIgCSARViARIBRWcnMiAhshCCASIAogAhshCiATIAcgAhshByAVIAsgAhshCyABQQFrIgENAAtB0I40IAg3AwBByI40IAo3AwBBwI40IAc3AwBBuI40IAs3AwBB4I40/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEHwjjT9DAAAAAAAAAAAAAAAAAAAAAD9CwMAQfiNNEHgjjRBuI40EMUJQYiPNEIANwMAQYCPNEIBNwMAQZCPNP0MAAAAAAAAAAAAAAAAAAAAAP0LAwBB+I00QYCPNEG4jjQQxQlBqI80QgA3AwBBoI80QgI3AwBBsI80/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEH4jTRBoI80QbiONBDFCUGYkDRB+I40KQMAIg9BmI80KQMAfSILQfCONCkDACIJQZCPNCkDAH0iCCAJViAIIAhB6I40KQMAIglBiI80KQMAfSIIIAlWIAggCEHgjjQpAwAiCUGAjzQpAwB9IgggCVatfSIJVHKtfSIHVHKtfSIKQZCONCkDACIQfCAHQYiONCkDACIRfCIMIAdUIAwgDCAJQYCONCkDACISfCINIAlUIA0gDSAIQfiNNCkDACIOfCITIAhUrXwiDVZyrXwiDFZyrXwgCiALIA9WIAogC1ZyIgEbNwMAQZCQNCAMIAcgARs3AwBBiJA0IA0gCSABGzcDAEGAkDQgEyAIIAEbNwMAIABB4ARqIgJB+I00QaCPNP0AAwBBsI80/QADABDACUHQjzQgAEHwBGoiAf0AAwD9CwMAQcCPNCAA/QAD4AT9CwMAIA4gECARIBKEhCIIhFANBSAAQegEaiEDIAH9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIAD9DAAAAAAAAAAAAAAAAAAAAAD9CwPgBEH4jTQgAkG4jjQQvwlBsJA0IAH9AAMA/QsDAEGgkDQgAP0AA+AE/QsDAEHgkTRB4I40/QADAP0LAwBB8JE0QfCONP0AAwD9CwMAQgEhBwNAIAhQIAcgDlpxDQcgACAHNwPgBCADQgA3AxAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAwBB+I00IABB4ARqIgRBuI40EL8JIAenQQV0IgJBsJA0aiIFIAH9AAMA/QsDACACQaCQNGoiBiAA/QAD4AT9CwMAIARB+I00IAb9AAMAIAX9AAMAEMAJIAJB8JE0aiAB/QADAP0LAwAgAkHgkTRqIAD9AAPgBP0LAwAgB0IBfCIHQgZSDQALIABBgARqQbCINEHa5isQ1gogAEHgA2pBsIg0QdbwKxDWCiAAQcADakGwiDRBt+grENYKIABBoANqQbCINEGM5SsQ1gpBoJM0QbCINDYCAEGokzQgAP0AA4AE/QsDAEG4kzQgAP0AA5AE/QsDAEHIkzQgAP0AA+AD/QsDAEHYkzQgAP0AA/AD/QsDAEHokzQgAP0AA8AD/QsDAEH4kzQgAP0AA9AD/QsDAEGIlDQgAP0AA6AD/QsDAEGYlDQgAP0AA7AD/QsDAEG4lDRByIk0/QADAP0LAwBBqJQ0QbiJNP0AAwD9CwMAQciINCkDACISQcCINCkDACITQbiINCkDACIRhIQiCVBBsIg0KQMAIghCAlhxDQdB0JQ0QgA3AwBByJQ0QgI3AwBB2JQ0/QwAAAAAAAAAAAAAAAAAAAAA/QsDAEGwiDRByJQ0QfCINBCkCSAJUCAIQgNYcQ0IQfCUNEIANwMAQeiUNEIDNwMAQfiUNP0MAAAAAAAAAAAAAAAAAAAAAP0LAwBBsIg0QeiUNEHwiDQQpAkgCVAgCEIIWHENCUGQlTRCADcDAEGIlTRCCDcDAEGYlTT9DAAAAAAAAAAAAAAAAAAAAAD9CwMAQbCINEGIlTRB8Ig0EKQJIABB8ARqIgFB+JQ0/QADAP0LAwAgAEHolDT9AAMA/QsD4ARBsIg0IARByJM0EKQJQbiVNCAB/QADAP0LAwBBqJU0IAD9AAPgBP0LAwAgCVAgCEIJWHENCiAAQgA3A8gEIABB0ARqIgL9DAAAAAAAAAAAAAAAAAAAAAD9CwMAIABCCTcDwARBsIg0IABBwARqIgFB8Ig0EKQJQbCINCABQciTNBCkCUEAIQFB2JU0IAL9AAMA/QsDAEHIlTQgAP0AA8AE/QsDACAJUCAIQhhYcQ0LIABCADcDqAQgAEGwBGoiAv0MAAAAAAAAAAAAAAAAAAAAAP0LAwAgAEIYNwOgBEGwiDQgAEGgBGoiA0HwiDQQpAlBsIg0IANByJM0EKQJQfiVNCAC/QADAP0LAwBB6JU0IAD9AAOgBP0LAwBBuJM0KQMAIQtBsJM0KQMAIQoCQEGokzQpAwAiFSAIQZiJNCkDACIMQeiUNCkDAH0iCHwiFCAIQbCJNCkDACINQYCVNCkDAH0iCSANViAJIAlBqIk0KQMAIg5B+JQ0KQMAfSIJIA5WIAkgCUGgiTQpAwAiD0HwlDQpAwB9IgkgD1YgCSAJIAggDFatfSIJVHKtfSIHVHKtfSIQVHIiAhtSDQAgCiAJIBF8IhEgCCAUVq18IhQgCSACG1INACALIAcgE3wiCCAJIBFWIBEgFFZyrXwiCSAHIAIbUg0AQcCTNCkDACAQIAcgCFYgCCAJVnKtfCASfCAQIAIbUSEBC0GJljQgAToAAEGIljQCf0EAIAwgFVINABpBACAKIA9SDQAaQQAgCyAOUg0AGkHAkzQpAwAgDVELOgAAIABBgAVqJAAMDAsgAEGAxio2AhBB5ABB9IcqIABBEGoQmwlBkJY0KAIAKAIAIQEgAEGAxio2AgAgAUGRjCogABBsAAsgAEGAxio2AjBB5ABB9IcqIABBMGoQmwlBkJY0KAIAKAIAIQEgAEGAxio2AiAgAUGRjCogAEEgahBsAAsgAEGK/ys2ApADQeQAQfSHKiAAQZADahCbCUGQljQoAgAoAgAhASAAQYr/KzYCgAMgAUGRjCogAEGAA2oQbAALIABBv/grNgLwAkHkAEH0hyogAEHwAmoQmwlBkJY0KAIAKAIAIQEgAEG/+Cs2AuACIAFBkYwqIABB4AJqEGwACyAAQY2ALDYCUEHkAEH0hyogAEHQAGoQmwlBkJY0KAIAKAIAIQEgAEGNgCw2AkAgAUGRjCogAEFAaxBsAAsgAEGAxio2AnBB5ABB9IcqIABB8ABqEJsJQZCWNCgCACgCACEBIABBgMYqNgJgIAFBkYwqIABB4ABqEGwACyAAQYDGKjYCkAFB5ABB9IcqIABBkAFqEJsJQZCWNCgCACgCACEBIABBgMYqNgKAASABQZGMKiAAQYABahBsAAsgAEGAxio2ArACQeQAQfSHKiAAQbACahCbCUGQljQoAgAoAgAhASAAQYDGKjYCoAIgAUGRjCogAEGgAmoQbAALIABBgMYqNgKQAkHkAEH0hyogAEGQAmoQmwlBkJY0KAIAKAIAIQEgAEGAxio2AoACIAFBkYwqIABBgAJqEGwACyAAQYDGKjYC8AFB5ABB9IcqIABB8AFqEJsJQZCWNCgCACgCACEBIABBgMYqNgLgASABQZGMKiAAQeABahBsAAsgAEGAxio2AtABQeQAQfSHKiAAQdABahCbCUGQljQoAgAoAgAhASAAQYDGKjYCwAEgAUGRjCogAEHAAWoQbAALIABBgMYqNgKwAUHkAEH0hyogAEGwAWoQmwlBkJY0KAIAKAIAIQEgAEGAxio2AqABIAFBkYwqIABBoAFqEGwAC0GomDRB7Jg0NgIAQYSYNEGAwAA2AgBBgJg0QYCAwAM2AgBB/Jc0QdCr9AM2AgBB4Jc0QSo2AgALC+GvMasBAEGACAulgikvLmx1YWNoZWNrcmMAc3RkID0gJ2x1YTU0JwppZ25vcmUgPSB7ICc2MTEnLCAnNjEyJywgJzYxNCcsICc2MjEnLCAnNjMxJyB9Cmdsb2JhbHMgPSB7CiAgICAnWkVOJywgJ09DVEVUJywgJ08nLCAnQklHJywgJ0lOVCcsICdFQ1AnLCAnRUNQMicsICdTQUxUJywgJ0ZMT0FUJywgJ0YnLAogICAgJ0dpdmVuJywnV2hlbicsJ1RoZW4nLCdJTicsJ0tJTicsJ0FDSycsJ2tleXJpbmcnLCdPVVQnLCdDT05GJywnV0hPJywKICAgICdJTlNQRUNUJywgJ0NCT1InLCAnSlNPTicsICdFQ0RIJywgJ0FFUycsICdIQVNIJywgJ0JFTkNIJywgJ0tERicsCiAgICAnTUFDSElORScsICdEQVRFJywgJ1ZFUlNJT04nLCAnU0VNVkVSJywgJ0knLCAnRVhUUkEnLCAnS0VZUycsICdDT0RFQycsCiAgICAncmVxdWlyZScsICdyZXF1aXJlX29uY2UnLCdmaWYnLCAnZGVlcG1hcCcsICdsdWF0eXBlJywgJ3NvcnRfcGFpcnMnLAogICAgJ2VtcHR5JywgJ2hhdmUnLCAnaW5pdGtleXJpbmcnLCAnaGF2ZWtleScsICd6ZW5ndWFyZCcsICdleGl0Y29kZScsCiAgICAnZGVwcmVjYXRlZCcsICdtYXloYXZlJywgJ3BhcnNlX3ByZWZpeCcsICdzdHJ0b2snLCAnc3RyY2FzZWNtcCcsCiAgICAndXNjb3JlJywgJ2RlYnVnX3RyYWNlYmFjaycsICdpc251bWJlcicsICd0cmltcScsICdsb2FkX3NjZW5hcmlvJywKICAgICdHMicsJ0FCQycsJ0VDREgnLCAnc2NoZW1hX2dldCcsICdkZWVwc29ydG1hcCcsIAogICAgJ2NoZWNrX2NvZGVjJywgJ1pLUF9jaGFsbGVuZ2UnLCAnU0hBMjU2JywgJ1NIQTUxMicsICdzaGEyNTYnLCAnc2hhNTEyJywKICAgICdwcmludGVycicsICdhY3QnLCAnbm90aWNlJywgJ3dhcm4nLCAnZXJyb3InLCAneHh4JywgJ2ZhdGFsJywgJ3RyaW0nLCAnc2VyaWFsaXplJywgJ2lzemVuJywKICAgICdERUJVRycsICdaRU5fdHJhY2ViYWNrJywgJ2lucHV0X2VuY29kaW5nJywgJ291dHB1dF9lbmNvZGluZycsICdnZXRfZm9ybWF0JywKICAgICdpc2FycmF5JywgJ2lzZGljdGlvbmFyeScsICdhcnJheV9jb250YWlucycsCiAgICAnZ3Vlc3NfY29udmVyc2lvbicsICdvcGVyYXRlX2NvbnZlcnNpb24nLCAnZGVlcGNvcHknLCAnZ3Vlc3Nfb3V0Y2FzdCcsICduZXdfY29kZWMnLAogICAgJ2hleCcsICdzdHInLCAnYmluJywgJ2Jhc2U2NCcsICd1cmw2NCcsICdiYXNlNTgnLAogICAgJ0lmV2hlbicsICdqc29udG9rJywgJ3plbmNvZGVfYXNzZXJ0JywgJ3plbmNvZGVfc2VyaWFsaXplJwogICAgfQpsb2NhbCBfY29sdW1ucyA9IDE0MAptYXhfbGluZV9sZW5ndGgJPSBfY29sdW1ucwptYXhfY29kZV9saW5lX2xlbmd0aCA9IF9jb2x1bW5zCm1heF9zdHJpbmdfbGluZV9sZW5ndGggPSBfY29sdW1ucwptYXhfY29tbWVudF9saW5lX2xlbmd0aAk9IF9jb2x1bW5zCi9SRUFETUUubWQAVGhlIGZpbGVzIGluIHRoaXMgZGlyZWN0b3J5IGFyZSAicHVyZSIgTFVBIGV4dGVuc2lvbnMgc3RhdGljYWxseQpjb21waWxlZCBhcyBiaW5hcmllcyBhbmQgbG9hZGVkIGluc2lkZSB6ZW5yb29tIGFzIHN0cmluZ3MuIFRoaXMgaXMKYmVjYXVzZSB0aGUgWmVucm9vbSBjYW5ub3QgYWNjZXNzIHRoZSBmaWxlc3lzdGVtLgoKVGhlIGV4dGVuc2lvbnMgYXJlIGNvbXBpbGVkIGludG8gQyBoZWFkZXJzIGJ5IHRoZSBNYWtlZmlsZSB0YXJnZXQKYGVtYmVkLWx1YWAgd2hpY2ggbmVlZHMgdG8gYmUgcnVuIG1hbnVhbGx5IGluIGNhc2Ugb2YgYWRkaXRpb24gb2YgbmV3CmV4dGVuc2lvbnMuIFRoZW4gem1ha2UgZW1iZWQtbHVheiB3aWxsIGNyZWF0ZSBgbHVhbGliXyouY2AgZmlsZXMgaW5zaWRlCnRoZSBzcmMvIGRpcmVjdG9yeS4gVG8gY29tcGxldGUgaW5jbHVzaW9uIHRoZXkgc2hvdWxkIGJlIGFkZGVkIGF0IHRoZQpiZWdpbm5pbmcgb2YgdGhlIGx1YV9mdW5jdGlvbnMuYyBmaWxlcyAoaW5zaWRlIHRoZSAjaW5jbHVkZSBkaXJlY3RpdmUKYXMgaWYgdGhleSdkIGJlIGhlYWRlcnMpIGFuZCBhdCB0aGUgZW5kIG9mIHRoZSBmaWxlIGJ5IHRoZQpsc2JfbG9hZF9zdHJpbmcoKSB0YWtpbmcgdGhlbSBhcyBzdHJpbmcgYXJndW1lbnRzLgoKL2NyeXB0b19iYnMubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIzLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkIGFuZCB3cml0dGVuIGJ5IEx1Y2EgRGkgRG9tZW5pY28sIFJlYmVjY2EgU2VsdmFnZ2luaSBhbmQgQWxiZXJ0byBMZXJkYQotLW1haW50YWluZWQgYnkgRGVuaXMgUm9pbwotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1dXQoKLS0tIDxoMT5CQlMgc2lnbmF0dXJlIHNjaGVtZTwvaDE+Ci0tCi0tIFRoZSBCQlMgc2lnbmF0dXJlIHNjaGVtZSAoYWxzbyBrbm93biBhcyB0aGUgQm9uZWgtQm95ZW4tU2hhY2hhbSBzaWduYXR1cmUgc2NoZW1lKSAKLS0gaXMgYSBjcnlwdG9ncmFwaGljIHNpZ25hdHVyZSBzY2hlbWUgYmFzZWQgb24gcGFpcmluZy1iYXNlZCBjcnlwdG9ncmFwaHk6IHRoZSBCQlMgc2NoZW1lIGlzIHBhcnRpY3VsYXJseSAKLS0gbm90YWJsZSBmb3IgaXRzIHVzZSBvZiBiaWxpbmVhciBwYWlyaW5ncyBvbiBlbGxpcHRpYyBjdXJ2ZXMsCi0tIHdoaWNoIGVuYWJsZSBlZmZpY2llbnQgdmVyaWZpY2F0aW9uIGFuZCBjb21wYWN0IHNpZ25hdHVyZXMuIAotLSBJdCBpcyBhIHByb2JhYmlsaXN0aWMgZGlnaXRhbCBzaWduYXR1cmUgc2NoZW1lIGJhc2VkIG9uIHRoZSBkaXNjcmV0ZSBsb2dhcml0aG0gcHJvYmxlbSwgaS5lLgotLSB0aGUgZGlmZmljdWx0IG9mIGZpbmRpbmcgdGhlIGRpY3JldGUgbG9nYXJpdGhtIGluIGEgZ3J1b3Agb2YgcHJpbWUgb3JkZXIuCi0tIAotLSBUaGUgQkJTIHNpZ25hdHVyZSBzY2hlbWUgdXRpbGl6ZXMgdHdvIGVsbGlwdGljIGN1cnZlcyBpbiBpdHMgY29uc3RydWN0aW9uOgotLSBFMTogeSBeIDIgPSB4IF4gMyArIDQgZGVmaW5lZCBvdmVyIHRoZSBmaW5pdGUgZmllbGQgR0YocCkuIAotLQotLSBFMjogeSBeIDIgPSB4IF4gMyArIDQgKiAoSSArIDEpIHdoZXJlIEkgXiAyICsgMSA9IDAgZGVmaW5lZCBvdmVyIHRoZSBmaW5pdGUgZmllbGQgR0YocF4yKQotLQotLSB3aGVyZSBwID0gKHQgLSAxKV4yICogKHReNCAtIHReMiArIDEpIC8gMyArIHQgYW5kIHQgPSAtMl42MyAtIDJeNjIgLSAyXjYwIC0gMl41NyAtIDJeNDggLSAyXjE2LgotLSAKLS0gTGV0IGJlIG9ic2VydmVkIHRoYXQgcCBpcyBub3QgYSBwcmltZSBudW1iZXIgYW5kIHRoZSB0d28gc3ViZ3JvdXBzIEcxIGFuZCBHMiBvZiBFMSBhbmQgRTIgYXJlIAotLSB0aGUgdHdvIGdyb3VwcyB1c2VkIGZvciB0aGUgcGFpcmluZyBoYXZpbmcgdGhlIHNhbWUgb3JkZXIgCi0tIHIgPSAweDczZWRhNzUzMjk5ZDdkNDgzMzM5ZDgwODA5YTFkODA1NTNiZGE0MDJmZmZlNWJmZWZmZmZmZmZmMDAwMDAwMDEgd2hpY2ggaXMgYSBwcmltZSBmYWN0b3Igb2YgcC4KLS0KLS0gUHVibGljIGtleXMgYW5kIGtleSBnZW5lcmF0aW9uIGFyZSBjb25zaWRlcmVkIGFzIHBvaW50cyBpbiBHMiBhbmQgc2lnbmF0dXJlcyBhcyBwb2ludCBpbiBHMS4KLS0gVGhpcyBjaG9pY2UgYWxsb3dzIHRvIHByb3ZpZGUgc2hvcnQgc2lnbmF0dXJlcyB3aXRoIHN0cm9uZyBzZWN1cml0eSBndWFyYW50ZWVzLgotLSAKLS0gCi0tCi0tIEBtb2R1bGUgQkJTCgoKLS0gb3B0aW1pemVkIEMgZXh0ZW5zaW9uIGZvciBtYXAgdG8gcG9pbnQKbG9jYWwgZmFzdEJCUyA9IHJlcXVpcmUoImJicyIpCmxvY2FsIGJicyA9IHt9CmxvY2FsIE9DVEVUX1NDQUxBUl9MRU5HVEggPSAzMiAtLSBjZWlsKGxvZzIoUFJJTUVfUikvOCkKbG9jYWwgT0NURVRfUE9JTlRfTEVOR1RIID0gNDggLS1jZWlsKGxvZzIocCkvOCkKCi0tc2VlIGRyYWZ0LWlydGYtY2ZyZy1iYnMtc2lnbmF0dXJlcy1sYXRlc3QgQXBwZW5kaXggQS4xCmxvY2FsIFBSSU1FX1IgPSBFQ1Aub3JkZXIoKQoKLS1kcmFmdC1pcnRmLWNmcmctcGFpcmluZy1mcmllbmRseS1jdXJ2ZXMtMTEgU2VjdGlvbiA0LjIuMQpsb2NhbCBJREVOVElUWV9HMSA9IEVDUC5nZW5lcmF0b3IoKQoKbG9jYWwgSyA9IG5pbCAtLSBzZWUgZnVuY3Rpb24gS19JTklUKCkgYmVsb3cKCi0tIEFkZGVkIGFwaV9pZAoKbG9jYWwgQ0lQSEVSU1VJVEVfU0hBS0UgPSB7CiAgICBleHBhbmQgPSBIQVNILmV4cGFuZF9tZXNzYWdlX3hvZiwKICAgIGNpcGhlcnN1aXRlX0lEID0gTy5mcm9tX3N0cmluZygiQkJTX0JMUzEyMzgxRzFfWE9GOlNIQUtFLTI1Nl9TU1dVX1JPXyIpLAogICAgYXBpX0lEID0gIE8uZnJvbV9zdHJpbmcoIkJCU19CTFMxMjM4MUcxX1hPRjpTSEFLRS0yNTZfU1NXVV9ST19IMkdfSE0yU18iKSwKICAgIGdlbmVyYXRvcl9zZWVkID0gTy5mcm9tX3N0cmluZygiQkJTX0JMUzEyMzgxRzFfWE9GOlNIQUtFLTI1Nl9TU1dVX1JPX0gyR19ITTJTX01FU1NBR0VfR0VORVJBVE9SX1NFRUQiKSwKICAgIHNlZWRfZHN0ID0gTy5mcm9tX3N0cmluZygiQkJTX0JMUzEyMzgxRzFfWE9GOlNIQUtFLTI1Nl9TU1dVX1JPX0gyR19ITTJTX1NJR19HRU5FUkFUT1JfU0VFRF8iKSwKICAgIGdlbmVyYXRvcl9kc3QgPSBPLmZyb21fc3RyaW5nKCJCQlNfQkxTMTIzODFHMV9YT0Y6U0hBS0UtMjU2X1NTV1VfUk9fSDJHX0hNMlNfU0lHX0dFTkVSQVRPUl9EU1RfIiksCiAgICBoYXNoX3RvX3NjYWxhcl9kc3QgPSBPLmZyb21fc3RyaW5nKCdCQlNfQkxTMTIzODFHMV9YT0Y6U0hBS0UtMjU2X1NTV1VfUk9fSDJHX0hNMlNfSDJTXycpLAogICAgbWFwX21zZ190b19zY2FsYXJfYXNfaGFzaF9kc3QgPSBPLmZyb21fc3RyaW5nKCdCQlNfQkxTMTIzODFHMV9YT0Y6U0hBS0UtMjU2X1NTV1VfUk9fSDJHX0hNMlNfTUFQX01TR19UT19TQ0FMQVJfQVNfSEFTSF8nKSwKICAgIGV4cGFuZF9kc3QgPSBPLmZyb21fc3RyaW5nKCdCQlNfQkxTMTIzODFHMV9YT0Y6U0hBS0UtMjU2X1NTV1VfUk9fU0lHX0RFVF9EU1RfJyksCiAgICBQMSA9IEVDUC5mcm9tX3pjYXNoKE8uZnJvbV9oZXgoJzg5MjlkZmJjN2U2NjQyYzRlZDljYmEwODU2ZTQ5M2Y4YjlkN2Q1ZmNiMGMzMWVmOGZkY2QzNGQ1MDY0OGE1NmM3OTVlMTA2ZTllYWRhNmUwYmRhMzg2YjQxNDE1MDc1NScpKSwKICAgIEdFTkVSQVRPUlMgPSB7fSwKICAgIEdFTkVSQVRPUl9WID0gSEFTSC5leHBhbmRfbWVzc2FnZV94b2YoTy5mcm9tX3N0cmluZygiQkJTX0JMUzEyMzgxRzFfWE9GOlNIQUtFLTI1Nl9TU1dVX1JPX0gyR19ITTJTX01FU1NBR0VfR0VORVJBVE9SX1NFRUQiKSwKICAgIE8uZnJvbV9zdHJpbmcoIkJCU19CTFMxMjM4MUcxX1hPRjpTSEFLRS0yNTZfU1NXVV9ST19IMkdfSE0yU19TSUdfR0VORVJBVE9SX1NFRURfIiksIDQ4KQp9Cgpsb2NhbCBDSVBIRVJTVUlURV9TSEEgPSB7CiAgICBleHBhbmQgPSBIQVNILmV4cGFuZF9tZXNzYWdlX3htZCwKICAgIGNpcGhlcnN1aXRlX0lEID0gTy5mcm9tX3N0cmluZygiQkJTX0JMUzEyMzgxRzFfWE1EOlNIQS0yNTZfU1NXVV9ST18iKSwKICAgIGFwaV9JRCA9IE8uZnJvbV9zdHJpbmcoIkJCU19CTFMxMjM4MUcxX1hNRDpTSEEtMjU2X1NTV1VfUk9fSDJHX0hNMlNfIiksCiAgICBnZW5lcmF0b3Jfc2VlZCA9IE8uZnJvbV9zdHJpbmcoIkJCU19CTFMxMjM4MUcxX1hNRDpTSEEtMjU2X1NTV1VfUk9fSDJHX0hNMlNfTUVTU0FHRV9HRU5FUkFUT1JfU0VFRCIpLAogICAgc2VlZF9kc3QgPSBPLmZyb21fc3RyaW5nKCJCQlNfQkxTMTIzODFHMV9YTUQ6U0hBLTI1Nl9TU1dVX1JPX0gyR19ITTJTX1NJR19HRU5FUkFUT1JfU0VFRF8iKSwKICAgIGdlbmVyYXRvcl9kc3QgPSBPLmZyb21fc3RyaW5nKCJCQlNfQkxTMTIzODFHMV9YTUQ6U0hBLTI1Nl9TU1dVX1JPX0gyR19ITTJTX1NJR19HRU5FUkFUT1JfRFNUXyIpLAogICAgaGFzaF90b19zY2FsYXJfZHN0ID0gTy5mcm9tX3N0cmluZygnQkJTX0JMUzEyMzgxRzFfWE1EOlNIQS0yNTZfU1NXVV9ST19IMkdfSE0yU19IMlNfJyksCiAgICBtYXBfbXNnX3RvX3NjYWxhcl9hc19oYXNoX2RzdCA9IE8uZnJvbV9zdHJpbmcoJ0JCU19CTFMxMjM4MUcxX1hNRDpTSEEtMjU2X1NTV1VfUk9fSDJHX0hNMlNfTUFQX01TR19UT19TQ0FMQVJfQVNfSEFTSF8nKSwKICAgIGV4cGFuZF9kc3QgPSBPLmZyb21fc3RyaW5nKCdCQlNfQkxTMTIzODFHMV9YTUQ6U0hBLTI1Nl9TU1dVX1JPX1NJR19ERVRfRFNUXycpLAogICAgUDEgPSBFQ1AuZnJvbV96Y2FzaChPLmZyb21faGV4KCdhOGNlMjU2MTAyODQwODIxYTNlOTRlYTkwMjVlNDY2MmIyMDU3NjJmOTc3NmIzYTc2NmM4NzJiOTQ4ZjFmZDIyNWU3YzU5Njk4NTg4ZTcwZDExNDA2ZDE2MWI0ZTI4YzknKSksCiAgICBHRU5FUkFUT1JTID0ge30sCiAgICBHRU5FUkFUT1JfViA9IEhBU0guZXhwYW5kX21lc3NhZ2VfeG1kKE8uZnJvbV9zdHJpbmcoIkJCU19CTFMxMjM4MUcxX1hNRDpTSEEtMjU2X1NTV1VfUk9fSDJHX0hNMlNfTUVTU0FHRV9HRU5FUkFUT1JfU0VFRCIpLAogICAgTy5mcm9tX3N0cmluZygiQkJTX0JMUzEyMzgxRzFfWE1EOlNIQS0yNTZfU1NXVV9ST19IMkdfSE0yU19TSUdfR0VORVJBVE9SX1NFRURfIiksIDQ4KQp9Ci0tIFRha2UgYXMgaW5wdXQgdGhlIGhhc2ggYXMgc3RyaW5nIGFuZCByZXR1cm4gYSB0YWJsZSB3aXRoIHRoZSBjb3JyZXNwb25kaW5nIHBhcmFtZXRlcnMKCi0tLSBSZXR1cm4gYSBzcGVjaWZpYyBjaXBoZXJzdWl0ZSBiYXNlZCBvbiB0aGUgcHJvdmlkZWQgaGFzaCBuYW1lLiAKLS0gVGhlcmUgYXJlIHR3byBwb3NzaWJpbGl0aWVzIGZvciB0aGUgb3V0cHV0OiB0aGUgY29uZmlndXJhdGlvbiBmb3IgU0hBS0UtMjU2IG9yIHRoZSBjb25maWd1cmF0aW9uIGZvciBTSEEtMjU2LgotLQotLUBmdW5jdGlvbiBCQlMuY2lwaGVyc3VpdGUKLS1AcGFyYW0gaGFzaCBhIHN0cmluZyB3aXRoIHRoZSBuYW1lIG9mIHRoZSBoYXNoIGZ1bmN0aW9uLCBzaGEyNTYgb3Igc2hha2UyNTYKLS1AcmV0dXJuIGEgY2lwaGVyc3VpdGUgY29uZmlndXJhdGlvbgotLUB1c2FnZQotLWJicyA9IHJlcXVpcmUnY3J5cHRvX2JicycKLS0qKnNlbGVjdCB0aGUgaGFzaCBzaGEyNTYKLS1zdWl0ZSA9IGJicy5jaXBoZXJzdWl0ZSgnc2hhMjU2JykKLS0qKnByaW50IGZvciBleGFtcGxlIHRoZSBjaXBoZXJzdWl0ZSBJRAotLXByaW50KHN1aXRlLmNpcGhlcnN1aXRlX0lEKQotLSoqcHJpbnQ6IEJCU19CTFMxMjM4MUcxX1hNRDpTSEEtMjU2X1NTV1VfUk9fCmZ1bmN0aW9uIGJicy5jaXBoZXJzdWl0ZShoYXNoX25hbWUpCiAgICAtLSBzZWVkX2xlbiA9IDQ4CiAgICBpZiBoYXNoX25hbWU6bG93ZXIoKSA9PSAnc2hhMjU2JyB0aGVuCiAgICAgICAgcmV0dXJuIENJUEhFUlNVSVRFX1NIQQoKICAgIGVsc2VpZiBoYXNoX25hbWU6bG93ZXIoKSA9PSAnc2hha2UyNTYnIHRoZW4KICAgICAgICByZXR1cm4gQ0lQSEVSU1VJVEVfU0hBS0UKICAgIGVsc2UKICAgICAgICBlcnJvcignSW52YWxpZCBoYXNoOiB1c2Ugc2hhMjU2IG9yIHNoYWtlMjU2JywgMikKICAgIGVuZAoKZW5kCgoKLS0gUkZDODAxNyBzZWN0aW9uIDQKLS0gY29udmVydHMgYSBub25uZWdhdGl2ZSBpbnRlZ2VyIHRvIGFuIG9jdGV0IHN0cmluZyBvZiBhIHNwZWNpZmllZCBsZW5ndGguCmxvY2FsIGZ1bmN0aW9uIGkyb3NwKHgsIHhfbGVuKQogICAgcmV0dXJuIE8ubmV3KEJJRy5uZXcoeCkpOnBhZCh4X2xlbikKZW5kCgotLSBSRkM4MDE3IHNlY3Rpb24gNAotLSBjb252ZXJ0cyBhbiBvY3RldCBzdHJpbmcgdG8gYSBub25uZWdhdGl2ZSBpbnRlZ2VyLgpsb2NhbCBmdW5jdGlvbiBvczJpcChvY3QpCiAgICByZXR1cm4gQklHLm5ldyhvY3QpCmVuZAoKLS0gSEFTSCBUTyBTQ0FMQVIgRlVOQ1RJT04KCi0tIEl0IGNvbnZlcnRzIGEgbWVzc2FnZSB3cml0dGVuIGluIG9jdGVjdHMgaW50byBhIEJJRyBtb2R1bG8gUFJJTUVfUiAob3JkZXIgb2Ygc3ViZ3JvdXApCgotLVtbIApJTlBVVDogY2lwaGVyc3VpdGUgKGEgdGFibGUpLCBtc2dfb2N0ZWN0cyAoYXMgemVucm9vbS5vY3RldCksIGRzdCAoYXMgemVucm9vbS5vY3RldCkKT1VUUFVUOiBoYXNoZWRfc2NhbGFyIChhcyB6ZW5yb29tLkJJRyksIHJlcHJlc2VudHMgYW4gaW50ZWdlciBiZXR3ZWVuIDEgYW5kIEVDUC5vcmRlcigpIC0gMQpdXQpsb2NhbCBmdW5jdGlvbiBoYXNoX3RvX3NjYWxhcihjaXBoZXJzdWl0ZSwgbXNnX29jdGVjdHMsIGRzdCkKICAgIGxvY2FsIEJJR18wID0gQklHLm5ldygwKQogICAgLS0gZHJhZnQtaXJ0Zi1jZnJnLWJicy1zaWduYXR1cmVzLWxhdGVzdCBTZWN0aW9uIDMuNC4zCiAgICBsb2NhbCBFWFBBTkRfTEVOID0gNDgKCiAgICAtLSBEZWZhdWx0IHZhbHVlIG9mIERTVCB3aGVuIG5vdCBwcm92aWRlZCAoc2VlIGFsc28gU2VjdGlvbiA2LjIuMikKICAgIGRzdCA9IGRzdCBvciBjaXBoZXJzdWl0ZS5oYXNoX3RvX3NjYWxhcl9kc3QKICAgIGxvY2FsIHVuaWZvcm1fYnl0ZXMgPSBjaXBoZXJzdWl0ZS5leHBhbmQobXNnX29jdGVjdHMsIGRzdCwgRVhQQU5EX0xFTikKICAgIGxvY2FsIGhhc2hlZF9zY2FsYXIgPSBCSUcubW9kKHVuaWZvcm1fYnl0ZXMsIFBSSU1FX1IpIC0tID0gb3MyaXAodW5pZm9ybV9ieXRlcykgJSBQUklNRV9SCiAgICByZXR1cm4gaGFzaGVkX3NjYWxhcgplbmQKCi0tIFNFQ1JFVCBLRVkgR0VORVJBVElPTiBGVU5DVElPTiBBTkQgUFVCTElDIEtFWSBHRU5FUkFUSU9OIEZVTkNUSU9OCgotLVtbIApJTlBVVDoga2V5X21hdGVyaWFsLCBrZXlfaW5mbywga2V5X2RzdCAoYWxsIGFzIHplbnJvb20ub2N0ZXQpLCBjaXBoZXJzdWl0ZSAoYXMgYSB0YWJsZSB0aGF0IHNob3VsZCBjb250YWluZWQgYWxsIGluZm9ybWF0aW9ucyBvZiB0aGUKdGFibGUgc2hvd24gYXQgbGluZXMgMTQgYW5kIDMwKQpPVVRQVVQ6IHNrIChhcyB6ZW5yb29tLm9jdGV0KSwgaXQgcmVwcmVzZW50cyBhIHNjYWxhciBiZXR3ZWVuIDEgYW5kIHRoZSBvcmRlciBvZiB0aGUgRUMgbWludXMgMQpdXQoKLS0tR2VuZXJhdGUgYSBzZWNyZXQga2V5IChzaykgZm9yIHVzZSBpbiBjcnlwdG9ncmFwaGljIG9wZXJhdGlvbnMuIAotLVRoZSBmdW5jdGlvbiB1c2VzIGEgcHJvdmlkZWQgY2lwaGVyc3VpdGUsIGtleSBtYXRlcmlhbCwga2V5IGluZm8sIGFuZCBkb21haW4gc2VwYXJhdGlvbiB0YWcgKERTVCkgdG8gZGVyaXZlIHRoZSBzZWNyZXQga2V5LiAKLS1UaGUgY2lwaGVyc3VpdGUgaXMgYSB0YWJsZSBjb250YWluaW5nIHRoZSBjaXBoZXIgc3VpdGUgY29uZmlndXJhdGlvbi4KLS1LZXkgbWF0ZXJpYWwgaXMgYW4gb3B0aW9uYWwgaW5wdXQgdXNlZCBhcyB0aGUgc2VlZCBmb3Iga2V5IGdlbmVyYXRpb24uIElmIG5vdCBwcm92aWRlZCwgYSBzZWN1cmUgcmFuZG9tIHZhbHVlIG9mIDMyIGJ5dGVzIGlzIGdlbmVyYXRlZC4KLS1LZXkgaW5mbyBpcyBhbiBvcHRpb25hbCBhZGRpdGlvbiBpbmZvcm1hdGlvbi4gSWYgbm90IHByb3ZpZGVkLCBpdCBkZWZhdWx0cyB0byBhbiBlbXB0eSBvY3RldC4gCi0ta2V5IERTVCBpcyBhbiBvcHRpb25hbCBkb21haW4gc2VwYXJhdGlvbiB0YWcuIElmIG5vdCBwcm92aWRlZCwgaXQgZGVmYXVsdHMgdG8gdGhlIGNpcGhlcnN1aXRlJ3MgY2lwaGVyc3VpdGVcX0lEIGNvbmNhdGVuYXRlZCB3aXRoIHRoZSBzdHJpbmcgJ0tFWUdFTlxfRFNUXF8nLgotLQotLUBmdW5jdGlvbiBCQlMua2V5Z2VuCi0tQHBhcmFtIGNpcGhlcnN1aXRlIAotLUBwYXJhbSBrZXlfbWF0ZXJpYWwKLS1AcGFyYW0ga2V5X2luZm8gCi0tQHBhcmFtIGtleV9kc3QKLS1AcmV0dXJuIHNrLCBhIHByaXZhdGUga2V5IDMyIGJ5dGVzIGxvbmcKLS1AdXNhZ2UgCi0tYmJzID0gcmVxdWlyZSdjcnlwdG9fYmJzJwotLSoqZ2VuZXJhdGUgY2lwaGVyc3VpdGUgYW5kICBrZXlfbSwga2V5X2luZm8sIGtleV9kc3QgYXMgcmFuZG9tIG9jdGV0IG9mIDMyIGJ5dGVzCi0tY2lwaGVyc3VpdGUgPSBiYnMuY2lwaGVyc3VpdGUoJ3NoYTI1NicpIAotLWtleV9tYXRlcmlhbCA9IE8ucmFuZG9tKDMyKQotLWtleV9pbmZvID0gTy5yYW5kb20oMzIpCi0ta2V5X2RzdCA9IE8ucmFuZG9wbSgzMikKLS0qKmNhbGN1bGF0ZSB0aGUgcHJpdmF0ZSBrZXkKLS1zayA9IGJicy5rZXlnZW4oY2lwaGVyc3VpdGUsIGtleV9tYXRlcmlhbCwga2V5X2luZm8sIGtleV9kc3QpCgpmdW5jdGlvbiBiYnMua2V5Z2VuKGNpcGhlcnN1aXRlLCBrZXlfbWF0ZXJpYWwsIGtleV9pbmZvLCBrZXlfZHN0KQogICAga2V5X21hdGVyaWFsID0ga2V5X21hdGVyaWFsIG9yIE8ucmFuZG9tKDMyKSAtLSBPLnJhbmRvbSBpcyBhIHNlY3VyZSBSTkcuCiAgICBpZiBub3QgY2lwaGVyc3VpdGUgdGhlbgogICAgICAgIGVycm9yKCdDaXBoZXJzdWl0ZSBub3QgaW5pdGlhbGl6ZWQgaW4gQkJTLmtleWdlbicsMikKICAgIGVuZAogICAgLS0gVE9ETzogYWRkIHdhcm5pbmcgb24gY3VydmUgbXVzdCBiZSBCTFMxMi0zODEKICAgIGlmIG5vdCBrZXlfaW5mbyB0aGVuCiAgICAgICAga2V5X2luZm8gPSBPLmVtcHR5KCkKICAgIGVsc2VpZiB0eXBlKGtleV9pbmZvKSA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICAga2V5X2luZm8gPSBPLmZyb21fc3RyaW5nKGtleV9pbmZvKQogICAgZW5kCiAgICBpZiBub3Qga2V5X2RzdCB0aGVuCiAgICAgICAga2V5X2RzdCA9IGNpcGhlcnN1aXRlLmNpcGhlcnN1aXRlX0lEIC4uIE8uZnJvbV9zdHJpbmcoJ0tFWUdFTl9EU1RfJykKICAgIGVsc2VpZiB0eXBlKGtleV9pbmZvKSA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICAga2V5X2RzdCA9IE8uZnJvbV9zdHJpbmcoa2V5X2luZm8pCiAgICBlbmQKICAgIGlmICNrZXlfbWF0ZXJpYWwgPCAzMiB0aGVuIGVycm9yKCdJTlZBTElEJywyKSBlbmQKICAgIGlmICNrZXlfaW5mbyA+IDY1NTM1IHRoZW4gZXJyb3IoJ0lOVkFMSUQnLDIpIGVuZAoKICAgIC0tIHVzaW5nIEJMUzM4MQogICAgLS0gMjU0IDwgbG9nMihQUklNRV9SKSA8IDI1NQogICAgLS0gY2VpbCgoMyAqIGNlaWwobG9nMihQUklNRV9SKSkpIC8gMTYpCiAgICBsb2NhbCBkZXJpdmVfaW5wdXQgPSBrZXlfbWF0ZXJpYWwgLi4gaTJvc3AoI2tleV9pbmZvLDIpIC4uIGtleV9pbmZvCiAgICBsb2NhbCBzayA9IGhhc2hfdG9fc2NhbGFyKGNpcGhlcnN1aXRlLCBkZXJpdmVfaW5wdXQsIGtleV9kc3QpCgogICAgcmV0dXJuIHNrCmVuZAoKZnVuY3Rpb24gYmJzLnNrMnBrKHNrKQogICAgcmV0dXJuIChFQ1AyLmdlbmVyYXRvcigpICogc2spOnRvX3pjYXNoKCkKZW5kCgotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQoKLS0gVEhFIEZPTExPV0lORyBNVUxUSS1MSU5FIENPTU1FTlQgQ09OVEFJTlMgR0VORVJJQyBWRVJTSU9OUyBPRiBUSEUgaGFzaF90b19maWVsZCBmdW5jdGlvbi4KCi0tIGRyYWZ0LWlydGYtY2ZyZy1oYXNoLXRvLWN1cnZlLTE2IHNlY3Rpb24gNS4yCi0taXQgcmV0dXJucyB1IGEgdGFibGUgb2YgdGFibGVzIGNvbnRhaW5pbmcgYmlnIGludGVnZXJzIHJlcHJlc2VudGluZyBlbGVtZW50cyBvZiB0aGUgZmllbGQKLS1bWwpmdW5jdGlvbiBiYnMuaGFzaF90b19maWVsZChtc2csIGNvdW50LCBEU1QpCiAgICAtLSBkcmFmdC1pcnRmLWNmcmctaGFzaC10by1jdXJ2ZS0xNiBzZWN0aW9uIDguOC4xIChCTFMxMi0zODEgcGFyYW1ldGVycykKICAgIC0tIEJMUzEyMzgxRzFfWE1EOlNIQS0yNTZfU1NXVV9ST18KICAgIGxvY2FsIG0gPSAxCiAgICBsb2NhbCBMID0gNjQKCiAgICBsb2NhbCBsZW5faW5fYnl0ZXMgPSBjb3VudCptKkwKICAgIGxvY2FsIHVuaWZvcm1fYnl0ZXMgPSBIQVNILmV4cGFuZF9tZXNzYWdlX3htZChtc2csIERTVCwgbGVuX2luX2J5dGVzKQogICAgbG9jYWwgdSA9IHt9CiAgICBmb3IgaSA9IDAsIChjb3VudC0xKSBkbwogICAgICAgIGxvY2FsIHVfaSA9IHt9CiAgICAgICAgZm9yIGogPSAwLCAobS0xKSBkbwogICAgICAgICAgICBsb2NhbCBlbG1fb2Zmc2V0ID0gTCooaitpKm0pCiAgICAgICAgICAgIGxvY2FsIHR2ID0gdW5pZm9ybV9ieXRlczpzdWIoZWxtX29mZnNldCsxLEwrZWxtX29mZnNldCkKICAgICAgICAgICAgbG9jYWwgZV9qID0gQklHLm1vZCh0diwgcCkgLS1sb2NhbCBlX2ogPSBvczJpcCh0dikgJSBwCiAgICAgICAgICAgIHVfaVtqKzFdID0gZV9qCiAgICAgICAgZW5kCiAgICAgICAgdVtpKzFdID0gdV9pCiAgICBlbmQKCiAgICByZXR1cm4gdQplbmQKCi0taGFzaF90b19maWVsZCBDQVNFIG0gPSAxCmZ1bmN0aW9uIGJicy5oYXNoX3RvX2ZpZWxkX20xKG1zZywgY291bnQsIERTVCkKICAgIC0tIGRyYWZ0LWlydGYtY2ZyZy1oYXNoLXRvLWN1cnZlLTE2IHNlY3Rpb24gOC44LjEgKEJMUzEyLTM4MSBwYXJhbWV0ZXJzKQogICAgLS0gQkxTMTIzODFHMV9YTUQ6U0hBLTI1Nl9TU1dVX1JPXwogICAgbG9jYWwgTCA9IDY0CgogICAgbG9jYWwgbGVuX2luX2J5dGVzID0gY291bnQqTAogICAgbG9jYWwgdW5pZm9ybV9ieXRlcyA9IEhBU0guZXhwYW5kX21lc3NhZ2VfeG1kKG1zZywgRFNULCBsZW5faW5fYnl0ZXMpCiAgICBsb2NhbCB1ID0ge30KICAgIGZvciBpID0gMCwgKGNvdW50LTEpIGRvCiAgICAgICAgbG9jYWwgZWxtX29mZnNldCA9IEwqaQogICAgICAgIGxvY2FsIHR2ID0gdW5pZm9ybV9ieXRlczpzdWIoZWxtX29mZnNldCsxLEwrZWxtX29mZnNldCkKICAgICAgICB1W2krMV0gPSBCSUcubW9kKHR2LCBwKSAtLWxvY2FsIGVfaiA9IG9zMmlwKHR2KSAlIHAKICAgIGVuZAoKICAgIHJldHVybiB1CmVuZAotLV1dCgotLSBkcmFmdC1pcnRmLWNmcmctaGFzaC10by1jdXJ2ZS0xNiBzZWN0aW9uIDUuMgotLSBJdCByZXR1cm5zIHUgYSB0YWJsZSBvZiB0YWJsZXMgY29udGFpbmluZyBiaWcgaW50ZWdlcnMgcmVwcmVzZW50aW5nIGVsZW1lbnRzIG9mIHRoZSBmaWVsZCAoU1BFQ0lGSUMgQ0FTRSBtID0gMSwgY291bnQgPSAyKQoKLS0tSGFzaCBhIG1lc3NhZ2UgaW50byB0d28gZmllbGQgZWxlbWVudHMgaW4gdGhlIHByaW1lIGZpZWxkIG9mIGFuIGVsbGlwdGljIGN1cnZlLgotLVRoaXMgaXMgYSBjb21tb24gb3BlcmF0aW9uIGluIGNyeXB0b2dyYXBoaWMgcHJvdG9jb2xzLCAgCi0td2hlcmUgbWVzc2FnZXMgbmVlZCB0byBiZSBtYXBwZWQgdG8gZmllbGQgZWxlbWVudHMuCi0tVGhlIHRoaXJkIGlucHV0IG9mIHRoZSBmdW5jdGlvbiwgdGhlIGRvbWFpbiBzZXBhcmF0aW9uIHRhZywgZW5zdXJlcyB0aGF0IHRoZSBzYW1lIGlucHV0IG1lc3NhZ2UgY2FuIGJlIGhhc2hlZCBkaWZmZXJlbnRseSAKLS1mb3IgZGlmZmVyZW50IHB1cnBvc2VzLCBwcmV2ZW50aW5nIGNvbGxpc2lvbnMgb3IgdW5pbnRlbmRlZCByZXVzZSBvZiBoYXNoIG91dHB1dHMuCi0tCi0tQGZ1bmN0aW9uIEJCUy5oYXNoX3RvX2ZpZWxkX20xX2MyCi0tQHBhcmFtIGNpcGhlcnN1aXRlCi0tQHBhcmFtIG1zZyB0aGUgaW5wdXQgbWVzc2FnZSB0byBiZSBoYXNoZWQKLS1AcGFyYW0gZHN0IGEgZG9tYWluIHNlcGFyYXRpb24gdGFnCi0tQHJldHVybiBhIHRhYmxlIGNvbnRhaW5pbmcgdGhlIHR3byBmaWVsZCBlbGVtZW50cwotLUB1c2FnZSAKLS1iYnMgPSByZXF1aXJlJ2NyeXB0b19iYnMnCi0tKipkZWZpbmUgYSBjaXBoZXJzdWl0ZSwgYSBEU1QgYW5kIGEgcmFuZG9tIG1lc3NhZ2UKLS1jaXBoZXJzdWl0ZSA9IGJicy5jaXBoZXJzdWl0ZSgnc2hhMjU2JykgCi0tRFNUX2hhc2hfdG9fZmllbGQgPSAnUVVVWC1WMDEtQ1MwMi13aXRoLUJMUzEyMzgxRzFfWE1EOlNIQS0yNTZfU1NXVV9ST18nCi0tbXNnID0gTy5yYW5kb20oMzIpCi0tKipyZXR1cm4gdGhlIHRhYmxlIEguIEhbMV0gYW5kIEhbMl0gd2lsbCBiZSB0aGUgdHdvIGZpZWxkIGVsZW1lbnRzCi0tSCA9IGJicy5oYXNoX3RvX2ZpZWxkX20xX2MyKGNpcGhlcnN1aXRlLCBtc2csIERTVF9oYXNoX3RvX2ZpZWxkKQoKZnVuY3Rpb24gYmJzLmhhc2hfdG9fZmllbGRfbTFfYzIoY2lwaGVyc3VpdGUsIG1zZywgZHN0KQogICAgbG9jYWwgcCA9IEVDUC5wcmltZSgpCiAgICBsb2NhbCBMID0gNjQKCiAgICBsb2NhbCB1bmlmb3JtX2J5dGVzID0gY2lwaGVyc3VpdGUuZXhwYW5kKG1zZywgZHN0LCAyKkwpCiAgICBsb2NhbCB1ID0ge30KICAgIHVbMV0gPSBCSUcubW9kKHVuaWZvcm1fYnl0ZXM6c3ViKDEsTCksIHApCiAgICB1WzJdID0gQklHLm1vZCh1bmlmb3JtX2J5dGVzOnN1YihMKzEsMipMKSwgcCkKICAgIHJldHVybiB1CmVuZAoKCi0tIGRyYWZ0LWlydGYtY2ZyZy1oYXNoLXRvLWN1cnZlLTE2IFNlY3Rpb24gNwotLSBJdCByZXR1cm5zIGEgcG9pbnQgaW4gdGhlIGNvcnJlY3Qgc3ViZ3JvdXAuCmxvY2FsIGZ1bmN0aW9uIGNsZWFyX2NvZmFjdG9yKGVjcF9wb2ludCkKICAgIGxvY2FsIGhfZWZmID0gQklHLm5ldyhPLmZyb21faGV4KCdkMjAxMDAwMDAwMDEwMDAxJykpCiAgICByZXR1cm4gZWNwX3BvaW50ICogaF9lZmYKZW5kCgotLUhBU0ggVE8gQ1VSVkUgQU5EIENSRUFURSBHRU5FUkFUT1JTIEFSRSBWRVJZIFNMT1csIE1BWUJFIEJFVFRFUiBUTyBJTVBMRU1FTlQgU09NRVRISU5HIElOIEMgU0VFIGh0dHBzOi8vZ2l0aHViLmNvbS9keW5lL1plbnJvb20vaXNzdWVzLzY0MiAgCi0tIGRyYWZ0LWlydGYtY2ZyZy1oYXNoLXRvLWN1cnZlLTE2IFNlY3Rpb24gMwotLSBJdCByZXR1cm5zIGEgcG9pbnQgaW4gdGhlIGNvcnJlY3Qgc3ViZ3JvdXAuCgotLS1IYXNoIGEgbWVzc2FnZSB0byBhIHBvaW50IG9uIGFuIGVsbGlwdGljIGN1cnZlLiBUaGlzIGlzIGEgY29tbW9uIG9wZXJhdGlvbiBpbiBjcnlwdG9ncmFwaGljIHByb3RvY29scywgd2hlcmUgbWVzc2FnZXMgCi0tbmVlZCB0byBiZSBtYXBwZWQgdG8gY3VydmUgcG9pbnRzIGZvciBvcGVyYXRpb25zIGxpa2Ugc2lnbmluZyBhbmQgdmVyaWZpY2F0aW9uLgotLUl0IHVzZXMgQHtoYXNoX3RvX2ZpZWxkX20xX2MyfSBmdW5jdGlvbiB0byBoYXNoIHRoZSBtZXNzYWdlIGludG8gdHdvIGZpZWxkIGVsZW1lbnRzIAotLXRoYXQgYXJlIG1hcHBlZCB0byBhIHBvaW50IG9uIHRoZSBlbGxpcHRpYyBjdXJ2ZS4KLS0KLS1AZnVuY3Rpb24gQkJTLmhhc2hfdG9fY3VydmUKLS1AcGFyYW0gY2lwaGVyc3VpdGUgCi0tQHBhcmFtIG1zZyB0aGUgaW5wdXQgbWVzc2FnZSB0byBiZSBoYXNoZWQKLS1AcGFyYW0gZHN0IGEgZG9tYWluIHNlcGFyYXRpb24gdGFnCi0tQHJldHVybiB0aGUgZmluYWwgY3VydmUgcG9pbnQgYWZ0ZXIgY2xlYXJpbmcgdGhlIGNvZmFjdG9yCi0tQHVzYWdlIAotLWJicyA9IHJlcXVpcmUnY3J5cHRvX2JicycKLS0qKmRlZmluZSBhIGNpcGhlcnN1aXRlLCBhIERTVCBhbmQgYSByYW5kb20gbWVzc2FnZQotLWNpcGhlcnN1aXRlID0gYmJzLmNpcGhlcnN1aXRlKCdzaGEyNTYnKSAKLS1EU1RfaGFzaF90b19maWVsZCA9ICdRVVVYLVYwMS1DUzAyLXdpdGgtQkxTMTIzODFHMV9YTUQ6U0hBLTI1Nl9TU1dVX1JPXycKLS1tc2cgPSBPLnJhbmRvbSgzMikKLS0qKnJldHVybiB0aGUgY3VydmUgcG9pbnQKLS1QID0gYmJzLmhhc2hfdG9fY3VydmUoY2lwaGVyc3VpdGUsIG1zZywgRFNUX2hhc2hfdG9fZmllbGQpCgpmdW5jdGlvbiBiYnMuaGFzaF90b19jdXJ2ZShjaXBoZXJzdWl0ZSwgbXNnLCBkc3QpCiAgICAtLSBsb2NhbCB1ID0gYmJzLmhhc2hfdG9fZmllbGRfbTEobXNnLCAyLCBEU1QpCiAgICBsb2NhbCBwID0gRUNQLnByaW1lKCkKICAgIGxvY2FsIHUgPSBiYnMuaGFzaF90b19maWVsZF9tMV9jMihjaXBoZXJzdWl0ZSwgbXNnLCBkc3QpCiAgICBsb2NhbCBRMCA9IGZhc3RCQlMubWFwX3RvX2N1cnZlKHVbMV0pCiAgICBsb2NhbCBRMSA9IGZhc3RCQlMubWFwX3RvX2N1cnZlKHVbMl0pCiAgICByZXR1cm4gY2xlYXJfY29mYWN0b3IoUTAgKyBRMSkKZW5kCgotLWRyYWZ0LWlydGYtY2ZyZy1iYnMtc2lnbmF0dXJlcyBTZWN0aW9uIDQuMgotLUl0IHJldHVybnMgYW4gYXJyYXkgb2YgZ2VuZXJhdG9ycy4KCi0tLUNyZWF0ZSBhIHNldCBvZiBjcnlwdG9ncmFwaGljIGdlbmVyYXRvcnMuIAotLVRoZXNlIGdlbmVyYXRvcnMgYXJlIHBvaW50cyBvbiBhbiBlbGxpcHRpYyBjdXJ2ZSBhbmQgYXJlIHVzZWQgaW4gb3BlcmF0aW9ucyBsaWtlIHNpZ25pbmcgYW5kIHZlcmlmaWNhdGlvbi4gCi0tVGhlIGZ1bmN0aW9uIGVuc3VyZXMgdGhhdCB0aGUgZ2VuZXJhdG9ycyBhcmUgY3JlYXRlZCBkZXRlcm1pbmlzdGljYWxseSBhbmQgc2VjdXJlbHksIAotLWJhc2VkIG9uIGEgc2VlZCB2YWx1ZSBhbmQgZG9tYWluIHNlcGFyYXRpb24gdGFncy4KLS0KLS1AZnVuY3Rpb24gQkJTLmNyZWF0ZV9nZW5lcmF0b3JzCi0tQHBhcmFtIGNpcGhlcnN1aXRlCi0tQHBhcmFtIGNvdW50IHRoZSBudW1iZXIgb2YgZ2VuZXJhdG9ycyB0byBjcmVhdGUKLS1AcmV0dXJuIHRoZSBmaXJzdCAnY291bnQnIGdlbmVyYXRvcnMgZnJvbSB0aGUgY2lwaGVyc3VpdGUuR0VORVJBVE9SUyB0YWJsZQotLUB1c2FnZQotLWJicyA9IHJlcXVpcmUnY3J5cHRvX2JicycKLS0qKmRlZmluZSBhIGNpcGhlcnN1aXRlIGFuZCBhIGNvdW50Ci0tY2lwaGVyc3VpdGUgPSBiYnMuY2lwaGVyc3VpdGUoJ3NoYTI1NicpIAotLWNvdW50ID0gNQotLSoqcmV0dXJuIGEgdGFibGUgRyBvZiA1IGdlbmVyYXRvcnMKLS1HID0gYmJzLmNyZWF0ZV9nZW5lcmF0b3JzKGNpcGhlcnN1aXRlLGNvdW50KQoKZnVuY3Rpb24gYmJzLmNyZWF0ZV9nZW5lcmF0b3JzKGNpcGhlcnN1aXRlLCBjb3VudCkKICAgIGlmIGNvdW50ID4gMl42NCAtMSB0aGVuIGVycm9yKCJNZXNzYWdlJ3MgbnVtYmVyIHRvbyBiaWcuIEF0IG1vc3QgMl42NC0xIG1lc3NhZ2UgYWxsb3dlZCIpIGVuZAoKICAgIGlmICNjaXBoZXJzdWl0ZS5HRU5FUkFUT1JTIDwgY291bnQgdGhlbgogICAgICAgIC0tIGxvY2FsIHNlZWRfbGVuID0gNDggLS1jZWlsKChjZWlsKGxvZzIoUFJJTUVfUikpICsgaykvOCkKICAgICAgICBsb2NhbCB2ID0gY2lwaGVyc3VpdGUuR0VORVJBVE9SX1YKCiAgICAgICAgZm9yIGkgPSAjY2lwaGVyc3VpdGUuR0VORVJBVE9SUyArIDEsIGNvdW50IGRvCiAgICAgICAgICAgIHYgPSBjaXBoZXJzdWl0ZS5leHBhbmQodi4uaTJvc3AoaSw4KSwgY2lwaGVyc3VpdGUuc2VlZF9kc3QsIDQ4KQogICAgICAgICAgICBsb2NhbCBnZW5lcmF0b3IgPSBiYnMuaGFzaF90b19jdXJ2ZShjaXBoZXJzdWl0ZSwgdiwgY2lwaGVyc3VpdGUuZ2VuZXJhdG9yX2RzdCkKICAgICAgICAgICAgdGFibGUuaW5zZXJ0KGNpcGhlcnN1aXRlLkdFTkVSQVRPUlMsIGdlbmVyYXRvcikKICAgICAgICBlbmQKCiAgICAgICAgY2lwaGVyc3VpdGUuR0VORVJBVE9SX1YgPSB2CiAgICAgICAgcmV0dXJuIGNpcGhlcnN1aXRlLkdFTkVSQVRPUlMKICAgIGVsc2UKICAgICAgICByZXR1cm4ge3RhYmxlLnVucGFjayhjaXBoZXJzdWl0ZS5HRU5FUkFUT1JTLCAxLCBjb3VudCl9CiAgICBlbmQKZW5kCgoKLS1bWyAKREVTQ1JJUFRJT046IHRoZSBmdW5jdGlvbiBiYnMubWVzc2FnZXNfdG9fc2NhbGFycyBpcyB0aGUgbmV3IHZlcnNpb24gb2YgdGhlIGZ1bmN0aW9uIGJicy5NYXBNZXNzYWdlVG9TY2FsYXJBc0hhc2guClRoZSBtYWluIGRpZmZlcmVuY2UgaXMgdGhhdCBpbiB0aGUgbmV3IHZlcmlzb24gd2UgY2FuIHRyYW5zZm9ybSBhIHNldCBvZiBtZXNzYWdlcyBpbnRvIGEgc2NhbGFyIGluc3RlYWQgb2YgdHJhbnNmb3JtaW5nIG9uZSBtZXNzYWdlLgpJTlBVVDogbWVzc2FnZXMgKGEgdmVjdG9yIG9mIHplbnJvb20ub2N0ZXQgd2hlcmUgaW5kZXggc3RhcnRzIGZyb20gMSksIGFwaV9pZCAoYXMgemVucm9vbS5vY3RldCkgd2hpY2ggRk9SIE5PVyBpcyBzdG9yZWQgaW4gdGhlIGNpcGhlcnN1aXRlIGZvciBzaW1wbGljaXR5LgpPVVRQVVQ6IG1zZ19zY2FsYXJzIChhIHZlY3RvciBvZiBzY2FsYXJzIHN0b3JlZCBhcyB6ZW5yb29tLm9jdGV0KQpdXQoKLS0tQ29udmVydCBhIGxpc3Qgb2YgbWVzc2FnZXMsIGEgdmVjdG9yIG9mIG9jdGV0cywgaW50byBhIGxpc3Qgb2Ygc2NhbGFyIHZhbHVlcyB1c2luZyBhIGNyeXB0b2dyYXBoaWMgaGFzaCBmdW5jdGlvbi4KLS0KLS1AZnVuY3Rpb24gQkJTLm1lc3NhZ2VzX3RvX3NjYWxhcnMKLS1AcGFyYW0gY2lwaGVyc3VpdGUKLS1AcGFyYW0gbWVzc2FnZXMgYSBzZXQgb2YgbWVzc2FnZXMKLS1AcmV0dXJuIGEgdmVjdG9yIG9mIHNjYWxhcnMgc3RvcmVkIGFzIG9jdGV0Ci0tQHVzYWdlIAotLWJicyA9IHJlcXVpcmUnY3J5cHRvX2JicycKLS0qKmRlZmluZSBhIGNpcGhlcnN1aXRlIGFuZCBhIHNldCBvZiByYW5kb20gbWVzc2FnZXMKLS1jaXBoZXJzdWl0ZSA9IGJicy5jaXBoZXJzdWl0ZSgnc2hhMjU2JykgCi0tbWFwX21lc3NhZ2VzX3RvX3NjYWxhcl9tZXNzYWdlcyA9IHsKLS0gICAgTy5yYW5kb20oMzIpLAotLSAgICBPLnJhbmRvbSg2NCksCi0tICAgIE8ucmFuZG9tKDE2KSAgCi0tfQotLSoqcmV0dXJuIGEgdmVjdG9yIG9mIG9jdGV0cwotLW91dHB1dF9zY2FsYXIgPSBiYnMubWVzc2FnZXNfdG9fc2NhbGFycyhjaXBoZXJzdWl0ZSxtYXBfbWVzc2FnZXNfdG9fc2NhbGFyX21lc3NhZ2VzKQoKZnVuY3Rpb24gYmJzLm1lc3NhZ2VzX3RvX3NjYWxhcnMoY2lwaGVyc3VpdGUsIG1lc3NhZ2VzKQoKICAgIGxvY2FsIEwgPSB0YWJsZV9zaXplKG1lc3NhZ2VzKQoKICAgIC0tIGZvciBub3cgYXBpX2lkIGlzIGluIHRoZSBjaXBoZXJzdWl0ZSBzbyB3ZSBhbHJlYWR5IGtub3cgaXQgaXMgYWx3YXlzIGdpdmVuIGFzIGlucHV0IHNpbmNlIGNpcGhlcnN1aXRlIGlzIGFsd2F5cyBnaXZlbgogICAgLS0gbGF0ZXIgd2UgbWF5IGFkZCBhIGNoZWNrOiBpZiBhcGlfaWQgaXMgdW5rbm93biB1c2UgYW4gZW1wdHkgc3RyaW5nCgogICAgbG9jYWwgbXNnX3NjYWxhcnMgPSB7fQoKICAgIGZvciBpID0gMSwgTCBkbwogICAgICAgIG1zZ19zY2FsYXJzW2ldID0gaGFzaF90b19zY2FsYXIoY2lwaGVyc3VpdGUsbWVzc2FnZXNbaV0sY2lwaGVyc3VpdGUubWFwX21zZ190b19zY2FsYXJfYXNfaGFzaF9kc3QpCiAgICBlbmQKCiAgICByZXR1cm4gbXNnX3NjYWxhcnMKCmVuZAoKLS1bWwpERVNDUklQVElPTjogVGhlIGZvbGxvd2luZyBmdW5jdGlvbiB0YWtlcyBpbiBpbnB1dCBhbiBhcnJheSBvZiBlbGVtZW50cyB0aGF0IGNhbiBiZSBwb2ludHMgb24gdGhlIEVDIChhcyB6ZW5yb29tLmVjcCBvciB6ZW5yb29tLmVjcDIpLAogICAgYmlnIGludGVnZXJzIChhcyB6ZW5yb29tLmJpZykgYW5kIGludGVnZXJzIChhcyBudW1iZXIpLiBJdCBjb252ZXJ0cyBlYWNoIGVsZW1lbnQgb2YgdGhlIGFycmF5IGludG8gYW4gb2N0ZXQgc3RyaW5nICh6ZW5yb29tLm9jdGV0KSBhbmQKICAgIG91dHB1dCB0aGUgY29uY2F0ZW5hdGlvbiBvZiBhbGwgc3VjaCBzdHJpbmdzLgogICAgSU5QVVQ6IGFycmF5IG9mIGVsZW1lbnRzIGluICJ6ZW5yb29tLmVjcCIsICJ6ZW5yb29tLmVjcDIiLCAiemVucm9vbS5iaWciIG9yICJudW1iZXIiCiAgICBPVVRQVVQ6IG9jdGV0X3Jlc3VsdCBhcyAiemVucm9vbS5vY3RldCIKXV0KbG9jYWwgZnVuY3Rpb24gc2VyaWFsaXphdGlvbihpbnB1dF9hcnJheSkKICAgIGxvY2FsIG9jdGV0X3Jlc3VsdCA9IE8uZW1wdHkoKQogICAgbG9jYWwgZWxfb2N0cyA9IE8uZW1wdHkoKQogICAgZm9yIGk9MSwgdGFibGVfc2l6ZShpbnB1dF9hcnJheSkgZG8KICAgICAgICBsb2NhbCBlbHQgPSBpbnB1dF9hcnJheVtpXQogICAgICAgIGxvY2FsIGVsdF90eXBlID0gdHlwZShlbHQpCiAgICAgICAgaWYgKGVsdF90eXBlID09ICJ6ZW5yb29tLmVjcCIpIG9yIChlbHRfdHlwZSA9PSAiemVucm9vbS5lY3AyIikgdGhlbgogICAgICAgICAgICBlbF9vY3RzID0gZWx0OnRvX3pjYXNoKCkKICAgICAgICBlbHNlaWYgKGVsdF90eXBlID09ICJ6ZW5yb29tLmJpZyIpIHRoZW4KICAgICAgICAgICAgZWxfb2N0cyA9IGkyb3NwKGVsdCwgT0NURVRfU0NBTEFSX0xFTkdUSCkKICAgICAgICBlbHNlaWYgKGVsdF90eXBlID09ICJudW1iZXIiKSB0aGVuCiAgICAgICAgICAgIGVsX29jdHMgPSBpMm9zcChlbHQsIDgpCiAgICAgICAgZWxzZQogICAgICAgICAgICBlcnJvcigiSW52YWxpZCB0eXBlIHBhc3NlZCBpbnNpZGUgc2VyaWFsaXplIiwgNCkKICAgICAgICBlbmQKCiAgICAgICAgb2N0ZXRfcmVzdWx0ID0gb2N0ZXRfcmVzdWx0IC4uIGVsX29jdHMKCiAgICBlbmQKCiAgICByZXR1cm4gb2N0ZXRfcmVzdWx0CmVuZAoKLS1bWwpERVNDUklQVElPTjogSXQgY2FsY3VsYXRlcyBhIGRvbWFpbiB2YWx1ZSwgZGlzdGlsbGF0aW5nIGFsbCBlc3NlbnRpYWwgY29udGV4dHVhbCBpbmZvcm1hdGlvbiBmb3IgYSBzaWduYXR1cmUuCklOUFVUOiBQSyAoYXMgemVucm9vbS5vY3RldCkgcmVwcmVzZW50aW5nIHRoZSBwdWJsaWMga2V5LCBRMSAoYXMgemVucm9vbS5lY3ApIHJlcHJlc2VudGluZyBhIHBvaW50IG9uIHRoZSBFQywgSF9wb2ludHMgKGFuIGFycmF5IG9mIHBvaW50cwpvbiB0aGUgc3ViZ3JvdXAgc3RvcmVkIGFzIHplbnJvb20uZWNwKSwgaGVhZGVyIChhcyB6ZW5yb29tLm9jdGV0KQpPVVRQVVQ6IGEgc2NhbGFyIHJlcHJlc2VudGVkIGFzIHplbnJvb20ub2N0ZXQKXV0KbG9jYWwgZnVuY3Rpb24gY2FsY3VsYXRlX2RvbWFpbihjaXBoZXJzdWl0ZSwgcGtfb2N0ZXQsIFExLCBIX3BvaW50cywgaGVhZGVyKQoKICAgIGhlYWRlciA9IGhlYWRlciBvciBPLmVtcHR5KCkKCiAgICBsb2NhbCBsZW4gPSAjSF9wb2ludHMKICAgIC0tIGFzc2VydCgjKGhlYWRlcikgPCAyXjY0KQogICAgLS0gYXNzZXJ0KEwgPCAyXjY0KQoKICAgIGxvY2FsIGRvbV9hcnJheSA9IHtsZW4sIFExLCB0YWJsZS51bnBhY2soSF9wb2ludHMpfQogICAgbG9jYWwgZG9tX29jdHMgPSBzZXJpYWxpemF0aW9uKGRvbV9hcnJheSkgLi4gY2lwaGVyc3VpdGUuYXBpX0lECiAgICBsb2NhbCBkb21faW5wdXQgPSBwa19vY3RldCAuLiBkb21fb2N0cyAuLiBpMm9zcCgjaGVhZGVyLCA4KSAuLiBoZWFkZXIKICAgIGxvY2FsIGRvbWFpbiA9IGhhc2hfdG9fc2NhbGFyKGNpcGhlcnN1aXRlLCBkb21faW5wdXQsY2lwaGVyc3VpdGUuaGFzaF90b19zY2FsYXJfZHN0KQoKICAgIHJldHVybiBkb21haW4KZW5kCgotLVtbCkRFU0NSSVBUSU9OOiAgVGhpcyBvcGVyYXRpb24gY29tcHV0ZXMgYSBkZXRlcm1pbmlzdGljIHNpZ25hdHVyZSBmcm9tIGEgc2VjcmV0IGtleShTSyksIGEgc2V0IG9mIGdlbmVyYXRvcnMgKHBvaW50cyBvZiBHMSkgYW5kCm9wdGlvbmFsbHkgYSBoZWFkZXIgYW5kIGEgdmVjdG9yIG9mIG1lc3NhZ2VzLgpJTlBVVDogY2lwaGVyc3VpdGUsIFNLIGFzICh6ZW5yb29tLm9jdGV0KSwgUEsgKGFzIHplbnJvb20ub2N0ZXQpIHJlcHJlc2VudGluZyB0aGUgcHVibGljIGtleSwgbWVzc2FnZXMoIGFuIGFycmF5IG9mIHNjYWxhcnMgcmVwcmVzZW50aW5nIHRoZSBtZXNzYWdlcywKc3RvcmVkIGFzIHplbnJvb20uYmlnKSwgZ2VuZXJhdG9ycyAoIGFuIGFycmF5IG9mIHBvaW50cyBvbiB0aGUgc3ViZ3JvdXAgb2YgRUMxIHN0b3JlZCBhcyB6ZW5yb29tLmVjcCksIGhlYWRlciAoYXMgemVucm9vbS5vY3RldCkKT1VUUFVUOiBhIHBhaXIgKEEsZSkgcmVwcmVzZW50ZWQgYXMgemVucm9vbS5vY3RldApdXQpsb2NhbCBmdW5jdGlvbiBjb3JlX3NpZ24oY2lwaGVyc3VpdGUsIHNrLCBwaywgaGVhZGVyLCBtZXNzYWdlcywgZ2VuZXJhdG9ycykKCiAgICAtLSBEZXNlcmlhbGl6YXRpb24KICAgIGxvY2FsIExFTiA9ICNtZXNzYWdlcwogICAgaWYgKCNnZW5lcmF0b3JzIH49IChMRU4gKzEpKSB0aGVuCiAgICAgICAgZXJyb3IoIlRoZSBudW1iZXJzIG9mIGdlbmVyYXRvcnMgbXVzdCBiZSAjbWVzc2FnZXMgKzEiLDMpCiAgICBlbmQKCiAgICBsb2NhbCBRXzEgPSBnZW5lcmF0b3JzWzFdCiAgICBsb2NhbCBIX2FycmF5ID0geyB0YWJsZS51bnBhY2soZ2VuZXJhdG9ycywgMiwgTEVOICsgMSkgfQoKICAgIC0tUHJvY2VkdXJlCiAgICBsb2NhbCBkb21haW4gPSBjYWxjdWxhdGVfZG9tYWluKGNpcGhlcnN1aXRlLCBwayAsIFFfMSwgSF9hcnJheSwgaGVhZGVyKQogICAgbG9jYWwgc2VyaWFsaXplX2FycmF5ID0ge3NrLCB0YWJsZS51bnBhY2sobWVzc2FnZXMpfQogICAgdGFibGUuaW5zZXJ0KHNlcmlhbGl6ZV9hcnJheSwgZG9tYWluKQogICAgbG9jYWwgZSA9IGhhc2hfdG9fc2NhbGFyKGNpcGhlcnN1aXRlLCBzZXJpYWxpemF0aW9uKHNlcmlhbGl6ZV9hcnJheSkpCgogICAgbG9jYWwgQkIgPSBjaXBoZXJzdWl0ZS5QMSArIFFfMSogZG9tYWluCiAgICBpZiAoTEVOID4gMCkgdGhlbgogICAgICAgIGZvciBpID0gMSxMRU4gZG8KICAgICAgICAgICAgQkIgPSBCQiArIChIX2FycmF5W2ldKiBtZXNzYWdlc1tpXSkKICAgICAgICBlbmQKICAgIGVuZAogICAgaWYgKEJJRy5tb2Qoc2sgKyBlLCBQUklNRV9SKSA9PSBCSUcubmV3KDApKSAgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIHZhbHVlIGZvciBlIiwzKSAgIAogICAgZW5kCiAgICBsb2NhbCBBQSA9IEJCICogQklHLm1vZGRpdihCSUcubmV3KDEpLCBzayArIGUsIFBSSU1FX1IpCiAgICByZXR1cm4gc2VyaWFsaXphdGlvbih7QUEsIGV9KQplbmQKCgotLVtbCkRFU0NSSVBUSU9OOiBUaGUgU2lnbiBvcGVyYXRpb24gcmV0dXJucyBhIEJCUyBzaWduYXR1cmUgZnJvbSBhIHNlY3JldCBrZXkgKFNLKSwgb3ZlciBhIGhlYWRlciBhbmQgYSBzZXQgb2YgbWVzc2FnZXMuCklOUFVUOiBjaXBoZXJzdWl0ZSAsIHNrIChhcyB6ZW5yb29tLm9jdGV0KSwgcGsgKGFzIHplbnJvb20ub2N0ZXQpLCBoZWFkZXIgKGFzIHplbnJvb20ub2N0ZXQpLCBtZXNzYWdlcyAoYXJyYXkgb2Ygb2N0ZXQgc3RyaW5ncyBzdG9yZWQgYXMgemVucm9vbS5vY3RldCksCmhlYWRlciAoYXMgemVucm9vbS5vY3RldCkuCk9VVFBVVDogdGhlIHNpZ25hdHVyZSAoQSxlKQpdXQoKLS0tVGhlIFNpZ24gb3BlcmF0aW9uIHJldHVybnMgYSBCQlMgc2lnbmF0dXJlIGZyb20gYSBzZWNyZXQga2V5IChzayksIG92ZXIgYSBoZWFkZXIgYW5kIGEgc2V0IG9mIG1lc3NhZ2VzLiAKLS1JdCB1c2VzIHRoZSA8Y29kZT5jb3JlX3NpZ248L2NvZGU+IGZ1bmN0aW9uLCB0aGF0IGNvbXB1dGVzIGEgZGV0ZXJtaW5pc3RpYyBzaWduYXR1cmUgZnJvbSBhIHNlY3JldCBrZXkgKHNrKSwgYSBzZXQgb2YgZ2VuZXJhdG9ycyAocG9pbnRzIG9mIEcxKSAKLS1hbmQgb3B0aW9uYWxseSBhIGhlYWRlciBhbmQgYSB2ZWN0b3Igb2YgbWVzc2FnZXMuCi0tCi0tQGZ1bmN0aW9uIEJCUy5zaWduCi0tQHBhcmFtIGNpcGhlcnN1aXRlIAotLUBwYXJhbSBzayB0aGUgc2VjcmV0IGtleSBhcyBhbiBvY3RldAotLUBwYXJhbSBoZWFkZXIKLS1AcGFyYW0gbWVzc2FnZXMgYXJyYXkgb2Ygb2N0ZXQgc3RyaW5ncyBzdG9yZWQgYXMgb2N0ZXQKLS1AcmV0dXJuIHRoZSBzaWduYXR1cmUgCi0tQHVzYWdlIAotLWJicyA9IHJlcXVpcmUnY3J5cHRvX2JicycKLS0qKmRlZmluZSBhIGNpcGhlcnN1aXRlLCBhIHNlY3JldCBrZXksIGEgcHVibGljIGtleSwgYW4gaGVhZGVyIGFuZCBhIG1lc3NhZ2UgCi0tY2lwaGVyc3VpdGUgPSBiYnMuY2lwaGVyc3VpdGUoJ3NoYTI1NicpIAotLVNFQ1JFVF9LRVkgPSAiNjBlNTUxMTBmNzY4ODNhMTNkMDMwYjJmNmJkMTE4ODM0MjJkNWFiZGU3MTc1NjlmYzA3MzFmNTEyMzcxNjlmYyIKLS1IRUFERVIgPSAiMTEyMjMzNDQ1NTY2Nzc4ODk5MDBhYWJiY2NkZGVlZmYiCi0tU0lOR0xFX01TR19BUlJBWSA9IHsgTy5mcm9tX2hleCgiOTg3MmFkMDg5ZTQ1MmM3YjZlMjgzZGZhYzJhODBkNThlOGQwZmY3MWNjNGQ1ZTMxMGExZGViZGRhNGE0NWYwMiIpIH0KLS0qKmNhbGN1bGF0ZSB0aGUgc2lnbmF0dXJlIGZvciB0aGUgZ2l2ZW4gbWVzc2FnZQotLW91dHB1dF9zaWduYXR1cmUgPSBiYnMuc2lnbihjaXBoZXJzdWl0ZSwgQklHLm5ldyhPLmZyb21faGV4KFNFQ1JFVF9LRVkpKSwgTy5mcm9tX2hleChIRUFERVIpLCBTSU5HTEVfTVNHX0FSUkFZKQoKCmZ1bmN0aW9uIGJicy5zaWduKGNpcGhlcnN1aXRlLCBzaywgaGVhZGVyLCBtZXNzYWdlc19vY3RldHMpCgogICAgLS0gRGVmYXVsdCB2YWx1ZXMgZm9yIGhlYWRlciBhbmQgbWVzc2FnZXMuCiAgICBpZiBub3QgbWVzc2FnZXNfb2N0ZXRzIHRoZW4KICAgICAgICAgICAgZXJyb3IoJ0VtcHR5IG1lc3NhZ2UgYXJndW1lbnQgaW4gQkJTLnNpZ24nLDIpCiAgICBlbmQKICAgIGxvY2FsIHBrID0gYmJzLnNrMnBrKHNrKQogICAgaGVhZGVyID0gaGVhZGVyIG9yIE8uZW1wdHkoKQogICAgbG9jYWwgbWVzc2FnZXMgPSBiYnMubWVzc2FnZXNfdG9fc2NhbGFycyhjaXBoZXJzdWl0ZSxtZXNzYWdlc19vY3RldHMpCgogICAgbG9jYWwgZ2VuZXJhdG9ycyA9IGJicy5jcmVhdGVfZ2VuZXJhdG9ycyhjaXBoZXJzdWl0ZSwgI21lc3NhZ2VzICsxKQogICAgbG9jYWwgc2lnbmF0dXJlID0gY29yZV9zaWduKGNpcGhlcnN1aXRlLCBzaywgcGssIGhlYWRlciwgbWVzc2FnZXMsIGdlbmVyYXRvcnMpCiAgICByZXR1cm4gc2lnbmF0dXJlCgplbmQKCi0tZHJhZnQtaXJ0Zi1jZnJnLWJicy1zaWduYXR1cmVzIFNlY3Rpb24gNC43LjMKLS0gSXQgaXMgdGhlIG9wcG9zaXRlIGZ1bmN0aW9uIG9mICJzZXJpYWxpemUiIHdpdGggaW5wdXQgIihQT0lOVCwgU0NBTEFSLCBTQ0FMQVIpIgpsb2NhbCBmdW5jdGlvbiBvY3RldHNfdG9fc2lnbmF0dXJlKHNpZ25hdHVyZV9vY3RldHMpCiAgICBsb2NhbCBleHBlY3RlZF9sZW4gPSBPQ1RFVF9TQ0FMQVJfTEVOR1RIICsgT0NURVRfUE9JTlRfTEVOR1RICiAgICBpZiAoI3NpZ25hdHVyZV9vY3RldHMgfj0gZXhwZWN0ZWRfbGVuKSB0aGVuCiAgICAgICAgZXJyb3IoIldyb25nIGxlbmd0aCBvZiBzaWduYXR1cmVfb2N0ZXRzIiwgNCkKICAgIGVuZAogICAgbG9jYWwgQV9vY3RldHMgPSBzaWduYXR1cmVfb2N0ZXRzOnN1YigxLCBPQ1RFVF9QT0lOVF9MRU5HVEgpCiAgICBsb2NhbCBBQSA9IEVDUC5mcm9tX3pjYXNoKEFfb2N0ZXRzOm9jdGV0KCkpCiAgICBpZiAoQUEgPT0gSURFTlRJVFlfRzEpIHRoZW4KICAgICAgICBlcnJvcigiUG9pbnQgaXMgaWRlbnRpdHkiLCA0KQogICAgZW5kCgogICAgbG9jYWwgaW5kZXggPSBPQ1RFVF9QT0lOVF9MRU5HVEggKyAxCiAgICBsb2NhbCBlbmRfaW5kZXggPSBpbmRleCArIE9DVEVUX1NDQUxBUl9MRU5HVEggLSAxCiAgICAtLSBvczFpcCB0cmFuc2Zvcm0gYSBzdHJpbmcgaW50byBhIEJJRwogICAgbG9jYWwgcyA9IG9zMmlwKHNpZ25hdHVyZV9vY3RldHM6c3ViKGluZGV4LCBlbmRfaW5kZXgpKQogICAgaWYgKHMgPT0gQklHLm5ldygwKSkgb3IgKHMgPj0gUFJJTUVfUikgdGhlbgogICAgICAgIGVycm9yKCJXcm9uZyBzIGluIGRlc2VyaWFsaXphdGlvbiIsIDQpCiAgICBlbmQKCiAgICByZXR1cm4ge0FBLCBzfQplbmQKCi0tZHJhZnQtaXJ0Zi1jZnJnLWJicy1zaWduYXR1cmVzIFNlY3Rpb24gNC43LjYKCi0tLUVuc3VyZSB0aGF0IHRoZSBwdWJsaWMga2V5IGlzIHZhbGlkLCBpbiB0aGUgcmlnaHQgc3ViZ3JvdXAsIGFuZCBub3QgdGhlIGlkZW50aXR5IGVsZW1lbnQuCi0tSXQgY29udmVydHMgdGhlIHB1YmxpYyBrZXkgKHBrKSBpbnRvIGEgcG9pbnQgVyBvbiB0aGUgZWxsaXB0aWMgY3VydmUgaW4gRzIgYW5kIGNoZWNrcyBpZiBXIGlzIGluIHRoZSBjb3JyZWN0IHN1Ymdyb3VwLgotLQotLUBmdW5jdGlvbiBCQlMub2N0ZXRzX3RvX3B1Yl9rZXkKLS1AcGFyYW0gcGsgdGhlIHB1YmxpYyBrZXkKLS1AcmV0dXJuIHRoZSBwb2ludCBXIAotLUB1c2FnZSAKLS1iYnMgPSByZXF1aXJlJ2NyeXB0b19iYnMnCi0tKipkZWZpbmUgYSBjaXBoZXJzdWl0ZSBhbmQgYSBwdWJsaWMga2V5Ci0tY2lwaGVyc3VpdGUgPSBiYnMuY2lwaGVyc3VpdGUoJ3NoYTI1NicpIAotLVBVQkxJQ19LRVkgPSAiYTgyMGYyMzBmNmFlMzg1MDNiODZjNzBkYzUwYjYxYzU4YTc3ZTQ1YzM5YWIyNWMwNjUyYmJhYThmYTEzNmYyODUxYmQ0NzgxYzlkY2RlMzlmYzlkMWQ1MmM5ZTYwMjY4MDYxZTdkNzYzMjE3MWQKLS0gICAgICAgICAgICAgIDkxYWE4ZDQ2MGFjZWUwZTk2ZjFlN2M0Y2ZiMTJkM2ZmOWFiNWQ1ZGM5MWMyNzdkYjc1Yzg0NWQ2NDllZjNjNGY2M2FlYmMzNjRjZDU1ZGVkMGMiCi0tKipjYWxjdWxhdGUgdGhlIHBvaW50IFcKLS1XID0gYmJzLm9jdGV0c190b19wdWJfa2V5KE8uZnJvbV9oZXgoUFVCTElDX0tFWSkpCgpmdW5jdGlvbiBiYnMub2N0ZXRzX3RvX3B1Yl9rZXkocGspCiAgICBsb2NhbCBXID0gRUNQMi5mcm9tX3pjYXNoKHBrKQoKICAgIC0tIEVDUDIuaW5maW5pdHkgPT0gSWRlbnRpdHlfRzIKICAgIGlmIChXID09IEVDUDIuaW5maW5pdHkoKSkgdGhlbgogICAgICAgIGVycm9yKCJXIGlzIGlkZW50aXR5IEcyIiwgNCkKICAgIGVuZAogICAgaWYgKFcgKiBQUklNRV9SIH49IEVDUDIuaW5maW5pdHkoKSkgdGhlbgogICAgICAgIGVycm9yKCJXIGlzIG5vdCBpbiBzdWJncm91cCIsIDQpCiAgICBlbmQKCiAgICByZXR1cm4gVwplbmQKCgotLVtbCkRFU0NSSVBUSU9OOiBHaXZlbiB0aGUgc2lnbmF0dXJlLCB0aGUgc2V0IG9mIG1lc3NhZ2VzIGFzc29jaWF0ZWQgYW5kIHRoZSBwdWJsaWMga2V5LCB0aGUgZm9sbG93aW5nIGZ1bmN0aW9uIHZlcmlmeSBpZiB0aGUgc2lnbmF0dXJlIGlzIHZhbGlkCklOUFVUOiBjaXBoZXJzdWl0ZSAoYSB0YWJsZSksIHBrIChhcyB6ZW5yb29tLm9jdGV0KSwgc2lnbmF0dXJlIChhcyB6ZW5yb29tLm9jdGV0KSwgZ2VuZXJhdG9ycyAoYXJyYXkgb2YgcG9pbnRzIG9uIHRoZSBzdWJncm91cCBvZiBFQzEgYXMKemVucm9vbS5lY3ApLCBtZXNzYWdlcyAoYXJyYXkgb2Ygc2NhbGFycyBzdG9yZWQgYXMgemVucm9vbS5vY3RldCksIGhlYWRlciAoYXMgemVucm9vbS5vY3RldCkuCk9VVFBVVDogYSBib29sZWFuLCB0cnVlIG9yIGZhbHNlIApdXQpsb2NhbCBmdW5jdGlvbiBjb3JlX3ZlcmlmeShjaXBoZXJzdWl0ZSwgcGssIHNpZ25hdHVyZSwgZ2VuZXJhdG9ycywgbWVzc2FnZXMsIGhlYWRlcikKCiAgICAtLSBEZWZhdWx0IHZhbHVlcwogICAgaGVhZGVyID0gaGVhZGVyIG9yIE8uZW1wdHkoKQoKICAgIC0tIERlc2VyaWFsaXphdGlvbgogICAgbG9jYWwgc2lnbmF0dXJlX3Jlc3VsdCA9IG9jdGV0c190b19zaWduYXR1cmUoc2lnbmF0dXJlKSAtLSB0cmFuc2Zvcm0gb2N0ZXQgaW50byBhIHRhYmxlIHtBQSwgc306IHdpdGggZW50cmllcyBpbiB6ZW5yb29tLmVjcCBhbmQgemVucm9vbS5CSUcKICAgIGxvY2FsIEFBLCBzID0gdGFibGUudW5wYWNrKHNpZ25hdHVyZV9yZXN1bHQpCiAgICBsb2NhbCBXID0gYmJzLm9jdGV0c190b19wdWJfa2V5KHBrKQogICAgbG9jYWwgTEVOID0gI21lc3NhZ2VzCiAgICBsb2NhbCBRXzEgPSB0YWJsZS51bnBhY2soZ2VuZXJhdG9ycywgMSkKICAgIGxvY2FsIEhfcG9pbnRzID0geyB0YWJsZS51bnBhY2soZ2VuZXJhdG9ycywgMiwgTEVOICsgMSkgfQogICAgLS0gUHJvY2VkdXJlCiAgICBsb2NhbCBkb21haW4gPSBjYWxjdWxhdGVfZG9tYWluKGNpcGhlcnN1aXRlLCBwaywgUV8xLCBIX3BvaW50cywgaGVhZGVyKQogICAgbG9jYWwgQkIgPSBjaXBoZXJzdWl0ZS5QMSArIChRXzEgKiBkb21haW4pCiAgICBpZiAoTEVOID4gMCkgdGhlbgogICAgICAgIGZvciBpID0gMSwgTEVOIGRvCiAgICAgICAgICAgIEJCID0gQkIgKyAoSF9wb2ludHNbaV0gKiBtZXNzYWdlc1tpXSkKICAgICAgICBlbmQKICAgIGVuZAogICAgbG9jYWwgTEhTID0gRUNQMi5hdGUoVyArIChFQ1AyLmdlbmVyYXRvcigpICogcyksIEFBKQogICAgbG9jYWwgUkhTID0gRUNQMi5hdGUoRUNQMi5nZW5lcmF0b3IoKSwgQkIpCiAgICByZXR1cm4gTEhTID09IFJIUwplbmQKCgotLVtbCkRFU0NSSVBUSU9OOiBUaGUgVmVyaWZ5IG9wZXJhdGlvbiB2YWxpZGF0ZXMgYSBCQlMgc2lnbmF0dXJlLCBnaXZlbiBhIHB1YmxpYyBrZXkgKFBLKSwgYSBoZWFkZXIgYW5kIGEgc2V0IG9mIG1lc3NhZ2VzLgpJTlBVVDogY2lwaGVyc3VpdGUgKGEgdGFibGUpLCBwayAoYXMgemVucm9vbS5vY3RldCksIHNpZ25hdHVyZSAoYXMgemVucm9vbS5vY3RldCksIG1lc3NhZ2VzIChhcnJheSBvZiBvY3RldCBzdHJpbmdzIGFzIHplbnJvb20ub2N0ZXQpLCBoZWFkZXIgKGFzIHplbnJvb20ub2N0ZXQpLgpPVVRQVVQ6IGEgYm9vbGVhbiwgdHJ1ZSBvciBmYWxzZSAKXV0KCi0tLVZhbGlkYXRlIGEgQkJTIHNpZ25hdHVyZS4gVG8gZG8gdGhpcyBpdCB1c2VzIHRoZSA8Y29kZT5jb3JlX3ZlcmlmeTwvY29kZT4gZnVuY3Rpb24sIHdoaWNoIHZlcmlmeSBpZiB0aGUgc2lnbmF0dXJlIGlzIHZhbGlkLgotLQotLUBmdW5jdGlvbiBCQlMudmVyaWZ5Ci0tQHBhcmFtIGNpcGhlcnN1aXRlCi0tQHBhcmFtIHBrIHRoZSBwdWJsaWMga2V5IGFzIGFuIG9jdGV0Ci0tQHBhcmFtIHNpZ25hdHVyZSBhcyBhbiBvY3RldCAKLS1AcGFyYW0gaGVhZGVyCi0tQHBhcmFtIG1lc3NhZ2VzIGFuIGFycmF5IG9mIG9jdGV0IHN0cmluZ3MgYXMgb2N0ZXQKLS1AcmV0dXJuIGEgYm9vbGVhbiwgdHJ1ZSBpZiB0aGUgc2lnbmF0dXJlIGlzIHZhbGlkLCBmYWxzZSBvdGhlcndpc2UKLS1AdXNhZ2UgCi0tKipmcm9tIHRoZSB1c2FnZSBpbiB0aGUgc2lnbiBmdW5jdGlvbiwgY2hlY2sgaWYgdGhlIHNpZ25hdHVyZSBpcyB2YWxpZAotLWlmIGJicy52ZXJpZnkoY2lwaGVyc3VpdGUsIE8uZnJvbV9oZXgoUFVCTElDX0tFWSksIG91dHB1dF9zaWduYXR1cmUsIE8uZnJvbV9oZXgoSEVBREVSKSwgU0lOR0xFX01TR19BUlJBWSkgdGhlbiBwcmludCAoInZhbGlkIHNpZ25hdHVyZSIpCi0tZWxzZSBwcmludCgiaW52YWxpZCBzaWduYXR1cmUiKQotLWVuZAotLSoqcHJpbnQ6dmFsaWQgc2lnbmF0dXJlCgpmdW5jdGlvbiBiYnMudmVyaWZ5KGNpcGhlcnN1aXRlLCBwayAsc2lnbmF0dXJlLCBoZWFkZXIsIG1lc3NhZ2VzX29jdGV0cykKICAgIG1lc3NhZ2VzX29jdGV0cyA9IG1lc3NhZ2VzX29jdGV0cyBvciBPLmVtcHR5e30KICAgIGxvY2FsIG1lc3NhZ2VzID0gYmJzLm1lc3NhZ2VzX3RvX3NjYWxhcnMoY2lwaGVyc3VpdGUsbWVzc2FnZXNfb2N0ZXRzKQogICAgbG9jYWwgZ2VuZXJhdG9ycyA9IGJicy5jcmVhdGVfZ2VuZXJhdG9ycyhjaXBoZXJzdWl0ZSwgI21lc3NhZ2VzICsxKQogICAgcmV0dXJuIGNvcmVfdmVyaWZ5KGNpcGhlcnN1aXRlLCBwayxzaWduYXR1cmUsIGdlbmVyYXRvcnMsIG1lc3NhZ2VzLCBoZWFkZXIpCmVuZAoKCgotLVtbCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBDcmVkZW50aWFsczpQcm9vZkdlbixQcm9vZlZlcmlmeSAtLS0tLS0tCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KXV0KCi0tIGRyYWZ0LWlydGYtY2ZyZy1iYnMtc2lnbmF0dXJlcy1sYXRlc3QgU2VjdGlvbiA0LjEKLS0gSXQgcmV0dXJucyBjb3VudCByYW5kb20gc2NhbGFyLgoKLS0tR2VuZXJhdGUgYSB0YWJsZSBvZiByYW5kb20gc2NhbGFycyB0aGF0IGFyZSB1bmlmb3JtbHkgZGlzdHJpYnV0ZWQgbW9kdWxvIHRoZSBFQ1Agb3JkZXIuCi0tCi0tQGZ1bmN0aW9uIEJCUy5jYWxjdWxhdGVfcmFuZG9tX3NjYWxhcnMKLS1AcGFyYW0gY291bnQgbnVtYmVyIG9mIHJhbmRvbSBzY2FsYXJzIHRvIGdlbmVyYXRlCi0tQHJldHVybiBhIHRhYmxlIG9mIHVuaWZvcm1seSBkaXN0cmlidXRlZCByYW5kb20gc2NhbGFycyBtb2R1bG8gdGhlIEVDUCBvcmRlcgotLUB1c2FnZSAKLS0qKmdlbmVyYXRlIGEgdGFibGUgb2YgNSByYW5kb20gc2NhbGFycwotLVQgPSBiYnMuY2FsY3VsYXRlX3JhbmRvbV9zY2FsYXJzKDUpCgpmdW5jdGlvbiBiYnMuY2FsY3VsYXRlX3JhbmRvbV9zY2FsYXJzKGNvdW50KQogICAgbG9jYWwgc2NhbGFyX2FycmF5ID0ge30KICAgIC0tW1sgVGhpcyBkb2VzIG5vdCBzZWVtIHVuaWZvcm1seSByYW5kb206CiAgICBmb3IgaSA9IDEsIGNvdW50IGRvCiAgICAgICAgc2NhbGFyX2FycmF5W2ldID0gQklHLm1vZChPLnJhbmRvbSg0OCksIFBSSU1FX1IpCiAgICBlbmQKICAgIC0tXV0KICAgIC0tIFdlIGxlYXZlIGl0IGxpa2UgdGhpcyBiZWNhdXNlIGl0IHNob3VsZCB5aWVsZCBhIG1vcmUgdW5pZm9ybSBkaXN0cmlidXRpb24uCiAgICBmb3IgaT0xLGNvdW50IGRvCiAgICAgICAgbG9jYWwgc2NhbGFyID0gb3MyaXAoQklHLnJhbmRvbSgpKQogICAgICAgIHdoaWxlIHNjYWxhciA+IFBSSU1FX1IgZG8KICAgICAgICAgICAgc2NhbGFyID0gb3MyaXAoQklHLnJhbmRvbSgpKQogICAgICAgIGVuZAogICAgICAgIHRhYmxlLmluc2VydChzY2FsYXJfYXJyYXksIHNjYWxhcikKICAgIGVuZAogICAgcmV0dXJuIHNjYWxhcl9hcnJheQplbmQKCi0tW1sKREVTQ1JJUFRJT046IFRoaXMgZnVuY3Rpb24gY2FsY3VsYXRlcyB0aGUgY2hhbGxhbmdlIHNjYWxhciB2YWx1ZSBuZWVkZWQgZm9yIGJvdGggdGhlIENvcmVQcm9vZkdlbiBhbmQgdGhlIENvcmVQcm9vZlZlcmlmeQpJTlBVVDogY2lwaGVyc3VpdGUgKGEgdGFibGUpLCBpbml0X3JlcyAoYSB2ZWN0b3IgY29uc2lzdGluZyBvZiBmaXZlIHBvaW50cyBvZiBHMSBhbmQgYSBzY2FsYXIgdmFsdWUgaW4gdGhhdCBvcmRlciksIGRpc2Nsb3NlZF9tZXNzYWdlcyAodmVjdG9yIG9mIHNjYWxhciB2YWx1ZXMpLCAKZGlzY2xvc2VkX2luZGV4ZXMgKHZlY3RvciBvZiBub24tbmVnYXRpdmUgaW50ZWdlcnMgaW4gYXNjZW5kaW5nIG9yZGVyKSwgcGgoIGFuIG9jdGV0IHN0cmluZykKCk9VVFBVVDogY2hhbGxlbmdlLCBhIHNjYWxhcgpdXQoKbG9jYWwgZnVuY3Rpb24gcHJvb2ZfY2hhbGxlbmdlX2NhbGN1bGF0ZShjaXBoZXJzdWl0ZSwgaW5pdF9yZXMsIGRpc2Nsb3NlZF9tZXNzYWdlcywgZGlzY2xvc2VkX2luZGV4ZXMsIHBoKQogICAgCiAgICBwaCA9IHBoIG9yIE8uZW1wdHkoKQoKICAgIGxvY2FsIFJfbGVuID0gI2Rpc2Nsb3NlZF9pbmRleGVzCiAgICAtLSBXZSBhdm9pZCB0aGUgY2hlY2sgUl9sZW4gPCAyXjY0CiAgICBpZiBSX2xlbiB+PSAjZGlzY2xvc2VkX21lc3NhZ2VzIHRoZW4KICAgICAgICBlcnJvcigiZGlzY2xvc2VkX2luZGV4ZXMgbGVuZ3RoIGlzIG5vdCBlcXVhbCB0byBkaXNjbG9zZWRfbWUgbGVuZ3RoIiwgNCkKICAgIGVuZAogICAgLS0gV2UgYXZvaWQgdGhlIGNoZWNrICMocGgpIDwgMl42NAogICAgbG9jYWwgY19hcnJheSA9IHt9CgogICAgaWYgUl9sZW4gfj0gMCB0aGVuCiAgICAgICAgY19hcnJheSA9IHtSX2xlbn0gICAgICAgCiAgICAgICAgZm9yIGkgPSAxLCBSX2xlbiBkbwogICAgICAgICAgICB0YWJsZS5pbnNlcnQoY19hcnJheSwgZGlzY2xvc2VkX2luZGV4ZXNbaV0tMSkKICAgICAgICAgICAgdGFibGUuaW5zZXJ0KGNfYXJyYXksIGRpc2Nsb3NlZF9tZXNzYWdlc1tpXSkKICAgICAgICBlbmQKICAgICAgICBmb3IgaSA9IDEsIDYgZG8KICAgICAgICAgICB0YWJsZS5pbnNlcnQoY19hcnJheSxpbml0X3Jlc1tpXSkKICAgICAgICBlbmQKICAgIGVsc2UKICAgICAgICBjX2FycmF5ID0ge1JfbGVuLCB0YWJsZS51bnBhY2soaW5pdF9yZXMsMSw2KX0KICAgIGVuZAogICAgbG9jYWwgY19vY3RzID0gc2VyaWFsaXphdGlvbihjX2FycmF5KSAuLiBpMm9zcCgjcGgsIDgpIC4uIHBoCiAgICAKCiAgICBsb2NhbCBjaGFsbGVuZ2UgPSBoYXNoX3RvX3NjYWxhcihjaXBoZXJzdWl0ZSwgY19vY3RzKQoKICAgIHJldHVybiBjaGFsbGVuZ2UKZW5kCgotLVtbCklOUFVUOiBwayAoemVucm9vbS5vY3RldCksIHNpZ25hdHVyZV9yZXN1bHQgKGEgcGFpciB6ZW5yb29tLmVjcCwgemVucm9vbS5CSUcpLCBnZW5lcmF0b3JzICh2ZWN0b3Igb2YgcG9pbnRzIG9mIEcxIGluIHplbnJvb20uZWNwKSwKcmFuZG9tX3NjYWxhcnMgKHZlY3RvciB6ZW5yb29tLkJJRykgaGVhZGVyICh6ZW5yb29tLm9jdGV0KSwgbWVzc2FnZXMgKHZlY3RvciBvZiBzY2FsYXJzIGluIHplbnJvb20uQklHKSwgdW5kaXNjbG9zZWRfaW5kZXhlcyAodmVjdG9yIG9mIG51bWJlcnMpLApjaXBoZXJzdWl0ZSAodGFibGUpLgpPVVRQVVQ6IGluaXRfcmVzIGEgdGFibGUgd2l0aCA1IHBvaW50cyBvbiBHMSAoemVucm9vbS5lY3ApIGFuZCBhIHNjYWxhciAoemVucm9vbS5CSUcpCl1dCgpsb2NhbCBmdW5jdGlvbiBwcm9vZl9pbml0KGNpcGhlcnN1aXRlLCBwaywgc2lnbmF0dXJlX3Jlc3VsdCwgZ2VuZXJhdG9ycywgcmFuZG9tX3NjYWxhcnMsIGhlYWRlciwgbWVzc2FnZXMsIHVuZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBsb2NhbCBBQSwgZSA9IHRhYmxlLnVucGFjayhzaWduYXR1cmVfcmVzdWx0KQogICAgbG9jYWwgTCA9IHRhYmxlX3NpemUobWVzc2FnZXMpCiAgICBsb2NhbCBVID0gdGFibGVfc2l6ZSh1bmRpc2Nsb3NlZF9pbmRleGVzKQogICAgbG9jYWwgaiA9IHt0YWJsZS51bnBhY2sodW5kaXNjbG9zZWRfaW5kZXhlcyl9CiAgICBsb2NhbCByMSwgcjIsIGV0LCByMXQsIHIzdCA9IHRhYmxlLnVucGFjayhyYW5kb21fc2NhbGFycywxLDUpCiAgICBsb2NhbCBtanQgPSB7dGFibGUudW5wYWNrKHJhbmRvbV9zY2FsYXJzLCA2LCA1ICsgVSl9CgogICAgaWYgdGFibGVfc2l6ZShnZW5lcmF0b3JzKSB+PSBMKzEgdGhlbiBlcnJvcignV3JvbmcgZ2VuZXJhdG9ycyBsZW5ndGgnKSBlbmQKICAgIGxvY2FsIFFfMSA9IHRhYmxlLnVucGFjayhnZW5lcmF0b3JzLCAxKQogICAgbG9jYWwgTXNnR2VuZXJhdG9ycyA9IHt0YWJsZS51bnBhY2soZ2VuZXJhdG9ycywgMiwgMSArIEwpfQogICAgbG9jYWwgSF9qID0ge30KICAgIGZvciBpID0gMSwgVSBkbwogICAgICAgIEhfaltpXSA9IE1zZ0dlbmVyYXRvcnNbaltpXV0KICAgIGVuZAogICAgCiAgICBpZiBVID4gTCB0aGVuIGVycm9yKCdudW1iZXIgb2YgdW5kaXNjbG9zZWQgaW5kZXhlcyBpcyBiaWdnZXIgdGhhbiB0aGUgbnVtYmVyIG9mIG1lc3NhZ2VzJywgNCkgZW5kCiAgICBmb3IgaSA9IDEsIFUgZG8KICAgICAgICBpZiB1bmRpc2Nsb3NlZF9pbmRleGVzW2ldIDw9IDAgb3IgdW5kaXNjbG9zZWRfaW5kZXhlc1tpXSA+IEwgdGhlbiBlcnJvcignV3JvbmcgdW5kaXNjbG9zZWQgaW5kZXhlcycsIDQpIGVuZAogICAgZW5kCiAgICAKICAgIGxvY2FsIGRvbWFpbiA9IGNhbGN1bGF0ZV9kb21haW4oY2lwaGVyc3VpdGUsIHBrLCBRXzEsIE1zZ0dlbmVyYXRvcnMsIGhlYWRlcikKICAgIAogICAgbG9jYWwgQkIgPSBjaXBoZXJzdWl0ZS5QMSArIChRXzEgKiBkb21haW4pCiAgICBmb3IgaSA9IDEsIEwgZG8KICAgICAgICBCQiA9IEJCICsgKE1zZ0dlbmVyYXRvcnNbaV0gKiBtZXNzYWdlc1tpXSkKICAgIGVuZAogICAgCiAgICBsb2NhbCBEID0gQkIgKiByMgogICAgbG9jYWwgQWJhciA9IEFBICogKHIxICogcjIpCiAgICBsb2NhbCBCYmFyID0gKEQgKiByMSkgLSAoQWJhciAqIGUpCiAgICBsb2NhbCBUMSA9IChBYmFyICogZXQpICsgKEQgKiByMXQpCiAgICBsb2NhbCBUMiA9IChEICogcjN0KQogICAgZm9yIGkgPSAxLCBVIGRvCiAgICAgICAgVDIgPSBUMiArIChIX2pbaV0gKiBtanRbaV0pCiAgICBlbmQKICAgIGxvY2FsIGluaXRfcmVzID0ge0FiYXIsIEJiYXIsIEQsIFQxLCBUMiwgZG9tYWlufQogICAgcmV0dXJuIGluaXRfcmVzCgplbmQKCi0tW1sKSU5QVVQ6IGluaXRfcmVzIChvdXRwdXQgb2YgUHJvb2ZJbml0KSwgY2hhbGxlbmdlIChvdXRwdXQgb2YgUHJvb2ZDaGFsbGVuZ2VDYWxjdWxhdGUpLCBlX3ZhbHVlIChzY2FsYXIgemVucm9vbS5CSUcpLCByYW5kb21fc2NhbGFycyAodmVjdG9yIG9mCnNjYWxhcnMsIHplbnJvb20uQklHKSwgdW5kaXNjbG9zZWRfbWVzc2FnZXMgKHZlY3RvciBvZiBzY2FsYXJzLCB6ZW5yb29tLkJJRykKT1VUUFVUOgpdXQoKbG9jYWwgZnVuY3Rpb24gcHJvb2ZfZmluYWxpemUoaW5pdF9yZXMsIGNoYWxsZW5nZSwgZV92YWx1ZSwgcmFuZG9tX3NjYWxhcnMsIHVuZGlzY2xvc2VkX21lc3NhZ2VzKQogICAgbG9jYWwgVSA9IHRhYmxlX3NpemUodW5kaXNjbG9zZWRfbWVzc2FnZXMpCgogICAgaWYgdGFibGVfc2l6ZShyYW5kb21fc2NhbGFycykgfj0gVSArIDUgdGhlbiBlcnJvcignV3JvbmcgbnVtYmVyIG9mIHJhbmRvbSBzY2FsYXJzJywgNCkgZW5kCiAgICAKICAgIGxvY2FsIHIxLCByMiwgZXQsIHIxdCwgcjN0ID0gdGFibGUudW5wYWNrKHJhbmRvbV9zY2FsYXJzLDEsNSkKCiAgICBsb2NhbCBtanQgPSB7dGFibGUudW5wYWNrKHJhbmRvbV9zY2FsYXJzLCA2LCA1ICsgVSl9CiAgICAKCiAgICBsb2NhbCBBYmFyLCBCYmFyLCBEID0gdGFibGUudW5wYWNrKGluaXRfcmVzKQogICAgbG9jYWwgcjMgPSBCSUcubW9kZGl2KEJJRy5uZXcoMSksIHIyLCBQUklNRV9SKQogICAgbG9jYWwgZXMgPSBCSUcubW9kKGV0ICsgQklHLm1vZG11bChlX3ZhbHVlLCBjaGFsbGVuZ2UsIFBSSU1FX1IpLFBSSU1FX1IpCiAgICBsb2NhbCByMXMgPSBCSUcubW9kKHIxdCAtIEJJRy5tb2RtdWwocjEsIGNoYWxsZW5nZSxQUklNRV9SKSxQUklNRV9SKQogICAgbG9jYWwgcjNzID0gQklHLm1vZChyM3QgLSBCSUcubW9kbXVsKHIzLGNoYWxsZW5nZSxQUklNRV9SKSxQUklNRV9SKQogICAgbG9jYWwgbXMgPSB7fQogICAgZm9yIGogPSAxLCBVIGRvCiAgICAgICAgbXNbal0gPSBCSUcubW9kKG1qdFtqXSArICh1bmRpc2Nsb3NlZF9tZXNzYWdlc1tqXSAqIGNoYWxsZW5nZSksIFBSSU1FX1IpCiAgICBlbmQKICAgIGxvY2FsIHByb29mID0ge0FiYXIsIEJiYXIsIEQsIGVzLCByMXMsIHIzc30gLS1tcywgY2hhbGxlbmdlCiAgICBmb3IgaSA9IDEsIFUgZG8KICAgICAgICBwcm9vZls2ICsgaV0gPSBtc1tpXQogICAgZW5kCiAgICBwcm9vZls2ICsgVSArIDFdID0gY2hhbGxlbmdlCiAgICByZXR1cm4gc2VyaWFsaXphdGlvbihwcm9vZikKZW5kCgotLVtbCklOUFVUOiBjaXBoZXJzdWl0ZSAodGFibGUpLCBwayAoemVucm9vbS5vY3RldCksIHNpZ25hdHVyZSAoemVucm9vbS5vY3RldCksIGdlbmVyYXRvcnMgKHZlY3RvciBvZiB6ZW5yb29tLmVjcCBvbiBHMSksIGhlYWRlciAoemVucm9vbS5vY3RldCksCnBoICh6ZW5yb29tLm9jdGV0KSwgbWVzc2FnZXMgKHZlY3RvciBvZiBzY2FsYXJzIGluIHplbnJvb20uQklHKSwgZGlzY2xvc2VkX2luZGV4ZXMgKHZlY3RvciBvZiBudW1iZXJzKQpPVVRQVVQ6IHByb29mIChvdXRwdXQgb2YgUHJvb2ZGaW5hbGl6ZSkKXV0KCmxvY2FsIGZ1bmN0aW9uIGNvcmVfcHJvb2ZfZ2VuKGNpcGhlcnN1aXRlLCBwaywgc2lnbmF0dXJlLCBnZW5lcmF0b3JzLCBoZWFkZXIsIHBoLCBtZXNzYWdlcywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBsb2NhbCBMID0gdGFibGVfc2l6ZShtZXNzYWdlcykKICAgIGxvY2FsIFIgPSB0YWJsZV9zaXplKGRpc2Nsb3NlZF9pbmRleGVzKQogICAgaWYgUiA+IEwgdGhlbiBlcnJvcignbnVtYmVyIG9mIGRpc2Nsb3NlZCBpbmRleGVzIGlzIGJpZ2dlciB0aGFuIHRoZSBudW1iZXIgb2YgbWVzc2FnZXMnLCAzKSBlbmQKICAgIGxvY2FsIFUgPGNvbnN0PiA9IEwgLSBSCiAgICBsb2NhbCBzaWduYXR1cmVfcmVzdWx0ID0gb2N0ZXRzX3RvX3NpZ25hdHVyZShzaWduYXR1cmUpCiAgICBsb2NhbCBBQSwgZSA9IHRhYmxlLnVucGFjayhzaWduYXR1cmVfcmVzdWx0KQogICAgbG9jYWwgdW5kaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBsb2NhbCBkaXNjbG9zZWRfbWVzc2FnZXMgPSB7fQogICAgbG9jYWwgdW5kaXNjbG9zZWRfbWVzc2FnZXMgPSB7fQogICAgZm9yIGksIHYgaW4gaXBhaXJzKGRpc2Nsb3NlZF9pbmRleGVzKSBkbwogICAgICAgIGlmIGkgPiAxIGFuZCBkaXNjbG9zZWRfaW5kZXhlc1tpXSA9PSBkaXNjbG9zZWRfaW5kZXhlc1tpIC0gMV0gdGhlbiAtLUFycmF5cyBhcmUgYWx3YXlzIHNvcnRlZCBpbiBwcm9vZl9nZW4gKGxpbmUgNjg0KSBiZWZvcmUgYmVpbmcgcGFzc2VkIGFzIGlucHV0IHRvIGNvcmVfcHJvb2ZfZ2VuCiAgICAgICAgICAgIGVycm9yKCdkaXNjbG9zZWQgaW5kZXhlcyBjb250YWlucyBkdXBsaWNhdGVzJywgMykKICAgICAgICBlbmQKICAgICAgICB0YWJsZS5pbnNlcnQoZGlzY2xvc2VkX21lc3NhZ2VzLCBtZXNzYWdlc1t2XSkKICAgIGVuZAogICAgZm9yIGkgPSAxLCBMIGRvCiAgICAgICAgaWYgbm90IGFycmF5X2NvbnRhaW5zKGRpc2Nsb3NlZF9pbmRleGVzLCBpKSB0aGVuCiAgICAgICAgICAgIHRhYmxlLmluc2VydCh1bmRpc2Nsb3NlZF9pbmRleGVzLCBpKQogICAgICAgIGVuZAogICAgZW5kCiAgICBmb3IgXyx2IGluIGlwYWlycyh1bmRpc2Nsb3NlZF9pbmRleGVzKSBkbwogICAgICAgIHRhYmxlLmluc2VydCh1bmRpc2Nsb3NlZF9tZXNzYWdlcywgbWVzc2FnZXNbdl0pCiAgICBlbmQKCiAgICBsb2NhbCByYW5kb21fc2NhbGFycyA8Y29uc3Q+ID0gYmJzLmNhbGN1bGF0ZV9yYW5kb21fc2NhbGFycyg1ICsgVSkKCiAgICBsb2NhbCBpbml0X3JlcyA9IHByb29mX2luaXQoY2lwaGVyc3VpdGUsIHBrLCBzaWduYXR1cmVfcmVzdWx0LCBnZW5lcmF0b3JzLCByYW5kb21fc2NhbGFycywgaGVhZGVyLCBtZXNzYWdlcywgdW5kaXNjbG9zZWRfaW5kZXhlcykKICAgIAogICAgbG9jYWwgY2hhbGxlbmdlID0gIHByb29mX2NoYWxsZW5nZV9jYWxjdWxhdGUoY2lwaGVyc3VpdGUsIGluaXRfcmVzLCBkaXNjbG9zZWRfbWVzc2FnZXMsIGRpc2Nsb3NlZF9pbmRleGVzLCBwaCkKICAgIAogICAgbG9jYWwgcHJvb2YgPSBwcm9vZl9maW5hbGl6ZShpbml0X3JlcywgY2hhbGxlbmdlLCBlLCByYW5kb21fc2NhbGFycywgdW5kaXNjbG9zZWRfbWVzc2FnZXMpCgogICAgcmV0dXJuIHByb29mCmVuZAoKLS1bWwpJTlBVVDogY2lwaGVyc3VpdGUgKHRhYmxlKSwgcGsgKHplbnJvb20ub2N0ZXQpLCBzaWduYXR1cmUgKHplbnJvb20ub2N0ZXQpLCBoZWFkZXIgKHplbnJvb20ub2N0ZXQpLCBwaCAoemVucm9vbS5vY3RldCksIG1lc3NhZ2VzICh2ZWN0b3Igb2YKemVucm9vbS5vY3RldCksIGRpc2Nsb3NlZF9pbmRleGVzICh2ZWN0b3Igb2YgbnVtYmVyKQpPVVRQVVQ6IHByb29mIChvdXRwdXQgb2YgQ29yZVByb29mR2VuKQpdXQoKLS0tQWxsb3cgYSB1c2VyIHRvIHByb3ZlIGtub3dsZWRnZSBvZiBhIHZhbGlkIHNpZ25hdHVyZSB3aGlsZSBzZWxlY3RpdmVseSByZXZlYWxpbmcgc29tZSBtZXNzYWdlcyBhbmQga2VlcGluZyBvdGhlcnMgaGlkZGVuLgotLUl0IHVzZXMgb3RoZXIgZnVuY3Rpb25zIGR1cmluZyB0aGUgcHJvY2Vzcy4gSW4gcGFydGljdWxhciwgdGhlIDxjb2RlPnByb29mXF9pbml0KCk8L2NvZGU+IGZ1bmN0aW9uIGNvbnN0cnVjdHMgY29tbWl0bWVudHMgdXNpbmcgdGhlIHNpZ25hdHVyZSwgcHVibGljIGtleSwgbWVzc2FnZSBnZW5lcmF0b3JzLCBhbmQgcmFuZG9tIHNjYWxhcnMuCi0tVGhlIDxjb2RlPnByb29mXF9jaGFsbGVuZ2VcX2NhbGN1bGF0ZTwvY29kZT4gZnVuY3Rpb24gZ2VuZXJhdGVzIGEgY2hhbGxlbmdlIHZhbHVlIGZyb20gdGhlIGNvbW1pdG1lbnRzLiBUaGUgPGNvZGU+cHJvb2ZcX2ZpbmFsaXplPC9jb2RlPiBmdW5jdGlvbiAKLS1jb21wdXRlcyB0aGUgZmluYWwgcHJvb2YgdmFsdWVzIGJhc2VkIG9uIHRoZSBjaGFsbGVuZ2UgYW5kIGluaXRpYWwgY29tbWl0bWVudHMuCi0tCi0tQGZ1bmN0aW9uIEJCUy5wcm9vZl9nZW4KLS1AcGFyYW0gY2lwaGVyc3VpdGUKLS1AcGFyYW0gcGsgdGhlIHB1YmxpYyBrZXkKLS1AcGFyYW0gc2lnbmF0dXJlCi0tQHBhcmFtIGhlYWRlcgotLUBwYXJhbSBwaCB0aGUgcHJlc2VudGF0aW9uIGhlYWRlcgotLUBwYXJhbSBtZXNzYWdlcyBhbiBhcnJheSBvZiBtZXNzYWdlcwotLUBwYXJhbSBpbmRleGVzIGFuIGFycmF5IG9mIGluZGV4ZXMgb2YgbWVzc2FnZXMgdGhlIHByb3ZlciB3YW50cyB0byByZXZlYWwKLS1AcmV0dXJuIGEgemVyby1rbm93bGVkZ2UgcHJvb2YgdGhhdCBjYW4gYmUgdmVyaWZpZWQgd2l0aG91dCByZXZlYWxpbmcgdGhlIGVudGlyZSBzaWduYXR1cmUuCi0tQHVzYWdlIAotLWJicyA9IHJlcXVpcmUnY3J5cHRvX2JicycKLS0qKmRlZmluZSBjaXBoZXJzdWl0ZSwgc2ssIHBrLCBoZWFkZXIsIHNpbmdsZSBtZXNzYWdlIGFycmF5LCBwcmVzZW50YXRpb24gaGVhZGVyIGFuZCBjYWxjdWxhdGUgYSB2YWxpZCBzaWduYXR1cmUKLS1jaXBoZXJzdWl0ZSA9IGJicy5jaXBoZXJzdWl0ZSgnc2hhMjU2JykgCi0tU0VDUkVUX0tFWSA9ICI2MGU1NTExMGY3Njg4M2ExM2QwMzBiMmY2YmQxMTg4MzQyMmQ1YWJkZTcxNzU2OWZjMDczMWY1MTIzNzE2OWZjIgotLVBVQkxJQ19LRVkgPSAiYTgyMGYyMzBmNmFlMzg1MDNiODZjNzBkYzUwYjYxYzU4YTc3ZTQ1YzM5YWIyNWMwNjUyYmJhYThmYTEzNmYyODUxYmQ0NzgxYzlkY2RlMzlmYzlkMWQ1MmM5ZTYwMjY4MDYxZTdkNwotLSAgICAgICAgICAgICAgNjMyMTcxZDkxYWE4ZDQ2MGFjZWUwZTk2ZjFlN2M0Y2ZiMTJkM2ZmOWFiNWQ1ZGM5MWMyNzdkYjc1Yzg0NWQ2NDllZjNjNGY2M2FlYmMzNjRjZDU1ZGVkMGMiCi0tSEVBREVSID0gIjExMjIzMzQ0NTU2Njc3ODg5OTAwYWFiYmNjZGRlZWZmIgotLVNJTkdMRV9NU0dfQVJSQVkgPSB7IE8uZnJvbV9oZXgoIjk4NzJhZDA4OWU0NTJjN2I2ZTI4M2RmYWMyYTgwZDU4ZThkMGZmNzFjYzRkNWUzMTBhMWRlYmRkYTRhNDVmMDIiKSB9Ci0tUFJFU0VOVEFUSU9OX0hFQURFUiA9IE8uZnJvbV9oZXgoImJlZDIzMWQ4ODA2NzVlZDEwMWVhZDMwNDUxMmUwNDNhZGU5OTU4ZGQwMjQxZWE3MGI0YjM5NTdmYmE5NDE1MDEiKQotLW91dHB1dF9zaWduYXR1cmUgPSBiYnMuc2lnbihjaXBoZXJzdWl0ZSwgQklHLm5ldyhPLmZyb21faGV4KFNFQ1JFVF9LRVkpKSwgTy5mcm9tX2hleChQVUJMSUNfS0VZKSwgTy5mcm9tX2hleChIRUFERVIpLCBTSU5HTEVfTVNHX0FSUkFZKQotLSoqcmV0dXJuIHRoZSBwcm9vZiBsaWtlIGFuIG9jdGV0Ci0tcGdfb3V0cHV0ID0gYmJzLnByb29mX2dlbihjaXBoZXJzdWl0ZSwgTy5mcm9tX2hleChQVUJMSUNfS0VZKSwgb3V0cHV0X3NpZ25hdHVyZSwgTy5mcm9tX2hleChIRUFERVIpLCBQUkVTRU5UQVRJT05fSEVBREVSLCBTSU5HTEVfTVNHX0FSUkFZLCB7MX0pCgpmdW5jdGlvbiBiYnMucHJvb2ZfZ2VuKGNpcGhlcnN1aXRlLCBwaywgc2lnbmF0dXJlLCBoZWFkZXIsIHBoLCBtZXNzYWdlcywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBoZWFkZXIgPSBoZWFkZXIgb3IgTy5lbXB0eSgpCiAgICBwaCA9IHBoIG9yIE8uZW1wdHkoKQogICAgdGFibGUuc29ydChkaXNjbG9zZWRfaW5kZXhlcykgLS0gbWFrZSBzdXJlIGluZGV4ZXMgYXJlIHNvcnRlZAogICAgaWYgZGlzY2xvc2VkX2luZGV4ZXNbMV0gPD0gMCB0aGVuCiAgICAgICAgZXJyb3IoJ0Rpc2Nsb3NlZCBpbmRleGVzIGNvbnRhaW5zIGFuIGludGVnZXIgbGVzcyB0aGFuIG9yIGVxdWFsIHRvIDAnLCAyKQogICAgZW5kCiAgICBpZiBkaXNjbG9zZWRfaW5kZXhlc1sjZGlzY2xvc2VkX2luZGV4ZXNdID4gI21lc3NhZ2VzIHRoZW4KICAgICAgICBlcnJvcignRGlzY2xvc2VkIGluZGV4IGNvbnRhaW5zIGFuIGludGVnZXIgd2hpY2ggZXhjZWVkcyB0aGUgdG90YWwgIG51bWJlciBvZiBtZXNzYWdlcycsIDIpCiAgICBlbmQKICAgIGxvY2FsIG1lc3NhZ2VzID0gYmJzLm1lc3NhZ2VzX3RvX3NjYWxhcnMoY2lwaGVyc3VpdGUsbWVzc2FnZXMpCiAgICBsb2NhbCBnZW5lcmF0b3JzID0gYmJzLmNyZWF0ZV9nZW5lcmF0b3JzKGNpcGhlcnN1aXRlLCB0YWJsZV9zaXplKG1lc3NhZ2VzKSArIDEpCiAgICBsb2NhbCBwcm9vZiA9IGNvcmVfcHJvb2ZfZ2VuKGNpcGhlcnN1aXRlLCBwaywgc2lnbmF0dXJlLCBnZW5lcmF0b3JzLCBoZWFkZXIsIHBoLCBtZXNzYWdlcywgZGlzY2xvc2VkX2luZGV4ZXMpCgogICAgcmV0dXJuIHByb29mCmVuZAoKLS1bWwpERVNDUklQVElPTjogRGVjb2RlIGFuIG9jdGV0IHN0cmluZyByZXByZXNlbnRpbmcgdGhlIHByb29mCklOUFVUOiBwcm9vZl9vY3RldHMgKGFuIG9jdGV0IHN0cmluZykKT1VUUFVUOiBwcm9vZiAoIGFuIGFycmF5IG9mIDMgcG9pbnRzIG9mIEcxIGFuZCA0ICsgVSBzY2FsYXJzKQpdXQpsb2NhbCBmdW5jdGlvbiBvY3RldHNfdG9fcHJvb2YocHJvb2Zfb2N0ZXRzKQogICAgbG9jYWwgcHJvb2ZfbGVuX2Zsb29yID0gMypPQ1RFVF9QT0lOVF9MRU5HVEggKyA0Kk9DVEVUX1NDQUxBUl9MRU5HVEgKICAgIGlmICNwcm9vZl9vY3RldHMgPCBwcm9vZl9sZW5fZmxvb3IgdGhlbgogICAgICAgIGVycm9yKCJwcm9vZl9vY3RldHMgaXMgdG9vIHNob3J0IiwgNCkKICAgIGVuZAogICAgbG9jYWwgaW5kZXggPSAxCiAgICBsb2NhbCByZXR1cm5fYXJyYXkgPSB7fQogICAgZm9yIGkgPSAxLCAzIGRvCiAgICAgICAgbG9jYWwgZW5kX2luZGV4ID0gaW5kZXggKyBPQ1RFVF9QT0lOVF9MRU5HVEggLSAxCiAgICAgICAgcmV0dXJuX2FycmF5W2ldID0gRUNQLmZyb21femNhc2gocHJvb2Zfb2N0ZXRzOnN1YihpbmRleCwgZW5kX2luZGV4KSkKICAgICAgICBpZiByZXR1cm5fYXJyYXlbaV0gPT0gSURFTlRJVFlfRzEgdGhlbgogICAgICAgICAgICBlcnJvcigiSW52YWxpZCBwb2ludCIsIDQpCiAgICAgICAgZW5kCiAgICAgICAgaW5kZXggPSBpbmRleCArIE9DVEVUX1BPSU5UX0xFTkdUSAogICAgZW5kCgogICAgbG9jYWwgaiA9IDQKICAgIHdoaWxlIGluZGV4IDwgI3Byb29mX29jdGV0cyBkbwogICAgICAgIGxvY2FsIGVuZF9pbmRleCA9IGluZGV4ICsgT0NURVRfU0NBTEFSX0xFTkdUSCAtMQogICAgICAgIHJldHVybl9hcnJheVtqXSA9IG9zMmlwKHByb29mX29jdGV0czpzdWIoaW5kZXgsIGVuZF9pbmRleCkpCiAgICAgICAgaWYgKHJldHVybl9hcnJheVtqXSA9PSBCSUcubmV3KDApKSBvciAocmV0dXJuX2FycmF5W2pdPj1QUklNRV9SKSB0aGVuCiAgICAgICAgICAgIHByaW50KGopCiAgICAgICAgICAgIGVycm9yKCJOb3QgYSBzY2FsYXIgaW4gb2N0ZXRzX3RvX3Byb29mIiwgNCkKICAgICAgICBlbmQKICAgICAgICBpbmRleCA9IGluZGV4ICsgT0NURVRfU0NBTEFSX0xFTkdUSAogICAgICAgIGogPSBqKzEKICAgIGVuZAoKICAgIGlmIGluZGV4IH49ICNwcm9vZl9vY3RldHMgKzEgdGhlbgogICAgICAgIGVycm9yKCJJbmRleCBpcyBub3QgcmlnaHQgbGVuZ3RoIiwgNCkKICAgIGVuZAoKICAgIGxvY2FsIG1zZ19jb21taXRtZW50cyA9IHt9CiAgICBpZiBqID4gNyB0aGVuCiAgICAgICAgbXNnX2NvbW1pdG1lbnRzID0ge3RhYmxlLnVucGFjayhyZXR1cm5fYXJyYXksIDcsIGotMil9CiAgICBlbmQKICAgIGxvY2FsIHJldF9hcnJheSA9IHt0YWJsZS51bnBhY2socmV0dXJuX2FycmF5LCAxLCA2KX0KICAgIHJldF9hcnJheVs3XSA9IG1zZ19jb21taXRtZW50cwogICAgdGFibGUuaW5zZXJ0KHJldF9hcnJheSxyZXR1cm5fYXJyYXlbai0xXSkKICAgIHJldHVybiByZXRfYXJyYXkKCmVuZAoKLS1bWwpERVNDUklQVElPTjogVGhpcyBvcGVyYXRpb25zIGluaXRpYWxpemVzIHRoZSBwcm9vZiB2ZXJpZmljYXRpb24gYW5kIHJldHVybiBvbmUgb2YgdGhlIGlucHV0cyBvZiB0aGUgY2hhbGxlbmdlIGNhbGN1bGF0aW9uIG9wZXJhdGlvbiAKSU5QVVQ6IGNpcGhlcnN1aXRlIChhIHRhYmxlKSwgcGsgKGFzIHplbnJvb20ub2N0ZXQpLCBBYmFyLCBCYmFyLCBEIChHMSBwb2ludHMpLCBlaGF0LCByMWhhdCAscjNoYXQgKHNjYWxhcnMpLCBjb21taXRtZW50cyAoYSBzY2FsYXIgdmVjdG9yKSwgYyhhIHNjYWxhcikKZ2VuZXJhdG9ycyAoIGFuIGFycmF5IG9mIEcxIHBvaW50cyksIGhlYWRlciAoYXMgemVucm9vbS5vY3RldCksIGRpc2Nsb3NlZF9tZXNzYWdlcyAoYXJyYXkgb2Ygb2N0ZXQgc3RyaW5ncyksIGRpc2Nsb3NlZF9pbmRleGVzKCBhbiBhcnJheSBvZiBwb3NpdGl2ZSBpbnRlZ2VycykgLgpPVVRQVVQ6IGFuIGFycmF5IGNvbnNpc3Rpbmcgb2YgNCBHMSBwb2ludHMgYW5kIGEgc2NhbGFyICAgCl1dCmxvY2FsIGZ1bmN0aW9uIHByb29mX3ZlcmlmeV9pbml0KGNpcGhlcnN1aXRlLCBwaywgQWJhciwgQmJhciwgRCAsIGVoYXQsIHIxaGF0LCByM2hhdCAsIGNvbW1pdG1lbnRzLCBjLCBnZW5lcmF0b3JzLCBoZWFkZXIsIGRpc2Nsb3NlZF9tZXNzYWdlcywgZGlzY2xvc2VkX2luZGV4ZXMpCgogICAgbG9jYWwgbGVuX1UgPSB0YWJsZV9zaXplKGNvbW1pdG1lbnRzKQogICAgbG9jYWwgbGVuX1IgPSB0YWJsZV9zaXplKGRpc2Nsb3NlZF9pbmRleGVzKQogICAgbG9jYWwgbGVuX0wgPSBsZW5fUiArIGxlbl9VCgogICAgLS1QcmVjb25kaXRpb25zCiAgICBmb3IgXyxpIGluIHBhaXJzKGRpc2Nsb3NlZF9pbmRleGVzKSBkbwogICAgICAgIGlmIChpIDwgMSkgb3IgKGkgPiBsZW5fTCkgdGhlbgogICAgICAgICAgICBlcnJvcigiZGlzY2xvc2VkX2luZGV4ZXMgb3V0IG9mIHJhbmdlIiwgNCkKICAgICAgICBlbmQKICAgIGVuZAogICAgaWYgdGFibGVfc2l6ZShkaXNjbG9zZWRfbWVzc2FnZXMpIH49IGxlbl9SIHRoZW4KICAgICAgICBlcnJvcigiVW5tYXRjaGluZyBpbmRleGVzIGFuZCBtZXNzYWdlcyIsIDQpCiAgICBlbmQKCiAgICBsb2NhbCBRXzEgPSBnZW5lcmF0b3JzWzFdCiAgICBsb2NhbCBNc2dHZW5lcmF0b3JzID0ge3RhYmxlLnVucGFjayhnZW5lcmF0b3JzLCAyLCBsZW5fTCsxKX0KCiAgICBsb2NhbCBkaXNjbG9zZWRfSCA9IHt9CiAgICBsb2NhbCBzZWNyZXRfSCA9IHt9CiAgICBmb3IgaSA9IDEsIGxlbl9MIGRvCiAgICAgICAgaWYgYXJyYXlfY29udGFpbnMoZGlzY2xvc2VkX2luZGV4ZXMsaSkgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQoZGlzY2xvc2VkX0gsIE1zZ0dlbmVyYXRvcnNbaV0pCiAgICAgICAgZWxzZQogICAgICAgICAgICB0YWJsZS5pbnNlcnQoc2VjcmV0X0gsIE1zZ0dlbmVyYXRvcnNbaV0pCiAgICAgICAgZW5kCiAgICBlbmQKCiAgICBsb2NhbCBkb21haW4gPSBjYWxjdWxhdGVfZG9tYWluKGNpcGhlcnN1aXRlLCBwaywgUV8xLCBNc2dHZW5lcmF0b3JzLCBoZWFkZXIpCgogICAgbG9jYWwgVF8xID0gQmJhciogYyArIEFiYXIqIGVoYXQgKyBEKiByMWhhdAogCiAgICBsb2NhbCBCdiA9IGNpcGhlcnN1aXRlLlAxICsgUV8xKmRvbWFpbgogICAgZm9yIGkgPSAxLCBsZW5fUiBkbwogICAgICAgIEJ2ID0gQnYgKyBkaXNjbG9zZWRfSFtpXSpkaXNjbG9zZWRfbWVzc2FnZXNbaV0KICAgIGVuZAoKICAgIGxvY2FsIFRfMiA9IEJ2KmMgKyBEKiByM2hhdAogICAgZm9yIGkgPSAxLCBsZW5fVSBkbwogICAgICAgIFRfMiA9IFRfMiArIHNlY3JldF9IW2ldKmNvbW1pdG1lbnRzW2ldCiAgICBlbmQKICAgIHJldHVybiB7QWJhciwgQmJhciwgRCwgVF8xLCBUXzIsIGRvbWFpbn0KCgplbmQKCi0tW1sKREVTQ1JJUFRJT046IFRoaXMgb3BlcmF0aW9ucyBjaGVja3MgdGhlIHZhbGlkaXR5IG9mIHRoZSBwcm9vZgpJTlBVVDogY2lwaGVyc3VpdGUgKGEgdGFibGUpLCBwayAoYXMgemVucm9vbS5vY3RldCksIHByb29mIChhcyB6ZW5yb29tLm9jdGV0KSwgZ2VuZXJhdG9ycyAoIGFuIGFycmF5IG9mIEcxIHBvaW50cyksIGhlYWRlciAoYXMgemVucm9vbS5vY3RldCksIHBoKCBhcyB6ZW5yb29tLm9jdGV0KQpkaXNjbG9zZWRfbWVzc2FnZXMgKGFycmF5IG9mIG9jdGV0IHN0cmluZ3MpLCBkaXNjbG9zZWRfaW5kZXhlcyggYW4gYXJyYXkgb2YgcG9zaXRpdmUgaW50ZWdlcnMpIC4KT1VUUFVUOiBhIGJvb2xlYW4gdHJ1ZSBvciBmYWxzZSAgIApdXQpsb2NhbCBmdW5jdGlvbiBjb3JlX3Byb29mX3ZlcmlmeShjaXBoZXJzdWl0ZSwgcGsgLCBwcm9vZiwgZ2VuZXJhdG9ycywgaGVhZGVyLCBwaCwgZGlzY2xvc2VkX21lc3NhZ2VzLCBkaXNjbG9zZWRfaW5kZXhlcykKCiAgICBsb2NhbCBwcm9vZl9yZXN1bHQgPSBvY3RldHNfdG9fcHJvb2YocHJvb2YpCiAgICBsb2NhbCBBYmFyLCBCYmFyLCBEICwgZWhhdCwgcjFoYXQsIHIzaGF0ICwgY29tbWl0bWVudHMsIGNwID0gdGFibGUudW5wYWNrKHByb29mX3Jlc3VsdCkKICAgIGxvY2FsIFcgPSBiYnMub2N0ZXRzX3RvX3B1Yl9rZXkocGspCgogICAgbG9jYWwgaW5pdF9yZXMgPSBwcm9vZl92ZXJpZnlfaW5pdChjaXBoZXJzdWl0ZSwgcGsgLCBBYmFyLCBCYmFyLCBEICwgZWhhdCwgcjFoYXQsIHIzaGF0ICwgY29tbWl0bWVudHMsIGNwLCBnZW5lcmF0b3JzLCBoZWFkZXIsIGRpc2Nsb3NlZF9tZXNzYWdlcywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBsb2NhbCBjaGFsbGVuZ2UgPSBwcm9vZl9jaGFsbGVuZ2VfY2FsY3VsYXRlKGNpcGhlcnN1aXRlLCBpbml0X3JlcywgZGlzY2xvc2VkX21lc3NhZ2VzLCBkaXNjbG9zZWRfaW5kZXhlcywgcGgpCiAgICBpZiAoY3Agfj0gY2hhbGxlbmdlKSB0aGVuCiAgICAgICAgcmV0dXJuIGZhbHNlCiAgICBlbmQKCiAgICBsb2NhbCBMSFMgPSBFQ1AyLmF0ZShXLCBBYmFyKQogICAgbG9jYWwgUkhTID0gRUNQMi5hdGUoRUNQMi5nZW5lcmF0b3IoKSwgQmJhcikKICAgIHJldHVybiAgTEhTID09IFJIUwoKZW5kCgotLVtbCkRFU0NSSVBUSU9OOiBUaGlzIGZ1bmN0aW9uIHZhbGlkYXRlcyBhIEJCUyBwcm9vZgpJTlBVVDogY2lwaGVyc3VpdGUgKGEgdGFibGUpLCBwayAoYXMgemVucm9vbS5vY3RldCksIHByb29mIChhcyB6ZW5yb29tLm9jdGV0KSwgaGVhZGVyIChhcyB6ZW5yb29tLm9jdGV0KSwgcGgoIGFzIHplbnJvb20ub2N0ZXQpCmRpc2Nsb3NlZF9tZXNzYWdlcyAoYXJyYXkgb2Ygb2N0ZXQgc3RyaW5ncyksIGRpc2Nsb3NlZF9pbmRleGVzKCBhbiBhcnJheSBvZiBwb3NpdGl2ZSBpbnRlZ2VycykgLgpPVVRQVVQ6IGEgYm9vbGVhbiB0cnVlIG9yIGZhbHNlICAgCl1dCgotLS1JdCBpcyByZXNwb25zaWJsZSBmb3IgdmFsaWRhdGluZyBhIEJCUyBwcm9vZi4gVGhpcyBwcm9vZiB3YXMgZ2VuZXJhdGVkIGJ5IEB7cHJvb2ZfZ2VufSBhbmQgYWxsb3dzIGEgdmVyaWZpZXIgdG8gY29uZmlybSB0aGF0IGEgc2lnbmVyIHBvc3Nlc3NlcyBhIHZhbGlkIEJCUyAKLS1zaWduYXR1cmUgd2hpbGUgc2VsZWN0aXZlbHkgcmV2ZWFsaW5nIG9ubHkgc29tZSBzaWduZWQgbWVzc2FnZXMuCi0tSXQgdXNlcyBzb21lIG90aGVyIGZ1bmN0aW9uczogdGhlIDxjb2RlPm9jdGV0c1xfdG9cX3Byb29mPC9jb2RlPiBmdW5jdGlvbiBjb252ZXJ0cyB0aGUgcHJvb2Ygb2N0ZXQgc3RyaW5nIGludG8gaXRzIG1hdGhlbWF0aWNhbCBjb21wb25lbnRzIChncm91cCBlbGVtZW50cyBhbmQgc2NhbGFycykuCi0tVGhlIDxjb2RlPnByb29mXF92ZXJpZnlcX2luaXQ8L2NvZGU+IGZ1bmN0aW9uIGNvbXB1dGVzIHRoZSBleHBlY3RlZCBjb21taXRtZW50cyBmb3IgZGlzY2xvc2VkIGFuZCB1bmRpc2Nsb3NlZCBtZXNzYWdlcy4KLS1UaGUgPGNvZGU+cHJvb2ZcX2NoYWxsZW5nZVxfY2FsY3VsYXRlPC9jb2RlPiBlbnN1cmVzIHRoYXQgdGhlIGNoYWxsZW5nZSBzY2FsYXIgd2FzIGNvbXB1dGVkIGNvcnJlY3RseS4KLS0KLS1AZnVuY3Rpb24gQkJTLnByb29mX3ZlcmlmeQotLUBwYXJhbSBjaXBoZXJzdWl0ZQotLUBwYXJhbSBwayB0aGUgcHVibGljIGtleQotLUBwYXJhbSBoZWFkZXIKLS1AcGFyYW0gcGggdGhlIHByZXNlbnRhdGlvbiBoZWFkZXIKLS1AcGFyYW0gbWVzc2FnZXMgYW4gYXJyYXkgb2YgbWVzc2FnZXMKLS1AcGFyYW0gaW5kZXhlcyBhbiBycmF5IG9mIGluZGV4ZXMgc3BlY2lmeWluZyB3aGljaCBtZXNzYWdlcyB3ZXJlIGRpc2Nsb3NlZAotLUByZXR1cm4gdHJ1ZSBpZiB0aGUgcHJvb2YgaXMgdmFsaWQsIGZhbHNlIG90aGVyd2lzZQotLUB1c2FnZSAKLS0qKmZyb20gdGhlIHVzYWdlIGluIHRoZSBwcm9vZl9nZW4gZnVuY3Rpb24sIGNoZWNrIGlmIHRoZSBwcm9vZiBpcyB2YWxpZAotLWlmICBiYnMucHJvb2ZfdmVyaWZ5KGNpcGhlcnN1aXRlLCBPLmZyb21faGV4KFBVQkxJQ19LRVkpLCBwZ19vdXRwdXQsIE8uZnJvbV9oZXgoSEVBREVSKSwgUFJFU0VOVEFUSU9OX0hFQURFUiwgU0lOR0xFX01TR19BUlJBWSwgezF9KSB0aGVuIHByaW50KCJ2YWxpZCBwcm9vZiIpCi0tZWxzZSBwcmludCgiaW52YWxpZCBwcm9vZiIpCi0tZW5kCi0tKipwcmludDogdmFsaWQgcHJvb2YKCmZ1bmN0aW9uIGJicy5wcm9vZl92ZXJpZnkoY2lwaGVyc3VpdGUsIHBrLCBwcm9vZiwgaGVhZGVyLCBwaCwgZGlzY2xvc2VkX21lc3NhZ2VzX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpCgogICAgbG9jYWwgcHJvb2ZfbGVuX2Zsb29yID0gMypPQ1RFVF9QT0lOVF9MRU5HVEggKyA0Kk9DVEVUX1NDQUxBUl9MRU5HVEgKICAgIGlmICNwcm9vZiA8IHByb29mX2xlbl9mbG9vciB0aGVuCiAgICAgICAgZXJyb3IoInByb29mX29jdGV0cyBpcyB0b28gc2hvcnQiLCAyKQogICAgZW5kCiAgICB0YWJsZS5zb3J0KGRpc2Nsb3NlZF9pbmRleGVzKSAtLSBtYWtlIHN1cmUgaW5kZXhlcyBhcmUgc29ydGVkCiAgICBoZWFkZXIgPSBoZWFkZXIgb3IgTy5lbXB0eSgpCiAgICBwaCA9IHBoIG9yIE8uZW1wdHkoKQogICAgZGlzY2xvc2VkX21lc3NhZ2VzX29jdGV0cyA9IGRpc2Nsb3NlZF9tZXNzYWdlc19vY3RldHMgb3Ige30KICAgIGRpc2Nsb3NlZF9pbmRleGVzID0gZGlzY2xvc2VkX2luZGV4ZXMgb3Ige30KICAgIGxvY2FsIGxlbl9VID0gbWF0aC5mbG9vcigoI3Byb29mLXByb29mX2xlbl9mbG9vcikvT0NURVRfU0NBTEFSX0xFTkdUSCkKICAgIGxvY2FsIGxlbl9SID0gdGFibGVfc2l6ZShkaXNjbG9zZWRfaW5kZXhlcykKICAgIGlmIGRpc2Nsb3NlZF9pbmRleGVzWzFdIDw9IDAgdGhlbgogICAgICAgIGVycm9yKCdEaXNjbG9zZWQgaW5kZXhlcyBjb250YWlucyBhbiBpbnRlZ2VyIGxlc3MgdGhhbiBvciBlcXVhbCB0byAwJywgMikKICAgIGVuZAogICAgaWYgZGlzY2xvc2VkX2luZGV4ZXNbI2Rpc2Nsb3NlZF9pbmRleGVzXSA+IGxlbl9SK2xlbl9VIHRoZW4KICAgICAgICBlcnJvcignRGlzY2xvc2VkIGluZGV4IGNvbnRhaW5zIGFuIGludGVnZXIgd2hpY2ggZXhjZWVkcyB0aGUgdG90YWwgIG51bWJlciBvZiBtZXNzYWdlcycsIDIpCiAgICBlbmQKICAgIGZvciBpID0gMiwgbGVuX1IsIDEgZG8KICAgICAgICBpZiBkaXNjbG9zZWRfaW5kZXhlc1tpXSA9PSBkaXNjbG9zZWRfaW5kZXhlc1tpIC0gMV0gdGhlbgogICAgICAgICAgICBlcnJvcignZGlzY2xvc2VkIGluZGV4ZXMgY29udGFpbnMgZHVwbGljYXRlcycsIDIpCiAgICAgICAgZW5kCiAgICBlbmQKICAgIGxvY2FsIG1lc3NhZ2Vfc2NhbGFycyA9IGJicy5tZXNzYWdlc190b19zY2FsYXJzKGNpcGhlcnN1aXRlLCBkaXNjbG9zZWRfbWVzc2FnZXNfb2N0ZXRzKQogICAgbG9jYWwgZ2VuZXJhdG9ycyA9IGJicy5jcmVhdGVfZ2VuZXJhdG9ycyhjaXBoZXJzdWl0ZSwgbGVuX1UrbGVuX1IrMSkKCiAgICByZXR1cm4gY29yZV9wcm9vZl92ZXJpZnkoY2lwaGVyc3VpdGUsIHBrLCBwcm9vZiwgZ2VuZXJhdG9ycywgaGVhZGVyLCBwaCwgbWVzc2FnZV9zY2FsYXJzLCBkaXNjbG9zZWRfaW5kZXhlcykKCmVuZAoKcmV0dXJuIGJicwoKL2NyeXB0b19iaXRjb2luLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBBbGJlcnRvIExlcmRhCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLV1dCgpsb2NhbCBidGMgPSB7fQoKLS0gQSBiaXRjb2luIGFkZHJlc3MgaXMgdW5pcXVlIGdpdmVuIHRoZSBwdWJsaWMga2V5Ci0tIGFkZHJlc3MgPSBSSVBFTUQxNjAoU0hBMjU2KHB1YmxpY19rZXkpKQotLSB0aGUgY29tcG9zaXRpb24gb2YgUklQRU1EMTYwIGFuZCBTSEEyNTYgaXMga25vd24gYXMgSEFTSDE2MApmdW5jdGlvbiBidGMuYWRkcmVzc19mcm9tX3B1YmxpY19rZXkocHVibGljX2tleSkKICAgcmV0dXJuIEhBU0guaGFzaDE2MChwdWJsaWNfa2V5KQplbmQKCgotLSBUaGUgdXNlciBrbm93cyBoaXMgcHJpdmF0ZSBrZXkgaW4gdGhlIFdJRiBmb3JtYXQgKGJhc2U1OCkKLS0gVGhpcyBmdW5jdGlvbiBjb21wdXRlIHRoZSBieXRlcyBvZiB0aGUgcHJpdmF0ZSBrZXkgKGFuIG9jdGV0KQotLSBmcm9tIHRoZSBXSUYgZm9ybWF0Ci0tIEBwYXJhbSB3aWYgUHJpdmF0ZSBrZXkgaW4gV0lGIGZvcm1hdAotLSBAcmV0dXJuIFByaXZhdGUga2V5IG9jdGV0CmZ1bmN0aW9uIGJ0Yy53aWZfdG9fc2sod2lmKQogICBpZiBub3QgdHlwZSh3aWYpID09ICd6ZW5yb29tLm9jdGV0JyB0aGVuCiAgICAgIGVycm9yKCJpbnZhbGlkIGJpdGNvaW4ga2V5IHR5cGUsIG5vdCBhbiBvY3RldDogIi4udHlwZSh3aWYpLCAzKSBlbmQKICAgbG9jYWwgbGVuID0gI3dpZgogICBpZiBub3QgKGxlbiA9PSAzMis2KSB0aGVuCiAgICAgIGVycm9yKCJJbnZhbGlkIGJpdGNvaW4ga2V5LCB3cm9uZyBXSUYgc2l6ZTogIi4ubGVuLi4iIGJ5dGVzIiwgMykgZW5kCiAgIGxvY2FsIHZlciA9IHdpZjpjaG9wKDEpOmhleCgpCiAgIGlmIG5vdCh2ZXIgPT0gJ2VmJyBvciB2ZXIgPT0gJzgwJykgdGhlbgogICAgICBlcnJvcigiSW52YWxpZCBiaXRjb2luIGtleSB2ZXJzaW9uOiAiLi52ZXIsIDMpIGVuZAogICBsb2NhbCBjb21wcmVzcyA9IHdpZjpzdWIoMzQsMzQpOmhleCgpCiAgIGlmIG5vdChjb21wcmVzcyA9PSAnMDEnKSB0aGVuCiAgICAgIGVycm9yKCJJbnZhbGlkIGJpdGNvaW4ga2V5IGNvbXByZXNzaW9uIGJ5dGU6ICIuLndpZjpzdWIobGVuLCBsZW4pOmhleCgpLCAzKSBlbmQKCiAgIGxvY2FsIGRhdGEgPSB3aWY6c3ViKDEsIGxlbi00KQoKICAgbG9jYWwgY2hlY2sgPSBIQVNILmRzaGEyNTYoZGF0YSk6Y2hvcCg0KQoKICAgaWYgbm90KHdpZjpzdWIobGVuLTMsIGxlbikgPT0gY2hlY2spIHRoZW4KICAgICAgZXJyb3IoIkludmFsaWQgYml0Y29pbiBrZXk6IGNoZWNrc3VtIG1pc21hdGNoIiwgMykgZW5kCgogICByZXR1cm4gd2lmOnN1YigyLGxlbi01KQplbmQKCgotLSAweDgwID0gTWFpbm5ldAotLSAweEVGID0gVGVzdG5ldApmdW5jdGlvbiBidGMuc2tfdG9fd2lmKHNrLCB2cykKICAgbG9jYWwgdmVyCiAgIGlmIHZzID09ICd0ZXN0bmV0JyB0aGVuCiAgICAgIHZlciA9IE8uZnJvbV9oZXgoJ0VGJykKICAgZWxzZQogICAgICB2ZXIgPSBPLmZyb21faGV4KCc4MCcpCiAgIGVuZAogICBsb2NhbCByZXMgPSB2ZXIuLnNrCiAgIHJlcyA9IHJlcy4uTy5mcm9tX2hleCgnMDEnKSAtLSBjb21wcmVzc2VkIHB1YmxpYyBrZXkKICAgcmVzID0gcmVzLi5IQVNILmRzaGEyNTYocmVzKTpjaG9wKDQpIC0tIGNoZWNrc3VtCiAgIHJldHVybiByZXMKZW5kCgotLSB2YXJpYWJsZSBsZW5ndGggZW5jb2RpbmcgZm9yIGludGVnZXIgYmFzZWQgb24gdGhlCi0tIGFjdHVhbCBsZW5ndGggb2YgdGhlIG51bWJlcgpmdW5jdGlvbiBidGMuZW5jb2RlX2NvbXBhY3Rfc2l6ZShuKQogICBsb2NhbCByZXMsIHBhZGRpbmcsIHByZWZpeCwgbGUgLS0gbGl0dGxlRW5kaWFuOwoKICAgaWYgdHlwZShuKSB+PSAiemVucm9vbS5iaWciIHRoZW4KICAgICAgbiA9IElOVC5uZXcobikKICAgZW5kCiAgIAogICBwYWRkaW5nID0gMAogICByZXMgPSBPLm5ldygpCiAgIGlmIG4gPD0gSU5ULm5ldygyNTIpIHRoZW4KICAgICAgcmVzID0gbjpvY3RldCgpCiAgIGVsc2UKICAgICAgbGUgPSBuOm9jdGV0KCk6cmV2ZXJzZSgpCiAgICAgIHByZWZpeCA9IE8ubmV3KCkKICAgICAgaWYgbiA8PSBJTlQubmV3KCcweGZmZmYnKSB0aGVuCgkgcHJlZml4ID0gTy5mcm9tX2hleCgnZmQnKSAKCSBwYWRkaW5nID0gMgogICAgICBlbHNlaWYgbiA8PSBJTlQubmV3KCcweGZmZmZmZmZmJykgdGhlbgoJIHByZWZpeCA9IE8uZnJvbV9oZXgoJ2ZlJykKCSBwYWRkaW5nID0gNAogICAgICBlbHNlaWYgbiA8PSBJTlQubmV3KCcweGZmZmZmZmZmZmZmZmZmZmYnKSB0aGVuCgkgcHJlZml4ID0gTy5mcm9tX2hleCgnZmYnKQoJIHBhZGRpbmcgPSA4CiAgICAgIGVsc2UKCSBwYWRkaW5nID0gI2xlCiAgICAgIGVuZAogICAgICByZXMgPSBwcmVmaXggLi4gbGUKICAgICAgcGFkZGluZyA9IHBhZGRpbmcgLSAjbGUKICAgZW5kCgogICBpZiBwYWRkaW5nID4gMCB0aGVuCiAgICAgIHJlcyA9IHJlcyAuLiBPLnplcm8ocGFkZGluZykKICAgZW5kCgogICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZGVjb2RlX2NvbXBhY3Rfc2l6ZV9hdF9pbmRleChyYXcsIGkpCiAgIGxvY2FsIGIxCgogICBiMSA9IHRvbnVtYmVyKHJhdzpzdWIoaSxpKTpoZXgoKSwgMTYpCiAgIGxvY2FsIHMsIGUgLS0gc3RhcnQgYW5kIGVuZCBpbmRleAogICBpZiBiMSA8IDB4ZmQgdGhlbgogICAgICBzLCBlID0gMSwgMQogICBlbHNlaWYgYjEgPT0gMHhmZCB0aGVuCiAgICAgIHMsIGUgPSAyLCAzCiAgIGVsc2VpZiBiMSA9PSAweGZlIHRoZW4KICAgICAgcywgZSA9IDIsIDUKICAgZWxzZQogICAgICBzLCBlID0gMiwgOQogICBlbmQKICAgcmV0dXJuIElOVC5uZXcocmF3OnN1YihpK3MtMSwgaStlLTEpKSwgaStlCmVuZAoKLS0gZml4ZWQgc2l6ZSBlbmNvZGluZyBmb3IgaW50ZWdlcgpmdW5jdGlvbiBidGMudG9fdWludChudW0sIG5ieXRlcykKICAgaWYgdHlwZShudW0pIH49ICJ6ZW5yb29tLmJpZyIgdGhlbgogICAgICBudW0gPSBJTlQubmV3KG51bSkKICAgZW5kCiAgIG51bSA9IG51bTpvY3RldCgpOnJldmVyc2UoKQogICBpZiAjbnVtIDwgbmJ5dGVzIHRoZW4KICAgICAgbnVtID0gbnVtIC4uIE8uemVybyhuYnl0ZXMgLSAjbnVtKQogICBlbmQKICAgcmV0dXJuIG51bQplbmQKCi0tIHJlYWQgbGl0dGxlIGVuZGlhbiBudW1iZXIgZnJvbSB0cmFuc2FjdGlvbiByYXcgYXQgcG9zaXRpb24gaSAKbG9jYWwgZnVuY3Rpb24gcmVhZF91aW50KHJhdywgaSwgbmJ5dGVzKQogICByZXR1cm4gQklHLm5ldyh0b251bWJlcihyYXc6c3ViKGksaStuYnl0ZXMtMSk6cmV2ZXJzZSgpOmhleCgpLCAxNikpLCBpK25ieXRlcwplbmQKLS0gVGhlIHNlbmRlciBhZGRyZXNzIGlzIG5vdCBpbiB0aGUgcmF3IHRyYW5zYWN0aW9uCmZ1bmN0aW9uIGJ0Yy5kZWNvZGVfcmF3X3RyYW5zYWN0aW9uKHJhdywgc2VuZGVyX2FkZHJlc3MsIGFtb3VudHNfc3BlbnQpCiAgIGxvY2FsIFNDUklQVF9TSVpFX0xJTUlUID0gQklHLmZyb21fZGVjaW1hbCgnMTAwMDAnKQogICBsb2NhbCB0eAogICBsb2NhbCBpPTEKICAgbG9jYWwgc2NyaXB0Qnl0ZXMKICAgdHggPSB7fQogICAtLSB2ZXJzaW9uIChsaXR0bGUgZW5kaWFuKQogICB0eC52ZXJzaW9uLCBpID0gcmVhZF91aW50KHJhdywgaSwgNCkKICAgYXNzZXJ0KHR4LnZlcnNpb24gPT0gMSBvciB0eC52ZXJzaW9uID09IDIpCgogICAtLSBjaGVjayBpZiB0aGlzIGlzIHNlZ3dpdCwgQklQIDE0MQoKICAgc2Vnd2l0ID0gKHJhdzpzdWIoaSwgaSsxKSA9PSBPLmZyb21faGV4KCcwMDAxJykpCiAgIGlmIHNlZ3dpdCB0aGVuCiAgICAgIGk9aSsyCiAgIGVuZAogICAKICAgLS0gcmVhZCB0eGluCiAgIGxvY2FsIG5fdHhpbgogICBuX3R4aW4sIGkgPSBkZWNvZGVfY29tcGFjdF9zaXplX2F0X2luZGV4KHJhdywgaSkKICAgdHgudHhJbiA9IHt9CiAgIGZvciBqPTEsdG9udW1iZXIobl90eGluOm9jdGV0KCk6aGV4KCksIDE2KSwxIGRvCiAgICAgIGxvY2FsIGN1cnJJbiA9IHt9CiAgICAgIC0tIHByZXZpb3VzIG91dHB1dAogICAgICBjdXJySW4udHhpZCA9IHJhdzpzdWIoaSwgaSszMi0xKTpyZXZlcnNlKCkKICAgICAgaT1pKzMyCgogICAgICBjdXJySW4udm91dCwgaSA9IHJlYWRfdWludChyYXcsIGksIDQpCgogICAgICBjdXJySW4uYW1vdW50U3BlbnQgPSBhbW91bnRzX3NwZW50W2pdCgogICAgICBzY3JpcHRCeXRlcywgaSA9IGRlY29kZV9jb21wYWN0X3NpemVfYXRfaW5kZXgocmF3LCBpKQogICAgICBhc3NlcnQoc2NyaXB0Qnl0ZXMgPCBTQ1JJUFRfU0laRV9MSU1JVCkKICAgICAgc2NyaXB0Qnl0ZXMgPSB0b251bWJlcihzY3JpcHRCeXRlczpvY3RldCgpOmhleCgpLCAxNikKICAgICAgaWYgc2NyaXB0Qnl0ZXMgPiAwIHRoZW4KCSAtLSBlbXB0eSBzY3JpcHQKCSBpID0gaSArIHNjcmlwdEJ5dGVzCiAgICAgIGVuZAogICAgICAKICAgICAgY3VyckluLnNlcXVlbmNlID0gcmF3OnN1YihpLCBpKzMpOnJldmVyc2UoKQogICAgICBpID0gaSArIDQKCiAgICAgIGN1cnJJbi5hZGRyZXNzID0gc2VuZGVyX2FkZHJlc3MKCiAgICAgIHRhYmxlLmluc2VydCh0eC50eEluLCBjdXJySW4pCiAgIGVuZAogICAtLSByZWFkIHR4b3V0CiAgIG5fdHhvdXQsIGkgPSBkZWNvZGVfY29tcGFjdF9zaXplX2F0X2luZGV4KHJhdywgaSkKICAgdHgudHhPdXQgPSB7fQogICBmb3Igaj0xLHRvbnVtYmVyKG5fdHhvdXQ6b2N0ZXQoKTpoZXgoKSwgMTYpLDEgZG8KICAgICAgbG9jYWwgY3Vyck91dCA9IHt9CiAgICAgIGN1cnJPdXQuYW1vdW50ID0gQklHLm5ldyhyYXc6c3ViKGksaSs4LTEpOnJldmVyc2UoKSkKICAgICAgaT1pKzgKCiAgICAgIHNjcmlwdEJ5dGVzLCBpID0gZGVjb2RlX2NvbXBhY3Rfc2l6ZV9hdF9pbmRleChyYXcsIGkpCiAgICAgIGFzc2VydChzY3JpcHRCeXRlcyA8IFNDUklQVF9TSVpFX0xJTUlUKQogICAgICBzY3JpcHRCeXRlcyA9IHRvbnVtYmVyKHNjcmlwdEJ5dGVzOm9jdGV0KCk6aGV4KCksIDE2KQogICAgICBpZiBzY3JpcHRCeXRlcyA+IDAgdGhlbgoJIC0tIGRlY29kZSB0aGUgc2NyaXB0CgkgLS0gdGhlIHNjcmlwdCBpcyAwMCBBRERSRVNTX0xFTiBBRERSRVNTCgkgLS0gdGVzdCBzZWd3aXQgdmVyIDAgc2NyaXB0CgkgYXNzZXJ0KHJhdzpzdWIoaSxpKSA9PSBPLmZyb21faGV4KCcwMCcpKQoJIGxvY2FsIGFkZHJlc3NMZW4gPSB0b251bWJlcihyYXc6c3ViKGkrMSxpKzEpOmhleCgpLCAxNikKCgkgYXNzZXJ0KDIrYWRkcmVzc0xlbiA9PSBzY3JpcHRCeXRlcykKCgkgY3Vyck91dC5hZGRyZXNzID0gcmF3OnN1YihpKzIsIGkrc2NyaXB0Qnl0ZXMtMSkKCgkgaSA9IGkgKyBzY3JpcHRCeXRlcwogICAgICBlbmQKCiAgICAgIHRhYmxlLmluc2VydCh0eC50eE91dCwgY3Vyck91dCkKICAgZW5kCgogICAtLSByZWFkIHdpdG5lc3MgKGlmIHNlZ3dpdCkKICAgaWYgc2Vnd2l0IHRoZW4KICAgICAgdHgud2l0bmVzcyA9IHt9CiAgICAgIGZvciBqPTEsI3R4LnR4SW4sMSBkbwogICAgICAJIHN0YWNrU2l6ZSwgaSA9IGRlY29kZV9jb21wYWN0X3NpemVfYXRfaW5kZXgocmF3LCBpKQogICAgICAJIHN0YWNrU2l6ZSA9IHRvbnVtYmVyKHN0YWNrU2l6ZTpvY3RldCgpOmhleCgpLCAxNikKICAgICAgCSBpdGVtcyA9IHt9CiAgICAgIAkgZm9yIGs9MSxzdGFja1NpemUsMSBkbwogICAgICAJICAgIGl0ZW1CeXRlcywgaSA9IGRlY29kZV9jb21wYWN0X3NpemVfYXRfaW5kZXgocmF3LCBpKQogICAgICAJICAgIGl0ZW1CeXRlcyA9IHRvbnVtYmVyKGl0ZW1CeXRlczpvY3RldCgpOmhleCgpLCAxNikKCSAgICBpdGVtID0gcmF3OnN1YihpLCBpK2l0ZW1CeXRlcy0xKQoJICAgIGk9aStpdGVtQnl0ZXMKICAgICAgCSAgICB0YWJsZS5pbnNlcnQoaXRlbXMsIGl0ZW0pCiAgICAgIAkgZW5kCiAgICAgIAkgdGFibGUuaW5zZXJ0KHR4LndpdG5lc3MsIGl0ZW1zKQogICAgICBlbmQKICAgZW5kCgogICAtLSByZWFkIG5sb2NrdGltZQogICB0eC5uTG9ja1RpbWUsIGkgPSByZWFkX3VpbnQocmF3LCBpLCA0KQoKICAgcmV0dXJuIHR4CmVuZAoKLS0gY3JlYXRlIGFuIG9jdGV0IHdoaWNoIGlzIGEgcmF3IHRyYW5zYWN0aW9uCi0tIHdvcmtzIG9ubHkgd2l0aCBCZWNoMzIgdjAgYWRkcmVzc2VzCi0tIHdpdGggbm90IGNvaW5iYXNlIGlucHV0Ci0tIEBwYXJhbSB0eCB0YWJsZSB3aGljaCByZXBwcmVzZW50IGEgdHJhbnNhY3Rpb24KLS0gQHJldHVybiBvY3RldCByYXcgdHJhbnNhY3Rpb24KZnVuY3Rpb24gYnRjLmJ1aWxkX3Jhd190cmFuc2FjdGlvbih0eCkKICAgbG9jYWwgcmF3LCBzY3JpcHQKICAgcmF3ID0gTy5uZXcoKQoKICAgc2lnd2l0ID0gKHR4WyJ3aXRuZXNzIl0gYW5kICN0eFsid2l0bmVzcyJdPjApCgogICAtLSB2ZXJzaW9uCiAgIHJhdyA9IHJhdyAuLiBPLmZyb21faGV4KCcwMjAwMDAwMCcpCgoKICAgaWYgc2lnd2l0IHRoZW4KICAgICAgLS0gbWFya2VyICsgZmxhZ3MKICAgICAgcmF3ID0gcmF3IC4uIE8uZnJvbV9oZXgoJzAwMDEnKQogICBlbmQKICAgCiAgIHJhdyA9IHJhdyAuLiBidGMuZW5jb2RlX2NvbXBhY3Rfc2l6ZShJTlQubmV3KCN0eC50eEluKSkKCiAgIC0tIHR4SW4KICAgZm9yIF8sIHYgaW4gcGFpcnModHgudHhJbikgZG8KICAgICAgLS0gb3V0cG9pbnQgKGhhc2ggYW5kIGluZGV4IG9mIHRoZSB0cmFuc2FjdGlvbikKICAgICAgcmF3ID0gcmF3IC4uIHYudHhpZDpyZXZlcnNlKCkgLi4gYnRjLnRvX3VpbnQodi52b3V0LCA0KQogICAgICAtLSB0aGUgc2NyaXB0IGRlcGVuZHMgb24gdGhlIHNpZ25hdHVyZQogICAgICBzY3JpcHQgPSBPLm5ldygpCgogICAgICByYXcgPSByYXcgLi4gYnRjLmVuY29kZV9jb21wYWN0X3NpemUoI3NjcmlwdCkgLi4gc2NyaXB0CiAgICAgIAogICAgICAtLSBTZXF1ZW5jZSBudW1iZXIgZGlzYWJsZWQKICAgICAgcmF3ID0gcmF3IC4uIE8uZnJvbV9oZXgoJ2ZmZmZmZmZmJykKICAgZW5kCgogICByYXcgPSByYXcgLi4gYnRjLmVuY29kZV9jb21wYWN0X3NpemUoSU5ULm5ldygjdHgudHhPdXQpKQoKICAgLS0gdHhPdXQKICAgZm9yIGssIHYgaW4gcGFpcnModHgudHhPdXQpIGRvCiAgICAgIC0tcmF3ID0gcmF3IC4uIGJ0Yy50b191aW50KHYuYW1vdW50LCA4KQogICAgICBhc3NlcnQodi5hZGRyZXNzLCAiQWRkcmVzcyBub3QgZm91bmQgaW4gdHhvdXRbIi4uay4uIl0iKQogICAgICBsb2NhbCBhbW91bnQgPSBPLm5ldyh2LmFtb3VudCkKICAgICAgcmF3ID0gcmF3IC4uIGFtb3VudDpyZXZlcnNlKCkKICAgICAgaWYgI3YuYW1vdW50IDwgOCB0aGVuCgkgcmF3ID0gcmF3IC4uIE8uemVybyg4IC0gI2Ftb3VudCkKICAgICAgZW5kCiAgICAgIC0tIGZpeGVkIHNjcmlwdCB0byBzZW5kIGJpdGNvaW5zCiAgICAgIC0tIE9QX0RVUCBPUF9IQVNIMTYwIDIwYnl0ZQogICAgICAtLXNjcmlwdCA9IE8uZnJvbV9oZXgoJzc2YTkxNCcpCgogICAgICAtLXNjcmlwdCA9IHNjcmlwdCAuLiB2LmFkZHJlc3MKCiAgICAgIC0tIE9QX0VRVUFMVkVSSUZZIE9QX0NIRUNLU0lHCiAgICAgIC0tc2NyaXB0ID0gc2NyaXB0IC4uIE8uZnJvbV9oZXgoJzg4YWMnKQogICAgICAtLSBCZWNoMzIKICAgICAgc2NyaXB0ID0gTy5mcm9tX2hleCgnMDAxNCcpCiAgICAgIC0tIHJlYWRCZWNoMzJBZGRyZXNzKHYuYWRkcmVzcykKICAgICAgc2NyaXB0ID0gc2NyaXB0IC4uIGZpZih2LmFkZHJlc3MucmF3LCB2LmFkZHJlc3MucmF3LCB2LmFkZHJlc3MpCiAgICAgIAogICAgICByYXcgPSByYXcgLi4gYnRjLmVuY29kZV9jb21wYWN0X3NpemUoI3NjcmlwdCkgLi4gc2NyaXB0CiAgIGVuZAoKICAgaWYgc2lnd2l0IHRoZW4KICAgICAgLS0gRG9jdW1lbnRhdGlvbiBodHRwczovL2JpdGNvaW5jb3JlLm9yZy9lbi9zZWd3aXRfd2FsbGV0X2Rldi8KICAgICAgLS0gVGhlIGRvY3VtZW50YXRpb24gdGFsa3MgYWJvdXQgInN0YWNrIGl0ZW1zIiBidXQgaXQgZG9lc24ndCBzcGVjaWZ5CiAgICAgIC0tIHdoaWNoIGFyZSB0aGV5LCBJIHRoaW5rIHRoYXQgSXQgZGVwZW5kcyBvbiB0aGUgdHlwZSBvZiB0cmFuc2FjdGlvbgogICAgICAtLSAoUDJTSCBvciBQMlBLSCkKCiAgICAgIC0tIFRoZSBzaXplIG9mIHdpdG5lc3NlcyBpcyBub3QgbmVjZXNzYXJ5IGJlY2F1c2UgaXQgaXMgZXF1YWwgdG8gdGhlIG51bWJlciBvZgogICAgICAtLSB0eGluCiAgICAgIC0tcmF3ID0gcmF3IC4uIGJ0Yy5lbmNvZGVfY29tcGFjdF9zaXplKCN0eFsid2l0bmVzcyJdKQoKICAgICAgZm9yIF8sIHYgaW4gcGFpcnModHhbIndpdG5lc3MiXSkgZG8KCSAtLSBlbmNvZGUgYWxsIHRoZSBzdGFjayBpdGVtcyBmb3IgdGhlIHdpdG5lc3MKCSByYXcgPSByYXcgLi4gYnRjLmVuY29kZV9jb21wYWN0X3NpemUoI3YpCgkgZm9yIF8sIHMgaW4gcGFpcnModikgZG8KCSAgICByYXcgPSByYXcgLi4gYnRjLmVuY29kZV9jb21wYWN0X3NpemUoI3MpCgkgICAgcmF3ID0gcmF3IC4uIHMKCSBlbmQKICAgICAgZW5kCiAgIGVuZAoKICAgcmF3ID0gcmF3IC4uIE8uZnJvbV9oZXgoJzAwMDAwMDAwJykKICAgCiAgIHJldHVybiByYXcKZW5kCgpsb2NhbCBmdW5jdGlvbiBlbmNvZGVfd2l0aF9wcmVwZW5kKGJ5dGVzKQogICBpZiB0b251bWJlcihieXRlczpzdWIoMSwxKTpoZXgoKSwgMTYpID49IDB4ODAgdGhlbgogICAgICBieXRlcyA9IE8uZnJvbV9oZXgoJzAwJykgLi4gYnl0ZXMKICAgZW5kCgogICByZXR1cm4gYnl0ZXMKZW5kCgotLSBERVIgaXMgdGhlIGZvcm1hdCB1c2VkIGJ5IGJpdGNvaW4gdG8gZW5jb2RlCi0tIEVDRFNBIHNpZ25hdHVyZXMKLS0gQHBhcmFtIHNpZyBzaWduYXR1cmUgdGFibGUgKHdpdGggciBhbmQgcykKLS0gQHJldHVybiBvY3RldCBlbmNvZGVkIHdpdGggREVSIGZvcm1hdApmdW5jdGlvbiBidGMuZW5jb2RlX2Rlcl9zaWduYXR1cmUoc2lnKQogICBsb2NhbCByZXMsIHRtcDsKCiAgIHJlcyA9IE8ubmV3KCkKCiAgIC0tIHIKICAgdG1wID0gZW5jb2RlX3dpdGhfcHJlcGVuZChzaWcucikKICAgcmVzID0gcmVzIC4uIE8uZnJvbV9oZXgoJzAyJykgLi4gSU5ULm5ldygjdG1wKTpvY3RldCgpIC4uIHRtcAoKICAgLS0gcwogICB0bXAgPSBlbmNvZGVfd2l0aF9wcmVwZW5kKHNpZy5zKQogICByZXMgPSByZXMgLi4gTy5mcm9tX2hleCgnMDInKSAuLiBJTlQubmV3KCN0bXApOm9jdGV0KCkgLi4gdG1wCiAgIAogICByZXMgPSBPLmZyb21faGV4KCczMCcpIC4uIElOVC5uZXcoI3Jlcyk6b2N0ZXQoKSAuLiByZXMKICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIHJlYWRfbnVtYmVyX2Zyb21fZGVyKHJhdywgcG9zKQogICBsb2NhbCBzaXplCiAgIGFzc2VydChyYXc6c3ViKHBvcywgcG9zKSA9PSBPLmZyb21faGV4KCcwMicpKQogICBwb3M9IHBvcysxCiAgIHNpemUgPSB0b251bWJlcihyYXc6c3ViKHBvcywgcG9zKTpoZXgoKSwgMTYpCiAgIHBvcyA9IHBvcyArMQoKICAgLS0gSWYgdGhlIGZpcnN0IGJ5dGUgaXMgYSAwIGRvIG5vdCBjb25zaWRlciBpdAogICBpZiByYXc6c3ViKHBvcywgcG9zKSA9PSBPLmZyb21faGV4KCcwMCcpIHRoZW4KICAgICAgcG9zID0gcG9zICsxCiAgICAgIHNpemUgPSBzaXplIC0xCiAgIGVuZAoKICAgZGF0YSA9IHJhdzpzdWIocG9zLCBwb3Mrc2l6ZS0xKQoKICAgcmV0dXJuIHsKICAgICAgZGF0YSwKICAgICAgcG9zK3NpemUKICAgfQplbmQKCi0tIERFUiBpcyB0aGUgZm9ybWF0IHVzZWQgYnkgYml0Y29pbiB0byBlbmNvZGUKLS0gRUNEU0Egc2lnbmF0dXJlcwotLSBAcGFyYW0gcmF3IG9jdGV0IGVuY29kZWQgd2l0aCBERVIgZm9ybWF0Ci0tIEByZXR1cm4gc2lnbmF0dXJlIHRhYmxlICh3aXRoIHIgYW5kIHMpCmZ1bmN0aW9uIGJ0Yy5kZWNvZGVfZGVyX3NpZ25hdHVyZShyYXcpCiAgIGxvY2FsIHNpZywgdG1wLCBzaXplOwogICBzaWcgPSB7fQoKICAgYXNzZXJ0KHJhdzpjaG9wKDEpID09IE8uZnJvbV9oZXgoJzMwJykpCgogICBzaXplID0gdG9udW1iZXIocmF3OnN1YigyLDIpOmhleCgpLCAxNikKCiAgIHRtcCA9IHJlYWRfbnVtYmVyX2Zyb21fZGVyKHJhdywgMykKCiAgIHNpZy5yID0gdG1wWzFdCiAgIHRtcCA9IHRtcFsyXQoKICAgdG1wID0gcmVhZF9udW1iZXJfZnJvbV9kZXIocmF3LCB0bXApCgogICBzaWcucyA9IHRtcFsxXQoKICAgcmV0dXJuIHNpZwplbmQKCi0tIEhhc2ggcmVxdWlyZWQgaW4gdGhlIHJhdyB0cmFuc2FjdGlvbiAoaXMgZXhwb3NlZCB0byBiZSBhYmxlIHRvIHVzZSBpdAotLSBpbiB0aGUgdGVzdHMpCmxvY2FsIGZ1bmN0aW9uIF9oYXNoX3ByZXZvdXRzKHR4KQogICBsb2NhbCByYXcKICAgbG9jYWwgSAogICBIID0gSEFTSC5uZXcoJ3NoYTI1NicpCgogICByYXcgPSBPLm5ldygpCgogICBmb3IgXywgdiBpbiBwYWlycyh0eC50eEluKSBkbwogICAgICByYXcgPSByYXcgLi4gdi50eGlkOnJldmVyc2UoKSAuLiBidGMudG9fdWludCh2LnZvdXQsIDQpCiAgIGVuZAoKICAgcmV0dXJuIEg6cHJvY2VzcyhIOnByb2Nlc3MocmF3KSkKZW5kCgotLSBIYXNoIHJlcXVpcmVkIGluIHRoZSByYXcgdHJhbnNhY3Rpb24gKGlzIGV4cG9zZWQgdG8gYmUgYWJsZSB0byB1c2UgaXQKLS0gaW4gdGhlIHRlc3RzKQpsb2NhbCBmdW5jdGlvbiBfaGFzaF9zZXF1ZW5jZSh0eCkKICAgbG9jYWwgcmF3CiAgIGxvY2FsIEgKICAgbG9jYWwgc2VxCiAgIEggPSBIQVNILm5ldygnc2hhMjU2JykKCiAgIHJhdyA9IE8ubmV3KCkKCiAgIGZvciBfLCB2IGluIHBhaXJzKHR4LnR4SW4pIGRvCiAgICAgIHNlcSA9IHZbJ3NlcXVlbmNlJ10KICAgICAgaWYgbm90IHNlcSB0aGVuCgkgLS0gZGVmYXVsdCB2YWx1ZSwgbm90IGVuYWJsZWQKCSBzZXEgPSBPLmZyb21faGV4KCdmZmZmZmZmZicpCiAgICAgIGVuZAogICAgICByYXcgPSByYXcgLi4gYnRjLnRvX3VpbnQoc2VxLCA0KQogICBlbmQKICAgCiAgIHJldHVybiBIOnByb2Nlc3MoSDpwcm9jZXNzKHJhdykpCmVuZAoKLS0gSGFzaCByZXF1aXJlZCBpbiB0aGUgcmF3IHRyYW5zYWN0aW9uIChpcyBleHBvc2VkIHRvIGJlIGFibGUgdG8gdXNlIGl0Ci0tIGluIHRoZSB0ZXN0cykKbG9jYWwgZnVuY3Rpb24gX2hhc2hfb3V0cHV0cyh0eCkKICAgbG9jYWwgcmF3CiAgIGxvY2FsIEgKICAgSCA9IEhBU0gubmV3KCdzaGEyNTYnKQoKICAgcmF3ID0gTy5uZXcoKQoKICAgZm9yIF8sIHYgaW4gcGFpcnModHgudHhPdXQpIGRvCiAgICAgIGFtb3VudCA9IE8ubmV3KHYuYW1vdW50KQogICAgICByYXcgPSByYXcgLi4gYW1vdW50OnJldmVyc2UoKQogICAgICBpZiAjdi5hbW91bnQgPCA4IHRoZW4KCSByYXcgPSByYXcgLi4gTy56ZXJvKDggLSAjYW1vdW50KQogICAgICBlbmQKICAgICAgLS0gVGhpcyBpcyBzcGVjaWZpYyB0byBCZWNoMzIgYWRkcmVzc2VzLCB3ZSBzaG91bGQgYmUgYWJsZSB0byB2ZXJpZnkgdGhlIGtpbmQgb2YgYWRkcmVzcwogICAgICByYXcgPSByYXcgLi4gTy5mcm9tX2hleCgnMTYwMDE0JykgLi4gZmlmKCB2LmFkZHJlc3MucmF3LCB2LmFkZHJlc3MucmF3LCB2LmFkZHJlc3MpCgogICBlbmQKCiAgIHJldHVybiBIOnByb2Nlc3MoSDpwcm9jZXNzKHJhdykpCmVuZAoKCi0tIEJJUDAxNDMKLS0gRG91YmxlIFNIQTI1NiBvZiB0aGUgc2VyaWFsaXphdGlvbiBvZjoKLS0gICAgICAxLiBuVmVyc2lvbiBvZiB0aGUgdHJhbnNhY3Rpb24gKDQtYnl0ZSBsaXR0bGUgZW5kaWFuKQotLSAgICAgIDIuIGhhc2hfcHJldm91dHMgKDMyLWJ5dGUgaGFzaCkKLS0gICAgICAzLiBoYXNoX3NlcXVlbmNlICgzMi1ieXRlIGhhc2gpCi0tICAgICAgNC4gb3V0cG9pbnQgKDMyLWJ5dGUgaGFzaCArIDQtYnl0ZSBsaXR0bGUgZW5kaWFuKSAKLS0gICAgICA1LiBzY3JpcHRDb2RlIG9mIHRoZSBpbnB1dCAoc2VyaWFsaXplZCBhcyBzY3JpcHRzIGluc2lkZSBDVHhPdXRzKQotLSAgICAgIDYuIHZhbHVlIG9mIHRoZSBvdXRwdXQgc3BlbnQgYnkgdGhpcyBpbnB1dCAoOC1ieXRlIGxpdHRsZSBlbmRpYW4pCi0tICAgICAgNy4gblNlcXVlbmNlIG9mIHRoZSBpbnB1dCAoNC1ieXRlIGxpdHRsZSBlbmRpYW4pCi0tICAgICAgOC4gaGFzaF9vdXRwdXRzICgzMi1ieXRlIGhhc2gpCi0tICAgICAgOS4gbkxvY2t0aW1lIG9mIHRoZSB0cmFuc2FjdGlvbiAoNC1ieXRlIGxpdHRsZSBlbmRpYW4pCi0tICAgICAxMC4gc2lnaGFzaCB0eXBlIG9mIHRoZSBzaWduYXR1cmUgKDQtYnl0ZSBsaXR0bGUgZW5kaWFuKQpsb2NhbCBmdW5jdGlvbiBidWlsZF90cmFuc2FjdGlvbl90b19zaWduKHR4LCBpKQogICBsb2NhbCByYXcKICAgbG9jYWwgYW1vdW50CiAgIGxvY2FsIGFkZHJlc3MgPSBmaWYodHgudHhJbltpXS5hZGRyZXNzLnJhdywgCgkJICAgICAgIHR4LnR4SW5baV0uYWRkcmVzcy5yYXcsIHR4LnR4SW5baV0uYWRkcmVzcykKICAgYXNzZXJ0KGFkZHJlc3MsICJDYW5ub3Qgc2lnbiBvciB2ZXJpZnkgdHJhbnNhY3Rpb246IG5vIGFkZHJlc3MgcHJvdmlkZWQiKQogICByYXcgPSBPLm5ldygpCiAgIC0tICAgICAgMS4gblZlcnNpb24gb2YgdGhlIHRyYW5zYWN0aW9uICg0LWJ5dGUgbGl0dGxlIGVuZGlhbikKICAgcmF3ID0gcmF3IC4uIGJ0Yy50b191aW50KHR4LnZlcnNpb24sIDQpCiAgIC0tICAgICAgMi4gaGFzaF9wcmV2b3V0cyAoMzItYnl0ZSBoYXNoKQogICByYXcgPSByYXcgLi4gX2hhc2hfcHJldm91dHModHgpCiAgIC0tICAgICAgMy4gaGFzaF9zZXF1ZW5jZSAoMzItYnl0ZSBoYXNoKQogICByYXcgPSByYXcgLi4gX2hhc2hfc2VxdWVuY2UodHgpCiAgIC0tICAgICAgNC4gb3V0cG9pbnQgKDMyLWJ5dGUgaGFzaCArIDQtYnl0ZSBsaXR0bGUgZW5kaWFuKQogICByYXcgPSByYXcgLi4gdHgudHhJbltpXS50eGlkOnJldmVyc2UoKSAuLiBidGMudG9fdWludCh0eC50eEluW2ldLnZvdXQsIDQpCiAgIC0tICAgICAgNS4gc2NyaXB0Q29kZSBvZiB0aGUgaW5wdXQgKHNlcmlhbGl6ZWQgYXMgc2NyaXB0cyBpbnNpZGUgQ1R4T3V0cykKICAgcmF3ID0gcmF3IC4uIE8uZnJvbV9oZXgoJzE5NzZhOTE0JykgLi4gYWRkcmVzcyAgLi4gTy5mcm9tX2hleCgnODhhYycpCiAgIC0tICAgICAgNi4gdmFsdWUgb2YgdGhlIG91dHB1dCBzcGVudCBieSB0aGlzIGlucHV0ICg4LWJ5dGUgbGl0dGxlIGVuZGlhbikKICAgYW1vdW50ID0gTy5uZXcodHgudHhJbltpXS5hbW91bnRTcGVudCkKICAgcmF3ID0gcmF3IC4uIGFtb3VudDpyZXZlcnNlKCkKICAgaWYgI2Ftb3VudCA8IDggdGhlbgogICAgICByYXcgPSByYXcgLi4gTy56ZXJvKDggLSAjYW1vdW50KQogICBlbmQKICAgLS0gICAgICA3LiBuU2VxdWVuY2Ugb2YgdGhlIGlucHV0ICg0LWJ5dGUgbGl0dGxlIGVuZGlhbikKICAgcmF3ID0gcmF3IC4uIHR4LnR4SW5baV0uc2VxdWVuY2U6cmV2ZXJzZSgpCiAgIC0tICAgICAgOC4gaGFzaF9vdXRwdXRzICgzMi1ieXRlIGhhc2gpCiAgIHJhdyA9IHJhdyAuLiBfaGFzaF9vdXRwdXRzKHR4KQogICAtLSAgICAgIDkuIG5Mb2NrdGltZSBvZiB0aGUgdHJhbnNhY3Rpb24gKDQtYnl0ZSBsaXR0bGUgZW5kaWFuKQogICByYXcgPSByYXcgLi4gYnRjLnRvX3VpbnQodHgubkxvY2tUaW1lLCA0KQogICAtLSAgICAgMTAuIHNpZ2hhc2ggdHlwZSBvZiB0aGUgc2lnbmF0dXJlICg0LWJ5dGUgbGl0dGxlIGVuZGlhbikKICAgcmF3ID0gcmF3IC4uIGJ0Yy50b191aW50KHR4Lm5IYXNoVHlwZSwgNCkKCiAgIHJldHVybiByYXcKZW5kCgotLSBIZXJlIEkgc2lnbiB0aGUgdHJhbnNhY3Rpb24KZnVuY3Rpb24gYnRjLmJ1aWxkX3dpdG5lc3ModHgsIHNrKQogICBsb2NhbCBwayA9IEVDREguY29tcHJlc3NfcHVibGljX2tleShFQ0RILnB1YmdlbihzaykpCiAgIGxvY2FsIHdpdG5lc3MgPSB7fQogICBmb3IgaT0xLCN0eC50eEluLDEgZG8KICAgICAgaWYgdHgudHhJbltpXS5zaWd3aXQgdGhlbgoJIC0tIGZpbGwgYWRkcmVzcyBnZW5lcmF0ZWQgZnJvbSBzayBpZiBub3QgcHJlc2VudCBpbiB0eGluCgkgbG9jYWwgcmF3VHggPSBidWlsZF90cmFuc2FjdGlvbl90b19zaWduKHR4LCBpKQoJIGxvY2FsIHNpZ0hhc2ggPSBIQVNILmRzaGEyNTYocmF3VHgpCgkgbG9jYWwgc2lnID0gRUNESC5zaWduX2VjZGgoc2ssIHNpZ0hhc2gpCgkgd2l0bmVzc1tpXSA9IHsKCSAgICBidGMuZW5jb2RlX2Rlcl9zaWduYXR1cmUoc2lnKSAuLiBPLmZyb21faGV4KCcwMScpLAoJICAgIHBrCgkgfQogICAgICBlbHNlCgkgd2l0bmVzc1tpXSA9IE8uemVybygxKQogICAgICBlbmQKICAgZW5kCgogICByZXR1cm4gd2l0bmVzcwplbmQKCmZ1bmN0aW9uIGJ0Yy52ZXJpZnlfd2l0bmVzcyh0eCkKICAgdHgubkhhc2hUeXBlID0gTy5mcm9tX2hleCgnMDAwMDAwMDEnKQogICBpZiB0eC53aXRuZXNzID09IG5pbCB0aGVuCiAgICAgIHJldHVybiBmYWxzZQogICBlbmQKICAgZm9yIGksIHYgaW4gcGFpcnModHgud2l0bmVzcykgZG8KICAgICAgbG9jYWwgcmF3VHggPSBidWlsZF90cmFuc2FjdGlvbl90b19zaWduKHR4LCBpKQogICAgICBsb2NhbCBzaWdIYXNoID0gSEFTSC5kc2hhMjU2KHJhd1R4KQogICAgICBsb2NhbCBzaWcgPSBidGMuZGVjb2RlX2Rlcl9zaWduYXR1cmUodlsxXSkKICAgICAgaWYgbm90IEVDREgudmVyaWZ5X2hhc2hlZChFQ0RILnVuY29tcHJlc3NfcHVibGljX2tleSh2WzJdKSwgc2lnSGFzaCwgc2lnLCAjc2lnSGFzaCkgdGhlbgoJIHJldHVybiBmYWxzZQogICAgICBlbmQKICAgZW5kCiAgIHJldHVybiB0cnVlCmVuZAoKLS0gUGF5IGF0dGVudGlvbiB0byB0aGUgYW1vdW50LCBpdCBoYXMgdG8gYmUgbXVsdGlwbGllZCBmb3IgMTBeOAotLSBAcGFyYW0gdW5zcGVudCBsaXN0IG9mIHVuc3BlbnQgdHJhbnNhY3Rpb25zCi0tIEBwYXJhbSB0byByZWNlaXZlciBiaXRjb2luIGFkZHJlc3MgKG11c3QgYmUgc2Vnd2l0L0JlY2gzMiEpCi0tIEBwYXJhbSBhbW91bnQgc2F0b3NoaSB0byB0cmFuc2ZlciAoQklHIGludGVnZXIpCi0tIEBwYXJhbSBmZWUgc2F0b3NoaSBvZiBmZWUgd2Ugd2FudCB0byBwYXkKLS0gQHJldHVybiBuaWwgaWYgdGhlIHRyYW5zYWN0aW9uIGNhbm5vdCBidWlsdAotLSAoZm9yIGV4YW1wbGUgaWYgdGhlcmUgYXJlIG5vdCBlbm91Z2ggZm91bmRzKQpmdW5jdGlvbiBidGMuYnVpbGRfdHhfZnJvbV91bnNwZW50KHVuc3BlbnQsIHRvLCBhbW91bnQsIGZlZSwgZnJvbSkKICAgbG9jYWwgdHgsIGksIGN1cnJlbnRBbW91bnQKICAgdHggPSB7CiAgICAgIHZlcnNpb249QklHLm5ldygyKSwKICAgICAgdHhJbiA9IHt9LAogICAgICB0eE91dCA9IHt9LAogICAgICBuTG9ja1RpbWU9QklHLm5ldygwKSwKICAgICAgbkhhc2hUeXBlPU8uZnJvbV9oZXgoJzAwMDAwMDAxJykKICAgfQoKCiAgIGk9MQogICBjdXJyZW50QW1vdW50ID0gSU5ULm5ldygwKQogICB3aGlsZSBpIDw9ICN1bnNwZW50IGFuZCBjdXJyZW50QW1vdW50IDwgYW1vdW50K2ZlZSBkbwogICAgICBhc3NlcnQodW5zcGVudFtpXS5hZGRyZXNzIG9yIGZyb20sICJObyBzZW5kZXIgYWRkcmVzcyBzcGVjaWZpZWQiKQogICAgICAtLSBhbW91bnQgc2hvdWxkIGJlIGFscmVhZHkgY29udmVydGVkIHRvIGEgemVucm9vbSB0eXBlLCBpZiBub3QKICAgICAgLS0gdGhlbiB3ZSBhc3N1bWUgaXQgaXMgYSBzdHJpbmcgdmFsdWUgZXhwcmVzc2VkIGluIHNhdG9zaGlzCiAgICAgIGxvY2FsIGFtb3VudCA9IHVuc3BlbnRbaV0uYW1vdW50CiAgICAgIGlmIG5vdCBpc3plbiggdHlwZSggYW1vdW50ICkgKSB0aGVuIGFtb3VudCA9IEJJRy5mcm9tX2RlY2ltYWwoIGFtb3VudCApIGVuZAogICAgICBjdXJyZW50QW1vdW50ID0gY3VycmVudEFtb3VudCArIGFtb3VudAogICAgICB0eC50eEluW2ldID0gewoJIHR4aWQgPSB1bnNwZW50W2ldLnR4aWQsCgkgdm91dCA9IHVuc3BlbnRbaV0udm91dCwKCSBzaWd3aXQgPSBPLmZyb21faGV4KCcwMScpLCAtLSB0aGlzIHNob3VsZCBiZSB0cnVlCgkgYWRkcmVzcyA9IHVuc3BlbnRbaV0uYWRkcmVzcyBvciBmcm9tLAoJIGFtb3VudFNwZW50ID0gYW1vdW50LAoJIHNlcXVlbmNlID0gTy5mcm9tX2hleCgnZmZmZmZmZmYnKSwKCSAtLXNjcmlwdFB1YktleSA9IHVuc3BlbnRbaV0uc2NyaXB0UHViS2V5CiAgICAgIH0KICAgICAgaT1pKzEKICAgZW5kCiAgIGlmIGN1cnJlbnRBbW91bnQgPCBhbW91bnQrZmVlIG9yIGk9PTEgdGhlbgogICAgICAtLSBOb3QgZW5vdWdoIEJUQwogICAgICByZXR1cm4gbmlsCiAgIGVuZAoKICAgLS0gQWRkIGV4YWN0bHkgdHdvIG91dHB1dHMsIG9uZSBmb3IgdGhlIHJlY2VpdmVyIGFuZCBvbmUgZm9yIHRoZSBleGNlZGluZyBhbW91bnQKICAgdHgudHhPdXRbMV0gPSB7CiAgICAgIGFtb3VudCA9IGFtb3VudCwKICAgICAgYWRkcmVzcyA9IHRvCiAgIH0KCiAgIGlmIGN1cnJlbnRBbW91bnQgPiBhbW91bnQrZmVlIHRoZW4KICAgICAgdHgudHhPdXRbMl0gPSB7CgkgYW1vdW50ID0gY3VycmVudEFtb3VudC1hbW91bnQtZmVlLAoJIGFkZHJlc3MgPSB0eC50eEluWzFdLmFkZHJlc3MKICAgICAgfQogICBlbmQKCiAgIHJldHVybiB0eAplbmQKCi0tIDEgQlRDID0gMWU4IHNhdG9zaGkKLS0gQHBhcmFtIHZhbHVlIG51bWJlciBvZiBCVEMgYXMgc3RyaW5nIChkaWdpdHMgd2l0aCBhIGRvdCkKLS0gQHJldHVybiBudW1iZXIgb2Ygc2F0aG9zaSBhcyB6ZW5yb29tLmJpZwpmdW5jdGlvbiBidGMudmFsdWVfYnRjX3RvX3NhdG9zaGkodmFsdWUpCiAgIHBvcyA9IHZhbHVlOmZpbmQoIiUuIikKICAgZGVjaW1hbHMgPSB2YWx1ZTpzdWIocG9zKzEsICN2YWx1ZSkKCiAgIGlmICNkZWNpbWFscyA+IDggdGhlbgogICAgICBlcnJvcigiU2F0b3NoaSBpcyB0aGUgc21hbGxlc3QgdW5pdCBvZiBtZWFzdXJlIikKICAgZW5kCgogICBkZWNpbWFscyA9IGRlY2ltYWxzIC4uIHN0cmluZy5yZXAoIjAiLCA4LSNkZWNpbWFscykKCiAgIHJldHVybiBCSUcuZnJvbV9kZWNpbWFsKHZhbHVlOnN1YigxLCBwb3MtMSkgLi4gZGVjaW1hbHMpCmVuZAoKLS0gMSBCVEMgPSAxZTggc2F0b3NoaQotLSBAcGFyYW0gdmFsdWUgbnVtYmVyIG9mIHNhdGhvc2kgYXMgemVucm9vbS5iaWcKLS0gQHJldHVybiBudW1iZXIgb2YgQlRDIGFzIHN0cmluZyAoZGlnaXRzIHdpdGggYSBkb3QpCmZ1bmN0aW9uIGJ0Yy52YWx1ZV9zYXRvc2hpX3RvX2J0Yyh2YWx1ZSkKICAgbG9jYWwgc3RyX3ZhbHVlID0gdmFsdWU6ZGVjaW1hbCgpCiAgIGxvY2FsIGxlbiA9ICNzdHJfdmFsdWUKICAgbG9jYWwgc3RyX2J0YzsKCiAgIGlmIGxlbiA8PSA4IHRoZW4KICAgICAgc3RyX2J0YyA9ICcwLic7CiAgICAgIGZvciBpPTEsOC1sZW4sMSBkbwoJIHN0cl9idGMgPSBzdHJfYnRjIC4uICcwJwogICAgICBlbmQKICAgICAgc3RyX2J0YyA9IHN0cl9idGMgLi4gc3RyX3ZhbHVlCiAgIGVsc2UKICAgICAgc3RyX2J0YyA9IHN0cmluZy5zdWIoc3RyX3ZhbHVlLCAxLCBsZW4tOCkgLi4gJy4nIC4uIHN0cmluZy5zdWIoc3RyX3ZhbHVlLCBsZW4tNywgbGVuKQogICBlbmQKCiAgIHN0cl9idGMgPSBzdHJpbmcuZ3N1YihzdHJfYnRjLCAnJS4/MCokJywgJycpCgogICByZXR1cm4gc3RyX2J0YwplbmQKCi0tIGZ1bmN0aW9uIHJhd1RyYW5zYWN0aW9uRnJvbUpTT04oZGF0YSwgc2spCi0tICAgIGxvY2FsIG9iaiA9IEpTT04uZGVjb2RlKGRhdGEpCi0tICAgIGxvY2FsIHNrID0gYnRjLnJlYWRfd2lmX3ByaXZhdGVfa2V5KHNrKQoKLS0gICAgZm9yIGssIHYgaW4gcGFpcnMob2JqLnVuc3BlbnQpIGRvCi0tICAgICAgIHYudHhpZCA9IE8uZnJvbV9oZXgodi50eGlkKQotLSAgICAgICB2LmFtb3VudCA9IHZhbHVlU2F0b3NoaVRvQlRDKHYuYW1vdW50KQotLSAgICBlbmQKCi0tICAgIGxvY2FsIHR4ID0gYnRjLmJ1aWxkX3R4X2Zyb21fdW5zcGVudChvYmoudW5zcGVudCwgc2ssIG9iai50bywgYnRjLmJpZ19mcm9tX3N0cmluZyhvYmouYW1vdW50KSwgYnRjLmJpZ19mcm9tX3N0cmluZyhvYmouZmVlKSkKCi0tICAgIHR4LndpdG5lc3MgPSBidGMuYnVpbGRfd2l0bmVzcyh0eCwgc2spCgotLSAgICBsb2NhbCByYXdUeCA9IGJ0Yy5idWlsZF9yYXdfdHJhbnNhY3Rpb24odHgpCgotLSAgICByZXR1cm4gcmF3VHgKLS0gZW5kCgoKcmV0dXJuIGJ0YwovY3J5cHRvX2NyZWRlbnRpYWwubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLVdyaXR0ZW4gYnkgRGVuaXMgUm9pbyBhbmQgQWxiZXJ0byBTb25uaW5vCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFR1ZXNkYXksIDIwdGggSnVseSAyMDIxCi0tXV0KCi0tIFplcm8tS25vd2xlZGdlIHByb29mIHNjaGVtZSBiYXNlZCBvbiBDb2NvbnV0Ci0tCi0tIENvY29udXQgaXMgYSBzZWxlY3RpdmUgZGlzY2xvc3VyZSBjcmVkZW50aWFsIHNjaGVtZSBzdXBwb3J0aW5nIHB1YmxpYwotLSBhbmQgcHJpdmF0ZSBhdHRyaWJ1dGVzLCByZS1yYW5kb21pemF0aW9uLCBhbmQgbXVsdGlwbGUgdW5saW5rYWJsZQotLSBzZWxlY3RpdmUgYXR0cmlidXRlIHJldmVsYXRpb25zLgoKbG9jYWwgY3JlZGVudGlhbCA9IHt9Cgpsb2NhbCBHMSA9IEVDUC5nZW5lcmF0b3IoKSAtLSByZXR1cm4gdmFsdWUKbG9jYWwgRzIgPSBFQ1AyLmdlbmVyYXRvcigpIC0tIHJldHVybiB2YWx1ZQoKLS0gbG9jYWwgemVyby1rbm93bGVkZ2UgcHJvb2YgdmVyaWZpY2F0aW9ucwpsb2NhbCBmdW5jdGlvbiBtYWtlX3BpX3MoZ2FtbWEsIGNvbW1pdCwgaywgciwgbSkKICAgbG9jYWwgd2sgPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgd20gPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgd3IgPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgQXcgPSBHMSAqIHdrCiAgIGxvY2FsIEJ3ID0gZ2FtbWEgKiB3ayArIGNvbW1pdCAqIHdtCiAgIGxvY2FsIEN3ID0gRzEgKiB3ciArIFNBTFQgKiB3bQogICBsb2NhbCBjID0gWktQX2NoYWxsZW5nZSh7Y29tbWl0LCBBdywgQncsIEN3fSkKICAgLS0gcmV0dXJuIHBpX3MKICAgcmV0dXJuIHsKICAgICAgY29tbWl0ID0gYywKICAgICAgcmsgPSB3ayAtIGMgKiBrLAogICAgICBybSA9IHdtIC0gYyAqIG0sCiAgICAgIHJyID0gd3IgLSBjICogcgogICB9CmVuZAoKZnVuY3Rpb24gY3JlZGVudGlhbC52ZXJpZnlfcGlfcyhsKQogICBsb2NhbCBBdyA9IGwuc2lnbi5hICogbC5waV9zLmNvbW1pdCArIEcxICogbC5waV9zLnJrCiAgIGxvY2FsIEJ3ID0KICAgICAgbC5zaWduLmIgKiBsLnBpX3MuY29tbWl0ICsgbC5wdWJsaWMgKiBsLnBpX3MucmsgKwogICAgICBsLmNvbW1pdCAqIGwucGlfcy5ybQogICBsb2NhbCBDdyA9CiAgICAgIGwuY29tbWl0ICogbC5waV9zLmNvbW1pdCArIEcxICogbC5waV9zLnJyICsgU0FMVCAqIGwucGlfcy5ybQogICAtLSByZXR1cm4gYSBib29sIGZvciBhc3NlcnQKICAgcmV0dXJuIGwucGlfcy5jb21taXQgPT0gWktQX2NoYWxsZW5nZSh7bC5jb21taXQsIEF3LCBCdywgQ3d9KQplbmQKCi0tIFB1YmxpYyBDb2NvbnV0IEFQSQpmdW5jdGlvbiBjcmVkZW50aWFsLmlzc3Vlcl9rZXlnZW4oKQogICByZXR1cm4gewogICAgICB4ID0gSU5ULnJhbmRvbSgpLAogICAgICB5ID0gSU5ULnJhbmRvbSgpCiAgIH0KZW5kCgpmdW5jdGlvbiBjcmVkZW50aWFsLmFnZ3JlZ2F0ZV9rZXlzKGtleXMpCiAgIGxvY2FsIGFnZ19hbHBoYSA9IGtleXNbMV0uYWxwaGEKICAgbG9jYWwgYWdnX2JldGEgPSBrZXlzWzFdLmJldGEKICAgaWYgI2tleXMgPiAxIHRoZW4KICAgICAgZm9yIGkgPSAyLCAja2V5cyBkbwogICAgICAgICBhZ2dfYWxwaGEgPSBhZ2dfYWxwaGEgKyBrZXlzW2ldLmFscGhhCiAgICAgICAgIGFnZ19iZXRhID0gYWdnX2JldGEgKyBrZXlzW2ldLmJldGEKICAgICAgZW5kCiAgIGVuZAogICAtLSByZXR1cm4gYWdna2V5cwogICByZXR1cm4gewogICAgICBhbHBoYSA9IGFnZ19hbHBoYSwKICAgICAgYmV0YSA9IGFnZ19iZXRhCiAgIH0KZW5kCgpmdW5jdGlvbiBjcmVkZW50aWFsLnByZXBhcmVfYmxpbmRfc2lnbihzZWNyZXQpCiAgIGxvY2FsIGdhbW1hID0gRzEgKiBzZWNyZXQKICAgbG9jYWwgbSA9IElOVC5uZXcoc2hhMjU2KHNlY3JldCkpICUgRUNQLm9yZGVyKCkKICAgLS0gRWxHYW1hbCBjb21taXRtZW50CiAgIGxvY2FsIHIgPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgY29tbWl0ID0gRzEgKiByICsgU0FMVCAqIG0KICAgbG9jYWwgayA9IElOVC5yYW5kb20oKQogICBsb2NhbCBzaWduID0gewogICAgICBhID0gRzEgKiBrLAogICAgICBiID0gZ2FtbWEgKiBrICsgY29tbWl0ICogbQogICB9CiAgIC0tIGNhbGN1bGF0ZSB6ZXJvIGtub3dsZWRnZSBwcm9vZnMKICAgbG9jYWwgcGlfcyA9IG1ha2VfcGlfcyhnYW1tYSwgY29tbWl0LCBrLCByLCBtKQogICAtLSByZXR1cm4gTGFtYmRhCiAgIHJldHVybiB7CiAgICAgIGNvbW1pdCA9IGNvbW1pdCwKICAgICAgc2lnbiA9IHNpZ24sCiAgICAgIHBpX3MgPSBwaV9zLAogICAgICBwdWJsaWMgPSBnYW1tYQogICB9CmVuZAoKZnVuY3Rpb24gY3JlZGVudGlhbC5ibGluZF9zaWduKHNrLCBMYW1iZGEpCiAgIGFzc2VydCgKICAgICAgY3JlZGVudGlhbC52ZXJpZnlfcGlfcyhMYW1iZGEpLAogICAgICAnWmVybyBrbm93bGVkZ2UgcHJvb2YgZG9lcyBub3QgdmVyaWZ5IChMYW1iZGEucGlfcyknLAogICAgICAyCiAgICkKICAgbG9jYWwgaCA9IExhbWJkYS5jb21taXQKICAgbG9jYWwgYV90aWxkZSA9IExhbWJkYS5zaWduLmEgKiBzay55CiAgIGxvY2FsIGJfdGlsZGUgPSBoICogc2sueCArIExhbWJkYS5zaWduLmIgKiBzay55CiAgIC0tIHNpZ21hIHRpbGRlCiAgIHJldHVybiB7CiAgICAgIGggPSBoLAogICAgICBhX3RpbGRlID0gYV90aWxkZSwKICAgICAgYl90aWxkZSA9IGJfdGlsZGUKICAgfQplbmQKCmZ1bmN0aW9uIGNyZWRlbnRpYWwuYWdncmVnYXRlX2NyZWRzKHNrLCBzaWdtYV90aWxkZSkKICAgbG9jYWwgYWdnX3MgPSBuaWwKICAgbG9jYWwgZmlyc3RfaCA9IG5pbAogICBmb3Igayx2IGluIHBhaXJzKHNpZ21hX3RpbGRlKSBkbwoJICBpZiBub3QgYWdnX3MgdGhlbgoJCSBhZ2dfcyA9IHYuYl90aWxkZSAtIHYuYV90aWxkZSAqIHNrCgkJIGZpcnN0X2ggPSB2LmgKCSAgZWxzZQogICAgICAgICBhZ2dfcyA9CiAgICAgICAgICAgIGFnZ19zICsgdi5iX3RpbGRlIC0gdi5hX3RpbGRlICogc2sKICAgICAgZW5kCiAgIGVuZAogICAtLSBhZ2dyZWdhdGVkIHNpZ21hCiAgIHJldHVybiB7CiAgICAgIGggPSBmaXJzdF9oLAogICAgICBzID0gYWdnX3MKICAgfQplbmQKCmZ1bmN0aW9uIGNyZWRlbnRpYWwucHJvdmVfY3JlZCh2ZXJpZnksIHNpZ21hLCBzZWNyZXQpCiAgIGxvY2FsIG0gPSBJTlQubmV3KHNoYTI1NihzZWNyZXQpKSAlIEVDUC5vcmRlcigpCiAgIGxvY2FsIHIgPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgcl9wcmltZSA9IElOVC5yYW5kb20oKQogICBsb2NhbCBzaWdtYV9wcmltZSA9IHsKICAgICAgaF9wcmltZSA9IHNpZ21hLmggKiByX3ByaW1lLAogICAgICBzX3ByaW1lID0gc2lnbWEucyAqIHJfcHJpbWUKICAgfQogICBsb2NhbCBrYXBwYSA9IHZlcmlmeS5hbHBoYSArIHZlcmlmeS5iZXRhICogbSArIEcyICogcgogICBsb2NhbCBudSA9IHNpZ21hX3ByaW1lLmhfcHJpbWUgKiByCiAgIGxvY2FsIHdtID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIHdyID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIGNoYWxsZW5nZSA9CiAgICAgIFpLUF9jaGFsbGVuZ2UoCiAgICAgIHsKICAgICAgICAgdmVyaWZ5LmFscGhhLAogICAgICAgICB2ZXJpZnkuYmV0YSwKICAgICAgICAgdmVyaWZ5LmFscGhhICsgRzIgKiB3ciArIHZlcmlmeS5iZXRhICogd20sIC0tIEF3CiAgICAgICAgIHNpZ21hX3ByaW1lLmhfcHJpbWUgKiB3cgogICAgICB9CiAgICkgLS0gQncKICAgLS0gcmV0dXJuIFRoZXRhCiAgIHJldHVybiB7CiAgICAgIGthcHBhID0ga2FwcGEsCiAgICAgIG51ID0gbnUsCiAgICAgIHNpZ21hX3ByaW1lID0gc2lnbWFfcHJpbWUsCiAgICAgIHBpX3YgPSB7CiAgICAgICAgIGMgPSBjaGFsbGVuZ2UsCiAgICAgICAgIHJyID0gd3IgLSByICogY2hhbGxlbmdlLAogICAgICAgICBybSA9IHdtIC0gbSAqIGNoYWxsZW5nZQogICAgICB9CiAgIH0KZW5kCgpmdW5jdGlvbiBjcmVkZW50aWFsLnZlcmlmeV9jcmVkKHZlcmlmeSwgVGhldGEpCiAgIGlmICN2ZXJpZnkgPT0gMSB0aGVuCiAgICAgIHZlcmlmeSA9IHZlcmlmeVsxXQogICBlbmQgLS0gc2luZ2xlIGVsZW1lbnQgaW4gYXJyYXkKICAgLS0gdmVyaWZ5IHBpX3YKICAgbG9jYWwgQXcgPQogICAgICBUaGV0YS5rYXBwYSAqIFRoZXRhLnBpX3YuYyArIEcyICogVGhldGEucGlfdi5yciArCiAgICAgIHZlcmlmeS5hbHBoYSAqIChCSUcubmV3KDEpIC0gVGhldGEucGlfdi5jKSArCiAgICAgIHZlcmlmeS5iZXRhICogVGhldGEucGlfdi5ybQogICBsb2NhbCBCdyA9CiAgICAgIFRoZXRhLm51ICogVGhldGEucGlfdi5jICsKICAgICAgVGhldGEuc2lnbWFfcHJpbWUuaF9wcmltZSAqIFRoZXRhLnBpX3YucnIKICAgLS0gY2hlY2sgemVybyBrbm93bGVkZ2UgcHJvb2YKICAgYXNzZXJ0KAogICAgICBUaGV0YS5waV92LmMgPT0gWktQX2NoYWxsZW5nZSh7dmVyaWZ5LmFscGhhLCB2ZXJpZnkuYmV0YSwgQXcsIEJ3fSksCiAgICAgICdjcmVkZW50aWFsIHZlcmlmaWNhdGlvbjogaW52YWxpZCBjaGFsbGVuZ2UnLAogICAgICAyCiAgICkKICAgYXNzZXJ0KAogICAgICBub3QgVGhldGEuc2lnbWFfcHJpbWUuaF9wcmltZTppc2luZigpLAogICAgICAnY3JlZGVudGlhbCB2ZXJpZmljYXRpb246IGludmFsaWQgc2lnbmF0dXJlIChpbmZpbml0ZSBzaWdtYSknLAogICAgICAyCiAgICkKICAgYXNzZXJ0KAogICAgICBFQ1AyLm1pbGxlcihUaGV0YS5rYXBwYSwgVGhldGEuc2lnbWFfcHJpbWUuaF9wcmltZSkgPT0KICAgICAgICAgRUNQMi5taWxsZXIoRzIsIFRoZXRhLnNpZ21hX3ByaW1lLnNfcHJpbWUgKyBUaGV0YS5udSksCiAgICAgICdjcmVkZW50aWFsIHZlcmlmaWNhdGlvbjogaW52YWxpZCBzaWduYXR1cmUgKG1pbGxlciBsb29wKScsCiAgICAgIDIKICAgKQogICByZXR1cm4gdHJ1ZQplbmQKCmZ1bmN0aW9uIGNyZWRlbnRpYWwucHJvdmVfY3JlZF91aWQodmssIHNpZ21hLCBzZWNyZXQsIHVpZCkKICAgbG9jYWwgbSA9IElOVC5uZXcoc2hhMjU2KHNlY3JldCkpICUgRUNQLm9yZGVyKCkKICAgbG9jYWwgciA9IElOVC5yYW5kb20oKQogICAtLSBtYXRlcmlhbAogICBsb2NhbCByX3ByaW1lID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIHNpZ21hX3ByaW1lID0gewogICAgICBoX3ByaW1lID0gc2lnbWEuaCAqIHJfcHJpbWUsCiAgICAgIHNfcHJpbWUgPSBzaWdtYS5zICogcl9wcmltZQogICB9CiAgIGxvY2FsIGthcHBhID0gdmsuYWxwaGEgKyB2ay5iZXRhICogbSArIEcyICogcgogICBsb2NhbCBudSA9IHNpZ21hX3ByaW1lLmhfcHJpbWUgKiByCiAgIGxvY2FsIHpldGEgPSBtICogRUNQLmhhc2h0b3BvaW50KHVpZCkKICAgLS0gcHJvb2YgLS0KICAgLS0gY3JlYXRlIHRoZSB3aXRuZXNzZXNzCiAgIGxvY2FsIHdtID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIHdyID0gSU5ULnJhbmRvbSgpCiAgIC0tIGNvbXB1dGUgdGhlIHdpdG5lc3Nlc3MgY29tbWl0bWVudHMKICAgbG9jYWwgQXcgPSB2ay5hbHBoYSArIHZrLmJldGEgKiB3bSArIEcyICogd3IKICAgbG9jYWwgQncgPSBzaWdtYV9wcmltZS5oX3ByaW1lICogd3IKICAgbG9jYWwgQ3cgPSB3bSAqIEVDUC5oYXNodG9wb2ludCh1aWQpCiAgIC0tIGNyZWF0ZSB0aGUgY2hhbGxlbmdlCiAgIGxvY2FsIGMgPSBaS1BfY2hhbGxlbmdlKHt2ay5hbHBoYSwgdmsuYmV0YSwgQXcsIEJ3LCBDd30pCiAgIC0tIGNyZWF0ZSByZXNwb25zZXMKICAgbG9jYWwgcGlfdiA9IHsKICAgICAgYyA9IGMsCiAgICAgIHJtID0gd20gLSBtICogYywKICAgICAgcnIgPSB3ciAtIHIgKiBjCiAgIH0KICAgbG9jYWwgVGhldGEgPSB7CiAgICAgIGthcHBhID0ga2FwcGEsCiAgICAgIG51ID0gbnUsCiAgICAgIHNpZ21hX3ByaW1lID0gc2lnbWFfcHJpbWUsCiAgICAgIHBpX3YgPSBwaV92CiAgIH0KICAgcmV0dXJuIFRoZXRhLCB6ZXRhCmVuZAoKZnVuY3Rpb24gY3JlZGVudGlhbC52ZXJpZnlfY3JlZF91aWQodmssIHRoZXRhLCB6ZXRhLCB1aWQpCiAgIC0tIHJlY29tcHV0ZSB3aXRuZXNzZXNzIGNvbW1pdG1lbnRzCiAgIGxvY2FsIEF3ID0KICAgICAgdGhldGEua2FwcGEgKiB0aGV0YS5waV92LmMgKyBHMiAqIHRoZXRhLnBpX3YucnIgKwogICAgICB2ay5hbHBoYSAqIChCSUcubmV3KDEpIC0gdGhldGEucGlfdi5jKSArCiAgICAgIHZrLmJldGEgKiB0aGV0YS5waV92LnJtCiAgIGxvY2FsIEJ3ID0KICAgICAgdGhldGEucGlfdi5yciAqIHRoZXRhLnNpZ21hX3ByaW1lLmhfcHJpbWUgKwogICAgICB0aGV0YS5udSAqIHRoZXRhLnBpX3YuYwogICBsb2NhbCBDdyA9IHRoZXRhLnBpX3Yucm0gKiBFQ1AuaGFzaHRvcG9pbnQodWlkKSArIHpldGEgKiB0aGV0YS5waV92LmMKICAgLS0gY29tcHV0ZSB0aGUgY2hhbGxlbmdlIHByaW1lCiAgIGFzc2VydCgKICAgICAgdGhldGEucGlfdi5jID09IFpLUF9jaGFsbGVuZ2Uoe3ZrLmFscGhhLCB2ay5iZXRhLCBBdywgQncsIEN3fSksCiAgICAgICdjcmVkZW50aWFsIHZlcmlmaWNhdGlvbjogaW52YWxpZCBjaGFsbGVuZ2UgZm9yIFVJRCcsCiAgICAgIDIKICAgKQogICAtLSB2ZXJpZnkgc2lnbmF0dXJlIC0tCiAgIGFzc2VydCgKICAgICAgbm90IHRoZXRhLnNpZ21hX3ByaW1lLmhfcHJpbWU6aXNpbmYoKSwKICAgICAgJ2NyZWRlbnRpYWwgdmVyaWZpY2F0aW9uOiBpbnZhbGlkIHNpZ25hdHVyZSAoaW5maW5pdGUgc2lnbWEpIGZvciBVSUQnLAogICAgICAyCiAgICkKICAgYXNzZXJ0KAogICAgICBFQ1AyLm1pbGxlcih0aGV0YS5rYXBwYSwgdGhldGEuc2lnbWFfcHJpbWUuaF9wcmltZSkgPT0KICAgICAgICAgRUNQMi5taWxsZXIoRzIsIHRoZXRhLnNpZ21hX3ByaW1lLnNfcHJpbWUgKyB0aGV0YS5udSksCiAgICAgICdjcmVkZW50aWFsIHZlcmlmaWNhdGlvbjogaW52YWxpZCBzaWduYXR1cmUgKG1pbGxlciBsb29wKSBmb3IgVUlEJywKICAgICAgMgogICApCiAgIHJldHVybiB0cnVlCmVuZAoKcmV0dXJuIGNyZWRlbnRpYWwKL2NyeXB0b19lbGdhbWFsLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBUdWVzZGF5LCAyMHRoIEp1bHkgMjAyMQotLV1dCgotLSBFbGdhbWFsIGJhc2VkIEFkZGl0aXZlIEhvbW9tb3JwaGljIGNvbW1pdG1lbnQgc2NoZW1lIAoKbG9jYWwgZWxnYWggPSB7CiAgIF9WRVJTSU9OID0gJ2NyeXB0b19lbGdhbWFsLmx1YSAwLjUnLAogICBfVVJMID0gJ2h0dHBzOi8vemVucm9vbS5keW5lLm9yZycsCiAgIF9ERVNDUklQVElPTiA9ICdFbGdhbWFsIGJhc2VkIEFkZGl0aXZlIEhvbW9tb3JwaGljIGNvbW1pdG1lbnQgc2NoZW1lICcsCiAgIF9MSUNFTlNFID0gW1sKTGljZW5zZWQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgUHVibGljIExpY2Vuc2UgYXMgcHVibGlzaGVkIGJ5CnRoZSBGcmVlIFNvZnR3YXJlIEZvdW5kYXRpb247IGVpdGhlciB2ZXJzaW9uIDMgb2YgdGhlIExpY2Vuc2UsIG9yCihhdCB5b3VyIG9wdGlvbikgYW55IGxhdGVyIHZlcnNpb24uICBVbmxlc3MgcmVxdWlyZWQgYnkgYXBwbGljYWJsZQpsYXcgb3IgYWdyZWVkIHRvIGluIHdyaXRpbmcsIHNvZnR3YXJlIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlCmlzIGRpc3RyaWJ1dGVkIG9uIGFuICJBUyBJUyIgQkFTSVMsIFdJVEhPVVQgV0FSUkFOVElFUyBPUgpDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLgpdXQp9Cgpsb2NhbCBHID0gRUNQLmdlbmVyYXRvcigpIC0tIHJldHVybiB2YWx1ZQpsb2NhbCBPICA9IEVDUC5vcmRlcigpIC0tIHJldHVybiB2YWx1ZQoKCi0tIHN0YXRlZnVsIGNoYWxsZW5nZSBoYXJkY29kZWQgc3RyaW5nCmxvY2FsIGhzID0gRUNQLmhhc2h0b3BvaW50KHN0cihbWwpKYXJvbWlsIHN0YXJ0ZWQgd3JpdGluZyB0aGlzIGNvZGUgb24gVHVlc2RheSAyMXN0IEphbnVhcnkgMjAyMApdXSAuLiBlbGdhaC5fTElDRU5TRSkpCmxvY2FsIGNoYWxsZW5nZSA9IEc6b2N0ZXQoKSAuLiBoczpvY3RldCgpCmxvY2FsIGZ1bmN0aW9uIHRvX2NoYWxsZW5nZShsaXN0KQogICBsb2NhbCBzZXIgPSBzZXJpYWxpemUobGlzdCkKICAgcmV0dXJuIElOVC5uZXcoIHNoYTI1NiggY2hhbGxlbmdlIC4uIHNlci5vY3RldHMgLi4gT0NURVQuZnJvbV9zdHJpbmcoc2VyLnN0cmluZ3MpKSkKZW5kCgpmdW5jdGlvbiBlbGdhaC5rZXlnZW4oKQoJICBsb2NhbCByZXMgPSB7IHByaXZhdGUgPSBJTlQucmFuZG9tKCkgfQoJICByZXMucHVibGljID0gRyAqIHJlcy5wcml2YXRlCgkgIHJldHVybihyZXMpCmVuZAoKZnVuY3Rpb24gZWxnYWgubmV3KHB1YiwgbSkKICAgLS0gc2lnbiA9PSB2b3RlCiAgIGxvY2FsIGsgPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgaHNtID0gaHMgKiBtIC0tIG9wdGltaXNhdGlvbgogICAtLSB2b3RlIGVuY3J5cHRpb24KICAgbG9jYWwgZW5jX3YgPSB7IGxlZnQgPSBHICogaywKCQkJCSAgIHJpZ2h0ID0gcHViICogayArIGhzbSB9CiAgIC0tIG9wcG9zaXRlIG9mIHZvdGUgZW5jcnlwdGlvbgogICBsb2NhbCBlbmNfdl9uZWcgPSB7IGxlZnQgPSBlbmNfdi5sZWZ0Om5lZ2F0aXZlKCksCgkJCQkJICAgcmlnaHQgPSBlbmNfdi5yaWdodDpuZWdhdGl2ZSgpICsgaHMgfQoKICAgLS0gY29tbWl0bWVudCB0byB0aGUgdm90ZQogICBsb2NhbCByID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIGN2ID0gRyAqIHIgKyBoc20KCiAgIC0tIHByb29mCiAgIC0tIGNyZWF0ZSB0aGUgd2l0bmVzZXNzCiAgIGxvY2FsIHdrID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIHdtID0gSU5ULnJhbmRvbSgpCiAgIGxvY2FsIHdyID0gSU5ULnJhbmRvbSgpCgogICBsb2NhbCBoc3dtID0gaHMgKiB3bSAtLSBvcHRpbWlzYXRpb24KICAgLS0gY29tcHV0ZSB0aGUgd2l0bmVzc2VzcyBjb21taXRtZW50cwogICBsb2NhbCBBdyA9IEcgICogd2sKICAgbG9jYWwgQncgPSBwdWIgKiB3ayArIGhzd20KICAgbG9jYWwgQ3cgPSBHICAqIHdyICsgaHN3bQoKICAgLS0gY3JlYXRlIHRoZSBjaGFsbGVuZ2UKICAgbG9jYWwgYyA9IHRvX2NoYWxsZW5nZSh7ZW5jX3YubGVmdCwgZW5jX3YucmlnaHQsCgkJCQkJCSAgIGN2LCBBdywgQncsIEN3fSkKICAgLS0gY3JlYXRlIHJlc3BvbnNlcwogICBsb2NhbCByayA9IHdrIC0gYyAqIGsKICAgbG9jYWwgcm0gPSB3bSAtIGMgKiBtCiAgIGxvY2FsIHJyID0gd3IgLSBjICogcgogICBsb2NhbCBwaSA9IHsgYyA9IGMsCgkJCQlyayA9IHJrLAoJCQkJcm0gPSBybSwKCQkJCXJyID0gcnIgfQoKICAgLS0gc2lnbmF0dXJlJ3MgVGhldGEKICAgcmV0dXJuIHsgdmFsdWUgPSB7IHBvcyA9IGVuY192LAoJCQkJCSAgbmVnID0gZW5jX3ZfbmVnIH0sIC0tIGxlZnQvcmlnaHQgdHVwbGVzCgkJCWN2ID0gY3YsIC0tIGVjcAoJCQlwaSA9IHBpIH0gLS0gcGkKZW5kCgpmdW5jdGlvbiBlbGdhaC52ZXJpZnkocHViLCB0aGV0YSkKICAgLS0gcmVjb21wdXRlIHdpdG5lc3Nlc3MgY29tbWl0bWVudAogICB6ZW5jb2RlX2Fzc2VydCh0aGV0YS5waSwgICAiRUxHQUgudmVyaWZ5IDFzdCBhcmd1bWVudCBoYXMgbm8gcHJvb2YiKQogICB6ZW5jb2RlX2Fzc2VydCh0aGV0YS52YWx1ZSwiRUxHQUgudmVyaWZ5IDJuZCBhcmd1bWVudCBoYXMgbm8gdmFsdWUiKQoKICAgbG9jYWwgdmFsdWUgPSB0aGV0YS52YWx1ZS5wb3MKICAgbG9jYWwgQXcgPSBHICogdGhldGEucGkucmsKCSAgKyB2YWx1ZS5sZWZ0ICogdGhldGEucGkuYwogICBsb2NhbCBCdyA9IHB1YiAqIHRoZXRhLnBpLnJrCgkgICsgaHMgKiB0aGV0YS5waS5ybQoJICArIHZhbHVlLnJpZ2h0ICogdGhldGEucGkuYwogICBsb2NhbCBDdyA9IEcgKiB0aGV0YS5waS5ycgoJICArIGhzICogdGhldGEucGkucm0KCSAgKyB0aGV0YS5jdiAqIHRoZXRhLnBpLmMKICAgLS0gdmVyaWZ5IGNoYWxsZW5nZQogICB6ZW5jb2RlX2Fzc2VydCh0aGV0YS5waS5jID09IHRvX2NoYWxsZW5nZSgKCQkJCSB7dmFsdWUubGVmdCwgdmFsdWUucmlnaHQsCgkJCQkgIHRoZXRhLmN2LCBBdywgQncsIEN3IH0pLAoJCQkgICJFTEdBSC52ZXJpZnk6IGNoYWxsZW5nZSBmYWlscyIpCiAgIHJldHVybiB0cnVlCmVuZAoKZnVuY3Rpb24gZWxnYWguemVybygpCiAgIHJldHVybiB7IHBvcyA9IHsgbGVmdCA9IEVDUC5pbmZpbml0eSgpLCByaWdodCA9IEVDUC5pbmZpbml0eSgpIH0sCgkJCW5lZyA9IHsgbGVmdCA9IEVDUC5pbmZpbml0eSgpLCByaWdodCA9IEVDUC5pbmZpbml0eSgpIH0gfQplbmQKCmZ1bmN0aW9uIGVsZ2FoLmFkZChwdWIsIGEsIGIpCiAgIGVsZ2FoLnZlcmlmeShwdWIsIGEpCiAgIGxvY2FsIHBvcyA9IHsgbGVmdCA9IG5pbCwgcmlnaHQgPSBuaWwgfQogICBsb2NhbCBuZWcgPSB7IGxlZnQgPSBuaWwsIHJpZ2h0ID0gbmlsIH0KICAgcG9zLmxlZnQgID0gYS52YWx1ZS5wb3MubGVmdCAgKyBiLnBvcy5sZWZ0CiAgIHBvcy5yaWdodCA9IGEudmFsdWUucG9zLnJpZ2h0ICsgYi5wb3MucmlnaHQKICAgbmVnLmxlZnQgID0gYS52YWx1ZS5uZWcubGVmdCAgKyBiLm5lZy5sZWZ0CiAgIG5lZy5yaWdodCA9IGEudmFsdWUubmVnLnJpZ2h0ICsgYi5uZWcucmlnaHQKICAgcmV0dXJuIHsgcG9zID0gcG9zLCBuZWcgPSBuZWcgfQplbmQKCmZ1bmN0aW9uIGVsZ2FoLnN1YihwdWIsIGEsIGIpCiAgIGVsZ2FoLnZlcmlmeShwdWIsIGEpCiAgIGxvY2FsIHBvcyA9IHsgbGVmdCA9IG5pbCwgcmlnaHQgPSBuaWwgfQogICBsb2NhbCBuZWcgPSB7IGxlZnQgPSBuaWwsIHJpZ2h0ID0gbmlsIH0KICAgcG9zLmxlZnQgID0gYS52YWx1ZS5wb3MubGVmdCAgLSBiLnBvcy5sZWZ0CiAgIHBvcy5yaWdodCA9IGEudmFsdWUucG9zLnJpZ2h0IC0gYi5wb3MucmlnaHQKICAgbmVnLmxlZnQgID0gYS52YWx1ZS5uZWcubGVmdCAgLSBiLm5lZy5sZWZ0CiAgIG5lZy5yaWdodCA9IGEudmFsdWUubmVnLnJpZ2h0IC0gYi5uZWcucmlnaHQKICAgcmV0dXJuIHsgcG9zID0gcG9zLCBuZWcgPSBuZWcgfQplbmQKCmZ1bmN0aW9uIGVsZ2FoLnRhbGx5KHB1YiwgcHJpdiwgbikKICAgbG9jYWwgd3ggPSBJTlQucmFuZG9tKCkKICAgbG9jYWwgQXcgPSB7IHd4Om1vZG5lZyhPKSAqIG4ucG9zLmxlZnQsCgkJCQl3eDptb2RuZWcoTykgKiBuLm5lZy5sZWZ0ICB9CiAgIGxvY2FsIGMgPSB0b19jaGFsbGVuZ2UoQXcpCiAgIGxvY2FsIHJ4ID0gd3ggLSBjICogcHJpdgogICBsb2NhbCBkZWMgPSB7IHBvcyA9IG4ucG9zLmxlZnQgKiBwcml2Om1vZG5lZyhPKSwKCQkJCSBuZWcgPSBuLm5lZy5sZWZ0ICogcHJpdjptb2RuZWcoTykgfQogICAtLSByZXR1cm4gcGlfdGFsbHkKICAgcmV0dXJuIHsgZGVjID0gZGVjLAoJCQlyeCAgPSByeCwKCQkJYyAgID0gYyAgIH0KZW5kCgpmdW5jdGlvbiBlbGdhaC52ZXJpZnlfdGFsbHkodGFsbHksIHZhbHVlKQogICBsb2NhbCByeG5lZyA9IHRhbGx5LnJ4Om1vZG5lZyhPKQogICBsb2NhbCBBdyA9IHsgcnhuZWcgKiB2YWx1ZS5wb3MubGVmdCArIHRhbGx5LmMgKiB0YWxseS5kZWMucG9zLAoJCQkJcnhuZWcgKiB2YWx1ZS5uZWcubGVmdCArIHRhbGx5LmMgKiB0YWxseS5kZWMubmVnICB9CiAgIHplbmNvZGVfYXNzZXJ0KHRhbGx5LmMgPT0gdG9fY2hhbGxlbmdlKEF3KSwKCQkgICJFTEdBSC52ZXJpZnlfdGFsbHk6IGNoYWxsZW5nZSBmYWlscyIpCiAgIHJldHVybiB0cnVlCmVuZAoKZnVuY3Rpb24gZWxnYWguY291bnQodGFsbHksIHZhbHVlLCBtYXgpCiAgIGVsZ2FoLnZlcmlmeV90YWxseSh0YWxseSwgdmFsdWUpCiAgIGxvY2FsIHJlc3RhYiA9IHsgfQogICBtYXggPSBtYXggb3IgMTAwMAogICBmb3IgaWR4PTEsbWF4IGRvCgkgIHJlc3RhYlsoQklHLm5ldyhpZHgpICogaHMpOm9jdGV0KCk6dXJsNjQoKV0gPSBpZHgKICAgZW5kCiAgIGxvY2FsIHJlcyA9IHsgcG9zID0gdmFsdWUucG9zLnJpZ2h0ICsgdGFsbHkuZGVjLnBvcywKCQkJCSBuZWcgPSB2YWx1ZS5uZWcucmlnaHQgKyB0YWxseS5kZWMubmVnICB9CiAgIHJldHVybiByZXN0YWJbcmVzLnBvczpvY3RldCgpOnVybDY0KCldCmVuZAoKcmV0dXJuIGVsZ2FoCi9jcnlwdG9fZXRoZXJldW0ubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIxLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IEFsYmVydG8gTGVyZGEgPGFsYmVydG9sZXJkYTk3QGdtYWlsLmNvbT4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCgpsb2NhbCBFVEggPSB7fQoKLS0gbnVtYmVyIHRvIG9jdGV0IChuMm8pLCB3ZXJlIG51bWJlciBpcyBhIGJpZyBpbnRlZ2VyCi0tIGluIFJMUCB0aGUgMCBpcyByZXBwcmVzZW50ZWQgYXMgdGhlIGVtcHR5IG9jdGV0CmZ1bmN0aW9uIEVUSC5uMm8obnVtKQogICBpZiBudW0gPT0gSU5ULm5ldygwKSB0aGVuCiAgICAgIHJldHVybiBPLmVtcHR5KCkKICAgZWxzZQogICAgICByZXR1cm4gbnVtOm9jdGV0KCkKICAgZW5kCmVuZAoKLS0gaWRlbSBmb3Igb2N0ZXQgdG8gbnVtYmVyIChvMm4pCmZ1bmN0aW9uIEVUSC5vMm4obykKICAgaWYgI28gPT0gMCB0aGVuCiAgICAgIHJldHVybiBJTlQubmV3KDApCiAgIGVsc2UKICAgICAgcmV0dXJuIElOVC5uZXcobykKICAgZW5kCmVuZAoKLS0gdGhlIGVtcHR5IG9jdGVjdCBpcyBlbmNvZGVkIGFzIG5pbAotLSBhIHRhYmxlIGNvbnRhaW5zIGluIHRoZSBmaXJzdCBwb3NpdGlvbiAoaS5lLiAxKSB0aGUgbnVtYmVyIG9mIGVsZW1lbnRzCmZ1bmN0aW9uIEVUSC5lbmNvZGVSTFAoZGF0YSkKICAgbG9jYWwgaGVhZGVyID0gbmlsCiAgIGxvY2FsIHJlcyA9IG5pbAogICBsb2NhbCBieXQgPSBuaWwKCiAgIGlmIHR5cGUoZGF0YSkgPT0gJ3plbnJvb20uYmlnJyB0aGVuCiAgICAgIGRhdGEgPSBFVEgubjJvKGRhdGEpCiAgIGVuZAoKICAgaWYgdHlwZShkYXRhKSA9PSAndGFibGUnIHRoZW4KICAgICAgLS0gZW1wdHkgb2N0ZXQKICAgICAgcmVzID0gTy5lbXB0eSgpCiAgICAgIGZvciBfLCB2IGluIHBhaXJzKGRhdGEpIGRvCgkgcmVzID0gcmVzIC4uIEVUSC5lbmNvZGVSTFAodikKICAgICAgZW5kCiAgICAgIGlmICNyZXMgPCA1NiB0aGVuCgkgcmVzID0gSU5ULm5ldygxOTIrI3Jlcyk6b2N0ZXQoKSAuLiByZXMKICAgICAgZWxzZQoJIC0tIExlbmd0aCBvZiB0aGUgcmVzdWx0IHRvIGJlIHNhdmVkIGJlZm9yZSB0aGUgYnl0ZXMgdGhlbXNlbHZlcwoJIGJ5dCA9IElOVC5uZXcoI3Jlcyk6b2N0ZXQoKQoJIGhlYWRlciA9IElOVC5uZXcoMjQ3KyNieXQpOm9jdGV0KCkgLi4gYnl0CgogICAgICBlbmQKICAgZWxzZWlmIGlzemVuKHR5cGUoZGF0YSkpIHRoZW4KICAgICAgcmVzID0gZGF0YTpvY3RldCgpCgogICAgICAtLSBpbmRleCBzaW5nbGUgYnl0ZXMgb2YgYW4gb2N0ZXQKICAgICAgbG9jYWwgYnl0ID0gSU5ULm5ldygwKQogICAgICBpZiAjcmVzID4gMCB0aGVuCgkgYnl0ID0gSU5ULm5ldyggcmVzOmNob3AoMSkgKQogICAgICBlbmQKCiAgICAgIGlmICNyZXMgfj0gMSBvciBieXQgPj0gSU5ULm5ldygxMjgpIHRoZW4KCSBpZiAjcmVzIDwgNTYgdGhlbgoJICAgIGhlYWRlciA9IElOVC5uZXcoMTI4KyNyZXMpOm9jdGV0KCkKCSBlbHNlCgkgICAgLS0gTGVuZ3RoIG9mIHRoZSByZXN1bHQgdG8gYmUgc2F2ZWQgYmVmb3JlIHRoZSBieXRlcyB0aGVtc2VsdmVzCgkgICAgYnl0ID0gSU5ULm5ldygjcmVzKTpvY3RldCgpCgkgICAgaGVhZGVyID0gSU5ULm5ldygxODMrI2J5dCk6b2N0ZXQoKSAuLiBieXQKCSBlbmQKICAgICAgZW5kCgogICBlbHNlCiAgICAgIGVycm9yKCJJbnZhbGlkIGRhdGEgdHlwZSBmb3IgRVRIIFJMUCBlbmNvZGVyOiAiLi50eXBlKGRhdGEpKQogICBlbmQKICAgaWYgaGVhZGVyIHRoZW4KICAgICAgcmVzID0gaGVhZGVyIC4uIHJlcwogICBlbmQKICAgcmV0dXJuIHJlcwplbmQKCgotLSBpIGlzIHRoZSBwb3NpdGlvbiBmcm9tIHdoaWNoIHdlIHN0YXJ0IHRvIHBhcnNlCi0tIHJldHVybiBhIHRhYmxlIHdpdGgKLS0gKiByZXMgd2hpY2ggaXMgdGhlIGNvbnRlbnQgcmVhZAotLSAqIGlkeCB3aGljaCBpcyB0aGUgcG9zaXRpb24gb2YgdGhlIG5leHQgYnl0ZSB0byByZWFkCmxvY2FsIGZ1bmN0aW9uIGRlY29kZVJMUGdlbmVyaWMocmxwLCBpKQogICBsb2NhbCBieXQsIGJ5dEludCwgcmVzLCBpZHgKCiAgIGJ5dCA9IHJscDpzdWIoaSwgaSkKICAgaWR4PWkrMQogICBieXRJbnQgPSB0b251bWJlcihieXQ6aGV4KCksIDE2KQoKICAgaWYgYnl0SW50IDwgMTI4IHRoZW4KICAgICAgcmVzID0gYnl0CiAgIGVsc2VpZiBieXRJbnQgPD0gMTgzIHRoZW4KICAgICAgaWR4ID0gaStieXRJbnQtMTI4KzEKICAgICAgaWYgYnl0SW50ID09IDEyOCB0aGVuCgkgcmVzID0gTy5lbXB0eSgpCiAgICAgIGVsc2UKCSByZXMgPSBybHA6c3ViKGkrMSwgaWR4LTEpCiAgICAgIGVuZAoKICAgZWxzZWlmIGJ5dEludCA8IDE5MiB0aGVuCiAgICAgIGxvY2FsIHNpemVFbmQgPSBieXRJbnQtMTgzOwogICAgICBsb2NhbCBzaXplID0gdG9udW1iZXIocmxwOnN1YihpKzEsIGkrc2l6ZUVuZCk6aGV4KCksIDE2KQogICAgICBpZHggPSBpK3NpemVFbmQrc2l6ZSsxCiAgICAgIHJlcyA9IHJscDpzdWIoaStzaXplRW5kKzEsIGlkeC0xKQogICBlbHNlIC0tIGl0IGlzIGEgdHVwbGUKICAgICAgbG9jYWwgagogICAgICBpZiBieXRJbnQgPD0gMjQ3IHRoZW4KCSBpZHggPSBpK2J5dEludC0xOTIrMSAtLSB0b3RhbCBudW1iZXIgb2YgYnl0ZXMKICAgICAgZWxzZSAtLSBkZWNvZGUgYmlnIGVuZGlhbiBlbmNvZGluZwoJIGxvY2FsIHNpemVFbmQKCSBzaXplRW5kID0gYnl0SW50LTI0NzsKCSBsb2NhbCBzaXplID0gdG9udW1iZXIocmxwOnN1YihpKzEsIGkrc2l6ZUVuZCk6aGV4KCksIDE2KQoJIGlkeCA9IGkrc2l6ZUVuZCtzaXplKzEKCSBpPWkrc2l6ZUVuZAogICAgICBlbmQKICAgICAgaT1pKzEgLS0gaW5pdGlhbCBwb3NpdGlvbgogICAgICBqPTEgLS0gaW5kZXggaW5zaWRlIHJlcwogICAgICByZXMgPSB7fQogICAgICAtLSBkZWNvZGUgdGhlIHR1cGxlIGluIGEgdGFibGUKICAgICAgd2hpbGUgaSA8IGlkeCBkbwoJIGxvY2FsIHJlYWROZXh0CgkgcmVhZE5leHQgPSBkZWNvZGVSTFBnZW5lcmljKHJscCwgaSkKCSByZXNbal0gPSByZWFkTmV4dC5yZXMKCSBqID0gaisxCgkgaSA9IHJlYWROZXh0LmlkeAogICAgICBlbmQKICAgZW5kCiAgIHJldHVybiB7CiAgICAgIHJlcz1yZXMsCiAgICAgIGlkeD1pZHgKICAgfQplbmQKCmZ1bmN0aW9uIEVUSC5kZWNvZGVSTFAocmxwKQogICByZXR1cm4gZGVjb2RlUkxQZ2VuZXJpYyhybHAsIDEpLnJlcwplbmQKCmZ1bmN0aW9uIEVUSC5lbmNvZGVUcmFuc2FjdGlvbih0eCkKICAgbG9jYWwgZmllbGRzID0ge3R4WyJub25jZSJdLCB0eFsiZ2FzX3ByaWNlIl0sIHR4WyJnYXNfbGltaXQiXSwgdHhbInRvIl0sCgkJICAgdHhbInZhbHVlIl0sIHR4WyJkYXRhIl0sIHR4WyJ2Il0sIHR4WyJyIl0sIHR4WyJzIl19CiAgIHJldHVybiBFVEguZW5jb2RlUkxQKGZpZWxkcykKZW5kCgpmdW5jdGlvbiBFVEguZGVjb2RlVHJhbnNhY3Rpb24ocmxwKQogICBsb2NhbCB0ID0gRVRILmRlY29kZVJMUChybHApCiAgIHJldHVybiB7CiAgICAgIG5vbmNlPUVUSC5vMm4odFsxXSksCiAgICAgIGdhc19wcmljZT1FVEgubzJuKHRbMl0pLAogICAgICBnYXNfbGltaXQ9RVRILm8ybih0WzNdKSwKICAgICAgdG89dFs0XSwKICAgICAgdmFsdWU9RVRILm8ybih0WzVdKSwKICAgICAgZGF0YT10WzZdLAogICAgICB2PUVUSC5vMm4odFs3XSksCiAgICAgIHI9dFs4XSwKICAgICAgcz10WzldCiAgIH0KZW5kCgotLSBTb2x2aW5nIElzc3VlICMzOTE6IGNoZWNrc3VtIGZvciBldGhlcmV1bSBhZGRyZXNzZXMKLS0gaHR0cHM6Ly9laXBzLmV0aGVyZXVtLm9yZy9FSVBTL2VpcC01NQpmdW5jdGlvbiBFVEguY2hlY2tzdW1fZW5jb2RlKGFkZHJlc3MpCiAgIGxvY2FsIGhleF9hZGRyID0gYWRkcmVzczpoZXgoKQogICBsb2NhbCBjaGVja3N1bW1lZF9idWZmZXIgPSAiIgogICBsb2NhbCBoYXNoZWRfYWRkcmVzcyA9IEhBU0gua2VjY2FrMjU2KGhleF9hZGRyKTpiaW4oKQogICBmb3IgaSA9IDEsICNoZXhfYWRkciBkbwogICAgICBsb2NhbCBjaGFyYWN0ZXIgPSBzdHJpbmcuc3ViKGhleF9hZGRyLCBpLCBpKQogICAgICBpZiBzdHJpbmcuZmluZCgiMDEyMzQ1Njc4OSIsIGNoYXJhY3RlcikgdGhlbgogICAgICAgICBjaGVja3N1bW1lZF9idWZmZXIgPSBjaGVja3N1bW1lZF9idWZmZXIuLmNoYXJhY3RlcgogICAgICBlbHNlaWYgc3RyaW5nLmZpbmQoImFiY2RlZiIsIGNoYXJhY3RlcikgdGhlbgogICAgICAgICBsb2NhbCBoYXNoZWRfYWRkcmVzc19uaWJibGUgPSBzdHJpbmcuc3ViKGhhc2hlZF9hZGRyZXNzLCA0KmkgLTMsIDQqaSAtMykKICAgICAgICAgaWYgaGFzaGVkX2FkZHJlc3NfbmliYmxlID09ICcxJyB0aGVuCiAgICAgICAgICAgIGNoZWNrc3VtbWVkX2J1ZmZlciA9IGNoZWNrc3VtbWVkX2J1ZmZlci4uc3RyaW5nLnVwcGVyKGNoYXJhY3RlcikKICAgICAgICAgZWxzZQogICAgICAgICAgICBjaGVja3N1bW1lZF9idWZmZXIgPSBjaGVja3N1bW1lZF9idWZmZXIuLmNoYXJhY3RlcgogICAgICAgICBlbmQKICAgICAgZWxzZQogICAgICAgICBlcnJvcigiVW5yZWNvZ25pemVkIGhleCBjaGFyYWN0ZXIgYXQgcG9zaXRpb24gIi4uaSwgMikKICAgICAgZW5kCiAgIGVuZAogICByZXR1cm4gIjB4Ii4uY2hlY2tzdW1tZWRfYnVmZmVyCmVuZAoKLS0gbW9kaWZ5IHRoZSBpbnB1dCB0cmFuc2FjdGlvbgpmdW5jdGlvbiBFVEguZW5jb2RlU2lnbmVkVHJhbnNhY3Rpb24oc2ssIHR4KQogICBsb2NhbCBILCB0eEhhc2gsIHNpZywgeV9wYXJpdHksIHR3bywgcmVzCiAgIHR4SGFzaCA9IEhBU0gua2VjY2FrMjU2KEVUSC5lbmNvZGVUcmFuc2FjdGlvbih0eCkpCgogICBzaWcsIHlfcGFyaXR5ID0gRUNESC5zaWduX2VjZGgoc2ssIHR4SGFzaCkKCiAgIHR3byA9IElOVC5uZXcoMikKCiAgIHJlcyA9IHR4CiAgIHJlcy52ID0gdHdvICogSU5ULm5ldyh0eC52KSArIElOVC5uZXcoMzUpCiAgIGlmIHlfcGFyaXR5IHRoZW4KICAgICByZXMudiA9IHJlcy52ICsgSU5ULm5ldygxKQogICBlbmQKICAgcmVzLnIgPSBJTlQubmV3KHNpZy5yKQogICByZXMucyA9IElOVC5uZXcoc2lnLnMpCgogICByZXR1cm4gRVRILmVuY29kZVRyYW5zYWN0aW9uKHJlcykKZW5kCgpsb2NhbCBmdW5jdGlvbiBoYXNoRnJvbVNpZ25lZFRyYW5zYWN0aW9uKHR4U2lnbmVkKQogICBsb2NhbCBmaWVsZHMsIEgsIHR4CiAgIGZpZWxkcyA9IHsibm9uY2UiLCAiZ2FzX3ByaWNlIiwgImdhc19saW1pdCIsICJ0byIsCgkgICAgICJ2YWx1ZSIsICJkYXRhIn0KCiAgIC0tIGNvbnN0cnVjdCB0aGUgdHJhbnNhY3Rpb24gd2hpY2ggd2FzIHNpZ25lZAogICB0eCA9IHt9CiAgIGZvciBfLCB2IGluIHBhaXJzKGZpZWxkcykgZG8KICAgICAgdHhbdl0gPSB0eFNpZ25lZFt2XQogICBlbmQKICAgdHhbInYiXSA9IElOVC5zaHIodHhTaWduZWRbInYiXS1JTlQubmV3KDM1KSwgMSkKICAgdHhbInIiXSA9IE8uZW1wdHkoKQogICB0eFsicyJdID0gTy5lbXB0eSgpCgogICBIID0gSEFTSC5uZXcoJ2tlY2NhazI1NicpCiAgIHJldHVybiBIQVNILmtlY2NhazI1NihFVEguZW5jb2RlVHJhbnNhY3Rpb24odHgpKQplbmQKCi0tIFZlcmlmeSB0aGUgc2lnbmF0dXJlIG9mIGEgdHJhbnNhY3Rpb24gd2hpY2ggaW1wbGVtZW50cyBFSVAtMTU1Ci0tIFNpbXBsZSByZXBsYXkgYXR0YWNrIHByb3RlY3Rpb24KLS0gaHR0cHM6Ly9naXRodWIuY29tL2V0aGVyZXVtL0VJUHMvYmxvYi9tYXN0ZXIvRUlQUy9laXAtMTU1Lm1kCmZ1bmN0aW9uIEVUSC52ZXJpZnlTaWduYXR1cmVUcmFuc2FjdGlvbihwaywgdHhTaWduZWQpCiAgIGxvY2FsIHR4SGFzaCA9IGhhc2hGcm9tU2lnbmVkVHJhbnNhY3Rpb24odHhTaWduZWQpCgogICBsb2NhbCBzaWcgPSB7CiAgICAgIHI9dHhTaWduZWRbInIiXSwKICAgICAgcz10eFNpZ25lZFsicyJdCiAgIH0KCiAgIHJldHVybiBFQ0RILnZlcmlmeV9oYXNoZWQocGssIHR4SGFzaCwgc2lnLCAjdHhIYXNoKQplbmQKCi0tIFRoaXMgZnVuY3Rpb24gZGVmYXVsdHMgdG8gc2lnbl9lY2RoX2RldGVybWluaXN0aWMgaWYgbm8gc2lnbl9mdW5jdGlvbiBpcyBwYXNzZWQuCi0tIE9uZSBtYXkgdXNlIHRoZSByYW5kb20gRUNEU0EgYnkgc3BlY2lmeWluZyB0aGUgInNpZ25fZnVuY3Rpb24iIHBhcmFtZXRlciBhcyAic2lnbl9lY2RoIi4KZnVuY3Rpb24gRVRILmVuY29kZVNpZ25lZERhdGEoc2ssIG1lc3NhZ2UsIHNpZ25fZnVuY3Rpb24pCiAgIGxvY2FsIGV0aGVyc01lc3NhZ2UgPSBPLmZyb21fc3RyaW5nKCJceDE5RXRoZXJldW0gU2lnbmVkIE1lc3NhZ2U6XG4iKSAuLiBPLm5ldygjbWVzc2FnZSkgLi4gbWVzc2FnZQogICBsb2NhbCBobXNnID0gSEFTSC5rZWNjYWsyNTYoZXRoZXJzTWVzc2FnZSkKICAgc2lnbl9mdW5jdGlvbiA9IHNpZ25fZnVuY3Rpb24gb3IgZnVuY3Rpb24oc2VjaywgbXNnKQogICAgICAgICByZXR1cm4gRUNESC5zaWduX2VjZGhfZGV0ZXJtaW5pc3RpYyhzZWNrLCBtc2csIDMyKSBlbmQKICAgbG9jYWwgc2lnLCB5X3BhciA9IHNpZ25fZnVuY3Rpb24oc2ssIGhtc2cpCgogICAtLSBJZiB5X3BhciA9IDAgPSBmYWxzZSB0aGVuIHlvdSB3cml0ZSAyNy4gT3RoZXJ3aXNlIDI4LgogICAtLSBTZWUgaHR0cHM6Ly9iaXRjb2luLnN0YWNrZXhjaGFuZ2UuY29tL2EvMTEyNDg5CiAgIGlmIHlfcGFyIHRoZW4KICAgICAgc2lnWyJ2Il0gPSBCSUcubmV3KDI4KQogICBlbHNlCiAgICAgIHNpZ1sidiJdID0gQklHLm5ldygyNykKICAgZW5kCgogICByZXR1cm4gc2lnCmVuZAoKCi0tIHZlcmlmeSB0aGUgc2lnbmF0dXJlIG9mIGEgdHJhbnNhY3Rpb24gb25seSB3aXRoIHRoZSBhZGRyZXNzCmZ1bmN0aW9uIEVUSC52ZXJpZnlfc2lnbmF0dXJlX2Zyb21fYWRkcmVzcyhzaWduYXR1cmUsIGFkZHJlc3MsIHlfcGFyaXR5LCBoYXNoKQogICBsb2NhbCBwaywgdmFsaWQKCiAgIGxvY2FsIHggPSBJTlQubmV3KHNpZ25hdHVyZS5yKQogICBsb2NhbCBwID0gRUNESC5wcmltZSgpCiAgIGxvY2FsIG4gPSBFQ0RILm9yZGVyKCkKICAgbG9jYWwgaCA9IEVDREguY29mYWN0b3IoKSAtLWg9MQogICByZXBlYXQKCSAgIHBrLCB2YWxpZCA9IEVDREgucmVjb3ZlcnkoeDpvY3RldCgpLCB5X3Bhcml0eSwgaGFzaCwgc2lnbmF0dXJlKQoJICAgaWYgaCA+IDAgdGhlbiAgIC0tIGRvIG5vdCBhZGQgbiBsYXN0IGl0ZXJhdGlvbgoJCSAgIHggPSAoeCArIG4pICUgcAoJICAgZW5kCgkgICBoID0gaC0xCiAgIHVudGlsICh2YWxpZCBhbmQgRVRILmFkZHJlc3NfZnJvbV9wdWJsaWNfa2V5KHBrKSA9PSBhZGRyZXNzKSBvciAoaCA8IDApCgogICByZXR1cm4gKHZhbGlkIGFuZCBFVEguYWRkcmVzc19mcm9tX3B1YmxpY19rZXkocGspID09IGFkZHJlc3MpCmVuZAoKLS0gdmVyaWZ5IHRoZSBzaWduYXR1cmUgb2YgYSB0cmFuc2FjdGlvbiBvbmx5IHdpdGggdGhlIGFkZHJlc3MKZnVuY3Rpb24gRVRILnZlcmlmeV90cmFuc2FjdGlvbl9mcm9tX2FkZHJlc3MoYWRkLCB0eFNpZ25lZCkKICAgbG9jYWwgdHhIYXNoLCBzaWcsIHlfcGFyaXR5LCBwaywgdmFsaWQKICAgdHhIYXNoID0gaGFzaEZyb21TaWduZWRUcmFuc2FjdGlvbih0eFNpZ25lZCkKCiAgIHNpZyA9IHsKICAgICAgcj10eFNpZ25lZC5yLAogICAgICBzPXR4U2lnbmVkLnMKICAgfQoKICAgeV9wYXJpdHkgPSBmaWYodHhTaWduZWQudjpwYXJpdHkoKSwgMCwgMSkgLS0geV9wYXJpdHk9MCA8PT4gdjpwYXJpdHkoKT0xCgogICByZXR1cm4gRVRILnZlcmlmeV9zaWduYXR1cmVfZnJvbV9hZGRyZXNzKHNpZywgYWRkLCB5X3Bhcml0eSwgdHhIYXNoKQplbmQKCi0tIEFzc3VtZSB3ZSBhcmUgZ2l2ZW4gYSBzbWFydCBjb250cmFjdCB3aXRoIGEgZnVuY3Rpb24gd2l0aCB0aGUKLS0gZm9sbG93aW5nIHNpZ25hdHVyZQotLSBmdW5jdGlvbiB3cml0ZVN0cmluZyhzdHJpbmcgbWVtb3J5KQotLSBXZSBzZW5kIGEgc3RyaW5nIGFuZCB0aGUgc21hcnQgY29udHJhY3Qgc2lnbmFscyBhbiBldmVudAoKLS0gU21hcnQgY29udHJhY3QKLS0gLy8gU1BEWC1MaWNlbnNlLUlkZW50aWZpZXI6IEdQTC0zLjAKLS0gcHJhZ21hIHNvbGlkaXR5IF4wLjguNDsKCgotLSBjb250cmFjdCBTYXZlU3RyaW5nIHsKCi0tICAgICBldmVudCBTdHJpbmdTYXZlRXZlbnQoYWRkcmVzcyB1c2VyLCBzdHJpbmcgY29udGVudCk7CgotLSAgICAgZnVuY3Rpb24gd3JpdGVTdHJpbmcoc3RyaW5nIG1lbW9yeSBjb250ZW50KSBwdWJsaWMgewotLSAgICAgICAgIGVtaXQgU3RyaW5nU2F2ZUV2ZW50KG1zZy5zZW5kZXIsIGNvbnRlbnQpOwotLSAgICAgfQotLSB9CgotLSBUYWtlbiBmcm9tIGh0dHBzOi8vZG9jcy5zb2xpZGl0eWxhbmcub3JnL2VuL3YwLjUuNi9hYmktc3BlYy5odG1sI2Z1bmN0aW9uLXNlbGVjdG9yLWFuZC1hcmd1bWVudC1lbmNvZGluZwpmdW5jdGlvbiBFVEgubWFrZV9zdG9yYWdlX2RhdGEoc3JjKQogICBsb2NhbCBmSWQsIG9mZnNldCwgcGFkZGluZ0xlbmd0aCwgcGFkZGluZywgYnl0TGVuLCBwYWRkaW5nTGVuCgogICAtLSBsb2NhbCBIID0gSEFTSC5uZXcoJ2tlY2NhazI1NicpCiAgIC0tIHN0cmluZy5zdWIoaGV4KEg6cHJvY2Vzcygnc3RvcmFnZShzdHJpbmcpJykpLCAxLCA4KQogICBmSWQgPSBPLmZyb21faGV4KCdiMzc0MDEyYicpCgogICAtLSBkeW5hbWljIHBhcmFtZXRlciBhcmUgc2F2ZWQgYXQgdGhlIGVuZCBvZiBzdHJpbmcsIHRoaXMgaXMgYXQgd2hpY2ggb2Zmc2V0IHRoZXkgYXJlIHNhdmVkCiAgIG9mZnNldCA9IE8uZnJvbV9oZXgoJzAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMjAnKQoKICAgLS0gbGVuZ3RoIGFzIGEgMjU2IHVuc2lnbmVkIGludGVnZXIKICAgbG9jYWwgc3JjX28gPSBzcmMKICAgaWYgaXN6ZW4odHlwZShzcmNfbykpIHRoZW4KICAgICAgc3JjX28gPSBzcmNfbzpvY3RldCgpCiAgIGVuZAogICBieXRMZW4gPSBJTlQubmV3KCNzcmNfbyk6b2N0ZXQoKQogICBwYWRkaW5nTGVuZ3RoID0gMzItI2J5dExlbgogICBwYWRkaW5nTGVuID0gTy56ZXJvKHBhZGRpbmdMZW5ndGgpCiAgIHBhZGRpbmdMZW5ndGggPSAjc3JjX28gJSAzMgogICBpZiBwYWRkaW5nTGVuZ3RoID4gMCB0aGVuCiAgICAgIHBhZGRpbmdMZW5ndGggPSAzMiAtIHBhZGRpbmdMZW5ndGgKICAgICAgcGFkZGluZyA9IE8uemVybyhwYWRkaW5nTGVuZ3RoKQogICBlbHNlCiAgICAgIHBhZGRpbmcgPSBPLmVtcHR5KCkKICAgZW5kCiAgIC0tIGRvbmUgd2l0aCBwYWRkaW5nCgogICByZXR1cm4gZklkIC4uIG9mZnNldCAuLiBwYWRkaW5nTGVuIC4uIGJ5dExlbiAgLi4gc3JjX28gLi4gcGFkZGluZwplbmQKCi0tIGdlbmVyYXRlIGFuIGV0aGVyZXVtIGtleXBhaXIKZnVuY3Rpb24gRVRILmtleWdlbigpCiAgIGxvY2FsIGtwID0gRUNESC5rZXlnZW4oKQogICAtLSB0aGUgYWRkcmVzcyBpcyB0aGUga2VjY2FrIGhhc2ggb2YgdGhlIHggY29uY2F0ZW5hdGVkIHdpdGgKICAgLS0gdGhlIHkgb2YgdGhlIHB1YmxpYyBrZXkgKHdpdGhvdXQgMDQgYXQgdGhlIGJlZ2lubmluZyEpCiAgIC0tIFRha2VuIGZyb20gaHR0cHM6Ly9naXRodWIuY29tL2V0aGVyZXVtYm9vay9ldGhlcmV1bWJvb2svYmxvYi9kZXZlbG9wLzA0a2V5cy1hZGRyZXNzZXMuYXNjaWlkb2MKICAgLS0gaW4gdGhlIHNlY3Rpb24gRXRoZXJldW0gQWRkcmVzcwogICAtLSBvciBpbiB0aGUgWWVsbG93IFBhcGVyCgogICAtLSBXYXJuaW5nOiB3ZSB0YWtlIG9ubHkgdGhlIGxhc3QgMjBieXRlcyBvZiB0aGUgaGFzaCAoLi4uKQogICByZXR1cm4gewogICAgICBhZGRyZXNzPUVUSC5hZGRyZXNzX2Zyb21fcHVibGljX2tleShrcC5wdWJsaWMpLAogICAgICBwcml2YXRlPWtwLnByaXZhdGUsCiAgIH0KZW5kCgpmdW5jdGlvbiBFVEguYWRkcmVzc19mcm9tX3B1YmxpY19rZXkocGspCiAgIHJldHVybiBIQVNILmtlY2NhazI1NihwazpzdWIoMiwgI3BrKSk6c3ViKDEzLCAzMikKZW5kCgpmdW5jdGlvbiBFVEguYWRkcmVzc19mcm9tX3NpZ25hdHVyZShzaWduYXR1cmUsIHlfcGFyaXR5LCBoYXNoKQogICBsb2NhbCBwaywgdmFsaWQKCiAgIGxvY2FsIHggPSBJTlQubmV3KHNpZ25hdHVyZS5yKQogICBsb2NhbCBwID0gRUNESC5wcmltZSgpCiAgIGxvY2FsIG4gPSBFQ0RILm9yZGVyKCkKICAgbG9jYWwgaCA9IEVDREguY29mYWN0b3IoKSAtLWg9MQogICByZXBlYXQKCSAgIHBrLCB2YWxpZCA9IEVDREgucmVjb3ZlcnkoeDpvY3RldCgpLCB5X3Bhcml0eSwgaGFzaCwgc2lnbmF0dXJlKQoJICAgaWYgaCA+IDAgdGhlbiAgIC0tIGRvIG5vdCBhZGQgbiBsYXN0IGl0ZXJhdGlvbgoJCSAgIHggPSAoeCArIG4pICUgcAoJICAgZW5kCgkgICBoID0gaC0xCiAgIHVudGlsICh2YWxpZCkgb3IgKGggPCAwKQoKICAgcmV0dXJuIHZhbGlkIGFuZCBFVEguYWRkcmVzc19mcm9tX3B1YmxpY19rZXkocGspCmVuZAoKbG9jYWwgZnVuY3Rpb24gZW5jb2RlX3VpbnQodmFsKQogICByZXR1cm4gQklHLm5ldyh2YWwpOmZpeGVkKDMyKQplbmQKCi0tIFRoZSBmb2xsb3dpbmcgdHlwZXMgYXJlIGNhbGxlZCDigJxkeW5hbWlj4oCdOgotLSAgICAgYnl0ZXMKLS0gICAgIHN0cmluZwotLSAgICAgVFtdIGZvciBhbnkgVAotLSAgICAgVFtrXSBmb3IgYW55IGR5bmFtaWMgVCBhbmQgYW55IGsgPj0gMAotLSAgICAgKFQxLC4uLixUaykgaWYgVGkgaXMgZHluYW1pYyBmb3Igc29tZSAxIDw9IGkgPD0gawpsb2NhbCBmdW5jdGlvbiBpc19keW5hbWljKHQpCiAgIGxvY2FsIGR5biA9IHQgPT0gJ3N0cmluZycgb3IgdCA9PSAnYnl0ZXMnIG9yIHN0cmluZy5tYXRjaCh0LCAnW2EtekEtWjAtOV0rJVslXScpCiAgIGlmIG5vdCBkeW4gdGhlbgogICAgICB0ID0gc3RyaW5nLm1hdGNoKHQsICcoW2EtekEtWl0rKSVbJWQrJV0nKQogICAgICBpZiB0IHRoZW4KICAgICAgICAgZHluID0gaXNfZHluYW1pYyh0KQogICAgICBlbmQKICAgZW5kCiAgIHJldHVybiBkeW4KZW5kCgpsb2NhbCBlbmNvZGVfdHVwbGUKCmxvY2FsIGZ1bmN0aW9uIGVuY29kZSh0LCBhcmcpCiAgIGxvY2FsIHJlcwogICBpZiB0eXBlKHQpID09ICJzdHJpbmciIHRoZW4KICAgICAgaWYgc3RyaW5nLm1hdGNoKHQsICd1aW50JWQrJCcpIG9yIHQgPT0gJ2FkZHJlc3MnIHRoZW4KICAgICAgICAgcmVzID0gZW5jb2RlX3VpbnQoYXJnKQogICAgICBlbHNlaWYgc3RyaW5nLm1hdGNoKHQsICdieXRlcyVkKyQnKSB0aGVuCiAgICAgICAgIGlmIGlzemVuKHR5cGUoYXJnKSkgdGhlbgogICAgICAgICAgICBhcmcgPSBhcmc6b2N0ZXQoKQogICAgICAgICBlbHNlCiAgICAgICAgICAgIGFyZyA9IE8ubmV3KGFyZykKICAgICAgICAgZW5kCiAgICAgICAgIGxvY2FsIHBhZGRpbmdMZW5ndGggPSAjYXJnICUgMzIKICAgICAgICAgbG9jYWwgcGFkZGluZwogICAgICAgICBpZiBwYWRkaW5nTGVuZ3RoID4gMCB0aGVuCiAgICAgICAgICAgIHBhZGRpbmdMZW5ndGggPSAzMiAtIHBhZGRpbmdMZW5ndGgKICAgICAgICAgICAgcGFkZGluZyA9IE8uemVybyhwYWRkaW5nTGVuZ3RoKQogICAgICAgICBlbHNlCiAgICAgICAgICAgIHBhZGRpbmcgPSBPLmVtcHR5KCkKICAgICAgICAgZW5kCiAgICAgICAgIHJlcyA9IGFyZyAuLiBwYWRkaW5nCiAgICAgIGVsc2VpZiB0ID09ICdib29sJyB0aGVuCiAgICAgICAgIGlmIGlzemVuKHR5cGUoYXJnKSkgdGhlbgogICAgICAgICAgICBhcmcgPSBhcmc6b2N0ZXQoKTpzdHJpbmcoKQogICAgICAgICBlbmQKICAgICAgICAgaWYgdHlwZShhcmcpID09ICdzdHJpbmcnIHRoZW4KICAgICAgICAgICAgaWYgYXJnIH49ICJ0cnVlIiBhbmQgYXJnIH49ICJmYWxzZSIgdGhlbgogICAgICAgICAgICAgICBlcnJvcihhcmcgLi4gIiBpcyBub3QgYSBib29sZWFuIHZhbHVlIikKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGFyZyA9IGFyZyB+PSAnZmFsc2UnCiAgICAgICAgIGVuZAogICAgICAgICByZXMgPSBCSUcubmV3KGZpZihhcmcsIDEsIDApKTpmaXhlZCgzMikKICAgICAgZWxzZWlmIHQgPT0gJ3N0cmluZycgb3IgdCA9PSAnYnl0ZXMnIHRoZW4KICAgICAgICAgaWYgaXN6ZW4odHlwZShhcmcpKSB0aGVuCiAgICAgICAgICAgIGFyZyA9IGFyZzpvY3RldCgpCiAgICAgICAgIGVsc2UKICAgICAgICAgICAgYXJnID0gTy5uZXcoYXJnKQogICAgICAgICBlbmQKICAgICAgICAgLS0gcmlnaHQgcGFkZGluZwogICAgICAgICBsb2NhbCBwYWRkaW5nTGVuZ3RoID0gI2FyZyAlIDMyCiAgICAgICAgIGxvY2FsIHBhZGRpbmcKICAgICAgICAgaWYgcGFkZGluZ0xlbmd0aCA+IDAgdGhlbgogICAgICAgICAgICBwYWRkaW5nTGVuZ3RoID0gMzIgLSBwYWRkaW5nTGVuZ3RoCiAgICAgICAgICAgIHBhZGRpbmcgPSBPLnplcm8ocGFkZGluZ0xlbmd0aCkKICAgICAgICAgZWxzZQogICAgICAgICAgICBwYWRkaW5nID0gTy5lbXB0eSgpCiAgICAgICAgIGVuZAogICAgICAgICByZXMgPSBJTlQubmV3KCNhcmcpOmZpeGVkKDMyKSAuLiBhcmcgLi4gcGFkZGluZwogICAgICBlbHNlCiAgICAgICAgIC0tIHRyeSB0byBwYXJzZSBhbiBhcnJheSB0eXBlCiAgICAgICAgIGxvY2FsIGxlbgogICAgICAgICBsb2NhbCB0dCwgayA9IHN0cmluZy5tYXRjaCh0LCAiKFthLXpBLVowLTldKyklWyglZCopJV0iKQogICAgICAgICBpZiB0dCB0aGVuCiAgICAgICAgICAgIGlmIGsgYW5kICNrID4gMCB0aGVuCiAgICAgICAgICAgICAgIGxlbiA9IHRvbnVtYmVyKGspCiAgICAgICAgICAgICAgIHJlcyA9IE8uZW1wdHkoKQogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgIGxlbiA9ICNhcmcKICAgICAgICAgICAgICAgcmVzID0gZW5jb2RlX3VpbnQoI2FyZykKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGxvY2FsIHBhcmFtcyA9IHt9CiAgICAgICAgICAgIGZvciBpPTEsbGVuLCAxIGRvCiAgICAgICAgICAgICAgIHRhYmxlLmluc2VydChwYXJhbXMsIHR0KQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgcmVzID0gcmVzIC4uIGVuY29kZShwYXJhbXMsIGFyZykKICAgICAgICAgZWxzZQogICAgICAgICAgICBlcnJvcigiVW5hYmxlIHRvIGVuY29kZSAiIC4uIHQpCiAgICAgICAgIGVuZAoKICAgICAgZW5kCiAgIGVsc2VpZiB0eXBlKHQpID09ICd0YWJsZScgdGhlbgogICAgICByZXMgPSBlbmNvZGVfdHVwbGUodCwgYXJnKQogICBlbmQKICAgcmV0dXJuIHJlcwplbmQKCmZ1bmN0aW9uIGVuY29kZV90dXBsZShwYXJhbXMsIGFyZ3MpCiAgIGxvY2FsIHJlcyA9IE8uZW1wdHkoKQoKICAgaWYgdHlwZShwYXJhbXMpIH49ICd0YWJsZScgdGhlbgogICAgICBlcnJvcigiVHlwZSBub3QgZW5jb2RhYmxlIGFzIHR1cGxlIikKICAgZW5kCgogICBsb2NhbCB0YWlscyA9IHt9CiAgIGxvY2FsIGhlYWRzID0ge30KCiAgIGxvY2FsIGhlYWRfc2l6ZSA9IDA7CiAgIGxvY2FsIHRhaWxfc2l6ZSA9IDA7CiAgIC0tIGNoZWNrIGlmIHRoZXJlIGFyZSBkeW5hbWljIHR5cGVzIGFuZCBjb21wdXRlIHRhaWxzCiAgIGZvciBpLCB2IGluIGlwYWlycyhwYXJhbXMpIGRvCiAgICAgIGlmIGlzX2R5bmFtaWModikgdGhlbgogICAgICAgICBoZWFkX3NpemUgPSBoZWFkX3NpemUgKyAzMgogICAgICAgICB0YWJsZS5pbnNlcnQodGFpbHMsIGVuY29kZSh2LCBhcmdzW2ldKSkKICAgICAgZWxzZQogICAgICAgICBsb2NhbCB0LCBrID0gc3RyaW5nLm1hdGNoKHYsICIoW2EtekEtWjAtOV0rKSVbKCVkKyklXSIpCiAgICAgICAgIGlmIHQgYW5kIGsgdGhlbgogICAgICAgICAgICBoZWFkX3NpemUgPSBoZWFkX3NpemUgKyAzMiAqIHRvbnVtYmVyKGspCiAgICAgICAgIGVsc2UKICAgICAgICAgICAgaGVhZF9zaXplID0gaGVhZF9zaXplICsgMzIKICAgICAgICAgZW5kCiAgICAgICAgIHRhYmxlLmluc2VydCh0YWlscywgTy5lbXB0eSgpKQogICAgICBlbmQKICAgZW5kCgogICBmb3IgaSwgdiBpbiBpcGFpcnMocGFyYW1zKSBkbwogICAgICAtLSBJIGRvbid0IGNoZWNrIHRoZSByYW5nZSBvZiB2YWx1ZXMgKGZvciBib29sIHRoZSBpbnB1dCBzaG91bGQgYmUgMCBvciAxKSwKICAgICAgLS0gd2hpbGUgZm9yIGludDxNPiBzaG91bGQgYmUgMCAuLi4gMl4oPE0+KS0xCiAgICAgIC0tIGFwcGVuZCBvZmZzZXQKICAgICAgaWYgaXNfZHluYW1pYyh2KSB0aGVuCiAgICAgICAgIHRhYmxlLmluc2VydChoZWFkcywgZW5jb2RlX3VpbnQoaGVhZF9zaXplK3RhaWxfc2l6ZSkpCiAgICAgICAgIHRhaWxfc2l6ZSA9IHRhaWxfc2l6ZSArICN0YWlsc1tpXQogICAgICBlbHNlCiAgICAgICAgIHRhYmxlLmluc2VydChoZWFkcywgZW5jb2RlKHYsIGFyZ3NbaV0pKQogICAgICBlbmQKICAgZW5kCgogICAtLSBpbXBsZW1lbnQgTy5jb25jYXQgZm9yIG1lbW9yeSBlZmZpY2llbnQgY29uY2F0CiAgIGZvciBfLCB2IGluIHBhaXJzKGhlYWRzKSBkbwogICAgICByZXMgPSByZXMgLi4gdgogICBlbmQKICAgZm9yIF8sIHYgaW4gcGFpcnModGFpbHMpIGRvCiAgICAgIHJlcyA9IHJlcyAuLiB2CiAgIGVuZAogICByZXR1cm4gcmVzCmVuZAoKRVRILmFiaV9lbmNvZGUgPSBlbmNvZGUKCgotLSBUT0RPOiByZW1vdmUgc28gbWFueSAuLiwgdGhlcmUgc2hvdWxkIGJlIHNvbWV0aGluZyBsaWtlIHRhYmxlLmNvbmNhdCBmb3Igb2N0ZXRzCi0tIFJlYWxseSBzaW1wbGUgZGF0YSBlbmNvZGVyLCBpdCBvbmx5IHdvcmtzIHdpdGggZWxlbWVudGFyeSB0eXBlcyAoZm9yCi0tIGV4YW1wbGUgRVJDLTIwIG9ubHkgdXNlcyB0aGlzIGtpbmQgb2YgZGF0YSB0eXBlcykKZnVuY3Rpb24gRVRILmRhdGFfY29udHJhY3RfZmFjdG9yeShmel9uYW1lLCBwYXJhbXMpCiAgIGlmIHR5cGUocGFyYW1zKSB+PSAndGFibGUnIHRoZW4KICAgICAgcGFyYW1zID0ge30KICAgZW5kCiAgIGxvY2FsIHNpZ25hdHVyZSA9IGZ6X25hbWUgLi4gJygnIC4uIHRhYmxlLmNvbmNhdChwYXJhbXMsICIsIikgLi4gJyknCiAgIGxvY2FsIGZfaWQgPSBPLmZyb21faGV4KHN0cmluZy5zdWIoaGV4KEhBU0gua2VjY2FrMjU2KHNpZ25hdHVyZSkpLCAxLCA4KSkKICAgcmV0dXJuIGZ1bmN0aW9uKC4uLikKICAgICAgcmV0dXJuIGZfaWQgLi4gZW5jb2RlX3R1cGxlKHBhcmFtcywgdGFibGUucGFjayguLi4pKQogICBlbmQKZW5kCgpmdW5jdGlvbiBFVEguY29udHJhY3RfcmV0dXJuX2ZhY3RvcnkocGFyYW1zKQogICBpZiB0eXBlKHBhcmFtcykgfj0gJ3RhYmxlJyB0aGVuCiAgICAgIHBhcmFtcyA9IHt9CiAgIGVuZAogICAtLSBAcGFyYW0gdmFsIHN0cmluZyBvciBvY3RldCB3aXRoIHRoZSB2YWx1ZSByZXR1cm5lZCBieSB0aGUgY29udHJhY3QKICAgcmV0dXJuIGZ1bmN0aW9uKHZhbCkKICAgICAgaWYgdHlwZSh2YWwpID09ICdzdHJpbmcnIHRoZW4KICAgCSAgdmFsID0gTy5mcm9tX2hleCh2YWwpCiAgICAgIGVuZAogICAgICBhc3NlcnQodHlwZSh2YWwpID09ICd6ZW5yb29tLm9jdGV0JykKCiAgICAgIGxvY2FsIHJlcyA9IHt9CiAgICAgIGZvciBpLCB2IGluIGlwYWlycyhwYXJhbXMpIGRvCiAgICAgICAgIC0tIEkgZG9uJ3QgY2hlY2sgdGhlIHJhbmdlIG9mIHZhbHVlcyAoZm9yIGJvb2wgdGhlIGlucHV0IHNob3VsZCBiZSAwIG9yIDEpLAogICAgICAgICAtLSB3aGlsZSBmb3IgaW50PE0+IHNob3VsZCBiZSAwIC4uLiAyXig8TT4pLTEKICAgICAgICAgaWYgdiA9PSAnYWRkcmVzcycgb3Igc3RyaW5nLm1hdGNoKHYsICdedWludCVkKyQnKSB0aGVuCiAgICAgICAgICAgIGxvY2FsIHZhbCA9IEJJRy5uZXcodmFsOnN1YigzMiAqIChpLTEpKzEsIDMyICogaSkpCiAgICAgICAgICAgIGlmIHYgPT0gJ2FkZHJlc3MnIHRoZW4KICAgICAgICAgICAgICAgdmFsID0gdmFsOmZpeGVkKDMyKQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgdGFibGUuaW5zZXJ0KHJlcywgdmFsKQogICAgICAgICBlbHNlaWYgdiA9PSAnYm9vbCcgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQocmVzLCBCSUcubmV3KHZhbDpzdWIoMzIgKiAoaS0xKSsxLCAzMiAqIGkpKSB+PSBCSUcubmV3KDApKQogICAgICAgICBlbHNlaWYgdiA9PSAnc3RyaW5nJyBvciB2ID09ICdieXRlcycgdGhlbgogICAgICAgICAgICAtLSBUT0RPOiBkb24ndCBrbm93IHRoZSBtYXhpbXVtIHNpemUgb2YgYXJndW1lbnQKICAgICAgICAgICAgLS0gdGhlcmUgY291bGQgYmUgYW4gb3ZlcmZsb3cKICAgICAgICAgICAgbG9jYWwgb2Zmc2V0ID0gdG9udW1iZXIodmFsOnN1YigzMiAqIChpLTEpKzEsIDMyICogaSk6aGV4KCksIDE2KQogICAgICAgICAgICBsb2NhbCBzbGVuID0gdG9udW1iZXIodmFsOnN1YigxK29mZnNldCwgMzIrb2Zmc2V0KTpoZXgoKSwgMTYpCiAgICAgICAgICAgIGxvY2FsIHMgPSB2YWw6c3ViKDErb2Zmc2V0KzMyLCBvZmZzZXQrMzIrc2xlbik6c3RyaW5nKCkKICAgICAgICAgICAgaWYgdiA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICAgICAgICAgIHMgPSBzOnN0cmluZygpCiAgICAgICAgICAgIGVuZAogICAgICAgICAgICB0YWJsZS5pbnNlcnQocmVzLCBzKQogICAgICAgICBlbHNlaWYgdiA9PSAiYnl0ZXMzMiIgdGhlbiAtLSBUT0RPOiBmb3IgYW55IGJ5dGVzWFgKICAgICAgICAgICAgbG9jYWwgdmFsID0gdmFsOnN1YigzMiAqIChpLTEpKzEsIDMyICogaSkKICAgICAgICAgICAgdGFibGUuaW5zZXJ0KHJlcywgdmFsKQogICAgICAgICBlbHNlCiAgICAgICAgICAgIGFzc2VydChmYWxzZSwgIlVua25vd24gZGF0YSB0eXBlIikKICAgICAgICAgZW5kCiAgICAgIGVuZAoKICAgICAgcmV0dXJuIHJlcwogICBlbmQKZW5kCgpFVEguYWJpX2RlY29kZSA9IEVUSC5jb250cmFjdF9yZXR1cm5fZmFjdG9yeQoKLS0gbWV0aG9kcyB3aXRoIHRoZSBtb2RpZmllciAidmlldyIgaGF2ZSB0byBiZSBleGVjdXRlZCAobG9jYWxseSkgd2l0aAotLSBldGhfY2FsbCwgdGhleSBkb24ndCBjaGFuZ2UgdGhlIGJsb2NrY2hhaW4KLS0gdGhlIGkgcHJvcGVydHkgYXJlIHRoZSBpbnB1dCBwYXJhbWV0ZXIKLS0gdGhlIG8gcHJvcGVydHkgaXMgKGFyZSkgdGhlIG91dHB1dCByZXR1cm4gdHlwZXMKbG9jYWwgRVJDMjBfU0lHTkFUVVJFUyA9IHsKICAgYmFsYW5jZU9mICAgICAgICAgPSB7IGk9eydhZGRyZXNzJ30sIG89eyd1aW50MjU2J30sIHZpZXc9dHJ1ZSB9LAogICB0cmFuc2ZlciAgICAgICAgICA9IHsgaT17J2FkZHJlc3MnLCAndWludDI1Nid9LCBvPXsnYm9vbCd9IH0sCiAgIGFwcHJvdmUgICAgICAgICAgID0geyBpPXsnYWRkcmVzcycsICd1aW50MjU2J30sIG89eydib29sJ30gfSwKICAgYWxsb3dhbmNlICAgICAgICAgPSB7IGk9eydhZGRyZXNzJywgJ2FkZHJlc3MnfSwgdmlldz10cnVlLCBvPXsndWludDI1Nid9IH0sCiAgIHRyYW5zZmVyRnJvbSAgICAgID0geyBpPXsnYWRkcmVzcycsICdhZGRyZXNzJywgJ3VpbnQyNTYnfSwgbz17J2Jvb2wnfSB9LAogICBkZWNpbWFscyAgICAgICAgICA9IHsgbz17J3VpbnQ4J30sIHZpZXc9dHJ1ZSB9LAogICBuYW1lICAgICAgICAgICAgICA9IHsgbz17J3N0cmluZyd9LCB2aWV3PXRydWUgfSwKICAgc3ltYm9sICAgICAgICAgICAgPSB7IG89eydzdHJpbmcnfSwgdmlldz10cnVlIH0sCiAgIHRvdGFsU3VwcGx5ICAgICAgID0geyBvPXsndWludDI1Nid9LCB2aWV3PXRydWUgfSwKfQoKRVRILmVyYzIwID0ge30KZm9yIGssIHYgaW4gcGFpcnMoRVJDMjBfU0lHTkFUVVJFUykgZG8KICAgRVRILmVyYzIwW2tdID0gRVRILmRhdGFfY29udHJhY3RfZmFjdG9yeShrLCB2LmkpCmVuZAoKRVRILmVyYzIwcmV0dXJuID0ge30KZm9yIGssIHYgaW4gcGFpcnMoRVJDMjBfU0lHTkFUVVJFUykgZG8KICAgRVRILmVyYzIwcmV0dXJuW2tdID0gRVRILmNvbnRyYWN0X3JldHVybl9mYWN0b3J5KHYubykKZW5kCgpsb2NhbCBGQVVDRVRfU0lHTkFUVVJFUyA9IHsKICAgdHJhbnNmZXIgPSB7IGk9eydhZGRyZXNzJ30gfSwKfQoKRVRILnRyYW5zZmVyX2VyYzIwX2RldGFpbHMgPSBFVEguZGF0YV9jb250cmFjdF9mYWN0b3J5KAogICAgICAgICJ0cmFuc2ZlckRldGFpbHMiLAogICAgICAgIHsiYWRkcmVzcyIsICJ1aW50MjU2IiwgImJ5dGVzIn0pCgpFVEguZmF1Y2V0ID0ge30KZm9yIGssIHYgaW4gcGFpcnMoRkFVQ0VUX1NJR05BVFVSRVMpIGRvCiAgIEVUSC5mYXVjZXRba10gPSBFVEguZGF0YV9jb250cmFjdF9mYWN0b3J5KGssIHYuaSkKZW5kCgotLSBUT0RPIGltcGxlbWVudCBhbGwgRVJDNzIxIG1ldGhvZHMKbG9jYWwgRVJDNzIxX1NJR05BVFVSRVMgPSB7CiAgIHNhZmVUcmFuc2ZlckZyb20gPSB7IGk9eydhZGRyZXNzJywgJ2FkZHJlc3MnLCAndWludDI1Nid9IH0sCiAgIGFwcHJvdmUgPSB7IGk9eydhZGRyZXNzJywgJ3VpbnQyNTYnfSB9LAp9CgpFVEguZXJjNzIxID0ge30KZm9yIGssIHYgaW4gcGFpcnMoRVJDNzIxX1NJR05BVFVSRVMpIGRvCiAgIEVUSC5lcmM3MjFba10gPSBFVEguZGF0YV9jb250cmFjdF9mYWN0b3J5KGssIHYuaSkKZW5kCgpFVEguY3JlYXRlX2VyYzcyMSA9IEVUSC5kYXRhX2NvbnRyYWN0X2ZhY3RvcnkoImNyZWF0ZUFzc2V0IiwgeyAnc3RyaW5nJyB9KQoKRVRILmV0aF90b19wbGFuZXRtaW50ID0gRVRILmRhdGFfY29udHJhY3RfZmFjdG9yeSgiYmVnaW5UcmFuc2ZlciIsIHsgJ2FkZHJlc3MnLCAndWludDI1NicsICdieXRlcycgfSkKcmV0dXJuIEVUSAovY3J5cHRvX2ZpYXRfc2hhbWlyLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBHaXVsaW8gU2FjY2hldAotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS0KLS1SZWZlcmVuY2VzOgotLWh0dHBzOi8vZGF0YXRyYWNrZXIuaWV0Zi5vcmcvZG9jL2h0bWwvZHJhZnQtZ29vZ2xlLWNmcmctbGliemstMDAjbmFtZS1zdW1jaGVjawotLWh0dHBzOi8vZ2l0aHViLmNvbS9nb29nbGUvbG9uZ2ZlbGxvdy16ay9ibG9iL21haW4vbGliL3JhbmRvbQotLQotLV1dCgpsb2NhbCBGUyA9IHt9Cgpsb2NhbCBmdW5jdGlvbiBBZXMoa2V5LCBwbGFpbnRleHQpCiAgICBsb2NhbCB6ZXJvID0gTy5mcm9tX2hleCgnMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAnKQogICAgcmV0dXJuIEFFUy5jdHJfZW5jcnlwdChrZXksIHplcm8sIHBsYWludGV4dCkKZW5kCgpsb2NhbCBmdW5jdGlvbiBjZWlsX2RpdjE2KG4pCiAgICBhc3NlcnQodHlwZShuKSA9PSAibnVtYmVyIiwgIm4gaXMgbm90IGEgbnVtYmVyIikKICAgIGlmIG1hdGguZm1vZChuLDE2KSA9PSAiMCIgdGhlbgogICAgICAgIHJldHVybiBuLzE2IAogICAgZWxzZQogICAgICAgIHJldHVybiBtYXRoLmNlaWwobi8xNikKICAgIGVuZCAKZW5kCgpsb2NhbCBmdW5jdGlvbiBmbG9vcl9kaXYxNihuKQogICAgYXNzZXJ0KHR5cGUobikgPT0gIm51bWJlciIsICJuIGlzIG5vdCBhIG51bWJlciIpCiAgICBpZiBtYXRoLmZtb2QobiwxNikgPT0gIjAiIHRoZW4KICAgICAgICByZXR1cm4gbi8xNiAKICAgIGVsc2UKICAgICAgICByZXR1cm4gbWF0aC5mbG9vcihuLzE2KQogICAgZW5kIAplbmQKCmZ1bmN0aW9uIEZTLmZpYXRfc2hhbWlyKHRyYW5zY3JpcHQsbl9ieXRlcyxzdGFydF9pbmRleCkKICAgIGxvY2FsIGtleSA9IHNoYTI1Nih0cmFuc2NyaXB0KQogICAgbG9jYWwgc3RyZWFtID0gTy5uZXcoKQogICAgbG9jYWwgbl9ibG9ja3MgPSBjZWlsX2RpdjE2KG5fYnl0ZXMpKzEKICAgIGZvciBpID0gZmxvb3JfZGl2MTYoc3RhcnRfaW5kZXgpLCBmbG9vcl9kaXYxNihzdGFydF9pbmRleCkrbl9ibG9ja3MtMSBkbyAKICAgICAgICBzdHJlYW0gPSBzdHJlYW06X19jb25jYXQoQWVzKGtleSwgTy5mcm9tX251bWJlcihpKTpyZXZlcnNlKCkpKQogICAgZW5kIAogICAgaWYgbl9ieXRlcyA9PSAwIHRoZW4KICAgICAgICByZXR1cm4gTy5mcm9tX251bWJlcigwKSwgc3RhcnRfaW5kZXgrMQogICAgZWxzZSAKICAgICAgICByZXR1cm4gc3RyZWFtOnN1YihtYXRoLmZtb2Qoc3RhcnRfaW5kZXgsMTYpKzEsIG1hdGguZm1vZChzdGFydF9pbmRleCwxNikrbl9ieXRlcyksIHN0YXJ0X2luZGV4K25fYnl0ZXMKICAgIGVuZCAKZW5kCiAgICAKbG9jYWwgZnVuY3Rpb24gY2VpbF9kaXY4KG4pCiAgICBhc3NlcnQodHlwZShuKSA9PSAiemVucm9vbS5iaWciLCAibiBpcyBub3QgYSBCSUciKQogICAgaWYgbjpfX21vZChiaWcubmV3KDgpKTpfX2VxKGJpZy5uZXcoMCkpIHRoZW4KICAgICAgICByZXR1cm4gbjpfX2RpdihiaWcubmV3KDgpKSAKICAgIGVsc2UKICAgICAgICByZXR1cm4gbjpfX2RpdihiaWcubmV3KDgpKTpfX2FkZChiaWcubmV3KDEpKQogICAgZW5kIAplbmQKCmZ1bmN0aW9uIEZTLmdlbmVyYXRlX25hdChtLCB0cmFuc2NyaXB0LCBzdGFydF9pbmRleCkKLS1nZW5lcmF0ZXMgYSByYW5kb20gbmF0dXJhbCBiZXR3ZWVuIDAgYW5kIG0tMSBpbmNsdXNpdmUKICAgIGFzc2VydCh0eXBlKG0pID09ICJ6ZW5yb29tLmJpZyIsICJtIGlzIG5vdCBhIEJJRyIpCiAgICBhc3NlcnQodHlwZSh0cmFuc2NyaXB0KSA9PSAiemVucm9vbS5vY3RldCIsICJ0cmFuc2NyaXB0IGlzIG5vdCBhbiBvY3RldCIpCiAgICBpZiBtOl9fZXEoYmlnLm5ldygxKSkgdGhlbiAKICAgICAgICByZXR1cm4gYmlnLm5ldygwKSwgc3RhcnRfaW5kZXgrMQogICAgZW5kIAogICAgbG9jYWwgbCA9IGJpZy5uZXcoMCkgCiAgICB3aGlsZSBiaWcubmV3KDIpOm1vZHBvd2VyKGwsRUNQLm9yZGVyKCkpOl9fbHQobSkgZG8KICAgICAgICBsID0gYmlnLnplbmFkZChsLGJpZy5uZXcoMSkpCiAgICBlbmQKICAgIGxvY2FsIG5fYnl0ZXMgPSBjZWlsX2RpdjgobCk6aW50KCkKICAgIGxvY2FsIG1vZCA9IGJpZy5uZXcoMik6bW9kcG93ZXIobCxFQ1Aub3JkZXIoKSkKICAgIGxvY2FsIHIgPSBtCiAgICBpZiBuX2J5dGVzID09IDAgdGhlbiAKICAgICAgICByZXR1cm4gYmlnLm5ldygwKSwgc3RhcnRfaW5kZXgrMQogICAgZWxzZQogICAgICAgIHdoaWxlIG06X19sdGUocikgZG8gCiAgICAgICAgICAgIGIsIHN0YXJ0X2luZGV4ID0gRlMuZmlhdF9zaGFtaXIodHJhbnNjcmlwdCwgbl9ieXRlcywgc3RhcnRfaW5kZXgpCiAgICAgICAgICAgIGxvY2FsIGsgPSBiaWcubmV3KGI6cmV2ZXJzZSgpKQogICAgICAgICAgICByID0gazpfX21vZChtb2QpCiAgICAgICAgZW5kICAKICAgICAgICByZXR1cm4gciwgc3RhcnRfaW5kZXgKICAgIGVuZAplbmQgCgpmdW5jdGlvbiBGUy5nZW5lcmF0ZV9maWVsZF9lbGVtZW50X3AodHJhbnNjcmlwdCxwLHN0YXJ0X2luZGV4KQogICAgYXNzZXJ0KHR5cGUocCkgPT0gInplbnJvb20uYmlnIiwgInAgaXMgbm90IGEgQklHIikKICAgIGxvY2FsIG5hdCwgc2kgPSAgRlMuZ2VuZXJhdGVfbmF0KHAsdHJhbnNjcmlwdCxzdGFydF9pbmRleCkKICAgIG9jdCA9IE8ubmV3KG5hdCkKICAgIHJldHVybiBvY3Q6cmV2ZXJzZSgpLCBzaQplbmQgCgpmdW5jdGlvbiBGUy5nZW5lcmF0ZV9maWVsZF9lbGVtZW50X2dmKHRyYW5zY3JpcHQsZGVnLHN0YXJ0X2luZGV4KQogICAgYXNzZXJ0KHR5cGUoZGVnKSA9PSAibnVtYmVyIiwgImRlZyBpcyBub3QgYSBudW1iZXIiKQogICAgbG9jYWwgbl9ieXRlcyA9IGRlZy84CiAgICBsb2NhbCBuYXQsIHNpID0gRlMuZmlhdF9zaGFtaXIodHJhbnNjcmlwdCxuX2J5dGVzLHN0YXJ0X2luZGV4KQogICAgcmV0dXJuIG5hdCwgc2kKZW5kCgpmdW5jdGlvbiBGUy5nZW5lcmF0ZV9jaGFsbGVuZ2VfcCh0cmFuc2NyaXB0LHAsbGVuLHN0YXJ0X2luZGV4KQogICAgYXNzZXJ0KHR5cGUocCkgPT0gInplbnJvb20uYmlnIiwgInAgaXMgbm90IGEgQklHIikKICAgIGFzc2VydCh0eXBlKGxlbikgPT0gIm51bWJlciIsICJsZW4gaXMgbm90IGEgbnVtYmVyIikKICAgIGxvY2FsIGFycmF5ID0ge30KICAgIGZvciBpID0gMSwgbGVuIGRvIAogICAgICAgIGVsdCwgc3RhcnRfaW5kZXggPSAgRlMuZ2VuZXJhdGVfZmllbGRfZWxlbWVudF9wKHRyYW5zY3JpcHQscCxzdGFydF9pbmRleCkKICAgICAgICB0YWJsZS5pbnNlcnQoYXJyYXksZWx0KQogICAgZW5kCiAgICByZXR1cm4gYXJyYXksIHN0YXJ0X2luZGV4CmVuZCAKCmZ1bmN0aW9uIEZTLmdlbmVyYXRlX2NoYWxsZW5nZV9nZih0cmFuc2NyaXB0LGRlZyxsZW4sc3RhcnRfaW5kZXgpCiAgICBhc3NlcnQodHlwZShkZWcpID09ICJudW1iZXIiLCAiZGVnIGlzIG5vdCBhIG51bWJlciIpCiAgICBhc3NlcnQodHlwZShsZW4pID09ICJudW1iZXIiLCAibGVuIGlzIG5vdCBhIG51bWJlciIpCiAgICBsb2NhbCBhcnJheSA9IHt9CiAgICBmb3IgaSA9IDEsIGxlbiBkbyAKICAgICAgICBlbHQsIHN0YXJ0X2luZGV4ID0gIEZTLmdlbmVyYXRlX2ZpZWxkX2VsZW1lbnRfZ2YodHJhbnNjcmlwdCxkZWcsc3RhcnRfaW5kZXgpCiAgICAgICAgdGFibGUuaW5zZXJ0KGFycmF5LGVsdCkKICAgIGVuZAogICAgcmV0dXJuIGFycmF5LCBzdGFydF9pbmRleAplbmQgCgpyZXR1cm4gRlMKCgoKL2NyeXB0b19mc3AubHVhAC0tW1sKICAgIC0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQogICAgLS0KICAgIC0tQ29weXJpZ2h0IChDKSAyMDI0LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgogICAgLS1Xcml0dGVuIGJ5IERlbmlzIFJvaW8KICAgIC0tCiAgICAtLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5CiAgICAtLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKICAgIC0tCiAgICAtLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAogICAgLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgogICAgLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCiAgICAtLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgogICAgLS0KICAgIC0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKICAgIC0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKICAgIC0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tXV0KCmxvY2FsIFQgPSB7IH0KCi0tIFRoZSBsZW5ndGggb2YgUlNLIG1hcmtzIHRoZSBtYXhpbXVtIG1lc3NhZ2UgbGVuZ3RoCi0tIHRvIG1ha2Ugc3VyZSB0aGF0IGl0cyBYT1IgY292ZXJzIHRoZSB3aG9sZSBtZXNzYWdlCgotLSBEZWZhdWx0IFNTIHNpemUgMjU2IGJpdCBvciAzMiBieXRlcwotLSBEZWZhdWx0IFByb2JhYmlsaXN0aWMgaGFzaCBzaXplIDMyIGJpdHMgLyA0IGJ5dGVzCi0tIERlZmF1bHQgUlNLIHNpemUgMjU2IGJ5dGVzClQuUlNLX2xlbmd0aCA9IDI1NgpULlBST0IgPSA0IC0tIHByb2JoYXNoIGJ5dGVzIGZvciBNQUMKClQuSEFTSCA9IEhBU0gubmV3KCdzaGEyNTYnKSAtLSBkbyBub3QgY2hhbmdlCgotLSBUT0RPOiBjaGVjayBJViBsZW5ndGgKLS0gZmluZCBtaW5pbXVtIGxlbmd0aCBvZiBrCgotLSBwcm9iYWJpbGlzdGljIGhhc2ggZnVuY3Rpb24gcmV0dXJuaW5nIG9ubHkgTiBieXRlcwpmdW5jdGlvbiBUOnByb2JoYXNoKGZvYmopCiAgICByZXR1cm4gc2VsZi5IQVNIOnByb2Nlc3Mob2JqKTpjaG9wKHNlbGYuUFJPQikKZW5kCgpmdW5jdGlvbiBUOmVuY3J5cHQoa2V5LCBtZXNzYWdlLCBub25jZSkKICAgaWYgbm90IG5vbmNlIHRoZW4gZXJyb3IoIkZTUCBlbmNyeXB0IG1pc3Npbmcgbm9uY2UiLDIpIGVuZAogICAgcmV0dXJuIEFFUy5jdHJfZW5jcnlwdCgKICAgICAgICBzZWxmLkhBU0g6cHJvY2VzcyhrZXkpLAogICAgICAgIG1lc3NhZ2UsCiAgICAgICAgc2VsZi5IQVNIOnByb2Nlc3Mobm9uY2UpCiAgICApCmVuZApmdW5jdGlvbiBUOmRlY3J5cHQoa2V5LCBjaXBoZXIsIG5vbmNlKQogICBpZiBub3Qgbm9uY2UgdGhlbiBlcnJvcigiRlNQIGRlY3J5cHQgbWlzc2luZyBub25jZSIsMikgZW5kCiAgICByZXR1cm4gQUVTLmN0cl9lbmNyeXB0KAogICAgICAgIHNlbGYuSEFTSDpwcm9jZXNzKGtleSksCiAgICAgICAgY2lwaGVyLAogICAgICAgIHNlbGYuSEFTSDpwcm9jZXNzKG5vbmNlKQogICAgKQplbmQKCi0tIGdlbmVyYXRlIGEgbm9uY2Ugd2l0aCBkZWZhdWx0IGZvcm1hdApmdW5jdGlvbiBUOm1ha2Vub25jZSgpCiAgIHJldHVybiBPQ1RFVC5mcm9tX3N0cmluZyhvcy5kYXRlKCIlWSVtJWQlSCVNJVMiLCBvcy50aW1lKCkpKQplbmQKCi0tIHByZXBhcmUgYSBjbGVhciB0ZXh0IG1lc3NhZ2UgdG8gYmUgZW5jcnlwdGVkCmZ1bmN0aW9uIFQ6ZW5jb2RldHh0KHRleHQpCiAgIGxvY2FsIG1heCA9IHNlbGYuUlNLX2xlbmd0aCAtIHNlbGYuUFJPQiAtMSAtLSBFT00gaXMgWzFdIDAwCiAgIGxvY2FsIGxlbiA9ICN0ZXh0CiAgIC0tIG1lc3NhZ2UgdG9vIGxvbmcgZm9yIGVuY29kaW5nCiAgIGlmIChsZW4gPiBtYXgpIHRoZW4gcmV0dXJuIG5pbAogICBlbHNlaWYgKGxlbiA9PSBtYXgpIHRoZW4gcmV0dXJuIHRleHQKICAgZW5kCiAgIC0tIGxlbjxtYXg6IG1lc3NhZ2UgbmVlZHMgZmlsbGluZyB3aXRoIHJhbmRvbQogICByZXR1cm4gKCB0ZXh0IC4uIE9DVEVULnplcm8oMSkgLi4gT0NURVQucmFuZG9tKG1heC1sZW4pICkKZW5kCgpmdW5jdGlvbiBUOmRlY29kZXR4dCh0ZXh0KQogICAtLSByZWFkIG91dCB0aGUgbnVsbCB0ZXJtaW5hdGVkIHN0cmluZwogICByZXR1cm4gT0NURVQuZnJvbV9zdHJpbmcodGV4dDpzdHJpbmcoKSkKZW5kCgpmdW5jdGlvbiBUOmVuY29kZV9tZXNzYWdlKFNTLCBub25jZSwgY2xlYXJ0ZXh0LCBSU0spCiAgICAtLSBSU0sgYXJnIGlzIG9ubHkgdXNlZCB0byB2ZXJpZnkgdmVjdG9ycwogICBpZiBub3QgU1MgdGhlbiBlcnJvcigiRlNQIHNlY3JldCBrZXkgbWlzc2luZyIsMikgZW5kCglpZiBub3QgKCAjU1MgPT0gMzIgKSB0aGVuCgkJCWVycm9yKCJGU1Agc2VjcmV0IGtleSBsZW5ndGggbXVzdCBiZSAzMiBieXRlcyIsIDIpIGVuZAogICAgaWYgUlNLIHRoZW4KICAgICAgICBpZiBub3QgKCAjUlNLID09IHNlbGYuUlNLX2xlbmd0aCApIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkZTUCBzZXNzaW9uIGtleSBsZW5ndGggbXVzdCBiZSAiLi5zZWxmLlJTS19sZW5ndGguLiIgYnl0ZXMiLCAyKSBlbmQKICAgIGVuZAogICAgbG9jYWwgcnNrID0gUlNLIG9yIE9DVEVULnJhbmRvbShzZWxmLlJTS19sZW5ndGgpCiAgICBsb2NhbCBtID0gewogICAgICAgIG4gPSBub25jZSwKICAgICAgICBrID0gc2VsZjplbmNyeXB0KFNTLCByc2ssIG5vbmNlKQoJCSAgIH4KCQkgICBzZWxmOmVuY3J5cHQoU1MsIG5vbmNlOmZpbGxyZXBlYXQoc2VsZi5SU0tfbGVuZ3RoKSwgbm9uY2UpLAogICAgICAgIHAgPSBzZWxmOmVuY3J5cHQoCiAgICAgICAgICAgIHJzaywKICAgICAgICAgICAgcnNrIH4gKHNlbGY6cHJvYmhhc2goU1MgfiByc2spIC4uIHNlbGY6ZW5jb2RldHh0KGNsZWFydGV4dCkpLAoJCQlub25jZSkKICAgIH0KICAgIHJldHVybiBtCmVuZAoKZnVuY3Rpb24gVDpkZWNvZGVfbWVzc2FnZShTUywgY2lwaGVydGV4dCwgbm9uY2UpCiAgICBsb2NhbCBpdiA9IG5vbmNlIG9yIGNpcGhlcnRleHQubgogICAgaWYgbm90IGl2IHRoZW4KICAgICAgICBlcnJvcigiVW5kZWZpbmVkIG5vbmNlIGluIEZTUDpkZWNvZGVfbWVzc2FnZSIsMikKICAgIGVuZAoJLS0gZGVjb2RlIHJzayBmcm9tIGsKICAgIGxvY2FsIHJzayA9IHNlbGY6ZGVjcnlwdCgKICAgICAgICBTUywKICAgICAgICBjaXBoZXJ0ZXh0LmsKCQl+IHNlbGY6ZW5jcnlwdChTUywgaXY6ZmlsbHJlcGVhdChzZWxmLlJTS19sZW5ndGgpLCBpdiksCiAgICAgICAgaXYpCiAgICBsb2NhbCBtID0gc2VsZjpkZWNyeXB0KHJzaywKICAgICAgICAgICAgICAgICAgICAgICAgICAgY2lwaGVydGV4dC5wOnhvcl9ncm93KHJzayksIGl2KQogICAgaWYgbm90IChzZWxmOnByb2JoYXNoKFNTIH4gcnNrKSA9PSBtOnN1YigxLHNlbGYuUFJPQikpIHRoZW4KICAgICAgICBlcnJvcigiSW52YWxpZCBhdXRoZW50aWNhdGlvbiBvZiBmc3AgY2lwaGVydGV4dCIsIDIpCiAgICBlbmQKICAgIHJldHVybiBzZWxmOmRlY29kZXR4dChtOnN1YihzZWxmLlBST0IrMSwjbSkpLCByc2sKZW5kCgpmdW5jdGlvbiBUOmVuY29kZV9yZXNwb25zZShTUywgbm9uY2UsIHJzaywgY2xlYXJ0ZXh0KQogICAgcmV0dXJuIHNlbGY6ZW5jcnlwdCgKICAgICAgICBTUywKICAgICAgICByc2sgfiAoc2VsZjpwcm9iaGFzaChyc2sgfiBub25jZSkgLi4gc2VsZjplbmNvZGV0eHQoY2xlYXJ0ZXh0KSksCiAgICAgICAgbm9uY2UpCmVuZAoKZnVuY3Rpb24gVDpkZWNvZGVfcmVzcG9uc2UoU1MsIG5vbmNlLCByc2ssIGNpcGhlcnRleHQpCiAgICBsb2NhbCBtID0gc2VsZjpkZWNvZGV0eHQoCgkgICBzZWxmOmRlY3J5cHQoU1MsIHJzayB+IGNpcGhlcnRleHQsIG5vbmNlKSApCiAgICBhc3NlcnQoc2VsZjpwcm9iaGFzaChyc2sgfiBub25jZSkgPT0gbTpzdWIoMSxzZWxmLlBST0IpLAogICAgICAgICJJbnZhbGlkIGF1dGhlbnRpY2F0aW9uIG9mIGZzcCByZXNwb25zZSIpCiAgICByZXR1cm4gbTpzdWIoc2VsZi5QUk9CKzEsI20pLCBtYWMKZW5kCgpyZXR1cm4gVAovY3J5cHRvX2pvc2UubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIxLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgTWF0dGVvIENyaXN0aW5vCi0tb24gRnJpZGF5LCAyMHRoIEp1bmUgMjAyNQotLV1dCgpsb2NhbCBqb3NlID0geyB9CgotLSBjcmVhdGUgYSBqd2sgZW5jb2RlZCBrZXkgc3RhcnRpbmcgZnJvbSB0aGUgc2svcGsKLS0gQHBhcmFtIGFsZyBhbGcgaW4gandrCi0tIEBwYXJhbSBza19mbGFnIHNrIGZsYWcsIGlmIHRydWUgdGhlIGFsZyBzayB3aWxsIGJlIGluc2VydGVkIGluIHRoZSBqd2sKLS0gQHBhcmFtIHBrIGEgc3BlY2lmaWMgcHVibGljIGtleSB0byBiZSB1c2VkCi0tIEByZXR1cm4gandrCmZ1bmN0aW9uIGpvc2UuY3JlYXRlX2p3ayhhbGcsIHNrX2ZsYWcsIHBrKQogICAgaWYgc2tfZmxhZyBhbmQgcGsgdGhlbgogICAgICAgIGVycm9yKCdKV0sgY2FuIG5vdCBiZSBjcmVhdGVkIHdpdGggemVucm9vbSBzayBhbmQgY3VzdG9tIHBrJywgMikKICAgIGVuZAogICAgbG9jYWwgY3J5cHRvIDxjb25zdD4gPSBDUllQVE8ubG9hZChhbGcpCiAgICBsb2NhbCBqd2sgPSB7IGFsZyA9IE8uZnJvbV9zdHJpbmcoY3J5cHRvLklBTkEpIH0KICAgIGxvY2FsIHNrCiAgICBpZiBza19mbGFnIHRoZW4KICAgICAgICBzayA9IGhhdmVrZXkoY3J5cHRvLmtleW5hbWUpCiAgICBlbmQKICAgIGxvY2FsIHB1YiA9IHBrIG9yIG1heWhhdmUnZXMyNTYgcHVibGljIGtleScKICAgIGlmIG5vdCBwdWIgYW5kIGNyeXB0by5wdWJnZW4gdGhlbgogICAgICAgIGlmIG5vdCBzayB0aGVuCiAgICAgICAgICAgIHNrID0gaGF2ZWtleShjcnlwdG8ua2V5bmFtZSkKICAgICAgICBlbmQKICAgICAgICBwdWIgPSBjcnlwdG8ucHViZ2VuKHNrKQogICAgZW5kCiAgICBpZiBjcnlwdG8uSUFOQSA9PSAnRVMyNTYnIHRoZW4KICAgICAgICBsb2NhbCBrZXlfb3BzID0geyB9CiAgICAgICAgandrLmt0eSA9IE8uZnJvbV9zdHJpbmcnRUMnCiAgICAgICAgandrLmNydiA9IE8uZnJvbV9zdHJpbmcnUC0yNTYnCiAgICAgICAgaWYgcHViIHRoZW4KICAgICAgICAgICAgdGFibGUuaW5zZXJ0KGtleV9vcHMsTy5mcm9tX3N0cmluZyd2ZXJpZnknKQogICAgICAgICAgICAtLSBjdXN0b20gY2FsbCBzaW5jZSB3ZSBrbm93IGhhcyAucHVibGljX3h5CiAgICAgICAgICAgIGp3ay54LCBqd2sueSA9IGNyeXB0by5jbGFzcy5wdWJsaWNfeHkocHViKQogICAgICAgIGVuZAogICAgICAgIGlmIHNrX2ZsYWcgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQoa2V5X29wcyxPLmZyb21fc3RyaW5nJ3NpZ24nKQogICAgICAgICAgICBqd2suZCA9IHNrCiAgICAgICAgZW5kCiAgICAgICAgandrLmtleV9vcHMgPSBrZXlfb3BzCiAgICAgICAgcmV0dXJuIGp3awogICAgZW5kCiAgICBpZiBjcnlwdG8uSUFOQSA9PSAnRUREU0EnIHRoZW4KICAgICAgICBsb2NhbCBrZXlfb3BzID0geyB9CiAgICAgICAgandrLmt0eSA9IE8uZnJvbV9zdHJpbmcnRUMnCiAgICAgICAgandrLmNydiA9IE8uZnJvbV9zdHJpbmcnUC0yNTYnCiAgICAgICAgaWYgcHViIHRoZW4KICAgICAgICAgICAgdGFibGUuaW5zZXJ0KGtleV9vcHMsTy5mcm9tX3N0cmluZyd2ZXJpZnknKQogICAgICAgICAgICBqd2sueCA9IHB1YgogICAgICAgIGVuZAogICAgICAgIGlmIHNrX2ZsYWcgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQoa2V5X29wcyxPLmZyb21fc3RyaW5nJ3NpZ24nKQogICAgICAgICAgICBqd2suZCA9IHNrCiAgICAgICAgZW5kCiAgICAgICAgandrLmtleV9vcHMgPSBrZXlfb3BzCiAgICAgICAgcmV0dXJuIGp3awogICAgZW5kCiAgICBpZiBjcnlwdG8uSUFOQSA9PSAnRVMyNTZLJyB0aGVuCiAgICAgICAgbG9jYWwga2V5X29wcyA9IHsgfQogICAgICAgIGp3ay5rdHkgPSBPLmZyb21fc3RyaW5nJ0VDJwogICAgICAgIGp3ay5jcnYgPSBPLmZyb21fc3RyaW5nJ3NlY3AyNTZrMScKICAgICAgICBpZiBwdWIgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQoa2V5X29wcyxPLmZyb21fc3RyaW5nJ3ZlcmlmeScpCiAgICAgICAgICAgIC0tIGN1c3RvbSBjYWxsIHNpbmNlIHdlIGtub3cgaGFzIC5wdWJsaWNfeHkKICAgICAgICAgICAgandrLngsIGp3ay55ID0gY3J5cHRvLmNsYXNzLnB1YmxpY194eShwdWIpCiAgICAgICAgZW5kCiAgICAgICAgaWYgc2tfZmxhZyB0aGVuCiAgICAgICAgICAgIHRhYmxlLmluc2VydChrZXlfb3BzLE8uZnJvbV9zdHJpbmcnc2lnbicpCiAgICAgICAgICAgIGp3ay5kID0gc2sKICAgICAgICBlbmQKICAgICAgICBqd2sua2V5X29wcyA9IGtleV9vcHMKICAgICAgICByZXR1cm4gandrCiAgICBlbmQKICAgIGlmIGNyeXB0by5JQU5BID09ICdNTC1EU0EtNDQnIHRoZW4KICAgICAgICBsb2NhbCBrZXlfb3BzID0geyB9CiAgICAgICAgaWYgcHViIHRoZW4KICAgICAgICAgICAgdGFibGUuaW5zZXJ0KGtleV9vcHMsTy5mcm9tX3N0cmluZyd2ZXJpZnknKQogICAgICAgICAgICBqd2sueCA9IHB1YgogICAgICAgIGVuZAogICAgICAgIGlmIHNrX2ZsYWcgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQoa2V5X29wcyxPLmZyb21fc3RyaW5nJ3NpZ24nKQogICAgICAgICAgICBqd2suZCA9IHNrCiAgICAgICAgZW5kCiAgICAgICAgandrLmFsZyA9IE8uZnJvbV9zdHJpbmcoY3J5cHRvLklBTkEpCiAgICAgICAgandrLmt0eSA9IE8uZnJvbV9zdHJpbmcnQUtQJwogICAgICAgIGp3ay5wYXJhbSA9IE8uZnJvbV9zdHJpbmcnNDQnCiAgICAgICAgandrLmtleV9vcHMgPSBrZXlfb3BzCiAgICAgICAgcmV0dXJuIGp3awogICAgZW5kCiAgICBlcnJvcignVW5zdXBwb3J0ZWQgSldLIGNyeXB0byBhbGdvcml0aG06ICcuLmFsZywyKQplbmQKCi0tIGdlbmVyYXRlIGEgSldTIHNpZ25hdHVyZQotLSBAcGFyYW0gcyB0aGUgc2lnbmF0dXJlLCBpZiBub3QgcHJlc2VudCBwYXlsb2FkIGNhbiBub3QgYmUgZW1wdHkgc3RyaW5nCi0tIEBwYXJhbSBoIHRoZSBoZWFkZXIgKG9wdGlvbmFsKSwgZGVmYXVsdCBpcyBlY2RzYSBvbiBzZWNwMjU2azEKLS0gQHBhcmFtIHAgdGhlIHBheWxvYWQgKG9wdGlvbmFsKSwgZGVmYXVsdCBpcyBlbXB0eSBzdHJpbmcKLS0gQHBhcmFtIGQgdGhlIGRldGFjaGVkIGZsYWcsIGlmIHNldCB0byB0cnVlIGFuZCBwYXlsb2FkIGlzIHByZXNlbnQsIHJlbW92ZSBwYXlsb2FkIGZyb20gandzCi0tIEByZXR1cm4gb2N0ZXQgc3RyaW5nIGNvbnRhaW5pbmcgdGhlIGp3cwpmdW5jdGlvbiBqb3NlLmNyZWF0ZV9qd3MocywgaCwgcCwgZCkKICAgIGlmIGggYW5kIGx1YXR5cGUoaCkgfj0gJ3RhYmxlJyB0aGVuCiAgICAgICAgZXJyb3IoJ0pPU0UgY3JlYXRlIEpXUyB3cm9uZyBhcmd1bWVudCB0eXBlIGZvciBoZWFkZXI6ICcKICAgICAgICAgICAgICAuLnR5cGUoaCksMikKICAgIGVuZAogICAgbG9jYWwgZnVuY3Rpb24gX2hlYWRlcnNfZnJvbV9vY3RldHMoaG8pCiAgICAgICAgbG9jYWwgdCA8Y29uc3Q+ID0gdHlwZShobykKICAgICAgICBpZiBpc3plbih0KSB0aGVuCiAgICAgICAgICAgIHJldHVybiBobzpvY3RldCgpOnRvX3N0cmluZygpCiAgICAgICAgZW5kCiAgICAgICAgaWYgdCA9PSAnYm9vbGVhbicgdGhlbiByZXR1cm4gaG8gZW5kCiAgICAgICAgcmV0dXJuIHRvc3RyaW5nKHQpCiAgICBlbmQKICAgIGxvY2FsIGhlYWRlciA9IHsgLS0gZGVmYXVsdAogICAgICAgIGFsZyA9ICdFUzI1NksnLAogICAgICAgIGI2NCA9IHRydWUsCiAgICAgICAgY3JpdCA9IHsnYjY0J30KICAgIH0KICAgIGlmIGggdGhlbiBoZWFkZXIgPSBkZWVwbWFwKF9oZWFkZXJzX2Zyb21fb2N0ZXRzLGgpIGVuZAogICAgbG9jYWwgZG90IDxjb25zdD4gPSBPLmZyb21fc3RyaW5nKCcuJykKICAgIGxvY2FsIHBheWxvYWQgPSBwIC0tIG1heSBiZSBjaGFuZ2VkIGJ5IGRldGFjaGVkIGZsYWcKICAgIGxvY2FsIHNpZ25hdHVyZSA9IHMKICAgIGlmIG5vdCBzaWduYXR1cmUgdGhlbgogICAgICAgIGlmIG5vdCBwYXlsb2FkIHRoZW4KICAgICAgICAgICAgZXJyb3IoJ0NhbiBub3QgY3JlYXRlIGEgandzIHNpZ25hdHVyZSB3aXRob3V0IHRoZSBwYXlsb2FkJywgMikKICAgICAgICBlbmQKICAgICAgICBpZiBub3QgaGVhZGVyLmFsZyB0aGVuCiAgICAgICAgICAgIGVycm9yKCdBbGdvcml0aG0gbm90IHNwZWNpZmllZCBpbiBqd3MgaGVhZGVyJywgMikKICAgICAgICBlbmQKICAgICAgICBsb2NhbCB0b19iZV9zaWduZWQgPGNvbnN0PiA9CiAgICAgICAgICAgIEpTT04uc2VyaWFsaXplKGhlYWRlcikKICAgICAgICAgICAgLi4KICAgICAgICAgICAgTy5mcm9tX3N0cmluZygnLicpCiAgICAgICAgICAgIC4uCiAgICAgICAgICAgIEpTT04uc2VyaWFsaXplKHBheWxvYWQpCiAgICAgICAgbG9jYWwgY3J5cHRvIDxjb25zdD4gPSBDUllQVE8ubG9hZChoZWFkZXIuYWxnKQogICAgICAgIGxvY2FsIHNrIDxjb25zdD4gPSBoYXZla2V5KGNyeXB0by5rZXluYW1lKQogICAgICAgIHNpZ25hdHVyZSA9IGNyeXB0by5zaWduKHNrLCB0b19iZV9zaWduZWQpCiAgICBlbmQKICAgIHBheWxvYWQgPSAoZCBhbmQgTy5mcm9tX3N0cmluZygnJykpIG9yIHBheWxvYWQKICAgIGlmIGx1YXR5cGUoc2lnbmF0dXJlKSA9PSAndGFibGUnIHRoZW4KICAgICAgICBpZiBub3Qoc2lnbmF0dXJlLnIgYW5kIHNpZ25hdHVyZS5zKSB0aGVuCiAgICAgICAgICAgIGVycm9yKCdUaGUgc2lnbmF0dXJlIHRhYmxlIGRvZXMgbm90IGNvbnRhaW5zIHIgYW5kIHMnLCAyKQogICAgICAgIGVuZAogICAgICAgIHNpZ25hdHVyZSA9IHNpZ25hdHVyZS5yOnBhZCgzMikgLi4gc2lnbmF0dXJlLnM6cGFkKDMyKQogICAgZW5kCiAgICByZXR1cm4gKEpTT04uc2VyaWFsaXplKGhlYWRlcikKICAgICAgICAgICAgLi5kb3QuLgogICAgICAgICAgICBKU09OLnNlcmlhbGl6ZShwYXlsb2FkKQogICAgICAgICAgICAuLmRvdC4uCiAgICAgICAgICAgIEpTT04uc2VyaWFsaXplKHNpZ25hdHVyZSkpCmVuZAoKLS0gUGFyc2UgYSBKV1Mgc3RyaW5nIGFuZCByZXR1cm4gYSBzdHJ1Y3R1cmUgd2l0aCBoZWFkZXIsIHBheWxvYWQgYW5kCi0tIHNpZ25hdHVyZSBpbiBhIGRpY3Rpb25hcnk6Ci0tIHsgaGVhZGVyLCBoZWFkZXJfZW5jLCBwYXlsb2FkLCBwYXlsb2FkX2VuYywgc2lnbmF0dXJlLCBzaWduYXR1cmVfZW5jIH0KZnVuY3Rpb24gam9zZS5wYXJzZV9qd3MoandzX2VuYykKICAgIGxvY2FsIHRqd3MgICAgPGNvbnN0PiA9IHN0cnRvayhPLnRvX3N0cmluZyhqd3NfZW5jKSwgJy4nKQogICAgaWYgdGp3c1sxXSA9PSAnJyB0aGVuIGVycm9yKCJUaGUgSldTIGhhcyBubyBoZWFkZXIiLCAyKSBlbmQKICAgIGlmIG5vdCBKU09OLnZhbGlkYXRlKE8uZnJvbV91cmw2NCh0andzWzFdKTpzdHJpbmcoKSkgdGhlbgogICAgICAgIGVycm9yKCJUaGUgSldTIGhlYWRlciBpcyBub3QgYSB2YWxpZCBKU09OIiwyKSBlbmQKICAgIGlmIHRqd3NbM10gPT0gJycgdGhlbiBlcnJvcigiVGhlIEpXUyBoYXMgbm8gc2lnbmF0dXJlIiwgMikgZW5kCiAgICBsb2NhbCBobyA8Y29uc3Q+ID0gTy5mcm9tX3N0cmluZyh0andzWzFdKQogICAgbG9jYWwgcmVzID0gewogICAgICAgIGhlYWRlcl9lbmMgPSBobywKICAgICAgICBoZWFkZXIgPSBKU09OLmRlc2VyaWFsaXplKGhvKQogICAgfQogICAgaWYgbHVhdHlwZShyZXMuaGVhZGVyKSB+PSAndGFibGUnIHRoZW4KICAgICAgICBlcnJvcignVGhlIEpXUyBoZWFkZXIgaXMgbm90IGEgZGljdGlvbmFyeScsIDIpIGVuZAogICAgaWYgdGp3c1syXSB+PSAnJyB0aGVuCiAgICAgICAgbG9jYWwgcG8gPGNvbnN0PiA9IE8uZnJvbV9zdHJpbmcodGp3c1syXSkKICAgICAgICByZXMucGF5bG9hZF9lbmMgPSBwbwogICAgICAgIHJlcy5wYXlsb2FkID0gSlNPTi5kZXNlcmlhbGl6ZShwbykKICAgIGVuZAogICAgbG9jYWwgc28gPGNvbnN0PiA9IE8uZnJvbV9zdHJpbmcodGp3c1szXSkKICAgIHJlcy5zaWduYXR1cmVfZW5jID0gc28KICAgIHJlcy5zaWduYXR1cmUgPSBKU09OLmRlc2VyaWFsaXplKHNvKQogICAgcmV0dXJuIHJlcwplbmQKCi0tIEV4dHJhY3QgdGhlIHB1YmxpYyBrZXkgZnJvbSBhIEpXSyBpbnNpZGUgdGhlIGEgSldTIGhlYWRlcjogaXQgbWF5Ci0tIGNvbnRhaW4gdGhlIHBrIG9mIHRoZSBzaWduYXR1cmUgd2hlbiB0eXAgaXMgZHBvcCtqd3QgYW5kIGhlYWRlci5qd2sKLS0gaXMgcHJlc2VudCBhbW9uZyBvdGhlciByZXF1aXJlbWVudHMgZGVmaW5lZCBpbjoKLS0gb2F1dGgtZHBvcCdzIDQuMi4gRFBvUCBQcm9vZiBKV1QgU3ludGF4Ci0tIGh0dHBzOi8vd3d3LmlldGYub3JnL2FyY2hpdmUvaWQvZHJhZnQtaWV0Zi1vYXV0aC1kcG9wLTEzLmh0bWwKLS0gQHBhcmFtIGhlYWRlciB0aGUgandzIGhlYWRlciB0aGF0IHNob3VsZCBjb250YWluIHRoZSBwdWJsaWMga2V5Ci0tIEBwYXJhbSBjcnlwdG8gY3J5cHRvIGFsZ28gdGhhdCBpcyBhbHJlYWR5IHJlc29sdmVkIGZvciB0aGlzIGhlYWRlcgotLSBAcmV0dXJuIHBrIGFuZCBjcnlwdG8gYWxnbwpmdW5jdGlvbiBqb3NlLmp3a190b19wayhoZWFkZXIsIGNyeXB0bykKICAgIGlmIGhlYWRlci50eXAgfj0gJ2Rwb3Arand0JyB0aGVuCiAgICAgICAgd2FybigiSldTIHR5cGUgaXMgbm90ICdkcG9wK2p3dCc6ICIuLihoZWFkZXIudHlwIG9yICduaWwnKSkKICAgICAgICAtLSByZXR1cm4gbmlsCiAgICBlbmQKICAgIGlmIG5vdCBoZWFkZXIuandrIHRoZW4KICAgICAgICB3YXJuKCJKV1MgaGVhZGVyIGRvZXNuJ3QgY29udGFpbnMgYSBqd2siKQogICAgICAgIHJldHVybiBuaWwKICAgIGVuZAogICAgaWYgaGVhZGVyLmp3ay5rdHkgfj0gJ0VDJyB0aGVuCiAgICAgICAgd2FybignSldLIHB1YmxpYyBrZXkgdHlwZSBpcyBub3QgRUMnLCAyKQogICAgICAgIHJldHVybiBuaWwKICAgIGVuZAogICAgaWYgbm90IGhlYWRlci5qd2suY3J2IHRoZW4KICAgICAgICB3YXJuKCdKV0sgY3VydmUgdHlwZSB1bmRlZmluZWQnLCAyKQogICAgICAgIHJldHVybiBuaWwKICAgIGVuZAogICAgbG9jYWwgandrX2NyeXB0byA8Y29uc3Q+ID0KICAgICAgICBDUllQVE8ubG9hZChoZWFkZXIuandrLmNydikKICAgIGlmIGNyeXB0byBhbmQgandrX2NyeXB0by5rZXluYW1lIH49IGNyeXB0by5rZXluYW1lIHRoZW4KICAgICAgICB3YXJuKCdKV0sgY3J5cHRvIGFsZ28gaXMgZGlmZmVyZW50IGZyb20gSldTOiAnLi5qd2tfY3J5cHRvLmtleW5hbWUpCiAgICAgICAgcmV0dXJuIG5pbAogICAgZW5kCiAgICBsb2NhbCByZXMKICAgIGlmIGhlYWRlci5qd2sueCBhbmQgaGVhZGVyLmp3ay55IHRoZW4KICAgICAgICByZXMgPSBPLmZyb21fdXJsNjQoaGVhZGVyLmp3ay54KTpwYWQoMzIpCiAgICAgICAgICAgIC4uTy5mcm9tX3VybDY0KGhlYWRlci5qd2sueSk6cGFkKDMyKQogICAgZWxzZQogICAgICAgIHdhcm4oIkpXSyBtaXNzZXMgcHVibGljIGtleSBjb29yZGluYXRlcyB4L3kiLCAyKQogICAgICAgIHJldHVybiBuaWwKICAgIGVuZAogICAgcmV0dXJuIHJlcywgandrX2NyeXB0bwplbmQKCnJldHVybiBqb3NlCi9jcnlwdG9fbGFncmFuZ2VfaW50ZXJwb2xhdGlvbi5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjAtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tIEltcGxlbWVudGF0aW9uIGJ5IEFsYmVydG8gSWJyaXNldmljaCBhbmQgRGVuaXMgUm9pbwotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IEFsYmVydG8gTGVyZGEKLS1vbiBUdWVzZGF5LCAwNHRoIE9jdG9iZXIgMjAyMQotLV1dCgoKbG9jYWwgbGkgPSB7CiAgIF9WRVJTSU9OID0gJ2NyeXB0b19sYWdyYW5nZV9pbnRlcnBvbGF0aW9uLmx1YSAxLjAnLAogICBfVVJMID0gJ2h0dHBzOi8vemVucm9vbS5keW5lLm9yZycsCiAgIF9ERVNDUklQVElPTiA9ICdTZWNyZXQgU2hhcmluZyBiYXNlZCBvbiBCSUcgSU5UIHVzaW5nIExhZ3JhbmdlIEludGVycG9sYXRpb24gb3ZlciAxc3Qgb3JkZXIgZWxsaXB0aWMgY3VydmVzIixBdHRyaWJ1dGUtYmFzZWQgY3JlZGVudGlhbCBzeXN0ZW0gc3VwcG9ydGluZyBtdWx0aXBsZSB1bmxpbmthYmxlIHByaXZhdGUgYXR0cmlidXRlIHJldmVsYXRpb25zJywKICAgX0xJQ0VOU0UgPSBbWwpMaWNlbnNlZCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBQdWJsaWMgTGljZW5zZSBhcyBwdWJsaXNoZWQgYnkKdGhlIEZyZWUgU29mdHdhcmUgRm91bmRhdGlvbjsgZWl0aGVyIHZlcnNpb24gMyBvZiB0aGUgTGljZW5zZSwgb3IKKGF0IHlvdXIgb3B0aW9uKSBhbnkgbGF0ZXIgdmVyc2lvbi4gIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlCmxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmUgZGlzdHJpYnV0ZWQgdW5kZXIgdGhlIExpY2Vuc2UKaXMgZGlzdHJpYnV0ZWQgb24gYW4gIkFTIElTIiBCQVNJUywgV0lUSE9VVCBXQVJSQU5USUVTIE9SCkNPTkRJVElPTlMgT0YgQU5ZIEtJTkQsIGVpdGhlciBleHByZXNzIG9yIGltcGxpZWQuCl1dCn0KCi0tIHRoZSBiaWdnZXN0IHByaW1lIGxlc3MgdGhhbiAyXigzMio4KQotLSBjb21wdXRlZCB3aXRoCi0tIGk6PTJeKDMyKjgpOwotLSB3aGlsZSBpIGdlIDJeKDMxKjgpIGRvCi0tICAgICBpZiBJc1ByaW1lKGkpIHRoZW4KLS0gICAgICAgICBwcmludChpKTsKLS0gICAgICAgICBicmVhazsKLS0gICAgIGVuZCBpZjsKLS0gICAgIGk6PWktMTsKLS0gZW5kIHdoaWxlOwoKLS0gYXQgaHR0cDovL21hZ21hLm1hdGhzLnVzeWQuZWR1LmF1L2NhbGMvCgotLSAxMTU3OTIwODkyMzczMTYxOTU0MjM1NzA5ODUwMDg2ODc5MDc4NTMyNjk5ODQ2NjU2NDA1NjQwMzk0NTc1ODQwMDc5MTMxMjk2Mzk3NDcKCgpsb2NhbCBvY3RQID0gTy5mcm9tX2hleCgnZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmY0MycpCmxvY2FsIFAgPSBCSUcubmV3KG9jdFApCi0tIGFzc2VydChQOm9jdGV0KCkgPT0gb2N0UCkKCmZ1bmN0aW9uIGxpLmNyZWF0ZV9zaGFyZWRfc2VjcmV0KHRvdGFsLCBxdW9ydW0sIHNlY3JldCkKICAgaWYgcXVvcnVtID49IHRvdGFsIHRoZW4KICAgICAgZXJyb3IoJ0Vycm9yIGNhbGxpbmcgY3JlYXRlX3NoYXJlZF9zZWNyZXQ6IHF1b3J1bSAoJy4ucXVvcnVtLi4nKSBtdXN0IGJlIHNtYWxsZXIgdGhhbiB0b3RhbCAoJy4udG90YWwuLicpJywgMikKICAgZW5kCiAgIGlmIG5vdCBzZWNyZXQgdGhlbgoJICBlcnJvcignU2VjcmV0IG5vdCBwcm92aWRlZCB0byBzaGFyZWQgc2VjcmV0IGNyZWF0aW9uJywgMikKICAgZW5kCiAgIC0tIGNoZWNrIHRoYXQgQklHIGNhbiBjb250YWluIHRoZSB3aG9sZSBzZWNyZXQsIGRlcGVuZHMgZnJvbSBjdXJ2ZSdzIHNpemUgYW5kIHRoZSBjaG9vc2VuIHByaW1lIFAKICAgbG9jYWwgc2VjYmlnID0gQklHLm5ldyhzZWNyZXQpCiAgIGlmIHNlY2JpZzpvY3RldCgpIH49IHNlY3JldCBvciBzZWNiaWcgPiBQIHRoZW4KICAgICAgZXJyb3IoJ1NlY3JldCBleGNlZWRzIG1heGltdW0gQklHIHNpemU6ICcuLiNPLi4nIGJ5dGVzIG9yIHRoZSBzaXplIG9mIHRoZSBjaG9vc2VuIHByaW1lJykKICAgZW5kCiAgIHNlY2JpZyA9IHNlY2JpZyAlIFAKICAgLS0gZ2VuZXJhdGlvbiBvZiB0aGUgY29lZmZpY2llbnRzIG9mIHRoZSBzZWNyZXQgcG9seW5vbWlhbAogICBsb2NhbCBjb2VmZiA9IHsgc2VjYmlnIH0KICAgLS0gdGFrZSBsYXN0IGFyZ3VtZW50IG9yIGNyZWF0ZSByYW5kb20KICAgZm9yIGk9MixxdW9ydW0sMSBkbwogICAgICBjb2VmZltpXSA9IEJJRy5tb2RyYW5kKFApCiAgIGVuZAogICAtLWdlbmVyYXRpb24gb2YgdGhlIHNoYXJlcwogICBsb2NhbCBzaGFyZXMgPSB7IH0KICAgZm9yIGk9MSx0b3RhbCwxIGRvCiAgICAgIGxvY2FsIHgKICAgICAgcmVwZWF0CgkgeCA9IEJJRy5tb2RyYW5kKFApCgkgaWYgeCB+PTAgdGhlbgoJICAgIC0tY2hlY2tpbmcgZm9yIGR1cGxpY2F0ZXMgaW4gc2hhcmVzCgkgICAgZm9yIF8sIGsgaW4gcGFpcnMoc2hhcmVzKSBkbwoJICAgICAgIGlmIHggPT0gayB0aGVuIHggPSAwIGVuZAoJICAgIGVuZAoJIGVuZAogICAgICB1bnRpbCB4IH49IDAJLS10aGlzIHBhcnQgcHJvdmlkZXMgdHJpdmlhbCB1bmxlYWthYmlsaXR5OiB4IGNvb3JkaW5hdGUgaXMgbmV2ZXIgemVybwoKICAgICAgbG9jYWwgeSA9IGNvZWZmWzFdICAgICAtLWFfMAogICAgICBsb2NhbCB4X24gPSBCSUcubmV3KDEpCiAgICAgIGZvciBuPTIscXVvcnVtLDEgZG8KCSB4X24gPSB4X246bW9kbXVsKHgsIFApIC0tIHheKG4tMSkKCSB5ID0gQklHLmFkZCh5LCBjb2VmZltuXTptb2RtdWwoeF9uLCBQKSkKCSB5ID0gQklHLm1vZCh5LCBQKSAtLSArYV8obi0xKXheKG4tMSkKICAgICAgZW5kCiAgICAgIHRhYmxlLmluc2VydChzaGFyZXMsIHt4ID0geCwgeSA9IHl9KQogICBlbmQgLS0gZm9yIGksdG90YWwKICAgLS0gb3ZlcndyaXRlIHNlY3JldCBmb3Igc2VjdXJlIGRpc3Bvc2FsCiAgIHJldHVybiBzaGFyZXMsIGNvZWZmWzFdCmVuZAoKZnVuY3Rpb24gbGkuY29tcG9zZV9zaGFyZWRfc2VjcmV0KHNoYXJlcykKICAgbG9jYWwgc2VjID0gQklHLm5ldygwKQogICBsb2NhbCBudW0KICAgbG9jYWwgZGVuCiAgIGxvY2FsIHF1b3J1bSA9ICNzaGFyZXMKICAgZm9yIGkgPSAxLHF1b3J1bSwxIGRvCiAgICAgIG51bSA9IEJJRy5uZXcoMSkKICAgICAgaWYgcXVvcnVtICUgMiA9PSAwIHRoZW4KCSBudW0gPSBQIC0gbnVtCiAgICAgIGVuZAogICAgICBkZW4gPSBCSUcubmV3KDEpCiAgICAgIGZvciBqID0gMSxxdW9ydW0sMSBkbwoJIGlmIGp+PWkgdGhlbgoJICAgIG51bSA9IG51bTptb2RtdWwoc2hhcmVzW2pdLngsIFApCgkgICAgZGVuID0gZGVuOm1vZG11bCgoc2hhcmVzW2ldLngpOm1vZHN1YihzaGFyZXNbal0ueCwgUCksIFApCgkgZW5kCiAgICAgIGVuZAogICAgICBzZWMgPSBCSUcuYWRkKHNlYywgKHNoYXJlc1tpXS55KTptb2RtdWwobnVtOm1vZGRpdihkZW4sIFApLCBQKSkKICAgICAgc2VjID0gQklHLm1vZChzZWMsIFApCiAgIGVuZAogICByZXR1cm4gc2VjCmVuZAoKcmV0dXJuIGxpCi9jcnlwdG9fbG9hZGVyLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IE1hdHRlbyBDcmlzdGlubwotLW9uIEZyaWRheSwgMjB0aCBKdW5lIDIwMjUKLS1dXQoKbG9jYWwgY3J5cHRvID0gewogICAgYWxnb3MgPSB7CiAgICAgICAgeyBJQU5BID0gJ0VERFNBJywKICAgICAgICAgIGtleXJpbmcgPSAnZWRkc2EnLAogICAgICAgICAgbGliID0gJ2VkZHNhJywKICAgICAgICAgIGFsaWFzID0geyAnZWQyNTUxOScgfSwKICAgICAgICAgIG1ldGhvZHMgPSB7IH0gLS0gZGVmYXVsdCBuYW1lcyBzaWduPXNpZ24sIHZlcmlmeT12ZXJpZnksIGV0YwogICAgICAgIH0sCiAgICAgICAgeyBJQU5BID0gJ0VTMjU2SycsCiAgICAgICAgICBrZXlyaW5nID0gJ2VjZGgnLAogICAgICAgICAgbGliID0gJ2VjZGgnLAogICAgICAgICAgYWxpYXMgPSB7ICdlY2RzYScsICdzZWNwMjU2azEnIH0sCiAgICAgICAgICBtZXRob2RzID0geyB9CiAgICAgICAgfSwKICAgICAgICB7IElBTkEgPSAnRVMyNTYnLAogICAgICAgICAga2V5cmluZyA9ICdlczI1NicsCiAgICAgICAgICBsaWIgPSAnZXMyNTYnLAogICAgICAgICAgYWxpYXMgPSB7ICdwMjU2JywgJ2VzLTI1NicsICdzZWNwMjU2cjEnLCAncC0yNTYnIH0sCiAgICAgICAgICBtZXRob2RzID0geyB9CiAgICAgICAgfSwKICAgICAgICB7IElBTkEgPSAnTUwtRFNBLTQ0JywKICAgICAgICAgIGtleXJpbmcgPSAnbWxkc2E0NCcsCiAgICAgICAgICBsaWIgPSAncXAnLAogICAgICAgICAgYWxpYXMgPSB7ICdkaWxpdGhpdW0yLTQ0JywgJ2ZpcHMyMDQnLCAnZmlwczIwNC00NCcgfSwKICAgICAgICAgIC0tIGhlcmUgbWV0aG9kcyBoYXZlIG5hbWVzIGRpZmZlcmVudCBmcm9tIHNpZ24sIHZlcmlmeSwgZXRjLgogICAgICAgICAgbWV0aG9kcyA9IHsgc2lnbiAgID0gJ21sZHNhNDRfc2lnbmF0dXJlJywKICAgICAgICAgICAgICAgICAgICAgIHZlcmlmeSA9ICdtbGRzYTQ0X3ZlcmlmeScsCiAgICAgICAgICAgICAgICAgICAgICBwdWJnZW4gPSAnbWxkc2E0NF9wdWJnZW4nICB9CiAgICAgICAgfQogICAgfQp9CgotLSBjYXNlIGluc2Vuc2l0aXZlIHNlYXJjaCBvZiBhIHN0cmluZyBpbiBhbiBhcnJheSBvZiBzdHJpbmdzCmxvY2FsIGZ1bmN0aW9uIF9pc19mb3VuZChfYXJyLCBfb2JqKQogICAgbG9jYWwgZm91bmQgPSBmYWxzZQogICAgaWYgI19vYmogPiAzMiB0aGVuCiAgICAgICAgZXJyb3IoIkNSWVBUTyBhbGdvIG5hbWUgdG9vIGxvbmc6ICIuLl9vYmosMykKICAgIGVuZAogICAgbG9jYWwgbmVlZGxlID0gX29iajpsb3dlcigpCiAgICBpZiBfYXJyLklBTkE6bG93ZXIoKSA9PSBuZWVkbGUgdGhlbiBmb3VuZCA9IHRydWUgZW5kCiAgICBpZiBfYXJyLmtleXJpbmc6bG93ZXIoKSA9PSBuZWVkbGUgdGhlbiBmb3VuZCA9IHRydWUgZW5kCiAgICBmb3IgXyx2IGluIGlwYWlycyhfYXJyLmFsaWFzKSBkbwogICAgICAgIGlmIHYgPT0gbmVlZGxlIHRoZW4gZm91bmQgPSB0cnVlIGVuZAogICAgZW5kCiAgICByZXR1cm4gZm91bmQKZW5kCgotLSB0YWtlIGFueSBrbm93biBzdHJpbmcgZm9yIGFuIGFsZ28gbmFtZSBhbmQgcmV0dXJuIElBTkEKLS0ga2VlcCBjb25zdGFudCB0aW1lIChzaWRlIGNoYW5uZWwgYXR0YWNrIG1pdGlnYXRpb24pCmxvY2FsIGZ1bmN0aW9uIF9sb29rdXAoaWQpCiAgICBsb2NhbCByZXMKICAgIGZvciBfLHYgaW4gaXBhaXJzKGNyeXB0by5hbGdvcykgZG8KICAgICAgICBpZiBfaXNfZm91bmQodixpZCkgdGhlbgogICAgICAgICAgICBsb2NhbCBsaWIgPGNvbnN0PiA9IHJlcXVpcmVfb25jZSh2LmxpYikKICAgICAgICAgICAgcmVzID0geyBJQU5BID0gdi5JQU5BLAogICAgICAgICAgICAgICAgICAgIGtleW5hbWUgPSB2LmtleXJpbmcsCiAgICAgICAgICAgICAgICAgICAgY2xhc3MgPSBsaWIsIC0tIGRpcmVjdCBhY2Nlc3MgdG8gbGliIG1ldGhvZHMKICAgICAgICAgICAgICAgICAgICBzaWduID0gICBsaWJbdi5tZXRob2RzLnNpZ24gICBvciAnc2lnbiddLAogICAgICAgICAgICAgICAgICAgIHZlcmlmeSA9IGxpYlt2Lm1ldGhvZHMudmVyaWZ5IG9yICd2ZXJpZnknXSwKICAgICAgICAgICAgICAgICAgICBwdWJnZW4gPSBsaWJbdi5tZXRob2RzLnB1YmdlbiBvciAncHViZ2VuJ10KICAgICAgICAgICAgICAgICAgfQogICAgICAgIGVuZAogICAgZW5kCiAgICBpZiByZXMgdGhlbiByZXR1cm4gcmVzIGVuZAogICAgZXJyb3IoIkNyeXB0byBhbGdvcml0aG0gbm90IGZvdW5kOiAiLi5pZCwyKQplbmQKCi0tIExvYWQgKHJlcXVpcmUtb25jZSkgYW5kIHJldHVybiBjcnlwdG8gY2xhc3MsIHdpdGggZnVuY3Rpb24gcG9pbnRlcnMKLS0gZm9yIGNvbW1vbiBmdW5jdGlvbnMgYXMgd2VsbCBjb3JyZWN0IG5hbWUgYWNjb3JkaW5nIHRvOgotLSBodHRwczovL3d3dy5pYW5hLm9yZy9hc3NpZ25tZW50cy9qb3NlL2pvc2UueGh0bWwKLS0gVGhpcyBwcm9jZWR1cmUgYXZvaWRzIHVzZSBwcm9jZWR1cmFsIGJyYW5jaGluZyB0byBrZWVwIGNvbnN0YW50IHRpbWUKLS0gKHNpZGUgY2hhbm5lbCBhdHRhY2sgbWl0aWdhdGlvbikKLS0gQHBhcmFtIGFueSBzdHJpbmcgZGVzY3JpYmluZyB0aGUgY3J5cHRvIHNpZ25hdHVyZSBhbGdvCi0tIEByZXR1cm4gc3RydWN0IHsgbmFtZSwgc2lnbiwgdmVyaWZ5LCBwdWJnZW4sIHB1YmxpY194eSwga2V5bmFtZSwgLi4uIH0KZnVuY3Rpb24gY3J5cHRvLmxvYWQoYW55KQogICAgbG9jYWwgaWQKICAgIGxvY2FsIHQgPGNvbnN0PiA9IHR5cGUoYW55KQogICAgaWYgdCA9PSAnemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgIGlkID0gYW55OnRvX3N0cmluZygpCiAgICBlbHNlaWYgdCA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICAgaWQgPSBhbnkKICAgIGVsc2UKICAgICAgICBlcnJvcignQ1JZUFRPIGxvYWRlciB3cm9uZyBhcmd1bWVudCB0eXBlOiAnLi50LDIpCiAgICBlbmQKICAgIHJldHVybiBfbG9va3VwKGFueSkKZW5kCgpyZXR1cm4gY3J5cHRvCi9jcnlwdG9fbG9uZ2ZlbGxvdy5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCmxvY2FsIGNfemsgPSByZXF1aXJlX29uY2UnbG9uZ2ZlbGxvdycKCmxvY2FsIGxvbmdmZWxsb3cgPSB7IH0KCi0tIHZhbHVlcyB1c2VkIGFzIHRydWUgYW5kIGZhbHNlIGluIG1kb2MKbG9uZ2ZlbGxvd1sneWVzJ10gPSBPLmZyb21faGV4J2Y1JwoKbG9uZ2ZlbGxvd1snbm8nXSA9IE8uZnJvbV9oZXgnZjQnCgpsb25nZmVsbG93Lm1kb2NfZXhhbXBsZSA9IGZ1bmN0aW9uKG51bSkKICAgIGxvY2FsIHJlcyA8Y29uc3Q+ID0gY196ay5tZG9jX2V4YW1wbGUobnVtKQogICAgaWYgbm90IHJlcyB0aGVuCiAgICAgICAgZXJyb3IoIkxvbmdmZWxsb3ctWksgTURPQyBleGFtcGxlIG5vdCBmb3VuZDogIi4ubnVtLDIpCiAgICBlbmQKICAgIHJldHVybiByZXMKZW5kCgpsb25nZmVsbG93LmdlbmVyYXRlX2NpcmN1aXQgPSBmdW5jdGlvbihudW0pCiAgICAtLSBDIGZ1bmMgcmV0dXJucyB0aGUgY29tcHJlc3NlZCBjaXJjdWl0IGFuZDoKCS0tIGx1YV9wdXNoc3RyaW5nKEwsemtfc3BlYy0+c3lzdGVtKTsKCS0tIGx1YV9wdXNoc3RyaW5nKEwsemtfc3BlYy0+dmVyc2lvbik7CgktLSBsdWFfcHVzaHN0cmluZyhMLHprX3NwZWMtPm51bV9hdHRyaWJ1dGVzKTsKCS0tIGx1YV9wdXNoc3RyaW5nKEwsemtfc3BlYy0+Y2lyY3VpdF9oYXNoKTsKCiAgICBjb21wcmVzc2VkLCBzeXN0ZW0sIHZlcnNpb24sCiAgICAgICAgbnVtX2F0dHJpYnV0ZXMsIGNpcmN1aXRfaGFzaCA9IGNfemsuZ2VuX2NpcmN1aXQobnVtKQoKICAgIGxvY2FsIHJlcyA8Y29uc3Q+ID0geyBjb21wcmVzc2VkID0gY29tcHJlc3NlZCwKICAgICAgICAgICAgICAgICAgICAgICAgICBzeXN0ZW0gPSAgICAgTy5mcm9tX3N0cmluZyhzeXN0ZW0pLAogICAgICAgICAgICAgICAgICAgICAgICAgIHZlcnNpb24gPSAgICBJTlQubmV3KHZlcnNpb24pLAogICAgICAgICAgICAgICAgICAgICAgICAgIG51bV9hdHRyaWJ1dGVzID0gSU5ULm5ldyhudW1fYXR0cmlidXRlcyksCiAgICAgICAgICAgICAgICAgICAgICAgICAgaGFzaCA9ICAgICAgIE8uZnJvbV9oZXgoY2lyY3VpdF9oYXNoKSwKICAgICAgICAgICAgICAgICAgICAgICAgICB6a3NwZWMgPSAgICAgSU5ULm5ldyhudW0pIH0KICAgIGlmIG5vdCByZXMuY29tcHJlc3NlZCB0aGVuCiAgICAgICAgcmV0dXJuIG5pbAogICAgICAgIC0tIGVycm9yKCJMb25nZmVsbG93LVpLIGdlbmVyYXRlIGNpcmN1aXQgZmFpbHVyZSIsMikKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKCmxvbmdmZWxsb3cubWRvY19wcm92ZXIgPSBmdW5jdGlvbihjaXJjdWl0LCBtZG9jLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgcGt4LCBwa3ksCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFucywgYXR0ciwgbm93KQogICAgaWYgbm90IHR5cGUoY2lyY3VpdCk9PSd0YWJsZScgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIGNpcmN1aXQgbm90IGEgdGFibGUiLDIpCiAgICBlbHNlaWYgdHlwZShjaXJjdWl0LmNvbXByZXNzZWQpfj0nemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIGNvbXByZXNzZWQgY2lyY3VpdCBub3QgYW4gb2N0ZXQiLDIpCiAgICBlbHNlaWYgbm90IHR5cGUobWRvYyk9PSd6ZW5yb29tLm9jdGV0JyBvciBtZG9jIDwgNjQgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIE1ET0MgZWl0aGVyIHRvbyBzbWFsbCBvciBub3QgYW4gb2N0ZXQiLDIpCiAgICBlbHNlaWYgdHlwZSh0cmFucyl+PSd6ZW5yb29tLm9jdGV0JyBvciAjdHJhbnMgPCAzMiB0aGVuCiAgICAgICAgZXJyb3IoIkludmFsaWQgdHJhbnNjcmlwdCBub3QgYW4gb2N0ZXQiLDIpCiAgICBlbHNlaWYgI3BreCB+PSAzMiBvciAjcGt5IH49IDMyCiAgICAgICAgb3IgdHlwZShwa3gpIH49ICd6ZW5yb29tLm9jdGV0JwogICAgICAgIG9yIHR5cGUocGt5KSB+PSAnemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIHB1YmxpYyBrZXlzIGNvb3JkaW5hdGVzIHggb3IgeSIsMikKICAgIGVsc2VpZiB0eXBlKGF0dHIpfj0ndGFibGUnIG9yICNhdHRyIDwgMQogICAgICAgIG9yIG5vdCBhdHRyWzFdLmlkIG9yIG5vdCBhdHRyWzFdLnZhbHVlIHRoZW4KICAgICAgICBlcnJvcigiSW52YWxpZCBhdHRyaWJ1dGVzIHRhYmxlIiwyKQogICAgZW5kCiAgICBmb3IgXyx2IGluIGlwYWlycyhhdHRyKSBkbwogICAgICAgIGlmIG5vdCB2LmlkIHRoZW4gZXJyb3IoIk1pc3NpbmcgaWQgaW4gYXR0cmlidXRlcyB0YWJsZSIsMikgZW5kCiAgICAgICAgaWYgbm90IHYudmFsdWUgdGhlbiBlcnJvcigiTWlzc2luZyB2YWx1ZSBpbiBhdHRyaWJ1dGVzIHRhYmxlIiwyKSBlbmQKICAgICAgICBpZiBsdWF0eXBlKHYudmFsdWUpPT0ndGFibGUnIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgdGFibGUgdmFsdWUgaW4gYXR0cmlidXRlcyIsMikKICAgICAgICBlbmQKICAgICAgICBpZiBsdWF0eXBlKHYuaWQpPT0ndGFibGUnIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgdGFibGUgaWQgaW4gYXR0cmlidXRlcyIsMikKICAgICAgICBlbmQKICAgIGVuZAogICAgLS0gZ2V0IFVUQyB0aW1lIChaVUxVKSB1c2luZyAnISp0JyB0byBhdm9pZCB0aW1lem9uZSBjb252ZXJzaW9uCiAgICAtLSB0aGVuIGZvcm1hdCBhcyAiWVlZWS1NTS1ERFRISDpNTTpTU1oiICgyMCBjaGFycykKICAgIGxvY2FsIG5vd25vdyA8Y29uc3Q+ID0gbm93CiAgICAgICAgb3IgTy5mcm9tX3N0cmluZyhvcy5kYXRlKCIhJVktJW0tJWRUJUg6JU06JVNaIiwKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgb3MudGltZShvcy5kYXRlKCIhKnQiKSkpKQogICAgaWYgbm90IGlzX3p1bHVfZGF0ZShub3dub3cpIHRoZW4KICAgICAgICBlcnJvcigiVGltZXN0YW1wIGlzIG5vdCBpbiBJU08gODYwMSBmb3JtYXQiLDIpCiAgICBlbmQKICAgIGxvY2FsIHByb29mIDxjb25zdD4gPQogICAgeyB6ayAgICAgICAgID0gY196ay5tZG9jX3Byb3ZlKGNpcmN1aXQuY29tcHJlc3NlZCwKICAgICAgICAgICAgICAgICAgICAgICAgICAgbWRvYywgcGt4LCBwa3ksIHRyYW5zLAogICAgICAgICAgICAgICAgICAgICAgICAgICBhdHRyLCBub3dub3csIGNpcmN1aXQuemtzcGVjOmludCgpKSwKICAgICAgemtzcGVjICAgICA9IGNpcmN1aXQuemtzcGVjIH0KICAgIGlmIG5vdCBwcm9vZi56ayB0aGVuCiAgICAgICAgcmV0dXJuIG5pbAogICAgICAgIC0tIGVycm9yKCJFcnJvciBpbiBsb25nZmVsbG93IG1kb2NfcHJvdmUgQyBjYWxsIiwyKQogICAgZW5kCiAgICByZXR1cm4gcHJvb2YKZW5kCgpsb25nZmVsbG93Lm1kb2NfdmVyaWZpZXIgPSBmdW5jdGlvbihjaXJjdWl0LCBwcm9vZiwKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgcGt4LCBwa3ksIHRyYW5zLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBhdHRyLCBub3csIGRvY190eXBlKQogICAgaWYgbm90IHR5cGUoY2lyY3VpdCk9PSd0YWJsZScgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIGNpcmN1aXQgbm90IGEgdGFibGUiLDIpCiAgICBlbHNlaWYgdHlwZShjaXJjdWl0LmNvbXByZXNzZWQpfj0nemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIGNvbXByZXNzZWQgY2lyY3VpdCBub3QgYW4gb2N0ZXQiLDIpCiAgICBlbHNlaWYgY2lyY3VpdC56a3NwZWMgfj0gcHJvb2YuemtzcGVjIHRoZW4KICAgICAgICBlcnJvcigiQ2lyY3VpdCB6a3NwZWMgdmVyc2lvbiBkb2VzIG5vdCBtYXRjaCBwcm9vZiIsMikKICAgIGVsc2VpZiBub3QgdHlwZShwcm9vZik9PSd0YWJsZScKICAgICAgICBhbmQgdHlwZShwcm9vZi56aykgPT0gJ3plbnJvb20ub2N0ZXQnIHRoZW4KICAgICAgICBlcnJvcigiSW52YWxpZCBwcm9vZiBkb2VzIG5vdCBjb250YWluIGEgWksgb2N0ZXQiLDIpCiAgICBlbHNlaWYgdHlwZSh0cmFucyl+PSd6ZW5yb29tLm9jdGV0JyBvciAjdHJhbnMgPCAzMiB0aGVuCiAgICAgICAgZXJyb3IoIkludmFsaWQgdHJhbnNjcmlwdCBub3QgYW4gb2N0ZXQiLDIpCiAgICBlbHNlaWYgI3BreCB+PSAzMiBvciAjcGt5IH49IDMyCiAgICAgICAgb3IgdHlwZShwa3gpIH49ICd6ZW5yb29tLm9jdGV0JwogICAgICAgIG9yIHR5cGUocGt5KSB+PSAnemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIHB1YmxpYyBrZXlzIGNvb3JkaW5hdGVzIHggb3IgeSIsMikKICAgIGVsc2VpZiB0eXBlKGF0dHIpfj0ndGFibGUnIG9yICNhdHRyIDwgMQogICAgICAgIG9yIG5vdCBhdHRyWzFdLmlkIG9yIG5vdCBhdHRyWzFdLnZhbHVlIHRoZW4KICAgICAgICBlcnJvcigiSW52YWxpZCBhdHRyaWJ1dGVzIHRhYmxlIiwyKQogICAgZWxzZWlmIHR5cGUoZG9jX3R5cGUpIH49ICd6ZW5yb29tLm9jdGV0JyB0aGVuCiAgICAgICAgZXJyb3IoIkludmFsaWQgZG9jdHlwZSBub3QgYW4gb2N0ZXQ6ICIuLnR5cGUoZG9jX3R5cGUpKQogICAgZW5kCiAgICBmb3IgXyx2IGluIGlwYWlycyhhdHRyKSBkbwogICAgICAgIGlmIG5vdCB2LmlkIHRoZW4gZXJyb3IoIk1pc3NpbmcgaWQgaW4gYXR0cmlidXRlcyB0YWJsZSIsMikgZW5kCiAgICAgICAgaWYgbm90IHYudmFsdWUgdGhlbiBlcnJvcigiTWlzc2luZyB2YWx1ZSBpbiBhdHRyaWJ1dGVzIHRhYmxlIiwyKSBlbmQKICAgICAgICBpZiBsdWF0eXBlKHYudmFsdWUpPT0ndGFibGUnIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgdGFibGUgdmFsdWUgaW4gYXR0cmlidXRlcyIsMikKICAgICAgICBlbmQKICAgICAgICBpZiBsdWF0eXBlKHYuaWQpPT0ndGFibGUnIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgdGFibGUgaWQgaW4gYXR0cmlidXRlcyIsMikKICAgICAgICBlbmQKICAgIGVuZAogICAgLS0gZ2V0IFVUQyB0aW1lIChaVUxVKSB1c2luZyAnISp0JyB0byBhdm9pZCB0aW1lem9uZSBjb252ZXJzaW9uCiAgICAtLSB0aGVuIGZvcm1hdCBhcyAiWVlZWS1NTS1ERFRISDpNTTpTU1oiICgyMCBjaGFycykKICAgIGxvY2FsIG5vd25vdyA8Y29uc3Q+ID0gbm93CiAgICAgICAgb3IgTy5mcm9tX3N0cmluZyhvcy5kYXRlKCIhJVktJW0tJWRUJUg6JU06JVNaIiwKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgb3MudGltZShvcy5kYXRlKCIhKnQiKSkpKQogICAgaWYgbm90IGlzX3p1bHVfZGF0ZShub3dub3cpIHRoZW4KICAgICAgICBlcnJvcigiVGltZXN0YW1wIGlzIG5vdCBpbiBJU08gODYwMSBmb3JtYXQiLDIpCiAgICBlbmQKICAgIHJldHVybiBjX3prLm1kb2NfdmVyaWZ5KGNpcmN1aXQuY29tcHJlc3NlZCwKICAgICAgICAgICAgICAgICAgICAgICAgICAgIHByb29mLnprLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgcGt4LCBwa3ksCiAgICAgICAgICAgICAgICAgICAgICAgICAgICB0cmFucywKICAgICAgICAgICAgICAgICAgICAgICAgICAgIGF0dHIsCiAgICAgICAgICAgICAgICAgICAgICAgICAgICBub3dub3csCiAgICAgICAgICAgICAgICAgICAgICAgICAgICBkb2NfdHlwZSwKICAgICAgICAgICAgICAgICAgICAgICAgICAgIHByb29mLnprc3BlYzppbnQoKSkKZW5kCgpsb25nZmVsbG93LmNpcmN1aXRfaWQgPSBmdW5jdGlvbihjaXJjKQogICAgbG9jYWwgcmVzIDxjb25zdD4gPSBjX3prLmNpcmN1aXRfaWQoY2lyYy5jb21wcmVzc2VkLCBjaXJjLnprc3BlYzppbnQoKSkKICAgIGlmIG5vdCByZXMgdGhlbgogICAgICAgIGVycm9yKCJVbnJlY29nbml6ZWQgWksgY2lyY3VpdCBJRCIsMikKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKCnJldHVybiBsb25nZmVsbG93Ci9jcnlwdG9fcGV0aXRpb24ubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLUNvY29udXQgaW1wbGVtZW50YXRpb24gYnkgQWxiZXJ0byBTb25uaW5vIGFuZCBEZW5pcyBSb2lvCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFR1ZXNkYXksIDIwdGggSnVseSAyMDIxCi0tXV0KCmxvY2FsIHBldGl0aW9uID0geyB9Cgpsb2NhbCBHMSA9IEVDUC5nZW5lcmF0b3IoKQpsb2NhbCBPICA9IEVDUC5vcmRlcigpCgpmdW5jdGlvbiBwZXRpdGlvbi5wcm92ZV9zaWduX3BldGl0aW9uKHB1YiwgbSkKICAgIC0tIHNpZ24gPT0gdm90ZQogICAgbG9jYWwgayA9IElOVC5yYW5kb20oKQogICAgLS0gdm90ZSBlbmNyeXB0aW9uCiAgICBsb2NhbCBlbmNfdiA9IHsgbGVmdCA9IEcxICogaywKICAgICAgICAgICAgICAgICAgICByaWdodCA9IHB1YiAqIGsgKyBTQUxUICogbSB9CiAgICAtLSBvcHBvc2l0ZSBvZiB2b3RlIGVuY3J5cHRpb24KICAgIGxvY2FsIGVuY192X25lZyA9IHsgbGVmdCA9IGVuY192LmxlZnQ6bmVnYXRpdmUoKSwKICAgICAgICAgICAgICAgICAgICAgICAgcmlnaHQgPSBlbmNfdi5yaWdodDpuZWdhdGl2ZSgpICsgU0FMVCB9CiAgICAtLSBjb21taXRtZW50IHRvIHRoZSB2b3RlCiAgICBsb2NhbCByMSA9IElOVC5yYW5kb20oKQogICAgbG9jYWwgcjIgPSByMSAqIChCSUcubmV3KDEpIC0gbSkKICAgIGxvY2FsIGN2ID0gRzEgKiBtICsgU0FMVCAqIHIxCiAKICAgIC0tIHByb29mCiAgICAtLSBjcmVhdGUgdGhlIHdpdG5lc2VzcwogICAgbG9jYWwgd2sgPSBJTlQucmFuZG9tKCkKICAgIGxvY2FsIHdtID0gSU5ULnJhbmRvbSgpCiAgICBsb2NhbCB3cjEgPSBJTlQucmFuZG9tKCkKICAgIGxvY2FsIHdyMiA9IElOVC5yYW5kb20oKQogICAgLS0gY29tcHV0ZSB0aGUgd2l0bmVzc2VzcyBjb21taXRtZW50cwogICAgbG9jYWwgQXcgPSBHMSp3awogICAgbG9jYWwgQncgPSBwdWIqd2sgKyBTQUxUKndtCiAgICBsb2NhbCBDdyA9IEcxKndtICsgU0FMVCp3cjEKICAgIGxvY2FsIER3ID0gY3Yqd20gKyBTQUxUKndyMgogICAgLS0gY3JlYXRlIHRoZSBjaGFsbGVuZ2UKICAgIGxvY2FsIGMgPSBaS1BfY2hhbGxlbmdlKHtlbmNfdi5sZWZ0LCBlbmNfdi5yaWdodCwKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgY3YsIEF3LCBCdywgQ3csIER3fSkgJSBPCiAgICAtLSBjcmVhdGUgcmVzcG9uc2VzCiAgICBsb2NhbCByayA9IHdrIC0gYyAqIGsKICAgIGxvY2FsIHJtID0gd20gLSBjICogbQogICAgbG9jYWwgcnIxID0gd3IxIC0gYyAqIHIxCiAgICBsb2NhbCBycjIgPSB3cjIgLSBjICogcjIKICAgIGxvY2FsIHBpX3ZvdGUgPSB7IGMgPSBjLAogICAgICAgICAgICAgICAgICAgICAgcmsgPSByaywKICAgICAgICAgICAgICAgICAgICAgIHJtID0gcm0sCiAgICAgICAgICAgICAgICAgICAgICBycjEgPSBycjEsCiAgICAgICAgICAgICAgICAgICAgICBycjIgPSBycjIgfQogCiAgICAtLSBzaWduYXR1cmUncyBUaGV0YQogICAgcmV0dXJuIHsgc2NvcmVzID0geyBwb3MgPSBlbmNfdiwKICAgICAgICAgICAgICAgICAgICAgICAgbmVnID0gZW5jX3ZfbmVnIH0sIC0tIGxlZnQvcmlnaHQgdHVwbGVzCiAgICAgICAgICAgICBjdiA9IGN2LCAtLSBlY3AKICAgICAgICAgICAgIHBpX3ZvdGUgPSBwaV92b3RlIH0gLS0gcGkKIGVuZAogCiBmdW5jdGlvbiBwZXRpdGlvbi52ZXJpZnlfc2lnbl9wZXRpdGlvbihwdWIsIHRoZXRhKQogICAgLS0gcmVjb21wdXRlIHdpdG5lc3Nlc3MgY29tbWl0bWVudAogICAgbG9jYWwgc2NvcmVzID0gdGhldGEuc2NvcmVzLnBvcyAtLSBvbmx5IHBvc2l0aXZlLCBub3QgbmVnYXRpdmU/CiAgICBsb2NhbCBBdyA9IEcxICogdGhldGEucGlfdm90ZS5yawogICAgICAgKyBzY29yZXMubGVmdCAqIHRoZXRhLnBpX3ZvdGUuYwogICAgbG9jYWwgQncgPSBwdWIgKiB0aGV0YS5waV92b3RlLnJrCiAgICAgICArIFNBTFQgKiB0aGV0YS5waV92b3RlLnJtCiAgICAgICArIHNjb3Jlcy5yaWdodCAqIHRoZXRhLnBpX3ZvdGUuYwogICAgbG9jYWwgQ3cgPSBHMSAqIHRoZXRhLnBpX3ZvdGUucm0KICAgICAgICsgU0FMVCAqIHRoZXRhLnBpX3ZvdGUucnIxCiAgICAgICArIHRoZXRhLmN2ICogdGhldGEucGlfdm90ZS5jCiAgICBsb2NhbCBEdyA9IHRoZXRhLmN2ICogdGhldGEucGlfdm90ZS5ybQogICAgICAgKyBTQUxUICogdGhldGEucGlfdm90ZS5ycjIKICAgICAgICsgdGhldGEuY3YgKiB0aGV0YS5waV92b3RlLmMKICAgIC0tIHZlcmlmeSBjaGFsbGVuZ2UKICAgIHplbmNvZGVfYXNzZXJ0KHRoZXRhLnBpX3ZvdGUuYyA9PSBaS1BfY2hhbGxlbmdlKAogICAgICAgICAgICAgICAgICB7c2NvcmVzLmxlZnQsIHNjb3Jlcy5yaWdodCwKICAgICAgICAgICAgICAgICAgIHRoZXRhLmN2LCBBdywgQncsIEN3LCBEdyB9KSwKICAgICAgICAgICAgICAgInZlcmlmeV9zaWduX3BldGl0aW9uOiBjaGFsbGVuZ2UgZmFpbHMiKQogICAgcmV0dXJuIHRydWUKIGVuZAogCiBmdW5jdGlvbiBwZXRpdGlvbi5wcm92ZV90YWxseV9wZXRpdGlvbihzaywgc2NvcmVzKQogICAgbG9jYWwgd3ggPSBJTlQucmFuZG9tKCkKICAgIGxvY2FsIEF3ID0geyB3eDptb2RuZWcoTykgKiBzY29yZXMucG9zLmxlZnQsCiAgICAgICAgICAgICAgICAgd3g6bW9kbmVnKE8pICogc2NvcmVzLm5lZy5sZWZ0ICB9CiAgICBsb2NhbCBjID0gWktQX2NoYWxsZW5nZShBdykKICAgIGxvY2FsIHJ4ID0gd3ggLSBjICogc2sKICAgIGxvY2FsIGRlYyA9IHsgcG9zID0gc2NvcmVzLnBvcy5sZWZ0ICogc2s6bW9kbmVnKE8pLAogICAgICAgICAgICAgICAgICBuZWcgPSBzY29yZXMubmVnLmxlZnQgKiBzazptb2RuZWcoTykgfQogICAgLS0gcmV0dXJuIHBpX3RhbGx5CiAgICByZXR1cm4geyBkZWMgPSBkZWMsCiAgICAgICAgICAgICByeCA9IHJ4LAogICAgICAgICAgICAgYyA9IGMgICAgfQogZW5kCiAKIGZ1bmN0aW9uIHBldGl0aW9uLnZlcmlmeV90YWxseV9wZXRpdGlvbihzY29yZXMsIHBpX3RhbGx5KQogICAgbG9jYWwgcnhuZWcgPSBwaV90YWxseS5yeDptb2RuZWcoTykKICAgIGxvY2FsIEF3ID0geyByeG5lZypzY29yZXMucG9zLmxlZnQgKyBwaV90YWxseS5jICogcGlfdGFsbHkuZGVjLnBvcywKICAgICAgICAgICAgICAgICByeG5lZypzY29yZXMubmVnLmxlZnQgKyBwaV90YWxseS5jICogcGlfdGFsbHkuZGVjLm5lZyAgfQogICAgemVuY29kZV9hc3NlcnQocGlfdGFsbHkuYyA9PSBaS1BfY2hhbGxlbmdlKEF3KSwKICAgICAgICAgICAgICAgInZlcmlmeV90YWxseV9wZXRpdGlvbjogY2hhbGxlbmdlIGZhaWxzIikKICAgIHJldHVybiB0cnVlCiBlbmQKIAogZnVuY3Rpb24gcGV0aXRpb24uY291bnRfc2lnbmF0dXJlc19wZXRpdGlvbihzY29yZXMsIHBpX3RhbGx5KQogICAgbG9jYWwgcmVzdGFiID0geyB9CiAgICBmb3IgaWR4PTEsMTAwMCBkbwogICAgICAgLS0gaWYgaWR4IH49IDAgdGhlbiAtLSBub3QgemVybwogICAgICAgcmVzdGFiWyhCSUcubmV3KGlkeCkgKiBTQUxUKTpvY3RldCgpOmhleCgpXSA9IGlkeAogICAgICAgLS0gZW5kCiAgICBlbmQKICAgIGxvY2FsIHJlcyA9IHsgcG9zID0gc2NvcmVzLnBvcy5yaWdodCArIHBpX3RhbGx5LmRlYy5wb3MsCiAgICAgICAgICAgICAgICAgIG5lZyA9IHNjb3Jlcy5uZWcucmlnaHQgKyBwaV90YWxseS5kZWMubmVnICB9CiAgICByZXR1cm4geyBwb3MgPSByZXN0YWJbcmVzLnBvczpvY3RldCgpOmhleCgpXSwKICAgICAgICAgICAgIG5lZyA9IHJlc3RhYltyZXMubmVnOm9jdGV0KCk6aGV4KCldICB9CiBlbmQKCiByZXR1cm4gcGV0aXRpb24vY3J5cHRvX3B2c3MubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIzLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IFJlYmVjY2EgU2VsdmFnZ2luaSwgTHVjYSBEaSBEb21lbmljbwotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1dXQoKbG9jYWwgUFZTUyA9IHt9Cgpsb2NhbCBDVVJWRV9PUkRFUiA9IEVDUC5vcmRlcigpCgpsb2NhbCBHRU5FUkFUT1JTID0ge1siZyJdID0gRUNQLm5ldyhCSUcubmV3KE8uZnJvbV9oZXgoIjA3ZWYzZjdmNjEyM2IyZjVlMWNlN2MyNDllMGE0NGM4YjE4YjM2NzFlMTFkNWUyMzNkMTU3NDJjZjUzOGQwNjhmOTRkZmFlM2FjOTk2NmU2MjZhM2Q2NjcwZDc4YjZlZSIpKSwgQklHLm5ldyhPLmZyb21faGV4KCIxMmQ1YzIwZTNjZTcxNDNjMDM0OTE4MjBhN2IwOGMwNjdmMjViZDliNzI0OTg1Y2Q5NWVjODYyZjhjYmIzMWM5NDRmNDIwZTU5ZjhmODIwYmNjZjZlOTRiNzIyMzZjYTciKSkpLAogICAgWyJHIl0gPSBFQ1AubmV3KEJJRy5uZXcoTy5mcm9tX2hleCgiMGExN2Y1YzdlYTNhYmUzNjU0YzRiNTZkNzA5ZWZkMjkzZTE3ZTc5MzI3ZTE1YjJhN2VhYmFiZDAyYjIwZWRmMzNiYmEwYTZmZjJjODAxOTIzMzk5YzNjOWZkNmExNzE4IikpLCBCSUcubmV3KE8uZnJvbV9oZXgoIjEyZjY1NzliNzdkYmM2NDg1MTA3ZTY4ZmUxODFlMGFlYjY4MGY2NjU4ODBjN2RlZDFkYjVmODRjMGEzZmRjMTUyZjI5OTUxMWU0ZTVmNjRmMTQyMmQyMWMyNzZmODQ4YSIpKSl9CgotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0gTklaS1AgLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCgotLSBOT1RFOiB0aGUgaW5wdXRzIG9mIHRoZSBmb2xsb3dpbmcgMiBmdW5jdGlvbnMgYXJlIHBvaW50cyBvbiB0aGUgY3VydmUuCmZ1bmN0aW9uIFBWU1MuZGV0X2NvbmNhdGVuYXRpb24oaDEsIGgyLCBhMSwgYTIpCiAgICBsb2NhbCBjb25jYXQgPSBPLmZyb21fc3RyaW5nKGgxOngoKTpkZWNpbWFsKCkpIC4uIE8uZnJvbV9zdHJpbmcoaDE6eSgpOmRlY2ltYWwoKSkKICAgIGNvbmNhdCA9IGNvbmNhdCAuLiBPLmZyb21fc3RyaW5nKGgyOngoKTpkZWNpbWFsKCkpIC4uIE8uZnJvbV9zdHJpbmcoaDI6eSgpOmRlY2ltYWwoKSkKICAgIGNvbmNhdCA9IGNvbmNhdCAuLiBPLmZyb21fc3RyaW5nKGExOngoKTpkZWNpbWFsKCkpIC4uIE8uZnJvbV9zdHJpbmcoYTE6eSgpOmRlY2ltYWwoKSkKICAgIGNvbmNhdCA9IGNvbmNhdCAuLiBPLmZyb21fc3RyaW5nKGEyOngoKTpkZWNpbWFsKCkpIC4uIE8uZnJvbV9zdHJpbmcoYTI6eSgpOmRlY2ltYWwoKSkKICAgIHJldHVybiBjb25jYXQKZW5kCgpmdW5jdGlvbiBQVlNTLmNvbmNhdGVuYXRpb24oaDEsIGgyLCBhMSwgYTIpCiAgICByZXR1cm4gaDE6dG9femNhc2goKSAuLiBoMjp0b196Y2FzaCgpIC4uIGExOnRvX3pjYXNoKCkgLi4gYTI6dG9femNhc2goKQplbmQKCi0tIFRoaXMgZnVuY3Rpb24gaW1wbGVtZW50cyB0aGUgY3JlYXRpb24gb2YgYSBub24taW50ZXJhY3RpdmUgemVybyBrbndvbGVkZ2UgcHJvb2YKLS0gb2YgdGhlIGRpc2NyZXRlIGxvZ2FyaXRobSBlcXVhbGl0eS4KLS0gU2VjdGlvbiAzIG9mIGh0dHBzOi8vbGluay5zcHJpbmdlci5jb20vY2hhcHRlci8xMC4xMDA3LzMtNTQwLTQ4MDcxLTRfNwotLSBTZWN0aW9uIDMgb2YgaHR0cHM6Ly93d3cud2luLnR1ZS5ubC9+YmVycnkvcGFwZXJzL2NyeXB0bzk5LnBkZgotLSBwb2ludHNfdGFibGVzIGlzIGFuIGFycmF5IHdoZXJlIGVhY2ggY29tcG9uZW50IGlzIHtnMSwgaDEsIGcyLCBoMn0uCi0tIGFscGhhID0gYWxwaGFfYXJyYXlbaV0gaXMgc3VjaCB0aGF0IGcxXmFscGhhID0gaDEgYW5kIGcyXmFscGhhID0gaDIKLS0gZGV0X2NoYWxsOiBhcnJheSBmb3IgZGV0ZXJtaW5pc3RpYyBjaGFsbGVuZ2VzIHcsIHVzZWQganVzdCBmb3IgdGVzdGluZwotLSBjb25jYXRfZjogb3B0aW9uYWwgKGRlZnVhbHQgUFZTUy5jb25jYXRlbmF0aW9uKSwgZnVuY3Rpb24gdGhhdCBzcGVjaWZpZXMgdGhlIG9yZGVyIGFuZCBlbmNvZGluZyB1c2VkIGZvciB0aGUgb3V0cHV0Ci0tIGhhc2g6IG9wdGlvbmFsIHBhcmFtZXRlciwgaWYgbm90IHByb3ZpZGVkIGRlZmF1bHQgdG8gU0hBLTI1NgpmdW5jdGlvbiBQVlNTLmNyZWF0ZV9wcm9vZl9ETEVRKHBvaW50c190YWJsZXMsIGFscGhhX2FycmF5LCBoYXNoLCBjb25jYXRfZiwgZGV0X2NoYWxsKQogICAgbG9jYWwgaGFzaF9mdW5jdGlvbiA9IGhhc2ggb3Igc2hhMjU2CiAgICBsb2NhbCBjb25jYXRfZnVuY3Rpb24gPSBjb25jYXRfZiBvciBQVlNTLmNvbmNhdGVuYXRpb24KICAgIGxvY2FsIHdfYXJyYXkgPSB7fQogICAgbG9jYWwgcl9hcnJheSA9IHt9CiAgICBsb2NhbCBjb25jYXQgPSBPLmVtcHR5KCkKICAgIGZvciBrLHYgaW4gcGFpcnMocG9pbnRzX3RhYmxlcykgZG8KICAgICAgICBsb2NhbCBnMSwgaDEsIGcyLCBoMiA9IHRhYmxlLnVucGFjayh2KQogICAgICAgIGxvY2FsIHcKICAgICAgICBpZihkZXRfY2hhbGwpIHRoZW4KICAgICAgICAgICAgdyA9IGRldF9jaGFsbFtrXQogICAgICAgIGVsc2UKICAgICAgICAgICAgdyA9IEJJRy5tb2RyYW5kKENVUlZFX09SREVSKQogICAgICAgIGVuZAogICAgICAgIHdfYXJyYXlba10gPSB3CiAgICAgICAgbG9jYWwgYTEgPSBnMSAqIHcKICAgICAgICBsb2NhbCBhMiA9IGcyICogdwogICAgICAgIGNvbmNhdCA9IGNvbmNhdCAuLiBjb25jYXRfZnVuY3Rpb24oaDEsIGgyLCBhMSwgYTIpCiAgICBlbmQKICAgIGxvY2FsIGMgPSBoYXNoX2Z1bmN0aW9uKGNvbmNhdCkKICAgIGMgPSBCSUcubW9kKCBCSUcubmV3KGMpICwgQ1VSVkVfT1JERVIpCgogICAgZm9yIGssYWxwaGEgaW4gcGFpcnMoYWxwaGFfYXJyYXkpIGRvCiAgICAgICAgbG9jYWwgciA9IGFscGhhOm1vZG11bChjLCBDVVJWRV9PUkRFUikKICAgICAgICByX2FycmF5W2tdID0gQklHLm1vZHN1Yih3X2FycmF5W2tdLCByLCBDVVJWRV9PUkRFUikKICAgIGVuZAogICAgdGFibGUuaW5zZXJ0KHJfYXJyYXksIDEsIGMpCiAgICByZXR1cm4gcl9hcnJheQplbmQKCi0tIFRoaXMgZnVuY3Rpb24gaW1wbGVtZW50cyB0aGUgdmVyaWZpY2F0aW9uIG9mIGEgbm9uLWludGVyYWN0aXZlIHplcm8ga253b2xlZGdlIHByb29mCi0tIG9mIHRoZSBkaXNjcmV0ZSBsb2dhcml0aG0gZXF1YWxpdHkuCi0tIFNlY3Rpb24gMyBvZiBodHRwczovL2xpbmsuc3ByaW5nZXIuY29tL2NoYXB0ZXIvMTAuMTAwNy8zLTU0MC00ODA3MS00XzcKLS0gU2VjdGlvbiAzIG9mIGh0dHBzOi8vd3d3Lndpbi50dWUubmwvfmJlcnJ5L3BhcGVycy9jcnlwdG85OS5wZGYKLS0gcG9pbnRzX3RhYmxlczogc2VlIFBWU1MuY3JlYXRlX3Byb29mX0RMRVEKLS0gcHJvb2Y6IHRhYmxlIGNvbnRhaW5pbmcsIGluIG9yZGVyLCB0aGUgY2hhbGxlbmdlIGFuZCB0aGUgcmVzcG9uc2UocykuCi0tIGhhc2ggYW5kIGNvbmNhdF9mOiBzZWUgUFZTUy5jcmVhdGVfcHJvb2ZfRExFUQpmdW5jdGlvbiBQVlNTLnZlcmlmeV9wcm9vZl9ETEVRKHBvaW50c190YWJsZXMsIHByb29mLCBoYXNoLCBjb25jYXRfZikKICAgIGxvY2FsIGhhc2hfZnVuY3Rpb24gPSBoYXNoIG9yIHNoYTI1NgogICAgbG9jYWwgY29uY2F0X2Z1bmN0aW9uID0gY29uY2F0X2Ygb3IgUFZTUy5jb25jYXRlbmF0aW9uCiAgICBsb2NhbCBjb25jYXQgPSBPLmVtcHR5KCkKICAgIGxvY2FsIGMgPSB0YWJsZS5yZW1vdmUocHJvb2YsIDEpCiAgICBmb3Igayx2IGluIHBhaXJzKHBvaW50c190YWJsZXMpIGRvCiAgICAgICAgbG9jYWwgZzEsIGgxLCBnMiwgaDIgPSB0YWJsZS51bnBhY2sodikKICAgICAgICBsb2NhbCByID0gcHJvb2Zba10KICAgICAgICBsb2NhbCBhMSA9IChnMSAqIHIpICsgKGgxICogYykKICAgICAgICBsb2NhbCBhMiA9IChnMiAqIHIpICsgKGgyICogYykKICAgICAgICBjb25jYXQgPSBjb25jYXQuLmNvbmNhdF9mdW5jdGlvbihoMSwgaDIsIGExLCBhMikKICAgIGVuZAogICAgdGFibGUuaW5zZXJ0KHByb29mLDEsYykKICAgIGxvY2FsIGRpZ2VzdCA9IGhhc2hfZnVuY3Rpb24oY29uY2F0KQoKICAgIHJldHVybiAoKEJJRy5tb2QoQklHLm5ldyhkaWdlc3QpLCBDVVJWRV9PUkRFUikpID09IGMpCmVuZAoKLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSBQVlNTIGluaXRpYWxpemF0aW9uIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KCi0tIEdpdmVuIGEgbnVtYmVyIG4gYW5kIGEgcHJpbWUgcCwgaXQgcmV0dXJucyBhIHRhYmxlIGNvbnRhaW5pbmcgbiBkaWZmZXJlbnQgZ2VuZXJhdG9ycyBvZiB0aGUgY3VydmUuCi0tIE5PVEUgdGhhdCBmb3IgQkxTMTItMzgxIHAgaXMgRUNQLnByaW1lKCkgYW5kIHIgaXMgRUNQLm9yZGVyKCkuCmxvY2FsIGZ1bmN0aW9uIGNyZWF0ZV9nZW5lcmF0b3JzKG4sIHAsIHIpCiAgICBsb2NhbCBnZW5lcmF0b3JzID0ge30KICAgIHdoaWxlICNnZW5lcmF0b3JzIDwgbiBkbwogICAgICAgIGxvY2FsIHggPSBCSUcubW9kcmFuZChwKQogICAgICAgIGxvY2FsIHJocyA9IEVDUC5yaHMoeCkKICAgICAgICB3aGlsZSBCSUcuamFjb2JpKHJocywgcCkgfj0gMSBkbwogICAgICAgICAgICB4ID0gQklHLm1vZHJhbmQocCkKICAgICAgICAgICAgcmhzID0gRUNQLnJocyh4KQogICAgICAgIGVuZAogICAgICAgIGxvY2FsIHkgPSBCSUcubW9kc3FydChyaHMsIHApCiAgICAgICAgbG9jYWwgcG9pbnQgPSBFQ1AubmV3KHgseSkKICAgICAgICAtLSBzZWUgZnVuY3Rpb24gY2xlYXIgY29mYWN0b3IgaW4gc3JjL2x1YS9jcnlwdG9fYmJzLmx1YQogICAgICAgIC0tIE5PVEUgdGhhdCB0aGlzIHdvcmtzIG9ubHkgb24gQkxTMTItMzgxIGN1cnZlCiAgICAgICAgbG9jYWwgaF9lZmYgPSBCSUcubmV3KE8uZnJvbV9oZXgoJ2QyMDEwMDAwMDAwMTAwMDEnKSkKICAgICAgICBwb2ludCA9IHBvaW50ICogaF9lZmYKICAgICAgICBpZiAocG9pbnQqciA9PSBFQ1AuaW5maW5pdHkoKSkgdGhlbgogICAgICAgICAgICBsb2NhbCBmbGFnID0gdHJ1ZQogICAgICAgICAgICBmb3IgXyxrIGluIHBhaXJzKGdlbmVyYXRvcnMpIGRvCiAgICAgICAgICAgICAgICBpZiBwb2ludCA9PSBrIHRoZW4KICAgICAgICAgICAgICAgICAgICBmbGFnID0gZmFsc2UKICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICBlbmQKICAgICAgICAgICAgaWYgZmxhZyB0aGVuCiAgICAgICAgICAgICAgICB0YWJsZS5pbnNlcnQoZ2VuZXJhdG9ycywgcG9pbnQpCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgZW5kCiAgICByZXR1cm4gZ2VuZXJhdG9ycwplbmQKCi0tIFRoaXMgZnVuY3Rpb24gcmV0dXJucyB0aGUgZGVmdWFsdCBmaXhlZCBnZW5lcmF0b3JzIGlmIG5vIGlucHV0IGlzIHByb3ZpZGVkOwotLSBvdGhlcndpc2UgaXQgcmV0dXJucyByYW5kb20gZ2VuZXJhdG9ycy4KZnVuY3Rpb24gUFZTUy5zZXRfZ2VuZXJhdG9ycyhpc19yYW5kb20pCiAgICBpZiBpc19yYW5kb20gdGhlbgogICAgICAgIGxvY2FsIHRhYmxlID0gY3JlYXRlX2dlbmVyYXRvcnMoMiwgRUNQLnByaW1lKCksIENVUlZFX09SREVSKQogICAgICAgIHJldHVybiB7ZyA9IHRhYmxlWzFdLCBHID0gdGFibGVbMl19CiAgICBlbHNlCiAgICAgICAgcmV0dXJuIEdFTkVSQVRPUlMKICAgIGVuZAplbmQKCi0tQ3JlYXRlIHRoZSBzZWNyZXQgYW5kIHB1YmxpYyBrZXlzIG9mIGEgcGFydGVjaXBhbnQgdXNpbmcgdGhlIGdlbmVyYXRvciBHCmZ1bmN0aW9uIFBWU1Mua2V5Z2VuKCkKICAgIHJldHVybiBCSUcubW9kcmFuZChDVVJWRV9PUkRFUikKZW5kCgpmdW5jdGlvbiBQVlNTLnNrMnBrKGdlbmVyYXRvcnMsIHNrKQogICAgcmV0dXJuIGdlbmVyYXRvcnMuRypzawplbmQKCi0tIHBvbHlub21pYWwgZXZhbHVhdGlvbiB1c2luZyBIb3JuZXIncyBydWxlLgotLSBLX2FycmF5IGlzIHRoZSBjb2VmZmljaWVudHMgdGFibGUKbG9jYWwgZnVuY3Rpb24gcG9sX2V2YWx1YXRpb24oeCwgS19hcnJheSkKICAgIGxvY2FsIGxlbiA9ICNLX2FycmF5CiAgICBsb2NhbCB5ID0gS19hcnJheVtsZW5dCiAgICBmb3IgaSA9IGxlbi0xLCAxLCAtMSBkbwogICAgICAgIHkgPSAoS19hcnJheVtpXSArIHk6bW9kbXVsKHgsIENVUlZFX09SREVSKSkgJSBDVVJWRV9PUkRFUgogICAgZW5kCiAgICByZXR1cm4geQplbmQKCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tIERJU1RSSUJVVElPTiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBTZWUgJ0Rpc3RyaWJ1dGlvbicgaW4gU2VjdGlvbiAzLjEgb2YgaHR0cHM6Ly93d3cud2luLnR1ZS5ubC9+YmVycnkvcGFwZXJzL2NyeXB0bzk5LnBkZgoKLS0gR2l2ZW4gdGhlIHNlY3JldCBzLCB0aGUgcHVibGljIGtleXMgcGtzLCB0aGUgcXVvcnVtL3RocmVzaG9sZCB0IGFuZCB0aGUgdG90YWwgcGFydGljaXBhbnRzIG4sCi0tIHRoZSBpc3N1ZXIgY29tcHV0ZXMgdGhlIHNoYXJlcy4KLS0gV2UgYXNzdW1lIHRoYXQgcyBpcyBhIEJJRyBtb2R1bG8gQ1VSVkVfT1JERVIuCi0tIGRldF92YWx1ZXMgKFVTRUQgT05MWSBGT1IgVEVTVElORykgPSB0YWJsZSBjb250YWluaW5nIHRoZSBwb2x5bm9taWFsIGNvZWZmaWNpZW50cyBhcnJheQotLSBBTkQgdGhlIGFycmF5IG9mIHRoZSAidmVyaWZpZXIgY2hhbGxlbmdlcyIgdXNlZCBpbiB0aGUgY3JlYXRlX3Byb29mLgpmdW5jdGlvbiBQVlNTLmNyZWF0ZV9zaGFyZXMoZ2VuZXJhdG9ycywgcywgcGtzLCB0LCBuLCBkZXRfdmFsdWVzKQogICAgbG9jYWwgZGV0X2NoYWxsID0gbmlsCiAgICBsb2NhbCBjb25jX2YgPSBuaWwKICAgIGxvY2FsIGNvZWZmaWNpZW50cyA9IHtzfQogICAgbG9jYWwgY29tbWl0bWVudHMgPSB7Z2VuZXJhdG9ycy5nICogc30KICAgIGlmKG5vdCBkZXRfdmFsdWVzKSB0aGVuCiAgICAgICAgZm9yIGkgPSAyLHQgZG8KICAgICAgICAgICAgY29lZmZpY2llbnRzW2ldID0gQklHLm1vZHJhbmQoQ1VSVkVfT1JERVIpCiAgICAgICAgICAgIGNvbW1pdG1lbnRzW2ldID0gZ2VuZXJhdG9ycy5nICogY29lZmZpY2llbnRzW2ldCiAgICAgICAgZW5kCiAgICBlbHNlCiAgICAgICAgZGV0X2NoYWxsID0gZGV0X3ZhbHVlc1syXQogICAgICAgIGNvbmNfZiA9IFBWU1MuZGV0X2NvbmNhdGVuYXRpb24KICAgICAgICBmb3IgaSA9IDIsdCBkbwogICAgICAgICAgICBjb2VmZmljaWVudHNbaV0gPSBkZXRfdmFsdWVzWzFdW2ldCiAgICAgICAgICAgIGNvbW1pdG1lbnRzW2ldID0gZ2VuZXJhdG9ycy5nICogY29lZmZpY2llbnRzW2ldCiAgICAgICAgZW5kCiAgICBlbmQKCiAgICBsb2NhbCBlbmNyeXB0ZWRfc2hhcmVzID0ge30KICAgIGxvY2FsIFhzID0ge30KICAgIGxvY2FsIGV2YWxzID0ge30KICAgIGxvY2FsIHByb29mX3BvaW50cyA9IHt9CiAgICBmb3IgaSA9IDEsbiBkbwogICAgICAgIGV2YWxzW2ldID0gcG9sX2V2YWx1YXRpb24oQklHLm5ldyhpKSwgY29lZmZpY2llbnRzKQogICAgICAgIGVuY3J5cHRlZF9zaGFyZXNbaV0gPSBwa3NbaV0gKiBldmFsc1tpXQogICAgICAgIFhzW2ldID0gZ2VuZXJhdG9ycy5nICogZXZhbHNbaV0KICAgICAgICBwcm9vZl9wb2ludHNbaV0gPSB7Z2VuZXJhdG9ycy5nLCBYc1tpXSwgcGtzW2ldLCBlbmNyeXB0ZWRfc2hhcmVzW2ldfQogICAgZW5kCgogICAgbG9jYWwgcHJvb2YgPSBQVlNTLmNyZWF0ZV9wcm9vZl9ETEVRKHByb29mX3BvaW50cywgZXZhbHMsIG5pbCwgY29uY19mLCBkZXRfY2hhbGwpCgogICAgcmV0dXJuIHtbImNvbW1pdG1lbnRzIl0gPSBjb21taXRtZW50cywgWyJwdWJsaWNfa2V5cyJdID0gcGtzLCBbImVuY3J5cHRlZF9zaGFyZXMiXSA9IGVuY3J5cHRlZF9zaGFyZXMsIFsicHJvb2YiXSA9IHByb29mfSwgWHMsIGV2YWxzCmVuZAoKLS0gR2l2ZW4gdGhlIHByb29mcyBvZiB0aGUgZW5jcnlwdGVkIHNoYXJlcywgdmVyaWZ5IHRoZWlyIHZhbGlkaXR5LgotLSBpc3N1ZXJfc2hhcmVzOiBkaWN0aW9uYXJ5IG91dHB1dHRlZCBmcm9tIFBWU1MuY3JlYXRlX3NoYXJlcy4KZnVuY3Rpb24gUFZTUy52ZXJpZnlfc2hhcmVzKGdlbmVyYXRvcnMsIHQsIG4sIGlzc3Vlcl9zaGFyZXMsIGNvbmNhdF9mKQogICAgbG9jYWwgY29uY2F0ZW50YXRpb25fZnVuY3Rpb24gPSBjb25jYXRfZiBvciBQVlNTLmNvbmNhdGVuYXRpb24KICAgIGxvY2FsIFhzID0ge30KICAgIGxvY2FsIHByb29mX3BvaW50cyA9IHt9CiAgICBmb3IgaT0xLG4gZG8KICAgICAgICBsb2NhbCB2YWx1ZSA9IEVDUC5pbmZpbml0eSgpCiAgICAgICAgZm9yIGogPSAwLCAodC0xKSBkbwogICAgICAgICAgICBsb2NhbCBwb3cgPSBCSUcubmV3KGkpOm1vZHBvd2VyKEJJRy5uZXcoaiksIENVUlZFX09SREVSKQogICAgICAgICAgICB2YWx1ZSA9IHZhbHVlICsgKGlzc3Vlcl9zaGFyZXMuY29tbWl0bWVudHNbaisxXSAqIHBvdykKICAgICAgICBlbmQKICAgICAgICBYc1tpXSA9IHZhbHVlCiAgICAgICAgcHJvb2ZfcG9pbnRzW2ldID0ge2dlbmVyYXRvcnMuZywgWHNbaV0sIGlzc3Vlcl9zaGFyZXMucHVibGljX2tleXNbaV0sIGlzc3Vlcl9zaGFyZXMuZW5jcnlwdGVkX3NoYXJlc1tpXX0KICAgIGVuZAoKICAgIHJldHVybiBQVlNTLnZlcmlmeV9wcm9vZl9ETEVRKHByb29mX3BvaW50cywgaXNzdWVyX3NoYXJlcy5wcm9vZiwgbmlsLCBjb25jYXRlbnRhdGlvbl9mdW5jdGlvbikKZW5kCgotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLVJFQ09OU1RSVUNUSU9OLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBTZWUgJ1JlY29uc3RydWN0aW9uJyBpbiBTZWN0aW9uIDMuMSBvZiBodHRwczovL3d3dy53aW4udHVlLm5sL35iZXJyeS9wYXBlcnMvY3J5cHRvOTkucGRmCgotLSBHaXZlbiB0aGUgcHJpdmF0ZSBrZXkgeCwgdGhlIHB1YmxpYyBrZXkgeSBhbmQgdGhlIGRpY3Rpb25hcnkgb3V0cHV0dGVkIGZyb20gUFZTUy5jcmVhdGVfc2hhcmVzLAotLSB0aGUgcGFydGljaXBhbnQgZGVjcnlwdHMgdGhlIHNoYXJlIGFuZCBjb21wdXRlcyBhIFpLUCBvZiB0aGUgY29ycmVjdG5lc3Mgb2YgdGhlIG9wZXJhdGlvbi4KLS0gZGV0X2NoYWxsIChVU0VEIE9OTFkgRk9SIFRFU1RJTkcpOiBhcnJheSBjb250YWluaW5nIGZpeGVkICJ2ZXJpZmllciBjaGFsbGVuZ2VzIi4KZnVuY3Rpb24gUFZTUy5kZWNyeXB0X3NoYXJlKGdlbmVyYXRvcnMsIHgsIHksIGlzc3Vlcl9zaGFyZXMsIGRldF9jaGFsbCkKICAgIGxvY2FsIGluZGV4ID0gMAogICAgZm9yIGssdiBpbiBwYWlycyhpc3N1ZXJfc2hhcmVzLnB1YmxpY19rZXlzKSBkbwogICAgICAgIGlmIHkgPT0gdiB0aGVuCiAgICAgICAgICAgIGluZGV4ID0gawogICAgICAgICAgICBicmVhawogICAgICAgIGVuZAogICAgZW5kCiAgICBsb2NhbCBZID0gaXNzdWVyX3NoYXJlcy5lbmNyeXB0ZWRfc2hhcmVzW2luZGV4XQogICAgbG9jYWwgUyA9IFkgKiBCSUcubW9kaW52KHgsIENVUlZFX09SREVSKQogICAgbG9jYWwgcG9pbnRfYXJyYXkgPSB7Z2VuZXJhdG9ycy5HLCB5LCBTLCBZfQogICAgbG9jYWwgY29uY19mID0gbmlsCiAgICBpZihkZXRfY2hhbGwpIHRoZW4KICAgICAgICBjb25jX2YgPSBQVlNTLmRldF9jb25jYXRlbmF0aW9uCiAgICBlbmQKICAgIGxvY2FsIHByb29mID0gUFZTUy5jcmVhdGVfcHJvb2ZfRExFUSh7cG9pbnRfYXJyYXl9LCB7eH0sIG5pbCwgY29uY19mLCBkZXRfY2hhbGwpCiAgICByZXR1cm4ge1siZGVjX3NoYXJlIl0gPSBTLCBbInByb29mIl0gPSBwcm9vZiwgWyJpbmRleCJdID0gaW5kZXgsIFsiZW5jX3NoYXJlIl0gPSBZLCBbInB1Yl9rZXkiXSA9IHl9CmVuZAoKLS1HaXZlbiBhcyBpbnB1dCBhbiBhcnJheSBvZiBkaWN0aW9uYXJpZXMgb3V0cHV0dGVkIGZyb20gUFZTUy5kZWNyeXB0X3NoYXJlcywKLS0gdmVyaWZ5IHRoZSB2YWxpZGl0eSBvZiB0aGUgc2hhcmVzIGFuZCByZXR1cm4gdGhlIGxpc3Qgb2YgdmFsaWQgZGVjcnlwdGVkIHNoYXJlcwpmdW5jdGlvbiBQVlNTLnZlcmlmeV9kZWNyeXB0ZWRfc2hhcmVzKGdlbmVyYXRvcnMsIHBhcnRlY2lwYW50c19zaGFyZXMsIGNvbmNhdF9mKQogICAgbG9jYWwgY29uY2F0ZW5hdGlvbl9mdW5jdGlvbiA9IGNvbmNhdF9mIG9yIFBWU1MuY29uY2F0ZW5hdGlvbgogICAgbG9jYWwgdmFsaWRfc2hhcmVzID0ge30KICAgIGxvY2FsIHZhbGlkX2luZGV4ZXMgPSB7fQogICAgZm9yIGkgPSAxLCAjcGFydGVjaXBhbnRzX3NoYXJlcyBkbwogICAgICAgIGlmIFBWU1MudmVyaWZ5X3Byb29mX0RMRVEoe3tnZW5lcmF0b3JzLkcsIHBhcnRlY2lwYW50c19zaGFyZXNbaV0ucHViX2tleSwgcGFydGVjaXBhbnRzX3NoYXJlc1tpXS5kZWNfc2hhcmUsIHBhcnRlY2lwYW50c19zaGFyZXNbaV0uZW5jX3NoYXJlfX0sIHBhcnRlY2lwYW50c19zaGFyZXNbaV0ucHJvb2YsIG5pbCwgY29uY2F0ZW5hdGlvbl9mdW5jdGlvbikgdGhlbgogICAgICAgICAgICB0YWJsZS5pbnNlcnQodmFsaWRfc2hhcmVzLCBwYXJ0ZWNpcGFudHNfc2hhcmVzW2ldLmRlY19zaGFyZSkKICAgICAgICAgICAgdGFibGUuaW5zZXJ0KHZhbGlkX2luZGV4ZXMsIHBhcnRlY2lwYW50c19zaGFyZXNbaV0uaW5kZXgpCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiB2YWxpZF9zaGFyZXMsIHZhbGlkX2luZGV4ZXMKZW5kCgotLSBHaXZlbiBhcyBpbnB1dCBhIHRhYmxlIGNvbnRhaW5pbmcgdGhlIGRlY3J5cHRlZCBzaGFyZXMsIHRoZSBpbmRleGVzIGFuZCB0aGUgdGhyZXNob2xkLCByZXRyaXZlIHRoZSBzZWNyZXQuCi0tIEhlcmUgd2UgYXJlIGFzc3VtaW5nIHRoYXQgdGhlIHNoYXJlcyBoYXZlIGJlZW4gYWxyZWFkeSB2ZXJpZmllZC4KZnVuY3Rpb24gUFZTUy5wb29saW5nX3NoYXJlcyhzaGFyZXMsIGluZGV4ZXMsIHRocmVzaG9sZCkKICAgIGlmICNzaGFyZXMgPj0gdGhyZXNob2xkIHRoZW4KICAgICAgICBsb2NhbCBzZWNyZXQgPSBFQ1AuaW5maW5pdHkoKQogICAgICAgIGZvciBrID0gMSwgdGhyZXNob2xkIGRvCiAgICAgICAgICAgIGxvY2FsIGkgPSBpbmRleGVzW2tdCiAgICAgICAgICAgIGxvY2FsIGxhZ3JhbmdlX2NvZWZmID0gQklHLm5ldygxKQogICAgICAgICAgICBmb3IgbSA9IDEsIHRocmVzaG9sZCBkbwogICAgICAgICAgICAgICAgbG9jYWwgaiA9IGluZGV4ZXNbbV0KICAgICAgICAgICAgICAgIGxvY2FsIGZhY3RvciA9IEJJRy5uZXcoMSkKICAgICAgICAgICAgICAgIGlmIGogfj0gaSB0aGVuCiAgICAgICAgICAgICAgICAgICAgbG9jYWwgYmlnX2ogPSBCSUcubmV3KGopCiAgICAgICAgICAgICAgICAgICAgZmFjdG9yID0gQklHLm1vZGRpdihiaWdfaiwgQklHLm1vZHN1YihiaWdfaiwgQklHLm5ldyhpKSwgQ1VSVkVfT1JERVIpLCBDVVJWRV9PUkRFUikKICAgICAgICAgICAgICAgICAgICBsYWdyYW5nZV9jb2VmZiA9IEJJRy5tb2RtdWwobGFncmFuZ2VfY29lZmYsZmFjdG9yLCBDVVJWRV9PUkRFUikKICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICBlbmQKICAgICAgICAgICAgc2VjcmV0ID0gc2VjcmV0ICsgKHNoYXJlc1trXSpsYWdyYW5nZV9jb2VmZikKICAgICAgICBlbmQKICAgICAgICByZXR1cm4gc2VjcmV0CiAgICBlbHNlCiAgICAgICAgZXJyb3IoIlRoZSBudW1iZXIgb2Ygc2hhcmVzICIuLiNzaGFyZXMuLiIgaXMgbGVzcyB0aGVuIHRoZSB0aHJlc2hvbGQgIi4udGhyZXNob2xkLCAyKQogICAgZW5kCmVuZAoKcmV0dXJuIFBWU1MKL2NyeXB0b19zY2hub3JyX3NpZ25hdHVyZS5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjAtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tSW1wbGVtZW50YXRpb24gYnkgQWxiZXJ0byBJYnJpc2V2aWMgYW5kIERlbmlzIFJvaW8KCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBNYXR0ZW8gQ3Jpc3Rpbm8KLS1vbiBUaHVyc2RheSwgMjR0aCBNYXJjaCAyMDIxCi0tXV0KCmxvY2FsIHNjaG5vcnIgPSB7fQoKLS0gcHJpbWUgbW9kdWx1cyBvZiB0aGUgY29vcmRpbmF0ZXMgb2YgRUNQIGFuZCBvcmRlciBvZiB0aGUgY3VydmUKbG9jYWwgcCA9IEVDUC5wcmltZSgpCmxvY2FsIG8gPSBFQ1Aub3JkZXIoKQotLSBnZW5lcmF0b3Igb2YgdGhlIGN1cnZlCmxvY2FsIEcgPSBFQ1AuZ2VuZXJhdG9yKCkKCi0tIG1ldGhvZCBmb3Igb2J0YWluaW5nIGEgdmFsaWQgRUMgc2VjcmV0IGtleSB0aGF0IGlzIGNob3NlbiBhdCByYW5kb20KZnVuY3Rpb24gc2Nobm9yci5rZXlnZW4oKQogICBsb2NhbCBzaywgZAogICByZXBlYXQKICAgICAgc2sgPSBPQ1RFVC5yYW5kb20oMzIpCiAgICAgIGQgPSBCSUcubmV3KHNrKQogICAgICBpZiAgbyA8PSBkIHRoZW4gZCA9IEJJRy5uZXcoMCkgZW5kIC0tZ3VhcmFudGllcyB0aGF0IHRoZSBnZW5lcmF0ZWQga2V5cGFpciBpcyB2YWxpZAogICB1bnRpbCAoZCB+PSBCSUcubmV3KDApKQogICByZXR1cm4gc2sKZW5kCgotLSBnaXZlbiBhIHZhbGlkIHNlY3JldCBrZXksIGV4dHJhY3RzIHRoZSByZWxhdGVkIHB1YmxpYyBrZXkgbm90IGVuY29kZWQgKGkuZS4gYXMgdGhlIHBvaW50IFA9KFA6eCgpLCBQOnkoKSkpCmxvY2FsIGZ1bmN0aW9uIHB1YnBvaW50X2dlbihzaykKICAgYXNzZXJ0KHNrLCAibm8gc2VjcmV0IGtleSBmb3VuZCIpCiAgIGFzc2VydCgjc2sgPT0gMzIsICdpbnZhbGlkIHNlY3JldCBrZXk6IGxlbmd0aCBpcyBub3Qgb2YgMzJCJykKICAgbG9jYWwgZCA9IEJJRy5uZXcoc2spCiAgIGFzc2VydChkIH49IEJJRy5uZXcoMCksICdpbnZhbGlkIHNlY3JldCBrZXksIGlzIHplcm8nKQogICBhc3NlcnQoZCA8IG8sICdpbnZhbGlkIHNlY3JldCBrZXksIG92ZXJmbG93IHdpdGggY3VydmUgb3JkZXInKQogICBsb2NhbCBQID0gZCpHCiAgIHJldHVybiBQCmVuZAoKLS0gZ2l2ZW4gYSB2YWxpZCBzZWNyZXQga2V5LCBleHRyYWN0cyB0aGUgcmVsYXRlZCBlbmNvZGVkIHB1YmxpYyBrZXkgCi0tIEBwYXJhbSBzayBhIDMyIEJ5dGUgT0NURVQsIHNlY3JldCBrZXkKLS0gQHJldHVybiBhIDQ4IEJ5dGUgT0NURVQsIHB1YmxpYyBrZXkKZnVuY3Rpb24gc2Nobm9yci5wdWJnZW4oc2spCiAgIGlmIGlzemVuKHR5cGUoc2spKSB0aGVuIHNrID0gc2s6b2N0ZXQoKSBlbmQKICAgbG9jYWwgUCA9IHB1YnBvaW50X2dlbihzaykKICAgbG9jYWwgcGsgPSAoUDp4KCkpOm9jdGV0KCk6cGFkKDQ4KQogICByZXR1cm4gcGsKZW5kCgotLSB2YWxpZGF0aW9uIG9mIHRoZSBwdWJsaWMga2V5IGRvbmUgaW4gdHdvIHN0ZXBzOgotLSAxLmNoZWNrIHRoZSBwb2ludCBpcyBvbiB0aGUgY3VydmUKLS0gMi5jaGVjayB0aGUgcG9pbnQgaXMgbm90IGluZmludGUKLS0gQHBhcmFtIHBrIGEgNDggQnl0ZSBPQ1RFVCwgcHVibGljIGtleQotLSBAcmV0dXJuIHRydWUgaWYgdGhlIHB1YmxpYyBrZXkgaXMgdmFsaWQsIG90aGVyd2lzZSBmYWxzZQpmdW5jdGlvbiBzY2hub3JyLnB1YmNoZWNrKHBrKQogICBpZiBpc3plbih0eXBlKHBrKSkgdGhlbiBwayA9IHBrOm9jdGV0KCkgZW5kCiAgIGxvY2FsIFAgPSBFQ1AubmV3KEJJRy5uZXcocGspKQogICByZXR1cm4gRUNQLnZhbGlkYXRlKFApIGFuZCBub3QgRUNQLmlzaW5mKFApCmVuZAoKLS0gdmFsaWRhdGlvbiBvZiB0aGUgcHJpdmF0ZSBrZXkgZG9uZSBpbiB0d28gc3RlcHM6Ci0tIDEuY2hlY2sgdGhlIGxlbmd0aAotLSAyLmNoZWNrIHRoYXQgaXQgaXMgZ3JhdGVyIHRoYW4gMCBhbmQgbG93ZXIgdGhhbiB0aGUgb3JkZXIgb2YgdGhlIGN1cnZlCi0tIEBwYXJhbSBzayBhIDMyIEJ5dGUgT0NURVQsIHNlY3JldCBrZXkKLS0gQHJldHVybiB0cnVlIGlmIHRoZSBzZWNyZXQga2V5IGlzIHZhbGlkLCBvdGhlcndpc2UgZmFsc2UKZnVuY3Rpb24gc2Nobm9yci5zZWNjaGVjayhzaykKICAgaWYgaXN6ZW4odHlwZShzaykpIHRoZW4gc2sgPSBzazpvY3RldCgpIGVuZAogICBsb2NhbCBkID0gQklHLm5ldyhzaykKICAgcmV0dXJuICgjc2sgPT0gMzIpIGFuZCAoZCB+PSBCSUcubmV3KDApKSBhbmQgKGQgPD0gbykKZW5kCgotLSB2YWxpZGF0aW9uIG9mIHRoZSBzaWduYXR1cmUgKHNpZz0ocixzKSkgZG9uZSBpbiB0aHJlZSBzdGVwczoKLS0gMS5jaGVjayB0aGUgbGVuZ3RoIG9mIHRoZSBzaWduYXR1cmUKLS0gMi5jaGVjayB0aGF0IHIgaXMgbG93ZXIgdGhhbiBwCi0tIDMuY2hlY2sgdGhhdCBzIGlzIGxvd2VyIHRoYW4gbwotLSBAcGFyYW0gc2lnIGEgODAgQnl0ZSBPQ1RFVCwgc2lnbmF0dXJlICgnc2lnPShyLHMpJykKLS0gQHJldHVybiB0cnVlIGlmIHRoZSBzaWduYXR1cmUgaXMgdmFsaWQsIG90aGVyd2lzZSBmYWxzZQpmdW5jdGlvbiBzY2hub3JyLnNpZ2NoZWNrKHNpZykKICAgaWYgc2lnIGFuZCAoI3NpZyA9PSA4MCkgdGhlbgogICAgICBsb2NhbCByX2Fyciwgc19hcnIgPSBPQ1RFVC5jaG9wKHNpZyw0OCkKICAgICAgbG9jYWwgciA9IEJJRy5uZXcocl9hcnIpCiAgICAgIGxvY2FsIHMgPSBCSUcubmV3KHNfYXJyKQogICAgICByZXR1cm4gKHIgPD0gcCkgYW5kIChzIDw9IG8pCiAgIGVuZAogICByZXR1cm4gZmFsc2UKZW5kCgoKLS0gbWV0aG9kIGZvciBvYnRhaW5pbmcgYW4gaGFzaCBkaWdlc3QgdXNpbmcgYSAoVVRGLTgpIGVuY29kZWQgdGFnIG5hbWUgdG9nZXRoZXIgd2l0aCB0aGUgZGF0YSB0byBwcm9jZXNzCi0tIE4uQjE6IEJ5IGRvaW5nIHRoaXMsIHdlIG1ha2Ugc3VyZSBoYXNoZXMgdXNlZCBpbiBvbmUgY29udGV4dCBjYW4ndCBiZSByZWludGVycHJldGVkIGluIGFub3RoZXIgb25lLCAKLS0gICAgICBpbiBzdWNoIGEgd2F5IHRoYXQgY29sbGlzaW9ucyBhY3Jvc3MgY29udGV4dHMgY2FuIGJlIGFzc3VtZWQgdG8gYmUgaW5mZWFzaWJsZS4KLS0gTi5CMjogdGFnIG5hbWVzIGNhbiBiZSBjdXN0b21pemVkIGF0IHdpbGwKbG9jYWwgZnVuY3Rpb24gaGFzaF90YWcodGFnLCBkYXRhKQogICBsb2NhbCBoID0gc2hhMjU2KE8uc3RyKHRhZykpCiAgIHJldHVybiBzaGEyNTYoaC4uaC4uZGF0YSkKZW5kCgoKLS0gc2lnbmluZyBhbGdvcml0aG0KLS0gQHBhcmFtIHNrIGEgMzIgQnl0ZSBPQ1RFVCwgc2VjcmV0IGtleQotLSBAcGFyYW0gbSBhbiBhcmJpdHJhcnkgbG9uZyBPQ1RFVCwgbWVzc2FnZSAKLS0gQHJldHVybiBhbiA4MCBCeXRlIE9DVEVULCBzaWduYXR1cmUgJyhyLHMpJycsIHIgaXMgNDggQnl0ZSBsb25nIGFuZCBzIGlzIDMyIEJ5dGUgbG9uZwpmdW5jdGlvbiBzY2hub3JyLnNpZ24oc2ssIG0pCiAgIGlmIGlzemVuKHR5cGUoc2spKSB0aGVuIHNrID0gc2s6b2N0ZXQoKSBlbmQKICAgbG9jYWwgZCA9IEJJRy5uZXcoc2spCiAgIGxvY2FsIFAgPSBwdWJwb2ludF9nZW4oc2spCiAgIC0tZm9yIGNvbnZlbnRpb24gd2UgbmVlZCB0aGF0IFAgaGFzIGV2ZW4geS1jb29yZGluYXRlCiAgIC0tTi5COiB3ZSBkb24ndCBjaGFuZ2UgdGhlIHBvaW50IHdpdGggdGhlIG5ldyBvbmUsIGJ1dCBvbmx5IHN0b3JlIHRoZSBjb2VmZmljaWVudCBkIG5lZWRlZCB0byBvYnRhaW4gaXQKICAgaWYgUDp5KCk6cGFyaXR5KCkgIHRoZW4gZCA9IG8gLSBkIGVuZCAKICAgbG9jYWwgawogICByZXBlYXQgCiAgICAgIGxvY2FsIGEgPSBPQ1RFVC5yYW5kb20oMzIpCiAgICAgIGxvY2FsIGggPSBoYXNoX3RhZygiQklQMDM0MC9hdXgiLCBhKQogICAgICBsb2NhbCB0ID0gT0NURVQueG9yKGQ6b2N0ZXQoKSwgaCkKICAgICAgbG9jYWwgcmFuZCA9IGhhc2hfdGFnKCJCSVAwMzQwL25vbmNlIiwgdC4uKChQOngoKSk6b2N0ZXQoKSkuLm0pCiAgICAgIGsgPSBCSUcubmV3KHJhbmQpICUgbyAgLS1tYXliZSBpdCBpcyBub3QgbmVlZGVkIHNpbmNlIG8gaXMgYmlnZ2VyCiAgIHVudGlsIGsgfj0gQklHLm5ldygwKQogICBsb2NhbCBSID0gaypHCiAgIAogICBpZiBSOnkoKTpwYXJpdHkoKSB0aGVuIGsgPSBvIC0gayBlbmQKICAgLS1hbHNvIGhlcmUgd2Ugc3RvcmUgb25seSB0aGUgY29lZmZpY2llbnQgaywgL3dvIGNoYW5naW5nIHRoZSBwb2ludCBSCiAgIGxvY2FsIGUgPSBCSUcubmV3KGhhc2hfdGFnKCJCSVAwMzQwL2NoYWxsZW5nZSIsICgoUjp4KCkpOm9jdGV0KCkpLi4oKFA6eCgpKTpvY3RldCgpKS4ubSkpICUgbwogICBsb2NhbCByID0gKFI6eCgpKTpvY3RldCgpOnBhZCg0OCkgLS1wYWRkaW5nIGlzIGZ1bmRhbWVudGFsLCBvdGhlcndpc2Ugd2UgY291bGQgbG9zZSBub24tc2lnbmlmaWNhbnQgemVyb3MKCiAgIGxvY2FsIHMgPSBCSUcubW9kKGsgKyBlKmQsIG8pOm9jdGV0KCk6cGFkKDMyKQogICBsb2NhbCBzaWcgPSByLi5zCiAgIHJldHVybiBzaWcKZW5kCgotLSB2ZXJpZmljYXRpb24gYWxnb3J0aWhtCi0tIEBwYXJhbSBwayBhIDQ4IEJ5dGUgT0NURVQsIHB1YmxpYyBrZXkKLS0gQHBhcmFtIG0gYW4gYXJiaXRyYXJ5IGxvbmcgT0NURVQsIG1lc3NhZ2UgCi0tIEBwYXJhbSBzaWcgYW4gODAgQnl0ZSBPQ1RFVCwgc2lnbmF0dXJlICgnc2lnPShyLHMpJykKLS0gQHJldHVybiB0cnVlIGlmIHZlcmlmaWNhdGlvbiBwYXNzZXMsIGZhbHNlIG90aGVyd2lzZQpmdW5jdGlvbiBzY2hub3JyLnZlcmlmeShwaywgbSwgc2lnKQogICBpZiBpc3plbih0eXBlKHBrKSkgdGhlbiBwayA9IHBrOm9jdGV0KCkgZW5kCiAgIC0tdGhlIGZvbGx3aW5nICJsaWZ0cyIgcGsgdG8gYW4gRUNQIHdpdGggeCA9IHBrIGFuZCB5IGlzIGV2ZW4KICAgbG9jYWwgUCA9IEVDUC5uZXcoQklHLm5ldyhwaykpICAgIAogICBpZiBub3QgUCB0aGVuCgkgIHdhcm4oInNjaG5vcnIudmVyaWZ5IGxpZnRpbmcgZmFpbGVkIikKCSAgcmV0dXJuIGZhbHNlCiAgIGVuZAogICBsb2NhbCByX2Fyciwgc19hcnIgPSBPQ1RFVC5jaG9wKHNpZyw0OCkKICAgbG9jYWwgciA9IEJJRy5uZXcocl9hcnIpCiAgIGlmIG5vdCAociA8PSBwKSB0aGVuCgkJIHdhcm4oInNjaG5vcnIudmVyaWZ5IGxpZnRpbmcgZmFpbGVkIikKCQkgcmV0dXJuIGZhbHNlCiAgIGVuZAogICBsb2NhbCBzID0gQklHLm5ldyhzX2FycikKICAgaWYgbm90IChzIDw9IG8pIHRoZW4KCSAgd2Fybigic2Nobm9yci52ZXJpZnkgZmFpbGVkLCBzIG92ZXJmbG93cyBvIikKCSAgcmV0dXJuIGZhbHNlCiAgIGVuZAogICBsb2NhbCBlID0gQklHLm5ldyhoYXNoX3RhZygiQklQMDM0MC9jaGFsbGVuZ2UiLCByOm9jdGV0KCkuLihQOngoKSk6b2N0ZXQoKS4ubSkpICUgbwogICBsb2NhbCBSID0gKHMqRykgLSAoZSpQKSAgICAgLS1pZiB0aGUgc2lnbmF0dXJlIGlzIHZhbGlkIHRoZSByZXN1bHQgd2lsbCBiZSBrKkcgYXMgZXhwZWN0ZWQgICAKICAgaWYgRUNQLmlzaW5mKFIpIHRoZW4KCQkgd2Fybigic2Nobm9yci52ZXJpZnkgZmFpbGVkLCBwb2ludCB0byBpbmZpbml0eSIpCgkJIHJldHVybiBmYWxzZQogICBlbmQKICAgaWYgUjp5KCk6cGFyaXR5KCkgdGhlbgoJCSB3YXJuKCJzY2hub3JyLnZlcmlmeSBmYWlsZWQsIHkgaXMgb2RkIikKCQkgcmV0dXJuIGZhbHNlCiAgIGVuZAogICBpZiBub3QgKFI6eCgpID09IHIpIHRoZW4KCSAgd2Fybigic2Nobm9yci52ZXJpZnkgZmFpbGVkLCB4IG1pc21hdGNoIikKCSAgcmV0dXJuIGZhbHNlCiAgIGVuZAogICByZXR1cm4gdHJ1ZQplbmQKCgpyZXR1cm4gc2Nobm9ycgotLSBUT0RPOiBiYXRjaCB2ZXJpZmljYXRpb24KL2NyeXB0b19zZF9qd3QubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIzLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLQotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5OgotLVJlYmVjY2EgU2VsdmFnZ2luaSwgQWxiZXJ0byBMZXJkYSBhbmQgRGVuaXMgUm9pbwotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS1dXQoKbG9jYWwgc2Rfand0ID0ge30KCmZ1bmN0aW9uIHNkX2p3dC5wcmVwYXJlX2RpY3Rpb25hcnkob2JqKQogICAtLSB2YWx1ZXMgaW4gaW5wdXQgbWF5IGJlIHN0cmluZywgbnVtYmVyIG9yIGJvb2wKICAgbG9jYWwgZnVuID0gZnVuY3Rpb24odikKCSAgbG9jYWwgcmVzCgkgIGxvY2FsIHR2IDxjb25zdD4gPSB0eXBlKHYpCgkgIGlmIHR2ID09ICdzdHJpbmcnIHRoZW4gcmV0dXJuIHYKCSAgZWxzZWlmIHR2ID09ICdudW1iZXInIHRoZW4gcmVzID0gdgoJICBlbHNlaWYgdHYgPT0gJ3plbnJvb20udGltZScgdGhlbgoJCSByZXMgPSB0b251bWJlcih0b3N0cmluZyh2KSkKCQkgaWYgdG9zdHJpbmcocmVzKSB+PSB0b3N0cmluZyh2KSB0aGVuCgkJCS0tIHNhZmV0eSBjaGVjayBvbiBzb21lIGNvbnZlcnNpb25zCgkJCWVycm9yKCJJbnZhbGlkIGNvbnZlcnNpb24gaW4gU0QtSldUIHZhbHVlOiAiLi50dikKCQkgZW5kCgkgIGVsc2VpZiB0diA9PSAnemVucm9vbS5iaWcnIHRoZW4KCQkgcmVzID0gdG9udW1iZXIodjpkZWNpbWFsKCkpCgkJIGlmIHRvc3RyaW5nKHJlcykgfj0gdG9zdHJpbmcodikgdGhlbgoJCQllcnJvcigiSW52YWxpZCBjb252ZXJzaW9uIGluIFNELUpXVCB2YWx1ZTogIi4udHYpCgkJIGVuZAoJICBlbHNlaWYgdHYgPT0gJ3plbnJvb20uZmxvYXQnIHRoZW4KCQkgcmVzID0gdG9zdHJpbmcodikKCQkgaWYgdG9zdHJpbmcocmVzKSB+PSB0b3N0cmluZyh2KSB0aGVuCgkJCWVycm9yKCJJbnZhbGlkIGNvbnZlcnNpb24gaW4gU0QtSldUIHZhbHVlOiAiLi50dikKCQkgZW5kCgkgIGVsc2VpZiB0diA9PSAnemVucm9vbS5vY3RldCcgdGhlbiByZXMgPSB2OnN0cigpCgkgIGVsc2VpZiB0diA9PSAnYm9vbGVhbicgdGhlbiByZXMgPSB2CiAgICAgIC0tIGVsc2VpZiBpc3plbih0dikgdGhlbiByZXMgPSB2Om9jdGV0KCk6c3RyKCkKCSAgZWxzZQogCQkgZXJyb3IoIkludmFsaWQgdmFsdWUgZm91bmQgaW4gU0QtSldUIGFycmF5OiAiLi50dikKCSAgZW5kCgkgIHJldHVybiByZXMKICAgZW5kCiAgIHJldHVybiBkZWVwbWFwKGZ1biwgb2JqKQplbmQKCi0tIEdpdmVuIGFzIGlucHV0IGEgImRpc2Nsb3N1cmUgYXJyYXkiIG9mIHRoZSBmb3JtIHtzYWx0LCBrZXksIHZhbHVlfQotLSBSZXR1cm46IGRpc2Nsb3N1cmUgPSB0aGUgYXJyYXkgaW4gb2N0ZXQgZm9ybQotLSAgICAgICAgIGhhc2hlZCA9IHRoZSBzaGEyNTYgZGlnZXN0IG9mIHRoZSBlbmNvZGVkIGFycmF5IChmb3IgX3NkKQotLSAgICAgICAgIGVuY29kZWRfZGlzID0gdGhlIHVybDY0K2pzb24gZW5jb2Rpbmcgb2YgdGhlIGlucHV0IGFycmF5ICh1c2VkIGp1c3QgZm9yIHRlc3RpbmcpCmZ1bmN0aW9uIHNkX2p3dC5jcmVhdGVfZGlzY2xvc3VyZShkaXNfYXJyKQogICAgLS0gVE9ETzogZGlzY2xvc3VyZSBvZiBkaXNjdGlvbmFyeQoKICAgIGxvY2FsIGVuY29kZWRfZGlzIDxjb25zdD4gPQogICAgICAgIE8uZnJvbV9zdHJpbmcoCiAgICAgICAgICAgIEpTT04ucmF3X2VuY29kZSgKICAgICAgICAgICAgICAgIHNkX2p3dC5wcmVwYXJlX2RpY3Rpb25hcnkoZGlzX2FyciksIHRydWUpKTp1cmw2NCgpCiAgICBsb2NhbCBkaXNjbG9zdXJlID0ge30KICAgIGZvciBpID0gMSwgI2Rpc19hcnIgZG8KICAgICAgICBpZiB0eXBlKGRpc19hcnJbaV0pID09ICd0YWJsZScgdGhlbgogICAgICAgICAgICBkaXNjbG9zdXJlW2ldID0gZGVlcG1hcChmdW5jdGlvbihvKSByZXR1cm4gTy5mcm9tX3N0cmluZyhvKSBlbmQsIGRpc19hcnJbaV0pCiAgICAgICAgZWxzZWlmIHR5cGUoZGlzX2FycltpXSkgPT0gJ3N0cmluZycgdGhlbgogICAgICAgICAgICBkaXNjbG9zdXJlW2ldID0gTy5mcm9tX3N0cmluZyhkaXNfYXJyW2ldKQogICAgICAgIGVsc2UKICAgICAgICAgICAgZGlzY2xvc3VyZVtpXSA9IGRpc19hcnJbaV0KICAgICAgICBlbmQKICAgIGVuZAogICAgbG9jYWwgaGFzaGVkID0gTy5mcm9tX3N0cmluZyhzaGEyNTYoZW5jb2RlZF9kaXMpOnVybDY0KCkpCiAgICByZXR1cm4gIGRpc2Nsb3N1cmUsIGhhc2hlZCwgZW5jb2RlZF9kaXMKZW5kCgotLVtbIEpXVCByZXNlcnZlZCBjbGFpbSBuYW1lcyAoc2VlIFNlY3Rpb24gNC4xIGFuZCBTZWN0aW9uIDUgb2YgUkZDNzUxOSkKImlzcyIgKElzc3VlcikgQ2xhaW0KInN1YiIgKFN1YmplY3QpIENsYWltCiJhdWQiIChBdWRpZW5jZSkgQ2xhaW0KImV4cCIgKEV4cGlyYXRpb24gVGltZSkgQ2xhaW0KIm5iZiIgKE5vdCBCZWZvcmUpIENsYWltCiJpYXQiIChJc3N1ZWQgQXQpIENsYWltCiJqdGkiIChKV1QgSUQpIENsYWltCiJ0eXAiIChUeXBlKSBIZWFkZXIgUGFyYW1ldGVyCiJjdHkiIChDb250ZW50IFR5cGUpIEhlYWRlciBQYXJhbWV0ZXIKXV0KbG9jYWwgSldUX1JFU0VSVkVEX0NMQUlNUyA9IHsiaXNzIiwgInN1YiIsICJhdWQiLCAiZXhwIiwgIm5iZiIsICJpYXQiLCAianRpIiwgInR5cCIsICJ0eXBlIiwgImN0eSIsICJjbmYifQoKbG9jYWwgTk9OX1NFTEVDVElWRUxZX0RJU0NMT1NBQkxFX0NMQUlNUyA9IHsiaXNzIiwgImlhdCIsICJleHAiLCAiY25mIiwgInR5cGUiLCAiX3NkIiwgIl9zZF9hbGcifQoKLS0gR2l2ZW4gYXMgaW5wdXQgYSBzZWxlY3RpdmUgZGlzY2xvc3VyZSByZXF1ZXN0Ci0tIFJldHVybiBhIHRhYmxlIGNvbnRhaW5pbmcgdHdvIGtleXM6Ci0tICAgICAgICBwYXlsb2FkID0gdGhlIGp3dCBjb250YWluaW5nIGRpc2Nsb3NhYmxlIG9iamVjdCAodGhlIGNyZWRlbnRpYWwgdG8gYmUgc2lnbmVkIGJ5IHRoZSBpc3N1ZXIpCi0tICAgICAgICBkaXNjbG9zdXJlcyA9IHRoZSBsaXN0IG9mIGRpc2Nsb3N1cmUgYXJyYXlzCmZ1bmN0aW9uIHNkX2p3dC5jcmVhdGVfc2Qoc2RyKQogICAgbG9jYWwgZGlzY2xvc3VyZXMgPSB7fQogICAgbG9jYWwgand0X3BheWxvYWQgPSB7CiAgICAgICAgX3NkX2FsZyA9IE8uZnJvbV9zdHJpbmcoInNoYS0yNTYiKSwKICAgICAgICBfc2QgPSB7fQogICAgfQogICAgZm9yIF8sIGYgaW4gcGFpcnMoc2RyLmZpZWxkcykgZG8KICAgICAgICBsb2NhbCBmID0gZjpzdHIoKQogICAgICAgIGxvY2FsIGVuY29kZSA9IG5pbAogICAgICAgIGlmIHR5cGUoc2RyLm9iamVjdFtmXSkgPT0gJ3RhYmxlJyB0aGVuCiAgICAgICAgICAgIGVuY29kZSA9IGRlZXBtYXAoZnVuY3Rpb24obykgcmV0dXJuIG86c3RyKCkgZW5kLCBzZHIub2JqZWN0W2ZdKQogICAgICAgIGVsc2VpZiB0eXBlKHNkci5vYmplY3RbZl0pID09ICd6ZW5yb29tLm9jdGV0JyB0aGVuCiAgICAgICAgICAgIGVuY29kZSA9IHNkci5vYmplY3RbZl06c3RyKCkKICAgICAgICBlbHNlCiAgICAgICAgICAgIGVuY29kZSA9IHNkci5vYmplY3RbZl0KICAgICAgICBlbmQKICAgICAgICBsb2NhbCBkaXNjbG9zdXJlX2FyciA9IHsKICAgICAgICAgICAgTy5yYW5kb20oMTYpOnVybDY0KCksCiAgICAgICAgICAgIGYsCiAgICAgICAgICAgIGVuY29kZQogICAgICAgIH0KICAgICAgICBsb2NhbCBkaXNjbG9zdXJlLCBoYXNoZWQgPSBzZF9qd3QuY3JlYXRlX2Rpc2Nsb3N1cmUoZGlzY2xvc3VyZV9hcnIpCgogICAgICAgIGRpc2Nsb3N1cmVzWyNkaXNjbG9zdXJlcysxXSA9IGRpc2Nsb3N1cmUKICAgICAgICBqd3RfcGF5bG9hZC5fc2RbI2p3dF9wYXlsb2FkLl9zZCsxXSA9IGhhc2hlZAogICAgZW5kCiAgICBmb3IgXywgcmMgaW4gcGFpcnMoSldUX1JFU0VSVkVEX0NMQUlNUykgZG8KICAgICAgICBqd3RfcGF5bG9hZFtyY10gPSBkZWVwY29weShzZHIub2JqZWN0W3JjXSkKICAgIGVuZAoKICAgIHJldHVybiB7CiAgICAgICAgcGF5bG9hZD1qd3RfcGF5bG9hZCwKICAgICAgICBkaXNjbG9zdXJlcz1kaXNjbG9zdXJlcywKICAgIH0KZW5kCgotLSBUT0RPOiBhZGQgdGVzdCBmcm9tIHNlY3Rpb24gQS4zIG9mCi0tIGh0dHBzOi8vd3d3LnJmYy1lZGl0b3Iub3JnL3JmYy9yZmM3NTE1Lmh0bWwKLS0gV0FSTklORzogdGhlIEpTT04gZW5jb2RlIGlzIG5vdCB1bmlxdWUsIHNvIEkgc2hvdWxkCi0tIHJldHVybiB0aGUgYmFzZTY0IGVuY29kaW5nIHRvIGJlIHN1cmUgdG8gYmUgYWJsZSB0byB2ZXJpZnkgaXQsCi0tIGJ1dCB3ZSBhcmUgaW4gemVucm9vbSBhbmQgaWYgSSBwcmludCB0aGUgc2FtZSBvYmplY3QgSSBvYnRhaW4gdGhlCi0tIHNhbWUgcmVwcmVzZW50YXRpb24sIHRodXMgSSBjYW4ga2VlcCB0aGUgb2JqZWN0IGFuZCBwcmludCBpdCBvbmx5Ci0tIG9uIGV4cG9ydCwgeWF5IQpmdW5jdGlvbiBzZF9qd3QuY3JlYXRlX2p3dChwYXlsb2FkLCBzaywgYWxnbykKICAgIGxvY2FsIGhlYWRlciA8Y29uc3Q+ID0gewogICAgICAgIGFsZz1PLmZyb21fc3RyaW5nKGFsZ28uSUFOQSksIC0tIFRPRE86IGRvZXMgSldUIGNvbnRhaW5zIC5hbGcgPyEKICAgICAgICB0eXA9Ty5mcm9tX3N0cmluZygiZGMrc2Qtand0IikKICAgIH0KICAgIGxvY2FsIHBheWxvYWRfc3RyIDxjb25zdD4gPSBzZF9qd3QucHJlcGFyZV9kaWN0aW9uYXJ5KHBheWxvYWQpCiAgICBsb2NhbCBiNjRwYXlsb2FkIDxjb25zdD4gPSBPLmZyb21fc3RyaW5nKEpTT04ucmF3X2VuY29kZShwYXlsb2FkX3N0ciwgdHJ1ZSkpOnVybDY0KCkKICAgIGxvY2FsIGhlYWRlcl9zdHIgPGNvbnN0PiA9IHNkX2p3dC5wcmVwYXJlX2RpY3Rpb25hcnkoaGVhZGVyKQogICAgbG9jYWwgYjY0aGVhZGVyIDxjb25zdD4gPSBPLmZyb21fc3RyaW5nKEpTT04ucmF3X2VuY29kZShoZWFkZXJfc3RyLCB0cnVlKSk6dXJsNjQoKQoKICAgIGxvY2FsIHNpZ25hdHVyZSA9IGFsZ28uc2lnbihzaywgTy5mcm9tX3N0cmluZyhiNjRoZWFkZXIgLi4gIi4iIC4uIGI2NHBheWxvYWQpKQogICAgcmV0dXJuIHsKICAgICAgICBoZWFkZXI9aGVhZGVyLAogICAgICAgIHBheWxvYWQ9cGF5bG9hZCwKICAgICAgICBzaWduYXR1cmU9c2lnbmF0dXJlLAogICAgfQplbmQKCmxvY2FsIGZ1bmN0aW9uIGlzX2luKGxpc3QsIGVsZW0pCiAgICBsb2NhbCBmb3VuZCA9IGZhbHNlCiAgICBmb3IgaSA9IDEsICNsaXN0IGRvCiAgICAgICAgaWYgbGlzdFtpXSA9PSBlbGVtIHRoZW4KICAgICAgICAgICAgZm91bmQgPSB0cnVlCiAgICAgICAgICAgIGJyZWFrCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiBmb3VuZAplbmQKCi0tIFRPRE86IEluIHRoZSBmaW5hbCB2ZXJzaW9uIHdlIHNob3VsZCBjaGVjayB0aGF0IHRoZSBzZC1qd3QgcGF5bG9hZCBjb250YWlucyBhbGwgdGhlIG1hbmRhdG9yeSBjbGFpbXMgYmVsb3cKLS0gImlzcyIsICJpYXQiLCAiY25mIiwgInR5cGUiLCBpZiAiX3NkIiA9PiAiX3NkX2FsZyIKZnVuY3Rpb24gc2Rfand0LmNoZWNrX21hbmRhdG9yeV9jbGFpbV9uYW1lcyhqd3QpCiAgICBsb2NhbCBmb3VuZCA9IHRydWUKICAgIGlmIGp3dC5fc2QgdGhlbgogICAgICAgIGlmIG5vdCBqd3QuX3NkX2FsZyB0aGVuCiAgICAgICAgICAgIGZvdW5kID0gZmFsc2UKICAgICAgICBlbmQKICAgIGVuZAogICAgaWYgbm90IGp3dC5pc3MgdGhlbgogICAgICAgIGZvdW5kID0gZmFsc2UKICAgIGVuZAogICAgcmV0dXJuIGZvdW5kCmVuZAoKLS0gQ2hlY2sgdGhhdCB0aGUgaW5wdXQgaXMgYSB0YWJsZSBvZiB0aHJlZSBlbGVtZW50cywgd2hlcmUgdGhlIGZpcnN0IHR3byBvYmplY3QgYXJlIHN0cmluZwotLSB0aGUgaW5wdXQgc2hvdWxkIGJlIG9mIHRoZSBmb3JtIHtzYWx0LCBrZXksIHZhbHVlfQotLSB3ZSBhbHNvIGNoZWNrIHRoYXQgdGhlIGtleSBpcyBub3QgaW4gTk9OX1NFTEVDVElWRUxZX0RJU0NMT1NBQkxFX0NMQUlNUwpsb2NhbCBmdW5jdGlvbiBkaXNjbG9zdXJlX2FycmF5X2lzX3ZhbGlkKGFycikKICAgIGlmIHR5cGUoYXJyKSB+PSAndGFibGUnIG9yICNhcnIgfj0gMyB0aGVuCiAgICAgICAgcmV0dXJuIGZhbHNlCiAgICBlbmQKICAgIGlmIHR5cGUoYXJyWzFdKSB+PSAnc3RyaW5nJyBvciB0eXBlKGFyclsyXSkgfj0gJ3N0cmluZycgdGhlbgogICAgICAgIHJldHVybiBmYWxzZQogICAgZW5kCiAgICBpZiBpc19pbihOT05fU0VMRUNUSVZFTFlfRElTQ0xPU0FCTEVfQ0xBSU1TLCBhcnJbMl0pIHRoZW4KICAgICAgICByZXR1cm4gZmFsc2UKICAgIGVuZAogICAgcmV0dXJuIHRydWUKZW5kCgpmdW5jdGlvbiBzZF9qd3QudmVyaWZ5X3NkX2ZpZWxkcyhqd3QsIGRpc2Nsb3N1cmVzKQogICAgbG9jYWwgbWF0Y2ggPSB0cnVlCiAgICBsb2NhbCBkaWdlc3RfYXJyID0gand0Ll9zZAogICAgbG9jYWwgZGlzY2xvc3VyZXNfYXJyIDxjb25zdD4gPSBzZF9qd3QucHJlcGFyZV9kaWN0aW9uYXJ5KGRpc2Nsb3N1cmVzKQogICAgbG9jYWwgY2xhaW1fbmFtZXMgPSB7fQogICAgZm9yIGkgPSAxLCAjZGlzY2xvc3VyZXNfYXJyIGRvCiAgICAgICAgaWYgbm90IGRpc2Nsb3N1cmVfYXJyYXlfaXNfdmFsaWQoZGlzY2xvc3VyZXNfYXJyW2ldKSB0aGVuCiAgICAgICAgICAgIHJldHVybiBmYWxzZQogICAgICAgIGVuZAogICAgICAgIGlmIGlzX2luKGNsYWltX25hbWVzLCBkaXNjbG9zdXJlc19hcnJbaV1bMl0pIHRoZW4KICAgICAgICAgICAgcmV0dXJuIGZhbHNlCiAgICAgICAgZWxzZQogICAgICAgICAgICB0YWJsZS5pbnNlcnQoY2xhaW1fbmFtZXMsIGRpc2Nsb3N1cmVzX2FycltpXVsyXSkKICAgICAgICBlbmQKICAgICAgICBsb2NhbCBfLCBoYXNoZWQgPSBzZF9qd3QuY3JlYXRlX2Rpc2Nsb3N1cmUoZGlzY2xvc3VyZXNfYXJyW2ldKQogICAgICAgIGlmIG5vdCBpc19pbihkaWdlc3RfYXJyLCBoYXNoZWQpIHRoZW4KICAgICAgICAgICAgbWF0Y2ggPSBmYWxzZQogICAgICAgICAgICBicmVhawogICAgICAgIGVuZAogICAgZW5kCiAgICByZXR1cm4gbWF0Y2gKZW5kCgpyZXR1cm4gc2Rfand0Ci9jcnlwdG9fdzNjLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IE1hdHRlbyBDcmlzdGlubwotLW9uIFRodXJzZGF5LCAyNnRoIFNlcHRlbWJlciAyMDI0Ci0tXV0KCmxvY2FsIFczQyA9IHt9Cgpsb2NhbCBmdW5jdGlvbiByZXF1aXJlX29uY2VfZnVuKHNjZW5hcmlvLCBmdW5fbmFtZSkKICAgIGxvY2FsIFMgPSByZXF1aXJlX29uY2Uoc2NlbmFyaW8pCiAgICBsb2NhbCBmID0gU1tmdW5fbmFtZV0KICAgIGlmIG5vdCBmIHRoZW4gZXJyb3IoIk1ldGhvZCAiLi5mdW5fbmFtZS4uIiBub3QgZm91bmQgaW4gIi4uc2NlbmFyaW8sIDIpIGVuZAogICAgcmV0dXJuIGYKZW5kCgotLSB1dGxpdHkgdG8gZW5jb2RlIGEgSlNPTiBhcyBvY3RldCBzdHJpbmcgYmFzZWQgb24gaXRzIG9yaWdpbmFsIGVuY29kaW5nCi0tIGlmIG9jdGV0IGFyZSBwYXNzZWQgYXMgaW5wdXQgaXQgd2lsbCBjaGVjayB0aGF0IHRoZSBvcmlnaW5hbCBzdHJpbmcgd2FzCi0tIGEganNvbiBvciBhIGpzb24gZW5jb2RlZCBpbiB1cmw2NAotLSBAcGFyYW0gc3JjIHRoZSBqc29uIHRvIGVuY29kZQotLSBAcmV0dXJuIG9jdGV0IHN0cmluZyBjb250YWluZyB0aGUgZW5jb2RlZCBqc29uCmZ1bmN0aW9uIFczQy5qc29uX2VuY29kaW5nKHNyYykKICAgIGxvY2FsIHNvdXJjZSwgY29kZWMgPSBoYXZlKHNyYykKICAgIGxvY2FsIHNvdXJjZV9zdHIgPSBzb3VyY2UKICAgIGlmIGx1YXR5cGUoc291cmNlKSA9PSAndGFibGUnIHRoZW4KICAgICAgICBsb2NhbCBlbmNvZGluZyA9IGNvZGVjLnNjaGVtYSBvciBjb2RlYy5lbmNvZGluZwoJCSAgIG9yIENPREVDLm91dHB1dC5lbmNvZGluZy5uYW1lCiAgICAgICAgc291cmNlX3N0ciA9IE8uZnJvbV9zdHJpbmcoIEpTT04uZW5jb2RlKHNvdXJjZSwgZW5jb2RpbmcpICkKICAgIGVsc2UKICAgICAgICAtLSBjaGVjayB0aGF0IGJlZm9yZSBlbmNvZGluZyBpdCB3YXMgYSB0YWJsZQogICAgICAgIC0tIHRoaXMgc2hvdWxkIGVuc3VyZSB0aGF0IHdlIGFyZSBzaWduaW5nIG9ubHkganNvbgogICAgICAgIGxvY2FsIGlucHV0ID0gZ2V0X2VuY29kaW5nX2Z1bmN0aW9uKGNvZGVjLmVuY29kaW5nKShzb3VyY2UpCiAgICAgICAgaWYgTy5pc191cmw2NChpbnB1dCkgdGhlbgogICAgICAgICAgICBpbnB1dCA9IE8uZnJvbV91cmw2NChpbnB1dCk6c3RyaW5nKCkKICAgICAgICBlbmQKICAgICAgICBpZiBub3QgSlNPTi52YWxpZGF0ZShpbnB1dCkgdGhlbgogICAgICAgICAgICBlcnJvcihzcmMuLicgaXMgbm90IGEganNvbiBvciBhbiBlbmNvZGVkIGpzb24nLCAyKQogICAgICAgIGVuZAogICAgZW5kCiAgICByZXR1cm4gc291cmNlX3N0cgplbmQKCi0tIHBhcnNlIEpXUyBzdHJpbmcKLS0gQHBhcmFtIG9fandzIHRoZSBqd3MgYXMgb2N0ZXQgKGZyb20gc3RyaW5nKQotLSBAcGFyYW0gb19wYXlsb2FkIHRoZSBwYXlsb2FkIGFzIG9jdGV0LCB0byB2ZXJpZnkgZGV0YWNoZWQgc2lnbmF0dXJlCi0tIEByZXR1cm4gc2lnbmF0dXJlICh0YWJsZSB7cixzfSBpbiBjYXNlIG9mIGVjZHNhIG9uIHNlY3AyNTZrMSkKLS0gQHJldHVybiB2ZXJpZmlmaWNhdGlvbiBmdW5jdGlvbiB0byB2ZXJpZnkgdGhlIHNpZ25hdHVyZSBiYXNlZCBvbiB0aGUgYWxnb3JpdGhtIHByZXNlbnQgaW4gdGhlIGhlYWRlcgotLSBAcmV0dXJuIHB1YmxpYyBrZXksIHRzYWtlIHRoZSBvbmUgaW4gdGhlIGhlYWRlciAoaWYgcHJlc2VudCkgb3IgdGhlIGNvcnJlY3Qga2V5IGluIHplbnJvb20gbWVtb3J5Ci0tIEByZXR1cm4gaGVhZGVyLnBheWxvYWQsIGlmIHBheWxvYWQgaXMgZGlmZmVyZW5ldCBmcm9tIHRoZSBlbXB0eSBzdHJpbmcKZnVuY3Rpb24gVzNDLmp3c19vY3RldF90b19zaWduYXR1cmUob19qd3MsIG9fcGF5bG9hZCkKICAgIGxvY2FsIHRva3MgPSBzdHJ0b2soT0NURVQudG9fc3RyaW5nKG9fandzKSwgJy4nKQogICAgLS0gcGFyc2UgaGVhZGVyCiAgICBsb2NhbCBwawogICAgbG9jYWwgaGVhZGVyID0gSlNPTi5kZWNvZGUoIE9DVEVULmZyb21fdXJsNjQodG9rc1sxXSk6c3RyaW5nKCkpCiAgICBsb2NhbCBhbGcgPSBoZWFkZXIuYWxnCiAgICBpZiBub3QgYWxnIHRoZW4gZXJyb3IoJ0pXUyBoZWFkZXIgaXMgbWlzc2luZyBhbGcgc3BlY2lmaWNhdGlvbicsIDIpIGVuZAogICAgaWYgaGVhZGVyLmp3ayB0aGVuCiAgICAgICAgLS0ga3R5IE1VU1QgYmUgcHJlc2VudAogICAgICAgIGlmIGhlYWRlci5qd2sua3R5IH49ICdFQycgdGhlbgogICAgICAgICAgICBlcnJvcignSldTIHB1YmxpYyBrZXkgdHlwZSBzdXBwb3J0ZWQgYnkgemVucm9vbSBpcyBvbmx5IEVDJywgMikKICAgICAgICBlbmQKICAgICAgICAtLSBpZiBrdHkgPT0gRUMsIGNydiBNVVNUIGJlIHByZXNlbnQKICAgICAgICBsb2NhbCBhbGdfdGFibGUgPSB7WydQLTI1NiddID0gJ0VTMjU2JywgWydzZWNwMjU2azEnXSA9ICdFUzI1NksnfQogICAgICAgIGxvY2FsIGFsZ19mcm9tX2NydiA9IGFsZ190YWJsZVtoZWFkZXIuandrLmNydl0KICAgICAgICBpZiBub3QgYWxnX2Zyb21fY3J2IHRoZW4KICAgICAgICAgICAgZXJyb3IoJ0pXUyBwdWJsaWMga2V5IGN1cnZlIHN1cHBvcnRlZCBieSB6ZW5yb29tIGFyZSBvbmx5IFAtMjU2IG9yIHNlY3AyNTZrMSwgZm91bmQ6ICcuLmhlYWRlci5qd2suY3J2LCAyKQogICAgICAgIGVsc2VpZiBhbGcgfj0gYWxnX2Zyb21fY3J2IHRoZW4KICAgICAgICAgICAgZXJyb3IoJ0pXUyBwdWJsaWMga2V5IGN1cnZlICcuLmhlYWRlci5qd2suY3J2Li4nIGRvZXMgbm90IG1hdGNoIHRoZSBhbGcgJy4uYWxnLCAyKQogICAgICAgIGVuZAogICAgICAgIGlmIGhlYWRlci5qd2sueCBhbmQgaGVhZGVyLmp3ay55IHRoZW4KICAgICAgICAgICAgcGsgPSBPLmZyb21fdXJsNjQoaGVhZGVyLmp3ay54KSAuLiBPLmZyb21fdXJsNjQoaGVhZGVyLmp3ay55KQogICAgICAgIGVuZAogICAgZW5kCiAgICAtLSBoZWFkZXIucGF5bG9hZCBpcyB3aGF0IHNob3VsZCBiZSBzaWduZWQKICAgIGlmIG5vdCBvX3BheWxvYWQgYW5kIHRva3NbMl0gPT0gIiIgdGhlbgogICAgICAgIGVycm9yKCdObyBwYXlsb2FkIHByb3ZpZGVkIGR1cmluZyBqd3MgdmVyaWZpY2F0aW9uJywgMikKICAgIGVuZAogICAgaWYgb19wYXlsb2FkIGFuZCB0b2tzWzJdIH49ICIiIHRoZW4KICAgICAgICBpZiB0b2tzWzJdIH49IE8udG9fc3RyaW5nKG9fcGF5bG9hZCkgdGhlbgogICAgICAgICAgICBlcnJvcignSldTIHBheWxvYWQgZG9lcyBub3QgbWF0Y2ggdGhlIHBheWxvYWQgaW4gaW5wdXQnLCAyKQogICAgICAgIGVuZAogICAgZW5kCiAgICBsb2NhbCBzaWduZWQgPSBPLmZyb21fc3RyaW5nKHRva3NbMV0uLicuJykuLihvX3BheWxvYWQgb3IgTy5mcm9tX3N0cmluZyh0b2tzWzJdKSkKICAgIC0tIHNpZ25hdHVyZQogICAgbG9jYWwgc2lnbmF0dXJlLCB2ZXJpZnlfZgogICAgaWYgYWxnID09ICdFUzI1NksnIHRoZW4KICAgICAgICBzaWduYXR1cmUgPSB7fQogICAgICAgIHNpZ25hdHVyZS5yLCBzaWduYXR1cmUucyA9IE9DVEVULmNob3AoT0NURVQuZnJvbV91cmw2NCh0b2tzWzNdKSwgMzIpCiAgICAgICAgdmVyaWZ5X2YgPSByZXF1aXJlX29uY2VfZnVuKCdlY2RoJywgJ3ZlcmlmeScpCiAgICAgICAgcGsgPSBwayBvciBBQ0suZWNkaF9wdWJsaWNfa2V5CiAgICBlbHNlaWYgYWxnID09ICdFUzI1NicgdGhlbgogICAgICAgIHNpZ25hdHVyZSA9IE9DVEVULmZyb21fdXJsNjQodG9rc1szXSkKICAgICAgICB2ZXJpZnlfZiA9IHJlcXVpcmVfb25jZV9mdW4oJ2VzMjU2JywgJ3ZlcmlmeScpCiAgICAgICAgcGsgPSBwayBvciBBQ0suZXMyNTZfcHVibGljX2tleQogICAgZWxzZQogICAgICAgIGVycm9yKGFsZyAuLiAnIGFsZ29yaXRobSBub3QgeWV0IHN1cHBvcnRlZCBieSB6ZW5yb29tIGp3cyB2ZXJpZmljYXRpb24nLCAyKQogICAgZW5kCiAgICByZXR1cm4gc2lnbmF0dXJlLCB2ZXJpZnlfZiwgcGssIHNpZ25lZAplbmQKCi0tIFZlcmlmeSBhIGp3cyBzaWduYXR1cmUgZnJvbSBhIGRvY3VtZW50IHByb29mCi0tIEBwYXJhbSBzcmMgdGhlIG5hbWUgb2YgdGhlIG9iamVjdCBjb250YWluaW5nIHRoZSBkb2N1bWVudAotLSBAcGFyYW0gZG9jdW1lbnQgdGhlIGRvY3VtZW50IHRvIGJlIHZlcmlmaWVkCi0tIEBwYXJhbSBwdWJsaWNfa2V5IHRoZSBwdWJsaWMga2V5IHRvIGJlIHVzZWQgZm9yIHZlcmlmaWNhdGlvbiwgaWYgbm90IHByZXNlbnQgdGhlIHB1YmxpYyBrZXkgaW4gdGhlIGhlYWRlciB3aWxsIGJlIHVzZWQKZnVuY3Rpb24gVzNDLnZlcmlmeV9qd3NfZnJvbV9wcm9vZihzcmMsIGRvY3VtZW50LCBwdWJsaWNfa2V5KQogICAgLS0gb21pdCBwcm9vZiBzdWJ0YWJsZSBmcm9tIHZlcmlmaWNhdGlvbgogICAgbG9jYWwgcHJvb2YgPSBkb2N1bWVudC5wcm9vZgogICAgZG9jdW1lbnQucHJvb2YgPSBuaWwKICAgIGxvY2FsIGRvY3VtZW50X3N0ciA9IFczQy5qc29uX2VuY29kaW5nKHNyYykKICAgIGxvY2FsIGRvY3VtZW50X2VuYyA9IE8uZnJvbV9zdHJpbmcoTy50b191cmw2NChkb2N1bWVudF9zdHIpKQogICAgZG9jdW1lbnQucHJvb2YgPSBwcm9vZgoKICAgIGxvY2FsIHNpZ25hdHVyZSwgdmVyaWZ5X2YsIHB1Yiwgc2lnbmVkID0gVzNDLmp3c19vY3RldF90b19zaWduYXR1cmUoZG9jdW1lbnQucHJvb2YuandzLCBkb2N1bWVudF9lbmMpCgogICAgbG9jYWwgcGsgPSBwdWJsaWNfa2V5IG9yIHB1YgogICAgaWYgbm90IHZlcmlmeV9mKHBrLCBzaWduZWQsIHNpZ25hdHVyZSkgdGhlbgogICAgICAgIC0tIHJldHJvIGNvbXBhdGliaWxpdHksIGJ1dCBub24gandzIGNvbXBsaWFudCBzaWduYXR1cmUKICAgICAgICBpZiB2ZXJpZnlfZihwaywgZG9jdW1lbnRfc3RyLCBzaWduYXR1cmUpIHRoZW4KICAgICAgICAgICAgd2FybignUmF3IHNpZ25hdHVyZSBvZiB0aGUgcGF5bG9hZCB2ZXJpZmllZCwgYnV0IGlzIG5vbiBzdGFuZGFyZCBqd3MnKQogICAgICAgIGVsc2UKICAgICAgICAgICAgZXJyb3IoJ1RoZSBzaWduYXR1cmUgZG9lcyBub3QgdmFsaWRhdGU6ICcgLi4gc3JjLCAyKQogICAgICAgIGVuZAogICAgZW5kCmVuZAoKCi0tIGNyZWF0ZSBhIGp3ayBlbmNvZGVkIGtleSBzdGFydGluZyBmcm9tIHRoZSByZWFsdGl2ZSBzay9wawotLSBAcGFyYW0gYWxnIGFsZyBpbiBqd2sKLS0gQHBhcmFtIHNrX2ZhbGcgc2sgZmxhZywgaWYgdHJ1ZSB0aGUgYWxnIHNrIHdpbGwgYmUgaW5zZXJ0ZWQgaW4gdGhlIGp3awotLSBAcGFyYW0gcGsgYSBzcGVjaWZpYyBwdWJsaWMga2V5IHRvIGJlIHVzZWQKLS0gQHJldHVybiBqd2sgYXMgYSBzdHJpbmcgZGljdGlvbmFyeSAobmVlZCB0byBiZSB0cmFuc2Zvcm1lZCBpbiBvY3RldCBiZWZvcmUgc3RvcmUgaW4gQUNLKQpmdW5jdGlvbiBXM0MuY3JlYXRlX3N0cmluZ19qd2soYWxnLCBza19mbGFnLCBwaykKICAgIGlmIHNrX2ZsYWcgYW5kIHBrIHRoZW4gZXJyb3IoJ0pXSyBjYW4gbm90IGJlIGNyZWF0ZWQgd2l0aCB6ZW5yb29tIHNrIGFuZCBjdXN0b20gcGsnLCAyKSBlbmQKICAgIGlmIGFsZyB+PSAnRVMyNTZLJyBhbmQgYWxnIH49ICdFUzI1NicgdGhlbiBlcnJvcihhbGcuLiAnIG5vdCB5ZXQgc3VwcG9ydGVkIGJ5IHplbnJvb20gandrJywgMikgZW5kCiAgICBsb2NhbCBhbGdfdG9fcGsgPSB7WydFUzI1NksnXT0gJ2VjZGhfcHVibGljX2tleScsIFsnRVMyNTYnXT0gJ2VzMjU2X3B1YmxpY19rZXknfQogICAgbG9jYWwgandrID0ge30KICAgIGp3ay5rdHkgPSAnRUMnCiAgICBqd2suY3J2ID0gZmlmKGFsZyA9PSAnRVMyNTZLJywgJ3NlY3AyNTZrMScsICdQLTI1NicpCiAgICBsb2NhbCBwdWJfeHlfZgogICAgaWYgYWxnID09ICdFUzI1NksnIHRoZW4KICAgICAgICBwdWJfeHlfZiA9IHJlcXVpcmVfb25jZV9mdW4oJ2VjZGgnLCAncHVibGljX3h5JykKICAgIGVsc2UKICAgICAgICBwdWJfeHlfZiA9IHJlcXVpcmVfb25jZV9mdW4oJ2VzMjU2JywgJ3B1YmxpY194eScpCiAgICBlbmQKICAgIGxvY2FsIHB1YgogICAgLS0gZXhwbGljaXQgcGsKICAgIGlmIHBrIHRoZW4KICAgICAgICBsb2NhbCBwdWJfY29kZWMKICAgICAgICBwdWIsIHB1Yl9jb2RlYyA9IGhhdmUocGspCiAgICAgICAgaWYgYWxnX3RvX3BrW2FsZ10gfj0gcHViX2NvZGVjLnNjaGVtYSB0aGVuCiAgICAgICAgICAgIGVycm9yKCdUaGUgJy4uYWxnLi4nIGFsZ29yaXRobSBkb2VzIG5vdCBtYXRjaCB0aGUgcHVibGljIGtleSBzY2hlbWEgJy4ucHViX2NvZGVjLnNjaGVtYSwgMikKICAgICAgICBlbmQKICAgIGVsc2UKICAgICAgICBsb2NhbCBzaywgcHViX2YKICAgICAgICBpZiBhbGcgPT0gJ0VTMjU2SycgdGhlbgogICAgICAgICAgICBzayA9IEFDSy5rZXlyaW5nIGFuZCBBQ0sua2V5cmluZy5lY2RoCiAgICAgICAgICAgIHB1Yl9mID0gcmVxdWlyZV9vbmNlX2Z1bignZWNkaCcsICdwdWJnZW4nKQogICAgICAgIGVsc2UKICAgICAgICAgICAgc2sgPSBBQ0sua2V5cmluZyBhbmQgQUNLLmtleXJpbmcuZXMyNTYKICAgICAgICAgICAgcHViX2YgPSByZXF1aXJlX29uY2VfZnVuKCdlczI1NicsICdwdWJnZW4nKQogICAgICAgIGVuZAogICAgICAgIC0tIHNrIGZvdW5kCiAgICAgICAgaWYgc2sgdGhlbgogICAgICAgICAgICBpZiBza19mbGFnIHRoZW4gandrLmQgPSBPLnRvX3VybDY0KHNrKSBlbmQKICAgICAgICAgICAgcHViID0gcHViX2Yoc2spCiAgICAgICAgLS0gc2sgbm90IGZvdW5kIHNlYXJjaCBmb3IgZGVmYXVsdCBwdWJsaWMga2V5CiAgICAgICAgZWxzZQogICAgICAgICAgICBpZiBza19mbGFnIHRoZW4gZXJyb3IoJ1ByaXZhdGUga2V5IGZvciAnLi5hbGcuLicgYWxnb3JpdGhtIG5vdCBmb3VuZCBpbiB0aGUga2V5cmluZycsIDIpIGVuZAogICAgICAgICAgICBsb2NhbCBwdWJfY29kZWMKICAgICAgICAgICAgcHViLCBwdWJfY29kZWMgPSBoYXZlKGFsZ190b19wa1thbGddKQogICAgICAgICAgICBpZiBhbGdfdG9fcGtbYWxnXSB+PSBwdWJfY29kZWMuc2NoZW1hIHRoZW4KICAgICAgICAgICAgICAgIGVycm9yKCdUaGUgJy4uYWxnLi4nIGFsZ29yaXRobSBkb2VzIG5vdCBtYXRjaCB0aGUgcHVibGljIGtleSBzY2hlbWEgJy4ucHViX2NvZGVjLnNjaGVtYSwgMikKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICBlbmQKICAgIGxvY2FsIHgsIHkgPSBwdWJfeHlfZihwdWIpCiAgICBqd2sueCA9IE8udG9fdXJsNjQoeCkKICAgIGp3ay55ID0gTy50b191cmw2NCh5KQogICAgcmV0dXJuIGp3awplbmQKCmZ1bmN0aW9uIFczQy5pbXBvcnRfand0KG9iaikKICAgIGxvY2FsIGZ1bmN0aW9uIGRlY29kZV9qd3RfcGFydHMocykKICAgICAgICBpZiB0eXBlKHMpID09ICdzdHJpbmcnIHRoZW4KICAgICAgICAgICAgcmV0dXJuIE8uZnJvbV9zdHJpbmcocykKICAgICAgICBlbHNlaWYgdHlwZShzKSA9PSAnbnVtYmVyJyB0aGVuCiAgICAgICAgICAgIHJldHVybiBmaWYoVElNRS5kZXRlY3RfdGltZV92YWx1ZShzKSwgVElNRS5uZXcsIEZMT0FULm5ldykocykKICAgICAgICBlbHNlCiAgICAgICAgICAgIHJldHVybiBzCiAgICAgICAgZW5kCiAgICBlbmQKICAgIGxvY2FsIGZ1bmN0aW9uIGltcG9ydF9qd3RfZGljdChkKQogICAgICAgIHJldHVybiBKU09OLmRlY29kZSgKICAgICAgICAgICAgc2NoZW1hX2dldCgKICAgICAgICAgICAgICAgIHRyaW0oZCksCiAgICAgICAgICAgICAgICAnLicsIE8uZnJvbV91cmw2NCwgdG9zdHJpbmcpOnN0cmluZygpKQogICAgICAgIC0tIHJldHVybiBkZWVwbWFwKGlucHV0X2VuY29kaW5nKCJzdHIiKS5mdW4sCiAgICAgICAgLS0gICAgICAgICAgICAgICAgSlNPTi5yYXdfZGVjb2RlKE8uZnJvbV91cmw2NCh0cmltKGQpKTpzdHIoKSkpCiAgICBlbmQKICAgIGxvY2FsIHRva3MgPSBzdHJ0b2sob2JqLCAiLiIpCiAgICAtLSBUT0RPOiB2ZXJpZnkgdGhpcyBpcyBhIHZhbGlkIGp3dAogICAgcmV0dXJuIHsKICAgICAgICBoZWFkZXIgPSBkZWVwbWFwKGRlY29kZV9qd3RfcGFydHMsaW1wb3J0X2p3dF9kaWN0KHRva3NbMV0pKSwKICAgICAgICBwYXlsb2FkID0gZGVlcG1hcChkZWNvZGVfand0X3BhcnRzLGltcG9ydF9qd3RfZGljdCh0b2tzWzJdKSksCiAgICAgICAgc2lnbmF0dXJlID0gTy5mcm9tX3VybDY0KHRva3NbM10pLAogICAgfQplbmQKCmZ1bmN0aW9uIFczQy5leHBvcnRfand0KG9iaikKICAgIGxvY2FsIGhlYWRlciA9IE8udG9fdXJsNjQoTy5mcm9tX3N0cmluZyhKU09OLmVuY29kZShvYmouaGVhZGVyLCAnc3RyaW5nJykpKQogICAgbG9jYWwgcGF5bG9hZCA9IE8udG9fdXJsNjQoTy5mcm9tX3N0cmluZyhKU09OLmVuY29kZShvYmoucGF5bG9hZCwgJ3N0cmluZycpKSkKICAgIHJldHVybiBoZWFkZXIgLi4gJy4nIC4uIHBheWxvYWQgLi4gJy4nIC4uIG9iai5zaWduYXR1cmU6dXJsNjQoKQplbmQKLS0gICAgIGxvY2FsIGVuY3N0ciA8Y29uc3Q+ID0gZ2V0X2VuY29kaW5nX2Z1bmN0aW9uKCJzdHJpbmciKQotLSAgICAgcmV0dXJuIHRhYmxlLmNvbmNhdCh7Ci0tICAgICAgICAgTy5mcm9tX3N0cmluZwotLSAgICAgICAgIChKU09OLnJhd19lbmNvZGUKLS0gICAgICAgICAgKGRlZXBtYXAoZW5jc3RyLCBvYmouaGVhZGVyKSx0cnVlKSk6dXJsNjQoKSwKLS0gICAgICAgICBPLmZyb21fc3RyaW5nCi0tICAgICAgICAgKEpTT04ucmF3X2VuY29kZQotLSAgICAgICAgICAoZGVlcG1hcChlbmNzdHIsb2JqLnBheWxvYWQpLHRydWUpKTp1cmw2NCgpLAotLSAgICAgICAgIE8udG9fdXJsNjQob2JqLnNpZ25hdHVyZSksCi0tICAgICB9LCAiLiIpCi0tIGVuZAoKcmV0dXJuIFczQwovaGR3YWxsZXQubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIxLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IEFsYmVydG8gTGVyZGEKLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCmxvY2FsIEhEVyA9IHt9CgotLSBhbiBleHRlbmRlZCBrZXkgaXMgYSB0YWJsZSB3aXRoIHRoZSBmaWVsZHMKLS0gc2VjcmV0LCBjaGFpbl9jb2RlLCBsZXZlbCwgZmluZ2VycHJpbnRfcGFyZW50LCBjaGlsZF9udW1iZXIKLS0gYSBwcml2YXRlIGtleSBtYXkgaGF2ZSBwdWJsaWM9bmlsCi0tIGEgcHVibGljIGtleSBoYXZlIHNlY3JldD1uaWwKCgotLSBwYXJzZSBleHRlbmRlZCBrZXkKLS0gQHBhcmFtIGRhdGEgb2N0ZXQgdG8gYmUgcGFyc2VkCi0tIEByZXR1cm4gZXh0ZW5kZWQga2V5CmZ1bmN0aW9uIEhEVy5wYXJzZV9leHRrZXkoZGF0YSkKICAgZGF0YSA9IE8uZnJvbV9iYXNlNTgoZGF0YSkKICAgLS0gY2hlY2sgY2hlY2tzdW0KICAgYXNzZXJ0KCNkYXRhID09IDgyIGFuZCBkYXRhOnN1YigjZGF0YS0zLCAjZGF0YSkgPT0gSEFTSC5kc2hhMjU2KGRhdGE6c3ViKDEsICNkYXRhLTQpKTpjaG9wKDQpLCAiV3JvbmcgaW5wdXQga2V5IiwgMikKICAgbG9jYWwgZXh0a2V5ID0ge30KICAgbG9jYWwgaSA9IDEKCiAgIGxvY2FsIHZlcnNpb24gPSBkYXRhOnN1YihpLGkrMykKICAgaSA9IGkgKyA0CgogICBhc3NlcnQodmVyc2lvbiA9PSBIRFcuTUFJTlBLIG9yIHZlcnNpb24gPT0gSERXLk1BSU5TSyBvcgoJICB2ZXJzaW9uID09IEhEVy5URVNUUEsgb3IgdmVyc2lvbiA9PSBIRFcuVEVTVFNLLCAiVW5rbm93biB2ZXJzaW9uIiwgMikKICAgbG9jYWwgcHVibGljID0gSERXLmlzUHVibGljKHZlcnNpb24pCgogICBleHRrZXkubGV2ZWwgPSB0b251bWJlcihkYXRhOnN1YihpLGkpOmhleCgpLCAxNikKICAgaSA9IGkgKyAxCgogICBleHRrZXkuZmluZ2VycHJpbnRfcGFyZW50ID0gZGF0YTpzdWIoaSwgaSszKQogICBpID0gaSArIDQKCiAgIC0tIGJpZyBlbmRpYW4gNCBieXRlcyBpbnRlZ2VyCiAgIGV4dGtleS5jaGlsZF9udW1iZXIgPSBCSUcubmV3KGRhdGE6c3ViKGksIGkrMykpCiAgIGkgPSBpICsgNAoKICAgZXh0a2V5LmNoYWluX2NvZGUgPSBkYXRhOnN1YihpLCBpKzMxKQogICBpID0gaSArIDMyCgogICBpZiBwdWJsaWMgdGhlbgogICAgICBleHRrZXkucHVibGljID0gZGF0YTpzdWIoaSxpKzMyKQogICBlbHNlCiAgICAgIGV4dGtleS5zZWNyZXQgPSBkYXRhOnN1YihpKzEsaSszMikKICAgZW5kCiAgIAogICByZXR1cm4gZXh0a2V5CmVuZAoKSERXLk1BSU5QSyA9IE8uZnJvbV9oZXgoJzA0ODhCMjFFJykKSERXLlRFU1RQSyA9IE8uZnJvbV9oZXgoJzA0MzU4N0NGJykKSERXLk1BSU5TSyA9IE8uZnJvbV9oZXgoJzA0ODhBREU0JykKSERXLlRFU1RTSyA9IE8uZnJvbV9oZXgoJzA0MzU4Mzk0JykKCmZ1bmN0aW9uIEhEVy5pc1B1YmxpYyh2ZXJzaW9uKQogICByZXR1cm4gdmVyc2lvbiA9PSBIRFcuTUFJTlBLIG9yIHZlcnNpb24gPT0gSERXLlRFU1RQSwplbmQKCmZ1bmN0aW9uIEhEVy5nZXRQdWJsaWMoZXh0a2V5KQogICBpZiBub3QgZXh0a2V5LnB1YmxpYyB0aGVuCiAgICAgIGV4dGtleS5wdWJsaWMgPSBFQ0RILnNrX3RvX3B1YmMoZXh0a2V5LnNlY3JldCkKICAgZW5kCiAgIGFzc2VydChleHRrZXkucHVibGljIH49IG5pbCkKICAgcmV0dXJuIGV4dGtleS5wdWJsaWMKZW5kCgpmdW5jdGlvbiBIRFcuZm9ybWF0X2V4dGtleShleHRrZXksIHZlcnNpb24pCiAgIGxvY2FsIGRhdGEgPSBPLmVtcHR5KCkKCiAgIGFzc2VydCh2ZXJzaW9uID09IEhEVy5NQUlOUEsgb3IgdmVyc2lvbiA9PSBIRFcuTUFJTlNLIG9yCgkgIHZlcnNpb24gPT0gSERXLlRFU1RQSyBvciB2ZXJzaW9uID09IEhEVy5URVNUU0tLLCAiVW5rbm93biB2ZXJzaW9uIiwgMikKCiAgIGxvY2FsIHB1YmxpYyA9IEhEVy5pc1B1YmxpYyh2ZXJzaW9uKQoKICAgZGF0YSA9IGRhdGEgLi4gdmVyc2lvbgoKICAgZGF0YSA9IGRhdGEgLi4gTy5mcm9tX2hleChzdHJpbmcuZm9ybWF0KCIlMDJ4IiwgZXh0a2V5LmxldmVsKSkKCiAgIGRhdGEgPSBkYXRhIC4uIEJJRy5uZXcoZXh0a2V5LmZpbmdlcnByaW50X3BhcmVudCk6Zml4ZWQoNCkKCiAgIGRhdGEgPSBkYXRhIC4uIEJJRy5uZXcoZXh0a2V5LmNoaWxkX251bWJlcik6Zml4ZWQoNCkKCiAgIGRhdGEgPSBkYXRhIC4uIGV4dGtleS5jaGFpbl9jb2RlCgogICBpZiBwdWJsaWMgdGhlbgogICAgICBkYXRhID0gZGF0YSAuLiBIRFcuZ2V0UHVibGljKGV4dGtleSkKICAgZWxzZQogICAgICBhc3NlcnQoZXh0a2V5LnNlY3JldCwgIkZyb20gYSBwdWJsaWMga2V5IGl0IGlzIG5vdCBwb3NzaWJsZSB0byBwcmludCBhIHByaXZhdGUga2V5IikKICAgICAgZGF0YSA9IGRhdGEgLi4gTy5mcm9tX2hleCgnMDAnKSAuLiBleHRrZXkuc2VjcmV0CiAgIGVuZAoKICAgbG9jYWwgY2hlY2sgPSBIQVNILmRzaGEyNTYoZGF0YSk6c3ViKDEsNCkKCiAgIGRhdGEgPSBkYXRhIC4uIGNoZWNrCiAgIAogICByZXR1cm4gZGF0YTpiYXNlNTgoKQplbmQKCi0tIENoaWxkIGtleSBkZXJpdmF0aW9uIHByaXZhdGUga2V5Ci0tIEBwYXJhbSBwYXJlbnRfa2V5IGV4dGVuZGVkIGtleSBvYmplY3QKLS0gQHBhcmFtIGkgaW5kZXgKZnVuY3Rpb24gSERXLmNrZF9wcml2KHBhcmVudF9rZXksIGkpCiAgIGxvY2FsIG5ld2tleSA9IHt9CiAgIGxvY2FsIGwKICAgbG9jYWwgczUxMiA9IEhBU0gubmV3KCdzaGE1MTInKQogICBsb2NhbCBwawogICAKICAgLS0gY2hlY2sgdmFsaWRpdHkgb2YgaW5kZXgKICAgYXNzZXJ0KGkgPD0gQklHLm5ldyhPLmZyb21faGV4KCdmZmZmZmZmZicpKSwgIkludmFsaWQgaW5kZXgiKQoKICAgLS0gd2UgY2Fubm90IGRlcml2ZSBhIHByaXZhdGUga2V5IGZyb20gYSBwdWJsaWMga2V5CiAgIGFzc2VydChwYXJlbnRfa2V5LnNlY3JldCwgIkNhbm5vdCBkZXJpdmUgYSBwcml2YXRlIGtleSBmcm9tIGEgcHVibGljIGtleSIpCiAgIAogICBuZXdrZXkuY2hpbGRfbnVtYmVyID0gaQogICBsb2NhbCBpX29jdCA9IGk6b2N0ZXQoKQogICBpZiAjaV9vY3QgPCA0IHRoZW4KICAgICAgaV9vY3QgPSBPLnplcm8oNCAtICNpX29jdCkgLi4gaV9vY3QKICAgZW5kCiAgIGlmIGkgPj0gQklHLm5ldyhPLmZyb21faGV4KCc4MDAwMDAwMCcpKSB0aGVuCiAgICAgIGwgPSBPLnplcm8oMSkgLi4gcGFyZW50X2tleS5zZWNyZXQgLi4gaV9vY3Q7ICAgICAgCiAgIGVsc2UKICAgICAgcGsgPSBIRFcuZ2V0UHVibGljKHBhcmVudF9rZXkpCiAgICAgIGwgPSBwayAuLiBpX29jdDsKICAgZW5kCiAgIAogICBsID0gSEFTSC5obWFjKHM1MTIsIHBhcmVudF9rZXkuY2hhaW5fY29kZSwgbCkKCiAgIGxvY2FsIGxMID0gQklHLm5ldyhsOnN1YiggMSwzMikpCiAgIGxvY2FsIGxSID0gbDpzdWIoMzMsNjQpCiAgCiAgIC0tIE9uIEJJUDMyIHRoZXJlIGlzIGEgbW9kLCBpZiBJIGFkZCBpdCwgaXQgZG9lc24ndCB3b3JrCiAgIC0tIFRPRE8gaW1wcm92ZSBhcml0aG1ldGljcyBtb2R1bG8gb3JkZXIgb2YgY3VydmUgc2VjcDI1NmsxCiAgIG5ld2tleS5zZWNyZXQgPSAoKGxMICsgQklHLm5ldyhwYXJlbnRfa2V5LnNlY3JldCkpICUgKEJJRy5uZXcoTy5mcm9tX2hleCgnRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkVCQUFFRENFNkFGNDhBMDNCQkZEMjVFOENEMDM2NDE0MScpKSkpOm9jdGV0KCkKCiAgIC0tIGNoZWNrIGlmIGxSID49IG9yZGVyIGN1cnZlLCBpbiB0aGF0IGNhc2UgcmV0dXJuIGNrZF9wcml2KHBhcmVudF9rZXksIGkrMSkKICAgaWYgbmV3a2V5LnNlY3JldCA9PSBJTlQubmV3KDApIHRoZW4KICAgICAgcmV0dXJuIEhEVy5ja2RfcHJpdihwYXJlbnRfa2V5LCBpKzEpCiAgIGVuZAoKICAgLS0gY29tcHV0ZSBmaW5nZXJwcmludAogICAtLSBwYXJlbnRfa2V5IGlzIGEgcHJpdmF0ZSBrZXkKICAgcGsgPSBIRFcuZ2V0UHVibGljKHBhcmVudF9rZXkpCiAgIG5ld2tleS5maW5nZXJwcmludF9wYXJlbnQgPSBIQVNILmhhc2gxNjAocGspOnN1YigxLDQpCiAgIAogICBuZXdrZXkuY2hhaW5fY29kZSA9IGxSCgogICBuZXdrZXkubGV2ZWwgPSBwYXJlbnRfa2V5LmxldmVsICsgMQoKICAgcmV0dXJuIG5ld2tleQplbmQKCi0tIHRoZSAibmV1dGVyZWQiIHZlcnNpb24sIGFzIGl0IHJlbW92ZXMgdGhlIGFiaWxpdHkgdG8gc2lnbiB0cmFuc2FjdGlvbnMKZnVuY3Rpb24gSERXLm5ldXRlcmVkKHBhcmVudF9rZXkpCiAgIGxvY2FsIG5ld2tleSA9IHt9CiAgIGZvciBrLCB2IGluIHBhaXJzKHBhcmVudF9rZXkpIGRvCiAgICAgIG5ld2tleVtrXSA9IHYKICAgZW5kCiAgIEhEVy5nZXRQdWJsaWMobmV3a2V5KQogICBuZXdrZXkuc2VjcmV0ID0gbmlsCiAgIHJldHVybiBuZXdrZXkgICAgICAKZW5kCgotLSBDaGlsZCBrZXkgZGVyaXZhdGlvbiBwdWJsaWMga2V5Ci0tIEBwYXJhbSBwYXJlbnRfa2V5IGV4dGVuZGVkIGtleSBvYmplY3QKLS0gQHBhcmFtIGkgaXQgaXMgb25seSBkZWZpbmVkIGZvciBub24taGFyZGVuZWQgY2hpbGQga2V5cyAoaSA8PSAweDgwMDAwMDAwKQpmdW5jdGlvbiBIRFcuY2tkX3B1YihwYXJlbnRfa2V5LCBpKQogICBsb2NhbCBuZXdrZXkgPSB7fQogICBsb2NhbCBsLCBsUiwgbEwKICAgbG9jYWwgczUxMiA9IEhBU0gubmV3KCdzaGE1MTInKQoKICAgLS0gY2hlY2sgdmFsaWRpdHkgb2YgaW5kZXgKICAgLS1hc3NlcnQoaSA8PSBCSUcubmV3KE8uZnJvbV9oZXgoJ2ZmZmZmZmZmJykpLCAiSW52YWxpZCBpbmRleCIpCgogICBhc3NlcnQoaSA8IEJJRy5uZXcoTy5mcm9tX2hleCgnODAwMDAwMDAnKSksICJQdWJsaWMga2V5IGRlcml2YXRpb24gaXMgb25seSBkZWZpbmVkIGZvciBub24taGFyZGVuZWQgY2hpbGQga2V5cyIpCgogICBpZiBwYXJlbnRfa2V5LnNlY3JldCB0aGVuCiAgICAgIG5ld2tleSA9IEhEVy5uZXV0ZXJlZChIRFcuY2tkX3ByaXYocGFyZW50X2tleSwgaSkpCiAgIGVsc2UKICAgICAgbG9jYWwgcGsgPSBIRFcuZ2V0UHVibGljKHBhcmVudF9rZXkpCiAgICAgIG5ld2tleS5jaGlsZF9udW1iZXIgPSBpCiAgICAgIAogICAgICBsID0gcGFyZW50X2tleS5wdWJsaWMgLi4gaTpmaXhlZCg0KQogICAgICBsID0gSEFTSC5obWFjKHM1MTIsIHBhcmVudF9rZXkuY2hhaW5fY29kZSwgbCkKCiAgICAgIGxMID0gQklHLm5ldyhsOnN1YiggMSwzMikpCiAgICAgIGxSID0gbDpzdWIoMzMsNjQpCgogICAgICBsb2NhbCBuRyA9IEVDREgucHViZ2VuKGxMKSAtLSA9IG4gKiBHCgogICAgICBuZXdrZXkucHVibGljID0gRUNESC5jb21wcmVzc19wdWJsaWNfa2V5KEVDREguYWRkKG5HLCBwYXJlbnRfa2V5LnB1YmxpYykpCiAgICAgIC0tIGNoZWNrIGlmIGxSID49IG9yZGVyIGN1cnZlLCBpbiB0aGF0IGNhc2UgcmV0dXJuIGNrZF9wcml2KHBhcmVudF9rZXksIGkrMSkKICAgICAgaWYgbmV3a2V5LnNlY3JldCA9PSBJTlQubmV3KDApIHRoZW4KCSByZXR1cm4gSERXLmNrZF9wcml2KHBhcmVudF9rZXksIGkrMSkKICAgICAgZW5kCgogICAgICBuZXdrZXkuZmluZ2VycHJpbnRfcGFyZW50ID0gSEFTSC5oYXNoMTYwKHBrKTpzdWIoMSw0KQogICAKICAgICAgbmV3a2V5LmNoYWluX2NvZGUgPSBsUgoKICAgICAgbmV3a2V5LmxldmVsID0gcGFyZW50X2tleS5sZXZlbCArIDEKICAgICAgCiAgIGVuZAoKICAgcmV0dXJuIG5ld2tleQplbmQKCmZ1bmN0aW9uIEhEVy5tYXN0ZXJfa2V5X2dlbmVyYXRpb24oc2VlZCkKICAgaWYgbm90IHNlZWQgdGhlbgogICAgICBzZWVkID0gTy5yYW5kb20oMzIpCiAgIGVuZAogICBsb2NhbCBzNTEyID0gSEFTSC5uZXcoJ3NoYTUxMicpCiAgIGxvY2FsIGwgPSBIQVNILmhtYWMoczUxMiwgTy5mcm9tX3N0cmluZygnQml0Y29pbiBzZWVkJyksIHNlZWQpCiAgIGxvY2FsIGxMID0gbDpzdWIoIDEsMzIpCiAgIC0tIGNoZWNrIExsIDwgb3JkZXIgb2YgdGhlIGN1cnZlCiAgIGxvY2FsIGxSID0gbDpzdWIoMzMsNjQpCiAgIHJldHVybiB7CiAgICAgIHNlY3JldCA9IGxMLAogICAgICBjaGFpbl9jb2RlID0gbFIsCiAgICAgIGxldmVsID0gMCwKICAgICAgZmluZ2VycHJpbnRfcGFyZW50ID0gTy5mcm9tX2hleCgnMDAwMDAwMDAnKSwKICAgICAgY2hpbGRfbnVtYmVyID0gTy5mcm9tX2hleCgnMDAwMDAwMDAnKSwKICAgfQplbmQKCi0tIEltcGxlbWVudHMgdGhlIGRlZmF1bHQgd2FsbGV0IGxheW91dAotLSBvbmx5IGV4dGVybmFsIGtleXMgYXJlIHN1cHBvcnRlZAotLSBAcGFyYW0gcGFyZW50X2tleSBwYXJlbnQgcHJpdmF0ZSBrZXkKLS0gQHBhcmFtIGkgYmlnbnVtIGkgPj0gMCBhbmQgaSA8PSA4MDAwMDAwMAotLSBAcGFyYW0gd2FsbGV0IGJpZ251bSBvciB0aGUgc3RyaW5nICcnICh0aGUgZGFmdWx0IHdhbGxldCksIG9wdGlvbmFsCi0tIEBwYXJhbSBub2hhcmRlbmVkIGJ5IGRlZmF1bHQgY2hpbGQga2V5cyBhcmUgaGFyZGVuZWQgKGlmIHRoZXJlIGlzIG5vdCB0aGUgcGFyYW1ldGVyCi0tIG5vaGFyZG5lZCA9IG5pbCB3aGljaCBpcyB0aGUgc2FtZSBhcyBmYWxzZSkKZnVuY3Rpb24gSERXLnN0YW5kYXJkX2NoaWxkKHBhcmVudF9rZXksIGksIHdhbGxldCwgbm9oYXJkZW5lZCkKICAgbG9jYWwgSEFSRE5FRCA9IEJJRy5uZXcoTy5mcm9tX2hleCgnODAwMDAwMDAnKSkKICAgYXNzZXJ0KGkgPCBIQVJETkVEKQoKICAgaWYgbm90IG5vaGFyZGVuZWQgdGhlbgogICAgICBpID0gaSArIEhBUkRORUQKICAgZW5kCgogICBpZiBub3Qgd2FsbGV0IG9yIHdhbGxldD09JycgdGhlbgogICAgICB3YWxsZXQgPSBJTlQubmV3KDApCiAgIGVuZAoKICAgYXNzZXJ0KHdhbGxldCA8IEhBUkRORUQpCgogICBsb2NhbCB3YWxsZXRfa2V5ID0gSERXLmNrZF9wcml2KHBhcmVudF9rZXksIHdhbGxldCtIQVJETkVEKQogICBsb2NhbCBleHRlcm5hbF9rZXkgPSBIRFcuY2tkX3ByaXYod2FsbGV0X2tleSwgSU5ULm5ldygwKSkKICAgbG9jYWwgYWRkcmVzc19rZXkgPSBIRFcuY2tkX3ByaXYoZXh0ZXJuYWxfa2V5LCBpKQoKICAgcmV0dXJuIGFkZHJlc3Nfa2V5CmVuZAoKZnVuY3Rpb24gSERXLm1uZW1vbmljX21hc3Rlcl9rZXkobW5lbW9uaWMsIHBhc3N3b3JkKQogICByZXR1cm4gSERXLm1hc3Rlcl9rZXlfZ2VuZXJhdGlvbihIQVNILm1uZW1vbmljX3NlZWQobW5lbW9uaWMsIHBhc3N3b3JkKSkKZW5kCgpyZXR1cm4gSERXCi9pbml0Lmx1YQAtLSBUaGlzIGZpbGUgaXMgcGFydCBvZiBaZW5yb29tIChodHRwczovL3plbnJvb20uZHluZS5vcmcpCi0tCi0tIENvcHlyaWdodCAoQykgMjAxOC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24gZGVzaWduZWQsIHdyaXR0ZW4gYW5kCi0tIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS0gVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS0gaXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgYXMKLS0gcHVibGlzaGVkIGJ5IHRoZSBGcmVlIFNvZnR3YXJlIEZvdW5kYXRpb24sIGVpdGhlciB2ZXJzaW9uIDMgb2YgdGhlCi0tIExpY2Vuc2UsIG9yIChhdCB5b3VyIG9wdGlvbikgYW55IGxhdGVyIHZlcnNpb24uCi0tCi0tIFRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLCBidXQKLS0gV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLSBNRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlIEdOVQotLSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLSBZb3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljCi0tIExpY2Vuc2UgYWxvbmcgd2l0aCB0aGlzIHByb2dyYW0uICBJZiBub3QsIHNlZQotLSA8aHR0cHM6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy8+LgoKLS0gaW5pdCBzY3JpcHQgZW1iZWRkZWQgYXQgY29tcGlsZSB0aW1lLiAgZXhlY3V0ZWQgaW4KLS0gemVuX2xvYWRfZXh0ZW5zaW9ucyhMKSB1c3VhbGx5IGFmdGVyIHplbl9pbml0KCkKCi0tIC0tIHJlbWFwIGZhdGFsIGFuZCBlcnJvcgpmdW5jdGlvbiBmYXRhbCh4KQoJWkVOLmRlYnVnKCkKCWxvY2FsIG1zZyA8Y29uc3Q+ID0geC5tc2cgb3IgJ2ZhdGFsIGVycm9yJwoJZXJyb3IoJ1plbmNvZGUgbGluZSAnLi54LmxpbmVudW0uLic6ICcuLm1zZywgMikKZW5kCgpfR1snUkVRVUlSRUQnXSA9IHt9Ci0tIGF2b2lkIGR1cGxpY2F0aW5nIHJlcXVpcmVzIChpbnRlcm5hbCBpbmNsdWRlcykKZnVuY3Rpb24gcmVxdWlyZV9vbmNlKG5pbmMpCglsb2NhbCBjbGFzcyA9IFJFUVVJUkVEW25pbmNdCglsb2NhbCBfcmVzCglpZiBub3QgY2xhc3MgdGhlbgoJCV9yZXMsIGNsYXNzID0gcGNhbGwoIGZ1bmN0aW9uKCkgcmV0dXJuIHJlcXVpcmUobmluYykgZW5kICkKCQlhc3NlcnQoX3JlcywgY2xhc3MpCgkJUkVRVUlSRURbbmluY10gPSBjbGFzcwoJZW5kCglyZXR1cm4gY2xhc3MKZW5kCgpfR1snU0NFTkFSSU9TJ10gPSB7fQpmdW5jdGlvbiBsb2FkX3NjZW5hcmlvKHNjZW4pCiAgIGxvY2FsIHMgPSBTQ0VOQVJJT1Nbc2Nlbl0KICAgaWYgbm90IHMgdGhlbgogICAgICBsb2NhbCBfcmVzLCBfZXJyCiAgICAgIF9yZXMsIF9lcnIgPSBwY2FsbCggZnVuY3Rpb24oKSByZXF1aXJlKHNjZW4pIGVuZCkKICAgICAgYXNzZXJ0KF9yZXMsIF9lcnIpCiAgICAgIFNDRU5BUklPU1tzY2VuXSA9IHRydWUKICAgZW5kCmVuZAoKLS0gZXJyb3IgPSB6ZW5fZXJyb3IgLS0gZnJvbSB6ZW5faW8KCi0tIFpFTiA9IHsgYXNzZXJ0ID0gYXNzZXJ0IH0gLS0gemVuY29kZSBzaGltIHdoZW4gbm90IGxvYWRlZApyZXF1aXJlKCd6ZW5yb29tX2NvbW1vbicpCk1BQ0hJTkUgPSByZXF1aXJlKCdzdGF0ZW1hY2hpbmUnKQoKLS0gU3RhbXAgdGhlIFZNIHdpdGggdmVyc2lvbiAoc2V0IGV4dGVybmFsbHkgYXQgYnVpbGQpCi0tIGV2ZXJ5IG9mZmljaWFsIER5bmUub3JnIHJlbGVhc2Ugc2hvdWxkIGhhdmUgdGhpcwpTRU1WRVIgPSByZXF1aXJlKCdzZW12ZXInKQotLSByZXR1cm5zIG5pbCBhbmQgYSB3YXJuaW5nIGlmIG5vIFZFUlNJT04gZm91bmQKX0dbJ1pFTlJPT01fVkVSU0lPTiddID0gU0VNVkVSKFZFUlNJT04pCgotLSBDYXAgdGhlIGxpbWl0IG9mIGl0ZXJhdGlvbnMgaW4gYnJhbmNoZXMKX0dbJ01BWElURVInXSA9IHRvbnVtYmVyKFNUUl9NQVhJVEVSKQpfR1snTUFYTUVNJ10gPSB0b251bWJlcihTVFJfTUFYTUVNKSAqIDEwMjQKCk9DVEVUID0gcmVxdWlyZSgnemVucm9vbV9vY3RldCcpCkJJRyA9IHJlcXVpcmUoJ3plbnJvb21fYmlnJykKRkxPQVQgPSByZXF1aXJlJ2Zsb2F0JwpUSU1FID0gcmVxdWlyZSd0aW1lJwpJTlNQRUNUID0gcmVxdWlyZSgnaW5zcGVjdCcpClFTT1JUID0gcmVxdWlyZSgncXNvcnRfb3AnKSAtLSBvcHRpbWl6ZWQgdGFibGUgc29ydAp0YWJsZS5zb3J0ID0gUVNPUlQgLS0gb3ZlcnJpZGUgbmF0aXZlIHRhYmxlIHNvcnQKU1BFTEwgPSByZXF1aXJlKCdzcGVsbCcpCkpTT04gPSByZXF1aXJlKCd6ZW5yb29tX2pzb24nKQpDUllQVE8gPSByZXF1aXJlKCdjcnlwdG9fbG9hZGVyJykKCi0tIEVDREggcHVibGljIGtleXMgY2Fubm90IGZ1bmN0aW9uIGFzIEVDUCBiZWNhdXNlIG9mIElBTkEgNzMwMwpBRVMgPSByZXF1aXJlKCdhZXMnKQpFQ1AgPSByZXF1aXJlKCd6ZW5yb29tX2VjcCcpCkVDUDIgPSByZXF1aXJlKCd6ZW5yb29tX2VjcDInKQpIQVNIID0gcmVxdWlyZSgnemVucm9vbV9oYXNoJykKLS0gQlRDID0gcmVxdWlyZSgnY3J5cHRvX2JpdGNvaW4nKSAtLSBCaXRjb2luIHByaW1pdGl2ZXMgaW1wb3J0ZWQgYnkgZGVmYXVsdApPID0gT0NURVQgLS0gYWxpYXMKSU5UID0gQklHIC0tIGFsaWFzCkYgPSBGTE9BVApVID0gVElNRSAtLSBhbGlhcyBVID0gVW5peCB0aW1lc3RhbXAKSSA9IElOU1BFQ1QgLS0gYWxpYXMKSCA9IEhBU0ggLS0gYWxpYXMKUEFJUiA9IEVDUDIgLS0gYWxpYXMKUEFJUi5hdGUgPSBFQ1AyLm1pbGxlciAtLWFsaWFzCmlmIF9HWydaRU5DT0RFX1NDT1BFJ10gfj0gJ0dJVkVOJyB0aGVuCiAgIE1QQUNLID0gcmVxdWlyZSgnemVucm9vbV9tc2dwYWNrJykKICAgQkVOQ0ggPSByZXF1aXJlKCd6ZW5yb29tX2JlbmNoJykKZW5kCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBaRU5DT0RFIHN0YXJ0cyBoZXJlCgotLSBkZWNsYXJlIEhFQVAgZ2xvYmFscyBpbiB0aGUgbWFpbiBjby1yb3V0aW5lCkFTVCA9IHt9IC0tIEFic3RyYWN0IFN5bnRheCBUcmVlIGZpbGxlZCBieSBaRU46cGFyc2VyCklOICA9IHt9IC0tIEdpdmVuIHByb2Nlc3NpbmcsIGltcG9ydCBnbG9iYWwgREFUQSBmcm9tIGpzb24KVE1QID0ge30gLS0gdGVtcG9yYXJ5IGJ1ZmZlciB1c2VkIGJ5IEdpdmVuCkFDSyA9IHt9IC0tIFdoZW4gcHJvY2Vzc2luZywgIGRlc3RpbmF0aW9uIGZvciBwdXNoKgpDQUNIRSA9IHt9IC0tIHRlbXBvcmFyeSBjYWNoZSB1c2VkIHRvIHN0b3JlIHN0YXRlcwpPVVQgPSB7fSAtLSBwcmludCBvdXQKQ09ERUMgPSB7fSAtLSBtZXRhZGF0YQpXSE8gPSBuaWwgLS0gd2hvYW1pCi0tIGdsb2JhbHMgd2lsbCBiZSBmaWxsZWQgYnkgemVuY29kZQpfR1snWkVOJ10gPSByZXF1aXJlKCd6ZW5jb2RlJykKCi0tIGJhc2UgemVuY29kZSBmdW5jdGlvbnMgYW5kIHNjaGVtYXMKbG9hZF9zY2VuYXJpbygnemVuY29kZV9kYXRhJykgLS0gcGljay9pbiwgY29udmVyc2lvbnMgZXRjLgpsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX2dpdmVuJykKbG9hZF9zY2VuYXJpbygnemVuY29kZV9rZXlyaW5nJykKCmlmIF9HWydaRU5DT0RFX1NDT1BFJ10gfj0gJ0dJVkVOJyB0aGVuCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfd2hlbicpCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfaGFzaCcpIC0tIHdoZW4gZXh0ZW5zaW9uCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfYXJyYXknKSAtLSB3aGVuIGV4dGVuc2lvbgogICBsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX3JhbmRvbScpIC0tIHdoZW4gZXh0ZW5zaW9uCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfZGljdGlvbmFyeScpIC0tIHdoZW4gZXh0ZW5zaW9uCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfdmVyaWZ5JykgLS0gd2hlbiBleHRlbnNpb24KICAgbG9hZF9zY2VuYXJpbygnemVuY29kZV90aGVuJykKICAgbG9hZF9zY2VuYXJpbygnemVuY29kZV9wYWNrJykgLS0gbXBhY2sgYW5kIHpwYWNrCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfZm9yZWFjaCcpCiAgIGxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfdGFibGUnKQogICBsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX3RpbWUnKQogICBsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX21hdGgnKQotLSBkZWZhdWx0IERTQSBhbGdvcyBhbmQgZ2xvYmFsIGFsaWFzZXMKICAgbG9hZF9zY2VuYXJpbyd6ZW5jb2RlX2VjZGgnCiAgIEVTMjU2SyA9IEVDREgKICAgU0VDUDI1NksxID0gRUNESAogICBsb2FkX3NjZW5hcmlvJ3plbmNvZGVfcXAnCiAgIFBRUyA9IFFQCiAgIGxvYWRfc2NlbmFyaW8nemVuY29kZV9lZGRzYScKICAgRUREU0EgPSBFRAogICBsb2FkX3NjZW5hcmlvJ3plbmNvZGVfZXMyNTYnCiAgIFAyNTYgPSBFUzI1NgplbmQKCi0tIHRoaXMgaXMgdG8gZXZhbHVhdGUgZXhwcmVzc2lvbnMgb3IgZGVyaXZhdGUgYSBjb2x1bW4KLS0gaXQgd291bGQgZXhlY3V0ZSBsdWEgY29kZSBpbnNpZGUgdGhlIHplbmNvZGUgYW5kIGlzCi0tIHRoZXJlZm9yZSBkYW5nZXJvdXMsIHN3aXRjaGVkIG9mZiBieSBkZWZhdWx0Ci0tIHJlcXVpcmUoJ3plbmNvZGVfZXZhbCcpCmxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfZGVidWcnKQoKLS0gYml0Y29pbiBpcyBsb2FkZWQgYnkgZGVmYXVsdApsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX2JpdGNvaW4nKQoKLS0gc2NlbmFyaW8gYXJlIGxvYWRlZCBvbi1kZW1hbmQKLS0gc2NlbmFyaW9zIGNhbiBvbmx5IGltcGxlbWVudCAiV2hlbiAuLi4iIHN0ZXBzCl9HWydHaXZlbiddID0gbmlsCl9HWydUaGVuJ10gPSBuaWwKCi0tLS0tLS0tLS0tCi0tIGRlZmF1bHRzCl9HWydDT05GJ10gPSB7CiAgIGNvZGUgPSB7CgkgIGVuY29kaW5nID0geyBmdW4gPSBmdW5jdGlvbihjb2RlKSByZXR1cm4gY29kZSBlbmQgfQogICB9LAogICBpbnB1dCA9IHsKCSAgZW5jb2RpbmcgPSBpbnB1dF9lbmNvZGluZygnYmFzZTY0JyksCgkgIGZvcm1hdCA9IHsgZnVuID0gSlNPTi5hdXRvLCBuYW1lID0gJ2pzb24nIH0sCgkgIHRhZ2dlZCA9IGZhbHNlCiAgIH0sCiAgIG91dHB1dCA9IHsKCSAgZW5jb2RpbmcgPSB7IGZ1biA9IGdldF9lbmNvZGluZ19mdW5jdGlvbignYmFzZTY0JyksCgkJCQkgICBuYW1lID0gJ2Jhc2U2NCcgfSwKCSAgZm9ybWF0ID0geyBmdW4gPSBKU09OLmF1dG8sIG5hbWUgPSAnanNvbicgfSwKCSAgc29ydGluZyA9IHRydWUsCgkgIHZlcnNpb25pbmcgPSBmYWxzZQogICB9LAogICBkZWJ1ZyA9IHsgZW5jb2RpbmcgPSB7IGZ1biA9IGdldF9lbmNvZGluZ19mdW5jdGlvbignaGV4JyksCgkJCQkJCSAgbmFtZSA9ICdoZXgnIH0sCgkJCSBmb3JtYXQgPSAnbG9nJyAtLSBvciAnY29tcGFjdCcgZm9yIGJhc2U2NCBlbmNvZGVkIGpzb24KCQkgICB9LAogICBwYXJzZXIgPSB7c3RyaWN0X21hdGNoID0gdHJ1ZSwKICAgICAgICAgICAgIHN0cmljdF9wYXJzZSA9IHRydWV9LAogICBleGVjID0geyBzY29wZSA9ICdmdWxsJyB9LCAtLSBmcm9tIGNvbmYgc2NvcGU9Z2l2ZW4sIHRyaWdnZXJzOgogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAtLSBwYXJzZXIuc3RyaWN0X21hdGNoPWZhbHNlCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIC0tIG1pc3NpbmcuZmF0YWw9ZmFsc2UKICAgbWlzc2luZyA9IHsgZmF0YWwgPSB0cnVlIH0sCiAgIGhlYXAgPSB7IGNoZWNrX2NvbGxpc2lvbiA9IHRydWUgfSwKICAgaGFzaCA9ICdzaGEyNTYnLAogICBwYXRoID0geyBzZXBhcmF0b3IgPSAnLicgfSwKfQotLSB0dXJuIG9uIGhlYXBndWFyZCB3aGVuIERFQlVHIG9yIGxpbnV4LWRlYnVnIGJ1aWxkCmlmIERFQlVHID4gMSBvciBNQUtFVEFSR0VUID09ICJsaW51eC1kZWJ1ZyIgdGhlbgogICBfR1snQ09ORiddLmhlYXBndWFyZCA9IHRydWUKZWxzZQogICBfR1snQ09ORiddLmhlYXBndWFyZCA9IGZhbHNlCmVuZAoKLS0gZG8gbm90IG1vZGlmeQpfR1snTElDRU5TRSddID0KCVtbCkxpY2Vuc2VkIHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIFB1YmxpYyBMaWNlbnNlIGFzIHB1Ymxpc2hlZCBieQp0aGUgRnJlZSBTb2Z0d2FyZSBGb3VuZGF0aW9uOyBlaXRoZXIgdmVyc2lvbiAzIG9mIHRoZSBMaWNlbnNlLCBvcgooYXQgeW91ciBvcHRpb24pIGFueSBsYXRlciB2ZXJzaW9uLiAgVW5sZXNzIHJlcXVpcmVkIGJ5IGFwcGxpY2FibGUKbGF3IG9yIGFncmVlZCB0byBpbiB3cml0aW5nLCBzb2Z0d2FyZSBkaXN0cmlidXRlZCB1bmRlciB0aGUgTGljZW5zZQppcyBkaXN0cmlidXRlZCBvbiBhbiAiQVMgSVMiIEJBU0lTLCBXSVRIT1VUIFdBUlJBTlRJRVMgT1IKQ09ORElUSU9OUyBPRiBBTlkgS0lORCwgZWl0aGVyIGV4cHJlc3Mgb3IgaW1wbGllZC4KXV0KX0dbJ0NPUFlSSUdIVCddID0KCVtbCkZvcmtlZCBieSBKYXJvbWlsIG9uIDE4IEphbnVhcnkgMjAyMCBmcm9tIENvY29udXQgUGV0aXRpb24KXV0KU0FMVCA9IEVDUC5oYXNodG9wb2ludChPQ1RFVC5mcm9tX3N0cmluZyhDT1BZUklHSFQgLi4gTElDRU5TRSkpCi0tIENhbGN1bGF0ZSBhIHN5c3RlbS13aWRlIGNyeXB0byBjaGFsbGVuZ2UgZm9yIFpLUCBvcGVyYXRpb25zCi0tIHJldHVybnMgYSBCSUcgSU5UCi0tIHRoaXMgaXMgYSBzb3J0IG9mIHNhbHRlZCBoYXNoIGZvciBhZHZhbmNlZCBaS1Agb3BlcmF0aW9ucyBhbmQKLS0gc2hvdWxkIG5vdCBiZSBjaGFuZ2VkLiBJdCBtYXkgYmUgbWFkZSBjb25maWd1cmFibGUgaW4gZnV0dXJlLgpmdW5jdGlvbiBaS1BfY2hhbGxlbmdlKGxpc3QpCglsb2NhbCBjaGFsbGVuZ2UgPQoJCUVDUC5nZW5lcmF0b3IoKTpvY3RldCgpIC4uIEVDUDIuZ2VuZXJhdG9yKCk6b2N0ZXQoKSAuLiBTQUxUOm9jdGV0KCkKCWxvY2FsIHNlciA9IHNlcmlhbGl6ZShsaXN0KQoJcmV0dXJuIElOVC5uZXcoCgkJc2hhMjU2KGNoYWxsZW5nZSAuLiBzZXIub2N0ZXRzIC4uIE9DVEVULmZyb21fc3RyaW5nKHNlci5zdHJpbmdzKSkKCSkgJSBFQ1Aub3JkZXIoKQplbmQKCmNvbGxlY3RnYXJiYWdlICdjb2xsZWN0JwovaW5zcGVjdC5sdWEALS0tIDxoMT5EZWJ1ZyBpbnNwZWN0aW9uIGZhY2lsaXR5PC9oMT4KLS0KLS0gVGhlIElOU1BFQ1QgY2xhc3MgcHJvdmlkZXMgYSBudW1iZXIgb2YgZnVuY3Rpb25zIHRvIGVhc2UKLS0gZGV2ZWxvcG1lbnQgYW5kIGRlYnVnZ2luZy4gSXQgbWFpbmx5IGNvbnNpc3RzIG9mIGFuIGFkdmFuY2VkCi0tIEB7cHJpbnR9IGZ1bmN0aW9uIHRoYXQgY2FuIHJlcHJlc2VudCBjb21wbGV4IGRhdGEgc3RydWN0dXJlcyAoTHVhCi0tIHRhYmxlcykgYW5kIHRhZyB0aGVpciBlbmNvZGluZyBmb3JtYXRzIGFuZCBzaXplLiAgQW5vdGhlciBAe3NweX0KLS0gZnVuY3Rpb24gcHJpbnRzIHRoZSBzYW1lIGFzIHBhc3MtdGhyb3VnaC4KLS0KLS0gQG1vZHVsZSBJTlNQRUNUCi0tIEBhdXRob3IgS2lraXRvIDxhIGhyZWY9Imh0dHA6Ly9naXRodWIuY29tL2tpa2l0by9pbnNwZWN0Lmx1YSI+Z2l0aHViLmNvbS9raWtpdG8vaW5zcGVjdC5sdWE8L2E+Ci0tIEBsaWNlbnNlIE1JVAoKbG9jYWwgaW5zcGVjdCA9IHsKICBfVkVSU0lPTiA9ICdpbnNwZWN0Lmx1YSAzLjEuMCcsCiAgX1VSTCAgICAgPSAnaHR0cDovL2dpdGh1Yi5jb20va2lraXRvL2luc3BlY3QubHVhJywKICBfREVTQ1JJUFRJT04gPSAnaHVtYW4tcmVhZGFibGUgcmVwcmVzZW50YXRpb25zIG9mIHRhYmxlcycKICAtLSBfTElDRU5TRSA9IFtbCiAgLS0gICBNSVQgTElDRU5TRQoKICAtLSAgIENvcHlyaWdodCAoYykgMjAxMyBFbnJpcXVlIEdhcmPDrWEgQ290YQogIC0tICAgQ29weXJpZ2h0IChjKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgoKICAtLSAgIFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhCiAgLS0gICBjb3B5IG9mIHRoaXMgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlCiAgLS0gICAiU29mdHdhcmUiKSwgdG8gZGVhbCBpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nCiAgLS0gICB3aXRob3V0IGxpbWl0YXRpb24gdGhlIHJpZ2h0cyB0byB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsCiAgLS0gICBkaXN0cmlidXRlLCBzdWJsaWNlbnNlLCBhbmQvb3Igc2VsbCBjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8KICAtLSAgIHBlcm1pdCBwZXJzb25zIHRvIHdob20gdGhlIFNvZnR3YXJlIGlzIGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0bwogIC0tICAgdGhlIGZvbGxvd2luZyBjb25kaXRpb25zOgoKICAtLSAgIFRoZSBhYm92ZSBjb3B5cmlnaHQgbm90aWNlIGFuZCB0aGlzIHBlcm1pc3Npb24gbm90aWNlIHNoYWxsIGJlIGluY2x1ZGVkCiAgLS0gICBpbiBhbGwgY29waWVzIG9yIHN1YnN0YW50aWFsIHBvcnRpb25zIG9mIHRoZSBTb2Z0d2FyZS4KCiAgLS0gICBUSEUgU09GVFdBUkUgSVMgUFJPVklERUQgIkFTIElTIiwgV0lUSE9VVCBXQVJSQU5UWSBPRiBBTlkgS0lORCwgRVhQUkVTUwogIC0tICAgT1IgSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRgogIC0tICAgTUVSQ0hBTlRBQklMSVRZLCBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRSBBTkQgTk9OSU5GUklOR0VNRU5ULgogIC0tICAgSU4gTk8gRVZFTlQgU0hBTEwgVEhFIEFVVEhPUlMgT1IgQ09QWVJJR0hUIEhPTERFUlMgQkUgTElBQkxFIEZPUiBBTlkKICAtLSAgIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsCiAgLS0gICBUT1JUIE9SIE9USEVSV0lTRSwgQVJJU0lORyBGUk9NLCBPVVQgT0YgT1IgSU4gQ09OTkVDVElPTiBXSVRIIFRIRQogIC0tICAgU09GVFdBUkUgT1IgVEhFIFVTRSBPUiBPVEhFUiBERUFMSU5HUyBJTiBUSEUgU09GVFdBUkUuCiAgLS0gXV0KfQoKbG9jYWwgdG9zdHJpbmcgPSB0b3N0cmluZwoKaW5zcGVjdC5LRVkgICAgICAgPSBzZXRtZXRhdGFibGUoe30sIHtfX3Rvc3RyaW5nID0gZnVuY3Rpb24oKSByZXR1cm4gJ2luc3BlY3QuS0VZJyBlbmR9KQppbnNwZWN0Lk1FVEFUQUJMRSA9IHNldG1ldGF0YWJsZSh7fSwge19fdG9zdHJpbmcgPSBmdW5jdGlvbigpIHJldHVybiAnaW5zcGVjdC5NRVRBVEFCTEUnIGVuZH0pCgoKLS0tCi0tIENvbnZlcnQgYSBkYXRhIG9iamVjdCB0byB0aGUgZGVzaXJlZCBmb3JtYXQgKGFyZ3VtZW50IG5hbWUgcHJvdmlkZWQKLS0gYXMgc3RyaW5nKSwgb3IgdXNlIENPTkYuZW5jb2Rpbmcgd2hlbiBjYWxsZWQgd2l0aG91dCBhcmd1bWVudAotLQotLSBAZnVuY3Rpb24gZXhwb3J0X29iaihvYmplY3QsIGZvcm1hdCkKLS0gQHBhcmFtIG9iamVjdCBkYXRhIGVsZW1lbnQgdG8gYmUgY29udmVydGVkCi0tIEBwYXJhbSBmb3JtYXQgcG9pbnRlciB0byBhIGNvbnZlcnRlciBmdW5jdGlvbgotLSBAcmV0dXJuIG9iamVjdCBjb252ZXJ0ZWQgdG8gZm9ybWF0CmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9hcnIob2JqZWN0LCBmb3JtYXQpCiAgemVuY29kZV9hc3NlcnQoCiAgICAgaXN6ZW4odHlwZShvYmplY3QpKSwKICAgICAnZXhwb3J0X2FyciBjYWxsZWQgb24gYSAnIC4uIHR5cGUob2JqZWN0KQogICkKICBsb2NhbCBjb252X2YgPSBuaWwKICBsb2NhbCBmdCA9IHR5cGUoZm9ybWF0KQogIGlmIGZvcm1hdCBhbmQgZnQgPT0gJ2Z1bmN0aW9uJyB0aGVuCiAgICAgY29udl9mID0gZm9ybWF0CiAgZWxzZWlmIGZvcm1hdCBhbmQgZnQgPT0gJ3N0cmluZycgdGhlbgogICAgIGNvbnZfZiA9IGdldF9lbmNvZGluZ19mdW5jdGlvbihmb3JtYXQpCiAgZWxzZWlmIG5vdCBDT05GLm91dHB1dC5lbmNvZGluZyB0aGVuCiAgICAgZXJyb3IoJ0NPTkYub3V0cHV0LmVuY29kaW5nIGlzIG5vdCBjb25maWd1cmVkJywgMikKICBlbHNlCiAgICBjb252X2YgPSBDT05GLmRlYnVnLmVuY29kaW5nLmZ1biAtLSBmYWxsYmFjayB0byBjb25maWd1cmVkIGNvbnZlcnNpb24gZnVuY3Rpb24KICBlbmQKICB6ZW5jb2RlX2Fzc2VydCgKICAgICB0eXBlKGNvbnZfZikgPT0gJ2Z1bmN0aW9uJywKICAgICAnZXhwb3J0X2FyciBjb252ZXJzaW9uIGZ1bmN0aW9uIG5vdCBjb25maWd1cmVkJwogICkKICByZXR1cm4gY29udl9mKG9iamVjdCkgLS0gVE9ETzogcHJvdGVjdGVkIGNhbGw/IGRlZXBtYXA/CmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X29iaihvYmplY3QsIGZvcm1hdCkKICAtLSBDT05GIHsgZW5jb2RpbmcgPSA8ZnVuY3Rpb24gMT4sCiAgLS0gICAgICAgIGVuY29kaW5nX3ByZWZpeCA9ICJ1NjQiICB9CiAgaWYgbm90IG9iamVjdCB0aGVuCgkgZXJyb3IoJ0luc3BlY3QuZXhwb3J0X29iaigpIG9iamVjdCBub3QgZm91bmQ6ICcsIGZvcm1hdCwzKSBlbmQKICBpZiBsdWF0eXBlKG9iamVjdCkgPT0gJ3RhYmxlJyB0aGVuCiAgICAgbG9jYWwgdHJlcyA9IHt9CiAgICAgZm9yIGssIHYgaW4gcGFpcnMob2JqZWN0KSBkbyAtLSBvbmx5IGZsYXQgdGFibGVzIHN1cHBvcnQgcmVjdXJzaW9uCiAgICAgICAgdGFibGUuaW5zZXJ0KHRyZXMsIGV4cG9ydF9hcnIodiwgZm9ybWF0KSkKICAgICBlbmQKICAgICByZXR1cm4gdHJlcwogIGVuZAogIHJldHVybiBleHBvcnRfYXJyKG9iamVjdCwgZm9ybWF0KQplbmQKCi0tIEFwb3N0cm9waGl6ZXMgdGhlIHN0cmluZyBpZiBpdCBoYXMgcXVvdGVzLCBidXQgbm90IGFwaG9zdHJvcGhlcwotLSBPdGhlcndpc2UsIGl0IHJldHVybnMgYSByZWd1bGFyIHF1b3RlZCBzdHJpbmcKbG9jYWwgZnVuY3Rpb24gc21hcnRRdW90ZShzdHIpCiAgaWYgc3RyOm1hdGNoKCciJykgYW5kIG5vdCBzdHI6bWF0Y2goIiciKSB0aGVuCiAgICByZXR1cm4gIiciIC4uIHN0ciAuLiAiJyIKICBlbmQKICByZXR1cm4gJyInIC4uIHN0cjpnc3ViKCciJywgJ1xcIicpIC4uICciJwplbmQKCi0tIFxhID0+ICdcXGEnLCBcMCA9PiAnXFwwJywgMzEgPT4gJ1wzMScKbG9jYWwgc2hvcnRDb250cm9sQ2hhckVzY2FwZXMgPSB7CiAgWyJcYSJdID0gIlxcYSIsICBbIlxiIl0gPSAiXFxiIiwgWyJcZiJdID0gIlxcZiIsIFsiXG4iXSA9ICJcXG4iLAogIFsiXHIiXSA9ICJcXHIiLCAgWyJcdCJdID0gIlxcdCIsIFsiXHYiXSA9ICJcXHYiCn0KbG9jYWwgbG9uZ0NvbnRyb2xDaGFyRXNjYXBlcyA9IHt9IC0tIFxhID0+IG5pbCwgXDAgPT4gXDAwMCwgMzEgPT4gXDAzMQpmb3IgaT0wLCAzMSBkbwogIGxvY2FsIGNoID0gc3RyaW5nLmNoYXIoaSkKICBpZiBub3Qgc2hvcnRDb250cm9sQ2hhckVzY2FwZXNbY2hdIHRoZW4KICAgIHNob3J0Q29udHJvbENoYXJFc2NhcGVzW2NoXSA9ICJcXCIuLmkKICAgIGxvbmdDb250cm9sQ2hhckVzY2FwZXNbY2hdICA9IHN0cmluZy5mb3JtYXQoIlxcJTAzZCIsIGkpCiAgZW5kCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXNjYXBlKHN0cikKICByZXR1cm4gKHN0cjpnc3ViKCJcXCIsICJcXFxcIikKICAgICAgICAgICAgIDpnc3ViKCIoJWMpJWZbMC05XSIsIGxvbmdDb250cm9sQ2hhckVzY2FwZXMpCiAgICAgICAgICAgICA6Z3N1YigiJWMiLCBzaG9ydENvbnRyb2xDaGFyRXNjYXBlcykpCmVuZAoKbG9jYWwgZnVuY3Rpb24gaXNJZGVudGlmaWVyKHN0cikKICByZXR1cm4gdHlwZShzdHIpID09ICdzdHJpbmcnIGFuZCBzdHI6bWF0Y2goICJeW18lYV1bXyVhJWRdKiQiICkKZW5kCgpsb2NhbCBmdW5jdGlvbiBpc1NlcXVlbmNlS2V5KGssIHNlcXVlbmNlTGVuZ3RoKQogIHJldHVybiB0eXBlKGspID09ICdudW1iZXInCiAgICAgYW5kIDEgPD0gawogICAgIGFuZCBrIDw9IHNlcXVlbmNlTGVuZ3RoCiAgICAgYW5kIG1hdGguZmxvb3IoaykgPT0gawplbmQKCmxvY2FsIGRlZmF1bHRUeXBlT3JkZXJzID0gewogIFsnbnVtYmVyJ10gICA9IDEsIFsnYm9vbGVhbiddICA9IDIsIFsnc3RyaW5nJ10gPSAzLCBbJ3RhYmxlJ10gPSA0LAogIFsnZnVuY3Rpb24nXSA9IDUsIFsndXNlcmRhdGEnXSA9IDYsIFsndGhyZWFkJ10gPSA3Cn0KCmxvY2FsIGZ1bmN0aW9uIHNvcnRLZXlzKGEsIGIpCiAgbG9jYWwgdGEsIHRiID0gdHlwZShhKSwgdHlwZShiKQoKICAtLSBzdHJpbmdzIGFuZCBudW1iZXJzIGFyZSBzb3J0ZWQgbnVtZXJpY2FsbHkvYWxwaGFiZXRpY2FsbHkKICBpZiB0YSA9PSB0YiBhbmQgKHRhID09ICdzdHJpbmcnIG9yIHRhID09ICdudW1iZXInKSB0aGVuIHJldHVybiBhIDwgYiBlbmQKCiAgbG9jYWwgZHRhLCBkdGIgPSBkZWZhdWx0VHlwZU9yZGVyc1t0YV0sIGRlZmF1bHRUeXBlT3JkZXJzW3RiXQogIC0tIFR3byBkZWZhdWx0IHR5cGVzIGFyZSBjb21wYXJlZCBhY2NvcmRpbmcgdG8gdGhlIGRlZmF1bHRUeXBlT3JkZXJzIHRhYmxlCiAgaWYgZHRhIGFuZCBkdGIgdGhlbiByZXR1cm4gZGVmYXVsdFR5cGVPcmRlcnNbdGFdIDwgZGVmYXVsdFR5cGVPcmRlcnNbdGJdCiAgZWxzZWlmIGR0YSAgICAgdGhlbiByZXR1cm4gdHJ1ZSAgLS0gZGVmYXVsdCB0eXBlcyBiZWZvcmUgY3VzdG9tIG9uZXMKICBlbHNlaWYgZHRiICAgICB0aGVuIHJldHVybiBmYWxzZSAtLSBjdXN0b20gdHlwZXMgYWZ0ZXIgZGVmYXVsdCBvbmVzCiAgZW5kCgogIC0tIGN1c3RvbSB0eXBlcyBhcmUgc29ydGVkIG91dCBhbHBoYWJldGljYWxseQogIHJldHVybiB0YSA8IHRiCmVuZAoKLS0gRm9yIGltcGxlbWVudGF0aW9uIHJlYXNvbnMsIHRoZSBiZWhhdmlvciBvZiByYXdsZW4gJiAjIGlzICJ1bmRlZmluZWQiIHdoZW4KLS0gdGFibGVzIGFyZW4ndCBwdXJlIHNlcXVlbmNlcy4gU28gd2UgaW1wbGVtZW50IG91ciBvd24gIyBvcGVyYXRvci4KbG9jYWwgZnVuY3Rpb24gZ2V0U2VxdWVuY2VMZW5ndGgodCkKICBsb2NhbCBsZW4gPSAxCiAgbG9jYWwgdiA9IHJhd2dldCh0LGxlbikKICB3aGlsZSB2IH49IG5pbCBkbwogICAgbGVuID0gbGVuICsgMQogICAgdiA9IHJhd2dldCh0LGxlbikKICBlbmQKICByZXR1cm4gbGVuIC0gMQplbmQKCmxvY2FsIGZ1bmN0aW9uIGdldE5vblNlcXVlbnRpYWxLZXlzKHQpCiAgbG9jYWwga2V5cyA9IHt9CiAgbG9jYWwgc2VxdWVuY2VMZW5ndGggPSBnZXRTZXF1ZW5jZUxlbmd0aCh0KQogIGZvciBrLF8gaW4gcGFpcnModCkgZG8KICAgIGlmIG5vdCBpc1NlcXVlbmNlS2V5KGssIHNlcXVlbmNlTGVuZ3RoKSB0aGVuIHRhYmxlLmluc2VydChrZXlzLCBrKSBlbmQKICBlbmQKICBRU09SVChrZXlzLCBzb3J0S2V5cykKICByZXR1cm4ga2V5cywgc2VxdWVuY2VMZW5ndGgKZW5kCgpsb2NhbCBmdW5jdGlvbiBnZXRUb1N0cmluZ1Jlc3VsdFNhZmVseSh0LCBtdCkKICBsb2NhbCBfX3Rvc3RyaW5nID0gdHlwZShtdCkgPT0gJ3RhYmxlJyBhbmQgcmF3Z2V0KG10LCAnX190b3N0cmluZycpCiAgbG9jYWwgc3RyLCBvawogIGlmIHR5cGUoX190b3N0cmluZykgPT0gJ2Z1bmN0aW9uJyB0aGVuCiAgICBvaywgc3RyID0gcGNhbGwoX190b3N0cmluZywgdCkKICAgIHN0ciA9IG9rIGFuZCBzdHIgb3IgJ2Vycm9yOiAnIC4uIHRvc3RyaW5nKHN0cikKICBlbmQKICBpZiB0eXBlKHN0cikgPT0gJ3N0cmluZycgYW5kICNzdHIgPiAwIHRoZW4gcmV0dXJuIHN0ciBlbmQKZW5kCgpsb2NhbCBmdW5jdGlvbiBjb3VudFRhYmxlQXBwZWFyYW5jZXModCwgdGFibGVBcHBlYXJhbmNlcykKICB0YWJsZUFwcGVhcmFuY2VzID0gdGFibGVBcHBlYXJhbmNlcyBvciB7fQoKICBpZiB0eXBlKHQpID09ICd0YWJsZScgdGhlbgogICAgaWYgbm90IHRhYmxlQXBwZWFyYW5jZXNbdF0gdGhlbgogICAgICB0YWJsZUFwcGVhcmFuY2VzW3RdID0gMQogICAgICBmb3Igayx2IGluIHBhaXJzKHQpIGRvCiAgICAgICAgY291bnRUYWJsZUFwcGVhcmFuY2VzKGssIHRhYmxlQXBwZWFyYW5jZXMpCiAgICAgICAgY291bnRUYWJsZUFwcGVhcmFuY2VzKHYsIHRhYmxlQXBwZWFyYW5jZXMpCiAgICAgIGVuZAogICAgICBjb3VudFRhYmxlQXBwZWFyYW5jZXMoZ2V0bWV0YXRhYmxlKHQpLCB0YWJsZUFwcGVhcmFuY2VzKQogICAgZWxzZQogICAgICB0YWJsZUFwcGVhcmFuY2VzW3RdID0gdGFibGVBcHBlYXJhbmNlc1t0XSArIDEKICAgIGVuZAogIGVuZAoKICByZXR1cm4gdGFibGVBcHBlYXJhbmNlcwplbmQKCmxvY2FsIGNvcHlTZXF1ZW5jZSA9IGZ1bmN0aW9uKHMpCiAgbG9jYWwgY29weSwgbGVuID0ge30sICNzCiAgZm9yIGk9MSwgbGVuIGRvIGNvcHlbaV0gPSBzW2ldIGVuZAogIHJldHVybiBjb3B5LCBsZW4KZW5kCgpsb2NhbCBmdW5jdGlvbiBtYWtlUGF0aChwYXRoLCAuLi4pCiAgbG9jYWwga2V5cyA9IHsuLi59CiAgbG9jYWwgbmV3UGF0aCwgbGVuID0gY29weVNlcXVlbmNlKHBhdGgpCiAgZm9yIGk9MSwgI2tleXMgZG8KICAgIG5ld1BhdGhbbGVuICsgaV0gPSBrZXlzW2ldCiAgZW5kCiAgcmV0dXJuIG5ld1BhdGgKZW5kCgpsb2NhbCBmdW5jdGlvbiBwcm9jZXNzUmVjdXJzaXZlKHByb2Nlc3MsIGl0ZW0sIHBhdGgsIHZpc2l0ZWQpCiAgICBpZiBpdGVtID09IG5pbCB0aGVuIHJldHVybiBuaWwgZW5kCiAgICBpZiB2aXNpdGVkW2l0ZW1dIHRoZW4gcmV0dXJuIHZpc2l0ZWRbaXRlbV0gZW5kCgogICAgbG9jYWwgcHJvY2Vzc2VkID0gcHJvY2VzcyhpdGVtLCBwYXRoKQoKICAgIGlmIHR5cGUocHJvY2Vzc2VkKSA9PSAndGFibGUnIHRoZW4KICAgICAgbG9jYWwgcHJvY2Vzc2VkQ29weSA9IHt9CiAgICAgIHZpc2l0ZWRbaXRlbV0gPSBwcm9jZXNzZWRDb3B5CiAgICAgIGxvY2FsIHByb2Nlc3NlZEtleQoKICAgICAgZm9yIGssdiBpbiBwYWlycyhwcm9jZXNzZWQpIGRvCiAgICAgICAgcHJvY2Vzc2VkS2V5ID0gcHJvY2Vzc1JlY3Vyc2l2ZShwcm9jZXNzLCBrLCBtYWtlUGF0aChwYXRoLCBrLCBpbnNwZWN0LktFWSksIHZpc2l0ZWQpCgogICAgICAgIGlmIHByb2Nlc3NlZEtleSB+PSBuaWwgdGhlbgogICAgICAgICAgcHJvY2Vzc2VkQ29weVtwcm9jZXNzZWRLZXldID0gcHJvY2Vzc1JlY3Vyc2l2ZShwcm9jZXNzLCB2LCBtYWtlUGF0aChwYXRoLCBwcm9jZXNzZWRLZXkpLCB2aXNpdGVkKQogICAgICAgIGVuZAogICAgICBlbmQKCiAgICAgIGxvY2FsIG10ICA9IHByb2Nlc3NSZWN1cnNpdmUocHJvY2VzcywgZ2V0bWV0YXRhYmxlKHByb2Nlc3NlZCksIG1ha2VQYXRoKHBhdGgsIGluc3BlY3QuTUVUQVRBQkxFKSwgdmlzaXRlZCkKICAgICAgaWYgdHlwZShtdCkgfj0gJ3RhYmxlJyB0aGVuIG10ID0gbmlsIGVuZCAtLSBpZ25vcmUgbm90IG5pbC90YWJsZSBfX21ldGF0YWJsZSBmaWVsZAogICAgICBzZXRtZXRhdGFibGUocHJvY2Vzc2VkQ29weSwgbXQpCiAgICAgIHByb2Nlc3NlZCA9IHByb2Nlc3NlZENvcHkKICAgIGVuZAogICAgcmV0dXJuIHByb2Nlc3NlZAplbmQKCgoKLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQoKbG9jYWwgSW5zcGVjdG9yID0ge30KbG9jYWwgSW5zcGVjdG9yX210ID0ge19faW5kZXggPSBJbnNwZWN0b3J9CgpmdW5jdGlvbiBJbnNwZWN0b3I6cHV0cyguLi4pCiAgbG9jYWwgYXJncyAgID0gey4uLn0KICBsb2NhbCBidWZmZXIgPSBzZWxmLmJ1ZmZlcgogIGxvY2FsIGxlbiAgICA9ICNidWZmZXIKICBmb3IgaT0xLCAjYXJncyBkbwogICAgbGVuID0gbGVuICsgMQogICAgYnVmZmVyW2xlbl0gPSBhcmdzW2ldCiAgZW5kCmVuZAoKZnVuY3Rpb24gSW5zcGVjdG9yOmRvd24oZikKICBzZWxmLmxldmVsID0gc2VsZi5sZXZlbCArIDEKICBmKCkKICBzZWxmLmxldmVsID0gc2VsZi5sZXZlbCAtIDEKZW5kCgpmdW5jdGlvbiBJbnNwZWN0b3I6dGFiaWZ5KCkKICBzZWxmOnB1dHMoc2VsZi5uZXdsaW5lLCBzdHJpbmcucmVwKHNlbGYuaW5kZW50LCBzZWxmLmxldmVsKSkKZW5kCgpmdW5jdGlvbiBJbnNwZWN0b3I6YWxyZWFkeVZpc2l0ZWQodikKICByZXR1cm4gc2VsZi5pZHNbdl0gfj0gbmlsCmVuZAoKZnVuY3Rpb24gSW5zcGVjdG9yOmdldElkKHYpCiAgbG9jYWwgaWQgPSBzZWxmLmlkc1t2XQogIGlmIG5vdCBpZCB0aGVuCiAgICBsb2NhbCB0diA9IHR5cGUodikKICAgIGlkICAgICAgICAgICAgICA9IChzZWxmLm1heElkc1t0dl0gb3IgMCkgKyAxCiAgICBzZWxmLm1heElkc1t0dl0gPSBpZAogICAgc2VsZi5pZHNbdl0gICAgID0gaWQKICBlbmQKICByZXR1cm4gdG9zdHJpbmcoaWQpCmVuZAoKZnVuY3Rpb24gSW5zcGVjdG9yOnB1dEtleShrKQogIGlmIGlzSWRlbnRpZmllcihrKSB0aGVuIHJldHVybiBzZWxmOnB1dHMoaykgZW5kCiAgc2VsZjpwdXRzKCJbIikKICBzZWxmOnB1dFZhbHVlKGspCiAgc2VsZjpwdXRzKCJdIikKZW5kCgpmdW5jdGlvbiBJbnNwZWN0b3I6cHV0VGFibGUodCwgZXhwKQogIGlmIHQgPT0gaW5zcGVjdC5LRVkgb3IgdCA9PSBpbnNwZWN0Lk1FVEFUQUJMRSB0aGVuCiAgICBzZWxmOnB1dHModG9zdHJpbmcodCkpCgktLSBzZWxmOnB1dHMoIlsiLi4jdC4uIl0iKQogIGVsc2VpZiBzZWxmOmFscmVhZHlWaXNpdGVkKHQpIHRoZW4KICAgIHNlbGY6cHV0cygnPHRhYmxlICcsIHNlbGY6Z2V0SWQodCksICc+JykKCS0tIHNlbGY6cHV0cygiWyIuLiN0Li4iXSIpCiAgZWxzZWlmIHNlbGYubGV2ZWwgPj0gc2VsZi5kZXB0aCB0aGVuCiAgICBzZWxmOnB1dHMoJ3suLi59JykKICBlbHNlCiAgICBpZiBzZWxmLnRhYmxlQXBwZWFyYW5jZXNbdF0gPiAxIHRoZW4gc2VsZjpwdXRzKCc8Jywgc2VsZjpnZXRJZCh0KSwgJz4nKSBlbmQKCiAgICBsb2NhbCBub25TZXF1ZW50aWFsS2V5cywgc2VxdWVuY2VMZW5ndGggPSBnZXROb25TZXF1ZW50aWFsS2V5cyh0KQogICAgbG9jYWwgbXQgICAgICAgICAgICAgICAgPSBnZXRtZXRhdGFibGUodCkKICAgIGxvY2FsIHRvU3RyaW5nUmVzdWx0ICAgID0gZ2V0VG9TdHJpbmdSZXN1bHRTYWZlbHkodCwgbXQpCgogICAgc2VsZjpwdXRzKCd7JykKICAgIHNlbGY6ZG93bihmdW5jdGlvbigpCiAgICAgIGlmIHRvU3RyaW5nUmVzdWx0IHRoZW4KICAgICAgICBzZWxmOnB1dHMoJyAtLSAnLCBlc2NhcGUodG9TdHJpbmdSZXN1bHQpKQogICAgICAgIGlmIHNlcXVlbmNlTGVuZ3RoID49IDEgdGhlbiBzZWxmOnRhYmlmeSgpIGVuZAogICAgICBlbmQKCiAgICAgIGxvY2FsIGNvdW50ID0gMAogICAgICBmb3IgaT0xLCBzZXF1ZW5jZUxlbmd0aCBkbwogICAgICAgIGlmIGNvdW50ID4gMCB0aGVuIHNlbGY6cHV0cygnLCcpIGVuZAogICAgICAgIHNlbGY6cHV0cygnICcpCiAgICAgICAgc2VsZjpwdXRWYWx1ZSh0W2ldLCBleHApCiAgICAgICAgY291bnQgPSBjb3VudCArIDEKICAgICAgZW5kCgogICAgICBmb3IgXyxrIGluIGlwYWlycyhub25TZXF1ZW50aWFsS2V5cykgZG8KICAgICAgICBpZiBjb3VudCA+IDAgdGhlbiBzZWxmOnB1dHMoJywnKSBlbmQKICAgICAgICBzZWxmOnRhYmlmeSgpCiAgICAgICAgc2VsZjpwdXRLZXkoaykKICAgICAgICBzZWxmOnB1dHMoJyA9ICcpCiAgICAgICAgc2VsZjpwdXRWYWx1ZSh0W2tdLCBleHApCiAgICAgICAgY291bnQgPSBjb3VudCArIDEKICAgICAgZW5kCgogICAgICBpZiB0eXBlKG10KSA9PSAndGFibGUnIHRoZW4KICAgICAgICBpZiBjb3VudCA+IDAgdGhlbiBzZWxmOnB1dHMoJywnKSBlbmQKICAgICAgICBzZWxmOnRhYmlmeSgpCiAgICAgICAgc2VsZjpwdXRzKCc8bWV0YXRhYmxlPiA9ICcpCiAgICAgICAgc2VsZjpwdXRWYWx1ZShtdCwgZXhwKQogICAgICBlbmQKICAgIGVuZCkKCiAgICBpZiAjbm9uU2VxdWVudGlhbEtleXMgPiAwIG9yIHR5cGUobXQpID09ICd0YWJsZScgdGhlbiAtLSByZXN1bHQgaXMgbXVsdGktbGluZWQuIEp1c3RpZnkgY2xvc2luZyB9CiAgICAgIHNlbGY6dGFiaWZ5KCkKICAgIGVsc2VpZiBzZXF1ZW5jZUxlbmd0aCA+IDAgdGhlbiAtLSBhcnJheSB0YWJsZXMgaGF2ZSBvbmUgZXh0cmEgc3BhY2UgYmVmb3JlIGNsb3NpbmcgfQogICAgICBzZWxmOnB1dHMoJyAnKQogICAgZW5kCgogICAgc2VsZjpwdXRzKCd9JykKICBlbmQKZW5kCgpmdW5jdGlvbiBJbnNwZWN0b3I6cHV0VmFsdWUodiwgZXhwKQogIGxvY2FsIHR2ID0gdHlwZSh2KQogIGxvY2FsIGV4cG9ydGVyID0gZXhwIG9yIGV4cG9ydF9vYmoKICBpZiB0diA9PSAnc3RyaW5nJyB0aGVuCiAgICBzZWxmOnB1dHMoc21hcnRRdW90ZShlc2NhcGUodikpKQogIGVsc2VpZiB0diA9PSAnbnVtYmVyJyBvciB0diA9PSAnYm9vbGVhbicgb3IgdHYgPT0gJ25pbCcgb3IKICAgICAgICAgdHYgPT0gJ2NkYXRhJyBvciB0diA9PSAnY3R5cGUnIHRoZW4KICAgIHNlbGY6cHV0cyh0b3N0cmluZyh2KSkKICBlbHNlaWYgdHYgPT0gJ3RhYmxlJyB0aGVuCgkgaWYgI3YgPiAwIHRoZW4gc2VsZjpwdXRzKCJbIi4uI3YuLiJdICIpIGVuZAoJIHNlbGY6cHV0VGFibGUodiwgZXhwb3J0ZXIpCiAgZWxzZWlmIGlzemVuKHR2KSB0aGVuCgkgaWYgdHYgPT0gInplbnJvb20ub2N0ZXQiIHRoZW4KICAgICAgICAgbG9jYWwgbGVuIDxjb25zdD4gPSAjdgogICAgICAgICBpZiBsZW4gPT0gMCB0aGVuCiAgICAgICAgICAgICBzZWxmOnB1dHMoIm9jdGV0WzBdIChudWxsKSIpCiAgICAgICAgIGVsc2VpZiB2OmlzX3plcm8oKSB0aGVuCiAgICAgICAgICAgICBzZWxmOnB1dHMoIm9jdGV0WyIgLi4gI3YgLi4gIl0gKGFsbCB6ZXJvKSIpCiAgICAgICAgIGVsc2VpZiBzZWxmLnNjaGVtYSBhbmQgKCBsZW4gPT0gMTYgb3IgbGVuID09IDMyIG9yIGxlbiA9PSA2NCApIHRoZW4KICAgICAgICAgICAgIHNlbGY6cHV0cygib2N0ZXRbIiAuLiAjdiAuLiAiXSAiIC4uIE8udG9faGV4KHYpKQogICAgICAgICBlbHNlaWYgc2VsZi5zY2hlbWEgYW5kIGxlbiA8IDMxIHRoZW4KICAgICAgICAgICAgIHNlbGY6cHV0cygib2N0ZXRbIiAuLiAjdiAuLiAiXSAiIC4uIE8udG9fc3RyaW5nKHYpKQogICAgICAgICBlbHNlCiAgICAgICAgICAgICBzZWxmOnB1dHMoIm9jdGV0WyIgLi4gI3YgLi4gIl0gIiAuLiBleHBvcnRlcih2KSkKICAgICAgICAgZW5kCgkgZWxzZWlmIHR2ID09ICJ6ZW5yb29tLmJpZyIgdGhlbgogICAgICAgICBsb2NhbCBpIDxjb25zdD4gPSB2Om9jdGV0KCkKICAgICAgICAgbG9jYWwgbGVuIDxjb25zdD4gPSAjaQogICAgICAgICBpZiBzZWxmLnNjaGVtYSBhbmQgbGVuIDwgOCB0aGVuCiAgICAgICAgICAgICBzZWxmOnB1dHMoImRlY1siIC4uIGxlbiAuLiJdICIuLiBCSUcudG9fZGVjaW1hbCh2KSkKICAgICAgICAgZWxzZWlmIGxlbiA9PSAxNiBvciBsZW4gPT0gMzIgb3IgbGVuID09IDY0IHRoZW4KICAgICAgICAgICAgIHNlbGY6cHV0cygiYmlnWyIgLi4gbGVuIC4uICJdICIgLi4gTy50b19oZXgoaSkpCiAgICAgICAgIGVsc2UKICAgICAgICAgICAgIHNlbGY6cHV0cygiYmlnWyIgLi4gbGVuLi4gIl0gIiAuLiBleHBvcnRlcih2LCAiaW50ZWdlciIpKQogICAgICAgICBlbmQKCSBlbHNlaWYgdHYgPT0gInplbnJvb20uZmxvYXQiIHRoZW4KCQlzZWxmOnB1dHMoImZsb2F0ICIgLi4gZXhwb3J0ZXIodiwgImZsb2F0IikpIC0tIGV4cG9ydGVyKGkpKQoJIGVsc2VpZiB0diA9PSAiemVucm9vbS50aW1lIiB0aGVuCgkJc2VsZjpwdXRzKCJ0aW1lICIgLi4gZXhwb3J0ZXIodiwgInRpbWUiKSkgLS0gZXhwb3J0ZXIoaSkpCgkgZWxzZWlmIHR2ID09ICJ6ZW5yb29tLmVjcCIgdGhlbgoJCWxvY2FsIGkgPSB2Om9jdGV0KCkKCQlpZiB2ID09ICJJbmZpbml0eSIgb3IgdiA9PSBFQ1AuaW5maW5pdHkoKSB0aGVuCgkJICAgc2VsZjpwdXRzKCJlY3BbLi4uXSAoSW5maW5pdHkpIikKCQllbHNlCgkJICAgc2VsZjpwdXRzKCJlY3BbIiAuLiAjaS4uICJdICIgLi4gZXhwb3J0ZXIoaSkpCgkJZW5kCgkgZWxzZWlmIHR2ID09ICJ6ZW5yb29tLmVjcDIiIHRoZW4KCQlsb2NhbCBpID0gdjpvY3RldCgpCgkJaWYgdiA9PSAiSW5maW5pdHkiIG9yIHYgPT0gRUNQMi5pbmZpbml0eSgpIHRoZW4KCQkgICBzZWxmOnB1dHMoImVjcFsuLi5dIChJbmZpbml0eSkiKQoJCWVsc2UKCQkgICBzZWxmOnB1dHMoImVjcDJbIiAuLiNpLi4gIl0gIi4uIGV4cG9ydGVyKGkpKQoJCWVuZAoJIGVsc2VpZiB0diA9PSAiemVucm9vbS5mcDEyIiB0aGVuCgkJbG9jYWwgaSA9IHY6b2N0ZXQoKQoJCXNlbGY6cHV0cygiZnAxMlsiIC4uI2kuLiAiXSAiLi4gZXhwb3J0ZXIoaSkpCgkgZWxzZWlmIHR2ID09ICJ6ZW5yb29tLmVjZGgiIHRoZW4KCQlsb2NhbCBwayA9IHY6cHVibGljKCkKCQlsb2NhbCBzayA9IHY6cHJpdmF0ZSgpCgkJaWYgbm90IHBrIGFuZCBub3Qgc2sgdGhlbiBzZWxmOnB1dHMoImVjZGgga2V5cmluZyBpcyBlbXB0eVxuIikKCQllbHNlCgkJICAgaWYgcGsgdGhlbiBzZWxmOnB1dHMoImVjZGgucHVibGljWyIuLiNway4uIl0gIi4uIGV4cG9ydGVyKHBrKS4uIlxuIikgZW5kCgkJICAgaWYgc2sgdGhlbiBzZWxmOnB1dHMoImVjZGgucHJpdmF0ZVsiLi4jc2suLiJdICIuLiBleHBvcnRlcihzaykuLiJcbiIpIGVuZAoJCWVuZAoJIGVsc2UKCQlzZWxmOnB1dHMoZXhwb3J0ZXIodjpvY3RldCgpKSkKCSBlbmQKICBlbHNlCiAgICBzZWxmOnB1dHMoJzwnLHR2LCcgJyxzZWxmOmdldElkKHYpLCc+JykKICBlbmQKZW5kCgotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCgpmdW5jdGlvbiBpbnNwZWN0Lmluc3BlY3Qocm9vdCwgb3B0aW9ucykKICBvcHRpb25zICAgICAgID0gb3B0aW9ucyBvciB7fQoKICBsb2NhbCBkZXB0aCAgID0gb3B0aW9ucy5kZXB0aCAgIG9yIG1hdGguaHVnZQogIGxvY2FsIG5ld2xpbmUgPSBvcHRpb25zLm5ld2xpbmUgb3IgJ1xuJwogIGxvY2FsIGluZGVudCAgPSBvcHRpb25zLmluZGVudCAgb3IgJyAgICAnCiAgbG9jYWwgcHJvY2VzcyA9IG9wdGlvbnMucHJvY2VzcwogIGxvY2FsIHNjaGVtYSAgPSBvcHRpb25zLnNjaGVtYSBvciBmYWxzZQogIGlmIHByb2Nlc3MgdGhlbgogICAgcm9vdCA9IHByb2Nlc3NSZWN1cnNpdmUocHJvY2Vzcywgcm9vdCwge30sIHt9KQogIGVuZAoKICBsb2NhbCBpbnNwZWN0b3IgPSBzZXRtZXRhdGFibGUoewogICAgc2NoZW1hICAgICAgICAgICA9IHNjaGVtYSwKICAgIGRlcHRoICAgICAgICAgICAgPSBkZXB0aCwKICAgIGxldmVsICAgICAgICAgICAgPSAwLAogICAgYnVmZmVyICAgICAgICAgICA9IHt9LAogICAgaWRzICAgICAgICAgICAgICA9IHt9LAogICAgbWF4SWRzICAgICAgICAgICA9IHt9LAogICAgbmV3bGluZSAgICAgICAgICA9IG5ld2xpbmUsCiAgICBpbmRlbnQgICAgICAgICAgID0gaW5kZW50LAogICAgdGFibGVBcHBlYXJhbmNlcyA9IGNvdW50VGFibGVBcHBlYXJhbmNlcyhyb290KQogIH0sIEluc3BlY3Rvcl9tdCkKCiAgLS0gb3B0aW9uIHNjaGVtYSBvbmx5IChkb24ndCBwcmludCBjb250ZW50cykKICBpZiBzY2hlbWEgdGhlbgoJIGxvY2FsIF9mID0gZnVuY3Rpb24oXykJcmV0dXJuKCIiKSBlbmQKCSBpbnNwZWN0b3I6cHV0VmFsdWUocm9vdCwgX2YpCiAgZWxzZQoJIGluc3BlY3RvcjpwdXRWYWx1ZShyb290KQogIGVuZAoKICByZXR1cm4gdGFibGUuY29uY2F0KGluc3BlY3Rvci5idWZmZXIpCmVuZAoKLS0gYXBwbHkgY29udmVyc2lvbiB3cmFwcGVyIHRvIGFsbCB2YWx1ZXMgb2YgYSB0YWJsZQpmdW5jdGlvbiBpbnNwZWN0LnByb2Nlc3MoaXRlbSwgZm9ybWF0KQogICByZXR1cm4gcHJvY2Vzc1JlY3Vyc2l2ZShmdW5jdGlvbihpdGVtKQoJIGlmIGlzemVuKHR5cGUoaXRlbSkpIHRoZW4KCSAgICByZXR1cm4gZXhwb3J0X29iaihpdGVtLCBmb3JtYXQpCgkgZWxzZQoJICAgIHJldHVybiBpdGVtCgkgZW5kCiAgIGVuZCwgaXRlbSwge30sIHt9KQplbmQKCi0tLSBQcmludCBhbGwgY29udGVudHMgb2YgYSB0YWJsZSBpbiBhIHRyZWUgcmVwcmVzZW50YXRpb24sIHdvcmtzIHdpdGgKLS0gY29tcGxleCBkYXRhIHN0cnVjdHVyZXMgYW5kIHByaW50cyB0byBTVERPVVQuCi0tCi0tIEBmdW5jdGlvbiBJTlNQRUNULnByaW50KG9iamVjdCkKLS0gQHBhcmFtIG9iamVjdCBjb21wbGV4IHRhYmxlIGRhdGEgc3RydWN0dXJlCmZ1bmN0aW9uIGluc3BlY3QucHJpbnQocm9vdCwgb3B0aW9ucykKICAgcHJpbnQoaW5zcGVjdC5pbnNwZWN0KHJvb3QsIG9wdGlvbnMpKQogICByZXR1cm4gcm9vdAplbmQKCi0tLSBQcmludCB0aGUgcHJvdG90eXBlIChubyBjb250ZW50cyBvbmx5IHNjaGVtYSkgb2YgYSB0YWJsZSBpbiBhIHRyZWUKLS0tIHJlcHJlc2VudGF0aW9uLCB3b3JrcyB3aXRoIGNvbXBsZXggZGF0YSBzdHJ1Y3R1cmVzIGFuZCBwcmludHMgdG8KLS0tIFNURE9VVC4KLS0KLS0gQGZ1bmN0aW9uIElOU1BFQ1Quc2NoZW1hKG9iamVjdCkKLS0gQHBhcmFtIG9iamVjdCBjb21wbGV4IHRhYmxlIGRhdGEgc3RydWN0dXJlCmZ1bmN0aW9uIGluc3BlY3Quc2NoZW1hKHJvb3QsIG9wdGlvbnMpCiAgIHdhcm4oaW5zcGVjdC5pbnNwZWN0KHJvb3QsIHsgc2NoZW1hID0gdHJ1ZSB9KSkKICAgcmV0dXJuIHJvb3QKZW5kCgotLS0gUHJpbnQgYWxsIGNvbnRlbnRzIG9mIGEgdGFibGUgdG8gU1RERVJSLiBXb3JrcyBzYW1lIHdheSBhcyBAe3ByaW50fS4KLS0KLS0gQGZ1bmN0aW9uIElOU1BFQ1Qud2FybihvYmplY3QpCi0tIEBwYXJhbSBvYmplY3QgY29tcGxleCB0YWJsZSBkYXRhIHN0cnVjdHVyZQpmdW5jdGlvbiBpbnNwZWN0Lndhcm4ocm9vdCwgb3B0aW9ucykKICAgaWYgbHVhdHlwZShvcHRpb25zKSA9PSAnc3RyaW5nJyB0aGVuCiAgICAgIHdhcm4oJ1NweSBvbjogJy4ub3B0aW9ucykKICAgICAgd2FybihpbnNwZWN0Lmluc3BlY3Qocm9vdCwge30pKQogICBlbHNlCiAgICAgIHdhcm4oaW5zcGVjdC5pbnNwZWN0KHJvb3QsIG9wdGlvbnMpKQogICBlbmQKICAgcmV0dXJuIHJvb3QKZW5kCgotLS0gUHJpbnQgYWxsIGNvbnRlbnRzIG9mIGEgdGFibGUgdG8gU1RERVJSIGFuZCByZXR1cm4gc2FtZSBvYmplY3QgYXMKLS0tIHBhc3N0aHJvdWdoLiBXb3JrcyBzYW1lIHdheSBhcyBAe3ByaW50fS4KLS0KLS0gQGZ1bmN0aW9uIElOU1BFQ1Quc3B5KG9iamVjdCkKLS0gQHBhcmFtIG9iamVjdCBjb21wbGV4IHRhYmxlIGRhdGEgc3RydWN0dXJlCi0tIEByZXR1cm4gb2JqZWN0IGl0c2VsZiAocGFzc3Rocm91Z2ggZm9yIG5lc3RpbmcpCmluc3BlY3Quc3B5ID0gaW5zcGVjdC53YXJuCgpzZXRtZXRhdGFibGUoaW5zcGVjdCwgeyBfX2NhbGwgPSBmdW5jdGlvbihfLCAuLi4pIHJldHVybiBpbnNwZWN0LnByaW50KC4uLikgZW5kIH0pCgpyZXR1cm4gaW5zcGVjdAovanNvbi5sdWEALS0KLS0ganNvbi5sdWEKLS0KLS0gQ29weXJpZ2h0IChjKSAyMDE5IHJ4aQotLSBDb3B5cmlnaHQgKGMpIDIwMjAtMjAyMSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tCi0tIFBlcm1pc3Npb24gaXMgaGVyZWJ5IGdyYW50ZWQsIGZyZWUgb2YgY2hhcmdlLCB0byBhbnkgcGVyc29uIG9idGFpbmluZyBhIGNvcHkgb2YKLS0gdGhpcyBzb2Z0d2FyZSBhbmQgYXNzb2NpYXRlZCBkb2N1bWVudGF0aW9uIGZpbGVzICh0aGUgIlNvZnR3YXJlIiksIHRvIGRlYWwgaW4KLS0gdGhlIFNvZnR3YXJlIHdpdGhvdXQgcmVzdHJpY3Rpb24sIGluY2x1ZGluZyB3aXRob3V0IGxpbWl0YXRpb24gdGhlIHJpZ2h0cyB0bwotLSB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsIGRpc3RyaWJ1dGUsIHN1YmxpY2Vuc2UsIGFuZC9vciBzZWxsIGNvcGllcwotLSBvZiB0aGUgU29mdHdhcmUsIGFuZCB0byBwZXJtaXQgcGVyc29ucyB0byB3aG9tIHRoZSBTb2Z0d2FyZSBpcyBmdXJuaXNoZWQgdG8gZG8KLS0gc28sIHN1YmplY3QgdG8gdGhlIGZvbGxvd2luZyBjb25kaXRpb25zOgotLQotLSBUaGUgYWJvdmUgY29weXJpZ2h0IG5vdGljZSBhbmQgdGhpcyBwZXJtaXNzaW9uIG5vdGljZSBzaGFsbCBiZSBpbmNsdWRlZCBpbiBhbGwKLS0gY29waWVzIG9yIHN1YnN0YW50aWFsIHBvcnRpb25zIG9mIHRoZSBTb2Z0d2FyZS4KLS0KLS0gVEhFIFNPRlRXQVJFIElTIFBST1ZJREVEICJBUyBJUyIsIFdJVEhPVVQgV0FSUkFOVFkgT0YgQU5ZIEtJTkQsIEVYUFJFU1MgT1IKLS0gSU1QTElFRCwgSU5DTFVESU5HIEJVVCBOT1QgTElNSVRFRCBUTyBUSEUgV0FSUkFOVElFUyBPRiBNRVJDSEFOVEFCSUxJVFksCi0tIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFIEFORCBOT05JTkZSSU5HRU1FTlQuIElOIE5PIEVWRU5UIFNIQUxMIFRIRQotLSBBVVRIT1JTIE9SIENPUFlSSUdIVCBIT0xERVJTIEJFIExJQUJMRSBGT1IgQU5ZIENMQUlNLCBEQU1BR0VTIE9SIE9USEVSCi0tIExJQUJJTElUWSwgV0hFVEhFUiBJTiBBTiBBQ1RJT04gT0YgQ09OVFJBQ1QsIFRPUlQgT1IgT1RIRVJXSVNFLCBBUklTSU5HIEZST00sCi0tIE9VVCBPRiBPUiBJTiBDT05ORUNUSU9OIFdJVEggVEhFIFNPRlRXQVJFIE9SIFRIRSBVU0UgT1IgT1RIRVIgREVBTElOR1MgSU4gVEhFCi0tIFNPRlRXQVJFLgotLQoKbG9jYWwganNvbiA9IHsgX3ZlcnNpb24gPSAiMC4xLjIiIH0KCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KLS0gRW5jb2RlCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KCi0tIFRPRE8oQWxiZXJ0byk6IGNoZWNrIHRoZSB3ZWlyZCBlcnJvciBpbiB0ZXN0L2x1YS9qc29uLmx1YQoKbG9jYWwgZW5jb2RlCgpsb2NhbCBlc2NhcGVfY2hhcl9tYXAgPSB7CiAgWyAiXFwiIF0gPSAiXFxcXCIsCiAgWyAiXCIiIF0gPSAiXFxcIiIsCiAgWyAiXGIiIF0gPSAiXFxiIiwKICBbICJcZiIgXSA9ICJcXGYiLAogIFsgIlxuIiBdID0gIlxcbiIsCiAgWyAiXHIiIF0gPSAiXFxyIiwKICBbICJcdCIgXSA9ICJcXHQiLAp9Cgpsb2NhbCBlc2NhcGVfY2hhcl9tYXBfaW52ID0geyBbICJcXC8iIF0gPSAiLyIgfQpmb3IgaywgdiBpbiBwYWlycyhlc2NhcGVfY2hhcl9tYXApIGRvCiAgZXNjYXBlX2NoYXJfbWFwX2ludlt2XSA9IGsKZW5kCgoKbG9jYWwgZnVuY3Rpb24gZXNjYXBlX2NoYXIoYykKICByZXR1cm4gZXNjYXBlX2NoYXJfbWFwW2NdIG9yIHN0cmluZy5mb3JtYXQoIlxcdSUwNHgiLCBjOmJ5dGUoKSkKZW5kCgoKbG9jYWwgZnVuY3Rpb24gZW5jb2RlX25pbCh2YWwpCiAgcmV0dXJuICJudWxsIgplbmQKCgpsb2NhbCBmdW5jdGlvbiBlbmNvZGVfdGFibGUodmFsLCBzdGFjaywgd2hpdGVzcGFjZXMpCiAgbG9jYWwgcmVzID0ge30KICBzdGFjayA9IHN0YWNrIG9yIHt9CiAgbG9jYWwgc2VwYXJhdG9yID0gIiwiCiAgaWYgd2hpdGVzcGFjZXMgdGhlbgogICAgICBzZXBhcmF0b3IgPSAiLCAiCiAgZW5kCiAgLS0gQ2lyY3VsYXIgcmVmZXJlbmNlPwogIGlmIHN0YWNrW3ZhbF0gdGhlbiBlcnJvcigiY2lyY3VsYXIgcmVmZXJlbmNlIikgZW5kCgogIHN0YWNrW3ZhbF0gPSB0cnVlCgogIGxvY2FsIF9pcGFpcnMgPGNvbnN0PiA9IGZpZihDT05GLm91dHB1dC5zb3J0aW5nLHNvcnRfaXBhaXJzLGlwYWlycykKICBsb2NhbCBfcGFpcnMgPGNvbnN0PiA9IGZpZihDT05GLm91dHB1dC5zb3J0aW5nLHNvcnRfcGFpcnMscGFpcnMpCgogIGlmIHJhd2dldCh2YWwsIDEpIH49IG5pbCBvciBuZXh0KHZhbCkgPT0gbmlsIHRoZW4KICAgIC0tIFRyZWF0IGFzIGFycmF5IC0tIGNoZWNrIGtleXMgYXJlIHZhbGlkIGFuZCBpdCBpcyBub3Qgc3BhcnNlCiAgICBsb2NhbCBuID0gMAogICAgZm9yIGsgaW4gcGFpcnModmFsKSBkbwogICAgICBpZiB0eXBlKGspIH49ICJudW1iZXIiIHRoZW4KICAgICAgICBlcnJvcigiaW52YWxpZCB0YWJsZTogbWl4ZWQgb3IgaW52YWxpZCBrZXkgdHlwZXMiKQogICAgICBlbmQKICAgICAgbiA9IG4gKyAxCiAgICBlbmQKICAgIGlmIG4gfj0gI3ZhbCB0aGVuCiAgICAgIHdhcm4oIkpTT04gZW5jb2RpbmcgZXJyb3I6ICIuLnR5cGUodmFsKSkKICAgICAgZXJyb3IoImludmFsaWQgdGFibGU6IHNwYXJzZSBhcnJheSAobj0iLi5uLi4iLCAjdmFsPSIuLiN2YWwuLiIpIikKICAgIGVuZAogICAgLS0gRW5jb2RlCglmb3IgaSwgdiBpbiBfaXBhaXJzKHZhbCkgZG8KCSAgIHJlc1sjcmVzKzFdID0gZW5jb2RlKHYsIHN0YWNrLCB3aGl0ZXNwYWNlcykKCWVuZAogICAgc3RhY2tbdmFsXSA9IG5pbAogICAgcmV0dXJuICJbIiAuLiB0YWJsZS5jb25jYXQocmVzLCBzZXBhcmF0b3IpIC4uICJdIgoKICBlbHNlCiAgICAtLSBUcmVhdCBhcyBhbiBvYmplY3QKICAgIGZvciBrLCB2IGluIF9wYWlycyh2YWwpIGRvCiAgICAgIGlmIHR5cGUoaykgfj0gInN0cmluZyIgdGhlbgogICAgICAgIGVycm9yKCJpbnZhbGlkIHRhYmxlOiBtaXhlZCBvciBpbnZhbGlkIGtleSB0eXBlcyIpCiAgICAgIGVuZAogICAgICBsb2NhbCB2YWwgPSBlbmNvZGUodiwgc3RhY2ssIHdoaXRlc3BhY2VzKQogICAgICBpZiB0eXBlKHZhbCkgPT0gJ3plbnJvb20uYmlnJyB0aGVuIHZhbCA9IHZhbDpkZWNpbWFsKCkgZW5kCiAgICAgIGxvY2FsIGNsbiA9ICI6IgogICAgICBpZiB3aGl0ZXNwYWNlcyB0aGVuCiAgICAgICAgY2xuID0gIjogIgogICAgICBlbmQKICAgICAgdGFibGUuaW5zZXJ0KHJlcywgZW5jb2RlKGssIHN0YWNrLCB3aGl0ZXNwYWNlcykgLi4gY2xuIC4uIHZhbCkKICAgIGVuZAogICAgc3RhY2tbdmFsXSA9IG5pbAogICAgcmV0dXJuICJ7IiAuLiB0YWJsZS5jb25jYXQocmVzLCBzZXBhcmF0b3IpIC4uICJ9IgogIGVuZAplbmQKCgpsb2NhbCBmdW5jdGlvbiBlbmNvZGVfc3RyaW5nKHZhbCkKICByZXR1cm4gJyInIC4uIHZhbDpnc3ViKCdbJXpcMS1cMzFcXCJdJywgZXNjYXBlX2NoYXIpIC4uICciJwplbmQKCgpsb2NhbCBmdW5jdGlvbiBlbmNvZGVfbnVtYmVyKHZhbCkKICAtLSBDaGVjayBmb3IgTmFOLCAtaW5mIGFuZCBpbmYKICAtLSBpZiB2YWwgfj0gdmFsIG9yIHZhbCA8PSAtbWF0aC5odWdlIG9yIHZhbCA+PSBtYXRoLmh1Z2UgdGhlbgogIC0tICAgZXJyb3IoInVuZXhwZWN0ZWQgbnVtYmVyIHZhbHVlICciIC4uIHRvc3RyaW5nKHZhbCkgLi4gIiciKQogIC0tIGVuZAogIC0tIHJldHVybiBzdHJpbmcuZm9ybWF0KCIlLjE0ZyIsIHZhbCkKICBsb2NhbCBzID0gdG9zdHJpbmcodmFsKQogIGxvY2FsIG4gPSB0b251bWJlcihzKQogIGlmIG5vdCBuIHRoZW4gZXJyb3IoIk5vdCBhIG51bWJlcjogIi4udmFsLCAyKSBlbmQKICByZXR1cm4gbgplbmQKCmxvY2FsIGZ1bmN0aW9uIGVuY29kZV9mdW5jdGlvbih2YWwpCiAgIC0tIHJldHVybiBoZXggZnVuY3Rpb24gYWRkcmVzcyBhcyBzdHJpbmcKICAgcmV0dXJuICciJyAuLiBzdHJ0b2sodG9zdHJpbmcodmFsKSlbMl0gLi4gJyInCmVuZAoKbG9jYWwgdHlwZV9mdW5jX21hcCA9IHsKICBbICJuaWwiICAgICBdID0gZW5jb2RlX25pbCwKICBbICJ0YWJsZSIgICBdID0gZW5jb2RlX3RhYmxlLAogIFsgInN0cmluZyIgIF0gPSBlbmNvZGVfc3RyaW5nLAogIFsgIm51bWJlciIgIF0gPSBlbmNvZGVfbnVtYmVyLAogIFsgImZ1bmN0aW9uIl0gPSBlbmNvZGVfZnVuY3Rpb24sCiAgWyAiYm9vbGVhbiIgXSA9IHRvc3RyaW5nLAp9CgoKZW5jb2RlID0gZnVuY3Rpb24odmFsLCBzdGFjaywgd2hpdGVzcGFjZXMpCiAgbG9jYWwgdCA9IHR5cGUodmFsKQogIGxvY2FsIGYgPSB0eXBlX2Z1bmNfbWFwW3RdCiAgaWYgZiB0aGVuCiAgICByZXR1cm4gZih2YWwsIHN0YWNrLCB3aGl0ZXNwYWNlcykKICBlbmQKICBlcnJvcigidW5leHBlY3RlZCB0eXBlICciIC4uIHQgLi4gIiciKQplbmQKCgpmdW5jdGlvbiBqc29uLnJhd19lbmNvZGUodmFsLCB3aGl0ZXNwYWNlcykKICAgcmV0dXJuKGVuY29kZSh2YWwsIG5pbCwgd2hpdGVzcGFjZXMpKQogICAtLSBzb3J0CiAgIC0tIGxvY2FsIG91dCA9ICJ7ICIKICAgLS0gZm9yIGssdiBpbiBzb3J0X3BhaXJzKHZhbCkgZG8KICAgLS0gCSAgb3V0ID0gb3V0IC4uICciJy4uay4uJyI6ICcKICAgLS0gCSAgb3V0ID0gb3V0IC4uIGVuY29kZSh2KS4uIiwiCiAgIC0tIGVuZAogICAtLSByZXR1cm4ob3V0OnN1YigxLC0yKSAuLiAifSIpCmVuZAoKCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KLS0gRGVjb2RlCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KCmxvY2FsIHBhcnNlCgpsb2NhbCBmdW5jdGlvbiBjcmVhdGVfc2V0KC4uLikKICBsb2NhbCByZXMgPSB7fQogIGZvciBpID0gMSwgc2VsZWN0KCIjIiwgLi4uKSBkbwogICAgcmVzWyBzZWxlY3QoaSwgLi4uKSBdID0gdHJ1ZQogIGVuZAogIHJldHVybiByZXMKZW5kCgpsb2NhbCBzcGFjZV9jaGFycyAgID0gY3JlYXRlX3NldCgiICIsICJcdCIsICJcciIsICJcbiIpCmxvY2FsIGRlbGltX2NoYXJzICAgPSBjcmVhdGVfc2V0KCIgIiwgIlx0IiwgIlxyIiwgIlxuIiwgIl0iLCAifSIsICIsIikKbG9jYWwgZXNjYXBlX2NoYXJzICA9IGNyZWF0ZV9zZXQoIlxcIiwgIi8iLCAnIicsICJiIiwgImYiLCAibiIsICJyIiwgInQiLCAidSIpCmxvY2FsIGxpdGVyYWxzICAgICAgPSBjcmVhdGVfc2V0KCJ0cnVlIiwgImZhbHNlIiwgIm51bGwiKQoKbG9jYWwgbGl0ZXJhbF9tYXAgPSB7CiAgWyAidHJ1ZSIgIF0gPSB0cnVlLAogIFsgImZhbHNlIiBdID0gZmFsc2UsCiAgWyAibnVsbCIgIF0gPSBuaWwsCn0KCgpsb2NhbCBmdW5jdGlvbiBuZXh0X2NoYXIoc3RyLCBpZHgsIHNldCwgbmVnYXRlKQogIGZvciBpID0gaWR4LCAjc3RyIGRvCiAgICBpZiBzZXRbc3RyOnN1YihpLCBpKV0gfj0gbmVnYXRlIHRoZW4KICAgICAgcmV0dXJuIGkKICAgIGVuZAogIGVuZAogIHJldHVybiAjc3RyICsgMQplbmQKCgpsb2NhbCBmdW5jdGlvbiBkZWNvZGVfZXJyb3Ioc3RyLCBpZHgsIG1zZykKICBsb2NhbCBsaW5lX2NvdW50ID0gMQogIGxvY2FsIGNvbF9jb3VudCA9IDEKICBmb3IgaSA9IDEsIGlkeCAtIDEgZG8KICAgIGNvbF9jb3VudCA9IGNvbF9jb3VudCArIDEKICAgIGlmIHN0cjpzdWIoaSwgaSkgPT0gIlxuIiB0aGVuCiAgICAgIGxpbmVfY291bnQgPSBsaW5lX2NvdW50ICsgMQogICAgICBjb2xfY291bnQgPSAxCiAgICBlbmQKICBlbmQKICBlcnJvciggc3RyaW5nLmZvcm1hdCgiVGhlIEpTT04gaW5wdXQgaXMgbm90IHZhbGlkOiAlcyBhdCBsaW5lICVkIGNvbCAlZCIsIG1zZywgbGluZV9jb3VudCwgY29sX2NvdW50KSApCmVuZAoKCmxvY2FsIGZ1bmN0aW9uIGNvZGVwb2ludF90b191dGY4KG4pCiAgLS0gaHR0cDovL3NjcmlwdHMuc2lsLm9yZy9jbXMvc2NyaXB0cy9wYWdlLnBocD9zaXRlX2lkPW5yc2kmaWQ9aXdzLWFwcGVuZGl4YQogIGxvY2FsIGYgPSBtYXRoLmZsb29yCiAgaWYgbiA8PSAweDdmIHRoZW4KICAgIHJldHVybiBzdHJpbmcuY2hhcihuKQogIGVsc2VpZiBuIDw9IDB4N2ZmIHRoZW4KICAgIHJldHVybiBzdHJpbmcuY2hhcihmKG4gLyA2NCkgKyAxOTIsIG4gJSA2NCArIDEyOCkKICBlbHNlaWYgbiA8PSAweGZmZmYgdGhlbgogICAgcmV0dXJuIHN0cmluZy5jaGFyKGYobiAvIDQwOTYpICsgMjI0LCBmKG4gJSA0MDk2IC8gNjQpICsgMTI4LCBuICUgNjQgKyAxMjgpCiAgZWxzZWlmIG4gPD0gMHgxMGZmZmYgdGhlbgogICAgcmV0dXJuIHN0cmluZy5jaGFyKGYobiAvIDI2MjE0NCkgKyAyNDAsIGYobiAlIDI2MjE0NCAvIDQwOTYpICsgMTI4LAogICAgICAgICAgICAgICAgICAgICAgIGYobiAlIDQwOTYgLyA2NCkgKyAxMjgsIG4gJSA2NCArIDEyOCkKICBlbmQKICBlcnJvciggc3RyaW5nLmZvcm1hdCgiaW52YWxpZCB1bmljb2RlIGNvZGVwb2ludCAnJXgnIiwgbikgKQplbmQKCgpsb2NhbCBmdW5jdGlvbiBwYXJzZV91bmljb2RlX2VzY2FwZShzKQogIGxvY2FsIG4xID0gdG9udW1iZXIoIHM6c3ViKDMsIDYpLCAgMTYgKQogIGxvY2FsIG4yID0gdG9udW1iZXIoIHM6c3ViKDksIDEyKSwgMTYgKQogIC0tIFN1cnJvZ2F0ZSBwYWlyPwogIGlmIG4yIHRoZW4KICAgIHJldHVybiBjb2RlcG9pbnRfdG9fdXRmOCgobjEgLSAweGQ4MDApICogMHg0MDAgKyAobjIgLSAweGRjMDApICsgMHgxMDAwMCkKICBlbHNlCiAgICByZXR1cm4gY29kZXBvaW50X3RvX3V0ZjgobjEpCiAgZW5kCmVuZAoKCmxvY2FsIGZ1bmN0aW9uIHBhcnNlX3N0cmluZyhzdHIsIGkpCiAgbG9jYWwgaGFzX3VuaWNvZGVfZXNjYXBlID0gZmFsc2UKICBsb2NhbCBoYXNfc3Vycm9nYXRlX2VzY2FwZSA9IGZhbHNlCiAgbG9jYWwgaGFzX2VzY2FwZSA9IGZhbHNlCiAgbG9jYWwgbGFzdAogIGZvciBqID0gaSArIDEsICNzdHIgZG8KICAgIGxvY2FsIHggPSBzdHI6Ynl0ZShqKQoKICAgIGlmIHggPCAzMiB0aGVuCiAgICAgIGRlY29kZV9lcnJvcihzdHIsIGosICJjb250cm9sIGNoYXJhY3RlciBpbiBzdHJpbmciKQogICAgZW5kCgogICAgaWYgbGFzdCA9PSA5MiB0aGVuIC0tICJcXCIgKGVzY2FwZSBjaGFyKQogICAgICBpZiB4ID09IDExNyB0aGVuIC0tICJ1IiAodW5pY29kZSBlc2NhcGUgc2VxdWVuY2UpCiAgICAgICAgbG9jYWwgaGV4ID0gc3RyOnN1YihqICsgMSwgaiArIDUpCiAgICAgICAgaWYgbm90IGhleDpmaW5kKCIleCV4JXgleCIpIHRoZW4KICAgICAgICAgIGRlY29kZV9lcnJvcihzdHIsIGosICJpbnZhbGlkIHVuaWNvZGUgZXNjYXBlIGluIHN0cmluZyIpCiAgICAgICAgZW5kCiAgICAgICAgaWYgaGV4OmZpbmQoIl5bZERdWzg5YUFiQl0iKSB0aGVuCiAgICAgICAgICBoYXNfc3Vycm9nYXRlX2VzY2FwZSA9IHRydWUKICAgICAgICBlbHNlCiAgICAgICAgICBoYXNfdW5pY29kZV9lc2NhcGUgPSB0cnVlCiAgICAgICAgZW5kCiAgICAgIGVsc2UKICAgICAgICBsb2NhbCBjID0gc3RyaW5nLmNoYXIoeCkKICAgICAgICBpZiBub3QgZXNjYXBlX2NoYXJzW2NdIHRoZW4KICAgICAgICAgIGRlY29kZV9lcnJvcihzdHIsIGosICJpbnZhbGlkIGVzY2FwZSBjaGFyICciIC4uIGMgLi4gIicgaW4gc3RyaW5nIikKICAgICAgICBlbmQKICAgICAgICBoYXNfZXNjYXBlID0gdHJ1ZQogICAgICBlbmQKICAgICAgbGFzdCA9IG5pbAoKICAgIGVsc2VpZiB4ID09IDM0IHRoZW4gLS0gJyInIChlbmQgb2Ygc3RyaW5nKQogICAgICBsb2NhbCBzID0gc3RyOnN1YihpICsgMSwgaiAtIDEpCiAgICAgIGlmIGhhc19zdXJyb2dhdGVfZXNjYXBlIHRoZW4KICAgICAgICBzID0gczpnc3ViKCJcXHVbZERdWzg5YUFiQl0uLlxcdS4uLi4iLCBwYXJzZV91bmljb2RlX2VzY2FwZSkKICAgICAgZW5kCiAgICAgIGlmIGhhc191bmljb2RlX2VzY2FwZSB0aGVuCiAgICAgICAgcyA9IHM6Z3N1YigiXFx1Li4uLiIsIHBhcnNlX3VuaWNvZGVfZXNjYXBlKQogICAgICBlbmQKICAgICAgaWYgaGFzX2VzY2FwZSB0aGVuCiAgICAgICAgcyA9IHM6Z3N1YigiXFwuIiwgZXNjYXBlX2NoYXJfbWFwX2ludikKICAgICAgZW5kCiAgICAgIHJldHVybiBzLCBqICsgMQoKICAgIGVsc2UKICAgICAgbGFzdCA9IHgKICAgIGVuZAogIGVuZAogIGRlY29kZV9lcnJvcihzdHIsIGksICJleHBlY3RlZCBjbG9zaW5nIHF1b3RlIGZvciBzdHJpbmciKQplbmQKCgpsb2NhbCBmdW5jdGlvbiBwYXJzZV9udW1iZXIoc3RyLCBpKQogIGxvY2FsIHggPSBuZXh0X2NoYXIoc3RyLCBpLCBkZWxpbV9jaGFycykKICBsb2NhbCBzID0gc3RyOnN1YihpLCB4IC0gMSkKICBsb2NhbCBuID0gdG9udW1iZXIocykKICBpZiBub3QgbiB0aGVuCiAgICBkZWNvZGVfZXJyb3Ioc3RyLCBpLCAiaW52YWxpZCBudW1iZXIgJyIgLi4gcyAuLiAiJyIpCiAgZW5kCiAgLS0gLS0gZmxvYXQgZGV0ZWN0aW9uCiAgLS0gaWYgczpmaW5kKCclLicpIHRoZW4gcmV0dXJuKG4pLCB4IGVuZAogIC0tIHJldHVybiBCSUcuZnJvbV9kZWNpbWFsKHMpLCB4CiAgIHJldHVybiBuLCB4CmVuZAoKbG9jYWwgZnVuY3Rpb24gcGFyc2VfbGl0ZXJhbChzdHIsIGkpCiAgbG9jYWwgeCA9IG5leHRfY2hhcihzdHIsIGksIGRlbGltX2NoYXJzKQogIGxvY2FsIHdvcmQgPSBzdHI6c3ViKGksIHggLSAxKQogIGlmIG5vdCBsaXRlcmFsc1t3b3JkXSB0aGVuCiAgICBkZWNvZGVfZXJyb3Ioc3RyLCBpLCAiaW52YWxpZCBsaXRlcmFsICciIC4uIHdvcmQgLi4gIiciKQogIGVuZAogIHJldHVybiBsaXRlcmFsX21hcFt3b3JkXSwgeAplbmQKCgpsb2NhbCBmdW5jdGlvbiBwYXJzZV9hcnJheShzdHIsIGkpCiAgbG9jYWwgcmVzID0ge30KICBsb2NhbCBuID0gMQogIGkgPSBpICsgMQogIHdoaWxlIDEgZG8KICAgIGxvY2FsIHgKICAgIGkgPSBuZXh0X2NoYXIoc3RyLCBpLCBzcGFjZV9jaGFycywgdHJ1ZSkKICAgIC0tIEVtcHR5IC8gZW5kIG9mIGFycmF5PwogICAgaWYgc3RyOnN1YihpLCBpKSA9PSAiXSIgdGhlbgogICAgICBpID0gaSArIDEKICAgICAgYnJlYWsKICAgIGVuZAogICAgLS0gUmVhZCB0b2tlbgogICAgeCwgaSA9IHBhcnNlKHN0ciwgaSkKICAgIHJlc1tuXSA9IHgKICAgIG4gPSBuICsgMQogICAgLS0gTmV4dCB0b2tlbgogICAgaSA9IG5leHRfY2hhcihzdHIsIGksIHNwYWNlX2NoYXJzLCB0cnVlKQogICAgbG9jYWwgY2hyID0gc3RyOnN1YihpLCBpKQogICAgaSA9IGkgKyAxCiAgICBpZiBjaHIgPT0gIl0iIHRoZW4gYnJlYWsgZW5kCiAgICBpZiBjaHIgfj0gIiwiIHRoZW4gZGVjb2RlX2Vycm9yKHN0ciwgaSwgImV4cGVjdGVkICddJyBvciAnLCciKSBlbmQKICBlbmQKICByZXR1cm4gcmVzLCBpCmVuZAoKCmxvY2FsIGZ1bmN0aW9uIHBhcnNlX29iamVjdChzdHIsIGkpCiAgbG9jYWwgcmVzID0ge30KICBpID0gaSArIDEKICB3aGlsZSAxIGRvCiAgICBsb2NhbCBrZXksIHZhbAogICAgaSA9IG5leHRfY2hhcihzdHIsIGksIHNwYWNlX2NoYXJzLCB0cnVlKQogICAgLS0gRW1wdHkgLyBlbmQgb2Ygb2JqZWN0PwogICAgaWYgc3RyOnN1YihpLCBpKSA9PSAifSIgdGhlbgogICAgICBpID0gaSArIDEKICAgICAgYnJlYWsKICAgIGVuZAogICAgLS0gUmVhZCBrZXkKICAgIGlmIHN0cjpzdWIoaSwgaSkgfj0gJyInIHRoZW4KICAgICAgZGVjb2RlX2Vycm9yKHN0ciwgaSwgImV4cGVjdGVkIHN0cmluZyBmb3Iga2V5IikKICAgIGVuZAogICAga2V5LCBpID0gcGFyc2Uoc3RyLCBpKQogICAgLS0gUmVhZCAnOicgZGVsaW1pdGVyCiAgICBpID0gbmV4dF9jaGFyKHN0ciwgaSwgc3BhY2VfY2hhcnMsIHRydWUpCiAgICBpZiBzdHI6c3ViKGksIGkpIH49ICI6IiB0aGVuCiAgICAgIGRlY29kZV9lcnJvcihzdHIsIGksICJleHBlY3RlZCAnOicgYWZ0ZXIga2V5IikKICAgIGVuZAogICAgaSA9IG5leHRfY2hhcihzdHIsIGkgKyAxLCBzcGFjZV9jaGFycywgdHJ1ZSkKICAgIC0tIFJlYWQgdmFsdWUKICAgIHZhbCwgaSA9IHBhcnNlKHN0ciwgaSkKICAgIC0tIFNldAogICAgcmVzW2tleV0gPSB2YWwKICAgIC0tIE5leHQgdG9rZW4KICAgIGkgPSBuZXh0X2NoYXIoc3RyLCBpLCBzcGFjZV9jaGFycywgdHJ1ZSkKICAgIGxvY2FsIGNociA9IHN0cjpzdWIoaSwgaSkKICAgIGkgPSBpICsgMQogICAgaWYgY2hyID09ICJ9IiB0aGVuIGJyZWFrIGVuZAogICAgaWYgY2hyIH49ICIsIiB0aGVuIGRlY29kZV9lcnJvcihzdHIsIGksICJleHBlY3RlZCAnfScgb3IgJywnIikgZW5kCiAgZW5kCiAgcmV0dXJuIHJlcywgaQplbmQKCgpsb2NhbCBjaGFyX2Z1bmNfbWFwID0gewogIFsgJyInIF0gPSBwYXJzZV9zdHJpbmcsCiAgWyAiMCIgXSA9IHBhcnNlX251bWJlciwKICBbICIxIiBdID0gcGFyc2VfbnVtYmVyLAogIFsgIjIiIF0gPSBwYXJzZV9udW1iZXIsCiAgWyAiMyIgXSA9IHBhcnNlX251bWJlciwKICBbICI0IiBdID0gcGFyc2VfbnVtYmVyLAogIFsgIjUiIF0gPSBwYXJzZV9udW1iZXIsCiAgWyAiNiIgXSA9IHBhcnNlX251bWJlciwKICBbICI3IiBdID0gcGFyc2VfbnVtYmVyLAogIFsgIjgiIF0gPSBwYXJzZV9udW1iZXIsCiAgWyAiOSIgXSA9IHBhcnNlX251bWJlciwKICBbICItIiBdID0gcGFyc2VfbnVtYmVyLAogIFsgInQiIF0gPSBwYXJzZV9saXRlcmFsLAogIFsgImYiIF0gPSBwYXJzZV9saXRlcmFsLAogIFsgIm4iIF0gPSBwYXJzZV9saXRlcmFsLAogIFsgIlsiIF0gPSBwYXJzZV9hcnJheSwKICBbICJ7IiBdID0gcGFyc2Vfb2JqZWN0LAp9CgoKcGFyc2UgPSBmdW5jdGlvbihzdHIsIGlkeCkKICBsb2NhbCBjaHIgPSBzdHI6c3ViKGlkeCwgaWR4KQogIGxvY2FsIGYgPSBjaGFyX2Z1bmNfbWFwW2Nocl0KICBpZiBmIHRoZW4KICAgIHJldHVybiBmKHN0ciwgaWR4KQogIGVuZAogIGRlY29kZV9lcnJvcihzdHIsIGlkeCwgInVuZXhwZWN0ZWQgY2hhcmFjdGVyICciIC4uIGNociAuLiAiJyIpCmVuZAoKCmZ1bmN0aW9uIGpzb24ucmF3X2RlY29kZShzdHIpCiAgaWYgdHlwZShzdHIpIH49ICJzdHJpbmciIHRoZW4KICAgIGVycm9yKCJleHBlY3RlZCBhcmd1bWVudCBvZiB0eXBlIHN0cmluZywgZ290ICIgLi4gdHlwZShzdHIpKQogIGVuZAogIGxvY2FsIHJlcywgaWR4ID0gcGFyc2Uoc3RyLCBuZXh0X2NoYXIoc3RyLCAxLCBzcGFjZV9jaGFycywgdHJ1ZSkpCiAgaWR4ID0gbmV4dF9jaGFyKHN0ciwgaWR4LCBzcGFjZV9jaGFycywgdHJ1ZSkKICBpZiBpZHggPD0gI3N0ciB0aGVuCiAgICBkZWNvZGVfZXJyb3Ioc3RyLCBpZHgsICJ0cmFpbGluZyBnYXJiYWdlIikKICBlbmQKICByZXR1cm4gcmVzCmVuZAoKCnJldHVybiBqc29uCi9tc2dwYWNrLmx1YQAtLVtbLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQoKCU1lc3NhZ2VQYWNrIGVuY29kZXIgLyBkZWNvZGVyIHdyaXR0ZW4gaW4gcHVyZSBMdWEgNS4zIC8gTHVhIDUuNAoJd3JpdHRlbiBieSBTZWJhc3RpYW4gU3RlaW5oYXVlciA8cy5zdGVpbmhhdWVyQHlhaG9vLmRlPgoKCVRoaXMgaXMgZnJlZSBhbmQgdW5lbmN1bWJlcmVkIHNvZnR3YXJlIHJlbGVhc2VkIGludG8gdGhlIHB1YmxpYyBkb21haW4uCgoJQW55b25lIGlzIGZyZWUgdG8gY29weSwgbW9kaWZ5LCBwdWJsaXNoLCB1c2UsIGNvbXBpbGUsIHNlbGwsIG9yCglkaXN0cmlidXRlIHRoaXMgc29mdHdhcmUsIGVpdGhlciBpbiBzb3VyY2UgY29kZSBmb3JtIG9yIGFzIGEgY29tcGlsZWQKCWJpbmFyeSwgZm9yIGFueSBwdXJwb3NlLCBjb21tZXJjaWFsIG9yIG5vbi1jb21tZXJjaWFsLCBhbmQgYnkgYW55CgltZWFucy4KCglJbiBqdXJpc2RpY3Rpb25zIHRoYXQgcmVjb2duaXplIGNvcHlyaWdodCBsYXdzLCB0aGUgYXV0aG9yIG9yIGF1dGhvcnMKCW9mIHRoaXMgc29mdHdhcmUgZGVkaWNhdGUgYW55IGFuZCBhbGwgY29weXJpZ2h0IGludGVyZXN0IGluIHRoZQoJc29mdHdhcmUgdG8gdGhlIHB1YmxpYyBkb21haW4uIFdlIG1ha2UgdGhpcyBkZWRpY2F0aW9uIGZvciB0aGUgYmVuZWZpdAoJb2YgdGhlIHB1YmxpYyBhdCBsYXJnZSBhbmQgdG8gdGhlIGRldHJpbWVudCBvZiBvdXIgaGVpcnMgYW5kCglzdWNjZXNzb3JzLiBXZSBpbnRlbmQgdGhpcyBkZWRpY2F0aW9uIHRvIGJlIGFuIG92ZXJ0IGFjdCBvZgoJcmVsaW5xdWlzaG1lbnQgaW4gcGVycGV0dWl0eSBvZiBhbGwgcHJlc2VudCBhbmQgZnV0dXJlIHJpZ2h0cyB0byB0aGlzCglzb2Z0d2FyZSB1bmRlciBjb3B5cmlnaHQgbGF3LgoKCVRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCAiQVMgSVMiLCBXSVRIT1VUIFdBUlJBTlRZIE9GIEFOWSBLSU5ELAoJRVhQUkVTUyBPUiBJTVBMSUVELCBJTkNMVURJTkcgQlVUIE5PVCBMSU1JVEVEIFRPIFRIRSBXQVJSQU5USUVTIE9GCglNRVJDSEFOVEFCSUxJVFksIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFIEFORCBOT05JTkZSSU5HRU1FTlQuCglJTiBOTyBFVkVOVCBTSEFMTCBUSEUgQVVUSE9SUyBCRSBMSUFCTEUgRk9SIEFOWSBDTEFJTSwgREFNQUdFUyBPUgoJT1RIRVIgTElBQklMSVRZLCBXSEVUSEVSIElOIEFOIEFDVElPTiBPRiBDT05UUkFDVCwgVE9SVCBPUiBPVEhFUldJU0UsCglBUklTSU5HIEZST00sIE9VVCBPRiBPUiBJTiBDT05ORUNUSU9OIFdJVEggVEhFIFNPRlRXQVJFIE9SIFRIRSBVU0UgT1IKCU9USEVSIERFQUxJTkdTIElOIFRIRSBTT0ZUV0FSRS4KCglGb3IgbW9yZSBpbmZvcm1hdGlvbiwgcGxlYXNlIHJlZmVyIHRvIDxodHRwOi8vdW5saWNlbnNlLm9yZy8+CgotLV1dLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQpsb2NhbCBwYWNrLCB1bnBhY2sgPSBzdHJpbmcucGFjaywgc3RyaW5nLnVucGFjawpsb2NhbCBtdHlwZSwgdXRmOGxlbiA9IG1hdGgudHlwZSwgdXRmOC5sZW4KbG9jYWwgdGNvbmNhdCwgdHVucGFjayA9IHRhYmxlLmNvbmNhdCwgdGFibGUudW5wYWNrCmxvY2FsIHNzdWIgPSBzdHJpbmcuc3ViCmxvY2FsIHR5cGUsIHBjYWxsLCBwYWlycywgc2VsZWN0ID0gdHlwZSwgcGNhbGwsIHBhaXJzLCBzZWxlY3QKCgotLVtbLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQoKCQlFbmNvZGVyCgotLV1dLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQpsb2NhbCBlbmNvZGVfdmFsdWUgLS0gZm9yd2FyZCBkZWNsYXJhdGlvbgoKbG9jYWwgZnVuY3Rpb24gaXNfYW5fYXJyYXkodmFsdWUpCglsb2NhbCBleHBlY3RlZCA9IDEKCWZvciBrIGluIHBhaXJzKHZhbHVlKSBkbwoJCWlmIGsgfj0gZXhwZWN0ZWQgdGhlbgoJCQlyZXR1cm4gZmFsc2UKCQllbmQKCQlleHBlY3RlZCA9IGV4cGVjdGVkICsgMQoJZW5kCglyZXR1cm4gdHJ1ZQplbmQKCmxvY2FsIGVuY29kZXJfZnVuY3Rpb25zID0gewoJWyduaWwnXSA9IGZ1bmN0aW9uKCkKCQlyZXR1cm4gcGFjaygnQicsIDB4YzApCgllbmQsCglbJ2Jvb2xlYW4nXSA9IGZ1bmN0aW9uKHZhbHVlKQoJCWlmIHZhbHVlIHRoZW4KCQkJcmV0dXJuIHBhY2soJ0InLCAweGMzKQoJCWVsc2UKCQkJcmV0dXJuIHBhY2soJ0InLCAweGMyKQoJCWVuZAoJZW5kLAoJWydudW1iZXInXSA9IGZ1bmN0aW9uKHZhbHVlKQoJCWlmIG10eXBlKHZhbHVlKSA9PSAnaW50ZWdlcicgdGhlbgoJCQlpZiB2YWx1ZSA+PSAwIHRoZW4KCQkJCWlmIHZhbHVlIDwgMTI4IHRoZW4KCQkJCQlyZXR1cm4gcGFjaygnQicsIHZhbHVlKQoJCQkJZWxzZWlmIHZhbHVlIDw9IDB4ZmYgdGhlbgoJCQkJCXJldHVybiBwYWNrKCdCQicsIDB4Y2MsIHZhbHVlKQoJCQkJZWxzZWlmIHZhbHVlIDw9IDB4ZmZmZiAgdGhlbgoJCQkJCXJldHVybiBwYWNrKCc+QkkyJywgMHhjZCwgdmFsdWUpCgkJCQllbHNlaWYgdmFsdWUgPD0gMHhmZmZmZmZmZiB0aGVuCgkJCQkJcmV0dXJuIHBhY2soJz5CSTQnLCAweGNlLCB2YWx1ZSkKCQkJCWVsc2UKCQkJCQlyZXR1cm4gcGFjaygnPkJJOCcsIDB4Y2YsIHZhbHVlKQoJCQkJZW5kCgkJCWVsc2UKCQkJCWlmIHZhbHVlID49IC0zMiB0aGVuCgkJCQkJcmV0dXJuIHBhY2soJ0InLCAweGUwICsgKHZhbHVlICsgMzIpKQoJCQkJZWxzZWlmIHZhbHVlID49IC0xMjggdGhlbgoJCQkJCXJldHVybiBwYWNrKCdCYicsIDB4ZDAsIHZhbHVlKQoJCQkJZWxzZWlmIHZhbHVlID49IC0zMjc2OCB0aGVuCgkJCQkJcmV0dXJuIHBhY2soJz5CaTInLCAweGQxLCB2YWx1ZSkKCQkJCWVsc2VpZiB2YWx1ZSA+PSAtMjE0NzQ4MzY0OCB0aGVuCgkJCQkJcmV0dXJuIHBhY2soJz5CaTQnLCAweGQyLCB2YWx1ZSkKCQkJCWVsc2UKCQkJCQlyZXR1cm4gcGFjaygnPkJpOCcsIDB4ZDMsIHZhbHVlKQoJCQkJZW5kCgkJCWVuZAoJCWVsc2UKCQkJbG9jYWwgdGVzdCA9IHVucGFjaygnZicsIHBhY2soJ2YnLCB2YWx1ZSkpCgkJCWlmIHRlc3QgPT0gdmFsdWUgdGhlbiAtLSBjaGVjayBpZiB3ZSBjYW4gdXNlIGZsb2F0CgkJCQlyZXR1cm4gcGFjaygnPkJmJywgMHhjYSwgdmFsdWUpCgkJCWVsc2UKCQkJCXJldHVybiBwYWNrKCc+QmQnLCAweGNiLCB2YWx1ZSkKCQkJZW5kCgkJZW5kCgllbmQsCglbJ3N0cmluZyddID0gZnVuY3Rpb24odmFsdWUpCgkJbG9jYWwgbGVuID0gI3ZhbHVlCgkJaWYgdXRmOGxlbih2YWx1ZSkgdGhlbiAtLSBjaGVjayBpZiBpdCBpcyBhIHJlYWwgdXRmOCBzdHJpbmcgb3IganVzdCBieXRlIGp1bmsKCQkJaWYgbGVuIDwgMzIgdGhlbgoJCQkJcmV0dXJuIHBhY2soJ0InLCAweGEwICsgbGVuKSAuLiB2YWx1ZQoJCQllbHNlaWYgbGVuIDwgMjU2IHRoZW4KCQkJCXJldHVybiBwYWNrKCc+QnMxJywgMHhkOSwgdmFsdWUpCgkJCWVsc2VpZiBsZW4gPCA2NTUzNiB0aGVuCgkJCQlyZXR1cm4gcGFjaygnPkJzMicsIDB4ZGEsIHZhbHVlKQoJCQllbHNlCgkJCQlyZXR1cm4gcGFjaygnPkJzNCcsIDB4ZGIsIHZhbHVlKQoJCQllbmQKCQllbHNlIC0tIGVuY29kZSBpdCBhcyBieXRlLWp1bmsgOikKCQkJaWYgbGVuIDwgMjU2IHRoZW4KCQkJCXJldHVybiBwYWNrKCc+QnMxJywgMHhjNCwgdmFsdWUpCgkJCWVsc2VpZiBsZW4gPCA2NTUzNiB0aGVuCgkJCQlyZXR1cm4gcGFjaygnPkJzMicsIDB4YzUsIHZhbHVlKQoJCQllbHNlCgkJCQlyZXR1cm4gcGFjaygnPkJzNCcsIDB4YzYsIHZhbHVlKQoJCQllbmQKCQllbmQKCWVuZCwKCVsndGFibGUnXSA9IGZ1bmN0aW9uKHZhbHVlKQoJCWlmIGlzX2FuX2FycmF5KHZhbHVlKSB0aGVuIC0tIGl0IHNlZW1zIHRvIGJlIGEgcHJvcGVyIEx1YSBhcnJheQoJCQlsb2NhbCBlbGVtZW50cyA9IHt9CgkJCWZvciBpLCB2IGluIHNvcnRfcGFpcnModmFsdWUpIGRvCgkJCQllbGVtZW50c1tpXSA9IGVuY29kZV92YWx1ZSh2KQoJCQllbmQKCgkJCWxvY2FsIGxlbmd0aCA9ICNlbGVtZW50cwoJCQlpZiBsZW5ndGggPCAxNiB0aGVuCgkJCQlyZXR1cm4gcGFjaygnPkInLCAweDkwICsgbGVuZ3RoKSAuLiB0Y29uY2F0KGVsZW1lbnRzKQoJCQllbHNlaWYgbGVuZ3RoIDwgNjU1MzYgdGhlbgoJCQkJcmV0dXJuIHBhY2soJz5CSTInLCAweGRjLCBsZW5ndGgpIC4uIHRjb25jYXQoZWxlbWVudHMpCgkJCWVsc2UKCQkJCXJldHVybiBwYWNrKCc+Qkk0JywgMHhkZCwgbGVuZ3RoKSAuLiB0Y29uY2F0KGVsZW1lbnRzKQoJCQllbmQKCQllbHNlIC0tIGVuY29kZSBhcyBhIG1hcAoJCQlsb2NhbCBlbGVtZW50cyA9IHt9CgkJCWZvciBrLCB2IGluIHNvcnRfcGFpcnModmFsdWUpIGRvCgkJCQllbGVtZW50c1sjZWxlbWVudHMgKyAxXSA9IGVuY29kZV92YWx1ZShrKQoJCQkJZWxlbWVudHNbI2VsZW1lbnRzICsgMV0gPSBlbmNvZGVfdmFsdWUodikKCQkJZW5kCgoJCQlsb2NhbCBsZW5ndGggPSAjZWxlbWVudHMgLy8gMgoJCQlpZiBsZW5ndGggPCAxNiB0aGVuCgkJCQlyZXR1cm4gcGFjaygnPkInLCAweDgwICsgbGVuZ3RoKSAuLiB0Y29uY2F0KGVsZW1lbnRzKQoJCQllbHNlaWYgbGVuZ3RoIDwgNjU1MzYgdGhlbgoJCQkJcmV0dXJuIHBhY2soJz5CSTInLCAweGRlLCBsZW5ndGgpIC4uIHRjb25jYXQoZWxlbWVudHMpCgkJCWVsc2UKCQkJCXJldHVybiBwYWNrKCc+Qkk0JywgMHhkZiwgbGVuZ3RoKSAuLiB0Y29uY2F0KGVsZW1lbnRzKQoJCQllbmQKCQllbmQKCWVuZCwKfQoKZW5jb2RlX3ZhbHVlID0gZnVuY3Rpb24odmFsdWUpCglyZXR1cm4gZW5jb2Rlcl9mdW5jdGlvbnNbdHlwZSh2YWx1ZSldKHZhbHVlKQplbmQKCmxvY2FsIGZ1bmN0aW9uIGVuY29kZSguLi4pCglsb2NhbCBkYXRhID0ge30KCWZvciBpID0gMSwgc2VsZWN0KCcjJywgLi4uKSBkbwoJCWRhdGFbI2RhdGEgKyAxXSA9IGVuY29kZV92YWx1ZShzZWxlY3QoaSwgLi4uKSkKCWVuZAoJcmV0dXJuIHRjb25jYXQoZGF0YSkKZW5kCgoKLS1bWy0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KCgkJRGVjb2RlcgoKLS1dXS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KbG9jYWwgZGVjb2RlX3ZhbHVlIC0tIGZvcndhcmQgZGVjbGFyYXRpb24KCmxvY2FsIGZ1bmN0aW9uIGRlY29kZV9hcnJheShkYXRhLCBwb3NpdGlvbiwgbGVuZ3RoKQoJbG9jYWwgZWxlbWVudHMsIHZhbHVlID0ge30KCWZvciBpID0gMSwgbGVuZ3RoIGRvCgkJdmFsdWUsIHBvc2l0aW9uID0gZGVjb2RlX3ZhbHVlKGRhdGEsIHBvc2l0aW9uKQoJCWVsZW1lbnRzW2ldID0gdmFsdWUKCWVuZAoJcmV0dXJuIGVsZW1lbnRzLCBwb3NpdGlvbgplbmQKCmxvY2FsIGZ1bmN0aW9uIGRlY29kZV9tYXAoZGF0YSwgcG9zaXRpb24sIGxlbmd0aCkKCWxvY2FsIGVsZW1lbnRzLCBrZXksIHZhbHVlID0ge30KCWZvciBpID0gMSwgbGVuZ3RoIGRvCgkJa2V5LCBwb3NpdGlvbiA9IGRlY29kZV92YWx1ZShkYXRhLCBwb3NpdGlvbikKCQl2YWx1ZSwgcG9zaXRpb24gPSBkZWNvZGVfdmFsdWUoZGF0YSwgcG9zaXRpb24pCgkJZWxlbWVudHNba2V5XSA9IHZhbHVlCgllbmQKCXJldHVybiBlbGVtZW50cywgcG9zaXRpb24KZW5kCgpsb2NhbCBkZWNvZGVyX2Z1bmN0aW9ucyA9IHsKCVsweGMwXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiBuaWwsIHBvc2l0aW9uCgllbmQsCglbMHhjMl0gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gZmFsc2UsIHBvc2l0aW9uCgllbmQsCglbMHhjM10gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gdHJ1ZSwgcG9zaXRpb24KCWVuZCwKCVsweGM0XSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiB1bnBhY2soJz5zMScsIGRhdGEsIHBvc2l0aW9uKQoJZW5kLAoJWzB4YzVdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIHVucGFjaygnPnMyJywgZGF0YSwgcG9zaXRpb24pCgllbmQsCglbMHhjNl0gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gdW5wYWNrKCc+czQnLCBkYXRhLCBwb3NpdGlvbikKCWVuZCwKCS0tIDB4YzcgLSAweGM5IGZvciB1c2VyZGF0YQoJWzB4Y2FdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIHVucGFjaygnPmYnLCBkYXRhLCBwb3NpdGlvbikKCWVuZCwKCVsweGNiXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiB1bnBhY2soJz5kJywgZGF0YSwgcG9zaXRpb24pCgllbmQsCglbMHhjY10gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gdW5wYWNrKCc+QicsIGRhdGEsIHBvc2l0aW9uKQoJZW5kLAoJWzB4Y2RdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIHVucGFjaygnPkkyJywgZGF0YSwgcG9zaXRpb24pCgllbmQsCglbMHhjZV0gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gdW5wYWNrKCc+STQnLCBkYXRhLCBwb3NpdGlvbikKCWVuZCwKCVsweGNmXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiB1bnBhY2soJz5JOCcsIGRhdGEsIHBvc2l0aW9uKQoJZW5kLAoJWzB4ZDBdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIHVucGFjaygnPmInLCBkYXRhLCBwb3NpdGlvbikKCWVuZCwKCVsweGQxXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiB1bnBhY2soJz5pMicsIGRhdGEsIHBvc2l0aW9uKQoJZW5kLAoJWzB4ZDJdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIHVucGFjaygnPmk0JywgZGF0YSwgcG9zaXRpb24pCgllbmQsCglbMHhkM10gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gdW5wYWNrKCc+aTgnLCBkYXRhLCBwb3NpdGlvbikKCWVuZCwKCS0tIDB4ZDQgLSAweGQ4IGZvciB1c2VyZGF0YQoJWzB4ZDldID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIHVucGFjaygnPnMxJywgZGF0YSwgcG9zaXRpb24pCgllbmQsCglbMHhkYV0gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlyZXR1cm4gdW5wYWNrKCc+czInLCBkYXRhLCBwb3NpdGlvbikKCWVuZCwKCVsweGRiXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiB1bnBhY2soJz5zNCcsIGRhdGEsIHBvc2l0aW9uKQoJZW5kLAoJWzB4ZGNdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJbG9jYWwgbGVuZ3RoCgkJbGVuZ3RoLCBwb3NpdGlvbiA9IHVucGFjaygnPkkyJywgZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIGRlY29kZV9hcnJheShkYXRhLCBwb3NpdGlvbiwgbGVuZ3RoKQoJZW5kLAoJWzB4ZGRdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJbG9jYWwgbGVuZ3RoCgkJbGVuZ3RoLCBwb3NpdGlvbiA9IHVucGFjaygnPkk0JywgZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIGRlY29kZV9hcnJheShkYXRhLCBwb3NpdGlvbiwgbGVuZ3RoKQoJZW5kLAoJWzB4ZGVdID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJbG9jYWwgbGVuZ3RoCgkJbGVuZ3RoLCBwb3NpdGlvbiA9IHVucGFjaygnPkkyJywgZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIGRlY29kZV9tYXAoZGF0YSwgcG9zaXRpb24sIGxlbmd0aCkKCWVuZCwKCVsweGRmXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCWxvY2FsIGxlbmd0aAoJCWxlbmd0aCwgcG9zaXRpb24gPSB1bnBhY2soJz5JNCcsIGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiBkZWNvZGVfbWFwKGRhdGEsIHBvc2l0aW9uLCBsZW5ndGgpCgllbmQsCn0KCi0tIGFkZCBmaXgtYXJyYXksIGZpeC1tYXAsIGZpeC1zdHJpbmcsIGZpeC1pbnQgc3R1ZmYKZm9yIGkgPSAweDAwLCAweDdmIGRvCglkZWNvZGVyX2Z1bmN0aW9uc1tpXSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCXJldHVybiBpLCBwb3NpdGlvbgoJZW5kCmVuZApmb3IgaSA9IDB4ODAsIDB4OGYgZG8KCWRlY29kZXJfZnVuY3Rpb25zW2ldID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIGRlY29kZV9tYXAoZGF0YSwgcG9zaXRpb24sIGkgLSAweDgwKQoJZW5kCmVuZApmb3IgaSA9IDB4OTAsIDB4OWYgZG8KCWRlY29kZXJfZnVuY3Rpb25zW2ldID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIGRlY29kZV9hcnJheShkYXRhLCBwb3NpdGlvbiwgaSAtIDB4OTApCgllbmQKZW5kCmZvciBpID0gMHhhMCwgMHhiZiBkbwoJZGVjb2Rlcl9mdW5jdGlvbnNbaV0gPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCQlsb2NhbCBsZW5ndGggPSBpIC0gMHhhMAoJCXJldHVybiBzc3ViKGRhdGEsIHBvc2l0aW9uLCBwb3NpdGlvbiArIGxlbmd0aCAtIDEpLCBwb3NpdGlvbiArIGxlbmd0aAoJZW5kCmVuZApmb3IgaSA9IDB4ZTAsIDB4ZmYgZG8KCWRlY29kZXJfZnVuY3Rpb25zW2ldID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJcmV0dXJuIC0zMiArIChpIC0gMHhlMCksIHBvc2l0aW9uCgllbmQKZW5kCgpkZWNvZGVfdmFsdWUgPSBmdW5jdGlvbihkYXRhLCBwb3NpdGlvbikKCWxvY2FsIGJ5dGUsIHZhbHVlCglieXRlLCBwb3NpdGlvbiA9IHVucGFjaygnQicsIGRhdGEsIHBvc2l0aW9uKQoJdmFsdWUsIHBvc2l0aW9uID0gZGVjb2Rlcl9mdW5jdGlvbnNbYnl0ZV0oZGF0YSwgcG9zaXRpb24pCglyZXR1cm4gdmFsdWUsIHBvc2l0aW9uCmVuZAoKCi0tW1stLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCgoJCUludGVyZmFjZQoKLS1dXS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KcmV0dXJuIHsKCV9BVVRIT1IgPSAnU2ViYXN0aWFuIFN0ZWluaGF1ZXIgPHMuc3RlaW5oYXVlckB5YWhvby5kZT4nLAoJX1ZFUlNJT04gPSAnMC42LjEnLAoKCWVuY29kZXJfZnVuY3Rpb25zID0gZW5jb2Rlcl9mdW5jdGlvbnMsCglkZWNvZGVyX2Z1bmN0aW9ucyA9IGRlY29kZXJfZnVuY3Rpb25zLAoKCS0tIHByaW1hcnkgZW5jb2RlIGZ1bmN0aW9uCgllbmNvZGUgPSBmdW5jdGlvbiguLi4pCgkJbG9jYWwgZGF0YSwgb2sgPSB7fQoJCWZvciBpID0gMSwgc2VsZWN0KCcjJywgLi4uKSBkbwoJCQlvaywgZGF0YVtpXSA9IHBjYWxsKGVuY29kZV92YWx1ZSwgc2VsZWN0KGksIC4uLikpCgkJCWlmIG5vdCBvayB0aGVuCgkJCQlyZXR1cm4gbmlsLCAnY2Fubm90IGVuY29kZSBNZXNzYWdlUGFjaycKCQkJZW5kCgkJZW5kCgkJcmV0dXJuIHRjb25jYXQoZGF0YSkKCWVuZCwKCgktLSBlbmNvZGUganVzdCBvbmUgdmFsdWUKCWVuY29kZV9vbmUgPSBmdW5jdGlvbih2YWx1ZSkKCQlsb2NhbCBvaywgZGF0YSA9IHBjYWxsKGVuY29kZV92YWx1ZSwgdmFsdWUpCgkJaWYgb2sgdGhlbgoJCQlyZXR1cm4gZGF0YQoJCWVsc2UKCQkJcmV0dXJuIG5pbCwgJ2Nhbm5vdCBlbmNvZGUgTWVzc2FnZVBhY2snCgkJZW5kCgllbmQsCgoJLS0gcHJpbWFyeSBkZWNvZGUgZnVuY3Rpb24KCWRlY29kZSA9IGZ1bmN0aW9uKGRhdGEsIHBvc2l0aW9uKQoJCWxvY2FsIHZhbHVlcywgdmFsdWUsIG9rID0ge30KCQlwb3NpdGlvbiA9IHBvc2l0aW9uIG9yIDEKCQl3aGlsZSBwb3NpdGlvbiA8PSAjZGF0YSBkbwoJCQlvaywgdmFsdWUsIHBvc2l0aW9uID0gcGNhbGwoZGVjb2RlX3ZhbHVlLCBkYXRhLCBwb3NpdGlvbikKCQkJaWYgb2sgdGhlbgoJCQkJdmFsdWVzWyN2YWx1ZXMgKyAxXSA9IHZhbHVlCgkJCWVsc2UKCQkJCXJldHVybiBuaWwsICdjYW5ub3QgZGVjb2RlIE1lc3NhZ2VQYWNrJwoJCQllbmQKCQllbmQKCQlyZXR1cm4gdHVucGFjayh2YWx1ZXMpCgllbmQsCgoJLS0gZGVjb2RlIGp1c3Qgb25lIHZhbHVlCglkZWNvZGVfb25lID0gZnVuY3Rpb24oZGF0YSwgcG9zaXRpb24pCgkJbG9jYWwgdmFsdWUsIG9rCgkJb2ssIHZhbHVlLCBwb3NpdGlvbiA9IHBjYWxsKGRlY29kZV92YWx1ZSwgZGF0YSwgcG9zaXRpb24gb3IgMSkKCQlpZiBvayB0aGVuCgkJCXJldHVybiB2YWx1ZSwgcG9zaXRpb24KCQllbHNlCgkJCXJldHVybiBuaWwsICdjYW5ub3QgZGVjb2RlIE1lc3NhZ2VQYWNrJwoJCWVuZAoJZW5kLAp9CgotLVtbLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLV1dLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQovcXNvcnRfb3AubHVhAC0tIENvcHlyaWdodCAoQykgMjAxNyAtIERhcmtSb2t1MTIKLS0gT3B0aW1pemVkIHZlcnNpb24uCgotLSBTdGFjayBzbG90ICMxID0gdC4KbG9jYWwgZnVuY3Rpb24gc2V0MiggdCAsIGkgLCBqICwgaXZhbCAsIGp2YWwgKQogICB0WyBpIF0gPSBpdmFsIDsgLS0gbHVhX3Jhd3NldGkoTCwgMSwgaSk7CiAgIHRbIGogXSA9IGp2YWwgOyAtLSBsdWFfcmF3c2V0aShMLCAxLCBqKTsKZW5kCgpsb2NhbCBmdW5jdGlvbiBkZWZhdWx0X2NvbXAoIGEgLCBiICkKICAgIGxvY2FsIGwsIHIKICAgIGlmIGlzemVuKHR5cGUoYSkpIHRoZW4gbCA9IGE6b2N0ZXQoKSBlbHNlIGwgPSBhIGVuZAogICAgaWYgaXN6ZW4odHlwZShiKSkgdGhlbiByID0gYjpvY3RldCgpIGVsc2UgciA9IGIgZW5kCiAgICByZXR1cm4gbCA8IHIKZW5kCgpsb2NhbCBhdXhzb3J0IDsKCmZ1bmN0aW9uIGF1eHNvcnQoIHQgLCBsICwgdSAsIHNvcnRfY29tcCApCgogICB3aGlsZSBsIDwgdSBkbyAKCiAgICAgIC0tIHNvcnQgZWxlbWVudHMgYVtsXSwgYVsobCt1KS8yXSBhbmQgYVt1XQoKICAgICAgZG8KICAgICAgICAgbG9jYWwgYSA9IHRbIGwgXSAtLSBsdWFfcmF3Z2V0aShMLCAxLCBsKTsKICAgICAgICAgbG9jYWwgYiA9IHRbIHUgXSAtLSBsdWFfcmF3Z2V0aShMLCAxLCB1KTsKCiAgICAgICAgIGlmIHNvcnRfY29tcCggYiAsIGEgKSB0aGVuCiAgICAgICAgICAgIHNldDIoIHQgLCBsICwgdSAsIGIgLCBhICkgLS0gLyogc3dhcCBhW2xdIC0gYVt1XSAqLwogICAgICAgICBlbmQKICAgICAgZW5kCgogICAgICBpZiB1IC0gbCA9PSAxIHRoZW4gYnJlYWsgZW5kIC0tIG9ubHkgMiBlbGVtZW50cwoKICAgICAgbG9jYWwgaSA9IG1hdGguZmxvb3IoICggbCArIHUgKSAvIDIgKSA7IC0tIC0tIGZvciB0YWlsIHJlY3Vyc2lvbiAoaSkuCgogICAgICBkbwogICAgICAgICBsb2NhbCBhID0gdFsgaSBdIC0tIGx1YV9yYXdnZXRpKEwsIDEsIGkpOwogICAgICAgICBsb2NhbCBiID0gdFsgbCBdIC0tIGx1YV9yYXdnZXRpKEwsIDEsIGwpOwoKICAgICAgICAgaWYgc29ydF9jb21wKCBhICwgYiApIHRoZW4gLS0gYVtpXSA8IGFbbF0gPwogICAgICAgICAgICBzZXQyKCB0ICwgaSAsIGwgLCBiICwgYSApCiAgICAgICAgIGVsc2UKICAgICAgICAgICAgYiA9IG5pbCAtLSByZW1vdmUgYVtsXQogICAgICAgICAgICBiID0gdFsgdSBdCiAgICAgICAgICAgIGlmIHNvcnRfY29tcCggYiAsIGEgKSB0aGVuIC0tIGFbdV08YVtpXSA/CiAgICAgICAgICAgICAgIHNldDIoIHQgLCBpICwgdSAsIGIgLCBhICkKICAgICAgICAgICAgZW5kCiAgICAgICAgIGVuZAogICAgICBlbmQKCiAgICAgIGlmIHUgLSBsID09IDIgdGhlbiBicmVhayBlbmQgOyAtLSBvbmx5IDMgZWxlbWVudHMKCiAgICAgIGxvY2FsIFAgPSB0WyBpIF0gLS0gUGl2b3QuCiAgICAgIGxvY2FsIFAyID0gUCAtLSBsdWFfcHVzaHZhbHVlKEwsIC0xKTsKICAgICAgbG9jYWwgYiA9IHRbIHUgLSAxIF0KCiAgICAgIHNldDIoIHQgLCBpICwgdSAtIDEgLCBiICwgUDIgKQogICAgICAtLSBhW2xdIDw9IFAgPT0gYVt1LTFdIDw9IGFbdV0sIG9ubHkgbmVlZCB0byBzb3J0IGZyb20gbCsxIHRvIHUtMiAqLwoKICAgICAgaSA9IGwgOwoKICAgICAgbG9jYWwgaiA9IHUgLSAxIDsgLS0gZm9yIHRhaWwgcmVjdXJzaW9uIChqKS4KCiAgICAgIHdoaWxlIHRydWUgZG8gLS0gZm9yKCA7IDsgKQogICAgICAgICAtLSBpbnZhcmlhbnQ6IGFbbC4uaV0gPD0gUCA8PSBhW2ouLnVdCiAgICAgICAgIC0tIHJlcGVhdCArK2kgdW50aWwgYVtpXSA+PSBQCgogICAgICAgICBpID0gaSArIDEgOyAtLSArK2kKICAgICAgICAgbG9jYWwgYSA9IHRbIGkgXSAtLSBsdWFfcmF3Z2V0aShMLCAxLCBpKQoKICAgICAgICAgd2hpbGUgc29ydF9jb21wKCBhICwgUCApIGRvCiAgICAgICAgICAgIGkgPSBpICsgMSA7IC0tICsraQogICAgICAgICAgICBhID0gdFsgaSBdIC0tIGx1YV9yYXdnZXRpKEwsIDEsIGkpCiAgICAgICAgIGVuZAoKICAgICAgICAgLS0gcmVwZWF0IC0taiB1bnRpbCBhW2pdIDw9IFAKCiAgICAgICAgIGogPSBqIC0gMSA7IC0tIC0tagogICAgICAgICBsb2NhbCBiID0gdFsgaiBdCgogICAgICAgICB3aGlsZSBzb3J0X2NvbXAoIFAgLCBiICkgZG8KICAgICAgICAgICAgaiA9IGogLSAxIDsgLS0gLS1qCiAgICAgICAgICAgIGIgPSB0WyBqIF0gLS0gbHVhX3Jhd2dldGkoTCwgMSwgaikKICAgICAgICAgZW5kCgogICAgICAgICBpZiBqIDwgaSB0aGVuCiAgICAgICAgICAgIGJyZWFrCiAgICAgICAgIGVuZAoKICAgICAgICAgc2V0MiggdCAsIGkgLCBqICwgYiAsIGEgKQogICAgICBlbmQgLS0gRW5kIGZvci4KCiAgICAgIHRbIHUgLSAxIF0gLCB0WyBpIF0gPSB0WyBpIF0gLCB0WyB1IC0gMSBdIDsKCiAgICAgIC0tIGFbbC4uaS0xXSA8PSBhW2ldID09IFAgPD0gYVtpKzEuLnVdICovCiAgICAgIC0tIGFkanVzdCBzbyB0aGF0IHNtYWxsZXIgaGFsZiBpcyBpbiBbai4uaV0gYW5kIGxhcmdlciBvbmUgaW4gW2wuLnVdICovCgogICAgICBpZiAoIGkgLSBsICkgPCAoIHUgLSBpICkgdGhlbgogICAgICAgICBqID0gbCA7CiAgICAgICAgIGkgPSBpIC0gMSA7CiAgICAgICAgIGwgPSBpICsgMiA7CiAgICAgIGVsc2UKICAgICAgICAgaiA9IGkgKyAxIDsKICAgICAgICAgaSA9IHUgOwogICAgICAgICB1ID0gaiAtIDIgOwogICAgICBlbmQKCiAgICAgIGF1eHNvcnQoIHQgLCBqICwgaSAsIHNvcnRfY29tcCApIDsgIC0tIGNhbGwgcmVjdXJzaXZlbHkgdGhlIHNtYWxsZXIgb25lICovCgogICBlbmQKICAgLS0gZW5kIG9mIHdoaWxlCiAgIC0tIHJlcGVhdCB0aGUgcm91dGluZSBmb3IgdGhlIGxhcmdlciBvbmUKCmVuZAoKLS0gc29ydCBmdW5jdGlvbi4KcmV0dXJuIGZ1bmN0aW9uKCB0ICwgY29tcCApCgogICBpZiB0eXBlKCB0ICkgfj0gInRhYmxlIiB0aGVuCiAgICAgICBlcnJvcigiUVNvcnQgZnVuY3Rpb24gYXJndW1lbnQgbm90IGEgdGFibGU6ICIuLnR5cGUoIHQpLCAyKQogICBlbmQKCiAgIGlmIGNvbXAgdGhlbgogICAgICBpZiB0eXBlKCBjb21wICkgfj0gImZ1bmN0aW9uIiB0aGVuCiAgICAgICAgICBlcnJvcigiUVNvcnQgZnVuY3Rpb24gYXJndW1lbnQgbm90IGEgZnVuY3Rpb246ICIuLnR5cGUoY29tcCksIDIpCiAgICAgIGVuZAogICBlbmQKCiAgIGF1eHNvcnQoIHQgLCAxICwgI3QgLCBjb21wIG9yIGRlZmF1bHRfY29tcCApCgplbmQKL3NlbXZlci5sdWEAbG9jYWwgc2VtdmVyID0gewogICBfVkVSU0lPTiAgICAgPSAnMS4yLjInLAogICBfREVTQ1JJUFRJT04gPSAnc2VtdmVyIGZvciBMdWEnLAogICBfVVJMICAgICAgICAgPSAnaHR0cHM6Ly9naXRodWIuY29tL2tpa2l0by9zZW12ZXIubHVhJwogIC0tICBfTElDRU5TRSAgICAgPSBbWwogIC0tICAgTUlUIExJQ0VOU0UKCiAgLS0gICBDb3B5cmlnaHQgKGMpIDIwMTUgRW5yaXF1ZSBHYXJjw61hIENvdGEKICAtLSAgIENvcHlyaWdodCAoYykgMjAxOS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KCiAgLS0gICBQZXJtaXNzaW9uIGlzIGhlcmVieSBncmFudGVkLCBmcmVlIG9mIGNoYXJnZSwgdG8gYW55IHBlcnNvbiBvYnRhaW5pbmcgYQogIC0tICAgY29weSBvZiB0b3RoZXIgc29mdHdhcmUgYW5kIGFzc29jaWF0ZWQgZG9jdW1lbnRhdGlvbiBmaWxlcyAodGhlCiAgLS0gICAiU29mdHdhcmUiKSwgdG8gZGVhbCBpbiB0aGUgU29mdHdhcmUgd2l0aG91dCByZXN0cmljdGlvbiwgaW5jbHVkaW5nCiAgLS0gICB3aXRob3V0IGxpbWl0YXRpb24gdGhlIHJpZ2h0cyB0byB1c2UsIGNvcHksIG1vZGlmeSwgbWVyZ2UsIHB1Ymxpc2gsCiAgLS0gICBkaXN0cmlidXRlLCBzdWJsaWNlbnNlLCBhbmQvb3Igc2VsbCBjb3BpZXMgb2YgdGhlIFNvZnR3YXJlLCBhbmQgdG8KICAtLSAgIHBlcm1pdCBwZXJzb25zIHRvIHdob20gdGhlIFNvZnR3YXJlIGlzIGZ1cm5pc2hlZCB0byBkbyBzbywgc3ViamVjdCB0bwogIC0tICAgdGhlIGZvbGxvd2luZyBjb25kaXRpb25zOgoKICAtLSAgIFRoZSBhYm92ZSBjb3B5cmlnaHQgbm90aWNlIGFuZCB0b3RoZXIgcGVybWlzc2lvbiBub3RpY2Ugc2hhbGwgYmUgaW5jbHVkZWQKICAtLSAgIGluIGFsbCBjb3BpZXMgb3Igc3Vic3RhbnRpYWwgcG9ydGlvbnMgb2YgdGhlIFNvZnR3YXJlLgoKICAtLSAgIFRIRSBTT0ZUV0FSRSBJUyBQUk9WSURFRCAiQVMgSVMiLCBXSVRIT1VUIFdBUlJBTlRZIE9GIEFOWSBLSU5ELCBFWFBSRVNTCiAgLS0gICBPUiBJTVBMSUVELCBJTkNMVURJTkcgQlVUIE5PVCBMSU1JVEVEIFRPIFRIRSBXQVJSQU5USUVTIE9GCiAgLS0gICBNRVJDSEFOVEFCSUxJVFksIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFIEFORCBOT05JTkZSSU5HRU1FTlQuCiAgLS0gICBJTiBOTyBFVkVOVCBTSEFMTCBUSEUgQVVUSE9SUyBPUiBDT1BZUklHSFQgSE9MREVSUyBCRSBMSUFCTEUgRk9SIEFOWQogIC0tICAgQ0xBSU0sIERBTUFHRVMgT1IgT1RIRVIgTElBQklMSVRZLCBXSEVUSEVSIElOIEFOIEFDVElPTiBPRiBDT05UUkFDVCwKICAtLSAgIFRPUlQgT1IgT1RIRVJXSVNFLCBBUklTSU5HIEZST00sIE9VVCBPRiBPUiBJTiBDT05ORUNUSU9OIFdJVEggVEhFCiAgLS0gICBTT0ZUV0FSRSBPUiBUSEUgVVNFIE9SIE9USEVSIERFQUxJTkdTIElOIFRIRSBTT0ZUV0FSRS4KICAtLSBdXQp9Cgpsb2NhbCBmdW5jdGlvbiBjaGVja1Bvc2l0aXZlSW50ZWdlcihudW1iZXIsIG5hbWUpCiAgIGFzc2VydChudW1iZXIgPj0gMCwgbmFtZSAuLiAnIG11c3QgYmUgYSB2YWxpZCBwb3NpdGl2ZSBudW1iZXInKQogICBhc3NlcnQobWF0aC5mbG9vcihudW1iZXIpID09IG51bWJlciwgbmFtZSAuLiAnIG11c3QgYmUgYW4gaW50ZWdlcicpCmVuZAoKbG9jYWwgZnVuY3Rpb24gcHJlc2VudCh2YWx1ZSkKICAgcmV0dXJuIHZhbHVlIGFuZCB2YWx1ZSB+PSAnJwplbmQKCi0tIHNwbGl0QnlEb3QoImEuYmJjLmQiKSA9PSB7ImEiLCAiYmJjIiwgImQifQpsb2NhbCBmdW5jdGlvbiBzcGxpdEJ5RG90KHN0cikKICAgc3RyID0gc3RyIG9yICIiCiAgIGxvY2FsIHQsIGNvdW50ID0ge30sIDAKICAgc3RyOmdzdWIoIihbXiUuXSspIiwgZnVuY3Rpb24oYykKCQkJICAgY291bnQgPSBjb3VudCArIDEKCQkJICAgdFtjb3VudF0gPSBjCiAgIGVuZCkKICAgcmV0dXJuIHQKZW5kCgpsb2NhbCBmdW5jdGlvbiBwYXJzZVByZXJlbGVhc2VBbmRCdWlsZFdpdGhTaWduKHN0cikKICAgbG9jYWwgcHJlcmVsZWFzZVdpdGhTaWduLCBidWlsZFdpdGhTaWduID0gc3RyOm1hdGNoKCJeKC1bXitdKykoKy4rKSQiKQogICBpZiBub3QgKHByZXJlbGVhc2VXaXRoU2lnbiBhbmQgYnVpbGRXaXRoU2lnbikgdGhlbgoJICBwcmVyZWxlYXNlV2l0aFNpZ24gPSBzdHI6bWF0Y2goIl4oLS4rKSQiKQoJICBidWlsZFdpdGhTaWduICAgICAgPSBzdHI6bWF0Y2goIl4oKy4rKSQiKQogICBlbmQKICAgYXNzZXJ0KHByZXJlbGVhc2VXaXRoU2lnbiBvciBidWlsZFdpdGhTaWduLCAoIlRoZSBwYXJhbWV0ZXIgJXEgbXVzdCBiZWdpbiB3aXRoICsgb3IgLSB0byBkZW5vdGUgYSBwcmVyZWxlYXNlIG9yIGEgYnVpbGQiKTpmb3JtYXQoc3RyKSkKICAgcmV0dXJuIHByZXJlbGVhc2VXaXRoU2lnbiwgYnVpbGRXaXRoU2lnbgplbmQKCmxvY2FsIGZ1bmN0aW9uIHBhcnNlUHJlcmVsZWFzZShwcmVyZWxlYXNlV2l0aFNpZ24pCiAgIGlmIHByZXJlbGVhc2VXaXRoU2lnbiB0aGVuCgkgIGxvY2FsIHByZXJlbGVhc2UgPSBwcmVyZWxlYXNlV2l0aFNpZ246bWF0Y2goIl4tKCV3WyUuJXctXSopJCIpCgkgIGFzc2VydChwcmVyZWxlYXNlLCAoIlRoZSBwcmVyZWxlYXNlICVxIGlzIG5vdCBhIHNsYXNoIGZvbGxvd2VkIGJ5IGFscGhhbnVtZXJpY3MsIGRvdHMgYW5kIHNsYXNoZXMiKTpmb3JtYXQocHJlcmVsZWFzZVdpdGhTaWduKSkKCSAgcmV0dXJuIHByZXJlbGVhc2UKICAgZW5kCmVuZAoKbG9jYWwgZnVuY3Rpb24gcGFyc2VCdWlsZChidWlsZFdpdGhTaWduKQogICBpZiBidWlsZFdpdGhTaWduIHRoZW4KCSAgbG9jYWwgYnVpbGQgPSBidWlsZFdpdGhTaWduOm1hdGNoKCJeJSsoJXdbJS4ldy1dKikkIikKCSAgYXNzZXJ0KGJ1aWxkLCAoIlRoZSBidWlsZCAlcSBpcyBub3QgYSArIHNpZ24gZm9sbG93ZWQgYnkgYWxwaGFudW1lcmljcywgZG90cyBhbmQgc2xhc2hlcyIpOmZvcm1hdChidWlsZFdpdGhTaWduKSkKCSAgcmV0dXJuIGJ1aWxkCiAgIGVuZAplbmQKCmxvY2FsIGZ1bmN0aW9uIHBhcnNlUHJlcmVsZWFzZUFuZEJ1aWxkKHN0cikKICAgaWYgbm90IHByZXNlbnQoc3RyKSB0aGVuIHJldHVybiBuaWwsIG5pbCBlbmQKCiAgIGxvY2FsIHByZXJlbGVhc2VXaXRoU2lnbiwgYnVpbGRXaXRoU2lnbiA9IHBhcnNlUHJlcmVsZWFzZUFuZEJ1aWxkV2l0aFNpZ24oc3RyKQoKICAgbG9jYWwgcHJlcmVsZWFzZSA9IHBhcnNlUHJlcmVsZWFzZShwcmVyZWxlYXNlV2l0aFNpZ24pCiAgIGxvY2FsIGJ1aWxkID0gcGFyc2VCdWlsZChidWlsZFdpdGhTaWduKQoKICAgcmV0dXJuIHByZXJlbGVhc2UsIGJ1aWxkCmVuZAoKbG9jYWwgZnVuY3Rpb24gcGFyc2VWZXJzaW9uKHN0cikKICAgbG9jYWwgc01ham9yCiAgIGxvY2FsIHNNaW5vcgogICBsb2NhbCBzUGF0Y2gKICAgbG9jYWwgc1ByZXJlbGVhc2VBbmRCdWlsZAogICBzTWFqb3IsIHNNaW5vciwgc1BhdGNoLCBzUHJlcmVsZWFzZUFuZEJ1aWxkID0gc3RyOm1hdGNoKCJeKCVkKyklLj8oJWQqKSUuPyglZCopKC4tKSQiKQogICBpZiBub3Qgc01ham9yIHRoZW4KCSAgc01ham9yLCBzTWlub3IsIHNQYXRjaCwgc1ByZXJlbGVhc2VBbmRCdWlsZCA9IHN0cjptYXRjaCgiXnYoJWQrKSUuPyglZCopJS4/KCVkKikoLi0pJCIpCiAgIGVuZAogICBhc3NlcnQodHlwZShzTWFqb3IpID09ICdzdHJpbmcnLCAoIkNvdWxkIG5vdCBleHRyYWN0IHZlcnNpb24gbnVtYmVyKHMpIGZyb20gJXEiKTpmb3JtYXQoc3RyKSkKICAgbG9jYWwgbWFqb3IsIG1pbm9yLCBwYXRjaCA9IHRvbnVtYmVyKHNNYWpvciksIHRvbnVtYmVyKHNNaW5vciksIHRvbnVtYmVyKHNQYXRjaCkKICAgbG9jYWwgcHJlcmVsZWFzZSwgYnVpbGQgPSBwYXJzZVByZXJlbGVhc2VBbmRCdWlsZChzUHJlcmVsZWFzZUFuZEJ1aWxkKQogICByZXR1cm4gbWFqb3IsIG1pbm9yLCBwYXRjaCwgcHJlcmVsZWFzZSwgYnVpbGQKZW5kCgoKLS0gcmV0dXJuIDAgaWYgYSA9PSBiLCAtMSBpZiBhIDwgYiwgYW5kIDEgaWYgYSA+IGIKbG9jYWwgZnVuY3Rpb24gY29tcGFyZShhLGIpCiAgIHJldHVybiBhID09IGIgYW5kIDAgb3IgYSA8IGIgYW5kIC0xIG9yIDEKZW5kCgpsb2NhbCBmdW5jdGlvbiBjb21wYXJlSWRzKG15SWQsIG90aGVySWQpCiAgIGlmIG15SWQgPT0gb3RoZXJJZCB0aGVuIHJldHVybiAgMAogICBlbHNlaWYgbm90IG15SWQgICAgdGhlbiByZXR1cm4gLTEKICAgZWxzZWlmIG5vdCBvdGhlcklkIHRoZW4gcmV0dXJuICAxCiAgIGVuZAoKICAgbG9jYWwgc2VsZk51bWJlciwgb3RoZXJOdW1iZXIgPSB0b251bWJlcihteUlkKSwgdG9udW1iZXIob3RoZXJJZCkKCiAgIGlmIHNlbGZOdW1iZXIgYW5kIG90aGVyTnVtYmVyIHRoZW4gLS0gbnVtZXJpY2FsIGNvbXBhcmlzb24KCSAgcmV0dXJuIGNvbXBhcmUoc2VsZk51bWJlciwgb3RoZXJOdW1iZXIpCgkgIC0tIG51bWVyaWNhbHMgYXJlIGFsd2F5cyBzbWFsbGVyIHRoYW4gYWxwaGFudW1zCiAgIGVsc2VpZiBzZWxmTnVtYmVyIHRoZW4KCSAgcmV0dXJuIC0xCiAgIGVsc2VpZiBvdGhlck51bWJlciB0aGVuCgkgIHJldHVybiAxCiAgIGVsc2UKCSAgcmV0dXJuIGNvbXBhcmUobXlJZCwgb3RoZXJJZCkgLS0gYWxwaGFudW1lcmljYWwgY29tcGFyaXNvbgogICBlbmQKZW5kCgpsb2NhbCBmdW5jdGlvbiBzbWFsbGVySWRMaXN0KG15SWRzLCBvdGhlcklkcykKICAgbG9jYWwgbXlMZW5ndGggPSAjbXlJZHMKICAgbG9jYWwgY29tcGFyaXNvbgoKICAgZm9yIGk9MSwgbXlMZW5ndGggZG8KCSAgY29tcGFyaXNvbiA9IGNvbXBhcmVJZHMobXlJZHNbaV0sIG90aGVySWRzW2ldKQoJICBpZiBjb21wYXJpc29uIH49IDAgdGhlbgoJCSByZXR1cm4gY29tcGFyaXNvbiA9PSAtMQoJICBlbmQKCSAgLS0gaWYgY29tcGFyaXNvbiA9PSAwLCBjb250aW51ZSBsb29wCiAgIGVuZAoKICAgcmV0dXJuIG15TGVuZ3RoIDwgI290aGVySWRzCmVuZAoKbG9jYWwgZnVuY3Rpb24gc21hbGxlclByZXJlbGVhc2UobWluZSwgb3RoZXIpCiAgIGlmIG1pbmUgPT0gb3RoZXIgb3Igbm90IG1pbmUgdGhlbiByZXR1cm4gZmFsc2UKICAgZWxzZWlmIG5vdCBvdGhlciB0aGVuIHJldHVybiB0cnVlCiAgIGVuZAoKICAgcmV0dXJuIHNtYWxsZXJJZExpc3Qoc3BsaXRCeURvdChtaW5lKSwgc3BsaXRCeURvdChvdGhlcikpCmVuZAoKbG9jYWwgbWV0aG9kcyA9IHt9CgpmdW5jdGlvbiBtZXRob2RzOm5leHRNYWpvcigpCiAgIHJldHVybiBzZW12ZXIoc2VsZi5tYWpvciArIDEsIDAsIDApCmVuZApmdW5jdGlvbiBtZXRob2RzOm5leHRNaW5vcigpCiAgIHJldHVybiBzZW12ZXIoc2VsZi5tYWpvciwgc2VsZi5taW5vciArIDEsIDApCmVuZApmdW5jdGlvbiBtZXRob2RzOm5leHRQYXRjaCgpCiAgIHJldHVybiBzZW12ZXIoc2VsZi5tYWpvciwgc2VsZi5taW5vciwgc2VsZi5wYXRjaCArIDEpCmVuZAoKbG9jYWwgbXQgPSB7IF9faW5kZXggPSBtZXRob2RzIH0KZnVuY3Rpb24gbXQ6X19lcShvdGhlcikKICAgcmV0dXJuIHNlbGYubWFqb3IgPT0gb3RoZXIubWFqb3IgYW5kCgkgIHNlbGYubWlub3IgPT0gb3RoZXIubWlub3IgYW5kCgkgIHNlbGYucGF0Y2ggPT0gb3RoZXIucGF0Y2ggYW5kCgkgIHNlbGYucHJlcmVsZWFzZSA9PSBvdGhlci5wcmVyZWxlYXNlCiAgIC0tIG5vdGljZSB0aGF0IGJ1aWxkIGlzIGlnbm9yZWQgZm9yIHByZWNlZGVuY2UgaW4gc2VtdmVyIDIuMC4wCmVuZApmdW5jdGlvbiBtdDpfX2x0KG90aGVyKQogICBpZiBzZWxmLm1ham9yIH49IG90aGVyLm1ham9yIHRoZW4gcmV0dXJuIHNlbGYubWFqb3IgPCBvdGhlci5tYWpvciBlbmQKICAgaWYgc2VsZi5taW5vciB+PSBvdGhlci5taW5vciB0aGVuIHJldHVybiBzZWxmLm1pbm9yIDwgb3RoZXIubWlub3IgZW5kCiAgIGlmIHNlbGYucGF0Y2ggfj0gb3RoZXIucGF0Y2ggdGhlbiByZXR1cm4gc2VsZi5wYXRjaCA8IG90aGVyLnBhdGNoIGVuZAogICByZXR1cm4gc21hbGxlclByZXJlbGVhc2Uoc2VsZi5wcmVyZWxlYXNlLCBvdGhlci5wcmVyZWxlYXNlKQogICAtLSBub3RpY2UgdGhhdCBidWlsZCBpcyBpZ25vcmVkIGZvciBwcmVjZWRlbmNlIGluIHNlbXZlciAyLjAuMAplbmQKLS0gVGhpcyB3b3JrcyBsaWtlIHRoZSAicGVzc2ltaXNzdGljIG9wZXJhdG9yIiBpbiBSdWJ5Z2Vtcy4KLS0gaWYgYSBhbmQgYiBhcmUgdmVyc2lvbnMsIGEgXiBiIG1lYW5zICJiIGlzIGJhY2t3YXJkcy1jb21wYXRpYmxlIHdpdGggYSIKLS0gaW4gb3RoZXIgd29yZHMsICJpdCdzIHNhZmUgdG8gdXBncmFkZSBmcm9tIGEgdG8gYiIKZnVuY3Rpb24gbXQ6X19wb3cob3RoZXIpCiAgIGlmIHNlbGYubWFqb3IgPT0gMCB0aGVuCgkgIHJldHVybiBzZWxmID09IG90aGVyCiAgIGVuZAogICByZXR1cm4gc2VsZi5tYWpvciA9PSBvdGhlci5tYWpvciBhbmQKCSAgc2VsZi5taW5vciA8PSBvdGhlci5taW5vcgplbmQKCmxvY2FsIGZ1bmN0aW9uIG5ldyhtYWpvciwgbWlub3IsIHBhdGNoLCBwcmVyZWxlYXNlLCBidWlsZCkKICAgaWYgbm90IG1ham9yIHRoZW4KICAgICAgIHdhcm4oIlplbnJvb20gYnVpbGQgbWlzc2VzIHZlcnNpb24gaW5mb3JtYXRpb24iKQogICAgICAgd2FybigiUnVubmluZyBWTSBpcyBub3QgYW4gb2ZmaWNpYWwgcmVsZWFzZSBieSBEeW5lLm9yZyIpCiAgICAgICByZXR1cm4gbmlsCiAgIGVuZAogICBsb2NhbCByZXN1bHQgPSB7IH0KICAgaWYgdHlwZShtYWpvcikgPT0gJ3N0cmluZycgdGhlbgoJICByZXN1bHQub3JpZ2luYWwgPSBtYWpvcgoJICBtYWpvcixtaW5vcixwYXRjaCxwcmVyZWxlYXNlLGJ1aWxkID0gcGFyc2VWZXJzaW9uKG1ham9yKQogICBlbmQKICAgcGF0Y2ggPSBwYXRjaCBvciAwCiAgIG1pbm9yID0gbWlub3Igb3IgMAoKICAgY2hlY2tQb3NpdGl2ZUludGVnZXIobWFqb3IsICJtYWpvciIpCiAgIGNoZWNrUG9zaXRpdmVJbnRlZ2VyKG1pbm9yLCAibWlub3IiKQogICBjaGVja1Bvc2l0aXZlSW50ZWdlcihwYXRjaCwgInBhdGNoIikKCiAgIHJlc3VsdC5tYWpvciA9IG1ham9yCiAgIHJlc3VsdC5taW5vciA9IG1pbm9yCiAgIHJlc3VsdC5wYXRjaCA9IHBhdGNoCiAgIHJlc3VsdC5wcmVyZWxlYXNlID0gcHJlcmVsZWFzZQogICByZXN1bHQuYnVpbGQgPSBidWlsZAogICByZXR1cm4gc2V0bWV0YXRhYmxlKHJlc3VsdCwgbXQpCmVuZAoKc2V0bWV0YXRhYmxlKHNlbXZlciwgeyBfX2NhbGwgPSBmdW5jdGlvbihfLCAuLi4pIHJldHVybiBuZXcoLi4uKSBlbmQgfSkKc2VtdmVyLl9WRVJTSU9OPSBzZW12ZXIoc2VtdmVyLl9WRVJTSU9OKQoKcmV0dXJuIHNlbXZlcgovc3BlbGwubHVhAC0tIFNwZWxsaW5nIENvcnJlY3Rvci4KLS0KLS0gQ29weXJpZ2h0IDIwMTQgRnJhbmNpc2NvIFphbW9yYS1NYXJ0aW5legotLSBDb3B5cmlnaHQgMjAyNCBKYXJvbWlsIChEeW5lLm9yZykKLS0gQWRhcHRhdGlvbiBvZiBQZXRlciBOb3J2aWcgcHl0aG9uIFNwZWxsaW5nIENvcnJlY3RvcjoKLS0gaHR0cDovL25vcnZpZy5jb20vc3BlbGwtY29ycmVjdC5odG1sCi0tIE9wZW4gc291cmNlIGNvZGUgdW5kZXIgTUlUIGxpY2Vuc2U6IGh0dHA6Ly93d3cub3BlbnNvdXJjZS5vcmcvbGljZW5zZXMvbWl0LWxpY2Vuc2UucGhwCgpsb2NhbCB5aWVsZCwgd3JhcCA9IGNvcm91dGluZS55aWVsZCwgY29yb3V0aW5lLndyYXAKbG9jYWwgYWxwaGFiZXRfc3RyLCBhbHBoYWJldCA9ICdhYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5eicsIHt9CmZvciBhIGluIGFscGhhYmV0X3N0cjpnbWF0Y2goIi4iKSBkbyBhbHBoYWJldFsjYWxwaGFiZXQgKyAxXSA9IGEgZW5kCnNwZWxsID0ge30KCmxvY2FsIGZ1bmN0aW9uIGxpc3QodykgcmV0dXJuIHBhaXJzIHsgW3ddID10cnVlIH0gZW5kCgpmdW5jdGlvbiBzcGVsbDptYXgoLi4uKQogICAgbG9jYWwgYXJnLCBtYXgsIGh5cCA9IHRhYmxlLnBhY2soLi4uKSwgMCwgbmlsCiAgICBmb3IgdyBpbiB0YWJsZS51bnBhY2soYXJnKSBkbwogICAgICAgIGxvY2FsIHAgPSBzZWxmLm1vZGVsW3ddIG9yIDEKICAgICAgICBpZiBwID4gbWF4IG9yIChwID09IG1heCBhbmQgaHlwIDwgdykgdGhlbgogICAgICAgICAgICBoeXAsIG1heCA9IHcsIHAKICAgICAgICBlbmQKICAgIGVuZAogICAgcmV0dXJuIGh5cAplbmQKCi0tIGxvY2FsIGZ1bmN0aW9uIHdvcmRzKHRleHQpIHJldHVybiB0ZXh0Omxvd2VyKCk6Z21hdGNoKCJbYS16XSsiKSBlbmQKCi0tIGxvY2FsIGZ1bmN0aW9uIHRyYWluKGZlYXR1cmVzKQotLSAgIGZvciBmIGluIGZlYXR1cmVzIGRvIG1vZGVsW2ZdID0gKG1vZGVsW2ZdIG9yIDEpICsgMSBlbmQKLS0gZW5kCgotLSBsb2NhbCBmdW5jdGlvbiBpbml0KGZpbGVuYW1lKSB0cmFpbih3b3Jkcyhpby5vcGVuKGZpbGVuYW1lKTpyZWFkKCIqYSIpKSkgZW5kCgpsb2NhbCBmdW5jdGlvbiBtYWtlX3lpZWxkKCkKICAgIGxvY2FsIHNldCA9IHt9CiAgICByZXR1cm4gZnVuY3Rpb24odykKICAgICAgICBpZiBub3Qgc2V0W3ddIHRoZW4KICAgICAgICAgICAgc2V0W3ddID0gdHJ1ZQogICAgICAgICAgICB5aWVsZCh3KQogICAgICAgIGVuZAogICAgZW5kCmVuZAoKbG9jYWwgZnVuY3Rpb24gZWRpdHMxKHdvcmRfc3RyLCB5aWVsZCkKICAgIGxvY2FsIHlpZWxkID0geWllbGQgb3IgbWFrZV95aWVsZCgpCiAgICByZXR1cm4gd3JhcChmdW5jdGlvbigpCiAgICAgICAgbG9jYWwgc3BsaXRzLCB3b3JkID0ge30sIHt9CiAgICAgICAgZm9yIGkgPSAxLCAjd29yZF9zdHIgZG8KICAgICAgICAgICAgd29yZFtpXSwgc3BsaXRzW2ldID0gd29yZF9zdHI6c3ViKGksIGkpLCB7d29yZF9zdHI6c3ViKDEsIGkpLCB3b3JkX3N0cjpzdWIoaSl9CiAgICAgICAgZW5kCiAgICAgICAgLS0gc2VudGluZWxzCiAgICAgICAgc3BsaXRzWzBdLCBzcGxpdHNbI3dvcmRfc3RyICsgMV0gPSB7IiIsIHdvcmRfc3RyfSwge3dvcmRfc3RyLCAiIn0KICAgICAgICAtLSBkZWxldGVzCiAgICAgICAgZm9yIGkgPSAxLCAjd29yZF9zdHIgZG8KICAgICAgICAgICAgeWllbGQoc3BsaXRzW2kgLSAxXVsxXSAuLiBzcGxpdHNbaSArIDFdWzJdKQogICAgICAgIGVuZAogICAgICAgIC0tIHRyYW5zcG9zZXMKICAgICAgICBmb3IgaSA9IDEsICN3b3JkX3N0ciAtIDEgZG8KICAgICAgICAgICAgeWllbGQoc3BsaXRzW2kgLSAxXVsxXSAuLiB3b3JkW2kgKyAxXSAuLiB3b3JkW2ldIC4uIHNwbGl0c1tpICsgMl1bMl0pCiAgICAgICAgZW5kCiAgICAgICAgLS0gcmVwbGFjZXMKICAgICAgICBmb3IgaSA9IDEsICN3b3JkX3N0ciBkbwogICAgICAgICAgICBmb3IgaiA9IDEsICNhbHBoYWJldCBkbwogICAgICAgICAgICAgICAgeWllbGQoc3BsaXRzW2kgLSAxXVsxXSAuLiBhbHBoYWJldFtqXSAuLiBzcGxpdHNbaSArIDFdWzJdKQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICAtLSBpbnNlcnRzCiAgICAgICAgZm9yIGkgPSAwLCAjd29yZF9zdHIgZG8KICAgICAgICAgICAgZm9yIGogPSAxLCAjYWxwaGFiZXQgZG8KICAgICAgICAgICAgICAgIHlpZWxkKHNwbGl0c1tpXVsxXSAuLiBhbHBoYWJldFtqXSAuLiBzcGxpdHNbaSArIDFdWzJdKQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgIGVuZCkKZW5kCgpmdW5jdGlvbiBzcGVsbDprbm93bl9lZGl0czIodywgc2V0KQogICAgbG9jYWwgeWllbGQsIHlpZWxkMiA9IG1ha2VfeWllbGQoKSwgbWFrZV95aWVsZCgpCiAgICByZXR1cm4gd3JhcChmdW5jdGlvbigpCiAgICAgICAgZm9yIGUxIGluIGVkaXRzMSh3KSBkbwogICAgICAgICAgICBmb3IgZTIgaW4gZWRpdHMxKGUxLCB5aWVsZDIpIGRvCiAgICAgICAgICAgICAgICBpZiBzZWxmLm1vZGVsW2UyXSB0aGVuCiAgICAgICAgICAgICAgICAgICAgeWllbGQoZTIpCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICBlbmQpCmVuZAoKZnVuY3Rpb24gc3BlbGw6a25vd24obGlzdCwgYXV4KQogICAgcmV0dXJuIHdyYXAoZnVuY3Rpb24oKQogICAgICAgIGZvciB3IGluIGxpc3QsIGF1eCBkbwogICAgICAgICAgICBpZiBzZWxmLm1vZGVsW3ddIHRoZW4KICAgICAgICAgICAgICAgIHlpZWxkKHcpCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgZW5kKQplbmQKCmZ1bmN0aW9uIHNwZWxsOmNvcnJlY3QodykKICAgIGxvY2FsIHcgPSB3Omxvd2VyKCkKICAgIGxvY2FsIHJlc3VsdCA9IHNlbGY6bWF4KHNlbGY6a25vd24obGlzdCh3KSkpCiAgICAgICAgb3Igc2VsZjptYXgoc2VsZjprbm93bihlZGl0czEodykpKQogICAgICAgIG9yIHNlbGY6bWF4KHNlbGY6a25vd25fZWRpdHMyKHcpKQogICAgICAgIG9yIHNlbGY6bWF4KGxpc3QodykpCiAgICBpZiByZXN1bHQgdGhlbgogICAgICAgIHJldHVybiByZXN1bHQKICAgIGVsc2UKICAgICAgICByZXR1cm4gZmFsc2UsICJObyBzdWdnZXN0aW9uIGZvdW5kIGZvciB3b3JkOiAiIC4uIHcKICAgIGVuZAplbmQKCnJldHVybiBzcGVsbAovc3RhdGVtYWNoaW5lLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAxOC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLUZvcmtlZCBmcm9tIHN0YXRlbWFjaGluZSBieSBLeWxlIENvbnJveSAoMjAxMikKLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tXV0KCmxvY2FsIG1hY2hpbmUgPSB7fQptYWNoaW5lLl9faW5kZXggPSBtYWNoaW5lCgpsb2NhbCBmdW5jdGlvbiBjYWxsX2hhbmRsZXIoaGFuZGxlciwgcGFyYW1zKQogIGlmIGhhbmRsZXIgdGhlbgogICAgcmV0dXJuIGhhbmRsZXIodGFibGUudW5wYWNrKHBhcmFtcykpCiAgZW5kCmVuZAoKbG9jYWwgZnVuY3Rpb24gY3JlYXRlX3RyYW5zaXRpb24obmFtZSkKICBsb2NhbCBjYW4sIHRvLCBmcm9tLCBwYXJhbXMKCiAgbG9jYWwgZnVuY3Rpb24gdHJhbnNpdGlvbihzZWxmLCAuLi4pCgkgY2FuLCB0byA9IHNlbGY6Y2FuKG5hbWUpCgkgZnJvbSA9IHNlbGYuY3VycmVudAoJIHBhcmFtcyA9IHsgc2VsZiwgbmFtZSwgZnJvbSwgdG8sIC4uLn0KCgkgaWYgbm90IGNhbiB0aGVuIHJldHVybiBmYWxzZSBlbmQKCSBzZWxmLmN1cnJlbnRUcmFuc2l0aW9uaW5nRXZlbnQgPSBuYW1lCgkgc2VsZi5jdXJyZW50ID0gdG8KCgkgY2FsbF9oYW5kbGVyKHNlbGZbIm9uIiAuLiB0b10sIHBhcmFtcykKCSBjYWxsX2hhbmRsZXIoc2VsZlsib24iIC4uIG5hbWVdLCBwYXJhbXMpCgoJIHNlbGYuY3VycmVudFRyYW5zaXRpb25pbmdFdmVudCA9IG5pbAoJIHJldHVybiB0cnVlCmVuZAoKcmV0dXJuIHRyYW5zaXRpb24KZW5kCgpsb2NhbCBmdW5jdGlvbiBhZGRfdG9fbWFwKG1hcCwgZXZlbnQpCiAgaWYgdHlwZShldmVudC5mcm9tKSA9PSAnc3RyaW5nJyB0aGVuCiAgICBtYXBbZXZlbnQuZnJvbV0gPSBldmVudC50bwogIGVsc2UKICAgIGZvciBfLCBmcm9tIGluIGlwYWlycyhldmVudC5mcm9tKSBkbwogICAgICBtYXBbZnJvbV0gPSBldmVudC50bwogICAgZW5kCiAgZW5kCmVuZAoKZnVuY3Rpb24gbWFjaGluZS5jcmVhdGUob3B0aW9ucykKICBhc3NlcnQob3B0aW9ucy5ldmVudHMpCgogIGxvY2FsIGZzbSA9IHt9CiAgc2V0bWV0YXRhYmxlKGZzbSwgbWFjaGluZSkKCiAgZnNtLm9wdGlvbnMgPSBvcHRpb25zCiAgZnNtLmN1cnJlbnQgPSBvcHRpb25zLmluaXRpYWwgb3IgJ25vbmUnCiAgZnNtLmV2ZW50cyA9IHt9CiAgZnNtLmxpbmUgPSAwCgogIGZvciBfLCBldmVudCBpbiBpcGFpcnMob3B0aW9ucy5ldmVudHMgb3Ige30pIGRvCiAgICBsb2NhbCBuYW1lID0gZXZlbnQubmFtZQogICAgZnNtW25hbWVdID0gZnNtW25hbWVdIG9yIGNyZWF0ZV90cmFuc2l0aW9uKG5hbWUpCiAgICBmc20uZXZlbnRzW25hbWVdID0gZnNtLmV2ZW50c1tuYW1lXSBvciB7IG1hcCA9IHt9IH0KICAgIGFkZF90b19tYXAoZnNtLmV2ZW50c1tuYW1lXS5tYXAsIGV2ZW50KQogIGVuZAogIAogIGZvciBuYW1lLCBjYWxsYmFjayBpbiBwYWlycyhvcHRpb25zLmNhbGxiYWNrcyBvciB7fSkgZG8KICAgIGZzbVtuYW1lXSA9IGNhbGxiYWNrCiAgZW5kCgogIHJldHVybiBmc20KZW5kCgpmdW5jdGlvbiBtYWNoaW5lOmlzKHN0YXRlKQogIHJldHVybiBzZWxmLmN1cnJlbnQgPT0gc3RhdGUKZW5kCgpmdW5jdGlvbiBtYWNoaW5lOmNhbihlKQogIGxvY2FsIGV2ZW50ID0gc2VsZi5ldmVudHNbZV0KICBsb2NhbCB0byA9IGV2ZW50IGFuZCBldmVudC5tYXBbc2VsZi5jdXJyZW50XQogIHJldHVybiB0byB+PSBuaWwsIHRvCmVuZAoKZnVuY3Rpb24gbWFjaGluZTp0cmFuc2l0aW9uKGV2ZW50KQogIGlmIHNlbGYuY3VycmVudFRyYW5zaXRpb25pbmdFdmVudCA9PSBldmVudCB0aGVuCiAgICByZXR1cm4gc2VsZltzZWxmLmN1cnJlbnRUcmFuc2l0aW9uaW5nRXZlbnRdKHNlbGYpCiAgZW5kCmVuZAoKcmV0dXJuIG1hY2hpbmUKL3N0YXRzLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBBbGJlcnRvIExlcmRhCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLV1dCi0tIFRhYmxlcyBzdXBwbGllZCBhcyBhcmd1bWVudHMgYXJlIG5vdCBjaGFuZ2VkLgoKCi0tIFRhYmxlIHRvIGhvbGQgc3RhdGlzdGljYWwgZnVuY3Rpb25zCmxvY2FsIHN0YXRzPXt9CgotLSBHZXQgdGhlIG1lYW4gdmFsdWUgb2YgYSB0YWJsZQpmdW5jdGlvbiBzdGF0cy5hdmVyYWdlKCB0YWJfaW4gKQogIGxvY2FsIHplcm8gPSBCSUcubmV3KDApCiAgbG9jYWwgb25lID0gQklHLm5ldygxKQogIGxvY2FsIHN1bSA9IHplcm8KICBsb2NhbCBjb3VudCA9IHplcm8gCiAgbG9jYWwgbmV3c3VtCiAgbG9jYWwgdAogIGZvciBfLHYgaW4gcGFpcnModGFiX2luKSBkbwogICAgdCA9IHR5cGUodikKICAgIGlmIHQgPT0gJ251bWJlcicgdGhlbgogICAgICB2ID0gQklHLmZyb21fZGVjaW1hbCh0b3N0cmluZyh2KSkKICAgIGVsc2VpZiBpc3plbih0KSB0aGVuCiAgICAgIHYgPSBCSUcuZnJvbV9kZWNpbWFsKHY6b2N0ZXQoKTpzdHJpbmcoKSkKICAgIGVsc2UKICAgICAgZXJyb3IoIlVua25vd24gdHlwZSBmb3IgbnVtYmVyIiwgMikKICAgIGVuZAogICAgaWYgdHlwZSh2KSA9PSAnemVucm9vbS5iaWcnIHRoZW4KICAgICAgbmV3c3VtID0gc3VtICsgdgogICAgICBjb3VudCA9IGNvdW50ICsgb25lCiAgICAgIHplbmNvZGVfYXNzZXJ0KG5ld3N1bSA+IHN1bSwgIk92ZXJmbG93IGluIHN1bSIpCiAgICAgIHN1bSA9IG5ld3N1bQogICAgZW5kCiAgZW5kCiAgemVuY29kZV9hc3NlcnQoY291bnQgPiB6ZXJvLCAiTm8gbnVtYmVycyBpbiBhcnJheSIpCgogIHJldHVybiAoc3VtIC8gY291bnQpCmVuZAotLSBHZXQgdGhlIHZhcmlhbmNlIG9mIGEgdGFibGUKZnVuY3Rpb24gc3RhdHMudmFyaWFuY2UoIHRhYl9pbiApCiAgbG9jYWwgemVybyA9IEJJRy5uZXcoMCkKICBsb2NhbCBvbmUgPSBCSUcubmV3KDEpCiAgbG9jYWwgbQogIGxvY2FsIHZtCiAgbG9jYWwgc3VtID0gemVybyAKICBsb2NhbCBjb3VudCA9IHplcm8KICBsb2NhbCByZXN1bHQKICBsb2NhbCB0CiAgbG9jYWwgbmV3c3VtCiAgbSA9IHN0YXRzLmF2ZXJhZ2UoIHRhYl9pbiApCgogIGZvciBfLHYgaW4gcGFpcnModGFiX2luKSBkbwogICAgdCA9IHR5cGUodikKCiAgICBpZiB0ID09ICdudW1iZXInIHRoZW4KICAgICAgdiA9IEJJRy5mcm9tX2RlY2ltYWwodG9zdHJpbmcodikpCiAgICBlbHNlaWYgaXN6ZW4odCkgdGhlbgogICAgICB2ID0gQklHLmZyb21fZGVjaW1hbCh2Om9jdGV0KCk6c3RyaW5nKCkpCiAgICBlbHNlCiAgICAgIGVycm9yKCJVbmtub3duIHR5cGUgZm9yIG51bWJlciIsIDIpCiAgICBlbmQKICAgIGlmIHR5cGUodikgPT0gJ3plbnJvb20uYmlnJyB0aGVuCiAgICAgIHZtID0gdiAtIG0KICAgICAgbmV3c3VtID0gc3VtICsgKHZtICogdm0pCiAgICAgIHplbmNvZGVfYXNzZXJ0KG5ld3N1bSA+IHN1bSwgIk92ZXJmbG93IGluIHN1bSIpCiAgICAgIGNvdW50ID0gY291bnQgKyBvbmUKICAgICAgc3VtID0gbmV3c3VtCiAgICBlbmQKICBlbmQKCiAgemVuY29kZV9hc3NlcnQoY291bnQgPiBvbmUsICJOb3QgZW5vdWdoIG51bWJlcnMgKGF0IGxlYXN0IDIpIikKICByZXN1bHQgPSBzdW0gLyAoY291bnQtb25lKQoKICByZXR1cm4gcmVzdWx0CmVuZAoKZnVuY3Rpb24gc3RhdHMuc3RhbmRhcmREZXZpYXRpb24oIHQgKQogIHJldHVybiBCSUcuc3FydChzdGF0cy52YXJpYW5jZSggdCApKQplbmQKCnJldHVybiBzdGF0cwovdGltZXRhYmxlLmx1YQBsb2NhbCBzdHJmb3JtYXQgPSBzdHJpbmcuZm9ybWF0CmxvY2FsIGZsb29yID0gbWF0aC5mbG9vcgpsb2NhbCBmdW5jdGlvbiBpZGl2KG4sIGQpCglyZXR1cm4gZmxvb3IobiAvIGQpCmVuZAoKbG9jYWwgY19sb2NhbGUgPSB7CglhYmRheSA9IHsiU3VuIiwgIk1vbiIsICJUdWUiLCAiV2VkIiwgIlRodSIsICJGcmkiLCAiU2F0In07CglkYXkgPSB7IlN1bmRheSIsICJNb25kYXkiLCAiVHVlc2RheSIsICJXZWRuZXNkYXkiLCAiVGh1cnNkYXkiLCAiRnJpZGF5IiwgIlNhdHVyZGF5In07CglhYm1vbiA9IHsiSmFuIiwgIkZlYiIsICJNYXIiLCAiQXByIiwgIk1heSIsICJKdW4iLCAiSnVsIiwgIkF1ZyIsICJTZXAiLCAiT2N0IiwgIk5vdiIsICJEZWMifTsKCW1vbiA9IHsiSmFudWFyeSIsICJGZWJydWFyeSIsICJNYXJjaCIsICJBcHJpbCIsICJNYXkiLCAiSnVuZSIsCgkJIkp1bHkiLCAiQXVndXN0IiwgIlNlcHRlbWJlciIsICJPY3RvYmVyIiwgIk5vdmVtYmVyIiwgIkRlY2VtYmVyIn07CglhbV9wbSA9IHsiQU0iLCAiUE0ifTsKfQoKLS0tIElTTy04NjAxIHdlZWsgbG9naWMKLS0gSVNPIDg2MDEgd2Vla2RheSBhcyBudW1iZXIgd2l0aCBNb25kYXkgYXMgMSAoMS03KQpsb2NhbCBmdW5jdGlvbiBpc29fODYwMV93ZWVrZGF5KHdkYXkpCglpZiB3ZGF5ID09IDEgdGhlbgoJCXJldHVybiA3CgllbHNlCgkJcmV0dXJuIHdkYXkgLSAxCgllbmQKZW5kCmxvY2FsIGlzb184NjAxX3dlZWsgZG8KCS0tIFllYXJzIHRoYXQgaGF2ZSA1MyB3ZWVrcyBhY2NvcmRpbmcgdG8gSVNPLTg2MDEKCWxvY2FsIGxvbmdfeWVhcnMgPSB7fQoJZm9yIF8sIHYgaW4gaXBhaXJzIHsKCQkgIDQsICAgOSwgIDE1LCAgMjAsICAyNiwgIDMyLCAgMzcsICA0MywgIDQ4LCAgNTQsICA2MCwgIDY1LCAgNzEsICA3NiwgIDgyLAoJCSA4OCwgIDkzLCAgOTksIDEwNSwgMTExLCAxMTYsIDEyMiwgMTI4LCAxMzMsIDEzOSwgMTQ0LCAxNTAsIDE1NiwgMTYxLCAxNjcsCgkJMTcyLCAxNzgsIDE4NCwgMTg5LCAxOTUsIDIwMSwgMjA3LCAyMTIsIDIxOCwgMjI0LCAyMjksIDIzNSwgMjQwLCAyNDYsIDI1MiwKCQkyNTcsIDI2MywgMjY4LCAyNzQsIDI4MCwgMjg1LCAyOTEsIDI5NiwgMzAzLCAzMDgsIDMxNCwgMzIwLCAzMjUsIDMzMSwgMzM2LAoJCTM0MiwgMzQ4LCAzNTMsIDM1OSwgMzY0LCAzNzAsIDM3NiwgMzgxLCAzODcsIDM5MiwgMzk4Cgl9IGRvCgkJbG9uZ195ZWFyc1t2XSA9IHRydWUKCWVuZAoJbG9jYWwgZnVuY3Rpb24gaXNfbG9uZ195ZWFyKHllYXIpCgkJcmV0dXJuIGxvbmdfeWVhcnNbeWVhciAlIDQwMF0KCWVuZAoJZnVuY3Rpb24gaXNvXzg2MDFfd2VlayhzZWxmKQoJCWxvY2FsIHdkYXkgPSBpc29fODYwMV93ZWVrZGF5KHNlbGYud2RheSkKCQlsb2NhbCBuID0gc2VsZi55ZGF5IC0gd2RheQoJCWxvY2FsIHllYXIgPSBzZWxmLnllYXIKCQlpZiBuIDwgLTMgdGhlbgoJCQl5ZWFyID0geWVhciAtIDEKCQkJaWYgaXNfbG9uZ195ZWFyKHllYXIpIHRoZW4KCQkJCXJldHVybiB5ZWFyLCA1Mywgd2RheQoJCQllbHNlCgkJCQlyZXR1cm4geWVhciwgNTIsIHdkYXkKCQkJZW5kCgkJZWxzZWlmIG4gPj0gMzYxIGFuZCBub3QgaXNfbG9uZ195ZWFyKHllYXIpIHRoZW4KCQkJcmV0dXJuIHllYXIgKyAxLCAxLCB3ZGF5CgkJZWxzZQoJCQlyZXR1cm4geWVhciwgaWRpdihuICsgMTAsIDcpLCB3ZGF5CgkJZW5kCgllbmQKZW5kCgotLS0gU3BlY2lmaWVycwpsb2NhbCB0ID0ge30KZnVuY3Rpb24gdDphKGxvY2FsZSkKCXJldHVybiAiJXMiLCBsb2NhbGUuYWJkYXlbc2VsZi53ZGF5XQplbmQKZnVuY3Rpb24gdDpBKGxvY2FsZSkKCXJldHVybiAiJXMiLCBsb2NhbGUuZGF5W3NlbGYud2RheV0KZW5kCmZ1bmN0aW9uIHQ6Yihsb2NhbGUpCglyZXR1cm4gIiVzIiwgbG9jYWxlLmFibW9uW3NlbGYubW9udGhdCmVuZApmdW5jdGlvbiB0OkIobG9jYWxlKQoJcmV0dXJuICIlcyIsIGxvY2FsZS5tb25bc2VsZi5tb250aF0KZW5kCmZ1bmN0aW9uIHQ6Yyhsb2NhbGUpCglyZXR1cm4gIiUuM3MgJS4zcyUzZCAlLjJkOiUuMmQ6JS4yZCAlZCIsCgkJbG9jYWxlLmFiZGF5W3NlbGYud2RheV0sIGxvY2FsZS5hYm1vbltzZWxmLm1vbnRoXSwKCQlzZWxmLmRheSwgc2VsZi5ob3VyLCBzZWxmLm1pbiwgc2VsZi5zZWMsIHNlbGYueWVhcgplbmQKLS0gQ2VudHVyeQpmdW5jdGlvbiB0OkMoKQoJcmV0dXJuICIlMDJkIiwgaWRpdihzZWxmLnllYXIsIDEwMCkKZW5kCmZ1bmN0aW9uIHQ6ZCgpCglyZXR1cm4gIiUwMmQiLCBzZWxmLmRheQplbmQKLS0gU2hvcnQgTU0vREQvWVkgZGF0ZSwgZXF1aXZhbGVudCB0byAlbS8lZC8leQpmdW5jdGlvbiB0OkQoKQoJcmV0dXJuICIlMDJkLyUwMmQvJTAyZCIsIHNlbGYubW9udGgsIHNlbGYuZGF5LCBzZWxmLnllYXIgJSAxMDAKZW5kCmZ1bmN0aW9uIHQ6ZSgpCglyZXR1cm4gIiUyZCIsIHNlbGYuZGF5CmVuZAotLSBTaG9ydCBZWVlZLU1NLUREIGRhdGUsIGVxdWl2YWxlbnQgdG8gJVktJW0tJWQKZnVuY3Rpb24gdDpGKCkKCXJldHVybiAiJWQtJTAyZC0lMDJkIiwgc2VsZi55ZWFyLCBzZWxmLm1vbnRoLCBzZWxmLmRheQplbmQKLS0gV2Vlay1iYXNlZCB5ZWFyLCBsYXN0IHR3byBkaWdpdHMgKDAwLTk5KQpmdW5jdGlvbiB0OmcoKQoJcmV0dXJuICIlMDJkIiwgaXNvXzg2MDFfd2VlayhzZWxmKSAlIDEwMAplbmQKLS0gV2Vlay1iYXNlZCB5ZWFyCmZ1bmN0aW9uIHQ6RygpCglyZXR1cm4gIiVkIiwgaXNvXzg2MDFfd2VlayhzZWxmKQplbmQKdC5oID0gdC5iCmZ1bmN0aW9uIHQ6SCgpCglyZXR1cm4gIiUwMmQiLCBzZWxmLmhvdXIKZW5kCmZ1bmN0aW9uIHQ6SSgpCglyZXR1cm4gIiUwMmQiLCAoc2VsZi5ob3VyLTEpICUgMTIgKyAxCmVuZApmdW5jdGlvbiB0OmooKQoJcmV0dXJuICIlMDNkIiwgc2VsZi55ZGF5CmVuZApmdW5jdGlvbiB0Om0oKQoJcmV0dXJuICIlMDJkIiwgc2VsZi5tb250aAplbmQKZnVuY3Rpb24gdDpNKCkKCXJldHVybiAiJTAyZCIsIHNlbGYubWluCmVuZAotLSBOZXctbGluZSBjaGFyYWN0ZXIgKCdcbicpCmZ1bmN0aW9uIHQ6bigpIC0tIGx1YWNoZWNrOiBpZ25vcmUgMjEyCglyZXR1cm4gIlxuIgplbmQKZnVuY3Rpb24gdDpwKGxvY2FsZSkKCXJldHVybiBzZWxmLmhvdXIgPCAxMiBhbmQgbG9jYWxlLmFtX3BtWzFdIG9yIGxvY2FsZS5hbV9wbVsyXQplbmQKLS0gVE9ETzogc2hvdWxkIHJlc3BlY3QgbG9jYWxlCmZ1bmN0aW9uIHQ6cihsb2NhbGUpCglyZXR1cm4gIiUwMmQ6JTAyZDolMDJkICVzIiwKCQkoc2VsZi5ob3VyLTEpICUgMTIgKyAxLCBzZWxmLm1pbiwgc2VsZi5zZWMsCgkJc2VsZi5ob3VyIDwgMTIgYW5kIGxvY2FsZS5hbV9wbVsxXSBvciBsb2NhbGUuYW1fcG1bMl0KZW5kCi0tIDI0LWhvdXIgSEg6TU0gdGltZSwgZXF1aXZhbGVudCB0byAlSDolTQpmdW5jdGlvbiB0OlIoKQoJcmV0dXJuICIlMDJkOiUwMmQiLCBzZWxmLmhvdXIsIHNlbGYubWluCmVuZApmdW5jdGlvbiB0OnMoKQoJcmV0dXJuICIlZCIsIHNlbGY6dGltZXN0YW1wKCkKZW5kCmZ1bmN0aW9uIHQ6UygpCglyZXR1cm4gIiUwMmQiLCBzZWxmLnNlYwplbmQKLS0gSG9yaXpvbnRhbC10YWIgY2hhcmFjdGVyICgnXHQnKQpmdW5jdGlvbiB0OnQoKSAtLSBsdWFjaGVjazogaWdub3JlIDIxMgoJcmV0dXJuICJcdCIKZW5kCi0tIElTTyA4NjAxIHRpbWUgZm9ybWF0IChISDpNTTpTUyksIGVxdWl2YWxlbnQgdG8gJUg6JU06JVMKZnVuY3Rpb24gdDpUKCkKCXJldHVybiAiJTAyZDolMDJkOiUwMmQiLCBzZWxmLmhvdXIsIHNlbGYubWluLCBzZWxmLnNlYwplbmQKZnVuY3Rpb24gdDp1KCkKCXJldHVybiAiJWQiLCBpc29fODYwMV93ZWVrZGF5KHNlbGYud2RheSkKZW5kCi0tIFdlZWsgbnVtYmVyIHdpdGggdGhlIGZpcnN0IFN1bmRheSBhcyB0aGUgZmlyc3QgZGF5IG9mIHdlZWsgb25lICgwMC01MykKZnVuY3Rpb24gdDpVKCkKCXJldHVybiAiJTAyZCIsIGlkaXYoc2VsZi55ZGF5IC0gc2VsZi53ZGF5ICsgNywgNykKZW5kCi0tIElTTyA4NjAxIHdlZWsgbnVtYmVyICgwMC01MykKZnVuY3Rpb24gdDpWKCkKCXJldHVybiAiJTAyZCIsIHNlbGVjdCgyLCBpc29fODYwMV93ZWVrKHNlbGYpKQplbmQKLS0gV2Vla2RheSBhcyBhIGRlY2ltYWwgbnVtYmVyIHdpdGggU3VuZGF5IGFzIDAgKDAtNikKZnVuY3Rpb24gdDp3KCkKCXJldHVybiAiJWQiLCBzZWxmLndkYXkgLSAxCmVuZAotLSBXZWVrIG51bWJlciB3aXRoIHRoZSBmaXJzdCBNb25kYXkgYXMgdGhlIGZpcnN0IGRheSBvZiB3ZWVrIG9uZSAoMDAtNTMpCmZ1bmN0aW9uIHQ6VygpCglyZXR1cm4gIiUwMmQiLCBpZGl2KHNlbGYueWRheSAtIGlzb184NjAxX3dlZWtkYXkoc2VsZi53ZGF5KSArIDcsIDcpCmVuZAotLSBUT0RPIG1ha2UgdC54IGFuZCB0LlggcmVzcGVjdCBsb2NhbGUKdC54ID0gdC5ECnQuWCA9IHQuVApmdW5jdGlvbiB0OnkoKQoJcmV0dXJuICIlMDJkIiwgc2VsZi55ZWFyICUgMTAwCmVuZApmdW5jdGlvbiB0OlkoKQoJcmV0dXJuICIlZCIsIHNlbGYueWVhcgplbmQKLS0gVE9ETyB0aW1lem9uZXMKZnVuY3Rpb24gdDp6KCkgLS0gbHVhY2hlY2s6IGlnbm9yZSAyMTIKCXJldHVybiAiKzAwMDAiCmVuZApmdW5jdGlvbiB0OlooKSAtLSBsdWFjaGVjazogaWdub3JlIDIxMgoJcmV0dXJuICJHTVQiCmVuZAotLSBBIGxpdGVyYWwgJyUnIGNoYXJhY3Rlci4KdFsiJSJdID0gZnVuY3Rpb24oc2VsZikgLS0gbHVhY2hlY2s6IGlnbm9yZSAyMTIKCXJldHVybiAiJSUiCmVuZAoKbG9jYWwgZnVuY3Rpb24gc3RyZnRpbWUoZm9ybWF0X3N0cmluZywgdGltZXRhYmxlKQoJcmV0dXJuIChzdHJpbmcuZ3N1Yihmb3JtYXRfc3RyaW5nLCAiJSUoW0VPXT8pKC4pIiwgZnVuY3Rpb24obG9jYWxlX21vZGlmaWVyLCBzcGVjaWZpZXIpCgkJbG9jYWwgZnVuYyA9IHRbc3BlY2lmaWVyXQoJCWlmIGZ1bmMgdGhlbgoJCQlyZXR1cm4gc3RyZm9ybWF0KGZ1bmModGltZXRhYmxlLCBjX2xvY2FsZSkpCgkJZWxzZQoJCQllcnJvcigiaW52YWxpZCBjb252ZXJzYXRpb24gc3BlY2lmaWVyICclIi4ubG9jYWxlX21vZGlmaWVyLi5zcGVjaWZpZXIuLiInIiwgMykKCQllbmQKCWVuZCkpCmVuZAoKbG9jYWwgZnVuY3Rpb24gYXNjdGltZSh0aW1ldGFibGUpCgktLSBFcXVpdmFsZW50IHRvIHRoZSBmb3JtYXQgc3RyaW5nICIlY1xuIgoJcmV0dXJuIHN0cmZvcm1hdCh0LmModGltZXRhYmxlLCBjX2xvY2FsZSkpIC4uICJcbiIKZW5kCgpsb2NhbCBzdHJmb3JtYXQgPSBzdHJpbmcuZm9ybWF0Cgpsb2NhbCBtb25fbGVuZ3RocyA9IHszMSwgMjgsIDMxLCAzMCwgMzEsIDMwLCAzMSwgMzEsIDMwLCAzMSwgMzAsIDMxfQotLSBOdW1iZXIgb2YgZGF5cyBpbiB5ZWFyIHVudGlsIHN0YXJ0IG9mIG1vbnRoOyBub3QgY29ycmVjdGVkIGZvciBsZWFwIHllYXJzCmxvY2FsIG1vbnRoc190b19kYXlzX2N1bXVsYXRpdmUgPSB7MH0KZm9yIGkgPSAyLCAxMiBkbwoJbW9udGhzX3RvX2RheXNfY3VtdWxhdGl2ZVtpXSA9IG1vbnRoc190b19kYXlzX2N1bXVsYXRpdmVbaS0xXSArIG1vbl9sZW5ndGhzW2ktMV0KZW5kCi0tIEZvciBTYWthbW90bydzIEFsZ29yaXRobSAoZGF5IG9mIHdlZWspCmxvY2FsIHNha2Ftb3RvID0gezAsIDMsIDIsIDUsIDAsIDMsIDUsIDEsIDQsIDYsIDIsIDR9OwoKbG9jYWwgZnVuY3Rpb24gaXNfbGVhcCh5KQoJaWYgKHkgJSA0KSB+PSAwIHRoZW4KCQlyZXR1cm4gZmFsc2UKCWVsc2VpZiAoeSAlIDEwMCkgfj0gMCB0aGVuCgkJcmV0dXJuIHRydWUKCWVsc2UKCQlyZXR1cm4gKHkgJSA0MDApID09IDAKCWVuZAplbmQKCmxvY2FsIGZ1bmN0aW9uIG1vbnRoX2xlbmd0aChtLCB5KQoJaWYgbSA9PSAyIHRoZW4KCQlyZXR1cm4gaXNfbGVhcCh5KSBhbmQgMjkgb3IgMjgKCWVsc2UKCQlyZXR1cm4gbW9uX2xlbmd0aHNbbV0KCWVuZAplbmQKCmxvY2FsIGZ1bmN0aW9uIGxlYXBfeWVhcnNfc2luY2UoeWVhcikKCXJldHVybiBpZGl2KHllYXIsIDQpIC0gaWRpdih5ZWFyLCAxMDApICsgaWRpdih5ZWFyLCA0MDApCmVuZAoKbG9jYWwgZnVuY3Rpb24gZGF5X29mX3llYXIoZGF5LCBtb250aCwgeWVhcikKCWxvY2FsIHlkYXkgPSBtb250aHNfdG9fZGF5c19jdW11bGF0aXZlW21vbnRoXQoJaWYgbW9udGggPiAyIGFuZCBpc19sZWFwKHllYXIpIHRoZW4KCQl5ZGF5ID0geWRheSArIDEKCWVuZAoJcmV0dXJuIHlkYXkgKyBkYXkKZW5kCgpsb2NhbCBmdW5jdGlvbiBkYXlfb2Zfd2VlayhkYXksIG1vbnRoLCB5ZWFyKQoJaWYgbW9udGggPCAzIHRoZW4KCQl5ZWFyID0geWVhciAtIDEKCWVuZAoJcmV0dXJuKHllYXIgKyBsZWFwX3llYXJzX3NpbmNlKHllYXIpICsgc2FrYW1vdG9bbW9udGhdICsgZGF5KSAlIDcgKyAxCmVuZAoKbG9jYWwgZnVuY3Rpb24gYm9ycm93KHRlbnMsIHVuaXRzLCBiYXNlKQoJbG9jYWwgZnJhYyA9IHRlbnMgJSAxCgl1bml0cyA9IHVuaXRzICsgZnJhYyAqIGJhc2UKCXRlbnMgPSB0ZW5zIC0gZnJhYwoJcmV0dXJuIHRlbnMsIHVuaXRzCmVuZAoKbG9jYWwgZnVuY3Rpb24gY2FycnkodGVucywgdW5pdHMsIGJhc2UpCglpZiB1bml0cyA+PSBiYXNlIHRoZW4KCQl0ZW5zICA9IHRlbnMgKyBpZGl2KHVuaXRzLCBiYXNlKQoJCXVuaXRzID0gdW5pdHMgJSBiYXNlCgllbHNlaWYgdW5pdHMgPCAwIHRoZW4KCQl0ZW5zICA9IHRlbnMgKyBpZGl2KHVuaXRzLCBiYXNlKQoJCXVuaXRzID0gKGJhc2UgKyB1bml0cykgJSBiYXNlCgllbmQKCXJldHVybiB0ZW5zLCB1bml0cwplbmQKCi0tIE1vZGlmeSBwYXJhbWV0ZXJzIHNvIHRoZXkgYWxsIGZpdCB3aXRoaW4gdGhlICJub3JtYWwiIHJhbmdlCmxvY2FsIGZ1bmN0aW9uIG5vcm1hbGlzZSh5ZWFyLCBtb250aCwgZGF5LCBob3VyLCBtaW4sIHNlYykKCS0tIGBtb250aGAgYW5kIGBkYXlgIHN0YXJ0IGZyb20gMSwgbmVlZCAtMSBhbmQgKzEgc28gaXQgd29ya3MgbW9kdWxvCgltb250aCwgZGF5ID0gbW9udGggLSAxLCBkYXkgLSAxCgoJLS0gQ29udmVydCBldmVyeXRoaW5nIChleGNlcHQgc2Vjb25kcykgdG8gYW4gaW50ZWdlcgoJLS0gYnkgcHJvcGFnYXRpbmcgZnJhY3Rpb25hbCBjb21wb25lbnRzIGRvd24uCgl5ZWFyICwgbW9udGggPSBib3Jyb3coeWVhciAsIG1vbnRoLCAxMikKCS0tIENhcnJ5IGZyb20gbW9udGggdG8geWVhciBmaXJzdCwgc28gd2UgZ2V0IG1vbnRoIGxlbmd0aCBjb3JyZWN0IGluIG5leHQgbGluZSBhcm91bmQgbGVhcCB5ZWFycwoJeWVhciAsIG1vbnRoID0gY2FycnkoeWVhciwgbW9udGgsIDEyKQoJbW9udGgsIGRheSAgID0gYm9ycm93KG1vbnRoLCBkYXkgICwgbW9udGhfbGVuZ3RoKGZsb29yKG1vbnRoICsgMSksIHllYXIpKQoJZGF5ICAsIGhvdXIgID0gYm9ycm93KGRheSAgLCBob3VyICwgMjQpCglob3VyICwgbWluICAgPSBib3Jyb3coaG91ciAsIG1pbiAgLCA2MCkKCW1pbiAgLCBzZWMgICA9IGJvcnJvdyhtaW4gICwgc2VjICAsIDYwKQoKCS0tIFByb3BhZ2F0ZSBvdXQgb2YgcmFuZ2UgdmFsdWVzIHVwCgktLSBlLmcuIGlmIGBtaW5gIGlzIDcwLCBgaG91cmAgaW5jcmVtZW50cyBieSAxIGFuZCBgbWluYCBiZWNvbWVzIDEwCgktLSBUaGlzIGhhcyB0byBoYXBwZW4gZm9yIGFsbCBjb2x1bW5zIGFmdGVyIGJvcnJvd2luZywgYXMgbG93ZXIgcmFkaXhlcyBtYXkgYmUgcHVzaGVkIG91dCBvZiByYW5nZQoJbWluICAsIHNlYyAgID0gY2FycnkobWluICwgc2VjICwgNjApIC0tIFRPRE86IGNvbnNpZGVyIGxlYXAgc2Vjb25kcz8KCWhvdXIgLCBtaW4gICA9IGNhcnJ5KGhvdXIsIG1pbiAsIDYwKQoJZGF5ICAsIGhvdXIgID0gY2FycnkoZGF5ICwgaG91ciwgMjQpCgktLSBFbnN1cmUgYGRheWAgaXMgbm90IHVuZGVyZmxvd2VkCgktLSBBZGQgYSB3aG9sZSB5ZWFyIG9mIGRheXMgYXQgYSB0aW1lLCB0aGlzIGlzIGxhdGVyIHJlc29sdmVkIGJ5IGFkZGluZyBtb250aHMKCS0tIFRPRE9bT1BUSU1JWkVdOiBUaGlzIGNvdWxkIGJlIHNsb3cgaWYgYGRheWAgaXMgZmFyIG91dCBvZiByYW5nZQoJd2hpbGUgZGF5IDwgMCBkbwoJCW1vbnRoID0gbW9udGggLSAxCgkJaWYgbW9udGggPCAwIHRoZW4KCQkJeWVhciA9IHllYXIgLSAxCgkJCW1vbnRoID0gMTEKCQllbmQKCQlkYXkgPSBkYXkgKyBtb250aF9sZW5ndGgobW9udGggKyAxLCB5ZWFyKQoJZW5kCgl5ZWFyLCBtb250aCA9IGNhcnJ5KHllYXIsIG1vbnRoLCAxMikKCgktLSBUT0RPW09QVElNSVpFXTogVGhpcyBjb3VsZCBwb3RlbnRpYWxseSBiZSBzbG93IGlmIGBkYXlgIGlzIHZlcnkgbGFyZ2UKCXdoaWxlIHRydWUgZG8KCQlsb2NhbCBpID0gbW9udGhfbGVuZ3RoKG1vbnRoICsgMSwgeWVhcikKCQlpZiBkYXkgPCBpIHRoZW4gYnJlYWsgZW5kCgkJZGF5ID0gZGF5IC0gaQoJCW1vbnRoID0gbW9udGggKyAxCgkJaWYgbW9udGggPj0gMTIgdGhlbgoJCQltb250aCA9IDAKCQkJeWVhciA9IHllYXIgKyAxCgkJZW5kCgllbmQKCgktLSBOb3cgd2UgY2FuIHBsYWNlIGBkYXlgIGFuZCBgbW9udGhgIGJhY2sgaW4gdGhlaXIgbm9ybWFsIHJhbmdlcwoJLS0gZS5nLiBtb250aCBhcyAxLTEyIGluc3RlYWQgb2YgMC0xMQoJbW9udGgsIGRheSA9IG1vbnRoICsgMSwgZGF5ICsgMQoKCXJldHVybiB5ZWFyLCBtb250aCwgZGF5LCBob3VyLCBtaW4sIHNlYwplbmQKCmxvY2FsIGxlYXBfeWVhcnNfc2luY2VfMTk3MCA9IGxlYXBfeWVhcnNfc2luY2UoMTk3MCkKbG9jYWwgZnVuY3Rpb24gdGltZXN0YW1wKHllYXIsIG1vbnRoLCBkYXksIGhvdXIsIG1pbiwgc2VjKQoJeWVhciwgbW9udGgsIGRheSwgaG91ciwgbWluLCBzZWMgPSBub3JtYWxpc2UoeWVhciwgbW9udGgsIGRheSwgaG91ciwgbWluLCBzZWMpCgoJbG9jYWwgZGF5c19zaW5jZV9lcG9jaCA9IGRheV9vZl95ZWFyKGRheSwgbW9udGgsIHllYXIpCgkJKyAzNjUgKiAoeWVhciAtIDE5NzApCgkJLS0gRWFjaCBsZWFwIHllYXIgYWRkcyBvbmUgZGF5CgkJKyAobGVhcF95ZWFyc19zaW5jZSh5ZWFyIC0gMSkgLSBsZWFwX3llYXJzX3NpbmNlXzE5NzApIC0gMQoKCXJldHVybiBkYXlzX3NpbmNlX2Vwb2NoICogKDYwKjYwKjI0KQoJCSsgaG91ciAqICg2MCo2MCkKCQkrIG1pbiAgKiA2MAoJCSsgc2VjCmVuZAoKCmxvY2FsIHRpbWV0YWJsZV9tZXRob2RzID0ge30KCmZ1bmN0aW9uIHRpbWV0YWJsZV9tZXRob2RzOnVucGFjaygpCglyZXR1cm4gYXNzZXJ0KHNlbGYueWVhciAsICJ5ZWFyIHJlcXVpcmVkIiksCgkJYXNzZXJ0KHNlbGYubW9udGgsICJtb250aCByZXF1aXJlZCIpLAoJCWFzc2VydChzZWxmLmRheSAgLCAiZGF5IHJlcXVpcmVkIiksCgkJc2VsZi5ob3VyIG9yIDEyLAoJCXNlbGYubWluICBvciAwLAoJCXNlbGYuc2VjICBvciAwLAoJCXNlbGYueWRheSwKCQlzZWxmLndkYXkKZW5kCgpmdW5jdGlvbiB0aW1ldGFibGVfbWV0aG9kczpub3JtYWxpc2UoKQoJbG9jYWwgeWVhciwgbW9udGgsIGRheQoJeWVhciwgbW9udGgsIGRheSwgc2VsZi5ob3VyLCBzZWxmLm1pbiwgc2VsZi5zZWMgPSBub3JtYWxpc2Uoc2VsZjp1bnBhY2soKSkKCglzZWxmLmRheSAgID0gZGF5CglzZWxmLm1vbnRoID0gbW9udGgKCXNlbGYueWVhciAgPSB5ZWFyCglzZWxmLnlkYXkgID0gZGF5X29mX3llYXIoZGF5LCBtb250aCwgeWVhcikKCXNlbGYud2RheSAgPSBkYXlfb2Zfd2VlayhkYXksIG1vbnRoLCB5ZWFyKQoKCXJldHVybiBzZWxmCmVuZAp0aW1ldGFibGVfbWV0aG9kcy5ub3JtYWxpemUgPSB0aW1ldGFibGVfbWV0aG9kcy5ub3JtYWxpc2UgLS0gQW1lcmljYW4gRW5nbGlzaAoKZnVuY3Rpb24gdGltZXRhYmxlX21ldGhvZHM6dGltZXN0YW1wKCkKCXJldHVybiB0aW1lc3RhbXAoc2VsZjp1bnBhY2soKSkKZW5kCgpmdW5jdGlvbiB0aW1ldGFibGVfbWV0aG9kczpyZmNfMzMzOSgpCglsb2NhbCB5ZWFyLCBtb250aCwgZGF5LCBob3VyLCBtaW4sIGZzZWMgPSBzZWxmOnVucGFjaygpCglsb2NhbCBzZWMsIG1zZWMgPSBib3Jyb3coZnNlYywgMCwgMTAwMCkKCW1zZWMgPSBtYXRoLmZsb29yKG1zZWMpCglyZXR1cm4gc3RyZm9ybWF0KCIlMDR1LSUwMnUtJTAydVQlMDJ1OiUwMnU6JTAyZC4lMDNkIiwgeWVhciwgbW9udGgsIGRheSwgaG91ciwgbWluLCBzZWMsIG1zZWMpCmVuZAoKZnVuY3Rpb24gdGltZXRhYmxlX21ldGhvZHM6c3RyZnRpbWUoZm9ybWF0X3N0cmluZykKCXJldHVybiBzdHJmdGltZShmb3JtYXRfc3RyaW5nLCBzZWxmKQplbmQKCmxvY2FsIHRpbWV0YWJsZV9tdAoKbG9jYWwgZnVuY3Rpb24gY29lcmNlX2FyZyh0KQoJaWYgZ2V0bWV0YXRhYmxlKHQpID09IHRpbWV0YWJsZV9tdCB0aGVuCgkJcmV0dXJuIHQ6dGltZXN0YW1wKCkKCWVuZAoJcmV0dXJuIHQKZW5kCgp0aW1ldGFibGVfbXQgPSB7CglfX2luZGV4ICAgID0gdGltZXRhYmxlX21ldGhvZHM7CglfX3Rvc3RyaW5nID0gdGltZXRhYmxlX21ldGhvZHMucmZjXzMzMzk7CglfX2VxID0gZnVuY3Rpb24oYSwgYikKCQlyZXR1cm4gYTp0aW1lc3RhbXAoKSA9PSBiOnRpbWVzdGFtcCgpCgllbmQ7CglfX2x0ID0gZnVuY3Rpb24oYSwgYikKCQlyZXR1cm4gYTp0aW1lc3RhbXAoKSA8IGI6dGltZXN0YW1wKCkKCWVuZDsKCV9fc3ViID0gZnVuY3Rpb24oYSwgYikKCQlyZXR1cm4gY29lcmNlX2FyZyhhKSAtIGNvZXJjZV9hcmcoYikKCWVuZDsKfQoKbG9jYWwgZnVuY3Rpb24gY2FzdF90aW1ldGFibGUodG0pCglyZXR1cm4gc2V0bWV0YXRhYmxlKHRtLCB0aW1ldGFibGVfbXQpCmVuZAoKbG9jYWwgZnVuY3Rpb24gbmV3X3RpbWV0YWJsZSh5ZWFyLCBtb250aCwgZGF5LCBob3VyLCBtaW4sIHNlYywgeWRheSwgd2RheSkKCXJldHVybiBjYXN0X3RpbWV0YWJsZSB7CgkJeWVhciAgPSB5ZWFyOwoJCW1vbnRoID0gbW9udGg7CgkJZGF5ICAgPSBkYXk7CgkJaG91ciAgPSBob3VyOwoJCW1pbiAgID0gbWluOwoJCXNlYyAgID0gc2VjOwoJCXlkYXkgID0geWRheTsKCQl3ZGF5ICA9IHdkYXk7Cgl9CmVuZAoKZnVuY3Rpb24gdGltZXRhYmxlX21ldGhvZHM6Y2xvbmUoKQoJcmV0dXJuIG5ld190aW1ldGFibGUoc2VsZjp1bnBhY2soKSkKZW5kCgpsb2NhbCBmdW5jdGlvbiBuZXdfZnJvbV90aW1lc3RhbXAodHMpCglpZiB0eXBlKHRzKSB+PSAibnVtYmVyIiB0aGVuCgkJZXJyb3IoImJhZCBhcmd1bWVudCAjMSB0byAnbmV3X2Zyb21fdGltZXN0YW1wJyAobnVtYmVyIGV4cGVjdGVkLCBnb3QgIiAuLiB0eXBlKHRzKSAuLiAiKSIsIDIpCgllbmQKCXJldHVybiBuZXdfdGltZXRhYmxlKDE5NzAsIDEsIDEsIDAsIDAsIHRzKTpub3JtYWxpc2UoKQplbmQKCi0tLSBQYXJzZSBhbiBSRkMgMzMzOSBkYXRldGltZSBhdCB0aGUgZ2l2ZW4gcG9zaXRpb24KLS0gUmV0dXJucyBhIHRpbWUgdGFibGUgYW5kIHRoZSBgdHpfb2Zmc2V0YAotLSBSZXR1cm4gdmFsdWUgaXMgbm90IG5vcm1hbGlzZWQgKHRoaXMgcHJlc2VydmVzIGEgbGVhcCBzZWNvbmQpCi0tIElmIHRoZSB0aW1lc3RhbXAgaXMgb25seSBwYXJ0aWFsIChpLmUuIG1pc3NpbmcgIloiIG9yIHRpbWUgb2Zmc2V0KSB0aGVuIGB0el9vZmZzZXRgIHdpbGwgYmUgbmlsCi0tIFRPRE86IFZhbGlkYXRlIGNvbXBvbmVudHMgYXJlIHdpdGhpbiB0aGVpciBib3VuZGFyeXMgKGUuZy4gMSA8PSBtb250aCA8PSAxMikKbG9jYWwgZnVuY3Rpb24gcmZjXzMzMzkoc3RyLCBpbml0KQoJbG9jYWwgeWVhciwgbW9udGgsIGRheSwgaG91ciwgbWluLCBzZWMsIHBhdHRfZW5kID0gc3RyOm1hdGNoKCJeKCVkJWQlZCVkKSUtKCVkJWQpJS0oJWQlZClbVHRdKCVkJWQlLj8lZCopOiglZCVkKTooJWQlZCkoKSIsIGluaXQpIC0tIGx1YWNoZWNrOiBpZ25vcmUgNjMxCglpZiBub3QgeWVhciB0aGVuCgkJcmV0dXJuIG5pbCwgIkludmFsaWQgUkZDIDMzMzkgdGltZXN0YW1wIgoJZW5kCgl5ZWFyICA9IHRvbnVtYmVyKHllYXIsIDEwKQoJbW9udGggPSB0b251bWJlcihtb250aCwgMTApCglkYXkgICA9IHRvbnVtYmVyKGRheSwgMTApCglob3VyICA9IHRvbnVtYmVyKGhvdXIsIDEwKQoJbWluICAgPSB0b251bWJlcihtaW4sIDEwKQoJc2VjICAgPSB0b251bWJlcihzZWMsIDEwKQoKCWxvY2FsIHR0ID0gbmV3X3RpbWV0YWJsZSh5ZWFyLCBtb250aCwgZGF5LCBob3VyLCBtaW4sIHNlYykKCglsb2NhbCB0el9vZmZzZXQKCWlmIHN0cjptYXRjaCgiXltael0iLCBwYXR0X2VuZCkgdGhlbgoJCXR6X29mZnNldCA9IDAKCWVsc2UKCQlsb2NhbCBob3VyX29mZnNldCwgbWluX29mZnNldCA9IHN0cjptYXRjaCgiXihbKy1dJWQlZCk6KCVkJWQpIiwgcGF0dF9lbmQpCgkJaWYgaG91cl9vZmZzZXQgdGhlbgoJCQl0el9vZmZzZXQgPSB0b251bWJlcihob3VyX29mZnNldCwgMTApICogMzYwMCArIHRvbnVtYmVyKG1pbl9vZmZzZXQsIDEwKSAqIDYwCgkJZWxzZSAtLSBsdWFjaGVjazogaWdub3JlIDU0MgoJCQktLSBJbnZhbGlkIFJGQyAzMzM5IHRpbWVzdGFtcCBvZmZzZXQgKHNob3VsZCBiZSBaIG9yICgrLy0paG91cjptaW4pCgkJCS0tIHR6X29mZnNldCB3aWxsIGJlIG5pbAoJCWVuZAoJZW5kCgoJcmV0dXJuIHR0LCB0el9vZmZzZXQKZW5kCgpyZXR1cm4gewoJLS0gdXNlZCBpbiB6ZW5yb29tCglmcm9tX3N0cmluZyA9IHJmY18zMzM5OwoJdG9fc3RyaW5nID0gZnVuY3Rpb24oYSkgcmV0dXJuIGE6bm9ybWFsaXNlKCk6cmZjXzMzMzkoKSBlbmQ7Cglmcm9tX3NlY29uZHMgPSBuZXdfZnJvbV90aW1lc3RhbXA7Cgl0b19zZWNvbmRzID0gZnVuY3Rpb24oYSkgcmV0dXJuIGE6bm9ybWFsaXNlKCk6dGltZXN0YW1wKCkgZW5kOwoJLS0gb3JpZ2luYWwgZnJvbSBsdWF0egoJaXNfbGVhcCA9IGlzX2xlYXA7CglkYXlfb2ZfeWVhciA9IGRheV9vZl95ZWFyOwoJZGF5X29mX3dlZWsgPSBkYXlfb2Zfd2VlazsKCW5vcm1hbGlzZSA9IG5vcm1hbGlzZTsKCXRpbWVzdGFtcCA9IHRpbWVzdGFtcDsKCW5ldyA9IG5ld190aW1ldGFibGU7CgluZXdfZnJvbV90aW1lc3RhbXAgPSBuZXdfZnJvbV90aW1lc3RhbXA7CgljYXN0ID0gY2FzdF90aW1ldGFibGU7Cgl0aW1ldGFibGVfbXQgPSB0aW1ldGFibGVfbXQ7Cn0KL3plbmNvZGUubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLV1dCi0tCi0tLSA8aDE+WmVuY29kZSBsYW5ndWFnZSBwYXJzZXI8L2gxPgotLQotLSA8YSBocmVmPSJodHRwczovL2Rldi56ZW5yb29tLm9yZy96ZW5jb2RlLyI+WmVuY29kZTwvYT4gaXMgYSBEb21haW4KLS0gU3BlY2lmaWMgTGFuZ3VhZ2UgKERTTCkgbWFkZSB0byBiZSB1bmRlcnN0b29kIGJ5IGh1bWFucy4gSXRzCi0tIHB1cnBvc2UgaXMgZGV0YWlsZWQgaW4gPGEKLS0gaHJlZj0iaHR0cHM6Ly9maWxlcy5keW5lLm9yZy96ZW5yb29tL1plbmNvZGVfV2hpdGVwYXBlci5wZGYiPnRoZQotLSBaZW5jb2RlIFdoaXRlcGFwZXI8L2E+IGFuZCBERUNPREUgRVUgcHJvamVjdC4KLS0KLS0gQG1vZHVsZSBaZW5jb2RlCi0tCi0tIEBhdXRob3IgRGVuaXMgIkphcm9taWwiIFJvaW8KLS0gQGxpY2Vuc2UgQUdQTHYzCi0tIEBjb3B5cmlnaHQgRHluZS5vcmcgZm91bmRhdGlvbiAyMDE4LTIwMjQKLS0KLS0gVGhlIFplbnJvb20gVk0gaXMgY2FwYWJsZSBvZiBwYXJzaW5nIHNwZWNpZmljIHNjZW5hcmlvcyB3cml0dGVuIGluCi0tIFplbmNvZGUgYW5kIGV4ZWN1dGUgaGlnaC1sZXZlbCBjcnlwdG9ncmFwaGljIG9wZXJhdGlvbnMgZGVzY3JpYmVkCi0tIGluIHRoZW07IHRoaXMgaXMgdG8gZmFjaWxpdGF0ZSB0aGUgaW50ZWdyYXRpb24gb2YgY29tcGxleAotLSBvcGVyYXRpb25zIGluIHNvZnR3YXJlIGFuZCB0aGUgbm9uLWxpdGVyYXRlIHVuZGVyc3RhbmRpbmcgb2Ygd2hhdCBhCi0tIGRpc3RyaWJ1dGVkIGFwcGxpY2F0aW9uIGRvZXMuCi0tCi0tIFRoaXMgc2VjdGlvbiBkb2Vzbid0IHByb3ZpZGUgdGhlIGRvY3VtZW50YXRpb24gb24gaG93IHRvIHdyaXRlCi0tIFplbmNvZGUuIFJlZmVyIHRvIHRoZSBsaW5rcyBhYm92ZSB0byBsZWFybiBpdC4gVGhpcyBkb2N1bWVudGF0aW9uCi0tIGNvbnRpbnVlcyB0byBpbGx1c3RyYXRlIGludGVybmFsczogaG93IHRoZSBaZW5jb2RlIGRpcmVjdC1zeW50YXgKLS0gcGFyc2VyIGlzIG1hZGUsIGhvdyBpdCBpbnRlZ3JhdGVzIGluIHRoZSBaZW5yb29tIG1lbW9yeSBtb2RlbC4KCi0tIFRoaXMgaXMgYWxzbyB0aGUgcmVmZXJlbmNlIGltcGxlbWVudGF0aW9uIHRvIGxlYXJuIGhvdyB0byBjb2RlCi0tIFplbmNvZGUgc2ltcGxlIHNjZW5hcmlvIHVzaW5nIFplcm9vbSdzIEx1YS4KLS0KLS0gQG1vZHVsZSBaZW5jb2RlCgpaRU4gPSB7CglnaXZlbl9zdGVwcyA9IHt9LAoJd2hlbl9zdGVwcyA9IHt9LAoJaWZfc3RlcHMgPSB7fSwKCWVuZGlmX3N0ZXBzID0geyBlbmRpZiA9IGZ1bmN0aW9uKCkgcmV0dXJuIGVuZCB9LCAtLW5vcAoJZm9yZWFjaF9zdGVwcyA9IHt9LAoJZW5kZm9yZWFjaF9zdGVwcyA9IHsgZW5kZm9yZWFjaCA9IGZ1bmN0aW9uKCkgcmV0dXJuIGVuZCB9LCAtLW5vcAoJdGhlbl9zdGVwcyA9IHt9LAoJc2NoZW1hcyA9IHt9LAoJYnJhbmNoID0gMCwKCWJyYW5jaF92YWxpZCA9IDAsCglpZCA9IDAsCgljaGVja3MgPSB7dmVyc2lvbiA9IGZhbHNlfSwgLS0gdmVyc2lvbiwgc2NlbmFyaW8gY2hlY2tlZCwgZXRjLgoJT0sgPSB0cnVlLCAtLSBzZXQgZmFsc2UgYnkgYXNzZXJ0cwoJanVtcCA9IG5pbCwKCUlURVJfcHJlc2VudCA9IGZhbHNlLAoJQlJBTkNIX3ByZXNlbnQgPSBmYWxzZSwKCUlURVIgPSB7fSwgLS0gZm9yZWFjaCBpbmZvcywKCUlURVJfcGFyc2UgPSB7fSwKCUlURVJfaGVhZCA9IG5pbCwKCXRyYWNlYmFjayA9IHt9LCAtLSB0cmFuc2ZlcnJlZCBpbnRvIEhFQVAgYnkgemVuY29kZV9iZWdpbgoJbGluZW51bSA9IDAsCglsYXN0X3ZhbGlkX3N0YXRlbWVudCA9IGZhbHNlLAoJcGhhc2UgPSAiZyIKfQoKbG9jYWwgX19tYXhtZW0gPGNvbnN0PiA9IF9HWydNQVhNRU0nXQpsb2NhbCBmdW5jdGlvbiBnYygpCglpZiBjb2xsZWN0Z2FyYmFnZSdjb3VudCcgPiBfX21heG1lbSB0aGVuCgkJY29sbGVjdGdhcmJhZ2UnY29sbGVjdCcKCWVuZAplbmQKCgpmdW5jdGlvbiBaRU46YWRkX3NjaGVtYShhcnIpCglsb2NhbCBfaWxsZWdhbF9zY2hlbWFzID0gewoJCS0tIGNvbnN0CgkJd2hvYW1pID0gdHJ1ZQoJfQoJZm9yIGssIHYgaW4gcGFpcnMoYXJyKSBkbwoJCS0tIGNoZWNrIG92ZXJ3cml0ZSAvIGR1cGxpY2F0ZSB0byBhdm9pZCBzY2VuYXJpbyBuYW1lc3BhY2UgY2xhc2gKCQlpZiBzZWxmLnNjaGVtYXNba10gdGhlbgoJCQllcnJvcignQWRkIHNjaGVtYSBkZW5pZWQsIGFscmVhZHkgcmVnaXN0ZXJlZCBzY2hlbWE6ICcgLi4gaywgMikKCQllbmQKCQlpZiBfaWxsZWdhbF9zY2hlbWFzW2tdIHRoZW4KCQkJZXJyb3IoJ0FkZCBzY2hlbWEgZGVuaWVkLCByZXNlcnZlZCBuYW1lOiAnIC4uIGssIDIpCgkJZW5kCgkJc2VsZi5zY2hlbWFzW2tdID0gdgoJZW5kCmVuZAoKZnVuY3Rpb24gWkVOOmJlZ2luKG5ld19oZWFwKQogICBzZWxmOmNydW1iKCkKICAgaWYgbmV3X2hlYXAgdGhlbgoJICAtLSBUT0RPOiBzZXR1cCB3aXRoIGFuIGV4aXN0aW5nIEhFQVAKICAgZWxzZQoJICBJTiAgPSB7fSAtLSBHaXZlbiBwcm9jZXNzaW5nLCBpbXBvcnQgZ2xvYmFsIERBVEEgZnJvbSBqc29uCgkgIEFDSyA9IHt9IC0tIFdoZW4gcHJvY2Vzc2luZywgIGRlc3RpbmF0aW9uIGZvciBwdXNoKgoJICBPVVQgPSB7fSAtLSBwcmludCBvdXQKCSAgQ09ERUMgPSB7fSAtLSBtZXRhZGF0YQoJICBDQUNIRSA9IHt9IC0tIGNvbnRyYWN0LXdpZGUgY29tcHV0YXRpb24gY2FjaGUKCSAgV0hPID0gbmlsCgkgIHRyYWNlYmFjayA9IHt9CiAgIGVuZAoKCS0tIHN0YXRlRGlhZ3JhbQogICAgLS0gWypdIC0tPiBHaXZlbgogICAgLS0gR2l2ZW4gLS0+IFdoZW4KICAgIC0tIFdoZW4gLS0+IFRoZW4KICAgIC0tIHN0YXRlIGJyYW5jaCB7CiAgICAtLSAgICAgSUYKICAgIC0tICAgICB3aGVuIHRoZW4KICAgIC0tICAgICAtLQogICAgLS0gICAgIEVuZElGCiAgICAtLSB9CiAgICAtLSBXaGVuIC0tPiBicmFuY2gKICAgIC0tIGJyYW5jaCAtLT4gV2hlbgogICAgLS0gVGhlbiAtLT4gWypdCgoJbG9jYWwgZnVuY3Rpb24gc2V0X3NlbnRlbmNlKHNlbGYsIGV2ZW50LCBmcm9tLCB0bywgY3R4KQoJICAgbG9jYWwgdHJhbnNsYXRlIDxjb25zdD4gPSB7CgkJICB3aGVuaWYgPSAnd2hlbicsCgkJICB0aGVuaWYgPSAndGhlbicsCgkJICB3aGVuZm9yZWFjaCA9ICd3aGVuJywKCQkgIHdoZW5mb3JlYWNoaWYgPSAnd2hlbicsCgkJICB3aGVuaWZmb3JlYWNoID0gJ3doZW4nLAoJCSAgZm9yZWFjaGlmID0gJ2ZvcmVhY2gnLAoJCSAgaWZmb3JlYWNoID0gJ2lmJwoJICAgfQoJICAgbG9jYWwgY3VycmVudCA8Y29uc3Q+ID0gc2VsZi5jdXJyZW50CgkgICBsb2NhbCBpbmRleCA8Y29uc3Q+ID0gdHJhbnNsYXRlW2N1cnJlbnRdIG9yIGN1cnJlbnQKCSAgIC0tIHNhdmUgaW4gcmVnIGEgcG9pbnRlciB0byBhcnJheSBvZiBzdGF0ZW1lbnRzCgkgICBsb2NhbCByZWcgPGNvbnN0PiA9IGN0eC5aW2luZGV4IC4uICdfc3RlcHMnXQoJICAgbG9jYWwgc2VudGVuY2UgPGNvbnN0PiA9IGN0eC5tc2cKCSAgIGxvY2FsIGxpbmVudW0gPGNvbnN0PiA9IGN0eC5aLmxpbmVudW0KCSAgIGN0eC5aLk9LID0gZmFsc2UKCSAgIHh4eCgnWmVuY29kZSBwYXJzZXIgZnJvbTogJyAuLiBmcm9tIC4uICIgdG86ICIuLnRvLCAzKQoJICAgYXNzZXJ0KHJlZywnQ2FsbGJhY2sgcmVnaXN0ZXIgbm90IGZvdW5kOiAnIC4uIGN1cnJlbnQpCgkgICAtLSBhc3NlcnQoI3JlZywnQ2FsbGJhY2sgcmVnaXN0ZXIgZW1wdHk6ICcuLmN1cnJlbnQpCgkgICBsb2NhbCBnc3ViIDxjb25zdD4gPSBzdHJpbmcuZ3N1YiAtLSBvcHRpbWl6YXRpb24KCSAgIC0tIFRPRE86IG9wdGltaXplIGluIEMKCSAgIC0tIHJlbW92ZSAnJyBjb250ZW50cywgbG93ZXIgZXZlcnl0aGluZywgZXhwdW5nZSBwcmVmaXhlcwoJICAgLS0gaWdub3JlICd0aGUnIG9ubHkgaW4gVGhlbiBzdGF0ZW1lbnRzCgkgICBsb2NhbCB0dCA9IGdzdWIoc2VudGVuY2UsICInKC4tKSciLCAiJyciKSAtLSBtc2cgdHJpbW1lZCBvbiBwYXJzZQoJICAgdHQgPSBnc3ViKHR0LCAnIEkgJywgJyAnLCAxKSAtLSBlbGltaW5hdGUgZmlyc3QgcGVyc29uIHByb25vdW4KCSAgIHR0ID0gdHQ6bG93ZXIoKSAtLSBsb3dlcmNhc2UgYWxsIHN0YXRlbWVudAoJICAgaWYgdG8gPT0gJ3RoZW4nIG9yIHRvID09ICd0aGVuaWYnIHRoZW4KCQkgIHR0ID0gZ3N1Yih0dCwgJyB0aGUgJywgJyAnLCAxKQoJICAgZW5kCgkgICBpZiB0byA9PSAnZ2l2ZW4nIHRoZW4KCQkgIHR0ID0gZ3N1Yih0dCwgJyB0aGUgJywgJyAnLCAxKQoJCSAgdHQgPSBnc3ViKHR0LCAnIGEgJywgJyAnLCAxKQoJCSAgdHQgPSBnc3ViKHR0LCAnIGFuICcsICcgJywgMSkKCQkgIHR0ID0gZ3N1Yih0dCwgJyBoYXZlICcsICcgJywgMSkKCQkgIHR0ID0gZ3N1Yih0dCwgJyBrbm93biBhcyAnLCAnICcsIDEpCgkJICB0dCA9IGdzdWIodHQsICcgdmFsaWQgJywgJyAnLCAxKQoJICAgZW5kCgkgICAtLSBwcmVmaXhlcyBmb3VuZCBhdCBiZWdpbm5pbmcgb2Ygc3RhdGVtZW50CgkgICB0dCA9IGdzdWIodHQsICded2hlbiAnLCAnJywgMSkKCSAgIHR0ID0gZ3N1Yih0dCwgJ150aGVuICcsICcnLCAxKQoJICAgdHQgPSBnc3ViKHR0LCAnXmdpdmVuICcsICcnLCAxKQoJICAgdHQgPSBnc3ViKHR0LCAnXmlmICcsICcnLCAxKQoJICAgdHQgPSBnc3ViKHR0LCAnXmZvcmVhY2ggJywgJycsIDEpCgkgICB0dCA9IGdzdWIodHQsICdeYW5kICcsICcnLCAxKSAtLSBUT0RPOiBleHB1bmdlIG9ubHkgZmlyc3QgJ2FuZCcKCSAgIC0tIGdlbmVyaWMgcGFydGljbGVzCgkgICB0dCA9IGdzdWIodHQsICdedGhhdCAnLCAnICcsIDEpCgkgICB0dCA9IGdzdWIodHQsICcgdGhlICcsICcgJykKCSAgIHR0ID0gZ3N1Yih0dCwgJ15hbiAnLCAnYSAnLCAxKSAtLSBlcXVpdmFsZW5jZQoJICAgdHQgPSBnc3ViKHR0LCAnIHZhbGlkICcsICcgJywgMSkgLS0gYmFja3dhcmQgY29tcGF0ICh2MSkKCSAgIHR0ID0gZ3N1Yih0dCwgJyBhbGwgJywgJyAnLCAxKQoJICAgdHQgPSBnc3ViKHR0LCAnIGluc2lkZSAnLCAnIGluICcsIDEpIC0tIGVxdWl2YWxlbmNlCgkgICAtLSBUT0RPOiBleHBpcmUgZGVwcmVjYXRpb24gdGhlbiBhY3RpdmF0ZSBlcXVpdmFsZW5jZQoJICAgLS0gdHQgPSBnc3ViKHR0LCAnIHNpemUgJywgJyBsZW5ndGggJywgMSkKCSAgIC0tIHRyaW1taW5nCgkgICB0dCA9IGdzdWIodHQsICcgKycsICcgJykgLS0gZWxpbWluYXRlIG11bHRpcGxlIGludGVybmFsIHNwYWNlcwoJICAgdHQgPSBnc3ViKHR0LCAnXiArJywgJycpIC0tIHJlbW92ZSBpbml0aWFsIHNwYWNlcwoJICAgdHQgPSBnc3ViKHR0LCAnICskJywgJycpIC0tIHJlbW92ZSBmaW5hbCBzcGFjZXMKCSAgIC0tCgkgICBsb2NhbCBmdW5jIDxjb25zdD4gPSByZWdbdHRdIC0tIGxvb2t1cCB0aGUgc3RhdGVtZW50CgkgICBpZiBmdW5jIGFuZCBsdWF0eXBlKGZ1bmMpID09ICdmdW5jdGlvbicgdGhlbgoJCSAgbG9jYWwgYXJncyA9IHt9IC0tIGhhbmRsZSBtdWx0aXBsZSBhcmd1bWVudHMgaW4gc2FtZSBzdHJpbmcKCQkgIGZvciBhcmcgaW4gc3RyaW5nLmdtYXRjaChzZW50ZW5jZSwgIicoLi0pJyIpIGRvCgkJCSAtLSBjb252ZXJ0IGFsbCBzcGFjZXMgdG8gdW5kZXJzY29yZSBpbiBhcmd1bWVudCBzdHJpbmdzCgkJCSBhcmcgPSB1c2NvcmUoYXJnLCAnICcsICdfJykKCQkJIHRhYmxlLmluc2VydChhcmdzLCBhcmcpCgkJICBlbmQKCQkgIGN0eC5aLmlkID0gY3R4LlouaWQgKyAxCgkJICAtLSBBU1QgZGF0YSBwcm90b3R5cGUKCQkgIHRhYmxlLmluc2VydCgKCQkJIEFTVCwKCQkJIHsKCQkJCWlkID0gY3R4LlouaWQsIC0tIG9yZGVyZWQgbnVtYmVyCgkJCQlhcmdzID0gYXJncywgLS0gYXJyYXkgb2YgdmFycwoJCQkJc291cmNlID0gc2VudGVuY2UsIC0tIHNvdXJjZSB0ZXh0CgkJCQlzZWN0aW9uID0gY3VycmVudCwKCQkJCWZyb20gPSBmcm9tLAoJCQkJdG8gPSB0bywKCQkJCWhvb2sgPSBmdW5jLAoJCQkJbGluZW51bSA9IGxpbmVudW0sCgkJCQlmID0gaW5kZXggPT0gJ2ZvcmVhY2gnIG9yIG5pbCwKCQkJCWVmID0gaW5kZXggPT0gJ2VuZGZvcmVhY2gnIG9yIG5pbCwKCQkJCWkgPSBpbmRleCA9PSAnaWYnIG9yIG5pbCwKCQkJCWVpID0gaW5kZXggPT0gJ2VuZGlmJyBvciBuaWwKCQkJIH0KCQkgICkgLS0gZnVuY3Rpb24KCQkgIGlmIGluZGV4ID09ICdmb3JlYWNoJyB0aGVuCgkJCWN0eC5aLklURVJfcHJlc2VudCA9IHRydWUKCQkJY3R4LlouSVRFUltjdHguWi5pZF0gPSB7IGp1bXAgPSBjdHguWi5pZCwgcG9zID0gMSB9CgkJCXRhYmxlLmluc2VydChjdHguWi5JVEVSX3BhcnNlLCBjdHguWi5pZCkKCQkgIGVsc2VpZiBpbmRleCA9PSAnZW5kZm9yZWFjaCcgdGhlbgoJCQlsb2NhbCBpZCA9IHRhYmxlLnJlbW92ZShjdHguWi5JVEVSX3BhcnNlKQoJCQljdHguWi5JVEVSW2lkXS5lbmRfaWQgPSBjdHguWi5pZAoJCSAgZW5kCgkJICBjdHguWi5CUkFOQ0hfcHJlc2VudCA9IGN0eC5aLkJSQU5DSF9wcmVzZW50IG9yIGluZGV4ID09ICdpZicKCQkgIGN0eC5aLk9LID0gdHJ1ZQoJICAgZW5kCgkgICBpZiBub3QgY3R4LlouT0sgYW5kIENPTkYucGFyc2VyLnN0cmljdF9tYXRjaCB0aGVuCgkJICBjdHguWi5kZWJ1ZygpCgkJICBleGl0Y29kZSgxKQoJCSAgZXJyb3IoJ1plbmNvZGUgbGluZSAnLi5saW5lbnVtLi4nIHBhdHRlcm4gbm90IGZvdW5kICgnLi5pbmRleC4uJyk6ICcgLi4gdHJpbShzZW50ZW5jZSksIDEpCgkJICByZXR1cm4gZmFsc2UKCSAgIGVuZAoJICAgaWYgbm90IENPTkYucGFyc2VyLnN0cmljdF9tYXRjaCB0aGVuCgkJICAgaWYgaW5kZXggPT0gJ2dpdmVuJyB0aGVuCgkJCSAgIGFzc2VydChub3QgY3R4LloubGFzdF92YWxpZF9zdGF0ZW1lbnQgb3IgY3R4LlouT0ssCgkJCQkJICAnWmVuY29kZSBsaW5lICcuLmxpbmVudW0uLicgZm91bmQgaW52YWxpZCBzdGF0ZW1lbnQgYWZ0ZXIgYSB2YWxpZCBvbmUgaW4gdGhlIGdpdmVuIHBoYXNlOiAnLi50cmltKHNlbnRlbmNlKSkKCQkgICBlbHNlaWYgaW5kZXggPT0gJ3RoZW4nIHRoZW4KCQkJICAgYXNzZXJ0KGN0eC5aLmxhc3RfdmFsaWRfc3RhdGVtZW50IG9yIG5vdCBjdHguWi5PSywKCQkJCQkgICdaZW5jb2RlIGxpbmUgJy4ubGluZW51bS4uJyBmb3VuZCB2YWxpZCBzdGF0ZW1lbnQgYWZ0ZXIgYW4gaW52YWxpZCBvbmUgaW4gdGhlIHRoZW4gcGhhc2U6ICcuLnRyaW0oc2VudGVuY2UpKQoJCSAgIGVsc2UKCQkJICAgYXNzZXJ0KGN0eC5aLk9LLCAnWmVuY29kZSBsaW5lICcuLmxpbmVudW0uLicgZm91bmQgaW52YWxpZCBzdGF0ZW1lbnQgb3V0IG9mIGdpdmVuIG9yIHRoZW4gcGhhc2U6ICcuLnRyaW0oc2VudGVuY2UpKQoJCSAgIGVuZAoJCSAgIGlmIG5vdCBjdHguWi5PSyB0aGVuCgkJCSAgIHRhYmxlLmluc2VydCh0cmFjZWJhY2ssICctJy4ubGluZW51bS4uJwknLi5zZW50ZW5jZSkKCQkJICAgZmlmKENPTkYucGFyc2VyLnN0cmljdF9wYXJzZSwgd2FybiwgZXJyb3IpKCdaZW5jb2RlIGxpbmUgJy4ubGluZW51bS4uJyBwYXR0ZXJuIGlnbm9yZWQ6ICcgLi4gc2VudGVuY2UsIDEpCgkJICAgZW5kCgkgICBlbmQKCSAgIGN0eC5aLmxhc3RfdmFsaWRfc3RhdGVtZW50ID0gY3R4LlouT0sKCSAgIHJldHVybiB0cnVlCgllbmQKCS0tIEVORCBsb2NhbCBmdW5jdGlvbiBzZXRfc2VudGVuY2UKCglsb2NhbCBmdW5jdGlvbiBzZXRfcnVsZSh0ZXh0KQoJICAgbG9jYWwgdHIgPSB0ZXh0Lm1zZzpnc3ViKCcgKycsICcgJykgLS0gZWxpbWluYXRlIG11bHRpcGxlIGludGVybmFsIHNwYWNlcwoJICAgbG9jYWwgcnVsZSA9IHN0cnRvayh0cmltKHRyKTpsb3dlcigpKQoJICAgbG9jYWwgcnVsZXMgPGNvbnN0PiA9IHsKCQkgIC0tIFRPRE86IHJ1bGUgZGVidWcgWyBmb3JtYXQgfCBlbmNvZGluZyBdCgkJICAtLSBbJ2xvYWQnXSA9IGZ1bmN0aW9uKGV4dGVuc2lvbikKCQkgIC0tCWlmIG5vdCBleHRlbnNpb24gdGhlbiByZXR1cm4gZmFsc2UgZW5kCgkJICAtLSAgYWN0KCJ6ZW5jb2RlIGV4dGVuc2lvbjogIi4uZXh0ZW5zaW9uKQoJCSAgLS0gIHJlcXVpcmUoInplbmNvZGVfIi4uZXh0ZW5zaW9uKQoJCSAgLS0gCXJldHVybiB0cnVlCgkJICAtLSBlbmQsCgkJICBbJ2NoZWNrIHZlcnNpb24nXSA9IGZ1bmN0aW9uICh2ZXJzaW9uKQoJCQkgLS0gVE9ETzogY2hlY2sgdmVyc2lvbiBvZiBydW5uaW5nIFZNCgkJCSBpZiBub3QgdmVyc2lvbiB0aGVuIHJldHVybiBmYWxzZSBlbmQKCQkJIGxvY2FsIHZlciA9IFNFTVZFUih2ZXJzaW9uKQoJCQkgaWYgdmVyID09IFpFTlJPT01fVkVSU0lPTiB0aGVuCgkJCQlhY3QoJ1plbmNvZGUgdmVyc2lvbiBtYXRjaDogJyAuLiBaRU5ST09NX1ZFUlNJT04ub3JpZ2luYWwpCgkJCSBlbHNlaWYgdmVyIDwgWkVOUk9PTV9WRVJTSU9OIHRoZW4KCQkJCXdhcm4oJ1plbmNvZGUgd3JpdHRlbiBmb3IgYW4gb2xkZXIgdmVyc2lvbjogJyAuLiB2ZXIub3JpZ2luYWwpCgkJCSBlbHNlaWYgdmVyID4gWkVOUk9PTV9WRVJTSU9OIHRoZW4KCQkJCXdhcm4oJ1plbmNvZGUgd3JpdHRlbiBmb3IgYSBuZXdlciB2ZXJzaW9uOiAnIC4uIHZlci5vcmlnaW5hbCkKCQkJIGVsc2UKCQkJCWVycm9yKCdWZXJzaW9uIGNoZWNrIGVycm9yOiAnIC4uIHZlcnNpb24pCgkJCSBlbmQKCQkJIHRleHQuWi5jaGVja3MudmVyc2lvbiA9IHRydWUKCQkJIHJldHVybiB0cnVlCgkJICBlbmQsCgkJICBbJ2lucHV0IGVuY29kaW5nJ10gPSBmdW5jdGlvbiAoZW5jb2RpbmcpCgkJCSBpZiBub3QgZW5jb2RpbmcgdGhlbiByZXR1cm4gZmFsc2UgZW5kCgkJCSBDT05GLmlucHV0LmVuY29kaW5nID0gaW5wdXRfZW5jb2RpbmcoZW5jb2RpbmcpCgkJCSByZXR1cm4gdHJ1ZSBhbmQgQ09ORi5pbnB1dC5lbmNvZGluZwoJCSAgZW5kLAoJCSAgWydpbnB1dCBmb3JtYXQnXSA9IGZ1bmN0aW9uIChmb3JtYXQpCgkJCSBpZiBub3QgZm9ybWF0IHRoZW4gcmV0dXJuIGZhbHNlIGVuZAoJCQkgQ09ORi5pbnB1dC5mb3JtYXQgPSBnZXRfZm9ybWF0KGZvcm1hdCkKCQkJIHJldHVybiB0cnVlIGFuZCBDT05GLmlucHV0LmZvcm1hdAoJCSAgZW5kLAoJCSAgWydpbnB1dCB1bnRhZ2dlZCddID0gZnVuY3Rpb24gKCkKCQkJIENPTkYuaW5wdXQudGFnZ2VkID0gZmFsc2UKCQkJIHJldHVybiB0cnVlCgkJICBlbmQsCgkJICBbJ2lucHV0IG51bWJlciddID0gZnVuY3Rpb24gKHdoYXQpCgkJCWlmIG5vdCB3aGF0IG9yIHdoYXQgfj0gJ3N0cmljdCcgdGhlbiByZXR1cm4gZmFsc2UgZW5kCgkJCUNPTkYuaW5wdXQubnVtYmVyX3N0cmljdCA9IHRydWUKCQkJcmV0dXJuIHRydWUKCQkgIGVuZCwKCQkgIFsnb3V0cHV0IGVuY29kaW5nJ10gPSBmdW5jdGlvbiAoZW5jb2RpbmcpCgkJCSBpZiBub3QgZW5jb2RpbmcgdGhlbiByZXR1cm4gZmFsc2UgZW5kCgkJCSBDT05GLm91dHB1dC5lbmNvZGluZyA9IHsgZnVuID0gZ2V0X2VuY29kaW5nX2Z1bmN0aW9uKGVuY29kaW5nKSwKCQkJCQkJCQkJICBuYW1lID0gZW5jb2RpbmcgfQoJCQkgcmV0dXJuIHRydWUgYW5kIENPTkYub3V0cHV0LmVuY29kaW5nCgkJICBlbmQsCgkJICBbJ291dHB1dCBmb3JtYXQnXSA9IGZ1bmN0aW9uIChmb3JtYXQpCgkJCSBpZiBub3QgZm9ybWF0IHRoZW4gcmV0dXJuIGZhbHNlIGVuZAoJCQkgQ09ORi5vdXRwdXQuZm9ybWF0ID0gZ2V0X2Zvcm1hdChmb3JtYXQpCgkJCSByZXR1cm4gdHJ1ZSBhbmQgQ09ORi5vdXRwdXQuZm9ybWF0CgkJICBlbmQsCgkJICBbJ291dHB1dCBzb3J0aW5nJ10gPSBmdW5jdGlvbih3aGF0KQoJCQkgaWYgd2hhdCA9PSAndHJ1ZScgdGhlbgoJCQkJQ09ORi5vdXRwdXQuc29ydGluZyA9IHRydWUKCQkJIGVsc2UKCQkJCUNPTkYub3V0cHV0LnNvcnRpbmcgPSBmYWxzZQoJCQkgZW5kCgkJCSByZXR1cm4gdHJ1ZQoJCSAgZW5kLAoJCSAgWydvdXRwdXQgdmVyc2lvbmluZyddID0gZnVuY3Rpb24gKCkKCQkJIENPTkYub3V0cHV0LnZlcnNpb25pbmcgPSB0cnVlCgkJCSByZXR1cm4gdHJ1ZQoJCSAgZW5kLAoJCSAgWyd1bmtub3duIGlnbm9yZSddID0gZnVuY3Rpb24gKCkKCQkJIENPTkYucGFyc2VyLnN0cmljdF9tYXRjaCA9IGZhbHNlCgkJCSByZXR1cm4gdHJ1ZQoJCSAgZW5kLAoJCSAgWydwYXRoIHNlcGFyYXRvciddID0gZnVuY3Rpb24gKHNlcGFyYXRvcikKCQkJaWYgbm90IHNlcGFyYXRvciBvciBzZXBhcmF0b3I6bGVuKCkgfj0gMSB0aGVuIHJldHVybiBmYWxzZSBlbmQKCQkJQ09ORi5wYXRoLnNlcGFyYXRvciA9IHNlcGFyYXRvcgoJCQlyZXR1cm4gdHJ1ZQoJCSBlbmQsCgkJICBbJ3NldCddID0gZnVuY3Rpb24gKGNvbmYsIHZhbHVlKQoJCQkgaWYgbm90IGNvbmYgb3Igbm90IHZhbHVlIHRoZW4gcmV0dXJuIGZhbHNlIGVuZAoJCQkgQ09ORltjb25mXSA9IGZpZiggdG9udW1iZXIodmFsdWUpLCB0b251bWJlcih2YWx1ZSksCgkJCQkJCQkgICBmaWYoIHZhbHVlPT0ndHJ1ZScsIHRydWUsCgkJCQkJCQkJCWZpZiggdmFsdWU9PSdmYWxzZScsIGZhbHNlLAoJCQkJCQkJCQkJIHZhbHVlKSkpCgkJCSByZXR1cm4gdHJ1ZQoJCSAgZW5kLAoJICAgfQoJICAgbG9jYWwgcmVzCgkgICBpZiBydWxlWzJdID09ICdzZXQnIHRoZW4KCQkgIHJlcyA9IHJ1bGVzW3J1bGVbMl1dKHJ1bGVbM10sIHJ1bGVbNF0pCgkgICBlbHNlCgkJICByZXMgPSBydWxlc1tydWxlWzJdLi4nICcuLnJ1bGVbM11dIGFuZCBydWxlc1tydWxlWzJdLi4nICcuLnJ1bGVbM11dKHJ1bGVbNF0pCgkgICBlbmQKCSAgIGlmIHJlcyB0aGVuIGFjdCh0ZXh0Lm1zZykgZWxzZSBlcnJvcignUnVsZSBpbnZhbGlkOiAnIC4uIHRleHQubXNnLCAzKSBlbmQKCSAgIHJldHVybiByZXMKCWVuZAoJLS0gRU5EIGxvY2FsIGZ1bmN0aW9uIHNldF9ydWxlCgoJLS0gc3RhdGUgbWFjaGluZSBjYWxsYmFjayBldmVudHMKCS0tIGdyYXBoIFRECgktLSAgICAgR2l2ZW4gLS0+IFdoZW4KCS0tICAgICBJRiAtLT4gV2hlbgoJLS0gICAgIFRoZW4gLS0+IFdoZW4KCS0tICAgICBHaXZlbiAtLT4gSUYKCS0tICAgICBXaGVuIC0tPiBJRgoJLS0gICAgIFRoZW4gLS0+IElGCgktLSAgICAgSUYgLS0+IFRoZW4KCS0tICAgICBJRiAtPiBGT1IKCS0tICAgICBXaGVuIC0+IEZPUgoJLS0gICAgIEZPUiAtPiBXaGVuCgktLSAgICAgRk9SIC0+IFRoZW4KCS0tICAgICBGT1IgLT4gSUYKCS0tICAgICBGT1IgLT4gVGhlbgoJLS0gICAgIFdoZW4gLS0+IFRoZW4KCS0tICAgICBHaXZlbiAtLT4gVGhlbgoJbG9jYWwgY2FsbGJhY2tzID0gewoJICAgLS0gbXNnIGlzIGEgdGFibGU6IHsgbXNnID0gInN0cmluZyIsIFogPSBzdGFjayAoc2VsZikgfQoJICAgb25zY2VuYXJpbyA9IGZ1bmN0aW9uKHNlbGYsIGV2ZW50LCBmcm9tLCB0bywgbXNnKQoJCSAgLS0gZmlyc3Qgd29yZCB1bnRpbCB0aGUgY29sb24KCQkgIGxvY2FsIHNjZW5hcmlvcyA9CgkJCSBzdHJ0b2soc3RyaW5nLm1hdGNoKHRyaW0obXNnLm1zZyk6bG93ZXIoKSwgJ1teOl0rJykpCgkJICBmb3Igaywgc2NlbiBpbiBpcGFpcnMoc2NlbmFyaW9zKSBkbwoJCQkgaWYgayB+PSAxIHRoZW4gLS0gc2tpcCBmaXJzdCAocHJlZml4KQoJCQkJbG9hZF9zY2VuYXJpbygnemVuY29kZV8nIC4uIHRyaW1xKHNjZW4pKQoJCQkJLS0gc2VsZjp0cmFjZSgnU2NlbmFyaW8gJyAuLiBzY2VuKQoJCQkJcmV0dXJuCgkJCSBlbmQKCQkgIGVuZAoJICAgZW5kLAoJICAgb25ydWxlID0gZnVuY3Rpb24oc2VsZiwgZXZlbnQsIGZyb20sIHRvLCBtc2cpCgkJICAtLSBwcm9jZXNzIHJ1bGVzIGltbWVkaWF0ZWx5CgkJICBpZiBtc2cgdGhlbglzZXRfcnVsZShtc2cpIGVuZAoJICAgZW5kLAoJICAgb25naXZlbiA9IHNldF9zZW50ZW5jZSwKCSAgIG9udGhlbiA9IHNldF9zZW50ZW5jZSwKCSAgIG9uYW5kID0gc2V0X3NlbnRlbmNlCgl9Cglsb2NhbCBldmVudHMgPSB7CgkgICB7bmFtZSA9ICdlbnRlcl9ydWxlJywgZnJvbSA9IHsnaW5pdCcsICdydWxlJywgJ3NjZW5hcmlvJ30sIHRvID0gJ3J1bGUnfSwKCSAgIHtuYW1lID0gJ2VudGVyX3NjZW5hcmlvJywgZnJvbSA9IHsnaW5pdCcsICdydWxlJywgJ3NjZW5hcmlvJ30sIHRvID0gJ3NjZW5hcmlvJ30sCgkgICB7bmFtZSA9ICdlbnRlcl9naXZlbicsIGZyb20gPSB7J2luaXQnLCAncnVsZScsICdzY2VuYXJpbyd9LAl0byA9ICdnaXZlbid9LAoJICAge25hbWUgPSAnZW50ZXJfZ2l2ZW4nLCBmcm9tID0geydnaXZlbid9LCB0byA9ICdnaXZlbid9LAoJICAge25hbWUgPSAnZW50ZXJfYW5kJywgZnJvbSA9ICdnaXZlbicsIHRvID0gJ2dpdmVuJ30sCgl9CglpZiBDT05GLmV4ZWMuc2NvcGUgPT0gJ2Z1bGwnIHRoZW4KCSAgIC0tIHJ1bGUgb3V0cHV0IGdpdmVuLW9ubHkKCSAgIGNhbGxiYWNrcy5vbndoZW4gPSBzZXRfc2VudGVuY2UKCSAgIGNhbGxiYWNrcy5vbmlmID0gc2V0X3NlbnRlbmNlCgkgICBjYWxsYmFja3Mub25lbmRpZiA9IHNldF9zZW50ZW5jZQoJICAgY2FsbGJhY2tzLm9ud2hlbmlmID0gc2V0X3NlbnRlbmNlCgkgICBjYWxsYmFja3Mub250aGVuaWYgPSBzZXRfc2VudGVuY2UKCSAgIGNhbGxiYWNrcy5vbmZvcmVhY2ggPSBzZXRfc2VudGVuY2UKCSAgIGNhbGxiYWNrcy5vbmVuZGZvcmVhY2ggPSBzZXRfc2VudGVuY2UKCSAgIGNhbGxiYWNrcy5vbndoZW5mb3JlYWNoID0gc2V0X3NlbnRlbmNlCgkgICBjYWxsYmFja3Mub25mb3JlYWNoaWYgPSBzZXRfc2VudGVuY2UKCSAgIGNhbGxiYWNrcy5vbndoZW5mb3JlYWNoaWYgPSBzZXRfc2VudGVuY2UKCSAgIGNhbGxiYWNrcy5vbmlmZm9yZWFjaCA9IHNldF9zZW50ZW5jZQoJICAgY2FsbGJhY2tzLm9ud2hlbmlmZm9yZWFjaCA9IHNldF9zZW50ZW5jZQoJICAgbG9jYWwgZXh0cmFfZXZlbnRzIDxjb25zdD4gPSB7CgkJICB7bmFtZSA9ICdlbnRlcl93aGVuJywgZnJvbSA9IHsnZ2l2ZW4nLCAnd2hlbicsICd0aGVuJywgJ2VuZGlmJywgJ2VuZGZvcmVhY2gnfSwgdG8gPSAnd2hlbid9LAoJCSAge25hbWUgPSAnZW50ZXJfdGhlbicsIGZyb20gPSB7J2dpdmVuJywgJ3doZW4nLCAndGhlbicsICdlbmRpZicsICdlbmRmb3JlYWNoJ30sIHRvID0gJ3RoZW4nfSwKCQkgIHtuYW1lID0gJ2VudGVyX2lmJywgZnJvbSA9IHsnaWYnLCAnZ2l2ZW4nLCAnd2hlbicsICd0aGVuJywgJ2VuZGlmJywgJ2VuZGZvcmVhY2gnLCAnd2hlbmlmJywgJ3RoZW5pZicsICdlbmRmb3JlYWNoJywgJ2ZvcmVhY2hpZid9LCB0byA9ICdpZid9LAoJCSAge25hbWUgPSAnZW50ZXJfd2hlbmlmJywgZnJvbSA9IHsnaWYnLCAnd2hlbmlmJywgJ3RoZW5pZicsICdlbmRmb3JlYWNoJywgJ2VuZGlmJ30sIHRvID0gJ3doZW5pZid9LAoJCSAge25hbWUgPSAnZW50ZXJfdGhlbmlmJywgZnJvbSA9IHsnaWYnLCAnd2hlbmlmJywgJ3RoZW5pZicsICdlbmRmb3JlYWNoJywgJ2VuZGlmJ30sIHRvID0gJ3RoZW5pZid9LAoJCSAge25hbWUgPSAnZW50ZXJfZW5kaWYnLCBmcm9tID0geyd3aGVuaWYnLCAnd2hlbmlmZm9yZWFjaCcsICd0aGVuaWYnLCAnZW5kZm9yZWFjaCcsICdlbmRpZid9LCB0byA9ICdlbmRpZid9LAoJCSAge25hbWUgPSAnZW50ZXJfZm9yZWFjaCcsIGZyb20gPSB7J2dpdmVuJywgJ3doZW4nLCAnZW5kaWYnLCAnZm9yZWFjaCcsICdlbmRmb3JlYWNoJywgJ3doZW5mb3JlYWNoJ30sIHRvID0gJ2ZvcmVhY2gnfSwKCQkgIHtuYW1lID0gJ2VudGVyX3doZW5mb3JlYWNoJywgZnJvbSA9IHsnZm9yZWFjaCcsICd3aGVuZm9yZWFjaCcsICdlbmRpZicsICdlbmRmb3JlYWNoJ30sIHRvID0gJ3doZW5mb3JlYWNoJ30sCgkJICB7bmFtZSA9ICdlbnRlcl9mb3JlYWNoaWYnLCBmcm9tID0geydpZicsICd3aGVuaWYnLCAnZW5kZm9yZWFjaCcsICdmb3JlYWNoaWYnLCAnd2hlbmZvcmVhY2hpZicsICdpZmZvcmVhY2gnLCAnd2hlbmlmZm9yZWFjaCcsICdlbmRpZid9LCB0byA9ICdmb3JlYWNoaWYnfSwKCQkgIHtuYW1lID0gJ2VudGVyX3doZW5mb3JlYWNoaWYnLCBmcm9tID0geydmb3JlYWNoaWYnLCAnd2hlbmZvcmVhY2hpZicsICdlbmRpZicsICdlbmRmb3JlYWNoJ30sIHRvID0gJ3doZW5mb3JlYWNoaWYnfSwKCQkgIHtuYW1lID0gJ2VudGVyX2lmZm9yZWFjaCcsIGZyb20gPSB7J2ZvcmVhY2gnLCAnd2hlbmZvcmVhY2gnLCAnaWZmb3JlYWNoJywgJ3doZW5pZmZvcmVhY2gnLCAnZm9yZWFjaGlmJywgJ3doZW5mb3JlYWNoaWYnLCAnZW5kaWYnLCAnZW5kZm9yZWFjaCcgfSwgdG8gPSAnaWZmb3JlYWNoJ30sCgkJICB7bmFtZSA9ICdlbnRlcl93aGVuaWZmb3JlYWNoJywgZnJvbSA9IHsnaWZmb3JlYWNoJywgJ3doZW5pZmZvcmVhY2gnLCAnZW5kZm9yZWFjaCcsICdlbmRpZid9LCB0byA9ICd3aGVuaWZmb3JlYWNoJ30sCgkJICB7bmFtZSA9ICdlbnRlcl9lbmRmb3JlYWNoJywgZnJvbSA9IHsnd2hlbmZvcmVhY2gnLCAnd2hlbmZvcmVhY2hpZicsICdlbmRpZicsICdlbmRmb3JlYWNoJ30sIHRvID0gJ2VuZGZvcmVhY2gnfSwKCQkgIHtuYW1lID0gJ2VudGVyX2FuZCcsIGZyb20gPSAnd2hlbicsIHRvID0gJ3doZW4nfSwKCQkgIHtuYW1lID0gJ2VudGVyX2FuZCcsIGZyb20gPSAndGhlbicsIHRvID0gJ3RoZW4nfSwKCQkgIHtuYW1lID0gJ2VudGVyX2FuZCcsIGZyb20gPSAnaWYnLCB0byA9ICdpZid9LAoJCSAge25hbWUgPSAnZW50ZXJfYW5kJywgZnJvbSA9ICd3aGVuaWYnLCB0byA9ICd3aGVuaWYnfSwKCQkgIHtuYW1lID0gJ2VudGVyX2FuZCcsIGZyb20gPSAndGhlbmlmJywgdG8gPSAndGhlbmlmJ30sCgkJICB7bmFtZSA9ICdlbnRlcl9hbmQnLCBmcm9tID0gJ2ZvcmVhY2gnLCB0byA9ICdmb3JlYWNoJ30sCgkJICB7bmFtZSA9ICdlbnRlcl9hbmQnLCBmcm9tID0gJ3doZW5mb3JlYWNoJywgdG8gPSAnd2hlbmZvcmVhY2gnfSwKCQkgIHtuYW1lID0gJ2VudGVyX2FuZCcsIGZyb20gPSAnZm9yZWFjaGlmJywgdG8gPSAnZm9yZWFjaGlmJ30sCgkJICB7bmFtZSA9ICdlbnRlcl9hbmQnLCBmcm9tID0gJ3doZW5mb3JlYWNoaWYnLCB0byA9ICd3aGVuZm9yZWFjaGlmJ30sCgkJICB7bmFtZSA9ICdlbnRlcl9hbmQnLCBmcm9tID0gJ2lmZm9yZWFjaCcsIHRvID0gJ2lmZm9yZWFjaCd9LAoJCSAge25hbWUgPSAnZW50ZXJfYW5kJywgZnJvbSA9ICd3aGVuaWZmb3JlYWNoJywgdG8gPSAnd2hlbmlmZm9yZWFjaCd9LAoJICAgfQoJICAgZm9yIF8sdiBpbiBwYWlycyhleHRyYV9ldmVudHMpIGRvIHRhYmxlLmluc2VydChldmVudHMsIHYpIGVuZAoJZW5kCgoJc2VsZi5tYWNoaW5lID0gTUFDSElORS5jcmVhdGUoewoJCWluaXRpYWwgPSAnaW5pdCcsCgkJZXZlbnRzID0gZXZlbnRzLAoJCWNhbGxiYWNrcyA9IGNhbGxiYWNrcwoJfSkKCWdjKCkKCS0tIFplbmNvZGUgaW5pdCB0cmFjZWJhY2sKCXJldHVybiB0cnVlCmVuZAoKLS0gcmV0dXJucyBhbiBpdGVyYXRvciBmb3IgbmV3bGluZSB0ZXJtaW5hdGlvbgpsb2NhbCBmdW5jdGlvbiB6ZW5jb2RlX25ld2xpbmVfaXRlcih0ZXh0KQoJcmV0dXJuIHRleHQ6Z21hdGNoKCJbXlxyXG5dKiIpCmVuZApsb2NhbCBmdW5jdGlvbiB6ZW5jb2RlX2lzZW1wdHkoYikKCWlmIGIgPT0gbmlsIG9yIGIgPT0gJycgdGhlbgoJCXJldHVybiB0cnVlCgllbHNlCgkJcmV0dXJuIGZhbHNlCgllbmQKZW5kCmxvY2FsIGZ1bmN0aW9uIHplbmNvZGVfaXNjb21tZW50KGIpCglsb2NhbCB4IDxjb25zdD4gPSBzdHJpbmcuc3ViKGIsMSwxKSAtLSBzdHJpbmcuY2hhcihiOmJ5dGUoMSkpCglpZiB4ID09ICcjJyB0aGVuCgkJcmV0dXJuIHRydWUKCWVsc2UKCQlyZXR1cm4gZmFsc2UKCWVuZAplbmQKbG9jYWwgZnVuY3Rpb24gZW50ZXJfYnJhbmNoaW5nX2FuZF9sb29waW5nKHR5cGUsIGluZm8sIHByZWZpeGVzLCBsbikKCWxvY2FsIGFscmVhZHlfcHJlZml4ID0gcHJlZml4ZXNbMV0gPT0gdHlwZQoJaWYgbm90IGFscmVhZHlfcHJlZml4IHRoZW4KCQl0YWJsZS5pbnNlcnQocHJlZml4ZXMsIDEsIHR5cGUpCgllbmQKCXRhYmxlLmluc2VydChpbmZvLCB7IGxuLCBhbHJlYWR5X3ByZWZpeCB9KQoJcmV0dXJuIHByZWZpeGVzWzFdLi4ocHJlZml4ZXNbMl0gb3IgJycpCmVuZAoKbG9jYWwgZnVuY3Rpb24gZW5kX2JyYW5jaGluZ19hbmRfbG9vcGluZyh0eXBlLCBpbmZvLCBwcmVmaXhlcywgbG4pCglsb2NhbCBuID0gZmlmKHR5cGUgPT0gJ2lmJywgJ2JyYW5jaGluZycsICdsb29wJykKCWlmICNpbmZvID09IDAgdGhlbgoJCWVycm9yKCdJdmFsaWQgJy4ubi4uJyBjbG9zaW5nIGF0IGxpbmUgJy4ubG4uLic6IG5vdGhpbmcgdG8gYmUgY2xvc2VkJywgMikKCWVsc2VpZiBwcmVmaXhlc1sxXSB+PSB0eXBlIHRoZW4KCQllcnJvcignSW52YWxpZCAnLi5uLi4nIGNsb3NpbmcgYXQgbGluZSAnLi5sbi4uJzogbmVlZCB0byBjbG9zZSBmaXJzdCB0aGUgJy4ucHJlZml4ZXNbMV0sIDIpCgllbmQKCWxvY2FsIHJtID0gdGFibGUucmVtb3ZlKGluZm8pCglpZiBub3Qgcm1bMl0gdGhlbgoJCXRhYmxlLnJlbW92ZShwcmVmaXhlcywgMSkKCWVuZAplbmQKbG9jYWwgZnVuY3Rpb24gY2hlY2tfb3Blbl9icmFuY2hpbmdfb3JfbG9vcGluZyh0eXBlLCBpbmZvKQoJaWYgI2luZm8gPT0gMCB0aGVuIHJldHVybiBlbmQKCWxvY2FsIGVycl9saW5lcyA9IHt9Cglmb3IgXywgdiBpbiBwYWlycyhpbmZvKSBkbwoJCXRhYmxlLmluc2VydChlcnJfbGluZXMsIHZbMV0pCgllbmQKCWVycm9yKCdJbnZhbGlkICcuLnR5cGUuLicgb3BlbmVkIGF0IGxpbmUgJy4udGFibGUuY29uY2F0KGVycl9saW5lcywgJywgJykuLicgYW5kIG5ldmVyIGNsb3NlZCcsIDIpCmVuZAoKZnVuY3Rpb24gWkVOOnBhcnNlKHRleHQpCiAgIHNlbGY6Y3J1bWIoKQogICBpZiAjdGV4dCA8IDkgdGhlbiAtLSBzdHJsZW4oImFuZCBkZWJ1ZyIpID09IDkKCSAgZXJyb3IoIlplbmNvZGUgdGV4dCB0b28gc2hvcnQgdG8gcGFyc2UiKQoJICByZXR1cm4gZmFsc2UKICAgZW5kCiAgIGxvY2FsIGJyYW5jaGluZyA9IHt9CiAgIGxvY2FsIGxvb3BpbmcgPSB7fQogICBsb2NhbCBwcmVmaXhlcyA9IHt9CiAgIGxvY2FsIHBhcnNlX3ByZWZpeCA8Y29uc3Q+ID0gcGFyc2VfcHJlZml4IC0tIG9wdGltaXphdGlvbgogICBsb2NhbCBsYXN0X3ByZWZpeAogICBzZWxmLmxpbmVudW0gPSAwCiAgIGxvY2FsIHJlcyA9IGZpZihDT05GLnBhcnNlci5zdHJpY3RfcGFyc2UsIHRydWUsIHsgaWdub3JlZD17fSwgaW52YWxpZD17fSB9KQogICBmb3IgbGluZSBpbiB6ZW5jb2RlX25ld2xpbmVfaXRlcih0ZXh0KSBkbwoJICBzZWxmLmxpbmVudW0gPSBzZWxmLmxpbmVudW0gKyAxCgkgIGxvY2FsIHRsaW5lID0gdHJpbShsaW5lKSAtLSBzYXZlcyB0cmltcyBpbiBpc2VtcHR5IC8gaXNjb21tZW50CgkgIGlmIG5vdCB6ZW5jb2RlX2lzZW1wdHkodGxpbmUpIGFuZCBub3QgemVuY29kZV9pc2NvbW1lbnQodGxpbmUpIHRoZW4KCQkgLS0gICB4eHgoJ0xpbmU6ICcuLiB0ZXh0LCAzKQoJCSAtLSBtYXggbGVuZ3RoIGZvciBzaW5nbGUgemVuY29kZSBsaW5lIGlzICNkZWZpbmUgTUFYX0xJTkUKCQkgLS0gaGFyZC1jb2RlZCBpbnNpZGUgemVucm9vbS5oCgkJIGxvY2FsIHByZWZpeCA9IHBhcnNlX3ByZWZpeChsaW5lKSAtLSB0cmltIGlzIGluY2x1ZGVkCgkJIGlmIG5vdCBwcmVmaXggdGhlbgoJCQlpZiBDT05GLnBhcnNlci5zdHJpY3RfcGFyc2UgdGhlbgoJCQkgICBlcnJvcigiSW52YWxpZCBaZW5jb2RlIGxpbmUgIi4uc2VsZi5saW5lbnVtLi4iOiAiLi5saW5lKQoJCQllbmQKCQkJdGFibGUuaW5zZXJ0KHJlcy5pbnZhbGlkLCB7bGluZSwgc2VsZi5saW5lbnVtLCAnSW52YWxpZCBaZW5jb2RlIGxpbmUnfSkKCQkgZW5kCgkJIHNlbGYuT0sgPSB0cnVlCgkJIGV4aXRjb2RlKDApCgkJIGlmIENPTkYuZXhlYy5zY29wZSA9PSAnZ2l2ZW4nIGFuZAoJCQkocHJlZml4ID09ICd3aGVuJyBvciBwcmVmaXggPT0gJ3RoZW4nCgkJCSBvciBwcmVmaXggPT0gJ2lmJyBvciBwcmVmaXggPT0gJ2ZvcmVhY2gnKSB0aGVuCgkJCWJyZWFrIC0tIHN0b3AgcGFyc2luZyBhZnRlciBnaXZlbiBibG9jawoJCSBlbmQKCgkJaWYgcHJlZml4ID09ICdpZicgb3IgKHByZWZpeCA9PSAnYW5kJyBhbmQgbGFzdF9wcmVmaXggPT0gJ2lmJykgdGhlbgoJCQlsYXN0X3ByZWZpeCA9ICdpZicKCQkJcHJlZml4ID0gZW50ZXJfYnJhbmNoaW5nX2FuZF9sb29waW5nKCdpZicsIGJyYW5jaGluZywgcHJlZml4ZXMsIHNlbGYubGluZW51bSkKCQllbHNlaWYgcHJlZml4ID09ICdmb3JlYWNoJyBvciAocHJlZml4ID09ICdhbmQnIGFuZCBsYXN0X3ByZWZpeCA9PSAnZm9yZWFjaCcpIHRoZW4KCQkJbGFzdF9wcmVmaXggPSAnZm9yZWFjaCcKCQkJcHJlZml4ID0gZW50ZXJfYnJhbmNoaW5nX2FuZF9sb29waW5nKCdmb3JlYWNoJywgbG9vcGluZywgcHJlZml4ZXMsIHNlbGYubGluZW51bSkKCQllbHNlaWYgcHJlZml4ID09ICdlbmRpZicgdGhlbgoJCQlsYXN0X3ByZWZpeCA9IHByZWZpeAoJCQllbmRfYnJhbmNoaW5nX2FuZF9sb29waW5nKCdpZicsIGJyYW5jaGluZywgcHJlZml4ZXMsIHNlbGYubGluZW51bSkKCQllbHNlaWYgcHJlZml4ID09ICdlbmRmb3JlYWNoJyB0aGVuCgkJCWxhc3RfcHJlZml4ID0gcHJlZml4CgkJCWVuZF9icmFuY2hpbmdfYW5kX2xvb3BpbmcoJ2ZvcmVhY2gnLCBsb29waW5nLCBwcmVmaXhlcywgc2VsZi5saW5lbnVtKQoJCWVsc2UKCQkJbGFzdF9wcmVmaXggPSBwcmVmaXgKCQllbmQKCQlpZiBwcmVmaXggPT0gJ3doZW4nIG9yIHByZWZpeCA9PSAndGhlbicgdGhlbgoJCQlwcmVmaXggPSBwcmVmaXggLi4gKHByZWZpeGVzWzFdIG9yICcnKS4uIChwcmVmaXhlc1syXSBvciAnJykKCQllbmQKCgkJIGlmIHByZWZpeCA9PSAid2hlbiIgb3IgcHJlZml4ID09ICJpZiIgb3IgcHJlZml4ID09ICJmb3JlYWNoIiB0aGVuCgkJCVpFTi5waGFzZSA9ICJ3IgoJCSBlbHNlaWYgcHJlZml4ID09ICJ0aGVuIiB0aGVuCgkJCVpFTi5waGFzZSA9ICJ0IgoJCSBlbmQKCQkgLS0gdHJ5IHRvIGVudGVyIHRoZSBtYWNoaW5lIHN0YXRlIG5hbWVkIGluIHByZWZpeAoJCSAtLSB4eHgoIlplbmNvZGUgbWFjaGluZSBlbnRlcl8iLi5wcmVmaXguLiI6ICIuLnRleHQsIDMpCgkJIGxvY2FsIGZtIDxjb25zdD4gPSBzZWxmLm1hY2hpbmVbImVudGVyXyIuLnByZWZpeF0KCQkgaWYgQ09ORi5wYXJzZXIuc3RyaWN0X21hdGNoID09IHRydWUgYW5kIG5vdCBmbSB0aGVuCgkJCWlmIENPTkYucGFyc2VyLnN0cmljdF9wYXJzZSB0aGVuCgkJCSAgIGVycm9yKCJJbnZhbGlkIFplbmNvZGUgcHJlZml4ICIuLnNlbGYubGluZW51bS4uIjogJyIuLmxpbmUuLiInIikKCQkJZW5kCgkJCXRhYmxlLmluc2VydChyZXMuaW52YWxpZCwge2xpbmUsIHNlbGYubGluZW51bSwgJ0ludmFsaWQgWmVuY29kZSBwcmVmaXgnfSkKCQkgZWxzZWlmIG5vdCBmbSB0aGVuCgkJCWlmIFpFTi5waGFzZSA9PSAnZycgYW5kIG5vdCBaRU4ubGFzdF92YWxpZF9zdGF0ZW1lbnQgdGhlbgoJCQkJaWYgQ09ORi5wYXJzZXIuc3RyaWN0X3BhcnNlIHRoZW4KCQkJCQl0YWJsZS5pbnNlcnQodHJhY2ViYWNrLCAnLScuLnNlbGYubGluZW51bS4uJyAgJy4ubGluZSkKCQkJCQl3YXJuKCdaZW5jb2RlIGxpbmUgJy4uc2VsZi5saW5lbnVtLi4nIHBhdHRlcm4gaWdub3JlZDogJyAuLiBsaW5lLCAxKQoJCQkJZWxzZQoJCQkJCXRhYmxlLmluc2VydChyZXMuaWdub3JlZCwge2xpbmUsIHNlbGYubGluZW51bX0pCgkJCQkgZW5kCgkJCWVsc2VpZiBaRU4ucGhhc2UgPT0gJ3QnIHRoZW4KCQkJCVpFTi5sYXN0X3ZhbGlkX3N0YXRlbWVudCA9IGZhbHNlCgkJCQlpZiBDT05GLnBhcnNlci5zdHJpY3RfcGFyc2UgdGhlbgoJCQkJCXRhYmxlLmluc2VydCh0cmFjZWJhY2ssICctJy4uc2VsZi5saW5lbnVtLi4nICAnLi5saW5lKQoJCQkJCXdhcm4oJ1plbmNvZGUgbGluZSAnLi5zZWxmLmxpbmVudW0uLicgcGF0dGVybiBpZ25vcmVkOiAnIC4uIGxpbmUsIDEpCgkJCQkgZWxzZQoJCQkJCXRhYmxlLmluc2VydChyZXMuaWdub3JlZCwge2xpbmUsIHNlbGYubGluZW51bX0pCgkJCQkgZW5kCgkJCWVsc2UKCQkJCWlmIENPTkYucGFyc2VyLnN0cmljdF9wYXJzZSB0aGVuCgkJCQkJZXJyb3IoIkludmFsaWQgWmVuY29kZSBsaW5lICIuLnNlbGYubGluZW51bS4uIjogJyIuLmxpbmUuLiInIikKCQkJCSBlbHNlCgkJCQkJdGFibGUuaW5zZXJ0KHJlcy5pbnZhbGlkLCB7bGluZSwgc2VsZi5saW5lbnVtLCAnSW52YWxpZCBaZW5jb2RlIGxpbmUnfSkKCQkJCSBlbmQKCQkJZW5kCgkJIGVsc2UKCQkJbG9jYWwgb2ssIGVyciA8Y29uc3Q+ID0gcGNhbGwoZm0sIHNlbGYubWFjaGluZSwgeyBtc2cgPSB0bGluZSwgWiA9IHNlbGYgfSkKCQkJaWYgbm90IG9rIG9yIChvayBhbmQgbm90IGVycikgdGhlbgoJCQkgICBpZiBDT05GLnBhcnNlci5zdHJpY3RfcGFyc2UgdGhlbgoJCQkJICBlcnJvcihlcnIgb3IgIkludmFsaWQgdHJhbnNpdGlvbiBmcm9tOiAiLi5zZWxmLm1hY2hpbmUuY3VycmVudC4uIiB0bzogIi4ubGluZSkKCQkJICAgZW5kCgkJCSAgIGlmIHR5cGUoZXJyKSA9PSAnc3RyaW5nJyBhbmQgZXJyLmZpbmQoZXJyLCAncGF0dGVybiBpZ25vcmVkJykgdGhlbgoJCQkJICB0YWJsZS5pbnNlcnQocmVzLmlnbm9yZWQsIHtsaW5lLCBzZWxmLmxpbmVudW19KQoJCQkgICBlbHNlCgkJCQkgIHRhYmxlLmluc2VydChyZXMuaW52YWxpZCwge2xpbmUsIHNlbGYubGluZW51bSwgZXJyIG9yICdJbnZhbGlkIHRyYW5zaXRpb24gZnJvbSAnLi5zZWxmLm1hY2hpbmUuY3VycmVudH0pCgkJCSAgIGVuZAoJCQllbmQKCQkgZW5kCgkgIGVuZAoJICAtLSBjb250aW51ZQogICBlbmQKCWNoZWNrX29wZW5fYnJhbmNoaW5nX29yX2xvb3BpbmcoJ2JyYW5jaGluZycsIGJyYW5jaGluZykKCWNoZWNrX29wZW5fYnJhbmNoaW5nX29yX2xvb3BpbmcoJ2xvb3BpbmcnLCBsb29waW5nKQoJZ2MoKQogICBpZiByZXMgPT0gdHJ1ZSB0aGVuCgkgIHJldHVybiB0cnVlCiAgIGVsc2UKCSAgcmV0dXJuIEpTT04uZW5jb2RlKHJlcykKICAgZW5kCmVuZAoKCmxvY2FsIGZ1bmN0aW9uIElOX3VzY29yZShpKQoJLS0gY29udmVydCBhbGwgZWxlbWVudCBrZXlzIG9mIElOIHRvIHVuZGVyc2NvcmUKCWxvY2FsIHJlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGkpIGRvCglpZiBsdWF0eXBlKHYpID09ICd0YWJsZScgdGhlbgoJCSByZXNbdXNjb3JlKGspXSA9IElOX3VzY29yZSh2KSAtLSByZWN1cnNpb24KCSAgZWxzZQoJCSByZXNbdXNjb3JlKGspXSA9IHYKCSAgZW5kCiAgIGVuZAogICByZXR1cm4gc2V0bWV0YXRhYmxlKHJlcywgZ2V0bWV0YXRhYmxlKGkpKQplbmQKCi0tIHJldHVybiB0cnVlOiBjYWxsZXIgc2tpcCBleGVjdXRpb24gYW5kIGdvIHRvIDo6Y29udGludWU6OgotLSByZXR1cm4gZmFsc2U6IGV4ZWN1dGUgc3RhdGVtZW50CmxvY2FsIGZ1bmN0aW9uIG1hbmFnZV9icmFuY2hpbmcoc3RhY2ssIHgpCgktLSBza2lwIGV4ZWN1dGlvbiBpZiBJZiBzdGF0ZW1lbnQgaXMgdGhlIGZpcnN0IGluIGEgZW5kZWQgbG9vcAoJaWYgc3RhY2suSVRFUl9oZWFkIGFuZCBzdGFjay5JVEVSX2hlYWQucG9zID09IDAgdGhlbiByZXR1cm4gZmFsc2UgZW5kCgoJc3RhY2suYnJhbmNoX2NvbmRpdGlvbiA9IG5pbAoJbG9jYWwgYiA9IHN0YWNrLmJyYW5jaAoJbG9jYWwgdiA9IHN0YWNrLmJyYW5jaF92YWxpZAoJbG9jYWwgcyA9IHguc2VjdGlvbgoKCWlmIHguaSB0aGVuCgkJc3RhY2suYnJhbmNoX2NvbmRpdGlvbiA9IHRydWUKCQlzdGFjay5icmFuY2ggPSBiKzEKCQlpZiB2ID09IGIgdGhlbgoJCQlzdGFjay5icmFuY2hfdmFsaWQgPSB2KzEKCQkJcmV0dXJuIGZhbHNlCgkJZW5kCgkJcmV0dXJuIHRydWUKCWVsc2VpZiB4LmVpIHRoZW4KCQlpZiB2ID09IGIgdGhlbgoJCQlzdGFjay5icmFuY2hfdmFsaWQgPSB2LTEKCQllbmQKCQlzdGFjay5icmFuY2ggPSBiLTEKCQlyZXR1cm4gdHJ1ZQoJZW5kCglyZXR1cm4gYiB+PSAwIGFuZCBiID4gdgplbmQKCi0tIHJldHVybiB0cnVlOiBjYWxsZXIgc2tpcCBleGVjdXRpb24gYW5kIGdvIHRvIDo6Y29udGludWU6OgotLSByZXR1cm4gZmFsc2U6IGV4ZWN1dGUgc3RhdGVtZW50CmxvY2FsIGZ1bmN0aW9uIG1hbmFnZV9mb3JlYWNoKHN0YWNrLCB4LCBjaSkKCWxvY2FsIGxhc3RfaXRlciA9IHN0YWNrLklURVJfaGVhZAoJLS0gaWYgbm8gZm9yZWFjaCBpcyBkZWZpbmVkIHNraXAgYWxsCglpZiBub3QgbGFzdF9pdGVyIGFuZCBub3QgeC5mIHRoZW4gcmV0dXJuIGZhbHNlIGVuZAoJaWYgeC5mIHRoZW4KCQlpZiBsYXN0X2l0ZXIgYW5kIGxhc3RfaXRlci5wb3MgPT0gMCB0aGVuCgkJCXN0YWNrLmp1bXAgPSBsYXN0X2l0ZXIuZW5kX2lkCgkJCXJldHVybiB0cnVlCgkJZW5kCgkJc3RhY2suSVRFUl9oZWFkID0gc3RhY2suSVRFUlt4LmlkXQoJCWlmIGxhc3RfaXRlciBhbmQgc3RhY2suSVRFUl9oZWFkLnBvcyA9PSAxIHRoZW4KCQkJc3RhY2suSVRFUl9oZWFkLnBhcmVudCA9IGxhc3RfaXRlcgoJCWVuZAoJCXJldHVybiBmYWxzZQoJZWxzZWlmIHguZWYgdGhlbgoJCWlmIGxhc3RfaXRlci5wb3MgPiAwIHRoZW4KCQkJbGFzdF9pdGVyLnBvcyA9IGxhc3RfaXRlci5wb3MgKyAxCgkJCXN0YWNrLmp1bXAgPSBsYXN0X2l0ZXIuanVtcAoJCQlyZXR1cm4gdHJ1ZQoJCWVsc2UKCQkJbGFzdF9pdGVyLnBvcyA9IDEKCQkJbGFzdF9pdGVyID0gc3RhY2suSVRFUl9oZWFkLnBhcmVudAoJCQlzdGFjay5JVEVSX2hlYWQgPSBsYXN0X2l0ZXIKCQllbmQKCWVuZAoJaWYgbGFzdF9pdGVyIHRoZW4KCQlpZiBsYXN0X2l0ZXIucG9zID4gTUFYSVRFUiB0aGVuCgkJCWVycm9yKCJMaW1pdCBvZiBpdGVyYXRpb25zIGV4Y2VlZGVkOiAiIC4uIE1BWElURVIpCgkJLS0gc2tpcCBhbGwgc3RhdGVtZW50cyBvbiBsYXN0IChub3QgdmFsaWQpIGxvb3AKCQllbHNlaWYgbGFzdF9pdGVyLnBvcyA9PSAwIHRoZW4KCQkJc3RhY2suanVtcCA9IGxhc3RfaXRlci5lbmRfaWQKCQkJcmV0dXJuIHRydWUKCQllbmQKCWVuZAoJcmV0dXJuIGxhc3RfaXRlciBhbmQgbGFzdF9pdGVyLnBvcyA9PSAwCmVuZAoKbG9jYWwgZnVuY3Rpb24gQVNUX2l0ZXJhdG9yKCkKCWxvY2FsIGkgPSAwCglsb2NhbCBBU1Rfc2l6ZSA8Y29uc3Q+ID0gdGFibGVfc2l6ZShBU1QpCglsb2NhbCBtYW5hZ2UKCWlmIFpFTi5JVEVSX3ByZXNlbnQgYW5kIFpFTi5CUkFOQ0hfcHJlc2VudCB0aGVuCgkJbWFuYWdlID0gZnVuY3Rpb24oeiwgdiwgaikgcmV0dXJuIG1hbmFnZV9icmFuY2hpbmcoeiwgdikgb3IgbWFuYWdlX2ZvcmVhY2goeiwgdiwgaikgZW5kCgllbHNlaWYgWkVOLklURVJfcHJlc2VudCBhbmQgbm90IFpFTi5CUkFOQ0hfcHJlc2VudCB0aGVuCgkJbWFuYWdlID0gZnVuY3Rpb24oeiwgdiwgaikgcmV0dXJuIG1hbmFnZV9mb3JlYWNoKHosIHYsIGopIGVuZAoJZWxzZWlmIG5vdCBaRU4uSVRFUl9wcmVzZW50IGFuZCBaRU4uQlJBTkNIX3ByZXNlbnQgdGhlbgoJCW1hbmFnZSA9IGZ1bmN0aW9uKHosIHYsIGopIHJldHVybiBtYW5hZ2VfYnJhbmNoaW5nKHosIHYpIGVuZAoJZWxzZQoJCW1hbmFnZSA9IGZ1bmN0aW9uKHosIHYsIGopIHJldHVybiBmYWxzZSBlbmQKCWVuZAoJcmV0dXJuIGZ1bmN0aW9uKCkKCQlpID0gaSsxCgkJLS0gRW5kIG9mIGl0ZXJhdGlvbiAoaSBleGNlZWRzIHRoZSBBU1QgbGVuZ3RoKQoJCWlmIGkgPiBBU1Rfc2l6ZSB0aGVuCgkJCXJldHVybiBuaWwKCQllbmQKCQlsb2NhbCB2YWx1ZSA9IEFTVFtpXQoJCXdoaWxlIGkgPCBBU1Rfc2l6ZSBhbmQgbWFuYWdlKFpFTiwgdmFsdWUsIGkpIGRvCgkJCWlmIFpFTi5qdW1wIHRoZW4KCQkJCWkgPSBaRU4uanVtcCAtIDEKCQkJCVpFTi5qdW1wID0gbmlsCgkJCWVuZAoJCQlpID0gaSsxCgkJCXZhbHVlID0gQVNUW2ldCgkJZW5kCgkJcmV0dXJuIHZhbHVlCgllbmQKZW5kCgoKZnVuY3Rpb24gWkVOOnJ1bigpCiAgIHNlbGY6Y3J1bWIoKQogICBsb2NhbCBydW50aW1lX3RyYWNlID0gZnVuY3Rpb24oeCkKCSAgdGFibGUuaW5zZXJ0KHRyYWNlYmFjaywgJysnLi54LmxpbmVudW0uLicgICcuLnguc291cmNlKQogICBlbmQKICAgbG9jYWwgcnVudGltZV9lcnJvciA9IGZ1bmN0aW9uKHgsIGVycikKCSAgdGFibGUuaW5zZXJ0KHRyYWNlYmFjaywgJ1shXSBFcnJvciBhdCBaZW5jb2RlIGxpbmUgJy4ueC5saW5lbnVtKQoJICBpZiBlcnIgdGhlbiB0YWJsZS5pbnNlcnQodHJhY2ViYWNrLCAnWyFdICcuLmVycikgZW5kCiAgIGVuZAogICAtLSBydW50aW1lIGNoZWNrcwogICBpZiBub3Qgc2VsZi5jaGVja3MudmVyc2lvbiB0aGVuCgkgIHdhcm4oCgkJICdaZW5jb2RlIGlzIG1pc3NpbmcgdmVyc2lvbiBjaGVjaywgcGxlYXNlIGFkZDogcnVsZSBjaGVjayB2ZXJzaW9uIE4uTi5OJwoJICApCiAgIGVuZAogICAtLSBIRUFQIHNldHVwCiAgIGxvY2FsIHRtcAogICBpZiBFWFRSQSB0aGVuCgkgIHRtcCAgPSBDT05GLmlucHV0LmZvcm1hdC5mdW4oRVhUUkEpIG9yIHt9CgkgIGZvciBrLCB2IGluIHBhaXJzKHRtcCkgZG8KCQkgSU5ba10gPSB2CgkgIGVuZAoJICBFWFRSQSA9IG5pbAogICBlbmQKICAgaWYgREFUQSB0aGVuCgkgIHRtcCAgPSBDT05GLmlucHV0LmZvcm1hdC5mdW4oREFUQSkgb3Ige30KCSAgZm9yIGssIHYgaW4gcGFpcnModG1wKSBkbwoJCSBpZiBJTltrXSB0aGVuCgkJCWVycm9yKCJPYmplY3QgbmFtZSBjb2xsaXNpb24gaW4gaW5wdXQ6ICIuLmspCgkJIGVuZAoJCSBJTltrXSA9IHYKCSAgZW5kCgkgIERBVEEgPSBuaWwKICAgZW5kCiAgIGlmIEtFWVMgdGhlbgoJICB0bXAgID0gQ09ORi5pbnB1dC5mb3JtYXQuZnVuKEtFWVMpIG9yIHt9CgkgIGZvciBrLCB2IGluIHBhaXJzKHRtcCkgZG8KCQkgaWYgSU5ba10gdGhlbgoJCQllcnJvcigiT2JqZWN0IG5hbWUgY29sbGlzaW9uIGluIGlucHV0OiAiLi5rKQoJCSBlbmQKCQkgSU5ba10gPSB2CgkgIGVuZAoJICBLRVlTID0gbmlsCiAgIGVuZAogICB0bXAgPSBuaWwKICAgZ2MoKQoKICAgLS0gY29udmVydCBhbGwgc3BhY2VzIGluIGtleXMgdG8gdW5kZXJzY29yZQogICBJTiA9IElOX3VzY29yZShJTikKCgktLSBFWEVDIHplbmNvZGUKCWZvciB4IGluIEFTVF9pdGVyYXRvcigpIGRvCgkJLS0gdHJpZ2dlciB1cG9uIHN3aXRjaCB0byB3aGVuIG9yIHRoZW4gc2VjdGlvbgoJCWlmIHguZnJvbSA9PSAnZ2l2ZW4nIGFuZCB4LnRvIH49ICdnaXZlbicgdGhlbgoJCQktLSBkZWxldGUgSU4gbWVtb3J5CgkJCUlOID0ge30KCQkJZ2MoKQoJCWVuZAoJCS0tIEhFQVAgaW50ZWdyaXR5IGd1YXJkCgkJaWYgQ09ORi5oZWFwZ3VhcmQgdGhlbiAtLSB3YXRjaGRvZwoJCQktLSBndWFyZCBBQ0sncyBjb250ZW50cyBvbiBzZWN0aW9uIHN3aXRjaAoJCQlkZWVwbWFwKHplbmd1YXJkLCBBQ0spCgkJCS0tIGNoZWNrIHRoYXQgZXZlcnl0aGluayBpbiBIRUFQLkFDSyBoYXMgYSBDT0RFQwoJCQlzZWxmOmNvZGVjZ3VhcmQoKQoJCWVuZAoKCQlzZWxmLk9LID0gdHJ1ZQoJCWV4aXRjb2RlKDApCgkJcnVudGltZV90cmFjZSh4KQoJCWxvY2FsIG9rLCBlcnIgPGNvbnN0PiA9IHBjYWxsKHguaG9vaywgdGFibGUudW5wYWNrKHguYXJncykpCgkJaWYgbm90IG9rIG9yIG5vdCBzZWxmLk9LIHRoZW4KCQkJcnVudGltZV9lcnJvcih4LCBlcnIpCgkJCWZhdGFsKHttc2c9eC5zb3VyY2UsIGxpbmVudW09eC5saW5lbnVtfSkgLS0gdHJhY2ViYWNrIHByaW50IGluc2lkZQoJCWVuZAoJCS0tIGdpdmUgYSBub3RpY2UgYWJvdXQgdGhlIENBQ0hFIGJlaW5nIHVzZWQKCQktLSBUT0RPOiBwcmludCBpdCBpbiBkZWJ1ZwoJCWlmICNDQUNIRSA+IDAgdGhlbiB4eHgoJ0NvbnRyYWN0IENBQ0hFIGlzIGluIHVzZScpIGVuZAoJCWdjKCkKCWVuZAogICAtLSBQUklOVCBvdXRwdXQKICAgc2VsZjpmdHJhY2UoJy0tLSBaZW5jb2RlIGV4ZWN1dGlvbiBjb21wbGV0ZWQnKQogICBpZiBDT05GLmV4ZWMuc2NvcGUgPT0gJ2Z1bGwnIHRoZW4KCSAgaWYgdHlwZShPVVQpID09ICd0YWJsZScgdGhlbgoJCSBzZWxmOmZ0cmFjZSgnPDw8IEVuY29kaW5nIHsgT1VUIH0gdG8gSlNPTiAnKQoJCSAtLSB0aGlzIGlzIGFsbCBhbHJlYWR5IGVuY29kZWQKCQkgLS0gbmVlZHMgdG8gYmUgZm9ybWF0dGVkCgkJIC0tIHdhcyB1c2VkIENPTkYub3V0cHV0LmZvcm1hdC5mdW4KCQkgLS0gc3VzcGVuZGVkIHVudGlsIG1vcmUgZm9ybWF0cyBhcmUgaW1wbGVtZW50ZWQKCQkgcHJpbnQoIEpTT04uZW5jb2RlKE9VVCkgKQoJCSBzZWxmOmZ0cmFjZSgnPj4+IEVuY29kaW5nIHN1Y2Nlc3NmdWwnKQoJICBlbHNlIC0tIHRoaXMgc2hvdWxkIG5ldmVyIG9jY3VyIGluIHplbmNvZGUsIE9VVCBpcyBhbHdheXMgYSB0YWJsZQoJCSBzZWxmOmZ0cmFjZSgnPDw8IFByaW50aW5nIE9VVCAocGxhaW4gZm9ybWF0LCBub3QgYSB0YWJsZSknKQoJCSBwcmludChPVVQpCgkgIGVuZAogICBlbHNlaWYgQ09ORi5leGVjLnNjb3BlID09ICdnaXZlbicgdGhlbgoJICBwcmludChKU09OLmVuY29kZSh7Q09ERUMgPSBDT0RFQ30pKQoJICBaRU46ZGVidWcoKSAtLSBKNjQgSEVBUCBhbmQgVFJBQ0UKICAgZW5kCiAgIGVuZAoKLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBaRU5DT0RFIFdBVENIRE9HCi0tIGFzc2VydCBhbGwgdmFsdWVzIGluIHRhYmxlIGFyZSBjb252ZXJ0ZWQgdG8gemVucm9vbSB0eXBlcwotLSB1c2VkIGluIHplbmNvZGUgd2hlbiB0cmFuc2l0aW9uaW5nIG91dCBvZiBnaXZlbiBtZW1vcnkKZnVuY3Rpb24gemVuZ3VhcmQodmFsLCBrZXkpIC0tIEFLQSB3YXRjaGRvZwogICBsb2NhbCB0diA8Y29uc3Q+ID0gdHlwZSh2YWwpCiAgIGlmIG5vdCAodHYgPT0gJ2Jvb2xlYW4nIG9yIGlzemVuKHR2KSkgdGhlbgoJICAgWkVOOmRlYnVnKCkKCSAgIGVycm9yKCJaZW5ndWFyZCBkZXRlY3RlZCBhbiBpbnZhbGlkIHZhbHVlIGluIEhFQVA6ICIKCQkJIC4ua2V5Li4iICgiLi50eXBlKHZhbCkuLiIpIiwgMykKICAgICAgcmV0dXJuIG5pbAogICBlbmQKZW5kCi0tIGNvbXBhcmUgaGVhcC5BQ0sgYW5kIGhlYXAuQ09ERUMKZnVuY3Rpb24gWkVOOmNvZGVjZ3VhcmQoKQogICBsb2NhbCBsZWZ0IDxjb25zdD4gPSBBQ0sKICAgbG9jYWwgcmlnaHQgPGNvbnN0PiA9IENPREVDCiAgIGxvY2FsIGZhdGFsIDxjb25zdD4gPSBDT05GLm1pc3NpbmcuZmF0YWwKICAgZm9yIGtleTEsIHZhbHVlMSBpbiBwYWlycyhsZWZ0KSBkbwogICAgICBpZiBub3QgcmlnaHRba2V5MV0gdGhlbgoJCSBzZWxmOmRlYnVnKCkKCQkgZXJyb3IoIkludGVybmFsIG1lbW9yeSBlcnJvcjogbWlzc2luZyBDT0RFQyBmb3IgIi4ua2V5MSkKCQkgcmV0dXJuIGZhbHNlLCBrZXkxCiAgICAgIGVuZAogICAgICAtLSBUT0RPOiBiYXNlIGNoZWNrcyBpZiBDT0RFQyBtYXRjaGVzCiAgIGVuZAogICAtLSBjaGVjayBmb3IgbWlzc2luZyBrZXlzIGluIHRibDEKICAgZm9yIGtleTIsIF8gaW4gcGFpcnMocmlnaHQpIGRvCiAgICAgIGlmIG5vdCBsZWZ0W2tleTJdIGFuZCBmYXRhbCB0aGVuCgkJIHNlbGY6ZGVidWcoKQoJCSBlcnJvcigiSW50ZXJuYWwgbWVtb3J5IGVycm9yOiB1bmJvdW5kIENPREVDIGZvciAiLi5rZXkyKQoJCSByZXR1cm4gZmFsc2UsIGtleTIKICAgICAgZW5kCiAgIGVuZAogICByZXR1cm4gdHJ1ZQplbmQKCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBaRU5DT0RFIFNUQVRFTUVOVCBERUNMQVJBVElPTiBGVU5DVElPTlMKZnVuY3Rpb24gR2l2ZW4odGV4dCwgZm4pCiAgIHRleHQgPSB0ZXh0Omxvd2VyKCkKICAgaWYgWkVOLmdpdmVuX3N0ZXBzW3RleHRdIHRoZW4KCSAgZXJyb3IoJ0NvbmZsaWN0aW5nIEdJVkVOIHN0YXRlbWVudCBsb2FkZWQgYnkgc2NlbmFyaW86ICcgLi4gdGV4dCwgMikKICAgZW5kCiAgIFpFTi5naXZlbl9zdGVwc1t0ZXh0XSA9IGZuCmVuZApmdW5jdGlvbiBXaGVuKHRleHQsIGZuKQogICBpZiBaRU5DT0RFX1NDT1BFID09ICdHSVZFTicgdGhlbgoJICB0ZXh0ID0gbmlsCgkgIGZuID0gbmlsCiAgIGVsc2UKCSAgdGV4dCA9IHRleHQ6bG93ZXIoKQoJICBpZiBaRU4ud2hlbl9zdGVwc1t0ZXh0XSB0aGVuCgkJIGVycm9yKCdDb25mbGljdGluZyBXSEVOIHN0YXRlbWVudCBsb2FkZWQgYnkgc2NlbmFyaW86ICcgLi4gdGV4dCwgMikKCSAgZW5kCgkgIFpFTi53aGVuX3N0ZXBzW3RleHRdID0gZm4KICAgZW5kCmVuZApmdW5jdGlvbiBJZldoZW4odGV4dCwgZm4pCiAgIGlmIFpFTkNPREVfU0NPUEUgPT0gJ0dJVkVOJyB0aGVuCgkgIHRleHQgPSBuaWwKCSAgZm4gPSBuaWwKICAgZWxzZQoJICB0ZXh0ID0gdGV4dDpsb3dlcigpCgkgIGlmIFpFTi5pZl9zdGVwc1t0ZXh0XSB0aGVuCgkJIGVycm9yKCdDb25mbGljdGluZyBJRi1XSEVOIHN0YXRlbWVudCBsb2FkZWQgYnkgc2NlbmFyaW86ICcuLnRleHQsIDIpCgkgIGVuZAoJICBpZiBaRU4ud2hlbl9zdGVwc1t0ZXh0XSB0aGVuCgkJIGVycm9yKCdDb25mbGljdGluZyBJRi1XSEVOIHN0YXRlbWVudCBsb2FkZWQgYnkgc2NlbmFyaW86ICcuLnRleHQsIDIpCgkgIGVuZAoJICBaRU4uaWZfc3RlcHNbdGV4dF0gICA9IGZuCgkgIFpFTi53aGVuX3N0ZXBzW3RleHRdID0gZm4KICAgZW5kCmVuZApmdW5jdGlvbiBGb3JlYWNoKHRleHQsIGZuKQogICBpZiBaRU5DT0RFX1NDT1BFID09ICdHSVZFTicgdGhlbgoJICB0ZXh0ID0gbmlsCgkgIGZuID0gbmlsCiAgIGVsc2UKCSAgdGV4dCA9IHRleHQ6bG93ZXIoKQoJICBpZiBaRU4uZm9yZWFjaF9zdGVwc1t0ZXh0XSB0aGVuCgkJCWVycm9yKCdDb25mbGljdGluZyBGT1JFQUNIIHN0YXRlbWVudCBsb2FkZWQgYnkgc2NlbmFyaW86ICcgLi4gdGV4dCwgMikKCSAgZW5kCgkgIFpFTi5mb3JlYWNoX3N0ZXBzW3RleHRdID0gZm4KICAgZW5kCmVuZApmdW5jdGlvbiBUaGVuKHRleHQsIGZuKQogICBpZiBaRU5DT0RFX1NDT1BFID09ICdHSVZFTicgdGhlbgoJICB0ZXh0ID0gbmlsCgkgIGZuID0gbmlsCiAgIGVsc2UKCSAgdGV4dCA9IHRleHQ6bG93ZXIoKQoJICBpZiBaRU4udGhlbl9zdGVwc1t0ZXh0XSB0aGVuCgkJCWVycm9yKCdDb25mbGljdGluZyBUSEVOIHN0YXRlbWVudCBsb2FkZWQgYnkgc2NlbmFyaW8gOiAnIC4uIHRleHQsIDIpCgkgIGVuZAoJICBaRU4udGhlbl9zdGVwc1t0ZXh0XSA9IGZuCiAgIGVuZAplbmQKCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLQotLSBaRU5DT0RFIEdMT0JBTCBVVElMSVRJRVMKZnVuY3Rpb24gSWFtKG5hbWUpCglpZiBuYW1lIHRoZW4KCQl6ZW5jb2RlX2Fzc2VydChub3QgV0hPLCAnSWRlbnRpdHkgYWxyZWFkeSBkZWZpbmVkIGluIFdITycpCgkJemVuY29kZV9hc3NlcnQodHlwZShuYW1lKSA9PSAnc3RyaW5nJywgJ093biBuYW1lIG5vdCBhIHN0cmluZycpCgkJV0hPID0gdXNjb3JlKG5hbWUpCgllbHNlCgkJemVuY29kZV9hc3NlcnQoV0hPLCAnTm8gaWRlbnRpdHkgc3BlY2lmaWVkIGluIFdITycpCgllbmQKCWFzc2VydChaRU4uT0spCmVuZApmdW5jdGlvbiBoYXZlKG9iaikgLS0gYWNjZXB0cyBhcnJheXMgZm9yIGRlcHRoIGNoZWNrcwoJbG9jYWwgcmVzCgktLSBkZXB0aCBjaGVjayB1c2VkIGluIHBpY2sKCWlmIGx1YXR5cGUob2JqKSA9PSAndGFibGUnIHRoZW4KCQlsb2NhbCBwcmV2ID0gQUNLCgkJZm9yIGssIHYgaW4gaXBhaXJzKG9iaikgZG8KCQkJcmVzID0gcHJldlt1c2NvcmUodildCgkJCWlmIG5vdCByZXMgdGhlbgoJCQkJZXJyb3IoJ0Nhbm5vdCBmaW5kIG9iamVjdDogJyAuLiB2LCAyKQoJCQllbmQKCQkJcHJldiA9IHJlcwoJCWVuZAoJCXJldHVybiByZXMKCWVuZAoKCWxvY2FsIG5hbWUgPSB1c2NvcmUodHJpbShvYmopKQoJcmVzID0gQUNLW25hbWVdCglpZiBub3QgcmVzIHRoZW4KCSAgIGVycm9yKCdDYW5ub3QgZmluZCBvYmplY3Q6ICcgLi4gbmFtZSwgMikKCWVuZAoJbG9jYWwgY29kZWMgPSBDT0RFQ1tuYW1lXQoJaWYgbm90IGNvZGVjIHRoZW4gZXJyb3IoIkNPREVDIG5vdCBmb3VuZDogIi4ubmFtZSwgMikgZW5kCglyZXR1cm4gcmVzLCBjb2RlYwplbmQKZnVuY3Rpb24gZW1wdHkob2JqKQoJLS0gY29udmVydCBhbGwgc3BhY2VzIHRvIHVuZGVyc2NvcmUgaW4gYXJndW1lbnQKCWlmIEFDS1t1c2NvcmUob2JqKV0gdGhlbgoJCWVycm9yKCdDYW5ub3Qgb3ZlcndyaXRlIGV4aXN0aW5nIG9iamVjdDogJyAuLiBvYmosIDIpCgllbmQKZW5kCmZ1bmN0aW9uIG1heWhhdmUob2JqKQoJLS0gVE9ETzogYWNjZXB0IGFycmF5cyBmb3IgZGVwdGggY2hlY2tzIGFzIHRoZSBgaGF2ZWAgZnVuY3Rpb24KCWxvY2FsIG5hbWUgPSB1c2NvcmUodHJpbShvYmopKQoJcmVzID0gQUNLW25hbWVdCglpZiBub3QgcmVzIHRoZW4KCQl3YXJuKG5hbWUgLi4gIiBub3QgZm91bmQgaW4gREFUQSBvciBLRVlTIikKCQlyZXR1cm4gbmlsCgllbmQKCWxvY2FsIGNvZGVjID0gQ09ERUNbbmFtZV0KCWlmIG5vdCBjb2RlYyB0aGVuIGVycm9yKCJDT0RFQyBub3QgZm91bmQ6ICIuLm5hbWUsIDIpIGVuZAoJcmV0dXJuIHJlcywgY29kZWMKZW5kCgpmdW5jdGlvbiB6ZW5jb2RlX3NlcmlhbGl6ZShBKQogICBsb2NhbCB0IDxjb25zdD4gPSBsdWF0eXBlKEEpCiAgIGlmIHQgPT0gJ3RhYmxlJyB0aGVuCiAgICAgIGxvY2FsIHJlcwogICAgICByZXMgPSBzZXJpYWxpemUoQSkKICAgICAgcmV0dXJuIE9DVEVULmZyb21fc3RyaW5nKHJlcy5zdHJpbmdzKSAuLiByZXMub2N0ZXRzCiAgIGVsc2VpZiB0ID09ICdudW1iZXInIHRoZW4KICAgICAgcmV0dXJuIE8uZnJvbV9zdHJpbmcodG9zdHJpbmcoQSkpCiAgIGVsc2VpZiB0ID09ICdzdHJpbmcnIHRoZW4KICAgICAgcmV0dXJuIE8uZnJvbV9zdHJpbmcoQSkKICAgZWxzZQogICAgICBsb2NhbCB6dCA8Y29uc3Q+ID0gdHlwZShBKQogICAgICBpZiBub3QgaXN6ZW4oenQpIHRoZW4KCSBlcnJvcignQ2Fubm90IGNvbnZlcnQgdmFsdWUgdG8gb2N0ZXQ6ICcuLnp0LCAyKQogICAgICBlbmQKICAgICAgLS0gYWxsIHplbnJvb20gdHlwZXMgaGF2ZSA6b2N0ZXQoKSBtZXRob2QgdG8gZXhwb3J0CiAgICAgIHJldHVybiBBOm9jdGV0KCkKICAgZW5kCiAgIGVycm9yKCdVbmtub3duIHR5cGUsIGNhbm5vdCBjb252ZXJ0IHRvIG9jdGV0OiAnLi50eXBlKEEpLCAyKQplbmQKCnJldHVybiBaRU4KL3plbmNvZGVfYXJyYXkubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFNhdHVyZGF5LCAyN3RoIE5vdmVtYmVyIDIwMjEKLS1dXQpsb2NhbCBzdGF0cyA9IHJlcXVpcmUoJ3N0YXRzJykKLS0gYXJyYXkgb3BlcmF0aW9ucwoKV2hlbigiY3JlYXRlIG5ldyBhcnJheSIsIGZ1bmN0aW9uKCkKCUFDSy5uZXdfYXJyYXkgPSB7IH0KCW5ld19jb2RlYygnbmV3IGFycmF5Jywge3plbnR5cGU9J2EnfSkKZW5kKQoKV2hlbihkZXByZWNhdGVkKAoJCSJjcmVhdGUgY29weSBvZiBlbGVtZW50ICcnIGZyb20gYXJyYXkgJyciLAoJCSJjb3B5ICcnIGZyb20gJycgdG8gJyciLAoJCWZ1bmN0aW9uKHBvcywgYXJyKQoJCQllbXB0eSAnY29weScKCQkJbG9jYWwgc3JjLCBzcmNfY29kZWMgPSBoYXZlKGFycikKCQkJemVuY29kZV9hc3NlcnQoc3JjX2NvZGVjLnplbnR5cGUgPT0gImEiLCAiTm90IGFuIGFycmF5OiAiLi5hcnIpCgkJCWxvY2FsIG51bSA9IHRvbnVtYmVyKG1heWhhdmUocG9zKSBvciBwb3MpCgkJCXplbmNvZGVfYXNzZXJ0KG51bSwgIkFyZ3VtZW50IGlzIG5vdCBhIHBvc2l0aW9uIG51bWJlcjogIi4ucG9zKQoJCQl6ZW5jb2RlX2Fzc2VydChzcmNbbnVtXSwgIk5vIGVsZW1lbnQgZm91bmQgaW46ICIuLmFyci4uIlsiLi5wb3MuLiJdIikKCQkJQUNLLmNvcHkgPSBzcmNbbnVtXQoJCQlsb2NhbCBuX2NvZGVjID0geyBlbmNvZGluZyA9IHNyY19jb2RlYy5lbmNvZGluZyB9CgkJCS0tIHRhYmxlIG9mIHNjaGVtYXMgY2FuIG9ubHkgY29udGFpbiBlbGVtZW50cwoJCQlpZiBzcmNfY29kZWMuc2NoZW1hIHRoZW4KCQkJCW5fY29kZWMuc2NoZW1hID0gc3JjX2NvZGVjLnNjaGVtYQoJCQkJbl9jb2RlYy56ZW50eXBlID0gImUiCgkJCWVuZAoJCQluZXdfY29kZWMoJ2NvcHknLCBuX2NvZGVjKQoJCWVuZAoJKQopCgpsb2NhbCBmdW5jdGlvbiBfaW5zZXJ0X2luKHdoYXQsIGRlc3QpCglsb2NhbCBkLCBkX2NvZGVjID0gaGF2ZShkZXN0KQoJemVuY29kZV9hc3NlcnQobHVhdHlwZShkKSA9PSAndGFibGUnLAoJIkludmFsaWQgZGVzdGluYXRpb24sIG5vdCBhIHRhYmxlOiAiLi5kZXN0KQoJemVuY29kZV9hc3NlcnQoZF9jb2RlYy56ZW50eXBlID09ICdhJywKCSJJbnZhbGlkIGRlc3RpbmF0aW9uLCBub3QgYW4gYXJyYXk6ICIuLmRlc3QpCgl0YWJsZS5pbnNlcnQoQUNLW2Rlc3RdLCB3aGF0KQplbmQKCldoZW4oImluc2VydCBzdHJpbmcgJycgaW4gJyciLCBmdW5jdGlvbihzdCwgZGVzdCkKCV9pbnNlcnRfaW4oTy5mcm9tX3N0cmluZyhzdCksIGRlc3QpCmVuZCkKV2hlbigiaW5zZXJ0IHRydWUgaW4gJyciLCBmdW5jdGlvbihkZXN0KQoJX2luc2VydF9pbih0cnVlLCBkZXN0KQplbmQpCldoZW4oImluc2VydCBmYWxzZSBpbiAnJyIsIGZ1bmN0aW9uKGRlc3QpCglfaW5zZXJ0X2luKGZhbHNlLCBkZXN0KQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfYWdncl9hcnJheShhcnIpCglsb2NhbCBBID0gaGF2ZShhcnIpCglsb2NhbCBjb2RlYyA9IENPREVDW2Fycl0KCXplbmNvZGVfYXNzZXJ0KGNvZGVjLnplbnR5cGUgPT0gJ2EnLCAiT2JqZWN0IGlzIG5vdCBhIHZhbGlkIGFycmF5OiAiLi5hcnIpCglsb2NhbCBjb3VudCA9IGlzYXJyYXkoQSkKCXplbmNvZGVfYXNzZXJ0KCBjb3VudCA+IDAsICJBcnJheSBpcyBlbXB0eSBvciBpbnZhbGlkOiAiLi5hcnIpCglsb2NhbCByZXMsIHBhcgoJaWYgbHVhdHlwZShBWzFdKSA9PSAnbnVtYmVyJyB0aGVuCgkJcmVzID0gMAoJCWZvciBfLHYgaW4gbmV4dCxBLG5pbCBkbwoJCQlyZXMgPSByZXMgKyB0b251bWJlcih2KQoJCWVuZAoJCXBhciA9IHtlbmNvZGluZz0nbnVtYmVyJyx6ZW50eXBlPSdlJ30KCWVsc2VpZiB0eXBlKEFbMV0pID09ICd6ZW5yb29tLmJpZycgdGhlbgoJCXJlcyA9IEJJRy5uZXcoMCkKCQlmb3IgXyx2IGluIG5leHQsQSxuaWwgZG8KCQkJcmVzID0gcmVzICsgdgoJCWVuZAoJCXBhciA9IHtlbmNvZGluZz0naW50ZWdlcicsemVudHlwZSA9ICdlJ30KCWVsc2VpZiB0eXBlKEFbMV0pID09ICd6ZW5yb29tLmVjcCcgdGhlbgoJCXJlcyA9IEVDUC5nZW5lcmF0b3IoKQoJCWZvciBfLHYgaW4gbmV4dCxBLG5pbCBkbwoJCQlyZXMgPSByZXMgKyB2CgkJZW5kCgkJcGFyID0ge3plbnR5cGUgPSAnZSd9CgllbHNlaWYgdHlwZShBWzFdKSA9PSAnemVucm9vbS5lY3AyJyB0aGVuCgkJcmVzID0gRUNQMi5nZW5lcmF0b3IoKQoJCWZvciBfLHYgaW4gbmV4dCxBLG5pbCBkbwoJCQlyZXMgPSByZXMgKyB2CgkJZW5kCgkJcGFyID0ge3plbnR5cGUgPSAnZSd9CgllbHNlaWYgdHlwZShBWzFdKSA9PSAnemVucm9vbS5mbG9hdCcgdGhlbgoJCXJlcyA9IEYubmV3KDApCgkJZm9yIF8sdiBpbiBuZXh0LEEsbmlsIGRvCgkJCXJlcyA9IHJlcyArIHYKCQllbmQKCQlwYXIgPSB7emVudHlwZSA9ICdlJ30KCWVsc2UKCQllcnJvcigiVW5rbm93biBhZ2dyZWdhdGlvbiBmb3IgdHlwZTogIi4udHlwZShBWzFdKSkKCWVuZAoJcmV0dXJuIHJlcywgcGFyCmVuZAoKV2hlbigiY3JlYXRlIGFnZ3JlZ2F0aW9uIG9mIGFycmF5ICcnIiwgZnVuY3Rpb24oYXJyKQoJZW1wdHknYWdncmVnYXRpb24nCglsb2NhbCBwYXJhbXMKCUFDSy5hZ2dyZWdhdGlvbiwgcGFyYW1zID0gX2FnZ3JfYXJyYXkoYXJyKQoJbmV3X2NvZGVjKCdhZ2dyZWdhdGlvbicsIHBhcmFtcykKZW5kKQpXaGVuKCJjcmVhdGUgc3VtIHZhbHVlIG9mIGVsZW1lbnRzIGluIGFycmF5ICcnIiwgZnVuY3Rpb24oYXJyKQoJZW1wdHknc3VtIHZhbHVlJwoJbG9jYWwgcGFyYW1zCglBQ0suc3VtX3ZhbHVlLCBwYXJhbXMgPSBfYWdncl9hcnJheShhcnIpCgluZXdfY29kZWMoJ3N1bSB2YWx1ZScsIHBhcmFtcykKZW5kKQpXaGVuKCJjcmVhdGUgYXZlcmFnZSBvZiBlbGVtZW50cyBpbiBhcnJheSAnJyIsIGZ1bmN0aW9uKGFycikKCWVtcHR5J2F2ZXJhZ2UnCglsb2NhbCBkYXRhID0gaGF2ZShhcnIpCglBQ0suYXZlcmFnZSA9IE8uZnJvbV9zdHJpbmcoc3RhdHMuYXZlcmFnZShkYXRhKTpkZWNpbWFsKCkpCgluZXdfY29kZWMoJ2F2ZXJhZ2UnLCB7IGVuY29kaW5nPSJzdHJpbmciIH0pCmVuZCkKV2hlbigiY3JlYXRlIHZhcmlhbmNlIG9mIGVsZW1lbnRzIGluIGFycmF5ICcnIiwgZnVuY3Rpb24oYXJyKQoJZW1wdHkndmFyaWFuY2UnCglsb2NhbCBkYXRhID0gaGF2ZShhcnIpCglBQ0sudmFyaWFuY2UgPSBPLmZyb21fc3RyaW5nKHN0YXRzLnZhcmlhbmNlKGRhdGEpOmRlY2ltYWwoKSkKCW5ld19jb2RlYygndmFyaWFuY2UnLCB7IGVuY29kaW5nPSJzdHJpbmciIH0pCmVuZCkKV2hlbigiY3JlYXRlIHN0YW5kYXJkIGRldmlhdGlvbiBvZiBlbGVtZW50cyBpbiBhcnJheSAnJyIsIGZ1bmN0aW9uKGFycikKCWVtcHR5J3N0YW5kYXJkX2RldmlhdGlvbicKCWxvY2FsIGRhdGEgPSBoYXZlKGFycikKCUFDSy5zdGFuZGFyZF9kZXZpYXRpb24gPSBPLmZyb21fc3RyaW5nKHN0YXRzLnN0YW5kYXJkRGV2aWF0aW9uKGRhdGEpOmRlY2ltYWwoKSkKCW5ld19jb2RlYygnc3RhbmRhcmRfZGV2aWF0aW9uJywgeyBlbmNvZGluZz0ic3RyaW5nIiB9KQplbmQpCgpXaGVuKCJjcmVhdGUgZmxhdCBhcnJheSBvZiBjb250ZW50cyBpbiAnJyIsIGZ1bmN0aW9uKGRpYykKCWxvY2FsIGNvZGVjID0gQ09ERUNbZGljXQoJemVuY29kZV9hc3NlcnQoY29kZWMuemVudHlwZSA9PSAnYScgb3IKCWNvZGVjLnplbnR5cGUgPT0gJ2QnLAoJIlRhcmdldCBpcyBub3QgYSB2YWxpZDogIi4uZGljKQoJbG9jYWwgZGF0YSA9IGhhdmUoZGljKQoJemVuY29kZV9hc3NlcnQobHVhdHlwZShkYXRhKSA9PSAndGFibGUnLCAiSW52YWxpZCBhcnJheTogIi4uZGljKQoJZW1wdHknZmxhdCBhcnJheScKCUFDSy5mbGF0X2FycmF5ID0ge30KCWRlZXBzb3J0bWFwKGZ1bmN0aW9uKHYsIGssIHJlcykgdGFibGUuaW5zZXJ0KHJlcywgdikgZW5kLCBkYXRhLCBBQ0suZmxhdF9hcnJheSkKCW5ld19jb2RlYygnZmxhdCBhcnJheScsIHsgZW5jb2Rpbmc9InN0cmluZyIgfSkKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX2tleXNfZmxhdF9hcnJheShkYXRhLCByZXMpCglmb3IgaywgaXRlbSBpbiBzb3J0X3BhaXJzKGRhdGEpIGRvCgkJaWYgdHlwZShrKSA9PSAnc3RyaW5nJyB0aGVuCgkJCWsgPSBPLmZyb21fc3RyaW5nKGspCgkJZWxzZWlmIHR5cGUoaykgPT0gJ251bWJlcicgdGhlbgoJCQlrID0gRi5uZXcoaykKCQllbmQKCQl0YWJsZS5pbnNlcnQocmVzLCBrKQoJCWlmIGx1YXR5cGUoaXRlbSkgPT0gJ3RhYmxlJyB0aGVuCgkJCV9rZXlzX2ZsYXRfYXJyYXkoaXRlbSwgcmVzKQoJCWVuZAoJZW5kCmVuZAoKV2hlbigiY3JlYXRlIGZsYXQgYXJyYXkgb2Yga2V5cyBpbiAnJyIsIGZ1bmN0aW9uKGRpYykKCWxvY2FsIGNvZGVjID0gQ09ERUNbZGljXQoJemVuY29kZV9hc3NlcnQoY29kZWMuemVudHlwZSA9PSAnYScgb3IKCWNvZGVjLnplbnR5cGUgPT0gJ2QnLAoJIlRhcmdldCBpcyBub3QgYSB2YWxpZDogIi4uZGljKQoJbG9jYWwgZGF0YSA9IGhhdmUoZGljKQoJemVuY29kZV9hc3NlcnQobHVhdHlwZShkYXRhKSA9PSAndGFibGUnLCAiSW52YWxpZCB0YXJnZXQ6ICIuLmRpYykKCWVtcHR5J2ZsYXQgYXJyYXknCglBQ0suZmxhdF9hcnJheSA9IHt9Cglfa2V5c19mbGF0X2FycmF5KGRhdGEsIEFDSy5mbGF0X2FycmF5KQoJbmV3X2NvZGVjKCdmbGF0IGFycmF5JywgeyBlbmNvZGluZz0ic3RyaW5nIiB9KQplbmQpCgpXaGVuKCJjcmVhdGUgYXJyYXkgb2Ygb2JqZWN0cyBuYW1lZCBieSAnJyBmb3VuZCBpbiAnJyIsIGZ1bmN0aW9uKG5hbWUsIGRpY3QpCgl6ZW5jb2RlX2Fzc2VydChpc2RpY3Rpb25hcnkoZGljdCksICJTZWNvbmQgYXJndW1lbnQgaXMgbm90IGEgZGljdGlvbmFyeSIpCglsb2NhbCBuID0gaGF2ZShuYW1lKTpvY3RldCgpOnN0cmluZygpCglsb2NhbCBzcmMgPSBoYXZlKGRpY3QpCgllbXB0eSdhcnJheScKCUFDSy5hcnJheSA9IHsgfQoJZGVlcG1hcChmdW5jdGlvbih2LGsscmVzKQoJCWlmIGsgPT0gbiB0aGVuIHRhYmxlLmluc2VydChyZXMsIHYpIGVuZAoJZW5kLCBzcmMsIEFDSy5hcnJheSkKCW5ld19jb2RlYygnYXJyYXknLCB7IGVuY29kaW5nPSdzdHJpbmcnLCB6ZW50eXBlPSdhJyB9KQplbmQpCgpXaGVuKCJjcmVhdGUgYXJyYXkgYnkgc3BsaXR0aW5nICcnIGF0ICcnIiwgZnVuY3Rpb24oZGF0YV9uYW1lLCBzZXBfbmFtZSkKCWxvY2FsIGRhdGEgPSB1c2NvcmUoaGF2ZShkYXRhX25hbWUpOm9jdGV0KCk6c3RyaW5nKCkpCglsb2NhbCBzZXAgPSB1c2NvcmUoaGF2ZShzZXBfbmFtZSk6b2N0ZXQoKTpzdHJpbmcoKSkKCXplbmNvZGVfYXNzZXJ0KCNzZXAgPT0gMSwgIllvdSBjYW4gb25seSBzcGxpdCB3aXRoIHJlc3BlY3QgdG8gb25lIGNoYXJhY3RlciIpCgllbXB0eSdhcnJheScKCWxvY2FsIHN0cmluZ3MgPSBzdHJ0b2soZGF0YSwgc2VwKQoJbG9jYWwgb2N0ZXRzID0ge30KCWZvciBfLCB2IGluIGlwYWlycyhzdHJpbmdzKSBkbwoJCS0tIGV4Y2x1ZGUgZW1wdHkgc3RyaW5ncyBmcm9tIGNvbnZlcnNpb24KCQlpZiB2IGFuZCAjdiA+IDAgdGhlbgoJCQl0YWJsZS5pbnNlcnQob2N0ZXRzLCBPLmZyb21fc3RyKHYpKQoJCWVuZAoJZW5kCglBQ0suYXJyYXkgPSBvY3RldHMKCW5ld19jb2RlYygnYXJyYXknLCB7IGVuY29kaW5nPSdzdHJpbmcnLCB6ZW50eXBlPSdhJyB9KQplbmQpCgpXaGVuKCJjcmVhdGUgJycgZnJvbSAnJyBpbiAnJyIsIGZ1bmN0aW9uKGRlc3QsIGtleV9uYW1lLCBvYmpfbmFtZSkKCWVtcHR5KGRlc3QpCglsb2NhbCBvYmosIG9ial9jb2RlYyA9IGhhdmUob2JqX25hbWUpCglsb2NhbCBrZXksIGtleV9lbmMgPSBtYXloYXZlKGtleV9uYW1lKQoJaWYga2V5IHRoZW4KCQlpZiBrZXlfZW5jLmVuY29kaW5nID09ICJzdHJpbmciIHRoZW4KCQkJa2V5ID0ga2V5OnN0cigpCgkJZWxzZWlmIGtleV9lbmMuZW5jb2RpbmcgPT0gImludGVnZXIiIHRoZW4KCQkJa2V5ID0ga2V5OmRlY2ltYWwoKQoJCWVuZAoJZWxzZQoJCWtleSA9IGtleV9uYW1lCgllbmQKCWlmIG9ial9jb2RlYy56ZW50eXBlID09ICdhJyB0aGVuCgkJbG9jYWwga2V5X251bSA9IHRvbnVtYmVyKGtleSkKCQl6ZW5jb2RlX2Fzc2VydCgjb2JqID49IGtleV9udW0sICJFbGVtZW50ICIuLmtleV9udW0uLiIgZG9lcyBub3QgZXhpc3RzIGluIGFycmF5ICIuLm9ial9uYW1lKQoJCUFDS1tkZXN0XSA9IG9ialtrZXlfbnVtXQoJZWxzZWlmIG9ial9jb2RlYy56ZW50eXBlID09ICdkJyB0aGVuCgkJemVuY29kZV9hc3NlcnQob2JqW2tleV0sICJFbGVtZW50ICIuLmtleS4uIiBkb2VzIG5vdCBleGlzdHMgaW4gZGljdGlvbmFyeSAiLi5vYmpfbmFtZSkKCQlBQ0tbZGVzdF0gPSBvYmpba2V5XQoJZWxzZQoJCWVycm9yKCJMYXN0IG9iamVjdCBtdXN0IGJlIGFuIGFycmF5IG9yIGRpY3Rpb25hcnksIGZvdW5kIGluc3RlYWQ6ICIuLm9ial9jb2RlYy56ZW50eXBlKQoJZW5kCgluZXdfY29kZWMoZGVzdCwge2VuY29kaW5nID0gb2JqX2NvZGVjLmVuY29kaW5nfSkKZW5kKQovemVuY29kZV9iYnMubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIzLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IFJlYmVjY2EgU2VsdmFnZ2luaSwgTHVjYSBEaSBEb21lbmljbyBhbmQgQWxiZXJ0byBMZXJkYQotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS1dXQoKLS1bWwoKUmlnaHQgbm93IHRoZSBaZW5jb2RlIHN0YXRlbWVudHMgc2V0IHRoZSBoZWFkZXIgcGFyYW1ldGVyICh1c2VkIGluIHRoZQpzaWduYXR1cmUsIHRoZSB2ZXJpZmljYXRpb24sIHRoZSBjcmVhdGlvbiBvZiB0aGUgcHJvb2YgYW5kIHRoZQp2ZXJpZmljYXRpb24gb2YgdGhlIHByb29mKSBhcyB0aGUgZGVmYXVsdCB2YWx1ZSwgYW4gZW1wdHkgb2N0ZXQuCgpJbiB0aGUgemVybyBrbm93bGVkZ2UgcHJvb2YgY29udGV4dCBhcyB3ZSBpbXBsZW1lbnRlZCBpdCBmb2xsb3dpbmcKdGhpcyBkcmFmdCwgdGhlIGhlYWRlciBpcyBjcmVhdGVkIGJ5IHRoZSBJU1NVRVIgYW5kIGl0IGlzIGRlc2lnbmVkIHRvCnBvc3NpYmx5IGNvbnRhaW4gcGllY2VzIG9mIGluZm9ybWF0aW9uIG1lYW50IHRvIGJlIFBVQkxJQy4gRm9yCmV4YW1wbGUsIGFuIGhlYWRlciBNQVkgY29udGFpbiBhIHNldCBvZiBtZXNzYWdlcyBtZWFudCB0byBiZSBBTFdBWVMKRElTQ0xPU0VEIGluIHRoZSBwcm9vZiBjcmVhdGlvbi4KClRvIGVuYWJsZSB0aGUgdXNlIG9mIHRoZSBoZWFkZXIgaW5zaWRlIFplbmNvZGUsIG9uZSBzaG91bGQgY3JlYXRlIGF0CmxlYXN0IHRocmVlIG5ldyBzdGF0ZW1lbnRzLCBjb25zaWRlcmluZyB0aGUgaGVhZGVyIHBhcmFtZXRlciBpbnNpZGUKdGhlIGlzc3VlciBjcmVkZW50aWFsIHNpZ25hdHVyZSwgaW5zaWRlIHRoZSBwcm9vZiBjcmVhdGlvbiBhbmQgaW5zaWRlCnRoZSBwcm9vZiB2ZXJpZmljYXRpb24uCgpSaWdodCBub3csIHRoZSBwcmVzZW50YXRpb24gaGVhZGVyICh1c2VkIGluIHRoZSBjcmVhdGlvbiBvZiB0aGUgcHJvb2YKYW5kIHRoZSB2ZXJpZmljYXRpb24gb2YgdGhlIHByb29mKSBpcyBzZXQgYXMgYSByYW5kb20gb2N0ZXQgb2YgZml4ZWQKbGVuZ3RoIGluc2lkZSB0aGUgWmVuY29kZSBleGFtcGxlcy4gSXQgaXMgbWVhbnQgdG8gbWl0aWdhdGUgdGhlIHJlcGxheQphdHRhY2tzLiBJdCBpcyBjcmVhdGVkIGJ5IHRoZSBQQVJUSUNJUEFOVCBhbmQgaXQgY2FuIGJlIGEgbm9uY2UgYW5kL29yCmNvbnRhaW4gYWRkaXRpb25hbCBpbmZvcm1hdGlvbiwgbGlrZSBhbiBleHBpcmF0aW9uIGRhdGUgb2YgdGhlIHByb29mCih0aGlzIGlzIHVzZWQgdG8gZ3VhcmFudGVlIHRoZSBmcmVzaG5lc3Mgb2YgdGhlIGdlbmVyYXRlZCBwcm9vZikuCgpPbmUgY2FuIGZpbmQgYSBuaWNlIHByZXNlbnRhdGlvbiByZWdhcmRpbmcgdGhlIEJCUyB6ZXJvLWtub3dsZWRnZQpwcm9vZiBzY2hlbWUgaGVyZQpodHRwczovL2dyb3R0by1uZXR3b3JraW5nLmNvbS9QcmVzZW50YXRpb25zL0JCU2ZvclZDcy9CQlNmb3JWQ3NCYXNpY3MuaHRtbCMvdGl0bGUtc2xpZGUKCk9uZSBtYXkgaW50ZXJhY3RpdmVseSB0ZXN0IHRoZSBmdW5jdGlvbmFsaXR5IG9mIHRoZQpCQlMgWktQIHNjaGVtZSBkaXJlY3RseSBvbiBhIGJyb3dzZXIgaGVyZQpodHRwczovL3d3dy5ncm90dG8tbmV0d29ya2luZy5jb20vQkJTRGVtby8KCk91ciBhY3R1YWwgaW1wbGVtZW50YXRpb24gb2YgdGhlIEJCUyBaS1AgZG9lcyBub3QgcmVxdWlyZSB0aGUgdXNlIG9mCnBhcnRpY2lwYW50J3MgU0VDUkVUIGtleSB0byBnZW5lcmF0ZSB0aGUgcHJvb2YuIEluIGNlcnRhaW4gdXNlIGNhc2UKc2NlbmFyaW8sIHRoaXMgYWxsb3dzIHRoZSBpc3N1ZXIgdG8gaW1wZXJzb25hdGUgYSBnaXZlbgpwYXJ0aWNpcGFudC4gVGhlcmUgYXJlIG1hbnkgcG9zc2libGUgc29sdXRpb25zIGZvciBzdWNoIGFuIGlzc3VlCmRlcGVuZGluZyBvbiB0aGUgYXBwbGljYXRpb24uIEEgcG9zc2libGUgdmFyaWFudCBvZiB0aGUgQkJTIFpLUAphc3Nlc3NpbmcgdGhlIGxhY2sgb2YgdGhlIHBhcnRpY2lwYW50J3MgcHJpdmF0ZSBrZXkgY2FuIGJlIGZvdW5kIGhlcmUKaHR0cHM6Ly9iYXNpbGVpb3NrYWwuZ2l0aHViLmlvL2Jicy1ib3VuZC1zaWduYXR1cmVzL2RyYWZ0LWJvdW5kLWJicy1zaWduYXR1cmVzLmh0bWwKCi0tXV0KCmxvY2FsIEJCUyA9IHJlcXVpcmUnY3J5cHRvX2JicycKCmxvY2FsIGZ1bmN0aW9uIGJic19wdWJsaWNfa2V5X2Yob2JqKQogICAgbG9jYWwgcG9pbnQgPSBFQ1AyLmZyb21femNhc2gob2JqKQogICAgaWYgcG9pbnQ6aXNpbmYoKSB0aGVuCiAgICAgICAgZXJyb3IoJ0ludmFsaWQgQkJTIHB1YmxpYyBrZXkgKGluZmluaXRlKScsIDMpIGVuZAogICAgLS0gVE9ETzogcmVzdG9yZSB0aGlzIHRlc3QgdXNpbmcgdGhlIHJpZ2h0IG11bHRpcGxpZXIKICAgIGlmIG5vdCAocG9pbnQqRUNQLm9yZGVyKCkpOmlzaW5mKCkgdGhlbgogICAgICAgIGVycm9yKCdJbnZhbGlkIEJCUyBwdWJsaWMga2V5IChwb2ludCpvcmRlciBub3QgaW5maW5pdGUpJywzKSBlbmQKICAgIHJldHVybiBvYmoKZW5kCgotLXNlZSBmdW5jdGlvbiBvY3RldHNfdG9fc2lnbmF0dXJlIGluIHNyYy9sdWEvY3J5cHRvX2Jicy5sdWEKbG9jYWwgZnVuY3Rpb24gYmJzX3NpZ25hdHVyZV9mKG9iaikKICAgIGxvY2FsIGV4cGVjdGVkX2xlbiA9IDgwCiAgICBsb2NhbCBzaWduYXR1cmVfb2N0ZXRzID0gb2JqOm9jdGV0KCkKICAgIGlmICNzaWduYXR1cmVfb2N0ZXRzIH49IGV4cGVjdGVkX2xlbiB0aGVuCiAgICAgICAgZXJyb3IoIkludmFsaWQgbGVuZ3RoIG9mIHNpZ25hdHVyZV9vY3RldHM6ICIuLiNzaWduYXR1cmVfb2N0ZXRzLCAzKSBlbmQKICAgIGxvY2FsIEFfb2N0ZXRzID0gc2lnbmF0dXJlX29jdGV0czpzdWIoMSwgNDgpCiAgICBsb2NhbCBBQSA9IEVDUC5mcm9tX3pjYXNoKEFfb2N0ZXRzKQogICAgaWYgQUEgPT0gRUNQLmdlbmVyYXRvcigpIHRoZW4KICAgICAgICBlcnJvcigiSW52YWxpZCBCQlMgc2lnbmF0dXJlOiBwb2ludCBlcXVhbCBvcmRlciBpZGVudGl0eSIsMykKICAgIGVuZAogICAgbG9jYWwgQklHXzAgPSBCSUcubmV3KDApCiAgICBsb2NhbCBpbmRleCA9IDQ5CiAgICBsb2NhbCBlbmRfaW5kZXggPSBpbmRleCArIDMxCiAgICBsb2NhbCBlID0gQklHLm5ldyhzaWduYXR1cmVfb2N0ZXRzOnN1YihpbmRleCwgZW5kX2luZGV4KSkKICAgIGxvY2FsIFBSSU1FX1IgPSBFQ1Aub3JkZXIoKQogICAgaWYgbm90ICggZSB+PSBCSUdfMCBhbmQgZSA8IFBSSU1FX1IgKSB0aGVuCiAgICAgICAgZXJyb3IoIkludmFsaWQgQkJTIHNpZ25hdHVyZTogd3JvbmcgZSBpbiBkZXNlcmlhbGl6YXRpb24iLDMpCiAgICBlbmQKICAgIC0tIGluZGV4ID0gaW5kZXggKyAzMgogICAgLS0gZW5kX2luZGV4ID0gaW5kZXggKyAzMQogICAgLS0gbG9jYWwgcyA9IEJJRy5uZXcoc2lnbmF0dXJlX29jdGV0czpzdWIoaW5kZXgsIGVuZF9pbmRleCkpCiAgICAtLSBpZiBub3QgKCBzIH49IEJJR18wIGFuZCBzIDwgUFJJTUVfUiApIHRoZW4KICAgIC0tICAgICBlcnJvcigiSW52YWxpZCBCQlMgc2lnbmF0dXJlOiB3cm9uZyBzIGluIGRlc2VyaWFsaXphdGlvbiIsIDMpCiAgICAtLSBlbmQKICAgIHJldHVybiBvYmoKZW5kCgpaRU46YWRkX3NjaGVtYSgKICAgewogICAgICBiYnNfcHVibGljX2tleSA9IGZ1bmN0aW9uKG9iaikKICAgICAgICByZXR1cm4gc2NoZW1hX2dldChvYmosICcuJywgYmJzX3B1YmxpY19rZXlfZikKICAgICAgZW5kLAogICAgICBiYnNfc2lnbmF0dXJlID0gZnVuY3Rpb24ob2JqKQogICAgICAgIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJy4nLCBiYnNfc2lnbmF0dXJlX2YpCiAgICAgIGVuZCwKICAgICAgYmJzX3NoYWtlX3B1YmxpY19rZXkgPSBmdW5jdGlvbihvYmopCiAgICAgICAgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnLicsIGJic19wdWJsaWNfa2V5X2YpCiAgICAgIGVuZCwKICAgICAgYmJzX3NoYWtlX3NpZ25hdHVyZSA9IGZ1bmN0aW9uKG9iaikKICAgICAgICByZXR1cm4gc2NoZW1hX2dldChvYmosICcuJywgYmJzX3NpZ25hdHVyZV9mKQogICAgICBlbmQKICAgfQopCgotLVtbCiAgICBLZXlHZW4gdGFrZXMgYXMgaW5wdXQgYW4gb2N0ZXQgc3RyaW5nIChvZiBsZW5ndGggYXQgbGVhc3QgMzIgYnl0ZXMpIElLTS4gCiAgICBJS00gTVVTVCBiZSBpbmZlYXNpYmxlIHRvIGd1ZXNzLCBlLmcuIGdlbmVyYXRlZCBieSBhIHRydXN0ZWQgc291cmNlIG9mIHJhbmRvbW5lc3MuCiAgICAKICAgIEZvciB0aGlzIHJlYXNvbiB3ZSBnZW5lcmF0ZSBJS00gaW5zaWRlIG9mIHRoZSBCQlMua2V5Z2VuKCkgZnVuY3Rpb24gKHNlZSBzcmMvbHVhL2NyeXB0b19iYnMubHVhKQogICAgCiAgICBLZXlHZW4gdGFrZXMgYWxzbyBhbiBvcHRpb25hbCBwYXJhbWV0ZXIsIGtleV9pbmZvLiAKICAgIFRoaXMgcGFyYW1ldGVyIE1BWSBiZSB1c2VkIHRvIGRlcml2ZSBtdWx0aXBsZSBpbmRlcGVuZGVudCBrZXlzIGZyb20gdGhlIHNhbWUgSUtNLiAKICAgIEJ5IGRlZmF1bHQsIGtleV9pbmZvIGlzIHRoZSBlbXB0eSBzdHJpbmcuCi0tXV0KCi0tIGdlbmVyYXRlIHRoZSBwcml2YXRlIGtleQpXaGVuKCJjcmVhdGUgYmJzIGtleSIsZnVuY3Rpb24oKQogICAgaW5pdGtleXJpbmcnYmJzJwogICAgbG9jYWwgY2lwaGVyc3VpdGUgPSBCQlMuY2lwaGVyc3VpdGUoJ3NoYTI1NicpCiAgICBBQ0sua2V5cmluZy5iYnMgPSBCQlMua2V5Z2VuKGNpcGhlcnN1aXRlKQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHJpdmF0ZSBrZXkKV2hlbigiY3JlYXRlIGJicyBzaGFrZSBrZXkiLGZ1bmN0aW9uKCkKICAgIGluaXRrZXlyaW5nJ2Jic19zaGFrZScKICAgIGxvY2FsIGNpcGhlcnN1aXRlID0gQkJTLmNpcGhlcnN1aXRlKCdzaGFrZTI1NicpCiAgICBBQ0sua2V5cmluZy5iYnNfc2hha2UgPSBCQlMua2V5Z2VuKGNpcGhlcnN1aXRlKQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgYmJzIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKICAgIGVtcHR5J2JicyBwdWJsaWMga2V5JwogICAgbG9jYWwgc2sgPSBoYXZla2V5J2JicycKICAgIEFDSy5iYnNfcHVibGljX2tleSA9IEJCUy5zazJwayhzaykKICAgIG5ld19jb2RlYygnYmJzIHB1YmxpYyBrZXknLCB7IHplbnR5cGUgPSAnZSd9KQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgYmJzIHNoYWtlIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKICAgIGVtcHR5J2JicyBzaGFrZSBwdWJsaWMga2V5JwogICAgbG9jYWwgc2sgPSBoYXZla2V5J2JicyBzaGFrZScKICAgIEFDSy5iYnNfc2hha2VfcHVibGljX2tleSA9IEJCUy5zazJwayhzaykKICAgIG5ld19jb2RlYygnYmJzIHNoYWtlIHB1YmxpYyBrZXknLCB7IHplbnR5cGUgPSAnZSd9KQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfa2V5X2Zyb21fc2VjcmV0KHNlYywgcGF0aCkKICAgbG9jYWwgc2sgPSBoYXZlKHNlYykKICAgbG9jYWwgbmFtZSA9IHVzY29yZShwYXRoKSBvciAnYmJzJwogICBpZiBuYW1lIH49ICdiYnMnIGFuZCBuYW1lIH49ICdiYnNfc2hha2UnIHRoZW4KICAgICAgIGVycm9yKCdVbnN1cHBvcnRlZCBCQlMga2V5IGZvcm1hdDogJy4ubmFtZSwgMykgZW5kCiAgIGluaXRrZXlyaW5nKG5hbWUpCiAgIC0tIENoZWNrIGlmIHRoZSB1c2VyLXByb3ZpZGVkIHNrIGlzIHJlYXNvbmFibGUKICAgaWYgdHlwZShzaykgfj0gInplbnJvb20uYmlnIiB0aGVuCiAgICAgICAgICAgZXJyb3IoIkludmFsaWQgQkJTIHNlY3JldCBrZXk6IG11c3QgYmUgYSBCSUcgaW50ZWdlciIsIDIpCiAgIGVuZAogICBpZiBzayA+PSBFQ1Aub3JkZXIoKSB0aGVuCiAgICAgICBlcnJvcigiSW52YWxpZCBCQlMgc2VjcmV0IGtleTogc2NhbGFyIGV4Y2VlZHMgb3JkZXIiLCAyKQogICBlbmQKICAgQUNLLmtleXJpbmdbbmFtZV0gPSBzawplbmQKCldoZW4oImNyZWF0ZSBiYnMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsIF9rZXlfZnJvbV9zZWNyZXQpCldoZW4oImNyZWF0ZSBiYnMga2V5IHdpdGggc2VjcmV0ICcnIiwgX2tleV9mcm9tX3NlY3JldCkKCldoZW4oImNyZWF0ZSBiYnMgc2hha2Uga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsIGZ1bmN0aW9uKHNrKSBfa2V5X2Zyb21fc2VjcmV0KHNrLCAnYmJzX3NoYWtlJykgZW5kKQpXaGVuKCJjcmVhdGUgYmJzIHNoYWtlIGtleSB3aXRoIHNlY3JldCAnJyIsIGZ1bmN0aW9uKHNrKSBfa2V5X2Zyb21fc2VjcmV0KHNrLCAnYmJzX3NoYWtlJykgZW5kKQoKV2hlbigiY3JlYXRlIGJicyBwdWJsaWMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsZnVuY3Rpb24oc2VjKQogICAgbG9jYWwgc2sgPSBoYXZlKHNlYykKICAgIC0tIENoZWNrIGlmIHRoZSB1c2VyLXByb3ZpZGVkIHNrIGlzIHJlYXNvbmFibGUKICAgIHplbmNvZGVfYXNzZXJ0KHR5cGUoc2spID09ICJ6ZW5yb29tLmJpZyIsICJzayBtdXN0IGhhdmUgdHlwZSBpbnRlZ2VyIikKICAgIHplbmNvZGVfYXNzZXJ0KHNrIDwgRUNQLm9yZGVyKCksICJzayBpcyBub3QgYSBzY2FsYXIiKQogICAgZW1wdHknYmJzIHB1YmxpYyBrZXknCiAgICBBQ0suYmJzX3B1YmxpY19rZXkgPSBCQlMuc2sycGsoc2spCiAgICBuZXdfY29kZWMoJ2JicyBwdWJsaWMga2V5JywgeyB6ZW50eXBlID0gJ2UnfSkKZW5kKQpXaGVuKCJjcmVhdGUgYmJzIHNoYWtlIHB1YmxpYyBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIixmdW5jdGlvbihzZWMpCiAgICBsb2NhbCBzayA9IGhhdmUoc2VjKQogICAgLS0gQ2hlY2sgaWYgdGhlIHVzZXItcHJvdmlkZWQgc2sgaXMgcmVhc29uYWJsZQogICAgemVuY29kZV9hc3NlcnQodHlwZShzaykgPT0gInplbnJvb20uYmlnIiwgInNrIG11c3QgaGF2ZSB0eXBlIGludGVnZXIiKQogICAgemVuY29kZV9hc3NlcnQoc2sgPCBFQ1Aub3JkZXIoKSwgInNrIGlzIG5vdCBhIHNjYWxhciIpCiAgICBlbXB0eSdiYnMgc2hha2UgcHVibGljIGtleScKICAgIEFDSy5iYnNfc2hha2VfcHVibGljX2tleSA9IEJCUy5zazJwayhzaykKICAgIG5ld19jb2RlYygnYmJzIHNoYWtlIHB1YmxpYyBrZXknLCB7IHplbnR5cGUgPSAnZSd9KQplbmQpCgotLVtbIFRoZSBmdW5jdGlvbiBCQlMuc2lnbiBtYXkgdGFrZSBhcyBpbnB1dCBhbHNvIGEgc3RyaW5nIG9jdGV0IEhFQURFUiBjb250YWluaW5nIGNvbnRleHQgCiAgICAgYW5kIGFwcGxpY2F0aW9uIHNwZWNpZmljIGluZm9ybWF0aW9uLiBJZiBub3Qgc3VwcGxpZWQsIGl0IGRlZmF1bHRzIHRvIGFuIGVtcHR5IHN0cmluZy4KLS1dXQoKbG9jYWwgZnVuY3Rpb24gZ2VuZXJpY19iYnNfc2lnbmF0dXJlKGRvYywgaCkKICAgIGxvY2FsIG9iaiwgb2JqX2NvZGVjID0gaGF2ZShkb2MpCiAgICBsb2NhbCBoYXNoID0gTy50b19zdHJpbmcobWF5aGF2ZShoKSkgb3IgaCBvciAnc2hhMjU2JwogICAgbG9jYWwgbmFtZSA9IGZpZihoYXNoPT0nc2hhMjU2JywgJ2JicycpCiAgICAgICAgb3IgZmlmKGhhc2g9PSdzaGFrZTI1NicsJ2Jic19zaGFrZScpCiAgICAgICAgb3IgZXJyb3IoIkludmFsaWQgc2lnbmF0dXJlIGhhc2g6ICIuLmhhc2gpCiAgICBlbXB0eShuYW1lLi4nIHNpZ25hdHVyZScpCiAgICBsb2NhbCBzayA9IGhhdmVrZXkobmFtZSkKICAgIGxvY2FsIGNpcGhlcnN1aXRlID0gQkJTLmNpcGhlcnN1aXRlKGhhc2gpCiAgICAtLSBmaXJzdCBjaGVjayBvbiBoLCBjaGVja3Mgb24gbmVzdGVkIHRhYmxlIGlzIGRvbmUgaW4gQkJTLnNpZ24gZm9yIG9wdGltaXphdGlvbgogICAgemVuY29kZV9hc3NlcnQob2JqX2NvZGVjLnplbnR5cGUgPT0gJ2UnIG9yIG9ial9jb2RlYy56ZW50eXBlID09ICdhJywKICAgICAgICAnQkJTIHNpZ25hdHVyZSBjYW4gYmUgZG9uZSBvbmx5IG9uIHN0cmluZ3Mgb3IgYW4gYXJyYXkgb2Ygc3RyaW5ncycpCiAgICBpZiAobHVhdHlwZShvYmopIH49ICd0YWJsZScpIHRoZW4gb2JqID0ge29ian0gZW5kCiAgICBsb2NhbCBwayA9IEJCUy5zazJwayhzaykKICAgIEFDS1tuYW1lLi4nX3NpZ25hdHVyZSddID0gQkJTLnNpZ24oY2lwaGVyc3VpdGUsIHNrLCBuaWwsIG9iaikKICAgIG5ld19jb2RlYyhuYW1lLi4nIHNpZ25hdHVyZScsIHsgemVudHlwZSA9ICdlJ30pCmVuZAoKV2hlbigiY3JlYXRlIGJicyBzaWduYXR1cmUgb2YgJyciLCBmdW5jdGlvbihkb2MpIGdlbmVyaWNfYmJzX3NpZ25hdHVyZShkb2MsICdzaGEyNTYnKSBlbmQpCldoZW4oImNyZWF0ZSBiYnMgc2hha2Ugc2lnbmF0dXJlIG9mICcnIiwgZnVuY3Rpb24oZG9jKSBnZW5lcmljX2Jic19zaWduYXR1cmUoZG9jLCAnc2hha2UyNTYnKSBlbmQpCgpsb2NhbCBmdW5jdGlvbiBnZW5lcmljX3ZlcmlmeShkb2MsIHNpZywgYnksIGgpCiAgICBsb2NhbCBzID0gaGF2ZShzaWcpCiAgICBsb2NhbCBvYmogPSBoYXZlKGRvYykKICAgIGxvY2FsIGhhc2ggPSBPLnRvX3N0cmluZyhtYXloYXZlKGgpKSBvciBoIG9yICdzaGEyNTYnCiAgICBsb2NhbCBuYW1lID0gZmlmKGhhc2g9PSdzaGEyNTYnLCAnYmJzJykKICAgICAgICBvciBmaWYoaGFzaD09J3NoYWtlMjU2JywnYmJzX3NoYWtlJykKICAgICAgICBvciBlcnJvcigiSW52YWxpZCBzaWduYXR1cmUgaGFzaDogIi4uaGFzaCkKICAgIGxvY2FsIHBrID0gbG9hZF9wdWJrZXlfY29tcGF0KGJ5LCBuYW1lKQogICAgbG9jYWwgY2lwaGVyc3VpdGUgPSBCQlMuY2lwaGVyc3VpdGUoaGFzaCkKICAgIGlmICh0eXBlKG9iaikgfj0gJ3RhYmxlJykgdGhlbiBvYmogPSB7b2JqfSBlbmQKICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICAgIEJCUy52ZXJpZnkoY2lwaGVyc3VpdGUsIHBrLCBzLCBuaWwsIG9iaiksCiAgICAgICAnVGhlICcuLnNwYWNlKG5hbWUpLi4nIHNpZ25hdHVyZSBieSAnLi5ieS4uJyBpcyBub3QgYXV0aGVudGljJwogICAgKQplbmQKCklmV2hlbigidmVyaWZ5ICcnIGhhcyBhIGJicyBzaWduYXR1cmUgaW4gJycgYnkgJyciLCBmdW5jdGlvbihkb2MsIHNpZywgYnkpCiAgICByZXR1cm4gZ2VuZXJpY192ZXJpZnkoZG9jLCBzaWcsIGJ5LCAnc2hhMjU2JykKZW5kKQpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSBiYnMgc2hha2Ugc2lnbmF0dXJlIGluICcnIGJ5ICcnIiwgZnVuY3Rpb24oZG9jLCBzaWcsIGJ5KQogICAgcmV0dXJuIGdlbmVyaWNfdmVyaWZ5KGRvYywgc2lnLCBieSwgJ3NoYWtlMjU2JykKZW5kKQoKLS1bWwogICAgUGFydGljaXBhbnQgZ2VuZXJhdGVzIHByb29mIHdpdGggdGhlIGZ1bmN0aW9uIGJicy5wcm9vZl9nZW4oY2lwaGVyc3VpdGUsIHBrLCBzaWduYXR1cmUsIAogICAgaGVhZGVyLCBwaCwgbWVzc2FnZXNfb2N0ZXRzLCBkaXNjbG9zZWRfaW5kZXhlcykKCiAgICBwaCA9IHByZXNlbnRhdGlvbiBoZWFkZXIsIHVzZWQgdG8gbWl0aWdhdGUgcmVwbGF5IGF0dGFjay4KLS1dXQoKLS1zZWUgZnVuY3Rpb24gb2N0ZXRzX3RvX3Byb29mIGluIHNyYy9sdWEvY3J5cHRvX2Jicy5sdWEKbG9jYWwgZnVuY3Rpb24gYmJzX3Byb29mX2Yob2JqKQogICAgbG9jYWwgcHJvb2Zfb2N0ZXRzID0gb2JqOm9jdGV0KCkKICAgIGxvY2FsIHByb29mX2xlbl9mbG9vciA9IDMwNAogICAgemVuY29kZV9hc3NlcnQoI3Byb29mX29jdGV0cyA+PSBwcm9vZl9sZW5fZmxvb3IsCiAgICAgICAgInByb29mX29jdGV0cyBpcyB0b28gc2hvcnQiCiAgICApCiAgICBsb2NhbCBpbmRleCA9IDEKICAgIGZvciBpID0gMSwgMyBkbwogICAgICAgIGxvY2FsIGVuZF9pbmRleCA9IGluZGV4ICsgNDcKICAgICAgICBsb2NhbCBwb2ludCA9IEVDUC5mcm9tX3pjYXNoKHByb29mX29jdGV0czpzdWIoaW5kZXgsIGVuZF9pbmRleCkpCiAgICAgICAgemVuY29kZV9hc3NlcnQocG9pbnQgfj0gRUNQLmdlbmVyYXRvcigpLAogICAgICAgICAgICAiSW52YWxpZCBwb2ludCIKICAgICAgICApCiAgICAgICAgaW5kZXggPSBpbmRleCArIDQ4CiAgICBlbmQKICAgIGxvY2FsIFBSSU1FX1IgPSBFQ1Aub3JkZXIoKQogICAgd2hpbGUgaW5kZXggPCAjcHJvb2Zfb2N0ZXRzIGRvCiAgICAgICAgbG9jYWwgZW5kX2luZGV4ID0gaW5kZXggKyAzMQogICAgICAgIGxvY2FsIHNjID0gQklHLm5ldyhwcm9vZl9vY3RldHM6c3ViKGluZGV4LCBlbmRfaW5kZXgpKQogICAgICAgIHplbmNvZGVfYXNzZXJ0KCBzYyB+PSBCSUcubmV3KDApIGFuZCBzYyA8IFBSSU1FX1IsCiAgICAgICAgICAgICJOb3QgYSBzY2FsYXIgaW4gb2N0ZXRzX3Byb29mIgogICAgICAgICkKICAgICAgICBpbmRleCA9IGluZGV4ICsgMzIKICAgIGVuZAoKICAgIHJldHVybiBvYmoKZW5kCgpaRU46YWRkX3NjaGVtYSgKICAgIHsKICAgICAgICBiYnNfcHJvb2YgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJy4nLCBiYnNfcHJvb2ZfZikgZW5kLAogICAgICAgIGJic19zaGFrZV9wcm9vZiA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnLicsIGJic19wcm9vZl9mKSBlbmQsCiAgICAgICAgYmJzX2NyZWRlbnRpYWwgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJy4nLCBiYnNfc2lnbmF0dXJlX2YpIGVuZCwKICAgICAgICBiYnNfc2hha2VfY3JlZGVudGlhbCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnLicsIGJic19zaWduYXR1cmVfZikgZW5kCiAgICB9CikKCldoZW4oImNyZWF0ZSBiYnMgZGlzY2xvc2VkIG1lc3NhZ2VzIiwgZnVuY3Rpb24oKQogICAgbG9jYWwgZGlzX2luZCA9IGhhdmUnYmJzIGRpc2Nsb3NlZCBpbmRleGVzJwogICAgbG9jYWwgYWxsX21zZ3MgPSBoYXZlJ2JicyBtZXNzYWdlcycKICAgIGVtcHR5J2JicyBkaXNjbG9zZWQgbWVzc2FnZXMnCiAgICBsb2NhbCBkaXNfbXNncyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGRpc19pbmQpIGRvCiAgICAgICAgZGlzX21zZ3Nba10gPSBhbGxfbXNnc1t0b251bWJlcih2KV0KICAgIGVuZAogICAgQUNLLmJic19kaXNjbG9zZWRfbWVzc2FnZXMgPSBkaXNfbXNncwogICAgbmV3X2NvZGVjKCdiYnMgZGlzY2xvc2VkIG1lc3NhZ2VzJywgeyB6ZW50eXBlID0gJ2EnLCBlbmNvZGluZyA9ICdzdHJpbmcnfSkKZW5kKQoKV2hlbigiY3JlYXRlIGJicyBwcm9vZiIsIGZ1bmN0aW9uKCkKICAgIGVtcHR5J2JicyBwcm9vZicKICAgIGxvY2FsIHBoID0gaGF2ZSdiYnMgcHJlc2VudGF0aW9uIGhlYWRlcic6b2N0ZXQoKQogICAgbG9jYWwgbWVzc2FnZV9vY3RldHMgPSBoYXZlJ2JicyBtZXNzYWdlcycKICAgIGxvY2FsIGZsb2F0X2luZGV4ZXMgPSBoYXZlJ2JicyBkaXNjbG9zZWQgaW5kZXhlcycKICAgIGxvY2FsIHB1YmsgPSBoYXZlJ2JicyBwdWJsaWMga2V5JwogICAgbG9jYWwgc2lnbmF0dXJlID0gaGF2ZSdiYnMgY3JlZGVudGlhbCcKICAgIGxvY2FsIGNpcGhlcnN1aXRlID0gQkJTLmNpcGhlcnN1aXRlKCdzaGEyNTYnKQogICAgaWYodHlwZShtZXNzYWdlX29jdGV0cykgfj0gJ3RhYmxlJykgdGhlbgogICAgICAgIG1lc3NhZ2Vfb2N0ZXRzID0ge21lc3NhZ2Vfb2N0ZXRzfQogICAgZW5kCiAgICBsb2NhbCBkaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGZsb2F0X2luZGV4ZXMpIGRvCiAgICAgICAgZGlzY2xvc2VkX2luZGV4ZXNba10gPSB0b251bWJlcih2KQogICAgZW5kCiAgICBBQ0suYmJzX3Byb29mID0gQkJTLnByb29mX2dlbihjaXBoZXJzdWl0ZSwgcHViaywgc2lnbmF0dXJlLCBuaWwsIHBoLCBtZXNzYWdlX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBuZXdfY29kZWMoJ2JicyBwcm9vZicsIHsgemVudHlwZSA9ICdlJ30pCmVuZCkKCldoZW4oImNyZWF0ZSBiYnMgc2hha2UgcHJvb2YiLCBmdW5jdGlvbigpCiAgICBlbXB0eSdiYnMgc2hha2UgcHJvb2YnCiAgICBsb2NhbCBwaCA9IGhhdmUnYmJzIHByZXNlbnRhdGlvbiBoZWFkZXInOm9jdGV0KCkKICAgIGxvY2FsIG1lc3NhZ2Vfb2N0ZXRzID0gaGF2ZSdiYnMgbWVzc2FnZXMnCiAgICBsb2NhbCBmbG9hdF9pbmRleGVzID0gaGF2ZSdiYnMgZGlzY2xvc2VkIGluZGV4ZXMnCiAgICBsb2NhbCBwdWJrID0gaGF2ZSdiYnMgc2hha2UgcHVibGljIGtleScKICAgIGxvY2FsIHNpZ25hdHVyZSA9IGhhdmUnYmJzIHNoYWtlIGNyZWRlbnRpYWwnCiAgICBsb2NhbCBjaXBoZXJzdWl0ZSA9IEJCUy5jaXBoZXJzdWl0ZSgnc2hha2UyNTYnKQogICAgaWYodHlwZShtZXNzYWdlX29jdGV0cykgfj0gJ3RhYmxlJykgdGhlbgogICAgICAgIG1lc3NhZ2Vfb2N0ZXRzID0ge21lc3NhZ2Vfb2N0ZXRzfQogICAgZW5kCiAgICBsb2NhbCBkaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGZsb2F0X2luZGV4ZXMpIGRvCiAgICAgICAgZGlzY2xvc2VkX2luZGV4ZXNba10gPSB0b251bWJlcih2KQogICAgZW5kCiAgICBBQ0suYmJzX3NoYWtlX3Byb29mID0gQkJTLnByb29mX2dlbihjaXBoZXJzdWl0ZSwgcHViaywgc2lnbmF0dXJlLCBuaWwsIHBoLCBtZXNzYWdlX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBuZXdfY29kZWMoJ2JicyBzaGFrZSBwcm9vZicsIHsgemVudHlwZSA9ICdlJ30pCmVuZCkKCklmV2hlbigidmVyaWZ5IGJicyBwcm9vZiIsIGZ1bmN0aW9uKCkKICAgIGxvY2FsIGNpcGhlcnN1aXRlID0gQkJTLmNpcGhlcnN1aXRlKCdzaGEyNTYnKQogICAgbG9jYWwgcHViayA9IGhhdmUnYmJzIHB1YmxpYyBrZXknCiAgICBsb2NhbCBwcm9vZiA9IGhhdmUnYmJzIHByb29mJwogICAgbG9jYWwgcGggPSBoYXZlJ2JicyBwcmVzZW50YXRpb24gaGVhZGVyJzpvY3RldCgpCiAgICBsb2NhbCBkaXNjbG9zZWRfbWVzc2FnZXNfb2N0ZXRzID0gaGF2ZSdiYnMgZGlzY2xvc2VkIG1lc3NhZ2VzJwogICAgbG9jYWwgZmxvYXRfaW5kZXhlcyA9IGhhdmUnYmJzIGRpc2Nsb3NlZCBpbmRleGVzJwogICAgbG9jYWwgZGlzY2xvc2VkX2luZGV4ZXMgPSB7fQogICAgZm9yIGssdiBpbiBwYWlycyhmbG9hdF9pbmRleGVzKSBkbwogICAgICAgIGRpc2Nsb3NlZF9pbmRleGVzW2tdID0gdG9udW1iZXIodikKICAgIGVuZAogICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgQkJTLnByb29mX3ZlcmlmeShjaXBoZXJzdWl0ZSwgcHViaywgcHJvb2YsIG5pbCwgcGgsIGRpc2Nsb3NlZF9tZXNzYWdlc19vY3RldHMsIGRpc2Nsb3NlZF9pbmRleGVzKSwKICAgICAgICdUaGUgYmJzIHByb29mIGlzIG5vdCB2YWxpZCcpCmVuZCkKCklmV2hlbigidmVyaWZ5IGJicyBzaGFrZSBwcm9vZiIsIGZ1bmN0aW9uKCkKICAgIGxvY2FsIGNpcGhlcnN1aXRlID0gQkJTLmNpcGhlcnN1aXRlKCdzaGFrZTI1NicpCiAgICBsb2NhbCBwdWJrID0gaGF2ZSdiYnMgc2hha2UgcHVibGljIGtleScKICAgIGxvY2FsIHByb29mID0gaGF2ZSdiYnMgc2hha2UgcHJvb2YnCiAgICBsb2NhbCBwaCA9IGhhdmUnYmJzIHByZXNlbnRhdGlvbiBoZWFkZXInOm9jdGV0KCkKICAgIGxvY2FsIGRpc2Nsb3NlZF9tZXNzYWdlc19vY3RldHMgPSBoYXZlJ2JicyBkaXNjbG9zZWQgbWVzc2FnZXMnCiAgICBsb2NhbCBmbG9hdF9pbmRleGVzID0gaGF2ZSdiYnMgZGlzY2xvc2VkIGluZGV4ZXMnCiAgICBsb2NhbCBkaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGZsb2F0X2luZGV4ZXMpIGRvCiAgICAgICAgZGlzY2xvc2VkX2luZGV4ZXNba10gPSB0b251bWJlcih2KQogICAgZW5kCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBCQlMucHJvb2ZfdmVyaWZ5KGNpcGhlcnN1aXRlLCBwdWJrLCBwcm9vZiwgbmlsLCBwaCwgZGlzY2xvc2VkX21lc3NhZ2VzX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpLAogICAgICAgJ1RoZSBiYnMgc2hha2UgcHJvb2YgaXMgbm90IHZhbGlkJykKZW5kKQoKLS1iYnMucHJvb2ZfZ2VuKGNpcGhlcnN1aXRlLCBwaywgc2lnbmF0dXJlLCBoZWFkZXIsIHBoLCBtZXNzYWdlc19vY3RldHMsIGRpc2Nsb3NlZF9pbmRleGVzKQpXaGVuKCJjcmVhdGUgYmJzIHByb29mIG9mIHNpZ25hdHVyZSAnJyBvZiBtZXNzYWdlcyAnJyB3aXRoIHB1YmxpYyBrZXkgJycgcHJlc2VudGF0aW9uIGhlYWRlciAnJyBhbmQgZGlzY2xvc2VkIGluZGV4ZXMgJyciLCBmdW5jdGlvbihzaWcsIG1zZywgcGssIHByaCwgZGlzX2luZCkKICAgIGVtcHR5J2JicyBwcm9vZicKICAgIGxvY2FsIG1lc3NhZ2Vfb2N0ZXRzID0gaGF2ZShtc2cpCiAgICBsb2NhbCBmbG9hdF9pbmRleGVzID0gaGF2ZShkaXNfaW5kKQogICAgbG9jYWwgcHViayA9IGhhdmUocGspCiAgICBsb2NhbCBzaWduYXR1cmUgPSBoYXZlKHNpZykKICAgIGxvY2FsIGNpcGhlcnN1aXRlID0gQkJTLmNpcGhlcnN1aXRlKCdzaGEyNTYnKQogICAgbG9jYWwgcGggPSBoYXZlKHByaCk6b2N0ZXQoKQogICAgaWYodHlwZShtZXNzYWdlX29jdGV0cykgfj0gJ3RhYmxlJykgdGhlbgogICAgICAgIG1lc3NhZ2Vfb2N0ZXRzID0ge21lc3NhZ2Vfb2N0ZXRzfQogICAgZW5kCiAgICBsb2NhbCBkaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGZsb2F0X2luZGV4ZXMpIGRvCiAgICAgICAgZGlzY2xvc2VkX2luZGV4ZXNba10gPSB0b251bWJlcih2KQogICAgZW5kCiAgICBBQ0suYmJzX3Byb29mID0gQkJTLnByb29mX2dlbihjaXBoZXJzdWl0ZSwgcHViaywgc2lnbmF0dXJlLCBuaWwsIHBoLCBtZXNzYWdlX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBuZXdfY29kZWMoJ2JicyBwcm9vZicsIHsgemVudHlwZSA9ICdlJ30pCmVuZCkKCi0tYmJzLnByb29mX2dlbihjaXBoZXJzdWl0ZSwgcGssIHNpZ25hdHVyZSwgaGVhZGVyLCBwaCwgbWVzc2FnZXNfb2N0ZXRzLCBkaXNjbG9zZWRfaW5kZXhlcykKV2hlbigiY3JlYXRlIGJicyBzaGFrZSBwcm9vZiBvZiBzaWduYXR1cmUgJycgb2YgbWVzc2FnZXMgJycgd2l0aCBwdWJsaWMga2V5ICcnIHByZXNlbnRhdGlvbiBoZWFkZXIgJycgYW5kIGRpc2Nsb3NlZCBpbmRleGVzICcnIiwgZnVuY3Rpb24oc2lnLCBtc2csIHBrLCBwcmgsIGRpc19pbmQpCiAgICBlbXB0eSdiYnMgc2hha2UgcHJvb2YnCiAgICBsb2NhbCBtZXNzYWdlX29jdGV0cyA9IGhhdmUobXNnKQogICAgbG9jYWwgZmxvYXRfaW5kZXhlcyA9IGhhdmUoZGlzX2luZCkKICAgIGxvY2FsIHB1YmsgPSBoYXZlKHBrKQogICAgbG9jYWwgc2lnbmF0dXJlID0gaGF2ZShzaWcpCiAgICBsb2NhbCBjaXBoZXJzdWl0ZSA9IEJCUy5jaXBoZXJzdWl0ZSgnc2hha2UyNTYnKQogICAgbG9jYWwgcGggPSBoYXZlKHByaCk6b2N0ZXQoKQogICAgaWYodHlwZShtZXNzYWdlX29jdGV0cykgfj0gJ3RhYmxlJykgdGhlbgogICAgICAgIG1lc3NhZ2Vfb2N0ZXRzID0ge21lc3NhZ2Vfb2N0ZXRzfQogICAgZW5kCiAgICBsb2NhbCBkaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGZsb2F0X2luZGV4ZXMpIGRvCiAgICAgICAgZGlzY2xvc2VkX2luZGV4ZXNba10gPSB0b251bWJlcih2KQogICAgZW5kCiAgICBBQ0suYmJzX3NoYWtlX3Byb29mID0gQkJTLnByb29mX2dlbihjaXBoZXJzdWl0ZSwgcHViaywgc2lnbmF0dXJlLCBuaWwsIHBoLCBtZXNzYWdlX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpCiAgICBuZXdfY29kZWMoJ2JicyBzaGFrZSBwcm9vZicsIHsgemVudHlwZSA9ICdlJ30pCmVuZCkKCi0tYmJzLnByb29mX3ZlcmlmeShjaXBoZXJzdWl0ZSwgcGssIHByb29mLCBoZWFkZXIsIHBoLCBkaXNjbG9zZWRfbWVzc2FnZXNfb2N0ZXRzLCBkaXNjbG9zZWRfaW5kZXhlcykKSWZXaGVuKCJ2ZXJpZnkgYmJzIHByb29mIHdpdGggcHVibGljIGtleSAnJyBwcmVzZW50YXRpb24gaGVhZGVyICcnIGRpc2Nsb3NlZCBtZXNzYWdlcyAnJyBhbmQgZGlzY2xvc2VkIGluZGV4ZXMgJyciLAogICAgICAgZnVuY3Rpb24ocGssIHByaCwgZGlzX21zZywgZGlzX2luZCkKICAgIGxvY2FsIHB1YmsgPSBoYXZlKHBrKQogICAgbG9jYWwgcHJvb2YgPSBoYXZlJ2JicyBwcm9vZicKICAgIGxvY2FsIHBoID0gaGF2ZShwcmgpOm9jdGV0KCkKICAgIGxvY2FsIGRpc2Nsb3NlZF9tZXNzYWdlc19vY3RldHMgPSBoYXZlKGRpc19tc2cpCiAgICBsb2NhbCBmbG9hdF9pbmRleGVzID0gaGF2ZShkaXNfaW5kKQogICAgbG9jYWwgY2lwaGVyc3VpdGUgPSBCQlMuY2lwaGVyc3VpdGUoJ3NoYTI1NicpCiAgICBsb2NhbCBkaXNjbG9zZWRfaW5kZXhlcyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKGZsb2F0X2luZGV4ZXMpIGRvCiAgICAgICAgZGlzY2xvc2VkX2luZGV4ZXNba10gPSB0b251bWJlcih2KQogICAgZW5kCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBCQlMucHJvb2ZfdmVyaWZ5KGNpcGhlcnN1aXRlLCBwdWJrLCBwcm9vZiwgbmlsLCBwaCwgZGlzY2xvc2VkX21lc3NhZ2VzX29jdGV0cywgZGlzY2xvc2VkX2luZGV4ZXMpLAogICAgICAgJ1RoZSBiYnMgcHJvb2YgaXMgbm90IHZhbGlkJykKZW5kKQoKLS1iYnMucHJvb2ZfdmVyaWZ5KGNpcGhlcnN1aXRlLCBwaywgcHJvb2YsIGhlYWRlciwgcGgsIGRpc2Nsb3NlZF9tZXNzYWdlc19vY3RldHMsIGRpc2Nsb3NlZF9pbmRleGVzKQpJZldoZW4oInZlcmlmeSBiYnMgc2hha2UgcHJvb2Ygd2l0aCBwdWJsaWMga2V5ICcnIHByZXNlbnRhdGlvbiBoZWFkZXIgJycgZGlzY2xvc2VkIG1lc3NhZ2VzICcnIGFuZCBkaXNjbG9zZWQgaW5kZXhlcyAnJyIsCiAgICAgICBmdW5jdGlvbihwaywgcHJoLCBkaXNfbXNnLCBkaXNfaW5kKQogICAgbG9jYWwgcHViayA9IGhhdmUocGspCiAgICBsb2NhbCBwcm9vZiA9IGhhdmUnYmJzIHNoYWtlIHByb29mJwogICAgbG9jYWwgcGggPSBoYXZlKHByaCk6b2N0ZXQoKQogICAgbG9jYWwgZGlzY2xvc2VkX21lc3NhZ2VzX29jdGV0cyA9IGhhdmUoZGlzX21zZykKICAgIGxvY2FsIGZsb2F0X2luZGV4ZXMgPSBoYXZlKGRpc19pbmQpCiAgICBsb2NhbCBjaXBoZXJzdWl0ZSA9IEJCUy5jaXBoZXJzdWl0ZSgnc2hha2UyNTYnKQogICAgbG9jYWwgZGlzY2xvc2VkX2luZGV4ZXMgPSB7fQogICAgZm9yIGssdiBpbiBwYWlycyhmbG9hdF9pbmRleGVzKSBkbwogICAgICAgIGRpc2Nsb3NlZF9pbmRleGVzW2tdID0gdG9udW1iZXIodikKICAgIGVuZAogICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgQkJTLnByb29mX3ZlcmlmeShjaXBoZXJzdWl0ZSwgcHViaywgcHJvb2YsIG5pbCwgcGgsIGRpc2Nsb3NlZF9tZXNzYWdlc19vY3RldHMsIGRpc2Nsb3NlZF9pbmRleGVzKSwKICAgICAgICdUaGUgYmJzIHNoYWtlIHByb29mIGlzIG5vdCB2YWxpZCcpCmVuZCkKL3plbmNvZGVfYml0Y29pbi5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjEtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgQWxiZXJ0byBMZXJkYSBhbmQgRGVuaXMgUm9pbwotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBTYXR1cmRheSwgOXRoIEFwcmlsIDIwMjIKLS1dXQoKQlRDID0gcmVxdWlyZV9vbmNlJ2NyeXB0b19iaXRjb2luJwoKbG9jYWwgZnVuY3Rpb24gX2JpdGNvaW5fdW5zcGVudF9pbXBvcnQob2JqKQogICAgbG9jYWwgcmVzID0ge30KICAgIGZvciBfLHYgaW4gcGFpcnMob2JqKSBkbwogICAgICAgIC0tIGNvbXBhdGliaWxpdHkgd2l0aCBlbGVjdHJ1bSBhbmQgYml0Y29pbiBjb3JlCiAgICAgICAgbG9jYWwgbl9hbW91bnQgPSBmaWYoIHYuYW1vdW50LCAnYW1vdW50JywgJ3ZhbHVlJykKICAgICAgICBsb2NhbCBuX3R4aWQgPSBmaWYoIHYudHhpZCwgJ3R4aWQnLCAncHJldm91dF9oYXNoJykKICAgICAgICBsb2NhbCBuX3ZvdXQgPSBmaWYoIHYudm91dCwgJ3ZvdXQnLCAncHJldm91dF9uJykKICAgICAgICBsb2NhbCBhZGRyZXNzCiAgICAgICAgaWYgdi5hZGRyZXNzIHRoZW4KCSAgICAgICAgYWRkcmVzcyA9IHNjaGVtYV9nZXQodiwnYWRkcmVzcycsIE8uZnJvbV9zZWd3aXQsIHRvc3RyaW5nKQogICAgICAgIGVuZAogICAgICAgIHRhYmxlLmluc2VydChyZXMsIHsKICAgICAgICAgICAgYWRkcmVzcyA9IGFkZHJlc3MsCiAgICAgICAgICAgIGFtb3VudCAgPSBzY2hlbWFfZ2V0KHYsIG5fYW1vdW50LCBCVEMudmFsdWVfYnRjX3RvX3NhdG9zaGksIHRvc3RyaW5nKSwKICAgICAgICAgICAgdHhpZCAgICA9IHNjaGVtYV9nZXQodiwgbl90eGlkLCBPQ1RFVC5mcm9tX2hleCwgdG9zdHJpbmcpLAogICAgICAgICAgICB2b3V0ICAgID0gc2NoZW1hX2dldCh2LCBuX3ZvdXQsIElOVC5uZXcpCiAgICAgICAgfSkKICAgZW5kCiAgIHJldHVybiByZXMKZW5kCmxvY2FsIGZ1bmN0aW9uIF9iaXRjb2luX3Vuc3BlbnRfZXhwb3J0KG9iaikKICAgIGxvY2FsIHJlcyA9IHsgfQogICAgZm9yIF8sdiBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgLS0gdG9fc2Vnd2l0OiBvY3RldCwgdmVyc2lvbiBudW1iZXIoMCksICdiYycgb3IgJ3RjJwogICAgICAgIHRhYmxlLmluc2VydChyZXMsIHsKICAgICAgICAgICAgYWRkcmVzcyA9IHYuYWRkcmVzczpzZWd3aXQoMCwgJ3RiJyksCiAgICAgICAgICAgIGFtb3VudCAgPSBCVEMudmFsdWVfc2F0b3NoaV90b19idGModi5hbW91bnQpLAogICAgICAgICAgICB0eGlkICAgID0gdi50eGlkOmhleCgpLAogICAgICAgICAgICB2b3V0ICAgID0gdi52b3V0CiAgICAgICAgfSkKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIF9zYXRvc2hpX3Vuc3BlbnRfaW1wb3J0KG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICBmb3IgXyx2IGluIHBhaXJzKG9iaikgZG8KICAgICAgICB0YWJsZS5pbnNlcnQocmVzLCB7CiAgICAgICAgICAgIGFtb3VudCA9IHNjaGVtYV9nZXQodiwndmFsdWUnLCBJTlQubmV3KSwKICAgICAgICAgICAgdHhpZCAgID0gc2NoZW1hX2dldCh2LCd0eGlkJywgT0NURVQuZnJvbV9oZXgsIHRvc3RyaW5nKSwKICAgICAgICAgICAgdm91dCAgID0gRi5uZXcodi52b3V0KQogICAgICAgIH0pCiAgICBlbmQKICAgIHJldHVybihyZXMpCmVuZApsb2NhbCBmdW5jdGlvbiBfc2F0b3NoaV91bnNwZW50X2V4cG9ydChvYmopCiAgICBsb2NhbCByZXMgPSB7fQogICAgZm9yIF8sdiBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgdGFibGUuaW5zZXJ0KHJlcywgewogICAgICAgICAgICBhbW91bnQgPSBCSUcudG9fZGVjaW1hbCh2LmFtb3VudCksCiAgICAgICAgICAgIHR4aWQgICA9IHYudHhpZDpoZXgoKSwKICAgICAgICAgICAgdm91dCAgID0gdi52b3V0CiAgICAgICAgfSkKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIF9hZGRyZXNzX2ltcG9ydChvYmopCiAgICBsb2NhbCByYXcsIHZlcnNpb24gPSBPLmZyb21fc2Vnd2l0KHRvc3RyaW5nKG9iaikpCiAgICBsb2NhbCBuZXR3b3JrID0gb2JqOnN1YigwLDIpCiAgICByZXR1cm4gewogICAgICAgIHJhdyA9IHJhdywKICAgICAgICB2ZXJzaW9uID0gRi5uZXcodmVyc2lvbiksCiAgICAgICAgbmV0d29yayA9IE8uZnJvbV9zdHJpbmcobmV0d29yaykKICAgIH0KZW5kCmxvY2FsIGZ1bmN0aW9uIF9hZGRyZXNzX2V4cG9ydChvYmopCiAgICBpZiBub3Qgb2JqLnJhdyB0aGVuIGVycm9yKCJDYW5ub3QgZXhwb3J0IGludmFsaWQgYml0Y29pbiBhZGRyZXNzIiwyKSBlbmQKICAgIHJldHVybiBPLnRvX3NlZ3dpdChvYmoucmF3LCB0b251bWJlcihvYmoudmVyc2lvbiksIE8udG9fc3RyaW5nKG9iai5uZXR3b3JrKSkKZW5kCgpsb2NhbCBmdW5jdGlvbiBfcGtfaW1wb3J0KG8pCiAgICBsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG8sICcuJykKICAgIGlmICNyZXMgfj0gMzMgdGhlbgogICAgICAgIGVycm9yKCdJbnZhbGlkIHB1YmxpYyBrZXkgc2l6ZTogJy4uI3JlcywgMikKICAgIGVuZAogICAgaWYgbm90IEVDREgucHViY2hlY2soRUNESC51bmNvbXByZXNzX3B1YmxpY19rZXkocmVzKSkgdGhlbgogICAgICAgIGVycm9yKCdQdWJsaWMga2V5IGlzIG5vdCBhIHZhbGlkIHBvaW50IG9uIGN1cnZlJywgMikKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIGJpdGNvaW5fcHVibGljX2tleSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gX3BrX2ltcG9ydAogICAgICAgIH0sCiAgICAgICAgc2F0b3NoaV9hbW91bnQgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnLicsIEJJRy5mcm9tX2RlY2ltYWwsIHRvc3RyaW5nKSBlbmQsCiAgICAgICAgICAgIGV4cG9ydCA9IEJJRy50b19kZWNpbWFsCiAgICAgICAgfSwKICAgICAgICBzYXRvc2hpX2ZlZSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gc2NoZW1hX2dldChvYmosICcuJywgQklHLmZyb21fZGVjaW1hbCwgdG9zdHJpbmcpIGVuZCwKICAgICAgICAgICAgZXhwb3J0ID0gQklHLnRvX2RlY2ltYWwKICAgICAgICB9LAogICAgICAgIHNhdG9zaGlfdW5zcGVudCA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gX3NhdG9zaGlfdW5zcGVudF9pbXBvcnQsCiAgICAgICAgICAgIGV4cG9ydCA9IF9zYXRvc2hpX3Vuc3BlbnRfZXhwb3J0CiAgICAgICAgfSwKICAgICAgICBiaXRjb2luX3Vuc3BlbnQgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IF9iaXRjb2luX3Vuc3BlbnRfaW1wb3J0LAogICAgICAgICAgICBleHBvcnQgPSBfYml0Y29pbl91bnNwZW50X2V4cG9ydAogICAgICAgIH0sCiAgICAgICAgdGVzdG5ldF91bnNwZW50ID0gewogICAgICAgICAgICBpbXBvcnQgPSBfYml0Y29pbl91bnNwZW50X2ltcG9ydCwKICAgICAgICAgICAgZXhwb3J0ID0gX2JpdGNvaW5fdW5zcGVudF9leHBvcnQKICAgICAgICB9LAogICAgICAgIGJpdGNvaW5fYWRkcmVzcyA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gX2FkZHJlc3NfaW1wb3J0LAogICAgICAgICAgICBleHBvcnQgPSBfYWRkcmVzc19leHBvcnQKICAgICAgICB9LAogICAgICAgIHRlc3RuZXRfYWRkcmVzcyA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gX2FkZHJlc3NfaW1wb3J0LAogICAgICAgICAgICBleHBvcnQgPSBfYWRkcmVzc19leHBvcnQKICAgICAgICB9LAogICAgICAtLSBUT0RPOiB7IHNjaGVtYSA9ICd0cmFuc2FjdGlvbicgfSkKICAgIH0KKQoKLS0gZ2VuZXJhdGUgYSBrZXlwYWlyIGluICJiaXRjb2luIiBmb3JtYXQgKG9ubHkgeCBjb29yZCwgMDMgcHJlcGVuZGVkKQpsb2NhbCBmdW5jdGlvbiBfa2V5Z2VuKG5hbWUpCglpbml0a2V5cmluZyhuYW1lKQoJbG9jYWwga3AgPSBFQ0RILmtleWdlbigpCglBQ0sua2V5cmluZ1tuYW1lXSA9IGtwLnByaXZhdGUKZW5kCldoZW4oImNyZWF0ZSBiaXRjb2luIGtleSIsIGZ1bmN0aW9uKCkgX2tleWdlbignYml0Y29pbicpIGVuZCkKV2hlbigiY3JlYXRlIHRlc3RuZXQga2V5IiwgZnVuY3Rpb24oKSBfa2V5Z2VuKCd0ZXN0bmV0JykgZW5kKQoKbG9jYWwgZnVuY3Rpb24gX2ltcG9ydF93aWYoc2VjLCBuYW1lKQoJCWxvY2FsIHNrID0gaGF2ZShzZWMpCgkJbG9jYWwgcmVzCgkJaWYgI3NrID09IDMyKzYgdGhlbiAtLSB3aWYKCQkgICBCVEMud2lmX3RvX3NrKHNrKSAtLSBjaGVja3MKCQkgICByZXMgPSBzawoJCWVsc2VpZiAjc2sgPT0gMzIgdGhlbgoJCSAgIHJlcyA9IHNrCgkJICAgLS0gVE9ETzogaW1wb3J0IGZyb20gaGR3YWxsZXQgeHByaXYgZm9ybWF0CgkJZWxzZQoJCSAgIGVycm9yKCJJbnZhbGlkICIuLm5hbWUuLiIga2V5IHNpemUgZm9yICIuLnNlYy4uIjogIi4uI3NrKQoJCWVuZAoJCWluaXRrZXlyaW5nKG5hbWUpCgkJQUNLLmtleXJpbmdbbmFtZV0gPSByZXMKZW5kCldoZW4oImNyZWF0ZSBiaXRjb2luIGtleSB3aXRoIHNlY3JldCBrZXkgJyciLCBmdW5jdGlvbihzZWMpCglfaW1wb3J0X3dpZihzZWMsICdiaXRjb2luJykgZW5kKQpXaGVuKCJjcmVhdGUgdGVzdG5ldCBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIiwgZnVuY3Rpb24oc2VjKQoJX2ltcG9ydF93aWYoc2VjLCAndGVzdG5ldCcpIGVuZCkKV2hlbigiY3JlYXRlIGJpdGNvaW4ga2V5IHdpdGggc2VjcmV0ICcnIiwgZnVuY3Rpb24oc2VjKQoJX2ltcG9ydF93aWYoc2VjLCAnYml0Y29pbicpIGVuZCkKV2hlbigiY3JlYXRlIHRlc3RuZXQga2V5IHdpdGggc2VjcmV0ICcnIiwgZnVuY3Rpb24oc2VjKQoJX2ltcG9ydF93aWYoc2VjLCAndGVzdG5ldCcpIGVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9nZXRfcHViKG5hbWUpCgllbXB0eShuYW1lLi4nIHB1YmxpYyBrZXknKQoJbG9jYWwgc2sgPSBoYXZla2V5KG5hbWUpCglBQ0tbbmFtZS4uJ19wdWJsaWNfa2V5J10gPSBFQ0RILnNrX3RvX3B1YmMoc2spCgluZXdfY29kZWMobmFtZS4uJyBwdWJsaWMga2V5JykKZW5kCldoZW4oImNyZWF0ZSBiaXRjb2luIHB1YmxpYyBrZXkiLCBmdW5jdGlvbigpIF9nZXRfcHViKCdiaXRjb2luJykgZW5kKQpXaGVuKCJjcmVhdGUgdGVzdG5ldCBwdWJsaWMga2V5IiwgZnVuY3Rpb24oKSBfZ2V0X3B1YigndGVzdG5ldCcpIGVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9jcmVhdGVfYWRkcihuYW1lLHBmeCkKCWVtcHR5KG5hbWUuLicgYWRkcmVzcycpCglsb2NhbCBwawoJaWYgQUNLW25hbWUuLidfcHVibGljX2tleSddIHRoZW4KCSAgIHBrID0gaGF2ZShuYW1lLi4nIHB1YmxpYyBrZXknKQoJZWxzZQoJICAgcGsgPSBFQ0RILnNrX3RvX3B1YmMoIGhhdmVrZXkobmFtZSkgKQoJZW5kCglBQ0tbbmFtZS4uJ19hZGRyZXNzJ10gPSB7IHJhdyA9IEJUQy5hZGRyZXNzX2Zyb21fcHVibGljX2tleShwayksCgkJCQkgIHZlcnNpb24gPSBGLm5ldygwKSwKCQkJCSAgbmV0d29yayA9IE8uZnJvbV9zdHJpbmcocGZ4KSB9CgluZXdfY29kZWMobmFtZS4uJyBhZGRyZXNzJykKZW5kCldoZW4oImNyZWF0ZSBiaXRjb2luIGFkZHJlc3MiLCBmdW5jdGlvbigpIF9jcmVhdGVfYWRkcignYml0Y29pbicsJ2JjJykgZW5kKQpXaGVuKCJjcmVhdGUgdGVzdG5ldCBhZGRyZXNzIiwgZnVuY3Rpb24oKSBfY3JlYXRlX2FkZHIoJ3Rlc3RuZXQnLCd0YicpIGVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9jcmVhdGVfdHgobmFtZSwgcmVjaXBpZW50KQoJbG9jYWwgdG8gICAgICA9IGhhdmUocmVjaXBpZW50IG9yICdyZWNpcGllbnQnKQoJaWYgbm90IHRvIHRoZW4KCQllcnJvcigiQ2Fubm90IGNyZWF0ZSAiLi5uYW1lLi4iIHRyYW5zYWN0aW9uOiByZWNpcGllbnQgbm90IHNwZWNpZmllZCIpCgllbmQKCWxvY2FsIHEgICAgICAgPSBoYXZlJ3NhdG9zaGkgYW1vdW50JwoJbG9jYWwgZmVlICAgICA9IGhhdmUnc2F0b3NoaSBmZWUnCglsb2NhbCB1bnNwZW50ID0gaGF2ZShuYW1lLi4nIHVuc3BlbnQnKQoJbG9jYWwgdHggPSBCVEMuYnVpbGRfdHhfZnJvbV91bnNwZW50KHVuc3BlbnQsIHRvLCBxLCBmZWUsIEFDSy5zZW5kZXIpCgl6ZW5jb2RlX2Fzc2VydCh0eCwgIk5vdCBlbm91Z2ggIi4ubmFtZS4uIiBpbiB0aGUgdW5zcGVudCBsaXN0IikKCUFDS1tuYW1lLi4nX3RyYW5zYWN0aW9uJ10gPSB0eAoJbmV3X2NvZGVjKG5hbWUuLidfdHJhbnNhY3Rpb24nKSAtLSBUT0RPOiB7IHNjaGVtYSA9ICd0cmFuc2FjdGlvbicgfSkKZW5kCldoZW4oImNyZWF0ZSBiaXRjb2luIHRyYW5zYWN0aW9uIiwgZnVuY3Rpb24oKSBfY3JlYXRlX3R4KCdiaXRjb2luJykgZW5kKQpXaGVuKCJjcmVhdGUgdGVzdG5ldCB0cmFuc2FjdGlvbiIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV90eCgndGVzdG5ldCcpIGVuZCkKV2hlbigiY3JlYXRlIGJpdGNvaW4gdHJhbnNhY3Rpb24gdG8gJyciLCBmdW5jdGlvbihyZWNpcGllbnQpIF9jcmVhdGVfdHgoJ2JpdGNvaW4nLCByZWNpcGllbnQpIGVuZCkKV2hlbigiY3JlYXRlIHRlc3RuZXQgdHJhbnNhY3Rpb24gdG8gJyciLCBmdW5jdGlvbihyZWNpcGllbnQpIF9jcmVhdGVfdHgoJ3Rlc3RuZXQnLCByZWNpcGllbnQpIGVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9zaWduX3R4KG5hbWUpCiAgIGxvY2FsIHNrID0gaGF2ZWtleShuYW1lKQogICBsb2NhbCB0eCA9IGhhdmUobmFtZS4uJ190cmFuc2FjdGlvbicpCiAgIHplbmNvZGVfYXNzZXJ0KG5vdCB0eC53aXRuZXNzLCAiVGhlICIuLm5hbWUuLiIgdHJhbnNhY3Rpb24gaXMgYWxyZWFkeSBzaWduZWQiKQogICB0eC53aXRuZXNzID0gQlRDLmJ1aWxkX3dpdG5lc3ModHgsIHNrKQplbmQKV2hlbigic2lnbiBiaXRjb2luIHRyYW5zYWN0aW9uIiwgZnVuY3Rpb24oKSBfc2lnbl90eCgnYml0Y29pbicpIGVuZCkKV2hlbigic2lnbiB0ZXN0bmV0IHRyYW5zYWN0aW9uIiwgZnVuY3Rpb24oKSBfc2lnbl90eCgndGVzdG5ldCcpIGVuZCkKCmxvY2FsIGZ1bmN0aW9uIF90b3Jhd190eChuYW1lKQoJbG9jYWwgdHggPSBoYXZlKG5hbWUuLicgdHJhbnNhY3Rpb24nKQoJbG9jYWwgZHN0ID0gbmFtZS4uJ19yYXdfdHJhbnNhY3Rpb24nCgllbXB0eShkc3QpCglBQ0tbZHN0XSA9IEJUQy5idWlsZF9yYXdfdHJhbnNhY3Rpb24odHgpCgluZXdfY29kZWMoZHN0LCB7IGVuY29kaW5nID0gJ2hleCcgfSkKZW5kCgpXaGVuKCJjcmVhdGUgYml0Y29pbiByYXcgdHJhbnNhY3Rpb24iLCBmdW5jdGlvbigpIF90b3Jhd190eCgnYml0Y29pbicpIGVuZCkKV2hlbigiY3JlYXRlIHRlc3RuZXQgcmF3IHRyYW5zYWN0aW9uIiwgZnVuY3Rpb24oKSBfdG9yYXdfdHgoJ3Rlc3RuZXQnKSBlbmQpCi96ZW5jb2RlX2NyZWRlbnRpYWwubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFNhdHVyZGF5LCA5dGggQXByaWwgMjAyMgotLV1dCgotLSBBQkMvQ09DT05VVCBpbXBsZW1lbnRhdGlvbiBpbiBaZW5jb2RlCgpsb2NhbCBDUkVEID0gcmVxdWlyZV9vbmNlKCdjcnlwdG9fY3JlZGVudGlhbCcpCi0tIGxvY2FsIEcxID0gRUNQLmdlbmVyYXRvcigpCmxvY2FsIEcyID0gRUNQMi5nZW5lcmF0b3IoKQoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X2lzc3Vlcl9wa19mKG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICBsb2NhbCBzdXBwID0gc2NoZW1hX2dldChvYmosICcuJykKICAgIGlmICh0eXBlKHN1cHApID09ICd6ZW5yb29tLm9jdGV0JykgdGhlbgogICAgICAgIHJlcy5hbHBoYSA9IEVDUDIuZnJvbV96Y2FzaChzdXBwOnN1YigxLCA5NikpCiAgICAgICAgcmVzLmJldGEgPSBFQ1AyLmZyb21femNhc2goc3VwcDpzdWIoOTcsIDE5MikpCiAgICBlbHNlCiAgICAgICAgcmVzLmFscGhhID0gc2NoZW1hX2dldChvYmosICdhbHBoYScsIEVDUDIubmV3KQogICAgICAgIHJlcy5iZXRhID0gc2NoZW1hX2dldChvYmosICdiZXRhJywgRUNQMi5uZXcpCiAgICBlbmQKICAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfY29tcHJlc3NlZF9pc3N1ZXJfcGtfZihvYmopCiAgICByZXR1cm4gb2JqLmFscGhhOnRvX3pjYXNoKCkuLm9iai5iZXRhOnRvX3pjYXNoKCkKZW5kCgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfY3JlZGVudGlhbF9yZXF1ZXN0X2Yob2JqKQogICAgbG9jYWwgcmVxID0gewogICAgICAgIHNpZ24gPSB7CiAgICAgICAgICAgIGEgPSBzY2hlbWFfZ2V0KG9iai5zaWduLCAnYScsIEVDUC5uZXcpLAogICAgICAgICAgICBiID0gc2NoZW1hX2dldChvYmouc2lnbiwgJ2InLCBFQ1AubmV3KQogICAgICAgIH0sCiAgICAgICAgcGlfcyA9IHsKICAgICAgICAgICAgcnIgPSBzY2hlbWFfZ2V0KG9iai5waV9zLCAncnInLCBJTlQubmV3LCBPLmZyb21fYmFzZTY0KSwKICAgICAgICAgICAgcm0gPSBzY2hlbWFfZ2V0KG9iai5waV9zLCAncm0nLCBJTlQubmV3LCBPLmZyb21fYmFzZTY0KSwKICAgICAgICAgICAgcmsgPSBzY2hlbWFfZ2V0KG9iai5waV9zLCAncmsnLCBJTlQubmV3LCBPLmZyb21fYmFzZTY0KSwKICAgICAgICAgICAgY29tbWl0ID0gc2NoZW1hX2dldChvYmoucGlfcywgJ2NvbW1pdCcsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpLAogICAgICAgIH0sCiAgICAgICAgY29tbWl0ID0gc2NoZW1hX2dldChvYmosICdjb21taXQnLCBFQ1AubmV3KSwKICAgICAgICBwdWJsaWMgPSBzY2hlbWFfZ2V0KG9iaiwgJ3B1YmxpYycsIEVDUC5uZXcpCiAgICB9CiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBDUkVELnZlcmlmeV9waV9zKHJlcSksCiAgICAgICAgJ0Vycm9yIGluIGNyZWRlbnRpYWwgcmVxdWVzdDogcHJvb2YgaXMgaW52YWxpZCAodmVyaWZ5X3BpX3MpJwogICAgKQogICAgcmV0dXJuIHJlcQplbmQKCi0tIGV4cG9ydGVkIGZ1bmN0aW9uIChub24gbG9jYWwpIGZvciB1c2UgaW4gemVuY29kZV9wZXRpdGlvbgpmdW5jdGlvbiBpbXBvcnRfY3JlZGVudGlhbF9wcm9vZl9mKG9iaikKICAgIHJldHVybiB7CiAgICAgICAgbnUgPSBzY2hlbWFfZ2V0KG9iaiwgJ251JywgRUNQLm5ldyksCiAgICAgICAga2FwcGEgPSBzY2hlbWFfZ2V0KG9iaiwgJ2thcHBhJywgRUNQMi5uZXcpLAogICAgICAgIHBpX3YgPSB7CiAgICAgICAgICAgIGMgPSBzY2hlbWFfZ2V0KG9iai5waV92LCAnYycsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpLAogICAgICAgICAgICBybSA9IHNjaGVtYV9nZXQob2JqLnBpX3YsICdybScsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpLAogICAgICAgICAgICByciA9IHNjaGVtYV9nZXQob2JqLnBpX3YsICdycicsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpCiAgICAgICAgfSwKICAgICAgICBzaWdtYV9wcmltZSA9IHsKICAgICAgICAgICAgaF9wcmltZSA9IHNjaGVtYV9nZXQob2JqLnNpZ21hX3ByaW1lLCAnaF9wcmltZScsIEVDUC5uZXcpLAogICAgICAgICAgICBzX3ByaW1lID0gc2NoZW1hX2dldChvYmouc2lnbWFfcHJpbWUsICdzX3ByaW1lJywgRUNQLm5ldykKICAgICAgICB9CiAgICB9CmVuZAoKZnVuY3Rpb24gZXhwb3J0X2NyZWRlbnRpYWxfcHJvb2ZfZihvYmopCiAgICBvYmoucGlfdi5yciA9IG9iai5waV92LnJyOm9jdGV0KCkKICAgIG9iai5waV92LnJtID0gb2JqLnBpX3Yucm06b2N0ZXQoKQogICAgb2JqLnBpX3YuYyA9IG9iai5waV92LmM6b2N0ZXQoKQogICAgcmV0dXJuIG9iagplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIC0tIHRoZXRhOiBibGluZCBwcm9vZiBvZiBjZXJ0aWZpY2F0aW9uCiAgICAgICAgY3JlZGVudGlhbF9wcm9vZiA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X2NyZWRlbnRpYWxfcHJvb2ZfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X2NyZWRlbnRpYWxfcHJvb2ZfZiwKICAgICAgICB9LAogICAgICAgIGlzc3Vlcl9wdWJsaWNfa2V5ID0gewogICAgICAgICAgICBpbXBvcnQgPSBpbXBvcnRfaXNzdWVyX3BrX2YKICAgICAgICB9LAogICAgICAgIGNvbXByZXNzZWRfaXNzdWVyX3B1YmxpY19rZXkgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGltcG9ydF9pc3N1ZXJfcGtfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X2NvbXByZXNzZWRfaXNzdWVyX3BrX2YKICAgICAgICB9LAogICAgICAgIGNyZWRlbnRpYWxfcmVxdWVzdCA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X2NyZWRlbnRpYWxfcmVxdWVzdF9mCiAgICAgICAgfQogICAgfQopCgotLSBjcmVkZW50aWFsIGtleXBhaXIgb3BlcmF0aW9ucwpXaGVuKCJjcmVhdGUgY3JlZGVudGlhbCBrZXkiLGZ1bmN0aW9uKCkKCWluaXRrZXlyaW5nJ2NyZWRlbnRpYWwnCglBQ0sua2V5cmluZy5jcmVkZW50aWFsID0gSU5ULnJhbmRvbSgpCmVuZCkKCldoZW4oImNyZWF0ZSBjcmVkZW50aWFsIGtleSB3aXRoIHNlY3JldCBrZXkgJyciLGZ1bmN0aW9uKHNlYykKCWluaXRrZXlyaW5nJ2NyZWRlbnRpYWwnCglsb2NhbCBzZWNyZXQgPSBoYXZlKHNlYykKCUFDSy5rZXlyaW5nLmNyZWRlbnRpYWwgPSBJTlQubmV3KHNlY3JldCkKZW5kKQpXaGVuKCJjcmVhdGUgY3JlZGVudGlhbCBrZXkgd2l0aCBzZWNyZXQgJyciLGZ1bmN0aW9uKHNlYykKCWluaXRrZXlyaW5nJ2NyZWRlbnRpYWwnCglsb2NhbCBzZWNyZXQgPSBoYXZlKHNlYykKCUFDSy5rZXlyaW5nLmNyZWRlbnRpYWwgPSBJTlQubmV3KHNlY3JldCkKZW5kKQoKV2hlbigiY3JlYXRlIGlzc3VlciBrZXkiLGZ1bmN0aW9uKCkKCQlpbml0a2V5cmluZydpc3N1ZXInCgkJQUNLLmtleXJpbmcuaXNzdWVyID0gQ1JFRC5pc3N1ZXJfa2V5Z2VuKCkKCWVuZAopCgpXaGVuKCJjcmVhdGUgaXNzdWVyIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKCWhhdmVrZXknaXNzdWVyJwoJQUNLLmlzc3Vlcl9wdWJsaWNfa2V5ID0gewoJICAgYWxwaGEgPSBHMiAqIEFDSy5rZXlyaW5nLmlzc3Vlci54LAoJICAgYmV0YSA9IEcyICogQUNLLmtleXJpbmcuaXNzdWVyLnkKCX0KCW5ld19jb2RlYydpc3N1ZXIgcHVibGljIGtleScKZW5kKQoKV2hlbigiY3JlYXRlIGNyZWRlbnRpYWwgcmVxdWVzdCIsIGZ1bmN0aW9uKCkKCWhhdmVrZXknY3JlZGVudGlhbCcKCUFDSy5jcmVkZW50aWFsX3JlcXVlc3QgPSBDUkVELnByZXBhcmVfYmxpbmRfc2lnbihBQ0sua2V5cmluZy5jcmVkZW50aWFsKQoJbmV3X2NvZGVjKCdjcmVkZW50aWFsIHJlcXVlc3QnKQplbmQpCgotLSBpc3N1ZXIncyBzaWduYXR1cmUgb2YgY3JlZGVudGlhbHMKWkVOOmFkZF9zY2hlbWEoCiAgIHsKICAgICAgLS0gc2lnbWF0aWxkZQogICAgICBjcmVkZW50aWFsX3NpZ25hdHVyZSA9IHsKCQkgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQoJCQlyZXR1cm4gewoJCQkgICBoID0gc2NoZW1hX2dldChvYmosICdoJywgRUNQLm5ldyksCgkJCSAgIGJfdGlsZGUgPSBzY2hlbWFfZ2V0KG9iaiwgJ2JfdGlsZGUnLCBFQ1AubmV3KSwKCQkJICAgYV90aWxkZSA9IHNjaGVtYV9nZXQob2JqLCAnYV90aWxkZScsIEVDUC5uZXcpCgkJCX0KCQkgZW5kCgkgIH0sCiAgICAgIC0tIGFnZ3NpZ21hOiBhZ2dyZWdhdGVkIHNpZ25hdHVyZXMgb2YgY2EgaXNzdWVycwoJICBjcmVkZW50aWFscyA9IHsKCQkgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQoJCQlyZXR1cm4gewoJCQkgICBoID0gc2NoZW1hX2dldChvYmosICdoJywgRUNQLm5ldyksCgkJCSAgIHMgPSBzY2hlbWFfZ2V0KG9iaiwgJ3MnLCBFQ1AubmV3KQoJCQl9CgkJIGVuZAoJICB9CiAgIH0KKQpXaGVuKCJjcmVhdGUgY3JlZGVudGlhbCBzaWduYXR1cmUiLGZ1bmN0aW9uKCkKCQloYXZlICdjcmVkZW50aWFsIHJlcXVlc3QnCiAgICAgIGhhdmVrZXknaXNzdWVyJwogICAgICBBQ0suY3JlZGVudGlhbF9zaWduYXR1cmUgPQoJIENSRUQuYmxpbmRfc2lnbihBQ0sua2V5cmluZy5pc3N1ZXIsIEFDSy5jcmVkZW50aWFsX3JlcXVlc3QpCiAgICAgIEFDSy52ZXJpZmllciA9IHsKCSBhbHBoYSA9IEcyICogQUNLLmtleXJpbmcuaXNzdWVyLngsCgkgYmV0YSA9IEcyICogQUNLLmtleXJpbmcuaXNzdWVyLnkKICAgICAgfQogICAgICBuZXdfY29kZWMnY3JlZGVudGlhbCBzaWduYXR1cmUnCiAgICAgIG5ld19jb2RlYyd2ZXJpZmllcicKICAgZW5kCikKV2hlbigiY3JlYXRlIGNyZWRlbnRpYWxzIixmdW5jdGlvbigpCiAgICAgIGhhdmUgJ2NyZWRlbnRpYWwgc2lnbmF0dXJlJwogICAgICBoYXZla2V5J2NyZWRlbnRpYWwnCiAgICAgIC0tIHByZXBhcmUgb3V0cHV0IHdpdGggYW4gYWdncmVnYXRlZCBzaWdtYSBjcmVkZW50aWFsCiAgICAgIC0tIHJlcXVlc3RlciBzaWducyB0aGUgc2lnbWEgd2l0aCBwcml2YXRlIGtleQogICAgICBBQ0suY3JlZGVudGlhbHMgPQoJIENSRUQuYWdncmVnYXRlX2NyZWRzKEFDSy5rZXlyaW5nLmNyZWRlbnRpYWwsIHtBQ0suY3JlZGVudGlhbF9zaWduYXR1cmV9KQogICAgICBuZXdfY29kZWMnY3JlZGVudGlhbHMnCiAgIGVuZAopCgpXaGVuKCJhZ2dyZWdhdGUgY3JlZGVudGlhbHMgaW4gJyciLGZ1bmN0aW9uKGNyZWRzKQogICAgICBsb2NhbCBjcmVkX3QgPSBoYXZlKGNyZWRzKQogICAgICBoYXZla2V5J2NyZWRlbnRpYWwnCiAgICAgIC0tIHByZXBhcmUgb3V0cHV0IHdpdGggYW4gYWdncmVnYXRlZCBzaWdtYSBjcmVkZW50aWFsCiAgICAgIC0tIHJlcXVlc3RlciBzaWducyB0aGUgc2lnbWEgd2l0aCBwcml2YXRlIGtleQogICAgICBBQ0suY3JlZGVudGlhbHMgPQoJCSBDUkVELmFnZ3JlZ2F0ZV9jcmVkcyhBQ0sua2V5cmluZy5jcmVkZW50aWFsLCBjcmVkX3QpCiAgICAgIG5ld19jb2RlYydjcmVkZW50aWFscycKICAgZW5kCikKCldoZW4oImFnZ3JlZ2F0ZSBpc3N1ZXIgcHVibGljIGtleXMiLGZ1bmN0aW9uKCkKCQloYXZlICdpc3N1ZXIgcHVibGljIGtleScKCQlpZiBub3QgQUNLLnZlcmlmaWVycyB0aGVuCgkJCUFDSy52ZXJpZmllcnMgPSB7fQoJCWVuZAoJCWZvciBrLCB2IGluIHBhaXJzKEFDSy5pc3N1ZXJfcHVibGljX2tleSkgZG8KCQkJQUNLLnZlcmlmaWVyc1trXSA9IHYKCQllbmQKCQktLSBUT0RPOiBhZ2dyZWdhdGUgYWxsIGFycmF5CgkJbmV3X2NvZGVjJ3ZlcmlmaWVycycKCWVuZAopCgoKV2hlbigiYWdncmVnYXRlIHZlcmlmaWVycyBpbiAnJyIsZnVuY3Rpb24oaXNzdWVycykKCQlsb2NhbCBpc3N1ZXJzX3QgPSBoYXZlKGlzc3VlcnMpCgkJZW1wdHknJwoJCWxvY2FsIHJlcyA9IHsgYWxwaGEgPSBuaWwsIGJldGEgPSBuaWx9CgkJZm9yIGssIHYgaW4gcGFpcnMoaXNzdWVyc190KSBkbwoJCSAgIGlmIG5vdCByZXMuYWxwaGEgdGhlbiByZXMuYWxwaGEgPSB2LmFscGhhCgkJCSAgZWxzZSByZXMuYWxwaGEgPSByZXMuYWxwaGEgKyB2LmFscGhhIGVuZAoJCSAgIGlmIG5vdCByZXMuYmV0YSB0aGVuIHJlcy5iZXRhID0gdi5iZXRhCgkJCSAgZWxzZSByZXMuYmV0YSA9IHJlcy5iZXRhICsgdi5iZXRhIGVuZAoJCWVuZAoJCUFDSy52ZXJpZmllcnMgPSByZXMKCQluZXdfY29kZWMndmVyaWZpZXJzJwoJZW5kCikKCldoZW4oImNyZWF0ZSBjcmVkZW50aWFsIHByb29mIixmdW5jdGlvbigpCgkJaGF2ZSAndmVyaWZpZXJzJwoJCWhhdmUgJ2NyZWRlbnRpYWxzJwoJCWVtcHR5ICdjcmVkZW50aWFsIHByb29mJwoJCWhhdmVrZXknY3JlZGVudGlhbCcKCQlBQ0suY3JlZGVudGlhbF9wcm9vZiA9CgkJCUNSRUQucHJvdmVfY3JlZChBQ0sudmVyaWZpZXJzLCBBQ0suY3JlZGVudGlhbHMsIEFDSy5rZXlyaW5nLmNyZWRlbnRpYWwpCgkJbmV3X2NvZGVjKCdjcmVkZW50aWFsIHByb29mJykKCWVuZAopCklmV2hlbigidmVyaWZ5IGNyZWRlbnRpYWwgcHJvb2YiLGZ1bmN0aW9uKCkKCQloYXZlICdjcmVkZW50aWFsIHByb29mJwoJCWhhdmUgJ3ZlcmlmaWVycycKCQl6ZW5jb2RlX2Fzc2VydCgKCQkJQ1JFRC52ZXJpZnlfY3JlZChBQ0sudmVyaWZpZXJzLCBBQ0suY3JlZGVudGlhbF9wcm9vZiksCgkJCSdDcmVkZW50aWFsIHByb29mIGRvZXMgbm90IHZhbGlkYXRlJwoJCSkKCWVuZAopCi96ZW5jb2RlX2RhdGEubHVhACAtLVtbCiAtLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KIC0tCiAtLUNvcHlyaWdodCAoQykgMjAxOC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KIC0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KIC0tCiAtLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5CiAtLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKIC0tCiAtLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAogLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgogLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCiAtLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgogLS0KIC0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKIC0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKIC0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0CiAtLQogLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KIC0tb24gU2F0dXJkYXksIDEzdGggTm92ZW1iZXIgMjAyMQogLS1dXQogLS0tIFplbmNvZGUgZGF0YSBpbnRlcm5hbHMKCi0tIFNwZWMgZm9yIG51bWJlciBpbnB1dCAvIG91dHB1dAotLSBpbnB1dCAgfCAgc3BlYyAgfCAgaW50ZXJuYWwgICAgIHwgIG91dHB1dAoKLS0gbnVtICAgICAgIG5vbmUgICAgIGZsb2F0ICAgICAgICAgICBmbG9hdAotLSBudW0gICAgICAgZmxvYXQgICAgZmxvYXQgICAgICAgICAgIGZsb2F0Ci0tIG51bSAgICAgICBpbnQgICAgICBpbnQgICAgICAgICAgICAgc3RyaW5nIChUT0RPKQotLSBzdHJpbmcgICAgbm9uZSAgICAgbWl4ZWQgICAgICAgICAgIHN0cmluZwotLSBzdHJpbmcgICAgaW50ICAgICAgaW50ICAgICAgICAgICAgIHN0cmluZwotLSBzdHJpbmcgICAgZmxvYXQgICAgZmxvYXQgICAgICAgICAgIGZsb2F0CgoKIC0tIFVzZWQgaW4gc2NlbmFyaW8ncyBzY2hlbWEgZGVjbGFyYXRpb25zIHRvIGNhc3QgdG8gemVucm9vbS4gdHlwZQogZnVuY3Rpb24gc2NoZW1hX2dldChvYmosIGtleSwgY29udmVyc2lvbiwgZW5jb2RpbmcpCgktLSBJLndhcm4oe29iaj1vYmosa2V5PWtleSxjb252ZXJzaW9uPWNvbnZlcnNpb24sZW5jb2Rpbmc9ZW5jb2Rpbmd9KQoJaWYgdHlwZShrZXkpIH49ICdzdHJpbmcnIHRoZW4KCSAgIGVycm9yKCdnZXQga2V5IGlzIG5vdCBhIHN0cmluZycsIDIpCgllbmQKCWlmIGNvbnZlcnNpb24gYW5kIHR5cGUoY29udmVyc2lvbikgfj0gJ2Z1bmN0aW9uJyB0aGVuCgkgICBlcnJvcignZ2V0IGludmFsaWQgY29udmVyc2lvbiBmdW5jdGlvbicsIDIpCgllbmQKCWlmIGVuY29kaW5nIGFuZCB0eXBlKGVuY29kaW5nKSB+PSAnZnVuY3Rpb24nIHRoZW4KCSAgIGVycm9yKCdnZXQgaW52YWxpZCBlbmNvZGluZyBmdW5jdGlvbicsIDIpCgllbmQKCWxvY2FsIGsKCWlmIG5vdCBvYmogdGhlbiAtLSB0YWtlIGZyb20gSU4gcm9vdAoJICAgayA9IElOW2tleV0KCWVsc2UKCSAgIGlmIGtleSA9PSAnLicgdGhlbgogICAgICAgICAgayA9IG9iagoJICAgZWxzZQogICAgICAgICAgayA9IG9ialtrZXldCgkgICBlbmQKCWVuZAoJaWYgayA9PSBuaWwgdGhlbgoJICAgZXJyb3IoJ0tleSBub3QgZm91bmQgaW4gb2JqZWN0IGNvbnZlcnNpb246ICcgLi4ga2V5LCAyKQoJZW5kCglsb2NhbCByZXMgPSBuaWwKCWxvY2FsIHQgPSB0eXBlKGspCgktLSBCSUcvSU5UIGRlZmF1bHQgZXhwb3J0IGlzIGRlY2ltYWwKCWlmIGNvbnZlcnNpb24gPT0gSU5ULm5ldyBhbmQgbm90IGVuY29kaW5nIHRoZW4KCSAgIC0tIGNvbXBhcmUgZnVuY3Rpb24gYWRkcmVzcyBhbmQgdXNlIGRlZmF1bHQKCSAgIHJlcyA9IElOVC5mcm9tX2RlY2ltYWwoaykKCWVsc2VpZiBpc3plbih0KSBhbmQgY29udmVyc2lvbiB0aGVuCgkgICByZXMgPSBjb252ZXJzaW9uKGspCgllbHNlaWYgaXN6ZW4odCkgYW5kIG5vdCBjb252ZXJzaW9uIHRoZW4KCSAgIHJlcyA9IGsKCWVsc2VpZiB0ID09ICdzdHJpbmcnIHRoZW4KCSAgIGlmIGVuY29kaW5nIHRoZW4KICAgICAgICAgIHJlcyA9IGVuY29kaW5nKGspCgkgICBlbHNlCiAgICAgICAgICByZXMgPSBDT05GLmlucHV0LmVuY29kaW5nLmZ1bihrKQoJICAgZW5kCgkgICBpZiBjb252ZXJzaW9uIHRoZW4KICAgICAgICAgIHJlcyA9IGNvbnZlcnNpb24ocmVzKQoJICAgZW5kCiAgZWxzZWlmIHQgPT0gJ2Jvb2xlYW4nIHRoZW4KICAgICByZXMgPSBrCgkgICBpZiBjb252ZXJzaW9uIHRoZW4KICAgICAgICAgIHJlcyA9IGNvbnZlcnNpb24ocmVzKQoJICAgZW5kCgllbHNlCgkgICBpZiB0ID09ICdudW1iZXInIHRoZW4KICAgICAgICAgIHJlcyA9IGsKCSAgIGVuZAoJICAgaWYgdCA9PSAndGFibGUnIHRoZW4KICAgICAgICAgIHJlcyA9IGRlZXBtYXAoZW5jb2Rpbmcgb3IgQ09ORi5pbnB1dC5lbmNvZGluZy5mdW4sIGspCiAgICAgICAgICBpZiBjb252ZXJzaW9uIHRoZW4KCQkJIHJlcyA9IGRlZXBtYXAoY29udmVyc2lvbiwgcmVzKQogICAgICAgICAgZW5kCgkgICBlbmQKCWVuZAogICBpZiBaRU4gdGhlbgogICAgICAgYXNzZXJ0KFpFTi5PSyBhbmQgcmVzIH49IG5pbCwnZ2V0IG9uIGludmFsaWQga2V5OiAnIC4uIGtleSAuLiAnICgnIC4uIHQgLi4gJyknLCAyKQogICBlbmQKCXJldHVybiByZXMKIGVuZAoKIC0tIHJldHVybiBsZWZ0bW9zdCBhbmQgcmlnaHRtb3N0IGlmIGRlZmluaXRpb24gc3RyaW5nIGluZGljYXRlcwogLS0gYSBsdWEgdGFibGU6IGRpY3Rpb25hcnksIGFycmF5IG9yIHNjaGVtYQogbG9jYWwgZnVuY3Rpb24gZXhwZWN0X3RhYmxlKGRlZmluaXRpb24pCiAgIGxvY2FsIHRva3MgPSBzdHJ0b2soZGVmaW5pdGlvbiwgJ18nKQogICBsb2NhbCByZXMgPSB7IHJpZ2h0bW9zdCA9IHRva3NbI3Rva3NdIH0KICAgaWYgI3Rva3MgPT0gMSBhbmQgcmVzLnJpZ2h0bW9zdCA9PSAnZGljdGlvbmFyeScgdGhlbgogICAgIHJldHVybiByZXMgLS0gZGljdGlvbmFyeSBhbG9uZSBpcyBhY2NlcHRlZCBhcyBjdXN0b21pemFibGUKICAgZW5kCiAgIGlmIHJlcy5yaWdodG1vc3QgPT0gJ2FycmF5JwogICAgIG9yCiAgICAgcmVzLnJpZ2h0bW9zdCA9PSAnZGljdGlvbmFyeScKICAgdGhlbgogICAgIHJlcy5sZWZ0d29yZHMgPSAnJyAtLSBjb25jYXQgYWxsIGxlZnQgd29yZHMgaW4gdG9rcyBtaW51cyB0aGUgbGFzdAogICAgIGZvciBpID0gMSwgI3Rva3MgLSAyIGRvCiAgICAgICByZXMubGVmdHdvcmRzID0gcmVzLmxlZnR3b3JkcyAuLiB0b2tzW2ldIC4uICdfJwogICAgIGVuZAogICAgIHJlcy5sZWZ0d29yZHMgPSB1c2NvcmUoIHJlcy5sZWZ0d29yZHMgLi4gdG9rc1sjdG9rcyAtIDFdICkKICAgICAtLSBubyB0cmFpbGluZyB1bmRlcnNjb3JlCiAgICAgcmV0dXJuIHJlcwogICBlbmQKICAgcmV0dXJuIG5pbAogICAtLSBzY2hlbWFzIG1heSBvciBtYXkgYmUgbm90IHRhYmxlcwogZW5kCgogLS0tIEdpdmVuIGJsb2NrIChJTiByZWFkLW9ubHkgbWVtb3J5KQogLS0gQHNlY3Rpb24gR2l2ZW4KCiAtLS0KIC0tIEd1ZXNzIGhvdyB0byBjb252ZXJ0IHRoZSBvYmplY3QsIHVzaW5nIHdoYXQgZm9ybWF0IG9yIHNjaGVtYQogLS0gY2hlY2sgdGhlIGRlZmluaXRpb24gc3RyaW5nIChjb21pbmcgc3RyYWlnaHQgZnJvbSB6ZW5jb2RlKQogLS0gY29uc2lkZXJpbmcgdGhlIHR5cGUgb2YgdGhlIG9iamVjdDoKIC0tIGBgYAogLS0gdHlwZSAgICBkZWYgICAgICAgY29udgogLS0gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCiAtLSAgICAgICAgIHNjaGVtYSAgICBzY2hlbWFfZig9PT0sIGRlZmF1bHRfZW5jb2RpbmcpCiAtLSBzdHIgICAgIGZvcm1hdCAgICBpbnB1dF9lbmNvZGluZyhmb3JtYXQpCiAtLSBudW0gICAgICAgICAgICAgICBpbnB1dF9lbmNvZGluZyhudW1iZXIpCiAtLSB0YWJsZSAgIGYgZGljdCAgICBkZWVwbWFwKHRhYmxlLCBpbnB1dF9lbmNvZGluZyhmKSkKIC0tIHRhYmxlICAgZiBhcnJheSAgIGRlZXBtYXAodGFibGUsIGlucHV0X2VuY29kaW5nKGYpKQogLS0gYGBgCiAtLSByZXR1cm5zIGEgdGFibGUgd2l0aCBmdW5jdGlvbiBwb2ludGVycyBhbmQgc3RyaW5nIGRlc2MgdGhhdAogLS0gd2lsbCBiZSB1c2VkIGJ5IEB7b3BlcmF0ZV9jb252ZXJzaW9ufQogLS0geyBmdW4gICAgICAgICA9IGNvbnZlcnNpb24gZnVuY3Rpb24gcG9pbnRlcgogLS0gICBjb252ZXJzaW9uICA9IGNvbnZlcnNpb24gc3RyaW5nIGRlc2NyaXB0aW9uCiAtLSAgIGNoZWNrICAgICAgID0gY2hlY2sgZnVuY3Rpb24gcG9pbnRlcgogLS0gICByYXcgICAgICAgICA9IHJhdyBkYXRhIHBvaW50ZXIKIC0tICAgKG5hbWUpICAgICAgPSBrZXkgbmFtZSBvZiBkYXRhIChzZXQgZXh0ZXJuYWxseSkKIC0tICAgKHJvb3QpICAgICAgPSByb290IHNlY3Rpb24gbmFtZSAoc2V0IGV4dGVybmFsbHkpCiAtLSAgIGx1YXR5cGUgICAgID0gdHlwZSBvZiByYXcgZGF0YSBmb3IgbHVhCiAtLSAgIHplbnR5cGUgICAgID0gdHlwZSBvZiBkYXRhIGZvciB6ZW5yb29tIChhcnJheSwgZGljdCwgZWxlbWVudCwgc2NoZW1hKQogLS0gICBtaXNzaW5nICAgICA9IHRydWUgaWYgdGhlIHJhdyBkYXRhIHdhcyBub3QgZm91bmQganVzdCBleHBlY3RlZAogLS0gfQogZnVuY3Rpb24gZ3Vlc3NfY29udmVyc2lvbihvYmosIGRlZmluaXRpb24pCiAgICBsb2NhbCB0CiAgICBsb2NhbCBvYmp0eXBlIDxjb25zdD4gPSBsdWF0eXBlKG9iaikKICAgIGxvY2FsIHJlcwogICAgaWYgbm90IGRlZmluaXRpb24gdGhlbgogICAgICAgZXJyb3IoIkNhbm5vdCB0YWtlIHVuZGVmaW5lZCBvYmplY3QsIGZvdW5kIGEgIi4udHlwZShvYmopLCAzKQogICAgZW5kCiAgICAtLSBhIGRlZmluZWQgc2NoZW1hIG92ZXJyaWRlcyBhbnkgb3RoZXIgY29udmVyc2lvbgogICAgdCA9IFpFTi5zY2hlbWFzW2RlZmluaXRpb25dCiAgICBpZiB0IHRoZW4KICAgICAgIC0tIGNvbXBsZXggc2NoZW1hIGlzIGEgdGFibGUgc3BlY2Z5aW5nIGluL291dCBjb252ZXJzaW9ucyBhczoKICAgICAgIC0tIHtpbXBvcnQ9ZnVuLCBleHBvcnQ9ZnVufQogICAgICAgbG9jYWwgYyA9IGZpZihsdWF0eXBlKHQpPT0ndGFibGUnLCAnY29tcGxleCcsICdkZWYnKQogICAgICAgLS0gZGVmYXVsdCBpcyBhbHdheXMgdGhlIGNvbmZpZ3VyZWQgb3V0cHV0IGVuY29kaW5nCgkgICByZXMgPSB7CgkJICBmdW4gPSB0LAoJCSAgc2NoZW1hID0gZGVmaW5pdGlvbiwKCQkgIHplbnR5cGUgPSAnZScsCgkJICByYXcgPSBvYmosCgkJICBlbmNvZGluZyA9IGMgfQoJICAgaWYgbm90IG9iaiB0aGVuIHJlcy5taXNzaW5nID0gdHJ1ZSBlbmQKCSAgIHJldHVybihyZXMpCiAgICBlbmQKCiAgICAtLSBkZWZpbml0aW9uOiB2YWx1ZV9lbmNvZGluZyAuLiBkYXRhX3R5cGUKICAgIC0tIHZhbHVlX2VuY29kaW5nOiBiYXNlNjQsIGhleCwgZXRjLgogICAgLS0gZGF0YV90eXBlOiBhcnJheSwgZGljdGlvbmFyeSwgc3RydWN0dXJlCiAgICBpZiBvYmp0eXBlID09ICd0YWJsZScgdGhlbgogICAgICBsb2NhbCBkZWYgPSBleHBlY3RfdGFibGUoZGVmaW5pdGlvbikKICAgICAgaWYgbm90IGRlZiB0aGVuIC0tIGNoZWNrIGlmIHRoZSBsYXN0IHdvcmQgaXMgYW1vbmcgemVudHlwZSBjb2xsZWN0aW9ucwogICAgICAgIC0tIGZhbGxiYWNrIHRvIHN0cmluZyBkaWN0aW9uYXJ5IG9yIGFycmF5CiAgICAgICAgaWYgaXNkaWN0aW9uYXJ5KG9iaikgdGhlbgogICAgICAgICAgZGVmID0gZXhwZWN0X3RhYmxlKCdzdHJpbmdfZGljdGlvbmFyeScpCiAgICAgICAgZWxzZQogICAgICAgICAgZGVmID0gZXhwZWN0X3RhYmxlKCdzdHJpbmdfYXJyYXknKQogICAgICAgIGVuZAogICAgICBlbmQKICAgICAgLS0gbWl4ZWQgZGljdGlvbmFyeSBoYXMgYSBjdXN0b20gZGVlcG1hc2sgQ09ERUMgZGVmaW5lZCBpbiBHaXZlbgogICAgICBpZiBub3QgZGVmLmxlZnR3b3JkcyBhbmQgZGVmLnJpZ2h0bW9zdCA9PSAnZGljdGlvbmFyeScgdGhlbgogICAgICAgIHJlcyA9IGlucHV0X2VuY29kaW5nKCdzdHJpbmcnKQogICAgICAgIHJlcy56ZW50eXBlID0gJ2QnCiAgICAgICAgcmVzLnJhdyA9IG9iagogICAgICAgIHJlcy5zdCA9ICdjJyAtLSAnX19jdXN0b21fZGljdGlvbmFyeV9fJwogICAgICAgIHJldHVybihyZXMpCiAgICAgIGVuZAogICAgICAtLSBzY2hlbWEgdHlwZSBpbiBhcnJheSBvciBkaWN0CiAgICAgIHQgPSBaRU4uc2NoZW1hc1sgZGVmLmxlZnR3b3JkcyBdCiAgICAgIGlmIHQgdGhlbgogICAgICAgIHJldHVybiAoewogICAgICAgICAgICBmdW4gPSB0LAogICAgICAgICAgICB6ZW50eXBlID0gc3RyaW5nLnN1YihkZWYucmlnaHRtb3N0LDEsMSksCiAgICAgICAgICAgIHNjaGVtYSA9IGRlZi5sZWZ0d29yZHMsCiAgICAgICAgICAgIGx1YXR5cGUgPSBvYmp0eXBlLAogICAgICAgICAgICByYXcgPSBvYmosCiAgICAgICAgfSkKICAgICAgZW5kCiAgICAgIC0tIG5vcm1hbCB0eXBlIGluIGlucHV0IGVuY29kaW5nOiBzdHJpbmcsIGJhc2U2NCBldGMuCiAgICAgIHJlcyA9IGlucHV0X2VuY29kaW5nKGRlZi5sZWZ0d29yZHMpCiAgICAgIGlmIHJlcyB0aGVuCiAgICAgICAgcmVzLnplbnR5cGUgPSBzdHJpbmcuc3ViKGRlZi5yaWdodG1vc3QsMSwxKQogICAgICAgIHJlcy5yYXcgPSBvYmoKICAgICAgICByZXMuc2NoZW1hID0gbmlsCiAgICAgICAgcmV0dXJuIChyZXMpCiAgICAgIGVuZAogICAgICBlcnJvcigiQ2Fubm90IHRha2Ugb2JqZWN0OiBpbnZhbGlkICIuLmRlZi5yaWdodG1vc3QuLiIgd2l0aCBlbmNvZGluZyAiLi5kZWYubGVmdHdvcmRzLCAzKQogICAgICByZXR1cm4gbmlsCiAgICBlbmQKCiAgICBpZiBvYmp0eXBlID09ICdudW1iZXInIHRoZW4KICAgICAgIGlmIGV4cGVjdF90YWJsZShkZWZpbml0aW9uKSB0aGVuCgkgIGVycm9yKCJDYW5ub3QgdGFrZSBvYmplY3Q6IGV4cGVjdGVkICciLi5kZWZpbml0aW9uLi4iJyBidXQgZm91bmQgJyIuLm9ianR5cGUuLiInIChub3QgYSB0YWJsZSkiLDMpCgkgIC0tIGVsc2VpZiBkZWZpbml0aW9uIH49ICdudW1iZXInIHRoZW4KCSAgLS0JICBlcnJvcigiQ2Fubm90IHRha2Ugb2JqZWN0OiBleHBlY3RlZCAnIi4uZGVmaW5pdGlvbi4uIicgYnV0IGZvdW5kICciLi5vYmp0eXBlLi4iJyIsMykKICAgICAgIGVuZAogICAgICAgcmVzID0gaW5wdXRfZW5jb2RpbmcoZGVmaW5pdGlvbikKICAgICAgIHJlcy56ZW50eXBlID0gJ2UnCiAgICAgICAtLSBpZiBvYmogPiAyMTQ3NDgzNjQ3IHRoZW4KICAgICAgIC0tCSAgZXJyb3IoJ092ZXJmbG93IG9mIG51bWJlciBvYmplY3Qgb3ZlciAzMmJpdCBzaWduZWQgc2l6ZScsIDMpCiAgICAgICAtLQkgIC0tIFRPRE86IG1heWJlIHN1cHBvcnQgdW5zaWduZWQgbmF0aXZlIGhlcmUKICAgICAgIC0tIGVuZAogICAgICAgcmVzLnJhdyA9IG9iagogICAgICAgLS0gYW55IHR5cGUgb2YgYWRkaXRpb25hbCBjb252ZXJzaW9uIGZyb20gYSBuYXRpdmUgbnVtYmVyCiAgICAgICAtLSBkZXRlY3RlZCBhdCBpbnB1dCBjYW4gaGFwcGVuIGhlcmUsIGZvciBpbnN0YW5jZSB1c2luZyBhIG5ldwogICAgICAgLS0gbmF0aXZlIHVuc2lnbmVkIGludGVnZXIKICAgICAgIHJldHVybiAocmVzKQogICAgZW5kCgogICAgaWYgb2JqdHlwZSA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICByZXMgPSBpbnB1dF9lbmNvZGluZyhkZWZpbml0aW9uKQogICAgICAgcmVzLnplbnR5cGUgPSAnZScKICAgICAgIHJlcy5zY2hlbWEgPSBuaWwKICAgICAgIHJlcy5yYXcgPSBvYmoKICAgICAgIHJldHVybiAocmVzKQogICAgZW5kCgoJaWYgb2JqdHlwZSA9PSAnbmlsJyB0aGVuCgkgICBsb2NhbCB0YWIgPGNvbnN0PiA9IGV4cGVjdF90YWJsZShkZWZpbml0aW9uKQoJICAgaWYgdGFiIHRoZW4gLS0gZG91YmxlIGVuY29kaW5nX3plbnR5cGUgZGVmaW5pdGlvbgoJCSAgaWYgWkVOLnNjaGVtYXNbdGFiLmxlZnR3b3Jkc10gdGhlbgoJCQkgcmV0dXJuKHsgemVudHlwZSA9IHN0cmluZy5zdWIodGFiLnJpZ2h0bW9zdCwxLDEpLAoJCQkJCSAgc2NoZW1hID0gdGFiLmxlZnR3b3JkcywKCQkJCQkgIGx1YXR5cGUgPSBvYmp0eXBlLAoJCQkJCSAgbWlzc2luZyA9IHRydWUKCQkJCQl9KQoJCSAgZWxzZQoJCQkgcmVzID0gaW5wdXRfZW5jb2RpbmcodGFiLmxlZnR3b3JkcykKCQkJIGlmIHJlcyB0aGVuCgkJCQlyZXMuemVudHlwZSA9IHN0cmluZy5zdWIodGFiLnJpZ2h0bW9zdCwxLDEpCgkJCQlyZXMuc2NoZW1hID0gbmlsCgkJCQlyZXMubWlzc2luZyA9IHRydWUKCQkJCXJldHVybihyZXMpCgkJCSBlbmQKCQkgIGVuZAoJICAgZW5kCgkgICAtLSBzaW5nbGUgZW5jb2RpbmcgZGVmaW5pdGlvbgoJICAgcmVzID0gaW5wdXRfZW5jb2RpbmcoZGVmaW5pdGlvbikKCSAgIHJlcy56ZW50eXBlID0gJ2UnCgkgICByZXMubWlzc2luZyA9IHRydWUKCSAgIHJldHVybihyZXMpCgllbmQKCiAgICAtLSBvYmp0eXBlIGlzIG5vdCBhIGx1YXR5cGUKICAgIGlmIGlzemVuKHR5cGUob2JqKSkgdGhlbgogICAgICAgcmVzID0gaW5wdXRfZW5jb2RpbmcoZGVmaW5pdGlvbikKICAgICAgIHJlcy56ZW50eXBlID0gJ2UnCiAgICAgICByZXMuc2NoZW1hID0gbmlsCiAgICAgICByZXMucmF3ID0gb2JqCiAgICAgICByZXR1cm4ocmVzKQogICAgZW5kCgogICAgZXJyb3IoJ0ludmFsaWQgb2JqZWN0OiBubyBjb252ZXJzaW9uIGZvciB0eXBlICcuLm9ianR5cGUuLic6ICcuLmRlZmluaXRpb24sIDMpCiAgICByZXR1cm4gbmlsCiBlbmQKCiAtLSBmYWN0b3J5IGZ1bmN0aW9uIHRvIGdlbmVyYXRlIGEgZnVuY3Rpb24gYW5kIHJldHVybiBpdHMgcG9pbnRlciB0aGUKIC0tIGZ1bmN0aW9uIGlzIGdlbmVyYXRlZCB1c2luZyBhbm90aGVyIHBvaW50ZXIgdG8gZnVuY3Rpb24gd2hpY2ggaXMKIC0tIHRoZSBlbmNvZGVyLCBwbHVzIGl0IGFwcGxpZXMgY29tbW9uIHNhZmV0eSBjaGVja3MgZm9yIGRhdGEgdHlwZXMKIC0tIHRoYXQgbXVzdCBiZSBleGNsdWRlZCBmb3IgZW5jb2RpbmcsIGFzIGZvciBpbnN0YW5jZSBudW1iZXJzIGFuZAogLS0gYm9vbGVhbnMuCiAtLSBhcmd1bWVudHM6IGVuY29kZXIncyBuYW1lLCBjb252ZXJzaW9uIGFuZCBjaGVjayBmdW5jdGlvbnMKIGxvY2FsIGZ1bmN0aW9uIGZfZmFjdG9yeV9lbmNvZGVyKGVuY29kZXJfbiwgZW5jb2Rlcl9mLCBlbmNvZGVyX2MpCiAgICBsb2NhbCByZXMgPSB7IH0KICAgIGlmIG5vdCBlbmNvZGVyX2YgdGhlbgogICAgICAgcmVzLmZ1biA9IGZ1bmN0aW9uKGRhdGEpIHJldHVybihkYXRhKSBlbmQKICAgIGVsc2UKICAgICAgIHJlcy5mdW4gPSBmdW5jdGlvbihkYXRhKQoJICBsb2NhbCBkdCA9IGx1YXR5cGUoZGF0YSkKICAgIGlmIGR0ID09ICdib29sZWFuJyB0aGVuCiAgICAgIHJldHVybiBkYXRhCiAgICBlbmQKCSAgLS0gd3JhcCBhbGwgY29udmVyc2lvbiBmdW5jdGlvbnMgbmVzdGVkIGluIGRlZXBtYXBzCgkgIC0tIFRPRE86IG9wdGltaXplCgkgIGlmIGR0ID09ICdudW1iZXInIGFuZCBlbmNvZGVyX24gfj0gJ2Zsb2F0JyBhbmQgZW5jb2Rlcl9uIH49ICd0aW1lJyB0aGVuCiAgICAgICBpZiBUSU1FLmRldGVjdF90aW1lX3ZhbHVlKGRhdGEpIGFuZCBub3QgQ09ORi5pbnB1dC5udW1iZXJfc3RyaWN0IHRoZW4KICAgICAgICAgIHdhcm4oIk51bWJlciB2YWx1ZSBpbXBvcnRlZCBhcyB0aW1lc3RhbXA6ICIuLmRhdGEpCiAgICAgICAgICByZXR1cm4gVElNRS5uZXcoZGF0YSkKICAgICAgIGVsc2UKICAgICAgICAgIHJldHVybiBGTE9BVC5uZXcoZGF0YSkKICAgICAgIGVuZAogIGVuZAoJICByZXR1cm4gZW5jb2Rlcl9mKGRhdGEpCiAgICAgICBlbmQKICAgIGVuZAogICAgcmVzLmVuY29kaW5nID0gZW5jb2Rlcl9uCiAgICByZXMuY2hlY2sgPSBlbmNvZGVyX2MKICAgIHJldHVybihyZXMpCiBlbmQKCiAtLSBnZXRzIGEgc3RyaW5nIGFuZCByZXR1cm5zIHRoZSBhc3NvY2lhdGVkIGZ1bmN0aW9uLCBzdHJpbmcgYW5kIHByZWZpeAogLS0gY29tZXMgYmVmb3JlIHNjaGVtYSBjaGVjawogZnVuY3Rpb24gaW5wdXRfZW5jb2Rpbmcod2hhdCkKICAgaWYgbm90IHdoYXQgdGhlbgogICAgIGVycm9yKCJDYWxsIHRvIGlucHV0X2VuY29kaW5nIHdpdGggYXJndW1lbnQgbmlsIiwyKQogICBlbmQKICAgaWYgbm90IGx1YXR5cGUod2hhdCkgPT0gJ3N0cmluZycgdGhlbgogICAgIGVycm9yKCJDYWxsIHRvIGlucHV0X2VuY29kaW5nIGFyZ3VtZW50IGlzIG5vdCBhIHN0cmluZzogIi4udHlwZSh3aGF0KSwyKQogICBlbmQKICAgIGlmIHdoYXQgPT0gJ3U2NCcgb3Igd2hhdCA9PSAndXJsNjQnIHRoZW4KICAgICAgIHJldHVybiBmX2ZhY3RvcnlfZW5jb2RlcigndXJsNjQnLCBPLmZyb21fdXJsNjQsIE8uaXNfdXJsNjQpCiAgICBlbHNlaWYgd2hhdCA9PSAnYjY0JyBvciB3aGF0ID09J2Jhc2U2NCcgdGhlbgogICAgICAgcmV0dXJuIGZfZmFjdG9yeV9lbmNvZGVyKCdiYXNlNjQnLCBPLmZyb21fYmFzZTY0LCBPLmlzX2Jhc2U2NCkKICAgIGVsc2VpZiB3aGF0ID09ICdiNTgnIG9yIHdoYXQgPT0nYmFzZTU4JyB0aGVuCiAgICAgICByZXR1cm4gZl9mYWN0b3J5X2VuY29kZXIoJ2Jhc2U1OCcsIE8uZnJvbV9iYXNlNTgsIE8uaXNfYmFzZTU4KQogICAgZWxzZWlmIHdoYXQgPT0gJ2hleCcgdGhlbgogICAgICAgcmV0dXJuIGZfZmFjdG9yeV9lbmNvZGVyKCdoZXgnLCBPLmZyb21faGV4LCBPLmlzX2hleCkKICAgIGVsc2VpZiB3aGF0ID09ICdiaW4nIG9yIHdoYXQgPT0gJ2JpbmFyeScgdGhlbgogICAgICAgcmV0dXJuIGZfZmFjdG9yeV9lbmNvZGVyKCdiaW5hcnknLCBPLmZyb21fYmluLCBPLmlzX2JpbikKICAgIGVsc2VpZiB3aGF0ID09ICdzdHInIG9yIHdoYXQgPT0gJ3N0cmluZycgdGhlbgogICAgICAgLS0gc3RyaW5nIGhhcyBubyBjaGVjayBmdW5jdGlvbgogICAgICAgcmV0dXJuIGZfZmFjdG9yeV9lbmNvZGVyKCdzdHJpbmcnLCBPLmZyb21fc3RyaW5nLCBuaWwpCiAgICBlbHNlaWYgd2hhdCA9PSdtbmVtb25pYycgdGhlbgogICAgICAgLS0gbW5lbW9uaWMgaGFzIG5vIGNoZWNrIGZ1bmN0aW9uIChUT0RPOikKICAgICAgIHJldHVybiBmX2ZhY3RvcnlfZW5jb2RlcignbW5lbW9uaWMnLCBPLmZyb21fbW5lbW9uaWMsIG5pbCkKICAgIGVsc2VpZiB3aGF0ID09J3V1aWQnIHRoZW4KICAgICAgcmV0dXJuIGZfZmFjdG9yeV9lbmNvZGVyKCd1dWlkJywgTy5mcm9tX3V1aWQsIG5pbCkKICAgIGVsc2VpZiB3aGF0ID09ICdpbnQnIG9yIHdoYXQgPT0gJ2ludGVnZXInIHRoZW4gLS0gYWthIEJJRwogICAgICAgcmV0dXJuIGZfZmFjdG9yeV9lbmNvZGVyKCdpbnRlZ2VyJywgQklHLmZyb21fZGVjaW1hbCwgQklHLmlzX2ludGVnZXIpCiAgICBlbHNlaWYgd2hhdCA9PSAnZmxvYXQnIG9yIHdoYXQgPT0gJ251bScgb3Igd2hhdCA9PSAnbnVtYmVyJyB0aGVuCiAgICAgICByZXR1cm4gZl9mYWN0b3J5X2VuY29kZXIoJ2Zsb2F0JywgRkxPQVQubmV3LCBGTE9BVC5pc19mbG9hdCkKICAgIGVsc2VpZiB3aGF0ID09ICd0aW1lJyB0aGVuCiAgICAgICByZXR1cm4gZl9mYWN0b3J5X2VuY29kZXIoJ3RpbWUnLCBUSU1FLm5ldywgbmlsKQogICAgZW5kCiAgICB3YXJuKCJVbmtub3duIGlucHV0IGVuY29kaW5nICciLi53aGF0Li4iJzogdXNpbmcgZGVmYXVsdCAnIi4uCiAgICAgICAgIENPTkYuaW5wdXQuZW5jb2RpbmcuZW5jb2RpbmcuLiInIikKICAgIHJldHVybiBpbnB1dF9lbmNvZGluZyhDT05GLmlucHV0LmVuY29kaW5nLmVuY29kaW5nKQogZW5kCgpsb2NhbCBmdW5jdGlvbiB0b19udW1iZXJfZihkYXRhKQogIGxvY2FsIHJlcyA9IHRvbnVtYmVyKHRvc3RyaW5nKGRhdGEpKQogIHplbmNvZGVfYXNzZXJ0KHJlcywgIkNvdWxkIG5vdCByZWFkIHRoZSBmbG9hdCBudW1iZXIiKQogIHJldHVybiByZXMKZW5kCgotLSBhIG5ldyAnZGVzY3JpcHRpb24nIGNvZGVjIHRvIHByaW50IG91dCBkaWN0aW9uYXJpZXMgaW4gdW51c2FibGUgYnV0Ci0tIHJlYWRhYmxlIGZvcm0uICB0aGlzIGlzIGEgbm9uLXJldmVyc2libGUgdHJhbnNmb3JtYXRpb24gdGhhdAotLSBvdXRwdXRzIGp1c3Qgc2l6ZSBvZiBvYmplY3RzIHdoZW4gdGhleSBhcmUgNjQgYnl0ZXMgbG9uZyBvciBhYm92ZSwKLS0gZWxzZSBzdHJpbmcKbG9jYWwgZnVuY3Rpb24gdG9fZGVzY3JpcHRpb25fZihkYXRhKQogIGxvY2FsIHMgPGNvbnN0PiA9ICNkYXRhCiAgaWYgcyA8IDY0IHRoZW4gLS0gYXNzdW1lIGlzIG5vdCBhIHN0cmluZyBvdmVyIDMyIGJ5dGVzCiAgICByZXR1cm4gZGF0YTp0b19zdHJpbmcoKQogIGVsc2UKICAgIGxvY2FsIHQgPGNvbnN0PiA9IHR5cGUoZGF0YSkKICAgIGxvY2FsIHJlcyA8Y29uc3Q+ID0gIiggIi4udG9zdHJpbmcocykuLiIgYnl0ZXMgIi4udC4uIiApIgogICAgcmV0dXJuIHJlcwogIGVuZAplbmQKCiAtLSBmYWN0b3J5IGZ1bmN0aW9uIHJldHVybnMgYSBzbWFsbCBvdXRjYXN0IGZ1bmN0aW9uIHRoYXQgYXBwbGllcwogLS0gcmV0dXJuIGd1ZXNzZWQuZnVuKGd1ZXNzZWQucmF3KXNhZmV0eSBjaGVja3Mgb24gdmFsdWVzIGxpa2UKIC0tIGV4Y2VwdGlvbnMgZm9yIG51bWJlcnMgYW5kIGJvb2xlYW5zCiBsb2NhbCBmdW5jdGlvbiBmX2ZhY3Rvcnlfb3V0Y2FzdChmdW4pCiAgICByZXR1cm4gZnVuY3Rpb24oZGF0YSkKICAgICAgIGxvY2FsIGR0ID0gdHlwZShkYXRhKQogICAgICAgaWYgZHQgPT0gJ3RhYmxlJyB0aGVuIGVycm9yKCJpbnZhbGlkIHRhYmxlIGNvbnZlcnNpb24iLDIpIGVuZAogICAgICAgLS0gcGFzc3Rocm91Z2ggbmF0aXZlIG51bWJlciBkYXRhCiAgICAgICBpZiBkdCA9PSAnbnVtYmVyJyBvciBkdCA9PSAnYm9vbGVhbicgdGhlbgoJCSAgcmV0dXJuIGRhdGEKICAgICAgIGVsc2VpZiBkdCA9PSAnemVucm9vbS5iaWcnIHRoZW4KICAgICAgICB6ZW5jb2RlX2Fzc2VydChmdW4gfj0gdG9fbnVtYmVyX2YgYW5kIGZ1biB+PSBPLnRvX21uZW1vbmljLCAiRW5jb2Rpbmcgbm90IHZhbGlkIGZvciBpbnRlZ2VycyIpCiAgICAgICAgbG9jYWwgY29ycmVjdF9mdW4gPSBmdW4KICAgICAgICBpZiBjb3JyZWN0X2Z1biA9PSBPLnRvX3N0cmluZyB0aGVuIGNvcnJlY3RfZnVuID0gQklHLnRvX2RlY2ltYWwgZW5kCiAgICAgICAgaWYgY29ycmVjdF9mdW4gfj0gQklHLnRvX2RlY2ltYWwgdGhlbgogICAgICAgICAgemVuY29kZV9hc3NlcnQoQklHLnplbnBvc2l0aXZlKGRhdGEpLCAiTmVnYXRpdmUgaW50ZWdlcnMgY2FuIG5vdCBiZSBlbmNvZGVkIikKICAgICAgICAgIGRhdGEgPSBkYXRhOm9jdGV0KCkKICAgICAgICBlbmQKICAgICAgICByZXR1cm4gY29ycmVjdF9mdW4oZGF0YSkKICAgICAgIGVsc2VpZiBkdCA9PSAnemVucm9vbS5mbG9hdCcgb3IgZHQgPT0gJ3plbnJvb20udGltZScgdGhlbgoJCSAgICByZXR1cm4gdG9fbnVtYmVyX2YoZGF0YSkKICAgICAgIGVsc2VpZiBpc3plbihkdCkgdGhlbgogICAgICAgIGlmIGZ1bihkYXRhKSA9PSBuaWwgdGhlbiByZXR1cm4gIiIgZW5kCiAgICAgICAgLS0gbGV2ZXJhZ2UgZmlyc3QgY2xhc3MgY2l0aXplbiBtZXRob2Qgb24gemVucm9vbSBkYXRhCiAgICAgICAgcmV0dXJuIGZ1bihkYXRhOm9jdGV0KCkpCiAgICAgICBlbmQKICAgICAgIHJldHVybiBmdW4oZGF0YSkKICAgIGVuZAogZW5kCgogZnVuY3Rpb24gZGVmYXVsdF9leHBvcnRfZihvYmopCglsb2NhbCBmID0gTy50b19vY3RldAoJaWYgbHVhdHlwZShvYmopID09ICd0YWJsZScgdGhlbgoJICAgcmV0dXJuIGRlZXBtYXAoZixvYmopCgllbHNlCgkgICByZXR1cm4gZihvYmopCgllbmQKIGVuZAoKIGxvY2FsIGRhdGFfZW5jb2RpbmdfdGFibGUgPSB7CiAgICBzdHJpbmcgPSBPLnRvX3N0cmluZywKICAgIGhleCA9IE8udG9faGV4LAogICAgYmFzZTY0ID0gTy50b19iYXNlNjQsCiAgICB1cmw2NCA9IE8udG9fdXJsNjQsCiAgICBiYXNlNTggPSBPLnRvX2Jhc2U1OCwKICAgIGJpbmFyeSA9IE8udG9fYmluLAogICAgYmluID0gTy50b19iaW4sCiAgICBtbmVtb25pYyA9IE8udG9fbW5lbW9uaWMsCiAgICB1dWlkID0gTy50b191dWlkLAogICAgZmxvYXQgPSB0b19udW1iZXJfZiwKICAgIG51bWJlciA9IHRvX251bWJlcl9mLAogICAgaW50ZWdlciA9IEJJRy50b19kZWNpbWFsLAogICAgdGltZSA9IHRvX251bWJlcl9mLAogICAgZGVzY3JpcHRpb24gPSB0b19kZXNjcmlwdGlvbl9mCiB9CgotLSB0YWtlcyBhIHN0cmluZyByZXR1cm5zIHRoZSBmdW5jdGlvbiwgZ29vZCBmb3IgdXNlIGluIGRlZXBtYXAoZnVuLHRhYmxlKQpmdW5jdGlvbiBnZXRfZW5jb2RpbmdfZnVuY3Rpb24oY2FzdCkKICBpZiBub3QgY2FzdCB0aGVuCiAgICBlcnJvcignZ2V0X2VuY29kaW5nX2Z1bmN0aW9uIGNhbGxlZCB3aXRoIG5pbCBhcmd1bWVudCcsIDIpCiAgZW5kCiAgaWYgbHVhdHlwZShjYXN0KSB+PSAnc3RyaW5nJyB0aGVuCiAgICBlcnJvcignZ2V0X2VuY29kaW5nX2Z1bmN0aW9uIGNhbGxlZCB3aXRoIHdyb25nIGFyZ3VtZW50OiAnLi50eXBlKGNhc3QpLCAzKQogIGVuZAogIGlmIGNhc3QgPT0gJ2RlZicgdGhlbgogICAgcmV0dXJuIENPTkYub3V0cHV0LmVuY29kaW5nLmZ1bgogIGVsc2VpZiBjYXN0ID09ICdib29sZWFuJyB0aGVuCiAgICByZXR1cm4gZnVuY3Rpb24oZGF0YSkgcmV0dXJuIGRhdGEgZW5kCiAgZW5kCiAgbG9jYWwgX2VuYyA8Y29uc3Q+ID0gZGF0YV9lbmNvZGluZ190YWJsZVtjYXN0XQogIGlmIF9lbmMgdGhlbgogICAgcmV0dXJuIGZfZmFjdG9yeV9vdXRjYXN0KF9lbmMpCiAgZW5kCiAgLS0gdHJ5IHNjaGVtYXMKICBsb2NhbCBmdW4gPSBaRU4uc2NoZW1hc1t1c2NvcmUoY2FzdCldCiAgaWYgbHVhdHlwZShmdW4pID09ICd0YWJsZScgdGhlbgogICAgaWYgZnVuLmV4cG9ydCB0aGVuCiAgICAgIHJldHVybiBmdW4uZXhwb3J0CiAgICBlbHNlCiAgICAgIHJldHVybiBkZWZhdWx0X2V4cG9ydF9mCiAgICBlbmQKICBlbmQKICAtLSBsYXN0IGRlZmF1bHQKICByZXR1cm4gQ09ORi5vdXRwdXQuZW5jb2RpbmcuZnVuCmVuZAoKIGZ1bmN0aW9uIGdldF9mb3JtYXQod2hhdCkKICAgIGlmIHdoYXQgPT0gJ2pzb24nIG9yIHdoYXQgPT0gJ0pTT04nIHRoZW4KICAgICAgIHJldHVybiB7IGZ1biA9IEpTT04uYXV0bywKCQluYW1lID0gJ2pzb24nIH0KICAgIC0tIGVsc2VpZiB3aGF0ID09ICdjYm9yJyBvciB3aGF0ID09ICdDQk9SJyB0aGVuCiAgICAtLSAgICByZXR1cm4geyBmdW4gPSBDQk9SLmF1dG8sCgktLSAJbmFtZSA9ICdjYm9yJyB9CiAgICBlbmQKICAgIGVycm9yKCJDb252ZXJzaW9uIGZvcm1hdCBub3Qgc3VwcG9ydGVkOiAiLi53aGF0LCAyKQogICAgcmV0dXJuIG5pbAogZW5kCgotLSBDQUNIRSBmb3JtYXQ6IHsga2V5ID0gdmFsLCAuLi4gfQotLSByL3cgbWVtb3J5IGludmlzaWJsZSB0byB6ZW5jb2RlICh1c2VkIGluc2lkZSBzdGF0ZW1lbnRzKQotLSBjYW4gb3ZlcndyaXRlIGV4aXN0aW5nIGRhdGEKZnVuY3Rpb24gbmV3X2NhY2hlKGtleSwgdmFsKQogICBpZiBub3Qga2V5IHRoZW4gZXJyb3IoIm5ld19jYWNoZSBjYWxsZWQgd2l0aCBlbXB0eSBrZXkiLCAyKSBlbmQKICAgaWYgbm90IHZhbCB0aGVuIGVycm9yKCJuZXdfY2FjaGUgY2FsbGVkIHdpdGggZW1wdHkgdmFsdWUiLCAyKSBlbmQKICAgeHh4KCJ6ZW5jb2RlX2NhY2hlIHNldCB2YWx1ZTogIi4ua2V5KQogICBDQUNIRVt1c2NvcmUoa2V5KV0gPSB2YWwKZW5kCgogLS0gQ09ERUMgZm9ybWF0OgogLS0geyBuYW1lOiBzdHJpbmcsCiAtLSAgIGVuY29kaW5nOiBlbmNvZGluZyBvZiBvYmplY3QgZGF0YSwgYm90aCBiYXNpYyBhbmQgc2NoZW1hCiAtLSAgIHplbnR5cGU6ICB6ZW5jb2RlIHR5cGU6ICdlJ2xlbWVudCwgJ2EncnJheSBvciAnZCdpY3Rpb25hcnkKIC0tICAgc2NoZW1hOiBzY2hlbWEgbmFtZSB1c2VkIHRvIGltcG9ydCBvciBuaWwgd2hlbiBiYXNpYyBvYmplY3QKIC0tICAgc3Q6IHNjaGVtYSB0eXBlIHByb3BlcnRpZXMsIHNvIGZhciBqdXN0ICdvJ3BlbiBvciAnYyd1c3RvbQogLS0gfQogZnVuY3Rpb24gbmV3X2NvZGVjKGNuYW1lLCBwYXJhbWV0ZXJzLCBjbG9uZSkKICAgIGlmIG5vdCBjbmFtZSB0aGVuIGVycm9yKCJNaXNzaW5nIG5hbWUgaW4gbmV3IGNvZGVjIiwgMikgZW5kCiAgICBsb2NhbCBuYW1lCglpZiBsdWF0eXBlKGNuYW1lKSA9PSAnc3RyaW5nJyB0aGVuCgkgICBuYW1lID0gdXNjb3JlKGNuYW1lKQoJZWxzZSAtLSBtYXkgYmUgYSBudW1lcmljYWwgaW5kZXgKCSAgIG5hbWUgPSBjbmFtZQoJZW5kCglsb2NhbCBhY2tuID0gQUNLW25hbWVdCiAgICBpZiBub3QgYWNrbiB0aGVuIGVycm9yKCJDYW5ub3QgY3JlYXRlIGNvZGVjLCBvYmplY3Qgbm90IGZvdW5kOiAiLi5uYW1lLCAyKSBlbmQKICAgIGlmIENPREVDW25hbWVdIHRoZW4gZXJyb3IoIkNhbm5vdCBvdmVyd3JpdGUgQ09ERUMuIi4ubmFtZSwgMikgZW5kCiAgICBsb2NhbCByZXMKICAgIGlmIGNsb25lIHRoZW4KCSAgIGxvY2FsIGNjbG9uZSA9IENPREVDW2Nsb25lXQoJICAgaWYgbm90IGNjbG9uZSB0aGVuCgkJICBlcnJvcigiQ2xvbmUgbm90IGZvdW5kIGluIENPREVDLiIuLmNsb25lLCAyKQoJICAgZW5kCiAgICAgICByZXMgPSBkZWVwY29weShjY2xvbmUpCiAgICAgICByZXMubmFtZSA9IG5hbWUKICAgIGVsc2UKICAgICAgIHJlcyA9IHsgbmFtZSA9IG5hbWUgfQoJICAgLS0gY2hlY2sgaWYgbmFtZSBpcyBhIHNjaGVtYQoJICAgaWYgWkVOLnNjaGVtYXNbbmFtZV0gdGhlbiByZXMuc2NoZW1hID0gbmFtZSBlbmQKICAgIC0tIGFsd2F5cyBkZXRlY3QgemVudHlwZSAobWF5IGJlIGFuIGVsZW1lbnQgZXh0cmFjdGVkIGZyb20gZGljdCkKICAgICAgbG9jYWwgbHQgPSBsdWF0eXBlKGFja24pCiAgICAgIGlmIGx0ID09ICd0YWJsZScgdGhlbgogICAgICAgICBpZiBaRU4uc2NoZW1hc1tuYW1lXSB0aGVuCiAgICAgICAgICByZXMuemVudHlwZSA9ICdlJwogICAgICAgICBlbHNlaWYgaXNkaWN0aW9uYXJ5KGFja24pIHRoZW4KICAgICAgICAgIHJlcy56ZW50eXBlID0gJ2QnCiAgICAgICAgIGVsc2VpZiBpc2FycmF5KGFja24pIHRoZW4KICAgICAgICAgIHJlcy56ZW50eXBlID0gJ2EnCiAgICAgICAgIGVsc2UKICAgICAgICAgIGVycm9yKCJVbmtub3duIHplbnR5cGUgZm9yIGx1YSB0YWJsZTogIi4ubmFtZSwgMikKICAgICAgICAgZW5kCiAgICAgIGVsc2UKICAgICAgICAgcmVzLnplbnR5cGUgPSAnZScKICAgICAgZW5kCiAgICBlbmQKICAgIC0tIG92ZXJ3cml0ZSB3aXRoIHBhcmFtZW50ZXJzIGluIGFyZ3VtZW50CiAgICBpZiBwYXJhbWV0ZXJzIHRoZW4KICAgICAgIGZvciBrLHYgaW4gcGFpcnMocGFyYW1ldGVycykgZG8KCQkgIHJlc1trXSA9IHYKICAgICAgIGVuZAogICAgZW5kCgktLSBkZWZhdWx0IGVuY29kaW5nIGlmIG5vdCBzcGVjaWZpZWQKCWlmIG5vdCByZXMuZW5jb2RpbmcgdGhlbiByZXMuZW5jb2RpbmcgPSAnZGVmJyBlbmQKICAgIENPREVDW25hbWVdID0gcmVzCiBlbmQKCiAtLSBDcmF3bHMgYSB3aG9sZSB0YWJsZSBzdHJ1Y3R1cmUgYW5kIGNvbGxlY3RzIGFsbCBzdHJpbmdzIGFuZCBvY3RldHMKIC0tIGNvbnRhaW5lZCBpbiBpdHMga2V5cyBhbmQgdmFsdWVzLiBDb252ZXJ0cyBudW1iZXJzIHRvCiAtLSBzdHJpbmdzLiBTdHJ1Y3R1cmUgcmV0dXJuZWQgaXM6CiAtLSB7IG9jdGV0cyA9IHplbnJvb20ub2N0ZXQKIC0tICAgc3RyaW5ncyA9IHN0cmluZyB9CiAtLSBjYWxsaW5nIGZ1bmN0aW9uIG1heSB3YW50IHRvIGNvbnZlcnQgYWxsIHRvIG9jdGV0IG9yIHN0cmluZwogLS0KIC0tIGFwcGx5IGEgZnVuY3Rpb24gb24gYWxsIGtleXMgYW5kIHZhbHVlcyBvZiBhIHRyZWUgc3RydWN0dXJlCiAtLSB1c2VzIHNvcnRlZCBsaXN0aW5nIGZvciBkZXRlcm1pbmlzdGljIG9yZGVyCiBsb2NhbCBmdW5jdGlvbiBzb3J0X2FwcGx5KGZ1bix0LC4uLikKICAgIGlmIGx1YXR5cGUoZnVuKSB+PSAnZnVuY3Rpb24nIHRoZW4KICAgICAgIGVycm9yKCJJbnRlcm5hbCBlcnJvcjogYXBwbHkgMXN0IGFyZ3VtZW50IGlzIG5vdCBhIGZ1bmN0aW9uIiwgMykKICAgICAgIHJldHVybiBuaWwgZW5kCiAgICAtLSBpZiBsdWF0eXBlKHQpID09ICdudW1iZXInIHRoZW4KICAgIC0tCSAgcmV0dXJuIHQgZW5kCiAgICBpZiBsdWF0eXBlKHQpIH49ICd0YWJsZScgdGhlbgogICAgICAgZXJyb3IoIkludGVybmFsIGVycm9yOiBhcHBseSAybmQgYXJndW1lbnQgaXMgbm90IGEgdGFibGUiLCAzKQogICAgICAgcmV0dXJuIG5pbCBlbmQKICAgIGZvciBrLHYgaW4gc29ydF9wYWlycyh0KSBkbyAtLSBPUFRJTUlaQVRJT046IHdhcyBzb3J0X3BhaXJzCiAgICAgICBpZiBsdWF0eXBlKHYpID09ICd0YWJsZScgdGhlbgoJICBzb3J0X2FwcGx5KGZ1bix2LC4uLikgLS0gcmVjdXJzaW9uCiAgICAgICBlbHNlCgkgIGZ1bih2LGssLi4uKQogICAgICAgZW5kCiAgICBlbmQKIGVuZAogZnVuY3Rpb24gc2VyaWFsaXplKHRhYikKICAgIGFzc2VydChsdWF0eXBlKHRhYikgPT0gJ3RhYmxlJywgJ0Nhbm5vdCBzZXJpYWxpemU6IG5vdCBhIHRhYmxlJywgMikKICAgIGxvY2FsIG9jdGV0cyA9IE9DVEVULnplcm8oMSkKICAgIGxvY2FsIHN0cmluZ3MgPSB7ICdLJyB9CiAgICBzb3J0X2FwcGx5KAogICAgICAgZnVuY3Rpb24odiwgaykKCSAgdGFibGUuaW5zZXJ0KHN0cmluZ3MsIHRvc3RyaW5nKGspKQoJICBpZiBpc3plbih0eXBlKHYpKSB0aGVuCgkgICAgIC0tIFRPRE86IG9wdGltaXplIG9jdGV0IGNvbmNhdGVuYXRpb24gaW4gQwoJICAgICAtLSB0byBhdm9pZCByZWFsbG9jYXRpb24gb2YgbmV3IG9jdGV0cyBpbiB0aGlzIGxvb3AKCSAgICAgLS0gc2hvdWxkIGNvdW50IHRvdGFsIGxlbmd0aCBhbGxvY2F0ZSBvbmUgYW5kIGluc2VydAoJICAgICBvY3RldHMgPSBvY3RldHMuLiB2Om9jdGV0KCkKCSAgZWxzZSAtLSBudW1iZXIKCSAgICAgdGFibGUuaW5zZXJ0KHN0cmluZ3MsIHRvc3RyaW5nKHYpKQoJICBlbmQKICAgICAgIGVuZCwKICAgICAgIHRhYgogICAgKQogICAgcmV0dXJuIHsKICAgICAgIG9jdGV0cyA9IG9jdGV0cywKICAgICAgIC0tIHN0cmluZyBjb25jYXRlbmF0aW9uIGlzIG9wdGltaXplZAogICAgICAgc3RyaW5ncyA9IHRhYmxlLmNvbmNhdChzdHJpbmdzKQogICAgfQogZW5kCgogLS0gZWxpbWluYXRlIGFsbCBlbXB0eSBzdHJpbmcgb2JqZWN0cyAiIiBhbmQgYWxsIGVtcHR5IGRpY3Rpb25hcmllcwogLS0gKGNvbnRhaW5pbmcgb25seSBlbXB5IG9iamVjdHMpLCB1c2VzIHJlY3Vyc2lvbiBpbnRvIHRhYmxlcwogZnVuY3Rpb24gcHJ1bmUodGFiKQogICAgYXNzZXJ0KGx1YXR5cGUodGFiKSA9PSAndGFibGUnLCAnQ2Fubm90IHBydW5lOiBub3QgYSB0YWJsZScsIDIpCiAgICBsb2NhbCBwcnVuZWRfdmFsdWVzID0gZGVlcG1hcChmdW5jdGlvbih2KQoJICBpZiB2Ll9fbGVuIGFuZCAjdiA9PSAwIHRoZW4gcmV0dXJuIG5pbAoJICBlbHNlIHJldHVybiB2IGVuZAogICAgZW5kLCB0YWIpCiAgICBsb2NhbCBmdW5jdGlvbiBwcnVuZV9pbih0dGFiKQogICAgICAgbG9jYWwgcmVzID0geyB9CiAgICAgICBsb2NhbCBuZXh0ID0gbmV4dAogICAgICAgbG9jYWwgbHVhdHlwZSA9IGx1YXR5cGUKICAgICAgIGZvciBrLHYgaW4gcGFpcnModHRhYikgZG8KCSAgaWYgbHVhdHlwZSh2KSA9PSAndGFibGUnIHRoZW4KCSAgICAgaWYgbmV4dCh2KSA9PSBuaWwgdGhlbgoJCXJlc1trXSA9IG5pbCAtLSB7fSB0byBuaWwKCSAgICAgZWxzZQoJCXJlc1trXSA9IHBydW5lX2luKHYpIC0tIHJlY3Vyc2lvbgoJICAgICBlbmQKCSAgZWxzZQoJICAgICByZXNba10gPSB2CgkgIGVuZAogICAgICAgZW5kCiAgICAgICByZXR1cm4gc2V0bWV0YXRhYmxlKHJlcywgZ2V0bWV0YXRhYmxlKHR0YWIpKQogICAgZW5kCiAgICBsb2NhbCBwcnVuZWRfdGFibGVzID0gcHJ1bmVfaW4ocHJ1bmVkX3ZhbHVlcykKICAgIHJldHVybiBwcnVuZWRfdGFibGVzCiBlbmQKCi0tIGVuY29kZSB0aGUgb2N0ZXQgaW4gQUNLW3NyY19uYW1lXSBmb2xsb3dpbmcgdGhlIHNyY19lbmMKLS0gYW5kIHRoZW4gaXQgdHJhbnNmb3JtIGl0IGJhY2sgdG8gb2N0ZXQgZm9sbG93aW5nIHRoZSBkZXN0X2VuYwotLSBAcGFyYW0gc3JjX25hbWUgbmFtZSBvZiB0aGUgdmFyaWFibGUgaW4gQUNLCi0tIEBwYXJhbSBzcmNfZW5jIHRoZSBlbmNvZGluZyB0byB1c2Ugd2hlbiB0cmFuc2Zvcm1pbmcgQUNLW3NyY19uYW1lXSBpbnRvIHN0cmluZwotLSBAcGFyYW0gZGVzdF9lbmMgdGhlIGVuY29kaW5nIHRvIHVzZSB3aGVuIHRyYW5zZnJvbWluZyBiYWNrIHRoZSBzdHJpbmcgaW50byBvY3RldAotLSBAcmV0dXJuIHRoZSBvY3RldC90YWJsZSBvZiBvY3RldHMgb2YgdGhlIGFib3ZlIHRyYW5zZm9ybWF0aW9uCmZ1bmN0aW9uIGFwcGx5X2VuY29kaW5nKHNyY19uYW1lLCBzcmNfZW5jLCBkZXN0X2VuYykKICBsb2NhbCBzcmNfdmFsdWUsIHNyY19jb2RlYyA9IGhhdmUoc3JjX25hbWUpCiAgZl9zcmNfZW5jID0gZ2V0X2VuY29kaW5nX2Z1bmN0aW9uKHNyY19lbmMpCiAgaWYgbm90IGZfc3JjX2VuYyB0aGVuIGVycm9yKCJFbmNvZGluZyBmb3JtYXQgbm90IGZvdW5kOiAiLi5zcmNfZW5jLCAyKSBlbmQKICBsb2NhbCBlbmNvZGVkX3NyYwogIC0tIGFjY3BldCBhbHNvIHNjaGVtYXMgYXMgZW5jb2RpbmcKICBpZiBaRU4uc2NoZW1hc1t1c2NvcmUoc3JjX2VuYyldIHRoZW4KICAgICAgaWYgc3JjX2NvZGVjLnNjaGVtYSBhbmQgdXNjb3JlKHNyY19lbmMpIH49IHNyY19jb2RlYy5zY2hlbWEgdGhlbgogICAgICAgICAgZXJyb3IoIlNvdXJjZSBzY2hlbWE6ICIuLnNyY19jb2RlYy5zY2hlbWEuLiIgZG9lcyBub3QgbWF0Y2ggZW5jb2RpbmcgIi4uc3JjX2VuYykKICAgICAgZW5kCiAgICAgIGlmIGZfc3JjX2VuYyA9PSBkZWZhdWx0X2V4cG9ydF9mIHRoZW4KICAgICAgICAgIGZfc3JjX2VuYyA9IGZ1bmN0aW9uIChvYmopCiAgICAgICAgICAgICAgaWYgbHVhdHlwZShvYmopID09ICJ0YWJsZSIgdGhlbgogICAgICAgICAgICAgICAgICByZXR1cm4gZGVlcG1hcChDT05GLm91dHB1dC5lbmNvZGluZy5mdW4sIG9iaikKICAgICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICAgIHJldHVybiBDT05GLm91dHB1dC5lbmNvZGluZy5mdW4ob2JqKQogICAgICAgICAgICAgIGVuZAogICAgICAgICAgZW5kCiAgICAgIGVuZAogICAgICBpZiBzcmNfY29kZWMuemVudHlwZSA9PSAiZSIgdGhlbgogICAgICAgICAgZW5jb2RlZF9zcmMgPSBmX3NyY19lbmMoc3JjX3ZhbHVlKQogICAgICBlbHNlCiAgICAgICAgICBlbmNvZGVkX3NyYyA9IHt9CiAgICAgICAgICBmb3Igayx2IGluIHNyY192YWx1ZSBkbwogICAgICAgICAgICAgIGVuY29kZWRfc3JjW2tdID0gZl9zcmNfZW5jKHNyY192YWx1ZSkKICAgICAgICAgIGVuZAogICAgICBlbmQKICBlbHNlCiAgICAgIGVuY29kZWRfc3JjID0gZGVlcG1hcChmX3NyY19lbmMsIHNyY192YWx1ZSkKICBlbmQKICBmX2Rlc3RfZW5jID0gaW5wdXRfZW5jb2RpbmcoZGVzdF9lbmMpCiAgaWYgbm90IGZfZGVzdF9lbmMgdGhlbiBlcnJvcigiRGVzdGluYXRpb24gZW5jb2RpbmcgZm9ybWF0IG5vdCBmb3VuZDogIi4uZGVzdF9lbmMsIDIpIGVuZAogIHJldHVybiBkZWVwbWFwKGZfZGVzdF9lbmMuZnVuLCBlbmNvZGVkX3NyYykKZW5kCi96ZW5jb2RlX2RlYnVnLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS1dXQoKCi0tIHF1aWNrIGludGVybmFsIGRlYnVnZ2luZyBmYWNpbGl0eQpmdW5jdGlvbiB4eHgocywgbikKICAgbG9jYWwgbiA8Y29uc3Q+ID0gbiBvciAzCiAgIGlmIERFQlVHID49IG4gdGhlbgoJICBpZiBMT0dGTVQgPT0gJ0pTT04nIHRoZW4KCQkgcHJpbnRlcnIoIlwiTFVBICIuLnMuLiJcIiwiKQoJICBlbHNlCgkJIHByaW50ZXJyKCJMVUEgIi4ucykKCSAgZW5kCiAgIGVuZAplbmQKCi0tIHRyYWNlIGZ1bmN0aW9uIGV4ZWN1dGlvbiBhbHNvIG9uIHN1Y2Nlc3MKZnVuY3Rpb24gWkVOOmZ0cmFjZShzcmMpCiAgIGlmIERFQlVHIDwgMyB0aGVuIHJldHVybiBlbmQKICAgaWYgbm90IHNyYyB0aGVuIHJldHVybiBlbmQKICAgaWYgbm90IHRyYWNlYmFjayB0aGVuIF9HWyd0cmFjZWJhY2snXSA9IHt9IGVuZAogICB0YWJsZS5pbnNlcnQodHJhY2ViYWNrLCAnIEQgIFpFTjonIC4uIHRyaW0oc3JjKSkKZW5kCi0tIGxvZyB6ZW5jb2RlIHdhcm5pbmcgaW4gdHJhY2ViYWNrCmZ1bmN0aW9uIFpFTjp3dHJhY2Uoc3JjKQoJdGFibGUuaW5zZXJ0KHRyYWNlYmFjaywgJyBXICArJyAuLiB0cmltKHNyYykpCmVuZApmdW5jdGlvbiBaRU46Y3J1bWIobXNnKQogICBzZWxmOmZ0cmFjZShkZWJ1Zy5nZXRpbmZvKDIsICduJykubmFtZSkKICAgaWYgbXNnIHRoZW4gc2VsZjpmdHJhY2UobXNnKSBlbmQKZW5kCgotLSBkZWJ1ZyBmdW5jdGlvbnMKZnVuY3Rpb24gWkVOOmRlYnVnX3RyYWNlYmFjaygpCiAgIGlmIENPTkYuZGVidWcuZm9ybWF0ID09ICdjb21wYWN0JyB0aGVuCgkgIGxvY2FsIHRtcCA9ICJKNjQgVFJBQ0U6ICIuLk9DVEVULnRvX2Jhc2U2NCgKCQkgT0NURVQuZnJvbV9zdHJpbmcoCgkJCUpTT04uZW5jb2RlKHRyYWNlYmFjaykpKQoJICBpZiBMT0dGTVQgPT0gJ0pTT04nIHRoZW4gdG1wID0gJyInLi50bXAuLiciLCcgZW5kCgkgIHByaW50ZXJyKHRtcCkKICAgZWxzZQoJICBmb3Igayx2IGluIHBhaXJzKHRyYWNlYmFjaykgZG8KCQkgaWYgTE9HRk1UID09ICdKU09OJyB0aGVuCgkJCXByaW50ZXJyKCciJy4udi4uJyIsJykKCQkgZWxzZQoJCQlwcmludGVycih2KQoJCSBlbmQKCSAgZW5kCiAgIGVuZAplbmQKR2l2ZW4oImJhY2t0cmFjZSIsIGZ1bmN0aW9uKCkgWkVOOmRlYnVnX3RyYWNlYmFjaygpIGVuZCkKV2hlbigiYmFja3RyYWNlIiwgZnVuY3Rpb24oKSBaRU46ZGVidWdfdHJhY2ViYWNrKCkgZW5kKQpUaGVuKCJiYWNrdHJhY2UiLCBmdW5jdGlvbigpIFpFTjpkZWJ1Z190cmFjZWJhY2soKSBlbmQpCkdpdmVuKCJ0cmFjZSIsIGZ1bmN0aW9uKCkgWkVOOmRlYnVnX3RyYWNlYmFjaygpIGVuZCkKV2hlbigidHJhY2UiLCBmdW5jdGlvbigpIFpFTjpkZWJ1Z190cmFjZWJhY2soKSBlbmQpClRoZW4oInRyYWNlIiwgZnVuY3Rpb24oKSBaRU46ZGVidWdfdHJhY2ViYWNrKCkgZW5kKQoKbG9jYWwgZnVuY3Rpb24gZGVidWdfaGVhcF9zY2hlbWEoKQogICAgLS0gVE9ETzogaGVyZSB3ZSBhc3N1bWUgdGhhdCBrZXlyaW5nIGlzIG9ubHkgbWFkZSBvZiBCSUcgb3IgT0NURVQKICAgIGxvY2FsIGZ1bmN0aW9uIHplcm9fYWxsX2NvbnRlbnRzKHYpCiAgICAgICAgbG9jYWwgdCA8Y29uc3Q+ID0gdHlwZSh2KQogICAgICAgIGlmIHQgPT0gJ3RhYmxlJyB0aGVuCiAgICAgICAgICAgIHplcm9fYWxsX2NvbnRlbnRzKHYpCiAgICAgICAgZWxzZQogICAgICAgICAgICBpZiB0ID09ICd6ZW5yb29tLmJpZycgdGhlbgogICAgICAgICAgICAgICAgcmV0dXJuIEJJRy5uZXcoI3Y6b2N0ZXQoKSkKICAgICAgICAgICAgZWxzZWlmIGlzemVuKHQpIHRoZW4KICAgICAgICAgICAgICAgIHJldHVybiBPLnplcm8oI3Y6b2N0ZXQoKSkKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgcmV0dXJuIE8uemVybygxKQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgIGVuZAogICAgbG9jYWwgayA8Y29uc3Q+ID0gQUNLLmtleXJpbmcKICAgIGlmIEFDSy5rZXlyaW5nIHRoZW4KICAgICAgICBBQ0sua2V5cmluZyA9IGRlZXBtYXAoemVyb19hbGxfY29udGVudHMsQUNLLmtleXJpbmcpCiAgICBlbmQKICAgIGxvY2FsIF9oZWFwIDxjb25zdD4gPSBJLmluc3BlY3QoewogICAgICAgIGFfQ09ERUNfYWNrID0gQ09ERUMsCiAgICAgICAgYl9HSVZFTl9pbiA9IElOLAogICAgICAgIGNfV0hFTl9hY2sgPSBBQ0ssCiAgICAgICAgZF9USEVOX291dCA9IE9VVAogICAgfSx7IHNjaGVtYSA9IHRydWUgfSkKICAgIEFDSy5rZXlyaW5nID0gawogICAgLS0gcHJpbnQgb25seSBrZXlzIHdpdGhvdXQgdmFsdWVzCiAgICBpZiBDT05GLmRlYnVnLmZvcm1hdCA9PSAnY29tcGFjdCcgYW5kIExPR0ZNVCA9PSAnSlNPTicgdGhlbgogICAgICAgIHByaW50ZXJyKCciSjY0IEhFQVA6ICcuLk9DVEVULmZyb21fc3RyaW5nKF9oZWFwKTpiYXNlNjQoKS4uJyIsJykKICAgIGVsc2UKICAgICAgICB3YXJuKF9oZWFwKQogICAgZW5kCmVuZAoKbG9jYWwgZnVuY3Rpb24gZGVidWdfaGVhcF9kdW1wKCkKICAgbG9jYWwgYWNrIDxjb25zdD4gPSBBQ0sKICAgbG9jYWwga2V5cmluZyA9IGFjay5rZXlyaW5nCiAgIGlmIENPTkYuZGVidWcuZm9ybWF0ID09ICdjb21wYWN0JyB0aGVuCgkgIGlmIGtleXJpbmcgdGhlbgoJCSBhY2sua2V5cmluZyA9ICcoaGlkZGVuKScKCSAgZW5kCgkgIGxvY2FsIHRtcCA9ICJKNjQgSEVBUDogIi4uT0NURVQudG9fYmFzZTY0KAoJCSBPQ1RFVC5mcm9tX3N0cmluZygKCQkJSlNPTi5lbmNvZGUoCgkJCSAgIHtHSVZFTl9kYXRhID0gSU4sCgkJCQlDT0RFQyA9IENPREVDLAoJCQkJV0hFTiA9IGFjaywKCQkJCVRIRU4gPSBPVVQsCgkJCQlDQUNIRSA9IENBQ0hFfSwKICAgICAgICAgICAgICAgIENPTkYuZGVidWcuZW5jb2RpbmcubmFtZSkpKQoJICBpZiBMT0dGTVQgPT0gJ0pTT04nIHRoZW4gdG1wID0gJyInLi50bXAuLiciLCcgZW5kCgkgIHByaW50ZXJyKHRtcCkKICAgZWxzZSAtLSBDT05GLmRlYnVnLmZvcm1hdCA9PSAnbG9nJwoJICAtLSBhY2sua2V5cmluZyA9ICcoaGlkZGVuKScKCSAgaWYga2V5cmluZyB0aGVuCiAgICAgICAgICBJLmluc3BlY3Qoe0tFWVJJTkcgPSBhY2sua2V5cmluZ30sIHsgc2NoZW1hID0gdHJ1ZSB9KQogICAgICAgICAgYWNrLmtleXJpbmcgPSAnKGhpZGRlbiknCgkgIGVuZAogICAgICBJLmluc3BlY3Qoe2FfR0lWRU5faW4gPSBJTiwKICAgICAgICAgICAgICAgICBjX1dIRU5fYWNrID0gYWNrLAogICAgICAgICAgICAgICAgIGNfQ09ERUNfYWNrID0gQ09ERUMsCiAgICAgICAgICAgICAgICAgY19DQUNIRV9hY2sgPSBDQUNIRSwKICAgICAgICAgICAgICAgICBkX1RIRU5fb3V0ID0gT1VUfSwKICAgICAgICAgIHsgc2NoZW1hID0gdHJ1ZSB9CiAgICAgICkKICAgZW5kCiAgIGFjay5rZXlyaW5nID0ga2V5cmluZwplbmQKCgp6ZW5jb2RlX2Fzc2VydCA9IGZ1bmN0aW9uKGNvbmRpdGlvbiwgZXJybXNnKQogICAgaWYgY29uZGl0aW9uIHRoZW4gcmV0dXJuIHRydWUgZW5kCiAgICBpZiBaRU4uYnJhbmNoX2NvbmRpdGlvbiB0aGVuCiAgICAgICAgWkVOLmJyYW5jaF92YWxpZCA9IFpFTi5icmFuY2hfdmFsaWQgLSAxCiAgICAgICAgdGFibGUuaW5zZXJ0KHRyYWNlYmFjaywgZXJybXNnKQogICAgICAgIHJldHVybiBmYWxzZQogICAgZW5kCiAgICAtLSBaRU4uZGVidWcoKSAtLSBwcmludHMgYWxsIGRhdGEgaW4gbWVtb3J5CiAgICAtLSB0YWJsZS5pbnNlcnQodHJhY2ViYWNrLCAnWyFdICcuLmVycm1zZykKICAgIFpFTi5PSyA9IGZhbHNlCiAgICBleGl0Y29kZSgxKQogICAgZXJyb3IoZXJybXNnLCAzKQplbmQKCmZ1bmN0aW9uIFpFTjpkZWJ1ZygpCglkZWJ1Z19oZWFwX3NjaGVtYSgpCglaRU46ZGVidWdfdHJhY2ViYWNrKCkKZW5kCgotLSBsb2NhbCBmdW5jdGlvbiBkZWJ1Z19vYmpfZHVtcCgpCi0tIGxvY2FsIGZ1bmN0aW9uIGRlYnVnX29ial9zY2hlbWEoKQoKR2l2ZW4oImRlYnVnIiwgZnVuY3Rpb24oKSBkZWJ1Z19oZWFwX3NjaGVtYSgpIFpFTjpkZWJ1Z190cmFjZWJhY2soKSBlbmQpCldoZW4oImRlYnVnIiwgIGZ1bmN0aW9uKCkgZGVidWdfaGVhcF9zY2hlbWEoKSBaRU46ZGVidWdfdHJhY2ViYWNrKCkgZW5kKQpUaGVuKCJkZWJ1ZyIsICBmdW5jdGlvbigpIGRlYnVnX2hlYXBfc2NoZW1hKCkgWkVOOmRlYnVnX3RyYWNlYmFjaygpIGVuZCkKCkdpdmVuKCJzY2hlbWEiLCBmdW5jdGlvbigpIGRlYnVnX2hlYXBfc2NoZW1hKCkgZW5kKQpXaGVuKCJzY2hlbWEiLCAgZnVuY3Rpb24oKSBkZWJ1Z19oZWFwX3NjaGVtYSgpIGVuZCkKVGhlbigic2NoZW1hIiwgIGZ1bmN0aW9uKCkgZGVidWdfaGVhcF9zY2hlbWEoKSBlbmQpCgpmdW5jdGlvbiBkZWJ1Z19jb2RlYygpCiAgIEkud2Fybih7Q09ERUMgPSBDT0RFQ30pCmVuZAoKR2l2ZW4oImJyZWFrIiwgZnVuY3Rpb24oKSBaRU4uT0sgPSBmYWxzZSBlbmQpCldoZW4oImJyZWFrIiwgIGZ1bmN0aW9uKCkgWkVOLk9LID0gZmFsc2UgZW5kKQpUaGVuKCJicmVhayIsICBmdW5jdGlvbigpIFpFTi5PSyA9IGZhbHNlIGVuZCkKCkdpdmVuKCJjb2RlYyIsIGZ1bmN0aW9uKCkgZGVidWdfY29kZWMoKSBlbmQpCldoZW4oImNvZGVjIiwgZnVuY3Rpb24oKSBkZWJ1Z19jb2RlYygpIGVuZCkKVGhlbigiY29kZWMiLCBmdW5jdGlvbigpIGRlYnVnX2NvZGVjKCkgZW5kKQoKR2l2ZW4oImNvbmZpZyIsIGZ1bmN0aW9uKCkgSS53YXJuKF9HWyJDT05GIl0pIGVuZCkKV2hlbigiY29uZmlnIiwgZnVuY3Rpb24oKSBJLndhcm4oX0dbIkNPTkYiXSkgZW5kKQpUaGVuKCJjb25maWciLCBmdW5jdGlvbigpIEkud2FybihfR1siQ09ORiJdKSBlbmQpCgpUaGVuKCJwcmludCBjb2RlYyIsIGZ1bmN0aW9uKCkKCQlpZiBPVVQuY29kZWMgdGhlbgoJCSAgIGVycm9yKCJDYW5ub3Qgb3ZlcndyaXRlIHByaW50ZWQgb3V0cHV0IGNvZGVjIikKCQllbmQKCQlPVVQuY29kZWMgPSBDT0RFQwplbmQpCi96ZW5jb2RlX2RpY3Rpb25hcnkubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIwLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFdlZG5lc2RheSwgNnRoIE9jdG9iZXIgMjAyMQotLV1dCgotLSB0aGlzIGlzIGEgbWFwIHJlZHVjZSBmdW5jdGlvbiBwcm9jZXNzaW5nIGEgc2luZ2xlIGFyZ3VtZW50IGFzCi0tIHZhbHVlcyBmb3VuZCwgaXQgdXNlcyBmdW5jdGlvbiBwb2ludGVycyBhbmQgY29uZGl0aW9ucyBmcm9tIHRoZQotLSBwYXJhbXMgc3RydWN0dXJlLgotLSBwYXJhbS50YXJnZXQgPSBrZXkgbmFtZSBvZiB0aGUgdmFsdWUgdG8gZmluZAotLSBwYXJhbS5vcCA9IHNpbmdsZSBhcmd1bWVudCBmdW5jdGlvbiB0byBydW4gb24gZm91bmQgdmFsdWUKLS0gcGFyYW0uY21wID0gZHVhbCBhcmd1bWVudCBjb21wYXJpc29uIGZvciBkaWN0aW9uYXJ5IGVsaWdpYmlsaXR5Ci0tIHBhcmFtLmNvbmRpdGlvbnMgPSBrL3YgbGlzdCBvZiBlbGVtZW50cyB0byBjb21wYXJlIGluIGRpY3Rpb25hcnkKCmxvY2FsIGZ1bmN0aW9uIGRpY3RzX3JlZHVjZShkaWN0cywgcGFyYW1zKQogICBsb2NhbCBmb3VuZAogICBsb2NhbCBhcnIKICAgZm9yIGFrLGF2IGluIHBhaXJzKGRpY3RzKSBkbwogICAgICBpZiBsdWF0eXBlKGF2KSA9PSAndGFibGUnIHRoZW4KCSBmb3VuZCA9IGZhbHNlCgkgLS0gYXBwbHkgcGFyYW1zIGZpbHRlcnMsIGJvb2xlYW4ganVzdCBjaGVjayBrZXkgcHJlc2VuY2UKCSBpZiBwYXJhbXMuY29uZGl0aW9ucyBhbmQgcGFyYW1zLmNtcCB0aGVuCgkgICAgZm9yIHBrLHB2IGluIHBhaXJzKHBhcmFtcy5jb25kaXRpb25zKSBkbwoJICAgICAgIGxvY2FsIHR2ID0gYXZbcGtdCgkgICAgICAgaWYgdHYgdGhlbgoJCSAgaWYgcGFyYW1zLmNtcCh0diwgcHYpIHRoZW4KCQkgICAgIGZvdW5kID0gdHJ1ZQoJCSAgZW5kCgkgICAgICAgZW5kCgkgICAgZW5kCgkgZWxzZSBmb3VuZCA9IHRydWUgZW5kIC0tIG5vIGZpbHRlcnMsIGFwcGx5IGV2ZXJ5d2hlcmUKCSAtLSBhcHBseSBzdW0gb2Ygc2VsZWN0ZWQga2V5L3ZhbHVlCgkgaWYgZm91bmQgYW5kIGF2W3BhcmFtcy50YXJnZXRdIH49IG5pbCB0aGVuCiAgICAgICAgIHBhcmFtcy5vcChhdltwYXJhbXMudGFyZ2V0XSkKCSBlbmQKICAgICAgZW5kIC0tIGF2IGlzIGEgdGFibGUKICAgZW5kCmVuZAoKV2hlbigiY3JlYXRlIG5ldyBkaWN0aW9uYXJ5IiwgZnVuY3Rpb24oKQoJCWVtcHR5J25ldyBkaWN0aW9uYXJ5JwoJCUFDSy5uZXdfZGljdGlvbmFyeSA9IHsgfQoJCW5ld19jb2RlYygnbmV3IGRpY3Rpb25hcnknLCB7IHplbnR5cGUgPSAnZCcsCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZW5jb2RpbmcgPSAnc3RyaW5nJ30pCmVuZCkKCgpXaGVuKCJjcmVhdGUgbmV3IGRpY3Rpb25hcnkgbmFtZWQgJyciLCBmdW5jdGlvbihuYW1lKQoJCWVtcHR5KG5hbWUpCgkJQUNLW25hbWVdID0geyB9CgkJbmV3X2NvZGVjKG5hbWUsIHsgemVudHlwZSA9ICdkJywKICAgICAgICAgICAgICAgICAgICAgICAgICBlbmNvZGluZyA9ICdzdHJpbmcnfSkKZW5kKQoKV2hlbigiY3JlYXRlIGFycmF5IG9mIGVsZW1lbnRzIG5hbWVkICcnIGZvciBkaWN0aW9uYXJpZXMgaW4gJyciLAogICAgIGZ1bmN0aW9uKG5hbWUsIGRpY3QpCgllbXB0eSdhcnJheScKCWxvY2FsIHNyYyA9IGhhdmUoZGljdCkKCXplbmNvZGVfYXNzZXJ0KGx1YXR5cGUoc3JjKT09J3RhYmxlJywgIk9iamVjdCBpcyBub3QgYSB0YWJsZTogIi4uZGljdCkKCWxvY2FsIHJlcyA9IHsgfQoJZm9yIGssIHYgaW4gcGFpcnMoc3JjKSBkbwoJICAgaWYgayA9PSBuYW1lIHRoZW4gdGFibGUuaW5zZXJ0KHJlcywgdikgZW5kCgkgICAtLSBkaWN0IGlzIG1vc3Qgb2Z0ZXJuIGFuIGFycmF5IG9mIGRpY3Rpb25hcmllcwoJICAgZm9yIGtrLCB2diBpbiBwYWlycyh2KSBkbwoJICAgICAgaWYga2sgPT0gbmFtZSB0aGVuIHRhYmxlLmluc2VydChyZXMsIHZ2KSBlbmQKCSAgIGVuZAoJZW5kCglBQ0suYXJyYXkgPSByZXMKCW5ld19jb2RlYygnYXJyYXknLCB7emVudHlwZT0nYSd9LCBkaWN0KQplbmQpCgpXaGVuKCJjcmVhdGUgcHJ1bmVkIGRpY3Rpb25hcnkgb2YgJyciLCBmdW5jdGlvbihkaWN0KQoJZW1wdHkncHJ1bmVkIGRpY3Rpb25hcnknCglsb2NhbCBkID0gaGF2ZShkaWN0KQoJemVuY29kZV9hc3NlcnQobHVhdHlwZShkKSA9PSAndGFibGUnLCAnT2JqZWN0IGlzIG5vdCBhIHRhYmxlOiAnLi5kaWN0KQoJQUNLLnBydW5lZF9kaWN0aW9uYXJ5ID0gcHJ1bmUoZCkKCW5ld19jb2RlYygncHJ1bmVkIGRpY3Rpb25hcnknLCBuaWwsIGRpY3QpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9pbml0aWFsX3NldChudW1iZXIsIG5hbWUsIGFycikKICAgIGxvY2FsIHQgPSB0eXBlKG51bWJlcikKICAgIGxvY2FsIGVuYwogICAgaWYgdCA9PSAiemVucm9vbS5mbG9hdCIgdGhlbgogICAgICAgIGVuYyA9ICJmbG9hdCIKICAgIGVsc2VpZiB0ID09ICJ6ZW5yb29tLmJpZyIgdGhlbgogICAgICAgIGVuYyA9ICJpbnRlZ2VyIgogICAgZWxzZWlmIHQgPT0gInplbnJvb20udGltZSIgdGhlbgogICAgICAgIGVuYyA9ICJ0aW1lIgogICAgZWxzZQogICAgICAgIGVycm9yKG5hbWUuLiIgaW5zaWRlIGRpY3Rpb25haXJlcyBpbiAiLi5hcnIuLiIgaXMgbmVpdGhlciBhIGludGVnZXIgbm9yIGEgZmxvYXQiKQogICAgZW5kCiAgICByZXR1cm4gbnVtYmVyLCBlbmMKZW5kCgpXaGVuKCJmaW5kIG1heCB2YWx1ZSAnJyBmb3IgZGljdGlvbmFyaWVzIGluICcnIiwgZnVuY3Rpb24obmFtZSwgYXJyKQoJemVuY29kZV9hc3NlcnQobHVhdHlwZShoYXZlKGFycikpID09ICd0YWJsZScsICdPYmplY3QgaXMgbm90IGEgdGFibGU6ICcuLmFycikKCWVtcHR5J21heCB2YWx1ZScKCWxvY2FsIG1heCA9IG5pbAogICAgbG9jYWwgbWF4X2VuYyA9IG5pbAoJbG9jYWwgcGFyYW1zID0gewoJCQkJdGFyZ2V0ID0gbmFtZSwKCQkJCW9wID0gZnVuY3Rpb24odikKCQkJCQlpZiBub3QgbWF4IHRoZW4KICAgICAgICAgICAgICAgICAgICAgICAgbWF4LCBtYXhfZW5jID0gX2luaXRpYWxfc2V0KHYsIG5hbWUsIGFycikKCQkJCQllbHNlaWYgbWF4IDwgdiB0aGVuIG1heCA9IHYgZW5kCgkJCQllbmQKCQkJfQoJZGljdHNfcmVkdWNlKEFDS1thcnJdLHBhcmFtcykgLS0gb3B0aW1pemF0aW9uPyBvcGVyYXRlIGRpcmVjdGx5IG9uIEFDSwogICAgemVuY29kZV9hc3NlcnQobWF4LCAiTm8gbWF4IHZhbHVlICIuLm5hbWUuLiIgZm91bmQgYWNyb3NzIGRpY3Rpb25hcmllcyBpbiAiLi5hcnIpCiAgICBBQ0subWF4X3ZhbHVlID0gbWF4CgluZXdfY29kZWMoJ21heCB2YWx1ZScsIHsKICAgICAgICB6ZW50eXBlID0gJ2UnLAogICAgICAgIGVuY29kaW5nID0gbWF4X2VuYwoJfSkKZW5kKQoKV2hlbigiZmluZCBtaW4gdmFsdWUgJycgZm9yIGRpY3Rpb25hcmllcyBpbiAnJyIsIGZ1bmN0aW9uKG5hbWUsIGFycikKCXplbmNvZGVfYXNzZXJ0KGx1YXR5cGUoaGF2ZShhcnIpKSA9PSAndGFibGUnLCAnT2JqZWN0IGlzIG5vdCBhIHRhYmxlOiAnLi5hcnIpCgllbXB0eSdtaW4gdmFsdWUnCglsb2NhbCBtaW4gPSBuaWwKICAgIGxvY2FsIG1pbl9lbmMgPSBuaWwKCWxvY2FsIHBhcmFtcyA9IHsKCQl0YXJnZXQgPSBuYW1lLAoJCW9wID0gZnVuY3Rpb24odikKICAgICAgICAgICAgaWYgbm90IG1pbiB0aGVuCiAgICAgICAgICAgICAgICBtaW4sIG1pbl9lbmMgPSBfaW5pdGlhbF9zZXQodiwgbmFtZSwgYXJyKQoJCQllbHNlaWYgdiA8IG1pbiB0aGVuIG1pbiA9IHYgZW5kCgkJIGVuZAoJfQoJZGljdHNfcmVkdWNlKEFDS1thcnJdLHBhcmFtcykKICAgIHplbmNvZGVfYXNzZXJ0KG1pbiwgIk5vIG1pbiB2YWx1ZSAiLi5uYW1lLi4iIGZvdW5kIGFjcm9zcyBkaWN0aW9uYXJpZXMgaW4gIi4uYXJyKQoJQUNLLm1pbl92YWx1ZSA9IG1pbgoJbmV3X2NvZGVjKCdtaW4gdmFsdWUnLCB7CiAgICAgICAgemVudHlwZSA9ICdlJywKICAgICAgICBlbmNvZGluZyA9IG1pbl9lbmMKICAgIH0pCmVuZCkKCldoZW4oImNyZWF0ZSBzdW0gdmFsdWUgJycgZm9yIGRpY3Rpb25hcmllcyBpbiAnJyIsIGZ1bmN0aW9uKG5hbWUsYXJyKQoJemVuY29kZV9hc3NlcnQobHVhdHlwZShoYXZlKGFycikpID09ICd0YWJsZScsICdPYmplY3QgaXMgbm90IGEgdGFibGU6ICcuLmFycikKCWVtcHR5J3N1bSB2YWx1ZScKCWxvY2FsIHN1bSAtLSByZXN1bHQgb2YgcmVkdWN0aW9uCiAgICBsb2NhbCBzdW1fZW5jCglsb2NhbCBwYXJhbXMgPSB7CgkJdGFyZ2V0ID0gbmFtZSwKCQlvcCA9IGZ1bmN0aW9uKHYpCiAgICAgICAgICAgIGlmIG5vdCBzdW0gdGhlbgogICAgICAgICAgICAgICAgc3VtLCBzdW1fZW5jID0gX2luaXRpYWxfc2V0KHYsIG5hbWUsIGFycikKICAgICAgICAgICAgZWxzZSBzdW0gPSBzdW0gKyB2IGVuZAoJCWVuZAoJfQogICAgZGljdHNfcmVkdWNlKEFDS1thcnJdLCBwYXJhbXMpCiAgICB6ZW5jb2RlX2Fzc2VydChzdW0sICJObyBzdW0gb2YgdmFsdWUgIi4ubmFtZQoJCQkJICAuLiIgZm91bmQgYWNyb3NzIGRpY3Rpb25hcmllcyBpbiAiLi5hcnIpCiAgICBBQ0suc3VtX3ZhbHVlID0gc3VtCgluZXdfY29kZWMoJ3N1bSB2YWx1ZScsIHsKICAgICAgICB6ZW50eXBlID0gJ2UnLAogICAgICAgIGVuY29kaW5nID0gc3VtX2VuYwoJfSkKZW5kKQoKV2hlbigiY3JlYXRlIHN1bSB2YWx1ZSAnJyBmb3IgZGljdGlvbmFyaWVzIGluICcnIHdoZXJlICcnID4gJyciLCBmdW5jdGlvbihuYW1lLGFyciwgbGVmdCwgcmlnaHQpCgl6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKGhhdmUoYXJyKSkgPT0gJ3RhYmxlJywgJ09iamVjdCBpcyBub3QgYSB0YWJsZTogJy4uYXJyKQoJaGF2ZShyaWdodCkKCWVtcHR5J3N1bSB2YWx1ZScKCglsb2NhbCBzdW0gPSBuaWwgLS0gcmVzdWx0IG9mIHJlZHVjdGlvbgogICAgbG9jYWwgc3VtX2VuYwoJbG9jYWwgcGFyYW1zID0gewoJCXRhcmdldCA9IG5hbWUsCgkJY29uZGl0aW9ucyA9IHsgfSwKCQljbXAgPSBmdW5jdGlvbihsLHIpIHJldHVybiBsID4gciBlbmQsCgkJb3AgPSBmdW5jdGlvbih2KQogICAgICAgICAgICBpZiBzdW0gPT0gbmlsIHRoZW4KICAgICAgICAgICAgICAgIHN1bSwgc3VtX2VuYyA9IF9pbml0aWFsX3NldCh2LCBuYW1lLCBhcnIpCiAgICAgICAgICAgIGVsc2Ugc3VtID0gc3VtICsgdiBlbmQKICAgICAgICBlbmQKCX0KCXBhcmFtcy5jb25kaXRpb25zW2xlZnRdID0gQUNLW3JpZ2h0XSAtLSB1c2VkIGluIGNtcAogICAgZGljdHNfcmVkdWNlKEFDS1thcnJdLCBwYXJhbXMpCiAgICB6ZW5jb2RlX2Fzc2VydChzdW0sICJObyBzdW0gb2YgdmFsdWUgIi4ubmFtZQoJCQkJICAuLiIgZm91bmQgYWNyb3NzIGRpY3Rpb25hcmllcyBpbiIuLmFycikKICAgIEFDSy5zdW1fdmFsdWUgPSBzdW0KCW5ld19jb2RlYygnc3VtIHZhbHVlJywgewogICAgICAgIHplbnR5cGUgPSAnZScsCiAgICAgICAgZW5jb2RpbmcgPSBzdW1fZW5jCgl9KQplbmQpCgpXaGVuKCJmaW5kICcnIGZvciBkaWN0aW9uYXJpZXMgaW4gJycgd2hlcmUgJycgPSAnJyIsZnVuY3Rpb24obmFtZSwgYXJyLCBsZWZ0LCByaWdodCkKCXplbmNvZGVfYXNzZXJ0KGx1YXR5cGUoaGF2ZShhcnIpKSA9PSAndGFibGUnLCAnT2JqZWN0IGlzIG5vdCBhIHRhYmxlOiAnLi5hcnIpCgloYXZlKHJpZ2h0KQoJZW1wdHkobmFtZSkKCglsb2NhbCB2YWwgPSB7IH0KCWxvY2FsIHBhcmFtcyA9IHsKCQl0YXJnZXQgPSBuYW1lLAoJCWNvbmRpdGlvbnMgPSB7IH0sCgkJY21wID0gZnVuY3Rpb24obCxyKSByZXR1cm4gbCA9PSByIGVuZCwKCQlvcCA9IGZ1bmN0aW9uKHYpIHRhYmxlLmluc2VydCh2YWwsIHYpIGVuZAoJfQoJcGFyYW1zLmNvbmRpdGlvbnNbbGVmdF0gPSBBQ0tbcmlnaHRdCglkaWN0c19yZWR1Y2UoQUNLW2Fycl0sIHBhcmFtcykKCXplbmNvZGVfYXNzZXJ0KHZhbCwgIk5vIHZhbHVlIGZvdW5kICIuLm5hbWUuLiIgYWNyb3NzIGRpY3Rpb25hcmllcyBpbiAiLi5hcnIpCglBQ0tbbmFtZV0gPSB2YWwKCW5ld19jb2RlYyhuYW1lLCB7emVudHlwZSA9ICdhJ30sIGFycikKZW5kKQoKCmxvY2FsIGZ1bmN0aW9uIF9leHRyYWN0KHRhYiwgZWxlLCByb290KQogICBsb2NhbCBuciA9IHJvb3Qgb3IgJ25pbCcKICAgemVuY29kZV9hc3NlcnQobHVhdHlwZSh0YWIpID09ICd0YWJsZScsICJPYmplY3QgaXMgbm90IGEgdGFibGU6ICIuLm5yKQogICB6ZW5jb2RlX2Fzc2VydChlbGUsICJVbmRlZmluZWQga2V5IG9yIGluZGV4OiAiLi5lbGUuLiIgaW4gIi4ubnIpCiAgIGlmICN0YWIgPT0gMSB0aGVuCiAgICAgIGlmIHRhYltlbGVdIHRoZW4gcmV0dXJuIHRhYltlbGVdIGVuZAogICAgICBpZiBsdWF0eXBlKHRhYlsxXSkgPT0gJ3RhYmxlJyBhbmQgdGFiWzFdW2VsZV0gdGhlbgoJIHJldHVybiB0YWJbMV1bZWxlXQogICAgICBlbmQKICAgZWxzZQogICAgICBpZiB0YWJbZWxlXSB0aGVuIHJldHVybiB0YWJbZWxlXSBlbmQKICAgZW5kCiAgIGVycm9yKCJNZW1iZXIgbm90IGZvdW5kOiAiLi5lbGUuLiIgaW4gIi4ubnIsIDMpCmVuZApsb2NhbCBmdW5jdGlvbiBjcmVhdGVfY29weV9mKHJvb3QsIGluMSwgaW4yKQoJZW1wdHknY29weScKCWxvY2FsIHIsIHJfY29kZWMgPSBoYXZlKHJvb3QpCglBQ0suY29weSA9IF9leHRyYWN0KHIsIGluMSwgcm9vdCkKCWlmIGluMiB0aGVuCgkgICBBQ0suY29weSA9IF9leHRyYWN0KEFDSy5jb3B5LCBpbjIsIGluMSkKCWVuZAogICAgbG9jYWwgbl9jb2RlYyA9IHsgZW5jb2RpbmcgPSByX2NvZGVjLmVuY29kaW5nIH0KICAgIC0tIHRhYmxlIG9mIHNjaGVtYXMgY2FuIG9ubHkgY29udGFpbiBlbGVtZW50cwogICAgaWYgcl9jb2RlYy5zY2hlbWEgdGhlbgogICAgICAgIG5fY29kZWMuc2NoZW1hID0gcl9jb2RlYy5zY2hlbWEKICAgICAgICBuX2NvZGVjLnplbnR5cGUgPSAiZSIKICAgIGVuZAogICAgbl9jb2RlYy5tYXNrID0gcl9jb2RlYy5tYXNrIC0tIGVuY29kaW5nIG1hc2sgaWYgbm90IG5pbAoJbmV3X2NvZGVjKCdjb3B5Jywgbl9jb2RlYykKCUNPREVDWydjb3B5J10ubmFtZSA9IGluMiBvciBpbjEKZW5kCldoZW4oImNyZWF0ZSBjb3B5IG9mICcnIGZyb20gZGljdGlvbmFyeSAnJyIsIGZ1bmN0aW9uKG5hbWUsIGRpY3QpIGNyZWF0ZV9jb3B5X2YoZGljdCwgbmFtZSkgZW5kKQpXaGVuKCJjcmVhdGUgY29weSBvZiAnJyBmcm9tICcnIiwgZnVuY3Rpb24obmFtZSwgZGljdCkgY3JlYXRlX2NvcHlfZihkaWN0LCBuYW1lKSBlbmQpCldoZW4oImNyZWF0ZSBjb3B5IG9mIG9iamVjdCBuYW1lZCBieSAnJyBmcm9tIGRpY3Rpb25hcnkgJyciLCBmdW5jdGlvbihuYW1lLCBkaWN0KQogIGxvY2FsIGxhYmVsID0gaGF2ZShuYW1lKQogIGNyZWF0ZV9jb3B5X2YoZGljdCwgbGFiZWw6c3RyaW5nKCkpCmVuZCkKCldoZW4oImZvciBlYWNoIGRpY3Rpb25hcnkgaW4gJycgYXBwZW5kICcnIHRvICcnIiwgZnVuY3Rpb24oYXJyLCByaWdodCwgbGVmdCkKCWxvY2FsIGRpY3RzID0gaGF2ZShhcnIpCgl6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKGRpY3RzKSA9PSAndGFibGUnLCAnT2JqZWN0IGlzIG5vdCBhIHRhYmxlOiAnLi5hcnIpCglmb3Iga2ssdnYgaW4gcGFpcnMoZGljdHMpIGRvCgkJbG9jYWwgbCwgcgoJCWZvciBrLHYgaW4gcGFpcnModnYpIGRvCgkJCWlmIGsgPT0gcmlnaHQgdGhlbiByID0gdiBlbmQKCQkJaWYgayA9PSBsZWZ0IHRoZW4gbCA9IHYgZW5kCgkJZW5kCgkJemVuY29kZV9hc3NlcnQobCwgIk9iamVjdCBub3QgZm91bmQ6ICIuLmtrLi4iLiIuLmxlZnQpCgkJemVuY29kZV9hc3NlcnQociwgIk9iamVjdCBub3QgZm91bmQ6ICIuLmtrLi4iLiIuLnJpZ2h0KQoJCXZ2W2xlZnRdID0gbC4ucgoJZW5kCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9maWx0ZXJfZnJvbSh2LCBrLCBmKQogICBmb3IgXywgZnYgaW4gcGFpcnMoZikgZG8KICAgICAgaWYgZnY6c3RyKCkgPT0gayB0aGVuCgkgcmV0dXJuIHYKICAgICAgZW5kCiAgIGVuZAogICByZXR1cm4gbmlsCmVuZAoKbG9jYWwgZnVuY3Rpb24gX2lzX2FycmF5X29mX2RpY3Rpb25hcmllcyhhKQogICBpZiBub3QgaXNhcnJheShhKSB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgZm9yIF8sIHYgaW4gcGFpcnMoYSkgZG8KICAgICAgaWYgbHVhdHlwZSh2KSB+PSAndGFibGUnIHRoZW4KCSByZXR1cm4gZmFsc2UKICAgICAgZW5kCiAgIGVuZAogICByZXR1cm4gdHJ1ZQplbmQKCldoZW4oImZpbHRlciAnJyBmaWVsZHMgZnJvbSAnJyIsIGZ1bmN0aW9uKGZpbHRlcnMsIHRhcmdldCkKCWxvY2FsIHQgPSBoYXZlKHRhcmdldCkKCXplbmNvZGVfYXNzZXJ0KGlzZGljdGlvbmFyeSh0YXJnZXQpIG9yCgkJICAgX2lzX2FycmF5X29mX2RpY3Rpb25hcmllcyh0KSwKCQkgICAiT2JqZWN0IGlzIG5vciBhIGRpY3Rpb25hcnkgbmVpdGhlciBhbiBhcnJheSBvZiBkaWN0aW9uYXJpZXM6ICIuLnRhcmdldCkKCWxvY2FsIGYgPSBoYXZlKGZpbHRlcnMpCgl6ZW5jb2RlX2Fzc2VydChpc2FycmF5KGZpbHRlcnMpLCAiT2JqZWN0IGlzIG5vdCBhbiBhcnJheTogIi4uZmlsdGVycykKCUFDS1t0YXJnZXRdID0gZGVlcG1hcChfZmlsdGVyX2Zyb20sIHQsIGYpCmVuZCkKL3plbmNvZGVfZGlkLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IE1hdHRlbyBDcmlzdGlubwotLW9uIFRodXJzZGF5LCAyNnRoIFNlcHRlbWJlciAyMDI0Ci0tXV0KCmxvY2FsIFczQyA9IHJlcXVpcmVfb25jZSAiY3J5cHRvX3czYyIKCmxvY2FsIEVUSEVSRVVNX0FERFJFU1MgPSAiZXRoZXJldW1fYWRkcmVzcyIKbG9jYWwgRUREU0FfUFVCTElDX0tFWSA9ICJlZGRzYV9wdWJsaWNfa2V5IgoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X2RpZF9kb2N1bWVudChkb2MpCiAgICAtLSBpZCBhbmQgQGNvbnRleHQgbXVzdCBiZSBhbHdheXMgcHJlc2VudCBpbiBESUQtZG9jdW1lbnRzCiAgICB6ZW5jb2RlX2Fzc2VydChkb2MuaWQgYW5kICNkb2MuaWQgPCAyNTYsICdJbnZhbGlkIERJRCBkb2N1bWVudDogaWQgbm90IGZvdW5kJykKICAgIHplbmNvZGVfYXNzZXJ0KGRvY1snQGNvbnRleHQnXSwgJ0ludmFsaWQgRElEIGRvY3VtZW50OiBAY29udGV4dCBub3QgZm91bmQnKQogICAgemVuY29kZV9hc3NlcnQoI0pTT04uZW5jb2RlKGRvYywgJ3N0cmluZycpIDwgODE5MiwgJ0RJRCBkb2N1bWVudCB0b28gbGFyZ2UnKQogICAgbG9jYWwgZGlkX2NvbXBvbmVudHMgPSBzdHJ0b2soZG9jLmlkLCAnOicpCiAgICAtLSBzY2htZTogZGlkCiAgICB6ZW5jb2RlX2Fzc2VydChkaWRfY29tcG9uZW50c1sxXSA9PSAnZGlkJywKICAgICAgICAgICAgJ0ludmFsaWQgRElEIGRvY3VtZW50OiBpbnZhbGlkIHNjaGVtZScpCiAgICAtLSBtZXRob2QgbmFtZTogYS16LzAtOQogICAgemVuY29kZV9hc3NlcnQobm90IGRpZF9jb21wb25lbnRzWzJdOm1hdGNoKCdbXiVsJWRdJyksCiAgICAgICAgICAgICdJbnZhbGlkIERJRCBkb2N1bWVudDogaW52YWxpZCBtZXRob2QtbmFtZScpCiAgICAtLSBtYXRob2Qgc3BlY2lmaWMgaWRlbnRpZmllcjogYS16L0EtWi8wLTkvIi4iLyItIi8iXyIvIiUiIEhFWERJRyBIRVhESUcKICAgIGxvY2FsIGVycm9yX21zZyA9ICdJbnZhbGlkIERJRCBkb2N1bWVudDogaW52YWxpZCBtZXRob2Qgc3BlY2lmaWMgaWRlbnRpZmllcicKICAgIGZvciBpPTMsI2RpZF9jb21wb25lbnRzIGRvCiAgICAgICAgZmlyc3QgPSB0cnVlCiAgICAgICAgZm9yIGNoYXJzIGluIGRpZF9jb21wb25lbnRzW2ldOmdtYXRjaCgnW14lJV0qJykgZG8KICAgICAgICAgICAgaWYgZmlyc3QgdGhlbgogICAgICAgICAgICAgICAgemVuY29kZV9hc3NlcnQobm90IGNoYXJzOm1hdGNoKCdbXiV3JS4lLSVfXScpLAogICAgICAgICAgICAgICAgICAgIGVycm9yX21zZykKICAgICAgICAgICAgICAgIGZpcnN0ID0gbmlsCiAgICAgICAgICAgIGVsc2UKICAgICAgICAgICAgLS0gY2hlY2tzICUlCiAgICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KGNoYXJzLCBlcnJvcl9tc2cpCiAgICAgICAgICAgIC0tIGNoZWNrcyAlaGV4aGV4Li4uCiAgICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KGNoYXJzOm1hdGNoKCcleCV4WyV3JS4lLSVfXSonKSA9PSBjaGFycywKICAgICAgICAgICAgICAgIGVycm9yX21zZykKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiBzY2hlbWFfZ2V0KGRvYywgJy4nLCBPLmZyb21fc3RyaW5nLCB0b3N0cmluZykKZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfZGlkX2RvY3VtZW50KGRvYykKICAgIHJldHVybiBkZWVwbWFwKE8udG9fc3RyaW5nLCBkb2MpCmVuZAoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3ZlcmlmaWNhdGlvbl9tZXRob2QoZG9jKQogICAgbG9jYWwgcmVzID0ge30KICAgIGxvY2FsIGltcG9ydF9mdW5jdGlvbnMgPSB7CiAgICAgICAgW0VUSEVSRVVNX0FERFJFU1NdID0gTy5mcm9tX2hleCwKICAgICAgICBbRUREU0FfUFVCTElDX0tFWV0gPSBPLmZyb21fYmFzZTU4CiAgICB9CiAgICBmb3Iga2V5LCBfIGluIHBhaXJzKGRvYykgZG8KICAgICAgICByZXNba2V5XSA9IHNjaGVtYV9nZXQoZG9jW2tleV0sICcuJywKICAgICAgICAgICAgICAgICAgICAgICAgICAgaW1wb3J0X2Z1bmN0aW9uc1trZXldIG9yIE8uZnJvbV9iYXNlNjQsCiAgICAgICAgICAgICAgICAgICAgICAgICAgIHRvc3RyaW5nKQogICAgZW5kCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X3ZlcmlmaWNhdGlvbl9tZXRob2QoZG9jKQogICAgbG9jYWwgcmVzID0ge30KICAgIGxvY2FsIGV4cG9ydF9mdW5jdGlvbnMgPSB7CiAgICAgICAgW0VUSEVSRVVNX0FERFJFU1NdID0gTy50b19oZXgsCiAgICAgICAgW0VERFNBX1BVQkxJQ19LRVldID0gTy50b19iYXNlNTgKICAgIH0KICAgIGZvciBrZXksIHZlcl9tZXRob2QgaW4gcGFpcnMoZG9jKSBkbwogICAgICAgIHJlc1trZXldID0gKGV4cG9ydF9mdW5jdGlvbnNba2V5XSBvciBPLnRvX2Jhc2U2NCkodmVyX21ldGhvZCkKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIGRpZF9kb2N1bWVudCA9IHsgCiAgICAgICAgICAgIGltcG9ydCA9IGltcG9ydF9kaWRfZG9jdW1lbnQsCiAgICAgICAgICAgIGV4cG9ydCA9IGV4cG9ydF9kaWRfZG9jdW1lbnQsCiAgICAgICAgICAgIHNjaGVtYXR5cGUgPSAnb3BlbicKICAgICAgICB9LAogICAgICAgIHZlcmlmaWNhdGlvbk1ldGhvZCA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X3ZlcmlmaWNhdGlvbl9tZXRob2QsCiAgICAgICAgICAgIGV4cG9ydCA9IGV4cG9ydF92ZXJpZmljYXRpb25fbWV0aG9kCiAgICAgICAgfQogICAgfQopCgpJZldoZW4oInZlcmlmeSBkaWQgZG9jdW1lbnQgbmFtZWQgJyciLCBmdW5jdGlvbihzcmMpCiAgICBsb2NhbCBkb2N1bWVudCA9IGhhdmUoc3JjKQogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KGRvY3VtZW50LnByb29mIGFuZCBkb2N1bWVudC5wcm9vZi5qd3MsCiAgICAgICAgJ1RoZSBvYmplY3QgaGFzIG5vIHNpZ25hdHVyZTogJyAuLiBzcmMpIHRoZW4gcmV0dXJuIGVuZAogICAgVzNDLnZlcmlmeV9qd3NfZnJvbV9wcm9vZihzcmMsIGRvY3VtZW50KQplbmQpCgpJZldoZW4oInZlcmlmeSBkaWQgZG9jdW1lbnQgbmFtZWQgJycgaXMgc2lnbmVkIGJ5ICcnIiwgZnVuY3Rpb24oc3JjLCBzaWduZXJfZGlkX2RvYykKICAgIGxvY2FsIGRvY3VtZW50ID0gaGF2ZShzcmMpCiAgICBsb2NhbCBzaWduZXJfZG9jdW1lbnQgPSBoYXZlKHNpZ25lcl9kaWRfZG9jKQogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KGRvY3VtZW50LnByb29mIGFuZCBkb2N1bWVudC5wcm9vZi5qd3MsCiAgICAgICAgJ1RoZSBvYmplY3QgaGFzIG5vIHNpZ25hdHVyZTogJyAuLiBzcmMpIHRoZW4gcmV0dXJuIGVuZAogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KGRvY3VtZW50LnByb29mLnZlcmlmaWNhdGlvbk1ldGhvZCwKICAgICAgICAnVGhlIHByb29mIGluc2lkZSAnLi5zcmMuLicgaGFzIG5vIHZlcmlmaWNhdGlvbk1ldGhvZCcpIHRoZW4gcmV0dXJuIGVuZAogICAgbG9jYWwgZGF0YSA9IHN0cnRvayhPLnRvX3N0cmluZyhkb2N1bWVudC5wcm9vZi52ZXJpZmljYXRpb25NZXRob2QpLCAnIycgKQogICAgbG9jYWwgc2lnbmVyX2lkID0gTy5mcm9tX3N0cmluZyhkYXRhWzFdKQogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KHNpZ25lcl9pZCA9PSBzaWduZXJfZG9jdW1lbnQuaWQsCiAgICAgICAgICAgICAgICAnVGhlIHNpZ25lciBpZCBpbiBwcm9vZiBpcyBkaWZmZXJlbnQgZnJvbSB0aGUgb25lIGluICcuLnNpZ25lcl9kaWRfZG9jKSB0aGVuIHJldHVybiBlbmQKICAgIGxvY2FsIGkgPSAxCiAgICBsb2NhbCBwayA9IG5pbAogICAgcmVwZWF0CiAgICAgICAgaWYgc2lnbmVyX2RvY3VtZW50LnZlcmlmaWNhdGlvbk1ldGhvZFtpXS5pZCA9PSBkb2N1bWVudC5wcm9vZi52ZXJpZmljYXRpb25NZXRob2QgdGhlbgogICAgICAgICAgICBwayA9IE8uZnJvbV9iYXNlNTgoCiAgICAgICAgICAgICAgICBPLnRvX3N0cmluZyggc2lnbmVyX2RvY3VtZW50LnZlcmlmaWNhdGlvbk1ldGhvZFtpXS5wdWJsaWNLZXlCYXNlNTggKSkKICAgICAgICBlbmQKICAgICAgICBpID0gaSsxCiAgICB1bnRpbCggKCBub3Qgc2lnbmVyX2RvY3VtZW50LnZlcmlmaWNhdGlvbk1ldGhvZFtpXSApIG9yIHBrICkKICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydChwayAsIGRhdGFbMl0uLicgdXNlZCB0byBzaWduICcuLnNyYy4uJyBub3QgZm91bmQgaW4gdGhlIGRpZCBkb2N1bWVudCAnLi5zaWduZXJfZGlkX2RvYykgdGhlbiByZXR1cm4gZW5kCiAgICBXM0MudmVyaWZ5X2p3c19mcm9tX3Byb29mKHNyYywgZG9jdW1lbnQsIHBrKQplbmQpCgotLSBvcGVyYXRpb25zIG9uIHRoZSBkaWQtZG9jdW1lbnQKV2hlbigiY3JlYXRlIHNlcnZpY2VFbmRwb2ludCBvZiAnJyIsIGZ1bmN0aW9uKGRpZF9kb2MpCiAgICBsb2NhbCBkb2MgPSBoYXZlKGRpZF9kb2MpCiAgICB6ZW5jb2RlX2Fzc2VydChkb2Muc2VydmljZSwgJ3NlcnZpY2Ugbm90IGZvdW5kJykKICAgIEFDSy5zZXJ2aWNlRW5kcG9pbnQgPSB7fQogICAgZm9yIF8sIHNlcnZpY2UgaW4gcGFpcnMoZG9jLnNlcnZpY2UpIGRvCiAgICAgICAgbG9jYWwgbmFtZSA9IHN0cnRvayhPLnRvX3N0cmluZyhzZXJ2aWNlLmlkKSwgJyMnKVsyXQogICAgICAgIEFDSy5zZXJ2aWNlRW5kcG9pbnRbbmFtZV0gPSBzZXJ2aWNlLnNlcnZpY2VFbmRwb2ludAogICAgZW5kCiAgICBuZXdfY29kZWMoJ3NlcnZpY2VFbmRwb2ludCcsIHsgZW5jb2RpbmcgPSAnc3RyaW5nJywKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgemVudHlwZSA9ICdkJyB9KQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfaW1wb3J0X3BrX2YocGtfbmFtZSwgcGtfdmFsdWUsIGRlc3QpCiAgICBsb2NhbCBpc3N1ZXJfcGsgPSAnaXNzdWVyX3B1YmxpY19rZXknCiAgICBsb2NhbCByZXMgPSBPLmZyb21fYmFzZTU4KE8udG9fc3RyaW5nKHBrX3ZhbHVlKSkKICAgIGlmIHN0cmluZy5zdWIocGtfbmFtZSwgMSwgI2lzc3Vlcl9waykgPT0gaXNzdWVyX3BrIHRoZW4KICAgICAgICByZXMgPSB7CiAgICAgICAgICAgIGFscGhhID0gRUNQMi5mcm9tX3pjYXNoKHJlczpzdWIoMSwgOTYpKSwKICAgICAgICAgICAgYmV0YSA9IEVDUDIuZnJvbV96Y2FzaChyZXM6c3ViKDk3LCAxOTIpKQogICAgICAgIH0KICAgIGVuZAogICAgZGVzdFtwa19uYW1lXSA9IHJlcwplbmQKCldoZW4oImNyZWF0ZSB2ZXJpZmljYXRpb25NZXRob2Qgb2YgJyciLCBmdW5jdGlvbihkaWRfZG9jKQogICAgbG9jYWwgZG9jID0gaGF2ZShkaWRfZG9jKQogICAgemVuY29kZV9hc3NlcnQoZG9jLnZlcmlmaWNhdGlvbk1ldGhvZCwgJ3ZlcmlmaWNhdGlvbk1ldGhvZCBub3QgZm91bmQnKQogICAgZW1wdHkgJ3ZlcmlmaWNhdGlvbk1ldGhvZCcKICAgIEFDSy52ZXJpZmljYXRpb25NZXRob2QgPSB7fQogICAgZm9yIF8sIHZlcl9tZXRob2QgaW4gcGFpcnMoZG9jLnZlcmlmaWNhdGlvbk1ldGhvZCkgZG8KICAgICAgICBsb2NhbCBwdWJfa2V5X25hbWUgPSBzdHJ0b2soTy50b19zdHJpbmcodmVyX21ldGhvZC5pZCksICcjJylbMl0KICAgICAgICBpZiBwdWJfa2V5X25hbWUgPT0gRVRIRVJFVU1fQUREUkVTUyB0aGVuCiAgICAgICAgICAgIGxvY2FsIGFkZHJlc3MgPSBzdHJ0b2soCiAgICAgICAgICAgICAgICBPLnRvX3N0cmluZyh2ZXJfbWV0aG9kLmJsb2NrY2hhaW5BY2NvdW50SWQpLCAnOicgKVszXQogICAgICAgICAgICBBQ0sudmVyaWZpY2F0aW9uTWV0aG9kW3B1Yl9rZXlfbmFtZV0gPSBPLmZyb21faGV4KGFkZHJlc3MpCiAgICAgICAgZWxzZQogICAgICAgICAgICBfaW1wb3J0X3BrX2YocHViX2tleV9uYW1lLCB2ZXJfbWV0aG9kLnB1YmxpY0tleUJhc2U1OCwgQUNLLnZlcmlmaWNhdGlvbk1ldGhvZCkKICAgICAgICBlbmQKICAgIGVuZAogICAgbmV3X2NvZGVjKCd2ZXJpZmljYXRpb25NZXRob2QnKQplbmQpCgpXaGVuKCJjcmVhdGUgJycgcHVibGljIGtleSBmcm9tIGRpZCBkb2N1bWVudCAnJyIsIGZ1bmN0aW9uKGFsZ28sIGRpZF9kb2MpCiAgICBsb2NhbCBkb2MgPSBoYXZlIChkaWRfZG9jKQogICAgbG9jYWwgcGtfbmFtZSA9IGFsZ28uLidfcHVibGljX2tleScKICAgIGVtcHR5IChwa19uYW1lKQogICAgemVuY29kZV9hc3NlcnQoZG9jLnZlcmlmaWNhdGlvbk1ldGhvZCwgJ3ZlcmlmaWNhdGlvbk1ldGhvZCBub3QgZm91bmQgaW4gJy4uZGlkX2RvYykKICAgIGxvY2FsIGlkID0gZG9jLmlkLi5PLmZyb21fc3RyaW5nKCcjJy4ucGtfbmFtZSkKICAgIGxvY2FsIGkgPSAxCiAgICByZXBlYXQKICAgICAgICBpZiBkb2MudmVyaWZpY2F0aW9uTWV0aG9kW2ldLmlkID09IGlkIHRoZW4KICAgICAgICAgICAgX2ltcG9ydF9wa19mKHBrX25hbWUsIGRvYy52ZXJpZmljYXRpb25NZXRob2RbaV0ucHVibGljS2V5QmFzZTU4LCBBQ0spCiAgICAgICAgZW5kCiAgICAgICAgaSA9IGkrMQogICAgdW50aWwoICggbm90IGRvYy52ZXJpZmljYXRpb25NZXRob2RbaV0gKSBvciBBQ0tbcGtfbmFtZV0gKQogICAgemVuY29kZV9hc3NlcnQoQUNLW3BrX25hbWVdLCBwa19uYW1lLi4nIG5vdCBmb3VuZCBpbiB0aGUgZGlkIGRvY3VtZW50ICcuLmRpZF9kb2MpCiAgICBDT0RFQ1twa19uYW1lXSA9IGd1ZXNzX2NvbnZlcnNpb24oQUNLW3BrX25hbWVdLCBwa19uYW1lKQogICAgQ09ERUNbcGtfbmFtZV0ubmFtZSA9IHBrX25hbWUKZW5kKQovemVuY29kZV9kcDN0Lmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBUdWVzZGF5LCAyMHRoIEp1bHkgMjAyMQotLV1dCgotLSBEZWNlbnRyYWxpemVkIFByaXZhY3ktUHJlc2VydmluZyBQcm94aW1pdHkgVHJhY2luZyBzY2VuYXJpb24gaW4gWmVuY29kZQoKU0hBMjU2ID0gSEFTSC5uZXcoJ3NoYTI1NicpCgotLSBaRU46YWRkX3NjaGVtYSh7Ci0tIAkgIC0tIHNlY3JldF9kYXlfa2V5ID0gZnVuY3Rpb24ob2JqKQotLSAJICAtLSAJIHplbmNvZGVfYXNzZXJ0KCNvYmogPT0gMzIsICJTZWNyZXQgZGF5IGtleSBoYXMgd3Jvbmcgc2l6ZSAobm90IDMyIGJ5dGVzIC8gMjU2IGJpdHMpIikKLS0gCSAgLS0gCSByZXR1cm4gb2JqCi0tIAkgIC0tIGVuZAotLSAJICAtLSBUT0RPOgotLSAJICAtLSBsaXN0IG9mIGluZmVjdGVkIChhcnJheSBvZiAzMiBieXRlIHJhbmRvbSBoYXNoZXMpCi0tIAkgIC0tIGVwaGVtZXJhbCBpZHMgKGFycmF5IG9mIDE2IGJ5dGUgQUVTLUdDTSBjaGVja3N1bXMpCi0tIH0pCgpXaGVuKCJyZW5ldyBzZWNyZXQgZGF5IGtleSB0byBhIG5ldyBkYXkiLCBmdW5jdGlvbigpCgkJemVuY29kZV9hc3NlcnQoQUNLLnNlY3JldF9kYXlfa2V5LCAiU2VjcmV0IGRheSBrZXkgbm90IGZvdW5kIikKCQlsb2NhbCBzayA9IFNIQTI1Njpwcm9jZXNzKEFDSy5zZWNyZXRfZGF5X2tleSkKCQl6ZW5jb2RlX2Fzc2VydChzaywgIkVycm9yIHJlbmV3aW5nIHNlY3JldCBkYXkga2V5IChTSEEyNTYpIikKCQlBQ0suc2VjcmV0X2RheV9rZXkgPSBzawplbmQpCgpXaGVuKCJjcmVhdGUgZXBoZW1lcmFsIGlkcyBmb3IgdG9kYXkiLCBmdW5jdGlvbigpCgkJemVuY29kZV9hc3NlcnQoQUNLLnNlY3JldF9kYXlfa2V5LCAiU2VjcmV0IGRheSBrZXkgbm90IGZvdW5kIikKCQl6ZW5jb2RlX2Fzc2VydChBQ0suYnJvYWRjYXN0X2tleSwgIkJyb2FkY2FzdCBrZXkgbm90IGZvdW5kIikKCQl6ZW5jb2RlX2Fzc2VydChpc251bWJlcihBQ0suZXBvY2gpLCAiRXBvY2ggbGVuZ3RoIChtaW51dGVzKSBub3QgZm91bmQiKQogICAgICAgIGxvY2FsIGVwb2NoID0gdG9udW1iZXIoQUNLLmVwb2NoKQoJCWxvY2FsIFBSRiA9IFNIQTI1NjpobWFjKEFDSy5zZWNyZXRfZGF5X2tleSwgQUNLLmJyb2FkY2FzdF9rZXkpCgkJbG9jYWwgZXBkID0gKDI0KjYwKS9lcG9jaCAtLSBudW0gZXBvY2hzIHBlciBkYXkKCQlsb2NhbCB6ZXJvID0gT0NURVQuemVybyhlcGQqMTYpIC0tIDAgYnl0ZSBidWZmZXIKCQlBQ0suZXBoZW1lcmFsX2lkcyA9IHsgfQoJCWZvciBpID0gMCxlcGQsMSBkbwoJCSAgIGxvY2FsIFBSRyA9IEFFUy5jdHJfZW5jcnlwdChQUkYsIHplcm8sIE8uZnJvbV9udW1iZXIoaSkpCgkJICAgbG9jYWwgbCxyID0gT0NURVQuY2hvcChQUkcsMTYpCgkJICAgdGFibGUuaW5zZXJ0KEFDSy5lcGhlbWVyYWxfaWRzLCBsKQoJCWVuZAogICAgICAgIG5ld19jb2RlYydlcGhlbWVyYWxfaWRzJwplbmQpCgpXaGVuKCJjcmVhdGUgcHJveGltaXR5IHRyYWNpbmcgb2YgaW5mZWN0ZWQgaWRzIiwgZnVuY3Rpb24oKQoJCXplbmNvZGVfYXNzZXJ0KGlzbnVtYmVyKEFDSy5lcG9jaCksICJOdW1iZXIgb2YgbW9tZW50cyBub3QgZm91bmQiKQogICAgICAgIGxvY2FsIGVwb2NoID0gdG9udW1iZXIoQUNLLmVwb2NoKQoJCXplbmNvZGVfYXNzZXJ0KHR5cGUoQUNLLmxpc3Rfb2ZfaW5mZWN0ZWQpID09ICd0YWJsZScsICJMaXN0IG9mIGluZmVjdGVkIG5vdCBmb3VuZCIpCgkJemVuY29kZV9hc3NlcnQodHlwZShBQ0suZXBoZW1lcmFsX2lkcykgPT0gJ3RhYmxlJywgIkxpc3Qgb2YgZXBoZW1lcmFsIGlkcyBub3QgZm91bmQiKQoJCXplbmNvZGVfYXNzZXJ0KEFDSy5icm9hZGNhc3Rfa2V5LCAiQnJvYWRjYXN0IGtleSBub3QgZm91bmQiKQoJCUFDSy5wcm94aW1pdHlfdHJhY2luZyA9IHsgfQoJCWxvY2FsIGVwZCA9ICgyNCo2MCkvZXBvY2ggLS0gbnVtIGVwb2NocyBwZXIgZGF5CgkJbG9jYWwgemVybyA9IE9DVEVULnplcm8oZXBkKjE2KSAtLSAwIGJ5dGUgYnVmZmVyCgkJZm9yIG4sc2sgaW4gaXBhaXJzKEFDSy5saXN0X29mX2luZmVjdGVkKSBkbwoJCSAgIGxvY2FsIFBSRiA9IFNIQTI1NjpobWFjKHNrLCBBQ0suYnJvYWRjYXN0X2tleSkKCQkgICBmb3IgaSA9IDAsZXBkLDEgZG8KCQkJICBsb2NhbCBQUkcgPSBPQ1RFVC5jaG9wKCBBRVMuY3RyX2VuY3J5cHQoUFJGLCB6ZXJvLCBPLmZyb21fbnVtYmVyKGkpKSwgMTYpCgkJCSAgZm9yIG5uLGVwaCBpbiBuZXh0LCBBQ0suZXBoZW1lcmFsX2lkcywgbmlsIGRvCgkJCQkgaWYgZXBoID09IFBSRyB0aGVuCgkJCQkJdGFibGUuaW5zZXJ0KEFDSy5wcm94aW1pdHlfdHJhY2luZywgc2spCgkJCQkgZW5kCgkJCSAgZW5kCgkJICAgZW5kCgkJZW5kCiAgICAgICAgbmV3X2NvZGVjJ3Byb3hpbWl0eV90cmFjaW5nJwplbmQpCi96ZW5jb2RlX2VjZGgubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFNhdHVyZGF5LCA5dGggQXByaWwgMjAyMgotLV1dCgpFQ0RIID0gcmVxdWlyZV9vbmNlJ3plbnJvb21fZWNkaCcKCi0tIGRlZmluZWQgb3V0c2lkZSBiZWNhdXNlIHJldXNlZCBhY3Jvc3MgZGlmZmVyZW50IHNjaGVtYXMKbG9jYWwgZnVuY3Rpb24gcHVibGljX2tleV9mKG8pCglsb2NhbCByZXMgPSBDT05GLmlucHV0LmVuY29kaW5nLmZ1bihvKQoJemVuY29kZV9hc3NlcnQoCgkJRUNESC5wdWJjaGVjayhyZXMpLAoJCSdQdWJsaWMga2V5IGlzIG5vdCBhIHZhbGlkIHBvaW50IG9uIGN1cnZlJwoJKQoJcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIHNpZ25hdHVyZV9mKG8pCiAgIHJldHVybiB7CiAgICAgIHIgPSBzY2hlbWFfZ2V0KG8sICdyJyksCiAgICAgIHMgPSBzY2hlbWFfZ2V0KG8sICdzJykKICAgfQplbmQKClpFTjphZGRfc2NoZW1hKAoJewoJCS0tIGtleXBhaXIgKEVDREgpCgkJcHVibGljX2tleSA9IHsKCQkgICBpbXBvcnQgPSBwdWJsaWNfa2V5X2YKCQl9LAoJCWVjZGhfcHVibGljX2tleSA9IHsKCQkgICBpbXBvcnQgPSBwdWJsaWNfa2V5X2YKCQl9LAoJCXNlY3JldF9tZXNzYWdlID0gewoJCSAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikKCQkJICByZXR1cm4gewoJCQkJIGNoZWNrc3VtID0gc2NoZW1hX2dldChvYmosICdjaGVja3N1bScpLAoJCQkJIGhlYWRlciA9IHNjaGVtYV9nZXQob2JqLCAnaGVhZGVyJyksCgkJCQkgaXYgPSBzY2hlbWFfZ2V0KG9iaiwgJ2l2JyksCgkJCQkgdGV4dCA9IHNjaGVtYV9nZXQob2JqLCAndGV4dCcpCgkJCSAgfQoJCSAgIGVuZAoJCX0sCgkJc2lnbmF0dXJlID0gewoJCSAgIGltcG9ydCA9IHNpZ25hdHVyZV9mCgkJfSwKCQllY2RoX3NpZ25hdHVyZSA9IHsKCQkgICBpbXBvcnQgPSBzaWduYXR1cmVfZgoJCX0KCX0KKQoKV2hlbigiY3JlYXRlIGVjZGgga2V5IixmdW5jdGlvbigpCgkJaW5pdGtleXJpbmcnZWNkaCcKCQlBQ0sua2V5cmluZy5lY2RoID0gRUNESC5rZXlnZW4oKS5wcml2YXRlCmVuZCkKV2hlbigiY3JlYXRlIGVjZGggcHVibGljIGtleSIsZnVuY3Rpb24oKQoJCWVtcHR5J2VjZGggcHVibGljIGtleScKCQlsb2NhbCBzayA9IGhhdmVrZXknZWNkaCcKCQlBQ0suZWNkaF9wdWJsaWNfa2V5ID0gRUNESC5wdWJnZW4oc2spCgkJbmV3X2NvZGVjKCdlY2RoIHB1YmxpYyBrZXknKQoJZW5kCikKCmxvY2FsIGZ1bmN0aW9uIF9lY2RoX2tleV9mcm9tX3NlY3JldChzZWMpCiAgICBsb2NhbCBzayA9IGhhdmUoc2VjKQoJaW5pdGtleXJpbmcnZWNkaCcKCUVDREgucHViZ2VuKHNrKQoJQUNLLmtleXJpbmcuZWNkaCA9IHNrCmVuZAoKV2hlbigiY3JlYXRlIGVjZGgga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsCiAgICAgX2VjZGhfa2V5X2Zyb21fc2VjcmV0CikKV2hlbigiY3JlYXRlIGVjZGgga2V5IHdpdGggc2VjcmV0ICcnIiwKICAgIF9lY2RoX2tleV9mcm9tX3NlY3JldAopCgotLSBlbmNyeXB0IHdpdGggYSBoZWFkZXIgYW5kIHNlY3JldApXaGVuKCJlbmNyeXB0IHNlY3JldCBtZXNzYWdlICcnIHdpdGggJyciLGZ1bmN0aW9uKG1zZywgc2VjKQoJCWxvY2FsIHRleHQgPSBoYXZlKG1zZykKCQlsb2NhbCBzayA9IGhhdmUoc2VjKQoJCWVtcHR5J3NlY3JldCBtZXNzYWdlJwoJCS0tIEtERjIgc2hhMjU2IG9uIGFsbCBzZWNyZXRzCgkJbG9jYWwgc2VjcmV0ID0gS0RGKHNrKQoJCUFDSy5zZWNyZXRfbWVzc2FnZSA9IHsKCQkJaGVhZGVyID0gQUNLLmhlYWRlciBvciBPQ1RFVC5mcm9tX3N0cmluZygnRGVmYXVsdEhlYWRlcicpLAoJCQlpdiA9IE8ucmFuZG9tKDMyKQoJCX0KCQlBQ0suc2VjcmV0X21lc3NhZ2UudGV4dCwgQUNLLnNlY3JldF9tZXNzYWdlLmNoZWNrc3VtID0KCQkJRUNESC5hZWFkX2VuY3J5cHQoCgkJCXNlY3JldCwKCQkJdGV4dCwKCQkJQUNLLnNlY3JldF9tZXNzYWdlLml2LAoJCQlBQ0suc2VjcmV0X21lc3NhZ2UuaGVhZGVyCgkJKQoJCW5ld19jb2RlYygnc2VjcmV0IG1lc3NhZ2UnKQplbmQpCgotLSBkZWNyeXB0IHdpdGggYSBzZWNyZXQKV2hlbigiZGVjcnlwdCB0ZXh0IG9mICcnIHdpdGggJyciLGZ1bmN0aW9uKG1zZywgc2VjKQoJCWxvY2FsIHNrID0gaGF2ZShzZWMpCgkJbG9jYWwgdGV4dCA9IGhhdmUobXNnKQoJCWVtcHR5J3RleHQnCgkJZW1wdHknY2hlY2tzdW0nCgkJbG9jYWwgc2VjcmV0ID0gS0RGKHNrKQoJCS0tIEtERjIgc2hhMjU2IG9uIGFsbCBzZWNyZXRzLCB0aGlzIHdheSB0aGUKCQktLSBzZWNyZXQgaXMgYWx3YXlzIDI1NiBiaXRzLCBzYWZlIGZvciBkaXJlY3QgYWVhZF9kZWNyeXB0CgkJQUNLLnRleHQsIEFDSy5jaGVja3N1bSA9CgkJCUVDREguYWVhZF9kZWNyeXB0KAoJCQlzZWNyZXQsCgkJCXRleHQudGV4dCwKCQkJdGV4dC5pdiwKCQkJdGV4dC5oZWFkZXIKCQkpCgkJemVuY29kZV9hc3NlcnQoQUNLLmNoZWNrc3VtID09IHRleHQuY2hlY2tzdW0sCgkJCSAgICdEZWNyeXB0aW9uIGVycm9yOiBhdXRoZW50aWNhdGlvbiBmYWlsdXJlLCBjaGVja3N1bSBtaXNtYXRjaCcpCgkJbmV3X2NvZGVjJ3RleHQnCgkJbmV3X2NvZGVjJ2NoZWNrc3VtJwplbmQpCgotLSBjaGVjayB2YXJpb3VzIGxvY2F0aW9ucyB0byBmaW5kIHRoZSBwdWJsaWMga2V5CmxvY2FsIGZ1bmN0aW9uIF9wdWJrZXlfY29tcGF0KF9rZXkpCglsb2NhbCBwdWJrZXkgPSBBQ0tbX2tleV0KCWlmIG5vdCBwdWJrZXkgdGhlbgoJCWxvY2FsIHB1YmtleV9hcnIKCQlwdWJrZXlfYXJyID0gQUNLLnB1YmxpY19rZXkgb3IgQUNLLnB1YmxpY19rZXlfc2Vzc2lvbiBvciBBQ0suZWNkaF9wdWJsaWNfa2V5CgkJaWYgbHVhdHlwZShwdWJrZXlfYXJyKSA9PSAndGFibGUnIHRoZW4KCQkgICBwdWJrZXkgPSBwdWJrZXlfYXJyW19rZXldCgkJZWxzZQoJCSAgIHB1YmtleSA9IHB1YmtleV9hcnIKCQllbmQKCQl6ZW5jb2RlX2Fzc2VydChwdWJrZXksICdQdWJsaWMga2V5IG5vdCBmb3VuZCBmb3I6ICcgLi4gX2tleSkKCWVuZAoJcmV0dXJuIHB1YmtleQplbmQKCi0tIGVuY3J5cHQgdG8gYSBzaW5nbGUgcHVibGljIGtleQpXaGVuKCJlbmNyeXB0IHNlY3JldCBtZXNzYWdlIG9mICcnIGZvciAnJyIsZnVuY3Rpb24obXNnLCBfa2V5KQoJCWxvY2FsIHNrID0gaGF2ZWtleSdlY2RoJwoJCWhhdmUobXNnKQoJCWxvY2FsIHBrID0gX3B1YmtleV9jb21wYXQoX2tleSkKCQllbXB0eSdzZWNyZXQgbWVzc2FnZScKCQlsb2NhbCBrZXkgPSBFQ0RILnNlc3Npb24oc2ssIHBrKQoJCUFDSy5zZWNyZXRfbWVzc2FnZSA9IHsKCQkJaGVhZGVyID0gQUNLLmhlYWRlciBvciBPQ1RFVC5mcm9tX3N0cmluZygnRGVmYXVsdEhlYWRlcicpLAoJCQlpdiA9IE8ucmFuZG9tKDMyKQoJCX0KCQlBQ0suc2VjcmV0X21lc3NhZ2UudGV4dCwgQUNLLnNlY3JldF9tZXNzYWdlLmNoZWNrc3VtID0KCQkJRUNESC5hZWFkX2VuY3J5cHQoCgkJCWtleSwKCQkJQUNLW21zZ10sCgkJCUFDSy5zZWNyZXRfbWVzc2FnZS5pdiwKCQkJQUNLLnNlY3JldF9tZXNzYWdlLmhlYWRlcgoJCSkKCQluZXdfY29kZWMoJ3NlY3JldCBtZXNzYWdlJykKZW5kKQoKV2hlbigiZGVjcnlwdCB0ZXh0IG9mICcnIGZyb20gJyciLGZ1bmN0aW9uKHNlY3JldCwgX2tleSkKCQlsb2NhbCBzayA9IGhhdmVrZXknZWNkaCcKCQloYXZlKHNlY3JldCkKCQlsb2NhbCBwayA9IF9wdWJrZXlfY29tcGF0KF9rZXkpCgkJbG9jYWwgbWVzc2FnZSA9IEFDS1tzZWNyZXRdW19rZXldIG9yIEFDS1tzZWNyZXRdCgkJbG9jYWwgc2Vzc2lvbiA9IEVDREguc2Vzc2lvbihzaywgcGspCgkJQUNLLnRleHQsIEFDSy5jaGVja3N1bSA9CgkJCUVDREguYWVhZF9kZWNyeXB0KHNlc3Npb24sIG1lc3NhZ2UudGV4dCwgbWVzc2FnZS5pdiwgbWVzc2FnZS5oZWFkZXIpCgkJemVuY29kZV9hc3NlcnQoCgkJCUFDSy5jaGVja3N1bSA9PSBtZXNzYWdlLmNoZWNrc3VtLAoJCQknRmFpbGVkIHZlcmlmaWNhdGlvbiBvZiBpbnRlZ3JpdHkgZm9yIHNlY3JldCBtZXNzYWdlJwoJCSkKCQluZXdfY29kZWMndGV4dCcKCQluZXdfY29kZWMnY2hlY2tzdW0nCmVuZCkKCi0tIHNpZ24gYSBtZXNzYWdlIGFuZCB2ZXJpZnkKbG9jYWwgZnVuY3Rpb24gX3NpZ25pbmcobXNnLCB2YXIpCiAgIGxvY2FsIHNrID0gaGF2ZWtleSdlY2RoJwogICBlbXB0eSh2YXIpCiAgIGxvY2FsIG9iaiA9IGhhdmUobXNnKQogICBBQ0tbdmFyXSA9IEVDREguc2lnbihzaywgemVuY29kZV9zZXJpYWxpemUob2JqKSkKICAgbmV3X2NvZGVjKHZhcikKZW5kCgpsb2NhbCBmdW5jdGlvbiBfdmVyaWZ5aW5nKG1zZywgc2lnLCBieSkKICAgbG9jYWwgcGsgPSBfcHVia2V5X2NvbXBhdChieSkKICAgbG9jYWwgb2JqID0gaGF2ZShtc2cpCiAgIGxvY2FsIHMgPSBoYXZlKHNpZykKICAgemVuY29kZV9hc3NlcnQoCiAgICAgIEVDREgudmVyaWZ5KHBrLCB6ZW5jb2RlX3NlcmlhbGl6ZShvYmopLCBzKSwKICAgICAgJ1RoZSBlY2RoIHNpZ25hdHVyZSBieSAnIC4uIGJ5IC4uICcgaXMgbm90IGF1dGhlbnRpYycKICAgKQplbmQKCldoZW4oImNyZWF0ZSBzaWduYXR1cmUgb2YgJyciLGZ1bmN0aW9uKG1zZykKICAgX3NpZ25pbmcobXNnLCAnc2lnbmF0dXJlJykKZW5kKQoKV2hlbigiY3JlYXRlIGVjZGggc2lnbmF0dXJlIG9mICcnIixmdW5jdGlvbihtc2cpCiAgIF9zaWduaW5nKG1zZywgJ2VjZGhfc2lnbmF0dXJlJykKZW5kKQoKLS0gVGhlIGRldGVybWluaXN0aWMgZWNkc2EvZWNkaCB1c2VzIHRoZSBkZWZhdWx0IFNIQTUxMiB0byBzaWduIGFuZCB2ZXJpZnkuCmxvY2FsIGZ1bmN0aW9uIF9zaWduaW5nX2RldChtc2csIHZhcikKICAgIGxvY2FsIHNrID0gaGF2ZWtleSdlY2RoJwogICAgZW1wdHkodmFyKQogICAgbG9jYWwgb2JqID0gaGF2ZShtc2cpCiAgICAtLSA2NCBoZXJlIG1lYW5zIHRvIHVzZSBTSEE1MTIuCiAgICBBQ0tbdmFyXSA9IEVDREguc2lnbl9kZXRlcm1pbmlzdGljKHNrLCB6ZW5jb2RlX3NlcmlhbGl6ZShvYmopLCA2NCkKICAgIG5ld19jb2RlYyh2YXIpCmVuZAoKV2hlbigiY3JlYXRlIGVjZGggZGV0ZXJtaW5pc3RpYyBzaWduYXR1cmUgb2YgJyciLGZ1bmN0aW9uKG1zZykKICAgIF9zaWduaW5nX2RldChtc2csICJlY2RoX2RldGVybWluaXN0aWNfc2lnbmF0dXJlIikKZW5kKQoKLS0gVGhlIGRldGVybWluaXN0aWMgZWNkc2EvZWNkaCBhYm92ZSB1c2VzIHRoZSBkZWZhdWx0IFNIQTUxMiB0byBzaWduIGFuZCB2ZXJpZnkuCi0tIElmIG9uZSB3bmF0cyB0byB1c2UgYW5vdGhlciBoYXNoLCB0aGUgRUNESC52ZXJpZnlfZGV0ZXJtaW5pc3RpYyBzaG91bGQgYmUKLS0gY2FsbGVkIHdpdGggdGhlIGNvcnJlY3QgaW50ZWdlciBpbnB1dC4KSWZXaGVuKCJ2ZXJpZnkgJycgaGFzIGEgZWNkaCBkZXRlcm1pbmlzdGljIHNpZ25hdHVyZSBpbiAnJyBieSAnJyIsX3ZlcmlmeWluZykKCldoZW4oImNyZWF0ZSBlY2RzYSBkZXRlcm1pbmlzdGljIHNpZ25hdHVyZSBvZiAnJyIsZnVuY3Rpb24obXNnKQogICAgX3NpZ25pbmdfZGV0KG1zZywgImVjZHNhX2RldGVybWluaXN0aWNfc2lnbmF0dXJlIikKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgJycgaGFzIGEgZWNkc2EgZGV0ZXJtaW5pc3RpYyBzaWduYXR1cmUgaW4gJycgYnkgJyciLF92ZXJpZnlpbmcpCgpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSBzaWduYXR1cmUgaW4gJycgYnkgJyciLF92ZXJpZnlpbmcpCgpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSBlY2RoIHNpZ25hdHVyZSBpbiAnJyBieSAnJyIsX3ZlcmlmeWluZykKL3plbmNvZGVfZWRkc2EubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIyLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IEFsYmVydG8gTGVyZGEgYW5kIERlbmlzIFJvaW8KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBBbGJlcnRvIExlcmRhCi0tb24gTW9uZGF5LCAyMHRoIEp1bmUgMjAyMgotLV1dCgpsb2NhbCBFRCA9IHJlcXVpcmUnZWQnCgpsb2NhbCBhbHJlYWR5X3dhcm5lZCA9IGZhbHNlCgotLSBkZXByZWNhdGlvbiBtZXNzYWdlIHRvIGJlIHJlbW92ZWQgaW4gdjYgcGFzc2luZyB0byBkZWZhdWx0IGVuY29kaW5nIGZvciBFRERTQQpsb2NhbCBmdW5jdGlvbiB3YXJuX2Jhc2U1OCgpCiAgICBpZiBub3QgYWxyZWFkeV93YXJuZWQgdGhlbgogICAgICAgIGFscmVhZHlfd2FybmVkID0gdHJ1ZQogICAgICAgIHdhcm4oIkluIHRoZSBuZXh0IHZlcnNpb24gZGVmYXVsdCBlbmNvZGluZyBmb3IgZWRkc2EgcGsgYW5kIHNpZ25hdHVyZSB3aWxsIGNoYW5nZSBmcm9tIGJhc2U1OCB0byBjb25maWctZGVmaW5lZCBlbmNvZGluZyAoZGVmYXVsdDogYmFzZTY0KSIpCiAgICBlbmQKZW5kCgpsb2NhbCBzY2hlbWEgPSB7CiAgICBpbXBvcnQgPSBmdW5jdGlvbihvKQogICAgICAgIHdhcm5fYmFzZTU4KCkKICAgICAgICByZXR1cm4gc2NoZW1hX2dldChvLCAnLicsIE8uZnJvbV9iYXNlNTgsIHRvc3RyaW5nKQogICAgZW5kLAogICAgZXhwb3J0ID0gZnVuY3Rpb24obykKICAgICAgICB3YXJuX2Jhc2U1OCgpCiAgICAgICAgcmV0dXJuIE8udG9fYmFzZTU4KG8pCiAgICBlbmQKfQoKWkVOOmFkZF9zY2hlbWEoCiAgICB7CiAgICAgICAgZWRkc2FfcHVibGljX2tleSA9IHNjaGVtYSwKICAgICAgICBlZGRzYV9zaWduYXR1cmUgPSBzY2hlbWEKICAgIH0KKQoKLS0gZ2VuZXJhdGUgdGhlIHByaXZhdGUga2V5CldoZW4oImNyZWF0ZSBlZGRzYSBrZXkiLGZ1bmN0aW9uKCkKCWluaXRrZXlyaW5nJ2VkZHNhJwoJQUNLLmtleXJpbmcuZWRkc2EgPSBFRC5zZWNnZW4oKQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgZWRkc2EgcHVibGljIGtleSIsZnVuY3Rpb24oKQoJZW1wdHknZWRkc2EgcHVibGljIGtleScKCWxvY2FsIHNrID0gaGF2ZWtleSdlZGRzYScKCUFDSy5lZGRzYV9wdWJsaWNfa2V5ID0gRUQucHViZ2VuKHNrKQoJbmV3X2NvZGVjKCdlZGRzYSBwdWJsaWMga2V5JywgeyB6ZW50eXBlID0gJ2UnLAoJCQkJCWVuY29kaW5nID0gJ2Jhc2U1OCd9KQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfcHVia2V5X2Zyb21fc2VjcmV0KHNlYykKICAgbG9jYWwgc2sgPSBoYXZlKHNlYykKICAgaW5pdGtleXJpbmcnZWRkc2EnCiAgIEVELnB1YmdlbihzaykKICAgQUNLLmtleXJpbmcuZWRkc2EgPSBzawplbmQKCldoZW4oImNyZWF0ZSBlZGRzYSBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIiwKICAgICBfcHVia2V5X2Zyb21fc2VjcmV0CikKCldoZW4oImNyZWF0ZSBlZGRzYSBrZXkgd2l0aCBzZWNyZXQgJyciLAogICAgIF9wdWJrZXlfZnJvbV9zZWNyZXQKKQoKV2hlbigiY3JlYXRlIGVkZHNhIHB1YmxpYyBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIixmdW5jdGlvbihzZWMpCglsb2NhbCBzayA9IGhhdmUoc2VjKQoJZW1wdHknZWRkc2EgcHVibGljIGtleScKCUFDSy5lZGRzYV9wdWJsaWNfa2V5ID0gRUQucHViZ2VuKHNrKQoJbmV3X2NvZGVjKCdlZGRzYSBwdWJsaWMga2V5JywgeyB6ZW50eXBlID0gJ2UnLAoJCQkJCWVuY29kaW5nID0gJ2Jhc2U1OCd9KQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgc2lnbiBmb3IgYSBtc2cgYW5kIHZlcmlmeQpXaGVuKCJjcmVhdGUgZWRkc2Egc2lnbmF0dXJlIG9mICcnIixmdW5jdGlvbihkb2MpCglsb2NhbCBzayA9IGhhdmVrZXknZWRkc2EnCglsb2NhbCBvYmogPSBoYXZlKGRvYykKCWVtcHR5J2VkZHNhIHNpZ25hdHVyZScKCUFDSy5lZGRzYV9zaWduYXR1cmUgPSBFRC5zaWduKHNrLCB6ZW5jb2RlX3NlcmlhbGl6ZShvYmopKQoJbmV3X2NvZGVjKCdlZGRzYSBzaWduYXR1cmUnLCB7IHplbnR5cGUgPSAnZScsCgkJCQkgICAgICAgZW5jb2RpbmcgPSAnYmFzZTU4J30pCmVuZCkKCklmV2hlbigidmVyaWZ5ICcnIGhhcyBhIGVkZHNhIHNpZ25hdHVyZSBpbiAnJyBieSAnJyIsZnVuY3Rpb24obXNnLCBzaWcsIGJ5KQoJICBsb2NhbCBwayA9IGxvYWRfcHVia2V5X2NvbXBhdChieSwgJ2VkZHNhJykKCSAgbG9jYWwgbSA9IGhhdmUobXNnKQoJICBsb2NhbCBzID0gaGF2ZShzaWcpCgkgIHplbmNvZGVfYXNzZXJ0KAoJICAgICBFRC52ZXJpZnkocGssIHMsIHplbmNvZGVfc2VyaWFsaXplKG0pKSwKCSAgICAgJ1RoZSBlZGRzYSBzaWduYXR1cmUgYnkgJy4uYnkuLicgaXMgbm90IGF1dGhlbnRpYycKCSAgKQplbmQpCi96ZW5jb2RlX2VzMjU2Lmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMy0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS0KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieToKLS1SZWJlY2NhIFNlbHZhZ2dpbmksIEFsYmVydG8gTGVyZGEgYW5kIERlbmlzIFJvaW8KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCmxvY2FsIEVTMjU2ID0gcmVxdWlyZV9vbmNlJ2VzMjU2JwoKbG9jYWwgZnVuY3Rpb24gcHVibGljX2tleV9mKG9iaikKCWxvY2FsIHJlcyA9IHNjaGVtYV9nZXQob2JqLCAnLicpCgl6ZW5jb2RlX2Fzc2VydCgKCQlFUzI1Ni5wdWJjaGVjayhyZXMpLAoJCSdQdWJsaWMga2V5IGlzIG5vdCBhIHZhbGlkIHBvaW50IG9uIGN1cnZlJwoJKQoJcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIGVzMjU2X3B1YmxpY19rZXkgPSB7IGltcG9ydCA9IHB1YmxpY19rZXlfZiB9LAogICAgICAgIGVzMjU2X3NpZ25hdHVyZSA9IHsgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gc2NoZW1hX2dldChvYmosICcuJykgZW5kIH0KICAgIH0KKQoKLS0gZ2VuZXJhdGUgdGhlIHByaXZhdGUga2V5CldoZW4oJ2NyZWF0ZSBlczI1NiBrZXknLGZ1bmN0aW9uKCkKCWluaXRrZXlyaW5nJ2VzMjU2JwoJQUNLLmtleXJpbmcuZXMyNTYgPSBFUzI1Ni5rZXlnZW4oKQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHVibGljIGtleQpXaGVuKCdjcmVhdGUgZXMyNTYgcHVibGljIGtleScsZnVuY3Rpb24oKQoJZW1wdHknZXMyNTYgcHVibGljIGtleScKCWxvY2FsIHNrID0gaGF2ZWtleSdlczI1NicKCUFDSy5lczI1Nl9wdWJsaWNfa2V5ID0gRVMyNTYucHViZ2VuKHNrKQoJbmV3X2NvZGVjKCdlczI1NiBwdWJsaWMga2V5JywgeyB6ZW50eXBlID0gJ2UnLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBlbmNvZGluZyA9ICdiYXNlNjQnfSkKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX3B1YmtleV9mcm9tX3NlY3JldChzZWMpCiAgIGxvY2FsIHNrID0gaGF2ZShzZWMpCiAgIGluaXRrZXlyaW5nJ2VzMjU2JwogICBFUzI1Ni5wdWJnZW4oc2spCiAgIEFDSy5rZXlyaW5nLmVzMjU2ID0gc2sKZW5kCgpXaGVuKCJjcmVhdGUgZXMyNTYga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsCiAgICAgX3B1YmtleV9mcm9tX3NlY3JldAopCgpXaGVuKCJjcmVhdGUgZXMyNTYga2V5IHdpdGggc2VjcmV0ICcnIiwKICAgICBfcHVia2V5X2Zyb21fc2VjcmV0CikKCldoZW4oImNyZWF0ZSBlczI1NiBwdWJsaWMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsZnVuY3Rpb24oc2VjKQoJbG9jYWwgc2sgPSBoYXZlKHNlYykKCWVtcHR5J2VzMjU2IHB1YmxpYyBrZXknCglBQ0suZXMyNTZfcHVibGljX2tleSA9IEVTMjU2LnB1YmdlbihzaykKCW5ld19jb2RlYygnZXMyNTYgcHVibGljIGtleScsIHsgemVudHlwZSA9ICdlJywKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZW5jb2RpbmcgPSAnYmFzZTY0J30pCmVuZCkKCi0tIGdlbmVyYXRlIHRoZSBzaWduIGZvciBhIG1zZyBhbmQgdmVyaWZ5CldoZW4oImNyZWF0ZSBlczI1NiBzaWduYXR1cmUgb2YgJyciLGZ1bmN0aW9uKGRvYykKCWxvY2FsIHNrIDxjb25zdD4gPSBoYXZla2V5J2VzMjU2JwoJbG9jYWwgb2JqIDxjb25zdD4gPSBoYXZlKGRvYykKCWVtcHR5J2VzMjU2IHNpZ25hdHVyZScKICAgIGxvY2FsIG90IDxjb25zdD4gPSB0eXBlKG9iaikKICAgIGlmIGlzemVuKG90KSB0aGVuCiAgICAgICAgQUNLLmVzMjU2X3NpZ25hdHVyZSA9IEVTMjU2LnNpZ24oc2ssIG9iajpvY3RldCgpKQogICAgZWxzZWlmIG90ID09ICd0YWJsZScgdGhlbgogICAgICAgIEFDSy5lczI1Nl9zaWduYXR1cmUgPSBFUzI1Ni5zaWduKHNrLCB6ZW5jb2RlX3NlcmlhbGl6ZShvYmopKQogICAgZWxzZQogICAgICAgIEFDSy5lczI1Nl9zaWduYXR1cmUgPSBFUzI1Ni5zaWduKHNrLCBvYmopCiAgICBlbmQKCW5ld19jb2RlYygnZXMyNTYgc2lnbmF0dXJlJywgeyB6ZW50eXBlID0gJ2UnLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGVuY29kaW5nID0gJ2Jhc2U2NCd9KQplbmQpCgpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSBlczI1NiBzaWduYXR1cmUgaW4gJycgYnkgJyciLGZ1bmN0aW9uKG1zZywgc2lnLCBieSkKCSAgbG9jYWwgcGsgPGNvbnN0PiA9IGxvYWRfcHVia2V5X2NvbXBhdChieSwgJ2VzMjU2JykKCSAgbG9jYWwgbSA8Y29uc3Q+ID0gaGF2ZShtc2cpCgkgIGxvY2FsIHMgPGNvbnN0PiA9IGhhdmUoc2lnKQogICAgICBsb2NhbCBtdCA8Y29uc3Q+ID0gdHlwZShtKQogICAgICBpZiBpc3plbihtdCkgdGhlbgogICAgICAgICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgICAgICAgRVMyNTYudmVyaWZ5KHBrLCBtOm9jdGV0KCksIHMpLAogICAgICAgICAgICAgICdUaGUgZXMyNTYgc2lnbmF0dXJlIGJ5ICcuLmJ5Li4nIGlzIG5vdCBhdXRoZW50aWMnCiAgICAgICAgICApCiAgICAgIGVsc2VpZiBtdCA9PSAndGFibGUnIHRoZW4KICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICAgICAgICAgIEVTMjU2LnZlcmlmeShwaywgemVuY29kZV9zZXJpYWxpemUobSksIHMpLAogICAgICAgICAgICAgICdUaGUgZXMyNTYgc2lnbmF0dXJlIGJ5ICcuLmJ5Li4nIGlzIG5vdCBhdXRoZW50aWMnCiAgICAgICAgICApCiAgICAgIGVsc2UKICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICAgICAgICAgIEVTMjU2LnZlcmlmeShwaywgbSwgcyksCiAgICAgICAgICAgICAgJ1RoZSBlczI1NiBzaWduYXR1cmUgYnkgJy4uYnkuLicgaXMgbm90IGF1dGhlbnRpYycKICAgICAgICAgICkKICAgICAgZW5kCmVuZCkKL3plbmNvZGVfZXRoZXJldW0ubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIyLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IEFsYmVydG8gTGVyZGEgYW5kIERlbmlzIFJvaW8KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBEZW5pcyBSb2lvCi0tb24gU3VuZGF5LCAxMHRoIEFwcmlsIDIwMjIKLS1dXQoKbG9jYWwgRVRIID0gcmVxdWlyZV9vbmNlJ2NyeXB0b19ldGhlcmV1bScKCgpsb2NhbCBmdW5jdGlvbiBiaWdfd2VpX3RvX3N0cl93ZWkoeCkKICAgcmV0dXJuIHg6ZGVjaW1hbCgpCmVuZApsb2NhbCBmdW5jdGlvbiBzdHJfd2VpX3RvX2JpZ193ZWkoeCkKICAgcmV0dXJuIEJJRy5mcm9tX2RlY2ltYWwodG9zdHJpbmcoeCkpCmVuZAotLSBUT0RPOiB0aGVzZSBjb252ZXJzaW9ucyBhcmUgc2xvdwp3ZWltdWx0ID0gQklHLm5ldygxMCk6bW9kcG93ZXIoQklHLm5ldygxOCksIEVDUC5vcmRlcigpKQpnd2VpbXVsdCA9IEJJRy5uZXcoMTApOm1vZHBvd2VyKEJJRy5uZXcoOSksIEVDUC5vcmRlcigpKQpsb2NhbCBmdW5jdGlvbiBzdHJfZ3dlaV90b19iaWdfd2VpKHgpCiAgIHJldHVybiAoIEJJRy5mcm9tX2RlY2ltYWwodG9zdHJpbmcoeCkpICogZ3dlaW11bHQgKQplbmQKbG9jYWwgZnVuY3Rpb24gYmlnX3dlaV90b19zdHJfZ3dlaSh4KQogICByZXR1cm4gKCB4IC8gZ3dlaW11bHQgKTpkZWNpbWFsKCkKZW5kCmxvY2FsIGZ1bmN0aW9uIHN0cl9ldGhfdG9fYmlnX3dlaSh4KQogICByZXR1cm4gKCBCSUcuZnJvbV9kZWNpbWFsKHRvc3RyaW5nKHgpKSAqIHdlaW11bHQgKQplbmQKbG9jYWwgZnVuY3Rpb24gYmlnX3dlaV90b19zdHJfZXRoKHgpCiAgIHJldHVybiAoICggeCAvIHdlaW11bHQgKTpkZWNpbWFsKCkgKQplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9ldGhfYWRkcmVzc19mKHN0cl9hZGQpCiAgICBsb2NhbCBvY3RfYWRkID0gTy5mcm9tX2hleChzdHJfYWRkKQogICAgbG9jYWwgY2hlY2sgPSBFVEguY2hlY2tzdW1fZW5jb2RlKG9jdF9hZGQpCiAgICBpZiBjaGVjayB+PSBzdHJfYWRkIHRoZW4KICAgICAgICBJLndhcm4oIkludmFsaWQgZW5jb2RpbmcgZm9yIGV0aGVyZXVtIGFkZHJlc3MuIEV4cGVjdGVkIGVuY29kaW5nOiAiIC4uIGNoZWNrKQogICAgZW5kCiAgICByZXR1cm4gb2N0X2FkZAplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9ldGhfdHgob2JqKQogIGxvY2FsIHJlcyA9IHsgfQogIHJlcy5ub25jZSA9IHNjaGVtYV9nZXQob2JqLCAnbm9uY2UnLCBJTlQuZnJvbV9kZWNpbWFsLCB0b3N0cmluZykKICByZXMuZ2FzX3ByaWNlID0gc2NoZW1hX2dldChvYmosICdnYXNfcHJpY2UnLCBJTlQuZnJvbV9kZWNpbWFsLCB0b3N0cmluZykKICByZXMuZ2FzX2xpbWl0ID0gc2NoZW1hX2dldChvYmosICdnYXNfbGltaXQnLCBJTlQuZnJvbV9kZWNpbWFsLCB0b3N0cmluZykKICByZXMudmFsdWUgPSBzY2hlbWFfZ2V0KG9iaiwgJ3ZhbHVlJywgSU5ULmZyb21fZGVjaW1hbCwgdG9zdHJpbmcpCiAgcmVzLnRvID0gc2NoZW1hX2dldChvYmosICd0bycsIGltcG9ydF9ldGhfYWRkcmVzc19mLCB0b3N0cmluZykKICBpZiBvYmouZGF0YSB0aGVuCiAgICByZXMuZGF0YSA9IHNjaGVtYV9nZXQob2JqLCAnZGF0YScsIE8uZnJvbV9oZXgsIHRvc3RyaW5nKQogIGVsc2UgcmVzLmRhdGEgPSBPLm5ldygpIGVuZAogIGlmIG9iai52IHRoZW4gcmVzLnYgPSBzY2hlbWFfZ2V0KG9iaiwgJ3YnLCBPLmZyb21faGV4KSBlbmQKICBpZiBvYmouciB0aGVuIHJlcy5yID0gc2NoZW1hX2dldChvYmosICdyJywgTy5mcm9tX2hleCkgZW5kCiAgaWYgb2JqLnMgdGhlbiByZXMucyA9IHNjaGVtYV9nZXQob2JqLCAncycsIE8uZnJvbV9oZXgpIGVuZAogIHJldHVybiByZXMKZW5kCmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9ldGhfdHgob2JqKQogIGxvY2FsIHJlcyA9IHsgfQogIGlmIG9iai5ub25jZSB0aGVuIHJlcy5ub25jZSA9IG9iai5ub25jZTpkZWNpbWFsKCkgZW5kCiAgcmVzLmdhc19wcmljZSA9IG9iai5nYXNfcHJpY2U6ZGVjaW1hbCgpCiAgcmVzLmdhc19saW1pdCA9IG9iai5nYXNfbGltaXQ6ZGVjaW1hbCgpCiAgcmVzLnRvID0gRVRILmNoZWNrc3VtX2VuY29kZShvYmoudG8pCiAgaWYgI29iai52YWx1ZSA9PSAwIHRoZW4gcmVzLnZhbHVlID0gJzAnCiAgZWxzZWlmIHR5cGUob2JqLnZhbHVlKSA9PSAnemVucm9vbS5iaWcnIHRoZW4KICAgIHJlcy52YWx1ZSA9IG9iai52YWx1ZTpkZWNpbWFsKCkKICBlbHNlCiAgICBlcnJvcigiaW52YWxpZCB2YWx1ZSB0eXBlOiAiLi50eXBlKG9iai52YWx1ZSkpCiAgZW5kCiAgaWYgb2JqLmRhdGEgdGhlbiByZXMuZGF0YSA9IG9iai5kYXRhOm9jdGV0KCk6aGV4KCkgZW5kCiAgaWYgb2JqLnYgdGhlbiByZXMudiA9IG9iai52Om9jdGV0KCk6aGV4KCkgZW5kCiAgaWYgb2JqLnIgdGhlbiByZXMuciA9IG9iai5yOm9jdGV0KCk6aGV4KCkgZW5kCiAgaWYgb2JqLnMgdGhlbiByZXMucyA9IG9iai5zOm9jdGV0KCk6aGV4KCkgZW5kCiAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9zaWduYXR1cmVfZihvYmopCiAgICBsb2NhbCByZXMgPSB7fQogICAgbG9jYWwgc3VwcCA9IHNjaGVtYV9nZXQob2JqLCAnLicsIG5pbCwgTy5mcm9tX2hleCkKICAgIGlmICh0eXBlKHN1cHApID09ICd6ZW5yb29tLm9jdGV0JykgdGhlbgogICAgICAgIHJlcyA9IHsKICAgICAgICAgICAgciA9IHN1cHA6c3ViKDEsMzIpLAogICAgICAgICAgICBzID0gc3VwcDpzdWIoMzMsIDY0KSwKICAgICAgICAgICAgdiA9IEJJRy5uZXcoc3VwcDpzdWIoNjUsIDY1KSkKICAgICAgICB9CiAgICBlbHNlCiAgICAgICAgcmVzLnIgPSBzY2hlbWFfZ2V0KG9iaiwgJ3InLCBuaWwsIE8uZnJvbV9oZXgpCiAgICAgICAgcmVzLnYgPSBzY2hlbWFfZ2V0KG9iaiwgJ3YnLCBuaWwsIEJJRy5mcm9tX2RlY2ltYWwpCiAgICAgICAgcmVzLnMgPSBzY2hlbWFfZ2V0KG9iaiwgJ3MnLCBuaWwsIE8uZnJvbV9oZXgpCiAgICBlbmQKICAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfc2lnbmF0dXJlX2Yob2JqKQogICAgaWYgKHR5cGUob2JqKSA9PSAndGFibGUnKSB0aGVuCiAgICAgICAgb2JqID0gb2JqLnIuLm9iai5zLi5PLm5ldyhvYmoudikKICAgIGVuZAogICAgcmV0dXJuICIweCIuLk8udG9faGV4KG9iaikKZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfc2lnbmF0dXJlX3RhYmxlX2Yob2JqKQogICAgbG9jYWwgcmVzID0ge30KICAgIHJlcy5yID0gb2JqLnI6b2N0ZXQoKTpoZXgoKQogICAgcmVzLnMgPSBvYmouczpvY3RldCgpOmhleCgpCiAgICByZXMudiA9IG9iai52OmRlY2ltYWwoKQogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9tZXRob2RfZihvYmopCiAgICBsb2NhbCByZXMgPSB7fQogICAgcmVzLm5hbWUgPSBzY2hlbWFfZ2V0KG9iaiwgJ25hbWUnLCBuaWwsIE8uZnJvbV9zdHJpbmcpCiAgICBsb2NhbCBpbnB1dCA9IHNjaGVtYV9nZXQob2JqLCAnaW5wdXQnLCBuaWwsIE8uZnJvbV9zdHJpbmcpCiAgICBpZiB0eXBlKGlucHV0KSB+PSAidGFibGUiIHRoZW4KICAgICAgICBlcnJvcigiaW52YWxpZCBpbnB1dCB0eXBlOiAiLi50eXBlKG9iai5vdXRwdXQpLi4ic2hvdWxkIGJlIGEgc3RyaW5nIGFycmF5IikKICAgIGVuZAogICAgcmVzLmlucHV0ID0gaW5wdXQKICAgIGxvY2FsIG91dHB1dCA9IHNjaGVtYV9nZXQob2JqLCAnb3V0cHV0JywgbmlsLCBPLmZyb21fc3RyaW5nKQogICAgaWYgdHlwZShpbnB1dCkgfj0gInRhYmxlIiB0aGVuCiAgICAgICAgZXJyb3IoImludmFsaWQgb3V0cHV0IHR5cGU6ICIuLnR5cGUob2JqLm91dHB1dCkuLiJzaG91bGQgYmUgYSBzdHJpbmcgYXJyYXkiKQogICAgZW5kCiAgICByZXMub3V0cHV0ID0gb3V0cHV0CiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X21ldGhvZF9mKG9iaikKICAgIHJlcyA9IHt9CiAgICByZXMubmFtZSA9IG9iai5uYW1lOm9jdGV0KCk6c3RyaW5nKCkKICAgIHJlcy5pbnB1dCA9IGRlZXBtYXAoZnVuY3Rpb24obykgcmV0dXJuIG86b2N0ZXQoKTpzdHJpbmcoKSBlbmQsIG9iai5pbnB1dCkKICAgIHJlcy5vdXRwdXQgPSBkZWVwbWFwKGZ1bmN0aW9uKG8pIHJldHVybiBvOm9jdGV0KCk6c3RyaW5nKCkgZW5kLCBvYmoub3V0cHV0KQogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9ldGhfYWRkcmVzc19zaWduYXR1cmVfcGFpcl9mKG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICByZXMuYWRkcmVzcyA9IHNjaGVtYV9nZXQob2JqLCAnYWRkcmVzcycsIGltcG9ydF9ldGhfYWRkcmVzc19mLCB0b3N0cmluZykKICAgIHJlcy5zaWduYXR1cmUgPSBpbXBvcnRfc2lnbmF0dXJlX2Yob2JqLnNpZ25hdHVyZSkKICAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfZXRoX2FkZHJlc3Nfc2lnbmF0dXJlX3BhaXJfZihvYmopCiAgICBsb2NhbCByZXMgPSB7fQogICAgcmVzLmFkZHJlc3MgPSBFVEguY2hlY2tzdW1fZW5jb2RlKG9iai5hZGRyZXNzKQogICAgcmVzLnNpZ25hdHVyZSA9IGV4cG9ydF9zaWduYXR1cmVfZihvYmouc2lnbmF0dXJlKQogICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICB7CiAgICAgIGV0aGVyZXVtX3B1YmxpY19rZXkgPSB7IGltcG9ydCA9IE8uZnJvbV9oZXgsCgkJCSAgICAgIGV4cG9ydCA9IE8udG9faGV4IH0sCiAgICAgIGV0aGVyZXVtX2FkZHJlc3MgPSB7IGltcG9ydCA9IGZ1bmN0aW9uKG9iaikKICAgICAgICAgICAgICAgIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJy4nLCBpbXBvcnRfZXRoX2FkZHJlc3NfZiwgdG9zdHJpbmcpCiAgICAgICAgICAgICAgICBlbmQsCgkJCSAgIGV4cG9ydCA9IEVUSC5jaGVja3N1bV9lbmNvZGUgfSwKICAgICAgLS0gVE9ETyBnZW5lcmljIGltcG9ydCBmcm9tIHN0cmluZyBpbiB6ZW5yb29tLmJpZywKICAgICAgLS0gaWYgYSBudW1iZXIgYmVnaW5zIHdpdGggMHggaW1wb3J0IGl0IGFzIGhleAogICAgICAtLSBvdGhlcndpc2UgYXMgZGVjaW1hbCAoaGVyZSB3ZSBoYXZlIHRvIHVzZSB0b251bWJlcgogICAgICAtLSBpbiBvcmRlciB0byBjb250ZW1wbGF0ZSBoZXggc3RyaW5ncykKICAgICAgZXRoZXJldW1fbm9uY2UgPSB7IGltcG9ydCA9IGZ1bmN0aW9uKG8pCgkJCQkJCQlsb2NhbCBuID0gdG9udW1iZXIobykKCQkJCQkJCXplbmNvZGVfYXNzZXJ0KG4sICJFdGhlcmV1bSBub25jZSBub3QgdmFsaWQiKQoJCQkJCQkJcmV0dXJuIElOVC5uZXcobikgZW5kLAogICAgICAgICAgICAgICAgICAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24obykgcmV0dXJuIG86ZGVjaW1hbCgpIGVuZCB9LAogICAgICBldGhlcmV1bV90cmFuc2FjdGlvbiA9IHsgaW1wb3J0ID0gaW1wb3J0X2V0aF90eCwKCQkJCQkJCSAgIGV4cG9ydCA9IGV4cG9ydF9ldGhfdHggfSwKICAgICAgc2lnbmVkX2V0aGVyZXVtX3RyYW5zYWN0aW9uID0geyBpbXBvcnQgPSBPLmZyb21faGV4LAoJCQkJCQkJCQkgIGV4cG9ydCA9IE8udG9faGV4IH0sCiAgICAgIGdhc19wcmljZSA9IHsgaW1wb3J0ID0gc3RyX3dlaV90b19iaWdfd2VpLAoJCQkJCWV4cG9ydCA9IGJpZ193ZWlfdG9fc3RyX3dlaSB9LAogICAgICBnYXNfbGltaXQgPSB7IGltcG9ydCA9IHN0cl93ZWlfdG9fYmlnX3dlaSwKCQkJCQlleHBvcnQgPSBiaWdfd2VpX3RvX3N0cl93ZWkgfSwKICAgICAgZXRoZXJldW1fdmFsdWUgPSB7IGltcG9ydCA9IHN0cl9ldGhfdG9fYmlnX3dlaSwKCQkJCQkJIGV4cG9ydCA9IGJpZ193ZWlfdG9fc3RyX2V0aCB9LAogICAgICBnd2VpX3ZhbHVlID0geyBpbXBvcnQgPSBzdHJfZ3dlaV90b19iaWdfd2VpLAoJCQkJCSBleHBvcnQgPSBiaWdfd2VpX3RvX3N0cl9nd2VpIH0sCiAgICAgIHdlaV92YWx1ZSA9IHsgaW1wb3J0ID0gc3RyX3dlaV90b19iaWdfd2VpLAoJCSAgICBleHBvcnQgPSBiaWdfd2VpX3RvX3N0cl93ZWkgfSwKICAgICAgZXRoZXJldW1fc2lnbmF0dXJlID0geyBpbXBvcnQgPSBpbXBvcnRfc2lnbmF0dXJlX2YsCiAgICAgICAgICAgIGV4cG9ydCA9IGV4cG9ydF9zaWduYXR1cmVfZn0sCiAgICAgIGV0aGVyZXVtX3NpZ25hdHVyZV90YWJsZSA9IHsgaW1wb3J0ID0gaW1wb3J0X3NpZ25hdHVyZV9mLAogICAgICAgICAgICBleHBvcnQgPSBleHBvcnRfc2lnbmF0dXJlX3RhYmxlX2Z9LAogICAgICBldGhlcmV1bV9tZXRob2QgPSB7IGltcG9ydCA9IGltcG9ydF9tZXRob2RfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X21ldGhvZF9mfSwKICAgICAgICBldGhlcmV1bV9hZGRyZXNzX3NpZ25hdHVyZV9wYWlyID0gewogICAgICAgICAgICBpbXBvcnQgPSBpbXBvcnRfZXRoX2FkZHJlc3Nfc2lnbmF0dXJlX3BhaXJfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X2V0aF9hZGRyZXNzX3NpZ25hdHVyZV9wYWlyX2YKICAgICAgICB9LAp9KQoKV2hlbigiY3JlYXRlIGV0aGVyZXVtIGtleSIsIGZ1bmN0aW9uKCkKCWluaXRrZXlyaW5nJ2V0aGVyZXVtJwoJQUNLLmtleXJpbmcuZXRoZXJldW0gPSBFQ0RILmtleWdlbigpLnByaXZhdGUKZW5kKQoKV2hlbigiY3JlYXRlIGV0aGVyZXVtIGFkZHJlc3MiLCBmdW5jdGlvbigpCgllbXB0eSdldGhlcmV1bSBhZGRyZXNzJwoJbG9jYWwgcGsgPSBBQ0suZXRoZXJldW1fcHVibGljX2tleQoJaWYgbm90IHBrIHRoZW4KCSAgIHBrID0gRUNESC5wdWJnZW4oIGhhdmVrZXknZXRoZXJldW0nICkKCWVuZAoJQUNLLmV0aGVyZXVtX2FkZHJlc3MgPSBFVEguYWRkcmVzc19mcm9tX3B1YmxpY19rZXkocGspCgluZXdfY29kZWMoJ2V0aGVyZXVtIGFkZHJlc3MnLCB7ZW5jb2RpbmcgPSAnY29tcGxleCd9KQplbmQpCgotLSBOb3RlIHRoYXQgdGhlIGFkZHJlc3MgbXVzdCBiZSBnaXZlbiBhcyBhIHN0cmluZwpXaGVuKCJ2ZXJpZnkgZXRoZXJldW0gYWRkcmVzcyBzdHJpbmcgJycgaXMgdmFsaWQiLCBmdW5jdGlvbihhZGQpCiAgICBsb2NhbCBzdHJfYWRkID0gTy50b19zdHJpbmcoaGF2ZShhZGQpKQogICAgbG9jYWwgYWRkcmVzcyA9IE8uZnJvbV9oZXgoc3RyX2FkZCkKICAgIHplbmNvZGVfYXNzZXJ0KHN0cl9hZGQgPT0gRVRILmNoZWNrc3VtX2VuY29kZShhZGRyZXNzKSwgIlRoZSBhZGRyZXNzIGhhcyBhIHdyb25nIGVuY29kaW5nIikKZW5kKQoKV2hlbigiY3JlYXRlIGV0aGVyZXVtIHRyYW5zYWN0aW9uIG9mICcnIHRvICcnIiwKZnVuY3Rpb24ocXVhbnRpdHksIGRlc3RhZGRyKQogIGVtcHR5J2V0aGVyZXVtIHRyYW5zYWN0aW9uJwogIGxvY2FsIHR4ID0geyB9CiAgdHguZ2FzX3ByaWNlID0gaGF2ZSdnYXMgcHJpY2UnCiAgdHguZ2FzX2xpbWl0ID0gaGF2ZSdnYXMgbGltaXQnCiAgdHgubm9uY2UgPSBoYXZlJ2V0aGVyZXVtIG5vbmNlJwogIHR4LnZhbHVlID0gaGF2ZShxdWFudGl0eSkKICB0eC50byA9IGhhdmUoZGVzdGFkZHIpCiAgdHguZGF0YSA9IE8ubmV3KCkKICBBQ0suZXRoZXJldW1fdHJhbnNhY3Rpb24gPSB0eAogIG5ld19jb2RlYygnZXRoZXJldW0gdHJhbnNhY3Rpb24nKQplbmQpCgpXaGVuKCJjcmVhdGUgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gJyciLApmdW5jdGlvbihkZXN0YWRkcikKICBlbXB0eSdldGhlcmV1bSB0cmFuc2FjdGlvbicKICBsb2NhbCB0eCA9IHsgfQogIHR4Lmdhc19wcmljZSA9IGhhdmUnZ2FzIHByaWNlJwogIHR4Lmdhc19saW1pdCA9IGhhdmUnZ2FzIGxpbWl0JwogIHR4Lm5vbmNlID0gaGF2ZSdldGhlcmV1bSBub25jZScKICB0eC52YWx1ZSA9IE8uZW1wdHkoKQogIHR4LmRhdGEgPSBPLmVtcHR5KCkKICB0eC50byA9IGhhdmUoZGVzdGFkZHIpCiAgQUNLLmV0aGVyZXVtX3RyYW5zYWN0aW9uID0gdHgKICBuZXdfY29kZWMoJ2V0aGVyZXVtIHRyYW5zYWN0aW9uJykKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX3VzZV9ldGhfdHJhbnNhY3Rpb24oYWJpX2Z1biwgLi4uKQogIGxvY2FsIHR4ID0gaGF2ZSdldGhlcmV1bSB0cmFuc2FjdGlvbicKICB6ZW5jb2RlX2Fzc2VydChub3QgdHguZGF0YSBvciAjdHguZGF0YSA9PSAwLCAiQ2Fubm90IG92ZXJ3cml0ZSB0cmFuc2FjdGlvbiBkYXRhIikKICB0eC5kYXRhID0gYWJpX2Z1biguLi4pCmVuZAoKLS0gd2UgY2FuIHN0b3JlIG9ubHkgc3RyaW5ncyAoZm9yIHRoZSBtb21lbnQpCldoZW4oInVzZSBldGhlcmV1bSB0cmFuc2FjdGlvbiB0byBzdG9yZSAnJyIsCmZ1bmN0aW9uKGNvbnRlbnQpCiAgX3VzZV9ldGhfdHJhbnNhY3Rpb24oRVRILm1ha2Vfc3RvcmFnZV9kYXRhLCBoYXZlKGNvbnRlbnQpKQplbmQpCgotLSBUT0RPOiBERVBSRUNBVEUKV2hlbigiY3JlYXRlIHN0cmluZyBmcm9tIGV0aGVyZXVtIGJ5dGVzIG5hbWVkICcnIiwgZnVuY3Rpb24ob2JqKQogIGVtcHR5J3N0cmluZycKICBsb2NhbCBkYXRhID0gaGF2ZShvYmopOm9jdGV0KCkKICBsb2NhbCBldGhfZGVjb2RlciA9IEVUSC5jb250cmFjdF9yZXR1cm5fZmFjdG9yeSh7ICdieXRlcycgfSkKICBsb2NhbCByZXN1bHQgPSBldGhfZGVjb2RlcihkYXRhKQogIHplbmNvZGVfYXNzZXJ0KCNyZXN1bHQgPT0gMSwgIldyb25nIGRhdGEgZm9ybWF0IikKICBBQ0suc3RyaW5nID0gTy5mcm9tX3N0cihyZXN1bHRbMV0pCiAgbmV3X2NvZGVjKCdzdHJpbmcnLCB7IGVuY29kaW5nID0gJ3N0cmluZyd9KQplbmQpCgpXaGVuKCJjcmVhdGUgJycgZGVjb2RlZCBmcm9tIGV0aGVyZXVtIGJ5dGVzICcnIiwgZnVuY3Rpb24oZHN0LCBvYmopCiAgZW1wdHkoZHN0KQogIGxvY2FsIGRhdGEgPSBoYXZlKG9iaik6b2N0ZXQoKQogIGxvY2FsIGV0aF9kZWNvZGVyID0gRVRILmNvbnRyYWN0X3JldHVybl9mYWN0b3J5KHsgJ2J5dGVzJyB9KQogIGxvY2FsIHJlc3VsdCA9IGV0aF9kZWNvZGVyKGRhdGEpCiAgemVuY29kZV9hc3NlcnQoI3Jlc3VsdCA9PSAxLCAiV3JvbmcgZGF0YSBmb3JtYXQiKQogIEFDS1tkc3RdID0gTy5mcm9tX3Jhd2xlbihyZXN1bHRbMV0sICNyZXN1bHRbMV0pCiAgbmV3X2NvZGVjKGRzdCkKZW5kKQoKLS0gVE9ETzogbW9yZSBjb250cmFjdCBtZXRob2RzCi0tIHVzZSB0aGUgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gc3RvcmUgJycKLS0gdXNlIHRoZSBldGhlcmV1bSB0cmFuc2FjdGlvbiB0byB0cmFuc2ZlciAnJyB0byAnJwotLSB1c2UgdGhlIGV0aGVyZXVtIHRyYW5zYWN0aW9uIHRvIGVsZWN0ICcnCi0tIHVzZSB0aGUgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gdm90ZSAnJwoKV2hlbigiY3JlYXRlIHNpZ25lZCBldGhlcmV1bSB0cmFuc2FjdGlvbiIsCmZ1bmN0aW9uKCkKICBsb2NhbCBzayA9IGhhdmVrZXknZXRoZXJldW0nCiAgbG9jYWwgdHggPSBoYXZlJ2V0aGVyZXVtIHRyYW5zYWN0aW9uJwogIHR4LnYgPSBJTlQubmV3KDEzMzcpIC0tIGRlZmF1bHQgbG9jYWwgdGVzdG5ldAogIEFDSy5zaWduZWRfZXRoZXJldW1fdHJhbnNhY3Rpb24gPQogIEVUSC5lbmNvZGVTaWduZWRUcmFuc2FjdGlvbihzaywgdHgpCiAgbmV3X2NvZGVjKCdzaWduZWQgZXRoZXJldW0gdHJhbnNhY3Rpb24nKQplbmQpCgpXaGVuKCJjcmVhdGUgc2lnbmVkIGV0aGVyZXVtIHRyYW5zYWN0aW9uIGZvciBjaGFpbiAnJyIsCmZ1bmN0aW9uKGNoYWluaWQpCiAgbG9jYWwgc2sgPSBoYXZla2V5J2V0aGVyZXVtJwogIGxvY2FsIHR4ID0gaGF2ZSdldGhlcmV1bSB0cmFuc2FjdGlvbicKICBsb2NhbCBjaWQsIGNpZF9jb2RlYyA9IG1heWhhdmUoY2hhaW5pZCkKICBpZiBjaWQgdGhlbgogICAgICBsb2NhbCBlbmMgPSBjaWRfY29kZWMuZW5jb2RpbmcKICAgICAgaWYgZW5jID09ICJzdHJpbmciIHRoZW4KICAgICAgICAgIGNpZCA9IHRvbnVtYmVyKGNpZDpzdHIoKSkgb3IgY2lkOm9jdGV0KCkKICAgICAgZWxzZWlmIGVuYyB+PSAiaW50ZWdlciIgdGhlbgogICAgICAgICAgZXJyb3IoIkludmFsaWQgY2hhaW4gaWQgZW5jb2Rpbmc6ICIuLmNpZF9jb2RlYy5lbmNvZGluZykKICAgICAgZW5kCiAgZWxzZQogICAgICBjaWQgPSB0b251bWJlcihjaGFpbmlkKSBvciBPLmZyb21fc3RyaW5nKGNoYWluaWQpCiAgZW5kCiAgY2lkID0gSU5ULm5ldyhjaWQpCiAgemVuY29kZV9hc3NlcnQoY2lkLCAiSW52YWxpZCBjaGFpbiBpZCIpCiAgaWYgbm90IHR4LmRhdGEgIHRoZW4gdHguZGF0YSA9IE8ubmV3KCkgZW5kCiAgaWYgbm90IHR4LnZhbHVlIHRoZW4gdHgudmFsdWUgPSBPLm5ldygpIGVuZAogIHR4LnYgPSBjaWQKICB0eC5yID0gTy5uZXcoKQogIHR4LnMgPSBPLm5ldygpCiAgQUNLLnNpZ25lZF9ldGhlcmV1bV90cmFuc2FjdGlvbiA9CiAgRVRILmVuY29kZVNpZ25lZFRyYW5zYWN0aW9uKHNrLCB0eCkKICBuZXdfY29kZWMoJ3NpZ25lZCBldGhlcmV1bSB0cmFuc2FjdGlvbicpCmVuZCkKCldoZW4oInZlcmlmeSBzaWduZWQgZXRoZXJldW0gdHJhbnNhY3Rpb24gZnJvbSAnJyIsCmZ1bmN0aW9uKHB1YmtleSkKICBsb2NhbCBwayA9IGhhdmUocHVia2V5KQogIGxvY2FsIHJhd3R4ID0gaGF2ZSdzaWduZWQgZXRoZXJldW0gdHJhbnNhY3Rpb24nCiAgbG9jYWwgdHggPSBFVEguZGVjb2RlVHJhbnNhY3Rpb24ocmF3dHgpCiAgLS0gVE9ETzogY2hlY2sgZGVjb2RlIGVycm9ycwogIHplbmNvZGVfYXNzZXJ0KCBFVEgudmVyaWZ5U2lnbmF0dXJlVHJhbnNhY3Rpb24ocGssIHR4KSApCmVuZCkKCldoZW4oImNyZWF0ZSBldGhlcmV1bSBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIixmdW5jdGlvbihzZWMpCglsb2NhbCBzayA9IGhhdmUoc2VjKQoJaW5pdGtleXJpbmcnZXRoZXJldW0nCglFQ0RILnB1YmdlbihzaykKCUFDSy5rZXlyaW5nLmV0aGVyZXVtID0gc2sKZW5kKQpXaGVuKCJjcmVhdGUgZXRoZXJldW0ga2V5IHdpdGggc2VjcmV0ICcnIixmdW5jdGlvbihzZWMpCglsb2NhbCBzayA9IGhhdmUoc2VjKQoJaW5pdGtleXJpbmcnZXRoZXJldW0nCglFQ0RILnB1YmdlbihzaykKCUFDSy5rZXlyaW5nLmV0aGVyZXVtID0gc2sKZW5kKQoKV2hlbigidXNlIGV0aGVyZXVtIHRyYW5zYWN0aW9uIHRvIHRyYW5zZmVyICcnIGVyYzIwIHRva2VucyB0byAnJyIsCmZ1bmN0aW9uKHF1YW50aXR5LCBkZXN0YWRkcikKICAgIF91c2VfZXRoX3RyYW5zYWN0aW9uKEVUSC5lcmMyMC50cmFuc2ZlciwKICAgICAgICAgICAgICAgICAgICAgICAgIGhhdmUoZGVzdGFkZHIpLAogICAgICAgICAgICAgICAgICAgICAgICAgQklHLm5ldyhoYXZlKHF1YW50aXR5KSkpCmVuZCkKCgpXaGVuKCJ1c2UgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gdHJhbnNmZXIgJycgZXJjMjAgdG9rZW5zIHRvICcnIHdpdGggZGV0YWlscyAnJyIsCmZ1bmN0aW9uKHF1YW50aXR5LCBkZXN0YWRkciwgZGV0YWlscykKICAgIF91c2VfZXRoX3RyYW5zYWN0aW9uKEVUSC50cmFuc2Zlcl9lcmMyMF9kZXRhaWxzLAogICAgICAgICAgICAgICAgICAgICAgICAgaGF2ZShkZXN0YWRkciksCiAgICAgICAgICAgICAgICAgICAgICAgICBCSUcubmV3KGhhdmUocXVhbnRpdHkpKSwKICAgICAgICAgICAgICAgICAgICAgICAgIGhhdmUoZGV0YWlscykpCmVuZCkKCldoZW4oInVzZSBldGhlcmV1bSB0cmFuc2FjdGlvbiB0byBjcmVhdGUgZXJjNzIxIG9mIHVyaSAnJyIsCmZ1bmN0aW9uKHVyaSkKICAgIF91c2VfZXRoX3RyYW5zYWN0aW9uKEVUSC5jcmVhdGVfZXJjNzIxLAogICAgICAgICAgICAgICAgICAgICAgICAgaGF2ZSh1cmkpOnN0cmluZygpKQplbmQpCgpXaGVuKCJ1c2UgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gY3JlYXRlIGVyYzcyMSBvZiBvYmplY3QgJyciLApmdW5jdGlvbih1cmkpCiAgICBfdXNlX2V0aF90cmFuc2FjdGlvbihFVEguY3JlYXRlX2VyYzcyMSwKICAgICAgICAgICAgICAgICAgICAgICAgIGhhdmUodXJpKTpiYXNlNjQoKSkKZW5kKQoKV2hlbigidXNlIGV0aGVyZXVtIHRyYW5zYWN0aW9uIHRvIHRyYW5zZmVyIGVyYzcyMSAnJyBmcm9tICcnIHRvICcnIiwKZnVuY3Rpb24odG9rZW5faWQsIGZyb20sIGRlc3QpCiAgICBfdXNlX2V0aF90cmFuc2FjdGlvbihFVEguZXJjNzIxLnNhZmVUcmFuc2ZlckZyb20sCiAgICAgICAgICAgICAgICAgICAgICAgICBoYXZlKGZyb20pLAogICAgICAgICAgICAgICAgICAgICAgICAgaGF2ZShkZXN0KSwKICAgICAgICAgICAgICAgICAgICAgICAgIEJJRy5uZXcoaGF2ZSh0b2tlbl9pZCkpKQplbmQpCgpXaGVuKCJ1c2UgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gYXBwcm92ZSBlcmM3MjEgJycgdHJhbnNmZXIgZnJvbSAnJyIsCmZ1bmN0aW9uKHRva2VuX2lkLCBmcm9tKQogICAgX3VzZV9ldGhfdHJhbnNhY3Rpb24oRVRILmVyYzcyMS5hcHByb3ZlLAogICAgICAgICAgICAgICAgICAgICAgICAgaGF2ZShmcm9tKSwKICAgICAgICAgICAgICAgICAgICAgICAgIEJJRy5uZXcoaGF2ZSh0b2tlbl9pZCkpKQplbmQpCgpXaGVuKCJ1c2UgZXRoZXJldW0gdHJhbnNhY3Rpb24gdG8gdHJhbnNmZXIgZXJjNzIxICcnIGluIGNvbnRyYWN0ICcnIHRvICcnIGluIHBsYW5ldG1pbnQiLApmdW5jdGlvbih0b2tlbl9pZCwgbmZ0LCB0bykKICAgIF91c2VfZXRoX3RyYW5zYWN0aW9uKEVUSC5ldGhfdG9fcGxhbmV0bWludCwKICAgICAgICAgICAgICAgICAgICAgICAgIGhhdmUobmZ0KSwKICAgICAgICAgICAgICAgICAgICAgICAgIEJJRy5uZXcoaGF2ZSh0b2tlbl9pZCkpLAogICAgICAgICAgICAgICAgICAgICAgICAgaGF2ZSh0bykpCmVuZCkKCldoZW4oImNyZWF0ZSBldGhlcmV1bSBhYmkgZW5jb2Rpbmcgb2YgJycgdXNpbmcgJyciLCBmdW5jdGlvbih0LCBhcmdzKQogICAgLS0gV2UgaW1wbHkgdGhhdCB0IGlzIGFuIG9jdGV0L29jdGV0IGFycmF5IGFuZCBhcmdzIGlzIGEgc2luZ2xlIHN0cmluZy9hIHN0cmluZyBhcnJheQogICAgbG9jYWwgZGF0YSA9IGhhdmUodCkKICAgIGxvY2FsIG9fdHlwZV9zcGVjID0gaGF2ZShhcmdzKQogICAgbG9jYWwgdHlwZV9zcGVjCiAgICAtLSBUT0RPOiBzdXBwb3J0IGZvciBuZXN0ZWQgYXJyYXkgdXNpbmcgZGVlcG1hcC4KICAgIGlmKHR5cGUob190eXBlX3NwZWMpID09ICJ0YWJsZSIpIHRoZW4KICAgICAgICB0eXBlX3NwZWMgPSB7fQogICAgICAgIGZvciBpLHYgaW4gcGFpcnMob190eXBlX3NwZWMpIGRvCiAgICAgICAgICAgIHR5cGVfc3BlY1tpXSA9IE8udG9fc3RyaW5nKHYpCiAgICAgICAgZW5kCiAgICBlbHNlCiAgICAgICAgdHlwZV9zcGVjID0gTy50b19zdHJpbmcob190eXBlX3NwZWMpCiAgICBlbmQKICAgIGVtcHR5J2V0aGVyZXVtIGFiaSBlbmNvZGluZycKICAgIEFDSy5ldGhlcmV1bV9hYmlfZW5jb2RpbmcgPSBFVEguYWJpX2VuY29kZSh0eXBlX3NwZWMsIGRhdGEpCiAgICBuZXdfY29kZWMoJ2V0aGVyZXVtIGFiaSBlbmNvZGluZycsIHtlbmNvZGluZyA9ICdoZXgnfSkKZW5kKQoKV2hlbigiY3JlYXRlIGV0aGVyZXVtIGFiaSBkZWNvZGluZyBvZiAnJyB1c2luZyAnJyIsIGZ1bmN0aW9uKHQsIGFyZ3MpCiAgICAtLSBXZSBpbXBseSB0aGF0IHQgaXMgYW4gb2N0ZXQvb2N0ZXQgYXJyYXkgYW5kIGFyZ3MgaXMgYSBzaW5nbGUgc3RyaW5nL2Egc3RyaW5nIGFycmF5CiAgICBsb2NhbCBkYXRhID0gaGF2ZSh0KQogICAgbG9jYWwgb190eXBlX3NwZWMgPSBoYXZlKGFyZ3MpCiAgICBsb2NhbCB0eXBlX3NwZWMKICAgIC0tIFRPRE86IHN1cHBvcnQgZm9yIG5lc3RlZCBhcnJheSB1c2luZyBkZWVwbWFwLgogICAgaWYodHlwZShvX3R5cGVfc3BlYykgPT0gInRhYmxlIikgdGhlbgogICAgICAgIHR5cGVfc3BlYyA9IHt9CiAgICAgICAgZm9yIGksdiBpbiBwYWlycyhvX3R5cGVfc3BlYykgZG8KICAgICAgICAgICAgdHlwZV9zcGVjW2ldID0gTy50b19zdHJpbmcodikKICAgICAgICBlbmQKICAgIGVsc2UKICAgICAgICB0eXBlX3NwZWMgPSBPLnRvX3N0cmluZyhvX3R5cGVfc3BlYykKICAgIGVuZAogICAgZW1wdHknZXRoZXJldW0gYWJpIGRlY29kaW5nJwogICAgQUNLLmV0aGVyZXVtX2FiaV9kZWNvZGluZyA9IEVUSC5hYmlfZGVjb2RlKHR5cGVfc3BlYykoZGF0YSkKICAgIG5ld19jb2RlYygnZXRoZXJldW0gYWJpIGRlY29kaW5nJywge3plbnR5cGU9ImEifSkKZW5kKQoKV2hlbigiY3JlYXRlIGV0aGVyZXVtIHNpZ25hdHVyZSBvZiAnJyIsIGZ1bmN0aW9uKG9iamVjdCkKICAgIGxvY2FsIHNrID0gaGF2ZWtleSdldGhlcmV1bScKICAgIGxvY2FsIGRhdGEgPSBoYXZlKG9iamVjdCkKCiAgICBlbXB0eSdldGhlcmV1bSBzaWduYXR1cmUnCiAgICBBQ0suZXRoZXJldW1fc2lnbmF0dXJlID0gRVRILmVuY29kZVNpZ25lZERhdGEoc2ssIGRhdGEpCiAgICBuZXdfY29kZWMoJ2V0aGVyZXVtIHNpZ25hdHVyZScpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9wcmVwYXJlX21zZ19mKHNyYykKICAgIGxvY2FsIG1zZyA9IGhhdmUoc3JjKQogICAgbG9jYWwgZXRoZXJzX21lc3NhZ2UgPSBPLmZyb21fc3RyaW5nKCJceDE5RXRoZXJldW0gU2lnbmVkIE1lc3NhZ2U6XG4iKSAuLiBPLm5ldygjbXNnKSAuLiBtc2cKICAgIGxvY2FsIGhhc2hlZF9tc2cgPSBIQVNILmtlY2NhazI1NihldGhlcnNfbWVzc2FnZSkKICAgIHJldHVybiBoYXNoZWRfbXNnCmVuZAoKSWZXaGVuKCJ2ZXJpZnkgJycgaGFzIGEgZXRoZXJldW0gc2lnbmF0dXJlIGluICcnIGJ5ICcnIiwgZnVuY3Rpb24oZG9jLCBzaWcsIGJ5KQogICAgbG9jYWwgaG1zZyA9IF9wcmVwYXJlX21zZ19mKGRvYykKICAgIGxvY2FsIHNpZ25hdHVyZSA9IGhhdmUoc2lnKQogICAgbG9jYWwgYWRkcmVzcyA9IGhhdmUoYnkpCiAgICB6ZW5jb2RlX2Fzc2VydChFVEgudmVyaWZ5X3NpZ25hdHVyZV9mcm9tX2FkZHJlc3Moc2lnbmF0dXJlLCBhZGRyZXNzLCBmaWYoc2lnbmF0dXJlLnY6cGFyaXR5KCksIDAsIDEpLCBobXNnKSwKICAgICAgICAgICAgJ1RoZSBldGhlcmV1bSBzaWduYXR1cmUgYnkgJy4uYnkuLicgaXMgbm90IGF1dGhlbnRpYycpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF92ZXJpZnlfYWRkcmVzc19zaWduYXR1cmVfYXJyYXkoYWRkX3NpZywgZG9jLCBmdW4pCiAgICBsb2NhbCBobXNnID0gX3ByZXBhcmVfbXNnX2YoZG9jKQogICAgbG9jYWwgYWRkcmVzc19zaWduYXR1cmUsIGFkZHJlc3Nfc2lnbmF0dXJlX2NvZGVjID0gaGF2ZShhZGRfc2lnKQogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KGFkZHJlc3Nfc2lnbmF0dXJlX2NvZGVjLnNjaGVtYSwgIlRoZSBldGhlcmV1bSBhZGRyZXNzIHNpZ25hdHVyZSBwYWlyIGFycmF5IGlzIG5vdCBhIHNjaGVtYSIpIHRoZW4gcmV0dXJuIGVuZAogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KGFkZHJlc3Nfc2lnbmF0dXJlX2NvZGVjLnplbnR5cGUgPT0gImEiLCAiVGhlIGV0aGVyZXVtIGFkZHJlc3Mgc2lnbmF0dXJlIHBhaXIgYXJyYXkgaXMgbm90IGFuIGFycmF5IikgdGhlbiByZXR1cm4gZW5kCiAgICByZXR1cm4gZnVuKGFkZHJlc3Nfc2lnbmF0dXJlLCBobXNnKQplbmQKCklmV2hlbigidmVyaWZ5IGV0aGVyZXVtIGFkZHJlc3Mgc2lnbmF0dXJlIHBhaXIgYXJyYXkgJycgb2YgJyciLCBmdW5jdGlvbihhZGRfc2lnLCBkb2MpCiAgICBfdmVyaWZ5X2FkZHJlc3Nfc2lnbmF0dXJlX2FycmF5KGFkZF9zaWcsIGRvYywKICAgICAgICBmdW5jdGlvbihhZGRyZXNzX3NpZ25hdHVyZV9wYWlyLCBobXNnKQogICAgICAgICAgICBmb3IgXywgdiBpbiBwYWlycyhhZGRyZXNzX3NpZ25hdHVyZV9wYWlyKSBkbwogICAgICAgICAgICAgICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KEVUSC52ZXJpZnlfc2lnbmF0dXJlX2Zyb21fYWRkcmVzcyh2LnNpZ25hdHVyZSwgdi5hZGRyZXNzLCBmaWYodi5zaWduYXR1cmUudjpwYXJpdHkoKSwgMCwgMSksIGhtc2cpLAogICAgICAgICAgICAgICAgICAgICdUaGUgZXRoZXJldW0gc2lnbmF0dXJlIGJ5ICcuLkVUSC5jaGVja3N1bV9lbmNvZGUodi5hZGRyZXNzKS4uJyBpcyBub3QgYXV0aGVudGljJykgdGhlbiByZXR1cm4gZW5kCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgKQplbmQpCgpXaGVuKCJ1c2UgZXRoZXJldW0gYWRkcmVzcyBzaWduYXR1cmUgcGFpciBhcnJheSAnJyB0byBjcmVhdGUgcmVzdWx0IGFycmF5IG9mICcnIiwgZnVuY3Rpb24oYWRkX3NpZywgZG9jKQogICAgZW1wdHkgJ3Jlc3VsdCBhcnJheScKICAgIEFDSy5yZXN1bHRfYXJyYXkgPSBfdmVyaWZ5X2FkZHJlc3Nfc2lnbmF0dXJlX2FycmF5KGFkZF9zaWcsIGRvYywKICAgICAgICBmdW5jdGlvbihhZGRyZXNzX3NpZ25hdHVyZV9wYWlyLCBobXNnKQogICAgICAgICAgICBsb2NhbCByZXMgPSB7fQogICAgICAgICAgICBmb3IgXywgdiBpbiBwYWlycyhhZGRyZXNzX3NpZ25hdHVyZV9wYWlyKSBkbwogICAgICAgICAgICAgICAgbG9jYWwgdG1wID0ge30KICAgICAgICAgICAgICAgIHRtcC5hZGRyZXNzID0gTy5mcm9tX3N0cmluZyhFVEguY2hlY2tzdW1fZW5jb2RlKHYuYWRkcmVzcykpCiAgICAgICAgICAgICAgICB0bXAuc3RhdHVzID0gRVRILnZlcmlmeV9zaWduYXR1cmVfZnJvbV9hZGRyZXNzKHYuc2lnbmF0dXJlLCB2LmFkZHJlc3MsIGZpZih2LnNpZ25hdHVyZS52OnBhcml0eSgpLCAwLCAxKSwgaG1zZykgYW5kIE8uZnJvbV9zdHJpbmcoInZlcmlmaWVkIikgb3IgTy5mcm9tX3N0cmluZygibm90IHZlcmlmaWVkIikKICAgICAgICAgICAgICAgIHRhYmxlLmluc2VydChyZXMsIHRtcCkKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIHJldHVybiByZXMKICAgICAgICBlbmQKICAgICkKICAgIG5ld19jb2RlYygicmVzdWx0IGFycmF5Iiwge2VuY29kaW5nPSJzdHJpbmcifSkKZW5kKQoKV2hlbigidXNlIGV0aGVyZXVtIHRyYW5zYWN0aW9uIHRvIHJ1biAnJyB1c2luZyAnJyIsIGZ1bmN0aW9uKG0sIHApCgogICAgbG9jYWwgbWV0aG9kLCBjb2RlYyA9IGhhdmUobSkKICAgIGxvY2FsIHBhcmFtcyA9IGhhdmUocCkKICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICAgY29kZWMuc2NoZW1hID09ICdldGhlcmV1bV9tZXRob2QnLAogICAgICAgJ21ldGhvZCBtdXN0IGJlIGEgYGV0aGVyZXVtIG1ldGhvZGAnCiAgICApCiAgICBsb2NhbCBpbnB1dCA9IGRlZXBtYXAoZnVuY3Rpb24obykKICAgICAgICByZXR1cm4gbzpvY3RldCgpOnN0cmluZygpIGVuZCwgbWV0aG9kLmlucHV0KQogICAgbG9jYWwgZW5jb2RlciA9IEVUSC5kYXRhX2NvbnRyYWN0X2ZhY3RvcnkoCiAgICAgICAgbWV0aG9kLm5hbWU6b2N0ZXQoKTpzdHJpbmcoKSwgaW5wdXQpCiAgICBsb2NhbCB0cmFuc2FjdGlvbl9kYXRhID0gZW5jb2Rlcih0YWJsZS51bnBhY2socGFyYW1zKSkKICAgIGxvY2FsIHR4ID0gaGF2ZSdldGhlcmV1bSB0cmFuc2FjdGlvbicKICAgIHplbmNvZGVfYXNzZXJ0KG5vdCB0eC5kYXRhIG9yICN0eC5kYXRhID09IDAsICJDYW5ub3Qgb3ZlcndyaXRlIHRyYW5zYWN0aW9uIGRhdGEiKQogICAgdHguZGF0YSA9IHRyYW5zYWN0aW9uX2RhdGEKZW5kKQoKV2hlbigiY3JlYXRlIGV0aGVyZXVtIGFkZHJlc3MgZnJvbSBldGhlcmV1bSBzaWduYXR1cmUgJycgb2YgJyciLCBmdW5jdGlvbihzaWduLCBkb2MpCiAgICBlbXB0eSdldGhlcmV1bSBhZGRyZXNzJwogICAgbG9jYWwgaGFzaGVkX21zZyA9IF9wcmVwYXJlX21zZ19mKGRvYykKICAgIGxvY2FsIHNpZ25hdHVyZSA9IGhhdmUoc2lnbikKICAgIGxvY2FsIHJlcyA9IEVUSC5hZGRyZXNzX2Zyb21fc2lnbmF0dXJlKHNpZ25hdHVyZSwgZmlmKHNpZ25hdHVyZS52OnBhcml0eSgpLCAwLCAxKSwgaGFzaGVkX21zZykKICAgIGlmIG5vdCByZXMgdGhlbgogICAgICAgIGVycm9yKCJObyB2YWxpZCBhZGRyZXNzIGZvdW5kIHJlbGF0ZWQgdG8gc2lnbmF0dXJlIDoiLi5zaWduKQogICAgZW5kCiAgICBBQ0suZXRoZXJldW1fYWRkcmVzcyA9IHJlcwogICAgbmV3X2NvZGVjKCdldGhlcmV1bSBhZGRyZXNzJywgeyB6ZW50eXBlID0gJ2UnICwgZW5jb2RpbmcgPSAnY29tcGxleCd9KQplbmQpCi96ZW5jb2RlX2ZvcmVhY2gubHVhAGxvY2FsIGZ1bmN0aW9uIGNsZWFyX2l0ZXJhdG9ycygpCiAgICBsb2NhbCBpbmZvID0gWkVOLklURVJfaGVhZAogICAgaWYgbm90IGluZm8ubmFtZXMgdGhlbiByZXR1cm4gZW5kCiAgICBmb3IgXyx2IGluIHBhaXJzKGluZm8ubmFtZXMpIGRvCiAgICAgICAgQUNLW3ZdID0gbmlsCiAgICAgICAgQ09ERUNbdl0gPSBuaWwKICAgIGVuZAogICAgaW5mby5uYW1lcyA9IG5pbAogICAgaW5mby5wb3MgPSAwCmVuZAoKbG9jYWwgZnVuY3Rpb24gaW5pdF9pdGVyYXRvcihuYW1lKQogICAgbG9jYWwgaW5mbyA9IFpFTi5JVEVSX2hlYWQKICAgIGlmIGluZm8ucG9zID09IDEgb3Igbm90IEFDS1tuYW1lXSB0aGVuCiAgICAgICAgZW1wdHkobmFtZSkKICAgICAgICBpZiBpbmZvLm5hbWVzIHRoZW4gdGFibGUuaW5zZXJ0KGluZm8ubmFtZXMsIG5hbWUpCiAgICAgICAgZWxzZSBpbmZvLm5hbWVzID0ge25hbWV9IGVuZAogICAgZW5kCmVuZAoKRm9yZWFjaCgiJycgaW4gJyciLCBmdW5jdGlvbihuYW1lLCBjb2xsZWN0aW9uKQogICAgbG9jYWwgaW5mbyA9IFpFTi5JVEVSX2hlYWQKICAgIGxvY2FsIGNvbCA9IGhhdmUoY29sbGVjdGlvbikKICAgIGxvY2FsIGNvbGxlY3Rpb25fY29kZWMgPSBDT0RFQ1tjb2xsZWN0aW9uXQoKICAgIHplbmNvZGVfYXNzZXJ0KGNvbGxlY3Rpb25fY29kZWMuemVudHlwZSA9PSAiYSIsICJDYW4gb25seSBpdGVyYXRlIG92ZXIgYXJyYXlzIikKICAgIGluaXRfaXRlcmF0b3IobmFtZSkKCiAgICAtLSBza2lwIGV4ZWN1dGlvbiBpbiB0aGUgbGFzdCBpdGVyYXRpb24KICAgIGlmIGluZm8ucG9zID09ICNjb2wrMSB0aGVuCiAgICAgICAgY2xlYXJfaXRlcmF0b3JzKCkKICAgIGVsc2UKICAgICAgICAtLSBmb3IgZWFjaCBpdGVyYXRpb24gcmVhZCB0aGUgdmFsdWUgaW4gdGhlIGNvbGxlY3Rpb24KICAgICAgICBBQ0tbbmFtZV0gPSBjb2xbaW5mby5wb3NdCiAgICAgICAgaWYgbm90IENPREVDW25hbWVdIHRoZW4KICAgICAgICAgICAgbG9jYWwgbl9jb2RlYyA9IHtlbmNvZGluZyA9IGNvbGxlY3Rpb25fY29kZWMuZW5jb2Rpbmd9CiAgICAgICAgICAgIGlmIGNvbGxlY3Rpb25fY29kZWMuc2NoZW1hIHRoZW4KICAgICAgICAgICAgICAgIG5fY29kZWMuc2NoZW1hID0gY29sbGVjdGlvbl9jb2RlYy5zY2hlbWEKICAgICAgICAgICAgICAgIG5fY29kZWMuemVudHlwZSA9ICJlIgogICAgICAgICAgICBlbmQKICAgICAgICAgICAgbmV3X2NvZGVjKG5hbWUsIG5fY29kZWMpCiAgICAgICAgZW5kCiAgICBlbmQKZW5kKQoKRm9yZWFjaCgiJycgaW4gc2VxdWVuY2UgZnJvbSAnJyB0byAnJyB3aXRoIHN0ZXAgJyciLCBmdW5jdGlvbihuYW1lLCBmcm9tX25hbWUsIHRvX25hbWUsIHN0ZXBfbmFtZSkKICAgIGxvY2FsIGluZm8gPSBaRU4uSVRFUl9oZWFkCiAgICBsb2NhbCBmcm9tID0gaGF2ZShmcm9tX25hbWUpCiAgICBsb2NhbCB0byAgID0gaGF2ZSh0b19uYW1lKQogICAgbG9jYWwgc3RlcCA9IGhhdmUoc3RlcF9uYW1lKQoKICAgIHplbmNvZGVfYXNzZXJ0KHR5cGUoZnJvbSkgPT0gdHlwZSh0bykgYW5kIHR5cGUodG8pID09IHR5cGUoc3RlcCksICJUeXBlcyBtdXN0IGJlIGVxdWFsIGluIGZvcmVhY2ggZGVjbGFyYXRpb24iKQogICAgemVuY29kZV9hc3NlcnQodHlwZShmcm9tKSA9PSAnemVucm9vbS5iaWcnIG9yIHR5cGUoZnJvbSkgPT0gJ3plbnJvb20uZmxvYXQnLCAiVW5rbm93biBudW1iZXIgdHlwZSIpCiAgICBpbml0X2l0ZXJhdG9yKG5hbWUpCgogICAgbG9jYWwgZmluaXNoZWQKICAgIGlmIHR5cGUoZnJvbSkgPT0gJ3plbnJvb20uYmlnJyB0aGVuCiAgICAgICAgLS0gb25seSBvbiBmaXJzdCBpdGVyYXRpb246IGRvIGNoZWNrcyBhbmQgc2F2ZSB1c2VmdWxsIHZhbHVlcwogICAgICAgIGlmIGluZm8ucG9zID09IDEgdGhlbgogICAgICAgICAgICB6ZW5jb2RlX2Fzc2VydChzdGVwIH49IEJJRy5uZXcoMCksICJ6ZXJvIHN0ZXAgaXMgbm90IHN1cHBvcnRlZCIpCiAgICAgICAgICAgIGxvY2FsIHJhbmdlX3NpemUgPSBCSUcuemVuc3ViKHRvLCBmcm9tKQogICAgICAgICAgICBpZiBCSUcuemVucG9zaXRpdmUoc3RlcCkgdGhlbgogICAgICAgICAgICAgICAgemVuY29kZV9hc3NlcnQoQklHLnplbnBvc2l0aXZlKHJhbmdlX3NpemUpIG9yIHJhbmdlX3NpemUgPT0gQklHLm5ldygwKSwgImVuZCBvZiBmb3JlYWNoIG11c3QgYmUgYmlnZ2VyIHRoYW4gdGhlIHN0YXJ0IGZvciBwb3N0aXZlIHN0ZXAiKQogICAgICAgICAgICAgICAgaW5mby50b19wbHVzXzEgPSBCSUcuemVuYWRkKHRvLCBCSUcubmV3KDEpKQogICAgICAgICAgICAgICAgLS0gY3VycmVudF92YWx1ZSA+ICB0bwogICAgICAgICAgICAgICAgLS0gY3VycmVudF92YWx1ZSA+PSB0byArIDEKICAgICAgICAgICAgICAgIC0tIChjdXJyZW50X3ZhbHVlIC0gKHRvKzEpKSA+PSAwCiAgICAgICAgICAgICAgICBpbmZvLmNoZWNrX2ZuID0gZnVuY3Rpb24gKCkKICAgICAgICAgICAgICAgICAgICBsb2NhbCBkaWZmID0gQklHLnplbnN1YihpbmZvLmN2LCBpbmZvLnRvX3BsdXNfMSkKICAgICAgICAgICAgICAgICAgICByZXR1cm4gQklHLnplbnBvc2l0aXZlKGRpZmYpIG9yIGRpZmYgPT0gQklHLm5ldygwKQogICAgICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGVsc2UKICAgICAgICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KG5vdCBCSUcuemVucG9zaXRpdmUocmFuZ2Vfc2l6ZSkgb3IgcmFuZ2Vfc2l6ZSA9PSBCSUcubmV3KDApLCAiZW5kIG9mIGZvcmVhY2ggbXVzdCBiZSBzbWFsbGVyIHRoYW4gdGhlIHN0YXJ0IGZvciBuZWdhdGl2ZSBzdGVwIikKICAgICAgICAgICAgICAgIGluZm8udG9fbWludXNfMSA9IEJJRy56ZW5zdWIodG8sIEJJRy5uZXcoMSkpCiAgICAgICAgICAgICAgICAtLSBjdXJyZW50X3ZhbHVlIDwgdG8KICAgICAgICAgICAgICAgIC0tIGN1cnJlbnRfdmFsdWUgPD0gdG8gLSAxCiAgICAgICAgICAgICAgICAtLSAoY3VycmVudF92YWx1ZSAtICh0by0xKSkgPD0gMAogICAgICAgICAgICAgICAgaW5mby5jaGVja19mbiA9IGZ1bmN0aW9uKCkKICAgICAgICAgICAgICAgICAgICBsb2NhbCBkaWZmID0gQklHLnplbnN1YihpbmZvLmN2LCBpbmZvLnRvX21pbnVzXzEpCiAgICAgICAgICAgICAgICAgICAgcmV0dXJuIG5vdCBCSUcuemVucG9zaXRpdmUoZGlmZikgb3IgZGlmZiA9PSBCSUcubmV3KDApCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGluZm8uY3YgPSBmcm9tCiAgICAgICAgZWxzZQogICAgICAgICAgICBpbmZvLmN2ID0gQklHLnplbmFkZChpbmZvLmN2LCBzdGVwKQogICAgICAgIGVuZAogICAgICAgIGZpbmlzaGVkID0gaW5mby5jaGVja19mbigpCiAgICBlbHNlCiAgICAgICAgLS0gb25seSBvbiBmaXJzdCBpdGVyYXRpb246IGRvIGNoZWNrcyBhbmQgc2F2ZSB1c2VmdWxsIHZhbHVlcwogICAgICAgIGlmIGluZm8ucG9zID09IDEgdGhlbgogICAgICAgICAgICB6ZW5jb2RlX2Fzc2VydChzdGVwIH49IEYubmV3KDApLCAiemVybyBzdGVwIGlzIG5vdCBzdXBwb3J0ZWQiKQogICAgICAgICAgICBpZiBzdGVwID4gRi5uZXcoMCkgdGhlbgogICAgICAgICAgICAgICAgemVuY29kZV9hc3NlcnQoZnJvbSA8PSB0bywgImVuZCBvZiBmb3JlYWNoIG11c3QgYmUgYmlnZ2VyIHRoYW4gdGhlIHN0YXJ0IGZvciBwb3N0aXZlIHN0ZXAiKQogICAgICAgICAgICAgICAgaW5mby5jaGVja19mbiA9IGZ1bmN0aW9uKCkgcmV0dXJuIGluZm8uY3YgPiB0byBlbmQKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgemVuY29kZV9hc3NlcnQoZnJvbSA+PSB0bywgImVuZCBvZiBmb3JlYWNoIG11c3QgYmUgc21hbGxlciB0aGFuIHRoZSBzdGFydCBmb3IgbmVnYXRpdmUgc3RlcCIpCiAgICAgICAgICAgICAgICBpbmZvLmNoZWNrX2ZuID0gZnVuY3Rpb24oKSByZXR1cm4gaW5mby5jdiA8IHRvIGVuZAogICAgICAgICAgICBlbmQKICAgICAgICAgICAgaW5mby5jdiA9IGZyb20KICAgICAgICBlbHNlCiAgICAgICAgICAgIGluZm8uY3YgPSBpbmZvLmN2ICsgc3RlcAogICAgICAgIGVuZAogICAgICAgIGZpbmlzaGVkID0gaW5mby5jaGVja19mbigpCiAgICBlbmQKCiAgICBpZiBmaW5pc2hlZCB0aGVuCiAgICAgICAgY2xlYXJfaXRlcmF0b3JzKCkKICAgIGVsc2UKICAgICAgICBBQ0tbbmFtZV0gPSBpbmZvLmN2CiAgICAgICAgaWYgbm90IENPREVDW25hbWVdIHRoZW4KICAgICAgICAgICAgbmV3X2NvZGVjKG5hbWUsIENPREVDW2Zyb21dKQogICAgICAgICAgICBDT0RFQ1tuYW1lXS5uYW1lID0gbmFtZQogICAgICAgIGVuZAogICAgZW5kCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF96aXBfd2l0aF9wcmVmaXgobmFtZSwgLi4uKQogICAgbG9jYWwgaW5mbyA9IFpFTi5JVEVSX2hlYWQKICAgIGxvY2FsIGFycmF5c19uYW1lcyA9IHsuLi59CiAgICBsb2NhbCBlbmNvZGluZ19mbiA9IHt9CgogICAgZm9yIF8sIG4gaW4gcGFpcnMoYXJyYXlzX25hbWVzKSBkbwogICAgICAgIGxvY2FsIHYsIGMgPSBoYXZlKG4pCiAgICAgICAgbG9jYWwgcHJlZml4ZWRfbmFtZSA9IHVzY29yZShuYW1lLi5uKQogICAgICAgIC0tIG9uIGZpcnN0IGl0ZXJhdGlvbnMgY2hlY2tzIHRoYXQgYXJlIGFsbCBhcnJheXMKICAgICAgICBpZiBpbmZvLnBvcyA9PSAxIHRoZW4KICAgICAgICAgICAgaWYgKGMuemVudHlwZSB+PSAiYSIpIHRoZW4KICAgICAgICAgICAgICAgIGVycm9yKCJDYW4gb25seSBpdGVyYXRlIG92ZXIgYXJyYXlzOiAiLi5uLi4iIGlzICIuLmMuemVudHlwZSwgMikKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGluaXRfaXRlcmF0b3IocHJlZml4ZWRfbmFtZSkKICAgICAgICBlbmQKICAgICAgICAtLSB0ZXJtaW5hdGUgbG9vcCBhcyBzb29uIGFzIG9uZSBhcnJheSBlbmRzCiAgICAgICAgaWYgbm90IHZbaW5mby5wb3NdIHRoZW4KICAgICAgICAgICAgY2xlYXJfaXRlcmF0b3JzKCkKICAgICAgICAgICAgcmV0dXJuCiAgICAgICAgZWxzZQogICAgICAgICAgICBBQ0tbcHJlZml4ZWRfbmFtZV0gPSB2W2luZm8ucG9zXQogICAgICAgICAgICBpZiBub3QgQ09ERUNbcHJlZml4ZWRfbmFtZV0gdGhlbgogICAgICAgICAgICAgICAgbG9jYWwgbl9jb2RlYyA9IHsgZW5jb2RpbmcgPSBjLmVuY29kaW5nIH0KICAgICAgICAgICAgICAgIC0tIHRhYmxlIG9mIHNjaGVtYXMgY2FuIG9ubHkgY29udGFpbiBlbGVtZW50cwogICAgICAgICAgICAgICAgaWYgYy5zY2hlbWEgdGhlbgogICAgICAgICAgICAgICAgICAgIG5fY29kZWMuc2NoZW1hID0gYy5zY2hlbWEKICAgICAgICAgICAgICAgICAgICBuX2NvZGVjLnplbnR5cGUgPSAiZSIKICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICAgICAgbmV3X2NvZGVjKHByZWZpeGVkX25hbWUsIG5fY29kZWMpCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgZW5kCmVuZAoKRm9yZWFjaCgidmFsdWUgcHJlZml4ICcnIGF0IHNhbWUgcG9zaXRpb24gaW4gYXJyYXlzICcnIGFuZCAnJyIsIF96aXBfd2l0aF9wcmVmaXgpCkZvcmVhY2goInZhbHVlIHByZWZpeCAnJyBhY3Jvc3MgYXJyYXlzICcnIGFuZCAnJyIsIF96aXBfd2l0aF9wcmVmaXgpCgpsb2NhbCBmdW5jdGlvbiBfemlwX292ZXJfbXVsdGlwbGVfYXJyYXlzKG5hbWUsIGFycmF5c19uYW1lcykKICAgIGxvY2FsIHYsIGMgPSBoYXZlKGFycmF5c19uYW1lcykKICAgIGlmKG5vdCBjIG9yIGMuemVudHlwZSB+PSAiYSIgb3IgYy5lbmNvZGluZyB+PSAic3RyaW5nIikgdGhlbgogICAgICAgIGVycm9yKCJBcnJheSBvZiBuYW1lcyBtdXN0IGJlIHNwZWNpZmllZCBpbiBhIHN0cmluZyBhcnJheSIsIDIpCiAgICBlbmQKICAgIGlmKG5leHQodixfKSA9PSBuaWwpIHRoZW4KICAgICAgICBlcnJvcigiQXJyYXkgb2YgbmFtZXMgbXVzdCBub3QgYmUgZW1wdHkiLCAyKQogICAgZW5kCiAgICBfemlwX3dpdGhfcHJlZml4KG5hbWUsIHRhYmxlLnVucGFjayhkZWVwbWFwKE8udG9fc3RyaW5nLCB2KSkpCmVuZApGb3JlYWNoKCJ2YWx1ZSBwcmVmaXggJycgYXQgc2FtZSBwb3NpdGlvbiBpbiBhcnJheXMgJyciLCBfemlwX292ZXJfbXVsdGlwbGVfYXJyYXlzKQpGb3JlYWNoKCJ2YWx1ZSBwcmVmaXggJycgYWNyb3NzIGFycmF5cyAnJyIsIF96aXBfb3Zlcl9tdWx0aXBsZV9hcnJheXMpCgotLSBicmVhayBmb3JlYWNoCgpsb2NhbCBmdW5jdGlvbiBicmVha19mb3JlYWNoKCkKICAgIGlmIG5vdCBaRU4uSVRFUl9oZWFkIHRoZW4KICAgICAgIGVycm9yKCJDYW4gb25seSBleGl0IGZyb20gZm9yZWFjaCBsb29wIiwgMikKICAgIGVuZAogICAgY2xlYXJfaXRlcmF0b3JzKCkKZW5kCgpXaGVuKCJleGl0IGZvcmVhY2giLCBicmVha19mb3JlYWNoKQpXaGVuKCJicmVhayBmb3JlYWNoIiwgYnJlYWtfZm9yZWFjaCkKL3plbmNvZGVfZnNwLmx1YQAKRlNQID0gcmVxdWlyZSdjcnlwdG9fZnNwJwotLSBGU1AuZW5jb2RlX21lc3NhZ2UKLS0gRlNQLmRlY29kZV9tZXNzYWdlCi0tIEZTUC5lbmNvZGVfcmVzcG9uc2UKLS0gRlNQLmRlY29kZV9yZXNwb25zZQoKLS0gbGVuZ3RoIG9mIGsgYW5kIHAgbXVzdCBiZSBhdCBsZWFzdCAzMiBieXRlcwpsb2NhbCBmdW5jdGlvbiBmc3BfY2lwaGVydGV4dF9mKG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICByZXMucCA9IHNjaGVtYV9nZXQob2JqLCAncCcpCglsb2NhbCBwbCA9ICNyZXMucAogICAgemVuY29kZV9hc3NlcnQocGwgPT0gRlNQLlJTS19sZW5ndGgsCgkJCQkgICAiRnNwIGNpcGhlcnRleHQgY29tcG9uZW50IHAgbXVzdCBiZSAiLi5GU1AuUlNLX2xlbmd0aC4uIiBieXRlcyBsb25nIikKICAgIHJlcy5rID0gc2NoZW1hX2dldChvYmosICdrJykKCWxvY2FsIGtsID0gI3Jlcy5rCiAgICB6ZW5jb2RlX2Fzc2VydChrbCA9PSBGU1AuUlNLX2xlbmd0aCwKCQkJCSAgICJGc3AgY2lwaGVydGV4dCBjb21wb25lbnQgayBtdXN0IGJlICIuLkZTUC5SU0tfbGVuZ3RoLi4iIGJ5dGVzIGxvbmciKQogICAgcmVzLm4gPSBzY2hlbWFfZ2V0KG9iaiwgJ24nKQogICAgemVuY29kZV9hc3NlcnQoI3Jlcy5uIDwgRlNQLlJTS19sZW5ndGgsCgkJCQkgICAiRnNwIGNpcGhlcnRleHQgY29tcG9uZW50IG4gbXVzdCBiZSBzbWFsbGVyIHRoYW4gMjU2IGJ5dGVzIikKICAgIHplbmNvZGVfYXNzZXJ0KHBsID09IGtsLAoJCQkJICAgIkZzcCBjaXBoZXJ0ZXh0IGNvbXBvbmVudCBwIGxlbmd0aCBtdXN0IGJlIGVxdWFsIHRvIGsiKQogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGZzcF8yNTZfYm91bmQob2JqLCBuYW1lKQogICAgbG9jYWwgcmVzID0gc2NoZW1hX2dldChvYmosICcuJykKICAgIHplbmNvZGVfYXNzZXJ0KCNyZXMgPT0gMjU2LCAiRlNQICIgLi4gbmFtZSAuLiAiIG11c3QgYmUgYXQgbGVhc3QgMjU2IGJ5dGVzIGxvbmciKQogICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIGZzcF9jaXBoZXJ0ZXh0ID0gZnNwX2NpcGhlcnRleHRfZiwKICAgICAgICBmc3BfcmVzcG9uc2UgPSBmdW5jdGlvbihvYmopIHJldHVybiBmc3BfMjU2X2JvdW5kKG9iaiwgInJlc3BvbnNlIikgZW5kLAogICAgICAgIGZzcF9zZXNzaW9uID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gZnNwXzI1Nl9ib3VuZChvYmosICJzZXNzaW9uIikgZW5kCiAgICB9CikKCmxvY2FsIGZ1bmN0aW9uIF9rZXlnZW4oKQogICAgLS0gbWV0aG9kIGZvciBvYnRhaW5pbmcgYSB2YWxpZCBFQyBzZWNyZXQga2V5IGF0IHJhbmRvbQogICAgbG9jYWwgc2ssIGQKICAgIHJlcGVhdAogICAgICAgIHNrID0gT0NURVQucmFuZG9tKDMyKQogICAgICAgIGQgPSBCSUcubmV3KHNrKQogICAgICAgIGlmICBFQ1Aub3JkZXIoKSA8PSBkIHRoZW4gZCA9IEJJRy5uZXcoMCkgZW5kIC0tZ3VhcmFudGllcyB0aGF0IHRoZSBnZW5lcmF0ZWQga2V5cGFpciBpcyB2YWxpZAogICAgdW50aWwgKGQgfj0gQklHLm5ldygwKSkKICAgIHJldHVybiBzawplbmQKCi0tIGdlbmVyYXRlIHRoZSBwcml2YXRlIGtleQpXaGVuKCJjcmVhdGUgZnNwIGtleSIsZnVuY3Rpb24oKQogICAgICAgICBpbml0a2V5cmluZydmc3AnCiAgICAgICAgIEFDSy5rZXlyaW5nLmZzcCA9IF9rZXlnZW4oKQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfZnNwX2tleV9mcm9tX3NlY3JldChzZWMpCiAgICBsb2NhbCBrID0gaGF2ZShzZWMpCiAgICBpbml0a2V5cmluZydmc3AnCiAgICBBQ0sua2V5cmluZy5mc3AgPSBrCmVuZAoKV2hlbigiY3JlYXRlIGZzcCBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIiwKCSBfZnNwX2tleV9mcm9tX3NlY3JldAopCldoZW4oImNyZWF0ZSBmc3Aga2V5IHdpdGggc2VjcmV0ICcnIiwKICAgICBfZnNwX2tleV9mcm9tX3NlY3JldAopCgoKLS0gY3JlYXRlIGZzcCBjbGVhcnRleHQgb2YgJycKLS0gQUNLLmZzcF9jbGVhcnRleHQKLS0gY3JlYXRlIGZzcCByZXNwb25zZSBvZiAnJyB0byAnJwotLSBjcmVhdGUgZnNwIGNsZWFyIHJlc3BvbnNlIG9mICcnCgotLSBjcmVhdGUgQUVTIEdDTSBjaXBoZXJ0ZXh0IG9mICcnCi0tIEFDSy5BRVMgR0NNX2NpcGhlcnRleHQKLS0gY3JlYXRlIEFFUyBHQ00gY2xlYXJ0ZXh0IG9mICcnCi0tIEFDSy5BRVMgR0NNX2NsZWFydGV4dAoKLS0gdXNlIGtleXJpbmcuZnNwIGFzIFNTCgotLSBjcmVhdGUgZnNwIGNpcGhlcnRleHQgb2YgJycKLS0gQUNLLmZzcF9jaXBoZXJ0ZXh0CldoZW4oImNyZWF0ZSBmc3AgY2lwaGVydGV4dCBvZiAnJyIsZnVuY3Rpb24obXNnKQogICAgICAgICBsb2NhbCBTUyA9IGhhdmVrZXknZnNwJwogICAgICAgICBsb2NhbCBtZXNzYWdlID0gaGF2ZShtc2cpCiAgICAgICAgIC0tIFJTSyBzZXNzaW9uIGtleSBpcyBub3QgaW1wb3J0ZWQgYmVjYXVzZSBzaG91bGQgYmUgZ2VuZXJhdGVkCiAgICAgICAgIC0tIGV2ZXJ5IG5ldyBzZXNzaW9uLgoJCSBsb2NhbCBSU0sgPSBtYXloYXZlJ2ZzcCBzZXNzaW9uJwoJCQlvciBPQ1RFVC5yYW5kb20oRlNQLlJTS19sZW5ndGgpCiAgICAgICAgIGxvY2FsIG5vbmNlID0gbWF5aGF2ZSdmc3Agbm9uY2UnCgkJCW9yIEZTUDptYWtlbm9uY2UoKQogICAgICAgICBBQ0suZnNwX2NpcGhlcnRleHQgPQoJCQlGU1A6ZW5jb2RlX21lc3NhZ2UoU1MsIG5vbmNlLCBtZXNzYWdlKQogICAgICAgICBuZXdfY29kZWMnZnNwIGNpcGhlcnRleHQnCmVuZCkKCi0tIHVzZSBrZXlyaW5nLmZzcCBhcyBTUwpXaGVuKCJjcmVhdGUgZnNwIGNsZWFydGV4dCBvZiAnJyIsZnVuY3Rpb24oY3R4dCkKICAgICAgICAgbG9jYWwgU1MgPSBoYXZla2V5J2ZzcCcKICAgICAgICAgbG9jYWwgY2lwaGVydGV4dCA9IGhhdmUoY3R4dCkKCQkgbG9jYWwgbm9uY2UgPSBtYXloYXZlJ2ZzcCBub25jZScgb3IgY2lwaGVydGV4dC5uCiAgICAgICAgIGxvY2FsIFJTSwogICAgICAgICBBQ0suZnNwX2NsZWFydGV4dCwgUlNLID0KICAgICAgICAgICAgIEZTUDpkZWNvZGVfbWVzc2FnZShTUywgY2lwaGVydGV4dCwgbm9uY2UpCiAgICAgICAgIG5ld19jb2RlYydmc3AgY2xlYXJ0ZXh0JwogICAgICAgICBuZXdfY2FjaGUoJ2ZzcCBzZXNzaW9uJywgUlNLKQogICAgICAgICBuZXdfY2FjaGUoJ2ZzcCBub25jZScsIG5vbmNlKQplbmQpCgpXaGVuKCJjcmVhdGUgZnNwIHJlc3BvbnNlIHdpdGggJyciLGZ1bmN0aW9uKG1zZykKICAgICAgICAgbG9jYWwgU1MgPSBoYXZla2V5J2ZzcCcKICAgICAgICAgbG9jYWwgcmVzcG9uc2UgPSBoYXZlKG1zZykKICAgICAgICAgbG9jYWwgUlNLID0KICAgICAgICAgICAgIG1heWhhdmUnZnNwIHNlc3Npb24nIG9yIENBQ0hFLmZzcF9zZXNzaW9uIG9yCiAgICAgICAgICAgICBlcnJvcigiRlNQIHNlc3Npb24gbm90IGZvdW5kIikKICAgICAgICAgbG9jYWwgbm9uY2UgPQogICAgICAgICAgICAgbWF5aGF2ZSdmc3Agbm9uY2UnIG9yIENBQ0hFLmZzcF9ub25jZSBvcgogICAgICAgICAgICAgZXJyb3IoIkZTUCBub25jZSBub3QgZm91bmQiKQogICAgICAgICBBQ0suZnNwX3Jlc3BvbnNlID0KICAgICAgICAgICAgIEZTUDplbmNvZGVfcmVzcG9uc2UoU1MsIG5vbmNlLCBSU0ssIHJlc3BvbnNlKQogICAgICAgICBuZXdfY29kZWMnZnNwIHJlc3BvbnNlJwplbmQpCgpXaGVuKCJjcmVhdGUgZnNwIHJlc3BvbnNlIG9mICcnIHdpdGggJyciLGZ1bmN0aW9uKGN0eHQsIG1zZykKICAgICAgICAgbG9jYWwgU1MgPSBoYXZla2V5J2ZzcCcKICAgICAgICAgbG9jYWwgY2lwaGVydGV4dCA9IGhhdmUoY3R4dCkKICAgICAgICAgbG9jYWwgcmVzcG9uc2UgPSBoYXZlKG1zZykKICAgICAgICAgbG9jYWwgXywgUlNLID0gRlNQOmRlY29kZV9tZXNzYWdlKFNTLCBjaXBoZXJ0ZXh0KQogICAgICAgICBsb2NhbCBub25jZSA9IGNpcGhlcnRleHQubiBvcgogICAgICAgICAgICAgbWF5aGF2ZSdmc3Agbm9uY2UnIG9yIENBQ0hFLmZzcF9ub25jZSBvciBGU1A6bWFrZW5vbmNlKCkKICAgICAgICAgQUNLLmZzcF9yZXNwb25zZSA9CiAgICAgICAgICAgICBGU1A6ZW5jb2RlX3Jlc3BvbnNlKFNTLCBub25jZSwgUlNLLCByZXNwb25zZSkKICAgICAgICAgbmV3X2NvZGVjJ2ZzcCByZXNwb25zZScKZW5kKQoKV2hlbigiY3JlYXRlIGZzcCBjbGVhcnRleHQgb2YgcmVzcG9uc2UgJyciLGZ1bmN0aW9uKGN0eHQpCiAgICAgICAgIGxvY2FsIFNTID0gaGF2ZWtleSdmc3AnCiAgICAgICAgIGxvY2FsIGNpcGhlcnRleHQgPSBoYXZlKGN0eHQpCiAgICAgICAgIGxvY2FsIFJTSyA9CiAgICAgICAgICAgICBtYXloYXZlJ2ZzcCBzZXNzaW9uJyBvciBDQUNIRS5mc3Bfc2Vzc2lvbiBvcgogICAgICAgICAgICAgZXJyb3IoIkZTUCBzZXNzaW9uIG5vdCBmb3VuZCIpCiAgICAgICAgIGxvY2FsIG5vbmNlID0KICAgICAgICAgICAgIG1heWhhdmUnZnNwIG5vbmNlJyBvciBDQUNIRS5mc3Bfbm9uY2Ugb3IgRlNQOm1ha2Vub25jZSgpCiAgICAgICAgIEFDSy5mc3BfY2xlYXJ0ZXh0ID0KICAgICAgICAgICAgIEZTUDpkZWNvZGVfcmVzcG9uc2UoU1MsIG5vbmNlLCBSU0ssIGNpcGhlcnRleHQpCiAgICAgICAgIG5ld19jb2RlYydmc3AgY2xlYXJ0ZXh0JwplbmQpCgpXaGVuKCJjcmVhdGUgZnNwIGNsZWFydGV4dCBvZiByZXNwb25zZSAnJyB0byAnJyIsZnVuY3Rpb24oY3JlcywgY21zZykKICAgICAgICAgbG9jYWwgU1MgPSBoYXZla2V5J2ZzcCcKICAgICAgICAgbG9jYWwgcmVzcG9uc2UgPSBoYXZlKGNyZXMpCiAgICAgICAgIGxvY2FsIG1lc3NhZ2UgPSBoYXZlKGNtc2cpCiAgICAgICAgIGxvY2FsIG5vbmNlID0gbWVzc2FnZS5uIG9yCiAgICAgICAgICAgICBtYXloYXZlJ2ZzcCBub25jZScgb3IgQ0FDSEUuZnNwX25vbmNlIG9yIEZTUDptYWtlbm9uY2UoKQogICAgICAgICBsb2NhbCBfLCBSU0sgPSBGU1A6ZGVjb2RlX21lc3NhZ2UoU1MsIG1lc3NhZ2UpCiAgICAgICAgIEFDSy5mc3BfY2xlYXJ0ZXh0ID0KICAgICAgICAgICAgIEZTUDpkZWNvZGVfcmVzcG9uc2UoU1MsIG5vbmNlLCBSU0ssIHJlc3BvbnNlKQogICAgICAgICBuZXdfY29kZWMnZnNwIGNsZWFydGV4dCcKZW5kKQovemVuY29kZV9naXZlbi5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMTgtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCi0tIFRPRE86IHVzZSBzdHJpY3QgdGFibGUKLS0gaHR0cHM6Ly9zdGV2ZWRvbm92YW4uZ2l0aHViLmlvL1BlbmxpZ2h0L2FwaS9saWJyYXJpZXMvcGwuc3RyaWN0Lmh0bWwKCi0tIHRoZSBtYWluIHNlY3VyaXR5IGNvbmNlcm4gaW4gdGhpcyBaZW5jb2RlIG1vZHVsZSBpcyB0aGF0IG5vIGRhdGEKLS0gcGFzc2VzIHdpdGhvdXQgdmFsaWRhdGlvbiBmcm9tIElOIHRvIEFDSyBvciBmcm9tCi0tIGlubGluZSBpbnB1dC4KCi0tIGRhdGEgY29taW5nIGluIGlzIGFuYWx5emVkIHRocm91Z2ggYSBzZXJpZXMgb2YgZnVuY3Rpb25zOgotLSBndWVzc19jb252ZXJzaW9uKHJhdywgY29udiBvciBuYW1lKSAtPiB6ZW5vZGVfZGF0YS5sdWEgTDoxMDAgYXBwcm94Ci0tLSB8XyBpZiBsdWF0eXBlKHN0cmluZykgJiYgZm9ybWF0IC0+IGlucHV0IGVuY29kaW5nKGZvcm1hdCkKCi0tIEdJVkVOCmxvY2FsIGZ1bmN0aW9uIGdjKCkKICAgWkVOLlRNUCA9IHt9CmVuZAoKLS0gc2FmZWx5IHRha2UgYW55IHplbnJvb20gb2JqZWN0IGFzIGluZGV4CmxvY2FsIGZ1bmN0aW9uIF9pbmRleF90b19zdHJpbmcod2hhdCkKICAgbG9jYWwgdCA8Y29uc3Q+ID0gdHlwZSh3aGF0KQogICBpZiB0ID09ICdzdHJpbmcnIHRoZW4KICAgICAgcmV0dXJuIHdoYXQKICAgZWxzZWlmIGlzemVuKHQpIHRoZW4KICAgICAgcmV0dXJuIHdoYXQ6b2N0ZXQoKTpzdHJpbmcoKQogICBlbmQKICAgZXJyb3IoIkludmFsaWQgdHlwZSB0byBpbmRleCB2YXJpYWJsZSBpbiBoZWFwOiAiLi50LCAzKQogICByZXR1cm4gbmlsCmVuZAoKLS0tCi0tIFBpY2sgYSBnZW5lcmljIGRhdGEgc3RydWN0dXJlIGZyb20gdGhlIDxiPklOPC9iPiBtZW1vcnkKLS0gc3BhY2UuIExvb2tzIGZvciBuYW1lZCBkYXRhIG9uIHRoZSBmaXJzdCBhbmQgc2Vjb25kIGxldmVsIGFuZCBtYWtlcwotLSBpdCByZWFkeSBpbiBaRU4uVE1QIGZvciBAe3ZhbGlkYXRlfSBvciBAe2Fja30uCi0tCi0tIEBmdW5jdGlvbiBwaWNrKG5hbWUsIGRhdGEsIGVuY29kaW5nKQotLSBAcGFyYW0gd2hhdCBzdHJpbmcgZGVzY3JpcHRvciBvZiB0aGUgZGF0YSBvYmplY3QKLS0gQHBhcmFtIGNvbnZbb3B0XSBvcHRpb25hbCBlbmNvZGluZyBzcGVjIChkZWZhdWx0IENPTkYuaW5wdXQuZW5jb2RpbmcpCi0tIEByZXR1cm4gdHJ1ZSBvciBmYWxzZQpsb2NhbCBmdW5jdGlvbiBwaWNrKHdoYXQsIGNvbnYpCiAgIGxvY2FsIG5hbWUgPGNvbnN0PiA9IF9pbmRleF90b19zdHJpbmcod2hhdCkKICAgbG9jYWwgcmF3IDxjb25zdD4gPSBJTltuYW1lXQogICBsb2NhbCBlcnIKICAgaWYgQ09ORi5taXNzaW5nLmZhdGFsIHRoZW4gZXJyID0gZXJyb3IgZWxzZSBlcnIgPSB3YXJuIGVuZAogICBpZiBub3QgcmF3IGFuZCBDT05GLm1pc3NpbmcuZmF0YWwgdGhlbgoJICBlcnIoIkNhbm5vdCBmaW5kICciIC4uIG5hbWUgLi4gIicgYW55d2hlcmUgKG51bGwgdmFsdWU/KSIsIDIpIGVuZAogICBpZiByYXcgPT0gJycgYW5kIENPTkYubWlzc2luZy5mYXRhbCB0aGVuCgkgIGVycigiRm91bmQgZW1wdHkgc3RyaW5nIGluICciIC4uIG5hbWUpIGVuZAogICAtLSBpZiBub3QgY29udiBhbmQgWkVOLnNjaGVtYXNbd2hhdF0gdGhlbiBjb252ID0gd2hhdCBlbmQKICAgWkVOLlRNUCA9IGd1ZXNzX2NvbnZlcnNpb24ocmF3LCBjb252IG9yIG5hbWUpCiAgIGlmIG5vdCBaRU4uVE1QIHRoZW4KCSAgZXJyb3IoJ0Nhbm5vdCBndWVzcyBhbnkgY29udmVyc2lvbiBmb3I6ICcgLi4KCQkJbHVhdHlwZShyYXcpIC4uICcgJyAuLiAoY29udiBvciBuYW1lIG9yICcobmlsKScpKSBlbmQKICAgWkVOLlRNUC5uYW1lID0gbmFtZQogICBhc3NlcnQoWkVOLk9LKQogICBpZiBERUJVRyA+IDEgdGhlbgoJICBaRU4uZnRyYWNlKCdwaWNrIGZvdW5kICcgLi4gbmFtZSAuLiAnKCcuLlpFTi5UTVAuemVudHlwZS4uJyknKQogICBlbmQKZW5kCgotLS0KLS0gUGljayBhIGRhdGEgc3RydWN0dXJlIG5hbWVkICd3aGF0JyBjb250YWluZWQgdW5kZXIgYSAnc2VjdGlvbicga2V5Ci0tIG9mIHRoZSBhdCB0aGUgcm9vdCBvZiB0aGUgPGI+SU48L2I+IG1lbW9yeSBzcGFjZS4gTG9va3MgZm9yIG5hbWVkCi0tIGRhdGEgYXQgdGhlIGZpcnN0IGFuZCBzZWNvbmQgbGV2ZWwgdW5kZXJuZWF0aCBJTltzZWN0aW9uXSBhbmQgbW92ZXMKLS0gaXQgdG8gWkVOLlRNUFt3aGF0XVtzZWN0aW9uXSwgcmVhZHkgZm9yIEB7dmFsaWRhdGV9IG9yIEB7YWNrfS4gSWYKLS0gWkVOLlRNUFt3aGF0XSBleGlzdHMgYWxyZWFkeSwgZXZlcnkgbmV3IGVudHJ5IGlzIGFkZGVkIGFzIGEga2V5L3ZhbHVlCi0tCi0tIEBmdW5jdGlvbiBwaWNraW4oc2VjdGlvbiwgbmFtZSkKLS0gQHBhcmFtIHNlY3Rpb24gc3RyaW5nIGRlc2NyaXB0b3Igb2YgdGhlIHNlY3Rpb24gY29udGFpbmluZyB0aGUgZGF0YQotLSBAcGFyYW0gd2hhdCBzdHJpbmcgZGVzY3JpcHRvciBvZiB0aGUgZGF0YSBvYmplY3QKLS0gQHBhcmFtIGNvbnYgc3RyaW5nIGV4cGxpY2l0IGNvbnZlcnNpb24gb3Igc2NoZW1hIHRvIHVzZQotLSBAcGFyYW0gZmFpbCBib29sIGJhaWwgb3V0IG9yIGNvbnRpbnVlIG9uIGVycm9yCi0tIEByZXR1cm4gdHJ1ZSBvciBmYWxzZQpsb2NhbCBmdW5jdGlvbiBwaWNraW4oc2VjdGlvbiwgd2hhdCwgY29udiwgZmFpbCkKICAgemVuY29kZV9hc3NlcnQoc2VjdGlvbiwgJ05vIHNlY3Rpb24gc3BlY2lmaWVkJykKICAgbG9jYWwgcm9vdCA8Y29uc3Q+ID0gSU5bc2VjdGlvbl0KICAgaWYgbm90IHJvb3QgdGhlbiBlcnJvcigiQ2Fubm90IGZpbmQgJyIuLnNlY3Rpb24uLiInIiwgMikgZW5kCiAgIGxvY2FsIG5hbWUgPGNvbnN0PiA9IF9pbmRleF90b19zdHJpbmcod2hhdCkKICAgbG9jYWwgcmF3ICAtLSBkYXRhIHBvaW50ZXIKICAgaWYgbHVhdHlwZShyb290KSB+PSAndGFibGUnIHRoZW4KICAgICAgZXJyb3IoIk9iamVjdCBpcyBub3QgYSB0YWJsZTogIi4uc2VjdGlvbiwgMikKICAgZW5kCiAgIGlmICNyb290ID09IDEgdGhlbgogICAgICByYXcgPSByb290W25hbWVdCiAgICAgIGlmIG5vdCByYXcgYW5kIGx1YXR5cGUocm9vdFsxXSkgPT0gJ3RhYmxlJyB0aGVuCgkJIHJhdyA9IHJvb3RbMV1bbmFtZV0KICAgICAgZW5kCiAgIGVsc2UKICAgICAgcmF3ID0gcm9vdFtuYW1lXQogICBlbmQKICAgaWYgbm90IHJhdyBhbmQgQ09ORi5taXNzaW5nLmZhdGFsIHRoZW4KICAgICAgZXJyb3IoIk9iamVjdCBub3QgZm91bmQ6ICIuLm5hbWUuLiIgaW4gIi4uc2VjdGlvbiwgMikKICAgZW5kCiAgIGlmIHJhdyA9PSAnJyBhbmQgQ09ORi5taXNzaW5nLmZhdGFsIHRoZW4KICAgICAgZXJyb3IoIkZvdW5kIGVtcHR5IHN0cmluZyAnIiAuLiBuYW1lIC4uIicgaW5zaWRlICciLi5zZWN0aW9uLi4iJyIsIDIpIGVuZAogICAtLSBjb252ID0gY29udiBvciBuYW1lCiAgIC0tIGlmIG5vdCBjb252IGFuZCBaRU4uc2NoZW1hc1tuYW1lXSB0aGVuIGNvbnYgPSBuYW1lIGVuZAogICAtLSBpZiBubyBlbmNvZGluZyBwcm92aWRlZCB0aGVuIGNvbnZlcnNpb24gaXMgc2FtZSBhcyBuYW1lIChzY2hlbWFzIGV0Yy4pCiAgIFpFTi5UTVAgPSBndWVzc19jb252ZXJzaW9uKHJhdywgY29udiBvciBuYW1lKQogICBaRU4uVE1QLm5hbWUgPSBuYW1lCiAgIFpFTi5UTVAucm9vdCA9IHNlY3Rpb24KICAgYXNzZXJ0KFpFTi5PSykKICAgaWYgREVCVUcgPiAxIHRoZW4KICAgICAgWkVOLmZ0cmFjZSgncGlja2luIGZvdW5kICcgLi4gbmFtZSAuLiAnIGluICcgLi4gc2VjdGlvbikKICAgZW5kCmVuZAoKCi0tIHRha2VzIGEgZGF0YSBvYmplY3QgYW5kIHRoZSBndWVzc2VkIHN0cnVjdHVyZSwgb3BlcmF0ZXMgdGhlCi0tIGNvbnZlcnNpb24gYW5kIHJldHVybnMgdGhlIHJlc3VsdGluZyByYXcgZGF0YSB0byBiZSB1c2VkIGluc2lkZSB0aGUKLS0gV0hFTiBibG9jayBpbiBIRUFQLgpmdW5jdGlvbiBvcGVyYXRlX2NvbnZlcnNpb24oZ3Vlc3NlZCkKICAgIC0tIGNhcnJ5IGd1ZXNzZWQgZGV0ZWN0aW9uIGluIENPREVDCiAgICBDT0RFQ1tndWVzc2VkLm5hbWVdID0gewogICAgICAgIG5hbWUgPSBndWVzc2VkLm5hbWUsCiAgICAgICAgZW5jb2RpbmcgPSBndWVzc2VkLmVuY29kaW5nLAogICAgICAgIHplbnR5cGUgPSBndWVzc2VkLnplbnR5cGUsCiAgICAgICAgcm9vdCA9IGd1ZXNzZWQucm9vdCwKICAgICAgICBzY2hlbWEgPSBndWVzc2VkLnNjaGVtYSwKICAgICAgICBtaXNzaW5nID0gZ3Vlc3NlZC5taXNzaW5nCiAgICB9CiAgICAtLSBkYXRhIG5vdCBmb3VuZCAoYW5kIENPTkYubWlzc2luZy5mYXRhbCA9PSBmYWxzZSkKICAgIGlmIGd1ZXNzZWQubWlzc2luZyB0aGVuIHJldHVybiBuaWwgZW5kCiAgICAtLSBjaGVjayBpZiBhbHJlYWR5IGEgemVucm9vbSB0eXBlCiAgICAtLSAoaS5lLiB6ZW5yb29tLmJpZyBmcm9tIGpzb24gZGVjb2RlKQogICAgaWYgbm90IGd1ZXNzZWQuZnVuIHRoZW4KICAgICAgICBlcnJvcignTm8gY29udmVyc2lvbiBvcGVyYXRpb24gZ3Vlc3NlZCcsIDIpCiAgICAgICAgcmV0dXJuIG5pbAogICAgZW5kCgogICAgLS0geHh4KCdPcGVyYXRpbmcgY29udmVyc2lvbiBvbjogJy4uZ3Vlc3NlZC5uYW1lKQogICAgbG9jYWwgZnVuID0gZ3Vlc3NlZC5mdW4KICAgIGlmIGx1YXR5cGUoZnVuKSA9PSAndGFibGUnIHRoZW4gZnVuID0gZnVuLmltcG9ydCBlbmQKICAgIGxvY2FsIGx0ID0gbHVhdHlwZShndWVzc2VkLnJhdykKICAgIGlmIGx0ID09ICd0YWJsZScgdGhlbgogICAgICAgIC0tIGNoZWNrIGNvcnJlY3RuZXNzIG9mIHRoZSBkYXRhIHR5cGUKICAgICAgICBpZiBndWVzc2VkLnplbnR5cGUgPT0gImEiIHRoZW4gYXNzZXJ0KGlzYXJyYXkoZ3Vlc3NlZC5yYXcpLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIkluY29ycmVjdCBkYXRhIHR5cGUsIGV4cGVjdGVkIGFycmF5IGZvciAiLi5ndWVzc2VkLm5hbWUpCiAgICAgICAgZWxzZWlmIGd1ZXNzZWQuemVudHlwZSA9PSAiZCIgdGhlbiBhc3NlcnQoaXNkaWN0aW9uYXJ5KGd1ZXNzZWQucmF3KSwKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAiSW5jb3JyZWN0IGRhdGEgdHlwZSwgZXhwZWN0ZWQgZGljdGlvbmFyeSBmb3IgIi4uZ3Vlc3NlZC5uYW1lKQogICAgICAgIGVuZAogICAgICAgIGlmIGd1ZXNzZWQuc2NoZW1hIHRoZW4KICAgICAgICAgICAgbG9jYWwgcmVzID0ge30KICAgICAgICAgICAgbG9jYWwgenQgPGNvbnN0PiA9IGd1ZXNzZWQuemVudHlwZQogICAgICAgICAgICBpZiB6dCA9PSAnZScgdGhlbiAtLSBzaW5nbGUgc2NoZW1hIGVsZW1lbnQKICAgICAgICAgICAgICAgIHJldHVybiBmdW4oZ3Vlc3NlZC5yYXcpCiAgICAgICAgICAgICAgICAtLSBhcnJheSBvZiBzY2hlbWFzCiAgICAgICAgICAgIGVsc2VpZiB6dCA9PSAnYScgdGhlbgogICAgICAgICAgICAgICAgZm9yIF8sdiBpbiBwYWlycyhndWVzc2VkLnJhdykgZG8KICAgICAgICAgICAgICAgICAgICB0YWJsZS5pbnNlcnQocmVzLCBmdW4odikpCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgICAgIC0tIGRpY3Rpb25hcnkgb2Ygc2NoZW1hcwogICAgICAgICAgICBlbHNlaWYgenQgPT0gJ2QnIHRoZW4KICAgICAgICAgICAgICAgIGZvciBrLCB2IGluIHBhaXJzKGd1ZXNzZWQucmF3KSBkbwogICAgICAgICAgICAgICAgICAgIHJlc1trXSA9IGZ1bih2KQogICAgICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGVsc2UKICAgICAgICAgICAgICAgIGVycm9yKCdVbmtub3duIHplbnR5cGUgdG8gb3BlcmF0ZSBzY2hlbWEgY29udmVyc2lvbjogJy4uZ3Vlc3NlZC56ZW50eXBlLCAyKQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgcmV0dXJuKHJlcykgLS0gYSwgZAogICAgICAgIGVsc2UKICAgICAgICAgICAgLS0gVE9ETzogYmV0dGVyIGVycm9yIGNoZWNraW5nIG9uIGRlZXBtYXA/CiAgICAgICAgICAgIGlmIGx1YXR5cGUoZ3Vlc3NlZC5jaGVjaykgPT0gJ2Z1bmN0aW9uJyB0aGVuCiAgICAgICAgICAgICAgICBkZWVwbWFwKGd1ZXNzZWQuY2hlY2ssIGd1ZXNzZWQucmF3KQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgcmV0dXJuIGRlZXBtYXAoZnVuLCBndWVzc2VkLnJhdykKICAgICAgICBlbmQKICAgIGVsc2UgLS0gZWxlbWVudAoKICAgICAgICAtLSBjb3JuZXIgY2FzZTogaW5wdXQgaXMgYWxyZWFkeSBhIHplbnJvb20gdHlwZQogICAgICAgIGlmIGx0ID09ICd1c2VyZGF0YScgdGhlbgogICAgICAgICAgICBpZiBpc3plbih0eXBlKGd1ZXNzZWQucmF3KSkgdGhlbgogICAgICAgICAgICAgICAgcmV0dXJuKGd1ZXNzZWQucmF3KQogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICBlcnJvcigiVW5rbm93biB1c2VyZGF0YSB0eXBlIGZvciBlbGVtZW50OiAiLi5ndWVzc2VkLm5hbWUsIDIpCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgICAgIC0tLQoKICAgICAgICBpZiBndWVzc2VkLmNoZWNrIHRoZW4KICAgICAgICAgICAgaWYgbm90IGd1ZXNzZWQuY2hlY2soZ3Vlc3NlZC5yYXcpIHRoZW4KICAgICAgICAgICAgICAgIGVycm9yKCJDYW5ub3QgZGVjb2RlICIgLi4gZ3Vlc3NlZC5uYW1lLi4gIiB3aXRoIGVuY29kaW5nICIuLmd1ZXNzZWQuZW5jb2RpbmcpCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgICAgIC0tIGZ1biBtYXkgcmV0dXJuIHR3byB2YWx1ZXM6IHZhbCBhbmQgb3B0aW9uYWwgcGFyYW0KICAgICAgICAtLSB3aGljaCBpcyB1c2VkIGluIGFjaygpIHRvIHNldCBhZGRpdGlvbmFsIENPREVDIHBhcmFtcwogICAgICAgIC0tIHBhcmFtIGlzIGRlZmluZWQgZGlyZWN0bHkgaW50byB0aGUgc2NoZW1hIGZ1bmN0aW9uIQogICAgICAgIHJldHVybiBmdW4oZ3Vlc3NlZC5yYXcpCiAgICBlbmQKZW5kCgpsb2NhbCBmdW5jdGlvbiBhY2tfdGFibGUoa2V5LCB2YWwpCiAgIHplbmNvZGVfYXNzZXJ0KAogICAgICBsdWF0eXBlKGtleSkgPT0gJ3N0cmluZycsCiAgICAgICdaRU4udGFibGVfYWRkIGFyZyAjMSBpcyBub3QgYSBzdHJpbmcnCiAgICkKICAgemVuY29kZV9hc3NlcnQoCiAgICAgIGx1YXR5cGUodmFsKSA9PSAnc3RyaW5nJywKICAgICAgJ1pFTi50YWJsZV9hZGQgYXJnICMyIGlzIG5vdCBhIHN0cmluZycKICAgKQogICBpZiBub3QgQUNLW2tleV0gdGhlbgogICAgICBBQ0tba2V5XSA9IHt9CiAgIGVuZAogICBsb2NhbCB0IDxjb25zdD4gPSBaRU4uVE1QCiAgIGxvY2FsIHYgPGNvbnN0PiA9IG9wZXJhdGVfY29udmVyc2lvbih0KQogICBBQ0tba2V5XVt2YWxdID0gdgogICBsb2NhbCBuIDxjb25zdD4gPSB0Lm5hbWUKICAgaWYga2V5IH49IG4gdGhlbgogICAgICBDT0RFQ1trZXldID0gQ09ERUNbbl0KICAgICAgQ09ERUNbbl0gPSBuaWwKICAgZW5kCiAgIGlmIG5vdCBDT0RFQ1trZXldLm1pc3NpbmcgdGhlbgoJICBsb2NhbCB2dCA8Y29uc3Q+ID0gdHlwZSh2KQoJICBpZiBpc3plbih2dCkgdGhlbgoJCSBDT0RFQ1trZXldLmJpbnR5cGUgPSB2dAoJICBlbmQKICAgZW5kCmVuZAoKLS0tCi0tIEZpbmFsIHN0ZXAgaW5zaWRlIHRoZSA8Yj5HaXZlbjwvYj4gYmxvY2sgdG93YXJkcyB0aGUgPGI+V2hlbjwvYj46Ci0tIHBhc3Mgb24gYSBkYXRhIHN0cnVjdHVyZSBpbnRvIHRoZSBBQ0sgbWVtb3J5IHNwYWNlLCByZWFkeSBmb3IKLS0gcHJvY2Vzc2luZy4gIEl0IHJlcXVpcmVzIHRoZSBkYXRhIHRvIGJlIHByZXNlbnQgaW4gWkVOLlRNUFtuYW1lXSBhbmQKLS0gdHlwaWNhbGx5IGZvbGxvd3MgYSBAe3BpY2t9LiBJbiBzb21lIHJlc3RyaWN0ZWQgY2FzZXMgaXQgaXMgdXNlZAotLSBpbnNpZGUgYSA8Yj5XaGVuPC9iPiBibG9jayBmb2xsb3dpbmcgdGhlIGlubGluZSBpbnNlcnRpb24gb2YgZGF0YQotLSBmcm9tIHplbmNvZGUuCi0tCi0tIEBmdW5jdGlvbiBhY2sobmFtZSkKLS0gQHBhcmFtIG5hbWUgc3RyaW5nIGtleSBvZiB0aGUgZGF0YSBvYmplY3QgaW4gWkVOLlRNUFtuYW1lXQpsb2NhbCBmdW5jdGlvbiBhY2sod2hhdCkKICAgbG9jYWwgdCA8Y29uc3Q+ID0gWkVOLlRNUAogICBsb2NhbCBuYW1lIDxjb25zdD4gPSBfaW5kZXhfdG9fc3RyaW5nKHdoYXQpCiAgIHplbmNvZGVfYXNzZXJ0KHQsICdObyB2YWxpZCBvYmplY3QgZm91bmQ6ICcgLi4gbmFtZSkKICAgZW1wdHkobmFtZSkKICAgLS0gZ2V0IHZhbHVlIGFuZCBvcHRpb25hbCBhZGRpdGlvbmFsIHBhcmFtZXRlcnMgZm9yIGNvZGVjCiAgIGxvY2FsIHZhbCA8Y29uc3Q+LCBwYXJhbSA8Y29uc3Q+ID0gb3BlcmF0ZV9jb252ZXJzaW9uKHQpCiAgIEFDS1tuYW1lXSA9IHZhbAogICBpZiBub3QgQ09ERUNbbmFtZV0ubWlzc2luZyB0aGVuCgkgIGxvY2FsIHZhbHR5cGUgPGNvbnN0PiA9IHR5cGUodmFsKQoJICBpZiBpc3plbih2YWx0eXBlKSB0aGVuCgkJIENPREVDW25hbWVdLmJpbnR5cGUgPSB2YWx0eXBlCgkgIGVuZAogICBlbmQKICAgaWYgcGFyYW0gdGhlbgogICAgICAgZm9yIGssdiBpbiBwYWlycyhwYXJhbSkgZG8KICAgICAgICAgICBDT0RFQ1tuYW1lXVtrXSA9IHYKICAgICAgIGVuZAogICBlbmQKICAgLS0gbmFtZSBvZiBzY2hlbWEgbWF5IGRpZmZlciBmcm9tIG5hbWUgb2Ygb2JqZWN0CiAgIC0tIG5ld19jb2RlYyhuYW1lLCB7IHNjaGVtYSA9IFpFTi5UTVAuc2NoZW1hIH0pCgogICAtLSBpZiBaRU4uVE1QLnNjaGVtYSBhbmQgKFpFTi5UTVAuc2NoZW1hIH49ICdudW1iZXInKSBhbmQgKCBaRU4uVE1QLnNjaGVtYSB+PSBaRU4uVE1QLmVuY29kaW5nICkgdGhlbgogICAtLSAgICBDT0RFQ1tuYW1lXS5zY2hlbWEgPSBaRU4uVE1QLnNjaGVtYQogICAtLSBlbmQKCmVuZAoKR2l2ZW4oIm5vdGhpbmciLGZ1bmN0aW9uKCkKICAgICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgIChuZXh0KElOKSA9PSBuaWwpLAogICAgICAgICAnVW5kZXNpcmVkIGRhdGEgcGFzc2VkIGFzIGlucHV0JwogICAgICApCmVuZCkKCi0tIG1heWJlIFRPRE86IEdpdmVuIGFsbCB2YWxpZCBkYXRhCi0tIGNvbnZlcnQgYW5kIGltcG9ydCBkYXRhIG9ubHkgd2hlbiBpcyBrbm93biBieSBzY2hlbWEgYW5kIHBhc3NlcyB2YWxpZGF0aW9uCi0tIGlnbm9yZSBhbGwgb3RoZXIgZGF0YSBzdHJ1Y3R1cmVzIHRoYXQgYXJlIG5vdCBrbm93biBieSBzY2hlbWEgb3IgZG9uJ3QgcGFzcyB2YWxpZGF0aW9uCgpHaXZlbigiYW0gJyciLGZ1bmN0aW9uKG5hbWUpCiAgICAgIElhbShuYW1lKQplbmQpCgpHaXZlbigibXkgbmFtZSBpcyBpbiAnJyBuYW1lZCAnJyIsZnVuY3Rpb24oc2MsIG5hbWUpCiAgICAgIHBpY2sobmFtZSwgc2MpCiAgICAgIGFzc2VydChaRU4uVE1QLm5hbWUsICdObyBuYW1lIGZvdW5kIGluOiAnIC4uIG5hbWUpCiAgICAgIElhbShPLnRvX3N0cmluZyhvcGVyYXRlX2NvbnZlcnNpb24oWkVOLlRNUCkpKQogICAgICBDT0RFQ1tuYW1lXSA9IG5pbCAtLSBqdXN0IHVzZWQgdG8gZ2V0IG5hbWUKZW5kKQoKR2l2ZW4oIm15IG5hbWUgaXMgaW4gJycgbmFtZWQgJycgaW4gJyciLGZ1bmN0aW9uKHNjLCBuYW1lLCBzdHJ1Y3QpCiAgICAgIHBpY2tpbihzdHJ1Y3QsIG5hbWUsIHNjKQogICAgICBhc3NlcnQoWkVOLlRNUC5uYW1lLCAgJ05vIG5hbWUgZm91bmQgaW46ICcuLm5hbWUpCiAgICAgIElhbShPLnRvX3N0cmluZyhvcGVyYXRlX2NvbnZlcnNpb24oWkVOLlRNUCkpKQogICAgICBDT0RFQ1tuYW1lXSA9IG5pbCAtLSBqdXN0IG5hbWUgc3RyaW5nCmVuZCkKCi0tIHZhcmlhYmxlIG5hbWVzOgotLSBzID0gc2NoZW1hIG9mIHZhcmlhYmxlIChvciBlbmNvZGluZykKLS0gbiA9IG5hbWUgb2YgdmFyaWFibGUKLS0gdCA9IHRhYmxlIGNvbnRhaW5pbmcgdGhlIHZhcmlhYmxlCgotLSBUT0RPOiBJIGhhdmUgYSAnJyBhcyAnJwpHaXZlbigiJyciLGZ1bmN0aW9uKG4pCiAgICAgIHBpY2sobikKICAgICAgYWNrKG4pCiAgICAgIGdjKCkKZW5kKQoKR2l2ZW4oIicnIGluICcnIixmdW5jdGlvbihzLCB0KQogICAgICBwaWNraW4odCwgcykKICAgICAgYWNrKHMpIC0tIHNhdmUgaXQgaW4gQUNLLm9iagogICAgICBnYygpCmVuZCkKCi0tIHB1YmxpYyBrZXlzIGZvciBrZXlyaW5nIGFycmF5cwotLSByZXR1cm5zIGEgc3BlY2lhbCBhcnJheSBmb3IgdXBjb21pbmcgc2Vzc2lvbjoKLS0gcHVibGljX2tleV9zZXNzaW9uIDogeyBuYW1lIDogdmFsdWUgfQpHaXZlbigiJycgcHVibGljIGtleSBmcm9tICcnIixmdW5jdGlvbihzLCB0KQogICAgICAtLSBpZiBub3QgcGlja2luKHQsIHMsIG5pbCwgZmFsc2UpIHRoZW4KICAgICAgLS0gCXBpY2tpbihzLCB0KQogICAgICAtLSBlbmQKICAgICAgcGlja2luKHQsIHMuLidfcHVibGljX2tleScsIHMuLidfcHVibGljX2tleScsIGZhbHNlKQogICAgICBhY2tfdGFibGUoJ3B1YmxpY19rZXlfc2Vzc2lvbicsIHQpCmVuZCkKCkdpdmVuKCInJyBmcm9tICcnIixmdW5jdGlvbihzLCB0KQogICAgICAtLSBpZiBub3QgcGlja2luKHQsIHMsIG5pbCwgZmFsc2UpIHRoZW4KICAgICAgLS0gCXBpY2tpbihzLCB0KQogICAgICAtLSBlbmQKICAgICAgcGlja2luKHQsIHMsIHMsIGZhbHNlKQogICAgICBhY2tfdGFibGUocywgdCkKICAgICAgZ2MoKQplbmQpCgpHaXZlbigiJycgbmFtZWQgJyciLGZ1bmN0aW9uKHMsIG4pCiAgICAgIC0tIHplbmNvZGVfYXNzZXJ0KGVuY29kZXIsICJJbnZhbGlkIGlucHV0IGVuY29kaW5nIGZvciAnIi4ubi4uIic6ICIuLnMpCiAgICAgIHBpY2sobiwgcykKICAgICAgYWNrKG4pCiAgICAgIGdjKCkKZW5kKQoKR2l2ZW4oIicnIG5hbWVkIGJ5ICcnIixmdW5jdGlvbihzLCBuKQogICAgICAtLSBsb2NhbCBuYW1lID0gaGF2ZShuKQogICAgICBsb2NhbCBuYW1lID0gX2luZGV4X3RvX3N0cmluZyhJTltuXSkKICAgICAgLS0gemVuY29kZV9hc3NlcnQoZW5jb2RlciwgIkludmFsaWQgaW5wdXQgZW5jb2RpbmcgZm9yICciLi5uLi4iJzogIi4ucykKICAgICAgcGljayhuYW1lLCBzKQogICAgICBhY2sobmFtZSkKICAgICAgZ2MoKQplbmQpCgpHaXZlbigiJycgbmFtZWQgJycgaW4gJyciLGZ1bmN0aW9uKHMsIG4sIHQpCiAgICAgIHBpY2tpbih0LCBuLCBzKQogICAgICBhY2sobikgLS0gc2F2ZSBpdCBpbiBBQ0submFtZQogICAgICBnYygpCmVuZCkKCkdpdmVuKCInJyBuYW1lZCBieSAnJyBpbiAnJyIsZnVuY3Rpb24ocywgbiwgdCkKICAgICAgbG9jYWwgbmFtZSA9IF9pbmRleF90b19zdHJpbmcoSU5bbl0pCiAgICAgIHBpY2tpbih0LCBuYW1lLCBzKQogICAgICBhY2sobmFtZSkgLS0gc2F2ZSBpdCBpbiBBQ0submFtZQogICAgICBnYygpCmVuZCkKCkdpdmVuKCJteSAnJyIsZnVuY3Rpb24obikKICAgICAgemVuY29kZV9hc3NlcnQoV0hPLCAnTm8gaWRlbnRpdHkgc3BlY2lmaWVkLCB1c2U6IEdpdmVuIEkgYW0gLi4uJykKICAgICAgcGlja2luKFdITywgbikKICAgICAgYWNrKG4pCiAgICAgIGdjKCkKZW5kKQoKR2l2ZW4oIm15ICcnIG5hbWVkICcnIixmdW5jdGlvbihzLCBuKQogICAgICAtLSB6ZW5jb2RlX2Fzc2VydChlbmNvZGVyLCAiSW52YWxpZCBpbnB1dCBlbmNvZGluZyBmb3IgJyIuLm4uLiInOiAiLi5zKQogICAgICBwaWNraW4oV0hPLCBuLCBzKQogICAgICBhY2sobikKICAgICAgZ2MoKQplbmQpCkdpdmVuKCJteSAnJyBuYW1lZCBieSAnJyIsZnVuY3Rpb24ocywgbikKICAgICAgLS0gemVuY29kZV9hc3NlcnQoZW5jb2RlciwgIkludmFsaWQgaW5wdXQgZW5jb2RpbmcgZm9yICciLi5uLi4iJzogIi4ucykKICAgICAgbG9jYWwgbmFtZSA9IF9pbmRleF90b19zdHJpbmcoSU5bbl0pCiAgICAgIHBpY2tpbihXSE8sIG5hbWUsIHMpCiAgICAgIGFjayhuYW1lKQogICAgICBnYygpCmVuZCkKCkdpdmVuKCInJyBpcyB2YWxpZCIsZnVuY3Rpb24obikKICAgICAgcGljayhuKQogICAgICBnYygpCmVuZCkKR2l2ZW4oIm15ICcnIGlzIHZhbGlkIixmdW5jdGlvbihuKQogICAgICBwaWNraW4oV0hPLCBuKQogICAgICBnYygpCmVuZCkKCkdpdmVuKCJyZW5hbWUgJycgdG8gJyciLGZ1bmN0aW9uKG9sZCwgbmV3KQogICAgICAgZW1wdHkobmV3KQogICAgICAgaGF2ZShvbGQpCiAgICAgICBBQ0tbbmV3XSA9IEFDS1tvbGRdCiAgICAgICBuZXdfY29kZWMobmV3LCBDT0RFQ1tvbGRdKQogICAgICAgQ09ERUNbbmV3XS5uYW1lID0gbmV3CgogICAgICAgQUNLW29sZF0gPSBuaWwKICAgICAgIENPREVDW29sZF0gPSBuaWwKZW5kKQoKR2l2ZW4oIicnIHBhcnQgb2YgJycgYWZ0ZXIgc3RyaW5nIHByZWZpeCAnJyIsIGZ1bmN0aW9uKGVuYywgc3JjLCBwZnhfbmFtZSkKCQkgbG9jYWwgd2hvbGUgPSBJTltzcmNdCgkJIHplbmNvZGVfYXNzZXJ0KHdob2xlLCAiQ2Fubm90IGZpbmQgJyIgLi4gc3JjIC4uICInIGFueXdoZXJlIChudWxsIHZhbHVlPykiKQoJCSBsb2NhbCBwZnggPSBJTltwZnhfbmFtZV0gb3IgcGZ4X25hbWUKCQkgbG9jYWwgcGxlbiA9ICNwZngKCQkgbG9jYWwgd2xlbiA9ICN3aG9sZQoJCSB6ZW5jb2RlX2Fzc2VydCh3bGVuID4gcGxlbiwgIlN0cmluZyB0b28gc2hvcnQ6ICIKCQkJCQkuLiBzcmMuLiAiKCIuLndsZW4uLiIpIHByZWZpeCgiLi5wbGVuLi4iKSIpCgkJIHplbmNvZGVfYXNzZXJ0KHN0cmluZy5zdWIod2hvbGUsIDEsIHBsZW4pID09IHBmeCwKCQkJCQkiUHJlZml4IG5vdCBmb3VuZCBpbiAiLi5zcmMuLiI6ICIuLnBmeF9uYW1lKQoJCSAtLSBpZiBub3QgY29udiBhbmQgWkVOLnNjaGVtYXNbd2hhdF0gdGhlbiBjb252ID0gd2hhdCBlbmQKCQkgWkVOLlRNUCA9IGd1ZXNzX2NvbnZlcnNpb24oc3RyaW5nLnN1Yih3aG9sZSxwbGVuKzEsd2xlbiksIGVuYykKCQkgWkVOLlRNUC5uYW1lID0gc3JjCgkJIGFjayhzcmMpCgkJIGdjKCkKZW5kKQoKR2l2ZW4oIicnIHBhcnQgb2YgJycgYmVmb3JlIHN0cmluZyBzdWZmaXggJyciLCBmdW5jdGlvbihlbmMsIHNyYywgc2Z4X25hbWUpCgkJIGxvY2FsIHdob2xlID0gSU5bc3JjXQoJCSB6ZW5jb2RlX2Fzc2VydCh3aG9sZSwgIkNhbm5vdCBmaW5kICciIC4uIHNyYyAuLiAiJyBhbnl3aGVyZSAobnVsbCB2YWx1ZT8pIikKCQkgbG9jYWwgc2Z4ID0gSU5bc2Z4X25hbWVdIG9yIHNmeF9uYW1lCgkJIGxvY2FsIHNsZW4gPSAjc2Z4CgkJIGxvY2FsIHdsZW4gPSAjd2hvbGUKCQkgemVuY29kZV9hc3NlcnQod2xlbiA+IHNsZW4sICJTdHJpbmcgdG9vIHNob3J0OiAiCgkJCQkJLi4gc3JjLi4gIigiLi53bGVuLi4iKSBzdWZmaXgoIi4uc2xlbi4uIikiKQoJCSB6ZW5jb2RlX2Fzc2VydChzdHJpbmcuc3ViKHdob2xlLCB3bGVuLXNsZW4rMSwgd2xlbikgPT0gc2Z4LAoJCQkJCSJTdWZmaXggbm90IGZvdW5kIGluICIuLnNyYy4uIjogIi4uc2Z4X25hbWUpCgkJIC0tIGlmIG5vdCBjb252IGFuZCBaRU4uc2NoZW1hc1t3aGF0XSB0aGVuIGNvbnYgPSB3aGF0IGVuZAoJCSBaRU4uVE1QID0gZ3Vlc3NfY29udmVyc2lvbihzdHJpbmcuc3ViKHdob2xlLDEsd2xlbi1zbGVuKSwgZW5jKQoJCSBaRU4uVE1QLm5hbWUgPSBzcmMKCQkgYWNrKHNyYykKCQkgZ2MoKQplbmQpCgpHaXZlbigiJycgaW4gcGF0aCAnJyIsIGZ1bmN0aW9uKGVuYywgcGF0aCkKICAgIGxvY2FsIGVsZV9mcm9tX3BhdGgsIGRlc3QgPSBwaWNrX2Zyb21fcGF0aChwYXRoKQogICAgWkVOLlRNUCA9IGd1ZXNzX2NvbnZlcnNpb24oZWxlX2Zyb21fcGF0aCwgZW5jKQogICAgWkVOLlRNUC5uYW1lID0gZGVzdAogICAgYWNrKGRlc3QpCiAgICBnYygpCmVuZCkKCkdpdmVuKCInJyBwYXJ0IG9mIHBhdGggJycgYWZ0ZXIgc3RyaW5nIHByZWZpeCAnJyIsIGZ1bmN0aW9uKGVuYywgcGF0aCwgcGZ4X25hbWUpCiAgICAgICAgICBsb2NhbCBlbGVfZnJvbV9wYXRoLCBkZXN0ID0gcGlja19mcm9tX3BhdGgocGF0aCkKICAgICAgICAgIGxvY2FsIHBmeCA9IElOW3BmeF9uYW1lXSBvciBwZnhfbmFtZQogICAgICAgICAgbG9jYWwgcGxlbiA9ICNwZngKICAgICAgICAgIGVsZWxlbiA9ICNlbGVfZnJvbV9wYXRoCiAgICAgICAgICB6ZW5jb2RlX2Fzc2VydChlbGVsZW4gPiBwbGVuLCAiU3RyaW5nIHRvbyBzaG9ydDogIgogICAgICAgICAgICAgICAgICAgICAgICAgLi4gcGF0aC4uICIoIi4uZWxlbGVuLi4iKSBwcmVmaXgoIi4ucGxlbi4uIikiKQogICAgICAgICAgemVuY29kZV9hc3NlcnQoc3RyaW5nLnN1YihlbGVfZnJvbV9wYXRoLCAxLCBwbGVuKSA9PSBwZngsCiAgICAgICAgICAgICAgICAgICAgICAgICAiUHJlZml4IG5vdCBmb3VuZCBpbiAiLi5wYXRoLi4iOiAiLi5wZnhfbmFtZSkKICAgICAgICAgIC0tIGlmIG5vdCBjb252IGFuZCBaRU4uc2NoZW1hc1t3aGF0XSB0aGVuIGNvbnYgPSB3aGF0IGVuZAogICAgICAgICAgWkVOLlRNUCA9IGd1ZXNzX2NvbnZlcnNpb24oc3RyaW5nLnN1YihlbGVfZnJvbV9wYXRoLHBsZW4rMSxlbGVsZW4pLCBlbmMpCiAgICAgICAgICBaRU4uVE1QLm5hbWUgPSBkZXN0CiAgICAgICAgICBhY2soZGVzdCkKICAgICAgICAgIGdjKCkKZW5kKQoKCkdpdmVuKCInJyBwYXJ0IG9mIHBhdGggJycgYmVmb3JlIHN0cmluZyBzdWZmaXggJyciLCBmdW5jdGlvbihlbmMsIHBhdGgsIHNmeF9uYW1lKQogICAgICAgICAgbG9jYWwgZWxlX2Zyb21fcGF0aCwgZGVzdCA9IHBpY2tfZnJvbV9wYXRoKHBhdGgpCiAgICAgICAgICBsb2NhbCBzZnggPSBJTltzZnhfbmFtZV0gb3Igc2Z4X25hbWUKICAgICAgICAgIGxvY2FsIHNsZW4gPSAjc2Z4CiAgICAgICAgICBlbGVsZW4gPSAjZWxlX2Zyb21fcGF0aAogICAgICAgICAgemVuY29kZV9hc3NlcnQoZWxlbGVuID4gc2xlbiwgIlN0cmluZyB0b28gc2hvcnQ6ICIKICAgICAgICAgICAgICAgICAgICAgICAgIC4uIHBhdGguLiAiKCIuLmVsZWxlbi4uIikgcHJlZml4KCIuLnNsZW4uLiIpIikKICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KHN0cmluZy5zdWIoZWxlX2Zyb21fcGF0aCwgZWxlbGVuLXNsZW4rMSwgZWxlbGVuKSA9PSBzZngsCiAgICAgICAgICAgICAgICAgICAgICAgICAiU3VmZml4IG5vdCBmb3VuZCBpbiAiLi5wYXRoLi4iOiAiLi5zZnhfbmFtZSkKICAgICAgICAgIC0tIGlmIG5vdCBjb252IGFuZCBaRU4uc2NoZW1hc1t3aGF0XSB0aGVuIGNvbnYgPSB3aGF0IGVuZAogICAgICAgICAgWkVOLlRNUCA9IGd1ZXNzX2NvbnZlcnNpb24oCiAgICAgICAgICAgICAgc3RyaW5nLnN1YihlbGVfZnJvbV9wYXRoLDEsZWxlbGVuLXNsZW4pLCBlbmMpCiAgICAgICAgICBaRU4uVE1QLm5hbWUgPSBkZXN0CiAgICAgICAgICBhY2soZGVzdCkKICAgICAgICAgIGdjKCkKZW5kKQoKCmxvY2FsIGZ1bmN0aW9uIF9kZWVwX3RyYW5zZm9ybSh0LCBwYXRoLCBlbmMpCiAgICBsb2NhbCBjdXJyZW50ID0gdAogICAgbG9jYWwgbnVtcCA8Y29uc3Q+ID0gI3BhdGgKICAgIGZvciBpID0gMSwgbnVtcCAtIDEgZG8KICAgICAgICBsb2NhbCBrZXkgPSBwYXRoW2ldCiAgICAgICAgaWYgdHlwZShjdXJyZW50KSB+PSAidGFibGUiIG9yIGN1cnJlbnRba2V5XSA9PSBuaWwgdGhlbgogICAgICAgICAgICBlcnJvcigiUGF0aCBub3QgZm91bmQgaW46ICIuLnBhdGhbMV0sMikKICAgICAgICBlbmQKICAgICAgICBjdXJyZW50ID0gY3VycmVudFtrZXldCiAgICBlbmQKICAgIGxvY2FsIGZpbmFsX2tleSA9IHBhdGhbbnVtcF0KICAgIGlmIGN1cnJlbnRbZmluYWxfa2V5XSB+PSBuaWwgdGhlbgogICAgICAgIGxvY2FsIHZhbCA8Y29uc3Q+ID0gT0NURVQudG9fc3RyaW5nKGN1cnJlbnRbZmluYWxfa2V5XSkKICAgICAgICBsb2NhbCBlbmNfdCA8Y29uc3Q+ID0gaW5wdXRfZW5jb2RpbmcoZW5jKQogICAgICAgIGlmIGVuY190LmNoZWNrIHRoZW4KICAgICAgICAgICAgaWYgbm90IGVuY190LmNoZWNrKHZhbCkgdGhlbgogICAgICAgICAgICAgICAgZXJyb3IoIkluY29ycmVjdCBlbmNvZGluZyBpbiAiLi5wYXRoWzFdCiAgICAgICAgICAgICAgICAgICAgICAuLiI6IGtleSAnIi4uZmluYWxfa2V5CiAgICAgICAgICAgICAgICAgICAgICAuLiInIGlzIG5vdCBhICIuLmVuY190LmVuY29kaW5nLDIpCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgICAgIGN1cnJlbnRbZmluYWxfa2V5XSA9IGVuY190LmZ1bih2YWwpCiAgICAgICAgcmV0dXJuIHRydWUgIC0tIFN1Y2Nlc3MKICAgIGVuZAogICAgZXJyb3IoIkZpbmFsIGtleSBub3QgZm91bmQ6ICIuLmZpbmFsX2tleSwyKQplbmQKCkdpdmVuKCJkZWNvZGUgZGljdGlvbmFyeSBwYXRoICcnIGFzICcnIiwgZnVuY3Rpb24ocGF0aCxlbmMpCiAgICAgICAgICBsb2NhbCBwYXRoX2FycmF5ID0gc3RydG9rKHVzY29yZShwYXRoKSwgQ09ORi5wYXRoLnNlcGFyYXRvcikKICAgICAgICAgIGxvY2FsIHJvb3QgPGNvbnN0PiA9IHBhdGhfYXJyYXlbMV0KICAgICAgICAgIHRhYmxlLnJlbW92ZShwYXRoX2FycmF5LDEpCiAgICAgICAgICBpZiBub3QgQ09ERUNbcm9vdF0gdGhlbgogICAgICAgICAgICAgIGVycm9yKCJEaWN0aW9uYXJ5IG5vdCBmb3VuZDogIi4ucm9vdCkKICAgICAgICAgIGVuZAogICAgICAgICAgaWYgQ09ERUNbcm9vdF0uemVudHlwZSB+PSAnZCcgdGhlbgogICAgICAgICAgICAgIEkud2FybihDT0RFQ1tyb290XSkKICAgICAgICAgICAgICBlcnJvcigiTm90IGEgZGljdGlvbmFyeTogIi4ucm9vdCkKICAgICAgICAgIGVuZAogICAgICAgICAgaWYgbm90IENPREVDW3Jvb3RdLm1hc2sgdGhlbiBDT0RFQ1tyb290XS5tYXNrID0geyB9IGVuZAogICAgICAgICAgZGVlcG1hc2tfc2V0KENPREVDW3Jvb3RdLm1hc2ssIHBhdGhfYXJyYXksIGVuYykKICAgICAgICAgIF9kZWVwX3RyYW5zZm9ybShBQ0tbcm9vdF0sIHBhdGhfYXJyYXksIGVuYykKZW5kKQovemVuY29kZV9oYXNoLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAxOC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBNb25kYXksIDEzdGggSmFudWFyeSAyMDI1Ci0tXV0KCgotLSBoYXNoaW5nCmxvY2FsIHZhbGlkX2hhc2hlcyA8Y29uc3Q+ID0gewogICAgc2hhMjU2ID0gdHJ1ZSwKICAgIHNoYTUxMiA9IHRydWUsCiAgICBzaGEzXzI1NiA9IHRydWUsCiAgICBzaGEzXzUxMiA9IHRydWUsCiAgICBzaGFrZTI1NiA9IHRydWUsCiAgICBrZWNjYWsyNTYgPSB0cnVlCn0KbG9jYWwgZnVuY3Rpb24gX2hhc2gocywgbiwgZCkKICAgIGxvY2FsIHNyYyA9IGhhdmUocykKICAgIG4gPSBuIG9yIENPTkYuaGFzaAogICAgZCA9IGQgb3IgJ2hhc2gnCiAgICAtLSBzZXJpYWxpemUgdGFibGVzIHVzaW5nIHplbnJvb20ncyBhbGdvCiAgICBpZiBub3QgdmFsaWRfaGFzaGVzW25dIHRoZW4KICAgICAgICBlcnJvcigiSGFzaCBhbGdvcml0aG0gbm90IGtub3duOiAiLi4gbikKICAgIGVuZAogICAgc3JjID0gemVuY29kZV9zZXJpYWxpemUoc3JjKQogICAgLS0gZnJvbSBpbml0OiBIQVNIID0gcmVxdWlyZSgnemVucm9vbV9oYXNoJykKICAgIGxvY2FsIF9oZiA8Y29uc3Q+ID0gSEFTSDppbml0KG4pCiAgICBBQ0tbZF0gPSBfaGY6cHJvY2VzcyhzcmMpCiAgICBuZXdfY29kZWMoZCwgeyB6ZW50eXBlID0gJ2UnIH0pCmVuZAoKV2hlbigiY3JlYXRlIGhhc2ggb2YgJyciLCBfaGFzaCkKV2hlbigiY3JlYXRlIGhhc2ggb2YgJycgdXNpbmcgJyciLCBfaGFzaCkKCi0tIGdsb2JhbCB1c2VkIGJ5IF9taG91dCBhbmQgX21oaW4KbG9jYWwgbXVsdGloYXNoX3ByZWZpeGVzIDxjb25zdD4gPSB7CiAgICBzaGEyNTYgPSBPQ1RFVC5mcm9tX2hleCcxMicsCiAgICBzaGE1MTIgPSBPQ1RFVC5mcm9tX2hleCcxMycsCiAgICBzaGEzXzUxMiA9IE9DVEVULmZyb21faGV4JzE0JywKICAgIHNoYTNfMjU2ID0gT0NURVQuZnJvbV9oZXgnMTYnLAogICAgc2hha2VfMjU2ID0gT0NURVQuZnJvbV9oZXgnMTknLAogICAga2VjY2FrXzI1NiA9IE9DVEVULmZyb21faGV4JzFiJwp9CgotLWh0dHBzOi8vZ2l0aHViLmNvbS9tdWx0aWZvcm1hdHMvbXVsdGljb2RlYy9ibG9iL21hc3Rlci90YWJsZS5jcwpsb2NhbCBmdW5jdGlvbiBfbWhvdXQobiwgb2JqKQogICAgbG9jYWwgX3NpemUgPGNvbnN0PiA9IHsKICAgICAgICBzaGEyNTYgPSBPQ1RFVC5mcm9tX251bWJlcigzMik6Y29weSgxNSwxKSwKICAgICAgICBzaGE1MTIgPSBPQ1RFVC5mcm9tX251bWJlcig2NCk6Y29weSgxNSwxKSwKICAgICAgICBzaGEzXzUxMiA9IE9DVEVULmZyb21fbnVtYmVyKDY0KTpjb3B5KDE1LDEpLAogICAgICAgIHNoYTNfMjU2ID0gT0NURVQuZnJvbV9udW1iZXIoMzIpOmNvcHkoMTUsMSksCiAgICAgICAgc2hha2VfMjU2ID0gT0NURVQuZnJvbV9udW1iZXIoMzIpOmNvcHkoMTUsMSksCiAgICAgICAga2VjY2FrXzI1NiA9IE9DVEVULmZyb21fbnVtYmVyKDMyKTpjb3B5KDE1LDEpCiAgICB9CiAgICBsb2NhbCBwZnggPGNvbnN0PiA9IG11bHRpaGFzaF9wcmVmaXhlc1tuXQogICAgbG9jYWwgc3ogPGNvbnN0PiA9IF9zaXplW25dCiAgICBpZiBub3QgcGZ4IHRoZW4gZXJyb3IoIk11bHRpaGFzaCBub3Qgc3VwcG9ydGVkOiAiLi5uLDIpIGVuZAogICAgaWYgbm90IHN6ICB0aGVuIGVycm9yKCJNdWx0aWhhc2ggbm90IHN1cHBvcnRlZDogIi4ubiwyKSBlbmQKICAgIHJldHVybiBwZnguLnN6Li5vYmoKZW5kCgpsb2NhbCBmdW5jdGlvbiBfbWhpbihzdHJpbmdfb2JqLGhhc2h0eXBlKQogICAgaWYgbm90IHR5cGUoc3RyaW5nX29iaikgPT0gJ3N0cmluZycgdGhlbgogICAgICAgIGVycm9yKCJNdWx0aWhhc2ggaW52YWxpZCBpbnB1dDogIi4udHlwZShzdHJpbmdfb2JqKSwzKQogICAgZW5kCiAgICBsb2NhbCBvYmogPGNvbnN0PiA9IENPTkYuaW5wdXQuZW5jb2RpbmcuZnVuKHN0cmluZ19vYmopCiAgICBsb2NhbCBwcmVmaXhlcyA8Y29uc3Q+ID0gewogICAgICAgIFsnMTInXSA9ICdzaGEyNTYnLAogICAgICAgIFsnMTMnXSA9ICdzaGE1MTInLAogICAgICAgIFsnMTQnXSA9ICdzaGEzXzUxMicsCiAgICAgICAgWycxNiddID0gJ3NoYTNfMjU2JywKICAgICAgICBbJzE5J10gPSAnc2hha2VfMjU2JywKICAgICAgICBbJzFiJ10gPSAna2VjY2FrXzI1NicKICAgIH0KICAgIGxvY2FsIF9wZngKICAgIGxvY2FsIGZpcnN0Ynl0ZSA8Y29uc3Q+ID0gb2JqOmNvcHkoMCwxKQogICAgaWYgaGFzaHR5cGUgdGhlbgogICAgICAgIF9wZnggPSBtdWx0aWhhc2hfcHJlZml4ZXNbaGFzaHR5cGVdCiAgICAgICAgaWYgbm90IF9wZnggdGhlbgogICAgICAgICAgICBlcnJvcigiTXVsdGloYXNoIG5vdCBzdXBwb3J0ZWQ6ICIuLmhhc2h0eXBlLDIpIGVuZAogICAgICAgIGlmIGZpcnN0Ynl0ZSB+PSBfcGZ4IHRoZW4KICAgICAgICAgICAgZXJyb3IoIkluY29ycmVjdCBtdWx0aWhhc2ggZm91bmQ6ICIKICAgICAgICAgICAgICAgICAgLi5maXJzdGJ5dGU6aGV4KCksMikgZW5kCiAgICAgICAgX3BmeCA9IGhhc2h0eXBlCiAgICBlbHNlCiAgICAgICAgX3BmeCA9IHByZWZpeGVzW2ZpcnN0Ynl0ZTpoZXgoKV0KICAgIGVuZAogICAgaWYgbm90IF9wZnggdGhlbgogICAgICAgIGVycm9yKCJNdWx0aWhhc2ggbm90IHN1cHBvcnRlZDogIi4uX3BmeCwyKSBlbmQKICAgIGxvY2FsIHN6IDxjb25zdD4gPSB0b251bWJlcihvYmo6Y29weSgxLDEpOmhleCgpLDE2KQogICAgaWYgI29iaiB+PSBzeisyIHRoZW4KICAgICAgICBlcnJvcigiTXVsdGloYXNoIGludmFsaWQgc2l6ZTogIi4uI29iaiwyKSBlbmQKICAgIC0tIHJldHVybiBhZGRpdGlvbmFsIHBhcmFtcyBmb3IgdGhlIGNvZGVjCiAgICByZXR1cm4gb2JqOmNvcHkoMixzeiksIHtzY2hlbWE9J211bHRpaGFzaF8nLi5fcGZ4fQplbmQKClpFTjphZGRfc2NoZW1hKHsKICAgICAgICBtdWx0aWhhc2ggPSB7CiAgICAgICAgICAgIGltcG9ydD1mdW5jdGlvbihvYmopIHJldHVybiBfbWhpbihvYmopIGVuZCwKICAgICAgICAgICAgZXhwb3J0PWZ1bmN0aW9uKG9iaikKICAgICAgICAgICAgICAgIGVycm9yKCJJbnZhbGlkIG11bHRpaGFzaCB2YWx1ZSIsMikgZW5kCiAgICAgICAgfSwKICAgICAgICBtdWx0aWhhc2hfc2hhMjU2ICAgPXsKICAgICAgICAgICAgaW1wb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taGluKG9iaiwnc2hhMjU2JykgZW5kLAogICAgICAgICAgICBleHBvcnQ9ZnVuY3Rpb24ob2JqKSByZXR1cm4gX21ob3V0KCdzaGEyNTYnLG9iaikgZW5kCiAgICAgICAgfSwKICAgICAgICBtdWx0aWhhc2hfc2hhNTEyICAgPXsKICAgICAgICAgICAgaW1wb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taGluKG9iaiwnc2hhNTEyJykgZW5kLAogICAgICAgICAgICBleHBvcnQ9ZnVuY3Rpb24ob2JqKSByZXR1cm4gX21ob3V0KCdzaGE1MTInLG9iaikgZW5kCiAgICAgICAgfSwKICAgICAgICBtdWx0aWhhc2hfc2hhM18yNTYgPXsKICAgICAgICAgICAgaW1wb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taGluKG9iaiwnc2hhM18yNTYnKSBlbmQsCiAgICAgICAgICAgIGV4cG9ydD1mdW5jdGlvbihvYmopIHJldHVybiBfbWhvdXQoJ3NoYTNfMjU2JyxvYmopIGVuZAogICAgICAgIH0sCiAgICAgICAgbXVsdGloYXNoX3NoYTNfNTEyID17CiAgICAgICAgICAgIGltcG9ydD1mdW5jdGlvbihvYmopIHJldHVybiAgX21oaW4ob2JqLCdzaGEzXzUxMicpIGVuZCwKICAgICAgICAgICAgZXhwb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taG91dCgnc2hhM181MTInLG9iaikgZW5kCiAgICAgICAgfSwKICAgICAgICBtdWx0aWhhc2hfc2hha2UyNTYgPXsKICAgICAgICAgICAgaW1wb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taGluKG9iaiwnc2hha2VfMjU2JykgZW5kLAogICAgICAgICAgICBleHBvcnQ9ZnVuY3Rpb24ob2JqKSByZXR1cm4gX21ob3V0KCdzaGFrZV8yNTYnLG9iaikgZW5kCiAgICAgICAgfSwKICAgICAgICBtdWx0aWhhc2hfa2VjY2FrMjU2PXsKICAgICAgICAgICAgaW1wb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taGluKG9iaiwna2VjY2FrXzI1NicpIGVuZCwKICAgICAgICAgICAgZXhwb3J0PWZ1bmN0aW9uKG9iaikgcmV0dXJuIF9taG91dCgna2VjY2FrXzI1Nicsb2JqKSBlbmQKICAgICAgICB9Cn0pCldoZW4oImNyZWF0ZSBtdWx0aWhhc2ggb2YgJyciLAogICAgIGZ1bmN0aW9uKHMpCiAgICAgICAgIF9oYXNoKHMsbmlsLCdtdWx0aWhhc2gnKQogICAgICAgICBDT0RFQ1snbXVsdGloYXNoJ10uc2NoZW1hID0gJ211bHRpaGFzaF8nLi5DT05GLmhhc2gKZW5kKQpXaGVuKCJjcmVhdGUgbXVsdGloYXNoIG9mICcnIHVzaW5nICcnIiwKICAgICBmdW5jdGlvbihzLCBuKQogICAgICAgICBfaGFzaChzLCBuLCdtdWx0aWhhc2gnKQogICAgICAgICBDT0RFQ1snbXVsdGloYXNoJ10uc2NoZW1hID0gJ211bHRpaGFzaF8nLi5uCmVuZCkKCldoZW4oImNyZWF0ZSBoYXNoIHRvIHBvaW50ICcnIG9mICcnIixmdW5jdGlvbihjdXJ2ZSwgb2JqZWN0KQogICAgbG9jYWwgRiA9IF9HW2N1cnZlXQogICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgICAgIGx1YXR5cGUoRi5oYXNodG9wb2ludCkgPT0gJ2Z1bmN0aW9uJywKICAgICAgICAgICAgJ0hhc2ggdHlwZSAnIC4uIGN1cnZlIC4uICcgaXMgaW52YWxpZCAobm8gaGFzaHRvcG9pbnQpJwogICAgKQogICAgZW1wdHknaGFzaF90b19wb2ludCcKICAgIGxvY2FsIG9iaiA9IGhhdmUob2JqZWN0KQogICAgQUNLLmhhc2hfdG9fcG9pbnQgPSBGLmhhc2h0b3BvaW50KHplbmNvZGVfc2VyaWFsaXplKG9iaikpCiAgICBuZXdfY29kZWMoJ2hhc2hfdG9fcG9pbnQnLCB7IHplbnR5cGU9J2UnIH0pCmVuZCkKCldoZW4oImNyZWF0ZSBoYXNoZXMgb2YgZWFjaCBvYmplY3QgaW4gJyciLGZ1bmN0aW9uKGFycikKICAgICAgICBsb2NhbCBBID0gaGF2ZShhcnIpCiAgICAgICAgbG9jYWwgY291bnQgPSBpc2FycmF5KEEpCiAgICAgICAgemVuY29kZV9hc3NlcnQoY291bnQgPiAwLCAnT2JqZWN0IGlzIG5vdCBhbiBhcnJheTogJyAuLiBhcnIpCiAgICAgICAgQUNLLmhhc2hlcyA9IGRlZXBtYXAoc2hhMjU2LCBBKQoJbmV3X2NvZGVjKCdoYXNoZXMnLCB7emVudHlwZT0nYScgfSkKICAgIGVuZAopCgotLSBITUFDIGZyb20gUkZDMjEwNC4KV2hlbigiY3JlYXRlIEhNQUMgb2YgJycgd2l0aCBrZXkgJyciLGZ1bmN0aW9uKG9iaiwga2V5KQogICAgICAgIGxvY2FsIHNyYyA9IGhhdmUob2JqKQogICAgICAgIGlmIGx1YXR5cGUoc3JjKSA9PSAndGFibGUnIHRoZW4KICAgICAgICAgICAgc3JjID0gemVuY29kZV9zZXJpYWxpemUoc3JjKQogICAgICAgIGVuZAogICAgICAgIGxvY2FsIGhrZXkgPSBoYXZlKGtleSkKICAgICAgICAtLSBzdGF0aWMgaW50IGhhc2hfaG1hYyhsdWFfU3RhdGUgKkwpIHsKICAgICAgICAtLSAgICAgaGFzaCAqaCAgID0gaGFzaF9hcmcoTCwxKTsKICAgICAgICAtLSAgICAgb2N0ZXQgKmsgID0gb19hcmcoTCwgMik7CiAgICAgICAgLS0gICAgIG9jdGV0ICppbiA9IG9fYXJnKEwsIDMpOwogICAgICAgIEFDSy5ITUFDID0gSEFTSC5uZXcoQ09ORi5oYXNoKTpobWFjKGhrZXksIHNyYykKCW5ld19jb2RlYygnSE1BQycsIHsgemVudHlwZSA9ICdlJyB9KQogICAgZW5kCikKCldoZW4oImNyZWF0ZSBrZXkgZGVyaXZhdGlvbiBvZiAnJyIsZnVuY3Rpb24ob2JqKQogICAgICAgIGxvY2FsIHNyYyA9IGhhdmUob2JqKQogICAgICAgIGlmIGx1YXR5cGUoc3JjKSA9PSAndGFibGUnIHRoZW4KICAgICAgICAgICAgc3JjID0gemVuY29kZV9zZXJpYWxpemUoc3JjKQogICAgICAgIGVuZAogICAgICAgIEFDSy5rZXlfZGVyaXZhdGlvbiA9IEhBU0gubmV3KENPTkYuaGFzaCk6a2RmKHNyYykKCW5ld19jb2RlYygna2V5X2Rlcml2YXRpb24nLCB7IHplbnR5cGUgPSAnZScgfSkKICAgIGVuZAopCgpXaGVuKCJjcmVhdGUga2V5IGRlcml2YXRpb25zIG9mIGVhY2ggb2JqZWN0IGluICcnIixmdW5jdGlvbih0YWIpCiAgICAgICAgbG9jYWwgdCA9IGhhdmUodGFiKQogICAgICAgIHplbmNvZGVfYXNzZXJ0KGx1YXR5cGUodCkgPT0gJ3RhYmxlJywgJ09iamVjdCBpcyBub3QgYSB0YWJsZTogJyAuLiB0YWIpCiAgICAgICAgQUNLLmtleV9kZXJpdmF0aW9ucyA9CgkgICAgZGVlcG1hcCgKCQlmdW5jdGlvbih2KQoJCSAgICByZXR1cm4gSEFTSC5uZXcoQ09ORi5oYXNoKTprZGYodikKCQllbmQsCgkJdCkKCSBuZXdfY29kZWMoJ2tleSBkZXJpdmF0aW9ucycsIHt6ZW50eXBlID0gQ09ERUNbdGFiXS56ZW50eXBlfSkKICAgIGVuZAopCgpsb2NhbCBmdW5jdGlvbiBfcGJrZGYyX2Yoc3JjLCBwYXNzLCBuKQogICAgaWYgbHVhdHlwZShzcmMpID09ICd0YWJsZScgdGhlbgoJICAgIHNyYyA9IHplbmNvZGVfc2VyaWFsaXplKHNyYykKICAgIGVuZAogICAgQUNLLmtleV9kZXJpdmF0aW9uID0KCUhBU0gubmV3KCdzaGE1MTInKTpwYmtkZjIoc3JjLAoJCQkJICB7c2FsdCA9IHBhc3MsCgkJCQkgICBpdGVyYXRpb25zID0gbiwKCQkJCSAgIGxlbmd0aCA9IDMyfSkKICAgIG5ld19jb2RlYygna2V5IGRlcml2YXRpb24nLCB7IHplbnR5cGUgPSAnZScgfSkKZW5kCgpXaGVuKCJjcmVhdGUga2V5IGRlcml2YXRpb24gb2YgJycgd2l0aCBwYXNzd29yZCAnJyIsZnVuY3Rpb24ob2JqLCBzYWx0KQoJX3Bia2RmMl9mKGhhdmUob2JqKSwgaGF2ZShzYWx0KSwgNTAwMCkKICAgIGVuZAopCgpXaGVuKCJjcmVhdGUga2V5IGRlcml2YXRpb24gb2YgJycgd2l0aCAnJyByb3VuZHMiLGZ1bmN0aW9uKG9iaiwgaXRlcikKCWxvY2FsIG4gPSB0b251bWJlcihpdGVyKSBvciB0b251bWJlcih0b3N0cmluZyhoYXZlKGl0ZXIpKSkKCV9wYmtkZjJfZihoYXZlKG9iaiksIG5pbCwgbikKICAgIGVuZAopCgpXaGVuKCJjcmVhdGUga2V5IGRlcml2YXRpb24gb2YgJycgd2l0aCAnJyByb3VuZHMgd2l0aCBwYXNzd29yZCAnJyIsZnVuY3Rpb24ob2JqLCBpdGVyLCBzYWx0KQoJbG9jYWwgbiA9IHRvbnVtYmVyKGl0ZXIpIG9yIHRvbnVtYmVyKHRvc3RyaW5nKGhhdmUoaXRlcikpKQoJX3Bia2RmMl9mKGhhdmUob2JqKSwgaGF2ZShzYWx0KSwgbikKICAgIGVuZAopCi96ZW5jb2RlX2h0dHAubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIxLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFNhdHVyZGF5LCAyN3RoIE5vdmVtYmVyIDIwMjEKLS1dXQoKbG9jYWwgX1VOUkVTRVJWRUQgPSAiQS1aYS16MC05JS0uX34iCmxvY2FsIF9HRU5fREVMSU1TID0gIjovPyMlWyVdQCIKbG9jYWwgX1NVQl9ERUxJTVMgPSAiISQmJygpKissOz0iCmxvY2FsIF9SRVNFUlZFRCA9IF9HRU5fREVMSU1TIC4uIF9TVUJfREVMSU1TCmxvY2FsIF9SRUdfTkFNRSA9ICJeWyIgLi4gX1VOUkVTRVJWRUQgLi4gIiUlIiAuLiBfU1VCX0RFTElNUyAuLiAiXSokIgpsb2NhbCBfSVBfRlVUVVJFX0xJVEVSQUwgPSAiXnZbMC05QS1GYS1mXSslLiIgLi4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIlsiIC4uIF9VTlJFU0VSVkVEIC4uIF9TVUJfREVMSU1TIC4uICJdKyQiCgpsb2NhbCBmdW5jdGlvbiBfbm9ybWFsaXplX3BlcmNlbnRfZW5jb2RpbmcgKHMpCiAgICBpZiBzOmZpbmQoIiUlJCIpIG9yIHM6ZmluZCgiJSUuJCIpIHRoZW4KICAgICAgICBlcnJvcigidW5maW5pc2hlZCBwZXJjZW50IGVuY29kaW5nIGF0IGVuZCBvZiBVUkkgJyIgLi4gcyAuLiAiJyIpCiAgICBlbmQKICAgIHJldHVybiBzOmdzdWIoIiUlKC4uKSIsIGZ1bmN0aW9uIChoZXgpCiAgICAgICAgaWYgbm90IGhleDpmaW5kKCJeWzAtOUEtRmEtZl1bMC05QS1GYS1mXSQiKSB0aGVuCiAgICAgICAgICAgIGVycm9yKCJpbnZhbGlkIHBlcmNlbnQgZW5jb2RpbmcgJyUiIC4uIGhleCAuLgogICAgICAgICAgICAgICAgICAiJyBpbiBVUkkgJyIgLi4gcyAuLiAiJyIpCiAgICAgICAgZW5kCiAgICAgICAgLS0gTmV2ZXIgcGVyY2VudC1lbmNvZGUgdW5yZXNlcnZlZCBjaGFyYWN0ZXJzLCBhbmQgYWx3YXlzIHVzZSB1cHBlcmNhc2UKICAgICAgICAtLSBoZXhhZGVjaW1hbCBmb3IgcGVyY2VudCBlbmNvZGluZy4gIFJGQyAzOTg2IHNlY3Rpb24gNi4yLjIuMi4KICAgICAgICBsb2NhbCBjaGFyID0gc3RyaW5nLmNoYXIodG9udW1iZXIoIjB4IiAuLiBoZXgpKQogICAgICAgIHJldHVybiBjaGFyOmZpbmQoIl5bIiAuLiBfVU5SRVNFUlZFRCAuLiAiXSIpIGFuZCBjaGFyIG9yICIlIiAuLiBoZXg6dXBwZXIoKQogICAgZW5kKQplbmQKCmxvY2FsIGZ1bmN0aW9uIF90b19wZXJjZW50X2VuY29kaW5nKHMpCiAgICAtLSBwZXJjZW50LWVuY29kZSBhbGwgbm9uLXVucmVzZXJ2ZWQgY2hhcmFjdGVycyAoZXhjZXB0IHNwYWNlcykKICAgIGxvY2FsIHN0ciA9IHM6Z3N1YigiKFteJXclLSUuJV8lfiBdKSIsIGZ1bmN0aW9uIChjaGFyKQogICAgICAgICAgICAgICAgICAgICAgICAgICAgIHJldHVybiBzdHJpbmcuZm9ybWF0KCIlJSUwMlgiLCBzdHJpbmcuYnl0ZShjaGFyKSkKICAgIGVuZCkKICAgIC0tIHNwYWNlcyB0byBwbHVzIHNpZ25zCiAgICByZXR1cm4gc3RyOmdzdWIoIiAiLCAiKyIpCmVuZAoKbG9jYWwgZnVuY3Rpb24gX2lzX2lwNF9saXRlcmFsIChzKQogICAgaWYgbm90IHM6ZmluZCgiXlswLTldKyUuWzAtOV0rJS5bMC05XSslLlswLTldKyQiKSB0aGVuIHJldHVybiBmYWxzZSBlbmQKCiAgICBmb3IgZGVjX29jdGV0IGluIHM6Z21hdGNoKCJbMC05XSsiKSBkbwogICAgICAgIGlmIGRlY19vY3RldDpsZW4oKSA+IDMgb3IgZGVjX29jdGV0OmZpbmQoIl4wLiIpIG9yCiAgICAgICAgICAgdG9udW1iZXIoZGVjX29jdGV0KSA+IDI1NSB0aGVuCiAgICAgICAgICAgIHJldHVybiBmYWxzZQogICAgICAgIGVuZAogICAgZW5kCgogICAgcmV0dXJuIHRydWUKZW5kCgpsb2NhbCBmdW5jdGlvbiBfaXNfaXA2X2xpdGVyYWwgKHMpCiAgICBsb2NhbCBoYWRfZWxpcHNpcyA9IGZhbHNlICAgICAgIC0tIHRydWUgd2hlbiAnOjonIGZvdW5kCiAgICBsb2NhbCBudW1fY2h1bmtzID0gMAogICAgd2hpbGUgcyB+PSAiIiBkbwogICAgICAgIG51bV9jaHVua3MgPSBudW1fY2h1bmtzICsgMQogICAgICAgIGxvY2FsIHAxLCBwMiA9IHM6ZmluZCgiOjo/IikKICAgICAgICBsb2NhbCBjaHVuawogICAgICAgIGlmIHAxIHRoZW4KICAgICAgICAgICAgY2h1bmsgPSBzOnN1YigxLCBwMSAtIDEpCiAgICAgICAgICAgIHMgPSBzOnN1YihwMiArIDEpCiAgICAgICAgICAgIGlmIHAyIH49IHAxIHRoZW4gICAgLS0gZm91bmQgJzo6JwogICAgICAgICAgICAgICAgaWYgaGFkX2VsaXBzaXMgdGhlbiByZXR1cm4gZmFsc2UgZW5kICAgIC0tIHR3byBvZiAnOjonCiAgICAgICAgICAgICAgICBoYWRfZWxpcHNpcyA9IHRydWUKICAgICAgICAgICAgICAgIGlmIGNodW5rID09ICIiIHRoZW4gbnVtX2NodW5rcyA9IG51bV9jaHVua3MgLSAxIGVuZAogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICBpZiBjaHVuayA9PSAiIiB0aGVuIHJldHVybiBmYWxzZSBlbmQgICAgLS0gJzonIGF0IHN0YXJ0CiAgICAgICAgICAgICAgICBpZiBzID09ICIiIHRoZW4gcmV0dXJuIGZhbHNlIGVuZCAgICAgICAgLS0gJzonIGF0IGVuZAogICAgICAgICAgICBlbmQKICAgICAgICBlbHNlCiAgICAgICAgICAgIGNodW5rID0gcwogICAgICAgICAgICBzID0gIiIKICAgICAgICBlbmQKCiAgICAgICAgLS0gQ2h1bmsgaXMgbmVpdGhlciA0LWRpZ2l0IGhleCBudW0sIG5vciBJUHY0YWRkcmVzcyBpbiBsYXN0IGNodW5rLgogICAgICAgIGlmIChub3QgY2h1bms6ZmluZCgiXlswLTlhLWZdKyQiKSBvciBjaHVuazpsZW4oKSA+IDQpIGFuZAogICAgICAgICAgIChzIH49ICIiIG9yIG5vdCBfaXNfaXA0X2xpdGVyYWwoY2h1bmspKSBhbmQKICAgICAgICAgICBjaHVuayB+PSAiIiB0aGVuCiAgICAgICAgICAgIHJldHVybiBmYWxzZQogICAgICAgIGVuZAoKICAgICAgICAtLSBJUHY0YWRkcmVzcyBpbiBsYXN0IHBvc2l0aW9uIGNvdW50cyBmb3IgdHdvIGNodW5rcyBvZiBoZXggZGlnaXRzLgogICAgICAgIGlmIGNodW5rOmxlbigpID4gNCB0aGVuIG51bV9jaHVua3MgPSBudW1fY2h1bmtzICsgMSBlbmQKICAgIGVuZAoKICAgIGlmIGhhZF9lbGlwc2lzIHRoZW4KICAgICAgICBpZiBudW1fY2h1bmtzID4gNyB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgIGVsc2UKICAgICAgICBpZiBudW1fY2h1bmtzIH49IDggdGhlbiByZXR1cm4gZmFsc2UgZW5kCiAgICBlbmQKCiAgICByZXR1cm4gdHJ1ZQplbmQKCmxvY2FsIGZ1bmN0aW9uIF9pc192YWxpZF9ob3N0IChob3N0KQogICBpZiBzdHJpbmcuZmluZChob3N0LCJeJVsuKiVdJCIpIHRoZW4KICAgICAgbG9jYWwgaXBfbGl0ZXJhbCA9IGhvc3Q6c3ViKDIsIC0yKQogICAgICBpZiBpcF9saXRlcmFsOmZpbmQoIl52IikgdGhlbgoJIGlmIG5vdCBpcF9saXRlcmFsOmZpbmQoX0lQX0ZVVFVSRV9MSVRFUkFMKSB0aGVuCgkgICAgcmV0dXJuICJpbnZhbGlkIElQdkZ1dHVyZSBsaXRlcmFsICciIC4uIGlwX2xpdGVyYWwgLi4gIiciCgkgZW5kCiAgICAgIGVsc2UKCSBpZiBub3QgX2lzX2lwNl9saXRlcmFsKGlwX2xpdGVyYWwpIHRoZW4KCSAgICByZXR1cm4gImludmFsaWQgSVB2NiBhZGRyZXNzICciIC4uIGlwX2xpdGVyYWwgLi4gIiciCgkgZW5kCiAgICAgIGVuZAogICBlbHNlaWYgbm90IF9pc19pcDRfbGl0ZXJhbChob3N0KSBhbmQgbm90IGhvc3Q6ZmluZChfUkVHX05BTUUpIHRoZW4KICAgICAgcmV0dXJuICJpbnZhbGlkIGhvc3QgdmFsdWUgJyIgLi4gaG9zdCAuLiAiJyIKICAgZW5kCiAgIHJldHVybiBuaWwKZW5kCgpmdW5jdGlvbiBpc192YWxpZF91cmkodXJpKQogICAgbG9jYWwgcGFyc2VkID0ge30KICAgIGxvY2FsIHVyaV9wYXR0ZXJuID0KICAgICAgICAiXiglYVsldysuLV0qKToiIC4uICAgICAgICAgLS0gU2NoZW1lCiAgICAgICAgIi8vKFteLz8jXSopIiAuLiAgICAgICAgICAgIC0tIEF1dGhvcml0eQogICAgICAgICIoW14/I10qKSIgLi4gICAgICAgICAgICAgICAtLSBQYXRoCiAgICAgICAgIiUlPyhbXiNdKikiIC4uICAgICAgICAgICAgIC0tIFF1ZXJ5CiAgICAgICAgIiM/KC4qKSIgICAgICAgICAgICAgICAgICAgIC0tIEZyYWdtZW50CiAgICBwYXJzZWQuc2NoZW1lLCBwYXJzZWQuYXV0aG9yaXR5LCBwYXJzZWQucGF0aCwgcGFyc2VkLnF1ZXJ5LCBwYXJzZWQuZnJhZ21lbnQgPSB1cmk6c3RyKCk6bWF0Y2godXJpX3BhdHRlcm4pCiAgICBpZiBwYXJzZWQuc2NoZW1lID09ICIiIHRoZW4KICAgICAgICBlcnJvcigiaW52YWxpZCB1cmksIG1pc3Npbmcgc2NoZW1lIGluICciIC4uIHVyaSAuLiAiJyIsIDIpCiAgICBlbmQKICAgIGlmIHBhcnNlZC5hdXRob3JpdHkgfj0gIiIgdGhlbgogICAgICAgIGxvY2FsIGF1dGhvcml0eV9wYXR0ZXJuID0gIl4oW146XSspOj8oJWQqKSQiCiAgICAgICAgcGFyc2VkLmhvc3RuYW1lLCBwYXJzZWQucG9ydCA9IHBhcnNlZC5hdXRob3JpdHk6bWF0Y2goYXV0aG9yaXR5X3BhdHRlcm4pCiAgICAgICAgaWYgcGFyc2VkLnBvcnQgfj0gIiIgYW5kIG5vdCB0b251bWJlcihwYXJzZWQucG9ydCkgdGhlbgogICAgICAgICAgICBlcnJvcigiaW52YWxpZCBwb3J0IGluICciIC4uIHBhcnNlZC5hdXRob3JpdHkgLi4gIiciLCAyKQogICAgICAgIGVuZAogICAgICAgIGxvY2FsIGhvc3RfZXJyb3IgPSBfaXNfdmFsaWRfaG9zdChwYXJzZWQuaG9zdG5hbWUpCiAgICAgICAgaWYgaG9zdF9lcnJvciB0aGVuCiAgICAgICAgICAgIGVycm9yKGhvc3RfZXJyb3IsIDIpCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiBwYXJzZWQKZW5kCgpXaGVuKCJjcmVhdGUgdXJsIGZyb20gJyciLCBmdW5jdGlvbihzcmMpCiAgICBsb2NhbCBvYmogPSBoYXZlKHNyYykKICAgIGlzX3ZhbGlkX3VyaShvYmopCiAgICBlbXB0eSd1cmwnCiAgICBBQ0sudXJsID0gb2JqCiAgICBuZXdfY29kZWMoJ3VybCcse3plbnR5cGU9J2UnLGNvbnRlbnQ9J3VybCcsIGVuY29kaW5nPSdzdHJpbmcnfSkKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX2FwcGVuZF90b191cmwoZWxlLCBkc3QsIGVuY29kaW5nX2YpCiAgICBsb2NhbCBhcmcsIGFyZ19jID0gaGF2ZShlbGUpCiAgICBsb2NhbCB1cmwsIHVybF9jID0gaGF2ZShkc3QpCiAgICBpZiB1cmxfYy5jb250ZW50IH49ICd1cmwnIHRoZW4KICAgICAgICBlcnJvcigiQ2Fubm90IGFwcGVuZCBodHRwIHJlcXVlc3QgdG8gaW52YWxpZCB1cmw6ICIuLmRzdCwgMikKICAgIGVuZAogICAgaWYgbHVhdHlwZShhcmcpID09ICd0YWJsZScgdGhlbgogICAgICAgIGVycm9yKCJDYW5ub3QgYXBwZW5kIHRhYmxlIHRvIHVybDogIi4uZHN0LCAyKQogICAgZW5kCiAgICBsb2NhbCBzZXBhcmF0b3IgPSBmaWYoIHVybDpzdHIoKTpmaW5kKCc/JyksICcmJywgJz8nICkKICAgIGxvY2FsIHR2ID0gdHlwZShhcmcpCiAgICBpZiB0diA9PSAnemVucm9vbS50aW1lJyBvciB0diA9PSAnemVucm9vbS5iaWcnIG9yIHR2ID09ICd6ZW5yb29tLmZsb2F0JyB0aGVuCiAgICAgICAgYXJnID0gdG9zdHJpbmcoYXJnKQogICAgZWxzZWlmIHR2ID09ICd6ZW5yb29tLm9jdGV0JyB0aGVuCiAgICAgICAgYXJnID0gYXJnOnN0cigpCiAgICBlbHNlCiAgICAgICAgZXJyb3IoIlVuZXhwZWN0ZWQgdmFsdWUgdHlwZSAnIi4udHYuLiInIGZvciAiLi5lbGUsIDIpCiAgICBlbmQKICAgIEFDS1tkc3RdID0gTy5mcm9tX3N0cmluZyh1cmw6c3RyKCkgLi4gc2VwYXJhdG9yIC4uCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZW5jb2RpbmdfZihlbGUpCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgLi4gJz0nIC4uCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgZW5jb2RpbmdfZihhcmcpCiAgICApCmVuZAoKV2hlbigiYXBwZW5kICcnIGFzIGh0dHAgcmVxdWVzdCB0byAnJyIsIGZ1bmN0aW9uKGVsZSwgZHN0KQogICAgX2FwcGVuZF90b191cmwoZWxlLCBkc3QsIF9ub3JtYWxpemVfcGVyY2VudF9lbmNvZGluZykKZW5kKQoKV2hlbigiYXBwZW5kIHBlcmNlbnQgZW5jb2Rpbmcgb2YgJycgYXMgaHR0cCByZXF1ZXN0IHRvICcnIiwgZnVuY3Rpb24oZWxlLCBkc3QpCiAgICBfYXBwZW5kX3RvX3VybChlbGUsIGRzdCwgX3RvX3BlcmNlbnRfZW5jb2RpbmcpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9nZXRfcGFyYW1ldGVyc19mcm9tX3RhYmxlKHRhYmxlX3BhcmFtcywgZW5jb2RpbmdfZikKICAgIGVtcHR5KCdodHRwX2dldF9wYXJhbWV0ZXJzJykKICAgIGxvY2FsIHBhcmFtcywgcGFyYW1zX2MgPSBoYXZlKHRhYmxlX3BhcmFtcykKICAgIGlmKHBhcmFtc19jLnplbnR5cGUgfj0gJ2QnKSB0aGVuCiAgICAgICAgZXJyb3IoIkV4cGVjdGVkIGRpY3Rpb25hcnksIGZvdW5kICIuLnBhcmFtc19jLnplbnR5cGUuLiIgZm9yICIuLnRhYmxlX3BhcmFtcywgMikKICAgIGVuZAogICAgaWYoIHBhcmFtc19jLmVuY29kaW5nIH49ICdzdHJpbmcnIGFuZCBwYXJhbXNfYy5lbmNvZGluZyB+PSAnZmxvYXQnIGFuZAogICAgICAgIHBhcmFtc19jLmVuY29kaW5nIH49ICdpbnRlZ2VyJyBhbmQgcGFyYW1zX2MuZW5jb2Rpbmcgfj0gJ3RpbWUnKSB0aGVuCiAgICAgICAgZXJyb3IoIlBhcmFtZXRlcnMgaW4gIi4udGFibGVfcGFyYW1zLi4iIG11c3QgYmUgb2YgdHlwZSAnc3RyaW5nJywgJ2Zsb2F0JywgJ2ludGVnZXInIG9yICd0aW1lJyIsIDIpCiAgICBlbmQKICAgIGxvY2FsIHJlcyA9ICIiCiAgICBmb3Igayx2IGluIHBhaXJzKHBhcmFtcykgZG8KICAgICAgICBsb2NhbCB0diA9IHR5cGUodikKICAgICAgICBpZiB0diA9PSAnemVucm9vbS50aW1lJyBvciB0diA9PSAnemVucm9vbS5iaWcnIG9yIHR2ID09ICd6ZW5yb29tLmZsb2F0JyB0aGVuCiAgICAgICAgICAgIHYgPSB0b3N0cmluZyh2KQogICAgICAgIGVsc2VpZiB0diA9PSAnemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgICAgICB2ID0gdjpzdHIoKQogICAgICAgIGVsc2UKICAgICAgICAgICAgZXJyb3IoIlVuZXhwZWN0ZWQgdmFsdWUgdHlwZSAnIi4udHYuLiInIGluICIuLnRhYmxlX3BhcmFtcywgMikKICAgICAgICBlbmQKICAgICAgICByZXMgPSByZXMuLmVuY29kaW5nX2YoaykuLiI9Ii4uZW5jb2RpbmdfZih2KS4uIiYiCiAgICBlbmQKICAgIGlmICNyZXMgPiAxIHRoZW4gcmVzID0gcmVzOnN1YigxLCAtMikgZW5kCiAgICBBQ0suaHR0cF9nZXRfcGFyYW1ldGVycyA9IE8uZnJvbV9zdHJpbmcocmVzKQogICAgbmV3X2NvZGVjKCdodHRwX2dldF9wYXJhbWV0ZXJzJywgeyB6ZW50eXBlID0gJ2UnLCBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCmVuZAoKV2hlbigiY3JlYXRlIGh0dHAgZ2V0IHBhcmFtZXRlcnMgZnJvbSAnJyIsIGZ1bmN0aW9uKHRhYmxlX3BhcmFtcykKICAgIF9nZXRfcGFyYW1ldGVyc19mcm9tX3RhYmxlKHRhYmxlX3BhcmFtcywgX25vcm1hbGl6ZV9wZXJjZW50X2VuY29kaW5nKQplbmQpCgpXaGVuKCJjcmVhdGUgaHR0cCBnZXQgcGFyYW1ldGVycyBmcm9tICcnIHVzaW5nIHBlcmNlbnQgZW5jb2RpbmciLCBmdW5jdGlvbih0YWJsZV9wYXJhbXMpCiAgICBfZ2V0X3BhcmFtZXRlcnNfZnJvbV90YWJsZSh0YWJsZV9wYXJhbXMsIF90b19wZXJjZW50X2VuY29kaW5nKQplbmQpCi96ZW5jb2RlX2p3ay5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjEtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBNYXR0ZW8gQ3Jpc3Rpbm8KLS1vbiBUaHVyc2RheSwgMjZ0aCBTZXB0ZW1iZXIgMjAyNAotLV1dCgpsb2NhbCBXM0MgPSByZXF1aXJlX29uY2UgImNyeXB0b193M2MiCgotLWZvciByZWZlcmVuY2Ugb24gSlNPTiBXZWIgS2V5IHNlZSBSRkM3NTE3Ci0tIFRPRE86IGltcGxlbWVudCBqd2sgZm9yIG90aGVyIHByaXZhdGUvcHVibGljIGtleXMKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X2p3ayhvYmopCiAgICB6ZW5jb2RlX2Fzc2VydChvYmoua3R5LCAiVGhlIGlucHV0IGlzIG5vdCBhIHZhbGlkIEpTT04gV2ViIEtleSwgbWlzc2luZyBrdHkiKQogICAgLS0gemVuY29kZV9hc3NlcnQob2JqLmt0eSA9PSAiRUMiLCAia3R5IG11c3QgYmUgRUMsIGdpdmVuIGlzICIuLm9iai5rdHkpCiAgICAtLSB6ZW5jb2RlX2Fzc2VydChvYmouY3J2LCAiVGhlIGlucHV0IGlzIG5vdCBhIHZhbGlkIEpTT04gV2ViIEtleSwgbWlzc2luZyBjcnYiKQogICAgLS0gemVuY29kZV9hc3NlcnQob2JqLmNydiA9PSAiUC0yNTYiLCAiY3J2IG11c3QgYmUgUC0yNTYsIGdpdmVuIGlzICIuLm9iai5jcnYpCiAgICB6ZW5jb2RlX2Fzc2VydChvYmoueCwgIlRoZSBpbnB1dCBpcyBub3QgYSB2YWxpZCBKU09OIFdlYiBLZXksIG1pc3NpbmcgeCIpCiAgICB6ZW5jb2RlX2Fzc2VydCgjTy5mcm9tX3VybDY0KG9iai54KSA9PSAzMiwgIldyb25nIGxlbmd0aCBpbiBmaWVsZCAneCcsIGV4cGVjdGVkIDMyIGdpdmVuIGlzICIuLiAjTy5mcm9tX3VybDY0KG9iai54KSkKICAgIHplbmNvZGVfYXNzZXJ0KG9iai55LCAiVGhlIGlucHV0IGlzIG5vdCBhIHZhbGlkIEpTT04gV2ViIEtleSwgbWlzc2luZyB5IikKICAgIHplbmNvZGVfYXNzZXJ0KCNPLmZyb21fdXJsNjQob2JqLnkpID09IDMyLCAiV3JvbmcgbGVuZ3RoIGluIGZpZWxkICd5JywgZXhwZWN0ZWQgMzIgZ2l2ZW4gaXMgIi4uICNPLmZyb21fdXJsNjQob2JqLnkpKQoKICAgIGxvY2FsIHJlcyA9IHsKICAgICAgICBrdHkgPSBPLmZyb21fc3RyaW5nKG9iai5rdHkpLAogICAgICAgIGNydiA9IE8uZnJvbV9zdHJpbmcob2JqLmNydiksCiAgICAgICAgeCA9IE8uZnJvbV91cmw2NChvYmoueCksCiAgICAgICAgeSA9IE8uZnJvbV91cmw2NChvYmoueSkKICAgIH0KICAgIGlmIG9iai5hbGcgdGhlbgogICAgICAgIC0tIHplbmNvZGVfYXNzZXJ0KG9iai5hbGcgPT0gIkVTMjU2IiwgImFsZyBtdXN0IGJlIEVTMjU2LCBnaXZlbiBpcyAiLi5vYmouYWxnKQogICAgICAgIHJlcy5hbGcgPSBPLmZyb21fc3RyaW5nKG9iai5hbGcpCiAgICBlbmQKICAgIGlmIG9iai51c2UgdGhlbgogICAgICAgIHplbmNvZGVfYXNzZXJ0KG9iai51c2UgPT0gInNpZyIsICJ1c2UgbXVzdCBiZSBzaWcsIGdpdmVuIGlzICIuLm9iai51c2UpCiAgICAgICAgcmVzLnVzZSA9IE8uZnJvbV9zdHJpbmcob2JqLnVzZSkKICAgIGVuZAogICAgaWYgb2JqLmtpZCB0aGVuCiAgICAgICAgcmVzLmtpZCA9IE8uZnJvbV91cmw2NChvYmoua2lkKQogICAgZW5kCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X2p3ayhvYmopCiAgICBsb2NhbCBrZXkgPSB7IH0KICAgIGlmIG9iai5kICAgdGhlbiBrZXkuZCA9ICAgTy50b19zdHJpbmcob2JqLmQpIGVuZAogICAgaWYgb2JqLmt0eSB0aGVuIGtleS5rdHkgPSBPLnRvX3N0cmluZyhvYmoua3R5KSBlbmQKICAgIGlmIG9iai5jcnYgdGhlbiBrZXkuY3J2ID0gTy50b19zdHJpbmcob2JqLmNydikgZW5kCiAgICBpZiBvYmoueCAgIHRoZW4ga2V5LnggPSAgIE8udG9fc3RyaW5nKG9iai54KSBlbmQKICAgIGlmIG9iai55ICAgdGhlbiBrZXkueSA9ICAgTy50b19zdHJpbmcob2JqLnkpIGVuZAogICAgaWYgb2JqLnVzZSB0aGVuIGtleS51c2UgPSBPLnRvX3N0cmluZyhvYmoudXNlKSBlbmQKICAgIGlmIG9iai5hbGcgdGhlbiBrZXkuYWxnID0gTy50b19zdHJpbmcob2JqLmFsZykgZW5kCiAgICBpZiBvYmoua2lkIHRoZW4ga2V5LmtpZCA9IE8udG9fc3RyaW5nKG9iai5raWQpIGVuZAogICAgcmV0dXJuIGtleQplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIGp3ayA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X2p3aywKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X2p3awogICAgICAgIH0KICAgIH0KKQoKbG9jYWwgZnVuY3Rpb24gX2NyZWF0ZV9qd2soYWxnLCBza19mbGFnLCBwaykKICAgIGVtcHR5ICdqd2snCiAgICBBQ0suandrID0gZGVlcG1hcChPLmZyb21fc3RyaW5nLCBXM0MuY3JlYXRlX3N0cmluZ19qd2soYWxnLCBza19mbGFnLCBwaykpCiAgICBuZXdfY29kZWMoJ2p3aycpIC0tIHsgc2NoZW1hemVudHlwZSA9ICdkJywKICAgICAgICAgICAgICAgICAgICAgIC0tIGVuY29kaW5nID0gJ3N0cmluZycgfSkKZW5kCgpXaGVuKCJjcmVhdGUgandrIG9mIHAyNTYgcHVibGljIGtleSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd2soJ0VTMjU2JykgZW5kKQpXaGVuKCJjcmVhdGUgandrIG9mIGVzMjU2IHB1YmxpYyBrZXkiLCBmdW5jdGlvbigpIF9jcmVhdGVfandrKCdFUzI1NicpIGVuZCkKV2hlbigiY3JlYXRlIGp3ayBvZiBzZWNwMjU2cjEgcHVibGljIGtleSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd2soJ0VTMjU2JykgZW5kKQpXaGVuKCJjcmVhdGUgandrIG9mIHAyNTYgcHVibGljIGtleSB3aXRoIHByaXZhdGUga2V5IiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3aygnRVMyNTYnLCB0cnVlKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2YgZXMyNTYgcHVibGljIGtleSB3aXRoIHByaXZhdGUga2V5IiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3aygnRVMyNTYnLCB0cnVlKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2Ygc2VjcDI1NnIxIHB1YmxpYyBrZXkgd2l0aCBwcml2YXRlIGtleSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd2soJ0VTMjU2JywgdHJ1ZSkgZW5kKQpXaGVuKCJjcmVhdGUgandrIG9mIHAyNTYgcHVibGljIGtleSAnJyIsIGZ1bmN0aW9uKHBrKSBfY3JlYXRlX2p3aygnRVMyNTYnLCBmYWxzZSwgcGspIGVuZCkKV2hlbigiY3JlYXRlIGp3ayBvZiBlczI1NiBwdWJsaWMga2V5ICcnIiwgZnVuY3Rpb24ocGspIF9jcmVhdGVfandrKCdFUzI1NicsIGZhbHNlLCBwaykgZW5kKQpXaGVuKCJjcmVhdGUgandrIG9mIHNlY3AyNTZyMSBwdWJsaWMga2V5ICcnIiwgZnVuY3Rpb24ocGspIF9jcmVhdGVfandrKCdFUzI1NicsIGZhbHNlLCBwaykgZW5kKQoKV2hlbigiY3JlYXRlIGp3ayBvZiBlY2RoIHB1YmxpYyBrZXkiLCBmdW5jdGlvbigpIF9jcmVhdGVfandrKCdFUzI1NksnKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2YgZXMyNTZrIHB1YmxpYyBrZXkiLCBmdW5jdGlvbigpIF9jcmVhdGVfandrKCdFUzI1NksnKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2Ygc2VjcDI1NmsxIHB1YmxpYyBrZXkiLCBmdW5jdGlvbigpIF9jcmVhdGVfandrKCdFUzI1NksnKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2YgZWNkaCBwdWJsaWMga2V5IHdpdGggcHJpdmF0ZSBrZXkiLCBmdW5jdGlvbigpIF9jcmVhdGVfandrKCdFUzI1NksnLCB0cnVlKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2YgZXMyNTZrIHB1YmxpYyBrZXkgd2l0aCBwcml2YXRlIGtleSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd2soJ0VTMjU2SycsIHRydWUpIGVuZCkKV2hlbigiY3JlYXRlIGp3ayBvZiBzZWNwMjU2azEgcHVibGljIGtleSB3aXRoIHByaXZhdGUga2V5IiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3aygnRVMyNTZLJywgdHJ1ZSkgZW5kKQpXaGVuKCJjcmVhdGUgandrIG9mIGVjZGggcHVibGljIGtleSAnJyIsIGZ1bmN0aW9uKHBrKSBfY3JlYXRlX2p3aygnRVMyNTZLJywgZmFsc2UsIHBrKSBlbmQpCldoZW4oImNyZWF0ZSBqd2sgb2YgZXMyNTZrIHB1YmxpYyBrZXkgJyciLCBmdW5jdGlvbihwaykgX2NyZWF0ZV9qd2soJ0VTMjU2SycsIGZhbHNlLCBwaykgZW5kKQpXaGVuKCJjcmVhdGUgandrIG9mIHNlY3AyNTZrMSBwdWJsaWMga2V5ICcnIiwgZnVuY3Rpb24ocGspIF9jcmVhdGVfandrKCdFUzI1NksnLCBmYWxzZSwgcGspIGVuZCkKL3plbmNvZGVfandzLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IE1hdHRlbyBDcmlzdGlubwotLW9uIFRodXJzZGF5LCAyNnRoIFNlcHRlbWJlciAyMDI0Ci0tXV0KCmxvY2FsIFczQyA9IHJlcXVpcmVfb25jZSAiY3J5cHRvX3czYyIKCi0tIFdoZW4oZGVwcmVjYXRlZCgKLS0gICAgICAgICAiY3JlYXRlIGp3cyBzaWduYXR1cmUgb2YgJyciLAotLSAgICAgICAgICJjcmVhdGUgandzIGRldGFjaGVkIHNpZ25hdHVyZSB3aXRoIGhlYWRlciAnJyBhbmQgcGF5bG9hZCAnJyIsCi0tICAgICAgICAgZnVuY3Rpb24oc3JjKQotLSAgICAgICAgICAgICB3YXJuKCdyYXcgc2lnbmF0dXJlIG9mIHRoZSBwYXlsb2FkLCBub24gc3RhbmRhcmQgandzJykKLS0gICAgICAgICAgICAgbG9jYWwgc291cmNlX3N0ciA9IFczQy5qc29uX2VuY29kaW5nKHNyYykKLS0gICAgICAgICAgICAgZW1wdHknandzJwotLSAgICAgICAgICAgICBsb2NhbCBzayA9IGhhdmVrZXknZWNkaCcgLS0gYXNzdW1pbmcgc2VjcDI1NmsxCi0tICAgICAgICAgICAgIEFDSy5qd3MgPSBPLmZyb21fc3RyaW5nKAotLSAgICAgICAgICAgICAgICAgVzNDLmp3c19zaWduYXR1cmVfdG9fb2N0ZXQoRUNESC5zaWduKHNrLCBzb3VyY2Vfc3RyKSkgKQotLSAgICAgICAgICAgICBuZXdfY29kZWMoJ2p3cycsIHsgemVudHlwZSA9ICdlJywKLS0gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCi0tICAgICAgICAgZW5kCi0tICAgICApCi0tICkKCi0tIFdoZW4oZGVwcmVjYXRlZCgKLS0gICAgICAgICAiY3JlYXRlIGp3cyBzaWduYXR1cmUgdXNpbmcgZWNkaCBzaWduYXR1cmUgaW4gJyciLAotLSAgICAgICAgICJjcmVhdGUgandzIGRldGFjaGVkIHNpZ25hdHVyZSB3aXRoIGhlYWRlciAnJyBhbmQgcGF5bG9hZCAnJyIsCi0tICAgICAgICAgZnVuY3Rpb24oc2lnbikKLS0gICAgICAgICAgICAgd2FybignZXh0ZXJuYWwgc2lnbmF0dXJlIGNhbiBiZSBub3QgandzIGNvbXBsaWFudCcpCi0tICAgICAgICAgICAgIGxvY2FsIHNpZ25hdHVyZSA9IGhhdmUoc2lnbikKLS0gICAgICAgICAgICAgZW1wdHknandzJwotLSAgICAgICAgICAgICBBQ0suandzID0gTy5mcm9tX3N0cmluZyhqd3Nfc2lnbmF0dXJlX3RvX29jdGV0KHNpZ25hdHVyZSkpCi0tICAgICAgICAgICAgIG5ld19jb2RlYygnandzJywgeyB6ZW50eXBlID0gJ2UnLAotLSAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGVuY29kaW5nID0gJ3N0cmluZycgfSkKLS0gICAgICAgICBlbmQKLS0gICAgICkKLS0gKQoKLS0gcmV0dXJuIGEgaGVhZGVyIGZvciBqd3MKLS0gQHBhcmFtIGFsZyBhbGcgaW4gandzIGhlYWRlcgotLSBAcGFyYW0gcGsgcGsgZmxhZywgaXMgdHJ1ZSB0aGUgYWxnIHBrIGlzIHNldCBpbiB0aGUgaGVhZGVyIGluIGp3ayBmb3JtYXQKbG9jYWwgZnVuY3Rpb24gX2NyZWF0ZV9qd3NfaGVhZGVyKGFsZywgcGspCiAgICBsb2NhbCBjcnlwdG8gPGNvbnN0PiA9IENSWVBUTy5sb2FkKGFsZykKICAgIEFDSy5qd3NfaGVhZGVyID0ge1snYWxnJ10gPSBPLmZyb21fc3RyaW5nKGNyeXB0by5JQU5BKX0KICAgIGlmIHBrIHRoZW4KICAgICAgICBsb2NhbCBqd2sgPSBKT1NFLmNyZWF0ZV9qd2soY3J5cHRvLklBTkEpCiAgICAgICAgandrLnggPSBPLmZyb21fc3RyaW5nKGp3ay54OnRvX3VybDY0KCkpCiAgICAgICAgandrLnkgPSBPLmZyb21fc3RyaW5nKGp3ay55OnRvX3VybDY0KCkpCiAgICAgICAgQUNLLmp3c19oZWFkZXIuandrID0gandrCiAgICBlbmQKICAgIG5ld19jb2RlYygnandzX2hlYWRlcicsIHsgemVudHlwZSA9ICdkJywgZW5jb2RpbmcgPSAnc3RyaW5nJyB9KQplbmQKCldoZW4oImNyZWF0ZSBqd3MgaGVhZGVyIGZvciAnJyBzaWduYXR1cmUiLCBmdW5jdGlvbihhbGdvX25hbWUpCiAgICAgICAgIGxvY2FsIGNyeXB0byA8Y29uc3Q+ID0gQ1JZUFRPLmxvYWQoYWxnb19uYW1lKQogICAgICAgICBlbXB0eSdqd3NfaGVhZGVyJwogICAgICAgICBBQ0suandzX2hlYWRlciA9IHsgYWxnID0gTy5mcm9tX3N0cmluZyhjcnlwdG8uSUFOQSkgfQogICAgICAgICAtLSBUT0RPOiBnZW5lcmF0ZSBVSUQKICAgICAgICAgbmV3X2NvZGVjKCdqd3NfaGVhZGVyJywgeyB6ZW50eXBlID0gJ2QnLCBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCmVuZCkKCldoZW4oImNyZWF0ZSBqd3MgaGVhZGVyIGZvciAnJyBzaWduYXR1cmUgd2l0aCBwdWJsaWMga2V5IiwgZnVuY3Rpb24oYWxnb19uYW1lKQogICAgICAgICBsb2NhbCBjcnlwdG8gPGNvbnN0PiA9IENSWVBUTy5sb2FkKGFsZ29fbmFtZSkKICAgICAgICAgZW1wdHknandzX2hlYWRlcicKICAgICAgICAgQUNLLmp3c19oZWFkZXIgPSB7IGFsZyA9IE8uZnJvbV9zdHJpbmcoY3J5cHRvLklBTkEpIH0KICAgICAgICAgbG9jYWwgandrID0gSk9TRS5jcmVhdGVfandrKGNyeXB0by5JQU5BKQogICAgICAgICBqd2sueCA9IE8uZnJvbV9zdHJpbmcoandrLng6dG9fdXJsNjQoKSkKICAgICAgICAgandrLnkgPSBPLmZyb21fc3RyaW5nKGp3ay55OnRvX3VybDY0KCkpCiAgICAgICAgIEFDSy5qd3NfaGVhZGVyLmp3ayA9IGp3awogICAgICAgICAtLSBUT0RPOiBnZW5lcmF0ZSBVSUQKICAgICAgICAgbmV3X2NvZGVjKCdqd3NfaGVhZGVyJywgeyB6ZW50eXBlID0gJ2QnLCBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCmVuZCkKCldoZW4oZGVwcmVjYXRlZCgiY3JlYXRlIGp3cyBoZWFkZXIgZm9yIHAyNTYgc2lnbmF0dXJlIiwKICAgICAgICAgICAgICAgICJjcmVhdGUgandzIGhlYWRlciBmb3IgJycgc2lnbmF0dXJlIiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3c19oZWFkZXIoJ0VTMjU2JykgZW5kKSkKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3IgZXMyNTYgc2lnbmF0dXJlIiwKICAgICAgICAgICAgICAgICJjcmVhdGUgandzIGhlYWRlciBmb3IgJycgc2lnbmF0dXJlIiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3c19oZWFkZXIoJ0VTMjU2JykgZW5kKSkKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3Igc2VjcDI1NnIxIHNpZ25hdHVyZSIsCiAgICAgICAgICAgICAgICAiY3JlYXRlIGp3cyBoZWFkZXIgZm9yICcnIHNpZ25hdHVyZSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd3NfaGVhZGVyKCdFUzI1NicpIGVuZCkpCldoZW4oZGVwcmVjYXRlZCgiY3JlYXRlIGp3cyBoZWFkZXIgZm9yIGVjZGggc2lnbmF0dXJlIiwKICAgICAgICAgICAgICAgICJjcmVhdGUgandzIGhlYWRlciBmb3IgJycgc2lnbmF0dXJlIiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3c19oZWFkZXIoJ0VTMjU2SycpIGVuZCkpCldoZW4oZGVwcmVjYXRlZCgiY3JlYXRlIGp3cyBoZWFkZXIgZm9yIGVzMjU2ayBzaWduYXR1cmUiLAogICAgICAgICAgICAgICAgImNyZWF0ZSBqd3MgaGVhZGVyIGZvciAnJyBzaWduYXR1cmUiLCBmdW5jdGlvbigpIF9jcmVhdGVfandzX2hlYWRlcignRVMyNTZLJykgZW5kKSkKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3Igc2VjcDI1NmsxIHNpZ25hdHVyZSIsCiAgICAgICAgICAgICAgICAiY3JlYXRlIGp3cyBoZWFkZXIgZm9yICcnIHNpZ25hdHVyZSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd3NfaGVhZGVyKCdFUzI1NksnKSBlbmQpKQoKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3IgcDI1NiBzaWduYXR1cmUgd2l0aCBwdWJsaWMga2V5IiwKICAgICAgICAgICAgICAgICJjcmVhdGUgandzIGhlYWRlciBmb3IgJycgc2lnbmF0dXJlIHdpdGggcHVibGljIGtleSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd3NfaGVhZGVyKCdFUzI1NicsIHRydWUpIGVuZCkpCldoZW4oZGVwcmVjYXRlZCgiY3JlYXRlIGp3cyBoZWFkZXIgZm9yIGVzMjU2IHNpZ25hdHVyZSB3aXRoIHB1YmxpYyBrZXkiLAogICAgICAgICAgICAgICAgImNyZWF0ZSBqd3MgaGVhZGVyIGZvciAnJyBzaWduYXR1cmUgd2l0aCBwdWJsaWMga2V5IiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3c19oZWFkZXIoJ0VTMjU2JywgdHJ1ZSkgZW5kKSkKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3Igc2VjcDI1NnIxIHNpZ25hdHVyZSB3aXRoIHB1YmxpYyBrZXkiLAogICAgICAgICAgICAgICAgImNyZWF0ZSBqd3MgaGVhZGVyIGZvciAnJyBzaWduYXR1cmUgd2l0aCBwdWJsaWMga2V5IiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3c19oZWFkZXIoJ0VTMjU2JywgdHJ1ZSkgZW5kKSkKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3IgZWNkaCBzaWduYXR1cmUgd2l0aCBwdWJsaWMga2V5IiwKICAgICAgICAgICAgICAgICJjcmVhdGUgandzIGhlYWRlciBmb3IgJycgc2lnbmF0dXJlIHdpdGggcHVibGljIGtleSIsIGZ1bmN0aW9uKCkgX2NyZWF0ZV9qd3NfaGVhZGVyKCdFUzI1NksnLCB0cnVlKSBlbmQpKQpXaGVuKGRlcHJlY2F0ZWQoImNyZWF0ZSBqd3MgaGVhZGVyIGZvciBlczI1Nmsgc2lnbmF0dXJlIHdpdGggcHVibGljIGtleSIsCiAgICAgICAgICAgICAgICAiY3JlYXRlIGp3cyBoZWFkZXIgZm9yICcnIHNpZ25hdHVyZSB3aXRoIHB1YmxpYyBrZXkiLCBmdW5jdGlvbigpIF9jcmVhdGVfandzX2hlYWRlcignRVMyNTZLJywgdHJ1ZSkgZW5kKSkKV2hlbihkZXByZWNhdGVkKCJjcmVhdGUgandzIGhlYWRlciBmb3Igc2VjcDI1NmsxIHNpZ25hdHVyZSB3aXRoIHB1YmxpYyBrZXkiLAogICAgICAgICAgICAgICAgImNyZWF0ZSBqd3MgaGVhZGVyIGZvciAnJyBzaWduYXR1cmUgd2l0aCBwdWJsaWMga2V5IiwgZnVuY3Rpb24oKSBfY3JlYXRlX2p3c19oZWFkZXIoJ0VTMjU2SycsIHRydWUpIGVuZCkpCgpXaGVuKCJjcmVhdGUgandzIHNpZ25hdHVyZSBvZiBoZWFkZXIgJycgYW5kIHBheWxvYWQgJyciLCBmdW5jdGlvbihoZWFkZXIsIHBheWxvYWQpCiAgICBlbXB0eSdqd3Nfc2lnbmF0dXJlJwogICAgbG9jYWwgaCA8Y29uc3Q+ID0gaGF2ZShoZWFkZXIpCiAgICBsb2NhbCBwIDxjb25zdD4gPSBoYXZlKHBheWxvYWQpCiAgICBBQ0tbJ2p3c19zaWduYXR1cmUnXSA9IEpPU0UuY3JlYXRlX2p3cyhuaWwsIGgsIHAsIGZhbHNlKQogICAgbmV3X2NvZGVjKCdqd3Nfc2lnbmF0dXJlJywgeyB6ZW50eXBlID0gJ2UnLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCmVuZCkKCi0tIGp3cyByZXN1bHQgd2lsbCBiZSB3aXRob3V0IHB5YWxvYWQsIHNpZ25hdHVyZSBpcyBhbHdheXMgcGVyZm9ybSBvbgotLSBoZWFkZXIucGF5bG9hZApXaGVuKCJjcmVhdGUgandzIGRldGFjaGVkIHNpZ25hdHVyZSBvZiBoZWFkZXIgJycgYW5kIHBheWxvYWQgJyciLCBmdW5jdGlvbihoZWFkZXIsIHBheWxvYWQpCiAgICBlbXB0eSdqd3NfZGV0YWNoZWRfc2lnbmF0dXJlJwogICAgbG9jYWwgaCA8Y29uc3Q+ID0gaGF2ZShoZWFkZXIpCiAgICBsb2NhbCBwIDxjb25zdD4gPSBoYXZlKHBheWxvYWQpCiAgICBBQ0tbJ2p3c19kZXRhY2hlZF9zaWduYXR1cmUnXSA9IEpPU0UuY3JlYXRlX2p3cyhuaWwsIGgsIHAsIHRydWUpCiAgICBuZXdfY29kZWMoJ2p3c19kZXRhY2hlZF9zaWduYXR1cmUnLCB7IHplbnR5cGUgPSAnZScsCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIGVuY29kaW5nID0gJ3N0cmluZycgfSkKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX3ZlcmlmeV9qd3Mobl9wYXlsb2FkLCBuX2p3cykKICAgIGxvY2FsIGp3c19lbmMgPGNvbnN0PiA9IGhhdmUobl9qd3Mgb3IgJ2p3cycpCiAgICBsb2NhbCBwYXlsb2FkIDxjb25zdD4gPSBoYXZlKG5fcGF5bG9hZCkKICAgIGxvY2FsIHBzZXIgICAgPGNvbnN0PiA9IEpTT04uc2VyaWFsaXplKHBheWxvYWQpCiAgICBsb2NhbCBqd3MgICAgIDxjb25zdD4gPSBKT1NFLnBhcnNlX2p3cyhqd3NfZW5jKQogICAgbG9jYWwgY3J5cHRvICA8Y29uc3Q+ID0gQ1JZUFRPLmxvYWQoandzLmhlYWRlci5hbGcpCiAgICAtLSB0aGUgcGF5bG9hZCBpcyBwYXNzZWQgYXMgYXJndW1lbnQgc28gd2UgYXNzdW1lIHRoaXMgdG8KICAgIC0tIGJlIGEgZGV0YWNoZWQgc2lnbmF0dXJlLCBpbiBjYXNlIGFub3RoZXIgcGF5bG9hZCBpcwogICAgLS0gcHJlc2VudCBpbiB0aGUgandzIHRoZW4gd2UgYWxzbyB2ZXJpZnkgaXQgaXMgdGhlIHNhbWUgYXMKICAgIC0tIHRoZSBkZXRhY2hlZCBvbmUKICAgIGlmIGp3cy5wYXlsb2FkIHRoZW4KICAgICAgICB6ZW5jb2RlX2Fzc2VydChwc2VyID09IGp3cy5wYXlsb2FkX2VuYywKICAgICAgICAgICAgICAgICAgICAgICAiVGhlIEpXUyBjb250YWlucyBhIGRpZmZlcmVudCBwYXlsb2FkIikKICAgIGVuZAogICAgbG9jYWwgdG9fYmVfdmVyaWZpZWQgPGNvbnN0PiA9CiAgICAgICAgandzLmhlYWRlcl9lbmMuLk8uZnJvbV9zdHJpbmcoJy4nKS4ucHNlcgogICAgLS0gaWYgaGVhZGVyLmFsZyA9PSAnRVMyNTZLJyB0aGVuCiAgICAtLSBUT0RPOiBzcGxpdCBzaWduYXR1cmUgaW4gciBhbmQgcyBzaG91bGQgYmUgZG9uZSBpbiBFQ0RICiAgICBsb2NhbCBwayA9IG1heWhhdmUoJ2p3c19wdWJsaWNfa2V5JykKICAgIGlmIG5vdCBwayB0aGVuIHBrID0gaGF2ZShjcnlwdG8ua2V5bmFtZS4uJ19wdWJsaWNfa2V5JykgZW5kCiAgICB6ZW5jb2RlX2Fzc2VydChjcnlwdG8udmVyaWZ5KHBrLCB0b19iZV92ZXJpZmllZCwgandzLnNpZ25hdHVyZSksCiAgICAgICAgICAgICAgICAgICAnSW52YWxpZCBKV1Mgc2lnbmF0dXJlIG9mOiAnLi5uX3BheWxvYWQpCmVuZApJZldoZW4oZGVwcmVjYXRlZCgidmVyaWZ5IGp3cyBzaWduYXR1cmUgb2YgJyciLAogICAgICAgICAgICAgICAgICAidmVyaWZ5ICcnIGhhcyBhIGp3cyBzaWduYXR1cmUgaW4gJyciLAogICAgICAgICAgICAgICAgICBfdmVyaWZ5X2p3cykpCklmV2hlbigidmVyaWZ5ICcnIGhhcyBhIGp3cyBzaWduYXR1cmUgaW4gJyciLCBfdmVyaWZ5X2p3cykKCklmV2hlbigidmVyaWZ5IGp3cyBzaWduYXR1cmUgaW4gJyciLCBmdW5jdGlvbihuX2p3cykKICAgICAgICAgICBsb2NhbCBqd3NfZW5jIDxjb25zdD4gPSBoYXZlKG5fandzKQogICAgICAgICAgIGxvY2FsIGp3cyAgICAgPGNvbnN0PiA9IEpPU0UucGFyc2VfandzKGp3c19lbmMpCiAgICAgICAgICAgemVuY29kZV9hc3NlcnQoIGp3cy5wYXlsb2FkLCAiVGhlIEpXUyBoYXMgbm8gcGF5bG9hZCIpCiAgICAgICAgICAgbG9jYWwgY3J5cHRvICA8Y29uc3Q+ID0gQ1JZUFRPLmxvYWQoandzLmhlYWRlci5hbGcpCiAgICAgICAgICAgbG9jYWwgdG9fYmVfdmVyaWZpZWQgPGNvbnN0PiA9IGp3cy5oZWFkZXJfZW5jLi5PLmZyb21fc3RyaW5nKCcuJykuLmp3cy5wYXlsb2FkX2VuYwogICAgICAgICAgIGxvY2FsIHBrID0gbWF5aGF2ZSgnandzX3B1YmxpY19rZXknKQogICAgICAgICAgIGlmIG5vdCBwayB0aGVuIHBrID0gbWF5aGF2ZShjcnlwdG8ua2V5bmFtZS4uJ19wdWJsaWNfa2V5JykgZW5kCiAgICAgICAgICAgaWYgbm90IHBrIHRoZW4gcGsgPSBKT1NFLmp3a190b19wayhqd3MuaGVhZGVyLCBjcnlwdG8pIGVuZAogICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KHBrLCAnUHVibGljIGtleSBub3QgZm91bmQgZm9yIEpXUyBzaWduYXR1cmUnKQogICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KGNyeXB0by52ZXJpZnkocGssIHRvX2JlX3ZlcmlmaWVkLCBqd3Muc2lnbmF0dXJlKSwKICAgICAgICAgICAgICAgICAgICAgICAgICAnSW52YWxpZCBKV1Mgc2lnbmF0dXJlIGluOiAnLi5uX2p3cykKZW5kKQovemVuY29kZV9qd3QubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIxLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgTWF0dGVvIENyaXN0aW5vCi0tb24gVGh1cnNkYXksIDI2dGggU2VwdGVtYmVyIDIwMjQKLS1dXQoKbG9jYWwgVzNDID0gcmVxdWlyZV9vbmNlJ2NyeXB0b193M2MnCgpaRU46YWRkX3NjaGVtYSgKICAgIHsKICAgICAgICBqc29uX3dlYl90b2tlbiA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gVzNDLmltcG9ydF9qd3QsCiAgICAgICAgICAgIGV4cG9ydCA9IFczQy5leHBvcnRfand0CiAgICAgICAgfSwKICAgICAgICBqd3QgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IFczQy5pbXBvcnRfand0LAogICAgICAgICAgICBleHBvcnQgPSBXM0MuZXhwb3J0X2p3dAogICAgICAgIH0KICAgIH0KKQoKZnVuY3Rpb24gY3JlYXRlX2p3dF9oczI1NihwYXlsb2FkLCBwYXNzd29yZCkKICAgIGxvY2FsIGhlYWRlciA8Y29uc3Q+ID0gewogICAgICAgIGFsZyA9IE8uZnJvbV9zdHJpbmcnSFMyNTYnLAogICAgICAgIHR5cCA9IE8uZnJvbV9zdHJpbmcnSldUJwogICAgfQogICAgbG9jYWwgYjY0aGVhZGVyIDxjb25zdD4gPSBPLmZyb21fc3RyaW5nKAogICAgICAgIEpTT04uZW5jb2RlKGhlYWRlciwnc3RyaW5nJykpOnVybDY0KCkKICAgIGxvY2FsIGI2NHBheWxvYWQgPGNvbnN0PiA9IE8uZnJvbV9zdHJpbmcoCiAgICAgICAgSlNPTi5lbmNvZGUocGF5bG9hZCwnc3RyaW5nJykpOnVybDY0KCkKICAgIGxvY2FsIGhhc2ggPSBIQVNILm5ldygic2hhMjU2IikKCiAgICBsb2NhbCBzaWduYXR1cmUgPGNvbnN0PiA9IGhhc2g6aG1hYygKICAgICAgICBwYXNzd29yZCwKICAgICAgICBiNjRoZWFkZXIgLi4gJy4nIC4uIGI2NHBheWxvYWQpCiAgICByZXR1cm4gewogICAgICAgIGhlYWRlcj1oZWFkZXIsCiAgICAgICAgcGF5bG9hZD1wYXlsb2FkLAogICAgICAgIHNpZ25hdHVyZT1zaWduYXR1cmUsCiAgICB9CmVuZAoKV2hlbigiY3JlYXRlIGpzb24gd2ViIHRva2VuIG9mICcnIHVzaW5nICcnIiwgZnVuY3Rpb24ocGF5bG9hZF9uYW1lLCBwYXNzd29yZF9uYW1lKQogICAgbG9jYWwgcGF5bG9hZCA8Y29uc3Q+ID0gaGF2ZShwYXlsb2FkX25hbWUpCiAgICBsb2NhbCBwYXNzd29yZCA8Y29uc3Q+ID0gbWF5aGF2ZShwYXNzd29yZF9uYW1lKSBvciBwYXNzd29yZF9uYW1lCiAgICBlbXB0eSdqc29uX3dlYl90b2tlbicKICAgIEFDSy5qc29uX3dlYl90b2tlbiA9IGNyZWF0ZV9qd3RfaHMyNTYocGF5bG9hZCwgcGFzc3dvcmQpCiAgICBuZXdfY29kZWMoImpzb25fd2ViX3Rva2VuIikKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkganNvbiB3ZWIgdG9rZW4gaW4gJycgdXNpbmcgJyciLCBmdW5jdGlvbihobWFjX25hbWUsIHBhc3N3b3JkX25hbWUpCiAgICBsb2NhbCBobWFjIDxjb25zdD4gPSBoYXZlKGhtYWNfbmFtZSkKICAgIGxvY2FsIHBhc3N3b3JkIDxjb25zdD4gPSBtYXloYXZlKHBhc3N3b3JkX25hbWUpIG9yIHBhc3N3b3JkX25hbWUKICAgIGxvY2FsIGp3dF9oczI1NiA8Y29uc3Q+ID0gY3JlYXRlX2p3dF9oczI1NihobWFjLnBheWxvYWQsIHBhc3N3b3JkKQogICAgemVuY29kZV9hc3NlcnQoand0X2hzMjU2LnNpZ25hdHVyZSA9PSBobWFjLnNpZ25hdHVyZSwgIkNvdWxkIG5vdCByZS1jcmVhdGUgSE1BQyIpCmVuZCkKL3plbmNvZGVfa2V5cmluZy5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjEtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tXV0KCgotLSBERVNDUklQVElPTjogU3BlY2lhbCBrZXlzIHNjaGVtYSBoYXMgb3B0aW9uYWwgbWVtYmVycyBjb21tb24gdG8KLS0gbXVsdGlwbGUgc2NlbmFyaW9zLCBpdCBwcm92aWRlcyBhIGNvbW1vbiBpbnRlcmZhY2UgdG8gY3JlYXRlIGtleXMsCi0tIHZlcmlmaWVycyBhbmQgY2hlY2sgdGhlaXIgZXhpc3RhbmNlLiBJdCBkb2VzIG5vdCB1c2UgdGhlIGtleXMsIHRoYXQncwotLSB1cCB0byB0aGUgc3BlY2lmaWMgc2NlbmFyaW9zLiBPbmUgc2luZ2xlIHNjZW5hcmlvIG1heSByZXF1aXJlIGFuZCB1c2UKLS0gdGhlIHNhbWUga2V5IHR5cGVzIChvbmUgb3IgbW9yZSkgYXMgb3RoZXJzIGRvLCBmb3IgaW5zdGFuY2UgcmVmbG93Ci0tIHVzZXMgYmxzIGFuZCBjcmVkZW50aWFsLCBwZXRpdGlvbiB1c2VzIGNyZWRlbnRpYWwgYW5kIGVjZGguCgotLSB1dGlscyBsb2NhbCBmdW5jdGlvbnMKbG9jYWwgZnVuY3Rpb24gbm9wKHgpIHJldHVybih4KSBlbmQKLS0gdGhlIGxlbmd0aCBvZiB0aGUga3liZXIsIGRpbGl0aGl1bSBhbmQgbnRydXAga2V5cyBjYW4gYmUgZm91bmQgaW4gWmVucm9vbS9zcmMvemVuX3FwLmMKbG9jYWwgZnVuY3Rpb24gZGlsaXRoaXVtX2YobykKICAgaWYgI28gfj0gMjUyOCB0aGVuCiAgICAgICBlcnJvcignRGlsaXRoaXVtIGtleSBsZW5ndGggaXMgbm90IGNvcnJlY3Q6ICcuLiNvLCAzKQogICBlbmQKICAgcmV0dXJuIG8KZW5kCmxvY2FsIGZ1bmN0aW9uIGt5YmVyX2YobykKICAgaWYgI28gfj0gMTYzMiB0aGVuCiAgICAgICBlcnJvcignS3liZXIga2V5IGxlbmd0aCBpcyBub3QgY29ycmVjdDogJy4uI28sIDMpCiAgIGVuZAogICByZXR1cm4gbwplbmQKbG9jYWwgZnVuY3Rpb24gbWxrZW01MTJfZihvKQogICBpZiAjbyB+PSAxNjMyIHRoZW4KICAgICAgIGVycm9yKCdNTC1LRU0tNTEyIGtleSBsZW5ndGggaXMgbm90IGNvcnJlY3Q6ICcuLiNvLCAzKQogICBlbmQKICAgcmV0dXJuIG8KZW5kCmxvY2FsIGZ1bmN0aW9uIG50cnVwX2YobykKICAgaWYgI28gfj0gMTc2MyB0aGVuCiAgICAgICBlcnJvcignTnRydXAga2V5IGxlbmd0aCBpcyBub3QgY29ycmVjdDogJy4uI28sIDMpCiAgIGVuZAogICByZXR1cm4gbwplbmQgIApsb2NhbCBmdW5jdGlvbiBtbGRzYTQ0X2YobykKICAgaWYgI28gfj0gMjU2MCB0aGVuCiAgICAgICBlcnJvcignbWxkc2E0NCBrZXkgbGVuZ3RoIGlzIG5vdCBjb3JyZWN0OiAnLi4jbywgMykKICAgZW5kCiAgIHJldHVybiBvCmVuZApsb2NhbCBmdW5jdGlvbiByc2FfZihvKQogICBpZiAjbyB+PSAxMjgwIHRoZW4KICAgICAgIGVycm9yKCdyc2Ega2V5IGxlbmd0aCBpcyBub3QgY29ycmVjdDogJy4uI28sIDMpCiAgIGVuZAogICByZXR1cm4gbwplbmQKCi0tIEtOT1dOIEtFWSBUWVBFUyBGT1VORCBJTiBBQ0sua2V5cmluZyBhbmQgdGhlaXIgaW1wb3J0L2V4cG9ydApsb2NhbCBrZXl0eXBlcyA8Y29uc3Q+ID0gewogICAgZWNkaCA9IHsKICAgICAgICBpbXBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJ2VjZGgnLCBub3AsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmouZWNkaDpvY3RldCgpOmJhc2U2NCgpIGVuZAogICAgfSwKICAgIGVzMjU2ID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnZXMyNTYnLCBub3AsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmouZXMyNTY6b2N0ZXQoKTpiYXNlNjQoKSBlbmQKICAgIH0sCiAgICBjcmVkZW50aWFsID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnY3JlZGVudGlhbCcsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmouY3JlZGVudGlhbDpvY3RldCgpOmJhc2U2NCgpIGVuZAogICAgfSwKICAgIGlzc3VlciA9IHsKICAgICAgICBpbXBvcnQgPSBmdW5jdGlvbihvYmopCiAgICAgICAgICAgIHJldHVybiB7CiAgICAgICAgICAgICAgICB4ID0gc2NoZW1hX2dldChvYmouaXNzdWVyLCAneCcsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpLAogICAgICAgICAgICAgICAgeSA9IHNjaGVtYV9nZXQob2JqLmlzc3VlciwgJ3knLCBJTlQubmV3LCBPLmZyb21fYmFzZTY0KQogICAgICAgICAgICB9CiAgICAgICAgZW5kLAogICAgICAgIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHt4ID0gb2JqLmlzc3Vlci54Om9jdGV0KCk6YmFzZTY0KCksIHkgPSBvYmouaXNzdWVyLnk6b2N0ZXQoKTpiYXNlNjQoKX0gZW5kCiAgICB9LAogICAgYmJzID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnYmJzJywgSU5ULm5ldywgTy5mcm9tX2Jhc2U2NCkgZW5kLAogICAgICAgIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIG9iai5iYnM6b2N0ZXQoKTpiYXNlNjQoKSBlbmQKICAgIH0sCiAgICBiYnNfc2hha2UgPSB7CiAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gc2NoZW1hX2dldChvYmosICdiYnNfc2hha2UnLCBJTlQubmV3LCBPLmZyb21fYmFzZTY0KSBlbmQsCiAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gb2JqLmJic19zaGFrZTpvY3RldCgpOmJhc2U2NCgpIGVuZAogICAgfSwKICAgIHB2c3MgPSB7CiAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gc2NoZW1hX2dldChvYmosICdwdnNzJywgSU5ULm5ldywgTy5mcm9tX2Jhc2U2NCkgZW5kLAogICAgICAgIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIG9iai5wdnNzOm9jdGV0KCk6YmFzZTY0KCkgZW5kCiAgICB9LAogICAgcmVmbG93ID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAncmVmbG93JywgSU5ULm5ldywgTy5mcm9tX2Jhc2U2NCkgZW5kLAogICAgICAgIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIG9iai5yZWZsb3c6b2N0ZXQoKTpiYXNlNjQoKSBlbmQKICAgIH0sCiAgICBiaXRjb2luID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnYml0Y29pbicsIEJUQy53aWZfdG9fc2ssIE8uZnJvbV9iYXNlNTgpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBPLnRvX2Jhc2U1OChCVEMuc2tfdG9fd2lmKG9iai5iaXRjb2luLCAnYml0Y29pbicpKSBlbmQKICAgIH0sCiAgICB0ZXN0bmV0ID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAndGVzdG5ldCcsIEJUQy53aWZfdG9fc2ssIE8uZnJvbV9iYXNlNTgpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBPLnRvX2Jhc2U1OChCVEMuc2tfdG9fd2lmKG9iai50ZXN0bmV0LCAndGVzdG5ldCcpKSBlbmQKICAgIH0sCiAgICBldGhlcmV1bSA9IHsKICAgICAgICBpbXBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJ2V0aGVyZXVtJywgbm9wLCBPLmZyb21faGV4KSBlbmQsCiAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gb2JqLmV0aGVyZXVtOm9jdGV0KCk6aGV4KCkgZW5kCiAgICB9LAogICAgZGlsaXRoaXVtID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnZGlsaXRoaXVtJywgZGlsaXRoaXVtX2YsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmouZGlsaXRoaXVtOm9jdGV0KCk6YmFzZTY0KCkgZW5kCiAgICB9LAogICAgbWxkc2E0NCA9IHsKICAgICAgICBpbXBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJ21sZHNhNDQnLCBtbGRzYTQ0X2YsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmoubWxkc2E0NDpvY3RldCgpOmJhc2U2NCgpIGVuZAogICAgfSwKICAgIHNjaG5vcnIgPSB7CiAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gc2NoZW1hX2dldChvYmosICdzY2hub3JyJywgbm9wLCBPLmZyb21fYmFzZTY0KSBlbmQsCiAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gb2JqLnNjaG5vcnI6b2N0ZXQoKTpiYXNlNjQoKSBlbmQKICAgIH0sCiAgICBreWJlciA9IHsKICAgICAgICBpbXBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJ2t5YmVyJywga3liZXJfZiwgTy5mcm9tX2Jhc2U2NCkgZW5kLAogICAgICAgIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIG9iai5reWJlcjpvY3RldCgpOmJhc2U2NCgpIGVuZAogICAgfSwKICAgIG1sa2VtNTEyID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnbWxrZW01MTInLCBtbGtlbTUxMl9mLCBPLmZyb21fYmFzZTY0KSBlbmQsCiAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gb2JqLm1sa2VtNTEyOm9jdGV0KCk6YmFzZTY0KCkgZW5kCiAgICB9LAogICAgcnNhID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAncnNhJywgcnNhX2YsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmoucnNhOm9jdGV0KCk6YmFzZTY0KCkgZW5kCiAgICB9LAogICAgbnRydXAgPSB7CiAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gc2NoZW1hX2dldChvYmosICdudHJ1cCcsIG50cnVwX2YsIE8uZnJvbV9iYXNlNjQpIGVuZCwKICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBvYmoubnRydXA6b2N0ZXQoKTpiYXNlNjQoKSBlbmQKICAgIH0sCiAgICBlZGRzYSA9IHsKICAgICAgICBpbXBvcnQgPSBmdW5jdGlvbihvYmopIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJ2VkZHNhJywgbm9wLCBPLmZyb21fYmFzZTU4KSBlbmQsCiAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gb2JqLmVkZHNhOm9jdGV0KCk6YmFzZTU4KCkgZW5kCiAgICB9LAogICAgZnNwID0gewogICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikgcmV0dXJuIHNjaGVtYV9nZXQob2JqLCAnZnNwJywgbm9wLCBPLmZyb21fYmFzZTY0KSBlbmQsCiAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24ob2JqKSByZXR1cm4gb2JqLmZzcDpvY3RldCgpOmJhc2U2NCgpIGVuZAogICAgfQp9Cgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfa2V5cmluZyhvYmopCiAgICBsb2NhbCByZXMgPSB7fQogICAgZm9yIGssXyBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgbG9jYWwgdCA9IGtleXR5cGVzW2tdCiAgICAgICAgaWYgbm90IHQgdGhlbgogICAgICAgICAgICBlcnJvcigiVW5zdXBwb3J0ZWQga2V5IHR5cGUgZm91bmQgaW4ga2V5cmluZzogIi4uaywgMikKICAgICAgICBlbmQKICAgICAgICByZXNba10gPSB0LmltcG9ydChvYmopCiAgICBlbmQKICAgIHJldHVybiByZXMKZW5kCgotLSB1c2VkIGluIHplbmNvZGVfdGhlbiBkaXJlY3RseQpmdW5jdGlvbiBleHBvcnRfa2V5cmluZyhvYmopCiAgICBsb2NhbCByZXMgPSB7fQogICAgZm9yIGssXyBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgbG9jYWwgdCA9IGtleXR5cGVzW2tdCiAgICAgICAgaWYgbm90IHQgdGhlbgogICAgICAgICAgICBlcnJvcigiVW5zdXBwb3J0ZWQga2V5IHR5cGUgZm91bmQgaW4ga2V5cmluZzogIi4uaywgMikKICAgICAgICBlbmQKICAgICAgICByZXNba10gPSB0LmV4cG9ydChvYmopCiAgICBlbmQKICAgIHJldHVybiByZXMKZW5kCgpaRU46YWRkX3NjaGVtYSgKICAgIHsKICAgICAgICBrZXlyaW5nID0gewogICAgICAgICAgICBpbXBvcnQgPSBpbXBvcnRfa2V5cmluZywKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X2tleXJpbmcKICAgICAgICB9CiAgICB9CikKCldoZW4oImNyZWF0ZSBrZXlyaW5nIiwgZnVuY3Rpb24oKQogICAgZW1wdHkna2V5cmluZycKICAgIGluaXRrZXlyaW5nKCkKZW5kKQoKLS0gVVRJTFMgZ2xvYmFsIGZ1bmN0aW9ucwoKLS0gY2hlY2sgdmFyaW91cyBsb2NhdGlvbnMgdG8gZmluZCB0aGUgcHVibGljIGtleQotLSBhbGdvIGNhbiBiZSBvbmUgb2YgZGlsaXRoaXVtLCBrZXliZXIsIGVkZHNhCi0tICBHaXZlbiBJIGhhdmUgYSAncycgZnJvbSAndCcgICAgICAgICAgICAtLT4gQUNLLnNbdF0KZnVuY3Rpb24gbG9hZF9wdWJrZXlfY29tcGF0KF9rZXksIGFsZ28pCiAgICBsb2NhbCBwdWJrZXkgPSBBQ0tbX2tleV0KICAgIGlmIHB1YmtleSB0aGVuIHJldHVybiBwdWJrZXkgZW5kCiAgICBwdWJrZXkgPSBBQ0tbYWxnby4uJ19wdWJsaWNfa2V5J10KICAgIGlmIGx1YXR5cGUocHVia2V5KSA9PSAndGFibGUnIHRoZW4KICAgICAgICBwdWJrZXkgPSBwdWJrZXlbX2tleV0KICAgIGVuZAogICAgaWYgbm90IHB1YmtleSB0aGVuCiAgICAgICAgZXJyb3IoJ1B1YmxpYyBrZXkgbm90IGZvdW5kIGZvcjogJyAuLiBfa2V5LCAyKQogICAgZW5kCiAgICByZXR1cm4gcHVia2V5CmVuZAoKZnVuY3Rpb24gaGF2ZWtleShrdHlwZSkKICAgIGxvY2FsIGtuYW1lID0gdXNjb3JlKGt0eXBlKQogICAgaWYgbm90IGtleXR5cGVzW2tuYW1lXSB0aGVuCiAgICAgICAgZXJyb3IoJ1Vua25vd24ga2V5IHR5cGU6ICcgLi4ga3R5cGUsIDIpCiAgICBlbmQKICAgIC0tIGNoZWNrIHRoYXQga2V5cyBleGlzdCBhbmQgYXJlIGEgdGFibGUKICAgIGluaXRrZXlyaW5nKCkKICAgIGxvY2FsIHJlcyA9IEFDSy5rZXlyaW5nW2tuYW1lXQogICAgaWYgbm90IHJlcyB0aGVuCiAgICAgICAgZXJyb3IoJ0tleSBub3QgZm91bmQ6ICcgLi4ga3R5cGUsIDIpCiAgICBlbmQKICAgIHJldHVybiByZXMKIGVuZAoKIC0tIGtleXJpbmcgaW5pdGlhbGl6YXRpb24KZnVuY3Rpb24gaW5pdGtleXJpbmcoa3R5cGUpCiAgICBpZiBub3QgQUNLLmtleXJpbmcgdGhlbgogICAgICAgIEFDSy5rZXlyaW5nID0ge30KICAgICAgICBuZXdfY29kZWMoJ2tleXJpbmcnKQogICAgZW5kCiAgICBpZiBsdWF0eXBlKEFDSy5rZXlyaW5nKSB+PSAndGFibGUnIHRoZW4KICAgICAgICBlcnJvcignS2V5cmluZyB0YWJsZSBpcyBjb3JydXB0ZWQnLCAyKQogICAgZW5kCiAgICAtLSBUT0RPOiBjaGVjayB0aGF0IGN1cnZlIHR5cGVzIG1hdGNoCiAgICAtLSBpZiBrdHlwZSBpcyBzcGVjaWZpZWQgdGhlbiBjaGVjayBvdmVyd3JpdGluZwogICAgaWYga3R5cGUgYW5kIEFDSy5rZXlyaW5nW3VzY29yZShrdHlwZSldIHRoZW4KICAgICAgICBlcnJvcignQ2Fubm90IG92ZXJ3cml0ZSBleGlzdGluZyBrZXk6ICcgLi4ga3R5cGUsIDIpCiAgICBlbmQKZW5kCi96ZW5jb2RlX2xvbmdmZWxsb3cubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLV1dCgpsb2NhbCBMRiA8Y29uc3Q+ID0gcmVxdWlyZV9vbmNlJ2NyeXB0b19sb25nZmVsbG93Jwpsb2NhbCBQMjU2IDxjb25zdD4gPSByZXF1aXJlX29uY2UnZXMyNTYnCmxvY2FsIE9VVENPTlYgPGNvbnN0PiA9IENPTkYub3V0cHV0LmVuY29kaW5nLmZ1bgoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X2xvbmdmZWxsb3dfY2lyY3VpdF9mKGNpcmMpCiAgICBpZiBub3QgaXNkaWN0aW9uYXJ5KGNpcmMpIHRoZW4KICAgICAgICBlcnJvcigibG9uZ2ZlbGxvdyBjaXJjdWl0IGlzIG5vdCBhIGRpY3Rpb25hcnkgKG1pc3NpbmcgbWV0YWRhdGEpIiwyKQogICAgZW5kCiAgICBpZiBub3QgY2lyYy5jb21wcmVzc2VkIHRoZW4KICAgICAgICBlcnJvcigibG9uZ2ZlbGxvdyBjaXJjdWl0IGlzIG1pc3NpbmcgY29tcHJlc3NlZCBkYXRhIiwyKQogICAgZW5kCiAgICBpZiBub3QgY2lyYy5zeXN0ZW0gdGhlbgogICAgICAgIGVycm9yKCJsb25nZmVsbG93IGNpcmN1aXQgaXMgbWlzc2luZyBzeXN0ZW0gbmFtZSIsMikKICAgIGVuZAogICAgaWYgbm90IGNpcmMudmVyc2lvbiB0aGVuCiAgICAgICAgZXJyb3IoImxvbmdmZWxsb3cgY2lyY3VpdCBpcyBtaXNzaW5nIHZlcnNpb24gbnVtYmVyIiwyKQogICAgZW5kCiAgICBpZiBub3QgY2lyYy5udW1fYXR0cmlidXRlcyB0aGVuCiAgICAgICAgZXJyb3IoImxvbmdmZWxsb3cgY2lyY3VpdCBpcyBtaXNzaW5nIG51bWJlciBvZiBhdHRyaWJ1dGVzIiwyKQogICAgZW5kCiAgICBpZiBub3QgY2lyYy56a3NwZWMgdGhlbgogICAgICAgIGVycm9yKCJsb25nZmVsbG93IGNpcmN1aXQgaXMgbWlzc2luZyB6a3NwZWMgdmVyc2lvbiIsMikKICAgIGVuZAogICAgcmV0dXJuKHsKICAgICAgICAgICAgY29tcHJlc3NlZCA9IHNjaGVtYV9nZXQoY2lyYy5jb21wcmVzc2VkLCcuJyksCiAgICAgICAgICAgIHN5c3RlbSA9ICAgICBPLmZyb21fc3RyaW5nKGNpcmMuc3lzdGVtKSwKICAgICAgICAgICAgdmVyc2lvbiA9ICAgIEJJRy5mcm9tX2RlY2ltYWwoY2lyYy52ZXJzaW9uKSwKICAgICAgICAgICAgbnVtX2F0dHJpYnV0ZXMgPSBCSUcuZnJvbV9kZWNpbWFsKGNpcmMubnVtX2F0dHJpYnV0ZXMpLAogICAgICAgICAgICB6a3NwZWMgPSAgICAgQklHLmZyb21fZGVjaW1hbChjaXJjLnprc3BlYyksCiAgICAgICAgICAgIGhhc2ggICAgICAgPSBPLmZyb21faGV4KGNpcmMuaGFzaCkKICAgICAgICAgICB9KQplbmQKCmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9sb25nZmVsbG93X2NpcmN1aXRfZihjaXJjKQogICAgaWYgbm90IGlzZGljdGlvbmFyeShjaXJjKSB0aGVuCiAgICAgICAgZXJyb3IoImxvbmdmZWxsb3cgY2lyY3VpdCBpcyBub3QgYSBkaWN0aW9uYXJ5IChtaXNzaW5nIG1ldGFkYXRhKSIsMikKICAgIGVuZAogICAgaWYgbm90IGNpcmMuY29tcHJlc3NlZCB0aGVuCiAgICAgICAgZXJyb3IoImxvbmdmZWxsb3cgY2lyY3VpdCBpcyBtaXNzaW5nIGNvbXByZXNzZWQgZGF0YSIsMikKICAgIGVuZAogICAgaWYgbm90IGNpcmMuc3lzdGVtIHRoZW4KICAgICAgICBlcnJvcigibG9uZ2ZlbGxvdyBjaXJjdWl0IGlzIG1pc3Npbmcgc3lzdGVtIG5hbWUiLDIpCiAgICBlbmQKICAgIGlmIG5vdCBjaXJjLnZlcnNpb24gdGhlbgogICAgICAgIGVycm9yKCJsb25nZmVsbG93IGNpcmN1aXQgaXMgbWlzc2luZyB2ZXJzaW9uIG51bWJlciIsMikKICAgIGVuZAogICAgaWYgbm90IGNpcmMubnVtX2F0dHJpYnV0ZXMgdGhlbgogICAgICAgIGVycm9yKCJsb25nZmVsbG93IGNpcmN1aXQgaXMgbWlzc2luZyBudW1iZXIgb2YgYXR0cmlidXRlcyIsMikKICAgIGVuZAogICAgaWYgbm90IGNpcmMuemtzcGVjIHRoZW4KICAgICAgICBlcnJvcigibG9uZ2ZlbGxvdyBjaXJjdWl0IGlzIG1pc3NpbmcgemtzcGVjIHZlcnNpb24iLDIpCiAgICBlbmQKICAgIGxvY2FsIGNvbnYgPGNvbnN0PiA9IENPTkYub3V0cHV0LmVuY29kaW5nLmZ1bgogICAgcmV0dXJuKHsKICAgICAgICAgICAgY29tcHJlc3NlZCA9IGNvbnYoY2lyYy5jb21wcmVzc2VkKSwKICAgICAgICAgICAgc3lzdGVtID0gICAgIE8udG9fc3RyaW5nKGNpcmMuc3lzdGVtKSwKICAgICAgICAgICAgdmVyc2lvbiA9ICAgIHRvbnVtYmVyKEJJRy50b19kZWNpbWFsKGNpcmMudmVyc2lvbikpLAogICAgICAgICAgICBudW1fYXR0cmlidXRlcyA9IHRvbnVtYmVyKEJJRy50b19kZWNpbWFsKGNpcmMubnVtX2F0dHJpYnV0ZXMpKSwKICAgICAgICAgICAgemtzcGVjID0gICAgIHRvbnVtYmVyKEJJRy50b19kZWNpbWFsKGNpcmMuemtzcGVjKSksCiAgICAgICAgICAgIGhhc2ggPSAgICAgICBPLnRvX2hleChzaGEyNTYoY2lyYy5jb21wcmVzc2VkKSkKICAgICAgICAgICB9KQplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9sb25nZmVsbG93X2F0dHJpYnV0ZXNfZih2YWwpCiAgICBsb2NhbCByZXMgPSB7IH0KICAgIGZvciBfLHYgaW4gaXBhaXJzKHZhbCkgZG8KICAgICAgICBsb2NhbCBpbXAgPSB7IGlkID0gTy5mcm9tX3N0cmluZyh2LmlkKSB9CiAgICAgICAgICAgICAgaW1wLnZhbHVlICA9IE8uZnJvbV9zdHJpbmcodi52YWx1ZSkKICAgICAgICB0YWJsZS5pbnNlcnQocmVzLCBpbXApCiAgICBlbmQKICAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfbG9uZ2ZlbGxvd19wcm9vZl9mKHZhbCkKICAgIHJldHVybih7IHprID0gc2NoZW1hX2dldCh2YWwsICd6aycpLAogICAgICAgICAgICAgemtzcGVjID0gc2NoZW1hX2dldCh2YWwsICd6a3NwZWMnLCBJTlQubmV3KSB9KQplbmQKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X2xvbmdmZWxsb3dfcHJvb2ZfZih2YWwpCiAgICByZXR1cm4oeyB6ayA9IE9VVENPTlYodmFsLnprKSwKICAgICAgICAgICAgIHprc3BlYyA9IHRvbnVtYmVyKEJJRy50b19kZWNpbWFsKHZhbC56a3NwZWMpKSB9KQplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIGF0dHJpYnV0ZXMgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGltcG9ydF9sb25nZmVsbG93X2F0dHJpYnV0ZXNfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X2xvbmdmZWxsb3dfYXR0cmlidXRlc19mLAogICAgICAgIH0sCiAgICAgICAgY2lyY3VpdCA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X2xvbmdmZWxsb3dfY2lyY3VpdF9mLAogICAgICAgICAgICBleHBvcnQgPSBleHBvcnRfbG9uZ2ZlbGxvd19jaXJjdWl0X2YKICAgICAgICB9LAogICAgICAgIHByb29mID0gewogICAgICAgICAgICBpbXBvcnQgPSBpbXBvcnRfbG9uZ2ZlbGxvd19wcm9vZl9mLAogICAgICAgICAgICBleHBvcnQgPSBleHBvcnRfbG9uZ2ZlbGxvd19wcm9vZl9mCiAgICAgICAgfQogICAgfQopCgpXaGVuKCJjcmVhdGUgY2lyY3VpdCBpZCAnJyIsIGZ1bmN0aW9uKGNpcmN1aXRfaWQpCiAgICAgICAgIGVtcHR5J2xvbmdmZWxsb3cgY2lyY3VpdCcKICAgICAgICAgbG9jYWwgaWQgPGNvbnN0PiA9IHRvbnVtYmVyKGNpcmN1aXRfaWQpCiAgICAgICAgIEFDSy5jaXJjdWl0ID0gTEYuZ2VuZXJhdGVfY2lyY3VpdChpZCkKICAgICAgICAgbmV3X2NvZGVjJ2NpcmN1aXQnCmVuZCkKCldoZW4oImNyZWF0ZSBwcm9vZiBvZiBhdHRyaWJ1dGVzICcnIGluIG1kb2MgJyciLAogICAgIGZ1bmN0aW9uKGF0dHJpYnV0ZXMsIG1kb2MpCiAgICAgICAgIGVtcHR5J2xvbmdmZWxsb3cgcHJvb2YnCiAgICAgICAgIGxvY2FsIGNpcmMgPGNvbnN0PiA9IGhhdmUnY2lyY3VpdCcKICAgICAgICAgbG9jYWwgdHJhbnMgPGNvbnN0PiA9IGhhdmUndHJhbnNjcmlwdCcKICAgICAgICAgbG9jYWwgbm93IDxjb25zdD4gPSBtYXloYXZlJ25vdycgb3IKICAgICAgICAgICAgIE8uZnJvbV9zdHJpbmcob3MuZGF0ZSgiISVZLSVtLSVkVCVIOiVNOiVTWiIsCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgb3MudGltZShvcy5kYXRlKCIhKnQiKSkpKQogICAgICAgICBsb2NhbCBwayA8Y29uc3Q+ID0gaGF2ZSdwdWJsaWMga2V5JwogICAgICAgICB6ZW5jb2RlX2Fzc2VydCgjcGs9PTY0LCAicHVibGljIGtleSBsZW5ndGggaXMgbm90IDY0IGJ5dGVzIChQMjU2KSIpCiAgICAgICAgIHplbmNvZGVfYXNzZXJ0KFAyNTYucHViY2hlY2socGspLCAiaW52YWxpZCBQMjU2IHB1YmxpYyBrZXkiKQogICAgICAgICBsb2NhbCBhdHRyIDxjb25zdD4gPSBoYXZlKGF0dHJpYnV0ZXMpCiAgICAgICAgIGxvY2FsIGRvY3VtZW50IDxjb25zdD4gPSBoYXZlKG1kb2MpCiAgICAgICAgIGxvY2FsIHBreCA8Y29uc3Q+ID0gcGs6c3ViKDEsMzIpCiAgICAgICAgIGxvY2FsIHBreSA8Y29uc3Q+ID0gcGs6c3ViKDMzLDY0KQogICAgICAgICBBQ0sucHJvb2YgPSBMRi5tZG9jX3Byb3ZlcgogICAgICAgICAoY2lyYywgZG9jdW1lbnQsIHBreCwgcGt5LCB0cmFucywKICAgICAgICAgIGRlZXBtYXAoTy50b19zdHJpbmcsIGF0dHIpLCBub3cpCiAgICAgICAgIHplbmNvZGVfYXNzZXJ0KEFDSy5wcm9vZiwiTG9uZ2ZlbGxvdyBwcm9vZiBnZW5lcmF0aW9uIGVycm9yIikKICAgICAgICAgLS0gVE9ETzogY29udmVydCBhbGwgcHJvb2YgY29udGVudHMgdG8gb2N0ZXRzPwogICAgICAgICBuZXdfY29kZWMncHJvb2YnCmVuZCkKCgpXaGVuKCJ2ZXJpZnkgcHJvb2Ygb2YgYXR0cmlidXRlcyAnJyBpbiBwcm9vZiAnJyIsCiAgICAgZnVuY3Rpb24oYXR0cmlidXRlcywgcHJvb2YpCiAgICAgICAgIGxvY2FsIGNpcmMgPGNvbnN0PiA9IGhhdmUnY2lyY3VpdCcKICAgICAgICAgbG9jYWwgdHJhbnMgPGNvbnN0PiA9IGhhdmUndHJhbnNjcmlwdCcKICAgICAgICAgbG9jYWwgbm93IDxjb25zdD4gPSBtYXloYXZlJ25vdycgb3IKICAgICAgICAgICAgIE8uZnJvbV9zdHJpbmcob3MuZGF0ZSgiISVZLSVtLSVkVCVIOiVNOiVTWiIsCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgb3MudGltZShvcy5kYXRlKCIhKnQiKSkpKQogICAgICAgICBsb2NhbCBwayA8Y29uc3Q+ID0gaGF2ZSdwdWJsaWMga2V5JwogICAgICAgICB6ZW5jb2RlX2Fzc2VydCgjcGs9PTY0LCAicHVibGljIGtleSBsZW5ndGggaXMgbm90IDY0IGJ5dGVzIChQMjU2KSIpCiAgICAgICAgIHplbmNvZGVfYXNzZXJ0KFAyNTYucHViY2hlY2socGspLCAiaW52YWxpZCBQMjU2IHB1YmxpYyBrZXkiKQogICAgICAgICBsb2NhbCBhdHRyIDxjb25zdD4gPSBoYXZlKGF0dHJpYnV0ZXMpCiAgICAgICAgIGxvY2FsIHprIDxjb25zdD4gPSBoYXZlKHByb29mKQogICAgICAgICBsb2NhbCBwa3ggPGNvbnN0PiA9IHBrOnN1YigxLDMyKQogICAgICAgICBsb2NhbCBwa3kgPGNvbnN0PiA9IHBrOnN1YigzMyw2NCkKICAgICAgICAgemVuY29kZV9hc3NlcnQoIExGLm1kb2NfdmVyaWZpZXIKICAgICAgICAgICAgICAgICAgICAgICAgIChjaXJjLCB6aywgcGt4LCBwa3ksIHRyYW5zLAogICAgICAgICAgICAgICAgICAgICAgICAgIGRlZXBtYXAoTy50b19zdHJpbmcsIGF0dHIpLCBub3csCiAgICAgICAgICAgICAgICAgICAgICAgICAgTy5mcm9tX3N0cmluZygnb3JnLmlzby4xODAxMy41LjEubURMJykpLAogICAgICAgICAgICAgICAgICAgICAgICAgIkVycm9yIGluIGxvbmdmZWxsb3cgWksgdmVyaWZpY2F0aW9uOiBpbnZhbGlkIHByb29mIikKICAgICAgICAgLS0gVE9ETzogY29udmVydCBhbGwgcHJvb2YgY29udGVudHMgdG8gb2N0ZXRzPwplbmQpCi96ZW5jb2RlX21hdGgubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgTWF0dGVvIENyaXN0aW5vCi0tb24gVHVlc2RheSwgMTR0aCBKYW51YXJ5IDIwMjUKLS1dXQoKLS0gdHJpbSBsZWFkaW5nIGFuZCB0cmFpbGluZyBzcGFjZXMgYW5kIHVuZGVyc2NvcmVzCmxvY2FsIGZ1bmN0aW9uIHV0cmltKHMpCiAgICBzID0gc3RyaW5nLmdzdWIocywgIl5bJXNfXSsiLCAiIikKICAgIHMgPSBzdHJpbmcuZ3N1YihzLCAiWyVzX10rJCIsICIiKQogICAgcmV0dXJuIHMKZW5kCgotLSBkYXRldGFibGUgb3BlcmF0aW9ucwpsb2NhbCBmdW5jdGlvbiBkYXRlX29wcyhvcCkKICAgIHJldHVybiBmdW5jdGlvbihsLCByKQogICAgICAgIGxvY2FsIHJlcyA9IHt9CiAgICAgICAgbG9jYWwgbGMgPGNvbnN0PiA9IHR5cGUobCkgPT0gJ3plbnJvb20udGltZScgYW5kIG9zLmRhdGUoIip0IiwgdG9udW1iZXIobCkpIG9yIGwgLS0gdHlwZSh0YWJsZSkgY2hlY2tlZCBhbHJlYWR5IGluIG1hdGhfb3AKICAgICAgICBsb2NhbCByYyA8Y29uc3Q+ID0gdHlwZShyKSA9PSAnemVucm9vbS50aW1lJyBhbmQgb3MuZGF0ZSgiKnQiLCB0b251bWJlcihyKSkgb3IgcgogICAgICAgIGxvY2FsIGZpZWxkcyA8Y29uc3Q+ID0geyAneWVhcicsICdtb250aCcsICdkYXknLCAnaG91cicsICdtaW4nLCAnc2VjJyB9CiAgICAgICAgZm9yIF8sIHYgaW4gcGFpcnMoZmllbGRzKSBkbwogICAgICAgICAgICByZXNbdl0gPSBUSU1FLm5ldyhvcCh0b251bWJlcihsY1t2XSkgb3IgMCwgdG9udW1iZXIocmNbdl0pIG9yIDApKQogICAgICAgIGVuZAogICAgICAgIHJldHVybiByZXMKICAgIGVuZAplbmQKCi0tIGJpeW5hcnkgb3BlcmF0aW9ucwpsb2NhbCBvcHMyIDxjb25zdD4gPSB7CiAgICBbJ3plbnJvb20uYmlnJ10gPSB7CiAgICAgICAgWycrJ10gPSBCSUcuemVuYWRkLAogICAgICAgIFsnLSddID0gQklHLnplbnN1YiwKICAgICAgICBbJyonXSA9IEJJRy56ZW5tdWwsCiAgICAgICAgWycvJ10gPSBCSUcuemVuZGl2LAogICAgICAgIFsnJSddID0gQklHLnplbm1vZAogICAgfSwKICAgIFsnemVucm9vbS5mbG9hdCddID0gewogICAgICAgIFsnKyddID0gRi5hZGQsCiAgICAgICAgWyctJ10gPSBGLnN1YiwKICAgICAgICBbJyonXSA9IEYubXVsLAogICAgICAgIFsnLyddID0gRi5kaXYsCiAgICAgICAgWyclJ10gPSBGLm1vZAogICAgfSwKICAgIFsnemVucm9vbS50aW1lJ10gPSB7CiAgICAgICAgWycrJ10gPSBUSU1FLmFkZCwKICAgICAgICBbJy0nXSA9IFRJTUUuc3ViCiAgICB9LAogICAgWyd0YWJsZSddID0gewogICAgICAgIFsnKyddID0gZGF0ZV9vcHMoZnVuY3Rpb24oYSxiKSByZXR1cm4gYStiIGVuZCksCiAgICAgICAgWyctJ10gPSBkYXRlX29wcyhmdW5jdGlvbihhLGIpIHJldHVybiBhLWIgZW5kKQogICAgfQp9CmxvY2FsIGZ1bmN0aW9uIGFwcGx5X29wMihvcCwgYSwgYikKICAgIGxvY2FsIGFfdHlwZSA8Y29uc3Q+ID0gdHlwZShhKQogICAgbG9jYWwgYl90eXBlIDxjb25zdD4gPSB0eXBlKGIpCiAgICAtLSBtYW5hZ2UgdGltZSArIHRhYmxlCiAgICBpZiBhX3R5cGUgPT0gJ3RhYmxlJyBhbmQgYl90eXBlID09ICd6ZW5yb29tLnRpbWUnIHRoZW4KICAgICAgICByZXR1cm4gb3BzMlthX3R5cGVdW29wXShhLCBiKQogICAgZWxzZWlmIGJfdHlwZSA9PSAndGFibGUnIGFuZCBhX3R5cGUgPT0gJ3plbnJvb20udGltZScgdGhlbgogICAgICAgIHJldHVybiBvcHMyW2JfdHlwZV1bb3BdKGEsIGIpCiAgICBlbmQKCiAgICBpZiBhX3R5cGUgfj0gYl90eXBlIHRoZW4KICAgICAgICBlcnJvcigiRGlmZmVyZW50IHR5cGVzIHRvIGRvIGFyaXRobWV0aWNzIG9uOiAiIC4uIGFfdHlwZSAuLiAiIGFuZCAiIC4uIHR5cGUoYiksIDIpCiAgICBlbmQKICAgIGlmIG9wczJbYV90eXBlXSBhbmQgb3BzMlthX3R5cGVdW29wXSB0aGVuCiAgICAgICAgcmV0dXJuIG9wczJbYV90eXBlXVtvcF0oYSwgYikKICAgIGVsc2UKICAgICAgICBlcnJvcigiVW5rbm93biB0eXBlIHRvIGRvIGFyaXRobWV0aWNzIG9uOiAiIC4uIHR5cGUoYSksIDIpCiAgICBlbmQKZW5kCgotLSB1bml0YXJ5IG9wZXJhdGlvbnMKbG9jYWwgb3BzMSA8Y29uc3Q+ID0gewogICAgWyd6ZW5yb29tLmJpZyddID0gewogICAgICAgIFsnfiddID0gQklHLnplbm9wcG9zaXRlCiAgICB9LAogICAgWyd6ZW5yb29tLmZsb2F0J10gPSB7CiAgICAgICAgWyd+J10gPSBGLm9wcG9zaXRlCiAgICB9LAogICAgWyd6ZW5yb29tLnRpbWUnXSA9IHsKICAgICAgICBbJ34nXSA9IFRJTUUub3Bwb3NpdGUKICAgIH0KfQpsb2NhbCBmdW5jdGlvbiBhcHBseV9vcDEob3AsIGEpCiAgICBsb2NhbCBhX3R5cGUgPGNvbnN0PiA9IHR5cGUoYSkKICAgIGlmIG9wczFbYV90eXBlXSBhbmQgb3BzMVthX3R5cGVdW29wXSB0aGVuCiAgICAgICAgcmV0dXJuIG9wczFbYV90eXBlXVtvcF0oYSkKICAgIGVsc2UKICAgICAgICBlcnJvcigiVW5rbm93biB0eXBlIHRvIGRvIGFyaXRobWV0aWNzIG9uOiAiIC4uIHR5cGUoYSksIDIpCiAgICBlbmQKZW5kCgotLSBvcGVyYXRvciBwcmlvcml0aWVzCmxvY2FsIHByaW9yaXRpZXMgPGNvbnN0PiA9IHsKICAgIFsnKyddID0gMCwKICAgIFsnLSddID0gMCwKICAgIFsnKiddID0gMSwKICAgIFsnLyddID0gMSwKICAgIFsnJSddID0gMSwKICAgIFsnfiddID0gMiAtLSB1bmFyeSBtaW51cwp9CgotLSBldmFsIHJwbiBleHByZXNzaW9ucwpsb2NhbCBmdW5jdGlvbiBfcnBuX2V2YWwocnBuKQogICAgLS0gY2FjaGUKICAgIGxvY2FsIHJlbW92ZSA8Y29uc3Q+ID0gdGFibGUucmVtb3ZlCiAgICBsb2NhbCBpbnNlcnQgPGNvbnN0PiA9IHRhYmxlLmluc2VydAogICAgLS0gZXZhbHVhdGUgdGhlIHJwbiBleHByZXNzaW9uCiAgICBsb2NhbCB2YWx1ZXMgPSB7fQogICAgZm9yIF8sIHYgaW4gcGFpcnMocnBuKSBkbwogICAgICAgIGxvY2FsIHJlcwogICAgICAgIGlmIHYgPT0gJ34nIHRoZW4KICAgICAgICAgICAgbG9jYWwgb3AgPSByZW1vdmUodmFsdWVzKQogICAgICAgICAgICBpZiBub3Qgb3AgdGhlbgogICAgICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgYXJpdGhtZXRpY2FsIGV4cHJlc3Npb24iLCAyKQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgcmVzID0gYXBwbHlfb3AxKHYsIG9wKQogICAgICAgIGVsc2VpZiBwcmlvcml0aWVzW3ZdIHRoZW4KICAgICAgICAgICAgbG9jYWwgb3AxID0gcmVtb3ZlKHZhbHVlcykKICAgICAgICAgICAgbG9jYWwgb3AyID0gcmVtb3ZlKHZhbHVlcykKICAgICAgICAgICAgaWYgbm90IG9wMSBvciBub3Qgb3AyIHRoZW4KICAgICAgICAgICAgICAgIGVycm9yKCJJbnZhbGlkIGFyaXRobWV0aWNhbCBleHByZXNzaW9uIiwgMikKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIHJlcyA9IGFwcGx5X29wMih2LCBvcDIsIG9wMSkKICAgICAgICBlbHNlCiAgICAgICAgICAgIGxvY2FsIHQgPGNvbnN0PiA9IHR5cGUodikKICAgICAgICAgICAgLS0gaXMgdGhlIGN1cnJlbnQgbnVtYmVyIGEgaW50ZWdlcj8KICAgICAgICAgICAgaWYgQklHLmlzX2ludGVnZXIodikgdGhlbgogICAgICAgICAgICAgICAgcmVzID0gQklHLm5ldyh2KQogICAgICAgICAgICBlbHNlaWYgRi5pc19mbG9hdCh2KSB0aGVuCiAgICAgICAgICAgICAgICByZXMgPSBGLm5ldyh2KQogICAgICAgICAgICBlbHNlaWYgdCA9PSAnemVucm9vbS5iaWcnIG9yIHQgPT0gJ3plbnJvb20udGltZScgb3IgdCA9PSAnemVucm9vbS5mbG9hdCcgb3IgdCA9PSAndGFibGUnIHRoZW4KICAgICAgICAgICAgICAgIHJlcyA9IHYKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgLS0gaGFuZGxlIHBhdGggZGl2aWRlZCBieSBjb25mIHNlcGFyYXRvciBpbiB2YWx1ZSBuYW1lCiAgICAgICAgICAgICAgICByZXMgPSBwaWNrX2Zyb21fcGF0aCh2LCB0cnVlKQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICBpbnNlcnQodmFsdWVzLCByZXMpCiAgICBlbmQKCiAgICBpZiAjdmFsdWVzIH49IDEgdGhlbgogICAgICAgIGVycm9yKCJJbnZhbGlkIGFyaXRobWV0aWNhbCBleHByZXNzaW9uIiwgMikKICAgIGVuZAogICAgQUNLLnJlc3VsdCA9IHZhbHVlc1sxXQogICAgbG9jYWwgdCA8Y29uc3Q+ID0gdHlwZShBQ0sucmVzdWx0KQogICAgbG9jYWwgbl9jb2RlYyA9IHsKICAgICAgICB6ZW50eXBlID0gJ2UnCiAgICB9CiAgICBpZiB0ID09ICd6ZW5yb29tLmJpZycgdGhlbgogICAgICAgIG5fY29kZWMuZW5jb2RpbmcgPSAnaW50ZWdlcicKICAgIGVsc2VpZiB0ID09ICd6ZW5yb29tLmZsb2F0JyB0aGVuCiAgICAgICAgbl9jb2RlYy5lbmNvZGluZyA9ICdmbG9hdCcKICAgIGVsc2VpZiB0ID09ICd6ZW5yb29tLnRpbWUnIHRoZW4KICAgICAgICBuX2NvZGVjLmVuY29kaW5nID0gJ3RpbWUnCiAgICBlbHNlaWYgdCA9PSAndGFibGUnIHRoZW4KICAgICAgICBuX2NvZGVjLmVuY29kaW5nID0gJ2NvbXBsZXgnCiAgICAgICAgbl9jb2RlYy5zY2hlbWEgPSAnZGF0ZV90YWJsZScKICAgIGVuZAogICAgbmV3X2NvZGVjKCdyZXN1bHQnLCBuX2NvZGVjKQplbmQKCmxvY2FsIGZ1bmN0aW9uIF9jaGVja19ub3RfdGFibGUobmFtZSwgaW5zaWRlKQogICAgbG9jYWwgcywgYyA9IGhhdmUoZmlmKGluc2lkZSwge2luc2lkZSwgbmFtZX0sIG5hbWUpKQogICAgaWYgdHlwZShzKSB+PSAndGFibGUnIHRoZW4gcmV0dXJuIHMgZW5kCiAgICBpZiBjIGFuZCBjLmVuY29kaW5nID09ICdjb21wbGV4JyBhbmQgYy5zY2hlbWEgPT0gJ2RhdGVfdGFibGUnIHRoZW4gcmV0dXJuIHMgZW5kCiAgICB3YXJuKCJUYWJsZSBuZWVkcyB0byBiZSBhZ2dyZWdhdGVkIGJlZm9yZSBkb2luZyBtYXRoIG9wZXJhdGlvbiB3aXRoIGl0OiAiIC4uIG5hbWUpCiAgICBlcnJvcigiRm91bmQgdGFibGUgYXMgaW5wdXQgdG8gbWF0aCBvcGVyYXRpb246ICIgLi4gbmFtZSwgMikKZW5kCgpXaGVuKCJjcmVhdGUgcmVzdWx0IG9mICcnIGludmVydGVkIHNpZ24iLCBmdW5jdGlvbihsZWZ0KQogICAgbG9jYWwgbCA9IF9jaGVja19ub3RfdGFibGUobGVmdCkKICAgIF9ycG5fZXZhbCh7bCwgJ34nfSkKZW5kKQoKV2hlbigiY3JlYXRlIHJlc3VsdCBvZiAnJyArICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcrJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgKyAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQsIGxkaWN0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcrJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgKyAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCwgcmRpY3QpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0LCBsZGljdCkKICAgIGxvY2FsIHIgPSBfY2hlY2tfbm90X3RhYmxlKHJpZ2h0LCByZGljdCkKICAgIF9ycG5fZXZhbCh7bCwgciwgJysnfSkKZW5kKQoKV2hlbigiY3JlYXRlIHJlc3VsdCBvZiAnJyAtICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICctJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgLSAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQsIGxkaWN0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICctJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgLSAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCwgcmRpY3QpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0LCBsZGljdCkKICAgIGxvY2FsIHIgPSBfY2hlY2tfbm90X3RhYmxlKHJpZ2h0LCByZGljdCkKICAgIF9ycG5fZXZhbCh7bCwgciwgJy0nfSkKZW5kKQoKV2hlbigiY3JlYXRlIHJlc3VsdCBvZiAnJyAqICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcqJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgKiAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQsIGxkaWN0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcqJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgKiAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIHJpZ2h0LCByZGljdCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQpCiAgICBsb2NhbCByID0gX2NoZWNrX25vdF90YWJsZShyaWdodCwgcmRpY3QpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcqJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgKiAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCwgcmRpY3QpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0LCBsZGljdCkKICAgIGxvY2FsIHIgPSBfY2hlY2tfbm90X3RhYmxlKHJpZ2h0LCByZGljdCkKICAgIF9ycG5fZXZhbCh7bCwgciwgJyonfSkKZW5kKQoKV2hlbigiY3JlYXRlIHJlc3VsdCBvZiAnJyAvICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcvJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgLyAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQsIGxkaWN0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcvJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgLyAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIHJpZ2h0LCByZGljdCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQpCiAgICBsb2NhbCByID0gX2NoZWNrX25vdF90YWJsZShyaWdodCwgcmRpY3QpCiAgICBfcnBuX2V2YWwoe2wsIHIsICcvJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgLyAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCwgcmRpY3QpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0LCBsZGljdCkKICAgIGxvY2FsIHIgPSBfY2hlY2tfbm90X3RhYmxlKHJpZ2h0LCByZGljdCkKICAgIF9ycG5fZXZhbCh7bCwgciwgJy8nfSkKZW5kKQoKV2hlbigiY3JlYXRlIHJlc3VsdCBvZiAnJyAlICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICclJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgJSAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCkKICAgIGxvY2FsIGwgPSBfY2hlY2tfbm90X3RhYmxlKGxlZnQsIGxkaWN0KQogICAgbG9jYWwgciA9IF9jaGVja19ub3RfdGFibGUocmlnaHQpCiAgICBfcnBuX2V2YWwoe2wsIHIsICclJ30pCmVuZCkKCldoZW4oImNyZWF0ZSByZXN1bHQgb2YgJycgaW4gJycgJSAnJyBpbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIGxkaWN0LCByaWdodCwgcmRpY3QpCiAgICBsb2NhbCBsID0gX2NoZWNrX25vdF90YWJsZShsZWZ0LCBsZGljdCkKICAgIGxvY2FsIHIgPSBfY2hlY2tfbm90X3RhYmxlKHJpZ2h0LCByZGljdCkKICAgIF9ycG5fZXZhbCh7bCwgciwgJyUnfSkKZW5kKQoKLS0gZ2VuZXJpYyBwb2x5bm9taWFsIGV2YWx1YXRpb24KV2hlbigiY3JlYXRlIHJlc3VsdCBvZiAnJyIsIGZ1bmN0aW9uKGV4cHIpCiAgICAtLSBjYWNoZQogICAgbG9jYWwgaW5zZXJ0IDxjb25zdD4gPSB0YWJsZS5pbnNlcnQKICAgIGxvY2FsIHJlbW92ZSA8Y29uc3Q+ID0gdGFibGUucmVtb3ZlCgogICAgZW1wdHkgJ3Jlc3VsdCcKICAgIC0tIHRva2VuaXphdGlvbnMKICAgIGxvY2FsIHJlIDxjb25zdD4gPSAnWygpKiUtJS8rXScKICAgIGxvY2FsIHRva2VucyA9IHt9CiAgICBsb2NhbCBmdW5jdGlvbiBleHRyYWN0X2FuZF9hZGRfdG9rZW4ocmFuZ2Vfc3RhcnQsIHJhbmdlX2VuZCkKICAgICAgICBsb2NhbCB2YWwgPGNvbnN0PiA9IHV0cmltKGV4cHI6c3ViKHJhbmdlX3N0YXJ0LCByYW5nZV9lbmQpKQogICAgICAgIGlmIHZhbCB+PSAiIiB0aGVuIGluc2VydCh0b2tlbnMsIHZhbCkgZW5kCiAgICBlbmQKICAgIGxvY2FsIHN0YXJ0X3BvcyA9IDEKICAgIHdoaWxlIHRydWUgZG8KICAgICAgICBsb2NhbCBtYXRjaF9wb3MgPGNvbnN0PiA9IGV4cHI6ZmluZChyZSwgc3RhcnRfcG9zKQogICAgICAgIGlmIG5vdCBtYXRjaF9wb3MgdGhlbgogICAgICAgICAgICAtLSBpZiBubyBtYXRjaCBmb3VuZCBhZGQgcmVtYWluaW5nIHRva2VuIHRvIHRva2VucwogICAgICAgICAgICBleHRyYWN0X2FuZF9hZGRfdG9rZW4oc3RhcnRfcG9zLCAjZXhwcikKICAgICAgICAgICAgYnJlYWsKICAgICAgICBlbHNlaWYgc3RhcnRfcG9zIDwgbWF0Y2hfcG9zIHRoZW4KICAgICAgICAgICAgLS0gYWRkIHRva2VucyBmaW5kIGJldHdlZW4gb25lIHNwZWNpYWwgc3ltYm9sIGFuZCB0aGUgb3RoZXIKICAgICAgICAgICAgZXh0cmFjdF9hbmRfYWRkX3Rva2VuKHN0YXJ0X3BvcywgbWF0Y2hfcG9zIC0gMSkKICAgICAgICBlbmQKICAgICAgICAtLSBhZGQgbWF0Y2hlZCBzcGVjaWFsIHN5bWJvbCBjaGFyIHRvIHRva2VucwogICAgICAgIGV4dHJhY3RfYW5kX2FkZF90b2tlbihtYXRjaF9wb3MsIG1hdGNoX3BvcykKICAgICAgICBzdGFydF9wb3MgPSBtYXRjaF9wb3MgKyAxCiAgICBlbmQKCiAgICAtLSBpbmZpeCB0byBSUE4KICAgIGxvY2FsIHJwbiA9IHt9CiAgICBsb2NhbCBvcGVyYXRvcnMgPSB7fQogICAgbG9jYWwgZXhwZWN0ZWRfdW5hcnkgPSB0cnVlCiAgICBmb3IgXywgdiBpbiBwYWlycyh0b2tlbnMpIGRvCiAgICAgICAgaWYgdiA9PSAnLScgYW5kIGV4cGVjdGVkX3VuYXJ5IHRoZW4KICAgICAgICAgICAgaW5zZXJ0KG9wZXJhdG9ycywgJ34nKSAtLSB1bmFyeSBtaW51cyAoY2hhbmdlIHNpZ24pCiAgICAgICAgZWxzZWlmIHByaW9yaXRpZXNbdl0gdGhlbgogICAgICAgICAgICB3aGlsZSBuZXh0KG9wZXJhdG9ycykgYW5kIG9wZXJhdG9yc1sjb3BlcmF0b3JzXSB+PSAnKCcgYW5kIHByaW9yaXRpZXNbb3BlcmF0b3JzWyNvcGVyYXRvcnNdXSA+PSBwcmlvcml0aWVzW3ZdIGRvCiAgICAgICAgICAgICAgICBpbnNlcnQocnBuLCByZW1vdmUob3BlcmF0b3JzKSkKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGluc2VydChvcGVyYXRvcnMsIHYpCiAgICAgICAgZWxzZWlmIHYgPT0gJygnIHRoZW4KICAgICAgICAgICAgaW5zZXJ0KG9wZXJhdG9ycywgdikKICAgICAgICBlbHNlaWYgdiA9PSAnKScgdGhlbgogICAgICAgICAgICAtLSBwdXQgZXZlcnkgb3BlcmF0b3IgaW4gcnBuIHVudGlsIEkgZG9uJ3Qgc2VlIHRoZSBvcGVuIHBhcmVucwogICAgICAgICAgICB3aGlsZSBuZXh0KG9wZXJhdG9ycykgYW5kIG9wZXJhdG9yc1sjb3BlcmF0b3JzXSB+PSAnKCcgZG8KICAgICAgICAgICAgICAgIGluc2VydChycG4sIHJlbW92ZShvcGVyYXRvcnMpKQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgemVuY29kZV9hc3NlcnQobmV4dChvcGVyYXRvcnMpLCAiUGFyYW50aGVzaXMgbm90IGJhbGFuY2VkIiwgMikKICAgICAgICAgICAgcmVtb3ZlKG9wZXJhdG9ycykgLS0gcmVtb3ZlIG9wZW4gcGFyZW5zCiAgICAgICAgZWxzZQogICAgICAgICAgICBpbnNlcnQocnBuLCB2KQogICAgICAgIGVuZAogICAgICAgIGV4cGVjdGVkX3VuYXJ5ID0gdiA9PSAnKCcKICAgIGVuZAoKICAgIC0tIGFsbCByZW1haW5pbmcgb3BlcmF0b3JzIGhhdmUgdG8gYmUgYXBwbGllZAogICAgd2hpbGUobmV4dChvcGVyYXRvcnMpKSBkbwogICAgICAgIGxvY2FsIG9wIDxjb25zdD4gPSByZW1vdmUob3BlcmF0b3JzKQogICAgICAgIHplbmNvZGVfYXNzZXJ0KG9wIH49ICcpJywgIlBhcmFudGhlc2lzIG5vdCBiYWxhbmNlZCIsIDIpCiAgICAgICAgaW5zZXJ0KHJwbiwgb3ApCiAgICBlbmQKCiAgICAtLSBldmFsdWF0ZSBycG4gZXhwcmVzc2lvbgogICAgX3Jwbl9ldmFsKHJwbikKZW5kKQovemVuY29kZV9tZXJrbGUubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IE1hdHRlbyBDcmlzdGlubwotLW9uIFR1ZXNkYXksIDh0aCBBcHJpbCAyMDI1Ci0tXV0KCmxvY2FsIGZ1bmN0aW9uIF9oYXNoKGRhdGEsIGhhc2h0eXBlKQogICAgaGFzaHR5cGUgPSBoYXNodHlwZSBvciBDT05GLmhhc2gKICAgIC0tZGVmYXVsdCBoYXNodHlwZTogc2hhMjU2CiAgICAtLXBvc3NpYmxlIGhhc2h0eXBlOgogICAgLS1zaGE1MTIKICAgIC0tc2hhM18yNTYKICAgIC0tc2hhM181MTIKICAgIC0tc2hha2UyNTYKICAgIC0ta2VjY2FrMjU2CiAgICBsb2NhbCBfaGYgPGNvbnN0PiA9IEhBU0g6aW5pdChoYXNodHlwZSkKICAgIHJldHVybiBfaGY6cHJvY2VzcyhkYXRhKQplbmQKCi0tIEZ1bmN0aW9uIHRvIGNyZWF0ZSBhIE1lcmtsZSByb290IGZyb20gYSB0YWJsZSBvZiBkYXRhCmxvY2FsIGZ1bmN0aW9uIF9jcmVhdGVfbWVya2xlX3Jvb3QoZGF0YV90YWJsZSwgaGFzaHR5cGUpCiAgICBsb2NhbCB0cmVlID0ge30KCiAgICAtLSBIYXNoIGVhY2ggcGllY2Ugb2YgZGF0YSBhbmQgYWRkIHRvIHRoZSB0cmVlCiAgICBmb3IgXywgZGF0YSBpbiBpcGFpcnMoZGF0YV90YWJsZSkgZG8KICAgICAgICB0YWJsZS5pbnNlcnQodHJlZSwgX2hhc2goZGF0YSwgaGFzaHR5cGUpKQogICAgZW5kCgogICAgLS0gQnVpbGQgdGhlIHRyZWUgYnkgaGFzaGluZyBwYWlycyBvZiBub2RlcyB1bnRpbCBhIHNpbmdsZSBoYXNoICh0aGUgcm9vdCkgaXMgb2J0YWluZWQKICAgIHdoaWxlICN0cmVlID4gMSBkbwogICAgICAgIGxvY2FsIHRlbXBfdHJlZSA9IHt9CiAgICAgICAgZm9yIGkgPSAxLCAjdHJlZSwgMiBkbwogICAgICAgICAgICBpZiBpICsgMSA8PSAjdHJlZSB0aGVuCiAgICAgICAgICAgICAgICBsb2NhbCBjb25jYXRlbmF0ZWRfaGFzaGVzID0gdHJlZVtpXSAuLiB0cmVlW2kgKyAxXQogICAgICAgICAgICAgICAgdGFibGUuaW5zZXJ0KHRlbXBfdHJlZSwgX2hhc2goY29uY2F0ZW5hdGVkX2hhc2hlcywgaGFzaHR5cGUpKQogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICB0YWJsZS5pbnNlcnQodGVtcF90cmVlLCB0cmVlW2ldKQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICB0cmVlID0gdGVtcF90cmVlCiAgICBlbmQKCiAgICByZXR1cm4gdHJlZVsxXSAtLSBUaGUgTWVya2xlIHJvb3QKZW5kCgpsb2NhbCBmdW5jdGlvbiBfemVuY29kZV9tZXJrbGVfcm9vdChuYW1lLCBoYXNodHlwZSkKICAgIGxvY2FsIGRhdGEgPSBwaWNrX2Zyb21fcGF0aChuYW1lLCB0cnVlKQogICAgaWYgbm90IGRhdGEgb3IgdHlwZShkYXRhKSB+PSAndGFibGUnIHRoZW4KICAgICAgICBlcnJvcigiVGFibGUgbm90IGZvdW5kIGluIHBhdGg6ICIuLm5hbWUsIDIpCiAgICBlbmQKICAgIEFDSy5tZXJrbGVfcm9vdCA9IF9jcmVhdGVfbWVya2xlX3Jvb3QoZGF0YSwgaGFzaHR5cGUpCiAgICByZXR1cm4gbmV3X2NvZGVjKCdtZXJrbGUgcm9vdCcsIHt6ZW50eXBlID0gInN0cmluZyJ9KQplbmQKCldoZW4oImNyZWF0ZSBtZXJrbGUgcm9vdCBvZiAnJyIsIF96ZW5jb2RlX21lcmtsZV9yb290KQpXaGVuKCJjcmVhdGUgbWVya2xlIHJvb3Qgb2YgJycgdXNpbmcgaGFzaCAnJyIsIF96ZW5jb2RlX21lcmtsZV9yb290KQpXaGVuKCJjcmVhdGUgbWVya2xlIHJvb3Qgb2YgZGljdGlvbmFyeSBwYXRoICcnIiwgX3plbmNvZGVfbWVya2xlX3Jvb3QpCldoZW4oImNyZWF0ZSBtZXJrbGUgcm9vdCBvZiBkaWN0aW9uYXJ5IHBhdGggJycgdXNpbmcgaGFzaCAnJyIsIF96ZW5jb2RlX21lcmtsZV9yb290KQoKLS0gRnVuY3Rpb24gdG8gdmVyaWZ5IHRoZSBpbnRlZ3JpdHkgb2YgYSBNZXJrbGUgcm9vdApsb2NhbCBmdW5jdGlvbiBfdmVyaWZ5X21lcmtsZV9yb290KHJvb3QsIG5hbWUpCiAgICAKICAgIGxvY2FsIGRhdGFfdGFibGUgPSBwaWNrX2Zyb21fcGF0aChuYW1lLCB0cnVlKQogICAgbG9jYWwgbWVya2xlX3Jvb3QgPSBBQ0tbcm9vdF0KICAgIAogICAgaWYgbm90IGRhdGFfdGFibGUgb3Igbm90IG1lcmtsZV9yb290IHRoZW4KICAgICAgICBlcnJvcigiSW5zZXJ0ZWQgdmFsdWVzIHNob3VsZCBiZSBub3QgbmlsbCIsIDIpCiAgICBlbmQgCgogICAgaWYgdHlwZShkYXRhX3RhYmxlKSB+PSAndGFibGUnIHRoZW4KICAgICAgICBlcnJvcigiVGFibGUgbm90IGZvdW5kIGluIHBhdGg6ICIuLm5hbWUsIDIpCiAgICBlbmQgCgogICAgbG9jYWwgY29tcHV0ZWRfcm9vdCA9IF9jcmVhdGVfbWVya2xlX3Jvb3QoZGF0YV90YWJsZSkKCiAgICBpZiBjb21wdXRlZF9yb290IH49IG1lcmtsZV9yb290IHRoZW4KICAgICAgICBlcnJvcigiVmVyaWZpY2F0aW9uIGZhaWw6IGVsZW1lbnRzIGFyZSBub3QgZXF1YWwiLCAyKQogICAgZW5kCgogICAgcmV0dXJuIGNvbXB1dGVkX3Jvb3QgPT0gbWVya2xlX3Jvb3QKZW5kCgpXaGVuKCJ2ZXJpZnkgbWVya2xlIHJvb3QgJycgb2YgJyciLCBfdmVyaWZ5X21lcmtsZV9yb290KQpXaGVuKCJ2ZXJpZnkgbWVya2xlIHJvb3QgJycgb2YgZGljdGlvbmFyeSBwYXRoICcnIiwgX3ZlcmlmeV9tZXJrbGVfcm9vdCkKCgoKLS0gRnVuY3Rpb24gdG8gY3JlYXRlIGEgTWVya2xlIHRyZWUgZnJvbSBhIHRhYmxlIG9mIGRhdGEKbG9jYWwgZnVuY3Rpb24gX2NyZWF0ZV9tZXJrbGVfdHJlZShkYXRhX3RhYmxlLCBoYXNodHlwZSkKICAgIGxvY2FsIHRyZWUgPSB7fQoKICAgIC0tIEhhc2ggZWFjaCBwaWVjZSBvZiBkYXRhIGFuZCBhZGQgdG8gdGhlIHRyZWUgKHRyZWUgYmFzaXMgbGVhZnMpCiAgICBmb3IgXywgZGF0YSBpbiBpcGFpcnMoZGF0YV90YWJsZSkgZG8KICAgICAgICB0YWJsZS5pbnNlcnQodHJlZSwgX2hhc2goZGF0YSwgaGFzaHR5cGUpKQogICAgZW5kCgogICAgbG9jYWwgdGVtcF90cmVlID0gdHJlZSAKCiAgICAtLSBCdWlsZCB0aGUgdHJlZSBieSBoYXNoaW5nIHBhaXJzIG9mIG5vZGVzIHVudGlsIGEgc2luZ2xlIGhhc2ggKHRoZSByb290KSBpcyBvYnRhaW5lZAogICAgd2hpbGUgI3RlbXBfdHJlZSA+IDEgZG8gICAgCiAgICAgICAgbG9jYWwgdGVtcF90cmVlX3N0ZXAgPSB7fQogICAgICAgIGZvciBpID0gMSwgI3RlbXBfdHJlZSwgMiBkbwogICAgICAgICAgICBpZiBpICsgMSA8PSAjdGVtcF90cmVlIHRoZW4gICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICBsb2NhbCBjb25jYXRlbmF0ZWRfaGFzaGVzID0gdGVtcF90cmVlW2ldIC4uIHRlbXBfdHJlZVtpICsgMV0KICAgICAgICAgICAgICAgIHRhYmxlLmluc2VydCh0cmVlLCBfaGFzaChjb25jYXRlbmF0ZWRfaGFzaGVzLCBoYXNodHlwZSkpCiAgICAgICAgICAgICAgICB0YWJsZS5pbnNlcnQodGVtcF90cmVlX3N0ZXAsIF9oYXNoKGNvbmNhdGVuYXRlZF9oYXNoZXMsIGhhc2h0eXBlKSApCiAgICAgICAgICAgIGVsc2UKICAgICAgICAgICAgICAgIHRhYmxlLmluc2VydCh0cmVlLCB0ZW1wX3RyZWVbaV0pCiAgICAgICAgICAgICAgICB0YWJsZS5pbnNlcnQodGVtcF90cmVlX3N0ZXAsIHRlbXBfdHJlZVtpXSkgICAgCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgICAgIHRlbXBfdHJlZSA9IHRlbXBfdHJlZV9zdGVwCiAgICBlbmQKICAgIAogICAgcmV0dXJuIHRyZWUgLS0gVGhlIG1lcmtsZSB0cmVlIAogICAgCmVuZAoKCmxvY2FsIGZ1bmN0aW9uIF9jcmVhdGVfbWVya2xlX3RyZWUyKGRhdGFfdGFibGUsIGhhc2h0eXBlKQogICAgbG9jYWwgTiA9ICNkYXRhX3RhYmxlCiAgICAtLWNyZWF0aW9uIG9mIHRoZSBlbXB0eSB0cmVlCiAgICBsb2NhbCB0cmVlID0ge30KICAgIGZvciBpID0gMSwgMipOIGRvCiAgICAgICAgdHJlZVtpXSA9ICIwIgogICAgZW5kCgogICAgLS1oYXNoaW5nIHRoZSBkYXRhIGlucHV0IGEgZmlsbGluZyB0aGUgZW5kIG9mIHRoZSB0cmVlCiAgICBmb3IgaSA9IE4gKyAxLCAyKk4gZG8KICAgICAgICB0cmVlW2ldID0gX2hhc2goZGF0YV90YWJsZVtpIC0gTl0sIGhhc2h0eXBlKQogICAgZW5kIAogICAgCiAgICAtLWZpbGxpbmcgdGhlIHZlY3RvciB0cmVlOiB0aGUgbm9kZSBpbiBwb3NpdGlvbiBpIGhhcyBhcyBsZWFmcyB0aGUgbm9kZXMgaW4gcG9zaXRpb24gMmkgYW5kIDJpKzEKICAgIGZvciBpID0gTiwgMiwgLTEgZG8KICAgICAgICBsb2NhbCBjb25jYXRlbmF0ZWQgPSB0cmVlWzIqaSAtIDFdIC4uIHRyZWVbMippXQogICAgICAgIHRyZWVbaV0gPSBfaGFzaChjb25jYXRlbmF0ZWQsIGhhc2h0eXBlKQogICAgZW5kIAogICAgCiAgICByZXR1cm4gdHJlZQogICAgICAKZW5kL3plbmNvZGVfcGFjay5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjItMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tXV0KCi0tIFRPRE86IGRpc3Rpbmd1aXNoIHpwYWNrIGFuZCBtcGFjawpXaGVuKCJjcmVhdGUgbXBhY2sgb2YgJyciLCBmdW5jdGlvbihzcmMpCiAgICBlbXB0eSdtcGFjaycKICAgIGxvY2FsIHNvdXJjZSA9IGhhdmUoc3JjKQogICAgbG9jYWwgdG1wID0gTVBBQ0suZW5jb2RlKHNvdXJjZSkKICAgIEFDSy5tcGFjayA9IE9DVEVULmZyb21fcmF3bGVuKCB0bXAsICN0bXAgKQogICAgbmV3X2NvZGVjKCdtcGFjaycsIHsgemVudHlwZSA9ICdlJ30pCmVuZCkKCldoZW4oImNyZWF0ZSAnJyBkZWNvZGVkIGZyb20gbXBhY2sgJyciLCBmdW5jdGlvbihkc3QsIHNyYykKICAgIGVtcHR5KGRzdCkKICAgIGxvY2FsIHBhY2sgPSBoYXZlKHNyYykKICAgIHplbmNvZGVfYXNzZXJ0KENPREVDW3NyY10uemVudHlwZSA9PSAnZScsICJJbnZhbGlkIG1wYWNrLCBub3QgYW4gZWxlbWVudDogIi4uc3JjKQogICAgemVuY29kZV9hc3NlcnQodHlwZShwYWNrKSA9PSAnemVucm9vbS5vY3RldCcsICJJbnZhbGlkIG1wYWNrLCBub3QgYW4gb2N0ZXQ6ICIuLnNyYykKICAgIEFDS1tkc3RdID0gTVBBQ0suZGVjb2RlKCBPQ1RFVC50b19zdHJpbmcoIHBhY2sgKSApCiAgICBuZXdfY29kZWMoZHN0KQplbmQpCi96ZW5jb2RlX3BldGl0aW9uLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBUdWVzZGF5LCAyMHRoIEp1bHkgMjAyMQotLV1dCgpsb2NhbCBDUkVEID0gcmVxdWlyZV9vbmNlJ2NyeXB0b19jcmVkZW50aWFsJwpsb2NhbCBQRVQgPSByZXF1aXJlX29uY2UnY3J5cHRvX3BldGl0aW9uJwoKbG9jYWwgZnVuY3Rpb24gcGV0aXRpb25fc2NvcmVzX2YobykKCWxvY2FsIG9iaiA9IGRlZXBtYXAoQ09ORi5pbnB1dC5lbmNvZGluZy5mdW4sIG8pCglyZXR1cm4gKHsKCQlwb3MgPSB7CgkJCWxlZnQgPSBzY2hlbWFfZ2V0KG9iai5wb3MsICdsZWZ0JywgRUNQLm5ldyksCgkJCXJpZ2h0ID0gc2NoZW1hX2dldChvYmoucG9zLCAncmlnaHQnLCBFQ1AubmV3KQoJCX0sCgkJbmVnID0gewoJCQlsZWZ0ID0gc2NoZW1hX2dldChvYmoubmVnLCAnbGVmdCcsIEVDUC5uZXcpLAoJCQlyaWdodCA9IHNjaGVtYV9nZXQob2JqLm5lZywgJ3JpZ2h0JywgRUNQLm5ldykKCQl9Cgl9KQplbmQKCgotLSBwZXRpdGlvbgpaRU46YWRkX3NjaGVtYSgKCXsKCQlwZXRpdGlvbl9zY29yZXMgPSBwZXRpdGlvbl9zY29yZXNfZiwKCQlwZXRpdGlvbiA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQogICAgICAgICAgICAgICAgbG9jYWwgcmVzID0gewogICAgICAgICAgICAgICAgICAgIHVpZCA9IHNjaGVtYV9nZXQob2JqLCAndWlkJyksCiAgICAgICAgICAgICAgICAgICAgc2NvcmVzID0gcGV0aXRpb25fc2NvcmVzX2Yob2JqLnNjb3JlcykKICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgICAgIGlmIG9iai5vd25lciB0aGVuCiAgICAgICAgICAgICAgICAgICAgcmVzLm93bmVyID0gc2NoZW1hX2dldChvYmosICdvd25lcicsIEVDUC5uZXcpCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgICAgIGlmIG9iai5pc3N1ZXJfcHVibGljX2tleSB0aGVuCgkJCQkgICBsb2NhbCBmID0gWkVOLnNjaGVtYXNbJ2lzc3Vlcl9wdWJsaWNfa2V5J10uaW1wb3J0CgkJCQkgICByZXMuaXNzdWVyX3B1YmxpY19rZXkgPSBmKG9iai5pc3N1ZXJfcHVibGljX2tleSkKICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICAgICAgaWYgb2JqLmxpc3QgdGhlbgogICAgICAgICAgICAgICAgICAgIHJlcy5saXN0ID0KICAgICAgICAgICAgICAgICAgICBkZWVwbWFwKAogICAgICAgICAgICAgICAgICAgIGZ1bmN0aW9uKG8pCiAgICAgICAgICAgICAgICAgICAgICAgIHJldHVybiBzY2hlbWFfZ2V0KG8sICcuJywgRUNQLm5ldykKICAgICAgICAgICAgICAgICAgICBlbmQsCiAgICAgICAgICAgICAgICAgICAgb2JqLmxpc3QKICAgICAgICAgICAgICAgICAgICApCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgICAgIGlmIG9iai5zaWduYXR1cmUgdGhlbgogICAgICAgICAgICAgICAgICAgIHJlcy5zaWduYXR1cmUgPSB7CiAgICAgICAgICAgICAgICAgICAgICAgIHIgPSBzY2hlbWFfZ2V0KG9iai5zaWduYXR1cmUsICdyJyksCiAgICAgICAgICAgICAgICAgICAgICAgIHMgPSBzY2hlbWFfZ2V0KG9iai5zaWduYXR1cmUsICdzJykKICAgICAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgICAgIHJldHVybiByZXMKICAgICAgICAgICAgZW5kLAogICAgICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopCiAgICAgICAgICAgICAgICByZXR1cm4gb2JqCiAgICAgICAgICAgIGVuZCwKICAgICAgICB9LAoJCXBldGl0aW9uX3NpZ25hdHVyZSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQogICAgICAgICAgICAgICAgcmV0dXJuIHsKICAgICAgICAgICAgICAgICAgICAtLSBmcm9tIHplbmNvZGVfY3JlZGVudGlhbAogICAgICAgICAgICAgICAgICAgIHByb29mID0gaW1wb3J0X2NyZWRlbnRpYWxfcHJvb2ZfZihvYmoucHJvb2YpLAogICAgICAgICAgICAgICAgICAgIHVpZF9zaWduYXR1cmUgPSBzY2hlbWFfZ2V0KG9iaiwgJ3VpZF9zaWduYXR1cmUnLCBFQ1AubmV3KSwKICAgICAgICAgICAgICAgICAgICB1aWRfcGV0aXRpb24gPSBzY2hlbWFfZ2V0KG9iaiwgJ3VpZF9wZXRpdGlvbicpCiAgICAgICAgICAgICAgICB9CiAgICAgICAgICAgIGVuZCwKICAgICAgICAgICAgZXhwb3J0ID0gZnVuY3Rpb24gKG9iaikKICAgICAgICAgICAgICAgIG9iai5wcm9vZiA9IGV4cG9ydF9jcmVkZW50aWFsX3Byb29mX2Yob2JqLnByb29mKQogICAgICAgICAgICAgICAgcmV0dXJuIG9iagogICAgICAgICAgICBlbmQsCiAgICAgICAgfSwKCQlwZXRpdGlvbl90YWxseSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQogICAgICAgICAgICAgICAgbG9jYWwgZGVjID0ge30KICAgICAgICAgICAgICAgIGRlYy5uZWcgPSBzY2hlbWFfZ2V0KG9iai5kZWMsICduZWcnLCBFQ1AubmV3KQogICAgICAgICAgICAgICAgZGVjLnBvcyA9IHNjaGVtYV9nZXQob2JqLmRlYywgJ3BvcycsIEVDUC5uZXcpCiAgICAgICAgICAgICAgICByZXR1cm4gewogICAgICAgICAgICAgICAgICAgIHVpZCA9IHNjaGVtYV9nZXQob2JqLCAndWlkJyksCiAgICAgICAgICAgICAgICAgICAgYyA9IHNjaGVtYV9nZXQob2JqLCAnYycsIElOVC5uZXcsIE8uZnJvbV9iYXNlNjQpLAogICAgICAgICAgICAgICAgICAgIGRlYyA9IGRlYywKICAgICAgICAgICAgICAgICAgICByeCA9IHNjaGVtYV9nZXQob2JqLCAncngnLCBJTlQubmV3LCBPLmZyb21fYmFzZTY0KSwKICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgZW5kLAogICAgICAgICAgICBleHBvcnQgPSBmdW5jdGlvbihvYmopCgkJIHJldHVybiB7CgkJICAgIHVpZCA9IG9iai51aWQsCgkJICAgIGMgPSBvYmouYzpvY3RldCgpOmJhc2U2NCgpLAoJCSAgICBkZWMgPSBvYmouZGVjLAoJCSAgICByeCA9IG9iai5yeDpvY3RldCgpOmJhc2U2NCgpCgkJIH0KCSAgICAgIGVuZCwKICAgICAgICB9LAoJfQopCgpXaGVuKCJjcmVhdGUgcGV0aXRpb24gJyciLGZ1bmN0aW9uKHVpZCkKCQloYXZla2V5J2NyZWRlbnRpYWwnCgkJLS0gemVuY29kZV9hc3NlcnQoQUNLLmtleXJpbmcuY3JlZGVudGlhbCwiQ3JlZGVudGlhbCBrZXkgbm90IGZvdW5kIikKCQlBQ0sucGV0aXRpb24gPSB7CgkJCXVpZCA9IE9DVEVULmZyb21fc3RyaW5nKHVpZCksIC0tIFRPRE86IHRha2UgVUlEIGZyb20gSEVBUCBub3QgU1RBQ0sKCQkJb3duZXIgPSBFQ1AuZ2VuZXJhdG9yKCkgKiBBQ0sua2V5cmluZy5jcmVkZW50aWFsLAoJCQlzY29yZXMgPSB7CgkJCQlwb3MgPSB7CgkJCQkJbGVmdCA9IEVDUC5pbmZpbml0eSgpLAoJCQkJCXJpZ2h0ID0gRUNQLmluZmluaXR5KCkKCQkJCX0sCgkJCQluZWcgPSB7CgkJCQkJbGVmdCA9IEVDUC5pbmZpbml0eSgpLAoJCQkJCXJpZ2h0ID0gRUNQLmluZmluaXR5KCkKCQkJCX0KCQkJfQoJCX0KCQluZXdfY29kZWMoJ3BldGl0aW9uJykKCQktLSBnZW5lcmF0ZSBhbiBFQ0RIIHNpZ25hdHVyZSBvZiB0aGUgKGVuY29kZWQpIHBldGl0aW9uIHVzaW5nIHRoZQoJCS0tIGNyZWRlbnRpYWwga2V5cwoJCS0tIGVjZGggPSBFQ0RILm5ldygpCgkJLS0gZWNkaDpwcml2YXRlKEFDSy5jcmVkX2twLnByaXZhdGUpCgkJLS0gQUNLLnBldGl0aW9uX2VjZGhfc2lnbiA9IHsgZWNkaDpzaWduKE1TRy5wYWNrKE9VVC5wZXRpdGlvbikpIH0KCQktLSBPVVQucGV0aXRpb25fZWNkaF9zaWduID0gbWFwKEFDSy5wZXRpdGlvbl9lY2RoX3NpZ24sIGhleCkKZW5kKQoKV2hlbigidmVyaWZ5IG5ldyBwZXRpdGlvbiB0byBiZSBlbXB0eSIsZnVuY3Rpb24oKQoJCXplbmNvZGVfYXNzZXJ0KAoJCQlFQ1AuaXNpbmYoQUNLLnBldGl0aW9uLnNjb3Jlcy5wb3MubGVmdCksCgkJCSdJbnZhbGlkIG5ldyBwZXRpdGlvbjogcG9zaXRpdmUgbGVmdCBzY29yZSBpcyBub3QgemVybycKCQkpCgkJemVuY29kZV9hc3NlcnQoCgkJCUVDUC5pc2luZihBQ0sucGV0aXRpb24uc2NvcmVzLnBvcy5yaWdodCksCgkJCSdJbnZhbGlkIG5ldyBwZXRpdGlvbjogcG9zaXRpdmUgcmlnaHQgc2NvcmUgaXMgbm90IHplcm8nCgkJKQoJCXplbmNvZGVfYXNzZXJ0KAoJCQlFQ1AuaXNpbmYoQUNLLnBldGl0aW9uLnNjb3Jlcy5uZWcubGVmdCksCgkJCSdJbnZhbGlkIG5ldyBwZXRpdGlvbjogbmVnYXRpdmUgbGVmdCBzY29yZSBpcyBub3QgemVybycKCQkpCgkJemVuY29kZV9hc3NlcnQoCgkJCUVDUC5pc2luZihBQ0sucGV0aXRpb24uc2NvcmVzLm5lZy5yaWdodCksCgkJCSdJbnZhbGlkIG5ldyBwZXRpdGlvbjogbmVnYXRpdmUgcmlnaHQgc2NvcmUgaXMgbm90IHplcm8nCgkJKQplbmQpCgpXaGVuKCJjcmVhdGUgcGV0aXRpb24gc2lnbmF0dXJlICcnIixmdW5jdGlvbih1aWQpCgkJaGF2ZSdjcmVkZW50aWFscycKCQloYXZlJ2lzc3VlciBwdWJsaWMga2V5JwoJCWhhdmVrZXknY3JlZGVudGlhbCcKCQlsb2NhbCBUaGV0YQoJCWxvY2FsIHpldGEKCQlsb2NhbCBhY2tfdWlkID0gT0NURVQuZnJvbV9zdHJpbmcodWlkKQoJCVRoZXRhLCB6ZXRhID0KCQkJQ1JFRC5wcm92ZV9jcmVkX3VpZCgKCQkJQUNLLmlzc3Vlcl9wdWJsaWNfa2V5LAoJCQlBQ0suY3JlZGVudGlhbHMsCgkJCUFDSy5rZXlyaW5nLmNyZWRlbnRpYWwsCgkJCWFja191aWQKCQkpCgkJQUNLLnBldGl0aW9uX3NpZ25hdHVyZSA9IHsKCQkJcHJvb2YgPSBUaGV0YSwKCQkJdWlkX3NpZ25hdHVyZSA9IHpldGEsIC0tIEVDUAoJCQl1aWRfcGV0aXRpb24gPSBhY2tfdWlkCgkJfQogICAgICAgIG5ld19jb2RlYygncGV0aXRpb25fc2lnbmF0dXJlJykKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgc2lnbmF0dXJlIHByb29mIGlzIGNvcnJlY3QiLGZ1bmN0aW9uKCkKCQl6ZW5jb2RlX2Fzc2VydCgKCQkJQ1JFRC52ZXJpZnlfY3JlZF91aWQoCgkJCQlBQ0suaXNzdWVyX3B1YmxpY19rZXksCgkJCQlBQ0sucGV0aXRpb25fc2lnbmF0dXJlLnByb29mLAoJCQkJQUNLLnBldGl0aW9uX3NpZ25hdHVyZS51aWRfc2lnbmF0dXJlLAoJCQkJQUNLLnBldGl0aW9uX3NpZ25hdHVyZS51aWRfcGV0aXRpb24KCQkJKSwKCQkJJ1BldGl0aW9uIHNpZ25hdHVyZSBpcyBpbnZhbGlkJwoJCSkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgcGV0aXRpb24gc2lnbmF0dXJlIGlzIG5vdCBhIGR1cGxpY2F0ZSIsIGZ1bmN0aW9uKCkKICAgIGlmIGx1YXR5cGUoQUNLLnBldGl0aW9uLmxpc3QpID09ICd0YWJsZScgdGhlbgogICAgICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICAgICAgKG5vdCBhcnJheV9jb250YWlucygKICAgICAgICAgICAgICAgIEFDSy5wZXRpdGlvbi5saXN0LAogICAgICAgICAgICAgICAgQUNLLnBldGl0aW9uX3NpZ25hdHVyZS51aWRfc2lnbmF0dXJlCiAgICAgICAgICAgICkpLAogICAgICAgICAgICAnRHVwbGljYXRlIHBldGl0aW9uIHNpZ25hdHVyZSBkZXRlY3RlZCcKICAgICAgICApIHRoZW4gcmV0dXJuIGVuZAogICAgZWxzZQogICAgICAgIEFDSy5wZXRpdGlvbi5saXN0ID0ge30KICAgIGVuZAogICAgdGFibGUuaW5zZXJ0KEFDSy5wZXRpdGlvbi5saXN0LCBBQ0sucGV0aXRpb25fc2lnbmF0dXJlLnVpZF9zaWduYXR1cmUpCmVuZCkKCklmV2hlbigidmVyaWZ5IHBldGl0aW9uIHNpZ25hdHVyZSBpcyBqdXN0IG9uZSBtb3JlIiwgZnVuY3Rpb24oKQogICAgLS0gdmVyaWZ5IHRoYXQgdGhlIHNpZ25hdHVyZSBpcyArMSAobm8gb3RoZXIgdmFsdWUgc3VwcG9ydGVkKQogICAgQUNLLnBldGl0aW9uX3NpZ25hdHVyZS5vbmUgPQogICAgICAgIFBFVC5wcm92ZV9zaWduX3BldGl0aW9uKEFDSy5wZXRpdGlvbi5vd25lciwgQklHLm5ldygxKSkKICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICAgIFBFVC52ZXJpZnlfc2lnbl9wZXRpdGlvbigKICAgICAgICAgICAgQUNLLnBldGl0aW9uLm93bmVyLAogICAgICAgICAgICBBQ0sucGV0aXRpb25fc2lnbmF0dXJlLm9uZQogICAgICAgICksCiAgICAgICAgJ0FCQyBwZXRpdGlvbiBzaWduYXR1cmUgYWRkcyBtb3JlIHRoYW4gb25lIHNpZ25hdHVyZScKICAgICkKCmVuZCkKCldoZW4oImFkZCBzaWduYXR1cmUgdG8gcGV0aXRpb24iLGZ1bmN0aW9uKCkKCQktLSBhZGQgdGhlIHNpZ25hdHVyZSB0byB0aGUgcGV0aXRpb24gY291bnQKCQlsb2NhbCBzY29yZXMgPSBBQ0sucGV0aXRpb24uc2NvcmVzCgkJbG9jYWwgcHNpZ24gPSBBQ0sucGV0aXRpb25fc2lnbmF0dXJlLm9uZQoJCXNjb3Jlcy5wb3MubGVmdCA9IHNjb3Jlcy5wb3MubGVmdCArIHBzaWduLnNjb3Jlcy5wb3MubGVmdAoJCXNjb3Jlcy5wb3MucmlnaHQgPSBzY29yZXMucG9zLnJpZ2h0ICsgcHNpZ24uc2NvcmVzLnBvcy5yaWdodAoJCXNjb3Jlcy5uZWcubGVmdCA9IHNjb3Jlcy5uZWcubGVmdCArIHBzaWduLnNjb3Jlcy5uZWcubGVmdAoJCXNjb3Jlcy5uZWcucmlnaHQgPSBzY29yZXMubmVnLnJpZ2h0ICsgcHNpZ24uc2NvcmVzLm5lZy5yaWdodAoJCS0tIFRPRE86IFpFTjpwdXNoKHsncGV0aXRpb24nICwnc2NvcmVzJ30KCQlBQ0sucGV0aXRpb24uc2NvcmVzID0gc2NvcmVzCmVuZCkKCldoZW4oImNyZWF0ZSBhIHBldGl0aW9uIHRhbGx5IixmdW5jdGlvbigpCgkJaGF2ZWtleSdjcmVkZW50aWFsJwoJCXplbmNvZGVfYXNzZXJ0KEFDSy5wZXRpdGlvbiwgJ1BldGl0aW9uIG5vdCBmb3VuZCcpCgkJQUNLLnBldGl0aW9uX3RhbGx5ID0KCQkJUEVULnByb3ZlX3RhbGx5X3BldGl0aW9uKAoJCQlBQ0sua2V5cmluZy5jcmVkZW50aWFsLAoJCQlBQ0sucGV0aXRpb24uc2NvcmVzCgkJKQoJCUFDSy5wZXRpdGlvbl90YWxseS51aWQgPSBBQ0sucGV0aXRpb24udWlkCiAgICAgICAgbmV3X2NvZGVjKCdwZXRpdGlvbl90YWxseScpCmVuZCkKCldoZW4oImNvdW50IHBldGl0aW9uIHJlc3VsdHMiLGZ1bmN0aW9uKCkKCQl6ZW5jb2RlX2Fzc2VydChBQ0sucGV0aXRpb24sICdQZXRpdGlvbiBub3QgZm91bmQnKQoJCXplbmNvZGVfYXNzZXJ0KEFDSy5wZXRpdGlvbl90YWxseSwgJ1RhbGx5IG5vdCBmb3VuZCcpCgkJemVuY29kZV9hc3NlcnQoCgkJCUFDSy5wZXRpdGlvbl90YWxseS51aWQgPT0gQUNLLnBldGl0aW9uLnVpZCwKCQkJJ1RhbGx5IGRvZXMgbm90IGNvcnJlc3BvbmQgdG8gcGV0aXRpb24nCgkJKQoJCUFDSy5wZXRpdGlvbl9yZXN1bHRzID0KCQkJSU5ULm5ldyhQRVQuY291bnRfc2lnbmF0dXJlc19wZXRpdGlvbigKCQkJQUNLLnBldGl0aW9uLnNjb3JlcywKCQkJQUNLLnBldGl0aW9uX3RhbGx5CgkJKS5wb3MpCiAgICAgICAgbmV3X2NvZGVjKCdwZXRpdGlvbl9yZXN1bHRzJykKZW5kKQovemVuY29kZV9wbGFuZXRtaW50Lmx1YQAKbG9jYWwgRUQgPSByZXF1aXJlJ2VkJwoKV2hlbigiY3JlYXRlIHBsYW5ldG1pbnQgc2lnbmF0dXJlcyBvZiAnJyIsIGZ1bmN0aW9uKHR4KQogICAgZW1wdHkncGxhbmV0bWludF9zaWduYXR1cmVzJwogICAgbG9jYWwgc2VyaWFsaXplZF90eCA9IGhhdmUodHgpOnN0cmluZygpCiAgICBsb2NhbCB0eCA9IEpTT04uZGVjb2RlKHNlcmlhbGl6ZWRfdHgpCgogICAgbG9jYWwgc2sgPSBoYXZla2V5J2VkZHNhJwogICAgbG9jYWwgcGxhbmV0bWludF9vdXRwdXRfc2lnbmF0dXJlcyA9IHt9CiAgICBsb2NhbCBTSEEyNTYgPSBoYXNoLm5ldygnc2hhM18yNTYnKQoKICAgIGZvciBpbmRleCwgaW5wdXQgaW4gcGFpcnModHguaW5wdXRzKSBkbwogICAgICAgIGxvY2FsIHRyYW5zYWN0aW9uVW5pcXVlRnVsZmlsbG1lbnQgPSBuaWwKICAgICAgICBpZiBpbnB1dC5mdWxmaWxscyB0aGVuCiAgICAgICAgICAgIHRyYW5zYWN0aW9uVW5pcXVlRnVsZmlsbG1lbnQgPSBzZXJpYWxpemVkX3R4IC4uIGlucHV0LmZ1bGZpbGxzLnRyYW5zYWN0aW9uX2lkIC4uIGlucHV0LmZ1bGZpbGxzLm91dHB1dF9pbmRleAogICAgICAgIGVsc2UKICAgICAgICAgICAgdHJhbnNhY3Rpb25VbmlxdWVGdWxmaWxsbWVudCA9IHNlcmlhbGl6ZWRfdHgKICAgICAgICBlbmQKICAgICAgICBsb2NhbCB0cmFuc2FjdGlvbkhhc2ggPSBTSEEyNTY6cHJvY2VzcyhPLmZyb21fc3RyaW5nKHRyYW5zYWN0aW9uVW5pcXVlRnVsZmlsbG1lbnQpKQogICAgICAgIGxvY2FsIHNpZ25hdHVyZSA9IEVELnNpZ24oc2ssIHRyYW5zYWN0aW9uSGFzaCkKICAgICAgICB0YWJsZS5pbnNlcnQocGxhbmV0bWludF9vdXRwdXRfc2lnbmF0dXJlcywgc2lnbmF0dXJlKQogICAgZW5kCgogICAgQUNLWydwbGFuZXRtaW50X3NpZ25hdHVyZXMnXSA9IHBsYW5ldG1pbnRfb3V0cHV0X3NpZ25hdHVyZXMKICAgIG5ld19jb2RlYygncGxhbmV0bWludF9zaWduYXR1cmVzJywge3plbnR5cGU9J2EnLCBsdWF0eXBlPSd0YWJsZScsIGVuY29kaW5nPSdoZXgnfSkKZW5kKQovemVuY29kZV9wdnNzLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMy0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBSZWJlY2NhIFNlbHZhZ2dpbmkgYW5kIEx1Y2EgRGkgRG9tZW5pY28KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCmxvY2FsIFBWU1MgPSByZXF1aXJlJ2NyeXB0b19wdnNzJwoKbG9jYWwgR0VORVJBVE9SUyA9IFBWU1Muc2V0X2dlbmVyYXRvcnMoKQoKbG9jYWwgZnVuY3Rpb24gcHZzc19wdWJsaWNfa2V5X2Yob2JqKQogICAgbG9jYWwgcG9pbnQgPSBFQ1AuZnJvbV96Y2FzaChvYmopCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgIHBvaW50IH49ICBFQ1AuaW5maW5pdHkoKSwKICAgICAgICdwdnNzIHB1YmxpYyBrZXkgaXMgbm90IHZhbGlkIChpcyBpbmZpbml0eSknCiAgICApCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBwb2ludCpFQ1Aub3JkZXIoKSA9PSBFQ1AuaW5maW5pdHkoKSwKICAgICAgICAncHZzcyBwdWJsaWMga2V5IGlzIG5vdCB2YWxpZCAobm90IGluIHRoZSBzdWJncm91cCknCiAgICApCiAgICByZXR1cm4gcG9pbnQKZW5kCgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfcHVibGljX3NoYXJlc19mKG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICByZXMucHVibGljX2tleXMgPSBzY2hlbWFfZ2V0KG9iaiwgJ3B1YmxpY19rZXlzJywgcHZzc19wdWJsaWNfa2V5X2YpCiAgICByZXMucHJvb2YgPSBzY2hlbWFfZ2V0KG9iaiwgJ3Byb29mJywgQklHLm5ldywgTy5mcm9tX2Jhc2U2NCkKICAgIHJlcy5jb21taXRtZW50cyA9IHNjaGVtYV9nZXQob2JqLCAnY29tbWl0bWVudHMnLCBFQ1AuZnJvbV96Y2FzaCwgTy5mcm9tX2Jhc2U2NCkKICAgIHJlcy5lbmNyeXB0ZWRfc2hhcmVzID0gc2NoZW1hX2dldChvYmosICdlbmNyeXB0ZWRfc2hhcmVzJywgRUNQLmZyb21femNhc2gsIE8uZnJvbV9iYXNlNjQpCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X3B1YmxpY19zaGFyZXNfZihvYmopCiAgICBsb2NhbCByZXMgPSB7WyJwdWJsaWNfa2V5cyJdID0ge30sIFsicHJvb2YiXSA9IHt9LCBbImVuY3J5cHRlZF9zaGFyZXMiXSA9IHt9LCBbImNvbW1pdG1lbnRzIl0gPSB7fX0KICAgIGZvciBrLHYgaW4gcGFpcnMob2JqLmNvbW1pdG1lbnRzKSBkbwogICAgICAgIHJlcy5jb21taXRtZW50c1trXSA9IHY6dG9femNhc2goKQogICAgZW5kCiAgICBsb2NhbCBuID0gI29iai5wdWJsaWNfa2V5cwogICAgZm9yIGk9MSxuIGRvCiAgICAgICAgcmVzLnB1YmxpY19rZXlzW2ldID0gb2JqLnB1YmxpY19rZXlzW2ldOnRvX3pjYXNoKCkKICAgICAgICByZXMucHJvb2ZbaV0gPSBvYmoucHJvb2ZbaV06b2N0ZXQoKTpiYXNlNjQoKQogICAgICAgIHJlcy5lbmNyeXB0ZWRfc2hhcmVzW2ldID0gb2JqLmVuY3J5cHRlZF9zaGFyZXNbaV06dG9femNhc2goKQogICAgZW5kCiAgICByZXMucHJvb2ZbbisxXSA9IG9iai5wcm9vZltuKzFdOm9jdGV0KCk6YmFzZTY0KCkKICAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfc2VjcmV0X3NoYXJlX2Yob2JqKQogICAgbG9jYWwgcmVzID0ge30KICAgIHJlcy5pbmRleCA9IHNjaGVtYV9nZXQob2JqLCAnaW5kZXgnLCBJTlQuZnJvbV9kZWNpbWFsLCB0b3N0cmluZykKICAgIHJlcy5wcm9vZiA9IHNjaGVtYV9nZXQob2JqLCAncHJvb2YnLCBCSUcubmV3LCBPLmZyb21fYmFzZTY0KQogICAgcmVzLmRlY19zaGFyZSA9IHNjaGVtYV9nZXQob2JqLCAnZGVjX3NoYXJlJywgRUNQLmZyb21femNhc2gsIE8uZnJvbV9iYXNlNjQpCiAgICByZXMuZW5jX3NoYXJlID0gc2NoZW1hX2dldChvYmosICdlbmNfc2hhcmUnLCBFQ1AuZnJvbV96Y2FzaCwgTy5mcm9tX2Jhc2U2NCkKICAgIHJlcy5wdWJfa2V5ID0gc2NoZW1hX2dldChvYmosICdwdWJfa2V5JywgcHZzc19wdWJsaWNfa2V5X2YpCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X3NlY3JldF9zaGFyZV9mKG9iaikKICAgIGxvY2FsIHJlcyA9IHtbInByb29mIl09e319CiAgICByZXMuaW5kZXggPSBvYmouaW5kZXg6ZGVjaW1hbCgpCiAgICByZXMuZW5jX3NoYXJlID0gb2JqLmVuY19zaGFyZTp0b196Y2FzaCgpCiAgICByZXMuZGVjX3NoYXJlID0gb2JqLmRlY19zaGFyZTp0b196Y2FzaCgpCiAgICByZXMucHViX2tleSA9IG9iai5wdWJfa2V5OnRvX3pjYXNoKCkKICAgIGZvciBrLHYgaW4gcGFpcnMob2JqLnByb29mKSBkbwogICAgICAgIHJlcy5wcm9vZltrXSA9IHY6b2N0ZXQoKTpiYXNlNjQoKQogICAgZW5kCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3ZlcmlmaWVkX3NoYXJlc19mKG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICByZXMudmFsaWRfaW5kZXhlcyA9IHNjaGVtYV9nZXQob2JqLCAndmFsaWRfaW5kZXhlcycsIElOVC5mcm9tX2RlY2ltYWwsIHRvc3RyaW5nKQogICAgcmVzLnZhbGlkX3NoYXJlcyA9IHNjaGVtYV9nZXQob2JqLCAndmFsaWRfc2hhcmVzJywgRUNQLmZyb21femNhc2gsIE8uZnJvbV9iYXNlNjQpCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X3ZlcmlmaWVkX3NoYXJlc19mKG9iaikKICAgIGxvY2FsIHJlcyA9IHtbInZhbGlkX2luZGV4ZXMiXSA9IHt9LCBbInZhbGlkX3NoYXJlcyJdID0ge319CiAgICBmb3IgaSA9IDEsICNvYmoudmFsaWRfaW5kZXhlcyBkbwogICAgICAgIHJlcy52YWxpZF9zaGFyZXNbaV0gPSBvYmoudmFsaWRfc2hhcmVzW2ldOnRvX3pjYXNoKCkKICAgICAgICByZXMudmFsaWRfaW5kZXhlc1tpXSA9IG9iai52YWxpZF9pbmRleGVzW2ldOmRlY2ltYWwoKQogICAgZW5kCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gdGFibGVsZW5ndGgoVCkKICAgIGxvY2FsIGNvdW50ID0gMAogICAgZm9yIF8gaW4gcGFpcnMoVCkgZG8gY291bnQgPSBjb3VudCArIDEgZW5kCiAgICByZXR1cm4gY291bnQKZW5kCgpaRU46YWRkX3NjaGVtYSgKICAgIHsKICAgICAgICBwdnNzX3B1YmxpY19rZXkgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGZ1bmN0aW9uKG9iaikKICAgICAgICAgICAgICAgIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJy4nLCBwdnNzX3B1YmxpY19rZXlfZikKICAgICAgICAgICAgZW5kLAogICAgICAgICAgICBleHBvcnQgPSBFQ1AudG9femNhc2gKICAgICAgICB9LAogICAgICAgIHB2c3NfcHVibGljX3NoYXJlcyA9IHsgaW1wb3J0ID0gaW1wb3J0X3B1YmxpY19zaGFyZXNfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X3B1YmxpY19zaGFyZXNfZn0sCiAgICAgICAgcHZzc19zZWNyZXRfc2hhcmUgPSB7IGltcG9ydCA9IGltcG9ydF9zZWNyZXRfc2hhcmVfZiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X3NlY3JldF9zaGFyZV9mCiAgICAgICAgfSwKICAgICAgICBwdnNzX3ZlcmlmaWVkX3NoYXJlcyA9IHsgaW1wb3J0ID0gaW1wb3J0X3ZlcmlmaWVkX3NoYXJlc19mLAogICAgICAgICAgICBleHBvcnQgPSBleHBvcnRfdmVyaWZpZWRfc2hhcmVzX2YKICAgICAgICB9CiAgICB9CikKCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0gUFZTUyBpbml0aWFsaXphdGlvbiAtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCgotLSBQYXJ0aWNpcGFudCBnZW5lcmF0ZXMgdGhlIHByaXZhdGUga2V5CldoZW4oImNyZWF0ZSBwdnNzIGtleSIsZnVuY3Rpb24oKQogICAgaW5pdGtleXJpbmcncHZzcycKICAgIEFDSy5rZXlyaW5nLnB2c3MgPSBQVlNTLmtleWdlbigpCmVuZCkKCi0tIFBhcnRpY2lwYW50IGdlbmVyYXRlcyB0aGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgcHZzcyBwdWJsaWMga2V5IixmdW5jdGlvbigpCiAgICBlbXB0eSdwdnNzIHB1YmxpYyBrZXknCiAgICBsb2NhbCBzayA9IGhhdmVrZXkncHZzcycKICAgIEFDSy5wdnNzX3B1YmxpY19rZXkgPSBQVlNTLnNrMnBrKEdFTkVSQVRPUlMsIHNrKQogICAgbmV3X2NvZGVjKCdwdnNzIHB1YmxpYyBrZXknLCB7IHplbnR5cGUgPSAnZSd9KQplbmQpCgotLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSBESVNUUklCVVRJT04gLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KCi0tIFRoZSBpc3N1ZXIgZ2VuZXJhdGVzIHRoZSBlbmNyeXB0ZWQgc2hhcmVzIGZvciBuIHBhcnRpY2lwYW50cyB3aXRoIHF1b3J1bSB0CldoZW4oImNyZWF0ZSBwdnNzIHB1YmxpYyBzaGFyZXMgb2YgJycgd2l0aCAnJyBxdW9ydW0gJycgdXNpbmcgcHVibGljIGtleXMgJyciLCBmdW5jdGlvbihzZWMsIG51bSwgdGhyLCBwdWJrcykKICAgIGxvY2FsIHMgPSBCSUcubmV3KCBoYXZlKHNlYykgKQoJbG9jYWwgbiA9IHRvbnVtYmVyKGhhdmUobnVtKTpkZWNpbWFsKCkpCgl6ZW5jb2RlX2Fzc2VydChuLCAiVG90YWwgc2hhcmVzIGlzIG5vdCBhIG51bWJlcjogIi4ubnVtKQoJbG9jYWwgdCA9IHRvbnVtYmVyKGhhdmUodGhyKTpkZWNpbWFsKCkpCgl6ZW5jb2RlX2Fzc2VydCh0LCAiUXVvcnVtIHNoYXJlcyBpcyBub3QgYSBudW1iZXI6ICIuLnRocikKICAgIHplbmNvZGVfYXNzZXJ0KHQgPD0gbiwgIlF1b3J1bSBpcyBiaWdnZXIgdGhhbiB0b3RhbCIpCiAgICBsb2NhbCBwa3MgPSBoYXZlKHB1YmtzKQogICAgbG9jYWwgcHZzc19wdWJsaWNfc2hhcmVzID0gUFZTUy5jcmVhdGVfc2hhcmVzKEdFTkVSQVRPUlMsIHMsIHBrcywgdCwgbikKCiAgICBlbXB0eSdwdnNzIHB1YmxpYyBzaGFyZXMnCiAgICBBQ0sucHZzc19wdWJsaWNfc2hhcmVzID0gcHZzc19wdWJsaWNfc2hhcmVzCiAgICBuZXdfY29kZWMoJ3B2c3MgcHVibGljIHNoYXJlcycpCgplbmQpCgotLSBBbnlvbmUgdmVyaWZpZXMgdGhlIGVuY3J5cHRlZCBzaGFyZXMgY3JlYXRlZCBieSB0aGUgaXNzdWVyCldoZW4oInZlcmlmeSBwdnNzIHB1YmxpYyBzaGFyZXMgd2l0aCAnJyBxdW9ydW0gJyciLCBmdW5jdGlvbihudW0sdGhyKQogICAgbG9jYWwgcHZzc19wdWJsaWNfc2hhcmVzID0gaGF2ZSdwdnNzIHB1YmxpYyBzaGFyZXMnCiAgICBsb2NhbCB0ID0gdG9udW1iZXIoaGF2ZSh0aHIpOmRlY2ltYWwoKSkKICAgIGxvY2FsIG4gPSB0b251bWJlcihoYXZlKG51bSk6ZGVjaW1hbCgpKQoKICAgIHplbmNvZGVfYXNzZXJ0KHQgPD0gbiwgIlF1b3J1bSBpcyBiaWdnZXIgdGhhbiB0b3RhbCIpCgogICAgemVuY29kZV9hc3NlcnQodHlwZShwdnNzX3B1YmxpY19zaGFyZXMucHVibGljX2tleXMpID09ICd0YWJsZScsICIncHZzcyBwYXJ0aWNpcGFudCBwa3MnIGlzIG5vdCBhIHRhYmxlIikKICAgIHplbmNvZGVfYXNzZXJ0KHR5cGUocHZzc19wdWJsaWNfc2hhcmVzLmNvbW1pdG1lbnRzKSA9PSAndGFibGUnLCAiJ3B2c3MgY29tbWl0bWVudHMnIGlzIG5vdCBhIHRhYmxlIikKICAgIHplbmNvZGVfYXNzZXJ0KHR5cGUocHZzc19wdWJsaWNfc2hhcmVzLmVuY3J5cHRlZF9zaGFyZXMpID09ICd0YWJsZScsICIncHZzcyBlbmNyeXB0ZWQgc2hhcmVzJyBpcyBub3QgYSB0YWJsZSIpCiAgICB6ZW5jb2RlX2Fzc2VydCh0eXBlKHB2c3NfcHVibGljX3NoYXJlcy5wcm9vZikgPT0gJ3RhYmxlJywgIidwdnNzIHByb29mJyBpcyBub3QgYSB0YWJsZSIpCgogICAgemVuY29kZV9hc3NlcnQodGFibGVsZW5ndGgocHZzc19wdWJsaWNfc2hhcmVzLnB1YmxpY19rZXlzKSA9PSBuLCAiJ3B2c3MgcGFydGljaXBhbnQgcGtzJyBpcyBvZiB3cm9uZyBsZW5ndGgiKQogICAgemVuY29kZV9hc3NlcnQodGFibGVsZW5ndGgocHZzc19wdWJsaWNfc2hhcmVzLmNvbW1pdG1lbnRzKSA9PSB0LCAiJ3B2c3MgY29tbWl0bWVudHMnIGlzIG9mIHdyb25nIGxlbmd0aCIpCiAgICB6ZW5jb2RlX2Fzc2VydCh0YWJsZWxlbmd0aChwdnNzX3B1YmxpY19zaGFyZXMuZW5jcnlwdGVkX3NoYXJlcykgPT0gbiwgIidwdnNzIGVuY3J5cHRlZCBzaGFyZXMnIGlzIG9mIHdyb25nIGxlbmd0aCIpCiAgICB6ZW5jb2RlX2Fzc2VydCh0YWJsZWxlbmd0aChwdnNzX3B1YmxpY19zaGFyZXMucHJvb2YpID09IG4gKyAxLCAiJ3B2c3MgcHJvb2YnIGlzIG9mIHdyb25nIGxlbmd0aCIpCgogICAgZm9yIF8sdiBpbiBwYWlycyhwdnNzX3B1YmxpY19zaGFyZXMucHJvb2YpIGRvCiAgICAgICAgemVuY29kZV9hc3NlcnQodHlwZSh2KSA9PSAnemVucm9vbS5iaWcnLCAnUHJvb2YgZWxlbWVudCBpcyBub3QgYmlnJykKICAgICAgICB6ZW5jb2RlX2Fzc2VydCh2IDwgRUNQLm9yZGVyKCksICdQcm9vZiBlbGVtZW50IGlzIG5vdCBtb2R1bG8gQ1VSVkVfT1JERVInKQogICAgZW5kCgogICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgUFZTUy52ZXJpZnlfc2hhcmVzKEdFTkVSQVRPUlMsIHQsIG4sIHB2c3NfcHVibGljX3NoYXJlcyksCiAgICAgICAgJ1RoZSBwdnNzIHB1YmxpYyBzaGFyZXMgYXJlIG5vdCBhdXRoZW50aWMnCiAgICApCmVuZCkKCi0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tIFJFQ09OU1RSVUNUSU9OIC0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0KCi0tIFBhcnRpY2lwYW50IGRlY3J5cHRzIGl0cyBvd24gc2hhcmUgQU5EIGdlbmVyYXRlIGEgcHJvb2YKV2hlbigiY3JlYXRlIHNlY3JldCBzaGFyZSB3aXRoIHB1YmxpYyBrZXkgJyciLCBmdW5jdGlvbihwaykKICAgIGxvY2FsIHggPSBoYXZla2V5J3B2c3MnCiAgICBsb2NhbCB5ID0gaGF2ZShwaykKICAgIHplbmNvZGVfYXNzZXJ0KHkgPT0gUFZTUy5zazJwayhHRU5FUkFUT1JTLCB4KSkKICAgIGxvY2FsIGlzc3Vlcl9zaGFyZXMgPSBoYXZlJ3B2c3MgcHVibGljIHNoYXJlcycKICAgIGxvY2FsIG91dHB1dCA9IFBWU1MuZGVjcnlwdF9zaGFyZShHRU5FUkFUT1JTLCB4LCB5LCBpc3N1ZXJfc2hhcmVzKQogICAgb3V0cHV0WyJpbmRleCJdID0gQklHLm5ldyhvdXRwdXRbImluZGV4Il0pCgogICAgZW1wdHkncHZzcyBzZWNyZXQgc2hhcmUnCiAgICBBQ0sucHZzc19zZWNyZXRfc2hhcmUgPSBvdXRwdXQKICAgIG5ld19jb2RlYygncHZzcyBzZWNyZXQgc2hhcmUnKQplbmQpCgotLSBFYWNoIHBhcnRpY2lwYW50IHZlcmlmaWVzIHRoZSBzaGFyZXMgb2YgdGhlIG90aGVycwpXaGVuKCJjcmVhdGUgcHZzcyB2ZXJpZmllZCBzaGFyZXMgZnJvbSAnJyIsIGZ1bmN0aW9uKGxpc3QpCiAgICBsb2NhbCBkZWNfc2hhcmVzID0gaGF2ZShsaXN0KQogICAgbG9jYWwgdmFsaWRfc2hhcmVzLCB2YWxpZF9pbmRleGVzID0gUFZTUy52ZXJpZnlfZGVjcnlwdGVkX3NoYXJlcyhHRU5FUkFUT1JTLCBkZWNfc2hhcmVzKQogICAgZm9yIGssdiBpbiBwYWlycyh2YWxpZF9pbmRleGVzKSBkbwogICAgICAgIHZhbGlkX2luZGV4ZXNba10gPSBCSUcubmV3KHYpCiAgICBlbmQKCiAgICBlbXB0eSdwdnNzIHZlcmlmaWVkIHNoYXJlcycKICAgIEFDSy5wdnNzX3ZlcmlmaWVkX3NoYXJlcyA9IHtbInZhbGlkX3NoYXJlcyJdID0gdmFsaWRfc2hhcmVzLCBbInZhbGlkX2luZGV4ZXMiXSA9IHZhbGlkX2luZGV4ZXN9CiAgICBuZXdfY29kZWMoJ3B2c3MgdmVyaWZpZWQgc2hhcmVzJykKCmVuZCkKCi0tIFNlY3JldCByZWNvbnN0cnVjdGlvbiAvIHBvb2xpbmcgdGhlIHNoYXJlCldoZW4oImNvbXBvc2UgcHZzcyBzZWNyZXQgdXNpbmcgJycgd2l0aCBxdW9ydW0gJyciLCBmdW5jdGlvbihzaHJzLCB0aHIpCiAgICBsb2NhbCB0aHJlc2hvbGQgPSB0b251bWJlcihCSUcudG9fZGVjaW1hbChoYXZlKHRocikpKQogICAgbG9jYWwgdmVyaWZpZWRfc2hhcmVzID0gaGF2ZShzaHJzKQoKICAgIGxvY2FsIHNlY3JldF9wb2ludCA9IFBWU1MucG9vbGluZ19zaGFyZXModmVyaWZpZWRfc2hhcmVzLnZhbGlkX3NoYXJlcywgdmVyaWZpZWRfc2hhcmVzLnZhbGlkX2luZGV4ZXMsIHRocmVzaG9sZCkKCiAgICBlbXB0eSdwdnNzIHNlY3JldCcKICAgIEFDSy5wdnNzX3NlY3JldCA9IHNlY3JldF9wb2ludDp0b196Y2FzaCgpCiAgICBuZXdfY29kZWMoJ3B2c3Mgc2VjcmV0Jywge3plbnR5cGUgPSAnZSd9KQplbmQpCi96ZW5jb2RlX3FwLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMi0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBBbGJlcnRvIExlcmRhIGFuZCBEZW5pcyBSb2lvCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgTWF0dGVvIENyaXN0aW5vCi0tb24gRnJpZGF5LCAxOXRoIEFwcmlsIDIwMjIKLS1dXQoKbG9jYWwgUVAgPSByZXF1aXJlJ3FwJwpfR1snUFEnXSA9IFFQIC0tIGNvcnJlY3Qgb2JqZWN0IG5hbWUgZ2xvYmFsbHkKCmxvY2FsIGZ1bmN0aW9uIGRpbGl0aGl1bV9wdWJsaWNfa2V5X2Yob2JqKQogICBsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQogICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgUVAuc2lncHViY2hlY2socmVzKSwKICAgICAgJ0RpbGl0aGl1bSBwdWJsaWMga2V5IGxlbmd0aCBpcyBub3QgY29ycmVjdCcKICAgKQogICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZGlsaXRoaXVtX3NpZ25hdHVyZV9mKG9iaikKICAgbG9jYWwgcmVzID0gc2NoZW1hX2dldChvYmosICcuJykKICAgemVuY29kZV9hc3NlcnQoCiAgICAgIFFQLnNpZ25hdHVyZV9jaGVjayhyZXMpLAogICAgICAnRGlsaXRoaXVtIHNpZ25hdHVyZSBsZW5ndGggaXMgbm90IGNvcnJlY3QnCiAgICkKICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGt5YmVyX3B1YmxpY19rZXlfZihvYmopCiAgIGxvY2FsIHJlcyA9IHNjaGVtYV9nZXQob2JqLCAnLicpCiAgIHplbmNvZGVfYXNzZXJ0KAogICAgICBRUC5rZW1wdWJjaGVjayhyZXMpLAogICAgICAnS3liZXIgcHVibGljIGtleSBsZW5ndGggaXMgbm90IGNvcnJlY3QnCiAgICkKICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGt5YmVyX3NlY3JldF9mKG9iaikKICAgbG9jYWwgcmVzID0gc2NoZW1hX2dldChvYmosICcuJykKICAgemVuY29kZV9hc3NlcnQoCiAgICAgIFFQLmtlbXNzY2hlY2socmVzKSwKICAgICAgJ0t5YmVyIHNlY3JldCBsZW50Z3RoIGlzIG5vdCBjb3JyZWN0JwogICApCiAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBreWJlcl9jaXBoZXJ0ZXh0X2Yob2JqKQogICBsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQogICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgUVAua2VtY3RjaGVjayhyZXMpLAogICAgICAnS3liZXIgY2lwaGVydGV4dCBsZW5ndGggaXMgbm90IGNvcnJlY3QnCiAgICkKICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGt5YmVyX2ltcG9ydF9rZW0ob2JqKQogICBsb2NhbCByZXMgPSB7fQogICByZXMua3liZXJfc2VjcmV0ID0ga3liZXJfc2VjcmV0X2Yob2JqLmt5YmVyX3NlY3JldCkKICAgcmVzLmt5YmVyX2NpcGhlcnRleHQgPSBreWJlcl9jaXBoZXJ0ZXh0X2Yob2JqLmt5YmVyX2NpcGhlcnRleHQpCiAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBtbGtlbTUxMl9wdWJsaWNfa2V5X2Yob2JqKQoJbG9jYWwgcmVzID0gc2NoZW1hX2dldChvYmosICcuJykKCXplbmNvZGVfYXNzZXJ0KAoJICAgUVAubWxrZW1fcHViY2hlY2socmVzKSwKCSAgICdNTC1LRU0tNTEyIHB1YmxpYyBrZXkgbGVuZ3RoIGlzIG5vdCBjb3JyZWN0JwoJKQoJcmV0dXJuIHJlcwogZW5kCiAKIGxvY2FsIGZ1bmN0aW9uIG1sa2VtNTEyX3NlY3JldF9mKG9iaikKCWxvY2FsIHJlcyA9IHNjaGVtYV9nZXQob2JqLCAnLicpCgl6ZW5jb2RlX2Fzc2VydCgKCSAgIFFQLm1sa2VtX3NzY2hlY2socmVzKSwKCSAgICdNTC1LRU0tNTEyIHNlY3JldCBsZW50Z3RoIGlzIG5vdCBjb3JyZWN0JwoJKQoJcmV0dXJuIHJlcwogZW5kCiAKIGxvY2FsIGZ1bmN0aW9uIG1sa2VtNTEyX2NpcGhlcnRleHRfZihvYmopCglsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQoJemVuY29kZV9hc3NlcnQoCgkgICBRUC5tbGtlbV9jdGNoZWNrKHJlcyksCgkgICAnTUwtS0VNLTUxMiBjaXBoZXJ0ZXh0IGxlbmd0aCBpcyBub3QgY29ycmVjdCcKCSkKCXJldHVybiByZXMKIGVuZAogCiBsb2NhbCBmdW5jdGlvbiBtbGtlbTUxMl9pbXBvcnRfa2VtKG9iaikKCWxvY2FsIHJlcyA9IHt9CglyZXMubWxrZW01MTJfc2VjcmV0ID0gbWxrZW01MTJfc2VjcmV0X2Yob2JqLm1sa2VtNTEyX3NlY3JldCkKCXJlcy5tbGtlbTUxMl9jaXBoZXJ0ZXh0ID0gbWxrZW01MTJfY2lwaGVydGV4dF9mKG9iai5tbGtlbTUxMl9jaXBoZXJ0ZXh0KQoJcmV0dXJuIHJlcwogZW5kCgpsb2NhbCBmdW5jdGlvbiBudHJ1cF9wdWJsaWNfa2V5X2Yob2JqKQogICBsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQogICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgUVAubnRydXBfcHViY2hlY2socmVzKSwKICAgICAgJ05UUlVQIHB1YmxpYyBrZXkgbGVuZ3RoIGlzIG5vdCBjb3JyZWN0JwogICApCiAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBudHJ1cF9zZWNyZXRfZihvYmopCiAgIGxvY2FsIHJlcyA9IHNjaGVtYV9nZXQob2JqLCAnLicpCiAgIHplbmNvZGVfYXNzZXJ0KAogICAgICBRUC5udHJ1cF9zc2NoZWNrKHJlcyksCiAgICAgICdOVFJVUCBzZWNyZXQgbGVudGd0aCBpcyBub3QgY29ycmVjdCcKICAgKQogICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gbnRydXBfY2lwaGVydGV4dF9mKG9iaikKICAgbG9jYWwgcmVzID0gc2NoZW1hX2dldChvYmosICcuJykKICAgemVuY29kZV9hc3NlcnQoCiAgICAgIFFQLm50cnVwX2N0Y2hlY2socmVzKSwKICAgICAgJ05UUlVQIGNpcGhlcnRleHQgbGVuZ3RoIGlzIG5vdCBjb3JyZWN0JwogICApCiAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBudHJ1cF9pbXBvcnRfa2VtKG9iaikKICAgbG9jYWwgcmVzID0ge30KICAgcmVzLm50cnVwX3NlY3JldCA9IG50cnVwX3NlY3JldF9mKG9iai5udHJ1cF9zZWNyZXQpCiAgIHJlcy5udHJ1cF9jaXBoZXJ0ZXh0ID0gbnRydXBfY2lwaGVydGV4dF9mKG9iai5udHJ1cF9jaXBoZXJ0ZXh0KQogICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gbWxkc2E0NF9wdWJsaWNfa2V5X2Yob2JqKQoJbG9jYWwgcmVzID0gc2NoZW1hX2dldChvYmosICcuJykKCXplbmNvZGVfYXNzZXJ0KAoJICAgUVAubWxkc2E0NF9wdWJjaGVjayhyZXMpLAoJICAgJ21sZHNhNDQgcHVibGljIGtleSBsZW5ndGggaXMgbm90IGNvcnJlY3QnCgkpCglyZXR1cm4gcmVzCiBlbmQKIAogbG9jYWwgZnVuY3Rpb24gbWxkc2E0NF9zaWduYXR1cmVfZihvYmopCglsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQoJemVuY29kZV9hc3NlcnQoCgkgICBRUC5tbGRzYTQ0X3NpZ25hdHVyZV9jaGVjayhyZXMpLAoJICAgJ21sZHNhNDQgc2lnbmF0dXJlIGxlbmd0aCBpcyBub3QgY29ycmVjdCcKCSkKCXJldHVybiByZXMKIGVuZAoKWkVOOmFkZF9zY2hlbWEoCiAgIHsKICAgICAgZGlsaXRoaXVtX3B1YmxpY19rZXkgPSB7aW1wb3J0PWRpbGl0aGl1bV9wdWJsaWNfa2V5X2Z9LAogICAgICBkaWxpdGhpdW1fc2lnbmF0dXJlID0ge2ltcG9ydD1kaWxpdGhpdW1fc2lnbmF0dXJlX2Z9LAogICAgICBreWJlcl9wdWJsaWNfa2V5ID0ge2ltcG9ydD1reWJlcl9wdWJsaWNfa2V5X2Z9LAogICAgICBreWJlcl9zZWNyZXQgPSB7aW1wb3J0PWt5YmVyX3NlY3JldF9mfSwKICAgICAga3liZXJfY2lwaGVydGV4dCA9IHtpbXBvcnQ9a3liZXJfY2lwaGVydGV4dF9mfSwKICAgICAga3liZXJfa2VtID0ge2ltcG9ydD1reWJlcl9pbXBvcnRfa2VtfSwKCSAgbWxrZW01MTJfcHVibGljX2tleSA9IHtpbXBvcnQ9bWxrZW01MTJfcHVibGljX2tleV9mfSwKICAgICAgbWxrZW01MTJfc2VjcmV0ID0ge2ltcG9ydD1tbGtlbTUxMl9zZWNyZXRfZn0sCiAgICAgIG1sa2VtNTEyX2NpcGhlcnRleHQgPSB7aW1wb3J0PW1sa2VtNTEyX2NpcGhlcnRleHRfZn0sCiAgICAgIG1sa2VtNTEyX2tlbSA9IHtpbXBvcnQ9bWxrZW01MTJfaW1wb3J0X2tlbX0sCiAgICAgIG50cnVwX3B1YmxpY19rZXkgPSB7aW1wb3J0PW50cnVwX3B1YmxpY19rZXlfZn0sCiAgICAgIG50cnVwX3NlY3JldCA9IHtpbXBvcnQ9bnRydXBfc2VjcmV0X2Z9LAogICAgICBudHJ1cF9jaXBoZXJ0ZXh0ID0ge2ltcG9ydD1udHJ1cF9jaXBoZXJ0ZXh0X2Z9LAogICAgICBudHJ1cF9rZW0gPSB7aW1wb3J0PW50cnVwX2ltcG9ydF9rZW19LAoJICBtbGRzYTQ0X3B1YmxpY19rZXkgPSB7aW1wb3J0PW1sZHNhNDRfcHVibGljX2tleV9mfSwKCSAgbWxkc2E0NF9zaWduYXR1cmUgPSB7aW1wb3J0PW1sZHNhNDRfc2lnbmF0dXJlX2Z9CiAgIH0KKQoKLS0jIERJTElUSElVTSAjLS0KCi0tIGdlbmVyYXRlIHRoZSBwcml2YXRlIGtleQpXaGVuKCJjcmVhdGUgZGlsaXRoaXVtIGtleSIsZnVuY3Rpb24oKQoJaW5pdGtleXJpbmcnZGlsaXRoaXVtJwoJQUNLLmtleXJpbmcuZGlsaXRoaXVtID0gUVAuc2lna2V5Z2VuKCkucHJpdmF0ZQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgZGlsaXRoaXVtIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKCWVtcHR5J2RpbGl0aGl1bSBwdWJsaWMga2V5JwoJbG9jYWwgc2sgPSBoYXZla2V5J2RpbGl0aGl1bScKCUFDSy5kaWxpdGhpdW1fcHVibGljX2tleSA9IFFQLnNpZ3B1YmdlbihzaykKCW5ld19jb2RlYygnZGlsaXRoaXVtIHB1YmxpYyBrZXknKQplbmQpCgpXaGVuKCJjcmVhdGUgZGlsaXRoaXVtIHB1YmxpYyBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIixmdW5jdGlvbihzZWMpCglsb2NhbCBzayA9IGhhdmUoc2VjKQoJZW1wdHknZGlsaXRoaXVtIHB1YmxpYyBrZXknCglBQ0suZGlsaXRoaXVtX3B1YmxpY19rZXkgPSBRUC5zaWdwdWJnZW4oc2spCgluZXdfY29kZWMoJ2RpbGl0aGl1bSBwdWJsaWMga2V5JykKZW5kKQoKLS0gZ2VuZXJhdGUgdGhlIHNpZ24gZm9yIGEgbXNnIGFuZCB2ZXJpZnkKV2hlbigiY3JlYXRlIGRpbGl0aGl1bSBzaWduYXR1cmUgb2YgJyciLGZ1bmN0aW9uKGRvYykKCWxvY2FsIHNrID0gaGF2ZWtleSdkaWxpdGhpdW0nCglsb2NhbCBvYmogPSBoYXZlKGRvYykKCWVtcHR5J2RpbGl0aGl1bSBzaWduYXR1cmUnCglBQ0suZGlsaXRoaXVtX3NpZ25hdHVyZSA9IFFQLnNpZ24oc2ssIHplbmNvZGVfc2VyaWFsaXplKG9iaikpCgluZXdfY29kZWMoJ2RpbGl0aGl1bSBzaWduYXR1cmUnKQplbmQpCgpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSBkaWxpdGhpdW0gc2lnbmF0dXJlIGluICcnIGJ5ICcnIixmdW5jdGlvbihtc2csIHNpZywgYnkpCgkgIGxvY2FsIHBrID0gbG9hZF9wdWJrZXlfY29tcGF0KGJ5LCAnZGlsaXRoaXVtJykKCSAgbG9jYWwgbSA9IGhhdmUobXNnKQoJICBsb2NhbCBzID0gaGF2ZShzaWcpCgkgIHplbmNvZGVfYXNzZXJ0KAoJICAgICBRUC52ZXJpZnkocGssIHMsIHplbmNvZGVfc2VyaWFsaXplKG0pKSwKCSAgICAgJ1RoZSBkaWxpdGhpdW0gc2lnbmF0dXJlIGJ5ICcuLmJ5Li4nIGlzIG5vdCBhdXRoZW50aWMnCgkgICkKZW5kKQoKLS0jIEtZQkVSICMtLQoKLS0gZ2VuZXJhdGUgdGhlIHByaXZhdGUga2V5CldoZW4oImNyZWF0ZSBreWJlciBrZXkiLGZ1bmN0aW9uKCkKCWluaXRrZXlyaW5nJ2t5YmVyJwoJQUNLLmtleXJpbmcua3liZXIgPSBRUC5rZW1rZXlnZW4oKS5wcml2YXRlCmVuZCkKCi0tIGdlbmVyYXRlIHB1YmxpYyBrZXkKV2hlbigiY3JlYXRlIGt5YmVyIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKCWVtcHR5J2t5YmVyIHB1YmxpYyBrZXknCglsb2NhbCBzayA9IGhhdmVrZXkna3liZXInCglBQ0sua3liZXJfcHVibGljX2tleSA9IFFQLmtlbXB1YmdlbihzaykKCW5ld19jb2RlYygna3liZXIgcHVibGljIGtleScpCmVuZCkKCldoZW4oImNyZWF0ZSBreWJlciBwdWJsaWMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsZnVuY3Rpb24oc2VjKQoJbG9jYWwgc2sgPSBoYXZlKHNlYykKCWVtcHR5J2t5YmVyIHB1YmxpYyBrZXknCglBQ0sua3liZXJfcHVibGljX2tleSA9IFFQLmtlbXB1YmdlbihzaykKCW5ld19jb2RlYygna3liZXIgcHVibGljIGtleScpCmVuZCkKCi0tIGNyZWF0ZSBhIHNlY3JldCBtZXNzYWdlIGFuZCBpdHMgY2lwaGVydGV4dApXaGVuKCJjcmVhdGUga3liZXIga2VtIGZvciAnJyIsZnVuY3Rpb24ocHViKQoJbG9jYWwgcGsgPSBsb2FkX3B1YmtleV9jb21wYXQocHViLCAna3liZXInKQoJZW1wdHkna3liZXIga2VtJwoJQUNLLmt5YmVyX2tlbSA9IHt9Cglsb2NhbCBlbmMgPSBRUC5lbmMocGspCglBQ0sua3liZXJfa2VtLmt5YmVyX2NpcGhlcnRleHQgPSBlbmMuY2lwaGVyCglBQ0sua3liZXJfa2VtLmt5YmVyX3NlY3JldCA9IGVuYy5zZWNyZXQKCW5ld19jb2RlYygna3liZXIga2VtJykKZW5kKQotLSBjcmVhdGUgdGhlIHNlY3JldCBzdGFydGluZyBmcm9tIGEgY2lwaGVydGV4dApXaGVuKCJjcmVhdGUga3liZXIgc2VjcmV0IGZyb20gJyciLGZ1bmN0aW9uKHNlY3JldCkKCWxvY2FsIHNrID0gaGF2ZWtleSdreWJlcicKCWxvY2FsIHNlYyA9IGhhdmUoc2VjcmV0KQoJZW1wdHkgJ2t5YmVyIHNlY3JldCcKCUFDSy5reWJlcl9zZWNyZXQgPSBRUC5kZWMoc2ssIHNlYykKCW5ld19jb2RlYygna3liZXIgc2VjcmV0JykKZW5kKQoKLS0jIE1MLUtFTS01MTIgIy0tCgotLSBnZW5lcmF0ZSB0aGUgcHJpdmF0ZSBrZXkKV2hlbigiY3JlYXRlIG1sa2VtNTEyIGtleSIsZnVuY3Rpb24oKQoJaW5pdGtleXJpbmcnbWxrZW01MTInCglBQ0sua2V5cmluZy5tbGtlbTUxMiA9IFFQLm1sa2VtX2tleWdlbigpLnByaXZhdGUKZW5kKQoKLS0gZ2VuZXJhdGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgbWxrZW01MTIgcHVibGljIGtleSIsZnVuY3Rpb24oKQoJZW1wdHknbWxrZW01MTIgcHVibGljIGtleScKCWxvY2FsIHNrID0gaGF2ZWtleSdtbGtlbTUxMicKCUFDSy5tbGtlbTUxMl9wdWJsaWNfa2V5ID0gUVAubWxrZW1fcHViZ2VuKHNrKQoJbmV3X2NvZGVjKCdtbGtlbTUxMiBwdWJsaWMga2V5JykKZW5kKQoKV2hlbigiY3JlYXRlIG1sa2VtNTEyIHB1YmxpYyBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIixmdW5jdGlvbihzZWMpCglsb2NhbCBzayA9IGhhdmUoc2VjKQoJZW1wdHknbWxrZW01MTIgcHVibGljIGtleScKCUFDSy5tbGtlbTUxMl9wdWJsaWNfa2V5ID0gUVAubWxrZW1fcHViZ2VuKHNrKQoJbmV3X2NvZGVjKCdtbGtlbTUxMiBwdWJsaWMga2V5JykKZW5kKQoKLS0gY3JlYXRlIGEgc2VjcmV0IG1lc3NhZ2UgYW5kIGl0cyBjaXBoZXJ0ZXh0CldoZW4oImNyZWF0ZSBtbGtlbTUxMiBrZW0gZm9yICcnIixmdW5jdGlvbihwdWIpCglsb2NhbCBwayA9IGxvYWRfcHVia2V5X2NvbXBhdChwdWIsICdtbGtlbTUxMicpCgllbXB0eSdtbGtlbTUxMiBrZW0nCglBQ0subWxrZW01MTJfa2VtID0ge30KCWxvY2FsIGVuYyA9IFFQLm1sa2VtX2VuYyhwaykKCUFDSy5tbGtlbTUxMl9rZW0ubWxrZW01MTJfY2lwaGVydGV4dCA9IGVuYy5jaXBoZXIKCUFDSy5tbGtlbTUxMl9rZW0ubWxrZW01MTJfc2VjcmV0ID0gZW5jLnNlY3JldAoJbmV3X2NvZGVjKCdtbGtlbTUxMiBrZW0nKQplbmQpCi0tIGNyZWF0ZSB0aGUgc2VjcmV0IHN0YXJ0aW5nIGZyb20gYSBjaXBoZXJ0ZXh0CldoZW4oImNyZWF0ZSBtbGtlbTUxMiBzZWNyZXQgZnJvbSAnJyIsZnVuY3Rpb24oc2VjcmV0KQoJbG9jYWwgc2sgPSBoYXZla2V5J21sa2VtNTEyJwoJbG9jYWwgc2VjID0gaGF2ZShzZWNyZXQpCgllbXB0eSAnbWxrZW01MTIgc2VjcmV0JwoJQUNLLm1sa2VtNTEyX3NlY3JldCA9IFFQLm1sa2VtX2RlYyhzaywgc2VjKQoJbmV3X2NvZGVjKCdtbGtlbTUxMiBzZWNyZXQnKQplbmQpCgotLSMgTlRSVVAgIy0tCgotLSBnZW5lcmF0ZSB0aGUgcHJpdmF0ZSBrZXkKV2hlbigiY3JlYXRlIG50cnVwIGtleSIsZnVuY3Rpb24oKQoJaW5pdGtleXJpbmcnbnRydXAnCglBQ0sua2V5cmluZy5udHJ1cCA9IFFQLm50cnVwX2tleWdlbigpLnByaXZhdGUKZW5kKQoKLS0gZ2VuZXJhdGUgdGhlIHB1YmxpYyBrZXkKV2hlbigiY3JlYXRlIG50cnVwIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKCWVtcHR5J250cnVwIHB1YmxpYyBrZXknCglsb2NhbCBzayA9IGhhdmVrZXknbnRydXAnCglBQ0subnRydXBfcHVibGljX2tleSA9IFFQLm50cnVwX3B1YmdlbihzaykKCW5ld19jb2RlYygnbnRydXAgcHVibGljIGtleScpCmVuZCkKCldoZW4oImNyZWF0ZSBudHJ1cCBwdWJsaWMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsZnVuY3Rpb24oc2VjKQoJbG9jYWwgc2sgPSBoYXZlKHNlYykKCWVtcHR5J250cnVwIHB1YmxpYyBrZXknCglBQ0subnRydXBfcHVibGljX2tleSA9IFFQLm50cnVwX3B1YmdlbihzaykKCW5ld19jb2RlYygnbnRydXAgcHVibGljIGtleScpCmVuZCkKCi0tIGNyZWF0ZSBhIHNlY3JldCBtZXNzYWdlIGFuZCBpdHMgY2lwaGVydGV4dApXaGVuKCJjcmVhdGUgbnRydXAga2VtIGZvciAnJyIsZnVuY3Rpb24ocHViKQoJbG9jYWwgcGsgPSBsb2FkX3B1YmtleV9jb21wYXQocHViLCAnbnRydXAnKQoJZW1wdHknbnRydXAga2VtJwoJQUNLLm50cnVwX2tlbSA9IHt9Cglsb2NhbCBlbmMgPSBRUC5udHJ1cF9lbmMocGspCglBQ0subnRydXBfa2VtLm50cnVwX2NpcGhlcnRleHQgPSBlbmMuY2lwaGVyCglBQ0subnRydXBfa2VtLm50cnVwX3NlY3JldCA9IGVuYy5zZWNyZXQKCW5ld19jb2RlYygnbnRydXAga2VtJykKZW5kKQotLSBjcmVhdGUgdGhlIHNlY3JldCBzdGFydGluZyBmcm9tIGEgY2lwaGVydGV4dApXaGVuKCJjcmVhdGUgbnRydXAgc2VjcmV0IGZyb20gJyciLGZ1bmN0aW9uKGNpcGhlcnRleHQpCglsb2NhbCBzayA9IGhhdmVrZXknbnRydXAnCglsb2NhbCBjdCA9IGhhdmUoY2lwaGVydGV4dCkKCWVtcHR5J250cnVwIHNlY3JldCcKCUFDSy5udHJ1cF9zZWNyZXQgPSBRUC5udHJ1cF9kZWMoc2ssIGN0KQoJbmV3X2NvZGVjKCdudHJ1cCBzZWNyZXQnKQplbmQpCgotLSMgTUwgRFNBIDQ0ICMtLQoKLS0gZ2VuZXJhdGUgdGhlIHByaXZhdGUga2V5CldoZW4oImNyZWF0ZSBtbGRzYTQ0IGtleSIsZnVuY3Rpb24oKQoJaW5pdGtleXJpbmcnbWxkc2E0NCcKCUFDSy5rZXlyaW5nLm1sZHNhNDQgPSBRUC5tbGRzYTQ0X2tleXBhaXIoKS5wcml2YXRlCmVuZCkKCi0tIGdlbmVyYXRlIHRoZSBwdWJsaWMga2V5CldoZW4oImNyZWF0ZSBtbGRzYTQ0IHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKCWVtcHR5J21sZHNhNDQgcHVibGljIGtleScKCWxvY2FsIHNrID0gaGF2ZWtleSdtbGRzYTQ0JwoJQUNLLm1sZHNhNDRfcHVibGljX2tleSA9IFFQLm1sZHNhNDRfcHViZ2VuKHNrKQoJbmV3X2NvZGVjKCdtbGRzYTQ0IHB1YmxpYyBrZXknKQplbmQpCgpXaGVuKCJjcmVhdGUgbWxkc2E0NCBwdWJsaWMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsZnVuY3Rpb24oc2VjKQoJbG9jYWwgc2sgPSBoYXZlKHNlYykKCWVtcHR5J21sZHNhNDQgcHVibGljIGtleScKCUFDSy5tbGRzYTQ0X3B1YmxpY19rZXkgPSBRUC5tbGRzYTQ0X3B1YmdlbihzaykKCW5ld19jb2RlYygnbWxkc2E0NCBwdWJsaWMga2V5JykKZW5kKQoKLS0gZ2VuZXJhdGUgdGhlIHNpZ24gZm9yIGEgbXNnIGFuZCB2ZXJpZnkKV2hlbigiY3JlYXRlIG1sZHNhNDQgc2lnbmF0dXJlIG9mICcnIixmdW5jdGlvbihkb2MpCglsb2NhbCBzayA9IGhhdmVrZXknbWxkc2E0NCcKCWxvY2FsIG9iaiA9IGhhdmUoZG9jKQogICAgbG9jYWwgY3R4ID0gbWF5aGF2ZSdjdHgnIG9yIG5pbAoJZW1wdHknbWxkc2E0NCBzaWduYXR1cmUnCglBQ0subWxkc2E0NF9zaWduYXR1cmUgPSBRUC5tbGRzYTQ0X3NpZ25hdHVyZShzaywgemVuY29kZV9zZXJpYWxpemUob2JqKSwgY3R4KQoJbmV3X2NvZGVjKCdtbGRzYTQ0IHNpZ25hdHVyZScpCmVuZCkKCklmV2hlbigidmVyaWZ5ICcnIGhhcyBhIG1sZHNhNDQgc2lnbmF0dXJlIGluICcnIGJ5ICcnIixmdW5jdGlvbihtc2csIHNpZywgYnkpCgkgIGxvY2FsIHBrID0gbG9hZF9wdWJrZXlfY29tcGF0KGJ5LCAnbWxkc2E0NCcpCgkgIGxvY2FsIG0gPSBoYXZlKG1zZykKCSAgbG9jYWwgcyA9IGhhdmUoc2lnKQogICAgICBsb2NhbCBjdHggPSBtYXloYXZlJ2N0eCcgb3IgbmlsCgkgIHplbmNvZGVfYXNzZXJ0KAoJICAgICBRUC5tbGRzYTQ0X3ZlcmlmeShwaywgcywgemVuY29kZV9zZXJpYWxpemUobSksIGN0eCksCgkgICAgICdUaGUgbWxkc2E0NCBzaWduYXR1cmUgYnkgJy4uYnkuLicgaXMgbm90IGF1dGhlbnRpYycKCSAgKQplbmQpCi96ZW5jb2RlX3JhbmRvbS5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMTgtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBEZW5pcyBSb2lvCi0tb24gU2F0dXJkYXksIDI3dGggTm92ZW1iZXIgMjAyMQotLV1dCgotLSB1dGlscwpsb2NhbCBmdW5jdGlvbiBfZ2V0X2J5dGVzKG4pCiAgICBsb2NhbCBudW0gPSB0b251bWJlcihtYXloYXZlKG4pIG9yIG4pCiAgICBpZiBub3QgbnVtIHRoZW4gZXJyb3IoIkFyZ3VtZW50IGlzIG5vdCBhIG51bWJlcjogIi4ubiwgMikgZW5kCiAgICByZXR1cm4gbWF0aC5jZWlsKG51bSkKZW5kCmxvY2FsIGZ1bmN0aW9uIF9nZXRfYnl0ZXNfZnJvbV9iaXRzKG4pCiAgICBsb2NhbCBudW0gPSB0b251bWJlcihtYXloYXZlKG4pIG9yIG4pCiAgICBpZiBub3QgbnVtIHRoZW4gZXJyb3IoIkFyZ3VtZW50IGlzIG5vdCBhIG51bWJlcjogIi4ubiwgMikgZW5kCiAgICByZXR1cm4gbWF0aC5jZWlsKG51bS84KQplbmQKCi0tIHVuaWZvcm1pdHkgb2J0YWluZWQgd2l0aCByZWplY3Rpb24gc2FtcGxpbmcKbG9jYWwgZnVuY3Rpb24gX3JhbmRvbV9tb2R1bG9fdW5pZm9ybV9kaXN0cmlidXRpb24obW9kdWxvLCBtYXhfcmFuZG9tLCByYW5kb21fZikKICAgIGlmIG5vdCBtb2R1bG8gdGhlbgogICAgICAgIGVycm9yKCJtb2R1bG8gaW5wdXQgYXJndW1lbnQgaXMgbWlzc2luZyIsIDIpCiAgICBlbmQKICAgIGxvY2FsIG1heF9yYW5kb20gPSBtYXhfcmFuZG9tIG9yIDY1NTM2CiAgICBpZiB0eXBlKG1heF9yYW5kb20pIH49IHR5cGUobW9kdWxvKSB0aGVuCiAgICAgICAgZXJyb3IoIm1heF9yYW5kb20gYW5kIG1vZHVsbyBoYXZlIGRpZmZlcmVudCB0eXBlczogIi4udHlwZShtYXhfcmFuZG9tKS4uIiBhbmQgIi4udHlwZShtb2R1bG8pLCAyKQogICAgZW5kCiAgICBpZiBtYXhfcmFuZG9tIDwgbW9kdWxvIHRoZW4KICAgICAgICBlcnJvcigibWF4X3JhbmRvbSBpcyBsZXNzIHRoYW4gbW9kdWxvIiwgMikKICAgIGVuZAogICAgbG9jYWwgcmFuZG9tX2YgPSByYW5kb21fZiBvciByYW5kb21faW50MTYKICAgIGxvY2FsIG1heF91bmlmb3JtX3JhbmRvbQogICAgaWYgdHlwZShtb2R1bG8pID09ICd6ZW5yb29tLmJpZycgdGhlbgogICAgICAgIG1heF91bmlmb3JtX3JhbmRvbSA9IChtYXhfcmFuZG9tL21vZHVsbykqbW9kdWxvCiAgICBlbHNlCiAgICAgICAgbWF4X3VuaWZvcm1fcmFuZG9tID0gbWF0aC5mbG9vcihtYXhfcmFuZG9tL21vZHVsbykqbW9kdWxvCiAgICBlbmQKICAgIGxvY2FsIHJhbmRvbSA9IHJhbmRvbV9mKCkKICAgIHdoaWxlIHJhbmRvbSA+PSBtYXhfdW5pZm9ybV9yYW5kb20gZG8KICAgICAgICByYW5kb20gPSByYW5kb21fZigpCiAgICBlbmQKICAgIHJldHVybiAocmFuZG9tICUgbW9kdWxvKSArMQplbmQKCi0tIHJhbmRvbSBvcGVyYXRpb25zLCBtb3N0bHkgb24gYXJyYXlzIGFuZCBzY2hlbWFzIHN1cHBvcnRlZAoKV2hlbigic2VlZCByYW5kb20gd2l0aCAnJyIsCiAgICAgZnVuY3Rpb24oc2VlZCkKICAgICAgICAgbG9jYWwgcyA9IGhhdmUoc2VlZCkKICAgICAgICAgemVuY29kZV9hc3NlcnQoaXN6ZW4odHlwZShzKSksICJOZXcgcmFuZG9tIHNlZWQgaXMgbm90IGEgdmFsaWQgemVucm9vbSB0eXBlOiAiLi5zZWVkKQogICAgICAgICBsb2NhbCBmaW5nZXJwcmludCA9IHJhbmRvbV9zZWVkKHM6b2N0ZXQoKSkgLS0gcGFzcyB0aGUgc2VlZCBmb3Igc3JhbmQgaW5pdAogICAgICAgICBhY3QoIk5ldyByYW5kb20gc2VlZCBvZiAiLi4jcy4uIiBieXRlcyIpCiAgICAgICAgIHh4eCgiTmV3IHJhbmRvbSBmaW5nZXJwcmludDogIi4uZmluZ2VycHJpbnQ6aGV4KCkpCiAgICAgZW5kCikKCi0tIHJhbmRvbSBvY3RldHMKCmxvY2FsIGZ1bmN0aW9uIF9jcmVhdGVfcmFuZG9tKGRlc3QsIGJ5dGVzKQogICAgZW1wdHkoZGVzdCkKICAgIEFDS1tkZXN0XSA9IE9DVEVULnJhbmRvbShieXRlcykKICAgIG5ld19jb2RlYyhkZXN0LCB7IHplbnR5cGUgPSAnZScgfSkKZW5kCgpXaGVuKCJjcmVhdGUgcmFuZG9tICcnIiwgZnVuY3Rpb24oZGVzdCkKICAgIF9jcmVhdGVfcmFuZG9tKGRlc3QsIDMyKQplbmQpCldoZW4oImNyZWF0ZSByYW5kb20gb2YgJycgYml0cyIsIGZ1bmN0aW9uKG4pCiAgICBfY3JlYXRlX3JhbmRvbSgncmFuZG9tJywgX2dldF9ieXRlc19mcm9tX2JpdHMobikpCmVuZCkKV2hlbigiY3JlYXRlIHJhbmRvbSBvZiAnJyBieXRlcyIsIGZ1bmN0aW9uKG4pCiAgICBfY3JlYXRlX3JhbmRvbSgncmFuZG9tJywgX2dldF9ieXRlcyhuKSkKZW5kKQoKV2hlbigKICAgIGRlcHJlY2F0ZWQoCiAgICAgICAgImNyZWF0ZSByYW5kb20gb2JqZWN0IG9mICcnIGJpdHMiLAogICAgICAgICJjcmVhdGUgcmFuZG9tIG9mICcnIGJpdHMiLAogICAgICAgIGZ1bmN0aW9uKG4pIF9jcmVhdGVfcmFuZG9tKCdyYW5kb21fb2JqZWN0JywgX2dldF9ieXRlc19mcm9tX2JpdHMobikpIGVuZAogICAgKQopCldoZW4oCiAgICBkZXByZWNhdGVkKAogICAgICAgICJjcmVhdGUgcmFuZG9tIG9iamVjdCBvZiAnJyBieXRlcyIsCiAgICAgICAgImNyZWF0ZSByYW5kb20gb2YgJycgYnl0ZXMiLAogICAgICAgIGZ1bmN0aW9uKG4pIF9jcmVhdGVfcmFuZG9tKCdyYW5kb21fb2JqZWN0JywgX2dldF9ieXRlcyhuKSkgZW5kCiAgICApCikKCi0tIGFycmF5IHNodWZmbGUKCi0tIEZpc2hlci1ZYXRlcyBhbGdvcml0aG0KbG9jYWwgZnVuY3Rpb24gc2h1ZmZsZV9hcnJheV9mKGFycikKICAgIGxvY2FsIHRhYiwgY190YWIgPSBoYXZlKGFycikKICAgIGlmIChjX3RhYi56ZW50eXBlIH49ICdhJyBhbmQgKG5vdCBjX3RhYi5zY2hlbWEgb3Igbm90IGlzYXJyYXkodGFiKSkpIHRoZW4KICAgICAgICBlcnJvcigiT2JqZWN0IHRvIGJlIHJhbmRvbWl6ZWQgaXMgbm90IGFuIGFycmF5OiAiLi5hcnIsIDIpCiAgICBlbmQKICAgIGxvY2FsIHRhYl9sZW4gPSAjdGFiCiAgICBsb2NhbCByZXMgPSB7IH0KICAgIGZvciBpID0gdGFiX2xlbiwyLC0xIGRvCiAgICAgICAgbG9jYWwgciA9IF9yYW5kb21fbW9kdWxvX3VuaWZvcm1fZGlzdHJpYnV0aW9uKGkpCiAgICAgICAgciA9IChyICUgaSkgKyAxCiAgICAgICAgdGFiW2ldLCB0YWJbcl0gPSB0YWJbcl0sIHRhYltpXQogICAgZW5kCmVuZAoKV2hlbigicmFuZG9taXplICcnIGFycmF5Iiwgc2h1ZmZsZV9hcnJheV9mKQoKLS0gcmFuZG9tIGFycmF5Cgpsb2NhbCBmdW5jdGlvbiBfY3JlYXRlX3JhbmRvbV9hcnJheShkZXN0X25hbWUsIGFycmF5X2xlbmd0aCwgZnVuX2lucHV0LCBmdW4sIGNvZGVjKQogICAgZW1wdHkoZGVzdF9uYW1lKQogICAgbG9jYWwgbGVuZ3RoID0gdG9udW1iZXIobWF5aGF2ZShhcnJheV9sZW5ndGgpIG9yIGFycmF5X2xlbmd0aCkKICAgIHplbmNvZGVfYXNzZXJ0KGxlbmd0aCwgIkFyZ3VtZW50IGlzIG5vdCBhIG51bWJlcjogIi4uYXJyYXlfbGVuZ3RoKQogICAgbG9jYWwgZHN0ID0ge30KICAgIGZvciBpID0gbGVuZ3RoLDEsLTEgZG8KICAgICAgICB0YWJsZS5pbnNlcnQoZHN0LCBmdW4oZnVuX2lucHV0KSkKICAgIGVuZAogICAgbG9jYWwgbl9jb2RlYyA9IHt6ZW50eXBlID0gJ2EnfQogICAgaWYgY29kZWMgdGhlbgogICAgICAgIGZvciBrLCB2IGluIHBhaXJzKGNvZGVjKSBkbwogICAgICAgICAgICBuX2NvZGVjW2tdID0gdgogICAgICAgIGVuZAogICAgZW5kCiAgICBBQ0tbZGVzdF9uYW1lXSA9IGRzdAogICAgbmV3X2NvZGVjKGRlc3RfbmFtZSwgbl9jb2RlYykKZW5kCgpXaGVuKCJjcmVhdGUgcmFuZG9tIGFycmF5IHdpdGggJycgZWxlbWVudHMiLCBmdW5jdGlvbihzKQogICAgX2NyZWF0ZV9yYW5kb21fYXJyYXkoJ3JhbmRvbV9hcnJheScsIHMsIDY0LCBPQ1RFVC5yYW5kb20pCmVuZCkKV2hlbigiY3JlYXRlIHJhbmRvbSBhcnJheSB3aXRoICcnIGVsZW1lbnRzIGVhY2ggb2YgJycgYml0cyIsIGZ1bmN0aW9uKHMsIGIpCiAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgncmFuZG9tX2FycmF5JywgcywgX2dldF9ieXRlc19mcm9tX2JpdHMoYiksIE9DVEVULnJhbmRvbSkKZW5kKQpXaGVuKCJjcmVhdGUgcmFuZG9tIGFycmF5IHdpdGggJycgZWxlbWVudHMgZWFjaCBvZiAnJyBieXRlcyIsIGZ1bmN0aW9uKHMsIGIpCiAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgncmFuZG9tX2FycmF5JywgcywgX2dldF9ieXRlcyhiKSwgT0NURVQucmFuZG9tKQplbmQpCgpXaGVuKAogICAgZGVwcmVjYXRlZCgKICAgICAgICAiY3JlYXRlIGFycmF5IG9mICcnIHJhbmRvbSBvYmplY3RzIiwKICAgICAgICAiY3JlYXRlIHJhbmRvbSBhcnJheSB3aXRoICcnIGVsZW1lbnRzIiwKICAgICAgICBmdW5jdGlvbihzKQogICAgICAgICAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgnYXJyYXknLCBzLCA2NCwgT0NURVQucmFuZG9tKQogICAgICAgIGVuZAogICAgKQopCldoZW4oCiAgICBkZXByZWNhdGVkKAogICAgICAgICJjcmVhdGUgYXJyYXkgb2YgJycgcmFuZG9tIG9iamVjdHMgb2YgJycgYml0cyIsCiAgICAgICAgImNyZWF0ZSByYW5kb20gYXJyYXkgd2l0aCAnJyBlbGVtZW50cyBlYWNoIG9mICcnIGJpdHMiLAogICAgICAgIGZ1bmN0aW9uKHMsIGIpCiAgICAgICAgICAgIF9jcmVhdGVfcmFuZG9tX2FycmF5KCdhcnJheScsIHMsIF9nZXRfYnl0ZXNfZnJvbV9iaXRzKGIpLCBPQ1RFVC5yYW5kb20pCiAgICAgICAgZW5kCiAgICApCikKV2hlbigKICAgIGRlcHJlY2F0ZWQoCiAgICAgICAgImNyZWF0ZSBhcnJheSBvZiAnJyByYW5kb20gb2JqZWN0cyBvZiAnJyBieXRlcyIsCiAgICAgICAgImNyZWF0ZSByYW5kb20gYXJyYXkgd2l0aCAnJyBlbGVtZW50cyBlYWNoIG9mICcnIGJ5dGVzIiwKICAgICAgICBmdW5jdGlvbihzLCBiKQogICAgICAgICAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgnYXJyYXknLCBzLCBfZ2V0X2J5dGVzKGIpLCBPQ1RFVC5yYW5kb20pCiAgICAgICAgZW5kCiAgICApCikKCldoZW4oImNyZWF0ZSByYW5kb20gYXJyYXkgd2l0aCAnJyBudW1iZXJzIiwgZnVuY3Rpb24ocykKICAgIF9jcmVhdGVfcmFuZG9tX2FycmF5KCdyYW5kb21fYXJyYXknLCBzLCA2NTUzNiwgZnVuY3Rpb24obSkgcmV0dXJuIEYubmV3KF9yYW5kb21fbW9kdWxvX3VuaWZvcm1fZGlzdHJpYnV0aW9uKG0pKSBlbmQsIHtlbmNvZGluZyA9ICdmbG9hdCd9KQplbmQpCldoZW4oImNyZWF0ZSByYW5kb20gYXJyYXkgd2l0aCAnJyBpbnRlZ2VycyIsIGZ1bmN0aW9uKHMpCiAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgncmFuZG9tX2FycmF5JywgcywgbmlsLCBCSUcucmFuZG9tLCB7ZW5jb2RpbmcgPSAnaW50ZWdlcid9KQplbmQpCldoZW4oCiAgICBkZXByZWNhdGVkKAogICAgICAgICJjcmVhdGUgYXJyYXkgb2YgJycgcmFuZG9tIG51bWJlcnMiLAogICAgICAgICJjcmVhdGUgcmFuZG9tIGFycmF5IHdpdGggJycgW251bWJlcnN8aW50ZWdlcnNdIiwKICAgICAgICBmdW5jdGlvbihzKQogICAgICAgICAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgnYXJyYXknLCBzLCBuaWwsIEJJRy5yYW5kb20sIHtlbmNvZGluZyA9ICdpbnRlZ2VyJ30pCiAgICAgICAgZW5kCiAgICApCikKCmxvY2FsIHJhbmRvbV9nZW5lcmF0b3IgPGNvbnN0PiA9IHsKICAgIFsnemVucm9vbS5iaWcnXSA9IHsKICAgICAgICBmdW4gPSBmdW5jdGlvbihpbnB1dF9tb2R1bG8pIHJldHVybiBfcmFuZG9tX21vZHVsb191bmlmb3JtX2Rpc3RyaWJ1dGlvbihpbnB1dF9tb2R1bG8sIEVDUC5vcmRlcigpLCBCSUcucmFuZG9tKSBlbmQsCiAgICAgICAgZW5jID0ge2VuY29kaW5nID0gJ2ludGVnZXInfQogICAgfSwKICAgIFsnemVucm9vbS5mbG9hdCddID0gewogICAgICAgIGZ1biA9IGZ1bmN0aW9uKGlucHV0X21vZHVsbykgcmV0dXJuIEYubmV3KF9yYW5kb21fbW9kdWxvX3VuaWZvcm1fZGlzdHJpYnV0aW9uKHRvbnVtYmVyKGlucHV0X21vZHVsbykpKSBlbmQsCiAgICAgICAgZW5jID0ge2VuY29kaW5nID0gJ2Zsb2F0J30KICAgIH0KfQpXaGVuKCJjcmVhdGUgcmFuZG9tIGFycmF5IHdpdGggJycgbnVtYmVycyBtb2R1bG8gJyciLCBmdW5jdGlvbiAocyxtKQogICAgbG9jYWwgbW9kdWxvLCBjID0gbWF5aGF2ZShtKSBvciBtLCBuaWwKICAgIGxvY2FsIG4gPSB0b251bWJlcihtb2R1bG8pCiAgICBpZiBub3QgbiB0aGVuIGVycm9yKCJBcmd1bWVudCBpcyBub3QgYSBudW1iZXI6ICIuLm0pIGVuZAogICAgaWYgYyBhbmQgYy5lbmNvZGluZyB+PSAiZmxvYXQiIHRoZW4KICAgICAgICBlcnJvcigiQXJndW1lbnQgaXMgbm90IGEgbnVtYmVyOiAiLi4gYy5lbmNvZGluZykKICAgIGVuZAogICAgbG9jYWwgcmFuZG9tX2dlbiA9IHJhbmRvbV9nZW5lcmF0b3JbJ3plbnJvb20uZmxvYXQnXQogICAgX2NyZWF0ZV9yYW5kb21fYXJyYXkoJ3JhbmRvbV9hcnJheScsIHMsIG4sIHJhbmRvbV9nZW4uZnVuLCByYW5kb21fZ2VuLmVuYykKZW5kKQpXaGVuKCJjcmVhdGUgcmFuZG9tIGFycmF5IHdpdGggJycgaW50ZWdlcnMgbW9kdWxvICcnIiwgZnVuY3Rpb24gKHMsbSkKICAgIGxvY2FsIG1vZHVsbywgYyA9IG1heWhhdmUobSkgb3IgbSwgbmlsCiAgICBsb2NhbCBuID0gQklHLm5ldyhtb2R1bG8pCiAgICBpZiBub3QgbiB0aGVuIGVycm9yKCJBcmd1bWVudCBpcyBub3QgYSBpbnRlZ2VyOiAiLi5tKSBlbmQKICAgIGlmIGMgYW5kIGMuZW5jb2Rpbmcgfj0gImludGVnZXIiIHRoZW4KICAgICAgICBlcnJvcigiQXJndW1lbnQgaXMgbm90IGEgaW50ZWdlcjogIi4uIGMuZW5jb2RpbmcpCiAgICBlbmQKICAgIGxvY2FsIHJhbmRvbV9nZW4gPSByYW5kb21fZ2VuZXJhdG9yWyd6ZW5yb29tLmJpZyddCiAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgncmFuZG9tX2FycmF5JywgcywgbiwgcmFuZG9tX2dlbi5mdW4sIHJhbmRvbV9nZW4uZW5jKQplbmQpCldoZW4oCiAgICBkZXByZWNhdGVkKAogICAgICAgICJjcmVhdGUgYXJyYXkgb2YgJycgcmFuZG9tIG51bWJlcnMgbW9kdWxvICcnIiwKICAgICAgICAiY3JlYXRlIHJhbmRvbSBhcnJheSB3aXRoICcnIFtudW1iZXJzfGludGVnZXJzXSBtb2R1bG8gJyciLAogICAgICAgIGZ1bmN0aW9uKHMsbSkKICAgICAgICAgICAgbG9jYWwgbW9kdWxvID0gbWF5aGF2ZShtKQogICAgICAgICAgICBpZiBub3QgbW9kdWxvIHRoZW4KICAgICAgICAgICAgICAgIGxvY2FsIG1vZCA9IHRvbnVtYmVyKG0pCiAgICAgICAgICAgICAgICB6ZW5jb2RlX2Fzc2VydChtb2QsICJBcmd1bWVudCBpcyBub3QgYSBudW1iZXI6ICIuLm0pCiAgICAgICAgICAgICAgICBtb2R1bG8gPSBCSUcubmV3KG1vZCkKICAgICAgICAgICAgZW5kCiAgICAgICAgICAgIGxvY2FsIG1vZHVsb190eXBlID0gdHlwZShtb2R1bG8pCiAgICAgICAgICAgIGxvY2FsIHJhbmRvbV9nZW4gPSByYW5kb21fZ2VuZXJhdG9yW21vZHVsb190eXBlXQogICAgICAgICAgICBpZiBub3QgcmFuZG9tX2dlbiB0aGVuCiAgICAgICAgICAgICAgICBlcnJvcigiTW9kdWxvIGlzIG5vdCBhIG51bWJlciBub3IgYW4gaW50ZWdlcjogIi4ubW9kdWxvX3R5cGUpCiAgICAgICAgICAgIGVuZAogICAgICAgICAgICBfY3JlYXRlX3JhbmRvbV9hcnJheSgnYXJyYXknLCBzLCBtb2R1bG8sIHJhbmRvbV9nZW4uZnVuLCByYW5kb21fZ2VuLmVuYykKICAgICAgICBlbmQKICAgICkKKQoKLS0gcGljayByYW5kb20gZWxlbWVudAoKLS0gcmVzZXJ2b2lyIHNhbXBsaW5nIGFsZ29yaXRobQpsb2NhbCBmdW5jdGlvbiBfZXh0cmFjdF9yYW5kb21fZWxlbWVudHMoZGVzdCwgbnVtLCBmcm9tLCBkZXN0X3R5cGUpCiAgICBlbXB0eShkZXN0KQogICAgbG9jYWwgbiA9IHRvbnVtYmVyKG51bSkgb3IgdG9udW1iZXIodG9zdHJpbmcoaGF2ZShudW0pKSkKICAgIHplbmNvZGVfYXNzZXJ0KG4gYW5kIG4+MCwgIk5vdCBhIG51bWJlciBvciBub3QgYSBwb3NpdGl2ZSBudW1iZXI6ICIuLm51bSkKICAgIGxvY2FsIHNyYywgc3JjX2NvZGVjID0gaGF2ZShmcm9tKQogICAgemVuY29kZV9hc3NlcnQobHVhdHlwZShzcmMpID09ICd0YWJsZScsICJPYmplY3QgaXMgbm90IGEgdGFibGU6ICIuLmZyb20pCiAgICBsb2NhbCBpc19hcnJheSA9IGlzYXJyYXkoc3JjKQogICAgbG9jYWwgc3JjX3R5cGUgPSBmaWYoaXNfYXJyYXksICJhIiwgImQiKQogICAgaWYgZGVzdF90eXBlIGFuZCBzcmNfdHlwZSB+PSBkZXN0X3R5cGUgdGhlbgogICAgICAgIGVycm9yKCJPYmplY3QgaGFzIHR5cGUgIi4uc3JjX3R5cGUuLiIgd2hpbGUgZGVzdGluYXRpb24gIi4uZGVzdF90eXBlLCAyKQogICAgZW5kCgogICAgbG9jYWwga2V5cyA9IHt9CiAgICBsb2NhbCB2YWx1ZXMgPSB7fQogICAgZm9yIGssdiBpbiBwYWlycyhzcmMpIGRvCiAgICAgICAgdGFibGUuaW5zZXJ0KGtleXMsIGspCiAgICAgICAgdGFibGUuaW5zZXJ0KHZhbHVlcywgdikKICAgIGVuZAoKICAgIGxvY2FsIGxlbiA9ICNrZXlzCiAgICBsb2NhbCBtYXhfbGVuID0gNjU1MzYKICAgIHplbmNvZGVfYXNzZXJ0KGxlbiA8IG1heF9sZW4sICJUaGUgbnVtYmVyIG9mIGVsZW1lbnRzIG9mICIuLmZyb20uLiIgZXhjZWVkIHRoZSBtYXhpbXVtIGxlbmd0aDogIi4ubWF4X2xlbikKICAgIHplbmNvZGVfYXNzZXJ0KG4gPD0gbGVuLCBudW0uLiIgaXMgZ3JhdGVyIHRoYW4gdGhlIG51bWJlciBvZiBlbGVtZW50cyBpbiAiLi5mcm9tKQoKICAgIGxvY2FsIGRzdCA9IHt9CiAgICBmb3IgaSA9IDEsIG4gZG8KICAgICAgICBpZiBpc19hcnJheSB0aGVuCiAgICAgICAgICAgIGRzdFtpXSA9IHZhbHVlc1tpXQogICAgICAgIGVsc2UKICAgICAgICAgICAgZHN0W2tleXNbaV1dID0gdmFsdWVzW2ldCiAgICAgICAgZW5kCiAgICBlbmQKCiAgICBmb3IgaSA9IG4rMSwgbGVuIGRvCiAgICAgICAgbG9jYWwgciA9IHJhbmRvbV9pbnQxNigpCiAgICAgICAgaWYgciAlIGkgPCBuIHRoZW4KICAgICAgICAgICAgbG9jYWwgcmVwbGFjZV9pbmRleCA9IChyICUgbikgKyAxCiAgICAgICAgICAgIGlmIGlzX2FycmF5IHRoZW4KICAgICAgICAgICAgICAgIGRzdFtyZXBsYWNlX2luZGV4XSA9IHZhbHVlc1tpXQogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICBkc3Rba2V5c1tyZXBsYWNlX2luZGV4XV0gPSBuaWwKICAgICAgICAgICAgICAgIGRzdFtrZXlzW2ldXSA9IHZhbHVlc1tpXQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgIGVuZAoKICAgIGxvY2FsIG5fY29kZWMgPSB7ZW5jb2RpbmcgPSBzcmNfY29kZWMuZW5jb2Rpbmd9CiAgICBpZiAobiA9PSAxKSB0aGVuIAogICAgICAgIG5fY29kZWMubmFtZSwgQUNLW2Rlc3RdID0gbmV4dChkc3QpCiAgICBlbHNlCiAgICAgICAgQUNLW2Rlc3RdID0gZHN0CiAgICBlbmQKICAgIG5ld19jb2RlYyhkZXN0LCBuX2NvZGVjKSAKZW5kCgpXaGVuKCJjcmVhdGUgcmFuZG9tIHBpY2sgZnJvbSAnJyIsIGZ1bmN0aW9uKGZyb20pCiAgICBfZXh0cmFjdF9yYW5kb21fZWxlbWVudHMoJ3JhbmRvbV9waWNrJywgMSwgZnJvbSkKZW5kKQpXaGVuKCJjcmVhdGUgcmFuZG9tIGFycmF5IHdpdGggJycgZWxlbWVudHMgZnJvbSAnJyIsIGZ1bmN0aW9uKG51bSwgZnJvbSkKICAgIF9leHRyYWN0X3JhbmRvbV9lbGVtZW50cygncmFuZG9tX2FycmF5JywgbnVtLCBmcm9tLCAiYSIpCmVuZCkKV2hlbigiY3JlYXRlIHJhbmRvbSBkaWN0aW9uYXJ5IHdpdGggJycgZWxlbWVudHMgZnJvbSAnJyIsIGZ1bmN0aW9uKG51bSwgZnJvbSkKICAgIF9leHRyYWN0X3JhbmRvbV9lbGVtZW50cygncmFuZG9tX2RpY3Rpb25hcnknLCBudW0sIGZyb20sICJkIikKZW5kKQoKV2hlbigKICAgIGRlcHJlY2F0ZWQoCiAgICAgICAgInBpY2sgcmFuZG9tIG9iamVjdCBpbiAnJyIsCiAgICAgICAgImNyZWF0ZSByYW5kb20gcGljayBmcm9tICcnIiwKICAgICAgICBmdW5jdGlvbihmcm9tKQogICAgICAgICAgICBfZXh0cmFjdF9yYW5kb21fZWxlbWVudHMoJ3JhbmRvbV9vYmplY3QnLCAxLCBmcm9tKQogICAgICAgIGVuZAogICAgKQopCldoZW4oCiAgICBkZXByZWNhdGVkKAogICAgICAgICJjcmVhdGUgcmFuZG9tIGRpY3Rpb25hcnkgd2l0aCAnJyByYW5kb20gb2JqZWN0cyBmcm9tICcnIiwKICAgICAgICAiY3JlYXRlIHJhbmRvbSBbYXJyYXl8ZGljdGlvbmFyeV0gd2l0aCAnJyBlbGVtZW50cyBmcm9tICcnIiwKICAgICAgICBmdW5jdGlvbihudW0sIGZyb20pCiAgICAgICAgICAgIF9leHRyYWN0X3JhbmRvbV9lbGVtZW50cygncmFuZG9tX2RpY3Rpb25hcnknLCBudW0sIGZyb20pCiAgICAgICAgZW5kCiAgICApCikKL3plbmNvZGVfcmVmbG93Lmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBTdW5kYXksIDEwdGggQXByaWwgMjAyMgotLV1dCgpsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX2NyZWRlbnRpYWwnKQoKQUJDID0gcmVxdWlyZV9vbmNlKCdjcnlwdG9fY3JlZGVudGlhbCcpCgpsb2NhbCBmdW5jdGlvbiBfZXhwb3J0X2JpZ19hc19vY3RldF9mKG9iaikKICAgIGlmIHR5cGUob2JqKSA9PSAnemVucm9vbS5iaWcnIHRoZW4KICAgICAgICByZXR1cm4gb2JqOm9jdGV0KCk6YmFzZTY0KCkKICAgIGVuZAogICAgcmV0dXJuIG9iagplbmQKCkcyID0gRUNQMi5nZW5lcmF0b3IoKQoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3JlZmxvd19zZWFsX2ZpbmdlcnByaW50c19mKG8pCiAgICBpZiBub3QgbyB0aGVuCiAgICAgICAgcmV0dXJuIHt9CiAgICBlbmQKICAgIGxvY2FsIHJhd2FyciA9IGRlZXBtYXAoQ09ORi5pbnB1dC5lbmNvZGluZy5mdW4sIG8pCiAgICBsb2NhbCBhcnIgPSB7fQogICAgZm9yIF8sIHYgaW4gaXBhaXJzKHJhd2FycikgZG8KICAgICAgICB0YWJsZS5pbnNlcnQoYXJyLCBFQ1AubmV3KHYpKQogICAgZW5kCiAgICByZXR1cm4gYXJyCmVuZAoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3JlZmxvd19zZWFsX2Yob2JqKQogICBsb2NhbCBmCiAgIGlmIG9iai5maW5nZXJwcmludHMgdGhlbgoJICBmID0gaW1wb3J0X3JlZmxvd19zZWFsX2ZpbmdlcnByaW50c19mKG9iai5maW5nZXJwcmludHMpCiAgIGVsc2UgZiA9IG5pbCBlbmQKICAgcmV0dXJuIHsKCSAgaWRlbnRpdHkgPSBzY2hlbWFfZ2V0KG9iaiwgJ2lkZW50aXR5JywgRUNQLm5ldyksCgkgIFNNID0gc2NoZW1hX2dldChvYmosICdTTScsIEVDUC5uZXcpLAoJICB2ZXJpZmllciA9IHNjaGVtYV9nZXQob2JqLCAndmVyaWZpZXInLCBFQ1AyLm5ldyksCgkgIGZpbmdlcnByaW50cyA9IGYKICAgfQplbmQKClpFTjphZGRfc2NoZW1hKAogICB7CiAgICAgIHJlZmxvd19wdWJsaWNfa2V5ID0gZnVuY3Rpb24ob2JqKQoJIHJldHVybiBzY2hlbWFfZ2V0KG9iaiwgJy4nLCBFQ1AyLm5ldykKICAgICAgZW5kLAoKICAgICAgcmVmbG93X3NlYWwgPSBpbXBvcnRfcmVmbG93X3NlYWxfZiwKCiAgICAgIHJlZmxvd19zaWduYXR1cmUgPSB7CgkgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQoJICAgIHJldHVybiB7CgkgICAgICAgaWRlbnRpdHkgPSBzY2hlbWFfZ2V0KG9iaiwgJ2lkZW50aXR5JywgRUNQLm5ldyksCgkgICAgICAgc2lnbmF0dXJlID0gc2NoZW1hX2dldChvYmosICdzaWduYXR1cmUnLCBFQ1AubmV3KSwKCSAgICAgICBwcm9vZiA9IGltcG9ydF9jcmVkZW50aWFsX3Byb29mX2Yob2JqLnByb29mKSwKCSAgICAgICB6ZXRhID0gc2NoZW1hX2dldChvYmosICd6ZXRhJywgRUNQLm5ldykKCSAgICB9CgkgZW5kLAoJIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikKICAgICAgICAgb2JqLnByb29mID0gZXhwb3J0X2NyZWRlbnRpYWxfcHJvb2ZfZihvYmoucHJvb2YpCiAgICAgICAgIHJldHVybiBvYmoKICAgICBlbmQsCiAgICAgIH0sCiAgICAgIHJlZmxvd19pZGVudGl0eSA9IGZ1bmN0aW9uKG9iaikKCSByZXR1cm4gc2NoZW1hX2dldChvYmosICcuJywgRUNQLm5ldykKICAgICAgZW5kLAogICAgICBtYXRlcmlhbF9wYXNzcG9ydCA9IGZ1bmN0aW9uKG9iaikKCSByZXR1cm4gewoJICAgIHNlYWwgPSBpbXBvcnRfcmVmbG93X3NlYWxfZihvYmouc2VhbCksCgkgICAgcHJvb2YgPSBpbXBvcnRfY3JlZGVudGlhbF9wcm9vZl9mKG9iai5wcm9vZiksCgkgICAgemV0YSA9IHNjaGVtYV9nZXQob2JqLCAnemV0YScsIEVDUC5uZXcpCgkgfQogICAgICBlbmQKICAgfQopCgpsb2NhbCBmdW5jdGlvbiBfbWFrZXVpZChzcmMpCiAgIGxvY2FsIHVpZAogICBpZiBsdWF0eXBlKHNyYykgPT0gJ3RhYmxlJyB0aGVuCgkgIHVpZCA9IEVDUC5oYXNodG9wb2ludCh6ZW5jb2RlX3NlcmlhbGl6ZShzcmMpKQogICBlbHNlCgkgIHVpZCA9IEVDUC5oYXNodG9wb2ludChzcmMpCiAgIGVuZAogICByZXR1cm4odWlkKQplbmQKCldoZW4oImNyZWF0ZSByZWZsb3cga2V5IixmdW5jdGlvbigpCiAgICAgICAgLS0ga2V5Z2VuOiDOtCA9IHIuTyA7IM6zID0gzrQuRzIKICAgICAgICBpbml0a2V5cmluZyAncmVmbG93JwogICAgICAgIEFDSy5rZXlyaW5nLnJlZmxvdyA9IElOVC5yYW5kb20oKQogICAgICAgIC0tIEJMUyBzZWNyZXQgc2lnbmluZyBrZXkKZW5kKQoKV2hlbigiY3JlYXRlIHJlZmxvdyBrZXkgd2l0aCBzZWNyZXQga2V5ICcnIixmdW5jdGlvbihzZWMpCiAgICBsb2NhbCBzayA9IGhhdmUoc2VjKQogICAgaW5pdGtleXJpbmcncmVmbG93JwogICAgQUNLLmtleXJpbmcucmVmbG93ID0gSU5ULm5ldyhzaykKZW5kKQpXaGVuKCJjcmVhdGUgcmVmbG93IGtleSB3aXRoIHNlY3JldCAnJyIsCmZ1bmN0aW9uKHNlYykKICAgIGxvY2FsIHNrID0gaGF2ZShzZWMpCiAgICBpbml0a2V5cmluZydyZWZsb3cnCiAgICBBQ0sua2V5cmluZy5yZWZsb3cgPSBJTlQubmV3KHNrKQplbmQpCgpXaGVuKCJjcmVhdGUgcmVmbG93IHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKICAgICAgICBlbXB0eSAncmVmbG93IHB1YmxpYyBrZXknCiAgICAgICAgaGF2ZWtleSAncmVmbG93JwogICAgICAgIEFDSy5yZWZsb3dfcHVibGljX2tleSA9IEcyICogQUNLLmtleXJpbmcucmVmbG93CgluZXdfY29kZWMncmVmbG93IHB1YmxpYyBrZXknCmVuZCkKCldoZW4oImFnZ3JlZ2F0ZSByZWZsb3cgcHVibGljIGtleSBmcm9tIGFycmF5ICcnIixmdW5jdGlvbihhcnIpCiAgICAgIGVtcHR5ICdyZWZsb3cgcHVibGljIGtleScKICAgICAgbG9jYWwgcyA9IGhhdmUoYXJyKQogICAgICB6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKHMpID09ICd0YWJsZScgYW5kIG5leHQocykgfj0gbmlsLCAiRW1wdHkgdGFibGU6ICIuLmFycikKICAgICAgbG9jYWwgdmFsCiAgICAgIGZvciBrLCB2IGluIHBhaXJzKHMpIGRvCgkgaWYgayA9PSAncmVmbG93X3B1YmxpY19rZXknIHRoZW4gdmFsID0gdgoJICAgIC0tIHRvbGVyYXRlIGFib3V0IG5hbWVkIGFycmF5cwoJIGVsc2VpZiB2LnJlZmxvd19wdWJsaWNfa2V5IHRoZW4gdmFsID0gdi5yZWZsb3dfcHVibGljX2tleQoJIGVsc2UgemVuY29kZV9hc3NlcnQoZmFsc2UsICJSZWZsb3cgcHVibGljIGtleSBub3QgZm91bmQgaW4gYXJyYXk6ICIKCQkJIC4uYXJyLi4iWyIuLiNzLi4iXSBhdCBrZXkgIi4uaykKCSBlbmQKCSBpZiBub3QgQUNLLnJlZmxvd19wdWJsaWNfa2V5IHRoZW4KCSAgICBBQ0sucmVmbG93X3B1YmxpY19rZXkgPSB2YWwKCSBlbHNlCgkgICAgQUNLLnJlZmxvd19wdWJsaWNfa2V5ID0gQUNLLnJlZmxvd19wdWJsaWNfa2V5ICsgdmFsCgkgZW5kCiAgICAgIGVuZAogICAgICBuZXdfY29kZWMncmVmbG93IHB1YmxpYyBrZXknCmVuZCkKCldoZW4oImNyZWF0ZSByZWZsb3cgaWRlbnRpdHkgb2YgJyciLGZ1bmN0aW9uKGRvYykKCWVtcHR5ICdyZWZsb3cgaWRlbnRpdHknCglBQ0sucmVmbG93X2lkZW50aXR5ID0gX21ha2V1aWQoaGF2ZShkb2MpKQoJbmV3X2NvZGVjJ3JlZmxvdyBpZGVudGl0eScKZW5kKQoKV2hlbigiY3JlYXRlIHJlZmxvdyBpZGVudGl0eSBvZiBvYmplY3RzIGluICcnIixmdW5jdGlvbihkb2MpCgllbXB0eSAncmVmbG93IGlkZW50aXR5JwoJbG9jYWwgYXJyID0gaGF2ZShkb2MpCgl6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKGFycik9PSd0YWJsZScsICJPYmplY3QgaXMgbm90IGFuIGFycmF5IG9yIGRpY3Rpb25hcnk6ICIuLmRvYykKCWxvY2FsIGZpcnN0ID0geyB9Cglmb3Igayx2IGluIHBhaXJzKGFycikgZG8KCSAgIC0tIGlmIHJlZmxvd19pZCBhbHJlYWR5IHByZXNlbnQgdGhlbiBjaGVjayBpZiBFQ1AgYW5kIHVzZSB0aGF0CgkgICBpZiB2LnJlZmxvd19pZGVudGl0eSB0aGVuCgkgICAgICBsb2NhbCByaWQgPSBFQ1AubmV3KHYucmVmbG93X2lkZW50aXR5KQoJICAgICAgemVuY29kZV9hc3NlcnQobm90IHJpZDppc2luZmluaXR5KCksCgkJCSAiT2JqZWN0ICIuLmRvYy4uIlsiLi5rLi4iXSBoYXMgYW4gaW52YWxpZCByZWZsb3cgaWRlbnRpdHkiKQoJICAgICAgdGFibGUuaW5zZXJ0KGZpcnN0LCByaWQpCgkgICBlbHNlCgkgICAgICB0YWJsZS5pbnNlcnQoZmlyc3QsIF9tYWtldWlkKHYpKQoJICAgZW5kCgllbmQKCWxvY2FsIHJlcwoJZm9yIF8sdiBpbiBwYWlycyhmaXJzdCkgZG8KCSAgIGlmIG5vdCByZXMgdGhlbgoJICAgICAgcmVzID0gdgoJICAgZWxzZQoJICAgICAgcmVzID0gcmVzICsgdgoJICAgZW5kCgllbmQKCUFDSy5yZWZsb3dfaWRlbnRpdHkgPSByZXMKCW5ld19jb2RlYydyZWZsb3cgaWRlbnRpdHknCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9jcmVhdGVfcmVmbG93X3NlYWxfZih1aWQpCiAgICBlbXB0eSAncmVmbG93IHNlYWwnCiAgICBoYXZlKHVpZCkKICAgIGhhdmUgJ3JlZmxvdyBwdWJsaWMga2V5JwogICAgbG9jYWwgVUlEID0gQUNLW3VpZF0KICAgIHplbmNvZGVfYXNzZXJ0KHR5cGUoVUlEKSA9PSAnemVucm9vbS5lY3AnLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgIkludmFsaWQgcmVmbG93IGlkZW50aXR5OiAiCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAuLnVpZC4uIiAoIi4udHlwZShVSUQpLi4iKSIpCiAgICBsb2NhbCByID0gSU5ULnJhbmRvbSgpCiAgICBBQ0sucmVmbG93X3NlYWwgPSB7CiAgICAgICAgaWRlbnRpdHkgPSBVSUQsCiAgICAgICAgU00gPSBVSUQgKiByLAogICAgICAgIHZlcmlmaWVyID0gQUNLLnJlZmxvd19wdWJsaWNfa2V5ICsgRzIgKiByCiAgICB9CiAgICBuZXdfY29kZWMncmVmbG93IHNlYWwnCmVuZAoKV2hlbigiY3JlYXRlIHJlZmxvdyBzZWFsIHdpdGggaWRlbnRpdHkgJyciLF9jcmVhdGVfcmVmbG93X3NlYWxfZikKV2hlbigiY3JlYXRlIHJlZmxvdyBzZWFsIixmdW5jdGlvbigpIF9jcmVhdGVfcmVmbG93X3NlYWxfZigncmVmbG93IGlkZW50aXR5JykgZW5kKQoKV2hlbigiY3JlYXRlIHJlZmxvdyBzaWduYXR1cmUiLGZ1bmN0aW9uKCkKCWVtcHR5ICdyZWZsb3cgc2lnbmF0dXJlJwoJaGF2ZSAncmVmbG93IHNlYWwnCgloYXZlICdpc3N1ZXIgcHVibGljIGtleScKCWhhdmVrZXkgJ3JlZmxvdycKCWhhdmVrZXkgJ2NyZWRlbnRpYWwnCgktLSBhZ2dyZWdhdGUgYWxsIGNyZWRlbnRpYWxzCglsb2NhbCBwdWJjcmVkID0gZmFsc2UKCWZvciBfLCB2IGluIHBhaXJzKEFDSy5pc3N1ZXJfcHVibGljX2tleSkgZG8KCSAgIGlmIG5vdCBwdWJjcmVkIHRoZW4KCSAgICAgIHB1YmNyZWQgPSB2CgkgICBlbHNlCgkgICAgICBwdWJjcmVkID0gewoJCSBbJ2FscGhhJ10gPSBwdWJjcmVkLmFscGhhICsgdi5hbHBoYSwKCQkgWydiZXRhJ10gPSBwdWJjcmVkLmJldGEgKyB2LmJldGEKCSAgICAgIH0KCSAgIGVuZAoJZW5kCglsb2NhbCBwLCB6ID0KCSAgIEFCQy5wcm92ZV9jcmVkX3VpZCgKCSAgICAgIHB1YmNyZWQsCgkgICAgICBBQ0suY3JlZGVudGlhbHMsCgkgICAgICBBQ0sua2V5cmluZy5jcmVkZW50aWFsLAoJICAgICAgQUNLLnJlZmxvd19zZWFsLmlkZW50aXR5CgkgICApCglBQ0sucmVmbG93X3NpZ25hdHVyZSA9IHsKCSAgIGlkZW50aXR5ID0gQUNLLnJlZmxvd19zZWFsLmlkZW50aXR5LAoJICAgc2lnbmF0dXJlID0gQUNLLnJlZmxvd19zZWFsLmlkZW50aXR5ICogQUNLLmtleXJpbmcucmVmbG93LAoJICAgcHJvb2YgPSBwLAoJICAgemV0YSA9IHoKCX0KCW5ld19jb2RlYygncmVmbG93IHNpZ25hdHVyZScpCmVuZCkKCldoZW4oInByZXBhcmUgY3JlZGVudGlhbHMgZm9yIHZlcmlmaWNhdGlvbiIsZnVuY3Rpb24oKQogICAgICAgIGhhdmUgJ2NyZWRlbnRpYWwnCiAgICAgICAgbG9jYWwgcmVzID0gZmFsc2UKICAgICAgICBmb3IgXywgdiBpbiBwYWlycyhBQ0suaXNzdWVyX3B1YmxpY19rZXkpIGRvCiAgICAgICAgICAgIGlmIG5vdCByZXMgdGhlbgogICAgICAgICAgICAgICAgcmVzID0ge2FscGhhID0gdi5hbHBoYSwgYmV0YSA9IHYuYmV0YX0KICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgcmVzLmFscGhhID0gcmVzLmFscGhhICsgdi5hbHBoYQogICAgICAgICAgICAgICAgcmVzLmJldGEgPSByZXMuYmV0YSArIHYuYmV0YQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICBBQ0sudmVyaWZpZXJzID0gcmVzCmVuZCkKCklmV2hlbigidmVyaWZ5IHJlZmxvdyBzaWduYXR1cmUgY3JlZGVudGlhbCIsZnVuY3Rpb24oKQogICAgICAgIGhhdmUgJ3JlZmxvd19zaWduYXR1cmUnCiAgICAgICAgaGF2ZSAndmVyaWZpZXJzJwogICAgICAgIGhhdmUgJ3JlZmxvd19zZWFsJwogICAgICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICAgICAgICBBQkMudmVyaWZ5X2NyZWRfdWlkKAogICAgICAgICAgICAgICAgQUNLLnZlcmlmaWVycywKICAgICAgICAgICAgICAgIEFDSy5yZWZsb3dfc2lnbmF0dXJlLnByb29mLAogICAgICAgICAgICAgICAgQUNLLnJlZmxvd19zaWduYXR1cmUuemV0YSwKICAgICAgICAgICAgICAgIEFDSy5yZWZsb3dfc2VhbC5pZGVudGl0eQogICAgICAgICAgICApLAogICAgICAgICAgICAnU2lnbmF0dXJlIGhhcyBhbiBpbnZhbGlkIGNyZWRlbnRpYWwgdG8gc2lnbicKICAgICAgICApCmVuZCkKCklmV2hlbigidmVyaWZ5IHJlZmxvdyBzaWduYXR1cmUgZmluZ2VycHJpbnQgaXMgbmV3IiwgZnVuY3Rpb24oKQogICAgaGF2ZSAncmVmbG93X3NpZ25hdHVyZScKICAgIGhhdmUgJ3JlZmxvd19zZWFsJwogICAgaWYgbm90IEFDSy5yZWZsb3dfc2VhbC5maW5nZXJwcmludHMgdGhlbgogICAgICAgIHJldHVybgogICAgZW5kCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBub3QgQUNLLnJlZmxvd19zZWFsLmZpbmdlcnByaW50c1tBQ0sucmVmbG93X3NpZ25hdHVyZS56ZXRhXSwKICAgICAgICAnU2lnbmF0dXJlIGZpbmdlcnByaW50IGlzIG5vdCBuZXcnCiAgICApCmVuZCkKCldoZW4oImFkZCByZWZsb3cgZmluZ2VycHJpbnQgdG8gcmVmbG93IHNlYWwiLGZ1bmN0aW9uKCkKICAgICAgICBoYXZlICdyZWZsb3dfc2lnbmF0dXJlJwogICAgICAgIGhhdmUgJ3JlZmxvd19zZWFsJwogICAgICAgIGlmIG5vdCBBQ0sucmVmbG93X3NlYWwuZmluZ2VycHJpbnRzIHRoZW4KICAgICAgICAgICAgQUNLLnJlZmxvd19zZWFsLmZpbmdlcnByaW50cyA9IHsKICAgICAgICAgICAgICAgIEFDSy5yZWZsb3dfc2lnbmF0dXJlLnpldGEKICAgICAgICAgICAgfQogICAgICAgIGVsc2UKICAgICAgICAgICAgdGFibGUuaW5zZXJ0KAogICAgICAgICAgICAgICAgQUNLLnJlZmxvd19zZWFsLmZpbmdlcnByaW50cywKICAgICAgICAgICAgICAgIEFDSy5yZWZsb3dfc2lnbmF0dXJlLnpldGEKICAgICAgICAgICAgKQogICAgICAgIGVuZAplbmQpCgpXaGVuKCJhZGQgcmVmbG93IHNpZ25hdHVyZSB0byByZWZsb3cgc2VhbCIsZnVuY3Rpb24oKQogICAgICAgIGhhdmUgJ3JlZmxvd19zZWFsJwogICAgICAgIGhhdmUgJ3JlZmxvd19zaWduYXR1cmUnCiAgICAgICAgQUNLLnJlZmxvd19zZWFsLlNNID0KICAgICAgICAgICAgQUNLLnJlZmxvd19zZWFsLlNNICsgQUNLLnJlZmxvd19zaWduYXR1cmUuc2lnbmF0dXJlCmVuZCkKCklmV2hlbigidmVyaWZ5IHJlZmxvdyBzZWFsIGlzIHZhbGlkIixmdW5jdGlvbigpCiAgICAgICAgaGF2ZSAncmVmbG93X3NlYWwnCiAgICAgICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgICAgIEVDUDIubWlsbGVyKEFDSy5yZWZsb3dfc2VhbC52ZXJpZmllciwgQUNLLnJlZmxvd19zZWFsLmlkZW50aXR5KQogICAgICAgICAgICA9PQogICAgICAgICAgICBFQ1AyLm1pbGxlcihHMiwgQUNLLnJlZmxvd19zZWFsLlNNKSwKICAgICAgICAgICAgInJlZmxvdyBzZWFsIGRvZXNuJ3QgdmFsaWRhdGVzIgogICAgICAgICkKZW5kKQoKV2hlbigiYWdncmVnYXRlIHJlZmxvdyBzZWFsIGFycmF5IGluICcnIixmdW5jdGlvbihhcnIpCiAgICAgICAgaGF2ZShhcnIpCiAgICAgICAgZW1wdHkgJ3JlZmxvdyBzZWFsJwogICAgICAgIGxvY2FsIGRzdCA9IHt9CiAgICAgICAgZm9yIF8sIHYgaW4gcGFpcnMoQUNLW2Fycl0pIGRvCiAgICAgICAgICAgIGlmIG5vdCBkc3QuVUlEIHRoZW4KICAgICAgICAgICAgICAgIGRzdC5VSUQgPSB2LlVJRAogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICBkc3QuVUlEID0gZHN0LlVJRCArIHYuVUlECiAgICAgICAgICAgIGVuZAogICAgICAgICAgICBpZiBub3QgZHN0LlNNIHRoZW4KICAgICAgICAgICAgICAgIGRzdC5TTSA9IHYuU00KICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgZHN0LlNNID0gZHN0LlNNICsgdi5TTQogICAgICAgICAgICBlbmQKICAgICAgICAgICAgaWYgbm90IGRzdC52ZXJpZmllciB0aGVuCiAgICAgICAgICAgICAgICBkc3QudmVyaWZpZXIgPSB2LnZlcmlmaWVyCiAgICAgICAgICAgIGVsc2UKICAgICAgICAgICAgICAgIGRzdC52ZXJpZmllciA9IGRzdC52ZXJpZmllciArIHYudmVyaWZpZXIKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICAgICAgQUNLLnJlZmxvd19zZWFsID0gZHN0CgluZXdfY29kZWMncmVmbG93IHNlYWwnCmVuZCkKCi0tLS0tLS0tLS0tLS0tLS0tLS0tCi0tIE1BVEVSSUFMIFBBU1NQT1JUCi0tCi0tIFNpbXBsaWZpZWQgZmxvdyB0byBnZW5lcmF0ZSBhbmQgdmVyaWZ5IG1hdGVyaWFsIHBhc3Nwb3J0cywgd2hpY2gKLS0gYXJlIGEgcGFydGljdWxhciB1c2UtY2FzZSBvZiByZWZsb3cgc2lnbmF0dXJlcy4gU3RhdGVtZW50cyBoZXJlIGRvCi0tIGltcGxpY2l0IHRoaW5ncyBhbmQgcmVkdWNlIGNvbXBsZXhpdHkgb2Ygb3BlcmF0aW9ucywgaW4gcGFydGljdWxhcgotLSB0aGVyZSBpcyBubyBtdWx0aS1wYXJ0eSBjb21wdXRhdGlvbiBpbiB0aGlzIHByb2Nlc3Mgc28gY3JlZGVudGlhbAotLSB1c2UgaXMgb21pdHRlZC4KCgotLSBhZ2dyZWdhdGlvbiBzdXBwb3J0cyBzaW5nbGUgZWxlbWVudCBhcnJheXMgYW5kIGZpeGVzIG9mZi1ieS1vbmUKbG9jYWwgZnVuY3Rpb24gX2FnZ3JlZ2F0ZV9hcnJheShhcnIpCiAgIGFzc2VydChpc2FycmF5KGFyciksICJDYW5ub3QgYWdncmVnYXRlIGludmFsaWQgYXJyYXkiLCAyKQogICBsb2NhbCByZXMgPSBhcnJbMV0KICAgaWYgI2FyciA+IDEgdGhlbgoJICBmb3IgaSA9IDIsICNhcnIgZG8KCQkgcmVzID0gcmVzICsgYXJyW2ldCgkgIGVuZAogICBlbmQKICAgcmV0dXJuKHJlcykKZW5kCgpXaGVuKCJjcmVhdGUgbWF0ZXJpYWwgcGFzc3BvcnQgb2YgJyciLGZ1bmN0aW9uKG9iaikKCSAgbG9jYWwga2V5ID0gaGF2ZWtleSdyZWZsb3cnCgkgIGxvY2FsIGNyZWQgPSBoYXZlJ2NyZWRlbnRpYWxzJwoJICBsb2NhbCBpZCA9IGhhdmUncmVmbG93IGlkZW50aXR5JwoJICBsb2NhbCBpc3N1ZXJfcHViID0gaGF2ZSdpc3N1ZXIgcHVibGljIGtleScKCSAgLS0gb2JqZWN0IHRvIHNpZ24KCSAgbG9jYWwgc3JjID0gaGF2ZShvYmopCgkgIGVtcHR5KCdtYXRlcmlhbCBwYXNzcG9ydCcpCgkgIC0tIGFwcGVuZCBhZ2VudCBpZCB0byB0cmFjayBhbmQgdHJhY2UKCSAgaWYgbm90IEFDSy5maW5nZXJwcmludHMgdGhlbiBBQ0suZmluZ2VycHJpbnRzID0geyB9IGVuZAoJICB0YWJsZS5pbnNlcnQoQUNLLmZpbmdlcnByaW50cywgaWQpCgkgIC0tIGNhbGN1bGF0ZSBvYmplY3QgdWlkCgkgIGxvY2FsIFVJRCA9IF9tYWtldWlkKHNyYykgLS0gcmVmbG93IHVuaXF1ZSBJRCBvZiBvYmplY3QKCSAgLS0gY2FsY3VsYXRlIHNpZ25pbmcgdWlkIChhZ2dyZWdhdGlvbiBvZiBhbGwgZmluZ2VycHJpbnRzKQoJICBsb2NhbCBTSUQgPSBVSUQgKyBfYWdncmVnYXRlX2FycmF5KEFDSy5maW5nZXJwcmludHMpCgkgIGxvY2FsIHIgPSBJTlQucmFuZG9tKCkgLS0gYmxpbmRpbmcgZmFjdG9yCgkgIGxvY2FsIHAsIHogPSBBQkMucHJvdmVfY3JlZF91aWQoaXNzdWVyX3B1YiwgY3JlZCwKCQkJCQkJCQkJICBBQ0sua2V5cmluZy5jcmVkZW50aWFsLCBTSUQpCgkgIEFDSy5tYXRlcmlhbF9wYXNzcG9ydCA9IHsKCQkgc2VhbCA9IHsKCQkJaWRlbnRpdHkgPSBVSUQsCgkJCWZpbmdlcnByaW50cyA9IEFDSy5maW5nZXJwcmludHMsIC0tIG9wdGlvbmFsCgkJCVNNID0gKFNJRCAqIHIpICsgKFNJRCAqIGtleSksIC0tIGJsaW5kaW5nIGZhY3RvcgoJCQl2ZXJpZmllciA9IChHMiAqIHIpICsgKEcyICoga2V5KQoJCSB9LAoJCSBwcm9vZiA9IHAsCgkJIHpldGEgPSB6CgkgIH0KCSAgbmV3X2NvZGVjJ21hdGVyaWFsIHBhc3Nwb3J0JwplbmQpCgpJZldoZW4oInZlcmlmeSBtYXRlcmlhbCBwYXNzcG9ydCBvZiAnJyIsZnVuY3Rpb24ob2JqKQoJICBsb2NhbCBzcmMgPSBoYXZlKG9iaikKCSAgbG9jYWwgbXAgPSBoYXZlJ21hdGVyaWFsIHBhc3Nwb3J0JwoJICBsb2NhbCBwdWIgPSBoYXZlJ2lzc3VlciBwdWJsaWMga2V5JwoJICBpZiBub3QgemVuY29kZV9hc3NlcnQobXAuc2VhbC5maW5nZXJwcmludHMsCgkJCQkgIk5vIGZpbmdlcnByaW50cyBmb3VuZCBpbiBtYXRlcmlhbCBwYXNzcG9ydCBzZWFsOiAiLi5vYmopIHRoZW4gcmV0dXJuIGVuZAoJICBsb2NhbCBVSUQgPSBfbWFrZXVpZChzcmMpCgkgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydChVSUQgPT0gbXAuc2VhbC5pZGVudGl0eSwKCQkJCSAiT2JqZWN0IGRvZXMgbm90IG1hdGNoIG1hdGVyaWFsIHBhc3Nwb3J0IGlkZW50aXR5IChuZWVkcyB0cmFjayBhbmQgdHJhY2U/KTogIi4ub2JqKSB0aGVuIHJldHVybiBlbmQKCSAgbG9jYWwgU0lEID0gVUlEICsgX2FnZ3JlZ2F0ZV9hcnJheShtcC5zZWFsLmZpbmdlcnByaW50cykKCSAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KAoJCSBFQ1AyLm1pbGxlcihtcC5zZWFsLnZlcmlmaWVyLCBTSUQpCgkJID09CgkJIEVDUDIubWlsbGVyKEcyLCBtcC5zZWFsLlNNKSwKCQkgIk9iamVjdCBtYXRjaGVzLCBidXQgc2VhbCBpcyBpbnZhbGlkOiAiLi5vYmopIHRoZW4gcmV0dXJuIGVuZAoJICBpZiBub3QgemVuY29kZV9hc3NlcnQoCgkJIEFCQy52ZXJpZnlfY3JlZF91aWQocHViLCBtcC5wcm9vZiwgbXAuemV0YSwgU0lEKSwKCQkgIk9iamVjdCBhbmQgc2VhbCBhcmUgdmFsaWQsIGJ1dCBwcm9vZiBvZiBpc3N1YW5jZSBmYWlsczogIi4ub2JqKSB0aGVuIHJldHVybiBlbmQKZW5kKQoKLS0gQ29tcGxleCBjaGVjayBjYWxjdWxhdGVzIFVJRCBvZiBvYmplY3QgYW5kIGNvbXBhcmVzIHRvIHNlYWwsIGlmCi0tIGNvcnJlY3QgdGhlbiB2YWxpZGF0ZXMsIGVsc2Ugc2VhcmNoZXMgZm9yIC50cmFjayBhcnJheSBvZiBzZWFscyBhbmQKLS0gY2FsY3VsYXRlcyBhZ2dyZWdhdGVkIFVJRCwgaWYgY29ycmVjdCB0aGVuIHZhbGlkYXRlcwpJZldoZW4oInZlcmlmeSBtYXRlcmlhbCBwYXNzcG9ydCBvZiAnJyBpcyB2YWxpZCIsZnVuY3Rpb24ob2JqKQoJICBoYXZlKG9iaikKCSAgaGF2ZShvYmouLicuc2VhbCcpCiAgICAgIC0tIFRPRE8KZW5kKQovemVuY29kZV9yc2EubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDI0LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IEFsYmVydG8gTGVyZGEgYW5kIERlbmlzIFJvaW8KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tXV0KCmxvY2FsIFJTQSA9IHJlcXVpcmUncnNhJwoKbG9jYWwgZnVuY3Rpb24gcnNhX3B1YmxpY19rZXlfZihvYmopCiAgICBsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQogICAgemVuY29kZV9hc3NlcnQoCiAgICAgICAgUlNBLnB1YmNoZWNrKHJlcyksCiAgICAgICAgJ3JzYSBwdWJsaWMga2V5IGxlbmd0aCBpcyBub3QgY29ycmVjdCcKICAgICkKICAgIHJldHVybiByZXMKZW5kCiAKbG9jYWwgZnVuY3Rpb24gcnNhX3NpZ25hdHVyZV9mKG9iaikKICAgIGxvY2FsIHJlcyA9IHNjaGVtYV9nZXQob2JqLCAnLicpCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBSU0Euc2lnbmF0dXJlX2NoZWNrKHJlcyksCiAgICAgICAgJ3JzYSBzaWduYXR1cmUgbGVuZ3RoIGlzIG5vdCBjb3JyZWN0JwogICAgKQogICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIHJzYV9wdWJsaWNfa2V5ID0ge2ltcG9ydD1yc2FfcHVibGljX2tleV9mfSwKICAgICAgICByc2Ffc2lnbmF0dXJlID0ge2ltcG9ydD1yc2Ffc2lnbmF0dXJlX2Z9CiAgICB9CikKCldoZW4oImNyZWF0ZSByc2Ega2V5IixmdW5jdGlvbigpCiAgICBpbml0a2V5cmluZydyc2EnCiAgICBBQ0sua2V5cmluZy5yc2EgPSBSU0Eua2V5Z2VuKCkucHJpdmF0ZQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgcHVibGljIGtleQpXaGVuKCJjcmVhdGUgcnNhIHB1YmxpYyBrZXkiLGZ1bmN0aW9uKCkKICAgIGVtcHR5J3JzYSBwdWJsaWMga2V5JwogICAgbG9jYWwgc2sgPSBoYXZla2V5J3JzYScKICAgIEFDSy5yc2FfcHVibGljX2tleSA9IFJTQS5wdWJnZW4oc2spCiAgICBuZXdfY29kZWMoJ3JzYSBwdWJsaWMga2V5JykKZW5kKQoKV2hlbigiY3JlYXRlIHJzYSBwdWJsaWMga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsZnVuY3Rpb24oc2VjKQogICAgbG9jYWwgc2sgPSBoYXZlKHNlYykKICAgIGVtcHR5J3JzYSBwdWJsaWMga2V5JwogICAgQUNLLnJzYV9wdWJsaWNfa2V5ID0gUlNBLnB1YmdlbihzaykKICAgIG5ld19jb2RlYygncnNhIHB1YmxpYyBrZXknKQplbmQpCgotLSBnZW5lcmF0ZSB0aGUgc2lnbiBmb3IgYSBtc2cgYW5kIHZlcmlmeQpXaGVuKCJjcmVhdGUgcnNhIHNpZ25hdHVyZSBvZiAnJyIsZnVuY3Rpb24oZG9jKQogICAgbG9jYWwgc2sgPSBoYXZla2V5J3JzYScKICAgIGxvY2FsIG9iaiA9IGhhdmUoZG9jKQogICAgZW1wdHkncnNhIHNpZ25hdHVyZScKICAgIEFDSy5yc2Ffc2lnbmF0dXJlID0gUlNBLnNpZ24oc2ssIHplbmNvZGVfc2VyaWFsaXplKG9iaikpCiAgICBuZXdfY29kZWMoJ3JzYSBzaWduYXR1cmUnKQplbmQpCgpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSByc2Egc2lnbmF0dXJlIGluICcnIGJ5ICcnIixmdW5jdGlvbihtc2csIHNpZywgYnkpCiAgICBsb2NhbCBwayA9IGxvYWRfcHVia2V5X2NvbXBhdChieSwgJ3JzYScpCiAgICBsb2NhbCBtID0gaGF2ZShtc2cpCiAgICBsb2NhbCBzID0gaGF2ZShzaWcpCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBSU0EudmVyaWZ5KHBrLCB6ZW5jb2RlX3NlcmlhbGl6ZShtKSwgcyksCiAgICAgICAgJ1RoZSByc2Egc2lnbmF0dXJlIGJ5ICcuLmJ5Li4nIGlzIG5vdCBhdXRoZW50aWMnCiAgICApCmVuZCkKL3plbmNvZGVfc2Nobm9yci5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjItMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgQWxiZXJ0byBMZXJkYSBhbmQgRGVuaXMgUm9pbwotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1dXQoKbG9jYWwgU0NIID0gcmVxdWlyZSdjcnlwdG9fc2Nobm9ycl9zaWduYXR1cmUnCgpsb2NhbCBmdW5jdGlvbiBzY2hub3JyX3B1YmxpY19rZXlfZihvYmopCiAgIGxvY2FsIHJlcyA9IHNjaGVtYV9nZXQob2JqLCAnLicpCiAgIHplbmNvZGVfYXNzZXJ0KAogICAgICBTQ0gucHViY2hlY2socmVzKSwKICAgICAgJ1NjaG5vcnIgcHVibGljIGtleSBpcyBub3QgdmFsaWQnCiAgICkKICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIHNjaG5vcnJfc2lnbmF0dXJlX2Yob2JqKQogICBsb2NhbCByZXMgPSBzY2hlbWFfZ2V0KG9iaiwgJy4nKQogICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgU0NILnNpZ2NoZWNrKHJlcyksCiAgICAgICdTY2hub3JyIHNpZ25hdHVyZSBpcyBub3QgdmFsaWQnCiAgICkKICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICB7CiAgICAgIHNjaG5vcnJfcHVibGljX2tleSA9IHNjaG5vcnJfcHVibGljX2tleV9mLAogICAgICBzY2hub3JyX3NpZ25hdHVyZSA9IHNjaG5vcnJfc2lnbmF0dXJlX2YKICAgfQopCgoKLS0gZ2VuZXJhdGUgdGhlIHByaXZhdGUga2V5CldoZW4oImNyZWF0ZSBzY2hub3JyIGtleSIsZnVuY3Rpb24oKQoJaW5pdGtleXJpbmcnc2Nobm9ycicKCUFDSy5rZXlyaW5nLnNjaG5vcnIgPSBTQ0gua2V5Z2VuKCkKZW5kKQoKLS0gZ2VuZXJhdGUgdGhlIHB1YmxpYyBrZXkKV2hlbigiY3JlYXRlIHNjaG5vcnIgcHVibGljIGtleSIsZnVuY3Rpb24oKQoJZW1wdHknc2Nobm9yciBwdWJsaWMga2V5JwoJbG9jYWwgc2sgPSBoYXZla2V5J3NjaG5vcnInCglBQ0suc2Nobm9ycl9wdWJsaWNfa2V5ID0gU0NILnB1YmdlbihzaykKCW5ld19jb2RlYygnc2Nobm9yciBwdWJsaWMga2V5JykKZW5kKQoKV2hlbigiY3JlYXRlIHNjaG5vcnIgcHVibGljIGtleSB3aXRoIHNlY3JldCBrZXkgJyciLGZ1bmN0aW9uKHNlYykKCWxvY2FsIHNrID0gaGF2ZShzZWMpCgllbXB0eSdzY2hub3JyIHB1YmxpYyBrZXknCglBQ0suc2Nobm9ycl9wdWJsaWNfa2V5ID0gU0NILnB1YmdlbihzaykKCW5ld19jb2RlYygnc2Nobm9yciBwdWJsaWMga2V5JykKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX3NjaG5vcnJfa2V5X2Zyb21fc2VjcmV0KHNlYykKICAgbG9jYWwgc2sgPSBoYXZlKHNlYykKICAgbG9jYWwgbyA9IEVDUC5vcmRlcigpCiAgIGxvY2FsIGQgPSBCSUcubmV3KHNrKSAlIG8KICAgemVuY29kZV9hc3NlcnQoZCB+PSBCSUcubmV3KDApLCAnaW52YWxpZCBzZWNyZXQga2V5LCBpcyB6ZXJvJykKICAgaW5pdGtleXJpbmcnc2Nobm9ycicKICAgQUNLLmtleXJpbmcuc2Nobm9yciA9IGQ6b2N0ZXQoKTpwYWQoMzIpCmVuZAoKV2hlbigiY3JlYXRlIHNjaG5vcnIga2V5IHdpdGggc2VjcmV0IGtleSAnJyIsCiAgICAgX3NjaG5vcnJfa2V5X2Zyb21fc2VjcmV0CikKV2hlbigiY3JlYXRlIHNjaG5vcnIga2V5IHdpdGggc2VjcmV0ICcnIiwKICAgICBfc2Nobm9ycl9rZXlfZnJvbV9zZWNyZXQKKQoKLS0gZ2VuZXJhdGUgdGhlIHNpZ24gZm9yIGEgbXNnIGFuZCB2ZXJpZnkKV2hlbigiY3JlYXRlIHNjaG5vcnIgc2lnbmF0dXJlIG9mICcnIixmdW5jdGlvbihkb2MpCglsb2NhbCBzayA9IGhhdmVrZXknc2Nobm9ycicKCWxvY2FsIG9iaiA9IGhhdmUoZG9jKQoJZW1wdHknc2Nobm9yciBzaWduYXR1cmUnCglBQ0suc2Nobm9ycl9zaWduYXR1cmUgPSBTQ0guc2lnbihzaywgemVuY29kZV9zZXJpYWxpemUob2JqKSkKCW5ld19jb2RlYygnc2Nobm9yciBzaWduYXR1cmUnKQplbmQpCgpJZldoZW4oInZlcmlmeSAnJyBoYXMgYSBzY2hub3JyIHNpZ25hdHVyZSBpbiAnJyBieSAnJyIsZnVuY3Rpb24oZG9jLCBzaWcsIGJ5KQoJICBsb2NhbCBwayA9IGxvYWRfcHVia2V5X2NvbXBhdChieSwgJ3NjaG5vcnInKQoJICBsb2NhbCBvYmogPSBoYXZlKGRvYykKCSAgbG9jYWwgcyA9IGhhdmUoc2lnKQoJICB6ZW5jb2RlX2Fzc2VydCgKCSAgICAgU0NILnZlcmlmeShwaywgemVuY29kZV9zZXJpYWxpemUob2JqKSwgcyksCgkgICAgICdUaGUgc2Nobm9yciBzaWduYXR1cmUgYnkgJy4uYnkuLicgaXMgbm90IGF1dGhlbnRpYycKCSAgKQplbmQpCi96ZW5jb2RlX3NkX2p3dC5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIFplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjMtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnk6Ci0tUmViZWNjYSBTZWx2YWdnaW5pLCBBbGJlcnRvIExlcmRhLCBEZW5pcyBSb2lvIGFuZCBBbmRyZWEgRCdJbnRpbm8KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tXV0KCmxvY2FsIFNEX0pXVCA9IHJlcXVpcmVfb25jZSdjcnlwdG9fc2Rfand0Jwpsb2NhbCBXM0MgPSByZXF1aXJlX29uY2UnY3J5cHRvX3czYycKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF91cmxfZihvYmopCiAgICAtLSBUT0RPOiB2YWxpZGF0aW9uIFVSTAogICAgcmV0dXJuIE8uZnJvbV9zdHIob2JqKQplbmQKCmxvY2FsIFVSTFNfTUVUQURBVEEgPSB7CiAgICAiY3JlZGVudGlhbF9pc3N1ZXIiLAogICAgImNyZWRlbnRpYWxfZW5kcG9pbnQiCn0KLS0iYXV0aG9yaXphdGlvbl9zZXJ2ZXJzIiwKCi0tIGxvY2FsIERJQ1RTX01FVEFEQVRBID0gewotLSAgICAgImdyYW50X3R5cGVzX3N1cHBvcnRlZCIsCi0tICAgICAiY29kZV9jaGFsbGVuZ2VfbWV0aG9kc19zdXBwb3J0ZWQiLAotLSAgICAgInJlc3BvbnNlX21vZGVzX3N1cHBvcnRlZCIsCi0tICAgICAicmVzcG9uc2VfdHlwZXNfc3VwcG9ydGVkIiwKLS0gICAgICJzY29wZXNfc3VwcG9ydGVkIiwKLS0gICAgICJzdWJqZWN0X3R5cGVzX3N1cHBvcnRlZCIsCi0tICAgICAidG9rZW5fZW5kcG9pbnRfYXV0aF9tZXRob2RzX3N1cHBvcnRlZCIsCi0tICAgICAiaWRfdG9rZW5fc2lnbmluZ19hbGdfdmFsdWVzX3N1cHBvcnRlZCIsCi0tICAgICAicmVxdWVzdF9vYmplY3Rfc2lnbmluZ19hbGdfdmFsdWVzX3N1cHBvcnRlZCIsCi0tICAgICAiY2xhaW1fdHlwZXNfc3VwcG9ydGVkIiwKLS0gfQoKLS0gbG9jYWwgQk9PTFNfTUVUQURBVEEgPSB7Ci0tICAgICAiY2xhaW1zX3BhcmFtZXRlcl9zdXBwb3J0ZWQiLAotLSAgICAgImF1dGhvcml6YXRpb25fcmVzcG9uc2VfaXNzX3BhcmFtZXRlcl9zdXBwb3J0ZWQiLAotLSAgICAgInJlcXVlc3RfcGFyYW1ldGVyX3N1cHBvcnRlZCIsCi0tICAgICAicmVxdWVzdF91cmlfcGFyYW1ldGVyX3N1cHBvcnRlZCIsCi0tIH0KCmxvY2FsIGZ1bmN0aW9uIGNoZWNrX2Rpc3BsYXkoZGlzcGxheSkKICAgIHJldHVybiBkaXNwbGF5Lm5hbWUgYW5kIGRpc3BsYXkubG9jYWxlCmVuZAoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3N1cHBvcnRlZF9zZWxlY3RpdmVfZGlzY2xvc3VyZShvYmopCiAgICBsb2NhbCBjaGVja19zdXBwb3J0ID0gZnVuY3Rpb24ob2JqLCB3aGF0LCBuZWVkZWQpCiAgICAgICAgZm91bmQgPSBmYWxzZQogICAgICAgIGlmKHR5cGUob2JqW3doYXRdKSA9PSAndGFibGUnKSB0aGVuCiAgICAgICAgICAgIGZvciBrLHYgaW4gcGFpcnMob2JqW3doYXRdKSBkbwogICAgICAgICAgICAgICBpZiB2ID09IG5lZWRlZFtrXSB0aGVuCiAgICAgICAgICAgICAgICAgICAgZm91bmQgPSB0cnVlCiAgICAgICAgICAgICAgICAgICAgYnJlYWsKICAgICAgICAgICAgICAgZW5kIAogICAgICAgICAgICBlbmQKICAgICAgICBlbHNlCiAgICAgICAgICAgIGlmICh0eXBlKG5lZWRlZCkgPT0gJ3RhYmxlJykgdGhlbgogICAgICAgICAgICAgICAgZm9yIF8sdiBpbiBwYWlycyhuZWVkZWQpIGRvCiAgICAgICAgICAgICAgICAgICAgaWYgb2JqW3doYXRdID09IHYgdGhlbgogICAgICAgICAgICAgICAgICAgICAgICBmb3VuZCA9IHRydWUKICAgICAgICAgICAgICAgICAgICAgICAgYnJlYWsKICAgICAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICBmb3VuZCA9IG9ialt3aGF0XSA9PSBuZWVkZWQKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICAgICAgaWYobm90IGZvdW5kKSB0aGVuCiAgICAgICAgICAgIGVycm9yKCJGb3VuZCBwYXJhbWV0ZXIgbm90IHN1cHBvcnRlZCBpbiAiIC4uIHdoYXQsIDMpCiAgICAgICAgZW5kCiAgICBlbmQKCiAgICBsb2NhbCByZXMgPSB7fQogICAgZm9yIGk9MSwjVVJMU19NRVRBREFUQSBkbwogICAgICAgIHJlc1tVUkxTX01FVEFEQVRBW2ldXSA9CiAgICAgICAgICAgIHNjaGVtYV9nZXQob2JqLCBVUkxTX01FVEFEQVRBW2ldLCBpbXBvcnRfdXJsX2YsIHRvc3RyaW5nKQogICAgZW5kCiAgICByZXMuYXV0aG9yaXphdGlvbl9zZXJ2ZXJzID0gc2NoZW1hX2dldChvYmosICdhdXRob3JpemF0aW9uX3NlcnZlcnMnLCBpbXBvcnRfdXJsX2YsIHRvc3RyaW5nKQogICAgbG9jYWwgY3JlZHMgPSBvYmouY3JlZGVudGlhbF9jb25maWd1cmF0aW9uc19zdXBwb3J0ZWQKICAgIGZvciBfLHYgaW4gcGFpcnMoY3JlZHMpIGRvCiAgICAgICAgY2hlY2tfZGlzcGxheSh2LmRpc3BsYXkpCiAgICAgICAgY2hlY2tfc3VwcG9ydCh2LCAnZm9ybWF0JywgeydsZHBfdmMnLCdkYytzZC1qd3QnfSkKICAgICAgICBpZiB2LmZvcm1hdCA9PSAnZGMrc2Qtand0JyB0aGVuCiAgICAgICAgICAgIGNoZWNrX3N1cHBvcnQodiwgJ2NyZWRlbnRpYWxfc2lnbmluZ19hbGdfdmFsdWVzX3N1cHBvcnRlZCcsIHsnRVMyNTYnLCdFRERTQScsJ01MRFNBNDQnLCdTRUNQMjU2SzEnfSkKICAgICAgICAgICAgaWYgKG5vdCB2LnZjdCkgdGhlbgogICAgICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgc3VwcG9ydGVkIHNlbGVjdGl2ZSBkaXNjbG9zdXJlOiBtaXNzaW5nIHBhcmFtZXRlciB2Y3QiLCAyKQogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICBpZiB2LmZvcm1hdCA9PSAnbGRwX3ZjJyB0aGVuIGNoZWNrX3N1cHBvcnQodiwgJ2NyZWRlbnRpYWxfc2lnbmluZ19hbGdfdmFsdWVzX3N1cHBvcnRlZCcsIHsnRWQyNTUxOVNpZ25hdHVyZTIwMTgnfSkgZW5kCiAgICAgICAgY2hlY2tfc3VwcG9ydCh2LCAnY3J5cHRvZ3JhcGhpY19iaW5kaW5nX21ldGhvZHNfc3VwcG9ydGVkJywgeyJqd2siLCAiZGlkOmR5bmU6c2FuZGJveC5zaWducm9vbSJ9KQogICAgICAgIC0tIGNoZWNrX3N1cHBvcnQoY3JlZHNbaV0sICdwcm9vZl90eXBlc19zdXBwb3J0ZWQnLCB7and0ID0geyBwcm9vZl9zaWduaW5nX2FsZ192YWx1ZXNfc3VwcG9ydGVkID0geyJFUzI1NiJ9fX0pCiAgICAgICAgLS0gY2xhaW1zIGFuZCBldmVyeXRoaW5nIGluIGl0IGFyZSBvcHRpb25hbAogICAgZW5kCgogICAgcmVzLmNyZWRlbnRpYWxfY29uZmlndXJhdGlvbnNfc3VwcG9ydGVkID0KICAgICAgICBzY2hlbWFfZ2V0KG9iaiwgJ2NyZWRlbnRpYWxfY29uZmlndXJhdGlvbnNfc3VwcG9ydGVkJywgTy5mcm9tX3N0ciwgdG9zdHJpbmcpCgogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9zdXBwb3J0ZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUob2JqKQogICAgbG9jYWwgcmVzID0ge30KICAgIGZvciBpPTEsI1VSTFNfTUVUQURBVEEgZG8KICAgICAgICByZXNbVVJMU19NRVRBREFUQVtpXV0gPSBvYmpbVVJMU19NRVRBREFUQVtpXV06c3RyKCkKICAgIGVuZAogICAgcmVzLmF1dGhvcml6YXRpb25fc2VydmVycyA9IHt9CiAgICBmb3Igayx2IGluIHBhaXJzKG9iai5hdXRob3JpemF0aW9uX3NlcnZlcnMpIGRvCiAgICAgICAgcmVzLmF1dGhvcml6YXRpb25fc2VydmVyc1trXSA9IHY6c3RyKCkKICAgIGVuZAogICAgcmVzLmNyZWRlbnRpYWxfY29uZmlndXJhdGlvbnNfc3VwcG9ydGVkID0KICAgICAgICBkZWVwbWFwKGZ1bmN0aW9uKG9iaikgcmV0dXJuIG9iajpzdHIoKSBlbmQsCiAgICAgICAgICAgIG9iai5jcmVkZW50aWFsX2NvbmZpZ3VyYXRpb25zX3N1cHBvcnRlZCkKICAgIHJldHVybiByZXMKZW5kCgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfc3RyX2RpY3Qob2JqKQogICAgcmV0dXJuIGRlZXBtYXAoaW5wdXRfZW5jb2RpbmcoInN0ciIpLmZ1biwgb2JqKQplbmQKCmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9zdHJfZGljdChvYmopCiAgICByZXR1cm4gZGVlcG1hcChnZXRfZW5jb2RpbmdfZnVuY3Rpb24oInN0cmluZyIpLCBvYmopCmVuZAoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3NlbGVjdGl2ZV9kaXNjbG9zdXJlX3JlcXVlc3Qob2JqKQogICAgemVuY29kZV9hc3NlcnQob2JqLmZpZWxkcywgIklucHV0IG9iamVjdCBzaG91bGQgaGF2ZSBhIGtleSAnZmllbGRzJyIpCiAgICB6ZW5jb2RlX2Fzc2VydChvYmoub2JqZWN0LCAiSW5wdXQgb2JqZWN0IHNob3VsZCBoYXZlIGEga2V5ICdvYmplY3QnIikKCiAgICBmb3IgaT0xLCAjb2JqLmZpZWxkcyBkbwogICAgICAgIHplbmNvZGVfYXNzZXJ0KHR5cGUob2JqLmZpZWxkc1tpXSkgPT0gJ3N0cmluZycsICJUaGUgb2JqZWN0IHdpdGgga2V5IGZpZWxkcyBtdXN0IGJlIGEgc3RyaW5nIGFycmF5IikKICAgICAgICBmb3VuZCA9IGZhbHNlCiAgICAgICAgZm9yIGssdiBpbiBwYWlycyhvYmoub2JqZWN0KSBkbwogICAgICAgICAgICBpZiBrID09IG9iai5maWVsZHNbaV0gdGhlbgogICAgICAgICAgICAgICAgZm91bmQgPSB0cnVlCiAgICAgICAgICAgICAgICBicmVhawogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICB6ZW5jb2RlX2Fzc2VydChmb3VuZCwgIlRoZSBmaWVsZCAiLi5vYmouZmllbGRzW2ldLi4iIGlzIG5vdCBhIGtleSBpbiB0aGUgb2JqZWN0IikKICAgIGVuZAoKICAgIHJldHVybiB7CiAgICAgICAgZmllbGRzID0gZGVlcG1hcChmdW5jdGlvbihvKSByZXR1cm4gTy5mcm9tX3N0cihvKSBlbmQsIG9iai5maWVsZHMpLAogICAgICAgIG9iamVjdCA9IGltcG9ydF9zdHJfZGljdChvYmoub2JqZWN0KSwKICAgIH0KZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmVfcmVxdWVzdChvYmopCiAgICByZXR1cm4gewogICAgICAgIGZpZWxkcyA9IGRlZXBtYXAoZnVuY3Rpb24obykgcmV0dXJuIG86c3RyKCkgZW5kLCBvYmouZmllbGRzKSwKICAgICAgICBvYmplY3QgPSBleHBvcnRfc3RyX2RpY3Qob2JqLm9iamVjdCksCiAgICB9CmVuZAoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3NlbGVjdGl2ZV9kaXNjbG9zdXJlKG9iaikKICAgIHJldHVybiB7CiAgICAgICAgcGF5bG9hZCA9IGltcG9ydF9zdHJfZGljdChvYmoucGF5bG9hZCksCiAgICAgICAgZGlzY2xvc3VyZXMgPSBpbXBvcnRfc3RyX2RpY3Qob2JqLmRpc2Nsb3N1cmVzKSwKICAgIH0KZW5kCgpsb2NhbCBmdW5jdGlvbiBleHBvcnRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUob2JqKQogICAgcmV0dXJuIHsKICAgICAgICBkaXNjbG9zdXJlcyA9IGV4cG9ydF9zdHJfZGljdChvYmouZGlzY2xvc3VyZXMpLAogICAgICAgIHBheWxvYWQgPSBleHBvcnRfc3RyX2RpY3Qob2JqLnBheWxvYWQpLAogICAgfQplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9kZWNvZGVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlKG9iaikKICAgIC0tIGV4cG9ydCB0aGUgd2hvbGUgb2JqIGFzIHN0cmluZyBkaWN0aW9uYXJ5IGJ1dCB0aGUgc2lnbmF0dXJlCiAgICBsb2NhbCBzaWduYXR1cmUgPSBvYmouand0LnNpZ25hdHVyZQogICAgb2JqLmp3dC5zaWduYXR1cmUgPSBuaWwKICAgIGxvY2FsIGp3dCA9IGltcG9ydF9zdHJfZGljdChvYmouand0KQogICAgb2JqLmp3dC5zaWduYXR1cmUgPSBzaWduYXR1cmUKCiAgICBqd3Quc2lnbmF0dXJlID0gTy5mcm9tX3VybDY0KHNpZ25hdHVyZSkKICAgIHJldHVybiB7CiAgICAgICAgand0ID0gand0LAogICAgICAgIGRpc2Nsb3N1cmVzID0gaW1wb3J0X3N0cl9kaWN0KG9iai5kaXNjbG9zdXJlcyksCiAgICB9CmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X2RlY29kZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUob2JqKQogICAgLS0gZXhwb3J0IHRoZSB3aG9sZSBvYmogYXMgc3RyaW5nIGRpY3Rpb25hcnkgYnV0IHRoZSBzaWduYXR1cmUKICAgIGxvY2FsIHNpZ25hdHVyZSA9IG9iai5qd3Quc2lnbmF0dXJlCiAgICBvYmouand0LnNpZ25hdHVyZSA9IG5pbAogICAgbG9jYWwgand0ID0gZXhwb3J0X3N0cl9kaWN0KG9iai5qd3QpCiAgICBvYmouand0LnNpZ25hdHVyZSA9IHNpZ25hdHVyZQogICAgand0LnNpZ25hdHVyZSA9IE8udG9fdXJsNjQoc2lnbmF0dXJlKQogICAgcmV0dXJuIHsKICAgICAgICBqd3QgPSBqd3QsCiAgICAgICAgZGlzY2xvc3VyZXMgPSBleHBvcnRfc3RyX2RpY3Qob2JqLmRpc2Nsb3N1cmVzKSwKICAgIH0KZW5kCgpsb2NhbCBmdW5jdGlvbiBpbXBvcnRfc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlKG9iaikKICAgIHplbmNvZGVfYXNzZXJ0KG9iajpzdWIoI29iaiwgI29iaikgPT0gJ34nLCAiSldUIGJpbmRpbmcgbm90IGltcGxlbWVudGVkIikKICAgIGxvY2FsIHRva3MgPSBzdHJ0b2sob2JqLCAifiIpCiAgICBkaXNjbG9zdXJlcyA9IHt9CiAgICBmb3IgaT0yLCN0b2tzIGRvCiAgICAgICAgZGlzY2xvc3VyZXNbI2Rpc2Nsb3N1cmVzKzFdID0gSlNPTi5yYXdfZGVjb2RlKE8uZnJvbV91cmw2NCh0b2tzW2ldKTpzdHIoKSkKICAgIGVuZAogICAgcmV0dXJuIHsKICAgICAgICBqd3QgPSBXM0MuaW1wb3J0X2p3dCh0b2tzWzFdKSwKICAgICAgICBkaXNjbG9zdXJlcyA9IGltcG9ydF9zdHJfZGljdChkaXNjbG9zdXJlcyksCiAgICB9CmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X3NpZ25lZF9zZWxlY3RpdmVfZGlzY2xvc3VyZShvYmopCiAgICBsb2NhbCByZWNvcmRzID0gewogICAgICAgIHRhYmxlLmNvbmNhdCgKICAgICAgICAgICAge08uZnJvbV9zdHJpbmcoSlNPTi5yYXdfZW5jb2RlKGV4cG9ydF9zdHJfZGljdChvYmouand0LmhlYWRlciksIHRydWUpKTp1cmw2NCgpLAogICAgICAgICAgICAgTy5mcm9tX3N0cmluZyhKU09OLnJhd19lbmNvZGUoZXhwb3J0X3N0cl9kaWN0KG9iai5qd3QucGF5bG9hZCksIHRydWUpKTp1cmw2NCgpLAogICAgICAgICAgICAgTy50b191cmw2NChvYmouand0LnNpZ25hdHVyZSksCiAgICAgICAgICAgIH0sICIuIikKICAgIH0KICAgIGZvciBfLCBkIGluIHBhaXJzKGV4cG9ydF9zdHJfZGljdChvYmouZGlzY2xvc3VyZXMpKSBkbwogICAgICAgIHRhYmxlLmluc2VydChyZWNvcmRzLCBPLmZyb21fc3RyaW5nKEpTT04ucmF3X2VuY29kZShkLCB0cnVlKSk6dXJsNjQoKSkKICAgIGVuZAogICAgcmV0dXJuIHRhYmxlLmNvbmNhdChyZWNvcmRzLCAifiIpIC4uICJ+IgplbmQKCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9zaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmVfd2lodF9rYihvYmopCiAgICBsb2NhbCBsYXN0X3BvcyA9IG9iajptYXRjaCgiLiooKX4iKQogICAgaWYgbm90IGxhc3RfcG9zIHRoZW4KICAgICAgICBlcnJvcigiSW52YWxpZCBzaWduZWQgc2VsZWN0aXZlIGRpc2Nsb3N1cmUgd2l0aCBrZXkgYmluZGluZzogIiAuLiBvYmosIDIpCiAgICBlbmQKICAgIGxvY2FsIHJlcyA9IGltcG9ydF9zaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUob2JqOnN1YigxLCBsYXN0X3BvcykpCiAgICByZXMua2V5X2JpbmRpbmcgPSBXM0MuaW1wb3J0X2p3dChvYmo6c3ViKGxhc3RfcG9zKzEpKQogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9zaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmVfd2lodF9rYihvYmopCiAgICBsb2NhbCBzc2QgPSBleHBvcnRfc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlKG9iaikKICAgIGxvY2FsIGtiID0gVzNDLmV4cG9ydF9qd3Qob2JqLmtleV9iaW5kaW5nKQogICAgcmV0dXJuIHNzZCAuLiBrYgplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIHN1cHBvcnRlZF9zZWxlY3RpdmVfZGlzY2xvc3VyZSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X3N1cHBvcnRlZF9zZWxlY3RpdmVfZGlzY2xvc3VyZSwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X3N1cHBvcnRlZF9zZWxlY3RpdmVfZGlzY2xvc3VyZQogICAgICAgIH0sCiAgICAgICAgc2VsZWN0aXZlX2Rpc2Nsb3N1cmVfcmVxdWVzdCA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X3NlbGVjdGl2ZV9kaXNjbG9zdXJlX3JlcXVlc3QsCiAgICAgICAgICAgIGV4cG9ydCA9IGV4cG9ydF9zZWxlY3RpdmVfZGlzY2xvc3VyZV9yZXF1ZXN0LAogICAgICAgIH0sCiAgICAgICAgc2VsZWN0aXZlX2Rpc2Nsb3N1cmUgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGltcG9ydF9zZWxlY3RpdmVfZGlzY2xvc3VyZSwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X3NlbGVjdGl2ZV9kaXNjbG9zdXJlLAogICAgICAgIH0sCiAgICAgICAgZGVjb2RlZF9zZWxlY3RpdmVfZGlzY2xvc3VyZSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X2RlY29kZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUsCiAgICAgICAgICAgIGV4cG9ydCA9IGV4cG9ydF9kZWNvZGVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlLAogICAgICAgIH0sCiAgICAgICAgc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlID0gewogICAgICAgICAgICBpbXBvcnQgPSBpbXBvcnRfc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlLAogICAgICAgICAgICBleHBvcnQgPSBleHBvcnRfc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlLAogICAgICAgIH0sCiAgICAgICAgc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlX3dpdGhfa2V5X2JpbmRpbmcgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGltcG9ydF9zaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmVfd2lodF9rYiwKICAgICAgICAgICAgZXhwb3J0ID0gZXhwb3J0X3NpZ25lZF9zZWxlY3RpdmVfZGlzY2xvc3VyZV93aWh0X2tiLAogICAgICAgIH0KICAgIH0KKQoKV2hlbigiY3JlYXRlIHNlbGVjdGl2ZSBkaXNjbG9zdXJlIHJlcXVlc3QgZnJvbSAnJyB3aXRoIGlkICcnIGZvciAnJyIsIGZ1bmN0aW9uKHNzZF9uYW1lLCBpZF9uYW1lLCBvYmplY3RfbmFtZSkKICAgIGxvY2FsIHNzZCA9IGhhdmUoc3NkX25hbWUpCiAgICBsb2NhbCBpZCA9IGhhdmUoaWRfbmFtZSkKICAgIGxvY2FsIG9iamVjdCA9IGhhdmUob2JqZWN0X25hbWUpCgogICAgbG9jYWwgY3JlZGVudGlhbAogICAgZm9yIF8sdiBpbiBwYWlycyhzc2QuY3JlZGVudGlhbF9jb25maWd1cmF0aW9uc19zdXBwb3J0ZWQpIGRvCiAgICAgICAgaWYgdi52Y3QgPT0gaWQgdGhlbiBjcmVkZW50aWFsID0gdiBlbmQKICAgIGVuZAogICAgemVuY29kZV9hc3NlcnQoY3JlZGVudGlhbCwgIlVua25vd24gY3JlZGVudGlhbCBpZCIpCiAgICBsb2NhbCBjbGFpbXMgPSBjcmVkZW50aWFsLmNsYWltcwogICAgbG9jYWwgZmllbGRzID0ge30KICAgIGZvciBfLHYgaW4gcGFpcnMoY2xhaW1zKSBkbwogICAgICAgIHRhYmxlLmluc2VydChmaWVsZHMsIHYucGF0aFsxXSkKICAgIGVuZAogICAgQUNLLnNlbGVjdGl2ZV9kaXNjbG9zdXJlX3JlcXVlc3QgPSB7CiAgICAgICAgZmllbGRzID0gZmllbGRzLAogICAgICAgIG9iamVjdCA9IG9iamVjdCwKICAgIH0KICAgIG5ld19jb2RlYygic2VsZWN0aXZlX2Rpc2Nsb3N1cmVfcmVxdWVzdCIpCmVuZCkKCldoZW4oImNyZWF0ZSBzZWxlY3RpdmUgZGlzY2xvc3VyZSBvZiAnJyIsIGZ1bmN0aW9uKHNkcl9uYW1lKQogICAgbG9jYWwgc2RyID0gaGF2ZShzZHJfbmFtZSkKICAgIGxvY2FsIHNkcCA9IFNEX0pXVC5jcmVhdGVfc2Qoc2RyKSAtLSBUT0RPOiBoYXNoIGFsZ28gYXMgYXJnCiAgICBBQ0suc2VsZWN0aXZlX2Rpc2Nsb3N1cmUgPSBzZHAKICAgIG5ld19jb2RlYygnc2VsZWN0aXZlX2Rpc2Nsb3N1cmUnKQplbmQpCgoKV2hlbigiY3JlYXRlIHNpZ25lZCBzZWxlY3RpdmUgZGlzY2xvc3VyZSBvZiAnJyIsIGZ1bmN0aW9uKHNkcF9uYW1lKQogICAgbG9jYWwgc2RwIDxjb25zdD4gPSBoYXZlKHNkcF9uYW1lKQogICAgQUNLLnNpZ25lZF9zZWxlY3RpdmVfZGlzY2xvc3VyZSA9IHsKICAgICAgICBqd3QgPSBTRF9KV1QuY3JlYXRlX2p3dChzZHAucGF5bG9hZCwKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICBoYXZla2V5KCdlczI1NicpLAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIENSWVBUTy5sb2FkKCdlczI1NicpKSwKICAgICAgICBkaXNjbG9zdXJlcyA9IHNkcC5kaXNjbG9zdXJlcywKICAgIH0KICAgIG5ld19jb2RlYygnc2lnbmVkX3NlbGVjdGl2ZV9kaXNjbG9zdXJlJykKZW5kKQoKV2hlbigiY3JlYXRlIHNpZ25lZCBzZWxlY3RpdmUgZGlzY2xvc3VyZSBvZiAnJyB3aXRoICcnIiwKICAgICBmdW5jdGlvbihzZHBfbmFtZSwgYWxnbykKICAgIGxvY2FsIHNkcCA8Y29uc3Q+ID0gaGF2ZShzZHBfbmFtZSkKICAgIGxvY2FsIGFsZyA8Y29uc3Q+ID0gbWF5aGF2ZShhbGdvKQogICAgbG9jYWwgY3J5cHRvIDxjb25zdD4gPSBDUllQVE8ubG9hZChhbGcgb3IgYWxnbykKICAgIEFDSy5zaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUgPSB7CiAgICAgICAgand0ID0gU0RfSldULmNyZWF0ZV9qd3Qoc2RwLnBheWxvYWQsIGhhdmVrZXkoY3J5cHRvLmtleW5hbWUpLCBjcnlwdG8pLAogICAgICAgIGRpc2Nsb3N1cmVzID0gc2RwLmRpc2Nsb3N1cmVzLAogICAgfQogICAgbmV3X2NvZGVjKCdzaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUnKQplbmQpCgpXaGVuKCJ1c2Ugc2lnbmVkIHNlbGVjdGl2ZSBkaXNjbG9zdXJlICcnIG9ubHkgd2l0aCBkaXNjbG9zdXJlcyAnJyIsIGZ1bmN0aW9uKHNzZF9uYW1lLCBsaXMpCiAgICBsb2NhbCBzc2QgPSBoYXZlKHNzZF9uYW1lKQogICAgbG9jYWwgZGlzY2xvc2VkX2tleXMgPSBoYXZlKGxpcykKICAgIGxvY2FsIGFsbF9kaXMgPGNvbnN0PiA9IHNzZC5kaXNjbG9zdXJlcwogICAgbG9jYWwgbmV3X2Rpc2Nsb3N1cmVzID0geyB9CiAgICBmb3IgXyxrIGluIHBhaXJzKGRpc2Nsb3NlZF9rZXlzKSBkbwogICAgICAgIGZvciBpbmQsIGFyciBpbiBwYWlycyhhbGxfZGlzKSBkbwogICAgICAgICAgICBpZiBhcnJbMl0gPT0gayB0aGVuCiAgICAgICAgICAgICAgICB0YWJsZS5pbnNlcnQobmV3X2Rpc2Nsb3N1cmVzLCBhcnIpCiAgICAgICAgICAgICAgICBicmVhawogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgIGVuZAogICAgc3NkLmRpc2Nsb3N1cmVzID0gbmV3X2Rpc2Nsb3N1cmVzCmVuZCkKCklmV2hlbigidmVyaWZ5IGRpc2Nsb3N1cmVzICcnIGFyZSBmb3VuZCBpbiBzaWduZWQgc2VsZWN0aXZlIGRpc2Nsb3N1cmUgJyciLCBmdW5jdGlvbihsaXMsIHNzZF9uYW1lKQogICAgbG9jYWwgc3NkID0gaGF2ZShzc2RfbmFtZSkKICAgIGxvY2FsIGRpc2Nsb3NlZF9rZXlzLCBjX2Rpc2Nsb3NlZF9rZXlzID0gaGF2ZShsaXMpCiAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoY19kaXNjbG9zZWRfa2V5cy56ZW50eXBlIH49ICdkJywgIkRpc2Nsb3N1cmVzIG11c3QgYmUgYSBzaW5nbGUgdmFsdWUgb3IgYW4gYXJyYXkiKSB0aGVuIHJldHVybiBlbmQKICAgIGlmIGNfZGlzY2xvc2VkX2tleXMuemVudHlwZSA9PSAnZScgdGhlbgogICAgICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydCh0eXBlKGRpc2Nsb3NlZF9rZXlzKSA9PSAnemVucm9vbS5vY3RldCcsICJEaXNjbG9zdXJlcyBtdXN0IGEgc2luZ2xlIHZhbHVlIG9yIGFuIGFycmF5IikgdGhlbiByZXR1cm4gZW5kCiAgICAgICAgZGlzY2xvc2VkX2tleXMgPSB7ZGlzY2xvc2VkX2tleXN9CiAgICBlbmQKICAgIGZvciBfLGsgaW4gcGFpcnMoZGlzY2xvc2VkX2tleXMpIGRvCiAgICAgICAgbG9jYWwgZm91bmQgPSBmYWxzZQogICAgICAgIGZvciBfLCB2IGluIHBhaXJzKHNzZC5kaXNjbG9zdXJlcykgZG8KICAgICAgICAgICAgaWYgdlsyXSA9PSBrIHRoZW4KICAgICAgICAgICAgICAgIGZvdW5kID0gdHJ1ZQogICAgICAgICAgICAgICAgYnJlYWsKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICAgICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KGZvdW5kLCAiRGlzY2xvc3VyZSBrZXkgbm90IGZvdW5kOiAiLi5rOm9jdGV0KCk6c3RyaW5nKCkpIHRoZW4gcmV0dXJuIGVuZAogICAgZW5kCmVuZCkKCi0tIGZvciByZWZlcmVuY2Ugc2VlIFNlY3Rpb24gOC4xIG9mIGh0dHBzOi8vZGF0YXRyYWNrZXIuaWV0Zi5vcmcvZG9jL2RyYWZ0LWlldGYtb2F1dGgtc2VsZWN0aXZlLWRpc2Nsb3N1cmUtand0LwpJZldoZW4oInZlcmlmeSBzaWduZWQgc2VsZWN0aXZlIGRpc2Nsb3N1cmUgJycgaXNzdWVkIGJ5ICcnIGlzIHZhbGlkIiwgZnVuY3Rpb24ob2JqLCBieSkKICAgIGxvY2FsIHNpZ25lZF9zZCA8Y29uc3Q+ID0gaGF2ZShvYmopCiAgICBsb2NhbCBqd3QgPGNvbnN0PiA9IHNpZ25lZF9zZC5qd3QKICAgIGxvY2FsIGRpc2Nsb3N1cmVzIDxjb25zdD4gPSBzaWduZWRfc2QuZGlzY2xvc3VyZXMKICAgIGxvY2FsIGFsZ28gPGNvbnN0PiA9IGp3dC5oZWFkZXIuYWxnOnN0cmluZygpCiAgICBsb2NhbCBjcnlwdG8gPGNvbnN0PiA9IENSWVBUTy5sb2FkKGFsZ28pCiAgICAtLSBpZiBqd3QuaGVhZGVyLmFsZyA9PSBPLmZyb21fc3RyaW5nKCJFUzI1NiIpIHRoZW4KICAgIGxvY2FsIGlzc19wayA8Y29uc3Q+ID0gbG9hZF9wdWJrZXlfY29tcGF0KGJ5LCBhbGdvOmxvd2VyKCkpCiAgICBsb2NhbCBwYXlsb2FkX3N0ciA8Y29uc3Q+ID0gU0RfSldULnByZXBhcmVfZGljdGlvbmFyeShqd3QucGF5bG9hZCkKICAgIGxvY2FsIGI2NHBheWxvYWQgPGNvbnN0PiA9IE8uZnJvbV9zdHJpbmcoSlNPTi5yYXdfZW5jb2RlKHBheWxvYWRfc3RyLCB0cnVlKSk6dXJsNjQoKQogICAgbG9jYWwgaGVhZGVyX3N0ciA8Y29uc3Q+ID0gU0RfSldULnByZXBhcmVfZGljdGlvbmFyeShqd3QuaGVhZGVyKQogICAgbG9jYWwgYjY0aGVhZGVyIDxjb25zdD4gPSBPLmZyb21fc3RyaW5nKEpTT04ucmF3X2VuY29kZShoZWFkZXJfc3RyLCB0cnVlKSk6dXJsNjQoKQoKICAgIC0tIGp3dC5wYXlsb2FkLl9zZF9hbGcgPT0gTy5mcm9tX3N0cmluZygic2hhLTI1NiIpCgogICAgLS0gQ2hlY2sgdGhhdCB0aGUgc2Qtand0IGNvbnRhaW5zIGFsbCB0aGUgbWFuZGF0b3J5IGNsYWltcwogICAgLS0gVE9ETzogYnJlYWsgZHVlIHRvIG5vbi1hbHBoYWJldGljIHNvcnRpbmcgb2Ygc3RyaW5nIGRpY3Rpb25hcnkKICAgIC0tIGVsZW1lbnRzIHdoZW4gcmUtZW5jb2RlZCB0byBKU09OLiBUaGUgcGF5bG9hZCBtYXkgYmUgYSBuZXN0ZWQKICAgIC0tIGRpY3Rpb25hcnkgYXQgMyBvciBtb3JlIGRlcHRoLgogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KAogICAgICAgIFNEX0pXVC5jaGVja19tYW5kYXRvcnlfY2xhaW1fbmFtZXMoand0LnBheWxvYWQpLAogICAgICAgICJUaGUgSldUIHBheWxvYWQgZG9lcyBub3QgY29udGFpbiB0aGUgbWFuZGF0b3J5IGNsYWltcyIpIHRoZW4gcmV0dXJuIGVuZAoKICAgIC0tIFByb2Nlc3MgdGhlIERpc2Nsb3N1cmVzIGFuZCBlbWJlZGRlZCBkaWdlc3RzIGluIHRoZSBJc3N1ZXJzaWduZWQgSldUIGFuZCBjb21wYXJlIHRoZSB2YWx1ZSB3aXRoIHRoZSBkaWdlc3RzIGNhbGN1bGF0ZWQKICAgIC0tIERpc2Nsb3N1cmVzIGFyZSBhbiBhcnJheSBhbmQgc29ydGluZyBpcyBrZXB0IHNvIHRoaXMgdmFsaWRhdGlvbiBwYXNzZXMuCiAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoCiAgICAgICAgU0RfSldULnZlcmlmeV9zZF9maWVsZHMoand0LnBheWxvYWQsIGRpc2Nsb3N1cmVzKSwKICAgICAgICAiVGhlIGRpc2Nsb3N1cmUgaXMgbm90IHZhbGlkIikgdGhlbiByZXR1cm4gZW5kCgogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KG9zLCAnQ291bGQgbm90IGZpbmQgb3MgdG8gY2hlY2sgdGltZXN0YW1wcycpIHRoZW4gcmV0dXJuIGVuZAogICAgbG9jYWwgdGltZV9ub3cgPSBUSU1FLm5ldyhvcy50aW1lKCkpCiAgICBpZihqd3QucGF5bG9hZC5pYXQpIHRoZW4KICAgICAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoand0LnBheWxvYWQuaWF0IDwgdGltZV9ub3csICdUaGUgaWF0IGNsYWltIGlzIG5vdCB2YWxpZCcpIHRoZW4gcmV0dXJuIGVuZAogICAgZW5kCiAgICBpZihqd3QucGF5bG9hZC5leHApIHRoZW4KICAgICAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoand0LnBheWxvYWQuZXhwID4gdGltZV9ub3csICdUaGUgZXhwIGNsYWltIGlzIG5vdCB2YWxpZCcpIHRoZW4gcmV0dXJuIGVuZAogICAgZW5kCiAgICBpZihqd3QucGF5bG9hZC5uYmYpIHRoZW4KICAgICAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoand0LnBheWxvYWQubmJmIDwgdGltZV9ub3csICdUaGUgbmJmIGNsYWltIGlzIG5vdCB2YWxpZCcpIHRoZW4gcmV0dXJuIGVuZAogICAgZW5kCgogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KAogICAgICAgIC0tIFRPRE8/OiBWYWxpZGF0ZSB0aGUgSXNzdWVyIGFuZCB0aGF0IHRoZSBzaWduaW5nIGtleSBiZWxvbmdzCiAgICAgICAgLS0gdG8gdGhpcyBJc3N1ZXIKICAgICAgICBjcnlwdG8udmVyaWZ5KGlzc19waywgTy5mcm9tX3N0cmluZyhiNjRoZWFkZXIgLi4gIi4iIC4uIGI2NHBheWxvYWQpLAogICAgICAgICAgICAgICAgICAgICAgand0LnNpZ25hdHVyZSkKICAgICAgICAsCiAgICAgICAgIlRoZSBpc3N1ZXIgc2lnbmF0dXJlIGlzIG5vdCB2YWxpZCIKICAgICkgdGhlbiByZXR1cm4gZW5kCgogICAgLS1UT0RPOiBjaGVjayB0aGF0IGlzc3VlZCBhdCBpcyBub3QgZXhwaXJlZAplbmQpCgpXaGVuKCJjcmVhdGUgZGlzY2xvc2VkIGt2IGZyb20gc2lnbmVkIHNlbGVjdGl2ZSBkaXNjbG9zdXJlICcnIiwgZnVuY3Rpb24oc3NkX25hbWUpCiAgICBsb2NhbCBzc2QsIHNzZF9jID0gaGF2ZShzc2RfbmFtZSkKICAgIHplbmNvZGVfYXNzZXJ0KHNzZF9jLnNjaGVtYSBhbmQgc3NkX2Muc2NoZW1hID09ICJzaWduZWRfc2VsZWN0aXZlX2Rpc2Nsb3N1cmUiLAogICAgICAgICJPYmplY3QgaXMgbm90IGEgc2lnbmVkIHNlbGVjdGl2ZSBkaXNjbG9zdXJlOiAiIC4uIHNzZF9uYW1lKQogICAgbG9jYWwgZGlzY2xvc2VkX2t2ID0ge30KICAgIGZvciBfLCB2IGluIHBhaXJzKHNzZC5kaXNjbG9zdXJlcykgZG8KICAgICAgICBkaXNjbG9zZWRfa3ZbdlsyXTpzdHIoKV0gPSB2WzNdCiAgICBlbmQKICAgIEFDSy5kaXNjbG9zZWRfa3YgPSBkaXNjbG9zZWRfa3YKICAgIG5ld19jb2RlYygnZGlzY2xvc2VkIGt2JywgewogICAgICAgIGVuY29kaW5nID0gJ3N0cmluZycsCiAgICAgICAgbHVhdHlwZSA9ICd0YWJsZScsCiAgICAgICAgemVudHlwZSA9ICdkJwogICAgfSkKZW5kKQovemVuY29kZV9zZWNzaGFyZS5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjAtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBEZW5pcyBSb2lvCi0tb24gVHVlc2RheSwgMjB0aCBKdWx5IDIwMjEKLS1dXQoKLS0gTGFncmFuZ2UgaW50ZXJwb2xhdGlvbiBpbXBsZW1lbnRhdGlvbiBpbiBaZW5jb2RlCgpMQUcgPSByZXF1aXJlX29uY2UoJ2NyeXB0b19sYWdyYW5nZV9pbnRlcnBvbGF0aW9uJykKCmxvY2FsIGZ1bmN0aW9uIF9leHBvcnRfYmlnX2FzX29jdGV0X2Yob2JqKQogICAgaWYgdHlwZShvYmopID09ICd6ZW5yb29tLmJpZycgdGhlbgogICAgICAgIHJldHVybiBvYmo6b2N0ZXQoKTpiYXNlNjQoKQogICAgZW5kCiAgICByZXR1cm4gb2JqCmVuZApmdW5jdGlvbiBzaW5nbGVfc2hhcmVfZihvKQogICBsb2NhbCBvYmogPSBkZWVwbWFwKENPTkYuaW5wdXQuZW5jb2RpbmcuZnVuLCBvKQogICByZXR1cm4geyB4ID0gc2NoZW1hX2dldChvYmosICd4JywgQklHLm5ldywgTy5mcm9tX2Jhc2U2NCksCiAgICAgICAgICAgIHkgPSBzY2hlbWFfZ2V0KG9iaiwgJ3knLCBCSUcubmV3LCBPLmZyb21fYmFzZTY0KSB9CmVuZApaRU46YWRkX3NjaGVtYSh7CiAgICAgIC0tIHNpbmdsZSBzaGFyZQogICAgICBzaW5nbGVfc2hhcmUgPSB7CiAgICAgICAgaW1wb3J0ID0gc2luZ2xlX3NoYXJlX2YsCiAgICAgICAgZXhwb3J0ID0gX2V4cG9ydF9iaWdfYXNfb2N0ZXRfZiwKICAgICAgfSwKICAgICAgLS0gYXJyYXkgb2Ygc2luZ2xlIHNoYXJlcwogICAgICBzZWNyZXRfc2hhcmVzID0gewogICAgICAgICAgaW1wb3J0ID0gZnVuY3Rpb24ob2JqKQogICAgICAgICAgICAgIGxvY2FsIHJlcyA9IHsgfQogICAgICAgICAgICAgIGZvciBrLHYgaW4gcGFpcnMob2JqKSBkbwogICAgICAgICAgICAgICAgICByZXNba10gPSBzaW5nbGVfc2hhcmVfZih2KQogICAgICAgICAgICAgIGVuZAogICAgICAgICAgICAgIHJldHVybiByZXMKICAgICAgICAgIGVuZCwKICAgICAgICAgIGV4cG9ydCA9IGZ1bmN0aW9uKG9iaikKICAgICAgICAgICAgICBsb2NhbCByZXMgPSB7IH0KICAgICAgICAgICAgICBmb3Igayx2IGluIHBhaXJzKG9iaikgZG8KICAgICAgICAgICAgICAgICAgcmVzW2tdID0gewogICAgICAgICAgICAgICAgICAgICAgeCA9IF9leHBvcnRfYmlnX2FzX29jdGV0X2Yodi54KSwKICAgICAgICAgICAgICAgICAgICAgIHkgPSBfZXhwb3J0X2JpZ19hc19vY3RldF9mKHYueSksCiAgICAgICAgICAgICAgICAgIH0KICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgICByZXR1cm4gcmVzCiAgICAgICAgICBlbmQsCiAgICAgIH0KfSkKCldoZW4oImNyZWF0ZSBzZWNyZXQgc2hhcmVzIG9mICcnIHdpdGggJycgcXVvcnVtICcnIiwgZnVuY3Rpb24oc2VjLCB0b3QsIHEpCglsb2NhbCBzb2N0ID0gaGF2ZShzZWMpCgktLSB0aGlzIGNoZWNrIGlzIHJlbGF0aXZlIHRvIHRoZSBCSUcgc2l6ZSwgZXN0YWJsaXNoZWQgYnkgY3VydmUncyBzaXplCgktLSBpdCBpcyBtYWRlIGluc2lkZSB0aGUgY3J5cHRvIGZ1bmN0aW9uLCBidXQgY291bGQgYWxzbyBiZSBtYWRlIGhlcmUKCS0tIGxvY2FsIHNiaWcgPSBCSUcubmV3KHNvY3QpICUgRUNQLm9yZGVyKCkKCS0tIHplbmNvZGVfYXNzZXJ0KHNiaWc6b2N0ZXQoKSA9PSBzb2N0LCAiU2VjcmV0IHRvbyBiaWcgdG8gc2hhcmU6ICIuLiNzb2N0Li4iIGJ5dGVzIikKCWxvY2FsIHRvdGFsID0gdG9udW1iZXIodG90KQoJemVuY29kZV9hc3NlcnQodG90YWwsICJUb3RhbCBzaGFyZXMgaXMgbm90IGEgbnVtYmVyOiAiLi50b3QpCglsb2NhbCBxdW9ydW0gPSB0b251bWJlcihxKQoJemVuY29kZV9hc3NlcnQocXVvcnVtLCAiUXVvcnVtIHNoYXJlcyBpcyBub3QgYSBudW1iZXI6ICIuLnEpCiAgICAgICAgQUNLLnNlY3JldF9zaGFyZXMgPSBMQUcuY3JlYXRlX3NoYXJlZF9zZWNyZXQodG90YWwscXVvcnVtLHNvY3QpCiAgICAgICAgbmV3X2NvZGVjKCdzZWNyZXRfc2hhcmVzJywgewogICAgICAgICAgICBlbmNvZGluZz0iY29tcGxleCIsCiAgICAgICAgICAgIHNjaGVtYT0ic2VjcmV0X3NoYXJlcyIsCiAgICAgICAgfSkKZW5kKQoKV2hlbigiY29tcG9zZSBzZWNyZXQgdXNpbmcgJyciLCBmdW5jdGlvbihzaGFyZXMpCglsb2NhbCBzaCA9IGhhdmUoc2hhcmVzKQogICAgICAgIEFDSy5zZWNyZXQgPSBMQUcuY29tcG9zZV9zaGFyZWRfc2VjcmV0KHNoKTpvY3RldCgpCiAgICAgICAgbmV3X2NvZGVjKCdzZWNyZXQnLCB7CiAgICAgICAgICAgIGVuY29kaW5nPSJiYXNlNjQiLAogICAgICAgICAgICB6ZW50eXBlPSdlJywKICAgICAgICB9KQplbmQpCi96ZW5jb2RlX3RhYmxlLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBNb25kYXksIDI4dGggQXVndXN0IDIwMjMKLS1dXQoKbG9jYWwgZnVuY3Rpb24gbW92ZV9vcl9jb3B5X2luKHNyY192YWx1ZSwgc3JjX25hbWUsIGRlc3QsIG5ldywgZW5jKQogICAgbG9jYWwgZCwgY2Rlc3QgPGNvbnN0PiA9IGhhdmUoZGVzdCkKICAgIGlmIGx1YXR5cGUoZCkgfj0gJ3RhYmxlJyB0aGVuIGVycm9yKCJPYmplY3QgaXMgbm90IGEgdGFibGU6ICIuLmRlc3QsIDIpIGVuZAogICAgbG9jYWwgbmV3X25hbWUgPGNvbnN0PiA9IG5ldyBvciBzcmNfbmFtZQogICAgaWYgZW5jIHRoZW4KICAgICAgICBzcmNfdmFsdWUgPSBhcHBseV9lbmNvZGluZyhzcmNfbmFtZSwgZW5jLCBjZGVzdC5lbmNvZGluZykKICAgIGVuZAogICAgaWYgY2Rlc3QuemVudHlwZSA9PSAnZScgYW5kIGNkZXN0LnNjaGVtYSB0aGVuCiAgICAgICAgbG9jYWwgc2Rlc3QgPGNvbnN0PiA9IFpFTi5zY2hlbWFzW2NkZXN0LnNjaGVtYV0KICAgICAgICBpZiBsdWF0eXBlKHNkZXN0KSB+PSAndGFibGUnIHRoZW4gLS0gb2xkIHNjaGVtYSB0eXBlcyBhcmUgbm90IG9wZW4KICAgICAgICAgICAgZXJyb3IoIlNjaGVtYSBpcyBub3Qgb3BlbiB0byBhY2NlcHQgZXh0cmEgb2JqZWN0czogIi4uZGVzdCwgMikKICAgICAgICBlbHNlaWYgbm90IHNkZXN0LnNjaGVtYXR5cGUgb3Igc2Rlc3Quc2NoZW1hdHlwZSB+PSAnb3BlbicgdGhlbgogICAgICAgICAgICBlcnJvcigiU2NoZW1hIGlzIG5vdCBvcGVuIHRvIGFjY2VwdCBleHRyYSBvYmplY3RzOiAiLi5kZXN0LCAyKQogICAgICAgIGVuZAogICAgICAgIGlmIGRbbmV3X25hbWVdIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkNhbm5vdCBvdmVyd3JpdGU6ICIuLm5ld19uYW1lLi4iIGluICIuLmRlc3QsMikKICAgICAgICBlbmQKICAgICAgICBkW25ld19uYW1lXSA9IHNyY192YWx1ZQogICAgICAgIEFDS1tkZXN0XSA9IGQKICAgIGVsc2VpZiBjZGVzdC56ZW50eXBlID09ICdkJyB0aGVuCiAgICAgICAgaWYgZFtuZXdfbmFtZV0gdGhlbgogICAgICAgICAgICBlcnJvcigiQ2Fubm90IG92ZXJ3cml0ZTogIi4ubmV3X25hbWUuLiIgaW4gIi4uZGVzdCwyKQogICAgICAgIGVuZAogICAgICAgIGRbbmV3X25hbWVdID0gc3JjX3ZhbHVlCiAgICAgICAgQUNLW2Rlc3RdID0gZAogICAgZWxzZWlmIGNkZXN0LnplbnR5cGUgPT0gJ2EnIHRoZW4KICAgICAgICB0YWJsZS5pbnNlcnQoQUNLW2Rlc3RdLCBzcmNfdmFsdWUpCiAgICBlbHNlCiAgICAgICAgZXJyb3IoIkludmFsaWQgZGVzdGluYXRpb24gdHlwZTogIi4uY2Rlc3QuemVudHlwZSwyKQogICAgZW5kCmVuZAoKV2hlbigibW92ZSBuYW1lZCBieSAnJyBpbiAnJyIsIGZ1bmN0aW9uKHNyY19uYW1lLCBkZXN0KQogICAgbG9jYWwgc3JjID0gaGF2ZShzcmNfbmFtZSk6c3RyaW5nKCkKICAgIG1vdmVfb3JfY29weV9pbihoYXZlKHNyYyksIHNyYywgZGVzdCkKICAgIEFDS1tzcmNdID0gbmlsCiAgICBDT0RFQ1tzcmNdID0gbmlsCmVuZCkKCldoZW4oIm1vdmUgJycgaW4gJyciLCBmdW5jdGlvbihzcmMsIGRlc3QpCiAgICBtb3ZlX29yX2NvcHlfaW4oaGF2ZShzcmMpLCBzcmMsIGRlc3QpCiAgICBBQ0tbc3JjXSA9IG5pbAogICAgQ09ERUNbc3JjXSA9IG5pbAplbmQpCgpXaGVuKCJtb3ZlICcnIHRvICcnIGluICcnIiwgZnVuY3Rpb24oc3JjLCBuZXcsIGRlc3QpCiAgICBtb3ZlX29yX2NvcHlfaW4oaGF2ZShzcmMpLCBzcmMsIGRlc3QsIG5ldykKICAgIEFDS1tzcmNdID0gbmlsCiAgICBDT0RFQ1tzcmNdID0gbmlsCmVuZCkKCldoZW4oIm1vdmUgJycgYXMgJycgaW4gJyciLCBmdW5jdGlvbihzcmMsIGVuYywgZGVzdCkKICAgIG1vdmVfb3JfY29weV9pbihoYXZlKHNyYyksIHNyYywgZGVzdCwgbmlsLCBlbmMpCiAgICBBQ0tbc3JjXSA9IG5pbAogICAgQ09ERUNbc3JjXSA9IG5pbAplbmQpCgpXaGVuKCJtb3ZlICcnIGZyb20gJycgaW4gJyciLCBmdW5jdGlvbihuYW1lLCBzcmMsIGRlc3QpCiAgICBtb3ZlX29yX2NvcHlfaW4oaGF2ZSh7c3JjLCBuYW1lfSksIG5hbWUsIGRlc3QpCiAgICBBQ0tbc3JjXVtuYW1lXSA9IG5pbAplbmQpCgpXaGVuKCJjb3B5IG5hbWVkIGJ5ICcnIGluICcnIiwgZnVuY3Rpb24oc3JjX25hbWUsIGRlc3QpCiAgICBsb2NhbCBzcmMgPSBoYXZlKHNyY19uYW1lKTpzdHJpbmcoKQogICAgbW92ZV9vcl9jb3B5X2luKGRlZXBjb3B5KGhhdmUoc3JjKSksIHNyYywgZGVzdCkKZW5kKQoKV2hlbigiY29weSAnJyBpbiAnJyIsIGZ1bmN0aW9uKHNyYywgZGVzdCkKICAgIG1vdmVfb3JfY29weV9pbihkZWVwY29weShoYXZlKHNyYykpLCBzcmMsIGRlc3QpCmVuZCkKCldoZW4oImNvcHkgJycgdG8gJycgaW4gJyciLCBmdW5jdGlvbihzcmMsIG5ldywgZGVzdCkKICAgIG1vdmVfb3JfY29weV9pbihoYXZlKHNyYyksIHNyYywgZGVzdCwgbmV3KQplbmQpCgpXaGVuKCJjb3B5ICcnIGFzICcnIGluICcnIiwgZnVuY3Rpb24oc3JjLCBlbmMsIGRlc3QpCiAgICBtb3ZlX29yX2NvcHlfaW4oaGF2ZShzcmMpLCBzcmMsIGRlc3QsIG5pbCwgZW5jKQplbmQpCgpXaGVuKCJjb3B5ICcnIGZyb20gJycgaW4gJyciLCBmdW5jdGlvbihuYW1lLCBzcmMsIGRlc3QpCiAgICBtb3ZlX29yX2NvcHlfaW4oaGF2ZSh7c3JjLCBuYW1lfSksIG5hbWUsIGRlc3QpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF93aGVuX3JlbW92ZV9kaWN0aW9uYXJ5KGVsZSwgZnJvbSkKICAgIC0tIGVsZSBpcyBqdXN0IHRoZSBuYW1lIChrZXkpIG9mIG9iamVjdCB0byByZW1vdmUKICAgIGxvY2FsIGRpY3QgPSBoYXZlKGZyb20pCiAgICB6ZW5jb2RlX2Fzc2VydChkaWN0LCAiRGljdGlvbmFyeSBub3QgZm91bmQ6ICIuLmZyb20pCiAgICBpZiBkaWN0W2VsZV0gdGhlbgogICAgICAgIEFDS1tmcm9tXVtlbGVdID0gbmlsIC0tIHJlbW92ZSBmcm9tIGRpY3Rpb25hcnkKICAgIGVsc2VpZiBDT0RFQ1tlbGVdLm5hbWUgfj0gZWxlIGFuZCBkaWN0W0NPREVDW2VsZV0ubmFtZV0gdGhlbgogICAgICAgIC0tIGl0IG1heSBiZSBhIGNvcHkgb3IgcmFuZG9tIG9iamVjdCB3aXRoIGRpZmZlcmVudCBuYW1lCiAgICAgICAgQUNLW2Zyb21dW0NPREVDW2VsZV0ubmFtZV0gPSBuaWwKICAgIGVsc2UKICAgICAgICBlcnJvcigiT2JqZWN0IG5vdCBmb3VuZCBpbiBkaWN0aW9uYXJ5OiAiLi5lbGUuLiIgaW4gIi4uZnJvbSkKICAgIGVuZAplbmQKCmxvY2FsIGZ1bmN0aW9uIF93aGVuX3JlbW92ZV9hcnJheShlbGUsIGZyb20pCiAgICBsb2NhbCBvYmogPSBoYXZlKGVsZSkKICAgIGxvY2FsIGFyciA9IGhhdmUoZnJvbSkKICAgIGxvY2FsIGZvdW5kID0gZmFsc2UKICAgIGxvY2FsIG5ld2Rlc3QgPSB7IH0KICAgIGlmIGx1YXR5cGUob2JqKSA9PSAndGFibGUnIHRoZW4KICAgICAgICAtLSBvdmVybG9hZCBfX2VxIGZvciB0YWJsZXMKICAgICAgICBsb2NhbCBtX29iaiA9IHt9CiAgICAgICAgbG9jYWwgbV9hcnIgPSB7fQogICAgICAgIHNldG1ldGF0YWJsZShhcnIsIG1fYXJyKQogICAgICAgIHNldG1ldGF0YWJsZShvYmosIG1fb2JqKQogICAgICAgIGxvY2FsIGZ1biA9IGZ1bmN0aW9uKGwsIHIpIHJldHVybiB6ZW5jb2RlX3NlcmlhbGl6ZShsKSA9PSB6ZW5jb2RlX3NlcmlhbGl6ZShyKSBlbmQKICAgICAgICBtX2Fyci5fX2VxID0gZnVuCiAgICAgICAgbV9vYmouX19lcSA9IGZ1bgogICAgZW5kCiAgICBmb3IgXyx2IGluIG5leHQsYXJyLG5pbCBkbwogICAgICAgIGlmIG5vdCAodiA9PSBvYmopIHRoZW4KICAgICAgICAgICAgdGFibGUuaW5zZXJ0KG5ld2Rlc3QsdikKICAgICAgICBlbHNlCiAgICAgICAgICAgIGZvdW5kID0gdHJ1ZQogICAgICAgIGVuZAogICAgZW5kCiAgICB6ZW5jb2RlX2Fzc2VydChmb3VuZCwgIkVsZW1lbnQgdG8gYmUgcmVtb3ZlZCBub3QgZm91bmQgaW4gYXJyYXkiKQogICAgQUNLW2Zyb21dID0gbmV3ZGVzdAplbmQKCldoZW4oInJlbW92ZSAnJyBmcm9tICcnIiwgZnVuY3Rpb24oZWxlLGZyb20pCiAgICBsb2NhbCBjb2RlYyA9IENPREVDW2Zyb21dCiAgICB6ZW5jb2RlX2Fzc2VydChjb2RlYywgIk5vIGNvZGVjIHJlZ2lzdHJhdGlvbiBmb3IgdGFyZ2V0OiAiLi5mcm9tKQogICAgaWYgY29kZWMuemVudHlwZSA9PSAnZCcKICAgICAgICBvciBjb2RlYy5zY2hlbWEgdGhlbgogICAgICAgIF93aGVuX3JlbW92ZV9kaWN0aW9uYXJ5KGVsZSwgZnJvbSkKICAgIGVsc2VpZiBjb2RlYy56ZW50eXBlID09ICdhJyB0aGVuCiAgICAgICAgX3doZW5fcmVtb3ZlX2FycmF5KGVsZSwgZnJvbSkKICAgIGVsc2UKICAgICAgICBJLndhcm4oeyBDT0RFQyA9IGNvZGVjfSkKICAgICAgICBlcnJvcigiSW52YWxpZCBjb2RlYyByZWdpc3RyYXRpb24gZm9yIHRhcmdldDogIi4uZnJvbSkKICAgIGVuZAplbmQpCgpsb2NhbCBmdW5jdGlvbiBjb3VudF9mKG9ial9uYW1lKQogICAgbG9jYWwgb2JqLCBvYmpfY29kZWMgPSBoYXZlKG9ial9uYW1lKQogICAgbG9jYWwgY291bnQgPSAwCiAgICBpZiBvYmpfY29kZWMuemVudHlwZSA9PSAnZCcgdGhlbgogICAgICAgIGZvciBfLCBfIGluIHBhaXJzKHQpIGRvCiAgICAgICAgICAgIGNvdW50ID0gY291bnQgKyAxCiAgICAgICAgZW5kCiAgICBlbHNlCiAgICAgICAgY291bnQgPSAjb2JqCiAgICBlbmQKICAgIHJldHVybiBjb3VudAplbmQKCldoZW4oImNyZWF0ZSBzaXplIG9mICcnIiwgZnVuY3Rpb24oYXJyKQogICAgQUNLLnNpemUgPSBGLm5ldyhjb3VudF9mKGFycikpCiAgICBuZXdfY29kZWMoJ3NpemUnLCB7emVudHlwZT0nZScsIGVuY29kaW5nPSdmbG9hdCd9KQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfaXNfZm91bmRfaW4oZWxlX25hbWUsIG9ial9uYW1lKQogICAgbG9jYWwgZWxlID0gbWF5aGF2ZShlbGVfbmFtZSkgb3IgTy5mcm9tX3N0cmluZyhlbGVfbmFtZSkKICAgIGxvY2FsIG9iaiwgb2JqX2NvZGVjID0gaGF2ZShvYmpfbmFtZSkKICAgIGlmIG9ial9jb2RlYy56ZW50eXBlID09ICdhJyB0aGVuCiAgICAgICAgZm9yIF8sdiBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgICAgIGlmIHYgPT0gZWxlIHRoZW4gcmV0dXJuIHRydWUgZW5kCiAgICAgICAgZW5kCiAgICBlbHNlaWYgb2JqX2NvZGVjLnplbnR5cGUgPT0gJ2QnIHRoZW4KICAgICAgICBsb2NhbCBlbCA9IE8udG9fc3RyaW5nKGVsZSkKICAgICAgICByZXR1cm4gb2JqW2VsXSBhbmQgKGx1YXR5cGUob2JqW2VsXSkgPT0gJ3RhYmxlJyBvciB0b251bWJlcihvYmpbZWxdKSBvciAjb2JqW2VsXSB+PSAwKQogICAgZWxzZQogICAgICAgIHplbmNvZGVfYXNzZXJ0KGZhbHNlLCAiSW52YWxpZCBjb250YWluZXIgdHlwZTogIi4ub2JqLi4iIGlzICIuLm9ial9jb2RlYy56ZW50eXBlKQogICAgZW5kCmVuZAoKSWZXaGVuKCJ2ZXJpZnkgJycgaXMgbm90IGZvdW5kIGluICcnIiwgZnVuY3Rpb24oZWxlX25hbWUsIG9ial9uYW1lKQogICAgICAgICAgIHplbmNvZGVfYXNzZXJ0KG5vdCBfaXNfZm91bmRfaW4oZWxlX25hbWUsIG9ial9uYW1lKSwKICAgICAgICAgICAgICAgICAgICAgICAgICAiT2JqZWN0IHNob3VsZCBub3QgYmUgZm91bmQ6ICIuLmVsZV9uYW1lLi4iIGluICIuLm9ial9uYW1lKQplbmQpCgpJZldoZW4oInZlcmlmeSAnJyBpcyBmb3VuZCBpbiAnJyIsIGZ1bmN0aW9uKGVsZV9uYW1lLCBvYmpfbmFtZSkKICAgICAgICAgICB6ZW5jb2RlX2Fzc2VydChfaXNfZm91bmRfaW4oZWxlX25hbWUsIG9ial9uYW1lKSwKICAgICAgICAgICAgICAgICAgICAgICAgICAiQ2Fubm90IGZpbmQgb2JqZWN0OiAiLi5lbGVfbmFtZS4uIiBpbiAiLi5vYmpfbmFtZSkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgJycgaXMgZm91bmQgaW4gJycgYXQgbGVhc3QgJycgdGltZXMiLCBmdW5jdGlvbihlbGVfbmFtZSwgb2JqX25hbWUsIHRpbWVzKQogICAgbG9jYWwgZWxlLCBlbGVfY29kZWMgPSBoYXZlKGVsZV9uYW1lKQogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KCBsdWF0eXBlKGVsZSkgfj0gJ3RhYmxlJywKICAgICAgICAgICAgICAgICJJbnZhbGlkIHVzZSBvZiB0YWJsZSBpbiBvYmplY3QgY29tcGFyaXNvbjogIi4uZWxlX25hbWUpIHRoZW4gcmV0dXJuIGVuZAogICAgbG9jYWwgbnVtID0gaGF2ZSh0aW1lcykKICAgIGxvY2FsIG9iaiwgb2JqX2NvZGVjID0gaGF2ZShvYmpfbmFtZSkKICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydCggbHVhdHlwZShvYmopID09ICd0YWJsZScsCiAgICAgICAgICAgICAgICAiTm90IGEgdGFibGU6ICIuLm9ial9uYW1lKSB0aGVuIHJldHVybiBlbmQKICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydCggb2JqX2NvZGVjLnplbnR5cGUgPT0gJ2EnLCAiTm90IGFuIGFycmF5OiAiLi5vYmpfbmFtZSkgdGhlbiByZXR1cm4gZW5kCiAgICBsb2NhbCBjb25zdHJ1Y3RvciA9IGZpZih0eXBlKG51bSkgPT0gInplbnJvb20uYmlnIiwgQklHLm5ldywgRi5uZXcpCiAgICBsb2NhbCBmb3VuZCA9IGNvbnN0cnVjdG9yKDApCiAgICBsb2NhbCBvbmUgPSBjb25zdHJ1Y3RvcigxKQogICAgZm9yIF8sdiBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgaWYgdHlwZSh2KSA9PSB0eXBlKGVsZSkgYW5kIHYgPT0gZWxlIHRoZW4gZm91bmQgPSBmb3VuZCArIG9uZSBlbmQKICAgIGVuZAogICAgaWYgdHlwZShudW0pID09ICJ6ZW5yb29tLmJpZyIgdGhlbgogICAgICAgIHplbmNvZGVfYXNzZXJ0KGZvdW5kID49IG51bSwgIk9iamVjdCAiLi5lbGVfbmFtZS4uIiBmb3VuZCBvbmx5ICIuLmZvdW5kOmRlY2ltYWwoKS4uIiB0aW1lcyBpbnN0ZWFkIG9mICIuLm51bTpkZWNpbWFsKCkuLiIgaW4gYXJyYXkgIi4ub2JqX25hbWUpCiAgICBlbHNlCiAgICAgICAgemVuY29kZV9hc3NlcnQoZm91bmQgPj0gbnVtLCAiT2JqZWN0ICIuLmVsZV9uYW1lLi4iIGZvdW5kIG9ubHkgIi4udG9zdHJpbmcoZm91bmQpLi4iIHRpbWVzIGluc3RlYWQgb2YgIi4udG9zdHJpbmcobnVtKS4uIiBpbiBhcnJheSAiLi5vYmpfbmFtZSkKICAgIGVuZAplbmQpCgpXaGVuKCJjcmVhdGUgY29weSBvZiBsYXN0IGVsZW1lbnQgZnJvbSAnJyIsIGZ1bmN0aW9uKG9ial9uYW1lKQogICAgbG9jYWwgb2JqLCBvYmpfY29kZWMgPSBoYXZlKG9ial9uYW1lKQogICAgaWYgdHlwZShvYmopIH49ICd0YWJsZScgdGhlbgogICAgICAgIGVycm9yKCJDYW4gb25seSBpbmRleCB0YWJsZXMiKQogICAgZW5kCiAgICBpZiBvYmpfY29kZWMuemVudHlwZSA9PSAnYScgdGhlbgogICAgICAgIGlmICNvYmogPT0gMCB0aGVuCiAgICAgICAgICAgIGVycm9yKCJMYXN0IGVsZW1lbnQgZG9lc24ndCBleGlzdCBmb3IgZW1wdHkgYXJyYXkiKQogICAgICAgIGVuZAogICAgICAgIEFDSy5jb3B5X29mX2xhc3RfZWxlbWVudCA9IG9ialsjb2JqXQogICAgZWxzZWlmIG9ial9jb2RlYy56ZW50eXBlID09ICdkJyB0aGVuCiAgICAgICAgbG9jYWwgZWxlbSA9IG5pbAogICAgICAgIGZvciBfLCB2IGluIHNvcnRfcGFpcnMob2JqKSBkbwogICAgICAgICAgICBlbGVtID0gdgogICAgICAgIGVuZAogICAgICAgIGlmIG5vdCBlbGVtIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkxhc3QgZWxlbWVudCBkb2Vzbid0IGV4aXN0IGZvciBlbXB0eSBkaWN0aW9uYXJ5IikKICAgICAgICBlbmQKICAgICAgICBBQ0suY29weV9vZl9sYXN0X2VsZW1lbnQgPSBlbGVtCiAgICBlbHNlCiAgICAgICAgZXJyb3IoIkNhbm5vdCBmaW5kIGxhc3QgZWxlbWVudCBpbiAiIC4uIG9ial9jb2RlYy56ZW50eXBlKQogICAgZW5kCiAgICBsb2NhbCBuX2NvZGVjID0ge2VuY29kaW5nID0gb2JqX2NvZGVjLmVuY29kaW5nfQogICAgLS0gaWYgY29weWluZyBmcm9tIHRhYmxlIG9mIHNjaGVtYQogICAgaWYgb2JqX2NvZGVjLnNjaGVtYSB0aGVuCiAgICAgICAgbl9jb2RlYy5zY2hlbWEgPSBvYmpfY29kZWMuc2NoZW1hCiAgICAgICAgbl9jb2RlYy56ZW50eXBlID0gImUiCiAgICBlbmQKICAgIG5ld19jb2RlYygnY29weV9vZl9sYXN0X2VsZW1lbnQnLCBuX2NvZGVjKQplbmQpCgpsb2NhbCBmdW5jdGlvbiB0YWtlX291dF9mKHBhdGgsIGRlc3QsIGZvcm1hdCkKICAgIGlmIGRlc3QgdGhlbiBwYXRoID0gcGF0aC4uQ09ORi5wYXRoLnNlcGFyYXRvci4uZGVzdCBlbmQKICAgIGxvY2FsIGVsZSA8Y29uc3Q+LCBkZXN0IDxjb25zdD4gPSBwaWNrX2Zyb21fcGF0aChwYXRoKQogICAgQUNLW2Rlc3RdID0gZWxlCiAgICBpZiBmb3JtYXQgdGhlbgogICAgICAgIG5ld19jb2RlYyhkZXN0LCBndWVzc19jb252ZXJzaW9uKEFDS1tkZXN0XSwgZm9ybWF0KSkKICAgIGVsc2UKICAgICAgICBsb2NhbCByb290IDxjb25zdD4gPSBzdHJ0b2sodXNjb3JlKHBhdGgpLCBDT05GLnBhdGguc2VwYXJhdG9yKVsxXQogICAgICAgIG5ld19jb2RlYyhkZXN0LCB7IGVuY29kaW5nID0gQ09ERUNbcm9vdF0uZW5jb2RpbmcgfSkKICAgIGVuZAplbmQKCldoZW4oInBpY2t1cCBmcm9tIHBhdGggJyciLCBmdW5jdGlvbihwYXRoKQogICAgdGFrZV9vdXRfZihwYXRoLCBuaWwsIG5pbCkKZW5kKQoKV2hlbigicGlja3VwIGEgJycgZnJvbSBwYXRoICcnIiwgZnVuY3Rpb24oZm9ybWF0LCBwYXRoKQogICAgdGFrZV9vdXRfZihwYXRoLCBuaWwsIGZvcm1hdCkKZW5kKQoKV2hlbigidGFrZSAnJyBmcm9tIHBhdGggJyciLCBmdW5jdGlvbih0YXJnZXQsIHBhdGgpCiAgICB0YWtlX291dF9mKHBhdGgsIHVzY29yZSh0YXJnZXQpLCBuaWwpCmVuZCkKCldoZW4oInNldCBwb2ludGVyIHRvICcnIiwgZnVuY3Rpb24ob2JqX25hbWUpCiAgICBsb2NhbCBvYmosIG9ial9jb2RlYyA9IGhhdmUob2JqX25hbWUpCiAgICBlbXB0eSAicG9pbnRlciIKICAgIEFDSy5wb2ludGVyID0gb2JqCiAgICBuZXdfY29kZWMoInBvaW50ZXIiLCBuaWwsIG9ial9uYW1lKQplbmQpCgpXaGVuKCJlbnRlciAnJyB3aXRoIHBvaW50ZXIiLCBmdW5jdGlvbihrZXlfbmFtZSkKICAgIGxvY2FsIGtleV9vLCBrZXlfY29kZWMgPSBtYXloYXZlKGtleV9uYW1lKQogICAgbG9jYWwgcCwgcF9jb2RlYyA9IGhhdmUoInBvaW50ZXIiKQogICAgbG9jYWwga2V5X3MKICAgIGlmIGtleV9vIHRoZW4KICAgICAgICBrZXlfcyA9IGdldF9lbmNvZGluZ19mdW5jdGlvbihrZXlfY29kZWMuZW5jb2RpbmcpKGtleV9vKQogICAgZWxzZQogICAgICAgIGtleV9zID0ga2V5X25hbWUKICAgIGVuZAogICAgaWYgcF9jb2RlYy56ZW50eXBlID09ICJhIiB0aGVuCiAgICAgICAga2V5X3MgPSB0b251bWJlcihrZXlfcykKICAgICAgICB6ZW5jb2RlX2Fzc2VydChrZXlfcywgIlBvaW50ZXIgaXMgYW4gYXJyYXkgYnV0IGtleSBpcyBub3QgYSBwb3NpdGlvbiBudW1iZXI6ICIuLmtleV9uYW1lKQogICAgZW5kCiAgICB6ZW5jb2RlX2Fzc2VydChwW2tleV9zXSwgIkNhbm5vdCBmaW5kICIuLmtleV9zLi4iIGluIHBvaW50ZXIiKQogICAgQUNLLnBvaW50ZXIgPSBwW2tleV9zXQogICAgbG9jYWwgbl9jb2RlYyA9IHtlbmNvZGluZyA9IHBfY29kZWMuZW5jb2Rpbmd9CiAgICBpZiBwX2NvZGVjLnNjaGVtYSB0aGVuCiAgICAgICAgbl9jb2RlYy5zY2hlbWEgPSBwX2NvZGVjLnNjaGVtYQogICAgICAgIG5fY29kZWMuemVudHlwZSA9ICJlIgogICAgZW5kCiAgICBDT0RFQy5wb2ludGVyID0gbmlsCiAgICBuZXdfY29kZWMoInBvaW50ZXIiLCBuX2NvZGVjKQplbmQpCi96ZW5jb2RlX3RoZW4ubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFN1bmRheSwgMTB0aCBBcHJpbCAyMDIyCi0tXV0KCi0tLSBUSEVOIGNvbWJpbmF0aW9uczoKLS0gdGhlCi0tIHRoZSBmcm9tCi0tIHRoZSBhcwotLSB0aGUgaW4KLS0gbXkKLS0gbXkgZnJvbQotLSBteSBhcwotLSB0aGUgZnJvbSBhcwotLSB0aGUgZnJvbSBpbgotLSB0aGUgYXMgaW4KLS0gdGhlIGZyb20gYXMgaW4KLS0gbXkgZnJvbSBhcwotLS0tLS0tLS0tLS0tLS0tLS0tLS0tCgpsb2NhbCBmdW5jdGlvbiBhcHBseV9zY2hlbWEodmFyaWFibGVfdmFsdWUsIHZhcmlhYmxlX25hbWUsIHNjaGVtYV9uYW1lKQogICAgbG9jYWwgZnVuCiAgICBsb2NhbCBjb2RlYyA9IENPREVDW3VzY29yZSh2YXJpYWJsZV9uYW1lKV0KICAgIGlmIG5vdCBjb2RlYyB0aGVuIGVycm9yKCJDT0RFQyBub3QgZm91bmQgZm9yIG9iamVjdDogIi4ua2V5LCAyKSBlbmQKICAgIGxvY2FsIHNjaGVtYSA9IFpFTi5zY2hlbWFzW3NjaGVtYV9uYW1lXQogICAgaWYgbm90IHNjaGVtYSB0aGVuIGVycm9yKCJTY2hlbWEgbm90IGZvdW5kOiAiLi52YXJpYWJsZV9uYW1lLDIpIGVuZAogICAgaWYgbHVhdHlwZShzY2hlbWEpID09ICdmdW5jdGlvbicgdGhlbiBmdW4gPSBkZWZhdWx0X2V4cG9ydF9mCiAgICBlbHNlCiAgICAgICAgZnVuID0gc2NoZW1hLmV4cG9ydCBvciBkZWZhdWx0X2V4cG9ydF9mCiAgICBlbmQKICAgIC0tIHRhYmxlCiAgICBpZiBjb2RlYy56ZW50eXBlIH49ICdlJyB0aGVuCiAgICAgICAgbG9jYWwgcmVzID0ge30KICAgICAgICBmb3Igayx2IGluIHBhaXJzKHZhcmlhYmxlX3ZhbHVlKSBkbwogICAgICAgICAgICByZXNba10gPSBmdW4odikKICAgICAgICBlbmQKICAgICAgICByZXR1cm4gcmVzCiAgICBlbmQKICAgIC0tIGVsZW1lbnQKICAgIHJldHVybiBmdW4odmFyaWFibGVfdmFsdWUpCmVuZAoKIC0tIENPREVDIGZvcm1hdDoKIC0tIHsgbmFtZTogc3RyaW5nLAogLS0gICBlbmNvZGluZzogZW5jb2Rpbmcgb2Ygb2JqZWN0IGRhdGEsIGJvdGggYmFzaWMgYW5kIHNjaGVtYQogLS0gICB6ZW50eXBlOiAgemVuY29kZSB0eXBlOiAnZSdsZW1lbnQsICdhJ3JyYXkgb3IgJ2QnaWN0aW9uYXJ5CiAtLSAgIHNjaGVtYTogc2NoZW1hIG5hbWUgdXNlZCB0byBpbXBvcnQgb3IgbmlsIHdoZW4gYmFzaWMgb2JqZWN0CiAtLSB9Cgpsb2NhbCBmdW5jdGlvbiB0aGVuX291dGNhc3QodmFsLCBrZXksIGVuYykKICAgaWYgbm90IHZhbCB0aGVuCiAgICAgIGVycm9yKCJUaGVuIG91dGNhc3QgY2FsbGVkIG9uIGVtcHR5IHZhcmlhYmxlIiwgMikKICAgZW5kCiAgIGxvY2FsIGZ1bgogICBpZiBlbmMgdGhlbgoJICBmdW4gPSBnZXRfZW5jb2RpbmdfZnVuY3Rpb24oZW5jKQogICAgICBpZiBaRU4uc2NoZW1hc1tlbmNdIHRoZW4KICAgICAgICByZXR1cm4gYXBwbHlfc2NoZW1hKHZhbCwga2V5LCBlbmMpCiAgICAgIGVsc2VpZiBmdW4gdGhlbgogICAgICAgIHJldHVybiBkZWVwbWFwKGZ1biwgdmFsKQogICAgICBlbmQKCSAgZXJyb3IoIk91dHB1dCBlbmNvZGluZyBub3QgZm91bmQ6ICIuLmVuYykKICAgZW5kCiAgIGxvY2FsIGNvZGVjID0gQ09ERUNbdXNjb3JlKGtleSldCiAgIGlmIG5vdCBjb2RlYyB0aGVuIGVycm9yKCJDT0RFQyBub3QgZm91bmQgZm9yIG9iamVjdDogIi4ua2V5LCAyKSBlbmQKICAgaWYgY29kZWMuc2NoZW1hIHRoZW4gcmV0dXJuIGFwcGx5X3NjaGVtYSh2YWwsIGtleSwgY29kZWMuc2NoZW1hKSBlbmQKICAgaWYgY29kZWMubWFzayB0aGVuIHJldHVybiBkZWVwbWFzayhPQ1RFVC50b19zdHJpbmcsdmFsLGNvZGVjLm1hc2spIGVuZAogICBpZiBjb2RlYy5lbmNvZGluZyB0aGVuCgkgIGZ1biA9IGdldF9lbmNvZGluZ19mdW5jdGlvbihjb2RlYy5lbmNvZGluZykKCSAgaWYgbm90IGZ1biB0aGVuIGVycm9yKCJDT0RFQyBlbmNvZGluZyBub3QgZm91bmQ6ICIuLmNvZGVjLmVuY29kaW5nKSBlbmQKICAgZWxzZQoJICBmdW4gPSBkZWZhdWx0X2V4cG9ydF9mCiAgIGVuZAogICByZXR1cm4gZGVlcG1hcChmdW4sIHZhbCkKZW5kCgpsb2NhbCBmdW5jdGlvbiB0aGVuX2luc2VydChkZXN0LCB2YWwsIGtleSkKICAgLS0gaW5pdGlhbGl6ZSBPVVQKICAgaWYgbm90IE9VVFtkZXN0XSB0aGVuCiAgICAgIGlmIEFDS1tkZXN0XSB0aGVuCgkgaWYgbHVhdHlwZShBQ0tbZGVzdF0pIH49ICd0YWJsZScgdGhlbgoJICAgIE9VVFtkZXN0XSA9IHsgQUNLW2Rlc3RdIH0KCSAgICB0YWJsZS5pbnNlcnQoT1VUW2Rlc3RdLCB2YWwpCgkgZWxzZWlmIGlzYXJyYXkoQUNLW2Rlc3RdKSB0aGVuCiAgICAgICAgT1VUW2Rlc3RdID0gZGVlcGNvcHkoQUNLW2Rlc3RdKQoJICAgIHRhYmxlLmluc2VydChPVVRbZGVzdF0sIHZhbCkKCSBlbHNlIC0tIGlzZGljdGlvbmFyeQogICAgICAgICBPVVRbZGVzdF0gPSBkZWVwY29weShBQ0tbZGVzdF0pCgkgICAgT1VUW2Rlc3RdW2tleV0gPSB2YWwKCSBlbmQKICAgICAgZWxzZSAtLSB1c2Ugb25seSB2YWwgYW5kIGtleQoJIE9VVFtkZXN0XSA9IHt9CgkgaWYga2V5IHRoZW4KCSAgICBPVVRbZGVzdF1ba2V5XSA9IHZhbAoJIGVsc2UKCSAgICB0YWJsZS5pbnNlcnQoT1VUW2Rlc3RdLCB2YWwpCgkgZW5kCiAgICAgIGVuZAogICBlbHNlIC0tIGxvYWQgT1VUCiAgICAgIGlmIGx1YXR5cGUoT1VUW2Rlc3RdKSB+PSAndGFibGUnIHRoZW4KCSAtLSBleHRlbmQgc3RyaW5nIHRvIGFycmF5CgkgbG9jYWwgdG1wID0gT1VUW2Rlc3RdCgkgT1VUW2Rlc3RdID0geyB0bXAgfQoJIHRhYmxlLmluc2VydChPVVRbZGVzdF0sIHZhbCkKICAgICAgZWxzZWlmIGlzYXJyYXkoT1VUW2Rlc3RdKSB0aGVuCgkgdGFibGUuaW5zZXJ0KE9VVFtkZXN0XSwgdmFsKQogICAgICBlbHNlIC0tIGlzZGljdGlvbmFyeQoJIGlmIG5vdCBrZXkgdGhlbgoJICAgIGVycm9yKGtleSwgJ1RoZW4gc3RhdGVtZW50IHRhcmdldHMgZGljdGlvbmFyeSB3aXRoIGVtcHR5IGtleTogJy4uZGVzdCwgMikKCSBlbmQKCSBPVVRbZGVzdF1ba2V5XSA9IHZhbAogICAgICBlbmQKICAgZW5kCmVuZAoKbG9jYWwgZnVuY3Rpb24gaXRlcmF0ZV9kYXRhKHQpCglsb2NhbCBhID0ge30KCWZvciBrLHYgaW4gbHVhX3BhaXJzKHQpIGRvCgkJaWYgayB+PSAna2V5cmluZycgdGhlbgoJCQl0YWJsZS5pbnNlcnQoYSwgbikKCQllbmQKCWVuZAoJbG9jYWwgaSA9IDAgICAgICAtLSBpdGVyYXRvciB2YXJpYWJsZQoJcmV0dXJuIGZ1bmN0aW9uICgpICAgLS0gaXRlcmF0b3IgZnVuY3Rpb24KCSAgIGkgPSBpICsgMQoJICAgcmV0dXJuIGFbaV0sIHRbYVtpXV0KCWVuZAplbmQKClRoZW4oIm5vdGhpbmciLCBmdW5jdGlvbigpIHJldHVybiBlbmQpIC0tIG5vcCB0byB0ZXJtaW5hdGUgaWYKClRoZW4oInByaW50IHN0cmluZyAnJyIsIGZ1bmN0aW9uKGspCglaRU46Y3J1bWIoKQoJaWYgbm90IE9VVC5vdXRwdXQgdGhlbgoJCU9VVC5vdXRwdXQgPSB7fQoJZW5kCgl0YWJsZS5pbnNlcnQoT1VULm91dHB1dCwgaykgLS0gcmF3IHN0cmluZyB2YWx1ZQplbmQpCgpUaGVuKCJwcmludCAnJyIsIGZ1bmN0aW9uKG5hbWUpCglsb2NhbCB2YWwgPSBoYXZlKG5hbWUpCglPVVRbbmFtZV0gPSB0aGVuX291dGNhc3QoIHZhbCwgbmFtZSApCmVuZCkKClRoZW4oInByaW50ICcnIGFzICcnIixmdW5jdGlvbihrLCBzKQoJbG9jYWwgdmFsID0gaGF2ZShrKQoJT1VUW2tdID0gdGhlbl9vdXRjYXN0KCB2YWwsIGssIHMgKQplbmQpCgpUaGVuKCJwcmludCBteSBuYW1lIGluICcnIixmdW5jdGlvbihkc3QpCgkJemVuY29kZV9hc3NlcnQoV0hPLCAnTm8gaWRlbnRpdHkgc3BlY2lmaWVkOiBwbGVhc2UgdXNlIEdpdmVuIEkgYW0nKQoJCXplbmNvZGVfYXNzZXJ0KG5vdCBPVVRbZHN0XSwgJ0Nhbm5vdCBvdmVyd3JpdGUgT1VULicuLmRzdCkKCQlPVVRbZHN0XSA9IFdITwplbmQpCgpUaGVuKCJwcmludCBteSAnJyIsZnVuY3Rpb24oaykKCUlhbSgpCglsb2NhbCB2YWwgPSBoYXZlKGspCgktLSBteSBzdGF0ZW1lbnRzIGFsd2F5cyBwcmludCB0byBhIGRpY3Rpb25hcnkgbmFtZWQgYWZ0ZXIgV0hPCglpZiBub3QgT1VUW1dIT10gdGhlbiBPVVRbV0hPXSA9IHsgfSBlbmQKCU9VVFtXSE9dW2tdID0gdGhlbl9vdXRjYXN0KCB2YWwsIGsgKQplbmQpCgpUaGVuKCJwcmludCBteSAnJyBhcyAnJyIsZnVuY3Rpb24oaywgcykKCUlhbSgpCglsb2NhbCB2YWwgPSBoYXZlKGspIC0tIHVzZSBhcnJheSB0byBjaGVjayBpbiBkZXB0aAoJaWYgayA9PSAna2V5cmluZycgb3IgcyA9PSAna2V5cmluZycgdGhlbgoJICAgT1VUW2tdID0gZXhwb3J0X2tleXJpbmcodmFsKQoJICAgd2FybigiREVQUkVDQVRFRDogVGhlbiBwcmludCAna2V5cmluZycgYXMgJy4uLiciKQoJICAgd2FybigiUGxlYXNlIHVzZTogVGhlbiBwcmludCBrZXlyaW5nIikKCWVsc2UKCSAgIHRoZW5faW5zZXJ0KCBXSE8sIHRoZW5fb3V0Y2FzdCggdmFsLCBrLCBzKSwgaykKCWVuZAplbmQpCgpUaGVuKCJwcmludCAnJyBmcm9tICcnIixmdW5jdGlvbihrLCBmKQoJbG9jYWwgdmFsID0gaGF2ZShmKQoJemVuY29kZV9hc3NlcnQodmFsW2tdLCAiT2JqZWN0OiAiLi5rLi4iLCBub3QgZm91bmQgaW4gIi4uZikKCS0tIGYgaXMgdXNlZCBpbiB0aGUgdGhlbl9vdXRjYXN0IHRvIHN1cHBvcnQgc2NoZW1hcwoJbG9jYWwgdG1wID0gdGhlbl9vdXRjYXN0KCB2YWwsIGYgKQoJT1VUW2tdID0gdG1wW2tdCmVuZCkKClRoZW4oInByaW50ICcnIGZyb20gJycgYXMgJyciLGZ1bmN0aW9uKGssIGYsIHMpCglsb2NhbCB2YWwgPSBoYXZlKHtmLGt9KSAtLSB1c2UgYXJyYXkgdG8gY2hlY2sgaW4gZGVwdGgKCU9VVFtrXSA9IHRoZW5fb3V0Y2FzdCggdmFsLCBrLCBzICkKZW5kKQoKVGhlbigicHJpbnQgJycgZnJvbSAnJyBhcyAnJyBpbiAnJyIsZnVuY3Rpb24oaywgZiwgcywgZCkKCWxvY2FsIHZhbCA9IGhhdmUoe2Ysa30pIC0tIHVzZSBhcnJheSB0byBjaGVjayBpbiBkZXB0aAoJdGhlbl9pbnNlcnQoIGQsIHRoZW5fb3V0Y2FzdCggdmFsLCBrLCBzICksIGspCmVuZCkKClRoZW4oInByaW50ICcnIGFzICcnIGluICcnIixmdW5jdGlvbihrLCBzLCBkKQoJbG9jYWwgdmFsID0gaGF2ZShrKSAtLSB1c2UgYXJyYXkgdG8gY2hlY2sgaW4gZGVwdGgKCXRoZW5faW5zZXJ0KCBkLCB0aGVuX291dGNhc3QoIHZhbCwgaywgcyApLCBrKQplbmQpCgpUaGVuKCJwcmludCBteSAnJyBmcm9tICcnIGFzICcnIixmdW5jdGlvbihrLCBmLCBzKQoJSWFtKCkKCWxvY2FsIHZhbCA9IGhhdmUoe2Ysa30pIC0tIHVzZSBhcnJheSB0byBjaGVjayBpbiBkZXB0aAoJdGhlbl9pbnNlcnQoIFdITywgdGhlbl9vdXRjYXN0KCB2YWwsIGssIHMgKSwgaykKZW5kKQoKVGhlbigicHJpbnQgbXkgJycgZnJvbSAnJyIsZnVuY3Rpb24oaywgZikKCUlhbSgpCglsb2NhbCB2YWwgPSBoYXZlKGYpCglsb2NhbCBjb2RlYyA9IENPREVDW2ZdCgl6ZW5jb2RlX2Fzc2VydCh2YWxba10sICJPYmplY3Q6ICIuLmsuLiIsIG5vdCBmb3VuIGluICIuLmYpCgktLSBteSBzdGF0ZW1lbnRzIGFsd2F5cyBwcmludCB0byBhIGRpY3Rpb25hcnkgbmFtZWQgYWZ0ZXIgV0hPCglpZiBub3QgT1VUW1dIT10gdGhlbiBPVVRbV0hPXSA9IHsgfSBlbmQKCU9VVFtXSE9dW2tdID0gdGhlbl9vdXRjYXN0KCB2YWwsIGssIGNvZGVjLmVuY29kaW5nIClba10KZW5kKQoKVGhlbigicHJpbnQga2V5cmluZyIsZnVuY3Rpb24oKQoJbG9jYWwgdmFsID0gaGF2ZSdrZXlyaW5nJwoJT1VULmtleXJpbmcgPSBaRU4uc2NoZW1hc1sna2V5cmluZyddLmV4cG9ydCh2YWwpCmVuZCkKVGhlbigicHJpbnQgbXkga2V5cmluZyIsZnVuY3Rpb24oKQoJSWFtKCkKCWxvY2FsIHZhbCA9IGhhdmUna2V5cmluZycKCU9VVFtXSE9dID0geyBrZXlyaW5nID0gWkVOLnNjaGVtYXNbJ2tleXJpbmcnXS5leHBvcnQodmFsKSB9CmVuZCkKCi0tIGRhdGEKLS0gZGF0YSBhcwotLSBkYXRhIGZyb20KLS0gZGF0YSBmcm9tIGFzCi0tIG15IGRhdGEKLS0gbXkgZGF0YSBhcwotLSBteSBkYXRhIGZyb20KLS0gbXkgZGF0YSBmcm9tIGFzCgpUaGVuKCJwcmludCBkYXRhIixmdW5jdGlvbigpCglmb3IgaywgdiBpbiBwYWlycyhBQ0spIGRvCgkgICBpZiBrIH49ICdrZXlyaW5nJyB0aGVuCgkgICAgICBPVVRba10gPSB0aGVuX291dGNhc3QodiwgaykKCSAgIGVuZAoJZW5kCmVuZAopCgpUaGVuKCJwcmludCBkYXRhIGFzICcnIixmdW5jdGlvbihlKQoJbG9jYWwgZnVuCglmb3IgaywgdiBpbiBwYWlycyhBQ0spIGRvCgkgICBpZiBrIH49ICdrZXlyaW5nJyB0aGVuCgkgICAgICBPVVRba10gPSB0aGVuX291dGNhc3QodiwgaywgZSkKCSAgIGVuZAoJZW5kCmVuZAopCgpUaGVuKCJwcmludCBkYXRhIGZyb20gJyciLCBmdW5jdGlvbihzcmMpCglsb2NhbCBvYmogPSBoYXZlKHNyYykKCWxvY2FsIGNvZGVjID0gQ09ERUNbc3JjXQoJZm9yIGssdiBpbiBwYWlycyhvYmopIGRvCgkgICBpZiBrIH49ICdrZXlyaW5nJyB0aGVuCgkgICAgICBPVVRba10gPSB0aGVuX291dGNhc3QoIHYsIGssIGNvZGVjLmVuY29kaW5nKQoJICAgZW5kCgllbmQKZW5kKQoKVGhlbigicHJpbnQgZGF0YSBmcm9tICcnIGFzICcnIiwgZnVuY3Rpb24oc3JjLCBlKQoJbG9jYWwgb2JqID0gaGF2ZShzcmMpCglmb3Igayx2IGluIHBhaXJzKG9iaikgZG8KCSAgIGlmIGsgfj0gJ2tleXJpbmcnIHRoZW4KCSAgICAgIE9VVFtrXSA9IHRoZW5fb3V0Y2FzdCggdiwgaywgZSApCgkgICBlbmQKCWVuZAplbmQpCgpUaGVuKCJwcmludCBteSBkYXRhIixmdW5jdGlvbigpCglJYW0oKSAtLSBzYW5pdHkgY2hlY2tzCglPVVRbV0hPXSA9IHsgfQoJZm9yIGssIHYgaW4gcGFpcnMoQUNLKSBkbwoJICAgaWYgayB+PSAna2V5cmluZycgdGhlbgoJICAgICAgT1VUW1dIT11ba10gPSB0aGVuX291dGNhc3QoIHYsIGsgKQoJICAgZW5kCgllbmQKZW5kKQpUaGVuKCJwcmludCBteSBkYXRhIGFzICcnIixmdW5jdGlvbihlKQoJSWFtKCkgLS0gc2FuaXR5IGNoZWNrcwoJT1VUW1dIT10gPSB7IH0KCWZvciBrLCB2IGluIHBhaXJzKEFDSykgZG8KCSAgIGlmIGsgfj0gJ2tleXJpbmcnIHRoZW4KCSAgICAgIE9VVFtXSE9dW2tdID0gdGhlbl9vdXRjYXN0KCB2LCBrLCBlICkKCSAgIGVuZAoJZW5kCmVuZAopCgpUaGVuKCJwcmludCBteSBkYXRhIGZyb20gJyciLGZ1bmN0aW9uKHNyYykKCUlhbSgpIC0tIHNhbml0eSBjaGVja3MKCU9VVFtXSE9dID0geyB9Cglsb2NhbCBvYmogPSBoYXZlKHNyYykKCWxvY2FsIGNvZGVjID0gQ09ERUNbc3JjXQoJZm9yIGssIHYgaW4gcGFpcnMob2JqKSBkbwoJICAgaWYgayB+PSAna2V5cmluZycgdGhlbgoJICAgICAgT1VUW1dIT11ba10gPSB0aGVuX291dGNhc3QoIHYsIGssIGNvZGVjLmVuY29kaW5nICkKCSAgIGVuZAoJZW5kCmVuZAopClRoZW4oInByaW50IG15IGRhdGEgZnJvbSAnJyBhcyAnJyIsZnVuY3Rpb24oc3JjLCBlKQoJSWFtKCkgLS0gc2FuaXR5IGNoZWNrcwoJT1VUW1dIT10gPSB7IH0KCWxvY2FsIG9iaiA9IGhhdmUoc3JjKQoJbG9jYWwgY29kZWMgPSBDT0RFQ1tzcmNdCglmb3IgaywgdiBpbiBwYWlycyhvYmopIGRvCgkgICBpZiBrIH49ICdrZXlyaW5nJyB0aGVuCgkgICAgICBPVVRbV0hPXVtrXSA9IHRoZW5fb3V0Y2FzdCggdiwgaywgY29kZWMuZW5jb2RpbmcgKQoJICAgZW5kCgllbmQKZW5kCikKClRoZW4oInByaW50IG9iamVjdCBuYW1lZCBieSAnJyIsIGZ1bmN0aW9uKG5hbWUpCglsb2NhbCByZWFsX25hbWUgPSBoYXZlKG5hbWUpOnN0cmluZygpCglsb2NhbCB2YWwgPSBoYXZlKHJlYWxfbmFtZSkKCWlmIHJlYWxfbmFtZSB+PSAna2V5cmluZycgdGhlbgoJICAgT1VUW3JlYWxfbmFtZV0gPSB0aGVuX291dGNhc3QoIHZhbCwgcmVhbF9uYW1lICkKCWVuZAplbmQpCgpUaGVuKCJlbmNvZGUgZGljdGlvbmFyeSBwYXRoICcnIGFzICcnIiwgZnVuY3Rpb24ocGF0aCwgZW5jKQogICAgICAgICBsb2NhbCBwYXRoX2FycmF5ID0gc3RydG9rKHVzY29yZShwYXRoKSwgQ09ORi5wYXRoLnNlcGFyYXRvcikKICAgICAgICAgbG9jYWwgcm9vdCA8Y29uc3Q+ID0gcGF0aF9hcnJheVsxXQogICAgICAgICB0YWJsZS5yZW1vdmUocGF0aF9hcnJheSwxKQogICAgICAgICAgaWYgbm90IENPREVDW3Jvb3RdIHRoZW4KICAgICAgICAgICAgICBlcnJvcigiRGljdGlvbmFyeSBub3QgZm91bmQ6ICIuLnJvb3QpCiAgICAgICAgICBlbmQKICAgICAgICAgIGlmIENPREVDW3Jvb3RdLnplbnR5cGUgfj0gJ2QnIHRoZW4KICAgICAgICAgICAgICBJLndhcm4oQ09ERUNbcm9vdF0pCiAgICAgICAgICAgICAgZXJyb3IoIk5vdCBhIGRpY3Rpb25hcnk6ICIuLnJvb3QpCiAgICAgICAgICBlbmQKICAgICAgICAgIGlmIG5vdCBDT0RFQ1tyb290XS5tYXNrIHRoZW4gQ09ERUNbcm9vdF0ubWFzayA9IHsgfSBlbmQKICAgICAgICAgIGRlZXBtYXNrX3NldChDT0RFQ1tyb290XS5tYXNrLCBwYXRoX2FycmF5LCBlbmMpCmVuZCkKL3plbmNvZGVfdGltZS5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMjEtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBNYXR0ZW8gQ3Jpc3Rpbm8KLS1vbiBUaHVyc2RheSwgMjl0aCBGZWJydWFyeSAyMDI0Ci0tXV0KCmxvY2FsIGZ1bmN0aW9uIGltcG9ydF9kYXRlX3RhYmxlKG9iaikKICAgIGxvY2FsIHJlcyA9IHt9CiAgICByZXMueWVhciA9IFRJTUUubmV3KG9iai55ZWFyIG9yIDApCiAgICByZXMubW9udGggPSBUSU1FLm5ldyhvYmoubW9udGggb3IgMCkKICAgIHJlcy5kYXkgPSBUSU1FLm5ldyhvYmouZGF5IG9yIDApCiAgICByZXMuaG91ciA9IFRJTUUubmV3KG9iai5ob3VyIG9yIDApCiAgICByZXMubWluID0gVElNRS5uZXcob2JqLm1pbiBvciAwKQogICAgcmVzLnNlYyA9IFRJTUUubmV3KG9iai5zZWMgb3IgMCkKICAgIHJlcy5pc2RzdCA9IG9iai5pc2RzdCBvciBmYWxzZQogICAgcmV0dXJuIHJlcwplbmQKCmxvY2FsIGZ1bmN0aW9uIGV4cG9ydF9kYXRlX3RhYmxlKG9iaikKICAgIGlmIHR5cGUob2JqKSA9PSAnemVucm9vbS50aW1lJyB0aGVuCiAgICAgICAgcmV0dXJuIG9zLmRhdGUoIip0IiwgdG9udW1iZXIob2JqKSkKICAgIGVuZAogICAgbG9jYWwgcmVzID0ge30KICAgIHJlcy55ZWFyID0gdG9udW1iZXIob2JqLnllYXIpCiAgICByZXMubW9udGggPSB0b251bWJlcihvYmoubW9udGgpCiAgICByZXMuZGF5ID0gdG9udW1iZXIob2JqLmRheSkKICAgIHJlcy5ob3VyID0gdG9udW1iZXIob2JqLmhvdXIpCiAgICByZXMubWluID0gdG9udW1iZXIob2JqLm1pbikKICAgIHJlcy5zZWMgPSB0b251bWJlcihvYmouc2VjKQogICAgcmVzLmlzZHN0ID0gb2JqLmlzZHN0CiAgICByZXR1cm4gcmVzCmVuZAoKWkVOOmFkZF9zY2hlbWEoCiAgICB7CiAgICAgICAgZGF0ZV90YWJsZSA9IHsKICAgICAgICAgICAgaW1wb3J0ID0gaW1wb3J0X2RhdGVfdGFibGUsCiAgICAgICAgICAgIGV4cG9ydCA9IGV4cG9ydF9kYXRlX3RhYmxlCiAgICAgICAgfQogICAgfQopCgpXaGVuKCJjcmVhdGUgdGltZXN0YW1wIiwgZnVuY3Rpb24oKQogICAgemVuY29kZV9hc3NlcnQob3MsICdDb3VsZCBub3QgZmluZCBvcycpCiAgICBBQ0sudGltZXN0YW1wID0gVElNRS5uZXcob3MudGltZSgpKQogICAgbmV3X2NvZGVjKCd0aW1lc3RhbXAnLCB7IHplbnR5cGUgPSAnZScsIGVuY29kaW5nID0gJ3RpbWUnfSkKZW5kKQoKV2hlbigiY3JlYXRlIGludGVnZXIgJycgY2FzdCBvZiB0aW1lc3RhbXAgJyciLCBmdW5jdGlvbihkZXN0LCBzb3VyY2UpCiAgICBlbXB0eShkZXN0KQogICAgbG9jYWwgc3JjID0gaGF2ZShzb3VyY2UpCiAgICBpZiB0eXBlKHNyYykgfj0gJ3plbnJvb20udGltZScgdGhlbgogICAgICAgIHNyYyA9IFRJTUUubmV3KHNyYykKICAgIGVuZAogICAgQUNLW2Rlc3RdID0gQklHLmZyb21fZGVjaW1hbCh0b3N0cmluZyhzcmMpKQogICAgbmV3X2NvZGVjKGRlc3QsIHsgemVudHlwZSA9ICdlJywgZW5jb2RpbmcgPSAnaW50ZWdlcid9KQplbmQpCgpXaGVuKCJjcmVhdGUgdGltZXN0YW1wIG9mIGRhdGUgdGFibGUgJyciLCBmdW5jdGlvbihkdCkKICAgIHplbmNvZGVfYXNzZXJ0KG9zLCAnQ291bGQgbm90IGZpbmQgb3MnKQogICAgbG9jYWwgZGF0ZV90YWJsZSwgZGF0ZV90YWJsZV9jb2RlYyA9IGhhdmUoZHQpCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgICBkYXRlX3RhYmxlX2NvZGVjLmVuY29kaW5nID09ICdjb21wbGV4JyBhbmQgZGF0ZV90YWJsZV9jb2RlYy5zY2hlbWEgPT0gJ2RhdGVfdGFibGUnLAogICAgICAgICdJbnZhbGlkIGRhdGUgdGFibGUgZW5jb2Rpbmc6ICcgLi4gZGF0ZV90YWJsZV9jb2RlYy5zY2hlbWEpCiAgICB6ZW5jb2RlX2Fzc2VydChkYXRlX3RhYmxlLnllYXIgPj0gVElNRS5uZXcoMTk3MCksCiAgICAgICAgJ0RhdGUgdGFibGUgJyAuLiBkdCAuLiAnIGNhbiBub3QgYmUgY29udmVydGVkIHRvIHRpbWVzdGFtcCwgJyAuLiB0b3N0cmluZyhkYXRlX3RhYmxlLnllYXIpIC4uICcgPCAxOTcwJykKICAgIGxvY2FsIHQgPSBvcy50aW1lKGV4cG9ydF9kYXRlX3RhYmxlKGRhdGVfdGFibGUpKQogICAgQUNLLnRpbWVzdGFtcCA9IFRJTUUubmV3KHQpCiAgICBuZXdfY29kZWMoJ3RpbWVzdGFtcCcsIHsgemVudHlwZSA9ICdlJywgZW5jb2RpbmcgPSAndGltZSd9KQplbmQpCgpXaGVuKCJjcmVhdGUgZGF0ZSB0YWJsZSBvZiB0aW1lc3RhbXAgJyciLCBmdW5jdGlvbih0KQogICAgemVuY29kZV9hc3NlcnQob3MsICdDb3VsZCBub3QgZmluZCBvcycpCiAgICBsb2NhbCB0aW1lc3RhbXAsIHRpbWVzdGFtcF9jb2RlYyA9IGhhdmUodCkKICAgIHplbmNvZGVfYXNzZXJ0KHRpbWVzdGFtcF9jb2RlYy5lbmNvZGluZyA9PSAndGltZScsCiAgICAgICAgJ0ludmFsaWQgdGltZSBlbmNvZGluZzogJyAuLiB0aW1lc3RhbXBfY29kZWMuZW5jb2RpbmcpCiAgICBBQ0suZGF0ZV90YWJsZSA9IGltcG9ydF9kYXRlX3RhYmxlKG9zLmRhdGUoIip0IiwgdG9udW1iZXIodGltZXN0YW1wKSkpCiAgICBuZXdfY29kZWMoJ2RhdGVfdGFibGUnLCB7IHplbnR5cGUgPSAnZScsIGVuY29kaW5nID0gJ2NvbXBsZXgnLCBzY2hlbWEgPSAnZGF0ZV90YWJsZSd9KQplbmQpCgpsb2NhbCBmdW5jdGlvbiBfdGltZXN0YW1wMlVUQyh0X25hbWUsIGRlc3QpCiAgICB6ZW5jb2RlX2Fzc2VydChvcywgJ0NvdWxkIG5vdCBmaW5kIG9zJykKICAgIGxvY2FsIGQgPGNvbnN0PiA9IGRlc3Qgb3IgJ1VUQ190aW1lc3RhbXAnCiAgICBlbXB0eShkKQogICAgbG9jYWwgdCA8Y29uc3Q+ID0gdG9udW1iZXIoKHRfbmFtZSBhbmQgaGF2ZSh0X25hbWUpKSBvciBvcy50aW1lKG9zLmRhdGUoIiEqdCIpKSkKICAgIGlmIHRfbmFtZSBhbmQgQ09ERUNbdF9uYW1lXSBhbmQgQ09ERUNbdF9uYW1lXS5lbmNvZGluZyB+PSAndGltZScgdGhlbgogICAgICAgIGVycm9yKCdJbnZhbGlkIHRpbWUgZW5jb2Rpbmc6ICcgLi4gdGltZXN0YW1wX2NvZGVjLmVuY29kaW5nLCAyKQogICAgZW5kCiAgICBBQ0tbZF0gPSBPLmZyb21fc3RyaW5nKG9zLmRhdGUoIiElWS0lbS0lZFQlSDolTTolU1oiLCB0KSkKICAgIG5ld19jb2RlYyhkLCB7IHplbnR5cGUgPSAnZScsIGVuY29kaW5nID0gJ3N0cmluZyd9KQplbmQKCldoZW4oImNyZWF0ZSBVVEMgdGltZXN0YW1wIG9mIG5vdyIsIF90aW1lc3RhbXAyVVRDKQpXaGVuKCJjcmVhdGUgVVRDIHRpbWVzdGFtcCBvZiAnJyIsIF90aW1lc3RhbXAyVVRDKQpXaGVuKCJjcmVhdGUgWlVMVSB0aW1lc3RhbXAgb2Ygbm93IiwgZnVuY3Rpb24oKSBfdGltZXN0YW1wMlVUQyhuaWwsICdaVUxVX3RpbWVzdGFtcCcpIGVuZCkKV2hlbigiY3JlYXRlIFpVTFUgdGltZXN0YW1wIG9mICcnIiwgZnVuY3Rpb24odF9uYW1lKSBfdGltZXN0YW1wMlVUQyh0X25hbWUsICdaVUxVX3RpbWVzdGFtcCcpIGVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9VVEMydGltZXN0YW1wKHRfbmFtZSkKICAgIGlmIG5vdCBvcyB0aGVuIGVycm9yKCdDb3VsZCBub3QgZmluZCBvcycsIDIpIGVuZAogICAgbG9jYWwgdXRjX3RpbWVzdGFtcCwgdXRjX3RpbWVzdGFtcF9jb2RlYyA8Y29uc3Q+ID0gaGF2ZSh0X25hbWUpCiAgICBpZiB1dGNfdGltZXN0YW1wX2NvZGVjLmVuY29kaW5nIH49ICdzdHJpbmcnIHRoZW4KICAgICAgICBlcnJvcignSW52YWxpZCBVVEMgdGltZXN0YW1wIGVuY29kaW5nOiAnIC4uIHV0Y190aW1lc3RhbXBfY29kZWMuZW5jb2RpbmcsIDIpCiAgICBlbmQKICAgIGxvY2FsIHllYXIsIG1vbnRoLCBkYXksIGhvdXIsIG1pbiwgc2VjIDxjb25zdD4gPSB1dGNfdGltZXN0YW1wOnN0cmluZygpOm1hdGNoKCIoJWQrKSUtKCVkKyklLSglZCspVCglZCspOiglZCspOiglZCspWiIpCiAgICBsb2NhbCB1dGNfdGFibGUgPGNvbnN0PiA9IHsKICAgICAgICB5ZWFyID0gdG9udW1iZXIoeWVhciksCiAgICAgICAgbW9udGggPSB0b251bWJlcihtb250aCksCiAgICAgICAgZGF5ID0gdG9udW1iZXIoZGF5KSwKICAgICAgICBob3VyID0gdG9udW1iZXIoaG91ciksCiAgICAgICAgbWluID0gdG9udW1iZXIobWluKSwKICAgICAgICBzZWMgPSB0b251bWJlcihzZWMpLAogICAgICAgIGlzZHN0ID0gZmFsc2UKICAgIH0KICAgIGxvY2FsIG9mZnNldCA8Y29uc3Q+ID0gbWF0aC5mbG9vcihvcy5kaWZmdGltZShvcy50aW1lKCksIG9zLnRpbWUob3MuZGF0ZSgiISp0IikpKSkKICAgIEFDSy50aW1lc3RhbXAgPSBUSU1FLm5ldyhvcy50aW1lKHV0Y190YWJsZSkgKyBvZmZzZXQpCiAgICBuZXdfY29kZWMoJ3RpbWVzdGFtcCcsIHsgemVudHlwZSA9ICdlJywgZW5jb2RpbmcgPSAndGltZSd9KQplbmQKCldoZW4oImNyZWF0ZSB0aW1lc3RhbXAgb2YgVVRDIHRpbWVzdGFtcCAnJyIsIF9VVEMydGltZXN0YW1wKQpXaGVuKCJjcmVhdGUgdGltZXN0YW1wIG9mIFpVTFUgdGltZXN0YW1wICcnIiwgX1VUQzJ0aW1lc3RhbXApCi96ZW5jb2RlX3ZjLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IE1hdHRlbyBDcmlzdGlubwotLW9uIFRodXJzZGF5LCAyNnRoIFNlcHRlbWJlciAyMDI0Ci0tXV0KCi0tIGxvY2FsIFczQyA9IHJlcXVpcmVfb25jZSAiY3J5cHRvX3czYyIKCmxvY2FsIEVUSEVSRVVNX0FERFJFU1MgPSAiZXRoZXJldW1fYWRkcmVzcyIKbG9jYWwgRUREU0FfUFVCTElDX0tFWSA9ICJlZGRzYV9wdWJsaWNfa2V5IgoKbG9jYWwgZnVuY3Rpb24gaW1wb3J0X3ZlcmlmaWNhdGlvbl9tZXRob2QoZG9jKQogICAgbG9jYWwgcmVzID0ge30KICAgIGxvY2FsIGltcG9ydF9mdW5jdGlvbnMgPSB7CiAgICAgICAgW0VUSEVSRVVNX0FERFJFU1NdID0gTy5mcm9tX2hleCwKICAgICAgICBbRUREU0FfUFVCTElDX0tFWV0gPSBPLmZyb21fYmFzZTU4CiAgICB9CiAgICBmb3Iga2V5LCBfIGluIHBhaXJzKGRvYykgZG8KICAgICAgICByZXNba2V5XSA9IHNjaGVtYV9nZXQoZG9jW2tleV0sICcuJywKICAgICAgICAgICAgICAgICAgICAgICAgICAgaW1wb3J0X2Z1bmN0aW9uc1trZXldIG9yIE8uZnJvbV9iYXNlNjQsCiAgICAgICAgICAgICAgICAgICAgICAgICAgIHRvc3RyaW5nKQogICAgZW5kCiAgICByZXR1cm4gcmVzCmVuZAoKbG9jYWwgZnVuY3Rpb24gZXhwb3J0X3ZlcmlmaWNhdGlvbl9tZXRob2QoZG9jKQogICAgbG9jYWwgcmVzID0ge30KICAgIGxvY2FsIGV4cG9ydF9mdW5jdGlvbnMgPSB7CiAgICAgICAgW0VUSEVSRVVNX0FERFJFU1NdID0gTy50b19oZXgsCiAgICAgICAgW0VERFNBX1BVQkxJQ19LRVldID0gTy50b19iYXNlNTgKICAgIH0KICAgIGZvciBrZXksIHZlcl9tZXRob2QgaW4gcGFpcnMoZG9jKSBkbwogICAgICAgIHJlc1trZXldID0gKGV4cG9ydF9mdW5jdGlvbnNba2V5XSBvciBPLnRvX2Jhc2U2NCkodmVyX21ldGhvZCkKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKClpFTjphZGRfc2NoZW1hKAogICAgewogICAgICAgIHZlcmlmaWNhdGlvbl9tZXRob2QgPSB7CiAgICAgICAgICAgIGltcG9ydCA9IGltcG9ydF92ZXJpZmljYXRpb25fbWV0aG9kLAoJCQlleHBvcnQgPSBleHBvcnRfdmVyaWZpY2F0aW9uX21ldGhvZAogICAgICAgIH0sCiAgICAgICAgdmVyaWZpYWJsZV9jcmVkZW50aWFsID0gZnVuY3Rpb24ob2JqKQogICAgICAgICAgICByZXR1cm4gc2NoZW1hX2dldChvYmosICcuJywgTy5mcm9tX3N0cmluZywgdG9zdHJpbmcpCiAgICAgICAgZW5kLAogICAgICAgIAogICAgfQopCgpXaGVuKCJzZXQgdmVyaWZpY2F0aW9uIG1ldGhvZCBpbiAnJyB0byAnJyIsIGZ1bmN0aW9uKHZjLCBtZXRoKQogICAgbG9jYWwgY3JlZCA9IGhhdmUodmMpCiAgICB6ZW5jb2RlX2Fzc2VydChjcmVkLnByb29mLCAnVGhlIG9iamVjdCBpcyBub3Qgc2lnbmVkOiAnIC4uIHZjKQogICAgbG9jYWwgbSA9IGhhdmUobWV0aCkKICAgIEFDS1t2Y10ucHJvb2YudmVyaWZpY2F0aW9uTWV0aG9kID0gbQplbmQpCgpXaGVuKCJnZXQgdmVyaWZpY2F0aW9uIG1ldGhvZCBpbiAnJyIsIGZ1bmN0aW9uKHZjKQogICAgZW1wdHkgJ3ZlcmlmaWNhdGlvbl9tZXRob2QnCiAgICBsb2NhbCBjcmVkID0gaGF2ZSh2YykKICAgIHplbmNvZGVfYXNzZXJ0KGNyZWQucHJvb2YsICdUaGUgb2JqZWN0IGlzIG5vdCBzaWduZWQ6ICcgLi4gdmMpCiAgICBBQ0sudmVyaWZpY2F0aW9uX21ldGhvZCA9IGNyZWQucHJvb2YudmVyaWZpY2F0aW9uTWV0aG9kCiAgICBuZXdfY29kZWMoJ3ZlcmlmaWNhdGlvbl9tZXRob2QnKQplbmQpCgpXaGVuKCJzaWduIHZlcmlmaWFibGUgY3JlZGVudGlhbCBuYW1lZCAnJyIsIGZ1bmN0aW9uKHZjKQogICAgbG9jYWwgY3JlZGVudGlhbCA9IGhhdmUodmMpCiAgICB6ZW5jb2RlX2Fzc2VydChub3QgY3JlZGVudGlhbC5wcm9vZiwKICAgICAgICAgICAgICAgICAgICdUaGUgb2JqZWN0IGlzIGFscmVhZHkgc2lnbmVkOiAnIC4uIHZjKQogICAgQUNLW3ZjXS5wcm9vZiA9IHsKICAgICAgICBbJ3R5cGUnXSA9IE8uZnJvbV9zdHJpbmcoJ1plbnJvb20gJy4uX0cuWkVOUk9PTV9WRVJTSU9OLm9yaWdpbmFsKSwKICAgICAgICAtLSAiU2lnbmF0dXJlIiwgLS0gVE9ETzogY2hlY2sgd2hhdCB0byB3cml0ZSBoZXJlIGZvciBzZWNwMjU2azEKICAgICAgICAtLSBjcmVhdGVkID0gIjIwMTgtMDYtMThUMjE6MTk6MTBaIiwKCiAgICAgICAgLS0gY3JlYXRlIGEgSldTIGRldGFjaGVkIHNpZ25hdHVyZSBvZiB0aGUgcGF5bG9hZCwgZGVmYXVsdCBhbGcKICAgICAgICBqd3MgPSBKT1NFLmNyZWF0ZV9qd3MoZmFsc2UsIG5pbCwgY3JlZGVudGlhbCwgdHJ1ZSksCiAgICAgICAgcHJvb2ZQdXJwb3NlID0gTy5mcm9tX3N0cmluZydhdXRoZW50aWNhdGUnIC0tIGFzc2VydGlvbk1ldGhvZCIsIC0tIFRPRE86IGNoZWNrCiAgICB9CmVuZCkKCklmV2hlbigidmVyaWZ5IHZlcmlmaWFibGUgY3JlZGVudGlhbCBuYW1lZCAnJyIsIGZ1bmN0aW9uKHNyYykKICAgIGxvY2FsIGRvY3VtZW50ID0gaGF2ZShzcmMpCiAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoZG9jdW1lbnQucHJvb2YgYW5kIGRvY3VtZW50LnByb29mLmp3cywKICAgICAgICAnVGhlIG9iamVjdCBoYXMgbm8gc2lnbmF0dXJlOiAnIC4uIHNyYykgdGhlbiByZXR1cm4gZW5kCiAgICBsb2NhbCBwcm9vZiA8Y29uc3Q+ID0gZG9jdW1lbnQucHJvb2YKICAgIGRvY3VtZW50LnByb29mID0gbmlsCiAgICBsb2NhbCBqd3MgPGNvbnN0PiA9IEpPU0UucGFyc2VfandzKHByb29mLmp3cykKICAgIGlmIGp3cy5wYXlsb2FkIHRoZW4KICAgICAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoSlNPTi5zZXJpYWxpemUoZG9jdW1lbnQpID09IGp3cy5wYXlsb2FkX2VuYywKICAgICAgICAgICAgICAgICAgICAgICAiVGhlIEpXUyBwcm9vZiBjb250YWlucyBhIGRpZmZlcmVudCBwYXlsb2FkIikgdGhlbiByZXR1cm4gZW5kCiAgICBlbmQKICAgIGxvY2FsIGNyeXB0byAgPGNvbnN0PiA9IENSWVBUTy5sb2FkKGp3cy5oZWFkZXIuYWxnKQogICAgbG9jYWwgcGsgPSBtYXloYXZlKCdqd3NfcHVibGljX2tleScpCiAgICBpZiBub3QgcGsgdGhlbiBwayA9IGhhdmUoY3J5cHRvLmtleW5hbWUuLidfcHVibGljX2tleScpIGVuZAogICAgbG9jYWwgdG9fYmVfdmVyaWZpZWQgPGNvbnN0PiA9CiAgICAgICAgandzLmhlYWRlcl9lbmMuLk8uZnJvbV9zdHJpbmcoJy4nKS4uSlNPTi5zZXJpYWxpemUoZG9jdW1lbnQpCiAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoY3J5cHRvLnZlcmlmeShwaywgdG9fYmVfdmVyaWZpZWQsIGp3cy5zaWduYXR1cmUpLAogICAgICAgICAgICAgICAgICAgJ0ludmFsaWQgdmVyaWZpYWJsZSBjcmVkZW50aWFsIHNpZ25hdHVyZSBvZjogJy4uc3JjKSB0aGVuIHJldHVybiBlbmQKZW5kKQovemVuY29kZV92ZXJpZnkubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFN1bmRheSwgMTF0aCBKdWx5IDIwMjEKLS1dXQotLSBnZW5lcmljIGNvbXBhcmlzb24gdXNpbmcgb3ZlcmxvYWRlZCBfX2VxIG9uIHZhbHVlcwpsb2NhbCBmdW5jdGlvbiBfZXEobGVmdCwgcmlnaHQpCiAgaWYgKGx1YXR5cGUobGVmdCkgPT0gJ251bWJlcicgYW5kIGx1YXR5cGUocmlnaHQpID09ICdudW1iZXInKQogICAgICBvciAodHlwZShsZWZ0KSA9PSAnemVucm9vbS5mbG9hdCcgYW5kIHR5cGUocmlnaHQpID09ICd6ZW5yb29tLmZsb2F0JykKICAgICAgb3IgKHR5cGUobGVmdCkgPT0gJ3plbnJvb20uYmlnJyBhbmQgdHlwZShyaWdodCkgPT0gJ3plbnJvb20uYmlnJykKICAgICAgb3IgKHR5cGUobGVmdCkgPT0gJ3plbnJvb20udGltZScgYW5kIHR5cGUocmlnaHQpID09ICd6ZW5yb29tLnRpbWUnKSB0aGVuCiAgICByZXR1cm4gKGxlZnQgPT0gcmlnaHQpCiAgZWxzZWlmIGx1YXR5cGUobGVmdCkgPT0gJ3RhYmxlJyBhbmQgbHVhdHlwZShyaWdodCkgPT0gJ3RhYmxlJyB0aGVuCiAgICAgaWYoI2xlZnQgfj0gI3JpZ2h0KSB0aGVuIHJldHVybiBmYWxzZSBlbmQgLS0gb3B0aW1pemF0aW9uCiAgICAgcmV0dXJuICh6ZW5jb2RlX3NlcmlhbGl6ZShsZWZ0KSA9PSB6ZW5jb2RlX3NlcmlhbGl6ZShyaWdodCkpCiAgZWxzZWlmIGlzemVuKHR5cGUobGVmdCkpIGFuZCBpc3plbih0eXBlKHJpZ2h0KSkgdGhlbgogICAgIHJldHVybiAobGVmdDpvY3RldCgpID09IHJpZ2h0Om9jdGV0KCkpCiAgZWxzZQogICAgIGVycm9yKCJDb21wYXJpc29uIGJldHdlZW4gaW5jb21wYXRpYmxlIHR5cGVzOiAiCgkgICAuLnR5cGUobGVmdCkuLiIgYW5kICIuLnR5cGUocmlnaHQpLCAyKQogIGVuZAplbmQKbG9jYWwgZnVuY3Rpb24gX25lcShsZWZ0LCByaWdodCkKICBpZiBsdWF0eXBlKGxlZnQpID09ICdudW1iZXInIGFuZCBsdWF0eXBlKHJpZ2h0KSA9PSAnbnVtYmVyJyB0aGVuCiAgICByZXR1cm4gKGxlZnQgfj0gcmlnaHQpCiAgZWxzZWlmICh0eXBlKGxlZnQpID09ICd6ZW5yb29tLmZsb2F0JyBhbmQgdHlwZShyaWdodCkgPT0gJ3plbnJvb20uZmxvYXQnKQogICAgICBvciAodHlwZShsZWZ0KSA9PSAnemVucm9vbS5iaWcnIGFuZCB0eXBlKHJpZ2h0KSA9PSAnemVucm9vbS5iaWcnKQogICAgICBvciAodHlwZShsZWZ0KSA9PSAnemVucm9vbS50aW1lJyBhbmQgdHlwZShyaWdodCkgPT0gJ3plbnJvb20udGltZScpIHRoZW4KICAgIHJldHVybiBub3QgKGxlZnQgPT0gcmlnaHQpCiAgZWxzZWlmIGx1YXR5cGUobGVmdCkgPT0gJ3RhYmxlJyBhbmQgbHVhdHlwZShyaWdodCkgPT0gJ3RhYmxlJyB0aGVuCiAgICAgaWYoI2xlZnQgfj0gI3JpZ2h0KSB0aGVuIHJldHVybiB0cnVlIGVuZCAtLSBvcHRpbWl6YXRpb24KICAgICByZXR1cm4gKHplbmNvZGVfc2VyaWFsaXplKGxlZnQpIH49IHplbmNvZGVfc2VyaWFsaXplKHJpZ2h0KSkKICBlbHNlaWYgaXN6ZW4odHlwZShsZWZ0KSkgYW5kIGlzemVuKHR5cGUocmlnaHQpKSB0aGVuCiAgICAgcmV0dXJuIChsZWZ0Om9jdGV0KCkgfj0gcmlnaHQ6b2N0ZXQoKSkKICBlbHNlCiAgICAgZXJyb3IoIkNvbXBhcmlzb24gYmV0d2VlbiBpbmNvbXBhdGlibGUgdHlwZXM6ICIKCSAgIC4udHlwZShsZWZ0KS4uIiBhbmQgIi4udHlwZShyaWdodCksIDIpCiAgZW5kCmVuZAoKSWZXaGVuKCJ2ZXJpZnkgJycgaXMgZXF1YWwgdG8gJyciLGZ1bmN0aW9uKGwsIHIpCiAgICBsb2NhbCBsZWZ0ID0gaGF2ZShsKQogICAgbG9jYWwgcmlnaHQgPSBoYXZlKHIpCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgX2VxKGxlZnQsIHJpZ2h0KSwKICAgICAgJ1ZlcmlmaWNhdGlvbiBmYWlsOiBlbGVtZW50cyBhcmUgbm90IGVxdWFsOiAnIC4uIGwgLi4gJyA9PSAnIC4uIHIKICAgICkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgJycgaXMgbm90IGVxdWFsIHRvICcnIixmdW5jdGlvbihsLCByKQogICAgbG9jYWwgbGVmdCA9IGhhdmUobCkKICAgIGxvY2FsIHJpZ2h0ID0gaGF2ZShyKQogICAgemVuY29kZV9hc3NlcnQoCiAgICAgIF9uZXEobGVmdCwgcmlnaHQpLAogICAgICAnVmVyaWZpY2F0aW9uIGZhaWw6IGVsZW1lbnRzIGFyZSBlcXVhbDogJyAuLiBsIC4uICcgPT0gJyAuLiByCiAgICApCmVuZCkKCi0tIGNvbXBhcmlzb24gaW5zaWRlIGRpY3Rpb25hcnkKSWZXaGVuKCJ2ZXJpZnkgJycgaXMgZXF1YWwgdG8gJycgaW4gJyciLGZ1bmN0aW9uKGwsIHRyLCB0dCkKICAgIGxvY2FsIGxlZnQgPSBoYXZlKGwpCiAgICBsb2NhbCB0YWIgPSBoYXZlKHR0KQogICAgbG9jYWwgcmlnaHQgPSB0YWJbdHJdCiAgICB6ZW5jb2RlX2Fzc2VydCgKICAgICAgX2VxKGxlZnQsIHJpZ2h0KSwKICAgICAgJ1ZlcmlmaWNhdGlvbiBmYWlsOiBlbGVtZW50cyBhcmUgbm90IGVxdWFsOiAnIC4uCiAgICAgICAgbCAuLiAnID09ICcgLi4gdHQgLi4gJy4nIC4uIHRyCiAgICApCmVuZCkKCklmV2hlbigidmVyaWZ5ICcnIGlzIG5vdCBlcXVhbCB0byAnJyBpbiAnJyIsZnVuY3Rpb24obCwgdHIsIHR0KQogICAgbG9jYWwgbGVmdCA9IGhhdmUobCkKICAgIGxvY2FsIHRhYiA9IGhhdmUodHQpCiAgICBsb2NhbCByaWdodCA9IHRhYlt0cl0KICAgIHplbmNvZGVfYXNzZXJ0KAogICAgICBfbmVxKGxlZnQsIHJpZ2h0KSwKICAgICAgJ1ZlcmlmaWNhdGlvbiBmYWlsOiBlbGVtZW50cyBhcmUgZXF1YWw6ICcgLi4KICAgICAgICBsIC4uICcgPT0gJyAuLiB0dCAuLiAnLicgLi4gdHIKICAgICkKZW5kKQoKLS0gY2hlY2sgYSB0dXBsZSBvZiBudW1iZXJzIGJlZm9yZSBjb21wYXJpc29uLCBjb252ZXJ0IHRvIEJJRyBvciBudW1iZXIsIGFuZCB0aGVuIGNvbXBhcmUKbG9jYWwgZnVuY3Rpb24gbnVtY2hlY2sobCwgciwgb3ApCiAgICBsb2NhbCBvcGVyYXRvcnMgPSB7CiAgICAgICAgWyI8Il0gPSBmdW5jdGlvbih4LCB5KSByZXR1cm4geDx5IGVuZCwKICAgICAgICBbIjw9Il0gPSBmdW5jdGlvbih4LCB5KSByZXR1cm4geDw9eSBlbmQsCiAgICAgICAgWyI+Il0gPSBmdW5jdGlvbih4LCB5KSByZXR1cm4geD55IGVuZCwKICAgICAgICBbIj49Il0gPSBmdW5jdGlvbih4LCB5KSByZXR1cm4geD49eSBlbmQKICAgIH0KICAgIGxvY2FsIGxlZnQgPSBoYXZlKGwpCiAgICBsb2NhbCByaWdodCA9IGhhdmUocikKICAgIGxvY2FsIGFsLCBhcgogICAgLS0KICAgIGlmIGxlZnQgPT0gbmlsIHRoZW4KICAgICAgICBlcnJvcignMXN0IGFyZ3VtZW50IG9mIG51bWVyaWNhbCBjb21wYXJpc29uIGlzIG5pbCcsIDIpCiAgICBlbmQKICAgIGxvY2FsIHRsID0gdHlwZShsZWZ0KQogICAgaWYgbm90IGlzemVuKHRsKSB0aGVuCiAgICAgICAgaWYgdGwgfj0gJ251bWJlcicgdGhlbgogICAgICAgICAgICBlcnJvcignMXN0IGFyZ3VtZW50IGludmFsaWQgbnVtZXJpYyB0eXBlOiAnIC4uIHRsLCAyKQogICAgICAgIGVuZAogICAgZW5kCiAgICBpZiB0bCA9PSAnemVucm9vbS5vY3RldCcgdGhlbgogICAgICAgIGFsID0gQklHLm5ldyhsZWZ0KQogICAgZWxzZWlmIHRsID09ICd6ZW5yb29tLmJpZycgb3IgdGwgPT0gJ251bWJlcicgb3IgdGwgPT0gJ3plbnJvb20uZmxvYXQnIG9yIHRsID09ICd6ZW5yb29tLnRpbWUnIHRoZW4KICAgICAgICBhbCA9IGxlZnQKICAgIGVsc2UKICAgICAgICBhbCA9IGxlZnQ6b2N0ZXQoKQogICAgZW5kCiAgICAtLQogICAgaWYgcmlnaHQgPT0gbmlsIHRoZW4KICAgICAgICBlcnJvcignMm5kIGFyZ3VtZW50IG9mIG51bWVyaWNhbCBjb21wYXJpc29uIGlzIG5pbCcsIDIpCiAgICBlbmQKICAgIGxvY2FsIHRyID0gdHlwZShyaWdodCkKICAgIGlmIG5vdCBpc3plbih0cikgdGhlbgogICAgICAgIGlmIHRyIH49ICdudW1iZXInIHRoZW4KICAgICAgICAgICAgZXJyb3IoJzJuZCBhcmd1bWVudCBpbnZhbGlkIG51bWVyaWMgdHlwZTogJyAuLiB0ciwgMikKICAgICAgICBlbmQKICAgIGVuZAogICAgaWYgdHIgPT0gJ3plbnJvb20ub2N0ZXQnIHRoZW4KICAgICAgICBhciA9IEJJRy5uZXcocmlnaHQpCiAgICBlbHNlaWYgdHIgPT0gJ3plbnJvb20uYmlnJyBvciB0ciA9PSAnbnVtYmVyJyBvciB0ciA9PSAnemVucm9vbS5mbG9hdCcgb3IgdHIgPT0gJ3plbnJvb20udGltZScgdGhlbgogICAgICAgIGFyID0gcmlnaHQKICAgIGVsc2UKICAgICAgICBhciA9IHJpZ2h0Om9jdGV0KCkKICAgIGVuZAogICAgemVuY29kZV9hc3NlcnQob3BlcmF0b3JzW29wXShhbCwgYXIpLCAnQ29tcGFyaXNvbiBmYWlsOiAnIC4uIGwgLi4gb3AgLi4gcikKZW5kCgpJZldoZW4oInZlcmlmeSBudW1iZXIgJycgaXMgbGVzcyB0aGFuICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBudW1jaGVjayhsZWZ0LCByaWdodCwgIjwiKQplbmQpCgpJZldoZW4oInZlcmlmeSBudW1iZXIgJycgaXMgbGVzcyBvciBlcXVhbCB0aGFuICcnIiwgZnVuY3Rpb24obGVmdCwgcmlnaHQpCiAgICBudW1jaGVjayhsZWZ0LCByaWdodCwgIjw9IikKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgbnVtYmVyICcnIGlzIG1vcmUgdGhhbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIHJpZ2h0KQogICAgbnVtY2hlY2sobGVmdCwgcmlnaHQsICI+IikKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgbnVtYmVyICcnIGlzIG1vcmUgb3IgZXF1YWwgdGhhbiAnJyIsIGZ1bmN0aW9uKGxlZnQsIHJpZ2h0KQogICAgbnVtY2hlY2sobGVmdCwgcmlnaHQsICI+PSIpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9jaGVja19jb21wYXJlX2xlbmd0aChvYmpfbmFtZSwgbnVtX25hbWUpCiAgICBsb2NhbCBvYmosIG9ial9jb2RlYyA9IGhhdmUob2JqX25hbWUpCiAgICBsb2NhbCBvYmpfenR5cGUgPSBvYmpfY29kZWMuemVudHlwZQogICAgbG9jYWwgbnVtLCBudW1fY29kZWMgPSBoYXZlKG51bV9uYW1lKQogICAgbG9jYWwgbnVtX2VuYyA9IG51bV9jb2RlYy5lbmNvZGluZwogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KG9ial96dHlwZSA9PSAiYSIgb3Igb2JqX3p0eXBlID09ICJkIiBvcgogICAgICAgIChvYmpfenR5cGUgPT0gImUiIGFuZCBvYmpfY29kZWMuZW5jb2RpbmcgPT0gInN0cmluZyIpLAogICAgICAgICJDYW4gbm90IGNvbXB1dGUgdGhlIGxlbmd0aCBmb3IgdHlwZSAiLi5vYmpfenR5cGUpIHRoZW4gcmV0dXJuIGVuZAogICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KG51bV9lbmMgPT0gImludGVnZXIiIG9yIG51bV9lbmMgPT0gImZsb2F0IiwKICAgICAgICAiQ2FuIG5vdCBjb21wYXJlIHRoZSBsZW5ndGggb2YgIi4ub2JqX25hbWUuLiIgd2l0aCBudW1iZXIgb2YgdHlwZSAiLi5udW1fZW5jKSB0aGVuIHJldHVybiBlbmQKICAgIGxvY2FsIG9ial9sZW5fZW5jID0geyBbImludGVnZXIiXSA9IEJJRy5uZXcsIFsiZmxvYXQiXSA9IEYubmV3IH0KICAgIGxvY2FsIG9ial9sZW4KICAgIGlmIG9ial96dHlwZSA9PSAiYSIgb3Igb2JqX3p0eXBlID09ICJlIiB0aGVuCiAgICAgICAgb2JqX2xlbiA9IG9ial9sZW5fZW5jW251bV9lbmNdKCNvYmopCiAgICBlbHNlCiAgICAgICAgb2JqX2xlbiA9IG9ial9sZW5fZW5jW251bV9lbmNdKDApCiAgICAgICAgbG9jYWwgb25lID0gb2JqX2xlbl9lbmNbbnVtX2VuY10oMSkKICAgICAgICBmb3IgXyBpbiBwYWlycyhvYmopIGRvCiAgICAgICAgICAgIG9ial9sZW4gPSBvYmpfbGVuICsgb25lCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiBvYmpfbGVuLCBudW0KZW5kCgpJZldoZW4oInZlcmlmeSBzaXplIG9mICcnIGlzIGxlc3MgdGhhbiAnJyIsIGZ1bmN0aW9uKG9ial9uYW1lLCBudW1fbmFtZSkKICAgIGxvY2FsIGwsIHIgPSBfY2hlY2tfY29tcGFyZV9sZW5ndGgob2JqX25hbWUsIG51bV9uYW1lKQogICAgemVuY29kZV9hc3NlcnQobCA8IHIsCiAgICAgICAgIkNvbXBhcmlzb24gZmFpbDogc2l6ZSBvZiAiLi5vYmpfbmFtZS4uIiBpcyBub3QgbGVzcyB0aGFuICIuLm51bV9uYW1lKQplbmQpCgpJZldoZW4oInZlcmlmeSBzaXplIG9mICcnIGlzIGxlc3Mgb3IgZXF1YWwgdGhhbiAnJyIsIGZ1bmN0aW9uKG9ial9uYW1lLCBudW1fbmFtZSkKICAgIGxvY2FsIGwsIHIgPSBfY2hlY2tfY29tcGFyZV9sZW5ndGgob2JqX25hbWUsIG51bV9uYW1lKQogICAgemVuY29kZV9hc3NlcnQobCA8PSByLAogICAgICAgICJDb21wYXJpc29uIGZhaWw6IHNpemUgb2YgIi4ub2JqX25hbWUuLiIgaXMgbm90IGxlc3Mgb3IgZXF1YWwgdGhhbiAiLi5udW1fbmFtZSkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgc2l6ZSBvZiAnJyBpcyBtb3JlIHRoYW4gJyciLCBmdW5jdGlvbihvYmpfbmFtZSwgbnVtX25hbWUpCiAgICBsb2NhbCBsLCByID0gX2NoZWNrX2NvbXBhcmVfbGVuZ3RoKG9ial9uYW1lLCBudW1fbmFtZSkKICAgIHplbmNvZGVfYXNzZXJ0KHIgPCBsLAogICAgICAgICJDb21wYXJpc29uIGZhaWw6IHNpemUgb2YgIi4ub2JqX25hbWUuLiIgaXMgbm90IG1vcmUgdGhhbiAiLi5udW1fbmFtZSkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgc2l6ZSBvZiAnJyBpcyBtb3JlIG9yIGVxdWFsIHRoYW4gJyciLCBmdW5jdGlvbihvYmpfbmFtZSwgbnVtX25hbWUpCiAgICBsb2NhbCBsLCByID0gX2NoZWNrX2NvbXBhcmVfbGVuZ3RoKG9ial9uYW1lLCBudW1fbmFtZSkKICAgIHplbmNvZGVfYXNzZXJ0KHIgPD0gbCwKICAgICAgICAiQ29tcGFyaXNvbiBmYWlsOiBzaXplIG9mICIuLm9ial9uYW1lLi4iIGlzIG5vdCBtb3JlIG9yIGVxdWFsIHRoYW4gIi4ubnVtX25hbWUpCmVuZCkKCi0tIFRPRE86IHN1YnN0aXR1dGUgd2l0aCBSRkMyMDQ3IGNvbXBsaWFudCBjb2RlICh0YWtlIGZyb20gamFyb21haWwpCmxvY2FsIGZ1bmN0aW9uIHZhbGlkZW1haWwoc3RyKQogIGlmIHN0ciA9PSBuaWwgdGhlbgogICAgcmV0dXJuIG5pbAogIGVuZAogIGlmICh0eXBlKHN0cikgfj0gJ3N0cmluZycpIHRoZW4KICAgIGVycm9yKCdFeHBlY3RlZCBzdHJpbmcnKQogICAgcmV0dXJuIG5pbAogIGVuZAogIGxvY2FsIGxhc3RBdCA9IHN0cjpmaW5kKCdbXiVAXSskJykKICBsb2NhbCBsb2NhbFBhcnQgPSBzdHI6c3ViKDEsIChsYXN0QXQgLSAyKSkgLS0gUmV0dXJucyB0aGUgc3Vic3RyaW5nIGJlZm9yZSAnQCcgc3ltYm9sCiAgbG9jYWwgZG9tYWluUGFydCA9IHN0cjpzdWIobGFzdEF0LCAjc3RyKSAtLSBSZXR1cm5zIHRoZSBzdWJzdHJpbmcgYWZ0ZXIgJ0AnIHN5bWJvbAogIC0tIHdlIHdlcmVudCBhYmxlIHRvIHNwbGl0IHRoZSBlbWFpbCBwcm9wZXJseQogIGlmIGxvY2FsUGFydCA9PSBuaWwgdGhlbgogICAgcmV0dXJuIG5pbCwgJ0xvY2FsIG5hbWUgaXMgaW52YWxpZCcKICBlbmQKCiAgaWYgZG9tYWluUGFydCA9PSBuaWwgdGhlbgogICAgcmV0dXJuIG5pbCwgJ0RvbWFpbiBpcyBpbnZhbGlkJwogIGVuZAogIC0tIGxvY2FsIHBhcnQgaXMgbWF4ZWQgYXQgNjQgY2hhcmFjdGVycwogIGlmICNsb2NhbFBhcnQgPiA2NCB0aGVuCiAgICByZXR1cm4gbmlsLCAnTG9jYWwgbmFtZSBtdXN0IGJlIGxlc3MgdGhhbiA2NCBjaGFyYWN0ZXJzJwogIGVuZAogIC0tIGRvbWFpbnMgYXJlIG1heGVkIGF0IDI1MyBjaGFyYWN0ZXJzCiAgaWYgI2RvbWFpblBhcnQgPiAyNTMgdGhlbgogICAgcmV0dXJuIG5pbCwgJ0RvbWFpbiBtdXN0IGJlIGxlc3MgdGhhbiAyNTMgY2hhcmFjdGVycycKICBlbmQKICAtLSBzb210aGluZyBpcyB3cm9uZwogIGlmIGxhc3RBdCA+PSA2NSB0aGVuCiAgICByZXR1cm4gbmlsLCAnSW52YWxpZCBAIHN5bWJvbCB1c2FnZScKICBlbmQKICBpZiBzdHJpbmcuc3ViKGRvbWFpblBhcnQsIDEsIDEpID09ICcuJyB0aGVuCiAgICByZXR1cm4gZmFsc2UsICdmaXJzdCBjaGFyYWN0ZXIgaW4gZG9tYWluUGFydCBpcyBhIGRvdCcKICBlbmQKICAtLSBxdW90ZXMgYXJlIG9ubHkgYWxsb3dlZCBhdCB0aGUgYmVnaW5uaW5nIG9mIGEgdGhlIGxvY2FsIG5hbWUKICBsb2NhbCBxdW90ZXMgPSBsb2NhbFBhcnQ6ZmluZCgnWyJdJykKICBpZiB0eXBlKHF1b3RlcykgPT0gJ251bWJlcicgYW5kIHF1b3RlcyA+IDEgdGhlbgogICAgcmV0dXJuIG5pbCwgJ0ludmFsaWQgdXNhZ2Ugb2YgcXVvdGVzJwogIGVuZAogIC0tIG5vIEAgc3ltYm9scyBhbGxvd2VkIG91dHNpZGUgcXVvdGVzCiAgaWYgbG9jYWxQYXJ0OmZpbmQoJyVAKycpIGFuZCBxdW90ZXMgPT0gbmlsIHRoZW4KICAgIHJldHVybiBuaWwsICdJbnZhbGlkIEAgc3ltYm9sIHVzYWdlIGluIGxvY2FsIHBhcnQnCiAgZW5kCiAgLS0gbm8gZG90IGZvdW5kIGluIGRvbWFpbiBuYW1lCiAgaWYgbm90IGRvbWFpblBhcnQ6ZmluZCgnJS4nKSB0aGVuCiAgICByZXR1cm4gbmlsLCAnTm8gVExEIGZvdW5kIGluIGRvbWFpbicKICBlbmQKICAtLSBvbmx5IDEgcGVyaW9kIGluIHN1Y2Nlc3Npb24gYWxsb3dlZAogIGlmIGRvbWFpblBhcnQ6ZmluZCgnJS4lLicpIHRoZW4KICAgIHJldHVybiBuaWwsICdUb28gbWFueSBwZXJpb2RzIGluIGRvbWFpbicKICBlbmQKICBpZiBsb2NhbFBhcnQ6ZmluZCgnJS4lLicpIHRoZW4KICAgIHJldHVybiBuaWwsICdUb28gbWFueSBwZXJpb2RzIGluIGxvY2FsIHBhcnQnCiAgZW5kCiAgLS0ganVzdCBhIGdlbmVyYWwgbWF0Y2gKICBpZiBub3Qgc3RyOm1hdGNoKCdbJXddKlslcF0qJUArWyV3XSpbJS5dP1sld10qJykgdGhlbgogICAgcmV0dXJuIG5pbCwgJ0VtYWlsIHBhdHRlcm4gdGVzdCBmYWlsZWQnCiAgZW5kCiAgaWYgKGxhc3RBdCA9PSBuaWwpIHRoZW4KICAgIGxhc3RBdCA9ICNzdHIgKyAxCiAgZW5kCgogIC0tIGFsbCBvdXIgdGVzdHMgcGFzc2VkLCBzbyB3ZSBhcmUgb2sKICByZXR1cm4gdHJ1ZQplbmQKCklmV2hlbigidmVyaWZ5ICcnIGlzIGEgZW1haWwiLGZ1bmN0aW9uKG5hbWUpCiAgICBsb2NhbCBBID0gQUNLW25hbWVdCiAgICBpZiBub3QgemVuY29kZV9hc3NlcnQoQSwgJ09iamVjdCBub3QgZm91bmQ6ICcgLi4gbmFtZSkgdGhlbiByZXR1cm4gZW5kCiAgICBsb2NhbCByZXMsIGVyciA9IHZhbGlkZW1haWwoTy50b19zdHJpbmcoQSkpCiAgICB6ZW5jb2RlX2Fzc2VydChyZXMsIGVycikKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgJycgY29udGFpbnMgYSBsaXN0IG9mIGVtYWlscyIsZnVuY3Rpb24obmFtZSkKICAgIGxvY2FsIEEgPSBBQ0tbbmFtZV0KICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydChBLCAnT2JqZWN0IG5vdCBmb3VuZDogJyAuLiBuYW1lKSB0aGVuIHJldHVybiBlbmQKICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydCgKICAgICAgbHVhdHlwZShBKSA9PSAndGFibGUnLAogICAgICAnT2JqZWN0IGlzIG5vdCBhIGNvbnRhaW5lcjogJyAuLiBuYW1lCiAgICApIHRoZW4gcmV0dXJuIGVuZAogICAgbG9jYWwgcmVzLCBlcnIKICAgIGZvciBrLCB2IGluIHBhaXJzKEEpIGRvCiAgICAgIHJlcywgZXJyID0gdmFsaWRlbWFpbChPLnRvX3N0cmluZyh2KSkKICAgICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KHJlcywgKGVyciBvciAnT0snKSAuLiAnIG9uIGVtYWlsOiAnIC4uIE8udG9fc3RyaW5nKHYpKSB0aGVuIHJldHVybiBlbmQKICAgIGVuZAplbmQpCgpJZldoZW4oInZlcmlmeSBlbGVtZW50cyBpbiAnJyBhcmUgZXF1YWwiLCBmdW5jdGlvbihvYmpfbmFtZSkKICAgIGxvY2FsIG9iaiA9IGhhdmUob2JqX25hbWUpCiAgICBsb2NhbCBmaXJzdCA9IG5pbAogICAgbG9jYWwgZmlyc3RfaWR4ID0gbmlsCiAgICBmb3Igayx2IGluIHBhaXJzKG9iaikgZG8KICAgICAgICBpZiBmaXJzdCA9PSBuaWwgdGhlbgogICAgICAgICAgICBmaXJzdCA9IHYKICAgICAgICAgICAgZmlyc3RfaWR4ID0gawogICAgICAgIGVsc2UKICAgICAgICAgICAgaWYgbm90IHplbmNvZGVfYXNzZXJ0KF9lcShmaXJzdCwgdiksCiAgICAgICAgICAgICAgICAiVmVyaWZpY2F0aW9uIGZhaWxlZDogdGhlIGVsZW1lbnRzIGluIHBvc2l0aW9uICIKICAgICAgICAgICAgICAgIC4uIGsgLi4gIiBhbmQgIiAuLiBmaXJzdF9pZHgKICAgICAgICAgICAgICAgIC4uICJhcmUgbm90IGVxdWFsIikgdGhlbiByZXR1cm4gZW5kCiAgICAgICAgZW5kCiAgICBlbmQKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgZWxlbWVudHMgaW4gJycgYXJlIG5vdCBlcXVhbCIsIGZ1bmN0aW9uKG9ial9uYW1lKQogICAgbG9jYWwgb2JqID0gaGF2ZShvYmpfbmFtZSkKICAgIGxvY2FsIGZpcnN0ID0gbmlsCiAgICBsb2NhbCBmaXJzdF9pZHggPSBuaWwKICAgIGZvciBrLHYgaW4gcGFpcnMob2JqKSBkbwogICAgICAgIGlmIGZpcnN0ID09IG5pbCB0aGVuCiAgICAgICAgICAgIGZpcnN0ID0gdgogICAgICAgICAgICBmaXJzdF9pZHggPSBrCiAgICAgICAgZWxzZQogICAgICAgICAgICBpZiBfbmVxKGZpcnN0LCB2KSB0aGVuCiAgICAgICAgICAgICAgICAtLSBhdCBsZWFzdCB0d28gZWxlbWVudHMgYXJlIGRpZmZlcmVudAogICAgICAgICAgICAgICAgcmV0dXJuIHRydWUKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHplbmNvZGVfYXNzZXJ0KGZhbHNlLCAiVmVyaWZpY2F0aW9uIGZhaWxlZDogYWxsIGVsZW1lbnRzIGFyZSBlcXVhbCIpCmVuZCkKCi0tIGlmIHN0YXJ0ID0gbmlsIHRoZW4gd2lsbCBjaGVjayBpZgotLSB0aGUgc3RyaW5nIGVuZHMgd2l0aCB0aGUgc3Vic3RyaW5nCmxvY2FsIGZ1bmN0aW9uIHN0YXJ0X3dpdGhfZnJvbShzdHIsIHN1Yiwgc3RhcnQpCiAgIGxvY2FsIHN0cl9vY3QgPSBoYXZlKHN0cikKICAgbG9jYWwgc3ViX29jdCA9IEFDS1tzdWJdCiAgIGxvY2FsIHN0cl9jb2RlYyA9IENPREVDW3N0cl0KICAgbG9jYWwgc3ViX2NvZGVjID0ge30KICAgaWYgc3ViX29jdCB0aGVuCiAgICAgIHN1Yl9jb2RlYyA9IENPREVDW3N1Yl0KICAgZWxzZQogICAgICBzdWJfb2N0ID0gTy5mcm9tX3N0cmluZyhzdWIpCiAgICAgIHN1Yl9jb2RlYy5lbmNvZGluZyA9ICdzdHJpbmcnCiAgICAgIHN1Yl9jb2RlYy56ZW50eXBlID0gJ2UnCiAgIGVuZAogICBpZiBub3QgemVuY29kZV9hc3NlcnQoc3RyX2NvZGVjLnplbnR5cGUgPT0gJ2UnIGFuZAoJICAgICAgc3ViX2NvZGVjLnplbnR5cGUgPT0gJ2UnLAoJICAgICAgIlZlcmlmaWNhdGlvbiBmYWlsZWQ6IG9uZSBvciBib3RoIGlucHV0cyBhcmUgbm90IGVsZW1lbnRzIikgdGhlbiByZXR1cm4gZW5kCiAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydChzdHJfY29kZWMuZW5jb2RpbmcgPT0gJ3N0cmluZycgYW5kCgkgICAgICBzdWJfY29kZWMuZW5jb2RpbmcgPT0gJ3N0cmluZycsCgkgICAgICAiVmVyaWZpY2F0aW9uIGZhaWxlZDogb25lIG9yIGJvdGggaW5wdXRzIGFyZSBub3Qgc3RyaW5ncyIpIHRoZW4gcmV0dXJuIGVuZAogICBpZiBub3QgemVuY29kZV9hc3NlcnQoI3N1Yl9vY3QgPD0gI3N0cl9vY3QsCgkgICAgICAiVmVyaWZpY2F0aW9uIGZhaWxlZDogc3Vic3RyaW5nIGlzIGxvbmdlciB0aGFuIHRoZSBzdHJpbmciKSB0aGVuIHJldHVybiBlbmQKICAgbG9jYWwgcyA9IHN0cl9vY3Q6c3RyaW5nKCkKICAgbG9jYWwgYiA9IHN1Yl9vY3Q6c3RyaW5nKCkKICAgc3RhcnQgPSBzdGFydCBvciAoI3MtI2IrMSkKICAgemVuY29kZV9hc3NlcnQoczpmaW5kKGIsIHN0YXJ0LCB0cnVlKSA9PSBzdGFydCwKCSAgICAgICJWZXJpZmljYXRpb24gZmFpbGVkOiBzdWJzdHJpbmcgbm90IGZvdW5kIGF0IHBvc2l0aW9uICIuLnN0YXJ0KQplbmQKCklmV2hlbigidmVyaWZ5ICcnIHN0YXJ0cyB3aXRoICcnIiwgZnVuY3Rpb24oc3RyLCBzdWIpCgkgIHN0YXJ0X3dpdGhfZnJvbShzdHIsIHN1YiwgMSkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgJycgaGFzIHByZWZpeCAnJyIsIGZ1bmN0aW9uKHN0ciwgc3ViKQoJICBzdGFydF93aXRoX2Zyb20oc3RyLCBzdWIsIDEpCmVuZCkKCklmV2hlbigidmVyaWZ5ICcnIGVuZHMgd2l0aCAnJyIsIGZ1bmN0aW9uKHN0ciwgc3ViKQoJICBzdGFydF93aXRoX2Zyb20oc3RyLCBzdWIsIG5pbCkKZW5kKQoKSWZXaGVuKCJ2ZXJpZnkgJycgaGFzIHN1ZmZpeCAnJyIsIGZ1bmN0aW9uKHN0ciwgc3ViKQoJICBzdGFydF93aXRoX2Zyb20oc3RyLCBzdWIsIG5pbCkKZW5kKQovemVuY29kZV93M2MubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDIxLTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgTWF0dGVvIENyaXN0aW5vCi0tb24gVGh1cnNkYXksIDI2dGggU2VwdGVtYmVyIDIwMjQKLS1dXQoKSk9TRSA9IHJlcXVpcmVfb25jZSdjcnlwdG9fam9zZScKbG9hZF9zY2VuYXJpbygnemVuY29kZV9qd2snKQpsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX2p3cycpCmxvYWRfc2NlbmFyaW8oJ3plbmNvZGVfand0JykKbG9hZF9zY2VuYXJpbygnemVuY29kZV9kaWQnKQpsb2FkX3NjZW5hcmlvKCd6ZW5jb2RlX3ZjJykKCgoKCi96ZW5jb2RlX3doZW4ubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIEZyaWRheSwgMjZ0aCBOb3ZlbWJlciAyMDIxCi0tXV0KCi0tLSBXSEVOCgotLSBub3AgdG8gdGVybWluYXRlIElGIGJsb2NrcwpXaGVuKCJkb25lIiwgZnVuY3Rpb24oKSBlbmQpCgoKbG9jYWwgZnVuY3Rpb24gX2lzX2ZvdW5kKGVsKQogICAgcmV0dXJuIEFDS1tlbF0gYW5kIChsdWF0eXBlKEFDS1tlbF0pID09ICd0YWJsZScgb3IgdG9udW1iZXIoQUNLW2VsXSkgb3IgI0FDS1tlbF0gfj0gMCkKZW5kCgpJZldoZW4oInZlcmlmeSAnJyBpcyBmb3VuZCIsIGZ1bmN0aW9uKGVsKQogICAgemVuY29kZV9hc3NlcnQoX2lzX2ZvdW5kKGVsKSwgIkNhbm5vdCBmaW5kIG9iamVjdDogIi4uZWwpCmVuZCkKCklmV2hlbigidmVyaWZ5ICcnIGlzIG5vdCBmb3VuZCIsIGZ1bmN0aW9uKGVsKQogICAgemVuY29kZV9hc3NlcnQobm90IF9pc19mb3VuZChlbCksICJPYmplY3Qgc2hvdWxkIG5vdCBiZSBmb3VuZDogIi4uZWwpCmVuZCkKCldoZW4oImFwcGVuZCAnJyB0byAnJyIsIGZ1bmN0aW9uKHNyYywgZGVzdCkKCQlsb2NhbCB2YWwgPSBoYXZlKHNyYykKCQlsb2NhbCBkc3QgPSBoYXZlKGRlc3QpCgkJemVuY29kZV9hc3NlcnQobHVhdHlwZShkc3QpIH49ICd0YWJsZScsCgkJCQkgICAiQ2Fubm90IGFwcGVuZCB0byB0YWJsZTogIi4uZGVzdCkKCQktLSBpZiB0aGUgZGVzdGluYXRpb24gaXMgYSBudW1iZXIsIGZpeCB0aGUgZW5jb2RpbmcgdG8gc3RyaW5nCgkJaWYgaXNudW1iZXIoZHN0KSB0aGVuCgkJICAgZHN0ID0gTy5mcm9tX3N0cmluZyggdG9zdHJpbmcoZHN0KSApCgkJICAgQ09ERUNbZGVzdF0uZW5jb2RpbmcgPSAic3RyaW5nIgoJCSAgIENPREVDW2Rlc3RdLnplbnR5cGUgPSAnZScKICAgICAgICBlbmQKICAgICAgICBpZiBpc251bWJlcih2YWwpIHRoZW4KCQkgICB2YWwgPSBPLmZyb21fc3RyaW5nKCB0b3N0cmluZyh2YWwpICkKCQllbmQKICAgICAgICBkc3QgPSBkc3Q6b2N0ZXQoKSAuLiB2YWwKCQlBQ0tbZGVzdF0gPSBkc3QKZW5kKQoKV2hlbigiYXBwZW5kIHN0cmluZyAnJyB0byAnJyIsIGZ1bmN0aW9uKGhzdHIsIGRlc3QpCglsb2NhbCBkc3QgPSBoYXZlKGRlc3QpCgl6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKGRzdCkgfj0gJ3RhYmxlJywgIkNhbm5vdCBhcHBlbmQgdG8gdGFibGU6ICIuLmRlc3QpCgktLSBpZiB0aGUgZGVzdGluYXRpb24gaXMgYSBudW1iZXIsIGZpeCBlbmNvZGluZyB0byBzdHJpbmcKCWlmIGlzbnVtYmVyKGRzdCkgdGhlbgoJICAgZHN0ID0gTy5mcm9tX3N0cmluZyggdG9zdHJpbmcoZHN0KSApCgkgICBDT0RFQ1tkZXN0XS5lbmNvZGluZyA9ICJzdHJpbmciCgkgICBDT0RFQ1tkZXN0XS56ZW50eXBlID0gJ2UnCgllbmQKCWRzdCA9IGRzdDpvY3RldCgpIC4uIE8uZnJvbV9zdHJpbmcoaHN0cikKCUFDS1tkZXN0XSA9IGRzdAplbmQpCgpXaGVuKCJwcmVwZW5kIHN0cmluZyAnJyB0byAnJyIsIGZ1bmN0aW9uKGhzdHIsIGRlc3QpCglsb2NhbCBkc3QgPSBoYXZlKGRlc3QpCgl6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKGRzdCkgfj0gJ3RhYmxlJywgIkNhbm5vdCBhcHBlbmQgdG8gdGFibGU6ICIuLmRlc3QpCgktLSBpZiB0aGUgZGVzdGluYXRpb24gaXMgYSBudW1iZXIsIGZpeCBlbmNvZGluZyB0byBzdHJpbmcKCWlmIGlzbnVtYmVyKGRzdCkgdGhlbgoJICAgZHN0ID0gTy5mcm9tX3N0cmluZyggdG9zdHJpbmcoZHN0KSApCgkgICBDT0RFQ1tkZXN0XS5lbmNvZGluZyA9ICJzdHJpbmciCgkgICBDT0RFQ1tkZXN0XS56ZW50eXBlID0gJ2UnCgllbmQKCWRzdCA9IE8uZnJvbV9zdHJpbmcoaHN0cikgLi4gZHN0Om9jdGV0KCkKCUFDS1tkZXN0XSA9IGRzdAplbmQpCgpXaGVuKCJhcHBlbmQgJycgb2YgJycgdG8gJyciLCBmdW5jdGlvbihlbmMsIHNyYywgZGVzdCkKCWxvY2FsIGZyb20gPSBoYXZlKHNyYykKCWxvY2FsIHRvID0gaGF2ZShkZXN0KQoJemVuY29kZV9hc3NlcnQodHlwZSh0bykgPT0gJ3plbnJvb20ub2N0ZXQnLCAiRGVzdGluYXRpb24gdHlwZSBpcyBub3Qgb2N0ZXQ6ICIuLmRlc3QuLiIgKCIuLnR5cGUodG8pLi4iKSIpCgl6ZW5jb2RlX2Fzc2VydChDT0RFQ1tkZXN0XS5lbmNvZGluZyA9PSAnc3RyaW5nJywgIkRlc3RpbmF0aW9uIGVuY29kaW5nIGlzIG5vdCBzdHJpbmc6ICIuLmRlc3QpCglsb2NhbCBmID0gZ2V0X2VuY29kaW5nX2Z1bmN0aW9uKGVuYykKCXplbmNvZGVfYXNzZXJ0KGYsICJFbmNvZGluZyBmb3JtYXQgbm90IGZvdW5kOiAiLi5lbmMpCgl0byA9IHRvIC4uIE8uZnJvbV9zdHJpbmcoIGYoIGZyb206b2N0ZXQoKSApICkKCUFDS1tkZXN0XSA9IHRvCmVuZCkKCldoZW4oImNyZWF0ZSAnJyIsIGZ1bmN0aW9uKGRlc3QpCgllbXB0eSAoZGVzdCkKCUFDS1tkZXN0XSA9IHsgfQoJQ09ERUNbZGVzdF0gPSBndWVzc19jb252ZXJzaW9uKEFDS1tkZXN0XSwgZGVzdCkKCUNPREVDW2Rlc3RdLm5hbWUgPSBkZXN0CmVuZCkKV2hlbigiY3JlYXRlICcnIG5hbWVkICcnIiwgZnVuY3Rpb24oc2NoLCBuYW1lKQoJZW1wdHkobmFtZSkKCUFDS1tuYW1lXSA9IHsgfQoJQ09ERUNbbmFtZV0gPSBndWVzc19jb252ZXJzaW9uKEFDS1tuYW1lXSwgc2NoKQoJQ09ERUNbbmFtZV0ubmFtZSA9IG5hbWUKZW5kKQoKLS0gc2ltcGxpZmllZCBleGNlcHRpb24gZm9yIEkgd3JpdGU6IGltcG9ydCBlbmNvZGluZyBmcm9tX3N0cmluZyAuLi4KV2hlbigid3JpdGUgc3RyaW5nICcnIGluICcnIiwgZnVuY3Rpb24oY29udGVudCwgZGVzdCkKCWVtcHR5KGRlc3QpCglBQ0tbZGVzdF0gPSBPLmZyb21fc3RyaW5nKGNvbnRlbnQpCgluZXdfY29kZWMoZGVzdCwKCQkJICB7ZW5jb2RpbmcgPSAnc3RyaW5nJywKCQkJICAgbHVhdHlwZSA9ICdzdHJpbmcnLAoJCQkgICB6ZW50eXBlID0gJ2UnIH0pCmVuZCkKCi0tIC4uLiBhbmQgZnJvbSBhIG51bWJlcgpXaGVuKCJ3cml0ZSBudW1iZXIgJycgaW4gJyciLCBmdW5jdGlvbihjb250ZW50LCBkZXN0KQoJZW1wdHkoZGVzdCkKCS0tIFRPRE86IGRldGVjdCBudW1iZXIgYmFzZSAxMAoJbG9jYWwgbnVtID0gdG9udW1iZXIoY29udGVudCkKCXplbmNvZGVfYXNzZXJ0KG51bSwgIkNhbm5vdCBjb252ZXJ0IHZhbHVlIHRvIG51bWJlcjogIi4uY29udGVudCkKLS0JaWYgbnVtID4gMjE0NzQ4MzY0NyB0aGVuCi0tCQllcnJvcignT3ZlcmZsb3cgb2YgbnVtYmVyIG9iamVjdCBvdmVyIDMyYml0IHNpZ25lZCBzaXplJykKCQktLSBUT0RPOiBtYXliZSBzdXBwb3J0IHVuc2lnbmVkIG5hdGl2ZSBoZXJlCi0tCWVuZAoKICAgIC0tLSBzaW11bGF0ZSBpbnB1dCBmcm9tIEdpdmVuIHRvIGFkZCBhIG5ldyBudW1iZXIKICAgIC0tLSBpbiBvcmRlciB0byBtYWtlIGl0IGRpc3Rpbmd1aXNoIGZsb2F0IGFuZCB0aW1lCglBQ0tbZGVzdF0gPSBpbnB1dF9lbmNvZGluZygnZmxvYXQnKS5mdW4obnVtKQogICAgbmV3X2NvZGVjKGRlc3QsIHt6ZW50eXBlID0gJ2UnLCBlbmNvZGluZyA9ICdudW1iZXInfSkKZW5kKQoKV2hlbigiY3JlYXRlIG51bWJlciBmcm9tICcnIiwgZnVuY3Rpb24oZnJvbSkKCWVtcHR5J251bWJlcicKCWxvY2FsIGdldCA9IGhhdmUoZnJvbSkKCUFDSy5udW1iZXIgPSBCSUcuZnJvbV9kZWNpbWFsKGdldDpvY3RldCgpOnN0cmluZygpKQoJbmV3X2NvZGVjKCdudW1iZXInLCB7emVudHlwZSA9ICdlJyB9KQplbmQpCgpXaGVuKCJzZXQgJycgdG8gJycgYXMgJyciLCBmdW5jdGlvbihkZXN0LCBjb250ZW50LCBmb3JtYXQpCgllbXB0eShkZXN0KQoJbG9jYWwgZ3Vlc3MgPSBpbnB1dF9lbmNvZGluZyhmb3JtYXQpCglndWVzcy5yYXcgPSBjb250ZW50CglndWVzcy5uYW1lID0gZGVzdAoJQUNLW2Rlc3RdID0gb3BlcmF0ZV9jb252ZXJzaW9uKGd1ZXNzKQotLQluZXdfY29kZWMoZGVzdCwgeyBsdWF0eXBlID0gbHVhdHlwZShBQ0tbZGVzdF0pLCB6ZW50eXBlID0gJ2UnIH0pCmVuZCkKCklmV2hlbigidmVyaWZ5ICcnIGlzIGEganNvbiIsIGZ1bmN0aW9uKHNyYykKICAgIGxvY2FsIG9iaiwgb2JqX2MgPSBoYXZlKHNyYykKICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydChvYmpfYy56ZW50eXBlID09ICdlJywgIkVuY29kZWQgSlNPTiBpcyBub3QgYW4gZWxlbWVudDogIi4uc3JjKSB0aGVuIHJldHVybiBlbmQKICAgIGlmIG5vdCB6ZW5jb2RlX2Fzc2VydChvYmpfYy5lbmNvZGluZyA9PSAnc3RyaW5nJywgIkVuY29kZWQgSlNPTiBpcyBub3QgYW4gc3RyaW5nOiAiLi5zcmMpIHRoZW4gcmV0dXJuIGVuZAogICAgemVuY29kZV9hc3NlcnQoSlNPTi52YWxpZGF0ZShPLnRvX3N0cmluZyhvYmopKSwgIkludmFsaWQgSlNPTiBvYmplY3Q6ICIuLnNyYykKZW5kKQoKV2hlbigiY3JlYXRlIGpzb24gZXNjYXBlZCBzdHJpbmcgb2YgJyciLCBmdW5jdGlvbihzcmMpCiAgICBsb2NhbCBvYmosIGNvZGVjID0gaGF2ZShzcmMpCiAgICBlbXB0eSAnanNvbl9lc2NhcGVkX3N0cmluZycKICAgIGxvY2FsIGVuY29kaW5nID0gY29kZWMuc2NoZW1hIG9yIGNvZGVjLmVuY29kaW5nCiAgICAgICAgb3IgQ09ERUMub3V0cHV0LmVuY29kaW5nLm5hbWUKICAgIEFDSy5qc29uX2VzY2FwZWRfc3RyaW5nID0gT0NURVQuZnJvbV9zdHJpbmcoIEpTT04uZW5jb2RlKG9iaiwgZW5jb2RpbmcpICkKICAgIG5ld19jb2RlYygnanNvbl9lc2NhcGVkX3N0cmluZycsIHtlbmNvZGluZyA9ICdzdHJpbmcnLCB6ZW50eXBlID0gJ2UnfSkKZW5kKQoKV2hlbigiY3JlYXRlIGpzb24gdW5lc2NhcGVkIG9iamVjdCBvZiAnJyIsIGZ1bmN0aW9uKHNyYykKICAgIGxvY2FsIG9iaiA9IGhhdmUoc3JjKQogICAgZW1wdHknanNvbl91bmVzY2FwZWRfb2JqZWN0JwogICAgQUNLLmpzb25fdW5lc2NhcGVkX29iamVjdCA9IGRlZXBtYXAoCiAgICAgICAgT0NURVQuZnJvbV9zdHJpbmcsCiAgICAgICAgSlNPTi5kZWNvZGUoTy50b19zdHJpbmcob2JqKSkKICAgICkKICAgIG5ld19jb2RlYygnanNvbl91bmVzY2FwZWRfb2JqZWN0Jywge2VuY29kaW5nID0gJ3N0cmluZyd9KQplbmQpCgotLSBudW1lcmljYWxzCldoZW4oInNldCAnJyB0byAnJyBiYXNlICcnIiwgZnVuY3Rpb24oZGVzdCwgY29udGVudCwgYmFzZSkKCWVtcHR5KGRlc3QpCglsb2NhbCBiYXMgPSB0b251bWJlcihiYXNlKQoJemVuY29kZV9hc3NlcnQoYmFzLCAiSW52YWxpZCBudW1lcmljYWwgY29udmVyc2lvbiBmb3IgYmFzZTogIi4uYmFzZSkKCWxvY2FsIG51bSA9IHRvbnVtYmVyKGNvbnRlbnQsYmFzKQoJemVuY29kZV9hc3NlcnQobnVtLCAiSW52YWxpZCBudW1lcmljYWwgY29udmVyc2lvbiBmb3IgdmFsdWU6ICIuLmNvbnRlbnQpCglBQ0tbZGVzdF0gPSBGLm5ldyhudW0pCgluZXdfY29kZWMoZGVzdCwge2VuY29kaW5nID0gJ251bWJlcicsIHplbnR5cGUgPSAnZScgfSkKZW5kKQoKbG9jYWwgZnVuY3Rpb24gX2RlbGV0ZV9mKG5hbWUpCiAgIGhhdmUobmFtZSkKICAgQUNLW25hbWVdID0gbmlsCiAgIENPREVDW25hbWVdID0gbmlsCmVuZApXaGVuKCJkZWxldGUgJyciLCBfZGVsZXRlX2YpCldoZW4oInJlbW92ZSAnJyIsIF9kZWxldGVfZikKCldoZW4oInJlbmFtZSAnJyB0byAnJyIsIGZ1bmN0aW9uKG9sZCxuZXcpCgloYXZlKG9sZCkKCWVtcHR5KG5ldykKCUFDS1tuZXddID0gQUNLW29sZF0KCUFDS1tvbGRdID0gbmlsCglDT0RFQ1tuZXddID0gQ09ERUNbb2xkXQoJQ09ERUNbb2xkXSA9IG5pbAplbmQpCldoZW4oInJlbmFtZSBvYmplY3QgbmFtZWQgYnkgJycgdG8gJyciLCBmdW5jdGlvbihvbGQsbmV3KQoJbG9jYWwgb2xkbyA9IGhhdmUob2xkKQoJbG9jYWwgb2xkcyA9IG9sZG86b2N0ZXQoKTpzdHJpbmcoKQoJaGF2ZShvbGRzKQoJZW1wdHkobmV3KQoJQUNLW25ld10gPSBBQ0tbb2xkc10KCUFDS1tvbGRzXSA9IG5pbAoJQ09ERUNbbmV3XSA9IENPREVDW29sZHNdCglDT0RFQ1tvbGRzXSA9IG5pbAplbmQpCldoZW4oInJlbmFtZSAnJyB0byBuYW1lZCBieSAnJyIsIGZ1bmN0aW9uKG9sZCxuZXcpCgloYXZlKG9sZCkKCWxvY2FsIG5ld28gPSBoYXZlKG5ldykKCWxvY2FsIG5ld3MgPSBuZXdvOm9jdGV0KCk6c3RyaW5nKCkKCWVtcHR5KG5ld3MpCglBQ0tbbmV3c10gPSBBQ0tbb2xkXQoJQUNLW29sZF0gPSBuaWwKCUNPREVDW25ld3NdID0gQ09ERUNbb2xkXQoJQ09ERUNbb2xkXSA9IG5pbAplbmQpCldoZW4oInJlbmFtZSBvYmplY3QgbmFtZWQgYnkgJycgdG8gbmFtZWQgYnkgJyciLCBmdW5jdGlvbihvbGQsbmV3KQoJbG9jYWwgb2xkbyA9IGhhdmUob2xkKQoJbG9jYWwgb2xkcyA9IG9sZG86b2N0ZXQoKTpzdHJpbmcoKQoJaGF2ZShvbGRzKQoJbG9jYWwgbmV3byA9IGhhdmUobmV3KQoJbG9jYWwgbmV3cyA9IG5ld286b2N0ZXQoKTpzdHJpbmcoKQoJZW1wdHkobmV3cykKCUFDS1tuZXdzXSA9IEFDS1tvbGRzXQoJQUNLW29sZHNdID0gbmlsCglDT0RFQ1tuZXdzXSA9IENPREVDW29sZHNdCglDT0RFQ1tvbGRzXSA9IG5pbAplbmQpCgotLSBjcmVhdGUgJycgZnJvbSAnJyBhcyAnJwpXaGVuKCJjcmVhdGUgJycgc3RyaW5nIG9mICcnIiwgZnVuY3Rpb24oZW5jb2RpbmcsIHNyYykKCQlsb2NhbCBvcmlnID0gaGF2ZShzcmMpCgkJemVuY29kZV9hc3NlcnQobHVhdHlwZShvcmlnKSB+PSAndGFibGUnLCAiU291cmNlIGVsZW1lbnQgaXMgbm90IGEgdGFibGU6ICIuLnNyYykKCQllbXB0eShlbmNvZGluZykgLS0gZGVzdGluYXRpb24gbmFtZSBpcyBlbmNvZGluZyBuYW1lCgkJbG9jYWwgZiA9IGdldF9lbmNvZGluZ19mdW5jdGlvbihlbmNvZGluZykKCQl6ZW5jb2RlX2Fzc2VydChmLCAiRW5jb2RpbmcgZm9ybWF0IG5vdCBmb3VuZDogIi4uZW5jb2RpbmcpCgkJQUNLW2VuY29kaW5nXSA9IE8uZnJvbV9zdHJpbmcoIGYoIG9yaWc6b2N0ZXQoKSApICkKCQluZXdfY29kZWMoZW5jb2RpbmcsIHsgemVudHlwZSA9ICdlJywKCQkJCQkJCSAgbHVhdHlwZSA9ICdzdHJpbmcnLAoJCQkJCQkJICBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIG1vdmVfb3JfY29weV90byhzcmMsIGRlc3QsIGVuYykKICAgIGVtcHR5KGRlc3QpCiAgICBpZiBub3QgZW5jIHRoZW4KICAgICAgICBBQ0tbZGVzdF0gPSBkZWVwY29weShoYXZlKHNyYykpCiAgICAgICAgbmV3X2NvZGVjKGRlc3QsIHsgfSwgc3JjKQogICAgZWxzZQogICAgICAgIEFDS1tkZXN0XSA9IGFwcGx5X2VuY29kaW5nKHNyYywgZW5jLCAic3RyaW5nIikKICAgICAgICBuZXdfY29kZWMoZGVzdCwgeyBlbmNvZGluZyA9ICdzdHJpbmcnIH0pCiAgICBlbmQKZW5kCgpXaGVuKCJjb3B5ICcnIHRvICcnIiwgbW92ZV9vcl9jb3B5X3RvKQoKV2hlbigiY29weSAnJyBhcyAnJyB0byAnJyIsIGZ1bmN0aW9uKHNyYywgZW5jLCBkZXN0KQogICAgbW92ZV9vcl9jb3B5X3RvKHNyYywgZGVzdCwgZW5jKQplbmQpCgpXaGVuKCJtb3ZlICcnIHRvICcnIiwgZnVuY3Rpb24oc3JjLCBkZXN0KQogICAgbW92ZV9vcl9jb3B5X3RvKHNyYywgZGVzdCkKICAgIEFDS1tzcmNdID0gbmlsCiAgICBDT0RFQ1tzcmNdID0gbmlsCmVuZCkKCldoZW4oIm1vdmUgJycgYXMgJycgdG8gJyciLCBmdW5jdGlvbihzcmMsIGVuYywgZGVzdCkKICAgIG1vdmVfb3JfY29weV90byhzcmMsIGRlc3QsIGVuYykKICAgIEFDS1tzcmNdID0gbmlsCiAgICBDT0RFQ1tzcmNdID0gbmlsCmVuZCkKCldoZW4oImNvcHkgY29udGVudHMgb2YgJycgaW4gJyciLCBmdW5jdGlvbihzcmMsZHN0KQogICAgbG9jYWwgb2JqLCBvYmpfY29kZWMgPSBoYXZlKHNyYykKICAgIHplbmNvZGVfYXNzZXJ0KGx1YXR5cGUob2JqKSA9PSAndGFibGUnLCAiT2JqZWN0IGlzIG5vdCBhIHRhYmxlOiAiLi5zcmMpCiAgICBsb2NhbCBkZXN0LCBkZXN0X2NvZGVjID0gaGF2ZShkc3QpCiAgICB6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKGRlc3QpID09ICd0YWJsZScsICJPYmplY3QgaXMgbm90IGEgdGFibGU6ICIuLnNyYykKICAgIGlmIGRlc3RfY29kZWMuemVudHlwZSA9PSAnYScgdGhlbgogICAgICAgIGZvciBfLCB2IGluIHBhaXJzKG9iaikgZG8KICAgICAgICAgICAgdGFibGUuaW5zZXJ0KEFDS1tkc3RdLCB2KQogICAgICAgIGVuZAogICAgZWxzZWlmIGRlc3RfY29kZWMuemVudHlwZSA9PSAnZCcgdGhlbgogICAgICAgIHplbmNvZGVfYXNzZXJ0KG9ial9jb2RlYy56ZW50eXBlID09ICdkJywgIkNhbiBub3QgY29weSBjb250ZW50cyBvZiBhbiBhcnJheSBpbnRvIGEgZGljdGlvbmFyeSIpCiAgICAgICAgZm9yIGssIHYgaW4gcGFpcnMob2JqKSBkbwogICAgICAgICAgICBpZiBBQ0tbZHN0XVtrXSB0aGVuIGVycm9yKCJDYW5ub3Qgb3ZlcndyaXRlOiAiLi5rLi4iIGluICIuLmRzdCkgZW5kCiAgICAgICAgICAgIEFDS1tkc3RdW2tdID0gdgogICAgICAgIGVuZAogICAgZWxzZWlmIGRlc3RfY29kZWMuemVudHlwZSA9PSAnZScgYW5kIGRlc3RfY29kZWMuc2NoZW1hIHRoZW4KICAgICAgICBsb2NhbCBkZXN0X3NjaGVtYSA9IFpFTi5zY2hlbWFzW2Rlc3RfY29kZWMuc2NoZW1hXQogICAgICAgIGlmIGx1YXR5cGUoZGVzdF9zY2hlbWEpIH49ICd0YWJsZScgdGhlbiAtLSBvbGQgc2NoZW1hIHR5cGVzIGFyZSBub3Qgb3BlbgogICAgICAgICAgICBlcnJvcigiU2NoZW1hIGlzIG5vdCBvcGVuIHRvIGFjY2VwdCBleHRyYSBvYmplY3RzOiAiLi5kc3QpCiAgICAgICAgZWxzZWlmIG5vdCBkZXN0X3NjaGVtYS5zY2hlbWF0eXBlIG9yIGRlc3Rfc2NoZW1hLnNjaGVtYXR5cGUgfj0gJ29wZW4nIHRoZW4KICAgICAgICAgICAgZXJyb3IoIlNjaGVtYSBpcyBub3Qgb3BlbiB0byBhY2NlcHQgZXh0cmEgb2JqZWN0czogIi4uZHN0KQogICAgICAgIGVuZAogICAgICAgIGZvciBrLCB2IGluIHBhaXJzKG9iaikgZG8KICAgICAgICAgICAgaWYgQUNLW2RzdF1ba10gdGhlbiBlcnJvcigiQ2Fubm90IG92ZXJ3cml0ZTogIi4uay4uIiBpbiAiLi5kc3QpIGVuZAogICAgICAgICAgICBBQ0tbZHN0XVtrXSA9IHYKICAgICAgICBlbmQKICAgIGVuZAplbmQpCgpXaGVuKCJjb3B5IGNvbnRlbnRzIG9mICcnIG5hbWVkICcnIGluICcnIiwgZnVuY3Rpb24oc3JjLG5hbWUsZHN0KQogICAgbG9jYWwgb2JqLCBvYmpfY29kZWMgPSBoYXZlKHNyYykKICAgIHplbmNvZGVfYXNzZXJ0KGx1YXR5cGUob2JqKSA9PSAndGFibGUnLCAiT2JqZWN0IGlzIG5vdCBhIHRhYmxlOiAiLi5zcmMpCiAgICB6ZW5jb2RlX2Fzc2VydChvYmpfY29kZWMuemVudHlwZSA9PSAnZCcsICJPYmplY3QgaXMgbm90IGEgZGljdGlvbmFyeTogIi4uc3JjKQogICAgemVuY29kZV9hc3NlcnQob2JqW25hbWVdLCAiT2JqZWN0IG5vdCBmb3VuZDogIi4ubmFtZS4uIiBpbnNpZGUgIi4uIHNyYykKICAgIGxvY2FsIGRlc3QsIGRlc3RfY29kZWMgPSBoYXZlKGRzdCkKICAgIHplbmNvZGVfYXNzZXJ0KGx1YXR5cGUoZGVzdCkgPT0gJ3RhYmxlJywgIk9iamVjdCBpcyBub3QgYSB0YWJsZTogIi4uc3JjKQogICAgaWYgZGVzdF9jb2RlYy56ZW50eXBlID09ICdhJyB0aGVuCiAgICAgICAgdGFibGUuaW5zZXJ0KEFDS1tkc3RdLCBvYmpbbmFtZV0pCiAgICBlbHNlaWYgZGVzdF9jb2RlYy56ZW50eXBlID09ICdkJyB0aGVuCiAgICAgICAgemVuY29kZV9hc3NlcnQobm90IGRlc3RbbmFtZV0sICJDYW5ub3Qgb3ZlcndyaXRlOiAiLi5uYW1lLi4iIGluICIuLmRzdCkKICAgICAgICBBQ0tbZHN0XVtuYW1lXSA9IG9ialtuYW1lXQogICAgZWxzZWlmIGRlc3RfY29kZWMuemVudHlwZSA9PSAnZScgYW5kIGRlc3RfY29kZWMuc2NoZW1hIHRoZW4KICAgICAgICBsb2NhbCBkZXN0X3NjaGVtYSA9IFpFTi5zY2hlbWFzW2Rlc3RfY29kZWMuc2NoZW1hXQogICAgICAgIGlmIGx1YXR5cGUoZGVzdF9zY2hlbWEpIH49ICd0YWJsZScgdGhlbiAtLSBvbGQgc2NoZW1hIHR5cGVzIGFyZSBub3Qgb3BlbgogICAgICAgICAgICBlcnJvcigiU2NoZW1hIGlzIG5vdCBvcGVuIHRvIGFjY2VwdCBleHRyYSBvYmplY3RzOiAiLi5kc3QpCiAgICAgICAgZWxzZWlmIG5vdCBkZXN0X3NjaGVtYS5zY2hlbWF0eXBlIG9yIGRlc3Rfc2NoZW1hLnNjaGVtYXR5cGUgfj0gJ29wZW4nIHRoZW4KICAgICAgICAgICAgZXJyb3IoIlNjaGVtYSBpcyBub3Qgb3BlbiB0byBhY2NlcHQgZXh0cmEgb2JqZWN0czogIi4uZHN0KQogICAgICAgIGVuZAogICAgICAgIHplbmNvZGVfYXNzZXJ0KGRlc3RbbmFtZV0sICJDYW5ub3Qgb3ZlcndyaXRlOiAiLi5uYW1lLi4iIGluICIuLmRzdCkKICAgICAgICBBQ0tbZHN0XVtuYW1lXSA9IG9ialtuYW1lXQogICAgZW5kCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIG1vdmVfb3JfY29weV9mcm9tX3RvKGtleV9uYW1lLCBzb3VyY2UsIG5ldykKICAgIGxvY2FsIHNyYywgc3JjX2NvZGVjID0gaGF2ZShzb3VyY2UpCiAgICBsb2NhbCBrZXksIGtleV9lbmMgPSBtYXloYXZlKGtleV9uYW1lKQogICAgaWYgc3JjX2NvZGVjLnplbnR5cGUgPT0gJ2EnIHRoZW4KICAgICAgICBpZiBrZXkgdGhlbgogICAgICAgICAgICBpZiBrZXlfZW5jLmVuY29kaW5nID09ICJzdHJpbmciIHRoZW4KICAgICAgICAgICAgICAgIGtleSA9IGtleTpzdHIoKQogICAgICAgICAgICBlbHNlaWYga2V5X2VuYy5lbmNvZGluZyA9PSAiaW50ZWdlciIgdGhlbgogICAgICAgICAgICAgICAga2V5ID0ga2V5OmRlY2ltYWwoKQogICAgICAgICAgICBlbHNlaWYga2V5X2VuYy5lbmNvZGluZyA9PSAiZmxvYXQiIHRoZW4KICAgICAgICAgICAgICAgIGtleSA9IGtleTpfX3Rvc3RyaW5nKCkKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgYXJyYXkga2V5IGVuY29kaW5nOiAiLi5rZXlfZW5jLmVuY29kaW5nLCAyKQogICAgICAgICAgICBlbmQKICAgICAgICBlbHNlCiAgICAgICAgICAgIGtleSA9IGtleV9uYW1lCiAgICAgICAgZW5kCiAgICAgICAgbG9jYWwgcG9zID0gdG9udW1iZXIoa2V5KQogICAgICAgIGlmIG5vdCBwb3MgdGhlbiBlcnJvcigiSW52YWxpZCBhcnJheSBpbmRleDogIi4ua2V5LCAyKSBlbmQKICAgICAgICBrZXkgPSBwb3MKICAgIGVsc2UKICAgICAgICBpZiBrZXkgdGhlbgogICAgICAgICAgICBpZiBrZXlfZW5jLmVuY29kaW5nID09ICJzdHJpbmciIHRoZW4KICAgICAgICAgICAgICAgIGtleSA9IGtleTpzdHIoKQogICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICBlcnJvcigiSW52YWxpZCBkaWN0aW9uYXJ5IGtleSBlbmNvZGluZzogIi4ua2V5X2VuYy5lbmNvZGluZywgMikKICAgICAgICAgICAgZW5kCiAgICAgICAgZWxzZQogICAgICAgICAgICBrZXkgPSBrZXlfbmFtZQogICAgICAgIGVuZAogICAgZW5kCiAgICBpZiBub3Qgc3JjW2tleV0gdGhlbiBlcnJvcigiT2JqZWN0IG5vdCBmb3VuZDogIi4ua2V5Li4iIGluc2lkZSAiLi5zb3VyY2UsIDIpIGVuZAogICAgaWYgQUNLW25ld10gdGhlbgogICAgICAgIGVycm9yKCJDYW5ub3Qgb3ZlcndyaXRlIGV4aXN0aW5nIG9iamVjdDogIi4ubmV3Li4iXG4iLi4KICAgICAgICAgICAgICAiVG8gY29weS9tb3ZlIGVsZW1lbnQgaW4gZXhpc3RpbmcgZWxlbWVudCB1c2U6XG4iLi4KICAgICAgICAgICAgICAiV2hlbiBJIG1vdmUvY29weSAnJyBmcm9tICcnIGluICcnIiwgMikKICAgIGVuZAogICAgQUNLW25ld10gPSBkZWVwY29weShzcmNba2V5XSkKICAgIGxvY2FsIG5fY29kZWMgPSB7IGVuY29kaW5nID0gc3JjX2NvZGVjLmVuY29kaW5nIH0KICAgIC0tIHRhYmxlIG9mIHNjaGVtYXMgY2FuIG9ubHkgY29udGFpbiBlbGVtZW50cwogICAgaWYgc3JjX2NvZGVjLnNjaGVtYSB0aGVuCiAgICAgICAgbl9jb2RlYy5zY2hlbWEgPSBzcmNfY29kZWMuc2NoZW1hCiAgICAgICAgbl9jb2RlYy56ZW50eXBlID0gImUiCiAgICBlbmQKICAgIG5ld19jb2RlYyhuZXcsIG5fY29kZWMpCiAgICByZXR1cm4gc3JjX2NvZGVjLnplbnR5cGUgPT0gJ2EnLCBrZXkKZW5kCgpXaGVuKCJjb3B5ICcnIGZyb20gJycgdG8gJyciLCBtb3ZlX29yX2NvcHlfZnJvbV90bykKCldoZW4oIm1vdmUgJycgZnJvbSAnJyB0byAnJyIsIGZ1bmN0aW9uKGVsZSwgc291cmNlLCBuZXcpCiAgICBsb2NhbCBpc19hcnJheSwgdG9fcmVtb3ZlID0gbW92ZV9vcl9jb3B5X2Zyb21fdG8oZWxlLCBzb3VyY2UsIG5ldykKICAgIGlmIGlzX2FycmF5IHRoZW4KICAgICAgICB0YWJsZS5yZW1vdmUoQUNLW3NvdXJjZV0sIHRvX3JlbW92ZSkKICAgIGVsc2UKICAgICAgICBBQ0tbc291cmNlXVt0b19yZW1vdmVdID0gbmlsCiAgICBlbmQKZW5kKQoKV2hlbigic3BsaXQgcmlnaHRtb3N0ICcnIGJ5dGVzIG9mICcnIiwgZnVuY3Rpb24obGVuLCBzcmMpCglsb2NhbCBvYmogPSBoYXZlKHNyYykKCWVtcHR5J3JpZ2h0bW9zdCcKCWxvY2FsIHMgPSB0b251bWJlcihsZW4pCgl6ZW5jb2RlX2Fzc2VydChzLCAiSW52YWxpZCBudW1iZXIgYXJnICMxOiAiLi50eXBlKGxlbikpCglsb2NhbCBsLHIgPSBPQ1RFVC5jaG9wKG9iaiwjb2JqLXMpCglBQ0sucmlnaHRtb3N0ID0gcgoJQUNLW3NyY10gPSBsCgluZXdfY29kZWMoJ3JpZ2h0bW9zdCcsIHsgfSwgc3JjKQplbmQpCgpXaGVuKCJzcGxpdCBsZWZ0bW9zdCAnJyBieXRlcyBvZiAnJyIsIGZ1bmN0aW9uKGxlbiwgc3JjKQoJbG9jYWwgb2JqID0gaGF2ZShzcmMpCgllbXB0eSdsZWZ0bW9zdCcKCWxvY2FsIHMgPSB0b251bWJlcihsZW4pCgl6ZW5jb2RlX2Fzc2VydChzLCAiSW52YWxpZCBudW1iZXIgYXJnICMxOiAiLi50eXBlKGxlbikpCglsb2NhbCBsLHIgPSBPQ1RFVC5jaG9wKG9iaixzKQoJQUNLLmxlZnRtb3N0ID0gbAoJQUNLW3NyY10gPSByCgluZXdfY29kZWMoJ2xlZnRtb3N0JywgeyB9LCBzcmMpCmVuZCkKCmxvY2FsIGZ1bmN0aW9uIF9jb3VudGNoYXIoaGF5c3RhY2ssIG5lZWRsZSkKICAgIHJldHVybiBzZWxlY3QoMiwgc3RyaW5nLmdzdWIoaGF5c3RhY2ssIG5lZWRsZSwgIiIpKQplbmQKV2hlbigiY3JlYXRlIGNvdW50IG9mIGNoYXIgJycgZm91bmQgaW4gJyciLCBmdW5jdGlvbihuZWVkbGUsIGhheXN0YWNrKQoJbG9jYWwgaCA9IGhhdmUoaGF5c3RhY2spCgllbXB0eSdjb3VudCcKLS0JQUNLLmNvdW50ID0gX2NvdW50Y2hhcihPLnRvX3N0cmluZyhoKSwgbmVlZGxlKQoJQUNLLmNvdW50ID0gRi5uZXcoaDpvY3RldCgpOmNoYXJjb3VudCh0b3N0cmluZyhuZWVkbGUpKSkKCW5ld19jb2RlYygnY291bnQnLAoJCSAge2VuY29kaW5nID0gJ251bWJlcicsCgkJICAgemVudHlwZSA9ICdlJyB9KQplbmQpCgotLSBUT0RPOgotLSBXaGVuKCJzZXQgJycgYXMgJycgd2l0aCAnJyIsIGZ1bmN0aW9uKGRlc3QsIGZvcm1hdCwgY29udGVudCkgZW5kKQotLSBXaGVuKCJhcHBlbmQgJycgYXMgJycgdG8gJyciLCBmdW5jdGlvbihjb250ZW50LCBmb3JtYXQsIGRlc3QpIGVuZCkKLS0gV2hlbigid3JpdGUgJycgYXMgJycgaW4gJyciLCBmdW5jdGlvbihjb250ZW50LCBkZXN0KSBlbmQpCi0tIGltcGxpY2l0IGNvbnZlcnNpb24gYXMgc3RyaW5nCgpsb2NhbCBmdW5jdGlvbiBfcm1femVyb3NfaW4odCkKICAgIGxvY2FsIHplcm9zIDxjb25zdD4gPSB7CiAgICAgICAgbnVtYmVyID0gMCwKICAgICAgICBbJ3plbnJvb20uZmxvYXQnXSA9IEYubmV3KDApLAogICAgICAgIFsnemVucm9vbS5iaWcnXSA9IEJJRy5uZXcoMCkKICAgIH0KICAgIGlmIGlzYXJyYXkodCkgdGhlbgogICAgICAgIGxvY2FsIGFyciA9IHt9CiAgICAgICAgZm9yIF8sIHYgaW4gcGFpcnModCkgZG8KICAgICAgICAgICAgaWYgdHlwZSh2KSA9PSAndGFibGUnIHRoZW4KICAgICAgICAgICAgICAgIHRhYmxlLmluc2VydChhcnIsIF9ybV96ZXJvc19pbih2KSkKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgbG9jYWwgeiA9IHplcm9zW3R5cGUodildCiAgICAgICAgICAgICAgICBpZiBub3QgeiBvciAoIHogYW5kIHYgfj0geikgdGhlbgogICAgICAgICAgICAgICAgICAgIHRhYmxlLmluc2VydChhcnIsIHYpCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgZW5kCiAgICAgICAgZW5kCiAgICAgICAgcmV0dXJuIGFycgogICAgZWxzZQogICAgICAgIGZvciBrLHYgaW4gcGFpcnModCkgZG8KICAgICAgICAgICAgaWYgdHlwZSh2KSA9PSAndGFibGUnIHRoZW4KICAgICAgICAgICAgICAgIHRba10gPSBfcm1femVyb3NfaW4odikKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgbG9jYWwgeiA9IHplcm9zW3R5cGUodildCiAgICAgICAgICAgICAgICBpZiB6IGFuZCB2ID09IHogdGhlbgogICAgICAgICAgICAgICAgICAgIHRba10gPSBuaWwKICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICBlbmQKICAgICAgICBlbmQKICAgICAgICByZXR1cm4gdAogICAgZW5kCmVuZAotLSBodHRwczovL2dpdGh1Yi5jb20vZHluZS9aZW5yb29tL2lzc3Vlcy8xNzUKV2hlbigicmVtb3ZlIHplcm8gdmFsdWVzIGluICcnIiwgZnVuY3Rpb24odGFyZ2V0KQogICAgbG9jYWwgdCA9IGhhdmUodGFyZ2V0KQogICAgemVuY29kZV9hc3NlcnQobHVhdHlwZSh0KSA9PSAndGFibGUnLCAiSW52YWxpZCB0YWJsZSBvYmplY3Q6ICIuLnRhcmdldCkKICAgIEFDS1t0YXJnZXRdID0gX3JtX3plcm9zX2luKHQpCmVuZCkKCldoZW4oInJlbW92ZSBzcGFjZXMgaW4gJyciLCBmdW5jdGlvbih0YXJnZXQpCiAgICBsb2NhbCBzcmMgPSBoYXZlKHRhcmdldCkKICAgIHplbmNvZGVfYXNzZXJ0KG5vdCBpc251bWJlcihzcmMpLCAiSW52YWxpZCBudW1iZXIgb2JqZWN0OiAiLi50YXJnZXQpCiAgICB6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKHNyYykgfj0gJ3RhYmxlJywgIkludmFsaWQgdGFibGUgb2JqZWN0OiAiLi50YXJnZXQpCiAgICBBQ0tbdGFyZ2V0XSA9IHNyYzpvY3RldCgpOnJtY2hhciggTy5mcm9tX2hleCgnMjAnKSApCmVuZCkKCldoZW4oInJlbW92ZSBuZXdsaW5lcyBpbiAnJyIsIGZ1bmN0aW9uKHRhcmdldCkKICAgIGxvY2FsIHNyYyA9IGhhdmUodGFyZ2V0KQogICAgemVuY29kZV9hc3NlcnQobm90IGlzbnVtYmVyKHNyYyksICJJbnZhbGlkIG51bWJlciBvYmplY3Q6ICIuLnRhcmdldCkKICAgIHplbmNvZGVfYXNzZXJ0KGx1YXR5cGUoc3JjKSB+PSAndGFibGUnLCAiSW52YWxpZCB0YWJsZSBvYmplY3Q6ICIuLnRhcmdldCkKICAgIEFDS1t0YXJnZXRdID0gc3JjOm9jdGV0KCk6cm1jaGFyKCBPLmZyb21faGV4KCcwQScpICkKZW5kKQoKV2hlbigicmVtb3ZlIG9jY3VycmVuY2VzIG9mIGNoYXJhY3RlciAnJyBpbiAnJyIsCiAgICAgZnVuY3Rpb24oY2hhciwgdGFyZ2V0KQogICAgbG9jYWwgc3JjID0gaGF2ZSh0YXJnZXQpCiAgICBsb2NhbCBjaCA9IGhhdmUoY2hhcikKICAgIHplbmNvZGVfYXNzZXJ0KG5vdCBpc251bWJlcihzcmMpLCAiSW52YWxpZCBudW1iZXIgb2JqZWN0OiAiLi50YXJnZXQpCiAgICB6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKHNyYykgfj0gJ3RhYmxlJywgIkludmFsaWQgdGFibGUgb2JqZWN0OiAiLi50YXJnZXQpCiAgICB6ZW5jb2RlX2Fzc2VydChub3QgaXNudW1iZXIoY2gpLCAiSW52YWxpZCBudW1iZXIgb2JqZWN0OiAiLi5jaGFyKQogICAgemVuY29kZV9hc3NlcnQobHVhdHlwZShjaCkgfj0gJ3RhYmxlJywgIkludmFsaWQgdGFibGUgb2JqZWN0OiAiLi5jaGFyKQogICAgQUNLW3RhcmdldF0gPSBzcmM6b2N0ZXQoKTpybWNoYXIoIGNoOm9jdGV0KCkgKQplbmQpCgpXaGVuKCJjb21wYWN0IGFzY2lpIHN0cmluZ3MgaW4gJyciLAogICAgIGZ1bmN0aW9uKHRhcmdldCkKCWxvY2FsIHNyYyA9IGhhdmUodGFyZ2V0KQoJemVuY29kZV9hc3NlcnQobm90IGlzbnVtYmVyKHNyYyksICJJbnZhbGlkIG51bWJlciBvYmplY3Q6ICIuLnRhcmdldCkKCXplbmNvZGVfYXNzZXJ0KGx1YXR5cGUoc3JjKSB+PSAndGFibGUnLCAiSW52YWxpZCB0YWJsZSBvYmplY3Q6ICIuLnRhcmdldCkKICAgIEFDS1t0YXJnZXRdID0gc3JjOm9jdGV0KCk6Y29tcGFjdF9hc2NpaSgpCmVuZCkKCi0tIFdoZW4oInJlbW92ZSBhbGwgZW1wdHkgc3RyaW5ncyBpbiAnJyIsIGZ1bmN0aW9uKHRhcmdldCkKLS0gCWhhdmUodGFyZ2V0KQotLSAJQUNLW3RhcmdldF0gPSBkZWVwbWFwKGZ1bmN0aW9uKHYpIGlmIHRyaW0odikgPT0gJycgdGhlbiByZXR1cm4gbmlsIGVuZCwgQUNLW3RhcmdldF0pCi0tIGVuZCkKCldoZW4oImNyZWF0ZSAnJyBjYXN0IG9mIHN0cmluZ3MgaW4gJyciLCBmdW5jdGlvbihjb252LCBzb3VyY2UpCgl6ZW5jb2RlX2Fzc2VydChDT0RFQ1tzb3VyY2VdLCAiT2JqZWN0IGhhcyBubyBjb2RlYzogIi4uc291cmNlKQoJemVuY29kZV9hc3NlcnQoQ09ERUNbc291cmNlXS5lbmNvZGluZyA9PSAnc3RyaW5nJywgIk9iamVjdCBoYXMgbm8gc3RyaW5nIGVuY29kaW5nOiAiLi5zb3VyY2UpCgllbXB0eShjb252KQoJbG9jYWwgc3JjID0gaGF2ZShzb3VyY2UpCglsb2NhbCBlbmMgPSBpbnB1dF9lbmNvZGluZyhjb252KQoJaWYgbHVhdHlwZShzcmMpID09ICd0YWJsZScgdGhlbgoJICAgQUNLW2NvbnZdID0gZGVlcG1hcChmdW5jdGlvbih2KQoJCSBsb2NhbCBzID0gT0NURVQudG9fc3RyaW5nKHYpCgkJIHplbmNvZGVfYXNzZXJ0KGVuYy5jaGVjayhzKSwgIk9iamVjdCB2YWx1ZSBpcyBub3QgYSAiLi5jb252Li4iOiAiLi5zb3VyY2UpCgkJIHJldHVybiBlbmMuZnVuKCBzICkKCSAgIGVuZCwgc3JjKQoJZWxzZQoJICAgbG9jYWwgcyA9IE9DVEVULnRvX3N0cmluZyhzcmMpCgkgICB6ZW5jb2RlX2Fzc2VydChlbmMuY2hlY2socyksICJPYmplY3QgdmFsdWUgaXMgbm90IGEgIi4uY29udi4uIjogIi4uc291cmNlKQoJICAgQUNLW2NvbnZdID0gZW5jLmZ1bihzKQoJZW5kCgluZXdfY29kZWMoY29udiwge2VuY29kaW5nID0gY29udn0pCmVuZCkKCldoZW4oImNyZWF0ZSBmbG9hdCAnJyBjYXN0IG9mIGludGVnZXIgaW4gJyciLCBmdW5jdGlvbihkZXN0LCBzb3VyY2UpCgllbXB0eShkZXN0KQoJbG9jYWwgc3JjID0gaGF2ZShzb3VyY2UpCiAgICBpZiB0eXBlKHNyYykgfj0gJ3plbnJvb20uYmlnJyB0aGVuCiAgICAgICAgc3JjID0gQklHLm5ldyhzcmMpCiAgICBlbmQKICAgIEFDS1tkZXN0XSA9IEYubmV3KEJJRy50b19kZWNpbWFsKHNyYykpCgluZXdfY29kZWMoZGVzdCwge2VuY29kaW5nID0gJ2Zsb2F0J30pCmVuZCkKCldoZW4oImV4aXQgd2l0aCBlcnJvciBtZXNzYWdlICcnIiwgZnVuY3Rpb24oZXJyKQogICAgbG9jYWwgZSwgZV9jb2RlYyA9IG1heWhhdmUoZXJyKQogICAgaWYgZSB0aGVuCiAgICAgICAgemVuY29kZV9hc3NlcnQobHVhdHlwZShlKSB+PSAndGFibGUnLCAiRXJyb3IgbWVzc2FnZSBjYW4gbm90IGJlIGEgdGFibGUgIi4uZXJyKQogICAgICAgIHplbmNvZGVfYXNzZXJ0KGVfY29kZWMuZW5jb2RpbmcgPT0gJ3N0cmluZycsICJFcnJvciBtZXNzYWdlIG11c3QgYmUgYSBzdHJpbmcgIi4uZXJyKQogICAgICAgIGUgPSBPLnRvX3N0cmluZyhlKQogICAgZWxzZQogICAgICAgIGUgPSBlcnIKICAgIGVuZAogICAgZXJyb3Ioc3BhY2UoZSkpCiAgICBaRU4uT0sgPSBmYWxzZQplbmQpCi96ZW5yb29tX2JlbmNoLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAxOS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBUdWVzZGF5LCAyMHRoIEp1bHkgMjAyMQotLV1dCgpsb2NhbCBiZW5jaCA9IHsgfQoKYmVuY2guZW50cm9weSA9IGZ1bmN0aW9uKCkKICAgYWN0KCJCZW5jaG1hcms6IGVudHJvcHkgb2YgcmFuZG9tIGdlbmVyYXRvcnMgKFNoYW5ub24gcmF0aW9zKSIpCiAgIC0tIHVzZSBzdGFuZGFyZCBFQ1Agc2l6ZQogICBsb2NhbCBzID0gI0VDUC5yYW5kb20oKTpvY3RldCgpCiAgIHJldHVybiB7IFNFRUQgPSBSTkdTRUVEOmVudHJvcHkoKSwKCSAgICBQUk5HID0gT0NURVQucmFuZG9tKDI1Nik6ZW50cm9weSgpLAoJICAgIE9DVEVUID0gT0NURVQucmFuZG9tKHMpOmVudHJvcHkoKSwKCSAgICBCSUcgPSBCSUcucmFuZG9tKCk6b2N0ZXQoKTplbnRyb3B5KCksCgkgICAgRUNQID0gRUNQLnJhbmRvbSgpOm9jdGV0KCk6ZW50cm9weSgpLAoJICAgIEVDUDIgPSBFQ1AyLnJhbmRvbSgpOm9jdGV0KCk6ZW50cm9weSgpIH0KZW5kCgpiZW5jaC5yYW5kb21faGFtbWluZ19mcmVxID0gZnVuY3Rpb24gKHMsIHEpCiAgIGxvY2FsIF9zID0gcyBvciA5NwogICBsb2NhbCBfcSA9IHEgb3IgNTAwMAogICBhY3QoIkJlbmNobWFyazogaGFtbWluZyBkaXN0YW5jZSBiZXR3ZWVuIHJhbmRvbSwgYXJndW1lbnRzOiAiLi5fcy4uIiAiLi5fcSkKCiAgIC0tIEVDUCBjb29yZGluYXRlcyBhcmUgOTcgYnl0ZXMKICAgbG9jYWwgbmV3ID0gTy5yYW5kb20oX3MpCiAgIGxvY2FsIHRvdCA9IDAKICAgbG9jYWwgb2xkCiAgIGZvciBpPV9xLDEsLTEgZG8KCSAgb2xkID0gbmV3CgkgIG5ldyA9IE8ucmFuZG9tKF9zKQoJICB0b3QgPSB0b3QgKyBPLmhhbW1pbmcob2xkLG5ldykKICAgZW5kCiAgIHJldHVybiB0b3QgLyBfcQplbmQKCmJlbmNoLnJhbmRvbV9rZGYgPSBmdW5jdGlvbigpCiAgIGFjdCgiQmVuY2htYXJrOiBLREYyIFNIQTI1NiBhbmQgU0hBNTEyIG9uIHJhbmRvbSIpCiAgIC0tIEtERjIgaW5wdXQgY2FuIGJlIGFueSwgb3V0cHV0CiAgIGxvY2FsIHIgPSBPLnJhbmRvbSg2NCkKICAgSEFTSC5rZGYyKEhBU0gubmV3KCdTSEEyNTYnKSxyKQogICBIQVNILmtkZjIoSEFTSC5uZXcoJ1NIQTUxMicpLHIpCmVuZAoKCi0tIGZpbmQgcHJpbWVzCmxvY2FsIHNxdWFyZSA9IHt9IGZvciBpPTAsOSBkbyBzcXVhcmVbaV09aSppIGVuZApsb2NhbCBmdW5jdGlvbiBzcXJzdW0obikKICAgbG9jYWwgc3VtID0gMAogICB3aGlsZSBuID4gMCBkbyBzdW0sIG4gPSBzdW0gKyBzcXVhcmVbbiAlIDEwXSwgbWF0aC5mbG9vcihuIC8gMTApIGVuZAogICByZXR1cm4gc3VtCmVuZApsb2NhbCBmdW5jdGlvbiBpc0hhcHB5KG4pCiAgIHdoaWxlIG4gfj0gMSBhbmQgbiB+PSA0IGRvIG4gPSBzcXJzdW0obikgZW5kCiAgIHJldHVybiBuID09IDEKZW5kCmxvY2FsIHByaW1lX251bWJlcnMgPSB7IDIsIDMgfQpsb2NhbCBmdW5jdGlvbiBpc1ByaW1lKG4pCiAgIGlmIG4gPT0gMSB0aGVuIHJldHVybiB0cnVlIGVuZAogICBmb3IgXyxpIGluIGlwYWlycyhwcmltZV9udW1iZXJzKSBkbwoJICBpZiBuID09IGkgdGhlbiByZXR1cm4gdHJ1ZSBlbmQKCSAgaWYgbiVpID09IDAgdGhlbiByZXR1cm4gZmFsc2UgZW5kCiAgIGVuZAogICBmb3IgaSA9IHByaW1lX251bWJlcnNbI3ByaW1lX251bWJlcnNdLCBtYXRoLmZsb29yKG4vMikrMSwgMiBkbwoJICBpZiBuJWkgPT0gMCB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgZW5kCiAgIGlmIG4gPiBwcmltZV9udW1iZXJzWyNwcmltZV9udW1iZXJzXSB0aGVuCgkgIHRhYmxlLmluc2VydChwcmltZV9udW1iZXJzLCBuKQogICBlbmQKICAgcmV0dXJuIHRydWUKZW5kCmJlbmNoLm1hdGggPSBmdW5jdGlvbihhLCBiLCBjKQoKICAgbG9jYWwgX2EgPSBhIG9yIDUwMDAwCiAgIGxvY2FsIF9iID0gYiBvciBfYSs1MDAwMAogICBsb2NhbCBfYyA9IGMgb3IgMQogICBhY3QoIkJlbmNobWFyazogbWF0aCBiYXNlZCBwcmltZSBudW1iZXIsIGFyZ3M6ICIuLl9hLi4iICIuLl9iLi4iICIuLl9jKQogICBsb2NhbCByZXMgPSB7IH0KICAgZm9yIG49X2EsX2IsX2MgZG8gCgkgIGlmIGlzSGFwcHkobikgYW5kIGlzUHJpbWUobikgdGhlbgoJCSB0YWJsZS5pbnNlcnQocmVzLCBuKQoJICBlbmQKICAgZW5kCiAgIHJldHVybiByZXMKZW5kCgpmdW5jdGlvbiBiZW5jaC5iaXQzMihOKQogICBOID0gTiBvciAxMDAwCiAgIGFjdCgiQmVuY2htYXJrOiBiaXQzMiBiYXNlZCBNYW5kZWxicm90IGdlbmVyYXRpb24sIGl0ZXJhdGlvbnM6ICIuLk4pCiAgIGxvY2FsIGJpdCA9IGJpdDMyCiAgIGxvY2FsIGJvciwgYmFuZCA9IGJpdC5ib3IsIGJpdC5iYW5kCiAgIGxvY2FsIHNobCwgc2hyLCByb2wgPSBiaXQubHNoaWZ0LCBiaXQucnNoaWZ0LCBiaXQubHJvdGF0ZQogICBsb2NhbCBjaGFyLCB1bnBhY2sgPSBzdHJpbmcuY2hhciwgdGFibGUudW5wYWNrCgogICBsb2NhbCBNLCBidWYgPSAyL04sIHt9CiAgIGZvciB5PTAsTi0xIGRvCgkgIGxvY2FsIENpLCBiLCBwID0geSpNLTEsIC0xNjc3NzIxNiwgMAoJICBsb2NhbCBDaXEgPSBDaSpDaQoJICBmb3IgeD0wLE4tMSwyIGRvCgkJIGxvY2FsIENyLCBDcjIgPSB4Kk0tMS41LCAoeCsxKSpNLTEuNQoJCSBsb2NhbCBaciwgWmksIFpycSwgWmlxID0gQ3IsIENpLCBDcipDciwgQ2lxCgkJIGxvY2FsIFpyMiwgWmkyLCBacnEyLCBaaXEyID0gQ3IyLCBDaSwgQ3IyKkNyMiwgQ2lxCgkJIGIgPSByb2woYiwgMikKCQkgZm9yIGk9MSw0OSBkbwoJCQlaaSA9IFpyKlppKjIgKyBDaTsgWmkyID0gWnIyKlppMioyICsgQ2kKCQkJWnIgPSBacnEtWmlxICsgQ3I7IFpyMiA9IFpycTItWmlxMiArIENyMgoJCQlaaXEgPSBaaSpaaTsgWmlxMiA9IFppMipaaTIKCQkJWnJxID0gWnIqWnI7IFpycTIgPSBacjIqWnIyCgkJCWlmIGJhbmQoYiwgMikgfj0gMCBhbmQgWnJxK1ppcSA+IDQuMCB0aGVuIGIgPSBiYW5kKGIsIC0zKSBlbmQKCQkJaWYgYmFuZChiLCAxKSB+PSAwIGFuZCBacnEyK1ppcTIgPiA0LjAgdGhlbiBiID0gYmFuZChiLCAtMikgZW5kCgkJCWlmIGJhbmQoYiwgMykgPT0gMCB0aGVuIGJyZWFrIGVuZAoJCSBlbmQKCQkgaWYgYiA+PSAwIHRoZW4gcCA9IHAgKyAxOyBidWZbcF0gPSBiOyBiID0gLTE2Nzc3MjE2OyBlbmQKCSAgZW5kCgkgIGlmIGIgfj0gLTE2Nzc3MjE2IHRoZW4KCQkgaWYgYmFuZChOLCAxKSB+PSAwIHRoZW4gYiA9IHNocihiLCAxKSBlbmQKCQkgcCA9IHAgKyAxOyBidWZbcF0gPSBzaGwoYiwgOC1iYW5kKE4sIDcpKQoJICBlbmQKCSAgLS0gd3JpdGUoY2hhcih1bnBhY2soYnVmLCAxLCBwKSkpCgkgIC0tIHdyaXRlKCcuJykKICAgZW5kCiAgIC0tIHByaW50KCcuJykKZW5kCgoKCnJldHVybiBiZW5jaAovemVucm9vbV9iaWcubHVhAGxvY2FsIGJpZyA9IHJlcXVpcmUnYmlnJwotLSBvcHRpbWl6YXRpb246IHdlIGNvdWxkIGltcGxlbWVudCBpdCBpbiBDCmZ1bmN0aW9uIGJpZy5zcXJ0KG51bSkKICBsb2NhbCB0d28gPSBCSUcubmV3KDIpCiAgbG9jYWwgeG4gPSBudW0KICBsb2NhbCB4bm47CgogIGlmIHhuIH49IEJJRy5uZXcoMCkgdGhlbgogICAgeG5uID0gKHhuICsgKG51bSAvIHhuKSkgLyB0d28KICAgIHdoaWxlIHhubiA8IHhuIGRvCiAgICAgIHhuID0geG5uCiAgICAgIHhubiA9ICh4biArIChudW0gLyB4bikpIC8gdHdvCiAgICBlbmQKICBlbmQKCgogIHJldHVybiB4bgogIAplbmQKCnJldHVybiBiaWcKL3plbnJvb21fY29tbW9uLmx1YQAtLVtbCiAgICAtLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KICAgIC0tCiAgICAtLUNvcHlyaWdodCAoQykgMjAxOC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KICAgIC0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KICAgIC0tCiAgICAtLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5CiAgICAtLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKICAgIC0tCiAgICAtLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAogICAgLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgogICAgLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCiAgICAtLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgogICAgLS0KICAgIC0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKICAgIC0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKICAgIC0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tXV0KCi0tIG92ZXJyaWRlIHR5cGUgdG8gcmVjb2duaXplIHplbnJvb20ncyB0eXBlcwpsb2NhbCBfbHVhdHlwZSA8Y29uc3Q+ID0gX0dbJ3R5cGUnXQpfR1snbHVhdHlwZSddID0gX2x1YXR5cGUKCmxvY2FsIF90eXBlIDxjb25zdD4gPSBmdW5jdGlvbih2YXIpCiAgICBsb2NhbCBzaW1wbGUgPSBsdWF0eXBlKHZhcikKICAgIGlmIHNpbXBsZSA9PSAidXNlcmRhdGEiIHRoZW4KICAgICAgICBsb2NhbCBtZXRhID0gZ2V0bWV0YXRhYmxlKHZhcikKICAgICAgICBpZiBtZXRhIHRoZW4gcmV0dXJuKG1ldGEuX19uYW1lKQogICAgICAgIGVsc2UgcmV0dXJuKCJ1bmtub3duIikgZW5kCiAgICBlbHNlIHJldHVybihzaW1wbGUpIGVuZAplbmQKX0dbJ3R5cGUnXSA9IF90eXBlCgotLSBUT0RPOiBvcHRpbWlzZSBpbiBDCmxvY2FsIF9pc3plbiA8Y29uc3Q+ID0gZnVuY3Rpb24obikKICAgIGlmIG5vdCBuIHRoZW4KICAgICAgICBlcnJvcigiQ2Fubm90IHBhcnNlIG51bGwgemVucm9vbSB0eXBlIiwyKSBlbmQKICAgIGZvciBfIGluIG46Z21hdGNoKCJ6ZW5yb29tIikgZG8KICAgICAgICByZXR1cm4gdHJ1ZQogICAgZW5kCiAgICByZXR1cm4gZmFsc2UKZW5kCl9HWydpc3plbiddID0gX2lzemVuCgotLSB3b3JrYXJvdW5kIGZvciBhIHRlcm5hcnkgY29uZGl0aW9uYWwgb3BlcmF0b3IKZnVuY3Rpb24gZmlmKGNvbmRpdGlvbiwgaWZfdHJ1ZSwgaWZfZmFsc2UpCiAgICBpZiBjb25kaXRpb24gdGhlbiByZXR1cm4gaWZfdHJ1ZSBlbHNlIHJldHVybiBpZl9mYWxzZSBlbmQKZW5kCgotLSByZWxpYWJsZSB0YWJsZSBzaXplIG1lYXN1cmVtZW50Cl9HWyd0YWJsZV9zaXplJ10gPSBmdW5jdGlvbih0KQogICAgaWYgbm90IHQgdGhlbiByZXR1cm4gMCBlbmQKICAgIGlmIGx1YXR5cGUodCkgfj0gJ3RhYmxlJyB0aGVuCiAgICAgICAgZXJyb3IoInRhYmxlX3NpemUgYXJndW1lbnQgaXMgbm90IGEgdGFibGU6ICIuLnR5cGUodCksMikKICAgIGVuZAogICAgbG9jYWwgYyA9IDAKICAgIGZvciBfIGluIHBhaXJzKHQpIGRvCiAgICAgICAgYyA9IGMgKyAxCiAgICBlbmQKICAgIHJldHVybiBjCmVuZAoKX0dbJ3VzY29yZSddID0gZnVuY3Rpb24oaW5wdXQpCiAgICBsb2NhbCBpdCA9IGx1YXR5cGUoaW5wdXQpCiAgICBpZiBpdCA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICAgcmV0dXJuIHN0cmluZy5nc3ViKGlucHV0LCAnICcsICdfJykKICAgIGVsc2VpZiBpdCA9PSAnbnVtYmVyJyB0aGVuCiAgICAgICAgcmV0dXJuIGlucHV0CiAgICBlbHNlCiAgICAgICAgZXJyb3IoIlVuZGVyc2NvcmUgdHJhbnNmb3JtIG5vdCBhIHN0cmluZyBvciBudW1iZXI6ICIuLml0LCAzKQogICAgZW5kCmVuZApfR1snc3BhY2UnXSA9IGZ1bmN0aW9uKGlucHV0KQogICAgbG9jYWwgaXQgPSBsdWF0eXBlKGlucHV0KQogICAgaWYgaXQgPT0gJ3N0cmluZycgdGhlbgogICAgICAgIHJldHVybiBzdHJpbmcuZ3N1YihpbnB1dCwgJ18nLCAnICcpCiAgICBlbHNlaWYgaXQgPT0gJ251bWJlcicgdGhlbgogICAgICAgIHJldHVybiBpbnB1dAogICAgZWxzZQogICAgICAgIGVycm9yKCJXaGl0ZXNwYWNlIHRyYW5zZm9ybSBub3QgYSBzdHJpbmcgb3IgbnVtYmVyOiAiLi5pdCwgMykKICAgIGVuZAplbmQKCl9HWydzdHJ0b2snXSA9IGZ1bmN0aW9uKHN0ciwgZGVsaW1pdGVyKQogICAgZGVsaW1pdGVyID0gZGVsaW1pdGVyIG9yICcgJwogICAgbG9jYWwgcmVzdWx0ID0ge30KICAgIGxvY2FsIHN0YXJ0ID0gMQogICAgbG9jYWwgZGVsaW1pdGVyUG9zID0gc3RyaW5nLmZpbmQoc3RyLCBkZWxpbWl0ZXIsIHN0YXJ0LCB0cnVlKQoKICAgIHdoaWxlIGRlbGltaXRlclBvcyBkbwogICAgICAgIGxvY2FsIHRva2VuID0gc3RyaW5nLnN1YihzdHIsIHN0YXJ0LCBkZWxpbWl0ZXJQb3MgLSAxKQogICAgICAgIHRhYmxlLmluc2VydChyZXN1bHQsIHRva2VuKQogICAgICAgIHN0YXJ0ID0gZGVsaW1pdGVyUG9zICsgMQogICAgICAgIGRlbGltaXRlclBvcyA9IHN0cmluZy5maW5kKHN0ciwgZGVsaW1pdGVyLCBzdGFydCwgdHJ1ZSkKICAgIGVuZAoKICAgIGxvY2FsIGxhc3RUb2tlbiA9IHN0cmluZy5zdWIoc3RyLCBzdGFydCkKICAgIGlmIGxhc3RUb2tlbiB+PSAiIiB0aGVuCiAgICAgICAgdGFibGUuaW5zZXJ0KHJlc3VsdCwgbGFzdFRva2VuKQogICAgZW5kCgogICAgcmV0dXJuIHJlc3VsdAplbmQKCi0tIHNvcnRlZCBpdGVyYXRvciBmb3IgZGV0ZXJtaW5pc3RpYyBvcmRlcmluZyBvZiB0YWJsZXMKLS0gZnJvbTogaHR0cHM6Ly93d3cubHVhLm9yZy9waWwvMTkuMy5odG1sCl9HWyJsdWFfcGFpcnMiXSAgPSBfR1sicGFpcnMiXQpfR1sibHVhX2lwYWlycyJdID0gX0dbImlwYWlycyJdCmxvY2FsIGZ1bmN0aW9uIF9wYWlycyh0KQogICAgbG9jYWwgYSA9IHt9CiAgICBmb3IgbiBpbiBsdWFfcGFpcnModCkgZG8gdGFibGUuaW5zZXJ0KGEsIG4pIGVuZAogICAgUVNPUlQoYSkgLS0gVE9ETzogY2Fubm90IHNvcnQgb3ZlciB6ZW5yb29tIHR5cGVzCiAgICBsb2NhbCBpID0gMCAgICAgIC0tIGl0ZXJhdG9yIHZhcmlhYmxlCiAgICByZXR1cm4gZnVuY3Rpb24gKCkgICAtLSBpdGVyYXRvciBmdW5jdGlvbgogICAgICAgIGkgPSBpICsgMQogICAgICAgIC0tIGlmIGFbaV0gPT0gbmlsIHRoZW4gcmV0dXJuIG5pbAogICAgICAgIHJldHVybiBhW2ldLCB0W2FbaV1dCiAgICBlbmQKZW5kCmxvY2FsIGZ1bmN0aW9uIF9pcGFpcnModCkKICAgIGxvY2FsIGEgPSB7fQogICAgZm9yIG4gaW4gbHVhX2lwYWlycyh0KSBkbyB0YWJsZS5pbnNlcnQoYSwgbikgZW5kCiAgICBRU09SVChhKQogICAgbG9jYWwgaSA9IDAgICAgICAtLSBpdGVyYXRvciB2YXJpYWJsZQogICAgcmV0dXJuIGZ1bmN0aW9uICgpICAgLS0gaXRlcmF0b3IgZnVuY3Rpb24KICAgICAgICBpID0gaSArIDEKICAgICAgICAtLSBpZiBhW2ldID09IG5pbCB0aGVuIHJldHVybiBuaWwKICAgICAgICByZXR1cm4gYVtpXQogICAgZW5kCmVuZAotLSBTd2l0Y2ggdG8gZGV0ZXJtaW5pc3RpYyAoc29ydGVkKSB0YWJsZSBpdGVyYXRvcnM6IHRoaXMgYnJlYWtzIGx1YQotLSB0ZXN0cyBpbiBwYXJ0aWN1bGFyIHRob3NlIHN0cmVzc2luZyBpL3BhaXJzIGFuZCBwYWNrL3VucGFjaywgd2hpY2gKLS0gYXJlIGFueXdheSB1bm5lY2Vzc2FyeSBjb3JuZXIgY2FzZXMgaW4gemVucm9vbSwgd2hpY2ggZXhpdHMgY2xlYW5seQotLSBhbmQgc2lnbmFsaW5nIGEgc3RhY2sgb3ZlcmZsb3cuIFBsZWFzZSByZXBvcnQgYmFjayBpZiB0aGlzCi0tIGdlbmVyYXRlcyBwcm9ibGVtcyBsZWFkaW5nIHRvIHRoZSBwYWlycyBmb3IgbG9vcCBpbiBmdW5jdGlvbiBhYm92ZS4KX0dbInNvcnRfcGFpcnMiXSAgPSBfcGFpcnMKX0dbInNvcnRfaXBhaXJzIl0gPSBfcGFpcnMKCmxvY2FsIGZ1bmN0aW9uIF9kZWVwY29weShvcmlnKQogICAgbG9jYWwgb3JpZ190eXBlID0gdHlwZShvcmlnKQogICAgbG9jYWwgY29weQogICAgaWYgb3JpZ190eXBlID09ICd0YWJsZScgdGhlbgogICAgICAgIGNvcHkgPSB7fQogICAgICAgIGZvciBvcmlnX2tleSwgb3JpZ192YWx1ZSBpbiBuZXh0LCBvcmlnLCBuaWwgZG8KICAgICAgICAgICAgY29weVtfZGVlcGNvcHkob3JpZ19rZXkpXSA9IF9kZWVwY29weShvcmlnX3ZhbHVlKQogICAgICAgIGVuZAogICAgICAgIHNldG1ldGF0YWJsZShjb3B5LCBfZGVlcGNvcHkoZ2V0bWV0YXRhYmxlKG9yaWcpKSkKICAgIGVsc2UgLS0gbnVtYmVyLCBzdHJpbmcsIGJvb2xlYW4sIGV0YwogICAgICAgIGNvcHkgPSBvcmlnCiAgICBlbmQKICAgIHJldHVybiBjb3B5CmVuZApfR1snZGVlcGNvcHknXSA9IF9kZWVwY29weQoKLS0gY29tcGFyZSB0d28gdGFibGVzCmxvY2FsIGZ1bmN0aW9uIF9kZWVwY21wKGxlZnQsIHJpZ2h0KQogICAgaWYgbm90ICggbHVhdHlwZShsZWZ0KSA9PSAidGFibGUiICkgdGhlbgogICAgICAgIGVycm9yKCJJbnRlcm5hbCBlcnJvcjogZGVlcGNtcCAxc3QgYXJndW1lbnQgaXMgbm90IGEgdGFibGUiKQogICAgZW5kCiAgICBpZiBub3QgKCBsdWF0eXBlKHJpZ2h0KSA9PSAidGFibGUiICkgdGhlbgogICAgICAgIGVycm9yKCJJbnRlcm5hbCBlcnJvcjogZGVlcGNtcCAybmQgYXJndW1lbnQgaXMgbm90IGEgdGFibGUiKQogICAgZW5kCiAgICBpZiBsZWZ0ID09IHJpZ2h0IHRoZW4gcmV0dXJuIHRydWUgZW5kCiAgICBmb3Iga2V5MSwgdmFsdWUxIGluIHBhaXJzKGxlZnQpIGRvCiAgICAgICAgbG9jYWwgdmFsdWUyID0gcmlnaHRba2V5MV0KICAgICAgICBpZiB2YWx1ZTIgPT0gbmlsIHRoZW4gcmV0dXJuIGZhbHNlCiAgICAgICAgZWxzZWlmIHZhbHVlMSB+PSB2YWx1ZTIgdGhlbgogICAgICAgICAgICBpZiB0eXBlKHZhbHVlMSkgPT0gInRhYmxlIiBhbmQgdHlwZSh2YWx1ZTIpID09ICJ0YWJsZSIgdGhlbgogICAgICAgICAgICAgICAgaWYgbm90IF9kZWVwY21wKHZhbHVlMSwgdmFsdWUyKSB0aGVuCiAgICAgICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlCiAgICAgICAgICAgICAgICBlbmQKICAgICAgICAgICAgZWxzZQogICAgICAgICAgICAgICAgcmV0dXJuIGZhbHNlCiAgICAgICAgICAgIGVuZAogICAgICAgIGVuZAogICAgZW5kCiAgICAtLSBjaGVjayBmb3IgbWlzc2luZyBrZXlzIGluIHRibDEKICAgIGZvciBrZXkyLCBfIGluIHBhaXJzKHJpZ2h0KSBkbwogICAgICAgIGlmIGxlZnRba2V5Ml0gPT0gbmlsIHRoZW4KICAgICAgICAgICAgcmV0dXJuIGZhbHNlCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiB0cnVlCmVuZApfR1snZGVlcGNtcCddID0gX2RlZXBjbXAKCi0tIGRlZXAgcmVjdXJzaXZlIG1hcCBvbiBhIHRyZWUgc3RydWN0dXJlCi0tIGZvciB1c2FnZSBzZWUgdGVzdC9kZWVwbWFwLmx1YQotLSBvcGVyYXRlcyBvbmx5IG9uIHN0cmluZ3MsIHBhc3NlcyBudW1iZXJzIHRocm91Z2gKbG9jYWwgZnVuY3Rpb24gX2RlZXBtYXAoZnVuLHQsLi4uKQogICAgbG9jYWwgbHVhdHlwZSA9IGx1YXR5cGUKICAgIGlmIGx1YXR5cGUoZnVuKSB+PSAnZnVuY3Rpb24nIHRoZW4KICAgICAgICBlcnJvcigiSW50ZXJuYWwgZXJyb3I6IGRlZXBtYXAgMXN0IGFyZ3VtZW50IGlzIG5vdCBhIGZ1bmN0aW9uIiwgMykKICAgICAgICByZXR1cm4gbmlsIGVuZAogICAgLS0gaWYgbHVhdHlwZSh0KSA9PSAnbnVtYmVyJyB0aGVuCiAgICAtLSAgICAgcmV0dXJuIHQgZW5kCiAgICBpZiBsdWF0eXBlKHQpIH49ICd0YWJsZScgdGhlbgogICAgICAgIHJldHVybiBmdW4odCkgZW5kCiAgICAtLSBlcnJvcigiSW50ZXJuYWwgZXJyb3I6IGRlZXBtYXAgMm5kIGFyZ3VtZW50IGlzIG5vdCBhIHRhYmxlIiwgMykKICAgIC0tIHJldHVybiBuaWwgZW5kCiAgICBsb2NhbCByZXMgPSB7fQogICAgZm9yIGssdiBpbiBwYWlycyh0KSBkbwogICAgICAgIGlmIGx1YXR5cGUodikgPT0gJ3RhYmxlJyB0aGVuCiAgICAgICAgICAgIHJlc1trXSA9IF9kZWVwbWFwKGZ1bix2LC4uLikgLS0gcmVjdXJzaW9uCiAgICAgICAgZWxzZQogICAgICAgICAgICByZXNba10gPSBmdW4odixrLC4uLikKICAgICAgICBlbmQKICAgIGVuZAogICAgcmV0dXJuIHNldG1ldGF0YWJsZShyZXMsIGdldG1ldGF0YWJsZSh0KSkKZW5kCl9HWydkZWVwbWFwJ10gPSBfZGVlcG1hcAoKbG9jYWwgZnVuY3Rpb24gX2RlZXBzb3J0bWFwKGZ1bix0LC4uLikKICAgIGxvY2FsIGx1YXR5cGUgPSBsdWF0eXBlCiAgICBpZiBsdWF0eXBlKGZ1bikgfj0gJ2Z1bmN0aW9uJyB0aGVuCiAgICAgICAgZXJyb3IoIkludGVybmFsIGVycm9yOiBkZWVwbWFwIDFzdCBhcmd1bWVudCBpcyBub3QgYSBmdW5jdGlvbiIsIDMpCiAgICAgICAgcmV0dXJuIG5pbCBlbmQKICAgIC0tIGlmIGx1YXR5cGUodCkgPT0gJ251bWJlcicgdGhlbgogICAgLS0gICAgIHJldHVybiB0IGVuZAogICAgaWYgbHVhdHlwZSh0KSB+PSAndGFibGUnIHRoZW4KICAgICAgICByZXR1cm4gZnVuKHQpIGVuZAogICAgLS0gZXJyb3IoIkludGVybmFsIGVycm9yOiBkZWVwbWFwIDJuZCBhcmd1bWVudCBpcyBub3QgYSB0YWJsZSIsIDMpCiAgICAtLSByZXR1cm4gbmlsIGVuZAogICAgbG9jYWwgcmVzID0ge30KICAgIGZvciBrLHYgaW4gc29ydF9wYWlycyh0KSBkbwogICAgICAgIGlmIGx1YXR5cGUodikgPT0gJ3RhYmxlJyB0aGVuCiAgICAgICAgICAgIHJlc1trXSA9IF9kZWVwc29ydG1hcChmdW4sdiwuLi4pIC0tIHJlY3Vyc2lvbgogICAgICAgIGVsc2UKICAgICAgICAgICAgcmVzW2tdID0gZnVuKHYsaywuLi4pCiAgICAgICAgZW5kCiAgICBlbmQKICAgIHJldHVybiBzZXRtZXRhdGFibGUocmVzLCBnZXRtZXRhdGFibGUodCkpCmVuZApfR1snZGVlcHNvcnRtYXAnXSA9IF9kZWVwc29ydG1hcAoKLS0gZnVuY3Rpb24gdG8gYmUgdXNlZCB3aGVuIGNvbnZlcnRpbmcgY29kZWNzIHdpdGggY29tcGxleCB0cmVlcwotLSBtYXNrIGlzIGEgZGljdGlvbmFyeSBvZiBmdW5jdGlvbnMgdG8gYmUgYXBwbGllZCBpbiBwbGFjZQpsb2NhbCBmdW5jdGlvbiBfZGVlcG1hc2soZnVuLCB0ZGF0YSwgbWFzaykKICAgIGxvY2FsIGx1YXR5cGUgPSBsdWF0eXBlCiAgICBpZiBsdWF0eXBlKGZ1bikgfj0gJ2Z1bmN0aW9uJyB0aGVuCiAgICAgICAgZXJyb3IoIkRlZXBtYXNrIGFyZyAxIG5vdCBhIGZ1bmN0aW9uOiAiLi5sdWF0eXBlKG1hc2spLCAzKQogICAgZW5kCiAgICBpZiBub3QgbWFzayB0aGVuCiAgICAgICAgZXJyb3IoIkRlZXBtYXNrIGFyZyAzIGlzIG5pbCIsIDIpCiAgICBlbmQKICAgIGlmIGx1YXR5cGUodGRhdGEpIH49ICd0YWJsZScgdGhlbgogICAgICAgIGVycm9yKCJEZWVwbWFzayBhcmcgMiBub3QgYSB0YWJsZTogIi4ubHVhdHlwZShtYXNrKSwgMykKICAgIGVuZAogICAgaWYgbWFzayBhbmQgbHVhdHlwZShtYXNrKSB+PSAndGFibGUnIHRoZW4KICAgICAgICBlcnJvcigiRGVlcG1hc2sgYXJnIDMgbm90IGEgdGFibGU6ICIuLmx1YXR5cGUobWFzayksIDMpCiAgICBlbmQKICAgIGxvY2FsIHJlcyA9IHt9CiAgICBmb3IgaywgdiBpbiBwYWlycyh0ZGF0YSkgZG8KICAgICAgICBsb2NhbCBtYXNrcCA8Y29uc3Q+ID0gbWFza1trXQogICAgICAgIGlmIG5vdCBtYXNrcCB0aGVuCiAgICAgICAgICAgIHJlc1trXSA9IGZ1bih2LCBrKQogICAgICAgICAgICBnb3RvIGNvbnRpbnVlCiAgICAgICAgZW5kCiAgICAgICAgaWYgbHVhdHlwZSh2KSA9PSAndGFibGUnIHRoZW4KICAgICAgICAgICAgcmVzW2tdID0gX2RlZXBtYXNrKGZ1biwgdiwgbWFza3ApCiAgICAgICAgICAgIGdvdG8gY29udGludWUKICAgICAgICBlbmQKICAgICAgICBpZiBub3QgbWFza3AgdGhlbgogICAgICAgICAgICByZXNba10gPSBmdW4odiwgaykKICAgICAgICAgICAgZ290byBjb250aW51ZQogICAgICAgIGVuZAogICAgICAgIGxvY2FsIGVuY29kZXIKICAgICAgICBpZiBsdWF0eXBlKG1hc2twKSA9PSAnZnVuY3Rpb24nIHRoZW4KICAgICAgICAgICAgZW5jb2RlciA9IG1hc2twCiAgICAgICAgZWxzZQogICAgICAgICAgICBlbmNvZGVyID0gZ2V0X2VuY29kaW5nX2Z1bmN0aW9uKG1hc2twKQogICAgICAgIGVuZAogICAgICAgIGlmIG5vdCBlbmNvZGVyIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkludmFsaWQgZW5jb2RpbmcgZm91bmQgaW4gIi4uawogICAgICAgICAgICAgICAgICAuLiI6ICIuLmVuY29kZXIsMikKICAgICAgICBlbmQKICAgICAgICByZXNba10gPSBlbmNvZGVyKHYsIGspCiAgICAgICAgOjpjb250aW51ZTo6CiAgICBlbmQKICAgIHJldHVybiBzZXRtZXRhdGFibGUocmVzLCBnZXRtZXRhdGFibGUodGRhdGEpKQplbmQKX0dbJ2RlZXBtYXNrJ10gPSBfZGVlcG1hc2sKCmxvY2FsIGZ1bmN0aW9uIF9tYXNrX3NldCh0LCBwYXRoLCB2YWx1ZSkKICAgIGxvY2FsIGN1cnJlbnQgPSB0CiAgICBsb2NhbCBudW1wIDxjb25zdD4gPSAjcGF0aAogICAgZm9yIGkgPSAxLCBudW1wIC0gMSBkbwogICAgICAgIGxvY2FsIGtleSA9IHBhdGhbaV0KICAgICAgICBpZiBub3QgY3VycmVudFtrZXldIHRoZW4gY3VycmVudFtrZXldID0ge30gZW5kCiAgICAgICAgY3VycmVudCA9IGN1cnJlbnRba2V5XQogICAgZW5kCiAgICBjdXJyZW50W3BhdGhbbnVtcF1dID0gdmFsdWUKICAgIHJldHVybiB0CmVuZApfR1snZGVlcG1hc2tfc2V0J10gPSBfbWFza19zZXQKCmZ1bmN0aW9uIGlzYXJyYXkob2JqKQogICAgaWYgbm90IG9iaiB0aGVuCiAgICAgICAgd2FybigiQXJndW1lbnQgb2YgaXNhcnJheSgpIGlzIG5pbCIpCiAgICAgICAgcmV0dXJuIGZhbHNlCiAgICBlbmQKICAgIGlmIGx1YXR5cGUob2JqKSA9PSAnc3RyaW5nJyB0aGVuCiAgICAgICAgLS0gc2VhY2ggSEVBRCBmb3IgQUNLW29ial0gYW5kIGNoZWNrIGl0cyBDT0RFQwogICAgICAgIGxvY2FsIG8gPSBBQ0tbb2JqXQogICAgICAgIGlmIG5vdCBvIHRoZW4gcmV0dXJuIGZhbHNlIGVuZAogICAgICAgIGlmIGx1YXR5cGUobykgfj0gJ3RhYmxlJyB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgICAgICBpZiBDT0RFQ1tvYmpdLnplbnR5cGUgPT0gJ2EnIHRoZW4gcmV0dXJuIHRydWUgZW5kCiAgICAgICAgcmV0dXJuIGZhbHNlCiAgICBlbmQKICAgIGlmIGx1YXR5cGUob2JqKSB+PSAndGFibGUnIHRoZW4KICAgICAgICAtLSB3YXJuKCJBcmd1bWVudCBvZiBpc2FycmF5KCkgaXMgbm90IGEgdGFibGUiKQogICAgICAgIHJldHVybiBmYWxzZQogICAgZW5kCiAgICBsb2NhbCBjb3VudCA9IDAKICAgIGZvciBrLCB2IGluIHBhaXJzKG9iaikgZG8KICAgICAgICAtLSBjaGVjayB0aGF0IGFsbCBrZXlzIGFyZSBudW1iZXJzCiAgICAgICAgLS0gZG9uJ3QgY2hlY2sgc3BhcnNlIHJhdGlvIChjanNvbidzIGx1YV9hcnJheV9sZW5ndGgpCiAgICAgICAgaWYgbHVhdHlwZShrKSB+PSAibnVtYmVyIiB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgICAgICBjb3VudCA9IGNvdW50ICsgMQogICAgZW5kCiAgICByZXR1cm4gY291bnQKZW5kCgpmdW5jdGlvbiBpc2RpY3Rpb25hcnkob2JqKQogICAgaWYgbm90IG9iaiB0aGVuCiAgICAgICAgd2FybigiQXJndW1lbnQgb2YgaXNkaWN0aW9uYXJ5KCkgaXMgbmlsIikKICAgICAgICByZXR1cm4gZmFsc2UKICAgIGVuZAogICAgaWYgbHVhdHlwZShvYmopID09ICdzdHJpbmcnIHRoZW4KICAgICAgICAtLSBzZWFjaCBIRUFEIGZvciBBQ0tbb2JqXSBhbmQgY2hlY2sgaXRzIENPREVDCiAgICAgICAgbG9jYWwgbyA9IEFDS1tvYmpdCiAgICAgICAgaWYgbm90IG8gdGhlbiByZXR1cm4gZmFsc2UgZW5kCiAgICAgICAgaWYgbHVhdHlwZShvKSB+PSAndGFibGUnIHRoZW4gcmV0dXJuIGZhbHNlIGVuZAogICAgICAgIGlmIENPREVDW29ial0uemVudHlwZSA9PSAnZCcKICAgICAgICAgICAgb3IgQ09ERUNbb2JqXS56ZW50eXBlID09ICdzY2hlbWEnIHRoZW4KICAgICAgICAgICAgcmV0dXJuIHRydWUgZW5kIC0tIFRSVUUKICAgICAgICByZXR1cm4gZmFsc2UKICAgIGVuZAogICAgLS0gY2hlY2sgdGhlIG9iamVjdCBpdHNlbGYKICAgIGlmIGx1YXR5cGUob2JqKSB+PSAndGFibGUnIHRoZW4gcmV0dXJuIGZhbHNlIGVuZAogICAgLS0gZXJyb3IoIkFyZ3VtZW50IGlzIG5vdCBhIHRhYmxlOiAiLi50eXBlKG9iaikKICAgIGxvY2FsIGNvdW50ID0gMAogICAgZm9yIGssIHYgaW4gcGFpcnMob2JqKSBkbwogICAgICAgIC0tIGNoZWNrIHRoYXQgYWxsIGtleXMgYXJlIG5vdCBudW1iZXJzCiAgICAgICAgLS0gZG9uJ3QgY2hlY2sgc3BhcnNlIHJhdGlvIChjanNvbidzIGx1YV9hcnJheV9sZW5ndGgpCiAgICAgICAgaWYgbHVhdHlwZShrKSB+PSAic3RyaW5nIiB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgICAgICBjb3VudCA9IGNvdW50ICsgMQogICAgZW5kCiAgICByZXR1cm4gY291bnQKZW5kCgpmdW5jdGlvbiBhcnJheV9jb250YWlucyhhcnIsIG9iaikKICAgIGlmIGx1YXR5cGUoYXJyKSB+PSAndGFibGUnIHRoZW4gZXJyb3IoIkludGVybmFsIGVycm9yOiBhcnJheV9jb250YWlucyBhcmd1bWVudCBpcyBub3QgYSB0YWJsZSIsMikgZW5kCiAgICBmb3IgaywgdiBpbiBwYWlycyhhcnIpIGRvCiAgICAgICAgaWYgbHVhdHlwZShrKSB+PSAnbnVtYmVyJyB0aGVuIGVycm9yKCJJbnRlcm5hbCBlcnJvcjogYXJyYXlfY29udGFpbnMgYXJndW1lbnQgaXMgbm90IGFuIGFycmF5IiwgMikgZW5kCiAgICAgICAgaWYgdiA9PSBvYmogdGhlbiByZXR1cm4gdHJ1ZSBlbmQKICAgIGVuZAogICAgcmV0dXJuIGZhbHNlCmVuZAoKCmZ1bmN0aW9uIGhlbHAobW9kdWxlKQogICAgaWYgbW9kdWxlID09IG5pbCB0aGVuCiAgICAgICAgcHJpbnQoInVzYWdlOiBoZWxwKG1vZHVsZSkiKQogICAgICAgIHByaW50KCJleGFtcGxlID4gaGVscChvY3RldCkiKQogICAgICAgIHByaW50KCJleGFtcGxlID4gaGVscChlY2RoKSIpCiAgICAgICAgcHJpbnQoImV4YW1wbGUgPiBoZWxwKGVjcCkiKQogICAgICAgIHJldHVybgogICAgZW5kCiAgICBmb3Igayx2IGluIHBhaXJzKG1vZHVsZSkgZG8KICAgICAgICBpZiB0eXBlKHYpfj0ndGFibGUnIGFuZCBzdHJpbmcuc3ViKGssMSwxKX49J18nIHRoZW4KICAgICAgICAgICAgcHJpbnQoImNsYXNzIG1ldGhvZDogIi4uaykKICAgICAgICBlbmQKICAgIGVuZAogICAgLS0gbG9jYWwgaW5zdCA9IG1vZHVsZS5uZXcoKQogICAgLS0gaWYgaW5zdCA9PSBuaWwgdGhlbiByZXR1cm4gZW5kCiAgICAtLSBmb3IgcyxmIGluIHBhaXJzKGdldG1ldGF0YWJsZShpbnN0KSkgZG8KICAgIC0tICAgICBpZihzdHJpbmcuc3ViKHMsMSwyKX49J19fJykgdGhlbiBwcmludCgib2JqZWN0IG1ldGhvZDogIi4ucykgZW5kCiAgICAtLSBlbmQKZW5kCgpsb2NhbCBvbGR0b251bWJlciA9IHRvbnVtYmVyCmZ1bmN0aW9uIHRvbnVtYmVyKG9iaiwgLi4uKQogICAgaWYgdHlwZShvYmopID09ICJ6ZW5yb29tLmZsb2F0IiBvciB0eXBlKG9iaikgPT0gInplbnJvb20udGltZSIgdGhlbgogICAgICAgIG9iaiA9IHRvc3RyaW5nKG9iaikKICAgIGVuZAogICAgcmV0dXJuIG9sZHRvbnVtYmVyKG9iaiwgLi4uKQplbmQKCmZ1bmN0aW9uIGlzbnVtYmVyKG4pCiAgICBsb2NhbCB0ID0gdHlwZShuKQogICAgcmV0dXJuIHQgPT0gJ251bWJlcicgb3IgdCA9PSAnemVucm9vbS5mbG9hdCcgb3IgdCA9PSAnemVucm9vbS5iaWcnCmVuZAoKZnVuY3Rpb24gZGVwcmVjYXRlZChvbGQsIG5ldywgZnVuYykKICAgIGxvY2FsIHdhcm5fZnVuYyA9IGZ1bmN0aW9uKC4uLikKICAgICAgICBsb2NhbCBzcGFjZSwgY29tbWEgPSAiXG4iLCAiIgogICAgICAgIGlmIENPTkYuZGVidWcuZm9ybWF0ID09ICdjb21wYWN0JyB0aGVuIHNwYWNlID0gIiAiOyBjb21tYSA9ICIsIiBlbmQKICAgICAgICB3YXJuKCJERVBSRUNBVEVEOiIuLnNwYWNlLi5vbGQuLmNvbW1hLi5zcGFjZS4uInVzZSBpbnN0ZWFkOiIuLnNwYWNlLi5uZXcpCiAgICAgICAgZnVuYyguLi4pCiAgICBlbmQKICAgIHJldHVybiBvbGQsIHdhcm5fZnVuYwplbmQKCmZ1bmN0aW9uIHppcCguLi4pCiAgICBsb2NhbCBhcnJheXMgPSB7Li4ufQogICAgbG9jYWwgYW5zID0ge30KICAgIGxvY2FsIGluZGV4ID0gMAogICAgZm9yIGssIHYgaW4gcGFpcnMoYXJyYXlzKSBkbwogICAgICAgIHplbmNvZGVfYXNzZXJ0KGlzYXJyYXkodiksICJ6aXAgaW5wdXQgYXJlIG5vdCBhcnJheXMiKQogICAgZW5kCiAgICByZXR1cm4gZnVuY3Rpb24oKQogICAgICAgIGluZGV4ID0gaW5kZXggKyAxCiAgICAgICAgZm9yIGssIHYgaW4gcGFpcnMoYXJyYXlzKSBkbwogICAgICAgICAgICBhbnNba10gPSB2W2luZGV4XQogICAgICAgICAgICAtLSBzdG9wIGl0ZXJhdGlvbiBhdCB0aGUgZmlyc3QgbmlsIHZhbHVlIGluIG9uZSBvZiB0aGUgYXJyYXkKICAgICAgICAgICAgaWYgYW5zW2tdID09IG5pbCB0aGVuIHJldHVybiBlbmQKICAgICAgICBlbmQKICAgICAgICByZXR1cm4gdGFibGUudW5wYWNrKGFucykKICAgIGVuZAplbmQKCi0tIGV4dHJhY3QgYW4gZWxlbWVudCBmcm9tIGRlZXAgZG93bgotLSB3b3JrcyBib3RoIGluIElOIGFuZCBBQ0sgbWVtb3J5Ci0tIEBwYXJhbSBwYXRoIHBhdGggdG8gdmFyaWFibGUgc2VwYXJhdGVkIGJ5IHBvaW50cwotLSBAcmV0dXJuIGVsZW1lbnQgZm91bmQgZm9sbG93aW5nIHRoZSBwYXRoCi0tIEByZXR1cm4gbmFtZSBvZiB0aGUgZGVzdGluYXRpb24KZnVuY3Rpb24gcGlja19mcm9tX3BhdGgocGF0aCwgbm9fZGVzdCkKICAgIGxvY2FsIHBhdGhfYXJyYXkgPSBzdHJ0b2sodXNjb3JlKHBhdGgpLCBDT05GLnBhdGguc2VwYXJhdG9yKQogICAgbG9jYWwgcm9vdCA9IHBhdGhfYXJyYXlbMV0KICAgIHRhYmxlLnJlbW92ZShwYXRoX2FycmF5LCAxKQogICAgbG9jYWwgZGVzdCA9IHBhdGhfYXJyYXlbI3BhdGhfYXJyYXldCiAgICBpZiBub3Qgbm9fZGVzdCB0aGVuIGVtcHR5KGRlc3QpIGVuZAogICAgLS0gc2hvdWxkIHdvcmtzIGJvdGggaW4gZ2l2ZW4gYW5kIHdoZW4gcGhhc2UKICAgIC0tIElOIGlzIGNoZWNrZWQgZmlyc3RseSBzaW5jZSBpbiB0aGUgV2hlbiBwaGFzZSBJTiB3aWxsIGJlIGVtcHR5CiAgICBsb2NhbCByZXMgPSBJTltyb290XSBvciBBQ0tbcm9vdF0KICAgIGZvciBfLHYgaW4gcGFpcnMocGF0aF9hcnJheSkgZG8KICAgICAgICB6ZW5jb2RlX2Fzc2VydChsdWF0eXBlKHJlcykgPT0gJ3RhYmxlJywgIk9iamVjdCBpcyBub3QgYSB0YWJsZTogIi4ucm9vdCkKICAgICAgICBpZiByZXNbdl0gPT0gbmlsIHRoZW4KICAgICAgICAgICAgbG9jYWwgdl9udW1iZXIgPSB0b251bWJlcih2KQogICAgICAgICAgICB6ZW5jb2RlX2Fzc2VydCh2X251bWJlciBhbmQgcmVzW3ZfbnVtYmVyXSB+PSBuaWwsICJLZXkgIi4udi4uIiBub3QgZm91bmQgaW4gIi4ucm9vdCkKICAgICAgICAgICAgcmVzID0gcmVzW3ZfbnVtYmVyXQogICAgICAgIGVsc2UKICAgICAgICAgICAgcmVzID0gcmVzW3ZdCiAgICAgICAgZW5kCiAgICAgICAgcm9vdCA9IHYKICAgIGVuZAogICAgcmV0dXJuIHJlcywgZGVzdAplbmQKCi0tIC0tIE1VTFRJQkFTRQoKLS0gVW5pY29kZSwgY2hhcmFjdGVyLCBlbmNvZGluZywgZGVzY3JpcHRpb24sIHN0YXR1cwotLSBVKzAwMzAsIDAsIGJhc2UyLCBCaW5hcnkgKDAxMDEwMTAxKSwgZXhwZXJpbWVudGFsCi0tIFUrMDA2NiwgZiwgYmFzZTE2LCBIZXhhZGVjaW1hbCAobG93ZXJjYXNlKSwgZmluYWwKLS0gVSswMDQ2LCBGLCBiYXNlMTZ1cHBlciwgSGV4YWRlY2ltYWwgKHVwcGVyY2FzZSksIGZpbmFsCi0tIFUrMDA1MiwgUiwgYmFzZTQ1LCBCYXNlNDUgUkZDOTI4NSwgZHJhZnQKLS0gVSswMDdhLCB6LCBiYXNlNThidGMsIEJhc2U1OCBCaXRjb2luLCBmaW5hbAotLSBVKzAwNmQsIG0sIGJhc2U2NCwgUkZDNDY0OCBubyBwYWRkaW5nLCBmaW5hbAotLSBVKzAwNGQsIE0sIGJhc2U2NHBhZCwgUkZDNDY0OCB3aXRoIHBhZGRpbmcsIGV4cGVyaW1lbnRhbAotLSBVKzAwNzUsIHUsIGJhc2U2NHVybCwgUkZDNDY0OCBubyBwYWRkaW5nLCBmaW5hbAotLSBVKzAwNTUsIFUsIGJhc2U2NHVybHBhZCwgUkZDNDY0OCB3aXRoIHBhZGRpbmcsIGZpbmFsCgpmdW5jdGlvbiBtdWx0aWJhc2VfZGVjb2RlKHNyYykKICAgIGxvY2FsIHBmeCA8Y29uc3Q+ID0gc3RyaW5nLnN1YihzcmMsMSwxKTpsb3dlcigpCiAgICBsb2NhbCB2YWwgPGNvbnN0PiA9IHN0cmluZy5zdWIoc3JjLDIpCiAgICBsb2NhbCB0cmFucyA8Y29uc3Q+ID0gewogICAgICAgIGYgPSBPLmZyb21faGV4LAogICAgICAgIHIgPSBPLmZyb21fYmFzZTQ1LAogICAgICAgIHogPSBPLmZyb21fYmFzZTU4LAogICAgICAgIG0gPSBPLmZyb21fYmFzZTY0LAogICAgICAgIHUgPSBPLmZyb21fdXJsNjQKICAgIH0KICAgIHJldHVybiB0cmFuc1twZnhdKHZhbCkKZW5kCgpmdW5jdGlvbiBpc196dWx1X2RhdGUoaW5wdXQpCiAgICAtLSBDaGVjayBiYXNpYyBwYXR0ZXJuIChzdXBwb3J0cyBkYXRlcyB3aXRoIG9yIHdpdGhvdXQgdGltZSBpbiBadWx1L1VUQykKICAgIGxvY2FsIHN0ciA9IGZpZihpc3plbih0eXBlKGlucHV0KSksaW5wdXQ6b2N0ZXQoKTpzdHJpbmcoKSxpbnB1dCkKICAgIGxvY2FsIHksIG0sIGQsIGhvdXIsIG1pbiwgc2VjID0KICAgICAgICBzdHJpbmcubWF0Y2goc3RyLCJeKCVkJWQlZCVkKS0oJWQlZCktKCVkJWQpVD8oJWQ/JWQ/KSU6PyglZD8lZD8pJTo/KCVkPyVkPylaPyQiKQogICAgLS0gaWYgbm8gZGF0ZSBwYXJ0IG1hdGNoZWQsIGludmFsaWQKICAgIGlmIG5vdCB5IG9yIG5vdCBtIG9yIG5vdCBkIHRoZW4KICAgICAgICByZXR1cm4gZmFsc2UKICAgIGVuZAogICAgLS0gY29udmVydCB0byBudW1iZXJzCiAgICB5LCBtLCBkID0gdG9udW1iZXIoeSksIHRvbnVtYmVyKG0pLCB0b251bWJlcihkKQogICAgaG91ciA9IHRvbnVtYmVyKGhvdXIpIG9yIDAKICAgIG1pbiA9IHRvbnVtYmVyKG1pbikgb3IgMAogICAgc2VjID0gdG9udW1iZXIoc2VjKSBvciAwCiAgICAtLSB2YWxpZGF0ZSByYW5nZXMKICAgIGlmIG0gPCAxIG9yIG0gPiAxMiB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgIGlmIGQgPCAxIG9yIGQgPiAzMSB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgIGlmIGhvdXIgPCAwIG9yIGhvdXIgPiAyMyB0aGVuIHJldHVybiBmYWxzZSBlbmQKICAgIGlmIG1pbiA8IDAgb3IgbWluID4gNTkgdGhlbiByZXR1cm4gZmFsc2UgZW5kCiAgICBpZiBzZWMgPCAwIG9yIHNlYyA+IDU5IHRoZW4gcmV0dXJuIGZhbHNlIGVuZAogICAgLS0gY2hlY2sgbW9udGgtZGF5IHZhbGlkaXR5IChlLmcuLCBGZWIgMzAgaXMgaW52YWxpZCkKICAgIGxvY2FsIGRheXNfaW5fbW9udGggPSB7MzEsIDI4LCAzMSwgMzAsIDMxLCAzMCwgMzEsIDMxLCAzMCwgMzEsIDMwLCAzMX0KICAgIC0tIGhhbmRsZSBsZWFwIHllYXJzIChGZWIgMjkpCiAgICBpZiBtID09IDIgdGhlbgogICAgICAgIGxvY2FsIGlzX2xlYXAgPSAoeSAlIDQwMCA9PSAwKSBvciAoeSAlIDEwMCB+PSAwIGFuZCB5ICUgNCA9PSAwKQogICAgICAgIGRheXNfaW5fbW9udGhbMl0gPSBpc19sZWFwIGFuZCAyOSBvciAyOAogICAgZW5kCiAgICBpZiBkID4gZGF5c19pbl9tb250aFttXSB0aGVuCiAgICAgICAgcmV0dXJuIGZhbHNlCiAgICBlbmQKICAgIHJldHVybiB0cnVlCmVuZAovemVucm9vbV9lY2RoLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMS0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBBbGJlcnRvIExlcmRhIGFuZCBEZW5pcyBSb2lvCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFR1ZXNkYXksIDIwdGggSnVseSAyMDIxCi0tXV0KCmxvY2FsIGVjZGggPSByZXF1aXJlX29uY2UnZWNkaCcKCmZ1bmN0aW9uIGVjZGguY29tcHJlc3NfcHVibGljX2tleShwdWJsaWMpCiAgIGxvY2FsIHgsIHkgPSBFQ0RILnB1Ynh5KHB1YmxpYykKICAgbG9jYWwgcGZ4ID0gZmlmKCBCSUcucGFyaXR5KEJJRy5uZXcoeSkgKSwgT0NURVQuZnJvbV9oZXgoJzAzJyksIE9DVEVULmZyb21faGV4KCcwMicpICkKICAgbG9jYWwgcGsgPSBwZnggLi4geAogICByZXR1cm4gcGsKZW5kCgpmdW5jdGlvbiBlY2RoLnVuY29tcHJlc3NfcHVibGljX2tleShwdWJsaWMpCiAgIGxvY2FsIHAgPSBFQ0RILnByaW1lKCkKICAgbG9jYWwgZSA9IEJJRy5zaHIocCArIElOVC5uZXcoMSksIDIpIC0tIGUgPSAocCsxKS80CgogICBsb2NhbCBwYXJpdHkgPSBwdWJsaWM6c3ViKDEsMSkKICAgYXNzZXJ0KHBhcml0eSA9PSBPLmZyb21faGV4KCcwMicpIG9yIHBhcml0eSA9PSBPLmZyb21faGV4KCcwMycpKQogICBsb2NhbCB4ID0gQklHLm5ldyhwdWJsaWM6c3ViKDIsICNwdWJsaWMpKQogICAtLSB5KnkgPSB4KngqeCArIDcKICAgbG9jYWwgcmhzID0gQklHLm1vZChCSUcubW9kbXVsKEJJRy5tb2RtdWwoeCx4LHApLHgscCkrQklHLm5ldyg3KSxwKQogICBsb2NhbCBzcXJ0X3JocyA9IHJoczptb2Rwb3dlcihlLCBwKQogICBhc3NlcnQoQklHLm1vZG11bChzcXJ0X3JocyxzcXJ0X3JocywgcCkgPT0gcmhzKQogICBpZiBzcXJ0X3JoczpwYXJpdHkoKSB+PSAocGFyaXR5ID09IE8uZnJvbV9oZXgoJzAzJykpIHRoZW4gLS0gdGhpcyBpcyBhIHhvcgogICAgICBzcXJ0X3JocyA9IHNxcnRfcmhzOm1vZG5lZyhwKQogICBlbmQKICAgcmV0dXJuIE8uZnJvbV9oZXgoJzA0JykgLi4geCAuLiBzcXJ0X3JocwplbmQKCi0tIGl0IGlzIHNpbWlsYXIgdG8gc2lnbiBldGgsIHMgPCBvcmRlci8yCmZ1bmN0aW9uIGVjZGguc2lnbl9lY2RoKHNrLCBkYXRhKQogICBsb2NhbCBvID0gRUNESC5vcmRlcigpCiAgIGxvY2FsIHNpZywgeSwgc2lnX3MKICAgc2lnLCB5ID0gRUNESC5zaWduX2hhc2hlZChzaywgZGF0YSwgI2RhdGEpCgogICBzaWdfcyA9IElOVC5uZXcoc2lnLnMpCiAgIGlmIHNpZ19zID4gSU5ULnNocihvLCAxKSB0aGVuCiAgICAgIHNpZ19zID0gSU5ULm1vZHN1YihvLCBzaWdfcywgbykKICAgICAgc2lnLnMgPSBzaWdfczpvY3RldCgpOnBhZCgzMikKICAgICAgeSA9IG5vdCB5CiAgIGVuZAogICByZXR1cm4gc2lnLCB5CmVuZAoKLS0gaXQgaXMgc2ltaWxhciB0byBzaWduIGV0aCwgcyA8IG9yZGVyLzIgZm9yIGRldGVybWluaXN0aWMgZWNkc2EKZnVuY3Rpb24gZWNkaC5zaWduX2VjZGhfZGV0ZXJtaW5pc3RpYyhzaywgZGF0YSwgaGFzaF9sZW4pCiAgICBsb2NhbCBvID0gRUNESC5vcmRlcigpCiAgICBsb2NhbCBzaWcsIHNpZ19zLCB5CiAgICBzaWcsIHkgPSBFQ0RILnNpZ25fZGV0X2hhc2hlZChzaywgZGF0YSwgaGFzaF9sZW4pCgogICAgc2lnX3MgPSBJTlQubmV3KHNpZy5zKQogICAgaWYgc2lnX3MgPiBJTlQuc2hyKG8sIDEpIHRoZW4KICAgICAgIHNpZ19zID0gSU5ULm1vZHN1YihvLCBzaWdfcywgbykKICAgICAgIHNpZy5zID0gc2lnX3M6b2N0ZXQoKTpwYWQoMzIpCiAgICAgICB5ID0gbm90IHkKICAgIGVuZAogICAgcmV0dXJuIHNpZywgeQogZW5kCgotLSBDb21wdXRlIHRoZSBjb21wcmVzc2VkIHB1YmxpYyBrZXkgKHB1YmMpIGZyb20gdGhlIHNlY3JldCBrZXkKZnVuY3Rpb24gZWNkaC5za190b19wdWJjKHNrKQogICBpZiBub3QgI3NrID09IDMyIHRoZW4KICAgICAgZXJyb3IoIkludmFsaWQgZWNkaCBwcml2YXRlIGtleSBzaXplOiAiLi4jc2ssMikgZW5kCiAgIHJldHVybiggRUNESC5jb21wcmVzc19wdWJsaWNfa2V5KCBFQ0RILnB1YmdlbihzaykgKSApCmVuZAoKcmV0dXJuIGVjZGgKL3plbnJvb21fZWNwLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAxOC0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS0KLS1MYXN0IG1vZGlmaWVkIGJ5IERlbmlzIFJvaW8KLS1vbiBUdWVzZGF5LCAyMHRoIEp1bHkgMjAyMQotLV1dCgpsb2NhbCBlY3AgPSByZXF1aXJlJ2VjcCcKCmZ1bmN0aW9uIGVjcC5oYXNodG9wb2ludChzKQogICByZXR1cm4gZWNwLm1hcGl0KHNoYTUxMihzKSkKZW5kCgpmdW5jdGlvbiBlY3AucmFuZG9tKCkKICAgcmV0dXJuIGVjcC5tYXBpdChPQ1RFVC5yYW5kb20oNjQpKQplbmQKCnJldHVybiBlY3AKL3plbnJvb21fZWNwMi5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMTgtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBEZW5pcyBSb2lvCi0tb24gVHVlc2RheSwgMjB0aCBKdWx5IDIwMjEKLS1dXQoKbG9jYWwgZWNwMiA9IHJlcXVpcmUnZWNwMicKcmVxdWlyZSdmcDEyJyAtLSBGUDEyIGltcGxpY2l0CgpmdW5jdGlvbiBlY3AyLmhhc2h0b3BvaW50KHMpCiAgIHJldHVybiBlY3AyLm1hcGl0KHNoYTUxMihzKSkKZW5kCgpmdW5jdGlvbiBlY3AyLnJhbmRvbSgpCiAgIHJldHVybiBlY3AyLm1hcGl0KE9DVEVULnJhbmRvbSg2NCkpCmVuZAoKcmV0dXJuIGVjcDIKL3plbnJvb21faGFzaC5sdWEALS1bWwotLVRoaXMgZmlsZSBpcyBwYXJ0IG9mIHplbnJvb20KLS0KLS1Db3B5cmlnaHQgKEMpIDIwMTgtMjAyNSBEeW5lLm9yZyBmb3VuZGF0aW9uCi0tZGVzaWduZWQsIHdyaXR0ZW4gYW5kIG1haW50YWluZWQgYnkgRGVuaXMgUm9pbyA8amFyb21pbEBkeW5lLm9yZz4KLS0KLS1UaGlzIHByb2dyYW0gaXMgZnJlZSBzb2Z0d2FyZTogeW91IGNhbiByZWRpc3RyaWJ1dGUgaXQgYW5kL29yIG1vZGlmeQotLWl0IHVuZGVyIHRoZSB0ZXJtcyBvZiB0aGUgR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS0KLS1UaGlzIHByb2dyYW0gaXMgZGlzdHJpYnV0ZWQgaW4gdGhlIGhvcGUgdGhhdCBpdCB3aWxsIGJlIHVzZWZ1bCwKLS1idXQgV0lUSE9VVCBBTlkgV0FSUkFOVFk7IHdpdGhvdXQgZXZlbiB0aGUgaW1wbGllZCB3YXJyYW50eSBvZgotLU1FUkNIQU5UQUJJTElUWSBvciBGSVRORVNTIEZPUiBBIFBBUlRJQ1VMQVIgUFVSUE9TRS4gIFNlZSB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgZm9yIG1vcmUgZGV0YWlscy4KLS0KLS1BbG9uZyB3aXRoIHRoaXMgcHJvZ3JhbSB5b3Ugc2hvdWxkIGhhdmUgcmVjZWl2ZWQgYSBjb3B5IG9mIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tSWYgbm90LCBzZWUgaHR0cDovL3d3dy5nbnUub3JnL2xpY2Vuc2VzL2FncGwudHh0Ci0tCi0tTGFzdCBtb2RpZmllZCBieSBNYXR0ZW8gQ3Jpc3Rpbm8KLS1vbiBNb25kYXksIDEzdGggSmFudWFyeSAyMDI1Ci0tXV0KCmxvY2FsIGhhc2ggPSByZXF1aXJlJ2hhc2gnCgotLSBjYWNoZSBzdG9yaW5nIGluaXRpYWxpemVkIHRhYmxlcyBmb3IgcmV1c2UKaGFzaC5jYWNoZSA9IHsgfQoKZnVuY3Rpb24gaGFzaDppbml0KG5hbWUpCiAgICBsb2NhbCByZXMKICAgIGlmIHNlbGYuY2FjaGVbbmFtZV0gdGhlbgogICAgICAgIHJlcyA9IHNlbGYuY2FjaGVbbmFtZV0KICAgIGVsc2UKICAgICAgICByZXMgPSBzZWxmLm5ldyhuYW1lKQogICAgICAgIHNlbGYuY2FjaGVbbmFtZV0gPSByZXMKICAgIGVuZAogICAgcmV0dXJuIHJlcwplbmQKCi0tIGVhc3kgdG8gdXNlIGNhbGxzCmZ1bmN0aW9uIHNoYTI1NihkYXRhKSAgIHJldHVybiBoYXNoOmluaXQoInNoYTI1NiIpOnByb2Nlc3MoZGF0YSkgZW5kCmZ1bmN0aW9uIHNoYTUxMihkYXRhKSAgIHJldHVybiBoYXNoOmluaXQoInNoYTUxMiIpOnByb2Nlc3MoZGF0YSkgZW5kCmZ1bmN0aW9uIHNoYTNfMjU2KGRhdGEpIHJldHVybiBoYXNoOmluaXQoInNoYTI1NiIpOnByb2Nlc3MoZGF0YSkgZW5kCmZ1bmN0aW9uIHNoYTNfNTEyKGRhdGEpIHJldHVybiBoYXNoOmluaXQoInNoYTUxMiIpOnByb2Nlc3MoZGF0YSkgZW5kCmhhc2guc2hhMjU2ID0gc2hhMjU2Cmhhc2guc2hhNTEyID0gc2hhNTEyCmhhc2guc2hhM18yNTYgPSBzaGEzXzI1NgpoYXNoLnNoYTNfNTEyID0gc2hhM181MTIKCmhhc2guc2hha2UyNTYgPSBmdW5jdGlvbihkYXRhLCBsZW4pIHJldHVybiBoYXNoOmluaXQoInNoYWtlMjU2Iik6cHJvY2VzcyhkYXRhLCBsZW4gb3IgMzIpIGVuZApoYXNoLmtlY2NhazI1NiA9IGZ1bmN0aW9uKGRhdGEpIHJldHVybiBoYXNoOmluaXQoImtlY2NhazI1NiIpOnByb2Nlc3MoZGF0YSkgZW5kCgpmdW5jdGlvbiBLREYoZGF0YSwgYml0cykgcmV0dXJuIGhhc2g6aW5pdCgic2hhIi4udG9zdHJpbmcoYml0cyBvciAyNTYpKTprZGYyKGRhdGEpIGVuZAoKZnVuY3Rpb24gaGFzaC5kc2hhMjU2KG1zZykKICAgbG9jYWwgX1NIQTI1NiA8Y29uc3Q+ID0gaGFzaDppbml0J3NoYTI1NicKICAgcmV0dXJuIF9TSEEyNTY6cHJvY2VzcyhfU0hBMjU2OnByb2Nlc3MobXNnKSkKZW5kCgpmdW5jdGlvbiBoYXNoLmhhc2gxNjAobXNnKQogICBsb2NhbCBfU0hBMjU2IDxjb25zdD4gPSBoYXNoOmluaXQnc2hhMjU2JwogICBsb2NhbCBfUk1EMTYwIDxjb25zdD4gPSBoYXNoOmluaXQncmlwZW1kMTYwJwogICByZXR1cm4gX1JNRDE2MDpwcm9jZXNzKF9TSEEyNTY6cHJvY2Vzcyhtc2cpKQoKZW5kCgotLXVzZWQgaW4gQkJTKyBzaWduYXR1cmUKaGFzaC5oa2RmX2V4dHJhY3QgPSBmdW5jdGlvbihzYWx0LCBpa20pCglyZXR1cm4gSEFTSC5obWFjKGhhc2g6aW5pdCdzaGEyNTYnLCBzYWx0LCBpa20pCmVuZAoKLS11c2VkIGluIEJCUysgc2lnbmF0dXJlCmhhc2guaGtkZl9leHBhbmQgPSBmdW5jdGlvbihwcmssIGluZm8sIGwpCglsb2NhbCBoID0gaGFzaDppbml0J3NoYTI1NicKCWxvY2FsIGhhc2hfbGVuID0gMzIKCWFzc2VydCgjcHJrID49IGhhc2hfbGVuKQoJYXNzZXJ0KGwgPD0gMjU1ICogaGFzaF9sZW4pCglhc3NlcnQobCA+IDApCgoJaWYgdHlwZShpbmZvKSA9PSAnc3RyaW5nJyB0aGVuCgkJaW5mbyA9IE8uZnJvbV9zdHJpbmcoaW5mbykKCWVuZAoKCS0tIGxvY2FsIG4gPSBtYXRoLmNlaWwobC9oYXNoX2xlbikKCgktLSBUT0RPOiBvcHRpbWl6ZSB1c2luZyBzb21ldGhpbmcgbGlrZSB0YWJsZS5jb25jYXQgZm9yIG9jdGV0cwoJbG9jYWwgdHByZWMgPSBIQVNILmhtYWMoaCwgcHJrLCBpbmZvIC4uIE8uZnJvbV9oZXgoJzAxJykpCglsb2NhbCBpID0gMgoJbG9jYWwgdCA9IHRwcmVjCgl3aGlsZSBsID4gI3QgZG8KCQl0cHJlYyA9IEhBU0guaG1hYyhoLCBwcmssIHRwcmVjIC4uIGluZm8gLi4gTy5mcm9tX2hleChzdHJpbmcuZm9ybWF0KCIlMDJ4IiwgaSkpKQoJCXQgPSB0IC4uIHRwcmVjCgkJaSA9IGkrMQoJZW5kCgoJLS0gVE9ETzogY2hlY2sgdGhhdCBzdWIgaXMgbm90IGNyZWF0aW5nIGEgY29weQoJcmV0dXJuIHQ6c3ViKDEsbCkKZW5kCgotLSBSRkM4MDE3IHNlY3Rpb24gNAotLSBjb252ZXJ0cyBhIG5vbm5lZ2F0aXZlIGludGVnZXIgdG8gYW4gb2N0ZXQgc3RyaW5nIG9mIGEgc3BlY2lmaWVkIGxlbmd0aC4KbG9jYWwgZnVuY3Rpb24gaTJvc3AoeCwgeF9sZW4pCglyZXR1cm4gTy5uZXcoQklHLm5ldyh4KSk6cGFkKHhfbGVuKQplbmQKCi0tdXNlZCBpbiBCQlMrIHNpZ25hdHVyZQotLSBkcmFmdC1pcnRmLWNmcmctaGFzaC10by1jdXJ2ZS0xNiBzZWN0aW9uIDUuMy4yCi0tIEl0IG91dHB1dHMgYSB1bmlmb3JtbHkgcmFuZG9tIGJ5dGUgc3RyaW5nLiAodXNlcyBTSEFLRTI1NikKaGFzaC5leHBhbmRfbWVzc2FnZV94b2YgPSBmdW5jdGlvbiAobXNnLCBEU1QsIGxlbl9pbl9ieXRlcykKLS1tc2cgYW5kIERTVCBtdXN0IGJlIG9jdGV0cwoJaWYgbGVuX2luX2J5dGVzID4gNjU1MzYgdGhlbgoJCWVycm9yKCJsZW5faW5fYnl0ZXMgaXMgdG9vIGJpZyIsIDIpCgllbmQKCWlmICNEU1QgPiAyNTUgdGhlbgoJCWVycm9yKCJsZW4oRFNUKSBpcyB0b28gYmlnIiwgMikKCWVuZAoKCWxvY2FsIERTVF9wcmltZSA9IERTVCAuLiBpMm9zcCgjRFNULCAxKQoJbG9jYWwgbXNnX3ByaW1lID0gbXNnIC4uIGkyb3NwKGxlbl9pbl9ieXRlcywgMikgLi4gRFNUX3ByaW1lCglsb2NhbCB1bmlmb3JtX2J5dGVzID0gaGFzaC5zaGFrZTI1Nihtc2dfcHJpbWUsIGxlbl9pbl9ieXRlcykKCglyZXR1cm4gdW5pZm9ybV9ieXRlcywgRFNUX3ByaW1lLCBtc2dfcHJpbWUKCmVuZAoKLS11c2VkIGluIEJCUysgc2lnbmF0dXJlCi0tIGRyYWZ0LWlydGYtY2ZyZy1oYXNoLXRvLWN1cnZlLTE2IHNlY3Rpb24gNS4zLjEKLS0gSXQgb3V0cHV0cyBhIHVuaWZvcm1seSByYW5kb20gYnl0ZSBzdHJpbmcuCmhhc2guZXhwYW5kX21lc3NhZ2VfeG1kID0gZnVuY3Rpb24obXNnLCBEU1QsIGxlbl9pbl9ieXRlcykKCS0tIG1zZywgRFNUIGFyZSBPQ1RFVFM7IGxlbl9pbl9ieXRlcyBpcyBhbiBpbnRlZ2VyLgoKCS0tIFBhcmFtZXRlcnM6CgktLSBhIGhhc2ggZnVuY3Rpb24gKFNIQS0yNTYgb3IgU0hBMy0yNTYgYXJlIGFwcHJvcHJpYXRlKQoJbG9jYWwgYl9pbl9ieXRlcyA9IDMyIC0tID0gb3V0cHV0IHNpemUgb2YgaGFzaCBJTiBCSVRTIC8gOAoJbG9jYWwgc19pbl9ieXRlcyA9IDY0IC0tIG9rIGZvciBTSEEtMjU2CgoJbG9jYWwgZWxsID0gbWF0aC5jZWlsKGxlbl9pbl9ieXRlcyAvIGJfaW5fYnl0ZXMpCglhc3NlcnQoZWxsIDw9IDI1NSkKCWFzc2VydChsZW5faW5fYnl0ZXMgPD0gNjU1MzUpCglsb2NhbCBEU1RfbGVuID0gI0RTVAoJYXNzZXJ0KCBEU1RfbGVuIDw9IDI1NSkKCglsb2NhbCBEU1RfcHJpbWUgPSBEU1QgLi4gaTJvc3AoRFNUX2xlbiwgMSkKCWxvY2FsIFpfcGFkID0gaTJvc3AoMCwgc19pbl9ieXRlcykKCWxvY2FsIGxfaV9iX3N0ciA9IGkyb3NwKGxlbl9pbl9ieXRlcywgMikKCWxvY2FsIG1zZ19wcmltZSA9IFpfcGFkLi5tc2cuLmxfaV9iX3N0ci4uaTJvc3AoMCwxKS4uRFNUX3ByaW1lCgoJbG9jYWwgYl8wID0gc2hhMjU2KG1zZ19wcmltZSkKCWxvY2FsIGJfMSA9IHNoYTI1NihiXzAuLmkyb3NwKDEsMSkuLkRTVF9wcmltZSkKCWxvY2FsIHVuaWZvcm1fYnl0ZXMgPSBiXzEKCS0tIGJfaiBhc3N1bWVzIHRoZSB2YWx1ZSBvZiBiXyhpLTEpIGluc2lkZSB0aGUgZm9yIGxvb3AsIGZvciBpIGJldHdlZW4gMiBhbmQgZWxsLgoJbG9jYWwgYl9qID0gYl8xCglmb3IgaSA9IDIsZWxsIGRvCgkJbG9jYWwgYl9pID0gc2hhMjU2KE8ueG9yKGJfMCwgYl9qKS4uaTJvc3AoaSwxKS4uRFNUX3ByaW1lKQoJCWJfaiA9IGJfaQoJCXVuaWZvcm1fYnl0ZXMgPSB1bmlmb3JtX2J5dGVzLi5iX2kKCWVuZAoJcmV0dXJuIHVuaWZvcm1fYnl0ZXM6c3ViKDEsbGVuX2luX2J5dGVzKSwgRFNUX3ByaW1lLCBtc2dfcHJpbWUKCmVuZAoKCnJldHVybiBoYXNoCi96ZW5yb29tX2pzb24ubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIEZyaWRheSwgMTJ0aCBOb3ZlbWJlciAyMDIxCi0tXV0KCmxvY2FsIEogPSByZXF1aXJlKCdqc29uJykKCgpKLmRlY29kZSA9IGZ1bmN0aW9uKGRhdGEpCiAgIGlmIG5vdCBkYXRhIHRoZW4gZXJyb3IoIkpTT04uZGVjb2RlIGNhbGxlZCB3aXRob3V0IGFyZ3VtZW50IiwgMikgZW5kCiAgIGlmICNkYXRhIDwgMiB0aGVuIGVycm9yKCJKU09OLmRlY29kZSBhcmd1bWVudCBpcyBlbXB0eSBzdHJpbmciLCAyKSBlbmQKICAgaWYgbHVhdHlwZShkYXRhKSB+PSAic3RyaW5nIiB0aGVuIGVycm9yKCJKU09OLmRlY29kZSBhcmd1bWVudCBvZiB1bnNvcHBvcnRlZCB0eXBlOiAiLi5sdWF0eXBlKGRhdGEpLCAyKSBlbmQKICAgbG9jYWwgcmVzID0ge30KICAgbG9jYWwgcmlnaHQgPSB0b3N0cmluZyhkYXRhKQogICBsb2NhbCBsZWZ0CiAgIGxvY2FsIHRtcAogICB3aGlsZSByaWdodCBhbmQgcmlnaHQgfj0gIiIgZG8KICAgICAgbGVmdCwgcmlnaHQgPSBqc29udG9rKHJpZ2h0KSAtLSBmdW5jdGlvbiBpbiB6ZW5fcGFyc2VyLmMKICAgICAgaWYgbm90IGxlZnQgdGhlbgogICAgICAgICBlcnJvcigiSlNPTiBkZWNvZGUgaW5wdXQgaXMgbm90IGEgZW5jb2RlZCB0YWJsZSIsIDIpCiAgICAgICAgIGJyZWFrCiAgICAgIGVuZAogICAgICB0bXAgPSBKU09OLnJhd19kZWNvZGUobGVmdCkKICAgICAgaWYgbHVhdHlwZSh0bXApID09ICd0YWJsZScgdGhlbgogICAgICAgICAgICBmb3Igayx2IGluIHBhaXJzKHRtcCkgZG8KICAgICAgICAgICAgICAgcmVzW2tdID0gdgogICAgICAgICAgICBlbmQKICAgICAgZWxzZQogICAgICAgICBlcnJvcigiSlNPTiBkZWNvZGUgaGFzIG5vdCByZXR1cm5lZCBhIHRhYmxlIiwgMikKICAgICAgZW5kCiAgIGVuZAogICByZXR1cm4gcmVzCmVuZAoKSi5lbmNvZGUgPSBmdW5jdGlvbih0YWIsZW5jLHdoaXRlc3BhY2UpCiAgIC0tIHRhYiBub3QgYSB0YWJsZQogICBpZiBsdWF0eXBlKHRhYikgfj0gJ3RhYmxlJyB0aGVuCiAgICBlcnJvcigiSlNPTiBlbmNvZGUgaW5wdXQgaXMgbm90IGEgdGFibGUiLCAyKQogICBlbmQKICAgcmV0dXJuCiAgICAgIEpTT04ucmF3X2VuY29kZSgKCSAtLSBwcm9jZXNzIGVuY29kZXMgemVuY29kZSB0eXBlcwoJIC0tIGl0IGlzIHBhcnQgb2YgaW5zcGVjdC5sdWEKCSBJTlNQRUNULnByb2Nlc3ModGFiLCBlbmMgb3IgQ09ORi5vdXRwdXQuZW5jb2RpbmcubmFtZSksCgkgd2hpdGVzcGFjZQogICAgICApCmVuZAoKCi0tIGdlbmVyYXRlIGEgc2VyaWFsaXplZCB1cmw2NChKU09OKSBlbmNvZGVkIG9jdGV0IHN0cmluZyBvZiBhbnkgb2JqZWN0Ci0tIEBwYXJhbSBhbnkgdGhlIG9iamVjdCB0byBzZXJpYWxpemUKLS0gQHJldHVybiBvY3RldCB3aGljaCBzaG91bGQgYmUgcHJpbnRlZCBhcyBzdHJpbmcKSi5zZXJpYWxpemUgPSBmdW5jdGlvbihhbnkpCiAgICBpZiBsdWF0eXBlKGFueSkgPT0gJ3RhYmxlJyB0aGVuCiAgICAgICAgcmV0dXJuICgKICAgICAgICAgICAgTy5mcm9tX3N0cmluZwogICAgICAgICAgICAoTy50b191cmw2NAogICAgICAgICAgICAgKE8uZnJvbV9zdHJpbmcKICAgICAgICAgICAgICAoSlNPTi5lbmNvZGUKICAgICAgICAgICAgICAgKGRlZXBtYXAKICAgICAgICAgICAgICAgIChmdW5jdGlvbihvKQogICAgICAgICAgICAgICAgICAgICAgICBsb2NhbCB0IDxjb25zdD4gPSB0eXBlKG8pCiAgICAgICAgICAgICAgICAgICAgICAgIGlmIHQgPT0gJ2Jvb2xlYW4nIG9yIHQgPT0gJ3plbnJvb20udGltZScgdGhlbgogICAgICAgICAgICAgICAgICAgICAgICAgICAgcmV0dXJuKG8pCiAgICAgICAgICAgICAgICAgICAgICAgIGVsc2VpZiBpc3plbih0KSB0aGVuCiAgICAgICAgICAgICAgICAgICAgICAgICAgICByZXR1cm4gTy50b19zdHJpbmcobzpvY3RldCgpKQogICAgICAgICAgICAgICAgICAgICAgICBlbHNlCiAgICAgICAgICAgICAgICAgICAgICAgICAgICByZXR1cm4odG9zdHJpbmcobykpCiAgICAgICAgICAgICAgICAgICAgICAgIGVuZAogICAgICAgICAgICAgICAgZW5kLGFueSkpCiAgICAgICAgICAgICAgKQogICAgICAgICAgICAgKQogICAgICAgICAgICApCiAgICAgICAgKQogICAgZWxzZQogICAgICAgIGlmIG5vdCBpc3plbih0eXBlKGFueSkpIHRoZW4KICAgICAgICAgICAgZXJyb3IoIkpTT04gc2VyaWFsaXplIGNhbGxlZCB3aXRoIHdyb25nIGFyZ3VtZW50IHR5cGU6ICIKICAgICAgICAgICAgICAgICAgLi50eXBlKGFueSksMikKICAgICAgICBlbmQKICAgICAgICBpZiAjYW55ID09IDAgdGhlbiByZXR1cm4gTy5mcm9tX3N0cmluZygnJykgZW5kCiAgICAgICAgcmV0dXJuIE8uZnJvbV9zdHJpbmcoTy50b191cmw2NChhbnk6b2N0ZXQoKSkpCiAgICBlbmQKZW5kCgotLSBnZW5lcmF0ZSBhIGRlLXNlcmlhbGl6ZWQgb2JqZWN0IGZyb20KLS0gYW55IHNlcmlhbGl6ZWQgb2N0ZXQKLS0gQHBhcmFtIGp3cyB0aGUgb2JqZWN0IHRvIHNlcmlhbGl6ZQotLSBAcmV0dXJuIG9iamVjdCB3aGljaCBjYW4gYmUgYWxzbyBhIHRhYmxlCkouZGVzZXJpYWxpemUgPSBmdW5jdGlvbihhbnkpCiAgICBpZiBub3QgaXN6ZW4odHlwZShhbnkpKSB0aGVuCiAgICAgICAgZXJyb3IoIkpPU0UgZGVzZXJpYWxpemUgY2FsbGVkIHdpdGggd3JvbmcgYXJndW1lbnQgdHlwZTogIgogICAgICAgICAgICAgIC4udHlwZShhbnkpLDIpCiAgICBlbmQKICAgIGxvY2FsIHUgPGNvbnN0PiA9IE8uZnJvbV91cmw2NChPLnRvX3N0cmluZyhhbnkpKQogICAgbG9jYWwgcyA8Y29uc3Q+ID0gTy50b19zdHJpbmcodSkKICAgIGlmIEpTT04udmFsaWRhdGUocykgdGhlbgogICAgICAgIHJldHVybiBKU09OLmRlY29kZShzKQogICAgZWxzZQogICAgICAgIHJldHVybih1KQogICAgZW5kCmVuZAoKSi5hdXRvID0gZnVuY3Rpb24ob2JqKQogICBsb2NhbCB0ID0gdHlwZShvYmopCiAgIGlmIHQgPT0gJ3RhYmxlJyB0aGVuCgkgIC0tIGV4cG9ydCB0YWJsZSB0byBKU09OCgkgIHJldHVybiBKU09OLmVuY29kZShvYmopCiAgIGVsc2VpZiB0ID09ICdzdHJpbmcnIHRoZW4KCSAgLS0gaW1wb3J0IEpTT04gc3RyaW5nIHRvIHRhYmxlCgkgIHJldHVybiBKU09OLmRlY29kZShvYmopCiAgIGVsc2UKCSAgZXJyb3IoIkpTT04uYXV0byB1bnJlY29nbmlzZWQgaW5wdXQgdHlwZTogIi4udCwgMykKCSAgcmV0dXJuIG5pbAogICBlbmQKZW5kCgotLSB2YWxpZGF0ZSBhIEpTT04KLS0gQHBhcmFtIGlucHV0IHN0cmluZyBlbmNvZGVkIGpzb24KLS0gQHJldHVybiBzdGF0dXM6IHRydWUgaWYgaW5wdXQgd2FzIHZhbGlkIGpzb24sIGZhbHNlIG90aGVyd2lzZQotLSBAcmV0dXJuIHZhbHVlOiBlcnJvciBpbiBjYXNlIHN0YXR1cyBpcyBmYWxzZSwgdGFibGUgaWYgc3RhdHVzIGlzIHRydWUKSi52YWxpZGF0ZSA9IGZ1bmN0aW9uKGlucHV0KQogICAgcmV0dXJuIHBjYWxsKEpTT04uZGVjb2RlLCBpbnB1dCkKZW5kCgpyZXR1cm4gSgovemVucm9vbV9tc2dwYWNrLmx1YQAtLVtbCi0tVGhpcyBmaWxlIGlzIHBhcnQgb2YgemVucm9vbQotLQotLUNvcHlyaWdodCAoQykgMjAyMi0yMDI1IER5bmUub3JnIGZvdW5kYXRpb24KLS1kZXNpZ25lZCwgd3JpdHRlbiBhbmQgbWFpbnRhaW5lZCBieSBEZW5pcyBSb2lvIDxqYXJvbWlsQGR5bmUub3JnPgotLQotLVRoaXMgcHJvZ3JhbSBpcyBmcmVlIHNvZnR3YXJlOiB5b3UgY2FuIHJlZGlzdHJpYnV0ZSBpdCBhbmQvb3IgbW9kaWZ5Ci0taXQgdW5kZXIgdGhlIHRlcm1zIG9mIHRoZSBHTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLQotLVRoaXMgcHJvZ3JhbSBpcyBkaXN0cmlidXRlZCBpbiB0aGUgaG9wZSB0aGF0IGl0IHdpbGwgYmUgdXNlZnVsLAotLWJ1dCBXSVRIT1VUIEFOWSBXQVJSQU5UWTsgd2l0aG91dCBldmVuIHRoZSBpbXBsaWVkIHdhcnJhbnR5IG9mCi0tTUVSQ0hBTlRBQklMSVRZIG9yIEZJVE5FU1MgRk9SIEEgUEFSVElDVUxBUiBQVVJQT1NFLiAgU2VlIHRoZQotLUdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSBmb3IgbW9yZSBkZXRhaWxzLgotLQotLUFsb25nIHdpdGggdGhpcyBwcm9ncmFtIHlvdSBzaG91bGQgaGF2ZSByZWNlaXZlZCBhIGNvcHkgb2YgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIHYzLjAKLS1JZiBub3QsIHNlZSBodHRwOi8vd3d3LmdudS5vcmcvbGljZW5zZXMvYWdwbC50eHQKLS1dXQoKbG9jYWwgbXBhY2sgPSByZXF1aXJlX29uY2UnbXNncGFjaycKbG9jYWwgcGFjayA9IHN0cmluZy5wYWNrCmxvY2FsIHVucGFjayA9IHN0cmluZy51bnBhY2sKCmxvY2FsIHRvX29jdGVudiA9IE9DVEVULnRvX3VybDY0CmxvY2FsIGZyb21fb2N0ZW52ID0gT0NURVQuZnJvbV91cmw2NAoKLS0gdXNlcmRhdGEgY29kZXMgYXZhaWxhYmxlCgotLSAweGN7Nyw4LDl9IAptcGFjay5lbmNvZGVyX2Z1bmN0aW9uc1snemVucm9vbS5vY3RldCddID0gZnVuY3Rpb24odikKICAgcmV0dXJuIHBhY2soJz5CczQnLCAweGM3LCB0b19vY3RlbnYodikpIGVuZAptcGFjay5lbmNvZGVyX2Z1bmN0aW9uc1snemVucm9vbS5iaWcnXSA9IGZ1bmN0aW9uKHYpCiAgIHJldHVybiBwYWNrKCc+QnM0JywgMHhjOCwgdG9fb2N0ZW52KHY6b2N0ZXQoKSkpIGVuZAotLSByZXNlcnZlZCBmb3IgemVucm9vbSAzLjAKLS0gbXBhY2suZW5jb2Rlcl9mdW5jdGlvbnNbJ3plbnJvb20uZmxvYXQnXSA9IGZ1bmN0aW9uKHYpCi0tICAgIHJldHVybiBwYWNrKCc+QnM0JywgMHhjOSwgdG9fb2N0ZW52KHY6b2N0ZXQoKSkpIGVuZAoKLS0gMHhkezQsNSw2LDcsOH0KbXBhY2suZW5jb2Rlcl9mdW5jdGlvbnNbJ3plbnJvb20uZWNwJ10gICA9IGZ1bmN0aW9uKHYpCiAgIHJldHVybiBwYWNrKCc+QnM0JywgMHhkNCwgdG9fb2N0ZW52KHY6b2N0ZXQoKSkpIGVuZAptcGFjay5lbmNvZGVyX2Z1bmN0aW9uc1snemVucm9vbS5lY3AyJ10gICA9IGZ1bmN0aW9uKHYpCiAgIHJldHVybiBwYWNrKCc+QnM0JywgMHhkNSwgdG9fb2N0ZW52KHY6b2N0ZXQoKSkpIGVuZAoKbG9jYWwgZnVuY3Rpb24gZGVjb2RlX29jdGV0KGRhdGEsIG9mZnNldCkKICAgbG9jYWwgdmFsdWUsIHBvcyA9IHVucGFjaygnPnM0JywgZGF0YSwgb2Zmc2V0KQogICByZXR1cm4gZnJvbV9vY3RlbnYodmFsdWUpLCBwb3MKZW5kCmxvY2FsIGZ1bmN0aW9uIGRlY29kZV9iaWcoZGF0YSwgb2Zmc2V0KQogICBsb2NhbCB2YWx1ZSwgcG9zID0gdW5wYWNrKCc+czQnLCBkYXRhLCBvZmZzZXQpCiAgIHJldHVybiBCSUcubmV3KGZyb21fb2N0ZW52KHZhbHVlKSksIHBvcwplbmQKbG9jYWwgZnVuY3Rpb24gZGVjb2RlX2VjcChkYXRhLCBvZmZzZXQpCiAgIGxvY2FsIHZhbHVlLCBwb3MgPSB1bnBhY2soJz5zNCcsIGRhdGEsIG9mZnNldCkKICAgcmV0dXJuIEVDUC5uZXcoZnJvbV9vY3RlbnYodmFsdWUpKSwgcG9zICAgCmVuZApsb2NhbCBmdW5jdGlvbiBkZWNvZGVfZWNwMihkYXRhLCBvZmZzZXQpCiAgIGxvY2FsIHZhbHVlLCBwb3MgPSB1bnBhY2soJz5zNCcsIGRhdGEsIG9mZnNldCkKICAgcmV0dXJuIEVDUDIubmV3KGZyb21fb2N0ZW52KHZhbHVlKSksIHBvcyAgIAplbmQKbXBhY2suZGVjb2Rlcl9mdW5jdGlvbnNbMHhjN10gPSBkZWNvZGVfb2N0ZXQKbXBhY2suZGVjb2Rlcl9mdW5jdGlvbnNbMHhjOF0gPSBkZWNvZGVfYmlnCm1wYWNrLmRlY29kZXJfZnVuY3Rpb25zWzB4ZDRdID0gZGVjb2RlX2VjcAptcGFjay5kZWNvZGVyX2Z1bmN0aW9uc1sweGQ1XSA9IGRlY29kZV9lY3AyCgpyZXR1cm4gbXBhY2sKL3plbnJvb21fb2N0ZXQubHVhAC0tW1sKLS1UaGlzIGZpbGUgaXMgcGFydCBvZiB6ZW5yb29tCi0tCi0tQ29weXJpZ2h0IChDKSAyMDE4LTIwMjUgRHluZS5vcmcgZm91bmRhdGlvbgotLWRlc2lnbmVkLCB3cml0dGVuIGFuZCBtYWludGFpbmVkIGJ5IERlbmlzIFJvaW8gPGphcm9taWxAZHluZS5vcmc+Ci0tCi0tVGhpcyBwcm9ncmFtIGlzIGZyZWUgc29mdHdhcmU6IHlvdSBjYW4gcmVkaXN0cmlidXRlIGl0IGFuZC9vciBtb2RpZnkKLS1pdCB1bmRlciB0aGUgdGVybXMgb2YgdGhlIEdOVSBBZmZlcm8gR2VuZXJhbCBQdWJsaWMgTGljZW5zZSB2My4wCi0tCi0tVGhpcyBwcm9ncmFtIGlzIGRpc3RyaWJ1dGVkIGluIHRoZSBob3BlIHRoYXQgaXQgd2lsbCBiZSB1c2VmdWwsCi0tYnV0IFdJVEhPVVQgQU5ZIFdBUlJBTlRZOyB3aXRob3V0IGV2ZW4gdGhlIGltcGxpZWQgd2FycmFudHkgb2YKLS1NRVJDSEFOVEFCSUxJVFkgb3IgRklUTkVTUyBGT1IgQSBQQVJUSUNVTEFSIFBVUlBPU0UuICBTZWUgdGhlCi0tR05VIEFmZmVybyBHZW5lcmFsIFB1YmxpYyBMaWNlbnNlIGZvciBtb3JlIGRldGFpbHMuCi0tCi0tQWxvbmcgd2l0aCB0aGlzIHByb2dyYW0geW91IHNob3VsZCBoYXZlIHJlY2VpdmVkIGEgY29weSBvZiB0aGUKLS1HTlUgQWZmZXJvIEdlbmVyYWwgUHVibGljIExpY2Vuc2UgdjMuMAotLUlmIG5vdCwgc2VlIGh0dHA6Ly93d3cuZ251Lm9yZy9saWNlbnNlcy9hZ3BsLnR4dAotLQotLUxhc3QgbW9kaWZpZWQgYnkgRGVuaXMgUm9pbwotLW9uIFR1ZXNkYXksIDIwdGggSnVseSAyMDIxCi0tXV0KCmxvY2FsIG9jdGV0ID0gcmVxdWlyZSdvY3RldCcKCi0tLSBpbXBsaWNpdCBjb252ZXJ0aW9uIGZ1bmN0aW9ucyBnb2luZyBib3RoIHdheXMKLS0gaWYgaW5wdXQgaXMgYW4gZW5jb2RlZCBzdHJpbmcsIHdpbGwgYmVjb21lIGFuIG9jdGV0Ci0tIGlmIGlucHV0IGlzIGEgbm9uLWVuY29kZWQgc3RyaW5nLCBpdCB3aWxsIGJlY29tZSBhIGJhc2U2NCBzdHJpbmcKLS0gaWYgaW5wdXQgaXMgYW4gb2N0ZXQsIHdpbGwgYmVjb21lIGFuIGVuY29kZWQgc3RyaW5nCmZ1bmN0aW9uIGhleChkYXRhKQogICBsb2NhbCB0ID0gdHlwZShkYXRhKQogICBpZih0ID09ICJzdHJpbmciKSB0aGVuCgkgIGlmIE8uaXNfaGV4KGRhdGEpIHRoZW4gcmV0dXJuIE8uZnJvbV9oZXgoZGF0YSkKCSAgZWxzZSByZXR1cm4gTy5mcm9tX3N0cihkYXRhKTpoZXgoKSBlbmQKICAgZWxzZWlmKHQgPT0gIm51bWJlciIpIHRoZW4gcmV0dXJuIGRhdGEKICAgZWxzZWlmKHQgPT0gInRhYmxlIikgdGhlbiByZXR1cm4gZGF0YQogICBlbHNlaWYgaXN6ZW4odCkgdGhlbiByZXR1cm4gZGF0YTpvY3RldCgpOmhleCgpIC0tIGFueSB6ZW5yb29tIHR5cGUgdG8gb2N0ZXQKICAgZW5kCmVuZApmdW5jdGlvbiBzdHIoZGF0YSkKICAgbG9jYWwgdCA9IHR5cGUoZGF0YSkKICAgaWYodCA9PSAic3RyaW5nIikgYW5kIGRhdGEgfj0gIiIgdGhlbgoJICBpZiBPQ1RFVC5pc191cmw2NChkYXRhKSB0aGVuCgkJIC0tIHJldHVybiBkZWNvZGVkIHN0cmluZyBmb3JtYXQgZm9yIEpTT04uZGVjb2RlCgkJIHJldHVybiBPQ1RFVC5mcm9tX3VybDY0KGRhdGEpOnN0cigpCgkgIGVsc2VpZiBPQ1RFVC5pc19iYXNlNjQoZGF0YSkgdGhlbgoJCSAtLSByZXR1cm4gZGVjb2RlZCBzdHJpbmcgZm9ybWF0IGZvciBKU09OLmRlY29kZQogICAgICAgcmV0dXJuIE9DVEVULmZyb21fYmFzZTY0KGRhdGEpOnN0cigpCiAgICAgIGVsc2VpZiBPQ1RFVC5pc19iYXNlNTgoZGF0YSkgdGhlbgogICAgICAgICAtLSByZXR1cm4gZGVjb2RlZCBzdHJpbmcgZm9ybWF0IGZvciBKU09OLmRlY29kZQogICAgICAgICByZXR1cm4gT0NURVQuZnJvbV9iYXNlNTgoZGF0YSk6c3RyKCkKCSAgZWxzZWlmIE9DVEVULmlzX2hleChkYXRhKSB0aGVuCgkJIC0tIHJldHVybiBkZWNvZGVkIHN0cmluZyBmb3JtYXQgZm9yIEpTT04uZGVjb2RlCgkJIHJldHVybiBPQ1RFVC5mcm9tX2hleChkYXRhKTpzdHIoKQoJICBlbHNlaWYgT0NURVQuaXNfYmluKGRhdGEpIHRoZW4KCQkgLS0gcmV0dXJuIGRlY29kZWQgc3RyaW5nIGZvcm1hdCBmb3IgSlNPTi5kZWNvZGUKCQkgcmV0dXJuIE9DVEVULmZyb21fYmluKGRhdGEpOnN0cigpCgkgIGVsc2UgLS0gaXRzIGFscmVhZHkgYSBzdHJpbmcgKHdlIHN1cHBvc2UsIHRoaXMgaXMgbm90IGRldGVybWluaXN0aWMpCgkJIHJldHVybiBkYXRhCgkgIGVuZAogICBlbHNlaWYgaXN6ZW4odCkgdGhlbgoJICByZXR1cm4gZGF0YTpvY3RldCgpOnN0cigpCiAgIGVsc2UKCSAgZXJyb3IoImF1dG9tYXRpYyBzdHIoKSBjb252ZXJzaW9uIGZhaWxlZCBmb3IgdHlwZTogIi4udCkKICAgZW5kCmVuZAoKZnVuY3Rpb24gYmluKGRhdGEpCiAgIGxvY2FsIHQgPSB0eXBlKGRhdGEpCiAgIGlmKHQgPT0gInN0cmluZyIpIHRoZW4KCSAgaWYgTy5pc19iaW4oZGF0YSkgdGhlbiByZXR1cm4gTy5mcm9tX2JpbihkYXRhKQoJICBlbHNlIHJldHVybiBPLmZyb21fc3RyKGRhdGEpOmJpbigpIGVuZAogICBlbHNlaWYodCA9PSAibnVtYmVyIikgdGhlbiByZXR1cm4gZGF0YQogICBlbHNlaWYodCA9PSAidGFibGUiKSB0aGVuIHJldHVybiBkYXRhCiAgIGVsc2VpZiBpc3plbih0KSB0aGVuIHJldHVybiBkYXRhOm9jdGV0KCk6YmluKCkgLS0gYW55IHplbnJvb20gdHlwZSB0byBvY3RldAogICBlbmQKZW5kCmZ1bmN0aW9uIGJhc2U2NChkYXRhKQogICBpZiBub3QgZGF0YSB0aGVuIGVycm9yKCJJbnRlcm5hbCBkYXRhIGNvbnZlcnNpb24gb24gbmlsIiwyKSBlbmQKICAgbG9jYWwgdCA9IHR5cGUoZGF0YSkKICAgaWYodCA9PSAic3RyaW5nIikgdGhlbgoJICBpZiBPLmlzX2Jhc2U2NChkYXRhKSB0aGVuIHJldHVybiBPLmZyb21fYmFzZTY0KGRhdGEpCgkgIGVsc2UgcmV0dXJuIE8uZnJvbV9zdHIoZGF0YSk6YmFzZTY0KCkgZW5kCiAgIGVsc2VpZih0ID09ICJudW1iZXIiKSB0aGVuIHJldHVybiBkYXRhCiAgIGVsc2VpZih0ID09ICJ0YWJsZSIpIHRoZW4gcmV0dXJuIGRhdGEKICAgZWxzZWlmIGlzemVuKHQpIHRoZW4gcmV0dXJuIGRhdGE6b2N0ZXQoKTpiYXNlNjQoKSAtLSBhbnkgemVucm9vbSB0eXBlIHRvIG9jdGV0CiAgIGVuZAplbmQKZnVuY3Rpb24gdXJsNjQoZGF0YSkKICAgaWYgbm90IGRhdGEgdGhlbiBlcnJvcigiSW50ZXJuYWwgZGF0YSBjb252ZXJzaW9uIG9uIG5pbCIsMikgZW5kCiAgIGxvY2FsIHQgPSB0eXBlKGRhdGEpCiAgIGlmKHQgPT0gInN0cmluZyIpIHRoZW4KCSAgaWYgTy5pc191cmw2NChkYXRhKSB0aGVuIHJldHVybiBPLmZyb21fdXJsNjQoZGF0YSkKCSAgZWxzZSByZXR1cm4gTy5mcm9tX3N0cihkYXRhKTp1cmw2NCgpIGVuZAogICBlbHNlaWYodCA9PSAibnVtYmVyIikgdGhlbiByZXR1cm4gZGF0YQogICBlbHNlaWYodCA9PSAidGFibGUiKSB0aGVuIHJldHVybiBkYXRhCiAgIGVsc2VpZiBpc3plbih0KSB0aGVuIHJldHVybiBkYXRhOm9jdGV0KCk6dXJsNjQoKSAtLSBhbnkgemVucm9vbSB0eXBlIHRvIG9jdGV0CiAgIGVuZAplbmQKZnVuY3Rpb24gYmFzZTU4KGRhdGEpCiAgIGxvY2FsIHQgPSB0eXBlKGRhdGEpCiAgIGlmKHQgPT0gInN0cmluZyIpIHRoZW4KCSAgaWYgTy5pc19iYXNlNTgoZGF0YSkgdGhlbiByZXR1cm4gTy5mcm9tX2Jhc2U1OChkYXRhKQoJICBlbHNlIHJldHVybiBPLmZyb21fc3RyKGRhdGEpOmJhc2U1OCgpIGVuZAogICBlbHNlaWYgaXN6ZW4odCkgdGhlbiByZXR1cm4gZGF0YTpvY3RldCgpOmJhc2U1OCgpIC0tIGFueSB6ZW5yb29tIHR5cGUgdG8gb2N0ZXQKICAgZW5kCmVuZAoKcmV0dXJuIG9jdGV0CgAAAAQAAFYFAAANBAAAYwkAAIICAABuCQAA8AsAAJ6xAAAADAAAnr0AADlIAACyvQAA6wUBAFEdAAACBgEAUyMBABwWAABnIwEAgzkBAGJKAACYOQEA+oMBANsQAAAShAEA7ZQBAGAQAAD9lAEAXaUBALwfAABupQEAKsUBALIPAABNxQEA/9QBAD8OAAAS1QEAUeMBAEIZAABo4wEAqvwBACkRAAC//AEA6A0CAMMvAAD5DQIAvD0CAAUZAADaPQIA31YCAD0dAADyVgIAL3QCAK4kAAA/dAIA7ZgCAAYeAAD7mAIAAbcCAKUbAAALtwIAsNICAIo+AAC90gIARxEDAC8sAABREQMAgD0DAKcoAACNPQMANGYDAHcMAABCZgMAuXIDABkcAADFcgMA3o4DADoMAADpjgMAI5sDAMQJAAA1mwMA+aQDAFQJAAAEpQMAWK4DAFMyAABnrgMAuuADALR6AADH4AMAe1sEAOUbAACOWwQAc3cEAMNEAACEdwQAR7wEAKYeAABcvAQAAtsEADIcAAAa2wQATPcEALpUAABe9wQAGEwFAN0VAAArTAUACGIFANsjAAAgYgUA+4UFAIAcAAAMhgUAjKIFABoMAACeogUAuK4FAAQZAADKrgUAzscFAI4LAADhxwUAb9MFADkNAACC0wUAu+AFAIVHAADR4AUAVigGANQYAABrKAYAP0EGAKcTAABQQQYA91QGAKxDAAAKVQYAtpgGACweAADImAYA9LYGALkfAAAGtwYAv9YGAIESAADQ1gYAUekGAMEgAABi6QYAIwoHAAgJAAA0CgcAPBMHAOEfAABREwcAMjMHAJ8YAABKMwcA6UsHAK4rAAD7SwcAqXcHACsTAAC9dwcA6IoHACkFAAD6igcAI5AHAMYeAAA5kAcA/64HAPkDAAAXrwcAELMHAFAhAAAiswcActQHALQpAACC1AcANv4HACcqAABK/gcAcSgIAOkuAACFKAgAblcIABoJAAB/VwgAmWAIAN4KAACuYAgAjGsIAKc8AACgawgAR6gIAIkLAABdqAgA5rMIAA0oAAD5swgABtwIAIEjAAAY3AgAmf8IAMATAACr/wgAaxMJAMMPAAB7EwkAPiMJABUxAABSIwkAZ1QJAMYDAAB4VAkAPlgJAEFGAABQWAkAkZ4JAMYPAACkngkAaq4JAEkBAAB7rgkAxK8JAGg9AADYrwkAQO0JAGAKAABS7QkAsvcJAKwDAADD9wkAb/sJANIDAACB+wkAU/8JAF4SAABl/wkAwxEKAEsQAADVEQoAICIKAMsIAAA1IgoAACsKAK8OAAATKwoAAAAAAE5vIGVycm9yIGluZm9ybWF0aW9uAElsbGVnYWwgYnl0ZSBzZXF1ZW5jZQBEb21haW4gZXJyb3IAUmVzdWx0IG5vdCByZXByZXNlbnRhYmxlAE5vdCBhIHR0eQBQZXJtaXNzaW9uIGRlbmllZABPcGVyYXRpb24gbm90IHBlcm1pdHRlZABObyBzdWNoIGZpbGUgb3IgZGlyZWN0b3J5AE5vIHN1Y2ggcHJvY2VzcwBGaWxlIGV4aXN0cwBWYWx1ZSB0b28gbGFyZ2UgZm9yIGRhdGEgdHlwZQBObyBzcGFjZSBsZWZ0IG9uIGRldmljZQBPdXQgb2YgbWVtb3J5AFJlc291cmNlIGJ1c3kASW50ZXJydXB0ZWQgc3lzdGVtIGNhbGwAUmVzb3VyY2UgdGVtcG9yYXJpbHkgdW5hdmFpbGFibGUASW52YWxpZCBzZWVrAENyb3NzLWRldmljZSBsaW5rAFJlYWQtb25seSBmaWxlIHN5c3RlbQBEaXJlY3Rvcnkgbm90IGVtcHR5AENvbm5lY3Rpb24gcmVzZXQgYnkgcGVlcgBPcGVyYXRpb24gdGltZWQgb3V0AENvbm5lY3Rpb24gcmVmdXNlZABIb3N0IGlzIGRvd24ASG9zdCBpcyB1bnJlYWNoYWJsZQBBZGRyZXNzIGluIHVzZQBCcm9rZW4gcGlwZQBJL08gZXJyb3IATm8gc3VjaCBkZXZpY2Ugb3IgYWRkcmVzcwBCbG9jayBkZXZpY2UgcmVxdWlyZWQATm8gc3VjaCBkZXZpY2UATm90IGEgZGlyZWN0b3J5AElzIGEgZGlyZWN0b3J5AFRleHQgZmlsZSBidXN5AEV4ZWMgZm9ybWF0IGVycm9yAEludmFsaWQgYXJndW1lbnQAQXJndW1lbnQgbGlzdCB0b28gbG9uZwBTeW1ib2xpYyBsaW5rIGxvb3AARmlsZW5hbWUgdG9vIGxvbmcAVG9vIG1hbnkgb3BlbiBmaWxlcyBpbiBzeXN0ZW0ATm8gZmlsZSBkZXNjcmlwdG9ycyBhdmFpbGFibGUAQmFkIGZpbGUgZGVzY3JpcHRvcgBObyBjaGlsZCBwcm9jZXNzAEJhZCBhZGRyZXNzAEZpbGUgdG9vIGxhcmdlAFRvbyBtYW55IGxpbmtzAE5vIGxvY2tzIGF2YWlsYWJsZQBSZXNvdXJjZSBkZWFkbG9jayB3b3VsZCBvY2N1cgBTdGF0ZSBub3QgcmVjb3ZlcmFibGUAUHJldmlvdXMgb3duZXIgZGllZABPcGVyYXRpb24gY2FuY2VsZWQARnVuY3Rpb24gbm90IGltcGxlbWVudGVkAE5vIG1lc3NhZ2Ugb2YgZGVzaXJlZCB0eXBlAElkZW50aWZpZXIgcmVtb3ZlZABEZXZpY2Ugbm90IGEgc3RyZWFtAE5vIGRhdGEgYXZhaWxhYmxlAERldmljZSB0aW1lb3V0AE91dCBvZiBzdHJlYW1zIHJlc291cmNlcwBMaW5rIGhhcyBiZWVuIHNldmVyZWQAUHJvdG9jb2wgZXJyb3IAQmFkIG1lc3NhZ2UARmlsZSBkZXNjcmlwdG9yIGluIGJhZCBzdGF0ZQBOb3QgYSBzb2NrZXQARGVzdGluYXRpb24gYWRkcmVzcyByZXF1aXJlZABNZXNzYWdlIHRvbyBsYXJnZQBQcm90b2NvbCB3cm9uZyB0eXBlIGZvciBzb2NrZXQAUHJvdG9jb2wgbm90IGF2YWlsYWJsZQBQcm90b2NvbCBub3Qgc3VwcG9ydGVkAFNvY2tldCB0eXBlIG5vdCBzdXBwb3J0ZWQATm90IHN1cHBvcnRlZABQcm90b2NvbCBmYW1pbHkgbm90IHN1cHBvcnRlZABBZGRyZXNzIGZhbWlseSBub3Qgc3VwcG9ydGVkIGJ5IHByb3RvY29sAEFkZHJlc3Mgbm90IGF2YWlsYWJsZQBOZXR3b3JrIGlzIGRvd24ATmV0d29yayB1bnJlYWNoYWJsZQBDb25uZWN0aW9uIHJlc2V0IGJ5IG5ldHdvcmsAQ29ubmVjdGlvbiBhYm9ydGVkAE5vIGJ1ZmZlciBzcGFjZSBhdmFpbGFibGUAU29ja2V0IGlzIGNvbm5lY3RlZABTb2NrZXQgbm90IGNvbm5lY3RlZABDYW5ub3Qgc2VuZCBhZnRlciBzb2NrZXQgc2h1dGRvd24AT3BlcmF0aW9uIGFscmVhZHkgaW4gcHJvZ3Jlc3MAT3BlcmF0aW9uIGluIHByb2dyZXNzAFN0YWxlIGZpbGUgaGFuZGxlAFJlbW90ZSBJL08gZXJyb3IAUXVvdGEgZXhjZWVkZWQATm8gbWVkaXVtIGZvdW5kAFdyb25nIG1lZGl1bSB0eXBlAE11bHRpaG9wIGF0dGVtcHRlZABSZXF1aXJlZCBrZXkgbm90IGF2YWlsYWJsZQBLZXkgaGFzIGV4cGlyZWQAS2V5IGhhcyBiZWVuIHJldm9rZWQAS2V5IHdhcyByZWplY3RlZCBieSBzZXJ2aWNlAEGyiikLlgGlAlsA8AG1BYwFJQGDBh0DlAT/AMcDMQMLBrwBjwF/A8oEKwDaBq8AQgNOA9wBDgQVAKEGDQGUAgsCOAZkArwC/wJdA+cECwfPAssF7wXbBeECHgZFAoUAggJsA28E8QDzAxgF2QDaA0wGVAJ7AZ0DvQQAAFEAFQK7ALMDbQD/AYUELwX5BDgAZQFGAZ8AtwaoAXMCUwEAQfiLKQsMIQQAAAAAAAAAAC8CAEGYjCkLBjUERwRWBABBrowpCwKgBABBwowpC/WGA0YFYAVuBWEGAADPAQAAAAAAAAAAyQbpBvkGHgc5B0kHXgcAAAAAAAAgZUcV9z8Aou8u/AXnPTmDK2VHFee/vgQ63AnH3j/7L3BkRxXXv0hMA1Bsd9I/vJLqKLPHzr8u+RfhJWLKP/6CK2VHFee/9wM63AnH3j8/fCtlRxXXv+Rb8FBsd9I/5Y923QnHzr8258QedmHKP5unZLw/Fce/ShvwVNGExD88OCyn5InCv2buWigvs8A/+Kyxaygk9z8AsM3uXwnhv6HM0mb34fY/ANB2vZSE4L+K1DAOPaH2PwD46K5DAeC/hWzQMuxh9j8AQAs2xf7ev/iYEZX6I/Y/AOC3Gtn93b9sAs+kW+f1PwCQxwyu/9y/uE8hWgWs9T8AoP0ROATcvx5uFg/tcfU/AOA6MmcL2781+AtZCTn1PwCwLVovFdq/3a1h7U8B9T8AYPhafyHZv9B7SI64yvQ/AJBxsE0w2L/uTzO0OZX0PwDgqfmJQde/adWv38tg9D8AkBm1K1XWv1O55E5mLfQ/ABCboiNr1b+m2B0RAfvzPwCgXw9lg9S/NlgMt5XJ8z8AoPY36Z3Tv0r9tkocmfM/AGCNU6G60r+1meAMjmnzPwBAykCD2dG/sucTguQ68z8A4EA6hfrQv7G9hRkZDfM/ADDnMpwd0L/XcbLKJeDyPwBg+qJ9hc6/gs0TzwS08j8AgD1jyNPMv1DLfCywiPI/AKAUTAMmy7/lTZRjIl7yPwDgTy8cfMm/sRWGPVY08j8AAIA/AtbHvzivPuNGC/I/AOAFGqczxr/do8397uLxPwAAV+n1lMS/MDkLWEq78T8AoOAk5PnCvwAif4RTlPE/AMD9Wlliwb8819XABm7xPwCAvXWanL+/wuS3R19I8T8AwPlbV3u8v9GFAK1YI/E/AID0D8Zgub8nIlMP8P7wPwAAtkfiTLa/jzrQdyDb8D8AQAGyeD+zv9mAWdbmt/A/AMBCGn04sL+NQHv+PpXwPwAAtQiSb6q/gzvFyiVz8D8AAHdPlXqkv1wbDeSXUfA/AAAMxagjnb+ijiDBkTDwPwAAeCkmapG/IX6zJRAQ8D8AAOjY+CB3v2unyvl+wO8/AABQsVP+hj+E8fbTZUTvPwCAD+HMHKE/fxCEnwfM7j8AgIuM/E2sP+hal5k6V+4/AEBXHjKqsz/mPb3w1uXtPwCAi9CgGLk/szj/gbZ37T8AQATa6XK+P0PpTXK1DO0/AGB/UNLcwT9jdQ7csqTsPwCg3gOrdsQ/UcvW6I4/7D8AIOJ3QwfHP0wMAk8r3es/AECpi96OyT/KFWAAbH3rPwDg0mq4Dcw/jzMubjYg6z8A4M6vCoTOPzlQKSZwxeo/AIBntAp50D/dMSe8AW3qPwDAAWgFrNE/i/E/vNMW6j8A4P7UEdvSP63+Z0nRwuk/AIDFTkYG1D8CmXz05HDpPwDwOgm+LdU/8ryCOfsg6T8A0FAgkFHWP/FZ94cB0+g/APDqzdJx1z9t9rnr5YboPwCQfYWcjtg/lLlYtpc86D8AYOFVAajZPyIQxv8F9Oc/ANDTbhi+2j/KFRQYIq3nPwDgoK7y0Ns/jP+e+dxn5z8AQL89pODcP44KuRIAIOY/BbZEBqsEiTymNFcEAGDmP6n3Yuqb/2E8xfIlw/+f5j+6kDzLz36CPARauTgA4OY/JpNzVoj/iDzjlJng/x/nP7GCXydA/Yo8EA5ZFQBg5z9BgyO0df1yvNVbZRIAoOc/diskfOYIeDym6VkyAODnP7ci9ibkCGK80rK07f8f6D8vyaUeRgKEvMP8+i0AYOg/H5ryovT3bTxQa4z3/5/oP/2VSQlTBI68ZhVnOQDg6D9Fe8e+8wSKvEUXv+L/H+k/PCAOQDT6d7zRn1zM/1/pP11poAWA/3a8Z0e6OwCg6T8DfuzExPhwPKUtuef/3+k/AkaMR9l/jjyv/S7X/x/qP36uzU1VDGq8lf8E3v9f6j9rsumMqX2GPCuNXsr/n+o/3hNMtcmEgrzqA63d/9/qPzwuYOrIElg8TT0N8f8f6z+ceCet3fqOvFoWIc7/X+s/NxLGGRfLUzx05lDZ/5/rPwDOlEHZ93M8r6icEwDg6z/Am10hxAp1PJnfRlsAIOw/ycHpU6buazyu97lAAGDsP9ZwSiefB3y8iv1VYgCg7D8fTOh2QAt6vF0JTNn/3+w/17Wa+TP5iDzP1nX5/x/tP77hX2YILFi8kxxWov9f7T/zldKbKAR7vAyLIp3/n+0/NqIPNFEChzwWfrxlAODtPwzYpBYeAXW8kUf2AgAg7j/gYu8JL4CJPNim11cAYO4/+vcMWHULfrwMwO0nAKDuPxGYRQmDhIy8fMv1bADg7j/0dhWVJ4CPvMx9K3gAIO8/j1N0ctmBj7wKRQwmAGDvP9z/JycAcUC8M9WM6P+f7z+wqP3h3BtYvImGD9X/3+8/bo6Ryxr5hzxnIykEACDwP4FGMmXzf5s8aNbj4/9f8D97la7dCPqGPFenhQoAoPA/kfvTgN7iV7zMP18aAODwPxTwxQUzgpG89bqv+P8f8T/CuoBmu/qLvK2RTeX/X/E/7+c3FxJ/nbzhNqwRAKDxP//1FgUKAJw8SELIGQDg8T+gXdrk+4KQvG5e/g8AIPI/Q/ucTND9iLyR2J8mAGDyP4LRlHkq/ow82uamKQCg8j/Fi15xcwJwvDk+KeD/3/I/+aay2jl8mzyC8Nz3/x/zP1RS3G4z8X08YIta8P9f8z/rMc1MVgOevMyuDi4AoPM/d6TTS+fwdTw2sjsEAODzPzOInRTLfZw8/4fRAgAg9D8oPS3Prwh+PLF8OA0AYPQ/ppllhTcIgjyJn1YEAKD0P9K8T5Bc+om880M1BADg9D8pUxftJRF4vA9/Asz/H/U/3FR3hNiDmDxvs4f9/1/1Pwco0DHnCYe8uvcd8v+f9T8Ce3Jon/eHPIE0/Ov/3/U/PukwLpCAkbwAAAAAAADwP3SFFdOw2e8/D4n5bFi17z9RWxLQAZPvP3tRfTy4cu8/qrloMYdU7z84YnVuejjvP+HeH/WdHu8/FbcxCv4G7z/LqTo3p/HuPyI0Ekym3u4/LYlhYAjO7j8nKjbV2r/uP4JPnVYrtO4/KVRI3Qer7j+FVTqwfqTuP807f2aeoO4/dF/s6HWf7j+HAetzFKHuPxPOTJmJpe4/26AqQuWs7j/lxc2wN7fuP5Dwo4KRxO4/XSU+sgPV7j+t01qZn+juP0de+/J2/+4/nFKF3ZsZ7z9pkO/cIDfvP4ek+9wYWO8/X5t7M5d87z/akKSir6TvP0BFblt20O8/AAAAAAAA6EKUI5FL+GqsP/PE+lDOv84/1lIM/0Iu5j8AAAAAAAA4Q/6CK2VHFUdAlCORS/hqvD7zxPpQzr8uP9ZSDP9CLpY/vvP4eexh9j/eqoyA93vVvz2Ir0rtcfU/223Ap/C+0r+wEPDwOZX0P2c6UX+uHtC/hQO4sJXJ8z/pJIKm2DHLv6VkiAwZDfM/WHfACk9Xxr+gjgt7Il7yPwCBnMcrqsG/PzQaSkq78T9eDozOdk66v7rlivBYI/E/zBxhWjyXsb+nAJlBP5XwPx4M4Tj0UqK/AAAAAAAA8D8AAAAAAAAAAKxHmv2MYO4/hFnyXaqlqj+gagIfs6TsP7QuNqpTXrw/5vxqVzYg6z8I2yB35SbFPy2qoWPRwuk/cEciDYbCyz/tQXgD5oboP+F+oMiLBdE/YkhT9dxn5z8J7rZXMATUP+85+v5CLuY/NIO4SKMO0L9qC+ALW1fVPyNBCvL+/9+/vvP4eexh9j8ZMJZbxv7evz2Ir0rtcfU/pPzUMmgL27+wEPDwOZX0P3u3HwqLQde/hQO4sJXJ8z97z20a6Z3Tv6VkiAwZDfM/Mbby85sd0L+gjgt7Il7yP/B6OxsdfMm/PzQaSkq78T+fPK+T4/nCv7rlivBYI/E/XI14v8tgub+nAJlBP5XwP85fR7adb6q/AAAAAAAA8D8AAAAAAAAAAKxHmv2MYO4/PfUkn8o4sz+gagIfs6TsP7qROFSpdsQ/5vxqVzYg6z/S5MRKC4TOPy2qoWPRwuk/HGXG8EUG1D/tQXgD5oboP/ifGyycjtg/YkhT9dxn5z/Me7FOpODcP01+Cve2Ete/4DJoSb/K3j/e4/qfRxXnv7jINV9HFfc/ZXUuZmlyc3QgPT0gTjF7fQBidXp6AGphenoAcXVpegBkaXp6eQBjcmF6eQBsYXp5AHB1Ynh5AGdhbGF4eQBwdWJsaWNfeHkAZWNkaF9wdWJfeHkAcDI1Nl9wdWJfeHkAaGVhdnkAZGVwdXR5AGR1dHkAYmVhdXR5AHByZXR0eQBuYXN0eQBwb3ZlcnR5AHByb3BlcnR5AGxpYmVydHkAcGFydHkAaW50ZXJ2YWwgaXMgZW1wdHkAT3BlcmF0aW9uIG1hZGUgbm8gcHJvZ3Jlc3Mgb3ZlciBtdWx0aXBsZSBjYWxscywgZHVlIHRvIGlucHV0IGJlaW5nIGVtcHR5AGJpZ19tb250eQB0d2VudHkAZmFjdWx0eQBwZW5hbHR5AGdyYXZpdHkAcHVyaXR5AHNlY3VyaXR5AHByaW9yaXR5AGJpZ19wYXJpdHkAaXNpbmZpbml0eQBlY3BfZ2V0X2luZmluaXR5AGVjcDJfZ2V0X2luZmluaXR5AGRpZ25pdHkAdXRpbGl0eQBhYmlsaXR5AHF1YWxpdHkAY2l0eQBhbnhpZXR5AGJ1c3kAZmFudGFzeQBlYXN5AGx1eHVyeQBjZW50dXJ5AGluanVyeQBmdXJ5AGluZHVzdHJ5AGdldHJlZ2lzdHJ5AGNvdW50cnkAZW50cnkAaHVycnkAd29ycnkAc29ycnkAbWVycnkAY2hlcnJ5AGNhcnJ5AGl2b3J5AGhpc3RvcnkAdmljdG9yeQBDYW5ub3QgYWxsb2NhdGUgb2N0ZXQgbWVtb3J5AEFsbG9jYXRpb24gZXJyb3IgOiBub3QgZW5vdWdoIG1lbW9yeQBnbG9yeQBjYXRlZ29yeQB0aGVvcnkAaW5xdWlyeQBodW5ncnkAYW5ncnkAZWNkaF9kc2FfcmVjb3ZlcnkAcG90dGVyeQBsb3R0ZXJ5AG15c3RlcnkAbWlzZXJ5AGdhbGxlcnkAY2VsZXJ5AGdyb2NlcnkAbGF1bmRyeQBjcnkAZmVicnVhcnkAbW9uZXRhcnkAbGlicmFyeQB6ZW5jb2RlX2RpY3Rpb25hcnkAb3JkaW5hcnkAYmluYXJ5AHByaW1hcnkAZGlhcnkAYXR0ZW1wdCB0byB5aWVsZCBhY3Jvc3MgYSBDLWNhbGwgYm91bmRhcnkAc3B5AHB1cHB5AHVuaGFwcHkAZW50cm9weQBtZW1jb3B5AENvdWxkIG5vdCBjcmVhdGUgc2FsdCBjb3B5AHRveQBoYXNoX2Rlc3Ryb3kAcDI1Nl9kZXN0cm95AGVjcDJfZGVzdHJveQBlbXBsb3kAZW5qb3kAYm95AHBvbnkAYmFsY29ueQBzdW5ueQBmdW5ueQB0aW55AGRlbnkAY29tcGFueQBhcm15AGVjb25vbXkAZW5lbXkAdHJ1bHkAZWFybHkAc3VwcGx5AG11bHRpcGx5AG9ubHkAc2lsbHkAamVsbHkAcmFsbHkAZWFzaWx5AGZhbWlseQB1Z2x5AGZseQBiYXJlbHkAbG9uZWx5AGludmFsaWQgcGt4LCBwa3kAbHVja3kAc2h5AHRyb3BoeQBlbmVyZ3kAYXBvbG9neQBiaW9sb2d5AGVjb2xvZ3kAc3RyYXRlZ3kAc2F0aXNmeQBpZGVudGlmeQBxcF92ZXJpZnkAemVuY29kZV92ZXJpZnkAZWRfdmVyaWZ5AG1kb2NfdmVyaWZ5AHJzYV92ZXJpZnkAZWNkaF9kc2FfdmVyaWZ5AHAyNTZfdmVyaWZ5AG1sZHNhNDRfdmVyaWZ5AG1sX2RzYV80NF92ZXJpZnkAdmVyaWZpZXI6IHZlcmlmeQBjbGFyaWZ5AG1vZGlmeQBkZWZ5AHN1cnZleQBqb3VybmV5AGhvbmV5AGNoaW1uZXkAa2lkbmV5AHZhbGxleQB0dXJrZXkAbW9ua2V5AGRvbmtleQBob2NrZXkAZXh0cmFjdF9zZWNrZXkAZXh0cmFjdF9wdWJrZXkAY29tcHJlc3NfcHVibGljX2tleQBpbnZhbGlkIHNpemUgZm9yIGNpcGhlcnRleHQga2V5AGludmFsaWQgc2l6ZSBmb3Igc2VjcmV0IGtleQBmYWlsZWQgdG8gYWxsb2NhdGUgc3BhY2UgZm9yIHNlY3JldCBrZXkAQ291bGQgbm90IGNyZWF0ZSBzZWNyZXQga2V5AENvdWxkIG5vdCBhbGxvY2F0ZSBzZWNyZXQga2V5AENvdWxkIG5vdCBkdXBsaWNhdGUgc2VjcmV0IGtleQBJbnZhbGlkIHNpemUgZm9yIEVkRFNBIHNlY3JldCBrZXkASW52YWxpZCBzaXplIGZvciBFQ0RTQSBzZWNyZXQga2V5AEludmFsaWQgc2l6ZSBmb3IgUDI1NiBzZWNyZXQga2V5AGZhaWxlZCB0byBhbGxvY2F0ZSBzcGFjZSBmb3IgdGhlIGFlcyBrZXkAQ291bGQgbm90IGFsbG9jYXRlIHNlc3Npb24ga2V5AENvdWxkIG5vdCBhbGxvY2F0ZSBlcGhlbWVyYWwga2V5AENvdWxkIG5vdCBhbGxvY2F0ZSBwcml2YXRlIGtleQBmYWlsZWQgdG8gYWxsb2NhdGUgc3BhY2UgZm9yIHRoZSBwcml2YXRlIGtleQBDb3VsZCBub3QgYWxsb2NhdGUgZGVyaXZlZCBrZXkAQ291bGQgbm90IGNyZWF0ZSBzaGFyZWQga2V5AENvdWxkIG5vdCBhbGxvY2F0ZSByYXcgcHVibGljIGtleQBDb3VsZCBub3QgY29tcHJlc3MgcHVibGljIGtleQBpbnZhbGlkIHNpemUgZm9yIHB1YmxpYyBrZXkAQ291bGQgbm90IGFsbG9jYXRlIHNwYWNlIGZvciBwdWJsaWMga2V5AGZhaWxlZCB0byBhbGxvY2F0ZSBzcGFjZSBmb3IgcHVibGljIGtleQBDb3VsZCBub3QgZ2VuZXJhdGUgcHVibGljIGtleQBDb3VsZCBub3QgY3JlYXRlIHB1YmxpYyBrZXkAQ291bGQgbm90IGFsbG9jYXRlIHB1YmxpYyBrZXkAQ3VvbGQgbm90IGFsbG9jYXRlIHB1YmxpYyBrZXkAZmFpbGVkIHRvIGFsbG9jYXRlIHNwYWNlIGZvciB0aGUgcHVibGljIGtleQBDb3VsZCBub3QgY3JlYXRlIGNvbXByZXNzZWQgcHVibGljIGtleQBJbnZhbGlkIHNpemUgZm9yIEVkRFNBIHB1YmxpYyBrZXkAdGhleQBvYmV5AG1lbG9keQBlbWJvZHkAY2FuZHkAYnVkZHkAbGFkeQBhbHJlYWR5AG1lcmN5AGZhbmN5AGhvYmJ5AGJhYnkAcnVud2F5AHN1YndheQBhd2F5AHN0YXkAZXNzYXkAYmV0cmF5AHRvX2FycmF5AHplbmNvZGVfYXJyYXkAc3ByYXkAZGlzcGxheQBkZWxheQBjbGF5AG9rYXkAeWRheQB3ZGF5AHRvZGF5AGhvbGlkYXkAZWNwX2dldF95AGFBYkJjQ2REZUZnR2hISWptTW5wclJTdFR1VVZ3V3hYeVl6WiV8fEVjRUNFeEVYRXlFWU9kT2VPSE9JT21PTU9TT3VPVU9WT3dPV095ACVtLyVkLyV5AHh4eABjYW5ub3QgZG8gaGV4MmJ1ZiBmb3IgaGFzaF9jdHgAJXMgOjogY2Fubm90IGFsbG9jYXRlIGhhc2hfY3R4AGZveABib3gAcGt4AHNpeABtYXRyaXgAbWl4AHBhcnNlX3ByZWZpeABpbnZhbGlkIGhhc2ggY29udGV4dCBwcmVmaXgAcGF0dGVybiB0b28gY29tcGxleABwcmludF9jdHhfaGV4AGx1YV9pc19oZXgAYmlnX3RvX2hleABmcm9tX2hleABjYW5ub3QgcHJpbnQgY3R4IGFzIGhleABfX25ld2luZGV4AF9faW5kZXgAaW50ZWdlciBpbmRleABpbnZhbGlkIHVwdmFsdWUgaW5kZXgAbHVhX2JpZ21heAByZWxheABlY3BfZ2V0X3gALSsgICAwWDB4AC0wWCswWCAwWC0weCsweCAweAAweCV4AHRvbW9ycm93AGJvcnJvdwBuYXJyb3cAdGhyb3cAeG9yX2dyb3cAYW5kX2dyb3cAZXllYnJvdwBfX3BvdwBmcDEyX3BvdwBzbm93AGtub3cAc2xvdwBob2xsb3cAZm9sbG93AHllbGxvdwBjcnlwdG9fbG9uZ2ZlbGxvdwB6ZW5jb2RlX2xvbmdmZWxsb3cAc3dhbGxvdwBzaGFsbG93AGdsb3cAaW50ZWdlciBvdmVyZmxvdwBDIHN0YWNrIG92ZXJmbG93AHN0cmluZyBsZW5ndGggb3ZlcmZsb3cAdGFibGUgb3ZlcmZsb3cAdW5zaWduZWQgb3ZlcmZsb3cAemVuY29kZV9yZWZsb3cAYmVsb3cAQ291bGQgbm90IGFsbG9jYXRlIG1lc3NhZ2UgdG8gc2hvdwB3aW5kb3cAc2hhZG93AG1lYWRvdwBlbGJvdwB0ZXJtLncgPCBwLm53AGNyZXcAcmVuZXcAb19uZXcAcmV2aWV3AG5lcGhldwBmZXcAZHJhdwBjbGF3AGJpZ19tb2RpbnYAZnAxMl9pbnYAYmFkIGludgBnZXRlbnYAYmlnX3plbmRpdgBfX2lkaXYAYmlnX21vZGRpdgBmbG9hdF9kaXYAYmlnX2RpdgBfX2RpdgBmYWlsZWQgdG8gYWxsb2NhdGUgc3BhY2UgZm9yIHRoZSBpdgAgZGVwdGg6ICV6dSB3aXJlczogJXp1IGluOiAlenUgb3V0OiV6dSB1c2U6JXp1IG92aDolenUgdDolenUgY3NlOiV6dSBub3RuOiV6dQB6c3RkIGZyb20gJXp1IC0tPiAlenUAYnl0ZXMgbGVuOiAlenUAdGFnZ2VkIG1zbyBpcyB0b28gYmlnOiAlenUAZmxuU3J0dQB5b3UAbWVudQBKU09OIGZvcm1hdCBlcnJvciwgZXhwZWN0ZWQ6ICVjLCBmb3VuZCAlYyBhdCBwb3NpdGlvbiAlbHUASlNPTiBpbnB1dCBzdHJpbmcgc2l6ZTogJWx1AGludmFsaWQgc3RyaW5nIHNpemU6ICVsdQBFcnJvciBpbiBhcmd1bWVudCAjJXUAQUVTLmN0cl9wcm9jZXNzIGFjY2VwdHMgb25seSBrZXlzIG9mIDE2IG9yIDMyIGJ5dGVzLCB0aGlzIGlzICV1AEVDREguYWVhZF9lbmNyeXB0IGFjY2VwdHMgYW4gaXYgb2YgMTIgYnl0ZXMgbWluaW11bSwgdGhpcyBpcyAldQBFQ0RILmFlYWRfZGVjcnlwdCBhY2NlcHRzIGFuIGl2IG9mIDEyIGJ5dGVzIG1pbmltdW0sIHRoaXMgaXMgJXUAQUVTLmN0cl9wcm9jZXNzIGFjY2VwdHMgYW4gaXYgb2YgMTIgYnl0ZXMgbWluaW11bSwgdGhpcyBpcyAldQBQcml2YXRlIGtleSBzaXplIHNob3VsZCBiZSAldSBieXRlLCB0aGlzIGlzICV1AFB1YmxpYyBrZXkgc2l6ZSBzaG91bGQgYmUgJXUgYnl0ZSwgdGhpcyBpcyAldQBFQ0RILmFlYWRfZW5jcnlwdCBhY2NlcHRzIG9ubHkga2V5cyBvZiAxNiwgMjQsIDMyLCB0aGlzIGlzICV1AEVDREguYWVhZF9kZWNyeXB0IGFjY2VwdHMgb25seSBrZXlzIG9mIDE2LCAyNCwgMzIsIHRoaXMgaXMgJXUAbWFwaXQgb24gby0+bGVuICV1AEpTT04gcGFyc2VyIGxldmVsOiAldQBoZXggc3RyaW5nIHNlcXVlbmNlIGxlbmd0aDogJXUAQ2Fubm90IGNyZWF0ZSBvY3RldCwgc2l6ZSB0b28gYmlnOiAldQAlczogaW52YWxpZCBzdHJpbmcgc2l6ZTogJXUAaW52YWxpZCBiaW5hcnkgc2VxdWVuY2Ugc2l6ZTogJXUAU0sgdHlwZTogJXUAU0lHIHR5cGU6ICV1AENBIHR5cGU6ICV1AENvdWxkIG5vdCBhbGxvY2F0ZSBzZWNyZXQga2V5IG9yIGNpcGhlcnRleHQAQ291bGQgbm90IGFsbG9jYXRlIGtlbSBjaXBoZXJ0ZXh0AENvdWxkIG5vdCBjcmVhdGUgY2lwaGVydGV4dABmYWlsZWQgdG8gYWxsb2NhdGUgc3BhY2UgZm9yIHRoZSBtZXNzc2FnZSB0ZXh0AGZhaWxlZCB0byBhbGxvY2F0ZSBzcGFjZSBmb3IgdGhlIG1lc3NhZ2UgdGV4dABuZXh0AHplbmNvZGVfand0AGNyeXB0b19zZF9qd3QAemVuY29kZV9zZF9qd3QAZWNwX291dHB1dABlY3AyX291dHB1dABDb3VsZCBub3QgYWxsb2NhdGUgb3V0cHV0AEN1b2xkIG5vdCBhbGxvY2F0ZSBvdXRwdXQAZmFpbGVkIHRvIGFsbG9jYXRlIHNwYWNlIGZvciB0aGUgb3V0cHV0AENvdWxkIG5vdCByZWFkIGZsb2F0IGlucHV0AE51bGwgaW5wdXQAQ291bGQgbm90IGluc3RhbnRpYXRlIGlucHV0AENvdWxkIG5vdCBhbGxvY2F0ZSBpbnB1dABDb3VsZCBub3QgcmVhZCB0aW1lIGlucHV0AEludmFsaWQgaW5wdXQAc2NvdXQAYWJvdXQAY29jb251dAB3YWxudXQAcGVhbnV0AGFuYWx5c3QAdHJ1c3QAbXVzdABhZGp1c3QAYXVndXN0AGR1c3QAcm9idXN0AGV4aGF1c3QAYnVyc3QAQ29udGV4dCBzaG91bGQgYmUgaW5pdCBmaXJzdABmcm9zdABwb3N0AGJvb3N0AGFsbW9zdABnaG9zdABjb3N0AGNvbnN0AGV4aXN0AHR3aXN0AGFydGlzdABkZW50aXN0AGFzc2lzdAByZXNpc3QAd3Jpc3QAdG91cmlzdABlbmxpc3QAbXVsdGlwbGUgdG8tYmUtY2xvc2VkIHZhcmlhYmxlcyBpbiBsb2NhbCBsaXN0AHdlc3QAaGFydmVzdABpbnZlc3QAdGVzdABhcnJlc3QAZm9yZXN0AGludGVyZXN0AG5lc3QAY2hlc3QAc3VnZ2VzdABiZXN0AGlzZHN0AHZhc3QAdG9hc3QAcm9hc3QAY29hc3QAYmxhc3QAZWFzdABodXJ0AGJpZ19tb2RzcXJ0AHNvcnQAZWNwX3pjYXNoX2V4cG9ydABlY3AyX3pjYXNoX2V4cG9ydABzcG9ydABhaXJwb3J0AGVjcF96Y2FzaF9pbXBvcnQAZWNwMl96Y2FzaF9pbXBvcnQAcmVwb3J0AGRhdGEgc3RyaW5nIHRvbyBzaG9ydABjb21mb3J0AGVmZm9ydABza2lydABkaXJ0AGRpdmVydABhc3NlcnQAaW5zZXJ0AGRlc2VydABhbGVydABjb25jZXJ0AGV4dHJhY3RfY2VydAByZXN0YXJ0AGVsaWRlX2F0X3N0YXJ0AFpLIENvbW1pdCBzdGFydABkZXBhcnQAYXBhcnQASW52YWxpZCBodW1hbiByZWFkYWJsZSBwYXJ0AHNtYXJ0AGhlYXJ0AGNhcnQAYWVzX2VuY3J5cHQAY3RyX2VuY3J5cHQAYWVzZ2NtX2VuY3J5cHQAZWNkaF9hZWFkX2VuY3J5cHQAcnNhX2VuY3J5cHQAYWVzX2RlY3J5cHQAY3RyX2RlY3J5cHQAYWVzZ2NtX2RlY3J5cHQAZWNkaF9hZWFkX2RlY3J5cHQAcnNhX2RlY3J5cHQAZXJ1cHQAdHJhbnNjcmlwdABFcnJvciBsb2FkaW5nIGx1YSBpbml0IHNjcmlwdABhZGFwdABwYXJyb3QAc3BvdABGYWlsZWQgdG8gZGVjb2RlIHJvb3QAc2hvb3QAZm9vdABfX2Jub3QAYml0X25vdABzbG90AHBpbG90AHJpb3QAcm9ib3QAZ3J1bnQAYW1vdW50AGNoYXJjb3VudABhY2NvdW50AGh1bnQAYXVudABmcm9udABTbG50AHplbl9wcmludAB2YXJpbnQAY29kZXBvaW50AENvdWxkIG5vdCBhbGxvY2F0ZSBlY3AgcG9pbnQAQ291bGQgbm90IGNyZWF0ZSBFQ1AgcG9pbnQAQ291bGQgbm90IGFsbG9jYXRlIEVDUCBwb2ludABDb3VsZCBub3QgY3JlYXRlIEVDUDIgcG9pbnQAQ291bGQgbm90IGFsbG9jYXRlIEVDUDIgcG9pbnQAemVuY29kZV9wbGFuZXRtaW50AGhpbnQAZmFpbnQAYmlnX3RvX2ludABXcm9uZyBmaXJzdCB0eXBlIGFyZ3VtZW50LCBleHBlY3RlZCBpbnQAV3JvbmcgdHlwZSBhcmd1bWVudCwgZXhwZWN0ZWQgaW50AHByZXZlbnQAZnJlcXVlbnQAdGVudABwcmVzZW50AGFic2VudABjdXJyZW50AHBhcmVudABwYXltZW50AHB1YmxpYyBrZXkgbm90IGZvdW5kIGluIGFueSBhcmd1bWVudABFbXB0eSBzdHJpbmcgYXMgc2NyaXB0IGFyZ3VtZW50AE5VTEwgc3RyaW5nIGFzIHNjcmlwdCBhcmd1bWVudABNaXNzaW5nIGZpcnN0IG9jdGV0IGFyZ3VtZW50AEludmFsaWQgcHVibGljIGtleSBwYXNzZWQgYXMgYXJndW1lbnQAaW52YWxpYiBiaWcgbnVtYmVyIGluIGFyZ3VtZW50AGludmFsaWQgaGFzaCBpbiBhcmd1bWVudABpbnZhbGlkIEVDUCBpbiBhcmd1bWVudABpbnZhbGlkIGZwMTIgaW4gYXJndW1lbnQAQ291bGQgbm90IHJlYWQgYmlnIGFyZ3VtZW50AEludmFsaWQgM3JkIGFyZ3VtZW50ACVzIDo6IGludmFsaWQgYXJndW1lbnQAZG9jdW1lbnQAZ2FybWVudABtb21lbnQAY29tbWVudABzZWdtZW50AENvdWxkIG5vdCBhbGxvY2F0ZSBiaWcgZWxlbWVudABjZW1lbnQAc2lsZW50AHRhbGVudABwYXRpZW50AG9yaWVudABjbGllbnQAYW5jaWVudABhZ2VudABzdHVkZW50AGFjY2lkZW50AGlubm9jZW50AHdhbnQAY29uc3RhbnQAcGVhc2FudABncmFudAB2aWJyYW50AHRlbmFudABnaWFudABlbGVwaGFudABlbGVnYW50AGluZmFudAB2YWNhbnQAbG9nZm10AGNhbm5vdCBhbGxvY2F0ZSBoYXNoX3Jlc3VsdABhZHVsdAB2YXVsdABhc3NhdWx0AGZhdWx0AGd1aWx0AHRpbHQAbWVsdABiZWx0AENvdWxkIG5vdCBhbGxvY2F0ZSBzYWx0AGZsb2F0X2x0AGJpZ19sdAB0aW1lX2x0AF9fbHQAZXhpdAB0b19zZWd3aXQAZnJvbV9zZWd3aXQAbGF3c3VpdABmcnVpdABxdWl0AGdlbl9jaXJjdWl0AENhbm5vdCBnZW5lcmF0ZSBaSyBjaXJjdWl0AGRlcG9zaXQAdmlzaXQAc3Bpcml0AGdyaXQAbWVyaXQAaW5oZXJpdABlY3BfbWFwaXQAZWNwMl9tYXBpdAB1bml0AHplbl9pbml0AHplbnJvb21faGFzaF9pbml0AHBlcm1pdABvbWl0AHZlcmlmaWVyOiByZWN2IGNvbW1pdABzZXRjc3RhY2tsaW1pdABhZG1pdABzdWJtaXQAc3BsaXQAa2l0AGhpZ2gtYml0IHNldCBvbiBpbnZhbGlkIGRpZ2l0AGludmFsaWQgYmFzZTU4IGRpZ2l0AHByb2ZpdABiZW5lZml0AGF1ZGl0AGNyZWRpdABvcmJpdABleGhpYml0AHJhYmJpdABoYWJpdABmdXp6X2JpdAB3YWl0AHRob3VnaHQAY2F1Z2h0AHNpZ2h0AGJyaWdodABzaGlmdF9yaWdodAB0b25pZ2h0AG1pZG5pZ2h0AHNsaWdodABmbGlnaHQAaGVpZ2h0AHNvZnQAc3dpZnQAZHJpZnQAbGlmdABmdXp6X2JpdF9jaXJjdWxhcl9zaGlmdABmdXp6X2J5dGVfY2lyY3VsYXJfc2hpZnQAZ2lmdABzaGlmdF9sZWZ0AGRyYWZ0AGNyYWZ0AHNoYWZ0AHdldAB2ZWx2ZXQAbmV3b2N0ZXQAZmlsbG9jdGV0AG5ld19lbXB0eV9vY3RldABlY3Bfb2N0ZXQAZmxvYXRfdG9fb2N0ZXQAaGFzaF90b19vY3RldABsdWFiaWdfdG9fb2N0ZXQAdGltZV90b19vY3RldABmcDEyX3RvX29jdGV0AGZwMTJfZnJvbV9vY3RldAB6ZW5yb29tX29jdGV0AGJpZ190b19maXhlZF9vY3RldABlY3AyX29jdGV0AHplbnJvb20ub2N0ZXQAYXJyYXkgY2Fubm90IGVuY29kZSBhbiBlbXB0eSBvY3RldABiYXNlNTggY2Fubm90IGVuY29kZSBhbiBlbXB0eSBvY3RldAB1cmw2NCBjYW5ub3QgZW5jb2RlIGFuIGVtcHR5IG9jdGV0AGJhc2U2NCBjYW5ub3QgZW5jb2RlIGFuIGVtcHR5IG9jdGV0AENhbm5vdCBjb3B5IG9jdGV0AGV4cGVjdGVkIDE2IGJ5dGVzIG9jdGV0AEludmFsaWQgQklHIG51bWJlciwgY2Fubm90IGNvbnZlcnQgdG8gb2N0ZXQAQ2Fubm90IGNyZWF0ZSBhIHplcm8gbGVuZ3RoIG9jdGV0AENhbm5vdCBwYXN0ZSBvY3RldABDb3VsZCBub3QgY3JlYXRlIG9jdGV0AENvdWxkIG5vdCBhbGxvY2F0ZSBvY3RldAByYXdzZXQAYXNzZXQAdXBzZXQAc3Vuc2V0AG9mZnNldAByZWdyZXQAQ291bGQgbm90IGFsbG9jYXRlIGtlbSBzZWNyZXQAZXJyb3IgaW4gd2hpbGUgZGVjaXBoZXJpbmcgdGhlIHNoYXJlZCBzZWNyZXQAZXJyb3IgaW4gdGhlIGNyZWF0aW9uIG9mIHRoZSBzaGFyZWQgc2VjcmV0AGNhcnBldAB0cnVtcGV0AHBvZXQAbWFnbmV0AHBsYW5ldABoZWxtZXQAYnVsbGV0AGhkd2FsbGV0AHRvaWxldABiYXNrZXQAbWFya2V0AGJsYW5rZXQAcm9ja2V0AHRpY2tldABjcmlja2V0AGJyYWNrZXQAamFja2V0AGRpZXQAcmF3Z2V0AGZvcmdldAB0YXJnZXQAYnVkZ2V0AGdhZGdldABzd2VldABzdHJlZXQAZWNkaF9kc2FfdmVyaWZ5X2RldABlY2RoX2RzYV9zaWduX2RldAB3cm9uZyBkb3QgcHJvZHVjdABjb25kdWN0AGluZmxpY3QAcHJlZGljdABhZGRpY3QAcHJvdGVjdABkZXRlY3QAaW5zZWN0AFNyYyBzaXplIGlzIGluY29ycmVjdABkaXJlY3QAZXhwZWN0AHN1c3BlY3QAaW5zcGVjdABhc3BlY3QAY29ubmVjdABjb2xsZWN0AG5lZ2xlY3QAcmVmbGVjdABzZWxlY3QAcHJvamVjdABpbmplY3QAcmVqZWN0AGV4dHJhY3Rfc3ViamVjdABvYmplY3QAcGVyZmVjdABleGFjdABpbnRhY3QAYXR0cmFjdABhYnN0cmFjdABpbXBhY3QAZW5hY3QAYXJ0ZWZhY3QAemVuX2FjdABidABuZXdmbG9hdABpc19mbG9hdAB6ZW5yb29tLmZsb2F0AENvdWxkIG5vdCByZWFkIGZsb2F0AGdvYXQAYm9hdABJbnZhbGlkIGlucHV0IGZvcm1hdABDYW5ub3QgYmUgZW5jb2RlZCB0byBzZWd3aXQgZm9ybWF0AHZhcmlhYmxlLWxlbmd0aCBmb3JtYXQAJXMgOjogd29yZHMgY2Fubm90IGJlIGVuY29kZWQgd2l0aCBiaXAzOSBmb3JtYXQAZmxhdABuYW1ld2hhdAB0aGF0AGNoYXQAZmF0AHNlYXQAcmV0cmVhdABncmVhdABmaWxscmVwZWF0AG1lYXQAd2hlYXQAYmlnX2NvbmNhdABfX2NvbmNhdABvY3RldCBvciBzdHJpbmcgZXhwZWN0ZWQgaW4gY29uY2F0AHplbmNvZGVfZHAzdABhbHdheXMAemVuY29kZV9qd3MAbmV3cwBjYWN0dXMAc3RhdHVzAGNlbnN1cwB2aXJ1cwBmYW1vdXMAamVhbG91cwBvYnZpb3VzAGN1cmlvdXMAdmFyaW91cwB2aWNpb3VzAGJvbnVzAGRpdmlzaW9uIG5vdCBzdXBwb3J0ZWQgd2l0aCBkb3VibGUgYmlnIG1vZHVsdXMAZ2VuaXVzAGZvY3VzAGJ1cwBwcml2YXRlX2lucHV0IGNhbiBvbmx5IGJlIGNhbGxlZCBvbmNlIGFmdGVyIHNldHRpbmcgcHVibGljIGlucHV0cwBpbnZhbGlkIHF1YWRyYXRpYyBjb25zdHJhaW50cwBFQ1Agbm90IGZvdW5kIGFtb25nIG11bHRpcGxpY2F0aW9uIGFyZ3VtZW50cwBCSUcgbm90IGZvdW5kIGFtb25nIG11bHRpcGxpY2F0aW9uIGFyZ3VtZW50cwB3cm9uZyBudW1iZXIgb2YgYXJndW1lbnRzAGRvY3VtZW50cwBjb25zdGFudHMAdG9vIG1hbnkgcmVzdWx0cwBJbnZhbGlkIGxlbmd0aCBvZiBtYXhpdGVyLCBtdXN0IGJlIGxlc3MgdGhhbiAldSBkaWdpdHMASW52YWxpZCBsZW5ndGggb2YgbWF4bWVtLCBtdXN0IGJlIGxlc3MgdGhhbiAldSBkaWdpdHMAYmlnX2JpdHMAcm5rID09IGtTdWJGaWVsZEJpdHMAbCA8PSBrU3ViRmllbGRCaXRzAHN0YXRzAGNyeXB0b19wdnNzAHplbmNvZGVfcHZzcwB0b3NzAGFjcm9zcwBib3NzAGRpc21pc3MAa2lzcwBndWVzcwBhY3RyZXNzAGV4cHJlc3MAY29uZ3Jlc3MAdG9fc2Vnd2l0X2FkZHJlc3MAZnJvbV9zZWd3aXRfYWRkcmVzcwBJbnZhbGlkIHNpemUgZm9yIHNlZ3dpdCBhZGRyZXNzACVzIDo6IG5vdCBiZWNoMzIgYWRkcmVzcwB3aXRuZXNzAGZpdG5lc3MAaWxsbmVzcwBidXNpbmVzcwBzYWRuZXNzAHVzZWxlc3MAZW5kbGVzcwBibGVzcwBnb2RkZXNzAGV4Y2VzcwBoYXNoX3Byb2Nlc3MAc3VjY2VzcwBTdWNjZXNzAGFjY2VzcwBncmFzcwBicmFzcwBwYXNzAG1hc3MAZ2xhc3MAc2Npc3NvcnMAc3RhaXJzAGlwYWlycwBfX3BhaXJzAGZ1bmN0aW9uIG9yIGV4cHJlc3Npb24gbmVlZHMgdG9vIG1hbnkgcmVnaXN0ZXJzAFVuc3VwcG9ydGVkIGNvbWJpbmF0aW9uIG9mIHBhcmFtZXRlcnMAYmFzZTU4IHN0cmluZyBjb250YWlucyBpbnZhbGlkIGNoYXJhY3RlcnMAYmFzZTQ1IHN0cmluZyBjb250YWlucyBpbnZhbGlkIGNoYXJhY3RlcnMAdXJsNjQgc3RyaW5nIGNvbnRhaW5zIGludmFsaWQgY2hhcmFjdGVycwBiYXNlNjQgc3RyaW5nIGNvbnRhaW5zIGludmFsaWQgY2hhcmFjdGVycwBzcGVjaWZpZXIgJyUlcScgY2Fubm90IGhhdmUgbW9kaWZpZXJzAEJJRy5uZXcgbnVtYmVyIGlucHV0IHN1cHBvcnQgb25seSAzMiBiaXQgaW50ZWdlcnMsIHVzZSBzdHJpbmdzIGZvciBsYXJnZXIgbnVtYmVycwBtb2RkaXYgbm90IHN1cHBvcnRlZCBvbiBkb3VibGUgYmlnIG51bWJlcnMAbW9kc3FydCBub3Qgc3VwcG9ydGVkIG9uIGRvdWJsZSBiaWcgbnVtYmVycwBtb2RzcXIgbm90IHN1cHBvcnRlZCBvbiBkb3VibGUgYmlnIG51bWJlcnMAbW9kbXVsIG5vdCBzdXBwb3J0ZWQgb24gZG91YmxlIGJpZyBudW1iZXJzAGphY29iaSBub3Qgc3VwcG9ydGVkIG9uIGRvdWJsZSBiaWcgbnVtYmVycwBtb2RuZWcgbm90IHN1cHBvcnRlZCBvbiBkb3VibGUgYmlnIG51bWJlcnMAbW9kdWxvIG9wZXJhdGlvbiBvbmx5IGF2YWlsYWJsZSB3aXRoIHBvc2l0aXZlIG51bWJlcnMAY2Fubm90IG11bHRpcGx5IGRvdWJsZSBCSUcgbnVtYmVycwBudXBzAGxhYmVscy9nb3RvcwBzdHJpbmcgY29udGFpbnMgemVyb3MAemVuY29kZV9zY2VuYXJpb3MAYWNvcwBjaGFvcwAtSXNyYyAtSWxpYi9sdWE1NC9zcmMgLUlsaWIgLUkvdXNyL2xvY2FsL2luY2x1ZGUgLUlsaWIvbWlsYWdyby1jcnlwdG8tYy9idWlsZC9pbmNsdWRlIC1JbGliL21pbGFncm8tY3J5cHRvLWMvaW5jbHVkZSAtSWxpYi9lZDI1NTE5LWRvbm5hIC1XYWxsIC1XZXh0cmEgLURBUkNIX1dBU00gLUQnQVJDSD1XQVNNJyAtTzIgLXNTVFJJQ1QgLWZsdG8gLWZuby1ydHRpIC1mbm8tZXhjZXB0aW9ucwB0b28gbWFueSBuZXN0ZWQgZnVuY3Rpb25zAGl0ZXJhdGlvbnMAZXh0cmFjdF9leHRlbnNpb25zAGxlbnMAZG5zAGplYW5zAG5wYXJhbXMAYXhpcwBkZWJyaXMAdGVubmlzAHRoaXMAQ2Fubm90IG1lYXN1cmUgaGFtbWluZyBkaXN0YW5jZSBvZiBvY3RldHMgb2YgZGlmZmVyZW50IGxlbmd0aHMAZWNwX3JocwBsb2d3IDw9IGtNYXhCaW5kaW5ncwBDSVJDVUlULT5sb2d2IDw9IGtNYXhCaW5kaW5ncwByb3VuZCA8PSBrTWF4QmluZGluZ3MAQ291bGQgbm90IGNyZWF0ZSBiaWdzAHRvbyBtYW55IHVwdmFsdWVzAGF0dGVtcHQgdG8gY29tcGFyZSB0d28gJXMgdmFsdWVzAG1vZGJ5dGVzAGJpZ19ieXRlcwBjaXJjdWl0IGJ5dGVzIGNvbnRhaW5zIGV4dHJhIGRhdGE6ICV6dSBieXRlcwBDcmVhdGluZyBhIHplcm8gZmlsbGVkIG9jdGV0IG9mICV1IGJ5dGVzACVzOiBvY3RldCBsZW5ndGggJXUgaW5zdGVhZCBvZiAldSBieXRlcwBhcmd1bWVudCAldSBvY3RldCB0b28gbG9uZzogJXUgYnl0ZXMAaGV4IHNlcXVlbmNlIHRvbyBsb25nOiAldSBieXRlcwBOdW1iZXIgY29udmVyc2lvbiBiaWdnZXIgdGhhbiAzMmJpdCwgQklHIHRydW5jYXRlZCB0byA0IGJ5dGVzAGJhc2U1OCBjYW5ub3QgZW5jb2RlIG9jdGV0cyBzbWFsbGVyIHRoYW4gMyBieXRlcwBHZW5lcmF0aW5nIFpLIGNpcmN1aXQgdiVsdSB3aXRoICVsdSBhdHRyaWJ1dGVzAGV4dHJhY3RfZGF0ZXMAdG9vIG1hbnkgY2FwdHVyZXMAZXhwaXJlcwBhY3RpdmVsaW5lcwBjaHVuayBoYXMgdG9vIG1hbnkgbGluZXMAQ2Fubm90IGNyZWF0ZSBEaWN0aW9uYXJ5IGZyb20gcHJvdmlkZWQgc2FtcGxlcwBucm93ID09IGlxICsgMyAqIG5xdHJpcGxlcwBsb2NhbCB2YXJpYWJsZXMAc2VyaWVzAG9wY29kZXMAbmFtZVNwYWNlcwBhZXMARXhhbXBsZSBpbmRleCBvdXQgb2YgYm91bmRzAGZpbmFsIHBvc2l0aW9uIG91dCBvZiBib3VuZHMAaW5pdGlhbCBwb3NpdGlvbiBvdXQgb2YgYm91bmRzAGx5cmljcwBldGhpY3MAY3J5cHRvX2JicwB6ZW5jb2RlX2JicwBhYnMAY2FudmFzAGdhcwBDb3VsZCBub3QgY3JlYXRlIEJJR3MAQ291bGQgbm90IGNyZWF0ZSBzaWduYXV0cmUucwBDb3VsZCBub3QgYWxsb2NhdGUgc2lnbmF1dHJlLnMAQ291bGQgbm90IGZpbmQgYXR0cmlidXRlICUuKnMAYXR0ZW1wdCB0byAlcyBhICVzIHZhbHVlJXMAQCVzAD4lcwBoYXNoIGJ5dGVzOiV6dSBpZDolcwBzaWcgYnl0ZXM6ICV6dSBpZDolcwAlcyBleHBlY3RlZCwgZ290ICVzAEVDUCBjdXJ2ZSBpcyAlcwAlcyAlcwBDb3VsZCBub3QgcGFyc2UgZmxvYXQgbnVtYmVyICVzACVzOiBzdHJpbmcgaXMgbm90IGEgbnVtYmVyICVzACVzIG5lYXIgJXMAQ291bGQgbm90IHJlYWQgdW5peCB0aW1lc3RhbXAgJXMAV3Jvbmcgc2l6ZSB0aW1lc3RhbXAgJXMAdnYgYmVnaW4gJXMARXJyb3IgaW4gJXMAdG9vIG1hbnkgJXMgKGxpbWl0IGlzICVkKSBpbiAlcwBhdHRlbXB0IHRvIGNvbXBhcmUgJXMgd2l0aCAlcwBuZXcgaGFzaCB0eXBlICVzAF5eIGVuZCAlcwBsb2FkZWQgJXMAUEFOSUMgJXMAc2V0ZW52OiBlbXB0eSB2YWx1ZSBmb3Iga2V5OiAlcwBJbnZhbGlkIGh1bWFuIHJlYWRhYmxlIHBhcnQ6ICVzAENvbXBpbGVkIGNpcmN1aXQ6ICVzAGRlY2xhcmluZyBsb2cgZm9ybWF0OiAlcwBjYW5ub3QgJXMgJXM6ICVzAGZhdGFsICVzOiAlcwBNRE9DIHByb3ZlciBlcnJvcjogJXMATURPQyB2ZXJpZmllciBlcnJvcjogJXMASGFzaCBhbGdvcml0aG0gbm90IGtub3duOiAlcwBSZWxlYXNlIHZlcnNpb246ICVzAEJ1aWxkIGNvbW1pdCBoYXNoOiAlcwBCdWlsZCBicmFuY2g6ICVzAEJ1aWxkIGFyY2hpdGVjdHVyZTogJXMAQ2Fubm90IGNyZWF0ZSBvY3RldCwgbWFsbG9jIGZhaWx1cmU6ICVzACVzIDo6IGludmFsaWQgaGFzaCB0eXBlOiAlcwB2ZXJpZnkgZG9uZTogJXMAcmVxdWlyZWQgZXh0ZW5zaW9uIG5vdCBmb3VuZDogJXMAemxpYi5VbmNvbXByZXNzQXRNb3N0IGZhaWxlZDogJXMAJXM6JWQ6ICVzAENhbm5vdCBjcmVhdGUgb2N0ZXQgdmFsdWUsIG1hbGxvYzogJXMAQnVpbGQgQ0ZMQUdTOiAlcwAlcyA6OiAlcwAlczogJXMKICAgICVzAGVjcDJfZ2V0X3pyAGVjcDJfZ2V0X3lyAGVjcDJfZ2V0X3hyAGhvdXIAYmx1cgBhbWF0ZXVyAG9jY3VyAGRpbm9zYXVyAHRvX3N0cgBmcm9tX3N0cgBiaWdfc2hpZnRyAHplbmNvZGVfc2Nobm9ycgB6ZW5fcHJpbnRlcnIAYmlnX21vZHNxcgBiaWdfc3FyAGZwMTJfc3FyAHJhem9yAF9fYnhvcgBmdXp6X2J5dGVfeG9yAGZsYXZvcgBVbmtub3duIGZyYW1lIGRlc2NyaXB0b3IAbW90b3IAbW9uaXRvcgBkb2N0b3IAZWNkaF9jb2ZhY3RvcgBlbGV2YXRvcgBmb3IgaXRlcmF0b3IAZWNwX2dlbmVyYXRvcgBlY3AyX2dlbmVyYXRvcgBFcnJvciBhbGxvY2F0aW5nIG5ldyByYW5kb20gbnVtYmVyIGdlbmVyYXRvcgBzcG9uc29yAGhvcnJvcgBtaXJyb3IAc3ludGF4IGVycm9yAFplbmNvZGUgaW5pdCBlcnJvcgBKU09OIHVua25vd24gcGFyc2VyIGVycm9yAFplbmNvZGUgcGFyc2VyIGVycm9yAFplbmNvZGUgcGFyc2UgZXJyb3IAWmVuY29kZSBydW50aW1lIGVycm9yAHN5c3RlbSBtYWxsb2MgZXJyb3IATUxLRU0gZXJyb3IAdmFwb3IAZmxvb3IAb3V0ZG9vcgBpbmRvb3IAZG9ub3IAbWlub3IAaHVtb3IAYXJtb3IAY29sb3IAYmFjaGVsb3IAbWFqb3IAd2FycmlvcgBqdW5pb3IAc2VuaW9yAGF1dGhvcgBhbmNob3IAZm9yAG9kb3IAdmVuZG9yAGhhcmJvcgBsYWJvcgBfX2JvcgBjcnlwdG9fZmlhdF9zaGFtaXIAZGlyAHJzYV9rZXlwYWlyAG1sZHNhNDRfa2V5cGFpcgBtbF9kc2FfNDRfa2V5cGFpcgBkZXNwYWlyAHJlcGFpcgBjaGFpcgB1bmZhaXIAYWZmYWlyAF9fc2hyAGJ1eWVyAGxheWVyAGFuc3dlcgB0b3dlcgBlbXBvd2VyAGJpZ19tb2Rwb3dlcgBmbG93ZXIAaG92ZXIAZGlzY292ZXIAdW5jb3ZlcgBzZW12ZXIAc2lsdmVyAHJpdmVyAGRlbGl2ZXIAc2hpdmVyAG5ldmVyAGNsZXZlcgBmZXZlcgBleHRyYWN0X2lzc3VlcgBvdXRlcgBidXR0ZXIAYml0dGVyAGxldHRlcgBiZXR0ZXIAbWF0dGVyAHNjYXR0ZXIAb3lzdGVyAGNsdXN0ZXIAZm9zdGVyAG1vbnN0ZXIAaGFtc3RlcgBzaXN0ZXIAbG9ic3RlcgBtYXN0ZXIAcXVhcnRlcgBjaGFwdGVyAHdpbnRlcgBlbnRlcgBmaWx0ZXIAYWx0ZXIAbWF4aXRlcgBpbnZhbGlkIGxvbmcgc3RyaW5nIGRlbGltaXRlcgBkYXVnaHRlcgBVbnN1cHBvcnRlZCBmcmFtZSBwYXJhbWV0ZXIAVW5zdXBwb3J0ZWQgcGFyYW1ldGVyAHdhdGVyAGNyYXRlcgBsYXRlcgBzdXBlcgBwcm9zcGVyAHdoaXNwZXIAdXBwZXIAY29wcGVyAHBlcHBlcgBwYXBlcgBvd25lcgB3aW5uZXIAZGlubmVyAGJhbm5lcgBzdW1tZXIAaGFtbWVyAG1pbGxlcgB0b2RkbGVyAGJ1bmtlcgBlbGVtZW50SWRlbnRpZmllcgBzb2xkaWVyAGJyb3RoZXIAYW5vdGhlcgBtb3RoZXIAcGFudGhlcgBuZWl0aGVyAHRvZ2V0aGVyAHJhdGhlcgBnYXRoZXIAZmF0aGVyAHdlYXRoZXIAY2lwaGVyAGJ1cmdlcgBnaW5nZXIAZmluZ2VyAGRhbmdlcgB0aWdlcgB0cmlnZ2VyAG1heGludGVnZXIAYmlnX2lzaW50ZWdlcgB0b2ludGVnZXIAbWluaW50ZWdlcgBpc19pbnRlZ2VyAEJJRyB0b28gYmlnIGZvciBjb252ZXJzaW9uIHRvIGludGVnZXIAb2JqZWN0IGxlbmd0aCBpcyBub3QgYW4gaW50ZWdlcgBmaWVsZCAnJXMnIGlzIG5vdCBhbiBpbnRlZ2VyAGx1YV9JbnRlZ2VyACVkLWJ5dGUgaW50ZWdlciBkb2VzIG5vdCBmaXQgaW50byBMdWEgSW50ZWdlcgBlYWdlcgBudHJhbnNmZXIAZnRyYW5zZmVyAHN1ZmZlcgBObyBzcGFjZSBsZWZ0IGluIG91dHB1dCBidWZmZXIATm8gc3BhY2UgbGVmdCBpbiBlcnJvciBidWZmZXIAY2Fubm90IGRvIGhleDJidWYgZm9yIGJ1ZmZlcgBPcGVyYXRpb24gb24gTlVMTCBkZXN0aW5hdGlvbiBidWZmZXIAb2ZmZXIAZGlmZmVyAHByZWZlcgBwaW9uZWVyAGRlZXIAcG93ZGVyAGRpc29yZGVyAGJvcmRlcgBlY3Bfb3JkZXIAZWNkaF9vcmRlcgB0aHVuZGVyAHdvbmRlcgByZW5kZXIAc2xlbmRlcgBzaG91bGRlcgBlbGRlcgBjb25zaWRlcgBzcGlkZXIAbGFkZGVyAGNyeXB0b19sb2FkZXIAbGVhZGVyAEludmFsaWQgb2N0ZXQgaGVhZGVyAENvdWxkIG5vdCBhbGxvY2F0ZSBoZWFkZXIAZmFpbGVkIHRvIGFsbG9jYXRlIHNwYWNlIGZvciB0aGUgaGVhZGVyAHNvY2NlcgBvY3RvYmVyAHRvbnVtYmVyAGZyb21fbnVtYmVyAENvdWxkIG5vdCByZWFkIGlucHV0IG51bWJlcgBDb3VsZCBub3QgYWxsb2NhdGUgZmxvYXQgbnVtYmVyAENvdWxkIG5vdCBwYXJzZSBmbG9hdCBudW1iZXIAbm8gbmVlZCBmb3IgbW9udGdvbWVyeSByZWR1Y3Rpb246IG5vdCBhIGRvdWJsZSBiaWcgbnVtYmVyAGNhbm5vdCBtYWtlIHNxdWFyZSByb290IG9mIGEgZG91YmxlIGJpZyBudW1iZXIAc2l6ZSBpcyBub3QgYSBwb3NpdGl2ZSBudW1iZXIAQ291bGQgbm90IGFsbG9jYXRlIHRpbWUgbnVtYmVyAG1hbGZvcm1lZCBudW1iZXIAc2hpZnQgaW5wdXQgaXMgbm90IGEgbnVtYmVyAE8uZnJvbV9udW1iZXIgaW5wdXQgaXMgbm90IGEgbnVtYmVyAHNlZ3dpdCB2ZXJzaW9uIGlzIG5vdCBhIG51bWJlcgBPLm5ldyAybmQgYXJnIGlzIG5vdCBhIG51bWJlcgB0aGUgbnVtYmVyIG9mIGJpdHMgdG8gc2hpZnQgaGFzIHRvIGJlIGEgbnVtYmVyAGx1bWJlcgBsdWFfTnVtYmVyAHRpbWJlcgByZW1lbWJlcgBkZWNlbWJlcgBmaWJlcgBydWJiZXIATlVMTCB2YXIAamFndWFyAGd1aXRhcgBsdW5hcgBzZW1pbmFyAHBvcHVsYXIAcmVndWxhcgBzaGlmdF9yaWdodF9jaXJjdWxhcgBzaGlmdF9sZWZ0X2NpcmN1bGFyAHNocl9jaXJjdWxhcgBzaGxfY2lyY3VsYXIAc29sYXIAcG9sYXIAc2ltaWxhcgBqYXIAbGlhcgBybWNoYXIAcmVtb3ZlX2NoYXIAc3VnYXIAY2lnYXIAeWVhcgBzd2VhcgBhcHBlYXIAbmVhcgBudWNsZWFyAHJhZGFyAGNhcgBiYXIAQ291bGQgbm90IGFsbG9jYXRlIHNpZ25hdHVyZS5yAENvdWxkIG5vdCBjcmVhdGUgc2lnbmF1dHJlLnIAQ291bGQgbm90IGFsbG9jYXRlIHNpZ25hdXRyZS5yAHRyaW1xAHAuYmxvY2tfZW5jIC0gcC5kYmxvY2sgPj0gcC5ucmVxAGVudHJvcHlfYnl0ZWZyZXEAZmxvYXRfZXEAZWNwX2VxAGJpZ19lcQB0aW1lX2VxAF9fZXEAZWNwMl9lcQBmcDEyX2VxAGZyZXhwAGxkZXhwAHNldHVwAHN5cnVwAHNvdXAAZ3JvdXAAa2V0Y2h1cABjdXAAemVuY29kZV9odHRwAGNyaXNwAGNyeXB0b19mc3AAemVuY29kZV9mc3AAd2FzcABnYXNwAHplbmNvZGVfcXAAc3RvcABsYXB0b3AAZHJvcABjcm9wAGVjcDJfbWlsbGVybG9vcAAnX19uZXdpbmRleCcgY2hhaW4gdG9vIGxvbmc7IHBvc3NpYmxlIGxvb3AAJ19faW5kZXgnIGNoYWluIHRvbyBsb25nOyBwb3NzaWJsZSBsb29wAGRldmVsb3AAc2hvcABjaG9wAHFzb3J0X29wAGNsdW1wAGp1bXAAZHVtcABzaHJpbXAAc3dhbXAAc3RhbXAAcmFtcABsYW1wAGRhbXAAY2FtcABwdWxwAGhlbHAAZXF1aXAAdGlwAGdvc3NpcAB0cmlwAGRyaXAAZmxpcABjbGlwAHdoaXAAc2hpcABzdGVwAHJlcABzbGVlcABrZWVwAGx1YV9uZXdfZWNwAHplbnJvb21fZWNwAHplbnJvb20uZWNwAHN3YXAAd3JhcAB0cmFwAHNjcmFwAHNvYXAAc25hcABjbGFwAGdhcABjaGVhcABQcAAlczogJXAAbiBpcyBub3QgYSBzcXVhcmUgbW9kdWxvIHAAdHdvAGF1dG8AcHJvdG8AcGhvdG8AZ290bwBpbnRvAG1vc3F1aXRvAHBvdGF0bwB0b21hdG8AYWxzbwBXIHBhcnQgaXMgbm9uemVybwBpc196ZXJvAGF0dGVtcHQgdG8gZGl2aWRlIGJ5IHplcm8AJ2Zvcicgc3RlcCBpcyB6ZXJvAENhbm5vdCBjcmVhdGUgb2N0ZXQsIHNpemUgbGVzcyB0aGFuIHplcm8AaGVybwB6b28AdGF0dG9vAGthbmdhcm9vAGJhbWJvbwBjYXNpbm8AcGlhbm8Adm9sY2FubwBjYW5ub3QgbXVsdGlwbHkgZG91YmxlIEJJRyBudW1iZXJzIHdpdGggRUNQIHBvaW50LCBuZWVkIG1vZHVsbwBjYW5ub3QgbXVsdGlwbHkgRUNQIHBvaW50IHdpdGggZG91YmxlIEJJRyBudW1iZXJzLCBuZWVkIG1vZHVsbwBoZWxsbwBidWZmYWxvAHJhZGlvAGVjaG8AY2FyZ28AbWFuZ28AZ2V0aW5mbwBsdWFfYmlnaW5mbwBzdGVyZW8AdmlkZW8AdW5kbwB0b3JuYWRvAGF2b2NhZG8AdG9iYWNjbwB0b3duAGZyb3duAGJyb3duAHVua25vd24AY2xvd24AZ293bgBzcGF3bgBsYXduAGRhd24Ac3VuAHJ1bgBndW4AZnVuAHJldHVybgBjaHVybgBob3JuAGNvcm4AZ292ZXJuAGNoYXJwYXR0ZXJuAG1pc3NpbmcgJ1snIGFmdGVyICclJWYnIGluIHBhdHRlcm4AemVuX3dhcm4AbGVhcm4AY2FueW9uAGNvdHRvbgBsZXNzb24AcGVyc29uAHplbnJvb21fanNvbgBwcmlzb24Ac2Vhc29uAHJlYXNvbgBpcm9uAHVwb24Ad2VhcG9uAHNvb24Ac3Bvb24AbW9vbgByYWNjb29uAGNhbm5vbgB6ZW5yb29tX2NvbW1vbgBzYWxtb24AbGVtb24AY2lubmFtb24Ac2Fsb24Ac29sdXRpb24AY2F1dGlvbgBxdWVzdGlvbgBwb3J0aW9uAGludmFsaWQgb3B0aW9uAFZpb2xhdGluZyBzbWFsbCB3aXJlLWxhYmVsIGFzc3VtcHRpb24AQ291bGQgbm90IGFsbG9jYXRlIG1lbW9yeSBkdXJpbmcgZGVjcmlwdGlvbgBlbW90aW9uAG1lbnRpb24AdHVpdGlvbgBjcnlwdG9fcGV0aXRpb24AemVuY29kZV9wZXRpdGlvbgBwb3NpdGlvbgBJbnN0cnVjdGlvbgBkb3VibGUgYmlnIG1vZHVsdXMgaW4gbW9udGdvbWVyeSByZWR1Y3Rpb24AYXVjdGlvbgBtYWluIGZ1bmN0aW9uAHVuYWJsZSB0byBkdW1wIGdpdmVuIGZ1bmN0aW9uAGNhbm5vdCB1c2UgJy4uLicgb3V0c2lkZSBhIHZhcmFyZyBmdW5jdGlvbgBmaWN0aW9uAHNlY3Rpb24AYWN0aW9uAEVycm9yIGhhbmRsZXIgZmF1bHQgYXQgaW5pdGFsaXphdGlvbgBVbmtub3duIGVycm9yIGF0IGluaXRhbGl6YXRpb24ATWVtb3J5IGFsbG9jYXRpb24gZXJyb3IgYXQgaW5pdGFsaXphdGlvbgBjYW5ub3Qgc2hyaW5rIGRvdWJsZSBiaWcgdG8gYmlnIGluIHJlLWluaXRpYWxpemF0aW9uAFJ1bnRpbWUgZXJyb3IgYXQgaW5pdGlhbGl6YXRpb24AYW5vbWFsb3VzIHN0YXRlIG9mIGJpZyBudW1iZXIgZGV0ZWN0ZWQgb24gaW5pdGlhbGl6YXRpb24AYW5vbWFsb3VzIHN0YXRlIG9mIGRvdWJsZSBiaWcgbnVtYmVyIGRldGVjdGVkIG9uIGluaXRpYWxpemF0aW9uAG51bWJlciVzIGhhcyBubyBpbnRlZ2VyIHJlcHJlc2VudGF0aW9uAG51bWJlciBoYXMgbm8gaW50ZWdlciByZXByZXNlbnRhdGlvbgBsb2FkaW5nIGx1YSBpbml0aWFsaXNhdGlvbgBSTkcgc2VlZCBmZWQgYnkgZXh0ZXJuYWwgY29uZmlndXJhdGlvbgBuYXRpb24AY3J5cHRvX2xhZ3JhbmdlX2ludGVycG9sYXRpb24AdGltZSByZXN1bHQgY2Fubm90IGJlIHJlcHJlc2VudGVkIGluIHRoaXMgaW5zdGFsbGF0aW9uAEhlYWRlciBvZiBMaXRlcmFscycgYmxvY2sgZG9lc24ndCByZXNwZWN0IGZvcm1hdCBzcGVjaWZpY2F0aW9uAGVjZGhfc2Vzc2lvbgBwMjU2X3Nlc3Npb24ASW52YWxpZCBzZWd3aXQgdmVyc2lvbgBNaXNzaW5nIGFyZ3VtZW50OiBsb25nZmVsbG93IGNpcmN1aXQgdmVyc2lvbgBJbnZhbGlkIFpLIHNwZWNpZmljYXRpb24gdmVyc2lvbgBJbnZhbGlkIFpLIHNwZWMgdmVyc2lvbgBlcm9zaW9uAHplbl9leGVjX2V4dGVuc2lvbgBtYW5zaW9uAHNjb3JwaW9uAGNoYW1waW9uAHJldW5pb24Ab25pb24Ab3BpbmlvbgBtaWxsaW9uAGN1c2hpb24AZmFzaGlvbgByZWdpb24Ad2Fnb24AZHJhZ29uAHBpZ2VvbgBhYmFuZG9uAGljb24AYmFjb24AY2FyYm9uAHJpYmJvbgBwZXJmb3JtIGJpdHdpc2Ugb3BlcmF0aW9uIG9uAHBlcmZvcm0gYXJpdGhtZXRpYyBvbgBhdXR1bW4AY29sdW1uAHR3aW4AbGF0aW4AY291c2luAGFzaW4Ac3BpbgB1cHZhbHVlam9pbgBjcnlwdG9fYml0Y29pbgB6ZW5jb2RlX2JpdGNvaW4AbWluAHZpb2xpbgBza2luAHB1bXBraW4AbmFwa2luAGRvbHBoaW4AbWFyZ2luAGJlZ2luAG11ZmZpbgBjYWJpbgBsdWFfaXNfYmluAHRvX2JpbgBmcm9tX2JpbgBzdXN0YWluAGN1cnRhaW4AY2VydGFpbgBjYXB0YWluAG1vdW50YWluAG9idGFpbgB0cmFpbgBncmFpbgBicmFpbgBkb21haW4AcmVtYWluAGV4cGxhaW4AYmFyZ2FpbgBhZ2FpbgBkZXNpZ24AcXBfc2lnbgBlZF9zaWduAHJzYV9zaWduAGVjZGhfZHNhX3NpZ24AcDI1Nl9zaWduAG1pc3NpbmcgM3JkIGFyZ3VtZW50OiBieXRlIHNpemUgb2Ygb2N0ZXQgdG8gc2lnbgBpbnZhbGlkIHNpemUgemVybyBmb3IgbWF0ZXJpYWwgdG8gc2lnbgBmcm96ZW4AY2l0aXplbgBvdmVuAHplbmNvZGVfZ2l2ZW4Ac2NvcGU9Z2l2ZW4Ac2V2ZW4AcmF2ZW4Aa2l0dGVuAG9mdGVuAHNpcmVuAHJlb3BlbgBmcm9tX3Jhd2xlbgBkYmlnbGVuAHFwX3NpZ25hdHVyZV9sZW4AX19sZW4AdG9rZW4AYnJva2VuAGNoaWNrZW4AYWxpZW4AemVuY29kZV93aGVuAHplbmNvZGVfdGhlbgBraXRjaGVuAG94eWdlbgBrZW1rZXlnZW4Ac2lna2V5Z2VuAG50cnVwX2tleWdlbgBtbGtlbV9rZXlnZW4AcXBfc250cnVwX2tlbV9rZXlnZW4AcXBfa2VtX2tleWdlbgBlY2RoX2tleWdlbgBxcF9zaWduYXR1cmVfa2V5Z2VuAHAyNTZfa2V5Z2VuAGVkX3NlY2dlbgBrZW1wdWJnZW4Ac2lncHViZ2VuAG50cnVwX3B1YmdlbgBtbGtlbV9wdWJnZW4AcXBfc250cnVwX2tlbV9wdWJnZW4AcXBfa2VtX3B1YmdlbgBlY2RoX3B1YmdlbgBxcF9zaWduYXR1cmVfcHViZ2VuAG1sX2RzYV80NF9zaWduYXR1cmVfcHViZ2VuAGVkX3B1YmdlbgByc2FfcHViZ2VuAHAyNTZfcHViZ2VuAG1sZHNhNDRfcHViZ2VuAGNpcmN1aXRfZ2VuAGJldHdlZW4AZ3JlZW4Ac2NyZWVuAGtlZW4AYnVyZGVuAGdhcmRlbgBzdWRkZW4AaGlkZGVuAHZhbgBhdGFuAGV4dHJhY3Rfc2FuAHZldGVyYW4AbG9hbgBuYW4AaHVtYW4Ad29tYW4AbGVzc2VyX3RoYW4Ab3JwaGFuAG9yZ2FuAHNsb2dhbgBmYW4AbWVhbgBib29sZWFuAGNsZWFuAG9jZWFuAGJlYW4Ac2NhbgBwZWxpY2FuAHVyYmFuAGNvbmNhdF9uAGd5bQB2YWN1dW0AcXVhbnR1bQBSZXN0b3JlZCBkYXRhIGRvZXNuJ3QgbWF0Y2ggY2hlY2tzdW0AZmFpbGVkIHRvIGFsbG9jYXRlIHNwYWNlIGZvciB0aGUgY2hlY2tzdW0AZm9ydW0AZHJ1bQBtZW1ibG9ja251bQBtYXhpbXVtAG1pbmltdW0Ac3RhZGl1bQBtdXNldW0AY3J5cHRvX2V0aGVyZXVtAHplbmNvZGVfZXRoZXJldW0AYWxidW0AaW5mb3JtAHVuaWZvcm0AcmVmb3JtAHZhbHVlIGhhcyBubyBsaXRlcmFsIGZvcm0AY29uZmlybQB0ZXJtAHN3YXJtAGFsYXJtAGZhcm0AYm90dG9tAGN1c3RvbQBzeW1wdG9tAGF0b20AYmxvc3NvbQBtdXNocm9vbQBicm9vbQBnbG9vbQBtb20Ad2lzZG9tAG5ld19yYW5kb20AZnV6el9iaXRfcmFuZG9tAGZ1enpfYml0X2NpcmN1bGFyX3NoaWZ0X3JhbmRvbQBmdXp6X2J5dGVfY2lyY3VsYXJfc2hpZnRfcmFuZG9tAGJpZ19yYW5kb20AZnV6el9ieXRlX3JhbmRvbQB6ZW5jb2RlX3JhbmRvbQBraW5nZG9tAF9fdW5tAGZpbG0AcGFsbQBjYWxtAHN3aW0AdHJpbQBzbGltAGNsYWltAHJoeXRobQBzeXN0ZW0AaXRlbQBwb2VtAG1heG1lbQBwcm9ibGVtAHByb2dyYW0AZGlhZ3JhbQBjcmFtAGZvYW0Ac2xhbQB0ZWFtAGRyZWFtAGNyZWFtAG9mX3NjYWxhciBtdXN0IGJlIGxlc3MgdGhhbiBtAGNyYXdsAHNvdWwAc2V0c3RlcG11bABiaWdfemVubXVsAGJpZ19tb2RtdWwAZmxvYXRfbXVsAGVjcF9tdWwAYmlnX211bABfX211bABlY3AyX211bABmcDEyX211bABhd2Z1bAB1c2VmdWwAdXJsAGdpcmwAcGlzdG9sAGNvbnRyb2wAcGF0cm9sAHdvb2wAc3Rvb2wAcG9vbABzY2hvb2wAY29vbABhbGNvaG9sAHVuZXhwZWN0ZWQgc3ltYm9sAHRlcm0uYyA8IG5sAHB1bGwAc2t1bGwAT3BlcmF0aW9uIG1hZGUgbm8gcHJvZ3Jlc3Mgb3ZlciBtdWx0aXBsZSBjYWxscywgZHVlIHRvIG91dHB1dCBidWZmZXIgYmVpbmcgZnVsbABlbnJvbGwAZG9sbAB3aWxsAHN0aWxsAGRyaWxsAHBpbGwAc2tpbGwAaGlsbABmaWxsAHRlbGwAc2VsbABzcGVsbABzaGVsbAB3YWxsAGluc3RhbGwAQXJndW1lbnRzIHRvbyBzbWFsbABEZXN0aW5hdGlvbiBidWZmZXIgaXMgdG9vIHNtYWxsAFNwZWNpZmllZCBtYXhTeW1ib2xWYWx1ZSBpcyB0b28gc21hbGwAUHJvb2YgdG9vIHNtYWxsAGZhbGwAeHBjYWxsAGlzdGFpbGNhbGwAcmVjYWxsAF9fY2FsbAB0YWlsIGNhbGwAYmFsbABjaXZpbABldmlsAHVudGlsAGZvc3NpbABhcHJpbABwdXBpbABzcG9pbABmb2lsAGNvaWwAYm9pbAB0YWJsZSBpbmRleCBpcyBuaWwAdW52ZWlsAGNlaWwAcGVuY2lsAGRldGFpbABzYWlsAHJhaWwAZW1haWwAX19zaGwAamV3ZWwAbm92ZWwAbGV2ZWwAdHJhdmVsAGNydWVsAGZ1ZWwAaG90ZWwAdmVzc2VsAGRpZXNlbAB3ZWFzZWwAc3F1aXJyZWwAYmFycmVsAGdvc3BlbAB0dW5uZWwAcGFuZWwAc3RlZWwAd2hlZWwAZmVlbABtb2RlbABjYW5jZWwAcmViZWwAbGFiZWwAcm95YWwAbG95YWwAb3ZhbABmZXN0aXZhbAByaXZhbABjYW5ub3QgYWxsb2NhdGUgdG1wLnZhbABtdXR1YWwAdmlydHVhbAByaXR1YWwAYWN0dWFsAHVudXN1YWwAdmlzdWFsAGNhc3VhbAByYXdlcXVhbABhbm51YWwAbWFudWFsAGNyeXN0YWwAdG90YWwAaW5jcmVtZW50YWwAdml0YWwAaG9zcGl0YWwAY2FwaXRhbABkaWdpdGFsAG1ldGFsAGZhdGFsAHJ1cmFsAG5ldXRyYWwAbW9yYWwAY29yYWwAZ2VuZXJhbABmZWRlcmFsAGV0ZXJuYWwAZ2VuZXJhdGlvbmFsAG9yaWdpbmFsAHplbnJvb21faGFzaF9maW5hbABjYW5hbABub3JtYWwAbWFtbWFsAGFuaW1hbAB0b19kZWNpbWFsAGZyb21fZGVjaW1hbABjcnlwdG9fZWxnYW1hbABjcnlwdG9fY3JlZGVudGlhbAB6ZW5jb2RlX2NyZWRlbnRpYWwAVmFsaWRpdHkgbm90IGZvdW5kIGluIHg1MDkgY3JlZGVudGlhbABJc3N1ZXIgbm90IGZvdW5kIGluIHg1MDkgY3JlZGVudGlhbABpbml0aWFsAHNwYXRpYWwAdHJpYWwAbWF0ZXJpYWwAZGVuaWFsAGRpYWwAY3J1Y2lhbABzb2NpYWwAc3BlY2lhbABpbGxlZ2FsAHJldmVhbABjZXJlYWwAZGVhbABtZWRhbABmaXNjYWwAdm9jYWwAc2V0bG9jYWwAZ2V0bG9jYWwAcGh5c2ljYWwAdHlwaWNhbABnbG9iYWwAU2wAcXB6cnk5eDhnZjJ0dmR3MHMzam41NGtoY2U2bXVhN2wAemVuY29kZV9qd2sAaGF3awBicmlzawBkZXNrAHRhc2sAbWFzawBhcnR3b3JrAG5ldHdvcmsAZm9yawBjbGVyawBwYXJrAGVtYmFyawBqc29udG9rAHNldGhvb2sAZ2V0aG9vawBleHRlcm5hbCBob29rAGNvb2sAYm9vawBqdW5rAG5vdCBhIGJpbmFyeSBjaHVuawBtYWluIGNodW5rAGNvcnJ1cHRlZCBjaHVuawB0cnVuY2F0ZWQgY2h1bmsAd2luawB4b3Jfc2hyaW5rAGFuZF9zaHJpbmsAZHJpbmsAcGluawBsaW5rAHRhbmsAdGhhbmsAYnVsawBzaWxrAG1pbGsAd2FsawB0YWxrAGNoYWxrAHNlZWsAY3JlZWsAdHJ1Y2sAcGx1Y2sAZHVjawBzdG9jawBzb2NrAGtub2NrAHVubG9jawBmbG9jawBjbG9jawBwLmJsb2NrX2VuYyA+PSBwLmRibG9jawBUaGlzIG1vZGUgY2Fubm90IGdlbmVyYXRlIGFuIHVuY29tcHJlc3NlZCBibG9jawBibG9ja19lbmMgPiBibG9jawBzaG9jawBxdWljawBzdGljawBzaWNrAHRyaWNrAGJyaWNrAGNsaWNrAGtpY2sAd3JlY2sAbmVjawBrZW1jdGNoZWNrAG50cnVwX2N0Y2hlY2sAbWxrZW1fY3RjaGVjawBxcF9zbnRydXBfa2VtX2N0Y2hlY2sAcXBfa2VtX2N0Y2hlY2sAa2Vtc3NjaGVjawBudHJ1cF9zc2NoZWNrAG1sa2VtX3NzY2hlY2sAcXBfc250cnVwX2tlbV9zc2NoZWNrAHFwX2tlbV9zc2NoZWNrAGtlbXB1YmNoZWNrAHNpZ3B1YmNoZWNrAG50cnVwX3B1YmNoZWNrAG1sa2VtX3B1YmNoZWNrAHFwX3NudHJ1cF9rZW1fcHViY2hlY2sAcXBfa2VtX3B1YmNoZWNrAGVjZGhfcHViY2hlY2sAcXBfc2lnbmF0dXJlX3B1YmNoZWNrAHJzYV9zaWduYXR1cmVfcHViY2hlY2sAbWxkc2E0NF9zaWduYXR1cmVfcHViY2hlY2sAcDI1Nl9wdWJjaGVjawBtbGRzYTQ0X3B1YmNoZWNrAHFwX3NpZ25hdHVyZV9jaGVjawByc2Ffc2lnbmF0dXJlX2NoZWNrAG1sZHNhNDRfc2lnbmF0dXJlX2NoZWNrAGF0dGFjawBPY3RldDpzdWJzdHIgY2FsbGVkIG9uIGEgbmVlZGxlIGJpZ2dlciB0aGFuIGhheXN0YWNrAE9jdGV0OmZpbmQgcG9zaXRpb24gKDNyZCBhcmcpIG91dCBvZiBoYXlzdGFjawBub3QgZW5vdWdoIHN0YWNrAHRyYWNrAGNyYWNrAHRvbyBtYW55IHJlc3VsdHMgdG8gdW5wYWNrAHplbnJvb21fbXNncGFjawB6ZW5jb2RlX3BhY2sAc25hY2sAYmxhY2sAdHJhY2ViYWNrAG9hawBzdGVhawBicmVhawBzcGVhawBibGVhawBuID49IGsAZWNwMl9nZXRfemkAZWNwMl9nZXRfeWkAdGF4aQBlY3AyX2dldF94aQBraXdpAHBpAGJyb2Njb2xpAHNraQBjb21wYWN0X2FzY2lpAHNhdG9zaGkAYmlnX2phY29iaQBpbnZhbGlkIG9jdGV0OnN1YigpIHBvc2l0aW9uIHN0YXJ0cyBmcm9tIDEgbm90ICVpAGludmFsaWQgb2N0ZXQ6c3ViKCkgdG8gZW5kIHBvc2l0aW9uICVpIHNtYWxsZXIgdGhhbiBzdGFydCBwb3NpdGlvbiAlaQBpbnZhbGlkIG9jdGV0OnN1YigpIHRvIGVuZCBwb3NpdGlvbiAlaSBvbiBzbWFsbCBvY3RldCBvZiBsZW4gJWkAY2Fubm90IGNob3Agb2N0ZXQgb2Ygc2l6ZSAlaSB0byBoaWdoZXIgbGVuZ3RoICVpAEdldHRpbmcgTURPQyBleGFtcGxlICVpAEludGVybmFsIGVycm9yIGdlbmVyYXRpbmcgY2lyY3VpdDogJWkAT2N0ZXQ6Y29weSBzdGFydGluZyBwb3NpdGlvbiBvdXQgb2YgYm91bmRzOiAlaQBPY3RldDpwYXN0ZSBzdGFydGluZyBwb3NpdGlvbiBvdXQgb2YgYm91bmRzOiAlaQBpbnZhbGlkIG9jdGV0OmNvcHkoKSBsZW5ndGggdG9vIGJpZzogJWkAV3JvbmcgY2lyY3VpdCBzcGVjOiAlaQBteXRoAHRydXRoAHlvdXRoAHNvdXRoAGlzc3VlckF1dGgAZGV2aWNlQXV0aAB3b3J0aABub3J0aABiaXJ0aABlYXJ0aABkZXB0aAB0b290aABzbW9vdGgAY2xvdGgAbW9udGgAd2VhbHRoAGhlYWx0aABmYWl0aAB3cm9uZyBzZWNyZXQga2V5IGxlbmd0aABJbnZhbGlkIHB1YmxpYyBrZXkgbGVuZ3RoAGludmFsaWQgdXVpZCBhcmd1bWVudCBsZW5ndGgAWDUwOSBpc3N1ZXIgcHJvcGVydHkgJXMgaGFzIHplcm8gbGVuZ3RoAHdpZHRoAHBhdGgAemVuY29kZV9tYXRoAGNydXNoAGJydXNoAHB1c2gAc2x1c2gAZmx1c2gAYmx1c2gAaGFyc2gAY29zaAB3aXNoAGZpbmlzaAB2YW5pc2gAZmlzaABkaXNoAGZyZXNoAG1lc2gAd2FzaAB0cmFzaABjcmFzaABmbGFzaABsdWFfbmV3X2hhc2gAemVucm9vbV9oYXNoAHplbmNvZGVfaGFzaAB6ZW5yb29tLmhhc2gASW52YWxpZCBhcmd1bWVudCB0byBFQ1AubWFwaXQoKSwgbm90IGFuIGhhc2gASW52YWxpZCBhcmd1bWVudCB0byBFQ1AyLm1hcGl0KCksIG5vdCBhbiBoYXNoAENvdWxkIG5vdCBjcmVhdGUgaGFzaAAlcyA6OiBjYW5ub3QgYWxsb2NhdGUgaGFzaABkYXNoAHRvX3pjYXNoAGZyb21femNhc2gAJXMgOjogY2Fubm90IGFsbG9jYXRlIHNoAHNpbmgAdGFuaAByb3VnaAB3b3JrU3BhY2UgYnVmZmVyIGlzIG5vdCBsYXJnZSBlbm91Z2gAbGF1Z2gAaGlnaAB6ZW5yb29tX2VjZGgAemVuY29kZV9lY2RoAHN1Y2gAY3JvdWNoAGNvdWNoAG11Y2gAY2x1dGNoAGR1dGNoAHN3aXRjaABwaXRjaABza2V0Y2gAZmV0Y2gAcGF0Y2gARGljdGlvbmFyeSBtaXNtYXRjaABBdHRyaWJ1dGUgY291bnQgbWlzbWF0Y2gAZmxvYXQgZm9ybWF0IG1pc21hdGNoAGludGVnZXIgZm9ybWF0IG1pc21hdGNoAHZlcnNpb24gbWlzbWF0Y2gAJXMgc2l6ZSBtaXNtYXRjaABnbWF0Y2gAc2l6ZSBvZiBpbnB1dCBkb2VzIG5vdCBtYXRjaABjYXRjaAB0b3JjaABtYXJjaABzZWFyY2gAY3J1bmNoAHB1bmNoAGx1bmNoAGluY2gAemVucm9vbV9iZW5jaAByYW5jaABvc3RyaWNoAGVucmljaABjb2FjaABzdG9tYWNoAHRlYWNoAHplbmNvZGVfZm9yZWFjaABiZWFjaADwn4yKIHNmcG9vbCBpbml0OiAldSBibG9ja3MgJXUgQiBlYWNoAHNocnVnAHBsdWcAemVuX2RlYnVnAHplbmNvZGVfZGVidWcAc2lnbmVkX21zZwB2ZXJpZmllZF9tc2cAaXN2YXJhcmcAdGltZV9hcmcAZnAxMl9hcmcAZnJvZwBjbG9nAGNhdGFsb2cAaGVkZ2Vob2cAZm9nAGRvZwB5b3VuZwBzb25nAERlc3RpbmF0aW9uIGJ1ZmZlciBpcyB3cm9uZwBTb3VyY2UgYnVmZmVyIGlzIHdyb25nAHN0cm9uZwBhbW9uZwBzaWduYXR1cmUgYXJndW1lbnQgaXMgJXUgYnl0ZXMgbG9uZwBsZXhpY2FsIGVsZW1lbnQgdG9vIGxvbmcAY29udHJvbCBzdHJ1Y3R1cmUgdG9vIGxvbmcAc3RyaW5nIHNsaWNlIHRvbyBsb25nAGFtYXppbmcAc3dpbmcAc3RpbmcAaW52YWxpZCBvcmRlciBmdW5jdGlvbiBmb3Igc29ydGluZwBzaW5nAHplbmNvZGVfa2V5cmluZwBkdXJpbmcAX190b3N0cmluZwBmbG9hdF90b19zdHJpbmcAdGltZV90b19zdHJpbmcAZnJvbV9zdHJpbmcAYmlnX3RvX2RlY2ltYWxfc3RyaW5nAGJpZ19mcm9tX2RlY2ltYWxfc3RyaW5nAGJpbmFyeSBzdHJpbmcAJXMgOjogSW52YWxpZCBvY3RldCBpbiBoZXggc3RyaW5nAGludmFsaWQgdXNlIG9mICclYycgaW4gcmVwbGFjZW1lbnQgc3RyaW5nAGJhZCBmb3JtYXQgZm9yIGNvbnN0YW50IHN0cmluZwB0YWJsZSBvciBzdHJpbmcAaW5pdGlhbCBwb3NpdGlvbiBvdXQgb2Ygc3RyaW5nAGJhc2U0NSBpbnZhbGlkIHN0cmluZwB1bmZpbmlzaGVkIHN0cmluZwB0aGUgaW5wdXQgaXMgbm90IGEgc3RyaW5nAGVycm9yIG9iamVjdCBpcyBub3QgYSBzdHJpbmcAcmVhZGVyIGZ1bmN0aW9uIG11c3QgcmV0dXJuIGEgc3RyaW5nACdfX3Rvc3RyaW5nJyBtdXN0IHJldHVybiBhIHN0cmluZwBzcHJpbmcAYm9yaW5nAGJyaW5nAGRhcmluZwBtb3JuaW5nAGlzcnVubmluZwBwb3Bjb3VudF9oYW1taW5nAGNlaWxpbmcAZXJyb3IgaW4gZXJyb3IgaGFuZGxpbmcAc2libGluZwBBbiBJL08gZXJyb3Igb2NjdXJyZWQgd2hlbiByZWFkaW5nL3NlZWtpbmcAbm90aGluZwBDb3VsZCBub3QgYWxsb2NhdGUgb2N0ZXQgZm9yIGhhc2hpbmcARnJhbWUgcmVxdWlyZXMgdG9vIG11Y2ggbWVtb3J5IGZvciBkZWNvZGluZwBwdWRkaW5nAHdlZGRpbmcASW52YWxpZCBwYWRkaW5nAGV4dHJhY3RfY2VydF9zaWcAcGlnAG5ld2JpZwB6ZW5yb29tX2JpZwB6ZW5yb29tLmJpZwBhcnJheSB0b28gYmlnAGZ1enpfYnl0ZTogb2N0ZXQgdG9vIGJpZwB0aGUgcmVzdWx0IGlzIHRvbyBiaWcAbWVtb3J5IGFsbG9jYXRpb24gZXJyb3I6IGJsb2NrIHRvbyBiaWcAT3V0cHV0IHNpemUgdG9vIGJpZwBDb3VsZCBub3QgY3JlYXRlIG9jdGV0IGZyb20gYmlnAGZvdW5kIGxlZnRvdmVyIGJ1ZmZlciB3aGlsZSBmcmVlaW5nIGJpZwBpZ25vcmluZyBzdXBlcmZsb3VzIGluaXRpYWxpemF0aW9uIG9mIGJpZwBDb3VsZCBub3QgY3JlYXRlIGJpZwBmb3VuZCBsZWZ0b3ZlciBidWZmZXIgd2hpbGUgZnJlZWluZyBkb3VibGUgYmlnAGlnbm9yaW5nIHN1cGVyZmxvdXMgaW5pdGlhbGl6YXRpb24gb2YgZG91YmxlIGJpZwBDb3VsZCBub3QgcmVhZCBiaWcAZWdnAGJpZ19tb2RuZWcAbGVnAGRlZwBDb3VsZCBub3QgY3JlYXRlIGF1dGhlbnRpY2F0aW9uIHRhZwBQcm92ZXIgRG9uZTogZmxhZwBiYWcAJS43ZwBjYW5ub3QgYWxsb2NhdGUgaGV4X2J1ZgBkd2FyZgBwcm9vZgBnZXQgbGVuZ3RoIG9mAGVjcF9pc2luZgBlY3AyX2lzaW5mAHdvbGYAbXlzZWxmAGhhbGYAZWxzZWlmAHN0dWZmAG9mZgBzaGVyaWZmAHNuaWZmAGNsaWZmAHN0YWZmAGdyaWVmAGJyaWVmAHJlbGllZgBjaGllZgBjaGVmAGJlZWYAbW9kZgBwYmtkZgBsZWFmADB4ZGMxYzFmNTVjZmY0Y2Q1Yzc2Y2Y0MTY5Mjc4ZjcyMTc2NjdmODZlZTgxZDg2NjliNjNmMmUxOWJjMTJhMGM5ZgAweGMyZjZmYTA1NmYyNDIzY2E1N2Y4MjhkZWQxMjY1NmJkYWU4NjNmMjM2NTQ1NjFkNDk0YWU1ZWZhOWZlYjg4M2YAMHgyYzgwYzEwYmY3MGY2M2JkZGNjNDFlYTIwZDc2YTIyZWNiYTJhOTdmYTg4MTFiZjE5ZDU3MjQzM2IxMmMwYzFmACVmAGJyb256ZQBtZW1ibG9ja3NpemUAcGFja3NpemUAQUREIGRvdWJsZXNpemUAb2N0ZXRfc2l6ZQBXcm9uZyBjdHggc2l6ZQBzdHJpbmcgbGVuZ3RoIGRvZXMgbm90IGZpdCBpbiBnaXZlbiBzaXplAHN0cmluZyBsb25nZXIgdGhhbiBnaXZlbiBzaXplAFdyb25nIHByaW1lIHNpemUAV3Jvbmcgc2VlZCBzaXplAHByaXplAHNxdWVlemUAYnJlZXplAG1hemUAZ2F6ZQBleWUAbWFwX3RvX2N1cnZlAEludmFsaWQgaW5wdXQgb2N0ZXQ6IG5vdCBhIHBvaW50IG9uIHRoZSBjdXJ2ZQBvYnNlcnZlAG5lcnZlAHN0b3ZlAGFwcHJvdmUAaW1wcm92ZQBtZG9jX3Byb3ZlAG11c3QgcnVuIGNvbW1pdCBiZWZvcmUgcHJvdmUAcmVtb3ZlAHRvbyBtYW55IGVsZW1lbnRzIHRvIG1vdmUAZ2xvdmUAc2hvdmUAZG92ZQBhYm92ZQBpbnZvbHZlAGV2b2x2ZQBzb2x2ZQB0d2VsdmUAdmFsdmUAYmlnX3plbnBvc2l0aXZlAGVjcF9uZWdhdGl2ZQBlY3AyX25lZ2F0aXZlAGFycml2ZQB0aHJpdmUAZGVyaXZlAGRyaXZlAG9saXZlAGdpdmUAcmVjZWl2ZQBuYWl2ZQBiZWxpZXZlAGFjaGlldmUAd2F2ZQBzYXZlAGJyYXZlAHBhdmUAYmVoYXZlAGxlYXZlAGNhdmUAdGlzc3VlAHRydWUAYW50aXF1ZQBybHRlcm1zIG5vdCB1bmlxdWUAcmVuYW1lZF9hdF9kIG5vdCB1bmlxdWUAdmVudWUAZ2x1ZQBibHVlAHNldHVzZXJ2YWx1ZQBnZXR1c2VydmFsdWUAc2V0dXB2YWx1ZQBnZXR1cHZhbHVlAGRldGVjdF90aW1lX3ZhbHVlAG5vIHZhbHVlAGluaXRpYWwgdmFsdWUAdmFyaWFibGUgJyVzJyBnb3QgYSBub24tY2xvc2FibGUgdmFsdWUAZWxlbWVudFZhbHVlAGFyZ3VlAHRvbmd1ZQBmYXRpZ3VlAHZhZ3VlAHJlc2N1ZQBmdXp6X2J5dGUAcmFuZG9tX2J5dGUAaW5pdGlhbCBwb3NpdGlvbiBpcyBhIGNvbnRpbnVhdGlvbiBieXRlAHJvdXRlAG1pbnV0ZQBzYWx1dGUAZXhlY3V0ZQB3YXN0ZQB0YXN0ZQBtZW1wYXN0ZQBjb3lvdGUAZGV2b3RlAHF1b3RlAG5vdGUAcHJvbW90ZQBmbG9hdF9sdGUAYmlnX2x0ZQB0aW1lX2x0ZQBfX2x0ZQBpbnZpdGUAYmlnX3plbm9wcG9zaXRlAGZsb2F0X29wcG9zaXRlAHRpbWVfb3Bwb3NpdGUAemVuX3dyaXRlAGZhdm9yaXRlAGVsaXRlAGtpdGUAZXhjaXRlAGF0aGxldGUAcHJpdmF0ZQBzaXR1YXRlAGVzdGF0ZQByb3RhdGUAaW1pdGF0ZQBkZWNvcmF0ZQBkb25hdGUAQ291bGQgbm90IGNyZWF0ZSB5IGNvb3JkaW5hdGUAQ291bGQgbm90IGNyZWF0ZSB4IGNvb3JkaW5hdGUAY29uY2F0ZW5hdGUAaW5tYXRlAHBsYXRlAGlzb2xhdGUAY29sbGF0ZQBza2F0ZQBnYXRlAGNyZWF0ZQB6ZW5yb29tX2hhc2hfdXBkYXRlAG1hbmRhdGUAZWNwX3ZhbGlkYXRlAGVkdWNhdGUAaW5kaWNhdGUAZGViYXRlAG1vdXNlAGJsb3VzZQByZWZ1c2UAZXhjdXNlAGFjY3VzZQBhYnVzZQBzZXRwYXVzZQBiZWNhdXNlAHB1cnNlAGNvdXJzZQBudXJzZQBob3JzZQBlbmRvcnNlAHVuaXZlcnNlAHJldmVyc2UAemVuX2NvbmZfcGFyc2UAZ2xpbXBzZQByb3NlAGV4cG9zZQBwdXJwb3NlAG9wcG9zZQBpbXBvc2UAY2hvb3NlAGdvb3NlAG5vc2UAX19jbG9zZQBjcnlwdG9fam9zZQBkb3NlAHZlcmJvc2UARmFpbGVkIHRvIHBhcnNlIGRldmljZSByZXNwb25zZQBzZW5zZQBpbW1lbnNlAGRlZmVuc2UAbGljZW5zZQBpbXB1bHNlAGVsc2UAQ09ORi5taXNzaW5nLmZhdGFsPWZhbHNlAENPTkYucGFyc2VyLnN0cmljdF9tYXRjaD1mYWxzZQBDT05GLnBhcnNlci5zdHJpY3RfcGFyc2U9ZmFsc2UAd2lzZQBjcnVpc2UAc3VycHJpc2UAdG9ydG9pc2UAbm9pc2UAZGVtaXNlAGV4ZXJjaXNlAHByYWlzZQBjaGVlc2UAcGhyYXNlAGVyYXNlAHB1cmNoYXNlAGRpc2Vhc2UAaW5jcmVhc2UAZGVjcmVhc2UAcGxlYXNlAHJlbGVhc2UAY2FzZQBiYXNlAG1peHR1cmUAZnV0dXJlAGdlc3R1cmUAaW52YWxpZCBwYXR0ZXJuIGNhcHR1cmUAdW5maW5pc2hlZCBjYXB0dXJlAHZlbnR1cmUAY3VsdHVyZQBwaWN0dXJlAGxlY3R1cmUAY3J5cHRvX3NjaG5vcnJfc2lnbmF0dXJlAG1sZHNhNDRfc2lnbmF0dXJlAG1sX2RzYV80NF9zaWduYXR1cmUAY291bGQgbm90IGFsbG9jYXRlIHNwYWNlIGZvciBzaWduYXR1cmUAQ291bGQgbm90IGFsbG9jYXRlIHNwYWNlIGZvciBzaWduYXR1cmUAZmFpbGVkIHRvIGFsbG9jYXRlIHNwYWNlIGZvciBzaWduYXR1cmUAQ291bGQgbm90IGFsbG9jYXRlIHNpZ25hdHVyZQBDdW9sZCBub3QgYWxsb2NhdGUgc2lnbmF0dXJlAGZhaWxlZCB0byBhbGxvY2F0ZSBzcGFjZSBmb3IgdGhlIHNpZ25hdHVyZQBJbnZhbGlkIHNpemUgZm9yIEVkRFNBIHNpZ25hdHVyZQBJbnZhbGlkIHNpemUgZm9yIFAyNTYgc2lnbmF0dXJlAGRldmljZVNpZ25hdHVyZQBmZWF0dXJlAGVuc3VyZQBsZWlzdXJlAG1lYXN1cmUAR2VuZXJhbCBmYWlsdXJlAENhbm5vdCBjcmVhdGUgb2N0ZXQsIG1hbGxvYyBmYWlsdXJlAGZpZ3VyZQBvYnNjdXJlAGlnbm9yZQBtb3JlAGJlZm9yZQBjb3JlAGdlbnJlAHdpcmUAcmVxdWlyZQBhY3F1aXJlAGVudGlyZQByZXRpcmUAZXhwaXJlAGluc3BpcmUAaGlyZQBmaXJlAHdoZXJlAHRoZXJlAHNwaGVyZQB1bmF3YXJlAHNxdWFyZQByYXJlAHNwYXJlAHByZXBhcmUAZ2xhcmUAemVuY29kZV9zZWNzaGFyZQB3YXJmYXJlAHNjYXJlAGN0eXBlAGRvY190eXBlAHZhbHVlSW5kZXggY2FsbGVkIG9uIG5vbi12YWx1ZSB0eXBlAHZhbHVlTGVuZ3RoIGNhbGxlZCBvbiBub24tdmFsdWUgdHlwZQBkb2NUeXBlAGVudmVsb3BlAGhvcGUAc2NvcGUAcGlwZQByZWNpcGUAdGFwZQBncmFwZQBlc2NhcGUAdG9lAGNhbm9lAHNob2UAZm9ydHVuZQBpbW11bmUAZHVuZQBvem9uZQBzdG9uZQBhbG9uZQBwaG9uZQBzb21lb25lAFpLIENvbW1pdG1lbnQgZG9uZQBaSyBjb25zdHJhaW50cyBkb25lAFpLIHN1bWNoZWNrIGRvbmUAWksgaGFzaCBwcm9vZiBkb25lAFpLIHNpZ25hdHVyZSBwcm9vZiBkb25lAGJvbmUAd2luZQBnZW51aW5lAGNhbm5vdCBjbG9zZSBhICVzIGNvcm91dGluZQBjYW5ub3QgcmVzdW1lIG5vbi1zdXNwZW5kZWQgY29yb3V0aW5lAGNhbm5vdCByZXN1bWUgZGVhZCBjb3JvdXRpbmUAYXR0ZW1wdCB0byB5aWVsZCBmcm9tIG91dHNpZGUgYSBjb3JvdXRpbmUAbWFyaW5lAGN1cnJlbnRsaW5lAG9ubGluZQBkZWNsaW5lAHNoaW5lAHN0YXRlbWFjaGluZQBlbmdpbmUAZWNwX2FmZmluZQBlY3AyX2FmZmluZQBkZWZpbmUAY29tYmluZQBzY2VuZQBpbnNhbmUAY3JhbmUAYXNzdW1lAHRvbyBtYW55IGFyZ3VtZW50cyB0byByZXN1bWUAdG9vIG1hbnkgcmVzdWx0cyB0byByZXN1bWUAdm9sdW1lAGF3ZXNvbWUAaG9tZQBpbmNvbWUAd2VsY29tZQBiZWNvbWUAbmV3dGltZQBkaWZmdGltZQB6ZW5jb2RlX3RpbWUAemVucm9vbS50aW1lAGVjcF9wcmltZQBlY2RoX3ByaW1lAGNyaW1lAHN1cHJlbWUAdGhlbWUAc2NoZW1lAHNhbWUAZnJhbWUAX19uYW1lAGZsYW1lAGJsYW1lAGdhbWUAZmFtZQBwdXp6bGUAc3R5bGUAcnVsZQBtdWxlAGxpdHRsZQBzZXR0bGUAY2F0dGxlAGJhdHRsZQB3cmVzdGxlAGNhc3RsZQB0dXJ0bGUAZ2VudGxlAHRpdGxlAGFpc2xlAGNvdXBsZQB0b3BwbGUAcmlwcGxlAGFwcGxlAHBlb3BsZQBzaW1wbGUAbWRvY19leGFtcGxlAHNhbXBsZQBtYXBsZQBwb2xlAGhvbGUAemVuY29kZV9tZXJrbGUAYW5rbGUAY2h1Y2tsZQB0YWNrbGUAZXhpbGUAc21pbGUAd2hpbGUAZnJhZ2lsZQBmaWxlAG1vYmlsZQBqdW5nbGUAYW5nbGUAc3RydWdnbGUAZ2lnZ2xlAGVhZ2xlAHJpZmxlAHNodWZmbGUAaHVyZGxlAG5vb2RsZQBidW5kbGUAaWRsZQBPY3RldDpmaW5kIHBvc2l0aW9uICgzcmQgYXJnKSBzcXVlZXplcyBvdXQgbmVlZGxlAG1pZGRsZQBzYWRkbGUAcGFkZGxlAGNyYWRsZQBiaWN5Y2xlAHJlY3ljbGUAbXVzY2xlAHJvb3Qgb2YgdW5pdHkgbm90IG9uIHRoZSB1bml0IGNpcmNsZQB1bmNsZQB2ZWhpY2xlAG1pcmFjbGUAdHJvdWJsZQBlY3BfZG91YmxlAG1hcmJsZQBub2JsZQBzdHVtYmxlAGNydW1ibGUAaHVtYmxlAHJlc2VtYmxlAHBvc3NpYmxlAGJ1YmJsZQBzdGFibGUAbm90YWJsZQB0aW1ldGFibGUAc2V0bWV0YXRhYmxlAGdldG1ldGF0YWJsZQBfX21ldGF0YWJsZQBjYW5ub3QgY2hhbmdlIGEgcHJvdGVjdGVkIG1ldGF0YWJsZQB6ZW5jb2RlX3RhYmxlAHN0cmluZy9mdW5jdGlvbi90YWJsZQBuaWwgb3IgdGFibGUAZmllbGQgJyVzJyBtaXNzaW5nIGluIGRhdGUgdGFibGUAc2lnbmF0dXJlIGFyZ3VtZW50IGludmFsaWQ6IG5vdCBhIHRhYmxlAGNhcGFibGUAdW5hYmxlAGVuYWJsZQB2aWFibGUAaXN5aWVsZGFibGUAY2FibGUAZmVtYWxlAHdoYWxlAGluaGFsZQBzY2FsZQBzZXRsb2NhbGUAX19sZQBldm9rZQBzbW9rZQBqb2tlAHN0cmlrZQBzcGlrZQBsaWtlAGJpa2UAYXdha2UAbWlzdGFrZQBzbmFrZQBtYWtlAGxha2UAY2FrZQBtb3ZpZQByb29raWUAaHVnZQBnYXVnZQBzdXJnZQBlbWVyZ2UAZm9ybWF0IHJlc3VsdCB0b28gbGFyZ2UARnJhbWUgaW5kZXggaXMgdG9vIGxhcmdlAGJ1ZmZlciB0b28gbGFyZ2UAVGV4dCBsZW5ndGggdG9vIGxhcmdlAHJlc3VsdGluZyBzdHJpbmcgdG9vIGxhcmdlAFVURi04IHZhbHVlIHRvbyBsYXJnZQBkZWNpbWFsIGVzY2FwZSB0b28gbGFyZ2UAVW5zdXBwb3J0ZWQgbWF4IFN5bWJvbCBWYWx1ZSA6IHRvbyBsYXJnZQBjaGFyZ2UAbG91bmdlAHBsdW5nZQBmcmluZ2UAYXJyYW5nZQBvcmFuZ2UAaW5kZXggb3V0IG9mIHJhbmdlAENvdWxkIG5vdCByZWFkIHVuaXggdGltZXN0YW1wICVzIG91dCBvZiByYW5nZQBSZXN1bHQgb2YgYWRkaXRpb24gb3V0IG9mIHJhbmdlAFJlc3VsdCBvZiBzdWJ0cmFjdGlvbiBvdXQgb2YgcmFuZ2UAbGV2ZWwgb3V0IG9mIHJhbmdlAHZhbHVlIG91dCBvZiByYW5nZQBiYXNlIG91dCBvZiByYW5nZQBleGNoYW5nZQBvYmxpZ2UAc2llZ2UAanVkZ2UAYnJpZGdlAHBsZWRnZQBiYWRnZQB2b3lhZ2UAd2FnZQBsYW5ndWFnZQBPcGVyYXRpb24gbm90IGF1dGhvcml6ZWQgYXQgY3VycmVudCBwcm9jZXNzaW5nIHN0YWdlAHZpbnRhZ2UAc2F1c2FnZQBxcF9zaWduZWRfbWVzc2FnZQBxcF92ZXJpZmllZF9tZXNzYWdlAENvdWxkIG5vdCBhbGxvY2F0ZSBpbnB1dCBtZXNzYWdlAENvdWxkIG5vdCBhbGxvY2F0ZSBzcGFjZSBmb3Igc2VjcmV0IG1lc3NhZ2UAQ291bGQgbm90IGFsbG9jYXRlIHNwYWNlIGZvciBtZXNzYWdlAGZhaWxlZCB0byBhbGxvY2F0ZSBzcGFjZSBmb3IgbWVzc2FnZQBDb3VsZCBub3Qgc2lnbiBtZXNzYWdlAENvdWxkIG5vdCBhbGxvY2F0ZSBtZXNzYWdlAGF2ZXJhZ2UAZ2FyYWdlAHBhZ2UAbWFuYWdlAGltYWdlAGRhbWFnZQB2aWxsYWdlAG1hcnJpYWdlAGVuZ2FnZQBsdWdnYWdlAGNhZ2UAY29sbGVjdGdhcmJhZ2UAY2FiYmFnZQB3aWZlAGtuaWZlAGxpZmUAZ2lyYWZmZQBzYWZlAEludmFsaWQgcG9zaXRpb24gZm9yIGxlYWYgaW4gTWVya2xlIHRyZWUAdGhyZWUAZGVncmVlAGRpc2FncmVlAGtuZWUAbm9taW5lZQBmbGVlAGNvZmZlZQBhdHRpdHVkZQBydWRlAGV4Y2x1ZGUAaW5jbHVkZQBlcGlzb2RlAGVyb2RlAF9fbW9kZQBleGl0Y29kZQB6ZW5jb2RlAEJsb2NrLWxldmVsIGV4dGVybmFsIHNlcXVlbmNlIHByb2R1Y2VyIHJldHVybmVkIGFuIGVycm9yIGNvZGUAVW5zcGVjaWZpZWQgZXJyb3IgY29kZQBpbnZhbGlkIFVURi04IGNvZGUAd2lkZQBwcm92aWRlAGRpdmlkZQBndWlkZQB0aWRlAG91dHNpZGUAaW5zaWRlAHByaWRlAHNsaWRlAGdsaWRlAGRlY2lkZQB0cmFkZQB1cGdyYWRlAHBhcmFkZQBibGFkZQBmYWRlAGRlY2FkZQBwcm9kdWNlAHJlZHVjZQBzYXVjZQByZXNvdXJjZQBkaXZvcmNlAGVuZm9yY2UAYW5ub3VuY2UAYm91bmNlAGJlZ2luX2Z1bGxfZmllbGQoKSBjYW4gb25seSBiZSBjYWxsZWQgb25jZQBjb252aW5jZQBzaW5jZQBzdHJpbmcgaXMgbm90IGEgdmFsaWQgYmluYXJ5IHNlcXVlbmNlAHN0cmluZyBpcyBub3QgYSB2YWxpZCBoZXggc2VxdWVuY2UAaW52YWxpZCBlc2NhcGUgc2VxdWVuY2UAc3RyaW5nIGlzIG5vdCBhIHZhbGlkIGJhc2U1OCBzZXF1ZW5jZQBzdHJpbmcgaXMgbm90IGEgdmFsaWQgdXJsNjQgc2VxdWVuY2UAc3RyaW5nIGlzIG5vdCBhIHZhbGlkIGJhc2U2NCBzZXF1ZW5jZQBzZW50ZW5jZQBlc3NlbmNlAHNjaWVuY2UAZmVuY2UAZXZpZGVuY2UAYWR2YW5jZQBwb3Bjb3VudF9oYW1taW5nX2Rpc3RhbmNlAGJpdHNoaWZ0X2hhbW1pbmdfZGlzdGFuY2UAcm9tYW5jZQBnbGFuY2UAYmFsYW5jZQBlbmhhbmNlAGRhbmNlAHR3aWNlAHNlcnZpY2UAZGV2aWNlAGFkdmljZQBqdWljZQB6ZW5fbm90aWNlAHByYWN0aWNlAHByaWNlAHNwaWNlAHZvaWNlAGNob2ljZQBuaWNlAHNsaWNlAHBvbGljZQBvZmZpY2UAZGljZQBwaWVjZQBncmFjZQBlbWJyYWNlAHNwYWNlAGZ1cm5hY2UAcmVwbGFjZQBwYWxhY2UAc3VyZmFjZQBwZWFjZQB0dWJlAGN1YmUAZ2xvYmUAdHJpYmUAZGVzY3JpYmUARWUAJWUAY3Jvd2QAcHJvdWQAY2xvdWQAYWJzdXJkAHN3b3JkAHJhbmRvbV93b3JkAGFmZm9yZAByZWNvcmQAd2VpcmQAYmlyZABsaXphcmQAaGF6YXJkAHlhcmQAZm9yd2FyZAB0b3dhcmQAYXdrd2FyZAByZXdhcmQAZ3VhcmQAbGVvcGFyZABjdXBib2FyZABvcmNoYXJkAGNhcmQAd29vZABibG9vZABob29kAGdvb2QAZm9vZABiaWdfemVubW9kAGZtb2QAZmxvYXRfbW9kAGJpZ19tb2QAX19tb2QAbWV0YW1ldGhvZABzb3VuZABzdXJyb3VuZABkZXN0aW5hdGlvbiB3cmFwIGFyb3VuZABmb3VuZABmaWVsZCAnJXMnIGlzIG91dC1vZi1ib3VuZABQYXJhbWV0ZXIgaXMgb3V0IG9mIGJvdW5kAGJleW9uZABwb25kAGRpYW1vbmQAc2Vjb25kAHJlbWluZABibGluZABraW5kAGJlaGluZABtZW1maW5kAGJpbmQAZXh0ZW5kAGF0dGVuZAB0cmVuZABzcGVuZABkZXBlbmQAbGVuZAB3ZWVrZW5kAGZyaWVuZABsZWdlbmQASlNPTiBoYXMgbWFsZm9ybWVkIGJlZ2lubmluZyBvciBlbmQAc3RhbmQAc2FuZABoYXNoX3NyYW5kAGJpZ19tb2RyYW5kAGJyYW5kAGV4cGFuZABkZW1hbmQAaXNsYW5kAGhhbmQAaHVzYmFuZABfX2JhbmQAd29ybGQAdXBob2xkAGdvbGQAdW5mb2xkACUwKmxsZAAlKmxsZAArJWxsZAB3aWxkAHJlYnVpbGQAY2hpbGQAaGFzaF95ZWxkAHlpZWxkAHNoaWVsZABlbGVtZW50IG5vdCBpbiBzdWJmaWVsZAAlKy40bGQAJWxkAHZpdmlkAHRvX3V1aWQAZnJvbV91dWlkAGxpcXVpZABmbHVpZABncmlkAGh5YnJpZAByYXBpZABhdm9pZABweXJhbWlkAHNvbGlkAHNpZ25hdHVyZSBhcmd1bWVudCBpbnZhbGlkAGhleCBzZXF1ZW5jZSBpbnZhbGlkAEV4dGVybmFsIHNlcXVlbmNlcyBhcmUgbm90IHZhbGlkAGtpZAByaWdpZAB1cHZhbHVlaWQAemVuY29kZV9kaWQAYWNpZABiaWQAYWZyYWlkAG1haWQAZ2V0X2NpcmN1aXRfaWQAd2lkID09IGxucGkuZGVzaXJlZF93aXJlX2lkAGludmFsaWQgYmlnIG51bWJlciBpbiBhcmd1bWVudDogbm90IGluaXRhbGl6ZWQAbWl4ZWQAZml4ZWQATHVhIHNjcmlwdCBzdWNjZXNzZnVsbHkgZXhlY3V0ZWQAWmVuY29kZSBzdWNjZXNzZnVsbHkgZXhlY3V0ZWQASW50ZWdlciB0b28gYmlnIHRvIGJlIGV4cG9ydGVkAHRhYmxlTG9nIHJlcXVpcmVzIHRvbyBtdWNoIG1lbW9yeSA6IHVuc3VwcG9ydGVkAFZlcnNpb24gbm90IHN1cHBvcnRlZABBRVMtQ1RSIHByb2Nlc3MgYWJvcnRlZABleGVjdXRpb24gYWJvcnRlZABFeGVjdXRpb24gYWJvcnRlZABFQ0RIIGVuY3J5cHRpb24gYWJvcnRlZABSU0EgZW5jcnlwdGlvbiBhYm9ydGVkAEVDREggZGVjcnlwdGlvbiBhYm9ydGVkAG9wZXJhdGlvbiBhYm9ydGVkAERpY3Rpb25hcnkgaXMgY29ycnVwdGVkACVzOiBFQ0RIIG1vZHVsdXMgbm90IGltcGxlbWVudGVkACVzOiBFQ0RIIGNvZmFjdG9yIG5vdCBpbXBsZW1lbnRlZAAlczogRUNESCBvcmRlciBub3QgaW1wbGVtZW50ZWQATm90IHlldCBpbXBsZW1lbnRlZABObyBlcnJvciBkZXRlY3RlZABEYXRhIGNvcnJ1cHRpb24gZGV0ZWN0ZWQAc2V0ZW52OiBOVUxMIHN0cmluZyBkZXRlY3RlZABzdHJpbmcgYXJndW1lbnQgZXhwZWN0ZWQAaGV4YWRlY2ltYWwgZGlnaXQgZXhwZWN0ZWQAZnVuY3Rpb24gYXJndW1lbnRzIGV4cGVjdGVkACVzIGV4cGVjdGVkAEx1YSBmdW5jdGlvbiBleHBlY3RlZABiYXNlNTggc3RyaW5nIGV4cGVjdGVkAGJhc2U0NSBzdHJpbmcgZXhwZWN0ZWQAdXJsNjQgc3RyaW5nIGV4cGVjdGVkAGJhc2U2NCBzdHJpbmcgZXhwZWN0ZWQAdmFsdWUgZXhwZWN0ZWQAYmluYXJ5IHN0cmluZyBzZXF1ZW5jZSBleHBlY3RlZABJbnZhbGlkIGxvbmcgcHVibGljIGtleSBwcmVmaXg6IDB4MDQgZXhwZWN0ZWQASW52YWxpZCBjb21wcmVzc2VkIHB1YmxpYyBrZXkgcHJlZml4OiAweDAyIG9yIDB4MDMgZXhwZWN0ZWQAJz0nIG9yICdpbicgZXhwZWN0ZWQAPG5hbWU+IG9yICcuLi4nIGV4cGVjdGVkAHBsZWRnZWQgYnVmZmVyIHN0YWJpbGl0eSBjb25kaXRpb24gaXMgbm90IHJlc3BlY3RlZABjaXJjdWl0IGNyZWF0ZWQAdXNlIG9mIFJORyBkZXByZWNhdGVkAGFtdXNlZABFQ1AgYXJnICV1IGlzIHpjYXNoIGNvbXByZXNzZWQARUNQMiBhcmcgJXUgaXMgemNhc2ggY29tcHJlc3NlZABoYXNoIGNpcmN1aXQgY291bGQgbm90IGJlIHBhcnNlZABzaWduYXR1cmUgY2lyY3VpdCBjb3VsZCBub3QgYmUgcGFyc2VkAGhhc2ggcHJvb2YgY291bGQgbm90IGJlIHBhcnNlZABzaWcgcHJvb2YgY291bGQgbm90IGJlIHBhcnNlZABpbnZhbGlkIHV1aWQgcGFyc2VkAHRpcmVkAGh1bmRyZWQAbG4uZGVzaXJlZF93aXJlX2lkICE9IGtXaXJlSWRVbmRlZmluZWQAbGFzdGxpbmVkZWZpbmVkAGlzc3VlclNpZ25lZABkZXZpY2VTaWduZWQAYXJtZWQAZXZhbF9jaXJjdWl0IGZhaWxlZABJbml0aWFsaXNhdGlvbiBvZiBsdWEgc2NyaXB0cyBmYWlsZWQAZmlsbF93aXRuZXNzIGZhaWxlZABXaXRuZXNzIGNyZWF0aW9uIGZhaWxlZABNZW1vcnkgYWxsb2NhdGlvbiBmYWlsZWQAZG90X2NoZWNrIGZhaWxlZABtZXJrbGVfY2hlY2sgZmFpbGVkAGxvd19kZWdyZWVfY2hlY2sgZmFpbGVkAHF1YWRyYXRpY19jaGVjayBmYWlsZWQAQ2lyY3VpdCBwYXJzaW5nIGZhaWxlZABIYXNoIHBhcnNpbmcgZmFpbGVkAFNpZ25hdHVyZSBwYXJzaW5nIGZhaWxlZABlY2RoX2RzYV92ZXJpZnlfaGFzaGVkAGVjZGhfZHNhX3NpZ25fZGV0X2hhc2hlZABlY2RoX2RzYV9zaWduX2hhc2hlZAByYW5kb21zZWVkAHJuZ3NlZWQAbW5lbW9uaWNfdG9fc2VlZAByYW5kb21fc2VlZABybmdfc2VlZABtbmVtb25pY19zZWVkAEhBU0ggcmFuZG9tIG51bWJlciBnZW5lcmF0b3IgbGFja3Mgc2VlZABzcGVlZABuZWVkAGhhc2hfZmVlZABzdXNwZW5kZWQATnVsbCBpbnB1dCBwcm92aWRlZABJbXBvcnQgb2Ygb2N0ZXQgdG8gQklHIGxpbWl0IGV4Y2VlZGVkAGJpZ196ZW5hZGQAZmxvYXRfYWRkAGVjcF9hZGQAZWNkaF9hZGQAYmlnX2FkZAB0aW1lX2FkZABfX2FkZABlY3AyX2FkZAAweDUwNzBlODE5OWYzYzVlMWVjZjYyNDk2NjI5OTQ5OTc2MDViNzIwNWIwMzlmZjc3ZmFkNGY5YWNlYjNjYWRiY2QAc2FkAHJhZABwYWQAcm9hZABsb2FkAG1hZABnbGFkAHNhbGFkAHNwcmVhZAB0aHJlYWQAYnJlYWQAcHJvb2ZzIHJlYWQAYWhlYWQAZGVhZABkYWQAXCUwM2QAXCVkACVZLSVtLSVkAGludmFsaWQgY2FwdHVyZSBpbmRleCAlJSVkAEV4cGVjdGVkIHRhYmxlIGF0IGluZGV4ICVkAGNhbm5vdCBjaG9wIG9jdGV0IHdpdGggbmVnYXRpdmUgc2l6ZSAlZABicmVhayBvdXRzaWRlIGxvb3AgYXQgbGluZSAlZABmdW5jdGlvbiBhdCBsaW5lICVkAG5vIHZpc2libGUgbGFiZWwgJyVzJyBmb3IgPGdvdG8+IGF0IGxpbmUgJWQAbGFiZWwgJyVzJyBhbHJlYWR5IGRlZmluZWQgb24gbGluZSAlZABJbnZhbGlkIHNpemUgZm9yIHNlZ3dpdCBhZGRyZXNzOiAlZABJbnZhbGlkIHNlZ3dpdCB2ZXJzaW9uOiAlZAB6ZW5jb2RlX3ZjAHNob3J0X3NyYwBjcmMAbWRvYwBmdW5jAG50cnVwX2VuYwBxcF9lbmMAbWxrZW1fZW5jAHFwX3NudHJ1cF9rZW1fZW5jAGFjb3VzdGljAHZlcmlmeV9kZXRlcm1pbmlzdGljAHNpZ25fZGV0ZXJtaW5pc3RpYwBkcmFzdGljAHBsYXN0aWMAZXhvdGljAGNyaXRpYwBhcmN0aWMAbXVzaWMAYmFzaWMAZWxlY3RyaWMAbnVtZXJpYwBmYWJyaWMAdG9waWMAb2x5bXBpYwBjaHJvbmljAHRvX21uZW1vbmljAGZyb21fbW5lbW9uaWMAJXMgOjogb2N0ZXQgYmlnZ2VyIHRoYW4gMzIgYnl0ZXMgY2Fubm90IGJlIGVuY29kZWQgdG8gbW5lbW9uaWMAJXMgOjogY2Fubm90IGJlIGVuY29kZWQgdG8gbW5lbW9uaWMAY2xpbmljAHBpY25pYwBwYW5pYwBtZWNoYW5pYwBjb21pYwBtaW1pYwBkeW5hbWljAGdhcmxpYwBwdWJsaWMAbG9naWMAdHJhZ2ljAG1hZ2ljAHRyYWZmaWMAYWVyb2JpYwBfX2djADB4YjQ2ODJlYzIwZTA2ZThkZjg0MGI1ZGQzMjk1OTc5OGFiMjBjNTQ0ZDRkYTUwMTA5ZmY0Njg0ZDA2ZmQyNjFmYwBzZWMAbnRydXBfZGVjAHFwX2RlYwBtbGtlbV9kZWMAcXBfc250cnVwX2tlbV9kZWMAYmMAaGFzaF9obWFjAGNyeXB0b193M2MAemVuY29kZV93M2MAMjAlYyVjLSVjJWMtJWMlYyAlYyVjOiVjJWM6JWMlYwBjb206JXp1LCBzYzolenUsIGNvbV9wcm9vZjolenUgWyV6dSBlbCwgJXp1IGVsLCAlenUgZCBpbiAlenUgcm93c106ICV6dWIAYmlnX3plbnN1YgBnc3ViAGJpZ19tb2RzdWIAZmxvYXRfc3ViAGVjcF9zdWIAYmlnX3N1YgB0aW1lX3N1YgBfX3N1YgBlY3AyX3N1YgBzY3J1YgBjaGVja3B1YgBwMjU2X2NvbXByZXNzX3B1YgBjbHViAGh1YgB0YgBhYnNvcmIAdmVyYgBqb2IAdGh1bWIAZHVtYgBib21iAGNsaW1iAGJ1bGIAcmliAHdlYgBncmFiAHNsYWIAcGl6emEAcndhAGxhdmEAL3plbmNvZGVfZGljdGlvbmFyeS5sdWEAL3plbmNvZGVfdmVyaWZ5Lmx1YQAvemVuY29kZV9hcnJheS5sdWEAL2NyeXB0b19sb25nZmVsbG93Lmx1YQAvemVuY29kZV9sb25nZmVsbG93Lmx1YQAvemVuY29kZV9yZWZsb3cubHVhAC96ZW5jb2RlX2p3dC5sdWEAL2NyeXB0b19zZF9qd3QubHVhAC96ZW5jb2RlX3NkX2p3dC5sdWEAL3plbmNvZGVfcGxhbmV0bWludC5sdWEAL2luaXQubHVhAC96ZW5yb29tX29jdGV0Lmx1YQAvaGR3YWxsZXQubHVhAC9pbnNwZWN0Lmx1YQAvemVuY29kZV9kcDN0Lmx1YQAvemVuY29kZV9qd3MubHVhAC9zdGF0cy5sdWEAL2NyeXB0b19wdnNzLmx1YQAvemVuY29kZV9wdnNzLmx1YQAvY3J5cHRvX2Jicy5sdWEAL3plbmNvZGVfYmJzLmx1YQAvemVuY29kZV9zY2hub3JyLmx1YQAvY3J5cHRvX2ZpYXRfc2hhbWlyLmx1YQAvc2VtdmVyLmx1YQAvY3J5cHRvX2xvYWRlci5sdWEAL3plbmNvZGVfaHR0cC5sdWEAL2NyeXB0b19mc3AubHVhAC96ZW5jb2RlX2ZzcC5sdWEAL3plbmNvZGVfcXAubHVhAC9xc29ydF9vcC5sdWEAL3plbnJvb21fZWNwLmx1YQAvemVucm9vbV9qc29uLmx1YQAvanNvbi5sdWEAL3plbnJvb21fY29tbW9uLmx1YQAvY3J5cHRvX3BldGl0aW9uLmx1YQAvemVuY29kZV9wZXRpdGlvbi5sdWEAL2NyeXB0b19sYWdyYW5nZV9pbnRlcnBvbGF0aW9uLmx1YQAvY3J5cHRvX2JpdGNvaW4ubHVhAC96ZW5jb2RlX2JpdGNvaW4ubHVhAC96ZW5jb2RlX2dpdmVuLmx1YQAvemVuY29kZV93aGVuLmx1YQAvemVuY29kZV90aGVuLmx1YQAvY3J5cHRvX2V0aGVyZXVtLmx1YQAvemVuY29kZV9ldGhlcmV1bS5sdWEAL3plbmNvZGVfcmFuZG9tLmx1YQAvc3BlbGwubHVhAC9jcnlwdG9fZWxnYW1hbC5sdWEAL2NyeXB0b19jcmVkZW50aWFsLmx1YQAvemVuY29kZV9jcmVkZW50aWFsLmx1YQAvemVuY29kZV9qd2subHVhAC96ZW5yb29tX21zZ3BhY2subHVhAC9tc2dwYWNrLmx1YQAvemVuY29kZV9wYWNrLmx1YQAvemVuY29kZV9tYXRoLmx1YQAvemVucm9vbV9oYXNoLmx1YQAvemVuY29kZV9oYXNoLmx1YQAvemVucm9vbV9lY2RoLmx1YQAvemVuY29kZV9lY2RoLmx1YQAvemVucm9vbV9iZW5jaC5sdWEAL3plbmNvZGVfZm9yZWFjaC5sdWEAL3plbmNvZGVfZGVidWcubHVhAC96ZW5jb2RlX2tleXJpbmcubHVhAC96ZW5yb29tX2JpZy5sdWEAL2NyeXB0b19qb3NlLmx1YQAvY3J5cHRvX3NjaG5vcnJfc2lnbmF0dXJlLmx1YQAvemVuY29kZV9zZWNzaGFyZS5sdWEAL3N0YXRlbWFjaGluZS5sdWEAL3plbmNvZGVfdGltZS5sdWEAL3plbmNvZGVfbWVya2xlLmx1YQAvdGltZXRhYmxlLmx1YQAvemVuY29kZV90YWJsZS5sdWEAL3plbmNvZGUubHVhAC96ZW5jb2RlX2RpZC5sdWEAL3plbmNvZGVfdmMubHVhAC9jcnlwdG9fdzNjLmx1YQAvemVuY29kZV93M2MubHVhAC96ZW5jb2RlX2RhdGEubHVhAC96ZW5jb2RlX3JzYS5sdWEAL3plbmNvZGVfZWRkc2EubHVhAC96ZW5jb2RlX2VzMjU2Lmx1YQAvemVucm9vbV9lY3AyLmx1YQAbTHVhAGxpZ2h0IHVzZXJkYXRhAHplbmNvZGVfZGF0YQBDdW9sZCBub3QgYWxsb2NhdGUga2V5IG9yIGRhdGEAemVuY29kZV9yc2EAdmlzYQB6ZW5jb2RlX2VkZHNhAGV4dHJhAG9wZXJhAGNhbWVyYQB6ZWJyYQB0dW5hAGFudGVubmEAYXJlbmEAYmFuYW5hAGRpbGVtbWEAYXN0aG1hAGRyYW1hAGdvcmlsbGEAdW1icmVsbGEAbWVkaWEAYWxwaGEAc2VhAGFyZWEAaWRlYQBzb2RhAHBhbmRhACVhAHBvc18gPCB3Xy5uMV8AVi0+bjBfID09IFctPm4wXwBFUS0+bigpID09IFctPm4wXwBjb21taXQgY3JlYXRlZC4gaFtubDolenVdLCBzW25sOiV6dV0gaGNbYjolenUgcjolenVdIHNjW2I6JXp1IHI6JXp1XQBjaXJjdWl0IGNyZWF0ZWQuIGhbaW46JXp1XSwgc1tpbjolenVdAGludGVncmFsIHNpemUgKCVkKSBvdXQgb2YgbGltaXRzIFsxLCVkXQA9W0NdAHRyZWVbMV0AJ10AIlpFTlJPT00gSlNPTiBMT0cgRU5EIiBdADIwMjQtMDUtMDVUMDk6MDA6MDBaADIwMjQtMDEtMzFUMDk6MDA6MDBaADIwMjQtMTAtMDFUMDk6MDA6MDBaADIwMjQtMDEtMzBUMDk6MDA6MDBaADIwMjUtMDEtMjlUMTg6MDA6MDBaADIwMjUtMDQtMzBUMDA6MDA6MDBaAF9IT09LS0VZAHhYAFBPU0lYAF9FTlYAJVUAZGVjbGFyaW5nIGdsb2JhbDogQ09OVEVYVABHTVQATE9HRk1UAENPTU1JVABDb3VsZCBub3QgY2hvcCBPQ1RFVABDb3VsZCBub3QgY3JlYXRlIE9DVEVUAENvdWxkIG5vdCBhbGxvY2F0ZSBPQ1RFVABDb3VsZCBub3QgZHVwbGljYXRlIE9DVEVUAENvdWxkIG5vdCByZWFkIE9DVEVUAENvdWxkIG5vdCBleHRyYWN0IHN1YiBPQ1RFVABDb3VsZCBub3QgYWxsb2NhdGUgT0NURVQgZnJvbSBGTE9BVABkZWNsYXJpbmcgZ2xvYmFsOiBLRVlTAFNUQVRFTUVOVFMAQ0ZMQUdTACVIOiVNOiVTAFNUUl9NQVhJVEVSAENvdWxkIG5vdCBhbGxvY2F0ZSBPQ1RFVCBmcm9tIEVDUABDb3VsZCBub3QgaW5zdGFudGlhdGUgRUNQAENvdWxkIG5vdCBjcmVhdGUgRUNQAE9jdGV0IGRvZXNuJ3QgY29udGFpbnMgYSB2YWxpZCBFQ1AAQ291bGQgbm90IHJlYWQgRUNQAGRlY2xhcmluZyBnbG9iYWw6IFNDRU5BUklPAC54WG5OAHRhYmxlIGluZGV4IGlzIE5hTgBKU09OAF9WRVJTSU9OAC0tLS0tQkVHSU4AWkVOAEdJVkVOAFNBTgBOQU4AV0FTTQBTVFJfTUFYTUVNACVIOiVNAExDX0FMTABvcmcuaXNvLjE4MDEzLjUuMS5tREwA8J+MiiB0b3RhbCBhbGxvYzogJWx1IEsA8J+MiiBzZnBvb2wgaGl0czogJXUgLSAlbHUgSwDwn4yKIHNmcG9vbCBtaXNzOiAldSAtICVsdSBLACVJAENvdWxkIG5vdCBjcmVhdGUgSEFTSABBUkNIAEJSQU5DSABfRwBERUJVRwBMQU5HAHNpemVvZl9CSUcAc2l6ZW9mX0RCSUcAQ291bGQgbm90IGNyZWF0ZSBvY3RldCBmcm9tIEJJRwBDb3VsZCBub3QgYWxsb2NhdGUgT0NURVQgZnJvbSBCSUcAQ291bGQgbm90IGNyZWF0ZSBCSUcAQ291bGQgbm90IGFsbG9jYXRlIEJJRwBDb3VsZCBub3QgcmVhZCBCSUcASU5GADAxMjM0NTY3ODlBQkNERUYAQ291bGQgbm90IGNyZWF0ZSBLREYAWkVOQ09ERV9TQ09QRQBDT0RFAC0tLS0tRU5EAGRpZ2VzdElEAE9JRABSTkdTRUVEAF9MT0FERUQAQwBJbml0aWFsaXplZCBtZW1vcnk6ICV1IEtCAE1lbW9yeSB1c2VkOiAldSBLQgBNYWxsb2Mgb3V0IG9mIG1lbW9yeSwgcmVxdWVzdGVkICVsdSBCAGRlY2xhcmluZyBnbG9iYWw6IERBVEEAZGVjbGFyaW5nIGdsb2JhbDogRVhUUkEAPT8APGludGVnZXI+ADxudW1iZXI+ADxzdHJpbmc+ADxlb2Y+ADxuYW1lPgBmdW5jdGlvbiA8JXM6JWQ+ADxOVUxMPgA+PgB+PQA+PQA9PQA8PQA8PABoZXg6AEx1YSBzY3JpcHQgZXJyb3I6AHN0YWNrIHRyYWNlYmFjazoAdXJuOnV1aWQ6AGRlYzoAOjoALTFlOTk5OQAtMDEyMzQ1Njc4OQB4NTA5ADM2MTM0MjUwOTU2NzQ5Nzk1Nzk4NTg1MTI3OTE5NTg3ODgxOTU2NjExMTA2NjcyOTg1MDE1MDcxODc3MTk4MjUzNTY4NDE0NDA1MTA5AHJuZ191aW50OAByYW5kX3VpbnQ4AHJhbmRvbV9pbnQ4AHJhbmRvbTgAdXRmOABjcmM4AG1sa2VtNzY4AGx1YV9pc19iYXNlNTgAdG9fYmFzZTU4AGZyb21fYmFzZTU4AEVycm9yIGluIGNvbnZlcnNpb24gZnJvbSBiYXNlNTgAMTE1NzkyMDg5MjEwMzU2MjQ4NzYyNjk3NDQ2OTQ5NDA3NTczNTMwMDg2MTQzNDE1MjkwMzE0MTk1NTMzNjMxMzA4ODY3MDk3ODUzOTQ4ADB4MTIzNTVkZDAzODVmZWQzYmMzM2JlZGM5NzgxYjlhYWQ0N2IzM2U0YzI0NzA0YjhkMTQyODhiMWIzY2I0NWMyOABDLlVURi04ADB4ZjZmOGU5YTgxMTkxMTMyOWE1ZjY1M2ZjZWM1OTkwMDkyYzkxYTY1YmMxNjk1ZDI5MWNkNTFkZTljOTRlN2RiNwA0ODQzOTU2MTI5MzkwNjQ1MTc1OTA1MjU4NTI1Mjc5NzkxNDIwMjc2Mjk0OTUyNjA0MTc0Nzk5NTg0NDA4MDcxNzA4MjQwNDYzNTI4NgAweGNjOTAwODQzNjk5NDA4OTM2YzkxMjQ3NGEyN2FiYjdiNjJkN2M5MGU0ZjZkODU1NzcxNDgyNTQ3NmVlZTIzNjYAemVuY29kZV9lczI1NgBwMjU2AGtlY2NhazI1NgBzaGFrZTI1NgBzaGEyNTYAc2hhM18yNTYAcm5nX3VpbnQxNgByYW5kX3VpbnQxNgByYW5kb21faW50MTYAcmFuZG9tMTYAOTRmMGUyYTUAdG9fYmFzZTQ1AGZyb21fYmFzZTQ1ADB4YjE5NzY0ZDMzYjUzMGU5YmQ2YTg3MDgxZjFkOGU1Y2JjODBkYjY0MGFjOTYyZWU4YTNlMDM5M2MxNGM2YmZiNABzaGEzODQAcmVhZF91NjQAbHVhX2lzX3VybDY0AHRvX3VybDY0AGZyb21fdXJsNjQAcmVhZF9pNjQAbHVhX2lzX2Jhc2U2NABwZW1fdG9fYmFzZTY0AGZyb21fYmFzZTY0AHdyb25nIHNpZ25hdHVyZSBhcmd1bWVudCBzaXplOiA2MiA8PSBzaWcgPD0gNjQAbWxrZW0xMDI0AEx1YSA1LjQAQkxTMzgzADB4M2Y5OTRjMDQzYmU3ZTE3ZGQwODM4NzI4MWJhYzBjMzdhNTI5MzYxYjNjYjM2YTBmYWMzOGQ0MWFjMDY2ZjkwMwBsdWFfbmV3X2VjcDIAemVucm9vbV9lY3AyAHplbnJvb20uZWNwMgBhdGFuMgB1bmluaXRpYWxpc2VkIGJpZyBpbiBhcmcyAGhhc2hfcGJrZGYyAGhhc2hfa2RmMgBDb3VsZCBub3QgYWxsb2NhdGUgT0NURVQgZnJvbSBFQ1AyAE9jdGV0IGRvZXNuJ3QgY29udGFpbnMgYSB2YWxpZCBFQ1AyAHJhbmRfdWludDMyAHJhbmRvbV9pbnQzMgBybmdfaW50MzIAcmFuZG9tMzIAUkZDODIyAHplbnJvb20uZnAxMgBDb3VsZCBub3QgYWxsb2NhdGUgRlAxMgBtbGtlbTUxMgBzaGE1MTIAc2hhM181MTIASE1BQyBpcyBvbmx5IHN1cHBvcnRlZCBmb3IgaGFzaCBTSEEyNTYgb3IgU0hBNTEyAGZvcm1hdCBhc2tzIGZvciBhbGlnbm1lbnQgbm90IHBvd2VyIG9mIDIAbG9uZ2ZlbGxvdy1saWJ6ay12MQB1bmluaXRpYWxpc2VkIGJpZyBpbiBhcmcxAEVDREggY3VydmUgaXMgU0VDUDI1NksxAG1hcF90b19jdXJ2ZV9HMQBhc3N1bWluZyB0aGF0IGNvcGllcz0xADQxMDU4MzYzNzI1MTUyMTQyMTI5MzI2MTI5NzgwMDQ3MjY4NDA5MTE0NDQxMDE1OTkzNzI1NTU0ODM1MjU2MzE0MDM5NDY3NDAxMjkxAEJMUzM4MQAweGZmZmZmZmZmMDAwMDAwMDBmZmZmZmZmZmZmZmZmZmZmYmNlNmZhYWRhNzE3OWU4NGYzYjljYWMyZmM2MzI1NTEAY29tLmdvb2dsZS53YWxsZXQuaWRjYXJkLjEAdjUuMjUuMQBvcmcuaXNvLjE4MDEzLjUuMQBubCA+PSAxAG5jID49IDEAbl8gPT0gMQBuMV8gPT0gMQBXXy5uMF8gPT0gMQBraTEgPT0gMQByaXBlbWQxNjAAbG9nMTAAWDQwMAAtMAAtIzAAY2xyLT5sb2d3ID4gMABuMCA+IDAAY19bMF0uZyA9PSAwAGNfWzBdLmhbMV0gPT0gMABjX1swXS5oWzBdID09IDAAa2kwID09IDAAY2Fubm90IHdyaXRlIHNjIHByb29mIHdpdGggbG9nYyAhPSAwAC8vAEV4ZWN1dGlvbiBhYm9ydGVkIHdpdGggZXJyb3JzLgBaZW5yb29tIHRlYXJkb3duLgBaZW5yb29tIGV4ZWN1dGlvbiBjb21wbGV0ZWQuAEEgTWVya2xlIHByb29mIHdpdGggMCBsZWF2ZXMgaXMgbm90IGRlZmluZWQuAFplbnJvb20gaW5pdGlhbGlzYXRpb24gZmFpbGVkLgBMdWEgaW5pdGlhbGlzYXRpb24gZmFpbGVkLgAlczogaG1hYyAoJXUgYnl0ZXMpIGZhaWxlZC4ALSsjMCAxMjM0NTY3ODkuAC4uLgBeJCorPy4oWyUtAFsgIlpFTlJPT00gSlNPTiBMT0cgU1RBUlQiLAAtKwBfVUJPWCoARklMRSoAbmV3IEVDUCB2YWx1ZSBvdXQgb2YgY3VydmUgKHBvaW50cyB0byBpbmZpbml0eSkAKHRlbXBvcmFyeSkAKEMgdGVtcG9yYXJ5KQBKU09OIGRvZXNuJ3Qgc3RhcnRzIHdpdGggJ3snIG5vciAnWycsIGNoYXIgZm91bmQ6ICVjICglMDJ4KQAlczogZnAxMiBjaHVuayBzaXplIG1pc21hdGNoICgldSAhPSAldSkAJXM6IGZwMTIgc2l6ZSBtaXNtYXRjaCAoJXUgIT0gJXUpAGwgPD0gc2l6ZW9mKHNpemVfdCkACgkuLi4JKHNraXBwaW5nICVkIGxldmVscykAUmFuZG9tIHNlZWQgZXJyb3I6IHRvbyBzbWFsbCAoJXUgYnl0ZXMpAG5ldyBmcDEyICgldSBieXRlcykAb3ZlcmZsb3cgaW4gbmF0KGNvbnN0IGNoYXIgKnMpAHN0YWNrIG92ZXJmbG93ICglcykAJXM6IGJhZCBiaW5hcnkgZm9ybWF0ICglcykAVW5rbm93biBNTEtFTSB0eXBlOiAlcyAoJXMpAGNhbGxpbmcgJyVzJyBvbiBiYWQgc2VsZiAoJXMpAGJhZCBhcmd1bWVudCAjJWQgKCVzKQBiYWQgYXJndW1lbnQgIyVkIHRvICclcycgKCVzKQBiYWQgJ2ZvcicgJXMgKG51bWJlciBleHBlY3RlZCwgZ290ICVzKQBpbnZhbGlkIHJlcGxhY2VtZW50IHZhbHVlIChhICVzKQAobnVsbCkAV3JvbmcgbnVtYmVyIG9mIGF0dHJpYnV0ZXM6ICVsaSAoZXhwZWN0ZWQgJWxpKQBPY3RldDpwYXN0ZSBuZWVkbGUgc2l6ZSAoJWkpIGV4Y2VlZHMgaGF5c3RhY2sgKCVpKQAodmFyYXJnKQBpbnZhbGlkIGZvcm1hdCAodG9vIGxvbmcpAE9jdGV0IGlzIG5vdCBhIHZhbGlkIEVDUCAocG9pbnQgaXMgbm90IG9uIHRoaXMgY3VydmUpAChmb3Igc3RhdGUpAChubyBuYW1lKQBtb2R1bHVzIGNhbm5vdCBiZSBhIGRvdWJsZSBiaWcgKGRtb2QpAD0oZGVidWcgY29tbWFuZCkAPShsb2FkKQB0b28gbWFueSAlcyAobGltaXQgaXMgJWQpACVzIGV4cGVjdGVkICh0byBjbG9zZSAlcyBhdCBsaW5lICVkKQB1bmZpbmlzaGVkIGxvbmcgJXMgKHN0YXJ0aW5nIGF0IGxpbmUgJWQpAEVycm9yIChnZW5lcmljKQBTdWJ0cmFjdGlvbiBlcnJvcjogYXJnMSBzbWFsbGVyIHRoYW4gYXJnMiAoY29uc2lkZXIgdXNlIG9mIDptb2RzdWIpAG9jdGV0IGxlbmd0aCBpcyAldSBpbnN0ZWFkIG9mIDY0IChuZWVkIHRvIHVzZSBzaGE1MTIpACgwLzApAG5hdCgwKQBwaSA+PSBwbC5vdnBfcG9seV9wYWQoMCwgMCkACgkoLi4udGFpbCBjYWxscy4uLikAbWFsZm9ybWVkIG51bWVyYWwgaW4gZGlnaXQoKQBWLT52X1tpXSAhPSBGLnplcm8oKQBkeCAhPSB6ZXJvKCkAZGVwdGhfdWIgPT0gbG5vZGVzLnNpemUoKQByZW5hbWVkX2F0X2Quc2l6ZSgpID09IGxub2Rlc19hdF9kLnNpemUoKQBldmVuIEEgaW4gaW52X21vZF9iKCkAYXR0ZW1wdCB0byBsb2FkIGEgJXMgY2h1bmsgKG1vZGUgaXMgJyVzJykAICglcyAnJXMnKQBtYWxmb3JtZWQgcGF0dGVybiAobWlzc2luZyBhcmd1bWVudHMgdG8gJyUlYicpAG1hbGZvcm1lZCBwYXR0ZXJuIChtaXNzaW5nICddJykAbWFsZm9ybWVkIHBhdHRlcm4gKGVuZHMgd2l0aCAnJSUnKQAgKABtaXNzaW5nICd9JwBtaXNzaW5nICd7JwB1bmZpbmlzaGVkIHN0cmluZyBmb3IgZm9ybWF0ICd6JwBpbnZhbGlkIGtleSB0byAnbmV4dCcAd3JvbmcgbnVtYmVyIG9mIGFyZ3VtZW50cyB0byAnaW5zZXJ0JwBDT05GLmRlYnVnLmZvcm1hdD0nY29tcGFjdCcAaW52YWxpZCBjb252ZXJzaW9uICclcycgdG8gJ2Zvcm1hdCcAaW52YWxpZCB2YWx1ZSAoJXMpIGF0IGluZGV4ICVJIGluIHRhYmxlIGZvciAnY29uY2F0JwAlcyAnJXMnAGludmFsaWQgb3B0aW9uICclcycAZnVuY3Rpb24gJyVzJwA8Z290byAlcz4gYXQgbGluZSAlZCBqdW1wcyBpbnRvIHRoZSBzY29wZSBvZiBsb2NhbCAnJXMnAHVua25vd24gYXR0cmlidXRlICclcycAbmFtZSBjb25mbGljdCBmb3IgbW9kdWxlICclcycAYXR0ZW1wdCB0byBhc3NpZ24gdG8gY29uc3QgdmFyaWFibGUgJyVzJwBhdHRlbXB0IHRvICVzIGEgJyVzJyB3aXRoIGEgJyVzJwBpbnZhbGlkIGNvbnZlcnNpb24gc3BlY2lmaWNhdGlvbjogJyVzJwBpbnZhbGlkIGNvbnZlcnNpb24gc3BlY2lmaWVyICclJSVzJwBDT05GLmV4ZWMuc2NvcGU9J2dpdmVuJwBDT05GLmV4ZWMuc2NvcGU9J2Z1bGwnAGludmFsaWQgb3B0aW9uICclJSVjJyB0byAnbHVhX3B1c2hmc3RyaW5nJwBtaXNzaW5nIHNpemUgZm9yIGZvcm1hdCBvcHRpb24gJ2MnAGludmFsaWQgZm9ybWF0IG9wdGlvbiAnJWMnAEpTT04gcGFyc2VyIGJyYWNrZXRbJXVdID0gJyVjJwBpbnZhbGlkIG5leHQgb3B0aW9uIGZvciBvcHRpb24gJ1gnACc8XCVkPicAaW52YWxpZCBvcHRpb24gJz4nAGF0dGVtcHQgdG8gcGVyZm9ybSAnbiUlMCcAW3NvdXJjZSAnACUAaW52YWxpZCAnLScgcG9zaXRpb25zIQBhc3NlcnRpb24gZmFpbGVkIQBwcm9vZl9sZW46ICV6dSAAZXJyb3IgaW4gAAoJJXM6IGluIAAKCSVzOiVkOiBpbiAAbHVhX2RlYnVnPiAAJXM6JWQ6IAAtKzAgAC0rIzAgAFtXXSAgAFtEXSAgAFsqXSAgAFshXSAgACAuICAgACAMCg0JCwBGYWlsZWQgdG8gYWxsb2NhdGUgcG9vbCBtZW1vcnkKACVzOiBJbnZhbGlkIHN0cmluZyBpbiBjb25maWd1cmF0aW9uOiAlbHUKAGNvbnQKAFshXSBFcnJvciBvbiB3cml0ZSgpICVsdSBieXRlcwoASW52YWxpZCBzY29wZSBjb25maWcgc3RyaW5nOiAldSBieXRlcwoAWyFdICVzCgAlczogZXJyb3IgcGFyc2luZyBjb25maWd1cmF0aW9uOiAlcwoARXJyb3IgcGFyc2luZyBjb25maWd1cmF0aW9uOiAlcwoASW52YWxpZCBjb25maWd1cmF0aW9uOiAlcwoASW52YWxpZCBsb2cgZm9ybWF0IHN0cmluZzogJXMKAEludmFsaWQgc2NvcGUgY29uZmlnIHN0cmluZzogJXMKAFplbmNvZGUgZXhlY3V0aW9uIGVycm9yCgBTRlBvb2wgYmxvY2tzaXplIG11c3QgYmUgYSBwb3dlciBvZiB0d28KAEludmFsaWQgaW50ZWdlciBjb25maWd1cmF0aW9uCgBVbmRlZmluZWQgY29uZmlnIHZhcmlhYmxlCgBsb2NhbCBfcmVzLCBfZXJyIDxjb25zdD4gPSBwY2FsbCggZnVuY3Rpb24oKSBaRU46YmVnaW4oKSBlbmQpCmlmIG5vdCBfcmVzIHRoZW4gZXhpdGNvZGUoNCkgWkVOLk9LID0gZmFsc2UgZXJyb3IoX2VyciwyKSBlbmQKAGxvY2FsIF9yZXMsIF9lcnIgPGNvbnN0PiA9IHBjYWxsKCBmdW5jdGlvbigpIFpFTjpwYXJzZShDT05GLmNvZGUuZW5jb2RpbmcuZnVuKENPREUpKSBlbmQpCmlmIG5vdCBfcmVzIHRoZW4gZXhpdGNvZGUoMykgWkVOLk9LID0gZmFsc2UgZXJyb3IoX2VyciwyKSBlbmQKAGxvY2FsIF9yZXMsIF9lcnIgPGNvbnN0PiA9IHBjYWxsKCBmdW5jdGlvbigpIFpFTjpydW4oKSBlbmQpCmlmIG5vdCBfcmVzIHRoZW4gZXhpdGNvZGUoMikgWkVOLk9LID0gZmFsc2UgZXJyb3IoX2VyciwyKSBlbmQKACVzOiBTYWlsZmlzaCBwb29sIG1lbW9yeSBpbml0aWFsaXphdGlvbiBmYWlsZWQKACVzOiBMdWEgbmV3c3RhdGUgY3JlYXRpb24gZmFpbGVkCgBJbnZhbGlkIGRpZ2l0IGluIG1heGl0ZXI6ICVjCgBJbnZhbGlkIGRpZ2l0IGluIG1heG1lbTogJWMKAEludmFsaWQgaGV4IGRpZ2l0IGluIHJhbmRvbSBzZWVkOiAlYwoASW52YWxpZCBsZW5ndGggb2YgcmFuZG9tIHNlZWQ6ICV1IChtdXN0IGJlICV1KQoAUEFOSUM6IHVucHJvdGVjdGVkIGVycm9yIGluIGNhbGwgdG8gTHVhIEFQSSAoJXMpCgBJbnZhbGlkIHJuZ3NlZWQgZGF0YSBwcmVmaXggKG11c3QgYmUgaGV4OikKAEludmFsaWQgbWF4aXRlciBkYXRhIHByZWZpeCAobXVzdCBiZSBkZWM6KQoASW52YWxpZCBtYXhtZW0gZGF0YSBwcmVmaXggKG11c3QgYmUgZGVjOikKAEludmFsaWQgbGVuZ3RoIG9mIGxvZyBmb3JtYXQ6ICV1IChtdXN0IGJlIDQpCgAZkw0KGgoACQBBwJMsCyN9BAsAjwQLAH0ECwCPBAsAgwQLAHcECwCJBAsAiQQLAIkECwBB8JMsCwh6ZW5yb29tLgBB8JcsC0VW8AoAAQAAAHzHCgACAAAA7MsKAAMAAABZlQoABAAAACp9CgAFAAAA+LYKAAYAAACBsAoABwAAAAPzCgAIAAAA5bMKAAkAQcCYLAsN8dAKAD0AAAAixQoAPgBB8JgsC/8/z5sKAAtUCgAczAoAQmYKABG9CgB0awoAGeUKAP90CgCO1AoA78AKANV5CgBybQoAHGoKAOjACgCgvQoA69cKACriCgAqxQoA03gKACJ1CgBPmAoABYcKAPJ4CgCPpgoArWkKAAvgCgA2dAoAYnkKAHFmCgA+bwoA920KAErTCgDA0woAkeMKAAqJCgCn1AoA9NcKADSdCgBF0AoAZG0KAJ/QCgCX4AoApaIKAA2JCgD6ZwoAPckKAKShCgBboQoAxKMKAHhoCgBengoANKUKABNYCgAXXwoAx2YKAHTGCgAB7AoAOVwKACCUCgA5igoAcHYKAEKGCgD6tAoAhrQKAAtqCgBj3AoAXmYKAH+ICgBcbQoAposKAOHJCgAaVQoAd6cKAJ/JCgAG0goAtaYKAESLCgAjiQoAwOsKANu9CgAgVAoAiVYKAMFoCgAhVwoABJEKAFjJCgCnvAoAUKUKADizCgB54goAC+wKAMjrCgCrvgoAq6EKAKDdCgBHiAoAjVYKAILVCgChzQoAZGcKAGS9CgCPXgoA8GgKABV1CgDrZgoA+KgKAPSoCgCHdAoAA24KAJ9yCgD6ZgoA+8cKAN3rCgDXvwoAxaEKAGOsCgAM1goAvtAKAPd0CgDglwoAl28KAHhmCgApagoAeIgKAO6TCgAjnAoA5c8KAJuVCgBm1woAcswKAG7FCgBmXAoAQcgKAHyjCgDi1AoAWn4KAFNcCgBTiAoA3JsKAJbOCgD8uQoAldMKAGdWCgAzpQoArpQKAM7rCgD3igoAIpEKAOpWCgAsnQoA/KUKAMzCCgCG4goAdnMKABPJCgCcswoAgaAKAPJSCgD+wAoAXcgKAKa6CgALxQoAppwKAL29CgDx1QoAmL0KAItfCgAhbgoAXbMKAI9vCgCOZwoAdlwKAMOJCgDcnwoAxNUKAHPKCgDw1woAbcwKAADWCgApVwoAu9QKALivCgC1iQoAKK0KAMbRCgDXyAoAhHMKALBnCgBOrQoAo3kKAObVCgAa1QoAyqEKANPACgAZvgoAPYYKAKOwCgAC1QoAY3UKACNcCgBspQoANOUKAOvGCgDSdgoASqkKAMFmCgBhjQoABrcKAIdeCgDaeAoAr6EKAA/SCgBxXQoAXlYKAKJzCgAQnQoAh9YKAOJ5CgCyvQoAheAKAEO8CgCeqgoAiM4KAI66CgDibwoADbcKAOOoCgCMrQoAT54KAIe7CgDboQoAPIsKALaVCgCMsAoADssKAC5cCgDLcwoATpUKAOnWCgA/5QoAyKkKAF9zCgAZygoAG4sKAPafCgCQiwoAk2YKABR3CgCCeQoAKFQKAK6JCgAXiQoAkVIKAEHQCgCznAoAG8wKAIh2CgAt0AoAkMwKAC6lCgCPogoArusKACGTCgCPoAoAY6cKAC6mCgAoXAoAspYKAEnGCgAFggoAS5YKAPLLCgDspgoA7JwKAB6RCgDimwoAENUKAGGVCgA2cwoAl1QKAO9oCgDHwgoAx7EKALWUCgAiyQoApaYKAF92CgAotAoAJLMKAPtUCgAMyQoA1W8KAADBCgDtlgoAyr0KAD23CgBZVQoAMW0KAJZ2CgBBVAoAZagKAOScCgD9iAoA4akKAH2bCgBuzgoAJ30KAB2KCgCFzQoAmMIKAPp1CgC/kwoAXawKAIHCCgChugoAkFQKAIBnCgBWngoAm7oKAO/WCgADWAoA89MKAHHBCgCy4goApckKAIypCgD2lQoA85AKANWWCgCoygoA0Z0KABtUCgA4pQoAo6IKALaTCgDaVwoABWAKAKhcCgB1oAoADakKAIyJCgCkqgoAVW0KAHy6CgA55QoAN+MKAFCTCgAhqgoAI7QKAIXBCgDXrwoAiNQKAMSVCgAN5QoA75IKAOCJCgBWsgoAeLMKAKpnCgBIZgoAZdEKALfQCgBnpQoAc5wKAJZ0CgBNiAoAKpwKAODHCgBfyAoAQmgKAFTjCgDBlgoAhVYKAH5oCgAedAoAkaEKAAJ5CgCOdAoAqo0KAJmjCgBB0goARakKAL+jCgDPigoAIVYKABynCgASxQoAAZYKAGF0CgDUZgoAUpYKAEuyCgBqVAoAQ8kKAAzBCgA8nAoAXYkKADy/CgDkrAoAbMoKAHhwCgDgogoA9ccKAOewCgCmigoAHqMKAKZSCgD6ogoAnW8KAOypCgDdXwoAmnMKAKTICgApkgoAcuIKAGySCgDUeAoARLIKAHzUCgA/qAoAzaUKAEvCCgDtygoAPbMKAIawCgBwVQoAw6YKAFzUCgAbwwoAGJIKAP/UCgC6dgoAe2sKANycCgCNvAoApJsKALahCgAivwoAfcoKAKLgCgAG0AoAHJMKAKXTCgCliwoAE7cKALOxCgBligoA2pUKAMZcCgBsqAoAxsAKAF9+CgDR0QoAL5AKAKrRCgCgxwoABcAKAK/CCgBMjQoA0sEKANnHCgDpVwoAldAKAKJcCgB3iQoAlNYKAGrCCgAzqAoA8mYKAIBWCgC6aAoAH9YKALBuCgDErwoA5lIKAHK9CgBt1AoAcWgKADqdCgDpqAoA7ogKAElWCgCXpQoARXQKANSSCgC50woAQ78KANiiCgA6qAoA0NUKALlVCgAT1AoA5aUKALFzCgA2jQoA9KYKAPtTCgDV6woA8IoKAFCGCgBpdAoAV2gKAJzQCgBSiQoAnsIKAMywCgDfeAoAWI0KAJpcCgB90woAXGgKAHfRCgD20QoAoFIKAPaGCgDqbAoAPbQKAEykCgCXnAoAFp0KAA7ACgAnWAoANYgKADCICgCXwQoA0coKAAy9CgBycAoAwZsKAOTrCgBb4goAAGAKAPSiCgBkeQoAJnAKAFykCgCtqQoARpMKAHm9CgBnkgoACqEKAGxVCgD+qQoAL+UKAGPGCgBGtQoAf2YKAF2yCgDtUgoAHboKAGDjCgCQjAoA98kKAKZWCgBGlgoAvq8KANNWCgC2ZwoANVQKAFyVCgAxVwoAklYKAJHOCgCfbwoAtcAKAEpoCgCvuQoAFXAKAFyLCgDJXwoApI0KAIziCgC+bQoAKW0KALVtCgALhwoAxb8KAOrBCgAYqQoAIVwKACTUCgCzzAoAZ5cKAFFWCgAwiQoAelMKAAHMCgAPdQoAYdYKAJt5CgAfwQoAmlYKABpXCgD+0QoAHtAKALvHCgCd0woAWFYKABZnCgATsgoAcbMKAEWkCgClxAoALIoKADLFCgByVAoAE8YKANzQCgCvpgoAMJMKALHrCgCPwgoA5NAKAFGbCgAUiAoAfmkKAD7GCgBwXAoAK9MKAO+/CgAypwoA44EKAEHTCgA+pQoASswKAB+9CgDqdAoAcckKALF5CgBszgoA0L8KAMzQCgDhwAoAH78KAHHCCgCLZgoAqm8KALTJCgDfZgoAW24KAGviCgCN1goAcHQKAEDFCgAknQoAVMEKAPp4CgAF1goAousKAFS8CgCtXgoAneIKAEzUCgCRUwoAzNEKAPtqCgDxrwoABKUKAEDCCgDiyAoA2lYKAKN2CgBkoAoAR1wKAC1UCgCqoQoArJsKAP91CgACpwoAeosKALi+CgALbgoAvL8KAJ3ECgB0VQoAKqcKALrQCgCA3woAI6YKACHMCgA70woAUqYKAHeyCgCTiQoA/F8KADiQCgA/mAoAHtcKAPDECgDOyQoAhaIKADKKCgBdpwoA+9UKANvHCgCeiwoAubAKAFTFCgCUoQoAsGYKAHeoCgDHsAoAk28KAHJ5CgCtXQoA97kKANHICgDtsAoA53UKAMiGCgCy0AoADXAKAEuTCgBYdQoAG6oKACCICgBFiQoATtcKAJ2wCgDmVgoA5aIKAA53CgA5tAoAYqUKAMrWCgDaXgoAKtUKANtpCgAA0goAa2cKAL1zCgAIqQoAVMYKAAShCgDT1AoASaUKAOiJCgCJ1QoAbV0KAMbJCgDEyAoAXmsKANGwCgAz1goAms0KAB60CgAuagoAtmYKALCVCgDKnQoAfm4KANOlCgDrlQoAdVYKADLUCgBQVAoA2cIKANJzCgA1nQoAt1IKAFFVCgDdyAoAu5MKAO3PCgA50AoA/Z8KAGjjCgDzbAoADIIKAEuSCgCAwAoAc4sKAKfMCgBPvAoAIqcKAAd3CgAXxQoAMMkKAPXGCgDgwgoAzmYKAK9tCgBicAoA8MkKAJeLCgBZ0AoAjaMKAIW9CgBs4AoAjtMKAI7FCgDyeQoApNEKAEfBCgBh1AoA4aEKAPVUCgAAvQoAHV8KABS+CgBedQoAqXkKAMPWCgAl1QoAeMEKAOrrCgADpgoAOpMKAAaWCgDKlQoATOUKAB7UCgAKnQoAmm0KADjGCgDceQoAoVMKABB2CgDknwoAVNcKAIi6CgDFbgoAYFUKAAqSCgCoXgoABWoKAPHUCgDseAoAftEKABFuCgBVkAoA55UKAKKgCgC5bwoA/ogKAFi6CgAFiwoA94kKAKLWCgD1VQoAlogKAAvVCgCpsAoAUGcKAPt1CgC/vQoA3qgKAMfUCgCY4AoA6q8KAOloCgDgUgoAMLQKABRwCgBIlQoAWHMKACuTCgCCngoAlZQKAAugCgAgsgoAbaQKAPZqCgBbkwoAT8UKAKNUCgBNXAoALlgKAL7WCgCLyQoAwlwKANNeCgBJyAoA/VcKACDVCgAcxgoA/JUKAHOHCgAZwQoA46YKAM9mCgDYpQoAOIYKAEyJCgAS5QoAoswKADigCgD1ygoAQYgKAEfdCgATVQoAJGoKAAvKCgB4VAoAu2cKAKfWCgBZ1woAFNQKANebCgAQ7AoASlcKACDKCgD/xAoAc6QKAFaoCgB6eQoAANAKAP2/CgDKwQoAXMYKAAh1CgBqwQoAr7wKAOLBCgBQswoA1NAKAE7ICgCmwgoAO14KAL3ACgAuiAoAVVQKAMZtCgAmdAoAYaEKAC7MCgDQbgoAFKgKAL10CgBJVAoAXcAKAPGKCgB7bQoANmYKAAtVCgDuxwoATHQKAJHRCgBHxQoAkqQKAPB0CgByZwoABJQKAFhnCgB+vwoAF70KAImWCgCb1goAasAKANC9CgC3ogoAnVQKAKpzCgBOkAoA0ZAKAJZSCgCqdgoATH4KAMdWCgC0pQoAJeUKAFScCgBWzAoA9VcKAFpWCgCCzgoAx9MKAPWSCgDayQoAaogKAE+pCgBzZgoApZQKAPGfCgBukwoAEJIKAAxcCgCqqgoAy9cKAAtYCgDs1QoAd6IKAOd4CgBRbwoAfp4KAMu/CgAEngoAhK0KAKXQCgBO0AoADqoKAMleCgBS5QoAO6YKAJ2ICgC6jQoANFwKAIvMCgAXkwoAqM4KAGCSCgB/zQoArYoKADacCgAasgoAaFUKAGDlCgAGYAoA1ZUKAHZuCgAdiQoArFIKAM+NCgC2ugoARZYKAMS9CgArwwoAbXAKAL65CgBYqAoAOtYKAKzECgDPlgoAJtYKAGewCgBDfgoA99QKAFmWCgC8iQoAwKUKANWQCgAXUwoAhlUKANrBCgBU0AoALHAKAA5wCgBozAoAOuUKADhvCgC4qQoAn5sKAEfXCgBGZwoA/sgKAIC9CgDA1AoAY+AKAC+gCgAGigoAkKgKAHyqCgB24woA8VYKAPW0CgDPkgoAOlUKAInUCgCMzQoAAb0KAEemCgAJVwoAJdAKAA2QCgBckAoASrMKADpUCgDcgQoAs8cKAGjgCgCD4woASnMKAPvXCgCppQoAH50KAFyICgCGzAoAcKcKAECgCgD5zwoAoMAKAGeVCgBsmwoAvKYKAIDJCgDYygoAMLMKAJ+cCgCGxwoAfXMKABXQCgDzqAoA7XkKAA6KCgAeswoAKqgKAIGwCgB9XQoAyokKABuhCgBKvAoAwl8KAGigCgC0xAoAIXYKAEvjCgBxqAoA++sKABpcCgAcbgoAKJAKAO5UCgBvlwoAIGEKAEFcCgC0zAoAym4KAIpUCgDXsAoA3c8KAPymCgBb1QoAV8oKAP1vCgDSqQoAnJsKAFrjCgDh1QoAI6EKADuICgARvwoAvcoKAHqHCgBKVQoA4ngKAHjMCgCEXQoAWtgKANHCCgDTyQoAKKYKAOJXCgDnoQoA+2wKAO6GCgAgWAoA74kKAN2vCgCllgoAFqcKAAbFCgAatwoACZQKAEyLCgBolwoA6IYKAPScCgDNwAoA+7wKAJXMCgBRsgoArJwKAPnICgCzVgoAg8oKADOhCgDSoQoAgOIKAGxmCgB5pgoAUboKAEJVCgB/rwoAkr0KAMzICgCQnAoAjl4KAABTCgAfmgoAlsQKAAuRCgC1qgoAdt8KAFu9CgCedAoAW4sKAPVfCgCbvAoAe2cKAFRzCgAAqQoADqcKAIaJCgCDdgoAGGUKAPrTCgAAcAoA38oKAGTCCgCq0AoAEsoKAGmnCgCyrwoAfsEKABzLCgBQvwoAkLcKANHTCgC6pQoAyl4KABCRCgAGkAoAE8EKAFpmCgA4rQoAFVwKANt0CgB1zgoA98QKAJO8CgD9nAoAsnYKAEqGCgB7oAoANI4KAIqICgBqugoAMI0KAAzUCgALngoAbaUKAK1cCgDL1goAf70KAKriCgAUbwoAPNIKAOzGCgCOmwoAmccKALxWCgAZngoAqOsKAJSbCgBjwQoADpcKAKnNCgCkbwoACNUKAHeNCgChVQoAV6AKAE5tCgBHpwoAUKAKAGmzCgBNiwoAJogKAKiJCgCyZQoAidEKAE2mCgDZnQoAXokKAMuVCgDjigoAhp4KANmJCgBoxgoACnUKAGXKCgD0zwoA+IgKAELUCgCKogoAGuwKABGmCgBF4woAU4sKAN2KCgC/0QoAg2sKABOpCgCzaQoAH1MKAOh5CgB9sgoAdLAKAEZtCgChowoANJYKAPjACgC4vQoAimsKAFHUCgBXZgoABpEKAJJtCgCLoAoAGp4KAJlTCgCQpQoAXskKANaKCgDidAoADW8KAGCWCgBBcwoAesYKAPmTCgCIwgoAlqgKALyUCgA+4woAI8MKABjUCgAauAoAyJsKAGKkCgD0aQoAs6kKAESNCgAnxgoAkqMKAGqyCgBW5QoAPNQKAFFzCgBj4goAZMAKAJ1cCgC4wgoAj84KAPipCgDOswoAk80KALyiCgBFcwoA3WoKAMOQCgCGyQoABdQKAMvVCgBiVgoAs6MKAGqQCgD+lgoAoJcKAAXLCgC8ZgoAEpQKADJVCgAGUwoAUY0KAD+JCgDY0woAesIKAC50CgA9jQoAhsUKAGxrCgD5UgoAVmsKAOHTCgCY0QoAsVUKAD1qCgC5UwoAdJYKAN+/CgA1vAoAyKIKAL15CgDY0QoAiG8KANCiCgC1dAoAVb8KACO6CgAOUwoAuYoKAD10CgCC1AoAb9EKAG/jCgDptwoA6qMKACaTCgDkwQoAiJwKAESzCgBWpQoA7VUKAJXCCgCpUwoAW8EKAAbBCgCSsAoAOGYKAOfICgBs1woAE1QKAK2gCgAVigoA9ZYKAIeqCgCEbgoAm1IKAEq/CgCybwoAqpYKACfUCgDlrAoAGJEKAFaVCgCjpQoAEZ0KAHvCCgDNVgoAEpMKAGOzCgBwogoAZs4KAGDXCgB7xQoACcAKAGyLCgD+nQoAAWAKAK2GCgA7XAoAZ6gKAIKWCgA1pgoA59YKABulCgCKvQoALMYKAK7UCgB7ygoA4NEKAKZ0CgBwoQoA2sAKALSbCgC5cgoAcpAKAMR0CgBMXgoAv8IKAJS6CgDsVgoAHZ0KACaQCgDf1QoA37wKAIyNCgDiXwoAhWsKABeeCgD2iAoAGnYKADrUCgAlaAoAIsUKAMa+CgD8ygoAAWcKAO3RCgC7wQoA8G0KADnFCgAIdgoA75UKAIabCgBeqAoA7l8KAOrUCgCpogoAROUKAOmbCgDi0woAc7MKAJnRCgCJzgoA/ckKAO9vCgDP1woAFbcKAPppCgBRyQoA5KgKAIimCgBbpgoAcYkKAF7gCgCkZwoA/2kKAIRmCgCMcwoAhtMKACS6CgCbzAoA3KEKAE/BCgD2vwoA77EKAIPVCgALvwoAQaYKAD6QCgDH0AoAyrMKAPTICgDjlQoAWFwKAAinCgBS4AoAXsoKAIt5CgBh0AoAnqUKAHHgCgDIlgoA3pYKADluCgAYvwoAv8gKAHnJCgBr1goAQlcKAKetCgDn0QoA7s4KAK29CgByXAoANcwKAIagCgCtxQoA0YkKAOjHCgC4yAoAuKMKADPTCgD4eQoAdJsKADxmCgCmkwoA6p8KAKZpCgDs5AoAB+wKADazCgB7lgoAA3YKANjVCgAvcwoAR5gKALBTCgBr3woA56kKAAptCgCudAoAfKQKAGKQCgBxiAoAxMEKACLTCgBmgQoAsdMKAMyaCgAFyQoA+ZEKAPidCgC7XwoAfnAKABVfCgCfxQoA/N4KAIekCgBuugoABdcKAFxwCgCoxwoAWpMKAH+JCgCBqgoAT8YKANVpCgDckgoAPGgKAJuNCgAGvQoA/5IKAMizCgADygoAD1cKAF23CgCTqgoAk9EKAHzOCgDcbwoAxZ0KADhtCgDNqQoAwVYKAGqJCgDJkAoAZckKAErSCgAxtQoAEZ4KAP+JCgDnvwoAeV0KADC8CgB6wAoAcLIKAJWtCgBnpAoAg5wKAFFoCgDvowoAUeUKAOqiCgBokwoAk40KAP/TCgCe0QoABnAKAJ6iCgBdoAoA72kKAM5eCgCXsAoA/qQKAONoCgC6yQoAUMwKANCvCgAirQoAgMwKALGTCgB2ugoAxF4KAKyTCgAtjgoAR6gKAAmqCgAV7AoAG3AKAL2QCgA0iwoAdNcKAOSWCgAmvQoAgMYKAEe0CgCalgoAhFQKAMxnCgAkowoAYtUKAAWSCgDv0QoAkK8KACzUCgCAxQoAHKgKAM+VCgBIrQoATqgKAHDfCgCBpAoAGdYKAGXFCgDn0woAs40KAGLMCgBInAoAvm4KAEtvCgBcpQoAa4cKAJ+WCgD0ZwoAumkKAJRcCgB34AoA/7YKAOlVCgB0xQoAO7wKAPOlCgAVywoAK6EKAIK6CgDgzgoAAXoKAAyTCgBl1goAtGgKAPC/CgBrXAoAPK0KABemCgCyogoAX5MKAIGVCgCNqgoAVqQKAAi1CgADqgoAfrMKAG7GCgCtowoApVQKAKG8CgA5VwoA33MKAFvMCgB/tAoA58kKAGptCgBkugoA5coKAO7ICgDTdAoARG8KAF9cCgDFeQoAP7IKAASgCgCqjAoA7ZAKAIZnCgB5bgoA/ooKAN+VCgBvVgoAq3IKALOKCgCsVgoAqsgKALfECgBJ1AoArcwKAFLCCgBo1QoA7lcKAHd0CgDUnAoADV8KAAaTCgCXkwoAnqEKAP6QCgDZcwoAIHAKAJSiCgACtQoAY7IKAJXUCgDXowoAvaEKAP+RCgCwogoA7MsKAK3JCgDmuQoAmaUKAD9tCgDcqQoAvakKADPGCgDEcwoA7qgKAC2/CgCelAoAc60KAIazCgDvogoAd6QKAA2eCgCobQoAZn4KAGdrCgCZoQoAX2cKABNlCgDCqQoA9XUKALLICgB5ngoABFUKAF/FCgAQXAoAkrcKAG1+CgDNbwoAj9AKAGu9CgCVXgoAKeUKAH2NCgCTcwoAhNEKAKyLCgAXbgoAH5AKAIrICgB7VgoANpMKAEHdCgDPvQoAN8kKAJ5nCgCjlQoAvFwKABOLCgBFxgoAY4sKAG9zCgBJngoAGZQKAH5eCgBvxgoAsb4KAPVvCgCuowoAyq8KAGOSCgCk4goASskKACqzCgCTlQoAW8IKAM54CgDLpgoADmcKANvUCgAqiQoAq5UKACZWCgDerAoAsdEKAInjCgB84woABJ0KAKGMCgChkwoA4bAKAMalCgB4XAoACnYKAIrQCgAT1goAJKgKAGfUCgCYqgoAsosKAJmiCgBBkwoAE1cKAMXKCgDyqQoA1r0KAKBWCgA9cwoAZmYKAISvCgB0VAoAV9QKAHeXCgDmygoAu+sKAAqmCgAZWAoA8ZUKACnJCgAsvQoAilMKAKvTCgAxnAoA5WYKAOqTCgAGxgoAn6gKAOFWCgDy6woA+ssKAGzFCgCvygoAW4kKAH+NCgCOlQoAA4kKAMjWCgDzVQoAaKEKAAe+CgDtbgoAJ8EKALyVCgAUqgoAQ6UKAJamCgCEpQoAmcAKALfRCgC81goAjpYKAMmKCgClcgoAk6AKAK7MCgDwzgoAAsEKAGXcCgCCowoAk3kKAJimCgADVAoAzW0KAKagCgDAvgoAxdcKABJYCgAzvQoAEqAKAMCwCgAaiAoAwnYKAJlnCgD9bQoAtcoKAIhwCgCPiAoAE8MKAA6+CgAg5QoA01cKAEmbCgAtVQoA3qUKACegCgAIzAoAoG0KAMp2CgCrVAoAiJUKAPBfCgAN0AoA5s4KAHycCgCApgoAnXYKAI/rCgC4bgoAnqYKAN2mCgAv1woAfqgKAO3TCgBn1woAwpQKADrICgBFvwoAnM4KAKPOCgC7mwoAyG8KANepCgCNpAoAUGYKAIRtCgClxQoAn6EKAGKICgDcsAoARpIKACe/CgCgigoAqL0KAGdcCgDjrwoAk5YKAP+QCgDspQoAgYsKAEjlCgDxtwoAK9YKALXUCgBVyAoAS2cKAIRwCgAozAoA8HUKACZ2CgAdpgoAbJ4KAFnFCgBVkwoAwYoKAGrRCgBusAoASdAKAOLWCgBRpAoAMpwKALRfCgDwxgoAA7UKAJKpCgDpigoAJYoKAB3FCgDroQoARsIKALSwCgBqeQoATLoKAD6gCgCFjQoAFdUKAKijCgCi1AoAA6kKALbWCgB+VAoArK8KAJyTCgCvqgoAGskKAAhnCgC2vwoAebQKAM7UCgD5kAoA4V4KABxhCgBBtAoAiq8KALXrCgCQlAoAacYKAJqUCgBBgNksC8AK////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AAAAAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAP////////////////////////////////////8KAAAACwAAAAwAAAANAAAADgAAAA8AAAD//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////woAAAALAAAADAAAAA0AAAAOAAAADwAAAP///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////0BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQD5APzQ1Njc4OTo7PD1AQEBAQEBAAAECAwQFBgcICQoLDA0ODxAREhMUFRYXGBlAQEBAP0AaGxwdHh8gISIjJCUmJygpKissLS4vMDEyM0BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBBQkNERUZHSElKS0xNTk9QUVJTVFVWV1hZWmFiY2RlZmdoaWprbG1ub3BxcnN0dXZ3eHl6MDEyMzQ1Njc4OS1fAEHQ4ywL/QMwMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVogJCUqKy0uLzoAAABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQCRAQEAlJkBAQEAnKEApKisAAQIDBAUGBwgJLEBAQEBAQAoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAMTIzNDU2Nzg5QUJDREVGR0hKS0xNTlBRUlNUVVZXWFlaYWJjZGVmZ2hpamttbm9wcXJzdHV2d3h5egAAAAAAAP///////////////////////////////////////////////////////////////w//ChEVFBoeBwX/////////Hf8YDRkJCBf/EhYfGxP/AQADEAscDA4GBAL///////8d/xgNGQkIF/8SFh8bE/8BAAMQCxwMDgYEAv//////lPUKAD8AAAC+9QoAQABB4OcsCzU9agoAQQAAAIiGCgBCAAAAtr8KAEMAAADR0woARAAAAECWCgBFAAAAInUKAEYAAAArXQoARwBBoOgsCwW2vwoAQwBBsOgsCyWIXQoASAAAAJmiCgBJAAAAgZEKAEoAAAAfqQoASwAAABB9CgBMAEHg6CwLrwHTVwoArrEKAIGwCgB5ngoAmMkKAH92CgBwogoAi+sKAFiSCgCcxQoAAl8KAH7rCgBSoQoAlLMKAEKSCgAy5AoA+tAKAOLhCgDaqAoAl5cKAOzLCgBrdgoAP2UKAHCcCgDlswoA/YEKAJZVCgCc6woAPrUKAPKdCgAdrQoAfIYKAIrICgDJeAoA62oKAAmoCgDQ9AoA59cKAI5cCgA6sgoAJJIKAIRfCgBsngoAQmUKAEGg6iwLzQX/////////////////////////////////////////////////////////////////AAECAwQFBgcI/////////wkKCwwNDg8Q/xESExQV/xYXGBkaGxwdHh8g////////ISIjJCUmJygpKiv/LC0uLzAxMjM0NTY3ODn//////+pfCgBNAAAAelMKAE4AAACQlAoATwAAADeUCgBQAAAA7+EKAFEAAABcdgoAUgAAAMSGCgBTAAAAl6kKAFMAAACbXgoAVAAAAJmiCgBVAAAA4ZIKAFYAAADo5AoAVwAAAMv1CgBYAAAAofUKAFkAAAAa8woAWgAAANddCgBbAAAAvZwKAFwAAABFjgoAXQAAAOP1CgBeAAAAPvUKAF8AAACz9QoAYAAAAC7zCgBhAAAAd7UKAGIAAABghgoAYgAAAB6eCgBjAAAA6V0KAGQAAADLnAoAZQAAAMbiCgBmAAAAPdcKAGcAAADo9QoAXgAAALj1CgBgAAAAU/MKAGEAAAD4tgoAYgAAAGWGCgBiAAAABl4KAGQAAADQnAoAZQAAAOJdCgBoAAAA2fUKAGkAAACq9QoAagAAACTzCgBrAAAAbbUKAGwAAABZhgoAbAAAAH1cCgBtAAAA/HAKAG4AAADEnAoAbwAAADXXCgBwAAAAuuIKAHEAAABwogoAcgAAAPtVCgBzAAAAsJEKAHQAAADakAoAdQAAAJmtCgB2AAAAEmoKAHcAAAA1twoAeAAAACy3CgB5AAAAYG4KAHoAAABqbgoAewAAAM2+CgB8AAAAuoYKAH0AAAC/bwoAfgAAAElwCgB/AAAAMXAKAIAAAACwpQoAgQAAALCQCgCCAAAAo5AKAIMAAAATiQoAhAAAALLWCgCFAAAApF4KAIYAAACmiAoAhwAAAJxeCgCIAAAA62kKAIkAAAD71QoAigAAACFWCgCLAAAANr8KAIwAQYDwLAvdBDeUCgBQAAAA7+EKAFEAAADEhgoAUwAAAJepCgBTAAAAm14KAFQAAACZogoAVQAAAOGSCgBWAAAA6OQKAFcAAAAwwQoAjQAAAHKkCgCOAAAABl4KAGgAAADo9QoAaQAAALj1CgBqAAAAU/MKAGsAAABD9QoAjwAAAPi2CgBsAAAAknIKAG4AAABlhgoAbAAAAI5cCgBtAAAA0JwKAG8AAABC1woAcAAAAC7jCgBxAAAA4l0KAGgAAADZ9QoAaQAAAKr1CgBqAAAAJPMKAGsAAAA09QoAjwAAAG21CgBsAAAA/HAKAG4AAABZhgoAbAAAAH1cCgBtAAAAxJwKAG8AAAA11woAcAAAALriCgBxAAAA6pEKAJAAAABa4AoAkQAAAEheCgCSAAAA+1UKAHMAAACwkQoAdAAAADW3CgB4AAAALLcKAHkAAABvbgoAegAAABJqCgB3AAAA2pAKAHUAAACZrQoAdgAAAJtoCgCTAAAAFnYKAJQAAADNvgoAfAAAALqGCgB9AAAAv28KAH4AAABJcAoAfwAAADFwCgCAAAAAsKUKAIEAAAATiQoAhAAAALCQCgCCAAAAo5AKAIMAAACy1goAhQAAAKReCgCGAAAApogKAIcAAACcXgoAiAAAAOtpCgCJAAAA+9UKAIoAAAAhVgoAiwAAADa/CgCMAAAAQ54KAJUAAAA3dgoAUgAAALOGCgBTAAAA2JEKAJAAAACZ4woAlgAAAE21CgBpAAAAVm4KAJcAAACupQoAgQAAABGJCgCEAAAAr9YKAIUAAACjiAoAhwAAAOBpCgCJAEHw9CwLfepfCgCYAAAASLoKAJkAAADyUwoAmQAAAEa6CgCaAAAAd40KAJsAAADnbgoAnAAAAGGHCgCdAAAA+vAKAJ0AAAAL4AoAngAAAOjkCgCfAAAAeKMKAKAAAACswAoAoQAAAJ7ICgCiAAAAtX4KAKMAAAC4sQoApAAAAMGxCgClAEGA9iwLlQHSxwoApgAAAFu9CgCnAAAA0coKAKgAAABGugoAmgAAAM1TCgCaAAAAknIKAKkAAAAL4AoAngAAAHxeCgCqAAAAKV0KAKsAAAAA4AoAngAAAOjkCgCfAAAA3eQKAJ8AAAB4owoAoAAAAGSjCgCgAAAA6pEKAKwAAADYkQoArAAAAJnjCgCtAAAATbUKAK4AAAC4sQoApABBoPcsC1XqXwoArwAAAGGHCgCwAAAA+vAKALAAAADnbgoAsQAAAEi6CgCyAAAA8lMKALIAAADBsQoAswAAAPiICgC0AAAAz5IKALQAAAAMiwoAtAAAAMnACgC0AEGA+CwLrQHSxwoAtQAAAFu9CgC2AAAARroKALcAAADNUwoAtwAAAJJyCgC4AAAANYYKALkAAACBrQoAugAAACmGCgC7AAAAcK0KALwAAAAdhgoAvQAAAGStCgC+AAAAC+AKAL8AAAAA4AoAvwAAAOjkCgDAAAAA3eQKAMAAAADqkQoAwQAAANiRCgDBAAAAeKMKAMIAAABkowoAwgAAAJnjCgDDAAAATbUKAMQAAAC4sQoAxQBBwPksC50C6l8KAMYAAAD8cAoAxwAAAImnCgDIAAAAfqcKAMkAAADqkQoAygAAAAvgCgDLAAAA6OQKAMwAAAB4owoAzQAAAFPVCgDOAAAAXmAKAM8AAACphgoA0AAAAIJ4CgDRAAAAioAKANIAAABDowoA0wAAAENgCgDUAAAAlYYKANUAAAC3uQoA1gAAALPkCgDXAAAAf9YKANgAAABwogoA2QAAAA5gCgDaAAAAs60KANsAAADEZwoA3AAAAIRTCgDdAAAAxlMKAN4AAAB8lQoA3wAAAEheCgDgAAAAE4kKAOEAAADoiwoA4gAAAM3fCgDjAAAAM9UKAOQAAACJvwoA5QAAAKPkCgDmAAAAOKMKAOcAAAAxYAoA6AAAAD29CgDpAEHw+ywL/QGScgoAxwAAAAZeCgDqAAAAjqcKAMkAAAAA4AoAywAAAN3kCgDMAAAAZKMKAM0AAABR1QoAzgAAAFxgCgDPAAAA2JEKAMoAAABWbgoA6wAAAHi/CgDsAAAAN3YKAO0AAACCeAoA0QAAAIqACgDSAAAAUmsKAO4AAABOjAoA7gAAAEOeCgDSAAAAqYYKANAAAABDowoA0wAAAENgCgDUAAAAlYYKANUAAAC3uQoA1gAAALPkCgDXAAAADmAKANoAAAA8iQoA7wAAALOtCgDbAAAAhFMKAN0AAADGUwoA3gAAAJnjCgDwAAAATbUKAMkAAABg2AoA8QAAABGJCgDhAEGA/iwLLepfCgDyAAAAknIKAPIAAADqkQoA8wAAAHijCgD0AAAAqYYKAPUAAAAiYAoA9gBBwP4sC03qkQoA8wAAAHijCgD0AAAAqYYKAPUAAAAiYAoA9gAAAJJyCgD3AAAAwF4KAPgAAABkowoA9AAAANiRCgDzAAAAmeMKAPkAAAC1XgoA+ABBoP8sC03v8goA+gAAANe+CgD6AAAAFfUKAPsAAACb1AoA+wAAACr3CgD8AAAA+/IKAPoAAAAi9QoA+wAAAEH3CgD8AAAAcKIKAPsAAAAl3woA/QBBgIAtC17qXwoA/gAAAJJyCgD/AAAAGuQKAAABAADS9goAAQEAALK6CgABAQAAxvYKAAIBAACwugoAAgEAADrfCgADAQAAJd8KAAQBAADv8goABQEAABX1CgAGAQAAKvcKAAcBAEHwgC0LdpJyCgD/AAAAvXkKAAgBAACA3woACQEAAPrWCgAKAQAAoJUKAAgBAAAa5AoAAAEAANL2CgABAQAAsroKAAEBAADG9goAAgEAALC6CgACAQAAJd8KAAQBAADv8goABQEAABX1CgAGAQAAKvcKAAcBAACZ4woACwEAQfCBLQuOAiAAAAAgAAAAHwAAACEAAAAhAAAAHwAAAB8AAAAgAAAAIAAAAB8AAAAfAAAAHwAAAB4AAAAgAAAAIAAAAB4AAAADnwoADAEAAMmfCgANAQAAd40KAA4BAACeyAoADwEAAAKHCgAQAQAAIGkKABEBAABlaQoAEgEAAAxpCgARAQAAUWkKABIBAAD0aAoAEQEAADlpCgASAQAAzJoKABMBAADy5AoAFAEAABusCgAUAQAArMAKABQBAADFnQoAFQEAANNXCgAWAQAASOIKABcBAADc3goAGAEAADPiCgAZAQAA9d4KABoBAADF3goAGwEAAClVCgAcAQAAvlIKAB0BAACxUgoAHQEAAAvgCgAeAQBBkIQtC07V9QoAHwEAAIZoCgAgAQAACbgKACEBAABEWAoAIgEAADVYCgAjAQAAmYkKACQBAADLdAoAJQEAADB+CgAmAQAAG6AKACcBAAC/gAoAKAEAQfCELQseD2kKACkBAABUaQoAKgEAAABpCgArAQAARWkKACwBAEGghS0LngKXngoALQEAAB6fCgAuAQAAXqsKAC8BAADFnQoAMAEAAOuzCgAxAQAA01cKADIBAAD2swoAMwEAADWeCgA0AQAAU6wKADUBAACNngoANgEAABSfCgA3AQAAUqsKADgBAAAGqwoAOQEAALqqCgA6AQAAJuIKADsBAAAO5AoAPAEAAK6eCgA9AQAANZ8KAD4BAAB5qwoAPwEAAB+rCgBAAQAA06oKAEEBAAAO4goAQgEAAPbjCgBDAQAAoZ4KAEQBAAAonwoARQEAAGqrCgBGAQAAEasKAEcBAADFqgoASAEAAP3hCgBJAQAA5eMKAEoBAADMiAoASwEAAEzDCgBMAQAAqVcKAE0BAADBnwoATgEAABOsCgBPAQAAS6wKAFABAEHQhy0LJg2fCgBRAQAAA58KAFEBAADJnwoAUgEAAMWdCgBTAQAA01cKAFQBAEGAiC0LTupfCgBVAQAA/HAKAFYBAADqkQoAVwEAAAvgCgBYAQAA6OQKAFkBAAB4owoAWgEAAF5gCgBbAQAAU9UKAFwBAACpvwoAXQEAADJ1CgBeAQBB4IgtC06ScgoAVgEAAE21CgBfAQAA2JEKAFcBAABWbgoAYAEAAHi/CgBhAQAAAOAKAFgBAADd5AoAWQEAAGSjCgBaAQAAXGAKAFsBAABR1QoAXAEAQcCJLQsu6l8KAGIBAAD8cAoAYwEAAE6+CgBkAQAAC+AKAGUBAADo5AoAZgEAAKm/CgBnAQBBgIotCz6ScgoAYwEAAE21CgBoAQAA2JEKAGkBAABWbgoAagEAAHi/CgBrAQAAAOAKAGUBAADd5AoAZgEAAH+iCgBnAQBB0IotC0w8FKkY1DDneQG27V/8lbp1ECVidytz+3nGVTeldl+QGApWlc5XU/LdXOQZuuS4Sosl8yHdiIbo0oVdiCUY/3GF////////////////AEGoiy0L7gEBAAAA/////wMAAAAAAAAA//////v////+//////////3///8EAAAAAQAAAFElY/zCyrnzhJ4Xp6365rz//////////wAAAAD/////ou55vpVMJIOmb71JnHmZRlnsays5skUoIFbZ85Qt4WZPvADuAAAAAAAAAADfvcQpYt+c2JAwhHjNBfCs1i4h96sgouU0SIcEHQYw3AOfCgBsAQAAyZ8KAG0BAADMmgoAbgEAAPLkCgBvAQAAG6wKAG8BAACswAoAbwEAAMWdCgBwAQAA01cKAHEBAAC+UgoAcgEAALFSCgByAQAAU1gKAHMBAEGgjS0LBpnjCgB0AQBBsI0tCz4DnwoAdQEAADFpCgB2AQAAdmkKAHcBAADFnQoAeAEAANNXCgB5AQAAyZ8KAHoBAAAbrAoAewEAAFOsCgB8AQBBgI4tCwZYvAoAfQEAQZCOLQt9QbsKADf2CgCD9vaEcUFuZHJvaWRIYW5kb3ZlcnYxWCAuEAWzqcjw3wTbQjAByLU5A/7QcbpQJMO6aXQOYtSRflgZY29tLmFuZHJvaWQubWRsLmFwcHJlYWRlclgg2Oc8cGDj6A0978JjTrBNCMZW4mBo2KVj9blFhdrhT60AQZiWLQu6C3UAAABP7QoAye8KAKwFAACjZ3ZlcnNpb25jMS4waWRvY3VtZW50c4GjZ2RvY1R5cGV1b3JnLmlzby4xODAxMy41LjEubURMbGlzc3VlclNpZ25lZKJqbmFtZVNwYWNlc6Fxb3JnLmlzby4xODAxMy41LjGB2BhYT6RoZGlnZXN0SUQAZnJhbmRvbVDxEFnrb7zmJlXfvW+DuJZwcWVsZW1lbnRJZGVudGlmaWVya2FnZV9vdmVyXzE4bGVsZW1lbnRWYWx1ZfVqaXNzdWVyQXV0aIRDoQEmoRghWQInMIICIzCCAamgAwIBAgIQR29vZ2xlX1Rlc3RfRFNfMTAKBggqhkjOPQQDAzA8MQswCQYDVQQGEwJVUzEOMAwGA1UECBMFVVMtTUExHTAbBgNVBAMMFEdvb2dsZSBURVNUIElBQ0EgbURMMB4XDTIzMDcyNjAwMDAwMVoXDTI0MTAyNTAwMDAwMVowOjELMAkGA1UEBhMCVVMxDjAMBgNVBAgTBVVTLU1BMRswGQYDVQQDDBJHb29nbGUgVEVTVCBEUyBtREwwWTATBgcqhkjOPQIBBggqhkjOPQMBBwNCAAQsgMEL9w9jvdzEHqINdqIuy6Kpf6iBG/GdVyQzsSwMHz+ZTAQ75+F90IOHKBusDDelKTYbPLNqD6w41BrAZvkDo4GOMIGLMB8GA1UdIwQYMBaAFN7zq2033p46gW4QMtArSK81inGrMB0GA1UdDgQWBBQ5e+U8UN/w16LkqeRl6nN6ntiSyDAOBgNVHQ8BAf8EBAMCB4AwIgYDVR0SBBswGYYXaHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8wFQYDVR0lAQH/BAswCQYHKIGMXQUBAjAKBggqhkjOPQQDAwNoADBlAjEAolzbim8MI5BbnT9YKmCPDBb0NrXu41h9LKl3FnxvFqK53hD+Hd0W3gcuT4ZvBgWnAjBqSIlCH5uzdLi94XWz1qsjIWupfmiVEJdK4PZZoQ6VhGm1vYDfwQWIgx2TGYGmOZhZAejYGFkB46ZndmVyc2lvbmMxLjBvZGlnZXN0QWxnb3JpdGhtZ1NIQS0yNTZnZG9jVHlwZXVvcmcuaXNvLjE4MDEzLjUuMS5tRExsdmFsdWVEaWdlc3RzoXFvcmcuaXNvLjE4MDEzLjUuMaUBWCCt9qMzA2re/EiQ3zjg9zcikIWpsLp8BxnTkkBddEYjdwJYIKChSlqhszaETY+NFI7UT9LMxm9U2HgrcPt3E/s8k/VWA1ggl7AYTt3jmct96i19J5pFaZDZ8xJGcWN4fhunZgpcCG8EWCCvC5/nJFyppZ9ksaqCzCwasThvd5Vkk4Nil8ioTSrgtABYIA2YVNtRSG/0SQe8YU/66pPa4aierUAmP5Aa5s5BJkYhbWRldmljZUtleUluZm+haWRldmljZUtleaQBAiABIVggwxSnq7oH5A5krofbStlxgBP9OY5uIxezBPV/yazKufUiWCDtuLAjDMyY3ULN/4mo0eJf+NGn+jiektyPAa+YWnnvzGx2YWxpZGl0eUluZm+jZnNpZ25lZMB0MjAyNC0wMS0yNVQyMToxMjo1OVppdmFsaWRGcm9twHQyMDI0LTAxLTI1VDIxOjEyOjU5Wmp2YWxpZFVudGlswHQyMDI0LTAyLTI0VDIxOjEyOjU5WlhAZwB76ZWj50OUXE+xxYronXLUlzGCUdnxl08I5ROJyG1AEQFIj8N+ZlVGSVPFHE+MZLlgE6GrBKmmW4D9Lztco2xkZXZpY2VTaWduZWSiam5hbWVTcGFjZXPYGEGgamRldmljZUF1dGihb2RldmljZVNpZ25hdHVyZYRDoQEmoPZYQM+wrBpjGwbhtdUDFvpD2rI4hqJrZ2wzurRSY0y639Gzq9G9el48NpfefOH8AEqQ3oTgYmT+lXiBmKzcPkxXXVlmc3RhdHVzAEGwvS0LfUG7CgA39goAg/b2hHFBbmRyb2lkSGFuZG92ZXJ2MVggLhAFs6nI8N8E20IwAci1OQP+0HG6UCTDuml0DmLUkX5YGWNvbS5hbmRyb2lkLm1kbC5hcHByZWFkZXJYINjnPHBg4+gNPe/CY06wTQjGVuJgaNilY/W5RYXa4U+tAEG4xS0L3Qt1AAAAJe0KAMnvCgDQBQAAo2d2ZXJzaW9uYzEuMGlkb2N1bWVudHOBo2dkb2NUeXBldW9yZy5pc28uMTgwMTMuNS4xLm1ETGxpc3N1ZXJTaWduZWSiam5hbWVTcGFjZXOhcW9yZy5pc28uMTgwMTMuNS4xgdgYWE+kaGRpZ2VzdElEAmZyYW5kb21QUtg97twL9mIFg1zMFq1oLXFlbGVtZW50SWRlbnRpZmllcmthZ2Vfb3Zlcl8xOGxlbGVtZW50VmFsdWX1amlzc3VlckF1dGiEQ6EBJqEYIVkCJzCCAiMwggGpoAMCAQICEEdvb2dsZV9UZXN0X0RTXzEwCgYIKoZIzj0EAwMwPDELMAkGA1UEBhMCVVMxDjAMBgNVBAgTBVVTLU1BMR0wGwYDVQQDDBRHb29nbGUgVEVTVCBJQUNBIG1ETDAeFw0yMzA3MjYwMDAwMDFaFw0yNDEwMjUwMDAwMDFaMDoxCzAJBgNVBAYTAlVTMQ4wDAYDVQQIEwVVUy1NQTEbMBkGA1UEAwwSR29vZ2xlIFRFU1QgRFMgbURMMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAELIDBC/cPY73cxB6iDXaiLsuiqX+ogRvxnVckM7EsDB8/mUwEO+fhfdCDhygbrAw3pSk2Gzyzag+sONQawGb5A6OBjjCBizAfBgNVHSMEGDAWgBTe86ttN96eOoFuEDLQK0ivNYpxqzAdBgNVHQ4EFgQUOXvlPFDf8Nei5KnkZepzep7YksgwDgYDVR0PAQH/BAQDAgeAMCIGA1UdEgQbMBmGF2h0dHBzOi8vd3d3Lmdvb2dsZS5jb20vMBUGA1UdJQEB/wQLMAkGByiBjF0FAQIwCgYIKoZIzj0EAwMDaAAwZQIxAKJc24pvDCOQW50/WCpgjwwW9Da17uNYfSypdxZ8bxaiud4Q/h3dFt4HLk+GbwYFpwIwakiJQh+bs3S4veF1s9arIyFrqX5olRCXSuD2WaEOlYRptb2A38EFiIMdkxmBpjmYWQIL2BhZAgamZ3ZlcnNpb25jMS4wb2RpZ2VzdEFsZ29yaXRobWdTSEEtMjU2Z2RvY1R5cGV1b3JnLmlzby4xODAxMy41LjEubURMbHZhbHVlRGlnZXN0c6Fxb3JnLmlzby4xODAxMy41LjGmAVgga27j1JcTZrLaiV+LebAINdTrnjZ7ogAhBjnJoiTVYZEAWCCXHpSzNFa7RdF+muVYo1FfaLRmJyKy7jwgmJFSwq3AcQRYIGQKMq4+6icw4dsRJ1bsZQCiq+4r5udQ4jw4t1Un8Y83BVggKH5QS9NcD4+oI5FmUNPIqY04QVDnlfYqEUTaRcCRITsDWCDRf4j2F3mqwKEA0N2g3UWFvXss5ZkiR/PtT9zXHZz6zAJYIJYiotn+Auy+PGMdmruUBfUI7dD0Pl8SUcnX+HnmlstgbWRldmljZUtleUluZm+haWRldmljZUtleaQBAiABIVggxU6Avaih4bqSZsvnTHpzz3kI4phYI8kanLH+V5hSnfsiWCAawy9cAk3Xp4YdKriXVDoeF5cEd6vTiGOluN4iM9HblWx2YWxpZGl0eUluZm+jZnNpZ25lZMB0MjAyNC0wMS0yNlQxNTozMjo1MFppdmFsaWRGcm9twHQyMDI0LTAxLTI2VDE1OjMyOjUwWmp2YWxpZFVudGlswHQyMDI0LTAyLTI1VDE1OjMyOjUwWlhArIeqAmC4NiKdHqKFLzyjKqNjnSYMANqBJCK71F/CBTcI/3BQ3swt/P06uv7qPWjlFLUk5MLu+K0o7NMUIfufj2xkZXZpY2VTaWduZWSiam5hbWVTcGFjZXPYGEGgamRldmljZUF1dGihb2RldmljZVNpZ25hdHVyZYRDoQEmoPZYQPKiWcwWv1wwUmhLHxZiB9WT/1sOHajBRMC26Q1Te95JOefooPokcI5aWSS5U1LWTwILWYmXHwkcof4F4ltFnYZmc3RhdHVzAEHQ7C0LboX0CgBK9QoAg/b2hHZHb29nbGVXYWxsZXRIYW5kb3ZlcnYxRAECAwR4ImNvbS5nb29nbGUuYW5kcm9pZC5nbXMudGVzdC53YWxsZXRYILDTgXl9CgZLXr7P/ZyLDxKI/IO4WcdgjpEFFDAlUSxUAEHY9C0L1xlmAAAAEO0KAMnvCgDIDAAAo2d2ZXJzaW9uYzEuMGlkb2N1bWVudHOBo2dkb2NUeXBldW9yZy5pc28uMTgwMTMuNS4xLm1ETGxpc3N1ZXJTaWduZWSiam5hbWVTcGFjZXOhcW9yZy5pc28uMTgwMTMuNS4xgdgYWGGkaGRpZ2VzdElEGB1mcmFuZG9tWCA9AmTABzdaQ2IMN8DMXIc+FTKlL10yDgXA+xdsDNm6sXFlbGVtZW50SWRlbnRpZmllcmthZ2Vfb3Zlcl8xOGxlbGVtZW50VmFsdWX1amlzc3VlckF1dGiEQ6EBJqEYIVkC3jCCAtowggI7oAMCAQICFAm9fE0tUxoseb9QNilAjuj9QMiJMAoGCCqGSM49BAMEMEAxDzANBgNVBAoMBkdvb2dsZTELMAkGA1UEBhMCWloxIDAeBgNVBAMMF1VMIFRFU1RJTkcgU3RhZ2luZyBSb290MB4XDTI0MDQyNjE1NDk0NVoXDTI1MDQyNjE1NDk0NVowPjEPMA0GA1UECgwGR29vZ2xlMQswCQYDVQQGEwJaWjEeMBwGA1UEAwwVVUwgVEVTVElORyBTdGFnaW5nIERTMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEzJAIQ2mUCJNskSR0onq7e2LXyQ5PbYVXcUglR27uI2axl2TTO1MOm9aocIHx2OXLyA22QKyWLuij4Dk8FMa/tKOCARMwggEPMB8GA1UdIwQYMBaAFHOnBB5QgZOe4Nu3AorjcS/QqjbBMA4GA1UdDwEB/wQEAwIHgDAhBgNVHRIEGjAYhhZodHRwczovL3d3dy5nb29nbGUuY29tMIGCBgNVHR8EezB5MHegdaBzhnFodHRwOi8vcHJpdmF0ZWNhLWNvbnRlbnQtNjYwM2M2NDctMDAwMC0yOWQ0LWFlYTYtZjRmNWU4MGQxYjkwLnN0b3JhZ2UuZ29vZ2xlYXBpcy5jb20vNDFkNDM2ODU5ZTQ1ZGJmM2U1YTkvY3JsLmNybDAVBgNVHSUBAf8ECzAJBgcogYxdBQECMB0GA1UdDgQWBBR8/YDoOD9mXJ1uK6O+9ngF9hZREzAKBggqhkjOPQQDBAOBjAAwgYgCQgH7kGn3PshnSfsrEkcqu0MXRPCIhQAayxzqtOtXXTSxKEQ9pTgRG0EO/mXq+8K0L1xgg3w4oCLhmIxF5fO3h2OgVQJCANAVKjWUFV/EWTeQJQeNOrEjKhMifxP3SeOT3SvNtvfaAMTCpW6cDCOfoHQLIitxwif0qJRiQ1gHUak6jL/toSCIWQg82BhZCDemZ3ZlcnNpb25jMS4wb2RpZ2VzdEFsZ29yaXRobWdTSEEtMjU2bHZhbHVlRGlnZXN0c6Jxb3JnLmlzby4xODAxMy41LjG4KwBYIFuiFVPmQ+Ugq96XgUGbozCeeGmSJdVjX0/jpQHHhwucAVggY0JRjrBoWpLgTS2M+P2oj6014Y13g0jCLfmBCWMpJkACWCBJvgbN9LYf4WqzSz31MI3/QirtT9nb2w6CDa33rh3PngNYIMZNVziZJlnl0jx5qvzeaqifp1F6bmPUc+igG9Rfo7rjBFggol2B2DJy020RdowCqxA6i9zWrjsyXFEazYfb5WS6YRoFWCBGbIQOQitCQ2qe9gro1Yscbier06he+ggtu7mRp3HsRwZYIAe0zFTv0B2zIpjld4thQ9Fl6+ERZRlMNO17IeRRMlNIB1ggdC/GuU1C9LUJOy4J8O0FM3AowQLYSwuD1hezXuvkfWsIWCDFwm8NP1lvlhYuvsfMrvv4op13IZ0h1vnC7GL0D3YyHglYIOz/KYuzBIkQfWeKItEMwwCTlqCkyFtCA3nEmSXNhM6ZClggg5huAdEm8E1FHPCD5x4kDjqe4iQGhvHJx3nnCT5mMJALWCBdngU9GvGGrZ30wetr7Aaqtasd8/5DWX/kkhjNBYGYmQxYIDraNqSnNOO4lzwXMtvMcWeIODsRVOr0gYtYv9n4KYMTDVggKRsYcdp5eLnE5SsabfwUKXRynegvFJZEClNytxlMjU4OWCBHS5koS/TnExx0nYUsy98ppyZFS1WWnlX+D0fUGq1d+w9YIOCY2xOEMLJswzyzFcyCDsTqS0s491pU5qZMfPCbX/LFEFgg/mi9Hd70x2D9+WsZr19af4LFJrnMZuTjeiQ9MwSRH1wRWCCRNk4WhT/+T6FQl4fYnf8SO2sfxHPp4KoHCs78vyX2mhJYIInbPpuiDrAW0oDNK+Llhtusxcg7tRCejQGj0ncebqgfE1ggm7U2CFBs4AM7iEnv1esVWOcUygV6V6DLAHhn1DyPb3kUWCAzO5socr49dtrreQ4IhlXMY3hSFxFXcZ/jjWzp98NeNxVYIOnUh04GTGTwlf+v084zLGtcMfEe/mlvOpu/bCo3aZ/3FlggZvJTpMXgyRhcKUXuLZPGQP0cVc+s9kTYp5smysQy3wwXWCB5o5EPuoRBkSejy0H8dVFn7vmfbDJVnrziXoFdbg59GBgYWCAAK0SBedne3rZysSq90e3+z/Q9MDGok5fXbSY+f2iKrRgZWCAC932sn1EIkgHseJqYPKgNYFHModqYO7jLjrfgxwKvChgaWCALDiTbp0ZIrS8cu2ZBRvcynqT+V+L6WxS2mn8+PZigEBgbWCB/jDkc581tqnXr17XNMvYc1PHd5Fq6obrfNWcclKgYQBgcWCBFUiqr/lNeBQcWgQ8Kcmt5AMX3wp3rFgt+GzjkQn8QLBgdWCCWYQ1Fnkv1abZzYs8IVf+z3XbHC2JJSM5j1ZOQomK6JxgeWCDOeaHFg3WVXgAU3E8r28M+JnlsDFsy2iNApDstyYE08BgfWCB4cW5SC8/Jd1l0iH1Bh+IM77l54Kf10cTfEefdnCHtOBggWCBfxu1xRqD044KXWRpYhrqRYvhlzPemDX633AuXs+2i3xghWCAiHeyZ+OU6/8GsNpgO3TDSRaB9noqP/vhOxEFTHWLtVhgiWCArGs3a9aU1yUP5dw0YDiluHqdIvdNcyO/+baZpZp8BTRgjWCB3bMh5VY31WzjHjr7fv4CM/kIfJOvWFhqLv/TJVHCCmhgkWCBLfg9RY76jds9Hdr1Sp3ZXKOuuHRdQwsnFuKMIszpP/RglWCANdp1IA1UWygNZXH+mDdQy/nXgiBEQFWSJZo+S0cAbyxgmWCACcBJ6tmZEV1PWElLK8F1KLyB3NcrpNJ3fNSwn6udu6BgnWCBCmpbjeVGx2JmYKIFKolJo+OtpU85Bf6mT+NFH8uDnRRgoWCD1A7kwjmNFuZ4PAcZzws8PhF4i/h93asjkHrGQWI2vahgpWCCuAl8hsgid+SFtbH1lUPM2S0IZex8/4mNy3JwMp+MMCBgqWCA+zZLEnD/uGEGppdduntXw/QYicpjnh20lwfYfebQ3wHdvcmcuaXNvLjE4MDEzLjUuMS5hYW12YacAWCC5PQWUr5b+dxrIeX+edXb406fTFDF6fGwpMrzh9N5PZAFYINg2VCMHL3O/YohGINi23CeyJ+ZWx9ayXrDWyNXiXEpEAlggwctPmqQbL5uhejOvhqy8RxbzjviRnxnZivwzfEFf5h0DWCBF25yPCuNDCQ8qOQeeiaRq+7SHG8jHcERiwPQ1SCd0gARYIDcPJiBngxyFHXeEsTlec56PoCXhi5I336cQBYdutIsGBVggjLakBQb3sQEgMkaV7yAVrUW+kzMUt16islDWi6lz0AkGWCDpAEAC+VnI4YAtm7KVbsAHWBhu0QJhlKE8xnlWNEps1W1kZXZpY2VLZXlJbmZvoWlkZXZpY2VLZXmkAQIgASFYINgDQJ0QYHXrRYPhypStVCtXefHoZKjSRoGhpi47UNvTIlgg1mY/J3ZmaAJqJQye0su73ddX4wOK6vEHj9q10rGCa6BsdmFsaWRpdHlJbmZvo2ZzaWduZWTAdDIwMjQtMDUtMDNUMDc6MDA6MDBaaXZhbGlkRnJvbcB0MjAyNC0wNS0wM1QwNzowMDowMFpqdmFsaWRVbnRpbMB0MjAyNS0wNS0wM1QwNzowMDowMFpnZG9jVHlwZXVvcmcuaXNvLjE4MDEzLjUuMS5tRExYQPs3d9m/LSUm4w2N9FngnnBIKECNYKfBPBTpT+Q9817ir4bpYIfwQBvQpy9uRRbfqZ2x8bctpbc5T4Ym4ZhZJ69sZGV2aWNlU2lnbmVkompuYW1lU3BhY2Vz2BhBoGpkZXZpY2VBdXRooW9kZXZpY2VTaWduYXR1cmWEQ6EBJqD2WEDv3ragkYVfkRxflGjQT+Ob7v88nrQySsR2ml6BLVJFO8ZI+MXgPRJnffT5a55WsMUPc3oC92tvJeJQKDSlHTFHZnN0YXR1cwBB8JsuC5cBu7oKAKnzCgCD9vaEcUJyb3dzZXJIYW5kb3ZlcnYxWCD5PrrEzk2ZAbmupHIUWuVCH4++y+XwOJaD9Z8I/PkORVgzo2NjYXQBZHR5cGUBZ2RldGFpbHOhZ2Jhc2VVcmx1aHR0cDovL2xvY2FsaG9zdDo4MDgwWCA8eZFLf4GhwlWPyBYZ3UoHTTIUPmz2iV/kfaFW0cWwrgBB+KMuC/QYjwAAADrtCgDJ7woAZQwAAKNndmVyc2lvbmMxLjBpZG9jdW1lbnRzgaNnZG9jVHlwZXVvcmcuaXNvLjE4MDEzLjUuMS5tRExsaXNzdWVyU2lnbmVkompuYW1lU3BhY2VzoXFvcmcuaXNvLjE4MDEzLjUuMYXYGFhapGhkaWdlc3RJRBgaZnJhbmRvbVByx68mSdBaOLAufhzH+dBGcWVsZW1lbnRJZGVudGlmaWVya2ZhbWlseV9uYW1lbGVsZW1lbnRWYWx1ZWpNdXN0ZXJtYW5u2BhYW6RoZGlnZXN0SUQKZnJhbmRvbVD8io9br7QMsyF3bb9fvhiBcWVsZW1lbnRJZGVudGlmaWVyamJpcnRoX2RhdGVsZWxlbWVudFZhbHVl2QPsajE5NzEtMDktMDHYGFhbpGhkaWdlc3RJRBRmcmFuZG9tUFnN3ZHXU+2Y/1VdL5cnRTtxZWxlbWVudElkZW50aWZpZXJqaXNzdWVfZGF0ZWxlbGVtZW50VmFsdWXZA+xqMjAyNC0wMy0xNdgYWEukaGRpZ2VzdElED2ZyYW5kb21QzNxZjKmv7pX9V2g+sZr/M3FlbGVtZW50SWRlbnRpZmllcmZoZWlnaHRsZWxlbWVudFZhbHVlGK/YGFhPpGhkaWdlc3RJRBVmcmFuZG9tUKxQ9lG8BPAB0CFjhHyfHMlxZWxlbWVudElkZW50aWZpZXJrYWdlX292ZXJfMThsZWxlbWVudFZhbHVl9Wppc3N1ZXJBdXRohEOhASahGCFZAoMwggJ/MIICJaADAgECAhA1ALqb79kcudp5Bf/vGL6KMAoGCCqGSM49BAMCMDkxCzAJBgNVBAYTAlVUMSowKAYDVQQDDCFPV0YgSWRlbnRpdHkgQ3JlZGVudGlhbCBURVNUIElBQ0EwHhcNMjQwOTAyMTcyMTEzWhcNMjUwOTAyMTcyMTEzWjA3MSgwJgYDVQQDDB9PV0YgSWRlbnRpdHkgQ3JlZGVudGlhbCBURVNUIERTMQswCQYDVQQGEwJVVDBZMBMGByqGSM49AgEGCCqGSM49AwEHA0IABNwcH1XP9M1cds9BaSePchdmf4bugdhmm2Py4ZvBKgyfEjVd0Dhf7TvDO+3JeBuarUezPkwkcEuNFCiLGzy0XCijggEPMIIBCzAdBgNVHQ4EFgQUEwnOhgud/7yFmSg6HdnB81VqY/EwHwYDVR0jBBgwFoAUPMBGmQ6TQoVGbfbG4Jrj42jfKw4wDgYDVR0PAQH/BAQDAgeAMBUGA1UdJQEB/wQLMAkGByiBjF0FAQIwVAYDVR0fBE0ESzBJMEegRaBDhkFodHRwczovL2dpdGh1Yi5jb20vb3BlbndhbGxldC1mb3VuZGF0aW9uLWxhYnMvaWRlbnRpdHktY3JlZGVudGlhbDBMBgNVHRIERQRDhkFodHRwczovL2dpdGh1Yi5jb20vb3BlbndhbGxldC1mb3VuZGF0aW9uLWxhYnMvaWRlbnRpdHktY3JlZGVudGlhbDAKBggqhkjOPQQDAgNIADBFAiEAzGEtstoiYJvwqevqOakFdPrG0bDti4vgRSc+xydvZAwCIH8hRDATRVRAk1O0t0xLZFJkFYFtL8tDKVcMYtVWJytUWQbb2BhZBtamZ3ZlcnNpb25jMS4wb2RpZ2VzdEFsZ29yaXRobWdTSEEtMjU2Z2RvY1R5cGV1b3JnLmlzby4xODAxMy41LjEubURMbHZhbHVlRGlnZXN0c6Jxb3JnLmlzby4xODAxMy41LjG4IhgaWCAstz4+woTAdkPLDPXfLcCsg/iyNrOptzK2jks7ZEb1eRgcWCCbvoCFI27QNokPmwPwGFMcM7JLNLKVLebbeR85AsSmbQpYIFvepDox0XjDxy/sRMcb5RWiaJYnvi0+cVw7uk4leFM0FFggVeDgXsDW4lkg9G5kKGypgfT8uumgvL2LiToiXZSmxpQWWCDI8u9Uv6a4GWf0eLWnqe42ZPYArI0on+/WqAPREHqmsBgfWCBqk2vTSCPugyCddk0eXTinDA3yCJNxy7mETP/5tcXI7xgnWCAaQEEt8YFVLem1QXRGZgSahp+yfi1YhveplyjruLlEMAdYIDixaZC5/HbyOoUWaQooqCJ50svZbN/YieQrrL8GufBSGCVYIOeLA2MTCywM2IcDHUILydOGhwU1+xZzzNhqy4PeKhB8GCFYIImQ8Nwa3tekYTSBLEQPwIvrqvv0cr0pjfKPHGW90AffCFggdR47JO+zL3QIESsS6IbsTPYXYVYvWr1a5XHHMHIwbNkDWCBSCVcXaoIqUZRH1hUjS81rlypxVPKkaZkrLsGGKRgZWA9YIH9JLs2t6bAV8Z6WVrfLTyfZaEDu1TQmZNzSI9FWQagbE1ggnSzwU5eaIWItuROV94qvW5ySORZT2MW7QmimQIOW/igEWCD3l9/kD12aYWydJvN0IlFWoJ5hrqSkOGBoGNS9LOYYsAxYIOWVN+w456eP6ejA6KgYgefB6S8RF7Ypes/xfI500K0SCVggb3+x3zUvIy8lmsCk7jl2CToyT9GxofMVskgdQKBpfMUYGFggcFhYZqvxxftg1fSwmqiruflSKhQtw1ShHL64WPYcoUAGWCC3YCeF71UxnG7x0+pvNh2p4fAEUBPNL3Sh2CR9GnWGvhJYIMGa30ZKmyLFecBWuw5FmLiQoLsWg7cpBn+oLF5qED0tGBtYIJSX+rHLpGzkEJCfXbDq2knF8BleywMiDem6iMlhxLv4AFggWyJaocYxas/tK+ZwFe1xwtpNhz8Bov3U1i+zASM4bcgOWCDPMnSOmPtrne49SEIftfa0UCSuRoeJJXmqBeMQJGAhgBVYIHHNRnycHHoMiJUG6X4TNeD/uB/RnY1chI101wIxq/qCGCBYIIgiUYbJQcgF6v9jnaWvBKrw6a18tISxZmaUMu1l9j1SGCZYIMa6H5lm1SVRXckMSD+TJf49jQg+LFi2hZcrMItNpD4xDVggM7b8RO1oc1Q3EfXnl53v6acaG0olT5Fk9Pw3/7gASFAYHVggPh/9Nlpztp6O437ZGsJ/eaE3AKe8Lv7ArQzO0d61vr8YHlggQImhcWpK1bnQ9tUY04XVL3eiDVBGFvnFiL1gxhTNJIoRWCCCHqgLG1M78yxsD87feJ2SrOJ4yGgjBnDjQflR+hULqgFYIKWKe+OJbHKzzpTiyPgjhA7G4tDjL54nzk1R+z7hfFnXAlgg5OtrLTw201T+HuKBiSlJeYKEguMCZItC1k+J2JcCLhEXWCCjE/JstiXSUiAl8zNRF1ygmuVNpe5qdQWlQO9VPN1gKQtYIJZH8Pi8kdXCskgXtuANevsvpOePTM6jFev8AcRKoBPWd29yZy5pc28uMTgwMTMuNS4xLmFhbXZhphgZWCCmqQlcqFfAKU2BUIsm1lmnc68w/CQhWrLfkuIej+e/+wVYIPy63TXxOvFTqvFyez/Whnf8XVK778DXnRw180fW0M6MGCNYIIsJrrPWfWa54mVaT0/pDisWQmaBknwFyyeL5Utqyok+EFggm82QK2vPnahwwUhPFFMj/ISiZNQiQTdSHANTxIwiw6sYJFggD9PZiO98ZAzEg/EjywvrDEmqbt2uluwXr2ZYawUWc1UYIlggRYfjahaacdbyUfo5aGmBIp6X5kbJhDwbWhOR2wNr0sBtZGV2aWNlS2V5SW5mb6FpZGV2aWNlS2V5pAECIAEhWCBTGoa9xa6ntL/xEgjvtcWn2xsAF8Ag19n2v4ktR6YX0SJYICSscnT35qEKOVa5LlrC+KtTzYqztDgiqx0FkE87ULLWbHZhbGlkaXR5SW5mb6Nmc2lnbmVkwHQyMDI0LTA5LTMwVDEzOjUwOjAwWml2YWxpZEZyb23AdDIwMjQtMDktMzBUMTM6NTA6MDBaanZhbGlkVW50aWzAdDIwMjQtMTAtMzBUMTM6NTA6MDBaWEDJm9QT+I3T8VTlgnAQ40MUtEEtTSUa7SjaruIjNgqdzJ/pRQh+VsmlTbZ6CuPX4aYu+mPDCXRUoOeC+gV35cTcbGRldmljZVNpZ25lZKJqbmFtZVNwYWNlc9gYQaBqZGV2aWNlQXV0aKFvZGV2aWNlU2lnbmF0dXJlhEOhASag9lhAg+8ONdjFNpK3HprqTCirrNT4UB1JIYItJNHUgmsuTuUNLD01rEry35VOOilyiq23m92GxiXp1nq5DL180HrhPGZzdGF0dXMAQZDLLgvEAQ/gCgD+ugoAg/b2hHFCcm93c2VySGFuZG92ZXJ2MVg3AQZ4Uz5Hp9sS3jkaWKBTGhM+jwcU7gdfyzhK+QqxcTHOJB578HGYMrWtAqzucv1pDvNFKAlx3lhJo2NjYXQBZHR5cGUBZ2RldGFpbHOhZ2Jhc2VVcmx4Kmh0dHBzOi8vb3YyLXRkbWdwd2FtLmRlbW9zLmNvcnAuZ29vZ2xlLmNvbVggxYbvKcfwdvwVK5OFlH6CWJ1t4kOuGJDvCF/RMSsfJd0AQZjTLguyEbwAAABk7QoA7vgKAKMIAACjZ3ZlcnNpb25jMS4waWRvY3VtZW50c4GjZ2RvY1R5cGV4GmNvbS5nb29nbGUud2FsbGV0LmlkY2FyZC4xbGlzc3VlclNpZ25lZKJqbmFtZVNwYWNlc6Fxb3JnLmlzby4xODAxMy41LjGB2BhYXaRoZGlnZXN0SUQZ66VmcmFuZG9tUPriZQ5aijM5K8V0Jm9NGadxZWxlbWVudElkZW50aWZpZXJqYmlydGhfZGF0ZWxlbGVtZW50VmFsdWXZA+xqMTk5OC0wOS0wNGppc3N1ZXJBdXRohEOhASahGCFZA5EwggONMIIDEqADAgECAhM1pSqFh0SwAQhb5qpMcvjIjwSXMAoGCCqGSM49BAMDMF0xCzAJBgNVBAYTAlVUMRMwEQYDVQQKEwpHb29nbGUgTExDMQ8wDQYDVQQLEwZXYWxsZXQxKDAmBgNVBAMTH1RFU1QgVVNFIE9OTFkgR0lDSSBTdGFnaW5nIFJvb3QwHhcNMjQwMzI4MDEyMjAwWhcNMjUwMzI4MDEyMTU5WjBbMQswCQYDVQQGEwJVVDETMBEGA1UEChMKR29vZ2xlIExMQzEPMA0GA1UECxMGV2FsbGV0MSYwJAYDVQQDEx1URVNUIFVTRSBPTkxZIEdJQ0kgU3RhZ2luZyBEUzBZMBMGByqGSM49AgEGCCqGSM49AwEHA0IABFBw6BmfPF4ez2JJZimUmXYFtyBbA5/3f61Pms6zytvNwvb6BW8kI8pX+Cje0SZWva6GPyNlRWHUlK5e+p/riD+jggGxMIIBrTAOBgNVHQ8BAf8EBAMCB4AwDAYDVR0TAQH/BAIwADAdBgNVHQ4EFgQUYhvRjKVkSTcrbwz3ghesim2j3mcwHwYDVR0jBBgwFoAUn1pow+mAGd7pmCVk9rojhP+S7bQwgY0GCCsGAQUFBwEBBIGAMH4wfAYIKwYBBQUHMAKGcGh0dHA6Ly9wcml2YXRlY2EtY29udGVudC02NjAzYzY0Ny0wMDAwLTI5ZDQtYWVhNi1mNGY1ZTgwZDFiOTAuc3RvcmFnZS5nb29nbGVhcGlzLmNvbS80MWQ0MzY4NTllNDVkYmYzZTVhOS9jYS5jcnQwgYIGA1UdHwR7MHkwd6B1oHOGcWh0dHA6Ly9wcml2YXRlY2EtY29udGVudC02NjAzYzY0Ny0wMDAwLTI5ZDQtYWVhNi1mNGY1ZTgwZDFiOTAuc3RvcmFnZS5nb29nbGVhcGlzLmNvbS80MWQ0MzY4NTllNDVkYmYzZTVhOS9jcmwuY3JsMCEGA1UdEgQaMBiGFmh0dHBzOi8vd3d3Lmdvb2dsZS5jb20wFQYDVR0lAQH/BAswCQYHKIGMXQUBAjAKBggqhkjOPQQDAwNpADBmAjEA+6O48S1Yxt8gvKJqbC6cMJ4m+XWFFpVxqxHxNbBM2BkkayQ/wNyJq2VKSufJJfUyAjEA+eDUCvw1b3QtsGV+ZNfIHxJkPDnB6z5q+QzWJE6/DRq3ejgBhF8Oz8hpnHyg7/XeWQNi2BhZA12mZ3ZlcnNpb25jMS4wb2RpZ2VzdEFsZ29yaXRobWdTSEEtMjU2bHZhbHVlRGlnZXN0c6Jxb3JnLmlzby4xODAxMy41LjGtGRGeWCAOwEg+UrflsaO61y3DUxObEIPASDfgqy1iJLAx6+15jxkp+lggFGyRhTth8L2diJNh+kAj5iL+W2ogqtSgrSpYSF7foxcZPwFYIPywluBNvg7Vev6aPJTVyh8uT0L2qK62ajBac+gC9dgNGUUOWCBNVVbf6W0LTdg6A+UX4KeF5fZ0s4fcyKZsGy8HhzJEbBlLFVggWk7UtiWhZwigAu6O/fqoNGnkKOJeS/7Cw7bvfVqY06sZS/lYIB/0mcwYOsi7V84t1h2iXhPjwHHx6Wa/+MSkq3KkyTF1GWOZWCD5Pc7dIRZT2ZyKYnApEMUnV5ckaFf4Kr6c1c3AeDZWdBllkFggo/XGxHRqtZ2ujEMm+ACsJfPYRT7yFB4cTyRGEY97WboZbvtYIOGFJbZvyXKGHYTFfGAeO/ufBUyMHLa0uVChJ3+xE8eaGZTgWCClYTZPkieljPv9v3yyKRcM0Fx7EJx6pR2mdoFyuR9/VxmXvVggBNW+2H4DuQjSZHYtj43WQSthu6Q91whwi92WlE3Ezl4Z4XtYIGnLV3bhLOHgBjG9j3ZUmTRPJw9k1kXGCIh3oD+jkC6HGeulWCCZA9AqvcYSw97nUr2IYu3g44aO4qIPXcjbAxpfV9deSngaY29tLmdvb2dsZS53YWxsZXQuaWRjYXJkLjGhGTKrWCC7USxhMtA6LxO3aoQ3VYLnHfpJdomB+rr1P4Q0AWtee21kZXZpY2VLZXlJbmZvoWlkZXZpY2VLZXmkAQIgASFYIIRZJxyimU53UXt0P3b9u4F5rfExMbtIfpOb0XvH6PVDIlggaQt79j+NFGlbxdXLSoIj+3vubd0IfZ4/BvwW/+iEzoNnZG9jVHlwZXgaY29tLmdvb2dsZS53YWxsZXQuaWRjYXJkLjFsdmFsaWRpdHlJbmZvo2ZzaWduZWTAdDIwMjUtMDEtMjlUMTQ6Mzk6MjhaaXZhbGlkRnJvbcB0MjAyNS0wMS0yOVQxNDozOToyOFpqdmFsaWRVbnRpbMB0MjAyNS0wMi0xMlQxNDozOToyOFpYQBKzelXL3NoDoG6gYNJEq1saEOQpUO2E357O97+wDbD7qE6jhkMijKKRTiUfXTdl8h5FMw7nK9gFKJl2t6YbP1JsZGV2aWNlU2lnbmVkompuYW1lU3BhY2Vz2BhBoGpkZXZpY2VBdXRooW9kZXZpY2VTaWduYXR1cmWEQ6EBJqD2WEA/rhuxTA8is3Mm9E1hL1mUNTmmC+jUpo8LCmYZ6jq/VtvD4usezahlL2LF1EQ/LBvemtXZLK8WvN8OfEDYW/XzZnN0YXR1cwBBsPouC5kBnuMKAPTzCgCD9vaEcUJyb3dzZXJIYW5kb3ZlcnYxWCABAgMEBQYHCAkKCwwNDg8QERITFBUWFxgZGhscHR4fIFg1o2NjYXQBZHR5cGUBZ2RldGFpbHOhZ2Jhc2VVcmx3aHR0cDovL3JlbHlpbmdwYXJ0eS5jb21YICEiIyQlJicoKSorLC0uLzAxMjM0NTY3ODk6Ozw9Pj9AAEG4gi8LoQqRAAAAee0KAMnvCgASBQAAo2d2ZXJzaW9uYzEuMGlkb2N1bWVudHOBo2dkb2NUeXBldW9yZy5pc28uMTgwMTMuNS4xLm1ETGxpc3N1ZXJTaWduZWSiam5hbWVTcGFjZXOhcW9yZy5pc28uMTgwMTMuNS4xgtgYWGCkaGRpZ2VzdElEAGZyYW5kb21YICIxGDx9n00uLhRtJIRYtMzpSHmP2oJA02Co9A9tdUjTcWVsZW1lbnRJZGVudGlmaWVya2FnZV9vdmVyXzE4bGVsZW1lbnRWYWx1ZfXYGFhfpGhkaWdlc3RJRAFmcmFuZG9tWCDNa3djjY8mGLcvkCW4jD1jKruo3pbjky2jVm5JHxnLkXFlbGVtZW50SWRlbnRpZmllcmNueW1sZWxlbWVudFZhbHVlZzEyMzEyNDRqaXNzdWVyQXV0aIRDoQEmoRghWQGDMIIBfzCCASagAwIBAgIBATAKBggqhkjOPQQDAjApMREwDwYDVQQKEwhhYmh2aW91czEUMBIGA1UEAxMLVGVzdGluZyBrZXkwHhcNMjUwNDI4MjExMDE0WhcNMjUwNTA1MjExMDE0WjApMREwDwYDVQQKEwhhYmh2aW91czEUMBIGA1UEAxMLVGVzdGluZyBrZXkwWTATBgcqhkjOPQIBBggqhkjOPQMBBwNCAAS0aC7CDgbo34QLXdMpWXmKsgxUTU2lAQn/RoTQb9Jh/Pb46agRkRMppfZT/OxZkAkskaZbwWldKRzVHenJTn23oz8wPTAOBgNVHQ8BAf8EBAMCBaAwHQYDVR0lBBYwFAYIKwYBBQUHAwEGCCsGAQUFBwMCMAwGA1UdEwEB/wQCMAAwCgYIKoZIzj0EAwIDRwAwRAIgMQ+ax1bP+kk9L3V3qzgOnU2mketajxnrstk5oWdJH74CIEx9rN4S9pix+W6hybyhPtec1Wf0BEc9oGYFqPFJ72cBWQF/2BhZAXqmZ3ZlcnNpb25jMS4wb2RpZ2VzdEFsZ29yaXRobWdTSEEtMjU2Z2RvY1R5cGV1b3JnLmlzby4xODAxMy41LjEubURMbHZhbHVlRGlnZXN0c6Fxb3JnLmlzby4xODAxMy41LjGiAFgg/3U79sEZY/1kTMzkNVbN4YV6zf2OfmB8Ad/13D4a+/wBWCDFcCwlJjik0Ol3RM04TwwEJgeUhL6hoslL5Y+16MIoYW1kZXZpY2VLZXlJbmZvoWlkZXZpY2VLZXmkAQIgASFYIAJ6Wh+pFR9nzdLFf6+EzP2wW89ZB4dl+gt+GoIjeQ3SIlggPhcIEb7PGE02ujjbwikhfU+soPFi1VTl8UCNWcS6qgtsdmFsaWRpdHlJbmZvo2ZzaWduZWTAdDIwMjUtMDQtMjhUMjE6MDA6MDBaaXZhbGlkRnJvbcB0MjAyNS0wNC0yOFQyMTowMDowMFpqdmFsaWRVbnRpbMB0MjAyNi0wNC0yOFQyMTowMDowMFpYQCkin6XaE3xz+uHly4dboNIhPQ2+3J0IlqdFmQiDctiYg0UFuG063n6tT8k6oozVxPP/LdSJ/omacechE650+o9sZGV2aWNlU2lnbmVkompuYW1lU3BhY2Vz2BhBoGpkZXZpY2VBdXRooW9kZXZpY2VTaWduYXR1cmWEQ6EBJqD2WEBSCxe4vX6uXU59zbiM3bJOeyv2Wv5CChxIgS2XZXhCurUFdPXIKcMvpteiKNuWZNx1Ti9skBx7mpdJWfybNctMZnN0YXR1cwBB0KkvCyaJbgoAfgEAAATYCgB/AQAAbMkKAIABAAC3vAoAgQEAAHZXCgCCAQBBgKovCyPNeQoAj98KAGh1CgB43goAj94KAPPdCgC8xAoAC94KABibCgBBsKovCzfNeQoAeN4KAPSkCgCP3goAo94KALzECgDUZQoALmYKAJqkCgCXsgoAOZsKAAAAAAABAwMEBAUGAEHxqi8L0gMBAgIDAwMDBAQEBAQEBAQFBQUFBQUFBQUFBQUFBQUFBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYGBgYHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgKCgoKCwsLCw4NCwsLCwYGBAQFBQcHBwcJCAMDAwMDAwMDAwMDAwICAQEAAEoAAABLAAAASQAAAE0AAAAAAAAAstYKAEKtCgCglQoA6sEKAF26CgBh1goAQMIKAIaICgA2mAoA/5MKAGG6CgA3nQoAkKgKAIClCgDraQoApogKABp2CgDvlQoAeZ4KANa9CgBDpQoAwMkKAOX5CgDK+goAyfoKADDyCgAt8goAM/IKACryCgA28goAJ/IKAHDyCgAC8goA8PEKAObxCgAI8goA+fEKAEHari8LBQgICAgIAEHxri8LXwwEBAQEBAQEBAQEBAQEBAQWFhYWFhYWFhYWBAQEBAQEBBUVFRUVFQUFBQUFBQUFBQUFBQUFBQUFBQUFBAQEBAUEFRUVFRUVBQUFBQUFBQUFBQUFBQUFBQUFBQUEBAQEAEHUsC8LdQYAAAAAAAAA////////////////AAAAAAAAAAAICgoJCQgICAgIAAgICAgAAAAACAgICAgICAgICAgICAgICAgICAgICAgICAgIgICACAgICAgAAAQQEBAQEBAQEBAQGGhoIAAACQkBAAkgCUgoAwAAAAAAEABB2LEvCwwgAAAAdXNlcmRhdGEAQfCxLwuTAWC+CgCApQoAbaAKANzYCwAGkAoA+LYKAOzLCgA2mAoA3NgLAH7gCgBGvgoA85MKABVeCgAKXgoAmeMKAOrQCgBDngoA2JEKAADgCgDd5AoAZKMKAFHVCgC1XgoAXGAKADhgCgCv1goAo4gKALOGCgCupQoAEYkKAH+iCgDgaQoAVm4KAEXMCgA3dgoAIqUKAIPBCgBBkLMvC94CAQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAuAAAALQAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAAAAAAAAmeMKAIMBAACDwQoAgwEAQYC2LwuzAWNoCgCEAQAAMtAKAIUBAAAUiAoAhgEAADvLCgCHAQAACHoKAIgBAABj4AoAiQEAABhlCgApAAAAEXoKAIoBAAAKpQoAiwEAAD1qCgCMAQAAQJYKAI0BAACspgoAjgEAACOeCgCPAQAAtnMKAJABAACYcgoAkQEAAK50CgCSAQAALssKAJMBAAA8jgoAlAEAAE+1CgCVAQAABsYKAJYBAAAJpQoAlwEAAFbwCgAAAAAAhu8KAEHAty8LJ1uSCgCTaAoAlnQKAB5qCgBfkwoA9cAKACmjCgAitwoAOqcKANGmCgBB9LcvCyEBAAAAAgAAAAMAAAAFAAAABgAAAAcAAAAJAAAACgAAAAsAQaC4Lws+hcAKAJgBAAAzyAoAmQEAACS3CgCaAQAAj3YKAJsBAACckwoAnAEAAP/WCgCdAQAAD8wKAJ4BAACFwQoAnwEAQfC4LwuWASS3CgCd4AoAhd8KAGmnCgDlswoAoAEAACu+CgChAQAAL6kKAKIBAABtlQoAowEAAI2oCgCkAQAAXlQKAKUBAAA7ywoApgEAAEO+CgCnAQAATZwKAKgBAADV1woAqQEAAB6+CgCqAQAAJ6kKAKsBAACEqAoArAEAAC7LCgCtAQAAOL4KAK4BAAAurQoArwEAAC9vCgCwAQBBkLovCxMupQoA75UKAKPHCgAeagoAKaUKAEGwui8LkwIBggoAsQEAACJ9CgCyAQAAQ5wKALMBAAAWoAoAtAEAAIulCgC1AQAAI30KALYBAADCuQoAtwEAAPWRCgC4AQAA04sKALkBAAAgiAoAugEAADrVCgC7AQAADW4KALwBAAAstAoAvQEAAEheCgC+AQAAeJwKAL8BAACrugoAwAEAAFbgCgDBAQAARJwKAMIBAADHZwoAwwEAABegCgDEAQAABsYKAMUBAACh9goAtAEAAK+wCgDGAQAA5bEKAMcBAADqsQoAyAEAAMBeCgDJAQAA7ZEKAMoBAADzkQoAywEAAGP5CgDMAQAAcKIKAAAAAAAB3woAAAAAAImtCgAAAAAAoswKAAAAAAC6iwoAAAAAAN2LCgBB0LwvCw5wogoAzQEAAAHfCgDOAQBB8LwvCy4hqgoAzwEAALDACgDQAQAAbMgKANEBAAAmYAoA0gEAADvMCgDTAQAAisgKANQBAEGwvS8LFQYAAAADAAAAAAAAAAQAAAABAAAAAgBB0L0vCxc0pQoAcsAKALPFCgB9VQoAleIKAIrICgBB8L0vC4YBBr8KANUBAADokAoA1gEAAPqSCgDXAQAA+9UKANgBAADgdQoA2QEAAACzCgDaAQAAquQKANsBAABFngoA3AEAAEaJCgDdAQAAHrMKAN4BAABkkwoA3wEAADDBCgDgAQAA6OQKAOEBAADJigoA4gEAAB2tCgDjAQAAm7sKAOQBAAD+rAoA5QEAQYG/LwtC4AoA5gEAAN3kCgDnAQAAZKMKAOgBAABR1QoA6QEAALVeCgDqAQAAXGAKAOsBAAA4YAoA7AEAAH+iCgDtAQAAFV4KAEHQvy8LNlx2CgDuAQAAamgKAO8BAAAdrQoA8AEAAP6sCgDxAQAA37wKAPIBAAD7vAoA8wEAAMxnCgD0AQBBkMAvCyuycgoA9QEAAEpqCgD2AQAA6JAKAPcBAABFngoA+AEAAG+BCgD5AQAADZYKAEHIwC8LDlsALX/CLf1dW4Atv10qAEHgwC8LIf////+AAAAAAAgAAAAAAQAAACAAAAAABAAAAAAAAAAABABBwMEvCzW4vSEBRrYCBPX7bgFQTQYYunAXHXE9sgVE0QoMB0ifGnrkxhGCKG4ZSQGCCSIVHgEvK6oEAQBBgMIvCzV+KwQdKuhjDflVFwUnJOIZNJMEFT/u3RBp12oYFiQTGtBrWQV7OkEE6DRrH8A+4wQFtgIeCQBBwMIvCzUBKLgIMKSaDHiiKAt3mJMVI8kSDbCoNA0KtZ0OupdRFZv9rRqocdEWcXMyAyPc+gR3Ul0OBgBBgMMvCzW+eV8Q/zpIFWpoBxu5ThoO87OaCZerVQnSmbwO7LTQDyg+yxlcFF4BrDSrDJhpTh0CSmwAAwBBwMMvCzW4XyMSbK87CGNP4BnHekodZ0+cC13C6wGR7D0dq5enHwPWDx9oYAEBrW+MEM8MdgXwO00QDABBgMQvCzTzStwNk1C8B4uwHxuagrUagvLFA/u4ZAcysL8N9tj2EEehVBj9/BgRQHo6AmXAiQ2z4sMPAEHAxC8LIwEAAAD4//8fv/+WH/8FSBs7VYAd0AQEDOfMIBWvM2UKp+1zAEGAxS8L0xsirijXmC+KQs1l7yORRDdxLztN7M/7wLW824mBpdu16Ti1SPNbwlY5GdAFtvER8VmbTxmvpII/khiBbdrVXhyrQgIDo5iqB9i+b3BFAVuDEoyy5E6+hTEk4rT/1cN9DFVviXvydF2+crGWFjv+sd6ANRLHJacG3JuUJmnPdPGbwdJK8Z7BaZvk4yVPOIZHvu+11YyLxp3BD2WcrHfMoQwkdQIrWW8s6S2D5KZuqoR0StT7Qb3cqbBctVMRg9qI+Xar32buUlE+mBAytC1txjGoPyH7mMgnA7DkDu++x39Zv8KPqD3zC+DGJacKk0eRp9VvggPgUWPKBnBuDgpnKSkU/C/SRoUKtycmySZcOCEbLu0qxFr8bSxN37OVnRMNOFPeY6+LVHMKZaiydzy7Cmp25q7tRy7JwoE7NYIUhSxykmQD8Uyh6L+iATBCvEtmGqiRl/jQcItLwjC+VAajUWzHGFLv1hnoktEQqWVVJAaZ1iogcVeFNQ70uNG7MnCgahDI0NK4FsGkGVOrQVEIbDcemeuO30x3SCeoSJvhtbywNGNaycWzDBw5y4pB40qq2E5z42N3T8qcW6O4stbzby5o/LLvXe6Cj3RgLxdDb2OleHKr8KEUeMiE7DlkGggCx4woHmMj+v++kOm9gt7rbFCkFXnGsvej+b4rU3Lj8nhxxpxhJurOPifKB8LAIce4htEe6+DN1n3a6njRbu5/T331um8Xcqpn8AammMiixX1jCq4N+b4EmD8RG0ccEzULcRuEfQQj9XfbKJMkx0B7q8oyvL7JFQq+njxMDRCcxGcdQ7ZCPsu+1MVMKn5l/Jwpf1ns+tY6q2/LXxdYR0qMGURsAQAAAAIAAAAEAAAACAAAABAAAAAgAAAAQAAAAIAAAAAbAAAANgAAAGwAAADYAAAAqwAAAE0AAACaAAAALwAAAMZjY6X4fHyE7nd3mfZ7e43/8vIN1mtrvd5vb7GRxcVUYDAwUAIBAQPOZ2epVisrfef+/hm119diTaur5ux2dpqPyspFH4KCnYnJyUD6fX2H7/r6FbJZWeuOR0fJ+/DwC0Gtreyz1NRnX6Ki/UWvr+ojnJy/U6Sk9+RycpabwMBbdbe3wuH9/Rw9k5OuTCYmamw2Nlp+Pz9B9ff3AoPMzE9oNDRcUaWl9NHl5TT58fEI4nFxk6vY2HNiMTFTKhUVPwgEBAyVx8dSRiMjZZ3Dw14wGBgoN5aWoQoFBQ8vmpq1DgcHCSQSEjYbgICb3+LiPc3r6yZOJydpf7Kyzep1dZ8SCQkbHYODnlgsLHQ0GhouNhsbLdxubrK0WlruW6Cg+6RSUvZ2OztNt9bWYX2zs85SKSl73ePjPl4vL3EThISXplNT9bnR0WgAAAAAwe3tLEAgIGDj/PwfebGxyLZbW+3Uamq+jcvLRme+vtlyOTlLlEpK3phMTNSwWFjohc/PSrvQ0GvF7+8qT6qq5e37+xaGQ0PFmk1N12YzM1URhYWUikVFz+n5+RAEAgIG/n9/gaBQUPB4PDxEJZ+fukuoqOOiUVHzXaOj/oBAQMAFj4+KP5KSrSGdnbxwODhI8fX1BGO8vN93trbBr9radUIhIWMgEBAw5f//Gv3z8w6/0tJtgc3NTBgMDBQmExM1w+zsL75fX+E1l5eiiEREzC4XFzmTxMRXVaen8vx+foJ6PT1HyGRkrLpdXecyGRkr5nNzlcBgYKAZgYGYnk9P0aPc3H9EIiJmVCoqfjuQkKsLiIiDjEZGysfu7ilruLjTKBQUPKfe3nm8Xl7iFgsLHa3b23bb4OA7ZDIyVnQ6Ok4UCgoekklJ2wwGBgpIJCRsuFxc5J/Cwl2909NuQ6ys78RiYqY5kZGoMZWVpNPk5DfyeXmL1efnMovIyENuNzdZ2m1ttwGNjYyx1dVknE5O0kmpqeDYbGy0rFZW+vP09AfP6uolymVlr/R6eo5Hrq7pEAgIGG+6utXweHiISiUlb1wuLnI4HBwkV6am8XO0tMeXxsZRy+joI6Hd3XzodHScPh8fIZZLS91hvb3cDYuLhg+KioXgcHCQfD4+QnG1tcTMZmaqkEhI2AYDAwX39vYBHA4OEsJhYaNqNTVfrldX+Wm5udAXhoaRmcHBWDodHScnnp652eHhOOv4+BMrmJizIhERM9Jpabup2dlwB46OiTOUlKctm5u2PB4eIhWHh5LJ6ekgh87OSapVVf9QKCh4pd/fegOMjI9ZoaH4CYmJgBoNDRdlv7/a1+bmMYRCQsbQaGi4gkFBwymZmbBaLS13Hg8PEXuwsMuoVFT8bbu71iwWFjpR9KdQfkFlUxoXpMM6J16WO6tryx+dRfGs+lirS+MDkyAw+lWtdm32iMx2kfUCTCVP5df8xSrL1yY1RIC1YqOP3rFaSSW6G2dF6g6YXf7A4cMvdQKBTPASjUaXo2vT+cYDj1/nFZKclb9teuuVUlna1L6DLVh0IdNJ4GkpjsnIRHXCiWr0jnl4mVg+aye5cd2+4U+28IitF8kgrGZ9zjq0Y99KGOUaMYKXUTNgYlN/RbFkd+C7a66E/oGgHPkIK5RwSGhYj0X9GZTebIdSe/i3q3PTI3JLAuLjH49XZlWrKrLrKAcvtcIDhsV7mtM3CKUwKIfyI7+lsgIDarrtFoJcis8cK6d5tJLzB/LwTmnioWXa9M0GBb7V0TRiH8Sm/oo0LlOdovNVoAWK4TKk9ut1C4PsOUBg76pecZ8GvW4QUT4hivmW3QY93T4Frk3mvUaRVI21ccRdBQQG1G9gUBX/GZj7JNa96ZeJQEPMZ9med7DoQr0HiYuI5xlbOHnI7tuhfApHfEIP6fiEHskAAAAACYCGgzIr7UgeEXCsbFpyTv0O//sPhThWPa7VHjYtOScKD9lkaFymIZtbVNEkNi46DApnsZNX5w+07pbSG5uRnoDAxU9h3CCiWndLaRwSGhbik7oKwKAq5Twi4EMSGxcdDgkNC/KLx60ttqi5FB6pyFfxGYWvdQdM7pndu6N/YP33ASafXHL1vERmO8Vb+340i0Mpdssjxty27fxouOTxY9cx3MpCY4UQE5ciQITGESCFSiR90rs9+K75MhHHKaFtHZ4vS9yyMPMNhlLsd8Hj0CuzFmypcLmZEZRI+kfpZCKo/IzEoPA/GlZ9LNgiM5Dvh0lOx9k40cGMyqL+mNQLNqb1gc+let4o2reOJj+tv6QsOp3kUHiSDWpfzJtUfkZi9o0TwpDYuOguOfdegsOv9Z9dgL5p0JN8b9Utqc8lErPIrJk7EBh9p+icY27bO7t7zSZ4CW5ZGPTsmrcBg0+aqOaVbmWq/+Z+IbzPCO8V6Oa655vZSm82zuqfCdQpsHzWMaSyryo/IzHGpZQwNaJmwHROvDf8gsqm4JDQsDOn2BXxBJhKQeza93/NUA4XkfYvdk3WjUPvsE3Mqk1U5JYE357RteNMaogbwSwfuEZlUX+dXuoEAYw1XfqHdHP7C0Eus2cdWpLb0lLpEFYzbdZHE5rXYYw3oQx6WfgUjusTPInOqSfut2HJNeEc5e16R7E8nNLfWVXycz8YFM55c8c3v1P3zepf/apb3z1vFHhE24bKr/OBuWjEPjgkNCzCo0BfFh3DcrziJQwoPEmL/w2VQTmoAXEIDLPe2LTknGRWwZB7y4Rh1TK2cEhsXHTQuFdCUglq1TA2pTi/QKOegfPX+3zjOYKbL/+HNI5DRMTe6ctUe5QypsIjPe5MlQtC+sNOCC6hZijZJLJ2W6JJbYvRJXL49mSGaJgW1KRczF1ltpJscEhQ/e252l4VRlenjZ2EkNirAIy80wr35FgFuLNFBtAsHo/KPw8Cwa+9AwETims6kRFBT2fc6pfyz87wtOZzlqx0IuetNYXi+TfoHHXfbkfxGnEdKcWJb7diDqoYvhv8Vj5LxtJ5IJrbwP54zVr0H92oM4gHxzGxEhBZJ4DsX2BRf6kZtUoNLeV6n5PJnO+g4DtNrir1sMjruzyDU5lhFysEfrp31ibhaRRjVSEMfQEDBQ8RM1X/Gi5ylqH4EzVf4ThI2HOVpPcCBgoeImaq5TRc5DdZ6yZqvtlwkKvmMVP1BAwUPETMT9FouNNuss1M1Gep4DtN12Km8QgYKHiIg5650Gu93H+BmLPOSdt2mrXEV/kQMFDwCx0nabvWYaP+GSt9h5Kt7C9xk67pIGCg+xY6TtJtt8Jd5zJW+hU/QcNe4j1HyUDAW+0sdJy/2nWfutVkrO8qfoKdvN96jomAm7bBWOgjZa/qJW+xyEPFVPwfIWOl9AcJGy13mbDLRspFz0reeYuGkajjPkLGUfMOEjZa7il7jYyPioWUp/INFzlL3XyEl6L9HCRstMdS9gEA/xkBMgIaxkvHG2gz7t8DZATgDjSNge9McQjI+GkcwX3CHbX5uSdqTeSmcprJCXhlL4oFIQ/hJBLwgkU1k9qOlo/bvTbQzpQTXNLxQEaDOGbd/TC/BotisyXimCKIkRB+bkjDo7YeQjprKFT6hT26K3kKFZufXspO1Kzl83OnV69YqFD06tZ0T67p1efmregs13V66xYL9VnLX7CcqVGgfwz2bxfESezYQx8tpHZ7t8y7Plr7YLGGO1KhbKpVKZ2XsoeQYb7c/LyVz803P1vRUzmEPEGibUcUKp5dVvLTq0QRktkjIC6JtHy4JneZ46VnSu3exTH+GA1jjIDA93AHMDEwDQYJYIZIAWUDBAIBBQAEIABB5OAvC5PJAfdkAAACMdj/AxX4/0SeAwAYIfT/KKHy/yQeBwAr3hsAK+kjAK2E+v9/FOD/dZovAAn70/9Jei8AJ+UoAFiWKQBwoA8ApIXv/4i3NgCQnff/oOru/2j5JwB709//1q3f/+caxf/3pOr/mPzN/zXQGgAitP//ATI9AMVFBABnSikAIHYBAM30LgDF3jUAA6Xm/ywwyf/UR9n/r747AIUVxf98jtH/loo2AEE+1P8ABDYATWr7/5zWIwBdxff/PRLm/9bq5v8efjUAWa/F/z+ENQAXVt//XJTn/4xzOACoYwwAmhsIAHaPDgBTODsANIU7ADD82P9UnR8ALU/V/+UGxP+BrOj/z+HH/xmY0f9d1un/7gk1AMc1IQC7z+f/dc/s/3KXHQBysMH/9rzw/4BSz/+u0s//4JDI/8rvAQDyEDQAhf7w/zjGIACfbikAo7fS/0ukx/9tuvn/CTTa/4LC9f8TQe3/O6b///cJ7P/dK/r/1JUUAGNFHABiLOr/6fvM//AKBAAXxAcAiEUvAACtAAC+Nu//RM0NAFpnPADKK8f/ft7//0g5GQDAac7/bHUkAN/H/P+hmAsACOjr/2zkAgAIyMn/wjYwAPa/4/+TPNv/4Er9/wUTFACSdxQAJZ4TAODQ5/9EmfP/Agjq/6Lu0f+cx8T/V6DI/9mXOgCT6h8AWv8zANRYIwD4QToAcv/M//s9IgCfq9r/IqTJ//USBACHJSUA8CTt/12bNQCgSMr//KLG/1a77f/eRc//Xr4NABpeHADm4A0AWn8MAIOPBwCKYuf/BFf///wG+P8hAPb/9lrQ/4QAHwCG7zAAfbnJ/9b89/+SRfT/wiHJ/xk5BQAMYQQAQc3a/xuwPgDncjQAOwDN/8d8GgAkGQMA5V4rAJkRKQA6etj/cU0TABzhPQCECRMAUfAlAEZaGAAYhcb/vhQTAJE4KACQ28n/iVDS/z+FHABLCx0Apvbv/76o6/8b4RIAPl7N/y8t6v/kHfn/xwYUAINyMgBuDeL/U3ns/5lAHQB4Jdn/rQXr/wXkFgDn2wsA6B0iAM/4MwA0uff/DMrU//h/5v9X0eP/G5HY/xIsx//YEAkAH17G/1hG4f+LHSUAt3MlAI98/f+Y3R0AmGgzALvUAgCnk+3/vmzP/xx8AgAIqhgAcf0tAKVcDACaNxkAZ6HH/z2M5P88odH/OcU1ABUBOwDAHQQA98QhAPQb8f/nNRoADjQHAEV9+f/QTBoArnzk/2gmHQCYjub/Mybv/9oF/P/bf8X/ZCfT/6/h3f/dk/n/CR3d/5PMAgAFGPH/KpwYAKnlyf9Qivf/LM87AE5D///fNuv/yhU8AGheFQC2FvP/zikeAGoJ5mfzvMkIu2euhYTKpzs8bvNy/pT4K6VP9TpfHTbxUQ5Sf63mgtGbBWiMKz5sHx+D2av7Qb1rW+DNGRN+IXk+kUDXBTkQnbO+QNEFnzn9CYqPaDSEwaVnEviYki/9RIU7jPXGk7wvGQ6M+8Ytk8/CQj1kmEgLJ2W61DM6nc8HWbtvS2cVvdvqpaLuAD/hQfrGV8kcndTNyuwWrx++Dk+o1bRCYKWZivasYE4MgSuPqjdusWsjnuBVJclpppW1a9dxPJP85ySStfUPepadRp8CB9bhZZqmWi4ufag/BgxZAmjT2qp+NG4FSO6Dk1nzuiZoB+YQvso7uNFeFgpPMUll0vyk6B9hVn26weX9U9M7vdZLIRrzMYFi2ltVhxW5KjCX7kyosCWvikuG6DCEWgIyZwGfAlAbwfT4gJobThZ6NEhn8fQR8puV+C32F2tOuE4qclsHb97XISq7Y7kEmlS/GGgFCgX+lan6YFZxiX4yc1CgBs3j6MOapEV0TD+TJ58J/I65UXMoOCX9ffTGZWdlkgr7PY00yieH5SEDkQ5osCYU5exFHr+UD7ptPcYr48BS+IzVdCnkGEzmsLF58ES61kekw4KRf7cpJ0vRFADVh6BkuBzxPOPzVRvrc35KFTO7pQhEvBKiAu1ex8NIUI1E7L9aDOsb3esG4kbxzEUpswPQ53mhMsh+TRIACp1yX/OPbQ6h1MFimHqyOFmsuGikjH17tgaYSTkn0ieE4ltXuVNFIOdcCLuEeEGuQUy2ODFxFXfr7gw6iK/IAIkVJ5s2p1naaLZlgL04zKK2e+VRpOOdaJGtnY83kfv4KCRfF4i5z58ytQoFn8BUE6LfZXixITKqmixvuqcjujtTIaBsOiwZkk926p3gF1MuXd1uHb+jTpTQXBpr0sCdszo1cHRJLlQoglKycX6SPChp6htGNtoPq6yKeiHISTU9VMYopWh1qxOLW9A3N7wsOmLvPCPZNJLz7V2n4vlYteGAdj2W+yM8bqxBJyzDAQ4yoSSQOo8+3QRmWbdZLHCI4ncDs2wjw9leZpwzsS/lvGFg5xUJfqM0qDXofd/qV5ho2pzhiyazZ3E2hREswtXv29mznlheUapJVGNb7TqCxgufxGWoxNFCW+kfDIW5FdMDb23XMB2cL2MO3cwuFTGJdpa20FFYemOoa7ffUjnvDqBJfdNtx+QGIRdERGxpf42SgNZT+yY/TWmknnO0sEuGLhGXxhDeX759J8STZKJ+rRmtT10mkEUwRsjfAA4J/mbtqxzmJQXIWIOgKqYMR0IgeuNKPWrc7RE7ptNkdO8GCFWvm78DBGZYzCjhEz9+dFm07HNYb/VoEsztPbagLOKGRWN4bVY0CMGcn6Q3FlHEm6jVVo6829J/fw/stRzZNcxeyluXM9AvWsaFQgWhw2cW8yoRZGxY7hpzQOIKaCqyk0fzpfsU1PeFaRZG1zxXAMjJhF4+WR4TYXu28sMvbFL8g+qcghTCld2XhHtD/6e1TqowTnRsi+iFPGFdDJ5zgXVfHsfZL7jscU4vC+ch43ekQLndVuaATx3OzlZlv357XVPEO/wF3d6vUq6zuCTPMDvtjGOVNJWBvqmDvKQzBB9lXEdnNzfZrdFA/Zm6LyfQ9JZvFgezrjvwFVLwY0OZ+Rg7bKW+H5BlJBTLlUBjNVXBFkAUEu9gvBCJDBQ4nox8kDBXkPVriltB4fF4pw9+p8O6959ABlCaopq411JvVlpjevYcUgKUUp0KC+4/UWZa3w9c55iPzgfhv4iGYdTtLDhxfgqgP+ReL3cgZxSxzpoHlrGU+OhKgqwATSL4SsRszffZUxcANNs9li0jaTxYOJe02ofeHYXykaD50deqtu1IoC/+tRJN4/yWxPvwce1b861rgrlzYcUo/2FyBNJvILFv+XabdJIeb60mfCvfE4lLUCPTZkvDixx1wJ1AjLjHlgfCk35vBa6mrgT2Wh+ZnOS+8VEjwWZr/+61CKhhUSHgAQ/Bzg9EHv5JplhNZH53rTGirvwh0tB/iFocRALzEcWDcaoBSUVOJMSd0vI9Ct7Yk3QOAitNIQyCfgbIbAq56m8WeTdB8PgajFS3sQi0mWIkfHoPzjnZBh75sGD3ExJtcnuIu0G+RkN0RH3oQCUrtRXU2kgdPmA7oRiKOnz3vc0vwSi3Tq6RZnxZTCN+yLSFCj2diGTn+ko1DMni2h2eagwHHocKiYm8S5m1ATNgQt1bOq5rczye1RnirWENZNSFJg8w5z631n2e5FXS9aweC2FcERaAyofhkl2XmTzCJZGXYleBExh1HoRHefpD10acY1n6xuV0KwXjHV4GoTCQuM+ixkd94NbwjhTQ2j88b1SRmnQ+nVeBuyYQYuxxgOzJNI31jBQn8DR59pKkRqkKhPa+hJlGVBhhiSq8oVzUu129HvryP2115Jp9L1fif0jziLtFw1aNqGBpbQvRn7mhrk6t648nZjmTjB9oqrGYDCkgnJQhjFI8nSGRUhE5e2ec/gLdBEEqQiQRXr+ycrU6o5gzDPqhZrZS+gFhy5TVU6+vADuGLLhqCdsGTiGBNU/kDMm2qCH1Kp5AKsEkZYGk/I6ktWUBdmqEoHSkkPHAfC/NhPnvEo8rqlgGKV5puMj+v9lnG1n6m7SAHA0vMYrs86teUXlZiBzwnsAzcHLLe4/Kxy7gPV21GJ9xs7mZHmSMofrlZeTtBZ/CNhEIYYsSMHCGT5tI75LrOi0QMtJhqBZhtFNi4SSqCxnnq349v75sSbr79UnUz1uKEJqUMOtzZLxw3UDcHA18MMGUwpJ0bvrLbagEVi5XnB6MYl0VQUeIxayGTYrrY1dR9lKjkVtRZ4jCpqEGtmQXfNTRiHJRi0HgQBFUctH2rBhgGgOfxkIn/omemCB/zC06/XeXSZLYT6UsfIUyoOMH0mTYeaIpfqYMHe0DBC7s6oWLJ3QW3yvLegfcIVZa9MthFkwKZNOVBfdQmQtzUsVOhzUtS8mNbySYz8jmxc41wBb6Rsv3zD0wCENF11vCTLIoldGaf4HBNWNlVGt/NnLAT262uGaDrYBzAHg6Eyp55xUhk8SFyd3NvaKJTMZi16OtqD0enSz4ZzAS27dbvmLKxmf0YQnuUhkh1iHsBHBH1Zt3YCMY0uDwWG3KDXROzs9SB+5I37cI7Abz+v/DxFlUuSoLcQWNoz6W+iUdFjxDeARXjBojnUOBwg4ntbefB9nj6pmq29kDK2wl9QMsfaRTe3UYD3l5WAzPMAF7MPn3fiV3PZAxr7uWvb1olGnP/tr0Ri8fvffWf6QUAe98f7NHStr9H9OFV5BzpBlSUkgZqWrmPd3YzNLAL8JkUEgv6v00ZiRImzouSmxOHD4p4RJRkksTbjegXaHctXg3cBExHEaviUWwIygDf0RcYFuJfMQgWYBlucyPO5IMEPDnd+/iAmUlAQDus66ozm2nJEzw5/DG/uk7YknjdZ5XaoYa5h0eFu9CVdW9Wsz0/hIvQMfA37IiRQoHpMlAf27QEGj2z3hBFM/GkDekGCV7YF4YGN9sjx2zWKJYYsNPp881bh3mZk//s+H31c1sq6xnUBTPlqUcQyygAOTTrkAtxOPbJg8ugCZF0mhwRZ4TMx8gUZ0DCGt/Uv0GAHwBZEmxGKikJS6wDiLVdQNGYoi6fDmyWVnwkzDBMHZ5qemNoTriJl4dcpHULyI6bG52INM5I+d5E8j7wxV48Srh3SCUYabV/aiF+MCp/1LC4cEiQBt3py86UYbZfdgIz9T5cZus9bODoh4bw2vQdhqXGZIYGjPGgE/7RW8W9c91x2HexzacHNlBkBvo1OMh/r2Da3wWMa9ydZ06L1EmnkoHaIjiy1vE94ARwcHthHumSfafYckaaBBLUkI4K/KH6ZzuOzRoUMhQYkqEcZ38EbEIHzQ2JGGNiU6H20Gd2SDcB2zxpf4JvJsP0GcsPXlA/16eMOLrRjgmLRrjSWOLNf3TmwC3352ka6CjuPGLf0UE2XgxqiIVOElhaVMvOCwQbS23mkD+2ifyRraRM8jobDAkBfVw/kWMCwyWpnVI2iAvDu920Ghb1I8LPc9R+wfUkuOgIxaNQpEUlcggSfJiogxjP8gH8AW41Mn10kW7b0UierVtn2EW/QijAURKTwisyqV2wxkiqH280UNG3rjexji9YC1ZgR1frA2mVoc2YVfcq+tqL+AXfQ/OTC0/GX/w3OyJd0ojIOjFhXuftmWHsrpo0Ytn8G+bDzMdfOdwOnyOr7BRbV86UrJ4cbYN0nZg0R7V+TQcB3AR5LMgSir2ZuP/PDWC1ny2+ofYW6ThC247QLoyaoQqAGBu6RIQktlDCdw7hsg4KPP0rGhgzWWm0+PXPBgt2ULZJWAznThZV//YLCs7JfA+MFBGSs+wa9Grd8UVQWtJ+p1Bq/SKrs+CEiioBqa43CHIn52MRgRgXMujKtRuCUAlnC/uEkxNWxKrHaOUgdDDC7oxd776AI2aiRieYn5gA4J/2fNDNwLMsotnb2y/DYRdi+GfMA04bnDHZeG5pi2wbqsgrn2ZurtX3ZbBKiN2Qjr6hHCKLENCS0Xlud/jGYqJXeRYnCEAn77R622hznfxH8t+RNtywfg7vS0oxh/Ez1/+Fap1wP+sgPmp4SToyXAH/bW1RZrZYc8keTob6YQJhok+PjAZCTDnHgtQQf1k8jmc4ufbFzStp5wTnCtqN5S9qXtZk44b6aBAmIhoNNcSF+F7Cf6rSpvRKRng3+H8baT/8aYslAjJw07xNSwnIcZl3ZMxzviJK+e7wCWhVjMQTYP+HC49qRkEcuKcsQqA+SLL+J4+ijZaYBVHUKUiwOnjjyQkX7BIPVXlJnZkzRb0E6z9bprdnwJCQUmlNL7OErl7872HuWQPZLTKmIXTpHFBjEzJmapYJ/oHuACwb28AI5JT2q3dkdL7q9FLV/oUglBL/tY+FWkCwsR3HVE5Z1qmlK8ULEYm3stLp6tv7GD5ItYD0FO7FRpGZcnzvIgoELJaOmhsdXbFJ0e0bMikWHc6dlCuk/YRgVSmVP0d3yGuHWVeEfOQjCQSlPTnjV/Rn11/cmNt0wgUAzO1x9fvmjdqS+KuzMWP4anTvo9PkTUvMx5S1+4qTSQ/FZYuQyiQOo7UFpwud7pk4diY60f6h8E7DMKG6hUBR20l0UZsy7eKmYgBZjq1MnjXA7pvkM6BDUV1UiCmobZ7boOOPEHXIU+qslyP6FXRVm/hWzSmS13iLT90rhyW2HTQ7WMc7vUYbfgp7fTnW8W9lwixOmZ50rpMzR/XoCSQ0YD4iij7CsIlxRlkOl9Ll6OxM3IA4u+8f30BKGsmah7v+hafc9XEaGyGLHYDG7wvivaNWreHXkN1WZSQwvPFXXzNqwWRKpqigcdYMBxCNh3GgNfU2NyW0ZxPaDd7atiXkhljetEaJFjQ0BcMHFytnAK6BwN6OITQzXwXBCZtLEKm3L1AgpRQPRWud8Zo+7TBwKlTz9Bh7dCLQpPMYGcYhAybmSqzGnoArs0Y2gtihuyNqETKkIGEypM1p5qEXpoYE5LN+thlNcPY1NG7/VNbVFKM5mMt2giDOScT1F5DKI3DQsnMeDJg81C97wPaeRqrB7tVM4y+rpeVJlMkcApMDqG53ht91WZYog/32ifNtdm5//0zLElFKSxXvjDN1kXHf8f7rrrj0+jf5AzaXaowiCyigMpbwJhUmH8X4QufiM5JOIiiVHsbrQWAHJL8I5/Doz0E8zEKR+zCdmNjvw9SFVbTpvtNz0VaBAjCoD+HvE/C7ucSm9Y8ZfIwhQzBqjjJCIrLayfbYJsXRnCsbw4ewCCp2nNkWfFzEi8RHuCKfPw5R5+rakqQdFL9Lo9yh4KK2UHyaVvYKleeXcALp1XXi0gw50LU8aS11gZiYVm8nqbR6oT3xe2XGaw4O7FRpxe1ZgaMhZt+hgZ9dEneTUURwKysnObpv5zN3yLZDA3D4NLbjTNDu6xfZo6tH5YqMowla4/HwUhUwBYpa6HgOxC0WexWaflZ0uy64y4yzfUTlLJ8eXLkzSR4h+kPO5G6CtE0234OrG0ugs2jThX4eGX/PQhmFwrwfzA/MEyFjLIX1jsK0+o7dzm3d9PFv1xqHoznxsbEtyqL97hhDQBF2Q1YA/wpk+y7b6R60uz4p+LCXxUKE9WhBrcaFWtBsDbB6e/XqFYgS+RYzeUHvavgVxvaL+av0uh3QvcqGhkxFDzFS/cWzt7tciDOJZcr5z6ytW/DubgIyVwLRQ4ufvsORk9DK+af1gc2ptQD094k2qC3DiFS8JNbVAC+fX4jMLQBZ+11NQEQ/Quf5pQQIyJ/5IMVDzJ141URsZmmr3EdtlM5m2/OZeZBoa/qOVjG/ln3qf1fQw+OwrHC6UIRAtZQO0ccPELqEO84Ox966FGVvsmyX7+Emxya+Hi8H3MAgBj4SBjHMOQZwc5eIgyWv+MVumuD4Nq2CFjhRzNvTUzJH33Bz+z3GBQ8QFGm9XVs3wzu9ytx3tsieuSnqt0/GXAZj5j83QwvG/W5sCdikWu+dpF3xLbHbqifj6gAlb84b4foNzzJ0h8sRtEYWh72onYSJDmC9YBQaUkNv565b2rrVQhWu8FGap3wk/g4uxYkwaxxjzcRHdfqlhijFGn3dcYj5La1IrHujv+G8hBwnZOMXc8dgyqpkBDrxUKf2m8T0b0Fo7HfTPkILPifnUs2D4pYu8Ol2IcqutzoC1GDIQIULa1eOGb3SjBYfMqA2I6gPR4hEOamEw0DbIB74RwHan96MEMBcVqdX6R9xJ7eY7DTepK+Uv67ImxCQP1BxIcT+IqXh9HD07UTRA5/PVorcqB8R7tISHsNktwer2qycTGoTFaXkDEvqRnhdSJMuHv/UFGHpDf+VU9ag/A8h9QfItFHirLYtw2m8aRwF9YUv6ZYvd1Tk/ih1OlDQjRjSlFsQWMVOk8gIiMtAwq66eBz+w4DD0FM3eD8qkqS+5al2kjHnKVcZo7KbqCsOC5LJUeozhce0gjHrzH3StjK/NZtZ5OXTMhdHfYUBoJB7+P5QZmsd2I0j7j1zal5ig76N8hYWJD8loVo+QwboFZ787vcHWrWNUl958LcCn+lxvJzTxy7oF8wvU96Dq1jxlTgTJ2CSDjjL4PDIfRCTPYbDchaeYQ0fPxucG6zYc/Bw7TJ33Plxxx4yXkd61xnr33bmkVwsyu0kUnbkRvK3AJLI5YmV9x4jB/lnt+f0x/ijIRi4V8alpThTyFZTk/NcQ3Hfb5JLfJQO9LPAJMycpH8RtSJRwiyfF0thXko5/J9aHDd3riReGghq/8L3DWqfWdDwEQrjrdOB6uHHBpn9NqZjtHG+meQT0jNu6w+5KS5K+8uxWDxi/07vIldCxpV88k3kmuw9Sgw1bAWTA6rys8sMZy8EBFtrnzCxStwq4ykVJtpx0SyLkm6VkC8721nttlIctdwW6DCPkvoiqrggRft9J5pmNGFjnDkE0V5E/R2qdNbdWNTCNEqPqBftWk15p6QdW81kLhpvv3x+Z+Eb8GLxMGMDbes8ZcYEMc92LtlwV592l0PAqEPnFuOUFYqxTcXdWMnqRm0btMClAKlYLR3fk608FZJPNQwYqjP52bReordwnAO7G+fUJRhZY1Rxkapfi7uXJvgZ/PBM5eVhJRjY6wPLhN+7bh9ltSReoF21wovJXRkJYUN4IIJ5OU8pRY4YbgyZM1I5L7353nQhngIZzrIai7b5KDZ1J/4QU9ac1wheUEq7dzX55RwjHCc00fDivuXAtkGqTPgO+F2ndkMo0QDcDTNayi5M67k3NadVbZ+77cfjtOzHxSLJ4bCQSJmhfox9CI2LkJsgq8tUDOYhykgwSOROCvht8GbiSSVqRIjuyTDZ94yF+2osUhJG0YYlLQ80rzPdkNDvY4IgBgehz7uD2tc+PUqDPhBlGf6BMOEcmitG7qjmd9FiRZd6//5Kh0N3x5iMqGK2ql5ZSJZoSK4MJPBmqd7GQRAdh1TGJfXrBY9HZstr3LfclokMqQ2KkZjN5azFnmgzj4JIzC59g4+Eq22h3jFxlnJuv6QX62e4ZQE9UKjYk7iFgAXFhhL004WmuYvGUzZfkgTFZE66iyuYSfepLnT9nuH6/NzEMYP2nhqxivlKF3xW44a8HAY40cs3YvCBryvGSQ6F2sl694lLZQ6DGjxgJ+i5ufpGhV+93FzeQFIWPEAEd2NsxazpEoFuHwmGY1GyN+vTeVmnHgoCxfsbmYqHesqYKd9q6YQRhP+sPaNx44TURv1deWJ2pdTufF6cR16IAlQ1iAruv0CIRX10XfnZSrN8WCqj4eRiVTlBrzavDu3sfvJfKnLeEhloeZcBQXknpYprVESaKe8NhWkfaoX9Ro6urLsKdsl1wpXJE6DsWdC3MUbznC1RHW2117R9wt68BpQNqBx+8/vSoVvBZsMvMf+1//152hSfVP6rhJDYsavd9mfOQJTX2dPHhcVBDY2LcM7SJiJEe8rzRBRlNCtbgqHYWWoonK7zAvIqbHqL5ZeGM19FGU15ueG8m1buzHgkrA+t9ZZq/AkQJYS/lBMXm0Yfp/o/oJ7OeCwMXBQxfbHO8I3jxBp/XhmwmNoYzH6hhXyMy1XSIz2B/yunnifzHNPAUetjhDiQi2b0t+UFRP1l2pMPzFdmFVhEFBFCAc/oesi09K4CCZrZ5N1Uw8Ne3EhTAYeEwtpTpGf4Cp1roe2G248Qpun8wtCRytbHGW6OIGAGxsx7LZxhrA1MbyxDP974PEMnPovXXS9yMkrHlpSv4GdRyYIJlvq21UB3w7HEdXQ9QyW6zziGmpO0yFX3zZg0LN7mSeI27H6anXIwwnC0znIHUzlW+EGSpkyGYddcluw2rHOtRw1MgXKt9pJFcR998GOJ2HY3lhcxWbykzcX2ElORczFdsnIqMMmvPiC41z59oVU6J3zL6jJwraoW/stjFks9Y7v7khzFS3xB5GAM9hbHVNraboIesXvw+4+7XcRSP/UF1XgBMtxpvE/ej3qVP58lLQzBhJCAGGReJiUC+j66+w8sedOwKTwlJVzvnCFkdW0mQrTNQoQEklHMb2CBr5vfm17I97GeeoRGXYe4d47OcvjO0MH9JfpXMBEef+jUVyw5D1dV3yEdlr9gTNYn9r2et4+hy0JNDdDZDF6FdmBqvTut7j6Bkim9eb+k7C2p39wVDZ3LoH5XU7hAmKq9eEVUBdZDaJsHeK603WiGFMCYAGKYUMFwSNMl/S96g2TRs6dJQpvqiy6mqK4LCAEDZYHLTZDFEt6H262x7fEzH4vDPUlfhVEHK8+cfxt8D73Y9pSZ0QvWMucUhzpVHyW+zXGZJIm9jBlGRJ49K9HJ1xv9uoYhAMX5EwyINN7McbEi0ik6EIQqGQTWk6L8R6yyY2izUscKgxHBB9v0MdN0lnAh9s+niayj9Ky+3ICW9F3SPbG0YtVfEVpvWlIgcTtIo0cvn2QbQ2rxVzVEtI7xoPcFKMwm2paPUaW0yQV7NDwJFrDimK7EqRfvBx5Ogylw6/7CsqlBATWQ6cKB0AfjOheJlvL0LrM3tKPZmsES1czlt3K/Vs5RtFvQSobnrxii1lQ4yj3xrVnaV092D80BJju+OcWdVI5nJpdGi3bfxEqXADRvEV3nOpv1VTxvtTvFtAi6CmaV3YXKsBJfo62RX+jqbyiUc0jG0wi7BFf1j6xvQWe3ISjQ/I0tFITtTwz4YDek0koMtjONQ11hyhRtcF3Jyq7FMUCRbbxi9rVS2hTS7X2ftOL+1PSsKnXFjkxWYBUYQmSYBGqz9opaRZNtI9ZE4RMn1LaWVU9Rcpj7+kLjmnFWxIeNc1NmzYWVjh6YzVcZacswHUhgPHU+RvCfULg5pF0fWMvvnv2GkabtNRhiavIegMD1vuZpvmf4d5xmirO5wYtGH/saAGrZI58ekPF7RVVSlrL2g7NR9MZVQmwkz40jKzUZyJ1IY5yS0UJ2LiE1PToWKo8kEZ/TSVY0xdSHCRDwKxEd1d6T7trfRzhE4OR1P41i4RGa8nGodxKvXGtEoMcbVWCOY0M40DvFzT6oxU+B/cxbmRzB8vzIU//ToIdbWxsdCHoG7FWZ/CB3fOjECP4rw9dRplqVdCy+AV/jMw4vnoJpC2lfofJSQxDHdybVWlDTNLrzPcJOCwCvYTuS6MUflcKO6dhrGji8PWlkTcQ+vry6QBta4I+4cFCj9dv6X76YCvXTb2+zv6UESIPBtpPavT/0cjAd1lKEpWSAPu4BFNwxm4pTTUdPbbYMa1fPgXD8+xCvbSMlQtn/VNjoQyOOSHzMys4igX1ibTASK0LuuJabrM9pQO1k4/mMqKVne2jWgFWt7T5qpgncq2NXBNyrF4joLdhYarO0k59j+mEsr8bYWXZx+l3Z2U2gMdyVBIry+5uUNmZMgVlzFeJXk7hB0qZ+Q2YyxLkTnHHbjxv1xWj/Xdckt7tpbsCNDEdOawLP5ukd8TNWAskF/BHZN7aOP2tasinMo2SGYGgr4Tteq9Q5Vv2FQHeT26yCWEhISaYKdnWrQuBBQJ4BtDruhajIRn8cLjffi9Cib2zdk/rayks903CNtTxOAewrnPiQd9YZIvB89marVrXnMGxYO8OalbZDlwlrAuaPvXHYqDsnQR7g0RENXrjy9yTvu0PM3mIdYfdxRLDBGB4ZA6Vwsvck2BtcOCFhZrzHzM557PYpdA2O0WPceHyuUN8qSdICOrRV0sDhGC+7t5rVLgPeLbCmTGVBi22q3Yzl5B9ZIvJgDFucbAooee2eu6qi6iTbVnBpDBhIbKC3rT3GL2X3Z2ZPjbEH+41wUOols/I5AhVs26XMNOMtQFoL7QrBTppeJvuSMauS+LcSBgvYK+8ulVym3Yx6e88bjzLkFWz+cablx8jxvMqzEveMVwfjSD+MLBLsGa0T8EJcI23EyR5CJv6mwf0DTDaUTqQ47BaqT0jZDmEgGQ1Cy3xPO2UcYGE9neMA0VC1aKA7cnzUjn2d3iLoAp1VAjRY6xt12tjcJQV+/Qe7HsWW+ZeToXCzdCWQgpZWZkhEJg037JyVv8LSirpXlfPLxiKkIDA1L2dSJnCcOEw3jP3Ule9ugUA/dMsEefUQwHYpApFvEZd2LkzpScSr8PCBokrJjueOBtYLzh+HgogxTr56me5jVHAUmYFm5i8cfWXcVbZhSv+OE4eZVLKDgWcDD9F3hpDw5s7cP9eBPXpPXuE7cl62fzG9FgcwuYOS+po5mB2OayXl7Q6Ff67GZufp+w0tXmxTFeuMaGfwFFhll3w/Q1c9Tp67rQq4C4m3QkXFxKHu7IRCwMPgPok7x+WMaca+1PWNxhk1z8wlZQPshc6+wkLIK0+YcgvKUlNVIZrlzD1r9IiBEbSwga4kI3luuVNbImh3BcMNMjmXwAoiIZSNJ+672qhfRAllP8bXDZL2WbNu1v3+m0xD5Ny5HJPCIGXjCCVJuEORSMLKlCxAt7vA6aunf1MozMnjC6dWid2KtM19vMH8GZlX4ZNqnpQRNAol+eFPDhk4A8Af+4f5ffbA9oFU3a9zTQUSfLapOyIStLN1Up7QwUE7lFA+QCyMNPDI2s1jQYbR7CbixzyPLhCbmwxbLMNseqLfpzXB1OXrwe7k+/Xp2a3Pc/QPljFHgtuv5hpzlIE1F3S/7dHEt0IvJz7+4ebwu7hOmsGir/BH9srJFcNtkumXqMgNRxKo8u8plPSgJshODihw2E+luOCmAG2w5Bv5g5ddwU9HFnAayFAb6jNfti8Eh0jux+QCccXnmqVtFUu0WY7DHU4GuUilEDxLmlx9l0rPMfAyyngTHTnTwEhfEgw08fiIQaNg1mCzGCYr9yan8bBSOqQMB5YZTdIJmW8pdN7CdYHAPPw27CWF663luF84bmv31S0o6rpcTCSJZ0uAKGcWI5dS6lCCJUdv8A+Lo9YY8PTsu/iUbs4FJYKhr8cPHjXgxXheqJd76Lu7HQBZ1UUOnxZehYJZhIqpslwj+2BLl8qJcconcwERwOQj8Us955nGx0mh1u+XyvhFgpYxYNOBlhJDehmUCaUKA1rjHwwhffD/P0SEQx42lMbiLND2AsXnAf/b/pk5OwGBSPlBWIeQ+O+Quq4USRCeTUA+8lK4wXsbVbQ1cBQzdbNO1cDu21o95pI78PzP3KmPMyKezHXwGhns8FV8eUltpSRe3uZp/N7QQAma23cvSzC9FLN3RReRFFRSRQ7SytQV7O8S0Rr/2eO24VjFidpvbjIlZLjMW8YE1WkviurRzGJKZEHkk+iU4yn9zC+SPlJSz3UT24IkOkSLrvff7OWDPH56hwSXpOanz+YWzrENhHfr5k+XfDjsnfexC6cxalvKcvzhE+/YYu8CPmoF9kGdxxdJdN6/JW3Y6Sw3RKcY5jVa4YkwDCf0aVg5PxYAy980YpeCS4VlaEHyF+eOAKPNqg75I3PAjtDkEMmQcVd/aGvNwEvAz3ojz6UonAFuRWLL0lFCGdwQvKUhP27YeFaHN4HQKx/eTu6dTzR7+iNTHAIMTfgM44axd/jzWASpV2dpYaMJaaZCNYiltHNcMDbOWKain1si4r+YGASQOu8R4izXp53h3vQBAmckbrd1B/OtKqNTMc+2zHPUcyGrWPMYywH3h28PxTiQ7lA+UhmLTL0OQwtvQwvlQYx+YGgrZd2Fmwq97rOqkBioJWiW5x0NPha0jfKW3yU1moxyeenO/FmrAy0jSOvvVbrMzX147kqNkA9uW7VaIUzclVaHVIUDp4YE3SDbagkHbI7ncFs0xATuYYjYrdrKgZcT6HXkYWbfFRXHn5QMaoDH87U/0h27PQcjKxU8OpF4Hw1CR2CJdKIWUjrmtxhskO7ebuIGR5b5Z01esF90J6gM+o9YOIuLLDCaydbz1VgMmQTlWyLPVEZe/QLACZx/pRnlU/V3RCNAmQJlELi1bQC8o3RKMtVobQI5WwYRkbM6olDgmyT9JzEEDRdrgnIpieIsQ0fzeumi+hbWmc619M3Wlj1FaPfLvJ+oWD/dHG2LFRpPcQKJyzNsspmalc+St1sA9dpJFn6eZkljD1gAxUi0OELOfnN7lnx44xyRCBCqfTwlHpmHImCNvSQOLf0HXskorKz4PKS5GARVSsGnmx8Dnt/DeKP6xWSWfxYJu/8YYz1+AcYIi5f1AmU1J9cVeMwprYfjaiqsj3gUtNFgmloehgYKoVdsdvXrN2G06rk84LE9g+B4rpEzwGvPUdMz0b55cSe7SVlQgMzkBYB2l4O3Mrly/KnsXJAX+sUzXs4KUCBSfGnbjwhVEgrOfh+Hny6zilWjMOIJLvFjA3lqmUQVw0g3yVFLBxKZ8q/1i07XDBAg+Gx5wcKFuccT+aYoWm8eBrZ4LJikGeWUMiciMlHuHBQQGZK9Z2/oZMkqeZpc+3Kxdw0RAHhM/uEPJZd7UfnoIbtdpUBcOT5Z9J7abIlZGiYE/s/Z524x11B2fulPF47J987zE7g0kxOtT1oIBSX0Z0kHr14tALBWF4ANQxiXKy6zC/TAvstpwj16zu2YNBazMFvu+40i6xGlukMG2pT3mumSdqw08GB0GFBO+gxTysGnhLH6JfYCjIpT4/kST9oGG9L4exbFwNVLbYez1VYPcJlEBB5WJyBlFBtCJ2Lp1/FEqkvQOLUkQhXZGWaZlKM9X3jtXYwNsyZ5925Otcg7hNJ4xyDvTMBumKq+1Ya7MmdXFBrPpQaN3ynu1clMFF2NEFWrnOYXIrFmWeDxBO54bNaRl06QmE/8ceHwRP8trm17GQ2+BkHtjemkwz4ZoDQi11q+9zEQkgaV+zE695lU+W4g+iy1Ce45ch9yL1QEeHfboM3bWDZqxHwFT41MpY7tyXDOrBkrtVfckRk1R19EmIz+H+kjxV8zXHEap+8iwwiSUNFcW4uc58hEllkDprIuggA5pfC4MPh6hHqTH18l+ef4Yvj880Fo2MPRTo6J0Y52DEvjwcQpZTegzGdOIBvmRdtbOPRe6ipk5ONjDEZ/v8qA1108mbbJH9JPJ8M75iFuuPTmLwUUx2aZ3xMIpjTHaspnmZdO54tNFgWkvzNc1nz/R2FVfYKlSXDQZpQ6SX5ptxuwL0zHxtk9PM+eYk+g52AEuyCiROhKCPwvwUL4MojcBMyNlnPrNEKz0pUiBwa0kkQdJanRCr6w4wLeOQSxQ3doIFo/vqlRMgN509AUkqPa450H+qjAe7Nd2JXXzBPI7yK8x4I3gUUvX9Xmg0q5jQUpYJeobdxYnIY9F+d24kXDAiOOfV45/MlIGCnXQO9BkyJmPq+Zqkl3ANqEECVthPoR9vl4RAmQzsqXfN2Eng46SYfrGnLoKCM29Qp0FMzM68KrdnlCdOspZ1mOPD3iMiKZVc8+r4sBVGKs0qT1WhnJSt82hPKIkRXwMGYHc4KytULqPGQpojArdHNKZzA3V/v0c/Wzl1X9/0+K+jCNBYgXWvVJZsr7QS7xkEwSOFW2fny8g8uazWfdZfnrVwCbF+7mEYae5oEFGi9SxBn7fFoMf3wUcI7b9jNHYEs3vLSBENc3ERJcSoJV8zoW2Pxf9Zfml2pgVbHTJ3mK+lX8iDeTAL4t/UtB/sgKk8gebDrMD07FMgwLmW9WhWJdTFcbY8xPDxlHxZ5whf7cCV1FbYsfzb6PmwC1hx2b/n1YiW1ZSoUx+jNCgNT6mXLPVokuAtVqS4Z0VCQj6j75sg1yaSILeqGeWiGAd6RXxwkqmzeQCkX2Cg6c9ki8Cy/j9EBWyPd/NcW5fDNX90OQghK+mKDqyD/zW4+GuLUGOFXK+Y5/BeWF+P9aRe871OaDc4Q9AROw1gDhQZuJ1pbE7YhFbnrx3CWXZyI2yHzVNYE1bW93RbBfV4t3aWNtt5UKZKiNDMXCLYc1xqZGCZPekqVX7FfAhin9I8bXGs0X/Y9EhHgAIXw/M1IGNPdTAy1EUsqN6+RssMk8keBcXCC2pPynomGZIWE3TPu4CNCMZZK1v+kCEQn6KbZdhWcfheOc/KzAj22SDN3Ucxrzk3OS0+EJSTiWs4fp56K9ZJWcuom9DzqHNcJGtLmARy3FN38c28LncRuYeIwFyPsyo9xVuSmT2vym0DrSDdfWWHlzkIwQaybRHlwfkIKMeK8beNahXwahF8hdq5M1uGcmgx0njjOudw0rrP8ZK3QSOMjA1CXGzjGYn3ws0WIZ1pGeVNUYSisDlf2eL3J4ZyRJzILW+XtkZuhqz78ZZA2JtblJcQlbt7X8aYGPj8IIwaOJ3b5Pndsik4m9hSMWUdIFYmgOWVz99LDdB/S6UVoxCVBVFDBM565+ehcTmJsGM3FquTFERlKuxTU28Tdjk9CmDy8shlpcco215+oSJC9GfAOMmUPxuD9yrHRhtSBUTsW4+Y/T5qT8voNr6hZKgcz7L3Hq0wuCpwIJJaeIzhH/jrAxEjHKqFPdirt2xeChRwy8JObY4nSeD+PeI/An01AoSynMP6dzGXP/It38iEgy1oWmOR+w6ERkeMI1XuJdJCA1JArKxn9cq7CrtLnpgK2hTxJ3w5oWptZWIHMrg7iresPT1fqB3+2InQd5E+0T50B45I7QBNBdoTSxGdnNfj19z9AkKDevubK+s+PHGmj39FUDMAE+FxGi4Evwk3474AUWvOgcVfWxwStv+iu9HZhsiqxWzX0u5N0zGQep8Owo+zZhL3lhecF+gzFawoSwy4YMoGbDxhzjFrH2gGjEarOs50DkO0tP647v3wHb46tUuD46hh1Mmx/G8RZiKSYMjj0vGAtD9nRsckpqRUYxFUXuxuHw0dIT+xxl1NEUW5djMl9sQX4a8bDRxrBYvfcmUZ2hZu4ALBmUMhQXeb7sJmis7DE7GLg6BpE6lQ35V+N1OgsoP4I0OreaHbdTYIjXWhLIEVkyGXWiV3NzxS1N9V1T6cpOEcYxHlGddrSgvCNYbLY1zvmCutHrCTvXjW0xjNITGh4IMkCOa06U9kjj1gD787dwmS0L+HPkHMlFZDT5ERNi2ZsDIJ4eiHPSDuXPieBsgpq93vtjoynZWypP0OKTwWmEXRtyJ25Mp1lTRXxOmB13EwEiOTC3CxxTLP/NIH7dGUTfLR1sRg95ZpXAqGS81kxcWj1Ne8euuxVhI85jEVyqMkem1CiANSk5ri0gsgLAteBm2F1lfGbzOdXYGTNx6WI3Try3DW2cFeJq7wfbPZs798Ch9G2vmgCU4V0nofM/CmZJEYwOVnUmMKF7Fn2X5g1fo86bvbyKqIsHSCnBqQxEbphKZCVFvGg0KOJvX66bGs7AgczeCY+WvF75+zYuwwxIFZD1jRJQ5OJUvUiEqUG+Nu5Ihz0w4+HbY8wl51NKmpnN9aF4nf0tUZmk2GPbGf/6EDdlLWrEXPspk3sjGXzRsh+xy6iHT+PXpsTzQFsdx0PE7ifmKLPj0wh1Z2bOSP3qm1Hvj3rYnU6X7igvY5UOOr3mXJ0RTHlwwBR1ScW5+kEE6KOray/BDtYhOiLFOhDtynbxRAIO1geK6q7s47lSVQr/pzcatIUmHgL3UiLP6sbPArGefn/4Q/ak9YtfC3eaESeRhmUXjW7UVTH3SNM3OYzYpl/RNa2pZNjvUT7b3zObM4HY/jG2JpLKAxdQzE1ESEsd3plxWao1FJzJGN+QqZdyiKs3ojGlBr4H667924GuQ9YWY04jK2IqCyf57+a8lhoPueNq88O6aV2fjefbwNUglkBvgtbSfA2HvSnxCl2V/bNDnG/ZFpLPCksRjjlTLG5OgvVVtBDNnBIWxgkN/lqiKjGCUUCIDJziVVLEzbg0p8oMzwjNuKDj8GuDLslH3DtbGHk+LCow32oJZ4OZgD3nKW89B8G42HpC8S9v5IMLhPBvnzZ9hid5Nu/dOYGSoTWYE6sIrX1IFFelVDAWwpyNVqAm0MJPwz8q0JiN4tO6EaTIlzzFxRp7PBOFLucmw6tIFf7j9S6+w4N+dtrkYHuv0NVY1IxgdTYezM/6wQRIu6+sV3Vm+6NuT9yCjerw8mR12gcv/GoRN48/RwZRG02FIy88kMXPJ47bIW1/CbaLpf7p2gOL7jMRDJZvOakZ0EAJ/Z2KJ07ZOtodg5AnR1dhAb8IQNDSxtqJFUifrs4ee6PzvhlJr7CLNaA6BT/Z+nuTjYvfm4u8fbSfstwM7M0zNaBhu6Rxc1Tp4XtnBACzoOIgFjBhXTt5GX+LW78dhGbYZxb0GyvtICEpbL0yd8txE3p6wKlTz00X31nTDr8CLgOd0mJ4pDbo0D0rCrM+5ibh9fe/k81IbYGafJUPmof6jQH05nBpGDWXBYxtoXAQJWCWfcjPjPi0QC5FgGtL09UTq6UQbK+RGzvVxhRHFRfmASNNi1rHqar9y6XpIRURDi2O7cd2SyWCJwS/Kp3BeaJFrbzOZthb4HuRClfmVE0fH3qn9D8UpH2XJOwlGyBSkBcKEeqmo4lt5MoBKacuBCcKBiXSUdZPSY/UyTF+OsSFe/DFMu/YgKOUbd31Xi4IG7wRVq+QTl1ZV+cbe2ufNC2Uf9ynGt3EalNDe/Z0dIXaj4/Bxiv8idpEFLXGeU//SIApjwst+Mip8ZlzGNPIXKTpgdTQH/jtJVnMy/XFKermRB2c6fQ+9bJy3GBxUjfX8kpO/S5t50ddY9RT0qCBdbEnS8xvXLA8rBFFVqFrCQfqgWVjjII1iTuIBQM0cFIR6Il+wZc5P/H5pXjKp5zugDWkIdc3pguWd+iwkXTt7/lIpm0+WA7WhHzeK1nPjooAya7iOr1JkSu+zuXhNl5BjZQTmkmDAOfXCbSGNXnfSlyObkMvscdJEiAMGOLTZvxMgiTKAINyd/TRRknRmgp4QVaSZwts+6Cuny5K/H8yO/O4NG1k66rLbCbjWkTnAzAOVBFLCTIu7+t2YEw0OwMyLyS38j1pmY1hEzOWILTJc94aJ1IMY5rrhWH8CucqxyFqgX6TvCXWqfJMvg/awdSawAceJWd4c/gKeIQY5YY34G2OWtRcNM531ciYcc7RONXTS0IzrkWfsv1Kbx6QUzxBzSrp/Qrzmuz1M51nxpW6eJ9y16ltvTUcN6Z24Vdf1IBSIGa7tNAxMnb7SlgGq+QKmuXHuaa/PQjadFfP+AdKDVXLdHt5kOuZKdKPi3R6fTYXwrYslsk8+t3mwe5L0cbMNgzc+5M8uZHxgkhbCfIElhG2WIQKrK+Q00W3DE4dftlcNdoKd57Sg0YkGexHCssswX9qE3SzF7AyIPv3wWsGs+hYc35ffLvvtuZHkd7o1ZVO5WB1XospPz3zPMzQ24oFDKdlws0DZ3CtuEHc1ZIGncxgtRN4STFsDK2pCsaVFGz7fNaKyhIYNGj6zZzetJ5wE9/L7+JsDjJUafp3wJlvZckU+SAeJzA//+SjvnKzmdFEg3FhgxEizTcUeaUzMnLNxO5PD5kTfciZAjN47rCcBEktHPECoar+T815BMB7h2R8K/ExutgUOdKDQCHbJYShj/eDSp4yQyaVYWDceqyzR1VjCPvMVuGYn89YXN5dqdKUBONBDb6/Bic3Z2Jc7OdFSmq0JKfCzWf3NQZiofufvUmse+HVtUsqwx78XokYtGAUWckWk80WsGFaTC6nT2UQUCWzOtDuu7Aw6+c6iacnHSNxsx3HO6V+tkPNIR22aEgFN2qbKJDdyFLzreKZCS0pkfjyfsDek8dyxnQAJhCMdkST1k305l3xgB7pDqyQFE8XpXzX+NUKBhEEqBZQzGSTxtRCRWJnRBcPmpp6S2R+s45IDBflz/k6iCuLRN/KlebI7FmmKQwMM8zWUhfIdJzHyX29N5RQKqCq/Yjmm/VkfFfaJAtrDPUnoEjhclfeauDKD3rk1WAckXvyzaPdWpSDAK829ie+DSYd2ykfNz5qvLIdLDho9xMUql3ODEVRsyqAonMQvBZ7zHptksSjp2cWCyXWceuiuHIrQzFAlYK/ixF33d4ZKD3oIaffGAOJ2TEu8kR+/El6here4dLMHt9+0z+dZu4bD20coDcapzZlMZUn0zjPjeqw7hkUwc5K2K0FBLviZfCmYbiDRlX33HNbivQcMnsV8hDw8U6TUO8TB1bJp8KzBUm+7blzI24Kw5POgWnaTOLSQET0S1ZWBL3mC9Wng+1TKeUDCATjo6p9B9bZw8wgiHMKpr5qgbYSeJqOgGnVE9ErhIu3tfLqfA+/vzgXYN1DYm/zlRFYefpYoAdWnyQqYXaemViD7mRtagOGum0NN/7HQ6N81/yruiMiymyDPfvU3mSKnZwFXkqyYlLas+nMHpFGJSF5FxNQKi4NN5lIQrqcnqD9nnPC7QHqz9wrjh3xzYWUtzXpwMYJ6ZrNTNpg7XsbsL9/rVj3xOo1XMlsqSaqpOiahxeRt0r1nGA33jTKMwzZbSkDwp5Q9v2WtoB9/lfZOOkKxfzF/PVdPVe97HatS3N9WWwFs+Vf9eF8Ek/6h9XFD0rKyYhNjMcgcrZZ1Tlb6g3jCkrdXyLOTtirOOSCG3ajNnpR0XM60rJAW0nGwfwEnCMxIbFurjnqfvWcZsSCFOStz1a+fuIXRC2VHOejUALbluoW1Mya4AHolhKAzrm2yzfocnd2TsX33JY/h4PUCvBGDnULljWWOA6Z8mOJ+3mGaOesRPN4QYjbxZvUa3QQL5qqx+TMo4RjghNoBRe4z9mYuEmNWCAMFMDW55irytHRwSNJ5ALqjsnv0OWRl94DBN7g40aajp/C4A9XTlE5vf27QHJVdWolTljLFkweM1ofjBRLu390DCzMxLyGk1Z4JxNzPCO59sbd5pJj38YZWlomAksIBSSClBHuGgel7Scz7tkZilylaArQfpyJueNXNmJxVFDCBVGLqC5rsAZkLyuTAMWDRHHVewymWUB9W0O/l3KlSgNyjukYl08vDHwQGB68M8+i/wZRbUPE6I9GJjNE4+u3d4xVr8BzJ62jmicb4lEpq2DvPDin3pfX5UtykGC8o0DtKhOAtLK8QpG7SqD7oykBVMwRl8a8UlFdyGRY6QsVDAJziQGwQb99ZDoH/IQiF01aMS1Pq+Mbv4IeIJL1waKwuPUQYUL8/1Voc8/pC43No4W99JE+JJk3mTgsoBCTzKnKJlULhruY6cybvLq/V/St+SRrmlNf9E70zu8av/cwN5mG0mnMurHPbH1mJjbFn7M+NXjR9n4y1K/Cqys5F7I0DjzCKFk2tCOSvB1SyjiZ68sIu2ke3sfeaM0gmeLAbewuPZMvXMamSGog8N6DDLfAbwnq2Nwd4QbMz3BmYoH64JKDVMlSPnhMDZMAFpTq4wmeC1+i/+EzCMjSMe5cBcQP3XqZZ6/mmxFc2ltgKgASfyyfyVQuM/IEvSsK1u9vwzg57MNY2MJ4j78Zj1ry7VhfyzWgRo7RBNCBL4P26HhIRnspAKiuCQ7miXmXLigr0XMele4N3Cgi+jmy8y/CXgSUTwUPV95z/FiYcj18lfuJhmGjBF4NQYchSQhF89/BuxdK9E2V0UVeZEnbRIKOnj8XI/k1aybF9/otr02WSioW4gX9S7crliMTpc3RqRB8Kv7Iu+5inGA6VbZheGmqEOx+ngbL1EvWzD7v+6WuJaViK04+dMl3dVGxy318JUAOruQgpZXAeEgCkO4GvdH7PAkjWWT89Hu4m6oCXXP4aMq3DU+xH3D2X2IZWaWhVVTsEsxmw/JsXkg7/iN4MYvwYx1FiD3fhiXPidcKnhalP1OXpnGdjU+fSMfBdguD5kK1YIduE8E2eMHqcUY38FZY0zOHTezV0m7AbI0RXDKLt0wnD+CeX/oE7WjOdI0g9ioH7nUcDbBM72Q9TZBtRK02YTXcwNOCrqH9WjwH5xq3shQAE6JJwjnW+19VZm/PPDWBhxDsKlkGSl9W6HWsy41gjrVoPa0sEddpIlDzlZxbDQYzgp9GgcLuofIqi0H0+5ipb8FKSYBi3bvwAIwVM+cfupGccw7LDFE4SBSNQzMQVGxCQeVZQ02X50gG2L1mtNVd2H3vGl8XynoBOvX8Ad981AvJRjbENeYFxejqVHpHaWsInOaWm/FxkEvDAChi5v7/gzBeZ/EnxzFPHBH+k7Kr0fhoiFOSb5E2aPr1Cnnnq94gEAJno0DnIZHelYlRSQ7je6AlqsCmg3l3YWKpO9JorkPTiKaIdn2HtkdHwn6NLtG6st2XWuU2QzsbFVXiLod0Fxv3HJkd7RCjxRpAa9UcyeF9jPjCiIleB4XQfng0zZpA3Su5vFGx/zQoj6LQD4x3QOchvsWYgm2M5cZjigz4avYtHL8JD7QkQnt9xFIddBwj4vjgT/+r9l+zA+Rf0uHZSShuFxUBEcMS9J+OaiTCfUEwQ9RUCTIF181f9sKpJlC18MjuXT36vjLiz581T3c3kzT4tMKnSRuM8UPDG/ZzzHDGd5edBz+7gkA/dbyvh768IsVfBKieZguQnwZ9kc2ylLU3Uqky6xOS8E/QZtoT+8HffhONXS5Ua7Ej6Lelv5NdNNzmR2oSDiHC2hAYpXfZ9F5JNhOddnFYCK14/64sEHr/C41UDxl9qkwrAiIbSM5BdKSLTA9KKS8osETeNk9hqGR8GLthvpowri8x65Mrhxvt9PlEHfx4OS2b7wtk2q9pCm/4QTo9np41GYZXmDQJrReX9wOZ47aU9a/U1RB9qkk7B7c6SOKVwM7Joe/crocNlFstEWhf08xvypAqVD0jI7c8VfihL6oI0vVux07cctto793IeTjf4rdTZ3OMA5idlZkE6tYmQ6ze09ZS98pEjLvChxcj9t5+rwbCDezWV/CHoFIYIckg5xldnoIu7WKfTgZ5kouo0RTqvbbjXhAG7S06oh9YA0TSpfrsF4DPr8XG9kAGoP7W5hEfhFhNjGWcSpG4PxLkCXUSDSsg2Q9pFu+Wmh1svJh6zMJlm5SSf/JqA89VGll9noQdXLfquawI7YpVRMY1dGt19vwGBEfwc+IeJ+Xm3UUcfDhMocBOsplGri1ef6DLuK8Fsf1wYUJ6BnrK7SuSiUUN6ad7BOmkBUF6nJZEXiP3CCs1A+oT02slNKamjQENrNkLRvA2ztfkJWcfk8uMIFXvEtnYg/crYk5D1LYxtn7U66ZKYxMjmMu2TqZMf6ZUjU9RMhx1+rr2xw7zYtmlKTxnkmSgMitRKHE7kIZkkkjrhlTrH2SPuoMkT0bLCIRPCWU5DxVdcr5TjFlCirCJ/n3f5O3LTWm0BcGH3Tbdq9VEaLzglntLXxkGOL2TDp5HDzNGjbPO7w1Wqy8ni+rps2o6WDoYBMa6m2bw10FtluNwnwiGbGr/013vE7iB4kso+TOeDyotiSqEHcwGhKXSgOfXl3b5C28NDAJ/FPhsdNRlZFGBUYt5UB6bMc/M8mDdMc+cVnWr5YruHfgv4jTvJcQIyieKJs67WxKuXtSLkhbmSqZPVYBODhufNAFNOXYZC/eNVBI96mnIJsGiWsNInBiQaAqgU5bJPn6iVqZBe9yUM7Erf9z63OqAyG8I3fbx7WM+oJAVcE0x/iGhgZ+pef22cjmKc+bY6cI03MEBZ5YAyZ57sqSxNxGEkJLK0+pAeZ076ECGjQE3r9zLxDGRVd/q7kY65DGh1fuijoCqa/3LdoSJ7c9AVzqJX1ZNpocUbXg2rSiBv//KylgyHo0QlD1XTcfmC2hTtol12s/rFhgEHuNTXNfkMZvnldA2S2TApL5+GZk0NZg2hnMfnsNaVxpPDfCeG6QQgZmLiXd0ivhSkREHZVWOXQBdq01Qpv6fKdRSq5tUIaj51Q2JoLbgi2Pzf+7CbrK9Rtm3L4D9XWJBw3LWGKY8omRVEIpSeRu4+IjtMqgoWbwzbDifA6jhYzEOmSUxK05YTz0HTb9SE3pOt0X2wlKZ7SPXQpuZvlwS9nf/qb+Lbr8wVHAMPGJqy9/ftSCSLXu7IoTVlJhDctwSE72uypri0Wq8LxlzV2Y6HW6Tr6a5N4U1RDIC39vE/QmpGsAuTUw4FeeNmeNKDxGT9nfyMv12+74vI0fDaATcnOtnayDmC73Lrr49p9XaexD3S4eMXWrxd59kDod3IHQPjGTFrqANBuFrZ8yKcshAwM8ASgB4/0bo0QbAQAMbMY/bKDfP9IN1k2O40BdcU2OJjiL43rhV4NukY3EOlynCmppH1YWar1SWFxyv8GtZnmaf92oESYQhdKiiNljLiO9r1MHEgCD9tj9uM4r6ZEr54SzaRb4ZqBoIyvV+jMWHuTFxkkGVDV3PzMwZPgKRucF89L8rLKn3FaiKfTAFujPIsTQyCyNyzqhBXtPKwdvpfbs5rb+o+JxCrnMVcM8MZE+kEOUtunON1Z6y5SkuESSurqk0XzIaHWua0KvHmOf/mbaEATps6blFmxSS92Fg7/5HmGXPby1Gakei2SZVegNcKO5ddlHUgX44vvFgHLhXeQyJ49lU7WAX2Z/LB9DGXuPhURjAtZKUeqhLzWrFNepkCAaRACJJjslkV9xBHtDrvasKL3tg7R6XH2LfDWGRCzrt2lHQMA/WPbC9XuzWca65sSAwnazC5sdbd3TDpdE+QtFWJWasCPizVf6rNBIcearfeQmD7Y3Oi9il6HR8ZQDlul+zghC2zttM5FBIxb2fyb23pnkuUMILHR7ynJ3sfKk6T8VoCMGUNDV7N/fLECG8x/WnEndoCU2BsObzSnDPdc9AtjiUTGSOyB6cCVKau32U4pmtyqhcNEdWEJCMGEB4jpMFABA/EmOJG2JIVeuGxj9F1VuC7RjuSufYiKQJUYGMum8CVXaEzz2dN2OV07a0KGRUF0oCD7+tadvqkuzk5PhfBflY/0wsMSvNckDPQwrScZ2cpn8BeLfxMLMRzw6Yt2Em9LcoseIAlmrwj65e9jke9Kgoe0aOWHrTYupg5vLc9DdoJnOyg8gWsLVLcvRMq4JOiGn1cL1QN+HKw8pqx7oxqSuC16s22ps9hsOfogseenVq+JdbZLLGAACGh5frrrNabq/X4/oWrNIBXPuuKjLo1E1xBZfEbIdb6JlUDiMq1JPD3bKuB1BO0RDMDTj1qFLCVuAGT81CXfxPr8rcCIGywY/Qt1FeNh3IlpYYonUM4JfiqF/JXjstcSYZv9BPjelb46nH5jvUIknVnbAyB/VWc/DOPK2BgX90u2bjw5Xq58QvyamRrjBqGBBP53Phuqjc3Dh3F8VB7f7jDqOioMx/OdTSBb2E7aE9LsofGwTb1wvYfK+Ed32B9HqrzNv3hPSmn5SXfeIgTXLeR7x4/fuwzY0AfgQnv5/aouC/N75vOUI+X8xODs6G5XXZYGB4PXYU+l32d6dKUQMpYTlJUWGDC1s3PTy0TkttYpHWdFSktOkpmYHyBqHvOHd5W/JwaZAayy4FCIhGkF62BYVYgZCWn69s8EkWgzN45uHt5T51rFdwFemjPNlgXz4KIMFTtXi1aT7+pm9LtevH+KPd+luc8J6Sd5tWnpXC5kf1vfoG61ONKOPeeqs61AefVLgDVKeVsZ3Pm1NU+EviEXWg3l1XTRpZqYRqhcR7bZijxJemFcY3X3d9ib2uOWPaORvPJQpmazYopKDo2Hx+bXzmsi+E9uZJnTwBeQ8hM99wDJHSkjWkGyZMlbK/UMh1eHGXZHDKL6zGxknc35oOWemdVY4FCB47+ip/aown2Siy6jfXFDr0UyzwE0duloRRsAaDMidzG2mNqQ4G/RcoJfG19uVvvPrp6t9fo32uKB9dtq1w1MZD9SbnhEhc2+sHWBZsv4hYMwDS0tng36IX1oRPaFwzwFjj8TQDTUVuM7PfqS8pNSXAvc0FE3kVrZpNrlDpqDTKJaeZCDD5gDLw7Uy7C18iQJTmwzH0dXieuNDM+Gm7QY/fjjAOqGZUR0wZxE4Jjb42Fq9vunVT83mIWpf5kYwChfG8SQ10gAqKnFYVbeCjDy922lX/5Wh8flrWOOymWYSKUHvARONcEcI03G9sIIR0DJUMjaLHgAHGzdFC3n4Xo0I26blNwlh3PB4UrhuoWHSSQOseSHlkDewrw4vBEg3wVUFlhGqC4LmQZohDG1Iczj3gRxhxgJaZ8yaMB2udQ9egEBRMMxiJuP7AuxtOZLqHt/rLLNbQ8VEM65E7kOlu7mJ8pxCcclanQ5286pgk0/G5YIdj2eUfxsi1WJtk9AYnClMUgwaDIpstWvIMYZK2y4FdaNiRXW85P0OXDx69zom1IV1TRTp/hF7rt89GfdZgHAGpTcgkoNTmvIU9deyJdx+cd9AMLWZ23D5IWJM7cO3NJLaPgnue1w2cl5/IXFFB/xbV1vZlAZdZ3k3Mx4Z9Ls3Cpq86rRHTBDxdz6zCC8GOZN9vjKf3+VZllv9vZ4frT3/rLdJc8tVBbJwTCwRVcUTUb7NH4iaOkKIZkc7UF6Fd2ZESkAGSo85NA7ovc4+2SJ9tgcvgidB6LMJjW1bsB+mP3RyIzaKNgVUXigZSz4JC5MYQPbzcw7h431vXTlz2hcy9D6cN8rW3opvmrK3/T0SQOORshqi4Zd7SJ6U5v0CfZb5l97TyC7nDXi855oIRYXiCgZNfxzP3o04uBFIClEVrDjkjJJx9ouyDnIn9ADz6h9nqkGMKirrco+SMjeX13+hKaaHtTKtxu8dp5VR7xq+W6/tFXuRdxKMFC7a5Xr795EpZyjd+BsgfUatT+90mpH+laIIo/bse4I6AXukCdMBTpaXx6NbTzzEcannela99B68vZhE1rJMYj/ITh8s0mQQ5AFAOLqlxfkuzXSe+vZt/bZ6Jq/kvHiC8Q6Z7/HQs1WCk/LFkKOMdVqVJEbZECe3ogNQfdXSxqg6yoe0oL8A1OPscuuzROK6LZTcYR2LkeCMZjCBmkY27Y3TquivKajm1D/UOfYngHMKzOH/Vy9KD5hDmIPhDQ1nAP0V+0lKP1wQnKYmUWPKmCZ4urAyiDFl54v/XJL3MRg4zB8poJEbqAgH68pJzD20Hw7ZPV4vcD0uhlPS5BgJP55qqU0C9j53XjIz+koMSwA8K7j0BqxGqZrzxAaopYSiHIdHzcZfJtM+F9IfzQH9Q2tExZdGS12nx7//D99I+P0VWnhGquu5aCgU91JbENdoWvMOdj5YQse1kLkK7rlS3HU/kisHwicUv/DZ8G8tC0JzBh6Fnsv2LK/EOCLGEzlZj3Pz+5mWuIranrw06i9jtT3Y2V33K+5u9KVZZzn2sRcNc3KeSTHR8hsTX9dJ3xoyBNUlmIKxkEkukYmaPofr6u34SnBMOT3w7g4r35WkfhlZrlrl5Blg4QTpki9+ekN756SaFW/BLc7HwAzX9MH96kUr10WAhQGEaVEGL8+i+iJMxi0ia2U2GpTe2mIDyOteWu2xzM8kRg62lQNcvZLC21nJgQTcHZ2gMUDZVl3qznM/xo1OCtG/p7c5s8lEfgBXvvquVxV/IMFg2xhiJpGIBSYE/2CDpgT3WfTmYXbeP9nDUTWHEnMqG4NXXWFOLgytVELldsY8joFMrczOA5MsQl4InxK0yswH7LhDRLIQ+u0NKlIruNVnO+7rwaWfRmPxNtOfwW7y0rSlCJR6p7qy7GI9KxVhUnnt5dHX3Q59NWJJcUxrudDIgnS+2GapGflZLnQotq82KAeSpQTheYVezV9KoTDGrQGtWpg/ZnVQPZFh2jEyGjYtxg1wAiCUMlhH+s6UlT9RAdgCXF3AMaHC2z1LxV7O+Q/cmg0TL4xrKpwDFZX48McHgAJrswSsFIOWeBS7lieiV6rzIdoHm7e6OogcOaAxGOJL5fkFMtg4++dejmpEQcv9jVP5N0lDqf2spXiMPCaNkK9GCQ3Kmzxj0GFmJdv/NUl0Y7toC3iJa73FA+w+VYAyG2/1165H2F+Wbt9z/Pi8KKOt/Dfwpl1phO4JqcI427R/Y9x7BvgtrCNbe1KA7lO50pqNbd76qhmP6M+CDhUEF3EO3N6V3bm7uXnCJjFqQFWz65PDyGiog2PSgnq55SlkDGxHIf3JWPFlUHRzn46ufZnRFgi7z/iiMqAKX0RtErpszTS4zApGEagbVJlCDPtpgXBnz27XrABG4bpF5nCKuaou8vqkWJ7zgTmTCiNZdYr7GF305mBpjxYdtTypFEWphTr90KwFNwjcON5v5m2l30XIOkhALAClUuEy9rTHY+HS6WUbvNwuRfQwQJd1xYInbYXMvpz5aUUT+nFO6sBz/ESIaSQ/WRqaLWOmywe4FWu79tfwVLzfxyMYC2cpbgOXHbtXSu1HiPQkC6eEDO0R/Qm/OmmfDYFx8GN5h89XLYyQIaJL9oryfVo6x+obUb7U2tzyzCbtdYBTpGWaXwCf/5zhYx9IdUT3/DTKZ5d4TOCXwX1G2TjLTXG4qF/5g4KI3lX3Y/pNFtw7PZiqz3irHbul8nILGWei7VyOYJIKEckJk7B0sy8EoxkBfRfC6JzYomfB0JVo9qWdZrCigrLlmGX1cwri7fGIwFYXbqgQET1tM/qydQsyiPPXiCkHJXYzFfmHixCZa0xnCQKP8ySsXxtYvQzjuv7pC6nwks+KAmkhmo8DWYOkfosD+G8xmSH4Tp9PjafqgtJJL3Qx71qrpXEJZetpWQIxXm77k+WH9WJssXE+Xcre7ZlJbT7MFODBkbSo26iJRxH1CCJiBmMO+wQzP7qsh4kGNfujYRCMdyQZvSCGg9FDrVgw0GN25f0PPDIQpi6iON/DBZpPmay9ise9mdzj76SfVCbW+WseRloddIGld3f8swUj2dN0ZKJ0VdT/4AFk3OEmGW5mP69JhUbbpQ5K8QTPf9dHDLqk9z/yPYU8zjLh3xA6oM4X6opOf+D9wR86RhXVL/HA8jH9IlMXFV0ehh3QoR8ymFl9lFWAzCBV8TfaVkYeIJMFTnT39pkzz3VqvGM1d6uU39EArNw46Q0I0d0rcS5i4tX9PukTf+UBmu4Y7fxzs5wTYwjpsQbNPqDFZ9qTpDKJY63IzneNRE+GG3BrQh8BHJFBTCbJ7yUsohe4t6PxRxQP82vadViQsDEdJ/UaTlIloZHINX7xdpxeV1OBa7c+cpsNb0CD+jjkpz8bu3YLm5OSf/nBuAhuq0TUy3FnvheAu5ljZOUiValytx7WbXuSPfNQ6MGtt8/VjGBP+ph521v8jb0tlq1PLx2vzps+cMfSAav5qzBXGDsUQNx2+xaBssugZb5shv5q/5tlm/pTVVSIlOnIFGzl1K5lZl06hPFa1rw+txsYUB/GxOWTjTnzSOIzZ9FLHF8KvxWHEp69dgMLofCMP9QTGxnfXZuwU/Lj59JgfIfDsYuCMKCqNDs48Z5z5yY+KHcFwwKQnJxpzPFGWSOnBvN92eXMtRgXknXptIFH0s0oB9nNbwzzylEK4HR2QqcLpvN7eqFwhQ5jzCQzzz1WWDeq/YMjKaoEVcdUrBia+XpzD7Mcxdx4M5DHDOFMM7yJK5rp+InBKa4SzwENH8vAnqmu9zQ6zO/RDSJOnNAhdcpV6qXrWOlP0V8sq0Uo3y3ctZPpfwqxkZQGRuMCQNbzqk3RdGRYbvI/CY7Lk79e/kI8X1bUNlGo377oIEKInoXw4CjRJQeWP9d9KZgFaP4kDbHlI6/bcgZzdSmsV7Q6JWcTpHC0hry8WS9fExeZQn2Eg9cDfVYfkRut0ap3vtlId35Kr1EuLrRYVAHDkbZg1UFwHufXrT8bIIWFVTMRY+HCFrEoCAE9XqUqT0QHDOaSUe0QHUJ0LU7FQmTItf2CTCs1ZIZ2ikoA6RPbzi+DRYidc2P4a67J1jj69/5Pt8oNvDJe5LwUiH6Tc3+HOxnJAC67a1Dc4JCo4+yfZN42wLfz7Bqe3pgIBEZfjfR7KRZxA7k0aPDUIjvRqca9lkZXFZfhNejVkeik+CxnDxEHh/2TbUm1OHzTCUzdhmpzwkxqsXwJKiVYbr1JIKJr0Bd+SLUsaxlQORw40iQwipeFgZxl1/ak1pEof296Se+aao39CX0LuT1bvmDu8NS/nlEstSFMHZRFxd+qEWA8+JXPbZJnX3GQKHFhhX58W3qPmfPnodbg+WILG8zFb5D4ywLI0N5jqmr/DcqY0PuZ7ba5/QpNYh4LNHm3GM5py3mYsihV79GSkH7UPK4a3VIjnxhCBH4S8QFx5TprWRWieZE/0jknRs/d1pcxEoP/ihTyU7XeBxPaTV97aDciDcokUX4WMf8J30XH2YsV5AvlVvV+In0rKTjRtq9B4qQ69QUzKr84wSzDJumijz9YSOvSSVWisToIbKOHRm6q/DL1mn3FjW7Fe/K98J3t0gs+o+TvIt4UwKpcar3+zuknRt/MhydzpAcy+OMT8ggZ4xdOlg321+yy1ekLYMI2Y290HJdsq0XzSj8fc0OZcuuI4m0YRAOKalkzk2LWfgAXSXtksISrXPuFLRS884nSEHhJDM4Ve0Tcakd7/UT4dqMrEt2iU90oGzRUP/xC31uQF6r0+NJN2ZL1D33TjOAPYgMdVOW0os0yAsJ/GF0RQv3Qntl51H2+tKsuTOxoK/ULxwK7LwtdS+yHosqCSAeQV1xBXIHQwR6mRODg9Z5ACk8zJuFyjUW/MuWstTy3fOBo51vnvYvulH3PVgM6tP7jlwZrwKNi30rwyLZdpG0H7wDwPqnS8ElYuZycri8bREN/wxxPMsdcWlaPUCKpBuXAxGHQGaxFXNurGPtKMYADwQlobLmuzsnxVmbXamXlGPgVWxw0I0yEMijnJjhoGS93bzQ6yGra4hJR1dLtUeixMQO96WJyxo7dRgeW0MX3bp8bkQW7Dt/1g5kzwaxMLFGPdfPA4ZizCwoT8SxiDCeq+ew8a+/qLlHzrElTScvBHNNBwSCNaJqpBwwYJBctS8bR+V5VCL1zO7pwpzYMv6+jCO9KYvJGCbSY/zdXnXSBM+FNX2f8ghdrA1IsDrSDrWyBbIFkPgdkadm93NAgxWQB953ZEx2z2jvZ9i+h/i1lnQ/YJQeHlL6a80+cAUM8zYK4UPRgysDlIcNeSwGivxnXyWnLT6AjAHUYHF9OgKztVZ7eBhzixD6j1noPmY7gLr44+QhmFUUoY8VDoZwNti3sH4rzTKppbf9AK9X/u0lA3BgLUzSXmE2jL1xKXi26Mn2Obwl451z6DWWqqqCMR7VIKp7E+VtyA3B9zAlPvhoJJjqtPDd89cmCTWOUsjZFkyTh/csfWtuMQbNNnJ78GURF2fNAAK273Yn7qL7xy66uYbwsyzudjZsfu6dYj4amElHaflQh04ZZ/Tnp/d4MOApRiSwn9LkZMbsHpCu39E0lSjMKVWM3z2m17dYHZeEupQywKYQXXdZr65AAfOpRj/fax2LqPkl7VHJFWLqb4AjE4vrGBfON8TTHafroYHp2faqvK6k5TieT5hPHJJ1109tod4VjX5qziutgVVJwzcTJZQZqQ2gnPy8g6DUCvLB1+WTiAFzHFiSMo9XppJH5ibeK9ue2F3wQIOgX01YeZekKhERoJsV6/A8yxqHgwXIUYZGcZnNTV1IOmqsUKF38s8rJhCCPkMoeLVuI9cqvEX34eKa1tBxs/Eo5a8BktrFf2pgk3ogMNNjKSxYDjU+iNHTeeMoLM+cHoKJiqnRrscdx8LDgEfMj4gsAOOQHV6xu74It/cAtTnQZEYT/LpgkRwcrll5p+ftTyb9PwYrF9RyfNhu+MTzuipQITYb0sG8cupHuGdwHWKGspq7NdXm71GJCE2ELM3JCy/mTvGjBmNvOxx9xuK56jaw0qlIOf7tVfX4Jwc5BioBtotcZlvdtFZ4dntQfuyffodtsw9dzfXcoH9lMtCZ1dDiPR0jwUTzLvpz0vF2yVSCf2UQSq5rWpRAcbJ5wLIMDc2KT8rfhLIrK6/95UksUE9S/inf82g9hcpwUEOt9eu5mh2qvYssOzVNVBOzLZrXkCw84AYBY6uIs9p+O5gitMMFLClCtNJzUCz1J2ziNvokKUJg9XKIJO7ruhz8fL/nyuArVCS0v3yNZxY0huay5bHZzJjSPSvUZ9zjXO7FMSrYV5XWMhPc4kErbugGVpVAbdT8/MQ3C6C6uwFPjoRnDBfq6YHUcfWFe5cagoOGzc2TWwBiXUuOGNAzCEWtUQb29ltXNciG0QPzumENF4JO1CUG0R1OxnzSuZgKZ02tztLM0k1AtU4VzZYFgSxH9RnWDXEIwX1/MXKt/uKKVIkHp1n71iJvJGSXI+G0my5NTc9IKsxMy7lw0Li2161PhFMbqk+JhUmUu26wzIQOSWoRrmQB5y3UJRoDdWhmNu2AHioHmzRcaPkGEoGntqW0VV7HMykaPJr8s8sU6w5u+NGuywHg6ZC/f83wCLvIelz5Mo7XBSV4cfewt3SIJj8ESINPycWVlafwRenMOU0XoycY1UP7Uouc64wvTbS62x7kBKZ3IWuVVC4hjp6BFHySDFB9s58Lf7zY96K1LTnhbrwgzJR+I3Jk0KLYjk3faJQWd9EE0Z/vdeomNFjoWcZ23MksszInSFHPijReHohG95EvOZDP61ijVGG6C2a/VwSNkarP87dn4hcz55UY3j8K8Is3T5fk4453kzC0+wfteCkhxIGIBC+dRC8WvHYvPBbUGzata72Gwaywxv7cMYCeqRx8izkLkTGG2KDkFTMydGW4DvhzcpLQ/ZgaOHGlHHbMkw/gVwO0eVCp8P2l8fv6kEdZ4ok4TZq/wlKDdFF1YW1QPOtSgXie/Z77umwg0juatLud51EwTiUJUVLoyw/liD+Ehs+PQ5ARilR7/KHpjqjuevZlb/c8MC3HQyGQ+3CJNOV871olltPxhz8tXP2quXAX6OpXSwrr+NhQ3NhqgDxz/PZQitgTG0qCzz0TOvoy8eIaAl/NPJV2/phw7T2GjD1Bqk4wOKwhptsXawTWgyfk0tt/EVD63b0DBKx2bQQVA8IK+ub3+A6CQrEQ6r8GJII76VBmRn0n4QqtA74ohuh8+9cj6SJRUq0E3pnua6PaBAV4rbH1s/XRCbsioyjouOZQBez4EVz5Pf6/aCO4+Hajx3tyZq8Y5yNVhd/8TXVNsrzWKPuk0vUwW6IdYRIEHLquwmvJ2nDEZO8EK1eR/4SV29gQe15soCpUPQtZSHI4gqx9pNLDYhlFRs58qRFFXJach8Xb1f1+R44fNLycySsMm5RtN3i+6zJuJaYmPgrprATn+kGa80eLVepmgGEq1TNRghK8UaR2X5Htrf09QnVXVVOuzeINzp3w8VaVm02kdugAo+WLPJgoXMn6A1RKrAf1m0vbnkUicG3gHA5uhRAc74mFgHY84iA7VSzWjpj4Sli3jQZAYjRFIWDHYwuPtudlFMthxQqseVKEYyeJhOUqgu+b44DvccQrj/340+M7Wakc64V9Ckqljtx3747zWLB4/I/NE1icDFvD8NA4mmkl5udryFqe1gx8R1Jut7qxoEMLX8w7JtDgMBK23JG6OMCM+57fx2WA4l/UItdVgV1mXY6oE4b8pYcv8p6QIAJaPWJSQfYnAiz+pkbLcPqSfcJAnAv3ryyqIYFcRxAUzr4n0czR945L0ZStaUVTfxbIsyir9Y4xdCuv/TmkuZsEr0jqwy/hu8yMnHxPI8Owp8HAzPu0uswcTRueBVaQzLwSuZgNfGdNJRMlYSDFsil19C7mwEF6qr2oqqRoE73Cj8Hgf1jqqd/s+d+HZS6eipexEQ9WVezJI1CUdDzSjAIPTcCvF4WAcUxze5Ol9LFEkIicuNMVJr5K8GtD65rIR2O7/KU7I/I2Mou9DxUykGN+1Efx1qUKKu3u/WKOtlnc5XIxIqu3Nb8d/4qYgvPbXX3MZZkLIQtCQq+N+VBl/D46E67mXpGXQoQMlX4nfkRGR7w+jeFkDhHLTAL1uFQMOCmoAKcABAJjoeQG7PKADmHHOAf+24gKzDUgBAAAAAAAAAACwoA4C0smGAZ0YjwB/aTUAYAy9AKfX+wGeTIACaWXhAR38BACSDK4AQYCqMQunHj6RQAN1QQ4AonPWAwWKLgB85vQDCYqPADQawgC49EwAgY8pAb70EwGFO4wBvfEkAfclwwFg3DcAt0w+A8JCPQAyTKQB4aRMAUs9owN0Ph8AaKp6A2GBRAB51ZMAVmUeAaBnmwCMWUMB7uW+AUMLtQDG8IkC7UW8AWXS/AAp+kcAzKpPAw0u7wFPTe8AvdZLARCN+QAmUEwBvVV1AFbkqgAwl+4AEypsAeRVcQEyRIcBEGoJADJnAQFPAagBI5geAQ+ouQE4WegBidjQAcPPpAGVQkwDruEQAYxQYgFM2/IAxqJyAC7amACbK/ECmqBoAbrWRwDpsGAA8u82ATlZigBTAFQDh6BkAFyOeAJnfL4AtbE+A/kpVQAzu6UAAhGvAEJUoAH3Oh4AI0E1AkTsvwAthvUBo3vdACBuFAMzF6UAhYIqAWD89gCXlz8C7oU+ACA4nAAtp70BjYWzAYNW0wC7s5YC+aoOAbEhMgKqJssBTfd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC/o04AJTSXAGNNGgDunNUB1MDRAUkuVAAUQSkBNs5PAMmDkgKpbxgBorO4AQBy2wAwXpMA9Sk4AH0NzALzrXcALN0gAlPqFAD5oMYB7H7qAWSAnQOAX4gBbX4zAAKptwEGgmICRLBeAXME4wHZ8pEBya0fAWkBJwEvY6gCqeKZAWWz2ADijXoBeUKZArX1hgDj5BkB1jnrAdetOAO059IAG69FAOQvOgHW4EUCzjhFAQ/+iwMWz9QByRR+A17VYAEIsCEAyAXPAUhDhgGSwNYBKyZwAES4SwHNWvsAleuNALWqOgB09O8AXJ0CAGatYgDeKoACIiHAAfflxAGBEXgA+2eXAwY0cAGLOEIDJ+L1AdhGJQKr1gkB6YlgAX8xywAFm5QAF5QJAdJ6DAAihhoB2syIAIYIKQHfUysCVBn3AJO/fwLMTsABDWrtAbvbTACv87sCaFmtAFUZWQGi85QAAnbRAiCeCQBtfwACqIgwAO532wPmrdUAzhL+Age6BwF9CQcBbypIAG807AJfP40AeKMuA1xGKABsKo4CbvyOAZrfkAAz5acBSPybA110DAGXoNoDm+4lAQvPjAKRYfMAgcAaAshUIQFuCk4DklGyAQMEGACh7tcBBY0hADXXDgGg6s8DxACzAZmkjQDhxGgACiMZAtDU8gFg/d4Ct2XlAN4SfwGkiIcBFrXQA+aLnQCzy90D/rlxAL3irANwQtYByT4tA2VACAFNrhAChHVEAYfeIAARkuEAAoG2AZestQDAcygCJS2UAZQTJwE/BwIBgiT+AvmfxgGBnQ4B5budAVjyiQC4Bm4AgxiVAkgSjwE3MpsBU3W8AIXbTQJkybQBVMjIASmuYACObUAB+fLPAVH0zwAMjXcBQYysA1kuVQHuWWUDEhsdAUcRdAAZslEBkCYJAeZ36AC71vQBMqNyAAM7zQHy39oAXtuXAI1ZhgArmsYBG8/eAW76wgJPfDsByOp7A7UWOgHae44CrOj2AelP4wFHaXIBZw7xAd5zPACifisCwjIPAWp3/wN3IhQAiIvTAThhdwAiCMYDQBEgAXXRNgKOdAgAbUfGA9xMPwEq0O4CR4qDABByLgOzy4sB5I2FACZ43AHHf6MAC7QnAYR4lQGtMB0Bg2aBAiMObgHka7cAFbEtAQZlUQJizlQB3x5FAJ50vQBCc5kDTCzMAXVp6wAIlaUBzxalA+8owgBa/2gBR3tpAVlzUgBWMXgBXNevA9xWzgBwueQA6ascAG0PngIMhYgB/f41AYBtBgCDDhUCv4pEATICuwJZ8isBaII8AyAecQCPFPwDcA5eAPmLfQHishIBg0sTAhcFGgDMw4IBgiF5AJnXEwPXPhoAflREAw1K8gHSat4DJzFUAGio3AAnj2EACRdaAYrD3QAT/SADjRY2AAarcQPHP3gBX+CRA12b4gE4EUcBQqX8AM8xygCte8oBvL91Aa0IpwES4rwDFUIkAZm7dQBorawBdrmgA9ES3AEXqxoBuqCrAM0GmAKQ9UIB6tiPAUUVoAFVrcQD/3HJAcCY0ADH/QoAMNJsAPNqJwGyBfkDTJkCAaS4LgDr+1wBX4VfAhhVMwGymc8BdMWZAIicpgEQFYgAVEvNAZ8QEgHFvYoAemR0AB/LdwIkM+UBU1CsArAJsQFeCUsCs5dpAbZr8gIhEDEAhXgZAFql0AHI/LYD1SDAATRKWALg7ucAA3olA6OVHgGRrR4BAmJTACTOsQDGFoUAbZ1mA6ikTgABP3cAzskZAHFhnwHer9QBIzPjArYprQHc0eoCpVHtAdAahQH6vRsA5X1XADDH3QBSmYsDroHyAJAD1QFx4AIA7IAHAI1EDQGvovgBt6XwAEElHwOuS9MAnf8jA20FOgBDVOICBa2hAOi+0QCOfy8Ad3QAA7EkKgATpxQBdn5FAdVVIgN/ZMwB772kAjDXUwHPixEA/1X3AMeQNAFOZ+oB6KO9Ag1JuwDqkfIAQL8KACGj3gHgnC8Ak7GyALVU+gAvMCgBi52hAL31LgLzimMBim+MAz06owGyYZIDuIm7AZ3PCwGpQs8AF289Asob2gElW+MAT4INAM/pUgFdk+0AYIQLAj+4xwHlackAmEGnAdmpRgBox8sAanxZAZupRAFRdaUAnCYYAExGPAIisAkA4TnuAPLHFAHSmooDF0xYAdXAsAM5CrMA5GyKAzrY3gGmd8IBYQoBAevTRgNemY0BfMXyAmsoDADRrpIAe+MlAQGifAJraxoAVQ8pA0i6RwBskY0BYpClAdQ1PgGxqwIAqtI6AMDcfQB2D8EAC1kBAKb8LAA+0g4AKUPuAAQPkABlQMIBcPqCAGBeAgK4EjkAHAQnA+VefgHs7MACHA1aAXzOsQILImIAfgZFATHZpQGmc5YACfbhACp8kgA3qm8B8A5lAbVjbwHhQM0Dj8M7AKzwYQPMKtQBNxD4AuigjADRI34B/usdAWi7vAFjJS4A1q3oA+UWCAB1cPsDrOVTAc0esQKF8WsB7yKPALvS5wAu2SUChefsAHOIUAD1Fn4BXej7AQ6a4wF5kmYBCoF8AfVBSQLr6yMAiHbrAPFgVwBGQcoC581zAHW7UgCn//UAa4W4A819ywAGTvEC0CAYAHVB1wEinuUAUKX7A0FGSACIADUDo8nDAVXz3AAcSAQBZOQiAOc/9wElM+AAmLZSAZp27wJjNpcAjJsDAFs5AQFHX4AB7GCRAdAsgwPrBosAF9fUAwawTACPW6cDMD07AYitzwHRNPABijN4AOPSxwEjK7wCBT+LAarZgAJEPV8AWqkgApfr7gDsqmIDUV2DAEP1uQFNrD8BrpOtAmT0jgH3zRICqYsTAauDFQEmPZwBtJCHArbi4gBYtzsD8dvwAdFLcwPlsSkBDpWzAiLJOwDIPqUBMlWMAe48bwB5PK4AXflRAzenEgC4ltUD/lh2AUrlrADaZosAmcU2AKJjKgGh6ywDrGsSAH7+3AMYT58B7hrIASu8RABlcYIAE3xPAfAwtAPMlr8AYo0MApcZRwExefwB3UIfAEp1ugA501sASb4/ADA5awGcFSoBsIOfAGcPUwOFe+UBgb3sApTClgCp5PwBpQF3AX0EdQExSu4A5YYmAdT8jgBU3EkDb0azAaOcFwIUZNgB0K/wA2RZMAAodFwBHnGZAEJUXQEUEMcALgu0Ac+D1AGGw68BWUiYAf8DYgOoxkUAqqggAKoLmQAQPzED3u58AOQpdALOBngBoVeTA/T4QgG2p5QC9MzqALPtWQJuHjEBbzJNAEbDMAE878wBsiTEAYyRZAPAjxQAe4pjAVv9oQET0IoCpOWBADNPpQEB4XQBVwI9AGyFOgDPHQUAHSv2AK3QQwG9rUIAkNoPAOs8dAHk5XMBScd7AXoTtwOWzgUBiiH5AHyMWwH4AuEA4tdYAbilaQF28bIAejSLAfL+TAHjpBQClRV/AeV6bQBxw5UBbeKRA8anYgCrQj8Ahq0NAZiBTwIqK1QBVMQUAHHEiQGOmJADnXm4ABJJ5ALm4ngAVFYHAO0+kgFyzUAAdnyjAGbUCQAdU8gAcBdlAgGdYABlwoYCPFE0AYGS7gA8Il0ADHZcAzabZwC47HMAUKpvAeSbyAJEwm8Bg4zzAnLriwEszrMCZbCXAHsBTwN/ld0BYY8UAFez6gD40kMD/JgzAI42HgEfKngA6p4BAG97EQDR0CgBu+alARtPlAHhQSsBAYMxAzDNjgGx0AQBizk4AAFncgOMqJ0BaZctAIGmpwAokB0DMvzrAF5AIALO+nEB+DDZAmptfwFHjDsC+dUpAVYklwIkpaMA0kxvAPo5RAAFNcUA/cKQAURyUAD5MJkAcJKjAcYn0wFHvJkDPeHPAZm9MgN9PrMA5PUDArUnNgD4igEAgYVHARgiSgC3Oy4A0ISTA2LqRgGTlgsCXxUXAG9+yQNHjHMAH9u1A8+PgAGY/OgB3SXtAUVQvwErXOsAmP54ATBVuAGwDsIBIuyuAe6eCwN+0LcBb+GHAfshRAExp58A17ZAAGEYhAC8f6IAv5rWAr/NWADs+SkBrhk8AZNbbALnfzoBurJLAG8iYwDKlSoA2e+rAcHS9QIYgzcAtU9zA3OAJQH28GMC4HCtAQZttQG9jxgBA5UbAeHSNgDMqBMBPhxUAbwrrAJnWNkBWXT0AYnU6gBIW6sARTvbAQG47QBPAksADxm4AMLkHwGCH2IA1wgFAXZaGgD918cAbbmqA9zZnAE1ZpwBHqrOAPJcCAGvR/0B4fXjA5k+SwBq1OMBPANgAKjwXwHYzVABIY6eArzxjACxbBUAP2I9AGnwpAFT0NgA6oq2AbZaygFDrhYDRNw0AViNHABDs4QAgccYAx9ENQFeGqUD9JOSATe7SABBMz0BHhVDAeF0nAEUGZEA3t12AG/CawBfjtQAvnsiAKieYgCLX+oBMKN5AV8degKOj78BKm7SAl62xgC2GnABd9pRAGe2tAF8zqAAe+OKA1LIKgH+sKADu8KXANIXoAAqi+sBYrkgAUL7BQD9tlMDzvhhAGMUegBkClYBkqfgAJJ8kAEiZjoB8Ud7AFnxsgIJ5aYBet0qAh0U1ABSgAMAMNHzAHd5QAMx45wB/23FAWcbkABBwMgxC90E7PsK/Zn+E/rVBY4FHwHKAFX/bgIpBrYAwgNO+z76vAU9AtP6CAF/AcP8sgW++X7/V/35A9wCYAL6+ZsBM//d+ccEjALY/fcD8/rTBeb++PkEAvj/wP5m/a75dvt+AL0Fq/ym//H+PgNrAHP6Cf9J/HL+wQMc+iv9wAHX+6UCBfux+64BKwJLAx37ZwMOBmkApgFLArEAFf/d/jT+JgZ1Bgr/CgOHBG3/9/zLBab9XwTK+YQCmPxdAaIBSQFk/7X/MQNJBFsCYgIqBfv6R/qAAUH7eP/CBMn6lvzcAF37hflf+wb6AvsaAxr6qvya/N4BlP/M/uQD3wO+A0z68gVcBgEAAAAAAAAAgoAAAAAAAACKgAAAAAAAgACAAIAAAACAi4AAAAAAAAABAACAAAAAAIGAAIAAAACACYAAAAAAAICKAAAAAAAAAIgAAAAAAAAACYAAgAAAAAAKAACAAAAAAIuAAIAAAAAAiwAAAAAAAICJgAAAAAAAgAOAAAAAAACAAoAAAAAAAICAAAAAAAAAgAqAAAAAAAAACgAAgAAAAICBgACAAAAAgICAAAAAAACAAQAAgAAAAAAIgACAAAAAgDExMjY0OTIyNDE0NjQxMDI4MTg3MzUwMDQ1NzYwOTY5MDI1ODM3MzAxODg0MDQzMDQ4OTQwODcyOTIyMzcxNDE3MTU4MjY2NDY4MDgwMgAAMzE3MDQwOTQ4NTE4MTUzNDEwNjY5NTY5ODU1MjE1ODg5MTI5Njk5MDM5NzQ0MTgxMDc5MzU0NDYyMjA2MTMwNTQ0MTY2Mzc2NDEwNDMAQajNMQsK+gEAAPsBAAD8AQBBvM0xC0n9AQAA/gEAAP8BAACEdERldmljZUF1dGhlbnRpY2F0aW9udW9yZy5pc28uMTgwMTMuNS4xLm1ETIRqU2lnbmF0dXJlMUOhASZAAEGQzjELU4RqU2lnbmF0dXJlMUOhASZAWXZhbGlkaXR5SW5mb3ZhbGlkRnJvbXZhbGlkVW50aWxkZXZpY2VLZXlJbmZvZGV2aWNlS2V5dmFsdWVEaWdlc3RzAEHwzjELEW9yZy5pc28uMTgwMTMuNS4xAEGNzzELGQIAAAECAAACAgAAAwIAAAQCAAAFAgAABgIAQbHPMQsZAgAABwIAAAgCAAAJAgAACgIAAAsCAAAMAgBB1c8xCxkCAAANAgAADgIAAA8CAAAQAgAAEQIAABICAEH5zzELWwIAABMCAAAUAgAAFQIAABYCAAAXAgAAGAIAAGl2YWxpZEZyb23AdGp2YWxpZFVudGlswHQAAABtZGV2aWNlS2V5SW5mb6FpZGV2aWNlS2V5pAECIAEhWCAiWCAAQeDQMQsibHZhbHVlRGlnZXN0c6Bxb3JnLmlzby4xODAxMy41LjFYIABBkNExCzxn5glqAAAAAIWuZ7sAAAAAcvNuPAAAAAA69U+lAAAAAH9SDlEAAAAAjGgFmwAAAACr2YMfAAAAABnN4FsAQdjRMQsaGQIAABoCAAAbAgAAHAIAAB0CAAAeAgAAHwIAQfzRMQsaGQIAACACAAAhAgAAIgIAACMCAAAkAgAAJQIAQaDSMQsaGQIAACYCAAAnAgAAKAIAACkCAAAqAgAAKwIAQcTSMQsaLAIAAC0CAAAuAgAALwIAADACAAAxAgAAMgIAQejSMQsaLAIAADMCAAA0AgAANQIAADYCAAA3AgAAOAIAQYzTMQsgLAIAADkCAAA6AgAAOwIAADwCAAA9AgAAPgIAAN6tvu8AQdDTMQswLAIAAD8CAABAAgAAQQIAAEICAABDAgAARAIAAHAAAAAwMTIzNDU2Nzg5YWJjZGVmAEGQ1DEL5gdn5glqha5nu3Lzbjw69U+lf1IOUYxoBZur2YMfGc3gW5gvikKRRDdxz/vAtaXbtelbwlY58RHxWaSCP5LVXhyrmKoH2AFbgxK+hTEkw30MVXRdvnL+sd6Apwbcm3Txm8HBaZvkhke+78adwQ/MoQwkbyzpLaqEdErcqbBc2oj5dlJRPphtxjGoyCcDsMd/Wb/zC+DGR5Gn1VFjygZnKSkUhQq3JzghGy78bSxNEw04U1RzCmW7Cmp2LsnCgYUscpKh6L+iS2YaqHCLS8KjUWzHGeiS0SQGmdaFNQ70cKBqEBbBpBkIbDceTHdIJ7W8sDSzDBw5SqrYTk/KnFvzby5o7oKPdG9jpXgUeMiECALHjPr/vpDrbFCk96P5vvJ4ccbp9woAMjgzNmYwZGY1YjdjMmM0MzFiZTIxNDExODMxZjhiM2QyYjc2OTRiMDI1YTlkNTZhMjUwODYyNzYxNjFmN2E5MwAAAAABAAAAAQAAAOn3CgA0MGEyNDgwOGY1M2Y1MTZiM2U2NTNlYzg5ODM0MmM0NmFjZjNiNGE5ODQzMzAxMzU0OGU3ODBkMmZmYjFiNGQwAAAAAAIAAAABAAAA6fcKADBmNWEzYmZhMjRhMTI1MjU0NGZkYTQ2MDJmZWE5OGZjNjliNjI5NmI2NGQ0YzdlNDhmMjQyMGRlMjkxMGJmNTUAAAAAAwAAAAEAAADp9woAOTZiNzFkNzE3M2MwMzQxODYwZDdiMWI4ZmJjY2VjYTNkNTUzNDdlY2NhMWM5NjE3ZTdkNmVmYmI2YjVjZjM0NAAAAAAEAAAAAQAAAGN8d3vya2/FMAFnK/7Xq3bKgsl9+llH8K3Uoq+cpHLAt/2TJjY/98w0peXxcdgxFQTHI8MYlgWaBxKA4usnsnUJgywaG25aoFI71rMp4y+EU9EA7SD8sVtqy745SkxYz9DvqvtDTTOFRfkCf1A8n6hRo0CPkp049by22iEQ//PSzQwT7F+XRBfEp349ZF0Zc2CBT9wiKpCIRu64FN5eC9vgMjoKSQYkXMLTrGKRleR558g3bY3VTqlsVvTqZXquCLp4JS4cprTG6N10H0u9i4pwPrVmSAP2DmE1V7mGwR2e4fiYEWnZjpSbHofpzlUo34yhiQ2/5kJoQZktD7BUuxaNAQIECBAgQIAbNgAAAAAARQIAAEUCAABGAgAARwIAAEgCAABJAgAASgIAAEsCAABMAgAATQIAAE4CAABOAgAATwIAAFACAABRAgAAUgIAAFMCAABUAgAAVQIAAFUCAABWAgAAVgIAAFcCAABYAgAAWQIAAFoCAABbAgAAXAIAAF0CAABdAgBBhNwxCwpeAgAAXwIAAGACAEGg3DELqgJhAgAAYgIAAGMCAABkAgAAZQIAAGYCAABnAgAAaAIAAGkCAABqAgAAawIAAGwCAAAEAAMAAgACAAIAAgACAAIAAgACAAIAAgACAAEAAQABAAIAAgACAAIAAgACAAIAAgACAAMAAgABAAEAAQABAAEA//////////8AAAAAAAAAAAEAAQABAAEAAQABAAIAAgACAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAP////////////8AAAAAAAABAAQAAwACAAIAAgACAAIAAgABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAP//////////////////AEHY3jELHQEAAAACAAAAAgAAAAMAAAADAAAABAAAAAQAAAAEAEGA3zELjRQTAAAADAAAAA0AAAABAAAABgAAAAEAAAABAAAAEwAAAA0AAAAOAAAAAQAAAAcAAAAAAAAAAQAAABQAAAAPAAAAEAAAAAEAAAAGAAAAAAAAAAEAAAAVAAAAEAAAABEAAAABAAAABQAAAAAAAAACAAAAFQAAABIAAAASAAAAAQAAAAUAAAAAAAAAAgAAABUAAAASAAAAEwAAAAMAAAAFAAAAAgAAAAMAAAAVAAAAEgAAABMAAAADAAAABQAAAAQAAAAEAAAAFQAAABMAAAAUAAAABAAAAAUAAAAIAAAABAAAABUAAAATAAAAFAAAAAQAAAAFAAAAEAAAAAUAAAAWAAAAFAAAABUAAAAEAAAABQAAABAAAAAFAAAAFgAAABUAAAAWAAAABQAAAAUAAAAQAAAABQAAABYAAAAVAAAAFgAAAAYAAAAFAAAAEAAAAAUAAAAWAAAAFgAAABcAAAAGAAAABQAAACAAAAAFAAAAFgAAABYAAAAWAAAABAAAAAUAAAAgAAAABgAAABYAAAAWAAAAFwAAAAUAAAAFAAAAIAAAAAYAAAAWAAAAFwAAABcAAAAGAAAABQAAACAAAAAGAAAAFgAAABYAAAAWAAAABQAAAAUAAAAwAAAABwAAABcAAAAXAAAAFgAAAAUAAAAEAAAAQAAAAAcAAAAXAAAAFwAAABYAAAAGAAAAAwAAAEAAAAAIAAAAFwAAABgAAAAWAAAABwAAAAMAAAAAAQAACQAAABkAAAAZAAAAFwAAAAcAAAADAAAAAAEAAAkAAAAaAAAAGgAAABgAAAAHAAAAAwAAAAACAAAJAAAAGwAAABsAAAAZAAAACQAAAAMAAADnAwAACQAAABIAAAAMAAAADQAAAAEAAAAFAAAAAQAAAAEAAAASAAAADQAAAA4AAAABAAAABgAAAAAAAAABAAAAEgAAAA4AAAAOAAAAAQAAAAUAAAAAAAAAAgAAABIAAAAQAAAAEAAAAAEAAAAEAAAAAAAAAAIAAAASAAAAEAAAABEAAAADAAAABQAAAAIAAAADAAAAEgAAABEAAAASAAAABQAAAAUAAAACAAAAAwAAABIAAAASAAAAEwAAAAMAAAAFAAAABAAAAAQAAAASAAAAEgAAABMAAAAEAAAABAAAAAQAAAAEAAAAEgAAABIAAAATAAAABAAAAAQAAAAIAAAABQAAABIAAAASAAAAEwAAAAUAAAAEAAAACAAAAAUAAAASAAAAEgAAABMAAAAGAAAABAAAAAgAAAAFAAAAEgAAABIAAAATAAAABQAAAAQAAAAMAAAABgAAABIAAAATAAAAEwAAAAcAAAAEAAAADAAAAAYAAAASAAAAEgAAABMAAAAEAAAABAAAABAAAAAHAAAAEgAAABIAAAATAAAABAAAAAMAAAAgAAAABwAAABIAAAASAAAAEwAAAAYAAAADAAAAgAAAAAcAAAASAAAAEwAAABMAAAAGAAAAAwAAAIAAAAAIAAAAEgAAABMAAAATAAAACAAAAAMAAAAAAQAACAAAABIAAAATAAAAEwAAAAYAAAADAAAAgAAAAAkAAAASAAAAEwAAABMAAAAIAAAAAwAAAAABAAAJAAAAEgAAABMAAAATAAAACgAAAAMAAAAAAgAACQAAABIAAAATAAAAEwAAAAwAAAADAAAAAAIAAAkAAAASAAAAEwAAABMAAAANAAAAAwAAAOcDAAAJAAAAEQAAAAwAAAAMAAAAAQAAAAUAAAABAAAAAQAAABEAAAAMAAAADQAAAAEAAAAGAAAAAAAAAAEAAAARAAAADQAAAA8AAAABAAAABQAAAAAAAAABAAAAEQAAAA8AAAAQAAAAAgAAAAUAAAAAAAAAAgAAABEAAAARAAAAEQAAAAIAAAAEAAAAAAAAAAIAAAARAAAAEAAAABEAAAADAAAABAAAAAIAAAADAAAAEQAAABAAAAARAAAAAwAAAAQAAAAEAAAABAAAABEAAAAQAAAAEQAAAAMAAAAEAAAACAAAAAUAAAARAAAAEAAAABEAAAAEAAAABAAAAAgAAAAFAAAAEQAAABAAAAARAAAABQAAAAQAAAAIAAAABQAAABEAAAAQAAAAEQAAAAYAAAAEAAAACAAAAAUAAAARAAAAEQAAABEAAAAFAAAABAAAAAgAAAAGAAAAEQAAABIAAAARAAAABwAAAAQAAAAMAAAABgAAABEAAAASAAAAEQAAAAMAAAAEAAAADAAAAAcAAAARAAAAEgAAABEAAAAEAAAAAwAAACAAAAAHAAAAEQAAABIAAAARAAAABgAAAAMAAAAAAQAABwAAABEAAAASAAAAEQAAAAYAAAADAAAAgAAAAAgAAAARAAAAEgAAABEAAAAIAAAAAwAAAAABAAAIAAAAEQAAABIAAAARAAAACgAAAAMAAAAAAgAACAAAABEAAAASAAAAEQAAAAUAAAADAAAAAAEAAAkAAAARAAAAEgAAABEAAAAHAAAAAwAAAAACAAAJAAAAEQAAABIAAAARAAAACQAAAAMAAAAAAgAACQAAABEAAAASAAAAEQAAAAsAAAADAAAA5wMAAAkAAAAOAAAADAAAAA0AAAABAAAABQAAAAEAAAABAAAADgAAAA4AAAAPAAAAAQAAAAUAAAAAAAAAAQAAAA4AAAAOAAAADwAAAAEAAAAEAAAAAAAAAAEAAAAOAAAADgAAAA8AAAACAAAABAAAAAAAAAACAAAADgAAAA4AAAAOAAAABAAAAAQAAAACAAAAAwAAAA4AAAAOAAAADgAAAAMAAAAEAAAABAAAAAQAAAAOAAAADgAAAA4AAAAEAAAABAAAAAgAAAAFAAAADgAAAA4AAAAOAAAABgAAAAQAAAAIAAAABQAAAA4AAAAOAAAADgAAAAgAAAAEAAAACAAAAAUAAAAOAAAADwAAAA4AAAAFAAAABAAAAAgAAAAGAAAADgAAAA8AAAAOAAAACQAAAAQAAAAIAAAABgAAAA4AAAAPAAAADgAAAAMAAAAEAAAADAAAAAcAAAAOAAAADwAAAA4AAAAEAAAAAwAAABgAAAAHAAAADgAAAA8AAAAOAAAABQAAAAMAAAAgAAAACAAAAA4AAAAPAAAADwAAAAYAAAADAAAAQAAAAAgAAAAOAAAADwAAAA8AAAAHAAAAAwAAAAABAAAIAAAADgAAAA8AAAAPAAAABQAAAAMAAAAwAAAACQAAAA4AAAAPAAAADwAAAAYAAAADAAAAgAAAAAkAAAAOAAAADwAAAA8AAAAHAAAAAwAAAAABAAAJAAAADgAAAA8AAAAPAAAACAAAAAMAAAAAAQAACQAAAA4AAAAPAAAADwAAAAgAAAADAAAAAAIAAAkAAAAOAAAADwAAAA8AAAAJAAAAAwAAAAACAAAJAAAADgAAAA8AAAAPAAAACgAAAAMAAADnAwAACQBBpPMxC+kcazgHAA2yBwCc8gcAcGQIAGCuCgCwcQsAMKoMAAAAAAAACAAAAAcAAGoGAAAABgAArQUAAGoFAAAxBQAAAAUAANQEAACtBAAAigQAAGoEAABMBAAAMQQAABcEAAAABAAA6QMAANQDAADAAwAArQMAAJsDAACKAwAAeQMAAGoDAABbAwAATAMAAD4DAAAxAwAAJAMAABcDAAALAwAAAAMAAPQCAADpAgAA3gIAANQCAADKAgAAwAIAALYCAACtAgAApAIAAJsCAACSAgAAigIAAIICAAB5AgAAcgIAAGoCAABiAgAAWwIAAFMCAABMAgAARQIAAD4CAAA3AgAAMQIAACoCAAAkAgAAHgIAABcCAAARAgAACwIAAAUCAAAAAgAA+gEAAPQBAADvAQAA6QEAAOQBAADeAQAA2QEAANQBAADPAQAAygEAAMUBAADAAQAAuwEAALYBAACyAQAArQEAAKgBAACkAQAAnwEAAJsBAACXAQAAkgEAAI4BAACKAQAAhgEAAIIBAAB+AQAAeQEAAHUBAAByAQAAbgEAAGoBAABmAQAAYgEAAF4BAABbAQAAVwEAAFMBAABQAQAATAEAAEkBAABFAQAAQgEAAD4BAAA7AQAANwEAADQBAAAxAQAALgEAACoBAAAnAQAAJAEAACEBAAAeAQAAGgEAABcBAAAUAQAAEQEAAA4BAAALAQAACAEAAAUBAAACAQAAAAEAAP0AAAD6AAAA9wAAAPQAAADxAAAA7wAAAOwAAADpAAAA5gAAAOQAAADhAAAA3gAAANwAAADZAAAA1wAAANQAAADRAAAAzwAAAMwAAADKAAAAxwAAAMUAAADCAAAAwAAAAL4AAAC7AAAAuQAAALYAAAC0AAAAsgAAAK8AAACtAAAAqwAAAKgAAACmAAAApAAAAKIAAACfAAAAnQAAAJsAAACZAAAAlwAAAJUAAACSAAAAkAAAAI4AAACMAAAAigAAAIgAAACGAAAAhAAAAIIAAACAAAAAfgAAAHsAAAB5AAAAdwAAAHUAAABzAAAAcgAAAHAAAABuAAAAbAAAAGoAAABoAAAAZgAAAGQAAABiAAAAYAAAAF4AAABdAAAAWwAAAFkAAABXAAAAVQAAAFMAAABSAAAAUAAAAE4AAABMAAAASgAAAEkAAABHAAAARQAAAEMAAABCAAAAQAAAAD4AAAA9AAAAOwAAADkAAAA3AAAANgAAADQAAAAyAAAAMQAAAC8AAAAuAAAALAAAACoAAAApAAAAJwAAACUAAAAkAAAAIgAAACEAAAAfAAAAHgAAABwAAAAaAAAAGQAAABcAAAAWAAAAFAAAABMAAAARAAAAEAAAAA4AAAANAAAACwAAAAoAAAAIAAAABwAAAAUAAAAEAAAAAgAAAAEAAAABAAEAAQABAAEAAQACAAIAAgABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQD/////////////AAAAAAAABAADAAIAAgACAAIAAgACAAIAAgACAAIAAgABAAEAAQACAAIAAgACAAIAAgACAAIAAgADAAIAAQABAAEAAQABAP//////////AAAAAAAAAAABAAQAAwACAAIAAgACAAIAAgABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAP//////////////////EjRWeJq83vDitBI0VngAAAAAAAAAAFx3d18s97j1EsR6ayZfk4TMDHPKqa1Htt6xTxFLu2Ww0J86jH5OWDQFa+JqfOGXTgSmmbxD1wM6TwTEIiQEzc6eJSSFxXbedsrqrVv2KIWcKXUJ4gY3VoaJ2HWjX0cCKebrpTmXKrOvOeaDONoUJ86e5iIXgq8eAii2IIZiewMA9cqIXUWNmgRAgZXmEddWhR9cYPx0rvcEIDq9aDQMn4KeFyXGhcj9TxuvPYoE3nOEskZWsCKIAFFfzNGyEl3XabxUkRUZSp2MA0C9q/QQzMORc7nsHNxt0C4wgO3n5ki+RzXgzjHbgTQQ0qHafPbDrMyWf4wdd8tl3SNXBXdxso6+lM1EDZWJxyuxADfc6k+TgvG97RFfSF56dmT9RiouHnz6LthxymkpLrq7XpPpRp0rguYFfrZW4KADnXNVP9eUA1qbtr0QcM30gpvX/PleRWHBSYdKtZyGJdKFYfqk0Ti76buUbxZ1tPFZCXJINRSkuiZruoBH7XoSI+A5RCbO0AjVeGB0bTaEvhftcjyXzqgBC0OaoiPDIe6Ar+MX1mKZW/eMnB3pDKu8TZrR5o4OU3JdP/UMjPYuBlWoQBZoOsBnCTGcn05uSaAUm7VyBFh4d4U4O8IkOCdTtVzUOpK/Zoa6kiRaGq5HWZYinlYE4zVvC4dGKhhlRxKUCekltrpswSKFWS6arN3yJGZmbghycTd4O1DKA1DfCT1WeNvBwIidKPysZRjVWPEkUsaucXYX12fpQaLYefuapNnKAeHhK2sYKW4vaCVmUG7AekVTlTl0uzrCtP9dA96qVB9Zsp1CCRB9A6gCKMXzJQsfOCfLajuCT+5RJV7098KAldmiDovh4bS8nFHtOwoBuz2CUvQPZ9I9T2HtQp17xVdiwBOTW0IUXosAuBShSz3BERwx/sFoVUyjPnboZl3wYsLxKpiLt/t1qvp2iO4qu3LR0KRiipeaRLejlD3BfANdwZ26u23x4JIdHxCGx5u3oAepgYbXuavJYimvGvbZesvT/Bb9LCFNYkRnW4yG1910nIlQ5iVjdMOn9CoEuso+WkY5pbFOytUFO/DbCb66clQrNlpOd82D0SkSIqFH36L1jqEMS1C5bkXivd/73zRG474vK81Gw5idgf74rvJhnVnUdlJ/NeNTxHk4SKUkubSSkYgmgAjs24IXZ5baKKqajlhAfPNOs5+8UQa5N4jW5fDTQfdkwbpwS3AKWhO82ipi92jYnAarwLngibo3vPZSNTIBSsFHu5jurEt5AE/VaXpjfd4HcV4l8rY7ea+ImLWZh2tGxvNZO3+qFsaIwv2j/ELPY8qBS2eiNs5a2IjniSN502sFDS3TnU5sOVzlpsDmcUVQ+77M6JFeETKrltE4j94Yy4q/BiZnAYjl2mb7FyOHF2A7g2QoydHyFny4nGaL5XRqdtu+FxTGhZ9liQzqEWCFrdrIrn7+tmW1pHYScyP2hdBppGzpo4NWNvCquPckhG90u03BrOT0WnU4BoZE5r31B3g9OXa7W49tvhfcNdxEzfADCWwZ8f3qcrZn8YJM7ZP/dqadPQXFBBAdUgKSzJzQmro3UfuseilN5YRFNBRqd0sLCo40C+Jx1CAI3EY9uDw4dBgc4e+hx+7tl6pC3BsL5TCzMuBwzlUZ2R3VOSmPuM0UpdO5Ddk/I5Enm3oPxUwKZ3ul38YFKn3Ad/qm0EZmi3fjSWe1R9qOnLMo79utSNQ+k/QLfav2aoSvSW5m6wjyWg5qzTQ19yJmXm5b70LKrn0ppjlV0/OuLYapHo6PSSKH5nLVwD0JUxyY9fuGv7+wCfoVnyFmYemxMIP7xL1m1Odw6ajyNW5zZlrvusG30lnbzZaJbdJH0sfWoxveyOo5Turyr6OfsYucU9gI1V9MDvkJhTOv+1ZZTqN18z4dFY4vLsGuP7jpkTYXeWMBv1aNWrjjikBnEjiCg20JwL0bkA+5Zey8MynTanyV1YosL167diht9GwahQ85ctrCoU0G5sOJU/ocEAwqxTDF+6OEr47XfpmLKOK5gTfEBT2o3vbCc9deW0w2jiIEETmkDd8+ep1WZ2gk2v7cjqGzqbenZ3ZeHXlDoZ84T0zczac9AsGLsMyxKeU6vrR6+U/n2zJhTnVF3zmoQlRjcd5Svj9ksW8vd4F6z0IKHpbq8p7Yg12085s+bkrP5D3u55UyLFRIaM0vZnhMZuHO5MRoTEeLVEeZC4vtpXc31yX8tzbWsRXJANrSsNl1usIhoWSKYM9da18MV/lfJTPz3O7UzhgkkjtjSrMEsODdNsFaL0tdsIPMWNJCjqLdJLRemM05lzZH32IXzuSFJLTgtOfRqPnB8OEWvw5WB2eRw46znczyLW66YhY62Hf/9PnLxLwrfdDX2Xj0QSzg4UxV7035zH4SgXWNBYo8yzYztamRT1z0CyzEOGOISPTNkwhkaKVeV7w07IBAqo609STzOX9S/44f7dnpFKLFjAX8JJJBd/5MsAC6uq9Szw8Sn5owEmJiZezzWKUvvtp6i+xLQjOkrqYTJWJBmKdMMtWijbikKFUkO3OH0sOuaG1+aUSaKLtJL76TEHutij0uY+y7UIOC6uEjB9ls8yuwMXSee4lHcIozy/2eIVYGfKLwEQM755bbwJG/F9uypYVOa/3UjJ1ApksFcbD62d+pH4P+1kAeeX2t6401r1g+XqYlDo3rgIXgFN/Ty7srq81+8lH3DPTYEyZPoU0rbQIAAG4CAABvAgAAcAIAAHECAAByAgAAcwIAAHQCAAB1AgAAdgIAAHcCAAB4AgAABAAAAAIAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAABgAAAAIAAAABAAAAAQAAAAIAAAADAAAABAAAAAQAAAAEAAAAAwAAAAIAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAQaCQMgsUAQEBAQICAwMEBgcICQoLDA0ODxAAQcGQMgs/AQIDBAUGBwgJCgsMDQ4PEBARERISExMUFBQUFRUVFRYWFhYWFhYWFxcXFxcXFxcYGBgYGBgYGBgYGBgYGBgYAEGgkTILFQEBAQECAgMDBAQFBwgJCgsMDQ4PEABBwZEyC6gBAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAgISEiIiMjJCQkJCUlJSUmJiYmJiYmJicnJycnJycnKCgoKCgoKCgoKCgoKCgoKCkpKSkpKSkpKSkpKSkpKSkqKioqKioqKioqKioqKioqKioqKioqKioqKioqKioqKnkCAAB6AgAAewIAAHwCAAAIAAAACQAAAAoAAAAKAAAAAQAAAAQAAAAIAEH0kjILGQEAAAACAAAABAAAAAAAAAACAAAABAAAAAgAQZiTMgsFAQAAAAEAQaiTMgvlAQEAAAABAAAAlgAAANgAAAB9AQAAdwAAAKoAAADNAAAAAgIAAHAAAACxAAAAxwAAABsCAABuAAAAxQAAAMIAAACEAgAAawAAAN0AAADAAAAA3wIAAGsAAAAAAQAAvQAAAHEDAABqAAAAZwEAALwAAACPBAAAbQAAAEYCAAC7AAAAIgYAAHIAAACwAgAAuwAAALAGAAB6AAAAOQMAALoAAACtBwAAiAAAANADAAC5AAAAUwgAAJYAAACcBAAAugAAABYIAACvAAAAYQUAALkAAADDBgAAygAAAIQFAAC5AAAAnwYAAMoAQaSVMguSBQEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0AAAAOAAAADwAAABAAAAASAAAAFAAAABYAAAAYAAAAHAAAACAAAAAoAAAAMAAAAEAAAACAAAAAAAEAAAACAAAABAAAAAgAAAAQAAAAIAAAAEAAAACAAAAAAAEAAQABAQYAAAAAAAAEAAAAABAAAAQAAAAAIAAABQEAAAAAAAAFAwAAAAAAAAUEAAAAAAAABQYAAAAAAAAFBwAAAAAAAAUJAAAAAAAABQoAAAAAAAAFDAAAAAAAAAYOAAAAAAABBRAAAAAAAAEFFAAAAAAAAQUWAAAAAAACBRwAAAAAAAMFIAAAAAAABAUwAAAAIAAGBUAAAAAAAAcFgAAAAAAACAYAAQAAAAAKBgAEAAAAAAwGABAAACAAAAQAAAAAAAAABAEAAAAAAAAFAgAAACAAAAUEAAAAAAAABQUAAAAgAAAFBwAAAAAAAAUIAAAAIAAABQoAAAAAAAAFCwAAAAAAAAYNAAAAIAABBRAAAAAAAAEFEgAAACAAAQUWAAAAAAACBRgAAAAgAAMFIAAAAAAAAwUoAAAAAAAGBEAAAAAQAAYEQAAAACAABwWAAAAAAAAJBgACAAAAAAsGAAgAADAAAAQAAAAAEAAABAEAAAAgAAAFAgAAACAAAAUDAAAAIAAABQUAAAAgAAAFBgAAACAAAAUIAAAAIAAABQkAAAAgAAAFCwAAACAAAAUMAAAAAAAABg8AAAAgAAEFEgAAACAAAQUUAAAAIAACBRgAAAAgAAIFHAAAACAAAwUoAAAAIAAEBTAAAAAAABAGAAABAAAADwYAgAAAAAAOBgBAAAAAAA0GACAAQcSaMgujAwEAAAABAAAABQAAAA0AAAAdAAAAPQAAAH0AAAD9AAAA/QEAAP0DAAD9BwAA/Q8AAP0fAAD9PwAA/X8AAP3/AAD9/wEA/f8DAP3/BwD9/w8A/f8fAP3/PwD9/38A/f//AP3//wH9//8D/f//B/3//w/9//8f/f//P/3//38AAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHwEAAQEFAAAAAAAABQAAAAAAAAYEPQAAAAAACQX9AQAAAAAPBf1/AAAAABUF/f8fAAAAAwUFAAAAAAAHBH0AAAAAAAwF/Q8AAAAAEgX9/wMAAAAXBf3/fwAAAAUFHQAAAAAACAT9AAAAAAAOBf0/AAAAABQF/f8PAAAAAgUBAAAAEAAHBH0AAAAAAAsF/QcAAAAAEQX9/wEAAAAWBf3/PwAAAAQFDQAAABAACAT9AAAAAAANBf0fAAAAABMF/f8HAAAAAQUBAAAAEAAGBD0AAAAAAAoF/QMAAAAAEAX9/wAAAAAcBf3//w8AABsF/f//BwAAGgX9//8DAAAZBf3//wEAABgF/f//AEHwnTIL0wEDAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAlAAAAJwAAACkAAAArAAAALwAAADMAAAA7AAAAQwAAAFMAAABjAAAAgwAAAAMBAAADAgAAAwQAAAMIAAADEAAAAyAAAANAAAADgAAAAwABAEHQnzILhgQBAAEBBgAAAAAAAAYDAAAAAAAABAQAAAAgAAAFBQAAAAAAAAUGAAAAAAAABQgAAAAAAAAFCQAAAAAAAAULAAAAAAAABg0AAAAAAAAGEAAAAAAAAAYTAAAAAAAABhYAAAAAAAAGGQAAAAAAAAYcAAAAAAAABh8AAAAAAAAGIgAAAAAAAQYlAAAAAAABBikAAAAAAAIGLwAAAAAAAwY7AAAAAAAEBlMAAAAAAAcGgwAAAAAACQYDAgAAEAAABAQAAAAAAAAEBQAAACAAAAUGAAAAAAAABQcAAAAgAAAFCQAAAAAAAAUKAAAAAAAABgwAAAAAAAAGDwAAAAAAAAYSAAAAAAAABhUAAAAAAAAGGAAAAAAAAAYbAAAAAAAABh4AAAAAAAAGIQAAAAAAAQYjAAAAAAABBicAAAAAAAIGKwAAAAAAAwYzAAAAAAAEBkMAAAAAAAUGYwAAAAAACAYDAQAAIAAABAQAAAAwAAAEBAAAABAAAAQFAAAAIAAABQcAAAAgAAAFCAAAACAAAAUKAAAAIAAABQsAAAAAAAAGDgAAAAAAAAYRAAAAAAAABhQAAAAAAAAGFwAAAAAAAAYaAAAAAAAABh0AAAAAAAAGIAAAAAAAEAYDAAEAAAAPBgOAAAAAAA4GA0AAAAAADQYDIAAAAAAMBgMQAAAAAAsGAwgAAAAACgYDBABB5KMyC3wBAAAAAwAAAAcAAAAPAAAAHwAAAD8AAAB/AAAA/wAAAP8BAAD/AwAA/wcAAP8PAAD/HwAA/z8AAP9/AAD//wAA//8BAP//AwD//wcA//8PAP//HwD//z8A//9/AP///wD///8B////A////wf///8P////H////z////9/AEH0pDILQwEAAAACAAAAAQAAAAQAAAAEAAAABAAAAAQAAAAIAAAACAAAAAgAAAAHAAAACAAAAAkAAAAKAAAACwAAAEMuVVRGLTgAQdClMgtHTENfQ1RZUEUAAAAATENfTlVNRVJJQwAATENfVElNRQAAAAAATENfQ09MTEFURQAATENfTU9ORVRBUlkATENfTUVTU0FHRVMAQaCmMgsj3hIElQAAAAD///////////////8gkwwAFAAAAEMuVVRGLTgAQeSmMgvdA4DeKACAyE0AAKd2AAA0ngCAEscAgJ/uAAB+FwGAXEABgOlnAQDIkAEAVbgBU3VuAE1vbgBUdWUAV2VkAFRodQBGcmkAU2F0AFN1bmRheQBNb25kYXkAVHVlc2RheQBXZWRuZXNkYXkAVGh1cnNkYXkARnJpZGF5AFNhdHVyZGF5AEphbgBGZWIATWFyAEFwcgBNYXkASnVuAEp1bABBdWcAU2VwAE9jdABOb3YARGVjAEphbnVhcnkARmVicnVhcnkATWFyY2gAQXByaWwATWF5AEp1bmUASnVseQBBdWd1c3QAU2VwdGVtYmVyAE9jdG9iZXIATm92ZW1iZXIARGVjZW1iZXIAQU0AUE0AJWEgJWIgJWUgJVQgJVkAJW0vJWQvJXkAJUg6JU06JVMAJUk6JU06JVMgJXAAAAAlbS8lZC8leQAwMTIzNDU2Nzg5ACVhICViICVlICVUICVZACVIOiVNOiVTAAAAAADRdJ4AV529KoBwUg///z4nCgAAAGQAAADoAwAAECcAAKCGAQBAQg8AgJaYAADh9QUZAAsAGRkZAAAAAAUAAAAAAAAJAAAAAAsAAAAAAAAAABkACgoZGRkDCgcAAQAJCxgAAAkGCwAACwAGGQAAABkZGQBB0aoyCyEOAAAAAAAAAAAZAAsNGRkZAA0AAAIACQ4AAAAJAA4AAA4AQYurMgsBDABBl6syCxUTAAAAABMAAAAACQwAAAAAAAwAAAwAQcWrMgsBEABB0asyCxUPAAAABA8AAAAACRAAAAAAABAAABAAQf+rMgsBEgBBi6wyCx4RAAAAABEAAAAACRIAAAAAABIAABIAABoAAAAaGhoAQcKsMgsOGgAAABoaGgAAAAAAAAkAQfOsMgsBFABB/6wyCxUXAAAAABcAAAAACRQAAAAAABQAABQAQa2tMgsBFgBBua0yC/4YFQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVGAAAAAAIAAAADAAAABQAAAAcAAAALAAAADQAAABEAAAATAAAAFwAAAB0AAAAfAAAAJQAAACkAAAArAAAALwAAADUAAAA7AAAAPQAAAEMAAABHAAAASQAAAE8AAABTAAAAWQAAAGEAAABlAAAAZwAAAGsAAABtAAAAcQAAAH8AAACDAAAAiQAAAIsAAACVAAAAlwAAAJ0AAACjAAAApwAAAK0AAACzAAAAtQAAAL8AAADBAAAAxQAAAMcAAADTAAAAAQAAAAsAAAANAAAAEQAAABMAAAAXAAAAHQAAAB8AAAAlAAAAKQAAACsAAAAvAAAANQAAADsAAAA9AAAAQwAAAEcAAABJAAAATwAAAFMAAABZAAAAYQAAAGUAAABnAAAAawAAAG0AAABxAAAAeQAAAH8AAACDAAAAiQAAAIsAAACPAAAAlQAAAJcAAACdAAAAowAAAKcAAACpAAAArQAAALMAAAC1AAAAuwAAAL8AAADBAAAAxQAAAMcAAADRAAAAAwAAAAQAAAAEAAAABgAAAIP5ogBETm4A/CkVANFXJwDdNPUAYtvAADyZlQBBkEMAY1H+ALveqwC3YcUAOm4kANJNQgBJBuAACeouAByS0QDrHf4AKbEcAOg+pwD1NYIARLsuAJzphAC0JnAAQX5fANaROQBTgzkAnPQ5AItfhAAo+b0A+B87AN7/lwAPmAUAES/vAApaiwBtH20Az342AAnLJwBGT7cAnmY/AC3qXwC6J3UA5evHAD178QD3OQcAklKKAPtr6gAfsV8ACF2NADADVgB7/EYA8KtrACC8zwA29JoA46kdAF5hkQAIG+YAhZllAKAUXwCNQGgAgNj/ACdzTQAGBjEAylYVAMmocwB74mAAa4zAABnERwDNZ8MACejcAFmDKgCLdsQAphyWAESv3QAZV9EApT4FAAUH/wAzfj8AwjLoAJhP3gC7fTIAJj3DAB5r7wCf+F4ANR86AH/yygDxhx0AfJAhAGokfADVbvoAMC13ABU7QwC1FMYAwxmdAK3EwgAsTUEADABdAIZ9RgDjcS0Am8aaADNiAAC00nwAtKeXADdV1QDXPvYAoxAYAE12/ABknSoAcNerAGN8+AB6sFcAFxXnAMBJVgA71tkAp4Q4ACQjywDWincAWlQjAAAfuQDxChsAGc7fAJ8x/wBmHmoAmVdhAKz7RwB+f9gAImW3ADLoiQDmv2AA78TNAGw2CQBdP9QAFt7XAFg73gDem5IA0iIoACiG6ADiWE0AxsoyAAjjFgDgfcsAF8BQAPMdpwAY4FsALhM0AIMSYgCDSAEA9Y5bAK2wfwAe6fIASEpDABBn0wCq3dgArl9CAGphzgAKKKQA05m0AAam8gBcd38Ao8KDAGE8iACKc3gAr4xaAG/XvQAtpmMA9L/LAI2B7wAmwWcAVcpFAMrZNgAoqNIAwmGNABLJdwAEJhQAEkabAMRZxADIxUQATbKRAAAX8wDUQ60AKUnlAP3VEAAAvvwAHpTMAHDO7gATPvUA7PGAALPnwwDH+CgAkwWUAMFxPgAuCbMAC0XzAIgSnACrIHsALrWfAEeSwgB7Mi8ADFVtAHKnkABr5x8AMcuWAHkWSgBBeeIA9N+JAOiUlwDi5oQAmTGXAIjtawBfXzYAu/0OAEiatABnpGwAcXJCAI1dMgCfFbgAvOUJAI0xJQD3dDkAMAUcAA0MAQBLCGgALO5YAEeqkAB05wIAvdYkAPd9pgBuSHIAnxbvAI6UpgC0kfYA0VNRAM8K8gAgmDMA9Ut+ALJjaADdPl8AQF0DAIWJfwBVUikAN2TAAG3YEAAySDIAW0x1AE5x1ABFVG4ACwnBACr1aQAUZtUAJwedAF0EUAC0O9sA6nbFAIf5FwBJa30AHSe6AJZpKQDGzKwArRRUAJDiagCI2YkALHJQAASkvgB3B5QA8zBwAAD8JwDqcagAZsJJAGTgPQCX3YMAoz+XAEOU/QANhowAMUHeAJI5nQDdcIwAF7fnAAjfOwAVNysAXICgAFqAkwAQEZIAD+jYAGyArwDb/0sAOJAPAFkYdgBipRUAYcu7AMeJuQAQQL0A0vIEAEl1JwDrtvYA2yK7AAoUqgCJJi8AZIN2AAk7MwAOlBoAUTqqAB2jwgCv7a4AXCYSAG3CTQAtepwAwFaXAAM/gwAJ8PYAK0CMAG0xmQA5tAcADCAVANjDWwD1ksQAxq1LAE7KpQCnN80A5qk2AKuSlADdQmgAGWPeAHaM7wBoi1IA/Ns3AK6hqwDfFTEAAK6hAAz72gBkTWYA7QW3ACllMABXVr8AR/86AGr5uQB1vvMAKJPfAKuAMABmjPYABMsVAPoiBgDZ5B0APbOkAFcbjwA2zQkATkLpABO+pAAzI7UA8KoaAE9lqADSwaUACz8PAFt4zQAj+XYAe4sEAIkXcgDGplMAb27iAO/rAACbSlgAxNq3AKpmugB2z88A0QIdALHxLQCMmcEAw613AIZI2gD3XaAAxoD0AKzwLwDd7JoAP1y8ANDebQCQxx8AKtu2AKMlOgAAr5oArVOTALZXBAApLbQAS4B+ANoHpwB2qg4Ae1mhABYSKgDcty0A+uX9AInb/gCJvv0A5HZsAAap/AA+gHAAhW4VAP2H/wAoPgcAYWczACoYhgBNveoAs+evAI9tbgCVZzkAMb9bAITXSAAw3xYAxy1DACVhNQDJcM4AMMu4AL9s/QCkAKIABWzkAFrdoAAhb0cAYhLSALlchABwYUkAa1bgAJlSAQBQVTcAHtW3ADPxxAATbl8AXTDkAIUuqQAdssMAoTI2AAi3pADqsdQAFvchAI9p5AAn/3cADAOAAI1ALQBPzaAAIKWZALOi0wAvXQoAtPlCABHaywB9vtAAm9vBAKsXvQDKooEACGpcAC5VFwAnAFUAfxTwAOEHhgAUC2QAlkGNAIe+3gDa/SoAayW2AHuJNAAF8/4Aub+eAGhqTwBKKqgAT8RaAC34vADXWpgA9MeVAA1NjQAgOqYApFdfABQ/sQCAOJUAzCABAHHdhgDJ3rYAv2D1AE1lEQABB2sAjLCsALLA0ABRVUgAHvsOAJVywwCjBjsAwEA1AAbcewDgRcwATin6ANbKyADo80EAfGTeAJtk2ADZvjEApJfDAHdY1ABp48UA8NoTALo6PABGGEYAVXVfANK99QBuksYArC5dAA5E7QAcPkIAYcSHACn96QDn1vMAInzKAG+RNQAI4MUA/9eNAG5q4gCw/cYAkwjBAHxddABrrbIAzW6dAD5yewDGEWoA98+pAClz3wC1yboAtwBRAOKyDQB0uiQA5X1gAHTYigANFSwAgRgMAH5mlAABKRYAn3p2AP39vgBWRe8A2X42AOzZEwCLurkAxJf8ADGoJwDxbsMAlMU2ANioVgC0qLUAz8wOABKJLQBvVzQALFaJAJnO4wDWILkAa16qAD4qnAARX8wA/QtKAOH0+wCOO20A4oYsAOnUhAD8tKkA7+7RAC41yQAvOWEAOCFEABvZyACB/AoA+0pqAC8c2ABTtIQATpmMAFQizAAqVdwAwMbWAAsZlgAacLgAaZVkACZaYAA/Uu4AfxEPAPS1EQD8y/UANLwtADS87gDoXcwA3V5gAGeOmwCSM+8AyRe4AGFYmwDhV7wAUYPGANg+EADdcUgALRzdAK8YoQAhLEYAWfPXANl6mACeVMAAT4b6AFYG/ADlea4AiSI2ADitIgBnk9wAVeiqAIImOADK55sAUQ2kAJkzsQCp1w4AaQVIAGWy8AB/iKcAiEyXAPnRNgAhkrMAe4JKAJjPIQBAn9wA3EdVAOF0OgBn60IA/p3fAF7UXwB7Z6QAuqx6AFX2ogAriCMAQbpVAFluCAAhKoYAOUeDAInj5gDlntQASftAAP9W6QAcD8oAxVmKAJT6KwDTwcUAD8XPANtargBHxYYAhUNiACGGOwAseZQAEGGHACpMewCALBoAQ78SAIgmkAB4PIkAqMTkAOXbewDEOsIAJvTqAPdnigANkr8AZaMrAD2TsQC9fAsApFHcACfdYwBp4d0AmpQZAKgplQBozigACe20AESfIABOmMoAcIJjAH58IwAPuTIAp/WOABRW5wAh8QgAtZ0qAG9+TQClGVEAtfmrAILf1gCW3WEAFjYCAMQ6nwCDoqEAcu1tADmNegCCuKkAazJcAEYnWwAANO0A0gB3APz0VQABWU0A4HGAAEHDxjILpQNA+yH5PwAAAAAtRHQ+AAAAgJhG+DwAAABgUcx4OwAAAICDG/A5AAAAQCAlejgAAACAIoLjNgAAAAAd82k1OGPtPtoPST9emHs/2g/JP2k3rDFoISIztA8UM2ghojPbD0k/2w9Jv+TLFkDkyxbAAAAAAAAAAIDbD0lA2w9JwL7z+HnsYfY/GTCWW8b+3r89iK9K7XH1P6T81DJoC9u/sBDw8DmV9D97tx8Ki0HXv4UDuLCVyfM/e89tGumd07+lZIgMGQ3zPzG28vObHdC/oI4LeyJe8j/wejsbHXzJvz80GkpKu/E/nzyvk+P5wr+65YrwWCPxP1yNeL/LYLm/pwCZQT+V8D/OX0e2nW+qvwAAAAAAAPA/AAAAAAAAAACsR5r9jGDuPz31JJ/KOLM/oGoCH7Ok7D+6kThUqXbEP+b8alc2IOs/0uTESguEzj8tqqFj0cLpPxxlxvBFBtQ/7UF4A+aG6D/4nxssnI7YP2JIU/XcZ+c/zHuxTqTg3D8LbknJFnbSP3rGdaBpGde/3bqnbArH3j/I9r5IRxXnvyu4KmVHFfc/AEH0yTILOn8CAAB/AgAAgAIAAIACAACAAgAAgAIAAIACAACAAgAAfwIAAH8CAACAAgAAfwIAAH8CAAB/AgAAfwIAQdDKMgsegAIAAIACAAB/AgAAfwIAAAAAAAB/AgAAAAAAAIACAEGAzDILA9AVfQBBkMwyC5sGZnVuY3Rpb24gR2l2ZW4odGV4dCwgZm4pIHRhYmxlLmluc2VydChaRU4uZ2l2ZW5fc3RlcHMsIHRleHQpIGVuZApmdW5jdGlvbiBXaGVuKHRleHQsIGZuKSB0YWJsZS5pbnNlcnQoWkVOLndoZW5fc3RlcHMsIHRleHQpIGVuZApmdW5jdGlvbiBUaGVuKHRleHQsIGZuKSB0YWJsZS5pbnNlcnQoWkVOLnRoZW5fc3RlcHMsIHRleHQpIGVuZApmdW5jdGlvbiBJZldoZW4odGV4dCwgZm4pIHRhYmxlLmluc2VydChaRU4uaWZfc3RlcHMsIHRleHQpIGVuZApmdW5jdGlvbiBGb3JlYWNoKHRleHQsIGZuKSB0YWJsZS5pbnNlcnQoWkVOLmZvcmVhY2hfc3RlcHMsIHRleHQpIGVuZApaRU4uYWRkX3NjaGVtYSA9IGZ1bmN0aW9uKGFycikgcmV0dXJuIG5pbCBlbmQKWkVOLmdpdmVuX3N0ZXBzID0ge30KWkVOLndoZW5fc3RlcHMgPSB7fQpaRU4udGhlbl9zdGVwcyA9IHt9ClpFTi5pZl9zdGVwcyA9IHt9ClpFTi5mb3JlYWNoX3N0ZXBzID0ge30KZm9yIF8sIHYgaW4gaXBhaXJzKHplbmNvZGVfc2NlbmFyaW9zKCkpIGRvCiAgaWYgbm90IFNDRU5BUklPIHRoZW4KICAgIHJlcXVpcmVfb25jZSgnemVuY29kZV8nLi52KQogIGVsc2VpZiBTQ0VOQVJJTyA9PSB2IHRoZW4KICAgIHJlcXVpcmVfb25jZSgnemVuY29kZV8nLi52KQogIGVuZAplbmQKU1RBVEVNRU5UUyA9IEpTT04uZW5jb2RlKAp7IEdpdmVuID0gWkVOLmdpdmVuX3N0ZXBzLAogIFdoZW4gPSBaRU4ud2hlbl9zdGVwcywKICBUaGVuID0gWkVOLnRoZW5fc3RlcHMsCiAgSWYgPSBaRU4uaWZfc3RlcHMsCiAgRm9yZWFjaCA9IFpFTi5mb3JlYWNoX3N0ZXBzIH0pAEGQzDMLywddVwoAWAwLAH3lCgAf5AoAWAwLAMfqCgANsQoAWAwLAGPpCgClpwoAWAwLAMvoCgB5sAoAWAwLAD/pCgBxngoAWAwLAFvoCgCQyQoAWAwLAGPqCgB3dgoAWAwLAIHmCgCpiAoAWAwLAPbmCgC1eAoAWAwLAJ3mCgCH9goAWAwLADHrCgA6oQoAWAwLAG3oCgBZnAoAWAwLAA3oCgB/lwoAWAwLAL/nCgBoogoAWAwLAJjoCgCD6woAWAwLAPrqCgBQkgoAWAwLAGDnCgCUxQoAWAwLACnqCgD6XgoAWAwLALvlCgBjiQoAWAwLAA7nCgCWpwoAWAwLALfoCgBX6woAWAwLAOjqCgDmkgoAWAwLAHDnCgBKoQoAWAwLAILoCgCMswoAWAwLAKzpCgA6kgoAWAwLAE/nCgAq5AoAWAwLANfqCgD60AoAWAwLAJnqCgCuxwoAWAwLAD/qCgBmcwoAWAwLAFTmCgDa4QoAWAwLALfqCgDSqAoAWAwLAProCgCPlwoAWAwLANTnCgB4ywoAWAwLAIbqCgBjdgoAWAwLAG/mCgAkywoAWAwLAHfqCgAIbwoAWAwLADfmCgA3ZQoAWAwLAAvmCgBonAoAWAwLACHoCgCLwQoAWAwLAPrpCgBVswoAWAwLAJnpCgCBpAoAWAwLAKzoCgDdswoAWAwLAMHpCgD1gQoAWAwLANDmCgCOVQoAWAwLAGXlCgAVcQoAWAwLAEHmCgCU6woAWAwLAAvrCgBnlgoAWAwLAI/nCgAmmgoAWAwLAOrnCgA2tQoAWAwLANTpCgDenQoAWAwLADboCgBvlgoAWAwLAKHnCgAVrQoAWAwLAC3pCgApZQoAWAwLAPjlCgB0hgoAWAwLAOHmCgB1yAoAWAwLAFHqCgDBeAoAWAwLAK7mCgDjagoAWAwLAB/mCgC3pwoAWAwLAOLoCgDI9AoAWAwLAB7rCgCveAoAWAwLAJLmCgANrQoAWAwLACDpCgDf1woAWAwLAKbqCgCGXAoAWAwLAJHlCgDoXgoAWAwLAKTlCgAysgoAWAwLAIfpCgAlsgoAWAwLAHXpCgDBjQoAWAwLABrnCgAAsQoAWAwLAFHpCgAvkgoAWAwLAD/nCgC5lgoAWAwLAKvnCgB/dAoAWAwLAGLmCgAckgoAWAwLAC3nCgB/kwoAWAwLAH7nCgB8XwoAWAwLANPlCgAzwwoAWAwLAAvqCgAFrQoAWAwLAAvpCgAluAoAWAwLAOnpCgBkngoAWAwLAEnoCgAdZQoAWAwLAOflCgDqgQoAWAwLAMDmCgBB8NMzCzQdTFgNQUChB9dfPhhBG98GickaCOx3DQyiY6MazH1wCpjqsAJMaksWgE5aD4bScQeKaUQBAEGw1DMLNeArFw5MR2IOdKk6G2K0QgaiVe8VeeenAOeCwgHoSR4ewRYgG3H3qQO6xGIAYADRAtEIKQ4JAEHw1DMLAQsAQbDVMwvRCbdJRhMTs2AVq1uLGeWrhQFhhSwO2marHYnJfwHgWhQRPjBrBazAzA4HRAIOgWYGHbHyBRoIAAAAu4PLE413pwG61TAG5k3lEYO0hh5oOJ4Rl9VfEFDtZQvnF3wcQD0KEawuYgFeVocSPu2UEgsAAACw3J4M7fy8APinXAJUenwYWMklDjT2gBLjoZUPMCtlDiQDzhvQVIgOMRJEB9jx7BLbBUAVBgAAAGFomx0gQ5wN8WQcBMa5xA0zNQgT2fhEGczGlxy3Ua0M5PXXEqAqPxh0goETbtuYH2ZxjhcLAAAA2ZWIDE1nqggU8Z0HYN5QFIWJwRoXzLIVuyH8DP9KQguZ25kUcowgHyytkBmG6DMDoyaXCQcAAACDKWUPMw6eCHNGzxmVWxoOCAr5CPNLyBVOe24GTyq7D7E82xVVOr0fBkh0AP4n5hpQMgwDCwAAAITtOQEtkb8Ot7JLAYJRogTaqLIG5HwMESNAhhPx4ckEhhWxH5UyVxywyY0aUprIH1Nl7RYGAAAAjsjwA8ewWgbnax0dkfGRD5szUwd5eBcDC5rGFmnrZBXlbTUT8ouIBiEOHRrFt1cDcOeBGwsAAAAX45cEVMOMC1ul0w0t5SsF+uQdHWKUZAsWi9IV6vOcDXU7xA3I9B0LzSzkHogfTxMfz9MABAAAAJ4MOR49gyAZX97JALhdFhIx+rcRXXpdCoydZRKLQQcQyy7dAnmc6ArUDYMLiE+fF+H4sQkLAAAAe/sFFvj5PhMyexcKGD/uFmlvhhTYAbAZK1RbHg/PvBvMffoN2LKSDgI7thzED5wTB9ohAwgAAAAp0qILdNFFDupHThNsATcWJIy2BibhjR8Cj/AeBlnED53XMR1xbw8ciKVHD+EcTBxIwggOAwAAABwb0gDSz+cJJn4PDXwDrRFVK8YK5L8wBFZy6gJpa3QJ79UBD9OfXhqLuSwGXDP+GUjVqAwEAAAA/zsrCHY7QQ55ugkM2QhRFT1x9QskRiwBmwQwABCeQRnoQXAWsSnHFEQcLRKGOKsW3qVhBQkAAAAZPrgc0s0RBj+3PwX5LKEHas3qDI1YAAeZ8kcTMU7rDUGJbx/IlP8NivlNAL1ERg/lL5YSBQAAANgsxg2cRG8YBHE9G31Iqg2XBP0WRuFVFDJTRRUs1uIHJAhbFFoH4hv7qw4S/cUVCxpYJRQBAAAAHqIyFdnK6RxUB14NPlA3Bb2pbRDZGXQCrTXuCgwkNAvH3/8dAz0fGlfHmwJQKVIEIBaOGgkAAAClBGMfFM1vAXDEowiIl6QBQPeCCVySdx4OKTQVldM5HTVXOQk3NigY30NOFXLPzAmOXzUHBwAAADpK6A5LoisBOxt4Ax6nZgenzukNVzGYA7g4JQZ06jUTVw9XATnLAh8Yg88DMmzSAs+qLBcDAAAAXlrMHd3Mvg/EtHgEOpFyC/qAxQLB/OYQW2agAk15Qxhjf24ZDHimA2z9LAxkUckaqcJ6CgoAAABB1qEZ02G3GxHckA5XJc0EOFCDGJw/0wZA0K0ZJiyuA41/4AwePX4Nz4KkFwSfShtqzw4BBQAAAArd7AiLJhwLC0AZHpaWnA4xWcERebycCX3b3QD63tIdtIL2ADQrnRWPW9sRqFXSE6sT/BUEAAAAAQBBwN8zC8kNM7sHF4wrwhSv8OgONt31GNA8PRSySrYXSq1IBQ0VyRETrREa5wZMCsJHZwnAnUQXgXzZEAQAAACWxkEO0Tq/BPgv6gssI84KbE3TGrP1oRFBPvQA56mEDekjEgM02rcbtQ1EFSOw3AkQapkUCQAAAPbhLQcGEv8G7kgBDFEspBomfdoAoMglHxINixNjFMsa4lIlFEzaUQMy4SgdzdwsFbqGxwwAAAAAy/TlEL3jqhEpe4cRPXW1AOSdzxGSAfYRkidwBG/dIRenKtQXOqPDFkYdJh5CODARbjeGHwAAAADb/ugSZ9e2DRAqEAQTuPEP7sKtEZoQ6R8M5uECynl8HzZVGQROqRAV+NMrFyb+wR/eP8AMBAAAAPClMxaJ1ZENphygFpJNxh4D4kQVap0eDkHZ9R629ZUa0Kd0ADWFxw1HeIQI1JbGAKT8AwYLAAAA8tbpHyrEDwuyV9ADjIT1EHp08xSxJp4AxUgtEzB8RRm4W+ccWcs7AfRdsgx5N1gfvLmwCgIAAAAp+3AYGGXyCmhN+hf9oYoML2RCCDZh0wYO9H8Au3f8FwUKFxQzNmUJr0mmF99wdQZTjXwYBAAAAIel2xu7crgB2OiBAY8DpAyd5qsMkA81Fy16sAm488wCvTqPGw1t8hCIJyMal9AsG4sBxB8EAAAAMBxzCl5XfR3Km64TuqvgHrO5Qw3yaD8PYRr4G14r8hQMKsQDUQptHXmvjghqew0Doae7AQcAAAAywREQ1oibADq/7g+cuXQeGwNhHsSxIB9gRP8E6ZVtGcsvzRPcH+oY40J/A3yj+QZ55BMXDAAAAI5NBxAmRT4Qs4E1ETbomxOdJEMWj8g/H6+5GAkYXhUXWTVSDG6X9h9QMEYOve1tHgipRgsMAAAA+B6XC4AnYAqDfIQEI4OjEGzwMwbaA3QInAA7AtaERgWxp3oE+qknAFhCVRQzJzcAwcqCEQUAAAAzAZgbrp/OFhCZygg4WiEfbMxZBiCelhGZTwAWgqkBATt7dRyuGN8TKwC/HDaVPRpKOVoEAQAAAEsidRSK81gT4e1rHso2CQK6Rs4HtZyuB6xmoxUM/ToQPWdeHB8lRhp9VqgAIp6JHEWWEhwCAAAABLbICfO1ogXBHQcQ/f0ECmYrGxDXSn0Kt17lCMuS8BEdGMsVdfkWGs5CqROcBx4S6eRrHgoAAADBYzYQnZI8CkAbCAPsHdEGf6DnEvOtlREMu5sPAROvHG0aYAlXh9YHUASGFGQxORXDxBIBCwAAAD2gSQ5hgbAXTI2nFMYOTAiK9wEeKXqrAYSSchaaOOYeT8iFGEUaHgJbL4MGPEACB8J1LRYMAAAA8me/HanFKRFH4lsebaz5CmfKLg3Ok+4S1jDEHM81qgqFxHgXinV0C5+r6htOtIEMBjPfGAIAAAAWVF8EwmyTBmrrpQCF5ckGJxf0CpPzRBL2SDgMmrd7G8UV0RGmbU8c70iDHCunHBOHKH0LCwAAAB0ApREYocgRdnu7FB+4KxYgapEM7+QHDbtQwQ437eETnNHGHG4UwRdEMgMMyYe+CJUHDh4FAAAArLf5Cv07MhaAOHMKv3MbB59EphWHtz0MsxcHAhuqyhhSAbcCjMFjFbqZ7Adbtg0Dl1KeDQQAAABcd2oSyJzQCE/uxwJLAzgVXx0FAAUg3hJNd70Dn6FRH/3sXgsSTGcFzaHuEF+2MxUIfAAGCwAAANkugRXQCnIHGLl3ABBg6wGSKxMXGgPpB836Xx/pQ98LN6TlDvs33RV+N+8A1E99HIvwPgoLAAAASl1TFersGRnaIJIEd+/FHyyFtBn5JYYaFa+CBOvVmBwM+/kEZrqOHlP5hgZGwtgG045sBgwAAABVP5EYXaR3A43XbAqqR70Qc7xPHVM/lwwhTO0esCd8DPcWMhAkVMoeZYGgGjncFA7aXKUHCwAAAKhqjxrlpMUHAIHBAJ8+hQsah1wKG3ObDWQ5pBg0bDcH0G2cHYiU1gAoBDwSegtIHZ4lLw0CAAAAkhBWAk+pJRSl+q4f3jDREm9RExlTZ0QNPjBKC8j5XRH/lH8HYihGEgdLYR1/BjoQdLbLDAUAAADMRTMXwonNFEewQg7Hxw4AMGm4GQbQfBdz9ZkI4FsxG0YzVBak+KIFUUzYEMf/7BgUlWsNBQAAAPcG7QaZ4NYPNCAzBQ57Lwog5IAEoTz5BtItBx8k5ZwSW1a/ErdrngpD96IYdp5cFg5AYAYBAAAAj0tjHdA5qgAR4CUN4uHqBcoFogq2GmseO8lMAXdOvAwPxHEBzsBrEFcJyRp8gLsNgR36AAcAAAABAEHA7TML0QFVBAYAAwAAAAMAAADA9gwAAAAAAFUECAADAAAAAwAAANT2DAAAAAAAVQQHAAMAAAADAAAA6PYMAAAAAABVBAoAAwAAAAMAAAD89gwAAAAAAFUECwADAAAAAwAAABD3DAAAAAAAVQQDAAMAAAADAAAAJPcMAAAAAAAqhkiG9w0BCQEAAAAJAAAACQAAADj3DAAAAAAAVR0RAAMAAAADAAAAVPcMAAAAAABVHQ8AAwAAAAMAAABo9wwAAAAAAFUdEwADAAAAAwAAAHz3DAAAAAAABQBBnO8zCwE6AEG07zMLCzgAAAA3AAAALA0NAEHM7zMLAQIAQdzvMwsI//////////8AQaDwMwsJkPcMAAAAAAAJAEG08DMLAToAQcjwMwsSOQAAAAAAAAA3AAAAOA0NAAAEAEH08DMLBP////8AQbjxMwsBBQBBxPEzCwJ9AgBB3PEzCw44AAAAfgIAAEgRDQAABABB9PEzCwEBAEGE8jMLBf////8KAEHI8jMLA7j4DA==");
          }
          function getBinarySync(file) {
            if (ArrayBuffer.isView(file)) {
              return file;
            }
            if (readBinary) {
              return readBinary(file);
            }
            throw "both async and sync fetching of the wasm failed";
          }
          async function getWasmBinary(binaryFile) {
            return getBinarySync(binaryFile);
          }
          async function instantiateArrayBuffer(binaryFile, imports) {
            try {
              var binary = await getWasmBinary(binaryFile);
              var instance = await WebAssembly.instantiate(binary, imports);
              return instance;
            } catch (reason) {
              err3(`failed to asynchronously prepare wasm: ${reason}`);
              if (isFileURI(wasmBinaryFile)) {
                err3(`warning: Loading from a file URI (${wasmBinaryFile}) is not supported in most browsers. See https://emscripten.org/docs/getting_started/FAQ.html#how-do-i-run-a-local-webserver-for-testing-why-does-my-program-stall-in-downloading-or-preparing`);
              }
              abort(reason);
            }
          }
          async function instantiateAsync(binary, binaryFile, imports) {
            return instantiateArrayBuffer(binaryFile, imports);
          }
          function getWasmImports() {
            return { env: wasmImports, wasi_snapshot_preview1: wasmImports };
          }
          async function createWasm() {
            function receiveInstance(instance, module3) {
              wasmExports = instance.exports;
              wasmMemory = wasmExports["memory"];
              assert2(wasmMemory, "memory not found in wasm exports");
              updateMemoryViews();
              wasmTable = wasmExports["__indirect_function_table"];
              assert2(wasmTable, "table not found in wasm exports");
              assignWasmExports(wasmExports);
              removeRunDependency("wasm-instantiate");
              return wasmExports;
            }
            addRunDependency("wasm-instantiate");
            var trueModule = Module2;
            function receiveInstantiationResult(result2) {
              assert2(Module2 === trueModule, "the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?");
              trueModule = null;
              return receiveInstance(result2["instance"]);
            }
            var info2 = getWasmImports();
            wasmBinaryFile ??= findWasmBinary();
            var result = await instantiateAsync(wasmBinary, wasmBinaryFile, info2);
            var exports3 = receiveInstantiationResult(result);
            return exports3;
          }
          class ExitStatus {
            name = "ExitStatus";
            constructor(status) {
              this.message = `Program terminated with exit(${status})`;
              this.status = status;
            }
          }
          var base64Decode = (b64) => {
            if (ENVIRONMENT_IS_NODE) {
              var buf = Buffer.from(b64, "base64");
              return new Uint8Array(buf.buffer, buf.byteOffset, buf.length);
            }
            assert2(b64.length % 4 == 0);
            var b1, b22, i3 = 0, j = 0, bLength = b64.length;
            var output3 = new Uint8Array((bLength * 3 >> 2) - (b64[bLength - 2] == "=") - (b64[bLength - 1] == "="));
            for (; i3 < bLength; i3 += 4, j += 3) {
              b1 = base64ReverseLookup[b64.charCodeAt(i3 + 1)];
              b22 = base64ReverseLookup[b64.charCodeAt(i3 + 2)];
              output3[j] = base64ReverseLookup[b64.charCodeAt(i3)] << 2 | b1 >> 4;
              output3[j + 1] = b1 << 4 | b22 >> 2;
              output3[j + 2] = b22 << 6 | base64ReverseLookup[b64.charCodeAt(i3 + 3)];
            }
            return output3;
          };
          var ptrToString = (ptr) => {
            assert2(typeof ptr === "number");
            ptr >>>= 0;
            return "0x" + ptr.toString(16).padStart(8, "0");
          };
          var stackRestore = (val) => __emscripten_stack_restore(val);
          var stackSave = () => _emscripten_stack_get_current();
          var warnOnce = (text) => {
            warnOnce.shown ||= {};
            if (!warnOnce.shown[text]) {
              warnOnce.shown[text] = 1;
              if (ENVIRONMENT_IS_NODE) text = "warning: " + text;
              err3(text);
            }
          };
          var PATH = { isAbs: (path3) => path3.charAt(0) === "/", splitPath: (filename) => {
            var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
            return splitPathRe.exec(filename).slice(1);
          }, normalizeArray: (parts, allowAboveRoot) => {
            var up = 0;
            for (var i3 = parts.length - 1; i3 >= 0; i3--) {
              var last = parts[i3];
              if (last === ".") {
                parts.splice(i3, 1);
              } else if (last === "..") {
                parts.splice(i3, 1);
                up++;
              } else if (up) {
                parts.splice(i3, 1);
                up--;
              }
            }
            if (allowAboveRoot) {
              for (; up; up--) {
                parts.unshift("..");
              }
            }
            return parts;
          }, normalize: (path3) => {
            var isAbsolute2 = PATH.isAbs(path3), trailingSlash = path3.slice(-1) === "/";
            path3 = PATH.normalizeArray(path3.split("/").filter((p12) => !!p12), !isAbsolute2).join("/");
            if (!path3 && !isAbsolute2) {
              path3 = ".";
            }
            if (path3 && trailingSlash) {
              path3 += "/";
            }
            return (isAbsolute2 ? "/" : "") + path3;
          }, dirname: (path3) => {
            var result = PATH.splitPath(path3), root = result[0], dir = result[1];
            if (!root && !dir) {
              return ".";
            }
            if (dir) {
              dir = dir.slice(0, -1);
            }
            return root + dir;
          }, basename: (path3) => path3 && path3.match(/([^\/]+|\/)\/*$/)[1], join: (...paths) => PATH.normalize(paths.join("/")), join2: (l, r2) => PATH.normalize(l + "/" + r2) };
          var initRandomFill = () => {
            if (ENVIRONMENT_IS_NODE) {
              var nodeCrypto = __require("crypto");
              return (view2) => nodeCrypto.randomFillSync(view2);
            }
            return (view2) => crypto.getRandomValues(view2);
          };
          var randomFill = (view2) => {
            (randomFill = initRandomFill())(view2);
          };
          var PATH_FS = { resolve: (...args) => {
            var resolvedPath = "", resolvedAbsolute = false;
            for (var i3 = args.length - 1; i3 >= -1 && !resolvedAbsolute; i3--) {
              var path3 = i3 >= 0 ? args[i3] : FS.cwd();
              if (typeof path3 != "string") {
                throw new TypeError("Arguments to path.resolve must be strings");
              } else if (!path3) {
                return "";
              }
              resolvedPath = path3 + "/" + resolvedPath;
              resolvedAbsolute = PATH.isAbs(path3);
            }
            resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p12) => !!p12), !resolvedAbsolute).join("/");
            return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
          }, relative: (from, to) => {
            from = PATH_FS.resolve(from).slice(1);
            to = PATH_FS.resolve(to).slice(1);
            function trim2(arr) {
              var start = 0;
              for (; start < arr.length; start++) {
                if (arr[start] !== "") break;
              }
              var end = arr.length - 1;
              for (; end >= 0; end--) {
                if (arr[end] !== "") break;
              }
              if (start > end) return [];
              return arr.slice(start, end - start + 1);
            }
            var fromParts = trim2(from.split("/"));
            var toParts = trim2(to.split("/"));
            var length2 = Math.min(fromParts.length, toParts.length);
            var samePartsLength = length2;
            for (var i3 = 0; i3 < length2; i3++) {
              if (fromParts[i3] !== toParts[i3]) {
                samePartsLength = i3;
                break;
              }
            }
            var outputParts = [];
            for (var i3 = samePartsLength; i3 < fromParts.length; i3++) {
              outputParts.push("..");
            }
            outputParts = outputParts.concat(toParts.slice(samePartsLength));
            return outputParts.join("/");
          } };
          var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder() : void 0;
          var UTF8ArrayToString = (heapOrArray, idx = 0, maxBytesToRead = NaN) => {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while (heapOrArray[endPtr] && !(endPtr >= endIdx)) ++endPtr;
            if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
              return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
            }
            var str = "";
            while (idx < endPtr) {
              var u0 = heapOrArray[idx++];
              if (!(u0 & 128)) {
                str += String.fromCharCode(u0);
                continue;
              }
              var u1 = heapOrArray[idx++] & 63;
              if ((u0 & 224) == 192) {
                str += String.fromCharCode((u0 & 31) << 6 | u1);
                continue;
              }
              var u2 = heapOrArray[idx++] & 63;
              if ((u0 & 240) == 224) {
                u0 = (u0 & 15) << 12 | u1 << 6 | u2;
              } else {
                if ((u0 & 248) != 240) warnOnce("Invalid UTF-8 leading byte " + ptrToString(u0) + " encountered when deserializing a UTF-8 string in wasm memory to a JS string!");
                u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
              }
              if (u0 < 65536) {
                str += String.fromCharCode(u0);
              } else {
                var ch = u0 - 65536;
                str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
              }
            }
            return str;
          };
          var FS_stdin_getChar_buffer = [];
          var lengthBytesUTF8 = (str) => {
            var len = 0;
            for (var i3 = 0; i3 < str.length; ++i3) {
              var c = str.charCodeAt(i3);
              if (c <= 127) {
                len++;
              } else if (c <= 2047) {
                len += 2;
              } else if (c >= 55296 && c <= 57343) {
                len += 4;
                ++i3;
              } else {
                len += 3;
              }
            }
            return len;
          };
          var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
            assert2(typeof str === "string", `stringToUTF8Array expects a string (got ${typeof str})`);
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for (var i3 = 0; i3 < str.length; ++i3) {
              var u = str.codePointAt(i3);
              if (u <= 127) {
                if (outIdx >= endIdx) break;
                heap[outIdx++] = u;
              } else if (u <= 2047) {
                if (outIdx + 1 >= endIdx) break;
                heap[outIdx++] = 192 | u >> 6;
                heap[outIdx++] = 128 | u & 63;
              } else if (u <= 65535) {
                if (outIdx + 2 >= endIdx) break;
                heap[outIdx++] = 224 | u >> 12;
                heap[outIdx++] = 128 | u >> 6 & 63;
                heap[outIdx++] = 128 | u & 63;
              } else {
                if (outIdx + 3 >= endIdx) break;
                if (u > 1114111) warnOnce("Invalid Unicode code point " + ptrToString(u) + " encountered when serializing a JS string to a UTF-8 string in wasm memory! (Valid unicode code points should be in range 0-0x10FFFF).");
                heap[outIdx++] = 240 | u >> 18;
                heap[outIdx++] = 128 | u >> 12 & 63;
                heap[outIdx++] = 128 | u >> 6 & 63;
                heap[outIdx++] = 128 | u & 63;
                i3++;
              }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
          };
          var intArrayFromString = (stringy, dontAddNull, length2) => {
            var len = length2 > 0 ? length2 : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull) u8array.length = numBytesWritten;
            return u8array;
          };
          var FS_stdin_getChar = () => {
            if (!FS_stdin_getChar_buffer.length) {
              var result = null;
              if (ENVIRONMENT_IS_NODE) {
                var BUFSIZE = 256;
                var buf = Buffer.alloc(BUFSIZE);
                var bytesRead = 0;
                var fd2 = process.stdin.fd;
                try {
                  bytesRead = fs2.readSync(fd2, buf, 0, BUFSIZE);
                } catch (e2) {
                  if (e2.toString().includes("EOF")) bytesRead = 0;
                  else throw e2;
                }
                if (bytesRead > 0) {
                  result = buf.slice(0, bytesRead).toString("utf-8");
                }
              } else if (typeof window != "undefined" && typeof window.prompt == "function") {
                result = window.prompt("Input: ");
                if (result !== null) {
                  result += "\n";
                }
              } else {
              }
              if (!result) {
                return null;
              }
              FS_stdin_getChar_buffer = intArrayFromString(result, true);
            }
            return FS_stdin_getChar_buffer.shift();
          };
          var TTY = { ttys: [], init() {
          }, shutdown() {
          }, register(dev, ops) {
            TTY.ttys[dev] = { input: [], output: [], ops };
            FS.registerDevice(dev, TTY.stream_ops);
          }, stream_ops: { open(stream) {
            var tty = TTY.ttys[stream.node.rdev];
            if (!tty) {
              throw new FS.ErrnoError(43);
            }
            stream.tty = tty;
            stream.seekable = false;
          }, close(stream) {
            stream.tty.ops.fsync(stream.tty);
          }, fsync(stream) {
            stream.tty.ops.fsync(stream.tty);
          }, read(stream, buffer, offset, length2, pos) {
            if (!stream.tty || !stream.tty.ops.get_char) {
              throw new FS.ErrnoError(60);
            }
            var bytesRead = 0;
            for (var i3 = 0; i3 < length2; i3++) {
              var result;
              try {
                result = stream.tty.ops.get_char(stream.tty);
              } catch (e2) {
                throw new FS.ErrnoError(29);
              }
              if (result === void 0 && bytesRead === 0) {
                throw new FS.ErrnoError(6);
              }
              if (result === null || result === void 0) break;
              bytesRead++;
              buffer[offset + i3] = result;
            }
            if (bytesRead) {
              stream.node.atime = Date.now();
            }
            return bytesRead;
          }, write(stream, buffer, offset, length2, pos) {
            if (!stream.tty || !stream.tty.ops.put_char) {
              throw new FS.ErrnoError(60);
            }
            try {
              for (var i3 = 0; i3 < length2; i3++) {
                stream.tty.ops.put_char(stream.tty, buffer[offset + i3]);
              }
            } catch (e2) {
              throw new FS.ErrnoError(29);
            }
            if (length2) {
              stream.node.mtime = stream.node.ctime = Date.now();
            }
            return i3;
          } }, default_tty_ops: { get_char(tty) {
            return FS_stdin_getChar();
          }, put_char(tty, val) {
            if (val === null || val === 10) {
              out(UTF8ArrayToString(tty.output));
              tty.output = [];
            } else {
              if (val != 0) tty.output.push(val);
            }
          }, fsync(tty) {
            if (tty.output?.length > 0) {
              out(UTF8ArrayToString(tty.output));
              tty.output = [];
            }
          }, ioctl_tcgets(tty) {
            return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
          }, ioctl_tcsets(tty, optional_actions, data) {
            return 0;
          }, ioctl_tiocgwinsz(tty) {
            return [24, 80];
          } }, default_tty1_ops: { put_char(tty, val) {
            if (val === null || val === 10) {
              err3(UTF8ArrayToString(tty.output));
              tty.output = [];
            } else {
              if (val != 0) tty.output.push(val);
            }
          }, fsync(tty) {
            if (tty.output?.length > 0) {
              err3(UTF8ArrayToString(tty.output));
              tty.output = [];
            }
          } } };
          var mmapAlloc = (size) => {
            abort("internal error: mmapAlloc called but `emscripten_builtin_memalign` native symbol not exported");
          };
          var MEMFS = { ops_table: null, mount(mount3) {
            return MEMFS.createNode(null, "/", 16895, 0);
          }, createNode(parent, name2, mode, dev) {
            if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
              throw new FS.ErrnoError(63);
            }
            MEMFS.ops_table ||= { dir: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, lookup: MEMFS.node_ops.lookup, mknod: MEMFS.node_ops.mknod, rename: MEMFS.node_ops.rename, unlink: MEMFS.node_ops.unlink, rmdir: MEMFS.node_ops.rmdir, readdir: MEMFS.node_ops.readdir, symlink: MEMFS.node_ops.symlink }, stream: { llseek: MEMFS.stream_ops.llseek } }, file: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: { llseek: MEMFS.stream_ops.llseek, read: MEMFS.stream_ops.read, write: MEMFS.stream_ops.write, mmap: MEMFS.stream_ops.mmap, msync: MEMFS.stream_ops.msync } }, link: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr, readlink: MEMFS.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: MEMFS.node_ops.getattr, setattr: MEMFS.node_ops.setattr }, stream: FS.chrdev_stream_ops } };
            var node = FS.createNode(parent, name2, mode, dev);
            if (FS.isDir(node.mode)) {
              node.node_ops = MEMFS.ops_table.dir.node;
              node.stream_ops = MEMFS.ops_table.dir.stream;
              node.contents = {};
            } else if (FS.isFile(node.mode)) {
              node.node_ops = MEMFS.ops_table.file.node;
              node.stream_ops = MEMFS.ops_table.file.stream;
              node.usedBytes = 0;
              node.contents = null;
            } else if (FS.isLink(node.mode)) {
              node.node_ops = MEMFS.ops_table.link.node;
              node.stream_ops = MEMFS.ops_table.link.stream;
            } else if (FS.isChrdev(node.mode)) {
              node.node_ops = MEMFS.ops_table.chrdev.node;
              node.stream_ops = MEMFS.ops_table.chrdev.stream;
            }
            node.atime = node.mtime = node.ctime = Date.now();
            if (parent) {
              parent.contents[name2] = node;
              parent.atime = parent.mtime = parent.ctime = node.atime;
            }
            return node;
          }, getFileDataAsTypedArray(node) {
            if (!node.contents) return new Uint8Array(0);
            if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
            return new Uint8Array(node.contents);
          }, expandFileStorage(node, newCapacity) {
            var prevCapacity = node.contents ? node.contents.length : 0;
            if (prevCapacity >= newCapacity) return;
            var CAPACITY_DOUBLING_MAX = 1024 * 1024;
            newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
            if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
            var oldContents = node.contents;
            node.contents = new Uint8Array(newCapacity);
            if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
          }, resizeFileStorage(node, newSize) {
            if (node.usedBytes == newSize) return;
            if (newSize == 0) {
              node.contents = null;
              node.usedBytes = 0;
            } else {
              var oldContents = node.contents;
              node.contents = new Uint8Array(newSize);
              if (oldContents) {
                node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
              }
              node.usedBytes = newSize;
            }
          }, node_ops: { getattr(node) {
            var attr = {};
            attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
            attr.ino = node.id;
            attr.mode = node.mode;
            attr.nlink = 1;
            attr.uid = 0;
            attr.gid = 0;
            attr.rdev = node.rdev;
            if (FS.isDir(node.mode)) {
              attr.size = 4096;
            } else if (FS.isFile(node.mode)) {
              attr.size = node.usedBytes;
            } else if (FS.isLink(node.mode)) {
              attr.size = node.link.length;
            } else {
              attr.size = 0;
            }
            attr.atime = new Date(node.atime);
            attr.mtime = new Date(node.mtime);
            attr.ctime = new Date(node.ctime);
            attr.blksize = 4096;
            attr.blocks = Math.ceil(attr.size / attr.blksize);
            return attr;
          }, setattr(node, attr) {
            for (const key of ["mode", "atime", "mtime", "ctime"]) {
              if (attr[key] != null) {
                node[key] = attr[key];
              }
            }
            if (attr.size !== void 0) {
              MEMFS.resizeFileStorage(node, attr.size);
            }
          }, lookup(parent, name2) {
            throw new FS.ErrnoError(44);
          }, mknod(parent, name2, mode, dev) {
            return MEMFS.createNode(parent, name2, mode, dev);
          }, rename(old_node, new_dir, new_name) {
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e2) {
            }
            if (new_node) {
              if (FS.isDir(old_node.mode)) {
                for (var i3 in new_node.contents) {
                  throw new FS.ErrnoError(55);
                }
              }
              FS.hashRemoveNode(new_node);
            }
            delete old_node.parent.contents[old_node.name];
            new_dir.contents[new_name] = old_node;
            old_node.name = new_name;
            new_dir.ctime = new_dir.mtime = old_node.parent.ctime = old_node.parent.mtime = Date.now();
          }, unlink(parent, name2) {
            delete parent.contents[name2];
            parent.ctime = parent.mtime = Date.now();
          }, rmdir(parent, name2) {
            var node = FS.lookupNode(parent, name2);
            for (var i3 in node.contents) {
              throw new FS.ErrnoError(55);
            }
            delete parent.contents[name2];
            parent.ctime = parent.mtime = Date.now();
          }, readdir(node) {
            return [".", "..", ...Object.keys(node.contents)];
          }, symlink(parent, newname, oldpath) {
            var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
            node.link = oldpath;
            return node;
          }, readlink(node) {
            if (!FS.isLink(node.mode)) {
              throw new FS.ErrnoError(28);
            }
            return node.link;
          } }, stream_ops: { read(stream, buffer, offset, length2, position) {
            var contents = stream.node.contents;
            if (position >= stream.node.usedBytes) return 0;
            var size = Math.min(stream.node.usedBytes - position, length2);
            assert2(size >= 0);
            if (size > 8 && contents.subarray) {
              buffer.set(contents.subarray(position, position + size), offset);
            } else {
              for (var i3 = 0; i3 < size; i3++) buffer[offset + i3] = contents[position + i3];
            }
            return size;
          }, write(stream, buffer, offset, length2, position, canOwn) {
            assert2(!(buffer instanceof ArrayBuffer));
            if (buffer.buffer === HEAP8.buffer) {
              canOwn = false;
            }
            if (!length2) return 0;
            var node = stream.node;
            node.mtime = node.ctime = Date.now();
            if (buffer.subarray && (!node.contents || node.contents.subarray)) {
              if (canOwn) {
                assert2(position === 0, "canOwn must imply no weird position inside the file");
                node.contents = buffer.subarray(offset, offset + length2);
                node.usedBytes = length2;
                return length2;
              } else if (node.usedBytes === 0 && position === 0) {
                node.contents = buffer.slice(offset, offset + length2);
                node.usedBytes = length2;
                return length2;
              } else if (position + length2 <= node.usedBytes) {
                node.contents.set(buffer.subarray(offset, offset + length2), position);
                return length2;
              }
            }
            MEMFS.expandFileStorage(node, position + length2);
            if (node.contents.subarray && buffer.subarray) {
              node.contents.set(buffer.subarray(offset, offset + length2), position);
            } else {
              for (var i3 = 0; i3 < length2; i3++) {
                node.contents[position + i3] = buffer[offset + i3];
              }
            }
            node.usedBytes = Math.max(node.usedBytes, position + length2);
            return length2;
          }, llseek(stream, offset, whence) {
            var position = offset;
            if (whence === 1) {
              position += stream.position;
            } else if (whence === 2) {
              if (FS.isFile(stream.node.mode)) {
                position += stream.node.usedBytes;
              }
            }
            if (position < 0) {
              throw new FS.ErrnoError(28);
            }
            return position;
          }, mmap(stream, length2, position, prot, flags) {
            if (!FS.isFile(stream.node.mode)) {
              throw new FS.ErrnoError(43);
            }
            var ptr;
            var allocated;
            var contents = stream.node.contents;
            if (!(flags & 2) && contents && contents.buffer === HEAP8.buffer) {
              allocated = false;
              ptr = contents.byteOffset;
            } else {
              allocated = true;
              ptr = mmapAlloc(length2);
              if (!ptr) {
                throw new FS.ErrnoError(48);
              }
              if (contents) {
                if (position > 0 || position + length2 < contents.length) {
                  if (contents.subarray) {
                    contents = contents.subarray(position, position + length2);
                  } else {
                    contents = Array.prototype.slice.call(contents, position, position + length2);
                  }
                }
                HEAP8.set(contents, ptr);
              }
            }
            return { ptr, allocated };
          }, msync(stream, buffer, offset, length2, mmapFlags) {
            MEMFS.stream_ops.write(stream, buffer, 0, length2, offset, false);
            return 0;
          } } };
          var asyncLoad = async (url) => {
            var arrayBuffer = await readAsync(url);
            assert2(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`);
            return new Uint8Array(arrayBuffer);
          };
          var FS_createDataFile = (...args) => FS.createDataFile(...args);
          var getUniqueRunDependency = (id) => {
            var orig = id;
            while (1) {
              if (!runDependencyTracking[id]) return id;
              id = orig + Math.random();
            }
          };
          var preloadPlugins = [];
          var FS_handledByPreloadPlugin = (byteArray, fullname, finish, onerror) => {
            if (typeof Browser != "undefined") Browser.init();
            var handled = false;
            preloadPlugins.forEach((plugin) => {
              if (handled) return;
              if (plugin["canHandle"](fullname)) {
                plugin["handle"](byteArray, fullname, finish, onerror);
                handled = true;
              }
            });
            return handled;
          };
          var FS_createPreloadedFile = (parent, name2, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) => {
            var fullname = name2 ? PATH_FS.resolve(PATH.join2(parent, name2)) : parent;
            var dep = getUniqueRunDependency(`cp ${fullname}`);
            function processData(byteArray) {
              function finish(byteArray2) {
                preFinish?.();
                if (!dontCreateFile) {
                  FS_createDataFile(parent, name2, byteArray2, canRead, canWrite, canOwn);
                }
                onload?.();
                removeRunDependency(dep);
              }
              if (FS_handledByPreloadPlugin(byteArray, fullname, finish, () => {
                onerror?.();
                removeRunDependency(dep);
              })) {
                return;
              }
              finish(byteArray);
            }
            addRunDependency(dep);
            if (typeof url == "string") {
              asyncLoad(url).then(processData, onerror);
            } else {
              processData(url);
            }
          };
          var FS_modeStringToFlags = (str) => {
            var flagModes = { r: 0, "r+": 2, w: 512 | 64 | 1, "w+": 512 | 64 | 2, a: 1024 | 64 | 1, "a+": 1024 | 64 | 2 };
            var flags = flagModes[str];
            if (typeof flags == "undefined") {
              throw new Error(`Unknown file open mode: ${str}`);
            }
            return flags;
          };
          var FS_getMode = (canRead, canWrite) => {
            var mode = 0;
            if (canRead) mode |= 292 | 73;
            if (canWrite) mode |= 146;
            return mode;
          };
          var UTF8ToString = (ptr, maxBytesToRead) => {
            assert2(typeof ptr == "number", `UTF8ToString expects a number (got ${typeof ptr})`);
            return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
          };
          var strError = (errno) => UTF8ToString(_strerror(errno));
          var ERRNO_CODES = { EPERM: 63, ENOENT: 44, ESRCH: 71, EINTR: 27, EIO: 29, ENXIO: 60, E2BIG: 1, ENOEXEC: 45, EBADF: 8, ECHILD: 12, EAGAIN: 6, EWOULDBLOCK: 6, ENOMEM: 48, EACCES: 2, EFAULT: 21, ENOTBLK: 105, EBUSY: 10, EEXIST: 20, EXDEV: 75, ENODEV: 43, ENOTDIR: 54, EISDIR: 31, EINVAL: 28, ENFILE: 41, EMFILE: 33, ENOTTY: 59, ETXTBSY: 74, EFBIG: 22, ENOSPC: 51, ESPIPE: 70, EROFS: 69, EMLINK: 34, EPIPE: 64, EDOM: 18, ERANGE: 68, ENOMSG: 49, EIDRM: 24, ECHRNG: 106, EL2NSYNC: 156, EL3HLT: 107, EL3RST: 108, ELNRNG: 109, EUNATCH: 110, ENOCSI: 111, EL2HLT: 112, EDEADLK: 16, ENOLCK: 46, EBADE: 113, EBADR: 114, EXFULL: 115, ENOANO: 104, EBADRQC: 103, EBADSLT: 102, EDEADLOCK: 16, EBFONT: 101, ENOSTR: 100, ENODATA: 116, ETIME: 117, ENOSR: 118, ENONET: 119, ENOPKG: 120, EREMOTE: 121, ENOLINK: 47, EADV: 122, ESRMNT: 123, ECOMM: 124, EPROTO: 65, EMULTIHOP: 36, EDOTDOT: 125, EBADMSG: 9, ENOTUNIQ: 126, EBADFD: 127, EREMCHG: 128, ELIBACC: 129, ELIBBAD: 130, ELIBSCN: 131, ELIBMAX: 132, ELIBEXEC: 133, ENOSYS: 52, ENOTEMPTY: 55, ENAMETOOLONG: 37, ELOOP: 32, EOPNOTSUPP: 138, EPFNOSUPPORT: 139, ECONNRESET: 15, ENOBUFS: 42, EAFNOSUPPORT: 5, EPROTOTYPE: 67, ENOTSOCK: 57, ENOPROTOOPT: 50, ESHUTDOWN: 140, ECONNREFUSED: 14, EADDRINUSE: 3, ECONNABORTED: 13, ENETUNREACH: 40, ENETDOWN: 38, ETIMEDOUT: 73, EHOSTDOWN: 142, EHOSTUNREACH: 23, EINPROGRESS: 26, EALREADY: 7, EDESTADDRREQ: 17, EMSGSIZE: 35, EPROTONOSUPPORT: 66, ESOCKTNOSUPPORT: 137, EADDRNOTAVAIL: 4, ENETRESET: 39, EISCONN: 30, ENOTCONN: 53, ETOOMANYREFS: 141, EUSERS: 136, EDQUOT: 19, ESTALE: 72, ENOTSUP: 138, ENOMEDIUM: 148, EILSEQ: 25, EOVERFLOW: 61, ECANCELED: 11, ENOTRECOVERABLE: 56, EOWNERDEAD: 62, ESTRPIPE: 135 };
          var FS = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: false, ignorePermissions: true, filesystems: null, syncFSRequests: 0, ErrnoError: class extends Error {
            name = "ErrnoError";
            constructor(errno) {
              super(runtimeInitialized ? strError(errno) : "");
              this.errno = errno;
              for (var key in ERRNO_CODES) {
                if (ERRNO_CODES[key] === errno) {
                  this.code = key;
                  break;
                }
              }
            }
          }, FSStream: class {
            shared = {};
            get object() {
              return this.node;
            }
            set object(val) {
              this.node = val;
            }
            get isRead() {
              return (this.flags & 2097155) !== 1;
            }
            get isWrite() {
              return (this.flags & 2097155) !== 0;
            }
            get isAppend() {
              return this.flags & 1024;
            }
            get flags() {
              return this.shared.flags;
            }
            set flags(val) {
              this.shared.flags = val;
            }
            get position() {
              return this.shared.position;
            }
            set position(val) {
              this.shared.position = val;
            }
          }, FSNode: class {
            node_ops = {};
            stream_ops = {};
            readMode = 292 | 73;
            writeMode = 146;
            mounted = null;
            constructor(parent, name2, mode, rdev) {
              if (!parent) {
                parent = this;
              }
              this.parent = parent;
              this.mount = parent.mount;
              this.id = FS.nextInode++;
              this.name = name2;
              this.mode = mode;
              this.rdev = rdev;
              this.atime = this.mtime = this.ctime = Date.now();
            }
            get read() {
              return (this.mode & this.readMode) === this.readMode;
            }
            set read(val) {
              val ? this.mode |= this.readMode : this.mode &= ~this.readMode;
            }
            get write() {
              return (this.mode & this.writeMode) === this.writeMode;
            }
            set write(val) {
              val ? this.mode |= this.writeMode : this.mode &= ~this.writeMode;
            }
            get isFolder() {
              return FS.isDir(this.mode);
            }
            get isDevice() {
              return FS.isChrdev(this.mode);
            }
          }, lookupPath(path3, opts = {}) {
            if (!path3) {
              throw new FS.ErrnoError(44);
            }
            opts.follow_mount ??= true;
            if (!PATH.isAbs(path3)) {
              path3 = FS.cwd() + "/" + path3;
            }
            linkloop: for (var nlinks = 0; nlinks < 40; nlinks++) {
              var parts = path3.split("/").filter((p12) => !!p12);
              var current = FS.root;
              var current_path = "/";
              for (var i3 = 0; i3 < parts.length; i3++) {
                var islast = i3 === parts.length - 1;
                if (islast && opts.parent) {
                  break;
                }
                if (parts[i3] === ".") {
                  continue;
                }
                if (parts[i3] === "..") {
                  current_path = PATH.dirname(current_path);
                  if (FS.isRoot(current)) {
                    path3 = current_path + "/" + parts.slice(i3 + 1).join("/");
                    continue linkloop;
                  } else {
                    current = current.parent;
                  }
                  continue;
                }
                current_path = PATH.join2(current_path, parts[i3]);
                try {
                  current = FS.lookupNode(current, parts[i3]);
                } catch (e2) {
                  if (e2?.errno === 44 && islast && opts.noent_okay) {
                    return { path: current_path };
                  }
                  throw e2;
                }
                if (FS.isMountpoint(current) && (!islast || opts.follow_mount)) {
                  current = current.mounted.root;
                }
                if (FS.isLink(current.mode) && (!islast || opts.follow)) {
                  if (!current.node_ops.readlink) {
                    throw new FS.ErrnoError(52);
                  }
                  var link3 = current.node_ops.readlink(current);
                  if (!PATH.isAbs(link3)) {
                    link3 = PATH.dirname(current_path) + "/" + link3;
                  }
                  path3 = link3 + "/" + parts.slice(i3 + 1).join("/");
                  continue linkloop;
                }
              }
              return { path: current_path, node: current };
            }
            throw new FS.ErrnoError(32);
          }, getPath(node) {
            var path3;
            while (true) {
              if (FS.isRoot(node)) {
                var mount3 = node.mount.mountpoint;
                if (!path3) return mount3;
                return mount3[mount3.length - 1] !== "/" ? `${mount3}/${path3}` : mount3 + path3;
              }
              path3 = path3 ? `${node.name}/${path3}` : node.name;
              node = node.parent;
            }
          }, hashName(parentid, name2) {
            var hash2 = 0;
            for (var i3 = 0; i3 < name2.length; i3++) {
              hash2 = (hash2 << 5) - hash2 + name2.charCodeAt(i3) | 0;
            }
            return (parentid + hash2 >>> 0) % FS.nameTable.length;
          }, hashAddNode(node) {
            var hash2 = FS.hashName(node.parent.id, node.name);
            node.name_next = FS.nameTable[hash2];
            FS.nameTable[hash2] = node;
          }, hashRemoveNode(node) {
            var hash2 = FS.hashName(node.parent.id, node.name);
            if (FS.nameTable[hash2] === node) {
              FS.nameTable[hash2] = node.name_next;
            } else {
              var current = FS.nameTable[hash2];
              while (current) {
                if (current.name_next === node) {
                  current.name_next = node.name_next;
                  break;
                }
                current = current.name_next;
              }
            }
          }, lookupNode(parent, name2) {
            var errCode = FS.mayLookup(parent);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            var hash2 = FS.hashName(parent.id, name2);
            for (var node = FS.nameTable[hash2]; node; node = node.name_next) {
              var nodeName = node.name;
              if (node.parent.id === parent.id && nodeName === name2) {
                return node;
              }
            }
            return FS.lookup(parent, name2);
          }, createNode(parent, name2, mode, rdev) {
            assert2(typeof parent == "object");
            var node = new FS.FSNode(parent, name2, mode, rdev);
            FS.hashAddNode(node);
            return node;
          }, destroyNode(node) {
            FS.hashRemoveNode(node);
          }, isRoot(node) {
            return node === node.parent;
          }, isMountpoint(node) {
            return !!node.mounted;
          }, isFile(mode) {
            return (mode & 61440) === 32768;
          }, isDir(mode) {
            return (mode & 61440) === 16384;
          }, isLink(mode) {
            return (mode & 61440) === 40960;
          }, isChrdev(mode) {
            return (mode & 61440) === 8192;
          }, isBlkdev(mode) {
            return (mode & 61440) === 24576;
          }, isFIFO(mode) {
            return (mode & 61440) === 4096;
          }, isSocket(mode) {
            return (mode & 49152) === 49152;
          }, flagsToPermissionString(flag) {
            var perms = ["r", "w", "rw"][flag & 3];
            if (flag & 512) {
              perms += "w";
            }
            return perms;
          }, nodePermissions(node, perms) {
            if (FS.ignorePermissions) {
              return 0;
            }
            if (perms.includes("r") && !(node.mode & 292)) {
              return 2;
            } else if (perms.includes("w") && !(node.mode & 146)) {
              return 2;
            } else if (perms.includes("x") && !(node.mode & 73)) {
              return 2;
            }
            return 0;
          }, mayLookup(dir) {
            if (!FS.isDir(dir.mode)) return 54;
            var errCode = FS.nodePermissions(dir, "x");
            if (errCode) return errCode;
            if (!dir.node_ops.lookup) return 2;
            return 0;
          }, mayCreate(dir, name2) {
            if (!FS.isDir(dir.mode)) {
              return 54;
            }
            try {
              var node = FS.lookupNode(dir, name2);
              return 20;
            } catch (e2) {
            }
            return FS.nodePermissions(dir, "wx");
          }, mayDelete(dir, name2, isdir) {
            var node;
            try {
              node = FS.lookupNode(dir, name2);
            } catch (e2) {
              return e2.errno;
            }
            var errCode = FS.nodePermissions(dir, "wx");
            if (errCode) {
              return errCode;
            }
            if (isdir) {
              if (!FS.isDir(node.mode)) {
                return 54;
              }
              if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
                return 10;
              }
            } else {
              if (FS.isDir(node.mode)) {
                return 31;
              }
            }
            return 0;
          }, mayOpen(node, flags) {
            if (!node) {
              return 44;
            }
            if (FS.isLink(node.mode)) {
              return 32;
            } else if (FS.isDir(node.mode)) {
              if (FS.flagsToPermissionString(flags) !== "r" || flags & (512 | 64)) {
                return 31;
              }
            }
            return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
          }, checkOpExists(op, err4) {
            if (!op) {
              throw new FS.ErrnoError(err4);
            }
            return op;
          }, MAX_OPEN_FDS: 4096, nextfd() {
            for (var fd2 = 0; fd2 <= FS.MAX_OPEN_FDS; fd2++) {
              if (!FS.streams[fd2]) {
                return fd2;
              }
            }
            throw new FS.ErrnoError(33);
          }, getStreamChecked(fd2) {
            var stream = FS.getStream(fd2);
            if (!stream) {
              throw new FS.ErrnoError(8);
            }
            return stream;
          }, getStream: (fd2) => FS.streams[fd2], createStream(stream, fd2 = -1) {
            assert2(fd2 >= -1);
            stream = Object.assign(new FS.FSStream(), stream);
            if (fd2 == -1) {
              fd2 = FS.nextfd();
            }
            stream.fd = fd2;
            FS.streams[fd2] = stream;
            return stream;
          }, closeStream(fd2) {
            FS.streams[fd2] = null;
          }, dupStream(origStream, fd2 = -1) {
            var stream = FS.createStream(origStream, fd2);
            stream.stream_ops?.dup?.(stream);
            return stream;
          }, doSetAttr(stream, node, attr) {
            var setattr = stream?.stream_ops.setattr;
            var arg = setattr ? stream : node;
            setattr ??= node.node_ops.setattr;
            FS.checkOpExists(setattr, 63);
            setattr(arg, attr);
          }, chrdev_stream_ops: { open(stream) {
            var device = FS.getDevice(stream.node.rdev);
            stream.stream_ops = device.stream_ops;
            stream.stream_ops.open?.(stream);
          }, llseek() {
            throw new FS.ErrnoError(70);
          } }, major: (dev) => dev >> 8, minor: (dev) => dev & 255, makedev: (ma, mi) => ma << 8 | mi, registerDevice(dev, ops) {
            FS.devices[dev] = { stream_ops: ops };
          }, getDevice: (dev) => FS.devices[dev], getMounts(mount3) {
            var mounts2 = [];
            var check = [mount3];
            while (check.length) {
              var m = check.pop();
              mounts2.push(m);
              check.push(...m.mounts);
            }
            return mounts2;
          }, syncfs(populate, callback) {
            if (typeof populate == "function") {
              callback = populate;
              populate = false;
            }
            FS.syncFSRequests++;
            if (FS.syncFSRequests > 1) {
              err3(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
            }
            var mounts2 = FS.getMounts(FS.root.mount);
            var completed = 0;
            function doCallback(errCode) {
              assert2(FS.syncFSRequests > 0);
              FS.syncFSRequests--;
              return callback(errCode);
            }
            function done(errCode) {
              if (errCode) {
                if (!done.errored) {
                  done.errored = true;
                  return doCallback(errCode);
                }
                return;
              }
              if (++completed >= mounts2.length) {
                doCallback(null);
              }
            }
            mounts2.forEach((mount3) => {
              if (!mount3.type.syncfs) {
                return done(null);
              }
              mount3.type.syncfs(mount3, populate, done);
            });
          }, mount(type, opts, mountpoint) {
            if (typeof type == "string") {
              throw type;
            }
            var root = mountpoint === "/";
            var pseudo = !mountpoint;
            var node;
            if (root && FS.root) {
              throw new FS.ErrnoError(10);
            } else if (!root && !pseudo) {
              var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
              mountpoint = lookup.path;
              node = lookup.node;
              if (FS.isMountpoint(node)) {
                throw new FS.ErrnoError(10);
              }
              if (!FS.isDir(node.mode)) {
                throw new FS.ErrnoError(54);
              }
            }
            var mount3 = { type, opts, mountpoint, mounts: [] };
            var mountRoot = type.mount(mount3);
            mountRoot.mount = mount3;
            mount3.root = mountRoot;
            if (root) {
              FS.root = mountRoot;
            } else if (node) {
              node.mounted = mount3;
              if (node.mount) {
                node.mount.mounts.push(mount3);
              }
            }
            return mountRoot;
          }, unmount(mountpoint) {
            var lookup = FS.lookupPath(mountpoint, { follow_mount: false });
            if (!FS.isMountpoint(lookup.node)) {
              throw new FS.ErrnoError(28);
            }
            var node = lookup.node;
            var mount3 = node.mounted;
            var mounts2 = FS.getMounts(mount3);
            Object.keys(FS.nameTable).forEach((hash2) => {
              var current = FS.nameTable[hash2];
              while (current) {
                var next = current.name_next;
                if (mounts2.includes(current.mount)) {
                  FS.destroyNode(current);
                }
                current = next;
              }
            });
            node.mounted = null;
            var idx = node.mount.mounts.indexOf(mount3);
            assert2(idx !== -1);
            node.mount.mounts.splice(idx, 1);
          }, lookup(parent, name2) {
            return parent.node_ops.lookup(parent, name2);
          }, mknod(path3, mode, dev) {
            var lookup = FS.lookupPath(path3, { parent: true });
            var parent = lookup.node;
            var name2 = PATH.basename(path3);
            if (!name2) {
              throw new FS.ErrnoError(28);
            }
            if (name2 === "." || name2 === "..") {
              throw new FS.ErrnoError(20);
            }
            var errCode = FS.mayCreate(parent, name2);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            if (!parent.node_ops.mknod) {
              throw new FS.ErrnoError(63);
            }
            return parent.node_ops.mknod(parent, name2, mode, dev);
          }, statfs(path3) {
            return FS.statfsNode(FS.lookupPath(path3, { follow: true }).node);
          }, statfsStream(stream) {
            return FS.statfsNode(stream.node);
          }, statfsNode(node) {
            var rtn = { bsize: 4096, frsize: 4096, blocks: 1e6, bfree: 5e5, bavail: 5e5, files: FS.nextInode, ffree: FS.nextInode - 1, fsid: 42, flags: 2, namelen: 255 };
            if (node.node_ops.statfs) {
              Object.assign(rtn, node.node_ops.statfs(node.mount.opts.root));
            }
            return rtn;
          }, create(path3, mode = 438) {
            mode &= 4095;
            mode |= 32768;
            return FS.mknod(path3, mode, 0);
          }, mkdir(path3, mode = 511) {
            mode &= 511 | 512;
            mode |= 16384;
            return FS.mknod(path3, mode, 0);
          }, mkdirTree(path3, mode) {
            var dirs = path3.split("/");
            var d = "";
            for (var dir of dirs) {
              if (!dir) continue;
              if (d || PATH.isAbs(path3)) d += "/";
              d += dir;
              try {
                FS.mkdir(d, mode);
              } catch (e2) {
                if (e2.errno != 20) throw e2;
              }
            }
          }, mkdev(path3, mode, dev) {
            if (typeof dev == "undefined") {
              dev = mode;
              mode = 438;
            }
            mode |= 8192;
            return FS.mknod(path3, mode, dev);
          }, symlink(oldpath, newpath) {
            if (!PATH_FS.resolve(oldpath)) {
              throw new FS.ErrnoError(44);
            }
            var lookup = FS.lookupPath(newpath, { parent: true });
            var parent = lookup.node;
            if (!parent) {
              throw new FS.ErrnoError(44);
            }
            var newname = PATH.basename(newpath);
            var errCode = FS.mayCreate(parent, newname);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            if (!parent.node_ops.symlink) {
              throw new FS.ErrnoError(63);
            }
            return parent.node_ops.symlink(parent, newname, oldpath);
          }, rename(old_path, new_path) {
            var old_dirname = PATH.dirname(old_path);
            var new_dirname = PATH.dirname(new_path);
            var old_name = PATH.basename(old_path);
            var new_name = PATH.basename(new_path);
            var lookup, old_dir, new_dir;
            lookup = FS.lookupPath(old_path, { parent: true });
            old_dir = lookup.node;
            lookup = FS.lookupPath(new_path, { parent: true });
            new_dir = lookup.node;
            if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
            if (old_dir.mount !== new_dir.mount) {
              throw new FS.ErrnoError(75);
            }
            var old_node = FS.lookupNode(old_dir, old_name);
            var relative2 = PATH_FS.relative(old_path, new_dirname);
            if (relative2.charAt(0) !== ".") {
              throw new FS.ErrnoError(28);
            }
            relative2 = PATH_FS.relative(new_path, old_dirname);
            if (relative2.charAt(0) !== ".") {
              throw new FS.ErrnoError(55);
            }
            var new_node;
            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e2) {
            }
            if (old_node === new_node) {
              return;
            }
            var isdir = FS.isDir(old_node.mode);
            var errCode = FS.mayDelete(old_dir, old_name, isdir);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            if (!old_dir.node_ops.rename) {
              throw new FS.ErrnoError(63);
            }
            if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
              throw new FS.ErrnoError(10);
            }
            if (new_dir !== old_dir) {
              errCode = FS.nodePermissions(old_dir, "w");
              if (errCode) {
                throw new FS.ErrnoError(errCode);
              }
            }
            FS.hashRemoveNode(old_node);
            try {
              old_dir.node_ops.rename(old_node, new_dir, new_name);
              old_node.parent = new_dir;
            } catch (e2) {
              throw e2;
            } finally {
              FS.hashAddNode(old_node);
            }
          }, rmdir(path3) {
            var lookup = FS.lookupPath(path3, { parent: true });
            var parent = lookup.node;
            var name2 = PATH.basename(path3);
            var node = FS.lookupNode(parent, name2);
            var errCode = FS.mayDelete(parent, name2, true);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            if (!parent.node_ops.rmdir) {
              throw new FS.ErrnoError(63);
            }
            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }
            parent.node_ops.rmdir(parent, name2);
            FS.destroyNode(node);
          }, readdir(path3) {
            var lookup = FS.lookupPath(path3, { follow: true });
            var node = lookup.node;
            var readdir3 = FS.checkOpExists(node.node_ops.readdir, 54);
            return readdir3(node);
          }, unlink(path3) {
            var lookup = FS.lookupPath(path3, { parent: true });
            var parent = lookup.node;
            if (!parent) {
              throw new FS.ErrnoError(44);
            }
            var name2 = PATH.basename(path3);
            var node = FS.lookupNode(parent, name2);
            var errCode = FS.mayDelete(parent, name2, false);
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            if (!parent.node_ops.unlink) {
              throw new FS.ErrnoError(63);
            }
            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }
            parent.node_ops.unlink(parent, name2);
            FS.destroyNode(node);
          }, readlink(path3) {
            var lookup = FS.lookupPath(path3);
            var link3 = lookup.node;
            if (!link3) {
              throw new FS.ErrnoError(44);
            }
            if (!link3.node_ops.readlink) {
              throw new FS.ErrnoError(28);
            }
            return link3.node_ops.readlink(link3);
          }, stat(path3, dontFollow) {
            var lookup = FS.lookupPath(path3, { follow: !dontFollow });
            var node = lookup.node;
            var getattr = FS.checkOpExists(node.node_ops.getattr, 63);
            return getattr(node);
          }, fstat(fd2) {
            var stream = FS.getStreamChecked(fd2);
            var node = stream.node;
            var getattr = stream.stream_ops.getattr;
            var arg = getattr ? stream : node;
            getattr ??= node.node_ops.getattr;
            FS.checkOpExists(getattr, 63);
            return getattr(arg);
          }, lstat(path3) {
            return FS.stat(path3, true);
          }, doChmod(stream, node, mode, dontFollow) {
            FS.doSetAttr(stream, node, { mode: mode & 4095 | node.mode & ~4095, ctime: Date.now(), dontFollow });
          }, chmod(path3, mode, dontFollow) {
            var node;
            if (typeof path3 == "string") {
              var lookup = FS.lookupPath(path3, { follow: !dontFollow });
              node = lookup.node;
            } else {
              node = path3;
            }
            FS.doChmod(null, node, mode, dontFollow);
          }, lchmod(path3, mode) {
            FS.chmod(path3, mode, true);
          }, fchmod(fd2, mode) {
            var stream = FS.getStreamChecked(fd2);
            FS.doChmod(stream, stream.node, mode, false);
          }, doChown(stream, node, dontFollow) {
            FS.doSetAttr(stream, node, { timestamp: Date.now(), dontFollow });
          }, chown(path3, uid, gid, dontFollow) {
            var node;
            if (typeof path3 == "string") {
              var lookup = FS.lookupPath(path3, { follow: !dontFollow });
              node = lookup.node;
            } else {
              node = path3;
            }
            FS.doChown(null, node, dontFollow);
          }, lchown(path3, uid, gid) {
            FS.chown(path3, uid, gid, true);
          }, fchown(fd2, uid, gid) {
            var stream = FS.getStreamChecked(fd2);
            FS.doChown(stream, stream.node, false);
          }, doTruncate(stream, node, len) {
            if (FS.isDir(node.mode)) {
              throw new FS.ErrnoError(31);
            }
            if (!FS.isFile(node.mode)) {
              throw new FS.ErrnoError(28);
            }
            var errCode = FS.nodePermissions(node, "w");
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            FS.doSetAttr(stream, node, { size: len, timestamp: Date.now() });
          }, truncate(path3, len) {
            if (len < 0) {
              throw new FS.ErrnoError(28);
            }
            var node;
            if (typeof path3 == "string") {
              var lookup = FS.lookupPath(path3, { follow: true });
              node = lookup.node;
            } else {
              node = path3;
            }
            FS.doTruncate(null, node, len);
          }, ftruncate(fd2, len) {
            var stream = FS.getStreamChecked(fd2);
            if (len < 0 || (stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(28);
            }
            FS.doTruncate(stream, stream.node, len);
          }, utime(path3, atime, mtime) {
            var lookup = FS.lookupPath(path3, { follow: true });
            var node = lookup.node;
            var setattr = FS.checkOpExists(node.node_ops.setattr, 63);
            setattr(node, { atime, mtime });
          }, open(path3, flags, mode = 438) {
            if (path3 === "") {
              throw new FS.ErrnoError(44);
            }
            flags = typeof flags == "string" ? FS_modeStringToFlags(flags) : flags;
            if (flags & 64) {
              mode = mode & 4095 | 32768;
            } else {
              mode = 0;
            }
            var node;
            var isDirPath;
            if (typeof path3 == "object") {
              node = path3;
            } else {
              isDirPath = path3.endsWith("/");
              var lookup = FS.lookupPath(path3, { follow: !(flags & 131072), noent_okay: true });
              node = lookup.node;
              path3 = lookup.path;
            }
            var created = false;
            if (flags & 64) {
              if (node) {
                if (flags & 128) {
                  throw new FS.ErrnoError(20);
                }
              } else if (isDirPath) {
                throw new FS.ErrnoError(31);
              } else {
                node = FS.mknod(path3, mode | 511, 0);
                created = true;
              }
            }
            if (!node) {
              throw new FS.ErrnoError(44);
            }
            if (FS.isChrdev(node.mode)) {
              flags &= ~512;
            }
            if (flags & 65536 && !FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }
            if (!created) {
              var errCode = FS.mayOpen(node, flags);
              if (errCode) {
                throw new FS.ErrnoError(errCode);
              }
            }
            if (flags & 512 && !created) {
              FS.truncate(node, 0);
            }
            flags &= ~(128 | 512 | 131072);
            var stream = FS.createStream({ node, path: FS.getPath(node), flags, seekable: true, position: 0, stream_ops: node.stream_ops, ungotten: [], error: false });
            if (stream.stream_ops.open) {
              stream.stream_ops.open(stream);
            }
            if (created) {
              FS.chmod(node, mode & 511);
            }
            return stream;
          }, close(stream) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }
            if (stream.getdents) stream.getdents = null;
            try {
              if (stream.stream_ops.close) {
                stream.stream_ops.close(stream);
              }
            } catch (e2) {
              throw e2;
            } finally {
              FS.closeStream(stream.fd);
            }
            stream.fd = null;
          }, isClosed(stream) {
            return stream.fd === null;
          }, llseek(stream, offset, whence) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }
            if (!stream.seekable || !stream.stream_ops.llseek) {
              throw new FS.ErrnoError(70);
            }
            if (whence != 0 && whence != 1 && whence != 2) {
              throw new FS.ErrnoError(28);
            }
            stream.position = stream.stream_ops.llseek(stream, offset, whence);
            stream.ungotten = [];
            return stream.position;
          }, read(stream, buffer, offset, length2, position) {
            assert2(offset >= 0);
            if (length2 < 0 || position < 0) {
              throw new FS.ErrnoError(28);
            }
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }
            if ((stream.flags & 2097155) === 1) {
              throw new FS.ErrnoError(8);
            }
            if (FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(31);
            }
            if (!stream.stream_ops.read) {
              throw new FS.ErrnoError(28);
            }
            var seeking = typeof position != "undefined";
            if (!seeking) {
              position = stream.position;
            } else if (!stream.seekable) {
              throw new FS.ErrnoError(70);
            }
            var bytesRead = stream.stream_ops.read(stream, buffer, offset, length2, position);
            if (!seeking) stream.position += bytesRead;
            return bytesRead;
          }, write(stream, buffer, offset, length2, position, canOwn) {
            assert2(offset >= 0);
            if (length2 < 0 || position < 0) {
              throw new FS.ErrnoError(28);
            }
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }
            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(8);
            }
            if (FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(31);
            }
            if (!stream.stream_ops.write) {
              throw new FS.ErrnoError(28);
            }
            if (stream.seekable && stream.flags & 1024) {
              FS.llseek(stream, 0, 2);
            }
            var seeking = typeof position != "undefined";
            if (!seeking) {
              position = stream.position;
            } else if (!stream.seekable) {
              throw new FS.ErrnoError(70);
            }
            var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length2, position, canOwn);
            if (!seeking) stream.position += bytesWritten;
            return bytesWritten;
          }, mmap(stream, length2, position, prot, flags) {
            if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
              throw new FS.ErrnoError(2);
            }
            if ((stream.flags & 2097155) === 1) {
              throw new FS.ErrnoError(2);
            }
            if (!stream.stream_ops.mmap) {
              throw new FS.ErrnoError(43);
            }
            if (!length2) {
              throw new FS.ErrnoError(28);
            }
            return stream.stream_ops.mmap(stream, length2, position, prot, flags);
          }, msync(stream, buffer, offset, length2, mmapFlags) {
            assert2(offset >= 0);
            if (!stream.stream_ops.msync) {
              return 0;
            }
            return stream.stream_ops.msync(stream, buffer, offset, length2, mmapFlags);
          }, ioctl(stream, cmd, arg) {
            if (!stream.stream_ops.ioctl) {
              throw new FS.ErrnoError(59);
            }
            return stream.stream_ops.ioctl(stream, cmd, arg);
          }, readFile(path3, opts = {}) {
            opts.flags = opts.flags || 0;
            opts.encoding = opts.encoding || "binary";
            if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
              throw new Error(`Invalid encoding type "${opts.encoding}"`);
            }
            var stream = FS.open(path3, opts.flags);
            var stat3 = FS.stat(path3);
            var length2 = stat3.size;
            var buf = new Uint8Array(length2);
            FS.read(stream, buf, 0, length2, 0);
            if (opts.encoding === "utf8") {
              buf = UTF8ArrayToString(buf);
            }
            FS.close(stream);
            return buf;
          }, writeFile(path3, data, opts = {}) {
            opts.flags = opts.flags || 577;
            var stream = FS.open(path3, opts.flags, opts.mode);
            if (typeof data == "string") {
              data = new Uint8Array(intArrayFromString(data, true));
            }
            if (ArrayBuffer.isView(data)) {
              FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
            } else {
              throw new Error("Unsupported data type");
            }
            FS.close(stream);
          }, cwd: () => FS.currentPath, chdir(path3) {
            var lookup = FS.lookupPath(path3, { follow: true });
            if (lookup.node === null) {
              throw new FS.ErrnoError(44);
            }
            if (!FS.isDir(lookup.node.mode)) {
              throw new FS.ErrnoError(54);
            }
            var errCode = FS.nodePermissions(lookup.node, "x");
            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }
            FS.currentPath = lookup.path;
          }, createDefaultDirectories() {
            FS.mkdir("/tmp");
            FS.mkdir("/home");
            FS.mkdir("/home/web_user");
          }, createDefaultDevices() {
            FS.mkdir("/dev");
            FS.registerDevice(FS.makedev(1, 3), { read: () => 0, write: (stream, buffer, offset, length2, pos) => length2, llseek: () => 0 });
            FS.mkdev("/dev/null", FS.makedev(1, 3));
            TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
            TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
            FS.mkdev("/dev/tty", FS.makedev(5, 0));
            FS.mkdev("/dev/tty1", FS.makedev(6, 0));
            var randomBuffer = new Uint8Array(1024), randomLeft = 0;
            var randomByte = () => {
              if (randomLeft === 0) {
                randomFill(randomBuffer);
                randomLeft = randomBuffer.byteLength;
              }
              return randomBuffer[--randomLeft];
            };
            FS.createDevice("/dev", "random", randomByte);
            FS.createDevice("/dev", "urandom", randomByte);
            FS.mkdir("/dev/shm");
            FS.mkdir("/dev/shm/tmp");
          }, createSpecialDirectories() {
            FS.mkdir("/proc");
            var proc_self = FS.mkdir("/proc/self");
            FS.mkdir("/proc/self/fd");
            FS.mount({ mount() {
              var node = FS.createNode(proc_self, "fd", 16895, 73);
              node.stream_ops = { llseek: MEMFS.stream_ops.llseek };
              node.node_ops = { lookup(parent, name2) {
                var fd2 = +name2;
                var stream = FS.getStreamChecked(fd2);
                var ret = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => stream.path }, id: fd2 + 1 };
                ret.parent = ret;
                return ret;
              }, readdir() {
                return Array.from(FS.streams.entries()).filter(([k, v]) => v).map(([k, v]) => k.toString());
              } };
              return node;
            } }, {}, "/proc/self/fd");
          }, createStandardStreams(input, output3, error) {
            if (input) {
              FS.createDevice("/dev", "stdin", input);
            } else {
              FS.symlink("/dev/tty", "/dev/stdin");
            }
            if (output3) {
              FS.createDevice("/dev", "stdout", null, output3);
            } else {
              FS.symlink("/dev/tty", "/dev/stdout");
            }
            if (error) {
              FS.createDevice("/dev", "stderr", null, error);
            } else {
              FS.symlink("/dev/tty1", "/dev/stderr");
            }
            var stdin = FS.open("/dev/stdin", 0);
            var stdout = FS.open("/dev/stdout", 1);
            var stderr = FS.open("/dev/stderr", 1);
            assert2(stdin.fd === 0, `invalid handle for stdin (${stdin.fd})`);
            assert2(stdout.fd === 1, `invalid handle for stdout (${stdout.fd})`);
            assert2(stderr.fd === 2, `invalid handle for stderr (${stderr.fd})`);
          }, staticInit() {
            FS.nameTable = new Array(4096);
            FS.mount(MEMFS, {}, "/");
            FS.createDefaultDirectories();
            FS.createDefaultDevices();
            FS.createSpecialDirectories();
            FS.filesystems = { MEMFS };
          }, init(input, output3, error) {
            assert2(!FS.initialized, "FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)");
            FS.initialized = true;
            FS.createStandardStreams(input, output3, error);
          }, quit() {
            FS.initialized = false;
            _fflush(0);
            for (var stream of FS.streams) {
              if (stream) {
                FS.close(stream);
              }
            }
          }, findObject(path3, dontResolveLastLink) {
            var ret = FS.analyzePath(path3, dontResolveLastLink);
            if (!ret.exists) {
              return null;
            }
            return ret.object;
          }, analyzePath(path3, dontResolveLastLink) {
            try {
              var lookup = FS.lookupPath(path3, { follow: !dontResolveLastLink });
              path3 = lookup.path;
            } catch (e2) {
            }
            var ret = { isRoot: false, exists: false, error: 0, name: null, path: null, object: null, parentExists: false, parentPath: null, parentObject: null };
            try {
              var lookup = FS.lookupPath(path3, { parent: true });
              ret.parentExists = true;
              ret.parentPath = lookup.path;
              ret.parentObject = lookup.node;
              ret.name = PATH.basename(path3);
              lookup = FS.lookupPath(path3, { follow: !dontResolveLastLink });
              ret.exists = true;
              ret.path = lookup.path;
              ret.object = lookup.node;
              ret.name = lookup.node.name;
              ret.isRoot = lookup.path === "/";
            } catch (e2) {
              ret.error = e2.errno;
            }
            return ret;
          }, createPath(parent, path3, canRead, canWrite) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            var parts = path3.split("/").reverse();
            while (parts.length) {
              var part = parts.pop();
              if (!part) continue;
              var current = PATH.join2(parent, part);
              try {
                FS.mkdir(current);
              } catch (e2) {
                if (e2.errno != 20) throw e2;
              }
              parent = current;
            }
            return current;
          }, createFile(parent, name2, properties, canRead, canWrite) {
            var path3 = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name2);
            var mode = FS_getMode(canRead, canWrite);
            return FS.create(path3, mode);
          }, createDataFile(parent, name2, data, canRead, canWrite, canOwn) {
            var path3 = name2;
            if (parent) {
              parent = typeof parent == "string" ? parent : FS.getPath(parent);
              path3 = name2 ? PATH.join2(parent, name2) : parent;
            }
            var mode = FS_getMode(canRead, canWrite);
            var node = FS.create(path3, mode);
            if (data) {
              if (typeof data == "string") {
                var arr = new Array(data.length);
                for (var i3 = 0, len = data.length; i3 < len; ++i3) arr[i3] = data.charCodeAt(i3);
                data = arr;
              }
              FS.chmod(node, mode | 146);
              var stream = FS.open(node, 577);
              FS.write(stream, data, 0, data.length, 0, canOwn);
              FS.close(stream);
              FS.chmod(node, mode);
            }
          }, createDevice(parent, name2, input, output3) {
            var path3 = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name2);
            var mode = FS_getMode(!!input, !!output3);
            FS.createDevice.major ??= 64;
            var dev = FS.makedev(FS.createDevice.major++, 0);
            FS.registerDevice(dev, { open(stream) {
              stream.seekable = false;
            }, close(stream) {
              if (output3?.buffer?.length) {
                output3(10);
              }
            }, read(stream, buffer, offset, length2, pos) {
              var bytesRead = 0;
              for (var i3 = 0; i3 < length2; i3++) {
                var result;
                try {
                  result = input();
                } catch (e2) {
                  throw new FS.ErrnoError(29);
                }
                if (result === void 0 && bytesRead === 0) {
                  throw new FS.ErrnoError(6);
                }
                if (result === null || result === void 0) break;
                bytesRead++;
                buffer[offset + i3] = result;
              }
              if (bytesRead) {
                stream.node.atime = Date.now();
              }
              return bytesRead;
            }, write(stream, buffer, offset, length2, pos) {
              for (var i3 = 0; i3 < length2; i3++) {
                try {
                  output3(buffer[offset + i3]);
                } catch (e2) {
                  throw new FS.ErrnoError(29);
                }
              }
              if (length2) {
                stream.node.mtime = stream.node.ctime = Date.now();
              }
              return i3;
            } });
            return FS.mkdev(path3, mode, dev);
          }, forceLoadFile(obj) {
            if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
            if (typeof XMLHttpRequest != "undefined") {
              throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
            } else {
              try {
                obj.contents = readBinary(obj.url);
                obj.usedBytes = obj.contents.length;
              } catch (e2) {
                throw new FS.ErrnoError(29);
              }
            }
          }, createLazyFile(parent, name2, url, canRead, canWrite) {
            class LazyUint8Array {
              lengthKnown = false;
              chunks = [];
              get(idx) {
                if (idx > this.length - 1 || idx < 0) {
                  return void 0;
                }
                var chunkOffset = idx % this.chunkSize;
                var chunkNum = idx / this.chunkSize | 0;
                return this.getter(chunkNum)[chunkOffset];
              }
              setDataGetter(getter) {
                this.getter = getter;
              }
              cacheLength() {
                var xhr = new XMLHttpRequest();
                xhr.open("HEAD", url, false);
                xhr.send(null);
                if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                var datalength = Number(xhr.getResponseHeader("Content-length"));
                var header;
                var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                var chunkSize = 1024 * 1024;
                if (!hasByteServing) chunkSize = datalength;
                var doXHR = (from, to) => {
                  if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                  if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                  var xhr2 = new XMLHttpRequest();
                  xhr2.open("GET", url, false);
                  if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
                  xhr2.responseType = "arraybuffer";
                  if (xhr2.overrideMimeType) {
                    xhr2.overrideMimeType("text/plain; charset=x-user-defined");
                  }
                  xhr2.send(null);
                  if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
                  if (xhr2.response !== void 0) {
                    return new Uint8Array(xhr2.response || []);
                  }
                  return intArrayFromString(xhr2.responseText || "", true);
                };
                var lazyArray2 = this;
                lazyArray2.setDataGetter((chunkNum) => {
                  var start = chunkNum * chunkSize;
                  var end = (chunkNum + 1) * chunkSize - 1;
                  end = Math.min(end, datalength - 1);
                  if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                    lazyArray2.chunks[chunkNum] = doXHR(start, end);
                  }
                  if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                  return lazyArray2.chunks[chunkNum];
                });
                if (usesGzip || !datalength) {
                  chunkSize = datalength = 1;
                  datalength = this.getter(0).length;
                  chunkSize = datalength;
                  out("LazyFiles on gzip forces download of the whole file when length is accessed");
                }
                this._length = datalength;
                this._chunkSize = chunkSize;
                this.lengthKnown = true;
              }
              get length() {
                if (!this.lengthKnown) {
                  this.cacheLength();
                }
                return this._length;
              }
              get chunkSize() {
                if (!this.lengthKnown) {
                  this.cacheLength();
                }
                return this._chunkSize;
              }
            }
            if (typeof XMLHttpRequest != "undefined") {
              if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
              var lazyArray = new LazyUint8Array();
              var properties = { isDevice: false, contents: lazyArray };
            } else {
              var properties = { isDevice: false, url };
            }
            var node = FS.createFile(parent, name2, properties, canRead, canWrite);
            if (properties.contents) {
              node.contents = properties.contents;
            } else if (properties.url) {
              node.contents = null;
              node.url = properties.url;
            }
            Object.defineProperties(node, { usedBytes: { get: function() {
              return this.contents.length;
            } } });
            var stream_ops = {};
            var keys = Object.keys(node.stream_ops);
            keys.forEach((key) => {
              var fn = node.stream_ops[key];
              stream_ops[key] = (...args) => {
                FS.forceLoadFile(node);
                return fn(...args);
              };
            });
            function writeChunks(stream, buffer, offset, length2, position) {
              var contents = stream.node.contents;
              if (position >= contents.length) return 0;
              var size = Math.min(contents.length - position, length2);
              assert2(size >= 0);
              if (contents.slice) {
                for (var i3 = 0; i3 < size; i3++) {
                  buffer[offset + i3] = contents[position + i3];
                }
              } else {
                for (var i3 = 0; i3 < size; i3++) {
                  buffer[offset + i3] = contents.get(position + i3);
                }
              }
              return size;
            }
            stream_ops.read = (stream, buffer, offset, length2, position) => {
              FS.forceLoadFile(node);
              return writeChunks(stream, buffer, offset, length2, position);
            };
            stream_ops.mmap = (stream, length2, position, prot, flags) => {
              FS.forceLoadFile(node);
              var ptr = mmapAlloc(length2);
              if (!ptr) {
                throw new FS.ErrnoError(48);
              }
              writeChunks(stream, HEAP8, ptr, length2, position);
              return { ptr, allocated: true };
            };
            node.stream_ops = stream_ops;
            return node;
          }, absolutePath() {
            abort("FS.absolutePath has been removed; use PATH_FS.resolve instead");
          }, createFolder() {
            abort("FS.createFolder has been removed; use FS.mkdir instead");
          }, createLink() {
            abort("FS.createLink has been removed; use FS.symlink instead");
          }, joinPath() {
            abort("FS.joinPath has been removed; use PATH.join instead");
          }, mmapAlloc() {
            abort("FS.mmapAlloc has been replaced by the top level function mmapAlloc");
          }, standardizePath() {
            abort("FS.standardizePath has been removed; use PATH.normalize instead");
          } };
          var SYSCALLS = { DEFAULT_POLLMASK: 5, calculateAt(dirfd, path3, allowEmpty) {
            if (PATH.isAbs(path3)) {
              return path3;
            }
            var dir;
            if (dirfd === -100) {
              dir = FS.cwd();
            } else {
              var dirstream = SYSCALLS.getStreamFromFD(dirfd);
              dir = dirstream.path;
            }
            if (path3.length == 0) {
              if (!allowEmpty) {
                throw new FS.ErrnoError(44);
              }
              return dir;
            }
            return dir + "/" + path3;
          }, writeStat(buf, stat3) {
            HEAP32[buf >> 2] = stat3.dev;
            HEAP32[buf + 4 >> 2] = stat3.mode;
            HEAPU32[buf + 8 >> 2] = stat3.nlink;
            HEAP32[buf + 12 >> 2] = stat3.uid;
            HEAP32[buf + 16 >> 2] = stat3.gid;
            HEAP32[buf + 20 >> 2] = stat3.rdev;
            HEAP64[buf + 24 >> 3] = BigInt(stat3.size);
            HEAP32[buf + 32 >> 2] = 4096;
            HEAP32[buf + 36 >> 2] = stat3.blocks;
            var atime = stat3.atime.getTime();
            var mtime = stat3.mtime.getTime();
            var ctime = stat3.ctime.getTime();
            HEAP64[buf + 40 >> 3] = BigInt(Math.floor(atime / 1e3));
            HEAPU32[buf + 48 >> 2] = atime % 1e3 * 1e3 * 1e3;
            HEAP64[buf + 56 >> 3] = BigInt(Math.floor(mtime / 1e3));
            HEAPU32[buf + 64 >> 2] = mtime % 1e3 * 1e3 * 1e3;
            HEAP64[buf + 72 >> 3] = BigInt(Math.floor(ctime / 1e3));
            HEAPU32[buf + 80 >> 2] = ctime % 1e3 * 1e3 * 1e3;
            HEAP64[buf + 88 >> 3] = BigInt(stat3.ino);
            return 0;
          }, writeStatFs(buf, stats) {
            HEAP32[buf + 4 >> 2] = stats.bsize;
            HEAP32[buf + 40 >> 2] = stats.bsize;
            HEAP32[buf + 8 >> 2] = stats.blocks;
            HEAP32[buf + 12 >> 2] = stats.bfree;
            HEAP32[buf + 16 >> 2] = stats.bavail;
            HEAP32[buf + 20 >> 2] = stats.files;
            HEAP32[buf + 24 >> 2] = stats.ffree;
            HEAP32[buf + 28 >> 2] = stats.fsid;
            HEAP32[buf + 44 >> 2] = stats.flags;
            HEAP32[buf + 36 >> 2] = stats.namelen;
          }, doMsync(addr, stream, len, flags, offset) {
            if (!FS.isFile(stream.node.mode)) {
              throw new FS.ErrnoError(43);
            }
            if (flags & 2) {
              return 0;
            }
            var buffer = HEAPU8.slice(addr, addr + len);
            FS.msync(stream, buffer, offset, len, flags);
          }, getStreamFromFD(fd2) {
            var stream = FS.getStreamChecked(fd2);
            return stream;
          }, varargs: void 0, getStr(ptr) {
            var ret = UTF8ToString(ptr);
            return ret;
          } };
          function ___syscall_dup3(fd2, newfd, flags) {
            try {
              var old = SYSCALLS.getStreamFromFD(fd2);
              assert2(!flags);
              if (old.fd === newfd) return -28;
              if (newfd < 0 || newfd >= FS.MAX_OPEN_FDS) return -8;
              var existing = FS.getStream(newfd);
              if (existing) FS.close(existing);
              return FS.dupStream(old, newfd).fd;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return -e2.errno;
            }
          }
          var syscallGetVarargI = () => {
            assert2(SYSCALLS.varargs != void 0);
            var ret = HEAP32[+SYSCALLS.varargs >> 2];
            SYSCALLS.varargs += 4;
            return ret;
          };
          var syscallGetVarargP = syscallGetVarargI;
          function ___syscall_fcntl64(fd2, cmd, varargs) {
            SYSCALLS.varargs = varargs;
            try {
              var stream = SYSCALLS.getStreamFromFD(fd2);
              switch (cmd) {
                case 0: {
                  var arg = syscallGetVarargI();
                  if (arg < 0) {
                    return -28;
                  }
                  while (FS.streams[arg]) {
                    arg++;
                  }
                  var newStream;
                  newStream = FS.dupStream(stream, arg);
                  return newStream.fd;
                }
                case 1:
                case 2:
                  return 0;
                case 3:
                  return stream.flags;
                case 4: {
                  var arg = syscallGetVarargI();
                  stream.flags |= arg;
                  return 0;
                }
                case 12: {
                  var arg = syscallGetVarargP();
                  var offset = 0;
                  HEAP16[arg + offset >> 1] = 2;
                  return 0;
                }
                case 13:
                case 14:
                  return 0;
              }
              return -28;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return -e2.errno;
            }
          }
          function ___syscall_ioctl(fd2, op, varargs) {
            SYSCALLS.varargs = varargs;
            try {
              var stream = SYSCALLS.getStreamFromFD(fd2);
              switch (op) {
                case 21509: {
                  if (!stream.tty) return -59;
                  return 0;
                }
                case 21505: {
                  if (!stream.tty) return -59;
                  if (stream.tty.ops.ioctl_tcgets) {
                    var termios = stream.tty.ops.ioctl_tcgets(stream);
                    var argp = syscallGetVarargP();
                    HEAP32[argp >> 2] = termios.c_iflag || 0;
                    HEAP32[argp + 4 >> 2] = termios.c_oflag || 0;
                    HEAP32[argp + 8 >> 2] = termios.c_cflag || 0;
                    HEAP32[argp + 12 >> 2] = termios.c_lflag || 0;
                    for (var i3 = 0; i3 < 32; i3++) {
                      HEAP8[argp + i3 + 17] = termios.c_cc[i3] || 0;
                    }
                    return 0;
                  }
                  return 0;
                }
                case 21510:
                case 21511:
                case 21512: {
                  if (!stream.tty) return -59;
                  return 0;
                }
                case 21506:
                case 21507:
                case 21508: {
                  if (!stream.tty) return -59;
                  if (stream.tty.ops.ioctl_tcsets) {
                    var argp = syscallGetVarargP();
                    var c_iflag = HEAP32[argp >> 2];
                    var c_oflag = HEAP32[argp + 4 >> 2];
                    var c_cflag = HEAP32[argp + 8 >> 2];
                    var c_lflag = HEAP32[argp + 12 >> 2];
                    var c_cc = [];
                    for (var i3 = 0; i3 < 32; i3++) {
                      c_cc.push(HEAP8[argp + i3 + 17]);
                    }
                    return stream.tty.ops.ioctl_tcsets(stream.tty, op, { c_iflag, c_oflag, c_cflag, c_lflag, c_cc });
                  }
                  return 0;
                }
                case 21519: {
                  if (!stream.tty) return -59;
                  var argp = syscallGetVarargP();
                  HEAP32[argp >> 2] = 0;
                  return 0;
                }
                case 21520: {
                  if (!stream.tty) return -59;
                  return -28;
                }
                case 21531: {
                  var argp = syscallGetVarargP();
                  return FS.ioctl(stream, op, argp);
                }
                case 21523: {
                  if (!stream.tty) return -59;
                  if (stream.tty.ops.ioctl_tiocgwinsz) {
                    var winsize = stream.tty.ops.ioctl_tiocgwinsz(stream.tty);
                    var argp = syscallGetVarargP();
                    HEAP16[argp >> 1] = winsize[0];
                    HEAP16[argp + 2 >> 1] = winsize[1];
                  }
                  return 0;
                }
                case 21524: {
                  if (!stream.tty) return -59;
                  return 0;
                }
                case 21515: {
                  if (!stream.tty) return -59;
                  return 0;
                }
                default:
                  return -28;
              }
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return -e2.errno;
            }
          }
          function ___syscall_openat(dirfd, path3, flags, varargs) {
            SYSCALLS.varargs = varargs;
            try {
              path3 = SYSCALLS.getStr(path3);
              path3 = SYSCALLS.calculateAt(dirfd, path3);
              var mode = varargs ? syscallGetVarargI() : 0;
              return FS.open(path3, flags, mode).fd;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return -e2.errno;
            }
          }
          var __abort_js = () => abort("native code called abort()");
          var __emscripten_fs_load_embedded_files = (ptr) => {
            do {
              var name_addr = HEAPU32[ptr >> 2];
              ptr += 4;
              var len = HEAPU32[ptr >> 2];
              ptr += 4;
              var content = HEAPU32[ptr >> 2];
              ptr += 4;
              var name2 = UTF8ToString(name_addr);
              FS.createPath("/", PATH.dirname(name2), true, true);
              FS.createDataFile(name2, null, HEAP8.subarray(content, content + len), true, true, true);
            } while (HEAPU32[ptr >> 2]);
          };
          var runtimeKeepaliveCounter = 0;
          var __emscripten_runtime_keepalive_clear = () => {
            runtimeKeepaliveCounter = 0;
          };
          var __emscripten_throw_longjmp = () => {
            throw Infinity;
          };
          var INT53_MAX = 9007199254740992;
          var INT53_MIN = -9007199254740992;
          var bigintToI53Checked = (num) => num < INT53_MIN || num > INT53_MAX ? NaN : Number(num);
          function __gmtime_js(time, tmPtr) {
            time = bigintToI53Checked(time);
            var date = new Date(time * 1e3);
            HEAP32[tmPtr >> 2] = date.getUTCSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getUTCMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getUTCHours();
            HEAP32[tmPtr + 12 >> 2] = date.getUTCDate();
            HEAP32[tmPtr + 16 >> 2] = date.getUTCMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getUTCFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getUTCDay();
            var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
            var yday = (date.getTime() - start) / (1e3 * 60 * 60 * 24) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
          }
          var isLeapYear = (year) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
          var MONTH_DAYS_LEAP_CUMULATIVE = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
          var MONTH_DAYS_REGULAR_CUMULATIVE = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
          var ydayFromDate = (date) => {
            var leap = isLeapYear(date.getFullYear());
            var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE;
            var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
            return yday;
          };
          function __localtime_js(time, tmPtr) {
            time = bigintToI53Checked(time);
            var date = new Date(time * 1e3);
            HEAP32[tmPtr >> 2] = date.getSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getHours();
            HEAP32[tmPtr + 12 >> 2] = date.getDate();
            HEAP32[tmPtr + 16 >> 2] = date.getMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getDay();
            var yday = ydayFromDate(date) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            HEAP32[tmPtr + 36 >> 2] = -(date.getTimezoneOffset() * 60);
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
            HEAP32[tmPtr + 32 >> 2] = dst;
          }
          var __mktime_js = function(tmPtr) {
            var ret = (() => {
              var date = new Date(HEAP32[tmPtr + 20 >> 2] + 1900, HEAP32[tmPtr + 16 >> 2], HEAP32[tmPtr + 12 >> 2], HEAP32[tmPtr + 8 >> 2], HEAP32[tmPtr + 4 >> 2], HEAP32[tmPtr >> 2], 0);
              var dst = HEAP32[tmPtr + 32 >> 2];
              var guessedOffset = date.getTimezoneOffset();
              var start = new Date(date.getFullYear(), 0, 1);
              var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
              var winterOffset = start.getTimezoneOffset();
              var dstOffset = Math.min(winterOffset, summerOffset);
              if (dst < 0) {
                HEAP32[tmPtr + 32 >> 2] = Number(summerOffset != winterOffset && dstOffset == guessedOffset);
              } else if (dst > 0 != (dstOffset == guessedOffset)) {
                var nonDstOffset = Math.max(winterOffset, summerOffset);
                var trueOffset = dst > 0 ? dstOffset : nonDstOffset;
                date.setTime(date.getTime() + (trueOffset - guessedOffset) * 6e4);
              }
              HEAP32[tmPtr + 24 >> 2] = date.getDay();
              var yday = ydayFromDate(date) | 0;
              HEAP32[tmPtr + 28 >> 2] = yday;
              HEAP32[tmPtr >> 2] = date.getSeconds();
              HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
              HEAP32[tmPtr + 8 >> 2] = date.getHours();
              HEAP32[tmPtr + 12 >> 2] = date.getDate();
              HEAP32[tmPtr + 16 >> 2] = date.getMonth();
              HEAP32[tmPtr + 20 >> 2] = date.getYear();
              var timeMs = date.getTime();
              if (isNaN(timeMs)) {
                return -1;
              }
              return timeMs / 1e3;
            })();
            return BigInt(ret);
          };
          var timers = {};
          var handleException = (e2) => {
            if (e2 instanceof ExitStatus || e2 == "unwind") {
              return EXITSTATUS;
            }
            checkStackCookie();
            if (e2 instanceof WebAssembly.RuntimeError) {
              if (_emscripten_stack_get_current() <= 0) {
                err3("Stack overflow detected.  You can try increasing -sSTACK_SIZE (currently set to 7340032)");
              }
            }
            quit_(1, e2);
          };
          var keepRuntimeAlive = () => true;
          var _proc_exit = (code) => {
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
              ABORT = true;
            }
            quit_(code, new ExitStatus(code));
          };
          var exitJS = (status, implicit) => {
            EXITSTATUS = status;
            checkUnflushedContent();
            if (keepRuntimeAlive() && !implicit) {
              var msg = `program exited (with status: ${status}), but keepRuntimeAlive() is set (counter=${runtimeKeepaliveCounter}) due to an async operation, so halting execution but not exiting the runtime or preventing further async execution (you can use emscripten_force_exit, if you want to force a true shutdown)`;
              readyPromiseReject?.(msg);
              err3(msg);
            }
            _proc_exit(status);
          };
          var _exit = exitJS;
          var maybeExit = () => {
            if (!keepRuntimeAlive()) {
              try {
                _exit(EXITSTATUS);
              } catch (e2) {
                handleException(e2);
              }
            }
          };
          var callUserCallback = (func) => {
            if (ABORT) {
              err3("user callback triggered after runtime exited or application aborted.  Ignoring.");
              return;
            }
            try {
              func();
              maybeExit();
            } catch (e2) {
              handleException(e2);
            }
          };
          var _emscripten_get_now = () => performance.now();
          var __setitimer_js = (which, timeout_ms) => {
            if (timers[which]) {
              clearTimeout(timers[which].id);
              delete timers[which];
            }
            if (!timeout_ms) return 0;
            var id = setTimeout(() => {
              assert2(which in timers);
              delete timers[which];
              callUserCallback(() => __emscripten_timeout(which, _emscripten_get_now()));
            }, timeout_ms);
            timers[which] = { id, timeout_ms };
            return 0;
          };
          var stringToUTF8 = (str, outPtr, maxBytesToWrite) => {
            assert2(typeof maxBytesToWrite == "number", "stringToUTF8(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!");
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
          };
          var __tzset_js = (timezone, daylight, std_name, dst_name) => {
            var currentYear = (/* @__PURE__ */ new Date()).getFullYear();
            var winter = new Date(currentYear, 0, 1);
            var summer = new Date(currentYear, 6, 1);
            var winterOffset = winter.getTimezoneOffset();
            var summerOffset = summer.getTimezoneOffset();
            var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
            HEAPU32[timezone >> 2] = stdTimezoneOffset * 60;
            HEAP32[daylight >> 2] = Number(winterOffset != summerOffset);
            var extractZone = (timezoneOffset) => {
              var sign6 = timezoneOffset >= 0 ? "-" : "+";
              var absOffset = Math.abs(timezoneOffset);
              var hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
              var minutes = String(absOffset % 60).padStart(2, "0");
              return `UTC${sign6}${hours}${minutes}`;
            };
            var winterName = extractZone(winterOffset);
            var summerName = extractZone(summerOffset);
            assert2(winterName);
            assert2(summerName);
            assert2(lengthBytesUTF8(winterName) <= 16, `timezone name truncated to fit in TZNAME_MAX (${winterName})`);
            assert2(lengthBytesUTF8(summerName) <= 16, `timezone name truncated to fit in TZNAME_MAX (${summerName})`);
            if (summerOffset < winterOffset) {
              stringToUTF8(winterName, std_name, 17);
              stringToUTF8(summerName, dst_name, 17);
            } else {
              stringToUTF8(winterName, dst_name, 17);
              stringToUTF8(summerName, std_name, 17);
            }
          };
          var _emscripten_date_now = () => Date.now();
          var nowIsMonotonic = 1;
          var checkWasiClock = (clock_id) => clock_id >= 0 && clock_id <= 3;
          function _clock_time_get(clk_id, ignored_precision, ptime) {
            ignored_precision = bigintToI53Checked(ignored_precision);
            if (!checkWasiClock(clk_id)) {
              return 28;
            }
            var now;
            if (clk_id === 0) {
              now = _emscripten_date_now();
            } else if (nowIsMonotonic) {
              now = _emscripten_get_now();
            } else {
              return 52;
            }
            var nsec = Math.round(now * 1e3 * 1e3);
            HEAP64[ptime >> 3] = BigInt(nsec);
            return 0;
          }
          var readEmAsmArgsArray = [];
          var readEmAsmArgs = (sigPtr, buf) => {
            assert2(Array.isArray(readEmAsmArgsArray));
            assert2(buf % 16 == 0);
            readEmAsmArgsArray.length = 0;
            var ch;
            while (ch = HEAPU8[sigPtr++]) {
              var chr = String.fromCharCode(ch);
              var validChars = ["d", "f", "i", "p"];
              validChars.push("j");
              assert2(validChars.includes(chr), `Invalid character ${ch}("${chr}") in readEmAsmArgs! Use only [${validChars}], and do not specify "v" for void return argument.`);
              var wide = ch != 105;
              wide &= ch != 112;
              buf += wide && buf % 8 ? 4 : 0;
              readEmAsmArgsArray.push(ch == 112 ? HEAPU32[buf >> 2] : ch == 106 ? HEAP64[buf >> 3] : ch == 105 ? HEAP32[buf >> 2] : HEAPF64[buf >> 3]);
              buf += wide ? 8 : 4;
            }
            return readEmAsmArgsArray;
          };
          var runEmAsmFunction = (code, sigPtr, argbuf) => {
            var args = readEmAsmArgs(sigPtr, argbuf);
            assert2(ASM_CONSTS.hasOwnProperty(code), `No EM_ASM constant found at address ${code}.  The loaded WebAssembly file is likely out of sync with the generated JavaScript.`);
            return ASM_CONSTS[code](...args);
          };
          var _emscripten_asm_const_int = (code, sigPtr, argbuf) => runEmAsmFunction(code, sigPtr, argbuf);
          var getHeapMax = () => 1073741824;
          var alignMemory = (size, alignment) => {
            assert2(alignment, "alignment argument is required");
            return Math.ceil(size / alignment) * alignment;
          };
          var growMemory = (size) => {
            var b = wasmMemory.buffer;
            var pages = (size - b.byteLength + 65535) / 65536 | 0;
            try {
              wasmMemory.grow(pages);
              updateMemoryViews();
              return 1;
            } catch (e2) {
              err3(`growMemory: Attempted to grow heap from ${b.byteLength} bytes to ${size} bytes, but got error: ${e2}`);
            }
          };
          var _emscripten_resize_heap = (requestedSize) => {
            var oldSize = HEAPU8.length;
            requestedSize >>>= 0;
            assert2(requestedSize > oldSize);
            var maxHeapSize = getHeapMax();
            if (requestedSize > maxHeapSize) {
              err3(`Cannot enlarge memory, requested ${requestedSize} bytes, but the limit is ${maxHeapSize} bytes!`);
              return false;
            }
            for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
              var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
              overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
              var newSize = Math.min(maxHeapSize, alignMemory(Math.max(requestedSize, overGrownHeapSize), 65536));
              var replacement = growMemory(newSize);
              if (replacement) {
                return true;
              }
            }
            err3(`Failed to grow the heap from ${oldSize} bytes to ${newSize} bytes, not enough memory!`);
            return false;
          };
          var ENV = {};
          var getExecutableName = () => thisProgram || "./this.program";
          var getEnvStrings = () => {
            if (!getEnvStrings.strings) {
              var lang = (typeof navigator == "object" && navigator.language || "C").replace("-", "_") + ".UTF-8";
              var env = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: lang, _: getExecutableName() };
              for (var x in ENV) {
                if (ENV[x] === void 0) delete env[x];
                else env[x] = ENV[x];
              }
              var strings = [];
              for (var x in env) {
                strings.push(`${x}=${env[x]}`);
              }
              getEnvStrings.strings = strings;
            }
            return getEnvStrings.strings;
          };
          var _environ_get = (__environ, environ_buf) => {
            var bufSize = 0;
            var envp = 0;
            for (var string of getEnvStrings()) {
              var ptr = environ_buf + bufSize;
              HEAPU32[__environ + envp >> 2] = ptr;
              bufSize += stringToUTF8(string, ptr, Infinity) + 1;
              envp += 4;
            }
            return 0;
          };
          var _environ_sizes_get = (penviron_count, penviron_buf_size) => {
            var strings = getEnvStrings();
            HEAPU32[penviron_count >> 2] = strings.length;
            var bufSize = 0;
            for (var string of strings) {
              bufSize += lengthBytesUTF8(string) + 1;
            }
            HEAPU32[penviron_buf_size >> 2] = bufSize;
            return 0;
          };
          function _fd_close(fd2) {
            try {
              var stream = SYSCALLS.getStreamFromFD(fd2);
              FS.close(stream);
              return 0;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return e2.errno;
            }
          }
          var doReadv = (stream, iov, iovcnt, offset) => {
            var ret = 0;
            for (var i3 = 0; i3 < iovcnt; i3++) {
              var ptr = HEAPU32[iov >> 2];
              var len = HEAPU32[iov + 4 >> 2];
              iov += 8;
              var curr = FS.read(stream, HEAP8, ptr, len, offset);
              if (curr < 0) return -1;
              ret += curr;
              if (curr < len) break;
              if (typeof offset != "undefined") {
                offset += curr;
              }
            }
            return ret;
          };
          function _fd_read(fd2, iov, iovcnt, pnum) {
            try {
              var stream = SYSCALLS.getStreamFromFD(fd2);
              var num = doReadv(stream, iov, iovcnt);
              HEAPU32[pnum >> 2] = num;
              return 0;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return e2.errno;
            }
          }
          function _fd_seek(fd2, offset, whence, newOffset) {
            offset = bigintToI53Checked(offset);
            try {
              if (isNaN(offset)) return 61;
              var stream = SYSCALLS.getStreamFromFD(fd2);
              FS.llseek(stream, offset, whence);
              HEAP64[newOffset >> 3] = BigInt(stream.position);
              if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
              return 0;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return e2.errno;
            }
          }
          var doWritev = (stream, iov, iovcnt, offset) => {
            var ret = 0;
            for (var i3 = 0; i3 < iovcnt; i3++) {
              var ptr = HEAPU32[iov >> 2];
              var len = HEAPU32[iov + 4 >> 2];
              iov += 8;
              var curr = FS.write(stream, HEAP8, ptr, len, offset);
              if (curr < 0) return -1;
              ret += curr;
              if (curr < len) {
                break;
              }
              if (typeof offset != "undefined") {
                offset += curr;
              }
            }
            return ret;
          };
          function _fd_write(fd2, iov, iovcnt, pnum) {
            try {
              var stream = SYSCALLS.getStreamFromFD(fd2);
              var num = doWritev(stream, iov, iovcnt);
              HEAPU32[pnum >> 2] = num;
              return 0;
            } catch (e2) {
              if (typeof FS == "undefined" || !(e2.name === "ErrnoError")) throw e2;
              return e2.errno;
            }
          }
          var wasmTableMirror = [];
          var wasmTable;
          var getWasmTableEntry = (funcPtr) => {
            var func = wasmTableMirror[funcPtr];
            if (!func) {
              wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
            }
            assert2(wasmTable.get(funcPtr) == func, "JavaScript-side Wasm function table mirror is out of date!");
            return func;
          };
          var getCFunc = (ident) => {
            var func = Module2["_" + ident];
            assert2(func, "Cannot call unknown function " + ident + ", make sure it is exported");
            return func;
          };
          var writeArrayToMemory = (array, buffer) => {
            assert2(array.length >= 0, "writeArrayToMemory array must have a length (should be an array or typed array)");
            HEAP8.set(array, buffer);
          };
          var stackAlloc = (sz) => __emscripten_stack_alloc(sz);
          var stringToUTF8OnStack = (str) => {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8(str, ret, size);
            return ret;
          };
          var ccall = (ident, returnType, argTypes, args, opts) => {
            var toC = { string: (str) => {
              var ret2 = 0;
              if (str !== null && str !== void 0 && str !== 0) {
                ret2 = stringToUTF8OnStack(str);
              }
              return ret2;
            }, array: (arr) => {
              var ret2 = stackAlloc(arr.length);
              writeArrayToMemory(arr, ret2);
              return ret2;
            } };
            function convertReturnValue(ret2) {
              if (returnType === "string") {
                return UTF8ToString(ret2);
              }
              if (returnType === "boolean") return Boolean(ret2);
              return ret2;
            }
            var func = getCFunc(ident);
            var cArgs = [];
            var stack = 0;
            assert2(returnType !== "array", 'Return type should not be "array".');
            if (args) {
              for (var i3 = 0; i3 < args.length; i3++) {
                var converter = toC[argTypes[i3]];
                if (converter) {
                  if (stack === 0) stack = stackSave();
                  cArgs[i3] = converter(args[i3]);
                } else {
                  cArgs[i3] = args[i3];
                }
              }
            }
            var ret = func(...cArgs);
            function onDone(ret2) {
              if (stack !== 0) stackRestore(stack);
              return convertReturnValue(ret2);
            }
            ret = onDone(ret);
            return ret;
          };
          var cwrap = (ident, returnType, argTypes, opts) => (...args) => ccall(ident, returnType, argTypes, args, opts);
          var FS_createPath = (...args) => FS.createPath(...args);
          var FS_unlink = (...args) => FS.unlink(...args);
          var FS_createLazyFile = (...args) => FS.createLazyFile(...args);
          var FS_createDevice = (...args) => FS.createDevice(...args);
          for (var base64ReverseLookup = new Uint8Array(123), i2 = 25; i2 >= 0; --i2) {
            base64ReverseLookup[48 + i2] = 52 + i2;
            base64ReverseLookup[65 + i2] = i2;
            base64ReverseLookup[97 + i2] = 26 + i2;
          }
          base64ReverseLookup[43] = 62;
          base64ReverseLookup[47] = 63;
          FS.createPreloadedFile = FS_createPreloadedFile;
          FS.staticInit();
          {
            if (Module2["print"]) out = Module2["print"];
            if (Module2["printErr"]) err3 = Module2["printErr"];
            checkIncomingModuleAPI();
            assert2(typeof Module2["memoryInitializerPrefixURL"] == "undefined", "Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead");
            assert2(typeof Module2["pthreadMainPrefixURL"] == "undefined", "Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead");
            assert2(typeof Module2["cdInitializerPrefixURL"] == "undefined", "Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead");
            assert2(typeof Module2["filePackagePrefixURL"] == "undefined", "Module.filePackagePrefixURL option was removed, use Module.locateFile instead");
            assert2(typeof Module2["read"] == "undefined", "Module.read option was removed");
            assert2(typeof Module2["readAsync"] == "undefined", "Module.readAsync option was removed (modify readAsync in JS)");
            assert2(typeof Module2["readBinary"] == "undefined", "Module.readBinary option was removed (modify readBinary in JS)");
            assert2(typeof Module2["setWindowTitle"] == "undefined", "Module.setWindowTitle option was removed (modify emscripten_set_window_title in JS)");
            assert2(typeof Module2["TOTAL_MEMORY"] == "undefined", "Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY");
            assert2(typeof Module2["ENVIRONMENT"] == "undefined", "Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -sENVIRONMENT=web or -sENVIRONMENT=node)");
            assert2(typeof Module2["STACK_SIZE"] == "undefined", "STACK_SIZE can no longer be set at runtime.  Use -sSTACK_SIZE at link time");
            assert2(typeof Module2["wasmMemory"] == "undefined", "Use of `wasmMemory` detected.  Use -sIMPORTED_MEMORY to define wasmMemory externally");
            assert2(typeof Module2["INITIAL_MEMORY"] == "undefined", "Detected runtime INITIAL_MEMORY setting.  Use -sIMPORTED_MEMORY to define wasmMemory dynamically");
          }
          Module2["addRunDependency"] = addRunDependency;
          Module2["removeRunDependency"] = removeRunDependency;
          Module2["ccall"] = ccall;
          Module2["cwrap"] = cwrap;
          Module2["FS_createPreloadedFile"] = FS_createPreloadedFile;
          Module2["FS_unlink"] = FS_unlink;
          Module2["FS_createPath"] = FS_createPath;
          Module2["FS_createDevice"] = FS_createDevice;
          Module2["FS_createDataFile"] = FS_createDataFile;
          Module2["FS_createLazyFile"] = FS_createLazyFile;
          var missingLibrarySymbols = ["writeI53ToI64", "writeI53ToI64Clamped", "writeI53ToI64Signaling", "writeI53ToU64Clamped", "writeI53ToU64Signaling", "readI53FromI64", "readI53FromU64", "convertI32PairToI53", "convertI32PairToI53Checked", "convertU32PairToI53", "getTempRet0", "setTempRet0", "zeroMemory", "withStackSave", "inetPton4", "inetNtop4", "inetPton6", "inetNtop6", "readSockaddr", "writeSockaddr", "emscriptenLog", "runMainThreadEmAsm", "jstoi_q", "autoResumeAudioContext", "getDynCaller", "dynCall", "runtimeKeepalivePush", "runtimeKeepalivePop", "asmjsMangle", "HandleAllocator", "getNativeTypeSize", "addOnPreRun", "addOnInit", "addOnPostCtor", "addOnPreMain", "addOnExit", "addOnPostRun", "STACK_SIZE", "STACK_ALIGN", "POINTER_SIZE", "ASSERTIONS", "uleb128Encode", "sigToWasmTypes", "generateFuncType", "convertJsFunctionToWasm", "getEmptyTableSlot", "updateTableMap", "getFunctionAddress", "addFunction", "removeFunction", "reallyNegative", "unSign", "strLen", "reSign", "formatString", "intArrayToString", "AsciiToString", "stringToAscii", "UTF16ToString", "stringToUTF16", "lengthBytesUTF16", "UTF32ToString", "stringToUTF32", "lengthBytesUTF32", "stringToNewUTF8", "registerKeyEventCallback", "maybeCStringToJsString", "findEventTarget", "getBoundingClientRect", "fillMouseEventData", "registerMouseEventCallback", "registerWheelEventCallback", "registerUiEventCallback", "registerFocusEventCallback", "fillDeviceOrientationEventData", "registerDeviceOrientationEventCallback", "fillDeviceMotionEventData", "registerDeviceMotionEventCallback", "screenOrientation", "fillOrientationChangeEventData", "registerOrientationChangeEventCallback", "fillFullscreenChangeEventData", "registerFullscreenChangeEventCallback", "JSEvents_requestFullscreen", "JSEvents_resizeCanvasForFullscreen", "registerRestoreOldStyle", "hideEverythingExceptGivenElement", "restoreHiddenElements", "setLetterbox", "softFullscreenResizeWebGLRenderTarget", "doRequestFullscreen", "fillPointerlockChangeEventData", "registerPointerlockChangeEventCallback", "registerPointerlockErrorEventCallback", "requestPointerLock", "fillVisibilityChangeEventData", "registerVisibilityChangeEventCallback", "registerTouchEventCallback", "fillGamepadEventData", "registerGamepadEventCallback", "registerBeforeUnloadEventCallback", "fillBatteryEventData", "battery", "registerBatteryEventCallback", "setCanvasElementSize", "getCanvasElementSize", "jsStackTrace", "getCallstack", "convertPCtoSourceLocation", "wasiRightsToMuslOFlags", "wasiOFlagsToMuslOFlags", "safeSetTimeout", "setImmediateWrapped", "safeRequestAnimationFrame", "clearImmediateWrapped", "registerPostMainLoop", "registerPreMainLoop", "getPromise", "makePromise", "idsToPromises", "makePromiseCallback", "Browser_asyncPrepareDataCounter", "arraySum", "addDays", "getSocketFromFD", "getSocketAddress", "FS_mkdirTree", "_setNetworkCallback"];
          missingLibrarySymbols.forEach(missingLibrarySymbol);
          var unexportedSymbols = ["run", "out", "err", "callMain", "abort", "wasmMemory", "wasmExports", "HEAPF32", "HEAPF64", "HEAP8", "HEAPU8", "HEAP16", "HEAPU16", "HEAP32", "HEAPU32", "HEAP64", "HEAPU64", "writeStackCookie", "checkStackCookie", "INT53_MAX", "INT53_MIN", "bigintToI53Checked", "stackSave", "stackRestore", "stackAlloc", "ptrToString", "exitJS", "getHeapMax", "growMemory", "ENV", "ERRNO_CODES", "strError", "DNS", "Protocols", "Sockets", "timers", "warnOnce", "readEmAsmArgsArray", "readEmAsmArgs", "runEmAsmFunction", "getExecutableName", "handleException", "keepRuntimeAlive", "callUserCallback", "maybeExit", "asyncLoad", "alignMemory", "mmapAlloc", "wasmTable", "getUniqueRunDependency", "noExitRuntime", "freeTableIndexes", "functionsInTableMap", "setValue", "getValue", "PATH", "PATH_FS", "UTF8Decoder", "UTF8ArrayToString", "UTF8ToString", "stringToUTF8Array", "stringToUTF8", "lengthBytesUTF8", "intArrayFromString", "UTF16Decoder", "stringToUTF8OnStack", "writeArrayToMemory", "JSEvents", "specialHTMLTargets", "findCanvasEventTarget", "currentFullscreenStrategy", "restoreOldWindowedStyle", "UNWIND_CACHE", "ExitStatus", "getEnvStrings", "checkWasiClock", "doReadv", "doWritev", "initRandomFill", "randomFill", "emSetImmediate", "emClearImmediate_deps", "emClearImmediate", "promiseMap", "Browser", "requestFullscreen", "requestFullScreen", "setCanvasSize", "getUserMedia", "createContext", "getPreloadedImageData__data", "wget", "MONTH_DAYS_REGULAR", "MONTH_DAYS_LEAP", "MONTH_DAYS_REGULAR_CUMULATIVE", "MONTH_DAYS_LEAP_CUMULATIVE", "isLeapYear", "ydayFromDate", "base64Decode", "SYSCALLS", "preloadPlugins", "FS_modeStringToFlags", "FS_getMode", "FS_stdin_getChar_buffer", "FS_stdin_getChar", "FS_readFile", "FS", "FS_root", "FS_mounts", "FS_devices", "FS_streams", "FS_nextInode", "FS_nameTable", "FS_currentPath", "FS_initialized", "FS_ignorePermissions", "FS_filesystems", "FS_syncFSRequests", "FS_lookupPath", "FS_getPath", "FS_hashName", "FS_hashAddNode", "FS_hashRemoveNode", "FS_lookupNode", "FS_createNode", "FS_destroyNode", "FS_isRoot", "FS_isMountpoint", "FS_isFile", "FS_isDir", "FS_isLink", "FS_isChrdev", "FS_isBlkdev", "FS_isFIFO", "FS_isSocket", "FS_flagsToPermissionString", "FS_nodePermissions", "FS_mayLookup", "FS_mayCreate", "FS_mayDelete", "FS_mayOpen", "FS_checkOpExists", "FS_nextfd", "FS_getStreamChecked", "FS_getStream", "FS_createStream", "FS_closeStream", "FS_dupStream", "FS_doSetAttr", "FS_chrdev_stream_ops", "FS_major", "FS_minor", "FS_makedev", "FS_registerDevice", "FS_getDevice", "FS_getMounts", "FS_syncfs", "FS_mount", "FS_unmount", "FS_lookup", "FS_mknod", "FS_statfs", "FS_statfsStream", "FS_statfsNode", "FS_create", "FS_mkdir", "FS_mkdev", "FS_symlink", "FS_rename", "FS_rmdir", "FS_readdir", "FS_readlink", "FS_stat", "FS_fstat", "FS_lstat", "FS_doChmod", "FS_chmod", "FS_lchmod", "FS_fchmod", "FS_doChown", "FS_chown", "FS_lchown", "FS_fchown", "FS_doTruncate", "FS_truncate", "FS_ftruncate", "FS_utime", "FS_open", "FS_close", "FS_isClosed", "FS_llseek", "FS_read", "FS_write", "FS_mmap", "FS_msync", "FS_ioctl", "FS_writeFile", "FS_cwd", "FS_chdir", "FS_createDefaultDirectories", "FS_createDefaultDevices", "FS_createSpecialDirectories", "FS_createStandardStreams", "FS_staticInit", "FS_init", "FS_quit", "FS_findObject", "FS_analyzePath", "FS_createFile", "FS_forceLoadFile", "FS_absolutePath", "FS_createFolder", "FS_createLink", "FS_joinPath", "FS_mmapAlloc", "FS_standardizePath", "MEMFS", "TTY", "PIPEFS", "SOCKFS"];
          unexportedSymbols.forEach(unexportedRuntimeSymbol);
          function checkIncomingModuleAPI() {
            ignoredModuleProp("ENVIRONMENT");
            ignoredModuleProp("GL_MAX_TEXTURE_IMAGE_UNITS");
            ignoredModuleProp("SDL_canPlayWithWebAudio");
            ignoredModuleProp("SDL_numSimultaneouslyQueuedBuffers");
            ignoredModuleProp("INITIAL_MEMORY");
            ignoredModuleProp("wasmMemory");
            ignoredModuleProp("arguments");
            ignoredModuleProp("buffer");
            ignoredModuleProp("canvas");
            ignoredModuleProp("doNotCaptureKeyboard");
            ignoredModuleProp("dynamicLibraries");
            ignoredModuleProp("elementPointerLock");
            ignoredModuleProp("extraStackTrace");
            ignoredModuleProp("forcedAspectRatio");
            ignoredModuleProp("instantiateWasm");
            ignoredModuleProp("keyboardListeningElement");
            ignoredModuleProp("freePreloadedMediaOnUse");
            ignoredModuleProp("loadSplitModule");
            ignoredModuleProp("locateFile");
            ignoredModuleProp("logReadFiles");
            ignoredModuleProp("mainScriptUrlOrBlob");
            ignoredModuleProp("mem");
            ignoredModuleProp("monitorRunDependencies");
            ignoredModuleProp("noExitRuntime");
            ignoredModuleProp("noInitialRun");
            ignoredModuleProp("onAbort");
            ignoredModuleProp("onCustomMessage");
            ignoredModuleProp("onExit");
            ignoredModuleProp("onFree");
            ignoredModuleProp("onFullScreen");
            ignoredModuleProp("onMalloc");
            ignoredModuleProp("onRealloc");
            ignoredModuleProp("onRuntimeInitialized");
            ignoredModuleProp("postMainLoop");
            ignoredModuleProp("postRun");
            ignoredModuleProp("preInit");
            ignoredModuleProp("preMainLoop");
            ignoredModuleProp("preRun");
            ignoredModuleProp("preinitializedWebGLContext");
            ignoredModuleProp("preloadPlugins");
            ignoredModuleProp("setStatus");
            ignoredModuleProp("statusMessage");
            ignoredModuleProp("stderr");
            ignoredModuleProp("stdin");
            ignoredModuleProp("stdout");
            ignoredModuleProp("thisProgram");
            ignoredModuleProp("wasm");
            ignoredModuleProp("wasmBinary");
            ignoredModuleProp("websocket");
            ignoredModuleProp("fetchSettings");
          }
          var ASM_CONSTS = { 850252: () => {
            Module2.exec_error();
          }, 850275: () => {
            Module2.onAbort();
          }, 850293: () => {
            Module2.exec_error();
          }, 850316: () => {
            Module2.onAbort();
          }, 850334: () => {
            Module2.exec_error();
          }, 850357: () => {
            Module2.onAbort();
          }, 850374: () => {
            Module2.exec_error();
          }, 850397: () => {
            Module2.onAbort();
          }, 850414: () => {
            Module2.exec_ok();
          }, 850434: () => {
            Module2.exec_error();
          }, 850457: () => {
            Module2.onAbort();
          }, 850474: ($0) => {
            Module2.print(UTF8ToString($0));
          }, 850507: ($0) => {
            Module2.printErr(UTF8ToString($0));
          }, 850543: () => {
            Module2.exec_ok();
          }, 850563: () => {
            Module2.exec_error();
          }, 850586: () => {
            Module2.onAbort();
          }, 850603: ($0) => {
            Module2.printErr(UTF8ToString($0));
          }, 850639: ($0, $1) => {
            Module2.printErr(UTF8ToString($0) + UTF8ToString($1));
          }, 850692: ($0) => {
            Module2.print(UTF8ToString($0));
          }, 850725: ($0) => {
            var nodeRandomBytes = function() {
              return __require("crypto").randomBytes;
            };
            var browserRandomBytes = function(n2) {
              var crypto5 = self.crypto || self.msCrypto;
              var QUOTA = 65536;
              return function(n3) {
                var arr = new Uint8Array(n3);
                for (var i3 = 0; i3 < n3; i3 += QUOTA) {
                  crypto5.getRandomValues(arr.subarray(i3, i3 + Math.min(n3 - i3, QUOTA)));
                }
                return arr;
              };
            };
            var getRandomBytes = (typeof self !== "undefined" && (self.crypto || self.msCrypto) ? browserRandomBytes : nodeRandomBytes)();
            var out2 = _malloc($0);
            writeArrayToMemory(getRandomBytes($0), out2);
            return out2;
          }, 851293: ($0) => {
            console.error(UTF8ToString($0));
          }, 851330: ($0) => {
            console.warn(UTF8ToString($0));
          }, 851366: ($0) => {
            console.log(UTF8ToString($0));
          } };
          var _malloc = Module2["_malloc"] = makeInvalidEarlyAccess("_malloc");
          var _calloc = Module2["_calloc"] = makeInvalidEarlyAccess("_calloc");
          var _free = Module2["_free"] = makeInvalidEarlyAccess("_free");
          var _realloc = Module2["_realloc"] = makeInvalidEarlyAccess("_realloc");
          var _fflush = makeInvalidEarlyAccess("_fflush");
          var _zencode_exec = Module2["_zencode_exec"] = makeInvalidEarlyAccess("_zencode_exec");
          var _zenroom_exec = Module2["_zenroom_exec"] = makeInvalidEarlyAccess("_zenroom_exec");
          var _zencode_valid_input = Module2["_zencode_valid_input"] = makeInvalidEarlyAccess("_zencode_valid_input");
          var _zencode_valid_code = Module2["_zencode_valid_code"] = makeInvalidEarlyAccess("_zencode_valid_code");
          var _zencode_get_statements = Module2["_zencode_get_statements"] = makeInvalidEarlyAccess("_zencode_get_statements");
          var _strerror = makeInvalidEarlyAccess("_strerror");
          var _zenroom_hash_init = Module2["_zenroom_hash_init"] = makeInvalidEarlyAccess("_zenroom_hash_init");
          var _zenroom_hash_update = Module2["_zenroom_hash_update"] = makeInvalidEarlyAccess("_zenroom_hash_update");
          var _zenroom_hash_final = Module2["_zenroom_hash_final"] = makeInvalidEarlyAccess("_zenroom_hash_final");
          var __emscripten_timeout = makeInvalidEarlyAccess("__emscripten_timeout");
          var _setThrew = makeInvalidEarlyAccess("_setThrew");
          var _emscripten_stack_init = makeInvalidEarlyAccess("_emscripten_stack_init");
          var _emscripten_stack_get_free = makeInvalidEarlyAccess("_emscripten_stack_get_free");
          var _emscripten_stack_get_base = makeInvalidEarlyAccess("_emscripten_stack_get_base");
          var _emscripten_stack_get_end = makeInvalidEarlyAccess("_emscripten_stack_get_end");
          var __emscripten_stack_restore = makeInvalidEarlyAccess("__emscripten_stack_restore");
          var __emscripten_stack_alloc = makeInvalidEarlyAccess("__emscripten_stack_alloc");
          var _emscripten_stack_get_current = makeInvalidEarlyAccess("_emscripten_stack_get_current");
          function assignWasmExports(wasmExports2) {
            Module2["_malloc"] = _malloc = createExportWrapper("malloc", 1);
            Module2["_calloc"] = _calloc = createExportWrapper("calloc", 2);
            Module2["_free"] = _free = createExportWrapper("free", 1);
            Module2["_realloc"] = _realloc = createExportWrapper("realloc", 2);
            _fflush = createExportWrapper("fflush", 1);
            Module2["_zencode_exec"] = _zencode_exec = createExportWrapper("zencode_exec", 6);
            Module2["_zenroom_exec"] = _zenroom_exec = createExportWrapper("zenroom_exec", 6);
            Module2["_zencode_valid_input"] = _zencode_valid_input = createExportWrapper("zencode_valid_input", 5);
            Module2["_zencode_valid_code"] = _zencode_valid_code = createExportWrapper("zencode_valid_code", 3);
            Module2["_zencode_get_statements"] = _zencode_get_statements = createExportWrapper("zencode_get_statements", 1);
            _strerror = createExportWrapper("strerror", 1);
            Module2["_zenroom_hash_init"] = _zenroom_hash_init = createExportWrapper("zenroom_hash_init", 1);
            Module2["_zenroom_hash_update"] = _zenroom_hash_update = createExportWrapper("zenroom_hash_update", 3);
            Module2["_zenroom_hash_final"] = _zenroom_hash_final = createExportWrapper("zenroom_hash_final", 1);
            __emscripten_timeout = createExportWrapper("_emscripten_timeout", 2);
            _setThrew = createExportWrapper("setThrew", 2);
            _emscripten_stack_init = wasmExports2["emscripten_stack_init"];
            _emscripten_stack_get_free = wasmExports2["emscripten_stack_get_free"];
            _emscripten_stack_get_base = wasmExports2["emscripten_stack_get_base"];
            _emscripten_stack_get_end = wasmExports2["emscripten_stack_get_end"];
            __emscripten_stack_restore = wasmExports2["_emscripten_stack_restore"];
            __emscripten_stack_alloc = wasmExports2["_emscripten_stack_alloc"];
            _emscripten_stack_get_current = wasmExports2["emscripten_stack_get_current"];
          }
          var wasmImports = { __syscall_dup3: ___syscall_dup3, __syscall_fcntl64: ___syscall_fcntl64, __syscall_ioctl: ___syscall_ioctl, __syscall_openat: ___syscall_openat, _abort_js: __abort_js, _emscripten_fs_load_embedded_files: __emscripten_fs_load_embedded_files, _emscripten_runtime_keepalive_clear: __emscripten_runtime_keepalive_clear, _emscripten_throw_longjmp: __emscripten_throw_longjmp, _gmtime_js: __gmtime_js, _localtime_js: __localtime_js, _mktime_js: __mktime_js, _setitimer_js: __setitimer_js, _tzset_js: __tzset_js, clock_time_get: _clock_time_get, emscripten_asm_const_int: _emscripten_asm_const_int, emscripten_date_now: _emscripten_date_now, emscripten_resize_heap: _emscripten_resize_heap, environ_get: _environ_get, environ_sizes_get: _environ_sizes_get, exit: _exit, fd_close: _fd_close, fd_read: _fd_read, fd_seek: _fd_seek, fd_write: _fd_write, invoke_vii, proc_exit: _proc_exit };
          var wasmExports = await createWasm();
          function invoke_vii(index2, a1, a2) {
            var sp = stackSave();
            try {
              getWasmTableEntry(index2)(a1, a2);
            } catch (e2) {
              stackRestore(sp);
              if (e2 !== e2 + 0) throw e2;
              _setThrew(1, 0);
            }
          }
          var calledRun;
          function stackCheckInit() {
            _emscripten_stack_init();
            writeStackCookie();
          }
          function run() {
            if (runDependencies > 0) {
              dependenciesFulfilled = run;
              return;
            }
            stackCheckInit();
            preRun();
            if (runDependencies > 0) {
              dependenciesFulfilled = run;
              return;
            }
            function doRun() {
              assert2(!calledRun);
              calledRun = true;
              Module2["calledRun"] = true;
              if (ABORT) return;
              initRuntime();
              readyPromiseResolve?.(Module2);
              assert2(!Module2["_main"], 'compiled without a main, but one is present. if you added it from JS, use Module["onRuntimeInitialized"]');
              postRun();
            }
            {
              doRun();
            }
            checkStackCookie();
          }
          function checkUnflushedContent() {
            var oldOut = out;
            var oldErr = err3;
            var has = false;
            out = err3 = (x) => {
              has = true;
            };
            try {
              _fflush(0);
              ["stdout", "stderr"].forEach((name2) => {
                var info2 = FS.analyzePath("/dev/" + name2);
                if (!info2) return;
                var stream = info2.object;
                var rdev = stream.rdev;
                var tty = TTY.ttys[rdev];
                if (tty?.output?.length) {
                  has = true;
                }
              });
            } catch (e2) {
            }
            out = oldOut;
            err3 = oldErr;
            if (has) {
              warnOnce("stdio streams had content in them that was not flushed. you should set EXIT_RUNTIME to 1 (see the Emscripten FAQ), or make sure to emit a newline when you printf etc.");
            }
          }
          function preInit() {
          }
          preInit();
          run();
          if (runtimeInitialized) {
            moduleRtn = Module2;
          } else {
            moduleRtn = new Promise((resolve2, reject) => {
              readyPromiseResolve = resolve2;
              readyPromiseReject = reject;
            });
          }
          for (const prop of Object.keys(Module2)) {
            if (!(prop in moduleArg)) {
              Object.defineProperty(moduleArg, prop, { configurable: true, get() {
                abort(`Access to module property ('${prop}') is no longer possible via the module constructor argument; Instead, use the result of the module constructor.`);
              } });
            }
          }
          return moduleRtn;
        };
      })();
      if (typeof exports2 === "object" && typeof module2 === "object") {
        module2.exports = Module;
        module2.exports.default = Module;
      } else if (typeof define === "function" && define["amd"])
        define([], () => Module);
    }
  });

  // ../../node_modules/.pnpm/cross-fetch@4.0.0_encoding@0.1.13/node_modules/cross-fetch/dist/browser-ponyfill.js
  var require_browser_ponyfill = __commonJS({
    "../../node_modules/.pnpm/cross-fetch@4.0.0_encoding@0.1.13/node_modules/cross-fetch/dist/browser-ponyfill.js"(exports2, module2) {
      var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof global !== "undefined" && global;
      var __globalThis__ = function() {
        function F() {
          this.fetch = false;
          this.DOMException = __global__.DOMException;
        }
        F.prototype = __global__;
        return new F();
      }();
      (function(globalThis2) {
        var irrelevant = function(exports3) {
          var global2 = typeof globalThis2 !== "undefined" && globalThis2 || typeof self !== "undefined" && self || typeof global2 !== "undefined" && global2;
          var support = {
            searchParams: "URLSearchParams" in global2,
            iterable: "Symbol" in global2 && "iterator" in Symbol,
            blob: "FileReader" in global2 && "Blob" in global2 && function() {
              try {
                new Blob();
                return true;
              } catch (e2) {
                return false;
              }
            }(),
            formData: "FormData" in global2,
            arrayBuffer: "ArrayBuffer" in global2
          };
          function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
          }
          if (support.arrayBuffer) {
            var viewClasses = [
              "[object Int8Array]",
              "[object Uint8Array]",
              "[object Uint8ClampedArray]",
              "[object Int16Array]",
              "[object Uint16Array]",
              "[object Int32Array]",
              "[object Uint32Array]",
              "[object Float32Array]",
              "[object Float64Array]"
            ];
            var isArrayBufferView2 = ArrayBuffer.isView || function(obj) {
              return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
          }
          function normalizeName(name2) {
            if (typeof name2 !== "string") {
              name2 = String(name2);
            }
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name2) || name2 === "") {
              throw new TypeError('Invalid character in header field name: "' + name2 + '"');
            }
            return name2.toLowerCase();
          }
          function normalizeValue2(value) {
            if (typeof value !== "string") {
              value = String(value);
            }
            return value;
          }
          function iteratorFor(items) {
            var iterator = {
              next: function() {
                var value = items.shift();
                return { done: value === void 0, value };
              }
            };
            if (support.iterable) {
              iterator[Symbol.iterator] = function() {
                return iterator;
              };
            }
            return iterator;
          }
          function Headers2(headers) {
            this.map = {};
            if (headers instanceof Headers2) {
              headers.forEach(function(value, name2) {
                this.append(name2, value);
              }, this);
            } else if (Array.isArray(headers)) {
              headers.forEach(function(header) {
                this.append(header[0], header[1]);
              }, this);
            } else if (headers) {
              Object.getOwnPropertyNames(headers).forEach(function(name2) {
                this.append(name2, headers[name2]);
              }, this);
            }
          }
          Headers2.prototype.append = function(name2, value) {
            name2 = normalizeName(name2);
            value = normalizeValue2(value);
            var oldValue = this.map[name2];
            this.map[name2] = oldValue ? oldValue + ", " + value : value;
          };
          Headers2.prototype["delete"] = function(name2) {
            delete this.map[normalizeName(name2)];
          };
          Headers2.prototype.get = function(name2) {
            name2 = normalizeName(name2);
            return this.has(name2) ? this.map[name2] : null;
          };
          Headers2.prototype.has = function(name2) {
            return this.map.hasOwnProperty(normalizeName(name2));
          };
          Headers2.prototype.set = function(name2, value) {
            this.map[normalizeName(name2)] = normalizeValue2(value);
          };
          Headers2.prototype.forEach = function(callback, thisArg) {
            for (var name2 in this.map) {
              if (this.map.hasOwnProperty(name2)) {
                callback.call(thisArg, this.map[name2], name2, this);
              }
            }
          };
          Headers2.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name2) {
              items.push(name2);
            });
            return iteratorFor(items);
          };
          Headers2.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
              items.push(value);
            });
            return iteratorFor(items);
          };
          Headers2.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name2) {
              items.push([name2, value]);
            });
            return iteratorFor(items);
          };
          if (support.iterable) {
            Headers2.prototype[Symbol.iterator] = Headers2.prototype.entries;
          }
          function consumed(body) {
            if (body.bodyUsed) {
              return Promise.reject(new TypeError("Already read"));
            }
            body.bodyUsed = true;
          }
          function fileReaderReady(reader) {
            return new Promise(function(resolve2, reject) {
              reader.onload = function() {
                resolve2(reader.result);
              };
              reader.onerror = function() {
                reject(reader.error);
              };
            });
          }
          function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
          }
          function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
          }
          function readArrayBufferAsText(buf) {
            var view2 = new Uint8Array(buf);
            var chars = new Array(view2.length);
            for (var i2 = 0; i2 < view2.length; i2++) {
              chars[i2] = String.fromCharCode(view2[i2]);
            }
            return chars.join("");
          }
          function bufferClone(buf) {
            if (buf.slice) {
              return buf.slice(0);
            } else {
              var view2 = new Uint8Array(buf.byteLength);
              view2.set(new Uint8Array(buf));
              return view2.buffer;
            }
          }
          function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
              this.bodyUsed = this.bodyUsed;
              this._bodyInit = body;
              if (!body) {
                this._bodyText = "";
              } else if (typeof body === "string") {
                this._bodyText = body;
              } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
                this._bodyBlob = body;
              } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
                this._bodyFormData = body;
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this._bodyText = body.toString();
              } else if (support.arrayBuffer && support.blob && isDataView(body)) {
                this._bodyArrayBuffer = bufferClone(body.buffer);
                this._bodyInit = new Blob([this._bodyArrayBuffer]);
              } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView2(body))) {
                this._bodyArrayBuffer = bufferClone(body);
              } else {
                this._bodyText = body = Object.prototype.toString.call(body);
              }
              if (!this.headers.get("content-type")) {
                if (typeof body === "string") {
                  this.headers.set("content-type", "text/plain;charset=UTF-8");
                } else if (this._bodyBlob && this._bodyBlob.type) {
                  this.headers.set("content-type", this._bodyBlob.type);
                } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                  this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
              }
            };
            if (support.blob) {
              this.blob = function() {
                var rejected = consumed(this);
                if (rejected) {
                  return rejected;
                }
                if (this._bodyBlob) {
                  return Promise.resolve(this._bodyBlob);
                } else if (this._bodyArrayBuffer) {
                  return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                } else if (this._bodyFormData) {
                  throw new Error("could not read FormData body as blob");
                } else {
                  return Promise.resolve(new Blob([this._bodyText]));
                }
              };
              this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                  var isConsumed = consumed(this);
                  if (isConsumed) {
                    return isConsumed;
                  }
                  if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
                    return Promise.resolve(
                      this._bodyArrayBuffer.buffer.slice(
                        this._bodyArrayBuffer.byteOffset,
                        this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                      )
                    );
                  } else {
                    return Promise.resolve(this._bodyArrayBuffer);
                  }
                } else {
                  return this.blob().then(readBlobAsArrayBuffer);
                }
              };
            }
            this.text = function() {
              var rejected = consumed(this);
              if (rejected) {
                return rejected;
              }
              if (this._bodyBlob) {
                return readBlobAsText(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
              } else if (this._bodyFormData) {
                throw new Error("could not read FormData body as text");
              } else {
                return Promise.resolve(this._bodyText);
              }
            };
            if (support.formData) {
              this.formData = function() {
                return this.text().then(decode2);
              };
            }
            this.json = function() {
              return this.text().then(JSON.parse);
            };
            return this;
          }
          var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
          function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
          }
          function Request2(input, options) {
            if (!(this instanceof Request2)) {
              throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            }
            options = options || {};
            var body = options.body;
            if (input instanceof Request2) {
              if (input.bodyUsed) {
                throw new TypeError("Already read");
              }
              this.url = input.url;
              this.credentials = input.credentials;
              if (!options.headers) {
                this.headers = new Headers2(input.headers);
              }
              this.method = input.method;
              this.mode = input.mode;
              this.signal = input.signal;
              if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
              }
            } else {
              this.url = String(input);
            }
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) {
              this.headers = new Headers2(options.headers);
            }
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) {
              throw new TypeError("Body not allowed for GET or HEAD requests");
            }
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
              if (options.cache === "no-store" || options.cache === "no-cache") {
                var reParamSearch = /([?&])_=[^&]*/;
                if (reParamSearch.test(this.url)) {
                  this.url = this.url.replace(reParamSearch, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
                } else {
                  var reQueryString = /\?/;
                  this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
                }
              }
            }
          }
          Request2.prototype.clone = function() {
            return new Request2(this, { body: this._bodyInit });
          };
          function decode2(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes2) {
              if (bytes2) {
                var split3 = bytes2.split("=");
                var name2 = split3.shift().replace(/\+/g, " ");
                var value = split3.join("=").replace(/\+/g, " ");
                form.append(decodeURIComponent(name2), decodeURIComponent(value));
              }
            });
            return form;
          }
          function parseHeaders(rawHeaders) {
            var headers = new Headers2();
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split("\r").map(function(header) {
              return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
              var parts = line.split(":");
              var key = parts.shift().trim();
              if (key) {
                var value = parts.join(":").trim();
                headers.append(key, value);
              }
            });
            return headers;
          }
          Body.call(Request2.prototype);
          function Response2(bodyInit, options) {
            if (!(this instanceof Response2)) {
              throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            }
            if (!options) {
              options = {};
            }
            this.type = "default";
            this.status = options.status === void 0 ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === void 0 ? "" : "" + options.statusText;
            this.headers = new Headers2(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
          }
          Body.call(Response2.prototype);
          Response2.prototype.clone = function() {
            return new Response2(this._bodyInit, {
              status: this.status,
              statusText: this.statusText,
              headers: new Headers2(this.headers),
              url: this.url
            });
          };
          Response2.error = function() {
            var response = new Response2(null, { status: 0, statusText: "" });
            response.type = "error";
            return response;
          };
          var redirectStatuses = [301, 302, 303, 307, 308];
          Response2.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) {
              throw new RangeError("Invalid status code");
            }
            return new Response2(null, { status, headers: { location: url } });
          };
          exports3.DOMException = global2.DOMException;
          try {
            new exports3.DOMException();
          } catch (err3) {
            exports3.DOMException = function(message, name2) {
              this.message = message;
              this.name = name2;
              var error = Error(message);
              this.stack = error.stack;
            };
            exports3.DOMException.prototype = Object.create(Error.prototype);
            exports3.DOMException.prototype.constructor = exports3.DOMException;
          }
          function fetch3(input, init3) {
            return new Promise(function(resolve2, reject) {
              var request4 = new Request2(input, init3);
              if (request4.signal && request4.signal.aborted) {
                return reject(new exports3.DOMException("Aborted", "AbortError"));
              }
              var xhr = new XMLHttpRequest();
              function abortXhr() {
                xhr.abort();
              }
              xhr.onload = function() {
                var options = {
                  status: xhr.status,
                  statusText: xhr.statusText,
                  headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                };
                options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                var body = "response" in xhr ? xhr.response : xhr.responseText;
                setTimeout(function() {
                  resolve2(new Response2(body, options));
                }, 0);
              };
              xhr.onerror = function() {
                setTimeout(function() {
                  reject(new TypeError("Network request failed"));
                }, 0);
              };
              xhr.ontimeout = function() {
                setTimeout(function() {
                  reject(new TypeError("Network request failed"));
                }, 0);
              };
              xhr.onabort = function() {
                setTimeout(function() {
                  reject(new exports3.DOMException("Aborted", "AbortError"));
                }, 0);
              };
              function fixUrl(url) {
                try {
                  return url === "" && global2.location.href ? global2.location.href : url;
                } catch (e2) {
                  return url;
                }
              }
              xhr.open(request4.method, fixUrl(request4.url), true);
              if (request4.credentials === "include") {
                xhr.withCredentials = true;
              } else if (request4.credentials === "omit") {
                xhr.withCredentials = false;
              }
              if ("responseType" in xhr) {
                if (support.blob) {
                  xhr.responseType = "blob";
                } else if (support.arrayBuffer && request4.headers.get("Content-Type") && request4.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) {
                  xhr.responseType = "arraybuffer";
                }
              }
              if (init3 && typeof init3.headers === "object" && !(init3.headers instanceof Headers2)) {
                Object.getOwnPropertyNames(init3.headers).forEach(function(name2) {
                  xhr.setRequestHeader(name2, normalizeValue2(init3.headers[name2]));
                });
              } else {
                request4.headers.forEach(function(value, name2) {
                  xhr.setRequestHeader(name2, value);
                });
              }
              if (request4.signal) {
                request4.signal.addEventListener("abort", abortXhr);
                xhr.onreadystatechange = function() {
                  if (xhr.readyState === 4) {
                    request4.signal.removeEventListener("abort", abortXhr);
                  }
                };
              }
              xhr.send(typeof request4._bodyInit === "undefined" ? null : request4._bodyInit);
            });
          }
          fetch3.polyfill = true;
          if (!global2.fetch) {
            global2.fetch = fetch3;
            global2.Headers = Headers2;
            global2.Request = Request2;
            global2.Response = Response2;
          }
          exports3.Headers = Headers2;
          exports3.Request = Request2;
          exports3.Response = Response2;
          exports3.fetch = fetch3;
          return exports3;
        }({});
      })(__globalThis__);
      __globalThis__.fetch.ponyfill = true;
      delete __globalThis__.fetch.polyfill;
      var ctx = __global__.fetch ? __global__ : __globalThis__;
      exports2 = ctx.fetch;
      exports2.default = ctx.fetch;
      exports2.fetch = ctx.fetch;
      exports2.Headers = ctx.Headers;
      exports2.Request = ctx.Request;
      exports2.Response = ctx.Response;
      module2.exports = exports2;
    }
  });

  // ../../node_modules/.pnpm/@ethereumjs+rlp@4.0.1/node_modules/@ethereumjs/rlp/dist/index.js
  var require_dist = __commonJS({
    "../../node_modules/.pnpm/@ethereumjs+rlp@4.0.1/node_modules/@ethereumjs/rlp/dist/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.RLP = exports2.utils = exports2.decode = exports2.encode = void 0;
      function encode4(input) {
        if (Array.isArray(input)) {
          const output3 = [];
          let outputLength = 0;
          for (let i2 = 0; i2 < input.length; i2++) {
            const encoded = encode4(input[i2]);
            output3.push(encoded);
            outputLength += encoded.length;
          }
          return concatBytes3(encodeLength(outputLength, 192), ...output3);
        }
        const inputBuf = toBytes2(input);
        if (inputBuf.length === 1 && inputBuf[0] < 128) {
          return inputBuf;
        }
        return concatBytes3(encodeLength(inputBuf.length, 128), inputBuf);
      }
      exports2.encode = encode4;
      function safeSlice(input, start, end) {
        if (end > input.length) {
          throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
        }
        return input.slice(start, end);
      }
      function decodeLength(v) {
        if (v[0] === 0) {
          throw new Error("invalid RLP: extra zeros");
        }
        return parseHexByte(bytesToHex4(v));
      }
      function encodeLength(len, offset) {
        if (len < 56) {
          return Uint8Array.from([len + offset]);
        }
        const hexLength = numberToHex3(len);
        const lLength = hexLength.length / 2;
        const firstByte = numberToHex3(offset + 55 + lLength);
        return Uint8Array.from(hexToBytes4(firstByte + hexLength));
      }
      function decode2(input, stream = false) {
        if (typeof input === "undefined" || input === null || input.length === 0) {
          return Uint8Array.from([]);
        }
        const inputBytes = toBytes2(input);
        const decoded = _decode(inputBytes);
        if (stream) {
          return decoded;
        }
        if (decoded.remainder.length !== 0) {
          throw new Error("invalid RLP: remainder must be zero");
        }
        return decoded.data;
      }
      exports2.decode = decode2;
      function _decode(input) {
        let length2, llength, data, innerRemainder, d;
        const decoded = [];
        const firstByte = input[0];
        if (firstByte <= 127) {
          return {
            data: input.slice(0, 1),
            remainder: input.slice(1)
          };
        } else if (firstByte <= 183) {
          length2 = firstByte - 127;
          if (firstByte === 128) {
            data = Uint8Array.from([]);
          } else {
            data = safeSlice(input, 1, length2);
          }
          if (length2 === 2 && data[0] < 128) {
            throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
          }
          return {
            data,
            remainder: input.slice(length2)
          };
        } else if (firstByte <= 191) {
          llength = firstByte - 182;
          if (input.length - 1 < llength) {
            throw new Error("invalid RLP: not enough bytes for string length");
          }
          length2 = decodeLength(safeSlice(input, 1, llength));
          if (length2 <= 55) {
            throw new Error("invalid RLP: expected string length to be greater than 55");
          }
          data = safeSlice(input, llength, length2 + llength);
          return {
            data,
            remainder: input.slice(length2 + llength)
          };
        } else if (firstByte <= 247) {
          length2 = firstByte - 191;
          innerRemainder = safeSlice(input, 1, length2);
          while (innerRemainder.length) {
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
          }
          return {
            data: decoded,
            remainder: input.slice(length2)
          };
        } else {
          llength = firstByte - 246;
          length2 = decodeLength(safeSlice(input, 1, llength));
          if (length2 < 56) {
            throw new Error("invalid RLP: encoded list too short");
          }
          const totalLength = llength + length2;
          if (totalLength > input.length) {
            throw new Error("invalid RLP: total length is larger than the data");
          }
          innerRemainder = safeSlice(input, llength, totalLength);
          while (innerRemainder.length) {
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
          }
          return {
            data: decoded,
            remainder: input.slice(totalLength)
          };
        }
      }
      var cachedHexes = Array.from({ length: 256 }, (_v, i2) => i2.toString(16).padStart(2, "0"));
      function bytesToHex4(uint8a) {
        let hex = "";
        for (let i2 = 0; i2 < uint8a.length; i2++) {
          hex += cachedHexes[uint8a[i2]];
        }
        return hex;
      }
      function parseHexByte(hexByte) {
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte))
          throw new Error("Invalid byte sequence");
        return byte;
      }
      function hexToBytes4(hex) {
        if (typeof hex !== "string") {
          throw new TypeError("hexToBytes: expected string, got " + typeof hex);
        }
        if (hex.length % 2)
          throw new Error("hexToBytes: received invalid unpadded hex");
        const array = new Uint8Array(hex.length / 2);
        for (let i2 = 0; i2 < array.length; i2++) {
          const j = i2 * 2;
          array[i2] = parseHexByte(hex.slice(j, j + 2));
        }
        return array;
      }
      function concatBytes3(...arrays) {
        if (arrays.length === 1)
          return arrays[0];
        const length2 = arrays.reduce((a, arr) => a + arr.length, 0);
        const result = new Uint8Array(length2);
        for (let i2 = 0, pad = 0; i2 < arrays.length; i2++) {
          const arr = arrays[i2];
          result.set(arr, pad);
          pad += arr.length;
        }
        return result;
      }
      function utf8ToBytes4(utf) {
        return new TextEncoder().encode(utf);
      }
      function numberToHex3(integer) {
        if (integer < 0) {
          throw new Error("Invalid integer as argument, must be unsigned!");
        }
        const hex = integer.toString(16);
        return hex.length % 2 ? `0${hex}` : hex;
      }
      function padToEven2(a) {
        return a.length % 2 ? `0${a}` : a;
      }
      function isHexPrefixed2(str) {
        return str.length >= 2 && str[0] === "0" && str[1] === "x";
      }
      function stripHexPrefix2(str) {
        if (typeof str !== "string") {
          return str;
        }
        return isHexPrefixed2(str) ? str.slice(2) : str;
      }
      function toBytes2(v) {
        if (v instanceof Uint8Array) {
          return v;
        }
        if (typeof v === "string") {
          if (isHexPrefixed2(v)) {
            return hexToBytes4(padToEven2(stripHexPrefix2(v)));
          }
          return utf8ToBytes4(v);
        }
        if (typeof v === "number" || typeof v === "bigint") {
          if (!v) {
            return Uint8Array.from([]);
          }
          return hexToBytes4(numberToHex3(v));
        }
        if (v === null || v === void 0) {
          return Uint8Array.from([]);
        }
        throw new Error("toBytes: received unsupported type " + typeof v);
      }
      exports2.utils = {
        bytesToHex: bytesToHex4,
        concatBytes: concatBytes3,
        hexToBytes: hexToBytes4,
        utf8ToBytes: utf8ToBytes4
      };
      exports2.RLP = { encode: encode4, decode: decode2 };
    }
  });

  // ../../node_modules/.pnpm/crc-32@1.2.2/node_modules/crc-32/crc32.js
  var require_crc32 = __commonJS({
    "../../node_modules/.pnpm/crc-32@1.2.2/node_modules/crc-32/crc32.js"(exports2) {
      var CRC32;
      (function(factory) {
        if (typeof DO_NOT_EXPORT_CRC === "undefined") {
          if ("object" === typeof exports2) {
            factory(exports2);
          } else if ("function" === typeof define && define.amd) {
            define(function() {
              var module3 = {};
              factory(module3);
              return module3;
            });
          } else {
            factory(CRC32 = {});
          }
        } else {
          factory(CRC32 = {});
        }
      })(function(CRC322) {
        CRC322.version = "1.2.2";
        function signed_crc_table() {
          var c = 0, table = new Array(256);
          for (var n2 = 0; n2 != 256; ++n2) {
            c = n2;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n2] = c;
          }
          return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
        }
        var T02 = signed_crc_table();
        function slice_by_16_tables(T) {
          var c = 0, v = 0, n2 = 0, table = typeof Int32Array !== "undefined" ? new Int32Array(4096) : new Array(4096);
          for (n2 = 0; n2 != 256; ++n2) table[n2] = T[n2];
          for (n2 = 0; n2 != 256; ++n2) {
            v = T[n2];
            for (c = 256 + n2; c < 4096; c += 256) v = table[c] = v >>> 8 ^ T[v & 255];
          }
          var out = [];
          for (n2 = 1; n2 != 16; ++n2) out[n2 - 1] = typeof Int32Array !== "undefined" ? table.subarray(n2 * 256, n2 * 256 + 256) : table.slice(n2 * 256, n2 * 256 + 256);
          return out;
        }
        var TT = slice_by_16_tables(T02);
        var T12 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
        var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
        var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
        function crc32_bstr(bstr, seed) {
          var C = seed ^ -1;
          for (var i2 = 0, L = bstr.length; i2 < L; ) C = C >>> 8 ^ T02[(C ^ bstr.charCodeAt(i2++)) & 255];
          return ~C;
        }
        function crc32_buf(B, seed) {
          var C = seed ^ -1, L = B.length - 15, i2 = 0;
          for (; i2 < L; ) C = Tf[B[i2++] ^ C & 255] ^ Te[B[i2++] ^ C >> 8 & 255] ^ Td[B[i2++] ^ C >> 16 & 255] ^ Tc[B[i2++] ^ C >>> 24] ^ Tb[B[i2++]] ^ Ta[B[i2++]] ^ T9[B[i2++]] ^ T8[B[i2++]] ^ T7[B[i2++]] ^ T6[B[i2++]] ^ T5[B[i2++]] ^ T4[B[i2++]] ^ T3[B[i2++]] ^ T2[B[i2++]] ^ T12[B[i2++]] ^ T02[B[i2++]];
          L += 15;
          while (i2 < L) C = C >>> 8 ^ T02[(C ^ B[i2++]) & 255];
          return ~C;
        }
        function crc32_str(str, seed) {
          var C = seed ^ -1;
          for (var i2 = 0, L = str.length, c = 0, d = 0; i2 < L; ) {
            c = str.charCodeAt(i2++);
            if (c < 128) {
              C = C >>> 8 ^ T02[(C ^ c) & 255];
            } else if (c < 2048) {
              C = C >>> 8 ^ T02[(C ^ (192 | c >> 6 & 31)) & 255];
              C = C >>> 8 ^ T02[(C ^ (128 | c & 63)) & 255];
            } else if (c >= 55296 && c < 57344) {
              c = (c & 1023) + 64;
              d = str.charCodeAt(i2++) & 1023;
              C = C >>> 8 ^ T02[(C ^ (240 | c >> 8 & 7)) & 255];
              C = C >>> 8 ^ T02[(C ^ (128 | c >> 2 & 63)) & 255];
              C = C >>> 8 ^ T02[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 255];
              C = C >>> 8 ^ T02[(C ^ (128 | d & 63)) & 255];
            } else {
              C = C >>> 8 ^ T02[(C ^ (224 | c >> 12 & 15)) & 255];
              C = C >>> 8 ^ T02[(C ^ (128 | c >> 6 & 63)) & 255];
              C = C >>> 8 ^ T02[(C ^ (128 | c & 63)) & 255];
            }
          }
          return ~C;
        }
        CRC322.table = T02;
        CRC322.bstr = crc32_bstr;
        CRC322.buf = crc32_buf;
        CRC322.str = crc32_str;
      });
    }
  });

  // ../../node_modules/.pnpm/setimmediate@1.0.5/node_modules/setimmediate/setImmediate.js
  var require_setImmediate = __commonJS({
    "../../node_modules/.pnpm/setimmediate@1.0.5/node_modules/setimmediate/setImmediate.js"(exports2) {
      (function(global2, undefined2) {
        "use strict";
        if (global2.setImmediate) {
          return;
        }
        var nextHandle = 1;
        var tasksByHandle = {};
        var currentlyRunningATask = false;
        var doc = global2.document;
        var registerImmediate;
        function setImmediate2(callback) {
          if (typeof callback !== "function") {
            callback = new Function("" + callback);
          }
          var args = new Array(arguments.length - 1);
          for (var i2 = 0; i2 < args.length; i2++) {
            args[i2] = arguments[i2 + 1];
          }
          var task = { callback, args };
          tasksByHandle[nextHandle] = task;
          registerImmediate(nextHandle);
          return nextHandle++;
        }
        function clearImmediate(handle) {
          delete tasksByHandle[handle];
        }
        function run(task) {
          var callback = task.callback;
          var args = task.args;
          switch (args.length) {
            case 0:
              callback();
              break;
            case 1:
              callback(args[0]);
              break;
            case 2:
              callback(args[0], args[1]);
              break;
            case 3:
              callback(args[0], args[1], args[2]);
              break;
            default:
              callback.apply(undefined2, args);
              break;
          }
        }
        function runIfPresent(handle) {
          if (currentlyRunningATask) {
            setTimeout(runIfPresent, 0, handle);
          } else {
            var task = tasksByHandle[handle];
            if (task) {
              currentlyRunningATask = true;
              try {
                run(task);
              } finally {
                clearImmediate(handle);
                currentlyRunningATask = false;
              }
            }
          }
        }
        function installNextTickImplementation() {
          registerImmediate = function(handle) {
            process.nextTick(function() {
              runIfPresent(handle);
            });
          };
        }
        function canUsePostMessage() {
          if (global2.postMessage && !global2.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global2.onmessage;
            global2.onmessage = function() {
              postMessageIsAsynchronous = false;
            };
            global2.postMessage("", "*");
            global2.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
          }
        }
        function installPostMessageImplementation() {
          var messagePrefix = "setImmediate$" + Math.random() + "$";
          var onGlobalMessage = function(event) {
            if (event.source === global2 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
              runIfPresent(+event.data.slice(messagePrefix.length));
            }
          };
          if (global2.addEventListener) {
            global2.addEventListener("message", onGlobalMessage, false);
          } else {
            global2.attachEvent("onmessage", onGlobalMessage);
          }
          registerImmediate = function(handle) {
            global2.postMessage(messagePrefix + handle, "*");
          };
        }
        function installMessageChannelImplementation() {
          var channel = new MessageChannel();
          channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
          };
          registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
          };
        }
        function installReadyStateChangeImplementation() {
          var html = doc.documentElement;
          registerImmediate = function(handle) {
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
              runIfPresent(handle);
              script.onreadystatechange = null;
              html.removeChild(script);
              script = null;
            };
            html.appendChild(script);
          };
        }
        function installSetTimeoutImplementation() {
          registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
          };
        }
        var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global2);
        attachTo = attachTo && attachTo.setTimeout ? attachTo : global2;
        if ({}.toString.call(global2.process) === "[object process]") {
          installNextTickImplementation();
        } else if (canUsePostMessage()) {
          installPostMessageImplementation();
        } else if (global2.MessageChannel) {
          installMessageChannelImplementation();
        } else if (doc && "onreadystatechange" in doc.createElement("script")) {
          installReadyStateChangeImplementation();
        } else {
          installSetTimeoutImplementation();
        }
        attachTo.setImmediate = setImmediate2;
        attachTo.clearImmediate = clearImmediate;
      })(typeof self === "undefined" ? typeof global === "undefined" ? exports2 : global : self);
    }
  });

  // ../../node_modules/.pnpm/path-browserify@1.0.1/node_modules/path-browserify/index.js
  var require_path_browserify = __commonJS({
    "../../node_modules/.pnpm/path-browserify@1.0.1/node_modules/path-browserify/index.js"(exports2, module2) {
      "use strict";
      function assertPath(path3) {
        if (typeof path3 !== "string") {
          throw new TypeError("Path must be a string. Received " + JSON.stringify(path3));
        }
      }
      function normalizeStringPosix(path3, allowAboveRoot) {
        var res = "";
        var lastSegmentLength = 0;
        var lastSlash = -1;
        var dots = 0;
        var code;
        for (var i2 = 0; i2 <= path3.length; ++i2) {
          if (i2 < path3.length)
            code = path3.charCodeAt(i2);
          else if (code === 47)
            break;
          else
            code = 47;
          if (code === 47) {
            if (lastSlash === i2 - 1 || dots === 1) {
            } else if (lastSlash !== i2 - 1 && dots === 2) {
              if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                if (res.length > 2) {
                  var lastSlashIndex = res.lastIndexOf("/");
                  if (lastSlashIndex !== res.length - 1) {
                    if (lastSlashIndex === -1) {
                      res = "";
                      lastSegmentLength = 0;
                    } else {
                      res = res.slice(0, lastSlashIndex);
                      lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                    }
                    lastSlash = i2;
                    dots = 0;
                    continue;
                  }
                } else if (res.length === 2 || res.length === 1) {
                  res = "";
                  lastSegmentLength = 0;
                  lastSlash = i2;
                  dots = 0;
                  continue;
                }
              }
              if (allowAboveRoot) {
                if (res.length > 0)
                  res += "/..";
                else
                  res = "..";
                lastSegmentLength = 2;
              }
            } else {
              if (res.length > 0)
                res += "/" + path3.slice(lastSlash + 1, i2);
              else
                res = path3.slice(lastSlash + 1, i2);
              lastSegmentLength = i2 - lastSlash - 1;
            }
            lastSlash = i2;
            dots = 0;
          } else if (code === 46 && dots !== -1) {
            ++dots;
          } else {
            dots = -1;
          }
        }
        return res;
      }
      function _format2(sep2, pathObject) {
        var dir = pathObject.dir || pathObject.root;
        var base2 = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
        if (!dir) {
          return base2;
        }
        if (dir === pathObject.root) {
          return dir + base2;
        }
        return dir + sep2 + base2;
      }
      var posix = {
        // path.resolve([from ...], to)
        resolve: function resolve2() {
          var resolvedPath = "";
          var resolvedAbsolute = false;
          var cwd;
          for (var i2 = arguments.length - 1; i2 >= -1 && !resolvedAbsolute; i2--) {
            var path3;
            if (i2 >= 0)
              path3 = arguments[i2];
            else {
              if (cwd === void 0)
                cwd = process.cwd();
              path3 = cwd;
            }
            assertPath(path3);
            if (path3.length === 0) {
              continue;
            }
            resolvedPath = path3 + "/" + resolvedPath;
            resolvedAbsolute = path3.charCodeAt(0) === 47;
          }
          resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);
          if (resolvedAbsolute) {
            if (resolvedPath.length > 0)
              return "/" + resolvedPath;
            else
              return "/";
          } else if (resolvedPath.length > 0) {
            return resolvedPath;
          } else {
            return ".";
          }
        },
        normalize: function normalize5(path3) {
          assertPath(path3);
          if (path3.length === 0) return ".";
          var isAbsolute2 = path3.charCodeAt(0) === 47;
          var trailingSeparator = path3.charCodeAt(path3.length - 1) === 47;
          path3 = normalizeStringPosix(path3, !isAbsolute2);
          if (path3.length === 0 && !isAbsolute2) path3 = ".";
          if (path3.length > 0 && trailingSeparator) path3 += "/";
          if (isAbsolute2) return "/" + path3;
          return path3;
        },
        isAbsolute: function isAbsolute2(path3) {
          assertPath(path3);
          return path3.length > 0 && path3.charCodeAt(0) === 47;
        },
        join: function join3() {
          if (arguments.length === 0)
            return ".";
          var joined;
          for (var i2 = 0; i2 < arguments.length; ++i2) {
            var arg = arguments[i2];
            assertPath(arg);
            if (arg.length > 0) {
              if (joined === void 0)
                joined = arg;
              else
                joined += "/" + arg;
            }
          }
          if (joined === void 0)
            return ".";
          return posix.normalize(joined);
        },
        relative: function relative2(from, to) {
          assertPath(from);
          assertPath(to);
          if (from === to) return "";
          from = posix.resolve(from);
          to = posix.resolve(to);
          if (from === to) return "";
          var fromStart = 1;
          for (; fromStart < from.length; ++fromStart) {
            if (from.charCodeAt(fromStart) !== 47)
              break;
          }
          var fromEnd = from.length;
          var fromLen = fromEnd - fromStart;
          var toStart = 1;
          for (; toStart < to.length; ++toStart) {
            if (to.charCodeAt(toStart) !== 47)
              break;
          }
          var toEnd = to.length;
          var toLen = toEnd - toStart;
          var length2 = fromLen < toLen ? fromLen : toLen;
          var lastCommonSep = -1;
          var i2 = 0;
          for (; i2 <= length2; ++i2) {
            if (i2 === length2) {
              if (toLen > length2) {
                if (to.charCodeAt(toStart + i2) === 47) {
                  return to.slice(toStart + i2 + 1);
                } else if (i2 === 0) {
                  return to.slice(toStart + i2);
                }
              } else if (fromLen > length2) {
                if (from.charCodeAt(fromStart + i2) === 47) {
                  lastCommonSep = i2;
                } else if (i2 === 0) {
                  lastCommonSep = 0;
                }
              }
              break;
            }
            var fromCode = from.charCodeAt(fromStart + i2);
            var toCode = to.charCodeAt(toStart + i2);
            if (fromCode !== toCode)
              break;
            else if (fromCode === 47)
              lastCommonSep = i2;
          }
          var out = "";
          for (i2 = fromStart + lastCommonSep + 1; i2 <= fromEnd; ++i2) {
            if (i2 === fromEnd || from.charCodeAt(i2) === 47) {
              if (out.length === 0)
                out += "..";
              else
                out += "/..";
            }
          }
          if (out.length > 0)
            return out + to.slice(toStart + lastCommonSep);
          else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47)
              ++toStart;
            return to.slice(toStart);
          }
        },
        _makeLong: function _makeLong(path3) {
          return path3;
        },
        dirname: function dirname3(path3) {
          assertPath(path3);
          if (path3.length === 0) return ".";
          var code = path3.charCodeAt(0);
          var hasRoot = code === 47;
          var end = -1;
          var matchedSlash = true;
          for (var i2 = path3.length - 1; i2 >= 1; --i2) {
            code = path3.charCodeAt(i2);
            if (code === 47) {
              if (!matchedSlash) {
                end = i2;
                break;
              }
            } else {
              matchedSlash = false;
            }
          }
          if (end === -1) return hasRoot ? "/" : ".";
          if (hasRoot && end === 1) return "//";
          return path3.slice(0, end);
        },
        basename: function basename2(path3, ext) {
          if (ext !== void 0 && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
          assertPath(path3);
          var start = 0;
          var end = -1;
          var matchedSlash = true;
          var i2;
          if (ext !== void 0 && ext.length > 0 && ext.length <= path3.length) {
            if (ext.length === path3.length && ext === path3) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for (i2 = path3.length - 1; i2 >= 0; --i2) {
              var code = path3.charCodeAt(i2);
              if (code === 47) {
                if (!matchedSlash) {
                  start = i2 + 1;
                  break;
                }
              } else {
                if (firstNonSlashEnd === -1) {
                  matchedSlash = false;
                  firstNonSlashEnd = i2 + 1;
                }
                if (extIdx >= 0) {
                  if (code === ext.charCodeAt(extIdx)) {
                    if (--extIdx === -1) {
                      end = i2;
                    }
                  } else {
                    extIdx = -1;
                    end = firstNonSlashEnd;
                  }
                }
              }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path3.length;
            return path3.slice(start, end);
          } else {
            for (i2 = path3.length - 1; i2 >= 0; --i2) {
              if (path3.charCodeAt(i2) === 47) {
                if (!matchedSlash) {
                  start = i2 + 1;
                  break;
                }
              } else if (end === -1) {
                matchedSlash = false;
                end = i2 + 1;
              }
            }
            if (end === -1) return "";
            return path3.slice(start, end);
          }
        },
        extname: function extname2(path3) {
          assertPath(path3);
          var startDot = -1;
          var startPart = 0;
          var end = -1;
          var matchedSlash = true;
          var preDotState = 0;
          for (var i2 = path3.length - 1; i2 >= 0; --i2) {
            var code = path3.charCodeAt(i2);
            if (code === 47) {
              if (!matchedSlash) {
                startPart = i2 + 1;
                break;
              }
              continue;
            }
            if (end === -1) {
              matchedSlash = false;
              end = i2 + 1;
            }
            if (code === 46) {
              if (startDot === -1)
                startDot = i2;
              else if (preDotState !== 1)
                preDotState = 1;
            } else if (startDot !== -1) {
              preDotState = -1;
            }
          }
          if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
          preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
          preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            return "";
          }
          return path3.slice(startDot, end);
        },
        format: function format5(pathObject) {
          if (pathObject === null || typeof pathObject !== "object") {
            throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
          }
          return _format2("/", pathObject);
        },
        parse: function parse4(path3) {
          assertPath(path3);
          var ret = { root: "", dir: "", base: "", ext: "", name: "" };
          if (path3.length === 0) return ret;
          var code = path3.charCodeAt(0);
          var isAbsolute2 = code === 47;
          var start;
          if (isAbsolute2) {
            ret.root = "/";
            start = 1;
          } else {
            start = 0;
          }
          var startDot = -1;
          var startPart = 0;
          var end = -1;
          var matchedSlash = true;
          var i2 = path3.length - 1;
          var preDotState = 0;
          for (; i2 >= start; --i2) {
            code = path3.charCodeAt(i2);
            if (code === 47) {
              if (!matchedSlash) {
                startPart = i2 + 1;
                break;
              }
              continue;
            }
            if (end === -1) {
              matchedSlash = false;
              end = i2 + 1;
            }
            if (code === 46) {
              if (startDot === -1) startDot = i2;
              else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) {
              preDotState = -1;
            }
          }
          if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
          preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
          preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
              if (startPart === 0 && isAbsolute2) ret.base = ret.name = path3.slice(1, end);
              else ret.base = ret.name = path3.slice(startPart, end);
            }
          } else {
            if (startPart === 0 && isAbsolute2) {
              ret.name = path3.slice(1, startDot);
              ret.base = path3.slice(1, end);
            } else {
              ret.name = path3.slice(startPart, startDot);
              ret.base = path3.slice(startPart, end);
            }
            ret.ext = path3.slice(startDot, end);
          }
          if (startPart > 0) ret.dir = path3.slice(0, startPart - 1);
          else if (isAbsolute2) ret.dir = "/";
          return ret;
        },
        sep: "/",
        delimiter: ":",
        win32: null,
        posix: null
      };
      posix.posix = posix;
      module2.exports = posix;
    }
  });

  // ../../node_modules/.pnpm/async-lock@1.4.1/node_modules/async-lock/lib/index.js
  var require_lib = __commonJS({
    "../../node_modules/.pnpm/async-lock@1.4.1/node_modules/async-lock/lib/index.js"(exports2, module2) {
      "use strict";
      var AsyncLock = function(opts) {
        opts = opts || {};
        this.Promise = opts.Promise || Promise;
        this.queues = /* @__PURE__ */ Object.create(null);
        this.domainReentrant = opts.domainReentrant || false;
        if (this.domainReentrant) {
          if (typeof process === "undefined" || typeof process.domain === "undefined") {
            throw new Error(
              "Domain-reentrant locks require `process.domain` to exist. Please flip `opts.domainReentrant = false`, use a NodeJS version that still implements Domain, or install a browser polyfill."
            );
          }
          this.domains = /* @__PURE__ */ Object.create(null);
        }
        this.timeout = opts.timeout || AsyncLock.DEFAULT_TIMEOUT;
        this.maxOccupationTime = opts.maxOccupationTime || AsyncLock.DEFAULT_MAX_OCCUPATION_TIME;
        this.maxExecutionTime = opts.maxExecutionTime || AsyncLock.DEFAULT_MAX_EXECUTION_TIME;
        if (opts.maxPending === Infinity || Number.isInteger(opts.maxPending) && opts.maxPending >= 0) {
          this.maxPending = opts.maxPending;
        } else {
          this.maxPending = AsyncLock.DEFAULT_MAX_PENDING;
        }
      };
      AsyncLock.DEFAULT_TIMEOUT = 0;
      AsyncLock.DEFAULT_MAX_OCCUPATION_TIME = 0;
      AsyncLock.DEFAULT_MAX_EXECUTION_TIME = 0;
      AsyncLock.DEFAULT_MAX_PENDING = 1e3;
      AsyncLock.prototype.acquire = function(key, fn, cb, opts) {
        if (Array.isArray(key)) {
          return this._acquireBatch(key, fn, cb, opts);
        }
        if (typeof fn !== "function") {
          throw new Error("You must pass a function to execute");
        }
        var deferredResolve = null;
        var deferredReject = null;
        var deferred = null;
        if (typeof cb !== "function") {
          opts = cb;
          cb = null;
          deferred = new this.Promise(function(resolve2, reject) {
            deferredResolve = resolve2;
            deferredReject = reject;
          });
        }
        opts = opts || {};
        var resolved = false;
        var timer = null;
        var occupationTimer = null;
        var executionTimer = null;
        var self2 = this;
        var done = function(locked, err3, ret) {
          if (occupationTimer) {
            clearTimeout(occupationTimer);
            occupationTimer = null;
          }
          if (executionTimer) {
            clearTimeout(executionTimer);
            executionTimer = null;
          }
          if (locked) {
            if (!!self2.queues[key] && self2.queues[key].length === 0) {
              delete self2.queues[key];
            }
            if (self2.domainReentrant) {
              delete self2.domains[key];
            }
          }
          if (!resolved) {
            if (!deferred) {
              if (typeof cb === "function") {
                cb(err3, ret);
              }
            } else {
              if (err3) {
                deferredReject(err3);
              } else {
                deferredResolve(ret);
              }
            }
            resolved = true;
          }
          if (locked) {
            if (!!self2.queues[key] && self2.queues[key].length > 0) {
              self2.queues[key].shift()();
            }
          }
        };
        var exec2 = function(locked) {
          if (resolved) {
            return done(locked);
          }
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }
          if (self2.domainReentrant && locked) {
            self2.domains[key] = process.domain;
          }
          var maxExecutionTime = opts.maxExecutionTime || self2.maxExecutionTime;
          if (maxExecutionTime) {
            executionTimer = setTimeout(function() {
              if (!!self2.queues[key]) {
                done(locked, new Error("Maximum execution time is exceeded " + key));
              }
            }, maxExecutionTime);
          }
          if (fn.length === 1) {
            var called = false;
            try {
              fn(function(err3, ret) {
                if (!called) {
                  called = true;
                  done(locked, err3, ret);
                }
              });
            } catch (err3) {
              if (!called) {
                called = true;
                done(locked, err3);
              }
            }
          } else {
            self2._promiseTry(function() {
              return fn();
            }).then(function(ret) {
              done(locked, void 0, ret);
            }, function(error) {
              done(locked, error);
            });
          }
        };
        if (self2.domainReentrant && !!process.domain) {
          exec2 = process.domain.bind(exec2);
        }
        var maxPending = opts.maxPending || self2.maxPending;
        if (!self2.queues[key]) {
          self2.queues[key] = [];
          exec2(true);
        } else if (self2.domainReentrant && !!process.domain && process.domain === self2.domains[key]) {
          exec2(false);
        } else if (self2.queues[key].length >= maxPending) {
          done(false, new Error("Too many pending tasks in queue " + key));
        } else {
          var taskFn = function() {
            exec2(true);
          };
          if (opts.skipQueue) {
            self2.queues[key].unshift(taskFn);
          } else {
            self2.queues[key].push(taskFn);
          }
          var timeout = opts.timeout || self2.timeout;
          if (timeout) {
            timer = setTimeout(function() {
              timer = null;
              done(false, new Error("async-lock timed out in queue " + key));
            }, timeout);
          }
        }
        var maxOccupationTime = opts.maxOccupationTime || self2.maxOccupationTime;
        if (maxOccupationTime) {
          occupationTimer = setTimeout(function() {
            if (!!self2.queues[key]) {
              done(false, new Error("Maximum occupation time is exceeded in queue " + key));
            }
          }, maxOccupationTime);
        }
        if (deferred) {
          return deferred;
        }
      };
      AsyncLock.prototype._acquireBatch = function(keys, fn, cb, opts) {
        if (typeof cb !== "function") {
          opts = cb;
          cb = null;
        }
        var self2 = this;
        var getFn = function(key, fn2) {
          return function(cb2) {
            self2.acquire(key, fn2, cb2, opts);
          };
        };
        var fnx = keys.reduceRight(function(prev, key) {
          return getFn(key, prev);
        }, fn);
        if (typeof cb === "function") {
          fnx(cb);
        } else {
          return new this.Promise(function(resolve2, reject) {
            if (fnx.length === 1) {
              fnx(function(err3, ret) {
                if (err3) {
                  reject(err3);
                } else {
                  resolve2(ret);
                }
              });
            } else {
              resolve2(fnx());
            }
          });
        }
      };
      AsyncLock.prototype.isBusy = function(key) {
        if (!key) {
          return Object.keys(this.queues).length > 0;
        } else {
          return !!this.queues[key];
        }
      };
      AsyncLock.prototype._promiseTry = function(fn) {
        try {
          return this.Promise.resolve(fn());
        } catch (e2) {
          return this.Promise.reject(e2);
        }
      };
      module2.exports = AsyncLock;
    }
  });

  // ../../node_modules/.pnpm/async-lock@1.4.1/node_modules/async-lock/index.js
  var require_async_lock = __commonJS({
    "../../node_modules/.pnpm/async-lock@1.4.1/node_modules/async-lock/index.js"(exports2, module2) {
      "use strict";
      module2.exports = require_lib();
    }
  });

  // ../../node_modules/.pnpm/inherits@2.0.4/node_modules/inherits/inherits_browser.js
  var require_inherits_browser = __commonJS({
    "../../node_modules/.pnpm/inherits@2.0.4/node_modules/inherits/inherits_browser.js"(exports2, module2) {
      if (typeof Object.create === "function") {
        module2.exports = function inherits2(ctor, superCtor) {
          if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
              constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
              }
            });
          }
        };
      } else {
        module2.exports = function inherits2(ctor, superCtor) {
          if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {
            };
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
          }
        };
      }
    }
  });

  // ../../node_modules/.pnpm/sha.js@2.4.11/node_modules/sha.js/hash.js
  var require_hash = __commonJS({
    "../../node_modules/.pnpm/sha.js@2.4.11/node_modules/sha.js/hash.js"(exports2, module2) {
      var Buffer7 = require_safe_buffer().Buffer;
      function Hash2(blockSize, finalSize) {
        this._block = Buffer7.alloc(blockSize);
        this._finalSize = finalSize;
        this._blockSize = blockSize;
        this._len = 0;
      }
      Hash2.prototype.update = function(data, enc) {
        if (typeof data === "string") {
          enc = enc || "utf8";
          data = Buffer7.from(data, enc);
        }
        var block = this._block;
        var blockSize = this._blockSize;
        var length2 = data.length;
        var accum = this._len;
        for (var offset = 0; offset < length2; ) {
          var assigned = accum % blockSize;
          var remainder = Math.min(length2 - offset, blockSize - assigned);
          for (var i2 = 0; i2 < remainder; i2++) {
            block[assigned + i2] = data[offset + i2];
          }
          accum += remainder;
          offset += remainder;
          if (accum % blockSize === 0) {
            this._update(block);
          }
        }
        this._len += length2;
        return this;
      };
      Hash2.prototype.digest = function(enc) {
        var rem = this._len % this._blockSize;
        this._block[rem] = 128;
        this._block.fill(0, rem + 1);
        if (rem >= this._finalSize) {
          this._update(this._block);
          this._block.fill(0);
        }
        var bits2 = this._len * 8;
        if (bits2 <= 4294967295) {
          this._block.writeUInt32BE(bits2, this._blockSize - 4);
        } else {
          var lowBits = (bits2 & 4294967295) >>> 0;
          var highBits = (bits2 - lowBits) / 4294967296;
          this._block.writeUInt32BE(highBits, this._blockSize - 8);
          this._block.writeUInt32BE(lowBits, this._blockSize - 4);
        }
        this._update(this._block);
        var hash2 = this._hash();
        return enc ? hash2.toString(enc) : hash2;
      };
      Hash2.prototype._update = function() {
        throw new Error("_update must be implemented by subclass");
      };
      module2.exports = Hash2;
    }
  });

  // ../../node_modules/.pnpm/sha.js@2.4.11/node_modules/sha.js/sha1.js
  var require_sha1 = __commonJS({
    "../../node_modules/.pnpm/sha.js@2.4.11/node_modules/sha.js/sha1.js"(exports2, module2) {
      var inherits2 = require_inherits_browser();
      var Hash2 = require_hash();
      var Buffer7 = require_safe_buffer().Buffer;
      var K = [
        1518500249,
        1859775393,
        2400959708 | 0,
        3395469782 | 0
      ];
      var W = new Array(80);
      function Sha1() {
        this.init();
        this._w = W;
        Hash2.call(this, 64, 56);
      }
      inherits2(Sha1, Hash2);
      Sha1.prototype.init = function() {
        this._a = 1732584193;
        this._b = 4023233417;
        this._c = 2562383102;
        this._d = 271733878;
        this._e = 3285377520;
        return this;
      };
      function rotl1(num) {
        return num << 1 | num >>> 31;
      }
      function rotl5(num) {
        return num << 5 | num >>> 27;
      }
      function rotl30(num) {
        return num << 30 | num >>> 2;
      }
      function ft(s2, b, c, d) {
        if (s2 === 0) return b & c | ~b & d;
        if (s2 === 2) return b & c | b & d | c & d;
        return b ^ c ^ d;
      }
      Sha1.prototype._update = function(M) {
        var W2 = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e2 = this._e | 0;
        for (var i2 = 0; i2 < 16; ++i2) W2[i2] = M.readInt32BE(i2 * 4);
        for (; i2 < 80; ++i2) W2[i2] = rotl1(W2[i2 - 3] ^ W2[i2 - 8] ^ W2[i2 - 14] ^ W2[i2 - 16]);
        for (var j = 0; j < 80; ++j) {
          var s2 = ~~(j / 20);
          var t2 = rotl5(a) + ft(s2, b, c, d) + e2 + W2[j] + K[s2] | 0;
          e2 = d;
          d = c;
          c = rotl30(b);
          b = a;
          a = t2;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e2 + this._e | 0;
      };
      Sha1.prototype._hash = function() {
        var H = Buffer7.allocUnsafe(20);
        H.writeInt32BE(this._a | 0, 0);
        H.writeInt32BE(this._b | 0, 4);
        H.writeInt32BE(this._c | 0, 8);
        H.writeInt32BE(this._d | 0, 12);
        H.writeInt32BE(this._e | 0, 16);
        return H;
      };
      module2.exports = Sha1;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/utils/common.js
  var require_common = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/utils/common.js"(exports2) {
      "use strict";
      var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
      function _has(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
      exports2.assign = function(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while (sources.length) {
          var source = sources.shift();
          if (!source) {
            continue;
          }
          if (typeof source !== "object") {
            throw new TypeError(source + "must be non-object");
          }
          for (var p12 in source) {
            if (_has(source, p12)) {
              obj[p12] = source[p12];
            }
          }
        }
        return obj;
      };
      exports2.shrinkBuf = function(buf, size) {
        if (buf.length === size) {
          return buf;
        }
        if (buf.subarray) {
          return buf.subarray(0, size);
        }
        buf.length = size;
        return buf;
      };
      var fnTyped = {
        arraySet: function(dest, src, src_offs, len, dest_offs) {
          if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
          }
          for (var i2 = 0; i2 < len; i2++) {
            dest[dest_offs + i2] = src[src_offs + i2];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function(chunks) {
          var i2, l, len, pos, chunk, result;
          len = 0;
          for (i2 = 0, l = chunks.length; i2 < l; i2++) {
            len += chunks[i2].length;
          }
          result = new Uint8Array(len);
          pos = 0;
          for (i2 = 0, l = chunks.length; i2 < l; i2++) {
            chunk = chunks[i2];
            result.set(chunk, pos);
            pos += chunk.length;
          }
          return result;
        }
      };
      var fnUntyped = {
        arraySet: function(dest, src, src_offs, len, dest_offs) {
          for (var i2 = 0; i2 < len; i2++) {
            dest[dest_offs + i2] = src[src_offs + i2];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function(chunks) {
          return [].concat.apply([], chunks);
        }
      };
      exports2.setTyped = function(on) {
        if (on) {
          exports2.Buf8 = Uint8Array;
          exports2.Buf16 = Uint16Array;
          exports2.Buf32 = Int32Array;
          exports2.assign(exports2, fnTyped);
        } else {
          exports2.Buf8 = Array;
          exports2.Buf16 = Array;
          exports2.Buf32 = Array;
          exports2.assign(exports2, fnUntyped);
        }
      };
      exports2.setTyped(TYPED_OK);
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/trees.js
  var require_trees = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/trees.js"(exports2) {
      "use strict";
      var utils = require_common();
      var Z_FIXED = 4;
      var Z_BINARY = 0;
      var Z_TEXT = 1;
      var Z_UNKNOWN = 2;
      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }
      var STORED_BLOCK = 0;
      var STATIC_TREES = 1;
      var DYN_TREES = 2;
      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      var LENGTH_CODES = 29;
      var LITERALS = 256;
      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      var D_CODES = 30;
      var BL_CODES = 19;
      var HEAP_SIZE = 2 * L_CODES + 1;
      var MAX_BITS = 15;
      var Buf_size = 16;
      var MAX_BL_BITS = 7;
      var END_BLOCK = 256;
      var REP_3_6 = 16;
      var REPZ_3_10 = 17;
      var REPZ_11_138 = 18;
      var extra_lbits = (
        /* extra bits for each length code */
        [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
      );
      var extra_dbits = (
        /* extra bits for each distance code */
        [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
      );
      var extra_blbits = (
        /* extra bits for each bit length code */
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
      );
      var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      var DIST_CODE_LEN = 512;
      var static_ltree = new Array((L_CODES + 2) * 2);
      zero(static_ltree);
      var static_dtree = new Array(D_CODES * 2);
      zero(static_dtree);
      var _dist_code = new Array(DIST_CODE_LEN);
      zero(_dist_code);
      var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
      zero(_length_code);
      var base_length = new Array(LENGTH_CODES);
      zero(base_length);
      var base_dist = new Array(D_CODES);
      zero(base_dist);
      function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
        this.static_tree = static_tree;
        this.extra_bits = extra_bits;
        this.extra_base = extra_base;
        this.elems = elems;
        this.max_length = max_length;
        this.has_stree = static_tree && static_tree.length;
      }
      var static_l_desc;
      var static_d_desc;
      var static_bl_desc;
      function TreeDesc(dyn_tree, stat_desc) {
        this.dyn_tree = dyn_tree;
        this.max_code = 0;
        this.stat_desc = stat_desc;
      }
      function d_code(dist) {
        return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
      }
      function put_short(s2, w) {
        s2.pending_buf[s2.pending++] = w & 255;
        s2.pending_buf[s2.pending++] = w >>> 8 & 255;
      }
      function send_bits(s2, value, length2) {
        if (s2.bi_valid > Buf_size - length2) {
          s2.bi_buf |= value << s2.bi_valid & 65535;
          put_short(s2, s2.bi_buf);
          s2.bi_buf = value >> Buf_size - s2.bi_valid;
          s2.bi_valid += length2 - Buf_size;
        } else {
          s2.bi_buf |= value << s2.bi_valid & 65535;
          s2.bi_valid += length2;
        }
      }
      function send_code(s2, c, tree) {
        send_bits(
          s2,
          tree[c * 2],
          tree[c * 2 + 1]
          /*.Len*/
        );
      }
      function bi_reverse(code, len) {
        var res = 0;
        do {
          res |= code & 1;
          code >>>= 1;
          res <<= 1;
        } while (--len > 0);
        return res >>> 1;
      }
      function bi_flush(s2) {
        if (s2.bi_valid === 16) {
          put_short(s2, s2.bi_buf);
          s2.bi_buf = 0;
          s2.bi_valid = 0;
        } else if (s2.bi_valid >= 8) {
          s2.pending_buf[s2.pending++] = s2.bi_buf & 255;
          s2.bi_buf >>= 8;
          s2.bi_valid -= 8;
        }
      }
      function gen_bitlen(s2, desc) {
        var tree = desc.dyn_tree;
        var max_code = desc.max_code;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var extra = desc.stat_desc.extra_bits;
        var base2 = desc.stat_desc.extra_base;
        var max_length = desc.stat_desc.max_length;
        var h;
        var n2, m;
        var bits2;
        var xbits;
        var f;
        var overflow = 0;
        for (bits2 = 0; bits2 <= MAX_BITS; bits2++) {
          s2.bl_count[bits2] = 0;
        }
        tree[s2.heap[s2.heap_max] * 2 + 1] = 0;
        for (h = s2.heap_max + 1; h < HEAP_SIZE; h++) {
          n2 = s2.heap[h];
          bits2 = tree[tree[n2 * 2 + 1] * 2 + 1] + 1;
          if (bits2 > max_length) {
            bits2 = max_length;
            overflow++;
          }
          tree[n2 * 2 + 1] = bits2;
          if (n2 > max_code) {
            continue;
          }
          s2.bl_count[bits2]++;
          xbits = 0;
          if (n2 >= base2) {
            xbits = extra[n2 - base2];
          }
          f = tree[n2 * 2];
          s2.opt_len += f * (bits2 + xbits);
          if (has_stree) {
            s2.static_len += f * (stree[n2 * 2 + 1] + xbits);
          }
        }
        if (overflow === 0) {
          return;
        }
        do {
          bits2 = max_length - 1;
          while (s2.bl_count[bits2] === 0) {
            bits2--;
          }
          s2.bl_count[bits2]--;
          s2.bl_count[bits2 + 1] += 2;
          s2.bl_count[max_length]--;
          overflow -= 2;
        } while (overflow > 0);
        for (bits2 = max_length; bits2 !== 0; bits2--) {
          n2 = s2.bl_count[bits2];
          while (n2 !== 0) {
            m = s2.heap[--h];
            if (m > max_code) {
              continue;
            }
            if (tree[m * 2 + 1] !== bits2) {
              s2.opt_len += (bits2 - tree[m * 2 + 1]) * tree[m * 2];
              tree[m * 2 + 1] = bits2;
            }
            n2--;
          }
        }
      }
      function gen_codes(tree, max_code, bl_count) {
        var next_code = new Array(MAX_BITS + 1);
        var code = 0;
        var bits2;
        var n2;
        for (bits2 = 1; bits2 <= MAX_BITS; bits2++) {
          next_code[bits2] = code = code + bl_count[bits2 - 1] << 1;
        }
        for (n2 = 0; n2 <= max_code; n2++) {
          var len = tree[n2 * 2 + 1];
          if (len === 0) {
            continue;
          }
          tree[n2 * 2] = bi_reverse(next_code[len]++, len);
        }
      }
      function tr_static_init() {
        var n2;
        var bits2;
        var length2;
        var code;
        var dist;
        var bl_count = new Array(MAX_BITS + 1);
        length2 = 0;
        for (code = 0; code < LENGTH_CODES - 1; code++) {
          base_length[code] = length2;
          for (n2 = 0; n2 < 1 << extra_lbits[code]; n2++) {
            _length_code[length2++] = code;
          }
        }
        _length_code[length2 - 1] = code;
        dist = 0;
        for (code = 0; code < 16; code++) {
          base_dist[code] = dist;
          for (n2 = 0; n2 < 1 << extra_dbits[code]; n2++) {
            _dist_code[dist++] = code;
          }
        }
        dist >>= 7;
        for (; code < D_CODES; code++) {
          base_dist[code] = dist << 7;
          for (n2 = 0; n2 < 1 << extra_dbits[code] - 7; n2++) {
            _dist_code[256 + dist++] = code;
          }
        }
        for (bits2 = 0; bits2 <= MAX_BITS; bits2++) {
          bl_count[bits2] = 0;
        }
        n2 = 0;
        while (n2 <= 143) {
          static_ltree[n2 * 2 + 1] = 8;
          n2++;
          bl_count[8]++;
        }
        while (n2 <= 255) {
          static_ltree[n2 * 2 + 1] = 9;
          n2++;
          bl_count[9]++;
        }
        while (n2 <= 279) {
          static_ltree[n2 * 2 + 1] = 7;
          n2++;
          bl_count[7]++;
        }
        while (n2 <= 287) {
          static_ltree[n2 * 2 + 1] = 8;
          n2++;
          bl_count[8]++;
        }
        gen_codes(static_ltree, L_CODES + 1, bl_count);
        for (n2 = 0; n2 < D_CODES; n2++) {
          static_dtree[n2 * 2 + 1] = 5;
          static_dtree[n2 * 2] = bi_reverse(n2, 5);
        }
        static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
        static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
        static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
      }
      function init_block(s2) {
        var n2;
        for (n2 = 0; n2 < L_CODES; n2++) {
          s2.dyn_ltree[n2 * 2] = 0;
        }
        for (n2 = 0; n2 < D_CODES; n2++) {
          s2.dyn_dtree[n2 * 2] = 0;
        }
        for (n2 = 0; n2 < BL_CODES; n2++) {
          s2.bl_tree[n2 * 2] = 0;
        }
        s2.dyn_ltree[END_BLOCK * 2] = 1;
        s2.opt_len = s2.static_len = 0;
        s2.last_lit = s2.matches = 0;
      }
      function bi_windup(s2) {
        if (s2.bi_valid > 8) {
          put_short(s2, s2.bi_buf);
        } else if (s2.bi_valid > 0) {
          s2.pending_buf[s2.pending++] = s2.bi_buf;
        }
        s2.bi_buf = 0;
        s2.bi_valid = 0;
      }
      function copy_block(s2, buf, len, header) {
        bi_windup(s2);
        if (header) {
          put_short(s2, len);
          put_short(s2, ~len);
        }
        utils.arraySet(s2.pending_buf, s2.window, buf, len, s2.pending);
        s2.pending += len;
      }
      function smaller(tree, n2, m, depth) {
        var _n2 = n2 * 2;
        var _m2 = m * 2;
        return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n2] <= depth[m];
      }
      function pqdownheap(s2, tree, k) {
        var v = s2.heap[k];
        var j = k << 1;
        while (j <= s2.heap_len) {
          if (j < s2.heap_len && smaller(tree, s2.heap[j + 1], s2.heap[j], s2.depth)) {
            j++;
          }
          if (smaller(tree, v, s2.heap[j], s2.depth)) {
            break;
          }
          s2.heap[k] = s2.heap[j];
          k = j;
          j <<= 1;
        }
        s2.heap[k] = v;
      }
      function compress_block(s2, ltree, dtree) {
        var dist;
        var lc;
        var lx = 0;
        var code;
        var extra;
        if (s2.last_lit !== 0) {
          do {
            dist = s2.pending_buf[s2.d_buf + lx * 2] << 8 | s2.pending_buf[s2.d_buf + lx * 2 + 1];
            lc = s2.pending_buf[s2.l_buf + lx];
            lx++;
            if (dist === 0) {
              send_code(s2, lc, ltree);
            } else {
              code = _length_code[lc];
              send_code(s2, code + LITERALS + 1, ltree);
              extra = extra_lbits[code];
              if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s2, lc, extra);
              }
              dist--;
              code = d_code(dist);
              send_code(s2, code, dtree);
              extra = extra_dbits[code];
              if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s2, dist, extra);
              }
            }
          } while (lx < s2.last_lit);
        }
        send_code(s2, END_BLOCK, ltree);
      }
      function build_tree(s2, desc) {
        var tree = desc.dyn_tree;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var elems = desc.stat_desc.elems;
        var n2, m;
        var max_code = -1;
        var node;
        s2.heap_len = 0;
        s2.heap_max = HEAP_SIZE;
        for (n2 = 0; n2 < elems; n2++) {
          if (tree[n2 * 2] !== 0) {
            s2.heap[++s2.heap_len] = max_code = n2;
            s2.depth[n2] = 0;
          } else {
            tree[n2 * 2 + 1] = 0;
          }
        }
        while (s2.heap_len < 2) {
          node = s2.heap[++s2.heap_len] = max_code < 2 ? ++max_code : 0;
          tree[node * 2] = 1;
          s2.depth[node] = 0;
          s2.opt_len--;
          if (has_stree) {
            s2.static_len -= stree[node * 2 + 1];
          }
        }
        desc.max_code = max_code;
        for (n2 = s2.heap_len >> 1; n2 >= 1; n2--) {
          pqdownheap(s2, tree, n2);
        }
        node = elems;
        do {
          n2 = s2.heap[
            1
            /*SMALLEST*/
          ];
          s2.heap[
            1
            /*SMALLEST*/
          ] = s2.heap[s2.heap_len--];
          pqdownheap(
            s2,
            tree,
            1
            /*SMALLEST*/
          );
          m = s2.heap[
            1
            /*SMALLEST*/
          ];
          s2.heap[--s2.heap_max] = n2;
          s2.heap[--s2.heap_max] = m;
          tree[node * 2] = tree[n2 * 2] + tree[m * 2];
          s2.depth[node] = (s2.depth[n2] >= s2.depth[m] ? s2.depth[n2] : s2.depth[m]) + 1;
          tree[n2 * 2 + 1] = tree[m * 2 + 1] = node;
          s2.heap[
            1
            /*SMALLEST*/
          ] = node++;
          pqdownheap(
            s2,
            tree,
            1
            /*SMALLEST*/
          );
        } while (s2.heap_len >= 2);
        s2.heap[--s2.heap_max] = s2.heap[
          1
          /*SMALLEST*/
        ];
        gen_bitlen(s2, desc);
        gen_codes(tree, max_code, s2.bl_count);
      }
      function scan_tree(s2, tree, max_code) {
        var n2;
        var prevlen = -1;
        var curlen;
        var nextlen = tree[0 * 2 + 1];
        var count = 0;
        var max_count = 7;
        var min_count = 4;
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        tree[(max_code + 1) * 2 + 1] = 65535;
        for (n2 = 0; n2 <= max_code; n2++) {
          curlen = nextlen;
          nextlen = tree[(n2 + 1) * 2 + 1];
          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            s2.bl_tree[curlen * 2] += count;
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              s2.bl_tree[curlen * 2]++;
            }
            s2.bl_tree[REP_3_6 * 2]++;
          } else if (count <= 10) {
            s2.bl_tree[REPZ_3_10 * 2]++;
          } else {
            s2.bl_tree[REPZ_11_138 * 2]++;
          }
          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }
      function send_tree(s2, tree, max_code) {
        var n2;
        var prevlen = -1;
        var curlen;
        var nextlen = tree[0 * 2 + 1];
        var count = 0;
        var max_count = 7;
        var min_count = 4;
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        for (n2 = 0; n2 <= max_code; n2++) {
          curlen = nextlen;
          nextlen = tree[(n2 + 1) * 2 + 1];
          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            do {
              send_code(s2, curlen, s2.bl_tree);
            } while (--count !== 0);
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              send_code(s2, curlen, s2.bl_tree);
              count--;
            }
            send_code(s2, REP_3_6, s2.bl_tree);
            send_bits(s2, count - 3, 2);
          } else if (count <= 10) {
            send_code(s2, REPZ_3_10, s2.bl_tree);
            send_bits(s2, count - 3, 3);
          } else {
            send_code(s2, REPZ_11_138, s2.bl_tree);
            send_bits(s2, count - 11, 7);
          }
          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }
      function build_bl_tree(s2) {
        var max_blindex;
        scan_tree(s2, s2.dyn_ltree, s2.l_desc.max_code);
        scan_tree(s2, s2.dyn_dtree, s2.d_desc.max_code);
        build_tree(s2, s2.bl_desc);
        for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
          if (s2.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) {
            break;
          }
        }
        s2.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
        return max_blindex;
      }
      function send_all_trees(s2, lcodes, dcodes, blcodes) {
        var rank;
        send_bits(s2, lcodes - 257, 5);
        send_bits(s2, dcodes - 1, 5);
        send_bits(s2, blcodes - 4, 4);
        for (rank = 0; rank < blcodes; rank++) {
          send_bits(s2, s2.bl_tree[bl_order[rank] * 2 + 1], 3);
        }
        send_tree(s2, s2.dyn_ltree, lcodes - 1);
        send_tree(s2, s2.dyn_dtree, dcodes - 1);
      }
      function detect_data_type(s2) {
        var black_mask = 4093624447;
        var n2;
        for (n2 = 0; n2 <= 31; n2++, black_mask >>>= 1) {
          if (black_mask & 1 && s2.dyn_ltree[n2 * 2] !== 0) {
            return Z_BINARY;
          }
        }
        if (s2.dyn_ltree[9 * 2] !== 0 || s2.dyn_ltree[10 * 2] !== 0 || s2.dyn_ltree[13 * 2] !== 0) {
          return Z_TEXT;
        }
        for (n2 = 32; n2 < LITERALS; n2++) {
          if (s2.dyn_ltree[n2 * 2] !== 0) {
            return Z_TEXT;
          }
        }
        return Z_BINARY;
      }
      var static_init_done = false;
      function _tr_init(s2) {
        if (!static_init_done) {
          tr_static_init();
          static_init_done = true;
        }
        s2.l_desc = new TreeDesc(s2.dyn_ltree, static_l_desc);
        s2.d_desc = new TreeDesc(s2.dyn_dtree, static_d_desc);
        s2.bl_desc = new TreeDesc(s2.bl_tree, static_bl_desc);
        s2.bi_buf = 0;
        s2.bi_valid = 0;
        init_block(s2);
      }
      function _tr_stored_block(s2, buf, stored_len, last) {
        send_bits(s2, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
        copy_block(s2, buf, stored_len, true);
      }
      function _tr_align(s2) {
        send_bits(s2, STATIC_TREES << 1, 3);
        send_code(s2, END_BLOCK, static_ltree);
        bi_flush(s2);
      }
      function _tr_flush_block(s2, buf, stored_len, last) {
        var opt_lenb, static_lenb;
        var max_blindex = 0;
        if (s2.level > 0) {
          if (s2.strm.data_type === Z_UNKNOWN) {
            s2.strm.data_type = detect_data_type(s2);
          }
          build_tree(s2, s2.l_desc);
          build_tree(s2, s2.d_desc);
          max_blindex = build_bl_tree(s2);
          opt_lenb = s2.opt_len + 3 + 7 >>> 3;
          static_lenb = s2.static_len + 3 + 7 >>> 3;
          if (static_lenb <= opt_lenb) {
            opt_lenb = static_lenb;
          }
        } else {
          opt_lenb = static_lenb = stored_len + 5;
        }
        if (stored_len + 4 <= opt_lenb && buf !== -1) {
          _tr_stored_block(s2, buf, stored_len, last);
        } else if (s2.strategy === Z_FIXED || static_lenb === opt_lenb) {
          send_bits(s2, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
          compress_block(s2, static_ltree, static_dtree);
        } else {
          send_bits(s2, (DYN_TREES << 1) + (last ? 1 : 0), 3);
          send_all_trees(s2, s2.l_desc.max_code + 1, s2.d_desc.max_code + 1, max_blindex + 1);
          compress_block(s2, s2.dyn_ltree, s2.dyn_dtree);
        }
        init_block(s2);
        if (last) {
          bi_windup(s2);
        }
      }
      function _tr_tally(s2, dist, lc) {
        s2.pending_buf[s2.d_buf + s2.last_lit * 2] = dist >>> 8 & 255;
        s2.pending_buf[s2.d_buf + s2.last_lit * 2 + 1] = dist & 255;
        s2.pending_buf[s2.l_buf + s2.last_lit] = lc & 255;
        s2.last_lit++;
        if (dist === 0) {
          s2.dyn_ltree[lc * 2]++;
        } else {
          s2.matches++;
          dist--;
          s2.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
          s2.dyn_dtree[d_code(dist) * 2]++;
        }
        return s2.last_lit === s2.lit_bufsize - 1;
      }
      exports2._tr_init = _tr_init;
      exports2._tr_stored_block = _tr_stored_block;
      exports2._tr_flush_block = _tr_flush_block;
      exports2._tr_tally = _tr_tally;
      exports2._tr_align = _tr_align;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/adler32.js
  var require_adler32 = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/adler32.js"(exports2, module2) {
      "use strict";
      function adler32(adler, buf, len, pos) {
        var s1 = adler & 65535 | 0, s2 = adler >>> 16 & 65535 | 0, n2 = 0;
        while (len !== 0) {
          n2 = len > 2e3 ? 2e3 : len;
          len -= n2;
          do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
          } while (--n2);
          s1 %= 65521;
          s2 %= 65521;
        }
        return s1 | s2 << 16 | 0;
      }
      module2.exports = adler32;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/crc32.js
  var require_crc322 = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/crc32.js"(exports2, module2) {
      "use strict";
      function makeTable() {
        var c, table = [];
        for (var n2 = 0; n2 < 256; n2++) {
          c = n2;
          for (var k = 0; k < 8; k++) {
            c = c & 1 ? 3988292384 ^ c >>> 1 : c >>> 1;
          }
          table[n2] = c;
        }
        return table;
      }
      var crcTable = makeTable();
      function crc32(crc, buf, len, pos) {
        var t2 = crcTable, end = pos + len;
        crc ^= -1;
        for (var i2 = pos; i2 < end; i2++) {
          crc = crc >>> 8 ^ t2[(crc ^ buf[i2]) & 255];
        }
        return crc ^ -1;
      }
      module2.exports = crc32;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/messages.js
  var require_messages = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/messages.js"(exports2, module2) {
      "use strict";
      module2.exports = {
        2: "need dictionary",
        /* Z_NEED_DICT       2  */
        1: "stream end",
        /* Z_STREAM_END      1  */
        0: "",
        /* Z_OK              0  */
        "-1": "file error",
        /* Z_ERRNO         (-1) */
        "-2": "stream error",
        /* Z_STREAM_ERROR  (-2) */
        "-3": "data error",
        /* Z_DATA_ERROR    (-3) */
        "-4": "insufficient memory",
        /* Z_MEM_ERROR     (-4) */
        "-5": "buffer error",
        /* Z_BUF_ERROR     (-5) */
        "-6": "incompatible version"
        /* Z_VERSION_ERROR (-6) */
      };
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/deflate.js
  var require_deflate = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/deflate.js"(exports2) {
      "use strict";
      var utils = require_common();
      var trees = require_trees();
      var adler32 = require_adler32();
      var crc32 = require_crc322();
      var msg = require_messages();
      var Z_NO_FLUSH = 0;
      var Z_PARTIAL_FLUSH = 1;
      var Z_FULL_FLUSH = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      var Z_BUF_ERROR = -5;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_FILTERED = 1;
      var Z_HUFFMAN_ONLY = 2;
      var Z_RLE = 3;
      var Z_FIXED = 4;
      var Z_DEFAULT_STRATEGY = 0;
      var Z_UNKNOWN = 2;
      var Z_DEFLATED = 8;
      var MAX_MEM_LEVEL = 9;
      var MAX_WBITS = 15;
      var DEF_MEM_LEVEL = 8;
      var LENGTH_CODES = 29;
      var LITERALS = 256;
      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      var D_CODES = 30;
      var BL_CODES = 19;
      var HEAP_SIZE = 2 * L_CODES + 1;
      var MAX_BITS = 15;
      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
      var PRESET_DICT = 32;
      var INIT_STATE = 42;
      var EXTRA_STATE = 69;
      var NAME_STATE = 73;
      var COMMENT_STATE = 91;
      var HCRC_STATE = 103;
      var BUSY_STATE = 113;
      var FINISH_STATE = 666;
      var BS_NEED_MORE = 1;
      var BS_BLOCK_DONE = 2;
      var BS_FINISH_STARTED = 3;
      var BS_FINISH_DONE = 4;
      var OS_CODE = 3;
      function err3(strm, errorCode) {
        strm.msg = msg[errorCode];
        return errorCode;
      }
      function rank(f) {
        return (f << 1) - (f > 4 ? 9 : 0);
      }
      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }
      function flush_pending(strm) {
        var s2 = strm.state;
        var len = s2.pending;
        if (len > strm.avail_out) {
          len = strm.avail_out;
        }
        if (len === 0) {
          return;
        }
        utils.arraySet(strm.output, s2.pending_buf, s2.pending_out, len, strm.next_out);
        strm.next_out += len;
        s2.pending_out += len;
        strm.total_out += len;
        strm.avail_out -= len;
        s2.pending -= len;
        if (s2.pending === 0) {
          s2.pending_out = 0;
        }
      }
      function flush_block_only(s2, last) {
        trees._tr_flush_block(s2, s2.block_start >= 0 ? s2.block_start : -1, s2.strstart - s2.block_start, last);
        s2.block_start = s2.strstart;
        flush_pending(s2.strm);
      }
      function put_byte(s2, b) {
        s2.pending_buf[s2.pending++] = b;
      }
      function putShortMSB(s2, b) {
        s2.pending_buf[s2.pending++] = b >>> 8 & 255;
        s2.pending_buf[s2.pending++] = b & 255;
      }
      function read_buf(strm, buf, start, size) {
        var len = strm.avail_in;
        if (len > size) {
          len = size;
        }
        if (len === 0) {
          return 0;
        }
        strm.avail_in -= len;
        utils.arraySet(buf, strm.input, strm.next_in, len, start);
        if (strm.state.wrap === 1) {
          strm.adler = adler32(strm.adler, buf, len, start);
        } else if (strm.state.wrap === 2) {
          strm.adler = crc32(strm.adler, buf, len, start);
        }
        strm.next_in += len;
        strm.total_in += len;
        return len;
      }
      function longest_match(s2, cur_match) {
        var chain_length = s2.max_chain_length;
        var scan = s2.strstart;
        var match;
        var len;
        var best_len = s2.prev_length;
        var nice_match = s2.nice_match;
        var limit = s2.strstart > s2.w_size - MIN_LOOKAHEAD ? s2.strstart - (s2.w_size - MIN_LOOKAHEAD) : 0;
        var _win = s2.window;
        var wmask = s2.w_mask;
        var prev = s2.prev;
        var strend = s2.strstart + MAX_MATCH;
        var scan_end1 = _win[scan + best_len - 1];
        var scan_end = _win[scan + best_len];
        if (s2.prev_length >= s2.good_match) {
          chain_length >>= 2;
        }
        if (nice_match > s2.lookahead) {
          nice_match = s2.lookahead;
        }
        do {
          match = cur_match;
          if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
            continue;
          }
          scan += 2;
          match++;
          do {
          } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
          len = MAX_MATCH - (strend - scan);
          scan = strend - MAX_MATCH;
          if (len > best_len) {
            s2.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) {
              break;
            }
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
          }
        } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
        if (best_len <= s2.lookahead) {
          return best_len;
        }
        return s2.lookahead;
      }
      function fill_window(s2) {
        var _w_size = s2.w_size;
        var p12, n2, m, more, str;
        do {
          more = s2.window_size - s2.lookahead - s2.strstart;
          if (s2.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s2.window, s2.window, _w_size, _w_size, 0);
            s2.match_start -= _w_size;
            s2.strstart -= _w_size;
            s2.block_start -= _w_size;
            n2 = s2.hash_size;
            p12 = n2;
            do {
              m = s2.head[--p12];
              s2.head[p12] = m >= _w_size ? m - _w_size : 0;
            } while (--n2);
            n2 = _w_size;
            p12 = n2;
            do {
              m = s2.prev[--p12];
              s2.prev[p12] = m >= _w_size ? m - _w_size : 0;
            } while (--n2);
            more += _w_size;
          }
          if (s2.strm.avail_in === 0) {
            break;
          }
          n2 = read_buf(s2.strm, s2.window, s2.strstart + s2.lookahead, more);
          s2.lookahead += n2;
          if (s2.lookahead + s2.insert >= MIN_MATCH) {
            str = s2.strstart - s2.insert;
            s2.ins_h = s2.window[str];
            s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[str + 1]) & s2.hash_mask;
            while (s2.insert) {
              s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[str + MIN_MATCH - 1]) & s2.hash_mask;
              s2.prev[str & s2.w_mask] = s2.head[s2.ins_h];
              s2.head[s2.ins_h] = str;
              str++;
              s2.insert--;
              if (s2.lookahead + s2.insert < MIN_MATCH) {
                break;
              }
            }
          }
        } while (s2.lookahead < MIN_LOOKAHEAD && s2.strm.avail_in !== 0);
      }
      function deflate_stored(s2, flush) {
        var max_block_size = 65535;
        if (max_block_size > s2.pending_buf_size - 5) {
          max_block_size = s2.pending_buf_size - 5;
        }
        for (; ; ) {
          if (s2.lookahead <= 1) {
            fill_window(s2);
            if (s2.lookahead === 0 && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s2.lookahead === 0) {
              break;
            }
          }
          s2.strstart += s2.lookahead;
          s2.lookahead = 0;
          var max_start = s2.block_start + max_block_size;
          if (s2.strstart === 0 || s2.strstart >= max_start) {
            s2.lookahead = s2.strstart - max_start;
            s2.strstart = max_start;
            flush_block_only(s2, false);
            if (s2.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          }
          if (s2.strstart - s2.block_start >= s2.w_size - MIN_LOOKAHEAD) {
            flush_block_only(s2, false);
            if (s2.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          }
        }
        s2.insert = 0;
        if (flush === Z_FINISH) {
          flush_block_only(s2, true);
          if (s2.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          return BS_FINISH_DONE;
        }
        if (s2.strstart > s2.block_start) {
          flush_block_only(s2, false);
          if (s2.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        }
        return BS_NEED_MORE;
      }
      function deflate_fast(s2, flush) {
        var hash_head;
        var bflush;
        for (; ; ) {
          if (s2.lookahead < MIN_LOOKAHEAD) {
            fill_window(s2);
            if (s2.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s2.lookahead === 0) {
              break;
            }
          }
          hash_head = 0;
          if (s2.lookahead >= MIN_MATCH) {
            s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[s2.strstart + MIN_MATCH - 1]) & s2.hash_mask;
            hash_head = s2.prev[s2.strstart & s2.w_mask] = s2.head[s2.ins_h];
            s2.head[s2.ins_h] = s2.strstart;
          }
          if (hash_head !== 0 && s2.strstart - hash_head <= s2.w_size - MIN_LOOKAHEAD) {
            s2.match_length = longest_match(s2, hash_head);
          }
          if (s2.match_length >= MIN_MATCH) {
            bflush = trees._tr_tally(s2, s2.strstart - s2.match_start, s2.match_length - MIN_MATCH);
            s2.lookahead -= s2.match_length;
            if (s2.match_length <= s2.max_lazy_match && s2.lookahead >= MIN_MATCH) {
              s2.match_length--;
              do {
                s2.strstart++;
                s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[s2.strstart + MIN_MATCH - 1]) & s2.hash_mask;
                hash_head = s2.prev[s2.strstart & s2.w_mask] = s2.head[s2.ins_h];
                s2.head[s2.ins_h] = s2.strstart;
              } while (--s2.match_length !== 0);
              s2.strstart++;
            } else {
              s2.strstart += s2.match_length;
              s2.match_length = 0;
              s2.ins_h = s2.window[s2.strstart];
              s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[s2.strstart + 1]) & s2.hash_mask;
            }
          } else {
            bflush = trees._tr_tally(s2, 0, s2.window[s2.strstart]);
            s2.lookahead--;
            s2.strstart++;
          }
          if (bflush) {
            flush_block_only(s2, false);
            if (s2.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          }
        }
        s2.insert = s2.strstart < MIN_MATCH - 1 ? s2.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          flush_block_only(s2, true);
          if (s2.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          return BS_FINISH_DONE;
        }
        if (s2.last_lit) {
          flush_block_only(s2, false);
          if (s2.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        }
        return BS_BLOCK_DONE;
      }
      function deflate_slow(s2, flush) {
        var hash_head;
        var bflush;
        var max_insert;
        for (; ; ) {
          if (s2.lookahead < MIN_LOOKAHEAD) {
            fill_window(s2);
            if (s2.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s2.lookahead === 0) {
              break;
            }
          }
          hash_head = 0;
          if (s2.lookahead >= MIN_MATCH) {
            s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[s2.strstart + MIN_MATCH - 1]) & s2.hash_mask;
            hash_head = s2.prev[s2.strstart & s2.w_mask] = s2.head[s2.ins_h];
            s2.head[s2.ins_h] = s2.strstart;
          }
          s2.prev_length = s2.match_length;
          s2.prev_match = s2.match_start;
          s2.match_length = MIN_MATCH - 1;
          if (hash_head !== 0 && s2.prev_length < s2.max_lazy_match && s2.strstart - hash_head <= s2.w_size - MIN_LOOKAHEAD) {
            s2.match_length = longest_match(s2, hash_head);
            if (s2.match_length <= 5 && (s2.strategy === Z_FILTERED || s2.match_length === MIN_MATCH && s2.strstart - s2.match_start > 4096)) {
              s2.match_length = MIN_MATCH - 1;
            }
          }
          if (s2.prev_length >= MIN_MATCH && s2.match_length <= s2.prev_length) {
            max_insert = s2.strstart + s2.lookahead - MIN_MATCH;
            bflush = trees._tr_tally(s2, s2.strstart - 1 - s2.prev_match, s2.prev_length - MIN_MATCH);
            s2.lookahead -= s2.prev_length - 1;
            s2.prev_length -= 2;
            do {
              if (++s2.strstart <= max_insert) {
                s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[s2.strstart + MIN_MATCH - 1]) & s2.hash_mask;
                hash_head = s2.prev[s2.strstart & s2.w_mask] = s2.head[s2.ins_h];
                s2.head[s2.ins_h] = s2.strstart;
              }
            } while (--s2.prev_length !== 0);
            s2.match_available = 0;
            s2.match_length = MIN_MATCH - 1;
            s2.strstart++;
            if (bflush) {
              flush_block_only(s2, false);
              if (s2.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
            }
          } else if (s2.match_available) {
            bflush = trees._tr_tally(s2, 0, s2.window[s2.strstart - 1]);
            if (bflush) {
              flush_block_only(s2, false);
            }
            s2.strstart++;
            s2.lookahead--;
            if (s2.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          } else {
            s2.match_available = 1;
            s2.strstart++;
            s2.lookahead--;
          }
        }
        if (s2.match_available) {
          bflush = trees._tr_tally(s2, 0, s2.window[s2.strstart - 1]);
          s2.match_available = 0;
        }
        s2.insert = s2.strstart < MIN_MATCH - 1 ? s2.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          flush_block_only(s2, true);
          if (s2.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          return BS_FINISH_DONE;
        }
        if (s2.last_lit) {
          flush_block_only(s2, false);
          if (s2.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        }
        return BS_BLOCK_DONE;
      }
      function deflate_rle(s2, flush) {
        var bflush;
        var prev;
        var scan, strend;
        var _win = s2.window;
        for (; ; ) {
          if (s2.lookahead <= MAX_MATCH) {
            fill_window(s2);
            if (s2.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s2.lookahead === 0) {
              break;
            }
          }
          s2.match_length = 0;
          if (s2.lookahead >= MIN_MATCH && s2.strstart > 0) {
            scan = s2.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
              strend = s2.strstart + MAX_MATCH;
              do {
              } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
              s2.match_length = MAX_MATCH - (strend - scan);
              if (s2.match_length > s2.lookahead) {
                s2.match_length = s2.lookahead;
              }
            }
          }
          if (s2.match_length >= MIN_MATCH) {
            bflush = trees._tr_tally(s2, 1, s2.match_length - MIN_MATCH);
            s2.lookahead -= s2.match_length;
            s2.strstart += s2.match_length;
            s2.match_length = 0;
          } else {
            bflush = trees._tr_tally(s2, 0, s2.window[s2.strstart]);
            s2.lookahead--;
            s2.strstart++;
          }
          if (bflush) {
            flush_block_only(s2, false);
            if (s2.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          }
        }
        s2.insert = 0;
        if (flush === Z_FINISH) {
          flush_block_only(s2, true);
          if (s2.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          return BS_FINISH_DONE;
        }
        if (s2.last_lit) {
          flush_block_only(s2, false);
          if (s2.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        }
        return BS_BLOCK_DONE;
      }
      function deflate_huff(s2, flush) {
        var bflush;
        for (; ; ) {
          if (s2.lookahead === 0) {
            fill_window(s2);
            if (s2.lookahead === 0) {
              if (flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              break;
            }
          }
          s2.match_length = 0;
          bflush = trees._tr_tally(s2, 0, s2.window[s2.strstart]);
          s2.lookahead--;
          s2.strstart++;
          if (bflush) {
            flush_block_only(s2, false);
            if (s2.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          }
        }
        s2.insert = 0;
        if (flush === Z_FINISH) {
          flush_block_only(s2, true);
          if (s2.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          return BS_FINISH_DONE;
        }
        if (s2.last_lit) {
          flush_block_only(s2, false);
          if (s2.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
        }
        return BS_BLOCK_DONE;
      }
      function Config(good_length, max_lazy, nice_length, max_chain, func) {
        this.good_length = good_length;
        this.max_lazy = max_lazy;
        this.nice_length = nice_length;
        this.max_chain = max_chain;
        this.func = func;
      }
      var configuration_table;
      configuration_table = [
        /*      good lazy nice chain */
        new Config(0, 0, 0, 0, deflate_stored),
        /* 0 store only */
        new Config(4, 4, 8, 4, deflate_fast),
        /* 1 max speed, no lazy matches */
        new Config(4, 5, 16, 8, deflate_fast),
        /* 2 */
        new Config(4, 6, 32, 32, deflate_fast),
        /* 3 */
        new Config(4, 4, 16, 16, deflate_slow),
        /* 4 lazy matches */
        new Config(8, 16, 32, 32, deflate_slow),
        /* 5 */
        new Config(8, 16, 128, 128, deflate_slow),
        /* 6 */
        new Config(8, 32, 128, 256, deflate_slow),
        /* 7 */
        new Config(32, 128, 258, 1024, deflate_slow),
        /* 8 */
        new Config(32, 258, 258, 4096, deflate_slow)
        /* 9 max compression */
      ];
      function lm_init(s2) {
        s2.window_size = 2 * s2.w_size;
        zero(s2.head);
        s2.max_lazy_match = configuration_table[s2.level].max_lazy;
        s2.good_match = configuration_table[s2.level].good_length;
        s2.nice_match = configuration_table[s2.level].nice_length;
        s2.max_chain_length = configuration_table[s2.level].max_chain;
        s2.strstart = 0;
        s2.block_start = 0;
        s2.lookahead = 0;
        s2.insert = 0;
        s2.match_length = s2.prev_length = MIN_MATCH - 1;
        s2.match_available = 0;
        s2.ins_h = 0;
      }
      function DeflateState() {
        this.strm = null;
        this.status = 0;
        this.pending_buf = null;
        this.pending_buf_size = 0;
        this.pending_out = 0;
        this.pending = 0;
        this.wrap = 0;
        this.gzhead = null;
        this.gzindex = 0;
        this.method = Z_DEFLATED;
        this.last_flush = -1;
        this.w_size = 0;
        this.w_bits = 0;
        this.w_mask = 0;
        this.window = null;
        this.window_size = 0;
        this.prev = null;
        this.head = null;
        this.ins_h = 0;
        this.hash_size = 0;
        this.hash_bits = 0;
        this.hash_mask = 0;
        this.hash_shift = 0;
        this.block_start = 0;
        this.match_length = 0;
        this.prev_match = 0;
        this.match_available = 0;
        this.strstart = 0;
        this.match_start = 0;
        this.lookahead = 0;
        this.prev_length = 0;
        this.max_chain_length = 0;
        this.max_lazy_match = 0;
        this.level = 0;
        this.strategy = 0;
        this.good_match = 0;
        this.nice_match = 0;
        this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
        this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
        this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
        zero(this.dyn_ltree);
        zero(this.dyn_dtree);
        zero(this.bl_tree);
        this.l_desc = null;
        this.d_desc = null;
        this.bl_desc = null;
        this.bl_count = new utils.Buf16(MAX_BITS + 1);
        this.heap = new utils.Buf16(2 * L_CODES + 1);
        zero(this.heap);
        this.heap_len = 0;
        this.heap_max = 0;
        this.depth = new utils.Buf16(2 * L_CODES + 1);
        zero(this.depth);
        this.l_buf = 0;
        this.lit_bufsize = 0;
        this.last_lit = 0;
        this.d_buf = 0;
        this.opt_len = 0;
        this.static_len = 0;
        this.matches = 0;
        this.insert = 0;
        this.bi_buf = 0;
        this.bi_valid = 0;
      }
      function deflateResetKeep(strm) {
        var s2;
        if (!strm || !strm.state) {
          return err3(strm, Z_STREAM_ERROR);
        }
        strm.total_in = strm.total_out = 0;
        strm.data_type = Z_UNKNOWN;
        s2 = strm.state;
        s2.pending = 0;
        s2.pending_out = 0;
        if (s2.wrap < 0) {
          s2.wrap = -s2.wrap;
        }
        s2.status = s2.wrap ? INIT_STATE : BUSY_STATE;
        strm.adler = s2.wrap === 2 ? 0 : 1;
        s2.last_flush = Z_NO_FLUSH;
        trees._tr_init(s2);
        return Z_OK;
      }
      function deflateReset(strm) {
        var ret = deflateResetKeep(strm);
        if (ret === Z_OK) {
          lm_init(strm.state);
        }
        return ret;
      }
      function deflateSetHeader(strm, head) {
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        if (strm.state.wrap !== 2) {
          return Z_STREAM_ERROR;
        }
        strm.state.gzhead = head;
        return Z_OK;
      }
      function deflateInit2(strm, level2, method, windowBits, memLevel, strategy) {
        if (!strm) {
          return Z_STREAM_ERROR;
        }
        var wrap2 = 1;
        if (level2 === Z_DEFAULT_COMPRESSION) {
          level2 = 6;
        }
        if (windowBits < 0) {
          wrap2 = 0;
          windowBits = -windowBits;
        } else if (windowBits > 15) {
          wrap2 = 2;
          windowBits -= 16;
        }
        if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level2 < 0 || level2 > 9 || strategy < 0 || strategy > Z_FIXED) {
          return err3(strm, Z_STREAM_ERROR);
        }
        if (windowBits === 8) {
          windowBits = 9;
        }
        var s2 = new DeflateState();
        strm.state = s2;
        s2.strm = strm;
        s2.wrap = wrap2;
        s2.gzhead = null;
        s2.w_bits = windowBits;
        s2.w_size = 1 << s2.w_bits;
        s2.w_mask = s2.w_size - 1;
        s2.hash_bits = memLevel + 7;
        s2.hash_size = 1 << s2.hash_bits;
        s2.hash_mask = s2.hash_size - 1;
        s2.hash_shift = ~~((s2.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
        s2.window = new utils.Buf8(s2.w_size * 2);
        s2.head = new utils.Buf16(s2.hash_size);
        s2.prev = new utils.Buf16(s2.w_size);
        s2.lit_bufsize = 1 << memLevel + 6;
        s2.pending_buf_size = s2.lit_bufsize * 4;
        s2.pending_buf = new utils.Buf8(s2.pending_buf_size);
        s2.d_buf = 1 * s2.lit_bufsize;
        s2.l_buf = (1 + 2) * s2.lit_bufsize;
        s2.level = level2;
        s2.strategy = strategy;
        s2.method = method;
        return deflateReset(strm);
      }
      function deflateInit(strm, level2) {
        return deflateInit2(strm, level2, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
      }
      function deflate(strm, flush) {
        var old_flush, s2;
        var beg, val;
        if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
          return strm ? err3(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
        }
        s2 = strm.state;
        if (!strm.output || !strm.input && strm.avail_in !== 0 || s2.status === FINISH_STATE && flush !== Z_FINISH) {
          return err3(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
        }
        s2.strm = strm;
        old_flush = s2.last_flush;
        s2.last_flush = flush;
        if (s2.status === INIT_STATE) {
          if (s2.wrap === 2) {
            strm.adler = 0;
            put_byte(s2, 31);
            put_byte(s2, 139);
            put_byte(s2, 8);
            if (!s2.gzhead) {
              put_byte(s2, 0);
              put_byte(s2, 0);
              put_byte(s2, 0);
              put_byte(s2, 0);
              put_byte(s2, 0);
              put_byte(s2, s2.level === 9 ? 2 : s2.strategy >= Z_HUFFMAN_ONLY || s2.level < 2 ? 4 : 0);
              put_byte(s2, OS_CODE);
              s2.status = BUSY_STATE;
            } else {
              put_byte(
                s2,
                (s2.gzhead.text ? 1 : 0) + (s2.gzhead.hcrc ? 2 : 0) + (!s2.gzhead.extra ? 0 : 4) + (!s2.gzhead.name ? 0 : 8) + (!s2.gzhead.comment ? 0 : 16)
              );
              put_byte(s2, s2.gzhead.time & 255);
              put_byte(s2, s2.gzhead.time >> 8 & 255);
              put_byte(s2, s2.gzhead.time >> 16 & 255);
              put_byte(s2, s2.gzhead.time >> 24 & 255);
              put_byte(s2, s2.level === 9 ? 2 : s2.strategy >= Z_HUFFMAN_ONLY || s2.level < 2 ? 4 : 0);
              put_byte(s2, s2.gzhead.os & 255);
              if (s2.gzhead.extra && s2.gzhead.extra.length) {
                put_byte(s2, s2.gzhead.extra.length & 255);
                put_byte(s2, s2.gzhead.extra.length >> 8 & 255);
              }
              if (s2.gzhead.hcrc) {
                strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending, 0);
              }
              s2.gzindex = 0;
              s2.status = EXTRA_STATE;
            }
          } else {
            var header = Z_DEFLATED + (s2.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s2.strategy >= Z_HUFFMAN_ONLY || s2.level < 2) {
              level_flags = 0;
            } else if (s2.level < 6) {
              level_flags = 1;
            } else if (s2.level === 6) {
              level_flags = 2;
            } else {
              level_flags = 3;
            }
            header |= level_flags << 6;
            if (s2.strstart !== 0) {
              header |= PRESET_DICT;
            }
            header += 31 - header % 31;
            s2.status = BUSY_STATE;
            putShortMSB(s2, header);
            if (s2.strstart !== 0) {
              putShortMSB(s2, strm.adler >>> 16);
              putShortMSB(s2, strm.adler & 65535);
            }
            strm.adler = 1;
          }
        }
        if (s2.status === EXTRA_STATE) {
          if (s2.gzhead.extra) {
            beg = s2.pending;
            while (s2.gzindex < (s2.gzhead.extra.length & 65535)) {
              if (s2.pending === s2.pending_buf_size) {
                if (s2.gzhead.hcrc && s2.pending > beg) {
                  strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s2.pending;
                if (s2.pending === s2.pending_buf_size) {
                  break;
                }
              }
              put_byte(s2, s2.gzhead.extra[s2.gzindex] & 255);
              s2.gzindex++;
            }
            if (s2.gzhead.hcrc && s2.pending > beg) {
              strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending - beg, beg);
            }
            if (s2.gzindex === s2.gzhead.extra.length) {
              s2.gzindex = 0;
              s2.status = NAME_STATE;
            }
          } else {
            s2.status = NAME_STATE;
          }
        }
        if (s2.status === NAME_STATE) {
          if (s2.gzhead.name) {
            beg = s2.pending;
            do {
              if (s2.pending === s2.pending_buf_size) {
                if (s2.gzhead.hcrc && s2.pending > beg) {
                  strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s2.pending;
                if (s2.pending === s2.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              if (s2.gzindex < s2.gzhead.name.length) {
                val = s2.gzhead.name.charCodeAt(s2.gzindex++) & 255;
              } else {
                val = 0;
              }
              put_byte(s2, val);
            } while (val !== 0);
            if (s2.gzhead.hcrc && s2.pending > beg) {
              strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending - beg, beg);
            }
            if (val === 0) {
              s2.gzindex = 0;
              s2.status = COMMENT_STATE;
            }
          } else {
            s2.status = COMMENT_STATE;
          }
        }
        if (s2.status === COMMENT_STATE) {
          if (s2.gzhead.comment) {
            beg = s2.pending;
            do {
              if (s2.pending === s2.pending_buf_size) {
                if (s2.gzhead.hcrc && s2.pending > beg) {
                  strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s2.pending;
                if (s2.pending === s2.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              if (s2.gzindex < s2.gzhead.comment.length) {
                val = s2.gzhead.comment.charCodeAt(s2.gzindex++) & 255;
              } else {
                val = 0;
              }
              put_byte(s2, val);
            } while (val !== 0);
            if (s2.gzhead.hcrc && s2.pending > beg) {
              strm.adler = crc32(strm.adler, s2.pending_buf, s2.pending - beg, beg);
            }
            if (val === 0) {
              s2.status = HCRC_STATE;
            }
          } else {
            s2.status = HCRC_STATE;
          }
        }
        if (s2.status === HCRC_STATE) {
          if (s2.gzhead.hcrc) {
            if (s2.pending + 2 > s2.pending_buf_size) {
              flush_pending(strm);
            }
            if (s2.pending + 2 <= s2.pending_buf_size) {
              put_byte(s2, strm.adler & 255);
              put_byte(s2, strm.adler >> 8 & 255);
              strm.adler = 0;
              s2.status = BUSY_STATE;
            }
          } else {
            s2.status = BUSY_STATE;
          }
        }
        if (s2.pending !== 0) {
          flush_pending(strm);
          if (strm.avail_out === 0) {
            s2.last_flush = -1;
            return Z_OK;
          }
        } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
          return err3(strm, Z_BUF_ERROR);
        }
        if (s2.status === FINISH_STATE && strm.avail_in !== 0) {
          return err3(strm, Z_BUF_ERROR);
        }
        if (strm.avail_in !== 0 || s2.lookahead !== 0 || flush !== Z_NO_FLUSH && s2.status !== FINISH_STATE) {
          var bstate = s2.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s2, flush) : s2.strategy === Z_RLE ? deflate_rle(s2, flush) : configuration_table[s2.level].func(s2, flush);
          if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
            s2.status = FINISH_STATE;
          }
          if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) {
              s2.last_flush = -1;
            }
            return Z_OK;
          }
          if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) {
              trees._tr_align(s2);
            } else if (flush !== Z_BLOCK) {
              trees._tr_stored_block(s2, 0, 0, false);
              if (flush === Z_FULL_FLUSH) {
                zero(s2.head);
                if (s2.lookahead === 0) {
                  s2.strstart = 0;
                  s2.block_start = 0;
                  s2.insert = 0;
                }
              }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
              s2.last_flush = -1;
              return Z_OK;
            }
          }
        }
        if (flush !== Z_FINISH) {
          return Z_OK;
        }
        if (s2.wrap <= 0) {
          return Z_STREAM_END;
        }
        if (s2.wrap === 2) {
          put_byte(s2, strm.adler & 255);
          put_byte(s2, strm.adler >> 8 & 255);
          put_byte(s2, strm.adler >> 16 & 255);
          put_byte(s2, strm.adler >> 24 & 255);
          put_byte(s2, strm.total_in & 255);
          put_byte(s2, strm.total_in >> 8 & 255);
          put_byte(s2, strm.total_in >> 16 & 255);
          put_byte(s2, strm.total_in >> 24 & 255);
        } else {
          putShortMSB(s2, strm.adler >>> 16);
          putShortMSB(s2, strm.adler & 65535);
        }
        flush_pending(strm);
        if (s2.wrap > 0) {
          s2.wrap = -s2.wrap;
        }
        return s2.pending !== 0 ? Z_OK : Z_STREAM_END;
      }
      function deflateEnd(strm) {
        var status;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        status = strm.state.status;
        if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
          return err3(strm, Z_STREAM_ERROR);
        }
        strm.state = null;
        return status === BUSY_STATE ? err3(strm, Z_DATA_ERROR) : Z_OK;
      }
      function deflateSetDictionary(strm, dictionary) {
        var dictLength = dictionary.length;
        var s2;
        var str, n2;
        var wrap2;
        var avail;
        var next;
        var input;
        var tmpDict;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        s2 = strm.state;
        wrap2 = s2.wrap;
        if (wrap2 === 2 || wrap2 === 1 && s2.status !== INIT_STATE || s2.lookahead) {
          return Z_STREAM_ERROR;
        }
        if (wrap2 === 1) {
          strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
        }
        s2.wrap = 0;
        if (dictLength >= s2.w_size) {
          if (wrap2 === 0) {
            zero(s2.head);
            s2.strstart = 0;
            s2.block_start = 0;
            s2.insert = 0;
          }
          tmpDict = new utils.Buf8(s2.w_size);
          utils.arraySet(tmpDict, dictionary, dictLength - s2.w_size, s2.w_size, 0);
          dictionary = tmpDict;
          dictLength = s2.w_size;
        }
        avail = strm.avail_in;
        next = strm.next_in;
        input = strm.input;
        strm.avail_in = dictLength;
        strm.next_in = 0;
        strm.input = dictionary;
        fill_window(s2);
        while (s2.lookahead >= MIN_MATCH) {
          str = s2.strstart;
          n2 = s2.lookahead - (MIN_MATCH - 1);
          do {
            s2.ins_h = (s2.ins_h << s2.hash_shift ^ s2.window[str + MIN_MATCH - 1]) & s2.hash_mask;
            s2.prev[str & s2.w_mask] = s2.head[s2.ins_h];
            s2.head[s2.ins_h] = str;
            str++;
          } while (--n2);
          s2.strstart = str;
          s2.lookahead = MIN_MATCH - 1;
          fill_window(s2);
        }
        s2.strstart += s2.lookahead;
        s2.block_start = s2.strstart;
        s2.insert = s2.lookahead;
        s2.lookahead = 0;
        s2.match_length = s2.prev_length = MIN_MATCH - 1;
        s2.match_available = 0;
        strm.next_in = next;
        strm.input = input;
        strm.avail_in = avail;
        s2.wrap = wrap2;
        return Z_OK;
      }
      exports2.deflateInit = deflateInit;
      exports2.deflateInit2 = deflateInit2;
      exports2.deflateReset = deflateReset;
      exports2.deflateResetKeep = deflateResetKeep;
      exports2.deflateSetHeader = deflateSetHeader;
      exports2.deflate = deflate;
      exports2.deflateEnd = deflateEnd;
      exports2.deflateSetDictionary = deflateSetDictionary;
      exports2.deflateInfo = "pako deflate (from Nodeca project)";
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/utils/strings.js
  var require_strings = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/utils/strings.js"(exports2) {
      "use strict";
      var utils = require_common();
      var STR_APPLY_OK = true;
      var STR_APPLY_UIA_OK = true;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch (__) {
        STR_APPLY_OK = false;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (__) {
        STR_APPLY_UIA_OK = false;
      }
      var _utf8len = new utils.Buf8(256);
      for (q = 0; q < 256; q++) {
        _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
      }
      var q;
      _utf8len[254] = _utf8len[254] = 1;
      exports2.string2buf = function(str) {
        var buf, c, c2, m_pos, i2, str_len = str.length, buf_len = 0;
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 64512) === 55296 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 64512) === 56320) {
              c = 65536 + (c - 55296 << 10) + (c2 - 56320);
              m_pos++;
            }
          }
          buf_len += c < 128 ? 1 : c < 2048 ? 2 : c < 65536 ? 3 : 4;
        }
        buf = new utils.Buf8(buf_len);
        for (i2 = 0, m_pos = 0; i2 < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 64512) === 55296 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 64512) === 56320) {
              c = 65536 + (c - 55296 << 10) + (c2 - 56320);
              m_pos++;
            }
          }
          if (c < 128) {
            buf[i2++] = c;
          } else if (c < 2048) {
            buf[i2++] = 192 | c >>> 6;
            buf[i2++] = 128 | c & 63;
          } else if (c < 65536) {
            buf[i2++] = 224 | c >>> 12;
            buf[i2++] = 128 | c >>> 6 & 63;
            buf[i2++] = 128 | c & 63;
          } else {
            buf[i2++] = 240 | c >>> 18;
            buf[i2++] = 128 | c >>> 12 & 63;
            buf[i2++] = 128 | c >>> 6 & 63;
            buf[i2++] = 128 | c & 63;
          }
        }
        return buf;
      };
      function buf2binstring(buf, len) {
        if (len < 65534) {
          if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
            return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
          }
        }
        var result = "";
        for (var i2 = 0; i2 < len; i2++) {
          result += String.fromCharCode(buf[i2]);
        }
        return result;
      }
      exports2.buf2binstring = function(buf) {
        return buf2binstring(buf, buf.length);
      };
      exports2.binstring2buf = function(str) {
        var buf = new utils.Buf8(str.length);
        for (var i2 = 0, len = buf.length; i2 < len; i2++) {
          buf[i2] = str.charCodeAt(i2);
        }
        return buf;
      };
      exports2.buf2string = function(buf, max2) {
        var i2, out, c, c_len;
        var len = max2 || buf.length;
        var utf16buf = new Array(len * 2);
        for (out = 0, i2 = 0; i2 < len; ) {
          c = buf[i2++];
          if (c < 128) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          if (c_len > 4) {
            utf16buf[out++] = 65533;
            i2 += c_len - 1;
            continue;
          }
          c &= c_len === 2 ? 31 : c_len === 3 ? 15 : 7;
          while (c_len > 1 && i2 < len) {
            c = c << 6 | buf[i2++] & 63;
            c_len--;
          }
          if (c_len > 1) {
            utf16buf[out++] = 65533;
            continue;
          }
          if (c < 65536) {
            utf16buf[out++] = c;
          } else {
            c -= 65536;
            utf16buf[out++] = 55296 | c >> 10 & 1023;
            utf16buf[out++] = 56320 | c & 1023;
          }
        }
        return buf2binstring(utf16buf, out);
      };
      exports2.utf8border = function(buf, max2) {
        var pos;
        max2 = max2 || buf.length;
        if (max2 > buf.length) {
          max2 = buf.length;
        }
        pos = max2 - 1;
        while (pos >= 0 && (buf[pos] & 192) === 128) {
          pos--;
        }
        if (pos < 0) {
          return max2;
        }
        if (pos === 0) {
          return max2;
        }
        return pos + _utf8len[buf[pos]] > max2 ? pos : max2;
      };
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/zstream.js
  var require_zstream = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/zstream.js"(exports2, module2) {
      "use strict";
      function ZStream() {
        this.input = null;
        this.next_in = 0;
        this.avail_in = 0;
        this.total_in = 0;
        this.output = null;
        this.next_out = 0;
        this.avail_out = 0;
        this.total_out = 0;
        this.msg = "";
        this.state = null;
        this.data_type = 2;
        this.adler = 0;
      }
      module2.exports = ZStream;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/deflate.js
  var require_deflate2 = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/deflate.js"(exports2) {
      "use strict";
      var zlib_deflate = require_deflate();
      var utils = require_common();
      var strings = require_strings();
      var msg = require_messages();
      var ZStream = require_zstream();
      var toString3 = Object.prototype.toString;
      var Z_NO_FLUSH = 0;
      var Z_FINISH = 4;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_SYNC_FLUSH = 2;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_DEFAULT_STRATEGY = 0;
      var Z_DEFLATED = 8;
      function Deflate(options) {
        if (!(this instanceof Deflate)) return new Deflate(options);
        this.options = utils.assign({
          level: Z_DEFAULT_COMPRESSION,
          method: Z_DEFLATED,
          chunkSize: 16384,
          windowBits: 15,
          memLevel: 8,
          strategy: Z_DEFAULT_STRATEGY,
          to: ""
        }, options || {});
        var opt = this.options;
        if (opt.raw && opt.windowBits > 0) {
          opt.windowBits = -opt.windowBits;
        } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
          opt.windowBits += 16;
        }
        this.err = 0;
        this.msg = "";
        this.ended = false;
        this.chunks = [];
        this.strm = new ZStream();
        this.strm.avail_out = 0;
        var status = zlib_deflate.deflateInit2(
          this.strm,
          opt.level,
          opt.method,
          opt.windowBits,
          opt.memLevel,
          opt.strategy
        );
        if (status !== Z_OK) {
          throw new Error(msg[status]);
        }
        if (opt.header) {
          zlib_deflate.deflateSetHeader(this.strm, opt.header);
        }
        if (opt.dictionary) {
          var dict;
          if (typeof opt.dictionary === "string") {
            dict = strings.string2buf(opt.dictionary);
          } else if (toString3.call(opt.dictionary) === "[object ArrayBuffer]") {
            dict = new Uint8Array(opt.dictionary);
          } else {
            dict = opt.dictionary;
          }
          status = zlib_deflate.deflateSetDictionary(this.strm, dict);
          if (status !== Z_OK) {
            throw new Error(msg[status]);
          }
          this._dict_set = true;
        }
      }
      Deflate.prototype.push = function(data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var status, _mode;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH;
        if (typeof data === "string") {
          strm.input = strings.string2buf(data);
        } else if (toString3.call(data) === "[object ArrayBuffer]") {
          strm.input = new Uint8Array(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_deflate.deflate(strm, _mode);
          if (status !== Z_STREAM_END && status !== Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH)) {
            if (this.options.to === "string") {
              this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
            } else {
              this.onData(utils.shrinkBuf(strm.output, strm.next_out));
            }
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
        if (_mode === Z_FINISH) {
          status = zlib_deflate.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK;
        }
        if (_mode === Z_SYNC_FLUSH) {
          this.onEnd(Z_OK);
          strm.avail_out = 0;
          return true;
        }
        return true;
      };
      Deflate.prototype.onData = function(chunk) {
        this.chunks.push(chunk);
      };
      Deflate.prototype.onEnd = function(status) {
        if (status === Z_OK) {
          if (this.options.to === "string") {
            this.result = this.chunks.join("");
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };
      function deflate(input, options) {
        var deflator = new Deflate(options);
        deflator.push(input, true);
        if (deflator.err) {
          throw deflator.msg || msg[deflator.err];
        }
        return deflator.result;
      }
      function deflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return deflate(input, options);
      }
      function gzip(input, options) {
        options = options || {};
        options.gzip = true;
        return deflate(input, options);
      }
      exports2.Deflate = Deflate;
      exports2.deflate = deflate;
      exports2.deflateRaw = deflateRaw;
      exports2.gzip = gzip;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/inffast.js
  var require_inffast = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/inffast.js"(exports2, module2) {
      "use strict";
      var BAD = 30;
      var TYPE = 12;
      module2.exports = function inflate_fast(strm, start) {
        var state;
        var _in;
        var last;
        var _out;
        var beg;
        var end;
        var dmax;
        var wsize;
        var whave;
        var wnext;
        var s_window;
        var hold;
        var bits2;
        var lcode;
        var dcode;
        var lmask;
        var dmask;
        var here;
        var op;
        var len;
        var dist;
        var from;
        var from_source;
        var input, output3;
        state = strm.state;
        _in = strm.next_in;
        input = strm.input;
        last = _in + (strm.avail_in - 5);
        _out = strm.next_out;
        output3 = strm.output;
        beg = _out - (start - strm.avail_out);
        end = _out + (strm.avail_out - 257);
        dmax = state.dmax;
        wsize = state.wsize;
        whave = state.whave;
        wnext = state.wnext;
        s_window = state.window;
        hold = state.hold;
        bits2 = state.bits;
        lcode = state.lencode;
        dcode = state.distcode;
        lmask = (1 << state.lenbits) - 1;
        dmask = (1 << state.distbits) - 1;
        top:
          do {
            if (bits2 < 15) {
              hold += input[_in++] << bits2;
              bits2 += 8;
              hold += input[_in++] << bits2;
              bits2 += 8;
            }
            here = lcode[hold & lmask];
            dolen:
              for (; ; ) {
                op = here >>> 24;
                hold >>>= op;
                bits2 -= op;
                op = here >>> 16 & 255;
                if (op === 0) {
                  output3[_out++] = here & 65535;
                } else if (op & 16) {
                  len = here & 65535;
                  op &= 15;
                  if (op) {
                    if (bits2 < op) {
                      hold += input[_in++] << bits2;
                      bits2 += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits2 -= op;
                  }
                  if (bits2 < 15) {
                    hold += input[_in++] << bits2;
                    bits2 += 8;
                    hold += input[_in++] << bits2;
                    bits2 += 8;
                  }
                  here = dcode[hold & dmask];
                  dodist:
                    for (; ; ) {
                      op = here >>> 24;
                      hold >>>= op;
                      bits2 -= op;
                      op = here >>> 16 & 255;
                      if (op & 16) {
                        dist = here & 65535;
                        op &= 15;
                        if (bits2 < op) {
                          hold += input[_in++] << bits2;
                          bits2 += 8;
                          if (bits2 < op) {
                            hold += input[_in++] << bits2;
                            bits2 += 8;
                          }
                        }
                        dist += hold & (1 << op) - 1;
                        if (dist > dmax) {
                          strm.msg = "invalid distance too far back";
                          state.mode = BAD;
                          break top;
                        }
                        hold >>>= op;
                        bits2 -= op;
                        op = _out - beg;
                        if (dist > op) {
                          op = dist - op;
                          if (op > whave) {
                            if (state.sane) {
                              strm.msg = "invalid distance too far back";
                              state.mode = BAD;
                              break top;
                            }
                          }
                          from = 0;
                          from_source = s_window;
                          if (wnext === 0) {
                            from += wsize - op;
                            if (op < len) {
                              len -= op;
                              do {
                                output3[_out++] = s_window[from++];
                              } while (--op);
                              from = _out - dist;
                              from_source = output3;
                            }
                          } else if (wnext < op) {
                            from += wsize + wnext - op;
                            op -= wnext;
                            if (op < len) {
                              len -= op;
                              do {
                                output3[_out++] = s_window[from++];
                              } while (--op);
                              from = 0;
                              if (wnext < len) {
                                op = wnext;
                                len -= op;
                                do {
                                  output3[_out++] = s_window[from++];
                                } while (--op);
                                from = _out - dist;
                                from_source = output3;
                              }
                            }
                          } else {
                            from += wnext - op;
                            if (op < len) {
                              len -= op;
                              do {
                                output3[_out++] = s_window[from++];
                              } while (--op);
                              from = _out - dist;
                              from_source = output3;
                            }
                          }
                          while (len > 2) {
                            output3[_out++] = from_source[from++];
                            output3[_out++] = from_source[from++];
                            output3[_out++] = from_source[from++];
                            len -= 3;
                          }
                          if (len) {
                            output3[_out++] = from_source[from++];
                            if (len > 1) {
                              output3[_out++] = from_source[from++];
                            }
                          }
                        } else {
                          from = _out - dist;
                          do {
                            output3[_out++] = output3[from++];
                            output3[_out++] = output3[from++];
                            output3[_out++] = output3[from++];
                            len -= 3;
                          } while (len > 2);
                          if (len) {
                            output3[_out++] = output3[from++];
                            if (len > 1) {
                              output3[_out++] = output3[from++];
                            }
                          }
                        }
                      } else if ((op & 64) === 0) {
                        here = dcode[(here & 65535) + (hold & (1 << op) - 1)];
                        continue dodist;
                      } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break top;
                      }
                      break;
                    }
                } else if ((op & 64) === 0) {
                  here = lcode[(here & 65535) + (hold & (1 << op) - 1)];
                  continue dolen;
                } else if (op & 32) {
                  state.mode = TYPE;
                  break top;
                } else {
                  strm.msg = "invalid literal/length code";
                  state.mode = BAD;
                  break top;
                }
                break;
              }
          } while (_in < last && _out < end);
        len = bits2 >> 3;
        _in -= len;
        bits2 -= len << 3;
        hold &= (1 << bits2) - 1;
        strm.next_in = _in;
        strm.next_out = _out;
        strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
        strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
        state.hold = hold;
        state.bits = bits2;
        return;
      };
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/inftrees.js
  var require_inftrees = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/inftrees.js"(exports2, module2) {
      "use strict";
      var utils = require_common();
      var MAXBITS = 15;
      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      var lbase = [
        /* Length codes 257..285 base */
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258,
        0,
        0
      ];
      var lext = [
        /* Length codes 257..285 extra */
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        17,
        17,
        17,
        17,
        18,
        18,
        18,
        18,
        19,
        19,
        19,
        19,
        20,
        20,
        20,
        20,
        21,
        21,
        21,
        21,
        16,
        72,
        78
      ];
      var dbase = [
        /* Distance codes 0..29 base */
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577,
        0,
        0
      ];
      var dext = [
        /* Distance codes 0..29 extra */
        16,
        16,
        16,
        16,
        17,
        17,
        18,
        18,
        19,
        19,
        20,
        20,
        21,
        21,
        22,
        22,
        23,
        23,
        24,
        24,
        25,
        25,
        26,
        26,
        27,
        27,
        28,
        28,
        29,
        29,
        64,
        64
      ];
      module2.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
        var bits2 = opts.bits;
        var len = 0;
        var sym = 0;
        var min = 0, max2 = 0;
        var root = 0;
        var curr = 0;
        var drop = 0;
        var left = 0;
        var used = 0;
        var huff = 0;
        var incr;
        var fill;
        var low;
        var mask2;
        var next;
        var base2 = null;
        var base_index = 0;
        var end;
        var count = new utils.Buf16(MAXBITS + 1);
        var offs = new utils.Buf16(MAXBITS + 1);
        var extra = null;
        var extra_index = 0;
        var here_bits, here_op, here_val;
        for (len = 0; len <= MAXBITS; len++) {
          count[len] = 0;
        }
        for (sym = 0; sym < codes; sym++) {
          count[lens[lens_index + sym]]++;
        }
        root = bits2;
        for (max2 = MAXBITS; max2 >= 1; max2--) {
          if (count[max2] !== 0) {
            break;
          }
        }
        if (root > max2) {
          root = max2;
        }
        if (max2 === 0) {
          table[table_index++] = 1 << 24 | 64 << 16 | 0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;
          opts.bits = 1;
          return 0;
        }
        for (min = 1; min < max2; min++) {
          if (count[min] !== 0) {
            break;
          }
        }
        if (root < min) {
          root = min;
        }
        left = 1;
        for (len = 1; len <= MAXBITS; len++) {
          left <<= 1;
          left -= count[len];
          if (left < 0) {
            return -1;
          }
        }
        if (left > 0 && (type === CODES || max2 !== 1)) {
          return -1;
        }
        offs[1] = 0;
        for (len = 1; len < MAXBITS; len++) {
          offs[len + 1] = offs[len] + count[len];
        }
        for (sym = 0; sym < codes; sym++) {
          if (lens[lens_index + sym] !== 0) {
            work[offs[lens[lens_index + sym]]++] = sym;
          }
        }
        if (type === CODES) {
          base2 = extra = work;
          end = 19;
        } else if (type === LENS) {
          base2 = lbase;
          base_index -= 257;
          extra = lext;
          extra_index -= 257;
          end = 256;
        } else {
          base2 = dbase;
          extra = dext;
          end = -1;
        }
        huff = 0;
        sym = 0;
        len = min;
        next = table_index;
        curr = root;
        drop = 0;
        low = -1;
        used = 1 << root;
        mask2 = used - 1;
        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
          return 1;
        }
        for (; ; ) {
          here_bits = len - drop;
          if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
          } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base2[base_index + work[sym]];
          } else {
            here_op = 32 + 64;
            here_val = 0;
          }
          incr = 1 << len - drop;
          fill = 1 << curr;
          min = fill;
          do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
          } while (fill !== 0);
          incr = 1 << len - 1;
          while (huff & incr) {
            incr >>= 1;
          }
          if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
          } else {
            huff = 0;
          }
          sym++;
          if (--count[len] === 0) {
            if (len === max2) {
              break;
            }
            len = lens[lens_index + work[sym]];
          }
          if (len > root && (huff & mask2) !== low) {
            if (drop === 0) {
              drop = root;
            }
            next += min;
            curr = len - drop;
            left = 1 << curr;
            while (curr + drop < max2) {
              left -= count[curr + drop];
              if (left <= 0) {
                break;
              }
              curr++;
              left <<= 1;
            }
            used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
              return 1;
            }
            low = huff & mask2;
            table[low] = root << 24 | curr << 16 | next - table_index | 0;
          }
        }
        if (huff !== 0) {
          table[next + huff] = len - drop << 24 | 64 << 16 | 0;
        }
        opts.bits = root;
        return 0;
      };
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/inflate.js
  var require_inflate = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/inflate.js"(exports2) {
      "use strict";
      var utils = require_common();
      var adler32 = require_adler32();
      var crc32 = require_crc322();
      var inflate_fast = require_inffast();
      var inflate_table = require_inftrees();
      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      var Z_TREES = 6;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_NEED_DICT = 2;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      var Z_MEM_ERROR = -4;
      var Z_BUF_ERROR = -5;
      var Z_DEFLATED = 8;
      var HEAD = 1;
      var FLAGS = 2;
      var TIME = 3;
      var OS = 4;
      var EXLEN = 5;
      var EXTRA = 6;
      var NAME = 7;
      var COMMENT = 8;
      var HCRC = 9;
      var DICTID = 10;
      var DICT = 11;
      var TYPE = 12;
      var TYPEDO = 13;
      var STORED = 14;
      var COPY_ = 15;
      var COPY = 16;
      var TABLE = 17;
      var LENLENS = 18;
      var CODELENS = 19;
      var LEN_ = 20;
      var LEN = 21;
      var LENEXT = 22;
      var DIST = 23;
      var DISTEXT = 24;
      var MATCH = 25;
      var LIT = 26;
      var CHECK = 27;
      var LENGTH = 28;
      var DONE = 29;
      var BAD = 30;
      var MEM = 31;
      var SYNC = 32;
      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      var MAX_WBITS = 15;
      var DEF_WBITS = MAX_WBITS;
      function zswap32(q) {
        return (q >>> 24 & 255) + (q >>> 8 & 65280) + ((q & 65280) << 8) + ((q & 255) << 24);
      }
      function InflateState() {
        this.mode = 0;
        this.last = false;
        this.wrap = 0;
        this.havedict = false;
        this.flags = 0;
        this.dmax = 0;
        this.check = 0;
        this.total = 0;
        this.head = null;
        this.wbits = 0;
        this.wsize = 0;
        this.whave = 0;
        this.wnext = 0;
        this.window = null;
        this.hold = 0;
        this.bits = 0;
        this.length = 0;
        this.offset = 0;
        this.extra = 0;
        this.lencode = null;
        this.distcode = null;
        this.lenbits = 0;
        this.distbits = 0;
        this.ncode = 0;
        this.nlen = 0;
        this.ndist = 0;
        this.have = 0;
        this.next = null;
        this.lens = new utils.Buf16(320);
        this.work = new utils.Buf16(288);
        this.lendyn = null;
        this.distdyn = null;
        this.sane = 0;
        this.back = 0;
        this.was = 0;
      }
      function inflateResetKeep(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        strm.total_in = strm.total_out = state.total = 0;
        strm.msg = "";
        if (state.wrap) {
          strm.adler = state.wrap & 1;
        }
        state.mode = HEAD;
        state.last = 0;
        state.havedict = 0;
        state.dmax = 32768;
        state.head = null;
        state.hold = 0;
        state.bits = 0;
        state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
        state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
        state.sane = 1;
        state.back = -1;
        return Z_OK;
      }
      function inflateReset(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        state.wsize = 0;
        state.whave = 0;
        state.wnext = 0;
        return inflateResetKeep(strm);
      }
      function inflateReset2(strm, windowBits) {
        var wrap2;
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (windowBits < 0) {
          wrap2 = 0;
          windowBits = -windowBits;
        } else {
          wrap2 = (windowBits >> 4) + 1;
          if (windowBits < 48) {
            windowBits &= 15;
          }
        }
        if (windowBits && (windowBits < 8 || windowBits > 15)) {
          return Z_STREAM_ERROR;
        }
        if (state.window !== null && state.wbits !== windowBits) {
          state.window = null;
        }
        state.wrap = wrap2;
        state.wbits = windowBits;
        return inflateReset(strm);
      }
      function inflateInit2(strm, windowBits) {
        var ret;
        var state;
        if (!strm) {
          return Z_STREAM_ERROR;
        }
        state = new InflateState();
        strm.state = state;
        state.window = null;
        ret = inflateReset2(strm, windowBits);
        if (ret !== Z_OK) {
          strm.state = null;
        }
        return ret;
      }
      function inflateInit(strm) {
        return inflateInit2(strm, DEF_WBITS);
      }
      var virgin = true;
      var lenfix;
      var distfix;
      function fixedtables(state) {
        if (virgin) {
          var sym;
          lenfix = new utils.Buf32(512);
          distfix = new utils.Buf32(32);
          sym = 0;
          while (sym < 144) {
            state.lens[sym++] = 8;
          }
          while (sym < 256) {
            state.lens[sym++] = 9;
          }
          while (sym < 280) {
            state.lens[sym++] = 7;
          }
          while (sym < 288) {
            state.lens[sym++] = 8;
          }
          inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, { bits: 9 });
          sym = 0;
          while (sym < 32) {
            state.lens[sym++] = 5;
          }
          inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, { bits: 5 });
          virgin = false;
        }
        state.lencode = lenfix;
        state.lenbits = 9;
        state.distcode = distfix;
        state.distbits = 5;
      }
      function updatewindow(strm, src, end, copy) {
        var dist;
        var state = strm.state;
        if (state.window === null) {
          state.wsize = 1 << state.wbits;
          state.wnext = 0;
          state.whave = 0;
          state.window = new utils.Buf8(state.wsize);
        }
        if (copy >= state.wsize) {
          utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
          state.wnext = 0;
          state.whave = state.wsize;
        } else {
          dist = state.wsize - state.wnext;
          if (dist > copy) {
            dist = copy;
          }
          utils.arraySet(state.window, src, end - copy, dist, state.wnext);
          copy -= dist;
          if (copy) {
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
          } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) {
              state.wnext = 0;
            }
            if (state.whave < state.wsize) {
              state.whave += dist;
            }
          }
        }
        return 0;
      }
      function inflate(strm, flush) {
        var state;
        var input, output3;
        var next;
        var put;
        var have, left;
        var hold;
        var bits2;
        var _in, _out;
        var copy;
        var from;
        var from_source;
        var here = 0;
        var here_bits, here_op, here_val;
        var last_bits, last_op, last_val;
        var len;
        var ret;
        var hbuf = new utils.Buf8(4);
        var opts;
        var n2;
        var order = (
          /* permutation of code lengths */
          [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
        );
        if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.mode === TYPE) {
          state.mode = TYPEDO;
        }
        put = strm.next_out;
        output3 = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits2 = state.bits;
        _in = have;
        _out = left;
        ret = Z_OK;
        inf_leave:
          for (; ; ) {
            switch (state.mode) {
              case HEAD:
                if (state.wrap === 0) {
                  state.mode = TYPEDO;
                  break;
                }
                while (bits2 < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                if (state.wrap & 2 && hold === 35615) {
                  state.check = 0;
                  hbuf[0] = hold & 255;
                  hbuf[1] = hold >>> 8 & 255;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  hold = 0;
                  bits2 = 0;
                  state.mode = FLAGS;
                  break;
                }
                state.flags = 0;
                if (state.head) {
                  state.head.done = false;
                }
                if (!(state.wrap & 1) || /* check if zlib header allowed */
                (((hold & 255) << 8) + (hold >> 8)) % 31) {
                  strm.msg = "incorrect header check";
                  state.mode = BAD;
                  break;
                }
                if ((hold & 15) !== Z_DEFLATED) {
                  strm.msg = "unknown compression method";
                  state.mode = BAD;
                  break;
                }
                hold >>>= 4;
                bits2 -= 4;
                len = (hold & 15) + 8;
                if (state.wbits === 0) {
                  state.wbits = len;
                } else if (len > state.wbits) {
                  strm.msg = "invalid window size";
                  state.mode = BAD;
                  break;
                }
                state.dmax = 1 << len;
                strm.adler = state.check = 1;
                state.mode = hold & 512 ? DICTID : TYPE;
                hold = 0;
                bits2 = 0;
                break;
              case FLAGS:
                while (bits2 < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                state.flags = hold;
                if ((state.flags & 255) !== Z_DEFLATED) {
                  strm.msg = "unknown compression method";
                  state.mode = BAD;
                  break;
                }
                if (state.flags & 57344) {
                  strm.msg = "unknown header flags set";
                  state.mode = BAD;
                  break;
                }
                if (state.head) {
                  state.head.text = hold >> 8 & 1;
                }
                if (state.flags & 512) {
                  hbuf[0] = hold & 255;
                  hbuf[1] = hold >>> 8 & 255;
                  state.check = crc32(state.check, hbuf, 2, 0);
                }
                hold = 0;
                bits2 = 0;
                state.mode = TIME;
              case TIME:
                while (bits2 < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                if (state.head) {
                  state.head.time = hold;
                }
                if (state.flags & 512) {
                  hbuf[0] = hold & 255;
                  hbuf[1] = hold >>> 8 & 255;
                  hbuf[2] = hold >>> 16 & 255;
                  hbuf[3] = hold >>> 24 & 255;
                  state.check = crc32(state.check, hbuf, 4, 0);
                }
                hold = 0;
                bits2 = 0;
                state.mode = OS;
              case OS:
                while (bits2 < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                if (state.head) {
                  state.head.xflags = hold & 255;
                  state.head.os = hold >> 8;
                }
                if (state.flags & 512) {
                  hbuf[0] = hold & 255;
                  hbuf[1] = hold >>> 8 & 255;
                  state.check = crc32(state.check, hbuf, 2, 0);
                }
                hold = 0;
                bits2 = 0;
                state.mode = EXLEN;
              case EXLEN:
                if (state.flags & 1024) {
                  while (bits2 < 16) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  state.length = hold;
                  if (state.head) {
                    state.head.extra_len = hold;
                  }
                  if (state.flags & 512) {
                    hbuf[0] = hold & 255;
                    hbuf[1] = hold >>> 8 & 255;
                    state.check = crc32(state.check, hbuf, 2, 0);
                  }
                  hold = 0;
                  bits2 = 0;
                } else if (state.head) {
                  state.head.extra = null;
                }
                state.mode = EXTRA;
              case EXTRA:
                if (state.flags & 1024) {
                  copy = state.length;
                  if (copy > have) {
                    copy = have;
                  }
                  if (copy) {
                    if (state.head) {
                      len = state.head.extra_len - state.length;
                      if (!state.head.extra) {
                        state.head.extra = new Array(state.head.extra_len);
                      }
                      utils.arraySet(
                        state.head.extra,
                        input,
                        next,
                        // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy,
                        /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                        len
                      );
                    }
                    if (state.flags & 512) {
                      state.check = crc32(state.check, input, copy, next);
                    }
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                  }
                  if (state.length) {
                    break inf_leave;
                  }
                }
                state.length = 0;
                state.mode = NAME;
              case NAME:
                if (state.flags & 2048) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  copy = 0;
                  do {
                    len = input[next + copy++];
                    if (state.head && len && state.length < 65536) {
                      state.head.name += String.fromCharCode(len);
                    }
                  } while (len && copy < have);
                  if (state.flags & 512) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  if (len) {
                    break inf_leave;
                  }
                } else if (state.head) {
                  state.head.name = null;
                }
                state.length = 0;
                state.mode = COMMENT;
              case COMMENT:
                if (state.flags & 4096) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  copy = 0;
                  do {
                    len = input[next + copy++];
                    if (state.head && len && state.length < 65536) {
                      state.head.comment += String.fromCharCode(len);
                    }
                  } while (len && copy < have);
                  if (state.flags & 512) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  if (len) {
                    break inf_leave;
                  }
                } else if (state.head) {
                  state.head.comment = null;
                }
                state.mode = HCRC;
              case HCRC:
                if (state.flags & 512) {
                  while (bits2 < 16) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  if (hold !== (state.check & 65535)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                  }
                  hold = 0;
                  bits2 = 0;
                }
                if (state.head) {
                  state.head.hcrc = state.flags >> 9 & 1;
                  state.head.done = true;
                }
                strm.adler = state.check = 0;
                state.mode = TYPE;
                break;
              case DICTID:
                while (bits2 < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                strm.adler = state.check = zswap32(hold);
                hold = 0;
                bits2 = 0;
                state.mode = DICT;
              case DICT:
                if (state.havedict === 0) {
                  strm.next_out = put;
                  strm.avail_out = left;
                  strm.next_in = next;
                  strm.avail_in = have;
                  state.hold = hold;
                  state.bits = bits2;
                  return Z_NEED_DICT;
                }
                strm.adler = state.check = 1;
                state.mode = TYPE;
              case TYPE:
                if (flush === Z_BLOCK || flush === Z_TREES) {
                  break inf_leave;
                }
              case TYPEDO:
                if (state.last) {
                  hold >>>= bits2 & 7;
                  bits2 -= bits2 & 7;
                  state.mode = CHECK;
                  break;
                }
                while (bits2 < 3) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                state.last = hold & 1;
                hold >>>= 1;
                bits2 -= 1;
                switch (hold & 3) {
                  case 0:
                    state.mode = STORED;
                    break;
                  case 1:
                    fixedtables(state);
                    state.mode = LEN_;
                    if (flush === Z_TREES) {
                      hold >>>= 2;
                      bits2 -= 2;
                      break inf_leave;
                    }
                    break;
                  case 2:
                    state.mode = TABLE;
                    break;
                  case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
                }
                hold >>>= 2;
                bits2 -= 2;
                break;
              case STORED:
                hold >>>= bits2 & 7;
                bits2 -= bits2 & 7;
                while (bits2 < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                if ((hold & 65535) !== (hold >>> 16 ^ 65535)) {
                  strm.msg = "invalid stored block lengths";
                  state.mode = BAD;
                  break;
                }
                state.length = hold & 65535;
                hold = 0;
                bits2 = 0;
                state.mode = COPY_;
                if (flush === Z_TREES) {
                  break inf_leave;
                }
              case COPY_:
                state.mode = COPY;
              case COPY:
                copy = state.length;
                if (copy) {
                  if (copy > have) {
                    copy = have;
                  }
                  if (copy > left) {
                    copy = left;
                  }
                  if (copy === 0) {
                    break inf_leave;
                  }
                  utils.arraySet(output3, input, next, copy, put);
                  have -= copy;
                  next += copy;
                  left -= copy;
                  put += copy;
                  state.length -= copy;
                  break;
                }
                state.mode = TYPE;
                break;
              case TABLE:
                while (bits2 < 14) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                state.nlen = (hold & 31) + 257;
                hold >>>= 5;
                bits2 -= 5;
                state.ndist = (hold & 31) + 1;
                hold >>>= 5;
                bits2 -= 5;
                state.ncode = (hold & 15) + 4;
                hold >>>= 4;
                bits2 -= 4;
                if (state.nlen > 286 || state.ndist > 30) {
                  strm.msg = "too many length or distance symbols";
                  state.mode = BAD;
                  break;
                }
                state.have = 0;
                state.mode = LENLENS;
              case LENLENS:
                while (state.have < state.ncode) {
                  while (bits2 < 3) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  state.lens[order[state.have++]] = hold & 7;
                  hold >>>= 3;
                  bits2 -= 3;
                }
                while (state.have < 19) {
                  state.lens[order[state.have++]] = 0;
                }
                state.lencode = state.lendyn;
                state.lenbits = 7;
                opts = { bits: state.lenbits };
                ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
                state.lenbits = opts.bits;
                if (ret) {
                  strm.msg = "invalid code lengths set";
                  state.mode = BAD;
                  break;
                }
                state.have = 0;
                state.mode = CODELENS;
              case CODELENS:
                while (state.have < state.nlen + state.ndist) {
                  for (; ; ) {
                    here = state.lencode[hold & (1 << state.lenbits) - 1];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 255;
                    here_val = here & 65535;
                    if (here_bits <= bits2) {
                      break;
                    }
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  if (here_val < 16) {
                    hold >>>= here_bits;
                    bits2 -= here_bits;
                    state.lens[state.have++] = here_val;
                  } else {
                    if (here_val === 16) {
                      n2 = here_bits + 2;
                      while (bits2 < n2) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits2;
                        bits2 += 8;
                      }
                      hold >>>= here_bits;
                      bits2 -= here_bits;
                      if (state.have === 0) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                      }
                      len = state.lens[state.have - 1];
                      copy = 3 + (hold & 3);
                      hold >>>= 2;
                      bits2 -= 2;
                    } else if (here_val === 17) {
                      n2 = here_bits + 3;
                      while (bits2 < n2) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits2;
                        bits2 += 8;
                      }
                      hold >>>= here_bits;
                      bits2 -= here_bits;
                      len = 0;
                      copy = 3 + (hold & 7);
                      hold >>>= 3;
                      bits2 -= 3;
                    } else {
                      n2 = here_bits + 7;
                      while (bits2 < n2) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits2;
                        bits2 += 8;
                      }
                      hold >>>= here_bits;
                      bits2 -= here_bits;
                      len = 0;
                      copy = 11 + (hold & 127);
                      hold >>>= 7;
                      bits2 -= 7;
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                      strm.msg = "invalid bit length repeat";
                      state.mode = BAD;
                      break;
                    }
                    while (copy--) {
                      state.lens[state.have++] = len;
                    }
                  }
                }
                if (state.mode === BAD) {
                  break;
                }
                if (state.lens[256] === 0) {
                  strm.msg = "invalid code -- missing end-of-block";
                  state.mode = BAD;
                  break;
                }
                state.lenbits = 9;
                opts = { bits: state.lenbits };
                ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
                state.lenbits = opts.bits;
                if (ret) {
                  strm.msg = "invalid literal/lengths set";
                  state.mode = BAD;
                  break;
                }
                state.distbits = 6;
                state.distcode = state.distdyn;
                opts = { bits: state.distbits };
                ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
                state.distbits = opts.bits;
                if (ret) {
                  strm.msg = "invalid distances set";
                  state.mode = BAD;
                  break;
                }
                state.mode = LEN_;
                if (flush === Z_TREES) {
                  break inf_leave;
                }
              case LEN_:
                state.mode = LEN;
              case LEN:
                if (have >= 6 && left >= 258) {
                  strm.next_out = put;
                  strm.avail_out = left;
                  strm.next_in = next;
                  strm.avail_in = have;
                  state.hold = hold;
                  state.bits = bits2;
                  inflate_fast(strm, _out);
                  put = strm.next_out;
                  output3 = strm.output;
                  left = strm.avail_out;
                  next = strm.next_in;
                  input = strm.input;
                  have = strm.avail_in;
                  hold = state.hold;
                  bits2 = state.bits;
                  if (state.mode === TYPE) {
                    state.back = -1;
                  }
                  break;
                }
                state.back = 0;
                for (; ; ) {
                  here = state.lencode[hold & (1 << state.lenbits) - 1];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 255;
                  here_val = here & 65535;
                  if (here_bits <= bits2) {
                    break;
                  }
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                if (here_op && (here_op & 240) === 0) {
                  last_bits = here_bits;
                  last_op = here_op;
                  last_val = here_val;
                  for (; ; ) {
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 255;
                    here_val = here & 65535;
                    if (last_bits + here_bits <= bits2) {
                      break;
                    }
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  hold >>>= last_bits;
                  bits2 -= last_bits;
                  state.back += last_bits;
                }
                hold >>>= here_bits;
                bits2 -= here_bits;
                state.back += here_bits;
                state.length = here_val;
                if (here_op === 0) {
                  state.mode = LIT;
                  break;
                }
                if (here_op & 32) {
                  state.back = -1;
                  state.mode = TYPE;
                  break;
                }
                if (here_op & 64) {
                  strm.msg = "invalid literal/length code";
                  state.mode = BAD;
                  break;
                }
                state.extra = here_op & 15;
                state.mode = LENEXT;
              case LENEXT:
                if (state.extra) {
                  n2 = state.extra;
                  while (bits2 < n2) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  state.length += hold & (1 << state.extra) - 1;
                  hold >>>= state.extra;
                  bits2 -= state.extra;
                  state.back += state.extra;
                }
                state.was = state.length;
                state.mode = DIST;
              case DIST:
                for (; ; ) {
                  here = state.distcode[hold & (1 << state.distbits) - 1];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 255;
                  here_val = here & 65535;
                  if (here_bits <= bits2) {
                    break;
                  }
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits2;
                  bits2 += 8;
                }
                if ((here_op & 240) === 0) {
                  last_bits = here_bits;
                  last_op = here_op;
                  last_val = here_val;
                  for (; ; ) {
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 255;
                    here_val = here & 65535;
                    if (last_bits + here_bits <= bits2) {
                      break;
                    }
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  hold >>>= last_bits;
                  bits2 -= last_bits;
                  state.back += last_bits;
                }
                hold >>>= here_bits;
                bits2 -= here_bits;
                state.back += here_bits;
                if (here_op & 64) {
                  strm.msg = "invalid distance code";
                  state.mode = BAD;
                  break;
                }
                state.offset = here_val;
                state.extra = here_op & 15;
                state.mode = DISTEXT;
              case DISTEXT:
                if (state.extra) {
                  n2 = state.extra;
                  while (bits2 < n2) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  state.offset += hold & (1 << state.extra) - 1;
                  hold >>>= state.extra;
                  bits2 -= state.extra;
                  state.back += state.extra;
                }
                if (state.offset > state.dmax) {
                  strm.msg = "invalid distance too far back";
                  state.mode = BAD;
                  break;
                }
                state.mode = MATCH;
              case MATCH:
                if (left === 0) {
                  break inf_leave;
                }
                copy = _out - left;
                if (state.offset > copy) {
                  copy = state.offset - copy;
                  if (copy > state.whave) {
                    if (state.sane) {
                      strm.msg = "invalid distance too far back";
                      state.mode = BAD;
                      break;
                    }
                  }
                  if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                  } else {
                    from = state.wnext - copy;
                  }
                  if (copy > state.length) {
                    copy = state.length;
                  }
                  from_source = state.window;
                } else {
                  from_source = output3;
                  from = put - state.offset;
                  copy = state.length;
                }
                if (copy > left) {
                  copy = left;
                }
                left -= copy;
                state.length -= copy;
                do {
                  output3[put++] = from_source[from++];
                } while (--copy);
                if (state.length === 0) {
                  state.mode = LEN;
                }
                break;
              case LIT:
                if (left === 0) {
                  break inf_leave;
                }
                output3[put++] = state.length;
                left--;
                state.mode = LEN;
                break;
              case CHECK:
                if (state.wrap) {
                  while (bits2 < 32) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold |= input[next++] << bits2;
                    bits2 += 8;
                  }
                  _out -= left;
                  strm.total_out += _out;
                  state.total += _out;
                  if (_out) {
                    strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/
                    state.flags ? crc32(state.check, output3, _out, put - _out) : adler32(state.check, output3, _out, put - _out);
                  }
                  _out = left;
                  if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                  }
                  hold = 0;
                  bits2 = 0;
                }
                state.mode = LENGTH;
              case LENGTH:
                if (state.wrap && state.flags) {
                  while (bits2 < 32) {
                    if (have === 0) {
                      break inf_leave;
                    }
                    have--;
                    hold += input[next++] << bits2;
                    bits2 += 8;
                  }
                  if (hold !== (state.total & 4294967295)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                  }
                  hold = 0;
                  bits2 = 0;
                }
                state.mode = DONE;
              case DONE:
                ret = Z_STREAM_END;
                break inf_leave;
              case BAD:
                ret = Z_DATA_ERROR;
                break inf_leave;
              case MEM:
                return Z_MEM_ERROR;
              case SYNC:
              default:
                return Z_STREAM_ERROR;
            }
          }
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits2;
        if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
          if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
          }
        }
        _in -= strm.avail_in;
        _out -= strm.avail_out;
        strm.total_in += _in;
        strm.total_out += _out;
        state.total += _out;
        if (state.wrap && _out) {
          strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
          state.flags ? crc32(state.check, output3, _out, strm.next_out - _out) : adler32(state.check, output3, _out, strm.next_out - _out);
        }
        strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
        if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
          ret = Z_BUF_ERROR;
        }
        return ret;
      }
      function inflateEnd(strm) {
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        var state = strm.state;
        if (state.window) {
          state.window = null;
        }
        strm.state = null;
        return Z_OK;
      }
      function inflateGetHeader(strm, head) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if ((state.wrap & 2) === 0) {
          return Z_STREAM_ERROR;
        }
        state.head = head;
        head.done = false;
        return Z_OK;
      }
      function inflateSetDictionary(strm, dictionary) {
        var dictLength = dictionary.length;
        var state;
        var dictid;
        var ret;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.wrap !== 0 && state.mode !== DICT) {
          return Z_STREAM_ERROR;
        }
        if (state.mode === DICT) {
          dictid = 1;
          dictid = adler32(dictid, dictionary, dictLength, 0);
          if (dictid !== state.check) {
            return Z_DATA_ERROR;
          }
        }
        ret = updatewindow(strm, dictionary, dictLength, dictLength);
        if (ret) {
          state.mode = MEM;
          return Z_MEM_ERROR;
        }
        state.havedict = 1;
        return Z_OK;
      }
      exports2.inflateReset = inflateReset;
      exports2.inflateReset2 = inflateReset2;
      exports2.inflateResetKeep = inflateResetKeep;
      exports2.inflateInit = inflateInit;
      exports2.inflateInit2 = inflateInit2;
      exports2.inflate = inflate;
      exports2.inflateEnd = inflateEnd;
      exports2.inflateGetHeader = inflateGetHeader;
      exports2.inflateSetDictionary = inflateSetDictionary;
      exports2.inflateInfo = "pako inflate (from Nodeca project)";
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/constants.js
  var require_constants2 = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/constants.js"(exports2, module2) {
      "use strict";
      module2.exports = {
        /* Allowed flush values; see deflate() and inflate() below for details */
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        /* Return codes for the compression/decompression functions. Negative values
        * are errors, positive values are used for special but normal events.
        */
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        //Z_MEM_ERROR:     -4,
        Z_BUF_ERROR: -5,
        //Z_VERSION_ERROR: -6,
        /* compression levels */
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        /* Possible values of the data_type field (though see inflate()) */
        Z_BINARY: 0,
        Z_TEXT: 1,
        //Z_ASCII:                1, // = Z_TEXT (deprecated)
        Z_UNKNOWN: 2,
        /* The deflate compression method */
        Z_DEFLATED: 8
        //Z_NULL:                 null // Use -1 or null inline, depending on var type
      };
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/gzheader.js
  var require_gzheader = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/zlib/gzheader.js"(exports2, module2) {
      "use strict";
      function GZheader() {
        this.text = 0;
        this.time = 0;
        this.xflags = 0;
        this.os = 0;
        this.extra = null;
        this.extra_len = 0;
        this.name = "";
        this.comment = "";
        this.hcrc = 0;
        this.done = false;
      }
      module2.exports = GZheader;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/inflate.js
  var require_inflate2 = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/lib/inflate.js"(exports2) {
      "use strict";
      var zlib_inflate = require_inflate();
      var utils = require_common();
      var strings = require_strings();
      var c = require_constants2();
      var msg = require_messages();
      var ZStream = require_zstream();
      var GZheader = require_gzheader();
      var toString3 = Object.prototype.toString;
      function Inflate(options) {
        if (!(this instanceof Inflate)) return new Inflate(options);
        this.options = utils.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ""
        }, options || {});
        var opt = this.options;
        if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
          opt.windowBits = -opt.windowBits;
          if (opt.windowBits === 0) {
            opt.windowBits = -15;
          }
        }
        if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
          opt.windowBits += 32;
        }
        if (opt.windowBits > 15 && opt.windowBits < 48) {
          if ((opt.windowBits & 15) === 0) {
            opt.windowBits |= 15;
          }
        }
        this.err = 0;
        this.msg = "";
        this.ended = false;
        this.chunks = [];
        this.strm = new ZStream();
        this.strm.avail_out = 0;
        var status = zlib_inflate.inflateInit2(
          this.strm,
          opt.windowBits
        );
        if (status !== c.Z_OK) {
          throw new Error(msg[status]);
        }
        this.header = new GZheader();
        zlib_inflate.inflateGetHeader(this.strm, this.header);
        if (opt.dictionary) {
          if (typeof opt.dictionary === "string") {
            opt.dictionary = strings.string2buf(opt.dictionary);
          } else if (toString3.call(opt.dictionary) === "[object ArrayBuffer]") {
            opt.dictionary = new Uint8Array(opt.dictionary);
          }
          if (opt.raw) {
            status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== c.Z_OK) {
              throw new Error(msg[status]);
            }
          }
        }
      }
      Inflate.prototype.push = function(data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var dictionary = this.options.dictionary;
        var status, _mode;
        var next_out_utf8, tail, utf8str;
        var allowBufError = false;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;
        if (typeof data === "string") {
          strm.input = strings.binstring2buf(data);
        } else if (toString3.call(data) === "[object ArrayBuffer]") {
          strm.input = new Uint8Array(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);
          if (status === c.Z_NEED_DICT && dictionary) {
            status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
          }
          if (status === c.Z_BUF_ERROR && allowBufError === true) {
            status = c.Z_OK;
            allowBufError = false;
          }
          if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.next_out) {
            if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH)) {
              if (this.options.to === "string") {
                next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                tail = strm.next_out - next_out_utf8;
                utf8str = strings.buf2string(strm.output, next_out_utf8);
                strm.next_out = tail;
                strm.avail_out = chunkSize - tail;
                if (tail) {
                  utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                }
                this.onData(utf8str);
              } else {
                this.onData(utils.shrinkBuf(strm.output, strm.next_out));
              }
            }
          }
          if (strm.avail_in === 0 && strm.avail_out === 0) {
            allowBufError = true;
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
        if (status === c.Z_STREAM_END) {
          _mode = c.Z_FINISH;
        }
        if (_mode === c.Z_FINISH) {
          status = zlib_inflate.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === c.Z_OK;
        }
        if (_mode === c.Z_SYNC_FLUSH) {
          this.onEnd(c.Z_OK);
          strm.avail_out = 0;
          return true;
        }
        return true;
      };
      Inflate.prototype.onData = function(chunk) {
        this.chunks.push(chunk);
      };
      Inflate.prototype.onEnd = function(status) {
        if (status === c.Z_OK) {
          if (this.options.to === "string") {
            this.result = this.chunks.join("");
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };
      function inflate(input, options) {
        var inflator = new Inflate(options);
        inflator.push(input, true);
        if (inflator.err) {
          throw inflator.msg || msg[inflator.err];
        }
        return inflator.result;
      }
      function inflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return inflate(input, options);
      }
      exports2.Inflate = Inflate;
      exports2.inflate = inflate;
      exports2.inflateRaw = inflateRaw;
      exports2.ungzip = inflate;
    }
  });

  // ../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/index.js
  var require_pako = __commonJS({
    "../../node_modules/.pnpm/pako@1.0.11/node_modules/pako/index.js"(exports2, module2) {
      "use strict";
      var assign2 = require_common().assign;
      var deflate = require_deflate2();
      var inflate = require_inflate2();
      var constants = require_constants2();
      var pako = {};
      assign2(pako, deflate, inflate, constants);
      module2.exports = pako;
    }
  });

  // ../../node_modules/.pnpm/pify@4.0.1/node_modules/pify/index.js
  var require_pify = __commonJS({
    "../../node_modules/.pnpm/pify@4.0.1/node_modules/pify/index.js"(exports2, module2) {
      "use strict";
      var processFn = (fn, options) => function(...args) {
        const P = options.promiseModule;
        return new P((resolve2, reject) => {
          if (options.multiArgs) {
            args.push((...result) => {
              if (options.errorFirst) {
                if (result[0]) {
                  reject(result);
                } else {
                  result.shift();
                  resolve2(result);
                }
              } else {
                resolve2(result);
              }
            });
          } else if (options.errorFirst) {
            args.push((error, result) => {
              if (error) {
                reject(error);
              } else {
                resolve2(result);
              }
            });
          } else {
            args.push(resolve2);
          }
          fn.apply(this, args);
        });
      };
      module2.exports = (input, options) => {
        options = Object.assign({
          exclude: [/.+(Sync|Stream)$/],
          errorFirst: true,
          promiseModule: Promise
        }, options);
        const objType = typeof input;
        if (!(input !== null && (objType === "object" || objType === "function"))) {
          throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${input === null ? "null" : objType}\``);
        }
        const filter2 = (key) => {
          const match = (pattern2) => typeof pattern2 === "string" ? key === pattern2 : pattern2.test(key);
          return options.include ? options.include.some(match) : !options.exclude.some(match);
        };
        let ret;
        if (objType === "function") {
          ret = function(...args) {
            return options.excludeMain ? input(...args) : processFn(input, options).apply(this, args);
          };
        } else {
          ret = Object.create(Object.getPrototypeOf(input));
        }
        for (const key in input) {
          const property = input[key];
          ret[key] = typeof property === "function" && filter2(key) ? processFn(property, options) : property;
        }
        return ret;
      };
    }
  });

  // ../../node_modules/.pnpm/ignore@5.3.2/node_modules/ignore/index.js
  var require_ignore = __commonJS({
    "../../node_modules/.pnpm/ignore@5.3.2/node_modules/ignore/index.js"(exports2, module2) {
      function makeArray(subject) {
        return Array.isArray(subject) ? subject : [subject];
      }
      var EMPTY = "";
      var SPACE = " ";
      var ESCAPE2 = "\\";
      var REGEX_TEST_BLANK_LINE = /^\s+$/;
      var REGEX_INVALID_TRAILING_BACKSLASH = /(?:[^\\]|^)\\$/;
      var REGEX_REPLACE_LEADING_EXCAPED_EXCLAMATION = /^\\!/;
      var REGEX_REPLACE_LEADING_EXCAPED_HASH = /^\\#/;
      var REGEX_SPLITALL_CRLF = /\r?\n/g;
      var REGEX_TEST_INVALID_PATH = /^\.*\/|^\.+$/;
      var SLASH = "/";
      var TMP_KEY_IGNORE = "node-ignore";
      if (typeof Symbol !== "undefined") {
        TMP_KEY_IGNORE = Symbol.for("node-ignore");
      }
      var KEY_IGNORE = TMP_KEY_IGNORE;
      var define2 = (object, key, value) => Object.defineProperty(object, key, { value });
      var REGEX_REGEXP_RANGE = /([0-z])-([0-z])/g;
      var RETURN_FALSE = () => false;
      var sanitizeRange = (range) => range.replace(
        REGEX_REGEXP_RANGE,
        (match, from, to) => from.charCodeAt(0) <= to.charCodeAt(0) ? match : EMPTY
      );
      var cleanRangeBackSlash = (slashes) => {
        const { length: length2 } = slashes;
        return slashes.slice(0, length2 - length2 % 2);
      };
      var REPLACERS = [
        [
          // remove BOM
          // TODO:
          // Other similar zero-width characters?
          /^\uFEFF/,
          () => EMPTY
        ],
        // > Trailing spaces are ignored unless they are quoted with backslash ("\")
        [
          // (a\ ) -> (a )
          // (a  ) -> (a)
          // (a ) -> (a)
          // (a \ ) -> (a  )
          /((?:\\\\)*?)(\\?\s+)$/,
          (_2, m1, m2) => m1 + (m2.indexOf("\\") === 0 ? SPACE : EMPTY)
        ],
        // replace (\ ) with ' '
        // (\ ) -> ' '
        // (\\ ) -> '\\ '
        // (\\\ ) -> '\\ '
        [
          /(\\+?)\s/g,
          (_2, m1) => {
            const { length: length2 } = m1;
            return m1.slice(0, length2 - length2 % 2) + SPACE;
          }
        ],
        // Escape metacharacters
        // which is written down by users but means special for regular expressions.
        // > There are 12 characters with special meanings:
        // > - the backslash \,
        // > - the caret ^,
        // > - the dollar sign $,
        // > - the period or dot .,
        // > - the vertical bar or pipe symbol |,
        // > - the question mark ?,
        // > - the asterisk or star *,
        // > - the plus sign +,
        // > - the opening parenthesis (,
        // > - the closing parenthesis ),
        // > - and the opening square bracket [,
        // > - the opening curly brace {,
        // > These special characters are often called "metacharacters".
        [
          /[\\$.|*+(){^]/g,
          (match) => `\\${match}`
        ],
        [
          // > a question mark (?) matches a single character
          /(?!\\)\?/g,
          () => "[^/]"
        ],
        // leading slash
        [
          // > A leading slash matches the beginning of the pathname.
          // > For example, "/*.c" matches "cat-file.c" but not "mozilla-sha1/sha1.c".
          // A leading slash matches the beginning of the pathname
          /^\//,
          () => "^"
        ],
        // replace special metacharacter slash after the leading slash
        [
          /\//g,
          () => "\\/"
        ],
        [
          // > A leading "**" followed by a slash means match in all directories.
          // > For example, "**/foo" matches file or directory "foo" anywhere,
          // > the same as pattern "foo".
          // > "**/foo/bar" matches file or directory "bar" anywhere that is directly
          // >   under directory "foo".
          // Notice that the '*'s have been replaced as '\\*'
          /^\^*\\\*\\\*\\\//,
          // '**/foo' <-> 'foo'
          () => "^(?:.*\\/)?"
        ],
        // starting
        [
          // there will be no leading '/'
          //   (which has been replaced by section "leading slash")
          // If starts with '**', adding a '^' to the regular expression also works
          /^(?=[^^])/,
          function startingReplacer() {
            return !/\/(?!$)/.test(this) ? "(?:^|\\/)" : "^";
          }
        ],
        // two globstars
        [
          // Use lookahead assertions so that we could match more than one `'/**'`
          /\\\/\\\*\\\*(?=\\\/|$)/g,
          // Zero, one or several directories
          // should not use '*', or it will be replaced by the next replacer
          // Check if it is not the last `'/**'`
          (_2, index2, str) => index2 + 6 < str.length ? "(?:\\/[^\\/]+)*" : "\\/.+"
        ],
        // normal intermediate wildcards
        [
          // Never replace escaped '*'
          // ignore rule '\*' will match the path '*'
          // 'abc.*/' -> go
          // 'abc.*'  -> skip this rule,
          //    coz trailing single wildcard will be handed by [trailing wildcard]
          /(^|[^\\]+)(\\\*)+(?=.+)/g,
          // '*.js' matches '.js'
          // '*.js' doesn't match 'abc'
          (_2, p1, p22) => {
            const unescaped = p22.replace(/\\\*/g, "[^\\/]*");
            return p1 + unescaped;
          }
        ],
        [
          // unescape, revert step 3 except for back slash
          // For example, if a user escape a '\\*',
          // after step 3, the result will be '\\\\\\*'
          /\\\\\\(?=[$.|*+(){^])/g,
          () => ESCAPE2
        ],
        [
          // '\\\\' -> '\\'
          /\\\\/g,
          () => ESCAPE2
        ],
        [
          // > The range notation, e.g. [a-zA-Z],
          // > can be used to match one of the characters in a range.
          // `\` is escaped by step 3
          /(\\)?\[([^\]/]*?)(\\*)($|\])/g,
          (match, leadEscape, range, endEscape, close2) => leadEscape === ESCAPE2 ? `\\[${range}${cleanRangeBackSlash(endEscape)}${close2}` : close2 === "]" ? endEscape.length % 2 === 0 ? `[${sanitizeRange(range)}${endEscape}]` : "[]" : "[]"
        ],
        // ending
        [
          // 'js' will not match 'js.'
          // 'ab' will not match 'abc'
          /(?:[^*])$/,
          // WTF!
          // https://git-scm.com/docs/gitignore
          // changes in [2.22.1](https://git-scm.com/docs/gitignore/2.22.1)
          // which re-fixes #24, #38
          // > If there is a separator at the end of the pattern then the pattern
          // > will only match directories, otherwise the pattern can match both
          // > files and directories.
          // 'js*' will not match 'a.js'
          // 'js/' will not match 'a.js'
          // 'js' will match 'a.js' and 'a.js/'
          (match) => /\/$/.test(match) ? `${match}$` : `${match}(?=$|\\/$)`
        ],
        // trailing wildcard
        [
          /(\^|\\\/)?\\\*$/,
          (_2, p1) => {
            const prefix = p1 ? `${p1}[^/]+` : "[^/]*";
            return `${prefix}(?=$|\\/$)`;
          }
        ]
      ];
      var regexCache = /* @__PURE__ */ Object.create(null);
      var makeRegex = (pattern2, ignoreCase) => {
        let source = regexCache[pattern2];
        if (!source) {
          source = REPLACERS.reduce(
            (prev, [matcher, replacer]) => prev.replace(matcher, replacer.bind(pattern2)),
            pattern2
          );
          regexCache[pattern2] = source;
        }
        return ignoreCase ? new RegExp(source, "i") : new RegExp(source);
      };
      var isString3 = (subject) => typeof subject === "string";
      var checkPattern = (pattern2) => pattern2 && isString3(pattern2) && !REGEX_TEST_BLANK_LINE.test(pattern2) && !REGEX_INVALID_TRAILING_BACKSLASH.test(pattern2) && pattern2.indexOf("#") !== 0;
      var splitPattern = (pattern2) => pattern2.split(REGEX_SPLITALL_CRLF);
      var IgnoreRule = class {
        constructor(origin, pattern2, negative, regex) {
          this.origin = origin;
          this.pattern = pattern2;
          this.negative = negative;
          this.regex = regex;
        }
      };
      var createRule = (pattern2, ignoreCase) => {
        const origin = pattern2;
        let negative = false;
        if (pattern2.indexOf("!") === 0) {
          negative = true;
          pattern2 = pattern2.substr(1);
        }
        pattern2 = pattern2.replace(REGEX_REPLACE_LEADING_EXCAPED_EXCLAMATION, "!").replace(REGEX_REPLACE_LEADING_EXCAPED_HASH, "#");
        const regex = makeRegex(pattern2, ignoreCase);
        return new IgnoreRule(
          origin,
          pattern2,
          negative,
          regex
        );
      };
      var throwError = (message, Ctor) => {
        throw new Ctor(message);
      };
      var checkPath = (path3, originalPath, doThrow) => {
        if (!isString3(path3)) {
          return doThrow(
            `path must be a string, but got \`${originalPath}\``,
            TypeError
          );
        }
        if (!path3) {
          return doThrow(`path must not be empty`, TypeError);
        }
        if (checkPath.isNotRelative(path3)) {
          const r2 = "`path.relative()`d";
          return doThrow(
            `path should be a ${r2} string, but got "${originalPath}"`,
            RangeError
          );
        }
        return true;
      };
      var isNotRelative = (path3) => REGEX_TEST_INVALID_PATH.test(path3);
      checkPath.isNotRelative = isNotRelative;
      checkPath.convert = (p12) => p12;
      var Ignore = class {
        constructor({
          ignorecase = true,
          ignoreCase = ignorecase,
          allowRelativePaths = false
        } = {}) {
          define2(this, KEY_IGNORE, true);
          this._rules = [];
          this._ignoreCase = ignoreCase;
          this._allowRelativePaths = allowRelativePaths;
          this._initCache();
        }
        _initCache() {
          this._ignoreCache = /* @__PURE__ */ Object.create(null);
          this._testCache = /* @__PURE__ */ Object.create(null);
        }
        _addPattern(pattern2) {
          if (pattern2 && pattern2[KEY_IGNORE]) {
            this._rules = this._rules.concat(pattern2._rules);
            this._added = true;
            return;
          }
          if (checkPattern(pattern2)) {
            const rule = createRule(pattern2, this._ignoreCase);
            this._added = true;
            this._rules.push(rule);
          }
        }
        // @param {Array<string> | string | Ignore} pattern
        add(pattern2) {
          this._added = false;
          makeArray(
            isString3(pattern2) ? splitPattern(pattern2) : pattern2
          ).forEach(this._addPattern, this);
          if (this._added) {
            this._initCache();
          }
          return this;
        }
        // legacy
        addPattern(pattern2) {
          return this.add(pattern2);
        }
        //          |           ignored : unignored
        // negative |   0:0   |   0:1   |   1:0   |   1:1
        // -------- | ------- | ------- | ------- | --------
        //     0    |  TEST   |  TEST   |  SKIP   |    X
        //     1    |  TESTIF |  SKIP   |  TEST   |    X
        // - SKIP: always skip
        // - TEST: always test
        // - TESTIF: only test if checkUnignored
        // - X: that never happen
        // @param {boolean} whether should check if the path is unignored,
        //   setting `checkUnignored` to `false` could reduce additional
        //   path matching.
        // @returns {TestResult} true if a file is ignored
        _testOne(path3, checkUnignored) {
          let ignored = false;
          let unignored = false;
          this._rules.forEach((rule) => {
            const { negative } = rule;
            if (unignored === negative && ignored !== unignored || negative && !ignored && !unignored && !checkUnignored) {
              return;
            }
            const matched = rule.regex.test(path3);
            if (matched) {
              ignored = !negative;
              unignored = negative;
            }
          });
          return {
            ignored,
            unignored
          };
        }
        // @returns {TestResult}
        _test(originalPath, cache2, checkUnignored, slices) {
          const path3 = originalPath && checkPath.convert(originalPath);
          checkPath(
            path3,
            originalPath,
            this._allowRelativePaths ? RETURN_FALSE : throwError
          );
          return this._t(path3, cache2, checkUnignored, slices);
        }
        _t(path3, cache2, checkUnignored, slices) {
          if (path3 in cache2) {
            return cache2[path3];
          }
          if (!slices) {
            slices = path3.split(SLASH);
          }
          slices.pop();
          if (!slices.length) {
            return cache2[path3] = this._testOne(path3, checkUnignored);
          }
          const parent = this._t(
            slices.join(SLASH) + SLASH,
            cache2,
            checkUnignored,
            slices
          );
          return cache2[path3] = parent.ignored ? parent : this._testOne(path3, checkUnignored);
        }
        ignores(path3) {
          return this._test(path3, this._ignoreCache, false).ignored;
        }
        createFilter() {
          return (path3) => !this.ignores(path3);
        }
        filter(paths) {
          return makeArray(paths).filter(this.createFilter());
        }
        // @returns {TestResult}
        test(path3) {
          return this._test(path3, this._testCache, true);
        }
      };
      var factory = (options) => new Ignore(options);
      var isPathValid = (path3) => checkPath(path3 && checkPath.convert(path3), path3, RETURN_FALSE);
      factory.isPathValid = isPathValid;
      factory.default = factory;
      module2.exports = factory;
      if (
        // Detect `process` so that it can run in browsers.
        typeof process !== "undefined" && (process.env && process.env.IGNORE_TEST_WIN32 || process.platform === "win32")
      ) {
        const makePosix = (str) => /^\\\\\?\\/.test(str) || /["<>|\u0000-\u001F]+/u.test(str) ? str : str.replace(/\\/g, "/");
        checkPath.convert = makePosix;
        const REGIX_IS_WINDOWS_PATH_ABSOLUTE = /^[a-z]:\//i;
        checkPath.isNotRelative = (path3) => REGIX_IS_WINDOWS_PATH_ABSOLUTE.test(path3) || isNotRelative(path3);
      }
    }
  });

  // ../../node_modules/.pnpm/clean-git-ref@2.0.1/node_modules/clean-git-ref/lib/index.js
  var require_lib2 = __commonJS({
    "../../node_modules/.pnpm/clean-git-ref@2.0.1/node_modules/clean-git-ref/lib/index.js"(exports2, module2) {
      "use strict";
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function replaceAll(str, search, replacement) {
        search = search instanceof RegExp ? search : new RegExp(escapeRegExp(search), "g");
        return str.replace(search, replacement);
      }
      var CleanGitRef = {
        clean: function clean(value) {
          if (typeof value !== "string") {
            throw new Error("Expected a string, received: " + value);
          }
          value = replaceAll(value, "./", "/");
          value = replaceAll(value, "..", ".");
          value = replaceAll(value, " ", "-");
          value = replaceAll(value, /^[~^:?*\\\-]/g, "");
          value = replaceAll(value, /[~^:?*\\]/g, "-");
          value = replaceAll(value, /[~^:?*\\\-]$/g, "");
          value = replaceAll(value, "@{", "-");
          value = replaceAll(value, /\.$/g, "");
          value = replaceAll(value, /\/$/g, "");
          value = replaceAll(value, /\.lock$/g, "");
          return value;
        }
      };
      module2.exports = CleanGitRef;
    }
  });

  // ../../node_modules/.pnpm/diff3@0.0.3/node_modules/diff3/onp.js
  var require_onp = __commonJS({
    "../../node_modules/.pnpm/diff3@0.0.3/node_modules/diff3/onp.js"(exports2, module2) {
      module2.exports = function(a_, b_) {
        var a = a_, b = b_, m = a.length, n2 = b.length, reverse = false, ed = null, offset = m + 1, path3 = [], pathposi = [], ses = [], lcs = "", SES_DELETE = -1, SES_COMMON = 0, SES_ADD = 1;
        var tmp1, tmp2;
        var init3 = function() {
          if (m >= n2) {
            tmp1 = a;
            tmp2 = m;
            a = b;
            b = tmp1;
            m = n2;
            n2 = tmp2;
            reverse = true;
            offset = m + 1;
          }
        };
        var P = function(x, y, k) {
          return {
            "x": x,
            "y": y,
            "k": k
          };
        };
        var seselem = function(elem, t2) {
          return {
            "elem": elem,
            "t": t2
          };
        };
        var snake = function(k, p12, pp) {
          var r2, x, y;
          if (p12 > pp) {
            r2 = path3[k - 1 + offset];
          } else {
            r2 = path3[k + 1 + offset];
          }
          y = Math.max(p12, pp);
          x = y - k;
          while (x < m && y < n2 && a[x] === b[y]) {
            ++x;
            ++y;
          }
          path3[k + offset] = pathposi.length;
          pathposi[pathposi.length] = new P(x, y, r2);
          return y;
        };
        var recordseq = function(epc) {
          var x_idx, y_idx, px_idx, py_idx, i2;
          x_idx = y_idx = 1;
          px_idx = py_idx = 0;
          for (i2 = epc.length - 1; i2 >= 0; --i2) {
            while (px_idx < epc[i2].x || py_idx < epc[i2].y) {
              if (epc[i2].y - epc[i2].x > py_idx - px_idx) {
                if (reverse) {
                  ses[ses.length] = new seselem(b[py_idx], SES_DELETE);
                } else {
                  ses[ses.length] = new seselem(b[py_idx], SES_ADD);
                }
                ++y_idx;
                ++py_idx;
              } else if (epc[i2].y - epc[i2].x < py_idx - px_idx) {
                if (reverse) {
                  ses[ses.length] = new seselem(a[px_idx], SES_ADD);
                } else {
                  ses[ses.length] = new seselem(a[px_idx], SES_DELETE);
                }
                ++x_idx;
                ++px_idx;
              } else {
                ses[ses.length] = new seselem(a[px_idx], SES_COMMON);
                lcs += a[px_idx];
                ++x_idx;
                ++y_idx;
                ++px_idx;
                ++py_idx;
              }
            }
          }
        };
        init3();
        return {
          SES_DELETE: -1,
          SES_COMMON: 0,
          SES_ADD: 1,
          editdistance: function() {
            return ed;
          },
          getlcs: function() {
            return lcs;
          },
          getses: function() {
            return ses;
          },
          compose: function() {
            var delta, size, fp, p12, r2, epc, i2, k;
            delta = n2 - m;
            size = m + n2 + 3;
            fp = {};
            for (i2 = 0; i2 < size; ++i2) {
              fp[i2] = -1;
              path3[i2] = -1;
            }
            p12 = -1;
            do {
              ++p12;
              for (k = -p12; k <= delta - 1; ++k) {
                fp[k + offset] = snake(k, fp[k - 1 + offset] + 1, fp[k + 1 + offset]);
              }
              for (k = delta + p12; k >= delta + 1; --k) {
                fp[k + offset] = snake(k, fp[k - 1 + offset] + 1, fp[k + 1 + offset]);
              }
              fp[delta + offset] = snake(delta, fp[delta - 1 + offset] + 1, fp[delta + 1 + offset]);
            } while (fp[delta + offset] !== n2);
            ed = delta + 2 * p12;
            r2 = path3[delta + offset];
            epc = [];
            while (r2 !== -1) {
              epc[epc.length] = new P(pathposi[r2].x, pathposi[r2].y, null);
              r2 = pathposi[r2].k;
            }
            recordseq(epc);
          }
        };
      };
    }
  });

  // ../../node_modules/.pnpm/diff3@0.0.3/node_modules/diff3/diff3.js
  var require_diff3 = __commonJS({
    "../../node_modules/.pnpm/diff3@0.0.3/node_modules/diff3/diff3.js"(exports2, module2) {
      var onp = require_onp();
      function longestCommonSubsequence(file1, file2) {
        var diff = new onp(file1, file2);
        diff.compose();
        var ses = diff.getses();
        var root;
        var prev;
        var file1RevIdx = file1.length - 1, file2RevIdx = file2.length - 1;
        for (var i2 = ses.length - 1; i2 >= 0; --i2) {
          if (ses[i2].t === diff.SES_COMMON) {
            if (prev) {
              prev.chain = {
                file1index: file1RevIdx,
                file2index: file2RevIdx,
                chain: null
              };
              prev = prev.chain;
            } else {
              root = {
                file1index: file1RevIdx,
                file2index: file2RevIdx,
                chain: null
              };
              prev = root;
            }
            file1RevIdx--;
            file2RevIdx--;
          } else if (ses[i2].t === diff.SES_DELETE) {
            file1RevIdx--;
          } else if (ses[i2].t === diff.SES_ADD) {
            file2RevIdx--;
          }
        }
        var tail = {
          file1index: -1,
          file2index: -1,
          chain: null
        };
        if (!prev) {
          return tail;
        }
        prev.chain = tail;
        return root;
      }
      function diffIndices(file1, file2) {
        var result = [];
        var tail1 = file1.length;
        var tail2 = file2.length;
        for (var candidate = longestCommonSubsequence(file1, file2); candidate !== null; candidate = candidate.chain) {
          var mismatchLength1 = tail1 - candidate.file1index - 1;
          var mismatchLength2 = tail2 - candidate.file2index - 1;
          tail1 = candidate.file1index;
          tail2 = candidate.file2index;
          if (mismatchLength1 || mismatchLength2) {
            result.push({
              file1: [tail1 + 1, mismatchLength1],
              file2: [tail2 + 1, mismatchLength2]
            });
          }
        }
        result.reverse();
        return result;
      }
      function diff3MergeIndices(a, o, b) {
        var i2;
        var m1 = diffIndices(o, a);
        var m2 = diffIndices(o, b);
        var hunks = [];
        function addHunk(h, side2) {
          hunks.push([h.file1[0], side2, h.file1[1], h.file2[0], h.file2[1]]);
        }
        for (i2 = 0; i2 < m1.length; i2++) {
          addHunk(m1[i2], 0);
        }
        for (i2 = 0; i2 < m2.length; i2++) {
          addHunk(m2[i2], 2);
        }
        hunks.sort(function(x, y) {
          return x[0] - y[0];
        });
        var result = [];
        var commonOffset = 0;
        function copyCommon(targetOffset) {
          if (targetOffset > commonOffset) {
            result.push([1, commonOffset, targetOffset - commonOffset]);
            commonOffset = targetOffset;
          }
        }
        for (var hunkIndex = 0; hunkIndex < hunks.length; hunkIndex++) {
          var firstHunkIndex = hunkIndex;
          var hunk = hunks[hunkIndex];
          var regionLhs = hunk[0];
          var regionRhs = regionLhs + hunk[2];
          while (hunkIndex < hunks.length - 1) {
            var maybeOverlapping = hunks[hunkIndex + 1];
            var maybeLhs = maybeOverlapping[0];
            if (maybeLhs > regionRhs) break;
            regionRhs = Math.max(regionRhs, maybeLhs + maybeOverlapping[2]);
            hunkIndex++;
          }
          copyCommon(regionLhs);
          if (firstHunkIndex == hunkIndex) {
            if (hunk[4] > 0) {
              result.push([hunk[1], hunk[3], hunk[4]]);
            }
          } else {
            var regions = {
              0: [a.length, -1, o.length, -1],
              2: [b.length, -1, o.length, -1]
            };
            for (i2 = firstHunkIndex; i2 <= hunkIndex; i2++) {
              hunk = hunks[i2];
              var side = hunk[1];
              var r2 = regions[side];
              var oLhs = hunk[0];
              var oRhs = oLhs + hunk[2];
              var abLhs = hunk[3];
              var abRhs = abLhs + hunk[4];
              r2[0] = Math.min(abLhs, r2[0]);
              r2[1] = Math.max(abRhs, r2[1]);
              r2[2] = Math.min(oLhs, r2[2]);
              r2[3] = Math.max(oRhs, r2[3]);
            }
            var aLhs = regions[0][0] + (regionLhs - regions[0][2]);
            var aRhs = regions[0][1] + (regionRhs - regions[0][3]);
            var bLhs = regions[2][0] + (regionLhs - regions[2][2]);
            var bRhs = regions[2][1] + (regionRhs - regions[2][3]);
            result.push([
              -1,
              aLhs,
              aRhs - aLhs,
              regionLhs,
              regionRhs - regionLhs,
              bLhs,
              bRhs - bLhs
            ]);
          }
          commonOffset = regionRhs;
        }
        copyCommon(o.length);
        return result;
      }
      function diff3Merge(a, o, b) {
        var result = [];
        var files = [a, o, b];
        var indices = diff3MergeIndices(a, o, b);
        var okLines = [];
        function flushOk() {
          if (okLines.length) {
            result.push({
              ok: okLines
            });
          }
          okLines = [];
        }
        function pushOk(xs) {
          for (var j = 0; j < xs.length; j++) {
            okLines.push(xs[j]);
          }
        }
        function isTrueConflict(rec) {
          if (rec[2] != rec[6]) return true;
          var aoff = rec[1];
          var boff = rec[5];
          for (var j = 0; j < rec[2]; j++) {
            if (a[j + aoff] != b[j + boff]) return true;
          }
          return false;
        }
        for (var i2 = 0; i2 < indices.length; i2++) {
          var x = indices[i2];
          var side = x[0];
          if (side == -1) {
            if (!isTrueConflict(x)) {
              pushOk(files[0].slice(x[1], x[1] + x[2]));
            } else {
              flushOk();
              result.push({
                conflict: {
                  a: a.slice(x[1], x[1] + x[2]),
                  aIndex: x[1],
                  o: o.slice(x[3], x[3] + x[4]),
                  oIndex: x[3],
                  b: b.slice(x[5], x[5] + x[6]),
                  bIndex: x[5]
                }
              });
            }
          } else {
            pushOk(files[side].slice(x[1], x[1] + x[2]));
          }
        }
        flushOk();
        return result;
      }
      module2.exports = diff3Merge;
    }
  });

  // ../../node_modules/.pnpm/isomorphic-git@1.32.3/node_modules/isomorphic-git/index.cjs
  var require_isomorphic_git = __commonJS({
    "../../node_modules/.pnpm/isomorphic-git@1.32.3/node_modules/isomorphic-git/index.cjs"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      function _interopDefault(ex) {
        return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
      }
      var AsyncLock = _interopDefault(require_async_lock());
      var Hash2 = _interopDefault(require_sha1());
      var pathBrowserify = require_path_browserify();
      var crc32 = _interopDefault(require_crc32());
      var pako = _interopDefault(require_pako());
      var pify = _interopDefault(require_pify());
      var ignore = _interopDefault(require_ignore());
      var cleanGitRef = _interopDefault(require_lib2());
      var diff3Merge = _interopDefault(require_diff3());
      var BaseError2 = class _BaseError extends Error {
        constructor(message) {
          super(message);
          this.caller = "";
        }
        toJSON() {
          return {
            code: this.code,
            data: this.data,
            caller: this.caller,
            message: this.message,
            stack: this.stack
          };
        }
        fromJSON(json) {
          const e2 = new _BaseError(json.message);
          e2.code = json.code;
          e2.data = json.data;
          e2.caller = json.caller;
          e2.stack = json.stack;
          return e2;
        }
        get isIsomorphicGitError() {
          return true;
        }
      };
      var UnmergedPathsError = class _UnmergedPathsError extends BaseError2 {
        /**
         * @param {Array<string>} filepaths
         */
        constructor(filepaths) {
          super(
            `Modifying the index is not possible because you have unmerged files: ${filepaths.toString}. Fix them up in the work tree, and then use 'git add/rm as appropriate to mark resolution and make a commit.`
          );
          this.code = this.name = _UnmergedPathsError.code;
          this.data = { filepaths };
        }
      };
      UnmergedPathsError.code = "UnmergedPathsError";
      var InternalError2 = class _InternalError extends BaseError2 {
        /**
         * @param {string} message
         */
        constructor(message) {
          super(
            `An internal error caused this command to fail. Please file a bug report at https://github.com/isomorphic-git/isomorphic-git/issues with this error message: ${message}`
          );
          this.code = this.name = _InternalError.code;
          this.data = { message };
        }
      };
      InternalError2.code = "InternalError";
      var UnsafeFilepathError = class _UnsafeFilepathError extends BaseError2 {
        /**
         * @param {string} filepath
         */
        constructor(filepath) {
          super(`The filepath "${filepath}" contains unsafe character sequences`);
          this.code = this.name = _UnsafeFilepathError.code;
          this.data = { filepath };
        }
      };
      UnsafeFilepathError.code = "UnsafeFilepathError";
      var BufferCursor = class {
        constructor(buffer) {
          this.buffer = buffer;
          this._start = 0;
        }
        eof() {
          return this._start >= this.buffer.length;
        }
        tell() {
          return this._start;
        }
        seek(n2) {
          this._start = n2;
        }
        slice(n2) {
          const r2 = this.buffer.slice(this._start, this._start + n2);
          this._start += n2;
          return r2;
        }
        toString(enc, length2) {
          const r2 = this.buffer.toString(enc, this._start, this._start + length2);
          this._start += length2;
          return r2;
        }
        write(value, length2, enc) {
          const r2 = this.buffer.write(value, this._start, length2, enc);
          this._start += length2;
          return r2;
        }
        copy(source, start, end) {
          const r2 = source.copy(this.buffer, this._start, start, end);
          this._start += r2;
          return r2;
        }
        readUInt8() {
          const r2 = this.buffer.readUInt8(this._start);
          this._start += 1;
          return r2;
        }
        writeUInt8(value) {
          const r2 = this.buffer.writeUInt8(value, this._start);
          this._start += 1;
          return r2;
        }
        readUInt16BE() {
          const r2 = this.buffer.readUInt16BE(this._start);
          this._start += 2;
          return r2;
        }
        writeUInt16BE(value) {
          const r2 = this.buffer.writeUInt16BE(value, this._start);
          this._start += 2;
          return r2;
        }
        readUInt32BE() {
          const r2 = this.buffer.readUInt32BE(this._start);
          this._start += 4;
          return r2;
        }
        writeUInt32BE(value) {
          const r2 = this.buffer.writeUInt32BE(value, this._start);
          this._start += 4;
          return r2;
        }
      };
      function compareStrings(a, b) {
        return -(a < b) || +(a > b);
      }
      function comparePath(a, b) {
        return compareStrings(a.path, b.path);
      }
      function normalizeMode2(mode) {
        let type = mode > 0 ? mode >> 12 : 0;
        if (type !== 4 && type !== 8 && type !== 10 && type !== 14) {
          type = 8;
        }
        let permissions = mode & 511;
        if (permissions & 73) {
          permissions = 493;
        } else {
          permissions = 420;
        }
        if (type !== 8) permissions = 0;
        return (type << 12) + permissions;
      }
      var MAX_UINT32 = 2 ** 32;
      function SecondsNanoseconds(givenSeconds, givenNanoseconds, milliseconds2, date) {
        if (givenSeconds !== void 0 && givenNanoseconds !== void 0) {
          return [givenSeconds, givenNanoseconds];
        }
        if (milliseconds2 === void 0) {
          milliseconds2 = date.valueOf();
        }
        const seconds2 = Math.floor(milliseconds2 / 1e3);
        const nanoseconds = (milliseconds2 - seconds2 * 1e3) * 1e6;
        return [seconds2, nanoseconds];
      }
      function normalizeStats(e2) {
        const [ctimeSeconds, ctimeNanoseconds] = SecondsNanoseconds(
          e2.ctimeSeconds,
          e2.ctimeNanoseconds,
          e2.ctimeMs,
          e2.ctime
        );
        const [mtimeSeconds, mtimeNanoseconds] = SecondsNanoseconds(
          e2.mtimeSeconds,
          e2.mtimeNanoseconds,
          e2.mtimeMs,
          e2.mtime
        );
        return {
          ctimeSeconds: ctimeSeconds % MAX_UINT32,
          ctimeNanoseconds: ctimeNanoseconds % MAX_UINT32,
          mtimeSeconds: mtimeSeconds % MAX_UINT32,
          mtimeNanoseconds: mtimeNanoseconds % MAX_UINT32,
          dev: e2.dev % MAX_UINT32,
          ino: e2.ino % MAX_UINT32,
          mode: normalizeMode2(e2.mode % MAX_UINT32),
          uid: e2.uid % MAX_UINT32,
          gid: e2.gid % MAX_UINT32,
          // size of -1 happens over a BrowserFS HTTP Backend that doesn't serve Content-Length headers
          // (like the Karma webserver) because BrowserFS HTTP Backend uses HTTP HEAD requests to do fs.stat
          size: e2.size > -1 ? e2.size % MAX_UINT32 : 0
        };
      }
      function toHex2(buffer) {
        let hex = "";
        for (const byte of new Uint8Array(buffer)) {
          if (byte < 16) hex += "0";
          hex += byte.toString(16);
        }
        return hex;
      }
      var supportsSubtleSHA1 = null;
      async function shasum(buffer) {
        if (supportsSubtleSHA1 === null) {
          supportsSubtleSHA1 = await testSubtleSHA1();
        }
        return supportsSubtleSHA1 ? subtleSHA1(buffer) : shasumSync(buffer);
      }
      function shasumSync(buffer) {
        return new Hash2().update(buffer).digest("hex");
      }
      async function subtleSHA1(buffer) {
        const hash2 = await crypto.subtle.digest("SHA-1", buffer);
        return toHex2(hash2);
      }
      async function testSubtleSHA1() {
        try {
          const hash2 = await subtleSHA1(new Uint8Array([]));
          return hash2 === "da39a3ee5e6b4b0d3255bfef95601890afd80709";
        } catch (_2) {
        }
        return false;
      }
      function parseCacheEntryFlags(bits2) {
        return {
          assumeValid: Boolean(bits2 & 32768),
          extended: Boolean(bits2 & 16384),
          stage: (bits2 & 12288) >> 12,
          nameLength: bits2 & 4095
        };
      }
      function renderCacheEntryFlags(entry) {
        const flags = entry.flags;
        flags.extended = false;
        flags.nameLength = Math.min(Buffer.from(entry.path).length, 4095);
        return (flags.assumeValid ? 32768 : 0) + (flags.extended ? 16384 : 0) + ((flags.stage & 3) << 12) + (flags.nameLength & 4095);
      }
      var GitIndex = class _GitIndex {
        /*::
         _entries: Map<string, CacheEntry>
         _dirty: boolean // Used to determine if index needs to be saved to filesystem
         */
        constructor(entries2, unmergedPaths) {
          this._dirty = false;
          this._unmergedPaths = unmergedPaths || /* @__PURE__ */ new Set();
          this._entries = entries2 || /* @__PURE__ */ new Map();
        }
        _addEntry(entry) {
          if (entry.flags.stage === 0) {
            entry.stages = [entry];
            this._entries.set(entry.path, entry);
            this._unmergedPaths.delete(entry.path);
          } else {
            let existingEntry = this._entries.get(entry.path);
            if (!existingEntry) {
              this._entries.set(entry.path, entry);
              existingEntry = entry;
            }
            existingEntry.stages[entry.flags.stage] = entry;
            this._unmergedPaths.add(entry.path);
          }
        }
        static async from(buffer) {
          if (Buffer.isBuffer(buffer)) {
            return _GitIndex.fromBuffer(buffer);
          } else if (buffer === null) {
            return new _GitIndex(null);
          } else {
            throw new InternalError2("invalid type passed to GitIndex.from");
          }
        }
        static async fromBuffer(buffer) {
          if (buffer.length === 0) {
            throw new InternalError2("Index file is empty (.git/index)");
          }
          const index3 = new _GitIndex();
          const reader = new BufferCursor(buffer);
          const magic = reader.toString("utf8", 4);
          if (magic !== "DIRC") {
            throw new InternalError2(`Invalid dircache magic file number: ${magic}`);
          }
          const shaComputed = await shasum(buffer.slice(0, -20));
          const shaClaimed = buffer.slice(-20).toString("hex");
          if (shaClaimed !== shaComputed) {
            throw new InternalError2(
              `Invalid checksum in GitIndex buffer: expected ${shaClaimed} but saw ${shaComputed}`
            );
          }
          const version18 = reader.readUInt32BE();
          if (version18 !== 2) {
            throw new InternalError2(`Unsupported dircache version: ${version18}`);
          }
          const numEntries = reader.readUInt32BE();
          let i2 = 0;
          while (!reader.eof() && i2 < numEntries) {
            const entry = {};
            entry.ctimeSeconds = reader.readUInt32BE();
            entry.ctimeNanoseconds = reader.readUInt32BE();
            entry.mtimeSeconds = reader.readUInt32BE();
            entry.mtimeNanoseconds = reader.readUInt32BE();
            entry.dev = reader.readUInt32BE();
            entry.ino = reader.readUInt32BE();
            entry.mode = reader.readUInt32BE();
            entry.uid = reader.readUInt32BE();
            entry.gid = reader.readUInt32BE();
            entry.size = reader.readUInt32BE();
            entry.oid = reader.slice(20).toString("hex");
            const flags = reader.readUInt16BE();
            entry.flags = parseCacheEntryFlags(flags);
            const pathlength = buffer.indexOf(0, reader.tell() + 1) - reader.tell();
            if (pathlength < 1) {
              throw new InternalError2(`Got a path length of: ${pathlength}`);
            }
            entry.path = reader.toString("utf8", pathlength);
            if (entry.path.includes("..\\") || entry.path.includes("../")) {
              throw new UnsafeFilepathError(entry.path);
            }
            let padding = 8 - (reader.tell() - 12) % 8;
            if (padding === 0) padding = 8;
            while (padding--) {
              const tmp = reader.readUInt8();
              if (tmp !== 0) {
                throw new InternalError2(
                  `Expected 1-8 null characters but got '${tmp}' after ${entry.path}`
                );
              } else if (reader.eof()) {
                throw new InternalError2("Unexpected end of file");
              }
            }
            entry.stages = [];
            index3._addEntry(entry);
            i2++;
          }
          return index3;
        }
        get unmergedPaths() {
          return [...this._unmergedPaths];
        }
        get entries() {
          return [...this._entries.values()].sort(comparePath);
        }
        get entriesMap() {
          return this._entries;
        }
        get entriesFlat() {
          return [...this.entries].flatMap((entry) => {
            return entry.stages.length > 1 ? entry.stages.filter((x) => x) : entry;
          });
        }
        *[Symbol.iterator]() {
          for (const entry of this.entries) {
            yield entry;
          }
        }
        insert({ filepath, stats, oid, stage = 0 }) {
          if (!stats) {
            stats = {
              ctimeSeconds: 0,
              ctimeNanoseconds: 0,
              mtimeSeconds: 0,
              mtimeNanoseconds: 0,
              dev: 0,
              ino: 0,
              mode: 0,
              uid: 0,
              gid: 0,
              size: 0
            };
          }
          stats = normalizeStats(stats);
          const bfilepath = Buffer.from(filepath);
          const entry = {
            ctimeSeconds: stats.ctimeSeconds,
            ctimeNanoseconds: stats.ctimeNanoseconds,
            mtimeSeconds: stats.mtimeSeconds,
            mtimeNanoseconds: stats.mtimeNanoseconds,
            dev: stats.dev,
            ino: stats.ino,
            // We provide a fallback value for `mode` here because not all fs
            // implementations assign it, but we use it in GitTree.
            // '100644' is for a "regular non-executable file"
            mode: stats.mode || 33188,
            uid: stats.uid,
            gid: stats.gid,
            size: stats.size,
            path: filepath,
            oid,
            flags: {
              assumeValid: false,
              extended: false,
              stage,
              nameLength: bfilepath.length < 4095 ? bfilepath.length : 4095
            },
            stages: []
          };
          this._addEntry(entry);
          this._dirty = true;
        }
        delete({ filepath }) {
          if (this._entries.has(filepath)) {
            this._entries.delete(filepath);
          } else {
            for (const key of this._entries.keys()) {
              if (key.startsWith(filepath + "/")) {
                this._entries.delete(key);
              }
            }
          }
          if (this._unmergedPaths.has(filepath)) {
            this._unmergedPaths.delete(filepath);
          }
          this._dirty = true;
        }
        clear() {
          this._entries.clear();
          this._dirty = true;
        }
        has({ filepath }) {
          return this._entries.has(filepath);
        }
        render() {
          return this.entries.map((entry) => `${entry.mode.toString(8)} ${entry.oid}    ${entry.path}`).join("\n");
        }
        static async _entryToBuffer(entry) {
          const bpath = Buffer.from(entry.path);
          const length2 = Math.ceil((62 + bpath.length + 1) / 8) * 8;
          const written = Buffer.alloc(length2);
          const writer = new BufferCursor(written);
          const stat3 = normalizeStats(entry);
          writer.writeUInt32BE(stat3.ctimeSeconds);
          writer.writeUInt32BE(stat3.ctimeNanoseconds);
          writer.writeUInt32BE(stat3.mtimeSeconds);
          writer.writeUInt32BE(stat3.mtimeNanoseconds);
          writer.writeUInt32BE(stat3.dev);
          writer.writeUInt32BE(stat3.ino);
          writer.writeUInt32BE(stat3.mode);
          writer.writeUInt32BE(stat3.uid);
          writer.writeUInt32BE(stat3.gid);
          writer.writeUInt32BE(stat3.size);
          writer.write(entry.oid, 20, "hex");
          writer.writeUInt16BE(renderCacheEntryFlags(entry));
          writer.write(entry.path, bpath.length, "utf8");
          return written;
        }
        async toObject() {
          const header = Buffer.alloc(12);
          const writer = new BufferCursor(header);
          writer.write("DIRC", 4, "utf8");
          writer.writeUInt32BE(2);
          writer.writeUInt32BE(this.entriesFlat.length);
          let entryBuffers = [];
          for (const entry of this.entries) {
            entryBuffers.push(_GitIndex._entryToBuffer(entry));
            if (entry.stages.length > 1) {
              for (const stage of entry.stages) {
                if (stage && stage !== entry) {
                  entryBuffers.push(_GitIndex._entryToBuffer(stage));
                }
              }
            }
          }
          entryBuffers = await Promise.all(entryBuffers);
          const body = Buffer.concat(entryBuffers);
          const main = Buffer.concat([header, body]);
          const sum = await shasum(main);
          return Buffer.concat([main, Buffer.from(sum, "hex")]);
        }
      };
      function compareStats(entry, stats, filemode = true, trustino = true) {
        const e2 = normalizeStats(entry);
        const s2 = normalizeStats(stats);
        const staleness = filemode && e2.mode !== s2.mode || e2.mtimeSeconds !== s2.mtimeSeconds || e2.ctimeSeconds !== s2.ctimeSeconds || e2.uid !== s2.uid || e2.gid !== s2.gid || trustino && e2.ino !== s2.ino || e2.size !== s2.size;
        return staleness;
      }
      var lock = null;
      var IndexCache = Symbol("IndexCache");
      function createCache() {
        return {
          map: /* @__PURE__ */ new Map(),
          stats: /* @__PURE__ */ new Map()
        };
      }
      async function updateCachedIndexFile(fs2, filepath, cache2) {
        const [stat3, rawIndexFile] = await Promise.all([
          fs2.lstat(filepath),
          fs2.read(filepath)
        ]);
        const index3 = await GitIndex.from(rawIndexFile);
        cache2.map.set(filepath, index3);
        cache2.stats.set(filepath, stat3);
      }
      async function isIndexStale(fs2, filepath, cache2) {
        const savedStats = cache2.stats.get(filepath);
        if (savedStats === void 0) return true;
        if (savedStats === null) return false;
        const currStats = await fs2.lstat(filepath);
        if (currStats === null) return false;
        return compareStats(savedStats, currStats);
      }
      var GitIndexManager = class {
        /**
         *
         * @param {object} opts
         * @param {import('../models/FileSystem.js').FileSystem} opts.fs
         * @param {string} opts.gitdir
         * @param {object} opts.cache
         * @param {bool} opts.allowUnmerged
         * @param {function(GitIndex): any} closure
         */
        static async acquire({ fs: fs2, gitdir, cache: cache2, allowUnmerged = true }, closure) {
          if (!cache2[IndexCache]) {
            cache2[IndexCache] = createCache();
          }
          const filepath = `${gitdir}/index`;
          if (lock === null) lock = new AsyncLock({ maxPending: Infinity });
          let result;
          let unmergedPaths = [];
          await lock.acquire(filepath, async () => {
            const theIndexCache = cache2[IndexCache];
            if (await isIndexStale(fs2, filepath, theIndexCache)) {
              await updateCachedIndexFile(fs2, filepath, theIndexCache);
            }
            const index3 = theIndexCache.map.get(filepath);
            unmergedPaths = index3.unmergedPaths;
            if (unmergedPaths.length && !allowUnmerged)
              throw new UnmergedPathsError(unmergedPaths);
            result = await closure(index3);
            if (index3._dirty) {
              const buffer = await index3.toObject();
              await fs2.write(filepath, buffer);
              theIndexCache.stats.set(filepath, await fs2.lstat(filepath));
              index3._dirty = false;
            }
          });
          return result;
        }
      };
      function basename2(path3) {
        const last = Math.max(path3.lastIndexOf("/"), path3.lastIndexOf("\\"));
        if (last > -1) {
          path3 = path3.slice(last + 1);
        }
        return path3;
      }
      function dirname3(path3) {
        const last = Math.max(path3.lastIndexOf("/"), path3.lastIndexOf("\\"));
        if (last === -1) return ".";
        if (last === 0) return "/";
        return path3.slice(0, last);
      }
      function flatFileListToDirectoryStructure(files) {
        const inodes = /* @__PURE__ */ new Map();
        const mkdir3 = function(name2) {
          if (!inodes.has(name2)) {
            const dir = {
              type: "tree",
              fullpath: name2,
              basename: basename2(name2),
              metadata: {},
              children: []
            };
            inodes.set(name2, dir);
            dir.parent = mkdir3(dirname3(name2));
            if (dir.parent && dir.parent !== dir) dir.parent.children.push(dir);
          }
          return inodes.get(name2);
        };
        const mkfile = function(name2, metadata) {
          if (!inodes.has(name2)) {
            const file = {
              type: "blob",
              fullpath: name2,
              basename: basename2(name2),
              metadata,
              // This recursively generates any missing parent folders.
              parent: mkdir3(dirname3(name2)),
              children: []
            };
            if (file.parent) file.parent.children.push(file);
            inodes.set(name2, file);
          }
          return inodes.get(name2);
        };
        mkdir3(".");
        for (const file of files) {
          mkfile(file.path, file);
        }
        return inodes;
      }
      function mode2type(mode) {
        switch (mode) {
          case 16384:
            return "tree";
          case 33188:
            return "blob";
          case 33261:
            return "blob";
          case 40960:
            return "blob";
          case 57344:
            return "commit";
        }
        throw new InternalError2(`Unexpected GitTree entry mode: ${mode.toString(8)}`);
      }
      var GitWalkerIndex = class {
        constructor({ fs: fs2, gitdir, cache: cache2 }) {
          this.treePromise = GitIndexManager.acquire(
            { fs: fs2, gitdir, cache: cache2 },
            async function(index3) {
              return flatFileListToDirectoryStructure(index3.entries);
            }
          );
          const walker = this;
          this.ConstructEntry = class StageEntry {
            constructor(fullpath) {
              this._fullpath = fullpath;
              this._type = false;
              this._mode = false;
              this._stat = false;
              this._oid = false;
            }
            async type() {
              return walker.type(this);
            }
            async mode() {
              return walker.mode(this);
            }
            async stat() {
              return walker.stat(this);
            }
            async content() {
              return walker.content(this);
            }
            async oid() {
              return walker.oid(this);
            }
          };
        }
        async readdir(entry) {
          const filepath = entry._fullpath;
          const tree = await this.treePromise;
          const inode = tree.get(filepath);
          if (!inode) return null;
          if (inode.type === "blob") return null;
          if (inode.type !== "tree") {
            throw new Error(`ENOTDIR: not a directory, scandir '${filepath}'`);
          }
          const names = inode.children.map((inode2) => inode2.fullpath);
          names.sort(compareStrings);
          return names;
        }
        async type(entry) {
          if (entry._type === false) {
            await entry.stat();
          }
          return entry._type;
        }
        async mode(entry) {
          if (entry._mode === false) {
            await entry.stat();
          }
          return entry._mode;
        }
        async stat(entry) {
          if (entry._stat === false) {
            const tree = await this.treePromise;
            const inode = tree.get(entry._fullpath);
            if (!inode) {
              throw new Error(
                `ENOENT: no such file or directory, lstat '${entry._fullpath}'`
              );
            }
            const stats = inode.type === "tree" ? {} : normalizeStats(inode.metadata);
            entry._type = inode.type === "tree" ? "tree" : mode2type(stats.mode);
            entry._mode = stats.mode;
            if (inode.type === "tree") {
              entry._stat = void 0;
            } else {
              entry._stat = stats;
            }
          }
          return entry._stat;
        }
        async content(_entry) {
        }
        async oid(entry) {
          if (entry._oid === false) {
            const tree = await this.treePromise;
            const inode = tree.get(entry._fullpath);
            entry._oid = inode.metadata.oid;
          }
          return entry._oid;
        }
      };
      var GitWalkSymbol = Symbol("GitWalkSymbol");
      function STAGE() {
        const o = /* @__PURE__ */ Object.create(null);
        Object.defineProperty(o, GitWalkSymbol, {
          value: function({ fs: fs2, gitdir, cache: cache2 }) {
            return new GitWalkerIndex({ fs: fs2, gitdir, cache: cache2 });
          }
        });
        Object.freeze(o);
        return o;
      }
      var NotFoundError = class _NotFoundError extends BaseError2 {
        /**
         * @param {string} what
         */
        constructor(what) {
          super(`Could not find ${what}.`);
          this.code = this.name = _NotFoundError.code;
          this.data = { what };
        }
      };
      NotFoundError.code = "NotFoundError";
      var ObjectTypeError = class _ObjectTypeError extends BaseError2 {
        /**
         * @param {string} oid
         * @param {'blob'|'commit'|'tag'|'tree'} actual
         * @param {'blob'|'commit'|'tag'|'tree'} expected
         * @param {string} [filepath]
         */
        constructor(oid, actual, expected, filepath) {
          super(
            `Object ${oid} ${filepath ? `at ${filepath}` : ""}was anticipated to be a ${expected} but it is a ${actual}.`
          );
          this.code = this.name = _ObjectTypeError.code;
          this.data = { oid, actual, expected, filepath };
        }
      };
      ObjectTypeError.code = "ObjectTypeError";
      var InvalidOidError = class _InvalidOidError extends BaseError2 {
        /**
         * @param {string} value
         */
        constructor(value) {
          super(`Expected a 40-char hex object id but saw "${value}".`);
          this.code = this.name = _InvalidOidError.code;
          this.data = { value };
        }
      };
      InvalidOidError.code = "InvalidOidError";
      var NoRefspecError = class _NoRefspecError extends BaseError2 {
        /**
         * @param {string} remote
         */
        constructor(remote) {
          super(`Could not find a fetch refspec for remote "${remote}". Make sure the config file has an entry like the following:
[remote "${remote}"]
	fetch = +refs/heads/*:refs/remotes/origin/*
`);
          this.code = this.name = _NoRefspecError.code;
          this.data = { remote };
        }
      };
      NoRefspecError.code = "NoRefspecError";
      var GitPackedRefs = class _GitPackedRefs {
        constructor(text) {
          this.refs = /* @__PURE__ */ new Map();
          this.parsedConfig = [];
          if (text) {
            let key = null;
            this.parsedConfig = text.trim().split("\n").map((line) => {
              if (/^\s*#/.test(line)) {
                return { line, comment: true };
              }
              const i2 = line.indexOf(" ");
              if (line.startsWith("^")) {
                const value = line.slice(1);
                this.refs.set(key + "^{}", value);
                return { line, ref: key, peeled: value };
              } else {
                const value = line.slice(0, i2);
                key = line.slice(i2 + 1);
                this.refs.set(key, value);
                return { line, ref: key, oid: value };
              }
            });
          }
          return this;
        }
        static from(text) {
          return new _GitPackedRefs(text);
        }
        delete(ref) {
          this.parsedConfig = this.parsedConfig.filter((entry) => entry.ref !== ref);
          this.refs.delete(ref);
        }
        toString() {
          return this.parsedConfig.map(({ line }) => line).join("\n") + "\n";
        }
      };
      var GitRefSpec = class _GitRefSpec {
        constructor({ remotePath, localPath, force, matchPrefix }) {
          Object.assign(this, {
            remotePath,
            localPath,
            force,
            matchPrefix
          });
        }
        static from(refspec) {
          const [
            forceMatch,
            remotePath,
            remoteGlobMatch,
            localPath,
            localGlobMatch
          ] = refspec.match(/^(\+?)(.*?)(\*?):(.*?)(\*?)$/).slice(1);
          const force = forceMatch === "+";
          const remoteIsGlob = remoteGlobMatch === "*";
          const localIsGlob = localGlobMatch === "*";
          if (remoteIsGlob !== localIsGlob) {
            throw new InternalError2("Invalid refspec");
          }
          return new _GitRefSpec({
            remotePath,
            localPath,
            force,
            matchPrefix: remoteIsGlob
          });
        }
        translate(remoteBranch) {
          if (this.matchPrefix) {
            if (remoteBranch.startsWith(this.remotePath)) {
              return this.localPath + remoteBranch.replace(this.remotePath, "");
            }
          } else {
            if (remoteBranch === this.remotePath) return this.localPath;
          }
          return null;
        }
        reverseTranslate(localBranch) {
          if (this.matchPrefix) {
            if (localBranch.startsWith(this.localPath)) {
              return this.remotePath + localBranch.replace(this.localPath, "");
            }
          } else {
            if (localBranch === this.localPath) return this.remotePath;
          }
          return null;
        }
      };
      var GitRefSpecSet = class _GitRefSpecSet {
        constructor(rules = []) {
          this.rules = rules;
        }
        static from(refspecs) {
          const rules = [];
          for (const refspec of refspecs) {
            rules.push(GitRefSpec.from(refspec));
          }
          return new _GitRefSpecSet(rules);
        }
        add(refspec) {
          const rule = GitRefSpec.from(refspec);
          this.rules.push(rule);
        }
        translate(remoteRefs) {
          const result = [];
          for (const rule of this.rules) {
            for (const remoteRef of remoteRefs) {
              const localRef = rule.translate(remoteRef);
              if (localRef) {
                result.push([remoteRef, localRef]);
              }
            }
          }
          return result;
        }
        translateOne(remoteRef) {
          let result = null;
          for (const rule of this.rules) {
            const localRef = rule.translate(remoteRef);
            if (localRef) {
              result = localRef;
            }
          }
          return result;
        }
        localNamespaces() {
          return this.rules.filter((rule) => rule.matchPrefix).map((rule) => rule.localPath.replace(/\/$/, ""));
        }
      };
      function compareRefNames(a, b) {
        const _a6 = a.replace(/\^\{\}$/, "");
        const _b3 = b.replace(/\^\{\}$/, "");
        const tmp = -(_a6 < _b3) || +(_a6 > _b3);
        if (tmp === 0) {
          return a.endsWith("^{}") ? 1 : -1;
        }
        return tmp;
      }
      var num = (val) => {
        if (typeof val === "number") {
          return val;
        }
        val = val.toLowerCase();
        let n2 = parseInt(val);
        if (val.endsWith("k")) n2 *= 1024;
        if (val.endsWith("m")) n2 *= 1024 * 1024;
        if (val.endsWith("g")) n2 *= 1024 * 1024 * 1024;
        return n2;
      };
      var bool2 = (val) => {
        if (typeof val === "boolean") {
          return val;
        }
        val = val.trim().toLowerCase();
        if (val === "true" || val === "yes" || val === "on") return true;
        if (val === "false" || val === "no" || val === "off") return false;
        throw Error(
          `Expected 'true', 'false', 'yes', 'no', 'on', or 'off', but got ${val}`
        );
      };
      var schema = {
        core: {
          filemode: bool2,
          bare: bool2,
          logallrefupdates: bool2,
          symlinks: bool2,
          ignorecase: bool2,
          bigFileThreshold: num
        }
      };
      var SECTION_LINE_REGEX = /^\[([A-Za-z0-9-.]+)(?: "(.*)")?\]$/;
      var SECTION_REGEX = /^[A-Za-z0-9-.]+$/;
      var VARIABLE_LINE_REGEX = /^([A-Za-z][A-Za-z-]*)(?: *= *(.*))?$/;
      var VARIABLE_NAME_REGEX = /^[A-Za-z][A-Za-z-]*$/;
      var VARIABLE_VALUE_COMMENT_REGEX = /^(.*?)( *[#;].*)$/;
      var extractSectionLine = (line) => {
        const matches = SECTION_LINE_REGEX.exec(line);
        if (matches != null) {
          const [section, subsection] = matches.slice(1);
          return [section, subsection];
        }
        return null;
      };
      var extractVariableLine = (line) => {
        const matches = VARIABLE_LINE_REGEX.exec(line);
        if (matches != null) {
          const [name2, rawValue = "true"] = matches.slice(1);
          const valueWithoutComments = removeComments(rawValue);
          const valueWithoutQuotes = removeQuotes(valueWithoutComments);
          return [name2, valueWithoutQuotes];
        }
        return null;
      };
      var removeComments = (rawValue) => {
        const commentMatches = VARIABLE_VALUE_COMMENT_REGEX.exec(rawValue);
        if (commentMatches == null) {
          return rawValue;
        }
        const [valueWithoutComment, comment] = commentMatches.slice(1);
        if (hasOddNumberOfQuotes(valueWithoutComment) && hasOddNumberOfQuotes(comment)) {
          return `${valueWithoutComment}${comment}`;
        }
        return valueWithoutComment;
      };
      var hasOddNumberOfQuotes = (text) => {
        const numberOfQuotes = (text.match(/(?:^|[^\\])"/g) || []).length;
        return numberOfQuotes % 2 !== 0;
      };
      var removeQuotes = (text) => {
        return text.split("").reduce((newText, c, idx, text2) => {
          const isQuote = c === '"' && text2[idx - 1] !== "\\";
          const isEscapeForQuote = c === "\\" && text2[idx + 1] === '"';
          if (isQuote || isEscapeForQuote) {
            return newText;
          }
          return newText + c;
        }, "");
      };
      var lower = (text) => {
        return text != null ? text.toLowerCase() : null;
      };
      var getPath = (section, subsection, name2) => {
        return [lower(section), subsection, lower(name2)].filter((a) => a != null).join(".");
      };
      var normalizePath2 = (path3) => {
        const pathSegments = path3.split(".");
        const section = pathSegments.shift();
        const name2 = pathSegments.pop();
        const subsection = pathSegments.length ? pathSegments.join(".") : void 0;
        return {
          section,
          subsection,
          name: name2,
          path: getPath(section, subsection, name2),
          sectionPath: getPath(section, subsection, null),
          isSection: !!section
        };
      };
      var findLastIndex = (array, callback) => {
        return array.reduce((lastIndex, item, index3) => {
          return callback(item) ? index3 : lastIndex;
        }, -1);
      };
      var GitConfig = class _GitConfig {
        constructor(text) {
          let section = null;
          let subsection = null;
          this.parsedConfig = text ? text.split("\n").map((line) => {
            let name2 = null;
            let value = null;
            const trimmedLine = line.trim();
            const extractedSection = extractSectionLine(trimmedLine);
            const isSection = extractedSection != null;
            if (isSection) {
              ;
              [section, subsection] = extractedSection;
            } else {
              const extractedVariable = extractVariableLine(trimmedLine);
              const isVariable = extractedVariable != null;
              if (isVariable) {
                ;
                [name2, value] = extractedVariable;
              }
            }
            const path3 = getPath(section, subsection, name2);
            return { line, isSection, section, subsection, name: name2, value, path: path3 };
          }) : [];
        }
        static from(text) {
          return new _GitConfig(text);
        }
        async get(path3, getall = false) {
          const normalizedPath = normalizePath2(path3).path;
          const allValues = this.parsedConfig.filter((config) => config.path === normalizedPath).map(({ section, name: name2, value }) => {
            const fn = schema[section] && schema[section][name2];
            return fn ? fn(value) : value;
          });
          return getall ? allValues : allValues.pop();
        }
        async getall(path3) {
          return this.get(path3, true);
        }
        async getSubsections(section) {
          return this.parsedConfig.filter((config) => config.isSection && config.section === section).map((config) => config.subsection);
        }
        async deleteSection(section, subsection) {
          this.parsedConfig = this.parsedConfig.filter(
            (config) => !(config.section === section && config.subsection === subsection)
          );
        }
        async append(path3, value) {
          return this.set(path3, value, true);
        }
        async set(path3, value, append2 = false) {
          const {
            section,
            subsection,
            name: name2,
            path: normalizedPath,
            sectionPath,
            isSection
          } = normalizePath2(path3);
          const configIndex = findLastIndex(
            this.parsedConfig,
            (config) => config.path === normalizedPath
          );
          if (value == null) {
            if (configIndex !== -1) {
              this.parsedConfig.splice(configIndex, 1);
            }
          } else {
            if (configIndex !== -1) {
              const config = this.parsedConfig[configIndex];
              const modifiedConfig = Object.assign({}, config, {
                name: name2,
                value,
                modified: true
              });
              if (append2) {
                this.parsedConfig.splice(configIndex + 1, 0, modifiedConfig);
              } else {
                this.parsedConfig[configIndex] = modifiedConfig;
              }
            } else {
              const sectionIndex = this.parsedConfig.findIndex(
                (config) => config.path === sectionPath
              );
              const newConfig = {
                section,
                subsection,
                name: name2,
                value,
                modified: true,
                path: normalizedPath
              };
              if (SECTION_REGEX.test(section) && VARIABLE_NAME_REGEX.test(name2)) {
                if (sectionIndex >= 0) {
                  this.parsedConfig.splice(sectionIndex + 1, 0, newConfig);
                } else {
                  const newSection = {
                    isSection,
                    section,
                    subsection,
                    modified: true,
                    path: sectionPath
                  };
                  this.parsedConfig.push(newSection, newConfig);
                }
              }
            }
          }
        }
        toString() {
          return this.parsedConfig.map(({ line, section, subsection, name: name2, value, modified: modified2 = false }) => {
            if (!modified2) {
              return line;
            }
            if (name2 != null && value != null) {
              if (typeof value === "string" && /[#;]/.test(value)) {
                return `	${name2} = "${value}"`;
              }
              return `	${name2} = ${value}`;
            }
            if (subsection != null) {
              return `[${section} "${subsection}"]`;
            }
            return `[${section}]`;
          }).join("\n");
        }
      };
      var GitConfigManager = class {
        static async get({ fs: fs2, gitdir }) {
          const text = await fs2.read(`${gitdir}/config`, { encoding: "utf8" });
          return GitConfig.from(text);
        }
        static async save({ fs: fs2, gitdir, config }) {
          await fs2.write(`${gitdir}/config`, config.toString(), {
            encoding: "utf8"
          });
        }
      };
      var refpaths = (ref) => [
        `${ref}`,
        `refs/${ref}`,
        `refs/tags/${ref}`,
        `refs/heads/${ref}`,
        `refs/remotes/${ref}`,
        `refs/remotes/${ref}/HEAD`
      ];
      var GIT_FILES = ["config", "description", "index", "shallow", "commondir"];
      var lock$1;
      async function acquireLock(ref, callback) {
        if (lock$1 === void 0) lock$1 = new AsyncLock();
        return lock$1.acquire(ref, callback);
      }
      var GitRefManager = class _GitRefManager {
        static async updateRemoteRefs({
          fs: fs2,
          gitdir,
          remote,
          refs,
          symrefs,
          tags,
          refspecs = void 0,
          prune = false,
          pruneTags = false
        }) {
          for (const value of refs.values()) {
            if (!value.match(/[0-9a-f]{40}/)) {
              throw new InvalidOidError(value);
            }
          }
          const config = await GitConfigManager.get({ fs: fs2, gitdir });
          if (!refspecs) {
            refspecs = await config.getall(`remote.${remote}.fetch`);
            if (refspecs.length === 0) {
              throw new NoRefspecError(remote);
            }
            refspecs.unshift(`+HEAD:refs/remotes/${remote}/HEAD`);
          }
          const refspec = GitRefSpecSet.from(refspecs);
          const actualRefsToWrite = /* @__PURE__ */ new Map();
          if (pruneTags) {
            const tags2 = await _GitRefManager.listRefs({
              fs: fs2,
              gitdir,
              filepath: "refs/tags"
            });
            await _GitRefManager.deleteRefs({
              fs: fs2,
              gitdir,
              refs: tags2.map((tag2) => `refs/tags/${tag2}`)
            });
          }
          if (tags) {
            for (const serverRef of refs.keys()) {
              if (serverRef.startsWith("refs/tags") && !serverRef.endsWith("^{}")) {
                if (!await _GitRefManager.exists({ fs: fs2, gitdir, ref: serverRef })) {
                  const oid = refs.get(serverRef);
                  actualRefsToWrite.set(serverRef, oid);
                }
              }
            }
          }
          const refTranslations = refspec.translate([...refs.keys()]);
          for (const [serverRef, translatedRef] of refTranslations) {
            const value = refs.get(serverRef);
            actualRefsToWrite.set(translatedRef, value);
          }
          const symrefTranslations = refspec.translate([...symrefs.keys()]);
          for (const [serverRef, translatedRef] of symrefTranslations) {
            const value = symrefs.get(serverRef);
            const symtarget = refspec.translateOne(value);
            if (symtarget) {
              actualRefsToWrite.set(translatedRef, `ref: ${symtarget}`);
            }
          }
          const pruned = [];
          if (prune) {
            for (const filepath of refspec.localNamespaces()) {
              const refs2 = (await _GitRefManager.listRefs({
                fs: fs2,
                gitdir,
                filepath
              })).map((file) => `${filepath}/${file}`);
              for (const ref of refs2) {
                if (!actualRefsToWrite.has(ref)) {
                  pruned.push(ref);
                }
              }
            }
            if (pruned.length > 0) {
              await _GitRefManager.deleteRefs({ fs: fs2, gitdir, refs: pruned });
            }
          }
          for (const [key, value] of actualRefsToWrite) {
            await acquireLock(
              key,
              async () => fs2.write(pathBrowserify.join(gitdir, key), `${value.trim()}
`, "utf8")
            );
          }
          return { pruned };
        }
        // TODO: make this less crude?
        static async writeRef({ fs: fs2, gitdir, ref, value }) {
          if (!value.match(/[0-9a-f]{40}/)) {
            throw new InvalidOidError(value);
          }
          await acquireLock(
            ref,
            async () => fs2.write(pathBrowserify.join(gitdir, ref), `${value.trim()}
`, "utf8")
          );
        }
        static async writeSymbolicRef({ fs: fs2, gitdir, ref, value }) {
          await acquireLock(
            ref,
            async () => fs2.write(pathBrowserify.join(gitdir, ref), `ref: ${value.trim()}
`, "utf8")
          );
        }
        static async deleteRef({ fs: fs2, gitdir, ref }) {
          return _GitRefManager.deleteRefs({ fs: fs2, gitdir, refs: [ref] });
        }
        static async deleteRefs({ fs: fs2, gitdir, refs }) {
          await Promise.all(refs.map((ref) => fs2.rm(pathBrowserify.join(gitdir, ref))));
          let text = await acquireLock(
            "packed-refs",
            async () => fs2.read(`${gitdir}/packed-refs`, { encoding: "utf8" })
          );
          const packed2 = GitPackedRefs.from(text);
          const beforeSize = packed2.refs.size;
          for (const ref of refs) {
            if (packed2.refs.has(ref)) {
              packed2.delete(ref);
            }
          }
          if (packed2.refs.size < beforeSize) {
            text = packed2.toString();
            await acquireLock(
              "packed-refs",
              async () => fs2.write(`${gitdir}/packed-refs`, text, { encoding: "utf8" })
            );
          }
        }
        /**
         * @param {object} args
         * @param {import('../models/FileSystem.js').FileSystem} args.fs
         * @param {string} args.gitdir
         * @param {string} args.ref
         * @param {number} [args.depth]
         * @returns {Promise<string>}
         */
        static async resolve({ fs: fs2, gitdir, ref, depth = void 0 }) {
          if (depth !== void 0) {
            depth--;
            if (depth === -1) {
              return ref;
            }
          }
          if (ref.startsWith("ref: ")) {
            ref = ref.slice("ref: ".length);
            return _GitRefManager.resolve({ fs: fs2, gitdir, ref, depth });
          }
          if (ref.length === 40 && /[0-9a-f]{40}/.test(ref)) {
            return ref;
          }
          const packedMap = await _GitRefManager.packedRefs({ fs: fs2, gitdir });
          const allpaths = refpaths(ref).filter((p12) => !GIT_FILES.includes(p12));
          for (const ref2 of allpaths) {
            const sha = await acquireLock(
              ref2,
              async () => await fs2.read(`${gitdir}/${ref2}`, { encoding: "utf8" }) || packedMap.get(ref2)
            );
            if (sha) {
              return _GitRefManager.resolve({ fs: fs2, gitdir, ref: sha.trim(), depth });
            }
          }
          throw new NotFoundError(ref);
        }
        static async exists({ fs: fs2, gitdir, ref }) {
          try {
            await _GitRefManager.expand({ fs: fs2, gitdir, ref });
            return true;
          } catch (err3) {
            return false;
          }
        }
        static async expand({ fs: fs2, gitdir, ref }) {
          if (ref.length === 40 && /[0-9a-f]{40}/.test(ref)) {
            return ref;
          }
          const packedMap = await _GitRefManager.packedRefs({ fs: fs2, gitdir });
          const allpaths = refpaths(ref);
          for (const ref2 of allpaths) {
            const refExists = await acquireLock(
              ref2,
              async () => fs2.exists(`${gitdir}/${ref2}`)
            );
            if (refExists) return ref2;
            if (packedMap.has(ref2)) return ref2;
          }
          throw new NotFoundError(ref);
        }
        static async expandAgainstMap({ ref, map }) {
          const allpaths = refpaths(ref);
          for (const ref2 of allpaths) {
            if (await map.has(ref2)) return ref2;
          }
          throw new NotFoundError(ref);
        }
        static resolveAgainstMap({ ref, fullref = ref, depth = void 0, map }) {
          if (depth !== void 0) {
            depth--;
            if (depth === -1) {
              return { fullref, oid: ref };
            }
          }
          if (ref.startsWith("ref: ")) {
            ref = ref.slice("ref: ".length);
            return _GitRefManager.resolveAgainstMap({ ref, fullref, depth, map });
          }
          if (ref.length === 40 && /[0-9a-f]{40}/.test(ref)) {
            return { fullref, oid: ref };
          }
          const allpaths = refpaths(ref);
          for (const ref2 of allpaths) {
            const sha = map.get(ref2);
            if (sha) {
              return _GitRefManager.resolveAgainstMap({
                ref: sha.trim(),
                fullref: ref2,
                depth,
                map
              });
            }
          }
          throw new NotFoundError(ref);
        }
        static async packedRefs({ fs: fs2, gitdir }) {
          const text = await acquireLock(
            "packed-refs",
            async () => fs2.read(`${gitdir}/packed-refs`, { encoding: "utf8" })
          );
          const packed2 = GitPackedRefs.from(text);
          return packed2.refs;
        }
        // List all the refs that match the `filepath` prefix
        static async listRefs({ fs: fs2, gitdir, filepath }) {
          const packedMap = _GitRefManager.packedRefs({ fs: fs2, gitdir });
          let files = null;
          try {
            files = await fs2.readdirDeep(`${gitdir}/${filepath}`);
            files = files.map((x) => x.replace(`${gitdir}/${filepath}/`, ""));
          } catch (err3) {
            files = [];
          }
          for (let key of (await packedMap).keys()) {
            if (key.startsWith(filepath)) {
              key = key.replace(filepath + "/", "");
              if (!files.includes(key)) {
                files.push(key);
              }
            }
          }
          files.sort(compareRefNames);
          return files;
        }
        static async listBranches({ fs: fs2, gitdir, remote }) {
          if (remote) {
            return _GitRefManager.listRefs({
              fs: fs2,
              gitdir,
              filepath: `refs/remotes/${remote}`
            });
          } else {
            return _GitRefManager.listRefs({ fs: fs2, gitdir, filepath: `refs/heads` });
          }
        }
        static async listTags({ fs: fs2, gitdir }) {
          const tags = await _GitRefManager.listRefs({
            fs: fs2,
            gitdir,
            filepath: `refs/tags`
          });
          return tags.filter((x) => !x.endsWith("^{}"));
        }
      };
      function compareTreeEntryPath(a, b) {
        return compareStrings(appendSlashIfDir(a), appendSlashIfDir(b));
      }
      function appendSlashIfDir(entry) {
        return entry.mode === "040000" ? entry.path + "/" : entry.path;
      }
      function mode2type$1(mode) {
        switch (mode) {
          case "040000":
            return "tree";
          case "100644":
            return "blob";
          case "100755":
            return "blob";
          case "120000":
            return "blob";
          case "160000":
            return "commit";
        }
        throw new InternalError2(`Unexpected GitTree entry mode: ${mode}`);
      }
      function parseBuffer(buffer) {
        const _entries = [];
        let cursor = 0;
        while (cursor < buffer.length) {
          const space = buffer.indexOf(32, cursor);
          if (space === -1) {
            throw new InternalError2(
              `GitTree: Error parsing buffer at byte location ${cursor}: Could not find the next space character.`
            );
          }
          const nullchar = buffer.indexOf(0, cursor);
          if (nullchar === -1) {
            throw new InternalError2(
              `GitTree: Error parsing buffer at byte location ${cursor}: Could not find the next null character.`
            );
          }
          let mode = buffer.slice(cursor, space).toString("utf8");
          if (mode === "40000") mode = "040000";
          const type = mode2type$1(mode);
          const path3 = buffer.slice(space + 1, nullchar).toString("utf8");
          if (path3.includes("\\") || path3.includes("/")) {
            throw new UnsafeFilepathError(path3);
          }
          const oid = buffer.slice(nullchar + 1, nullchar + 21).toString("hex");
          cursor = nullchar + 21;
          _entries.push({ mode, path: path3, oid, type });
        }
        return _entries;
      }
      function limitModeToAllowed(mode) {
        if (typeof mode === "number") {
          mode = mode.toString(8);
        }
        if (mode.match(/^0?4.*/)) return "040000";
        if (mode.match(/^1006.*/)) return "100644";
        if (mode.match(/^1007.*/)) return "100755";
        if (mode.match(/^120.*/)) return "120000";
        if (mode.match(/^160.*/)) return "160000";
        throw new InternalError2(`Could not understand file mode: ${mode}`);
      }
      function nudgeIntoShape(entry) {
        if (!entry.oid && entry.sha) {
          entry.oid = entry.sha;
        }
        entry.mode = limitModeToAllowed(entry.mode);
        if (!entry.type) {
          entry.type = mode2type$1(entry.mode);
        }
        return entry;
      }
      var GitTree = class _GitTree {
        constructor(entries2) {
          if (Buffer.isBuffer(entries2)) {
            this._entries = parseBuffer(entries2);
          } else if (Array.isArray(entries2)) {
            this._entries = entries2.map(nudgeIntoShape);
          } else {
            throw new InternalError2("invalid type passed to GitTree constructor");
          }
          this._entries.sort(comparePath);
        }
        static from(tree) {
          return new _GitTree(tree);
        }
        render() {
          return this._entries.map((entry) => `${entry.mode} ${entry.type} ${entry.oid}    ${entry.path}`).join("\n");
        }
        toObject() {
          const entries2 = [...this._entries];
          entries2.sort(compareTreeEntryPath);
          return Buffer.concat(
            entries2.map((entry) => {
              const mode = Buffer.from(entry.mode.replace(/^0/, ""));
              const space = Buffer.from(" ");
              const path3 = Buffer.from(entry.path, "utf8");
              const nullchar = Buffer.from([0]);
              const oid = Buffer.from(entry.oid, "hex");
              return Buffer.concat([mode, space, path3, nullchar, oid]);
            })
          );
        }
        /**
         * @returns {TreeEntry[]}
         */
        entries() {
          return this._entries;
        }
        *[Symbol.iterator]() {
          for (const entry of this._entries) {
            yield entry;
          }
        }
      };
      var GitObject = class {
        /**
         * Wraps a raw object with a Git header.
         *
         * @param {Object} params - The parameters for wrapping.
         * @param {string} params.type - The type of the Git object (e.g., 'blob', 'tree', 'commit').
         * @param {Uint8Array} params.object - The raw object data to wrap.
         * @returns {Uint8Array} The wrapped Git object as a single buffer.
         */
        static wrap({ type, object }) {
          const header = `${type} ${object.length}\0`;
          const headerLen = header.length;
          const totalLength = headerLen + object.length;
          const wrappedObject = new Uint8Array(totalLength);
          for (let i2 = 0; i2 < headerLen; i2++) {
            wrappedObject[i2] = header.charCodeAt(i2);
          }
          wrappedObject.set(object, headerLen);
          return wrappedObject;
        }
        /**
         * Unwraps a Git object buffer into its type and raw object data.
         *
         * @param {Buffer|Uint8Array} buffer - The buffer containing the wrapped Git object.
         * @returns {{ type: string, object: Buffer }} An object containing the type and the raw object data.
         * @throws {InternalError} If the length specified in the header does not match the actual object length.
         */
        static unwrap(buffer) {
          const s2 = buffer.indexOf(32);
          const i2 = buffer.indexOf(0);
          const type = buffer.slice(0, s2).toString("utf8");
          const length2 = buffer.slice(s2 + 1, i2).toString("utf8");
          const actualLength = buffer.length - (i2 + 1);
          if (parseInt(length2) !== actualLength) {
            throw new InternalError2(
              `Length mismatch: expected ${length2} bytes but got ${actualLength} instead.`
            );
          }
          return {
            type,
            object: Buffer.from(buffer.slice(i2 + 1))
          };
        }
      };
      async function readObjectLoose({ fs: fs2, gitdir, oid }) {
        const source = `objects/${oid.slice(0, 2)}/${oid.slice(2)}`;
        const file = await fs2.read(`${gitdir}/${source}`);
        if (!file) {
          return null;
        }
        return { object: file, format: "deflated", source };
      }
      function applyDelta(delta, source) {
        const reader = new BufferCursor(delta);
        const sourceSize = readVarIntLE(reader);
        if (sourceSize !== source.byteLength) {
          throw new InternalError2(
            `applyDelta expected source buffer to be ${sourceSize} bytes but the provided buffer was ${source.length} bytes`
          );
        }
        const targetSize = readVarIntLE(reader);
        let target;
        const firstOp = readOp(reader, source);
        if (firstOp.byteLength === targetSize) {
          target = firstOp;
        } else {
          target = Buffer.alloc(targetSize);
          const writer = new BufferCursor(target);
          writer.copy(firstOp);
          while (!reader.eof()) {
            writer.copy(readOp(reader, source));
          }
          const tell = writer.tell();
          if (targetSize !== tell) {
            throw new InternalError2(
              `applyDelta expected target buffer to be ${targetSize} bytes but the resulting buffer was ${tell} bytes`
            );
          }
        }
        return target;
      }
      function readVarIntLE(reader) {
        let result = 0;
        let shift = 0;
        let byte = null;
        do {
          byte = reader.readUInt8();
          result |= (byte & 127) << shift;
          shift += 7;
        } while (byte & 128);
        return result;
      }
      function readCompactLE(reader, flags, size) {
        let result = 0;
        let shift = 0;
        while (size--) {
          if (flags & 1) {
            result |= reader.readUInt8() << shift;
          }
          flags >>= 1;
          shift += 8;
        }
        return result;
      }
      function readOp(reader, source) {
        const byte = reader.readUInt8();
        const COPY = 128;
        const OFFS = 15;
        const SIZE = 112;
        if (byte & COPY) {
          const offset = readCompactLE(reader, byte & OFFS, 4);
          let size = readCompactLE(reader, (byte & SIZE) >> 4, 3);
          if (size === 0) size = 65536;
          return source.slice(offset, offset + size);
        } else {
          return reader.slice(byte);
        }
      }
      function fromValue2(value) {
        let queue = [value];
        return {
          next() {
            return Promise.resolve({ done: queue.length === 0, value: queue.pop() });
          },
          return() {
            queue = [];
            return {};
          },
          [Symbol.asyncIterator]() {
            return this;
          }
        };
      }
      function getIterator2(iterable) {
        if (iterable[Symbol.asyncIterator]) {
          return iterable[Symbol.asyncIterator]();
        }
        if (iterable[Symbol.iterator]) {
          return iterable[Symbol.iterator]();
        }
        if (iterable.next) {
          return iterable;
        }
        return fromValue2(iterable);
      }
      var StreamReader = class {
        constructor(stream) {
          if (typeof Buffer === "undefined") {
            throw new Error("Missing Buffer dependency");
          }
          this.stream = getIterator2(stream);
          this.buffer = null;
          this.cursor = 0;
          this.undoCursor = 0;
          this.started = false;
          this._ended = false;
          this._discardedBytes = 0;
        }
        eof() {
          return this._ended && this.cursor === this.buffer.length;
        }
        tell() {
          return this._discardedBytes + this.cursor;
        }
        async byte() {
          if (this.eof()) return;
          if (!this.started) await this._init();
          if (this.cursor === this.buffer.length) {
            await this._loadnext();
            if (this._ended) return;
          }
          this._moveCursor(1);
          return this.buffer[this.undoCursor];
        }
        async chunk() {
          if (this.eof()) return;
          if (!this.started) await this._init();
          if (this.cursor === this.buffer.length) {
            await this._loadnext();
            if (this._ended) return;
          }
          this._moveCursor(this.buffer.length);
          return this.buffer.slice(this.undoCursor, this.cursor);
        }
        async read(n2) {
          if (this.eof()) return;
          if (!this.started) await this._init();
          if (this.cursor + n2 > this.buffer.length) {
            this._trim();
            await this._accumulate(n2);
          }
          this._moveCursor(n2);
          return this.buffer.slice(this.undoCursor, this.cursor);
        }
        async skip(n2) {
          if (this.eof()) return;
          if (!this.started) await this._init();
          if (this.cursor + n2 > this.buffer.length) {
            this._trim();
            await this._accumulate(n2);
          }
          this._moveCursor(n2);
        }
        async undo() {
          this.cursor = this.undoCursor;
        }
        async _next() {
          this.started = true;
          let { done, value } = await this.stream.next();
          if (done) {
            this._ended = true;
            if (!value) return Buffer.alloc(0);
          }
          if (value) {
            value = Buffer.from(value);
          }
          return value;
        }
        _trim() {
          this.buffer = this.buffer.slice(this.undoCursor);
          this.cursor -= this.undoCursor;
          this._discardedBytes += this.undoCursor;
          this.undoCursor = 0;
        }
        _moveCursor(n2) {
          this.undoCursor = this.cursor;
          this.cursor += n2;
          if (this.cursor > this.buffer.length) {
            this.cursor = this.buffer.length;
          }
        }
        async _accumulate(n2) {
          if (this._ended) return;
          const buffers = [this.buffer];
          while (this.cursor + n2 > lengthBuffers(buffers)) {
            const nextbuffer = await this._next();
            if (this._ended) break;
            buffers.push(nextbuffer);
          }
          this.buffer = Buffer.concat(buffers);
        }
        async _loadnext() {
          this._discardedBytes += this.buffer.length;
          this.undoCursor = 0;
          this.cursor = 0;
          this.buffer = await this._next();
        }
        async _init() {
          this.buffer = await this._next();
        }
      };
      function lengthBuffers(buffers) {
        return buffers.reduce((acc, buffer) => acc + buffer.length, 0);
      }
      async function listpack(stream, onData) {
        const reader = new StreamReader(stream);
        let PACK = await reader.read(4);
        PACK = PACK.toString("utf8");
        if (PACK !== "PACK") {
          throw new InternalError2(`Invalid PACK header '${PACK}'`);
        }
        let version18 = await reader.read(4);
        version18 = version18.readUInt32BE(0);
        if (version18 !== 2) {
          throw new InternalError2(`Invalid packfile version: ${version18}`);
        }
        let numObjects = await reader.read(4);
        numObjects = numObjects.readUInt32BE(0);
        if (numObjects < 1) return;
        while (!reader.eof() && numObjects--) {
          const offset = reader.tell();
          const { type, length: length2, ofs, reference } = await parseHeader(reader);
          const inflator = new pako.Inflate();
          while (!inflator.result) {
            const chunk = await reader.chunk();
            if (!chunk) break;
            inflator.push(chunk, false);
            if (inflator.err) {
              throw new InternalError2(`Pako error: ${inflator.msg}`);
            }
            if (inflator.result) {
              if (inflator.result.length !== length2) {
                throw new InternalError2(
                  `Inflated object size is different from that stated in packfile.`
                );
              }
              await reader.undo();
              await reader.read(chunk.length - inflator.strm.avail_in);
              const end = reader.tell();
              await onData({
                data: inflator.result,
                type,
                num: numObjects,
                offset,
                end,
                reference,
                ofs
              });
            }
          }
        }
      }
      async function parseHeader(reader) {
        let byte = await reader.byte();
        const type = byte >> 4 & 7;
        let length2 = byte & 15;
        if (byte & 128) {
          let shift = 4;
          do {
            byte = await reader.byte();
            length2 |= (byte & 127) << shift;
            shift += 7;
          } while (byte & 128);
        }
        let ofs;
        let reference;
        if (type === 6) {
          let shift = 0;
          ofs = 0;
          const bytes2 = [];
          do {
            byte = await reader.byte();
            ofs |= (byte & 127) << shift;
            shift += 7;
            bytes2.push(byte);
          } while (byte & 128);
          reference = Buffer.from(bytes2);
        }
        if (type === 7) {
          const buf = await reader.read(20);
          reference = buf;
        }
        return { type, length: length2, ofs, reference };
      }
      var supportsDecompressionStream = false;
      async function inflate(buffer) {
        if (supportsDecompressionStream === null) {
          supportsDecompressionStream = testDecompressionStream();
        }
        return supportsDecompressionStream ? browserInflate(buffer) : pako.inflate(buffer);
      }
      async function browserInflate(buffer) {
        const ds = new DecompressionStream("deflate");
        const d = new Blob([buffer]).stream().pipeThrough(ds);
        return new Uint8Array(await new Response(d).arrayBuffer());
      }
      function testDecompressionStream() {
        try {
          const ds = new DecompressionStream("deflate");
          if (ds) return true;
        } catch (_2) {
        }
        return false;
      }
      function decodeVarInt(reader) {
        const bytes2 = [];
        let byte = 0;
        let multibyte = 0;
        do {
          byte = reader.readUInt8();
          const lastSeven = byte & 127;
          bytes2.push(lastSeven);
          multibyte = byte & 128;
        } while (multibyte);
        return bytes2.reduce((a, b) => a + 1 << 7 | b, -1);
      }
      function otherVarIntDecode(reader, startWith) {
        let result = startWith;
        let shift = 4;
        let byte = null;
        do {
          byte = reader.readUInt8();
          result |= (byte & 127) << shift;
          shift += 7;
        } while (byte & 128);
        return result;
      }
      var GitPackIndex = class _GitPackIndex {
        constructor(stuff) {
          Object.assign(this, stuff);
          this.offsetCache = {};
        }
        static async fromIdx({ idx, getExternalRefDelta }) {
          const reader = new BufferCursor(idx);
          const magic = reader.slice(4).toString("hex");
          if (magic !== "ff744f63") {
            return;
          }
          const version18 = reader.readUInt32BE();
          if (version18 !== 2) {
            throw new InternalError2(
              `Unable to read version ${version18} packfile IDX. (Only version 2 supported)`
            );
          }
          if (idx.byteLength > 2048 * 1024 * 1024) {
            throw new InternalError2(
              `To keep implementation simple, I haven't implemented the layer 5 feature needed to support packfiles > 2GB in size.`
            );
          }
          reader.seek(reader.tell() + 4 * 255);
          const size = reader.readUInt32BE();
          const hashes = [];
          for (let i2 = 0; i2 < size; i2++) {
            const hash2 = reader.slice(20).toString("hex");
            hashes[i2] = hash2;
          }
          reader.seek(reader.tell() + 4 * size);
          const offsets = /* @__PURE__ */ new Map();
          for (let i2 = 0; i2 < size; i2++) {
            offsets.set(hashes[i2], reader.readUInt32BE());
          }
          const packfileSha = reader.slice(20).toString("hex");
          return new _GitPackIndex({
            hashes,
            crcs: {},
            offsets,
            packfileSha,
            getExternalRefDelta
          });
        }
        static async fromPack({ pack, getExternalRefDelta, onProgress }) {
          const listpackTypes = {
            1: "commit",
            2: "tree",
            3: "blob",
            4: "tag",
            6: "ofs-delta",
            7: "ref-delta"
          };
          const offsetToObject = {};
          const packfileSha = pack.slice(-20).toString("hex");
          const hashes = [];
          const crcs = {};
          const offsets = /* @__PURE__ */ new Map();
          let totalObjectCount = null;
          let lastPercent = null;
          await listpack([pack], async ({ data, type, reference, offset, num: num2 }) => {
            if (totalObjectCount === null) totalObjectCount = num2;
            const percent = Math.floor(
              (totalObjectCount - num2) * 100 / totalObjectCount
            );
            if (percent !== lastPercent) {
              if (onProgress) {
                await onProgress({
                  phase: "Receiving objects",
                  loaded: totalObjectCount - num2,
                  total: totalObjectCount
                });
              }
            }
            lastPercent = percent;
            type = listpackTypes[type];
            if (["commit", "tree", "blob", "tag"].includes(type)) {
              offsetToObject[offset] = {
                type,
                offset
              };
            } else if (type === "ofs-delta") {
              offsetToObject[offset] = {
                type,
                offset
              };
            } else if (type === "ref-delta") {
              offsetToObject[offset] = {
                type,
                offset
              };
            }
          });
          const offsetArray = Object.keys(offsetToObject).map(Number);
          for (const [i2, start] of offsetArray.entries()) {
            const end = i2 + 1 === offsetArray.length ? pack.byteLength - 20 : offsetArray[i2 + 1];
            const o = offsetToObject[start];
            const crc = crc32.buf(pack.slice(start, end)) >>> 0;
            o.end = end;
            o.crc = crc;
          }
          const p12 = new _GitPackIndex({
            pack: Promise.resolve(pack),
            packfileSha,
            crcs,
            hashes,
            offsets,
            getExternalRefDelta
          });
          lastPercent = null;
          let count = 0;
          const objectsByDepth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (let offset in offsetToObject) {
            offset = Number(offset);
            const percent = Math.floor(count * 100 / totalObjectCount);
            if (percent !== lastPercent) {
              if (onProgress) {
                await onProgress({
                  phase: "Resolving deltas",
                  loaded: count,
                  total: totalObjectCount
                });
              }
            }
            count++;
            lastPercent = percent;
            const o = offsetToObject[offset];
            if (o.oid) continue;
            try {
              p12.readDepth = 0;
              p12.externalReadDepth = 0;
              const { type, object } = await p12.readSlice({ start: offset });
              objectsByDepth[p12.readDepth] += 1;
              const oid = await shasum(GitObject.wrap({ type, object }));
              o.oid = oid;
              hashes.push(oid);
              offsets.set(oid, offset);
              crcs[oid] = o.crc;
            } catch (err3) {
              continue;
            }
          }
          hashes.sort();
          return p12;
        }
        async toBuffer() {
          const buffers = [];
          const write2 = (str, encoding) => {
            buffers.push(Buffer.from(str, encoding));
          };
          write2("ff744f63", "hex");
          write2("00000002", "hex");
          const fanoutBuffer = new BufferCursor(Buffer.alloc(256 * 4));
          for (let i2 = 0; i2 < 256; i2++) {
            let count = 0;
            for (const hash2 of this.hashes) {
              if (parseInt(hash2.slice(0, 2), 16) <= i2) count++;
            }
            fanoutBuffer.writeUInt32BE(count);
          }
          buffers.push(fanoutBuffer.buffer);
          for (const hash2 of this.hashes) {
            write2(hash2, "hex");
          }
          const crcsBuffer = new BufferCursor(Buffer.alloc(this.hashes.length * 4));
          for (const hash2 of this.hashes) {
            crcsBuffer.writeUInt32BE(this.crcs[hash2]);
          }
          buffers.push(crcsBuffer.buffer);
          const offsetsBuffer = new BufferCursor(Buffer.alloc(this.hashes.length * 4));
          for (const hash2 of this.hashes) {
            offsetsBuffer.writeUInt32BE(this.offsets.get(hash2));
          }
          buffers.push(offsetsBuffer.buffer);
          write2(this.packfileSha, "hex");
          const totalBuffer = Buffer.concat(buffers);
          const sha = await shasum(totalBuffer);
          const shaBuffer = Buffer.alloc(20);
          shaBuffer.write(sha, "hex");
          return Buffer.concat([totalBuffer, shaBuffer]);
        }
        async load({ pack }) {
          this.pack = pack;
        }
        async unload() {
          this.pack = null;
        }
        async read({ oid }) {
          if (!this.offsets.get(oid)) {
            if (this.getExternalRefDelta) {
              this.externalReadDepth++;
              return this.getExternalRefDelta(oid);
            } else {
              throw new InternalError2(`Could not read object ${oid} from packfile`);
            }
          }
          const start = this.offsets.get(oid);
          return this.readSlice({ start });
        }
        async readSlice({ start }) {
          if (this.offsetCache[start]) {
            return Object.assign({}, this.offsetCache[start]);
          }
          this.readDepth++;
          const types4 = {
            16: "commit",
            32: "tree",
            48: "blob",
            64: "tag",
            96: "ofs_delta",
            112: "ref_delta"
          };
          if (!this.pack) {
            throw new InternalError2(
              "Tried to read from a GitPackIndex with no packfile loaded into memory"
            );
          }
          const raw = (await this.pack).slice(start);
          const reader = new BufferCursor(raw);
          const byte = reader.readUInt8();
          const btype = byte & 112;
          let type = types4[btype];
          if (type === void 0) {
            throw new InternalError2("Unrecognized type: 0b" + btype.toString(2));
          }
          const lastFour = byte & 15;
          let length2 = lastFour;
          const multibyte = byte & 128;
          if (multibyte) {
            length2 = otherVarIntDecode(reader, lastFour);
          }
          let base2 = null;
          let object = null;
          if (type === "ofs_delta") {
            const offset = decodeVarInt(reader);
            const baseOffset = start - offset;
            ({ object: base2, type } = await this.readSlice({ start: baseOffset }));
          }
          if (type === "ref_delta") {
            const oid = reader.slice(20).toString("hex");
            ({ object: base2, type } = await this.read({ oid }));
          }
          const buffer = raw.slice(reader.tell());
          object = Buffer.from(await inflate(buffer));
          if (object.byteLength !== length2) {
            throw new InternalError2(
              `Packfile told us object would have length ${length2} but it had length ${object.byteLength}`
            );
          }
          if (base2) {
            object = Buffer.from(applyDelta(object, base2));
          }
          if (this.readDepth > 3) {
            this.offsetCache[start] = { type, object };
          }
          return { type, format: "content", object };
        }
      };
      var PackfileCache = Symbol("PackfileCache");
      async function loadPackIndex({
        fs: fs2,
        filename,
        getExternalRefDelta,
        emitter,
        emitterPrefix
      }) {
        const idx = await fs2.read(filename);
        return GitPackIndex.fromIdx({ idx, getExternalRefDelta });
      }
      function readPackIndex({
        fs: fs2,
        cache: cache2,
        filename,
        getExternalRefDelta,
        emitter,
        emitterPrefix
      }) {
        if (!cache2[PackfileCache]) cache2[PackfileCache] = /* @__PURE__ */ new Map();
        let p12 = cache2[PackfileCache].get(filename);
        if (!p12) {
          p12 = loadPackIndex({
            fs: fs2,
            filename,
            getExternalRefDelta,
            emitter,
            emitterPrefix
          });
          cache2[PackfileCache].set(filename, p12);
        }
        return p12;
      }
      async function readObjectPacked({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        format: format5 = "content",
        getExternalRefDelta
      }) {
        let list2 = await fs2.readdir(pathBrowserify.join(gitdir, "objects/pack"));
        list2 = list2.filter((x) => x.endsWith(".idx"));
        for (const filename of list2) {
          const indexFile = `${gitdir}/objects/pack/${filename}`;
          const p12 = await readPackIndex({
            fs: fs2,
            cache: cache2,
            filename: indexFile,
            getExternalRefDelta
          });
          if (p12.error) throw new InternalError2(p12.error);
          if (p12.offsets.has(oid)) {
            if (!p12.pack) {
              const packFile = indexFile.replace(/idx$/, "pack");
              p12.pack = fs2.read(packFile);
            }
            const result = await p12.read({ oid, getExternalRefDelta });
            result.format = "content";
            result.source = `objects/pack/${filename.replace(/idx$/, "pack")}`;
            return result;
          }
        }
        return null;
      }
      async function _readObject({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        format: format5 = "content"
      }) {
        const getExternalRefDelta = (oid2) => _readObject({ fs: fs2, cache: cache2, gitdir, oid: oid2 });
        let result;
        if (oid === "4b825dc642cb6eb9a060e54bf8d69288fbee4904") {
          result = { format: "wrapped", object: Buffer.from(`tree 0\0`) };
        }
        if (!result) {
          result = await readObjectLoose({ fs: fs2, gitdir, oid });
        }
        if (!result) {
          result = await readObjectPacked({
            fs: fs2,
            cache: cache2,
            gitdir,
            oid,
            getExternalRefDelta
          });
          if (!result) {
            throw new NotFoundError(oid);
          }
          return result;
        }
        if (format5 === "deflated") {
          return result;
        }
        if (result.format === "deflated") {
          result.object = Buffer.from(await inflate(result.object));
          result.format = "wrapped";
        }
        if (format5 === "wrapped") {
          return result;
        }
        const sha = await shasum(result.object);
        if (sha !== oid) {
          throw new InternalError2(
            `SHA check failed! Expected ${oid}, computed ${sha}`
          );
        }
        const { object, type } = GitObject.unwrap(result.object);
        result.type = type;
        result.object = object;
        result.format = "content";
        if (format5 === "content") {
          return result;
        }
        throw new InternalError2(`invalid requested format "${format5}"`);
      }
      var AlreadyExistsError = class _AlreadyExistsError extends BaseError2 {
        /**
         * @param {'note'|'remote'|'tag'|'branch'} noun
         * @param {string} where
         * @param {boolean} canForce
         */
        constructor(noun, where, canForce = true) {
          super(
            `Failed to create ${noun} at ${where} because it already exists.${canForce ? ` (Hint: use 'force: true' parameter to overwrite existing ${noun}.)` : ""}`
          );
          this.code = this.name = _AlreadyExistsError.code;
          this.data = { noun, where, canForce };
        }
      };
      AlreadyExistsError.code = "AlreadyExistsError";
      var AmbiguousError = class _AmbiguousError extends BaseError2 {
        /**
         * @param {'oids'|'refs'} nouns
         * @param {string} short
         * @param {string[]} matches
         */
        constructor(nouns, short, matches) {
          super(
            `Found multiple ${nouns} matching "${short}" (${matches.join(
              ", "
            )}). Use a longer abbreviation length to disambiguate them.`
          );
          this.code = this.name = _AmbiguousError.code;
          this.data = { nouns, short, matches };
        }
      };
      AmbiguousError.code = "AmbiguousError";
      var CheckoutConflictError = class _CheckoutConflictError extends BaseError2 {
        /**
         * @param {string[]} filepaths
         */
        constructor(filepaths) {
          super(
            `Your local changes to the following files would be overwritten by checkout: ${filepaths.join(
              ", "
            )}`
          );
          this.code = this.name = _CheckoutConflictError.code;
          this.data = { filepaths };
        }
      };
      CheckoutConflictError.code = "CheckoutConflictError";
      var CommitNotFetchedError = class _CommitNotFetchedError extends BaseError2 {
        /**
         * @param {string} ref
         * @param {string} oid
         */
        constructor(ref, oid) {
          super(
            `Failed to checkout "${ref}" because commit ${oid} is not available locally. Do a git fetch to make the branch available locally.`
          );
          this.code = this.name = _CommitNotFetchedError.code;
          this.data = { ref, oid };
        }
      };
      CommitNotFetchedError.code = "CommitNotFetchedError";
      var EmptyServerResponseError = class _EmptyServerResponseError extends BaseError2 {
        constructor() {
          super(`Empty response from git server.`);
          this.code = this.name = _EmptyServerResponseError.code;
          this.data = {};
        }
      };
      EmptyServerResponseError.code = "EmptyServerResponseError";
      var FastForwardError = class _FastForwardError extends BaseError2 {
        constructor() {
          super(`A simple fast-forward merge was not possible.`);
          this.code = this.name = _FastForwardError.code;
          this.data = {};
        }
      };
      FastForwardError.code = "FastForwardError";
      var GitPushError = class _GitPushError extends BaseError2 {
        /**
         * @param {string} prettyDetails
         * @param {PushResult} result
         */
        constructor(prettyDetails, result) {
          super(`One or more branches were not updated: ${prettyDetails}`);
          this.code = this.name = _GitPushError.code;
          this.data = { prettyDetails, result };
        }
      };
      GitPushError.code = "GitPushError";
      var HttpError2 = class _HttpError extends BaseError2 {
        /**
         * @param {number} statusCode
         * @param {string} statusMessage
         * @param {string} response
         */
        constructor(statusCode, statusMessage, response) {
          super(`HTTP Error: ${statusCode} ${statusMessage}`);
          this.code = this.name = _HttpError.code;
          this.data = { statusCode, statusMessage, response };
        }
      };
      HttpError2.code = "HttpError";
      var InvalidFilepathError = class _InvalidFilepathError extends BaseError2 {
        /**
         * @param {'leading-slash'|'trailing-slash'|'directory'} [reason]
         */
        constructor(reason) {
          let message = "invalid filepath";
          if (reason === "leading-slash" || reason === "trailing-slash") {
            message = `"filepath" parameter should not include leading or trailing directory separators because these can cause problems on some platforms.`;
          } else if (reason === "directory") {
            message = `"filepath" should not be a directory.`;
          }
          super(message);
          this.code = this.name = _InvalidFilepathError.code;
          this.data = { reason };
        }
      };
      InvalidFilepathError.code = "InvalidFilepathError";
      var InvalidRefNameError = class _InvalidRefNameError extends BaseError2 {
        /**
         * @param {string} ref
         * @param {string} suggestion
         * @param {boolean} canForce
         */
        constructor(ref, suggestion) {
          super(
            `"${ref}" would be an invalid git reference. (Hint: a valid alternative would be "${suggestion}".)`
          );
          this.code = this.name = _InvalidRefNameError.code;
          this.data = { ref, suggestion };
        }
      };
      InvalidRefNameError.code = "InvalidRefNameError";
      var MaxDepthError = class _MaxDepthError extends BaseError2 {
        /**
         * @param {number} depth
         */
        constructor(depth) {
          super(`Maximum search depth of ${depth} exceeded.`);
          this.code = this.name = _MaxDepthError.code;
          this.data = { depth };
        }
      };
      MaxDepthError.code = "MaxDepthError";
      var MergeNotSupportedError = class _MergeNotSupportedError extends BaseError2 {
        constructor() {
          super(`Merges with conflicts are not supported yet.`);
          this.code = this.name = _MergeNotSupportedError.code;
          this.data = {};
        }
      };
      MergeNotSupportedError.code = "MergeNotSupportedError";
      var MergeConflictError = class _MergeConflictError extends BaseError2 {
        /**
         * @param {Array<string>} filepaths
         * @param {Array<string>} bothModified
         * @param {Array<string>} deleteByUs
         * @param {Array<string>} deleteByTheirs
         */
        constructor(filepaths, bothModified, deleteByUs, deleteByTheirs) {
          super(
            `Automatic merge failed with one or more merge conflicts in the following files: ${filepaths.toString()}. Fix conflicts then commit the result.`
          );
          this.code = this.name = _MergeConflictError.code;
          this.data = { filepaths, bothModified, deleteByUs, deleteByTheirs };
        }
      };
      MergeConflictError.code = "MergeConflictError";
      var MissingNameError = class _MissingNameError extends BaseError2 {
        /**
         * @param {'author'|'committer'|'tagger'} role
         */
        constructor(role) {
          super(
            `No name was provided for ${role} in the argument or in the .git/config file.`
          );
          this.code = this.name = _MissingNameError.code;
          this.data = { role };
        }
      };
      MissingNameError.code = "MissingNameError";
      var MissingParameterError = class _MissingParameterError extends BaseError2 {
        /**
         * @param {string} parameter
         */
        constructor(parameter) {
          super(
            `The function requires a "${parameter}" parameter but none was provided.`
          );
          this.code = this.name = _MissingParameterError.code;
          this.data = { parameter };
        }
      };
      MissingParameterError.code = "MissingParameterError";
      var MultipleGitError = class _MultipleGitError extends BaseError2 {
        /**
         * @param {Error[]} errors
         * @param {string} message
         */
        constructor(errors) {
          super(
            `There are multiple errors that were thrown by the method. Please refer to the "errors" property to see more`
          );
          this.code = this.name = _MultipleGitError.code;
          this.data = { errors };
          this.errors = errors;
        }
      };
      MultipleGitError.code = "MultipleGitError";
      var ParseError3 = class _ParseError extends BaseError2 {
        /**
         * @param {string} expected
         * @param {string} actual
         */
        constructor(expected, actual) {
          super(`Expected "${expected}" but received "${actual}".`);
          this.code = this.name = _ParseError.code;
          this.data = { expected, actual };
        }
      };
      ParseError3.code = "ParseError";
      var PushRejectedError = class _PushRejectedError extends BaseError2 {
        /**
         * @param {'not-fast-forward'|'tag-exists'} reason
         */
        constructor(reason) {
          let message = "";
          if (reason === "not-fast-forward") {
            message = " because it was not a simple fast-forward";
          } else if (reason === "tag-exists") {
            message = " because tag already exists";
          }
          super(`Push rejected${message}. Use "force: true" to override.`);
          this.code = this.name = _PushRejectedError.code;
          this.data = { reason };
        }
      };
      PushRejectedError.code = "PushRejectedError";
      var RemoteCapabilityError = class _RemoteCapabilityError extends BaseError2 {
        /**
         * @param {'shallow'|'deepen-since'|'deepen-not'|'deepen-relative'} capability
         * @param {'depth'|'since'|'exclude'|'relative'} parameter
         */
        constructor(capability, parameter) {
          super(
            `Remote does not support the "${capability}" so the "${parameter}" parameter cannot be used.`
          );
          this.code = this.name = _RemoteCapabilityError.code;
          this.data = { capability, parameter };
        }
      };
      RemoteCapabilityError.code = "RemoteCapabilityError";
      var SmartHttpError = class _SmartHttpError extends BaseError2 {
        /**
         * @param {string} preview
         * @param {string} response
         */
        constructor(preview, response) {
          super(
            `Remote did not reply using the "smart" HTTP protocol. Expected "001e# service=git-upload-pack" but received: ${preview}`
          );
          this.code = this.name = _SmartHttpError.code;
          this.data = { preview, response };
        }
      };
      SmartHttpError.code = "SmartHttpError";
      var UnknownTransportError = class _UnknownTransportError extends BaseError2 {
        /**
         * @param {string} url
         * @param {string} transport
         * @param {string} [suggestion]
         */
        constructor(url, transport, suggestion) {
          super(
            `Git remote "${url}" uses an unrecognized transport protocol: "${transport}"`
          );
          this.code = this.name = _UnknownTransportError.code;
          this.data = { url, transport, suggestion };
        }
      };
      UnknownTransportError.code = "UnknownTransportError";
      var UrlParseError = class _UrlParseError extends BaseError2 {
        /**
         * @param {string} url
         */
        constructor(url) {
          super(`Cannot parse remote URL: "${url}"`);
          this.code = this.name = _UrlParseError.code;
          this.data = { url };
        }
      };
      UrlParseError.code = "UrlParseError";
      var UserCanceledError = class _UserCanceledError extends BaseError2 {
        constructor() {
          super(`The operation was canceled.`);
          this.code = this.name = _UserCanceledError.code;
          this.data = {};
        }
      };
      UserCanceledError.code = "UserCanceledError";
      var IndexResetError = class _IndexResetError extends BaseError2 {
        /**
         * @param {Array<string>} filepaths
         */
        constructor(filepath) {
          super(
            `Could not merge index: Entry for '${filepath}' is not up to date. Either reset the index entry to HEAD, or stage your unstaged changes.`
          );
          this.code = this.name = _IndexResetError.code;
          this.data = { filepath };
        }
      };
      IndexResetError.code = "IndexResetError";
      var NoCommitError = class _NoCommitError extends BaseError2 {
        /**
         * @param {string} ref
         */
        constructor(ref) {
          super(
            `"${ref}" does not point to any commit. You're maybe working on a repository with no commits yet. `
          );
          this.code = this.name = _NoCommitError.code;
          this.data = { ref };
        }
      };
      NoCommitError.code = "NoCommitError";
      var Errors = /* @__PURE__ */ Object.freeze({
        __proto__: null,
        AlreadyExistsError,
        AmbiguousError,
        CheckoutConflictError,
        CommitNotFetchedError,
        EmptyServerResponseError,
        FastForwardError,
        GitPushError,
        HttpError: HttpError2,
        InternalError: InternalError2,
        InvalidFilepathError,
        InvalidOidError,
        InvalidRefNameError,
        MaxDepthError,
        MergeNotSupportedError,
        MergeConflictError,
        MissingNameError,
        MissingParameterError,
        MultipleGitError,
        NoRefspecError,
        NotFoundError,
        ObjectTypeError,
        ParseError: ParseError3,
        PushRejectedError,
        RemoteCapabilityError,
        SmartHttpError,
        UnknownTransportError,
        UnsafeFilepathError,
        UrlParseError,
        UserCanceledError,
        UnmergedPathsError,
        IndexResetError,
        NoCommitError
      });
      function formatAuthor({ name: name2, email, timestamp: timestamp2, timezoneOffset }) {
        timezoneOffset = formatTimezoneOffset(timezoneOffset);
        return `${name2} <${email}> ${timestamp2} ${timezoneOffset}`;
      }
      function formatTimezoneOffset(minutes) {
        const sign6 = simpleSign(negateExceptForZero(minutes));
        minutes = Math.abs(minutes);
        const hours = Math.floor(minutes / 60);
        minutes -= hours * 60;
        let strHours = String(hours);
        let strMinutes = String(minutes);
        if (strHours.length < 2) strHours = "0" + strHours;
        if (strMinutes.length < 2) strMinutes = "0" + strMinutes;
        return (sign6 === -1 ? "-" : "+") + strHours + strMinutes;
      }
      function simpleSign(n2) {
        return Math.sign(n2) || (Object.is(n2, -0) ? -1 : 1);
      }
      function negateExceptForZero(n2) {
        return n2 === 0 ? n2 : -n2;
      }
      function normalizeNewlines(str) {
        str = str.replace(/\r/g, "");
        str = str.replace(/^\n+/, "");
        str = str.replace(/\n+$/, "") + "\n";
        return str;
      }
      function parseAuthor(author) {
        const [, name2, email, timestamp2, offset] = author.match(
          /^(.*) <(.*)> (.*) (.*)$/
        );
        return {
          name: name2,
          email,
          timestamp: Number(timestamp2),
          timezoneOffset: parseTimezoneOffset(offset)
        };
      }
      function parseTimezoneOffset(offset) {
        let [, sign6, hours, minutes] = offset.match(/(\+|-)(\d\d)(\d\d)/);
        minutes = (sign6 === "+" ? 1 : -1) * (Number(hours) * 60 + Number(minutes));
        return negateExceptForZero$1(minutes);
      }
      function negateExceptForZero$1(n2) {
        return n2 === 0 ? n2 : -n2;
      }
      var GitAnnotatedTag = class _GitAnnotatedTag {
        constructor(tag2) {
          if (typeof tag2 === "string") {
            this._tag = tag2;
          } else if (Buffer.isBuffer(tag2)) {
            this._tag = tag2.toString("utf8");
          } else if (typeof tag2 === "object") {
            this._tag = _GitAnnotatedTag.render(tag2);
          } else {
            throw new InternalError2(
              "invalid type passed to GitAnnotatedTag constructor"
            );
          }
        }
        static from(tag2) {
          return new _GitAnnotatedTag(tag2);
        }
        static render(obj) {
          return `object ${obj.object}
type ${obj.type}
tag ${obj.tag}
tagger ${formatAuthor(obj.tagger)}

${obj.message}
${obj.gpgsig ? obj.gpgsig : ""}`;
        }
        justHeaders() {
          return this._tag.slice(0, this._tag.indexOf("\n\n"));
        }
        message() {
          const tag2 = this.withoutSignature();
          return tag2.slice(tag2.indexOf("\n\n") + 2);
        }
        parse() {
          return Object.assign(this.headers(), {
            message: this.message(),
            gpgsig: this.gpgsig()
          });
        }
        render() {
          return this._tag;
        }
        headers() {
          const headers = this.justHeaders().split("\n");
          const hs = [];
          for (const h of headers) {
            if (h[0] === " ") {
              hs[hs.length - 1] += "\n" + h.slice(1);
            } else {
              hs.push(h);
            }
          }
          const obj = {};
          for (const h of hs) {
            const key = h.slice(0, h.indexOf(" "));
            const value = h.slice(h.indexOf(" ") + 1);
            if (Array.isArray(obj[key])) {
              obj[key].push(value);
            } else {
              obj[key] = value;
            }
          }
          if (obj.tagger) {
            obj.tagger = parseAuthor(obj.tagger);
          }
          if (obj.committer) {
            obj.committer = parseAuthor(obj.committer);
          }
          return obj;
        }
        withoutSignature() {
          const tag2 = normalizeNewlines(this._tag);
          if (tag2.indexOf("\n-----BEGIN PGP SIGNATURE-----") === -1) return tag2;
          return tag2.slice(0, tag2.lastIndexOf("\n-----BEGIN PGP SIGNATURE-----"));
        }
        gpgsig() {
          if (this._tag.indexOf("\n-----BEGIN PGP SIGNATURE-----") === -1) return;
          const signature = this._tag.slice(
            this._tag.indexOf("-----BEGIN PGP SIGNATURE-----"),
            this._tag.indexOf("-----END PGP SIGNATURE-----") + "-----END PGP SIGNATURE-----".length
          );
          return normalizeNewlines(signature);
        }
        payload() {
          return this.withoutSignature() + "\n";
        }
        toObject() {
          return Buffer.from(this._tag, "utf8");
        }
        static async sign(tag2, sign6, secretKey) {
          const payload = tag2.payload();
          let { signature } = await sign6({ payload, secretKey });
          signature = normalizeNewlines(signature);
          const signedTag = payload + signature;
          return _GitAnnotatedTag.from(signedTag);
        }
      };
      function indent(str) {
        return str.trim().split("\n").map((x) => " " + x).join("\n") + "\n";
      }
      function outdent(str) {
        return str.split("\n").map((x) => x.replace(/^ /, "")).join("\n");
      }
      var GitCommit = class _GitCommit {
        constructor(commit2) {
          if (typeof commit2 === "string") {
            this._commit = commit2;
          } else if (Buffer.isBuffer(commit2)) {
            this._commit = commit2.toString("utf8");
          } else if (typeof commit2 === "object") {
            this._commit = _GitCommit.render(commit2);
          } else {
            throw new InternalError2("invalid type passed to GitCommit constructor");
          }
        }
        static fromPayloadSignature({ payload, signature }) {
          const headers = _GitCommit.justHeaders(payload);
          const message = _GitCommit.justMessage(payload);
          const commit2 = normalizeNewlines(
            headers + "\ngpgsig" + indent(signature) + "\n" + message
          );
          return new _GitCommit(commit2);
        }
        static from(commit2) {
          return new _GitCommit(commit2);
        }
        toObject() {
          return Buffer.from(this._commit, "utf8");
        }
        // Todo: allow setting the headers and message
        headers() {
          return this.parseHeaders();
        }
        // Todo: allow setting the headers and message
        message() {
          return _GitCommit.justMessage(this._commit);
        }
        parse() {
          return Object.assign({ message: this.message() }, this.headers());
        }
        static justMessage(commit2) {
          return normalizeNewlines(commit2.slice(commit2.indexOf("\n\n") + 2));
        }
        static justHeaders(commit2) {
          return commit2.slice(0, commit2.indexOf("\n\n"));
        }
        parseHeaders() {
          const headers = _GitCommit.justHeaders(this._commit).split("\n");
          const hs = [];
          for (const h of headers) {
            if (h[0] === " ") {
              hs[hs.length - 1] += "\n" + h.slice(1);
            } else {
              hs.push(h);
            }
          }
          const obj = {
            parent: []
          };
          for (const h of hs) {
            const key = h.slice(0, h.indexOf(" "));
            const value = h.slice(h.indexOf(" ") + 1);
            if (Array.isArray(obj[key])) {
              obj[key].push(value);
            } else {
              obj[key] = value;
            }
          }
          if (obj.author) {
            obj.author = parseAuthor(obj.author);
          }
          if (obj.committer) {
            obj.committer = parseAuthor(obj.committer);
          }
          return obj;
        }
        static renderHeaders(obj) {
          let headers = "";
          if (obj.tree) {
            headers += `tree ${obj.tree}
`;
          } else {
            headers += `tree 4b825dc642cb6eb9a060e54bf8d69288fbee4904
`;
          }
          if (obj.parent) {
            if (obj.parent.length === void 0) {
              throw new InternalError2(`commit 'parent' property should be an array`);
            }
            for (const p12 of obj.parent) {
              headers += `parent ${p12}
`;
            }
          }
          const author = obj.author;
          headers += `author ${formatAuthor(author)}
`;
          const committer = obj.committer || obj.author;
          headers += `committer ${formatAuthor(committer)}
`;
          if (obj.gpgsig) {
            headers += "gpgsig" + indent(obj.gpgsig);
          }
          return headers;
        }
        static render(obj) {
          return _GitCommit.renderHeaders(obj) + "\n" + normalizeNewlines(obj.message);
        }
        render() {
          return this._commit;
        }
        withoutSignature() {
          const commit2 = normalizeNewlines(this._commit);
          if (commit2.indexOf("\ngpgsig") === -1) return commit2;
          const headers = commit2.slice(0, commit2.indexOf("\ngpgsig"));
          const message = commit2.slice(
            commit2.indexOf("-----END PGP SIGNATURE-----\n") + "-----END PGP SIGNATURE-----\n".length
          );
          return normalizeNewlines(headers + "\n" + message);
        }
        isolateSignature() {
          const signature = this._commit.slice(
            this._commit.indexOf("-----BEGIN PGP SIGNATURE-----"),
            this._commit.indexOf("-----END PGP SIGNATURE-----") + "-----END PGP SIGNATURE-----".length
          );
          return outdent(signature);
        }
        static async sign(commit2, sign6, secretKey) {
          const payload = commit2.withoutSignature();
          const message = _GitCommit.justMessage(commit2._commit);
          let { signature } = await sign6({ payload, secretKey });
          signature = normalizeNewlines(signature);
          const headers = _GitCommit.justHeaders(commit2._commit);
          const signedCommit = headers + "\ngpgsig" + indent(signature) + "\n" + message;
          return _GitCommit.from(signedCommit);
        }
      };
      async function resolveTree({ fs: fs2, cache: cache2, gitdir, oid }) {
        if (oid === "4b825dc642cb6eb9a060e54bf8d69288fbee4904") {
          return { tree: GitTree.from([]), oid };
        }
        const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
        if (type === "tag") {
          oid = GitAnnotatedTag.from(object).parse().object;
          return resolveTree({ fs: fs2, cache: cache2, gitdir, oid });
        }
        if (type === "commit") {
          oid = GitCommit.from(object).parse().tree;
          return resolveTree({ fs: fs2, cache: cache2, gitdir, oid });
        }
        if (type !== "tree") {
          throw new ObjectTypeError(oid, type, "tree");
        }
        return { tree: GitTree.from(object), oid };
      }
      var GitWalkerRepo = class {
        constructor({ fs: fs2, gitdir, ref, cache: cache2 }) {
          this.fs = fs2;
          this.cache = cache2;
          this.gitdir = gitdir;
          this.mapPromise = (async () => {
            const map = /* @__PURE__ */ new Map();
            let oid;
            try {
              oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref });
            } catch (e2) {
              if (e2 instanceof NotFoundError) {
                oid = "4b825dc642cb6eb9a060e54bf8d69288fbee4904";
              }
            }
            const tree = await resolveTree({ fs: fs2, cache: this.cache, gitdir, oid });
            tree.type = "tree";
            tree.mode = "40000";
            map.set(".", tree);
            return map;
          })();
          const walker = this;
          this.ConstructEntry = class TreeEntry {
            constructor(fullpath) {
              this._fullpath = fullpath;
              this._type = false;
              this._mode = false;
              this._stat = false;
              this._content = false;
              this._oid = false;
            }
            async type() {
              return walker.type(this);
            }
            async mode() {
              return walker.mode(this);
            }
            async stat() {
              return walker.stat(this);
            }
            async content() {
              return walker.content(this);
            }
            async oid() {
              return walker.oid(this);
            }
          };
        }
        async readdir(entry) {
          const filepath = entry._fullpath;
          const { fs: fs2, cache: cache2, gitdir } = this;
          const map = await this.mapPromise;
          const obj = map.get(filepath);
          if (!obj) throw new Error(`No obj for ${filepath}`);
          const oid = obj.oid;
          if (!oid) throw new Error(`No oid for obj ${JSON.stringify(obj)}`);
          if (obj.type !== "tree") {
            return null;
          }
          const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
          if (type !== obj.type) {
            throw new ObjectTypeError(oid, type, obj.type);
          }
          const tree = GitTree.from(object);
          for (const entry2 of tree) {
            map.set(pathBrowserify.join(filepath, entry2.path), entry2);
          }
          return tree.entries().map((entry2) => pathBrowserify.join(filepath, entry2.path));
        }
        async type(entry) {
          if (entry._type === false) {
            const map = await this.mapPromise;
            const { type } = map.get(entry._fullpath);
            entry._type = type;
          }
          return entry._type;
        }
        async mode(entry) {
          if (entry._mode === false) {
            const map = await this.mapPromise;
            const { mode } = map.get(entry._fullpath);
            entry._mode = normalizeMode2(parseInt(mode, 8));
          }
          return entry._mode;
        }
        async stat(_entry) {
        }
        async content(entry) {
          if (entry._content === false) {
            const map = await this.mapPromise;
            const { fs: fs2, cache: cache2, gitdir } = this;
            const obj = map.get(entry._fullpath);
            const oid = obj.oid;
            const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
            if (type !== "blob") {
              entry._content = void 0;
            } else {
              entry._content = new Uint8Array(object);
            }
          }
          return entry._content;
        }
        async oid(entry) {
          if (entry._oid === false) {
            const map = await this.mapPromise;
            const obj = map.get(entry._fullpath);
            entry._oid = obj.oid;
          }
          return entry._oid;
        }
      };
      function TREE({ ref = "HEAD" } = {}) {
        const o = /* @__PURE__ */ Object.create(null);
        Object.defineProperty(o, GitWalkSymbol, {
          value: function({ fs: fs2, gitdir, cache: cache2 }) {
            return new GitWalkerRepo({ fs: fs2, gitdir, ref, cache: cache2 });
          }
        });
        Object.freeze(o);
        return o;
      }
      var GitWalkerFs = class {
        constructor({ fs: fs2, dir, gitdir, cache: cache2 }) {
          this.fs = fs2;
          this.cache = cache2;
          this.dir = dir;
          this.gitdir = gitdir;
          this.config = null;
          const walker = this;
          this.ConstructEntry = class WorkdirEntry {
            constructor(fullpath) {
              this._fullpath = fullpath;
              this._type = false;
              this._mode = false;
              this._stat = false;
              this._content = false;
              this._oid = false;
            }
            async type() {
              return walker.type(this);
            }
            async mode() {
              return walker.mode(this);
            }
            async stat() {
              return walker.stat(this);
            }
            async content() {
              return walker.content(this);
            }
            async oid() {
              return walker.oid(this);
            }
          };
        }
        async readdir(entry) {
          const filepath = entry._fullpath;
          const { fs: fs2, dir } = this;
          const names = await fs2.readdir(pathBrowserify.join(dir, filepath));
          if (names === null) return null;
          return names.map((name2) => pathBrowserify.join(filepath, name2));
        }
        async type(entry) {
          if (entry._type === false) {
            await entry.stat();
          }
          return entry._type;
        }
        async mode(entry) {
          if (entry._mode === false) {
            await entry.stat();
          }
          return entry._mode;
        }
        async stat(entry) {
          if (entry._stat === false) {
            const { fs: fs2, dir } = this;
            let stat3 = await fs2.lstat(`${dir}/${entry._fullpath}`);
            if (!stat3) {
              throw new Error(
                `ENOENT: no such file or directory, lstat '${entry._fullpath}'`
              );
            }
            let type = stat3.isDirectory() ? "tree" : "blob";
            if (type === "blob" && !stat3.isFile() && !stat3.isSymbolicLink()) {
              type = "special";
            }
            entry._type = type;
            stat3 = normalizeStats(stat3);
            entry._mode = stat3.mode;
            if (stat3.size === -1 && entry._actualSize) {
              stat3.size = entry._actualSize;
            }
            entry._stat = stat3;
          }
          return entry._stat;
        }
        async content(entry) {
          if (entry._content === false) {
            const { fs: fs2, dir, gitdir } = this;
            if (await entry.type() === "tree") {
              entry._content = void 0;
            } else {
              const config = await this._getGitConfig(fs2, gitdir);
              const autocrlf = await config.get("core.autocrlf");
              const content = await fs2.read(`${dir}/${entry._fullpath}`, { autocrlf });
              entry._actualSize = content.length;
              if (entry._stat && entry._stat.size === -1) {
                entry._stat.size = entry._actualSize;
              }
              entry._content = new Uint8Array(content);
            }
          }
          return entry._content;
        }
        async oid(entry) {
          if (entry._oid === false) {
            const self2 = this;
            const { fs: fs2, gitdir, cache: cache2 } = this;
            let oid;
            await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
              const stage = index3.entriesMap.get(entry._fullpath);
              const stats = await entry.stat();
              const config = await self2._getGitConfig(fs2, gitdir);
              const filemode = await config.get("core.filemode");
              const trustino = typeof process !== "undefined" ? !(process.platform === "win32") : true;
              if (!stage || compareStats(stats, stage, filemode, trustino)) {
                const content = await entry.content();
                if (content === void 0) {
                  oid = void 0;
                } else {
                  oid = await shasum(
                    GitObject.wrap({ type: "blob", object: content })
                  );
                  if (stage && oid === stage.oid && (!filemode || stats.mode === stage.mode) && compareStats(stats, stage, filemode, trustino)) {
                    index3.insert({
                      filepath: entry._fullpath,
                      stats,
                      oid
                    });
                  }
                }
              } else {
                oid = stage.oid;
              }
            });
            entry._oid = oid;
          }
          return entry._oid;
        }
        async _getGitConfig(fs2, gitdir) {
          if (this.config) {
            return this.config;
          }
          this.config = await GitConfigManager.get({ fs: fs2, gitdir });
          return this.config;
        }
      };
      function WORKDIR() {
        const o = /* @__PURE__ */ Object.create(null);
        Object.defineProperty(o, GitWalkSymbol, {
          value: function({ fs: fs2, dir, gitdir, cache: cache2 }) {
            return new GitWalkerFs({ fs: fs2, dir, gitdir, cache: cache2 });
          }
        });
        Object.freeze(o);
        return o;
      }
      function arrayRange(start, end) {
        const length2 = end - start;
        return Array.from({ length: length2 }, (_2, i2) => start + i2);
      }
      var flat = typeof Array.prototype.flat === "undefined" ? (entries2) => entries2.reduce((acc, x) => acc.concat(x), []) : (entries2) => entries2.flat();
      var RunningMinimum = class {
        constructor() {
          this.value = null;
        }
        consider(value) {
          if (value === null || value === void 0) return;
          if (this.value === null) {
            this.value = value;
          } else if (value < this.value) {
            this.value = value;
          }
        }
        reset() {
          this.value = null;
        }
      };
      function* unionOfIterators(sets) {
        const min = new RunningMinimum();
        let minimum;
        const heads = [];
        const numsets = sets.length;
        for (let i2 = 0; i2 < numsets; i2++) {
          heads[i2] = sets[i2].next().value;
          if (heads[i2] !== void 0) {
            min.consider(heads[i2]);
          }
        }
        if (min.value === null) return;
        while (true) {
          const result = [];
          minimum = min.value;
          min.reset();
          for (let i2 = 0; i2 < numsets; i2++) {
            if (heads[i2] !== void 0 && heads[i2] === minimum) {
              result[i2] = heads[i2];
              heads[i2] = sets[i2].next().value;
            } else {
              result[i2] = null;
            }
            if (heads[i2] !== void 0) {
              min.consider(heads[i2]);
            }
          }
          yield result;
          if (min.value === null) return;
        }
      }
      async function _walk({
        fs: fs2,
        cache: cache2,
        dir,
        gitdir,
        trees,
        // @ts-ignore
        map = async (_2, entry) => entry,
        // The default reducer is a flatmap that filters out undefineds.
        reduce = async (parent, children) => {
          const flatten2 = flat(children);
          if (parent !== void 0) flatten2.unshift(parent);
          return flatten2;
        },
        // The default iterate function walks all children concurrently
        iterate = (walk2, children) => Promise.all([...children].map(walk2))
      }) {
        const walkers = trees.map(
          (proxy) => proxy[GitWalkSymbol]({ fs: fs2, dir, gitdir, cache: cache2 })
        );
        const root = new Array(walkers.length).fill(".");
        const range = arrayRange(0, walkers.length);
        const unionWalkerFromReaddir = async (entries2) => {
          range.map((i2) => {
            const entry = entries2[i2];
            entries2[i2] = entry && new walkers[i2].ConstructEntry(entry);
          });
          const subdirs = await Promise.all(
            range.map((i2) => {
              const entry = entries2[i2];
              return entry ? walkers[i2].readdir(entry) : [];
            })
          );
          const iterators = subdirs.map((array) => {
            return (array === null ? [] : array)[Symbol.iterator]();
          });
          return {
            entries: entries2,
            children: unionOfIterators(iterators)
          };
        };
        const walk2 = async (root2) => {
          const { entries: entries2, children } = await unionWalkerFromReaddir(root2);
          const fullpath = entries2.find((entry) => entry && entry._fullpath)._fullpath;
          const parent = await map(fullpath, entries2);
          if (parent !== null) {
            let walkedChildren = await iterate(walk2, children);
            walkedChildren = walkedChildren.filter((x) => x !== void 0);
            return reduce(parent, walkedChildren);
          }
        };
        return walk2(root);
      }
      async function rmRecursive(fs2, filepath) {
        const entries2 = await fs2.readdir(filepath);
        if (entries2 == null) {
          await fs2.rm(filepath);
        } else if (entries2.length) {
          await Promise.all(
            entries2.map((entry) => {
              const subpath = pathBrowserify.join(filepath, entry);
              return fs2.lstat(subpath).then((stat3) => {
                if (!stat3) return;
                return stat3.isDirectory() ? rmRecursive(fs2, subpath) : fs2.rm(subpath);
              });
            })
          ).then(() => fs2.rmdir(filepath));
        } else {
          await fs2.rmdir(filepath);
        }
      }
      function isPromiseLike(obj) {
        return isObject3(obj) && isFunction2(obj.then) && isFunction2(obj.catch);
      }
      function isObject3(obj) {
        return obj && typeof obj === "object";
      }
      function isFunction2(obj) {
        return typeof obj === "function";
      }
      function isPromiseFs(fs2) {
        const test = (targetFs) => {
          try {
            return targetFs.readFile().catch((e2) => e2);
          } catch (e2) {
            return e2;
          }
        };
        return isPromiseLike(test(fs2));
      }
      var commands = [
        "readFile",
        "writeFile",
        "mkdir",
        "rmdir",
        "unlink",
        "stat",
        "lstat",
        "readdir",
        "readlink",
        "symlink"
      ];
      function bindFs(target, fs2) {
        if (isPromiseFs(fs2)) {
          for (const command of commands) {
            target[`_${command}`] = fs2[command].bind(fs2);
          }
        } else {
          for (const command of commands) {
            target[`_${command}`] = pify(fs2[command].bind(fs2));
          }
        }
        if (isPromiseFs(fs2)) {
          if (fs2.rm) target._rm = fs2.rm.bind(fs2);
          else if (fs2.rmdir.length > 1) target._rm = fs2.rmdir.bind(fs2);
          else target._rm = rmRecursive.bind(null, target);
        } else {
          if (fs2.rm) target._rm = pify(fs2.rm.bind(fs2));
          else if (fs2.rmdir.length > 2) target._rm = pify(fs2.rmdir.bind(fs2));
          else target._rm = rmRecursive.bind(null, target);
        }
      }
      var FileSystem2 = class {
        constructor(fs2) {
          if (typeof fs2._original_unwrapped_fs !== "undefined") return fs2;
          const promises = Object.getOwnPropertyDescriptor(fs2, "promises");
          if (promises && promises.enumerable) {
            bindFs(this, fs2.promises);
          } else {
            bindFs(this, fs2);
          }
          this._original_unwrapped_fs = fs2;
        }
        /**
         * Return true if a file exists, false if it doesn't exist.
         * Rethrows errors that aren't related to file existence.
         */
        async exists(filepath, options = {}) {
          try {
            await this._stat(filepath);
            return true;
          } catch (err3) {
            if (err3.code === "ENOENT" || err3.code === "ENOTDIR" || (err3.code || "").includes("ENS")) {
              return false;
            } else {
              console.log('Unhandled error in "FileSystem.exists()" function', err3);
              throw err3;
            }
          }
        }
        /**
         * Return the contents of a file if it exists, otherwise returns null.
         *
         * @param {string} filepath
         * @param {object} [options]
         *
         * @returns {Promise<Buffer|string|null>}
         */
        async read(filepath, options = {}) {
          try {
            let buffer = await this._readFile(filepath, options);
            if (options.autocrlf === "true") {
              try {
                buffer = new TextDecoder("utf8", { fatal: true }).decode(buffer);
                buffer = buffer.replace(/\r\n/g, "\n");
                buffer = new TextEncoder().encode(buffer);
              } catch (error) {
              }
            }
            if (typeof buffer !== "string") {
              buffer = Buffer.from(buffer);
            }
            return buffer;
          } catch (err3) {
            return null;
          }
        }
        /**
         * Write a file (creating missing directories if need be) without throwing errors.
         *
         * @param {string} filepath
         * @param {Buffer|Uint8Array|string} contents
         * @param {object|string} [options]
         */
        async write(filepath, contents, options = {}) {
          try {
            await this._writeFile(filepath, contents, options);
            return;
          } catch (err3) {
            await this.mkdir(dirname3(filepath));
            await this._writeFile(filepath, contents, options);
          }
        }
        /**
         * Make a directory (or series of nested directories) without throwing an error if it already exists.
         */
        async mkdir(filepath, _selfCall = false) {
          try {
            await this._mkdir(filepath);
            return;
          } catch (err3) {
            if (err3 === null) return;
            if (err3.code === "EEXIST") return;
            if (_selfCall) throw err3;
            if (err3.code === "ENOENT") {
              const parent = dirname3(filepath);
              if (parent === "." || parent === "/" || parent === filepath) throw err3;
              await this.mkdir(parent);
              await this.mkdir(filepath, true);
            }
          }
        }
        /**
         * Delete a file without throwing an error if it is already deleted.
         */
        async rm(filepath) {
          try {
            await this._unlink(filepath);
          } catch (err3) {
            if (err3.code !== "ENOENT") throw err3;
          }
        }
        /**
         * Delete a directory without throwing an error if it is already deleted.
         */
        async rmdir(filepath, opts) {
          try {
            if (opts && opts.recursive) {
              await this._rm(filepath, opts);
            } else {
              await this._rmdir(filepath);
            }
          } catch (err3) {
            if (err3.code !== "ENOENT") throw err3;
          }
        }
        /**
         * Read a directory without throwing an error is the directory doesn't exist
         */
        async readdir(filepath) {
          try {
            const names = await this._readdir(filepath);
            names.sort(compareStrings);
            return names;
          } catch (err3) {
            if (err3.code === "ENOTDIR") return null;
            return [];
          }
        }
        /**
         * Return a flast list of all the files nested inside a directory
         *
         * Based on an elegant concurrent recursive solution from SO
         * https://stackoverflow.com/a/45130990/2168416
         */
        async readdirDeep(dir) {
          const subdirs = await this._readdir(dir);
          const files = await Promise.all(
            subdirs.map(async (subdir) => {
              const res = dir + "/" + subdir;
              return (await this._stat(res)).isDirectory() ? this.readdirDeep(res) : res;
            })
          );
          return files.reduce((a, f) => a.concat(f), []);
        }
        /**
         * Return the Stats of a file/symlink if it exists, otherwise returns null.
         * Rethrows errors that aren't related to file existence.
         */
        async lstat(filename) {
          try {
            const stats = await this._lstat(filename);
            return stats;
          } catch (err3) {
            if (err3.code === "ENOENT" || (err3.code || "").includes("ENS")) {
              return null;
            }
            throw err3;
          }
        }
        /**
         * Reads the contents of a symlink if it exists, otherwise returns null.
         * Rethrows errors that aren't related to file existence.
         */
        async readlink(filename, opts = { encoding: "buffer" }) {
          try {
            const link3 = await this._readlink(filename, opts);
            return Buffer.isBuffer(link3) ? link3 : Buffer.from(link3);
          } catch (err3) {
            if (err3.code === "ENOENT" || (err3.code || "").includes("ENS")) {
              return null;
            }
            throw err3;
          }
        }
        /**
         * Write the contents of buffer to a symlink.
         */
        async writelink(filename, buffer) {
          return this._symlink(buffer.toString("utf8"), filename);
        }
      };
      function assertParameter(name2, value) {
        if (value === void 0) {
          throw new MissingParameterError(name2);
        }
      }
      async function modified(entry, base2) {
        if (!entry && !base2) return false;
        if (entry && !base2) return true;
        if (!entry && base2) return true;
        if (await entry.type() === "tree" && await base2.type() === "tree") {
          return false;
        }
        if (await entry.type() === await base2.type() && await entry.mode() === await base2.mode() && await entry.oid() === await base2.oid()) {
          return false;
        }
        return true;
      }
      async function abortMerge({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        commit: commit2 = "HEAD",
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("dir", dir);
          assertParameter("gitdir", gitdir);
          const fs2 = new FileSystem2(_fs);
          const trees = [TREE({ ref: commit2 }), WORKDIR(), STAGE()];
          let unmergedPaths = [];
          await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            unmergedPaths = index3.unmergedPaths;
          });
          const results = await _walk({
            fs: fs2,
            cache: cache2,
            dir,
            gitdir,
            trees,
            map: async function(path3, [head, workdir, index3]) {
              const staged = !await modified(workdir, index3);
              const unmerged = unmergedPaths.includes(path3);
              const unmodified = !await modified(index3, head);
              if (staged || unmerged) {
                return head ? {
                  path: path3,
                  mode: await head.mode(),
                  oid: await head.oid(),
                  type: await head.type(),
                  content: await head.content()
                } : void 0;
              }
              if (unmodified) return false;
              else throw new IndexResetError(path3);
            }
          });
          await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            for (const entry of results) {
              if (entry === false) continue;
              if (!entry) {
                await fs2.rmdir(`${dir}/${entry.path}`, { recursive: true });
                index3.delete({ filepath: entry.path });
                continue;
              }
              if (entry.type === "blob") {
                const content = new TextDecoder().decode(entry.content);
                await fs2.write(`${dir}/${entry.path}`, content, { mode: entry.mode });
                index3.insert({
                  filepath: entry.path,
                  oid: entry.oid,
                  stage: 0
                });
              }
            }
          });
        } catch (err3) {
          err3.caller = "git.abortMerge";
          throw err3;
        }
      }
      var GitIgnoreManager = class {
        static async isIgnored({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), filepath }) {
          if (basename2(filepath) === ".git") return true;
          if (filepath === ".") return false;
          let excludes = "";
          const excludesFile = pathBrowserify.join(gitdir, "info", "exclude");
          if (await fs2.exists(excludesFile)) {
            excludes = await fs2.read(excludesFile, "utf8");
          }
          const pairs = [
            {
              gitignore: pathBrowserify.join(dir, ".gitignore"),
              filepath
            }
          ];
          const pieces = filepath.split("/").filter(Boolean);
          for (let i2 = 1; i2 < pieces.length; i2++) {
            const folder = pieces.slice(0, i2).join("/");
            const file = pieces.slice(i2).join("/");
            pairs.push({
              gitignore: pathBrowserify.join(dir, folder, ".gitignore"),
              filepath: file
            });
          }
          let ignoredStatus = false;
          for (const p12 of pairs) {
            let file;
            try {
              file = await fs2.read(p12.gitignore, "utf8");
            } catch (err3) {
              if (err3.code === "NOENT") continue;
            }
            const ign = ignore().add(excludes);
            ign.add(file);
            const parentdir = dirname3(p12.filepath);
            if (parentdir !== "." && ign.ignores(parentdir)) return true;
            if (ignoredStatus) {
              ignoredStatus = !ign.test(p12.filepath).unignored;
            } else {
              ignoredStatus = ign.test(p12.filepath).ignored;
            }
          }
          return ignoredStatus;
        }
      };
      async function writeObjectLoose({ fs: fs2, gitdir, object, format: format5, oid }) {
        if (format5 !== "deflated") {
          throw new InternalError2(
            "GitObjectStoreLoose expects objects to write to be in deflated format"
          );
        }
        const source = `objects/${oid.slice(0, 2)}/${oid.slice(2)}`;
        const filepath = `${gitdir}/${source}`;
        if (!await fs2.exists(filepath)) await fs2.write(filepath, object);
      }
      var supportsCompressionStream = null;
      async function deflate(buffer) {
        if (supportsCompressionStream === null) {
          supportsCompressionStream = testCompressionStream();
        }
        return supportsCompressionStream ? browserDeflate(buffer) : pako.deflate(buffer);
      }
      async function browserDeflate(buffer) {
        const cs = new CompressionStream("deflate");
        const c = new Blob([buffer]).stream().pipeThrough(cs);
        return new Uint8Array(await new Response(c).arrayBuffer());
      }
      function testCompressionStream() {
        try {
          const cs = new CompressionStream("deflate");
          cs.writable.close();
          const stream = new Blob([]).stream();
          stream.cancel();
          return true;
        } catch (_2) {
          return false;
        }
      }
      async function _writeObject({
        fs: fs2,
        gitdir,
        type,
        object,
        format: format5 = "content",
        oid = void 0,
        dryRun = false
      }) {
        if (format5 !== "deflated") {
          if (format5 !== "wrapped") {
            object = GitObject.wrap({ type, object });
          }
          oid = await shasum(object);
          object = Buffer.from(await deflate(object));
        }
        if (!dryRun) {
          await writeObjectLoose({ fs: fs2, gitdir, object, format: "deflated", oid });
        }
        return oid;
      }
      function posixifyPathBuffer(buffer) {
        let idx;
        while (~(idx = buffer.indexOf(92))) buffer[idx] = 47;
        return buffer;
      }
      async function add2({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath,
        cache: cache2 = {},
        force = false,
        parallel = true
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("dir", dir);
          assertParameter("gitdir", gitdir);
          assertParameter("filepath", filepath);
          const fs2 = new FileSystem2(_fs);
          await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async (index3) => {
            const config = await GitConfigManager.get({ fs: fs2, gitdir });
            const autocrlf = await config.get("core.autocrlf");
            return addToIndex({
              dir,
              gitdir,
              fs: fs2,
              filepath,
              index: index3,
              force,
              parallel,
              autocrlf
            });
          });
        } catch (err3) {
          err3.caller = "git.add";
          throw err3;
        }
      }
      async function addToIndex({
        dir,
        gitdir,
        fs: fs2,
        filepath,
        index: index3,
        force,
        parallel,
        autocrlf
      }) {
        filepath = Array.isArray(filepath) ? filepath : [filepath];
        const promises = filepath.map(async (currentFilepath) => {
          if (!force) {
            const ignored = await GitIgnoreManager.isIgnored({
              fs: fs2,
              dir,
              gitdir,
              filepath: currentFilepath
            });
            if (ignored) return;
          }
          const stats = await fs2.lstat(pathBrowserify.join(dir, currentFilepath));
          if (!stats) throw new NotFoundError(currentFilepath);
          if (stats.isDirectory()) {
            const children = await fs2.readdir(pathBrowserify.join(dir, currentFilepath));
            if (parallel) {
              const promises2 = children.map(
                (child) => addToIndex({
                  dir,
                  gitdir,
                  fs: fs2,
                  filepath: [pathBrowserify.join(currentFilepath, child)],
                  index: index3,
                  force,
                  parallel,
                  autocrlf
                })
              );
              await Promise.all(promises2);
            } else {
              for (const child of children) {
                await addToIndex({
                  dir,
                  gitdir,
                  fs: fs2,
                  filepath: [pathBrowserify.join(currentFilepath, child)],
                  index: index3,
                  force,
                  parallel,
                  autocrlf
                });
              }
            }
          } else {
            const object = stats.isSymbolicLink() ? await fs2.readlink(pathBrowserify.join(dir, currentFilepath)).then(posixifyPathBuffer) : await fs2.read(pathBrowserify.join(dir, currentFilepath), { autocrlf });
            if (object === null) throw new NotFoundError(currentFilepath);
            const oid = await _writeObject({ fs: fs2, gitdir, type: "blob", object });
            index3.insert({ filepath: currentFilepath, stats, oid });
          }
        });
        const settledPromises = await Promise.allSettled(promises);
        const rejectedPromises = settledPromises.filter((settle2) => settle2.status === "rejected").map((settle2) => settle2.reason);
        if (rejectedPromises.length > 1) {
          throw new MultipleGitError(rejectedPromises);
        }
        if (rejectedPromises.length === 1) {
          throw rejectedPromises[0];
        }
        const fulfilledPromises = settledPromises.filter((settle2) => settle2.status === "fulfilled" && settle2.value).map((settle2) => settle2.value);
        return fulfilledPromises;
      }
      async function _getConfig({ fs: fs2, gitdir, path: path3 }) {
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        return config.get(path3);
      }
      function assignDefined(target, ...sources) {
        for (const source of sources) {
          if (source) {
            for (const key of Object.keys(source)) {
              const val = source[key];
              if (val !== void 0) {
                target[key] = val;
              }
            }
          }
        }
        return target;
      }
      async function normalizeAuthorObject({ fs: fs2, gitdir, author, commit: commit2 }) {
        const timestamp2 = Math.floor(Date.now() / 1e3);
        const defaultAuthor = {
          name: await _getConfig({ fs: fs2, gitdir, path: "user.name" }),
          email: await _getConfig({ fs: fs2, gitdir, path: "user.email" }) || "",
          // author.email is allowed to be empty string
          timestamp: timestamp2,
          timezoneOffset: new Date(timestamp2 * 1e3).getTimezoneOffset()
        };
        const normalizedAuthor = assignDefined(
          {},
          defaultAuthor,
          commit2 ? commit2.author : void 0,
          author
        );
        if (normalizedAuthor.name === void 0) {
          return void 0;
        }
        return normalizedAuthor;
      }
      async function normalizeCommitterObject({
        fs: fs2,
        gitdir,
        author,
        committer,
        commit: commit2
      }) {
        const timestamp2 = Math.floor(Date.now() / 1e3);
        const defaultCommitter = {
          name: await _getConfig({ fs: fs2, gitdir, path: "user.name" }),
          email: await _getConfig({ fs: fs2, gitdir, path: "user.email" }) || "",
          // committer.email is allowed to be empty string
          timestamp: timestamp2,
          timezoneOffset: new Date(timestamp2 * 1e3).getTimezoneOffset()
        };
        const normalizedCommitter = assignDefined(
          {},
          defaultCommitter,
          commit2 ? commit2.committer : void 0,
          author,
          committer
        );
        if (normalizedCommitter.name === void 0) {
          return void 0;
        }
        return normalizedCommitter;
      }
      async function resolveCommit({ fs: fs2, cache: cache2, gitdir, oid }) {
        const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
        if (type === "tag") {
          oid = GitAnnotatedTag.from(object).parse().object;
          return resolveCommit({ fs: fs2, cache: cache2, gitdir, oid });
        }
        if (type !== "commit") {
          throw new ObjectTypeError(oid, type, "commit");
        }
        return { commit: GitCommit.from(object), oid };
      }
      async function _readCommit({ fs: fs2, cache: cache2, gitdir, oid }) {
        const { commit: commit2, oid: commitOid } = await resolveCommit({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid
        });
        const result = {
          oid: commitOid,
          commit: commit2.parse(),
          payload: commit2.withoutSignature()
        };
        return result;
      }
      async function _commit({
        fs: fs2,
        cache: cache2,
        onSign,
        gitdir,
        message,
        author: _author,
        committer: _committer,
        signingKey,
        amend = false,
        dryRun = false,
        noUpdateBranch = false,
        ref,
        parent,
        tree
      }) {
        let initialCommit = false;
        if (!ref) {
          ref = await GitRefManager.resolve({
            fs: fs2,
            gitdir,
            ref: "HEAD",
            depth: 2
          });
        }
        let refOid, refCommit;
        try {
          refOid = await GitRefManager.resolve({
            fs: fs2,
            gitdir,
            ref
          });
          refCommit = await _readCommit({ fs: fs2, gitdir, oid: refOid, cache: {} });
        } catch {
          initialCommit = true;
        }
        if (amend && initialCommit) {
          throw new NoCommitError(ref);
        }
        const author = !amend ? await normalizeAuthorObject({ fs: fs2, gitdir, author: _author }) : await normalizeAuthorObject({
          fs: fs2,
          gitdir,
          author: _author,
          commit: refCommit.commit
        });
        if (!author) throw new MissingNameError("author");
        const committer = !amend ? await normalizeCommitterObject({
          fs: fs2,
          gitdir,
          author,
          committer: _committer
        }) : await normalizeCommitterObject({
          fs: fs2,
          gitdir,
          author,
          committer: _committer,
          commit: refCommit.commit
        });
        if (!committer) throw new MissingNameError("committer");
        return GitIndexManager.acquire(
          { fs: fs2, gitdir, cache: cache2, allowUnmerged: false },
          async function(index3) {
            const inodes = flatFileListToDirectoryStructure(index3.entries);
            const inode = inodes.get(".");
            if (!tree) {
              tree = await constructTree({ fs: fs2, gitdir, inode, dryRun });
            }
            if (!parent) {
              if (!amend) {
                parent = refOid ? [refOid] : [];
              } else {
                parent = refCommit.commit.parent;
              }
            } else {
              parent = await Promise.all(
                parent.map((p12) => {
                  return GitRefManager.resolve({ fs: fs2, gitdir, ref: p12 });
                })
              );
            }
            if (!message) {
              if (!amend) {
                throw new MissingParameterError("message");
              } else {
                message = refCommit.commit.message;
              }
            }
            let comm = GitCommit.from({
              tree,
              parent,
              author,
              committer,
              message
            });
            if (signingKey) {
              comm = await GitCommit.sign(comm, onSign, signingKey);
            }
            const oid = await _writeObject({
              fs: fs2,
              gitdir,
              type: "commit",
              object: comm.toObject(),
              dryRun
            });
            if (!noUpdateBranch && !dryRun) {
              await GitRefManager.writeRef({
                fs: fs2,
                gitdir,
                ref,
                value: oid
              });
            }
            return oid;
          }
        );
      }
      async function constructTree({ fs: fs2, gitdir, inode, dryRun }) {
        const children = inode.children;
        for (const inode2 of children) {
          if (inode2.type === "tree") {
            inode2.metadata.mode = "040000";
            inode2.metadata.oid = await constructTree({ fs: fs2, gitdir, inode: inode2, dryRun });
          }
        }
        const entries2 = children.map((inode2) => ({
          mode: inode2.metadata.mode,
          path: inode2.basename,
          oid: inode2.metadata.oid,
          type: inode2.type
        }));
        const tree = GitTree.from(entries2);
        const oid = await _writeObject({
          fs: fs2,
          gitdir,
          type: "tree",
          object: tree.toObject(),
          dryRun
        });
        return oid;
      }
      async function resolveFilepath2({ fs: fs2, cache: cache2, gitdir, oid, filepath }) {
        if (filepath.startsWith("/")) {
          throw new InvalidFilepathError("leading-slash");
        } else if (filepath.endsWith("/")) {
          throw new InvalidFilepathError("trailing-slash");
        }
        const _oid = oid;
        const result = await resolveTree({ fs: fs2, cache: cache2, gitdir, oid });
        const tree = result.tree;
        if (filepath === "") {
          oid = result.oid;
        } else {
          const pathArray = filepath.split("/");
          oid = await _resolveFilepath({
            fs: fs2,
            cache: cache2,
            gitdir,
            tree,
            pathArray,
            oid: _oid,
            filepath
          });
        }
        return oid;
      }
      async function _resolveFilepath({
        fs: fs2,
        cache: cache2,
        gitdir,
        tree,
        pathArray,
        oid,
        filepath
      }) {
        const name2 = pathArray.shift();
        for (const entry of tree) {
          if (entry.path === name2) {
            if (pathArray.length === 0) {
              return entry.oid;
            } else {
              const { type, object } = await _readObject({
                fs: fs2,
                cache: cache2,
                gitdir,
                oid: entry.oid
              });
              if (type !== "tree") {
                throw new ObjectTypeError(oid, type, "tree", filepath);
              }
              tree = GitTree.from(object);
              return _resolveFilepath({
                fs: fs2,
                cache: cache2,
                gitdir,
                tree,
                pathArray,
                oid,
                filepath
              });
            }
          }
        }
        throw new NotFoundError(`file or directory found at "${oid}:${filepath}"`);
      }
      async function _readTree({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        filepath = void 0
      }) {
        if (filepath !== void 0) {
          oid = await resolveFilepath2({ fs: fs2, cache: cache2, gitdir, oid, filepath });
        }
        const { tree, oid: treeOid } = await resolveTree({ fs: fs2, cache: cache2, gitdir, oid });
        const result = {
          oid: treeOid,
          tree: tree.entries()
        };
        return result;
      }
      async function _writeTree({ fs: fs2, gitdir, tree }) {
        const object = GitTree.from(tree).toObject();
        const oid = await _writeObject({
          fs: fs2,
          gitdir,
          type: "tree",
          object,
          format: "content"
        });
        return oid;
      }
      async function _addNote({
        fs: fs2,
        cache: cache2,
        onSign,
        gitdir,
        ref,
        oid,
        note,
        force,
        author,
        committer,
        signingKey
      }) {
        let parent;
        try {
          parent = await GitRefManager.resolve({ gitdir, fs: fs2, ref });
        } catch (err3) {
          if (!(err3 instanceof NotFoundError)) {
            throw err3;
          }
        }
        const result = await _readTree({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid: parent || "4b825dc642cb6eb9a060e54bf8d69288fbee4904"
        });
        let tree = result.tree;
        if (force) {
          tree = tree.filter((entry) => entry.path !== oid);
        } else {
          for (const entry of tree) {
            if (entry.path === oid) {
              throw new AlreadyExistsError("note", oid);
            }
          }
        }
        if (typeof note === "string") {
          note = Buffer.from(note, "utf8");
        }
        const noteOid = await _writeObject({
          fs: fs2,
          gitdir,
          type: "blob",
          object: note,
          format: "content"
        });
        tree.push({ mode: "100644", path: oid, oid: noteOid, type: "blob" });
        const treeOid = await _writeTree({
          fs: fs2,
          gitdir,
          tree
        });
        const commitOid = await _commit({
          fs: fs2,
          cache: cache2,
          onSign,
          gitdir,
          ref,
          tree: treeOid,
          parent: parent && [parent],
          message: `Note added by 'isomorphic-git addNote'
`,
          author,
          committer,
          signingKey
        });
        return commitOid;
      }
      async function addNote({
        fs: _fs,
        onSign,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref = "refs/notes/commits",
        oid,
        note,
        force,
        author: _author,
        committer: _committer,
        signingKey,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          assertParameter("note", note);
          if (signingKey) {
            assertParameter("onSign", onSign);
          }
          const fs2 = new FileSystem2(_fs);
          const author = await normalizeAuthorObject({ fs: fs2, gitdir, author: _author });
          if (!author) throw new MissingNameError("author");
          const committer = await normalizeCommitterObject({
            fs: fs2,
            gitdir,
            author,
            committer: _committer
          });
          if (!committer) throw new MissingNameError("committer");
          return await _addNote({
            fs: new FileSystem2(fs2),
            cache: cache2,
            onSign,
            gitdir,
            ref,
            oid,
            note,
            force,
            author,
            committer,
            signingKey
          });
        } catch (err3) {
          err3.caller = "git.addNote";
          throw err3;
        }
      }
      async function _addRemote({ fs: fs2, gitdir, remote, url, force }) {
        if (remote !== cleanGitRef.clean(remote)) {
          throw new InvalidRefNameError(remote, cleanGitRef.clean(remote));
        }
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        if (!force) {
          const remoteNames = await config.getSubsections("remote");
          if (remoteNames.includes(remote)) {
            if (url !== await config.get(`remote.${remote}.url`)) {
              throw new AlreadyExistsError("remote", remote);
            }
          }
        }
        await config.set(`remote.${remote}.url`, url);
        await config.set(
          `remote.${remote}.fetch`,
          `+refs/heads/*:refs/remotes/${remote}/*`
        );
        await GitConfigManager.save({ fs: fs2, gitdir, config });
      }
      async function addRemote({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        remote,
        url,
        force = false
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("remote", remote);
          assertParameter("url", url);
          return await _addRemote({
            fs: new FileSystem2(fs2),
            gitdir,
            remote,
            url,
            force
          });
        } catch (err3) {
          err3.caller = "git.addRemote";
          throw err3;
        }
      }
      async function _annotatedTag({
        fs: fs2,
        cache: cache2,
        onSign,
        gitdir,
        ref,
        tagger,
        message = ref,
        gpgsig,
        object,
        signingKey,
        force = false
      }) {
        ref = ref.startsWith("refs/tags/") ? ref : `refs/tags/${ref}`;
        if (!force && await GitRefManager.exists({ fs: fs2, gitdir, ref })) {
          throw new AlreadyExistsError("tag", ref);
        }
        const oid = await GitRefManager.resolve({
          fs: fs2,
          gitdir,
          ref: object || "HEAD"
        });
        const { type } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
        let tagObject = GitAnnotatedTag.from({
          object: oid,
          type,
          tag: ref.replace("refs/tags/", ""),
          tagger,
          message,
          gpgsig
        });
        if (signingKey) {
          tagObject = await GitAnnotatedTag.sign(tagObject, onSign, signingKey);
        }
        const value = await _writeObject({
          fs: fs2,
          gitdir,
          type: "tag",
          object: tagObject.toObject()
        });
        await GitRefManager.writeRef({ fs: fs2, gitdir, ref, value });
      }
      async function annotatedTag({
        fs: _fs,
        onSign,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        tagger: _tagger,
        message = ref,
        gpgsig,
        object,
        signingKey,
        force = false,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          if (signingKey) {
            assertParameter("onSign", onSign);
          }
          const fs2 = new FileSystem2(_fs);
          const tagger = await normalizeAuthorObject({ fs: fs2, gitdir, author: _tagger });
          if (!tagger) throw new MissingNameError("tagger");
          return await _annotatedTag({
            fs: fs2,
            cache: cache2,
            onSign,
            gitdir,
            ref,
            tagger,
            message,
            gpgsig,
            object,
            signingKey,
            force
          });
        } catch (err3) {
          err3.caller = "git.annotatedTag";
          throw err3;
        }
      }
      async function _branch({
        fs: fs2,
        gitdir,
        ref,
        object,
        checkout: checkout2 = false,
        force = false
      }) {
        if (ref !== cleanGitRef.clean(ref)) {
          throw new InvalidRefNameError(ref, cleanGitRef.clean(ref));
        }
        const fullref = `refs/heads/${ref}`;
        if (!force) {
          const exist = await GitRefManager.exists({ fs: fs2, gitdir, ref: fullref });
          if (exist) {
            throw new AlreadyExistsError("branch", ref, false);
          }
        }
        let oid;
        try {
          oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref: object || "HEAD" });
        } catch (e2) {
        }
        if (oid) {
          await GitRefManager.writeRef({ fs: fs2, gitdir, ref: fullref, value: oid });
        }
        if (checkout2) {
          await GitRefManager.writeSymbolicRef({
            fs: fs2,
            gitdir,
            ref: "HEAD",
            value: fullref
          });
        }
      }
      async function branch({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        object,
        checkout: checkout2 = false,
        force = false
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          return await _branch({
            fs: new FileSystem2(fs2),
            gitdir,
            ref,
            object,
            checkout: checkout2,
            force
          });
        } catch (err3) {
          err3.caller = "git.branch";
          throw err3;
        }
      }
      var worthWalking = (filepath, root) => {
        if (filepath === "." || root == null || root.length === 0 || root === ".") {
          return true;
        }
        if (root.length >= filepath.length) {
          return root.startsWith(filepath);
        } else {
          return filepath.startsWith(root);
        }
      };
      async function _checkout({
        fs: fs2,
        cache: cache2,
        onProgress,
        onPostCheckout,
        dir,
        gitdir,
        remote,
        ref,
        filepaths,
        noCheckout,
        noUpdateHead,
        dryRun,
        force,
        track = true,
        nonBlocking = false,
        batchSize = 100
      }) {
        let oldOid;
        if (onPostCheckout) {
          try {
            oldOid = await GitRefManager.resolve({ fs: fs2, gitdir, ref: "HEAD" });
          } catch (err3) {
            oldOid = "0000000000000000000000000000000000000000";
          }
        }
        let oid;
        try {
          oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref });
        } catch (err3) {
          if (ref === "HEAD") throw err3;
          const remoteRef = `${remote}/${ref}`;
          oid = await GitRefManager.resolve({
            fs: fs2,
            gitdir,
            ref: remoteRef
          });
          if (track) {
            const config = await GitConfigManager.get({ fs: fs2, gitdir });
            await config.set(`branch.${ref}.remote`, remote);
            await config.set(`branch.${ref}.merge`, `refs/heads/${ref}`);
            await GitConfigManager.save({ fs: fs2, gitdir, config });
          }
          await GitRefManager.writeRef({
            fs: fs2,
            gitdir,
            ref: `refs/heads/${ref}`,
            value: oid
          });
        }
        if (!noCheckout) {
          let ops;
          try {
            ops = await analyze({
              fs: fs2,
              cache: cache2,
              onProgress,
              dir,
              gitdir,
              ref,
              force,
              filepaths
            });
          } catch (err3) {
            if (err3 instanceof NotFoundError && err3.data.what === oid) {
              throw new CommitNotFetchedError(ref, oid);
            } else {
              throw err3;
            }
          }
          const conflicts = ops.filter(([method]) => method === "conflict").map(([method, fullpath]) => fullpath);
          if (conflicts.length > 0) {
            throw new CheckoutConflictError(conflicts);
          }
          const errors = ops.filter(([method]) => method === "error").map(([method, fullpath]) => fullpath);
          if (errors.length > 0) {
            throw new InternalError2(errors.join(", "));
          }
          if (dryRun) {
            if (onPostCheckout) {
              await onPostCheckout({
                previousHead: oldOid,
                newHead: oid,
                type: filepaths != null && filepaths.length > 0 ? "file" : "branch"
              });
            }
            return;
          }
          let count = 0;
          const total = ops.length;
          await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            await Promise.all(
              ops.filter(
                ([method]) => method === "delete" || method === "delete-index"
              ).map(async function([method, fullpath]) {
                const filepath = `${dir}/${fullpath}`;
                if (method === "delete") {
                  await fs2.rm(filepath);
                }
                index3.delete({ filepath: fullpath });
                if (onProgress) {
                  await onProgress({
                    phase: "Updating workdir",
                    loaded: ++count,
                    total
                  });
                }
              })
            );
          });
          await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            for (const [method, fullpath] of ops) {
              if (method === "rmdir" || method === "rmdir-index") {
                const filepath = `${dir}/${fullpath}`;
                try {
                  if (method === "rmdir") {
                    await fs2.rmdir(filepath);
                  }
                  index3.delete({ filepath: fullpath });
                  if (onProgress) {
                    await onProgress({
                      phase: "Updating workdir",
                      loaded: ++count,
                      total
                    });
                  }
                } catch (e2) {
                  if (e2.code === "ENOTEMPTY") {
                    console.log(
                      `Did not delete ${fullpath} because directory is not empty`
                    );
                  } else {
                    throw e2;
                  }
                }
              }
            }
          });
          await Promise.all(
            ops.filter(([method]) => method === "mkdir" || method === "mkdir-index").map(async function([_2, fullpath]) {
              const filepath = `${dir}/${fullpath}`;
              await fs2.mkdir(filepath);
              if (onProgress) {
                await onProgress({
                  phase: "Updating workdir",
                  loaded: ++count,
                  total
                });
              }
            })
          );
          if (nonBlocking) {
            const eligibleOps = ops.filter(
              ([method]) => method === "create" || method === "create-index" || method === "update" || method === "mkdir-index"
            );
            const updateWorkingDirResults = await batchAllSettled(
              "Update Working Dir",
              eligibleOps.map(
                ([method, fullpath, oid2, mode, chmod3]) => () => updateWorkingDir({ fs: fs2, cache: cache2, gitdir, dir }, [
                  method,
                  fullpath,
                  oid2,
                  mode,
                  chmod3
                ])
              ),
              onProgress,
              batchSize
            );
            await GitIndexManager.acquire(
              { fs: fs2, gitdir, cache: cache2, allowUnmerged: true },
              async function(index3) {
                await batchAllSettled(
                  "Update Index",
                  updateWorkingDirResults.map(
                    ([fullpath, oid2, stats]) => () => updateIndex({ index: index3, fullpath, oid: oid2, stats })
                  ),
                  onProgress,
                  batchSize
                );
              }
            );
          } else {
            await GitIndexManager.acquire(
              { fs: fs2, gitdir, cache: cache2, allowUnmerged: true },
              async function(index3) {
                await Promise.all(
                  ops.filter(
                    ([method]) => method === "create" || method === "create-index" || method === "update" || method === "mkdir-index"
                  ).map(async function([method, fullpath, oid2, mode, chmod3]) {
                    const filepath = `${dir}/${fullpath}`;
                    try {
                      if (method !== "create-index" && method !== "mkdir-index") {
                        const { object } = await _readObject({
                          fs: fs2,
                          cache: cache2,
                          gitdir,
                          oid: oid2
                        });
                        if (chmod3) {
                          await fs2.rm(filepath);
                        }
                        if (mode === 33188) {
                          await fs2.write(filepath, object);
                        } else if (mode === 33261) {
                          await fs2.write(filepath, object, { mode: 511 });
                        } else if (mode === 40960) {
                          await fs2.writelink(filepath, object);
                        } else {
                          throw new InternalError2(
                            `Invalid mode 0o${mode.toString(
                              8
                            )} detected in blob ${oid2}`
                          );
                        }
                      }
                      const stats = await fs2.lstat(filepath);
                      if (mode === 33261) {
                        stats.mode = 493;
                      }
                      if (method === "mkdir-index") {
                        stats.mode = 57344;
                      }
                      index3.insert({
                        filepath: fullpath,
                        stats,
                        oid: oid2
                      });
                      if (onProgress) {
                        await onProgress({
                          phase: "Updating workdir",
                          loaded: ++count,
                          total
                        });
                      }
                    } catch (e2) {
                      console.log(e2);
                    }
                  })
                );
              }
            );
          }
          if (onPostCheckout) {
            await onPostCheckout({
              previousHead: oldOid,
              newHead: oid,
              type: filepaths != null && filepaths.length > 0 ? "file" : "branch"
            });
          }
        }
        if (!noUpdateHead) {
          const fullRef = await GitRefManager.expand({ fs: fs2, gitdir, ref });
          if (fullRef.startsWith("refs/heads")) {
            await GitRefManager.writeSymbolicRef({
              fs: fs2,
              gitdir,
              ref: "HEAD",
              value: fullRef
            });
          } else {
            await GitRefManager.writeRef({ fs: fs2, gitdir, ref: "HEAD", value: oid });
          }
        }
      }
      async function analyze({
        fs: fs2,
        cache: cache2,
        onProgress,
        dir,
        gitdir,
        ref,
        force,
        filepaths
      }) {
        let count = 0;
        return _walk({
          fs: fs2,
          cache: cache2,
          dir,
          gitdir,
          trees: [TREE({ ref }), WORKDIR(), STAGE()],
          map: async function(fullpath, [commit2, workdir, stage]) {
            if (fullpath === ".") return;
            if (filepaths && !filepaths.some((base2) => worthWalking(fullpath, base2))) {
              return null;
            }
            if (onProgress) {
              await onProgress({ phase: "Analyzing workdir", loaded: ++count });
            }
            const key = [!!stage, !!commit2, !!workdir].map(Number).join("");
            switch (key) {
              case "000":
                return;
              case "001":
                if (force && filepaths && filepaths.includes(fullpath)) {
                  return ["delete", fullpath];
                }
                return;
              case "010": {
                switch (await commit2.type()) {
                  case "tree": {
                    return ["mkdir", fullpath];
                  }
                  case "blob": {
                    return [
                      "create",
                      fullpath,
                      await commit2.oid(),
                      await commit2.mode()
                    ];
                  }
                  case "commit": {
                    return [
                      "mkdir-index",
                      fullpath,
                      await commit2.oid(),
                      await commit2.mode()
                    ];
                  }
                  default: {
                    return [
                      "error",
                      `new entry Unhandled type ${await commit2.type()}`
                    ];
                  }
                }
              }
              case "011": {
                switch (`${await commit2.type()}-${await workdir.type()}`) {
                  case "tree-tree": {
                    return;
                  }
                  case "tree-blob":
                  case "blob-tree": {
                    return ["conflict", fullpath];
                  }
                  case "blob-blob": {
                    if (await commit2.oid() !== await workdir.oid()) {
                      if (force) {
                        return [
                          "update",
                          fullpath,
                          await commit2.oid(),
                          await commit2.mode(),
                          await commit2.mode() !== await workdir.mode()
                        ];
                      } else {
                        return ["conflict", fullpath];
                      }
                    } else {
                      if (await commit2.mode() !== await workdir.mode()) {
                        if (force) {
                          return [
                            "update",
                            fullpath,
                            await commit2.oid(),
                            await commit2.mode(),
                            true
                          ];
                        } else {
                          return ["conflict", fullpath];
                        }
                      } else {
                        return [
                          "create-index",
                          fullpath,
                          await commit2.oid(),
                          await commit2.mode()
                        ];
                      }
                    }
                  }
                  case "commit-tree": {
                    return;
                  }
                  case "commit-blob": {
                    return ["conflict", fullpath];
                  }
                  default: {
                    return ["error", `new entry Unhandled type ${commit2.type}`];
                  }
                }
              }
              case "100": {
                return ["delete-index", fullpath];
              }
              case "101": {
                switch (await stage.type()) {
                  case "tree": {
                    return ["rmdir-index", fullpath];
                  }
                  case "blob": {
                    if (await stage.oid() !== await workdir.oid()) {
                      if (force) {
                        return ["delete", fullpath];
                      } else {
                        return ["conflict", fullpath];
                      }
                    } else {
                      return ["delete", fullpath];
                    }
                  }
                  case "commit": {
                    return ["rmdir-index", fullpath];
                  }
                  default: {
                    return [
                      "error",
                      `delete entry Unhandled type ${await stage.type()}`
                    ];
                  }
                }
              }
              case "110":
              case "111": {
                switch (`${await stage.type()}-${await commit2.type()}`) {
                  case "tree-tree": {
                    return;
                  }
                  case "blob-blob": {
                    if (await stage.oid() === await commit2.oid() && await stage.mode() === await commit2.mode() && !force) {
                      return;
                    }
                    if (workdir) {
                      if (await workdir.oid() !== await stage.oid() && await workdir.oid() !== await commit2.oid()) {
                        if (force) {
                          return [
                            "update",
                            fullpath,
                            await commit2.oid(),
                            await commit2.mode(),
                            await commit2.mode() !== await workdir.mode()
                          ];
                        } else {
                          return ["conflict", fullpath];
                        }
                      }
                    } else if (force) {
                      return [
                        "update",
                        fullpath,
                        await commit2.oid(),
                        await commit2.mode(),
                        await commit2.mode() !== await stage.mode()
                      ];
                    }
                    if (await commit2.mode() !== await stage.mode()) {
                      return [
                        "update",
                        fullpath,
                        await commit2.oid(),
                        await commit2.mode(),
                        true
                      ];
                    }
                    if (await commit2.oid() !== await stage.oid()) {
                      return [
                        "update",
                        fullpath,
                        await commit2.oid(),
                        await commit2.mode(),
                        false
                      ];
                    } else {
                      return;
                    }
                  }
                  case "tree-blob": {
                    return ["update-dir-to-blob", fullpath, await commit2.oid()];
                  }
                  case "blob-tree": {
                    return ["update-blob-to-tree", fullpath];
                  }
                  case "commit-commit": {
                    return [
                      "mkdir-index",
                      fullpath,
                      await commit2.oid(),
                      await commit2.mode()
                    ];
                  }
                  default: {
                    return [
                      "error",
                      `update entry Unhandled type ${await stage.type()}-${await commit2.type()}`
                    ];
                  }
                }
              }
            }
          },
          // Modify the default flat mapping
          reduce: async function(parent, children) {
            children = flat(children);
            if (!parent) {
              return children;
            } else if (parent && parent[0] === "rmdir") {
              children.push(parent);
              return children;
            } else {
              children.unshift(parent);
              return children;
            }
          }
        });
      }
      async function updateIndex({ index: index3, fullpath, stats, oid }) {
        try {
          index3.insert({
            filepath: fullpath,
            stats,
            oid
          });
        } catch (e2) {
          console.warn(`Error inserting ${fullpath} into index:`, e2);
        }
      }
      async function updateWorkingDir({ fs: fs2, cache: cache2, gitdir, dir }, [method, fullpath, oid, mode, chmod3]) {
        const filepath = `${dir}/${fullpath}`;
        if (method !== "create-index" && method !== "mkdir-index") {
          const { object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
          if (chmod3) {
            await fs2.rm(filepath);
          }
          if (mode === 33188) {
            await fs2.write(filepath, object);
          } else if (mode === 33261) {
            await fs2.write(filepath, object, { mode: 511 });
          } else if (mode === 40960) {
            await fs2.writelink(filepath, object);
          } else {
            throw new InternalError2(
              `Invalid mode 0o${mode.toString(8)} detected in blob ${oid}`
            );
          }
        }
        const stats = await fs2.lstat(filepath);
        if (mode === 33261) {
          stats.mode = 493;
        }
        if (method === "mkdir-index") {
          stats.mode = 57344;
        }
        return [fullpath, oid, stats];
      }
      async function batchAllSettled(operationName, tasks, onProgress, batchSize) {
        const results = [];
        try {
          for (let i2 = 0; i2 < tasks.length; i2 += batchSize) {
            const batch = tasks.slice(i2, i2 + batchSize).map((task) => task());
            const batchResults = await Promise.allSettled(batch);
            batchResults.forEach((result) => {
              if (result.status === "fulfilled") results.push(result.value);
            });
            if (onProgress) {
              await onProgress({
                phase: "Updating workdir",
                loaded: i2 + batch.length,
                total: tasks.length
              });
            }
          }
          return results;
        } catch (error) {
          console.error(`Error during ${operationName}: ${error}`);
        }
        return results;
      }
      async function checkout({
        fs: fs2,
        onProgress,
        onPostCheckout,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        remote = "origin",
        ref: _ref,
        filepaths,
        noCheckout = false,
        noUpdateHead = _ref === void 0,
        dryRun = false,
        force = false,
        track = true,
        cache: cache2 = {},
        nonBlocking = false,
        batchSize = 100
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("dir", dir);
          assertParameter("gitdir", gitdir);
          const ref = _ref || "HEAD";
          return await _checkout({
            fs: new FileSystem2(fs2),
            cache: cache2,
            onProgress,
            onPostCheckout,
            dir,
            gitdir,
            remote,
            ref,
            filepaths,
            noCheckout,
            noUpdateHead,
            dryRun,
            force,
            track,
            nonBlocking,
            batchSize
          });
        } catch (err3) {
          err3.caller = "git.checkout";
          throw err3;
        }
      }
      var abbreviateRx = new RegExp("^refs/(heads/|tags/|remotes/)?(.*)");
      function abbreviateRef(ref) {
        const match = abbreviateRx.exec(ref);
        if (match) {
          if (match[1] === "remotes/" && ref.endsWith("/HEAD")) {
            return match[2].slice(0, -5);
          } else {
            return match[2];
          }
        }
        return ref;
      }
      async function _currentBranch({
        fs: fs2,
        gitdir,
        fullname = false,
        test = false
      }) {
        const ref = await GitRefManager.resolve({
          fs: fs2,
          gitdir,
          ref: "HEAD",
          depth: 2
        });
        if (test) {
          try {
            await GitRefManager.resolve({ fs: fs2, gitdir, ref });
          } catch (_2) {
            return;
          }
        }
        if (!ref.startsWith("refs/")) return;
        return fullname ? ref : abbreviateRef(ref);
      }
      function translateSSHtoHTTP(url) {
        url = url.replace(/^git@([^:]+):/, "https://$1/");
        url = url.replace(/^ssh:\/\//, "https://");
        return url;
      }
      function calculateBasicAuthHeader({ username = "", password = "" }) {
        return `Basic ${Buffer.from(`${username}:${password}`).toString("base64")}`;
      }
      async function forAwait2(iterable, cb) {
        const iter = getIterator2(iterable);
        while (true) {
          const { value, done } = await iter.next();
          if (value) await cb(value);
          if (done) break;
        }
        if (iter.return) iter.return();
      }
      async function collect2(iterable) {
        let size = 0;
        const buffers = [];
        await forAwait2(iterable, (value) => {
          buffers.push(value);
          size += value.byteLength;
        });
        const result = new Uint8Array(size);
        let nextIndex = 0;
        for (const buffer of buffers) {
          result.set(buffer, nextIndex);
          nextIndex += buffer.byteLength;
        }
        return result;
      }
      function extractAuthFromUrl(url) {
        let userpass = url.match(/^https?:\/\/([^/]+)@/);
        if (userpass == null) return { url, auth: {} };
        userpass = userpass[1];
        const [username, password] = userpass.split(":");
        url = url.replace(`${userpass}@`, "");
        return { url, auth: { username, password } };
      }
      function padHex(b, n2) {
        const s2 = n2.toString(16);
        return "0".repeat(b - s2.length) + s2;
      }
      var GitPktLine = class {
        static flush() {
          return Buffer.from("0000", "utf8");
        }
        static delim() {
          return Buffer.from("0001", "utf8");
        }
        static encode(line) {
          if (typeof line === "string") {
            line = Buffer.from(line);
          }
          const length2 = line.length + 4;
          const hexlength = padHex(4, length2);
          return Buffer.concat([Buffer.from(hexlength, "utf8"), line]);
        }
        static streamReader(stream) {
          const reader = new StreamReader(stream);
          return async function read2() {
            try {
              let length2 = await reader.read(4);
              if (length2 == null) return true;
              length2 = parseInt(length2.toString("utf8"), 16);
              if (length2 === 0) return null;
              if (length2 === 1) return null;
              const buffer = await reader.read(length2 - 4);
              if (buffer == null) return true;
              return buffer;
            } catch (err3) {
              stream.error = err3;
              return true;
            }
          };
        }
      };
      async function parseCapabilitiesV2(read2) {
        const capabilities2 = {};
        let line;
        while (true) {
          line = await read2();
          if (line === true) break;
          if (line === null) continue;
          line = line.toString("utf8").replace(/\n$/, "");
          const i2 = line.indexOf("=");
          if (i2 > -1) {
            const key = line.slice(0, i2);
            const value = line.slice(i2 + 1);
            capabilities2[key] = value;
          } else {
            capabilities2[line] = true;
          }
        }
        return { protocolVersion: 2, capabilities2 };
      }
      async function parseRefsAdResponse(stream, { service }) {
        const capabilities = /* @__PURE__ */ new Set();
        const refs = /* @__PURE__ */ new Map();
        const symrefs = /* @__PURE__ */ new Map();
        const read2 = GitPktLine.streamReader(stream);
        let lineOne = await read2();
        while (lineOne === null) lineOne = await read2();
        if (lineOne === true) throw new EmptyServerResponseError();
        if (lineOne.includes("version 2")) {
          return parseCapabilitiesV2(read2);
        }
        if (lineOne.toString("utf8").replace(/\n$/, "") !== `# service=${service}`) {
          throw new ParseError3(`# service=${service}\\n`, lineOne.toString("utf8"));
        }
        let lineTwo = await read2();
        while (lineTwo === null) lineTwo = await read2();
        if (lineTwo === true) return { capabilities, refs, symrefs };
        lineTwo = lineTwo.toString("utf8");
        if (lineTwo.includes("version 2")) {
          return parseCapabilitiesV2(read2);
        }
        const [firstRef, capabilitiesLine] = splitAndAssert(lineTwo, "\0", "\\x00");
        capabilitiesLine.split(" ").map((x) => capabilities.add(x));
        if (firstRef !== "0000000000000000000000000000000000000000 capabilities^{}") {
          const [ref, name2] = splitAndAssert(firstRef, " ", " ");
          refs.set(name2, ref);
          while (true) {
            const line = await read2();
            if (line === true) break;
            if (line !== null) {
              const [ref2, name3] = splitAndAssert(line.toString("utf8"), " ", " ");
              refs.set(name3, ref2);
            }
          }
        }
        for (const cap of capabilities) {
          if (cap.startsWith("symref=")) {
            const m = cap.match(/symref=([^:]+):(.*)/);
            if (m.length === 3) {
              symrefs.set(m[1], m[2]);
            }
          }
        }
        return { protocolVersion: 1, capabilities, refs, symrefs };
      }
      function splitAndAssert(line, sep2, expected) {
        const split3 = line.trim().split(sep2);
        if (split3.length !== 2) {
          throw new ParseError3(
            `Two strings separated by '${expected}'`,
            line.toString("utf8")
          );
        }
        return split3;
      }
      var corsProxify = (corsProxy, url) => corsProxy.endsWith("?") ? `${corsProxy}${url}` : `${corsProxy}/${url.replace(/^https?:\/\//, "")}`;
      var updateHeaders = (headers, auth) => {
        if (auth.username || auth.password) {
          headers.Authorization = calculateBasicAuthHeader(auth);
        }
        if (auth.headers) {
          Object.assign(headers, auth.headers);
        }
      };
      var stringifyBody = async (res) => {
        try {
          const data = Buffer.from(await collect2(res.body));
          const response = data.toString("utf8");
          const preview = response.length < 256 ? response : response.slice(0, 256) + "...";
          return { preview, response, data };
        } catch (e2) {
          return {};
        }
      };
      var GitRemoteHTTP = class {
        static async capabilities() {
          return ["discover", "connect"];
        }
        /**
         * @param {Object} args
         * @param {HttpClient} args.http
         * @param {ProgressCallback} [args.onProgress]
         * @param {AuthCallback} [args.onAuth]
         * @param {AuthFailureCallback} [args.onAuthFailure]
         * @param {AuthSuccessCallback} [args.onAuthSuccess]
         * @param {string} [args.corsProxy]
         * @param {string} args.service
         * @param {string} args.url
         * @param {Object<string, string>} args.headers
         * @param {1 | 2} args.protocolVersion - Git Protocol Version
         */
        static async discover({
          http: http2,
          onProgress,
          onAuth,
          onAuthSuccess,
          onAuthFailure,
          corsProxy,
          service,
          url: _origUrl,
          headers,
          protocolVersion
        }) {
          let { url, auth } = extractAuthFromUrl(_origUrl);
          const proxifiedURL = corsProxy ? corsProxify(corsProxy, url) : url;
          if (auth.username || auth.password) {
            headers.Authorization = calculateBasicAuthHeader(auth);
          }
          if (protocolVersion === 2) {
            headers["Git-Protocol"] = "version=2";
          }
          let res;
          let tryAgain;
          let providedAuthBefore = false;
          do {
            res = await http2.request({
              onProgress,
              method: "GET",
              url: `${proxifiedURL}/info/refs?service=${service}`,
              headers
            });
            tryAgain = false;
            if (res.statusCode === 401 || res.statusCode === 203) {
              const getAuth = providedAuthBefore ? onAuthFailure : onAuth;
              if (getAuth) {
                auth = await getAuth(url, {
                  ...auth,
                  headers: { ...headers }
                });
                if (auth && auth.cancel) {
                  throw new UserCanceledError();
                } else if (auth) {
                  updateHeaders(headers, auth);
                  providedAuthBefore = true;
                  tryAgain = true;
                }
              }
            } else if (res.statusCode === 200 && providedAuthBefore && onAuthSuccess) {
              await onAuthSuccess(url, auth);
            }
          } while (tryAgain);
          if (res.statusCode !== 200) {
            const { response } = await stringifyBody(res);
            throw new HttpError2(res.statusCode, res.statusMessage, response);
          }
          if (res.headers["content-type"] === `application/x-${service}-advertisement`) {
            const remoteHTTP = await parseRefsAdResponse(res.body, { service });
            remoteHTTP.auth = auth;
            return remoteHTTP;
          } else {
            const { preview, response, data } = await stringifyBody(res);
            try {
              const remoteHTTP = await parseRefsAdResponse([data], { service });
              remoteHTTP.auth = auth;
              return remoteHTTP;
            } catch (e2) {
              throw new SmartHttpError(preview, response);
            }
          }
        }
        /**
         * @param {Object} args
         * @param {HttpClient} args.http
         * @param {ProgressCallback} [args.onProgress]
         * @param {string} [args.corsProxy]
         * @param {string} args.service
         * @param {string} args.url
         * @param {Object<string, string>} [args.headers]
         * @param {any} args.body
         * @param {any} args.auth
         */
        static async connect({
          http: http2,
          onProgress,
          corsProxy,
          service,
          url,
          auth,
          body,
          headers
        }) {
          const urlAuth = extractAuthFromUrl(url);
          if (urlAuth) url = urlAuth.url;
          if (corsProxy) url = corsProxify(corsProxy, url);
          headers["content-type"] = `application/x-${service}-request`;
          headers.accept = `application/x-${service}-result`;
          updateHeaders(headers, auth);
          const res = await http2.request({
            onProgress,
            method: "POST",
            url: `${url}/${service}`,
            body,
            headers
          });
          if (res.statusCode !== 200) {
            const { response } = stringifyBody(res);
            throw new HttpError2(res.statusCode, res.statusMessage, response);
          }
          return res;
        }
      };
      function parseRemoteUrl({ url }) {
        if (url.startsWith("git@")) {
          return {
            transport: "ssh",
            address: url
          };
        }
        const matches = url.match(/(\w+)(:\/\/|::)(.*)/);
        if (matches === null) return;
        if (matches[2] === "://") {
          return {
            transport: matches[1],
            address: matches[0]
          };
        }
        if (matches[2] === "::") {
          return {
            transport: matches[1],
            address: matches[3]
          };
        }
      }
      var GitRemoteManager = class {
        static getRemoteHelperFor({ url }) {
          const remoteHelpers = /* @__PURE__ */ new Map();
          remoteHelpers.set("http", GitRemoteHTTP);
          remoteHelpers.set("https", GitRemoteHTTP);
          const parts = parseRemoteUrl({ url });
          if (!parts) {
            throw new UrlParseError(url);
          }
          if (remoteHelpers.has(parts.transport)) {
            return remoteHelpers.get(parts.transport);
          }
          throw new UnknownTransportError(
            url,
            parts.transport,
            parts.transport === "ssh" ? translateSSHtoHTTP(url) : void 0
          );
        }
      };
      var lock$2 = null;
      var GitShallowManager = class {
        static async read({ fs: fs2, gitdir }) {
          if (lock$2 === null) lock$2 = new AsyncLock();
          const filepath = pathBrowserify.join(gitdir, "shallow");
          const oids = /* @__PURE__ */ new Set();
          await lock$2.acquire(filepath, async function() {
            const text = await fs2.read(filepath, { encoding: "utf8" });
            if (text === null) return oids;
            if (text.trim() === "") return oids;
            text.trim().split("\n").map((oid) => oids.add(oid));
          });
          return oids;
        }
        static async write({ fs: fs2, gitdir, oids }) {
          if (lock$2 === null) lock$2 = new AsyncLock();
          const filepath = pathBrowserify.join(gitdir, "shallow");
          if (oids.size > 0) {
            const text = [...oids].join("\n") + "\n";
            await lock$2.acquire(filepath, async function() {
              await fs2.write(filepath, text, {
                encoding: "utf8"
              });
            });
          } else {
            await lock$2.acquire(filepath, async function() {
              await fs2.rm(filepath);
            });
          }
        }
      };
      async function hasObjectLoose({ fs: fs2, gitdir, oid }) {
        const source = `objects/${oid.slice(0, 2)}/${oid.slice(2)}`;
        return fs2.exists(`${gitdir}/${source}`);
      }
      async function hasObjectPacked({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        getExternalRefDelta
      }) {
        let list2 = await fs2.readdir(pathBrowserify.join(gitdir, "objects/pack"));
        list2 = list2.filter((x) => x.endsWith(".idx"));
        for (const filename of list2) {
          const indexFile = `${gitdir}/objects/pack/${filename}`;
          const p12 = await readPackIndex({
            fs: fs2,
            cache: cache2,
            filename: indexFile,
            getExternalRefDelta
          });
          if (p12.error) throw new InternalError2(p12.error);
          if (p12.offsets.has(oid)) {
            return true;
          }
        }
        return false;
      }
      async function hasObject({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        format: format5 = "content"
      }) {
        const getExternalRefDelta = (oid2) => _readObject({ fs: fs2, cache: cache2, gitdir, oid: oid2 });
        let result = await hasObjectLoose({ fs: fs2, gitdir, oid });
        if (!result) {
          result = await hasObjectPacked({
            fs: fs2,
            cache: cache2,
            gitdir,
            oid,
            getExternalRefDelta
          });
        }
        return result;
      }
      function emptyPackfile(pack) {
        const pheader = "5041434b";
        const version18 = "00000002";
        const obCount = "00000000";
        const header = pheader + version18 + obCount;
        return pack.slice(0, 12).toString("hex") === header;
      }
      function filterCapabilities(server, client) {
        const serverNames = server.map((cap) => cap.split("=", 1)[0]);
        return client.filter((cap) => {
          const name2 = cap.split("=", 1)[0];
          return serverNames.includes(name2);
        });
      }
      var pkg2 = {
        name: "isomorphic-git",
        version: "1.32.3",
        agent: "git/isomorphic-git@1.32.3"
      };
      var FIFO = class {
        constructor() {
          this._queue = [];
        }
        write(chunk) {
          if (this._ended) {
            throw Error("You cannot write to a FIFO that has already been ended!");
          }
          if (this._waiting) {
            const resolve2 = this._waiting;
            this._waiting = null;
            resolve2({ value: chunk });
          } else {
            this._queue.push(chunk);
          }
        }
        end() {
          this._ended = true;
          if (this._waiting) {
            const resolve2 = this._waiting;
            this._waiting = null;
            resolve2({ done: true });
          }
        }
        destroy(err3) {
          this.error = err3;
          this.end();
        }
        async next() {
          if (this._queue.length > 0) {
            return { value: this._queue.shift() };
          }
          if (this._ended) {
            return { done: true };
          }
          if (this._waiting) {
            throw Error(
              "You cannot call read until the previous call to read has returned!"
            );
          }
          return new Promise((resolve2) => {
            this._waiting = resolve2;
          });
        }
      };
      function findSplit(str) {
        const r2 = str.indexOf("\r");
        const n2 = str.indexOf("\n");
        if (r2 === -1 && n2 === -1) return -1;
        if (r2 === -1) return n2 + 1;
        if (n2 === -1) return r2 + 1;
        if (n2 === r2 + 1) return n2 + 1;
        return Math.min(r2, n2) + 1;
      }
      function splitLines(input) {
        const output3 = new FIFO();
        let tmp = "";
        (async () => {
          await forAwait2(input, (chunk) => {
            chunk = chunk.toString("utf8");
            tmp += chunk;
            while (true) {
              const i2 = findSplit(tmp);
              if (i2 === -1) break;
              output3.write(tmp.slice(0, i2));
              tmp = tmp.slice(i2);
            }
          });
          if (tmp.length > 0) {
            output3.write(tmp);
          }
          output3.end();
        })();
        return output3;
      }
      var GitSideBand = class {
        static demux(input) {
          const read2 = GitPktLine.streamReader(input);
          const packetlines = new FIFO();
          const packfile = new FIFO();
          const progress = new FIFO();
          const nextBit = async function() {
            const line = await read2();
            if (line === null) return nextBit();
            if (line === true) {
              packetlines.end();
              progress.end();
              input.error ? packfile.destroy(input.error) : packfile.end();
              return;
            }
            switch (line[0]) {
              case 1: {
                packfile.write(line.slice(1));
                break;
              }
              case 2: {
                progress.write(line.slice(1));
                break;
              }
              case 3: {
                const error = line.slice(1);
                progress.write(error);
                packetlines.end();
                progress.end();
                packfile.destroy(new Error(error.toString("utf8")));
                return;
              }
              default: {
                packetlines.write(line);
              }
            }
            nextBit();
          };
          nextBit();
          return {
            packetlines,
            packfile,
            progress
          };
        }
        // static mux ({
        //   protocol, // 'side-band' or 'side-band-64k'
        //   packetlines,
        //   packfile,
        //   progress,
        //   error
        // }) {
        //   const MAX_PACKET_LENGTH = protocol === 'side-band-64k' ? 999 : 65519
        //   let output = new PassThrough()
        //   packetlines.on('data', data => {
        //     if (data === null) {
        //       output.write(GitPktLine.flush())
        //     } else {
        //       output.write(GitPktLine.encode(data))
        //     }
        //   })
        //   let packfileWasEmpty = true
        //   let packfileEnded = false
        //   let progressEnded = false
        //   let errorEnded = false
        //   let goodbye = Buffer.concat([
        //     GitPktLine.encode(Buffer.from('010A', 'hex')),
        //     GitPktLine.flush()
        //   ])
        //   packfile
        //     .on('data', data => {
        //       packfileWasEmpty = false
        //       const buffers = splitBuffer(data, MAX_PACKET_LENGTH)
        //       for (const buffer of buffers) {
        //         output.write(
        //           GitPktLine.encode(Buffer.concat([Buffer.from('01', 'hex'), buffer]))
        //         )
        //       }
        //     })
        //     .on('end', () => {
        //       packfileEnded = true
        //       if (!packfileWasEmpty) output.write(goodbye)
        //       if (progressEnded && errorEnded) output.end()
        //     })
        //   progress
        //     .on('data', data => {
        //       const buffers = splitBuffer(data, MAX_PACKET_LENGTH)
        //       for (const buffer of buffers) {
        //         output.write(
        //           GitPktLine.encode(Buffer.concat([Buffer.from('02', 'hex'), buffer]))
        //         )
        //       }
        //     })
        //     .on('end', () => {
        //       progressEnded = true
        //       if (packfileEnded && errorEnded) output.end()
        //     })
        //   error
        //     .on('data', data => {
        //       const buffers = splitBuffer(data, MAX_PACKET_LENGTH)
        //       for (const buffer of buffers) {
        //         output.write(
        //           GitPktLine.encode(Buffer.concat([Buffer.from('03', 'hex'), buffer]))
        //         )
        //       }
        //     })
        //     .on('end', () => {
        //       errorEnded = true
        //       if (progressEnded && packfileEnded) output.end()
        //     })
        //   return output
        // }
      };
      async function parseUploadPackResponse(stream) {
        const { packetlines, packfile, progress } = GitSideBand.demux(stream);
        const shallows = [];
        const unshallows = [];
        const acks = [];
        let nak = false;
        let done = false;
        return new Promise((resolve2, reject) => {
          forAwait2(packetlines, (data) => {
            const line = data.toString("utf8").trim();
            if (line.startsWith("shallow")) {
              const oid = line.slice(-41).trim();
              if (oid.length !== 40) {
                reject(new InvalidOidError(oid));
              }
              shallows.push(oid);
            } else if (line.startsWith("unshallow")) {
              const oid = line.slice(-41).trim();
              if (oid.length !== 40) {
                reject(new InvalidOidError(oid));
              }
              unshallows.push(oid);
            } else if (line.startsWith("ACK")) {
              const [, oid, status2] = line.split(" ");
              acks.push({ oid, status: status2 });
              if (!status2) done = true;
            } else if (line.startsWith("NAK")) {
              nak = true;
              done = true;
            } else {
              done = true;
              nak = true;
            }
            if (done) {
              stream.error ? reject(stream.error) : resolve2({ shallows, unshallows, acks, nak, packfile, progress });
            }
          }).finally(() => {
            if (!done) {
              stream.error ? reject(stream.error) : resolve2({ shallows, unshallows, acks, nak, packfile, progress });
            }
          });
        });
      }
      function writeUploadPackRequest({
        capabilities = [],
        wants = [],
        haves = [],
        shallows = [],
        depth = null,
        since = null,
        exclude = []
      }) {
        const packstream = [];
        wants = [...new Set(wants)];
        let firstLineCapabilities = ` ${capabilities.join(" ")}`;
        for (const oid of wants) {
          packstream.push(GitPktLine.encode(`want ${oid}${firstLineCapabilities}
`));
          firstLineCapabilities = "";
        }
        for (const oid of shallows) {
          packstream.push(GitPktLine.encode(`shallow ${oid}
`));
        }
        if (depth !== null) {
          packstream.push(GitPktLine.encode(`deepen ${depth}
`));
        }
        if (since !== null) {
          packstream.push(
            GitPktLine.encode(`deepen-since ${Math.floor(since.valueOf() / 1e3)}
`)
          );
        }
        for (const oid of exclude) {
          packstream.push(GitPktLine.encode(`deepen-not ${oid}
`));
        }
        packstream.push(GitPktLine.flush());
        for (const oid of haves) {
          packstream.push(GitPktLine.encode(`have ${oid}
`));
        }
        packstream.push(GitPktLine.encode(`done
`));
        return packstream;
      }
      async function _fetch2({
        fs: fs2,
        cache: cache2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        gitdir,
        ref: _ref,
        remoteRef: _remoteRef,
        remote: _remote,
        url: _url,
        corsProxy,
        depth = null,
        since = null,
        exclude = [],
        relative: relative2 = false,
        tags = false,
        singleBranch = false,
        headers = {},
        prune = false,
        pruneTags = false
      }) {
        const ref = _ref || await _currentBranch({ fs: fs2, gitdir, test: true });
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        const remote = _remote || ref && await config.get(`branch.${ref}.remote`) || "origin";
        const url = _url || await config.get(`remote.${remote}.url`);
        if (typeof url === "undefined") {
          throw new MissingParameterError("remote OR url");
        }
        const remoteRef = _remoteRef || ref && await config.get(`branch.${ref}.merge`) || _ref || "HEAD";
        if (corsProxy === void 0) {
          corsProxy = await config.get("http.corsProxy");
        }
        const GitRemoteHTTP2 = GitRemoteManager.getRemoteHelperFor({ url });
        const remoteHTTP = await GitRemoteHTTP2.discover({
          http: http2,
          onAuth,
          onAuthSuccess,
          onAuthFailure,
          corsProxy,
          service: "git-upload-pack",
          url,
          headers,
          protocolVersion: 1
        });
        const auth = remoteHTTP.auth;
        const remoteRefs = remoteHTTP.refs;
        if (remoteRefs.size === 0) {
          return {
            defaultBranch: null,
            fetchHead: null,
            fetchHeadDescription: null
          };
        }
        if (depth !== null && !remoteHTTP.capabilities.has("shallow")) {
          throw new RemoteCapabilityError("shallow", "depth");
        }
        if (since !== null && !remoteHTTP.capabilities.has("deepen-since")) {
          throw new RemoteCapabilityError("deepen-since", "since");
        }
        if (exclude.length > 0 && !remoteHTTP.capabilities.has("deepen-not")) {
          throw new RemoteCapabilityError("deepen-not", "exclude");
        }
        if (relative2 === true && !remoteHTTP.capabilities.has("deepen-relative")) {
          throw new RemoteCapabilityError("deepen-relative", "relative");
        }
        const { oid, fullref } = GitRefManager.resolveAgainstMap({
          ref: remoteRef,
          map: remoteRefs
        });
        for (const remoteRef2 of remoteRefs.keys()) {
          if (remoteRef2 === fullref || remoteRef2 === "HEAD" || remoteRef2.startsWith("refs/heads/") || tags && remoteRef2.startsWith("refs/tags/")) {
            continue;
          }
          remoteRefs.delete(remoteRef2);
        }
        const capabilities = filterCapabilities(
          [...remoteHTTP.capabilities],
          [
            "multi_ack_detailed",
            "no-done",
            "side-band-64k",
            // Note: I removed 'thin-pack' option since our code doesn't "fatten" packfiles,
            // which is necessary for compatibility with git. It was the cause of mysterious
            // 'fatal: pack has [x] unresolved deltas' errors that plagued us for some time.
            // isomorphic-git is perfectly happy with thin packfiles in .git/objects/pack but
            // canonical git it turns out is NOT.
            "ofs-delta",
            `agent=${pkg2.agent}`
          ]
        );
        if (relative2) capabilities.push("deepen-relative");
        const wants = singleBranch ? [oid] : remoteRefs.values();
        const haveRefs = singleBranch ? [ref] : await GitRefManager.listRefs({
          fs: fs2,
          gitdir,
          filepath: `refs`
        });
        let haves = [];
        for (let ref2 of haveRefs) {
          try {
            ref2 = await GitRefManager.expand({ fs: fs2, gitdir, ref: ref2 });
            const oid2 = await GitRefManager.resolve({ fs: fs2, gitdir, ref: ref2 });
            if (await hasObject({ fs: fs2, cache: cache2, gitdir, oid: oid2 })) {
              haves.push(oid2);
            }
          } catch (err3) {
          }
        }
        haves = [...new Set(haves)];
        const oids = await GitShallowManager.read({ fs: fs2, gitdir });
        const shallows = remoteHTTP.capabilities.has("shallow") ? [...oids] : [];
        const packstream = writeUploadPackRequest({
          capabilities,
          wants,
          haves,
          shallows,
          depth,
          since,
          exclude
        });
        const packbuffer = Buffer.from(await collect2(packstream));
        const raw = await GitRemoteHTTP2.connect({
          http: http2,
          onProgress,
          corsProxy,
          service: "git-upload-pack",
          url,
          auth,
          body: [packbuffer],
          headers
        });
        const response = await parseUploadPackResponse(raw.body);
        if (raw.headers) {
          response.headers = raw.headers;
        }
        for (const oid2 of response.shallows) {
          if (!oids.has(oid2)) {
            try {
              const { object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid: oid2 });
              const commit2 = new GitCommit(object);
              const hasParents = await Promise.all(
                commit2.headers().parent.map((oid3) => hasObject({ fs: fs2, cache: cache2, gitdir, oid: oid3 }))
              );
              const haveAllParents = hasParents.length === 0 || hasParents.every((has) => has);
              if (!haveAllParents) {
                oids.add(oid2);
              }
            } catch (err3) {
              oids.add(oid2);
            }
          }
        }
        for (const oid2 of response.unshallows) {
          oids.delete(oid2);
        }
        await GitShallowManager.write({ fs: fs2, gitdir, oids });
        if (singleBranch) {
          const refs = /* @__PURE__ */ new Map([[fullref, oid]]);
          const symrefs = /* @__PURE__ */ new Map();
          let bail = 10;
          let key = fullref;
          while (bail--) {
            const value = remoteHTTP.symrefs.get(key);
            if (value === void 0) break;
            symrefs.set(key, value);
            key = value;
          }
          const realRef = remoteRefs.get(key);
          if (realRef) {
            refs.set(key, realRef);
          }
          const { pruned } = await GitRefManager.updateRemoteRefs({
            fs: fs2,
            gitdir,
            remote,
            refs,
            symrefs,
            tags,
            prune
          });
          if (prune) {
            response.pruned = pruned;
          }
        } else {
          const { pruned } = await GitRefManager.updateRemoteRefs({
            fs: fs2,
            gitdir,
            remote,
            refs: remoteRefs,
            symrefs: remoteHTTP.symrefs,
            tags,
            prune,
            pruneTags
          });
          if (prune) {
            response.pruned = pruned;
          }
        }
        response.HEAD = remoteHTTP.symrefs.get("HEAD");
        if (response.HEAD === void 0) {
          const { oid: oid2 } = GitRefManager.resolveAgainstMap({
            ref: "HEAD",
            map: remoteRefs
          });
          for (const [key, value] of remoteRefs.entries()) {
            if (key !== "HEAD" && value === oid2) {
              response.HEAD = key;
              break;
            }
          }
        }
        const noun = fullref.startsWith("refs/tags") ? "tag" : "branch";
        response.FETCH_HEAD = {
          oid,
          description: `${noun} '${abbreviateRef(fullref)}' of ${url}`
        };
        if (onProgress || onMessage) {
          const lines = splitLines(response.progress);
          forAwait2(lines, async (line) => {
            if (onMessage) await onMessage(line);
            if (onProgress) {
              const matches = line.match(/([^:]*).*\((\d+?)\/(\d+?)\)/);
              if (matches) {
                await onProgress({
                  phase: matches[1].trim(),
                  loaded: parseInt(matches[2], 10),
                  total: parseInt(matches[3], 10)
                });
              }
            }
          });
        }
        const packfile = Buffer.from(await collect2(response.packfile));
        if (raw.body.error) throw raw.body.error;
        const packfileSha = packfile.slice(-20).toString("hex");
        const res = {
          defaultBranch: response.HEAD,
          fetchHead: response.FETCH_HEAD.oid,
          fetchHeadDescription: response.FETCH_HEAD.description
        };
        if (response.headers) {
          res.headers = response.headers;
        }
        if (prune) {
          res.pruned = response.pruned;
        }
        if (packfileSha !== "" && !emptyPackfile(packfile)) {
          res.packfile = `objects/pack/pack-${packfileSha}.pack`;
          const fullpath = pathBrowserify.join(gitdir, res.packfile);
          await fs2.write(fullpath, packfile);
          const getExternalRefDelta = (oid2) => _readObject({ fs: fs2, cache: cache2, gitdir, oid: oid2 });
          const idx = await GitPackIndex.fromPack({
            pack: packfile,
            getExternalRefDelta,
            onProgress
          });
          await fs2.write(fullpath.replace(/\.pack$/, ".idx"), await idx.toBuffer());
        }
        return res;
      }
      async function _init({
        fs: fs2,
        bare = false,
        dir,
        gitdir = bare ? dir : pathBrowserify.join(dir, ".git"),
        defaultBranch = "master"
      }) {
        if (await fs2.exists(gitdir + "/config")) return;
        let folders = [
          "hooks",
          "info",
          "objects/info",
          "objects/pack",
          "refs/heads",
          "refs/tags"
        ];
        folders = folders.map((dir2) => gitdir + "/" + dir2);
        for (const folder of folders) {
          await fs2.mkdir(folder);
        }
        await fs2.write(
          gitdir + "/config",
          `[core]
	repositoryformatversion = 0
	filemode = false
	bare = ${bare}
` + (bare ? "" : "	logallrefupdates = true\n") + "	symlinks = false\n	ignorecase = true\n"
        );
        await fs2.write(gitdir + "/HEAD", `ref: refs/heads/${defaultBranch}
`);
      }
      async function _clone({
        fs: fs2,
        cache: cache2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        onPostCheckout,
        dir,
        gitdir,
        url,
        corsProxy,
        ref,
        remote,
        depth,
        since,
        exclude,
        relative: relative2,
        singleBranch,
        noCheckout,
        noTags,
        headers,
        nonBlocking,
        batchSize = 100
      }) {
        try {
          await _init({ fs: fs2, gitdir });
          await _addRemote({ fs: fs2, gitdir, remote, url, force: false });
          if (corsProxy) {
            const config = await GitConfigManager.get({ fs: fs2, gitdir });
            await config.set(`http.corsProxy`, corsProxy);
            await GitConfigManager.save({ fs: fs2, gitdir, config });
          }
          const { defaultBranch, fetchHead } = await _fetch2({
            fs: fs2,
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            gitdir,
            ref,
            remote,
            corsProxy,
            depth,
            since,
            exclude,
            relative: relative2,
            singleBranch,
            headers,
            tags: !noTags
          });
          if (fetchHead === null) return;
          ref = ref || defaultBranch;
          ref = ref.replace("refs/heads/", "");
          await _checkout({
            fs: fs2,
            cache: cache2,
            onProgress,
            onPostCheckout,
            dir,
            gitdir,
            ref,
            remote,
            noCheckout,
            nonBlocking,
            batchSize
          });
        } catch (err3) {
          await fs2.rmdir(gitdir, { recursive: true, maxRetries: 10 }).catch(() => void 0);
          throw err3;
        }
      }
      async function clone({
        fs: fs2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        onPostCheckout,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        url,
        corsProxy = void 0,
        ref = void 0,
        remote = "origin",
        depth = void 0,
        since = void 0,
        exclude = [],
        relative: relative2 = false,
        singleBranch = false,
        noCheckout = false,
        noTags = false,
        headers = {},
        cache: cache2 = {},
        nonBlocking = false,
        batchSize = 100
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("http", http2);
          assertParameter("gitdir", gitdir);
          if (!noCheckout) {
            assertParameter("dir", dir);
          }
          assertParameter("url", url);
          return await _clone({
            fs: new FileSystem2(fs2),
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            onPostCheckout,
            dir,
            gitdir,
            url,
            corsProxy,
            ref,
            remote,
            depth,
            since,
            exclude,
            relative: relative2,
            singleBranch,
            noCheckout,
            noTags,
            headers,
            nonBlocking,
            batchSize
          });
        } catch (err3) {
          err3.caller = "git.clone";
          throw err3;
        }
      }
      async function commit({
        fs: _fs,
        onSign,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        message,
        author,
        committer,
        signingKey,
        amend = false,
        dryRun = false,
        noUpdateBranch = false,
        ref,
        parent,
        tree,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          if (!amend) {
            assertParameter("message", message);
          }
          if (signingKey) {
            assertParameter("onSign", onSign);
          }
          const fs2 = new FileSystem2(_fs);
          return await _commit({
            fs: fs2,
            cache: cache2,
            onSign,
            gitdir,
            message,
            author,
            committer,
            signingKey,
            amend,
            dryRun,
            noUpdateBranch,
            ref,
            parent,
            tree
          });
        } catch (err3) {
          err3.caller = "git.commit";
          throw err3;
        }
      }
      async function currentBranch({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        fullname = false,
        test = false
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          return await _currentBranch({
            fs: new FileSystem2(fs2),
            gitdir,
            fullname,
            test
          });
        } catch (err3) {
          err3.caller = "git.currentBranch";
          throw err3;
        }
      }
      async function _deleteBranch({ fs: fs2, gitdir, ref }) {
        ref = ref.startsWith("refs/heads/") ? ref : `refs/heads/${ref}`;
        const exist = await GitRefManager.exists({ fs: fs2, gitdir, ref });
        if (!exist) {
          throw new NotFoundError(ref);
        }
        const fullRef = await GitRefManager.expand({ fs: fs2, gitdir, ref });
        const currentRef = await _currentBranch({ fs: fs2, gitdir, fullname: true });
        if (fullRef === currentRef) {
          const value = await GitRefManager.resolve({ fs: fs2, gitdir, ref: fullRef });
          await GitRefManager.writeRef({ fs: fs2, gitdir, ref: "HEAD", value });
        }
        await GitRefManager.deleteRef({ fs: fs2, gitdir, ref: fullRef });
        const abbrevRef = abbreviateRef(ref);
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        await config.deleteSection("branch", abbrevRef);
        await GitConfigManager.save({ fs: fs2, gitdir, config });
      }
      async function deleteBranch({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("ref", ref);
          return await _deleteBranch({
            fs: new FileSystem2(fs2),
            gitdir,
            ref
          });
        } catch (err3) {
          err3.caller = "git.deleteBranch";
          throw err3;
        }
      }
      async function deleteRef({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), ref }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("ref", ref);
          await GitRefManager.deleteRef({ fs: new FileSystem2(fs2), gitdir, ref });
        } catch (err3) {
          err3.caller = "git.deleteRef";
          throw err3;
        }
      }
      async function _deleteRemote({ fs: fs2, gitdir, remote }) {
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        await config.deleteSection("remote", remote);
        await GitConfigManager.save({ fs: fs2, gitdir, config });
      }
      async function deleteRemote({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        remote
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("remote", remote);
          return await _deleteRemote({
            fs: new FileSystem2(fs2),
            gitdir,
            remote
          });
        } catch (err3) {
          err3.caller = "git.deleteRemote";
          throw err3;
        }
      }
      async function _deleteTag({ fs: fs2, gitdir, ref }) {
        ref = ref.startsWith("refs/tags/") ? ref : `refs/tags/${ref}`;
        await GitRefManager.deleteRef({ fs: fs2, gitdir, ref });
      }
      async function deleteTag({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), ref }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("ref", ref);
          return await _deleteTag({
            fs: new FileSystem2(fs2),
            gitdir,
            ref
          });
        } catch (err3) {
          err3.caller = "git.deleteTag";
          throw err3;
        }
      }
      async function expandOidLoose({ fs: fs2, gitdir, oid: short }) {
        const prefix = short.slice(0, 2);
        const objectsSuffixes = await fs2.readdir(`${gitdir}/objects/${prefix}`);
        return objectsSuffixes.map((suffix) => `${prefix}${suffix}`).filter((_oid) => _oid.startsWith(short));
      }
      async function expandOidPacked({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid: short,
        getExternalRefDelta
      }) {
        const results = [];
        let list2 = await fs2.readdir(pathBrowserify.join(gitdir, "objects/pack"));
        list2 = list2.filter((x) => x.endsWith(".idx"));
        for (const filename of list2) {
          const indexFile = `${gitdir}/objects/pack/${filename}`;
          const p12 = await readPackIndex({
            fs: fs2,
            cache: cache2,
            filename: indexFile,
            getExternalRefDelta
          });
          if (p12.error) throw new InternalError2(p12.error);
          for (const oid of p12.offsets.keys()) {
            if (oid.startsWith(short)) results.push(oid);
          }
        }
        return results;
      }
      async function _expandOid({ fs: fs2, cache: cache2, gitdir, oid: short }) {
        const getExternalRefDelta = (oid) => _readObject({ fs: fs2, cache: cache2, gitdir, oid });
        const results = await expandOidLoose({ fs: fs2, gitdir, oid: short });
        const packedOids = await expandOidPacked({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid: short,
          getExternalRefDelta
        });
        for (const packedOid of packedOids) {
          if (results.indexOf(packedOid) === -1) {
            results.push(packedOid);
          }
        }
        if (results.length === 1) {
          return results[0];
        }
        if (results.length > 1) {
          throw new AmbiguousError("oids", short, results);
        }
        throw new NotFoundError(`an object matching "${short}"`);
      }
      async function expandOid({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          return await _expandOid({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oid
          });
        } catch (err3) {
          err3.caller = "git.expandOid";
          throw err3;
        }
      }
      async function expandRef({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), ref }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          return await GitRefManager.expand({
            fs: new FileSystem2(fs2),
            gitdir,
            ref
          });
        } catch (err3) {
          err3.caller = "git.expandRef";
          throw err3;
        }
      }
      async function _findMergeBase({ fs: fs2, cache: cache2, gitdir, oids }) {
        const visits = {};
        const passes = oids.length;
        let heads = oids.map((oid, index3) => ({ index: index3, oid }));
        while (heads.length) {
          const result = /* @__PURE__ */ new Set();
          for (const { oid, index: index3 } of heads) {
            if (!visits[oid]) visits[oid] = /* @__PURE__ */ new Set();
            visits[oid].add(index3);
            if (visits[oid].size === passes) {
              result.add(oid);
            }
          }
          if (result.size > 0) {
            return [...result];
          }
          const newheads = /* @__PURE__ */ new Map();
          for (const { oid, index: index3 } of heads) {
            try {
              const { object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
              const commit2 = GitCommit.from(object);
              const { parent } = commit2.parseHeaders();
              for (const oid2 of parent) {
                if (!visits[oid2] || !visits[oid2].has(index3)) {
                  newheads.set(oid2 + ":" + index3, { oid: oid2, index: index3 });
                }
              }
            } catch (err3) {
            }
          }
          heads = Array.from(newheads.values());
        }
        return [];
      }
      var LINEBREAKS = /^.*(\r?\n|$)/gm;
      function mergeFile({ branches, contents }) {
        const ourName = branches[1];
        const theirName = branches[2];
        const baseContent = contents[0];
        const ourContent = contents[1];
        const theirContent = contents[2];
        const ours = ourContent.match(LINEBREAKS);
        const base2 = baseContent.match(LINEBREAKS);
        const theirs = theirContent.match(LINEBREAKS);
        const result = diff3Merge(ours, base2, theirs);
        const markerSize = 7;
        let mergedText = "";
        let cleanMerge = true;
        for (const item of result) {
          if (item.ok) {
            mergedText += item.ok.join("");
          }
          if (item.conflict) {
            cleanMerge = false;
            mergedText += `${"<".repeat(markerSize)} ${ourName}
`;
            mergedText += item.conflict.a.join("");
            mergedText += `${"=".repeat(markerSize)}
`;
            mergedText += item.conflict.b.join("");
            mergedText += `${">".repeat(markerSize)} ${theirName}
`;
          }
        }
        return { cleanMerge, mergedText };
      }
      async function mergeTree({
        fs: fs2,
        cache: cache2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        index: index3,
        ourOid,
        baseOid,
        theirOid,
        ourName = "ours",
        baseName = "base",
        theirName = "theirs",
        dryRun = false,
        abortOnConflict = true,
        mergeDriver
      }) {
        const ourTree = TREE({ ref: ourOid });
        const baseTree = TREE({ ref: baseOid });
        const theirTree = TREE({ ref: theirOid });
        const unmergedFiles = [];
        const bothModified = [];
        const deleteByUs = [];
        const deleteByTheirs = [];
        const results = await _walk({
          fs: fs2,
          cache: cache2,
          dir,
          gitdir,
          trees: [ourTree, baseTree, theirTree],
          map: async function(filepath, [ours, base2, theirs]) {
            const path3 = basename2(filepath);
            const ourChange = await modified(ours, base2);
            const theirChange = await modified(theirs, base2);
            switch (`${ourChange}-${theirChange}`) {
              case "false-false": {
                return {
                  mode: await base2.mode(),
                  path: path3,
                  oid: await base2.oid(),
                  type: await base2.type()
                };
              }
              case "false-true": {
                if (!theirs && await ours.type() === "tree") {
                  return {
                    mode: await ours.mode(),
                    path: path3,
                    oid: await ours.oid(),
                    type: await ours.type()
                  };
                }
                return theirs ? {
                  mode: await theirs.mode(),
                  path: path3,
                  oid: await theirs.oid(),
                  type: await theirs.type()
                } : void 0;
              }
              case "true-false": {
                if (!ours && await theirs.type() === "tree") {
                  return {
                    mode: await theirs.mode(),
                    path: path3,
                    oid: await theirs.oid(),
                    type: await theirs.type()
                  };
                }
                return ours ? {
                  mode: await ours.mode(),
                  path: path3,
                  oid: await ours.oid(),
                  type: await ours.type()
                } : void 0;
              }
              case "true-true": {
                if (ours && theirs && await ours.type() === "tree" && await theirs.type() === "tree") {
                  return {
                    mode: await ours.mode(),
                    path: path3,
                    oid: await ours.oid(),
                    type: "tree"
                  };
                }
                if (ours && theirs && await ours.type() === "blob" && await theirs.type() === "blob") {
                  return mergeBlobs({
                    fs: fs2,
                    gitdir,
                    path: path3,
                    ours,
                    base: base2,
                    theirs,
                    ourName,
                    baseName,
                    theirName,
                    mergeDriver
                  }).then(async (r2) => {
                    if (!r2.cleanMerge) {
                      unmergedFiles.push(filepath);
                      bothModified.push(filepath);
                      if (!abortOnConflict) {
                        let baseOid2 = "";
                        if (base2 && await base2.type() === "blob") {
                          baseOid2 = await base2.oid();
                        }
                        const ourOid2 = await ours.oid();
                        const theirOid2 = await theirs.oid();
                        index3.delete({ filepath });
                        if (baseOid2) {
                          index3.insert({ filepath, oid: baseOid2, stage: 1 });
                        }
                        index3.insert({ filepath, oid: ourOid2, stage: 2 });
                        index3.insert({ filepath, oid: theirOid2, stage: 3 });
                      }
                    } else if (!abortOnConflict) {
                      index3.insert({ filepath, oid: r2.mergeResult.oid, stage: 0 });
                    }
                    return r2.mergeResult;
                  });
                }
                if (base2 && !ours && theirs && await base2.type() === "blob" && await theirs.type() === "blob") {
                  unmergedFiles.push(filepath);
                  deleteByUs.push(filepath);
                  if (!abortOnConflict) {
                    const baseOid2 = await base2.oid();
                    const theirOid2 = await theirs.oid();
                    index3.delete({ filepath });
                    index3.insert({ filepath, oid: baseOid2, stage: 1 });
                    index3.insert({ filepath, oid: theirOid2, stage: 3 });
                  }
                  return {
                    mode: await theirs.mode(),
                    oid: await theirs.oid(),
                    type: "blob",
                    path: path3
                  };
                }
                if (base2 && ours && !theirs && await base2.type() === "blob" && await ours.type() === "blob") {
                  unmergedFiles.push(filepath);
                  deleteByTheirs.push(filepath);
                  if (!abortOnConflict) {
                    const baseOid2 = await base2.oid();
                    const ourOid2 = await ours.oid();
                    index3.delete({ filepath });
                    index3.insert({ filepath, oid: baseOid2, stage: 1 });
                    index3.insert({ filepath, oid: ourOid2, stage: 2 });
                  }
                  return {
                    mode: await ours.mode(),
                    oid: await ours.oid(),
                    type: "blob",
                    path: path3
                  };
                }
                if (base2 && !ours && !theirs && (await base2.type() === "blob" || await base2.type() === "tree")) {
                  return void 0;
                }
                throw new MergeNotSupportedError();
              }
            }
          },
          /**
           * @param {TreeEntry} [parent]
           * @param {Array<TreeEntry>} children
           */
          reduce: unmergedFiles.length !== 0 && (!dir || abortOnConflict) ? void 0 : async (parent, children) => {
            const entries2 = children.filter(Boolean);
            if (!parent) return;
            if (parent && parent.type === "tree" && entries2.length === 0 && parent.path !== ".")
              return;
            if (entries2.length > 0 || parent.path === "." && entries2.length === 0) {
              const tree = new GitTree(entries2);
              const object = tree.toObject();
              const oid = await _writeObject({
                fs: fs2,
                gitdir,
                type: "tree",
                object,
                dryRun
              });
              parent.oid = oid;
            }
            return parent;
          }
        });
        if (unmergedFiles.length !== 0) {
          if (dir && !abortOnConflict) {
            await _walk({
              fs: fs2,
              cache: cache2,
              dir,
              gitdir,
              trees: [TREE({ ref: results.oid })],
              map: async function(filepath, [entry]) {
                const path3 = `${dir}/${filepath}`;
                if (await entry.type() === "blob") {
                  const mode = await entry.mode();
                  const content = new TextDecoder().decode(await entry.content());
                  await fs2.write(path3, content, { mode });
                }
                return true;
              }
            });
          }
          return new MergeConflictError(
            unmergedFiles,
            bothModified,
            deleteByUs,
            deleteByTheirs
          );
        }
        return results.oid;
      }
      async function mergeBlobs({
        fs: fs2,
        gitdir,
        path: path3,
        ours,
        base: base2,
        theirs,
        ourName,
        theirName,
        baseName,
        dryRun,
        mergeDriver = mergeFile
      }) {
        const type = "blob";
        let baseMode = "100755";
        let baseOid = "";
        let baseContent = "";
        if (base2 && await base2.type() === "blob") {
          baseMode = await base2.mode();
          baseOid = await base2.oid();
          baseContent = Buffer.from(await base2.content()).toString("utf8");
        }
        const mode = baseMode === await ours.mode() ? await theirs.mode() : await ours.mode();
        if (await ours.oid() === await theirs.oid()) {
          return {
            cleanMerge: true,
            mergeResult: { mode, path: path3, oid: await ours.oid(), type }
          };
        }
        if (await ours.oid() === baseOid) {
          return {
            cleanMerge: true,
            mergeResult: { mode, path: path3, oid: await theirs.oid(), type }
          };
        }
        if (await theirs.oid() === baseOid) {
          return {
            cleanMerge: true,
            mergeResult: { mode, path: path3, oid: await ours.oid(), type }
          };
        }
        const ourContent = Buffer.from(await ours.content()).toString("utf8");
        const theirContent = Buffer.from(await theirs.content()).toString("utf8");
        const { mergedText, cleanMerge } = await mergeDriver({
          branches: [baseName, ourName, theirName],
          contents: [baseContent, ourContent, theirContent],
          path: path3
        });
        const oid = await _writeObject({
          fs: fs2,
          gitdir,
          type: "blob",
          object: Buffer.from(mergedText, "utf8"),
          dryRun
        });
        return { cleanMerge, mergeResult: { mode, path: path3, oid, type } };
      }
      async function _merge({
        fs: fs2,
        cache: cache2,
        dir,
        gitdir,
        ours,
        theirs,
        fastForward: fastForward2 = true,
        fastForwardOnly = false,
        dryRun = false,
        noUpdateBranch = false,
        abortOnConflict = true,
        message,
        author,
        committer,
        signingKey,
        onSign,
        mergeDriver,
        allowUnrelatedHistories = false
      }) {
        if (ours === void 0) {
          ours = await _currentBranch({ fs: fs2, gitdir, fullname: true });
        }
        ours = await GitRefManager.expand({
          fs: fs2,
          gitdir,
          ref: ours
        });
        theirs = await GitRefManager.expand({
          fs: fs2,
          gitdir,
          ref: theirs
        });
        const ourOid = await GitRefManager.resolve({
          fs: fs2,
          gitdir,
          ref: ours
        });
        const theirOid = await GitRefManager.resolve({
          fs: fs2,
          gitdir,
          ref: theirs
        });
        const baseOids = await _findMergeBase({
          fs: fs2,
          cache: cache2,
          gitdir,
          oids: [ourOid, theirOid]
        });
        if (baseOids.length !== 1) {
          if (baseOids.length === 0 && allowUnrelatedHistories) {
            baseOids.push("4b825dc642cb6eb9a060e54bf8d69288fbee4904");
          } else {
            throw new MergeNotSupportedError();
          }
        }
        const baseOid = baseOids[0];
        if (baseOid === theirOid) {
          return {
            oid: ourOid,
            alreadyMerged: true
          };
        }
        if (fastForward2 && baseOid === ourOid) {
          if (!dryRun && !noUpdateBranch) {
            await GitRefManager.writeRef({ fs: fs2, gitdir, ref: ours, value: theirOid });
          }
          return {
            oid: theirOid,
            fastForward: true
          };
        } else {
          if (fastForwardOnly) {
            throw new FastForwardError();
          }
          const tree = await GitIndexManager.acquire(
            { fs: fs2, gitdir, cache: cache2, allowUnmerged: false },
            async (index3) => {
              return mergeTree({
                fs: fs2,
                cache: cache2,
                dir,
                gitdir,
                index: index3,
                ourOid,
                theirOid,
                baseOid,
                ourName: abbreviateRef(ours),
                baseName: "base",
                theirName: abbreviateRef(theirs),
                dryRun,
                abortOnConflict,
                mergeDriver
              });
            }
          );
          if (tree instanceof MergeConflictError) throw tree;
          if (!message) {
            message = `Merge branch '${abbreviateRef(theirs)}' into ${abbreviateRef(
              ours
            )}`;
          }
          const oid = await _commit({
            fs: fs2,
            cache: cache2,
            gitdir,
            message,
            ref: ours,
            tree,
            parent: [ourOid, theirOid],
            author,
            committer,
            signingKey,
            onSign,
            dryRun,
            noUpdateBranch
          });
          return {
            oid,
            tree,
            mergeCommit: true
          };
        }
      }
      async function _pull({
        fs: fs2,
        cache: cache2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        dir,
        gitdir,
        ref,
        url,
        remote,
        remoteRef,
        prune,
        pruneTags,
        fastForward: fastForward2,
        fastForwardOnly,
        corsProxy,
        singleBranch,
        headers,
        author,
        committer,
        signingKey
      }) {
        try {
          if (!ref) {
            const head = await _currentBranch({ fs: fs2, gitdir });
            if (!head) {
              throw new MissingParameterError("ref");
            }
            ref = head;
          }
          const { fetchHead, fetchHeadDescription } = await _fetch2({
            fs: fs2,
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            gitdir,
            corsProxy,
            ref,
            url,
            remote,
            remoteRef,
            singleBranch,
            headers,
            prune,
            pruneTags
          });
          await _merge({
            fs: fs2,
            cache: cache2,
            gitdir,
            ours: ref,
            theirs: fetchHead,
            fastForward: fastForward2,
            fastForwardOnly,
            message: `Merge ${fetchHeadDescription}`,
            author,
            committer,
            signingKey,
            dryRun: false,
            noUpdateBranch: false
          });
          await _checkout({
            fs: fs2,
            cache: cache2,
            onProgress,
            dir,
            gitdir,
            ref,
            remote,
            noCheckout: false
          });
        } catch (err3) {
          err3.caller = "git.pull";
          throw err3;
        }
      }
      async function fastForward({
        fs: fs2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        url,
        remote,
        remoteRef,
        corsProxy,
        singleBranch,
        headers = {},
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("http", http2);
          assertParameter("gitdir", gitdir);
          const thisWillNotBeUsed = {
            name: "",
            email: "",
            timestamp: Date.now(),
            timezoneOffset: 0
          };
          return await _pull({
            fs: new FileSystem2(fs2),
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            dir,
            gitdir,
            ref,
            url,
            remote,
            remoteRef,
            fastForwardOnly: true,
            corsProxy,
            singleBranch,
            headers,
            author: thisWillNotBeUsed,
            committer: thisWillNotBeUsed
          });
        } catch (err3) {
          err3.caller = "git.fastForward";
          throw err3;
        }
      }
      async function fetch3({
        fs: fs2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        remote,
        remoteRef,
        url,
        corsProxy,
        depth = null,
        since = null,
        exclude = [],
        relative: relative2 = false,
        tags = false,
        singleBranch = false,
        headers = {},
        prune = false,
        pruneTags = false,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("http", http2);
          assertParameter("gitdir", gitdir);
          return await _fetch2({
            fs: new FileSystem2(fs2),
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            gitdir,
            ref,
            remote,
            remoteRef,
            url,
            corsProxy,
            depth,
            since,
            exclude,
            relative: relative2,
            tags,
            singleBranch,
            headers,
            prune,
            pruneTags
          });
        } catch (err3) {
          err3.caller = "git.fetch";
          throw err3;
        }
      }
      async function findMergeBase({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oids,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oids", oids);
          return await _findMergeBase({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oids
          });
        } catch (err3) {
          err3.caller = "git.findMergeBase";
          throw err3;
        }
      }
      async function _findRoot({ fs: fs2, filepath }) {
        if (await fs2.exists(pathBrowserify.join(filepath, ".git"))) {
          return filepath;
        } else {
          const parent = dirname3(filepath);
          if (parent === filepath) {
            throw new NotFoundError(`git root for ${filepath}`);
          }
          return _findRoot({ fs: fs2, filepath: parent });
        }
      }
      async function findRoot({ fs: fs2, filepath }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("filepath", filepath);
          return await _findRoot({ fs: new FileSystem2(fs2), filepath });
        } catch (err3) {
          err3.caller = "git.findRoot";
          throw err3;
        }
      }
      async function getConfig({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), path: path3 }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("path", path3);
          return await _getConfig({
            fs: new FileSystem2(fs2),
            gitdir,
            path: path3
          });
        } catch (err3) {
          err3.caller = "git.getConfig";
          throw err3;
        }
      }
      async function _getConfigAll({ fs: fs2, gitdir, path: path3 }) {
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        return config.getall(path3);
      }
      async function getConfigAll({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        path: path3
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("path", path3);
          return await _getConfigAll({
            fs: new FileSystem2(fs2),
            gitdir,
            path: path3
          });
        } catch (err3) {
          err3.caller = "git.getConfigAll";
          throw err3;
        }
      }
      async function getRemoteInfo({
        http: http2,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        corsProxy,
        url,
        headers = {},
        forPush = false
      }) {
        try {
          assertParameter("http", http2);
          assertParameter("url", url);
          const GitRemoteHTTP2 = GitRemoteManager.getRemoteHelperFor({ url });
          const remote = await GitRemoteHTTP2.discover({
            http: http2,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            corsProxy,
            service: forPush ? "git-receive-pack" : "git-upload-pack",
            url,
            headers,
            protocolVersion: 1
          });
          const result = {
            capabilities: [...remote.capabilities]
          };
          for (const [ref, oid] of remote.refs) {
            const parts = ref.split("/");
            const last = parts.pop();
            let o = result;
            for (const part of parts) {
              o[part] = o[part] || {};
              o = o[part];
            }
            o[last] = oid;
          }
          for (const [symref, ref] of remote.symrefs) {
            const parts = symref.split("/");
            const last = parts.pop();
            let o = result;
            for (const part of parts) {
              o[part] = o[part] || {};
              o = o[part];
            }
            o[last] = ref;
          }
          return result;
        } catch (err3) {
          err3.caller = "git.getRemoteInfo";
          throw err3;
        }
      }
      function formatInfoRefs(remote, prefix, symrefs, peelTags) {
        const refs = [];
        for (const [key, value] of remote.refs) {
          if (prefix && !key.startsWith(prefix)) continue;
          if (key.endsWith("^{}")) {
            if (peelTags) {
              const _key = key.replace("^{}", "");
              const last = refs[refs.length - 1];
              const r2 = last.ref === _key ? last : refs.find((x) => x.ref === _key);
              if (r2 === void 0) {
                throw new Error("I did not expect this to happen");
              }
              r2.peeled = value;
            }
            continue;
          }
          const ref = { ref: key, oid: value };
          if (symrefs) {
            if (remote.symrefs.has(key)) {
              ref.target = remote.symrefs.get(key);
            }
          }
          refs.push(ref);
        }
        return refs;
      }
      async function getRemoteInfo2({
        http: http2,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        corsProxy,
        url,
        headers = {},
        forPush = false,
        protocolVersion = 2
      }) {
        try {
          assertParameter("http", http2);
          assertParameter("url", url);
          const GitRemoteHTTP2 = GitRemoteManager.getRemoteHelperFor({ url });
          const remote = await GitRemoteHTTP2.discover({
            http: http2,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            corsProxy,
            service: forPush ? "git-receive-pack" : "git-upload-pack",
            url,
            headers,
            protocolVersion
          });
          if (remote.protocolVersion === 2) {
            return {
              protocolVersion: remote.protocolVersion,
              capabilities: remote.capabilities2
            };
          }
          const capabilities = {};
          for (const cap of remote.capabilities) {
            const [key, value] = cap.split("=");
            if (value) {
              capabilities[key] = value;
            } else {
              capabilities[key] = true;
            }
          }
          return {
            protocolVersion: 1,
            capabilities,
            refs: formatInfoRefs(remote, void 0, true, true)
          };
        } catch (err3) {
          err3.caller = "git.getRemoteInfo2";
          throw err3;
        }
      }
      async function hashObject({
        type,
        object,
        format: format5 = "content",
        oid = void 0
      }) {
        if (format5 !== "deflated") {
          if (format5 !== "wrapped") {
            object = GitObject.wrap({ type, object });
          }
          oid = await shasum(object);
        }
        return { oid, object };
      }
      async function hashBlob({ object }) {
        try {
          assertParameter("object", object);
          if (typeof object === "string") {
            object = Buffer.from(object, "utf8");
          } else if (!(object instanceof Uint8Array)) {
            object = new Uint8Array(object);
          }
          const type = "blob";
          const { oid, object: _object } = await hashObject({
            type,
            format: "content",
            object
          });
          return { oid, type, object: _object, format: "wrapped" };
        } catch (err3) {
          err3.caller = "git.hashBlob";
          throw err3;
        }
      }
      async function _indexPack({
        fs: fs2,
        cache: cache2,
        onProgress,
        dir,
        gitdir,
        filepath
      }) {
        try {
          filepath = pathBrowserify.join(dir, filepath);
          const pack = await fs2.read(filepath);
          const getExternalRefDelta = (oid) => _readObject({ fs: fs2, cache: cache2, gitdir, oid });
          const idx = await GitPackIndex.fromPack({
            pack,
            getExternalRefDelta,
            onProgress
          });
          await fs2.write(filepath.replace(/\.pack$/, ".idx"), await idx.toBuffer());
          return {
            oids: [...idx.hashes]
          };
        } catch (err3) {
          err3.caller = "git.indexPack";
          throw err3;
        }
      }
      async function indexPack({
        fs: fs2,
        onProgress,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("dir", dir);
          assertParameter("gitdir", dir);
          assertParameter("filepath", filepath);
          return await _indexPack({
            fs: new FileSystem2(fs2),
            cache: cache2,
            onProgress,
            dir,
            gitdir,
            filepath
          });
        } catch (err3) {
          err3.caller = "git.indexPack";
          throw err3;
        }
      }
      async function init3({
        fs: fs2,
        bare = false,
        dir,
        gitdir = bare ? dir : pathBrowserify.join(dir, ".git"),
        defaultBranch = "master"
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          if (!bare) {
            assertParameter("dir", dir);
          }
          return await _init({
            fs: new FileSystem2(fs2),
            bare,
            dir,
            gitdir,
            defaultBranch
          });
        } catch (err3) {
          err3.caller = "git.init";
          throw err3;
        }
      }
      async function _isDescendent({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        ancestor,
        depth
      }) {
        const shallows = await GitShallowManager.read({ fs: fs2, gitdir });
        if (!oid) {
          throw new MissingParameterError("oid");
        }
        if (!ancestor) {
          throw new MissingParameterError("ancestor");
        }
        if (oid === ancestor) return false;
        const queue = [oid];
        const visited = /* @__PURE__ */ new Set();
        let searchdepth = 0;
        while (queue.length) {
          if (searchdepth++ === depth) {
            throw new MaxDepthError(depth);
          }
          const oid2 = queue.shift();
          const { type, object } = await _readObject({
            fs: fs2,
            cache: cache2,
            gitdir,
            oid: oid2
          });
          if (type !== "commit") {
            throw new ObjectTypeError(oid2, type, "commit");
          }
          const commit2 = GitCommit.from(object).parse();
          for (const parent of commit2.parent) {
            if (parent === ancestor) return true;
          }
          if (!shallows.has(oid2)) {
            for (const parent of commit2.parent) {
              if (!visited.has(parent)) {
                queue.push(parent);
                visited.add(parent);
              }
            }
          }
        }
        return false;
      }
      async function isDescendent({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        ancestor,
        depth = -1,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          assertParameter("ancestor", ancestor);
          return await _isDescendent({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oid,
            ancestor,
            depth
          });
        } catch (err3) {
          err3.caller = "git.isDescendent";
          throw err3;
        }
      }
      async function isIgnored({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("dir", dir);
          assertParameter("gitdir", gitdir);
          assertParameter("filepath", filepath);
          return GitIgnoreManager.isIgnored({
            fs: new FileSystem2(fs2),
            dir,
            gitdir,
            filepath
          });
        } catch (err3) {
          err3.caller = "git.isIgnored";
          throw err3;
        }
      }
      async function listBranches({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        remote
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          return GitRefManager.listBranches({
            fs: new FileSystem2(fs2),
            gitdir,
            remote
          });
        } catch (err3) {
          err3.caller = "git.listBranches";
          throw err3;
        }
      }
      async function _listFiles({ fs: fs2, gitdir, ref, cache: cache2 }) {
        if (ref) {
          const oid = await GitRefManager.resolve({ gitdir, fs: fs2, ref });
          const filenames = [];
          await accumulateFilesFromOid({
            fs: fs2,
            cache: cache2,
            gitdir,
            oid,
            filenames,
            prefix: ""
          });
          return filenames;
        } else {
          return GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            return index3.entries.map((x) => x.path);
          });
        }
      }
      async function accumulateFilesFromOid({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        filenames,
        prefix
      }) {
        const { tree } = await _readTree({ fs: fs2, cache: cache2, gitdir, oid });
        for (const entry of tree) {
          if (entry.type === "tree") {
            await accumulateFilesFromOid({
              fs: fs2,
              cache: cache2,
              gitdir,
              oid: entry.oid,
              filenames,
              prefix: pathBrowserify.join(prefix, entry.path)
            });
          } else {
            filenames.push(pathBrowserify.join(prefix, entry.path));
          }
        }
      }
      async function listFiles({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          return await _listFiles({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            ref
          });
        } catch (err3) {
          err3.caller = "git.listFiles";
          throw err3;
        }
      }
      async function _listNotes({ fs: fs2, cache: cache2, gitdir, ref }) {
        let parent;
        try {
          parent = await GitRefManager.resolve({ gitdir, fs: fs2, ref });
        } catch (err3) {
          if (err3 instanceof NotFoundError) {
            return [];
          }
        }
        const result = await _readTree({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid: parent
        });
        const notes = result.tree.map((entry) => ({
          target: entry.path,
          note: entry.oid
        }));
        return notes;
      }
      async function listNotes({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref = "refs/notes/commits",
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          return await _listNotes({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            ref
          });
        } catch (err3) {
          err3.caller = "git.listNotes";
          throw err3;
        }
      }
      async function listRefs({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          return GitRefManager.listRefs({ fs: new FileSystem2(fs2), gitdir, filepath });
        } catch (err3) {
          err3.caller = "git.listRefs";
          throw err3;
        }
      }
      async function _listRemotes({ fs: fs2, gitdir }) {
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        const remoteNames = await config.getSubsections("remote");
        const remotes = Promise.all(
          remoteNames.map(async (remote) => {
            const url = await config.get(`remote.${remote}.url`);
            return { remote, url };
          })
        );
        return remotes;
      }
      async function listRemotes({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git") }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          return await _listRemotes({
            fs: new FileSystem2(fs2),
            gitdir
          });
        } catch (err3) {
          err3.caller = "git.listRemotes";
          throw err3;
        }
      }
      async function parseListRefsResponse(stream) {
        const read2 = GitPktLine.streamReader(stream);
        const refs = [];
        let line;
        while (true) {
          line = await read2();
          if (line === true) break;
          if (line === null) continue;
          line = line.toString("utf8").replace(/\n$/, "");
          const [oid, ref, ...attrs] = line.split(" ");
          const r2 = { ref, oid };
          for (const attr of attrs) {
            const [name2, value] = attr.split(":");
            if (name2 === "symref-target") {
              r2.target = value;
            } else if (name2 === "peeled") {
              r2.peeled = value;
            }
          }
          refs.push(r2);
        }
        return refs;
      }
      async function writeListRefsRequest({ prefix, symrefs, peelTags }) {
        const packstream = [];
        packstream.push(GitPktLine.encode("command=ls-refs\n"));
        packstream.push(GitPktLine.encode(`agent=${pkg2.agent}
`));
        if (peelTags || symrefs || prefix) {
          packstream.push(GitPktLine.delim());
        }
        if (peelTags) packstream.push(GitPktLine.encode("peel"));
        if (symrefs) packstream.push(GitPktLine.encode("symrefs"));
        if (prefix) packstream.push(GitPktLine.encode(`ref-prefix ${prefix}`));
        packstream.push(GitPktLine.flush());
        return packstream;
      }
      async function listServerRefs({
        http: http2,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        corsProxy,
        url,
        headers = {},
        forPush = false,
        protocolVersion = 2,
        prefix,
        symrefs,
        peelTags
      }) {
        try {
          assertParameter("http", http2);
          assertParameter("url", url);
          const remote = await GitRemoteHTTP.discover({
            http: http2,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            corsProxy,
            service: forPush ? "git-receive-pack" : "git-upload-pack",
            url,
            headers,
            protocolVersion
          });
          if (remote.protocolVersion === 1) {
            return formatInfoRefs(remote, prefix, symrefs, peelTags);
          }
          const body = await writeListRefsRequest({ prefix, symrefs, peelTags });
          const res = await GitRemoteHTTP.connect({
            http: http2,
            auth: remote.auth,
            headers,
            corsProxy,
            service: forPush ? "git-receive-pack" : "git-upload-pack",
            url,
            body
          });
          return parseListRefsResponse(res.body);
        } catch (err3) {
          err3.caller = "git.listServerRefs";
          throw err3;
        }
      }
      async function listTags({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git") }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          return GitRefManager.listTags({ fs: new FileSystem2(fs2), gitdir });
        } catch (err3) {
          err3.caller = "git.listTags";
          throw err3;
        }
      }
      function compareAge(a, b) {
        return a.committer.timestamp - b.committer.timestamp;
      }
      var EMPTY_OID = "e69de29bb2d1d6434b8b29ae775ad8c2e48c5391";
      async function resolveFileIdInTree({ fs: fs2, cache: cache2, gitdir, oid, fileId }) {
        if (fileId === EMPTY_OID) return;
        const _oid = oid;
        let filepath;
        const result = await resolveTree({ fs: fs2, cache: cache2, gitdir, oid });
        const tree = result.tree;
        if (fileId === result.oid) {
          filepath = result.path;
        } else {
          filepath = await _resolveFileId({
            fs: fs2,
            cache: cache2,
            gitdir,
            tree,
            fileId,
            oid: _oid
          });
          if (Array.isArray(filepath)) {
            if (filepath.length === 0) filepath = void 0;
            else if (filepath.length === 1) filepath = filepath[0];
          }
        }
        return filepath;
      }
      async function _resolveFileId({
        fs: fs2,
        cache: cache2,
        gitdir,
        tree,
        fileId,
        oid,
        filepaths = [],
        parentPath = ""
      }) {
        const walks = tree.entries().map(function(entry) {
          let result;
          if (entry.oid === fileId) {
            result = pathBrowserify.join(parentPath, entry.path);
            filepaths.push(result);
          } else if (entry.type === "tree") {
            result = _readObject({
              fs: fs2,
              cache: cache2,
              gitdir,
              oid: entry.oid
            }).then(function({ object }) {
              return _resolveFileId({
                fs: fs2,
                cache: cache2,
                gitdir,
                tree: GitTree.from(object),
                fileId,
                oid,
                filepaths,
                parentPath: pathBrowserify.join(parentPath, entry.path)
              });
            });
          }
          return result;
        });
        await Promise.all(walks);
        return filepaths;
      }
      async function _log({
        fs: fs2,
        cache: cache2,
        gitdir,
        filepath,
        ref,
        depth,
        since,
        force,
        follow
      }) {
        const sinceTimestamp = typeof since === "undefined" ? void 0 : Math.floor(since.valueOf() / 1e3);
        const commits = [];
        const shallowCommits = await GitShallowManager.read({ fs: fs2, gitdir });
        const oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref });
        const tips = [await _readCommit({ fs: fs2, cache: cache2, gitdir, oid })];
        let lastFileOid;
        let lastCommit;
        let isOk;
        function endCommit(commit2) {
          if (isOk && filepath) commits.push(commit2);
        }
        while (tips.length > 0) {
          const commit2 = tips.pop();
          if (sinceTimestamp !== void 0 && commit2.commit.committer.timestamp <= sinceTimestamp) {
            break;
          }
          if (filepath) {
            let vFileOid;
            try {
              vFileOid = await resolveFilepath2({
                fs: fs2,
                cache: cache2,
                gitdir,
                oid: commit2.commit.tree,
                filepath
              });
              if (lastCommit && lastFileOid !== vFileOid) {
                commits.push(lastCommit);
              }
              lastFileOid = vFileOid;
              lastCommit = commit2;
              isOk = true;
            } catch (e2) {
              if (e2 instanceof NotFoundError) {
                let found = follow && lastFileOid;
                if (found) {
                  found = await resolveFileIdInTree({
                    fs: fs2,
                    cache: cache2,
                    gitdir,
                    oid: commit2.commit.tree,
                    fileId: lastFileOid
                  });
                  if (found) {
                    if (Array.isArray(found)) {
                      if (lastCommit) {
                        const lastFound = await resolveFileIdInTree({
                          fs: fs2,
                          cache: cache2,
                          gitdir,
                          oid: lastCommit.commit.tree,
                          fileId: lastFileOid
                        });
                        if (Array.isArray(lastFound)) {
                          found = found.filter((p12) => lastFound.indexOf(p12) === -1);
                          if (found.length === 1) {
                            found = found[0];
                            filepath = found;
                            if (lastCommit) commits.push(lastCommit);
                          } else {
                            found = false;
                            if (lastCommit) commits.push(lastCommit);
                            break;
                          }
                        }
                      }
                    } else {
                      filepath = found;
                      if (lastCommit) commits.push(lastCommit);
                    }
                  }
                }
                if (!found) {
                  if (isOk && lastFileOid) {
                    commits.push(lastCommit);
                    if (!force) break;
                  }
                  if (!force && !follow) throw e2;
                }
                lastCommit = commit2;
                isOk = false;
              } else throw e2;
            }
          } else {
            commits.push(commit2);
          }
          if (depth !== void 0 && commits.length === depth) {
            endCommit(commit2);
            break;
          }
          if (!shallowCommits.has(commit2.oid)) {
            for (const oid2 of commit2.commit.parent) {
              const commit3 = await _readCommit({ fs: fs2, cache: cache2, gitdir, oid: oid2 });
              if (!tips.map((commit4) => commit4.oid).includes(commit3.oid)) {
                tips.push(commit3);
              }
            }
          }
          if (tips.length === 0) {
            endCommit(commit2);
          }
          tips.sort((a, b) => compareAge(a.commit, b.commit));
        }
        return commits;
      }
      async function log2({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath,
        ref = "HEAD",
        depth,
        since,
        // Date
        force,
        follow,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          return await _log({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            filepath,
            ref,
            depth,
            since,
            force,
            follow
          });
        } catch (err3) {
          err3.caller = "git.log";
          throw err3;
        }
      }
      async function merge3({
        fs: _fs,
        onSign,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ours,
        theirs,
        fastForward: fastForward2 = true,
        fastForwardOnly = false,
        dryRun = false,
        noUpdateBranch = false,
        abortOnConflict = true,
        message,
        author: _author,
        committer: _committer,
        signingKey,
        cache: cache2 = {},
        mergeDriver,
        allowUnrelatedHistories = false
      }) {
        try {
          assertParameter("fs", _fs);
          if (signingKey) {
            assertParameter("onSign", onSign);
          }
          const fs2 = new FileSystem2(_fs);
          const author = await normalizeAuthorObject({ fs: fs2, gitdir, author: _author });
          if (!author && (!fastForwardOnly || !fastForward2)) {
            throw new MissingNameError("author");
          }
          const committer = await normalizeCommitterObject({
            fs: fs2,
            gitdir,
            author,
            committer: _committer
          });
          if (!committer && (!fastForwardOnly || !fastForward2)) {
            throw new MissingNameError("committer");
          }
          return await _merge({
            fs: fs2,
            cache: cache2,
            dir,
            gitdir,
            ours,
            theirs,
            fastForward: fastForward2,
            fastForwardOnly,
            dryRun,
            noUpdateBranch,
            abortOnConflict,
            message,
            author,
            committer,
            signingKey,
            onSign,
            mergeDriver,
            allowUnrelatedHistories
          });
        } catch (err3) {
          err3.caller = "git.merge";
          throw err3;
        }
      }
      var types3 = {
        commit: 16,
        tree: 32,
        blob: 48,
        tag: 64,
        ofs_delta: 96,
        ref_delta: 112
      };
      async function _pack({
        fs: fs2,
        cache: cache2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oids
      }) {
        const hash2 = new Hash2();
        const outputStream = [];
        function write2(chunk, enc) {
          const buff = Buffer.from(chunk, enc);
          outputStream.push(buff);
          hash2.update(buff);
        }
        async function writeObject2({ stype, object }) {
          const type = types3[stype];
          let length2 = object.length;
          let multibyte = length2 > 15 ? 128 : 0;
          const lastFour = length2 & 15;
          length2 = length2 >>> 4;
          let byte = (multibyte | type | lastFour).toString(16);
          write2(byte, "hex");
          while (multibyte) {
            multibyte = length2 > 127 ? 128 : 0;
            byte = multibyte | length2 & 127;
            write2(padHex(2, byte), "hex");
            length2 = length2 >>> 7;
          }
          write2(Buffer.from(await deflate(object)));
        }
        write2("PACK");
        write2("00000002", "hex");
        write2(padHex(8, oids.length), "hex");
        for (const oid of oids) {
          const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
          await writeObject2({ write: write2, object, stype: type });
        }
        const digest = hash2.digest();
        outputStream.push(digest);
        return outputStream;
      }
      async function _packObjects({ fs: fs2, cache: cache2, gitdir, oids, write: write2 }) {
        const buffers = await _pack({ fs: fs2, cache: cache2, gitdir, oids });
        const packfile = Buffer.from(await collect2(buffers));
        const packfileSha = packfile.slice(-20).toString("hex");
        const filename = `pack-${packfileSha}.pack`;
        if (write2) {
          await fs2.write(pathBrowserify.join(gitdir, `objects/pack/${filename}`), packfile);
          return { filename };
        }
        return {
          filename,
          packfile: new Uint8Array(packfile)
        };
      }
      async function packObjects({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oids,
        write: write2 = false,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oids", oids);
          return await _packObjects({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oids,
            write: write2
          });
        } catch (err3) {
          err3.caller = "git.packObjects";
          throw err3;
        }
      }
      async function pull({
        fs: _fs,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        url,
        remote,
        remoteRef,
        prune = false,
        pruneTags = false,
        fastForward: fastForward2 = true,
        fastForwardOnly = false,
        corsProxy,
        singleBranch,
        headers = {},
        author: _author,
        committer: _committer,
        signingKey,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          const fs2 = new FileSystem2(_fs);
          const author = await normalizeAuthorObject({ fs: fs2, gitdir, author: _author });
          if (!author) throw new MissingNameError("author");
          const committer = await normalizeCommitterObject({
            fs: fs2,
            gitdir,
            author,
            committer: _committer
          });
          if (!committer) throw new MissingNameError("committer");
          return await _pull({
            fs: fs2,
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            dir,
            gitdir,
            ref,
            url,
            remote,
            remoteRef,
            fastForward: fastForward2,
            fastForwardOnly,
            corsProxy,
            singleBranch,
            headers,
            author,
            committer,
            signingKey,
            prune,
            pruneTags
          });
        } catch (err3) {
          err3.caller = "git.pull";
          throw err3;
        }
      }
      async function listCommitsAndTags({
        fs: fs2,
        cache: cache2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        start,
        finish
      }) {
        const shallows = await GitShallowManager.read({ fs: fs2, gitdir });
        const startingSet = /* @__PURE__ */ new Set();
        const finishingSet = /* @__PURE__ */ new Set();
        for (const ref of start) {
          startingSet.add(await GitRefManager.resolve({ fs: fs2, gitdir, ref }));
        }
        for (const ref of finish) {
          try {
            const oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref });
            finishingSet.add(oid);
          } catch (err3) {
          }
        }
        const visited = /* @__PURE__ */ new Set();
        async function walk2(oid) {
          visited.add(oid);
          const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
          if (type === "tag") {
            const tag2 = GitAnnotatedTag.from(object);
            const commit2 = tag2.headers().object;
            return walk2(commit2);
          }
          if (type !== "commit") {
            throw new ObjectTypeError(oid, type, "commit");
          }
          if (!shallows.has(oid)) {
            const commit2 = GitCommit.from(object);
            const parents = commit2.headers().parent;
            for (oid of parents) {
              if (!finishingSet.has(oid) && !visited.has(oid)) {
                await walk2(oid);
              }
            }
          }
        }
        for (const oid of startingSet) {
          await walk2(oid);
        }
        return visited;
      }
      async function listObjects({
        fs: fs2,
        cache: cache2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oids
      }) {
        const visited = /* @__PURE__ */ new Set();
        async function walk2(oid) {
          if (visited.has(oid)) return;
          visited.add(oid);
          const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
          if (type === "tag") {
            const tag2 = GitAnnotatedTag.from(object);
            const obj = tag2.headers().object;
            await walk2(obj);
          } else if (type === "commit") {
            const commit2 = GitCommit.from(object);
            const tree = commit2.headers().tree;
            await walk2(tree);
          } else if (type === "tree") {
            const tree = GitTree.from(object);
            for (const entry of tree) {
              if (entry.type === "blob") {
                visited.add(entry.oid);
              }
              if (entry.type === "tree") {
                await walk2(entry.oid);
              }
            }
          }
        }
        for (const oid of oids) {
          await walk2(oid);
        }
        return visited;
      }
      async function parseReceivePackResponse(packfile) {
        const result = {};
        let response = "";
        const read2 = GitPktLine.streamReader(packfile);
        let line = await read2();
        while (line !== true) {
          if (line !== null) response += line.toString("utf8") + "\n";
          line = await read2();
        }
        const lines = response.toString("utf8").split("\n");
        line = lines.shift();
        if (!line.startsWith("unpack ")) {
          throw new ParseError3('unpack ok" or "unpack [error message]', line);
        }
        result.ok = line === "unpack ok";
        if (!result.ok) {
          result.error = line.slice("unpack ".length);
        }
        result.refs = {};
        for (const line2 of lines) {
          if (line2.trim() === "") continue;
          const status2 = line2.slice(0, 2);
          const refAndMessage = line2.slice(3);
          let space = refAndMessage.indexOf(" ");
          if (space === -1) space = refAndMessage.length;
          const ref = refAndMessage.slice(0, space);
          const error = refAndMessage.slice(space + 1);
          result.refs[ref] = {
            ok: status2 === "ok",
            error
          };
        }
        return result;
      }
      async function writeReceivePackRequest({
        capabilities = [],
        triplets = []
      }) {
        const packstream = [];
        let capsFirstLine = `\0 ${capabilities.join(" ")}`;
        for (const trip of triplets) {
          packstream.push(
            GitPktLine.encode(
              `${trip.oldoid} ${trip.oid} ${trip.fullRef}${capsFirstLine}
`
            )
          );
          capsFirstLine = "";
        }
        packstream.push(GitPktLine.flush());
        return packstream;
      }
      async function _push({
        fs: fs2,
        cache: cache2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        onPrePush,
        gitdir,
        ref: _ref,
        remoteRef: _remoteRef,
        remote,
        url: _url,
        force = false,
        delete: _delete = false,
        corsProxy,
        headers = {}
      }) {
        const ref = _ref || await _currentBranch({ fs: fs2, gitdir });
        if (typeof ref === "undefined") {
          throw new MissingParameterError("ref");
        }
        const config = await GitConfigManager.get({ fs: fs2, gitdir });
        remote = remote || await config.get(`branch.${ref}.pushRemote`) || await config.get("remote.pushDefault") || await config.get(`branch.${ref}.remote`) || "origin";
        const url = _url || await config.get(`remote.${remote}.pushurl`) || await config.get(`remote.${remote}.url`);
        if (typeof url === "undefined") {
          throw new MissingParameterError("remote OR url");
        }
        const remoteRef = _remoteRef || await config.get(`branch.${ref}.merge`);
        if (typeof url === "undefined") {
          throw new MissingParameterError("remoteRef");
        }
        if (corsProxy === void 0) {
          corsProxy = await config.get("http.corsProxy");
        }
        const fullRef = await GitRefManager.expand({ fs: fs2, gitdir, ref });
        const oid = _delete ? "0000000000000000000000000000000000000000" : await GitRefManager.resolve({ fs: fs2, gitdir, ref: fullRef });
        const GitRemoteHTTP2 = GitRemoteManager.getRemoteHelperFor({ url });
        const httpRemote = await GitRemoteHTTP2.discover({
          http: http2,
          onAuth,
          onAuthSuccess,
          onAuthFailure,
          corsProxy,
          service: "git-receive-pack",
          url,
          headers,
          protocolVersion: 1
        });
        const auth = httpRemote.auth;
        let fullRemoteRef;
        if (!remoteRef) {
          fullRemoteRef = fullRef;
        } else {
          try {
            fullRemoteRef = await GitRefManager.expandAgainstMap({
              ref: remoteRef,
              map: httpRemote.refs
            });
          } catch (err3) {
            if (err3 instanceof NotFoundError) {
              fullRemoteRef = remoteRef.startsWith("refs/") ? remoteRef : `refs/heads/${remoteRef}`;
            } else {
              throw err3;
            }
          }
        }
        const oldoid = httpRemote.refs.get(fullRemoteRef) || "0000000000000000000000000000000000000000";
        if (onPrePush) {
          const hookCancel = await onPrePush({
            remote,
            url,
            localRef: { ref: _delete ? "(delete)" : fullRef, oid },
            remoteRef: { ref: fullRemoteRef, oid: oldoid }
          });
          if (!hookCancel) throw new UserCanceledError();
        }
        const thinPack = !httpRemote.capabilities.has("no-thin");
        let objects = /* @__PURE__ */ new Set();
        if (!_delete) {
          const finish = [...httpRemote.refs.values()];
          let skipObjects = /* @__PURE__ */ new Set();
          if (oldoid !== "0000000000000000000000000000000000000000") {
            const mergebase = await _findMergeBase({
              fs: fs2,
              cache: cache2,
              gitdir,
              oids: [oid, oldoid]
            });
            for (const oid2 of mergebase) finish.push(oid2);
            if (thinPack) {
              skipObjects = await listObjects({ fs: fs2, cache: cache2, gitdir, oids: mergebase });
            }
          }
          if (!finish.includes(oid)) {
            const commits = await listCommitsAndTags({
              fs: fs2,
              cache: cache2,
              gitdir,
              start: [oid],
              finish
            });
            objects = await listObjects({ fs: fs2, cache: cache2, gitdir, oids: commits });
          }
          if (thinPack) {
            try {
              const ref2 = await GitRefManager.resolve({
                fs: fs2,
                gitdir,
                ref: `refs/remotes/${remote}/HEAD`,
                depth: 2
              });
              const { oid: oid2 } = await GitRefManager.resolveAgainstMap({
                ref: ref2.replace(`refs/remotes/${remote}/`, ""),
                fullref: ref2,
                map: httpRemote.refs
              });
              const oids = [oid2];
              for (const oid3 of await listObjects({ fs: fs2, cache: cache2, gitdir, oids })) {
                skipObjects.add(oid3);
              }
            } catch (e2) {
            }
            for (const oid2 of skipObjects) {
              objects.delete(oid2);
            }
          }
          if (oid === oldoid) force = true;
          if (!force) {
            if (fullRef.startsWith("refs/tags") && oldoid !== "0000000000000000000000000000000000000000") {
              throw new PushRejectedError("tag-exists");
            }
            if (oid !== "0000000000000000000000000000000000000000" && oldoid !== "0000000000000000000000000000000000000000" && !await _isDescendent({
              fs: fs2,
              cache: cache2,
              gitdir,
              oid,
              ancestor: oldoid,
              depth: -1
            })) {
              throw new PushRejectedError("not-fast-forward");
            }
          }
        }
        const capabilities = filterCapabilities(
          [...httpRemote.capabilities],
          ["report-status", "side-band-64k", `agent=${pkg2.agent}`]
        );
        const packstream1 = await writeReceivePackRequest({
          capabilities,
          triplets: [{ oldoid, oid, fullRef: fullRemoteRef }]
        });
        const packstream2 = _delete ? [] : await _pack({
          fs: fs2,
          cache: cache2,
          gitdir,
          oids: [...objects]
        });
        const res = await GitRemoteHTTP2.connect({
          http: http2,
          onProgress,
          corsProxy,
          service: "git-receive-pack",
          url,
          auth,
          headers,
          body: [...packstream1, ...packstream2]
        });
        const { packfile, progress } = await GitSideBand.demux(res.body);
        if (onMessage) {
          const lines = splitLines(progress);
          forAwait2(lines, async (line) => {
            await onMessage(line);
          });
        }
        const result = await parseReceivePackResponse(packfile);
        if (res.headers) {
          result.headers = res.headers;
        }
        if (remote && result.ok && result.refs[fullRemoteRef].ok && !fullRef.startsWith("refs/tags")) {
          const ref2 = `refs/remotes/${remote}/${fullRemoteRef.replace(
            "refs/heads",
            ""
          )}`;
          if (_delete) {
            await GitRefManager.deleteRef({ fs: fs2, gitdir, ref: ref2 });
          } else {
            await GitRefManager.writeRef({ fs: fs2, gitdir, ref: ref2, value: oid });
          }
        }
        if (result.ok && Object.values(result.refs).every((result2) => result2.ok)) {
          return result;
        } else {
          const prettyDetails = Object.entries(result.refs).filter(([k, v]) => !v.ok).map(([k, v]) => `
  - ${k}: ${v.error}`).join("");
          throw new GitPushError(prettyDetails, result);
        }
      }
      async function push({
        fs: fs2,
        http: http2,
        onProgress,
        onMessage,
        onAuth,
        onAuthSuccess,
        onAuthFailure,
        onPrePush,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        remoteRef,
        remote = "origin",
        url,
        force = false,
        delete: _delete = false,
        corsProxy,
        headers = {},
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("http", http2);
          assertParameter("gitdir", gitdir);
          return await _push({
            fs: new FileSystem2(fs2),
            cache: cache2,
            http: http2,
            onProgress,
            onMessage,
            onAuth,
            onAuthSuccess,
            onAuthFailure,
            onPrePush,
            gitdir,
            ref,
            remoteRef,
            remote,
            url,
            force,
            delete: _delete,
            corsProxy,
            headers
          });
        } catch (err3) {
          err3.caller = "git.push";
          throw err3;
        }
      }
      async function resolveBlob({ fs: fs2, cache: cache2, gitdir, oid }) {
        const { type, object } = await _readObject({ fs: fs2, cache: cache2, gitdir, oid });
        if (type === "tag") {
          oid = GitAnnotatedTag.from(object).parse().object;
          return resolveBlob({ fs: fs2, cache: cache2, gitdir, oid });
        }
        if (type !== "blob") {
          throw new ObjectTypeError(oid, type, "blob");
        }
        return { oid, blob: new Uint8Array(object) };
      }
      async function _readBlob({
        fs: fs2,
        cache: cache2,
        gitdir,
        oid,
        filepath = void 0
      }) {
        if (filepath !== void 0) {
          oid = await resolveFilepath2({ fs: fs2, cache: cache2, gitdir, oid, filepath });
        }
        const blob = await resolveBlob({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid
        });
        return blob;
      }
      async function readBlob({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        filepath,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          return await _readBlob({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oid,
            filepath
          });
        } catch (err3) {
          err3.caller = "git.readBlob";
          throw err3;
        }
      }
      async function readCommit({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          return await _readCommit({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oid
          });
        } catch (err3) {
          err3.caller = "git.readCommit";
          throw err3;
        }
      }
      async function _readNote({
        fs: fs2,
        cache: cache2,
        gitdir,
        ref = "refs/notes/commits",
        oid
      }) {
        const parent = await GitRefManager.resolve({ gitdir, fs: fs2, ref });
        const { blob } = await _readBlob({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid: parent,
          filepath: oid
        });
        return blob;
      }
      async function readNote({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref = "refs/notes/commits",
        oid,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          assertParameter("oid", oid);
          return await _readNote({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            ref,
            oid
          });
        } catch (err3) {
          err3.caller = "git.readNote";
          throw err3;
        }
      }
      async function readObject({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        format: format5 = "parsed",
        filepath = void 0,
        encoding = void 0,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          const fs2 = new FileSystem2(_fs);
          if (filepath !== void 0) {
            oid = await resolveFilepath2({
              fs: fs2,
              cache: cache2,
              gitdir,
              oid,
              filepath
            });
          }
          const _format2 = format5 === "parsed" ? "content" : format5;
          const result = await _readObject({
            fs: fs2,
            cache: cache2,
            gitdir,
            oid,
            format: _format2
          });
          result.oid = oid;
          if (format5 === "parsed") {
            result.format = "parsed";
            switch (result.type) {
              case "commit":
                result.object = GitCommit.from(result.object).parse();
                break;
              case "tree":
                result.object = GitTree.from(result.object).entries();
                break;
              case "blob":
                if (encoding) {
                  result.object = result.object.toString(encoding);
                } else {
                  result.object = new Uint8Array(result.object);
                  result.format = "content";
                }
                break;
              case "tag":
                result.object = GitAnnotatedTag.from(result.object).parse();
                break;
              default:
                throw new ObjectTypeError(
                  result.oid,
                  result.type,
                  "blob|commit|tag|tree"
                );
            }
          } else if (result.format === "deflated" || result.format === "wrapped") {
            result.type = result.format;
          }
          return result;
        } catch (err3) {
          err3.caller = "git.readObject";
          throw err3;
        }
      }
      async function _readTag({ fs: fs2, cache: cache2, gitdir, oid }) {
        const { type, object } = await _readObject({
          fs: fs2,
          cache: cache2,
          gitdir,
          oid,
          format: "content"
        });
        if (type !== "tag") {
          throw new ObjectTypeError(oid, type, "tag");
        }
        const tag2 = GitAnnotatedTag.from(object);
        const result = {
          oid,
          tag: tag2.parse(),
          payload: tag2.payload()
        };
        return result;
      }
      async function readTag({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          return await _readTag({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oid
          });
        } catch (err3) {
          err3.caller = "git.readTag";
          throw err3;
        }
      }
      async function readTree({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        oid,
        filepath = void 0,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          return await _readTree({
            fs: new FileSystem2(fs2),
            cache: cache2,
            gitdir,
            oid,
            filepath
          });
        } catch (err3) {
          err3.caller = "git.readTree";
          throw err3;
        }
      }
      async function remove3({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("filepath", filepath);
          await GitIndexManager.acquire(
            { fs: new FileSystem2(_fs), gitdir, cache: cache2 },
            async function(index3) {
              index3.delete({ filepath });
            }
          );
        } catch (err3) {
          err3.caller = "git.remove";
          throw err3;
        }
      }
      async function _removeNote({
        fs: fs2,
        cache: cache2,
        onSign,
        gitdir,
        ref = "refs/notes/commits",
        oid,
        author,
        committer,
        signingKey
      }) {
        let parent;
        try {
          parent = await GitRefManager.resolve({ gitdir, fs: fs2, ref });
        } catch (err3) {
          if (!(err3 instanceof NotFoundError)) {
            throw err3;
          }
        }
        const result = await _readTree({
          fs: fs2,
          gitdir,
          oid: parent || "4b825dc642cb6eb9a060e54bf8d69288fbee4904"
        });
        let tree = result.tree;
        tree = tree.filter((entry) => entry.path !== oid);
        const treeOid = await _writeTree({
          fs: fs2,
          gitdir,
          tree
        });
        const commitOid = await _commit({
          fs: fs2,
          cache: cache2,
          onSign,
          gitdir,
          ref,
          tree: treeOid,
          parent: parent && [parent],
          message: `Note removed by 'isomorphic-git removeNote'
`,
          author,
          committer,
          signingKey
        });
        return commitOid;
      }
      async function removeNote({
        fs: _fs,
        onSign,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref = "refs/notes/commits",
        oid,
        author: _author,
        committer: _committer,
        signingKey,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("oid", oid);
          const fs2 = new FileSystem2(_fs);
          const author = await normalizeAuthorObject({ fs: fs2, gitdir, author: _author });
          if (!author) throw new MissingNameError("author");
          const committer = await normalizeCommitterObject({
            fs: fs2,
            gitdir,
            author,
            committer: _committer
          });
          if (!committer) throw new MissingNameError("committer");
          return await _removeNote({
            fs: fs2,
            cache: cache2,
            onSign,
            gitdir,
            ref,
            oid,
            author,
            committer,
            signingKey
          });
        } catch (err3) {
          err3.caller = "git.removeNote";
          throw err3;
        }
      }
      async function _renameBranch({
        fs: fs2,
        gitdir,
        oldref,
        ref,
        checkout: checkout2 = false
      }) {
        if (ref !== cleanGitRef.clean(ref)) {
          throw new InvalidRefNameError(ref, cleanGitRef.clean(ref));
        }
        if (oldref !== cleanGitRef.clean(oldref)) {
          throw new InvalidRefNameError(oldref, cleanGitRef.clean(oldref));
        }
        const fulloldref = `refs/heads/${oldref}`;
        const fullnewref = `refs/heads/${ref}`;
        const newexist = await GitRefManager.exists({ fs: fs2, gitdir, ref: fullnewref });
        if (newexist) {
          throw new AlreadyExistsError("branch", ref, false);
        }
        const value = await GitRefManager.resolve({
          fs: fs2,
          gitdir,
          ref: fulloldref,
          depth: 1
        });
        await GitRefManager.writeRef({ fs: fs2, gitdir, ref: fullnewref, value });
        await GitRefManager.deleteRef({ fs: fs2, gitdir, ref: fulloldref });
        const fullCurrentBranchRef = await _currentBranch({
          fs: fs2,
          gitdir,
          fullname: true
        });
        const isCurrentBranch = fullCurrentBranchRef === fulloldref;
        if (checkout2 || isCurrentBranch) {
          await GitRefManager.writeSymbolicRef({
            fs: fs2,
            gitdir,
            ref: "HEAD",
            value: fullnewref
          });
        }
      }
      async function renameBranch({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        oldref,
        checkout: checkout2 = false
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          assertParameter("oldref", oldref);
          return await _renameBranch({
            fs: new FileSystem2(fs2),
            gitdir,
            ref,
            oldref,
            checkout: checkout2
          });
        } catch (err3) {
          err3.caller = "git.renameBranch";
          throw err3;
        }
      }
      async function hashObject$1({ gitdir, type, object }) {
        return shasum(GitObject.wrap({ type, object }));
      }
      async function resetIndex({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath,
        ref,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("filepath", filepath);
          const fs2 = new FileSystem2(_fs);
          let oid;
          let workdirOid;
          try {
            oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref: ref || "HEAD" });
          } catch (e2) {
            if (ref) {
              throw e2;
            }
          }
          if (oid) {
            try {
              oid = await resolveFilepath2({
                fs: fs2,
                cache: cache2,
                gitdir,
                oid,
                filepath
              });
            } catch (e2) {
              oid = null;
            }
          }
          let stats = {
            ctime: /* @__PURE__ */ new Date(0),
            mtime: /* @__PURE__ */ new Date(0),
            dev: 0,
            ino: 0,
            mode: 0,
            uid: 0,
            gid: 0,
            size: 0
          };
          const object = dir && await fs2.read(pathBrowserify.join(dir, filepath));
          if (object) {
            workdirOid = await hashObject$1({
              gitdir,
              type: "blob",
              object
            });
            if (oid === workdirOid) {
              stats = await fs2.lstat(pathBrowserify.join(dir, filepath));
            }
          }
          await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            index3.delete({ filepath });
            if (oid) {
              index3.insert({ filepath, stats, oid });
            }
          });
        } catch (err3) {
          err3.caller = "git.reset";
          throw err3;
        }
      }
      async function resolveRef({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        depth
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          const oid = await GitRefManager.resolve({
            fs: new FileSystem2(fs2),
            gitdir,
            ref,
            depth
          });
          return oid;
        } catch (err3) {
          err3.caller = "git.resolveRef";
          throw err3;
        }
      }
      async function setConfig({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        path: path3,
        value,
        append: append2 = false
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("path", path3);
          const fs2 = new FileSystem2(_fs);
          const config = await GitConfigManager.get({ fs: fs2, gitdir });
          if (append2) {
            await config.append(path3, value);
          } else {
            await config.set(path3, value);
          }
          await GitConfigManager.save({ fs: fs2, gitdir, config });
        } catch (err3) {
          err3.caller = "git.setConfig";
          throw err3;
        }
      }
      async function _writeCommit({ fs: fs2, gitdir, commit: commit2 }) {
        const object = GitCommit.from(commit2).toObject();
        const oid = await _writeObject({
          fs: fs2,
          gitdir,
          type: "commit",
          object,
          format: "content"
        });
        return oid;
      }
      var GitRefStash = class _GitRefStash {
        // constructor removed
        static get timezoneOffsetForRefLogEntry() {
          const offsetMinutes = (/* @__PURE__ */ new Date()).getTimezoneOffset();
          const offsetHours = Math.abs(Math.floor(offsetMinutes / 60));
          const offsetMinutesFormatted = Math.abs(offsetMinutes % 60).toString().padStart(2, "0");
          const sign6 = offsetMinutes > 0 ? "-" : "+";
          return `${sign6}${offsetHours.toString().padStart(2, "0")}${offsetMinutesFormatted}`;
        }
        static createStashReflogEntry(author, stashCommit, message) {
          const nameNoSpace = author.name.replace(/\s/g, "");
          const z40 = "0000000000000000000000000000000000000000";
          const timestamp2 = Math.floor(Date.now() / 1e3);
          const timezoneOffset = _GitRefStash.timezoneOffsetForRefLogEntry;
          return `${z40} ${stashCommit} ${nameNoSpace} ${author.email} ${timestamp2} ${timezoneOffset}	${message}
`;
        }
        static getStashReflogEntry(reflogString, parsed = false) {
          const reflogLines = reflogString.split("\n");
          const entries2 = reflogLines.filter((l) => l).reverse().map(
            (line, idx) => parsed ? `stash@{${idx}}: ${line.split("	")[1]}` : line
          );
          return entries2;
        }
      };
      var _TreeMap = {
        stage: STAGE,
        workdir: WORKDIR
      };
      var lock$3;
      async function acquireLock$1(ref, callback) {
        if (lock$3 === void 0) lock$3 = new AsyncLock();
        return lock$3.acquire(ref, callback);
      }
      async function checkAndWriteBlob(fs2, gitdir, dir, filepath, oid = null) {
        const currentFilepath = pathBrowserify.join(dir, filepath);
        const stats = await fs2.lstat(currentFilepath);
        if (!stats) throw new NotFoundError(currentFilepath);
        if (stats.isDirectory())
          throw new InternalError2(
            `${currentFilepath}: file expected, but found directory`
          );
        const objContent = oid ? await readObjectLoose({ fs: fs2, gitdir, oid }) : void 0;
        let retOid = objContent ? oid : void 0;
        if (!objContent) {
          await acquireLock$1({ fs: fs2, gitdir, currentFilepath }, async () => {
            const object = stats.isSymbolicLink() ? await fs2.readlink(currentFilepath).then(posixifyPathBuffer) : await fs2.read(currentFilepath);
            if (object === null) throw new NotFoundError(currentFilepath);
            retOid = await _writeObject({ fs: fs2, gitdir, type: "blob", object });
          });
        }
        return retOid;
      }
      async function processTreeEntries({ fs: fs2, dir, gitdir, entries: entries2 }) {
        async function processTreeEntry(entry) {
          if (entry.type === "tree") {
            if (!entry.oid) {
              const children = await Promise.all(entry.children.map(processTreeEntry));
              entry.oid = await _writeTree({
                fs: fs2,
                gitdir,
                tree: children
              });
              entry.mode = 16384;
            }
          } else if (entry.type === "blob") {
            entry.oid = await checkAndWriteBlob(
              fs2,
              gitdir,
              dir,
              entry.path,
              entry.oid
            );
            entry.mode = 33188;
          }
          entry.path = entry.path.split("/").pop();
          return entry;
        }
        return Promise.all(entries2.map(processTreeEntry));
      }
      async function writeTreeChanges({
        fs: fs2,
        dir,
        gitdir,
        treePair
        // [TREE({ ref: 'HEAD' }), 'STAGE'] would be the equivalent of `git write-tree`
      }) {
        const isStage = treePair[1] === "stage";
        const trees = treePair.map((t2) => typeof t2 === "string" ? _TreeMap[t2]() : t2);
        const changedEntries = [];
        const map = async (filepath, [head, stage]) => {
          if (filepath === "." || await GitIgnoreManager.isIgnored({ fs: fs2, dir, gitdir, filepath })) {
            return;
          }
          if (stage) {
            if (!head || await head.oid() !== await stage.oid() && await stage.oid() !== void 0) {
              changedEntries.push([head, stage]);
            }
            return {
              mode: await stage.mode(),
              path: filepath,
              oid: await stage.oid(),
              type: await stage.type()
            };
          }
        };
        const reduce = async (parent, children) => {
          children = children.filter(Boolean);
          if (!parent) {
            return children.length > 0 ? children : void 0;
          } else {
            parent.children = children;
            return parent;
          }
        };
        const iterate = async (walk2, children) => {
          const filtered = [];
          for (const child of children) {
            const [head, stage] = child;
            if (isStage) {
              if (stage) {
                if (await fs2.exists(`${dir}/${stage.toString()}`)) {
                  filtered.push(child);
                } else {
                  changedEntries.push([null, stage]);
                }
              }
            } else if (head) {
              if (!stage) {
                changedEntries.push([head, null]);
              } else {
                filtered.push(child);
              }
            }
          }
          return filtered.length ? Promise.all(filtered.map(walk2)) : [];
        };
        const entries2 = await _walk({
          fs: fs2,
          cache: {},
          dir,
          gitdir,
          trees,
          map,
          reduce,
          iterate
        });
        if (changedEntries.length === 0 || entries2.length === 0) {
          return null;
        }
        const processedEntries = await processTreeEntries({
          fs: fs2,
          dir,
          gitdir,
          entries: entries2
        });
        const treeEntries = processedEntries.filter(Boolean).map((entry) => ({
          mode: entry.mode,
          path: entry.path,
          oid: entry.oid,
          type: entry.type
        }));
        return _writeTree({ fs: fs2, gitdir, tree: treeEntries });
      }
      async function applyTreeChanges({
        fs: fs2,
        dir,
        gitdir,
        stashCommit,
        parentCommit,
        wasStaged
      }) {
        const dirRemoved = [];
        const stageUpdated = [];
        const ops = await _walk({
          fs: fs2,
          cache: {},
          dir,
          gitdir,
          trees: [TREE({ ref: parentCommit }), TREE({ ref: stashCommit })],
          map: async (filepath, [parent, stash2]) => {
            if (filepath === "." || await GitIgnoreManager.isIgnored({ fs: fs2, dir, gitdir, filepath })) {
              return;
            }
            const type = stash2 ? await stash2.type() : await parent.type();
            if (type !== "tree" && type !== "blob") {
              return;
            }
            if (!stash2 && parent) {
              const method = type === "tree" ? "rmdir" : "rm";
              if (type === "tree") dirRemoved.push(filepath);
              if (type === "blob" && wasStaged)
                stageUpdated.push({ filepath, oid: await parent.oid() });
              return { method, filepath };
            }
            const oid = await stash2.oid();
            if (!parent || await parent.oid() !== oid) {
              if (type === "tree") {
                return { method: "mkdir", filepath };
              } else {
                if (wasStaged)
                  stageUpdated.push({
                    filepath,
                    oid,
                    stats: await fs2.lstat(pathBrowserify.join(dir, filepath))
                  });
                return {
                  method: "write",
                  filepath,
                  oid
                };
              }
            }
          }
        });
        await acquireLock$1({ fs: fs2, gitdir, dirRemoved, ops }, async () => {
          for (const op of ops) {
            const currentFilepath = pathBrowserify.join(dir, op.filepath);
            switch (op.method) {
              case "rmdir":
                await fs2.rmdir(currentFilepath);
                break;
              case "mkdir":
                await fs2.mkdir(currentFilepath);
                break;
              case "rm":
                await fs2.rm(currentFilepath);
                break;
              case "write":
                if (!dirRemoved.some(
                  (removedDir) => currentFilepath.startsWith(removedDir)
                )) {
                  const { object } = await _readObject({
                    fs: fs2,
                    cache: {},
                    gitdir,
                    oid: op.oid
                  });
                  if (await fs2.exists(currentFilepath)) {
                    await fs2.rm(currentFilepath);
                  }
                  await fs2.write(currentFilepath, object);
                }
                break;
            }
          }
        });
        await GitIndexManager.acquire({ fs: fs2, gitdir, cache: {} }, async (index3) => {
          stageUpdated.forEach(({ filepath, stats, oid }) => {
            index3.insert({ filepath, stats, oid });
          });
        });
      }
      var GitStashManager = class _GitStashManager {
        constructor({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git") }) {
          Object.assign(this, {
            fs: fs2,
            dir,
            gitdir,
            _author: null
          });
        }
        static get refStash() {
          return "refs/stash";
        }
        static get refLogsStash() {
          return "logs/refs/stash";
        }
        get refStashPath() {
          return pathBrowserify.join(this.gitdir, _GitStashManager.refStash);
        }
        get refLogsStashPath() {
          return pathBrowserify.join(this.gitdir, _GitStashManager.refLogsStash);
        }
        async getAuthor() {
          if (!this._author) {
            this._author = await normalizeAuthorObject({
              fs: this.fs,
              gitdir: this.gitdir,
              author: {}
            });
            if (!this._author) throw new MissingNameError("author");
          }
          return this._author;
        }
        async getStashSHA(refIdx, stashEntries) {
          if (!await this.fs.exists(this.refStashPath)) {
            return null;
          }
          const entries2 = stashEntries || await this.readStashReflogs({ parsed: false });
          return entries2[refIdx].split(" ")[1];
        }
        async writeStashCommit({ message, tree, parent }) {
          return _writeCommit({
            fs: this.fs,
            gitdir: this.gitdir,
            commit: {
              message,
              tree,
              parent,
              author: await this.getAuthor(),
              committer: await this.getAuthor()
            }
          });
        }
        async readStashCommit(refIdx) {
          const stashEntries = await this.readStashReflogs({ parsed: false });
          if (refIdx !== 0) {
            if (refIdx < 0 || refIdx > stashEntries.length - 1) {
              throw new InvalidRefNameError(
                `stash@${refIdx}`,
                "number that is in range of [0, num of stash pushed]"
              );
            }
          }
          const stashSHA = await this.getStashSHA(refIdx, stashEntries);
          if (!stashSHA) {
            return {};
          }
          return _readCommit({
            fs: this.fs,
            cache: {},
            gitdir: this.gitdir,
            oid: stashSHA
          });
        }
        async writeStashRef(stashCommit) {
          return GitRefManager.writeRef({
            fs: this.fs,
            gitdir: this.gitdir,
            ref: _GitStashManager.refStash,
            value: stashCommit
          });
        }
        async writeStashReflogEntry({ stashCommit, message }) {
          const author = await this.getAuthor();
          const entry = GitRefStash.createStashReflogEntry(
            author,
            stashCommit,
            message
          );
          const filepath = this.refLogsStashPath;
          await acquireLock$1({ filepath, entry }, async () => {
            const appendTo = await this.fs.exists(filepath) ? await this.fs.read(filepath, "utf8") : "";
            await this.fs.write(filepath, appendTo + entry, "utf8");
          });
        }
        async readStashReflogs({ parsed = false }) {
          if (!await this.fs.exists(this.refLogsStashPath)) {
            return [];
          }
          const reflogBuffer = await this.fs.read(this.refLogsStashPath);
          const reflogString = reflogBuffer.toString();
          return GitRefStash.getStashReflogEntry(reflogString, parsed);
        }
      };
      async function _stashPush({ fs: fs2, dir, gitdir, message = "" }) {
        const stashMgr = new GitStashManager({ fs: fs2, dir, gitdir });
        await stashMgr.getAuthor();
        const branch2 = await _currentBranch({
          fs: fs2,
          gitdir,
          fullname: false
        });
        const headCommit = await GitRefManager.resolve({
          fs: fs2,
          gitdir,
          ref: "HEAD"
        });
        const headCommitObj = await readCommit({ fs: fs2, dir, gitdir, oid: headCommit });
        const headMsg = headCommitObj.commit.message;
        const stashCommitParents = [headCommit];
        let stashCommitTree = null;
        let workDirCompareBase = TREE({ ref: "HEAD" });
        const indexTree = await writeTreeChanges({
          fs: fs2,
          dir,
          gitdir,
          treePair: [TREE({ ref: "HEAD" }), "stage"]
        });
        if (indexTree) {
          const stashCommitOne = await stashMgr.writeStashCommit({
            message: `stash-Index: WIP on ${branch2} - ${(/* @__PURE__ */ new Date()).toISOString()}`,
            tree: indexTree,
            // stashCommitTree
            parent: stashCommitParents
          });
          stashCommitParents.push(stashCommitOne);
          stashCommitTree = indexTree;
          workDirCompareBase = STAGE();
        }
        const workingTree = await writeTreeChanges({
          fs: fs2,
          dir,
          gitdir,
          treePair: [workDirCompareBase, "workdir"]
        });
        if (workingTree) {
          const workingHeadCommit = await stashMgr.writeStashCommit({
            message: `stash-WorkDir: WIP on ${branch2} - ${(/* @__PURE__ */ new Date()).toISOString()}`,
            tree: workingTree,
            parent: [stashCommitParents[stashCommitParents.length - 1]]
          });
          stashCommitParents.push(workingHeadCommit);
          stashCommitTree = workingTree;
        }
        if (!stashCommitTree || !indexTree && !workingTree) {
          throw new NotFoundError("changes, nothing to stash");
        }
        const stashMsg = (message.trim() || `WIP on ${branch2}`) + `: ${headCommit.substring(0, 7)} ${headMsg}`;
        const stashCommit = await stashMgr.writeStashCommit({
          message: stashMsg,
          tree: stashCommitTree,
          parent: stashCommitParents
        });
        await stashMgr.writeStashRef(stashCommit);
        await stashMgr.writeStashReflogEntry({
          stashCommit,
          message: stashMsg
        });
        await checkout({
          fs: fs2,
          dir,
          gitdir,
          ref: branch2,
          track: false,
          force: true
          // force checkout to discard changes
        });
        return stashCommit;
      }
      async function _stashApply({ fs: fs2, dir, gitdir, refIdx = 0 }) {
        const stashMgr = new GitStashManager({ fs: fs2, dir, gitdir });
        const stashCommit = await stashMgr.readStashCommit(refIdx);
        const { parent: stashParents = null } = stashCommit.commit ? stashCommit.commit : {};
        if (!stashParents || !Array.isArray(stashParents)) {
          return;
        }
        for (let i2 = 0; i2 < stashParents.length - 1; i2++) {
          const applyingCommit = await _readCommit({
            fs: fs2,
            cache: {},
            gitdir,
            oid: stashParents[i2 + 1]
          });
          const wasStaged = applyingCommit.commit.message.startsWith("stash-Index");
          await applyTreeChanges({
            fs: fs2,
            dir,
            gitdir,
            stashCommit: stashParents[i2 + 1],
            parentCommit: stashParents[i2],
            wasStaged
          });
        }
      }
      async function _stashDrop({ fs: fs2, dir, gitdir, refIdx = 0 }) {
        const stashMgr = new GitStashManager({ fs: fs2, dir, gitdir });
        const stashCommit = await stashMgr.readStashCommit(refIdx);
        if (!stashCommit.commit) {
          return;
        }
        const stashRefPath = stashMgr.refStashPath;
        await acquireLock$1(stashRefPath, async () => {
          if (await fs2.exists(stashRefPath)) {
            await fs2.rm(stashRefPath);
          }
        });
        const reflogEntries = await stashMgr.readStashReflogs({ parsed: false });
        if (!reflogEntries.length) {
          return;
        }
        reflogEntries.splice(refIdx, 1);
        const stashReflogPath = stashMgr.refLogsStashPath;
        await acquireLock$1({ reflogEntries, stashReflogPath, stashMgr }, async () => {
          if (reflogEntries.length) {
            await fs2.write(stashReflogPath, reflogEntries.join("\n"), "utf8");
            const lastStashCommit = reflogEntries[reflogEntries.length - 1].split(
              " "
            )[1];
            await stashMgr.writeStashRef(lastStashCommit);
          } else {
            await fs2.rm(stashReflogPath);
          }
        });
      }
      async function _stashList({ fs: fs2, dir, gitdir }) {
        const stashMgr = new GitStashManager({ fs: fs2, dir, gitdir });
        return stashMgr.readStashReflogs({ parsed: true });
      }
      async function _stashClear({ fs: fs2, dir, gitdir }) {
        const stashMgr = new GitStashManager({ fs: fs2, dir, gitdir });
        const stashRefPath = [stashMgr.refStashPath, stashMgr.refLogsStashPath];
        await acquireLock$1(stashRefPath, async () => {
          await Promise.all(
            stashRefPath.map(async (path3) => {
              if (await fs2.exists(path3)) {
                return fs2.rm(path3);
              }
            })
          );
        });
      }
      async function _stashPop({ fs: fs2, dir, gitdir, refIdx = 0 }) {
        await _stashApply({ fs: fs2, dir, gitdir, refIdx });
        await _stashDrop({ fs: fs2, dir, gitdir, refIdx });
      }
      async function stash({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        op = "push",
        message = "",
        refIdx = 0
      }) {
        assertParameter("fs", fs2);
        assertParameter("dir", dir);
        assertParameter("gitdir", gitdir);
        assertParameter("op", op);
        const stashMap = {
          push: _stashPush,
          apply: _stashApply,
          drop: _stashDrop,
          list: _stashList,
          clear: _stashClear,
          pop: _stashPop
        };
        const opsNeedRefIdx = ["apply", "drop", "pop"];
        try {
          const _fs = new FileSystem2(fs2);
          const folders = ["refs", "logs", "logs/refs"];
          folders.map((f) => pathBrowserify.join(gitdir, f)).forEach(async (folder) => {
            if (!await _fs.exists(folder)) {
              await _fs.mkdir(folder);
            }
          });
          const opFunc = stashMap[op];
          if (opFunc) {
            if (opsNeedRefIdx.includes(op) && refIdx < 0) {
              throw new InvalidRefNameError(
                `stash@${refIdx}`,
                "number that is in range of [0, num of stash pushed]"
              );
            }
            return await opFunc({ fs: _fs, dir, gitdir, message, refIdx });
          }
          throw new Error(`To be implemented: ${op}`);
        } catch (err3) {
          err3.caller = "git.stash";
          throw err3;
        }
      }
      async function status({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        filepath,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("filepath", filepath);
          const fs2 = new FileSystem2(_fs);
          const ignored = await GitIgnoreManager.isIgnored({
            fs: fs2,
            gitdir,
            dir,
            filepath
          });
          if (ignored) {
            return "ignored";
          }
          const headTree = await getHeadTree({ fs: fs2, cache: cache2, gitdir });
          const treeOid = await getOidAtPath({
            fs: fs2,
            cache: cache2,
            gitdir,
            tree: headTree,
            path: filepath
          });
          const indexEntry = await GitIndexManager.acquire(
            { fs: fs2, gitdir, cache: cache2 },
            async function(index3) {
              for (const entry of index3) {
                if (entry.path === filepath) return entry;
              }
              return null;
            }
          );
          const stats = await fs2.lstat(pathBrowserify.join(dir, filepath));
          const H = treeOid !== null;
          const I = indexEntry !== null;
          const W = stats !== null;
          const getWorkdirOid = async () => {
            if (I && !compareStats(indexEntry, stats)) {
              return indexEntry.oid;
            } else {
              const object = await fs2.read(pathBrowserify.join(dir, filepath));
              const workdirOid = await hashObject$1({
                gitdir,
                type: "blob",
                object
              });
              if (I && indexEntry.oid === workdirOid) {
                if (stats.size !== -1) {
                  GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
                    index3.insert({ filepath, stats, oid: workdirOid });
                  });
                }
              }
              return workdirOid;
            }
          };
          if (!H && !W && !I) return "absent";
          if (!H && !W && I) return "*absent";
          if (!H && W && !I) return "*added";
          if (!H && W && I) {
            const workdirOid = await getWorkdirOid();
            return workdirOid === indexEntry.oid ? "added" : "*added";
          }
          if (H && !W && !I) return "deleted";
          if (H && !W && I) {
            return treeOid === indexEntry.oid ? "*deleted" : "*deleted";
          }
          if (H && W && !I) {
            const workdirOid = await getWorkdirOid();
            return workdirOid === treeOid ? "*undeleted" : "*undeletemodified";
          }
          if (H && W && I) {
            const workdirOid = await getWorkdirOid();
            if (workdirOid === treeOid) {
              return workdirOid === indexEntry.oid ? "unmodified" : "*unmodified";
            } else {
              return workdirOid === indexEntry.oid ? "modified" : "*modified";
            }
          }
        } catch (err3) {
          err3.caller = "git.status";
          throw err3;
        }
      }
      async function getOidAtPath({ fs: fs2, cache: cache2, gitdir, tree, path: path3 }) {
        if (typeof path3 === "string") path3 = path3.split("/");
        const dirname4 = path3.shift();
        for (const entry of tree) {
          if (entry.path === dirname4) {
            if (path3.length === 0) {
              return entry.oid;
            }
            const { type, object } = await _readObject({
              fs: fs2,
              cache: cache2,
              gitdir,
              oid: entry.oid
            });
            if (type === "tree") {
              const tree2 = GitTree.from(object);
              return getOidAtPath({ fs: fs2, cache: cache2, gitdir, tree: tree2, path: path3 });
            }
            if (type === "blob") {
              throw new ObjectTypeError(entry.oid, type, "blob", path3.join("/"));
            }
          }
        }
        return null;
      }
      async function getHeadTree({ fs: fs2, cache: cache2, gitdir }) {
        let oid;
        try {
          oid = await GitRefManager.resolve({ fs: fs2, gitdir, ref: "HEAD" });
        } catch (e2) {
          if (e2 instanceof NotFoundError) {
            return [];
          }
        }
        const { tree } = await _readTree({ fs: fs2, cache: cache2, gitdir, oid });
        return tree;
      }
      async function statusMatrix({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref = "HEAD",
        filepaths = ["."],
        filter: filter2,
        cache: cache2 = {},
        ignored: shouldIgnore = false
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          const fs2 = new FileSystem2(_fs);
          return await _walk({
            fs: fs2,
            cache: cache2,
            dir,
            gitdir,
            trees: [TREE({ ref }), WORKDIR(), STAGE()],
            map: async function(filepath, [head, workdir, stage]) {
              if (!head && !stage && workdir) {
                if (!shouldIgnore) {
                  const isIgnored2 = await GitIgnoreManager.isIgnored({
                    fs: fs2,
                    dir,
                    filepath
                  });
                  if (isIgnored2) {
                    return null;
                  }
                }
              }
              if (!filepaths.some((base2) => worthWalking(filepath, base2))) {
                return null;
              }
              if (filter2) {
                if (!filter2(filepath)) return;
              }
              const [headType, workdirType, stageType] = await Promise.all([
                head && head.type(),
                workdir && workdir.type(),
                stage && stage.type()
              ]);
              const isBlob2 = [headType, workdirType, stageType].includes("blob");
              if ((headType === "tree" || headType === "special") && !isBlob2) return;
              if (headType === "commit") return null;
              if ((workdirType === "tree" || workdirType === "special") && !isBlob2)
                return;
              if (stageType === "commit") return null;
              if ((stageType === "tree" || stageType === "special") && !isBlob2) return;
              const headOid = headType === "blob" ? await head.oid() : void 0;
              const stageOid = stageType === "blob" ? await stage.oid() : void 0;
              let workdirOid;
              if (headType !== "blob" && workdirType === "blob" && stageType !== "blob") {
                workdirOid = "42";
              } else if (workdirType === "blob") {
                workdirOid = await workdir.oid();
              }
              const entry = [void 0, headOid, workdirOid, stageOid];
              const result = entry.map((value) => entry.indexOf(value));
              result.shift();
              return [filepath, ...result];
            }
          });
        } catch (err3) {
          err3.caller = "git.statusMatrix";
          throw err3;
        }
      }
      async function tag({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        object,
        force = false
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          const fs2 = new FileSystem2(_fs);
          if (ref === void 0) {
            throw new MissingParameterError("ref");
          }
          ref = ref.startsWith("refs/tags/") ? ref : `refs/tags/${ref}`;
          const value = await GitRefManager.resolve({
            fs: fs2,
            gitdir,
            ref: object || "HEAD"
          });
          if (!force && await GitRefManager.exists({ fs: fs2, gitdir, ref })) {
            throw new AlreadyExistsError("tag", ref);
          }
          await GitRefManager.writeRef({ fs: fs2, gitdir, ref, value });
        } catch (err3) {
          err3.caller = "git.tag";
          throw err3;
        }
      }
      async function updateIndex$1({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        cache: cache2 = {},
        filepath,
        oid,
        mode,
        add: add3,
        remove: remove4,
        force
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("filepath", filepath);
          const fs2 = new FileSystem2(_fs);
          if (remove4) {
            return await GitIndexManager.acquire(
              { fs: fs2, gitdir, cache: cache2 },
              async function(index3) {
                if (!force) {
                  const fileStats2 = await fs2.lstat(pathBrowserify.join(dir, filepath));
                  if (fileStats2) {
                    if (fileStats2.isDirectory()) {
                      throw new InvalidFilepathError("directory");
                    }
                    return;
                  }
                }
                if (index3.has({ filepath })) {
                  index3.delete({
                    filepath
                  });
                }
              }
            );
          }
          let fileStats;
          if (!oid) {
            fileStats = await fs2.lstat(pathBrowserify.join(dir, filepath));
            if (!fileStats) {
              throw new NotFoundError(
                `file at "${filepath}" on disk and "remove" not set`
              );
            }
            if (fileStats.isDirectory()) {
              throw new InvalidFilepathError("directory");
            }
          }
          return await GitIndexManager.acquire({ fs: fs2, gitdir, cache: cache2 }, async function(index3) {
            if (!add3 && !index3.has({ filepath })) {
              throw new NotFoundError(
                `file at "${filepath}" in index and "add" not set`
              );
            }
            let stats;
            if (!oid) {
              stats = fileStats;
              const object = stats.isSymbolicLink() ? await fs2.readlink(pathBrowserify.join(dir, filepath)) : await fs2.read(pathBrowserify.join(dir, filepath));
              oid = await _writeObject({
                fs: fs2,
                gitdir,
                type: "blob",
                format: "content",
                object
              });
            } else {
              stats = {
                ctime: /* @__PURE__ */ new Date(0),
                mtime: /* @__PURE__ */ new Date(0),
                dev: 0,
                ino: 0,
                mode,
                uid: 0,
                gid: 0,
                size: 0
              };
            }
            index3.insert({
              filepath,
              oid,
              stats
            });
            return oid;
          });
        } catch (err3) {
          err3.caller = "git.updateIndex";
          throw err3;
        }
      }
      function version17() {
        try {
          return pkg2.version;
        } catch (err3) {
          err3.caller = "git.version";
          throw err3;
        }
      }
      async function walk({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        trees,
        map,
        reduce,
        iterate,
        cache: cache2 = {}
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("trees", trees);
          return await _walk({
            fs: new FileSystem2(fs2),
            cache: cache2,
            dir,
            gitdir,
            trees,
            map,
            reduce,
            iterate
          });
        } catch (err3) {
          err3.caller = "git.walk";
          throw err3;
        }
      }
      async function writeBlob({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), blob }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("blob", blob);
          return await _writeObject({
            fs: new FileSystem2(fs2),
            gitdir,
            type: "blob",
            object: blob,
            format: "content"
          });
        } catch (err3) {
          err3.caller = "git.writeBlob";
          throw err3;
        }
      }
      async function writeCommit({
        fs: fs2,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        commit: commit2
      }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("commit", commit2);
          return await _writeCommit({
            fs: new FileSystem2(fs2),
            gitdir,
            commit: commit2
          });
        } catch (err3) {
          err3.caller = "git.writeCommit";
          throw err3;
        }
      }
      async function writeObject({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        type,
        object,
        format: format5 = "parsed",
        oid,
        encoding = void 0
      }) {
        try {
          const fs2 = new FileSystem2(_fs);
          if (format5 === "parsed") {
            switch (type) {
              case "commit":
                object = GitCommit.from(object).toObject();
                break;
              case "tree":
                object = GitTree.from(object).toObject();
                break;
              case "blob":
                object = Buffer.from(object, encoding);
                break;
              case "tag":
                object = GitAnnotatedTag.from(object).toObject();
                break;
              default:
                throw new ObjectTypeError(oid || "", type, "blob|commit|tag|tree");
            }
            format5 = "content";
          }
          oid = await _writeObject({
            fs: fs2,
            gitdir,
            type,
            object,
            oid,
            format: format5
          });
          return oid;
        } catch (err3) {
          err3.caller = "git.writeObject";
          throw err3;
        }
      }
      async function writeRef({
        fs: _fs,
        dir,
        gitdir = pathBrowserify.join(dir, ".git"),
        ref,
        value,
        force = false,
        symbolic = false
      }) {
        try {
          assertParameter("fs", _fs);
          assertParameter("gitdir", gitdir);
          assertParameter("ref", ref);
          assertParameter("value", value);
          const fs2 = new FileSystem2(_fs);
          if (ref !== cleanGitRef.clean(ref)) {
            throw new InvalidRefNameError(ref, cleanGitRef.clean(ref));
          }
          if (!force && await GitRefManager.exists({ fs: fs2, gitdir, ref })) {
            throw new AlreadyExistsError("ref", ref);
          }
          if (symbolic) {
            await GitRefManager.writeSymbolicRef({
              fs: fs2,
              gitdir,
              ref,
              value
            });
          } else {
            value = await GitRefManager.resolve({
              fs: fs2,
              gitdir,
              ref: value
            });
            await GitRefManager.writeRef({
              fs: fs2,
              gitdir,
              ref,
              value
            });
          }
        } catch (err3) {
          err3.caller = "git.writeRef";
          throw err3;
        }
      }
      async function _writeTag({ fs: fs2, gitdir, tag: tag2 }) {
        const object = GitAnnotatedTag.from(tag2).toObject();
        const oid = await _writeObject({
          fs: fs2,
          gitdir,
          type: "tag",
          object,
          format: "content"
        });
        return oid;
      }
      async function writeTag({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), tag: tag2 }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("tag", tag2);
          return await _writeTag({
            fs: new FileSystem2(fs2),
            gitdir,
            tag: tag2
          });
        } catch (err3) {
          err3.caller = "git.writeTag";
          throw err3;
        }
      }
      async function writeTree({ fs: fs2, dir, gitdir = pathBrowserify.join(dir, ".git"), tree }) {
        try {
          assertParameter("fs", fs2);
          assertParameter("gitdir", gitdir);
          assertParameter("tree", tree);
          return await _writeTree({
            fs: new FileSystem2(fs2),
            gitdir,
            tree
          });
        } catch (err3) {
          err3.caller = "git.writeTree";
          throw err3;
        }
      }
      var index2 = {
        Errors,
        STAGE,
        TREE,
        WORKDIR,
        add: add2,
        abortMerge,
        addNote,
        addRemote,
        annotatedTag,
        branch,
        checkout,
        clone,
        commit,
        getConfig,
        getConfigAll,
        setConfig,
        currentBranch,
        deleteBranch,
        deleteRef,
        deleteRemote,
        deleteTag,
        expandOid,
        expandRef,
        fastForward,
        fetch: fetch3,
        findMergeBase,
        findRoot,
        getRemoteInfo,
        getRemoteInfo2,
        hashBlob,
        indexPack,
        init: init3,
        isDescendent,
        isIgnored,
        listBranches,
        listFiles,
        listNotes,
        listRefs,
        listRemotes,
        listServerRefs,
        listTags,
        log: log2,
        merge: merge3,
        packObjects,
        pull,
        push,
        readBlob,
        readCommit,
        readNote,
        readObject,
        readTag,
        readTree,
        remove: remove3,
        removeNote,
        renameBranch,
        resetIndex,
        updateIndex: updateIndex$1,
        resolveRef,
        status,
        statusMatrix,
        tag,
        version: version17,
        walk,
        writeBlob,
        writeCommit,
        writeObject,
        writeRef,
        writeTag,
        writeTree,
        stash
      };
      exports2.Errors = Errors;
      exports2.STAGE = STAGE;
      exports2.TREE = TREE;
      exports2.WORKDIR = WORKDIR;
      exports2.abortMerge = abortMerge;
      exports2.add = add2;
      exports2.addNote = addNote;
      exports2.addRemote = addRemote;
      exports2.annotatedTag = annotatedTag;
      exports2.branch = branch;
      exports2.checkout = checkout;
      exports2.clone = clone;
      exports2.commit = commit;
      exports2.currentBranch = currentBranch;
      exports2.default = index2;
      exports2.deleteBranch = deleteBranch;
      exports2.deleteRef = deleteRef;
      exports2.deleteRemote = deleteRemote;
      exports2.deleteTag = deleteTag;
      exports2.expandOid = expandOid;
      exports2.expandRef = expandRef;
      exports2.fastForward = fastForward;
      exports2.fetch = fetch3;
      exports2.findMergeBase = findMergeBase;
      exports2.findRoot = findRoot;
      exports2.getConfig = getConfig;
      exports2.getConfigAll = getConfigAll;
      exports2.getRemoteInfo = getRemoteInfo;
      exports2.getRemoteInfo2 = getRemoteInfo2;
      exports2.hashBlob = hashBlob;
      exports2.indexPack = indexPack;
      exports2.init = init3;
      exports2.isDescendent = isDescendent;
      exports2.isIgnored = isIgnored;
      exports2.listBranches = listBranches;
      exports2.listFiles = listFiles;
      exports2.listNotes = listNotes;
      exports2.listRefs = listRefs;
      exports2.listRemotes = listRemotes;
      exports2.listServerRefs = listServerRefs;
      exports2.listTags = listTags;
      exports2.log = log2;
      exports2.merge = merge3;
      exports2.packObjects = packObjects;
      exports2.pull = pull;
      exports2.push = push;
      exports2.readBlob = readBlob;
      exports2.readCommit = readCommit;
      exports2.readNote = readNote;
      exports2.readObject = readObject;
      exports2.readTag = readTag;
      exports2.readTree = readTree;
      exports2.remove = remove3;
      exports2.removeNote = removeNote;
      exports2.renameBranch = renameBranch;
      exports2.resetIndex = resetIndex;
      exports2.resolveRef = resolveRef;
      exports2.setConfig = setConfig;
      exports2.stash = stash;
      exports2.status = status;
      exports2.statusMatrix = statusMatrix;
      exports2.tag = tag;
      exports2.updateIndex = updateIndex$1;
      exports2.version = version17;
      exports2.walk = walk;
      exports2.writeBlob = writeBlob;
      exports2.writeCommit = writeCommit;
      exports2.writeObject = writeObject;
      exports2.writeRef = writeRef;
      exports2.writeTag = writeTag;
      exports2.writeTree = writeTree;
    }
  });

  // ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js
  var require_lodash = __commonJS({
    "../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js"(exports2, module2) {
      (function() {
        var undefined2;
        var VERSION4 = "4.17.21";
        var LARGE_ARRAY_SIZE = 200;
        var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
        var HASH_UNDEFINED = "__lodash_hash_undefined__";
        var MAX_MEMOIZE_SIZE = 500;
        var PLACEHOLDER = "__lodash_placeholder__";
        var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
        var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
        var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
        var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
        var HOT_COUNT = 800, HOT_SPAN = 16;
        var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
        var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER2 = 17976931348623157e292, NAN = 0 / 0;
        var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        var wrapFlags = [
          ["ary", WRAP_ARY_FLAG],
          ["bind", WRAP_BIND_FLAG],
          ["bindKey", WRAP_BIND_KEY_FLAG],
          ["curry", WRAP_CURRY_FLAG],
          ["curryRight", WRAP_CURRY_RIGHT_FLAG],
          ["flip", WRAP_FLIP_FLAG],
          ["partial", WRAP_PARTIAL_FLAG],
          ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
          ["rearg", WRAP_REARG_FLAG]
        ];
        var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
        var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
        var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
        var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
        var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
        var reTrimStart = /^\s+/;
        var reWhitespace = /\s/;
        var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
        var reEscapeChar = /\\(\\)?/g;
        var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
        var reFlags = /\w*$/;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var reIsOctal = /^0o[0-7]+$/i;
        var reIsUint = /^(?:0|[1-9]\d*)$/;
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        var reNoMatch = /($^)/;
        var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
        var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
        var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
        var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
        var reApos = RegExp(rsApos, "g");
        var reComboMark = RegExp(rsCombo, "g");
        var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
        var reUnicodeWord = RegExp([
          rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
          rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
          rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
          rsUpper + "+" + rsOptContrUpper,
          rsOrdUpper,
          rsOrdLower,
          rsDigits,
          rsEmoji
        ].join("|"), "g");
        var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        var contextProps = [
          "Array",
          "Buffer",
          "DataView",
          "Date",
          "Error",
          "Float32Array",
          "Float64Array",
          "Function",
          "Int8Array",
          "Int16Array",
          "Int32Array",
          "Map",
          "Math",
          "Object",
          "Promise",
          "RegExp",
          "Set",
          "String",
          "Symbol",
          "TypeError",
          "Uint8Array",
          "Uint8ClampedArray",
          "Uint16Array",
          "Uint32Array",
          "WeakMap",
          "_",
          "clearTimeout",
          "isFinite",
          "parseInt",
          "setTimeout"
        ];
        var templateCounter = -1;
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        var cloneableTags = {};
        cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
        cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
        var deburredLetters = {
          // Latin-1 Supplement block.
          "\xC0": "A",
          "\xC1": "A",
          "\xC2": "A",
          "\xC3": "A",
          "\xC4": "A",
          "\xC5": "A",
          "\xE0": "a",
          "\xE1": "a",
          "\xE2": "a",
          "\xE3": "a",
          "\xE4": "a",
          "\xE5": "a",
          "\xC7": "C",
          "\xE7": "c",
          "\xD0": "D",
          "\xF0": "d",
          "\xC8": "E",
          "\xC9": "E",
          "\xCA": "E",
          "\xCB": "E",
          "\xE8": "e",
          "\xE9": "e",
          "\xEA": "e",
          "\xEB": "e",
          "\xCC": "I",
          "\xCD": "I",
          "\xCE": "I",
          "\xCF": "I",
          "\xEC": "i",
          "\xED": "i",
          "\xEE": "i",
          "\xEF": "i",
          "\xD1": "N",
          "\xF1": "n",
          "\xD2": "O",
          "\xD3": "O",
          "\xD4": "O",
          "\xD5": "O",
          "\xD6": "O",
          "\xD8": "O",
          "\xF2": "o",
          "\xF3": "o",
          "\xF4": "o",
          "\xF5": "o",
          "\xF6": "o",
          "\xF8": "o",
          "\xD9": "U",
          "\xDA": "U",
          "\xDB": "U",
          "\xDC": "U",
          "\xF9": "u",
          "\xFA": "u",
          "\xFB": "u",
          "\xFC": "u",
          "\xDD": "Y",
          "\xFD": "y",
          "\xFF": "y",
          "\xC6": "Ae",
          "\xE6": "ae",
          "\xDE": "Th",
          "\xFE": "th",
          "\xDF": "ss",
          // Latin Extended-A block.
          "\u0100": "A",
          "\u0102": "A",
          "\u0104": "A",
          "\u0101": "a",
          "\u0103": "a",
          "\u0105": "a",
          "\u0106": "C",
          "\u0108": "C",
          "\u010A": "C",
          "\u010C": "C",
          "\u0107": "c",
          "\u0109": "c",
          "\u010B": "c",
          "\u010D": "c",
          "\u010E": "D",
          "\u0110": "D",
          "\u010F": "d",
          "\u0111": "d",
          "\u0112": "E",
          "\u0114": "E",
          "\u0116": "E",
          "\u0118": "E",
          "\u011A": "E",
          "\u0113": "e",
          "\u0115": "e",
          "\u0117": "e",
          "\u0119": "e",
          "\u011B": "e",
          "\u011C": "G",
          "\u011E": "G",
          "\u0120": "G",
          "\u0122": "G",
          "\u011D": "g",
          "\u011F": "g",
          "\u0121": "g",
          "\u0123": "g",
          "\u0124": "H",
          "\u0126": "H",
          "\u0125": "h",
          "\u0127": "h",
          "\u0128": "I",
          "\u012A": "I",
          "\u012C": "I",
          "\u012E": "I",
          "\u0130": "I",
          "\u0129": "i",
          "\u012B": "i",
          "\u012D": "i",
          "\u012F": "i",
          "\u0131": "i",
          "\u0134": "J",
          "\u0135": "j",
          "\u0136": "K",
          "\u0137": "k",
          "\u0138": "k",
          "\u0139": "L",
          "\u013B": "L",
          "\u013D": "L",
          "\u013F": "L",
          "\u0141": "L",
          "\u013A": "l",
          "\u013C": "l",
          "\u013E": "l",
          "\u0140": "l",
          "\u0142": "l",
          "\u0143": "N",
          "\u0145": "N",
          "\u0147": "N",
          "\u014A": "N",
          "\u0144": "n",
          "\u0146": "n",
          "\u0148": "n",
          "\u014B": "n",
          "\u014C": "O",
          "\u014E": "O",
          "\u0150": "O",
          "\u014D": "o",
          "\u014F": "o",
          "\u0151": "o",
          "\u0154": "R",
          "\u0156": "R",
          "\u0158": "R",
          "\u0155": "r",
          "\u0157": "r",
          "\u0159": "r",
          "\u015A": "S",
          "\u015C": "S",
          "\u015E": "S",
          "\u0160": "S",
          "\u015B": "s",
          "\u015D": "s",
          "\u015F": "s",
          "\u0161": "s",
          "\u0162": "T",
          "\u0164": "T",
          "\u0166": "T",
          "\u0163": "t",
          "\u0165": "t",
          "\u0167": "t",
          "\u0168": "U",
          "\u016A": "U",
          "\u016C": "U",
          "\u016E": "U",
          "\u0170": "U",
          "\u0172": "U",
          "\u0169": "u",
          "\u016B": "u",
          "\u016D": "u",
          "\u016F": "u",
          "\u0171": "u",
          "\u0173": "u",
          "\u0174": "W",
          "\u0175": "w",
          "\u0176": "Y",
          "\u0177": "y",
          "\u0178": "Y",
          "\u0179": "Z",
          "\u017B": "Z",
          "\u017D": "Z",
          "\u017A": "z",
          "\u017C": "z",
          "\u017E": "z",
          "\u0132": "IJ",
          "\u0133": "ij",
          "\u0152": "Oe",
          "\u0153": "oe",
          "\u0149": "'n",
          "\u017F": "s"
        };
        var htmlEscapes = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        };
        var htmlUnescapes = {
          "&amp;": "&",
          "&lt;": "<",
          "&gt;": ">",
          "&quot;": '"',
          "&#39;": "'"
        };
        var stringEscapes = {
          "\\": "\\",
          "'": "'",
          "\n": "n",
          "\r": "r",
          "\u2028": "u2028",
          "\u2029": "u2029"
        };
        var freeParseFloat = parseFloat, freeParseInt = parseInt;
        var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
        var freeSelf = typeof self == "object" && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function("return this")();
        var freeExports = typeof exports2 == "object" && exports2 && !exports2.nodeType && exports2;
        var freeModule = freeExports && typeof module2 == "object" && module2 && !module2.nodeType && module2;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
          try {
            var types3 = freeModule && freeModule.require && freeModule.require("util").types;
            if (types3) {
              return types3;
            }
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
          } catch (e2) {
          }
        }();
        var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        function apply(func, thisArg, args) {
          switch (args.length) {
            case 0:
              return func.call(thisArg);
            case 1:
              return func.call(thisArg, args[0]);
            case 2:
              return func.call(thisArg, args[0], args[1]);
            case 3:
              return func.call(thisArg, args[0], args[1], args[2]);
          }
          return func.apply(thisArg, args);
        }
        function arrayAggregator(array, setter, iteratee, accumulator) {
          var index2 = -1, length2 = array == null ? 0 : array.length;
          while (++index2 < length2) {
            var value = array[index2];
            setter(accumulator, value, iteratee(value), array);
          }
          return accumulator;
        }
        function arrayEach(array, iteratee) {
          var index2 = -1, length2 = array == null ? 0 : array.length;
          while (++index2 < length2) {
            if (iteratee(array[index2], index2, array) === false) {
              break;
            }
          }
          return array;
        }
        function arrayEachRight(array, iteratee) {
          var length2 = array == null ? 0 : array.length;
          while (length2--) {
            if (iteratee(array[length2], length2, array) === false) {
              break;
            }
          }
          return array;
        }
        function arrayEvery(array, predicate) {
          var index2 = -1, length2 = array == null ? 0 : array.length;
          while (++index2 < length2) {
            if (!predicate(array[index2], index2, array)) {
              return false;
            }
          }
          return true;
        }
        function arrayFilter(array, predicate) {
          var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
          while (++index2 < length2) {
            var value = array[index2];
            if (predicate(value, index2, array)) {
              result[resIndex++] = value;
            }
          }
          return result;
        }
        function arrayIncludes(array, value) {
          var length2 = array == null ? 0 : array.length;
          return !!length2 && baseIndexOf(array, value, 0) > -1;
        }
        function arrayIncludesWith(array, value, comparator) {
          var index2 = -1, length2 = array == null ? 0 : array.length;
          while (++index2 < length2) {
            if (comparator(value, array[index2])) {
              return true;
            }
          }
          return false;
        }
        function arrayMap(array, iteratee) {
          var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
          while (++index2 < length2) {
            result[index2] = iteratee(array[index2], index2, array);
          }
          return result;
        }
        function arrayPush(array, values) {
          var index2 = -1, length2 = values.length, offset = array.length;
          while (++index2 < length2) {
            array[offset + index2] = values[index2];
          }
          return array;
        }
        function arrayReduce(array, iteratee, accumulator, initAccum) {
          var index2 = -1, length2 = array == null ? 0 : array.length;
          if (initAccum && length2) {
            accumulator = array[++index2];
          }
          while (++index2 < length2) {
            accumulator = iteratee(accumulator, array[index2], index2, array);
          }
          return accumulator;
        }
        function arrayReduceRight(array, iteratee, accumulator, initAccum) {
          var length2 = array == null ? 0 : array.length;
          if (initAccum && length2) {
            accumulator = array[--length2];
          }
          while (length2--) {
            accumulator = iteratee(accumulator, array[length2], length2, array);
          }
          return accumulator;
        }
        function arraySome(array, predicate) {
          var index2 = -1, length2 = array == null ? 0 : array.length;
          while (++index2 < length2) {
            if (predicate(array[index2], index2, array)) {
              return true;
            }
          }
          return false;
        }
        var asciiSize = baseProperty("length");
        function asciiToArray(string) {
          return string.split("");
        }
        function asciiWords(string) {
          return string.match(reAsciiWord) || [];
        }
        function baseFindKey(collection, predicate, eachFunc) {
          var result;
          eachFunc(collection, function(value, key, collection2) {
            if (predicate(value, key, collection2)) {
              result = key;
              return false;
            }
          });
          return result;
        }
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
          var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (predicate(array[index2], index2, array)) {
              return index2;
            }
          }
          return -1;
        }
        function baseIndexOf(array, value, fromIndex) {
          return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        function baseIndexOfWith(array, value, fromIndex, comparator) {
          var index2 = fromIndex - 1, length2 = array.length;
          while (++index2 < length2) {
            if (comparator(array[index2], value)) {
              return index2;
            }
          }
          return -1;
        }
        function baseIsNaN(value) {
          return value !== value;
        }
        function baseMean(array, iteratee) {
          var length2 = array == null ? 0 : array.length;
          return length2 ? baseSum(array, iteratee) / length2 : NAN;
        }
        function baseProperty(key) {
          return function(object) {
            return object == null ? undefined2 : object[key];
          };
        }
        function basePropertyOf(object) {
          return function(key) {
            return object == null ? undefined2 : object[key];
          };
        }
        function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
          eachFunc(collection, function(value, index2, collection2) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
          });
          return accumulator;
        }
        function baseSortBy(array, comparer) {
          var length2 = array.length;
          array.sort(comparer);
          while (length2--) {
            array[length2] = array[length2].value;
          }
          return array;
        }
        function baseSum(array, iteratee) {
          var result, index2 = -1, length2 = array.length;
          while (++index2 < length2) {
            var current = iteratee(array[index2]);
            if (current !== undefined2) {
              result = result === undefined2 ? current : result + current;
            }
          }
          return result;
        }
        function baseTimes(n2, iteratee) {
          var index2 = -1, result = Array(n2);
          while (++index2 < n2) {
            result[index2] = iteratee(index2);
          }
          return result;
        }
        function baseToPairs(object, props) {
          return arrayMap(props, function(key) {
            return [key, object[key]];
          });
        }
        function baseTrim(string) {
          return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
        }
        function baseUnary(func) {
          return function(value) {
            return func(value);
          };
        }
        function baseValues(object, props) {
          return arrayMap(props, function(key) {
            return object[key];
          });
        }
        function cacheHas(cache2, key) {
          return cache2.has(key);
        }
        function charsStartIndex(strSymbols, chrSymbols) {
          var index2 = -1, length2 = strSymbols.length;
          while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
          }
          return index2;
        }
        function charsEndIndex(strSymbols, chrSymbols) {
          var index2 = strSymbols.length;
          while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
          }
          return index2;
        }
        function countHolders(array, placeholder) {
          var length2 = array.length, result = 0;
          while (length2--) {
            if (array[length2] === placeholder) {
              ++result;
            }
          }
          return result;
        }
        var deburrLetter = basePropertyOf(deburredLetters);
        var escapeHtmlChar = basePropertyOf(htmlEscapes);
        function escapeStringChar(chr) {
          return "\\" + stringEscapes[chr];
        }
        function getValue(object, key) {
          return object == null ? undefined2 : object[key];
        }
        function hasUnicode(string) {
          return reHasUnicode.test(string);
        }
        function hasUnicodeWord(string) {
          return reHasUnicodeWord.test(string);
        }
        function iteratorToArray(iterator) {
          var data, result = [];
          while (!(data = iterator.next()).done) {
            result.push(data.value);
          }
          return result;
        }
        function mapToArray(map) {
          var index2 = -1, result = Array(map.size);
          map.forEach(function(value, key) {
            result[++index2] = [key, value];
          });
          return result;
        }
        function overArg(func, transform) {
          return function(arg) {
            return func(transform(arg));
          };
        }
        function replaceHolders(array, placeholder) {
          var index2 = -1, length2 = array.length, resIndex = 0, result = [];
          while (++index2 < length2) {
            var value = array[index2];
            if (value === placeholder || value === PLACEHOLDER) {
              array[index2] = PLACEHOLDER;
              result[resIndex++] = index2;
            }
          }
          return result;
        }
        function setToArray(set4) {
          var index2 = -1, result = Array(set4.size);
          set4.forEach(function(value) {
            result[++index2] = value;
          });
          return result;
        }
        function setToPairs(set4) {
          var index2 = -1, result = Array(set4.size);
          set4.forEach(function(value) {
            result[++index2] = [value, value];
          });
          return result;
        }
        function strictIndexOf(array, value, fromIndex) {
          var index2 = fromIndex - 1, length2 = array.length;
          while (++index2 < length2) {
            if (array[index2] === value) {
              return index2;
            }
          }
          return -1;
        }
        function strictLastIndexOf(array, value, fromIndex) {
          var index2 = fromIndex + 1;
          while (index2--) {
            if (array[index2] === value) {
              return index2;
            }
          }
          return index2;
        }
        function stringSize(string) {
          return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
        }
        function stringToArray(string) {
          return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }
        function trimmedEndIndex(string) {
          var index2 = string.length;
          while (index2-- && reWhitespace.test(string.charAt(index2))) {
          }
          return index2;
        }
        var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
        function unicodeSize(string) {
          var result = reUnicode.lastIndex = 0;
          while (reUnicode.test(string)) {
            ++result;
          }
          return result;
        }
        function unicodeToArray(string) {
          return string.match(reUnicode) || [];
        }
        function unicodeWords(string) {
          return string.match(reUnicodeWord) || [];
        }
        var runInContext = function runInContext2(context) {
          context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
          var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
          var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
          var coreJsData = context["__core-js_shared__"];
          var funcToString = funcProto.toString;
          var hasOwnProperty2 = objectProto.hasOwnProperty;
          var idCounter = 0;
          var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
          }();
          var nativeObjectToString = objectProto.toString;
          var objectCtorString = funcToString.call(Object2);
          var oldDash = root._;
          var reIsNative = RegExp2(
            "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
          );
          var Buffer7 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer7 ? Buffer7.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
          var defineProperty = function() {
            try {
              var func = getNative(Object2, "defineProperty");
              func({}, "", {});
              return func;
            } catch (e2) {
            }
          }();
          var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
          var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer7 ? Buffer7.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
          var DataView2 = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
          var metaMap = WeakMap2 && new WeakMap2();
          var realNames = {};
          var dataViewCtorString = toSource(DataView2), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
          var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
          function lodash(value) {
            if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
              if (value instanceof LodashWrapper) {
                return value;
              }
              if (hasOwnProperty2.call(value, "__wrapped__")) {
                return wrapperClone(value);
              }
            }
            return new LodashWrapper(value);
          }
          var baseCreate = /* @__PURE__ */ function() {
            function object() {
            }
            return function(proto2) {
              if (!isObject3(proto2)) {
                return {};
              }
              if (objectCreate) {
                return objectCreate(proto2);
              }
              object.prototype = proto2;
              var result2 = new object();
              object.prototype = undefined2;
              return result2;
            };
          }();
          function baseLodash() {
          }
          function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined2;
          }
          lodash.templateSettings = {
            /**
             * Used to detect `data` property values to be HTML-escaped.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            "escape": reEscape,
            /**
             * Used to detect code to be evaluated.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            "evaluate": reEvaluate,
            /**
             * Used to detect `data` property values to inject.
             *
             * @memberOf _.templateSettings
             * @type {RegExp}
             */
            "interpolate": reInterpolate,
            /**
             * Used to reference the data object in the template text.
             *
             * @memberOf _.templateSettings
             * @type {string}
             */
            "variable": "",
            /**
             * Used to import variables into the compiled template.
             *
             * @memberOf _.templateSettings
             * @type {Object}
             */
            "imports": {
              /**
               * A reference to the `lodash` function.
               *
               * @memberOf _.templateSettings.imports
               * @type {Function}
               */
              "_": lodash
            }
          };
          lodash.prototype = baseLodash.prototype;
          lodash.prototype.constructor = lodash;
          LodashWrapper.prototype = baseCreate(baseLodash.prototype);
          LodashWrapper.prototype.constructor = LodashWrapper;
          function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
          }
          function lazyClone() {
            var result2 = new LazyWrapper(this.__wrapped__);
            result2.__actions__ = copyArray(this.__actions__);
            result2.__dir__ = this.__dir__;
            result2.__filtered__ = this.__filtered__;
            result2.__iteratees__ = copyArray(this.__iteratees__);
            result2.__takeCount__ = this.__takeCount__;
            result2.__views__ = copyArray(this.__views__);
            return result2;
          }
          function lazyReverse() {
            if (this.__filtered__) {
              var result2 = new LazyWrapper(this);
              result2.__dir__ = -1;
              result2.__filtered__ = true;
            } else {
              result2 = this.clone();
              result2.__dir__ *= -1;
            }
            return result2;
          }
          function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view2 = getView(0, arrLength, this.__views__), start = view2.start, end = view2.end, length2 = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length2, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
              return baseWrapperValue(array, this.__actions__);
            }
            var result2 = [];
            outer:
              while (length2-- && resIndex < takeCount) {
                index2 += dir;
                var iterIndex = -1, value = array[index2];
                while (++iterIndex < iterLength) {
                  var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                  if (type == LAZY_MAP_FLAG) {
                    value = computed;
                  } else if (!computed) {
                    if (type == LAZY_FILTER_FLAG) {
                      continue outer;
                    } else {
                      break outer;
                    }
                  }
                }
                result2[resIndex++] = value;
              }
            return result2;
          }
          LazyWrapper.prototype = baseCreate(baseLodash.prototype);
          LazyWrapper.prototype.constructor = LazyWrapper;
          function Hash2(entries2) {
            var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
            this.clear();
            while (++index2 < length2) {
              var entry = entries2[index2];
              this.set(entry[0], entry[1]);
            }
          }
          function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
          }
          function hashDelete(key) {
            var result2 = this.has(key) && delete this.__data__[key];
            this.size -= result2 ? 1 : 0;
            return result2;
          }
          function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
              var result2 = data[key];
              return result2 === HASH_UNDEFINED ? undefined2 : result2;
            }
            return hasOwnProperty2.call(data, key) ? data[key] : undefined2;
          }
          function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined2 : hasOwnProperty2.call(data, key);
          }
          function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
            return this;
          }
          Hash2.prototype.clear = hashClear;
          Hash2.prototype["delete"] = hashDelete;
          Hash2.prototype.get = hashGet;
          Hash2.prototype.has = hashHas;
          Hash2.prototype.set = hashSet;
          function ListCache(entries2) {
            var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
            this.clear();
            while (++index2 < length2) {
              var entry = entries2[index2];
              this.set(entry[0], entry[1]);
            }
          }
          function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
          }
          function listCacheDelete(key) {
            var data = this.__data__, index2 = assocIndexOf(data, key);
            if (index2 < 0) {
              return false;
            }
            var lastIndex = data.length - 1;
            if (index2 == lastIndex) {
              data.pop();
            } else {
              splice.call(data, index2, 1);
            }
            --this.size;
            return true;
          }
          function listCacheGet(key) {
            var data = this.__data__, index2 = assocIndexOf(data, key);
            return index2 < 0 ? undefined2 : data[index2][1];
          }
          function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
          }
          function listCacheSet(key, value) {
            var data = this.__data__, index2 = assocIndexOf(data, key);
            if (index2 < 0) {
              ++this.size;
              data.push([key, value]);
            } else {
              data[index2][1] = value;
            }
            return this;
          }
          ListCache.prototype.clear = listCacheClear;
          ListCache.prototype["delete"] = listCacheDelete;
          ListCache.prototype.get = listCacheGet;
          ListCache.prototype.has = listCacheHas;
          ListCache.prototype.set = listCacheSet;
          function MapCache(entries2) {
            var index2 = -1, length2 = entries2 == null ? 0 : entries2.length;
            this.clear();
            while (++index2 < length2) {
              var entry = entries2[index2];
              this.set(entry[0], entry[1]);
            }
          }
          function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
              "hash": new Hash2(),
              "map": new (Map2 || ListCache)(),
              "string": new Hash2()
            };
          }
          function mapCacheDelete(key) {
            var result2 = getMapData(this, key)["delete"](key);
            this.size -= result2 ? 1 : 0;
            return result2;
          }
          function mapCacheGet(key) {
            return getMapData(this, key).get(key);
          }
          function mapCacheHas(key) {
            return getMapData(this, key).has(key);
          }
          function mapCacheSet(key, value) {
            var data = getMapData(this, key), size2 = data.size;
            data.set(key, value);
            this.size += data.size == size2 ? 0 : 1;
            return this;
          }
          MapCache.prototype.clear = mapCacheClear;
          MapCache.prototype["delete"] = mapCacheDelete;
          MapCache.prototype.get = mapCacheGet;
          MapCache.prototype.has = mapCacheHas;
          MapCache.prototype.set = mapCacheSet;
          function SetCache(values2) {
            var index2 = -1, length2 = values2 == null ? 0 : values2.length;
            this.__data__ = new MapCache();
            while (++index2 < length2) {
              this.add(values2[index2]);
            }
          }
          function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
          }
          function setCacheHas(value) {
            return this.__data__.has(value);
          }
          SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
          SetCache.prototype.has = setCacheHas;
          function Stack(entries2) {
            var data = this.__data__ = new ListCache(entries2);
            this.size = data.size;
          }
          function stackClear() {
            this.__data__ = new ListCache();
            this.size = 0;
          }
          function stackDelete(key) {
            var data = this.__data__, result2 = data["delete"](key);
            this.size = data.size;
            return result2;
          }
          function stackGet(key) {
            return this.__data__.get(key);
          }
          function stackHas(key) {
            return this.__data__.has(key);
          }
          function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
              var pairs = data.__data__;
              if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([key, value]);
                this.size = ++data.size;
                return this;
              }
              data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
          }
          Stack.prototype.clear = stackClear;
          Stack.prototype["delete"] = stackDelete;
          Stack.prototype.get = stackGet;
          Stack.prototype.has = stackHas;
          Stack.prototype.set = stackSet;
          function arrayLikeKeys(value, inherited) {
            var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType2 = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType2, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length2 = result2.length;
            for (var key in value) {
              if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
              (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
              isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
              isType2 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
              isIndex(key, length2)))) {
                result2.push(key);
              }
            }
            return result2;
          }
          function arraySample(array) {
            var length2 = array.length;
            return length2 ? array[baseRandom(0, length2 - 1)] : undefined2;
          }
          function arraySampleSize(array, n2) {
            return shuffleSelf(copyArray(array), baseClamp(n2, 0, array.length));
          }
          function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
          }
          function assignMergeValue(object, key, value) {
            if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
              baseAssignValue(object, key, value);
            }
          }
          function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
              baseAssignValue(object, key, value);
            }
          }
          function assocIndexOf(array, key) {
            var length2 = array.length;
            while (length2--) {
              if (eq(array[length2][0], key)) {
                return length2;
              }
            }
            return -1;
          }
          function baseAggregator(collection, setter, iteratee2, accumulator) {
            baseEach(collection, function(value, key, collection2) {
              setter(accumulator, value, iteratee2(value), collection2);
            });
            return accumulator;
          }
          function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
          }
          function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
          }
          function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) {
              defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
              });
            } else {
              object[key] = value;
            }
          }
          function baseAt(object, paths) {
            var index2 = -1, length2 = paths.length, result2 = Array2(length2), skip = object == null;
            while (++index2 < length2) {
              result2[index2] = skip ? undefined2 : get4(object, paths[index2]);
            }
            return result2;
          }
          function baseClamp(number2, lower, upper) {
            if (number2 === number2) {
              if (upper !== undefined2) {
                number2 = number2 <= upper ? number2 : upper;
              }
              if (lower !== undefined2) {
                number2 = number2 >= lower ? number2 : lower;
              }
            }
            return number2;
          }
          function baseClone(value, bitmask, customizer, key, object, stack) {
            var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) {
              result2 = object ? customizer(value, key, object, stack) : customizer(value);
            }
            if (result2 !== undefined2) {
              return result2;
            }
            if (!isObject3(value)) {
              return value;
            }
            var isArr = isArray2(value);
            if (isArr) {
              result2 = initCloneArray(value);
              if (!isDeep) {
                return copyArray(value, result2);
              }
            } else {
              var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
              if (isBuffer2(value)) {
                return cloneBuffer(value, isDeep);
              }
              if (tag == objectTag || tag == argsTag || isFunc && !object) {
                result2 = isFlat || isFunc ? {} : initCloneObject(value);
                if (!isDeep) {
                  return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
                }
              } else {
                if (!cloneableTags[tag]) {
                  return object ? value : {};
                }
                result2 = initCloneByTag(value, tag, isDeep);
              }
            }
            stack || (stack = new Stack());
            var stacked = stack.get(value);
            if (stacked) {
              return stacked;
            }
            stack.set(value, result2);
            if (isSet(value)) {
              value.forEach(function(subValue) {
                result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
              });
            } else if (isMap(value)) {
              value.forEach(function(subValue, key2) {
                result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
              });
            }
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined2 : keysFunc(value);
            arrayEach(props || value, function(subValue, key2) {
              if (props) {
                key2 = subValue;
                subValue = value[key2];
              }
              assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
            return result2;
          }
          function baseConforms(source) {
            var props = keys(source);
            return function(object) {
              return baseConformsTo(object, source, props);
            };
          }
          function baseConformsTo(object, source, props) {
            var length2 = props.length;
            if (object == null) {
              return !length2;
            }
            object = Object2(object);
            while (length2--) {
              var key = props[length2], predicate = source[key], value = object[key];
              if (value === undefined2 && !(key in object) || !predicate(value)) {
                return false;
              }
            }
            return true;
          }
          function baseDelay(func, wait, args) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return setTimeout2(function() {
              func.apply(undefined2, args);
            }, wait);
          }
          function baseDifference(array, values2, iteratee2, comparator) {
            var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array.length, result2 = [], valuesLength = values2.length;
            if (!length2) {
              return result2;
            }
            if (iteratee2) {
              values2 = arrayMap(values2, baseUnary(iteratee2));
            }
            if (comparator) {
              includes2 = arrayIncludesWith;
              isCommon = false;
            } else if (values2.length >= LARGE_ARRAY_SIZE) {
              includes2 = cacheHas;
              isCommon = false;
              values2 = new SetCache(values2);
            }
            outer:
              while (++index2 < length2) {
                var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                  var valuesIndex = valuesLength;
                  while (valuesIndex--) {
                    if (values2[valuesIndex] === computed) {
                      continue outer;
                    }
                  }
                  result2.push(value);
                } else if (!includes2(values2, computed, comparator)) {
                  result2.push(value);
                }
              }
            return result2;
          }
          var baseEach = createBaseEach(baseForOwn);
          var baseEachRight = createBaseEach(baseForOwnRight, true);
          function baseEvery(collection, predicate) {
            var result2 = true;
            baseEach(collection, function(value, index2, collection2) {
              result2 = !!predicate(value, index2, collection2);
              return result2;
            });
            return result2;
          }
          function baseExtremum(array, iteratee2, comparator) {
            var index2 = -1, length2 = array.length;
            while (++index2 < length2) {
              var value = array[index2], current = iteratee2(value);
              if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
                var computed = current, result2 = value;
              }
            }
            return result2;
          }
          function baseFill(array, value, start, end) {
            var length2 = array.length;
            start = toInteger(start);
            if (start < 0) {
              start = -start > length2 ? 0 : length2 + start;
            }
            end = end === undefined2 || end > length2 ? length2 : toInteger(end);
            if (end < 0) {
              end += length2;
            }
            end = start > end ? 0 : toLength(end);
            while (start < end) {
              array[start++] = value;
            }
            return array;
          }
          function baseFilter(collection, predicate) {
            var result2 = [];
            baseEach(collection, function(value, index2, collection2) {
              if (predicate(value, index2, collection2)) {
                result2.push(value);
              }
            });
            return result2;
          }
          function baseFlatten(array, depth, predicate, isStrict, result2) {
            var index2 = -1, length2 = array.length;
            predicate || (predicate = isFlattenable);
            result2 || (result2 = []);
            while (++index2 < length2) {
              var value = array[index2];
              if (depth > 0 && predicate(value)) {
                if (depth > 1) {
                  baseFlatten(value, depth - 1, predicate, isStrict, result2);
                } else {
                  arrayPush(result2, value);
                }
              } else if (!isStrict) {
                result2[result2.length] = value;
              }
            }
            return result2;
          }
          var baseFor = createBaseFor();
          var baseForRight = createBaseFor(true);
          function baseForOwn(object, iteratee2) {
            return object && baseFor(object, iteratee2, keys);
          }
          function baseForOwnRight(object, iteratee2) {
            return object && baseForRight(object, iteratee2, keys);
          }
          function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
              return isFunction2(object[key]);
            });
          }
          function baseGet(object, path3) {
            path3 = castPath(path3, object);
            var index2 = 0, length2 = path3.length;
            while (object != null && index2 < length2) {
              object = object[toKey(path3[index2++])];
            }
            return index2 && index2 == length2 ? object : undefined2;
          }
          function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result2 = keysFunc(object);
            return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
          }
          function baseGetTag(value) {
            if (value == null) {
              return value === undefined2 ? undefinedTag : nullTag;
            }
            return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
          }
          function baseGt(value, other) {
            return value > other;
          }
          function baseHas(object, key) {
            return object != null && hasOwnProperty2.call(object, key);
          }
          function baseHasIn(object, key) {
            return object != null && key in Object2(object);
          }
          function baseInRange(number2, start, end) {
            return number2 >= nativeMin(start, end) && number2 < nativeMax(start, end);
          }
          function baseIntersection(arrays, iteratee2, comparator) {
            var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
            while (othIndex--) {
              var array = arrays[othIndex];
              if (othIndex && iteratee2) {
                array = arrayMap(array, baseUnary(iteratee2));
              }
              maxLength = nativeMin(array.length, maxLength);
              caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
            }
            array = arrays[0];
            var index2 = -1, seen = caches[0];
            outer:
              while (++index2 < length2 && result2.length < maxLength) {
                var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                  othIndex = othLength;
                  while (--othIndex) {
                    var cache2 = caches[othIndex];
                    if (!(cache2 ? cacheHas(cache2, computed) : includes2(arrays[othIndex], computed, comparator))) {
                      continue outer;
                    }
                  }
                  if (seen) {
                    seen.push(computed);
                  }
                  result2.push(value);
                }
              }
            return result2;
          }
          function baseInverter(object, setter, iteratee2, accumulator) {
            baseForOwn(object, function(value, key, object2) {
              setter(accumulator, iteratee2(value), key, object2);
            });
            return accumulator;
          }
          function baseInvoke(object, path3, args) {
            path3 = castPath(path3, object);
            object = parent(object, path3);
            var func = object == null ? object : object[toKey(last(path3))];
            return func == null ? undefined2 : apply(func, object, args);
          }
          function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
          }
          function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
          }
          function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
          }
          function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) {
              return true;
            }
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
              return value !== value && other !== other;
            }
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
          }
          function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer2(object)) {
              if (!isBuffer2(other)) {
                return false;
              }
              objIsArr = true;
              objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
              stack || (stack = new Stack());
              return objIsArr || isTypedArray2(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
              var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
              if (objIsWrapped || othIsWrapped) {
                var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                stack || (stack = new Stack());
                return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
              }
            }
            if (!isSameTag) {
              return false;
            }
            stack || (stack = new Stack());
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
          }
          function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
          }
          function baseIsMatch(object, source, matchData, customizer) {
            var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
            if (object == null) {
              return !length2;
            }
            object = Object2(object);
            while (index2--) {
              var data = matchData[index2];
              if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
                return false;
              }
            }
            while (++index2 < length2) {
              data = matchData[index2];
              var key = data[0], objValue = object[key], srcValue = data[1];
              if (noCustomizer && data[2]) {
                if (objValue === undefined2 && !(key in object)) {
                  return false;
                }
              } else {
                var stack = new Stack();
                if (customizer) {
                  var result2 = customizer(objValue, srcValue, key, object, source, stack);
                }
                if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                  return false;
                }
              }
            }
            return true;
          }
          function baseIsNative(value) {
            if (!isObject3(value) || isMasked(value)) {
              return false;
            }
            var pattern2 = isFunction2(value) ? reIsNative : reIsHostCtor;
            return pattern2.test(toSource(value));
          }
          function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
          }
          function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
          }
          function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
          }
          function baseIteratee(value) {
            if (typeof value == "function") {
              return value;
            }
            if (value == null) {
              return identity;
            }
            if (typeof value == "object") {
              return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            }
            return property(value);
          }
          function baseKeys(object) {
            if (!isPrototype(object)) {
              return nativeKeys(object);
            }
            var result2 = [];
            for (var key in Object2(object)) {
              if (hasOwnProperty2.call(object, key) && key != "constructor") {
                result2.push(key);
              }
            }
            return result2;
          }
          function baseKeysIn(object) {
            if (!isObject3(object)) {
              return nativeKeysIn(object);
            }
            var isProto = isPrototype(object), result2 = [];
            for (var key in object) {
              if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
                result2.push(key);
              }
            }
            return result2;
          }
          function baseLt(value, other) {
            return value < other;
          }
          function baseMap(collection, iteratee2) {
            var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
            baseEach(collection, function(value, key, collection2) {
              result2[++index2] = iteratee2(value, key, collection2);
            });
            return result2;
          }
          function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) {
              return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            }
            return function(object) {
              return object === source || baseIsMatch(object, source, matchData);
            };
          }
          function baseMatchesProperty(path3, srcValue) {
            if (isKey(path3) && isStrictComparable(srcValue)) {
              return matchesStrictComparable(toKey(path3), srcValue);
            }
            return function(object) {
              var objValue = get4(object, path3);
              return objValue === undefined2 && objValue === srcValue ? hasIn(object, path3) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
          }
          function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) {
              return;
            }
            baseFor(source, function(srcValue, key) {
              stack || (stack = new Stack());
              if (isObject3(srcValue)) {
                baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
              } else {
                var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
                if (newValue === undefined2) {
                  newValue = srcValue;
                }
                assignMergeValue(object, key, newValue);
              }
            }, keysIn);
          }
          function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
              assignMergeValue(object, key, stacked);
              return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
            var isCommon = newValue === undefined2;
            if (isCommon) {
              var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
              newValue = srcValue;
              if (isArr || isBuff || isTyped) {
                if (isArray2(objValue)) {
                  newValue = objValue;
                } else if (isArrayLikeObject(objValue)) {
                  newValue = copyArray(objValue);
                } else if (isBuff) {
                  isCommon = false;
                  newValue = cloneBuffer(srcValue, true);
                } else if (isTyped) {
                  isCommon = false;
                  newValue = cloneTypedArray(srcValue, true);
                } else {
                  newValue = [];
                }
              } else if (isPlainObject3(srcValue) || isArguments(srcValue)) {
                newValue = objValue;
                if (isArguments(objValue)) {
                  newValue = toPlainObject(objValue);
                } else if (!isObject3(objValue) || isFunction2(objValue)) {
                  newValue = initCloneObject(srcValue);
                }
              } else {
                isCommon = false;
              }
            }
            if (isCommon) {
              stack.set(srcValue, newValue);
              mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
              stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
          }
          function baseNth(array, n2) {
            var length2 = array.length;
            if (!length2) {
              return;
            }
            n2 += n2 < 0 ? length2 : 0;
            return isIndex(n2, length2) ? array[n2] : undefined2;
          }
          function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) {
              iteratees = arrayMap(iteratees, function(iteratee2) {
                if (isArray2(iteratee2)) {
                  return function(value) {
                    return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                  };
                }
                return iteratee2;
              });
            } else {
              iteratees = [identity];
            }
            var index2 = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result2 = baseMap(collection, function(value, key, collection2) {
              var criteria = arrayMap(iteratees, function(iteratee2) {
                return iteratee2(value);
              });
              return { "criteria": criteria, "index": ++index2, "value": value };
            });
            return baseSortBy(result2, function(object, other) {
              return compareMultiple(object, other, orders);
            });
          }
          function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path3) {
              return hasIn(object, path3);
            });
          }
          function basePickBy(object, paths, predicate) {
            var index2 = -1, length2 = paths.length, result2 = {};
            while (++index2 < length2) {
              var path3 = paths[index2], value = baseGet(object, path3);
              if (predicate(value, path3)) {
                baseSet(result2, castPath(path3, object), value);
              }
            }
            return result2;
          }
          function basePropertyDeep(path3) {
            return function(object) {
              return baseGet(object, path3);
            };
          }
          function basePullAll(array, values2, iteratee2, comparator) {
            var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values2.length, seen = array;
            if (array === values2) {
              values2 = copyArray(values2);
            }
            if (iteratee2) {
              seen = arrayMap(array, baseUnary(iteratee2));
            }
            while (++index2 < length2) {
              var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
              while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
                if (seen !== array) {
                  splice.call(seen, fromIndex, 1);
                }
                splice.call(array, fromIndex, 1);
              }
            }
            return array;
          }
          function basePullAt(array, indexes) {
            var length2 = array ? indexes.length : 0, lastIndex = length2 - 1;
            while (length2--) {
              var index2 = indexes[length2];
              if (length2 == lastIndex || index2 !== previous) {
                var previous = index2;
                if (isIndex(index2)) {
                  splice.call(array, index2, 1);
                } else {
                  baseUnset(array, index2);
                }
              }
            }
            return array;
          }
          function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
          }
          function baseRange(start, end, step, fromRight) {
            var index2 = -1, length2 = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length2);
            while (length2--) {
              result2[fromRight ? length2 : ++index2] = start;
              start += step;
            }
            return result2;
          }
          function baseRepeat(string, n2) {
            var result2 = "";
            if (!string || n2 < 1 || n2 > MAX_SAFE_INTEGER) {
              return result2;
            }
            do {
              if (n2 % 2) {
                result2 += string;
              }
              n2 = nativeFloor(n2 / 2);
              if (n2) {
                string += string;
              }
            } while (n2);
            return result2;
          }
          function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
          }
          function baseSample(collection) {
            return arraySample(values(collection));
          }
          function baseSampleSize(collection, n2) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n2, 0, array.length));
          }
          function baseSet(object, path3, value, customizer) {
            if (!isObject3(object)) {
              return object;
            }
            path3 = castPath(path3, object);
            var index2 = -1, length2 = path3.length, lastIndex = length2 - 1, nested = object;
            while (nested != null && ++index2 < length2) {
              var key = toKey(path3[index2]), newValue = value;
              if (key === "__proto__" || key === "constructor" || key === "prototype") {
                return object;
              }
              if (index2 != lastIndex) {
                var objValue = nested[key];
                newValue = customizer ? customizer(objValue, key, nested) : undefined2;
                if (newValue === undefined2) {
                  newValue = isObject3(objValue) ? objValue : isIndex(path3[index2 + 1]) ? [] : {};
                }
              }
              assignValue(nested, key, newValue);
              nested = nested[key];
            }
            return object;
          }
          var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
          };
          var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
              "configurable": true,
              "enumerable": false,
              "value": constant(string),
              "writable": true
            });
          };
          function baseShuffle(collection) {
            return shuffleSelf(values(collection));
          }
          function baseSlice(array, start, end) {
            var index2 = -1, length2 = array.length;
            if (start < 0) {
              start = -start > length2 ? 0 : length2 + start;
            }
            end = end > length2 ? length2 : end;
            if (end < 0) {
              end += length2;
            }
            length2 = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result2 = Array2(length2);
            while (++index2 < length2) {
              result2[index2] = array[index2 + start];
            }
            return result2;
          }
          function baseSome(collection, predicate) {
            var result2;
            baseEach(collection, function(value, index2, collection2) {
              result2 = predicate(value, index2, collection2);
              return !result2;
            });
            return !!result2;
          }
          function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
              while (low < high) {
                var mid = low + high >>> 1, computed = array[mid];
                if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                  low = mid + 1;
                } else {
                  high = mid;
                }
              }
              return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
          }
          function baseSortedIndexBy(array, value, iteratee2, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) {
              return 0;
            }
            value = iteratee2(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
            while (low < high) {
              var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
              if (valIsNaN) {
                var setLow = retHighest || othIsReflexive;
              } else if (valIsUndefined) {
                setLow = othIsReflexive && (retHighest || othIsDefined);
              } else if (valIsNull) {
                setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
              } else if (valIsSymbol) {
                setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
              } else if (othIsNull || othIsSymbol) {
                setLow = false;
              } else {
                setLow = retHighest ? computed <= value : computed < value;
              }
              if (setLow) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
          }
          function baseSortedUniq(array, iteratee2) {
            var index2 = -1, length2 = array.length, resIndex = 0, result2 = [];
            while (++index2 < length2) {
              var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
              if (!index2 || !eq(computed, seen)) {
                var seen = computed;
                result2[resIndex++] = value === 0 ? 0 : value;
              }
            }
            return result2;
          }
          function baseToNumber(value) {
            if (typeof value == "number") {
              return value;
            }
            if (isSymbol(value)) {
              return NAN;
            }
            return +value;
          }
          function baseToString(value) {
            if (typeof value == "string") {
              return value;
            }
            if (isArray2(value)) {
              return arrayMap(value, baseToString) + "";
            }
            if (isSymbol(value)) {
              return symbolToString ? symbolToString.call(value) : "";
            }
            var result2 = value + "";
            return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
          }
          function baseUniq(array, iteratee2, comparator) {
            var index2 = -1, includes2 = arrayIncludes, length2 = array.length, isCommon = true, result2 = [], seen = result2;
            if (comparator) {
              isCommon = false;
              includes2 = arrayIncludesWith;
            } else if (length2 >= LARGE_ARRAY_SIZE) {
              var set5 = iteratee2 ? null : createSet(array);
              if (set5) {
                return setToArray(set5);
              }
              isCommon = false;
              includes2 = cacheHas;
              seen = new SetCache();
            } else {
              seen = iteratee2 ? [] : result2;
            }
            outer:
              while (++index2 < length2) {
                var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                  var seenIndex = seen.length;
                  while (seenIndex--) {
                    if (seen[seenIndex] === computed) {
                      continue outer;
                    }
                  }
                  if (iteratee2) {
                    seen.push(computed);
                  }
                  result2.push(value);
                } else if (!includes2(seen, computed, comparator)) {
                  if (seen !== result2) {
                    seen.push(computed);
                  }
                  result2.push(value);
                }
              }
            return result2;
          }
          function baseUnset(object, path3) {
            path3 = castPath(path3, object);
            object = parent(object, path3);
            return object == null || delete object[toKey(last(path3))];
          }
          function baseUpdate(object, path3, updater, customizer) {
            return baseSet(object, path3, updater(baseGet(object, path3)), customizer);
          }
          function baseWhile(array, predicate, isDrop, fromRight) {
            var length2 = array.length, index2 = fromRight ? length2 : -1;
            while ((fromRight ? index2-- : ++index2 < length2) && predicate(array[index2], index2, array)) {
            }
            return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
          }
          function baseWrapperValue(value, actions) {
            var result2 = value;
            if (result2 instanceof LazyWrapper) {
              result2 = result2.value();
            }
            return arrayReduce(actions, function(result3, action) {
              return action.func.apply(action.thisArg, arrayPush([result3], action.args));
            }, result2);
          }
          function baseXor(arrays, iteratee2, comparator) {
            var length2 = arrays.length;
            if (length2 < 2) {
              return length2 ? baseUniq(arrays[0]) : [];
            }
            var index2 = -1, result2 = Array2(length2);
            while (++index2 < length2) {
              var array = arrays[index2], othIndex = -1;
              while (++othIndex < length2) {
                if (othIndex != index2) {
                  result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
                }
              }
            }
            return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
          }
          function baseZipObject(props, values2, assignFunc) {
            var index2 = -1, length2 = props.length, valsLength = values2.length, result2 = {};
            while (++index2 < length2) {
              var value = index2 < valsLength ? values2[index2] : undefined2;
              assignFunc(result2, props[index2], value);
            }
            return result2;
          }
          function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
          }
          function castFunction(value) {
            return typeof value == "function" ? value : identity;
          }
          function castPath(value, object) {
            if (isArray2(value)) {
              return value;
            }
            return isKey(value, object) ? [value] : stringToPath(toString3(value));
          }
          var castRest = baseRest;
          function castSlice(array, start, end) {
            var length2 = array.length;
            end = end === undefined2 ? length2 : end;
            return !start && end >= length2 ? array : baseSlice(array, start, end);
          }
          var clearTimeout2 = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
          };
          function cloneBuffer(buffer, isDeep) {
            if (isDeep) {
              return buffer.slice();
            }
            var length2 = buffer.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
            buffer.copy(result2);
            return result2;
          }
          function cloneArrayBuffer(arrayBuffer) {
            var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
            return result2;
          }
          function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
          }
          function cloneRegExp(regexp) {
            var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result2.lastIndex = regexp.lastIndex;
            return result2;
          }
          function cloneSymbol(symbol2) {
            return symbolValueOf ? Object2(symbolValueOf.call(symbol2)) : {};
          }
          function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
          }
          function compareAscending(value, other) {
            if (value !== other) {
              var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
              var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
              if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
                return 1;
              }
              if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
                return -1;
              }
            }
            return 0;
          }
          function compareMultiple(object, other, orders) {
            var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
            while (++index2 < length2) {
              var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
              if (result2) {
                if (index2 >= ordersLength) {
                  return result2;
                }
                var order = orders[index2];
                return result2 * (order == "desc" ? -1 : 1);
              }
            }
            return object.index - other.index;
          }
          function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
            while (++leftIndex < leftLength) {
              result2[leftIndex] = partials[leftIndex];
            }
            while (++argsIndex < holdersLength) {
              if (isUncurried || argsIndex < argsLength) {
                result2[holders[argsIndex]] = args[argsIndex];
              }
            }
            while (rangeLength--) {
              result2[leftIndex++] = args[argsIndex++];
            }
            return result2;
          }
          function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
            while (++argsIndex < rangeLength) {
              result2[argsIndex] = args[argsIndex];
            }
            var offset = argsIndex;
            while (++rightIndex < rightLength) {
              result2[offset + rightIndex] = partials[rightIndex];
            }
            while (++holdersIndex < holdersLength) {
              if (isUncurried || argsIndex < argsLength) {
                result2[offset + holders[holdersIndex]] = args[argsIndex++];
              }
            }
            return result2;
          }
          function copyArray(source, array) {
            var index2 = -1, length2 = source.length;
            array || (array = Array2(length2));
            while (++index2 < length2) {
              array[index2] = source[index2];
            }
            return array;
          }
          function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index2 = -1, length2 = props.length;
            while (++index2 < length2) {
              var key = props[index2];
              var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
              if (newValue === undefined2) {
                newValue = source[key];
              }
              if (isNew) {
                baseAssignValue(object, key, newValue);
              } else {
                assignValue(object, key, newValue);
              }
            }
            return object;
          }
          function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
          }
          function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
          }
          function createAggregator(setter, initializer) {
            return function(collection, iteratee2) {
              var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
              return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
            };
          }
          function createAssigner(assigner) {
            return baseRest(function(object, sources) {
              var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined2, guard = length2 > 2 ? sources[2] : undefined2;
              customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined2;
              if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                customizer = length2 < 3 ? undefined2 : customizer;
                length2 = 1;
              }
              object = Object2(object);
              while (++index2 < length2) {
                var source = sources[index2];
                if (source) {
                  assigner(object, source, index2, customizer);
                }
              }
              return object;
            });
          }
          function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee2) {
              if (collection == null) {
                return collection;
              }
              if (!isArrayLike(collection)) {
                return eachFunc(collection, iteratee2);
              }
              var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
              while (fromRight ? index2-- : ++index2 < length2) {
                if (iteratee2(iterable[index2], index2, iterable) === false) {
                  break;
                }
              }
              return collection;
            };
          }
          function createBaseFor(fromRight) {
            return function(object, iteratee2, keysFunc) {
              var index2 = -1, iterable = Object2(object), props = keysFunc(object), length2 = props.length;
              while (length2--) {
                var key = props[fromRight ? length2 : ++index2];
                if (iteratee2(iterable[key], key, iterable) === false) {
                  break;
                }
              }
              return object;
            };
          }
          function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
              var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
              return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
          }
          function createCaseFirst(methodName) {
            return function(string) {
              string = toString3(string);
              var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
              var chr = strSymbols ? strSymbols[0] : string.charAt(0);
              var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
              return chr[methodName]() + trailing;
            };
          }
          function createCompounder(callback) {
            return function(string) {
              return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
          }
          function createCtor(Ctor) {
            return function() {
              var args = arguments;
              switch (args.length) {
                case 0:
                  return new Ctor();
                case 1:
                  return new Ctor(args[0]);
                case 2:
                  return new Ctor(args[0], args[1]);
                case 3:
                  return new Ctor(args[0], args[1], args[2]);
                case 4:
                  return new Ctor(args[0], args[1], args[2], args[3]);
                case 5:
                  return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                case 6:
                  return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                case 7:
                  return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
              }
              var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
              return isObject3(result2) ? result2 : thisBinding;
            };
          }
          function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
              var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder = getHolder(wrapper);
              while (index2--) {
                args[index2] = arguments[index2];
              }
              var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
              length2 -= holders.length;
              if (length2 < arity) {
                return createRecurry(
                  func,
                  bitmask,
                  createHybrid,
                  wrapper.placeholder,
                  undefined2,
                  args,
                  holders,
                  undefined2,
                  undefined2,
                  arity - length2
                );
              }
              var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
              return apply(fn, this, args);
            }
            return wrapper;
          }
          function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
              var iterable = Object2(collection);
              if (!isArrayLike(collection)) {
                var iteratee2 = getIteratee(predicate, 3);
                collection = keys(collection);
                predicate = function(key) {
                  return iteratee2(iterable[key], key, iterable);
                };
              }
              var index2 = findIndexFunc(collection, predicate, fromIndex);
              return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined2;
            };
          }
          function createFlow(fromRight) {
            return flatRest(function(funcs) {
              var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
              if (fromRight) {
                funcs.reverse();
              }
              while (index2--) {
                var func = funcs[index2];
                if (typeof func != "function") {
                  throw new TypeError2(FUNC_ERROR_TEXT);
                }
                if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                  var wrapper = new LodashWrapper([], true);
                }
              }
              index2 = wrapper ? index2 : length2;
              while (++index2 < length2) {
                func = funcs[index2];
                var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
                if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                  wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                } else {
                  wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
              }
              return function() {
                var args = arguments, value = args[0];
                if (wrapper && args.length == 1 && isArray2(value)) {
                  return wrapper.plant(value).value();
                }
                var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value;
                while (++index3 < length2) {
                  result2 = funcs[index3].call(this, result2);
                }
                return result2;
              };
            });
          }
          function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
            function wrapper() {
              var length2 = arguments.length, args = Array2(length2), index2 = length2;
              while (index2--) {
                args[index2] = arguments[index2];
              }
              if (isCurried) {
                var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
              }
              if (partials) {
                args = composeArgs(args, partials, holders, isCurried);
              }
              if (partialsRight) {
                args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
              }
              length2 -= holdersCount;
              if (isCurried && length2 < arity) {
                var newHolders = replaceHolders(args, placeholder);
                return createRecurry(
                  func,
                  bitmask,
                  createHybrid,
                  wrapper.placeholder,
                  thisArg,
                  args,
                  newHolders,
                  argPos,
                  ary2,
                  arity - length2
                );
              }
              var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
              length2 = args.length;
              if (argPos) {
                args = reorder(args, argPos);
              } else if (isFlip && length2 > 1) {
                args.reverse();
              }
              if (isAry && ary2 < length2) {
                args.length = ary2;
              }
              if (this && this !== root && this instanceof wrapper) {
                fn = Ctor || createCtor(fn);
              }
              return fn.apply(thisBinding, args);
            }
            return wrapper;
          }
          function createInverter(setter, toIteratee) {
            return function(object, iteratee2) {
              return baseInverter(object, setter, toIteratee(iteratee2), {});
            };
          }
          function createMathOperation(operator, defaultValue) {
            return function(value, other) {
              var result2;
              if (value === undefined2 && other === undefined2) {
                return defaultValue;
              }
              if (value !== undefined2) {
                result2 = value;
              }
              if (other !== undefined2) {
                if (result2 === undefined2) {
                  return other;
                }
                if (typeof value == "string" || typeof other == "string") {
                  value = baseToString(value);
                  other = baseToString(other);
                } else {
                  value = baseToNumber(value);
                  other = baseToNumber(other);
                }
                result2 = operator(value, other);
              }
              return result2;
            };
          }
          function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
              iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
              return baseRest(function(args) {
                var thisArg = this;
                return arrayFunc(iteratees, function(iteratee2) {
                  return apply(iteratee2, thisArg, args);
                });
              });
            });
          }
          function createPadding(length2, chars) {
            chars = chars === undefined2 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) {
              return charsLength ? baseRepeat(chars, length2) : chars;
            }
            var result2 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length2).join("") : result2.slice(0, length2);
          }
          function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
              var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
              while (++leftIndex < leftLength) {
                args[leftIndex] = partials[leftIndex];
              }
              while (argsLength--) {
                args[leftIndex++] = arguments[++argsIndex];
              }
              return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
          }
          function createRange(fromRight) {
            return function(start, end, step) {
              if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
                end = step = undefined2;
              }
              start = toFinite(start);
              if (end === undefined2) {
                end = start;
                start = 0;
              } else {
                end = toFinite(end);
              }
              step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
              return baseRange(start, end, step, fromRight);
            };
          }
          function createRelationalOperation(operator) {
            return function(value, other) {
              if (!(typeof value == "string" && typeof other == "string")) {
                value = toNumber3(value);
                other = toNumber3(other);
              }
              return operator(value, other);
            };
          }
          function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
              bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            }
            var newData = [
              func,
              bitmask,
              thisArg,
              newPartials,
              newHolders,
              newPartialsRight,
              newHoldersRight,
              argPos,
              ary2,
              arity
            ];
            var result2 = wrapFunc.apply(undefined2, newData);
            if (isLaziable(func)) {
              setData(result2, newData);
            }
            result2.placeholder = placeholder;
            return setWrapToString(result2, func, bitmask);
          }
          function createRound(methodName) {
            var func = Math2[methodName];
            return function(number2, precision) {
              number2 = toNumber3(number2);
              precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
              if (precision && nativeIsFinite(number2)) {
                var pair = (toString3(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                pair = (toString3(value) + "e").split("e");
                return +(pair[0] + "e" + (+pair[1] - precision));
              }
              return func(number2);
            };
          }
          var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop2 : function(values2) {
            return new Set2(values2);
          };
          function createToPairs(keysFunc) {
            return function(object) {
              var tag = getTag(object);
              if (tag == mapTag) {
                return mapToArray(object);
              }
              if (tag == setTag) {
                return setToPairs(object);
              }
              return baseToPairs(object, keysFunc(object));
            };
          }
          function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            var length2 = partials ? partials.length : 0;
            if (!length2) {
              bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
              partials = holders = undefined2;
            }
            ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
            arity = arity === undefined2 ? arity : toInteger(arity);
            length2 -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
              var partialsRight = partials, holdersRight = holders;
              partials = holders = undefined2;
            }
            var data = isBindKey ? undefined2 : getData(func);
            var newData = [
              func,
              bitmask,
              thisArg,
              partials,
              holders,
              partialsRight,
              holdersRight,
              argPos,
              ary2,
              arity
            ];
            if (data) {
              mergeData(newData, data);
            }
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length2, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
              bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            }
            if (!bitmask || bitmask == WRAP_BIND_FLAG) {
              var result2 = createBind(func, bitmask, thisArg);
            } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
              result2 = createCurry(func, bitmask, arity);
            } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
              result2 = createPartial(func, bitmask, thisArg, partials);
            } else {
              result2 = createHybrid.apply(undefined2, newData);
            }
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result2, newData), func, bitmask);
          }
          function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
              return srcValue;
            }
            return objValue;
          }
          function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject3(objValue) && isObject3(srcValue)) {
              stack.set(srcValue, objValue);
              baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
              stack["delete"](srcValue);
            }
            return objValue;
          }
          function customOmitClone(value) {
            return isPlainObject3(value) ? undefined2 : value;
          }
          function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
              return false;
            }
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) {
              return arrStacked == other && othStacked == array;
            }
            var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
            stack.set(array, other);
            stack.set(other, array);
            while (++index2 < arrLength) {
              var arrValue = array[index2], othValue = other[index2];
              if (customizer) {
                var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
              }
              if (compared !== undefined2) {
                if (compared) {
                  continue;
                }
                result2 = false;
                break;
              }
              if (seen) {
                if (!arraySome(other, function(othValue2, othIndex) {
                  if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                    return seen.push(othIndex);
                  }
                })) {
                  result2 = false;
                  break;
                }
              } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                result2 = false;
                break;
              }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result2;
          }
          function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch (tag) {
              case dataViewTag:
                if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                  return false;
                }
                object = object.buffer;
                other = other.buffer;
              case arrayBufferTag:
                if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                  return false;
                }
                return true;
              case boolTag:
              case dateTag:
              case numberTag:
                return eq(+object, +other);
              case errorTag:
                return object.name == other.name && object.message == other.message;
              case regexpTag:
              case stringTag:
                return object == other + "";
              case mapTag:
                var convert2 = mapToArray;
              case setTag:
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                convert2 || (convert2 = setToArray);
                if (object.size != other.size && !isPartial) {
                  return false;
                }
                var stacked = stack.get(object);
                if (stacked) {
                  return stacked == other;
                }
                bitmask |= COMPARE_UNORDERED_FLAG;
                stack.set(object, other);
                var result2 = equalArrays(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
                stack["delete"](object);
                return result2;
              case symbolTag:
                if (symbolValueOf) {
                  return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
            }
            return false;
          }
          function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) {
              return false;
            }
            var index2 = objLength;
            while (index2--) {
              var key = objProps[index2];
              if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
                return false;
              }
            }
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) {
              return objStacked == other && othStacked == object;
            }
            var result2 = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while (++index2 < objLength) {
              key = objProps[index2];
              var objValue = object[key], othValue = other[key];
              if (customizer) {
                var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
              }
              if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                result2 = false;
                break;
              }
              skipCtor || (skipCtor = key == "constructor");
            }
            if (result2 && !skipCtor) {
              var objCtor = object.constructor, othCtor = other.constructor;
              if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
                result2 = false;
              }
            }
            stack["delete"](object);
            stack["delete"](other);
            return result2;
          }
          function flatRest(func) {
            return setToString(overRest(func, undefined2, flatten2), func + "");
          }
          function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
          }
          function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
          }
          var getData = !metaMap ? noop2 : function(func) {
            return metaMap.get(func);
          };
          function getFuncName(func) {
            var result2 = func.name + "", array = realNames[result2], length2 = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
            while (length2--) {
              var data = array[length2], otherFunc = data.func;
              if (otherFunc == null || otherFunc == func) {
                return data.name;
              }
            }
            return result2;
          }
          function getHolder(func) {
            var object = hasOwnProperty2.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
          }
          function getIteratee() {
            var result2 = lodash.iteratee || iteratee;
            result2 = result2 === iteratee ? baseIteratee : result2;
            return arguments.length ? result2(arguments[0], arguments[1]) : result2;
          }
          function getMapData(map2, key) {
            var data = map2.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
          }
          function getMatchData(object) {
            var result2 = keys(object), length2 = result2.length;
            while (length2--) {
              var key = result2[length2], value = object[key];
              result2[length2] = [key, value, isStrictComparable(value)];
            }
            return result2;
          }
          function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined2;
          }
          function getRawTag(value) {
            var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
            try {
              value[symToStringTag] = undefined2;
              var unmasked = true;
            } catch (e2) {
            }
            var result2 = nativeObjectToString.call(value);
            if (unmasked) {
              if (isOwn) {
                value[symToStringTag] = tag;
              } else {
                delete value[symToStringTag];
              }
            }
            return result2;
          }
          var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) {
              return [];
            }
            object = Object2(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol2) {
              return propertyIsEnumerable.call(object, symbol2);
            });
          };
          var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result2 = [];
            while (object) {
              arrayPush(result2, getSymbols(object));
              object = getPrototype(object);
            }
            return result2;
          };
          var getTag = baseGetTag;
          if (DataView2 && getTag(new DataView2(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
            getTag = function(value) {
              var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
              if (ctorString) {
                switch (ctorString) {
                  case dataViewCtorString:
                    return dataViewTag;
                  case mapCtorString:
                    return mapTag;
                  case promiseCtorString:
                    return promiseTag;
                  case setCtorString:
                    return setTag;
                  case weakMapCtorString:
                    return weakMapTag;
                }
              }
              return result2;
            };
          }
          function getView(start, end, transforms) {
            var index2 = -1, length2 = transforms.length;
            while (++index2 < length2) {
              var data = transforms[index2], size2 = data.size;
              switch (data.type) {
                case "drop":
                  start += size2;
                  break;
                case "dropRight":
                  end -= size2;
                  break;
                case "take":
                  end = nativeMin(end, start + size2);
                  break;
                case "takeRight":
                  start = nativeMax(start, end - size2);
                  break;
              }
            }
            return { "start": start, "end": end };
          }
          function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
          }
          function hasPath(object, path3, hasFunc) {
            path3 = castPath(path3, object);
            var index2 = -1, length2 = path3.length, result2 = false;
            while (++index2 < length2) {
              var key = toKey(path3[index2]);
              if (!(result2 = object != null && hasFunc(object, key))) {
                break;
              }
              object = object[key];
            }
            if (result2 || ++index2 != length2) {
              return result2;
            }
            length2 = object == null ? 0 : object.length;
            return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray2(object) || isArguments(object));
          }
          function initCloneArray(array) {
            var length2 = array.length, result2 = new array.constructor(length2);
            if (length2 && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
              result2.index = array.index;
              result2.input = array.input;
            }
            return result2;
          }
          function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
          }
          function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch (tag) {
              case arrayBufferTag:
                return cloneArrayBuffer(object);
              case boolTag:
              case dateTag:
                return new Ctor(+object);
              case dataViewTag:
                return cloneDataView(object, isDeep);
              case float32Tag:
              case float64Tag:
              case int8Tag:
              case int16Tag:
              case int32Tag:
              case uint8Tag:
              case uint8ClampedTag:
              case uint16Tag:
              case uint32Tag:
                return cloneTypedArray(object, isDeep);
              case mapTag:
                return new Ctor();
              case numberTag:
              case stringTag:
                return new Ctor(object);
              case regexpTag:
                return cloneRegExp(object);
              case setTag:
                return new Ctor();
              case symbolTag:
                return cloneSymbol(object);
            }
          }
          function insertWrapDetails(source, details) {
            var length2 = details.length;
            if (!length2) {
              return source;
            }
            var lastIndex = length2 - 1;
            details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length2 > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
          }
          function isFlattenable(value) {
            return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
          }
          function isIndex(value, length2) {
            var type = typeof value;
            length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
            return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
          }
          function isIterateeCall(value, index2, object) {
            if (!isObject3(object)) {
              return false;
            }
            var type = typeof index2;
            if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
              return eq(object[index2], value);
            }
            return false;
          }
          function isKey(value, object) {
            if (isArray2(value)) {
              return false;
            }
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
              return true;
            }
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
          }
          function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
          }
          function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
              return false;
            }
            if (func === other) {
              return true;
            }
            var data = getData(other);
            return !!data && func === data[0];
          }
          function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
          }
          var isMaskable = coreJsData ? isFunction2 : stubFalse;
          function isPrototype(value) {
            var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto2;
          }
          function isStrictComparable(value) {
            return value === value && !isObject3(value);
          }
          function matchesStrictComparable(key, srcValue) {
            return function(object) {
              if (object == null) {
                return false;
              }
              return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
            };
          }
          function memoizeCapped(func) {
            var result2 = memoize(func, function(key) {
              if (cache2.size === MAX_MEMOIZE_SIZE) {
                cache2.clear();
              }
              return key;
            });
            var cache2 = result2.cache;
            return result2;
          }
          function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            if (!(isCommon || isCombo)) {
              return data;
            }
            if (srcBitmask & WRAP_BIND_FLAG) {
              data[2] = source[2];
              newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            var value = source[3];
            if (value) {
              var partials = data[3];
              data[3] = partials ? composeArgs(partials, value, source[4]) : value;
              data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            value = source[5];
            if (value) {
              partials = data[5];
              data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
              data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            value = source[7];
            if (value) {
              data[7] = value;
            }
            if (srcBitmask & WRAP_ARY_FLAG) {
              data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            }
            if (data[9] == null) {
              data[9] = source[9];
            }
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
          }
          function nativeKeysIn(object) {
            var result2 = [];
            if (object != null) {
              for (var key in Object2(object)) {
                result2.push(key);
              }
            }
            return result2;
          }
          function objectToString(value) {
            return nativeObjectToString.call(value);
          }
          function overRest(func, start, transform2) {
            start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
            return function() {
              var args = arguments, index2 = -1, length2 = nativeMax(args.length - start, 0), array = Array2(length2);
              while (++index2 < length2) {
                array[index2] = args[start + index2];
              }
              index2 = -1;
              var otherArgs = Array2(start + 1);
              while (++index2 < start) {
                otherArgs[index2] = args[index2];
              }
              otherArgs[start] = transform2(array);
              return apply(func, this, otherArgs);
            };
          }
          function parent(object, path3) {
            return path3.length < 2 ? object : baseGet(object, baseSlice(path3, 0, -1));
          }
          function reorder(array, indexes) {
            var arrLength = array.length, length2 = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while (length2--) {
              var index2 = indexes[length2];
              array[length2] = isIndex(index2, arrLength) ? oldArray[index2] : undefined2;
            }
            return array;
          }
          function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") {
              return;
            }
            if (key == "__proto__") {
              return;
            }
            return object[key];
          }
          var setData = shortOut(baseSetData);
          var setTimeout2 = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
          };
          var setToString = shortOut(baseSetToString);
          function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
          }
          function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
              var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
              lastCalled = stamp;
              if (remaining > 0) {
                if (++count >= HOT_COUNT) {
                  return arguments[0];
                }
              } else {
                count = 0;
              }
              return func.apply(undefined2, arguments);
            };
          }
          function shuffleSelf(array, size2) {
            var index2 = -1, length2 = array.length, lastIndex = length2 - 1;
            size2 = size2 === undefined2 ? length2 : size2;
            while (++index2 < size2) {
              var rand = baseRandom(index2, lastIndex), value = array[rand];
              array[rand] = array[index2];
              array[index2] = value;
            }
            array.length = size2;
            return array;
          }
          var stringToPath = memoizeCapped(function(string) {
            var result2 = [];
            if (string.charCodeAt(0) === 46) {
              result2.push("");
            }
            string.replace(rePropName, function(match, number2, quote, subString) {
              result2.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
            });
            return result2;
          });
          function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) {
              return value;
            }
            var result2 = value + "";
            return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
          }
          function toSource(func) {
            if (func != null) {
              try {
                return funcToString.call(func);
              } catch (e2) {
              }
              try {
                return func + "";
              } catch (e2) {
              }
            }
            return "";
          }
          function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
              var value = "_." + pair[0];
              if (bitmask & pair[1] && !arrayIncludes(details, value)) {
                details.push(value);
              }
            });
            return details.sort();
          }
          function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) {
              return wrapper.clone();
            }
            var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result2.__actions__ = copyArray(wrapper.__actions__);
            result2.__index__ = wrapper.__index__;
            result2.__values__ = wrapper.__values__;
            return result2;
          }
          function chunk(array, size2, guard) {
            if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
              size2 = 1;
            } else {
              size2 = nativeMax(toInteger(size2), 0);
            }
            var length2 = array == null ? 0 : array.length;
            if (!length2 || size2 < 1) {
              return [];
            }
            var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size2));
            while (index2 < length2) {
              result2[resIndex++] = baseSlice(array, index2, index2 += size2);
            }
            return result2;
          }
          function compact2(array) {
            var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result2 = [];
            while (++index2 < length2) {
              var value = array[index2];
              if (value) {
                result2[resIndex++] = value;
              }
            }
            return result2;
          }
          function concat2() {
            var length2 = arguments.length;
            if (!length2) {
              return [];
            }
            var args = Array2(length2 - 1), array = arguments[0], index2 = length2;
            while (index2--) {
              args[index2 - 1] = arguments[index2];
            }
            return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
          }
          var difference = baseRest(function(array, values2) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
          });
          var differenceBy = baseRest(function(array, values2) {
            var iteratee2 = last(values2);
            if (isArrayLikeObject(iteratee2)) {
              iteratee2 = undefined2;
            }
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
          });
          var differenceWith = baseRest(function(array, values2) {
            var comparator = last(values2);
            if (isArrayLikeObject(comparator)) {
              comparator = undefined2;
            }
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
          });
          function drop(array, n2, guard) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return [];
            }
            n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
            return baseSlice(array, n2 < 0 ? 0 : n2, length2);
          }
          function dropRight(array, n2, guard) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return [];
            }
            n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
            n2 = length2 - n2;
            return baseSlice(array, 0, n2 < 0 ? 0 : n2);
          }
          function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
          }
          function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
          }
          function fill(array, value, start, end) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return [];
            }
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
              start = 0;
              end = length2;
            }
            return baseFill(array, value, start, end);
          }
          function findIndex(array, predicate, fromIndex) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return -1;
            }
            var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index2 < 0) {
              index2 = nativeMax(length2 + index2, 0);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index2);
          }
          function findLastIndex(array, predicate, fromIndex) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return -1;
            }
            var index2 = length2 - 1;
            if (fromIndex !== undefined2) {
              index2 = toInteger(fromIndex);
              index2 = fromIndex < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
          }
          function flatten2(array) {
            var length2 = array == null ? 0 : array.length;
            return length2 ? baseFlatten(array, 1) : [];
          }
          function flattenDeep(array) {
            var length2 = array == null ? 0 : array.length;
            return length2 ? baseFlatten(array, INFINITY) : [];
          }
          function flattenDepth(array, depth) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return [];
            }
            depth = depth === undefined2 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
          }
          function fromPairs(pairs) {
            var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result2 = {};
            while (++index2 < length2) {
              var pair = pairs[index2];
              result2[pair[0]] = pair[1];
            }
            return result2;
          }
          function head(array) {
            return array && array.length ? array[0] : undefined2;
          }
          function indexOf(array, value, fromIndex) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return -1;
            }
            var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index2 < 0) {
              index2 = nativeMax(length2 + index2, 0);
            }
            return baseIndexOf(array, value, index2);
          }
          function initial(array) {
            var length2 = array == null ? 0 : array.length;
            return length2 ? baseSlice(array, 0, -1) : [];
          }
          var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
          });
          var intersectionBy = baseRest(function(arrays) {
            var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee2 === last(mapped)) {
              iteratee2 = undefined2;
            } else {
              mapped.pop();
            }
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
          });
          var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined2;
            if (comparator) {
              mapped.pop();
            }
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
          });
          function join3(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
          }
          function last(array) {
            var length2 = array == null ? 0 : array.length;
            return length2 ? array[length2 - 1] : undefined2;
          }
          function lastIndexOf(array, value, fromIndex) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return -1;
            }
            var index2 = length2;
            if (fromIndex !== undefined2) {
              index2 = toInteger(fromIndex);
              index2 = index2 < 0 ? nativeMax(length2 + index2, 0) : nativeMin(index2, length2 - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
          }
          function nth(array, n2) {
            return array && array.length ? baseNth(array, toInteger(n2)) : undefined2;
          }
          var pull = baseRest(pullAll);
          function pullAll(array, values2) {
            return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
          }
          function pullAllBy(array, values2, iteratee2) {
            return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
          }
          function pullAllWith(array, values2, comparator) {
            return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
          }
          var pullAt = flatRest(function(array, indexes) {
            var length2 = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index2) {
              return isIndex(index2, length2) ? +index2 : index2;
            }).sort(compareAscending));
            return result2;
          });
          function remove3(array, predicate) {
            var result2 = [];
            if (!(array && array.length)) {
              return result2;
            }
            var index2 = -1, indexes = [], length2 = array.length;
            predicate = getIteratee(predicate, 3);
            while (++index2 < length2) {
              var value = array[index2];
              if (predicate(value, index2, array)) {
                result2.push(value);
                indexes.push(index2);
              }
            }
            basePullAt(array, indexes);
            return result2;
          }
          function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
          }
          function slice(array, start, end) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return [];
            }
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
              start = 0;
              end = length2;
            } else {
              start = start == null ? 0 : toInteger(start);
              end = end === undefined2 ? length2 : toInteger(end);
            }
            return baseSlice(array, start, end);
          }
          function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
          }
          function sortedIndexBy(array, value, iteratee2) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
          }
          function sortedIndexOf(array, value) {
            var length2 = array == null ? 0 : array.length;
            if (length2) {
              var index2 = baseSortedIndex(array, value);
              if (index2 < length2 && eq(array[index2], value)) {
                return index2;
              }
            }
            return -1;
          }
          function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
          }
          function sortedLastIndexBy(array, value, iteratee2) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
          }
          function sortedLastIndexOf(array, value) {
            var length2 = array == null ? 0 : array.length;
            if (length2) {
              var index2 = baseSortedIndex(array, value, true) - 1;
              if (eq(array[index2], value)) {
                return index2;
              }
            }
            return -1;
          }
          function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
          }
          function sortedUniqBy(array, iteratee2) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
          }
          function tail(array) {
            var length2 = array == null ? 0 : array.length;
            return length2 ? baseSlice(array, 1, length2) : [];
          }
          function take(array, n2, guard) {
            if (!(array && array.length)) {
              return [];
            }
            n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
            return baseSlice(array, 0, n2 < 0 ? 0 : n2);
          }
          function takeRight(array, n2, guard) {
            var length2 = array == null ? 0 : array.length;
            if (!length2) {
              return [];
            }
            n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
            n2 = length2 - n2;
            return baseSlice(array, n2 < 0 ? 0 : n2, length2);
          }
          function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
          }
          function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
          }
          var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
          });
          var unionBy = baseRest(function(arrays) {
            var iteratee2 = last(arrays);
            if (isArrayLikeObject(iteratee2)) {
              iteratee2 = undefined2;
            }
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
          });
          var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined2;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
          });
          function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
          }
          function uniqBy(array, iteratee2) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
          }
          function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined2;
            return array && array.length ? baseUniq(array, undefined2, comparator) : [];
          }
          function unzip(array) {
            if (!(array && array.length)) {
              return [];
            }
            var length2 = 0;
            array = arrayFilter(array, function(group) {
              if (isArrayLikeObject(group)) {
                length2 = nativeMax(group.length, length2);
                return true;
              }
            });
            return baseTimes(length2, function(index2) {
              return arrayMap(array, baseProperty(index2));
            });
          }
          function unzipWith(array, iteratee2) {
            if (!(array && array.length)) {
              return [];
            }
            var result2 = unzip(array);
            if (iteratee2 == null) {
              return result2;
            }
            return arrayMap(result2, function(group) {
              return apply(iteratee2, undefined2, group);
            });
          }
          var without = baseRest(function(array, values2) {
            return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
          });
          var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
          });
          var xorBy = baseRest(function(arrays) {
            var iteratee2 = last(arrays);
            if (isArrayLikeObject(iteratee2)) {
              iteratee2 = undefined2;
            }
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
          });
          var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined2;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
          });
          var zip = baseRest(unzip);
          function zipObject(props, values2) {
            return baseZipObject(props || [], values2 || [], assignValue);
          }
          function zipObjectDeep(props, values2) {
            return baseZipObject(props || [], values2 || [], baseSet);
          }
          var zipWith = baseRest(function(arrays) {
            var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined2;
            iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
            return unzipWith(arrays, iteratee2);
          });
          function chain(value) {
            var result2 = lodash(value);
            result2.__chain__ = true;
            return result2;
          }
          function tap(value, interceptor) {
            interceptor(value);
            return value;
          }
          function thru(value, interceptor) {
            return interceptor(value);
          }
          var wrapperAt = flatRest(function(paths) {
            var length2 = paths.length, start = length2 ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
              return baseAt(object, paths);
            };
            if (length2 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
              return this.thru(interceptor);
            }
            value = value.slice(start, +start + (length2 ? 1 : 0));
            value.__actions__.push({
              "func": thru,
              "args": [interceptor],
              "thisArg": undefined2
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
              if (length2 && !array.length) {
                array.push(undefined2);
              }
              return array;
            });
          });
          function wrapperChain() {
            return chain(this);
          }
          function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
          }
          function wrapperNext() {
            if (this.__values__ === undefined2) {
              this.__values__ = toArray2(this.value());
            }
            var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
            return { "done": done, "value": value };
          }
          function wrapperToIterator() {
            return this;
          }
          function wrapperPlant(value) {
            var result2, parent2 = this;
            while (parent2 instanceof baseLodash) {
              var clone2 = wrapperClone(parent2);
              clone2.__index__ = 0;
              clone2.__values__ = undefined2;
              if (result2) {
                previous.__wrapped__ = clone2;
              } else {
                result2 = clone2;
              }
              var previous = clone2;
              parent2 = parent2.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result2;
          }
          function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
              var wrapped = value;
              if (this.__actions__.length) {
                wrapped = new LazyWrapper(this);
              }
              wrapped = wrapped.reverse();
              wrapped.__actions__.push({
                "func": thru,
                "args": [reverse],
                "thisArg": undefined2
              });
              return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
          }
          function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
          }
          var countBy = createAggregator(function(result2, value, key) {
            if (hasOwnProperty2.call(result2, key)) {
              ++result2[key];
            } else {
              baseAssignValue(result2, key, 1);
            }
          });
          function every(collection, predicate, guard) {
            var func = isArray2(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) {
              predicate = undefined2;
            }
            return func(collection, getIteratee(predicate, 3));
          }
          function filter2(collection, predicate) {
            var func = isArray2(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
          }
          var find = createFind(findIndex);
          var findLast = createFind(findLastIndex);
          function flatMap(collection, iteratee2) {
            return baseFlatten(map(collection, iteratee2), 1);
          }
          function flatMapDeep(collection, iteratee2) {
            return baseFlatten(map(collection, iteratee2), INFINITY);
          }
          function flatMapDepth(collection, iteratee2, depth) {
            depth = depth === undefined2 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee2), depth);
          }
          function forEach2(collection, iteratee2) {
            var func = isArray2(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee2, 3));
          }
          function forEachRight(collection, iteratee2) {
            var func = isArray2(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee2, 3));
          }
          var groupBy = createAggregator(function(result2, value, key) {
            if (hasOwnProperty2.call(result2, key)) {
              result2[key].push(value);
            } else {
              baseAssignValue(result2, key, [value]);
            }
          });
          function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length2 = collection.length;
            if (fromIndex < 0) {
              fromIndex = nativeMax(length2 + fromIndex, 0);
            }
            return isString3(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value, fromIndex) > -1;
          }
          var invokeMap = baseRest(function(collection, path3, args) {
            var index2 = -1, isFunc = typeof path3 == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
            baseEach(collection, function(value) {
              result2[++index2] = isFunc ? apply(path3, value, args) : baseInvoke(value, path3, args);
            });
            return result2;
          });
          var keyBy = createAggregator(function(result2, value, key) {
            baseAssignValue(result2, key, value);
          });
          function map(collection, iteratee2) {
            var func = isArray2(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee2, 3));
          }
          function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) {
              return [];
            }
            if (!isArray2(iteratees)) {
              iteratees = iteratees == null ? [] : [iteratees];
            }
            orders = guard ? undefined2 : orders;
            if (!isArray2(orders)) {
              orders = orders == null ? [] : [orders];
            }
            return baseOrderBy(collection, iteratees, orders);
          }
          var partition = createAggregator(function(result2, value, key) {
            result2[key ? 0 : 1].push(value);
          }, function() {
            return [[], []];
          });
          function reduce(collection, iteratee2, accumulator) {
            var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
          }
          function reduceRight(collection, iteratee2, accumulator) {
            var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
          }
          function reject(collection, predicate) {
            var func = isArray2(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
          }
          function sample(collection) {
            var func = isArray2(collection) ? arraySample : baseSample;
            return func(collection);
          }
          function sampleSize(collection, n2, guard) {
            if (guard ? isIterateeCall(collection, n2, guard) : n2 === undefined2) {
              n2 = 1;
            } else {
              n2 = toInteger(n2);
            }
            var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n2);
          }
          function shuffle(collection) {
            var func = isArray2(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
          }
          function size(collection) {
            if (collection == null) {
              return 0;
            }
            if (isArrayLike(collection)) {
              return isString3(collection) ? stringSize(collection) : collection.length;
            }
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) {
              return collection.size;
            }
            return baseKeys(collection).length;
          }
          function some(collection, predicate, guard) {
            var func = isArray2(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) {
              predicate = undefined2;
            }
            return func(collection, getIteratee(predicate, 3));
          }
          var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) {
              return [];
            }
            var length2 = iteratees.length;
            if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
              iteratees = [];
            } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
              iteratees = [iteratees[0]];
            }
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
          });
          var now = ctxNow || function() {
            return root.Date.now();
          };
          function after(n2, func) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            n2 = toInteger(n2);
            return function() {
              if (--n2 < 1) {
                return func.apply(this, arguments);
              }
            };
          }
          function ary(func, n2, guard) {
            n2 = guard ? undefined2 : n2;
            n2 = func && n2 == null ? func.length : n2;
            return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n2);
          }
          function before(n2, func) {
            var result2;
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            n2 = toInteger(n2);
            return function() {
              if (--n2 > 0) {
                result2 = func.apply(this, arguments);
              }
              if (n2 <= 1) {
                func = undefined2;
              }
              return result2;
            };
          }
          var bind2 = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
              var holders = replaceHolders(partials, getHolder(bind2));
              bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
          });
          var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
              var holders = replaceHolders(partials, getHolder(bindKey));
              bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
          });
          function curry(func, arity, guard) {
            arity = guard ? undefined2 : arity;
            var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
            result2.placeholder = curry.placeholder;
            return result2;
          }
          function curryRight(func, arity, guard) {
            arity = guard ? undefined2 : arity;
            var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
            result2.placeholder = curryRight.placeholder;
            return result2;
          }
          function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            wait = toNumber3(wait) || 0;
            if (isObject3(options)) {
              leading = !!options.leading;
              maxing = "maxWait" in options;
              maxWait = maxing ? nativeMax(toNumber3(options.maxWait) || 0, wait) : maxWait;
              trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
              var args = lastArgs, thisArg = lastThis;
              lastArgs = lastThis = undefined2;
              lastInvokeTime = time;
              result2 = func.apply(thisArg, args);
              return result2;
            }
            function leadingEdge(time) {
              lastInvokeTime = time;
              timerId = setTimeout2(timerExpired, wait);
              return leading ? invokeFunc(time) : result2;
            }
            function remainingWait(time) {
              var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
              return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
              var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
              return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
              var time = now();
              if (shouldInvoke(time)) {
                return trailingEdge(time);
              }
              timerId = setTimeout2(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
              timerId = undefined2;
              if (trailing && lastArgs) {
                return invokeFunc(time);
              }
              lastArgs = lastThis = undefined2;
              return result2;
            }
            function cancel() {
              if (timerId !== undefined2) {
                clearTimeout2(timerId);
              }
              lastInvokeTime = 0;
              lastArgs = lastCallTime = lastThis = timerId = undefined2;
            }
            function flush() {
              return timerId === undefined2 ? result2 : trailingEdge(now());
            }
            function debounced() {
              var time = now(), isInvoking = shouldInvoke(time);
              lastArgs = arguments;
              lastThis = this;
              lastCallTime = time;
              if (isInvoking) {
                if (timerId === undefined2) {
                  return leadingEdge(lastCallTime);
                }
                if (maxing) {
                  clearTimeout2(timerId);
                  timerId = setTimeout2(timerExpired, wait);
                  return invokeFunc(lastCallTime);
                }
              }
              if (timerId === undefined2) {
                timerId = setTimeout2(timerExpired, wait);
              }
              return result2;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
          }
          var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
          });
          var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber3(wait) || 0, args);
          });
          function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
          }
          function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            var memoized = function() {
              var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
              if (cache2.has(key)) {
                return cache2.get(key);
              }
              var result2 = func.apply(this, args);
              memoized.cache = cache2.set(key, result2) || cache2;
              return result2;
            };
            memoized.cache = new (memoize.Cache || MapCache)();
            return memoized;
          }
          memoize.Cache = MapCache;
          function negate(predicate) {
            if (typeof predicate != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return function() {
              var args = arguments;
              switch (args.length) {
                case 0:
                  return !predicate.call(this);
                case 1:
                  return !predicate.call(this, args[0]);
                case 2:
                  return !predicate.call(this, args[0], args[1]);
                case 3:
                  return !predicate.call(this, args[0], args[1], args[2]);
              }
              return !predicate.apply(this, args);
            };
          }
          function once(func) {
            return before(2, func);
          }
          var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
              var index2 = -1, length2 = nativeMin(args.length, funcsLength);
              while (++index2 < length2) {
                args[index2] = transforms[index2].call(this, args[index2]);
              }
              return apply(func, this, args);
            });
          });
          var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
          });
          var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
          });
          var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
          });
          function rest(func, start) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            start = start === undefined2 ? start : toInteger(start);
            return baseRest(func, start);
          }
          function spread3(func, start) {
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
              var array = args[start], otherArgs = castSlice(args, 0, start);
              if (array) {
                arrayPush(otherArgs, array);
              }
              return apply(func, this, otherArgs);
            });
          }
          function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (isObject3(options)) {
              leading = "leading" in options ? !!options.leading : leading;
              trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
              "leading": leading,
              "maxWait": wait,
              "trailing": trailing
            });
          }
          function unary(func) {
            return ary(func, 1);
          }
          function wrap2(value, wrapper) {
            return partial(castFunction(wrapper), value);
          }
          function castArray() {
            if (!arguments.length) {
              return [];
            }
            var value = arguments[0];
            return isArray2(value) ? value : [value];
          }
          function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
          }
          function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
          }
          function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
          }
          function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
          }
          function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
          }
          function eq(value, other) {
            return value === other || value !== value && other !== other;
          }
          var gt = createRelationalOperation(baseGt);
          var gte = createRelationalOperation(function(value, other) {
            return value >= other;
          });
          var isArguments = baseIsArguments(/* @__PURE__ */ function() {
            return arguments;
          }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
          };
          var isArray2 = Array2.isArray;
          var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
          function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction2(value);
          }
          function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
          }
          function isBoolean3(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
          }
          var isBuffer2 = nativeIsBuffer || stubFalse;
          var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
          function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject3(value);
          }
          function isEmpty(value) {
            if (value == null) {
              return true;
            }
            if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments(value))) {
              return !value.length;
            }
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) {
              return !value.size;
            }
            if (isPrototype(value)) {
              return !baseKeys(value).length;
            }
            for (var key in value) {
              if (hasOwnProperty2.call(value, key)) {
                return false;
              }
            }
            return true;
          }
          function isEqual(value, other) {
            return baseIsEqual(value, other);
          }
          function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            var result2 = customizer ? customizer(value, other) : undefined2;
            return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
          }
          function isError(value) {
            if (!isObjectLike(value)) {
              return false;
            }
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject3(value);
          }
          function isFinite2(value) {
            return typeof value == "number" && nativeIsFinite(value);
          }
          function isFunction2(value) {
            if (!isObject3(value)) {
              return false;
            }
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
          }
          function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
          }
          function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
          }
          function isObject3(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
          }
          function isObjectLike(value) {
            return value != null && typeof value == "object";
          }
          var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
          function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
          }
          function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return baseIsMatch(object, source, getMatchData(source), customizer);
          }
          function isNaN2(value) {
            return isNumber3(value) && value != +value;
          }
          function isNative(value) {
            if (isMaskable(value)) {
              throw new Error2(CORE_ERROR_TEXT);
            }
            return baseIsNative(value);
          }
          function isNull(value) {
            return value === null;
          }
          function isNil(value) {
            return value == null;
          }
          function isNumber3(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
          }
          function isPlainObject3(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
              return false;
            }
            var proto2 = getPrototype(value);
            if (proto2 === null) {
              return true;
            }
            var Ctor = hasOwnProperty2.call(proto2, "constructor") && proto2.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
          }
          var isRegExp2 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
          function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
          }
          var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
          function isString3(value) {
            return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
          }
          function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
          }
          var isTypedArray2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
          function isUndefined2(value) {
            return value === undefined2;
          }
          function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
          }
          function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
          }
          var lt = createRelationalOperation(baseLt);
          var lte = createRelationalOperation(function(value, other) {
            return value <= other;
          });
          function toArray2(value) {
            if (!value) {
              return [];
            }
            if (isArrayLike(value)) {
              return isString3(value) ? stringToArray(value) : copyArray(value);
            }
            if (symIterator && value[symIterator]) {
              return iteratorToArray(value[symIterator]());
            }
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
          }
          function toFinite(value) {
            if (!value) {
              return value === 0 ? value : 0;
            }
            value = toNumber3(value);
            if (value === INFINITY || value === -INFINITY) {
              var sign6 = value < 0 ? -1 : 1;
              return sign6 * MAX_INTEGER2;
            }
            return value === value ? value : 0;
          }
          function toInteger(value) {
            var result2 = toFinite(value), remainder = result2 % 1;
            return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
          }
          function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
          }
          function toNumber3(value) {
            if (typeof value == "number") {
              return value;
            }
            if (isSymbol(value)) {
              return NAN;
            }
            if (isObject3(value)) {
              var other = typeof value.valueOf == "function" ? value.valueOf() : value;
              value = isObject3(other) ? other + "" : other;
            }
            if (typeof value != "string") {
              return value === 0 ? value : +value;
            }
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
          }
          function toPlainObject(value) {
            return copyObject(value, keysIn(value));
          }
          function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
          }
          function toString3(value) {
            return value == null ? "" : baseToString(value);
          }
          var assign2 = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
              copyObject(source, keys(source), object);
              return;
            }
            for (var key in source) {
              if (hasOwnProperty2.call(source, key)) {
                assignValue(object, key, source[key]);
              }
            }
          });
          var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
          });
          var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
          });
          var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
          });
          var at = flatRest(baseAt);
          function create2(prototype3, properties) {
            var result2 = baseCreate(prototype3);
            return properties == null ? result2 : baseAssign(result2, properties);
          }
          var defaults3 = baseRest(function(object, sources) {
            object = Object2(object);
            var index2 = -1;
            var length2 = sources.length;
            var guard = length2 > 2 ? sources[2] : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              length2 = 1;
            }
            while (++index2 < length2) {
              var source = sources[index2];
              var props = keysIn(source);
              var propsIndex = -1;
              var propsLength = props.length;
              while (++propsIndex < propsLength) {
                var key = props[propsIndex];
                var value = object[key];
                if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
                  object[key] = source[key];
                }
              }
            }
            return object;
          });
          var defaultsDeep = baseRest(function(args) {
            args.push(undefined2, customDefaultsMerge);
            return apply(mergeWith, undefined2, args);
          });
          function findKey2(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
          }
          function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
          }
          function forIn(object, iteratee2) {
            return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
          }
          function forInRight(object, iteratee2) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
          }
          function forOwn(object, iteratee2) {
            return object && baseForOwn(object, getIteratee(iteratee2, 3));
          }
          function forOwnRight(object, iteratee2) {
            return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
          }
          function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
          }
          function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
          }
          function get4(object, path3, defaultValue) {
            var result2 = object == null ? undefined2 : baseGet(object, path3);
            return result2 === undefined2 ? defaultValue : result2;
          }
          function has(object, path3) {
            return object != null && hasPath(object, path3, baseHas);
          }
          function hasIn(object, path3) {
            return object != null && hasPath(object, path3, baseHasIn);
          }
          var invert2 = createInverter(function(result2, value, key) {
            if (value != null && typeof value.toString != "function") {
              value = nativeObjectToString.call(value);
            }
            result2[value] = key;
          }, constant(identity));
          var invertBy = createInverter(function(result2, value, key) {
            if (value != null && typeof value.toString != "function") {
              value = nativeObjectToString.call(value);
            }
            if (hasOwnProperty2.call(result2, value)) {
              result2[value].push(key);
            } else {
              result2[value] = [key];
            }
          }, getIteratee);
          var invoke = baseRest(baseInvoke);
          function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
          }
          function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
          }
          function mapKeys(object, iteratee2) {
            var result2 = {};
            iteratee2 = getIteratee(iteratee2, 3);
            baseForOwn(object, function(value, key, object2) {
              baseAssignValue(result2, iteratee2(value, key, object2), value);
            });
            return result2;
          }
          function mapValues(object, iteratee2) {
            var result2 = {};
            iteratee2 = getIteratee(iteratee2, 3);
            baseForOwn(object, function(value, key, object2) {
              baseAssignValue(result2, key, iteratee2(value, key, object2));
            });
            return result2;
          }
          var merge3 = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
          });
          var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
          });
          var omit3 = flatRest(function(object, paths) {
            var result2 = {};
            if (object == null) {
              return result2;
            }
            var isDeep = false;
            paths = arrayMap(paths, function(path3) {
              path3 = castPath(path3, object);
              isDeep || (isDeep = path3.length > 1);
              return path3;
            });
            copyObject(object, getAllKeysIn(object), result2);
            if (isDeep) {
              result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            }
            var length2 = paths.length;
            while (length2--) {
              baseUnset(result2, paths[length2]);
            }
            return result2;
          });
          function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
          }
          var pick3 = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
          });
          function pickBy(object, predicate) {
            if (object == null) {
              return {};
            }
            var props = arrayMap(getAllKeysIn(object), function(prop) {
              return [prop];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path3) {
              return predicate(value, path3[0]);
            });
          }
          function result(object, path3, defaultValue) {
            path3 = castPath(path3, object);
            var index2 = -1, length2 = path3.length;
            if (!length2) {
              length2 = 1;
              object = undefined2;
            }
            while (++index2 < length2) {
              var value = object == null ? undefined2 : object[toKey(path3[index2])];
              if (value === undefined2) {
                index2 = length2;
                value = defaultValue;
              }
              object = isFunction2(value) ? value.call(object) : value;
            }
            return object;
          }
          function set4(object, path3, value) {
            return object == null ? object : baseSet(object, path3, value);
          }
          function setWith(object, path3, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return object == null ? object : baseSet(object, path3, value, customizer);
          }
          var toPairs = createToPairs(keys);
          var toPairsIn = createToPairs(keysIn);
          function transform(object, iteratee2, accumulator) {
            var isArr = isArray2(object), isArrLike = isArr || isBuffer2(object) || isTypedArray2(object);
            iteratee2 = getIteratee(iteratee2, 4);
            if (accumulator == null) {
              var Ctor = object && object.constructor;
              if (isArrLike) {
                accumulator = isArr ? new Ctor() : [];
              } else if (isObject3(object)) {
                accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object)) : {};
              } else {
                accumulator = {};
              }
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
              return iteratee2(accumulator, value, index2, object2);
            });
            return accumulator;
          }
          function unset(object, path3) {
            return object == null ? true : baseUnset(object, path3);
          }
          function update(object, path3, updater) {
            return object == null ? object : baseUpdate(object, path3, castFunction(updater));
          }
          function updateWith(object, path3, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined2;
            return object == null ? object : baseUpdate(object, path3, castFunction(updater), customizer);
          }
          function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
          }
          function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
          }
          function clamp(number2, lower, upper) {
            if (upper === undefined2) {
              upper = lower;
              lower = undefined2;
            }
            if (upper !== undefined2) {
              upper = toNumber3(upper);
              upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined2) {
              lower = toNumber3(lower);
              lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber3(number2), lower, upper);
          }
          function inRange(number2, start, end) {
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            number2 = toNumber3(number2);
            return baseInRange(number2, start, end);
          }
          function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
              upper = floating = undefined2;
            }
            if (floating === undefined2) {
              if (typeof upper == "boolean") {
                floating = upper;
                upper = undefined2;
              } else if (typeof lower == "boolean") {
                floating = lower;
                lower = undefined2;
              }
            }
            if (lower === undefined2 && upper === undefined2) {
              lower = 0;
              upper = 1;
            } else {
              lower = toFinite(lower);
              if (upper === undefined2) {
                upper = lower;
                lower = 0;
              } else {
                upper = toFinite(upper);
              }
            }
            if (lower > upper) {
              var temp = lower;
              lower = upper;
              upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
              var rand = nativeRandom();
              return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
          }
          var camelCase = createCompounder(function(result2, word, index2) {
            word = word.toLowerCase();
            return result2 + (index2 ? capitalize2(word) : word);
          });
          function capitalize2(string) {
            return upperFirst(toString3(string).toLowerCase());
          }
          function deburr(string) {
            string = toString3(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
          }
          function endsWith2(string, target, position) {
            string = toString3(string);
            target = baseToString(target);
            var length2 = string.length;
            position = position === undefined2 ? length2 : baseClamp(toInteger(position), 0, length2);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
          }
          function escape2(string) {
            string = toString3(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
          }
          function escapeRegExp(string) {
            string = toString3(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
          }
          var kebabCase = createCompounder(function(result2, word, index2) {
            return result2 + (index2 ? "-" : "") + word.toLowerCase();
          });
          var lowerCase = createCompounder(function(result2, word, index2) {
            return result2 + (index2 ? " " : "") + word.toLowerCase();
          });
          var lowerFirst = createCaseFirst("toLowerCase");
          function pad(string, length2, chars) {
            string = toString3(string);
            length2 = toInteger(length2);
            var strLength = length2 ? stringSize(string) : 0;
            if (!length2 || strLength >= length2) {
              return string;
            }
            var mid = (length2 - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
          }
          function padEnd(string, length2, chars) {
            string = toString3(string);
            length2 = toInteger(length2);
            var strLength = length2 ? stringSize(string) : 0;
            return length2 && strLength < length2 ? string + createPadding(length2 - strLength, chars) : string;
          }
          function padStart(string, length2, chars) {
            string = toString3(string);
            length2 = toInteger(length2);
            var strLength = length2 ? stringSize(string) : 0;
            return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string : string;
          }
          function parseInt2(string, radix, guard) {
            if (guard || radix == null) {
              radix = 0;
            } else if (radix) {
              radix = +radix;
            }
            return nativeParseInt(toString3(string).replace(reTrimStart, ""), radix || 0);
          }
          function repeat(string, n2, guard) {
            if (guard ? isIterateeCall(string, n2, guard) : n2 === undefined2) {
              n2 = 1;
            } else {
              n2 = toInteger(n2);
            }
            return baseRepeat(toString3(string), n2);
          }
          function replace2() {
            var args = arguments, string = toString3(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
          }
          var snakeCase = createCompounder(function(result2, word, index2) {
            return result2 + (index2 ? "_" : "") + word.toLowerCase();
          });
          function split3(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
              separator = limit = undefined2;
            }
            limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) {
              return [];
            }
            string = toString3(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp2(separator))) {
              separator = baseToString(separator);
              if (!separator && hasUnicode(string)) {
                return castSlice(stringToArray(string), 0, limit);
              }
            }
            return string.split(separator, limit);
          }
          var startCase = createCompounder(function(result2, word, index2) {
            return result2 + (index2 ? " " : "") + upperFirst(word);
          });
          function startsWith(string, target, position) {
            string = toString3(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
          }
          function template(string, options, guard) {
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) {
              options = undefined2;
            }
            string = toString3(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            var reDelimiters = RegExp2(
              (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
              "g"
            );
            var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
              interpolateValue || (interpolateValue = esTemplateValue);
              source += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
              if (escapeValue) {
                isEscaping = true;
                source += "' +\n__e(" + escapeValue + ") +\n'";
              }
              if (evaluateValue) {
                isEvaluating = true;
                source += "';\n" + evaluateValue + ";\n__p += '";
              }
              if (interpolateValue) {
                source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
              }
              index2 = offset + match.length;
              return match;
            });
            source += "';\n";
            var variable = hasOwnProperty2.call(options, "variable") && options.variable;
            if (!variable) {
              source = "with (obj) {\n" + source + "\n}\n";
            } else if (reForbiddenIdentifierChars.test(variable)) {
              throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
            }
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result2 = attempt(function() {
              return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
            });
            result2.source = source;
            if (isError(result2)) {
              throw result2;
            }
            return result2;
          }
          function toLower(value) {
            return toString3(value).toLowerCase();
          }
          function toUpper(value) {
            return toString3(value).toUpperCase();
          }
          function trim2(string, chars, guard) {
            string = toString3(string);
            if (string && (guard || chars === undefined2)) {
              return baseTrim(string);
            }
            if (!string || !(chars = baseToString(chars))) {
              return string;
            }
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
          }
          function trimEnd(string, chars, guard) {
            string = toString3(string);
            if (string && (guard || chars === undefined2)) {
              return string.slice(0, trimmedEndIndex(string) + 1);
            }
            if (!string || !(chars = baseToString(chars))) {
              return string;
            }
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
          }
          function trimStart(string, chars, guard) {
            string = toString3(string);
            if (string && (guard || chars === undefined2)) {
              return string.replace(reTrimStart, "");
            }
            if (!string || !(chars = baseToString(chars))) {
              return string;
            }
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
          }
          function truncate3(string, options) {
            var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject3(options)) {
              var separator = "separator" in options ? options.separator : separator;
              length2 = "length" in options ? toInteger(options.length) : length2;
              omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString3(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
              var strSymbols = stringToArray(string);
              strLength = strSymbols.length;
            }
            if (length2 >= strLength) {
              return string;
            }
            var end = length2 - stringSize(omission);
            if (end < 1) {
              return omission;
            }
            var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined2) {
              return result2 + omission;
            }
            if (strSymbols) {
              end += result2.length - end;
            }
            if (isRegExp2(separator)) {
              if (string.slice(end).search(separator)) {
                var match, substring = result2;
                if (!separator.global) {
                  separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
                }
                separator.lastIndex = 0;
                while (match = separator.exec(substring)) {
                  var newEnd = match.index;
                }
                result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
              }
            } else if (string.indexOf(baseToString(separator), end) != end) {
              var index2 = result2.lastIndexOf(separator);
              if (index2 > -1) {
                result2 = result2.slice(0, index2);
              }
            }
            return result2 + omission;
          }
          function unescape2(string) {
            string = toString3(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
          }
          var upperCase = createCompounder(function(result2, word, index2) {
            return result2 + (index2 ? " " : "") + word.toUpperCase();
          });
          var upperFirst = createCaseFirst("toUpperCase");
          function words(string, pattern2, guard) {
            string = toString3(string);
            pattern2 = guard ? undefined2 : pattern2;
            if (pattern2 === undefined2) {
              return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            }
            return string.match(pattern2) || [];
          }
          var attempt = baseRest(function(func, args) {
            try {
              return apply(func, undefined2, args);
            } catch (e2) {
              return isError(e2) ? e2 : new Error2(e2);
            }
          });
          var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
              key = toKey(key);
              baseAssignValue(object, key, bind2(object[key], object));
            });
            return object;
          });
          function cond(pairs) {
            var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length2 ? [] : arrayMap(pairs, function(pair) {
              if (typeof pair[1] != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              return [toIteratee(pair[0]), pair[1]];
            });
            return baseRest(function(args) {
              var index2 = -1;
              while (++index2 < length2) {
                var pair = pairs[index2];
                if (apply(pair[0], this, args)) {
                  return apply(pair[1], this, args);
                }
              }
            });
          }
          function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
          }
          function constant(value) {
            return function() {
              return value;
            };
          }
          function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
          }
          var flow = createFlow();
          var flowRight = createFlow(true);
          function identity(value) {
            return value;
          }
          function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
          }
          function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
          }
          function matchesProperty(path3, srcValue) {
            return baseMatchesProperty(path3, baseClone(srcValue, CLONE_DEEP_FLAG));
          }
          var method = baseRest(function(path3, args) {
            return function(object) {
              return baseInvoke(object, path3, args);
            };
          });
          var methodOf = baseRest(function(object, args) {
            return function(path3) {
              return baseInvoke(object, path3, args);
            };
          });
          function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject3(source) && (methodNames.length || !props.length))) {
              options = source;
              source = object;
              object = this;
              methodNames = baseFunctions(source, keys(source));
            }
            var chain2 = !(isObject3(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
            arrayEach(methodNames, function(methodName) {
              var func = source[methodName];
              object[methodName] = func;
              if (isFunc) {
                object.prototype[methodName] = function() {
                  var chainAll = this.__chain__;
                  if (chain2 || chainAll) {
                    var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                    actions.push({ "func": func, "args": arguments, "thisArg": object });
                    result2.__chain__ = chainAll;
                    return result2;
                  }
                  return func.apply(object, arrayPush([this.value()], arguments));
                };
              }
            });
            return object;
          }
          function noConflict() {
            if (root._ === this) {
              root._ = oldDash;
            }
            return this;
          }
          function noop2() {
          }
          function nthArg(n2) {
            n2 = toInteger(n2);
            return baseRest(function(args) {
              return baseNth(args, n2);
            });
          }
          var over = createOver(arrayMap);
          var overEvery = createOver(arrayEvery);
          var overSome = createOver(arraySome);
          function property(path3) {
            return isKey(path3) ? baseProperty(toKey(path3)) : basePropertyDeep(path3);
          }
          function propertyOf(object) {
            return function(path3) {
              return object == null ? undefined2 : baseGet(object, path3);
            };
          }
          var range = createRange();
          var rangeRight = createRange(true);
          function stubArray() {
            return [];
          }
          function stubFalse() {
            return false;
          }
          function stubObject() {
            return {};
          }
          function stubString() {
            return "";
          }
          function stubTrue() {
            return true;
          }
          function times(n2, iteratee2) {
            n2 = toInteger(n2);
            if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
              return [];
            }
            var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin(n2, MAX_ARRAY_LENGTH);
            iteratee2 = getIteratee(iteratee2);
            n2 -= MAX_ARRAY_LENGTH;
            var result2 = baseTimes(length2, iteratee2);
            while (++index2 < n2) {
              iteratee2(index2);
            }
            return result2;
          }
          function toPath(value) {
            if (isArray2(value)) {
              return arrayMap(value, toKey);
            }
            return isSymbol(value) ? [value] : copyArray(stringToPath(toString3(value)));
          }
          function uniqueId(prefix) {
            var id = ++idCounter;
            return toString3(prefix) + id;
          }
          var add2 = createMathOperation(function(augend, addend) {
            return augend + addend;
          }, 0);
          var ceil = createRound("ceil");
          var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
          }, 1);
          var floor = createRound("floor");
          function max2(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
          }
          function maxBy(array, iteratee2) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
          }
          function mean(array) {
            return baseMean(array, identity);
          }
          function meanBy(array, iteratee2) {
            return baseMean(array, getIteratee(iteratee2, 2));
          }
          function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
          }
          function minBy(array, iteratee2) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
          }
          var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
          }, 1);
          var round = createRound("round");
          var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
          }, 0);
          function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
          }
          function sumBy(array, iteratee2) {
            return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
          }
          lodash.after = after;
          lodash.ary = ary;
          lodash.assign = assign2;
          lodash.assignIn = assignIn;
          lodash.assignInWith = assignInWith;
          lodash.assignWith = assignWith;
          lodash.at = at;
          lodash.before = before;
          lodash.bind = bind2;
          lodash.bindAll = bindAll;
          lodash.bindKey = bindKey;
          lodash.castArray = castArray;
          lodash.chain = chain;
          lodash.chunk = chunk;
          lodash.compact = compact2;
          lodash.concat = concat2;
          lodash.cond = cond;
          lodash.conforms = conforms;
          lodash.constant = constant;
          lodash.countBy = countBy;
          lodash.create = create2;
          lodash.curry = curry;
          lodash.curryRight = curryRight;
          lodash.debounce = debounce;
          lodash.defaults = defaults3;
          lodash.defaultsDeep = defaultsDeep;
          lodash.defer = defer;
          lodash.delay = delay;
          lodash.difference = difference;
          lodash.differenceBy = differenceBy;
          lodash.differenceWith = differenceWith;
          lodash.drop = drop;
          lodash.dropRight = dropRight;
          lodash.dropRightWhile = dropRightWhile;
          lodash.dropWhile = dropWhile;
          lodash.fill = fill;
          lodash.filter = filter2;
          lodash.flatMap = flatMap;
          lodash.flatMapDeep = flatMapDeep;
          lodash.flatMapDepth = flatMapDepth;
          lodash.flatten = flatten2;
          lodash.flattenDeep = flattenDeep;
          lodash.flattenDepth = flattenDepth;
          lodash.flip = flip;
          lodash.flow = flow;
          lodash.flowRight = flowRight;
          lodash.fromPairs = fromPairs;
          lodash.functions = functions;
          lodash.functionsIn = functionsIn;
          lodash.groupBy = groupBy;
          lodash.initial = initial;
          lodash.intersection = intersection;
          lodash.intersectionBy = intersectionBy;
          lodash.intersectionWith = intersectionWith;
          lodash.invert = invert2;
          lodash.invertBy = invertBy;
          lodash.invokeMap = invokeMap;
          lodash.iteratee = iteratee;
          lodash.keyBy = keyBy;
          lodash.keys = keys;
          lodash.keysIn = keysIn;
          lodash.map = map;
          lodash.mapKeys = mapKeys;
          lodash.mapValues = mapValues;
          lodash.matches = matches;
          lodash.matchesProperty = matchesProperty;
          lodash.memoize = memoize;
          lodash.merge = merge3;
          lodash.mergeWith = mergeWith;
          lodash.method = method;
          lodash.methodOf = methodOf;
          lodash.mixin = mixin;
          lodash.negate = negate;
          lodash.nthArg = nthArg;
          lodash.omit = omit3;
          lodash.omitBy = omitBy;
          lodash.once = once;
          lodash.orderBy = orderBy;
          lodash.over = over;
          lodash.overArgs = overArgs;
          lodash.overEvery = overEvery;
          lodash.overSome = overSome;
          lodash.partial = partial;
          lodash.partialRight = partialRight;
          lodash.partition = partition;
          lodash.pick = pick3;
          lodash.pickBy = pickBy;
          lodash.property = property;
          lodash.propertyOf = propertyOf;
          lodash.pull = pull;
          lodash.pullAll = pullAll;
          lodash.pullAllBy = pullAllBy;
          lodash.pullAllWith = pullAllWith;
          lodash.pullAt = pullAt;
          lodash.range = range;
          lodash.rangeRight = rangeRight;
          lodash.rearg = rearg;
          lodash.reject = reject;
          lodash.remove = remove3;
          lodash.rest = rest;
          lodash.reverse = reverse;
          lodash.sampleSize = sampleSize;
          lodash.set = set4;
          lodash.setWith = setWith;
          lodash.shuffle = shuffle;
          lodash.slice = slice;
          lodash.sortBy = sortBy;
          lodash.sortedUniq = sortedUniq;
          lodash.sortedUniqBy = sortedUniqBy;
          lodash.split = split3;
          lodash.spread = spread3;
          lodash.tail = tail;
          lodash.take = take;
          lodash.takeRight = takeRight;
          lodash.takeRightWhile = takeRightWhile;
          lodash.takeWhile = takeWhile;
          lodash.tap = tap;
          lodash.throttle = throttle;
          lodash.thru = thru;
          lodash.toArray = toArray2;
          lodash.toPairs = toPairs;
          lodash.toPairsIn = toPairsIn;
          lodash.toPath = toPath;
          lodash.toPlainObject = toPlainObject;
          lodash.transform = transform;
          lodash.unary = unary;
          lodash.union = union;
          lodash.unionBy = unionBy;
          lodash.unionWith = unionWith;
          lodash.uniq = uniq;
          lodash.uniqBy = uniqBy;
          lodash.uniqWith = uniqWith;
          lodash.unset = unset;
          lodash.unzip = unzip;
          lodash.unzipWith = unzipWith;
          lodash.update = update;
          lodash.updateWith = updateWith;
          lodash.values = values;
          lodash.valuesIn = valuesIn;
          lodash.without = without;
          lodash.words = words;
          lodash.wrap = wrap2;
          lodash.xor = xor;
          lodash.xorBy = xorBy;
          lodash.xorWith = xorWith;
          lodash.zip = zip;
          lodash.zipObject = zipObject;
          lodash.zipObjectDeep = zipObjectDeep;
          lodash.zipWith = zipWith;
          lodash.entries = toPairs;
          lodash.entriesIn = toPairsIn;
          lodash.extend = assignIn;
          lodash.extendWith = assignInWith;
          mixin(lodash, lodash);
          lodash.add = add2;
          lodash.attempt = attempt;
          lodash.camelCase = camelCase;
          lodash.capitalize = capitalize2;
          lodash.ceil = ceil;
          lodash.clamp = clamp;
          lodash.clone = clone;
          lodash.cloneDeep = cloneDeep;
          lodash.cloneDeepWith = cloneDeepWith;
          lodash.cloneWith = cloneWith;
          lodash.conformsTo = conformsTo;
          lodash.deburr = deburr;
          lodash.defaultTo = defaultTo;
          lodash.divide = divide;
          lodash.endsWith = endsWith2;
          lodash.eq = eq;
          lodash.escape = escape2;
          lodash.escapeRegExp = escapeRegExp;
          lodash.every = every;
          lodash.find = find;
          lodash.findIndex = findIndex;
          lodash.findKey = findKey2;
          lodash.findLast = findLast;
          lodash.findLastIndex = findLastIndex;
          lodash.findLastKey = findLastKey;
          lodash.floor = floor;
          lodash.forEach = forEach2;
          lodash.forEachRight = forEachRight;
          lodash.forIn = forIn;
          lodash.forInRight = forInRight;
          lodash.forOwn = forOwn;
          lodash.forOwnRight = forOwnRight;
          lodash.get = get4;
          lodash.gt = gt;
          lodash.gte = gte;
          lodash.has = has;
          lodash.hasIn = hasIn;
          lodash.head = head;
          lodash.identity = identity;
          lodash.includes = includes;
          lodash.indexOf = indexOf;
          lodash.inRange = inRange;
          lodash.invoke = invoke;
          lodash.isArguments = isArguments;
          lodash.isArray = isArray2;
          lodash.isArrayBuffer = isArrayBuffer2;
          lodash.isArrayLike = isArrayLike;
          lodash.isArrayLikeObject = isArrayLikeObject;
          lodash.isBoolean = isBoolean3;
          lodash.isBuffer = isBuffer2;
          lodash.isDate = isDate2;
          lodash.isElement = isElement;
          lodash.isEmpty = isEmpty;
          lodash.isEqual = isEqual;
          lodash.isEqualWith = isEqualWith;
          lodash.isError = isError;
          lodash.isFinite = isFinite2;
          lodash.isFunction = isFunction2;
          lodash.isInteger = isInteger;
          lodash.isLength = isLength;
          lodash.isMap = isMap;
          lodash.isMatch = isMatch;
          lodash.isMatchWith = isMatchWith;
          lodash.isNaN = isNaN2;
          lodash.isNative = isNative;
          lodash.isNil = isNil;
          lodash.isNull = isNull;
          lodash.isNumber = isNumber3;
          lodash.isObject = isObject3;
          lodash.isObjectLike = isObjectLike;
          lodash.isPlainObject = isPlainObject3;
          lodash.isRegExp = isRegExp2;
          lodash.isSafeInteger = isSafeInteger;
          lodash.isSet = isSet;
          lodash.isString = isString3;
          lodash.isSymbol = isSymbol;
          lodash.isTypedArray = isTypedArray2;
          lodash.isUndefined = isUndefined2;
          lodash.isWeakMap = isWeakMap;
          lodash.isWeakSet = isWeakSet;
          lodash.join = join3;
          lodash.kebabCase = kebabCase;
          lodash.last = last;
          lodash.lastIndexOf = lastIndexOf;
          lodash.lowerCase = lowerCase;
          lodash.lowerFirst = lowerFirst;
          lodash.lt = lt;
          lodash.lte = lte;
          lodash.max = max2;
          lodash.maxBy = maxBy;
          lodash.mean = mean;
          lodash.meanBy = meanBy;
          lodash.min = min;
          lodash.minBy = minBy;
          lodash.stubArray = stubArray;
          lodash.stubFalse = stubFalse;
          lodash.stubObject = stubObject;
          lodash.stubString = stubString;
          lodash.stubTrue = stubTrue;
          lodash.multiply = multiply;
          lodash.nth = nth;
          lodash.noConflict = noConflict;
          lodash.noop = noop2;
          lodash.now = now;
          lodash.pad = pad;
          lodash.padEnd = padEnd;
          lodash.padStart = padStart;
          lodash.parseInt = parseInt2;
          lodash.random = random;
          lodash.reduce = reduce;
          lodash.reduceRight = reduceRight;
          lodash.repeat = repeat;
          lodash.replace = replace2;
          lodash.result = result;
          lodash.round = round;
          lodash.runInContext = runInContext2;
          lodash.sample = sample;
          lodash.size = size;
          lodash.snakeCase = snakeCase;
          lodash.some = some;
          lodash.sortedIndex = sortedIndex;
          lodash.sortedIndexBy = sortedIndexBy;
          lodash.sortedIndexOf = sortedIndexOf;
          lodash.sortedLastIndex = sortedLastIndex;
          lodash.sortedLastIndexBy = sortedLastIndexBy;
          lodash.sortedLastIndexOf = sortedLastIndexOf;
          lodash.startCase = startCase;
          lodash.startsWith = startsWith;
          lodash.subtract = subtract;
          lodash.sum = sum;
          lodash.sumBy = sumBy;
          lodash.template = template;
          lodash.times = times;
          lodash.toFinite = toFinite;
          lodash.toInteger = toInteger;
          lodash.toLength = toLength;
          lodash.toLower = toLower;
          lodash.toNumber = toNumber3;
          lodash.toSafeInteger = toSafeInteger;
          lodash.toString = toString3;
          lodash.toUpper = toUpper;
          lodash.trim = trim2;
          lodash.trimEnd = trimEnd;
          lodash.trimStart = trimStart;
          lodash.truncate = truncate3;
          lodash.unescape = unescape2;
          lodash.uniqueId = uniqueId;
          lodash.upperCase = upperCase;
          lodash.upperFirst = upperFirst;
          lodash.each = forEach2;
          lodash.eachRight = forEachRight;
          lodash.first = head;
          mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
              if (!hasOwnProperty2.call(lodash.prototype, methodName)) {
                source[methodName] = func;
              }
            });
            return source;
          }(), { "chain": false });
          lodash.VERSION = VERSION4;
          arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
            lodash[methodName].placeholder = lodash;
          });
          arrayEach(["drop", "take"], function(methodName, index2) {
            LazyWrapper.prototype[methodName] = function(n2) {
              n2 = n2 === undefined2 ? 1 : nativeMax(toInteger(n2), 0);
              var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
              if (result2.__filtered__) {
                result2.__takeCount__ = nativeMin(n2, result2.__takeCount__);
              } else {
                result2.__views__.push({
                  "size": nativeMin(n2, MAX_ARRAY_LENGTH),
                  "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
                });
              }
              return result2;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n2) {
              return this.reverse()[methodName](n2).reverse();
            };
          });
          arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
            var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee2) {
              var result2 = this.clone();
              result2.__iteratees__.push({
                "iteratee": getIteratee(iteratee2, 3),
                "type": type
              });
              result2.__filtered__ = result2.__filtered__ || isFilter;
              return result2;
            };
          });
          arrayEach(["head", "last"], function(methodName, index2) {
            var takeName = "take" + (index2 ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
              return this[takeName](1).value()[0];
            };
          });
          arrayEach(["initial", "tail"], function(methodName, index2) {
            var dropName = "drop" + (index2 ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
              return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
          });
          LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
          };
          LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
          };
          LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
          };
          LazyWrapper.prototype.invokeMap = baseRest(function(path3, args) {
            if (typeof path3 == "function") {
              return new LazyWrapper(this);
            }
            return this.map(function(value) {
              return baseInvoke(value, path3, args);
            });
          });
          LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
          };
          LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result2 = this;
            if (result2.__filtered__ && (start > 0 || end < 0)) {
              return new LazyWrapper(result2);
            }
            if (start < 0) {
              result2 = result2.takeRight(-start);
            } else if (start) {
              result2 = result2.drop(start);
            }
            if (end !== undefined2) {
              end = toInteger(end);
              result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
            }
            return result2;
          };
          LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
          };
          LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
          };
          baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) {
              return;
            }
            lodash.prototype[methodName] = function() {
              var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
              var interceptor = function(value2) {
                var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
                return isTaker && chainAll ? result3[0] : result3;
              };
              if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
                isLazy = useLazy = false;
              }
              var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
              if (!retUnwrapped && useLazy) {
                value = onlyLazy ? value : new LazyWrapper(this);
                var result2 = func.apply(value, args);
                result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
                return new LodashWrapper(result2, chainAll);
              }
              if (isUnwrapped && onlyLazy) {
                return func.apply(this, args);
              }
              result2 = this.thru(interceptor);
              return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
            };
          });
          arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
              var args = arguments;
              if (retUnwrapped && !this.__chain__) {
                var value = this.value();
                return func.apply(isArray2(value) ? value : [], args);
              }
              return this[chainName](function(value2) {
                return func.apply(isArray2(value2) ? value2 : [], args);
              });
            };
          });
          baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
              var key = lodashFunc.name + "";
              if (!hasOwnProperty2.call(realNames, key)) {
                realNames[key] = [];
              }
              realNames[key].push({ "name": methodName, "func": lodashFunc });
            }
          });
          realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
            "name": "wrapper",
            "func": undefined2
          }];
          LazyWrapper.prototype.clone = lazyClone;
          LazyWrapper.prototype.reverse = lazyReverse;
          LazyWrapper.prototype.value = lazyValue;
          lodash.prototype.at = wrapperAt;
          lodash.prototype.chain = wrapperChain;
          lodash.prototype.commit = wrapperCommit;
          lodash.prototype.next = wrapperNext;
          lodash.prototype.plant = wrapperPlant;
          lodash.prototype.reverse = wrapperReverse;
          lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
          lodash.prototype.first = lodash.prototype.head;
          if (symIterator) {
            lodash.prototype[symIterator] = wrapperToIterator;
          }
          return lodash;
        };
        var _2 = runInContext();
        if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
          root._ = _2;
          define(function() {
            return _2;
          });
        } else if (freeModule) {
          (freeModule.exports = _2)._ = _2;
          freeExports._ = _2;
        } else {
          root._ = _2;
        }
      }).call(exports2);
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/codegen/code.js
  var require_code = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/codegen/code.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.regexpCode = exports2.getEsmExportName = exports2.getProperty = exports2.safeStringify = exports2.stringify = exports2.strConcat = exports2.addCodeArg = exports2.str = exports2._ = exports2.nil = exports2._Code = exports2.Name = exports2.IDENTIFIER = exports2._CodeOrName = void 0;
      var _CodeOrName = class {
      };
      exports2._CodeOrName = _CodeOrName;
      exports2.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
      var Name = class extends _CodeOrName {
        constructor(s2) {
          super();
          if (!exports2.IDENTIFIER.test(s2))
            throw new Error("CodeGen: name must be a valid identifier");
          this.str = s2;
        }
        toString() {
          return this.str;
        }
        emptyStr() {
          return false;
        }
        get names() {
          return { [this.str]: 1 };
        }
      };
      exports2.Name = Name;
      var _Code = class extends _CodeOrName {
        constructor(code) {
          super();
          this._items = typeof code === "string" ? [code] : code;
        }
        toString() {
          return this.str;
        }
        emptyStr() {
          if (this._items.length > 1)
            return false;
          const item = this._items[0];
          return item === "" || item === '""';
        }
        get str() {
          var _a6;
          return (_a6 = this._str) !== null && _a6 !== void 0 ? _a6 : this._str = this._items.reduce((s2, c) => `${s2}${c}`, "");
        }
        get names() {
          var _a6;
          return (_a6 = this._names) !== null && _a6 !== void 0 ? _a6 : this._names = this._items.reduce((names, c) => {
            if (c instanceof Name)
              names[c.str] = (names[c.str] || 0) + 1;
            return names;
          }, {});
        }
      };
      exports2._Code = _Code;
      exports2.nil = new _Code("");
      function _2(strs, ...args) {
        const code = [strs[0]];
        let i2 = 0;
        while (i2 < args.length) {
          addCodeArg(code, args[i2]);
          code.push(strs[++i2]);
        }
        return new _Code(code);
      }
      exports2._ = _2;
      var plus = new _Code("+");
      function str(strs, ...args) {
        const expr = [safeStringify(strs[0])];
        let i2 = 0;
        while (i2 < args.length) {
          expr.push(plus);
          addCodeArg(expr, args[i2]);
          expr.push(plus, safeStringify(strs[++i2]));
        }
        optimize(expr);
        return new _Code(expr);
      }
      exports2.str = str;
      function addCodeArg(code, arg) {
        if (arg instanceof _Code)
          code.push(...arg._items);
        else if (arg instanceof Name)
          code.push(arg);
        else
          code.push(interpolate(arg));
      }
      exports2.addCodeArg = addCodeArg;
      function optimize(expr) {
        let i2 = 1;
        while (i2 < expr.length - 1) {
          if (expr[i2] === plus) {
            const res = mergeExprItems(expr[i2 - 1], expr[i2 + 1]);
            if (res !== void 0) {
              expr.splice(i2 - 1, 3, res);
              continue;
            }
            expr[i2++] = "+";
          }
          i2++;
        }
      }
      function mergeExprItems(a, b) {
        if (b === '""')
          return a;
        if (a === '""')
          return b;
        if (typeof a == "string") {
          if (b instanceof Name || a[a.length - 1] !== '"')
            return;
          if (typeof b != "string")
            return `${a.slice(0, -1)}${b}"`;
          if (b[0] === '"')
            return a.slice(0, -1) + b.slice(1);
          return;
        }
        if (typeof b == "string" && b[0] === '"' && !(a instanceof Name))
          return `"${a}${b.slice(1)}`;
        return;
      }
      function strConcat(c1, c2) {
        return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str`${c1}${c2}`;
      }
      exports2.strConcat = strConcat;
      function interpolate(x) {
        return typeof x == "number" || typeof x == "boolean" || x === null ? x : safeStringify(Array.isArray(x) ? x.join(",") : x);
      }
      function stringify2(x) {
        return new _Code(safeStringify(x));
      }
      exports2.stringify = stringify2;
      function safeStringify(x) {
        return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
      }
      exports2.safeStringify = safeStringify;
      function getProperty(key) {
        return typeof key == "string" && exports2.IDENTIFIER.test(key) ? new _Code(`.${key}`) : _2`[${key}]`;
      }
      exports2.getProperty = getProperty;
      function getEsmExportName(key) {
        if (typeof key == "string" && exports2.IDENTIFIER.test(key)) {
          return new _Code(`${key}`);
        }
        throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
      }
      exports2.getEsmExportName = getEsmExportName;
      function regexpCode(rx) {
        return new _Code(rx.toString());
      }
      exports2.regexpCode = regexpCode;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/codegen/scope.js
  var require_scope = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/codegen/scope.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.ValueScope = exports2.ValueScopeName = exports2.Scope = exports2.varKinds = exports2.UsedValueState = void 0;
      var code_1 = require_code();
      var ValueError = class extends Error {
        constructor(name2) {
          super(`CodeGen: "code" for ${name2} not defined`);
          this.value = name2.value;
        }
      };
      var UsedValueState;
      (function(UsedValueState2) {
        UsedValueState2[UsedValueState2["Started"] = 0] = "Started";
        UsedValueState2[UsedValueState2["Completed"] = 1] = "Completed";
      })(UsedValueState || (exports2.UsedValueState = UsedValueState = {}));
      exports2.varKinds = {
        const: new code_1.Name("const"),
        let: new code_1.Name("let"),
        var: new code_1.Name("var")
      };
      var Scope = class {
        constructor({ prefixes, parent } = {}) {
          this._names = {};
          this._prefixes = prefixes;
          this._parent = parent;
        }
        toName(nameOrPrefix) {
          return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
        }
        name(prefix) {
          return new code_1.Name(this._newName(prefix));
        }
        _newName(prefix) {
          const ng = this._names[prefix] || this._nameGroup(prefix);
          return `${prefix}${ng.index++}`;
        }
        _nameGroup(prefix) {
          var _a6, _b3;
          if (((_b3 = (_a6 = this._parent) === null || _a6 === void 0 ? void 0 : _a6._prefixes) === null || _b3 === void 0 ? void 0 : _b3.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) {
            throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
          }
          return this._names[prefix] = { prefix, index: 0 };
        }
      };
      exports2.Scope = Scope;
      var ValueScopeName = class extends code_1.Name {
        constructor(prefix, nameStr) {
          super(nameStr);
          this.prefix = prefix;
        }
        setValue(value, { property, itemIndex }) {
          this.value = value;
          this.scopePath = (0, code_1._)`.${new code_1.Name(property)}[${itemIndex}]`;
        }
      };
      exports2.ValueScopeName = ValueScopeName;
      var line = (0, code_1._)`\n`;
      var ValueScope = class extends Scope {
        constructor(opts) {
          super(opts);
          this._values = {};
          this._scope = opts.scope;
          this.opts = { ...opts, _n: opts.lines ? line : code_1.nil };
        }
        get() {
          return this._scope;
        }
        name(prefix) {
          return new ValueScopeName(prefix, this._newName(prefix));
        }
        value(nameOrPrefix, value) {
          var _a6;
          if (value.ref === void 0)
            throw new Error("CodeGen: ref must be passed in value");
          const name2 = this.toName(nameOrPrefix);
          const { prefix } = name2;
          const valueKey = (_a6 = value.key) !== null && _a6 !== void 0 ? _a6 : value.ref;
          let vs = this._values[prefix];
          if (vs) {
            const _name = vs.get(valueKey);
            if (_name)
              return _name;
          } else {
            vs = this._values[prefix] = /* @__PURE__ */ new Map();
          }
          vs.set(valueKey, name2);
          const s2 = this._scope[prefix] || (this._scope[prefix] = []);
          const itemIndex = s2.length;
          s2[itemIndex] = value.ref;
          name2.setValue(value, { property: prefix, itemIndex });
          return name2;
        }
        getValue(prefix, keyOrRef) {
          const vs = this._values[prefix];
          if (!vs)
            return;
          return vs.get(keyOrRef);
        }
        scopeRefs(scopeName, values = this._values) {
          return this._reduceValues(values, (name2) => {
            if (name2.scopePath === void 0)
              throw new Error(`CodeGen: name "${name2}" has no value`);
            return (0, code_1._)`${scopeName}${name2.scopePath}`;
          });
        }
        scopeCode(values = this._values, usedValues, getCode3) {
          return this._reduceValues(values, (name2) => {
            if (name2.value === void 0)
              throw new Error(`CodeGen: name "${name2}" has no value`);
            return name2.value.code;
          }, usedValues, getCode3);
        }
        _reduceValues(values, valueCode, usedValues = {}, getCode3) {
          let code = code_1.nil;
          for (const prefix in values) {
            const vs = values[prefix];
            if (!vs)
              continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || /* @__PURE__ */ new Map();
            vs.forEach((name2) => {
              if (nameSet.has(name2))
                return;
              nameSet.set(name2, UsedValueState.Started);
              let c = valueCode(name2);
              if (c) {
                const def = this.opts.es5 ? exports2.varKinds.var : exports2.varKinds.const;
                code = (0, code_1._)`${code}${def} ${name2} = ${c};${this.opts._n}`;
              } else if (c = getCode3 === null || getCode3 === void 0 ? void 0 : getCode3(name2)) {
                code = (0, code_1._)`${code}${c}${this.opts._n}`;
              } else {
                throw new ValueError(name2);
              }
              nameSet.set(name2, UsedValueState.Completed);
            });
          }
          return code;
        }
      };
      exports2.ValueScope = ValueScope;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/codegen/index.js
  var require_codegen = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/codegen/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.or = exports2.and = exports2.not = exports2.CodeGen = exports2.operators = exports2.varKinds = exports2.ValueScopeName = exports2.ValueScope = exports2.Scope = exports2.Name = exports2.regexpCode = exports2.stringify = exports2.getProperty = exports2.nil = exports2.strConcat = exports2.str = exports2._ = void 0;
      var code_1 = require_code();
      var scope_1 = require_scope();
      var code_2 = require_code();
      Object.defineProperty(exports2, "_", { enumerable: true, get: function() {
        return code_2._;
      } });
      Object.defineProperty(exports2, "str", { enumerable: true, get: function() {
        return code_2.str;
      } });
      Object.defineProperty(exports2, "strConcat", { enumerable: true, get: function() {
        return code_2.strConcat;
      } });
      Object.defineProperty(exports2, "nil", { enumerable: true, get: function() {
        return code_2.nil;
      } });
      Object.defineProperty(exports2, "getProperty", { enumerable: true, get: function() {
        return code_2.getProperty;
      } });
      Object.defineProperty(exports2, "stringify", { enumerable: true, get: function() {
        return code_2.stringify;
      } });
      Object.defineProperty(exports2, "regexpCode", { enumerable: true, get: function() {
        return code_2.regexpCode;
      } });
      Object.defineProperty(exports2, "Name", { enumerable: true, get: function() {
        return code_2.Name;
      } });
      var scope_2 = require_scope();
      Object.defineProperty(exports2, "Scope", { enumerable: true, get: function() {
        return scope_2.Scope;
      } });
      Object.defineProperty(exports2, "ValueScope", { enumerable: true, get: function() {
        return scope_2.ValueScope;
      } });
      Object.defineProperty(exports2, "ValueScopeName", { enumerable: true, get: function() {
        return scope_2.ValueScopeName;
      } });
      Object.defineProperty(exports2, "varKinds", { enumerable: true, get: function() {
        return scope_2.varKinds;
      } });
      exports2.operators = {
        GT: new code_1._Code(">"),
        GTE: new code_1._Code(">="),
        LT: new code_1._Code("<"),
        LTE: new code_1._Code("<="),
        EQ: new code_1._Code("==="),
        NEQ: new code_1._Code("!=="),
        NOT: new code_1._Code("!"),
        OR: new code_1._Code("||"),
        AND: new code_1._Code("&&"),
        ADD: new code_1._Code("+")
      };
      var Node = class {
        optimizeNodes() {
          return this;
        }
        optimizeNames(_names, _constants) {
          return this;
        }
      };
      var Def = class extends Node {
        constructor(varKind, name2, rhs) {
          super();
          this.varKind = varKind;
          this.name = name2;
          this.rhs = rhs;
        }
        render({ es5, _n }) {
          const varKind = es5 ? scope_1.varKinds.var : this.varKind;
          const rhs = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
          return `${varKind} ${this.name}${rhs};` + _n;
        }
        optimizeNames(names, constants) {
          if (!names[this.name.str])
            return;
          if (this.rhs)
            this.rhs = optimizeExpr(this.rhs, names, constants);
          return this;
        }
        get names() {
          return this.rhs instanceof code_1._CodeOrName ? this.rhs.names : {};
        }
      };
      var Assign = class extends Node {
        constructor(lhs, rhs, sideEffects) {
          super();
          this.lhs = lhs;
          this.rhs = rhs;
          this.sideEffects = sideEffects;
        }
        render({ _n }) {
          return `${this.lhs} = ${this.rhs};` + _n;
        }
        optimizeNames(names, constants) {
          if (this.lhs instanceof code_1.Name && !names[this.lhs.str] && !this.sideEffects)
            return;
          this.rhs = optimizeExpr(this.rhs, names, constants);
          return this;
        }
        get names() {
          const names = this.lhs instanceof code_1.Name ? {} : { ...this.lhs.names };
          return addExprNames(names, this.rhs);
        }
      };
      var AssignOp = class extends Assign {
        constructor(lhs, op, rhs, sideEffects) {
          super(lhs, rhs, sideEffects);
          this.op = op;
        }
        render({ _n }) {
          return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
        }
      };
      var Label = class extends Node {
        constructor(label) {
          super();
          this.label = label;
          this.names = {};
        }
        render({ _n }) {
          return `${this.label}:` + _n;
        }
      };
      var Break = class extends Node {
        constructor(label) {
          super();
          this.label = label;
          this.names = {};
        }
        render({ _n }) {
          const label = this.label ? ` ${this.label}` : "";
          return `break${label};` + _n;
        }
      };
      var Throw = class extends Node {
        constructor(error) {
          super();
          this.error = error;
        }
        render({ _n }) {
          return `throw ${this.error};` + _n;
        }
        get names() {
          return this.error.names;
        }
      };
      var AnyCode = class extends Node {
        constructor(code) {
          super();
          this.code = code;
        }
        render({ _n }) {
          return `${this.code};` + _n;
        }
        optimizeNodes() {
          return `${this.code}` ? this : void 0;
        }
        optimizeNames(names, constants) {
          this.code = optimizeExpr(this.code, names, constants);
          return this;
        }
        get names() {
          return this.code instanceof code_1._CodeOrName ? this.code.names : {};
        }
      };
      var ParentNode = class extends Node {
        constructor(nodes = []) {
          super();
          this.nodes = nodes;
        }
        render(opts) {
          return this.nodes.reduce((code, n2) => code + n2.render(opts), "");
        }
        optimizeNodes() {
          const { nodes } = this;
          let i2 = nodes.length;
          while (i2--) {
            const n2 = nodes[i2].optimizeNodes();
            if (Array.isArray(n2))
              nodes.splice(i2, 1, ...n2);
            else if (n2)
              nodes[i2] = n2;
            else
              nodes.splice(i2, 1);
          }
          return nodes.length > 0 ? this : void 0;
        }
        optimizeNames(names, constants) {
          const { nodes } = this;
          let i2 = nodes.length;
          while (i2--) {
            const n2 = nodes[i2];
            if (n2.optimizeNames(names, constants))
              continue;
            subtractNames(names, n2.names);
            nodes.splice(i2, 1);
          }
          return nodes.length > 0 ? this : void 0;
        }
        get names() {
          return this.nodes.reduce((names, n2) => addNames(names, n2.names), {});
        }
      };
      var BlockNode = class extends ParentNode {
        render(opts) {
          return "{" + opts._n + super.render(opts) + "}" + opts._n;
        }
      };
      var Root = class extends ParentNode {
      };
      var Else = class extends BlockNode {
      };
      Else.kind = "else";
      var If = class _If extends BlockNode {
        constructor(condition, nodes) {
          super(nodes);
          this.condition = condition;
        }
        render(opts) {
          let code = `if(${this.condition})` + super.render(opts);
          if (this.else)
            code += "else " + this.else.render(opts);
          return code;
        }
        optimizeNodes() {
          super.optimizeNodes();
          const cond = this.condition;
          if (cond === true)
            return this.nodes;
          let e2 = this.else;
          if (e2) {
            const ns = e2.optimizeNodes();
            e2 = this.else = Array.isArray(ns) ? new Else(ns) : ns;
          }
          if (e2) {
            if (cond === false)
              return e2 instanceof _If ? e2 : e2.nodes;
            if (this.nodes.length)
              return this;
            return new _If(not(cond), e2 instanceof _If ? [e2] : e2.nodes);
          }
          if (cond === false || !this.nodes.length)
            return void 0;
          return this;
        }
        optimizeNames(names, constants) {
          var _a6;
          this.else = (_a6 = this.else) === null || _a6 === void 0 ? void 0 : _a6.optimizeNames(names, constants);
          if (!(super.optimizeNames(names, constants) || this.else))
            return;
          this.condition = optimizeExpr(this.condition, names, constants);
          return this;
        }
        get names() {
          const names = super.names;
          addExprNames(names, this.condition);
          if (this.else)
            addNames(names, this.else.names);
          return names;
        }
      };
      If.kind = "if";
      var For = class extends BlockNode {
      };
      For.kind = "for";
      var ForLoop = class extends For {
        constructor(iteration) {
          super();
          this.iteration = iteration;
        }
        render(opts) {
          return `for(${this.iteration})` + super.render(opts);
        }
        optimizeNames(names, constants) {
          if (!super.optimizeNames(names, constants))
            return;
          this.iteration = optimizeExpr(this.iteration, names, constants);
          return this;
        }
        get names() {
          return addNames(super.names, this.iteration.names);
        }
      };
      var ForRange = class extends For {
        constructor(varKind, name2, from, to) {
          super();
          this.varKind = varKind;
          this.name = name2;
          this.from = from;
          this.to = to;
        }
        render(opts) {
          const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
          const { name: name2, from, to } = this;
          return `for(${varKind} ${name2}=${from}; ${name2}<${to}; ${name2}++)` + super.render(opts);
        }
        get names() {
          const names = addExprNames(super.names, this.from);
          return addExprNames(names, this.to);
        }
      };
      var ForIter = class extends For {
        constructor(loop, varKind, name2, iterable) {
          super();
          this.loop = loop;
          this.varKind = varKind;
          this.name = name2;
          this.iterable = iterable;
        }
        render(opts) {
          return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
        }
        optimizeNames(names, constants) {
          if (!super.optimizeNames(names, constants))
            return;
          this.iterable = optimizeExpr(this.iterable, names, constants);
          return this;
        }
        get names() {
          return addNames(super.names, this.iterable.names);
        }
      };
      var Func = class extends BlockNode {
        constructor(name2, args, async) {
          super();
          this.name = name2;
          this.args = args;
          this.async = async;
        }
        render(opts) {
          const _async = this.async ? "async " : "";
          return `${_async}function ${this.name}(${this.args})` + super.render(opts);
        }
      };
      Func.kind = "func";
      var Return = class extends ParentNode {
        render(opts) {
          return "return " + super.render(opts);
        }
      };
      Return.kind = "return";
      var Try = class extends BlockNode {
        render(opts) {
          let code = "try" + super.render(opts);
          if (this.catch)
            code += this.catch.render(opts);
          if (this.finally)
            code += this.finally.render(opts);
          return code;
        }
        optimizeNodes() {
          var _a6, _b3;
          super.optimizeNodes();
          (_a6 = this.catch) === null || _a6 === void 0 ? void 0 : _a6.optimizeNodes();
          (_b3 = this.finally) === null || _b3 === void 0 ? void 0 : _b3.optimizeNodes();
          return this;
        }
        optimizeNames(names, constants) {
          var _a6, _b3;
          super.optimizeNames(names, constants);
          (_a6 = this.catch) === null || _a6 === void 0 ? void 0 : _a6.optimizeNames(names, constants);
          (_b3 = this.finally) === null || _b3 === void 0 ? void 0 : _b3.optimizeNames(names, constants);
          return this;
        }
        get names() {
          const names = super.names;
          if (this.catch)
            addNames(names, this.catch.names);
          if (this.finally)
            addNames(names, this.finally.names);
          return names;
        }
      };
      var Catch = class extends BlockNode {
        constructor(error) {
          super();
          this.error = error;
        }
        render(opts) {
          return `catch(${this.error})` + super.render(opts);
        }
      };
      Catch.kind = "catch";
      var Finally = class extends BlockNode {
        render(opts) {
          return "finally" + super.render(opts);
        }
      };
      Finally.kind = "finally";
      var CodeGen = class {
        constructor(extScope, opts = {}) {
          this._values = {};
          this._blockStarts = [];
          this._constants = {};
          this.opts = { ...opts, _n: opts.lines ? "\n" : "" };
          this._extScope = extScope;
          this._scope = new scope_1.Scope({ parent: extScope });
          this._nodes = [new Root()];
        }
        toString() {
          return this._root.render(this.opts);
        }
        // returns unique name in the internal scope
        name(prefix) {
          return this._scope.name(prefix);
        }
        // reserves unique name in the external scope
        scopeName(prefix) {
          return this._extScope.name(prefix);
        }
        // reserves unique name in the external scope and assigns value to it
        scopeValue(prefixOrName, value) {
          const name2 = this._extScope.value(prefixOrName, value);
          const vs = this._values[name2.prefix] || (this._values[name2.prefix] = /* @__PURE__ */ new Set());
          vs.add(name2);
          return name2;
        }
        getScopeValue(prefix, keyOrRef) {
          return this._extScope.getValue(prefix, keyOrRef);
        }
        // return code that assigns values in the external scope to the names that are used internally
        // (same names that were returned by gen.scopeName or gen.scopeValue)
        scopeRefs(scopeName) {
          return this._extScope.scopeRefs(scopeName, this._values);
        }
        scopeCode() {
          return this._extScope.scopeCode(this._values);
        }
        _def(varKind, nameOrPrefix, rhs, constant) {
          const name2 = this._scope.toName(nameOrPrefix);
          if (rhs !== void 0 && constant)
            this._constants[name2.str] = rhs;
          this._leafNode(new Def(varKind, name2, rhs));
          return name2;
        }
        // `const` declaration (`var` in es5 mode)
        const(nameOrPrefix, rhs, _constant) {
          return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
        }
        // `let` declaration with optional assignment (`var` in es5 mode)
        let(nameOrPrefix, rhs, _constant) {
          return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
        }
        // `var` declaration with optional assignment
        var(nameOrPrefix, rhs, _constant) {
          return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
        }
        // assignment code
        assign(lhs, rhs, sideEffects) {
          return this._leafNode(new Assign(lhs, rhs, sideEffects));
        }
        // `+=` code
        add(lhs, rhs) {
          return this._leafNode(new AssignOp(lhs, exports2.operators.ADD, rhs));
        }
        // appends passed SafeExpr to code or executes Block
        code(c) {
          if (typeof c == "function")
            c();
          else if (c !== code_1.nil)
            this._leafNode(new AnyCode(c));
          return this;
        }
        // returns code for object literal for the passed argument list of key-value pairs
        object(...keyValues) {
          const code = ["{"];
          for (const [key, value] of keyValues) {
            if (code.length > 1)
              code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
              code.push(":");
              (0, code_1.addCodeArg)(code, value);
            }
          }
          code.push("}");
          return new code_1._Code(code);
        }
        // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
        if(condition, thenBody, elseBody) {
          this._blockNode(new If(condition));
          if (thenBody && elseBody) {
            this.code(thenBody).else().code(elseBody).endIf();
          } else if (thenBody) {
            this.code(thenBody).endIf();
          } else if (elseBody) {
            throw new Error('CodeGen: "else" body without "then" body');
          }
          return this;
        }
        // `else if` clause - invalid without `if` or after `else` clauses
        elseIf(condition) {
          return this._elseNode(new If(condition));
        }
        // `else` clause - only valid after `if` or `else if` clauses
        else() {
          return this._elseNode(new Else());
        }
        // end `if` statement (needed if gen.if was used only with condition)
        endIf() {
          return this._endBlockNode(If, Else);
        }
        _for(node, forBody) {
          this._blockNode(node);
          if (forBody)
            this.code(forBody).endFor();
          return this;
        }
        // a generic `for` clause (or statement if `forBody` is passed)
        for(iteration, forBody) {
          return this._for(new ForLoop(iteration), forBody);
        }
        // `for` statement for a range of values
        forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
          const name2 = this._scope.toName(nameOrPrefix);
          return this._for(new ForRange(varKind, name2, from, to), () => forBody(name2));
        }
        // `for-of` statement (in es5 mode replace with a normal for loop)
        forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
          const name2 = this._scope.toName(nameOrPrefix);
          if (this.opts.es5) {
            const arr = iterable instanceof code_1.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, code_1._)`${arr}.length`, (i2) => {
              this.var(name2, (0, code_1._)`${arr}[${i2}]`);
              forBody(name2);
            });
          }
          return this._for(new ForIter("of", varKind, name2, iterable), () => forBody(name2));
        }
        // `for-in` statement.
        // With option `ownProperties` replaced with a `for-of` loop for object keys
        forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
          if (this.opts.ownProperties) {
            return this.forOf(nameOrPrefix, (0, code_1._)`Object.keys(${obj})`, forBody);
          }
          const name2 = this._scope.toName(nameOrPrefix);
          return this._for(new ForIter("in", varKind, name2, obj), () => forBody(name2));
        }
        // end `for` loop
        endFor() {
          return this._endBlockNode(For);
        }
        // `label` statement
        label(label) {
          return this._leafNode(new Label(label));
        }
        // `break` statement
        break(label) {
          return this._leafNode(new Break(label));
        }
        // `return` statement
        return(value) {
          const node = new Return();
          this._blockNode(node);
          this.code(value);
          if (node.nodes.length !== 1)
            throw new Error('CodeGen: "return" should have one node');
          return this._endBlockNode(Return);
        }
        // `try` statement
        try(tryBody, catchCode, finallyCode) {
          if (!catchCode && !finallyCode)
            throw new Error('CodeGen: "try" without "catch" and "finally"');
          const node = new Try();
          this._blockNode(node);
          this.code(tryBody);
          if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new Catch(error);
            catchCode(error);
          }
          if (finallyCode) {
            this._currNode = node.finally = new Finally();
            this.code(finallyCode);
          }
          return this._endBlockNode(Catch, Finally);
        }
        // `throw` statement
        throw(error) {
          return this._leafNode(new Throw(error));
        }
        // start self-balancing block
        block(body, nodeCount) {
          this._blockStarts.push(this._nodes.length);
          if (body)
            this.code(body).endBlock(nodeCount);
          return this;
        }
        // end the current self-balancing block
        endBlock(nodeCount) {
          const len = this._blockStarts.pop();
          if (len === void 0)
            throw new Error("CodeGen: not in self-balancing block");
          const toClose = this._nodes.length - len;
          if (toClose < 0 || nodeCount !== void 0 && toClose !== nodeCount) {
            throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
          }
          this._nodes.length = len;
          return this;
        }
        // `function` heading (or definition if funcBody is passed)
        func(name2, args = code_1.nil, async, funcBody) {
          this._blockNode(new Func(name2, args, async));
          if (funcBody)
            this.code(funcBody).endFunc();
          return this;
        }
        // end function definition
        endFunc() {
          return this._endBlockNode(Func);
        }
        optimize(n2 = 1) {
          while (n2-- > 0) {
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
          }
        }
        _leafNode(node) {
          this._currNode.nodes.push(node);
          return this;
        }
        _blockNode(node) {
          this._currNode.nodes.push(node);
          this._nodes.push(node);
        }
        _endBlockNode(N1, N2) {
          const n2 = this._currNode;
          if (n2 instanceof N1 || N2 && n2 instanceof N2) {
            this._nodes.pop();
            return this;
          }
          throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
        }
        _elseNode(node) {
          const n2 = this._currNode;
          if (!(n2 instanceof If)) {
            throw new Error('CodeGen: "else" without "if"');
          }
          this._currNode = n2.else = node;
          return this;
        }
        get _root() {
          return this._nodes[0];
        }
        get _currNode() {
          const ns = this._nodes;
          return ns[ns.length - 1];
        }
        set _currNode(node) {
          const ns = this._nodes;
          ns[ns.length - 1] = node;
        }
      };
      exports2.CodeGen = CodeGen;
      function addNames(names, from) {
        for (const n2 in from)
          names[n2] = (names[n2] || 0) + (from[n2] || 0);
        return names;
      }
      function addExprNames(names, from) {
        return from instanceof code_1._CodeOrName ? addNames(names, from.names) : names;
      }
      function optimizeExpr(expr, names, constants) {
        if (expr instanceof code_1.Name)
          return replaceName(expr);
        if (!canOptimize(expr))
          return expr;
        return new code_1._Code(expr._items.reduce((items, c) => {
          if (c instanceof code_1.Name)
            c = replaceName(c);
          if (c instanceof code_1._Code)
            items.push(...c._items);
          else
            items.push(c);
          return items;
        }, []));
        function replaceName(n2) {
          const c = constants[n2.str];
          if (c === void 0 || names[n2.str] !== 1)
            return n2;
          delete names[n2.str];
          return c;
        }
        function canOptimize(e2) {
          return e2 instanceof code_1._Code && e2._items.some((c) => c instanceof code_1.Name && names[c.str] === 1 && constants[c.str] !== void 0);
        }
      }
      function subtractNames(names, from) {
        for (const n2 in from)
          names[n2] = (names[n2] || 0) - (from[n2] || 0);
      }
      function not(x) {
        return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, code_1._)`!${par(x)}`;
      }
      exports2.not = not;
      var andCode = mappend(exports2.operators.AND);
      function and(...args) {
        return args.reduce(andCode);
      }
      exports2.and = and;
      var orCode = mappend(exports2.operators.OR);
      function or(...args) {
        return args.reduce(orCode);
      }
      exports2.or = or;
      function mappend(op) {
        return (x, y) => x === code_1.nil ? y : y === code_1.nil ? x : (0, code_1._)`${par(x)} ${op} ${par(y)}`;
      }
      function par(x) {
        return x instanceof code_1.Name ? x : (0, code_1._)`(${x})`;
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/util.js
  var require_util2 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/util.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.checkStrictMode = exports2.getErrorPath = exports2.Type = exports2.useFunc = exports2.setEvaluated = exports2.evaluatedPropsToName = exports2.mergeEvaluated = exports2.eachItem = exports2.unescapeJsonPointer = exports2.escapeJsonPointer = exports2.escapeFragment = exports2.unescapeFragment = exports2.schemaRefOrVal = exports2.schemaHasRulesButRef = exports2.schemaHasRules = exports2.checkUnknownRules = exports2.alwaysValidSchema = exports2.toHash = void 0;
      var codegen_1 = require_codegen();
      var code_1 = require_code();
      function toHash(arr) {
        const hash2 = {};
        for (const item of arr)
          hash2[item] = true;
        return hash2;
      }
      exports2.toHash = toHash;
      function alwaysValidSchema(it, schema) {
        if (typeof schema == "boolean")
          return schema;
        if (Object.keys(schema).length === 0)
          return true;
        checkUnknownRules(it, schema);
        return !schemaHasRules(schema, it.self.RULES.all);
      }
      exports2.alwaysValidSchema = alwaysValidSchema;
      function checkUnknownRules(it, schema = it.schema) {
        const { opts, self: self2 } = it;
        if (!opts.strictSchema)
          return;
        if (typeof schema === "boolean")
          return;
        const rules = self2.RULES.keywords;
        for (const key in schema) {
          if (!rules[key])
            checkStrictMode(it, `unknown keyword: "${key}"`);
        }
      }
      exports2.checkUnknownRules = checkUnknownRules;
      function schemaHasRules(schema, rules) {
        if (typeof schema == "boolean")
          return !schema;
        for (const key in schema)
          if (rules[key])
            return true;
        return false;
      }
      exports2.schemaHasRules = schemaHasRules;
      function schemaHasRulesButRef(schema, RULES) {
        if (typeof schema == "boolean")
          return !schema;
        for (const key in schema)
          if (key !== "$ref" && RULES.all[key])
            return true;
        return false;
      }
      exports2.schemaHasRulesButRef = schemaHasRulesButRef;
      function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword, $data) {
        if (!$data) {
          if (typeof schema == "number" || typeof schema == "boolean")
            return schema;
          if (typeof schema == "string")
            return (0, codegen_1._)`${schema}`;
        }
        return (0, codegen_1._)`${topSchemaRef}${schemaPath}${(0, codegen_1.getProperty)(keyword)}`;
      }
      exports2.schemaRefOrVal = schemaRefOrVal;
      function unescapeFragment(str) {
        return unescapeJsonPointer(decodeURIComponent(str));
      }
      exports2.unescapeFragment = unescapeFragment;
      function escapeFragment(str) {
        return encodeURIComponent(escapeJsonPointer(str));
      }
      exports2.escapeFragment = escapeFragment;
      function escapeJsonPointer(str) {
        if (typeof str == "number")
          return `${str}`;
        return str.replace(/~/g, "~0").replace(/\//g, "~1");
      }
      exports2.escapeJsonPointer = escapeJsonPointer;
      function unescapeJsonPointer(str) {
        return str.replace(/~1/g, "/").replace(/~0/g, "~");
      }
      exports2.unescapeJsonPointer = unescapeJsonPointer;
      function eachItem(xs, f) {
        if (Array.isArray(xs)) {
          for (const x of xs)
            f(x);
        } else {
          f(xs);
        }
      }
      exports2.eachItem = eachItem;
      function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues: mergeValues3, resultToName }) {
        return (gen2, from, to, toName) => {
          const res = to === void 0 ? from : to instanceof codegen_1.Name ? (from instanceof codegen_1.Name ? mergeNames(gen2, from, to) : mergeToName(gen2, from, to), to) : from instanceof codegen_1.Name ? (mergeToName(gen2, to, from), from) : mergeValues3(from, to);
          return toName === codegen_1.Name && !(res instanceof codegen_1.Name) ? resultToName(gen2, res) : res;
        };
      }
      exports2.mergeEvaluated = {
        props: makeMergeEvaluated({
          mergeNames: (gen2, from, to) => gen2.if((0, codegen_1._)`${to} !== true && ${from} !== undefined`, () => {
            gen2.if((0, codegen_1._)`${from} === true`, () => gen2.assign(to, true), () => gen2.assign(to, (0, codegen_1._)`${to} || {}`).code((0, codegen_1._)`Object.assign(${to}, ${from})`));
          }),
          mergeToName: (gen2, from, to) => gen2.if((0, codegen_1._)`${to} !== true`, () => {
            if (from === true) {
              gen2.assign(to, true);
            } else {
              gen2.assign(to, (0, codegen_1._)`${to} || {}`);
              setEvaluated(gen2, to, from);
            }
          }),
          mergeValues: (from, to) => from === true ? true : { ...from, ...to },
          resultToName: evaluatedPropsToName
        }),
        items: makeMergeEvaluated({
          mergeNames: (gen2, from, to) => gen2.if((0, codegen_1._)`${to} !== true && ${from} !== undefined`, () => gen2.assign(to, (0, codegen_1._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
          mergeToName: (gen2, from, to) => gen2.if((0, codegen_1._)`${to} !== true`, () => gen2.assign(to, from === true ? true : (0, codegen_1._)`${to} > ${from} ? ${to} : ${from}`)),
          mergeValues: (from, to) => from === true ? true : Math.max(from, to),
          resultToName: (gen2, items) => gen2.var("items", items)
        })
      };
      function evaluatedPropsToName(gen2, ps) {
        if (ps === true)
          return gen2.var("props", true);
        const props = gen2.var("props", (0, codegen_1._)`{}`);
        if (ps !== void 0)
          setEvaluated(gen2, props, ps);
        return props;
      }
      exports2.evaluatedPropsToName = evaluatedPropsToName;
      function setEvaluated(gen2, props, ps) {
        Object.keys(ps).forEach((p12) => gen2.assign((0, codegen_1._)`${props}${(0, codegen_1.getProperty)(p12)}`, true));
      }
      exports2.setEvaluated = setEvaluated;
      var snippets = {};
      function useFunc(gen2, f) {
        return gen2.scopeValue("func", {
          ref: f,
          code: snippets[f.code] || (snippets[f.code] = new code_1._Code(f.code))
        });
      }
      exports2.useFunc = useFunc;
      var Type;
      (function(Type2) {
        Type2[Type2["Num"] = 0] = "Num";
        Type2[Type2["Str"] = 1] = "Str";
      })(Type || (exports2.Type = Type = {}));
      function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
        if (dataProp instanceof codegen_1.Name) {
          const isNumber3 = dataPropType === Type.Num;
          return jsPropertySyntax ? isNumber3 ? (0, codegen_1._)`"[" + ${dataProp} + "]"` : (0, codegen_1._)`"['" + ${dataProp} + "']"` : isNumber3 ? (0, codegen_1._)`"/" + ${dataProp}` : (0, codegen_1._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
        }
        return jsPropertySyntax ? (0, codegen_1.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
      }
      exports2.getErrorPath = getErrorPath;
      function checkStrictMode(it, msg, mode = it.opts.strictSchema) {
        if (!mode)
          return;
        msg = `strict mode: ${msg}`;
        if (mode === true)
          throw new Error(msg);
        it.self.logger.warn(msg);
      }
      exports2.checkStrictMode = checkStrictMode;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/names.js
  var require_names = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/names.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var names = {
        // validation function arguments
        data: new codegen_1.Name("data"),
        // data passed to validation function
        // args passed from referencing schema
        valCxt: new codegen_1.Name("valCxt"),
        // validation/data context - should not be used directly, it is destructured to the names below
        instancePath: new codegen_1.Name("instancePath"),
        parentData: new codegen_1.Name("parentData"),
        parentDataProperty: new codegen_1.Name("parentDataProperty"),
        rootData: new codegen_1.Name("rootData"),
        // root data - same as the data passed to the first/top validation function
        dynamicAnchors: new codegen_1.Name("dynamicAnchors"),
        // used to support recursiveRef and dynamicRef
        // function scoped variables
        vErrors: new codegen_1.Name("vErrors"),
        // null or array of validation errors
        errors: new codegen_1.Name("errors"),
        // counter of validation errors
        this: new codegen_1.Name("this"),
        // "globals"
        self: new codegen_1.Name("self"),
        scope: new codegen_1.Name("scope"),
        // JTD serialize/parse name for JSON string and position
        json: new codegen_1.Name("json"),
        jsonPos: new codegen_1.Name("jsonPos"),
        jsonLen: new codegen_1.Name("jsonLen"),
        jsonPart: new codegen_1.Name("jsonPart")
      };
      exports2.default = names;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/errors.js
  var require_errors2 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/errors.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.extendErrors = exports2.resetErrorsCount = exports2.reportExtraError = exports2.reportError = exports2.keyword$DataError = exports2.keywordError = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var names_1 = require_names();
      exports2.keywordError = {
        message: ({ keyword }) => (0, codegen_1.str)`must pass "${keyword}" keyword validation`
      };
      exports2.keyword$DataError = {
        message: ({ keyword, schemaType }) => schemaType ? (0, codegen_1.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, codegen_1.str)`"${keyword}" keyword is invalid ($data)`
      };
      function reportError(cxt, error = exports2.keywordError, errorPaths, overrideAllErrors) {
        const { it } = cxt;
        const { gen: gen2, compositeRule, allErrors } = it;
        const errObj = errorObjectCode(cxt, error, errorPaths);
        if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) {
          addError(gen2, errObj);
        } else {
          returnErrors(it, (0, codegen_1._)`[${errObj}]`);
        }
      }
      exports2.reportError = reportError;
      function reportExtraError(cxt, error = exports2.keywordError, errorPaths) {
        const { it } = cxt;
        const { gen: gen2, compositeRule, allErrors } = it;
        const errObj = errorObjectCode(cxt, error, errorPaths);
        addError(gen2, errObj);
        if (!(compositeRule || allErrors)) {
          returnErrors(it, names_1.default.vErrors);
        }
      }
      exports2.reportExtraError = reportExtraError;
      function resetErrorsCount(gen2, errsCount) {
        gen2.assign(names_1.default.errors, errsCount);
        gen2.if((0, codegen_1._)`${names_1.default.vErrors} !== null`, () => gen2.if(errsCount, () => gen2.assign((0, codegen_1._)`${names_1.default.vErrors}.length`, errsCount), () => gen2.assign(names_1.default.vErrors, null)));
      }
      exports2.resetErrorsCount = resetErrorsCount;
      function extendErrors({ gen: gen2, keyword, schemaValue, data, errsCount, it }) {
        if (errsCount === void 0)
          throw new Error("ajv implementation error");
        const err3 = gen2.name("err");
        gen2.forRange("i", errsCount, names_1.default.errors, (i2) => {
          gen2.const(err3, (0, codegen_1._)`${names_1.default.vErrors}[${i2}]`);
          gen2.if((0, codegen_1._)`${err3}.instancePath === undefined`, () => gen2.assign((0, codegen_1._)`${err3}.instancePath`, (0, codegen_1.strConcat)(names_1.default.instancePath, it.errorPath)));
          gen2.assign((0, codegen_1._)`${err3}.schemaPath`, (0, codegen_1.str)`${it.errSchemaPath}/${keyword}`);
          if (it.opts.verbose) {
            gen2.assign((0, codegen_1._)`${err3}.schema`, schemaValue);
            gen2.assign((0, codegen_1._)`${err3}.data`, data);
          }
        });
      }
      exports2.extendErrors = extendErrors;
      function addError(gen2, errObj) {
        const err3 = gen2.const("err", errObj);
        gen2.if((0, codegen_1._)`${names_1.default.vErrors} === null`, () => gen2.assign(names_1.default.vErrors, (0, codegen_1._)`[${err3}]`), (0, codegen_1._)`${names_1.default.vErrors}.push(${err3})`);
        gen2.code((0, codegen_1._)`${names_1.default.errors}++`);
      }
      function returnErrors(it, errs) {
        const { gen: gen2, validateName, schemaEnv } = it;
        if (schemaEnv.$async) {
          gen2.throw((0, codegen_1._)`new ${it.ValidationError}(${errs})`);
        } else {
          gen2.assign((0, codegen_1._)`${validateName}.errors`, errs);
          gen2.return(false);
        }
      }
      var E = {
        keyword: new codegen_1.Name("keyword"),
        schemaPath: new codegen_1.Name("schemaPath"),
        // also used in JTD errors
        params: new codegen_1.Name("params"),
        propertyName: new codegen_1.Name("propertyName"),
        message: new codegen_1.Name("message"),
        schema: new codegen_1.Name("schema"),
        parentSchema: new codegen_1.Name("parentSchema")
      };
      function errorObjectCode(cxt, error, errorPaths) {
        const { createErrors } = cxt.it;
        if (createErrors === false)
          return (0, codegen_1._)`{}`;
        return errorObject(cxt, error, errorPaths);
      }
      function errorObject(cxt, error, errorPaths = {}) {
        const { gen: gen2, it } = cxt;
        const keyValues = [
          errorInstancePath(it, errorPaths),
          errorSchemaPath(cxt, errorPaths)
        ];
        extraErrorProps(cxt, error, keyValues);
        return gen2.object(...keyValues);
      }
      function errorInstancePath({ errorPath }, { instancePath }) {
        const instPath = instancePath ? (0, codegen_1.str)`${errorPath}${(0, util_1.getErrorPath)(instancePath, util_1.Type.Str)}` : errorPath;
        return [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, instPath)];
      }
      function errorSchemaPath({ keyword, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
        let schPath = parentSchema ? errSchemaPath : (0, codegen_1.str)`${errSchemaPath}/${keyword}`;
        if (schemaPath) {
          schPath = (0, codegen_1.str)`${schPath}${(0, util_1.getErrorPath)(schemaPath, util_1.Type.Str)}`;
        }
        return [E.schemaPath, schPath];
      }
      function extraErrorProps(cxt, { params, message }, keyValues) {
        const { keyword, data, schemaValue, it } = cxt;
        const { opts, propertyName, topSchemaRef, schemaPath } = it;
        keyValues.push([E.keyword, keyword], [E.params, typeof params == "function" ? params(cxt) : params || (0, codegen_1._)`{}`]);
        if (opts.messages) {
          keyValues.push([E.message, typeof message == "function" ? message(cxt) : message]);
        }
        if (opts.verbose) {
          keyValues.push([E.schema, schemaValue], [E.parentSchema, (0, codegen_1._)`${topSchemaRef}${schemaPath}`], [names_1.default.data, data]);
        }
        if (propertyName)
          keyValues.push([E.propertyName, propertyName]);
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/boolSchema.js
  var require_boolSchema = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/boolSchema.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.boolOrEmptySchema = exports2.topBoolOrEmptySchema = void 0;
      var errors_1 = require_errors2();
      var codegen_1 = require_codegen();
      var names_1 = require_names();
      var boolError = {
        message: "boolean schema is false"
      };
      function topBoolOrEmptySchema(it) {
        const { gen: gen2, schema, validateName } = it;
        if (schema === false) {
          falseSchemaError(it, false);
        } else if (typeof schema == "object" && schema.$async === true) {
          gen2.return(names_1.default.data);
        } else {
          gen2.assign((0, codegen_1._)`${validateName}.errors`, null);
          gen2.return(true);
        }
      }
      exports2.topBoolOrEmptySchema = topBoolOrEmptySchema;
      function boolOrEmptySchema(it, valid) {
        const { gen: gen2, schema } = it;
        if (schema === false) {
          gen2.var(valid, false);
          falseSchemaError(it);
        } else {
          gen2.var(valid, true);
        }
      }
      exports2.boolOrEmptySchema = boolOrEmptySchema;
      function falseSchemaError(it, overrideAllErrors) {
        const { gen: gen2, data } = it;
        const cxt = {
          gen: gen2,
          keyword: "false schema",
          data,
          schema: false,
          schemaCode: false,
          schemaValue: false,
          params: {},
          it
        };
        (0, errors_1.reportError)(cxt, boolError, void 0, overrideAllErrors);
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/rules.js
  var require_rules = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/rules.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.getRules = exports2.isJSONType = void 0;
      var _jsonTypes = ["string", "number", "integer", "boolean", "null", "object", "array"];
      var jsonTypes = new Set(_jsonTypes);
      function isJSONType(x) {
        return typeof x == "string" && jsonTypes.has(x);
      }
      exports2.isJSONType = isJSONType;
      function getRules() {
        const groups = {
          number: { type: "number", rules: [] },
          string: { type: "string", rules: [] },
          array: { type: "array", rules: [] },
          object: { type: "object", rules: [] }
        };
        return {
          types: { ...groups, integer: true, boolean: true, null: true },
          rules: [{ rules: [] }, groups.number, groups.string, groups.array, groups.object],
          post: { rules: [] },
          all: {},
          keywords: {}
        };
      }
      exports2.getRules = getRules;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/applicability.js
  var require_applicability = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/applicability.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.shouldUseRule = exports2.shouldUseGroup = exports2.schemaHasRulesForType = void 0;
      function schemaHasRulesForType({ schema, self: self2 }, type) {
        const group = self2.RULES.types[type];
        return group && group !== true && shouldUseGroup(schema, group);
      }
      exports2.schemaHasRulesForType = schemaHasRulesForType;
      function shouldUseGroup(schema, group) {
        return group.rules.some((rule) => shouldUseRule(schema, rule));
      }
      exports2.shouldUseGroup = shouldUseGroup;
      function shouldUseRule(schema, rule) {
        var _a6;
        return schema[rule.keyword] !== void 0 || ((_a6 = rule.definition.implements) === null || _a6 === void 0 ? void 0 : _a6.some((kwd) => schema[kwd] !== void 0));
      }
      exports2.shouldUseRule = shouldUseRule;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/dataType.js
  var require_dataType = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/dataType.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.reportTypeError = exports2.checkDataTypes = exports2.checkDataType = exports2.coerceAndCheckDataType = exports2.getJSONTypes = exports2.getSchemaTypes = exports2.DataType = void 0;
      var rules_1 = require_rules();
      var applicability_1 = require_applicability();
      var errors_1 = require_errors2();
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var DataType;
      (function(DataType2) {
        DataType2[DataType2["Correct"] = 0] = "Correct";
        DataType2[DataType2["Wrong"] = 1] = "Wrong";
      })(DataType || (exports2.DataType = DataType = {}));
      function getSchemaTypes(schema) {
        const types3 = getJSONTypes(schema.type);
        const hasNull = types3.includes("null");
        if (hasNull) {
          if (schema.nullable === false)
            throw new Error("type: null contradicts nullable: false");
        } else {
          if (!types3.length && schema.nullable !== void 0) {
            throw new Error('"nullable" cannot be used without "type"');
          }
          if (schema.nullable === true)
            types3.push("null");
        }
        return types3;
      }
      exports2.getSchemaTypes = getSchemaTypes;
      function getJSONTypes(ts) {
        const types3 = Array.isArray(ts) ? ts : ts ? [ts] : [];
        if (types3.every(rules_1.isJSONType))
          return types3;
        throw new Error("type must be JSONType or JSONType[]: " + types3.join(","));
      }
      exports2.getJSONTypes = getJSONTypes;
      function coerceAndCheckDataType(it, types3) {
        const { gen: gen2, data, opts } = it;
        const coerceTo = coerceToTypes(types3, opts.coerceTypes);
        const checkTypes = types3.length > 0 && !(coerceTo.length === 0 && types3.length === 1 && (0, applicability_1.schemaHasRulesForType)(it, types3[0]));
        if (checkTypes) {
          const wrongType = checkDataTypes(types3, data, opts.strictNumbers, DataType.Wrong);
          gen2.if(wrongType, () => {
            if (coerceTo.length)
              coerceData(it, types3, coerceTo);
            else
              reportTypeError(it);
          });
        }
        return checkTypes;
      }
      exports2.coerceAndCheckDataType = coerceAndCheckDataType;
      var COERCIBLE = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
      function coerceToTypes(types3, coerceTypes) {
        return coerceTypes ? types3.filter((t2) => COERCIBLE.has(t2) || coerceTypes === "array" && t2 === "array") : [];
      }
      function coerceData(it, types3, coerceTo) {
        const { gen: gen2, data, opts } = it;
        const dataType = gen2.let("dataType", (0, codegen_1._)`typeof ${data}`);
        const coerced = gen2.let("coerced", (0, codegen_1._)`undefined`);
        if (opts.coerceTypes === "array") {
          gen2.if((0, codegen_1._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, () => gen2.assign(data, (0, codegen_1._)`${data}[0]`).assign(dataType, (0, codegen_1._)`typeof ${data}`).if(checkDataTypes(types3, data, opts.strictNumbers), () => gen2.assign(coerced, data)));
        }
        gen2.if((0, codegen_1._)`${coerced} !== undefined`);
        for (const t2 of coerceTo) {
          if (COERCIBLE.has(t2) || t2 === "array" && opts.coerceTypes === "array") {
            coerceSpecificType(t2);
          }
        }
        gen2.else();
        reportTypeError(it);
        gen2.endIf();
        gen2.if((0, codegen_1._)`${coerced} !== undefined`, () => {
          gen2.assign(data, coerced);
          assignParentData(it, coerced);
        });
        function coerceSpecificType(t2) {
          switch (t2) {
            case "string":
              gen2.elseIf((0, codegen_1._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, codegen_1._)`"" + ${data}`).elseIf((0, codegen_1._)`${data} === null`).assign(coerced, (0, codegen_1._)`""`);
              return;
            case "number":
              gen2.elseIf((0, codegen_1._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, codegen_1._)`+${data}`);
              return;
            case "integer":
              gen2.elseIf((0, codegen_1._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, codegen_1._)`+${data}`);
              return;
            case "boolean":
              gen2.elseIf((0, codegen_1._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, codegen_1._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
              return;
            case "null":
              gen2.elseIf((0, codegen_1._)`${data} === "" || ${data} === 0 || ${data} === false`);
              gen2.assign(coerced, null);
              return;
            case "array":
              gen2.elseIf((0, codegen_1._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, codegen_1._)`[${data}]`);
          }
        }
      }
      function assignParentData({ gen: gen2, parentData, parentDataProperty }, expr) {
        gen2.if((0, codegen_1._)`${parentData} !== undefined`, () => gen2.assign((0, codegen_1._)`${parentData}[${parentDataProperty}]`, expr));
      }
      function checkDataType(dataType, data, strictNums, correct = DataType.Correct) {
        const EQ = correct === DataType.Correct ? codegen_1.operators.EQ : codegen_1.operators.NEQ;
        let cond;
        switch (dataType) {
          case "null":
            return (0, codegen_1._)`${data} ${EQ} null`;
          case "array":
            cond = (0, codegen_1._)`Array.isArray(${data})`;
            break;
          case "object":
            cond = (0, codegen_1._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
          case "integer":
            cond = numCond((0, codegen_1._)`!(${data} % 1) && !isNaN(${data})`);
            break;
          case "number":
            cond = numCond();
            break;
          default:
            return (0, codegen_1._)`typeof ${data} ${EQ} ${dataType}`;
        }
        return correct === DataType.Correct ? cond : (0, codegen_1.not)(cond);
        function numCond(_cond = codegen_1.nil) {
          return (0, codegen_1.and)((0, codegen_1._)`typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1._)`isFinite(${data})` : codegen_1.nil);
        }
      }
      exports2.checkDataType = checkDataType;
      function checkDataTypes(dataTypes, data, strictNums, correct) {
        if (dataTypes.length === 1) {
          return checkDataType(dataTypes[0], data, strictNums, correct);
        }
        let cond;
        const types3 = (0, util_1.toHash)(dataTypes);
        if (types3.array && types3.object) {
          const notObj = (0, codegen_1._)`typeof ${data} != "object"`;
          cond = types3.null ? notObj : (0, codegen_1._)`!${data} || ${notObj}`;
          delete types3.null;
          delete types3.array;
          delete types3.object;
        } else {
          cond = codegen_1.nil;
        }
        if (types3.number)
          delete types3.integer;
        for (const t2 in types3)
          cond = (0, codegen_1.and)(cond, checkDataType(t2, data, strictNums, correct));
        return cond;
      }
      exports2.checkDataTypes = checkDataTypes;
      var typeError = {
        message: ({ schema }) => `must be ${schema}`,
        params: ({ schema, schemaValue }) => typeof schema == "string" ? (0, codegen_1._)`{type: ${schema}}` : (0, codegen_1._)`{type: ${schemaValue}}`
      };
      function reportTypeError(it) {
        const cxt = getTypeErrorContext(it);
        (0, errors_1.reportError)(cxt, typeError);
      }
      exports2.reportTypeError = reportTypeError;
      function getTypeErrorContext(it) {
        const { gen: gen2, data, schema } = it;
        const schemaCode = (0, util_1.schemaRefOrVal)(it, schema, "type");
        return {
          gen: gen2,
          keyword: "type",
          data,
          schema: schema.type,
          schemaCode,
          schemaValue: schemaCode,
          parentSchema: schema,
          params: {},
          it
        };
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/defaults.js
  var require_defaults2 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/defaults.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.assignDefaults = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      function assignDefaults(it, ty) {
        const { properties, items } = it.schema;
        if (ty === "object" && properties) {
          for (const key in properties) {
            assignDefault(it, key, properties[key].default);
          }
        } else if (ty === "array" && Array.isArray(items)) {
          items.forEach((sch, i2) => assignDefault(it, i2, sch.default));
        }
      }
      exports2.assignDefaults = assignDefaults;
      function assignDefault(it, prop, defaultValue) {
        const { gen: gen2, compositeRule, data, opts } = it;
        if (defaultValue === void 0)
          return;
        const childData = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(prop)}`;
        if (compositeRule) {
          (0, util_1.checkStrictMode)(it, `default is ignored for: ${childData}`);
          return;
        }
        let condition = (0, codegen_1._)`${childData} === undefined`;
        if (opts.useDefaults === "empty") {
          condition = (0, codegen_1._)`${condition} || ${childData} === null || ${childData} === ""`;
        }
        gen2.if(condition, (0, codegen_1._)`${childData} = ${(0, codegen_1.stringify)(defaultValue)}`);
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/code.js
  var require_code2 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/code.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateUnion = exports2.validateArray = exports2.usePattern = exports2.callValidateCode = exports2.schemaProperties = exports2.allSchemaProperties = exports2.noPropertyInData = exports2.propertyInData = exports2.isOwnProperty = exports2.hasPropFunc = exports2.reportMissingProp = exports2.checkMissingProp = exports2.checkReportMissingProp = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var names_1 = require_names();
      var util_2 = require_util2();
      function checkReportMissingProp(cxt, prop) {
        const { gen: gen2, data, it } = cxt;
        gen2.if(noPropertyInData(gen2, data, prop, it.opts.ownProperties), () => {
          cxt.setParams({ missingProperty: (0, codegen_1._)`${prop}` }, true);
          cxt.error();
        });
      }
      exports2.checkReportMissingProp = checkReportMissingProp;
      function checkMissingProp({ gen: gen2, data, it: { opts } }, properties, missing) {
        return (0, codegen_1.or)(...properties.map((prop) => (0, codegen_1.and)(noPropertyInData(gen2, data, prop, opts.ownProperties), (0, codegen_1._)`${missing} = ${prop}`)));
      }
      exports2.checkMissingProp = checkMissingProp;
      function reportMissingProp(cxt, missing) {
        cxt.setParams({ missingProperty: missing }, true);
        cxt.error();
      }
      exports2.reportMissingProp = reportMissingProp;
      function hasPropFunc(gen2) {
        return gen2.scopeValue("func", {
          // eslint-disable-next-line @typescript-eslint/unbound-method
          ref: Object.prototype.hasOwnProperty,
          code: (0, codegen_1._)`Object.prototype.hasOwnProperty`
        });
      }
      exports2.hasPropFunc = hasPropFunc;
      function isOwnProperty(gen2, data, property) {
        return (0, codegen_1._)`${hasPropFunc(gen2)}.call(${data}, ${property})`;
      }
      exports2.isOwnProperty = isOwnProperty;
      function propertyInData(gen2, data, property, ownProperties) {
        const cond = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(property)} !== undefined`;
        return ownProperties ? (0, codegen_1._)`${cond} && ${isOwnProperty(gen2, data, property)}` : cond;
      }
      exports2.propertyInData = propertyInData;
      function noPropertyInData(gen2, data, property, ownProperties) {
        const cond = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(property)} === undefined`;
        return ownProperties ? (0, codegen_1.or)(cond, (0, codegen_1.not)(isOwnProperty(gen2, data, property))) : cond;
      }
      exports2.noPropertyInData = noPropertyInData;
      function allSchemaProperties(schemaMap) {
        return schemaMap ? Object.keys(schemaMap).filter((p12) => p12 !== "__proto__") : [];
      }
      exports2.allSchemaProperties = allSchemaProperties;
      function schemaProperties(it, schemaMap) {
        return allSchemaProperties(schemaMap).filter((p12) => !(0, util_1.alwaysValidSchema)(it, schemaMap[p12]));
      }
      exports2.schemaProperties = schemaProperties;
      function callValidateCode({ schemaCode, data, it: { gen: gen2, topSchemaRef, schemaPath, errorPath }, it }, func, context, passSchema) {
        const dataAndSchema = passSchema ? (0, codegen_1._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
        const valCxt = [
          [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, errorPath)],
          [names_1.default.parentData, it.parentData],
          [names_1.default.parentDataProperty, it.parentDataProperty],
          [names_1.default.rootData, names_1.default.rootData]
        ];
        if (it.opts.dynamicRef)
          valCxt.push([names_1.default.dynamicAnchors, names_1.default.dynamicAnchors]);
        const args = (0, codegen_1._)`${dataAndSchema}, ${gen2.object(...valCxt)}`;
        return context !== codegen_1.nil ? (0, codegen_1._)`${func}.call(${context}, ${args})` : (0, codegen_1._)`${func}(${args})`;
      }
      exports2.callValidateCode = callValidateCode;
      var newRegExp = (0, codegen_1._)`new RegExp`;
      function usePattern({ gen: gen2, it: { opts } }, pattern2) {
        const u = opts.unicodeRegExp ? "u" : "";
        const { regExp } = opts.code;
        const rx = regExp(pattern2, u);
        return gen2.scopeValue("pattern", {
          key: rx.toString(),
          ref: rx,
          code: (0, codegen_1._)`${regExp.code === "new RegExp" ? newRegExp : (0, util_2.useFunc)(gen2, regExp)}(${pattern2}, ${u})`
        });
      }
      exports2.usePattern = usePattern;
      function validateArray(cxt) {
        const { gen: gen2, data, keyword, it } = cxt;
        const valid = gen2.name("valid");
        if (it.allErrors) {
          const validArr = gen2.let("valid", true);
          validateItems(() => gen2.assign(validArr, false));
          return validArr;
        }
        gen2.var(valid, true);
        validateItems(() => gen2.break());
        return valid;
        function validateItems(notValid) {
          const len = gen2.const("len", (0, codegen_1._)`${data}.length`);
          gen2.forRange("i", 0, len, (i2) => {
            cxt.subschema({
              keyword,
              dataProp: i2,
              dataPropType: util_1.Type.Num
            }, valid);
            gen2.if((0, codegen_1.not)(valid), notValid);
          });
        }
      }
      exports2.validateArray = validateArray;
      function validateUnion(cxt) {
        const { gen: gen2, schema, keyword, it } = cxt;
        if (!Array.isArray(schema))
          throw new Error("ajv implementation error");
        const alwaysValid = schema.some((sch) => (0, util_1.alwaysValidSchema)(it, sch));
        if (alwaysValid && !it.opts.unevaluated)
          return;
        const valid = gen2.let("valid", false);
        const schValid = gen2.name("_valid");
        gen2.block(() => schema.forEach((_sch, i2) => {
          const schCxt = cxt.subschema({
            keyword,
            schemaProp: i2,
            compositeRule: true
          }, schValid);
          gen2.assign(valid, (0, codegen_1._)`${valid} || ${schValid}`);
          const merged = cxt.mergeValidEvaluated(schCxt, schValid);
          if (!merged)
            gen2.if((0, codegen_1.not)(valid));
        }));
        cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
      }
      exports2.validateUnion = validateUnion;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/keyword.js
  var require_keyword = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/keyword.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateKeywordUsage = exports2.validSchemaType = exports2.funcKeywordCode = exports2.macroKeywordCode = void 0;
      var codegen_1 = require_codegen();
      var names_1 = require_names();
      var code_1 = require_code2();
      var errors_1 = require_errors2();
      function macroKeywordCode(cxt, def) {
        const { gen: gen2, keyword, schema, parentSchema, it } = cxt;
        const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
        const schemaRef = useKeyword(gen2, keyword, macroSchema);
        if (it.opts.validateSchema !== false)
          it.self.validateSchema(macroSchema, true);
        const valid = gen2.name("valid");
        cxt.subschema({
          schema: macroSchema,
          schemaPath: codegen_1.nil,
          errSchemaPath: `${it.errSchemaPath}/${keyword}`,
          topSchemaRef: schemaRef,
          compositeRule: true
        }, valid);
        cxt.pass(valid, () => cxt.error(true));
      }
      exports2.macroKeywordCode = macroKeywordCode;
      function funcKeywordCode(cxt, def) {
        var _a6;
        const { gen: gen2, keyword, schema, parentSchema, $data, it } = cxt;
        checkAsyncKeyword(it, def);
        const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
        const validateRef = useKeyword(gen2, keyword, validate);
        const valid = gen2.let("valid");
        cxt.block$data(valid, validateKeyword);
        cxt.ok((_a6 = def.valid) !== null && _a6 !== void 0 ? _a6 : valid);
        function validateKeyword() {
          if (def.errors === false) {
            assignValid();
            if (def.modifying)
              modifyData(cxt);
            reportErrs(() => cxt.error());
          } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying)
              modifyData(cxt);
            reportErrs(() => addErrs(cxt, ruleErrs));
          }
        }
        function validateAsync() {
          const ruleErrs = gen2.let("ruleErrs", null);
          gen2.try(() => assignValid((0, codegen_1._)`await `), (e2) => gen2.assign(valid, false).if((0, codegen_1._)`${e2} instanceof ${it.ValidationError}`, () => gen2.assign(ruleErrs, (0, codegen_1._)`${e2}.errors`), () => gen2.throw(e2)));
          return ruleErrs;
        }
        function validateSync() {
          const validateErrs = (0, codegen_1._)`${validateRef}.errors`;
          gen2.assign(validateErrs, null);
          assignValid(codegen_1.nil);
          return validateErrs;
        }
        function assignValid(_await = def.async ? (0, codegen_1._)`await ` : codegen_1.nil) {
          const passCxt = it.opts.passContext ? names_1.default.this : names_1.default.self;
          const passSchema = !("compile" in def && !$data || def.schema === false);
          gen2.assign(valid, (0, codegen_1._)`${_await}${(0, code_1.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
        }
        function reportErrs(errors) {
          var _a7;
          gen2.if((0, codegen_1.not)((_a7 = def.valid) !== null && _a7 !== void 0 ? _a7 : valid), errors);
        }
      }
      exports2.funcKeywordCode = funcKeywordCode;
      function modifyData(cxt) {
        const { gen: gen2, data, it } = cxt;
        gen2.if(it.parentData, () => gen2.assign(data, (0, codegen_1._)`${it.parentData}[${it.parentDataProperty}]`));
      }
      function addErrs(cxt, errs) {
        const { gen: gen2 } = cxt;
        gen2.if((0, codegen_1._)`Array.isArray(${errs})`, () => {
          gen2.assign(names_1.default.vErrors, (0, codegen_1._)`${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`).assign(names_1.default.errors, (0, codegen_1._)`${names_1.default.vErrors}.length`);
          (0, errors_1.extendErrors)(cxt);
        }, () => cxt.error());
      }
      function checkAsyncKeyword({ schemaEnv }, def) {
        if (def.async && !schemaEnv.$async)
          throw new Error("async keyword in sync schema");
      }
      function useKeyword(gen2, keyword, result) {
        if (result === void 0)
          throw new Error(`keyword "${keyword}" failed to compile`);
        return gen2.scopeValue("keyword", typeof result == "function" ? { ref: result } : { ref: result, code: (0, codegen_1.stringify)(result) });
      }
      function validSchemaType(schema, schemaType, allowUndefined = false) {
        return !schemaType.length || schemaType.some((st) => st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
      }
      exports2.validSchemaType = validSchemaType;
      function validateKeywordUsage({ schema, opts, self: self2, errSchemaPath }, def, keyword) {
        if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) {
          throw new Error("ajv implementation error");
        }
        const deps = def.dependencies;
        if (deps === null || deps === void 0 ? void 0 : deps.some((kwd) => !Object.prototype.hasOwnProperty.call(schema, kwd))) {
          throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
        }
        if (def.validateSchema) {
          const valid = def.validateSchema(schema[keyword]);
          if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self2.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log")
              self2.logger.error(msg);
            else
              throw new Error(msg);
          }
        }
      }
      exports2.validateKeywordUsage = validateKeywordUsage;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/subschema.js
  var require_subschema = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/subschema.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.extendSubschemaMode = exports2.extendSubschemaData = exports2.getSubschema = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      function getSubschema(it, { keyword, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
        if (keyword !== void 0 && schema !== void 0) {
          throw new Error('both "keyword" and "schema" passed, only one allowed');
        }
        if (keyword !== void 0) {
          const sch = it.schema[keyword];
          return schemaProp === void 0 ? {
            schema: sch,
            schemaPath: (0, codegen_1._)`${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
          } : {
            schema: sch[schemaProp],
            schemaPath: (0, codegen_1._)`${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}${(0, codegen_1.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, util_1.escapeFragment)(schemaProp)}`
          };
        }
        if (schema !== void 0) {
          if (schemaPath === void 0 || errSchemaPath === void 0 || topSchemaRef === void 0) {
            throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
          }
          return {
            schema,
            schemaPath,
            topSchemaRef,
            errSchemaPath
          };
        }
        throw new Error('either "keyword" or "schema" must be passed');
      }
      exports2.getSubschema = getSubschema;
      function extendSubschemaData(subschema, it, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
        if (data !== void 0 && dataProp !== void 0) {
          throw new Error('both "data" and "dataProp" passed, only one allowed');
        }
        const { gen: gen2 } = it;
        if (dataProp !== void 0) {
          const { errorPath, dataPathArr, opts } = it;
          const nextData = gen2.let("data", (0, codegen_1._)`${it.data}${(0, codegen_1.getProperty)(dataProp)}`, true);
          dataContextProps(nextData);
          subschema.errorPath = (0, codegen_1.str)`${errorPath}${(0, util_1.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
          subschema.parentDataProperty = (0, codegen_1._)`${dataProp}`;
          subschema.dataPathArr = [...dataPathArr, subschema.parentDataProperty];
        }
        if (data !== void 0) {
          const nextData = data instanceof codegen_1.Name ? data : gen2.let("data", data, true);
          dataContextProps(nextData);
          if (propertyName !== void 0)
            subschema.propertyName = propertyName;
        }
        if (dataTypes)
          subschema.dataTypes = dataTypes;
        function dataContextProps(_nextData) {
          subschema.data = _nextData;
          subschema.dataLevel = it.dataLevel + 1;
          subschema.dataTypes = [];
          it.definedProperties = /* @__PURE__ */ new Set();
          subschema.parentData = it.data;
          subschema.dataNames = [...it.dataNames, _nextData];
        }
      }
      exports2.extendSubschemaData = extendSubschemaData;
      function extendSubschemaMode(subschema, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
        if (compositeRule !== void 0)
          subschema.compositeRule = compositeRule;
        if (createErrors !== void 0)
          subschema.createErrors = createErrors;
        if (allErrors !== void 0)
          subschema.allErrors = allErrors;
        subschema.jtdDiscriminator = jtdDiscriminator;
        subschema.jtdMetadata = jtdMetadata;
      }
      exports2.extendSubschemaMode = extendSubschemaMode;
    }
  });

  // ../../node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js
  var require_fast_deep_equal = __commonJS({
    "../../node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js"(exports2, module2) {
      "use strict";
      module2.exports = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == "object" && typeof b == "object") {
          if (a.constructor !== b.constructor) return false;
          var length2, i2, keys;
          if (Array.isArray(a)) {
            length2 = a.length;
            if (length2 != b.length) return false;
            for (i2 = length2; i2-- !== 0; )
              if (!equal(a[i2], b[i2])) return false;
            return true;
          }
          if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
          if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
          if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
          keys = Object.keys(a);
          length2 = keys.length;
          if (length2 !== Object.keys(b).length) return false;
          for (i2 = length2; i2-- !== 0; )
            if (!Object.prototype.hasOwnProperty.call(b, keys[i2])) return false;
          for (i2 = length2; i2-- !== 0; ) {
            var key = keys[i2];
            if (!equal(a[key], b[key])) return false;
          }
          return true;
        }
        return a !== a && b !== b;
      };
    }
  });

  // ../../node_modules/.pnpm/json-schema-traverse@1.0.0/node_modules/json-schema-traverse/index.js
  var require_json_schema_traverse = __commonJS({
    "../../node_modules/.pnpm/json-schema-traverse@1.0.0/node_modules/json-schema-traverse/index.js"(exports2, module2) {
      "use strict";
      var traverse = module2.exports = function(schema, opts, cb) {
        if (typeof opts == "function") {
          cb = opts;
          opts = {};
        }
        cb = opts.cb || cb;
        var pre = typeof cb == "function" ? cb : cb.pre || function() {
        };
        var post = cb.post || function() {
        };
        _traverse(opts, pre, post, schema, "", schema);
      };
      traverse.keywords = {
        additionalItems: true,
        items: true,
        contains: true,
        additionalProperties: true,
        propertyNames: true,
        not: true,
        if: true,
        then: true,
        else: true
      };
      traverse.arrayKeywords = {
        items: true,
        allOf: true,
        anyOf: true,
        oneOf: true
      };
      traverse.propsKeywords = {
        $defs: true,
        definitions: true,
        properties: true,
        patternProperties: true,
        dependencies: true
      };
      traverse.skipKeywords = {
        default: true,
        enum: true,
        const: true,
        required: true,
        maximum: true,
        minimum: true,
        exclusiveMaximum: true,
        exclusiveMinimum: true,
        multipleOf: true,
        maxLength: true,
        minLength: true,
        pattern: true,
        format: true,
        maxItems: true,
        minItems: true,
        uniqueItems: true,
        maxProperties: true,
        minProperties: true
      };
      function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
        if (schema && typeof schema == "object" && !Array.isArray(schema)) {
          pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
          for (var key in schema) {
            var sch = schema[key];
            if (Array.isArray(sch)) {
              if (key in traverse.arrayKeywords) {
                for (var i2 = 0; i2 < sch.length; i2++)
                  _traverse(opts, pre, post, sch[i2], jsonPtr + "/" + key + "/" + i2, rootSchema, jsonPtr, key, schema, i2);
              }
            } else if (key in traverse.propsKeywords) {
              if (sch && typeof sch == "object") {
                for (var prop in sch)
                  _traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
              }
            } else if (key in traverse.keywords || opts.allKeys && !(key in traverse.skipKeywords)) {
              _traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
            }
          }
          post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        }
      }
      function escapeJsonPtr(str) {
        return str.replace(/~/g, "~0").replace(/\//g, "~1");
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/resolve.js
  var require_resolve = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/resolve.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.getSchemaRefs = exports2.resolveUrl = exports2.normalizeId = exports2._getFullPath = exports2.getFullPath = exports2.inlineRef = void 0;
      var util_1 = require_util2();
      var equal = require_fast_deep_equal();
      var traverse = require_json_schema_traverse();
      var SIMPLE_INLINED = /* @__PURE__ */ new Set([
        "type",
        "format",
        "pattern",
        "maxLength",
        "minLength",
        "maxProperties",
        "minProperties",
        "maxItems",
        "minItems",
        "maximum",
        "minimum",
        "uniqueItems",
        "multipleOf",
        "required",
        "enum",
        "const"
      ]);
      function inlineRef(schema, limit = true) {
        if (typeof schema == "boolean")
          return true;
        if (limit === true)
          return !hasRef(schema);
        if (!limit)
          return false;
        return countKeys(schema) <= limit;
      }
      exports2.inlineRef = inlineRef;
      var REF_KEYWORDS = /* @__PURE__ */ new Set([
        "$ref",
        "$recursiveRef",
        "$recursiveAnchor",
        "$dynamicRef",
        "$dynamicAnchor"
      ]);
      function hasRef(schema) {
        for (const key in schema) {
          if (REF_KEYWORDS.has(key))
            return true;
          const sch = schema[key];
          if (Array.isArray(sch) && sch.some(hasRef))
            return true;
          if (typeof sch == "object" && hasRef(sch))
            return true;
        }
        return false;
      }
      function countKeys(schema) {
        let count = 0;
        for (const key in schema) {
          if (key === "$ref")
            return Infinity;
          count++;
          if (SIMPLE_INLINED.has(key))
            continue;
          if (typeof schema[key] == "object") {
            (0, util_1.eachItem)(schema[key], (sch) => count += countKeys(sch));
          }
          if (count === Infinity)
            return Infinity;
        }
        return count;
      }
      function getFullPath(resolver, id = "", normalize5) {
        if (normalize5 !== false)
          id = normalizeId(id);
        const p12 = resolver.parse(id);
        return _getFullPath(resolver, p12);
      }
      exports2.getFullPath = getFullPath;
      function _getFullPath(resolver, p12) {
        const serialized = resolver.serialize(p12);
        return serialized.split("#")[0] + "#";
      }
      exports2._getFullPath = _getFullPath;
      var TRAILING_SLASH_HASH = /#\/?$/;
      function normalizeId(id) {
        return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
      }
      exports2.normalizeId = normalizeId;
      function resolveUrl(resolver, baseId, id) {
        id = normalizeId(id);
        return resolver.resolve(baseId, id);
      }
      exports2.resolveUrl = resolveUrl;
      var ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
      function getSchemaRefs(schema, baseId) {
        if (typeof schema == "boolean")
          return {};
        const { schemaId, uriResolver } = this.opts;
        const schId = normalizeId(schema[schemaId] || baseId);
        const baseIds = { "": schId };
        const pathPrefix = getFullPath(uriResolver, schId, false);
        const localRefs = {};
        const schemaRefs = /* @__PURE__ */ new Set();
        traverse(schema, { allKeys: true }, (sch, jsonPtr, _2, parentJsonPtr) => {
          if (parentJsonPtr === void 0)
            return;
          const fullPath = pathPrefix + jsonPtr;
          let innerBaseId = baseIds[parentJsonPtr];
          if (typeof sch[schemaId] == "string")
            innerBaseId = addRef.call(this, sch[schemaId]);
          addAnchor.call(this, sch.$anchor);
          addAnchor.call(this, sch.$dynamicAnchor);
          baseIds[jsonPtr] = innerBaseId;
          function addRef(ref) {
            const _resolve2 = this.opts.uriResolver.resolve;
            ref = normalizeId(innerBaseId ? _resolve2(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref))
              throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string")
              schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") {
              checkAmbiguosRef(sch, schOrRef.schema, ref);
            } else if (ref !== normalizeId(fullPath)) {
              if (ref[0] === "#") {
                checkAmbiguosRef(sch, localRefs[ref], ref);
                localRefs[ref] = sch;
              } else {
                this.refs[ref] = fullPath;
              }
            }
            return ref;
          }
          function addAnchor(anchor) {
            if (typeof anchor == "string") {
              if (!ANCHOR.test(anchor))
                throw new Error(`invalid anchor "${anchor}"`);
              addRef.call(this, `#${anchor}`);
            }
          }
        });
        return localRefs;
        function checkAmbiguosRef(sch1, sch2, ref) {
          if (sch2 !== void 0 && !equal(sch1, sch2))
            throw ambiguos(ref);
        }
        function ambiguos(ref) {
          return new Error(`reference "${ref}" resolves to more than one schema`);
        }
      }
      exports2.getSchemaRefs = getSchemaRefs;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/index.js
  var require_validate = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/validate/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.getData = exports2.KeywordCxt = exports2.validateFunctionCode = void 0;
      var boolSchema_1 = require_boolSchema();
      var dataType_1 = require_dataType();
      var applicability_1 = require_applicability();
      var dataType_2 = require_dataType();
      var defaults_1 = require_defaults2();
      var keyword_1 = require_keyword();
      var subschema_1 = require_subschema();
      var codegen_1 = require_codegen();
      var names_1 = require_names();
      var resolve_1 = require_resolve();
      var util_1 = require_util2();
      var errors_1 = require_errors2();
      function validateFunctionCode(it) {
        if (isSchemaObj(it)) {
          checkKeywords(it);
          if (schemaCxtHasRules(it)) {
            topSchemaObjCode(it);
            return;
          }
        }
        validateFunction(it, () => (0, boolSchema_1.topBoolOrEmptySchema)(it));
      }
      exports2.validateFunctionCode = validateFunctionCode;
      function validateFunction({ gen: gen2, validateName, schema, schemaEnv, opts }, body) {
        if (opts.code.es5) {
          gen2.func(validateName, (0, codegen_1._)`${names_1.default.data}, ${names_1.default.valCxt}`, schemaEnv.$async, () => {
            gen2.code((0, codegen_1._)`"use strict"; ${funcSourceUrl(schema, opts)}`);
            destructureValCxtES5(gen2, opts);
            gen2.code(body);
          });
        } else {
          gen2.func(validateName, (0, codegen_1._)`${names_1.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, () => gen2.code(funcSourceUrl(schema, opts)).code(body));
        }
      }
      function destructureValCxt(opts) {
        return (0, codegen_1._)`{${names_1.default.instancePath}="", ${names_1.default.parentData}, ${names_1.default.parentDataProperty}, ${names_1.default.rootData}=${names_1.default.data}${opts.dynamicRef ? (0, codegen_1._)`, ${names_1.default.dynamicAnchors}={}` : codegen_1.nil}}={}`;
      }
      function destructureValCxtES5(gen2, opts) {
        gen2.if(names_1.default.valCxt, () => {
          gen2.var(names_1.default.instancePath, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.instancePath}`);
          gen2.var(names_1.default.parentData, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.parentData}`);
          gen2.var(names_1.default.parentDataProperty, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.parentDataProperty}`);
          gen2.var(names_1.default.rootData, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.rootData}`);
          if (opts.dynamicRef)
            gen2.var(names_1.default.dynamicAnchors, (0, codegen_1._)`${names_1.default.valCxt}.${names_1.default.dynamicAnchors}`);
        }, () => {
          gen2.var(names_1.default.instancePath, (0, codegen_1._)`""`);
          gen2.var(names_1.default.parentData, (0, codegen_1._)`undefined`);
          gen2.var(names_1.default.parentDataProperty, (0, codegen_1._)`undefined`);
          gen2.var(names_1.default.rootData, names_1.default.data);
          if (opts.dynamicRef)
            gen2.var(names_1.default.dynamicAnchors, (0, codegen_1._)`{}`);
        });
      }
      function topSchemaObjCode(it) {
        const { schema, opts, gen: gen2 } = it;
        validateFunction(it, () => {
          if (opts.$comment && schema.$comment)
            commentKeyword(it);
          checkNoDefault(it);
          gen2.let(names_1.default.vErrors, null);
          gen2.let(names_1.default.errors, 0);
          if (opts.unevaluated)
            resetEvaluated(it);
          typeAndKeywords(it);
          returnResults(it);
        });
        return;
      }
      function resetEvaluated(it) {
        const { gen: gen2, validateName } = it;
        it.evaluated = gen2.const("evaluated", (0, codegen_1._)`${validateName}.evaluated`);
        gen2.if((0, codegen_1._)`${it.evaluated}.dynamicProps`, () => gen2.assign((0, codegen_1._)`${it.evaluated}.props`, (0, codegen_1._)`undefined`));
        gen2.if((0, codegen_1._)`${it.evaluated}.dynamicItems`, () => gen2.assign((0, codegen_1._)`${it.evaluated}.items`, (0, codegen_1._)`undefined`));
      }
      function funcSourceUrl(schema, opts) {
        const schId = typeof schema == "object" && schema[opts.schemaId];
        return schId && (opts.code.source || opts.code.process) ? (0, codegen_1._)`/*# sourceURL=${schId} */` : codegen_1.nil;
      }
      function subschemaCode(it, valid) {
        if (isSchemaObj(it)) {
          checkKeywords(it);
          if (schemaCxtHasRules(it)) {
            subSchemaObjCode(it, valid);
            return;
          }
        }
        (0, boolSchema_1.boolOrEmptySchema)(it, valid);
      }
      function schemaCxtHasRules({ schema, self: self2 }) {
        if (typeof schema == "boolean")
          return !schema;
        for (const key in schema)
          if (self2.RULES.all[key])
            return true;
        return false;
      }
      function isSchemaObj(it) {
        return typeof it.schema != "boolean";
      }
      function subSchemaObjCode(it, valid) {
        const { schema, gen: gen2, opts } = it;
        if (opts.$comment && schema.$comment)
          commentKeyword(it);
        updateContext(it);
        checkAsyncSchema(it);
        const errsCount = gen2.const("_errs", names_1.default.errors);
        typeAndKeywords(it, errsCount);
        gen2.var(valid, (0, codegen_1._)`${errsCount} === ${names_1.default.errors}`);
      }
      function checkKeywords(it) {
        (0, util_1.checkUnknownRules)(it);
        checkRefsAndKeywords(it);
      }
      function typeAndKeywords(it, errsCount) {
        if (it.opts.jtd)
          return schemaKeywords(it, [], false, errsCount);
        const types3 = (0, dataType_1.getSchemaTypes)(it.schema);
        const checkedTypes = (0, dataType_1.coerceAndCheckDataType)(it, types3);
        schemaKeywords(it, types3, !checkedTypes, errsCount);
      }
      function checkRefsAndKeywords(it) {
        const { schema, errSchemaPath, opts, self: self2 } = it;
        if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1.schemaHasRulesButRef)(schema, self2.RULES)) {
          self2.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
        }
      }
      function checkNoDefault(it) {
        const { schema, opts } = it;
        if (schema.default !== void 0 && opts.useDefaults && opts.strictSchema) {
          (0, util_1.checkStrictMode)(it, "default is ignored in the schema root");
        }
      }
      function updateContext(it) {
        const schId = it.schema[it.opts.schemaId];
        if (schId)
          it.baseId = (0, resolve_1.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
      }
      function checkAsyncSchema(it) {
        if (it.schema.$async && !it.schemaEnv.$async)
          throw new Error("async schema in sync schema");
      }
      function commentKeyword({ gen: gen2, schemaEnv, schema, errSchemaPath, opts }) {
        const msg = schema.$comment;
        if (opts.$comment === true) {
          gen2.code((0, codegen_1._)`${names_1.default.self}.logger.log(${msg})`);
        } else if (typeof opts.$comment == "function") {
          const schemaPath = (0, codegen_1.str)`${errSchemaPath}/$comment`;
          const rootName = gen2.scopeValue("root", { ref: schemaEnv.root });
          gen2.code((0, codegen_1._)`${names_1.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
        }
      }
      function returnResults(it) {
        const { gen: gen2, schemaEnv, validateName, ValidationError, opts } = it;
        if (schemaEnv.$async) {
          gen2.if((0, codegen_1._)`${names_1.default.errors} === 0`, () => gen2.return(names_1.default.data), () => gen2.throw((0, codegen_1._)`new ${ValidationError}(${names_1.default.vErrors})`));
        } else {
          gen2.assign((0, codegen_1._)`${validateName}.errors`, names_1.default.vErrors);
          if (opts.unevaluated)
            assignEvaluated(it);
          gen2.return((0, codegen_1._)`${names_1.default.errors} === 0`);
        }
      }
      function assignEvaluated({ gen: gen2, evaluated, props, items }) {
        if (props instanceof codegen_1.Name)
          gen2.assign((0, codegen_1._)`${evaluated}.props`, props);
        if (items instanceof codegen_1.Name)
          gen2.assign((0, codegen_1._)`${evaluated}.items`, items);
      }
      function schemaKeywords(it, types3, typeErrors, errsCount) {
        const { gen: gen2, schema, data, allErrors, opts, self: self2 } = it;
        const { RULES } = self2;
        if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1.schemaHasRulesButRef)(schema, RULES))) {
          gen2.block(() => keywordCode(it, "$ref", RULES.all.$ref.definition));
          return;
        }
        if (!opts.jtd)
          checkStrictTypes(it, types3);
        gen2.block(() => {
          for (const group of RULES.rules)
            groupKeywords(group);
          groupKeywords(RULES.post);
        });
        function groupKeywords(group) {
          if (!(0, applicability_1.shouldUseGroup)(schema, group))
            return;
          if (group.type) {
            gen2.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
            iterateKeywords(it, group);
            if (types3.length === 1 && types3[0] === group.type && typeErrors) {
              gen2.else();
              (0, dataType_2.reportTypeError)(it);
            }
            gen2.endIf();
          } else {
            iterateKeywords(it, group);
          }
          if (!allErrors)
            gen2.if((0, codegen_1._)`${names_1.default.errors} === ${errsCount || 0}`);
        }
      }
      function iterateKeywords(it, group) {
        const { gen: gen2, schema, opts: { useDefaults } } = it;
        if (useDefaults)
          (0, defaults_1.assignDefaults)(it, group.type);
        gen2.block(() => {
          for (const rule of group.rules) {
            if ((0, applicability_1.shouldUseRule)(schema, rule)) {
              keywordCode(it, rule.keyword, rule.definition, group.type);
            }
          }
        });
      }
      function checkStrictTypes(it, types3) {
        if (it.schemaEnv.meta || !it.opts.strictTypes)
          return;
        checkContextTypes(it, types3);
        if (!it.opts.allowUnionTypes)
          checkMultipleTypes(it, types3);
        checkKeywordTypes(it, it.dataTypes);
      }
      function checkContextTypes(it, types3) {
        if (!types3.length)
          return;
        if (!it.dataTypes.length) {
          it.dataTypes = types3;
          return;
        }
        types3.forEach((t2) => {
          if (!includesType(it.dataTypes, t2)) {
            strictTypesError(it, `type "${t2}" not allowed by context "${it.dataTypes.join(",")}"`);
          }
        });
        narrowSchemaTypes(it, types3);
      }
      function checkMultipleTypes(it, ts) {
        if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) {
          strictTypesError(it, "use allowUnionTypes to allow union type keyword");
        }
      }
      function checkKeywordTypes(it, ts) {
        const rules = it.self.RULES.all;
        for (const keyword in rules) {
          const rule = rules[keyword];
          if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it.schema, rule)) {
            const { type } = rule.definition;
            if (type.length && !type.some((t2) => hasApplicableType(ts, t2))) {
              strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
            }
          }
        }
      }
      function hasApplicableType(schTs, kwdT) {
        return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
      }
      function includesType(ts, t2) {
        return ts.includes(t2) || t2 === "integer" && ts.includes("number");
      }
      function narrowSchemaTypes(it, withTypes) {
        const ts = [];
        for (const t2 of it.dataTypes) {
          if (includesType(withTypes, t2))
            ts.push(t2);
          else if (withTypes.includes("integer") && t2 === "number")
            ts.push("integer");
        }
        it.dataTypes = ts;
      }
      function strictTypesError(it, msg) {
        const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
        msg += ` at "${schemaPath}" (strictTypes)`;
        (0, util_1.checkStrictMode)(it, msg, it.opts.strictTypes);
      }
      var KeywordCxt = class {
        constructor(it, def, keyword) {
          (0, keyword_1.validateKeywordUsage)(it, def, keyword);
          this.gen = it.gen;
          this.allErrors = it.allErrors;
          this.keyword = keyword;
          this.data = it.data;
          this.schema = it.schema[keyword];
          this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
          this.schemaValue = (0, util_1.schemaRefOrVal)(it, this.schema, keyword, this.$data);
          this.schemaType = def.schemaType;
          this.parentSchema = it.schema;
          this.params = {};
          this.it = it;
          this.def = def;
          if (this.$data) {
            this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
          } else {
            this.schemaCode = this.schemaValue;
            if (!(0, keyword_1.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) {
              throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
            }
          }
          if ("code" in def ? def.trackErrors : def.errors !== false) {
            this.errsCount = it.gen.const("_errs", names_1.default.errors);
          }
        }
        result(condition, successAction, failAction) {
          this.failResult((0, codegen_1.not)(condition), successAction, failAction);
        }
        failResult(condition, successAction, failAction) {
          this.gen.if(condition);
          if (failAction)
            failAction();
          else
            this.error();
          if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors)
              this.gen.endIf();
          } else {
            if (this.allErrors)
              this.gen.endIf();
            else
              this.gen.else();
          }
        }
        pass(condition, failAction) {
          this.failResult((0, codegen_1.not)(condition), void 0, failAction);
        }
        fail(condition) {
          if (condition === void 0) {
            this.error();
            if (!this.allErrors)
              this.gen.if(false);
            return;
          }
          this.gen.if(condition);
          this.error();
          if (this.allErrors)
            this.gen.endIf();
          else
            this.gen.else();
        }
        fail$data(condition) {
          if (!this.$data)
            return this.fail(condition);
          const { schemaCode } = this;
          this.fail((0, codegen_1._)`${schemaCode} !== undefined && (${(0, codegen_1.or)(this.invalid$data(), condition)})`);
        }
        error(append2, errorParams, errorPaths) {
          if (errorParams) {
            this.setParams(errorParams);
            this._error(append2, errorPaths);
            this.setParams({});
            return;
          }
          this._error(append2, errorPaths);
        }
        _error(append2, errorPaths) {
          ;
          (append2 ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
        }
        $dataError() {
          (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
        }
        reset() {
          if (this.errsCount === void 0)
            throw new Error('add "trackErrors" to keyword definition');
          (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
        }
        ok(cond) {
          if (!this.allErrors)
            this.gen.if(cond);
        }
        setParams(obj, assign2) {
          if (assign2)
            Object.assign(this.params, obj);
          else
            this.params = obj;
        }
        block$data(valid, codeBlock, $dataValid = codegen_1.nil) {
          this.gen.block(() => {
            this.check$data(valid, $dataValid);
            codeBlock();
          });
        }
        check$data(valid = codegen_1.nil, $dataValid = codegen_1.nil) {
          if (!this.$data)
            return;
          const { gen: gen2, schemaCode, schemaType, def } = this;
          gen2.if((0, codegen_1.or)((0, codegen_1._)`${schemaCode} === undefined`, $dataValid));
          if (valid !== codegen_1.nil)
            gen2.assign(valid, true);
          if (schemaType.length || def.validateSchema) {
            gen2.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== codegen_1.nil)
              gen2.assign(valid, false);
          }
          gen2.else();
        }
        invalid$data() {
          const { gen: gen2, schemaCode, schemaType, def, it } = this;
          return (0, codegen_1.or)(wrong$DataType(), invalid$DataSchema());
          function wrong$DataType() {
            if (schemaType.length) {
              if (!(schemaCode instanceof codegen_1.Name))
                throw new Error("ajv implementation error");
              const st = Array.isArray(schemaType) ? schemaType : [schemaType];
              return (0, codegen_1._)`${(0, dataType_2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
            }
            return codegen_1.nil;
          }
          function invalid$DataSchema() {
            if (def.validateSchema) {
              const validateSchemaRef = gen2.scopeValue("validate$data", { ref: def.validateSchema });
              return (0, codegen_1._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return codegen_1.nil;
          }
        }
        subschema(appl, valid) {
          const subschema = (0, subschema_1.getSubschema)(this.it, appl);
          (0, subschema_1.extendSubschemaData)(subschema, this.it, appl);
          (0, subschema_1.extendSubschemaMode)(subschema, appl);
          const nextContext = { ...this.it, ...subschema, items: void 0, props: void 0 };
          subschemaCode(nextContext, valid);
          return nextContext;
        }
        mergeEvaluated(schemaCxt, toName) {
          const { it, gen: gen2 } = this;
          if (!it.opts.unevaluated)
            return;
          if (it.props !== true && schemaCxt.props !== void 0) {
            it.props = util_1.mergeEvaluated.props(gen2, schemaCxt.props, it.props, toName);
          }
          if (it.items !== true && schemaCxt.items !== void 0) {
            it.items = util_1.mergeEvaluated.items(gen2, schemaCxt.items, it.items, toName);
          }
        }
        mergeValidEvaluated(schemaCxt, valid) {
          const { it, gen: gen2 } = this;
          if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen2.if(valid, () => this.mergeEvaluated(schemaCxt, codegen_1.Name));
            return true;
          }
        }
      };
      exports2.KeywordCxt = KeywordCxt;
      function keywordCode(it, keyword, def, ruleType) {
        const cxt = new KeywordCxt(it, def, keyword);
        if ("code" in def) {
          def.code(cxt, ruleType);
        } else if (cxt.$data && def.validate) {
          (0, keyword_1.funcKeywordCode)(cxt, def);
        } else if ("macro" in def) {
          (0, keyword_1.macroKeywordCode)(cxt, def);
        } else if (def.compile || def.validate) {
          (0, keyword_1.funcKeywordCode)(cxt, def);
        }
      }
      var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
      var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
      function getData($data, { dataLevel, dataNames, dataPathArr }) {
        let jsonPointer;
        let data;
        if ($data === "")
          return names_1.default.rootData;
        if ($data[0] === "/") {
          if (!JSON_POINTER.test($data))
            throw new Error(`Invalid JSON-pointer: ${$data}`);
          jsonPointer = $data;
          data = names_1.default.rootData;
        } else {
          const matches = RELATIVE_JSON_POINTER.exec($data);
          if (!matches)
            throw new Error(`Invalid JSON-pointer: ${$data}`);
          const up = +matches[1];
          jsonPointer = matches[2];
          if (jsonPointer === "#") {
            if (up >= dataLevel)
              throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
          }
          if (up > dataLevel)
            throw new Error(errorMsg("data", up));
          data = dataNames[dataLevel - up];
          if (!jsonPointer)
            return data;
        }
        let expr = data;
        const segments = jsonPointer.split("/");
        for (const segment of segments) {
          if (segment) {
            data = (0, codegen_1._)`${data}${(0, codegen_1.getProperty)((0, util_1.unescapeJsonPointer)(segment))}`;
            expr = (0, codegen_1._)`${expr} && ${data}`;
          }
        }
        return expr;
        function errorMsg(pointerType, up) {
          return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
        }
      }
      exports2.getData = getData;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/validation_error.js
  var require_validation_error = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/validation_error.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var ValidationError = class extends Error {
        constructor(errors) {
          super("validation failed");
          this.errors = errors;
          this.ajv = this.validation = true;
        }
      };
      exports2.default = ValidationError;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/ref_error.js
  var require_ref_error = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/ref_error.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var resolve_1 = require_resolve();
      var MissingRefError = class extends Error {
        constructor(resolver, baseId, ref, msg) {
          super(msg || `can't resolve reference ${ref} from id ${baseId}`);
          this.missingRef = (0, resolve_1.resolveUrl)(resolver, baseId, ref);
          this.missingSchema = (0, resolve_1.normalizeId)((0, resolve_1.getFullPath)(resolver, this.missingRef));
        }
      };
      exports2.default = MissingRefError;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/index.js
  var require_compile = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/compile/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.resolveSchema = exports2.getCompilingSchema = exports2.resolveRef = exports2.compileSchema = exports2.SchemaEnv = void 0;
      var codegen_1 = require_codegen();
      var validation_error_1 = require_validation_error();
      var names_1 = require_names();
      var resolve_1 = require_resolve();
      var util_1 = require_util2();
      var validate_1 = require_validate();
      var SchemaEnv = class {
        constructor(env) {
          var _a6;
          this.refs = {};
          this.dynamicAnchors = {};
          let schema;
          if (typeof env.schema == "object")
            schema = env.schema;
          this.schema = env.schema;
          this.schemaId = env.schemaId;
          this.root = env.root || this;
          this.baseId = (_a6 = env.baseId) !== null && _a6 !== void 0 ? _a6 : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
          this.schemaPath = env.schemaPath;
          this.localRefs = env.localRefs;
          this.meta = env.meta;
          this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
          this.refs = {};
        }
      };
      exports2.SchemaEnv = SchemaEnv;
      function compileSchema(sch) {
        const _sch = getCompilingSchema.call(this, sch);
        if (_sch)
          return _sch;
        const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId);
        const { es5, lines } = this.opts.code;
        const { ownProperties } = this.opts;
        const gen2 = new codegen_1.CodeGen(this.scope, { es5, lines, ownProperties });
        let _ValidationError;
        if (sch.$async) {
          _ValidationError = gen2.scopeValue("Error", {
            ref: validation_error_1.default,
            code: (0, codegen_1._)`require("ajv/dist/runtime/validation_error").default`
          });
        }
        const validateName = gen2.scopeName("validate");
        sch.validateName = validateName;
        const schemaCxt = {
          gen: gen2,
          allErrors: this.opts.allErrors,
          data: names_1.default.data,
          parentData: names_1.default.parentData,
          parentDataProperty: names_1.default.parentDataProperty,
          dataNames: [names_1.default.data],
          dataPathArr: [codegen_1.nil],
          // TODO can its length be used as dataLevel if nil is removed?
          dataLevel: 0,
          dataTypes: [],
          definedProperties: /* @__PURE__ */ new Set(),
          topSchemaRef: gen2.scopeValue("schema", this.opts.code.source === true ? { ref: sch.schema, code: (0, codegen_1.stringify)(sch.schema) } : { ref: sch.schema }),
          validateName,
          ValidationError: _ValidationError,
          schema: sch.schema,
          schemaEnv: sch,
          rootId,
          baseId: sch.baseId || rootId,
          schemaPath: codegen_1.nil,
          errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
          errorPath: (0, codegen_1._)`""`,
          opts: this.opts,
          self: this
        };
        let sourceCode;
        try {
          this._compilations.add(sch);
          (0, validate_1.validateFunctionCode)(schemaCxt);
          gen2.optimize(this.opts.code.optimize);
          const validateCode = gen2.toString();
          sourceCode = `${gen2.scopeRefs(names_1.default.scope)}return ${validateCode}`;
          if (this.opts.code.process)
            sourceCode = this.opts.code.process(sourceCode, sch);
          const makeValidate = new Function(`${names_1.default.self}`, `${names_1.default.scope}`, sourceCode);
          const validate = makeValidate(this, this.scope.get());
          this.scope.value(validateName, { ref: validate });
          validate.errors = null;
          validate.schema = sch.schema;
          validate.schemaEnv = sch;
          if (sch.$async)
            validate.$async = true;
          if (this.opts.code.source === true) {
            validate.source = { validateName, validateCode, scopeValues: gen2._values };
          }
          if (this.opts.unevaluated) {
            const { props, items } = schemaCxt;
            validate.evaluated = {
              props: props instanceof codegen_1.Name ? void 0 : props,
              items: items instanceof codegen_1.Name ? void 0 : items,
              dynamicProps: props instanceof codegen_1.Name,
              dynamicItems: items instanceof codegen_1.Name
            };
            if (validate.source)
              validate.source.evaluated = (0, codegen_1.stringify)(validate.evaluated);
          }
          sch.validate = validate;
          return sch;
        } catch (e2) {
          delete sch.validate;
          delete sch.validateName;
          if (sourceCode)
            this.logger.error("Error compiling schema, function code:", sourceCode);
          throw e2;
        } finally {
          this._compilations.delete(sch);
        }
      }
      exports2.compileSchema = compileSchema;
      function resolveRef(root, baseId, ref) {
        var _a6;
        ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref);
        const schOrFunc = root.refs[ref];
        if (schOrFunc)
          return schOrFunc;
        let _sch = resolve2.call(this, root, ref);
        if (_sch === void 0) {
          const schema = (_a6 = root.localRefs) === null || _a6 === void 0 ? void 0 : _a6[ref];
          const { schemaId } = this.opts;
          if (schema)
            _sch = new SchemaEnv({ schema, schemaId, root, baseId });
        }
        if (_sch === void 0)
          return;
        return root.refs[ref] = inlineOrCompile.call(this, _sch);
      }
      exports2.resolveRef = resolveRef;
      function inlineOrCompile(sch) {
        if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs))
          return sch.schema;
        return sch.validate ? sch : compileSchema.call(this, sch);
      }
      function getCompilingSchema(schEnv) {
        for (const sch of this._compilations) {
          if (sameSchemaEnv(sch, schEnv))
            return sch;
        }
      }
      exports2.getCompilingSchema = getCompilingSchema;
      function sameSchemaEnv(s1, s2) {
        return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
      }
      function resolve2(root, ref) {
        let sch;
        while (typeof (sch = this.refs[ref]) == "string")
          ref = sch;
        return sch || this.schemas[ref] || resolveSchema.call(this, root, ref);
      }
      function resolveSchema(root, ref) {
        const p12 = this.opts.uriResolver.parse(ref);
        const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p12);
        let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root.baseId, void 0);
        if (Object.keys(root.schema).length > 0 && refPath === baseId) {
          return getJsonPointer.call(this, p12, root);
        }
        const id = (0, resolve_1.normalizeId)(refPath);
        const schOrRef = this.refs[id] || this.schemas[id];
        if (typeof schOrRef == "string") {
          const sch = resolveSchema.call(this, root, schOrRef);
          if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object")
            return;
          return getJsonPointer.call(this, p12, sch);
        }
        if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object")
          return;
        if (!schOrRef.validate)
          compileSchema.call(this, schOrRef);
        if (id === (0, resolve_1.normalizeId)(ref)) {
          const { schema } = schOrRef;
          const { schemaId } = this.opts;
          const schId = schema[schemaId];
          if (schId)
            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
          return new SchemaEnv({ schema, schemaId, root, baseId });
        }
        return getJsonPointer.call(this, p12, schOrRef);
      }
      exports2.resolveSchema = resolveSchema;
      var PREVENT_SCOPE_CHANGE = /* @__PURE__ */ new Set([
        "properties",
        "patternProperties",
        "enum",
        "dependencies",
        "definitions"
      ]);
      function getJsonPointer(parsedRef, { baseId, schema, root }) {
        var _a6;
        if (((_a6 = parsedRef.fragment) === null || _a6 === void 0 ? void 0 : _a6[0]) !== "/")
          return;
        for (const part of parsedRef.fragment.slice(1).split("/")) {
          if (typeof schema === "boolean")
            return;
          const partSchema = schema[(0, util_1.unescapeFragment)(part)];
          if (partSchema === void 0)
            return;
          schema = partSchema;
          const schId = typeof schema === "object" && schema[this.opts.schemaId];
          if (!PREVENT_SCOPE_CHANGE.has(part) && schId) {
            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
          }
        }
        let env;
        if (typeof schema != "boolean" && schema.$ref && !(0, util_1.schemaHasRulesButRef)(schema, this.RULES)) {
          const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
          env = resolveSchema.call(this, root, $ref);
        }
        const { schemaId } = this.opts;
        env = env || new SchemaEnv({ schema, schemaId, root, baseId });
        if (env.schema !== env.root.schema)
          return env;
        return void 0;
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/refs/data.json
  var require_data = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/refs/data.json"(exports2, module2) {
      module2.exports = {
        $id: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
        description: "Meta-schema for $data reference (JSON AnySchema extension proposal)",
        type: "object",
        required: ["$data"],
        properties: {
          $data: {
            type: "string",
            anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }]
          }
        },
        additionalProperties: false
      };
    }
  });

  // ../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/lib/scopedChars.js
  var require_scopedChars = __commonJS({
    "../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/lib/scopedChars.js"(exports2, module2) {
      "use strict";
      var HEX = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        a: 10,
        A: 10,
        b: 11,
        B: 11,
        c: 12,
        C: 12,
        d: 13,
        D: 13,
        e: 14,
        E: 14,
        f: 15,
        F: 15
      };
      module2.exports = {
        HEX
      };
    }
  });

  // ../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/lib/utils.js
  var require_utils2 = __commonJS({
    "../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/lib/utils.js"(exports2, module2) {
      "use strict";
      var { HEX } = require_scopedChars();
      var IPV4_REG = /^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)$/u;
      function normalizeIPv4(host) {
        if (findToken(host, ".") < 3) {
          return { host, isIPV4: false };
        }
        const matches = host.match(IPV4_REG) || [];
        const [address] = matches;
        if (address) {
          return { host: stripLeadingZeros(address, "."), isIPV4: true };
        } else {
          return { host, isIPV4: false };
        }
      }
      function stringArrayToHexStripped(input, keepZero = false) {
        let acc = "";
        let strip = true;
        for (const c of input) {
          if (HEX[c] === void 0) return void 0;
          if (c !== "0" && strip === true) strip = false;
          if (!strip) acc += c;
        }
        if (keepZero && acc.length === 0) acc = "0";
        return acc;
      }
      function getIPV6(input) {
        let tokenCount = 0;
        const output3 = { error: false, address: "", zone: "" };
        const address = [];
        const buffer = [];
        let isZone = false;
        let endipv6Encountered = false;
        let endIpv6 = false;
        function consume() {
          if (buffer.length) {
            if (isZone === false) {
              const hex = stringArrayToHexStripped(buffer);
              if (hex !== void 0) {
                address.push(hex);
              } else {
                output3.error = true;
                return false;
              }
            }
            buffer.length = 0;
          }
          return true;
        }
        for (let i2 = 0; i2 < input.length; i2++) {
          const cursor = input[i2];
          if (cursor === "[" || cursor === "]") {
            continue;
          }
          if (cursor === ":") {
            if (endipv6Encountered === true) {
              endIpv6 = true;
            }
            if (!consume()) {
              break;
            }
            tokenCount++;
            address.push(":");
            if (tokenCount > 7) {
              output3.error = true;
              break;
            }
            if (i2 - 1 >= 0 && input[i2 - 1] === ":") {
              endipv6Encountered = true;
            }
            continue;
          } else if (cursor === "%") {
            if (!consume()) {
              break;
            }
            isZone = true;
          } else {
            buffer.push(cursor);
            continue;
          }
        }
        if (buffer.length) {
          if (isZone) {
            output3.zone = buffer.join("");
          } else if (endIpv6) {
            address.push(buffer.join(""));
          } else {
            address.push(stringArrayToHexStripped(buffer));
          }
        }
        output3.address = address.join("");
        return output3;
      }
      function normalizeIPv6(host) {
        if (findToken(host, ":") < 2) {
          return { host, isIPV6: false };
        }
        const ipv6 = getIPV6(host);
        if (!ipv6.error) {
          let newHost = ipv6.address;
          let escapedHost = ipv6.address;
          if (ipv6.zone) {
            newHost += "%" + ipv6.zone;
            escapedHost += "%25" + ipv6.zone;
          }
          return { host: newHost, escapedHost, isIPV6: true };
        } else {
          return { host, isIPV6: false };
        }
      }
      function stripLeadingZeros(str, token) {
        let out = "";
        let skip = true;
        const l = str.length;
        for (let i2 = 0; i2 < l; i2++) {
          const c = str[i2];
          if (c === "0" && skip) {
            if (i2 + 1 <= l && str[i2 + 1] === token || i2 + 1 === l) {
              out += c;
              skip = false;
            }
          } else {
            if (c === token) {
              skip = true;
            } else {
              skip = false;
            }
            out += c;
          }
        }
        return out;
      }
      function findToken(str, token) {
        let ind = 0;
        for (let i2 = 0; i2 < str.length; i2++) {
          if (str[i2] === token) ind++;
        }
        return ind;
      }
      var RDS1 = /^\.\.?\//u;
      var RDS2 = /^\/\.(?:\/|$)/u;
      var RDS3 = /^\/\.\.(?:\/|$)/u;
      var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/u;
      function removeDotSegments(input) {
        const output3 = [];
        while (input.length) {
          if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
          } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
          } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output3.pop();
          } else if (input === "." || input === "..") {
            input = "";
          } else {
            const im = input.match(RDS5);
            if (im) {
              const s2 = im[0];
              input = input.slice(s2.length);
              output3.push(s2);
            } else {
              throw new Error("Unexpected dot segment condition");
            }
          }
        }
        return output3.join("");
      }
      function normalizeComponentEncoding(components, esc) {
        const func = esc !== true ? escape : unescape;
        if (components.scheme !== void 0) {
          components.scheme = func(components.scheme);
        }
        if (components.userinfo !== void 0) {
          components.userinfo = func(components.userinfo);
        }
        if (components.host !== void 0) {
          components.host = func(components.host);
        }
        if (components.path !== void 0) {
          components.path = func(components.path);
        }
        if (components.query !== void 0) {
          components.query = func(components.query);
        }
        if (components.fragment !== void 0) {
          components.fragment = func(components.fragment);
        }
        return components;
      }
      function recomposeAuthority(components) {
        const uriTokens = [];
        if (components.userinfo !== void 0) {
          uriTokens.push(components.userinfo);
          uriTokens.push("@");
        }
        if (components.host !== void 0) {
          let host = unescape(components.host);
          const ipV4res = normalizeIPv4(host);
          if (ipV4res.isIPV4) {
            host = ipV4res.host;
          } else {
            const ipV6res = normalizeIPv6(ipV4res.host);
            if (ipV6res.isIPV6 === true) {
              host = `[${ipV6res.escapedHost}]`;
            } else {
              host = components.host;
            }
          }
          uriTokens.push(host);
        }
        if (typeof components.port === "number" || typeof components.port === "string") {
          uriTokens.push(":");
          uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : void 0;
      }
      module2.exports = {
        recomposeAuthority,
        normalizeComponentEncoding,
        removeDotSegments,
        normalizeIPv4,
        normalizeIPv6,
        stringArrayToHexStripped
      };
    }
  });

  // ../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/lib/schemes.js
  var require_schemes = __commonJS({
    "../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/lib/schemes.js"(exports2, module2) {
      "use strict";
      var UUID_REG = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/iu;
      var URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
      function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
      }
      function httpParse(components) {
        if (!components.host) {
          components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
      }
      function httpSerialize(components) {
        const secure = String(components.scheme).toLowerCase() === "https";
        if (components.port === (secure ? 443 : 80) || components.port === "") {
          components.port = void 0;
        }
        if (!components.path) {
          components.path = "/";
        }
        return components;
      }
      function wsParse(wsComponents) {
        wsComponents.secure = isSecure(wsComponents);
        wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
        wsComponents.path = void 0;
        wsComponents.query = void 0;
        return wsComponents;
      }
      function wsSerialize(wsComponents) {
        if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
          wsComponents.port = void 0;
        }
        if (typeof wsComponents.secure === "boolean") {
          wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
          wsComponents.secure = void 0;
        }
        if (wsComponents.resourceName) {
          const [path3, query] = wsComponents.resourceName.split("?");
          wsComponents.path = path3 && path3 !== "/" ? path3 : void 0;
          wsComponents.query = query;
          wsComponents.resourceName = void 0;
        }
        wsComponents.fragment = void 0;
        return wsComponents;
      }
      function urnParse(urnComponents, options) {
        if (!urnComponents.path) {
          urnComponents.error = "URN can not be parsed";
          return urnComponents;
        }
        const matches = urnComponents.path.match(URN_REG);
        if (matches) {
          const scheme = options.scheme || urnComponents.scheme || "urn";
          urnComponents.nid = matches[1].toLowerCase();
          urnComponents.nss = matches[2];
          const urnScheme = `${scheme}:${options.nid || urnComponents.nid}`;
          const schemeHandler = SCHEMES[urnScheme];
          urnComponents.path = void 0;
          if (schemeHandler) {
            urnComponents = schemeHandler.parse(urnComponents, options);
          }
        } else {
          urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
      }
      function urnSerialize(urnComponents, options) {
        const scheme = options.scheme || urnComponents.scheme || "urn";
        const nid = urnComponents.nid.toLowerCase();
        const urnScheme = `${scheme}:${options.nid || nid}`;
        const schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
          urnComponents = schemeHandler.serialize(urnComponents, options);
        }
        const uriComponents = urnComponents;
        const nss = urnComponents.nss;
        uriComponents.path = `${nid || options.nid}:${nss}`;
        options.skipEscape = true;
        return uriComponents;
      }
      function urnuuidParse(urnComponents, options) {
        const uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = void 0;
        if (!options.tolerant && (!uuidComponents.uuid || !UUID_REG.test(uuidComponents.uuid))) {
          uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
      }
      function urnuuidSerialize(uuidComponents) {
        const urnComponents = uuidComponents;
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
      }
      var http2 = {
        scheme: "http",
        domainHost: true,
        parse: httpParse,
        serialize: httpSerialize
      };
      var https = {
        scheme: "https",
        domainHost: http2.domainHost,
        parse: httpParse,
        serialize: httpSerialize
      };
      var ws2 = {
        scheme: "ws",
        domainHost: true,
        parse: wsParse,
        serialize: wsSerialize
      };
      var wss = {
        scheme: "wss",
        domainHost: ws2.domainHost,
        parse: ws2.parse,
        serialize: ws2.serialize
      };
      var urn = {
        scheme: "urn",
        parse: urnParse,
        serialize: urnSerialize,
        skipNormalize: true
      };
      var urnuuid = {
        scheme: "urn:uuid",
        parse: urnuuidParse,
        serialize: urnuuidSerialize,
        skipNormalize: true
      };
      var SCHEMES = {
        http: http2,
        https,
        ws: ws2,
        wss,
        urn,
        "urn:uuid": urnuuid
      };
      module2.exports = SCHEMES;
    }
  });

  // ../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/index.js
  var require_fast_uri = __commonJS({
    "../../node_modules/.pnpm/fast-uri@3.0.6/node_modules/fast-uri/index.js"(exports2, module2) {
      "use strict";
      var { normalizeIPv6, normalizeIPv4, removeDotSegments, recomposeAuthority, normalizeComponentEncoding } = require_utils2();
      var SCHEMES = require_schemes();
      function normalize5(uri, options) {
        if (typeof uri === "string") {
          uri = serialize(parse4(uri, options), options);
        } else if (typeof uri === "object") {
          uri = parse4(serialize(uri, options), options);
        }
        return uri;
      }
      function resolve2(baseURI, relativeURI, options) {
        const schemelessOptions = Object.assign({ scheme: "null" }, options);
        const resolved = resolveComponents(parse4(baseURI, schemelessOptions), parse4(relativeURI, schemelessOptions), schemelessOptions, true);
        return serialize(resolved, { ...schemelessOptions, skipEscape: true });
      }
      function resolveComponents(base2, relative2, options, skipNormalization) {
        const target = {};
        if (!skipNormalization) {
          base2 = parse4(serialize(base2, options), options);
          relative2 = parse4(serialize(relative2, options), options);
        }
        options = options || {};
        if (!options.tolerant && relative2.scheme) {
          target.scheme = relative2.scheme;
          target.userinfo = relative2.userinfo;
          target.host = relative2.host;
          target.port = relative2.port;
          target.path = removeDotSegments(relative2.path || "");
          target.query = relative2.query;
        } else {
          if (relative2.userinfo !== void 0 || relative2.host !== void 0 || relative2.port !== void 0) {
            target.userinfo = relative2.userinfo;
            target.host = relative2.host;
            target.port = relative2.port;
            target.path = removeDotSegments(relative2.path || "");
            target.query = relative2.query;
          } else {
            if (!relative2.path) {
              target.path = base2.path;
              if (relative2.query !== void 0) {
                target.query = relative2.query;
              } else {
                target.query = base2.query;
              }
            } else {
              if (relative2.path.charAt(0) === "/") {
                target.path = removeDotSegments(relative2.path);
              } else {
                if ((base2.userinfo !== void 0 || base2.host !== void 0 || base2.port !== void 0) && !base2.path) {
                  target.path = "/" + relative2.path;
                } else if (!base2.path) {
                  target.path = relative2.path;
                } else {
                  target.path = base2.path.slice(0, base2.path.lastIndexOf("/") + 1) + relative2.path;
                }
                target.path = removeDotSegments(target.path);
              }
              target.query = relative2.query;
            }
            target.userinfo = base2.userinfo;
            target.host = base2.host;
            target.port = base2.port;
          }
          target.scheme = base2.scheme;
        }
        target.fragment = relative2.fragment;
        return target;
      }
      function equal(uriA, uriB, options) {
        if (typeof uriA === "string") {
          uriA = unescape(uriA);
          uriA = serialize(normalizeComponentEncoding(parse4(uriA, options), true), { ...options, skipEscape: true });
        } else if (typeof uriA === "object") {
          uriA = serialize(normalizeComponentEncoding(uriA, true), { ...options, skipEscape: true });
        }
        if (typeof uriB === "string") {
          uriB = unescape(uriB);
          uriB = serialize(normalizeComponentEncoding(parse4(uriB, options), true), { ...options, skipEscape: true });
        } else if (typeof uriB === "object") {
          uriB = serialize(normalizeComponentEncoding(uriB, true), { ...options, skipEscape: true });
        }
        return uriA.toLowerCase() === uriB.toLowerCase();
      }
      function serialize(cmpts, opts) {
        const components = {
          host: cmpts.host,
          scheme: cmpts.scheme,
          userinfo: cmpts.userinfo,
          port: cmpts.port,
          path: cmpts.path,
          query: cmpts.query,
          nid: cmpts.nid,
          nss: cmpts.nss,
          uuid: cmpts.uuid,
          fragment: cmpts.fragment,
          reference: cmpts.reference,
          resourceName: cmpts.resourceName,
          secure: cmpts.secure,
          error: ""
        };
        const options = Object.assign({}, opts);
        const uriTokens = [];
        const schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.path !== void 0) {
          if (!options.skipEscape) {
            components.path = escape(components.path);
            if (components.scheme !== void 0) {
              components.path = components.path.split("%3A").join(":");
            }
          } else {
            components.path = unescape(components.path);
          }
        }
        if (options.reference !== "suffix" && components.scheme) {
          uriTokens.push(components.scheme, ":");
        }
        const authority = recomposeAuthority(components);
        if (authority !== void 0) {
          if (options.reference !== "suffix") {
            uriTokens.push("//");
          }
          uriTokens.push(authority);
          if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
          }
        }
        if (components.path !== void 0) {
          let s2 = components.path;
          if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s2 = removeDotSegments(s2);
          }
          if (authority === void 0) {
            s2 = s2.replace(/^\/\//u, "/%2F");
          }
          uriTokens.push(s2);
        }
        if (components.query !== void 0) {
          uriTokens.push("?", components.query);
        }
        if (components.fragment !== void 0) {
          uriTokens.push("#", components.fragment);
        }
        return uriTokens.join("");
      }
      var hexLookUp = Array.from({ length: 127 }, (_v, k) => /[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(k)));
      function nonSimpleDomain(value) {
        let code = 0;
        for (let i2 = 0, len = value.length; i2 < len; ++i2) {
          code = value.charCodeAt(i2);
          if (code > 126 || hexLookUp[code]) {
            return true;
          }
        }
        return false;
      }
      var URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
      function parse4(uri, opts) {
        const options = Object.assign({}, opts);
        const parsed = {
          scheme: void 0,
          userinfo: void 0,
          host: "",
          port: void 0,
          path: "",
          query: void 0,
          fragment: void 0
        };
        const gotEncoding = uri.indexOf("%") !== -1;
        let isIP = false;
        if (options.reference === "suffix") uri = (options.scheme ? options.scheme + ":" : "") + "//" + uri;
        const matches = uri.match(URI_PARSE);
        if (matches) {
          parsed.scheme = matches[1];
          parsed.userinfo = matches[3];
          parsed.host = matches[4];
          parsed.port = parseInt(matches[5], 10);
          parsed.path = matches[6] || "";
          parsed.query = matches[7];
          parsed.fragment = matches[8];
          if (isNaN(parsed.port)) {
            parsed.port = matches[5];
          }
          if (parsed.host) {
            const ipv4result = normalizeIPv4(parsed.host);
            if (ipv4result.isIPV4 === false) {
              const ipv6result = normalizeIPv6(ipv4result.host);
              parsed.host = ipv6result.host.toLowerCase();
              isIP = ipv6result.isIPV6;
            } else {
              parsed.host = ipv4result.host;
              isIP = true;
            }
          }
          if (parsed.scheme === void 0 && parsed.userinfo === void 0 && parsed.host === void 0 && parsed.port === void 0 && parsed.query === void 0 && !parsed.path) {
            parsed.reference = "same-document";
          } else if (parsed.scheme === void 0) {
            parsed.reference = "relative";
          } else if (parsed.fragment === void 0) {
            parsed.reference = "absolute";
          } else {
            parsed.reference = "uri";
          }
          if (options.reference && options.reference !== "suffix" && options.reference !== parsed.reference) {
            parsed.error = parsed.error || "URI is not a " + options.reference + " reference.";
          }
          const schemeHandler = SCHEMES[(options.scheme || parsed.scheme || "").toLowerCase()];
          if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && nonSimpleDomain(parsed.host)) {
              try {
                parsed.host = URL.domainToASCII(parsed.host.toLowerCase());
              } catch (e2) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e2;
              }
            }
          }
          if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (gotEncoding && parsed.scheme !== void 0) {
              parsed.scheme = unescape(parsed.scheme);
            }
            if (gotEncoding && parsed.host !== void 0) {
              parsed.host = unescape(parsed.host);
            }
            if (parsed.path) {
              parsed.path = escape(unescape(parsed.path));
            }
            if (parsed.fragment) {
              parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
            }
          }
          if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(parsed, options);
          }
        } else {
          parsed.error = parsed.error || "URI can not be parsed.";
        }
        return parsed;
      }
      var fastUri = {
        SCHEMES,
        normalize: normalize5,
        resolve: resolve2,
        resolveComponents,
        equal,
        serialize,
        parse: parse4
      };
      module2.exports = fastUri;
      module2.exports.default = fastUri;
      module2.exports.fastUri = fastUri;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/uri.js
  var require_uri = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/uri.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var uri = require_fast_uri();
      uri.code = 'require("ajv/dist/runtime/uri").default';
      exports2.default = uri;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/core.js
  var require_core = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/core.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.CodeGen = exports2.Name = exports2.nil = exports2.stringify = exports2.str = exports2._ = exports2.KeywordCxt = void 0;
      var validate_1 = require_validate();
      Object.defineProperty(exports2, "KeywordCxt", { enumerable: true, get: function() {
        return validate_1.KeywordCxt;
      } });
      var codegen_1 = require_codegen();
      Object.defineProperty(exports2, "_", { enumerable: true, get: function() {
        return codegen_1._;
      } });
      Object.defineProperty(exports2, "str", { enumerable: true, get: function() {
        return codegen_1.str;
      } });
      Object.defineProperty(exports2, "stringify", { enumerable: true, get: function() {
        return codegen_1.stringify;
      } });
      Object.defineProperty(exports2, "nil", { enumerable: true, get: function() {
        return codegen_1.nil;
      } });
      Object.defineProperty(exports2, "Name", { enumerable: true, get: function() {
        return codegen_1.Name;
      } });
      Object.defineProperty(exports2, "CodeGen", { enumerable: true, get: function() {
        return codegen_1.CodeGen;
      } });
      var validation_error_1 = require_validation_error();
      var ref_error_1 = require_ref_error();
      var rules_1 = require_rules();
      var compile_1 = require_compile();
      var codegen_2 = require_codegen();
      var resolve_1 = require_resolve();
      var dataType_1 = require_dataType();
      var util_1 = require_util2();
      var $dataRefSchema = require_data();
      var uri_1 = require_uri();
      var defaultRegExp = (str, flags) => new RegExp(str, flags);
      defaultRegExp.code = "new RegExp";
      var META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes"];
      var EXT_SCOPE_NAMES = /* @__PURE__ */ new Set([
        "validate",
        "serialize",
        "parse",
        "wrapper",
        "root",
        "schema",
        "keyword",
        "pattern",
        "formats",
        "validate$data",
        "func",
        "obj",
        "Error"
      ]);
      var removedOptions = {
        errorDataPath: "",
        format: "`validateFormats: false` can be used instead.",
        nullable: '"nullable" keyword is supported by default.',
        jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
        extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
        missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
        processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
        sourceCode: "Use option `code: {source: true}`",
        strictDefaults: "It is default now, see option `strict`.",
        strictKeywords: "It is default now, see option `strict`.",
        uniqueItems: '"uniqueItems" keyword is always validated.',
        unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
        cache: "Map is used as cache, schema object as key.",
        serialize: "Map is used as cache, schema object as key.",
        ajvErrors: "It is default now."
      };
      var deprecatedOptions = {
        ignoreKeywordsWithRef: "",
        jsPropertySyntax: "",
        unicode: '"minLength"/"maxLength" account for unicode characters by default.'
      };
      var MAX_EXPRESSION = 200;
      function requiredOptions(o) {
        var _a6, _b3, _c2, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        const s2 = o.strict;
        const _optz = (_a6 = o.code) === null || _a6 === void 0 ? void 0 : _a6.optimize;
        const optimize = _optz === true || _optz === void 0 ? 1 : _optz || 0;
        const regExp = (_c2 = (_b3 = o.code) === null || _b3 === void 0 ? void 0 : _b3.regExp) !== null && _c2 !== void 0 ? _c2 : defaultRegExp;
        const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : uri_1.default;
        return {
          strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s2) !== null && _f !== void 0 ? _f : true,
          strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s2) !== null && _h !== void 0 ? _h : true,
          strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s2) !== null && _k !== void 0 ? _k : "log",
          strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s2) !== null && _m !== void 0 ? _m : "log",
          strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s2) !== null && _p !== void 0 ? _p : false,
          code: o.code ? { ...o.code, optimize, regExp } : { optimize, regExp },
          loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
          loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : MAX_EXPRESSION,
          meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
          messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
          inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
          schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
          addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
          validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
          validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
          unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
          int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
          uriResolver
        };
      }
      var Ajv2 = class {
        constructor(opts = {}) {
          this.schemas = {};
          this.refs = {};
          this.formats = {};
          this._compilations = /* @__PURE__ */ new Set();
          this._loading = {};
          this._cache = /* @__PURE__ */ new Map();
          opts = this.opts = { ...opts, ...requiredOptions(opts) };
          const { es5, lines } = this.opts.code;
          this.scope = new codegen_2.ValueScope({ scope: {}, prefixes: EXT_SCOPE_NAMES, es5, lines });
          this.logger = getLogger(opts.logger);
          const formatOpt = opts.validateFormats;
          opts.validateFormats = false;
          this.RULES = (0, rules_1.getRules)();
          checkOptions2.call(this, removedOptions, opts, "NOT SUPPORTED");
          checkOptions2.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
          this._metaOpts = getMetaSchemaOptions.call(this);
          if (opts.formats)
            addInitialFormats.call(this);
          this._addVocabularies();
          this._addDefaultMetaSchema();
          if (opts.keywords)
            addInitialKeywords.call(this, opts.keywords);
          if (typeof opts.meta == "object")
            this.addMetaSchema(opts.meta);
          addInitialSchemas.call(this);
          opts.validateFormats = formatOpt;
        }
        _addVocabularies() {
          this.addKeyword("$async");
        }
        _addDefaultMetaSchema() {
          const { $data, meta, schemaId } = this.opts;
          let _dataRefSchema = $dataRefSchema;
          if (schemaId === "id") {
            _dataRefSchema = { ...$dataRefSchema };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
          }
          if (meta && $data)
            this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
        }
        defaultMeta() {
          const { meta, schemaId } = this.opts;
          return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : void 0;
        }
        validate(schemaKeyRef, data) {
          let v;
          if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v)
              throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
          } else {
            v = this.compile(schemaKeyRef);
          }
          const valid = v(data);
          if (!("$async" in v))
            this.errors = v.errors;
          return valid;
        }
        compile(schema, _meta) {
          const sch = this._addSchema(schema, _meta);
          return sch.validate || this._compileSchemaEnv(sch);
        }
        compileAsync(schema, meta) {
          if (typeof this.opts.loadSchema != "function") {
            throw new Error("options.loadSchema should be a function");
          }
          const { loadSchema } = this.opts;
          return runCompileAsync.call(this, schema, meta);
          async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
          }
          async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) {
              await runCompileAsync.call(this, { $ref }, true);
            }
          }
          async function _compileAsync(sch) {
            try {
              return this._compileSchemaEnv(sch);
            } catch (e2) {
              if (!(e2 instanceof ref_error_1.default))
                throw e2;
              checkLoaded.call(this, e2);
              await loadMissingSchema.call(this, e2.missingSchema);
              return _compileAsync.call(this, sch);
            }
          }
          function checkLoaded({ missingSchema: ref, missingRef }) {
            if (this.refs[ref]) {
              throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
            }
          }
          async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref])
              await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref])
              this.addSchema(_schema, ref, meta);
          }
          async function _loadSchema(ref) {
            const p12 = this._loading[ref];
            if (p12)
              return p12;
            try {
              return await (this._loading[ref] = loadSchema(ref));
            } finally {
              delete this._loading[ref];
            }
          }
        }
        // Adds schema to the instance
        addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema) {
          if (Array.isArray(schema)) {
            for (const sch of schema)
              this.addSchema(sch, void 0, _meta, _validateSchema);
            return this;
          }
          let id;
          if (typeof schema === "object") {
            const { schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== void 0 && typeof id != "string") {
              throw new Error(`schema ${schemaId} must be string`);
            }
          }
          key = (0, resolve_1.normalizeId)(key || id);
          this._checkUnique(key);
          this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
          return this;
        }
        // Add schema that will be used to validate other schemas
        // options in META_IGNORE_OPTIONS are alway set to false
        addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema) {
          this.addSchema(schema, key, true, _validateSchema);
          return this;
        }
        //  Validate schema against its meta-schema
        validateSchema(schema, throwOrLogError) {
          if (typeof schema == "boolean")
            return true;
          let $schema;
          $schema = schema.$schema;
          if ($schema !== void 0 && typeof $schema != "string") {
            throw new Error("$schema must be a string");
          }
          $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
          if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
          }
          const valid = this.validate($schema, schema);
          if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log")
              this.logger.error(message);
            else
              throw new Error(message);
          }
          return valid;
        }
        // Get compiled schema by `key` or `ref`.
        // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
        getSchema(keyRef) {
          let sch;
          while (typeof (sch = getSchEnv.call(this, keyRef)) == "string")
            keyRef = sch;
          if (sch === void 0) {
            const { schemaId } = this.opts;
            const root = new compile_1.SchemaEnv({ schema: {}, schemaId });
            sch = compile_1.resolveSchema.call(this, root, keyRef);
            if (!sch)
              return;
            this.refs[keyRef] = sch;
          }
          return sch.validate || this._compileSchemaEnv(sch);
        }
        // Remove cached schema(s).
        // If no parameter is passed all schemas but meta-schemas are removed.
        // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
        // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
        removeSchema(schemaKeyRef) {
          if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
          }
          switch (typeof schemaKeyRef) {
            case "undefined":
              this._removeAllSchemas(this.schemas);
              this._removeAllSchemas(this.refs);
              this._cache.clear();
              return this;
            case "string": {
              const sch = getSchEnv.call(this, schemaKeyRef);
              if (typeof sch == "object")
                this._cache.delete(sch.schema);
              delete this.schemas[schemaKeyRef];
              delete this.refs[schemaKeyRef];
              return this;
            }
            case "object": {
              const cacheKey = schemaKeyRef;
              this._cache.delete(cacheKey);
              let id = schemaKeyRef[this.opts.schemaId];
              if (id) {
                id = (0, resolve_1.normalizeId)(id);
                delete this.schemas[id];
                delete this.refs[id];
              }
              return this;
            }
            default:
              throw new Error("ajv.removeSchema: invalid parameter");
          }
        }
        // add "vocabulary" - a collection of keywords
        addVocabulary(definitions) {
          for (const def of definitions)
            this.addKeyword(def);
          return this;
        }
        addKeyword(kwdOrDef, def) {
          let keyword;
          if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
              this.logger.warn("these parameters are deprecated, see docs for addKeyword");
              def.keyword = keyword;
            }
          } else if (typeof kwdOrDef == "object" && def === void 0) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) {
              throw new Error("addKeywords: keyword must be string or non-empty array");
            }
          } else {
            throw new Error("invalid addKeywords parameters");
          }
          checkKeyword.call(this, keyword, def);
          if (!def) {
            (0, util_1.eachItem)(keyword, (kwd) => addRule.call(this, kwd));
            return this;
          }
          keywordMetaschema.call(this, def);
          const definition = {
            ...def,
            type: (0, dataType_1.getJSONTypes)(def.type),
            schemaType: (0, dataType_1.getJSONTypes)(def.schemaType)
          };
          (0, util_1.eachItem)(keyword, definition.type.length === 0 ? (k) => addRule.call(this, k, definition) : (k) => definition.type.forEach((t2) => addRule.call(this, k, definition, t2)));
          return this;
        }
        getKeyword(keyword) {
          const rule = this.RULES.all[keyword];
          return typeof rule == "object" ? rule.definition : !!rule;
        }
        // Remove keyword
        removeKeyword(keyword) {
          const { RULES } = this;
          delete RULES.keywords[keyword];
          delete RULES.all[keyword];
          for (const group of RULES.rules) {
            const i2 = group.rules.findIndex((rule) => rule.keyword === keyword);
            if (i2 >= 0)
              group.rules.splice(i2, 1);
          }
          return this;
        }
        // Add format
        addFormat(name2, format5) {
          if (typeof format5 == "string")
            format5 = new RegExp(format5);
          this.formats[name2] = format5;
          return this;
        }
        errorsText(errors = this.errors, { separator = ", ", dataVar = "data" } = {}) {
          if (!errors || errors.length === 0)
            return "No errors";
          return errors.map((e2) => `${dataVar}${e2.instancePath} ${e2.message}`).reduce((text, msg) => text + separator + msg);
        }
        $dataMetaSchema(metaSchema, keywordsJsonPointers) {
          const rules = this.RULES.all;
          metaSchema = JSON.parse(JSON.stringify(metaSchema));
          for (const jsonPointer of keywordsJsonPointers) {
            const segments = jsonPointer.split("/").slice(1);
            let keywords = metaSchema;
            for (const seg of segments)
              keywords = keywords[seg];
            for (const key in rules) {
              const rule = rules[key];
              if (typeof rule != "object")
                continue;
              const { $data } = rule.definition;
              const schema = keywords[key];
              if ($data && schema)
                keywords[key] = schemaOrData(schema);
            }
          }
          return metaSchema;
        }
        _removeAllSchemas(schemas, regex) {
          for (const keyRef in schemas) {
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
              if (typeof sch == "string") {
                delete schemas[keyRef];
              } else if (sch && !sch.meta) {
                this._cache.delete(sch.schema);
                delete schemas[keyRef];
              }
            }
          }
        }
        _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
          let id;
          const { schemaId } = this.opts;
          if (typeof schema == "object") {
            id = schema[schemaId];
          } else {
            if (this.opts.jtd)
              throw new Error("schema must be object");
            else if (typeof schema != "boolean")
              throw new Error("schema must be object or boolean");
          }
          let sch = this._cache.get(schema);
          if (sch !== void 0)
            return sch;
          baseId = (0, resolve_1.normalizeId)(id || baseId);
          const localRefs = resolve_1.getSchemaRefs.call(this, schema, baseId);
          sch = new compile_1.SchemaEnv({ schema, schemaId, meta, baseId, localRefs });
          this._cache.set(sch.schema, sch);
          if (addSchema && !baseId.startsWith("#")) {
            if (baseId)
              this._checkUnique(baseId);
            this.refs[baseId] = sch;
          }
          if (validateSchema)
            this.validateSchema(schema, true);
          return sch;
        }
        _checkUnique(id) {
          if (this.schemas[id] || this.refs[id]) {
            throw new Error(`schema with key or id "${id}" already exists`);
          }
        }
        _compileSchemaEnv(sch) {
          if (sch.meta)
            this._compileMetaSchema(sch);
          else
            compile_1.compileSchema.call(this, sch);
          if (!sch.validate)
            throw new Error("ajv implementation error");
          return sch.validate;
        }
        _compileMetaSchema(sch) {
          const currentOpts = this.opts;
          this.opts = this._metaOpts;
          try {
            compile_1.compileSchema.call(this, sch);
          } finally {
            this.opts = currentOpts;
          }
        }
      };
      Ajv2.ValidationError = validation_error_1.default;
      Ajv2.MissingRefError = ref_error_1.default;
      exports2.default = Ajv2;
      function checkOptions2(checkOpts2, options, msg, log2 = "error") {
        for (const key in checkOpts2) {
          const opt = key;
          if (opt in options)
            this.logger[log2](`${msg}: option ${key}. ${checkOpts2[opt]}`);
        }
      }
      function getSchEnv(keyRef) {
        keyRef = (0, resolve_1.normalizeId)(keyRef);
        return this.schemas[keyRef] || this.refs[keyRef];
      }
      function addInitialSchemas() {
        const optsSchemas = this.opts.schemas;
        if (!optsSchemas)
          return;
        if (Array.isArray(optsSchemas))
          this.addSchema(optsSchemas);
        else
          for (const key in optsSchemas)
            this.addSchema(optsSchemas[key], key);
      }
      function addInitialFormats() {
        for (const name2 in this.opts.formats) {
          const format5 = this.opts.formats[name2];
          if (format5)
            this.addFormat(name2, format5);
        }
      }
      function addInitialKeywords(defs) {
        if (Array.isArray(defs)) {
          this.addVocabulary(defs);
          return;
        }
        this.logger.warn("keywords option as map is deprecated, pass array");
        for (const keyword in defs) {
          const def = defs[keyword];
          if (!def.keyword)
            def.keyword = keyword;
          this.addKeyword(def);
        }
      }
      function getMetaSchemaOptions() {
        const metaOpts = { ...this.opts };
        for (const opt of META_IGNORE_OPTIONS)
          delete metaOpts[opt];
        return metaOpts;
      }
      var noLogs = { log() {
      }, warn() {
      }, error() {
      } };
      function getLogger(logger) {
        if (logger === false)
          return noLogs;
        if (logger === void 0)
          return console;
        if (logger.log && logger.warn && logger.error)
          return logger;
        throw new Error("logger must implement log, warn and error methods");
      }
      var KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
      function checkKeyword(keyword, def) {
        const { RULES } = this;
        (0, util_1.eachItem)(keyword, (kwd) => {
          if (RULES.keywords[kwd])
            throw new Error(`Keyword ${kwd} is already defined`);
          if (!KEYWORD_NAME.test(kwd))
            throw new Error(`Keyword ${kwd} has invalid name`);
        });
        if (!def)
          return;
        if (def.$data && !("code" in def || "validate" in def)) {
          throw new Error('$data keyword must have "code" or "validate" function');
        }
      }
      function addRule(keyword, definition, dataType) {
        var _a6;
        const post = definition === null || definition === void 0 ? void 0 : definition.post;
        if (dataType && post)
          throw new Error('keyword with "post" flag cannot have "type"');
        const { RULES } = this;
        let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t2 }) => t2 === dataType);
        if (!ruleGroup) {
          ruleGroup = { type: dataType, rules: [] };
          RULES.rules.push(ruleGroup);
        }
        RULES.keywords[keyword] = true;
        if (!definition)
          return;
        const rule = {
          keyword,
          definition: {
            ...definition,
            type: (0, dataType_1.getJSONTypes)(definition.type),
            schemaType: (0, dataType_1.getJSONTypes)(definition.schemaType)
          }
        };
        if (definition.before)
          addBeforeRule.call(this, ruleGroup, rule, definition.before);
        else
          ruleGroup.rules.push(rule);
        RULES.all[keyword] = rule;
        (_a6 = definition.implements) === null || _a6 === void 0 ? void 0 : _a6.forEach((kwd) => this.addKeyword(kwd));
      }
      function addBeforeRule(ruleGroup, rule, before) {
        const i2 = ruleGroup.rules.findIndex((_rule) => _rule.keyword === before);
        if (i2 >= 0) {
          ruleGroup.rules.splice(i2, 0, rule);
        } else {
          ruleGroup.rules.push(rule);
          this.logger.warn(`rule ${before} is not defined`);
        }
      }
      function keywordMetaschema(def) {
        let { metaSchema } = def;
        if (metaSchema === void 0)
          return;
        if (def.$data && this.opts.$data)
          metaSchema = schemaOrData(metaSchema);
        def.validateSchema = this.compile(metaSchema, true);
      }
      var $dataRef = {
        $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
      };
      function schemaOrData(schema) {
        return { anyOf: [schema, $dataRef] };
      }
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/core/id.js
  var require_id = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/core/id.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var def = {
        keyword: "id",
        code() {
          throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/core/ref.js
  var require_ref = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/core/ref.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.callRef = exports2.getValidate = void 0;
      var ref_error_1 = require_ref_error();
      var code_1 = require_code2();
      var codegen_1 = require_codegen();
      var names_1 = require_names();
      var compile_1 = require_compile();
      var util_1 = require_util2();
      var def = {
        keyword: "$ref",
        schemaType: "string",
        code(cxt) {
          const { gen: gen2, schema: $ref, it } = cxt;
          const { baseId, schemaEnv: env, validateName, opts, self: self2 } = it;
          const { root } = env;
          if (($ref === "#" || $ref === "#/") && baseId === root.baseId)
            return callRootRef();
          const schOrEnv = compile_1.resolveRef.call(self2, root, baseId, $ref);
          if (schOrEnv === void 0)
            throw new ref_error_1.default(it.opts.uriResolver, baseId, $ref);
          if (schOrEnv instanceof compile_1.SchemaEnv)
            return callValidate(schOrEnv);
          return inlineRefSchema(schOrEnv);
          function callRootRef() {
            if (env === root)
              return callRef(cxt, validateName, env, env.$async);
            const rootName = gen2.scopeValue("root", { ref: root });
            return callRef(cxt, (0, codegen_1._)`${rootName}.validate`, root, root.$async);
          }
          function callValidate(sch) {
            const v = getValidate(cxt, sch);
            callRef(cxt, v, sch, sch.$async);
          }
          function inlineRefSchema(sch) {
            const schName = gen2.scopeValue("schema", opts.code.source === true ? { ref: sch, code: (0, codegen_1.stringify)(sch) } : { ref: sch });
            const valid = gen2.name("valid");
            const schCxt = cxt.subschema({
              schema: sch,
              dataTypes: [],
              schemaPath: codegen_1.nil,
              topSchemaRef: schName,
              errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
          }
        }
      };
      function getValidate(cxt, sch) {
        const { gen: gen2 } = cxt;
        return sch.validate ? gen2.scopeValue("validate", { ref: sch.validate }) : (0, codegen_1._)`${gen2.scopeValue("wrapper", { ref: sch })}.validate`;
      }
      exports2.getValidate = getValidate;
      function callRef(cxt, v, sch, $async) {
        const { gen: gen2, it } = cxt;
        const { allErrors, schemaEnv: env, opts } = it;
        const passCxt = opts.passContext ? names_1.default.this : codegen_1.nil;
        if ($async)
          callAsyncRef();
        else
          callSyncRef();
        function callAsyncRef() {
          if (!env.$async)
            throw new Error("async schema referenced by sync schema");
          const valid = gen2.let("valid");
          gen2.try(() => {
            gen2.code((0, codegen_1._)`await ${(0, code_1.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v);
            if (!allErrors)
              gen2.assign(valid, true);
          }, (e2) => {
            gen2.if((0, codegen_1._)`!(${e2} instanceof ${it.ValidationError})`, () => gen2.throw(e2));
            addErrorsFrom(e2);
            if (!allErrors)
              gen2.assign(valid, false);
          });
          cxt.ok(valid);
        }
        function callSyncRef() {
          cxt.result((0, code_1.callValidateCode)(cxt, v, passCxt), () => addEvaluatedFrom(v), () => addErrorsFrom(v));
        }
        function addErrorsFrom(source) {
          const errs = (0, codegen_1._)`${source}.errors`;
          gen2.assign(names_1.default.vErrors, (0, codegen_1._)`${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`);
          gen2.assign(names_1.default.errors, (0, codegen_1._)`${names_1.default.vErrors}.length`);
        }
        function addEvaluatedFrom(source) {
          var _a6;
          if (!it.opts.unevaluated)
            return;
          const schEvaluated = (_a6 = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a6 === void 0 ? void 0 : _a6.evaluated;
          if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
              if (schEvaluated.props !== void 0) {
                it.props = util_1.mergeEvaluated.props(gen2, schEvaluated.props, it.props);
              }
            } else {
              const props = gen2.var("props", (0, codegen_1._)`${source}.evaluated.props`);
              it.props = util_1.mergeEvaluated.props(gen2, props, it.props, codegen_1.Name);
            }
          }
          if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
              if (schEvaluated.items !== void 0) {
                it.items = util_1.mergeEvaluated.items(gen2, schEvaluated.items, it.items);
              }
            } else {
              const items = gen2.var("items", (0, codegen_1._)`${source}.evaluated.items`);
              it.items = util_1.mergeEvaluated.items(gen2, items, it.items, codegen_1.Name);
            }
          }
        }
      }
      exports2.callRef = callRef;
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/core/index.js
  var require_core2 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/core/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var id_1 = require_id();
      var ref_1 = require_ref();
      var core = [
        "$schema",
        "$id",
        "$defs",
        "$vocabulary",
        { keyword: "$comment" },
        "definitions",
        id_1.default,
        ref_1.default
      ];
      exports2.default = core;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitNumber.js
  var require_limitNumber = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitNumber.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var ops = codegen_1.operators;
      var KWDs = {
        maximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
        minimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
        exclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
        exclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE }
      };
      var error = {
        message: ({ keyword, schemaCode }) => (0, codegen_1.str)`must be ${KWDs[keyword].okStr} ${schemaCode}`,
        params: ({ keyword, schemaCode }) => (0, codegen_1._)`{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`
      };
      var def = {
        keyword: Object.keys(KWDs),
        type: "number",
        schemaType: "number",
        $data: true,
        error,
        code(cxt) {
          const { keyword, data, schemaCode } = cxt;
          cxt.fail$data((0, codegen_1._)`${data} ${KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/multipleOf.js
  var require_multipleOf = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/multipleOf.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var error = {
        message: ({ schemaCode }) => (0, codegen_1.str)`must be multiple of ${schemaCode}`,
        params: ({ schemaCode }) => (0, codegen_1._)`{multipleOf: ${schemaCode}}`
      };
      var def = {
        keyword: "multipleOf",
        type: "number",
        schemaType: "number",
        $data: true,
        error,
        code(cxt) {
          const { gen: gen2, data, schemaCode, it } = cxt;
          const prec = it.opts.multipleOfPrecision;
          const res = gen2.let("res");
          const invalid = prec ? (0, codegen_1._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, codegen_1._)`${res} !== parseInt(${res})`;
          cxt.fail$data((0, codegen_1._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/ucs2length.js
  var require_ucs2length = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/ucs2length.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      function ucs2length(str) {
        const len = str.length;
        let length2 = 0;
        let pos = 0;
        let value;
        while (pos < len) {
          length2++;
          value = str.charCodeAt(pos++);
          if (value >= 55296 && value <= 56319 && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 64512) === 56320)
              pos++;
          }
        }
        return length2;
      }
      exports2.default = ucs2length;
      ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitLength.js
  var require_limitLength = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitLength.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var ucs2length_1 = require_ucs2length();
      var error = {
        message({ keyword, schemaCode }) {
          const comp = keyword === "maxLength" ? "more" : "fewer";
          return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} characters`;
        },
        params: ({ schemaCode }) => (0, codegen_1._)`{limit: ${schemaCode}}`
      };
      var def = {
        keyword: ["maxLength", "minLength"],
        type: "string",
        schemaType: "number",
        $data: true,
        error,
        code(cxt) {
          const { keyword, data, schemaCode, it } = cxt;
          const op = keyword === "maxLength" ? codegen_1.operators.GT : codegen_1.operators.LT;
          const len = it.opts.unicode === false ? (0, codegen_1._)`${data}.length` : (0, codegen_1._)`${(0, util_1.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
          cxt.fail$data((0, codegen_1._)`${len} ${op} ${schemaCode}`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/pattern.js
  var require_pattern = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/pattern.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var code_1 = require_code2();
      var codegen_1 = require_codegen();
      var error = {
        message: ({ schemaCode }) => (0, codegen_1.str)`must match pattern "${schemaCode}"`,
        params: ({ schemaCode }) => (0, codegen_1._)`{pattern: ${schemaCode}}`
      };
      var def = {
        keyword: "pattern",
        type: "string",
        schemaType: "string",
        $data: true,
        error,
        code(cxt) {
          const { data, $data, schema, schemaCode, it } = cxt;
          const u = it.opts.unicodeRegExp ? "u" : "";
          const regExp = $data ? (0, codegen_1._)`(new RegExp(${schemaCode}, ${u}))` : (0, code_1.usePattern)(cxt, schema);
          cxt.fail$data((0, codegen_1._)`!${regExp}.test(${data})`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitProperties.js
  var require_limitProperties = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitProperties.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var error = {
        message({ keyword, schemaCode }) {
          const comp = keyword === "maxProperties" ? "more" : "fewer";
          return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} properties`;
        },
        params: ({ schemaCode }) => (0, codegen_1._)`{limit: ${schemaCode}}`
      };
      var def = {
        keyword: ["maxProperties", "minProperties"],
        type: "object",
        schemaType: "number",
        $data: true,
        error,
        code(cxt) {
          const { keyword, data, schemaCode } = cxt;
          const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
          cxt.fail$data((0, codegen_1._)`Object.keys(${data}).length ${op} ${schemaCode}`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/required.js
  var require_required = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/required.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var code_1 = require_code2();
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var error = {
        message: ({ params: { missingProperty } }) => (0, codegen_1.str)`must have required property '${missingProperty}'`,
        params: ({ params: { missingProperty } }) => (0, codegen_1._)`{missingProperty: ${missingProperty}}`
      };
      var def = {
        keyword: "required",
        type: "object",
        schemaType: "array",
        $data: true,
        error,
        code(cxt) {
          const { gen: gen2, schema, schemaCode, data, $data, it } = cxt;
          const { opts } = it;
          if (!$data && schema.length === 0)
            return;
          const useLoop = schema.length >= opts.loopRequired;
          if (it.allErrors)
            allErrorsMode();
          else
            exitOnErrorMode();
          if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties } = cxt.it;
            for (const requiredKey of schema) {
              if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === void 0 && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, util_1.checkStrictMode)(it, msg, it.opts.strictRequired);
              }
            }
          }
          function allErrorsMode() {
            if (useLoop || $data) {
              cxt.block$data(codegen_1.nil, loopAllRequired);
            } else {
              for (const prop of schema) {
                (0, code_1.checkReportMissingProp)(cxt, prop);
              }
            }
          }
          function exitOnErrorMode() {
            const missing = gen2.let("missing");
            if (useLoop || $data) {
              const valid = gen2.let("valid", true);
              cxt.block$data(valid, () => loopUntilMissing(missing, valid));
              cxt.ok(valid);
            } else {
              gen2.if((0, code_1.checkMissingProp)(cxt, schema, missing));
              (0, code_1.reportMissingProp)(cxt, missing);
              gen2.else();
            }
          }
          function loopAllRequired() {
            gen2.forOf("prop", schemaCode, (prop) => {
              cxt.setParams({ missingProperty: prop });
              gen2.if((0, code_1.noPropertyInData)(gen2, data, prop, opts.ownProperties), () => cxt.error());
            });
          }
          function loopUntilMissing(missing, valid) {
            cxt.setParams({ missingProperty: missing });
            gen2.forOf(missing, schemaCode, () => {
              gen2.assign(valid, (0, code_1.propertyInData)(gen2, data, missing, opts.ownProperties));
              gen2.if((0, codegen_1.not)(valid), () => {
                cxt.error();
                gen2.break();
              });
            }, codegen_1.nil);
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitItems.js
  var require_limitItems = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/limitItems.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var error = {
        message({ keyword, schemaCode }) {
          const comp = keyword === "maxItems" ? "more" : "fewer";
          return (0, codegen_1.str)`must NOT have ${comp} than ${schemaCode} items`;
        },
        params: ({ schemaCode }) => (0, codegen_1._)`{limit: ${schemaCode}}`
      };
      var def = {
        keyword: ["maxItems", "minItems"],
        type: "array",
        schemaType: "number",
        $data: true,
        error,
        code(cxt) {
          const { keyword, data, schemaCode } = cxt;
          const op = keyword === "maxItems" ? codegen_1.operators.GT : codegen_1.operators.LT;
          cxt.fail$data((0, codegen_1._)`${data}.length ${op} ${schemaCode}`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/equal.js
  var require_equal = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/runtime/equal.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var equal = require_fast_deep_equal();
      equal.code = 'require("ajv/dist/runtime/equal").default';
      exports2.default = equal;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/uniqueItems.js
  var require_uniqueItems = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/uniqueItems.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var dataType_1 = require_dataType();
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var equal_1 = require_equal();
      var error = {
        message: ({ params: { i: i2, j } }) => (0, codegen_1.str)`must NOT have duplicate items (items ## ${j} and ${i2} are identical)`,
        params: ({ params: { i: i2, j } }) => (0, codegen_1._)`{i: ${i2}, j: ${j}}`
      };
      var def = {
        keyword: "uniqueItems",
        type: "array",
        schemaType: "boolean",
        $data: true,
        error,
        code(cxt) {
          const { gen: gen2, data, $data, schema, parentSchema, schemaCode, it } = cxt;
          if (!$data && !schema)
            return;
          const valid = gen2.let("valid");
          const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
          cxt.block$data(valid, validateUniqueItems, (0, codegen_1._)`${schemaCode} === false`);
          cxt.ok(valid);
          function validateUniqueItems() {
            const i2 = gen2.let("i", (0, codegen_1._)`${data}.length`);
            const j = gen2.let("j");
            cxt.setParams({ i: i2, j });
            gen2.assign(valid, true);
            gen2.if((0, codegen_1._)`${i2} > 1`, () => (canOptimize() ? loopN : loopN2)(i2, j));
          }
          function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t2) => t2 === "object" || t2 === "array");
          }
          function loopN(i2, j) {
            const item = gen2.name("item");
            const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, dataType_1.DataType.Wrong);
            const indices = gen2.const("indices", (0, codegen_1._)`{}`);
            gen2.for((0, codegen_1._)`;${i2}--;`, () => {
              gen2.let(item, (0, codegen_1._)`${data}[${i2}]`);
              gen2.if(wrongType, (0, codegen_1._)`continue`);
              if (itemTypes.length > 1)
                gen2.if((0, codegen_1._)`typeof ${item} == "string"`, (0, codegen_1._)`${item} += "_"`);
              gen2.if((0, codegen_1._)`typeof ${indices}[${item}] == "number"`, () => {
                gen2.assign(j, (0, codegen_1._)`${indices}[${item}]`);
                cxt.error();
                gen2.assign(valid, false).break();
              }).code((0, codegen_1._)`${indices}[${item}] = ${i2}`);
            });
          }
          function loopN2(i2, j) {
            const eql = (0, util_1.useFunc)(gen2, equal_1.default);
            const outer = gen2.name("outer");
            gen2.label(outer).for((0, codegen_1._)`;${i2}--;`, () => gen2.for((0, codegen_1._)`${j} = ${i2}; ${j}--;`, () => gen2.if((0, codegen_1._)`${eql}(${data}[${i2}], ${data}[${j}])`, () => {
              cxt.error();
              gen2.assign(valid, false).break(outer);
            })));
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/const.js
  var require_const = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/const.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var equal_1 = require_equal();
      var error = {
        message: "must be equal to constant",
        params: ({ schemaCode }) => (0, codegen_1._)`{allowedValue: ${schemaCode}}`
      };
      var def = {
        keyword: "const",
        $data: true,
        error,
        code(cxt) {
          const { gen: gen2, data, $data, schemaCode, schema } = cxt;
          if ($data || schema && typeof schema == "object") {
            cxt.fail$data((0, codegen_1._)`!${(0, util_1.useFunc)(gen2, equal_1.default)}(${data}, ${schemaCode})`);
          } else {
            cxt.fail((0, codegen_1._)`${schema} !== ${data}`);
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/enum.js
  var require_enum = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/enum.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var equal_1 = require_equal();
      var error = {
        message: "must be equal to one of the allowed values",
        params: ({ schemaCode }) => (0, codegen_1._)`{allowedValues: ${schemaCode}}`
      };
      var def = {
        keyword: "enum",
        schemaType: "array",
        $data: true,
        error,
        code(cxt) {
          const { gen: gen2, data, $data, schema, schemaCode, it } = cxt;
          if (!$data && schema.length === 0)
            throw new Error("enum must have non-empty array");
          const useLoop = schema.length >= it.opts.loopEnum;
          let eql;
          const getEql = () => eql !== null && eql !== void 0 ? eql : eql = (0, util_1.useFunc)(gen2, equal_1.default);
          let valid;
          if (useLoop || $data) {
            valid = gen2.let("valid");
            cxt.block$data(valid, loopEnum);
          } else {
            if (!Array.isArray(schema))
              throw new Error("ajv implementation error");
            const vSchema = gen2.const("vSchema", schemaCode);
            valid = (0, codegen_1.or)(...schema.map((_x, i2) => equalCode(vSchema, i2)));
          }
          cxt.pass(valid);
          function loopEnum() {
            gen2.assign(valid, false);
            gen2.forOf("v", schemaCode, (v) => gen2.if((0, codegen_1._)`${getEql()}(${data}, ${v})`, () => gen2.assign(valid, true).break()));
          }
          function equalCode(vSchema, i2) {
            const sch = schema[i2];
            return typeof sch === "object" && sch !== null ? (0, codegen_1._)`${getEql()}(${data}, ${vSchema}[${i2}])` : (0, codegen_1._)`${data} === ${sch}`;
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/index.js
  var require_validation = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/validation/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var limitNumber_1 = require_limitNumber();
      var multipleOf_1 = require_multipleOf();
      var limitLength_1 = require_limitLength();
      var pattern_1 = require_pattern();
      var limitProperties_1 = require_limitProperties();
      var required_1 = require_required();
      var limitItems_1 = require_limitItems();
      var uniqueItems_1 = require_uniqueItems();
      var const_1 = require_const();
      var enum_1 = require_enum();
      var validation = [
        // number
        limitNumber_1.default,
        multipleOf_1.default,
        // string
        limitLength_1.default,
        pattern_1.default,
        // object
        limitProperties_1.default,
        required_1.default,
        // array
        limitItems_1.default,
        uniqueItems_1.default,
        // any
        { keyword: "type", schemaType: ["string", "array"] },
        { keyword: "nullable", schemaType: "boolean" },
        const_1.default,
        enum_1.default
      ];
      exports2.default = validation;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/additionalItems.js
  var require_additionalItems = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/additionalItems.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateAdditionalItems = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var error = {
        message: ({ params: { len } }) => (0, codegen_1.str)`must NOT have more than ${len} items`,
        params: ({ params: { len } }) => (0, codegen_1._)`{limit: ${len}}`
      };
      var def = {
        keyword: "additionalItems",
        type: "array",
        schemaType: ["boolean", "object"],
        before: "uniqueItems",
        error,
        code(cxt) {
          const { parentSchema, it } = cxt;
          const { items } = parentSchema;
          if (!Array.isArray(items)) {
            (0, util_1.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
          }
          validateAdditionalItems(cxt, items);
        }
      };
      function validateAdditionalItems(cxt, items) {
        const { gen: gen2, schema, data, keyword, it } = cxt;
        it.items = true;
        const len = gen2.const("len", (0, codegen_1._)`${data}.length`);
        if (schema === false) {
          cxt.setParams({ len: items.length });
          cxt.pass((0, codegen_1._)`${len} <= ${items.length}`);
        } else if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
          const valid = gen2.var("valid", (0, codegen_1._)`${len} <= ${items.length}`);
          gen2.if((0, codegen_1.not)(valid), () => validateItems(valid));
          cxt.ok(valid);
        }
        function validateItems(valid) {
          gen2.forRange("i", items.length, len, (i2) => {
            cxt.subschema({ keyword, dataProp: i2, dataPropType: util_1.Type.Num }, valid);
            if (!it.allErrors)
              gen2.if((0, codegen_1.not)(valid), () => gen2.break());
          });
        }
      }
      exports2.validateAdditionalItems = validateAdditionalItems;
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/items.js
  var require_items = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/items.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateTuple = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var code_1 = require_code2();
      var def = {
        keyword: "items",
        type: "array",
        schemaType: ["object", "array", "boolean"],
        before: "uniqueItems",
        code(cxt) {
          const { schema, it } = cxt;
          if (Array.isArray(schema))
            return validateTuple(cxt, "additionalItems", schema);
          it.items = true;
          if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
          cxt.ok((0, code_1.validateArray)(cxt));
        }
      };
      function validateTuple(cxt, extraItems, schArr = cxt.schema) {
        const { gen: gen2, parentSchema, data, keyword, it } = cxt;
        checkStrictTuple(parentSchema);
        if (it.opts.unevaluated && schArr.length && it.items !== true) {
          it.items = util_1.mergeEvaluated.items(gen2, schArr.length, it.items);
        }
        const valid = gen2.name("valid");
        const len = gen2.const("len", (0, codegen_1._)`${data}.length`);
        schArr.forEach((sch, i2) => {
          if ((0, util_1.alwaysValidSchema)(it, sch))
            return;
          gen2.if((0, codegen_1._)`${len} > ${i2}`, () => cxt.subschema({
            keyword,
            schemaProp: i2,
            dataProp: i2
          }, valid));
          cxt.ok(valid);
        });
        function checkStrictTuple(sch) {
          const { opts, errSchemaPath } = it;
          const l = schArr.length;
          const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
          if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, util_1.checkStrictMode)(it, msg, opts.strictTuples);
          }
        }
      }
      exports2.validateTuple = validateTuple;
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/prefixItems.js
  var require_prefixItems = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/prefixItems.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var items_1 = require_items();
      var def = {
        keyword: "prefixItems",
        type: "array",
        schemaType: ["array"],
        before: "uniqueItems",
        code: (cxt) => (0, items_1.validateTuple)(cxt, "items")
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/items2020.js
  var require_items2020 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/items2020.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var code_1 = require_code2();
      var additionalItems_1 = require_additionalItems();
      var error = {
        message: ({ params: { len } }) => (0, codegen_1.str)`must NOT have more than ${len} items`,
        params: ({ params: { len } }) => (0, codegen_1._)`{limit: ${len}}`
      };
      var def = {
        keyword: "items",
        type: "array",
        schemaType: ["object", "boolean"],
        before: "uniqueItems",
        error,
        code(cxt) {
          const { schema, parentSchema, it } = cxt;
          const { prefixItems } = parentSchema;
          it.items = true;
          if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
          if (prefixItems)
            (0, additionalItems_1.validateAdditionalItems)(cxt, prefixItems);
          else
            cxt.ok((0, code_1.validateArray)(cxt));
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/contains.js
  var require_contains = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/contains.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var error = {
        message: ({ params: { min, max: max2 } }) => max2 === void 0 ? (0, codegen_1.str)`must contain at least ${min} valid item(s)` : (0, codegen_1.str)`must contain at least ${min} and no more than ${max2} valid item(s)`,
        params: ({ params: { min, max: max2 } }) => max2 === void 0 ? (0, codegen_1._)`{minContains: ${min}}` : (0, codegen_1._)`{minContains: ${min}, maxContains: ${max2}}`
      };
      var def = {
        keyword: "contains",
        type: "array",
        schemaType: ["object", "boolean"],
        before: "uniqueItems",
        trackErrors: true,
        error,
        code(cxt) {
          const { gen: gen2, schema, parentSchema, data, it } = cxt;
          let min;
          let max2;
          const { minContains, maxContains } = parentSchema;
          if (it.opts.next) {
            min = minContains === void 0 ? 1 : minContains;
            max2 = maxContains;
          } else {
            min = 1;
          }
          const len = gen2.const("len", (0, codegen_1._)`${data}.length`);
          cxt.setParams({ min, max: max2 });
          if (max2 === void 0 && min === 0) {
            (0, util_1.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
          }
          if (max2 !== void 0 && min > max2) {
            (0, util_1.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
          }
          if ((0, util_1.alwaysValidSchema)(it, schema)) {
            let cond = (0, codegen_1._)`${len} >= ${min}`;
            if (max2 !== void 0)
              cond = (0, codegen_1._)`${cond} && ${len} <= ${max2}`;
            cxt.pass(cond);
            return;
          }
          it.items = true;
          const valid = gen2.name("valid");
          if (max2 === void 0 && min === 1) {
            validateItems(valid, () => gen2.if(valid, () => gen2.break()));
          } else if (min === 0) {
            gen2.let(valid, true);
            if (max2 !== void 0)
              gen2.if((0, codegen_1._)`${data}.length > 0`, validateItemsWithCount);
          } else {
            gen2.let(valid, false);
            validateItemsWithCount();
          }
          cxt.result(valid, () => cxt.reset());
          function validateItemsWithCount() {
            const schValid = gen2.name("_valid");
            const count = gen2.let("count", 0);
            validateItems(schValid, () => gen2.if(schValid, () => checkLimits(count)));
          }
          function validateItems(_valid, block) {
            gen2.forRange("i", 0, len, (i2) => {
              cxt.subschema({
                keyword: "contains",
                dataProp: i2,
                dataPropType: util_1.Type.Num,
                compositeRule: true
              }, _valid);
              block();
            });
          }
          function checkLimits(count) {
            gen2.code((0, codegen_1._)`${count}++`);
            if (max2 === void 0) {
              gen2.if((0, codegen_1._)`${count} >= ${min}`, () => gen2.assign(valid, true).break());
            } else {
              gen2.if((0, codegen_1._)`${count} > ${max2}`, () => gen2.assign(valid, false).break());
              if (min === 1)
                gen2.assign(valid, true);
              else
                gen2.if((0, codegen_1._)`${count} >= ${min}`, () => gen2.assign(valid, true));
            }
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/dependencies.js
  var require_dependencies = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/dependencies.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.validateSchemaDeps = exports2.validatePropertyDeps = exports2.error = void 0;
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var code_1 = require_code2();
      exports2.error = {
        message: ({ params: { property, depsCount, deps } }) => {
          const property_ies = depsCount === 1 ? "property" : "properties";
          return (0, codegen_1.str)`must have ${property_ies} ${deps} when property ${property} is present`;
        },
        params: ({ params: { property, depsCount, deps, missingProperty } }) => (0, codegen_1._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
        // TODO change to reference
      };
      var def = {
        keyword: "dependencies",
        type: "object",
        schemaType: "object",
        error: exports2.error,
        code(cxt) {
          const [propDeps, schDeps] = splitDependencies(cxt);
          validatePropertyDeps(cxt, propDeps);
          validateSchemaDeps(cxt, schDeps);
        }
      };
      function splitDependencies({ schema }) {
        const propertyDeps = {};
        const schemaDeps = {};
        for (const key in schema) {
          if (key === "__proto__")
            continue;
          const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
          deps[key] = schema[key];
        }
        return [propertyDeps, schemaDeps];
      }
      function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
        const { gen: gen2, data, it } = cxt;
        if (Object.keys(propertyDeps).length === 0)
          return;
        const missing = gen2.let("missing");
        for (const prop in propertyDeps) {
          const deps = propertyDeps[prop];
          if (deps.length === 0)
            continue;
          const hasProperty = (0, code_1.propertyInData)(gen2, data, prop, it.opts.ownProperties);
          cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
          });
          if (it.allErrors) {
            gen2.if(hasProperty, () => {
              for (const depProp of deps) {
                (0, code_1.checkReportMissingProp)(cxt, depProp);
              }
            });
          } else {
            gen2.if((0, codegen_1._)`${hasProperty} && (${(0, code_1.checkMissingProp)(cxt, deps, missing)})`);
            (0, code_1.reportMissingProp)(cxt, missing);
            gen2.else();
          }
        }
      }
      exports2.validatePropertyDeps = validatePropertyDeps;
      function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
        const { gen: gen2, data, keyword, it } = cxt;
        const valid = gen2.name("valid");
        for (const prop in schemaDeps) {
          if ((0, util_1.alwaysValidSchema)(it, schemaDeps[prop]))
            continue;
          gen2.if(
            (0, code_1.propertyInData)(gen2, data, prop, it.opts.ownProperties),
            () => {
              const schCxt = cxt.subschema({ keyword, schemaProp: prop }, valid);
              cxt.mergeValidEvaluated(schCxt, valid);
            },
            () => gen2.var(valid, true)
            // TODO var
          );
          cxt.ok(valid);
        }
      }
      exports2.validateSchemaDeps = validateSchemaDeps;
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/propertyNames.js
  var require_propertyNames = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/propertyNames.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var error = {
        message: "property name must be valid",
        params: ({ params }) => (0, codegen_1._)`{propertyName: ${params.propertyName}}`
      };
      var def = {
        keyword: "propertyNames",
        type: "object",
        schemaType: ["object", "boolean"],
        error,
        code(cxt) {
          const { gen: gen2, schema, data, it } = cxt;
          if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
          const valid = gen2.name("valid");
          gen2.forIn("key", data, (key) => {
            cxt.setParams({ propertyName: key });
            cxt.subschema({
              keyword: "propertyNames",
              data: key,
              dataTypes: ["string"],
              propertyName: key,
              compositeRule: true
            }, valid);
            gen2.if((0, codegen_1.not)(valid), () => {
              cxt.error(true);
              if (!it.allErrors)
                gen2.break();
            });
          });
          cxt.ok(valid);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js
  var require_additionalProperties = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var code_1 = require_code2();
      var codegen_1 = require_codegen();
      var names_1 = require_names();
      var util_1 = require_util2();
      var error = {
        message: "must NOT have additional properties",
        params: ({ params }) => (0, codegen_1._)`{additionalProperty: ${params.additionalProperty}}`
      };
      var def = {
        keyword: "additionalProperties",
        type: ["object"],
        schemaType: ["boolean", "object"],
        allowUndefined: true,
        trackErrors: true,
        error,
        code(cxt) {
          const { gen: gen2, schema, parentSchema, data, errsCount, it } = cxt;
          if (!errsCount)
            throw new Error("ajv implementation error");
          const { allErrors, opts } = it;
          it.props = true;
          if (opts.removeAdditional !== "all" && (0, util_1.alwaysValidSchema)(it, schema))
            return;
          const props = (0, code_1.allSchemaProperties)(parentSchema.properties);
          const patProps = (0, code_1.allSchemaProperties)(parentSchema.patternProperties);
          checkAdditionalProperties();
          cxt.ok((0, codegen_1._)`${errsCount} === ${names_1.default.errors}`);
          function checkAdditionalProperties() {
            gen2.forIn("key", data, (key) => {
              if (!props.length && !patProps.length)
                additionalPropertyCode(key);
              else
                gen2.if(isAdditional(key), () => additionalPropertyCode(key));
            });
          }
          function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
              const propsSchema = (0, util_1.schemaRefOrVal)(it, parentSchema.properties, "properties");
              definedProp = (0, code_1.isOwnProperty)(gen2, propsSchema, key);
            } else if (props.length) {
              definedProp = (0, codegen_1.or)(...props.map((p12) => (0, codegen_1._)`${key} === ${p12}`));
            } else {
              definedProp = codegen_1.nil;
            }
            if (patProps.length) {
              definedProp = (0, codegen_1.or)(definedProp, ...patProps.map((p12) => (0, codegen_1._)`${(0, code_1.usePattern)(cxt, p12)}.test(${key})`));
            }
            return (0, codegen_1.not)(definedProp);
          }
          function deleteAdditional(key) {
            gen2.code((0, codegen_1._)`delete ${data}[${key}]`);
          }
          function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
              deleteAdditional(key);
              return;
            }
            if (schema === false) {
              cxt.setParams({ additionalProperty: key });
              cxt.error();
              if (!allErrors)
                gen2.break();
              return;
            }
            if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
              const valid = gen2.name("valid");
              if (opts.removeAdditional === "failing") {
                applyAdditionalSchema(key, valid, false);
                gen2.if((0, codegen_1.not)(valid), () => {
                  cxt.reset();
                  deleteAdditional(key);
                });
              } else {
                applyAdditionalSchema(key, valid);
                if (!allErrors)
                  gen2.if((0, codegen_1.not)(valid), () => gen2.break());
              }
            }
          }
          function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
              keyword: "additionalProperties",
              dataProp: key,
              dataPropType: util_1.Type.Str
            };
            if (errors === false) {
              Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
              });
            }
            cxt.subschema(subschema, valid);
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/properties.js
  var require_properties = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/properties.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var validate_1 = require_validate();
      var code_1 = require_code2();
      var util_1 = require_util2();
      var additionalProperties_1 = require_additionalProperties();
      var def = {
        keyword: "properties",
        type: "object",
        schemaType: "object",
        code(cxt) {
          const { gen: gen2, schema, parentSchema, data, it } = cxt;
          if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === void 0) {
            additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
          }
          const allProps = (0, code_1.allSchemaProperties)(schema);
          for (const prop of allProps) {
            it.definedProperties.add(prop);
          }
          if (it.opts.unevaluated && allProps.length && it.props !== true) {
            it.props = util_1.mergeEvaluated.props(gen2, (0, util_1.toHash)(allProps), it.props);
          }
          const properties = allProps.filter((p12) => !(0, util_1.alwaysValidSchema)(it, schema[p12]));
          if (properties.length === 0)
            return;
          const valid = gen2.name("valid");
          for (const prop of properties) {
            if (hasDefault(prop)) {
              applyPropertySchema(prop);
            } else {
              gen2.if((0, code_1.propertyInData)(gen2, data, prop, it.opts.ownProperties));
              applyPropertySchema(prop);
              if (!it.allErrors)
                gen2.else().var(valid, true);
              gen2.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
          }
          function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== void 0;
          }
          function applyPropertySchema(prop) {
            cxt.subschema({
              keyword: "properties",
              schemaProp: prop,
              dataProp: prop
            }, valid);
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/patternProperties.js
  var require_patternProperties = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/patternProperties.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var code_1 = require_code2();
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var util_2 = require_util2();
      var def = {
        keyword: "patternProperties",
        type: "object",
        schemaType: "object",
        code(cxt) {
          const { gen: gen2, schema, data, parentSchema, it } = cxt;
          const { opts } = it;
          const patterns = (0, code_1.allSchemaProperties)(schema);
          const alwaysValidPatterns = patterns.filter((p12) => (0, util_1.alwaysValidSchema)(it, schema[p12]));
          if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) {
            return;
          }
          const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
          const valid = gen2.name("valid");
          if (it.props !== true && !(it.props instanceof codegen_1.Name)) {
            it.props = (0, util_2.evaluatedPropsToName)(gen2, it.props);
          }
          const { props } = it;
          validatePatternProperties();
          function validatePatternProperties() {
            for (const pat of patterns) {
              if (checkProperties)
                checkMatchingProperties(pat);
              if (it.allErrors) {
                validateProperties(pat);
              } else {
                gen2.var(valid, true);
                validateProperties(pat);
                gen2.if(valid);
              }
            }
          }
          function checkMatchingProperties(pat) {
            for (const prop in checkProperties) {
              if (new RegExp(pat).test(prop)) {
                (0, util_1.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
              }
            }
          }
          function validateProperties(pat) {
            gen2.forIn("key", data, (key) => {
              gen2.if((0, codegen_1._)`${(0, code_1.usePattern)(cxt, pat)}.test(${key})`, () => {
                const alwaysValid = alwaysValidPatterns.includes(pat);
                if (!alwaysValid) {
                  cxt.subschema({
                    keyword: "patternProperties",
                    schemaProp: pat,
                    dataProp: key,
                    dataPropType: util_2.Type.Str
                  }, valid);
                }
                if (it.opts.unevaluated && props !== true) {
                  gen2.assign((0, codegen_1._)`${props}[${key}]`, true);
                } else if (!alwaysValid && !it.allErrors) {
                  gen2.if((0, codegen_1.not)(valid), () => gen2.break());
                }
              });
            });
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/not.js
  var require_not = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/not.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var util_1 = require_util2();
      var def = {
        keyword: "not",
        schemaType: ["object", "boolean"],
        trackErrors: true,
        code(cxt) {
          const { gen: gen2, schema, it } = cxt;
          if ((0, util_1.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
          }
          const valid = gen2.name("valid");
          cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
          }, valid);
          cxt.failResult(valid, () => cxt.reset(), () => cxt.error());
        },
        error: { message: "must NOT be valid" }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/anyOf.js
  var require_anyOf = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/anyOf.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var code_1 = require_code2();
      var def = {
        keyword: "anyOf",
        schemaType: "array",
        trackErrors: true,
        code: code_1.validateUnion,
        error: { message: "must match a schema in anyOf" }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/oneOf.js
  var require_oneOf = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/oneOf.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var error = {
        message: "must match exactly one schema in oneOf",
        params: ({ params }) => (0, codegen_1._)`{passingSchemas: ${params.passing}}`
      };
      var def = {
        keyword: "oneOf",
        schemaType: "array",
        trackErrors: true,
        error,
        code(cxt) {
          const { gen: gen2, schema, parentSchema, it } = cxt;
          if (!Array.isArray(schema))
            throw new Error("ajv implementation error");
          if (it.opts.discriminator && parentSchema.discriminator)
            return;
          const schArr = schema;
          const valid = gen2.let("valid", false);
          const passing = gen2.let("passing", null);
          const schValid = gen2.name("_valid");
          cxt.setParams({ passing });
          gen2.block(validateOneOf);
          cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
          function validateOneOf() {
            schArr.forEach((sch, i2) => {
              let schCxt;
              if ((0, util_1.alwaysValidSchema)(it, sch)) {
                gen2.var(schValid, true);
              } else {
                schCxt = cxt.subschema({
                  keyword: "oneOf",
                  schemaProp: i2,
                  compositeRule: true
                }, schValid);
              }
              if (i2 > 0) {
                gen2.if((0, codegen_1._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, codegen_1._)`[${passing}, ${i2}]`).else();
              }
              gen2.if(schValid, () => {
                gen2.assign(valid, true);
                gen2.assign(passing, i2);
                if (schCxt)
                  cxt.mergeEvaluated(schCxt, codegen_1.Name);
              });
            });
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/allOf.js
  var require_allOf = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/allOf.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var util_1 = require_util2();
      var def = {
        keyword: "allOf",
        schemaType: "array",
        code(cxt) {
          const { gen: gen2, schema, it } = cxt;
          if (!Array.isArray(schema))
            throw new Error("ajv implementation error");
          const valid = gen2.name("valid");
          schema.forEach((sch, i2) => {
            if ((0, util_1.alwaysValidSchema)(it, sch))
              return;
            const schCxt = cxt.subschema({ keyword: "allOf", schemaProp: i2 }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
          });
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/if.js
  var require_if = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/if.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var util_1 = require_util2();
      var error = {
        message: ({ params }) => (0, codegen_1.str)`must match "${params.ifClause}" schema`,
        params: ({ params }) => (0, codegen_1._)`{failingKeyword: ${params.ifClause}}`
      };
      var def = {
        keyword: "if",
        schemaType: ["object", "boolean"],
        trackErrors: true,
        error,
        code(cxt) {
          const { gen: gen2, parentSchema, it } = cxt;
          if (parentSchema.then === void 0 && parentSchema.else === void 0) {
            (0, util_1.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
          }
          const hasThen = hasSchema(it, "then");
          const hasElse = hasSchema(it, "else");
          if (!hasThen && !hasElse)
            return;
          const valid = gen2.let("valid", true);
          const schValid = gen2.name("_valid");
          validateIf();
          cxt.reset();
          if (hasThen && hasElse) {
            const ifClause = gen2.let("ifClause");
            cxt.setParams({ ifClause });
            gen2.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
          } else if (hasThen) {
            gen2.if(schValid, validateClause("then"));
          } else {
            gen2.if((0, codegen_1.not)(schValid), validateClause("else"));
          }
          cxt.pass(valid, () => cxt.error(true));
          function validateIf() {
            const schCxt = cxt.subschema({
              keyword: "if",
              compositeRule: true,
              createErrors: false,
              allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
          }
          function validateClause(keyword, ifClause) {
            return () => {
              const schCxt = cxt.subschema({ keyword }, schValid);
              gen2.assign(valid, schValid);
              cxt.mergeValidEvaluated(schCxt, valid);
              if (ifClause)
                gen2.assign(ifClause, (0, codegen_1._)`${keyword}`);
              else
                cxt.setParams({ ifClause: keyword });
            };
          }
        }
      };
      function hasSchema(it, keyword) {
        const schema = it.schema[keyword];
        return schema !== void 0 && !(0, util_1.alwaysValidSchema)(it, schema);
      }
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/thenElse.js
  var require_thenElse = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/thenElse.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var util_1 = require_util2();
      var def = {
        keyword: ["then", "else"],
        schemaType: ["object", "boolean"],
        code({ keyword, parentSchema, it }) {
          if (parentSchema.if === void 0)
            (0, util_1.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/index.js
  var require_applicator = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/applicator/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var additionalItems_1 = require_additionalItems();
      var prefixItems_1 = require_prefixItems();
      var items_1 = require_items();
      var items2020_1 = require_items2020();
      var contains_1 = require_contains();
      var dependencies_1 = require_dependencies();
      var propertyNames_1 = require_propertyNames();
      var additionalProperties_1 = require_additionalProperties();
      var properties_1 = require_properties();
      var patternProperties_1 = require_patternProperties();
      var not_1 = require_not();
      var anyOf_1 = require_anyOf();
      var oneOf_1 = require_oneOf();
      var allOf_1 = require_allOf();
      var if_1 = require_if();
      var thenElse_1 = require_thenElse();
      function getApplicator(draft2020 = false) {
        const applicator = [
          // any
          not_1.default,
          anyOf_1.default,
          oneOf_1.default,
          allOf_1.default,
          if_1.default,
          thenElse_1.default,
          // object
          propertyNames_1.default,
          additionalProperties_1.default,
          dependencies_1.default,
          properties_1.default,
          patternProperties_1.default
        ];
        if (draft2020)
          applicator.push(prefixItems_1.default, items2020_1.default);
        else
          applicator.push(additionalItems_1.default, items_1.default);
        applicator.push(contains_1.default);
        return applicator;
      }
      exports2.default = getApplicator;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/format/format.js
  var require_format = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/format/format.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var error = {
        message: ({ schemaCode }) => (0, codegen_1.str)`must match format "${schemaCode}"`,
        params: ({ schemaCode }) => (0, codegen_1._)`{format: ${schemaCode}}`
      };
      var def = {
        keyword: "format",
        type: ["number", "string"],
        schemaType: "string",
        $data: true,
        error,
        code(cxt, ruleType) {
          const { gen: gen2, data, $data, schema, schemaCode, it } = cxt;
          const { opts, errSchemaPath, schemaEnv, self: self2 } = it;
          if (!opts.validateFormats)
            return;
          if ($data)
            validate$DataFormat();
          else
            validateFormat();
          function validate$DataFormat() {
            const fmts = gen2.scopeValue("formats", {
              ref: self2.formats,
              code: opts.code.formats
            });
            const fDef = gen2.const("fDef", (0, codegen_1._)`${fmts}[${schemaCode}]`);
            const fType = gen2.let("fType");
            const format5 = gen2.let("format");
            gen2.if((0, codegen_1._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, () => gen2.assign(fType, (0, codegen_1._)`${fDef}.type || "string"`).assign(format5, (0, codegen_1._)`${fDef}.validate`), () => gen2.assign(fType, (0, codegen_1._)`"string"`).assign(format5, fDef));
            cxt.fail$data((0, codegen_1.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
              if (opts.strictSchema === false)
                return codegen_1.nil;
              return (0, codegen_1._)`${schemaCode} && !${format5}`;
            }
            function invalidFmt() {
              const callFormat = schemaEnv.$async ? (0, codegen_1._)`(${fDef}.async ? await ${format5}(${data}) : ${format5}(${data}))` : (0, codegen_1._)`${format5}(${data})`;
              const validData = (0, codegen_1._)`(typeof ${format5} == "function" ? ${callFormat} : ${format5}.test(${data}))`;
              return (0, codegen_1._)`${format5} && ${format5} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
          }
          function validateFormat() {
            const formatDef = self2.formats[schema];
            if (!formatDef) {
              unknownFormat();
              return;
            }
            if (formatDef === true)
              return;
            const [fmtType, format5, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType)
              cxt.pass(validCondition());
            function unknownFormat() {
              if (opts.strictSchema === false) {
                self2.logger.warn(unknownMsg());
                return;
              }
              throw new Error(unknownMsg());
              function unknownMsg() {
                return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
              }
            }
            function getFormat(fmtDef) {
              const code = fmtDef instanceof RegExp ? (0, codegen_1.regexpCode)(fmtDef) : opts.code.formats ? (0, codegen_1._)`${opts.code.formats}${(0, codegen_1.getProperty)(schema)}` : void 0;
              const fmt = gen2.scopeValue("formats", { key: schema, ref: fmtDef, code });
              if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) {
                return [fmtDef.type || "string", fmtDef.validate, (0, codegen_1._)`${fmt}.validate`];
              }
              return ["string", fmtDef, fmt];
            }
            function validCondition() {
              if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                if (!schemaEnv.$async)
                  throw new Error("async format in sync schema");
                return (0, codegen_1._)`await ${fmtRef}(${data})`;
              }
              return typeof format5 == "function" ? (0, codegen_1._)`${fmtRef}(${data})` : (0, codegen_1._)`${fmtRef}.test(${data})`;
            }
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/format/index.js
  var require_format2 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/format/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var format_1 = require_format();
      var format5 = [format_1.default];
      exports2.default = format5;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/metadata.js
  var require_metadata = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/metadata.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.contentVocabulary = exports2.metadataVocabulary = void 0;
      exports2.metadataVocabulary = [
        "title",
        "description",
        "default",
        "deprecated",
        "readOnly",
        "writeOnly",
        "examples"
      ];
      exports2.contentVocabulary = [
        "contentMediaType",
        "contentEncoding",
        "contentSchema"
      ];
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/draft7.js
  var require_draft7 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/draft7.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var core_1 = require_core2();
      var validation_1 = require_validation();
      var applicator_1 = require_applicator();
      var format_1 = require_format2();
      var metadata_1 = require_metadata();
      var draft7Vocabularies = [
        core_1.default,
        validation_1.default,
        (0, applicator_1.default)(),
        format_1.default,
        metadata_1.metadataVocabulary,
        metadata_1.contentVocabulary
      ];
      exports2.default = draft7Vocabularies;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/discriminator/types.js
  var require_types = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/discriminator/types.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.DiscrError = void 0;
      var DiscrError;
      (function(DiscrError2) {
        DiscrError2["Tag"] = "tag";
        DiscrError2["Mapping"] = "mapping";
      })(DiscrError || (exports2.DiscrError = DiscrError = {}));
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/discriminator/index.js
  var require_discriminator = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/vocabularies/discriminator/index.js"(exports2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      var codegen_1 = require_codegen();
      var types_1 = require_types();
      var compile_1 = require_compile();
      var ref_error_1 = require_ref_error();
      var util_1 = require_util2();
      var error = {
        message: ({ params: { discrError, tagName } }) => discrError === types_1.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
        params: ({ params: { discrError, tag, tagName } }) => (0, codegen_1._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
      };
      var def = {
        keyword: "discriminator",
        type: "object",
        schemaType: "object",
        error,
        code(cxt) {
          const { gen: gen2, data, schema, parentSchema, it } = cxt;
          const { oneOf } = parentSchema;
          if (!it.opts.discriminator) {
            throw new Error("discriminator: requires discriminator option");
          }
          const tagName = schema.propertyName;
          if (typeof tagName != "string")
            throw new Error("discriminator: requires propertyName");
          if (schema.mapping)
            throw new Error("discriminator: mapping is not supported");
          if (!oneOf)
            throw new Error("discriminator: requires oneOf keyword");
          const valid = gen2.let("valid", false);
          const tag = gen2.const("tag", (0, codegen_1._)`${data}${(0, codegen_1.getProperty)(tagName)}`);
          gen2.if((0, codegen_1._)`typeof ${tag} == "string"`, () => validateMapping(), () => cxt.error(false, { discrError: types_1.DiscrError.Tag, tag, tagName }));
          cxt.ok(valid);
          function validateMapping() {
            const mapping = getMapping();
            gen2.if(false);
            for (const tagValue in mapping) {
              gen2.elseIf((0, codegen_1._)`${tag} === ${tagValue}`);
              gen2.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen2.else();
            cxt.error(false, { discrError: types_1.DiscrError.Mapping, tag, tagName });
            gen2.endIf();
          }
          function applyTagSchema(schemaProp) {
            const _valid = gen2.name("valid");
            const schCxt = cxt.subschema({ keyword: "oneOf", schemaProp }, _valid);
            cxt.mergeEvaluated(schCxt, codegen_1.Name);
            return _valid;
          }
          function getMapping() {
            var _a6;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for (let i2 = 0; i2 < oneOf.length; i2++) {
              let sch = oneOf[i2];
              if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it.self.RULES)) {
                const ref = sch.$ref;
                sch = compile_1.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                if (sch instanceof compile_1.SchemaEnv)
                  sch = sch.schema;
                if (sch === void 0)
                  throw new ref_error_1.default(it.opts.uriResolver, it.baseId, ref);
              }
              const propSch = (_a6 = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a6 === void 0 ? void 0 : _a6[tagName];
              if (typeof propSch != "object") {
                throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
              }
              tagRequired = tagRequired && (topRequired || hasRequired(sch));
              addMappings(propSch, i2);
            }
            if (!tagRequired)
              throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required }) {
              return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i2) {
              if (sch.const) {
                addMapping(sch.const, i2);
              } else if (sch.enum) {
                for (const tagValue of sch.enum) {
                  addMapping(tagValue, i2);
                }
              } else {
                throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
              }
            }
            function addMapping(tagValue, i2) {
              if (typeof tagValue != "string" || tagValue in oneOfMapping) {
                throw new Error(`discriminator: "${tagName}" values must be unique strings`);
              }
              oneOfMapping[tagValue] = i2;
            }
          }
        }
      };
      exports2.default = def;
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/refs/json-schema-draft-07.json
  var require_json_schema_draft_07 = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/refs/json-schema-draft-07.json"(exports2, module2) {
      module2.exports = {
        $schema: "http://json-schema.org/draft-07/schema#",
        $id: "http://json-schema.org/draft-07/schema#",
        title: "Core schema meta-schema",
        definitions: {
          schemaArray: {
            type: "array",
            minItems: 1,
            items: { $ref: "#" }
          },
          nonNegativeInteger: {
            type: "integer",
            minimum: 0
          },
          nonNegativeIntegerDefault0: {
            allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }]
          },
          simpleTypes: {
            enum: ["array", "boolean", "integer", "null", "number", "object", "string"]
          },
          stringArray: {
            type: "array",
            items: { type: "string" },
            uniqueItems: true,
            default: []
          }
        },
        type: ["object", "boolean"],
        properties: {
          $id: {
            type: "string",
            format: "uri-reference"
          },
          $schema: {
            type: "string",
            format: "uri"
          },
          $ref: {
            type: "string",
            format: "uri-reference"
          },
          $comment: {
            type: "string"
          },
          title: {
            type: "string"
          },
          description: {
            type: "string"
          },
          default: true,
          readOnly: {
            type: "boolean",
            default: false
          },
          examples: {
            type: "array",
            items: true
          },
          multipleOf: {
            type: "number",
            exclusiveMinimum: 0
          },
          maximum: {
            type: "number"
          },
          exclusiveMaximum: {
            type: "number"
          },
          minimum: {
            type: "number"
          },
          exclusiveMinimum: {
            type: "number"
          },
          maxLength: { $ref: "#/definitions/nonNegativeInteger" },
          minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" },
          pattern: {
            type: "string",
            format: "regex"
          },
          additionalItems: { $ref: "#" },
          items: {
            anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }],
            default: true
          },
          maxItems: { $ref: "#/definitions/nonNegativeInteger" },
          minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" },
          uniqueItems: {
            type: "boolean",
            default: false
          },
          contains: { $ref: "#" },
          maxProperties: { $ref: "#/definitions/nonNegativeInteger" },
          minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" },
          required: { $ref: "#/definitions/stringArray" },
          additionalProperties: { $ref: "#" },
          definitions: {
            type: "object",
            additionalProperties: { $ref: "#" },
            default: {}
          },
          properties: {
            type: "object",
            additionalProperties: { $ref: "#" },
            default: {}
          },
          patternProperties: {
            type: "object",
            additionalProperties: { $ref: "#" },
            propertyNames: { format: "regex" },
            default: {}
          },
          dependencies: {
            type: "object",
            additionalProperties: {
              anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }]
            }
          },
          propertyNames: { $ref: "#" },
          const: true,
          enum: {
            type: "array",
            items: true,
            minItems: 1,
            uniqueItems: true
          },
          type: {
            anyOf: [
              { $ref: "#/definitions/simpleTypes" },
              {
                type: "array",
                items: { $ref: "#/definitions/simpleTypes" },
                minItems: 1,
                uniqueItems: true
              }
            ]
          },
          format: { type: "string" },
          contentMediaType: { type: "string" },
          contentEncoding: { type: "string" },
          if: { $ref: "#" },
          then: { $ref: "#" },
          else: { $ref: "#" },
          allOf: { $ref: "#/definitions/schemaArray" },
          anyOf: { $ref: "#/definitions/schemaArray" },
          oneOf: { $ref: "#/definitions/schemaArray" },
          not: { $ref: "#" }
        },
        default: true
      };
    }
  });

  // ../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/ajv.js
  var require_ajv = __commonJS({
    "../../node_modules/.pnpm/ajv@8.17.1/node_modules/ajv/dist/ajv.js"(exports2, module2) {
      "use strict";
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.MissingRefError = exports2.ValidationError = exports2.CodeGen = exports2.Name = exports2.nil = exports2.stringify = exports2.str = exports2._ = exports2.KeywordCxt = exports2.Ajv = void 0;
      var core_1 = require_core();
      var draft7_1 = require_draft7();
      var discriminator_1 = require_discriminator();
      var draft7MetaSchema = require_json_schema_draft_07();
      var META_SUPPORT_DATA = ["/properties"];
      var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
      var Ajv2 = class extends core_1.default {
        _addVocabularies() {
          super._addVocabularies();
          draft7_1.default.forEach((v) => this.addVocabulary(v));
          if (this.opts.discriminator)
            this.addKeyword(discriminator_1.default);
        }
        _addDefaultMetaSchema() {
          super._addDefaultMetaSchema();
          if (!this.opts.meta)
            return;
          const metaSchema = this.opts.$data ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA) : draft7MetaSchema;
          this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
          this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
        }
        defaultMeta() {
          return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : void 0);
        }
      };
      exports2.Ajv = Ajv2;
      module2.exports = exports2 = Ajv2;
      module2.exports.Ajv = Ajv2;
      Object.defineProperty(exports2, "__esModule", { value: true });
      exports2.default = Ajv2;
      var validate_1 = require_validate();
      Object.defineProperty(exports2, "KeywordCxt", { enumerable: true, get: function() {
        return validate_1.KeywordCxt;
      } });
      var codegen_1 = require_codegen();
      Object.defineProperty(exports2, "_", { enumerable: true, get: function() {
        return codegen_1._;
      } });
      Object.defineProperty(exports2, "str", { enumerable: true, get: function() {
        return codegen_1.str;
      } });
      Object.defineProperty(exports2, "stringify", { enumerable: true, get: function() {
        return codegen_1.stringify;
      } });
      Object.defineProperty(exports2, "nil", { enumerable: true, get: function() {
        return codegen_1.nil;
      } });
      Object.defineProperty(exports2, "Name", { enumerable: true, get: function() {
        return codegen_1.Name;
      } });
      Object.defineProperty(exports2, "CodeGen", { enumerable: true, get: function() {
        return codegen_1.CodeGen;
      } });
      var validation_error_1 = require_validation_error();
      Object.defineProperty(exports2, "ValidationError", { enumerable: true, get: function() {
        return validation_error_1.default;
      } });
      var ref_error_1 = require_ref_error();
      Object.defineProperty(exports2, "MissingRefError", { enumerable: true, get: function() {
        return ref_error_1.default;
      } });
    }
  });

  // ../../node_modules/.pnpm/@capacitor+core@6.0.0/node_modules/@capacitor/core/dist/index.js
  var createCapacitorPlatforms, initPlatforms, CapacitorPlatforms, addPlatform, setPlatform, ExceptionCode, CapacitorException, getPlatformId, createCapacitor, initCapacitorGlobal, Capacitor, registerPlugin, Plugins, WebPlugin, encode3, decode, CapacitorCookiesPluginWeb, CapacitorCookies, readBlobAsBase64, normalizeHttpHeaders, buildUrlParams, buildRequestInit, CapacitorHttpPluginWeb, CapacitorHttp;
  var init_dist5 = __esm({
    "../../node_modules/.pnpm/@capacitor+core@6.0.0/node_modules/@capacitor/core/dist/index.js"() {
      createCapacitorPlatforms = (win) => {
        const defaultPlatformMap = /* @__PURE__ */ new Map();
        defaultPlatformMap.set("web", { name: "web" });
        const capPlatforms = win.CapacitorPlatforms || {
          currentPlatform: { name: "web" },
          platforms: defaultPlatformMap
        };
        const addPlatform2 = (name2, platform) => {
          capPlatforms.platforms.set(name2, platform);
        };
        const setPlatform2 = (name2) => {
          if (capPlatforms.platforms.has(name2)) {
            capPlatforms.currentPlatform = capPlatforms.platforms.get(name2);
          }
        };
        capPlatforms.addPlatform = addPlatform2;
        capPlatforms.setPlatform = setPlatform2;
        return capPlatforms;
      };
      initPlatforms = (win) => win.CapacitorPlatforms = createCapacitorPlatforms(win);
      CapacitorPlatforms = /* @__PURE__ */ initPlatforms(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
      addPlatform = CapacitorPlatforms.addPlatform;
      setPlatform = CapacitorPlatforms.setPlatform;
      (function(ExceptionCode2) {
        ExceptionCode2["Unimplemented"] = "UNIMPLEMENTED";
        ExceptionCode2["Unavailable"] = "UNAVAILABLE";
      })(ExceptionCode || (ExceptionCode = {}));
      CapacitorException = class extends Error {
        constructor(message, code, data) {
          super(message);
          this.message = message;
          this.code = code;
          this.data = data;
        }
      };
      getPlatformId = (win) => {
        var _a6, _b3;
        if (win === null || win === void 0 ? void 0 : win.androidBridge) {
          return "android";
        } else if ((_b3 = (_a6 = win === null || win === void 0 ? void 0 : win.webkit) === null || _a6 === void 0 ? void 0 : _a6.messageHandlers) === null || _b3 === void 0 ? void 0 : _b3.bridge) {
          return "ios";
        } else {
          return "web";
        }
      };
      createCapacitor = (win) => {
        var _a6, _b3, _c2, _d, _e;
        const capCustomPlatform = win.CapacitorCustomPlatform || null;
        const cap = win.Capacitor || {};
        const Plugins2 = cap.Plugins = cap.Plugins || {};
        const capPlatforms = win.CapacitorPlatforms;
        const defaultGetPlatform = () => {
          return capCustomPlatform !== null ? capCustomPlatform.name : getPlatformId(win);
        };
        const getPlatform = ((_a6 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _a6 === void 0 ? void 0 : _a6.getPlatform) || defaultGetPlatform;
        const defaultIsNativePlatform = () => getPlatform() !== "web";
        const isNativePlatform = ((_b3 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _b3 === void 0 ? void 0 : _b3.isNativePlatform) || defaultIsNativePlatform;
        const defaultIsPluginAvailable = (pluginName) => {
          const plugin = registeredPlugins.get(pluginName);
          if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) {
            return true;
          }
          if (getPluginHeader(pluginName)) {
            return true;
          }
          return false;
        };
        const isPluginAvailable = ((_c2 = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _c2 === void 0 ? void 0 : _c2.isPluginAvailable) || defaultIsPluginAvailable;
        const defaultGetPluginHeader = (pluginName) => {
          var _a7;
          return (_a7 = cap.PluginHeaders) === null || _a7 === void 0 ? void 0 : _a7.find((h) => h.name === pluginName);
        };
        const getPluginHeader = ((_d = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _d === void 0 ? void 0 : _d.getPluginHeader) || defaultGetPluginHeader;
        const handleError = (err3) => win.console.error(err3);
        const pluginMethodNoop = (_target, prop, pluginName) => {
          return Promise.reject(`${pluginName} does not have an implementation of "${prop}".`);
        };
        const registeredPlugins = /* @__PURE__ */ new Map();
        const defaultRegisterPlugin = (pluginName, jsImplementations = {}) => {
          const registeredPlugin = registeredPlugins.get(pluginName);
          if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
          }
          const platform = getPlatform();
          const pluginHeader = getPluginHeader(pluginName);
          let jsImplementation;
          const loadPluginImplementation = async () => {
            if (!jsImplementation && platform in jsImplementations) {
              jsImplementation = typeof jsImplementations[platform] === "function" ? jsImplementation = await jsImplementations[platform]() : jsImplementation = jsImplementations[platform];
            } else if (capCustomPlatform !== null && !jsImplementation && "web" in jsImplementations) {
              jsImplementation = typeof jsImplementations["web"] === "function" ? jsImplementation = await jsImplementations["web"]() : jsImplementation = jsImplementations["web"];
            }
            return jsImplementation;
          };
          const createPluginMethod = (impl, prop) => {
            var _a7, _b4;
            if (pluginHeader) {
              const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m) => prop === m.name);
              if (methodHeader) {
                if (methodHeader.rtype === "promise") {
                  return (options) => cap.nativePromise(pluginName, prop.toString(), options);
                } else {
                  return (options, callback) => cap.nativeCallback(pluginName, prop.toString(), options, callback);
                }
              } else if (impl) {
                return (_a7 = impl[prop]) === null || _a7 === void 0 ? void 0 : _a7.bind(impl);
              }
            } else if (impl) {
              return (_b4 = impl[prop]) === null || _b4 === void 0 ? void 0 : _b4.bind(impl);
            } else {
              throw new CapacitorException(`"${pluginName}" plugin is not implemented on ${platform}`, ExceptionCode.Unimplemented);
            }
          };
          const createPluginMethodWrapper = (prop) => {
            let remove3;
            const wrapper = (...args) => {
              const p12 = loadPluginImplementation().then((impl) => {
                const fn = createPluginMethod(impl, prop);
                if (fn) {
                  const p13 = fn(...args);
                  remove3 = p13 === null || p13 === void 0 ? void 0 : p13.remove;
                  return p13;
                } else {
                  throw new CapacitorException(`"${pluginName}.${prop}()" is not implemented on ${platform}`, ExceptionCode.Unimplemented);
                }
              });
              if (prop === "addListener") {
                p12.remove = async () => remove3();
              }
              return p12;
            };
            wrapper.toString = () => `${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, "name", {
              value: prop,
              writable: false,
              configurable: false
            });
            return wrapper;
          };
          const addListener = createPluginMethodWrapper("addListener");
          const removeListener = createPluginMethodWrapper("removeListener");
          const addListenerNative = (eventName, callback) => {
            const call3 = addListener({ eventName }, callback);
            const remove3 = async () => {
              const callbackId = await call3;
              removeListener({
                eventName,
                callbackId
              }, callback);
            };
            const p12 = new Promise((resolve2) => call3.then(() => resolve2({ remove: remove3 })));
            p12.remove = async () => {
              console.warn(`Using addListener() without 'await' is deprecated.`);
              await remove3();
            };
            return p12;
          };
          const proxy = new Proxy({}, {
            get(_2, prop) {
              switch (prop) {
                case "$$typeof":
                  return void 0;
                case "toJSON":
                  return () => ({});
                case "addListener":
                  return pluginHeader ? addListenerNative : addListener;
                case "removeListener":
                  return removeListener;
                default:
                  return createPluginMethodWrapper(prop);
              }
            }
          });
          Plugins2[pluginName] = proxy;
          registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy,
            platforms: /* @__PURE__ */ new Set([
              ...Object.keys(jsImplementations),
              ...pluginHeader ? [platform] : []
            ])
          });
          return proxy;
        };
        const registerPlugin2 = ((_e = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _e === void 0 ? void 0 : _e.registerPlugin) || defaultRegisterPlugin;
        if (!cap.convertFileSrc) {
          cap.convertFileSrc = (filePath) => filePath;
        }
        cap.getPlatform = getPlatform;
        cap.handleError = handleError;
        cap.isNativePlatform = isNativePlatform;
        cap.isPluginAvailable = isPluginAvailable;
        cap.pluginMethodNoop = pluginMethodNoop;
        cap.registerPlugin = registerPlugin2;
        cap.Exception = CapacitorException;
        cap.DEBUG = !!cap.DEBUG;
        cap.isLoggingEnabled = !!cap.isLoggingEnabled;
        cap.platform = cap.getPlatform();
        cap.isNative = cap.isNativePlatform();
        return cap;
      };
      initCapacitorGlobal = (win) => win.Capacitor = createCapacitor(win);
      Capacitor = /* @__PURE__ */ initCapacitorGlobal(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
      registerPlugin = Capacitor.registerPlugin;
      Plugins = Capacitor.Plugins;
      WebPlugin = class {
        constructor(config) {
          this.listeners = {};
          this.retainedEventArguments = {};
          this.windowListeners = {};
          if (config) {
            console.warn(`Capacitor WebPlugin "${config.name}" config object was deprecated in v3 and will be removed in v4.`);
            this.config = config;
          }
        }
        addListener(eventName, listenerFunc) {
          let firstListener = false;
          const listeners = this.listeners[eventName];
          if (!listeners) {
            this.listeners[eventName] = [];
            firstListener = true;
          }
          this.listeners[eventName].push(listenerFunc);
          const windowListener = this.windowListeners[eventName];
          if (windowListener && !windowListener.registered) {
            this.addWindowListener(windowListener);
          }
          if (firstListener) {
            this.sendRetainedArgumentsForEvent(eventName);
          }
          const remove3 = async () => this.removeListener(eventName, listenerFunc);
          const p12 = Promise.resolve({ remove: remove3 });
          return p12;
        }
        async removeAllListeners() {
          this.listeners = {};
          for (const listener in this.windowListeners) {
            this.removeWindowListener(this.windowListeners[listener]);
          }
          this.windowListeners = {};
        }
        notifyListeners(eventName, data, retainUntilConsumed) {
          const listeners = this.listeners[eventName];
          if (!listeners) {
            if (retainUntilConsumed) {
              let args = this.retainedEventArguments[eventName];
              if (!args) {
                args = [];
              }
              args.push(data);
              this.retainedEventArguments[eventName] = args;
            }
            return;
          }
          listeners.forEach((listener) => listener(data));
        }
        hasListeners(eventName) {
          return !!this.listeners[eventName].length;
        }
        registerWindowListener(windowEventName, pluginEventName) {
          this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName,
            pluginEventName,
            handler: (event) => {
              this.notifyListeners(pluginEventName, event);
            }
          };
        }
        unimplemented(msg = "not implemented") {
          return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
        }
        unavailable(msg = "not available") {
          return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
        }
        async removeListener(eventName, listenerFunc) {
          const listeners = this.listeners[eventName];
          if (!listeners) {
            return;
          }
          const index2 = listeners.indexOf(listenerFunc);
          this.listeners[eventName].splice(index2, 1);
          if (!this.listeners[eventName].length) {
            this.removeWindowListener(this.windowListeners[eventName]);
          }
        }
        addWindowListener(handle) {
          window.addEventListener(handle.windowEventName, handle.handler);
          handle.registered = true;
        }
        removeWindowListener(handle) {
          if (!handle) {
            return;
          }
          window.removeEventListener(handle.windowEventName, handle.handler);
          handle.registered = false;
        }
        sendRetainedArgumentsForEvent(eventName) {
          const args = this.retainedEventArguments[eventName];
          if (!args) {
            return;
          }
          delete this.retainedEventArguments[eventName];
          args.forEach((arg) => {
            this.notifyListeners(eventName, arg);
          });
        }
      };
      encode3 = (str) => encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      decode = (str) => str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      CapacitorCookiesPluginWeb = class extends WebPlugin {
        async getCookies() {
          const cookies = document.cookie;
          const cookieMap = {};
          cookies.split(";").forEach((cookie) => {
            if (cookie.length <= 0)
              return;
            let [key, value] = cookie.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
            key = decode(key).trim();
            value = decode(value).trim();
            cookieMap[key] = value;
          });
          return cookieMap;
        }
        async setCookie(options) {
          try {
            const encodedKey = encode3(options.key);
            const encodedValue = encode3(options.value);
            const expires = `; expires=${(options.expires || "").replace("expires=", "")}`;
            const path3 = (options.path || "/").replace("path=", "");
            const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : "";
            document.cookie = `${encodedKey}=${encodedValue || ""}${expires}; path=${path3}; ${domain};`;
          } catch (error) {
            return Promise.reject(error);
          }
        }
        async deleteCookie(options) {
          try {
            document.cookie = `${options.key}=; Max-Age=0`;
          } catch (error) {
            return Promise.reject(error);
          }
        }
        async clearCookies() {
          try {
            const cookies = document.cookie.split(";") || [];
            for (const cookie of cookies) {
              document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${(/* @__PURE__ */ new Date()).toUTCString()};path=/`);
            }
          } catch (error) {
            return Promise.reject(error);
          }
        }
        async clearAllCookies() {
          try {
            await this.clearCookies();
          } catch (error) {
            return Promise.reject(error);
          }
        }
      };
      CapacitorCookies = registerPlugin("CapacitorCookies", {
        web: () => new CapacitorCookiesPluginWeb()
      });
      readBlobAsBase64 = async (blob) => new Promise((resolve2, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          resolve2(base64String.indexOf(",") >= 0 ? base64String.split(",")[1] : base64String);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(blob);
      });
      normalizeHttpHeaders = (headers = {}) => {
        const originalKeys = Object.keys(headers);
        const loweredKeys = Object.keys(headers).map((k) => k.toLocaleLowerCase());
        const normalized = loweredKeys.reduce((acc, key, index2) => {
          acc[key] = headers[originalKeys[index2]];
          return acc;
        }, {});
        return normalized;
      };
      buildUrlParams = (params, shouldEncode = true) => {
        if (!params)
          return null;
        const output3 = Object.entries(params).reduce((accumulator, entry) => {
          const [key, value] = entry;
          let encodedValue;
          let item;
          if (Array.isArray(value)) {
            item = "";
            value.forEach((str) => {
              encodedValue = shouldEncode ? encodeURIComponent(str) : str;
              item += `${key}=${encodedValue}&`;
            });
            item.slice(0, -1);
          } else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
          }
          return `${accumulator}&${item}`;
        }, "");
        return output3.substr(1);
      };
      buildRequestInit = (options, extra = {}) => {
        const output3 = Object.assign({ method: options.method || "GET", headers: options.headers }, extra);
        const headers = normalizeHttpHeaders(options.headers);
        const type = headers["content-type"] || "";
        if (typeof options.data === "string") {
          output3.body = options.data;
        } else if (type.includes("application/x-www-form-urlencoded")) {
          const params = new URLSearchParams();
          for (const [key, value] of Object.entries(options.data || {})) {
            params.set(key, value);
          }
          output3.body = params.toString();
        } else if (type.includes("multipart/form-data") || options.data instanceof FormData) {
          const form = new FormData();
          if (options.data instanceof FormData) {
            options.data.forEach((value, key) => {
              form.append(key, value);
            });
          } else {
            for (const key of Object.keys(options.data)) {
              form.append(key, options.data[key]);
            }
          }
          output3.body = form;
          const headers2 = new Headers(output3.headers);
          headers2.delete("content-type");
          output3.headers = headers2;
        } else if (type.includes("application/json") || typeof options.data === "object") {
          output3.body = JSON.stringify(options.data);
        }
        return output3;
      };
      CapacitorHttpPluginWeb = class extends WebPlugin {
        /**
         * Perform an Http request given a set of options
         * @param options Options to build the HTTP request
         */
        async request(options) {
          const requestInit = buildRequestInit(options, options.webFetchExtra);
          const urlParams = buildUrlParams(options.params, options.shouldEncodeUrlParams);
          const url = urlParams ? `${options.url}?${urlParams}` : options.url;
          const response = await fetch(url, requestInit);
          const contentType = response.headers.get("content-type") || "";
          let { responseType = "text" } = response.ok ? options : {};
          if (contentType.includes("application/json")) {
            responseType = "json";
          }
          let data;
          let blob;
          switch (responseType) {
            case "arraybuffer":
            case "blob":
              blob = await response.blob();
              data = await readBlobAsBase64(blob);
              break;
            case "json":
              data = await response.json();
              break;
            case "document":
            case "text":
            default:
              data = await response.text();
          }
          const headers = {};
          response.headers.forEach((value, key) => {
            headers[key] = value;
          });
          return {
            data,
            headers,
            status: response.status,
            url: response.url
          };
        }
        /**
         * Perform an Http GET request given a set of options
         * @param options Options to build the HTTP request
         */
        async get(options) {
          return this.request(Object.assign(Object.assign({}, options), { method: "GET" }));
        }
        /**
         * Perform an Http POST request given a set of options
         * @param options Options to build the HTTP request
         */
        async post(options) {
          return this.request(Object.assign(Object.assign({}, options), { method: "POST" }));
        }
        /**
         * Perform an Http PUT request given a set of options
         * @param options Options to build the HTTP request
         */
        async put(options) {
          return this.request(Object.assign(Object.assign({}, options), { method: "PUT" }));
        }
        /**
         * Perform an Http PATCH request given a set of options
         * @param options Options to build the HTTP request
         */
        async patch(options) {
          return this.request(Object.assign(Object.assign({}, options), { method: "PATCH" }));
        }
        /**
         * Perform an Http DELETE request given a set of options
         * @param options Options to build the HTTP request
         */
        async delete(options) {
          return this.request(Object.assign(Object.assign({}, options), { method: "DELETE" }));
        }
      };
      CapacitorHttp = registerPlugin("CapacitorHttp", {
        web: () => new CapacitorHttpPluginWeb()
      });
    }
  });

  // ../../node_modules/.pnpm/@capacitor+preferences@6.0.3_@capacitor+core@6.0.0/node_modules/@capacitor/preferences/dist/esm/web.js
  var web_exports = {};
  __export(web_exports, {
    PreferencesWeb: () => PreferencesWeb
  });
  var PreferencesWeb;
  var init_web = __esm({
    "../../node_modules/.pnpm/@capacitor+preferences@6.0.3_@capacitor+core@6.0.0/node_modules/@capacitor/preferences/dist/esm/web.js"() {
      init_dist5();
      PreferencesWeb = class extends WebPlugin {
        constructor() {
          super(...arguments);
          this.group = "CapacitorStorage";
        }
        async configure({ group }) {
          if (typeof group === "string") {
            this.group = group;
          }
        }
        async get(options) {
          const value = this.impl.getItem(this.applyPrefix(options.key));
          return { value };
        }
        async set(options) {
          this.impl.setItem(this.applyPrefix(options.key), options.value);
        }
        async remove(options) {
          this.impl.removeItem(this.applyPrefix(options.key));
        }
        async keys() {
          const keys = this.rawKeys().map((k) => k.substring(this.prefix.length));
          return { keys };
        }
        async clear() {
          for (const key of this.rawKeys()) {
            this.impl.removeItem(key);
          }
        }
        async migrate() {
          var _a6;
          const migrated = [];
          const existing = [];
          const oldprefix = "_cap_";
          const keys = Object.keys(this.impl).filter((k) => k.indexOf(oldprefix) === 0);
          for (const oldkey of keys) {
            const key = oldkey.substring(oldprefix.length);
            const value = (_a6 = this.impl.getItem(oldkey)) !== null && _a6 !== void 0 ? _a6 : "";
            const { value: currentValue } = await this.get({ key });
            if (typeof currentValue === "string") {
              existing.push(key);
            } else {
              await this.set({ key, value });
              migrated.push(key);
            }
          }
          return { migrated, existing };
        }
        async removeOld() {
          const oldprefix = "_cap_";
          const keys = Object.keys(this.impl).filter((k) => k.indexOf(oldprefix) === 0);
          for (const oldkey of keys) {
            this.impl.removeItem(oldkey);
          }
        }
        get impl() {
          return window.localStorage;
        }
        get prefix() {
          return this.group === "NativeStorage" ? "" : `${this.group}.`;
        }
        rawKeys() {
          return Object.keys(this.impl).filter((k) => k.indexOf(this.prefix) === 0);
        }
        applyPrefix(key) {
          return this.prefix + key;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/can-promise.js
  var require_can_promise = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/can-promise.js"(exports2, module2) {
      module2.exports = function() {
        return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/utils.js
  var require_utils3 = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/utils.js"(exports2) {
      var toSJISFunction;
      var CODEWORDS_COUNT = [
        0,
        // Not used
        26,
        44,
        70,
        100,
        134,
        172,
        196,
        242,
        292,
        346,
        404,
        466,
        532,
        581,
        655,
        733,
        815,
        901,
        991,
        1085,
        1156,
        1258,
        1364,
        1474,
        1588,
        1706,
        1828,
        1921,
        2051,
        2185,
        2323,
        2465,
        2611,
        2761,
        2876,
        3034,
        3196,
        3362,
        3532,
        3706
      ];
      exports2.getSymbolSize = function getSymbolSize(version17) {
        if (!version17) throw new Error('"version" cannot be null or undefined');
        if (version17 < 1 || version17 > 40) throw new Error('"version" should be in range from 1 to 40');
        return version17 * 4 + 17;
      };
      exports2.getSymbolTotalCodewords = function getSymbolTotalCodewords(version17) {
        return CODEWORDS_COUNT[version17];
      };
      exports2.getBCHDigit = function(data) {
        let digit = 0;
        while (data !== 0) {
          digit++;
          data >>>= 1;
        }
        return digit;
      };
      exports2.setToSJISFunction = function setToSJISFunction(f) {
        if (typeof f !== "function") {
          throw new Error('"toSJISFunc" is not a valid function.');
        }
        toSJISFunction = f;
      };
      exports2.isKanjiModeEnabled = function() {
        return typeof toSJISFunction !== "undefined";
      };
      exports2.toSJIS = function toSJIS(kanji) {
        return toSJISFunction(kanji);
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/error-correction-level.js
  var require_error_correction_level = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/error-correction-level.js"(exports2) {
      exports2.L = { bit: 1 };
      exports2.M = { bit: 0 };
      exports2.Q = { bit: 3 };
      exports2.H = { bit: 2 };
      function fromString(string) {
        if (typeof string !== "string") {
          throw new Error("Param is not a string");
        }
        const lcStr = string.toLowerCase();
        switch (lcStr) {
          case "l":
          case "low":
            return exports2.L;
          case "m":
          case "medium":
            return exports2.M;
          case "q":
          case "quartile":
            return exports2.Q;
          case "h":
          case "high":
            return exports2.H;
          default:
            throw new Error("Unknown EC Level: " + string);
        }
      }
      exports2.isValid = function isValid4(level2) {
        return level2 && typeof level2.bit !== "undefined" && level2.bit >= 0 && level2.bit < 4;
      };
      exports2.from = function from(value, defaultValue) {
        if (exports2.isValid(value)) {
          return value;
        }
        try {
          return fromString(value);
        } catch (e2) {
          return defaultValue;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/bit-buffer.js
  var require_bit_buffer = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/bit-buffer.js"(exports2, module2) {
      function BitBuffer() {
        this.buffer = [];
        this.length = 0;
      }
      BitBuffer.prototype = {
        get: function(index2) {
          const bufIndex = Math.floor(index2 / 8);
          return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) === 1;
        },
        put: function(num, length2) {
          for (let i2 = 0; i2 < length2; i2++) {
            this.putBit((num >>> length2 - i2 - 1 & 1) === 1);
          }
        },
        getLengthInBits: function() {
          return this.length;
        },
        putBit: function(bit) {
          const bufIndex = Math.floor(this.length / 8);
          if (this.buffer.length <= bufIndex) {
            this.buffer.push(0);
          }
          if (bit) {
            this.buffer[bufIndex] |= 128 >>> this.length % 8;
          }
          this.length++;
        }
      };
      module2.exports = BitBuffer;
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/bit-matrix.js
  var require_bit_matrix = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/bit-matrix.js"(exports2, module2) {
      function BitMatrix(size) {
        if (!size || size < 1) {
          throw new Error("BitMatrix size must be defined and greater than 0");
        }
        this.size = size;
        this.data = new Uint8Array(size * size);
        this.reservedBit = new Uint8Array(size * size);
      }
      BitMatrix.prototype.set = function(row, col, value, reserved) {
        const index2 = row * this.size + col;
        this.data[index2] = value;
        if (reserved) this.reservedBit[index2] = true;
      };
      BitMatrix.prototype.get = function(row, col) {
        return this.data[row * this.size + col];
      };
      BitMatrix.prototype.xor = function(row, col, value) {
        this.data[row * this.size + col] ^= value;
      };
      BitMatrix.prototype.isReserved = function(row, col) {
        return this.reservedBit[row * this.size + col];
      };
      module2.exports = BitMatrix;
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/alignment-pattern.js
  var require_alignment_pattern = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/alignment-pattern.js"(exports2) {
      var getSymbolSize = require_utils3().getSymbolSize;
      exports2.getRowColCoords = function getRowColCoords(version17) {
        if (version17 === 1) return [];
        const posCount = Math.floor(version17 / 7) + 2;
        const size = getSymbolSize(version17);
        const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
        const positions = [size - 7];
        for (let i2 = 1; i2 < posCount - 1; i2++) {
          positions[i2] = positions[i2 - 1] - intervals;
        }
        positions.push(6);
        return positions.reverse();
      };
      exports2.getPositions = function getPositions(version17) {
        const coords = [];
        const pos = exports2.getRowColCoords(version17);
        const posLength = pos.length;
        for (let i2 = 0; i2 < posLength; i2++) {
          for (let j = 0; j < posLength; j++) {
            if (i2 === 0 && j === 0 || // top-left
            i2 === 0 && j === posLength - 1 || // bottom-left
            i2 === posLength - 1 && j === 0) {
              continue;
            }
            coords.push([pos[i2], pos[j]]);
          }
        }
        return coords;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/finder-pattern.js
  var require_finder_pattern = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/finder-pattern.js"(exports2) {
      var getSymbolSize = require_utils3().getSymbolSize;
      var FINDER_PATTERN_SIZE = 7;
      exports2.getPositions = function getPositions(version17) {
        const size = getSymbolSize(version17);
        return [
          // top-left
          [0, 0],
          // top-right
          [size - FINDER_PATTERN_SIZE, 0],
          // bottom-left
          [0, size - FINDER_PATTERN_SIZE]
        ];
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/mask-pattern.js
  var require_mask_pattern = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/mask-pattern.js"(exports2) {
      exports2.Patterns = {
        PATTERN000: 0,
        PATTERN001: 1,
        PATTERN010: 2,
        PATTERN011: 3,
        PATTERN100: 4,
        PATTERN101: 5,
        PATTERN110: 6,
        PATTERN111: 7
      };
      var PenaltyScores = {
        N1: 3,
        N2: 3,
        N3: 40,
        N4: 10
      };
      exports2.isValid = function isValid4(mask2) {
        return mask2 != null && mask2 !== "" && !isNaN(mask2) && mask2 >= 0 && mask2 <= 7;
      };
      exports2.from = function from(value) {
        return exports2.isValid(value) ? parseInt(value, 10) : void 0;
      };
      exports2.getPenaltyN1 = function getPenaltyN1(data) {
        const size = data.size;
        let points = 0;
        let sameCountCol = 0;
        let sameCountRow = 0;
        let lastCol = null;
        let lastRow = null;
        for (let row = 0; row < size; row++) {
          sameCountCol = sameCountRow = 0;
          lastCol = lastRow = null;
          for (let col = 0; col < size; col++) {
            let module3 = data.get(row, col);
            if (module3 === lastCol) {
              sameCountCol++;
            } else {
              if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
              lastCol = module3;
              sameCountCol = 1;
            }
            module3 = data.get(col, row);
            if (module3 === lastRow) {
              sameCountRow++;
            } else {
              if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
              lastRow = module3;
              sameCountRow = 1;
            }
          }
          if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
          if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
        }
        return points;
      };
      exports2.getPenaltyN2 = function getPenaltyN2(data) {
        const size = data.size;
        let points = 0;
        for (let row = 0; row < size - 1; row++) {
          for (let col = 0; col < size - 1; col++) {
            const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
            if (last === 4 || last === 0) points++;
          }
        }
        return points * PenaltyScores.N2;
      };
      exports2.getPenaltyN3 = function getPenaltyN3(data) {
        const size = data.size;
        let points = 0;
        let bitsCol = 0;
        let bitsRow = 0;
        for (let row = 0; row < size; row++) {
          bitsCol = bitsRow = 0;
          for (let col = 0; col < size; col++) {
            bitsCol = bitsCol << 1 & 2047 | data.get(row, col);
            if (col >= 10 && (bitsCol === 1488 || bitsCol === 93)) points++;
            bitsRow = bitsRow << 1 & 2047 | data.get(col, row);
            if (col >= 10 && (bitsRow === 1488 || bitsRow === 93)) points++;
          }
        }
        return points * PenaltyScores.N3;
      };
      exports2.getPenaltyN4 = function getPenaltyN4(data) {
        let darkCount = 0;
        const modulesCount = data.data.length;
        for (let i2 = 0; i2 < modulesCount; i2++) darkCount += data.data[i2];
        const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
        return k * PenaltyScores.N4;
      };
      function getMaskAt(maskPattern, i2, j) {
        switch (maskPattern) {
          case exports2.Patterns.PATTERN000:
            return (i2 + j) % 2 === 0;
          case exports2.Patterns.PATTERN001:
            return i2 % 2 === 0;
          case exports2.Patterns.PATTERN010:
            return j % 3 === 0;
          case exports2.Patterns.PATTERN011:
            return (i2 + j) % 3 === 0;
          case exports2.Patterns.PATTERN100:
            return (Math.floor(i2 / 2) + Math.floor(j / 3)) % 2 === 0;
          case exports2.Patterns.PATTERN101:
            return i2 * j % 2 + i2 * j % 3 === 0;
          case exports2.Patterns.PATTERN110:
            return (i2 * j % 2 + i2 * j % 3) % 2 === 0;
          case exports2.Patterns.PATTERN111:
            return (i2 * j % 3 + (i2 + j) % 2) % 2 === 0;
          default:
            throw new Error("bad maskPattern:" + maskPattern);
        }
      }
      exports2.applyMask = function applyMask(pattern2, data) {
        const size = data.size;
        for (let col = 0; col < size; col++) {
          for (let row = 0; row < size; row++) {
            if (data.isReserved(row, col)) continue;
            data.xor(row, col, getMaskAt(pattern2, row, col));
          }
        }
      };
      exports2.getBestMask = function getBestMask(data, setupFormatFunc) {
        const numPatterns = Object.keys(exports2.Patterns).length;
        let bestPattern = 0;
        let lowerPenalty = Infinity;
        for (let p12 = 0; p12 < numPatterns; p12++) {
          setupFormatFunc(p12);
          exports2.applyMask(p12, data);
          const penalty = exports2.getPenaltyN1(data) + exports2.getPenaltyN2(data) + exports2.getPenaltyN3(data) + exports2.getPenaltyN4(data);
          exports2.applyMask(p12, data);
          if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p12;
          }
        }
        return bestPattern;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/error-correction-code.js
  var require_error_correction_code = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/error-correction-code.js"(exports2) {
      var ECLevel = require_error_correction_level();
      var EC_BLOCKS_TABLE = [
        // L  M  Q  H
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        2,
        1,
        2,
        2,
        4,
        1,
        2,
        4,
        4,
        2,
        4,
        4,
        4,
        2,
        4,
        6,
        5,
        2,
        4,
        6,
        6,
        2,
        5,
        8,
        8,
        4,
        5,
        8,
        8,
        4,
        5,
        8,
        11,
        4,
        8,
        10,
        11,
        4,
        9,
        12,
        16,
        4,
        9,
        16,
        16,
        6,
        10,
        12,
        18,
        6,
        10,
        17,
        16,
        6,
        11,
        16,
        19,
        6,
        13,
        18,
        21,
        7,
        14,
        21,
        25,
        8,
        16,
        20,
        25,
        8,
        17,
        23,
        25,
        9,
        17,
        23,
        34,
        9,
        18,
        25,
        30,
        10,
        20,
        27,
        32,
        12,
        21,
        29,
        35,
        12,
        23,
        34,
        37,
        12,
        25,
        34,
        40,
        13,
        26,
        35,
        42,
        14,
        28,
        38,
        45,
        15,
        29,
        40,
        48,
        16,
        31,
        43,
        51,
        17,
        33,
        45,
        54,
        18,
        35,
        48,
        57,
        19,
        37,
        51,
        60,
        19,
        38,
        53,
        63,
        20,
        40,
        56,
        66,
        21,
        43,
        59,
        70,
        22,
        45,
        62,
        74,
        24,
        47,
        65,
        77,
        25,
        49,
        68,
        81
      ];
      var EC_CODEWORDS_TABLE = [
        // L  M  Q  H
        7,
        10,
        13,
        17,
        10,
        16,
        22,
        28,
        15,
        26,
        36,
        44,
        20,
        36,
        52,
        64,
        26,
        48,
        72,
        88,
        36,
        64,
        96,
        112,
        40,
        72,
        108,
        130,
        48,
        88,
        132,
        156,
        60,
        110,
        160,
        192,
        72,
        130,
        192,
        224,
        80,
        150,
        224,
        264,
        96,
        176,
        260,
        308,
        104,
        198,
        288,
        352,
        120,
        216,
        320,
        384,
        132,
        240,
        360,
        432,
        144,
        280,
        408,
        480,
        168,
        308,
        448,
        532,
        180,
        338,
        504,
        588,
        196,
        364,
        546,
        650,
        224,
        416,
        600,
        700,
        224,
        442,
        644,
        750,
        252,
        476,
        690,
        816,
        270,
        504,
        750,
        900,
        300,
        560,
        810,
        960,
        312,
        588,
        870,
        1050,
        336,
        644,
        952,
        1110,
        360,
        700,
        1020,
        1200,
        390,
        728,
        1050,
        1260,
        420,
        784,
        1140,
        1350,
        450,
        812,
        1200,
        1440,
        480,
        868,
        1290,
        1530,
        510,
        924,
        1350,
        1620,
        540,
        980,
        1440,
        1710,
        570,
        1036,
        1530,
        1800,
        570,
        1064,
        1590,
        1890,
        600,
        1120,
        1680,
        1980,
        630,
        1204,
        1770,
        2100,
        660,
        1260,
        1860,
        2220,
        720,
        1316,
        1950,
        2310,
        750,
        1372,
        2040,
        2430
      ];
      exports2.getBlocksCount = function getBlocksCount(version17, errorCorrectionLevel) {
        switch (errorCorrectionLevel) {
          case ECLevel.L:
            return EC_BLOCKS_TABLE[(version17 - 1) * 4 + 0];
          case ECLevel.M:
            return EC_BLOCKS_TABLE[(version17 - 1) * 4 + 1];
          case ECLevel.Q:
            return EC_BLOCKS_TABLE[(version17 - 1) * 4 + 2];
          case ECLevel.H:
            return EC_BLOCKS_TABLE[(version17 - 1) * 4 + 3];
          default:
            return void 0;
        }
      };
      exports2.getTotalCodewordsCount = function getTotalCodewordsCount(version17, errorCorrectionLevel) {
        switch (errorCorrectionLevel) {
          case ECLevel.L:
            return EC_CODEWORDS_TABLE[(version17 - 1) * 4 + 0];
          case ECLevel.M:
            return EC_CODEWORDS_TABLE[(version17 - 1) * 4 + 1];
          case ECLevel.Q:
            return EC_CODEWORDS_TABLE[(version17 - 1) * 4 + 2];
          case ECLevel.H:
            return EC_CODEWORDS_TABLE[(version17 - 1) * 4 + 3];
          default:
            return void 0;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/galois-field.js
  var require_galois_field = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/galois-field.js"(exports2) {
      var EXP_TABLE = new Uint8Array(512);
      var LOG_TABLE = new Uint8Array(256);
      (function initTables() {
        let x = 1;
        for (let i2 = 0; i2 < 255; i2++) {
          EXP_TABLE[i2] = x;
          LOG_TABLE[x] = i2;
          x <<= 1;
          if (x & 256) {
            x ^= 285;
          }
        }
        for (let i2 = 255; i2 < 512; i2++) {
          EXP_TABLE[i2] = EXP_TABLE[i2 - 255];
        }
      })();
      exports2.log = function log2(n2) {
        if (n2 < 1) throw new Error("log(" + n2 + ")");
        return LOG_TABLE[n2];
      };
      exports2.exp = function exp(n2) {
        return EXP_TABLE[n2];
      };
      exports2.mul = function mul(x, y) {
        if (x === 0 || y === 0) return 0;
        return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]];
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/polynomial.js
  var require_polynomial = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/polynomial.js"(exports2) {
      var GF = require_galois_field();
      exports2.mul = function mul(p1, p22) {
        const coeff = new Uint8Array(p1.length + p22.length - 1);
        for (let i2 = 0; i2 < p1.length; i2++) {
          for (let j = 0; j < p22.length; j++) {
            coeff[i2 + j] ^= GF.mul(p1[i2], p22[j]);
          }
        }
        return coeff;
      };
      exports2.mod = function mod3(divident, divisor) {
        let result = new Uint8Array(divident);
        while (result.length - divisor.length >= 0) {
          const coeff = result[0];
          for (let i2 = 0; i2 < divisor.length; i2++) {
            result[i2] ^= GF.mul(divisor[i2], coeff);
          }
          let offset = 0;
          while (offset < result.length && result[offset] === 0) offset++;
          result = result.slice(offset);
        }
        return result;
      };
      exports2.generateECPolynomial = function generateECPolynomial(degree) {
        let poly = new Uint8Array([1]);
        for (let i2 = 0; i2 < degree; i2++) {
          poly = exports2.mul(poly, new Uint8Array([1, GF.exp(i2)]));
        }
        return poly;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/reed-solomon-encoder.js
  var require_reed_solomon_encoder = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/reed-solomon-encoder.js"(exports2, module2) {
      var Polynomial = require_polynomial();
      function ReedSolomonEncoder(degree) {
        this.genPoly = void 0;
        this.degree = degree;
        if (this.degree) this.initialize(this.degree);
      }
      ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
        this.degree = degree;
        this.genPoly = Polynomial.generateECPolynomial(this.degree);
      };
      ReedSolomonEncoder.prototype.encode = function encode4(data) {
        if (!this.genPoly) {
          throw new Error("Encoder not initialized");
        }
        const paddedData = new Uint8Array(data.length + this.degree);
        paddedData.set(data);
        const remainder = Polynomial.mod(paddedData, this.genPoly);
        const start = this.degree - remainder.length;
        if (start > 0) {
          const buff = new Uint8Array(this.degree);
          buff.set(remainder, start);
          return buff;
        }
        return remainder;
      };
      module2.exports = ReedSolomonEncoder;
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/version-check.js
  var require_version_check = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/version-check.js"(exports2) {
      exports2.isValid = function isValid4(version17) {
        return !isNaN(version17) && version17 >= 1 && version17 <= 40;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/regex.js
  var require_regex = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/regex.js"(exports2) {
      var numeric = "[0-9]+";
      var alphanumeric = "[A-Z $%*+\\-./:]+";
      var kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
      kanji = kanji.replace(/u/g, "\\u");
      var byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
      exports2.KANJI = new RegExp(kanji, "g");
      exports2.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
      exports2.BYTE = new RegExp(byte, "g");
      exports2.NUMERIC = new RegExp(numeric, "g");
      exports2.ALPHANUMERIC = new RegExp(alphanumeric, "g");
      var TEST_KANJI = new RegExp("^" + kanji + "$");
      var TEST_NUMERIC = new RegExp("^" + numeric + "$");
      var TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
      exports2.testKanji = function testKanji(str) {
        return TEST_KANJI.test(str);
      };
      exports2.testNumeric = function testNumeric(str) {
        return TEST_NUMERIC.test(str);
      };
      exports2.testAlphanumeric = function testAlphanumeric(str) {
        return TEST_ALPHANUMERIC.test(str);
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/mode.js
  var require_mode = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/mode.js"(exports2) {
      var VersionCheck = require_version_check();
      var Regex = require_regex();
      exports2.NUMERIC = {
        id: "Numeric",
        bit: 1 << 0,
        ccBits: [10, 12, 14]
      };
      exports2.ALPHANUMERIC = {
        id: "Alphanumeric",
        bit: 1 << 1,
        ccBits: [9, 11, 13]
      };
      exports2.BYTE = {
        id: "Byte",
        bit: 1 << 2,
        ccBits: [8, 16, 16]
      };
      exports2.KANJI = {
        id: "Kanji",
        bit: 1 << 3,
        ccBits: [8, 10, 12]
      };
      exports2.MIXED = {
        bit: -1
      };
      exports2.getCharCountIndicator = function getCharCountIndicator(mode, version17) {
        if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
        if (!VersionCheck.isValid(version17)) {
          throw new Error("Invalid version: " + version17);
        }
        if (version17 >= 1 && version17 < 10) return mode.ccBits[0];
        else if (version17 < 27) return mode.ccBits[1];
        return mode.ccBits[2];
      };
      exports2.getBestModeForData = function getBestModeForData(dataStr) {
        if (Regex.testNumeric(dataStr)) return exports2.NUMERIC;
        else if (Regex.testAlphanumeric(dataStr)) return exports2.ALPHANUMERIC;
        else if (Regex.testKanji(dataStr)) return exports2.KANJI;
        else return exports2.BYTE;
      };
      exports2.toString = function toString3(mode) {
        if (mode && mode.id) return mode.id;
        throw new Error("Invalid mode");
      };
      exports2.isValid = function isValid4(mode) {
        return mode && mode.bit && mode.ccBits;
      };
      function fromString(string) {
        if (typeof string !== "string") {
          throw new Error("Param is not a string");
        }
        const lcStr = string.toLowerCase();
        switch (lcStr) {
          case "numeric":
            return exports2.NUMERIC;
          case "alphanumeric":
            return exports2.ALPHANUMERIC;
          case "kanji":
            return exports2.KANJI;
          case "byte":
            return exports2.BYTE;
          default:
            throw new Error("Unknown mode: " + string);
        }
      }
      exports2.from = function from(value, defaultValue) {
        if (exports2.isValid(value)) {
          return value;
        }
        try {
          return fromString(value);
        } catch (e2) {
          return defaultValue;
        }
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/version.js
  var require_version2 = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/version.js"(exports2) {
      var Utils = require_utils3();
      var ECCode = require_error_correction_code();
      var ECLevel = require_error_correction_level();
      var Mode = require_mode();
      var VersionCheck = require_version_check();
      var G18 = 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0;
      var G18_BCH = Utils.getBCHDigit(G18);
      function getBestVersionForDataLength(mode, length2, errorCorrectionLevel) {
        for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
          if (length2 <= exports2.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
            return currentVersion;
          }
        }
        return void 0;
      }
      function getReservedBitsCount(mode, version17) {
        return Mode.getCharCountIndicator(mode, version17) + 4;
      }
      function getTotalBitsFromDataArray(segments, version17) {
        let totalBits = 0;
        segments.forEach(function(data) {
          const reservedBits = getReservedBitsCount(data.mode, version17);
          totalBits += reservedBits + data.getBitsLength();
        });
        return totalBits;
      }
      function getBestVersionForMixedData(segments, errorCorrectionLevel) {
        for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
          const length2 = getTotalBitsFromDataArray(segments, currentVersion);
          if (length2 <= exports2.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
            return currentVersion;
          }
        }
        return void 0;
      }
      exports2.from = function from(value, defaultValue) {
        if (VersionCheck.isValid(value)) {
          return parseInt(value, 10);
        }
        return defaultValue;
      };
      exports2.getCapacity = function getCapacity(version17, errorCorrectionLevel, mode) {
        if (!VersionCheck.isValid(version17)) {
          throw new Error("Invalid QR Code version");
        }
        if (typeof mode === "undefined") mode = Mode.BYTE;
        const totalCodewords = Utils.getSymbolTotalCodewords(version17);
        const ecTotalCodewords = ECCode.getTotalCodewordsCount(version17, errorCorrectionLevel);
        const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
        if (mode === Mode.MIXED) return dataTotalCodewordsBits;
        const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version17);
        switch (mode) {
          case Mode.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
          case Mode.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
          case Mode.KANJI:
            return Math.floor(usableBits / 13);
          case Mode.BYTE:
          default:
            return Math.floor(usableBits / 8);
        }
      };
      exports2.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel) {
        let seg;
        const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);
        if (Array.isArray(data)) {
          if (data.length > 1) {
            return getBestVersionForMixedData(data, ecl);
          }
          if (data.length === 0) {
            return 1;
          }
          seg = data[0];
        } else {
          seg = data;
        }
        return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
      };
      exports2.getEncodedBits = function getEncodedBits(version17) {
        if (!VersionCheck.isValid(version17) || version17 < 7) {
          throw new Error("Invalid QR Code version");
        }
        let d = version17 << 12;
        while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
          d ^= G18 << Utils.getBCHDigit(d) - G18_BCH;
        }
        return version17 << 12 | d;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/format-info.js
  var require_format_info = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/format-info.js"(exports2) {
      var Utils = require_utils3();
      var G15 = 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0;
      var G15_MASK = 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1;
      var G15_BCH = Utils.getBCHDigit(G15);
      exports2.getEncodedBits = function getEncodedBits(errorCorrectionLevel, mask2) {
        const data = errorCorrectionLevel.bit << 3 | mask2;
        let d = data << 10;
        while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
          d ^= G15 << Utils.getBCHDigit(d) - G15_BCH;
        }
        return (data << 10 | d) ^ G15_MASK;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/numeric-data.js
  var require_numeric_data = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/numeric-data.js"(exports2, module2) {
      var Mode = require_mode();
      function NumericData(data) {
        this.mode = Mode.NUMERIC;
        this.data = data.toString();
      }
      NumericData.getBitsLength = function getBitsLength(length2) {
        return 10 * Math.floor(length2 / 3) + (length2 % 3 ? length2 % 3 * 3 + 1 : 0);
      };
      NumericData.prototype.getLength = function getLength() {
        return this.data.length;
      };
      NumericData.prototype.getBitsLength = function getBitsLength() {
        return NumericData.getBitsLength(this.data.length);
      };
      NumericData.prototype.write = function write2(bitBuffer) {
        let i2, group, value;
        for (i2 = 0; i2 + 3 <= this.data.length; i2 += 3) {
          group = this.data.substr(i2, 3);
          value = parseInt(group, 10);
          bitBuffer.put(value, 10);
        }
        const remainingNum = this.data.length - i2;
        if (remainingNum > 0) {
          group = this.data.substr(i2);
          value = parseInt(group, 10);
          bitBuffer.put(value, remainingNum * 3 + 1);
        }
      };
      module2.exports = NumericData;
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/alphanumeric-data.js
  var require_alphanumeric_data = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/alphanumeric-data.js"(exports2, module2) {
      var Mode = require_mode();
      var ALPHA_NUM_CHARS = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        " ",
        "$",
        "%",
        "*",
        "+",
        "-",
        ".",
        "/",
        ":"
      ];
      function AlphanumericData(data) {
        this.mode = Mode.ALPHANUMERIC;
        this.data = data;
      }
      AlphanumericData.getBitsLength = function getBitsLength(length2) {
        return 11 * Math.floor(length2 / 2) + 6 * (length2 % 2);
      };
      AlphanumericData.prototype.getLength = function getLength() {
        return this.data.length;
      };
      AlphanumericData.prototype.getBitsLength = function getBitsLength() {
        return AlphanumericData.getBitsLength(this.data.length);
      };
      AlphanumericData.prototype.write = function write2(bitBuffer) {
        let i2;
        for (i2 = 0; i2 + 2 <= this.data.length; i2 += 2) {
          let value = ALPHA_NUM_CHARS.indexOf(this.data[i2]) * 45;
          value += ALPHA_NUM_CHARS.indexOf(this.data[i2 + 1]);
          bitBuffer.put(value, 11);
        }
        if (this.data.length % 2) {
          bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i2]), 6);
        }
      };
      module2.exports = AlphanumericData;
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/byte-data.js
  var require_byte_data = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/byte-data.js"(exports2, module2) {
      var Mode = require_mode();
      function ByteData(data) {
        this.mode = Mode.BYTE;
        if (typeof data === "string") {
          this.data = new TextEncoder().encode(data);
        } else {
          this.data = new Uint8Array(data);
        }
      }
      ByteData.getBitsLength = function getBitsLength(length2) {
        return length2 * 8;
      };
      ByteData.prototype.getLength = function getLength() {
        return this.data.length;
      };
      ByteData.prototype.getBitsLength = function getBitsLength() {
        return ByteData.getBitsLength(this.data.length);
      };
      ByteData.prototype.write = function(bitBuffer) {
        for (let i2 = 0, l = this.data.length; i2 < l; i2++) {
          bitBuffer.put(this.data[i2], 8);
        }
      };
      module2.exports = ByteData;
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/kanji-data.js
  var require_kanji_data = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/kanji-data.js"(exports2, module2) {
      var Mode = require_mode();
      var Utils = require_utils3();
      function KanjiData(data) {
        this.mode = Mode.KANJI;
        this.data = data;
      }
      KanjiData.getBitsLength = function getBitsLength(length2) {
        return length2 * 13;
      };
      KanjiData.prototype.getLength = function getLength() {
        return this.data.length;
      };
      KanjiData.prototype.getBitsLength = function getBitsLength() {
        return KanjiData.getBitsLength(this.data.length);
      };
      KanjiData.prototype.write = function(bitBuffer) {
        let i2;
        for (i2 = 0; i2 < this.data.length; i2++) {
          let value = Utils.toSJIS(this.data[i2]);
          if (value >= 33088 && value <= 40956) {
            value -= 33088;
          } else if (value >= 57408 && value <= 60351) {
            value -= 49472;
          } else {
            throw new Error(
              "Invalid SJIS character: " + this.data[i2] + "\nMake sure your charset is UTF-8"
            );
          }
          value = (value >>> 8 & 255) * 192 + (value & 255);
          bitBuffer.put(value, 13);
        }
      };
      module2.exports = KanjiData;
    }
  });

  // ../../node_modules/.pnpm/dijkstrajs@1.0.3/node_modules/dijkstrajs/dijkstra.js
  var require_dijkstra = __commonJS({
    "../../node_modules/.pnpm/dijkstrajs@1.0.3/node_modules/dijkstrajs/dijkstra.js"(exports2, module2) {
      "use strict";
      var dijkstra = {
        single_source_shortest_paths: function(graph, s2, d) {
          var predecessors = {};
          var costs = {};
          costs[s2] = 0;
          var open3 = dijkstra.PriorityQueue.make();
          open3.push(s2, 0);
          var closest2, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
          while (!open3.empty()) {
            closest2 = open3.pop();
            u = closest2.value;
            cost_of_s_to_u = closest2.cost;
            adjacent_nodes = graph[u] || {};
            for (v in adjacent_nodes) {
              if (adjacent_nodes.hasOwnProperty(v)) {
                cost_of_e = adjacent_nodes[v];
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                  costs[v] = cost_of_s_to_u_plus_cost_of_e;
                  open3.push(v, cost_of_s_to_u_plus_cost_of_e);
                  predecessors[v] = u;
                }
              }
            }
          }
          if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = ["Could not find a path from ", s2, " to ", d, "."].join("");
            throw new Error(msg);
          }
          return predecessors;
        },
        extract_shortest_path_from_predecessor_list: function(predecessors, d) {
          var nodes = [];
          var u = d;
          var predecessor;
          while (u) {
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
          }
          nodes.reverse();
          return nodes;
        },
        find_path: function(graph, s2, d) {
          var predecessors = dijkstra.single_source_shortest_paths(graph, s2, d);
          return dijkstra.extract_shortest_path_from_predecessor_list(
            predecessors,
            d
          );
        },
        /**
         * A very naive priority queue implementation.
         */
        PriorityQueue: {
          make: function(opts) {
            var T = dijkstra.PriorityQueue, t2 = {}, key;
            opts = opts || {};
            for (key in T) {
              if (T.hasOwnProperty(key)) {
                t2[key] = T[key];
              }
            }
            t2.queue = [];
            t2.sorter = opts.sorter || T.default_sorter;
            return t2;
          },
          default_sorter: function(a, b) {
            return a.cost - b.cost;
          },
          /**
           * Add a new item to the queue and ensure the highest priority element
           * is at the front of the queue.
           */
          push: function(value, cost) {
            var item = { value, cost };
            this.queue.push(item);
            this.queue.sort(this.sorter);
          },
          /**
           * Return the highest priority element in the queue.
           */
          pop: function() {
            return this.queue.shift();
          },
          empty: function() {
            return this.queue.length === 0;
          }
        }
      };
      if (typeof module2 !== "undefined") {
        module2.exports = dijkstra;
      }
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/segments.js
  var require_segments = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/segments.js"(exports2) {
      var Mode = require_mode();
      var NumericData = require_numeric_data();
      var AlphanumericData = require_alphanumeric_data();
      var ByteData = require_byte_data();
      var KanjiData = require_kanji_data();
      var Regex = require_regex();
      var Utils = require_utils3();
      var dijkstra = require_dijkstra();
      function getStringByteLength(str) {
        return unescape(encodeURIComponent(str)).length;
      }
      function getSegments(regex, mode, str) {
        const segments = [];
        let result;
        while ((result = regex.exec(str)) !== null) {
          segments.push({
            data: result[0],
            index: result.index,
            mode,
            length: result[0].length
          });
        }
        return segments;
      }
      function getSegmentsFromString(dataStr) {
        const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
        const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
        let byteSegs;
        let kanjiSegs;
        if (Utils.isKanjiModeEnabled()) {
          byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
          kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
        } else {
          byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
          kanjiSegs = [];
        }
        const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
        return segs.sort(function(s1, s2) {
          return s1.index - s2.index;
        }).map(function(obj) {
          return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
          };
        });
      }
      function getSegmentBitsLength(length2, mode) {
        switch (mode) {
          case Mode.NUMERIC:
            return NumericData.getBitsLength(length2);
          case Mode.ALPHANUMERIC:
            return AlphanumericData.getBitsLength(length2);
          case Mode.KANJI:
            return KanjiData.getBitsLength(length2);
          case Mode.BYTE:
            return ByteData.getBitsLength(length2);
        }
      }
      function mergeSegments(segs) {
        return segs.reduce(function(acc, curr) {
          const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
          if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
          }
          acc.push(curr);
          return acc;
        }, []);
      }
      function buildNodes(segs) {
        const nodes = [];
        for (let i2 = 0; i2 < segs.length; i2++) {
          const seg = segs[i2];
          switch (seg.mode) {
            case Mode.NUMERIC:
              nodes.push([
                seg,
                { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
                { data: seg.data, mode: Mode.BYTE, length: seg.length }
              ]);
              break;
            case Mode.ALPHANUMERIC:
              nodes.push([
                seg,
                { data: seg.data, mode: Mode.BYTE, length: seg.length }
              ]);
              break;
            case Mode.KANJI:
              nodes.push([
                seg,
                { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
              ]);
              break;
            case Mode.BYTE:
              nodes.push([
                { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
              ]);
          }
        }
        return nodes;
      }
      function buildGraph(nodes, version17) {
        const table = {};
        const graph = { start: {} };
        let prevNodeIds = ["start"];
        for (let i2 = 0; i2 < nodes.length; i2++) {
          const nodeGroup = nodes[i2];
          const currentNodeIds = [];
          for (let j = 0; j < nodeGroup.length; j++) {
            const node = nodeGroup[j];
            const key = "" + i2 + j;
            currentNodeIds.push(key);
            table[key] = { node, lastCount: 0 };
            graph[key] = {};
            for (let n2 = 0; n2 < prevNodeIds.length; n2++) {
              const prevNodeId = prevNodeIds[n2];
              if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                table[prevNodeId].lastCount += node.length;
              } else {
                if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode.getCharCountIndicator(node.mode, version17);
              }
            }
          }
          prevNodeIds = currentNodeIds;
        }
        for (let n2 = 0; n2 < prevNodeIds.length; n2++) {
          graph[prevNodeIds[n2]].end = 0;
        }
        return { map: graph, table };
      }
      function buildSingleSegment(data, modesHint) {
        let mode;
        const bestMode = Mode.getBestModeForData(data);
        mode = Mode.from(modesHint, bestMode);
        if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
          throw new Error('"' + data + '" cannot be encoded with mode ' + Mode.toString(mode) + ".\n Suggested mode is: " + Mode.toString(bestMode));
        }
        if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
          mode = Mode.BYTE;
        }
        switch (mode) {
          case Mode.NUMERIC:
            return new NumericData(data);
          case Mode.ALPHANUMERIC:
            return new AlphanumericData(data);
          case Mode.KANJI:
            return new KanjiData(data);
          case Mode.BYTE:
            return new ByteData(data);
        }
      }
      exports2.fromArray = function fromArray(array) {
        return array.reduce(function(acc, seg) {
          if (typeof seg === "string") {
            acc.push(buildSingleSegment(seg, null));
          } else if (seg.data) {
            acc.push(buildSingleSegment(seg.data, seg.mode));
          }
          return acc;
        }, []);
      };
      exports2.fromString = function fromString(data, version17) {
        const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());
        const nodes = buildNodes(segs);
        const graph = buildGraph(nodes, version17);
        const path3 = dijkstra.find_path(graph.map, "start", "end");
        const optimizedSegs = [];
        for (let i2 = 1; i2 < path3.length - 1; i2++) {
          optimizedSegs.push(graph.table[path3[i2]].node);
        }
        return exports2.fromArray(mergeSegments(optimizedSegs));
      };
      exports2.rawSplit = function rawSplit(data) {
        return exports2.fromArray(
          getSegmentsFromString(data, Utils.isKanjiModeEnabled())
        );
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/qrcode.js
  var require_qrcode = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/core/qrcode.js"(exports2) {
      var Utils = require_utils3();
      var ECLevel = require_error_correction_level();
      var BitBuffer = require_bit_buffer();
      var BitMatrix = require_bit_matrix();
      var AlignmentPattern = require_alignment_pattern();
      var FinderPattern = require_finder_pattern();
      var MaskPattern = require_mask_pattern();
      var ECCode = require_error_correction_code();
      var ReedSolomonEncoder = require_reed_solomon_encoder();
      var Version = require_version2();
      var FormatInfo = require_format_info();
      var Mode = require_mode();
      var Segments = require_segments();
      function setupFinderPattern(matrix, version17) {
        const size = matrix.size;
        const pos = FinderPattern.getPositions(version17);
        for (let i2 = 0; i2 < pos.length; i2++) {
          const row = pos[i2][0];
          const col = pos[i2][1];
          for (let r2 = -1; r2 <= 7; r2++) {
            if (row + r2 <= -1 || size <= row + r2) continue;
            for (let c = -1; c <= 7; c++) {
              if (col + c <= -1 || size <= col + c) continue;
              if (r2 >= 0 && r2 <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r2 === 0 || r2 === 6) || r2 >= 2 && r2 <= 4 && c >= 2 && c <= 4) {
                matrix.set(row + r2, col + c, true, true);
              } else {
                matrix.set(row + r2, col + c, false, true);
              }
            }
          }
        }
      }
      function setupTimingPattern(matrix) {
        const size = matrix.size;
        for (let r2 = 8; r2 < size - 8; r2++) {
          const value = r2 % 2 === 0;
          matrix.set(r2, 6, value, true);
          matrix.set(6, r2, value, true);
        }
      }
      function setupAlignmentPattern(matrix, version17) {
        const pos = AlignmentPattern.getPositions(version17);
        for (let i2 = 0; i2 < pos.length; i2++) {
          const row = pos[i2][0];
          const col = pos[i2][1];
          for (let r2 = -2; r2 <= 2; r2++) {
            for (let c = -2; c <= 2; c++) {
              if (r2 === -2 || r2 === 2 || c === -2 || c === 2 || r2 === 0 && c === 0) {
                matrix.set(row + r2, col + c, true, true);
              } else {
                matrix.set(row + r2, col + c, false, true);
              }
            }
          }
        }
      }
      function setupVersionInfo(matrix, version17) {
        const size = matrix.size;
        const bits2 = Version.getEncodedBits(version17);
        let row, col, mod3;
        for (let i2 = 0; i2 < 18; i2++) {
          row = Math.floor(i2 / 3);
          col = i2 % 3 + size - 8 - 3;
          mod3 = (bits2 >> i2 & 1) === 1;
          matrix.set(row, col, mod3, true);
          matrix.set(col, row, mod3, true);
        }
      }
      function setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
        const size = matrix.size;
        const bits2 = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
        let i2, mod3;
        for (i2 = 0; i2 < 15; i2++) {
          mod3 = (bits2 >> i2 & 1) === 1;
          if (i2 < 6) {
            matrix.set(i2, 8, mod3, true);
          } else if (i2 < 8) {
            matrix.set(i2 + 1, 8, mod3, true);
          } else {
            matrix.set(size - 15 + i2, 8, mod3, true);
          }
          if (i2 < 8) {
            matrix.set(8, size - i2 - 1, mod3, true);
          } else if (i2 < 9) {
            matrix.set(8, 15 - i2 - 1 + 1, mod3, true);
          } else {
            matrix.set(8, 15 - i2 - 1, mod3, true);
          }
        }
        matrix.set(size - 8, 8, 1, true);
      }
      function setupData(matrix, data) {
        const size = matrix.size;
        let inc = -1;
        let row = size - 1;
        let bitIndex = 7;
        let byteIndex = 0;
        for (let col = size - 1; col > 0; col -= 2) {
          if (col === 6) col--;
          while (true) {
            for (let c = 0; c < 2; c++) {
              if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) {
                  dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                }
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                  byteIndex++;
                  bitIndex = 7;
                }
              }
            }
            row += inc;
            if (row < 0 || size <= row) {
              row -= inc;
              inc = -inc;
              break;
            }
          }
        }
      }
      function createData(version17, errorCorrectionLevel, segments) {
        const buffer = new BitBuffer();
        segments.forEach(function(data) {
          buffer.put(data.mode.bit, 4);
          buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version17));
          data.write(buffer);
        });
        const totalCodewords = Utils.getSymbolTotalCodewords(version17);
        const ecTotalCodewords = ECCode.getTotalCodewordsCount(version17, errorCorrectionLevel);
        const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
        if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
          buffer.put(0, 4);
        }
        while (buffer.getLengthInBits() % 8 !== 0) {
          buffer.putBit(0);
        }
        const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
        for (let i2 = 0; i2 < remainingByte; i2++) {
          buffer.put(i2 % 2 ? 17 : 236, 8);
        }
        return createCodewords(buffer, version17, errorCorrectionLevel);
      }
      function createCodewords(bitBuffer, version17, errorCorrectionLevel) {
        const totalCodewords = Utils.getSymbolTotalCodewords(version17);
        const ecTotalCodewords = ECCode.getTotalCodewordsCount(version17, errorCorrectionLevel);
        const dataTotalCodewords = totalCodewords - ecTotalCodewords;
        const ecTotalBlocks = ECCode.getBlocksCount(version17, errorCorrectionLevel);
        const blocksInGroup2 = totalCodewords % ecTotalBlocks;
        const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
        const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
        const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
        const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
        const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
        const rs = new ReedSolomonEncoder(ecCount);
        let offset = 0;
        const dcData = new Array(ecTotalBlocks);
        const ecData = new Array(ecTotalBlocks);
        let maxDataSize = 0;
        const buffer = new Uint8Array(bitBuffer.buffer);
        for (let b = 0; b < ecTotalBlocks; b++) {
          const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
          dcData[b] = buffer.slice(offset, offset + dataSize);
          ecData[b] = rs.encode(dcData[b]);
          offset += dataSize;
          maxDataSize = Math.max(maxDataSize, dataSize);
        }
        const data = new Uint8Array(totalCodewords);
        let index2 = 0;
        let i2, r2;
        for (i2 = 0; i2 < maxDataSize; i2++) {
          for (r2 = 0; r2 < ecTotalBlocks; r2++) {
            if (i2 < dcData[r2].length) {
              data[index2++] = dcData[r2][i2];
            }
          }
        }
        for (i2 = 0; i2 < ecCount; i2++) {
          for (r2 = 0; r2 < ecTotalBlocks; r2++) {
            data[index2++] = ecData[r2][i2];
          }
        }
        return data;
      }
      function createSymbol(data, version17, errorCorrectionLevel, maskPattern) {
        let segments;
        if (Array.isArray(data)) {
          segments = Segments.fromArray(data);
        } else if (typeof data === "string") {
          let estimatedVersion = version17;
          if (!estimatedVersion) {
            const rawSegments = Segments.rawSplit(data);
            estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
          }
          segments = Segments.fromString(data, estimatedVersion || 40);
        } else {
          throw new Error("Invalid data");
        }
        const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);
        if (!bestVersion) {
          throw new Error("The amount of data is too big to be stored in a QR Code");
        }
        if (!version17) {
          version17 = bestVersion;
        } else if (version17 < bestVersion) {
          throw new Error(
            "\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n"
          );
        }
        const dataBits = createData(version17, errorCorrectionLevel, segments);
        const moduleCount = Utils.getSymbolSize(version17);
        const modules = new BitMatrix(moduleCount);
        setupFinderPattern(modules, version17);
        setupTimingPattern(modules);
        setupAlignmentPattern(modules, version17);
        setupFormatInfo(modules, errorCorrectionLevel, 0);
        if (version17 >= 7) {
          setupVersionInfo(modules, version17);
        }
        setupData(modules, dataBits);
        if (isNaN(maskPattern)) {
          maskPattern = MaskPattern.getBestMask(
            modules,
            setupFormatInfo.bind(null, modules, errorCorrectionLevel)
          );
        }
        MaskPattern.applyMask(maskPattern, modules);
        setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
        return {
          modules,
          version: version17,
          errorCorrectionLevel,
          maskPattern,
          segments
        };
      }
      exports2.create = function create2(data, options) {
        if (typeof data === "undefined" || data === "") {
          throw new Error("No input text");
        }
        let errorCorrectionLevel = ECLevel.M;
        let version17;
        let mask2;
        if (typeof options !== "undefined") {
          errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
          version17 = Version.from(options.version);
          mask2 = MaskPattern.from(options.maskPattern);
          if (options.toSJISFunc) {
            Utils.setToSJISFunction(options.toSJISFunc);
          }
        }
        return createSymbol(data, version17, errorCorrectionLevel, mask2);
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/renderer/utils.js
  var require_utils4 = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/renderer/utils.js"(exports2) {
      function hex2rgba(hex) {
        if (typeof hex === "number") {
          hex = hex.toString();
        }
        if (typeof hex !== "string") {
          throw new Error("Color should be defined as hex string");
        }
        let hexCode = hex.slice().replace("#", "").split("");
        if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
          throw new Error("Invalid hex color: " + hex);
        }
        if (hexCode.length === 3 || hexCode.length === 4) {
          hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
            return [c, c];
          }));
        }
        if (hexCode.length === 6) hexCode.push("F", "F");
        const hexValue = parseInt(hexCode.join(""), 16);
        return {
          r: hexValue >> 24 & 255,
          g: hexValue >> 16 & 255,
          b: hexValue >> 8 & 255,
          a: hexValue & 255,
          hex: "#" + hexCode.slice(0, 6).join("")
        };
      }
      exports2.getOptions = function getOptions(options) {
        if (!options) options = {};
        if (!options.color) options.color = {};
        const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
        const width = options.width && options.width >= 21 ? options.width : void 0;
        const scale = options.scale || 4;
        return {
          width,
          scale: width ? 4 : scale,
          margin,
          color: {
            dark: hex2rgba(options.color.dark || "#000000ff"),
            light: hex2rgba(options.color.light || "#ffffffff")
          },
          type: options.type,
          rendererOpts: options.rendererOpts || {}
        };
      };
      exports2.getScale = function getScale(qrSize, opts) {
        return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
      };
      exports2.getImageWidth = function getImageWidth(qrSize, opts) {
        const scale = exports2.getScale(qrSize, opts);
        return Math.floor((qrSize + opts.margin * 2) * scale);
      };
      exports2.qrToImageData = function qrToImageData(imgData, qr, opts) {
        const size = qr.modules.size;
        const data = qr.modules.data;
        const scale = exports2.getScale(size, opts);
        const symbolSize = Math.floor((size + opts.margin * 2) * scale);
        const scaledMargin = opts.margin * scale;
        const palette = [opts.color.light, opts.color.dark];
        for (let i2 = 0; i2 < symbolSize; i2++) {
          for (let j = 0; j < symbolSize; j++) {
            let posDst = (i2 * symbolSize + j) * 4;
            let pxColor = opts.color.light;
            if (i2 >= scaledMargin && j >= scaledMargin && i2 < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
              const iSrc = Math.floor((i2 - scaledMargin) / scale);
              const jSrc = Math.floor((j - scaledMargin) / scale);
              pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
            }
            imgData[posDst++] = pxColor.r;
            imgData[posDst++] = pxColor.g;
            imgData[posDst++] = pxColor.b;
            imgData[posDst] = pxColor.a;
          }
        }
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/renderer/canvas.js
  var require_canvas = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/renderer/canvas.js"(exports2) {
      var Utils = require_utils4();
      function clearCanvas(ctx, canvas, size) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (!canvas.style) canvas.style = {};
        canvas.height = size;
        canvas.width = size;
        canvas.style.height = size + "px";
        canvas.style.width = size + "px";
      }
      function getCanvasElement() {
        try {
          return document.createElement("canvas");
        } catch (e2) {
          throw new Error("You need to specify a canvas element");
        }
      }
      exports2.render = function render(qrData, canvas, options) {
        let opts = options;
        let canvasEl = canvas;
        if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
          opts = canvas;
          canvas = void 0;
        }
        if (!canvas) {
          canvasEl = getCanvasElement();
        }
        opts = Utils.getOptions(opts);
        const size = Utils.getImageWidth(qrData.modules.size, opts);
        const ctx = canvasEl.getContext("2d");
        const image = ctx.createImageData(size, size);
        Utils.qrToImageData(image.data, qrData, opts);
        clearCanvas(ctx, canvasEl, size);
        ctx.putImageData(image, 0, 0);
        return canvasEl;
      };
      exports2.renderToDataURL = function renderToDataURL(qrData, canvas, options) {
        let opts = options;
        if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
          opts = canvas;
          canvas = void 0;
        }
        if (!opts) opts = {};
        const canvasEl = exports2.render(qrData, canvas, opts);
        const type = opts.type || "image/png";
        const rendererOpts = opts.rendererOpts || {};
        return canvasEl.toDataURL(type, rendererOpts.quality);
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/renderer/svg-tag.js
  var require_svg_tag = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/renderer/svg-tag.js"(exports2) {
      var Utils = require_utils4();
      function getColorAttrib(color, attrib) {
        const alpha = color.a / 255;
        const str = attrib + '="' + color.hex + '"';
        return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
      }
      function svgCmd(cmd, x, y) {
        let str = cmd + x;
        if (typeof y !== "undefined") str += " " + y;
        return str;
      }
      function qrToPath(data, size, margin) {
        let path3 = "";
        let moveBy = 0;
        let newRow = false;
        let lineLength = 0;
        for (let i2 = 0; i2 < data.length; i2++) {
          const col = Math.floor(i2 % size);
          const row = Math.floor(i2 / size);
          if (!col && !newRow) newRow = true;
          if (data[i2]) {
            lineLength++;
            if (!(i2 > 0 && col > 0 && data[i2 - 1])) {
              path3 += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
              moveBy = 0;
              newRow = false;
            }
            if (!(col + 1 < size && data[i2 + 1])) {
              path3 += svgCmd("h", lineLength);
              lineLength = 0;
            }
          } else {
            moveBy++;
          }
        }
        return path3;
      }
      exports2.render = function render(qrData, options, cb) {
        const opts = Utils.getOptions(options);
        const size = qrData.modules.size;
        const data = qrData.modules.data;
        const qrcodesize = size + opts.margin * 2;
        const bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
        const path3 = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
        const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
        const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
        const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path3 + "</svg>\n";
        if (typeof cb === "function") {
          cb(null, svgTag);
        }
        return svgTag;
      };
    }
  });

  // ../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/browser.js
  var require_browser4 = __commonJS({
    "../../node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode/lib/browser.js"(exports2) {
      var canPromise = require_can_promise();
      var QRCode = require_qrcode();
      var CanvasRenderer = require_canvas();
      var SvgRenderer = require_svg_tag();
      function renderCanvas(renderFunc, canvas, text, opts, cb) {
        const args = [].slice.call(arguments, 1);
        const argsNum = args.length;
        const isLastArgCb = typeof args[argsNum - 1] === "function";
        if (!isLastArgCb && !canPromise()) {
          throw new Error("Callback required as last argument");
        }
        if (isLastArgCb) {
          if (argsNum < 2) {
            throw new Error("Too few arguments provided");
          }
          if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = void 0;
          } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
              cb = opts;
              opts = void 0;
            } else {
              cb = opts;
              opts = text;
              text = canvas;
              canvas = void 0;
            }
          }
        } else {
          if (argsNum < 1) {
            throw new Error("Too few arguments provided");
          }
          if (argsNum === 1) {
            text = canvas;
            canvas = opts = void 0;
          } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = void 0;
          }
          return new Promise(function(resolve2, reject) {
            try {
              const data = QRCode.create(text, opts);
              resolve2(renderFunc(data, canvas, opts));
            } catch (e2) {
              reject(e2);
            }
          });
        }
        try {
          const data = QRCode.create(text, opts);
          cb(null, renderFunc(data, canvas, opts));
        } catch (e2) {
          cb(e2);
        }
      }
      exports2.create = QRCode.create;
      exports2.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
      exports2.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
      exports2.toString = renderCanvas.bind(null, function(data, _2, opts) {
        return SvgRenderer.render(data, opts);
      });
    }
  });

  // ../core/package.json
  var package_default = {
    name: "@slangroom/core",
    version: "1.49.3",
    dependencies: {
      "@slangroom/deps": "workspace:*",
      "@slangroom/ignored": "workspace:*",
      "@slangroom/shared": "workspace:*",
      "fastest-levenshtein": "1.0.16"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../../node_modules/.pnpm/chevrotain@10.5.0/node_modules/chevrotain/lib_esm/api_esm.mjs
  var import_api = __toESM(require_api4(), 1);
  var Alternation = import_api.default.Alternation;
  var Alternative = import_api.default.Alternative;
  var CstParser = import_api.default.CstParser;
  var EMPTY_ALT = import_api.default.EMPTY_ALT;
  var EOF = import_api.default.EOF;
  var EarlyExitException = import_api.default.EarlyExitException;
  var EmbeddedActionsParser = import_api.default.EmbeddedActionsParser;
  var GAstVisitor = import_api.default.GAstVisitor;
  var LLkLookaheadStrategy = import_api.default.LLkLookaheadStrategy;
  var Lexer = import_api.default.Lexer;
  var LexerDefinitionErrorType = import_api.default.LexerDefinitionErrorType;
  var MismatchedTokenException = import_api.default.MismatchedTokenException;
  var NoViableAltException = import_api.default.NoViableAltException;
  var NonTerminal = import_api.default.NonTerminal;
  var NotAllInputParsedException = import_api.default.NotAllInputParsedException;
  var Option = import_api.default.Option;
  var Parser = import_api.default.Parser;
  var ParserDefinitionErrorType = import_api.default.ParserDefinitionErrorType;
  var Repetition = import_api.default.Repetition;
  var RepetitionMandatory = import_api.default.RepetitionMandatory;
  var RepetitionMandatoryWithSeparator = import_api.default.RepetitionMandatoryWithSeparator;
  var RepetitionWithSeparator = import_api.default.RepetitionWithSeparator;
  var Rule = import_api.default.Rule;
  var Terminal = import_api.default.Terminal;
  var VERSION = import_api.default.VERSION;
  var clearCache = import_api.default.clearCache;
  var createSyntaxDiagramsCode = import_api.default.createSyntaxDiagramsCode;
  var createToken = import_api.default.createToken;
  var createTokenInstance = import_api.default.createTokenInstance;
  var defaultLexerErrorProvider = import_api.default.defaultLexerErrorProvider;
  var defaultParserErrorProvider = import_api.default.defaultParserErrorProvider;
  var generateCstDts = import_api.default.generateCstDts;
  var getLookaheadPaths = import_api.default.getLookaheadPaths;
  var isRecognitionException = import_api.default.isRecognitionException;
  var serializeGrammar = import_api.default.serializeGrammar;
  var serializeProduction = import_api.default.serializeProduction;
  var tokenLabel = import_api.default.tokenLabel;
  var tokenMatcher = import_api.default.tokenMatcher;
  var tokenName = import_api.default.tokenName;

  // ../shared/build/esm/src/tokens.js
  var Whitespace = createToken({
    name: "Whitespace",
    pattern: /\s+/,
    group: Lexer.SKIPPED
  });
  var Comment = createToken({
    name: "Comment",
    pattern: /#[^\n\r]*/,
    group: "comments"
  });

  // ../../node_modules/.pnpm/zenroom@5.25.1/node_modules/zenroom/package.json
  var package_default2 = {
    name: "zenroom",
    version: "5.25.1",
    description: "wrapper of Zenroom, a secure and small virtual machine for crypto language processing",
    main: "dist/main/index.js",
    typings: "dist/main/index.d.ts",
    module: "dist/module/index.js",
    repository: "https://github.com/dyne/zenroom.git",
    homepage: "https://dev.zenroom.org/#/pages/javascript",
    author: "Puria Nafisi Azizi <puria@dyne.org>",
    license: "AGPL-3.0-only",
    keywords: [
      "zenroom",
      "crypto-language-processing",
      "virtual-machine",
      "blockchain",
      "crypto",
      "ecc",
      "dyne",
      "ecdh",
      "ecdsa",
      "zero-knowledge-proofs",
      "javascript",
      "npm",
      "ecp2",
      "miller-loop",
      "hamming-distance",
      "elgamal",
      "aes-gcm",
      "aead",
      "seccomp",
      "goldilocks"
    ],
    scripts: {
      lint: "npx standard",
      build: "run-s build:*",
      "build:zenroom": "cd ../.. && make -f build/wasm.mk",
      "build:clean": "rimraf dist/*",
      "build:copylibs": "mkdirp dist/web && mkdirp dist/main && mkdirp dist/module && cp -v ../../zenroom.web.js dist/web/zenroom.js && cp -v ../../zenroom.js dist/module/ && cp -v ../../zenroom.js dist/main/",
      "build:copylibssrc": "cp -v ../../zenroom.js src/",
      "build:typescript": "tsc -p tsconfig.json",
      "build:module": "tsc -p tsconfig.module.json",
      "build:web": "tsc -p tsconfig.web.json",
      "coverage:old": "nyc report --reporter=text-lcov > coverage.lcov && codecov",
      test: "nyc ava",
      bench: "node dist/main/bench.js",
      doc: "documentation serve src/wrapper.js --shallow",
      "doc:api": "documentation readme src/wrapper.js -s '\u2699\uFE0F API' --shallow --markdown-toc false",
      release: "release-it --no-git.requireCleanWorkingDir",
      "release:pre": "DEBUG=release-it:* release-it --no-git --preRelease -i pre --publish --ci --npm.skipChecks --disable-metrics",
      "watch:build": "tsc -p tsconfig.json -w",
      "watch:test": "nyc --silent ava --watch",
      watch: "run-p watch:*"
    },
    files: [
      "dist/main",
      "dist/web",
      "dist/module",
      "!**/*.spec.*",
      "!**/*.json",
      "CHANGELOG.md",
      "LICENSE",
      "README.md"
    ],
    devDependencies: {
      "@ava/typescript": "^6.0.0",
      "@istanbuljs/nyc-config-typescript": "^1.0.2",
      "@types/node": "^22.5.4",
      ava: "^6.1.3",
      codecov: "^3.8.3",
      "cross-env": "^7.0.2",
      documentation: "^14.0.3",
      eslint: "^9.10.0",
      "eslint-config-airbnb-base": "^15.0.0",
      "eslint-plugin-import": "^2.25.4",
      mkdirp: "^3.0.1",
      nanobench: "^3.0.0",
      "npm-run-all": "^4.1.5",
      nyc: "^17.0.0",
      "release-it": "^17.6.0",
      rimraf: "^6.0.1",
      standard: "^17.1.0",
      "ts-node": "^10.7.0",
      typescript: "^5.6.2"
    },
    standard: {
      ignore: [
        "dist",
        "zenroom",
        "test"
      ]
    },
    ava: {
      failFast: true,
      timeout: "60s",
      typescript: {
        rewritePaths: {
          "src/": "dist/main/"
        },
        compile: false
      },
      files: [
        "!dist/module/**",
        "!dist/web/**"
      ]
    },
    nyc: {
      extends: "@istanbuljs/nyc-config-typescript",
      exclude: [
        "**/*.spec.js",
        "**/zenroom.js"
      ]
    },
    engines: {
      node: ">=22"
    }
  };

  // ../../node_modules/.pnpm/zenroom@5.25.1/node_modules/zenroom/dist/module/index.js
  var import_zenroom = __toESM(require_zenroom());
  var cache = {
    module: null
  };
  var getModule = async () => {
    if (cache.module === null) {
      cache.module = await (0, import_zenroom.default)();
    }
    return cache.module;
  };
  var zencode_exec = async (zencode2, props) => {
    const Module = await getModule();
    return new Promise((resolve2, reject) => {
      let result = "";
      let logs = "";
      const _exec = Module.cwrap("zencode_exec", "number", [
        "string",
        "string",
        "string",
        "string",
        "string",
        "string"
      ]);
      Module.print = (t2) => result += t2;
      Module.printErr = (t2) => logs += t2;
      Module.exec_ok = () => {
        resolve2({ result, logs });
      };
      Module.exec_error = () => {
        reject({ result, logs });
      };
      Module.onAbort = () => {
        reject({ result, logs });
      };
      const { data = null, keys = null, extra = null, context = null, conf = null } = { ...props };
      _exec(zencode2, conf, keys, data, extra, context);
    });
  };
  var zencode_valid_code = async (zencode2, conf = null, strict = 1) => {
    const Module = await getModule();
    return new Promise((resolve2, reject) => {
      let result = "";
      let logs = "";
      const _exec = Module.cwrap("zencode_valid_code", "number", [
        "string",
        "string",
        "number"
      ]);
      Module.print = (t2) => result += t2;
      Module.printErr = (t2) => logs += t2;
      Module.exec_ok = () => {
        resolve2({ result, logs });
      };
      Module.exec_error = () => {
        reject({ result, logs });
      };
      Module.onAbort = () => {
        reject({ result, logs });
      };
      _exec(zencode2, conf, strict);
    });
  };
  var safe_zencode_valid_code = async (zencode2, conf = null) => {
    return zencode_valid_code(zencode2, conf, 0);
  };

  // ../deps/build/esm/src/zenroom.js
  var zenroomVersion = package_default2.version;

  // ../shared/build/esm/src/zenroom.js
  var ZenError = class extends Error {
    constructor(logs) {
      super(logs);
      this.name = "ZenroomError";
    }
  };
  var stringify = (params) => {
    return {
      data: JSON.stringify(params.data),
      keys: JSON.stringify(params.keys),
      extra: JSON.stringify(params.extra || {}),
      conf: params.conf || ""
    };
  };
  var zencodeExec = async (contract, params) => {
    let tmp;
    try {
      tmp = await zencode_exec(contract, stringify(params));
    } catch (e2) {
      throw new ZenError(e2.logs);
    }
    return {
      result: JSON.parse(tmp.result),
      logs: tmp.logs
    };
  };
  var zencodeParse = async (contract) => {
    let tmp;
    try {
      tmp = await safe_zencode_valid_code(contract);
    } catch (e2) {
      throw new ZenError(e2.logs);
    }
    return {
      result: JSON.parse(tmp.result),
      logs: tmp.logs
    };
  };

  // ../../node_modules/.pnpm/chalk@5.6.0/node_modules/chalk/source/vendor/ansi-styles/index.js
  var ANSI_BACKGROUND_OFFSET = 10;
  var wrapAnsi16 = (offset = 0) => (code) => `\x1B[${code + offset}m`;
  var wrapAnsi256 = (offset = 0) => (code) => `\x1B[${38 + offset};5;${code}m`;
  var wrapAnsi16m = (offset = 0) => (red, green, blue) => `\x1B[${38 + offset};2;${red};${green};${blue}m`;
  var styles = {
    modifier: {
      reset: [0, 0],
      // 21 isn't widely supported and 22 does the same thing
      bold: [1, 22],
      dim: [2, 22],
      italic: [3, 23],
      underline: [4, 24],
      overline: [53, 55],
      inverse: [7, 27],
      hidden: [8, 28],
      strikethrough: [9, 29]
    },
    color: {
      black: [30, 39],
      red: [31, 39],
      green: [32, 39],
      yellow: [33, 39],
      blue: [34, 39],
      magenta: [35, 39],
      cyan: [36, 39],
      white: [37, 39],
      // Bright color
      blackBright: [90, 39],
      gray: [90, 39],
      // Alias of `blackBright`
      grey: [90, 39],
      // Alias of `blackBright`
      redBright: [91, 39],
      greenBright: [92, 39],
      yellowBright: [93, 39],
      blueBright: [94, 39],
      magentaBright: [95, 39],
      cyanBright: [96, 39],
      whiteBright: [97, 39]
    },
    bgColor: {
      bgBlack: [40, 49],
      bgRed: [41, 49],
      bgGreen: [42, 49],
      bgYellow: [43, 49],
      bgBlue: [44, 49],
      bgMagenta: [45, 49],
      bgCyan: [46, 49],
      bgWhite: [47, 49],
      // Bright color
      bgBlackBright: [100, 49],
      bgGray: [100, 49],
      // Alias of `bgBlackBright`
      bgGrey: [100, 49],
      // Alias of `bgBlackBright`
      bgRedBright: [101, 49],
      bgGreenBright: [102, 49],
      bgYellowBright: [103, 49],
      bgBlueBright: [104, 49],
      bgMagentaBright: [105, 49],
      bgCyanBright: [106, 49],
      bgWhiteBright: [107, 49]
    }
  };
  var modifierNames = Object.keys(styles.modifier);
  var foregroundColorNames = Object.keys(styles.color);
  var backgroundColorNames = Object.keys(styles.bgColor);
  var colorNames = [...foregroundColorNames, ...backgroundColorNames];
  function assembleStyles() {
    const codes = /* @__PURE__ */ new Map();
    for (const [groupName, group] of Object.entries(styles)) {
      for (const [styleName, style] of Object.entries(group)) {
        styles[styleName] = {
          open: `\x1B[${style[0]}m`,
          close: `\x1B[${style[1]}m`
        };
        group[styleName] = styles[styleName];
        codes.set(style[0], style[1]);
      }
      Object.defineProperty(styles, groupName, {
        value: group,
        enumerable: false
      });
    }
    Object.defineProperty(styles, "codes", {
      value: codes,
      enumerable: false
    });
    styles.color.close = "\x1B[39m";
    styles.bgColor.close = "\x1B[49m";
    styles.color.ansi = wrapAnsi16();
    styles.color.ansi256 = wrapAnsi256();
    styles.color.ansi16m = wrapAnsi16m();
    styles.bgColor.ansi = wrapAnsi16(ANSI_BACKGROUND_OFFSET);
    styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
    styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);
    Object.defineProperties(styles, {
      rgbToAnsi256: {
        value(red, green, blue) {
          if (red === green && green === blue) {
            if (red < 8) {
              return 16;
            }
            if (red > 248) {
              return 231;
            }
            return Math.round((red - 8) / 247 * 24) + 232;
          }
          return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
        },
        enumerable: false
      },
      hexToRgb: {
        value(hex) {
          const matches = /[a-f\d]{6}|[a-f\d]{3}/i.exec(hex.toString(16));
          if (!matches) {
            return [0, 0, 0];
          }
          let [colorString] = matches;
          if (colorString.length === 3) {
            colorString = [...colorString].map((character) => character + character).join("");
          }
          const integer = Number.parseInt(colorString, 16);
          return [
            /* eslint-disable no-bitwise */
            integer >> 16 & 255,
            integer >> 8 & 255,
            integer & 255
            /* eslint-enable no-bitwise */
          ];
        },
        enumerable: false
      },
      hexToAnsi256: {
        value: (hex) => styles.rgbToAnsi256(...styles.hexToRgb(hex)),
        enumerable: false
      },
      ansi256ToAnsi: {
        value(code) {
          if (code < 8) {
            return 30 + code;
          }
          if (code < 16) {
            return 90 + (code - 8);
          }
          let red;
          let green;
          let blue;
          if (code >= 232) {
            red = ((code - 232) * 10 + 8) / 255;
            green = red;
            blue = red;
          } else {
            code -= 16;
            const remainder = code % 36;
            red = Math.floor(code / 36) / 5;
            green = Math.floor(remainder / 6) / 5;
            blue = remainder % 6 / 5;
          }
          const value = Math.max(red, green, blue) * 2;
          if (value === 0) {
            return 30;
          }
          let result = 30 + (Math.round(blue) << 2 | Math.round(green) << 1 | Math.round(red));
          if (value === 2) {
            result += 60;
          }
          return result;
        },
        enumerable: false
      },
      rgbToAnsi: {
        value: (red, green, blue) => styles.ansi256ToAnsi(styles.rgbToAnsi256(red, green, blue)),
        enumerable: false
      },
      hexToAnsi: {
        value: (hex) => styles.ansi256ToAnsi(styles.hexToAnsi256(hex)),
        enumerable: false
      }
    });
    return styles;
  }
  var ansiStyles = assembleStyles();
  var ansi_styles_default = ansiStyles;

  // ../../node_modules/.pnpm/chalk@5.6.0/node_modules/chalk/source/vendor/supports-color/browser.js
  var level = (() => {
    if (!("navigator" in globalThis)) {
      return 0;
    }
    if (globalThis.navigator.userAgentData) {
      const brand = navigator.userAgentData.brands.find(({ brand: brand2 }) => brand2 === "Chromium");
      if (brand && brand.version > 93) {
        return 3;
      }
    }
    if (/\b(Chrome|Chromium)\//.test(globalThis.navigator.userAgent)) {
      return 1;
    }
    return 0;
  })();
  var colorSupport = level !== 0 && {
    level,
    hasBasic: true,
    has256: level >= 2,
    has16m: level >= 3
  };
  var supportsColor = {
    stdout: colorSupport,
    stderr: colorSupport
  };
  var browser_default = supportsColor;

  // ../../node_modules/.pnpm/chalk@5.6.0/node_modules/chalk/source/utilities.js
  function stringReplaceAll(string, substring, replacer) {
    let index2 = string.indexOf(substring);
    if (index2 === -1) {
      return string;
    }
    const substringLength = substring.length;
    let endIndex = 0;
    let returnValue = "";
    do {
      returnValue += string.slice(endIndex, index2) + substring + replacer;
      endIndex = index2 + substringLength;
      index2 = string.indexOf(substring, endIndex);
    } while (index2 !== -1);
    returnValue += string.slice(endIndex);
    return returnValue;
  }
  function stringEncaseCRLFWithFirstIndex(string, prefix, postfix, index2) {
    let endIndex = 0;
    let returnValue = "";
    do {
      const gotCR = string[index2 - 1] === "\r";
      returnValue += string.slice(endIndex, gotCR ? index2 - 1 : index2) + prefix + (gotCR ? "\r\n" : "\n") + postfix;
      endIndex = index2 + 1;
      index2 = string.indexOf("\n", endIndex);
    } while (index2 !== -1);
    returnValue += string.slice(endIndex);
    return returnValue;
  }

  // ../../node_modules/.pnpm/chalk@5.6.0/node_modules/chalk/source/index.js
  var { stdout: stdoutColor, stderr: stderrColor } = browser_default;
  var GENERATOR = Symbol("GENERATOR");
  var STYLER = Symbol("STYLER");
  var IS_EMPTY = Symbol("IS_EMPTY");
  var levelMapping = [
    "ansi",
    "ansi",
    "ansi256",
    "ansi16m"
  ];
  var styles2 = /* @__PURE__ */ Object.create(null);
  var applyOptions = (object, options = {}) => {
    if (options.level && !(Number.isInteger(options.level) && options.level >= 0 && options.level <= 3)) {
      throw new Error("The `level` option should be an integer from 0 to 3");
    }
    const colorLevel = stdoutColor ? stdoutColor.level : 0;
    object.level = options.level === void 0 ? colorLevel : options.level;
  };
  var chalkFactory = (options) => {
    const chalk2 = (...strings) => strings.join(" ");
    applyOptions(chalk2, options);
    Object.setPrototypeOf(chalk2, createChalk.prototype);
    return chalk2;
  };
  function createChalk(options) {
    return chalkFactory(options);
  }
  Object.setPrototypeOf(createChalk.prototype, Function.prototype);
  for (const [styleName, style] of Object.entries(ansi_styles_default)) {
    styles2[styleName] = {
      get() {
        const builder = createBuilder(this, createStyler(style.open, style.close, this[STYLER]), this[IS_EMPTY]);
        Object.defineProperty(this, styleName, { value: builder });
        return builder;
      }
    };
  }
  styles2.visible = {
    get() {
      const builder = createBuilder(this, this[STYLER], true);
      Object.defineProperty(this, "visible", { value: builder });
      return builder;
    }
  };
  var getModelAnsi = (model, level2, type, ...arguments_) => {
    if (model === "rgb") {
      if (level2 === "ansi16m") {
        return ansi_styles_default[type].ansi16m(...arguments_);
      }
      if (level2 === "ansi256") {
        return ansi_styles_default[type].ansi256(ansi_styles_default.rgbToAnsi256(...arguments_));
      }
      return ansi_styles_default[type].ansi(ansi_styles_default.rgbToAnsi(...arguments_));
    }
    if (model === "hex") {
      return getModelAnsi("rgb", level2, type, ...ansi_styles_default.hexToRgb(...arguments_));
    }
    return ansi_styles_default[type][model](...arguments_);
  };
  var usedModels = ["rgb", "hex", "ansi256"];
  for (const model of usedModels) {
    styles2[model] = {
      get() {
        const { level: level2 } = this;
        return function(...arguments_) {
          const styler = createStyler(getModelAnsi(model, levelMapping[level2], "color", ...arguments_), ansi_styles_default.color.close, this[STYLER]);
          return createBuilder(this, styler, this[IS_EMPTY]);
        };
      }
    };
    const bgModel = "bg" + model[0].toUpperCase() + model.slice(1);
    styles2[bgModel] = {
      get() {
        const { level: level2 } = this;
        return function(...arguments_) {
          const styler = createStyler(getModelAnsi(model, levelMapping[level2], "bgColor", ...arguments_), ansi_styles_default.bgColor.close, this[STYLER]);
          return createBuilder(this, styler, this[IS_EMPTY]);
        };
      }
    };
  }
  var proto = Object.defineProperties(() => {
  }, {
    ...styles2,
    level: {
      enumerable: true,
      get() {
        return this[GENERATOR].level;
      },
      set(level2) {
        this[GENERATOR].level = level2;
      }
    }
  });
  var createStyler = (open3, close2, parent) => {
    let openAll;
    let closeAll;
    if (parent === void 0) {
      openAll = open3;
      closeAll = close2;
    } else {
      openAll = parent.openAll + open3;
      closeAll = close2 + parent.closeAll;
    }
    return {
      open: open3,
      close: close2,
      openAll,
      closeAll,
      parent
    };
  };
  var createBuilder = (self2, _styler, _isEmpty) => {
    const builder = (...arguments_) => applyStyle(builder, arguments_.length === 1 ? "" + arguments_[0] : arguments_.join(" "));
    Object.setPrototypeOf(builder, proto);
    builder[GENERATOR] = self2;
    builder[STYLER] = _styler;
    builder[IS_EMPTY] = _isEmpty;
    return builder;
  };
  var applyStyle = (self2, string) => {
    if (self2.level <= 0 || !string) {
      return self2[IS_EMPTY] ? "" : string;
    }
    let styler = self2[STYLER];
    if (styler === void 0) {
      return string;
    }
    const { openAll, closeAll } = styler;
    if (string.includes("\x1B")) {
      while (styler !== void 0) {
        string = stringReplaceAll(string, styler.close, styler.open);
        styler = styler.parent;
      }
    }
    const lfIndex = string.indexOf("\n");
    if (lfIndex !== -1) {
      string = stringEncaseCRLFWithFirstIndex(string, closeAll, openAll, lfIndex);
    }
    return openAll + string + closeAll;
  };
  Object.defineProperties(createChalk.prototype, styles2);
  var chalk = createChalk();
  var chalkStderr = createChalk({ level: stderrColor ? stderrColor.level : 0 });
  var source_default = chalk;

  // ../shared/build/esm/src/colors.js
  var sentenceHighlight = source_default.bgRed;
  var textHighlight = source_default.bold;
  var errorColor = source_default.red;
  var suggestedColor = source_default.green;
  var missingColor = source_default.cyan;
  var extraColor = source_default.magenta;
  var lineNoColor = source_default.yellow;

  // ../core/build/esm/src/lexer.js
  var Token = class {
    /**
     * The raw string of a token, such as `Asche`.
     */
    raw;
    /**
     * The line number of the token.
     */
    lineNo;
    /**
     * The lowercased version of {@link raw} string, such as `asche`.
     */
    name;
    /**
     * The start position of the token in the given line, must be non-negative.
     */
    start;
    /**
     * The end position of the token in the given line, must be >= {@link start}.
     */
    end;
    /**
     * Whether this token is an identifier or not.  It is an identifier if the
     * first character of {@link raw} is a single-quote.
     */
    isIdent;
    /**
     * Creates a new instance of {@link Token}.
     *
     * @throws {@link Error}
     * If {@link raw} is empty.
     *
     * @throws {@link Error}
     * If {@link lineNo} is not positive.
     *
     * @throws {@link Error}
     * If {@link start} is negative.
     *
     * @throws {@link Error}
     * If {@link end} is less than {@link start}.
     */
    constructor(raw, lineNo, start, end) {
      if (!raw)
        throw new Error("raw cannot be empty string");
      if (lineNo <= 0)
        throw new Error("lineNo must be positive");
      if (start < 0)
        throw new Error("start cannot be negative");
      if (end < start)
        throw new Error("end cannot be less than start");
      this.raw = raw;
      this.lineNo = lineNo;
      this.start = start;
      this.end = end;
      this.name = this.raw.toLowerCase();
      this.isIdent = this.raw.charAt(0) === "'";
    }
  };
  var LexError = class extends Error {
    constructor(t2) {
      super();
      this.name = "LexError @slangroom/core@" + package_default.version;
      this.message = `at ${t2.lineNo}:${t2.start + 1}-${t2.end + 1}
 unclosed single-quote ${errorColor(t2.raw)}`;
    }
  };
  var lex = (stmt, lineNo) => {
    const tokens = [];
    const c = [...stmt];
    let raw = "";
    let i2 = 0;
    while (i2 < c.length) {
      while (c[i2] === " " || c[i2] === "	")
        ++i2;
      if (c[i2] === "'") {
        const start = i2;
        raw += c[i2++];
        while (i2 < c.length && c[i2] !== "'")
          raw += c[i2++];
        if (i2 >= c.length)
          return { ok: false, error: { message: new LexError(new Token(raw, lineNo, start, c.length - 1)), lineNo, start, end: c.length - 1 } };
        raw += c[i2++];
        tokens.push(new Token(raw, lineNo, start, i2 - 1));
        raw = "";
      } else {
        const start = i2;
        while (i2 < c.length && c[i2] !== " " && c[i2] !== "	" && c[i2] !== "'")
          raw += c[i2++];
        if (raw.length)
          tokens.push(new Token(raw, lineNo, start, i2 - 1));
        raw = "";
      }
    }
    return { ok: true, value: [tokens, lineNo] };
  };

  // ../../node_modules/.pnpm/fastest-levenshtein@1.0.16/node_modules/fastest-levenshtein/esm/mod.js
  var peq = new Uint32Array(65536);
  var myers_32 = (a, b) => {
    const n2 = a.length;
    const m = b.length;
    const lst = 1 << n2 - 1;
    let pv = -1;
    let mv = 0;
    let sc = n2;
    let i2 = n2;
    while (i2--) {
      peq[a.charCodeAt(i2)] |= 1 << i2;
    }
    for (i2 = 0; i2 < m; i2++) {
      let eq = peq[b.charCodeAt(i2)];
      const xv = eq | mv;
      eq |= (eq & pv) + pv ^ pv;
      mv |= ~(eq | pv);
      pv &= eq;
      if (mv & lst) {
        sc++;
      }
      if (pv & lst) {
        sc--;
      }
      mv = mv << 1 | 1;
      pv = pv << 1 | ~(xv | mv);
      mv &= xv;
    }
    i2 = n2;
    while (i2--) {
      peq[a.charCodeAt(i2)] = 0;
    }
    return sc;
  };
  var myers_x = (b, a) => {
    const n2 = a.length;
    const m = b.length;
    const mhc = [];
    const phc = [];
    const hsize = Math.ceil(n2 / 32);
    const vsize = Math.ceil(m / 32);
    for (let i2 = 0; i2 < hsize; i2++) {
      phc[i2] = -1;
      mhc[i2] = 0;
    }
    let j = 0;
    for (; j < vsize - 1; j++) {
      let mv2 = 0;
      let pv2 = -1;
      const start2 = j * 32;
      const vlen2 = Math.min(32, m) + start2;
      for (let k = start2; k < vlen2; k++) {
        peq[b.charCodeAt(k)] |= 1 << k;
      }
      for (let i2 = 0; i2 < n2; i2++) {
        const eq = peq[a.charCodeAt(i2)];
        const pb2 = phc[i2 / 32 | 0] >>> i2 & 1;
        const mb = mhc[i2 / 32 | 0] >>> i2 & 1;
        const xv = eq | mv2;
        const xh = ((eq | mb) & pv2) + pv2 ^ pv2 | eq | mb;
        let ph = mv2 | ~(xh | pv2);
        let mh = pv2 & xh;
        if (ph >>> 31 ^ pb2) {
          phc[i2 / 32 | 0] ^= 1 << i2;
        }
        if (mh >>> 31 ^ mb) {
          mhc[i2 / 32 | 0] ^= 1 << i2;
        }
        ph = ph << 1 | pb2;
        mh = mh << 1 | mb;
        pv2 = mh | ~(xv | ph);
        mv2 = ph & xv;
      }
      for (let k = start2; k < vlen2; k++) {
        peq[b.charCodeAt(k)] = 0;
      }
    }
    let mv = 0;
    let pv = -1;
    const start = j * 32;
    const vlen = Math.min(32, m - start) + start;
    for (let k = start; k < vlen; k++) {
      peq[b.charCodeAt(k)] |= 1 << k;
    }
    let score = m;
    for (let i2 = 0; i2 < n2; i2++) {
      const eq = peq[a.charCodeAt(i2)];
      const pb2 = phc[i2 / 32 | 0] >>> i2 & 1;
      const mb = mhc[i2 / 32 | 0] >>> i2 & 1;
      const xv = eq | mv;
      const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
      let ph = mv | ~(xh | pv);
      let mh = pv & xh;
      score += ph >>> m - 1 & 1;
      score -= mh >>> m - 1 & 1;
      if (ph >>> 31 ^ pb2) {
        phc[i2 / 32 | 0] ^= 1 << i2;
      }
      if (mh >>> 31 ^ mb) {
        mhc[i2 / 32 | 0] ^= 1 << i2;
      }
      ph = ph << 1 | pb2;
      mh = mh << 1 | mb;
      pv = mh | ~(xv | ph);
      mv = ph & xv;
    }
    for (let k = start; k < vlen; k++) {
      peq[b.charCodeAt(k)] = 0;
    }
    return score;
  };
  var distance = (a, b) => {
    if (a.length < b.length) {
      const tmp = b;
      b = a;
      a = tmp;
    }
    if (b.length === 0) {
      return a.length;
    }
    if (a.length <= 32) {
      return myers_32(a, b);
    }
    return myers_x(a, b);
  };
  var closest = (str, arr) => {
    let min_distance = Infinity;
    let min_index = 0;
    for (let i2 = 0; i2 < arr.length; i2++) {
      const dist = distance(str, arr[i2]);
      if (dist < min_distance) {
        min_distance = dist;
        min_index = i2;
      }
    }
    return arr[min_index];
  };

  // ../core/build/esm/src/parser.js
  var TokenType;
  (function(TokenType2) {
    TokenType2["AFTER"] = "after";
    TokenType2["AND"] = "and";
    TokenType2["BEFORE"] = "before";
    TokenType2["COLON"] = ":";
    TokenType2["COMMA"] = ",";
    TokenType2["COMPUTE"] = "compute";
    TokenType2["CONNECT"] = "connect";
    TokenType2["GIVEN"] = "given";
    TokenType2["I"] = "I";
    TokenType2["IDENTIFIER"] = "'<identifier>'";
    TokenType2["INTO"] = "into";
    TokenType2["IS"] = "is";
    TokenType2["OPEN"] = "open";
    TokenType2["OUTPUT"] = "output";
    TokenType2["PREPARE"] = "prepare";
    TokenType2["SECRET"] = "secret";
    TokenType2["SEND"] = "send";
    TokenType2["THEN"] = "then";
    TokenType2["TO"] = "to";
    TokenType2["WHERE"] = "where";
    TokenType2["WITH"] = "with";
  })(TokenType || (TokenType = {}));
  var IdentType;
  (function(IdentType2) {
    IdentType2["BINDINGS"] = "bindings";
    IdentType2["OPEN"] = "open";
    IdentType2["CONNECT"] = "connect";
    IdentType2["INTO"] = "into";
    IdentType2["INTOSECRET"] = "intoSecret";
  })(IdentType || (IdentType = {}));
  var version2 = package_default.version;
  var ParseError = class _ParseError extends Error {
    /**
     * Represents an error case where a wrong type of one or multiple tokens are
     * found.  If a token is not found, use {@link missing}.
     *
     * @example
     * An alternative can be provided with the second parameter:
     * ```ts
     * if (token.name !== "asche")
     * 	throw ParseError.wrong(token, "asche")
     * ```
     *
     * @example
     * Multiple alternatives (e.g. "foo", or "bar", or "baz") can be provided also:
     * ```ts
     * if (token.name !== "given" || token.name !== "then")
     * 	throw ParseError.wrong(token, "given", "then")
     * ```
     */
    static wrong(have, wantFirst, ...wantRest) {
      const wantsColored = [wantFirst, ...wantRest].map((x) => suggestedColor(x)).join(" or ");
      const haveRaw = have.raw;
      return new _ParseError(`at ${have.lineNo}:${have.start + 1}-${have.end + 1}
 ${errorColor(haveRaw)} may be ${wantsColored}`);
    }
    /**
     * Represents an error case where a token is missing.  If a token is found
     * but of a wrong type, use {@link wrong}.
     *
     * @example
     * What is expected can be provided with the second parameter:
     * ```ts
     * if (tokenDoesntExist)
     * 	throw ParseError.missing(1, "asche")
     * ```
     *
     * @example
     * What is expected could be multiple (e.g. "foo", or "bar", or "baz") also:
     * ```ts
     * if (tokenDoesntExist)
     * 	throw ParseError.missing(1, "given", "then")
     * ```
     *
     * @example
     * If the first parameter is a token found previously,
     * it creates diagnostic messages according to that.
     * A line number can be provided instead of a token,
     * which means that there exist no prior token.
     */
    static missing(prevTokenOrLineNo, wantFirst, ...wantRest) {
      const wantsColored = [wantFirst, ...wantRest].map((x) => missingColor(x)).join(", ");
      if (typeof prevTokenOrLineNo == "number") {
        const lineNo = prevTokenOrLineNo;
        return new _ParseError(`at ${lineNo}
 missing one of: ${wantsColored}`);
      }
      const token = prevTokenOrLineNo;
      return new _ParseError(`at ${token.lineNo}:${token.start + 1}-${token.end + 1}
 must be followed by one of: ${wantsColored}`);
    }
    /**
     * Represents an error case where an unexpected extra token is found.
     *
     * @example
     * ```ts
     * if (token)
     *	throw ParseError.extra(token)
     * ```
     */
    static extra(token) {
      return new _ParseError(`at ${token.lineNo}:${token.start + 1}-${token.end + 1}
 extra token ${extraColor(token.raw)}`);
    }
    /**
     * @internal
     */
    constructor(message) {
      super(message);
      this.name = "ParseError @slangroom/core@" + package_default.version;
    }
  };
  var lemmeout = {};
  var ErrorHandler = class {
    m;
    t;
    curErrLen;
    constructor(m, t2, curErrLen) {
      this.m = m;
      this.t = t2;
      this.curErrLen = curErrLen;
    }
    report(i2, expected, ...alternates) {
      const have = this.t[i2];
      let msg;
      if (have) {
        msg = ParseError.wrong(have, expected, ...alternates);
      } else {
        msg = ParseError.missing(i2 > 2 && this.t[i2 - 1] || this.m.lineNo, expected, ...alternates);
      }
      this.m.err.push({
        message: msg,
        lineNo: this.m.lineNo,
        ...have && {
          start: have.start,
          end: have.end
        }
      });
      if (this.curErrLen !== void 0 && this.m.err.length > this.curErrLen)
        throw lemmeout;
    }
    expect(i2, expected, ...alternates) {
      if (this.t[i2]?.name !== expected) {
        this.report(i2, expected, ...alternates);
        return false;
      }
      return true;
    }
    isIdent(i2, dest, tokName) {
      if (!this.t[i2]?.isIdent) {
        this.report(i2, TokenType.IDENTIFIER);
        return;
      }
      const id = this.t[i2].raw.slice(1, -1);
      switch (dest) {
        case IdentType.BINDINGS:
          if (tokName)
            this.m.bindings.set(tokName.name, id);
          break;
        case IdentType.INTO:
          this.m.into = id;
          break;
        case IdentType.INTOSECRET:
          this.m.intoSecret = id;
          break;
        case IdentType.OPEN:
          this.m.open = id;
          break;
        case IdentType.CONNECT:
          this.m.connect = id;
          break;
      }
    }
  };
  var openConnectParser = (m, i2, errorHandler) => {
    const k = m.key;
    if (k.openconnect === TokenType.OPEN) {
      errorHandler.expect(++i2, TokenType.OPEN);
      errorHandler.isIdent(++i2, IdentType.OPEN);
      errorHandler.expect(++i2, TokenType.AND);
    } else if (k.openconnect === TokenType.CONNECT) {
      errorHandler.expect(++i2, TokenType.CONNECT);
      errorHandler.expect(++i2, TokenType.TO);
      errorHandler.isIdent(++i2, IdentType.CONNECT);
      errorHandler.expect(++i2, TokenType.AND);
    }
    return i2;
  };
  var outputParser = (m, t2, i2, errorHandler) => {
    const lineNo = m.lineNo;
    const ident = t2[t2.length - 1];
    if (!m.into && !m.intoSecret && t2.length - i2 >= 5 && ident?.isIdent) {
      for (++i2; i2 < t2.length - 5; ++i2) {
        m.err.push({
          message: ParseError.extra(t2[i2]),
          lineNo,
          start: t2[i2].start,
          end: t2[i2].end
        });
      }
      const baseOutput = [TokenType.AND, TokenType.OUTPUT, TokenType.INTO];
      let assign2 = (val) => m.into = val;
      let length2 = t2.length - i2;
      if (length2 == 5) {
        const isShiftedBaseOutput = baseOutput.every((name2, index2) => {
          return t2[i2 + 1 + index2]?.name == name2;
        });
        if (isShiftedBaseOutput) {
          m.err.push({
            message: ParseError.extra(t2[i2]),
            lineNo,
            start: t2[i2].start,
            end: t2[i2].end
          });
          length2 = 4;
        } else {
          baseOutput.splice(2, 0, TokenType.SECRET);
          assign2 = (val) => m.intoSecret = val;
        }
      }
      let isValid4 = true;
      baseOutput.forEach((name2, index2) => {
        isValid4 = errorHandler.expect(t2.length - length2 + index2, name2) && isValid4;
      });
      if (isValid4)
        assign2(ident.raw.slice(1, -1));
    } else {
      for (++i2; i2 < t2.length; ++i2) {
        m.err.push({
          message: ParseError.extra(t2[i2]),
          lineNo,
          start: t2[i2].start,
          end: t2[i2].end
        });
      }
    }
  };
  var givenThenParser = (m, t2, curErrLen) => {
    const errorHandler = new ErrorHandler(m, t2, curErrLen);
    const k = m.key;
    let i2 = 0;
    if (t2[i2 + 1]?.raw == TokenType.I) {
      ++i2;
    } else {
      if (t2[i2 + 1]?.name == TokenType.CONNECT || t2[i2 + 1]?.name == TokenType.OPEN || t2[i2 + 1]?.name == TokenType.SEND || t2[i2 + 1]?.name == k.phrase.split(" ")[0]) {
        m.err.push({
          message: ParseError.missing(t2[i2], TokenType.I),
          lineNo: m.lineNo
        });
      } else {
        errorHandler.report(++i2, TokenType.I);
      }
    }
    i2 = openConnectParser(m, i2, errorHandler);
    const params = new Set(k.params);
    k.params?.forEach(() => {
      errorHandler.expect(++i2, TokenType.SEND);
      const tokName = t2[++i2];
      if (tokName && params.has(tokName.name)) {
        params.delete(tokName.name);
      } else {
        const [first, ...rest] = [...params.values()];
        errorHandler.report(i2, first, ...rest);
      }
      errorHandler.isIdent(++i2, IdentType.BINDINGS, tokName);
      errorHandler.expect(++i2, TokenType.AND);
    });
    k.phrase.split(" ").forEach((name2) => errorHandler.expect(++i2, name2));
    outputParser(m, t2, i2, errorHandler);
    if (curErrLen !== void 0 && m.err.length > curErrLen)
      throw lemmeout;
    return curErrLen !== void 0 && m.err.length < curErrLen;
  };
  var prepareComputeParser = (m, t2, curErrLen) => {
    const errorHandler = new ErrorHandler(m, t2, curErrLen);
    const k = m.key;
    let i2 = 0;
    const secondToken = t2[i2 + 1];
    if (secondToken?.isIdent) {
      ++i2;
      m.into = secondToken.raw.slice(1, -1);
      errorHandler.expect(++i2, TokenType.COLON);
    } else if (secondToken?.name === TokenType.SECRET) {
      ++i2;
      errorHandler.isIdent(++i2, IdentType.INTOSECRET);
      errorHandler.expect(++i2, TokenType.COLON);
    }
    i2 = openConnectParser(m, i2, errorHandler);
    k.phrase.split(" ").forEach((name2) => errorHandler.expect(++i2, name2));
    const params = new Set(k.params);
    if (k.params) {
      const whereWith = t2[++i2]?.name;
      if (whereWith !== TokenType.WHERE && whereWith !== TokenType.WITH)
        errorHandler.report(i2, TokenType.WITH, TokenType.WHERE);
      k.params.forEach((_2, index2) => {
        const tokName = t2[++i2];
        if (tokName && params.has(tokName.name)) {
          params.delete(tokName.name);
        } else {
          const [first, ...rest] = [...params.values()];
          errorHandler.report(i2, first, ...rest);
        }
        if (whereWith == TokenType.WHERE)
          errorHandler.expect(++i2, TokenType.IS);
        errorHandler.isIdent(++i2, IdentType.BINDINGS, tokName);
        if (index2 + 1 !== k.params?.length)
          errorHandler.expect(++i2, TokenType.COMMA);
      });
    }
    outputParser(m, t2, i2, errorHandler);
    if (curErrLen !== void 0 && m.err.length > curErrLen)
      throw lemmeout;
    return curErrLen !== void 0 && m.err.length < curErrLen;
  };
  var parse3 = (p12, t2, lineNo) => {
    const cst = {
      matches: [],
      errors: []
    };
    if (!t2[0]) {
      cst.errors.push({
        message: ParseError.missing(lineNo, `${TokenType.GIVEN} ${TokenType.I}`, `${TokenType.THEN} ${TokenType.I}`, TokenType.PREPARE, TokenType.BEFORE, TokenType.COMPUTE, TokenType.AFTER),
        lineNo
      });
      return cst;
    }
    let name2 = t2[0].name;
    let isGivenThen = name2 === TokenType.GIVEN || name2 === TokenType.THEN;
    let isPrepareCompute = name2 === TokenType.PREPARE || name2 === TokenType.PREPARE + TokenType.COLON || name2 === TokenType.BEFORE || name2 === TokenType.BEFORE + TokenType.COLON || name2 === TokenType.COMPUTE || name2 === TokenType.COMPUTE + TokenType.COLON || name2 === TokenType.AFTER || name2 === TokenType.AFTER + TokenType.COLON;
    let openConnect;
    if (isGivenThen) {
      cst.givenThen = name2;
      if (t2[2]?.raw === TokenType.OPEN || t2[2]?.raw === TokenType.CONNECT)
        openConnect = t2[2]?.raw;
    } else {
      if (name2.endsWith(TokenType.COLON))
        name2 = name2.slice(0, -1);
      if (isPrepareCompute) {
        cst.givenThen = name2 === TokenType.PREPARE || name2 === TokenType.BEFORE ? TokenType.GIVEN : TokenType.THEN;
        const openOrConnectTokens = [t2[1]?.raw, t2[3]?.raw, t2[4]?.raw];
        if (openOrConnectTokens.includes(TokenType.CONNECT))
          openConnect = TokenType.CONNECT;
        else if (openOrConnectTokens.includes(TokenType.OPEN))
          openConnect = TokenType.OPEN;
      } else {
        const closestMatch = closest(name2, [
          TokenType.GIVEN,
          TokenType.THEN,
          TokenType.PREPARE,
          TokenType.BEFORE,
          TokenType.COMPUTE,
          TokenType.AFTER
        ]);
        if (closestMatch === TokenType.GIVEN || closestMatch === TokenType.THEN) {
          isGivenThen = true;
          cst.errors.push({
            message: ParseError.wrong(t2[0], TokenType.GIVEN, TokenType.THEN),
            lineNo,
            start: t2[0].start,
            end: t2[0].end
          });
        } else {
          isPrepareCompute = true;
          cst.errors.push({
            message: ParseError.wrong(t2[0], TokenType.PREPARE, TokenType.BEFORE, TokenType.COMPUTE, TokenType.AFTER),
            lineNo,
            start: t2[0].start,
            end: t2[0].end
          });
        }
      }
    }
    p12.forEach(([k]) => {
      if (openConnect && openConnect !== k.openconnect)
        return;
      const parseStatement = (parser) => {
        try {
          const match = { key: k, bindings: /* @__PURE__ */ new Map(), err: [], lineNo };
          if (parser(match, t2, cst.matches[0]?.err.length))
            cst.matches.length = 0;
          cst.matches.push(match);
        } catch (e2) {
          if (e2 !== lemmeout)
            throw e2;
        }
      };
      if (isGivenThen)
        parseStatement(givenThenParser);
      if (isPrepareCompute)
        parseStatement(prepareComputeParser);
    });
    return cst;
  };

  // ../core/build/esm/src/visitor.js
  var visit = (cst, params) => {
    if (cst.errors.length)
      throw new Error("cst must not have any general errors");
    if (cst.matches.length !== 1)
      throw new Error("cst must have only one match");
    const m = cst.matches[0];
    if (m.err.length)
      throw new Error("cst's match must not have any errors");
    const ast = {
      key: m.key,
      params: /* @__PURE__ */ new Map()
    };
    if (m.into)
      ast.into = m.into;
    if (m.intoSecret)
      ast.intoSecret = m.intoSecret;
    if (m.open)
      ast.open = fetchOpenconnect(params, m.open);
    if (m.connect)
      ast.connect = fetchOpenconnect(params, m.connect);
    m.bindings?.forEach((ident, name2) => {
      const val = fetchDatakeys(params, ident);
      ast.params.set(name2, val);
    });
    return { ast, lineNo: m.lineNo };
  };
  var getDatakeys = (params, rhs) => params.data[rhs] ? params.data[rhs] : params.keys[rhs];
  var fetchDatakeys = (params, rhs) => {
    const val = getDatakeys(params, rhs);
    if (val === void 0)
      throw new Error(`Can't find ${rhs} in DATA or KEYS`);
    return val;
  };
  var getOpenconnect = (params, rhs) => {
    const val = getDatakeys(params, rhs);
    if (typeof val === "string")
      return [val];
    if (Array.isArray(val)) {
      if (val.every((x) => typeof x === "string"))
        return val;
      else
        throw new Error(`the array referenced by ${rhs} must solely composed of strings`);
    }
    return [];
  };
  var fetchOpenconnect = (params, rhs) => {
    const val = getOpenconnect(params, rhs);
    if (val.length === 0)
      throw new Error(`${rhs} must contain a value`);
    return val;
  };

  // ../core/build/esm/src/plugin.js
  var DuplicatePluginError = class extends Error {
    constructor({ openconnect, params, phrase }) {
      super(`duplicated plugin with key: openconnect=${openconnect ?? ""} params=${[
        ...params ?? []
      ].join(", ")} phrase="${phrase}"`);
      this.name = "DubplicatePluginError";
    }
  };
  var PluginMap = class {
    /**
     * The datastore backing our implementation of a map.
     *
     * We use an array for the implementation, and each method mutating this
     * array ensures that only a single unique value of {@link PluginMapKey}
     * exists in the entire array.
     */
    #store = [];
    /**
     * Finds the index of the value inside the {@link #store}, where
     * {@link their} key matches with our's.
     *
     * @param their Their {@link PluginMapKey} to match against ours.
     * @returns the index of the match if found, or `-1` otherwise.
     */
    #index(their) {
      return this.#store.findIndex(([our]) => {
        const openconn = their.openconnect === our.openconnect;
        const params = their.params?.length === our.params?.length && (their.params ?? []).every((v, i2) => v === our.params?.[i2]);
        const phrase = their.phrase === our.phrase;
        return openconn && params && phrase;
      });
    }
    /**
     * Loops over each value of the map, with a callback function taking a
     * single argument of an array of pairs of {@link PluginMapKey} and
     * {@link PluginExecutor}, respectively.
     *
     * @privateRemarks
     * I don't know why I can't just use `forEach = this.#store.forEach`, but it
     * just doesn't work.  So I have to define it this way, which provides a
     * limited set of what's possible with {@link #store.forEach}.
     */
    forEach(cb) {
      this.#store.forEach(cb);
    }
    /**
     * If exists, looks up the {@link PluginExecutor} referenced by {@link k}.
     *
     * @param k The key to look up with.
     *
     * @returns the {@link PluginExecutor} if exists.
     */
    get(k) {
      return this.#store[this.#index(k)]?.[1];
    }
    /**
     * Checks whether the given key {@link k} exists in the map.
     *
     * @param k The key to look up with.
     *
     * @returns Whether the key exists or not.
     */
    has(k) {
      return this.#index(k) !== -1;
    }
    /**
     * Sets the value {@link v} using the key {@link v}.
     *
     * @param k The key to point to the value {@link v}.
     * @param v The value to be pointed to by the key {@link k}.
     *
     * @throws {@link DuplicatePluginError}
     * If the key {@link k} already exists in the map.
     */
    set(k, v) {
      if (this.has(k))
        throw new DuplicatePluginError(k);
      this.#store.push([k, v]);
    }
  };
  var Plugin = class {
    /**
     * The list of plugin definitions belonging to this plugin.
     */
    store = new PluginMap();
    /**
     * The concerete implementation of the many overridden {@link new} methods.
     * See them for their documentation.
     */
    new(phraseOrParamsOrOpenconnect, executorOrPhraseOrParams, executorOrPhrase, executor) {
      let openconnect;
      let params;
      let phrase;
      if (
        // The 4th clause:
        typeof phraseOrParamsOrOpenconnect === "string" && (phraseOrParamsOrOpenconnect === "open" || phraseOrParamsOrOpenconnect === "connect") && Array.isArray(executorOrPhraseOrParams) && typeof executorOrPhrase === "string" && executor
      ) {
        openconnect = phraseOrParamsOrOpenconnect;
        params = executorOrPhraseOrParams;
        phrase = executorOrPhrase;
      } else if (
        // The 3rd clause:
        typeof phraseOrParamsOrOpenconnect === "string" && (phraseOrParamsOrOpenconnect === "open" || phraseOrParamsOrOpenconnect === "connect") && typeof executorOrPhraseOrParams === "string" && typeof executorOrPhrase === "function"
      ) {
        openconnect = phraseOrParamsOrOpenconnect;
        phrase = executorOrPhraseOrParams;
        executor = executorOrPhrase;
      } else if (
        // The 2nd clause:
        Array.isArray(phraseOrParamsOrOpenconnect) && typeof executorOrPhraseOrParams === "string" && typeof executorOrPhrase === "function"
      ) {
        params = phraseOrParamsOrOpenconnect;
        phrase = executorOrPhraseOrParams;
        executor = executorOrPhrase;
      } else if (
        // The 1st clause:
        typeof phraseOrParamsOrOpenconnect === "string" && typeof executorOrPhraseOrParams === "function"
      ) {
        phrase = phraseOrParamsOrOpenconnect;
        executor = executorOrPhraseOrParams;
      } else {
        throw new Error("unreachable");
      }
      if (phrase.split(" ").some((x) => !isSane(x)))
        throw new Error("phrase must be composed of alpha-numerical, underscore, and dash values split by a single space");
      const key = { phrase };
      if (openconnect)
        key.openconnect = openconnect;
      if (params) {
        const found = params.find((x) => !isSane(x));
        if (found !== void 0)
          throw new Error(`the following parameter must be composed of alpha-numerical values, optionally split by dashes or underscores: ${found}`);
        const duplicates = [
          ...params.reduce((acc, cur) => {
            const found2 = acc.get(cur);
            if (found2)
              acc.set(cur, found2 + 1);
            else
              acc.set(cur, 1);
            return acc;
          }, /* @__PURE__ */ new Map())
        ].reduce((acc, cur) => {
          if (cur[1] > 1)
            acc.push(cur[0]);
          return acc;
        }, []);
        if (duplicates.length)
          throw new Error(`params must not have duplicate values: ${duplicates.join(", ")}`);
        key.params = params;
      }
      this.store.set(key, executor);
      return executor;
    }
  };
  var isSane = (str) => /^[a-z][a-z0-9]*([_-][a-z0-9]+)*$/.test(str);
  var PluginContextImpl = class {
    #ast;
    constructor(ast) {
      this.#ast = ast;
    }
    /**
     * {@inheritDoc PluginContext.pass}
     */
    pass(result) {
      return { ok: true, value: result };
    }
    /**
     * {@inheritDoc PluginContext.fail}
     */
    fail(reason) {
      return { ok: false, error: reason };
    }
    /**
     * {@inheritDoc PluginContext.getConnect}
     */
    getConnect() {
      return this.#ast.connect || [];
    }
    /**
     * {@inheritDoc PluginContext.fetchConnect}
     */
    fetchConnect() {
      const val = this.getConnect();
      if (val.length === 0)
        throw new Error("a connect is required");
      return val;
    }
    /**
     * {@inheritDoc PluginContext.getOpen}
     */
    getOpen() {
      return this.#ast.open || [];
    }
    /**
     * {@inheritDoc PluginContext.fetchOpen}
     */
    fetchOpen() {
      const val = this.getOpen();
      if (val.length === 0)
        throw new Error("a open is required");
      return val;
    }
    /**
     * {@inheritDoc PluginContext.get}
     */
    get(lhs) {
      return this.#ast.params.get(lhs);
    }
    /**
     * {@inheritDoc PluginContext.fetch}
     */
    fetch(lhs) {
      const val = this.get(lhs);
      if (!val)
        throw new Error(`the parameter isn't provided: ${lhs}`);
      return val;
    }
  };

  // ../ignored/package.json
  var package_default3 = {
    name: "@slangroom/ignored",
    version: "1.49.3",
    dependencies: {
      "@slangroom/deps": "workspace:*",
      "@slangroom/shared": "workspace:*"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../ignored/build/esm/src/index.js
  var version3 = package_default3.version;
  var InvalidStatementError = class extends Error {
    constructor(e2, couldBeIgnore) {
      if (couldBeIgnore)
        e2 = "Maybe missing: \x1B[35mRule unknown ignore\x1B[0m\n" + e2;
      super(e2);
      this.name = "Zencode Invalid Statement @slangroom/ignored@" + package_default3.version + " Error";
    }
  };
  var couldBeIgnored = (lineNo, contract, invalidLinesNos) => {
    const contractArray = contract.split("\n");
    const validLinesBeforeLineNo = contractArray.slice(0, lineNo - 1).filter((_v, i2) => !invalidLinesNos.includes(i2 + 1));
    const validGivenLine = validLinesBeforeLineNo.some((x) => x.toLowerCase().trim().startsWith("given"));
    if (!validGivenLine) {
      return true;
    } else {
      const validThenLine = validLinesBeforeLineNo.some((x) => x.toLowerCase().trim().startsWith("then"));
      if (validThenLine) {
        const validLinesAfterLineNo = contractArray.slice(lineNo).filter((_v, i2) => !invalidLinesNos.includes(i2 + 1));
        if (validLinesAfterLineNo.every((x) => x.trim() == "" || x.trim().startsWith("#"))) {
          return true;
        }
      }
    }
    return false;
  };
  var getIgnoredStatements = async (contract) => {
    const zout = await zencodeParse(contract);
    const invalidLinesNos = zout.result.invalid.map((x) => x[1]);
    const ruleUnknownIgnore = JSON.parse(zout.logs).some((x) => x.toLowerCase().includes("rule unknown ignore"));
    ;
    return {
      ignoredLines: zout.result.ignored.map((x) => [x[0].trim(), x[1]]),
      invalidLines: zout.result.invalid.map((x) => {
        return { message: new InvalidStatementError(x[2], !ruleUnknownIgnore && couldBeIgnored(x[1], contract, invalidLinesNos)), lineNo: x[1] };
      })
    };
  };

  // ../core/build/esm/src/slangroom.js
  var RUI = "Rule unknown ignore\n";
  var Slangroom = class {
    /**
     * The datastore that stores our plugins.
     */
    #plugins = new PluginMap();
    /**
     * Creates an instance of {@link Slangroom}.
     *
     * @param first A plugin or list of it.
     * @param rest A plugin or list of it, spreaded.
     *
     * @throws {@link @slangroom/core/plugin#DuplicatePluginError}
     * If any of the plugin definitions have duplicates.
     */
    constructor(first, ...rest) {
      const p12 = this.#plugins;
      [first, ...rest].forEach(function recurse(x) {
        if (Array.isArray(x))
          x.forEach(recurse);
        else
          x.store.forEach(([k, v]) => p12.set(k, v));
      });
    }
    /**
     * Executes a given contract with parameters using the list of plugins
     * provided at the class ininitation.
     *
     * @param contract The Zenroom contract with optional custom statements.
     * @param optParams The Zenroom parameters to be supplied.
     *
     * @returns The output of Zenroom execution along with custom executors
     * applied to it (before or after).
     *
     * @throws {@link Error}
     * If there exists any general errors of the parsed lines.
     *
     * @throws {@link Error}
     * If there exists any errors on any matches.
     *
     * @throws {@link Error}
     * If no plugin definitions can be matched against a custom statement.
     */
    async execute(contract, optParams) {
      contract = contract.replaceAll("	", "    ");
      const paramsGiven = requirifyZenParams(optParams);
      const { ignoredLines, invalidLines } = await getIgnoredStatements(`${RUI}${contract}`);
      if (typeof invalidLines[0] !== "undefined") {
        thorwErrors(invalidLines.map((x) => {
          x.lineNo = x.lineNo - 1;
          return x;
        }), contract);
      }
      const lexedResult = ignoredLines.map((ignored) => lex(ignored[0], ignored[1] - 1));
      const lexedErrors = lexedResult.flatMap((x) => {
        if (!x.ok)
          return x.error;
        return [];
      });
      if (typeof lexedErrors[0] !== "undefined")
        thorwErrors(lexedErrors, contract);
      const lexedLines = lexedResult.flatMap((x) => {
        if (x.ok)
          return [x.value];
        return [];
      });
      const parsedLines = lexedLines.map((lexed) => parse3(this.#plugins, ...lexed));
      const parsedErrors = parsedLines.flatMap((x) => [...x.errors, ...x.matches[0]?.err ?? []]);
      if (typeof parsedErrors[0] !== "undefined")
        thorwErrors(parsedErrors, contract);
      const cstGivens = parsedLines.filter((x) => x.givenThen === "given");
      for (const cst of cstGivens) {
        const { ast, lineNo } = visit(cst, paramsGiven);
        const exec2 = this.#plugins.get(ast.key);
        if (!exec2)
          return thorwErrors([{ message: new Error("no statements matched"), lineNo }], contract);
        const res = await exec2(new PluginContextImpl(ast));
        if (!res.ok)
          return thorwErrors([{ message: res.error, lineNo }], contract, paramsGiven.data);
        if (ast.into)
          paramsGiven.data[ast.into] = res.value;
        else if (ast.intoSecret)
          paramsGiven.keys[ast.intoSecret] = res.value;
      }
      const zout = await zencodeExec(`${RUI}${contract}`, paramsGiven);
      const paramsThen = { data: zout.result, keys: paramsGiven.keys };
      const cstThens = parsedLines.filter((x) => x.givenThen === "then");
      for (const cst of cstThens) {
        const { ast, lineNo } = visit(cst, paramsThen);
        const exec2 = this.#plugins.get(ast.key);
        if (!exec2)
          return thorwErrors([{ message: new Error("no statements matched"), lineNo }], contract);
        const res = await exec2(new PluginContextImpl(ast));
        if (!res.ok)
          return thorwErrors([{ message: res.error, lineNo }], contract, paramsThen.data);
        if (ast.into)
          paramsThen.data[ast.into] = res.value;
        else if (ast.intoSecret)
          paramsThen.keys[ast.intoSecret] = res.value;
      }
      Object.keys(paramsThen.data).forEach((k) => paramsThen.data[k] == null && delete paramsThen.data[k]);
      return { result: paramsThen.data, logs: zout.logs };
    }
    getPlugin() {
      return this.#plugins;
    }
  };
  var requirifyZenParams = (params) => {
    if (!params)
      return { data: {}, keys: {}, conf: "", extra: {} };
    if (!params.data)
      params.data = {};
    if (!params.keys)
      params.keys = {};
    return { extra: {}, conf: "", ...params };
  };
  var thorwErrors = (errorArray, contract, params) => {
    const contractLines = contract.split("\n");
    const lineNumber = errorArray[0].lineNo;
    const initialWS = contractLines[lineNumber - 1].match(/^[\s]+/) || [""];
    const colStart = errorArray[0].start ? errorArray[0].start + initialWS[0].length : initialWS[0].length;
    const colEnd = errorArray[0].end ? errorArray[0].end + 1 + initialWS[0].length : contractLines[lineNumber - 1].length;
    const lineStart = lineNumber > 2 ? lineNumber - 2 : 0;
    const lineEnd = lineNumber + 2 > contractLines.length ? contractLines.length : lineNumber + 2;
    let e2 = "";
    for (let i2 = lineStart; i2 < lineEnd; i2++) {
      const linePrefix = `${i2} | `;
      if (i2 === lineNumber - 1) {
        const boldError = textHighlight(contractLines[i2].slice(colStart, colEnd));
        const redBackground = sentenceHighlight(contractLines[i2].slice(0, colStart) + boldError + contractLines[i2].slice(colEnd));
        e2 = e2.concat(`${lineNoColor(linePrefix)}${redBackground}
`);
        e2 = e2.concat(" ".repeat(colStart + linePrefix.length) + errorColor("^".repeat(colEnd - colStart)) + "\n");
      } else {
        e2 = e2.concat(`${lineNoColor(linePrefix)}${contractLines[i2]}
`);
      }
    }
    e2 = e2.concat("\nError colors:\n");
    e2 = e2.concat(` - ${errorColor("error")}
`);
    e2 = e2.concat(` - ${suggestedColor("suggested words")}
`);
    e2 = e2.concat(` - ${missingColor("missing words")}
`);
    e2 = e2.concat(` - ${extraColor("extra words")}
`);
    for (const err3 of errorArray) {
      e2 = e2.concat("\n" + err3.message + "\n");
    }
    if (params) {
      e2 = e2.concat("\nHeap:\n" + JSON.stringify(params, null, 4) + "\n");
    }
    throw new Error(e2);
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/error_codes.js
  var ERR_RESPONSE = 100;
  var ERR_INVALID_RESPONSE = 101;
  var ERR_FORMATTERS = 201;
  var ERR_METHOD_NOT_IMPLEMENTED = 202;
  var ERR_OPERATION_TIMEOUT = 203;
  var ERR_OPERATION_ABORT = 204;
  var ERR_ABI_ENCODING = 205;
  var ERR_EXISTING_PLUGIN_NAMESPACE = 206;
  var ERR_INVALID_METHOD_PARAMS = 207;
  var ERR_CONTRACT = 300;
  var ERR_CONTRACT_RESOLVER_MISSING = 301;
  var ERR_CONTRACT_EXECUTION_REVERTED = 310;
  var ERR_CONTRACT_TX_DATA_AND_INPUT = 311;
  var ERR_TX = 400;
  var ERR_TX_REVERT_TRANSACTION = 402;
  var ERR_TX_REVERT_WITHOUT_REASON = 405;
  var ERR_RAW_TX_UNDEFINED = 407;
  var ERR_TX_INVALID_SENDER = 408;
  var ERR_TX_MISSING_CUSTOM_CHAIN = 410;
  var ERR_TX_MISSING_CUSTOM_CHAIN_ID = 411;
  var ERR_TX_CHAIN_ID_MISMATCH = 412;
  var ERR_TX_INVALID_CHAIN_INFO = 413;
  var ERR_TX_MISSING_CHAIN_INFO = 414;
  var ERR_TX_MISSING_GAS = 415;
  var ERR_TX_INVALID_LEGACY_GAS = 416;
  var ERR_TX_INVALID_FEE_MARKET_GAS = 417;
  var ERR_TX_INVALID_FEE_MARKET_GAS_PRICE = 418;
  var ERR_TX_INVALID_LEGACY_FEE_MARKET = 419;
  var ERR_TX_INVALID_OBJECT = 420;
  var ERR_TX_INVALID_NONCE_OR_CHAIN_ID = 421;
  var ERR_TX_UNABLE_TO_POPULATE_NONCE = 422;
  var ERR_TX_UNSUPPORTED_EIP_1559 = 423;
  var ERR_TX_UNSUPPORTED_TYPE = 424;
  var ERR_TX_DATA_AND_INPUT = 425;
  var ERR_TX_POLLING_TIMEOUT = 426;
  var ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL = 427;
  var ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER = 428;
  var ERR_TX_LOCAL_WALLET_NOT_AVAILABLE = 429;
  var ERR_TX_NOT_FOUND = 430;
  var ERR_TX_SEND_TIMEOUT = 431;
  var ERR_TX_BLOCK_TIMEOUT = 432;
  var ERR_TX_SIGNING = 433;
  var ERR_TX_GAS_MISMATCH = 434;
  var ERR_TX_CHAIN_MISMATCH = 435;
  var ERR_TX_HARDFORK_MISMATCH = 436;
  var ERR_TX_INVALID_RECEIVER = 437;
  var ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR = 438;
  var ERR_TX_INVALID_PROPERTIES_FOR_TYPE = 439;
  var ERR_TX_MISSING_GAS_INNER_ERROR = 440;
  var ERR_TX_GAS_MISMATCH_INNER_ERROR = 441;
  var ERR_CONN = 500;
  var ERR_CONN_NOT_OPEN = 503;
  var ERR_CONN_MAX_ATTEMPTS = 505;
  var ERR_CONN_PENDING_REQUESTS = 506;
  var ERR_REQ_ALREADY_SENT = 507;
  var ERR_PROVIDER = 600;
  var ERR_INVALID_CLIENT = 602;
  var ERR_SUBSCRIPTION = 603;
  var ERR_WS_PROVIDER = 604;
  var ERR_PRIVATE_KEY_LENGTH = 701;
  var ERR_INVALID_PRIVATE_KEY = 702;
  var ERR_UNSUPPORTED_KDF = 703;
  var ERR_KEY_DERIVATION_FAIL = 704;
  var ERR_KEY_VERSION_UNSUPPORTED = 705;
  var ERR_INVALID_PASSWORD = 706;
  var ERR_IV_LENGTH = 707;
  var ERR_PBKDF2_ITERATIONS = 709;
  var ERR_SIGNATURE_FAILED = 801;
  var ERR_INVALID_SIGNATURE = 802;
  var JSONRPC_ERR_REJECTED_REQUEST = 4001;
  var JSONRPC_ERR_UNAUTHORIZED = 4100;
  var JSONRPC_ERR_UNSUPPORTED_METHOD = 4200;
  var JSONRPC_ERR_DISCONNECTED = 4900;
  var JSONRPC_ERR_CHAIN_DISCONNECTED = 4901;
  var ERR_ENS_UNSUPPORTED_NETWORK = 902;
  var ERR_ENS_NETWORK_NOT_SYNCED = 903;
  var ERR_INVALID_STRING = 1001;
  var ERR_INVALID_BYTES = 1002;
  var ERR_INVALID_NUMBER = 1003;
  var ERR_INVALID_UNIT = 1004;
  var ERR_INVALID_ADDRESS = 1005;
  var ERR_INVALID_HEX = 1006;
  var ERR_INVALID_BOOLEAN = 1008;
  var ERR_INVALID_UNSIGNED_INTEGER = 1009;
  var ERR_INVALID_SIZE = 1010;
  var ERR_INVALID_LARGE_VALUE = 1011;
  var ERR_INVALID_BLOCK = 1012;
  var ERR_INVALID_NIBBLE_WIDTH = 1014;
  var ERR_VALIDATION = 1100;
  var ERR_CORE_HARDFORK_MISMATCH = 1101;
  var ERR_SCHEMA_FORMAT = 1200;
  var ERR_RPC_INVALID_JSON = -32700;
  var ERR_RPC_INVALID_REQUEST = -32600;
  var ERR_RPC_INVALID_METHOD = -32601;
  var ERR_RPC_INVALID_PARAMS = -32602;
  var ERR_RPC_INTERNAL_ERROR = -32603;
  var ERR_RPC_INVALID_INPUT = -32e3;
  var ERR_RPC_MISSING_RESOURCE = -32001;
  var ERR_RPC_UNAVAILABLE_RESOURCE = -32002;
  var ERR_RPC_TRANSACTION_REJECTED = -32003;
  var ERR_RPC_UNSUPPORTED_METHOD = -32004;
  var ERR_RPC_LIMIT_EXCEEDED = -32005;
  var ERR_RPC_NOT_SUPPORTED = -32006;

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/web3_error_base.js
  var BaseWeb3Error = class extends Error {
    constructor(msg, innerError) {
      super(msg);
      this.innerError = innerError;
      this.name = this.constructor.name;
      if (typeof Error.captureStackTrace === "function") {
        Error.captureStackTrace(new.target.constructor);
      } else {
        this.stack = new Error().stack;
      }
    }
    static convertToString(value, unquotValue = false) {
      if (value === null || value === void 0)
        return "undefined";
      const result = JSON.stringify(value, (_2, v) => typeof v === "bigint" ? v.toString() : v);
      return unquotValue && ["bigint", "string"].includes(typeof value) ? result.replace(/['\\"]+/g, "") : result;
    }
    toJSON() {
      return {
        name: this.name,
        code: this.code,
        message: this.message,
        innerError: this.innerError
      };
    }
  };
  var InvalidValueError = class extends BaseWeb3Error {
    constructor(value, msg) {
      super(`Invalid value given "${BaseWeb3Error.convertToString(value, true)}". Error: ${msg}.`);
      this.name = this.constructor.name;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/account_errors.js
  var PrivateKeyLengthError = class extends BaseWeb3Error {
    constructor() {
      super(`Private key must be 32 bytes.`);
      this.code = ERR_PRIVATE_KEY_LENGTH;
    }
  };
  var InvalidPrivateKeyError = class extends BaseWeb3Error {
    constructor() {
      super(`Invalid Private Key, Not a valid string or uint8Array`);
      this.code = ERR_INVALID_PRIVATE_KEY;
    }
  };
  var InvalidSignatureError = class extends BaseWeb3Error {
    constructor(errorDetails) {
      super(`"${errorDetails}"`);
      this.code = ERR_INVALID_SIGNATURE;
    }
  };
  var InvalidKdfError = class extends BaseWeb3Error {
    constructor() {
      super(`Invalid key derivation function`);
      this.code = ERR_UNSUPPORTED_KDF;
    }
  };
  var KeyDerivationError = class extends BaseWeb3Error {
    constructor() {
      super(`Key derivation failed - possibly wrong password`);
      this.code = ERR_KEY_DERIVATION_FAIL;
    }
  };
  var KeyStoreVersionError = class extends BaseWeb3Error {
    constructor() {
      super("Unsupported key store version");
      this.code = ERR_KEY_VERSION_UNSUPPORTED;
    }
  };
  var InvalidPasswordError = class extends BaseWeb3Error {
    constructor() {
      super("Password cannot be empty");
      this.code = ERR_INVALID_PASSWORD;
    }
  };
  var IVLengthError = class extends BaseWeb3Error {
    constructor() {
      super("Initialization vector must be 16 bytes");
      this.code = ERR_IV_LENGTH;
    }
  };
  var PBKDF2IterationsError = class extends BaseWeb3Error {
    constructor() {
      super("c > 1000, pbkdf2 is less secure with less iterations");
      this.code = ERR_PBKDF2_ITERATIONS;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/connection_errors.js
  var ConnectionError = class extends BaseWeb3Error {
    constructor(message, event) {
      super(message);
      this.code = ERR_CONN;
      if (event) {
        this.errorCode = event.code;
        this.errorReason = event.reason;
      }
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { errorCode: this.errorCode, errorReason: this.errorReason });
    }
  };
  var ConnectionNotOpenError = class extends ConnectionError {
    constructor(event) {
      super("Connection not open", event);
      this.code = ERR_CONN_NOT_OPEN;
    }
  };
  var MaxAttemptsReachedOnReconnectingError = class extends ConnectionError {
    constructor(numberOfAttempts) {
      super(`Maximum number of reconnect attempts reached! (${numberOfAttempts})`);
      this.code = ERR_CONN_MAX_ATTEMPTS;
    }
  };
  var PendingRequestsOnReconnectingError = class extends ConnectionError {
    constructor() {
      super("CONNECTION ERROR: Provider started to reconnect before the response got received!");
      this.code = ERR_CONN_PENDING_REQUESTS;
    }
  };
  var RequestAlreadySentError = class extends ConnectionError {
    constructor(id) {
      super(`Request already sent with following id: ${id}`);
      this.code = ERR_REQ_ALREADY_SENT;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/contract_errors.js
  var Web3ContractError = class extends BaseWeb3Error {
    constructor(message, receipt) {
      super(message);
      this.code = ERR_CONTRACT;
      this.receipt = receipt;
    }
  };
  var ResolverMethodMissingError = class extends BaseWeb3Error {
    constructor(address, name2) {
      super(`The resolver at ${address} does not implement requested method: "${name2}".`);
      this.address = address;
      this.name = name2;
      this.code = ERR_CONTRACT_RESOLVER_MISSING;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { address: this.address, name: this.name });
    }
  };
  var Eip838ExecutionError = class _Eip838ExecutionError extends Web3ContractError {
    constructor(error) {
      super(error.message || "Error");
      this.name = "name" in error && error.name || this.constructor.name;
      this.stack = "stack" in error && error.stack || void 0;
      this.code = error.code;
      if (typeof error.data === "object") {
        let originalError;
        if ("originalError" in error.data) {
          originalError = error.data.originalError;
        } else {
          originalError = error.data;
        }
        this.data = originalError.data;
        this.innerError = new _Eip838ExecutionError(originalError);
      } else {
        this.data = error.data;
      }
    }
    setDecodedProperties(errorName, errorSignature, errorArgs) {
      this.errorName = errorName;
      this.errorSignature = errorSignature;
      this.errorArgs = errorArgs;
    }
    toJSON() {
      let json = Object.assign(Object.assign({}, super.toJSON()), { data: this.data });
      if (this.errorName) {
        json = Object.assign(Object.assign({}, json), { errorName: this.errorName, errorSignature: this.errorSignature, errorArgs: this.errorArgs });
      }
      return json;
    }
  };
  var ContractExecutionError = class extends Web3ContractError {
    constructor(rpcError) {
      super("Error happened while trying to execute a function inside a smart contract");
      this.code = ERR_CONTRACT_EXECUTION_REVERTED;
      this.innerError = new Eip838ExecutionError(rpcError);
    }
  };
  var ContractTransactionDataAndInputError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`data: ${(_a6 = value.data) !== null && _a6 !== void 0 ? _a6 : "undefined"}, input: ${(_b3 = value.input) !== null && _b3 !== void 0 ? _b3 : "undefined"}`, `You can't have "data" and "input" as properties of a contract at the same time, please use either "data" or "input" instead.`);
      this.code = ERR_CONTRACT_TX_DATA_AND_INPUT;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/ens_errors.js
  var ENSUnsupportedNetworkError = class extends BaseWeb3Error {
    constructor(networkType) {
      super(`ENS is not supported on network ${networkType}`);
      this.code = ERR_ENS_UNSUPPORTED_NETWORK;
    }
  };
  var ENSNetworkNotSyncedError = class extends BaseWeb3Error {
    constructor() {
      super(`Network not synced`);
      this.code = ERR_ENS_NETWORK_NOT_SYNCED;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/generic_errors.js
  var InvalidMethodParamsError = class extends BaseWeb3Error {
    constructor(hint) {
      super(`Invalid parameters passed. "${typeof hint !== "undefined" ? hint : ""}"`);
      this.hint = hint;
      this.code = ERR_INVALID_METHOD_PARAMS;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { hint: this.hint });
    }
  };
  var FormatterError = class extends BaseWeb3Error {
    constructor() {
      super(...arguments);
      this.code = ERR_FORMATTERS;
    }
  };
  var MethodNotImplementedError = class extends BaseWeb3Error {
    constructor() {
      super("The method you're trying to call is not implemented.");
      this.code = ERR_METHOD_NOT_IMPLEMENTED;
    }
  };
  var OperationTimeoutError = class extends BaseWeb3Error {
    constructor() {
      super(...arguments);
      this.code = ERR_OPERATION_TIMEOUT;
    }
  };
  var OperationAbortError = class extends BaseWeb3Error {
    constructor() {
      super(...arguments);
      this.code = ERR_OPERATION_ABORT;
    }
  };
  var AbiError = class extends BaseWeb3Error {
    constructor(message, props) {
      super(message);
      this.code = ERR_ABI_ENCODING;
      this.props = props !== null && props !== void 0 ? props : {};
    }
  };
  var ExistingPluginNamespaceError = class extends BaseWeb3Error {
    constructor(pluginNamespace) {
      super(`A plugin with the namespace: ${pluginNamespace} has already been registered.`);
      this.code = ERR_EXISTING_PLUGIN_NAMESPACE;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/provider_errors.js
  var ProviderError = class extends BaseWeb3Error {
    constructor() {
      super(...arguments);
      this.code = ERR_PROVIDER;
    }
  };
  var InvalidClientError = class extends BaseWeb3Error {
    constructor(clientUrl) {
      super(`Client URL "${clientUrl}" is invalid.`);
      this.code = ERR_INVALID_CLIENT;
    }
  };
  var SubscriptionError = class extends BaseWeb3Error {
    constructor() {
      super(...arguments);
      this.code = ERR_SUBSCRIPTION;
    }
  };
  var Web3WSProviderError = class extends BaseWeb3Error {
    constructor() {
      super(...arguments);
      this.code = ERR_WS_PROVIDER;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/signature_errors.js
  var SignatureError = class extends InvalidValueError {
    constructor() {
      super(...arguments);
      this.code = ERR_SIGNATURE_FAILED;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/transaction_errors.js
  var TransactionError = class extends BaseWeb3Error {
    constructor(message, receipt) {
      super(message);
      this.receipt = receipt;
      this.code = ERR_TX;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { receipt: this.receipt });
    }
  };
  var TransactionRevertInstructionError = class extends BaseWeb3Error {
    constructor(reason, signature, receipt, data) {
      super(`Transaction has been reverted by the EVM${receipt === void 0 ? "" : `:
 ${BaseWeb3Error.convertToString(receipt)}`}`);
      this.reason = reason;
      this.signature = signature;
      this.receipt = receipt;
      this.data = data;
      this.code = ERR_TX_REVERT_TRANSACTION;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { reason: this.reason, signature: this.signature, receipt: this.receipt, data: this.data });
    }
  };
  var TransactionRevertWithCustomError = class extends TransactionRevertInstructionError {
    constructor(reason, customErrorName, customErrorDecodedSignature, customErrorArguments, signature, receipt, data) {
      super(reason);
      this.reason = reason;
      this.customErrorName = customErrorName;
      this.customErrorDecodedSignature = customErrorDecodedSignature;
      this.customErrorArguments = customErrorArguments;
      this.signature = signature;
      this.receipt = receipt;
      this.data = data;
      this.code = ERR_TX_REVERT_TRANSACTION_CUSTOM_ERROR;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { reason: this.reason, customErrorName: this.customErrorName, customErrorDecodedSignature: this.customErrorDecodedSignature, customErrorArguments: this.customErrorArguments, signature: this.signature, receipt: this.receipt, data: this.data });
    }
  };
  var TransactionRevertedWithoutReasonError = class extends TransactionError {
    constructor(receipt) {
      super(`Transaction has been reverted by the EVM${receipt === void 0 ? "" : `:
 ${BaseWeb3Error.convertToString(receipt)}`}`, receipt);
      this.code = ERR_TX_REVERT_WITHOUT_REASON;
    }
  };
  var UndefinedRawTransactionError = class extends TransactionError {
    constructor() {
      super(`Raw transaction undefined`);
      this.code = ERR_RAW_TX_UNDEFINED;
    }
  };
  var TransactionNotFound = class extends TransactionError {
    constructor() {
      super("Transaction not found");
      this.code = ERR_TX_NOT_FOUND;
    }
  };
  var InvalidTransactionWithSender = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid transaction with invalid sender");
      this.code = ERR_TX_INVALID_SENDER;
    }
  };
  var InvalidTransactionWithReceiver = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid transaction with invalid receiver");
      this.code = ERR_TX_INVALID_RECEIVER;
    }
  };
  var MissingCustomChainError = class extends InvalidValueError {
    constructor() {
      super("MissingCustomChainError", "If tx.common is provided it must have tx.common.customChain");
      this.code = ERR_TX_MISSING_CUSTOM_CHAIN;
    }
  };
  var MissingCustomChainIdError = class extends InvalidValueError {
    constructor() {
      super("MissingCustomChainIdError", "If tx.common is provided it must have tx.common.customChain and tx.common.customChain.chainId");
      this.code = ERR_TX_MISSING_CUSTOM_CHAIN_ID;
    }
  };
  var ChainIdMismatchError = class extends InvalidValueError {
    constructor(value) {
      super(
        JSON.stringify(value),
        // https://github.com/ChainSafe/web3.js/blob/8783f4d64e424456bdc53b34ef1142d0a7cee4d7/packages/web3-eth-accounts/src/index.js#L176
        "Chain Id doesnt match in tx.chainId tx.common.customChain.chainId"
      );
      this.code = ERR_TX_CHAIN_ID_MISMATCH;
    }
  };
  var ChainMismatchError = class extends InvalidValueError {
    constructor(value) {
      super(JSON.stringify(value), "Chain doesnt match in tx.chain tx.common.basechain");
      this.code = ERR_TX_CHAIN_MISMATCH;
    }
  };
  var HardforkMismatchError = class extends InvalidValueError {
    constructor(value) {
      super(JSON.stringify(value), "hardfork doesnt match in tx.hardfork tx.common.hardfork");
      this.code = ERR_TX_HARDFORK_MISMATCH;
    }
  };
  var CommonOrChainAndHardforkError = class extends InvalidValueError {
    constructor() {
      super("CommonOrChainAndHardforkError", "Please provide the common object or the chain and hardfork property but not all together.");
      this.code = ERR_TX_INVALID_CHAIN_INFO;
    }
  };
  var MissingChainOrHardforkError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super("MissingChainOrHardforkError", `When specifying chain and hardfork, both values must be defined. Received "chain": ${(_a6 = value.chain) !== null && _a6 !== void 0 ? _a6 : "undefined"}, "hardfork": ${(_b3 = value.hardfork) !== null && _b3 !== void 0 ? _b3 : "undefined"}`);
      this.code = ERR_TX_MISSING_CHAIN_INFO;
    }
  };
  var MissingGasInnerError = class extends BaseWeb3Error {
    constructor() {
      super('Missing properties in transaction, either define "gas" and "gasPrice" for type 0 transactions or "gas", "maxPriorityFeePerGas" and "maxFeePerGas" for type 2 transactions');
      this.code = ERR_TX_MISSING_GAS_INNER_ERROR;
    }
  };
  var MissingGasError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3, _c2, _d;
      super(`gas: ${(_a6 = value.gas) !== null && _a6 !== void 0 ? _a6 : "undefined"}, gasPrice: ${(_b3 = value.gasPrice) !== null && _b3 !== void 0 ? _b3 : "undefined"}, maxPriorityFeePerGas: ${(_c2 = value.maxPriorityFeePerGas) !== null && _c2 !== void 0 ? _c2 : "undefined"}, maxFeePerGas: ${(_d = value.maxFeePerGas) !== null && _d !== void 0 ? _d : "undefined"}`, '"gas" is missing');
      this.code = ERR_TX_MISSING_GAS;
      this.innerError = new MissingGasInnerError();
    }
  };
  var TransactionGasMismatchInnerError = class extends BaseWeb3Error {
    constructor() {
      super('Missing properties in transaction, either define "gas" and "gasPrice" for type 0 transactions or "gas", "maxPriorityFeePerGas" and "maxFeePerGas" for type 2 transactions, not both');
      this.code = ERR_TX_GAS_MISMATCH_INNER_ERROR;
    }
  };
  var TransactionGasMismatchError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3, _c2, _d;
      super(`gas: ${(_a6 = value.gas) !== null && _a6 !== void 0 ? _a6 : "undefined"}, gasPrice: ${(_b3 = value.gasPrice) !== null && _b3 !== void 0 ? _b3 : "undefined"}, maxPriorityFeePerGas: ${(_c2 = value.maxPriorityFeePerGas) !== null && _c2 !== void 0 ? _c2 : "undefined"}, maxFeePerGas: ${(_d = value.maxFeePerGas) !== null && _d !== void 0 ? _d : "undefined"}`, "transaction must specify legacy or fee market gas properties, not both");
      this.code = ERR_TX_GAS_MISMATCH;
      this.innerError = new TransactionGasMismatchInnerError();
    }
  };
  var InvalidGasOrGasPrice = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`gas: ${(_a6 = value.gas) !== null && _a6 !== void 0 ? _a6 : "undefined"}, gasPrice: ${(_b3 = value.gasPrice) !== null && _b3 !== void 0 ? _b3 : "undefined"}`, "Gas or gasPrice is lower than 0");
      this.code = ERR_TX_INVALID_LEGACY_GAS;
    }
  };
  var InvalidMaxPriorityFeePerGasOrMaxFeePerGas = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`maxPriorityFeePerGas: ${(_a6 = value.maxPriorityFeePerGas) !== null && _a6 !== void 0 ? _a6 : "undefined"}, maxFeePerGas: ${(_b3 = value.maxFeePerGas) !== null && _b3 !== void 0 ? _b3 : "undefined"}`, "maxPriorityFeePerGas or maxFeePerGas is lower than 0");
      this.code = ERR_TX_INVALID_FEE_MARKET_GAS;
    }
  };
  var Eip1559GasPriceError = class extends InvalidValueError {
    constructor(value) {
      super(value, "eip-1559 transactions don't support gasPrice");
      this.code = ERR_TX_INVALID_FEE_MARKET_GAS_PRICE;
    }
  };
  var UnsupportedFeeMarketError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`maxPriorityFeePerGas: ${(_a6 = value.maxPriorityFeePerGas) !== null && _a6 !== void 0 ? _a6 : "undefined"}, maxFeePerGas: ${(_b3 = value.maxFeePerGas) !== null && _b3 !== void 0 ? _b3 : "undefined"}`, "pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas");
      this.code = ERR_TX_INVALID_LEGACY_FEE_MARKET;
    }
  };
  var InvalidTransactionObjectError = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid transaction object");
      this.code = ERR_TX_INVALID_OBJECT;
    }
  };
  var InvalidNonceOrChainIdError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`nonce: ${(_a6 = value.nonce) !== null && _a6 !== void 0 ? _a6 : "undefined"}, chainId: ${(_b3 = value.chainId) !== null && _b3 !== void 0 ? _b3 : "undefined"}`, "Nonce or chainId is lower than 0");
      this.code = ERR_TX_INVALID_NONCE_OR_CHAIN_ID;
    }
  };
  var UnableToPopulateNonceError = class extends InvalidValueError {
    constructor() {
      super("UnableToPopulateNonceError", "unable to populate nonce, no from address available");
      this.code = ERR_TX_UNABLE_TO_POPULATE_NONCE;
    }
  };
  var Eip1559NotSupportedError = class extends InvalidValueError {
    constructor() {
      super("Eip1559NotSupportedError", "Network doesn't support eip-1559");
      this.code = ERR_TX_UNSUPPORTED_EIP_1559;
    }
  };
  var UnsupportedTransactionTypeError = class extends InvalidValueError {
    constructor(value) {
      super(value, "unsupported transaction type");
      this.code = ERR_TX_UNSUPPORTED_TYPE;
    }
  };
  var TransactionDataAndInputError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`data: ${(_a6 = value.data) !== null && _a6 !== void 0 ? _a6 : "undefined"}, input: ${(_b3 = value.input) !== null && _b3 !== void 0 ? _b3 : "undefined"}`, `You can't have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.`);
      this.code = ERR_TX_DATA_AND_INPUT;
    }
  };
  var TransactionSendTimeoutError = class extends BaseWeb3Error {
    constructor(value) {
      super(`The connected Ethereum Node did not respond within ${value.numberOfSeconds} seconds, please make sure your transaction was properly sent and you are connected to a healthy Node. Be aware that transaction might still be pending or mined!
	Transaction Hash: ${value.transactionHash ? value.transactionHash.toString() : "not available"}`);
      this.code = ERR_TX_SEND_TIMEOUT;
    }
  };
  function transactionTimeoutHint(transactionHash) {
    return `Please make sure your transaction was properly sent and there are no previous pending transaction for the same account. However, be aware that it might still be mined!
	Transaction Hash: ${transactionHash ? transactionHash.toString() : "not available"}`;
  }
  var TransactionPollingTimeoutError = class extends BaseWeb3Error {
    constructor(value) {
      super(`Transaction was not mined within ${value.numberOfSeconds} seconds. ${transactionTimeoutHint(value.transactionHash)}`);
      this.code = ERR_TX_POLLING_TIMEOUT;
    }
  };
  var TransactionBlockTimeoutError = class extends BaseWeb3Error {
    constructor(value) {
      super(`Transaction started at ${value.starterBlockNumber} but was not mined within ${value.numberOfBlocks} blocks. ${transactionTimeoutHint(value.transactionHash)}`);
      this.code = ERR_TX_BLOCK_TIMEOUT;
    }
  };
  var TransactionMissingReceiptOrBlockHashError = class extends InvalidValueError {
    constructor(value) {
      var _a6, _b3;
      super(`receipt: ${JSON.stringify(value.receipt)}, blockHash: ${(_a6 = value.blockHash) === null || _a6 === void 0 ? void 0 : _a6.toString()}, transactionHash: ${(_b3 = value.transactionHash) === null || _b3 === void 0 ? void 0 : _b3.toString()}`, `Receipt missing or blockHash null`);
      this.code = ERR_TX_RECEIPT_MISSING_OR_BLOCKHASH_NULL;
    }
  };
  var TransactionReceiptMissingBlockNumberError = class extends InvalidValueError {
    constructor(value) {
      super(`receipt: ${JSON.stringify(value.receipt)}`, `Receipt missing block number`);
      this.code = ERR_TX_RECEIPT_MISSING_BLOCK_NUMBER;
    }
  };
  var TransactionSigningError = class extends BaseWeb3Error {
    constructor(errorDetails) {
      super(`Invalid signature. "${errorDetails}"`);
      this.code = ERR_TX_SIGNING;
    }
  };
  var LocalWalletNotAvailableError = class extends InvalidValueError {
    constructor() {
      super("LocalWalletNotAvailableError", `Attempted to index account in local wallet, but no wallet is available`);
      this.code = ERR_TX_LOCAL_WALLET_NOT_AVAILABLE;
    }
  };
  var InvalidPropertiesForTransactionTypeError = class extends BaseWeb3Error {
    constructor(validationError, txType) {
      const invalidPropertyNames = [];
      validationError.forEach((error) => invalidPropertyNames.push(error.keyword));
      super(`The following properties are invalid for the transaction type ${txType}: ${invalidPropertyNames.join(", ")}`);
      this.code = ERR_TX_INVALID_PROPERTIES_FOR_TYPE;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/utils_errors.js
  var InvalidBytesError = class extends InvalidValueError {
    constructor(value) {
      super(value, "can not parse as byte data");
      this.code = ERR_INVALID_BYTES;
    }
  };
  var InvalidNumberError = class extends InvalidValueError {
    constructor(value) {
      super(value, "can not parse as number data");
      this.code = ERR_INVALID_NUMBER;
    }
  };
  var InvalidAddressError = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid ethereum address");
      this.code = ERR_INVALID_ADDRESS;
    }
  };
  var InvalidStringError = class extends InvalidValueError {
    constructor(value) {
      super(value, "not a valid string");
      this.code = ERR_INVALID_STRING;
    }
  };
  var InvalidUnitError = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid unit");
      this.code = ERR_INVALID_UNIT;
    }
  };
  var HexProcessingError = class extends InvalidValueError {
    constructor(value) {
      super(value, "can not be converted to hex");
      this.code = ERR_INVALID_HEX;
    }
  };
  var NibbleWidthError = class extends InvalidValueError {
    constructor(value) {
      super(value, "value greater than the nibble width");
      this.code = ERR_INVALID_NIBBLE_WIDTH;
    }
  };
  var InvalidBooleanError = class extends InvalidValueError {
    constructor(value) {
      super(value, "not a valid boolean.");
      this.code = ERR_INVALID_BOOLEAN;
    }
  };
  var InvalidUnsignedIntegerError = class extends InvalidValueError {
    constructor(value) {
      super(value, "not a valid unsigned integer.");
      this.code = ERR_INVALID_UNSIGNED_INTEGER;
    }
  };
  var InvalidSizeError = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid size given.");
      this.code = ERR_INVALID_SIZE;
    }
  };
  var InvalidLargeValueError = class extends InvalidValueError {
    constructor(value) {
      super(value, "value is larger than size.");
      this.code = ERR_INVALID_LARGE_VALUE;
    }
  };
  var InvalidBlockError = class extends InvalidValueError {
    constructor(value) {
      super(value, "invalid string given");
      this.code = ERR_INVALID_BLOCK;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/response_errors.js
  var isResponseWithError = (response) => !Array.isArray(response) && response.jsonrpc === "2.0" && !!response && // eslint-disable-next-line no-null/no-null
  (response.result === void 0 || response.result === null) && // JSON RPC consider "null" as valid response
  "error" in response && (typeof response.id === "number" || typeof response.id === "string");
  var buildErrorMessage = (response) => isResponseWithError(response) ? response.error.message : "";
  var ResponseError = class extends BaseWeb3Error {
    constructor(response, message, request4) {
      var _a6;
      super(message !== null && message !== void 0 ? message : `Returned error: ${Array.isArray(response) ? response.map((r2) => buildErrorMessage(r2)).join(",") : buildErrorMessage(response)}`);
      this.code = ERR_RESPONSE;
      if (!message) {
        this.data = Array.isArray(response) ? response.map((r2) => {
          var _a7;
          return (_a7 = r2.error) === null || _a7 === void 0 ? void 0 : _a7.data;
        }) : (_a6 = response === null || response === void 0 ? void 0 : response.error) === null || _a6 === void 0 ? void 0 : _a6.data;
      }
      this.request = request4;
      let errorOrErrors;
      if (`error` in response) {
        errorOrErrors = response.error;
      } else if (response instanceof Array) {
        errorOrErrors = response.map((r2) => r2.error);
      }
      this.innerError = errorOrErrors;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { data: this.data, request: this.request });
    }
  };
  var InvalidResponseError = class extends ResponseError {
    constructor(result, request4) {
      super(result, void 0, request4);
      this.code = ERR_INVALID_RESPONSE;
      let errorOrErrors;
      if (`error` in result) {
        errorOrErrors = result.error;
      } else if (result instanceof Array) {
        errorOrErrors = result.map((r2) => r2.error);
      }
      this.innerError = errorOrErrors;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/core_errors.js
  var ConfigHardforkMismatchError = class extends BaseWeb3Error {
    constructor(defaultHardfork, commonHardFork) {
      super(`Web3Config hardfork doesnt match in defaultHardfork ${defaultHardfork} and common.hardfork ${commonHardFork}`);
      this.code = ERR_CORE_HARDFORK_MISMATCH;
    }
  };
  var ConfigChainMismatchError = class extends BaseWeb3Error {
    constructor(defaultHardfork, commonHardFork) {
      super(`Web3Config chain doesnt match in defaultHardfork ${defaultHardfork} and common.hardfork ${commonHardFork}`);
      this.code = ERR_CORE_HARDFORK_MISMATCH;
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/rpc_error_messages.js
  var genericRpcErrorMessageTemplate = "An Rpc error has occured with a code of *code*";
  var RpcErrorMessages = {
    //  EIP-1474 & JSON RPC 2.0
    // https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1474.md
    [ERR_RPC_INVALID_JSON]: {
      message: "Parse error",
      description: "Invalid JSON"
    },
    [ERR_RPC_INVALID_REQUEST]: {
      message: "Invalid request",
      description: "JSON is not a valid request object	"
    },
    [ERR_RPC_INVALID_METHOD]: {
      message: "Method not found",
      description: "Method does not exist	"
    },
    [ERR_RPC_INVALID_PARAMS]: {
      message: "Invalid params",
      description: "Invalid method parameters"
    },
    [ERR_RPC_INTERNAL_ERROR]: {
      message: "Internal error",
      description: "Internal JSON-RPC error"
    },
    [ERR_RPC_INVALID_INPUT]: {
      message: "Invalid input",
      description: "Missing or invalid parameters"
    },
    [ERR_RPC_MISSING_RESOURCE]: {
      message: "Resource not found",
      description: "Requested resource not found"
    },
    [ERR_RPC_UNAVAILABLE_RESOURCE]: {
      message: "Resource unavailable",
      description: "Requested resource not available"
    },
    [ERR_RPC_TRANSACTION_REJECTED]: {
      message: "Transaction rejected",
      description: "Transaction creation failed"
    },
    [ERR_RPC_UNSUPPORTED_METHOD]: {
      message: "Method not supported",
      description: "Method is not implemented"
    },
    [ERR_RPC_LIMIT_EXCEEDED]: {
      message: "Limit exceeded",
      description: "Request exceeds defined limit"
    },
    [ERR_RPC_NOT_SUPPORTED]: {
      message: "JSON-RPC version not supported",
      description: "Version of JSON-RPC protocol is not supported"
    },
    // EIP-1193
    // https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1193.md#provider-errors
    [JSONRPC_ERR_REJECTED_REQUEST]: {
      name: "User Rejected Request",
      message: "The user rejected the request."
    },
    [JSONRPC_ERR_UNAUTHORIZED]: {
      name: "Unauthorized",
      message: "The requested method and/or account has not been authorized by the user."
    },
    [JSONRPC_ERR_UNSUPPORTED_METHOD]: {
      name: "Unsupported Method",
      message: "The Provider does not support the requested method."
    },
    [JSONRPC_ERR_DISCONNECTED]: {
      name: "Disconnected",
      message: "The Provider is disconnected from all chains."
    },
    [JSONRPC_ERR_CHAIN_DISCONNECTED]: {
      name: "Chain Disconnected",
      message: "The Provider is not connected to the requested chain."
    },
    // EIP-1193 - CloseEvent
    // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
    "0-999": {
      name: "",
      message: "Not used."
    },
    1e3: {
      name: "Normal Closure",
      message: "The connection successfully completed the purpose for which it was created."
    },
    1001: {
      name: "Going Away",
      message: "The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection."
    },
    1002: {
      name: "Protocol error",
      message: "The endpoint is terminating the connection due to a protocol error."
    },
    1003: {
      name: "Unsupported Data",
      message: "The connection is being terminated because the endpoint received data of a type it cannot accept. (For example, a text-only endpoint received binary data.)"
    },
    1004: {
      name: "Reserved",
      message: "Reserved. A meaning might be defined in the future."
    },
    1005: {
      name: "No Status Rcvd",
      message: "Reserved. Indicates that no status code was provided even though one was expected."
    },
    1006: {
      name: "Abnormal Closure",
      message: "Reserved. Indicates that a connection was closed abnormally (that is, with no close frame being sent) when a status code is expected."
    },
    1007: {
      name: "Invalid frame payload data",
      message: "The endpoint is terminating the connection because a message was received that contained inconsistent data (e.g., non-UTF-8 data within a text message)."
    },
    1008: {
      name: "Policy Violation",
      message: "The endpoint is terminating the connection because it received a message that violates its policy. This is a generic status code, used when codes 1003 and 1009 are not suitable."
    },
    1009: {
      name: "Message Too Big",
      message: "The endpoint is terminating the connection because a data frame was received that is too large."
    },
    1010: {
      name: "Mandatory Ext.",
      message: "The client is terminating the connection because it expected the server to negotiate one or more extension, but the server didn't."
    },
    1011: {
      name: "Internal Error",
      message: "The server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request."
    },
    1012: {
      name: "Service Restart",
      message: "The server is terminating the connection because it is restarting."
    },
    1013: {
      name: "Try Again Later",
      message: "The server is terminating the connection due to a temporary condition, e.g. it is overloaded and is casting off some of its clients."
    },
    1014: {
      name: "Bad Gateway",
      message: "The server was acting as a gateway or proxy and received an invalid response from the upstream server. This is similar to 502 HTTP Status Code."
    },
    1015: {
      name: "TLS handshake",
      message: "Reserved. Indicates that the connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified)."
    },
    "1016-2999": {
      name: "",
      message: "For definition by future revisions of the WebSocket Protocol specification, and for definition by extension specifications."
    },
    "3000-3999": {
      name: "",
      message: "For use by libraries, frameworks, and applications. These status codes are registered directly with IANA. The interpretation of these codes is undefined by the WebSocket protocol."
    },
    "4000-4999": {
      name: "",
      message: "For private use, and thus can't be registered. Such codes can be used by prior agreements between WebSocket applications. The interpretation of these codes is undefined by the WebSocket protocol."
    }
  };

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/rpc_errors.js
  var RpcError = class extends BaseWeb3Error {
    constructor(rpcError, message) {
      super(message !== null && message !== void 0 ? message : genericRpcErrorMessageTemplate.replace("*code*", rpcError.error.code.toString()));
      this.code = rpcError.error.code;
      this.id = rpcError.id;
      this.jsonrpc = rpcError.jsonrpc;
      this.jsonRpcError = rpcError.error;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { error: this.jsonRpcError, id: this.id, jsonRpc: this.jsonrpc });
    }
  };
  var EIP1193ProviderRpcError = class extends BaseWeb3Error {
    constructor(code, data) {
      var _a6, _b3, _c2, _d;
      if (!code) {
        super();
      } else if ((_a6 = RpcErrorMessages[code]) === null || _a6 === void 0 ? void 0 : _a6.message) {
        super(RpcErrorMessages[code].message);
      } else {
        const statusCodeRange = Object.keys(RpcErrorMessages).find((statusCode) => typeof statusCode === "string" && code >= parseInt(statusCode.split("-")[0], 10) && code <= parseInt(statusCode.split("-")[1], 10));
        super((_c2 = (_b3 = RpcErrorMessages[statusCodeRange !== null && statusCodeRange !== void 0 ? statusCodeRange : ""]) === null || _b3 === void 0 ? void 0 : _b3.message) !== null && _c2 !== void 0 ? _c2 : genericRpcErrorMessageTemplate.replace("*code*", (_d = code === null || code === void 0 ? void 0 : code.toString()) !== null && _d !== void 0 ? _d : '""'));
      }
      this.code = code;
      this.data = data;
    }
  };
  var ParseError2 = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_INVALID_JSON].message);
      this.code = ERR_RPC_INVALID_JSON;
    }
  };
  var InvalidRequestError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_INVALID_REQUEST].message);
      this.code = ERR_RPC_INVALID_REQUEST;
    }
  };
  var MethodNotFoundError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_INVALID_METHOD].message);
      this.code = ERR_RPC_INVALID_METHOD;
    }
  };
  var InvalidParamsError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_INVALID_PARAMS].message);
      this.code = ERR_RPC_INVALID_PARAMS;
    }
  };
  var InternalError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_INTERNAL_ERROR].message);
      this.code = ERR_RPC_INTERNAL_ERROR;
    }
  };
  var InvalidInputError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_INVALID_INPUT].message);
      this.code = ERR_RPC_INVALID_INPUT;
    }
  };
  var MethodNotSupported = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_UNSUPPORTED_METHOD].message);
      this.code = ERR_RPC_UNSUPPORTED_METHOD;
    }
  };
  var ResourceUnavailableError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_UNAVAILABLE_RESOURCE].message);
      this.code = ERR_RPC_UNAVAILABLE_RESOURCE;
    }
  };
  var ResourcesNotFoundError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_MISSING_RESOURCE].message);
      this.code = ERR_RPC_MISSING_RESOURCE;
    }
  };
  var VersionNotSupportedError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_NOT_SUPPORTED].message);
      this.code = ERR_RPC_NOT_SUPPORTED;
    }
  };
  var TransactionRejectedError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_TRANSACTION_REJECTED].message);
      this.code = ERR_RPC_TRANSACTION_REJECTED;
    }
  };
  var LimitExceededError = class extends RpcError {
    constructor(rpcError) {
      super(rpcError, RpcErrorMessages[ERR_RPC_LIMIT_EXCEEDED].message);
      this.code = ERR_RPC_LIMIT_EXCEEDED;
    }
  };
  var rpcErrorsMap = /* @__PURE__ */ new Map();
  rpcErrorsMap.set(ERR_RPC_INVALID_JSON, { error: ParseError2 });
  rpcErrorsMap.set(ERR_RPC_INVALID_REQUEST, {
    error: InvalidRequestError
  });
  rpcErrorsMap.set(ERR_RPC_INVALID_METHOD, {
    error: MethodNotFoundError
  });
  rpcErrorsMap.set(ERR_RPC_INVALID_PARAMS, { error: InvalidParamsError });
  rpcErrorsMap.set(ERR_RPC_INTERNAL_ERROR, { error: InternalError });
  rpcErrorsMap.set(ERR_RPC_INVALID_INPUT, { error: InvalidInputError });
  rpcErrorsMap.set(ERR_RPC_UNSUPPORTED_METHOD, {
    error: MethodNotSupported
  });
  rpcErrorsMap.set(ERR_RPC_UNAVAILABLE_RESOURCE, {
    error: ResourceUnavailableError
  });
  rpcErrorsMap.set(ERR_RPC_TRANSACTION_REJECTED, {
    error: TransactionRejectedError
  });
  rpcErrorsMap.set(ERR_RPC_MISSING_RESOURCE, {
    error: ResourcesNotFoundError
  });
  rpcErrorsMap.set(ERR_RPC_NOT_SUPPORTED, {
    error: VersionNotSupportedError
  });
  rpcErrorsMap.set(ERR_RPC_LIMIT_EXCEEDED, { error: LimitExceededError });

  // ../../node_modules/.pnpm/web3-errors@1.1.4/node_modules/web3-errors/lib/esm/errors/schema_errors.js
  var SchemaFormatError = class extends BaseWeb3Error {
    constructor(type) {
      super(`Format for the type ${type} is unsupported`);
      this.type = type;
      this.code = ERR_SCHEMA_FORMAT;
    }
    toJSON() {
      return Object.assign(Object.assign({}, super.toJSON()), { type: this.type });
    }
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/index.js
  var esm_exports = {};
  __export(esm_exports, {
    ChunkResponseParser: () => ChunkResponseParser,
    Eip1193Provider: () => Eip1193Provider,
    EventEmitter: () => EventEmitter2,
    SocketProvider: () => SocketProvider,
    Web3DeferredPromise: () => Web3DeferredPromise,
    asciiToHex: () => asciiToHex,
    bytesToHex: () => bytesToHex2,
    bytesToUint8Array: () => bytesToUint8Array,
    checkAddressCheckSum: () => checkAddressCheckSum2,
    compareBlockNumbers: () => compareBlockNumbers,
    convert: () => convert,
    convertScalarValue: () => convertScalarValue,
    encodePacked: () => encodePacked,
    ethUnitMap: () => ethUnitMap,
    format: () => format4,
    fromAscii: () => fromAscii,
    fromDecimal: () => fromDecimal,
    fromTwosComplement: () => fromTwosComplement,
    fromUtf8: () => fromUtf8,
    fromWei: () => fromWei,
    getStorageSlotNumForLongString: () => getStorageSlotNumForLongString,
    hexToAscii: () => hexToAscii,
    hexToBytes: () => hexToBytes2,
    hexToNumber: () => hexToNumber2,
    hexToNumberString: () => hexToNumberString,
    hexToString: () => hexToString,
    hexToUtf8: () => hexToUtf8,
    isAddress: () => isAddress2,
    isBatchRequest: () => isBatchRequest,
    isBatchResponse: () => isBatchResponse,
    isBloom: () => isBloom2,
    isContractAddressInBloom: () => isContractAddressInBloom2,
    isContractInitOptions: () => isContractInitOptions,
    isDataFormat: () => isDataFormat,
    isHex: () => isHex2,
    isHexStrict: () => isHexStrict2,
    isInBloom: () => isInBloom2,
    isNullish: () => isNullish2,
    isPromise: () => isPromise,
    isResponseRpcError: () => isResponseRpcError,
    isResponseWithError: () => isResponseWithError2,
    isResponseWithNotification: () => isResponseWithNotification,
    isResponseWithResult: () => isResponseWithResult,
    isSubscriptionResult: () => isSubscriptionResult,
    isTopic: () => isTopic2,
    isTopicInBloom: () => isTopicInBloom2,
    isUserEthereumAddressInBloom: () => isUserEthereumAddressInBloom2,
    isValidResponse: () => isValidResponse,
    jsonRpc: () => json_rpc_exports,
    keccak256: () => keccak256Wrapper,
    keccak256Wrapper: () => keccak256Wrapper,
    leftPad: () => leftPad,
    mergeDeep: () => mergeDeep,
    numberToHex: () => numberToHex2,
    padLeft: () => padLeft2,
    padRight: () => padRight,
    pollTillDefined: () => pollTillDefined,
    pollTillDefinedAndReturnIntervalId: () => pollTillDefinedAndReturnIntervalId,
    processSolidityEncodePackedArgs: () => processSolidityEncodePackedArgs,
    randomBytes: () => randomBytes2,
    randomHex: () => randomHex,
    rejectIfConditionAtInterval: () => rejectIfConditionAtInterval,
    rejectIfTimeout: () => rejectIfTimeout,
    rightPad: () => rightPad,
    setRequestIdStart: () => setRequestIdStart,
    sha3: () => sha3,
    sha3Raw: () => sha3Raw,
    soliditySha3: () => soliditySha3,
    soliditySha3Raw: () => soliditySha3Raw,
    stringToHex: () => stringToHex,
    toAscii: () => toAscii,
    toBatchPayload: () => toBatchPayload,
    toBigInt: () => toBigInt,
    toBool: () => toBool,
    toChecksumAddress: () => toChecksumAddress,
    toDecimal: () => toDecimal,
    toHex: () => toHex,
    toNumber: () => toNumber2,
    toPayload: () => toPayload,
    toTwosComplement: () => toTwosComplement,
    toUtf8: () => toUtf8,
    toWei: () => toWei,
    uint8ArrayConcat: () => uint8ArrayConcat,
    uint8ArrayEquals: () => uint8ArrayEquals,
    utf8ToBytes: () => utf8ToBytes2,
    utf8ToHex: () => utf8ToHex,
    uuidV4: () => uuidV4,
    validateResponse: () => validateResponse,
    waitWithTimeout: () => waitWithTimeout
  });

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/_assert.js
  function number(n2) {
    if (!Number.isSafeInteger(n2) || n2 < 0)
      throw new Error(`Wrong positive integer: ${n2}`);
  }
  function bool(b) {
    if (typeof b !== "boolean")
      throw new Error(`Expected boolean, not ${b}`);
  }
  function bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array))
      throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length))
      throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
  }
  function hash(hash2) {
    if (typeof hash2 !== "function" || typeof hash2.create !== "function")
      throw new Error("Hash should be wrapped by utils.wrapConstructor");
    number(hash2.outputLen);
    number(hash2.blockLen);
  }
  function exists3(instance, checkFinished = true) {
    if (instance.destroyed)
      throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished)
      throw new Error("Hash#digest() has already been called");
  }
  function output2(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) {
      throw new Error(`digestInto() expects output buffer of length at least ${min}`);
    }
  }
  var assert = {
    number,
    bool,
    bytes,
    hash,
    exists: exists3,
    output: output2
  };
  var assert_default = assert;

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/_u64.js
  var U32_MASK64 = BigInt(2 ** 32 - 1);
  var _32n = BigInt(32);
  function fromBig(n2, le = false) {
    if (le)
      return { h: Number(n2 & U32_MASK64), l: Number(n2 >> _32n & U32_MASK64) };
    return { h: Number(n2 >> _32n & U32_MASK64) | 0, l: Number(n2 & U32_MASK64) | 0 };
  }
  function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for (let i2 = 0; i2 < lst.length; i2++) {
      const { h, l } = fromBig(lst[i2], le);
      [Ah[i2], Al[i2]] = [h, l];
    }
    return [Ah, Al];
  }
  var toBig = (h, l) => BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
  var shrSH = (h, l, s2) => h >>> s2;
  var shrSL = (h, l, s2) => h << 32 - s2 | l >>> s2;
  var rotrSH = (h, l, s2) => h >>> s2 | l << 32 - s2;
  var rotrSL = (h, l, s2) => h << 32 - s2 | l >>> s2;
  var rotrBH = (h, l, s2) => h << 64 - s2 | l >>> s2 - 32;
  var rotrBL = (h, l, s2) => h >>> s2 - 32 | l << 64 - s2;
  var rotr32H = (h, l) => l;
  var rotr32L = (h, l) => h;
  var rotlSH = (h, l, s2) => h << s2 | l >>> 32 - s2;
  var rotlSL = (h, l, s2) => l << s2 | h >>> 32 - s2;
  var rotlBH = (h, l, s2) => l << s2 - 32 | h >>> 64 - s2;
  var rotlBL = (h, l, s2) => h << s2 - 32 | l >>> 64 - s2;
  function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return { h: Ah + Bh + (l / 2 ** 32 | 0) | 0, l: l | 0 };
  }
  var add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
  var add3H = (low, Ah, Bh, Ch) => Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
  var add4L = (Al, Bl, Cl, Dl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
  var add4H = (low, Ah, Bh, Ch, Dh) => Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
  var add5L = (Al, Bl, Cl, Dl, El) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
  var add5H = (low, Ah, Bh, Ch, Dh, Eh) => Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
  var u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
  };
  var u64_default = u64;

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/crypto.js
  var crypto2 = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : void 0;

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/utils.js
  var u8a = (a) => a instanceof Uint8Array;
  var u32 = (arr) => new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
  var createView = (arr) => new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
  var rotr = (word, shift) => word << 32 - shift | word >>> shift;
  var isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
  if (!isLE)
    throw new Error("Non little-endian hardware is not supported");
  var hexes = Array.from({ length: 256 }, (v, i2) => i2.toString(16).padStart(2, "0"));
  function utf8ToBytes(str) {
    if (typeof str !== "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str));
  }
  function toBytes(data) {
    if (typeof data === "string")
      data = utf8ToBytes(data);
    if (!u8a(data))
      throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
  }
  function concatBytes(...arrays) {
    const r2 = new Uint8Array(arrays.reduce((sum, a) => sum + a.length, 0));
    let pad = 0;
    arrays.forEach((a) => {
      if (!u8a(a))
        throw new Error("Uint8Array expected");
      r2.set(a, pad);
      pad += a.length;
    });
    return r2;
  }
  var Hash = class {
    // Safe version that clones internal state
    clone() {
      return this._cloneInto();
    }
  };
  var isPlainObject = (obj) => Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
  function checkOpts(defaults3, opts) {
    if (opts !== void 0 && (typeof opts !== "object" || !isPlainObject(opts)))
      throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults3, opts);
    return merged;
  }
  function wrapConstructor(hashCons) {
    const hashC = (msg) => hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = () => hashCons();
    return hashC;
  }
  function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts) => hashCons(opts);
    return hashC;
  }
  function randomBytes(bytesLength = 32) {
    if (crypto2 && typeof crypto2.getRandomValues === "function") {
      return crypto2.getRandomValues(new Uint8Array(bytesLength));
    }
    throw new Error("crypto.getRandomValues must be defined");
  }

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/sha3.js
  var [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [[], [], []];
  var _0n = BigInt(0);
  var _1n = BigInt(1);
  var _2n = BigInt(2);
  var _7n = BigInt(7);
  var _256n = BigInt(256);
  var _0x71n = BigInt(113);
  for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
    [x, y] = [y, (2 * x + 3 * y) % 5];
    SHA3_PI.push(2 * (5 * y + x));
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    let t2 = _0n;
    for (let j = 0; j < 7; j++) {
      R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
      if (R & _2n)
        t2 ^= _1n << (_1n << BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t2);
  }
  var [SHA3_IOTA_H, SHA3_IOTA_L] = u64_default.split(_SHA3_IOTA, true);
  var rotlH = (h, l, s2) => s2 > 32 ? u64_default.rotlBH(h, l, s2) : u64_default.rotlSH(h, l, s2);
  var rotlL = (h, l, s2) => s2 > 32 ? u64_default.rotlBL(h, l, s2) : u64_default.rotlSL(h, l, s2);
  function keccakP(s2, rounds = 24) {
    const B = new Uint32Array(5 * 2);
    for (let round = 24 - rounds; round < 24; round++) {
      for (let x = 0; x < 10; x++)
        B[x] = s2[x] ^ s2[x + 10] ^ s2[x + 20] ^ s2[x + 30] ^ s2[x + 40];
      for (let x = 0; x < 10; x += 2) {
        const idx1 = (x + 8) % 10;
        const idx0 = (x + 2) % 10;
        const B0 = B[idx0];
        const B1 = B[idx0 + 1];
        const Th = rotlH(B0, B1, 1) ^ B[idx1];
        const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
        for (let y = 0; y < 50; y += 10) {
          s2[x + y] ^= Th;
          s2[x + y + 1] ^= Tl;
        }
      }
      let curH = s2[2];
      let curL = s2[3];
      for (let t2 = 0; t2 < 24; t2++) {
        const shift = SHA3_ROTL[t2];
        const Th = rotlH(curH, curL, shift);
        const Tl = rotlL(curH, curL, shift);
        const PI = SHA3_PI[t2];
        curH = s2[PI];
        curL = s2[PI + 1];
        s2[PI] = Th;
        s2[PI + 1] = Tl;
      }
      for (let y = 0; y < 50; y += 10) {
        for (let x = 0; x < 10; x++)
          B[x] = s2[y + x];
        for (let x = 0; x < 10; x++)
          s2[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
      }
      s2[0] ^= SHA3_IOTA_H[round];
      s2[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
  }
  var Keccak = class _Keccak extends Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
      super();
      this.blockLen = blockLen;
      this.suffix = suffix;
      this.outputLen = outputLen;
      this.enableXOF = enableXOF;
      this.rounds = rounds;
      this.pos = 0;
      this.posOut = 0;
      this.finished = false;
      this.destroyed = false;
      assert_default.number(outputLen);
      if (0 >= this.blockLen || this.blockLen >= 200)
        throw new Error("Sha3 supports only keccak-f1600 function");
      this.state = new Uint8Array(200);
      this.state32 = u32(this.state);
    }
    keccak() {
      keccakP(this.state32, this.rounds);
      this.posOut = 0;
      this.pos = 0;
    }
    update(data) {
      assert_default.exists(this);
      const { blockLen, state } = this;
      data = toBytes(data);
      const len = data.length;
      for (let pos = 0; pos < len; ) {
        const take = Math.min(blockLen - this.pos, len - pos);
        for (let i2 = 0; i2 < take; i2++)
          state[this.pos++] ^= data[pos++];
        if (this.pos === blockLen)
          this.keccak();
      }
      return this;
    }
    finish() {
      if (this.finished)
        return;
      this.finished = true;
      const { state, suffix, pos, blockLen } = this;
      state[pos] ^= suffix;
      if ((suffix & 128) !== 0 && pos === blockLen - 1)
        this.keccak();
      state[blockLen - 1] ^= 128;
      this.keccak();
    }
    writeInto(out) {
      assert_default.exists(this, false);
      assert_default.bytes(out);
      this.finish();
      const bufferOut = this.state;
      const { blockLen } = this;
      for (let pos = 0, len = out.length; pos < len; ) {
        if (this.posOut >= blockLen)
          this.keccak();
        const take = Math.min(blockLen - this.posOut, len - pos);
        out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
        this.posOut += take;
        pos += take;
      }
      return out;
    }
    xofInto(out) {
      if (!this.enableXOF)
        throw new Error("XOF is not possible for this instance");
      return this.writeInto(out);
    }
    xof(bytes2) {
      assert_default.number(bytes2);
      return this.xofInto(new Uint8Array(bytes2));
    }
    digestInto(out) {
      assert_default.output(out, this);
      if (this.finished)
        throw new Error("digest() was already called");
      this.writeInto(out);
      this.destroy();
      return out;
    }
    digest() {
      return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
      this.destroyed = true;
      this.state.fill(0);
    }
    _cloneInto(to) {
      const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
      to || (to = new _Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
      to.state32.set(this.state32);
      to.pos = this.pos;
      to.posOut = this.posOut;
      to.finished = this.finished;
      to.rounds = rounds;
      to.suffix = suffix;
      to.outputLen = outputLen;
      to.enableXOF = enableXOF;
      to.destroyed = this.destroyed;
      return to;
    }
  };
  var gen = (suffix, blockLen, outputLen) => wrapConstructor(() => new Keccak(blockLen, suffix, outputLen));
  var sha3_224 = gen(6, 144, 224 / 8);
  var sha3_256 = gen(6, 136, 256 / 8);
  var sha3_384 = gen(6, 104, 384 / 8);
  var sha3_512 = gen(6, 72, 512 / 8);
  var keccak_224 = gen(1, 144, 224 / 8);
  var keccak_256 = gen(1, 136, 256 / 8);
  var keccak_384 = gen(1, 104, 384 / 8);
  var keccak_512 = gen(1, 72, 512 / 8);
  var genShake = (suffix, blockLen, outputLen) => wrapXOFConstructorWithOpts((opts = {}) => new Keccak(blockLen, suffix, opts.dkLen === void 0 ? outputLen : opts.dkLen, true));
  var shake128 = genShake(31, 168, 128 / 8);
  var shake256 = genShake(31, 136, 256 / 8);

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/utils.js
  var assertBool = assert_default.bool;
  var assertBytes = assert_default.bytes;
  function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) {
      throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof data}`);
    }
    return new TextDecoder().decode(data);
  }
  function equalsBytes(a, b) {
    if (a.length !== b.length) {
      return false;
    }
    for (let i2 = 0; i2 < a.length; i2++) {
      if (a[i2] !== b[i2]) {
        return false;
      }
    }
    return true;
  }
  function wrapHash(hash2) {
    return (msg) => {
      assert_default.bytes(msg);
      return hash2(msg);
    };
  }
  var crypto3 = (() => {
    const webCrypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
    const nodeRequire = typeof module !== "undefined" && typeof module.require === "function" && module.require.bind(module);
    return {
      node: nodeRequire && !webCrypto ? nodeRequire("crypto") : void 0,
      web: webCrypto
    };
  })();

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/keccak.js
  var keccak224 = wrapHash(keccak_224);
  var keccak256 = (() => {
    const k = wrapHash(keccak_256);
    k.create = keccak_256.create;
    return k;
  })();
  var keccak384 = wrapHash(keccak_384);
  var keccak512 = wrapHash(keccak_512);

  // ../../node_modules/.pnpm/zod@3.24.1/node_modules/zod/lib/index.mjs
  var util;
  (function(util3) {
    util3.assertEqual = (val) => val;
    function assertIs(_arg) {
    }
    util3.assertIs = assertIs;
    function assertNever(_x) {
      throw new Error();
    }
    util3.assertNever = assertNever;
    util3.arrayToEnum = (items) => {
      const obj = {};
      for (const item of items) {
        obj[item] = item;
      }
      return obj;
    };
    util3.getValidEnumValues = (obj) => {
      const validKeys = util3.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
      const filtered = {};
      for (const k of validKeys) {
        filtered[k] = obj[k];
      }
      return util3.objectValues(filtered);
    };
    util3.objectValues = (obj) => {
      return util3.objectKeys(obj).map(function(e2) {
        return obj[e2];
      });
    };
    util3.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
      const keys = [];
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          keys.push(key);
        }
      }
      return keys;
    };
    util3.find = (arr, checker) => {
      for (const item of arr) {
        if (checker(item))
          return item;
      }
      return void 0;
    };
    util3.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
      return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util3.joinValues = joinValues;
    util3.jsonStringifyReplacer = (_2, value) => {
      if (typeof value === "bigint") {
        return value.toString();
      }
      return value;
    };
  })(util || (util = {}));
  var objectUtil;
  (function(objectUtil3) {
    objectUtil3.mergeShapes = (first, second) => {
      return {
        ...first,
        ...second
        // second overwrites first
      };
    };
  })(objectUtil || (objectUtil = {}));
  var ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
  ]);
  var getParsedType = (data) => {
    const t2 = typeof data;
    switch (t2) {
      case "undefined":
        return ZodParsedType.undefined;
      case "string":
        return ZodParsedType.string;
      case "number":
        return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
      case "boolean":
        return ZodParsedType.boolean;
      case "function":
        return ZodParsedType.function;
      case "bigint":
        return ZodParsedType.bigint;
      case "symbol":
        return ZodParsedType.symbol;
      case "object":
        if (Array.isArray(data)) {
          return ZodParsedType.array;
        }
        if (data === null) {
          return ZodParsedType.null;
        }
        if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
          return ZodParsedType.promise;
        }
        if (typeof Map !== "undefined" && data instanceof Map) {
          return ZodParsedType.map;
        }
        if (typeof Set !== "undefined" && data instanceof Set) {
          return ZodParsedType.set;
        }
        if (typeof Date !== "undefined" && data instanceof Date) {
          return ZodParsedType.date;
        }
        return ZodParsedType.object;
      default:
        return ZodParsedType.unknown;
    }
  };
  var ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
  ]);
  var quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
  };
  var ZodError = class _ZodError extends Error {
    get errors() {
      return this.issues;
    }
    constructor(issues) {
      super();
      this.issues = [];
      this.addIssue = (sub) => {
        this.issues = [...this.issues, sub];
      };
      this.addIssues = (subs = []) => {
        this.issues = [...this.issues, ...subs];
      };
      const actualProto = new.target.prototype;
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(this, actualProto);
      } else {
        this.__proto__ = actualProto;
      }
      this.name = "ZodError";
      this.issues = issues;
    }
    format(_mapper) {
      const mapper = _mapper || function(issue) {
        return issue.message;
      };
      const fieldErrors = { _errors: [] };
      const processError = (error) => {
        for (const issue of error.issues) {
          if (issue.code === "invalid_union") {
            issue.unionErrors.map(processError);
          } else if (issue.code === "invalid_return_type") {
            processError(issue.returnTypeError);
          } else if (issue.code === "invalid_arguments") {
            processError(issue.argumentsError);
          } else if (issue.path.length === 0) {
            fieldErrors._errors.push(mapper(issue));
          } else {
            let curr = fieldErrors;
            let i2 = 0;
            while (i2 < issue.path.length) {
              const el = issue.path[i2];
              const terminal = i2 === issue.path.length - 1;
              if (!terminal) {
                curr[el] = curr[el] || { _errors: [] };
              } else {
                curr[el] = curr[el] || { _errors: [] };
                curr[el]._errors.push(mapper(issue));
              }
              curr = curr[el];
              i2++;
            }
          }
        }
      };
      processError(this);
      return fieldErrors;
    }
    static assert(value) {
      if (!(value instanceof _ZodError)) {
        throw new Error(`Not a ZodError: ${value}`);
      }
    }
    toString() {
      return this.message;
    }
    get message() {
      return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
      return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
      const fieldErrors = {};
      const formErrors = [];
      for (const sub of this.issues) {
        if (sub.path.length > 0) {
          fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
          fieldErrors[sub.path[0]].push(mapper(sub));
        } else {
          formErrors.push(mapper(sub));
        }
      }
      return { formErrors, fieldErrors };
    }
    get formErrors() {
      return this.flatten();
    }
  };
  ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
  };
  var errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
      case ZodIssueCode.invalid_type:
        if (issue.received === ZodParsedType.undefined) {
          message = "Required";
        } else {
          message = `Expected ${issue.expected}, received ${issue.received}`;
        }
        break;
      case ZodIssueCode.invalid_literal:
        message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
        break;
      case ZodIssueCode.unrecognized_keys:
        message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
        break;
      case ZodIssueCode.invalid_union:
        message = `Invalid input`;
        break;
      case ZodIssueCode.invalid_union_discriminator:
        message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
        break;
      case ZodIssueCode.invalid_enum_value:
        message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
        break;
      case ZodIssueCode.invalid_arguments:
        message = `Invalid function arguments`;
        break;
      case ZodIssueCode.invalid_return_type:
        message = `Invalid function return type`;
        break;
      case ZodIssueCode.invalid_date:
        message = `Invalid date`;
        break;
      case ZodIssueCode.invalid_string:
        if (typeof issue.validation === "object") {
          if ("includes" in issue.validation) {
            message = `Invalid input: must include "${issue.validation.includes}"`;
            if (typeof issue.validation.position === "number") {
              message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
            }
          } else if ("startsWith" in issue.validation) {
            message = `Invalid input: must start with "${issue.validation.startsWith}"`;
          } else if ("endsWith" in issue.validation) {
            message = `Invalid input: must end with "${issue.validation.endsWith}"`;
          } else {
            util.assertNever(issue.validation);
          }
        } else if (issue.validation !== "regex") {
          message = `Invalid ${issue.validation}`;
        } else {
          message = "Invalid";
        }
        break;
      case ZodIssueCode.too_small:
        if (issue.type === "array")
          message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
        else if (issue.type === "string")
          message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
        else if (issue.type === "number")
          message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
        else if (issue.type === "date")
          message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
        else
          message = "Invalid input";
        break;
      case ZodIssueCode.too_big:
        if (issue.type === "array")
          message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
        else if (issue.type === "string")
          message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
        else if (issue.type === "number")
          message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
        else if (issue.type === "bigint")
          message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
        else if (issue.type === "date")
          message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
        else
          message = "Invalid input";
        break;
      case ZodIssueCode.custom:
        message = `Invalid input`;
        break;
      case ZodIssueCode.invalid_intersection_types:
        message = `Intersection results could not be merged`;
        break;
      case ZodIssueCode.not_multiple_of:
        message = `Number must be a multiple of ${issue.multipleOf}`;
        break;
      case ZodIssueCode.not_finite:
        message = "Number must be finite";
        break;
      default:
        message = _ctx.defaultError;
        util.assertNever(issue);
    }
    return { message };
  };
  var overrideErrorMap = errorMap;
  function setErrorMap(map) {
    overrideErrorMap = map;
  }
  function getErrorMap() {
    return overrideErrorMap;
  }
  var makeIssue = (params) => {
    const { data, path: path3, errorMaps, issueData } = params;
    const fullPath = [...path3, ...issueData.path || []];
    const fullIssue = {
      ...issueData,
      path: fullPath
    };
    if (issueData.message !== void 0) {
      return {
        ...issueData,
        path: fullPath,
        message: issueData.message
      };
    }
    let errorMessage = "";
    const maps = errorMaps.filter((m) => !!m).slice().reverse();
    for (const map of maps) {
      errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
      ...issueData,
      path: fullPath,
      message: errorMessage
    };
  };
  var EMPTY_PATH = [];
  function addIssueToContext(ctx, issueData) {
    const overrideMap = getErrorMap();
    const issue = makeIssue({
      issueData,
      data: ctx.data,
      path: ctx.path,
      errorMaps: [
        ctx.common.contextualErrorMap,
        // contextual error map is first priority
        ctx.schemaErrorMap,
        // then schema-bound map if available
        overrideMap,
        // then global override map
        overrideMap === errorMap ? void 0 : errorMap
        // then global default map
      ].filter((x) => !!x)
    });
    ctx.common.issues.push(issue);
  }
  var ParseStatus = class _ParseStatus {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      if (this.value === "valid")
        this.value = "dirty";
    }
    abort() {
      if (this.value !== "aborted")
        this.value = "aborted";
    }
    static mergeArray(status, results) {
      const arrayValue = [];
      for (const s2 of results) {
        if (s2.status === "aborted")
          return INVALID;
        if (s2.status === "dirty")
          status.dirty();
        arrayValue.push(s2.value);
      }
      return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
      const syncPairs = [];
      for (const pair of pairs) {
        const key = await pair.key;
        const value = await pair.value;
        syncPairs.push({
          key,
          value
        });
      }
      return _ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
      const finalObject = {};
      for (const pair of pairs) {
        const { key, value } = pair;
        if (key.status === "aborted")
          return INVALID;
        if (value.status === "aborted")
          return INVALID;
        if (key.status === "dirty")
          status.dirty();
        if (value.status === "dirty")
          status.dirty();
        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
          finalObject[key.value] = value.value;
        }
      }
      return { status: status.value, value: finalObject };
    }
  };
  var INVALID = Object.freeze({
    status: "aborted"
  });
  var DIRTY = (value) => ({ status: "dirty", value });
  var OK = (value) => ({ status: "valid", value });
  var isAborted = (x) => x.status === "aborted";
  var isDirty = (x) => x.status === "dirty";
  var isValid2 = (x) => x.status === "valid";
  var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
  function __classPrivateFieldGet4(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
  }
  function __classPrivateFieldSet4(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
  }
  var errorUtil;
  (function(errorUtil3) {
    errorUtil3.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil3.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
  })(errorUtil || (errorUtil = {}));
  var _ZodEnum_cache;
  var _ZodNativeEnum_cache;
  var ParseInputLazyPath = class {
    constructor(parent, value, path3, key) {
      this._cachedPath = [];
      this.parent = parent;
      this.data = value;
      this._path = path3;
      this._key = key;
    }
    get path() {
      if (!this._cachedPath.length) {
        if (this._key instanceof Array) {
          this._cachedPath.push(...this._path, ...this._key);
        } else {
          this._cachedPath.push(...this._path, this._key);
        }
      }
      return this._cachedPath;
    }
  };
  var handleResult = (ctx, result) => {
    if (isValid2(result)) {
      return { success: true, data: result.value };
    } else {
      if (!ctx.common.issues.length) {
        throw new Error("Validation failed but no issues detected.");
      }
      return {
        success: false,
        get error() {
          if (this._error)
            return this._error;
          const error = new ZodError(ctx.common.issues);
          this._error = error;
          return this._error;
        }
      };
    }
  };
  function processCreateParams(params) {
    if (!params)
      return {};
    const { errorMap: errorMap3, invalid_type_error, required_error, description } = params;
    if (errorMap3 && (invalid_type_error || required_error)) {
      throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap3)
      return { errorMap: errorMap3, description };
    const customMap = (iss, ctx) => {
      var _a6, _b3;
      const { message } = params;
      if (iss.code === "invalid_enum_value") {
        return { message: message !== null && message !== void 0 ? message : ctx.defaultError };
      }
      if (typeof ctx.data === "undefined") {
        return { message: (_a6 = message !== null && message !== void 0 ? message : required_error) !== null && _a6 !== void 0 ? _a6 : ctx.defaultError };
      }
      if (iss.code !== "invalid_type")
        return { message: ctx.defaultError };
      return { message: (_b3 = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b3 !== void 0 ? _b3 : ctx.defaultError };
    };
    return { errorMap: customMap, description };
  }
  var ZodType = class {
    get description() {
      return this._def.description;
    }
    _getType(input) {
      return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
      return ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      };
    }
    _processInputParams(input) {
      return {
        status: new ParseStatus(),
        ctx: {
          common: input.parent.common,
          data: input.data,
          parsedType: getParsedType(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        }
      };
    }
    _parseSync(input) {
      const result = this._parse(input);
      if (isAsync(result)) {
        throw new Error("Synchronous parse encountered promise.");
      }
      return result;
    }
    _parseAsync(input) {
      const result = this._parse(input);
      return Promise.resolve(result);
    }
    parse(data, params) {
      const result = this.safeParse(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    }
    safeParse(data, params) {
      var _a6;
      const ctx = {
        common: {
          issues: [],
          async: (_a6 = params === null || params === void 0 ? void 0 : params.async) !== null && _a6 !== void 0 ? _a6 : false,
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const result = this._parseSync({ data, path: ctx.path, parent: ctx });
      return handleResult(ctx, result);
    }
    "~validate"(data) {
      var _a6, _b3;
      const ctx = {
        common: {
          issues: [],
          async: !!this["~standard"].async
        },
        path: [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      if (!this["~standard"].async) {
        try {
          const result = this._parseSync({ data, path: [], parent: ctx });
          return isValid2(result) ? {
            value: result.value
          } : {
            issues: ctx.common.issues
          };
        } catch (err3) {
          if ((_b3 = (_a6 = err3 === null || err3 === void 0 ? void 0 : err3.message) === null || _a6 === void 0 ? void 0 : _a6.toLowerCase()) === null || _b3 === void 0 ? void 0 : _b3.includes("encountered")) {
            this["~standard"].async = true;
          }
          ctx.common = {
            issues: [],
            async: true
          };
        }
      }
      return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid2(result) ? {
        value: result.value
      } : {
        issues: ctx.common.issues
      });
    }
    async parseAsync(data, params) {
      const result = await this.safeParseAsync(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    }
    async safeParseAsync(data, params) {
      const ctx = {
        common: {
          issues: [],
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
          async: true
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
      const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
      return handleResult(ctx, result);
    }
    refine(check, message) {
      const getIssueProperties = (val) => {
        if (typeof message === "string" || typeof message === "undefined") {
          return { message };
        } else if (typeof message === "function") {
          return message(val);
        } else {
          return message;
        }
      };
      return this._refinement((val, ctx) => {
        const result = check(val);
        const setError = () => ctx.addIssue({
          code: ZodIssueCode.custom,
          ...getIssueProperties(val)
        });
        if (typeof Promise !== "undefined" && result instanceof Promise) {
          return result.then((data) => {
            if (!data) {
              setError();
              return false;
            } else {
              return true;
            }
          });
        }
        if (!result) {
          setError();
          return false;
        } else {
          return true;
        }
      });
    }
    refinement(check, refinementData) {
      return this._refinement((val, ctx) => {
        if (!check(val)) {
          ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
          return false;
        } else {
          return true;
        }
      });
    }
    _refinement(refinement) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: { type: "refinement", refinement }
      });
    }
    superRefine(refinement) {
      return this._refinement(refinement);
    }
    constructor(def) {
      this.spa = this.safeParseAsync;
      this._def = def;
      this.parse = this.parse.bind(this);
      this.safeParse = this.safeParse.bind(this);
      this.parseAsync = this.parseAsync.bind(this);
      this.safeParseAsync = this.safeParseAsync.bind(this);
      this.spa = this.spa.bind(this);
      this.refine = this.refine.bind(this);
      this.refinement = this.refinement.bind(this);
      this.superRefine = this.superRefine.bind(this);
      this.optional = this.optional.bind(this);
      this.nullable = this.nullable.bind(this);
      this.nullish = this.nullish.bind(this);
      this.array = this.array.bind(this);
      this.promise = this.promise.bind(this);
      this.or = this.or.bind(this);
      this.and = this.and.bind(this);
      this.transform = this.transform.bind(this);
      this.brand = this.brand.bind(this);
      this.default = this.default.bind(this);
      this.catch = this.catch.bind(this);
      this.describe = this.describe.bind(this);
      this.pipe = this.pipe.bind(this);
      this.readonly = this.readonly.bind(this);
      this.isNullable = this.isNullable.bind(this);
      this.isOptional = this.isOptional.bind(this);
      this["~standard"] = {
        version: 1,
        vendor: "zod",
        validate: (data) => this["~validate"](data)
      };
    }
    optional() {
      return ZodOptional.create(this, this._def);
    }
    nullable() {
      return ZodNullable.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return ZodArray.create(this);
    }
    promise() {
      return ZodPromise.create(this, this._def);
    }
    or(option) {
      return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
      return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
      return new ZodEffects({
        ...processCreateParams(this._def),
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: { type: "transform", transform }
      });
    }
    default(def) {
      const defaultValueFunc = typeof def === "function" ? def : () => def;
      return new ZodDefault({
        ...processCreateParams(this._def),
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodDefault
      });
    }
    brand() {
      return new ZodBranded({
        typeName: ZodFirstPartyTypeKind.ZodBranded,
        type: this,
        ...processCreateParams(this._def)
      });
    }
    catch(def) {
      const catchValueFunc = typeof def === "function" ? def : () => def;
      return new ZodCatch({
        ...processCreateParams(this._def),
        innerType: this,
        catchValue: catchValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodCatch
      });
    }
    describe(description) {
      const This = this.constructor;
      return new This({
        ...this._def,
        description
      });
    }
    pipe(target) {
      return ZodPipeline.create(this, target);
    }
    readonly() {
      return ZodReadonly.create(this);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  };
  var cuidRegex = /^c[^\s-]{8,}$/i;
  var cuid2Regex = /^[0-9a-z]+$/;
  var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
  var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
  var nanoidRegex = /^[a-z0-9_-]{21}$/i;
  var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
  var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
  var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
  var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
  var emojiRegex;
  var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
  var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
  var ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
  var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
  var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
  var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
  var dateRegex = new RegExp(`^${dateRegexSource}$`);
  function timeRegexSource(args) {
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) {
      regex = `${regex}\\.\\d{${args.precision}}`;
    } else if (args.precision == null) {
      regex = `${regex}(\\.\\d+)?`;
    }
    return regex;
  }
  function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
  }
  function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset)
      opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
  }
  function isValidIP(ip, version17) {
    if ((version17 === "v4" || !version17) && ipv4Regex.test(ip)) {
      return true;
    }
    if ((version17 === "v6" || !version17) && ipv6Regex.test(ip)) {
      return true;
    }
    return false;
  }
  function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt))
      return false;
    try {
      const [header] = jwt.split(".");
      const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
      const decoded = JSON.parse(atob(base64));
      if (typeof decoded !== "object" || decoded === null)
        return false;
      if (!decoded.typ || !decoded.alg)
        return false;
      if (alg && decoded.alg !== alg)
        return false;
      return true;
    } catch (_a6) {
      return false;
    }
  }
  function isValidCidr(ip, version17) {
    if ((version17 === "v4" || !version17) && ipv4CidrRegex.test(ip)) {
      return true;
    }
    if ((version17 === "v6" || !version17) && ipv6CidrRegex.test(ip)) {
      return true;
    }
    return false;
  }
  var ZodString = class _ZodString extends ZodType {
    _parse(input) {
      if (this._def.coerce) {
        input.data = String(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.string) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      const status = new ParseStatus();
      let ctx = void 0;
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          if (input.data.length < check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          if (input.data.length > check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "length") {
          const tooBig = input.data.length > check.value;
          const tooSmall = input.data.length < check.value;
          if (tooBig || tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            if (tooBig) {
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: check.value,
                type: "string",
                inclusive: true,
                exact: true,
                message: check.message
              });
            } else if (tooSmall) {
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: check.value,
                type: "string",
                inclusive: true,
                exact: true,
                message: check.message
              });
            }
            status.dirty();
          }
        } else if (check.kind === "email") {
          if (!emailRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "email",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "emoji") {
          if (!emojiRegex) {
            emojiRegex = new RegExp(_emojiRegex, "u");
          }
          if (!emojiRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "emoji",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "uuid") {
          if (!uuidRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "uuid",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "nanoid") {
          if (!nanoidRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "nanoid",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cuid") {
          if (!cuidRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "cuid",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cuid2") {
          if (!cuid2Regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "cuid2",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "ulid") {
          if (!ulidRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "ulid",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "url") {
          try {
            new URL(input.data);
          } catch (_a6) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "url",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "regex") {
          check.regex.lastIndex = 0;
          const testResult = check.regex.test(input.data);
          if (!testResult) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "regex",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "trim") {
          input.data = input.data.trim();
        } else if (check.kind === "includes") {
          if (!input.data.includes(check.value, check.position)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: { includes: check.value, position: check.position },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "toLowerCase") {
          input.data = input.data.toLowerCase();
        } else if (check.kind === "toUpperCase") {
          input.data = input.data.toUpperCase();
        } else if (check.kind === "startsWith") {
          if (!input.data.startsWith(check.value)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: { startsWith: check.value },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "endsWith") {
          if (!input.data.endsWith(check.value)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: { endsWith: check.value },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "datetime") {
          const regex = datetimeRegex(check);
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: "datetime",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "date") {
          const regex = dateRegex;
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: "date",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "time") {
          const regex = timeRegex(check);
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_string,
              validation: "time",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "duration") {
          if (!durationRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "duration",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "ip") {
          if (!isValidIP(input.data, check.version)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "ip",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "jwt") {
          if (!isValidJWT(input.data, check.alg)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "jwt",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cidr") {
          if (!isValidCidr(input.data, check.version)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "cidr",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "base64") {
          if (!base64Regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "base64",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "base64url") {
          if (!base64urlRegex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              validation: "base64url",
              code: ZodIssueCode.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
      return this.refinement((data) => regex.test(data), {
        validation,
        code: ZodIssueCode.invalid_string,
        ...errorUtil.errToObj(message)
      });
    }
    _addCheck(check) {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    email(message) {
      return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
      return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
      return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
      return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    nanoid(message) {
      return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
      return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
      return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
      return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    base64(message) {
      return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
    }
    base64url(message) {
      return this._addCheck({
        kind: "base64url",
        ...errorUtil.errToObj(message)
      });
    }
    jwt(options) {
      return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
    }
    ip(options) {
      return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    cidr(options) {
      return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
      var _a6, _b3;
      if (typeof options === "string") {
        return this._addCheck({
          kind: "datetime",
          precision: null,
          offset: false,
          local: false,
          message: options
        });
      }
      return this._addCheck({
        kind: "datetime",
        precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
        offset: (_a6 = options === null || options === void 0 ? void 0 : options.offset) !== null && _a6 !== void 0 ? _a6 : false,
        local: (_b3 = options === null || options === void 0 ? void 0 : options.local) !== null && _b3 !== void 0 ? _b3 : false,
        ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
      });
    }
    date(message) {
      return this._addCheck({ kind: "date", message });
    }
    time(options) {
      if (typeof options === "string") {
        return this._addCheck({
          kind: "time",
          precision: null,
          message: options
        });
      }
      return this._addCheck({
        kind: "time",
        precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
        ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
      });
    }
    duration(message) {
      return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
    }
    regex(regex, message) {
      return this._addCheck({
        kind: "regex",
        regex,
        ...errorUtil.errToObj(message)
      });
    }
    includes(value, options) {
      return this._addCheck({
        kind: "includes",
        value,
        position: options === null || options === void 0 ? void 0 : options.position,
        ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
      });
    }
    startsWith(value, message) {
      return this._addCheck({
        kind: "startsWith",
        value,
        ...errorUtil.errToObj(message)
      });
    }
    endsWith(value, message) {
      return this._addCheck({
        kind: "endsWith",
        value,
        ...errorUtil.errToObj(message)
      });
    }
    min(minLength, message) {
      return this._addCheck({
        kind: "min",
        value: minLength,
        ...errorUtil.errToObj(message)
      });
    }
    max(maxLength, message) {
      return this._addCheck({
        kind: "max",
        value: maxLength,
        ...errorUtil.errToObj(message)
      });
    }
    length(len, message) {
      return this._addCheck({
        kind: "length",
        value: len,
        ...errorUtil.errToObj(message)
      });
    }
    /**
     * Equivalent to `.min(1)`
     */
    nonempty(message) {
      return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }]
      });
    }
    toLowerCase() {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "toLowerCase" }]
      });
    }
    toUpperCase() {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "toUpperCase" }]
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isDate() {
      return !!this._def.checks.find((ch) => ch.kind === "date");
    }
    get isTime() {
      return !!this._def.checks.find((ch) => ch.kind === "time");
    }
    get isDuration() {
      return !!this._def.checks.find((ch) => ch.kind === "duration");
    }
    get isEmail() {
      return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
      return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
      return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isNANOID() {
      return !!this._def.checks.find((ch) => ch.kind === "nanoid");
    }
    get isCUID() {
      return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
      return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
      return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
      return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get isCIDR() {
      return !!this._def.checks.find((ch) => ch.kind === "cidr");
    }
    get isBase64() {
      return !!this._def.checks.find((ch) => ch.kind === "base64");
    }
    get isBase64url() {
      return !!this._def.checks.find((ch) => ch.kind === "base64url");
    }
    get minLength() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxLength() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2;
    }
  };
  ZodString.create = (params) => {
    var _a6;
    return new ZodString({
      checks: [],
      typeName: ZodFirstPartyTypeKind.ZodString,
      coerce: (_a6 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a6 !== void 0 ? _a6 : false,
      ...processCreateParams(params)
    });
  };
  function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
  }
  var ZodNumber = class _ZodNumber extends ZodType {
    constructor() {
      super(...arguments);
      this.min = this.gte;
      this.max = this.lte;
      this.step = this.multipleOf;
    }
    _parse(input) {
      if (this._def.coerce) {
        input.data = Number(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.number) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.number,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      let ctx = void 0;
      const status = new ParseStatus();
      for (const check of this._def.checks) {
        if (check.kind === "int") {
          if (!util.isInteger(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_type,
              expected: "integer",
              received: "float",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "min") {
          const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
          if (tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "number",
              inclusive: check.inclusive,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
          if (tooBig) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "number",
              inclusive: check.inclusive,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "multipleOf") {
          if (floatSafeRemainder(input.data, check.value) !== 0) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.not_multiple_of,
              multipleOf: check.value,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "finite") {
          if (!Number.isFinite(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.not_finite,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    gte(value, message) {
      return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
      return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
      return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
      return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
      return new _ZodNumber({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind,
            value,
            inclusive,
            message: errorUtil.toString(message)
          }
        ]
      });
    }
    _addCheck(check) {
      return new _ZodNumber({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    int(message) {
      return this._addCheck({
        kind: "int",
        message: errorUtil.toString(message)
      });
    }
    positive(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
    negative(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
    nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
    nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
    multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value,
        message: errorUtil.toString(message)
      });
    }
    finite(message) {
      return this._addCheck({
        kind: "finite",
        message: errorUtil.toString(message)
      });
    }
    safe(message) {
      return this._addCheck({
        kind: "min",
        inclusive: true,
        value: Number.MIN_SAFE_INTEGER,
        message: errorUtil.toString(message)
      })._addCheck({
        kind: "max",
        inclusive: true,
        value: Number.MAX_SAFE_INTEGER,
        message: errorUtil.toString(message)
      });
    }
    get minValue() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxValue() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2;
    }
    get isInt() {
      return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
    }
    get isFinite() {
      let max2 = null, min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
          return true;
        } else if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        } else if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return Number.isFinite(min) && Number.isFinite(max2);
    }
  };
  ZodNumber.create = (params) => {
    return new ZodNumber({
      checks: [],
      typeName: ZodFirstPartyTypeKind.ZodNumber,
      coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
      ...processCreateParams(params)
    });
  };
  var ZodBigInt = class _ZodBigInt extends ZodType {
    constructor() {
      super(...arguments);
      this.min = this.gte;
      this.max = this.lte;
    }
    _parse(input) {
      if (this._def.coerce) {
        try {
          input.data = BigInt(input.data);
        } catch (_a6) {
          return this._getInvalidInput(input);
        }
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.bigint) {
        return this._getInvalidInput(input);
      }
      let ctx = void 0;
      const status = new ParseStatus();
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
          if (tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              type: "bigint",
              minimum: check.value,
              inclusive: check.inclusive,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
          if (tooBig) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              type: "bigint",
              maximum: check.value,
              inclusive: check.inclusive,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "multipleOf") {
          if (input.data % check.value !== BigInt(0)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.not_multiple_of,
              multipleOf: check.value,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    _getInvalidInput(input) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx.parsedType
      });
      return INVALID;
    }
    gte(value, message) {
      return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
      return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
      return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
      return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
      return new _ZodBigInt({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind,
            value,
            inclusive,
            message: errorUtil.toString(message)
          }
        ]
      });
    }
    _addCheck(check) {
      return new _ZodBigInt({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    positive(message) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
    negative(message) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
    nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
    nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
    multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value,
        message: errorUtil.toString(message)
      });
    }
    get minValue() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxValue() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2;
    }
  };
  ZodBigInt.create = (params) => {
    var _a6;
    return new ZodBigInt({
      checks: [],
      typeName: ZodFirstPartyTypeKind.ZodBigInt,
      coerce: (_a6 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a6 !== void 0 ? _a6 : false,
      ...processCreateParams(params)
    });
  };
  var ZodBoolean = class extends ZodType {
    _parse(input) {
      if (this._def.coerce) {
        input.data = Boolean(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.boolean) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.boolean,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodBoolean.create = (params) => {
    return new ZodBoolean({
      typeName: ZodFirstPartyTypeKind.ZodBoolean,
      coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
      ...processCreateParams(params)
    });
  };
  var ZodDate = class _ZodDate extends ZodType {
    _parse(input) {
      if (this._def.coerce) {
        input.data = new Date(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.date) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.date,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      if (isNaN(input.data.getTime())) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_date
        });
        return INVALID;
      }
      const status = new ParseStatus();
      let ctx = void 0;
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          if (input.data.getTime() < check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              message: check.message,
              inclusive: true,
              exact: false,
              minimum: check.value,
              type: "date"
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          if (input.data.getTime() > check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              message: check.message,
              inclusive: true,
              exact: false,
              maximum: check.value,
              type: "date"
            });
            status.dirty();
          }
        } else {
          util.assertNever(check);
        }
      }
      return {
        status: status.value,
        value: new Date(input.data.getTime())
      };
    }
    _addCheck(check) {
      return new _ZodDate({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    min(minDate, message) {
      return this._addCheck({
        kind: "min",
        value: minDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
    max(maxDate, message) {
      return this._addCheck({
        kind: "max",
        value: maxDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
    get minDate() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min != null ? new Date(min) : null;
    }
    get maxDate() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2 != null ? new Date(max2) : null;
    }
  };
  ZodDate.create = (params) => {
    return new ZodDate({
      checks: [],
      coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
      typeName: ZodFirstPartyTypeKind.ZodDate,
      ...processCreateParams(params)
    });
  };
  var ZodSymbol = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.symbol) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.symbol,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodSymbol.create = (params) => {
    return new ZodSymbol({
      typeName: ZodFirstPartyTypeKind.ZodSymbol,
      ...processCreateParams(params)
    });
  };
  var ZodUndefined = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.undefined) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.undefined,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodUndefined.create = (params) => {
    return new ZodUndefined({
      typeName: ZodFirstPartyTypeKind.ZodUndefined,
      ...processCreateParams(params)
    });
  };
  var ZodNull = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.null) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.null,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodNull.create = (params) => {
    return new ZodNull({
      typeName: ZodFirstPartyTypeKind.ZodNull,
      ...processCreateParams(params)
    });
  };
  var ZodAny = class extends ZodType {
    constructor() {
      super(...arguments);
      this._any = true;
    }
    _parse(input) {
      return OK(input.data);
    }
  };
  ZodAny.create = (params) => {
    return new ZodAny({
      typeName: ZodFirstPartyTypeKind.ZodAny,
      ...processCreateParams(params)
    });
  };
  var ZodUnknown = class extends ZodType {
    constructor() {
      super(...arguments);
      this._unknown = true;
    }
    _parse(input) {
      return OK(input.data);
    }
  };
  ZodUnknown.create = (params) => {
    return new ZodUnknown({
      typeName: ZodFirstPartyTypeKind.ZodUnknown,
      ...processCreateParams(params)
    });
  };
  var ZodNever = class extends ZodType {
    _parse(input) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.never,
        received: ctx.parsedType
      });
      return INVALID;
    }
  };
  ZodNever.create = (params) => {
    return new ZodNever({
      typeName: ZodFirstPartyTypeKind.ZodNever,
      ...processCreateParams(params)
    });
  };
  var ZodVoid = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.undefined) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.void,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return OK(input.data);
    }
  };
  ZodVoid.create = (params) => {
    return new ZodVoid({
      typeName: ZodFirstPartyTypeKind.ZodVoid,
      ...processCreateParams(params)
    });
  };
  var ZodArray = class _ZodArray extends ZodType {
    _parse(input) {
      const { ctx, status } = this._processInputParams(input);
      const def = this._def;
      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }
      if (def.exactLength !== null) {
        const tooBig = ctx.data.length > def.exactLength.value;
        const tooSmall = ctx.data.length < def.exactLength.value;
        if (tooBig || tooSmall) {
          addIssueToContext(ctx, {
            code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
            minimum: tooSmall ? def.exactLength.value : void 0,
            maximum: tooBig ? def.exactLength.value : void 0,
            type: "array",
            inclusive: true,
            exact: true,
            message: def.exactLength.message
          });
          status.dirty();
        }
      }
      if (def.minLength !== null) {
        if (ctx.data.length < def.minLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.minLength.message
          });
          status.dirty();
        }
      }
      if (def.maxLength !== null) {
        if (ctx.data.length > def.maxLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.maxLength.message
          });
          status.dirty();
        }
      }
      if (ctx.common.async) {
        return Promise.all([...ctx.data].map((item, i2) => {
          return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i2));
        })).then((result2) => {
          return ParseStatus.mergeArray(status, result2);
        });
      }
      const result = [...ctx.data].map((item, i2) => {
        return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i2));
      });
      return ParseStatus.mergeArray(status, result);
    }
    get element() {
      return this._def.type;
    }
    min(minLength, message) {
      return new _ZodArray({
        ...this._def,
        minLength: { value: minLength, message: errorUtil.toString(message) }
      });
    }
    max(maxLength, message) {
      return new _ZodArray({
        ...this._def,
        maxLength: { value: maxLength, message: errorUtil.toString(message) }
      });
    }
    length(len, message) {
      return new _ZodArray({
        ...this._def,
        exactLength: { value: len, message: errorUtil.toString(message) }
      });
    }
    nonempty(message) {
      return this.min(1, message);
    }
  };
  ZodArray.create = (schema, params) => {
    return new ZodArray({
      type: schema,
      minLength: null,
      maxLength: null,
      exactLength: null,
      typeName: ZodFirstPartyTypeKind.ZodArray,
      ...processCreateParams(params)
    });
  };
  function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
      const newShape = {};
      for (const key in schema.shape) {
        const fieldSchema = schema.shape[key];
        newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
      }
      return new ZodObject({
        ...schema._def,
        shape: () => newShape
      });
    } else if (schema instanceof ZodArray) {
      return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
      });
    } else if (schema instanceof ZodOptional) {
      return ZodOptional.create(deepPartialify(schema.unwrap()));
    } else if (schema instanceof ZodNullable) {
      return ZodNullable.create(deepPartialify(schema.unwrap()));
    } else if (schema instanceof ZodTuple) {
      return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    } else {
      return schema;
    }
  }
  var ZodObject = class _ZodObject extends ZodType {
    constructor() {
      super(...arguments);
      this._cached = null;
      this.nonstrict = this.passthrough;
      this.augment = this.extend;
    }
    _getCached() {
      if (this._cached !== null)
        return this._cached;
      const shape = this._def.shape();
      const keys = util.objectKeys(shape);
      return this._cached = { shape, keys };
    }
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.object) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext(ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx2.parsedType
        });
        return INVALID;
      }
      const { status, ctx } = this._processInputParams(input);
      const { shape, keys: shapeKeys } = this._getCached();
      const extraKeys = [];
      if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
        for (const key in ctx.data) {
          if (!shapeKeys.includes(key)) {
            extraKeys.push(key);
          }
        }
      }
      const pairs = [];
      for (const key of shapeKeys) {
        const keyValidator = shape[key];
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }
      if (this._def.catchall instanceof ZodNever) {
        const unknownKeys = this._def.unknownKeys;
        if (unknownKeys === "passthrough") {
          for (const key of extraKeys) {
            pairs.push({
              key: { status: "valid", value: key },
              value: { status: "valid", value: ctx.data[key] }
            });
          }
        } else if (unknownKeys === "strict") {
          if (extraKeys.length > 0) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.unrecognized_keys,
              keys: extraKeys
            });
            status.dirty();
          }
        } else if (unknownKeys === "strip") ;
        else {
          throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        }
      } else {
        const catchall = this._def.catchall;
        for (const key of extraKeys) {
          const value = ctx.data[key];
          pairs.push({
            key: { status: "valid", value: key },
            value: catchall._parse(
              new ParseInputLazyPath(ctx, value, ctx.path, key)
              //, ctx.child(key), value, getParsedType(value)
            ),
            alwaysSet: key in ctx.data
          });
        }
      }
      if (ctx.common.async) {
        return Promise.resolve().then(async () => {
          const syncPairs = [];
          for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
              key,
              value,
              alwaysSet: pair.alwaysSet
            });
          }
          return syncPairs;
        }).then((syncPairs) => {
          return ParseStatus.mergeObjectSync(status, syncPairs);
        });
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
    get shape() {
      return this._def.shape();
    }
    strict(message) {
      errorUtil.errToObj;
      return new _ZodObject({
        ...this._def,
        unknownKeys: "strict",
        ...message !== void 0 ? {
          errorMap: (issue, ctx) => {
            var _a6, _b3, _c2, _d;
            const defaultError = (_c2 = (_b3 = (_a6 = this._def).errorMap) === null || _b3 === void 0 ? void 0 : _b3.call(_a6, issue, ctx).message) !== null && _c2 !== void 0 ? _c2 : ctx.defaultError;
            if (issue.code === "unrecognized_keys")
              return {
                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
              };
            return {
              message: defaultError
            };
          }
        } : {}
      });
    }
    strip() {
      return new _ZodObject({
        ...this._def,
        unknownKeys: "strip"
      });
    }
    passthrough() {
      return new _ZodObject({
        ...this._def,
        unknownKeys: "passthrough"
      });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
      return new _ZodObject({
        ...this._def,
        shape: () => ({
          ...this._def.shape(),
          ...augmentation
        })
      });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
      const merged = new _ZodObject({
        unknownKeys: merging._def.unknownKeys,
        catchall: merging._def.catchall,
        shape: () => ({
          ...this._def.shape(),
          ...merging._def.shape()
        }),
        typeName: ZodFirstPartyTypeKind.ZodObject
      });
      return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
      return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index2) {
      return new _ZodObject({
        ...this._def,
        catchall: index2
      });
    }
    pick(mask2) {
      const shape = {};
      util.objectKeys(mask2).forEach((key) => {
        if (mask2[key] && this.shape[key]) {
          shape[key] = this.shape[key];
        }
      });
      return new _ZodObject({
        ...this._def,
        shape: () => shape
      });
    }
    omit(mask2) {
      const shape = {};
      util.objectKeys(this.shape).forEach((key) => {
        if (!mask2[key]) {
          shape[key] = this.shape[key];
        }
      });
      return new _ZodObject({
        ...this._def,
        shape: () => shape
      });
    }
    /**
     * @deprecated
     */
    deepPartial() {
      return deepPartialify(this);
    }
    partial(mask2) {
      const newShape = {};
      util.objectKeys(this.shape).forEach((key) => {
        const fieldSchema = this.shape[key];
        if (mask2 && !mask2[key]) {
          newShape[key] = fieldSchema;
        } else {
          newShape[key] = fieldSchema.optional();
        }
      });
      return new _ZodObject({
        ...this._def,
        shape: () => newShape
      });
    }
    required(mask2) {
      const newShape = {};
      util.objectKeys(this.shape).forEach((key) => {
        if (mask2 && !mask2[key]) {
          newShape[key] = this.shape[key];
        } else {
          const fieldSchema = this.shape[key];
          let newField = fieldSchema;
          while (newField instanceof ZodOptional) {
            newField = newField._def.innerType;
          }
          newShape[key] = newField;
        }
      });
      return new _ZodObject({
        ...this._def,
        shape: () => newShape
      });
    }
    keyof() {
      return createZodEnum(util.objectKeys(this.shape));
    }
  };
  ZodObject.create = (shape, params) => {
    return new ZodObject({
      shape: () => shape,
      unknownKeys: "strip",
      catchall: ZodNever.create(),
      typeName: ZodFirstPartyTypeKind.ZodObject,
      ...processCreateParams(params)
    });
  };
  ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
      shape: () => shape,
      unknownKeys: "strict",
      catchall: ZodNever.create(),
      typeName: ZodFirstPartyTypeKind.ZodObject,
      ...processCreateParams(params)
    });
  };
  ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
      shape,
      unknownKeys: "strip",
      catchall: ZodNever.create(),
      typeName: ZodFirstPartyTypeKind.ZodObject,
      ...processCreateParams(params)
    });
  };
  var ZodUnion = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const options = this._def.options;
      function handleResults(results) {
        for (const result of results) {
          if (result.result.status === "valid") {
            return result.result;
          }
        }
        for (const result of results) {
          if (result.result.status === "dirty") {
            ctx.common.issues.push(...result.ctx.common.issues);
            return result.result;
          }
        }
        const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors
        });
        return INVALID;
      }
      if (ctx.common.async) {
        return Promise.all(options.map(async (option) => {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: []
            },
            parent: null
          };
          return {
            result: await option._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            }),
            ctx: childCtx
          };
        })).then(handleResults);
      } else {
        let dirty = void 0;
        const issues = [];
        for (const option of options) {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: []
            },
            parent: null
          };
          const result = option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          });
          if (result.status === "valid") {
            return result;
          } else if (result.status === "dirty" && !dirty) {
            dirty = { result, ctx: childCtx };
          }
          if (childCtx.common.issues.length) {
            issues.push(childCtx.common.issues);
          }
        }
        if (dirty) {
          ctx.common.issues.push(...dirty.ctx.common.issues);
          return dirty.result;
        }
        const unionErrors = issues.map((issues2) => new ZodError(issues2));
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors
        });
        return INVALID;
      }
    }
    get options() {
      return this._def.options;
    }
  };
  ZodUnion.create = (types3, params) => {
    return new ZodUnion({
      options: types3,
      typeName: ZodFirstPartyTypeKind.ZodUnion,
      ...processCreateParams(params)
    });
  };
  var getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
      return getDiscriminator(type.schema);
    } else if (type instanceof ZodEffects) {
      return getDiscriminator(type.innerType());
    } else if (type instanceof ZodLiteral) {
      return [type.value];
    } else if (type instanceof ZodEnum) {
      return type.options;
    } else if (type instanceof ZodNativeEnum) {
      return util.objectValues(type.enum);
    } else if (type instanceof ZodDefault) {
      return getDiscriminator(type._def.innerType);
    } else if (type instanceof ZodUndefined) {
      return [void 0];
    } else if (type instanceof ZodNull) {
      return [null];
    } else if (type instanceof ZodOptional) {
      return [void 0, ...getDiscriminator(type.unwrap())];
    } else if (type instanceof ZodNullable) {
      return [null, ...getDiscriminator(type.unwrap())];
    } else if (type instanceof ZodBranded) {
      return getDiscriminator(type.unwrap());
    } else if (type instanceof ZodReadonly) {
      return getDiscriminator(type.unwrap());
    } else if (type instanceof ZodCatch) {
      return getDiscriminator(type._def.innerType);
    } else {
      return [];
    }
  };
  var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const discriminator = this.discriminator;
      const discriminatorValue = ctx.data[discriminator];
      const option = this.optionsMap.get(discriminatorValue);
      if (!option) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union_discriminator,
          options: Array.from(this.optionsMap.keys()),
          path: [discriminator]
        });
        return INVALID;
      }
      if (ctx.common.async) {
        return option._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      } else {
        return option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
      const optionsMap = /* @__PURE__ */ new Map();
      for (const type of options) {
        const discriminatorValues = getDiscriminator(type.shape[discriminator]);
        if (!discriminatorValues.length) {
          throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
        }
        for (const value of discriminatorValues) {
          if (optionsMap.has(value)) {
            throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
          }
          optionsMap.set(value, type);
        }
      }
      return new _ZodDiscriminatedUnion({
        typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
        discriminator,
        options,
        optionsMap,
        ...processCreateParams(params)
      });
    }
  };
  function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
      return { valid: true, data: a };
    } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
      const bKeys = util.objectKeys(b);
      const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
      const newObj = { ...a, ...b };
      for (const key of sharedKeys) {
        const sharedValue = mergeValues(a[key], b[key]);
        if (!sharedValue.valid) {
          return { valid: false };
        }
        newObj[key] = sharedValue.data;
      }
      return { valid: true, data: newObj };
    } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
      if (a.length !== b.length) {
        return { valid: false };
      }
      const newArray = [];
      for (let index2 = 0; index2 < a.length; index2++) {
        const itemA = a[index2];
        const itemB = b[index2];
        const sharedValue = mergeValues(itemA, itemB);
        if (!sharedValue.valid) {
          return { valid: false };
        }
        newArray.push(sharedValue.data);
      }
      return { valid: true, data: newArray };
    } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
      return { valid: true, data: a };
    } else {
      return { valid: false };
    }
  }
  var ZodIntersection = class extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      const handleParsed = (parsedLeft, parsedRight) => {
        if (isAborted(parsedLeft) || isAborted(parsedRight)) {
          return INVALID;
        }
        const merged = mergeValues(parsedLeft.value, parsedRight.value);
        if (!merged.valid) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_intersection_types
          });
          return INVALID;
        }
        if (isDirty(parsedLeft) || isDirty(parsedRight)) {
          status.dirty();
        }
        return { status: status.value, value: merged.data };
      };
      if (ctx.common.async) {
        return Promise.all([
          this._def.left._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }),
          this._def.right._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          })
        ]).then(([left, right]) => handleParsed(left, right));
      } else {
        return handleParsed(this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }));
      }
    }
  };
  ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
      left,
      right,
      typeName: ZodFirstPartyTypeKind.ZodIntersection,
      ...processCreateParams(params)
    });
  };
  var ZodTuple = class _ZodTuple extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }
      if (ctx.data.length < this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        return INVALID;
      }
      const rest = this._def.rest;
      if (!rest && ctx.data.length > this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        status.dirty();
      }
      const items = [...ctx.data].map((item, itemIndex) => {
        const schema = this._def.items[itemIndex] || this._def.rest;
        if (!schema)
          return null;
        return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
      }).filter((x) => !!x);
      if (ctx.common.async) {
        return Promise.all(items).then((results) => {
          return ParseStatus.mergeArray(status, results);
        });
      } else {
        return ParseStatus.mergeArray(status, items);
      }
    }
    get items() {
      return this._def.items;
    }
    rest(rest) {
      return new _ZodTuple({
        ...this._def,
        rest
      });
    }
  };
  ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
      throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
      items: schemas,
      typeName: ZodFirstPartyTypeKind.ZodTuple,
      rest: null,
      ...processCreateParams(params)
    });
  };
  var ZodRecord = class _ZodRecord extends ZodType {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const pairs = [];
      const keyType = this._def.keyType;
      const valueType = this._def.valueType;
      for (const key in ctx.data) {
        pairs.push({
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
          value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }
      if (ctx.common.async) {
        return ParseStatus.mergeObjectAsync(status, pairs);
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
    get element() {
      return this._def.valueType;
    }
    static create(first, second, third) {
      if (second instanceof ZodType) {
        return new _ZodRecord({
          keyType: first,
          valueType: second,
          typeName: ZodFirstPartyTypeKind.ZodRecord,
          ...processCreateParams(third)
        });
      }
      return new _ZodRecord({
        keyType: ZodString.create(),
        valueType: first,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(second)
      });
    }
  };
  var ZodMap = class extends ZodType {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.map) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.map,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const keyType = this._def.keyType;
      const valueType = this._def.valueType;
      const pairs = [...ctx.data.entries()].map(([key, value], index2) => {
        return {
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index2, "key"])),
          value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index2, "value"]))
        };
      });
      if (ctx.common.async) {
        const finalMap = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            if (key.status === "aborted" || value.status === "aborted") {
              return INVALID;
            }
            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }
            finalMap.set(key.value, value.value);
          }
          return { status: status.value, value: finalMap };
        });
      } else {
        const finalMap = /* @__PURE__ */ new Map();
        for (const pair of pairs) {
          const key = pair.key;
          const value = pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      }
    }
  };
  ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
      valueType,
      keyType,
      typeName: ZodFirstPartyTypeKind.ZodMap,
      ...processCreateParams(params)
    });
  };
  var ZodSet = class _ZodSet extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.set) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.set,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const def = this._def;
      if (def.minSize !== null) {
        if (ctx.data.size < def.minSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.minSize.message
          });
          status.dirty();
        }
      }
      if (def.maxSize !== null) {
        if (ctx.data.size > def.maxSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.maxSize.message
          });
          status.dirty();
        }
      }
      const valueType = this._def.valueType;
      function finalizeSet(elements2) {
        const parsedSet = /* @__PURE__ */ new Set();
        for (const element of elements2) {
          if (element.status === "aborted")
            return INVALID;
          if (element.status === "dirty")
            status.dirty();
          parsedSet.add(element.value);
        }
        return { status: status.value, value: parsedSet };
      }
      const elements = [...ctx.data.values()].map((item, i2) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i2)));
      if (ctx.common.async) {
        return Promise.all(elements).then((elements2) => finalizeSet(elements2));
      } else {
        return finalizeSet(elements);
      }
    }
    min(minSize, message) {
      return new _ZodSet({
        ...this._def,
        minSize: { value: minSize, message: errorUtil.toString(message) }
      });
    }
    max(maxSize, message) {
      return new _ZodSet({
        ...this._def,
        maxSize: { value: maxSize, message: errorUtil.toString(message) }
      });
    }
    size(size, message) {
      return this.min(size, message).max(size, message);
    }
    nonempty(message) {
      return this.min(1, message);
    }
  };
  ZodSet.create = (valueType, params) => {
    return new ZodSet({
      valueType,
      minSize: null,
      maxSize: null,
      typeName: ZodFirstPartyTypeKind.ZodSet,
      ...processCreateParams(params)
    });
  };
  var ZodFunction = class _ZodFunction extends ZodType {
    constructor() {
      super(...arguments);
      this.validate = this.implement;
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.function) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.function,
          received: ctx.parsedType
        });
        return INVALID;
      }
      function makeArgsIssue(args, error) {
        return makeIssue({
          data: args,
          path: ctx.path,
          errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap
          ].filter((x) => !!x),
          issueData: {
            code: ZodIssueCode.invalid_arguments,
            argumentsError: error
          }
        });
      }
      function makeReturnsIssue(returns, error) {
        return makeIssue({
          data: returns,
          path: ctx.path,
          errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap
          ].filter((x) => !!x),
          issueData: {
            code: ZodIssueCode.invalid_return_type,
            returnTypeError: error
          }
        });
      }
      const params = { errorMap: ctx.common.contextualErrorMap };
      const fn = ctx.data;
      if (this._def.returns instanceof ZodPromise) {
        const me = this;
        return OK(async function(...args) {
          const error = new ZodError([]);
          const parsedArgs = await me._def.args.parseAsync(args, params).catch((e2) => {
            error.addIssue(makeArgsIssue(args, e2));
            throw error;
          });
          const result = await Reflect.apply(fn, this, parsedArgs);
          const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e2) => {
            error.addIssue(makeReturnsIssue(result, e2));
            throw error;
          });
          return parsedReturns;
        });
      } else {
        const me = this;
        return OK(function(...args) {
          const parsedArgs = me._def.args.safeParse(args, params);
          if (!parsedArgs.success) {
            throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
          }
          const result = Reflect.apply(fn, this, parsedArgs.data);
          const parsedReturns = me._def.returns.safeParse(result, params);
          if (!parsedReturns.success) {
            throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
          }
          return parsedReturns.data;
        });
      }
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...items) {
      return new _ZodFunction({
        ...this._def,
        args: ZodTuple.create(items).rest(ZodUnknown.create())
      });
    }
    returns(returnType) {
      return new _ZodFunction({
        ...this._def,
        returns: returnType
      });
    }
    implement(func) {
      const validatedFunc = this.parse(func);
      return validatedFunc;
    }
    strictImplement(func) {
      const validatedFunc = this.parse(func);
      return validatedFunc;
    }
    static create(args, returns, params) {
      return new _ZodFunction({
        args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
        returns: returns || ZodUnknown.create(),
        typeName: ZodFirstPartyTypeKind.ZodFunction,
        ...processCreateParams(params)
      });
    }
  };
  var ZodLazy = class extends ZodType {
    get schema() {
      return this._def.getter();
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const lazySchema = this._def.getter();
      return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
  };
  ZodLazy.create = (getter, params) => {
    return new ZodLazy({
      getter,
      typeName: ZodFirstPartyTypeKind.ZodLazy,
      ...processCreateParams(params)
    });
  };
  var ZodLiteral = class extends ZodType {
    _parse(input) {
      if (input.data !== this._def.value) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_literal,
          expected: this._def.value
        });
        return INVALID;
      }
      return { status: "valid", value: input.data };
    }
    get value() {
      return this._def.value;
    }
  };
  ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
      value,
      typeName: ZodFirstPartyTypeKind.ZodLiteral,
      ...processCreateParams(params)
    });
  };
  function createZodEnum(values, params) {
    return new ZodEnum({
      values,
      typeName: ZodFirstPartyTypeKind.ZodEnum,
      ...processCreateParams(params)
    });
  }
  var ZodEnum = class _ZodEnum extends ZodType {
    constructor() {
      super(...arguments);
      _ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
      if (typeof input.data !== "string") {
        const ctx = this._getOrReturnCtx(input);
        const expectedValues = this._def.values;
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }
      if (!__classPrivateFieldGet4(this, _ZodEnum_cache, "f")) {
        __classPrivateFieldSet4(this, _ZodEnum_cache, new Set(this._def.values), "f");
      }
      if (!__classPrivateFieldGet4(this, _ZodEnum_cache, "f").has(input.data)) {
        const ctx = this._getOrReturnCtx(input);
        const expectedValues = this._def.values;
        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_enum_value,
          options: expectedValues
        });
        return INVALID;
      }
      return OK(input.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    get Values() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    get Enum() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    extract(values, newDef = this._def) {
      return _ZodEnum.create(values, {
        ...this._def,
        ...newDef
      });
    }
    exclude(values, newDef = this._def) {
      return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
        ...this._def,
        ...newDef
      });
    }
  };
  _ZodEnum_cache = /* @__PURE__ */ new WeakMap();
  ZodEnum.create = createZodEnum;
  var ZodNativeEnum = class extends ZodType {
    constructor() {
      super(...arguments);
      _ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
      const nativeEnumValues = util.getValidEnumValues(this._def.values);
      const ctx = this._getOrReturnCtx(input);
      if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
        const expectedValues = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }
      if (!__classPrivateFieldGet4(this, _ZodNativeEnum_cache, "f")) {
        __classPrivateFieldSet4(this, _ZodNativeEnum_cache, new Set(util.getValidEnumValues(this._def.values)), "f");
      }
      if (!__classPrivateFieldGet4(this, _ZodNativeEnum_cache, "f").has(input.data)) {
        const expectedValues = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_enum_value,
          options: expectedValues
        });
        return INVALID;
      }
      return OK(input.data);
    }
    get enum() {
      return this._def.values;
    }
  };
  _ZodNativeEnum_cache = /* @__PURE__ */ new WeakMap();
  ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
      values,
      typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
      ...processCreateParams(params)
    });
  };
  var ZodPromise = class extends ZodType {
    unwrap() {
      return this._def.type;
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.promise,
          received: ctx.parsedType
        });
        return INVALID;
      }
      const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
      return OK(promisified.then((data) => {
        return this._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap
        });
      }));
    }
  };
  ZodPromise.create = (schema, params) => {
    return new ZodPromise({
      type: schema,
      typeName: ZodFirstPartyTypeKind.ZodPromise,
      ...processCreateParams(params)
    });
  };
  var ZodEffects = class extends ZodType {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      const effect = this._def.effect || null;
      const checkCtx = {
        addIssue: (arg) => {
          addIssueToContext(ctx, arg);
          if (arg.fatal) {
            status.abort();
          } else {
            status.dirty();
          }
        },
        get path() {
          return ctx.path;
        }
      };
      checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
      if (effect.type === "preprocess") {
        const processed = effect.transform(ctx.data, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(processed).then(async (processed2) => {
            if (status.value === "aborted")
              return INVALID;
            const result = await this._def.schema._parseAsync({
              data: processed2,
              path: ctx.path,
              parent: ctx
            });
            if (result.status === "aborted")
              return INVALID;
            if (result.status === "dirty")
              return DIRTY(result.value);
            if (status.value === "dirty")
              return DIRTY(result.value);
            return result;
          });
        } else {
          if (status.value === "aborted")
            return INVALID;
          const result = this._def.schema._parseSync({
            data: processed,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID;
          if (result.status === "dirty")
            return DIRTY(result.value);
          if (status.value === "dirty")
            return DIRTY(result.value);
          return result;
        }
      }
      if (effect.type === "refinement") {
        const executeRefinement = (acc) => {
          const result = effect.refinement(acc, checkCtx);
          if (ctx.common.async) {
            return Promise.resolve(result);
          }
          if (result instanceof Promise) {
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          }
          return acc;
        };
        if (ctx.common.async === false) {
          const inner = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          executeRefinement(inner.value);
          return { status: status.value, value: inner.value };
        } else {
          return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
            if (inner.status === "aborted")
              return INVALID;
            if (inner.status === "dirty")
              status.dirty();
            return executeRefinement(inner.value).then(() => {
              return { status: status.value, value: inner.value };
            });
          });
        }
      }
      if (effect.type === "transform") {
        if (ctx.common.async === false) {
          const base2 = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (!isValid2(base2))
            return base2;
          const result = effect.transform(base2.value, checkCtx);
          if (result instanceof Promise) {
            throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
          }
          return { status: status.value, value: result };
        } else {
          return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base2) => {
            if (!isValid2(base2))
              return base2;
            return Promise.resolve(effect.transform(base2.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
          });
        }
      }
      util.assertNever(effect);
    }
  };
  ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
      schema,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect,
      ...processCreateParams(params)
    });
  };
  ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
      schema,
      effect: { type: "preprocess", transform: preprocess },
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      ...processCreateParams(params)
    });
  };
  var ZodOptional = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType === ZodParsedType.undefined) {
        return OK(void 0);
      }
      return this._def.innerType._parse(input);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodOptional.create = (type, params) => {
    return new ZodOptional({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodOptional,
      ...processCreateParams(params)
    });
  };
  var ZodNullable = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType === ZodParsedType.null) {
        return OK(null);
      }
      return this._def.innerType._parse(input);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodNullable.create = (type, params) => {
    return new ZodNullable({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodNullable,
      ...processCreateParams(params)
    });
  };
  var ZodDefault = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      let data = ctx.data;
      if (ctx.parsedType === ZodParsedType.undefined) {
        data = this._def.defaultValue();
      }
      return this._def.innerType._parse({
        data,
        path: ctx.path,
        parent: ctx
      });
    }
    removeDefault() {
      return this._def.innerType;
    }
  };
  ZodDefault.create = (type, params) => {
    return new ZodDefault({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodDefault,
      defaultValue: typeof params.default === "function" ? params.default : () => params.default,
      ...processCreateParams(params)
    });
  };
  var ZodCatch = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const newCtx = {
        ...ctx,
        common: {
          ...ctx.common,
          issues: []
        }
      };
      const result = this._def.innerType._parse({
        data: newCtx.data,
        path: newCtx.path,
        parent: {
          ...newCtx
        }
      });
      if (isAsync(result)) {
        return result.then((result2) => {
          return {
            status: "valid",
            value: result2.status === "valid" ? result2.value : this._def.catchValue({
              get error() {
                return new ZodError(newCtx.common.issues);
              },
              input: newCtx.data
            })
          };
        });
      } else {
        return {
          status: "valid",
          value: result.status === "valid" ? result.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      }
    }
    removeCatch() {
      return this._def.innerType;
    }
  };
  ZodCatch.create = (type, params) => {
    return new ZodCatch({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodCatch,
      catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
      ...processCreateParams(params)
    });
  };
  var ZodNaN = class extends ZodType {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType.nan) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.nan,
          received: ctx.parsedType
        });
        return INVALID;
      }
      return { status: "valid", value: input.data };
    }
  };
  ZodNaN.create = (params) => {
    return new ZodNaN({
      typeName: ZodFirstPartyTypeKind.ZodNaN,
      ...processCreateParams(params)
    });
  };
  var BRAND = Symbol("zod_brand");
  var ZodBranded = class extends ZodType {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const data = ctx.data;
      return this._def.type._parse({
        data,
        path: ctx.path,
        parent: ctx
      });
    }
    unwrap() {
      return this._def.type;
    }
  };
  var ZodPipeline = class _ZodPipeline extends ZodType {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.common.async) {
        const handleAsync = async () => {
          const inResult = await this._def.in._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inResult.status === "aborted")
            return INVALID;
          if (inResult.status === "dirty") {
            status.dirty();
            return DIRTY(inResult.value);
          } else {
            return this._def.out._parseAsync({
              data: inResult.value,
              path: ctx.path,
              parent: ctx
            });
          }
        };
        return handleAsync();
      } else {
        const inResult = this._def.in._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return {
            status: "dirty",
            value: inResult.value
          };
        } else {
          return this._def.out._parseSync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      }
    }
    static create(a, b) {
      return new _ZodPipeline({
        in: a,
        out: b,
        typeName: ZodFirstPartyTypeKind.ZodPipeline
      });
    }
  };
  var ZodReadonly = class extends ZodType {
    _parse(input) {
      const result = this._def.innerType._parse(input);
      const freeze = (data) => {
        if (isValid2(data)) {
          data.value = Object.freeze(data.value);
        }
        return data;
      };
      return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
      innerType: type,
      typeName: ZodFirstPartyTypeKind.ZodReadonly,
      ...processCreateParams(params)
    });
  };
  function custom(check, params = {}, fatal) {
    if (check)
      return ZodAny.create().superRefine((data, ctx) => {
        var _a6, _b3;
        if (!check(data)) {
          const p12 = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
          const _fatal = (_b3 = (_a6 = p12.fatal) !== null && _a6 !== void 0 ? _a6 : fatal) !== null && _b3 !== void 0 ? _b3 : true;
          const p22 = typeof p12 === "string" ? { message: p12 } : p12;
          ctx.addIssue({ code: "custom", ...p22, fatal: _fatal });
        }
      });
    return ZodAny.create();
  }
  var late = {
    object: ZodObject.lazycreate
  };
  var ZodFirstPartyTypeKind;
  (function(ZodFirstPartyTypeKind3) {
    ZodFirstPartyTypeKind3["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind3["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind3["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind3["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind3["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind3["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind3["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind3["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind3["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind3["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind3["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind3["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind3["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind3["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind3["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind3["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind3["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind3["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind3["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind3["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind3["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind3["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind3["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind3["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind3["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind3["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind3["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind3["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind3["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind3["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind3["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind3["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind3["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind3["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind3["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind3["ZodReadonly"] = "ZodReadonly";
  })(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
  var instanceOfType = (cls, params = {
    message: `Input not instance of ${cls.name}`
  }) => custom((data) => data instanceof cls, params);
  var stringType = ZodString.create;
  var numberType = ZodNumber.create;
  var nanType = ZodNaN.create;
  var bigIntType = ZodBigInt.create;
  var booleanType = ZodBoolean.create;
  var dateType = ZodDate.create;
  var symbolType = ZodSymbol.create;
  var undefinedType = ZodUndefined.create;
  var nullType = ZodNull.create;
  var anyType = ZodAny.create;
  var unknownType = ZodUnknown.create;
  var neverType = ZodNever.create;
  var voidType = ZodVoid.create;
  var arrayType = ZodArray.create;
  var objectType = ZodObject.create;
  var strictObjectType = ZodObject.strictCreate;
  var unionType = ZodUnion.create;
  var discriminatedUnionType = ZodDiscriminatedUnion.create;
  var intersectionType = ZodIntersection.create;
  var tupleType = ZodTuple.create;
  var recordType = ZodRecord.create;
  var mapType = ZodMap.create;
  var setType = ZodSet.create;
  var functionType = ZodFunction.create;
  var lazyType = ZodLazy.create;
  var literalType = ZodLiteral.create;
  var enumType = ZodEnum.create;
  var nativeEnumType = ZodNativeEnum.create;
  var promiseType = ZodPromise.create;
  var effectsType = ZodEffects.create;
  var optionalType = ZodOptional.create;
  var nullableType = ZodNullable.create;
  var preprocessType = ZodEffects.createWithPreprocess;
  var pipelineType = ZodPipeline.create;
  var ostring = () => stringType().optional();
  var onumber = () => numberType().optional();
  var oboolean = () => booleanType().optional();
  var coerce = {
    string: (arg) => ZodString.create({ ...arg, coerce: true }),
    number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
    boolean: (arg) => ZodBoolean.create({
      ...arg,
      coerce: true
    }),
    bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
    date: (arg) => ZodDate.create({ ...arg, coerce: true })
  };
  var NEVER = INVALID;
  var z = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap,
    getErrorMap,
    makeIssue,
    EMPTY_PATH,
    addIssueToContext,
    ParseStatus,
    INVALID,
    DIRTY,
    OK,
    isAborted,
    isDirty,
    isValid: isValid2,
    isAsync,
    get util() {
      return util;
    },
    get objectUtil() {
      return objectUtil;
    },
    ZodParsedType,
    getParsedType,
    ZodType,
    datetimeRegex,
    ZodString,
    ZodNumber,
    ZodBigInt,
    ZodBoolean,
    ZodDate,
    ZodSymbol,
    ZodUndefined,
    ZodNull,
    ZodAny,
    ZodUnknown,
    ZodNever,
    ZodVoid,
    ZodArray,
    ZodObject,
    ZodUnion,
    ZodDiscriminatedUnion,
    ZodIntersection,
    ZodTuple,
    ZodRecord,
    ZodMap,
    ZodSet,
    ZodFunction,
    ZodLazy,
    ZodLiteral,
    ZodEnum,
    ZodNativeEnum,
    ZodPromise,
    ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional,
    ZodNullable,
    ZodDefault,
    ZodCatch,
    ZodNaN,
    BRAND,
    ZodBranded,
    ZodPipeline,
    ZodReadonly,
    custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late,
    get ZodFirstPartyTypeKind() {
      return ZodFirstPartyTypeKind;
    },
    coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    "enum": enumType,
    "function": functionType,
    "instanceof": instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    "null": nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean,
    onumber,
    optional: optionalType,
    ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    "undefined": undefinedType,
    union: unionType,
    unknown: unknownType,
    "void": voidType,
    NEVER,
    ZodIssueCode,
    quotelessJson,
    ZodError
  });

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/errors.js
  var errorFormatter = (error) => {
    if (error.message) {
      return error.message;
    }
    return "unspecified error";
  };
  var Web3ValidatorError = class extends BaseWeb3Error {
    constructor(errors) {
      super();
      this.code = ERR_VALIDATION;
      this.errors = errors;
      super.message = `Web3 validator found ${errors.length} error[s]:
${this._compileErrors().join("\n")}`;
    }
    _compileErrors() {
      return this.errors.map(errorFormatter);
    }
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/utils.js
  var utils_exports = {};
  __export(utils_exports, {
    abiSchemaToJsonSchema: () => abiSchemaToJsonSchema,
    codePointToInt: () => codePointToInt,
    ethAbiToJsonSchema: () => ethAbiToJsonSchema,
    fetchArrayElement: () => fetchArrayElement,
    hexToNumber: () => hexToNumber,
    hexToUint8Array: () => hexToUint8Array,
    numberToHex: () => numberToHex,
    padLeft: () => padLeft,
    parseBaseType: () => parseBaseType,
    transformJsonDataToAbiFormat: () => transformJsonDataToAbiFormat,
    uint8ArrayToHexString: () => uint8ArrayToHexString
  });

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/constants.js
  var VALID_ETH_BASE_TYPES = ["bool", "int", "uint", "bytes", "string", "address", "tuple"];

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/abi.js
  var isAbiParameterSchema = (schema) => typeof schema === "object" && "type" in schema && "name" in schema;

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/string.js
  var isString = (value) => typeof value === "string";
  var isHexStrict = (hex) => typeof hex === "string" && /^((-)?0x[0-9a-f]+|(0x))$/i.test(hex);
  function isHexString(value, length2) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/))
      return false;
    if (typeof length2 !== "undefined" && length2 > 0 && value.length !== 2 + 2 * length2)
      return false;
    return true;
  }
  var isHex = (hex) => typeof hex === "number" || typeof hex === "bigint" || typeof hex === "string" && /^((-0x|0x|-)?[0-9a-f]+|(0x))$/i.test(hex);
  function isHexPrefixed(str) {
    if (typeof str !== "string") {
      throw new Error(`[isHexPrefixed] input must be type 'string', received type ${typeof str}`);
    }
    return str.startsWith("0x");
  }
  var validateNoLeadingZeroes = function(values) {
    for (const [k, v] of Object.entries(values)) {
      if (v !== void 0 && v.length > 0 && v[0] === 0) {
        throw new Error(`${k} cannot have leading zeroes, received: ${v.toString()}`);
      }
    }
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/utils.js
  var extraTypes = ["hex", "number", "blockNumber", "blockNumberOrTag", "filter", "bloom"];
  var parseBaseType = (type) => {
    let strippedType = type.replace(/ /, "");
    let baseTypeSize;
    let isArray2 = false;
    let arraySizes = [];
    if (type.includes("[")) {
      strippedType = strippedType.slice(0, strippedType.indexOf("["));
      arraySizes = [...type.matchAll(/(?:\[(\d*)\])/g)].map((match) => parseInt(match[1], 10)).map((size) => Number.isNaN(size) ? -1 : size);
      isArray2 = arraySizes.length > 0;
    }
    if (VALID_ETH_BASE_TYPES.includes(strippedType)) {
      return { baseType: strippedType, isArray: isArray2, baseTypeSize, arraySizes };
    }
    if (strippedType.startsWith("int")) {
      baseTypeSize = parseInt(strippedType.substring(3), 10);
      strippedType = "int";
    } else if (strippedType.startsWith("uint")) {
      baseTypeSize = parseInt(type.substring(4), 10);
      strippedType = "uint";
    } else if (strippedType.startsWith("bytes")) {
      baseTypeSize = parseInt(strippedType.substring(5), 10);
      strippedType = "bytes";
    } else {
      return { baseType: void 0, isArray: false, baseTypeSize: void 0, arraySizes };
    }
    return { baseType: strippedType, isArray: isArray2, baseTypeSize, arraySizes };
  };
  var convertEthType = (type, parentSchema = {}) => {
    const typePropertyPresent = Object.keys(parentSchema).includes("type");
    if (typePropertyPresent) {
      throw new Web3ValidatorError([
        {
          keyword: "eth",
          message: 'Either "eth" or "type" can be presented in schema',
          params: { eth: type },
          instancePath: "",
          schemaPath: ""
        }
      ]);
    }
    const { baseType, baseTypeSize } = parseBaseType(type);
    if (!baseType && !extraTypes.includes(type)) {
      throw new Web3ValidatorError([
        {
          keyword: "eth",
          message: `Eth data type "${type}" is not valid`,
          params: { eth: type },
          instancePath: "",
          schemaPath: ""
        }
      ]);
    }
    if (baseType) {
      if (baseType === "tuple") {
        throw new Error('"tuple" type is not implemented directly.');
      }
      return { format: `${baseType}${baseTypeSize !== null && baseTypeSize !== void 0 ? baseTypeSize : ""}`, required: true };
    }
    if (type) {
      return { format: type, required: true };
    }
    return {};
  };
  var abiSchemaToJsonSchema = (abis, level2 = "/0") => {
    const schema = {
      type: "array",
      items: [],
      maxItems: abis.length,
      minItems: abis.length
    };
    for (const [index2, abi] of abis.entries()) {
      let abiType;
      let abiName;
      let abiComponents = [];
      if (isAbiParameterSchema(abi)) {
        abiType = abi.type;
        abiName = abi.name;
        abiComponents = abi.components;
      } else if (typeof abi === "string") {
        abiType = abi;
        abiName = `${level2}/${index2}`;
      } else if (Array.isArray(abi)) {
        if (abi[0] && typeof abi[0] === "string" && abi[0].startsWith("tuple") && !Array.isArray(abi[0]) && abi[1] && Array.isArray(abi[1])) {
          abiType = abi[0];
          abiName = `${level2}/${index2}`;
          abiComponents = abi[1];
        } else {
          abiType = "tuple";
          abiName = `${level2}/${index2}`;
          abiComponents = abi;
        }
      }
      const { baseType, isArray: isArray2, arraySizes } = parseBaseType(abiType);
      let childSchema;
      let lastSchema = schema;
      for (let i2 = arraySizes.length - 1; i2 > 0; i2 -= 1) {
        childSchema = {
          type: "array",
          items: [],
          maxItems: arraySizes[i2],
          minItems: arraySizes[i2]
        };
        if (arraySizes[i2] < 0) {
          delete childSchema.maxItems;
          delete childSchema.minItems;
        }
        if (!Array.isArray(lastSchema.items)) {
          lastSchema.items = [lastSchema.items, childSchema];
        } else if (lastSchema.items.length === 0) {
          lastSchema.items = childSchema;
        } else {
          lastSchema.items.push(childSchema);
        }
        lastSchema = childSchema;
      }
      if (baseType === "tuple" && !isArray2) {
        const nestedTuple = abiSchemaToJsonSchema(abiComponents, abiName);
        nestedTuple.$id = abiName;
        lastSchema.items.push(nestedTuple);
      } else if (baseType === "tuple" && isArray2) {
        const arraySize = arraySizes[0];
        const item = {
          $id: abiName,
          type: "array",
          items: abiSchemaToJsonSchema(abiComponents, abiName),
          maxItems: arraySize,
          minItems: arraySize
        };
        if (arraySize < 0) {
          delete item.maxItems;
          delete item.minItems;
        }
        lastSchema.items.push(item);
      } else if (isArray2) {
        const arraySize = arraySizes[0];
        const item = {
          type: "array",
          $id: abiName,
          items: convertEthType(String(baseType)),
          minItems: arraySize,
          maxItems: arraySize
        };
        if (arraySize < 0) {
          delete item.maxItems;
          delete item.minItems;
        }
        lastSchema.items.push(item);
      } else if (Array.isArray(lastSchema.items)) {
        lastSchema.items.push(Object.assign({ $id: abiName }, convertEthType(abiType)));
      } else {
        lastSchema.items.items.push(Object.assign({ $id: abiName }, convertEthType(abiType)));
      }
      lastSchema = schema;
    }
    return schema;
  };
  var ethAbiToJsonSchema = (abis) => abiSchemaToJsonSchema(abis);
  var fetchArrayElement = (data, level2) => {
    if (level2 === 1) {
      return data;
    }
    return fetchArrayElement(data[0], level2 - 1);
  };
  var transformJsonDataToAbiFormat = (abis, data, transformedData) => {
    const newData = [];
    for (const [index2, abi] of abis.entries()) {
      let abiType;
      let abiName;
      let abiComponents = [];
      if (isAbiParameterSchema(abi)) {
        abiType = abi.type;
        abiName = abi.name;
        abiComponents = abi.components;
      } else if (typeof abi === "string") {
        abiType = abi;
      } else if (Array.isArray(abi)) {
        if (abi[1] && Array.isArray(abi[1])) {
          abiType = abi[0];
          abiComponents = abi[1];
        } else {
          abiType = "tuple";
          abiComponents = abi;
        }
      }
      const { baseType, isArray: isArray2, arraySizes } = parseBaseType(abiType);
      const dataItem = Array.isArray(data) ? data[index2] : data[abiName];
      if (baseType === "tuple" && !isArray2) {
        newData.push(transformJsonDataToAbiFormat(abiComponents, dataItem, transformedData));
      } else if (baseType === "tuple" && isArray2) {
        const tupleData = [];
        for (const tupleItem of dataItem) {
          if (arraySizes.length > 1) {
            const nestedItems = fetchArrayElement(tupleItem, arraySizes.length - 1);
            const nestedData = [];
            for (const nestedItem of nestedItems) {
              nestedData.push(transformJsonDataToAbiFormat(abiComponents, nestedItem, transformedData));
            }
            tupleData.push(nestedData);
          } else {
            tupleData.push(transformJsonDataToAbiFormat(abiComponents, tupleItem, transformedData));
          }
        }
        newData.push(tupleData);
      } else {
        newData.push(dataItem);
      }
    }
    transformedData = transformedData !== null && transformedData !== void 0 ? transformedData : [];
    transformedData.push(...newData);
    return transformedData;
  };
  var codePointToInt = (codePoint) => {
    if (codePoint >= 48 && codePoint <= 57) {
      return codePoint - 48;
    }
    if (codePoint >= 65 && codePoint <= 70) {
      return codePoint - 55;
    }
    if (codePoint >= 97 && codePoint <= 102) {
      return codePoint - 87;
    }
    throw new Error(`Invalid code point: ${codePoint}`);
  };
  var hexToNumber = (value) => {
    if (!isHexStrict(value)) {
      throw new Error("Invalid hex string");
    }
    const [negative, hexValue] = value.startsWith("-") ? [true, value.slice(1)] : [false, value];
    const num = BigInt(hexValue);
    if (num > Number.MAX_SAFE_INTEGER) {
      return negative ? -num : num;
    }
    if (num < Number.MIN_SAFE_INTEGER) {
      return num;
    }
    return negative ? -1 * Number(num) : Number(num);
  };
  var numberToHex = (value) => {
    if ((typeof value === "number" || typeof value === "bigint") && value < 0) {
      return `-0x${value.toString(16).slice(1)}`;
    }
    if ((typeof value === "number" || typeof value === "bigint") && value >= 0) {
      return `0x${value.toString(16)}`;
    }
    if (typeof value === "string" && isHexStrict(value)) {
      const [negative, hex] = value.startsWith("-") ? [true, value.slice(1)] : [false, value];
      const hexValue = hex.split(/^(-)?0(x|X)/).slice(-1)[0];
      return `${negative ? "-" : ""}0x${hexValue.replace(/^0+/, "").toLowerCase()}`;
    }
    if (typeof value === "string" && !isHexStrict(value)) {
      return numberToHex(BigInt(value));
    }
    throw new InvalidNumberError(value);
  };
  var padLeft = (value, characterAmount, sign6 = "0") => {
    if (typeof value === "string" && !isHexStrict(value)) {
      return value.padStart(characterAmount, sign6);
    }
    const hex = typeof value === "string" && isHexStrict(value) ? value : numberToHex(value);
    const [prefix, hexValue] = hex.startsWith("-") ? ["-0x", hex.slice(3)] : ["0x", hex.slice(2)];
    return `${prefix}${hexValue.padStart(characterAmount, sign6)}`;
  };
  function uint8ArrayToHexString(uint8Array) {
    let hexString = "0x";
    for (const e2 of uint8Array) {
      const hex = e2.toString(16);
      hexString += hex.length === 1 ? `0${hex}` : hex;
    }
    return hexString;
  }
  function hexToUint8Array(hex) {
    let value;
    if (hex.toLowerCase().startsWith("0x")) {
      value = hex.slice(2);
    } else {
      value = hex;
    }
    if (value.length % 2 !== 0) {
      throw new InvalidBytesError(`hex string has odd length: ${hex}`);
    }
    const bytes2 = new Uint8Array(Math.ceil(value.length / 2));
    for (let i2 = 0; i2 < bytes2.length; i2 += 1) {
      const byte = parseInt(value.substring(i2 * 2, i2 * 2 + 2), 16);
      bytes2[i2] = byte;
    }
    return bytes2;
  }

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/address.js
  var checkAddressCheckSum = (data) => {
    if (!/^(0x)?[0-9a-f]{40}$/i.test(data))
      return false;
    const address = data.slice(2);
    const updatedData = utf8ToBytes(address.toLowerCase());
    const addressHash = uint8ArrayToHexString(keccak256(updatedData)).slice(2);
    for (let i2 = 0; i2 < 40; i2 += 1) {
      if (parseInt(addressHash[i2], 16) > 7 && address[i2].toUpperCase() !== address[i2] || parseInt(addressHash[i2], 16) <= 7 && address[i2].toLowerCase() !== address[i2]) {
        return false;
      }
    }
    return true;
  };
  var isAddress = (value, checkChecksum = true) => {
    if (typeof value !== "string" && !(value instanceof Uint8Array)) {
      return false;
    }
    let valueToCheck;
    if (value instanceof Uint8Array) {
      valueToCheck = uint8ArrayToHexString(value);
    } else if (typeof value === "string" && !isHexStrict(value)) {
      valueToCheck = value.toLowerCase().startsWith("0x") ? value : `0x${value}`;
    } else {
      valueToCheck = value;
    }
    if (!/^(0x)?[0-9a-f]{40}$/i.test(valueToCheck)) {
      return false;
    }
    if (/^(0x|0X)?[0-9a-f]{40}$/.test(valueToCheck) || /^(0x|0X)?[0-9A-F]{40}$/.test(valueToCheck)) {
      return true;
    }
    return checkChecksum ? checkAddressCheckSum(valueToCheck) : true;
  };

  // ../../node_modules/.pnpm/web3-types@1.3.1/node_modules/web3-types/lib/esm/data_format_types.js
  var FMT_NUMBER;
  (function(FMT_NUMBER2) {
    FMT_NUMBER2["NUMBER"] = "NUMBER_NUMBER";
    FMT_NUMBER2["HEX"] = "NUMBER_HEX";
    FMT_NUMBER2["STR"] = "NUMBER_STR";
    FMT_NUMBER2["BIGINT"] = "NUMBER_BIGINT";
  })(FMT_NUMBER || (FMT_NUMBER = {}));
  var FMT_BYTES;
  (function(FMT_BYTES2) {
    FMT_BYTES2["HEX"] = "BYTES_HEX";
    FMT_BYTES2["UINT8ARRAY"] = "BYTES_UINT8ARRAY";
  })(FMT_BYTES || (FMT_BYTES = {}));
  var DEFAULT_RETURN_FORMAT = { number: FMT_NUMBER.BIGINT, bytes: FMT_BYTES.HEX };
  var ETH_DATA_FORMAT = { number: FMT_NUMBER.HEX, bytes: FMT_BYTES.HEX };

  // ../../node_modules/.pnpm/web3-types@1.3.1/node_modules/web3-types/lib/esm/eth_types.js
  var BlockTags;
  (function(BlockTags2) {
    BlockTags2["EARLIEST"] = "earliest";
    BlockTags2["LATEST"] = "latest";
    BlockTags2["PENDING"] = "pending";
    BlockTags2["SAFE"] = "safe";
    BlockTags2["FINALIZED"] = "finalized";
  })(BlockTags || (BlockTags = {}));
  var HardforksOrdered;
  (function(HardforksOrdered2) {
    HardforksOrdered2["chainstart"] = "chainstart";
    HardforksOrdered2["frontier"] = "frontier";
    HardforksOrdered2["homestead"] = "homestead";
    HardforksOrdered2["dao"] = "dao";
    HardforksOrdered2["tangerineWhistle"] = "tangerineWhistle";
    HardforksOrdered2["spuriousDragon"] = "spuriousDragon";
    HardforksOrdered2["byzantium"] = "byzantium";
    HardforksOrdered2["constantinople"] = "constantinople";
    HardforksOrdered2["petersburg"] = "petersburg";
    HardforksOrdered2["istanbul"] = "istanbul";
    HardforksOrdered2["muirGlacier"] = "muirGlacier";
    HardforksOrdered2["berlin"] = "berlin";
    HardforksOrdered2["london"] = "london";
    HardforksOrdered2["altair"] = "altair";
    HardforksOrdered2["arrowGlacier"] = "arrowGlacier";
    HardforksOrdered2["grayGlacier"] = "grayGlacier";
    HardforksOrdered2["bellatrix"] = "bellatrix";
    HardforksOrdered2["merge"] = "merge";
    HardforksOrdered2["capella"] = "capella";
    HardforksOrdered2["shanghai"] = "shanghai";
  })(HardforksOrdered || (HardforksOrdered = {}));

  // ../../node_modules/.pnpm/web3-types@1.3.1/node_modules/web3-types/lib/esm/primitives_types.js
  var TypedArray = Object.getPrototypeOf(Uint8Array);

  // ../../node_modules/.pnpm/web3-types@1.3.1/node_modules/web3-types/lib/esm/web3_base_provider.js
  var __awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var symbol = Symbol.for("web3/base-provider");
  var Web3BaseProvider = class _Web3BaseProvider {
    static isWeb3Provider(provider) {
      return provider instanceof _Web3BaseProvider || Boolean(provider && provider[symbol]);
    }
    // To match an object "instanceof" does not work if
    // matcher class and object is using different package versions
    // to overcome this bottleneck used this approach.
    // The symbol value for one string will always remain same regardless of package versions
    // eslint-disable-next-line class-methods-use-this
    get [symbol]() {
      return true;
    }
    /**
     * @deprecated Please use `.request` instead.
     * @param payload - Request Payload
     * @param callback - Callback
     */
    send(payload, callback) {
      this.request(payload).then((response) => {
        callback(null, response);
      }).catch((err3) => {
        callback(err3);
      });
    }
    /**
     * @deprecated Please use `.request` instead.
     * @param payload - Request Payload
     */
    sendAsync(payload) {
      return __awaiter(this, void 0, void 0, function* () {
        return this.request(payload);
      });
    }
    /**
     * Modify the return type of the request method to be fully compatible with EIP-1193
     *
     * [deprecated] In the future major releases (\>= v5) all providers are supposed to be fully compatible with EIP-1193.
     * So this method will not be needed and would not be available in the future.
     *
     * @returns A new instance of the provider with the request method fully compatible with EIP-1193
     *
     * @example
     * ```ts
     * const provider = new Web3HttpProvider('http://localhost:8545');
     * const fullyCompatibleProvider = provider.asEIP1193Provider();
     * const result = await fullyCompatibleProvider.request({ method: 'eth_getBalance' });
     * console.log(result); // '0x0234c8a3397aab58' or something like that
     * ```
     */
    asEIP1193Provider() {
      const newObj = Object.create(this);
      const originalRequest = newObj.request;
      newObj.request = function request4(args) {
        return __awaiter(this, void 0, void 0, function* () {
          const response = yield originalRequest(args);
          return response.result;
        });
      };
      newObj.asEIP1193Provider = void 0;
      return newObj;
    }
  };

  // ../../node_modules/.pnpm/web3-types@1.3.1/node_modules/web3-types/lib/esm/web3_base_wallet.js
  var Web3BaseWallet = class extends Array {
    constructor(accountProvider) {
      super();
      this._accountProvider = accountProvider;
    }
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/numbers.js
  var bigintPower = (base2, expo) => {
    let res = base2;
    for (let index2 = 1; index2 < expo; index2 += 1) {
      res *= base2;
    }
    return res;
  };
  var isUInt = (value, options = {
    abiType: "uint"
  }) => {
    if (!["number", "string", "bigint"].includes(typeof value) || typeof value === "string" && value.length === 0) {
      return false;
    }
    let size;
    if (options === null || options === void 0 ? void 0 : options.abiType) {
      const { baseTypeSize } = parseBaseType(options.abiType);
      if (baseTypeSize) {
        size = baseTypeSize;
      }
    } else if (options.bitSize) {
      size = options.bitSize;
    }
    const maxSize = bigintPower(BigInt(2), BigInt(size !== null && size !== void 0 ? size : 256)) - BigInt(1);
    try {
      const valueToCheck = typeof value === "string" && isHexStrict(value) ? BigInt(hexToNumber(value)) : BigInt(value);
      return valueToCheck >= 0 && valueToCheck <= maxSize;
    } catch (error) {
      return false;
    }
  };
  var isInt = (value, options = {
    abiType: "int"
  }) => {
    if (!["number", "string", "bigint"].includes(typeof value)) {
      return false;
    }
    if (typeof value === "number" && value > Number.MAX_SAFE_INTEGER) {
      return false;
    }
    let size;
    if (options === null || options === void 0 ? void 0 : options.abiType) {
      const { baseTypeSize, baseType } = parseBaseType(options.abiType);
      if (baseType !== "int") {
        return false;
      }
      if (baseTypeSize) {
        size = baseTypeSize;
      }
    } else if (options.bitSize) {
      size = options.bitSize;
    }
    const maxSize = bigintPower(BigInt(2), BigInt((size !== null && size !== void 0 ? size : 256) - 1));
    const minSize = BigInt(-1) * bigintPower(BigInt(2), BigInt((size !== null && size !== void 0 ? size : 256) - 1));
    try {
      const valueToCheck = typeof value === "string" && isHexStrict(value) ? BigInt(hexToNumber(value)) : BigInt(value);
      return valueToCheck >= minSize && valueToCheck <= maxSize;
    } catch (error) {
      return false;
    }
  };
  var isNumber = (value) => {
    if (isInt(value)) {
      return true;
    }
    if (typeof value === "string" && /[0-9.]/.test(value) && value.indexOf(".") === value.lastIndexOf(".")) {
      return true;
    }
    if (typeof value === "number") {
      return true;
    }
    return false;
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/block.js
  var isBlockNumber = (value) => isUInt(value);
  var isBlockTag = (value) => Object.values(BlockTags).includes(value);
  var isBlockNumberOrTag = (value) => isBlockTag(value) || isBlockNumber(value);

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/bloom.js
  var isBloom = (bloom) => {
    if (typeof bloom !== "string") {
      return false;
    }
    if (!/^(0x)?[0-9a-f]{512}$/i.test(bloom)) {
      return false;
    }
    if (/^(0x)?[0-9a-f]{512}$/.test(bloom) || /^(0x)?[0-9A-F]{512}$/.test(bloom)) {
      return true;
    }
    return false;
  };
  var isInBloom = (bloom, value) => {
    if (typeof value === "string" && !isHexStrict(value)) {
      return false;
    }
    if (!isBloom(bloom)) {
      return false;
    }
    const uint8Array = typeof value === "string" ? hexToUint8Array(value) : value;
    const hash2 = uint8ArrayToHexString(keccak256(uint8Array)).slice(2);
    for (let i2 = 0; i2 < 12; i2 += 4) {
      const bitpos = (
        // eslint-disable-next-line no-bitwise
        (parseInt(hash2.slice(i2, i2 + 2), 16) << 8) + parseInt(hash2.slice(i2 + 2, i2 + 4), 16) & 2047
      );
      const code = codePointToInt(bloom.charCodeAt(bloom.length - 1 - Math.floor(bitpos / 4)));
      const offset = 1 << bitpos % 4;
      if ((code & offset) !== offset) {
        return false;
      }
    }
    return true;
  };
  var isUserEthereumAddressInBloom = (bloom, ethereumAddress) => {
    if (!isBloom(bloom)) {
      return false;
    }
    if (!isAddress(ethereumAddress)) {
      return false;
    }
    const address = padLeft(ethereumAddress, 64);
    return isInBloom(bloom, address);
  };
  var isContractAddressInBloom = (bloom, contractAddress) => {
    if (!isBloom(bloom)) {
      return false;
    }
    if (!isAddress(contractAddress)) {
      return false;
    }
    return isInBloom(bloom, contractAddress);
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/boolean.js
  var isBoolean = (value) => {
    if (!["number", "string", "boolean"].includes(typeof value)) {
      return false;
    }
    if (typeof value === "boolean") {
      return true;
    }
    if (typeof value === "string" && !isHexStrict(value)) {
      return value === "1" || value === "0";
    }
    if (typeof value === "string" && isHexStrict(value)) {
      return value === "0x1" || value === "0x0";
    }
    return value === 1 || value === 0;
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/bytes.js
  var isBytes = (value, options = {
    abiType: "bytes"
  }) => {
    if (typeof value !== "string" && !Array.isArray(value) && !(value instanceof Uint8Array)) {
      return false;
    }
    if (typeof value === "string" && isHexStrict(value) && value.startsWith("-")) {
      return false;
    }
    if (typeof value === "string" && !isHexStrict(value)) {
      return false;
    }
    let valueToCheck;
    if (typeof value === "string") {
      if (value.length % 2 !== 0) {
        return false;
      }
      valueToCheck = hexToUint8Array(value);
    } else if (Array.isArray(value)) {
      if (value.some((d) => d < 0 || d > 255 || !Number.isInteger(d))) {
        return false;
      }
      valueToCheck = new Uint8Array(value);
    } else {
      valueToCheck = value;
    }
    if (options === null || options === void 0 ? void 0 : options.abiType) {
      const { baseTypeSize } = parseBaseType(options.abiType);
      return baseTypeSize ? valueToCheck.length === baseTypeSize : true;
    }
    if (options === null || options === void 0 ? void 0 : options.size) {
      return valueToCheck.length === (options === null || options === void 0 ? void 0 : options.size);
    }
    return true;
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/object.js
  var isNullish = (item) => (
    // Using "null" value intentionally for validation
    // eslint-disable-next-line no-null/no-null
    item === void 0 || item === null
  );
  var isObject = (item) => typeof item === "object" && !isNullish(item) && !Array.isArray(item) && !(item instanceof TypedArray);

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/topic.js
  var isTopic = (topic) => {
    if (typeof topic !== "string") {
      return false;
    }
    if (!/^(0x)?[0-9a-f]{64}$/i.test(topic)) {
      return false;
    }
    if (/^(0x)?[0-9a-f]{64}$/.test(topic) || /^(0x)?[0-9A-F]{64}$/.test(topic)) {
      return true;
    }
    return false;
  };
  var isTopicInBloom = (bloom, topic) => {
    if (!isBloom(bloom)) {
      return false;
    }
    if (!isTopic(topic)) {
      return false;
    }
    return isInBloom(bloom, topic);
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validation/filter.js
  var isFilterObject = (value) => {
    const expectedFilterProperties = [
      "fromBlock",
      "toBlock",
      "address",
      "topics",
      "blockHash"
    ];
    if (isNullish(value) || typeof value !== "object")
      return false;
    if (!Object.keys(value).every((property) => expectedFilterProperties.includes(property)))
      return false;
    if (!isNullish(value.fromBlock) && !isBlockNumberOrTag(value.fromBlock) || !isNullish(value.toBlock) && !isBlockNumberOrTag(value.toBlock))
      return false;
    if (!isNullish(value.address)) {
      if (Array.isArray(value.address)) {
        if (!value.address.every((address) => isAddress(address)))
          return false;
      } else if (!isAddress(value.address))
        return false;
    }
    if (!isNullish(value.topics)) {
      if (!value.topics.every((topic) => {
        if (isNullish(topic))
          return true;
        if (Array.isArray(topic)) {
          return topic.every((nestedTopic) => isTopic(nestedTopic));
        }
        if (isTopic(topic))
          return true;
        return false;
      }))
        return false;
    }
    return true;
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/formats.js
  var formats = {
    address: (data) => isAddress(data),
    bloom: (data) => isBloom(data),
    blockNumber: (data) => isBlockNumber(data),
    blockTag: (data) => isBlockTag(data),
    blockNumberOrTag: (data) => isBlockNumberOrTag(data),
    bool: (data) => isBoolean(data),
    bytes: (data) => isBytes(data),
    filter: (data) => isFilterObject(data),
    hex: (data) => isHexStrict(data),
    uint: (data) => isUInt(data),
    int: (data) => isInt(data),
    number: (data) => isNumber(data),
    string: (data) => isString(data)
  };
  for (let bitSize = 8; bitSize <= 256; bitSize += 8) {
    formats[`int${bitSize}`] = (data) => isInt(data, { bitSize });
    formats[`uint${bitSize}`] = (data) => isUInt(data, { bitSize });
  }
  for (let size = 1; size <= 32; size += 1) {
    formats[`bytes${size}`] = (data) => isBytes(data, { size });
  }
  formats.bytes256 = formats.bytes;
  var formats_default = formats;

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/validator.js
  var convertToZod = (schema) => {
    if ((!(schema === null || schema === void 0 ? void 0 : schema.type) || (schema === null || schema === void 0 ? void 0 : schema.type) === "object") && (schema === null || schema === void 0 ? void 0 : schema.properties)) {
      const obj = {};
      for (const name2 of Object.keys(schema.properties)) {
        const zItem = convertToZod(schema.properties[name2]);
        if (zItem) {
          obj[name2] = zItem;
        }
      }
      if (Array.isArray(schema.required)) {
        return z.object(obj).partial().required(schema.required.reduce((acc, v) => Object.assign(Object.assign({}, acc), { [v]: true }), {}));
      }
      return z.object(obj).partial();
    }
    if ((schema === null || schema === void 0 ? void 0 : schema.type) === "array" && (schema === null || schema === void 0 ? void 0 : schema.items)) {
      if (Array.isArray(schema.items) && schema.items.length > 0) {
        const arr = [];
        for (const item of schema.items) {
          const zItem = convertToZod(item);
          if (zItem) {
            arr.push(zItem);
          }
        }
        return z.tuple(arr);
      }
      return z.array(convertToZod(schema.items));
    }
    if (schema.oneOf && Array.isArray(schema.oneOf)) {
      return z.union(schema.oneOf.map((oneOfSchema) => convertToZod(oneOfSchema)));
    }
    if (schema === null || schema === void 0 ? void 0 : schema.format) {
      if (!formats_default[schema.format]) {
        throw new SchemaFormatError(schema.format);
      }
      return z.any().refine(formats_default[schema.format], (value) => ({
        params: { value, format: schema.format }
      }));
    }
    if ((schema === null || schema === void 0 ? void 0 : schema.type) && (schema === null || schema === void 0 ? void 0 : schema.type) !== "object" && typeof z[String(schema.type)] === "function") {
      return z[String(schema.type)]();
    }
    return z.object({ data: z.any() }).partial();
  };
  var Validator = class _Validator {
    // eslint-disable-next-line no-useless-constructor, @typescript-eslint/no-empty-function
    static factory() {
      if (!_Validator.validatorInstance) {
        _Validator.validatorInstance = new _Validator();
      }
      return _Validator.validatorInstance;
    }
    validate(schema, data, options) {
      var _a6, _b3;
      const zod = convertToZod(schema);
      const result = zod.safeParse(data);
      if (!result.success) {
        const errors = this.convertErrors((_b3 = (_a6 = result.error) === null || _a6 === void 0 ? void 0 : _a6.issues) !== null && _b3 !== void 0 ? _b3 : []);
        if (errors) {
          if (options === null || options === void 0 ? void 0 : options.silent) {
            return errors;
          }
          throw new Web3ValidatorError(errors);
        }
      }
      return void 0;
    }
    // eslint-disable-next-line class-methods-use-this
    convertErrors(errors) {
      if (errors && Array.isArray(errors) && errors.length > 0) {
        return errors.map((error) => {
          var _a6;
          let message;
          let keyword;
          let params;
          let schemaPath;
          schemaPath = error.path.join("/");
          const field2 = String(error.path[error.path.length - 1]);
          const instancePath = error.path.join("/");
          if (error.code === ZodIssueCode.too_big) {
            keyword = "maxItems";
            schemaPath = `${instancePath}/maxItems`;
            params = { limit: error.maximum };
            message = `must NOT have more than ${error.maximum} items`;
          } else if (error.code === ZodIssueCode.too_small) {
            keyword = "minItems";
            schemaPath = `${instancePath}/minItems`;
            params = { limit: error.minimum };
            message = `must NOT have fewer than ${error.minimum} items`;
          } else if (error.code === ZodIssueCode.custom) {
            const { value, format: format5 } = (_a6 = error.params) !== null && _a6 !== void 0 ? _a6 : {};
            if (typeof value === "undefined") {
              message = `value at "/${schemaPath}" is required`;
            } else {
              message = `value "${// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              typeof value === "object" ? JSON.stringify(value) : value}" at "/${schemaPath}" must pass "${format5}" validation`;
            }
            params = { value };
          }
          return {
            keyword: keyword !== null && keyword !== void 0 ? keyword : field2,
            instancePath: instancePath ? `/${instancePath}` : "",
            schemaPath: schemaPath ? `#${schemaPath}` : "#",
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            params: params !== null && params !== void 0 ? params : { value: error.message },
            message: message !== null && message !== void 0 ? message : error.message
          };
        });
      }
      return void 0;
    }
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/web3_validator.js
  var Web3Validator = class {
    constructor() {
      this._validator = Validator.factory();
    }
    validateJSONSchema(schema, data, options) {
      return this._validator.validate(schema, data, options);
    }
    validate(schema, data, options = { silent: false }) {
      var _a6, _b3;
      const jsonSchema = ethAbiToJsonSchema(schema);
      if (Array.isArray(jsonSchema.items) && ((_a6 = jsonSchema.items) === null || _a6 === void 0 ? void 0 : _a6.length) === 0 && data.length === 0) {
        return void 0;
      }
      if (Array.isArray(jsonSchema.items) && ((_b3 = jsonSchema.items) === null || _b3 === void 0 ? void 0 : _b3.length) === 0 && data.length !== 0) {
        throw new Web3ValidatorError([
          {
            instancePath: "/0",
            schemaPath: "/",
            keyword: "required",
            message: "empty schema against data can not be validated",
            params: data
          }
        ]);
      }
      return this._validator.validate(jsonSchema, data, options);
    }
  };

  // ../../node_modules/.pnpm/web3-validator@2.0.3/node_modules/web3-validator/lib/esm/default_validator.js
  var validator = new Web3Validator();

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/converters.js
  var ethUnitMap = {
    noether: BigInt(0),
    wei: BigInt(1),
    kwei: BigInt(1e3),
    Kwei: BigInt(1e3),
    babbage: BigInt(1e3),
    femtoether: BigInt(1e3),
    mwei: BigInt(1e6),
    Mwei: BigInt(1e6),
    lovelace: BigInt(1e6),
    picoether: BigInt(1e6),
    gwei: BigInt(1e9),
    Gwei: BigInt(1e9),
    shannon: BigInt(1e9),
    nanoether: BigInt(1e9),
    nano: BigInt(1e9),
    szabo: BigInt(1e12),
    microether: BigInt(1e12),
    micro: BigInt(1e12),
    finney: BigInt(1e15),
    milliether: BigInt(1e15),
    milli: BigInt(1e15),
    ether: BigInt("1000000000000000000"),
    kether: BigInt("1000000000000000000000"),
    grand: BigInt("1000000000000000000000"),
    mether: BigInt("1000000000000000000000000"),
    gether: BigInt("1000000000000000000000000000"),
    tether: BigInt("1000000000000000000000000000000")
  };
  var bytesToUint8Array = (data) => {
    validator.validate(["bytes"], [data]);
    if (data instanceof Uint8Array) {
      return data;
    }
    if (Array.isArray(data)) {
      return new Uint8Array(data);
    }
    if (typeof data === "string") {
      return utils_exports.hexToUint8Array(data);
    }
    throw new InvalidBytesError(data);
  };
  var { uint8ArrayToHexString: uint8ArrayToHexString2 } = utils_exports;
  var bytesToHex2 = (bytes2) => uint8ArrayToHexString2(bytesToUint8Array(bytes2));
  var hexToBytes2 = (bytes2) => {
    if (typeof bytes2 === "string" && bytes2.slice(0, 2).toLowerCase() !== "0x") {
      return bytesToUint8Array(`0x${bytes2}`);
    }
    return bytesToUint8Array(bytes2);
  };
  var hexToNumber2 = (value) => {
    validator.validate(["hex"], [value]);
    return utils_exports.hexToNumber(value);
  };
  var toDecimal = hexToNumber2;
  var numberToHex2 = (value, hexstrict) => {
    if (typeof value !== "bigint")
      validator.validate(["int"], [value]);
    let updatedValue = utils_exports.numberToHex(value);
    if (hexstrict) {
      if (!updatedValue.startsWith("-") && updatedValue.length % 2 === 1) {
        updatedValue = "0x0".concat(updatedValue.slice(2));
      } else if (updatedValue.length % 2 === 0 && updatedValue.startsWith("-"))
        updatedValue = "-0x0".concat(updatedValue.slice(3));
    }
    return updatedValue;
  };
  var fromDecimal = numberToHex2;
  var hexToNumberString = (data) => hexToNumber2(data).toString();
  var utf8ToHex = (str) => {
    validator.validate(["string"], [str]);
    let strWithoutNullCharacter = str.replace(/^(?:\u0000)/, "");
    strWithoutNullCharacter = strWithoutNullCharacter.replace(/(?:\u0000)$/, "");
    return bytesToHex2(new TextEncoder().encode(strWithoutNullCharacter));
  };
  var fromUtf8 = utf8ToHex;
  var stringToHex = utf8ToHex;
  var hexToUtf8 = (str) => bytesToUtf8(hexToBytes2(str));
  var toUtf8 = (input) => {
    if (typeof input === "string") {
      return hexToUtf8(input);
    }
    validator.validate(["bytes"], [input]);
    return bytesToUtf8(input);
  };
  var utf8ToBytes2 = utf8ToBytes;
  var hexToString = hexToUtf8;
  var asciiToHex = (str) => {
    validator.validate(["string"], [str]);
    let hexString = "";
    for (let i2 = 0; i2 < str.length; i2 += 1) {
      const hexCharCode = str.charCodeAt(i2).toString(16);
      hexString += hexCharCode.length % 2 !== 0 ? `0${hexCharCode}` : hexCharCode;
    }
    return `0x${hexString}`;
  };
  var fromAscii = asciiToHex;
  var hexToAscii = (str) => {
    const decoder2 = new TextDecoder("ascii");
    return decoder2.decode(hexToBytes2(str));
  };
  var toAscii = hexToAscii;
  var toHex = (value, returnType) => {
    if (typeof value === "string" && isAddress(value)) {
      return returnType ? "address" : `0x${value.toLowerCase().replace(/^0x/i, "")}`;
    }
    if (typeof value === "boolean") {
      return returnType ? "bool" : value ? "0x01" : "0x00";
    }
    if (typeof value === "number") {
      return returnType ? value < 0 ? "int256" : "uint256" : numberToHex2(value);
    }
    if (typeof value === "bigint") {
      return returnType ? "bigint" : numberToHex2(value);
    }
    if (typeof value === "object" && !!value) {
      return returnType ? "string" : utf8ToHex(JSON.stringify(value));
    }
    if (typeof value === "string") {
      if (value.startsWith("-0x") || value.startsWith("-0X")) {
        return returnType ? "int256" : numberToHex2(value);
      }
      if (isHexStrict(value)) {
        return returnType ? "bytes" : value;
      }
      if (isHex(value) && !isInt(value)) {
        return returnType ? "bytes" : `0x${value}`;
      }
      if (!Number.isFinite(value)) {
        return returnType ? "string" : utf8ToHex(value);
      }
    }
    throw new HexProcessingError(value);
  };
  var toNumber2 = (value) => {
    if (typeof value === "number") {
      return value;
    }
    if (typeof value === "bigint") {
      return value >= Number.MIN_SAFE_INTEGER && value <= Number.MAX_SAFE_INTEGER ? Number(value) : value;
    }
    if (typeof value === "string" && isHexStrict(value)) {
      return hexToNumber2(value);
    }
    try {
      return toNumber2(BigInt(value));
    } catch (_a6) {
      throw new InvalidNumberError(value);
    }
  };
  var toBigInt = (value) => {
    if (typeof value === "number") {
      return BigInt(value);
    }
    if (typeof value === "bigint") {
      return value;
    }
    if (typeof value === "string" && isHex(value)) {
      if (value.startsWith("-")) {
        return -BigInt(value.substring(1));
      }
      return BigInt(value);
    }
    throw new InvalidNumberError(value);
  };
  var fromWei = (number2, unit) => {
    const denomination = ethUnitMap[unit];
    if (!denomination) {
      throw new InvalidUnitError(unit);
    }
    const value = String(toNumber2(number2));
    const numberOfZerosInDenomination = denomination.toString().length - 1;
    if (numberOfZerosInDenomination <= 0) {
      return value.toString();
    }
    const zeroPaddedValue = value.padStart(numberOfZerosInDenomination, "0");
    const integer = zeroPaddedValue.slice(0, -numberOfZerosInDenomination);
    const fraction = zeroPaddedValue.slice(-numberOfZerosInDenomination).replace(/\.?0+$/, "");
    if (integer === "") {
      return `0.${fraction}`;
    }
    if (fraction === "") {
      return integer;
    }
    return `${integer}.${fraction}`;
  };
  var toWei = (number2, unit) => {
    validator.validate(["number"], [number2]);
    const denomination = ethUnitMap[unit];
    if (!denomination) {
      throw new InvalidUnitError(unit);
    }
    const [integer, fraction] = String(typeof number2 === "string" && !isHexStrict(number2) ? number2 : toNumber2(number2)).split(".").concat("");
    const value = BigInt(`${integer}${fraction}`);
    const updatedValue = value * denomination;
    const numberOfZerosInDenomination = denomination.toString().length - 1;
    const decimals = Math.min(fraction.length, numberOfZerosInDenomination);
    if (decimals === 0) {
      return updatedValue.toString();
    }
    return updatedValue.toString().padStart(decimals, "0").slice(0, -decimals);
  };
  var toChecksumAddress = (address) => {
    if (!isAddress(address, false)) {
      throw new InvalidAddressError(address);
    }
    const lowerCaseAddress = address.toLowerCase().replace(/^0x/i, "");
    const hash2 = utils_exports.uint8ArrayToHexString(keccak256(utf8ToBytes2(lowerCaseAddress)));
    if (isNullish(hash2) || hash2 === "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470")
      return "";
    let checksumAddress = "0x";
    const addressHash = hash2.replace(/^0x/i, "");
    for (let i2 = 0; i2 < lowerCaseAddress.length; i2 += 1) {
      if (parseInt(addressHash[i2], 16) > 7) {
        checksumAddress += lowerCaseAddress[i2].toUpperCase();
      } else {
        checksumAddress += lowerCaseAddress[i2];
      }
    }
    return checksumAddress;
  };
  var toBool = (value) => {
    if (typeof value === "boolean") {
      return value;
    }
    if (typeof value === "number" && (value === 0 || value === 1)) {
      return Boolean(value);
    }
    if (typeof value === "bigint" && (value === BigInt(0) || value === BigInt(1))) {
      return Boolean(value);
    }
    if (typeof value === "string" && !isHexStrict(value) && (value === "1" || value === "0" || value === "false" || value === "true")) {
      if (value === "true") {
        return true;
      }
      if (value === "false") {
        return false;
      }
      return Boolean(Number(value));
    }
    if (typeof value === "string" && isHexStrict(value) && (value === "0x1" || value === "0x0")) {
      return Boolean(toNumber2(value));
    }
    throw new InvalidBooleanError(value);
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/event_emitter.js
  var import_events = __toESM(require_events(), 1);
  var __awaiter2 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var wrapFunction = (fn) => (params) => fn(params.detail);
  var EventEmitterAtBrowser = class extends EventTarget {
    constructor() {
      super(...arguments);
      this._listeners = {};
      this.maxListeners = Number.MAX_SAFE_INTEGER;
    }
    on(eventName, fn) {
      this.addEventListener(eventName, fn);
      return this;
    }
    once(eventName, fn) {
      const onceCallback = (params) => __awaiter2(this, void 0, void 0, function* () {
        this.off(eventName, onceCallback);
        yield fn(params);
      });
      return this.on(eventName, onceCallback);
    }
    off(eventName, fn) {
      this.removeEventListener(eventName, fn);
      return this;
    }
    emit(eventName, params) {
      const event = new CustomEvent(eventName, { detail: params });
      return super.dispatchEvent(event);
    }
    listenerCount(eventName) {
      const eventListeners = this._listeners[eventName];
      return eventListeners ? eventListeners.length : 0;
    }
    listeners(eventName) {
      return this._listeners[eventName].map((value) => value[0]) || [];
    }
    eventNames() {
      return Object.keys(this._listeners);
    }
    removeAllListeners() {
      Object.keys(this._listeners).forEach((event) => {
        this._listeners[event].forEach((listener) => {
          super.removeEventListener(event, listener[1]);
        });
      });
      this._listeners = {};
      return this;
    }
    setMaxListeners(maxListeners) {
      this.maxListeners = maxListeners;
      return this;
    }
    getMaxListeners() {
      return this.maxListeners;
    }
    addEventListener(eventName, fn) {
      const wrappedFn = wrapFunction(fn);
      super.addEventListener(eventName, wrappedFn);
      if (!this._listeners[eventName]) {
        this._listeners[eventName] = [];
      }
      this._listeners[eventName].push([fn, wrappedFn]);
    }
    removeEventListener(eventName, fn) {
      const eventListeners = this._listeners[eventName];
      if (eventListeners) {
        const index2 = eventListeners.findIndex((item) => item[0] === fn);
        if (index2 !== -1) {
          super.removeEventListener(eventName, eventListeners[index2][1]);
          eventListeners.splice(index2, 1);
        }
      }
    }
  };
  var EventEmitterType;
  if (typeof window === "undefined") {
    EventEmitterType = import_events.EventEmitter;
  } else {
    EventEmitterType = EventEmitterAtBrowser;
  }
  var EventEmitter2 = class extends EventEmitterType {
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/validation.js
  var isHexStrict2 = isHexStrict;
  var isHex2 = isHex;
  var checkAddressCheckSum2 = checkAddressCheckSum;
  var isAddress2 = isAddress;
  var isBloom2 = isBloom;
  var isInBloom2 = isInBloom;
  var isUserEthereumAddressInBloom2 = isUserEthereumAddressInBloom;
  var isContractAddressInBloom2 = isContractAddressInBloom;
  var isTopic2 = isTopic;
  var isTopicInBloom2 = isTopicInBloom;
  var compareBlockNumbers = (blockA, blockB) => {
    const isABlockTag = typeof blockA === "string" && isBlockTag(blockA);
    const isBBlockTag = typeof blockB === "string" && isBlockTag(blockB);
    if (blockA === blockB || (blockA === "earliest" || blockA === 0) && (blockB === "earliest" || blockB === 0)) {
      return 0;
    }
    if (blockA === "earliest" && blockB > 0) {
      return -1;
    }
    if (blockB === "earliest" && blockA > 0) {
      return 1;
    }
    if (isABlockTag && isBBlockTag) {
      const tagsOrder = {
        [BlockTags.EARLIEST]: 1,
        [BlockTags.FINALIZED]: 2,
        [BlockTags.SAFE]: 3,
        [BlockTags.LATEST]: 4,
        [BlockTags.PENDING]: 5
      };
      if (tagsOrder[blockA] < tagsOrder[blockB]) {
        return -1;
      }
      return 1;
    }
    if (isABlockTag && !isBBlockTag || !isABlockTag && isBBlockTag) {
      throw new InvalidBlockError("Cannot compare blocktag with provided non-blocktag input.");
    }
    const bigIntA = BigInt(blockA);
    const bigIntB = BigInt(blockB);
    if (bigIntA < bigIntB) {
      return -1;
    }
    if (bigIntA === bigIntB) {
      return 0;
    }
    return 1;
  };
  var isContractInitOptions = (options) => typeof options === "object" && !isNullish(options) && Object.keys(options).length !== 0 && [
    "input",
    "data",
    "from",
    "gas",
    "gasPrice",
    "gasLimit",
    "address",
    "jsonInterface",
    "syncWithContext",
    "dataInputFill"
  ].some((key) => key in options);
  var isNullish2 = isNullish;

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/objects.js
  var isIterable = (item) => typeof item === "object" && !isNullish(item) && !Array.isArray(item) && !(item instanceof TypedArray);
  var mergeDeep = (destination, ...sources) => {
    const result = destination;
    if (!isIterable(result)) {
      return result;
    }
    for (const src of sources) {
      for (const key in src) {
        if (isIterable(src[key])) {
          if (!result[key]) {
            result[key] = {};
          }
          mergeDeep(result[key], src[key]);
        } else if (!isNullish(src[key]) && Object.hasOwnProperty.call(src, key)) {
          if (Array.isArray(src[key]) || src[key] instanceof TypedArray) {
            result[key] = src[key].slice(0);
          } else {
            result[key] = src[key];
          }
        }
      }
    }
    return result;
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/string_manipulation.js
  var padLeft2 = (value, characterAmount, sign6 = "0") => {
    if (typeof value === "string") {
      if (!isHexStrict(value)) {
        return value.padStart(characterAmount, sign6);
      }
      return utils_exports.padLeft(value, characterAmount, sign6);
    }
    validator.validate(["int"], [value]);
    return utils_exports.padLeft(value, characterAmount, sign6);
  };
  var padRight = (value, characterAmount, sign6 = "0") => {
    if (typeof value === "string" && !isHexStrict(value)) {
      return value.padEnd(characterAmount, sign6);
    }
    validator.validate(["int"], [value]);
    const hexString = typeof value === "string" && isHexStrict(value) ? value : numberToHex2(value);
    const prefixLength = hexString.startsWith("-") ? 3 : 2;
    return hexString.padEnd(characterAmount + prefixLength, sign6);
  };
  var rightPad = padRight;
  var leftPad = padLeft2;
  var toTwosComplement = (value, nibbleWidth = 64) => {
    validator.validate(["int"], [value]);
    const val = toNumber2(value);
    if (val >= 0)
      return padLeft2(toHex(val), nibbleWidth);
    const largestBit = bigintPower(BigInt(2), BigInt(nibbleWidth * 4));
    if (-val >= largestBit) {
      throw new NibbleWidthError(`value: ${value}, nibbleWidth: ${nibbleWidth}`);
    }
    const updatedVal = BigInt(val);
    const complement = updatedVal + largestBit;
    return padLeft2(numberToHex2(complement), nibbleWidth);
  };
  var fromTwosComplement = (value, nibbleWidth = 64) => {
    validator.validate(["int"], [value]);
    const val = toNumber2(value);
    if (val < 0)
      return val;
    const largestBit = Math.ceil(Math.log(Number(val)) / Math.log(2));
    if (largestBit > nibbleWidth * 4)
      throw new NibbleWidthError(`value: "${value}", nibbleWidth: "${nibbleWidth}"`);
    if (nibbleWidth * 4 !== largestBit)
      return val;
    const complement = bigintPower(BigInt(2), BigInt(nibbleWidth) * BigInt(4));
    return toNumber2(BigInt(val) - complement);
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/uint8array.js
  function uint8ArrayConcat(...parts) {
    const length2 = parts.reduce((prev, part) => {
      const agg = prev + part.length;
      return agg;
    }, 0);
    const result = new Uint8Array(length2);
    let offset = 0;
    for (const part of parts) {
      result.set(part, offset);
      offset += part.length;
    }
    return result;
  }
  function uint8ArrayEquals(a, b) {
    if (a === b) {
      return true;
    }
    if (a.byteLength !== b.byteLength) {
      return false;
    }
    for (let i2 = 0; i2 < a.byteLength; i2 += 1) {
      if (a[i2] !== b[i2]) {
        return false;
      }
    }
    return true;
  }

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/formatter.js
  var { parseBaseType: parseBaseType2 } = utils_exports;
  var isDataFormat = (dataFormat) => typeof dataFormat === "object" && !isNullish(dataFormat) && "number" in dataFormat && "bytes" in dataFormat;
  var findSchemaByDataPath = (schema, dataPath, oneOfPath = []) => {
    let result = Object.assign({}, schema);
    let previousDataPath;
    for (const dataPart of dataPath) {
      if (result.oneOf && previousDataPath) {
        const path3 = oneOfPath.find(function(element) {
          return this === element[0];
        }, previousDataPath !== null && previousDataPath !== void 0 ? previousDataPath : "");
        if (path3 && path3[0] === previousDataPath) {
          result = result.oneOf[path3[1]];
        }
      }
      if (!result.properties && !result.items) {
        return void 0;
      }
      if (result.properties) {
        result = result.properties[dataPart];
      } else if (result.items && result.items.properties) {
        const node = result.items.properties;
        if (!node) {
          return void 0;
        }
        result = node[dataPart];
      } else if (result.items && isObject(result.items)) {
        result = result.items;
      } else if (result.items && Array.isArray(result.items)) {
        result = result.items[parseInt(dataPart, 10)];
      }
      if (result && dataPart)
        previousDataPath = dataPart;
    }
    return result;
  };
  var convertScalarValue = (value, ethType, format5) => {
    try {
      const { baseType, baseTypeSize } = parseBaseType2(ethType);
      if (baseType === "int" || baseType === "uint") {
        switch (format5.number) {
          case FMT_NUMBER.NUMBER:
            return Number(toBigInt(value));
          case FMT_NUMBER.HEX:
            return numberToHex2(toBigInt(value));
          case FMT_NUMBER.STR:
            return toBigInt(value).toString();
          case FMT_NUMBER.BIGINT:
            return toBigInt(value);
          default:
            throw new FormatterError(`Invalid format: ${String(format5.number)}`);
        }
      }
      if (baseType === "bytes") {
        let paddedValue;
        if (baseTypeSize) {
          if (typeof value === "string")
            paddedValue = padLeft2(value, baseTypeSize * 2);
          else if (value instanceof Uint8Array) {
            paddedValue = uint8ArrayConcat(new Uint8Array(baseTypeSize - value.length), value);
          }
        } else {
          paddedValue = value;
        }
        switch (format5.bytes) {
          case FMT_BYTES.HEX:
            return bytesToHex2(bytesToUint8Array(paddedValue));
          case FMT_BYTES.UINT8ARRAY:
            return bytesToUint8Array(paddedValue);
          default:
            throw new FormatterError(`Invalid format: ${String(format5.bytes)}`);
        }
      }
    } catch (error) {
      return value;
    }
    return value;
  };
  var convert = (data, schema, dataPath, format5, oneOfPath = []) => {
    var _a6, _b3;
    if (!isObject(data) && !Array.isArray(data)) {
      return convertScalarValue(data, schema === null || schema === void 0 ? void 0 : schema.format, format5);
    }
    const object = data;
    for (const [key, value] of Object.entries(object)) {
      dataPath.push(key);
      const schemaProp = findSchemaByDataPath(schema, dataPath, oneOfPath);
      if (isNullish(schemaProp)) {
        delete object[key];
        dataPath.pop();
        continue;
      }
      if (isObject(value)) {
        convert(value, schema, dataPath, format5);
        dataPath.pop();
        continue;
      }
      if (Array.isArray(value)) {
        let _schemaProp = schemaProp;
        if ((schemaProp === null || schemaProp === void 0 ? void 0 : schemaProp.oneOf) !== void 0) {
          schemaProp.oneOf.forEach((oneOfSchemaProp, index2) => {
            var _a7, _b4;
            if (!Array.isArray(schemaProp === null || schemaProp === void 0 ? void 0 : schemaProp.items) && (typeof value[0] === "object" && ((_a7 = oneOfSchemaProp === null || oneOfSchemaProp === void 0 ? void 0 : oneOfSchemaProp.items) === null || _a7 === void 0 ? void 0 : _a7.type) === "object" || typeof value[0] === "string" && ((_b4 = oneOfSchemaProp === null || oneOfSchemaProp === void 0 ? void 0 : oneOfSchemaProp.items) === null || _b4 === void 0 ? void 0 : _b4.type) !== "object")) {
              _schemaProp = oneOfSchemaProp;
              oneOfPath.push([key, index2]);
            }
          });
        }
        if (isNullish(_schemaProp === null || _schemaProp === void 0 ? void 0 : _schemaProp.items)) {
          delete object[key];
          dataPath.pop();
          continue;
        }
        if (isObject(_schemaProp.items) && !isNullish(_schemaProp.items.format)) {
          for (let i2 = 0; i2 < value.length; i2 += 1) {
            object[key][i2] = convertScalarValue(
              value[i2],
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              (_a6 = _schemaProp === null || _schemaProp === void 0 ? void 0 : _schemaProp.items) === null || _a6 === void 0 ? void 0 : _a6.format,
              format5
            );
          }
          dataPath.pop();
          continue;
        }
        if (!Array.isArray(_schemaProp === null || _schemaProp === void 0 ? void 0 : _schemaProp.items) && ((_b3 = _schemaProp === null || _schemaProp === void 0 ? void 0 : _schemaProp.items) === null || _b3 === void 0 ? void 0 : _b3.type) === "object") {
          for (const arrObject of value) {
            convert(arrObject, schema, dataPath, format5, oneOfPath);
          }
          dataPath.pop();
          continue;
        }
        if (Array.isArray(_schemaProp === null || _schemaProp === void 0 ? void 0 : _schemaProp.items)) {
          for (let i2 = 0; i2 < value.length; i2 += 1) {
            object[key][i2] = convertScalarValue(value[i2], _schemaProp.items[i2].format, format5);
          }
          dataPath.pop();
          continue;
        }
      }
      object[key] = convertScalarValue(value, schemaProp.format, format5);
      dataPath.pop();
    }
    return object;
  };
  var format4 = (schema, data, returnFormat) => {
    let dataToParse;
    if (isObject(data)) {
      dataToParse = mergeDeep({}, data);
    } else if (Array.isArray(data)) {
      dataToParse = [...data];
    } else {
      dataToParse = data;
    }
    const jsonSchema = isObject(schema) ? schema : utils_exports.ethAbiToJsonSchema(schema);
    if (!jsonSchema.properties && !jsonSchema.items && !jsonSchema.format) {
      throw new FormatterError("Invalid json schema for formatting");
    }
    return convert(dataToParse, jsonSchema, [], returnFormat);
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/hash.js
  var SHA3_EMPTY_BYTES = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
  var sha3 = (data) => {
    let updatedData;
    if (typeof data === "string") {
      if (data.startsWith("0x") && isHexStrict(data)) {
        updatedData = hexToBytes2(data);
      } else {
        updatedData = utf8ToBytes(data);
      }
    } else {
      updatedData = data;
    }
    const hash2 = bytesToHex2(keccak256(updatedData));
    return hash2 === SHA3_EMPTY_BYTES ? void 0 : hash2;
  };
  var sha3Raw = (data) => {
    const hash2 = sha3(data);
    if (isNullish(hash2)) {
      return SHA3_EMPTY_BYTES;
    }
    return hash2;
  };
  var keccak256Wrapper = (data) => {
    let processedData;
    if (typeof data === "bigint" || typeof data === "number") {
      processedData = utf8ToBytes(data.toString());
    } else if (Array.isArray(data)) {
      processedData = new Uint8Array(data);
    } else if (typeof data === "string" && !isHexStrict(data)) {
      processedData = utf8ToBytes(data);
    } else {
      processedData = bytesToUint8Array(data);
    }
    return bytesToHex2(keccak256(processedData));
  };
  var getType = (arg) => {
    if (Array.isArray(arg)) {
      throw new Error("Autodetection of array types is not supported.");
    }
    let type;
    let value;
    if (typeof arg === "object" && ("t" in arg || "type" in arg) && ("v" in arg || "value" in arg)) {
      type = "t" in arg ? arg.t : arg.type;
      value = "v" in arg ? arg.v : arg.value;
      type = type.toLowerCase() === "bigint" ? "int" : type;
    } else if (typeof arg === "bigint") {
      return ["int", arg];
    } else {
      type = toHex(arg, true);
      value = toHex(arg);
      if (!type.startsWith("int") && !type.startsWith("uint")) {
        type = "bytes";
      }
    }
    if ((type.startsWith("int") || type.startsWith("uint")) && typeof value === "string" && !/^(-)?0x/i.test(value)) {
      value = toBigInt(value);
    }
    return [type, value];
  };
  var elementaryName = (name2) => {
    if (name2.startsWith("int[")) {
      return `int256${name2.slice(3)}`;
    }
    if (name2 === "int") {
      return "int256";
    }
    if (name2.startsWith("uint[")) {
      return `uint256'${name2.slice(4)}`;
    }
    if (name2 === "uint") {
      return "uint256";
    }
    return name2;
  };
  var parseTypeN = (value, typeLength) => {
    const typesize = /^(\d+).*$/.exec(value.slice(typeLength));
    return typesize ? parseInt(typesize[1], 10) : 0;
  };
  var bitLength = (value) => {
    const updatedVal = value.toString(2);
    return updatedVal.length;
  };
  var solidityPack = (type, val) => {
    const value = val.toString();
    if (type === "string") {
      if (typeof val === "string")
        return utf8ToHex(val);
      throw new InvalidStringError(val);
    }
    if (type === "bool" || type === "boolean") {
      if (typeof val === "boolean")
        return val ? "01" : "00";
      throw new InvalidBooleanError(val);
    }
    if (type === "address") {
      if (!isAddress(value)) {
        throw new InvalidAddressError(value);
      }
      return value;
    }
    const name2 = elementaryName(type);
    if (type.startsWith("uint")) {
      const size = parseTypeN(name2, "uint".length);
      if (size % 8 || size < 8 || size > 256) {
        throw new InvalidSizeError(value);
      }
      const num = toNumber2(value);
      if (bitLength(num) > size) {
        throw new InvalidLargeValueError(value);
      }
      if (num < BigInt(0)) {
        throw new InvalidUnsignedIntegerError(value);
      }
      return size ? leftPad(num.toString(16), size / 8 * 2) : num.toString(16);
    }
    if (type.startsWith("int")) {
      const size = parseTypeN(name2, "int".length);
      if (size % 8 || size < 8 || size > 256) {
        throw new InvalidSizeError(type);
      }
      const num = toNumber2(value);
      if (bitLength(num) > size) {
        throw new InvalidLargeValueError(value);
      }
      if (num < BigInt(0)) {
        return toTwosComplement(num.toString(), size / 8 * 2);
      }
      return size ? leftPad(num.toString(16), size / 4) : num.toString(16);
    }
    if (name2 === "bytes") {
      if (value.replace(/^0x/i, "").length % 2 !== 0) {
        throw new InvalidBytesError(value);
      }
      return value;
    }
    if (type.startsWith("bytes")) {
      if (value.replace(/^0x/i, "").length % 2 !== 0) {
        throw new InvalidBytesError(value);
      }
      const size = parseTypeN(type, "bytes".length);
      if (!size || size < 1 || size > 64 || size < value.replace(/^0x/i, "").length / 2) {
        throw new InvalidBytesError(value);
      }
      return rightPad(value, size * 2);
    }
    return "";
  };
  var processSolidityEncodePackedArgs = (arg) => {
    const [type, val] = getType(arg);
    if (Array.isArray(val)) {
      const hexArg2 = val.map((v) => solidityPack(type, v).replace("0x", ""));
      return hexArg2.join("");
    }
    const hexArg = solidityPack(type, val);
    return hexArg.replace("0x", "");
  };
  var encodePacked = (...values) => {
    const hexArgs = values.map(processSolidityEncodePackedArgs);
    return `0x${hexArgs.join("").toLowerCase()}`;
  };
  var soliditySha3 = (...values) => sha3(encodePacked(...values));
  var soliditySha3Raw = (...values) => sha3Raw(encodePacked(...values));
  var getStorageSlotNumForLongString = (mainSlotNumber) => sha3(`0x${(typeof mainSlotNumber === "number" ? mainSlotNumber.toString() : mainSlotNumber).padStart(64, "0")}`);

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/random.js
  function getRandomBytesSync(bytes2) {
    return randomBytes(bytes2);
  }

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/random.js
  var randomBytes2 = (size) => getRandomBytesSync(size);
  var randomHex = (byteSize) => bytesToHex2(randomBytes2(byteSize));

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/promise_helpers.js
  var __awaiter3 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function isPromise(object) {
    return (typeof object === "object" || typeof object === "function") && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    typeof object.then === "function";
  }
  function waitWithTimeout(awaitable, timeout, error) {
    return __awaiter3(this, void 0, void 0, function* () {
      let timeoutId;
      const result = yield Promise.race([
        awaitable instanceof Promise ? awaitable : awaitable(),
        new Promise((resolve2, reject) => {
          timeoutId = setTimeout(() => error ? reject(error) : resolve2(void 0), timeout);
        })
      ]);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (result instanceof Error) {
        throw result;
      }
      return result;
    });
  }
  function pollTillDefinedAndReturnIntervalId(func, interval) {
    let intervalId;
    const polledRes = new Promise((resolve2, reject) => {
      intervalId = setInterval(
        function intervalCallbackFunc() {
          (() => __awaiter3(this, void 0, void 0, function* () {
            try {
              const res = yield waitWithTimeout(func, interval);
              if (!isNullish(res)) {
                clearInterval(intervalId);
                resolve2(res);
              }
            } catch (error) {
              clearInterval(intervalId);
              reject(error);
            }
          }))();
          return intervalCallbackFunc;
        }(),
        interval
      );
    });
    return [polledRes, intervalId];
  }
  function pollTillDefined(func, interval) {
    return __awaiter3(this, void 0, void 0, function* () {
      return pollTillDefinedAndReturnIntervalId(func, interval)[0];
    });
  }
  function rejectIfTimeout(timeout, error) {
    let timeoutId;
    const rejectOnTimeout = new Promise((_2, reject) => {
      timeoutId = setTimeout(() => {
        reject(error);
      }, timeout);
    });
    return [timeoutId, rejectOnTimeout];
  }
  function rejectIfConditionAtInterval(cond, interval) {
    let intervalId;
    const rejectIfCondition = new Promise((_2, reject) => {
      intervalId = setInterval(() => {
        (() => __awaiter3(this, void 0, void 0, function* () {
          const error = yield cond();
          if (error) {
            clearInterval(intervalId);
            reject(error);
          }
        }))();
      }, interval);
    });
    return [intervalId, rejectIfCondition];
  }

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/json_rpc.js
  var json_rpc_exports = {};
  __export(json_rpc_exports, {
    isBatchRequest: () => isBatchRequest,
    isBatchResponse: () => isBatchResponse,
    isResponseRpcError: () => isResponseRpcError,
    isResponseWithError: () => isResponseWithError2,
    isResponseWithNotification: () => isResponseWithNotification,
    isResponseWithResult: () => isResponseWithResult,
    isSubscriptionResult: () => isSubscriptionResult,
    isValidResponse: () => isValidResponse,
    setRequestIdStart: () => setRequestIdStart,
    toBatchPayload: () => toBatchPayload,
    toPayload: () => toPayload,
    validateResponse: () => validateResponse
  });

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/uuid.js
  var uuidV4 = () => {
    const bytes2 = randomBytes2(16);
    bytes2[6] = bytes2[6] & 15 | 64;
    bytes2[8] = bytes2[8] & 63 | 128;
    const hexString = bytesToHex2(bytes2);
    return [
      hexString.substring(2, 10),
      hexString.substring(10, 14),
      hexString.substring(14, 18),
      hexString.substring(18, 22),
      hexString.substring(22, 34)
    ].join("-");
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/json_rpc.js
  var isResponseRpcError = (rpcError) => {
    const errorCode = rpcError.error.code;
    return rpcErrorsMap.has(errorCode) || errorCode >= -32099 && errorCode <= -32e3;
  };
  var isResponseWithResult = (response) => !Array.isArray(response) && !!response && response.jsonrpc === "2.0" && // JSON RPC consider "null" as valid response
  "result" in response && isNullish(response.error) && (typeof response.id === "number" || typeof response.id === "string");
  var isResponseWithError2 = (response) => !Array.isArray(response) && response.jsonrpc === "2.0" && !!response && isNullish(response.result) && // JSON RPC consider "null" as valid response
  "error" in response && (typeof response.id === "number" || typeof response.id === "string");
  var isResponseWithNotification = (response) => !Array.isArray(response) && !!response && response.jsonrpc === "2.0" && !isNullish(response.params) && !isNullish(response.method);
  var isSubscriptionResult = (response) => !Array.isArray(response) && !!response && response.jsonrpc === "2.0" && "id" in response && // JSON RPC consider "null" as valid response
  "result" in response;
  var validateResponse = (response) => isResponseWithResult(response) || isResponseWithError2(response);
  var isValidResponse = (response) => Array.isArray(response) ? response.every(validateResponse) : validateResponse(response);
  var isBatchResponse = (response) => Array.isArray(response) && response.length > 0 && isValidResponse(response);
  var requestIdSeed;
  var setRequestIdStart = (start) => {
    requestIdSeed = start;
  };
  var toPayload = (request4) => {
    var _a6, _b3, _c2, _d;
    if (typeof requestIdSeed !== "undefined") {
      requestIdSeed += 1;
    }
    return {
      jsonrpc: (_a6 = request4.jsonrpc) !== null && _a6 !== void 0 ? _a6 : "2.0",
      id: (_c2 = (_b3 = request4.id) !== null && _b3 !== void 0 ? _b3 : requestIdSeed) !== null && _c2 !== void 0 ? _c2 : uuidV4(),
      method: request4.method,
      params: (_d = request4.params) !== null && _d !== void 0 ? _d : void 0
    };
  };
  var toBatchPayload = (requests) => requests.map((request4) => toPayload(request4));
  var isBatchRequest = (request4) => Array.isArray(request4) && request4.length > 0;

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/web3_deferred_promise.js
  var __awaiter4 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var _a2;
  var Web3DeferredPromise = class {
    /**
     *
     * @param timeout - (optional) The timeout in milliseconds.
     * @param eagerStart - (optional) If true, the timer starts as soon as the promise is created.
     * @param timeoutMessage - (optional) The message to include in the timeout erro that is thrown when the promise times out.
     */
    constructor({ timeout, eagerStart, timeoutMessage } = {
      timeout: 0,
      eagerStart: false,
      timeoutMessage: "DeferredPromise timed out"
    }) {
      this[_a2] = "Promise";
      this._state = "pending";
      this._promise = new Promise((resolve2, reject) => {
        this._resolve = resolve2;
        this._reject = reject;
      });
      this._timeoutMessage = timeoutMessage;
      this._timeoutInterval = timeout;
      if (eagerStart) {
        this.startTimer();
      }
    }
    /**
     * Returns the current state of the promise.
     * @returns 'pending' | 'fulfilled' | 'rejected'
     */
    get state() {
      return this._state;
    }
    /**
     *
     * @param onfulfilled - (optional) The callback to execute when the promise is fulfilled.
     * @param onrejected  - (optional) The callback to execute when the promise is rejected.
     * @returns
     */
    then(onfulfilled, onrejected) {
      return __awaiter4(this, void 0, void 0, function* () {
        return this._promise.then(onfulfilled, onrejected);
      });
    }
    /**
     *
     * @param onrejected - (optional) The callback to execute when the promise is rejected.
     * @returns
     */
    catch(onrejected) {
      return __awaiter4(this, void 0, void 0, function* () {
        return this._promise.catch(onrejected);
      });
    }
    /**
     *
     * @param onfinally - (optional) The callback to execute when the promise is settled (fulfilled or rejected).
     * @returns
     */
    finally(onfinally) {
      return __awaiter4(this, void 0, void 0, function* () {
        return this._promise.finally(onfinally);
      });
    }
    /**
     * Resolves the current promise.
     * @param value - The value to resolve the promise with.
     */
    resolve(value) {
      this._resolve(value);
      this._state = "fulfilled";
      this._clearTimeout();
    }
    /**
     * Rejects the current promise.
     * @param reason - The reason to reject the promise with.
     */
    reject(reason) {
      this._reject(reason);
      this._state = "rejected";
      this._clearTimeout();
    }
    /**
     * Starts the timeout timer for the promise.
     */
    startTimer() {
      if (this._timeoutInterval && this._timeoutInterval > 0) {
        this._timeoutId = setTimeout(this._checkTimeout.bind(this), this._timeoutInterval);
      }
    }
    _checkTimeout() {
      if (this._state === "pending" && this._timeoutId) {
        this.reject(new OperationTimeoutError(this._timeoutMessage));
      }
    }
    _clearTimeout() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
      }
    }
  };
  _a2 = Symbol.toStringTag;

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/chunk_response_parser.js
  var ChunkResponseParser = class {
    constructor(eventEmitter, autoReconnect) {
      this.eventEmitter = eventEmitter;
      this.autoReconnect = autoReconnect;
    }
    clearQueues() {
      if (typeof this._clearQueues === "function") {
        this._clearQueues();
      }
    }
    onError(clearQueues) {
      this._clearQueues = clearQueues;
    }
    parseResponse(data) {
      const returnValues = [];
      const dechunkedData = data.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|");
      dechunkedData.forEach((_chunkData) => {
        let chunkData = _chunkData;
        if (this.lastChunk) {
          chunkData = this.lastChunk + chunkData;
        }
        let result;
        try {
          result = JSON.parse(chunkData);
        } catch (e2) {
          this.lastChunk = chunkData;
          if (this.lastChunkTimeout) {
            clearTimeout(this.lastChunkTimeout);
          }
          this.lastChunkTimeout = setTimeout(() => {
            if (this.autoReconnect)
              return;
            this.clearQueues();
            this.eventEmitter.emit("error", new InvalidResponseError({
              id: 1,
              jsonrpc: "2.0",
              error: { code: 2, message: "Chunk timeout" }
            }));
          }, 1e3 * 15);
          return;
        }
        clearTimeout(this.lastChunkTimeout);
        this.lastChunk = void 0;
        if (result)
          returnValues.push(result);
      });
      return returnValues;
    }
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/web3_eip1193_provider.js
  var import_events2 = __toESM(require_events(), 1);
  var __awaiter5 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Eip1193Provider = class extends Web3BaseProvider {
    constructor() {
      super(...arguments);
      this._eventEmitter = new import_events2.EventEmitter();
      this._chainId = "";
      this._accounts = [];
    }
    _getChainId() {
      var _a6;
      return __awaiter5(this, void 0, void 0, function* () {
        const data = yield this.request(toPayload({
          method: "eth_chainId",
          params: []
        }));
        return (_a6 = data === null || data === void 0 ? void 0 : data.result) !== null && _a6 !== void 0 ? _a6 : "";
      });
    }
    _getAccounts() {
      var _a6;
      return __awaiter5(this, void 0, void 0, function* () {
        const data = yield this.request(toPayload({
          method: "eth_accounts",
          params: []
        }));
        return (_a6 = data === null || data === void 0 ? void 0 : data.result) !== null && _a6 !== void 0 ? _a6 : [];
      });
    }
    _onConnect() {
      Promise.all([
        this._getChainId().then((chainId) => {
          if (chainId !== this._chainId) {
            this._chainId = chainId;
            this._eventEmitter.emit("chainChanged", this._chainId);
          }
        }).catch((err3) => {
          console.error(err3);
        }),
        this._getAccounts().then((accounts) => {
          if (!(this._accounts.length === accounts.length && accounts.every((v) => accounts.includes(v)))) {
            this._accounts = accounts;
            this._onAccountsChanged();
          }
        }).catch((err3) => {
          console.error(err3);
        })
      ]).then(() => this._eventEmitter.emit("connect", {
        chainId: this._chainId
      })).catch((err3) => {
        console.error(err3);
      });
    }
    // todo this must be ProvideRpcError with a message too
    _onDisconnect(code, data) {
      this._eventEmitter.emit("disconnect", new EIP1193ProviderRpcError(code, data));
    }
    _onAccountsChanged() {
      this._eventEmitter.emit("accountsChanged", this._accounts);
    }
  };

  // ../../node_modules/.pnpm/web3-utils@4.1.0/node_modules/web3-utils/lib/esm/socket_provider.js
  var __awaiter6 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var DEFAULT_RECONNECTION_OPTIONS = {
    autoReconnect: true,
    delay: 5e3,
    maxAttempts: 5
  };
  var NORMAL_CLOSE_CODE = 1e3;
  var SocketProvider = class extends Eip1193Provider {
    /**
     * This is an abstract class for implementing a socket provider (e.g. WebSocket, IPC). It extends the EIP-1193 provider {@link EIP1193Provider}.
     * @param socketPath - The path to the socket (e.g. /ipc/path or ws://localhost:8546)
     * @param socketOptions - The options for the socket connection. Its type is supposed to be specified in the inherited classes.
     * @param reconnectOptions - The options for the socket reconnection {@link ReconnectOptions}
     */
    constructor(socketPath, socketOptions, reconnectOptions) {
      super();
      this._connectionStatus = "connecting";
      this._onMessageHandler = this._onMessage.bind(this);
      this._onOpenHandler = this._onConnect.bind(this);
      this._onCloseHandler = this._onCloseEvent.bind(this);
      this._onErrorHandler = this._onError.bind(this);
      if (!this._validateProviderPath(socketPath))
        throw new InvalidClientError(socketPath);
      this._socketPath = socketPath;
      this._socketOptions = socketOptions;
      this._reconnectOptions = Object.assign(Object.assign({}, DEFAULT_RECONNECTION_OPTIONS), reconnectOptions !== null && reconnectOptions !== void 0 ? reconnectOptions : {});
      this._pendingRequestsQueue = /* @__PURE__ */ new Map();
      this._sentRequestsQueue = /* @__PURE__ */ new Map();
      this._init();
      this.connect();
      this.chunkResponseParser = new ChunkResponseParser(this._eventEmitter, this._reconnectOptions.autoReconnect);
      this.chunkResponseParser.onError(() => {
        this._clearQueues();
      });
      this.isReconnecting = false;
    }
    get SocketConnection() {
      return this._socketConnection;
    }
    _init() {
      this._reconnectAttempts = 0;
    }
    /**
     * Try to establish a connection to the socket
     */
    connect() {
      try {
        this._openSocketConnection();
        this._connectionStatus = "connecting";
        this._addSocketListeners();
      } catch (e2) {
        if (!this.isReconnecting) {
          this._connectionStatus = "disconnected";
          if (e2 && e2.message) {
            throw new ConnectionError(`Error while connecting to ${this._socketPath}. Reason: ${e2.message}`);
          } else {
            throw new InvalidClientError(this._socketPath);
          }
        } else {
          setImmediate(() => {
            this._reconnect();
          });
        }
      }
    }
    // eslint-disable-next-line class-methods-use-this
    _validateProviderPath(path3) {
      return !!path3;
    }
    /**
     *
     * @returns the pendingRequestQueue size
     */
    // eslint-disable-next-line class-methods-use-this
    getPendingRequestQueueSize() {
      return this._pendingRequestsQueue.size;
    }
    /**
     *
     * @returns the sendPendingRequests size
     */
    // eslint-disable-next-line class-methods-use-this
    getSentRequestsQueueSize() {
      return this._sentRequestsQueue.size;
    }
    /**
     *
     * @returns `true` if the socket supports subscriptions
     */
    // eslint-disable-next-line class-methods-use-this
    supportsSubscriptions() {
      return true;
    }
    on(type, listener) {
      this._eventEmitter.on(type, listener);
    }
    once(type, listener) {
      this._eventEmitter.once(type, listener);
    }
    removeListener(type, listener) {
      this._eventEmitter.removeListener(type, listener);
    }
    _onDisconnect(code, data) {
      this._connectionStatus = "disconnected";
      super._onDisconnect(code, data);
    }
    /**
     * Disconnects the socket
     * @param code - The code to be sent to the server
     * @param data - The data to be sent to the server
     */
    disconnect(code, data) {
      const disconnectCode = code !== null && code !== void 0 ? code : NORMAL_CLOSE_CODE;
      this._removeSocketListeners();
      if (this.getStatus() !== "disconnected") {
        this._closeSocketConnection(disconnectCode, data);
      }
      this._onDisconnect(disconnectCode, data);
    }
    /**
     * Safely disconnects the socket, async and waits for request size to be 0 before disconnecting
     * @param forceDisconnect - If true, will clear queue after 5 attempts of waiting for both pending and sent queue to be 0
     * @param ms - Determines the ms of setInterval
     * @param code - The code to be sent to the server
     * @param data - The data to be sent to the server
     */
    safeDisconnect(code, data, forceDisconnect = false, ms = 1e3) {
      return __awaiter6(this, void 0, void 0, function* () {
        let retryAttempt = 0;
        const checkQueue = () => __awaiter6(this, void 0, void 0, function* () {
          return new Promise((resolve2) => {
            const interval = setInterval(() => {
              if (forceDisconnect && retryAttempt === 5) {
                this.clearQueues();
              }
              if (this.getPendingRequestQueueSize() === 0 && this.getSentRequestsQueueSize() === 0) {
                clearInterval(interval);
                resolve2(true);
              }
              retryAttempt += 1;
            }, ms);
          });
        });
        yield checkQueue();
        this.disconnect(code, data);
      });
    }
    /**
     * Removes all listeners for the specified event type.
     * @param type - The event type to remove the listeners for
     */
    removeAllListeners(type) {
      this._eventEmitter.removeAllListeners(type);
    }
    _onError(event) {
      if (this.isReconnecting) {
        this._reconnect();
      } else {
        this._eventEmitter.emit("error", event);
      }
    }
    /**
     * Resets the socket, removing all listeners and pending requests
     */
    reset() {
      this._sentRequestsQueue.clear();
      this._pendingRequestsQueue.clear();
      this._init();
      this._removeSocketListeners();
      this._addSocketListeners();
    }
    _reconnect() {
      if (this.isReconnecting) {
        return;
      }
      this.isReconnecting = true;
      if (this._sentRequestsQueue.size > 0) {
        this._sentRequestsQueue.forEach((request4, key) => {
          request4.deferredPromise.reject(new PendingRequestsOnReconnectingError());
          this._sentRequestsQueue.delete(key);
        });
      }
      if (this._reconnectAttempts < this._reconnectOptions.maxAttempts) {
        this._reconnectAttempts += 1;
        setTimeout(() => {
          this._removeSocketListeners();
          this.connect();
          this.isReconnecting = false;
        }, this._reconnectOptions.delay);
      } else {
        this.isReconnecting = false;
        this._clearQueues();
        this._removeSocketListeners();
        this._eventEmitter.emit("error", new MaxAttemptsReachedOnReconnectingError(this._reconnectOptions.maxAttempts));
      }
    }
    /**
     *  Creates a request object to be sent to the server
     */
    request(request4) {
      return __awaiter6(this, void 0, void 0, function* () {
        if (isNullish2(this._socketConnection)) {
          throw new Error("Connection is undefined");
        }
        if (this.getStatus() === "disconnected") {
          this.connect();
        }
        const requestId = isBatchRequest(request4) ? request4[0].id : request4.id;
        if (!requestId) {
          throw new Web3WSProviderError("Request Id not defined");
        }
        if (this._sentRequestsQueue.has(requestId)) {
          throw new RequestAlreadySentError(requestId);
        }
        const deferredPromise = new Web3DeferredPromise();
        deferredPromise.catch((error) => {
          this._eventEmitter.emit("error", error);
        });
        const reqItem = {
          payload: request4,
          deferredPromise
        };
        if (this.getStatus() === "connecting") {
          this._pendingRequestsQueue.set(requestId, reqItem);
          return reqItem.deferredPromise;
        }
        this._sentRequestsQueue.set(requestId, reqItem);
        try {
          this._sendToSocket(reqItem.payload);
        } catch (error) {
          this._sentRequestsQueue.delete(requestId);
          this._eventEmitter.emit("error", error);
        }
        return deferredPromise;
      });
    }
    _onConnect() {
      this._connectionStatus = "connected";
      this._reconnectAttempts = 0;
      super._onConnect();
      this._sendPendingRequests();
    }
    _sendPendingRequests() {
      for (const [id, value] of this._pendingRequestsQueue.entries()) {
        this._sendToSocket(value.payload);
        this._pendingRequestsQueue.delete(id);
        this._sentRequestsQueue.set(id, value);
      }
    }
    _onMessage(event) {
      const responses = this._parseResponses(event);
      if (isNullish2(responses) || responses.length === 0) {
        return;
      }
      for (const response of responses) {
        if (isResponseWithNotification(response) && response.method.endsWith("_subscription")) {
          this._eventEmitter.emit("message", response);
          return;
        }
        const requestId = isBatchResponse(response) ? response[0].id : response.id;
        const requestItem = this._sentRequestsQueue.get(requestId);
        if (!requestItem) {
          return;
        }
        if (isBatchResponse(response) || isResponseWithResult(response) || isResponseWithError2(response)) {
          this._eventEmitter.emit("message", response);
          requestItem.deferredPromise.resolve(response);
        }
        this._sentRequestsQueue.delete(requestId);
      }
    }
    clearQueues(event) {
      this._clearQueues(event);
    }
    _clearQueues(event) {
      if (this._pendingRequestsQueue.size > 0) {
        this._pendingRequestsQueue.forEach((request4, key) => {
          request4.deferredPromise.reject(new ConnectionNotOpenError(event));
          this._pendingRequestsQueue.delete(key);
        });
      }
      if (this._sentRequestsQueue.size > 0) {
        this._sentRequestsQueue.forEach((request4, key) => {
          request4.deferredPromise.reject(new ConnectionNotOpenError(event));
          this._sentRequestsQueue.delete(key);
        });
      }
      this._removeSocketListeners();
    }
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_event_emitter.js
  var Web3EventEmitter = class {
    constructor() {
      this._emitter = new EventEmitter2();
    }
    on(eventName, fn) {
      this._emitter.on(eventName, fn);
    }
    once(eventName, fn) {
      this._emitter.once(eventName, fn);
    }
    off(eventName, fn) {
      this._emitter.off(eventName, fn);
    }
    emit(eventName, params) {
      this._emitter.emit(eventName, params);
    }
    listenerCount(eventName) {
      return this._emitter.listenerCount(eventName);
    }
    listeners(eventName) {
      return this._emitter.listeners(eventName);
    }
    eventNames() {
      return this._emitter.eventNames();
    }
    removeAllListeners() {
      return this._emitter.removeAllListeners();
    }
    setMaxListenerWarningThreshold(maxListenersWarningThreshold) {
      this._emitter.setMaxListeners(maxListenersWarningThreshold);
    }
    getMaxListeners() {
      return this._emitter.getMaxListeners();
    }
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_config.js
  var Web3ConfigEvent;
  (function(Web3ConfigEvent2) {
    Web3ConfigEvent2["CONFIG_CHANGE"] = "CONFIG_CHANGE";
  })(Web3ConfigEvent || (Web3ConfigEvent = {}));
  var Web3Config = class extends Web3EventEmitter {
    constructor(options) {
      super();
      this.config = {
        handleRevert: false,
        defaultAccount: void 0,
        defaultBlock: "latest",
        transactionBlockTimeout: 50,
        transactionConfirmationBlocks: 24,
        transactionPollingInterval: 1e3,
        transactionPollingTimeout: 750 * 1e3,
        transactionReceiptPollingInterval: void 0,
        transactionSendTimeout: 750 * 1e3,
        transactionConfirmationPollingInterval: void 0,
        blockHeaderTimeout: 10,
        maxListenersWarningThreshold: 100,
        contractDataInputFill: "data",
        defaultNetworkId: void 0,
        defaultChain: "mainnet",
        defaultHardfork: "london",
        // TODO - Check if there is a default Common
        defaultCommon: void 0,
        defaultTransactionType: "0x2",
        defaultMaxPriorityFeePerGas: toHex(25e8),
        enableExperimentalFeatures: {
          useSubscriptionWhenCheckingBlockTimeout: false,
          useRpcCallSpecification: false
        },
        transactionBuilder: void 0,
        transactionTypeParser: void 0
      };
      this.setConfig(options !== null && options !== void 0 ? options : {});
    }
    setConfig(options) {
      const keys = Object.keys(options);
      for (const key of keys) {
        this._triggerConfigChange(key, options[key]);
      }
      Object.assign(this.config, options);
    }
    /**
     * The `handleRevert` options property returns the revert reason string if enabled for the following methods:
     * - web3.eth.sendTransaction()
     * - web3.eth.call()
     * - myContract.methods.myMethod().call()
     * - myContract.methods.myMethod().send()
     * Default is `false`.
     *
     * `Note`: At the moment `handleRevert` is only supported for `sendTransaction` and not for `sendSignedTransaction`
     */
    get handleRevert() {
      return this.config.handleRevert;
    }
    /**
     * Will set the handleRevert
     */
    set handleRevert(val) {
      this._triggerConfigChange("handleRevert", val);
      this.config.handleRevert = val;
    }
    /**
     * The `contractDataInputFill` options property will allow you to set the hash of the method signature and encoded parameters to the property
     * either `data`, `input` or both within your contract.
     * This will affect the contracts send, call and estimateGas methods
     * Default is `input`.
     */
    get contractDataInputFill() {
      return this.config.contractDataInputFill;
    }
    /**
     * Will set the contractDataInputFill
     */
    set contractDataInputFill(val) {
      this._triggerConfigChange("contractDataInputFill", val);
      this.config.contractDataInputFill = val;
    }
    /**
     * This default address is used as the default `from` property, if no `from` property is specified in for the following methods:
     * - web3.eth.sendTransaction()
     * - web3.eth.call()
     * - myContract.methods.myMethod().call()
     * - myContract.methods.myMethod().send()
     */
    get defaultAccount() {
      return this.config.defaultAccount;
    }
    /**
     * Will set the default account.
     */
    set defaultAccount(val) {
      this._triggerConfigChange("defaultAccount", val);
      this.config.defaultAccount = val;
    }
    /**
     * The default block is used for certain methods. You can override it by passing in the defaultBlock as last parameter. The default value is `"latest"`.
     * - web3.eth.getBalance()
     * - web3.eth.getCode()
     * - web3.eth.getTransactionCount()
     * - web3.eth.getStorageAt()
     * - web3.eth.call()
     * - myContract.methods.myMethod().call()
     */
    get defaultBlock() {
      return this.config.defaultBlock;
    }
    /**
     * Will set the default block.
     *
     * - A block number
     * - `"earliest"` - String: The genesis block
     * - `"latest"` - String: The latest block (current head of the blockchain)
     * - `"pending"` - String: The currently mined block (including pending transactions)
     * - `"finalized"` - String: (For POS networks) The finalized block is one which has been accepted as canonical by greater than 2/3 of validators
     * - `"safe"` - String: (For POS networks) The safe head block is one which under normal network conditions, is expected to be included in the canonical chain. Under normal network conditions the safe head and the actual tip of the chain will be equivalent (with safe head trailing only by a few seconds). Safe heads will be less likely to be reorged than the proof of work network`s latest blocks.
     */
    set defaultBlock(val) {
      this._triggerConfigChange("defaultBlock", val);
      this.config.defaultBlock = val;
    }
    /**
     * The time used to wait for Ethereum Node to return the sent transaction result.
     * Note: If the RPC call stuck at the Node and therefor timed-out, the transaction may still be pending or even mined by the Network. We recommend checking the pending transactions in such a case.
     * Default is `750` seconds (12.5 minutes).
     */
    get transactionSendTimeout() {
      return this.config.transactionSendTimeout;
    }
    /**
     * Will set the transactionSendTimeout.
     */
    set transactionSendTimeout(val) {
      this._triggerConfigChange("transactionSendTimeout", val);
      this.config.transactionSendTimeout = val;
    }
    /**
     * The `transactionBlockTimeout` is used over socket-based connections. This option defines the amount of new blocks it should wait until the first confirmation happens, otherwise the PromiEvent rejects with a timeout error.
     * Default is `50`.
     */
    get transactionBlockTimeout() {
      return this.config.transactionBlockTimeout;
    }
    /**
     * Will set the transactionBlockTimeout.
     */
    set transactionBlockTimeout(val) {
      this._triggerConfigChange("transactionBlockTimeout", val);
      this.config.transactionBlockTimeout = val;
    }
    /**
     * This defines the number of blocks it requires until a transaction is considered confirmed.
     * Default is `24`.
     */
    get transactionConfirmationBlocks() {
      return this.config.transactionConfirmationBlocks;
    }
    /**
     * Will set the transactionConfirmationBlocks.
     */
    set transactionConfirmationBlocks(val) {
      this._triggerConfigChange("transactionConfirmationBlocks", val);
      this.config.transactionConfirmationBlocks = val;
    }
    /**
     * Used over HTTP connections. This option defines the number of seconds between Web3 calls for a receipt which confirms that a transaction was mined by the network.
     * Default is `1000` ms.
     */
    get transactionPollingInterval() {
      return this.config.transactionPollingInterval;
    }
    /**
     * Will set the transactionPollingInterval.
     */
    set transactionPollingInterval(val) {
      this._triggerConfigChange("transactionPollingInterval", val);
      this.config.transactionPollingInterval = val;
      this.transactionReceiptPollingInterval = val;
      this.transactionConfirmationPollingInterval = val;
    }
    /**
     * Used over HTTP connections. This option defines the number of seconds Web3 will wait for a receipt which confirms that a transaction was mined by the network. Note: If this method times out, the transaction may still be pending.
     * Default is `750` seconds (12.5 minutes).
     */
    get transactionPollingTimeout() {
      return this.config.transactionPollingTimeout;
    }
    /**
     * Will set the transactionPollingTimeout.
     */
    set transactionPollingTimeout(val) {
      this._triggerConfigChange("transactionPollingTimeout", val);
      this.config.transactionPollingTimeout = val;
    }
    /**
     * The `transactionPollingInterval` is used over HTTP connections. This option defines the number of seconds between Web3 calls for a receipt which confirms that a transaction was mined by the network.
     * Default is `undefined`
     */
    get transactionReceiptPollingInterval() {
      return this.config.transactionReceiptPollingInterval;
    }
    /**
     * Will set the transactionReceiptPollingInterval
     */
    set transactionReceiptPollingInterval(val) {
      this._triggerConfigChange("transactionReceiptPollingInterval", val);
      this.config.transactionReceiptPollingInterval = val;
    }
    get transactionConfirmationPollingInterval() {
      return this.config.transactionConfirmationPollingInterval;
    }
    set transactionConfirmationPollingInterval(val) {
      this._triggerConfigChange("transactionConfirmationPollingInterval", val);
      this.config.transactionConfirmationPollingInterval = val;
    }
    /**
     * The blockHeaderTimeout is used over socket-based connections. This option defines the amount seconds it should wait for `'newBlockHeaders'` event before falling back to polling to fetch transaction receipt.
     * Default is `10` seconds.
     */
    get blockHeaderTimeout() {
      return this.config.blockHeaderTimeout;
    }
    /**
     * Will set the blockHeaderTimeout
     */
    set blockHeaderTimeout(val) {
      this._triggerConfigChange("blockHeaderTimeout", val);
      this.config.blockHeaderTimeout = val;
    }
    /**
     * The enableExperimentalFeatures is used to enable trying new experimental features that are still not fully implemented or not fully tested or still have some related issues.
     * Default is `false` for every feature.
     */
    get enableExperimentalFeatures() {
      return this.config.enableExperimentalFeatures;
    }
    /**
     * Will set the enableExperimentalFeatures
     */
    set enableExperimentalFeatures(val) {
      this._triggerConfigChange("enableExperimentalFeatures", val);
      this.config.enableExperimentalFeatures = val;
    }
    get maxListenersWarningThreshold() {
      return this.config.maxListenersWarningThreshold;
    }
    set maxListenersWarningThreshold(val) {
      this._triggerConfigChange("maxListenersWarningThreshold", val);
      this.setMaxListenerWarningThreshold(val);
      this.config.maxListenersWarningThreshold = val;
    }
    get defaultNetworkId() {
      return this.config.defaultNetworkId;
    }
    set defaultNetworkId(val) {
      this._triggerConfigChange("defaultNetworkId", val);
      this.config.defaultNetworkId = val;
    }
    get defaultChain() {
      return this.config.defaultChain;
    }
    set defaultChain(val) {
      if (!isNullish2(this.config.defaultCommon) && !isNullish2(this.config.defaultCommon.baseChain) && val !== this.config.defaultCommon.baseChain)
        throw new ConfigChainMismatchError(this.config.defaultChain, val);
      this._triggerConfigChange("defaultChain", val);
      this.config.defaultChain = val;
    }
    /**
     * Will return the default hardfork. Default is `london`
     * The default hardfork property can be one of the following:
     * - `chainstart`
     * - `homestead`
     * - `dao`
     * - `tangerineWhistle`
     * - `spuriousDragon`
     * - `byzantium`
     * - `constantinople`
     * - `petersburg`
     * - `istanbul`
     * - `berlin`
     * - `london`
     * - 'arrowGlacier',
     * - 'tangerineWhistle',
     * - 'muirGlacier'
     *
     */
    get defaultHardfork() {
      return this.config.defaultHardfork;
    }
    /**
     * Will set the default hardfork.
     *
     */
    set defaultHardfork(val) {
      if (!isNullish2(this.config.defaultCommon) && !isNullish2(this.config.defaultCommon.hardfork) && val !== this.config.defaultCommon.hardfork)
        throw new ConfigHardforkMismatchError(this.config.defaultCommon.hardfork, val);
      this._triggerConfigChange("defaultHardfork", val);
      this.config.defaultHardfork = val;
    }
    /**
     *
     * Will get the default common property
     * The default common property does contain the following Common object:
     * - `customChain` - `Object`: The custom chain properties
     * 	- `name` - `string`: (optional) The name of the chain
     * 	- `networkId` - `number`: Network ID of the custom chain
     * 	- `chainId` - `number`: Chain ID of the custom chain
     * - `baseChain` - `string`: (optional) mainnet, goerli, kovan, rinkeby, or ropsten
     * - `hardfork` - `string`: (optional) chainstart, homestead, dao, tangerineWhistle, spuriousDragon, byzantium, constantinople, petersburg, istanbul, berlin, or london
     * Default is `undefined`.
     *
     */
    get defaultCommon() {
      return this.config.defaultCommon;
    }
    /**
     * Will set the default common property
     *
     */
    set defaultCommon(val) {
      if (!isNullish2(this.config.defaultHardfork) && !isNullish2(val) && !isNullish2(val.hardfork) && this.config.defaultHardfork !== val.hardfork)
        throw new ConfigHardforkMismatchError(this.config.defaultHardfork, val.hardfork);
      if (!isNullish2(this.config.defaultChain) && !isNullish2(val) && !isNullish2(val.baseChain) && this.config.defaultChain !== val.baseChain)
        throw new ConfigChainMismatchError(this.config.defaultChain, val.baseChain);
      this._triggerConfigChange("defaultCommon", val);
      this.config.defaultCommon = val;
    }
    get defaultTransactionType() {
      return this.config.defaultTransactionType;
    }
    set defaultTransactionType(val) {
      this._triggerConfigChange("defaultTransactionType", val);
      this.config.defaultTransactionType = val;
    }
    get defaultMaxPriorityFeePerGas() {
      return this.config.defaultMaxPriorityFeePerGas;
    }
    set defaultMaxPriorityFeePerGas(val) {
      this._triggerConfigChange("defaultMaxPriorityFeePerGas", val);
      this.config.defaultMaxPriorityFeePerGas = val;
    }
    get transactionBuilder() {
      return this.config.transactionBuilder;
    }
    set transactionBuilder(val) {
      this._triggerConfigChange("transactionBuilder", val);
      this.config.transactionBuilder = val;
    }
    get transactionTypeParser() {
      return this.config.transactionTypeParser;
    }
    set transactionTypeParser(val) {
      this._triggerConfigChange("transactionTypeParser", val);
      this.config.transactionTypeParser = val;
    }
    _triggerConfigChange(config, newValue) {
      this.emit(Web3ConfigEvent.CONFIG_CHANGE, {
        name: config,
        oldValue: this.config[config],
        newValue
      });
    }
  };

  // ../../node_modules/.pnpm/web3-providers-http@4.1.0_encoding@0.1.13/node_modules/web3-providers-http/lib/esm/index.js
  var import_cross_fetch = __toESM(require_browser_ponyfill(), 1);
  var __awaiter7 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var HttpProvider = class _HttpProvider extends Web3BaseProvider {
    constructor(clientUrl, httpProviderOptions) {
      super();
      if (!_HttpProvider.validateClientUrl(clientUrl))
        throw new InvalidClientError(clientUrl);
      this.clientUrl = clientUrl;
      this.httpProviderOptions = httpProviderOptions;
    }
    static validateClientUrl(clientUrl) {
      return typeof clientUrl === "string" ? /^http(s)?:\/\//i.test(clientUrl) : false;
    }
    /* eslint-disable class-methods-use-this */
    getStatus() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    supportsSubscriptions() {
      return false;
    }
    request(payload, requestOptions) {
      var _a6;
      return __awaiter7(this, void 0, void 0, function* () {
        const providerOptionsCombined = Object.assign(Object.assign({}, (_a6 = this.httpProviderOptions) === null || _a6 === void 0 ? void 0 : _a6.providerOptions), requestOptions);
        const response = yield (0, import_cross_fetch.default)(this.clientUrl, Object.assign(Object.assign({}, providerOptionsCombined), { method: "POST", headers: Object.assign(Object.assign({}, providerOptionsCombined.headers), { "Content-Type": "application/json" }), body: JSON.stringify(payload) }));
        if (!response.ok)
          throw new ResponseError(yield response.json());
        return yield response.json();
      });
    }
    /* eslint-disable class-methods-use-this */
    on() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    removeListener() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    once() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    removeAllListeners() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    connect() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    disconnect() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    reset() {
      throw new MethodNotImplementedError();
    }
    /* eslint-disable class-methods-use-this */
    reconnect() {
      throw new MethodNotImplementedError();
    }
  };

  // ../../node_modules/.pnpm/isomorphic-ws@5.0.0_ws@8.15.0_bufferutil@4.0.7_utf-8-validate@6.0.3_/node_modules/isomorphic-ws/browser.js
  var ws = null;
  if (typeof WebSocket !== "undefined") {
    ws = WebSocket;
  } else if (typeof MozWebSocket !== "undefined") {
    ws = MozWebSocket;
  } else if (typeof global !== "undefined") {
    ws = global.WebSocket || global.MozWebSocket;
  } else if (typeof window !== "undefined") {
    ws = window.WebSocket || window.MozWebSocket;
  } else if (typeof self !== "undefined") {
    ws = self.WebSocket || self.MozWebSocket;
  }
  var browser_default2 = ws;

  // ../../node_modules/.pnpm/web3-providers-ws@4.0.7_bufferutil@4.0.7_utf-8-validate@6.0.3/node_modules/web3-providers-ws/lib/esm/index.js
  var WebSocketProvider = class extends SocketProvider {
    /**
     * This is a class used for Web Socket connections. It extends the abstract class SocketProvider {@link SocketProvider} that extends the EIP-1193 provider {@link EIP1193Provider}.
     * @param socketPath - The path to the Web Socket.
     * @param socketOptions - The options for the Web Socket client.
     * @param reconnectOptions - The options for the socket reconnection {@link ReconnectOptions}
     */
    // this constructor is to specify the type for `socketOptions` for a better intellisense.
    // eslint-disable-next-line no-useless-constructor
    constructor(socketPath, socketOptions, reconnectOptions) {
      super(socketPath, socketOptions, reconnectOptions);
    }
    // eslint-disable-next-line class-methods-use-this
    _validateProviderPath(providerUrl) {
      return typeof providerUrl === "string" ? /^ws(s)?:\/\//i.test(providerUrl) : false;
    }
    getStatus() {
      if (this._socketConnection && !isNullish2(this._socketConnection)) {
        switch (this._socketConnection.readyState) {
          case this._socketConnection.CONNECTING: {
            return "connecting";
          }
          case this._socketConnection.OPEN: {
            return "connected";
          }
          default: {
            return "disconnected";
          }
        }
      }
      return "disconnected";
    }
    _openSocketConnection() {
      this._socketConnection = new browser_default2(this._socketPath, void 0, this._socketOptions && Object.keys(this._socketOptions).length === 0 ? void 0 : this._socketOptions);
    }
    _closeSocketConnection(code, data) {
      var _a6;
      (_a6 = this._socketConnection) === null || _a6 === void 0 ? void 0 : _a6.close(code, data);
    }
    _sendToSocket(payload) {
      var _a6;
      if (this.getStatus() === "disconnected") {
        throw new ConnectionNotOpenError();
      }
      (_a6 = this._socketConnection) === null || _a6 === void 0 ? void 0 : _a6.send(JSON.stringify(payload));
    }
    _parseResponses(event) {
      return this.chunkResponseParser.parseResponse(event.data);
    }
    _addSocketListeners() {
      var _a6, _b3, _c2, _d;
      (_a6 = this._socketConnection) === null || _a6 === void 0 ? void 0 : _a6.addEventListener("open", this._onOpenHandler);
      (_b3 = this._socketConnection) === null || _b3 === void 0 ? void 0 : _b3.addEventListener("message", this._onMessageHandler);
      (_c2 = this._socketConnection) === null || _c2 === void 0 ? void 0 : _c2.addEventListener("close", (e2) => this._onCloseHandler(e2));
      (_d = this._socketConnection) === null || _d === void 0 ? void 0 : _d.addEventListener("error", this._onErrorHandler);
    }
    _removeSocketListeners() {
      var _a6, _b3, _c2;
      (_a6 = this._socketConnection) === null || _a6 === void 0 ? void 0 : _a6.removeEventListener("message", this._onMessageHandler);
      (_b3 = this._socketConnection) === null || _b3 === void 0 ? void 0 : _b3.removeEventListener("open", this._onOpenHandler);
      (_c2 = this._socketConnection) === null || _c2 === void 0 ? void 0 : _c2.removeEventListener("close", this._onCloseHandler);
    }
    _onCloseEvent(event) {
      var _a6;
      if (this._reconnectOptions.autoReconnect && (![1e3, 1001].includes(event.code) || !event.wasClean)) {
        this._reconnect();
        return;
      }
      this._clearQueues(event);
      this._removeSocketListeners();
      this._onDisconnect(event.code, event.reason);
      (_a6 = this._socketConnection) === null || _a6 === void 0 ? void 0 : _a6.removeEventListener("error", this._onErrorHandler);
    }
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/utils.js
  var isWeb3Provider = (provider) => Web3BaseProvider.isWeb3Provider(provider);
  var isLegacyRequestProvider = (provider) => typeof provider !== "string" && "request" in provider && provider.request.constructor.name === "Function";
  var isEIP1193Provider = (provider) => typeof provider !== "string" && "request" in provider && provider.request.constructor.name === "AsyncFunction";
  var isLegacySendProvider = (provider) => typeof provider !== "string" && "send" in provider;
  var isLegacySendAsyncProvider = (provider) => typeof provider !== "string" && "sendAsync" in provider;
  var isSupportedProvider = (provider) => provider && (isWeb3Provider(provider) || isEIP1193Provider(provider) || isLegacyRequestProvider(provider) || isLegacySendAsyncProvider(provider) || isLegacySendProvider(provider));
  var isSupportSubscriptions = (provider) => {
    if (provider && "supportsSubscriptions" in provider) {
      return provider.supportsSubscriptions();
    }
    if (provider && typeof provider !== "string" && "on" in provider) {
      return true;
    }
    return false;
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_request_manager.js
  var __awaiter8 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Web3RequestManagerEvent;
  (function(Web3RequestManagerEvent2) {
    Web3RequestManagerEvent2["PROVIDER_CHANGED"] = "PROVIDER_CHANGED";
    Web3RequestManagerEvent2["BEFORE_PROVIDER_CHANGE"] = "BEFORE_PROVIDER_CHANGE";
  })(Web3RequestManagerEvent || (Web3RequestManagerEvent = {}));
  var availableProviders = {
    HttpProvider,
    WebsocketProvider: WebSocketProvider
  };
  var Web3RequestManager = class _Web3RequestManager extends Web3EventEmitter {
    constructor(provider, useRpcCallSpecification) {
      super();
      if (!isNullish2(provider)) {
        this.setProvider(provider);
      }
      this.useRpcCallSpecification = useRpcCallSpecification;
    }
    /**
     * Will return all available providers
     */
    static get providers() {
      return availableProviders;
    }
    /**
     * Will return the current provider.
     *
     * @returns Returns the current provider
     */
    get provider() {
      return this._provider;
    }
    /**
     * Will return all available providers
     */
    // eslint-disable-next-line class-methods-use-this
    get providers() {
      return availableProviders;
    }
    /**
     * Use to set provider. Provider can be a provider instance or a string.
     *
     * @param provider - The provider to set
     */
    setProvider(provider) {
      let newProvider;
      if (provider && typeof provider === "string" && this.providers) {
        if (/^http(s)?:\/\//i.test(provider)) {
          newProvider = new this.providers.HttpProvider(provider);
        } else if (/^ws(s)?:\/\//i.test(provider)) {
          newProvider = new this.providers.WebsocketProvider(provider);
        } else {
          throw new ProviderError(`Can't autodetect provider for "${provider}"`);
        }
      } else if (isNullish2(provider)) {
        newProvider = void 0;
      } else {
        newProvider = provider;
      }
      this.emit(Web3RequestManagerEvent.BEFORE_PROVIDER_CHANGE, this._provider);
      this._provider = newProvider;
      this.emit(Web3RequestManagerEvent.PROVIDER_CHANGED, this._provider);
      return true;
    }
    /**
     *
     * Will execute a request
     *
     * @param request - {@link Web3APIRequest} The request to send
     *
     * @returns The response of the request {@link ResponseType}. If there is error
     * in the response, will throw an error
     */
    send(request4) {
      return __awaiter8(this, void 0, void 0, function* () {
        const response = yield this._sendRequest(request4);
        if (json_rpc_exports.isResponseWithResult(response)) {
          return response.result;
        }
        throw new ResponseError(response);
      });
    }
    /**
     * Same as send, but, will execute a batch of requests
     *
     * @param request {@link JsonRpcBatchRequest} The batch request to send
     */
    sendBatch(request4) {
      return __awaiter8(this, void 0, void 0, function* () {
        const response = yield this._sendRequest(request4);
        return response;
      });
    }
    _sendRequest(request4) {
      return __awaiter8(this, void 0, void 0, function* () {
        const { provider } = this;
        if (isNullish2(provider)) {
          throw new ProviderError("Provider not available. Use `.setProvider` or `.provider=` to initialize the provider.");
        }
        const payload = json_rpc_exports.isBatchRequest(request4) ? json_rpc_exports.toBatchPayload(request4) : json_rpc_exports.toPayload(request4);
        if (isWeb3Provider(provider)) {
          let response;
          try {
            response = yield provider.request(payload);
          } catch (error) {
            response = error;
          }
          return this._processJsonRpcResponse(payload, response, { legacy: false, error: false });
        }
        if (isEIP1193Provider(provider)) {
          return provider.request(payload).then((res) => this._processJsonRpcResponse(payload, res, {
            legacy: true,
            error: false
          })).catch((error) => this._processJsonRpcResponse(payload, error, { legacy: true, error: true }));
        }
        if (isLegacyRequestProvider(provider)) {
          return new Promise((resolve2, reject) => {
            const rejectWithError = (err3) => reject(this._processJsonRpcResponse(payload, err3, {
              legacy: true,
              error: true
            }));
            const resolveWithResponse = (response) => resolve2(this._processJsonRpcResponse(payload, response, {
              legacy: true,
              error: false
            }));
            const result = provider.request(
              payload,
              // a callback that is expected to be called after getting the response:
              (err3, response) => {
                if (err3) {
                  return rejectWithError(err3);
                }
                return resolveWithResponse(response);
              }
            );
            if (isPromise(result)) {
              const responsePromise = result;
              responsePromise.then(resolveWithResponse).catch(rejectWithError);
            }
          });
        }
        if (isLegacySendProvider(provider)) {
          return new Promise((resolve2, reject) => {
            provider.send(payload, (err3, response) => {
              if (err3) {
                return reject(this._processJsonRpcResponse(payload, err3, {
                  legacy: true,
                  error: true
                }));
              }
              if (isNullish2(response)) {
                throw new ResponseError("", 'Got a "nullish" response from provider.');
              }
              return resolve2(this._processJsonRpcResponse(payload, response, {
                legacy: true,
                error: false
              }));
            });
          });
        }
        if (isLegacySendAsyncProvider(provider)) {
          return provider.sendAsync(payload).then((response) => this._processJsonRpcResponse(payload, response, { legacy: true, error: false })).catch((error) => this._processJsonRpcResponse(payload, error, {
            legacy: true,
            error: true
          }));
        }
        throw new ProviderError("Provider does not have a request or send method to use.");
      });
    }
    // eslint-disable-next-line class-methods-use-this
    _processJsonRpcResponse(payload, response, { legacy, error }) {
      if (isNullish2(response)) {
        return this._buildResponse(
          payload,
          // Some providers uses "null" as valid empty response
          // eslint-disable-next-line no-null/no-null
          null,
          error
        );
      }
      if (json_rpc_exports.isResponseWithError(response)) {
        if (this.useRpcCallSpecification && isResponseRpcError(response)) {
          const rpcErrorResponse = response;
          if (rpcErrorsMap.get(rpcErrorResponse.error.code)) {
            const Err = rpcErrorsMap.get(rpcErrorResponse.error.code).error;
            throw new Err(rpcErrorResponse);
          } else {
            throw new RpcError(rpcErrorResponse);
          }
        } else if (!_Web3RequestManager._isReverted(response)) {
          throw new InvalidResponseError(response, payload);
        }
      }
      if (json_rpc_exports.isResponseWithResult(response)) {
        return response;
      }
      if (response instanceof Error) {
        _Web3RequestManager._isReverted(response);
        throw response;
      }
      if (!legacy && json_rpc_exports.isBatchRequest(payload) && json_rpc_exports.isBatchResponse(response)) {
        return response;
      }
      if (legacy && !error && json_rpc_exports.isBatchRequest(payload)) {
        return response;
      }
      if (legacy && error && json_rpc_exports.isBatchRequest(payload)) {
        throw response;
      }
      if (legacy && !json_rpc_exports.isResponseWithError(response) && !json_rpc_exports.isResponseWithResult(response)) {
        return this._buildResponse(payload, response, error);
      }
      if (json_rpc_exports.isBatchRequest(payload) && !Array.isArray(response)) {
        throw new ResponseError(response, "Got normal response for a batch request.");
      }
      if (!json_rpc_exports.isBatchRequest(payload) && Array.isArray(response)) {
        throw new ResponseError(response, "Got batch response for a normal request.");
      }
      if ((json_rpc_exports.isResponseWithError(response) || json_rpc_exports.isResponseWithResult(response)) && !json_rpc_exports.isBatchRequest(payload)) {
        if (response.id && payload.id !== response.id) {
          throw new InvalidResponseError(response);
        }
      }
      throw new ResponseError(response, "Invalid response");
    }
    static _isReverted(response) {
      let error;
      if (json_rpc_exports.isResponseWithError(response)) {
        error = response.error;
      } else if (response instanceof Error) {
        error = response;
      }
      if (error === null || error === void 0 ? void 0 : error.message.includes("revert"))
        throw new ContractExecutionError(error);
      return false;
    }
    // Need to use same types as _processJsonRpcResponse so have to declare as instance method
    // eslint-disable-next-line class-methods-use-this
    _buildResponse(payload, response, error) {
      const res = {
        jsonrpc: "2.0",
        // eslint-disable-next-line no-nested-ternary
        id: json_rpc_exports.isBatchRequest(payload) ? payload[0].id : "id" in payload ? payload.id : (
          // Have to use the null here explicitly
          // eslint-disable-next-line no-null/no-null
          null
        )
      };
      if (error) {
        return Object.assign(Object.assign({}, res), { error: response });
      }
      return Object.assign(Object.assign({}, res), { result: response });
    }
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_subscription_manager.js
  var __awaiter9 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Web3SubscriptionManager = class {
    constructor(requestManager, registeredSubscriptions2, tolerateUnlinkedSubscription = false) {
      this.requestManager = requestManager;
      this.registeredSubscriptions = registeredSubscriptions2;
      this.tolerateUnlinkedSubscription = tolerateUnlinkedSubscription;
      this._subscriptions = /* @__PURE__ */ new Map();
      this.requestManager.on(Web3RequestManagerEvent.BEFORE_PROVIDER_CHANGE, () => __awaiter9(this, void 0, void 0, function* () {
        yield this.unsubscribe();
      }));
      this.requestManager.on(Web3RequestManagerEvent.PROVIDER_CHANGED, () => {
        this.clear();
        this.listenToProviderEvents();
      });
      this.listenToProviderEvents();
    }
    listenToProviderEvents() {
      const providerAsWebProvider = this.requestManager.provider;
      if (!this.requestManager.provider || typeof (providerAsWebProvider === null || providerAsWebProvider === void 0 ? void 0 : providerAsWebProvider.supportsSubscriptions) === "function" && !(providerAsWebProvider === null || providerAsWebProvider === void 0 ? void 0 : providerAsWebProvider.supportsSubscriptions())) {
        return;
      }
      if (typeof this.requestManager.provider.on === "function") {
        if (typeof this.requestManager.provider.request === "function") {
          this.requestManager.provider.on(
            "message",
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
            (message) => this.messageListener(message)
          );
        } else {
          providerAsWebProvider.on("data", (data) => this.messageListener(data));
        }
      }
    }
    messageListener(data) {
      var _a6, _b3, _c2;
      if (!data) {
        throw new SubscriptionError("Should not call messageListener with no data. Type was");
      }
      const subscriptionId = ((_a6 = data.params) === null || _a6 === void 0 ? void 0 : _a6.subscription) || ((_b3 = data.data) === null || _b3 === void 0 ? void 0 : _b3.subscription) || ((_c2 = data.id) === null || _c2 === void 0 ? void 0 : _c2.toString(16));
      if (subscriptionId) {
        const sub = this._subscriptions.get(subscriptionId);
        sub === null || sub === void 0 ? void 0 : sub.processSubscriptionData(data);
      }
    }
    /**
     * Will create a new subscription
     *
     * @param name - The subscription you want to subscribe to
     * @param args - Optional additional parameters, depending on the subscription type
     * @param returnFormat- ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     *
     * Will subscribe to a specific topic (note: name)
     * @returns The subscription object
     */
    subscribe(name2, args, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter9(this, void 0, void 0, function* () {
        const Klass = this.registeredSubscriptions[name2];
        if (!Klass) {
          throw new SubscriptionError("Invalid subscription type");
        }
        const subscription = new Klass(args !== null && args !== void 0 ? args : void 0, {
          subscriptionManager: this,
          returnFormat
        });
        yield this.addSubscription(subscription);
        return subscription;
      });
    }
    /**
     * Will returns all subscriptions.
     */
    get subscriptions() {
      return this._subscriptions;
    }
    /**
     *
     * Adds an instance of {@link Web3Subscription} and subscribes to it
     *
     * @param sub - A {@link Web3Subscription} object
     */
    addSubscription(sub) {
      return __awaiter9(this, void 0, void 0, function* () {
        if (!this.requestManager.provider) {
          throw new ProviderError("Provider not available");
        }
        if (!this.supportsSubscriptions()) {
          throw new SubscriptionError("The current provider does not support subscriptions");
        }
        if (sub.id && this._subscriptions.has(sub.id)) {
          throw new SubscriptionError(`Subscription with id "${sub.id}" already exists`);
        }
        yield sub.sendSubscriptionRequest();
        if (isNullish2(sub.id)) {
          throw new SubscriptionError("Subscription is not subscribed yet.");
        }
        this._subscriptions.set(sub.id, sub);
        return sub.id;
      });
    }
    /**
     * Will clear a subscription
     *
     * @param id - The subscription of type {@link Web3Subscription}  to remove
     */
    removeSubscription(sub) {
      return __awaiter9(this, void 0, void 0, function* () {
        const { id } = sub;
        if (isNullish2(id)) {
          throw new SubscriptionError("Subscription is not subscribed yet. Or, had already been unsubscribed but not through the Subscription Manager.");
        }
        if (!this._subscriptions.has(id) && !this.tolerateUnlinkedSubscription) {
          throw new SubscriptionError(`Subscription with id "${id.toString()}" does not exists`);
        }
        yield sub.sendUnsubscribeRequest();
        this._subscriptions.delete(id);
        return id;
      });
    }
    /**
     * Will unsubscribe all subscriptions that fulfill the condition
     *
     * @param condition - A function that access and `id` and a `subscription` and return `true` or `false`
     * @returns An array of all the un-subscribed subscriptions
     */
    unsubscribe(condition) {
      return __awaiter9(this, void 0, void 0, function* () {
        const result = [];
        for (const [id, sub] of this.subscriptions.entries()) {
          if (!condition || typeof condition === "function" && condition({ id, sub })) {
            result.push(this.removeSubscription(sub));
          }
        }
        return Promise.all(result);
      });
    }
    /**
     * Clears all subscriptions
     */
    clear() {
      this._subscriptions.clear();
    }
    /**
     * Check whether the current provider supports subscriptions.
     *
     * @returns `true` or `false` depending on if the current provider supports subscriptions
     */
    supportsSubscriptions() {
      return isNullish2(this.requestManager.provider) ? false : isSupportSubscriptions(this.requestManager.provider);
    }
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_subscriptions.js
  var __awaiter10 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Web3Subscription = class extends Web3EventEmitter {
    constructor(args, options) {
      var _a6;
      super();
      this.args = args;
      const { requestManager } = options;
      const { subscriptionManager } = options;
      if (requestManager && subscriptionManager) {
        throw new SubscriptionError("Only requestManager or subscriptionManager should be provided at Subscription constructor");
      }
      if (!requestManager && !subscriptionManager) {
        throw new SubscriptionError("Either requestManager or subscriptionManager should be provided at Subscription constructor");
      }
      if (requestManager) {
        this._subscriptionManager = new Web3SubscriptionManager(requestManager, {}, true);
      } else {
        this._subscriptionManager = subscriptionManager;
      }
      this._returnFormat = (_a6 = options === null || options === void 0 ? void 0 : options.returnFormat) !== null && _a6 !== void 0 ? _a6 : DEFAULT_RETURN_FORMAT;
    }
    get id() {
      return this._id;
    }
    get lastBlock() {
      return this._lastBlock;
    }
    subscribe() {
      return __awaiter10(this, void 0, void 0, function* () {
        return this._subscriptionManager.addSubscription(this);
      });
    }
    processSubscriptionData(data) {
      var _a6, _b3;
      if (data === null || data === void 0 ? void 0 : data.data) {
        this._processSubscriptionResult((_b3 = (_a6 = data === null || data === void 0 ? void 0 : data.data) === null || _a6 === void 0 ? void 0 : _a6.result) !== null && _b3 !== void 0 ? _b3 : data === null || data === void 0 ? void 0 : data.data);
      } else if (data && json_rpc_exports.isResponseWithNotification(data)) {
        this._processSubscriptionResult(data === null || data === void 0 ? void 0 : data.params.result);
      }
    }
    sendSubscriptionRequest() {
      return __awaiter10(this, void 0, void 0, function* () {
        this._id = yield this._subscriptionManager.requestManager.send({
          method: "eth_subscribe",
          params: this._buildSubscriptionParams()
        });
        this.emit("connected", this._id);
        return this._id;
      });
    }
    get returnFormat() {
      return this._returnFormat;
    }
    get subscriptionManager() {
      return this._subscriptionManager;
    }
    resubscribe() {
      return __awaiter10(this, void 0, void 0, function* () {
        yield this.unsubscribe();
        yield this.subscribe();
      });
    }
    unsubscribe() {
      return __awaiter10(this, void 0, void 0, function* () {
        if (!this.id) {
          return;
        }
        yield this._subscriptionManager.removeSubscription(this);
      });
    }
    sendUnsubscribeRequest() {
      return __awaiter10(this, void 0, void 0, function* () {
        yield this._subscriptionManager.requestManager.send({
          method: "eth_unsubscribe",
          params: [this.id]
        });
        this._id = void 0;
      });
    }
    // eslint-disable-next-line class-methods-use-this
    formatSubscriptionResult(data) {
      return data;
    }
    _processSubscriptionResult(data) {
      this.emit("data", this.formatSubscriptionResult(data));
    }
    _processSubscriptionError(error) {
      this.emit("error", error);
    }
    // eslint-disable-next-line class-methods-use-this
    _buildSubscriptionParams() {
      throw new Error("Implement in the child class");
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/wallet.js
  var __awaiter11 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Wallet = class _Wallet extends Web3BaseWallet {
    constructor() {
      super(...arguments);
      this._addressMap = /* @__PURE__ */ new Map();
      this._defaultKeyName = "web3js_wallet";
    }
    /**
     * Get the storage object of the browser
     *
     * @returns the storage
     */
    static getStorage() {
      let storage;
      try {
        storage = window.localStorage;
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return storage;
      } catch (e2) {
        return e2 && // everything except Firefox
        (e2.code === 22 || // Firefox
        e2.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e2.name === "QuotaExceededError" || // Firefox
        e2.name === "NS_ERROR_DOM_QUOTA_REACHED") && // acknowledge QuotaExceededError only if there's something already stored
        !isNullish(storage) && storage.length !== 0 ? storage : void 0;
      }
    }
    /**
     * Generates one or more accounts in the wallet. If wallets already exist they will not be overridden.
     *
     * @param numberOfAccounts - Number of accounts to create. Leave empty to create an empty wallet.
     * @returns The wallet
     * ```ts
     * web3.eth.accounts.wallet.create(2)
     * > Wallet(2) [
     *   {
     *     address: '0xde38310a42B751AE57d30cFFF4a0A3c52A442fCE',
     *     privateKey: '0x6422c9d28efdcbee93c1d32a5fc6fd6fa081b985487885296cf8c9bbb5872600',
     *     signTransaction: [Function: signTransaction],
     *     sign: [Function: sign],
     *     encrypt: [Function: encrypt]
     *   },
     *   {
     *     address: '0x766BF755246d924B1d017Fdb5390f38a60166691',
     *     privateKey: '0x756530f13c0eb636ebdda655335f5dea9921e3362e2e588b0ad59e556f7751f0',
     *     signTransaction: [Function: signTransaction],
     *     sign: [Function: sign],
     *     encrypt: [Function: encrypt]
     *   },
     *   _accountProvider: {
     *     create: [Function: create],
     *     privateKeyToAccount: [Function: privateKeyToAccount],
     *     decrypt: [Function: decrypt]
     *   },
     *   _addressMap: Map(2) {
     *     '0xde38310a42b751ae57d30cfff4a0a3c52a442fce' => 0,
     *     '0x766bf755246d924b1d017fdb5390f38a60166691' => 1
     *   },
     *   _defaultKeyName: 'web3js_wallet'
     * ]
     *
     * ```
     */
    create(numberOfAccounts) {
      for (let i2 = 0; i2 < numberOfAccounts; i2 += 1) {
        this.add(this._accountProvider.create());
      }
      return this;
    }
    /**
     * Adds an account using a private key or account object to the wallet.
     *
     * @param account - A private key or account object
     * @returns The wallet
     *
     * ```ts
     * web3.eth.accounts.wallet.add('0xbce9b59981303e76c4878b1a6d7b088ec6b9dd5c966b7d5f54d7a749ff683387');
     * > Wallet(1) [
     *   {
     *     address: '0x85D70633b90e03e0276B98880286D0D055685ed7',
     *     privateKey: '0xbce9b59981303e76c4878b1a6d7b088ec6b9dd5c966b7d5f54d7a749ff683387',
     *     signTransaction: [Function: signTransaction],
     *     sign: [Function: sign],
     *     encrypt: [Function: encrypt]
     *   },
     *   _accountProvider: {
     *     create: [Function: create],
     *     privateKeyToAccount: [Function: privateKeyToAccount],
     *     decrypt: [Function: decrypt]
     *   },
     *   _addressMap: Map(1) { '0x85d70633b90e03e0276b98880286d0d055685ed7' => 0 },
     *   _defaultKeyName: 'web3js_wallet'
     * ]
     * ```
     */
    add(account) {
      var _a6;
      if (typeof account === "string") {
        return this.add(this._accountProvider.privateKeyToAccount(account));
      }
      let index2 = this.length;
      const existAccount = this.get(account.address);
      if (existAccount) {
        console.warn(`Account ${account.address.toLowerCase()} already exists.`);
        index2 = (_a6 = this._addressMap.get(account.address.toLowerCase())) !== null && _a6 !== void 0 ? _a6 : index2;
      }
      this._addressMap.set(account.address.toLowerCase(), index2);
      this[index2] = account;
      return this;
    }
    /**
     * Get the account of the wallet with either the index or public address.
     *
     * @param addressOrIndex - A string of the address or number index within the wallet.
     * @returns The account object or undefined if the account doesn't exist
     */
    get(addressOrIndex) {
      if (typeof addressOrIndex === "string") {
        const index2 = this._addressMap.get(addressOrIndex.toLowerCase());
        if (!isNullish(index2)) {
          return this[index2];
        }
        return void 0;
      }
      return this[addressOrIndex];
    }
    /**
     * Removes an account from the wallet.
     *
     * @param addressOrIndex - The account address, or index in the wallet.
     * @returns true if the wallet was removed. false if it couldn't be found.
     * ```ts
     * web3.eth.accounts.wallet.add('0xbce9b59981303e76c4878b1a6d7b088ec6b9dd5c966b7d5f54d7a749ff683387');
     *
     * web3.eth.accounts.wallet.remove('0x85D70633b90e03e0276B98880286D0D055685ed7');
     * > true
     * web3.eth.accounts.wallet
     * > Wallet(0) [
     * _accountProvider: {
     *   create: [Function: create],
     *   privateKeyToAccount: [Function: privateKeyToAccount],
     *   decrypt: [Function: decrypt]
     * },
     * _addressMap: Map(0) {},
     * _defaultKeyName: 'web3js_wallet'
     * ]
     * ```
     */
    remove(addressOrIndex) {
      if (typeof addressOrIndex === "string") {
        const index2 = this._addressMap.get(addressOrIndex.toLowerCase());
        if (isNullish(index2)) {
          return false;
        }
        this._addressMap.delete(addressOrIndex.toLowerCase());
        this.splice(index2, 1);
        return true;
      }
      if (this[addressOrIndex]) {
        this.splice(addressOrIndex, 1);
        return true;
      }
      return false;
    }
    /**
     * Securely empties the wallet and removes all its accounts.
     * Use this with *caution as it will remove all accounts stored in local wallet.
     *
     * @returns The wallet object
     * ```ts
     *
     * web3.eth.accounts.wallet.clear();
     * > Wallet(0) [
     * _accountProvider: {
     *   create: [Function: create],
     *   privateKeyToAccount: [Function: privateKeyToAccount],
     *   decrypt: [Function: decrypt]
     * },
     * _addressMap: Map(0) {},
     * _defaultKeyName: 'web3js_wallet'
     * ]
     * ```
     */
    clear() {
      this._addressMap.clear();
      this.length = 0;
      return this;
    }
    /**
     * Encrypts all wallet accounts to an array of encrypted keystore v3 objects.
     *
     * @param password - The password which will be used for encryption
     * @param options - encryption options
     * @returns An array of the encrypted keystore v3.
     *
     * ```ts
     * web3.eth.accounts.wallet.create(1)
     * web3.eth.accounts.wallet.encrypt("abc").then(console.log);
     * > [
     * '{"version":3,"id":"fa46e213-a7c3-4844-b903-dd14d39cc7db",
     * "address":"fa3e41a401609103c241431cbdee8623ae2a321a","crypto":
     * {"ciphertext":"8d179a911d6146ad2924e86bf493ed89b8ff3596ffec0816e761c542016ab13c",
     * "cipherparams":{"iv":"acc888c6cf4a19b86846cef0185a7164"},"cipher":"aes-128-ctr",
     * "kdf":"scrypt","kdfparams":{"n":8192,"r":8,"p":1,"dklen":32,"salt":"6a743c9b367d15f4758e4f3f3378ff0fd443708d1c64854e07588ea5331823ae"},
     * "mac":"410544c8307e3691fda305eb3722d82c3431f212a87daa119a21587d96698b57"}}'
     * ]
     * ```
     */
    encrypt(password, options) {
      return __awaiter11(this, void 0, void 0, function* () {
        return Promise.all(this.map((account) => __awaiter11(this, void 0, void 0, function* () {
          return account.encrypt(password, options);
        })));
      });
    }
    /**
     * Decrypts keystore v3 objects.
     *
     * @param encryptedWallets - An array of encrypted keystore v3 objects to decrypt
     * @param password - The password to encrypt with
     * @param options - decrypt options for the wallets
     * @returns The decrypted wallet object
     *
     * ```ts
     * web3.eth.accounts.wallet.decrypt([
     * { version: 3,
     * id: '83191a81-aaca-451f-b63d-0c5f3b849289',
     * address: '06f702337909c06c82b09b7a22f0a2f0855d1f68',
     * crypto:
     * { ciphertext: '7d34deae112841fba86e3e6cf08f5398dda323a8e4d29332621534e2c4069e8d',
     *   cipherparams: { iv: '497f4d26997a84d570778eae874b2333' },
     *   cipher: 'aes-128-ctr',
     *   kdf: 'scrypt',
     *   kdfparams:
     *    { dklen: 32,
     *      salt: '208dd732a27aa4803bb760228dff18515d5313fd085bbce60594a3919ae2d88d',
     *      n: 262144,
     *      r: 8,
     *      p: 1 },
     *   mac: '0062a853de302513c57bfe3108ab493733034bf3cb313326f42cf26ea2619cf9' } },
     * { version: 3,
     * id: '7d6b91fa-3611-407b-b16b-396efb28f97e',
     * address: 'b5d89661b59a9af0b34f58d19138baa2de48baaf',
     * crypto:
     * { ciphertext: 'cb9712d1982ff89f571fa5dbef447f14b7e5f142232bd2a913aac833730eeb43',
     *   cipherparams: { iv: '8cccb91cb84e435437f7282ec2ffd2db' },
     *   cipher: 'aes-128-ctr',
     *   kdf: 'scrypt',
     *   kdfparams:
     *    { dklen: 32,
     *      salt: '08ba6736363c5586434cd5b895e6fe41ea7db4785bd9b901dedce77a1514e8b8',
     *      n: 262144,
     *      r: 8,
     *      p: 1 },
     *   mac: 'd2eb068b37e2df55f56fa97a2bf4f55e072bef0dd703bfd917717d9dc54510f0' } }
     * ], 'test').then(console.log)
     * > Wallet {
     *   _accountProvider: {
     *     create: [Function: create],
     *     privateKeyToAccount: [Function: privateKeyToAccount],
     *     decrypt: [Function: decrypt]
     *   },
     *   _defaultKeyName: 'web3js_wallet',
     *   _accounts: {
     *     '0x85d70633b90e03e0276b98880286d0d055685ed7': {
     *       address: '0x85D70633b90e03e0276B98880286D0D055685ed7',
     *       privateKey: '0xbce9b59981303e76c4878b1a6d7b088ec6b9dd5c966b7d5f54d7a749ff683387',
     *       signTransaction: [Function: signTransaction],
     *       sign: [Function: sign],
     *       encrypt: [Function: encrypt]
     *     },
     *     '0x06f702337909c06c82b09b7a22f0a2f0855d1f68': {
     *       address: '0x06F702337909C06C82B09B7A22F0a2f0855d1F68',
     *       privateKey: '87a51da18900da7398b3bab03996833138f269f8f66dd1237b98df6b9ce14573',
     *       signTransaction: [Function: signTransaction],
     *       sign: [Function: sign],
     *       encrypt: [Function: encrypt]
     *     },
     *     '0xb5d89661b59a9af0b34f58d19138baa2de48baaf': {
     *       address: '0xB5d89661B59a9aF0b34f58D19138bAa2de48BAaf',
     *       privateKey: '7ee61c5282979aae9dd795bb6a54e8bdc2bfe009acb64eb9a67322eec3b3da6e',
     *       signTransaction: [Function: signTransaction],
     *       sign: [Function: sign],
     *       encrypt: [Function: encrypt]
     *     }
     *   }
     * }
     * ```
     */
    decrypt(encryptedWallets, password, options) {
      return __awaiter11(this, void 0, void 0, function* () {
        const results = yield Promise.all(encryptedWallets.map((wallet) => __awaiter11(this, void 0, void 0, function* () {
          return this._accountProvider.decrypt(wallet, password, options);
        })));
        for (const res of results) {
          this.add(res);
        }
        return this;
      });
    }
    /**
     * Stores the wallet encrypted and as string in local storage.
     * **__NOTE:__** Browser only
     *
     * @param password - The password to encrypt the wallet
     * @param keyName - (optional) The key used for the local storage position, defaults to `"web3js_wallet"`.
     * @returns Will return boolean value true if saved properly
     * ```ts
     * web3.eth.accounts.wallet.save('test#!$');
     * >true
     * ```
     */
    save(password, keyName) {
      return __awaiter11(this, void 0, void 0, function* () {
        const storage = _Wallet.getStorage();
        if (!storage) {
          throw new Error("Local storage not available.");
        }
        storage.setItem(keyName !== null && keyName !== void 0 ? keyName : this._defaultKeyName, JSON.stringify(yield this.encrypt(password)));
        return true;
      });
    }
    /**
     * Loads a wallet from local storage and decrypts it.
     * **__NOTE:__** Browser only
     *
     * @param password - The password to decrypt the wallet.
     * @param keyName - (optional)The key used for local storage position, defaults to `web3js_wallet"`
     * @returns Returns the wallet object
     *
     * ```ts
     * web3.eth.accounts.wallet.save('test#!$');
     * > true
     * web3.eth.accounts.wallet.load('test#!$');
     * { defaultKeyName: "web3js_wallet",
     *   length: 0,
     *   _accounts: Accounts {_requestManager: RequestManager, givenProvider: Proxy, providers: {…}, _provider: WebsocketProvider, …},
     *   [[Prototype]]: Object
     * }
     * ```
     */
    load(password, keyName) {
      return __awaiter11(this, void 0, void 0, function* () {
        const storage = _Wallet.getStorage();
        if (!storage) {
          throw new Error("Local storage not available.");
        }
        const keystore = storage.getItem(keyName !== null && keyName !== void 0 ? keyName : this._defaultKeyName);
        if (keystore) {
          yield this.decrypt(JSON.parse(keystore) || [], password);
        }
        return this;
      });
    }
  };

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/aes.js
  var crypto4 = { web: crypto2 };
  function validateOpt(key, iv, mode) {
    if (!mode.startsWith("aes-")) {
      throw new Error(`AES submodule doesn't support mode ${mode}`);
    }
    if (iv.length !== 16) {
      throw new Error("AES: wrong IV length");
    }
    if (mode.startsWith("aes-128") && key.length !== 16 || mode.startsWith("aes-256") && key.length !== 32) {
      throw new Error("AES: wrong key length");
    }
  }
  async function getBrowserKey(mode, key, iv) {
    if (!crypto4.web) {
      throw new Error("Browser crypto not available.");
    }
    let keyMode;
    if (["aes-128-cbc", "aes-256-cbc"].includes(mode)) {
      keyMode = "cbc";
    }
    if (["aes-128-ctr", "aes-256-ctr"].includes(mode)) {
      keyMode = "ctr";
    }
    if (!keyMode) {
      throw new Error("AES: unsupported mode");
    }
    const wKey = await crypto4.web.subtle.importKey("raw", key, { name: `AES-${keyMode.toUpperCase()}`, length: key.length * 8 }, true, ["encrypt", "decrypt"]);
    return [wKey, { name: `aes-${keyMode}`, iv, counter: iv, length: 128 }];
  }
  async function encrypt(msg, key, iv, mode = "aes-128-ctr", pkcs7PaddingEnabled = true) {
    validateOpt(key, iv, mode);
    if (crypto4.web) {
      const [wKey, wOpt] = await getBrowserKey(mode, key, iv);
      const cipher = await crypto4.web.subtle.encrypt(wOpt, wKey, msg);
      let res = new Uint8Array(cipher);
      if (!pkcs7PaddingEnabled && wOpt.name === "aes-cbc" && !(msg.length % 16)) {
        res = res.slice(0, -16);
      }
      return res;
    } else if (crypto4.node) {
      const cipher = crypto4.node.createCipheriv(mode, key, iv);
      cipher.setAutoPadding(pkcs7PaddingEnabled);
      return concatBytes(cipher.update(msg), cipher.final());
    } else {
      throw new Error("The environment doesn't have AES module");
    }
  }
  async function getPadding(cypherText, key, iv, mode) {
    const lastBlock = cypherText.slice(-16);
    for (let i2 = 0; i2 < 16; i2++) {
      lastBlock[i2] ^= iv[i2] ^ 16;
    }
    const res = await encrypt(lastBlock, key, iv, mode);
    return res.slice(0, 16);
  }
  async function decrypt(cypherText, key, iv, mode = "aes-128-ctr", pkcs7PaddingEnabled = true) {
    validateOpt(key, iv, mode);
    if (crypto4.web) {
      const [wKey, wOpt] = await getBrowserKey(mode, key, iv);
      if (!pkcs7PaddingEnabled && wOpt.name === "aes-cbc") {
        const padding = await getPadding(cypherText, key, iv, mode);
        cypherText = concatBytes(cypherText, padding);
      }
      const msg = await crypto4.web.subtle.decrypt(wOpt, wKey, cypherText);
      const msgBytes = new Uint8Array(msg);
      if (wOpt.name === "aes-cbc") {
        const encrypted = await encrypt(msgBytes, key, iv, mode);
        if (!equalsBytes(encrypted, cypherText)) {
          throw new Error("AES: wrong padding");
        }
      }
      return msgBytes;
    } else if (crypto4.node) {
      const decipher = crypto4.node.createDecipheriv(mode, key, iv);
      decipher.setAutoPadding(pkcs7PaddingEnabled);
      return concatBytes(decipher.update(cypherText), decipher.final());
    } else {
      throw new Error("The environment doesn't have AES module");
    }
  }

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/hmac.js
  var HMAC = class extends Hash {
    constructor(hash2, _key) {
      super();
      this.finished = false;
      this.destroyed = false;
      assert_default.hash(hash2);
      const key = toBytes(_key);
      this.iHash = hash2.create();
      if (typeof this.iHash.update !== "function")
        throw new Error("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen;
      this.outputLen = this.iHash.outputLen;
      const blockLen = this.blockLen;
      const pad = new Uint8Array(blockLen);
      pad.set(key.length > blockLen ? hash2.create().update(key).digest() : key);
      for (let i2 = 0; i2 < pad.length; i2++)
        pad[i2] ^= 54;
      this.iHash.update(pad);
      this.oHash = hash2.create();
      for (let i2 = 0; i2 < pad.length; i2++)
        pad[i2] ^= 54 ^ 92;
      this.oHash.update(pad);
      pad.fill(0);
    }
    update(buf) {
      assert_default.exists(this);
      this.iHash.update(buf);
      return this;
    }
    digestInto(out) {
      assert_default.exists(this);
      assert_default.bytes(out, this.outputLen);
      this.finished = true;
      this.iHash.digestInto(out);
      this.oHash.update(out);
      this.oHash.digestInto(out);
      this.destroy();
    }
    digest() {
      const out = new Uint8Array(this.oHash.outputLen);
      this.digestInto(out);
      return out;
    }
    _cloneInto(to) {
      to || (to = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
      to = to;
      to.finished = finished;
      to.destroyed = destroyed;
      to.blockLen = blockLen;
      to.outputLen = outputLen;
      to.oHash = oHash._cloneInto(to.oHash);
      to.iHash = iHash._cloneInto(to.iHash);
      return to;
    }
    destroy() {
      this.destroyed = true;
      this.oHash.destroy();
      this.iHash.destroy();
    }
  };
  var hmac = (hash2, key, message) => new HMAC(hash2, key).update(message).digest();
  hmac.create = (hash2, key) => new HMAC(hash2, key);

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/pbkdf2.js
  function pbkdf2Init(hash2, _password, _salt, _opts) {
    assert_default.hash(hash2);
    const opts = checkOpts({ dkLen: 32, asyncTick: 10 }, _opts);
    const { c, dkLen, asyncTick } = opts;
    assert_default.number(c);
    assert_default.number(dkLen);
    assert_default.number(asyncTick);
    if (c < 1)
      throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = toBytes(_password);
    const salt = toBytes(_salt);
    const DK = new Uint8Array(dkLen);
    const PRF = hmac.create(hash2, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return { c, dkLen, asyncTick, DK, PRF, PRFSalt };
  }
  function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW)
      prfW.destroy();
    u.fill(0);
    return DK;
  }
  function pbkdf2(hash2, password, salt, opts) {
    const { c, dkLen, DK, PRF, PRFSalt } = pbkdf2Init(hash2, password, salt, opts);
    let prfW;
    const arr = new Uint8Array(4);
    const view2 = createView(arr);
    const u = new Uint8Array(PRF.outputLen);
    for (let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen) {
      const Ti = DK.subarray(pos, pos + PRF.outputLen);
      view2.setInt32(0, ti, false);
      (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
      Ti.set(u.subarray(0, Ti.length));
      for (let ui = 1; ui < c; ui++) {
        PRF._cloneInto(prfW).update(u).digestInto(u);
        for (let i2 = 0; i2 < Ti.length; i2++)
          Ti[i2] ^= u[i2];
      }
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
  }

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/_sha2.js
  function setBigUint64(view2, byteOffset, value, isLE2) {
    if (typeof view2.setBigUint64 === "function")
      return view2.setBigUint64(byteOffset, value, isLE2);
    const _32n2 = BigInt(32);
    const _u32_max = BigInt(4294967295);
    const wh = Number(value >> _32n2 & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE2 ? 4 : 0;
    const l = isLE2 ? 0 : 4;
    view2.setUint32(byteOffset + h, wh, isLE2);
    view2.setUint32(byteOffset + l, wl, isLE2);
  }
  var SHA2 = class extends Hash {
    constructor(blockLen, outputLen, padOffset, isLE2) {
      super();
      this.blockLen = blockLen;
      this.outputLen = outputLen;
      this.padOffset = padOffset;
      this.isLE = isLE2;
      this.finished = false;
      this.length = 0;
      this.pos = 0;
      this.destroyed = false;
      this.buffer = new Uint8Array(blockLen);
      this.view = createView(this.buffer);
    }
    update(data) {
      assert_default.exists(this);
      const { view: view2, buffer, blockLen } = this;
      data = toBytes(data);
      const len = data.length;
      for (let pos = 0; pos < len; ) {
        const take = Math.min(blockLen - this.pos, len - pos);
        if (take === blockLen) {
          const dataView = createView(data);
          for (; blockLen <= len - pos; pos += blockLen)
            this.process(dataView, pos);
          continue;
        }
        buffer.set(data.subarray(pos, pos + take), this.pos);
        this.pos += take;
        pos += take;
        if (this.pos === blockLen) {
          this.process(view2, 0);
          this.pos = 0;
        }
      }
      this.length += data.length;
      this.roundClean();
      return this;
    }
    digestInto(out) {
      assert_default.exists(this);
      assert_default.output(out, this);
      this.finished = true;
      const { buffer, view: view2, blockLen, isLE: isLE2 } = this;
      let { pos } = this;
      buffer[pos++] = 128;
      this.buffer.subarray(pos).fill(0);
      if (this.padOffset > blockLen - pos) {
        this.process(view2, 0);
        pos = 0;
      }
      for (let i2 = pos; i2 < blockLen; i2++)
        buffer[i2] = 0;
      setBigUint64(view2, blockLen - 8, BigInt(this.length * 8), isLE2);
      this.process(view2, 0);
      const oview = createView(out);
      const len = this.outputLen;
      if (len % 4)
        throw new Error("_sha2: outputLen should be aligned to 32bit");
      const outLen = len / 4;
      const state = this.get();
      if (outLen > state.length)
        throw new Error("_sha2: outputLen bigger than state");
      for (let i2 = 0; i2 < outLen; i2++)
        oview.setUint32(4 * i2, state[i2], isLE2);
    }
    digest() {
      const { buffer, outputLen } = this;
      this.digestInto(buffer);
      const res = buffer.slice(0, outputLen);
      this.destroy();
      return res;
    }
    _cloneInto(to) {
      to || (to = new this.constructor());
      to.set(...this.get());
      const { blockLen, buffer, length: length2, finished, destroyed, pos } = this;
      to.length = length2;
      to.pos = pos;
      to.finished = finished;
      to.destroyed = destroyed;
      if (length2 % blockLen)
        to.buffer.set(buffer);
      return to;
    }
  };

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/sha256.js
  var Chi = (a, b, c) => a & b ^ ~a & c;
  var Maj = (a, b, c) => a & b ^ a & c ^ b & c;
  var SHA256_K = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  var IV = new Uint32Array([
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ]);
  var SHA256_W = new Uint32Array(64);
  var SHA256 = class extends SHA2 {
    constructor() {
      super(64, 32, 8, false);
      this.A = IV[0] | 0;
      this.B = IV[1] | 0;
      this.C = IV[2] | 0;
      this.D = IV[3] | 0;
      this.E = IV[4] | 0;
      this.F = IV[5] | 0;
      this.G = IV[6] | 0;
      this.H = IV[7] | 0;
    }
    get() {
      const { A, B, C, D, E, F, G, H } = this;
      return [A, B, C, D, E, F, G, H];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
      this.A = A | 0;
      this.B = B | 0;
      this.C = C | 0;
      this.D = D | 0;
      this.E = E | 0;
      this.F = F | 0;
      this.G = G | 0;
      this.H = H | 0;
    }
    process(view2, offset) {
      for (let i2 = 0; i2 < 16; i2++, offset += 4)
        SHA256_W[i2] = view2.getUint32(offset, false);
      for (let i2 = 16; i2 < 64; i2++) {
        const W15 = SHA256_W[i2 - 15];
        const W2 = SHA256_W[i2 - 2];
        const s0 = rotr(W15, 7) ^ rotr(W15, 18) ^ W15 >>> 3;
        const s1 = rotr(W2, 17) ^ rotr(W2, 19) ^ W2 >>> 10;
        SHA256_W[i2] = s1 + SHA256_W[i2 - 7] + s0 + SHA256_W[i2 - 16] | 0;
      }
      let { A, B, C, D, E, F, G, H } = this;
      for (let i2 = 0; i2 < 64; i2++) {
        const sigma1 = rotr(E, 6) ^ rotr(E, 11) ^ rotr(E, 25);
        const T12 = H + sigma1 + Chi(E, F, G) + SHA256_K[i2] + SHA256_W[i2] | 0;
        const sigma0 = rotr(A, 2) ^ rotr(A, 13) ^ rotr(A, 22);
        const T2 = sigma0 + Maj(A, B, C) | 0;
        H = G;
        G = F;
        F = E;
        E = D + T12 | 0;
        D = C;
        C = B;
        B = A;
        A = T12 + T2 | 0;
      }
      A = A + this.A | 0;
      B = B + this.B | 0;
      C = C + this.C | 0;
      D = D + this.D | 0;
      E = E + this.E | 0;
      F = F + this.F | 0;
      G = G + this.G | 0;
      H = H + this.H | 0;
      this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
      SHA256_W.fill(0);
    }
    destroy() {
      this.set(0, 0, 0, 0, 0, 0, 0, 0);
      this.buffer.fill(0);
    }
  };
  var SHA224 = class extends SHA256 {
    constructor() {
      super();
      this.A = 3238371032 | 0;
      this.B = 914150663 | 0;
      this.C = 812702999 | 0;
      this.D = 4144912697 | 0;
      this.E = 4290775857 | 0;
      this.F = 1750603025 | 0;
      this.G = 1694076839 | 0;
      this.H = 3204075428 | 0;
      this.outputLen = 28;
    }
  };
  var sha256 = wrapConstructor(() => new SHA256());
  var sha224 = wrapConstructor(() => new SHA224());

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/sha512.js
  var [SHA512_Kh, SHA512_Kl] = u64_default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
  ].map((n2) => BigInt(n2)));
  var SHA512_W_H = new Uint32Array(80);
  var SHA512_W_L = new Uint32Array(80);
  var SHA512 = class extends SHA2 {
    constructor() {
      super(128, 64, 16, false);
      this.Ah = 1779033703 | 0;
      this.Al = 4089235720 | 0;
      this.Bh = 3144134277 | 0;
      this.Bl = 2227873595 | 0;
      this.Ch = 1013904242 | 0;
      this.Cl = 4271175723 | 0;
      this.Dh = 2773480762 | 0;
      this.Dl = 1595750129 | 0;
      this.Eh = 1359893119 | 0;
      this.El = 2917565137 | 0;
      this.Fh = 2600822924 | 0;
      this.Fl = 725511199 | 0;
      this.Gh = 528734635 | 0;
      this.Gl = 4215389547 | 0;
      this.Hh = 1541459225 | 0;
      this.Hl = 327033209 | 0;
    }
    // prettier-ignore
    get() {
      const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
      return [Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
      this.Ah = Ah | 0;
      this.Al = Al | 0;
      this.Bh = Bh | 0;
      this.Bl = Bl | 0;
      this.Ch = Ch | 0;
      this.Cl = Cl | 0;
      this.Dh = Dh | 0;
      this.Dl = Dl | 0;
      this.Eh = Eh | 0;
      this.El = El | 0;
      this.Fh = Fh | 0;
      this.Fl = Fl | 0;
      this.Gh = Gh | 0;
      this.Gl = Gl | 0;
      this.Hh = Hh | 0;
      this.Hl = Hl | 0;
    }
    process(view2, offset) {
      for (let i2 = 0; i2 < 16; i2++, offset += 4) {
        SHA512_W_H[i2] = view2.getUint32(offset);
        SHA512_W_L[i2] = view2.getUint32(offset += 4);
      }
      for (let i2 = 16; i2 < 80; i2++) {
        const W15h = SHA512_W_H[i2 - 15] | 0;
        const W15l = SHA512_W_L[i2 - 15] | 0;
        const s0h = u64_default.rotrSH(W15h, W15l, 1) ^ u64_default.rotrSH(W15h, W15l, 8) ^ u64_default.shrSH(W15h, W15l, 7);
        const s0l = u64_default.rotrSL(W15h, W15l, 1) ^ u64_default.rotrSL(W15h, W15l, 8) ^ u64_default.shrSL(W15h, W15l, 7);
        const W2h = SHA512_W_H[i2 - 2] | 0;
        const W2l = SHA512_W_L[i2 - 2] | 0;
        const s1h = u64_default.rotrSH(W2h, W2l, 19) ^ u64_default.rotrBH(W2h, W2l, 61) ^ u64_default.shrSH(W2h, W2l, 6);
        const s1l = u64_default.rotrSL(W2h, W2l, 19) ^ u64_default.rotrBL(W2h, W2l, 61) ^ u64_default.shrSL(W2h, W2l, 6);
        const SUMl = u64_default.add4L(s0l, s1l, SHA512_W_L[i2 - 7], SHA512_W_L[i2 - 16]);
        const SUMh = u64_default.add4H(SUMl, s0h, s1h, SHA512_W_H[i2 - 7], SHA512_W_H[i2 - 16]);
        SHA512_W_H[i2] = SUMh | 0;
        SHA512_W_L[i2] = SUMl | 0;
      }
      let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
      for (let i2 = 0; i2 < 80; i2++) {
        const sigma1h = u64_default.rotrSH(Eh, El, 14) ^ u64_default.rotrSH(Eh, El, 18) ^ u64_default.rotrBH(Eh, El, 41);
        const sigma1l = u64_default.rotrSL(Eh, El, 14) ^ u64_default.rotrSL(Eh, El, 18) ^ u64_default.rotrBL(Eh, El, 41);
        const CHIh = Eh & Fh ^ ~Eh & Gh;
        const CHIl = El & Fl ^ ~El & Gl;
        const T1ll = u64_default.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i2], SHA512_W_L[i2]);
        const T1h = u64_default.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i2], SHA512_W_H[i2]);
        const T1l = T1ll | 0;
        const sigma0h = u64_default.rotrSH(Ah, Al, 28) ^ u64_default.rotrBH(Ah, Al, 34) ^ u64_default.rotrBH(Ah, Al, 39);
        const sigma0l = u64_default.rotrSL(Ah, Al, 28) ^ u64_default.rotrBL(Ah, Al, 34) ^ u64_default.rotrBL(Ah, Al, 39);
        const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
        const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
        Hh = Gh | 0;
        Hl = Gl | 0;
        Gh = Fh | 0;
        Gl = Fl | 0;
        Fh = Eh | 0;
        Fl = El | 0;
        ({ h: Eh, l: El } = u64_default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
        Dh = Ch | 0;
        Dl = Cl | 0;
        Ch = Bh | 0;
        Cl = Bl | 0;
        Bh = Ah | 0;
        Bl = Al | 0;
        const All = u64_default.add3L(T1l, sigma0l, MAJl);
        Ah = u64_default.add3H(All, T1h, sigma0h, MAJh);
        Al = All | 0;
      }
      ({ h: Ah, l: Al } = u64_default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
      ({ h: Bh, l: Bl } = u64_default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
      ({ h: Ch, l: Cl } = u64_default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
      ({ h: Dh, l: Dl } = u64_default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
      ({ h: Eh, l: El } = u64_default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
      ({ h: Fh, l: Fl } = u64_default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
      ({ h: Gh, l: Gl } = u64_default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
      ({ h: Hh, l: Hl } = u64_default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
      this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
      SHA512_W_H.fill(0);
      SHA512_W_L.fill(0);
    }
    destroy() {
      this.buffer.fill(0);
      this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
  };
  var SHA512_224 = class extends SHA512 {
    constructor() {
      super();
      this.Ah = 2352822216 | 0;
      this.Al = 424955298 | 0;
      this.Bh = 1944164710 | 0;
      this.Bl = 2312950998 | 0;
      this.Ch = 502970286 | 0;
      this.Cl = 855612546 | 0;
      this.Dh = 1738396948 | 0;
      this.Dl = 1479516111 | 0;
      this.Eh = 258812777 | 0;
      this.El = 2077511080 | 0;
      this.Fh = 2011393907 | 0;
      this.Fl = 79989058 | 0;
      this.Gh = 1067287976 | 0;
      this.Gl = 1780299464 | 0;
      this.Hh = 286451373 | 0;
      this.Hl = 2446758561 | 0;
      this.outputLen = 28;
    }
  };
  var SHA512_256 = class extends SHA512 {
    constructor() {
      super();
      this.Ah = 573645204 | 0;
      this.Al = 4230739756 | 0;
      this.Bh = 2673172387 | 0;
      this.Bl = 3360449730 | 0;
      this.Ch = 596883563 | 0;
      this.Cl = 1867755857 | 0;
      this.Dh = 2520282905 | 0;
      this.Dl = 1497426621 | 0;
      this.Eh = 2519219938 | 0;
      this.El = 2827943907 | 0;
      this.Fh = 3193839141 | 0;
      this.Fl = 1401305490 | 0;
      this.Gh = 721525244 | 0;
      this.Gl = 746961066 | 0;
      this.Hh = 246885852 | 0;
      this.Hl = 2177182882 | 0;
      this.outputLen = 32;
    }
  };
  var SHA384 = class extends SHA512 {
    constructor() {
      super();
      this.Ah = 3418070365 | 0;
      this.Al = 3238371032 | 0;
      this.Bh = 1654270250 | 0;
      this.Bl = 914150663 | 0;
      this.Ch = 2438529370 | 0;
      this.Cl = 812702999 | 0;
      this.Dh = 355462360 | 0;
      this.Dl = 4144912697 | 0;
      this.Eh = 1731405415 | 0;
      this.El = 4290775857 | 0;
      this.Fh = 2394180231 | 0;
      this.Fl = 1750603025 | 0;
      this.Gh = 3675008525 | 0;
      this.Gl = 1694076839 | 0;
      this.Hh = 1203062813 | 0;
      this.Hl = 3204075428 | 0;
      this.outputLen = 48;
    }
  };
  var sha512 = wrapConstructor(() => new SHA512());
  var sha512_224 = wrapConstructor(() => new SHA512_224());
  var sha512_256 = wrapConstructor(() => new SHA512_256());
  var sha384 = wrapConstructor(() => new SHA384());

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/pbkdf2.js
  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
    if (!["sha256", "sha512"].includes(digest)) {
      throw new Error("Only sha256 and sha512 are supported");
    }
    assertBytes(password);
    assertBytes(salt);
    return pbkdf2(digest === "sha256" ? sha256 : sha512, password, salt, {
      c: iterations,
      dkLen: keylen
    });
  }

  // ../../node_modules/.pnpm/@noble+hashes@1.3.1/node_modules/@noble/hashes/esm/scrypt.js
  var rotl = (a, b) => a << b | a >>> 32 - b;
  function XorAndSalsa(prev, pi, input, ii, out, oi) {
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    for (let i2 = 0; i2 < 8; i2 += 2) {
      x04 ^= rotl(x00 + x12 | 0, 7);
      x08 ^= rotl(x04 + x00 | 0, 9);
      x12 ^= rotl(x08 + x04 | 0, 13);
      x00 ^= rotl(x12 + x08 | 0, 18);
      x09 ^= rotl(x05 + x01 | 0, 7);
      x13 ^= rotl(x09 + x05 | 0, 9);
      x01 ^= rotl(x13 + x09 | 0, 13);
      x05 ^= rotl(x01 + x13 | 0, 18);
      x14 ^= rotl(x10 + x06 | 0, 7);
      x02 ^= rotl(x14 + x10 | 0, 9);
      x06 ^= rotl(x02 + x14 | 0, 13);
      x10 ^= rotl(x06 + x02 | 0, 18);
      x03 ^= rotl(x15 + x11 | 0, 7);
      x07 ^= rotl(x03 + x15 | 0, 9);
      x11 ^= rotl(x07 + x03 | 0, 13);
      x15 ^= rotl(x11 + x07 | 0, 18);
      x01 ^= rotl(x00 + x03 | 0, 7);
      x02 ^= rotl(x01 + x00 | 0, 9);
      x03 ^= rotl(x02 + x01 | 0, 13);
      x00 ^= rotl(x03 + x02 | 0, 18);
      x06 ^= rotl(x05 + x04 | 0, 7);
      x07 ^= rotl(x06 + x05 | 0, 9);
      x04 ^= rotl(x07 + x06 | 0, 13);
      x05 ^= rotl(x04 + x07 | 0, 18);
      x11 ^= rotl(x10 + x09 | 0, 7);
      x08 ^= rotl(x11 + x10 | 0, 9);
      x09 ^= rotl(x08 + x11 | 0, 13);
      x10 ^= rotl(x09 + x08 | 0, 18);
      x12 ^= rotl(x15 + x14 | 0, 7);
      x13 ^= rotl(x12 + x15 | 0, 9);
      x14 ^= rotl(x13 + x12 | 0, 13);
      x15 ^= rotl(x14 + x13 | 0, 18);
    }
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
  }
  function BlockMix(input, ii, out, oi, r2) {
    let head = oi + 0;
    let tail = oi + 16 * r2;
    for (let i2 = 0; i2 < 16; i2++)
      out[tail + i2] = input[ii + (2 * r2 - 1) * 16 + i2];
    for (let i2 = 0; i2 < r2; i2++, head += 16, ii += 16) {
      XorAndSalsa(out, tail, input, ii, out, head);
      if (i2 > 0)
        tail += 16;
      XorAndSalsa(out, head, input, ii += 16, out, tail);
    }
  }
  function scryptInit(password, salt, _opts) {
    const opts = checkOpts({
      dkLen: 32,
      asyncTick: 10,
      maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N, r: r2, p: p12, dkLen, asyncTick, maxmem, onProgress } = opts;
    assert_default.number(N);
    assert_default.number(r2);
    assert_default.number(p12);
    assert_default.number(dkLen);
    assert_default.number(asyncTick);
    assert_default.number(maxmem);
    if (onProgress !== void 0 && typeof onProgress !== "function")
      throw new Error("progressCb should be function");
    const blockSize = 128 * r2;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) {
      throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    }
    if (p12 < 0 || p12 > (2 ** 32 - 1) * 32 / blockSize) {
      throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    }
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) {
      throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    }
    const memUsed = blockSize * (N + p12);
    if (memUsed > maxmem) {
      throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    }
    const B = pbkdf2(sha256, password, salt, { c: 1, dkLen: blockSize * p12 });
    const B32 = u32(B);
    const V = u32(new Uint8Array(blockSize * N));
    const tmp = u32(new Uint8Array(blockSize));
    let blockMixCb = () => {
    };
    if (onProgress) {
      const totalBlockMix = 2 * N * p12;
      const callbackPer = Math.max(Math.floor(totalBlockMix / 1e4), 1);
      let blockMixCnt = 0;
      blockMixCb = () => {
        blockMixCnt++;
        if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix))
          onProgress(blockMixCnt / totalBlockMix);
      };
    }
    return { N, r: r2, p: p12, dkLen, blockSize32, V, B32, B, tmp, blockMixCb, asyncTick };
  }
  function scryptOutput(password, dkLen, B, V, tmp) {
    const res = pbkdf2(sha256, password, B, { c: 1, dkLen });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
  }
  function scrypt(password, salt, opts) {
    const { N, r: r2, p: p12, dkLen, blockSize32, V, B32, B, tmp, blockMixCb } = scryptInit(password, salt, opts);
    for (let pi = 0; pi < p12; pi++) {
      const Pi = blockSize32 * pi;
      for (let i2 = 0; i2 < blockSize32; i2++)
        V[i2] = B32[Pi + i2];
      for (let i2 = 0, pos = 0; i2 < N - 1; i2++) {
        BlockMix(V, pos, V, pos += blockSize32, r2);
        blockMixCb();
      }
      BlockMix(V, (N - 1) * blockSize32, B32, Pi, r2);
      blockMixCb();
      for (let i2 = 0; i2 < N; i2++) {
        const j = B32[Pi + blockSize32 - 16] % N;
        for (let k = 0; k < blockSize32; k++)
          tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k];
        BlockMix(tmp, 0, B32, Pi, r2);
        blockMixCb();
      }
    }
    return scryptOutput(password, dkLen, B, V, tmp);
  }

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/scrypt.js
  function scryptSync(password, salt, n2, p12, r2, dkLen, onProgress) {
    assertBytes(password);
    assertBytes(salt);
    return scrypt(password, salt, { N: n2, r: r2, p: p12, dkLen, onProgress });
  }

  // ../../node_modules/.pnpm/ethereum-cryptography@2.1.2/node_modules/ethereum-cryptography/esm/secp256k1.js
  var secp256k1_exports = {};
  __export(secp256k1_exports, {
    secp256k1: () => secp256k1
  });

  // ../../node_modules/.pnpm/@noble+curves@1.1.0/node_modules/@noble/curves/esm/abstract/utils.js
  var utils_exports2 = {};
  __export(utils_exports2, {
    bitGet: () => bitGet,
    bitLen: () => bitLen,
    bitMask: () => bitMask,
    bitSet: () => bitSet,
    bytesToHex: () => bytesToHex3,
    bytesToNumberBE: () => bytesToNumberBE,
    bytesToNumberLE: () => bytesToNumberLE,
    concatBytes: () => concatBytes2,
    createHmacDrbg: () => createHmacDrbg,
    ensureBytes: () => ensureBytes,
    equalBytes: () => equalBytes,
    hexToBytes: () => hexToBytes3,
    hexToNumber: () => hexToNumber3,
    numberToBytesBE: () => numberToBytesBE,
    numberToBytesLE: () => numberToBytesLE,
    numberToHexUnpadded: () => numberToHexUnpadded,
    numberToVarBytesBE: () => numberToVarBytesBE,
    utf8ToBytes: () => utf8ToBytes3,
    validateObject: () => validateObject2
  });
  var _0n2 = BigInt(0);
  var _1n2 = BigInt(1);
  var _2n2 = BigInt(2);
  var u8a2 = (a) => a instanceof Uint8Array;
  var hexes2 = Array.from({ length: 256 }, (v, i2) => i2.toString(16).padStart(2, "0"));
  function bytesToHex3(bytes2) {
    if (!u8a2(bytes2))
      throw new Error("Uint8Array expected");
    let hex = "";
    for (let i2 = 0; i2 < bytes2.length; i2++) {
      hex += hexes2[bytes2[i2]];
    }
    return hex;
  }
  function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
  }
  function hexToNumber3(hex) {
    if (typeof hex !== "string")
      throw new Error("hex string expected, got " + typeof hex);
    return BigInt(hex === "" ? "0" : `0x${hex}`);
  }
  function hexToBytes3(hex) {
    if (typeof hex !== "string")
      throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2)
      throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for (let i2 = 0; i2 < array.length; i2++) {
      const j = i2 * 2;
      const hexByte = hex.slice(j, j + 2);
      const byte = Number.parseInt(hexByte, 16);
      if (Number.isNaN(byte) || byte < 0)
        throw new Error("Invalid byte sequence");
      array[i2] = byte;
    }
    return array;
  }
  function bytesToNumberBE(bytes2) {
    return hexToNumber3(bytesToHex3(bytes2));
  }
  function bytesToNumberLE(bytes2) {
    if (!u8a2(bytes2))
      throw new Error("Uint8Array expected");
    return hexToNumber3(bytesToHex3(Uint8Array.from(bytes2).reverse()));
  }
  function numberToBytesBE(n2, len) {
    return hexToBytes3(n2.toString(16).padStart(len * 2, "0"));
  }
  function numberToBytesLE(n2, len) {
    return numberToBytesBE(n2, len).reverse();
  }
  function numberToVarBytesBE(n2) {
    return hexToBytes3(numberToHexUnpadded(n2));
  }
  function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") {
      try {
        res = hexToBytes3(hex);
      } catch (e2) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e2}`);
      }
    } else if (u8a2(hex)) {
      res = Uint8Array.from(hex);
    } else {
      throw new Error(`${title} must be hex string or Uint8Array`);
    }
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength)
      throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
  }
  function concatBytes2(...arrays) {
    const r2 = new Uint8Array(arrays.reduce((sum, a) => sum + a.length, 0));
    let pad = 0;
    arrays.forEach((a) => {
      if (!u8a2(a))
        throw new Error("Uint8Array expected");
      r2.set(a, pad);
      pad += a.length;
    });
    return r2;
  }
  function equalBytes(b1, b22) {
    if (b1.length !== b22.length)
      return false;
    for (let i2 = 0; i2 < b1.length; i2++)
      if (b1[i2] !== b22[i2])
        return false;
    return true;
  }
  function utf8ToBytes3(str) {
    if (typeof str !== "string")
      throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str));
  }
  function bitLen(n2) {
    let len;
    for (len = 0; n2 > _0n2; n2 >>= _1n2, len += 1)
      ;
    return len;
  }
  function bitGet(n2, pos) {
    return n2 >> BigInt(pos) & _1n2;
  }
  var bitSet = (n2, pos, value) => {
    return n2 | (value ? _1n2 : _0n2) << BigInt(pos);
  };
  var bitMask = (n2) => (_2n2 << BigInt(n2 - 1)) - _1n2;
  var u8n = (data) => new Uint8Array(data);
  var u8fr = (arr) => Uint8Array.from(arr);
  function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2)
      throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2)
      throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function")
      throw new Error("hmacFn must be a function");
    let v = u8n(hashLen);
    let k = u8n(hashLen);
    let i2 = 0;
    const reset = () => {
      v.fill(1);
      k.fill(0);
      i2 = 0;
    };
    const h = (...b) => hmacFn(k, v, ...b);
    const reseed = (seed = u8n()) => {
      k = h(u8fr([0]), seed);
      v = h();
      if (seed.length === 0)
        return;
      k = h(u8fr([1]), seed);
      v = h();
    };
    const gen2 = () => {
      if (i2++ >= 1e3)
        throw new Error("drbg: tried 1000 values");
      let len = 0;
      const out = [];
      while (len < qByteLen) {
        v = h();
        const sl = v.slice();
        out.push(sl);
        len += v.length;
      }
      return concatBytes2(...out);
    };
    const genUntil = (seed, pred) => {
      reset();
      reseed(seed);
      let res = void 0;
      while (!(res = pred(gen2())))
        reseed();
      reset();
      return res;
    };
    return genUntil;
  }
  var validatorFns = {
    bigint: (val) => typeof val === "bigint",
    function: (val) => typeof val === "function",
    boolean: (val) => typeof val === "boolean",
    string: (val) => typeof val === "string",
    isSafeInteger: (val) => Number.isSafeInteger(val),
    array: (val) => Array.isArray(val),
    field: (val, object) => object.Fp.isValid(val),
    hash: (val) => typeof val === "function" && Number.isSafeInteger(val.outputLen)
  };
  function validateObject2(object, validators3, optValidators = {}) {
    const checkField = (fieldName, type, isOptional) => {
      const checkVal = validatorFns[type];
      if (typeof checkVal !== "function")
        throw new Error(`Invalid validator "${type}", expected function`);
      const val = object[fieldName];
      if (isOptional && val === void 0)
        return;
      if (!checkVal(val, object)) {
        throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
      }
    };
    for (const [fieldName, type] of Object.entries(validators3))
      checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))
      checkField(fieldName, type, true);
    return object;
  }

  // ../../node_modules/.pnpm/@noble+curves@1.1.0/node_modules/@noble/curves/esm/abstract/modular.js
  var _0n3 = BigInt(0);
  var _1n3 = BigInt(1);
  var _2n3 = BigInt(2);
  var _3n = BigInt(3);
  var _4n = BigInt(4);
  var _5n = BigInt(5);
  var _8n = BigInt(8);
  var _9n = BigInt(9);
  var _16n = BigInt(16);
  function mod2(a, b) {
    const result = a % b;
    return result >= _0n3 ? result : b + result;
  }
  function pow(num, power, modulo) {
    if (modulo <= _0n3 || power < _0n3)
      throw new Error("Expected power/modulo > 0");
    if (modulo === _1n3)
      return _0n3;
    let res = _1n3;
    while (power > _0n3) {
      if (power & _1n3)
        res = res * num % modulo;
      num = num * num % modulo;
      power >>= _1n3;
    }
    return res;
  }
  function pow2(x, power, modulo) {
    let res = x;
    while (power-- > _0n3) {
      res *= res;
      res %= modulo;
    }
    return res;
  }
  function invert(number2, modulo) {
    if (number2 === _0n3 || modulo <= _0n3) {
      throw new Error(`invert: expected positive integers, got n=${number2} mod=${modulo}`);
    }
    let a = mod2(number2, modulo);
    let b = modulo;
    let x = _0n3, y = _1n3, u = _1n3, v = _0n3;
    while (a !== _0n3) {
      const q = b / a;
      const r2 = b % a;
      const m = x - u * q;
      const n2 = y - v * q;
      b = a, a = r2, x = u, y = v, u = m, v = n2;
    }
    const gcd = b;
    if (gcd !== _1n3)
      throw new Error("invert: does not exist");
    return mod2(x, modulo);
  }
  function tonelliShanks(P) {
    const legendreC = (P - _1n3) / _2n3;
    let Q, S, Z;
    for (Q = P - _1n3, S = 0; Q % _2n3 === _0n3; Q /= _2n3, S++)
      ;
    for (Z = _2n3; Z < P && pow(Z, legendreC, P) !== P - _1n3; Z++)
      ;
    if (S === 1) {
      const p1div4 = (P + _1n3) / _4n;
      return function tonelliFast(Fp2, n2) {
        const root = Fp2.pow(n2, p1div4);
        if (!Fp2.eql(Fp2.sqr(root), n2))
          throw new Error("Cannot find square root");
        return root;
      };
    }
    const Q1div2 = (Q + _1n3) / _2n3;
    return function tonelliSlow(Fp2, n2) {
      if (Fp2.pow(n2, legendreC) === Fp2.neg(Fp2.ONE))
        throw new Error("Cannot find square root");
      let r2 = S;
      let g = Fp2.pow(Fp2.mul(Fp2.ONE, Z), Q);
      let x = Fp2.pow(n2, Q1div2);
      let b = Fp2.pow(n2, Q);
      while (!Fp2.eql(b, Fp2.ONE)) {
        if (Fp2.eql(b, Fp2.ZERO))
          return Fp2.ZERO;
        let m = 1;
        for (let t2 = Fp2.sqr(b); m < r2; m++) {
          if (Fp2.eql(t2, Fp2.ONE))
            break;
          t2 = Fp2.sqr(t2);
        }
        const ge = Fp2.pow(g, _1n3 << BigInt(r2 - m - 1));
        g = Fp2.sqr(ge);
        x = Fp2.mul(x, ge);
        b = Fp2.mul(b, g);
        r2 = m;
      }
      return x;
    };
  }
  function FpSqrt(P) {
    if (P % _4n === _3n) {
      const p1div4 = (P + _1n3) / _4n;
      return function sqrt3mod4(Fp2, n2) {
        const root = Fp2.pow(n2, p1div4);
        if (!Fp2.eql(Fp2.sqr(root), n2))
          throw new Error("Cannot find square root");
        return root;
      };
    }
    if (P % _8n === _5n) {
      const c1 = (P - _5n) / _8n;
      return function sqrt5mod8(Fp2, n2) {
        const n22 = Fp2.mul(n2, _2n3);
        const v = Fp2.pow(n22, c1);
        const nv = Fp2.mul(n2, v);
        const i2 = Fp2.mul(Fp2.mul(nv, _2n3), v);
        const root = Fp2.mul(nv, Fp2.sub(i2, Fp2.ONE));
        if (!Fp2.eql(Fp2.sqr(root), n2))
          throw new Error("Cannot find square root");
        return root;
      };
    }
    if (P % _16n === _9n) {
    }
    return tonelliShanks(P);
  }
  var FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
  ];
  function validateField(field2) {
    const initial = {
      ORDER: "bigint",
      MASK: "bigint",
      BYTES: "isSafeInteger",
      BITS: "isSafeInteger"
    };
    const opts = FIELD_FIELDS.reduce((map, val) => {
      map[val] = "function";
      return map;
    }, initial);
    return validateObject2(field2, opts);
  }
  function FpPow(f, num, power) {
    if (power < _0n3)
      throw new Error("Expected power > 0");
    if (power === _0n3)
      return f.ONE;
    if (power === _1n3)
      return num;
    let p12 = f.ONE;
    let d = num;
    while (power > _0n3) {
      if (power & _1n3)
        p12 = f.mul(p12, d);
      d = f.sqr(d);
      power >>= _1n3;
    }
    return p12;
  }
  function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i2) => {
      if (f.is0(num))
        return acc;
      tmp[i2] = acc;
      return f.mul(acc, num);
    }, f.ONE);
    const inverted = f.inv(lastMultiplied);
    nums.reduceRight((acc, num, i2) => {
      if (f.is0(num))
        return acc;
      tmp[i2] = f.mul(acc, tmp[i2]);
      return f.mul(acc, num);
    }, inverted);
    return tmp;
  }
  function nLength(n2, nBitLength) {
    const _nBitLength = nBitLength !== void 0 ? nBitLength : n2.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength };
  }
  function Field(ORDER, bitLen2, isLE2 = false, redef = {}) {
    if (ORDER <= _0n3)
      throw new Error(`Expected Fp ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen2);
    if (BYTES > 2048)
      throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = FpSqrt(ORDER);
    const f = Object.freeze({
      ORDER,
      BITS,
      BYTES,
      MASK: bitMask(BITS),
      ZERO: _0n3,
      ONE: _1n3,
      create: (num) => mod2(num, ORDER),
      isValid: (num) => {
        if (typeof num !== "bigint")
          throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
        return _0n3 <= num && num < ORDER;
      },
      is0: (num) => num === _0n3,
      isOdd: (num) => (num & _1n3) === _1n3,
      neg: (num) => mod2(-num, ORDER),
      eql: (lhs, rhs) => lhs === rhs,
      sqr: (num) => mod2(num * num, ORDER),
      add: (lhs, rhs) => mod2(lhs + rhs, ORDER),
      sub: (lhs, rhs) => mod2(lhs - rhs, ORDER),
      mul: (lhs, rhs) => mod2(lhs * rhs, ORDER),
      pow: (num, power) => FpPow(f, num, power),
      div: (lhs, rhs) => mod2(lhs * invert(rhs, ORDER), ORDER),
      // Same as above, but doesn't normalize
      sqrN: (num) => num * num,
      addN: (lhs, rhs) => lhs + rhs,
      subN: (lhs, rhs) => lhs - rhs,
      mulN: (lhs, rhs) => lhs * rhs,
      inv: (num) => invert(num, ORDER),
      sqrt: redef.sqrt || ((n2) => sqrtP(f, n2)),
      invertBatch: (lst) => FpInvertBatch(f, lst),
      // TODO: do we really need constant cmov?
      // We don't have const-time bigints anyway, so probably will be not very useful
      cmov: (a, b, c) => c ? b : a,
      toBytes: (num) => isLE2 ? numberToBytesLE(num, BYTES) : numberToBytesBE(num, BYTES),
      fromBytes: (bytes2) => {
        if (bytes2.length !== BYTES)
          throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes2.length}`);
        return isLE2 ? bytesToNumberLE(bytes2) : bytesToNumberBE(bytes2);
      }
    });
    return Object.freeze(f);
  }
  function hashToPrivateScalar(hash2, groupOrder, isLE2 = false) {
    hash2 = ensureBytes("privateHash", hash2);
    const hashLen = hash2.length;
    const minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024)
      throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE2 ? bytesToNumberLE(hash2) : bytesToNumberBE(hash2);
    return mod2(num, groupOrder - _1n3) + _1n3;
  }

  // ../../node_modules/.pnpm/@noble+curves@1.1.0/node_modules/@noble/curves/esm/abstract/curve.js
  var _0n4 = BigInt(0);
  var _1n4 = BigInt(1);
  function wNAF(c, bits2) {
    const constTimeNegate = (condition, item) => {
      const neg = item.negate();
      return condition ? neg : item;
    };
    const opts = (W) => {
      const windows = Math.ceil(bits2 / W) + 1;
      const windowSize = 2 ** (W - 1);
      return { windows, windowSize };
    };
    return {
      constTimeNegate,
      // non-const time multiplication ladder
      unsafeLadder(elm, n2) {
        let p12 = c.ZERO;
        let d = elm;
        while (n2 > _0n4) {
          if (n2 & _1n4)
            p12 = p12.add(d);
          d = d.double();
          n2 >>= _1n4;
        }
        return p12;
      },
      /**
       * Creates a wNAF precomputation window. Used for caching.
       * Default window size is set by `utils.precompute()` and is equal to 8.
       * Number of precomputed points depends on the curve size:
       * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
       * - 𝑊 is the window size
       * - 𝑛 is the bitlength of the curve order.
       * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
       * @returns precomputed point tables flattened to a single array
       */
      precomputeWindow(elm, W) {
        const { windows, windowSize } = opts(W);
        const points = [];
        let p12 = elm;
        let base2 = p12;
        for (let window2 = 0; window2 < windows; window2++) {
          base2 = p12;
          points.push(base2);
          for (let i2 = 1; i2 < windowSize; i2++) {
            base2 = base2.add(p12);
            points.push(base2);
          }
          p12 = base2.double();
        }
        return points;
      },
      /**
       * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
       * @param W window size
       * @param precomputes precomputed tables
       * @param n scalar (we don't check here, but should be less than curve order)
       * @returns real and fake (for const-time) points
       */
      wNAF(W, precomputes, n2) {
        const { windows, windowSize } = opts(W);
        let p12 = c.ZERO;
        let f = c.BASE;
        const mask2 = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for (let window2 = 0; window2 < windows; window2++) {
          const offset = window2 * windowSize;
          let wbits = Number(n2 & mask2);
          n2 >>= shiftBy;
          if (wbits > windowSize) {
            wbits -= maxNumber;
            n2 += _1n4;
          }
          const offset1 = offset;
          const offset2 = offset + Math.abs(wbits) - 1;
          const cond1 = window2 % 2 !== 0;
          const cond2 = wbits < 0;
          if (wbits === 0) {
            f = f.add(constTimeNegate(cond1, precomputes[offset1]));
          } else {
            p12 = p12.add(constTimeNegate(cond2, precomputes[offset2]));
          }
        }
        return { p: p12, f };
      },
      wNAFCached(P, precomputesMap, n2, transform) {
        const W = P._WINDOW_SIZE || 1;
        let comp = precomputesMap.get(P);
        if (!comp) {
          comp = this.precomputeWindow(P, W);
          if (W !== 1) {
            precomputesMap.set(P, transform(comp));
          }
        }
        return this.wNAF(W, comp, n2);
      }
    };
  }
  function validateBasic(curve) {
    validateField(curve.Fp);
    validateObject2(curve, {
      n: "bigint",
      h: "bigint",
      Gx: "field",
      Gy: "field"
    }, {
      nBitLength: "isSafeInteger",
      nByteLength: "isSafeInteger"
    });
    return Object.freeze({
      ...nLength(curve.n, curve.nBitLength),
      ...curve,
      ...{ p: curve.Fp.ORDER }
    });
  }

  // ../../node_modules/.pnpm/@noble+curves@1.1.0/node_modules/@noble/curves/esm/abstract/weierstrass.js
  function validatePointOpts(curve) {
    const opts = validateBasic(curve);
    validateObject2(opts, {
      a: "field",
      b: "field"
    }, {
      allowedPrivateKeyLengths: "array",
      wrapPrivateKey: "boolean",
      isTorsionFree: "function",
      clearCofactor: "function",
      allowInfinityPoint: "boolean",
      fromBytes: "function",
      toBytes: "function"
    });
    const { endo, Fp: Fp2, a } = opts;
    if (endo) {
      if (!Fp2.eql(a, Fp2.ZERO)) {
        throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
      }
      if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") {
        throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
      }
    }
    return Object.freeze({ ...opts });
  }
  var { bytesToNumberBE: b2n, hexToBytes: h2b } = utils_exports2;
  var DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
      constructor(m = "") {
        super(m);
      }
    },
    _parseInt(data) {
      const { Err: E } = DER;
      if (data.length < 2 || data[0] !== 2)
        throw new E("Invalid signature integer tag");
      const len = data[1];
      const res = data.subarray(2, len + 2);
      if (!len || res.length !== len)
        throw new E("Invalid signature integer: wrong length");
      if (res[0] & 128)
        throw new E("Invalid signature integer: negative");
      if (res[0] === 0 && !(res[1] & 128))
        throw new E("Invalid signature integer: unnecessary leading zero");
      return { d: b2n(res), l: data.subarray(len + 2) };
    },
    toSig(hex) {
      const { Err: E } = DER;
      const data = typeof hex === "string" ? h2b(hex) : hex;
      if (!(data instanceof Uint8Array))
        throw new Error("ui8a expected");
      let l = data.length;
      if (l < 2 || data[0] != 48)
        throw new E("Invalid signature tag");
      if (data[1] !== l - 2)
        throw new E("Invalid signature: incorrect length");
      const { d: r2, l: sBytes } = DER._parseInt(data.subarray(2));
      const { d: s2, l: rBytesLeft } = DER._parseInt(sBytes);
      if (rBytesLeft.length)
        throw new E("Invalid signature: left bytes after parsing");
      return { r: r2, s: s2 };
    },
    hexFromSig(sig) {
      const slice = (s3) => Number.parseInt(s3[0], 16) & 8 ? "00" + s3 : s3;
      const h = (num) => {
        const hex = num.toString(16);
        return hex.length & 1 ? `0${hex}` : hex;
      };
      const s2 = slice(h(sig.s));
      const r2 = slice(h(sig.r));
      const shl = s2.length / 2;
      const rhl = r2.length / 2;
      const sl = h(shl);
      const rl = h(rhl);
      return `30${h(rhl + shl + 4)}02${rl}${r2}02${sl}${s2}`;
    }
  };
  var _0n5 = BigInt(0);
  var _1n5 = BigInt(1);
  var _2n4 = BigInt(2);
  var _3n2 = BigInt(3);
  var _4n2 = BigInt(4);
  function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp: Fp2 } = CURVE;
    const toBytes2 = CURVE.toBytes || ((c, point, isCompressed) => {
      const a = point.toAffine();
      return concatBytes2(Uint8Array.from([4]), Fp2.toBytes(a.x), Fp2.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes2) => {
      const tail = bytes2.subarray(1);
      const x = Fp2.fromBytes(tail.subarray(0, Fp2.BYTES));
      const y = Fp2.fromBytes(tail.subarray(Fp2.BYTES, 2 * Fp2.BYTES));
      return { x, y };
    });
    function weierstrassEquation(x) {
      const { a, b } = CURVE;
      const x2 = Fp2.sqr(x);
      const x3 = Fp2.mul(x2, x);
      return Fp2.add(Fp2.add(x3, Fp2.mul(x, a)), b);
    }
    if (!Fp2.eql(Fp2.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx)))
      throw new Error("bad generator point: equation left != right");
    function isWithinCurveOrder(num) {
      return typeof num === "bigint" && _0n5 < num && num < CURVE.n;
    }
    function assertGE(num) {
      if (!isWithinCurveOrder(num))
        throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    function normPrivateKeyToScalar(key) {
      const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n: n2 } = CURVE;
      if (lengths && typeof key !== "bigint") {
        if (key instanceof Uint8Array)
          key = bytesToHex3(key);
        if (typeof key !== "string" || !lengths.includes(key.length))
          throw new Error("Invalid key");
        key = key.padStart(nByteLength * 2, "0");
      }
      let num;
      try {
        num = typeof key === "bigint" ? key : bytesToNumberBE(ensureBytes("private key", key, nByteLength));
      } catch (error) {
        throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
      }
      if (wrapPrivateKey)
        num = mod2(num, n2);
      assertGE(num);
      return num;
    }
    const pointPrecomputes = /* @__PURE__ */ new Map();
    function assertPrjPoint(other) {
      if (!(other instanceof Point2))
        throw new Error("ProjectivePoint expected");
    }
    class Point2 {
      constructor(px, py, pz) {
        this.px = px;
        this.py = py;
        this.pz = pz;
        if (px == null || !Fp2.isValid(px))
          throw new Error("x required");
        if (py == null || !Fp2.isValid(py))
          throw new Error("y required");
        if (pz == null || !Fp2.isValid(pz))
          throw new Error("z required");
      }
      // Does not validate if the point is on-curve.
      // Use fromHex instead, or call assertValidity() later.
      static fromAffine(p12) {
        const { x, y } = p12 || {};
        if (!p12 || !Fp2.isValid(x) || !Fp2.isValid(y))
          throw new Error("invalid affine point");
        if (p12 instanceof Point2)
          throw new Error("projective point not allowed");
        const is0 = (i2) => Fp2.eql(i2, Fp2.ZERO);
        if (is0(x) && is0(y))
          return Point2.ZERO;
        return new Point2(x, y, Fp2.ONE);
      }
      get x() {
        return this.toAffine().x;
      }
      get y() {
        return this.toAffine().y;
      }
      /**
       * Takes a bunch of Projective Points but executes only one
       * inversion on all of them. Inversion is very slow operation,
       * so this improves performance massively.
       * Optimization: converts a list of projective points to a list of identical points with Z=1.
       */
      static normalizeZ(points) {
        const toInv = Fp2.invertBatch(points.map((p12) => p12.pz));
        return points.map((p12, i2) => p12.toAffine(toInv[i2])).map(Point2.fromAffine);
      }
      /**
       * Converts hash string or Uint8Array to Point.
       * @param hex short/long ECDSA hex
       */
      static fromHex(hex) {
        const P = Point2.fromAffine(fromBytes(ensureBytes("pointHex", hex)));
        P.assertValidity();
        return P;
      }
      // Multiplies generator point by privateKey.
      static fromPrivateKey(privateKey) {
        return Point2.BASE.multiply(normPrivateKeyToScalar(privateKey));
      }
      // "Private method", don't use it directly
      _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        pointPrecomputes.delete(this);
      }
      // A point on curve is valid if it conforms to equation.
      assertValidity() {
        if (this.is0()) {
          if (CURVE.allowInfinityPoint)
            return;
          throw new Error("bad point: ZERO");
        }
        const { x, y } = this.toAffine();
        if (!Fp2.isValid(x) || !Fp2.isValid(y))
          throw new Error("bad point: x or y not FE");
        const left = Fp2.sqr(y);
        const right = weierstrassEquation(x);
        if (!Fp2.eql(left, right))
          throw new Error("bad point: equation left != right");
        if (!this.isTorsionFree())
          throw new Error("bad point: not in prime-order subgroup");
      }
      hasEvenY() {
        const { y } = this.toAffine();
        if (Fp2.isOdd)
          return !Fp2.isOdd(y);
        throw new Error("Field doesn't support isOdd");
      }
      /**
       * Compare one point to another.
       */
      equals(other) {
        assertPrjPoint(other);
        const { px: X1, py: Y1, pz: Z1 } = this;
        const { px: X2, py: Y2, pz: Z2 } = other;
        const U1 = Fp2.eql(Fp2.mul(X1, Z2), Fp2.mul(X2, Z1));
        const U2 = Fp2.eql(Fp2.mul(Y1, Z2), Fp2.mul(Y2, Z1));
        return U1 && U2;
      }
      /**
       * Flips point to one corresponding to (x, -y) in Affine coordinates.
       */
      negate() {
        return new Point2(this.px, Fp2.neg(this.py), this.pz);
      }
      // Renes-Costello-Batina exception-free doubling formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 3
      // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
      double() {
        const { a, b } = CURVE;
        const b3 = Fp2.mul(b, _3n2);
        const { px: X1, py: Y1, pz: Z1 } = this;
        let X3 = Fp2.ZERO, Y3 = Fp2.ZERO, Z3 = Fp2.ZERO;
        let t0 = Fp2.mul(X1, X1);
        let t1 = Fp2.mul(Y1, Y1);
        let t2 = Fp2.mul(Z1, Z1);
        let t3 = Fp2.mul(X1, Y1);
        t3 = Fp2.add(t3, t3);
        Z3 = Fp2.mul(X1, Z1);
        Z3 = Fp2.add(Z3, Z3);
        X3 = Fp2.mul(a, Z3);
        Y3 = Fp2.mul(b3, t2);
        Y3 = Fp2.add(X3, Y3);
        X3 = Fp2.sub(t1, Y3);
        Y3 = Fp2.add(t1, Y3);
        Y3 = Fp2.mul(X3, Y3);
        X3 = Fp2.mul(t3, X3);
        Z3 = Fp2.mul(b3, Z3);
        t2 = Fp2.mul(a, t2);
        t3 = Fp2.sub(t0, t2);
        t3 = Fp2.mul(a, t3);
        t3 = Fp2.add(t3, Z3);
        Z3 = Fp2.add(t0, t0);
        t0 = Fp2.add(Z3, t0);
        t0 = Fp2.add(t0, t2);
        t0 = Fp2.mul(t0, t3);
        Y3 = Fp2.add(Y3, t0);
        t2 = Fp2.mul(Y1, Z1);
        t2 = Fp2.add(t2, t2);
        t0 = Fp2.mul(t2, t3);
        X3 = Fp2.sub(X3, t0);
        Z3 = Fp2.mul(t2, t1);
        Z3 = Fp2.add(Z3, Z3);
        Z3 = Fp2.add(Z3, Z3);
        return new Point2(X3, Y3, Z3);
      }
      // Renes-Costello-Batina exception-free addition formula.
      // There is 30% faster Jacobian formula, but it is not complete.
      // https://eprint.iacr.org/2015/1060, algorithm 1
      // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
      add(other) {
        assertPrjPoint(other);
        const { px: X1, py: Y1, pz: Z1 } = this;
        const { px: X2, py: Y2, pz: Z2 } = other;
        let X3 = Fp2.ZERO, Y3 = Fp2.ZERO, Z3 = Fp2.ZERO;
        const a = CURVE.a;
        const b3 = Fp2.mul(CURVE.b, _3n2);
        let t0 = Fp2.mul(X1, X2);
        let t1 = Fp2.mul(Y1, Y2);
        let t2 = Fp2.mul(Z1, Z2);
        let t3 = Fp2.add(X1, Y1);
        let t4 = Fp2.add(X2, Y2);
        t3 = Fp2.mul(t3, t4);
        t4 = Fp2.add(t0, t1);
        t3 = Fp2.sub(t3, t4);
        t4 = Fp2.add(X1, Z1);
        let t5 = Fp2.add(X2, Z2);
        t4 = Fp2.mul(t4, t5);
        t5 = Fp2.add(t0, t2);
        t4 = Fp2.sub(t4, t5);
        t5 = Fp2.add(Y1, Z1);
        X3 = Fp2.add(Y2, Z2);
        t5 = Fp2.mul(t5, X3);
        X3 = Fp2.add(t1, t2);
        t5 = Fp2.sub(t5, X3);
        Z3 = Fp2.mul(a, t4);
        X3 = Fp2.mul(b3, t2);
        Z3 = Fp2.add(X3, Z3);
        X3 = Fp2.sub(t1, Z3);
        Z3 = Fp2.add(t1, Z3);
        Y3 = Fp2.mul(X3, Z3);
        t1 = Fp2.add(t0, t0);
        t1 = Fp2.add(t1, t0);
        t2 = Fp2.mul(a, t2);
        t4 = Fp2.mul(b3, t4);
        t1 = Fp2.add(t1, t2);
        t2 = Fp2.sub(t0, t2);
        t2 = Fp2.mul(a, t2);
        t4 = Fp2.add(t4, t2);
        t0 = Fp2.mul(t1, t4);
        Y3 = Fp2.add(Y3, t0);
        t0 = Fp2.mul(t5, t4);
        X3 = Fp2.mul(t3, X3);
        X3 = Fp2.sub(X3, t0);
        t0 = Fp2.mul(t3, t1);
        Z3 = Fp2.mul(t5, Z3);
        Z3 = Fp2.add(Z3, t0);
        return new Point2(X3, Y3, Z3);
      }
      subtract(other) {
        return this.add(other.negate());
      }
      is0() {
        return this.equals(Point2.ZERO);
      }
      wNAF(n2) {
        return wnaf.wNAFCached(this, pointPrecomputes, n2, (comp) => {
          const toInv = Fp2.invertBatch(comp.map((p12) => p12.pz));
          return comp.map((p12, i2) => p12.toAffine(toInv[i2])).map(Point2.fromAffine);
        });
      }
      /**
       * Non-constant-time multiplication. Uses double-and-add algorithm.
       * It's faster, but should only be used when you don't care about
       * an exposed private key e.g. sig verification, which works over *public* keys.
       */
      multiplyUnsafe(n2) {
        const I = Point2.ZERO;
        if (n2 === _0n5)
          return I;
        assertGE(n2);
        if (n2 === _1n5)
          return this;
        const { endo } = CURVE;
        if (!endo)
          return wnaf.unsafeLadder(this, n2);
        let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n2);
        let k1p = I;
        let k2p = I;
        let d = this;
        while (k1 > _0n5 || k2 > _0n5) {
          if (k1 & _1n5)
            k1p = k1p.add(d);
          if (k2 & _1n5)
            k2p = k2p.add(d);
          d = d.double();
          k1 >>= _1n5;
          k2 >>= _1n5;
        }
        if (k1neg)
          k1p = k1p.negate();
        if (k2neg)
          k2p = k2p.negate();
        k2p = new Point2(Fp2.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
        return k1p.add(k2p);
      }
      /**
       * Constant time multiplication.
       * Uses wNAF method. Windowed method may be 10% faster,
       * but takes 2x longer to generate and consumes 2x memory.
       * Uses precomputes when available.
       * Uses endomorphism for Koblitz curves.
       * @param scalar by which the point would be multiplied
       * @returns New point
       */
      multiply(scalar) {
        assertGE(scalar);
        let n2 = scalar;
        let point, fake;
        const { endo } = CURVE;
        if (endo) {
          const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n2);
          let { p: k1p, f: f1p } = this.wNAF(k1);
          let { p: k2p, f: f2p } = this.wNAF(k2);
          k1p = wnaf.constTimeNegate(k1neg, k1p);
          k2p = wnaf.constTimeNegate(k2neg, k2p);
          k2p = new Point2(Fp2.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
          point = k1p.add(k2p);
          fake = f1p.add(f2p);
        } else {
          const { p: p12, f } = this.wNAF(n2);
          point = p12;
          fake = f;
        }
        return Point2.normalizeZ([point, fake])[0];
      }
      /**
       * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
       * Not using Strauss-Shamir trick: precomputation tables are faster.
       * The trick could be useful if both P and Q are not G (not in our case).
       * @returns non-zero affine point
       */
      multiplyAndAddUnsafe(Q, a, b) {
        const G = Point2.BASE;
        const mul = (P, a2) => a2 === _0n5 || a2 === _1n5 || !P.equals(G) ? P.multiplyUnsafe(a2) : P.multiply(a2);
        const sum = mul(this, a).add(mul(Q, b));
        return sum.is0() ? void 0 : sum;
      }
      // Converts Projective point to affine (x, y) coordinates.
      // Can accept precomputed Z^-1 - for example, from invertBatch.
      // (x, y, z) ∋ (x=x/z, y=y/z)
      toAffine(iz) {
        const { px: x, py: y, pz: z2 } = this;
        const is0 = this.is0();
        if (iz == null)
          iz = is0 ? Fp2.ONE : Fp2.inv(z2);
        const ax = Fp2.mul(x, iz);
        const ay = Fp2.mul(y, iz);
        const zz = Fp2.mul(z2, iz);
        if (is0)
          return { x: Fp2.ZERO, y: Fp2.ZERO };
        if (!Fp2.eql(zz, Fp2.ONE))
          throw new Error("invZ was invalid");
        return { x: ax, y: ay };
      }
      isTorsionFree() {
        const { h: cofactor, isTorsionFree } = CURVE;
        if (cofactor === _1n5)
          return true;
        if (isTorsionFree)
          return isTorsionFree(Point2, this);
        throw new Error("isTorsionFree() has not been declared for the elliptic curve");
      }
      clearCofactor() {
        const { h: cofactor, clearCofactor } = CURVE;
        if (cofactor === _1n5)
          return this;
        if (clearCofactor)
          return clearCofactor(Point2, this);
        return this.multiplyUnsafe(CURVE.h);
      }
      toRawBytes(isCompressed = true) {
        this.assertValidity();
        return toBytes2(Point2, this, isCompressed);
      }
      toHex(isCompressed = true) {
        return bytesToHex3(this.toRawBytes(isCompressed));
      }
    }
    Point2.BASE = new Point2(CURVE.Gx, CURVE.Gy, Fp2.ONE);
    Point2.ZERO = new Point2(Fp2.ZERO, Fp2.ONE, Fp2.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = wNAF(Point2, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    return {
      CURVE,
      ProjectivePoint: Point2,
      normPrivateKeyToScalar,
      weierstrassEquation,
      isWithinCurveOrder
    };
  }
  function validateOpts(curve) {
    const opts = validateBasic(curve);
    validateObject2(opts, {
      hash: "hash",
      hmac: "function",
      randomBytes: "function"
    }, {
      bits2int: "function",
      bits2int_modN: "function",
      lowS: "boolean"
    });
    return Object.freeze({ lowS: true, ...opts });
  }
  function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp: Fp2, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp2.BYTES + 1;
    const uncompressedLen = 2 * Fp2.BYTES + 1;
    function isValidFieldElement(num) {
      return _0n5 < num && num < Fp2.ORDER;
    }
    function modN(a) {
      return mod2(a, CURVE_ORDER);
    }
    function invN(a) {
      return invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point2, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
      ...CURVE,
      toBytes(c, point, isCompressed) {
        const a = point.toAffine();
        const x = Fp2.toBytes(a.x);
        const cat = concatBytes2;
        if (isCompressed) {
          return cat(Uint8Array.from([point.hasEvenY() ? 2 : 3]), x);
        } else {
          return cat(Uint8Array.from([4]), x, Fp2.toBytes(a.y));
        }
      },
      fromBytes(bytes2) {
        const len = bytes2.length;
        const head = bytes2[0];
        const tail = bytes2.subarray(1);
        if (len === compressedLen && (head === 2 || head === 3)) {
          const x = bytesToNumberBE(tail);
          if (!isValidFieldElement(x))
            throw new Error("Point is not on curve");
          const y2 = weierstrassEquation(x);
          let y = Fp2.sqrt(y2);
          const isYOdd = (y & _1n5) === _1n5;
          const isHeadOdd = (head & 1) === 1;
          if (isHeadOdd !== isYOdd)
            y = Fp2.neg(y);
          return { x, y };
        } else if (len === uncompressedLen && head === 4) {
          const x = Fp2.fromBytes(tail.subarray(0, Fp2.BYTES));
          const y = Fp2.fromBytes(tail.subarray(Fp2.BYTES, 2 * Fp2.BYTES));
          return { x, y };
        } else {
          throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
      }
    });
    const numToNByteStr = (num) => bytesToHex3(numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number2) {
      const HALF = CURVE_ORDER >> _1n5;
      return number2 > HALF;
    }
    function normalizeS(s2) {
      return isBiggerThanHalfOrder(s2) ? modN(-s2) : s2;
    }
    const slcNum = (b, from, to) => bytesToNumberBE(b.slice(from, to));
    class Signature {
      constructor(r2, s2, recovery) {
        this.r = r2;
        this.s = s2;
        this.recovery = recovery;
        this.assertValidity();
      }
      // pair (bytes of r, bytes of s)
      static fromCompact(hex) {
        const l = CURVE.nByteLength;
        hex = ensureBytes("compactSignature", hex, l * 2);
        return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
      }
      // DER encoded ECDSA signature
      // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
      static fromDER(hex) {
        const { r: r2, s: s2 } = DER.toSig(ensureBytes("DER", hex));
        return new Signature(r2, s2);
      }
      assertValidity() {
        if (!isWithinCurveOrder(this.r))
          throw new Error("r must be 0 < r < CURVE.n");
        if (!isWithinCurveOrder(this.s))
          throw new Error("s must be 0 < s < CURVE.n");
      }
      addRecoveryBit(recovery) {
        return new Signature(this.r, this.s, recovery);
      }
      recoverPublicKey(msgHash) {
        const { r: r2, s: s2, recovery: rec } = this;
        const h = bits2int_modN(ensureBytes("msgHash", msgHash));
        if (rec == null || ![0, 1, 2, 3].includes(rec))
          throw new Error("recovery id invalid");
        const radj = rec === 2 || rec === 3 ? r2 + CURVE.n : r2;
        if (radj >= Fp2.ORDER)
          throw new Error("recovery id 2 or 3 invalid");
        const prefix = (rec & 1) === 0 ? "02" : "03";
        const R = Point2.fromHex(prefix + numToNByteStr(radj));
        const ir = invN(radj);
        const u1 = modN(-h * ir);
        const u2 = modN(s2 * ir);
        const Q = Point2.BASE.multiplyAndAddUnsafe(R, u1, u2);
        if (!Q)
          throw new Error("point at infinify");
        Q.assertValidity();
        return Q;
      }
      // Signatures should be low-s, to prevent malleability.
      hasHighS() {
        return isBiggerThanHalfOrder(this.s);
      }
      normalizeS() {
        return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
      }
      // DER-encoded
      toDERRawBytes() {
        return hexToBytes3(this.toDERHex());
      }
      toDERHex() {
        return DER.hexFromSig({ r: this.r, s: this.s });
      }
      // padded bytes of r, then padded bytes of s
      toCompactRawBytes() {
        return hexToBytes3(this.toCompactHex());
      }
      toCompactHex() {
        return numToNByteStr(this.r) + numToNByteStr(this.s);
      }
    }
    const utils = {
      isValidPrivateKey(privateKey) {
        try {
          normPrivateKeyToScalar(privateKey);
          return true;
        } catch (error) {
          return false;
        }
      },
      normPrivateKeyToScalar,
      /**
       * Produces cryptographically secure private key from random of size (nBitLength+64)
       * as per FIPS 186 B.4.1 with modulo bias being neglible.
       */
      randomPrivateKey: () => {
        const rand = CURVE.randomBytes(Fp2.BYTES + 8);
        const num = hashToPrivateScalar(rand, CURVE_ORDER);
        return numberToBytesBE(num, CURVE.nByteLength);
      },
      /**
       * Creates precompute table for an arbitrary EC point. Makes point "cached".
       * Allows to massively speed-up `point.multiply(scalar)`.
       * @returns cached point
       * @example
       * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
       * fast.multiply(privKey); // much faster ECDH now
       */
      precompute(windowSize = 8, point = Point2.BASE) {
        point._setWindowSize(windowSize);
        point.multiply(BigInt(3));
        return point;
      }
    };
    function getPublicKey(privateKey, isCompressed = true) {
      return Point2.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    function isProbPub(item) {
      const arr = item instanceof Uint8Array;
      const str = typeof item === "string";
      const len = (arr || str) && item.length;
      if (arr)
        return len === compressedLen || len === uncompressedLen;
      if (str)
        return len === 2 * compressedLen || len === 2 * uncompressedLen;
      if (item instanceof Point2)
        return true;
      return false;
    }
    function getSharedSecret(privateA, publicB, isCompressed = true) {
      if (isProbPub(privateA))
        throw new Error("first arg must be private key");
      if (!isProbPub(publicB))
        throw new Error("second arg must be public key");
      const b = Point2.fromHex(publicB);
      return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    const bits2int = CURVE.bits2int || function(bytes2) {
      const num = bytesToNumberBE(bytes2);
      const delta = bytes2.length * 8 - CURVE.nBitLength;
      return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes2) {
      return modN(bits2int(bytes2));
    };
    const ORDER_MASK = bitMask(CURVE.nBitLength);
    function int2octets(num) {
      if (typeof num !== "bigint")
        throw new Error("bigint expected");
      if (!(_0n5 <= num && num < ORDER_MASK))
        throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
      return numberToBytesBE(num, CURVE.nByteLength);
    }
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
      if (["recovered", "canonical"].some((k) => k in opts))
        throw new Error("sign() legacy options not supported");
      const { hash: hash2, randomBytes: randomBytes3 } = CURVE;
      let { lowS, prehash, extraEntropy: ent } = opts;
      if (lowS == null)
        lowS = true;
      msgHash = ensureBytes("msgHash", msgHash);
      if (prehash)
        msgHash = ensureBytes("prehashed msgHash", hash2(msgHash));
      const h1int = bits2int_modN(msgHash);
      const d = normPrivateKeyToScalar(privateKey);
      const seedArgs = [int2octets(d), int2octets(h1int)];
      if (ent != null) {
        const e2 = ent === true ? randomBytes3(Fp2.BYTES) : ent;
        seedArgs.push(ensureBytes("extraEntropy", e2, Fp2.BYTES));
      }
      const seed = concatBytes2(...seedArgs);
      const m = h1int;
      function k2sig(kBytes) {
        const k = bits2int(kBytes);
        if (!isWithinCurveOrder(k))
          return;
        const ik = invN(k);
        const q = Point2.BASE.multiply(k).toAffine();
        const r2 = modN(q.x);
        if (r2 === _0n5)
          return;
        const s2 = modN(ik * modN(m + r2 * d));
        if (s2 === _0n5)
          return;
        let recovery = (q.x === r2 ? 0 : 2) | Number(q.y & _1n5);
        let normS = s2;
        if (lowS && isBiggerThanHalfOrder(s2)) {
          normS = normalizeS(s2);
          recovery ^= 1;
        }
        return new Signature(r2, normS, recovery);
      }
      return { seed, k2sig };
    }
    const defaultSigOpts = { lowS: CURVE.lowS, prehash: false };
    const defaultVerOpts = { lowS: CURVE.lowS, prehash: false };
    function sign6(msgHash, privKey, opts = defaultSigOpts) {
      const { seed, k2sig } = prepSig(msgHash, privKey, opts);
      const C = CURVE;
      const drbg = createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
      return drbg(seed, k2sig);
    }
    Point2.BASE._setWindowSize(8);
    function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
      const sg = signature;
      msgHash = ensureBytes("msgHash", msgHash);
      publicKey = ensureBytes("publicKey", publicKey);
      if ("strict" in opts)
        throw new Error("options.strict was renamed to lowS");
      const { lowS, prehash } = opts;
      let _sig = void 0;
      let P;
      try {
        if (typeof sg === "string" || sg instanceof Uint8Array) {
          try {
            _sig = Signature.fromDER(sg);
          } catch (derError) {
            if (!(derError instanceof DER.Err))
              throw derError;
            _sig = Signature.fromCompact(sg);
          }
        } else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
          const { r: r3, s: s3 } = sg;
          _sig = new Signature(r3, s3);
        } else {
          throw new Error("PARSE");
        }
        P = Point2.fromHex(publicKey);
      } catch (error) {
        if (error.message === "PARSE")
          throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
        return false;
      }
      if (lowS && _sig.hasHighS())
        return false;
      if (prehash)
        msgHash = CURVE.hash(msgHash);
      const { r: r2, s: s2 } = _sig;
      const h = bits2int_modN(msgHash);
      const is = invN(s2);
      const u1 = modN(h * is);
      const u2 = modN(r2 * is);
      const R = Point2.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine();
      if (!R)
        return false;
      const v = modN(R.x);
      return v === r2;
    }
    return {
      CURVE,
      getPublicKey,
      getSharedSecret,
      sign: sign6,
      verify,
      ProjectivePoint: Point2,
      Signature,
      utils
    };
  }

  // ../../node_modules/.pnpm/@noble+curves@1.1.0/node_modules/@noble/curves/esm/_shortw_utils.js
  function getHash(hash2) {
    return {
      hash: hash2,
      hmac: (key, ...msgs) => hmac(hash2, key, concatBytes(...msgs)),
      randomBytes
    };
  }
  function createCurve(curveDef, defHash) {
    const create2 = (hash2) => weierstrass({ ...curveDef, ...getHash(hash2) });
    return Object.freeze({ ...create2(defHash), create: create2 });
  }

  // ../../node_modules/.pnpm/@noble+curves@1.1.0/node_modules/@noble/curves/esm/secp256k1.js
  var secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
  var secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
  var _1n6 = BigInt(1);
  var _2n5 = BigInt(2);
  var divNearest = (a, b) => (a + b / _2n5) / b;
  function sqrtMod(y) {
    const P = secp256k1P;
    const _3n3 = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b22 = y * y * y % P;
    const b3 = b22 * b22 * y % P;
    const b6 = pow2(b3, _3n3, P) * b3 % P;
    const b9 = pow2(b6, _3n3, P) * b3 % P;
    const b11 = pow2(b9, _2n5, P) * b22 % P;
    const b222 = pow2(b11, _11n, P) * b11 % P;
    const b44 = pow2(b222, _22n, P) * b222 % P;
    const b88 = pow2(b44, _44n, P) * b44 % P;
    const b176 = pow2(b88, _88n, P) * b88 % P;
    const b220 = pow2(b176, _44n, P) * b44 % P;
    const b223 = pow2(b220, _3n3, P) * b3 % P;
    const t1 = pow2(b223, _23n, P) * b222 % P;
    const t2 = pow2(t1, _6n, P) * b22 % P;
    const root = pow2(t2, _2n5, P);
    if (!Fp.eql(Fp.sqr(root), y))
      throw new Error("Cannot find square root");
    return root;
  }
  var Fp = Field(secp256k1P, void 0, void 0, { sqrt: sqrtMod });
  var secp256k1 = createCurve({
    a: BigInt(0),
    b: BigInt(7),
    Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */
    endo: {
      beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
      splitScalar: (k) => {
        const n2 = secp256k1N;
        const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
        const b1 = -_1n6 * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
        const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
        const b22 = a1;
        const POW_2_128 = BigInt("0x100000000000000000000000000000000");
        const c1 = divNearest(b22 * k, n2);
        const c2 = divNearest(-b1 * k, n2);
        let k1 = mod2(k - c1 * a1 - c2 * a2, n2);
        let k2 = mod2(-c1 * b1 - c2 * b22, n2);
        const k1neg = k1 > POW_2_128;
        const k2neg = k2 > POW_2_128;
        if (k1neg)
          k1 = n2 - k1;
        if (k2neg)
          k2 = n2 - k2;
        if (k1 > POW_2_128 || k2 > POW_2_128) {
          throw new Error("splitScalar: Endomorphism failed, k=" + k);
        }
        return { k1neg, k1, k2neg, k2 };
      }
    }
  }, sha256);
  var _0n6 = BigInt(0);
  var Point = secp256k1.ProjectivePoint;

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/constants.js
  var _a3;
  var secp256k12 = (_a3 = secp256k1) !== null && _a3 !== void 0 ? _a3 : secp256k1_exports;
  var MAX_UINT64 = BigInt("0xffffffffffffffff");
  var MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
  var SECP256K1_ORDER = secp256k12.CURVE.n;
  var SECP256K1_ORDER_DIV_2 = SECP256K1_ORDER / BigInt(2);

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/schemas.js
  var keyStoreSchema = {
    type: "object",
    required: ["crypto", "id", "version", "address"],
    properties: {
      crypto: {
        type: "object",
        required: ["cipher", "ciphertext", "cipherparams", "kdf", "kdfparams", "mac"],
        properties: {
          cipher: { type: "string" },
          ciphertext: { type: "string" },
          cipherparams: { type: "object" },
          kdf: { type: "string" },
          kdfparams: { type: "object" },
          salt: { type: "string" },
          mac: { type: "string" }
        }
      },
      id: { type: "string" },
      version: { type: "number" },
      address: { type: "string" }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/enums.js
  var Chain;
  (function(Chain2) {
    Chain2[Chain2["Mainnet"] = 1] = "Mainnet";
    Chain2[Chain2["Goerli"] = 5] = "Goerli";
    Chain2[Chain2["Sepolia"] = 11155111] = "Sepolia";
  })(Chain || (Chain = {}));
  var Hardfork;
  (function(Hardfork2) {
    Hardfork2["Chainstart"] = "chainstart";
    Hardfork2["Homestead"] = "homestead";
    Hardfork2["Dao"] = "dao";
    Hardfork2["TangerineWhistle"] = "tangerineWhistle";
    Hardfork2["SpuriousDragon"] = "spuriousDragon";
    Hardfork2["Byzantium"] = "byzantium";
    Hardfork2["Constantinople"] = "constantinople";
    Hardfork2["Petersburg"] = "petersburg";
    Hardfork2["Istanbul"] = "istanbul";
    Hardfork2["MuirGlacier"] = "muirGlacier";
    Hardfork2["Berlin"] = "berlin";
    Hardfork2["London"] = "london";
    Hardfork2["ArrowGlacier"] = "arrowGlacier";
    Hardfork2["GrayGlacier"] = "grayGlacier";
    Hardfork2["MergeForkIdTransition"] = "mergeForkIdTransition";
    Hardfork2["Merge"] = "merge";
    Hardfork2["Shanghai"] = "shanghai";
    Hardfork2["ShardingForkDev"] = "shardingFork";
  })(Hardfork || (Hardfork = {}));
  var ConsensusType;
  (function(ConsensusType2) {
    ConsensusType2["ProofOfStake"] = "pos";
    ConsensusType2["ProofOfWork"] = "pow";
    ConsensusType2["ProofOfAuthority"] = "poa";
  })(ConsensusType || (ConsensusType = {}));
  var ConsensusAlgorithm;
  (function(ConsensusAlgorithm2) {
    ConsensusAlgorithm2["Ethash"] = "ethash";
    ConsensusAlgorithm2["Clique"] = "clique";
    ConsensusAlgorithm2["Casper"] = "casper";
  })(ConsensusAlgorithm || (ConsensusAlgorithm = {}));
  var CustomChain;
  (function(CustomChain2) {
    CustomChain2["PolygonMainnet"] = "polygon-mainnet";
    CustomChain2["PolygonMumbai"] = "polygon-mumbai";
    CustomChain2["ArbitrumRinkebyTestnet"] = "arbitrum-rinkeby-testnet";
    CustomChain2["ArbitrumOne"] = "arbitrum-one";
    CustomChain2["xDaiChain"] = "x-dai-chain";
    CustomChain2["OptimisticKovan"] = "optimistic-kovan";
    CustomChain2["OptimisticEthereum"] = "optimistic-ethereum";
  })(CustomChain || (CustomChain = {}));

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/types.js
  var TypeOutput;
  (function(TypeOutput2) {
    TypeOutput2[TypeOutput2["Number"] = 0] = "Number";
    TypeOutput2[TypeOutput2["BigInt"] = 1] = "BigInt";
    TypeOutput2[TypeOutput2["Uint8Array"] = 2] = "Uint8Array";
    TypeOutput2[TypeOutput2["PrefixedHexString"] = 3] = "PrefixedHexString";
  })(TypeOutput || (TypeOutput = {}));

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/utils.js
  var stripHexPrefix = (str) => {
    if (typeof str !== "string")
      throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
    return isHexPrefixed(str) ? str.slice(2) : str;
  };
  function formatNonce(nonce) {
    if (!nonce || nonce === "0x0") {
      return "0x0000000000000000";
    }
    if (isHexPrefixed(nonce)) {
      return `0x${stripHexPrefix(nonce).padStart(16, "0")}`;
    }
    return `0x${nonce.padStart(16, "0")}`;
  }
  var intToHex = function(i2) {
    if (!Number.isSafeInteger(i2) || i2 < 0) {
      throw new Error(`Received an invalid integer type: ${i2}`);
    }
    return `0x${i2.toString(16)}`;
  };
  function parseGethParams(json, mergeForkIdPostMerge = true) {
    var _a6, _b3;
    const { name: name2, config, difficulty, mixHash, gasLimit, coinbase, baseFeePerGas } = json;
    let { extraData, timestamp: timestamp2, nonce } = json;
    const genesisTimestamp = Number(timestamp2);
    const { chainId } = config;
    if (extraData === "") {
      extraData = "0x";
    }
    if (!isHexPrefixed(timestamp2)) {
      timestamp2 = intToHex(parseInt(timestamp2));
    }
    if (nonce.length !== 18) {
      nonce = formatNonce(nonce);
    }
    if (config.eip155Block !== config.eip158Block) {
      throw new Error("EIP155 block number must equal EIP 158 block number since both are part of SpuriousDragon hardfork and the client only supports activating the full hardfork");
    }
    const params = {
      name: name2,
      chainId,
      networkId: chainId,
      genesis: {
        timestamp: timestamp2,
        // eslint-disable-next-line radix
        gasLimit: parseInt(gasLimit),
        // eslint-disable-next-line radix
        difficulty: parseInt(difficulty),
        nonce,
        extraData,
        mixHash,
        coinbase,
        baseFeePerGas
      },
      hardfork: void 0,
      hardforks: [],
      bootstrapNodes: [],
      consensus: (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        config.clique !== void 0 ? {
          type: "poa",
          algorithm: "clique",
          clique: {
            // The recent geth genesis seems to be using blockperiodseconds
            // and epochlength for clique specification
            // see: https://hackmd.io/PqZgMpnkSWCWv5joJoFymQ
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
            period: (_a6 = config.clique.period) !== null && _a6 !== void 0 ? _a6 : config.clique.blockperiodseconds,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-unsafe-assignment
            epoch: (_b3 = config.clique.epoch) !== null && _b3 !== void 0 ? _b3 : config.clique.epochlength
          }
        } : {
          type: "pow",
          algorithm: "ethash",
          ethash: {}
        }
      )
    };
    const forkMap = {
      [Hardfork.Homestead]: { name: "homesteadBlock" },
      [Hardfork.Dao]: { name: "daoForkBlock" },
      [Hardfork.TangerineWhistle]: { name: "eip150Block" },
      [Hardfork.SpuriousDragon]: { name: "eip155Block" },
      [Hardfork.Byzantium]: { name: "byzantiumBlock" },
      [Hardfork.Constantinople]: { name: "constantinopleBlock" },
      [Hardfork.Petersburg]: { name: "petersburgBlock" },
      [Hardfork.Istanbul]: { name: "istanbulBlock" },
      [Hardfork.MuirGlacier]: { name: "muirGlacierBlock" },
      [Hardfork.Berlin]: { name: "berlinBlock" },
      [Hardfork.London]: { name: "londonBlock" },
      [Hardfork.MergeForkIdTransition]: {
        name: "mergeForkBlock",
        postMerge: mergeForkIdPostMerge
      },
      [Hardfork.Shanghai]: { name: "shanghaiTime", postMerge: true, isTimestamp: true },
      [Hardfork.ShardingForkDev]: {
        name: "shardingForkTime",
        postMerge: true,
        isTimestamp: true
      }
    };
    const forkMapRev = Object.keys(forkMap).reduce((acc, elem) => {
      acc[forkMap[elem].name] = elem;
      return acc;
    }, {});
    const configHardforkNames = Object.keys(config).filter(
      // eslint-disable-next-line no-null/no-null, @typescript-eslint/no-unsafe-member-access
      (key) => forkMapRev[key] !== void 0 && config[key] !== void 0 && config[key] !== null
    );
    params.hardforks = configHardforkNames.map((nameBlock) => ({
      name: forkMapRev[nameBlock],
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      block: (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        forkMap[forkMapRev[nameBlock]].isTimestamp === true || // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        typeof config[nameBlock] !== "number" ? (
          // eslint-disable-next-line no-null/no-null
          null
        ) : (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          config[nameBlock]
        )
      ),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      timestamp: (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        forkMap[forkMapRev[nameBlock]].isTimestamp === true && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        typeof config[nameBlock] === "number" ? (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          config[nameBlock]
        ) : void 0
      )
    })).filter((fork) => fork.block !== null || fork.timestamp !== void 0);
    params.hardforks.sort((a, b) => {
      var _a7, _b4;
      return ((_a7 = a.block) !== null && _a7 !== void 0 ? _a7 : Infinity) - ((_b4 = b.block) !== null && _b4 !== void 0 ? _b4 : Infinity);
    });
    params.hardforks.sort((a, b) => {
      var _a7, _b4;
      return ((_a7 = a.timestamp) !== null && _a7 !== void 0 ? _a7 : genesisTimestamp) - ((_b4 = b.timestamp) !== null && _b4 !== void 0 ? _b4 : genesisTimestamp);
    });
    if (config.terminalTotalDifficulty !== void 0) {
      const mergeConfig3 = {
        name: Hardfork.Merge,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
        ttd: config.terminalTotalDifficulty,
        // eslint-disable-next-line no-null/no-null
        block: null
      };
      const postMergeIndex = params.hardforks.findIndex(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (hf) => {
          var _a7;
          return ((_a7 = forkMap[hf.name]) === null || _a7 === void 0 ? void 0 : _a7.postMerge) === true;
        }
      );
      if (postMergeIndex !== -1) {
        params.hardforks.splice(postMergeIndex, 0, mergeConfig3);
      } else {
        params.hardforks.push(mergeConfig3);
      }
    }
    const latestHardfork = params.hardforks.length > 0 ? params.hardforks.slice(-1)[0] : void 0;
    params.hardfork = latestHardfork === null || latestHardfork === void 0 ? void 0 : latestHardfork.name;
    params.hardforks.unshift({ name: Hardfork.Chainstart, block: 0 });
    return params;
  }
  function parseGethGenesis(json, name2, mergeForkIdPostMerge) {
    try {
      if (["config", "difficulty", "gasLimit", "alloc"].some((field2) => !(field2 in json))) {
        throw new Error("Invalid format, expected geth genesis fields missing");
      }
      if (name2 !== void 0) {
        json.name = name2;
      }
      return parseGethParams(json, mergeForkIdPostMerge);
    } catch (e2) {
      throw new Error(`Error parsing parameters file: ${e2.message}`);
    }
  }
  function padToEven(value) {
    let a = value;
    if (typeof a !== "string") {
      throw new Error(`[padToEven] value must be type 'string', received ${typeof a}`);
    }
    if (a.length % 2)
      a = `0${a}`;
    return a;
  }
  var intToUint8Array = function(i2) {
    const hex = intToHex(i2);
    return hexToBytes2(`0x${padToEven(hex.slice(2))}`);
  };
  var toUint8Array = function(v) {
    if (v === null || v === void 0) {
      return new Uint8Array();
    }
    if (v instanceof Uint8Array) {
      return v;
    }
    if (Array.isArray(v)) {
      return Uint8Array.from(v);
    }
    if (typeof v === "string") {
      if (!isHexString(v)) {
        throw new Error(`Cannot convert string to Uint8Array. only supports 0x-prefixed hex strings and this string was given: ${v}`);
      }
      return hexToBytes2(padToEven(stripHexPrefix(v)));
    }
    if (typeof v === "number") {
      return toUint8Array(numberToHex2(v));
    }
    if (typeof v === "bigint") {
      if (v < BigInt(0)) {
        throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${v}`);
      }
      let n2 = v.toString(16);
      if (n2.length % 2)
        n2 = `0${n2}`;
      return toUint8Array(`0x${n2}`);
    }
    if (v.toArray) {
      return Uint8Array.from(v.toArray());
    }
    throw new Error("invalid type");
  };
  function uint8ArrayToBigInt(buf) {
    const hex = bytesToHex2(buf);
    if (hex === "0x") {
      return BigInt(0);
    }
    return BigInt(hex);
  }
  function bigIntToUint8Array(num) {
    return toUint8Array(`0x${num.toString(16)}`);
  }
  var zeros = function(bytes2) {
    return new Uint8Array(bytes2).fill(0);
  };
  var setLength = function(msg, length2, right) {
    const buf = zeros(length2);
    if (right) {
      if (msg.length < length2) {
        buf.set(msg);
        return buf;
      }
      return msg.subarray(0, length2);
    }
    if (msg.length < length2) {
      buf.set(msg, length2 - msg.length);
      return buf;
    }
    return msg.subarray(-length2);
  };
  function assertIsUint8Array(input) {
    if (!(input instanceof Uint8Array)) {
      const msg = `This method only supports Uint8Array but input was: ${input}`;
      throw new Error(msg);
    }
  }
  var setLengthLeft = function(msg, length2) {
    assertIsUint8Array(msg);
    return setLength(msg, length2, false);
  };
  function stripZeros(a) {
    let first = a[0];
    while (a.length > 0 && first.toString() === "0") {
      a = a.slice(1);
      first = a[0];
    }
    return a;
  }
  var unpadUint8Array = function(a) {
    assertIsUint8Array(a);
    return stripZeros(a);
  };
  var bigIntToHex = (num) => `0x${num.toString(16)}`;
  function bigIntToUnpaddedUint8Array(value) {
    return unpadUint8Array(bigIntToUint8Array(value));
  }
  function calculateSigRecovery(v, chainId) {
    if (v === BigInt(0) || v === BigInt(1))
      return v;
    if (chainId === void 0) {
      return v - BigInt(27);
    }
    return v - (chainId * BigInt(2) + BigInt(35));
  }
  function isValidSigRecovery(recovery) {
    return recovery === BigInt(0) || recovery === BigInt(1);
  }
  var ecrecover = function(msgHash, v, r2, s2, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) {
      throw new Error("Invalid signature v value");
    }
    const senderPubKey = new secp256k12.Signature(uint8ArrayToBigInt(r2), uint8ArrayToBigInt(s2)).addRecoveryBit(Number(recovery)).recoverPublicKey(msgHash).toRawBytes(false);
    return senderPubKey.slice(1);
  };
  function toType(input, outputType) {
    if (input === null) {
      return null;
    }
    if (input === void 0) {
      return void 0;
    }
    if (typeof input === "string" && !isHexString(input)) {
      throw new Error(`A string must be provided with a 0x-prefix, given: ${input}`);
    } else if (typeof input === "number" && !Number.isSafeInteger(input)) {
      throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    }
    const output3 = toUint8Array(input);
    switch (outputType) {
      case TypeOutput.Uint8Array:
        return output3;
      case TypeOutput.BigInt:
        return uint8ArrayToBigInt(output3);
      case TypeOutput.Number: {
        const bigInt = uint8ArrayToBigInt(output3);
        if (bigInt > BigInt(Number.MAX_SAFE_INTEGER)) {
          throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
        }
        return Number(bigInt);
      }
      case TypeOutput.PrefixedHexString:
        return bytesToHex2(output3);
      default:
        throw new Error("unknown outputType");
    }
  }

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/eip1559Transaction.js
  var import_rlp = __toESM(require_dist(), 1);

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/common.js
  var import_crc_32 = __toESM(require_crc32(), 1);

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/chains/goerli.js
  var goerli_default = {
    "name": "goerli",
    "chainId": 5,
    "networkId": 5,
    "defaultHardfork": "merge",
    "consensus": {
      "type": "poa",
      "algorithm": "clique",
      "clique": {
        "period": 15,
        "epoch": 3e4
      }
    },
    "comment": "Cross-client PoA test network",
    "url": "https://github.com/goerli/testnet",
    "genesis": {
      "timestamp": "0x5c51a607",
      "gasLimit": 10485760,
      "difficulty": 1,
      "nonce": "0x0000000000000000",
      "extraData": "0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
    },
    "hardforks": [
      {
        "name": "chainstart",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "homestead",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "tangerineWhistle",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "spuriousDragon",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "byzantium",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "constantinople",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "petersburg",
        "block": 0,
        "forkHash": "0xa3f5ab08"
      },
      {
        "name": "istanbul",
        "block": 1561651,
        "forkHash": "0xc25efa5c"
      },
      {
        "name": "berlin",
        "block": 4460644,
        "forkHash": "0x757a1c47"
      },
      {
        "name": "london",
        "block": 5062605,
        "forkHash": "0xb8c6299d"
      },
      {
        "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://goerli.etherscan.io/block/7382818",
        "name": "merge",
        "ttd": "10790000",
        "block": 7382819,
        "forkHash": "0xb8c6299d"
      },
      {
        "name": "mergeForkIdTransition",
        "block": null,
        "forkHash": null
      },
      {
        "name": "shanghai",
        "block": null,
        "forkHash": null
      }
    ],
    "bootstrapNodes": [],
    "dnsNetworks": [
      "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net"
    ]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/chains/mainnet.js
  var mainnet_default = {
    "name": "mainnet",
    "chainId": 1,
    "networkId": 1,
    "defaultHardfork": "merge",
    "consensus": {
      "type": "pow",
      "algorithm": "ethash",
      "ethash": {}
    },
    "comment": "The Ethereum main chain",
    "url": "https://ethstats.net/",
    "genesis": {
      "gasLimit": 5e3,
      "difficulty": 17179869184,
      "nonce": "0x0000000000000042",
      "extraData": "0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa"
    },
    "hardforks": [
      {
        "name": "chainstart",
        "block": 0,
        "forkHash": "0xfc64ec04"
      },
      {
        "name": "homestead",
        "block": 115e4,
        "forkHash": "0x97c2c34c"
      },
      {
        "name": "dao",
        "block": 192e4,
        "forkHash": "0x91d1f948"
      },
      {
        "name": "tangerineWhistle",
        "block": 2463e3,
        "forkHash": "0x7a64da13"
      },
      {
        "name": "spuriousDragon",
        "block": 2675e3,
        "forkHash": "0x3edd5b10"
      },
      {
        "name": "byzantium",
        "block": 437e4,
        "forkHash": "0xa00bc324"
      },
      {
        "name": "constantinople",
        "block": 728e4,
        "forkHash": "0x668db0af"
      },
      {
        "name": "petersburg",
        "block": 728e4,
        "forkHash": "0x668db0af"
      },
      {
        "name": "istanbul",
        "block": 9069e3,
        "forkHash": "0x879d6e30"
      },
      {
        "name": "muirGlacier",
        "block": 92e5,
        "forkHash": "0xe029e991"
      },
      {
        "name": "berlin",
        "block": 12244e3,
        "forkHash": "0x0eb440f6"
      },
      {
        "name": "london",
        "block": 12965e3,
        "forkHash": "0xb715077d"
      },
      {
        "name": "arrowGlacier",
        "block": 13773e3,
        "forkHash": "0x20c327fc"
      },
      {
        "name": "grayGlacier",
        "block": 1505e4,
        "forkHash": "0xf0afd0e3"
      },
      {
        "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://etherscan.io/block/15537393",
        "name": "merge",
        "ttd": "58750000000000000000000",
        "block": 15537394,
        "forkHash": "0xf0afd0e3"
      },
      {
        "name": "mergeForkIdTransition",
        "block": null,
        "forkHash": null
      },
      {
        "name": "shanghai",
        "block": null,
        "forkHash": null
      }
    ],
    "bootstrapNodes": [],
    "dnsNetworks": [
      "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net"
    ]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/chains/sepolia.js
  var sepolia_default = {
    "name": "sepolia",
    "chainId": 11155111,
    "networkId": 11155111,
    "defaultHardfork": "merge",
    "consensus": {
      "type": "pow",
      "algorithm": "ethash",
      "ethash": {}
    },
    "comment": "PoW test network to replace Ropsten",
    "url": "https://github.com/ethereum/go-ethereum/pull/23730",
    "genesis": {
      "timestamp": "0x6159af19",
      "gasLimit": 3e7,
      "difficulty": 131072,
      "nonce": "0x0000000000000000",
      "extraData": "0x5365706f6c69612c20417468656e732c204174746963612c2047726565636521"
    },
    "hardforks": [
      {
        "name": "chainstart",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "homestead",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "tangerineWhistle",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "spuriousDragon",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "byzantium",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "constantinople",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "petersburg",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "istanbul",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "muirGlacier",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "berlin",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "london",
        "block": 0,
        "forkHash": "0xfe3366e7"
      },
      {
        "//_comment": "The forkHash will remain same as mergeForkIdTransition is post merge, terminal block: https://sepolia.etherscan.io/block/1450408",
        "name": "merge",
        "ttd": "17000000000000000",
        "block": 1450409,
        "forkHash": "0xfe3366e7"
      },
      {
        "name": "mergeForkIdTransition",
        "block": 1735371,
        "forkHash": "0xb96cbd13"
      },
      {
        "name": "shanghai",
        "block": null,
        "timestamp": "1677557088",
        "forkHash": "0xf7f9bc08"
      }
    ],
    "bootstrapNodes": [],
    "dnsNetworks": [
      "enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.sepolia.ethdisco.net"
    ]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/1153.js
  var __default = {
    "name": "EIP-1153",
    "number": 1153,
    "comment": "Transient Storage",
    "url": "https://eips.ethereum.org/EIPS/eip-1153",
    "status": "Review",
    "minimumHardfork": "chainstart",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {
      "tstore": {
        "v": 100,
        "d": "Base fee of the TSTORE opcode"
      },
      "tload": {
        "v": 100,
        "d": "Base fee of the TLOAD opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/1559.js
  var __default2 = {
    "name": "EIP-1559",
    "number": 1559,
    "comment": "Fee market change for ETH 1.0 chain",
    "url": "https://eips.ethereum.org/EIPS/eip-1559",
    "status": "Final",
    "minimumHardfork": "berlin",
    "requiredEIPs": [2930],
    "gasConfig": {
      "baseFeeMaxChangeDenominator": {
        "v": 8,
        "d": "Maximum base fee change denominator"
      },
      "elasticityMultiplier": {
        "v": 2,
        "d": "Maximum block gas target elasticity"
      },
      "initialBaseFee": {
        "v": 1e9,
        "d": "Initial base fee on first EIP1559 block"
      }
    },
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/2315.js
  var __default3 = {
    "name": "EIP-2315",
    "number": 2315,
    "comment": "Simple subroutines for the EVM",
    "url": "https://eips.ethereum.org/EIPS/eip-2315",
    "status": "Draft",
    "minimumHardfork": "istanbul",
    "gasConfig": {},
    "gasPrices": {
      "beginsub": {
        "v": 2,
        "d": "Base fee of the BEGINSUB opcode"
      },
      "returnsub": {
        "v": 5,
        "d": "Base fee of the RETURNSUB opcode"
      },
      "jumpsub": {
        "v": 10,
        "d": "Base fee of the JUMPSUB opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/2537.js
  var __default4 = {
    "name": "EIP-2537",
    "number": 2537,
    "comment": "BLS12-381 precompiles",
    "url": "https://eips.ethereum.org/EIPS/eip-2537",
    "status": "Draft",
    "minimumHardfork": "chainstart",
    "gasConfig": {},
    "gasPrices": {
      "Bls12381G1AddGas": {
        "v": 600,
        "d": "Gas cost of a single BLS12-381 G1 addition precompile-call"
      },
      "Bls12381G1MulGas": {
        "v": 12e3,
        "d": "Gas cost of a single BLS12-381 G1 multiplication precompile-call"
      },
      "Bls12381G2AddGas": {
        "v": 4500,
        "d": "Gas cost of a single BLS12-381 G2 addition precompile-call"
      },
      "Bls12381G2MulGas": {
        "v": 55e3,
        "d": "Gas cost of a single BLS12-381 G2 multiplication precompile-call"
      },
      "Bls12381PairingBaseGas": {
        "v": 115e3,
        "d": "Base gas cost of BLS12-381 pairing check"
      },
      "Bls12381PairingPerPairGas": {
        "v": 23e3,
        "d": "Per-pair gas cost of BLS12-381 pairing check"
      },
      "Bls12381MapG1Gas": {
        "v": 5500,
        "d": "Gas cost of BLS12-381 map field element to G1"
      },
      "Bls12381MapG2Gas": {
        "v": 11e4,
        "d": "Gas cost of BLS12-381 map field element to G2"
      },
      "Bls12381MultiExpGasDiscount": {
        "v": [
          [1, 1200],
          [2, 888],
          [3, 764],
          [4, 641],
          [5, 594],
          [6, 547],
          [7, 500],
          [8, 453],
          [9, 438],
          [10, 423],
          [11, 408],
          [12, 394],
          [13, 379],
          [14, 364],
          [15, 349],
          [16, 334],
          [17, 330],
          [18, 326],
          [19, 322],
          [20, 318],
          [21, 314],
          [22, 310],
          [23, 306],
          [24, 302],
          [25, 298],
          [26, 294],
          [27, 289],
          [28, 285],
          [29, 281],
          [30, 277],
          [31, 273],
          [32, 269],
          [33, 268],
          [34, 266],
          [35, 265],
          [36, 263],
          [37, 262],
          [38, 260],
          [39, 259],
          [40, 257],
          [41, 256],
          [42, 254],
          [43, 253],
          [44, 251],
          [45, 250],
          [46, 248],
          [47, 247],
          [48, 245],
          [49, 244],
          [50, 242],
          [51, 241],
          [52, 239],
          [53, 238],
          [54, 236],
          [55, 235],
          [56, 233],
          [57, 232],
          [58, 231],
          [59, 229],
          [60, 228],
          [61, 226],
          [62, 225],
          [63, 223],
          [64, 222],
          [65, 221],
          [66, 220],
          [67, 219],
          [68, 219],
          [69, 218],
          [70, 217],
          [71, 216],
          [72, 216],
          [73, 215],
          [74, 214],
          [75, 213],
          [76, 213],
          [77, 212],
          [78, 211],
          [79, 211],
          [80, 210],
          [81, 209],
          [82, 208],
          [83, 208],
          [84, 207],
          [85, 206],
          [86, 205],
          [87, 205],
          [88, 204],
          [89, 203],
          [90, 202],
          [91, 202],
          [92, 201],
          [93, 200],
          [94, 199],
          [95, 199],
          [96, 198],
          [97, 197],
          [98, 196],
          [99, 196],
          [100, 195],
          [101, 194],
          [102, 193],
          [103, 193],
          [104, 192],
          [105, 191],
          [106, 191],
          [107, 190],
          [108, 189],
          [109, 188],
          [110, 188],
          [111, 187],
          [112, 186],
          [113, 185],
          [114, 185],
          [115, 184],
          [116, 183],
          [117, 182],
          [118, 182],
          [119, 181],
          [120, 180],
          [121, 179],
          [122, 179],
          [123, 178],
          [124, 177],
          [125, 176],
          [126, 176],
          [127, 175],
          [128, 174]
        ],
        "d": "Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/2565.js
  var __default5 = {
    "name": "EIP-2565",
    "number": 2565,
    "comment": "ModExp gas cost",
    "url": "https://eips.ethereum.org/EIPS/eip-2565",
    "status": "Final",
    "minimumHardfork": "byzantium",
    "gasConfig": {},
    "gasPrices": {
      "modexpGquaddivisor": {
        "v": 3,
        "d": "Gquaddivisor from modexp precompile for gas calculation"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/2718.js
  var __default6 = {
    "name": "EIP-2718",
    "comment": "Typed Transaction Envelope",
    "url": "https://eips.ethereum.org/EIPS/eip-2718",
    "status": "Final",
    "minimumHardfork": "chainstart",
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/2929.js
  var __default7 = {
    "name": "EIP-2929",
    "comment": "Gas cost increases for state access opcodes",
    "url": "https://eips.ethereum.org/EIPS/eip-2929",
    "status": "Final",
    "minimumHardfork": "chainstart",
    "gasConfig": {},
    "gasPrices": {
      "coldsload": {
        "v": 2100,
        "d": "Gas cost of the first read of storage from a given location (per transaction)"
      },
      "coldaccountaccess": {
        "v": 2600,
        "d": "Gas cost of the first read of a given address (per transaction)"
      },
      "warmstorageread": {
        "v": 100,
        "d": "Gas cost of reading storage locations which have already loaded 'cold'"
      },
      "sstoreCleanGasEIP2200": {
        "v": 2900,
        "d": "Once per SSTORE operation from clean non-zero to something else"
      },
      "sstoreNoopGasEIP2200": {
        "v": 100,
        "d": "Once per SSTORE operation if the value doesn't change"
      },
      "sstoreDirtyGasEIP2200": {
        "v": 100,
        "d": "Once per SSTORE operation if a dirty value is changed"
      },
      "sstoreInitRefundEIP2200": {
        "v": 19900,
        "d": "Once per SSTORE operation for resetting to the original zero value"
      },
      "sstoreCleanRefundEIP2200": {
        "v": 4900,
        "d": "Once per SSTORE operation for resetting to the original non-zero value"
      },
      "call": {
        "v": 0,
        "d": "Base fee of the CALL opcode"
      },
      "callcode": {
        "v": 0,
        "d": "Base fee of the CALLCODE opcode"
      },
      "delegatecall": {
        "v": 0,
        "d": "Base fee of the DELEGATECALL opcode"
      },
      "staticcall": {
        "v": 0,
        "d": "Base fee of the STATICCALL opcode"
      },
      "balance": {
        "v": 0,
        "d": "Base fee of the BALANCE opcode"
      },
      "extcodesize": {
        "v": 0,
        "d": "Base fee of the EXTCODESIZE opcode"
      },
      "extcodecopy": {
        "v": 0,
        "d": "Base fee of the EXTCODECOPY opcode"
      },
      "extcodehash": {
        "v": 0,
        "d": "Base fee of the EXTCODEHASH opcode"
      },
      "sload": {
        "v": 0,
        "d": "Base fee of the SLOAD opcode"
      },
      "sstore": {
        "v": 0,
        "d": "Base fee of the SSTORE opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/2930.js
  var __default8 = {
    "name": "EIP-2930",
    "comment": "Optional access lists",
    "url": "https://eips.ethereum.org/EIPS/eip-2930",
    "status": "Final",
    "minimumHardfork": "istanbul",
    "requiredEIPs": [2718, 2929],
    "gasConfig": {},
    "gasPrices": {
      "accessListStorageKeyCost": {
        "v": 1900,
        "d": "Gas cost per storage key in an Access List transaction"
      },
      "accessListAddressCost": {
        "v": 2400,
        "d": "Gas cost per storage key in an Access List transaction"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3198.js
  var __default9 = {
    "name": "EIP-3198",
    "number": 3198,
    "comment": "BASEFEE opcode",
    "url": "https://eips.ethereum.org/EIPS/eip-3198",
    "status": "Final",
    "minimumHardfork": "london",
    "gasConfig": {},
    "gasPrices": {
      "basefee": {
        "v": 2,
        "d": "Gas cost of the BASEFEE opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3529.js
  var __default10 = {
    "name": "EIP-3529",
    "comment": "Reduction in refunds",
    "url": "https://eips.ethereum.org/EIPS/eip-3529",
    "status": "Final",
    "minimumHardfork": "berlin",
    "requiredEIPs": [2929],
    "gasConfig": {
      "maxRefundQuotient": {
        "v": 5,
        "d": "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
      }
    },
    "gasPrices": {
      "selfdestructRefund": {
        "v": 0,
        "d": "Refunded following a selfdestruct operation"
      },
      "sstoreClearRefundEIP2200": {
        "v": 4800,
        "d": "Once per SSTORE operation for clearing an originally existing storage slot"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3540.js
  var __default11 = {
    "name": "EIP-3540",
    "number": 3540,
    "comment": "EVM Object Format (EOF) v1",
    "url": "https://eips.ethereum.org/EIPS/eip-3540",
    "status": "Review",
    "minimumHardfork": "london",
    "requiredEIPs": [3541],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3541.js
  var __default12 = {
    "name": "EIP-3541",
    "comment": "Reject new contracts starting with the 0xEF byte",
    "url": "https://eips.ethereum.org/EIPS/eip-3541",
    "status": "Final",
    "minimumHardfork": "berlin",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3554.js
  var __default13 = {
    "name": "EIP-3554",
    "comment": "Reduction in refunds",
    "url": "Difficulty Bomb Delay to December 1st 2021",
    "status": "Final",
    "minimumHardfork": "muirGlacier",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {
      "difficultyBombDelay": {
        "v": 95e5,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3607.js
  var __default14 = {
    "name": "EIP-3607",
    "number": 3607,
    "comment": "Reject transactions from senders with deployed code",
    "url": "https://eips.ethereum.org/EIPS/eip-3607",
    "status": "Final",
    "minimumHardfork": "chainstart",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3651.js
  var __default15 = {
    "name": "EIP-3651",
    "number": 3198,
    "comment": "Warm COINBASE",
    "url": "https://eips.ethereum.org/EIPS/eip-3651",
    "status": "Review",
    "minimumHardfork": "london",
    "requiredEIPs": [2929],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3670.js
  var __default16 = {
    "name": "EIP-3670",
    "number": 3670,
    "comment": "EOF - Code Validation",
    "url": "https://eips.ethereum.org/EIPS/eip-3670",
    "status": "Review",
    "minimumHardfork": "london",
    "requiredEIPs": [3540],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3675.js
  var __default17 = {
    "name": "EIP-3675",
    "number": 3675,
    "comment": "Upgrade consensus to Proof-of-Stake",
    "url": "https://eips.ethereum.org/EIPS/eip-3675",
    "status": "Final",
    "minimumHardfork": "london",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3855.js
  var __default18 = {
    "name": "EIP-3855",
    "number": 3855,
    "comment": "PUSH0 instruction",
    "url": "https://eips.ethereum.org/EIPS/eip-3855",
    "status": "Review",
    "minimumHardfork": "chainstart",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {
      "push0": {
        "v": 2,
        "d": "Base fee of the PUSH0 opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/3860.js
  var __default19 = {
    "name": "EIP-3860",
    "number": 3860,
    "comment": "Limit and meter initcode",
    "url": "https://eips.ethereum.org/EIPS/eip-3860",
    "status": "Review",
    "minimumHardfork": "spuriousDragon",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {
      "initCodeWordCost": {
        "v": 2,
        "d": "Gas to pay for each word (32 bytes) of initcode when creating a contract"
      }
    },
    "vm": {
      "maxInitCodeSize": {
        "v": 49152,
        "d": "Maximum length of initialization code when creating a contract"
      }
    },
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/4345.js
  var __default20 = {
    "name": "EIP-4345",
    "number": 4345,
    "comment": "Difficulty Bomb Delay to June 2022",
    "url": "https://eips.ethereum.org/EIPS/eip-4345",
    "status": "Final",
    "minimumHardfork": "london",
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {
      "difficultyBombDelay": {
        "v": 107e5,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/4399.js
  var __default21 = {
    "name": "EIP-4399",
    "number": 4399,
    "comment": "Supplant DIFFICULTY opcode with PREVRANDAO",
    "url": "https://eips.ethereum.org/EIPS/eip-4399",
    "status": "Review",
    "minimumHardfork": "london",
    "requiredEIPs": [],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/5133.js
  var __default22 = {
    "name": "EIP-5133",
    "number": 5133,
    "comment": "Delaying Difficulty Bomb to mid-September 2022",
    "url": "https://eips.ethereum.org/EIPS/eip-5133",
    "status": "Draft",
    "minimumHardfork": "grayGlacier",
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {
      "difficultyBombDelay": {
        "v": 114e5,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/eips/index.js
  var EIPs = {
    1153: __default,
    1559: __default2,
    2315: __default3,
    2537: __default4,
    2565: __default5,
    2718: __default6,
    2929: __default7,
    2930: __default8,
    3198: __default9,
    3529: __default10,
    3540: __default11,
    3541: __default12,
    3554: __default13,
    3607: __default14,
    3651: __default15,
    3670: __default16,
    3675: __default17,
    3855: __default18,
    3860: __default19,
    4345: __default20,
    4399: __default21,
    5133: __default22
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/chainstart.js
  var chainstart_default = {
    "name": "chainstart",
    "comment": "Start of the Ethereum main chain",
    "url": "",
    "status": "",
    "gasConfig": {
      "minGasLimit": {
        "v": 5e3,
        "d": "Minimum the gas limit may ever be"
      },
      "gasLimitBoundDivisor": {
        "v": 1024,
        "d": "The bound divisor of the gas limit, used in update calculations"
      },
      "maxRefundQuotient": {
        "v": 2,
        "d": "Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"
      }
    },
    "gasPrices": {
      "base": {
        "v": 2,
        "d": "Gas base cost, used e.g. for ChainID opcode (Istanbul)"
      },
      "tierStep": {
        "v": [0, 2, 3, 5, 8, 10, 20],
        "d": "Once per operation, for a selection of them"
      },
      "exp": {
        "v": 10,
        "d": "Base fee of the EXP opcode"
      },
      "expByte": {
        "v": 10,
        "d": "Times ceil(log256(exponent)) for the EXP instruction"
      },
      "sha3": {
        "v": 30,
        "d": "Base fee of the SHA3 opcode"
      },
      "sha3Word": {
        "v": 6,
        "d": "Once per word of the SHA3 operation's data"
      },
      "sload": {
        "v": 50,
        "d": "Base fee of the SLOAD opcode"
      },
      "sstoreSet": {
        "v": 2e4,
        "d": "Once per SSTORE operation if the zeroness changes from zero"
      },
      "sstoreReset": {
        "v": 5e3,
        "d": "Once per SSTORE operation if the zeroness does not change from zero"
      },
      "sstoreRefund": {
        "v": 15e3,
        "d": "Once per SSTORE operation if the zeroness changes to zero"
      },
      "jumpdest": {
        "v": 1,
        "d": "Base fee of the JUMPDEST opcode"
      },
      "log": {
        "v": 375,
        "d": "Base fee of the LOG opcode"
      },
      "logData": {
        "v": 8,
        "d": "Per byte in a LOG* operation's data"
      },
      "logTopic": {
        "v": 375,
        "d": "Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"
      },
      "create": {
        "v": 32e3,
        "d": "Base fee of the CREATE opcode"
      },
      "call": {
        "v": 40,
        "d": "Base fee of the CALL opcode"
      },
      "callStipend": {
        "v": 2300,
        "d": "Free gas given at beginning of call"
      },
      "callValueTransfer": {
        "v": 9e3,
        "d": "Paid for CALL when the value transfor is non-zero"
      },
      "callNewAccount": {
        "v": 25e3,
        "d": "Paid for CALL when the destination address didn't exist prior"
      },
      "selfdestructRefund": {
        "v": 24e3,
        "d": "Refunded following a selfdestruct operation"
      },
      "memory": {
        "v": 3,
        "d": "Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"
      },
      "quadCoeffDiv": {
        "v": 512,
        "d": "Divisor for the quadratic particle of the memory cost equation"
      },
      "createData": {
        "v": 200,
        "d": ""
      },
      "tx": {
        "v": 21e3,
        "d": "Per transaction. NOTE: Not payable on data of calls between transactions"
      },
      "txCreation": {
        "v": 32e3,
        "d": "The cost of creating a contract via tx"
      },
      "txDataZero": {
        "v": 4,
        "d": "Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"
      },
      "txDataNonZero": {
        "v": 68,
        "d": "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
      },
      "copy": {
        "v": 3,
        "d": "Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"
      },
      "ecRecover": {
        "v": 3e3,
        "d": ""
      },
      "sha256": {
        "v": 60,
        "d": ""
      },
      "sha256Word": {
        "v": 12,
        "d": ""
      },
      "ripemd160": {
        "v": 600,
        "d": ""
      },
      "ripemd160Word": {
        "v": 120,
        "d": ""
      },
      "identity": {
        "v": 15,
        "d": ""
      },
      "identityWord": {
        "v": 3,
        "d": ""
      },
      "stop": {
        "v": 0,
        "d": "Base fee of the STOP opcode"
      },
      "add": {
        "v": 3,
        "d": "Base fee of the ADD opcode"
      },
      "mul": {
        "v": 5,
        "d": "Base fee of the MUL opcode"
      },
      "sub": {
        "v": 3,
        "d": "Base fee of the SUB opcode"
      },
      "div": {
        "v": 5,
        "d": "Base fee of the DIV opcode"
      },
      "sdiv": {
        "v": 5,
        "d": "Base fee of the SDIV opcode"
      },
      "mod": {
        "v": 5,
        "d": "Base fee of the MOD opcode"
      },
      "smod": {
        "v": 5,
        "d": "Base fee of the SMOD opcode"
      },
      "addmod": {
        "v": 8,
        "d": "Base fee of the ADDMOD opcode"
      },
      "mulmod": {
        "v": 8,
        "d": "Base fee of the MULMOD opcode"
      },
      "signextend": {
        "v": 5,
        "d": "Base fee of the SIGNEXTEND opcode"
      },
      "lt": {
        "v": 3,
        "d": "Base fee of the LT opcode"
      },
      "gt": {
        "v": 3,
        "d": "Base fee of the GT opcode"
      },
      "slt": {
        "v": 3,
        "d": "Base fee of the SLT opcode"
      },
      "sgt": {
        "v": 3,
        "d": "Base fee of the SGT opcode"
      },
      "eq": {
        "v": 3,
        "d": "Base fee of the EQ opcode"
      },
      "iszero": {
        "v": 3,
        "d": "Base fee of the ISZERO opcode"
      },
      "and": {
        "v": 3,
        "d": "Base fee of the AND opcode"
      },
      "or": {
        "v": 3,
        "d": "Base fee of the OR opcode"
      },
      "xor": {
        "v": 3,
        "d": "Base fee of the XOR opcode"
      },
      "not": {
        "v": 3,
        "d": "Base fee of the NOT opcode"
      },
      "byte": {
        "v": 3,
        "d": "Base fee of the BYTE opcode"
      },
      "address": {
        "v": 2,
        "d": "Base fee of the ADDRESS opcode"
      },
      "balance": {
        "v": 20,
        "d": "Base fee of the BALANCE opcode"
      },
      "origin": {
        "v": 2,
        "d": "Base fee of the ORIGIN opcode"
      },
      "caller": {
        "v": 2,
        "d": "Base fee of the CALLER opcode"
      },
      "callvalue": {
        "v": 2,
        "d": "Base fee of the CALLVALUE opcode"
      },
      "calldataload": {
        "v": 3,
        "d": "Base fee of the CALLDATALOAD opcode"
      },
      "calldatasize": {
        "v": 2,
        "d": "Base fee of the CALLDATASIZE opcode"
      },
      "calldatacopy": {
        "v": 3,
        "d": "Base fee of the CALLDATACOPY opcode"
      },
      "codesize": {
        "v": 2,
        "d": "Base fee of the CODESIZE opcode"
      },
      "codecopy": {
        "v": 3,
        "d": "Base fee of the CODECOPY opcode"
      },
      "gasprice": {
        "v": 2,
        "d": "Base fee of the GASPRICE opcode"
      },
      "extcodesize": {
        "v": 20,
        "d": "Base fee of the EXTCODESIZE opcode"
      },
      "extcodecopy": {
        "v": 20,
        "d": "Base fee of the EXTCODECOPY opcode"
      },
      "blockhash": {
        "v": 20,
        "d": "Base fee of the BLOCKHASH opcode"
      },
      "coinbase": {
        "v": 2,
        "d": "Base fee of the COINBASE opcode"
      },
      "timestamp": {
        "v": 2,
        "d": "Base fee of the TIMESTAMP opcode"
      },
      "number": {
        "v": 2,
        "d": "Base fee of the NUMBER opcode"
      },
      "difficulty": {
        "v": 2,
        "d": "Base fee of the DIFFICULTY opcode"
      },
      "gaslimit": {
        "v": 2,
        "d": "Base fee of the GASLIMIT opcode"
      },
      "pop": {
        "v": 2,
        "d": "Base fee of the POP opcode"
      },
      "mload": {
        "v": 3,
        "d": "Base fee of the MLOAD opcode"
      },
      "mstore": {
        "v": 3,
        "d": "Base fee of the MSTORE opcode"
      },
      "mstore8": {
        "v": 3,
        "d": "Base fee of the MSTORE8 opcode"
      },
      "sstore": {
        "v": 0,
        "d": "Base fee of the SSTORE opcode"
      },
      "jump": {
        "v": 8,
        "d": "Base fee of the JUMP opcode"
      },
      "jumpi": {
        "v": 10,
        "d": "Base fee of the JUMPI opcode"
      },
      "pc": {
        "v": 2,
        "d": "Base fee of the PC opcode"
      },
      "msize": {
        "v": 2,
        "d": "Base fee of the MSIZE opcode"
      },
      "gas": {
        "v": 2,
        "d": "Base fee of the GAS opcode"
      },
      "push": {
        "v": 3,
        "d": "Base fee of the PUSH opcode"
      },
      "dup": {
        "v": 3,
        "d": "Base fee of the DUP opcode"
      },
      "swap": {
        "v": 3,
        "d": "Base fee of the SWAP opcode"
      },
      "callcode": {
        "v": 40,
        "d": "Base fee of the CALLCODE opcode"
      },
      "return": {
        "v": 0,
        "d": "Base fee of the RETURN opcode"
      },
      "invalid": {
        "v": 0,
        "d": "Base fee of the INVALID opcode"
      },
      "selfdestruct": {
        "v": 0,
        "d": "Base fee of the SELFDESTRUCT opcode"
      }
    },
    "vm": {
      "stackLimit": {
        "v": 1024,
        "d": "Maximum size of VM stack allowed"
      },
      "callCreateDepth": {
        "v": 1024,
        "d": "Maximum depth of call/create stack"
      },
      "maxExtraDataSize": {
        "v": 32,
        "d": "Maximum size extra data may be after Genesis"
      }
    },
    "pow": {
      "minimumDifficulty": {
        "v": 131072,
        "d": "The minimum that the difficulty may ever be"
      },
      "difficultyBoundDivisor": {
        "v": 2048,
        "d": "The bound divisor of the difficulty, used in the update calculations"
      },
      "durationLimit": {
        "v": 13,
        "d": "The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"
      },
      "epochDuration": {
        "v": 3e4,
        "d": "Duration between proof-of-work epochs"
      },
      "timebombPeriod": {
        "v": 1e5,
        "d": "Exponential difficulty timebomb period"
      },
      "minerReward": {
        "v": "5000000000000000000",
        "d": "the amount a miner get rewarded for mining a block"
      },
      "difficultyBombDelay": {
        "v": 0,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/dao.js
  var dao_default = {
    "name": "dao",
    "comment": "DAO rescue hardfork",
    "url": "https://eips.ethereum.org/EIPS/eip-779",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/homestead.js
  var homestead_default = {
    "name": "homestead",
    "comment": "Homestead hardfork with protocol and network changes",
    "url": "https://eips.ethereum.org/EIPS/eip-606",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "delegatecall": {
        "v": 40,
        "d": "Base fee of the DELEGATECALL opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/tangerineWhistle.js
  var tangerineWhistle_default = {
    "name": "tangerineWhistle",
    "comment": "Hardfork with gas cost changes for IO-heavy operations",
    "url": "https://eips.ethereum.org/EIPS/eip-608",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "sload": {
        "v": 200,
        "d": "Once per SLOAD operation"
      },
      "call": {
        "v": 700,
        "d": "Once per CALL operation & message call transaction"
      },
      "extcodesize": {
        "v": 700,
        "d": "Base fee of the EXTCODESIZE opcode"
      },
      "extcodecopy": {
        "v": 700,
        "d": "Base fee of the EXTCODECOPY opcode"
      },
      "balance": {
        "v": 400,
        "d": "Base fee of the BALANCE opcode"
      },
      "delegatecall": {
        "v": 700,
        "d": "Base fee of the DELEGATECALL opcode"
      },
      "callcode": {
        "v": 700,
        "d": "Base fee of the CALLCODE opcode"
      },
      "selfdestruct": {
        "v": 5e3,
        "d": "Base fee of the SELFDESTRUCT opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/spuriousDragon.js
  var spuriousDragon_default = {
    "name": "spuriousDragon",
    "comment": "HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit",
    "url": "https://eips.ethereum.org/EIPS/eip-607",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "expByte": {
        "v": 50,
        "d": "Times ceil(log256(exponent)) for the EXP instruction"
      }
    },
    "vm": {
      "maxCodeSize": {
        "v": 24576,
        "d": "Maximum length of contract code"
      }
    },
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/byzantium.js
  var byzantium_default = {
    "name": "byzantium",
    "comment": "Hardfork with new precompiles, instructions and other protocol changes",
    "url": "https://eips.ethereum.org/EIPS/eip-609",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "modexpGquaddivisor": {
        "v": 20,
        "d": "Gquaddivisor from modexp precompile for gas calculation"
      },
      "ecAdd": {
        "v": 500,
        "d": "Gas costs for curve addition precompile"
      },
      "ecMul": {
        "v": 4e4,
        "d": "Gas costs for curve multiplication precompile"
      },
      "ecPairing": {
        "v": 1e5,
        "d": "Base gas costs for curve pairing precompile"
      },
      "ecPairingWord": {
        "v": 8e4,
        "d": "Gas costs regarding curve pairing precompile input length"
      },
      "revert": {
        "v": 0,
        "d": "Base fee of the REVERT opcode"
      },
      "staticcall": {
        "v": 700,
        "d": "Base fee of the STATICCALL opcode"
      },
      "returndatasize": {
        "v": 2,
        "d": "Base fee of the RETURNDATASIZE opcode"
      },
      "returndatacopy": {
        "v": 3,
        "d": "Base fee of the RETURNDATACOPY opcode"
      }
    },
    "vm": {},
    "pow": {
      "minerReward": {
        "v": "3000000000000000000",
        "d": "the amount a miner get rewarded for mining a block"
      },
      "difficultyBombDelay": {
        "v": 3e6,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/constantinople.js
  var constantinople_default = {
    "name": "constantinople",
    "comment": "Postponed hardfork including EIP-1283 (SSTORE gas metering changes)",
    "url": "https://eips.ethereum.org/EIPS/eip-1013",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "netSstoreNoopGas": {
        "v": 200,
        "d": "Once per SSTORE operation if the value doesn't change"
      },
      "netSstoreInitGas": {
        "v": 2e4,
        "d": "Once per SSTORE operation from clean zero"
      },
      "netSstoreCleanGas": {
        "v": 5e3,
        "d": "Once per SSTORE operation from clean non-zero"
      },
      "netSstoreDirtyGas": {
        "v": 200,
        "d": "Once per SSTORE operation from dirty"
      },
      "netSstoreClearRefund": {
        "v": 15e3,
        "d": "Once per SSTORE operation for clearing an originally existing storage slot"
      },
      "netSstoreResetRefund": {
        "v": 4800,
        "d": "Once per SSTORE operation for resetting to the original non-zero value"
      },
      "netSstoreResetClearRefund": {
        "v": 19800,
        "d": "Once per SSTORE operation for resetting to the original zero value"
      },
      "shl": {
        "v": 3,
        "d": "Base fee of the SHL opcode"
      },
      "shr": {
        "v": 3,
        "d": "Base fee of the SHR opcode"
      },
      "sar": {
        "v": 3,
        "d": "Base fee of the SAR opcode"
      },
      "extcodehash": {
        "v": 400,
        "d": "Base fee of the EXTCODEHASH opcode"
      },
      "create2": {
        "v": 32e3,
        "d": "Base fee of the CREATE2 opcode"
      }
    },
    "vm": {},
    "pow": {
      "minerReward": {
        "v": "2000000000000000000",
        "d": "The amount a miner gets rewarded for mining a block"
      },
      "difficultyBombDelay": {
        "v": 5e6,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/petersburg.js
  var petersburg_default = {
    "name": "petersburg",
    "comment": "Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople",
    "url": "https://eips.ethereum.org/EIPS/eip-1716",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "netSstoreNoopGas": {
        "v": null,
        "d": "Removed along EIP-1283"
      },
      "netSstoreInitGas": {
        "v": null,
        "d": "Removed along EIP-1283"
      },
      "netSstoreCleanGas": {
        "v": null,
        "d": "Removed along EIP-1283"
      },
      "netSstoreDirtyGas": {
        "v": null,
        "d": "Removed along EIP-1283"
      },
      "netSstoreClearRefund": {
        "v": null,
        "d": "Removed along EIP-1283"
      },
      "netSstoreResetRefund": {
        "v": null,
        "d": "Removed along EIP-1283"
      },
      "netSstoreResetClearRefund": {
        "v": null,
        "d": "Removed along EIP-1283"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/istanbul.js
  var istanbul_default = {
    "name": "istanbul",
    "comment": "HF targeted for December 2019 following the Constantinople/Petersburg HF",
    "url": "https://eips.ethereum.org/EIPS/eip-1679",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {
      "blake2Round": {
        "v": 1,
        "d": "Gas cost per round for the Blake2 F precompile"
      },
      "ecAdd": {
        "v": 150,
        "d": "Gas costs for curve addition precompile"
      },
      "ecMul": {
        "v": 6e3,
        "d": "Gas costs for curve multiplication precompile"
      },
      "ecPairing": {
        "v": 45e3,
        "d": "Base gas costs for curve pairing precompile"
      },
      "ecPairingWord": {
        "v": 34e3,
        "d": "Gas costs regarding curve pairing precompile input length"
      },
      "txDataNonZero": {
        "v": 16,
        "d": "Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"
      },
      "sstoreSentryGasEIP2200": {
        "v": 2300,
        "d": "Minimum gas required to be present for an SSTORE call, not consumed"
      },
      "sstoreNoopGasEIP2200": {
        "v": 800,
        "d": "Once per SSTORE operation if the value doesn't change"
      },
      "sstoreDirtyGasEIP2200": {
        "v": 800,
        "d": "Once per SSTORE operation if a dirty value is changed"
      },
      "sstoreInitGasEIP2200": {
        "v": 2e4,
        "d": "Once per SSTORE operation from clean zero to non-zero"
      },
      "sstoreInitRefundEIP2200": {
        "v": 19200,
        "d": "Once per SSTORE operation for resetting to the original zero value"
      },
      "sstoreCleanGasEIP2200": {
        "v": 5e3,
        "d": "Once per SSTORE operation from clean non-zero to something else"
      },
      "sstoreCleanRefundEIP2200": {
        "v": 4200,
        "d": "Once per SSTORE operation for resetting to the original non-zero value"
      },
      "sstoreClearRefundEIP2200": {
        "v": 15e3,
        "d": "Once per SSTORE operation for clearing an originally existing storage slot"
      },
      "balance": {
        "v": 700,
        "d": "Base fee of the BALANCE opcode"
      },
      "extcodehash": {
        "v": 700,
        "d": "Base fee of the EXTCODEHASH opcode"
      },
      "chainid": {
        "v": 2,
        "d": "Base fee of the CHAINID opcode"
      },
      "selfbalance": {
        "v": 5,
        "d": "Base fee of the SELFBALANCE opcode"
      },
      "sload": {
        "v": 800,
        "d": "Base fee of the SLOAD opcode"
      }
    },
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/muirGlacier.js
  var muirGlacier_default = {
    "name": "muirGlacier",
    "comment": "HF to delay the difficulty bomb",
    "url": "https://eips.ethereum.org/EIPS/eip-2384",
    "status": "Final",
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {
      "difficultyBombDelay": {
        "v": 9e6,
        "d": "the amount of blocks to delay the difficulty bomb with"
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/berlin.js
  var berlin_default = {
    "name": "berlin",
    "comment": "HF targeted for July 2020 following the Muir Glacier HF",
    "url": "https://eips.ethereum.org/EIPS/eip-2070",
    "status": "Final",
    "eips": [2565, 2929, 2718, 2930]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/london.js
  var london_default = {
    "name": "london",
    "comment": "HF targeted for July 2021 following the Berlin fork",
    "url": "https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md",
    "status": "Final",
    "eips": [1559, 3198, 3529, 3541]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/shanghai.js
  var shanghai_default = {
    "name": "shanghai",
    "comment": "Next feature hardfork after the merge hardfork having withdrawals, warm coinbase, push0, limit/meter initcode",
    "url": "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/shanghai.md",
    "status": "Final",
    "eips": [3651, 3855, 3860, 4895]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/arrowGlacier.js
  var arrowGlacier_default = {
    "name": "arrowGlacier",
    "comment": "HF to delay the difficulty bomb",
    "url": "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/arrow-glacier.md",
    "status": "Final",
    "eips": [4345],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/grayGlacier.js
  var grayGlacier_default = {
    "name": "grayGlacier",
    "comment": "Delaying the difficulty bomb to Mid September 2022",
    "url": "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/gray-glacier.md",
    "status": "Draft",
    "eips": [5133],
    "gasConfig": {},
    "gasPrices": {},
    "vm": {},
    "pow": {}
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/mergeForkIdTransition.js
  var mergeForkIdTransition_default = {
    "name": "mergeForkIdTransition",
    "comment": "Pre-merge hardfork to fork off non-upgraded clients",
    "url": "https://eips.ethereum.org/EIPS/eip-3675",
    "status": "Draft",
    "eips": []
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/merge.js
  var merge_default = {
    "name": "merge",
    "comment": "Hardfork to upgrade the consensus mechanism to Proof-of-Stake",
    "url": "https://github.com/ethereum/execution-specs/blob/master/network-upgrades/mainnet-upgrades/merge.md",
    "status": "Final",
    "consensus": {
      "type": "pos",
      "algorithm": "casper",
      "casper": {}
    },
    "eips": [3675, 4399]
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/hardforks/index.js
  var hardforks = {
    chainstart: chainstart_default,
    homestead: homestead_default,
    dao: dao_default,
    tangerineWhistle: tangerineWhistle_default,
    spuriousDragon: spuriousDragon_default,
    byzantium: byzantium_default,
    constantinople: constantinople_default,
    petersburg: petersburg_default,
    istanbul: istanbul_default,
    muirGlacier: muirGlacier_default,
    berlin: berlin_default,
    london: london_default,
    shanghai: shanghai_default,
    arrowGlacier: arrowGlacier_default,
    grayGlacier: grayGlacier_default,
    mergeForkIdTransition: mergeForkIdTransition_default,
    merge: merge_default
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/common/common.js
  var { buf: crc32Uint8Array } = import_crc_32.default;
  var Common = class _Common extends EventEmitter2 {
    constructor(opts) {
      var _a6, _b3;
      super();
      this._eips = [];
      this._customChains = (_a6 = opts.customChains) !== null && _a6 !== void 0 ? _a6 : [];
      this._chainParams = this.setChain(opts.chain);
      this.DEFAULT_HARDFORK = (_b3 = this._chainParams.defaultHardfork) !== null && _b3 !== void 0 ? _b3 : Hardfork.Merge;
      this.HARDFORK_CHANGES = this.hardforks().map((hf) => [
        hf.name,
        hardforks[hf.name]
      ]);
      this._hardfork = this.DEFAULT_HARDFORK;
      if (opts.hardfork !== void 0) {
        this.setHardfork(opts.hardfork);
      }
      if (opts.eips) {
        this.setEIPs(opts.eips);
      }
    }
    /**
     * Creates a {@link Common} object for a custom chain, based on a standard one.
     *
     * It uses all the {@link Chain} parameters from the {@link baseChain} option except the ones overridden
     * in a provided {@link chainParamsOrName} dictionary. Some usage example:
     *
     * ```javascript
     * Common.custom({chainId: 123})
     * ```
     *
     * There are also selected supported custom chains which can be initialized by using one of the
     * {@link CustomChains} for {@link chainParamsOrName}, e.g.:
     *
     * ```javascript
     * Common.custom(CustomChains.MaticMumbai)
     * ```
     *
     * Note that these supported custom chains only provide some base parameters (usually the chain and
     * network ID and a name) and can only be used for selected use cases (e.g. sending a tx with
     * the `web3-utils/tx` library to a Layer-2 chain).
     *
     * @param chainParamsOrName Custom parameter dict (`name` will default to `custom-chain`) or string with name of a supported custom chain
     * @param opts Custom chain options to set the {@link CustomCommonOpts.baseChain}, selected {@link CustomCommonOpts.hardfork} and others
     */
    static custom(chainParamsOrName, opts = {}) {
      var _a6;
      const baseChain = (_a6 = opts.baseChain) !== null && _a6 !== void 0 ? _a6 : "mainnet";
      const standardChainParams = Object.assign({}, _Common._getChainParams(baseChain));
      standardChainParams.name = "custom-chain";
      if (typeof chainParamsOrName !== "string") {
        return new _Common(Object.assign({ chain: Object.assign(Object.assign({}, standardChainParams), chainParamsOrName) }, opts));
      }
      if (chainParamsOrName === CustomChain.PolygonMainnet) {
        return _Common.custom({
          name: CustomChain.PolygonMainnet,
          chainId: 137,
          networkId: 137
        }, opts);
      }
      if (chainParamsOrName === CustomChain.PolygonMumbai) {
        return _Common.custom({
          name: CustomChain.PolygonMumbai,
          chainId: 80001,
          networkId: 80001
        }, opts);
      }
      if (chainParamsOrName === CustomChain.ArbitrumRinkebyTestnet) {
        return _Common.custom({
          name: CustomChain.ArbitrumRinkebyTestnet,
          chainId: 421611,
          networkId: 421611
        }, opts);
      }
      if (chainParamsOrName === CustomChain.ArbitrumOne) {
        return _Common.custom({
          name: CustomChain.ArbitrumOne,
          chainId: 42161,
          networkId: 42161
        }, opts);
      }
      if (chainParamsOrName === CustomChain.xDaiChain) {
        return _Common.custom({
          name: CustomChain.xDaiChain,
          chainId: 100,
          networkId: 100
        }, opts);
      }
      if (chainParamsOrName === CustomChain.OptimisticKovan) {
        return _Common.custom({
          name: CustomChain.OptimisticKovan,
          chainId: 69,
          networkId: 69
        }, Object.assign({ hardfork: Hardfork.Berlin }, opts));
      }
      if (chainParamsOrName === CustomChain.OptimisticEthereum) {
        return _Common.custom({
          name: CustomChain.OptimisticEthereum,
          chainId: 10,
          networkId: 10
        }, Object.assign({ hardfork: Hardfork.Berlin }, opts));
      }
      throw new Error(`Custom chain ${chainParamsOrName} not supported`);
    }
    /**
     * Static method to load and set common from a geth genesis json
     * @param genesisJson json of geth configuration
     * @param { chain, eips, genesisHash, hardfork, mergeForkIdPostMerge } to further configure the common instance
     * @returns Common
     */
    static fromGethGenesis(genesisJson, { chain, eips, genesisHash, hardfork, mergeForkIdPostMerge }) {
      var _a6;
      const genesisParams = parseGethGenesis(genesisJson, chain, mergeForkIdPostMerge);
      const common = new _Common({
        chain: (_a6 = genesisParams.name) !== null && _a6 !== void 0 ? _a6 : "custom",
        customChains: [genesisParams],
        eips,
        hardfork: hardfork !== null && hardfork !== void 0 ? hardfork : genesisParams.hardfork
      });
      if (genesisHash !== void 0) {
        common.setForkHashes(genesisHash);
      }
      return common;
    }
    /**
     * Static method to determine if a {@link chainId} is supported as a standard chain
     * @param chainId bigint id (`1`) of a standard chain
     * @returns boolean
     */
    static isSupportedChainId(chainId) {
      const initializedChains = this._getInitializedChains();
      return Boolean(initializedChains.names[chainId.toString()]);
    }
    static _getChainParams(_chain, customChains) {
      let chain = _chain;
      const initializedChains = this._getInitializedChains(customChains);
      if (typeof chain === "number" || typeof chain === "bigint") {
        chain = chain.toString();
        if (initializedChains.names[chain]) {
          const name2 = initializedChains.names[chain];
          return initializedChains[name2];
        }
        throw new Error(`Chain with ID ${chain} not supported`);
      }
      if (initializedChains[chain] !== void 0) {
        return initializedChains[chain];
      }
      throw new Error(`Chain with name ${chain} not supported`);
    }
    /**
     * Sets the chain
     * @param chain String ('mainnet') or Number (1) chain representation.
     *              Or, a Dictionary of chain parameters for a private network.
     * @returns The dictionary with parameters set as chain
     */
    setChain(chain) {
      if (typeof chain === "number" || typeof chain === "bigint" || typeof chain === "string") {
        this._chainParams = _Common._getChainParams(chain, this._customChains);
      } else if (typeof chain === "object") {
        if (this._customChains.length > 0) {
          throw new Error("Chain must be a string, number, or bigint when initialized with customChains passed in");
        }
        const required = ["networkId", "genesis", "hardforks", "bootstrapNodes"];
        for (const param of required) {
          if (!(param in chain)) {
            throw new Error(`Missing required chain parameter: ${param}`);
          }
        }
        this._chainParams = chain;
      } else {
        throw new Error("Wrong input format");
      }
      for (const hf of this.hardforks()) {
        if (hf.block === void 0) {
          throw new Error(`Hardfork cannot have undefined block number`);
        }
      }
      return this._chainParams;
    }
    /**
     * Sets the hardfork to get params for
     * @param hardfork String identifier (e.g. 'byzantium') or {@link Hardfork} enum
     */
    setHardfork(hardfork) {
      let existing = false;
      for (const hfChanges of this.HARDFORK_CHANGES) {
        if (hfChanges[0] === hardfork) {
          if (this._hardfork !== hardfork) {
            this._hardfork = hardfork;
            this.emit("hardforkChanged", hardfork);
          }
          existing = true;
        }
      }
      if (!existing) {
        throw new Error(`Hardfork with name ${hardfork} not supported`);
      }
    }
    /**
     * Returns the hardfork based on the block number or an optional
     * total difficulty (Merge HF) provided.
     *
     * An optional TD takes precedence in case the corresponding HF block
     * is set to `null` or otherwise needs to match (if not an error
     * will be thrown).
     *
     * @param blockNumber
     * @param td : total difficulty of the parent block (for block hf) OR of the chain latest (for chain hf)
     * @param timestamp: timestamp in seconds at which block was/is to be minted
     * @returns The name of the HF
     */
    getHardforkByBlockNumber(_blockNumber, _td, _timestamp) {
      const blockNumber = toType(_blockNumber, TypeOutput.BigInt);
      const td2 = toType(_td, TypeOutput.BigInt);
      const timestamp2 = toType(_timestamp, TypeOutput.Number);
      const hfs = this.hardforks().filter((hf) => (
        // eslint-disable-next-line no-null/no-null
        hf.block !== null || // eslint-disable-next-line no-null/no-null
        hf.ttd !== null && hf.ttd !== void 0 || hf.timestamp !== void 0
      ));
      const mergeIndex = hfs.findIndex((hf) => hf.ttd !== null && hf.ttd !== void 0);
      const doubleTTDHF = hfs.slice(mergeIndex + 1).findIndex((hf) => hf.ttd !== null && hf.ttd !== void 0);
      if (doubleTTDHF >= 0) {
        throw Error(`More than one merge hardforks found with ttd specified`);
      }
      let hfIndex = hfs.findIndex((hf) => (
        // eslint-disable-next-line no-null/no-null
        hf.block !== null && hf.block > blockNumber || timestamp2 !== void 0 && Number(hf.timestamp) > timestamp2
      ));
      if (hfIndex === -1) {
        hfIndex = hfs.length;
      } else if (hfIndex === 0) {
        throw Error("Must have at least one hardfork at block 0");
      }
      if (timestamp2 === void 0) {
        const stepBack = hfs.slice(0, hfIndex).reverse().findIndex((hf) => hf.block !== null || hf.ttd !== void 0);
        hfIndex -= stepBack;
      }
      hfIndex -= 1;
      if (hfs[hfIndex].block === null && hfs[hfIndex].timestamp === void 0) {
        if (td2 === void 0 || td2 === null || BigInt(hfs[hfIndex].ttd) > td2) {
          hfIndex -= 1;
        }
      } else if (mergeIndex >= 0 && td2 !== void 0 && td2 !== null) {
        if (hfIndex >= mergeIndex && BigInt(hfs[mergeIndex].ttd) > td2) {
          throw Error("Maximum HF determined by total difficulty is lower than the block number HF");
        } else if (hfIndex < mergeIndex && BigInt(hfs[mergeIndex].ttd) <= td2) {
          throw Error("HF determined by block number is lower than the minimum total difficulty HF");
        }
      }
      const hfStartIndex = hfIndex;
      for (; hfIndex < hfs.length - 1; hfIndex += 1) {
        if (hfs[hfIndex].block !== hfs[hfIndex + 1].block || hfs[hfIndex].timestamp !== hfs[hfIndex + 1].timestamp) {
          break;
        }
      }
      if (timestamp2) {
        const minTimeStamp = hfs.slice(0, hfStartIndex).reduce((acc, hf) => {
          var _a6;
          return Math.max(Number((_a6 = hf.timestamp) !== null && _a6 !== void 0 ? _a6 : "0"), acc);
        }, 0);
        if (minTimeStamp > timestamp2) {
          throw Error(`Maximum HF determined by timestamp is lower than the block number/ttd HF`);
        }
        const maxTimeStamp = hfs.slice(hfIndex + 1).reduce((acc, hf) => {
          var _a6;
          return Math.min(Number((_a6 = hf.timestamp) !== null && _a6 !== void 0 ? _a6 : timestamp2), acc);
        }, timestamp2);
        if (maxTimeStamp < timestamp2) {
          throw Error(`Maximum HF determined by block number/ttd is lower than timestamp HF`);
        }
      }
      const hardfork = hfs[hfIndex];
      return hardfork.name;
    }
    /**
     * Sets a new hardfork based on the block number or an optional
     * total difficulty (Merge HF) provided.
     *
     * An optional TD takes precedence in case the corresponding HF block
     * is set to `null` or otherwise needs to match (if not an error
     * will be thrown).
     *
     * @param blockNumber
     * @param td
     * @param timestamp
     * @returns The name of the HF set
     */
    setHardforkByBlockNumber(blockNumber, td2, timestamp2) {
      const hardfork = this.getHardforkByBlockNumber(blockNumber, td2, timestamp2);
      this.setHardfork(hardfork);
      return hardfork;
    }
    /**
     * Internal helper function, returns the params for the given hardfork for the chain set
     * @param hardfork Hardfork name
     * @returns Dictionary with hardfork params or null if hardfork not on chain
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    _getHardfork(hardfork) {
      const hfs = this.hardforks();
      for (const hf of hfs) {
        if (hf.name === hardfork)
          return hf;
      }
      return null;
    }
    /**
     * Sets the active EIPs
     * @param eips
     */
    setEIPs(eips = []) {
      for (const eip of eips) {
        if (!(eip in EIPs)) {
          throw new Error(`${eip} not supported`);
        }
        const minHF = this.gteHardfork(EIPs[eip].minimumHardfork);
        if (!minHF) {
          throw new Error(
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eip} cannot be activated on hardfork ${this.hardfork()}, minimumHardfork: ${minHF}`
          );
        }
        if (EIPs[eip].requiredEIPs !== void 0) {
          for (const elem of EIPs[eip].requiredEIPs) {
            if (!(eips.includes(elem) || this.isActivatedEIP(elem))) {
              throw new Error(
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `${eip} requires EIP ${elem}, but is not included in the EIP list`
              );
            }
          }
        }
      }
      this._eips = eips;
    }
    /**
     * Returns a parameter for the current chain setup
     *
     * If the parameter is present in an EIP, the EIP always takes precedence.
     * Otherwise the parameter if taken from the latest applied HF with
     * a change on the respective parameter.
     *
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @returns The value requested or `BigInt(0)` if not found
     */
    param(topic, name2) {
      let value;
      for (const eip of this._eips) {
        value = this.paramByEIP(topic, name2, eip);
        if (value !== void 0)
          return value;
      }
      return this.paramByHardfork(topic, name2, this._hardfork);
    }
    /**
     * Returns the parameter corresponding to a hardfork
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param hardfork Hardfork name
     * @returns The value requested or `BigInt(0)` if not found
     */
    paramByHardfork(topic, name2, hardfork) {
      let value = null;
      for (const hfChanges of this.HARDFORK_CHANGES) {
        if ("eips" in hfChanges[1]) {
          const hfEIPs = hfChanges[1].eips;
          for (const eip of hfEIPs) {
            const valueEIP = this.paramByEIP(topic, name2, eip);
            value = typeof valueEIP === "bigint" ? valueEIP : value;
          }
        } else {
          if (hfChanges[1][topic] === void 0) {
            throw new Error(`Topic ${topic} not defined`);
          }
          if (hfChanges[1][topic][name2] !== void 0) {
            value = hfChanges[1][topic][name2].v;
          }
        }
        if (hfChanges[0] === hardfork)
          break;
      }
      return BigInt(value !== null && value !== void 0 ? value : 0);
    }
    /**
     * Returns a parameter corresponding to an EIP
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param eip Number of the EIP
     * @returns The value requested or `undefined` if not found
     */
    // eslint-disable-next-line class-methods-use-this
    paramByEIP(topic, name2, eip) {
      if (!(eip in EIPs)) {
        throw new Error(`${eip} not supported`);
      }
      const eipParams = EIPs[eip];
      if (!(topic in eipParams)) {
        throw new Error(`Topic ${topic} not defined`);
      }
      if (eipParams[topic][name2] === void 0) {
        return void 0;
      }
      const value = eipParams[topic][name2].v;
      return BigInt(value);
    }
    /**
     * Returns a parameter for the hardfork active on block number or
     * optional provided total difficulty (Merge HF)
     * @param topic Parameter topic
     * @param name Parameter name
     * @param blockNumber Block number
     * @param td Total difficulty
     *    * @returns The value requested or `BigInt(0)` if not found
     */
    paramByBlock(topic, name2, blockNumber, td2, timestamp2) {
      const hardfork = this.getHardforkByBlockNumber(blockNumber, td2, timestamp2);
      return this.paramByHardfork(topic, name2, hardfork);
    }
    /**
     * Checks if an EIP is activated by either being included in the EIPs
     * manually passed in with the {@link CommonOpts.eips} or in a
     * hardfork currently being active
     *
     * Note: this method only works for EIPs being supported
     * by the {@link CommonOpts.eips} constructor option
     * @param eip
     */
    isActivatedEIP(eip) {
      if (this.eips().includes(eip)) {
        return true;
      }
      for (const hfChanges of this.HARDFORK_CHANGES) {
        const hf = hfChanges[1];
        if (this.gteHardfork(hf.name) && "eips" in hf) {
          if (hf.eips.includes(eip)) {
            return true;
          }
        }
      }
      return false;
    }
    /**
     * Checks if set or provided hardfork is active on block number
     * @param hardfork Hardfork name or null (for HF set)
     * @param blockNumber
     * @returns True if HF is active on block number
     */
    hardforkIsActiveOnBlock(_hardfork, _blockNumber) {
      const blockNumber = toType(_blockNumber, TypeOutput.BigInt);
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const hfBlock = this.hardforkBlock(hardfork);
      if (typeof hfBlock === "bigint" && hfBlock !== BigInt(0) && blockNumber >= hfBlock) {
        return true;
      }
      return false;
    }
    /**
     * Alias to hardforkIsActiveOnBlock when hardfork is set
     * @param blockNumber
     * @returns True if HF is active on block number
     */
    activeOnBlock(blockNumber) {
      return this.hardforkIsActiveOnBlock(null, blockNumber);
    }
    /**
     * Sequence based check if given or set HF1 is greater than or equal HF2
     * @param hardfork1 Hardfork name or null (if set)
     * @param hardfork2 Hardfork name
     * @param opts Hardfork options
     * @returns True if HF1 gte HF2
     */
    hardforkGteHardfork(_hardfork1, hardfork2) {
      const hardfork1 = _hardfork1 !== null && _hardfork1 !== void 0 ? _hardfork1 : this._hardfork;
      const hardforks2 = this.hardforks();
      let posHf1 = -1;
      let posHf2 = -1;
      let index2 = 0;
      for (const hf of hardforks2) {
        if (hf.name === hardfork1)
          posHf1 = index2;
        if (hf.name === hardfork2)
          posHf2 = index2;
        index2 += 1;
      }
      return posHf1 >= posHf2 && posHf2 !== -1;
    }
    /**
     * Alias to hardforkGteHardfork when hardfork is set
     * @param hardfork Hardfork name
     * @returns True if hardfork set is greater than hardfork provided
     */
    gteHardfork(hardfork) {
      return this.hardforkGteHardfork(null, hardfork);
    }
    /**
     * Returns the hardfork change block for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if unscheduled
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    hardforkBlock(_hardfork) {
      var _a6;
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const block = (_a6 = this._getHardfork(hardfork)) === null || _a6 === void 0 ? void 0 : _a6.block;
      if (block === void 0 || block === null) {
        return null;
      }
      return BigInt(block);
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    hardforkTimestamp(_hardfork) {
      var _a6;
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const timestamp2 = (_a6 = this._getHardfork(hardfork)) === null || _a6 === void 0 ? void 0 : _a6.timestamp;
      if (timestamp2 === void 0 || timestamp2 === null) {
        return null;
      }
      return BigInt(timestamp2);
    }
    /**
     * Returns the hardfork change block for eip
     * @param eip EIP number
     * @returns Block number or null if unscheduled
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    eipBlock(eip) {
      for (const hfChanges of this.HARDFORK_CHANGES) {
        const hf = hfChanges[1];
        if ("eips" in hf) {
          if (hf.eips.includes(eip)) {
            return this.hardforkBlock(typeof hfChanges[0] === "number" ? String(hfChanges[0]) : hfChanges[0]);
          }
        }
      }
      return null;
    }
    /**
     * Returns the hardfork change total difficulty (Merge HF) for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Total difficulty or null if no set
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    hardforkTTD(_hardfork) {
      var _a6;
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const ttd = (_a6 = this._getHardfork(hardfork)) === null || _a6 === void 0 ? void 0 : _a6.ttd;
      if (ttd === void 0 || ttd === null) {
        return null;
      }
      return BigInt(ttd);
    }
    /**
     * True if block number provided is the hardfork (given or set) change block
     * @param blockNumber Number of the block to check
     * @param hardfork Hardfork name, optional if HF set
     * @returns True if blockNumber is HF block
     * @deprecated
     */
    isHardforkBlock(_blockNumber, _hardfork) {
      const blockNumber = toType(_blockNumber, TypeOutput.BigInt);
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const block = this.hardforkBlock(hardfork);
      return typeof block === "bigint" && block !== BigInt(0) ? block === blockNumber : false;
    }
    /**
     * Returns the change block for the next hardfork after the hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block timestamp, number or null if not available
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    nextHardforkBlockOrTimestamp(_hardfork) {
      var _a6, _b3;
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const hfs = this.hardforks();
      let hfIndex = hfs.findIndex((hf) => hf.name === hardfork);
      if (hardfork === Hardfork.Merge) {
        hfIndex -= 1;
      }
      if (hfIndex < 0) {
        return null;
      }
      let currHfTimeOrBlock = (_a6 = hfs[hfIndex].timestamp) !== null && _a6 !== void 0 ? _a6 : hfs[hfIndex].block;
      currHfTimeOrBlock = // eslint-disable-next-line no-null/no-null
      currHfTimeOrBlock !== null && currHfTimeOrBlock !== void 0 ? Number(currHfTimeOrBlock) : (
        // eslint-disable-next-line no-null/no-null
        null
      );
      const nextHf = hfs.slice(hfIndex + 1).find((hf) => {
        var _a7;
        let hfTimeOrBlock = (_a7 = hf.timestamp) !== null && _a7 !== void 0 ? _a7 : hf.block;
        hfTimeOrBlock = // eslint-disable-next-line no-null/no-null
        hfTimeOrBlock !== null && hfTimeOrBlock !== void 0 ? Number(hfTimeOrBlock) : (
          // eslint-disable-next-line no-null/no-null
          null
        );
        return hf.name !== Hardfork.Merge && // eslint-disable-next-line no-null/no-null
        hfTimeOrBlock !== null && hfTimeOrBlock !== void 0 && hfTimeOrBlock !== currHfTimeOrBlock;
      });
      if (nextHf === void 0) {
        return null;
      }
      const nextHfBlock = (_b3 = nextHf.timestamp) !== null && _b3 !== void 0 ? _b3 : nextHf.block;
      if (nextHfBlock === null || nextHfBlock === void 0) {
        return null;
      }
      return BigInt(nextHfBlock);
    }
    /**
     * Returns the change block for the next hardfork after the hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if not available
     * @deprecated
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    nextHardforkBlock(_hardfork) {
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      let hfBlock = this.hardforkBlock(hardfork);
      if (hfBlock === null && hardfork === Hardfork.Merge) {
        const hfs = this.hardforks();
        const mergeIndex = hfs.findIndex((hf) => hf.ttd !== null && hf.ttd !== void 0);
        if (mergeIndex < 0) {
          throw Error(`Merge hardfork should have been found`);
        }
        hfBlock = this.hardforkBlock(hfs[mergeIndex - 1].name);
      }
      if (hfBlock === null) {
        return null;
      }
      const nextHfBlock = this.hardforks().reduce((acc, hf) => {
        const block = BigInt(
          // eslint-disable-next-line no-null/no-null
          hf.block === null || hf.ttd !== void 0 && hf.ttd !== null ? 0 : hf.block
        );
        return block > hfBlock && acc === null ? block : acc;
      }, null);
      return nextHfBlock;
    }
    /**
     * True if block number provided is the hardfork change block following the hardfork given or set
     * @param blockNumber Number of the block to check
     * @param hardfork Hardfork name, optional if HF set
     * @returns True if blockNumber is HF block
     * @deprecated
     */
    isNextHardforkBlock(_blockNumber, _hardfork) {
      const blockNumber = toType(_blockNumber, TypeOutput.BigInt);
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const nextHardforkBlock = this.nextHardforkBlock(hardfork);
      return nextHardforkBlock === null ? false : nextHardforkBlock === blockNumber;
    }
    /**
     * Internal helper function to calculate a fork hash
     * @param hardfork Hardfork name
     * @param genesisHash Genesis block hash of the chain
     * @returns Fork hash as hex string
     */
    _calcForkHash(hardfork, genesisHash) {
      let hfUint8Array = new Uint8Array();
      let prevBlockOrTime = 0;
      for (const hf of this.hardforks()) {
        const { block, timestamp: timestamp2, name: name2 } = hf;
        let blockOrTime = timestamp2 !== null && timestamp2 !== void 0 ? timestamp2 : block;
        blockOrTime = blockOrTime !== null ? Number(blockOrTime) : null;
        if (typeof blockOrTime === "number" && blockOrTime !== 0 && blockOrTime !== prevBlockOrTime && name2 !== Hardfork.Merge) {
          const hfBlockUint8Array = hexToBytes2(blockOrTime.toString(16).padStart(16, "0"));
          hfUint8Array = uint8ArrayConcat(hfUint8Array, hfBlockUint8Array);
          prevBlockOrTime = blockOrTime;
        }
        if (hf.name === hardfork)
          break;
      }
      const inputUint8Array = uint8ArrayConcat(genesisHash, hfUint8Array);
      const forkhash = bytesToHex2(intToUint8Array(crc32Uint8Array(inputUint8Array) >>> 0));
      return forkhash;
    }
    /**
     * Returns an eth/64 compliant fork hash (EIP-2124)
     * @param hardfork Hardfork name, optional if HF set
     * @param genesisHash Genesis block hash of the chain, optional if already defined and not needed to be calculated
     */
    forkHash(_hardfork, genesisHash) {
      const hardfork = _hardfork !== null && _hardfork !== void 0 ? _hardfork : this._hardfork;
      const data = this._getHardfork(hardfork);
      if (
        // eslint-disable-next-line no-null/no-null
        data === null || // eslint-disable-next-line no-null/no-null
        (data === null || data === void 0 ? void 0 : data.block) === null && (data === null || data === void 0 ? void 0 : data.timestamp) === void 0 && (data === null || data === void 0 ? void 0 : data.ttd) === void 0
      ) {
        const msg = "No fork hash calculation possible for future hardfork";
        throw new Error(msg);
      }
      if ((data === null || data === void 0 ? void 0 : data.forkHash) !== null && (data === null || data === void 0 ? void 0 : data.forkHash) !== void 0) {
        return data.forkHash;
      }
      if (!genesisHash)
        throw new Error("genesisHash required for forkHash calculation");
      return this._calcForkHash(hardfork, genesisHash);
    }
    /**
     *
     * @param forkHash Fork hash as a hex string
     * @returns Array with hardfork data (name, block, forkHash)
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    hardforkForForkHash(forkHash) {
      const resArray = this.hardforks().filter((hf) => hf.forkHash === forkHash);
      return resArray.length >= 1 ? resArray[resArray.length - 1] : null;
    }
    /**
     * Sets any missing forkHashes on the passed-in {@link Common} instance
     * @param common The {@link Common} to set the forkHashes for
     * @param genesisHash The genesis block hash
     */
    setForkHashes(genesisHash) {
      var _a6;
      for (const hf of this.hardforks()) {
        const blockOrTime = (_a6 = hf.timestamp) !== null && _a6 !== void 0 ? _a6 : hf.block;
        if (
          // eslint-disable-next-line no-null/no-null
          (hf.forkHash === null || hf.forkHash === void 0) && // eslint-disable-next-line no-null/no-null
          (blockOrTime !== null && blockOrTime !== void 0 || typeof hf.ttd !== "undefined")
        ) {
          hf.forkHash = this.forkHash(hf.name, genesisHash);
        }
      }
    }
    /**
     * Returns the Genesis parameters of the current chain
     * @returns Genesis dictionary
     */
    genesis() {
      return this._chainParams.genesis;
    }
    /**
     * Returns the hardforks for current chain
     * @returns {Array} Array with arrays of hardforks
     */
    hardforks() {
      return this._chainParams.hardforks;
    }
    /**
     * Returns bootstrap nodes for the current chain
     * @returns {Dictionary} Dict with bootstrap nodes
     */
    bootstrapNodes() {
      return this._chainParams.bootstrapNodes;
    }
    /**
     * Returns DNS networks for the current chain
     * @returns {String[]} Array of DNS ENR urls
     */
    dnsNetworks() {
      return this._chainParams.dnsNetworks;
    }
    /**
     * Returns the hardfork set
     * @returns Hardfork name
     */
    hardfork() {
      return this._hardfork;
    }
    /**
     * Returns the Id of current chain
     * @returns chain Id
     */
    chainId() {
      return BigInt(this._chainParams.chainId);
    }
    /**
     * Returns the name of current chain
     * @returns chain name (lower case)
     */
    chainName() {
      return this._chainParams.name;
    }
    /**
     * Returns the Id of current network
     * @returns network Id
     */
    networkId() {
      return BigInt(this._chainParams.networkId);
    }
    /**
     * Returns the active EIPs
     * @returns List of EIPs
     */
    eips() {
      return this._eips;
    }
    /**
     * Returns the consensus type of the network
     * Possible values: "pow"|"poa"|"pos"
     *
     * Note: This value can update along a Hardfork.
     */
    consensusType() {
      const hardfork = this.hardfork();
      let value;
      for (const hfChanges of this.HARDFORK_CHANGES) {
        if ("consensus" in hfChanges[1]) {
          value = hfChanges[1].consensus.type;
        }
        if (hfChanges[0] === hardfork)
          break;
      }
      return value !== null && value !== void 0 ? value : this._chainParams.consensus.type;
    }
    /**
     * Returns the concrete consensus implementation
     * algorithm or protocol for the network
     * e.g. "ethash" for "pow" consensus type,
     * "clique" for "poa" consensus type or
     * "casper" for "pos" consensus type.
     *
     * Note: This value can update along a Hardfork.
     */
    consensusAlgorithm() {
      const hardfork = this.hardfork();
      let value;
      for (const hfChanges of this.HARDFORK_CHANGES) {
        if ("consensus" in hfChanges[1]) {
          value = hfChanges[1].consensus.algorithm;
        }
        if (hfChanges[0] === hardfork)
          break;
      }
      return value !== null && value !== void 0 ? value : this._chainParams.consensus.algorithm;
    }
    /**
     * Returns a dictionary with consensus configuration
     * parameters based on the consensus algorithm
     *
     * Expected returns (parameters must be present in
     * the respective chain json files):
     *
     * ethash: empty object
     * clique: period, epoch
     * casper: empty object
     *
     * Note: This value can update along a Hardfork.
     */
    consensusConfig() {
      var _a6;
      const hardfork = this.hardfork();
      let value;
      for (const hfChanges of this.HARDFORK_CHANGES) {
        if ("consensus" in hfChanges[1]) {
          value = hfChanges[1].consensus[hfChanges[1].consensus.algorithm];
        }
        if (hfChanges[0] === hardfork)
          break;
      }
      return (_a6 = value !== null && value !== void 0 ? value : this._chainParams.consensus[this.consensusAlgorithm()]) !== null && _a6 !== void 0 ? _a6 : {};
    }
    /**
     * Returns a deep copy of this {@link Common} instance.
     */
    copy() {
      const copy = Object.assign(Object.create(Object.getPrototypeOf(this)), this);
      copy.removeAllListeners();
      return copy;
    }
    static _getInitializedChains(customChains) {
      const names = {};
      for (const [name2, id] of Object.entries(Chain)) {
        names[id] = name2.toLowerCase();
      }
      const chains = { mainnet: mainnet_default, goerli: goerli_default, sepolia: sepolia_default };
      if (customChains) {
        for (const chain of customChains) {
          const { name: name2 } = chain;
          names[chain.chainId.toString()] = name2;
          chains[name2] = chain;
        }
      }
      chains.names = names;
      return chains;
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/types.js
  var Capability;
  (function(Capability2) {
    Capability2[Capability2["EIP155ReplayProtection"] = 155] = "EIP155ReplayProtection";
    Capability2[Capability2["EIP1559FeeMarket"] = 1559] = "EIP1559FeeMarket";
    Capability2[Capability2["EIP2718TypedTransaction"] = 2718] = "EIP2718TypedTransaction";
    Capability2[Capability2["EIP2930AccessLists"] = 2930] = "EIP2930AccessLists";
  })(Capability || (Capability = {}));
  function isAccessListUint8Array(input) {
    if (input.length === 0) {
      return true;
    }
    const firstItem = input[0];
    if (Array.isArray(firstItem)) {
      return true;
    }
    return false;
  }
  function isAccessList(input) {
    return !isAccessListUint8Array(input);
  }

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/address.js
  var Address = class _Address {
    constructor(buf) {
      if (buf.length !== 20) {
        throw new Error("Invalid address length");
      }
      this.buf = buf;
    }
    /**
     * Returns the zero address.
     */
    static zero() {
      return new _Address(zeros(20));
    }
    /**
     * Is address equal to another.
     */
    equals(address) {
      return uint8ArrayEquals(this.buf, address.buf);
    }
    /**
     * Is address zero.
     */
    isZero() {
      return this.equals(_Address.zero());
    }
    /**
     * Returns hex encoding of address.
     */
    toString() {
      return bytesToHex2(this.buf);
    }
    /**
     * Returns Uint8Array representation of address.
     */
    toArray() {
      return this.buf;
    }
    /**
     * Returns the ethereum address of a given public key.
     * Accepts "Ethereum public keys" and SEC1 encoded keys.
     * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
     * @param sanitize Accept public keys in other formats
     */
    static publicToAddress(_pubKey, sanitize = false) {
      let pubKey = _pubKey;
      assertIsUint8Array(pubKey);
      if (sanitize && pubKey.length !== 64) {
        pubKey = secp256k12.ProjectivePoint.fromHex(pubKey).toRawBytes(false).slice(1);
      }
      if (pubKey.length !== 64) {
        throw new Error("Expected pubKey to be of length 64");
      }
      return keccak256(pubKey).slice(-20);
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/utils.js
  var checkMaxInitCodeSize = (common, length2) => {
    const maxInitCodeSize = common.param("vm", "maxInitCodeSize");
    if (maxInitCodeSize && BigInt(length2) > maxInitCodeSize) {
      throw new Error(`the initcode size of this transaction is too large: it is ${length2} while the max is ${common.param("vm", "maxInitCodeSize")}`);
    }
  };
  var getAccessListData = (accessList) => {
    let AccessListJSON;
    let uint8arrayAccessList;
    if (isAccessList(accessList)) {
      AccessListJSON = accessList;
      const newAccessList = [];
      for (let i2 = 0; i2 < accessList.length; i2 += 1) {
        const item = accessList[i2];
        const addressBytes = toUint8Array(item.address);
        const storageItems = [];
        for (let index2 = 0; index2 < item.storageKeys.length; index2 += 1) {
          storageItems.push(toUint8Array(item.storageKeys[index2]));
        }
        newAccessList.push([addressBytes, storageItems]);
      }
      uint8arrayAccessList = newAccessList;
    } else {
      uint8arrayAccessList = accessList !== null && accessList !== void 0 ? accessList : [];
      const json = [];
      for (let i2 = 0; i2 < uint8arrayAccessList.length; i2 += 1) {
        const data = uint8arrayAccessList[i2];
        const address = bytesToHex2(data[0]);
        const storageKeys = [];
        for (let item = 0; item < data[1].length; item += 1) {
          storageKeys.push(bytesToHex2(data[1][item]));
        }
        const jsonItem = {
          address,
          storageKeys
        };
        json.push(jsonItem);
      }
      AccessListJSON = json;
    }
    return {
      AccessListJSON,
      accessList: uint8arrayAccessList
    };
  };
  var verifyAccessList = (accessList) => {
    for (let key = 0; key < accessList.length; key += 1) {
      const accessListItem = accessList[key];
      const address = accessListItem[0];
      const storageSlots = accessListItem[1];
      if (accessListItem[2] !== void 0) {
        throw new Error("Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.");
      }
      if (address.length !== 20) {
        throw new Error("Invalid EIP-2930 transaction: address length should be 20 bytes");
      }
      for (let storageSlot = 0; storageSlot < storageSlots.length; storageSlot += 1) {
        if (storageSlots[storageSlot].length !== 32) {
          throw new Error("Invalid EIP-2930 transaction: storage slot length should be 32 bytes");
        }
      }
    }
  };
  var getAccessListJSON = (accessList) => {
    const accessListJSON = [];
    for (let index2 = 0; index2 < accessList.length; index2 += 1) {
      const item = accessList[index2];
      const JSONItem = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/consistent-type-assertions
        address: bytesToHex2(setLengthLeft(item[0], 20)),
        storageKeys: []
      };
      const storageSlots = item && item[1];
      for (let slot = 0; slot < storageSlots.length; slot += 1) {
        const storageSlot = storageSlots[slot];
        JSONItem.storageKeys.push(bytesToHex2(setLengthLeft(storageSlot, 32)));
      }
      accessListJSON.push(JSONItem);
    }
    return accessListJSON;
  };
  var getDataFeeEIP2930 = (accessList, common) => {
    const accessListStorageKeyCost = common.param("gasPrices", "accessListStorageKeyCost");
    const accessListAddressCost = common.param("gasPrices", "accessListAddressCost");
    let slots = 0;
    for (let index2 = 0; index2 < accessList.length; index2 += 1) {
      const item = accessList[index2];
      const storageSlots = item[1];
      slots += storageSlots.length;
    }
    const addresses = accessList.length;
    return addresses * Number(accessListAddressCost) + slots * Number(accessListStorageKeyCost);
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/baseTransaction.js
  var BaseTransaction = class {
    constructor(txData, opts) {
      var _a6, _b3;
      this.cache = {
        hash: void 0,
        dataFee: void 0
      };
      this.activeCapabilities = [];
      this.DEFAULT_CHAIN = Chain.Mainnet;
      this.DEFAULT_HARDFORK = Hardfork.Merge;
      const { nonce, gasLimit, to, value, data, v, r: r2, s: s2, type } = txData;
      this._type = Number(uint8ArrayToBigInt(toUint8Array(type)));
      this.txOptions = opts;
      const toB = toUint8Array(to === "" ? "0x" : to);
      const vB = toUint8Array(v === "" ? "0x" : v);
      const rB = toUint8Array(r2 === "" ? "0x" : r2);
      const sB = toUint8Array(s2 === "" ? "0x" : s2);
      this.nonce = uint8ArrayToBigInt(toUint8Array(nonce === "" ? "0x" : nonce));
      this.gasLimit = uint8ArrayToBigInt(toUint8Array(gasLimit === "" ? "0x" : gasLimit));
      this.to = toB.length > 0 ? new Address(toB) : void 0;
      this.value = uint8ArrayToBigInt(toUint8Array(value === "" ? "0x" : value));
      this.data = toUint8Array(data === "" ? "0x" : data);
      this.v = vB.length > 0 ? uint8ArrayToBigInt(vB) : void 0;
      this.r = rB.length > 0 ? uint8ArrayToBigInt(rB) : void 0;
      this.s = sB.length > 0 ? uint8ArrayToBigInt(sB) : void 0;
      this._validateCannotExceedMaxInteger({ value: this.value, r: this.r, s: this.s });
      this._validateCannotExceedMaxInteger({ gasLimit: this.gasLimit }, 64);
      this._validateCannotExceedMaxInteger({ nonce: this.nonce }, 64, true);
      const createContract = this.to === void 0 || this.to === null;
      const allowUnlimitedInitCodeSize = (_a6 = opts.allowUnlimitedInitCodeSize) !== null && _a6 !== void 0 ? _a6 : false;
      const common = (_b3 = opts.common) !== null && _b3 !== void 0 ? _b3 : this._getCommon();
      if (createContract && common.isActivatedEIP(3860) && !allowUnlimitedInitCodeSize) {
        checkMaxInitCodeSize(common, this.data.length);
      }
    }
    /**
     * Returns the transaction type.
     *
     * Note: legacy txs will return tx type `0`.
     */
    get type() {
      return this._type;
    }
    /**
     * Checks if a tx type defining capability is active
     * on a tx, for example the EIP-1559 fee market mechanism
     * or the EIP-2930 access list feature.
     *
     * Note that this is different from the tx type itself,
     * so EIP-2930 access lists can very well be active
     * on an EIP-1559 tx for example.
     *
     * This method can be useful for feature checks if the
     * tx type is unknown (e.g. when instantiated with
     * the tx factory).
     *
     * See `Capabilites` in the `types` module for a reference
     * on all supported capabilities.
     */
    supports(capability) {
      return this.activeCapabilities.includes(capability);
    }
    validate(stringError = false) {
      const errors = [];
      if (this.getBaseFee() > this.gasLimit) {
        errors.push(`gasLimit is too low. given ${this.gasLimit}, need at least ${this.getBaseFee()}`);
      }
      if (this.isSigned() && !this.verifySignature()) {
        errors.push("Invalid Signature");
      }
      return stringError ? errors : errors.length === 0;
    }
    _validateYParity() {
      const { v } = this;
      if (v !== void 0 && v !== BigInt(0) && v !== BigInt(1)) {
        const msg = this._errorMsg("The y-parity of the transaction should either be 0 or 1");
        throw new Error(msg);
      }
    }
    /**
     * EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2are considered invalid.
     * Reasoning: https://ethereum.stackexchange.com/a/55728
     */
    _validateHighS() {
      const { s: s2 } = this;
      if (this.common.gteHardfork("homestead") && s2 !== void 0 && s2 > SECP256K1_ORDER_DIV_2) {
        const msg = this._errorMsg("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
        throw new Error(msg);
      }
    }
    /**
     * The minimum amount of gas the tx must have (DataFee + TxFee + Creation Fee)
     */
    getBaseFee() {
      const txFee = this.common.param("gasPrices", "tx");
      let fee = this.getDataFee();
      if (txFee)
        fee += txFee;
      if (this.common.gteHardfork("homestead") && this.toCreationAddress()) {
        const txCreationFee = this.common.param("gasPrices", "txCreation");
        if (txCreationFee)
          fee += txCreationFee;
      }
      return fee;
    }
    /**
     * The amount of gas paid for the data in this tx
     */
    getDataFee() {
      const txDataZero = this.common.param("gasPrices", "txDataZero");
      const txDataNonZero = this.common.param("gasPrices", "txDataNonZero");
      let cost = BigInt(0);
      for (let i2 = 0; i2 < this.data.length; i2 += 1) {
        this.data[i2] === 0 ? cost += txDataZero : cost += txDataNonZero;
      }
      if ((this.to === void 0 || this.to === null) && this.common.isActivatedEIP(3860)) {
        const dataLength = BigInt(Math.ceil(this.data.length / 32));
        const initCodeCost = this.common.param("gasPrices", "initCodeWordCost") * dataLength;
        cost += initCodeCost;
      }
      return cost;
    }
    /**
     * If the tx's `to` is to the creation address
     */
    toCreationAddress() {
      return this.to === void 0 || this.to.buf.length === 0;
    }
    isSigned() {
      const { v, r: r2, s: s2 } = this;
      if (v === void 0 || r2 === void 0 || s2 === void 0) {
        return false;
      }
      return true;
    }
    /**
     * Determines if the signature is valid
     */
    verifySignature() {
      try {
        const publicKey = this.getSenderPublicKey();
        return unpadUint8Array(publicKey).length !== 0;
      } catch (e2) {
        return false;
      }
    }
    /**
     * Returns the sender's address
     */
    getSenderAddress() {
      return new Address(Address.publicToAddress(this.getSenderPublicKey()));
    }
    /**
     * Signs a transaction.
     *
     * Note that the signed tx is returned as a new object,
     * use as follows:
     * ```javascript
     * const signedTx = tx.sign(privateKey)
     * ```
     */
    sign(privateKey) {
      if (privateKey.length !== 32) {
        const msg = this._errorMsg("Private key must be 32 bytes in length.");
        throw new Error(msg);
      }
      let hackApplied = false;
      if (this.type === 0 && this.common.gteHardfork("spuriousDragon") && !this.supports(Capability.EIP155ReplayProtection)) {
        this.activeCapabilities.push(Capability.EIP155ReplayProtection);
        hackApplied = true;
      }
      const msgHash = this.getMessageToSign(true);
      const { v, r: r2, s: s2 } = this._ecsign(msgHash, privateKey);
      const tx = this._processSignature(v, r2, s2);
      if (hackApplied) {
        const index2 = this.activeCapabilities.indexOf(Capability.EIP155ReplayProtection);
        if (index2 > -1) {
          this.activeCapabilities.splice(index2, 1);
        }
      }
      return tx;
    }
    /**
     * Does chain ID checks on common and returns a common
     * to be used on instantiation
     * @hidden
     *
     * @param common - {@link Common} instance from tx options
     * @param chainId - Chain ID from tx options (typed txs) or signature (legacy tx)
     */
    _getCommon(common, chainId) {
      var _a6;
      if (chainId !== void 0) {
        const chainIdBigInt = uint8ArrayToBigInt(toUint8Array(chainId));
        if (common) {
          if (common.chainId() !== chainIdBigInt) {
            const msg = this._errorMsg("The chain ID does not match the chain ID of Common");
            throw new Error(msg);
          }
          return common.copy();
        }
        if (Common.isSupportedChainId(chainIdBigInt)) {
          return new Common({ chain: chainIdBigInt, hardfork: this.DEFAULT_HARDFORK });
        }
        return Common.custom({
          name: "custom-chain",
          networkId: chainIdBigInt,
          chainId: chainIdBigInt
        }, { baseChain: this.DEFAULT_CHAIN, hardfork: this.DEFAULT_HARDFORK });
      }
      return (_a6 = common === null || common === void 0 ? void 0 : common.copy()) !== null && _a6 !== void 0 ? _a6 : new Common({ chain: this.DEFAULT_CHAIN, hardfork: this.DEFAULT_HARDFORK });
    }
    /**
     * Validates that an object with BigInt values cannot exceed the specified bit limit.
     * @param values Object containing string keys and BigInt values
     * @param bits Number of bits to check (64 or 256)
     * @param cannotEqual Pass true if the number also cannot equal one less the maximum value
     */
    _validateCannotExceedMaxInteger(values, bits2 = 256, cannotEqual = false) {
      for (const [key, value] of Object.entries(values)) {
        switch (bits2) {
          case 64:
            if (cannotEqual) {
              if (value !== void 0 && value >= MAX_UINT64) {
                const msg = this._errorMsg(`${key} cannot equal or exceed MAX_UINT64 (2^64-1), given ${value}`);
                throw new Error(msg);
              }
            } else if (value !== void 0 && value > MAX_UINT64) {
              const msg = this._errorMsg(`${key} cannot exceed MAX_UINT64 (2^64-1), given ${value}`);
              throw new Error(msg);
            }
            break;
          case 256:
            if (cannotEqual) {
              if (value !== void 0 && value >= MAX_INTEGER) {
                const msg = this._errorMsg(`${key} cannot equal or exceed MAX_INTEGER (2^256-1), given ${value}`);
                throw new Error(msg);
              }
            } else if (value !== void 0 && value > MAX_INTEGER) {
              const msg = this._errorMsg(`${key} cannot exceed MAX_INTEGER (2^256-1), given ${value}`);
              throw new Error(msg);
            }
            break;
          default: {
            const msg = this._errorMsg("unimplemented bits value");
            throw new Error(msg);
          }
        }
      }
    }
    static _validateNotArray(values) {
      const txDataKeys = [
        "nonce",
        "gasPrice",
        "gasLimit",
        "to",
        "value",
        "data",
        "v",
        "r",
        "s",
        "type",
        "baseFee",
        "maxFeePerGas",
        "chainId"
      ];
      for (const [key, value] of Object.entries(values)) {
        if (txDataKeys.includes(key)) {
          if (Array.isArray(value)) {
            throw new Error(`${key} cannot be an array`);
          }
        }
      }
    }
    /**
     * Returns the shared error postfix part for _error() method
     * tx type implementations.
     */
    _getSharedErrorPostfix() {
      let hash2 = "";
      try {
        hash2 = this.isSigned() ? bytesToHex2(this.hash()) : "not available (unsigned)";
      } catch (e2) {
        hash2 = "error";
      }
      let isSigned = "";
      try {
        isSigned = this.isSigned().toString();
      } catch (e2) {
        hash2 = "error";
      }
      let hf = "";
      try {
        hf = this.common.hardfork();
      } catch (e2) {
        hf = "error";
      }
      let postfix = `tx type=${this.type} hash=${hash2} nonce=${this.nonce} value=${this.value} `;
      postfix += `signed=${isSigned} hf=${hf}`;
      return postfix;
    }
    // eslint-disable-next-line class-methods-use-this
    _ecsign(msgHash, privateKey, chainId) {
      const signature = secp256k12.sign(msgHash, privateKey);
      const signatureBytes = signature.toCompactRawBytes();
      const r2 = signatureBytes.subarray(0, 32);
      const s2 = signatureBytes.subarray(32, 64);
      const v = chainId === void 0 ? BigInt(signature.recovery + 27) : BigInt(signature.recovery + 35) + BigInt(chainId) * BigInt(2);
      return { r: r2, s: s2, v };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromSerializedTx(serialized, opts = {}) {
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromTxData(txData, opts = {}) {
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/eip1559Transaction.js
  var TRANSACTION_TYPE = 2;
  var TRANSACTION_TYPE_UINT8ARRAY = hexToBytes2(TRANSACTION_TYPE.toString(16).padStart(2, "0"));
  var FeeMarketEIP1559Transaction = class _FeeMarketEIP1559Transaction extends BaseTransaction {
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */
    constructor(txData, opts = {}) {
      var _a6;
      super(Object.assign(Object.assign({}, txData), { type: TRANSACTION_TYPE }), opts);
      this.DEFAULT_HARDFORK = "london";
      const { chainId, accessList, maxFeePerGas, maxPriorityFeePerGas } = txData;
      this.common = this._getCommon(opts.common, chainId);
      this.chainId = this.common.chainId();
      if (!this.common.isActivatedEIP(1559)) {
        throw new Error("EIP-1559 not enabled on Common");
      }
      this.activeCapabilities = this.activeCapabilities.concat([1559, 2718, 2930]);
      const accessListData = getAccessListData(accessList !== null && accessList !== void 0 ? accessList : []);
      this.accessList = accessListData.accessList;
      this.AccessListJSON = accessListData.AccessListJSON;
      verifyAccessList(this.accessList);
      this.maxFeePerGas = uint8ArrayToBigInt(toUint8Array(maxFeePerGas === "" ? "0x" : maxFeePerGas));
      this.maxPriorityFeePerGas = uint8ArrayToBigInt(toUint8Array(maxPriorityFeePerGas === "" ? "0x" : maxPriorityFeePerGas));
      this._validateCannotExceedMaxInteger({
        maxFeePerGas: this.maxFeePerGas,
        maxPriorityFeePerGas: this.maxPriorityFeePerGas
      });
      BaseTransaction._validateNotArray(txData);
      if (this.gasLimit * this.maxFeePerGas > MAX_INTEGER) {
        const msg = this._errorMsg("gasLimit * maxFeePerGas cannot exceed MAX_INTEGER (2^256-1)");
        throw new Error(msg);
      }
      if (this.maxFeePerGas < this.maxPriorityFeePerGas) {
        const msg = this._errorMsg("maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)");
        throw new Error(msg);
      }
      this._validateYParity();
      this._validateHighS();
      const freeze = (_a6 = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _a6 !== void 0 ? _a6 : true;
      if (freeze) {
        Object.freeze(this);
      }
    }
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, v, r, s }
     *
     * Notes:
     * - `chainId` will be set automatically if not provided
     * - All parameters are optional and have some basic default values
     */
    static fromTxData(txData, opts = {}) {
      return new _FeeMarketEIP1559Transaction(txData, opts);
    }
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `0x02 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS])`
     */
    static fromSerializedTx(serialized, opts = {}) {
      if (!uint8ArrayEquals(serialized.subarray(0, 1), TRANSACTION_TYPE_UINT8ARRAY)) {
        throw new Error(`Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: ${TRANSACTION_TYPE}, received: ${bytesToHex2(serialized.subarray(0, 1))}`);
      }
      const values = import_rlp.RLP.decode(serialized.subarray(1));
      if (!Array.isArray(values)) {
        throw new Error("Invalid serialized tx input: must be array");
      }
      return _FeeMarketEIP1559Transaction.fromValuesArray(values, opts);
    }
    /**
     * Create a transaction from a values array.
     *
     * Format: `[chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS]`
     */
    static fromValuesArray(values, opts = {}) {
      if (values.length !== 9 && values.length !== 12) {
        throw new Error("Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).");
      }
      const [chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data, accessList, v, r2, s2] = values;
      this._validateNotArray({ chainId, v });
      validateNoLeadingZeroes({
        nonce,
        maxPriorityFeePerGas,
        maxFeePerGas,
        gasLimit,
        value,
        v,
        r: r2,
        s: s2
      });
      return new _FeeMarketEIP1559Transaction({
        chainId: uint8ArrayToBigInt(chainId),
        nonce,
        maxPriorityFeePerGas,
        maxFeePerGas,
        gasLimit,
        to,
        value,
        data,
        accessList: accessList !== null && accessList !== void 0 ? accessList : [],
        v: v !== void 0 ? uint8ArrayToBigInt(v) : void 0,
        r: r2,
        s: s2
      }, opts);
    }
    /**
     * The amount of gas paid for the data in this tx
     */
    getDataFee() {
      if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) {
        return this.cache.dataFee.value;
      }
      let cost = super.getDataFee();
      cost += BigInt(getDataFeeEIP2930(this.accessList, this.common));
      if (Object.isFrozen(this)) {
        this.cache.dataFee = {
          value: cost,
          hardfork: this.common.hardfork()
        };
      }
      return cost;
    }
    /**
     * The up front amount that an account must have for this transaction to be valid
     * @param baseFee The base fee of the block (will be set to 0 if not provided)
     */
    getUpfrontCost(baseFee = BigInt(0)) {
      const prio = this.maxPriorityFeePerGas;
      const maxBase = this.maxFeePerGas - baseFee;
      const inclusionFeePerGas = prio < maxBase ? prio : maxBase;
      const gasPrice = inclusionFeePerGas + baseFee;
      return this.gasLimit * gasPrice + this.value;
    }
    /**
     * Returns a Uint8Array Array of the raw Uint8Arrays of the EIP-1559 transaction, in order.
     *
     * Format: `[chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS]`
     *
     * Use {@link FeeMarketEIP1559Transaction.serialize} to add a transaction to a block
     * with {@link Block.fromValuesArray}.
     *
     * For an unsigned tx this method uses the empty Uint8Array values for the
     * signature parameters `v`, `r` and `s` for encoding. For an EIP-155 compliant
     * representation for external signing use {@link FeeMarketEIP1559Transaction.getMessageToSign}.
     */
    raw() {
      return [
        bigIntToUnpaddedUint8Array(this.chainId),
        bigIntToUnpaddedUint8Array(this.nonce),
        bigIntToUnpaddedUint8Array(this.maxPriorityFeePerGas),
        bigIntToUnpaddedUint8Array(this.maxFeePerGas),
        bigIntToUnpaddedUint8Array(this.gasLimit),
        this.to !== void 0 ? this.to.buf : Uint8Array.from([]),
        bigIntToUnpaddedUint8Array(this.value),
        this.data,
        this.accessList,
        this.v !== void 0 ? bigIntToUnpaddedUint8Array(this.v) : Uint8Array.from([]),
        this.r !== void 0 ? bigIntToUnpaddedUint8Array(this.r) : Uint8Array.from([]),
        this.s !== void 0 ? bigIntToUnpaddedUint8Array(this.s) : Uint8Array.from([])
      ];
    }
    /**
     * Returns the serialized encoding of the EIP-1559 transaction.
     *
     * Format: `0x02 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS])`
     *
     * Note that in contrast to the legacy tx serialization format this is not
     * valid RLP any more due to the raw tx type preceding and concatenated to
     * the RLP encoding of the values.
     */
    serialize() {
      const base2 = this.raw();
      return uint8ArrayConcat(TRANSACTION_TYPE_UINT8ARRAY, import_rlp.RLP.encode(base2));
    }
    /**
     * Returns the serialized unsigned tx (hashed or raw), which can be used
     * to sign the transaction (e.g. for sending to a hardware wallet).
     *
     * Note: in contrast to the legacy tx the raw message format is already
     * serialized and doesn't need to be RLP encoded any more.
     *
     * ```javascript
     * const serializedMessage = tx.getMessageToSign(false) // use this for the HW wallet input
     * ```
     *
     * @param hashMessage - Return hashed message if set to true (default: true)
     */
    getMessageToSign(hashMessage2 = true) {
      const base2 = this.raw().slice(0, 9);
      const message = uint8ArrayConcat(TRANSACTION_TYPE_UINT8ARRAY, import_rlp.RLP.encode(base2));
      if (hashMessage2) {
        return keccak256(message);
      }
      return message;
    }
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link FeeMarketEIP1559Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */
    hash() {
      if (!this.isSigned()) {
        const msg = this._errorMsg("Cannot call hash method if transaction is not signed");
        throw new Error(msg);
      }
      if (Object.isFrozen(this)) {
        if (!this.cache.hash) {
          this.cache.hash = keccak256(this.serialize());
        }
        return this.cache.hash;
      }
      return keccak256(this.serialize());
    }
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */
    getMessageToVerifySignature() {
      return this.getMessageToSign();
    }
    /**
     * Returns the public key of the sender
     */
    getSenderPublicKey() {
      if (!this.isSigned()) {
        const msg = this._errorMsg("Cannot call this method if transaction is not signed");
        throw new Error(msg);
      }
      const msgHash = this.getMessageToVerifySignature();
      const { v, r: r2, s: s2 } = this;
      this._validateHighS();
      try {
        return ecrecover(
          msgHash,
          v + BigInt(27),
          // Recover the 27 which was stripped from ecsign
          bigIntToUnpaddedUint8Array(r2),
          bigIntToUnpaddedUint8Array(s2)
        );
      } catch (e2) {
        const msg = this._errorMsg("Invalid Signature");
        throw new Error(msg);
      }
    }
    _processSignature(v, r2, s2) {
      const opts = Object.assign(Object.assign({}, this.txOptions), { common: this.common });
      return _FeeMarketEIP1559Transaction.fromTxData({
        chainId: this.chainId,
        nonce: this.nonce,
        maxPriorityFeePerGas: this.maxPriorityFeePerGas,
        maxFeePerGas: this.maxFeePerGas,
        gasLimit: this.gasLimit,
        to: this.to,
        value: this.value,
        data: this.data,
        accessList: this.accessList,
        v: v - BigInt(27),
        r: uint8ArrayToBigInt(r2),
        s: uint8ArrayToBigInt(s2)
      }, opts);
    }
    /**
     * Returns an object with the JSON representation of the transaction
     */
    toJSON() {
      const accessListJSON = getAccessListJSON(this.accessList);
      return {
        chainId: bigIntToHex(this.chainId),
        nonce: bigIntToHex(this.nonce),
        maxPriorityFeePerGas: bigIntToHex(this.maxPriorityFeePerGas),
        maxFeePerGas: bigIntToHex(this.maxFeePerGas),
        gasLimit: bigIntToHex(this.gasLimit),
        to: this.to !== void 0 ? this.to.toString() : void 0,
        value: bigIntToHex(this.value),
        data: bytesToHex2(this.data),
        accessList: accessListJSON,
        v: this.v !== void 0 ? bigIntToHex(this.v) : void 0,
        r: this.r !== void 0 ? bigIntToHex(this.r) : void 0,
        s: this.s !== void 0 ? bigIntToHex(this.s) : void 0
      };
    }
    /**
     * Return a compact error string representation of the object
     */
    errorStr() {
      let errorStr = this._getSharedErrorPostfix();
      errorStr += ` maxFeePerGas=${this.maxFeePerGas} maxPriorityFeePerGas=${this.maxPriorityFeePerGas}`;
      return errorStr;
    }
    /**
     * Internal helper function to create an annotated error message
     *
     * @param msg Base error message
     * @hidden
     */
    _errorMsg(msg) {
      return `${msg} (${this.errorStr()})`;
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/eip2930Transaction.js
  var import_rlp2 = __toESM(require_dist(), 1);
  var TRANSACTION_TYPE2 = 1;
  var TRANSACTION_TYPE_UINT8ARRAY2 = hexToBytes2(TRANSACTION_TYPE2.toString(16).padStart(2, "0"));
  var AccessListEIP2930Transaction = class _AccessListEIP2930Transaction extends BaseTransaction {
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */
    constructor(txData, opts = {}) {
      var _a6;
      super(Object.assign(Object.assign({}, txData), { type: TRANSACTION_TYPE2 }), opts);
      this.DEFAULT_HARDFORK = "berlin";
      const { chainId, accessList, gasPrice } = txData;
      this.common = this._getCommon(opts.common, chainId);
      this.chainId = this.common.chainId();
      if (!this.common.isActivatedEIP(2930)) {
        throw new Error("EIP-2930 not enabled on Common");
      }
      this.activeCapabilities = this.activeCapabilities.concat([2718, 2930]);
      const accessListData = getAccessListData(accessList !== null && accessList !== void 0 ? accessList : []);
      this.accessList = accessListData.accessList;
      this.AccessListJSON = accessListData.AccessListJSON;
      verifyAccessList(this.accessList);
      this.gasPrice = uint8ArrayToBigInt(toUint8Array(gasPrice === "" ? "0x" : gasPrice));
      this._validateCannotExceedMaxInteger({
        gasPrice: this.gasPrice
      });
      BaseTransaction._validateNotArray(txData);
      if (this.gasPrice * this.gasLimit > MAX_INTEGER) {
        const msg = this._errorMsg("gasLimit * gasPrice cannot exceed MAX_INTEGER");
        throw new Error(msg);
      }
      this._validateYParity();
      this._validateHighS();
      const freeze = (_a6 = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _a6 !== void 0 ? _a6 : true;
      if (freeze) {
        Object.freeze(this);
      }
    }
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * v, r, s }
     *
     * Notes:
     * - `chainId` will be set automatically if not provided
     * - All parameters are optional and have some basic default values
     */
    static fromTxData(txData, opts = {}) {
      return new _AccessListEIP2930Transaction(txData, opts);
    }
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `0x01 || rlp([chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)])`
     */
    static fromSerializedTx(serialized, opts = {}) {
      if (!uint8ArrayEquals(serialized.subarray(0, 1), TRANSACTION_TYPE_UINT8ARRAY2)) {
        throw new Error(`Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: ${TRANSACTION_TYPE2}, received: ${bytesToHex2(serialized.subarray(0, 1))}`);
      }
      const values = import_rlp2.RLP.decode(Uint8Array.from(serialized.subarray(1)));
      if (!Array.isArray(values)) {
        throw new Error("Invalid serialized tx input: must be array");
      }
      return _AccessListEIP2930Transaction.fromValuesArray(values, opts);
    }
    /**
     * Create a transaction from a values array.
     *
     * Format: `[chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)]`
     */
    static fromValuesArray(values, opts = {}) {
      if (values.length !== 8 && values.length !== 11) {
        throw new Error("Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).");
      }
      const [chainId, nonce, gasPrice, gasLimit, to, value, data, accessList, v, r2, s2] = values;
      this._validateNotArray({ chainId, v });
      validateNoLeadingZeroes({ nonce, gasPrice, gasLimit, value, v, r: r2, s: s2 });
      const emptyAccessList = [];
      return new _AccessListEIP2930Transaction({
        chainId: uint8ArrayToBigInt(chainId),
        nonce,
        gasPrice,
        gasLimit,
        to,
        value,
        data,
        accessList: accessList !== null && accessList !== void 0 ? accessList : emptyAccessList,
        v: v !== void 0 ? uint8ArrayToBigInt(v) : void 0,
        r: r2,
        s: s2
      }, opts);
    }
    /**
     * The amount of gas paid for the data in this tx
     */
    getDataFee() {
      if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) {
        return this.cache.dataFee.value;
      }
      let cost = super.getDataFee();
      cost += BigInt(getDataFeeEIP2930(this.accessList, this.common));
      if (Object.isFrozen(this)) {
        this.cache.dataFee = {
          value: cost,
          hardfork: this.common.hardfork()
        };
      }
      return cost;
    }
    /**
     * The up front amount that an account must have for this transaction to be valid
     */
    getUpfrontCost() {
      return this.gasLimit * this.gasPrice + this.value;
    }
    /**
     * Returns a Uint8Array Array of the raw Uint8Arrays of the EIP-2930 transaction, in order.
     *
     * Format: `[chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)]`
     *
     * Use {@link AccessListEIP2930Transaction.serialize} to add a transaction to a block
     * with {@link Block.fromValuesArray}.
     *
     * For an unsigned tx this method uses the empty UINT8ARRAY values for the
     * signature parameters `v`, `r` and `s` for encoding. For an EIP-155 compliant
     * representation for external signing use {@link AccessListEIP2930Transaction.getMessageToSign}.
     */
    raw() {
      return [
        bigIntToUnpaddedUint8Array(this.chainId),
        bigIntToUnpaddedUint8Array(this.nonce),
        bigIntToUnpaddedUint8Array(this.gasPrice),
        bigIntToUnpaddedUint8Array(this.gasLimit),
        this.to !== void 0 ? this.to.buf : Uint8Array.from([]),
        bigIntToUnpaddedUint8Array(this.value),
        this.data,
        this.accessList,
        this.v !== void 0 ? bigIntToUnpaddedUint8Array(this.v) : Uint8Array.from([]),
        this.r !== void 0 ? bigIntToUnpaddedUint8Array(this.r) : Uint8Array.from([]),
        this.s !== void 0 ? bigIntToUnpaddedUint8Array(this.s) : Uint8Array.from([])
      ];
    }
    /**
     * Returns the serialized encoding of the EIP-2930 transaction.
     *
     * Format: `0x01 || rlp([chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)])`
     *
     * Note that in contrast to the legacy tx serialization format this is not
     * valid RLP any more due to the raw tx type preceding and concatenated to
     * the RLP encoding of the values.
     */
    serialize() {
      const base2 = this.raw();
      return uint8ArrayConcat(TRANSACTION_TYPE_UINT8ARRAY2, import_rlp2.RLP.encode(base2));
    }
    /**
     * Returns the serialized unsigned tx (hashed or raw), which can be used
     * to sign the transaction (e.g. for sending to a hardware wallet).
     *
     * Note: in contrast to the legacy tx the raw message format is already
     * serialized and doesn't need to be RLP encoded any more.
     *
     * ```javascript
     * const serializedMessage = tx.getMessageToSign(false) // use this for the HW wallet input
     * ```
     *
     * @param hashMessage - Return hashed message if set to true (default: true)
     */
    getMessageToSign(hashMessage2 = true) {
      const base2 = this.raw().slice(0, 8);
      const message = uint8ArrayConcat(TRANSACTION_TYPE_UINT8ARRAY2, import_rlp2.RLP.encode(base2));
      if (hashMessage2) {
        return keccak256(message);
      }
      return message;
    }
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link AccessListEIP2930Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */
    hash() {
      if (!this.isSigned()) {
        const msg = this._errorMsg("Cannot call hash method if transaction is not signed");
        throw new Error(msg);
      }
      if (Object.isFrozen(this)) {
        if (!this.cache.hash) {
          this.cache.hash = keccak256(this.serialize());
        }
        return this.cache.hash;
      }
      return keccak256(this.serialize());
    }
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */
    getMessageToVerifySignature() {
      return this.getMessageToSign();
    }
    /**
     * Returns the public key of the sender
     */
    getSenderPublicKey() {
      if (!this.isSigned()) {
        const msg = this._errorMsg("Cannot call this method if transaction is not signed");
        throw new Error(msg);
      }
      const msgHash = this.getMessageToVerifySignature();
      const { v, r: r2, s: s2 } = this;
      this._validateHighS();
      try {
        return ecrecover(
          msgHash,
          v + BigInt(27),
          // Recover the 27 which was stripped from ecsign
          bigIntToUnpaddedUint8Array(r2),
          bigIntToUnpaddedUint8Array(s2)
        );
      } catch (e2) {
        const msg = this._errorMsg("Invalid Signature");
        throw new Error(msg);
      }
    }
    _processSignature(v, r2, s2) {
      const opts = Object.assign(Object.assign({}, this.txOptions), { common: this.common });
      return _AccessListEIP2930Transaction.fromTxData({
        chainId: this.chainId,
        nonce: this.nonce,
        gasPrice: this.gasPrice,
        gasLimit: this.gasLimit,
        to: this.to,
        value: this.value,
        data: this.data,
        accessList: this.accessList,
        v: v - BigInt(27),
        r: uint8ArrayToBigInt(r2),
        s: uint8ArrayToBigInt(s2)
      }, opts);
    }
    /**
     * Returns an object with the JSON representation of the transaction
     */
    toJSON() {
      const accessListJSON = getAccessListJSON(this.accessList);
      return {
        chainId: bigIntToHex(this.chainId),
        nonce: bigIntToHex(this.nonce),
        gasPrice: bigIntToHex(this.gasPrice),
        gasLimit: bigIntToHex(this.gasLimit),
        to: this.to !== void 0 ? this.to.toString() : void 0,
        value: bigIntToHex(this.value),
        data: bytesToHex2(this.data),
        accessList: accessListJSON,
        v: this.v !== void 0 ? bigIntToHex(this.v) : void 0,
        r: this.r !== void 0 ? bigIntToHex(this.r) : void 0,
        s: this.s !== void 0 ? bigIntToHex(this.s) : void 0
      };
    }
    /**
     * Return a compact error string representation of the object
     */
    errorStr() {
      var _a6, _b3;
      let errorStr = this._getSharedErrorPostfix();
      errorStr += ` gasPrice=${this.gasPrice} accessListCount=${(_b3 = (_a6 = this.accessList) === null || _a6 === void 0 ? void 0 : _a6.length) !== null && _b3 !== void 0 ? _b3 : 0}`;
      return errorStr;
    }
    /**
     * Internal helper function to create an annotated error message
     *
     * @param msg Base error message
     * @hidden
     */
    _errorMsg(msg) {
      return `${msg} (${this.errorStr()})`;
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/legacyTransaction.js
  var import_rlp3 = __toESM(require_dist(), 1);
  var TRANSACTION_TYPE3 = 0;
  function meetsEIP155(_v, chainId) {
    const v = Number(_v);
    const chainIdDoubled = Number(chainId) * 2;
    return v === chainIdDoubled + 35 || v === chainIdDoubled + 36;
  }
  var Transaction2 = class _Transaction extends BaseTransaction {
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */
    constructor(txData, opts = {}) {
      var _a6;
      super(Object.assign(Object.assign({}, txData), { type: TRANSACTION_TYPE3 }), opts);
      this.common = this._validateTxV(this.v, opts.common);
      this.gasPrice = uint8ArrayToBigInt(toUint8Array(txData.gasPrice === "" ? "0x" : txData.gasPrice));
      if (this.gasPrice * this.gasLimit > MAX_INTEGER) {
        const msg = this._errorMsg("gas limit * gasPrice cannot exceed MAX_INTEGER (2^256-1)");
        throw new Error(msg);
      }
      this._validateCannotExceedMaxInteger({ gasPrice: this.gasPrice });
      BaseTransaction._validateNotArray(txData);
      if (this.common.gteHardfork("spuriousDragon")) {
        if (!this.isSigned()) {
          this.activeCapabilities.push(Capability.EIP155ReplayProtection);
        } else {
          if (meetsEIP155(this.v, this.common.chainId())) {
            this.activeCapabilities.push(Capability.EIP155ReplayProtection);
          }
        }
      }
      const freeze = (_a6 = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _a6 !== void 0 ? _a6 : true;
      if (freeze) {
        Object.freeze(this);
      }
    }
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { nonce, gasPrice, gasLimit, to, value, data, v, r, s }
     *
     * Notes:
     * - All parameters are optional and have some basic default values
     */
    static fromTxData(txData, opts = {}) {
      return new _Transaction(txData, opts);
    }
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
     */
    static fromSerializedTx(serialized, opts = {}) {
      const values = import_rlp3.RLP.decode(serialized);
      if (!Array.isArray(values)) {
        throw new Error("Invalid serialized tx input. Must be array");
      }
      return this.fromValuesArray(values, opts);
    }
    /**
     * Create a transaction from a values array.
     *
     * Format: `[nonce, gasPrice, gasLimit, to, value, data, v, r, s]`
     */
    static fromValuesArray(values, opts = {}) {
      if (values.length !== 6 && values.length !== 9) {
        throw new Error("Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).");
      }
      const [nonce, gasPrice, gasLimit, to, value, data, v, r2, s2] = values;
      validateNoLeadingZeroes({ nonce, gasPrice, gasLimit, value, v, r: r2, s: s2 });
      return new _Transaction({
        nonce,
        gasPrice,
        gasLimit,
        to,
        value,
        data,
        v,
        r: r2,
        s: s2
      }, opts);
    }
    /**
     * Returns a Uint8Array Array of the raw Uint8Arrays of the legacy transaction, in order.
     *
     * Format: `[nonce, gasPrice, gasLimit, to, value, data, v, r, s]`
     *
     * For legacy txs this is also the correct format to add transactions
     * to a block with {@link Block.fromValuesArray} (use the `serialize()` method
     * for typed txs).
     *
     * For an unsigned tx this method returns the empty Uint8Array values
     * for the signature parameters `v`, `r` and `s`. For an EIP-155 compliant
     * representation have a look at {@link Transaction.getMessageToSign}.
     */
    raw() {
      return [
        bigIntToUnpaddedUint8Array(this.nonce),
        bigIntToUnpaddedUint8Array(this.gasPrice),
        bigIntToUnpaddedUint8Array(this.gasLimit),
        this.to !== void 0 ? this.to.buf : Uint8Array.from([]),
        bigIntToUnpaddedUint8Array(this.value),
        this.data,
        this.v !== void 0 ? bigIntToUnpaddedUint8Array(this.v) : Uint8Array.from([]),
        this.r !== void 0 ? bigIntToUnpaddedUint8Array(this.r) : Uint8Array.from([]),
        this.s !== void 0 ? bigIntToUnpaddedUint8Array(this.s) : Uint8Array.from([])
      ];
    }
    /**
     * Returns the serialized encoding of the legacy transaction.
     *
     * Format: `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
     *
     * For an unsigned tx this method uses the empty Uint8Array values for the
     * signature parameters `v`, `r` and `s` for encoding. For an EIP-155 compliant
     * representation for external signing use {@link Transaction.getMessageToSign}.
     */
    serialize() {
      return import_rlp3.RLP.encode(this.raw());
    }
    _getMessageToSign() {
      const values = [
        bigIntToUnpaddedUint8Array(this.nonce),
        bigIntToUnpaddedUint8Array(this.gasPrice),
        bigIntToUnpaddedUint8Array(this.gasLimit),
        this.to !== void 0 ? this.to.buf : Uint8Array.from([]),
        bigIntToUnpaddedUint8Array(this.value),
        this.data
      ];
      if (this.supports(Capability.EIP155ReplayProtection)) {
        values.push(toUint8Array(this.common.chainId()));
        values.push(unpadUint8Array(toUint8Array(0)));
        values.push(unpadUint8Array(toUint8Array(0)));
      }
      return values;
    }
    getMessageToSign(hashMessage2 = true) {
      const message = this._getMessageToSign();
      if (hashMessage2) {
        return keccak256(import_rlp3.RLP.encode(message));
      }
      return message;
    }
    /**
     * The amount of gas paid for the data in this tx
     */
    getDataFee() {
      if (this.cache.dataFee && this.cache.dataFee.hardfork === this.common.hardfork()) {
        return this.cache.dataFee.value;
      }
      if (Object.isFrozen(this)) {
        this.cache.dataFee = {
          value: super.getDataFee(),
          hardfork: this.common.hardfork()
        };
      }
      return super.getDataFee();
    }
    /**
     * The up front amount that an account must have for this transaction to be valid
     */
    getUpfrontCost() {
      return this.gasLimit * this.gasPrice + this.value;
    }
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */
    hash() {
      if (!this.isSigned()) {
        const msg = this._errorMsg("Cannot call hash method if transaction is not signed");
        throw new Error(msg);
      }
      if (Object.isFrozen(this)) {
        if (!this.cache.hash) {
          this.cache.hash = keccak256(import_rlp3.RLP.encode(this.raw()));
        }
        return this.cache.hash;
      }
      return keccak256(import_rlp3.RLP.encode(this.raw()));
    }
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */
    getMessageToVerifySignature() {
      if (!this.isSigned()) {
        const msg = this._errorMsg("This transaction is not signed");
        throw new Error(msg);
      }
      const message = this._getMessageToSign();
      return keccak256(import_rlp3.RLP.encode(message));
    }
    /**
     * Returns the public key of the sender
     */
    getSenderPublicKey() {
      const msgHash = this.getMessageToVerifySignature();
      const { v, r: r2, s: s2 } = this;
      this._validateHighS();
      try {
        return ecrecover(msgHash, v, bigIntToUnpaddedUint8Array(r2), bigIntToUnpaddedUint8Array(s2), this.supports(Capability.EIP155ReplayProtection) ? this.common.chainId() : void 0);
      } catch (e2) {
        const msg = this._errorMsg("Invalid Signature");
        throw new Error(msg);
      }
    }
    /**
     * Process the v, r, s values from the `sign` method of the base transaction.
     */
    _processSignature(_v, r2, s2) {
      let v = _v;
      if (this.supports(Capability.EIP155ReplayProtection)) {
        v += this.common.chainId() * BigInt(2) + BigInt(8);
      }
      const opts = Object.assign(Object.assign({}, this.txOptions), { common: this.common });
      return _Transaction.fromTxData({
        nonce: this.nonce,
        gasPrice: this.gasPrice,
        gasLimit: this.gasLimit,
        to: this.to,
        value: this.value,
        data: this.data,
        v,
        r: uint8ArrayToBigInt(r2),
        s: uint8ArrayToBigInt(s2)
      }, opts);
    }
    /**
     * Returns an object with the JSON representation of the transaction.
     */
    toJSON() {
      return {
        nonce: bigIntToHex(this.nonce),
        gasPrice: bigIntToHex(this.gasPrice),
        gasLimit: bigIntToHex(this.gasLimit),
        to: this.to !== void 0 ? this.to.toString() : void 0,
        value: bigIntToHex(this.value),
        data: bytesToHex2(this.data),
        v: this.v !== void 0 ? bigIntToHex(this.v) : void 0,
        r: this.r !== void 0 ? bigIntToHex(this.r) : void 0,
        s: this.s !== void 0 ? bigIntToHex(this.s) : void 0
      };
    }
    /**
     * Validates tx's `v` value
     */
    _validateTxV(_v, common) {
      let chainIdBigInt;
      const v = _v !== void 0 ? Number(_v) : void 0;
      if (v !== void 0) {
        if (v < 37 && v !== 27 && v !== 28) {
          throw new Error(`Legacy txs need either v = 27/28 or v >= 37 (EIP-155 replay protection), got v = ${v}`);
        }
      }
      if (v !== void 0 && v !== 0 && (!common || common.gteHardfork("spuriousDragon")) && v !== 27 && v !== 28) {
        if (common) {
          if (!meetsEIP155(BigInt(v), common.chainId())) {
            throw new Error(`Incompatible EIP155-based V ${v} and chain id ${common.chainId()}. See the Common parameter of the Transaction constructor to set the chain id.`);
          }
        } else {
          let numSub;
          if ((v - 35) % 2 === 0) {
            numSub = 35;
          } else {
            numSub = 36;
          }
          chainIdBigInt = BigInt(v - numSub) / BigInt(2);
        }
      }
      return this._getCommon(common, chainIdBigInt);
    }
    /**
     * Return a compact error string representation of the object
     */
    errorStr() {
      let errorStr = this._getSharedErrorPostfix();
      errorStr += ` gasPrice=${this.gasPrice}`;
      return errorStr;
    }
    /**
     * Internal helper function to create an annotated error message
     *
     * @param msg Base error message
     * @hidden
     */
    _errorMsg(msg) {
      return `${msg} (${this.errorStr()})`;
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/tx/transactionFactory.js
  var extraTxTypes = /* @__PURE__ */ new Map();
  var TransactionFactory = class _TransactionFactory {
    // It is not possible to instantiate a TransactionFactory object.
    // eslint-disable-next-line @typescript-eslint/no-empty-function, no-useless-constructor
    constructor() {
    }
    static typeToInt(txType) {
      return Number(uint8ArrayToBigInt(toUint8Array(txType)));
    }
    static registerTransactionType(type, txClass) {
      const txType = _TransactionFactory.typeToInt(type);
      extraTxTypes.set(txType, txClass);
    }
    /**
     * Create a transaction from a `txData` object
     *
     * @param txData - The transaction data. The `type` field will determine which transaction type is returned (if undefined, creates a legacy transaction)
     * @param txOptions - Options to pass on to the constructor of the transaction
     */
    static fromTxData(txData, txOptions = {}) {
      if (!("type" in txData) || txData.type === void 0) {
        return Transaction2.fromTxData(txData, txOptions);
      }
      const txType = _TransactionFactory.typeToInt(txData.type);
      if (txType === 0) {
        return Transaction2.fromTxData(txData, txOptions);
      }
      if (txType === 1) {
        return AccessListEIP2930Transaction.fromTxData(
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          txData,
          txOptions
        );
      }
      if (txType === 2) {
        return FeeMarketEIP1559Transaction.fromTxData(
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          txData,
          txOptions
        );
      }
      const ExtraTransaction = extraTxTypes.get(txType);
      if (ExtraTransaction === null || ExtraTransaction === void 0 ? void 0 : ExtraTransaction.fromTxData) {
        return ExtraTransaction.fromTxData(txData, txOptions);
      }
      throw new Error(`Tx instantiation with type ${txType} not supported`);
    }
    /**
     * This method tries to decode serialized data.
     *
     * @param data - The data Uint8Array
     * @param txOptions - The transaction options
     */
    static fromSerializedData(data, txOptions = {}) {
      if (data[0] <= 127) {
        switch (data[0]) {
          case 1:
            return AccessListEIP2930Transaction.fromSerializedTx(data, txOptions);
          case 2:
            return FeeMarketEIP1559Transaction.fromSerializedTx(data, txOptions);
          default: {
            const ExtraTransaction = extraTxTypes.get(Number(data[0]));
            if (ExtraTransaction === null || ExtraTransaction === void 0 ? void 0 : ExtraTransaction.fromSerializedTx) {
              return ExtraTransaction.fromSerializedTx(data, txOptions);
            }
            throw new Error(`TypedTransaction with ID ${data[0]} unknown`);
          }
        }
      } else {
        return Transaction2.fromSerializedTx(data, txOptions);
      }
    }
    /**
     * When decoding a BlockBody, in the transactions field, a field is either:
     * A Uint8Array (a TypedTransaction - encoded as TransactionType || rlp(TransactionPayload))
     * A Uint8Array[] (Legacy Transaction)
     * This method returns the right transaction.
     *
     * @param data - A Uint8Array or Uint8Array[]
     * @param txOptions - The transaction options
     */
    static fromBlockBodyData(data, txOptions = {}) {
      if (data instanceof Uint8Array) {
        return this.fromSerializedData(data, txOptions);
      }
      if (Array.isArray(data)) {
        return Transaction2.fromValuesArray(data, txOptions);
      }
      throw new Error("Cannot decode transaction: unknown type input");
    }
  };

  // ../../node_modules/.pnpm/web3-eth-accounts@4.1.0/node_modules/web3-eth-accounts/lib/esm/account.js
  var __awaiter12 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var parseAndValidatePrivateKey = (data, ignoreLength) => {
    let privateKeyUint8Array;
    if (!ignoreLength && typeof data === "string" && isHexStrict(data) && data.length !== 66) {
      throw new PrivateKeyLengthError();
    }
    try {
      privateKeyUint8Array = data instanceof Uint8Array ? data : bytesToUint8Array(data);
    } catch (_a6) {
      throw new InvalidPrivateKeyError();
    }
    if (!ignoreLength && privateKeyUint8Array.byteLength !== 32) {
      throw new PrivateKeyLengthError();
    }
    return privateKeyUint8Array;
  };
  var hashMessage = (message) => {
    const messageHex = isHexStrict(message) ? message : utf8ToHex(message);
    const messageBytes = hexToBytes2(messageHex);
    const preamble = hexToBytes2(fromUtf8(`Ethereum Signed Message:
${messageBytes.byteLength}`));
    const ethMessage = uint8ArrayConcat(preamble, messageBytes);
    return sha3Raw(ethMessage);
  };
  var sign = (data, privateKey) => {
    const privateKeyUint8Array = parseAndValidatePrivateKey(privateKey);
    const hash2 = hashMessage(data);
    const signature = secp256k12.sign(hash2.substring(2), privateKeyUint8Array);
    const signatureBytes = signature.toCompactRawBytes();
    const r2 = signature.r.toString(16).padStart(64, "0");
    const s2 = signature.s.toString(16).padStart(64, "0");
    const v = signature.recovery + 27;
    return {
      message: data,
      messageHash: hash2,
      v: numberToHex2(v),
      r: `0x${r2}`,
      s: `0x${s2}`,
      signature: `${bytesToHex2(signatureBytes)}${v.toString(16)}`
    };
  };
  var signTransaction = (transaction, privateKey) => __awaiter12(void 0, void 0, void 0, function* () {
    const signedTx = transaction.sign(hexToBytes2(privateKey));
    if (isNullish(signedTx.v) || isNullish(signedTx.r) || isNullish(signedTx.s))
      throw new TransactionSigningError("Signer Error");
    const validationErrors = signedTx.validate(true);
    if (validationErrors.length > 0) {
      let errorString = "Signer Error ";
      for (const validationError of validationErrors) {
        errorString += `${errorString} ${validationError}.`;
      }
      throw new TransactionSigningError(errorString);
    }
    const rawTx = bytesToHex2(signedTx.serialize());
    const txHash = sha3Raw(rawTx);
    return {
      messageHash: bytesToHex2(signedTx.getMessageToSign(true)),
      v: `0x${signedTx.v.toString(16)}`,
      r: `0x${signedTx.r.toString(16).padStart(64, "0")}`,
      s: `0x${signedTx.s.toString(16).padStart(64, "0")}`,
      rawTransaction: rawTx,
      transactionHash: bytesToHex2(txHash)
    };
  });
  var recoverTransaction = (rawTransaction) => {
    if (isNullish(rawTransaction))
      throw new UndefinedRawTransactionError();
    const tx = TransactionFactory.fromSerializedData(hexToBytes2(rawTransaction));
    return toChecksumAddress(tx.getSenderAddress().toString());
  };
  var recover = (data, signatureOrV, prefixedOrR, s2, prefixed) => {
    if (typeof data === "object") {
      const signatureStr = `${data.r}${data.s.slice(2)}${data.v.slice(2)}`;
      return recover(data.messageHash, signatureStr, prefixedOrR);
    }
    if (typeof signatureOrV === "string" && typeof prefixedOrR === "string" && !isNullish(s2)) {
      const signatureStr = `${prefixedOrR}${s2.slice(2)}${signatureOrV.slice(2)}`;
      return recover(data, signatureStr, prefixed);
    }
    if (isNullish(signatureOrV))
      throw new InvalidSignatureError("signature string undefined");
    const V_INDEX = 130;
    const hashedMessage = prefixedOrR ? data : hashMessage(data);
    let v = parseInt(signatureOrV.substring(V_INDEX), 16);
    if (v > 26) {
      v -= 27;
    }
    const ecPublicKey = secp256k12.Signature.fromCompact(signatureOrV.slice(2, V_INDEX)).addRecoveryBit(v).recoverPublicKey(hashedMessage.replace("0x", "")).toRawBytes(false);
    const publicHash = sha3Raw(ecPublicKey.subarray(1));
    const address = toChecksumAddress(`0x${publicHash.slice(-40)}`);
    return address;
  };
  var privateKeyToAddress = (privateKey) => {
    const privateKeyUint8Array = parseAndValidatePrivateKey(privateKey);
    const publicKey = secp256k12.getPublicKey(privateKeyUint8Array, false);
    const publicKeyHash = sha3Raw(publicKey.slice(1));
    const address = publicKeyHash.slice(-40);
    return toChecksumAddress(`0x${address}`);
  };
  var privateKeyToPublicKey = (privateKey, isCompressed) => {
    const privateKeyUint8Array = parseAndValidatePrivateKey(privateKey);
    return `0x${bytesToHex2(secp256k12.getPublicKey(privateKeyUint8Array, isCompressed)).slice(4)}`;
  };
  var encrypt2 = (privateKey, password, options) => __awaiter12(void 0, void 0, void 0, function* () {
    var _a6, _b3, _c2, _d, _e, _f, _g;
    const privateKeyUint8Array = parseAndValidatePrivateKey(privateKey);
    let salt;
    if (options === null || options === void 0 ? void 0 : options.salt) {
      salt = typeof options.salt === "string" ? hexToBytes2(options.salt) : options.salt;
    } else {
      salt = randomBytes2(32);
    }
    if (!(isString(password) || password instanceof Uint8Array)) {
      throw new InvalidPasswordError();
    }
    const uint8ArrayPassword = typeof password === "string" ? hexToBytes2(utf8ToHex(password)) : password;
    let initializationVector;
    if (options === null || options === void 0 ? void 0 : options.iv) {
      initializationVector = typeof options.iv === "string" ? hexToBytes2(options.iv) : options.iv;
      if (initializationVector.length !== 16) {
        throw new IVLengthError();
      }
    } else {
      initializationVector = randomBytes2(16);
    }
    const kdf = (_a6 = options === null || options === void 0 ? void 0 : options.kdf) !== null && _a6 !== void 0 ? _a6 : "scrypt";
    let derivedKey;
    let kdfparams;
    if (kdf === "pbkdf2") {
      kdfparams = {
        dklen: (_b3 = options === null || options === void 0 ? void 0 : options.dklen) !== null && _b3 !== void 0 ? _b3 : 32,
        salt: bytesToHex2(salt).replace("0x", ""),
        c: (_c2 = options === null || options === void 0 ? void 0 : options.c) !== null && _c2 !== void 0 ? _c2 : 262144,
        prf: "hmac-sha256"
      };
      if (kdfparams.c < 1e3) {
        throw new PBKDF2IterationsError();
      }
      derivedKey = pbkdf2Sync(uint8ArrayPassword, salt, kdfparams.c, kdfparams.dklen, "sha256");
    } else if (kdf === "scrypt") {
      kdfparams = {
        n: (_d = options === null || options === void 0 ? void 0 : options.n) !== null && _d !== void 0 ? _d : 8192,
        r: (_e = options === null || options === void 0 ? void 0 : options.r) !== null && _e !== void 0 ? _e : 8,
        p: (_f = options === null || options === void 0 ? void 0 : options.p) !== null && _f !== void 0 ? _f : 1,
        dklen: (_g = options === null || options === void 0 ? void 0 : options.dklen) !== null && _g !== void 0 ? _g : 32,
        salt: bytesToHex2(salt).replace("0x", "")
      };
      derivedKey = scryptSync(uint8ArrayPassword, salt, kdfparams.n, kdfparams.p, kdfparams.r, kdfparams.dklen);
    } else {
      throw new InvalidKdfError();
    }
    const cipher = yield encrypt(privateKeyUint8Array, derivedKey.slice(0, 16), initializationVector, "aes-128-ctr");
    const ciphertext = bytesToHex2(cipher).slice(2);
    const mac = sha3Raw(uint8ArrayConcat(derivedKey.slice(16, 32), cipher)).replace("0x", "");
    return {
      version: 3,
      id: uuidV4(),
      address: privateKeyToAddress(privateKeyUint8Array).toLowerCase().replace("0x", ""),
      crypto: {
        ciphertext,
        cipherparams: {
          iv: bytesToHex2(initializationVector).replace("0x", "")
        },
        cipher: "aes-128-ctr",
        kdf,
        kdfparams,
        mac
      }
    };
  });
  var privateKeyToAccount = (privateKey, ignoreLength) => {
    const privateKeyUint8Array = parseAndValidatePrivateKey(privateKey, ignoreLength);
    return {
      address: privateKeyToAddress(privateKeyUint8Array),
      privateKey: bytesToHex2(privateKeyUint8Array),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      signTransaction: (_tx) => {
        throw new TransactionSigningError("Do not have network access to sign the transaction");
      },
      sign: (data) => sign(typeof data === "string" ? data : JSON.stringify(data), privateKeyUint8Array),
      encrypt: (password, options) => __awaiter12(void 0, void 0, void 0, function* () {
        return encrypt2(privateKeyUint8Array, password, options);
      })
    };
  };
  var create = () => {
    const privateKey = secp256k12.utils.randomPrivateKey();
    return privateKeyToAccount(`${bytesToHex2(privateKey)}`);
  };
  var decrypt2 = (keystore, password, nonStrict) => __awaiter12(void 0, void 0, void 0, function* () {
    const json = typeof keystore === "object" ? keystore : JSON.parse(nonStrict ? keystore.toLowerCase() : keystore);
    validator.validateJSONSchema(keyStoreSchema, json);
    if (json.version !== 3)
      throw new KeyStoreVersionError();
    const uint8ArrayPassword = typeof password === "string" ? hexToBytes2(utf8ToHex(password)) : password;
    validator.validate(["bytes"], [uint8ArrayPassword]);
    let derivedKey;
    if (json.crypto.kdf === "scrypt") {
      const kdfparams = json.crypto.kdfparams;
      const uint8ArraySalt = typeof kdfparams.salt === "string" ? hexToBytes2(kdfparams.salt) : kdfparams.salt;
      derivedKey = scryptSync(uint8ArrayPassword, uint8ArraySalt, kdfparams.n, kdfparams.p, kdfparams.r, kdfparams.dklen);
    } else if (json.crypto.kdf === "pbkdf2") {
      const kdfparams = json.crypto.kdfparams;
      const uint8ArraySalt = typeof kdfparams.salt === "string" ? hexToBytes2(kdfparams.salt) : kdfparams.salt;
      derivedKey = pbkdf2Sync(uint8ArrayPassword, uint8ArraySalt, kdfparams.c, kdfparams.dklen, "sha256");
    } else {
      throw new InvalidKdfError();
    }
    const ciphertext = hexToBytes2(json.crypto.ciphertext);
    const mac = sha3Raw(uint8ArrayConcat(derivedKey.slice(16, 32), ciphertext)).replace("0x", "");
    if (mac !== json.crypto.mac) {
      throw new KeyDerivationError();
    }
    const seed = yield decrypt(hexToBytes2(json.crypto.ciphertext), derivedKey.slice(0, 16), hexToBytes2(json.crypto.cipherparams.iv));
    return privateKeyToAccount(seed);
  });

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_batch_request.js
  var __awaiter13 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var DEFAULT_BATCH_REQUEST_TIMEOUT = 1e3;
  var Web3BatchRequest = class {
    constructor(requestManager) {
      this._requestManager = requestManager;
      this._requests = /* @__PURE__ */ new Map();
    }
    get requests() {
      return [...this._requests.values()].map((r2) => r2.payload);
    }
    add(request4) {
      const payload = json_rpc_exports.toPayload(request4);
      const promise = new Web3DeferredPromise();
      this._requests.set(payload.id, { payload, promise });
      return promise;
    }
    // eslint-disable-next-line class-methods-use-this
    execute(options) {
      var _a6;
      return __awaiter13(this, void 0, void 0, function* () {
        if (this.requests.length === 0) {
          return Promise.resolve([]);
        }
        const request4 = new Web3DeferredPromise({
          timeout: (_a6 = options === null || options === void 0 ? void 0 : options.timeout) !== null && _a6 !== void 0 ? _a6 : DEFAULT_BATCH_REQUEST_TIMEOUT,
          eagerStart: true,
          timeoutMessage: "Batch request timeout"
        });
        this._processBatchRequest(request4).catch((err3) => request4.reject(err3));
        request4.catch((err3) => {
          if (err3 instanceof OperationTimeoutError) {
            this._abortAllRequests("Batch request timeout");
          }
          request4.reject(err3);
        });
        return request4;
      });
    }
    _processBatchRequest(promise) {
      var _a6, _b3;
      return __awaiter13(this, void 0, void 0, function* () {
        const response = yield this._requestManager.sendBatch([...this._requests.values()].map((r2) => r2.payload));
        if (response.length !== this._requests.size) {
          this._abortAllRequests("Invalid batch response");
          throw new ResponseError(response, `Batch request size mismatch the results size. Requests: ${this._requests.size}, Responses: ${response.length}`);
        }
        const requestIds = this.requests.map((r2) => r2.id).map(Number).sort((a, b) => a - b);
        const responseIds = response.map((r2) => r2.id).map(Number).sort((a, b) => a - b);
        if (JSON.stringify(requestIds) !== JSON.stringify(responseIds)) {
          this._abortAllRequests("Invalid batch response");
          throw new ResponseError(response, `Batch request mismatch the results. Requests: [${requestIds.join()}], Responses: [${responseIds.join()}]`);
        }
        for (const res of response) {
          if (json_rpc_exports.isResponseWithResult(res)) {
            (_a6 = this._requests.get(res.id)) === null || _a6 === void 0 ? void 0 : _a6.promise.resolve(res.result);
          } else if (json_rpc_exports.isResponseWithError(res)) {
            (_b3 = this._requests.get(res.id)) === null || _b3 === void 0 ? void 0 : _b3.promise.reject(res.error);
          }
        }
        promise.resolve(response);
      });
    }
    _abortAllRequests(msg) {
      for (const { promise } of this._requests.values()) {
        promise.reject(new OperationAbortError(msg));
      }
    }
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_context.js
  var __awaiter14 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Web3Context = class _Web3Context extends Web3Config {
    constructor(providerOrContext) {
      var _a6;
      super();
      this.providers = Web3RequestManager.providers;
      if (isNullish2(providerOrContext) || typeof providerOrContext === "string" && providerOrContext.trim() !== "" || isSupportedProvider(providerOrContext)) {
        this._requestManager = new Web3RequestManager(providerOrContext);
        this._subscriptionManager = new Web3SubscriptionManager(this._requestManager, {});
        return;
      }
      const { config, provider, requestManager, subscriptionManager, registeredSubscriptions: registeredSubscriptions2, accountProvider, wallet } = providerOrContext;
      this.setConfig(config !== null && config !== void 0 ? config : {});
      this._requestManager = requestManager !== null && requestManager !== void 0 ? requestManager : new Web3RequestManager(provider, (_a6 = config === null || config === void 0 ? void 0 : config.enableExperimentalFeatures) === null || _a6 === void 0 ? void 0 : _a6.useSubscriptionWhenCheckingBlockTimeout);
      if (subscriptionManager) {
        this._subscriptionManager = subscriptionManager;
      } else {
        this._subscriptionManager = new Web3SubscriptionManager(this.requestManager, registeredSubscriptions2 !== null && registeredSubscriptions2 !== void 0 ? registeredSubscriptions2 : {});
      }
      if (accountProvider) {
        this._accountProvider = accountProvider;
      }
      if (wallet) {
        this._wallet = wallet;
      }
    }
    get requestManager() {
      return this._requestManager;
    }
    /**
     * Will return the current subscriptionManager ({@link Web3SubscriptionManager})
     */
    get subscriptionManager() {
      return this._subscriptionManager;
    }
    get wallet() {
      return this._wallet;
    }
    get accountProvider() {
      return this._accountProvider;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromContextObject(...args) {
      return new this(...args.reverse());
    }
    getContextObject() {
      var _a6;
      return {
        config: this.config,
        provider: this.provider,
        requestManager: this.requestManager,
        subscriptionManager: this.subscriptionManager,
        registeredSubscriptions: (_a6 = this.subscriptionManager) === null || _a6 === void 0 ? void 0 : _a6.registeredSubscriptions,
        providers: this.providers,
        wallet: this.wallet,
        accountProvider: this.accountProvider
      };
    }
    /**
     * Use to create new object of any type extended by `Web3Context`
     * and link it to current context. This can be used to initiate a global context object
     * and then use it to create new objects of any type extended by `Web3Context`.
     */
    use(ContextRef, ...args) {
      const newContextChild = new ContextRef(...[...args, this.getContextObject()]);
      this.on(Web3ConfigEvent.CONFIG_CHANGE, (event) => {
        newContextChild.setConfig({ [event.name]: event.newValue });
      });
      return newContextChild;
    }
    /**
     * Link current context to another context.
     */
    link(parentContext) {
      this.setConfig(parentContext.config);
      this._requestManager = parentContext.requestManager;
      this.provider = parentContext.provider;
      this._subscriptionManager = parentContext.subscriptionManager;
      this._wallet = parentContext.wallet;
      this._accountProvider = parentContext._accountProvider;
      parentContext.on(Web3ConfigEvent.CONFIG_CHANGE, (event) => {
        this.setConfig({ [event.name]: event.newValue });
      });
    }
    // eslint-disable-next-line no-use-before-define
    registerPlugin(plugin) {
      if (this[plugin.pluginNamespace] !== void 0)
        throw new ExistingPluginNamespaceError(plugin.pluginNamespace);
      const _pluginObject = {
        [plugin.pluginNamespace]: plugin
      };
      _pluginObject[plugin.pluginNamespace].link(this);
      Object.assign(this, _pluginObject);
    }
    /**
     * Will return the current provider.
     *
     * @returns Returns the current provider
     * @example
     * ```ts
     * const web3 = new Web3Context("http://localhost:8545");
     * console.log(web3.provider);
     * > HttpProvider {
     * 	clientUrl: 'http://localhost:8545',
     * 	httpProviderOptions: undefined
     *  }
     * ```
     */
    get provider() {
      return this.currentProvider;
    }
    /**
     * Will set the current provider.
     *
     * @param provider - The provider to set
     *
     * Accepted providers are of type {@link SupportedProviders}
     * @example
     * ```ts
     *  const web3Context = new web3ContextContext("http://localhost:8545");
     * web3Context.provider = "ws://localhost:8545";
     * console.log(web3Context.provider);
     * > WebSocketProvider {
     * _eventEmitter: EventEmitter {
     * _events: [Object: null prototype] {},
     * _eventsCount: 0,
     * ...
     * }
     * ```
     */
    set provider(provider) {
      this.requestManager.setProvider(provider);
    }
    /**
     * Will return the current provider. (The same as `provider`)
     *
     * @returns Returns the current provider
     * @example
     * ```ts
     * const web3Context = new Web3Context("http://localhost:8545");
     * console.log(web3Context.provider);
     * > HttpProvider {
     * 	clientUrl: 'http://localhost:8545',
     * 	httpProviderOptions: undefined
     *  }
     * ```
     */
    get currentProvider() {
      return this.requestManager.provider;
    }
    /**
     * Will set the current provider. (The same as `provider`)
     *
     * @param provider - {@link SupportedProviders} The provider to set
     *
     * @example
     * ```ts
     *  const web3Context = new Web3Context("http://localhost:8545");
     * web3Context.currentProvider = "ws://localhost:8545";
     * console.log(web3Context.provider);
     * > WebSocketProvider {
     * _eventEmitter: EventEmitter {
     * _events: [Object: null prototype] {},
     * _eventsCount: 0,
     * ...
     * }
     * ```
     */
    set currentProvider(provider) {
      this.requestManager.setProvider(provider);
    }
    /**
     * Will return the givenProvider if available.
     *
     * When using web3.js in an Ethereum compatible browser, it will set with the current native provider by that browser. Will return the given provider by the (browser) environment, otherwise `undefined`.
     */
    // eslint-disable-next-line class-methods-use-this
    get givenProvider() {
      return _Web3Context.givenProvider;
    }
    /**
     * Will set the provider.
     *
     * @param provider - {@link SupportedProviders} The provider to set
     * @returns Returns true if the provider was set
     */
    setProvider(provider) {
      this.provider = provider;
      return true;
    }
    /**
     * Will return the {@link Web3BatchRequest} constructor.
     */
    get BatchRequest() {
      return Web3BatchRequest.bind(void 0, this._requestManager);
    }
    /**
     * This method allows extending the web3 modules.
     * Note: This method is only for backward compatibility, and It is recommended to use Web3 v4 Plugin feature for extending web3.js functionality if you are developing some thing new.
     */
    extend(extendObj) {
      var _a6;
      if (extendObj.property && !this[extendObj.property])
        this[extendObj.property] = {};
      (_a6 = extendObj.methods) === null || _a6 === void 0 ? void 0 : _a6.forEach((element) => {
        const method = (...givenParams) => __awaiter14(this, void 0, void 0, function* () {
          return this.requestManager.send({
            method: element.call,
            params: givenParams
          });
        });
        if (extendObj.property)
          this[extendObj.property][element.name] = method;
        else
          this[element.name] = method;
      });
      return this;
    }
  };
  Web3Context.providers = Web3RequestManager.providers;

  // ../../node_modules/.pnpm/web3-eth-iban@4.0.7/node_modules/web3-eth-iban/lib/esm/iban.js
  var Iban = class _Iban {
    /**
     * Construct a direct or indirect IBAN that has conversion methods and validity checks.
     * If the provided string was not of either the length of a direct IBAN (34 or 35),
     * nor the length of an indirect IBAN (20), an Error will be thrown ('Invalid IBAN was provided').
     *
     * @param iban - a Direct or an Indirect IBAN
     * @returns - Iban instance
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS");
     * > Iban { _iban: 'XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS' }
     * ```
     */
    constructor(iban) {
      this.toAddress = () => {
        if (this.isDirect()) {
          const base36 = this._iban.slice(4);
          const parsedBigInt = _Iban._parseInt(base36, 36);
          const paddedBigInt = leftPad(parsedBigInt, 40);
          return toChecksumAddress(paddedBigInt);
        }
        throw new Error("Iban is indirect and cannot be converted. Must be length of 34 or 35");
      };
      if (_Iban.isIndirect(iban) || _Iban.isDirect(iban)) {
        this._iban = iban;
      } else {
        throw new Error("Invalid IBAN was provided");
      }
    }
    /**
     * A static method that checks if an IBAN is Direct.
     * It actually check the length of the provided variable and, only if it is 34 or 35, it returns true.
     * Note: this is also available as a method at an Iban instance.
     * @param iban - an IBAN to be checked
     * @returns - `true` if the provided `iban` is a Direct IBAN, and `false` otherwise.
     *
     * @example
     * ```ts
     * web3.eth.Iban.isDirect("XE81ETHXREGGAVOFYORK");
     * > false
     * ```
     */
    static isDirect(iban) {
      return iban.length === 34 || iban.length === 35;
    }
    /**
     * An instance method that checks if iban number is Direct.
     * It actually check the length of the provided variable and, only if it is 34 or 35, it returns true.
     * Note: this is also available as a static method.
     * @param iban - an IBAN to be checked
     * @returns - `true` if the provided `iban` is a Direct IBAN, and `false` otherwise.
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE81ETHXREGGAVOFYORK");
     * iban.isDirect();
     * > false
     * ```
     */
    isDirect() {
      return _Iban.isDirect(this._iban);
    }
    /**
     * A static method that checks if an IBAN is Indirect.
     * It actually check the length of the provided variable and, only if it is 20, it returns true.
     * Note: this is also available as a method at an Iban instance.
     * @param iban - an IBAN to be checked
     * @returns - `true` if the provided `iban` is an Indirect IBAN, and `false` otherwise.
     *
     * @example
     * ```ts
     * web3.eth.Iban.isIndirect("XE81ETHXREGGAVOFYORK");
     * > true
     * ```
     */
    static isIndirect(iban) {
      return iban.length === 20;
    }
    /**
     * check if iban number if indirect
     * It actually check the length of the provided variable and, only if it is 20, it returns true.
     * Note: this is also available as a static method.
     * @param iban - an IBAN to be checked
     * @returns - `true` if the provided `iban` is an Indirect IBAN, and `false` otherwise.
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE81ETHXREGGAVOFYORK");
     * iban.isIndirect();
     * > true
     * ```
     */
    isIndirect() {
      return _Iban.isIndirect(this._iban);
    }
    /**
     * This method could be used to check if a given string is valid IBAN object.
     * Note: this is also available as a method at an Iban instance.
     *
     * @param iban - a string to be checked if it is in IBAN
     * @returns - true if it is valid IBAN
     *
     * @example
     * ```ts
     * web3.eth.Iban.isValid("XE81ETHXREGGAVOFYORK");
     * > true
     *
     * web3.eth.Iban.isValid("XE82ETHXREGGAVOFYORK");
     * > false // because the checksum is incorrect
     * ```
     */
    static isValid(iban) {
      return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(iban) && _Iban._mod9710(_Iban._iso13616Prepare(iban)) === 1;
    }
    /**
     * Should be called to check if the early provided IBAN is correct.
     * Note: this is also available as a static method.
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE81ETHXREGGAVOFYORK");
     * iban.isValid();
     * > true
     *
     * const iban = new web3.eth.Iban("XE82ETHXREGGAVOFYORK");
     * iban.isValid();
     * > false // because the checksum is incorrect
     * ```
     */
    isValid() {
      return _Iban.isValid(this._iban);
    }
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @param bban - the BBAN to convert to IBAN
     * @returns an Iban class instance that holds the equivalent IBAN
     *
     * @example
     * ```ts
     * web3.eth.Iban.fromBban('ETHXREGGAVOFYORK');
     * > Iban {_iban: "XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS"}
     * ```
     */
    static fromBban(bban) {
      const countryCode = "XE";
      const remainder = this._mod9710(this._iso13616Prepare(`${countryCode}00${bban}`));
      const checkDigit = `0${(98 - remainder).toString()}`.slice(-2);
      return new _Iban(`${countryCode}${checkDigit}${bban}`);
    }
    /**
     * Should be used to create IBAN object for given institution and identifier
     *
     * @param options - an object holds the `institution` and the `identifier` which will be composed to create an `Iban` object from.
     * @returns an Iban class instance that holds the equivalent IBAN
     *
     * @example
     * ```ts
     * web3.eth.Iban.createIndirect({
     *     institution: "XREG",
     *     identifier: "GAVOFYORK"
     * });
     * > Iban {_iban: "XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS"}
     * ```
     */
    static createIndirect(options) {
      return _Iban.fromBban(`ETH${options.institution}${options.identifier}`);
    }
    /**
     * This method should be used to create iban object from an Ethereum address.
     *
     * @param address - an Ethereum address
     * @returns an Iban class instance that holds the equivalent IBAN
     *
     * @example
     * ```ts
     * web3.eth.Iban.fromAddress("0x00c5496aEe77C1bA1f0854206A26DdA82a81D6D8");
     * > Iban {_iban: "XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS"}
     * ```
     */
    static fromAddress(address) {
      if (!isAddress(address)) {
        throw new InvalidAddressError(address);
      }
      const num = BigInt(hexToNumber2(address));
      const base36 = num.toString(36);
      const padded = leftPad(base36, 15);
      return _Iban.fromBban(padded.toUpperCase());
    }
    /**
     * This method should be used to create IBAN address from an Ethereum address
     *
     * @param address - an Ethereum address
     * @return the equivalent IBAN address
     *
     * @example
     * ```ts
     * web3.eth.Iban.toIban("0x00c5496aEe77C1bA1f0854206A26DdA82a81D6D8");
     * > "XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS"
     * ```
     */
    static toIban(address) {
      return _Iban.fromAddress(address).toString();
    }
    /**
     * Should be called to get client identifier within institution
     *
     * @return the client of the IBAN instance.
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE81ETHXREGGAVOFYORK");
     * iban.client();
     * > 'GAVOFYORK'
     * ```
     */
    client() {
      return this.isIndirect() ? this._iban.slice(11) : "";
    }
    /**
     * Returns the IBAN checksum of the early provided IBAN
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE81ETHXREGGAVOFYORK");
     * iban.checksum();
     * > "81"
     * ```
     *
     */
    checksum() {
      return this._iban.slice(2, 4);
    }
    /**
     * Returns institution identifier from the early provided  IBAN
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban("XE81ETHXREGGAVOFYORK");
     * iban.institution();
     * > 'XREG'
     * ```
     */
    institution() {
      return this.isIndirect() ? this._iban.slice(7, 11) : "";
    }
    /**
     * Simply returns the early provided IBAN
     *
     * @example
     * ```ts
     * const iban = new web3.eth.Iban('XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS');
     * iban.toString();
     * > 'XE7338O073KYGTWWZN0F2WZ0R8PX5ZPPZS'
     * ```
     */
    toString() {
      return this._iban;
    }
  };
  Iban._iso13616Prepare = (iban) => {
    const A = "A".charCodeAt(0);
    const Z = "Z".charCodeAt(0);
    const upperIban = iban.toUpperCase();
    const modifiedIban = `${upperIban.slice(4)}${upperIban.slice(0, 4)}`;
    return modifiedIban.split("").map((n2) => {
      const code = n2.charCodeAt(0);
      if (code >= A && code <= Z) {
        return code - A + 10;
      }
      return n2;
    }).join("");
  };
  Iban._parseInt = (str, base2) => [...str].reduce((acc, curr) => BigInt(parseInt(curr, base2)) + BigInt(base2) * acc, BigInt(0));
  Iban._mod9710 = (iban) => {
    let remainder = iban;
    let block;
    while (remainder.length > 2) {
      block = remainder.slice(0, 9);
      remainder = `${(parseInt(block, 10) % 97).toString()}${remainder.slice(block.length)}`;
    }
    return parseInt(remainder, 10) % 97;
  };
  Iban.toAddress = (iban) => {
    const ibanObject = new Iban(iban);
    return ibanObject.toAddress();
  };

  // ../../node_modules/.pnpm/web3-core@4.3.2_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-core/lib/esm/web3_promi_event.js
  var __awaiter15 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var _a4;
  var Web3PromiEvent = class extends Web3EventEmitter {
    constructor(executor) {
      super();
      this[_a4] = "Promise";
      this._promise = new Promise(executor);
    }
    then(onfulfilled, onrejected) {
      return __awaiter15(this, void 0, void 0, function* () {
        return this._promise.then(onfulfilled, onrejected);
      });
    }
    catch(onrejected) {
      return __awaiter15(this, void 0, void 0, function* () {
        return this._promise.catch(onrejected);
      });
    }
    finally(onfinally) {
      return __awaiter15(this, void 0, void 0, function* () {
        return this._promise.finally(onfinally);
      });
    }
    on(eventName, fn) {
      super.on(eventName, fn);
      return this;
    }
    once(eventName, fn) {
      super.once(eventName, fn);
      return this;
    }
  };
  _a4 = Symbol.toStringTag;

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/index.js
  var import_setimmediate = __toESM(require_setImmediate(), 1);

  // ../../node_modules/.pnpm/web3-rpc-methods@1.1.4_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-rpc-methods/lib/esm/eth_rpc_methods.js
  var eth_rpc_methods_exports = {};
  __export(eth_rpc_methods_exports, {
    call: () => call,
    compileLLL: () => compileLLL,
    compileSerpent: () => compileSerpent,
    compileSolidity: () => compileSolidity,
    createAccessList: () => createAccessList,
    estimateGas: () => estimateGas,
    getAccounts: () => getAccounts,
    getBalance: () => getBalance,
    getBlockByHash: () => getBlockByHash,
    getBlockByNumber: () => getBlockByNumber,
    getBlockNumber: () => getBlockNumber,
    getBlockTransactionCountByHash: () => getBlockTransactionCountByHash,
    getBlockTransactionCountByNumber: () => getBlockTransactionCountByNumber,
    getChainId: () => getChainId,
    getCode: () => getCode,
    getCoinbase: () => getCoinbase,
    getCompilers: () => getCompilers,
    getFeeHistory: () => getFeeHistory,
    getFilterChanges: () => getFilterChanges,
    getFilterLogs: () => getFilterLogs,
    getGasPrice: () => getGasPrice,
    getHashRate: () => getHashRate,
    getLogs: () => getLogs,
    getMining: () => getMining,
    getNodeInfo: () => getNodeInfo,
    getPendingTransactions: () => getPendingTransactions,
    getProof: () => getProof,
    getProtocolVersion: () => getProtocolVersion,
    getStorageAt: () => getStorageAt,
    getSyncing: () => getSyncing,
    getTransactionByBlockHashAndIndex: () => getTransactionByBlockHashAndIndex,
    getTransactionByBlockNumberAndIndex: () => getTransactionByBlockNumberAndIndex,
    getTransactionByHash: () => getTransactionByHash,
    getTransactionCount: () => getTransactionCount,
    getTransactionReceipt: () => getTransactionReceipt,
    getUncleByBlockHashAndIndex: () => getUncleByBlockHashAndIndex,
    getUncleByBlockNumberAndIndex: () => getUncleByBlockNumberAndIndex,
    getUncleCountByBlockHash: () => getUncleCountByBlockHash,
    getUncleCountByBlockNumber: () => getUncleCountByBlockNumber,
    getWork: () => getWork,
    newBlockFilter: () => newBlockFilter,
    newFilter: () => newFilter,
    newPendingTransactionFilter: () => newPendingTransactionFilter,
    requestAccounts: () => requestAccounts,
    sendRawTransaction: () => sendRawTransaction,
    sendTransaction: () => sendTransaction,
    sign: () => sign2,
    signTransaction: () => signTransaction2,
    signTypedData: () => signTypedData,
    submitHashrate: () => submitHashrate,
    submitWork: () => submitWork,
    uninstallFilter: () => uninstallFilter
  });
  var __awaiter16 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function getProtocolVersion(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_protocolVersion",
        params: []
      });
    });
  }
  function getSyncing(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_syncing",
        params: []
      });
    });
  }
  function getCoinbase(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_coinbase",
        params: []
      });
    });
  }
  function getMining(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_mining",
        params: []
      });
    });
  }
  function getHashRate(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_hashrate",
        params: []
      });
    });
  }
  function getGasPrice(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_gasPrice",
        params: []
      });
    });
  }
  function getAccounts(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_accounts",
        params: []
      });
    });
  }
  function getBlockNumber(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_blockNumber",
        params: []
      });
    });
  }
  function getBalance(requestManager, address, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address", "blockNumberOrTag"], [address, blockNumber]);
      return requestManager.send({
        method: "eth_getBalance",
        params: [address, blockNumber]
      });
    });
  }
  function getStorageAt(requestManager, address, storageSlot, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address", "hex", "blockNumberOrTag"], [address, storageSlot, blockNumber]);
      return requestManager.send({
        method: "eth_getStorageAt",
        params: [address, storageSlot, blockNumber]
      });
    });
  }
  function getTransactionCount(requestManager, address, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address", "blockNumberOrTag"], [address, blockNumber]);
      return requestManager.send({
        method: "eth_getTransactionCount",
        params: [address, blockNumber]
      });
    });
  }
  function getBlockTransactionCountByHash(requestManager, blockHash) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32"], [blockHash]);
      return requestManager.send({
        method: "eth_getBlockTransactionCountByHash",
        params: [blockHash]
      });
    });
  }
  function getBlockTransactionCountByNumber(requestManager, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag"], [blockNumber]);
      return requestManager.send({
        method: "eth_getBlockTransactionCountByNumber",
        params: [blockNumber]
      });
    });
  }
  function getUncleCountByBlockHash(requestManager, blockHash) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32"], [blockHash]);
      return requestManager.send({
        method: "eth_getUncleCountByBlockHash",
        params: [blockHash]
      });
    });
  }
  function getUncleCountByBlockNumber(requestManager, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag"], [blockNumber]);
      return requestManager.send({
        method: "eth_getUncleCountByBlockNumber",
        params: [blockNumber]
      });
    });
  }
  function getCode(requestManager, address, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address", "blockNumberOrTag"], [address, blockNumber]);
      return requestManager.send({
        method: "eth_getCode",
        params: [address, blockNumber]
      });
    });
  }
  function sign2(requestManager, address, message) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address", "hex"], [address, message]);
      return requestManager.send({
        method: "eth_sign",
        params: [address, message]
      });
    });
  }
  function signTransaction2(requestManager, transaction) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_signTransaction",
        params: [transaction]
      });
    });
  }
  function sendTransaction(requestManager, transaction) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_sendTransaction",
        params: [transaction]
      });
    });
  }
  function sendRawTransaction(requestManager, transaction) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["hex"], [transaction]);
      return requestManager.send({
        method: "eth_sendRawTransaction",
        params: [transaction]
      });
    });
  }
  function call(requestManager, transaction, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag"], [blockNumber]);
      return requestManager.send({
        method: "eth_call",
        params: [transaction, blockNumber]
      });
    });
  }
  function estimateGas(requestManager, transaction, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag"], [blockNumber]);
      return requestManager.send({
        method: "eth_estimateGas",
        params: [transaction, blockNumber]
      });
    });
  }
  function getBlockByHash(requestManager, blockHash, hydrated) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32", "bool"], [blockHash, hydrated]);
      return requestManager.send({
        method: "eth_getBlockByHash",
        params: [blockHash, hydrated]
      });
    });
  }
  function getBlockByNumber(requestManager, blockNumber, hydrated) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag", "bool"], [blockNumber, hydrated]);
      return requestManager.send({
        method: "eth_getBlockByNumber",
        params: [blockNumber, hydrated]
      });
    });
  }
  function getTransactionByHash(requestManager, transactionHash) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32"], [transactionHash]);
      return requestManager.send({
        method: "eth_getTransactionByHash",
        params: [transactionHash]
      });
    });
  }
  function getTransactionByBlockHashAndIndex(requestManager, blockHash, transactionIndex) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32", "hex"], [blockHash, transactionIndex]);
      return requestManager.send({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [blockHash, transactionIndex]
      });
    });
  }
  function getTransactionByBlockNumberAndIndex(requestManager, blockNumber, transactionIndex) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag", "hex"], [blockNumber, transactionIndex]);
      return requestManager.send({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [blockNumber, transactionIndex]
      });
    });
  }
  function getTransactionReceipt(requestManager, transactionHash) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32"], [transactionHash]);
      return requestManager.send({
        method: "eth_getTransactionReceipt",
        params: [transactionHash]
      });
    });
  }
  function getUncleByBlockHashAndIndex(requestManager, blockHash, uncleIndex) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32", "hex"], [blockHash, uncleIndex]);
      return requestManager.send({
        method: "eth_getUncleByBlockHashAndIndex",
        params: [blockHash, uncleIndex]
      });
    });
  }
  function getUncleByBlockNumberAndIndex(requestManager, blockNumber, uncleIndex) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag", "hex"], [blockNumber, uncleIndex]);
      return requestManager.send({
        method: "eth_getUncleByBlockNumberAndIndex",
        params: [blockNumber, uncleIndex]
      });
    });
  }
  function getCompilers(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_getCompilers",
        params: []
      });
    });
  }
  function compileSolidity(requestManager, code) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["string"], [code]);
      return requestManager.send({
        method: "eth_compileSolidity",
        params: [code]
      });
    });
  }
  function compileLLL(requestManager, code) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["string"], [code]);
      return requestManager.send({
        method: "eth_compileLLL",
        params: [code]
      });
    });
  }
  function compileSerpent(requestManager, code) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["string"], [code]);
      return requestManager.send({
        method: "eth_compileSerpent",
        params: [code]
      });
    });
  }
  function newFilter(requestManager, filter2) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["filter"], [filter2]);
      return requestManager.send({
        method: "eth_newFilter",
        params: [filter2]
      });
    });
  }
  function newBlockFilter(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_newBlockFilter",
        params: []
      });
    });
  }
  function newPendingTransactionFilter(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_newPendingTransactionFilter",
        params: []
      });
    });
  }
  function uninstallFilter(requestManager, filterIdentifier) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["hex"], [filterIdentifier]);
      return requestManager.send({
        method: "eth_uninstallFilter",
        params: [filterIdentifier]
      });
    });
  }
  function getFilterChanges(requestManager, filterIdentifier) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["hex"], [filterIdentifier]);
      return requestManager.send({
        method: "eth_getFilterChanges",
        params: [filterIdentifier]
      });
    });
  }
  function getFilterLogs(requestManager, filterIdentifier) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["hex"], [filterIdentifier]);
      return requestManager.send({
        method: "eth_getFilterLogs",
        params: [filterIdentifier]
      });
    });
  }
  function getLogs(requestManager, filter2) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["filter"], [filter2]);
      return requestManager.send({
        method: "eth_getLogs",
        params: [filter2]
      });
    });
  }
  function getWork(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_getWork",
        params: []
      });
    });
  }
  function submitWork(requestManager, nonce, hash2, digest) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes8", "bytes32", "bytes32"], [nonce, hash2, digest]);
      return requestManager.send({
        method: "eth_submitWork",
        params: [nonce, hash2, digest]
      });
    });
  }
  function submitHashrate(requestManager, hashRate, id) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["bytes32", "bytes32"], [hashRate, id]);
      return requestManager.send({
        method: "eth_submitHashrate",
        params: [hashRate, id]
      });
    });
  }
  function getFeeHistory(requestManager, blockCount, newestBlock, rewardPercentiles) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["hex", "blockNumberOrTag"], [blockCount, newestBlock]);
      for (const rewardPercentile of rewardPercentiles) {
        validator.validate(["number"], [rewardPercentile]);
      }
      return requestManager.send({
        method: "eth_feeHistory",
        params: [blockCount, newestBlock, rewardPercentiles]
      });
    });
  }
  function getPendingTransactions(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_pendingTransactions",
        params: []
      });
    });
  }
  function requestAccounts(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_requestAccounts",
        params: []
      });
    });
  }
  function getChainId(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "eth_chainId",
        params: []
      });
    });
  }
  function getProof(requestManager, address, storageKeys, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address", "bytes32[]", "blockNumberOrTag"], [address, storageKeys, blockNumber]);
      return requestManager.send({
        method: "eth_getProof",
        params: [address, storageKeys, blockNumber]
      });
    });
  }
  function getNodeInfo(requestManager) {
    return __awaiter16(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "web3_clientVersion",
        params: []
      });
    });
  }
  function createAccessList(requestManager, transaction, blockNumber) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["blockNumberOrTag"], [blockNumber]);
      return requestManager.send({
        method: "eth_createAccessList",
        params: [transaction, blockNumber]
      });
    });
  }
  function signTypedData(requestManager, address, typedData, useLegacy = false) {
    return __awaiter16(this, void 0, void 0, function* () {
      validator.validate(["address"], [address]);
      return requestManager.send({
        method: `eth_signTypedData${useLegacy ? "" : "_v4"}`,
        params: [address, typedData]
      });
    });
  }

  // ../../node_modules/.pnpm/web3-rpc-methods@1.1.4_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-rpc-methods/lib/esm/net_rpc_methods.js
  var net_rpc_methods_exports = {};
  __export(net_rpc_methods_exports, {
    getId: () => getId,
    getPeerCount: () => getPeerCount,
    isListening: () => isListening
  });
  var __awaiter17 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function getId(requestManager) {
    return __awaiter17(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "net_version",
        params: []
      });
    });
  }
  function getPeerCount(requestManager) {
    return __awaiter17(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "net_peerCount",
        params: []
      });
    });
  }
  function isListening(requestManager) {
    return __awaiter17(this, void 0, void 0, function* () {
      return requestManager.send({
        method: "net_listening",
        params: []
      });
    });
  }

  // ../../node_modules/.pnpm/web3-rpc-methods@1.1.4_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-rpc-methods/lib/esm/personal_rpc_methods.js
  var personal_rpc_methods_exports = {};
  __export(personal_rpc_methods_exports, {
    ecRecover: () => ecRecover,
    getAccounts: () => getAccounts2,
    importRawKey: () => importRawKey,
    lockAccount: () => lockAccount,
    newAccount: () => newAccount,
    sendTransaction: () => sendTransaction2,
    sign: () => sign3,
    signTransaction: () => signTransaction3,
    unlockAccount: () => unlockAccount
  });
  var __awaiter18 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var getAccounts2 = (requestManager) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_listAccounts",
      params: []
    });
  });
  var newAccount = (requestManager, password) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_newAccount",
      params: [password]
    });
  });
  var unlockAccount = (requestManager, address, password, unlockDuration) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_unlockAccount",
      params: [address, password, unlockDuration]
    });
  });
  var lockAccount = (requestManager, address) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_lockAccount",
      params: [address]
    });
  });
  var importRawKey = (requestManager, keyData, passphrase) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_importRawKey",
      params: [keyData, passphrase]
    });
  });
  var sendTransaction2 = (requestManager, tx, passphrase) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_sendTransaction",
      params: [tx, passphrase]
    });
  });
  var signTransaction3 = (requestManager, tx, passphrase) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_signTransaction",
      params: [tx, passphrase]
    });
  });
  var sign3 = (requestManager, data, address, passphrase) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_sign",
      params: [data, address, passphrase]
    });
  });
  var ecRecover = (requestManager, signedData, signature) => __awaiter18(void 0, void 0, void 0, function* () {
    return requestManager.send({
      method: "personal_ecRecover",
      params: [signedData, signature]
    });
  });

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/detect_transaction_type.js
  var transactionType0x0Schema = {
    type: "object",
    properties: {
      accessList: {
        type: "null"
      },
      maxFeePerGas: {
        type: "null"
      },
      maxPriorityFeePerGas: {
        type: "null"
      }
    }
  };
  var transactionType0x1Schema = {
    type: "object",
    properties: {
      maxFeePerGas: {
        type: "null"
      },
      maxPriorityFeePerGas: {
        type: "null"
      }
    }
  };
  var transactionType0x2Schema = {
    type: "object",
    properties: {
      gasPrice: {
        type: "null"
      }
    }
  };
  var validateTxTypeAndHandleErrors = (txSchema, tx, txType) => {
    try {
      validator.validateJSONSchema(txSchema, tx);
    } catch (error) {
      if (error instanceof Web3ValidatorError)
        throw new InvalidPropertiesForTransactionTypeError(error.errors, txType);
      throw error;
    }
  };
  var defaultTransactionTypeParser = (transaction) => {
    var _a6, _b3;
    const tx = transaction;
    if (!isNullish(tx.type)) {
      let txSchema;
      switch (tx.type) {
        case "0x0":
          txSchema = transactionType0x0Schema;
          break;
        case "0x1":
          txSchema = transactionType0x1Schema;
          break;
        case "0x2":
          txSchema = transactionType0x2Schema;
          break;
        default:
          return format4({ format: "uint" }, tx.type, ETH_DATA_FORMAT);
      }
      validateTxTypeAndHandleErrors(txSchema, tx, tx.type);
      return format4({ format: "uint" }, tx.type, ETH_DATA_FORMAT);
    }
    if (!isNullish(tx.maxFeePerGas) || !isNullish(tx.maxPriorityFeePerGas)) {
      validateTxTypeAndHandleErrors(transactionType0x2Schema, tx, "0x2");
      return "0x2";
    }
    if (!isNullish(tx.accessList)) {
      validateTxTypeAndHandleErrors(transactionType0x1Schema, tx, "0x1");
      return "0x1";
    }
    const givenHardfork = (_a6 = tx.hardfork) !== null && _a6 !== void 0 ? _a6 : (_b3 = tx.common) === null || _b3 === void 0 ? void 0 : _b3.hardfork;
    if (!isNullish(givenHardfork)) {
      const hardforkIndex = Object.keys(HardforksOrdered).indexOf(givenHardfork);
      if (hardforkIndex >= Object.keys(HardforksOrdered).indexOf("london"))
        return !isNullish(tx.gasPrice) ? "0x0" : "0x2";
      if (hardforkIndex === Object.keys(HardforksOrdered).indexOf("berlin"))
        return "0x0";
    }
    if (!isNullish(tx.gasPrice)) {
      validateTxTypeAndHandleErrors(transactionType0x0Schema, tx, "0x0");
      return "0x0";
    }
    return void 0;
  };
  var detectTransactionType = (transaction, web3Context) => {
    var _a6;
    return ((_a6 = web3Context === null || web3Context === void 0 ? void 0 : web3Context.transactionTypeParser) !== null && _a6 !== void 0 ? _a6 : defaultTransactionTypeParser)(transaction);
  };
  var detectRawTransactionType = (transaction) => transaction[0] > 127 ? "0x0" : toHex(transaction[0]);

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/schemas.js
  var accessListItemSchema = {
    type: "object",
    properties: {
      address: {
        format: "address"
      },
      storageKeys: {
        type: "array",
        items: {
          format: "bytes32"
        }
      }
    }
  };
  var accessListSchema = {
    type: "array",
    items: Object.assign({}, accessListItemSchema)
  };
  var accessListResultSchema = {
    type: "object",
    properties: {
      accessList: Object.assign({}, accessListSchema),
      gasUsed: {
        type: "string"
      }
    }
  };
  var chainSchema = {
    type: "string",
    enum: ["goerli", "kovan", "mainnet", "rinkeby", "ropsten", "sepolia"]
  };
  var hardforkSchema = {
    type: "string",
    enum: [
      "arrowGlacier",
      "berlin",
      "byzantium",
      "chainstart",
      "constantinople",
      "dao",
      "homestead",
      "istanbul",
      "london",
      "merge",
      "muirGlacier",
      "petersburg",
      "shanghai",
      "spuriousDragon",
      "tangerineWhistle"
    ]
  };
  var customChainSchema = {
    type: "object",
    properties: {
      name: {
        format: "string"
      },
      networkId: {
        format: "uint"
      },
      chainId: {
        format: "uint"
      }
    }
  };
  var transactionSchema = {
    type: "object",
    properties: {
      from: {
        format: "address"
      },
      to: {
        oneOf: [{ format: "address" }, { type: "null" }]
      },
      value: {
        format: "uint"
      },
      gas: {
        format: "uint"
      },
      gasPrice: {
        format: "uint"
      },
      effectiveGasPrice: {
        format: "uint"
      },
      type: {
        format: "uint"
      },
      maxFeePerGas: {
        format: "uint"
      },
      maxPriorityFeePerGas: {
        format: "uint"
      },
      accessList: Object.assign({}, accessListSchema),
      data: {
        format: "bytes"
      },
      input: {
        format: "bytes"
      },
      nonce: {
        format: "uint"
      },
      chain: Object.assign({}, chainSchema),
      hardfork: Object.assign({}, hardforkSchema),
      chainId: {
        format: "uint"
      },
      networkId: {
        format: "uint"
      },
      common: {
        type: "object",
        properties: {
          customChain: Object.assign({}, customChainSchema),
          baseChain: Object.assign({}, chainSchema),
          hardfork: Object.assign({}, hardforkSchema)
        }
      },
      gasLimit: {
        format: "uint"
      },
      v: {
        format: "uint"
      },
      r: {
        format: "bytes32"
      },
      s: {
        format: "bytes32"
      }
    }
  };
  var transactionInfoSchema = {
    type: "object",
    properties: Object.assign(Object.assign({}, transactionSchema.properties), { blockHash: {
      format: "bytes32"
    }, blockNumber: {
      format: "uint"
    }, hash: {
      format: "bytes32"
    }, transactionIndex: {
      format: "uint"
    }, from: {
      format: "address"
    }, to: {
      oneOf: [{ format: "address" }, { type: "null" }]
    }, value: {
      format: "uint"
    }, gas: {
      format: "uint"
    }, gasPrice: {
      format: "uint"
    }, effectiveGasPrice: {
      format: "uint"
    }, type: {
      format: "uint"
    }, maxFeePerGas: {
      format: "uint"
    }, maxPriorityFeePerGas: {
      format: "uint"
    }, accessList: Object.assign({}, accessListSchema), data: {
      format: "bytes"
    }, input: {
      format: "bytes"
    }, nonce: {
      format: "uint"
    }, gasLimit: {
      format: "uint"
    }, v: {
      format: "uint"
    }, r: {
      format: "bytes32"
    }, s: {
      format: "bytes32"
    } })
  };
  var blockSchema = {
    type: "object",
    properties: {
      parentHash: {
        format: "bytes32"
      },
      sha3Uncles: {
        format: "bytes32"
      },
      miner: {
        format: "bytes"
      },
      stateRoot: {
        format: "bytes32"
      },
      transactionsRoot: {
        format: "bytes32"
      },
      receiptsRoot: {
        format: "bytes32"
      },
      logsBloom: {
        format: "bytes256"
      },
      difficulty: {
        format: "uint"
      },
      number: {
        format: "uint"
      },
      gasLimit: {
        format: "uint"
      },
      gasUsed: {
        format: "uint"
      },
      timestamp: {
        format: "uint"
      },
      extraData: {
        format: "bytes"
      },
      mixHash: {
        format: "bytes32"
      },
      nonce: {
        format: "uint"
      },
      totalDifficulty: {
        format: "uint"
      },
      baseFeePerGas: {
        format: "uint"
      },
      size: {
        format: "uint"
      },
      transactions: {
        oneOf: [
          {
            type: "array",
            items: Object.assign({}, transactionInfoSchema)
          },
          {
            type: "array",
            items: {
              format: "bytes32"
            }
          }
        ]
      },
      uncles: {
        type: "array",
        items: {
          format: "bytes32"
        }
      },
      hash: {
        format: "bytes32"
      }
    }
  };
  var withdrawalsSchema = {
    type: "object",
    properties: {
      index: {
        format: "uint"
      },
      validatorIndex: {
        format: "uint"
      },
      address: {
        format: "address"
      },
      amount: {
        format: "uint"
      }
    }
  };
  var blockHeaderSchema = {
    type: "object",
    properties: {
      author: {
        format: "bytes32"
      },
      hash: {
        format: "bytes32"
      },
      parentHash: {
        format: "bytes32"
      },
      receiptsRoot: {
        format: "bytes32"
      },
      miner: {
        format: "bytes"
      },
      stateRoot: {
        format: "bytes32"
      },
      transactionsRoot: {
        format: "bytes32"
      },
      withdrawalsRoot: {
        format: "bytes32"
      },
      logsBloom: {
        format: "bytes256"
      },
      difficulty: {
        format: "uint"
      },
      totalDifficulty: {
        format: "uint"
      },
      number: {
        format: "uint"
      },
      gasLimit: {
        format: "uint"
      },
      gasUsed: {
        format: "uint"
      },
      timestamp: {
        format: "uint"
      },
      extraData: {
        format: "bytes"
      },
      nonce: {
        format: "uint"
      },
      sha3Uncles: {
        format: "bytes32"
      },
      size: {
        format: "uint"
      },
      baseFeePerGas: {
        format: "uint"
      },
      excessDataGas: {
        format: "uint"
      },
      mixHash: {
        format: "bytes32"
      },
      transactions: {
        type: "array",
        items: {
          format: "bytes32"
        }
      },
      uncles: {
        type: "array",
        items: {
          format: "bytes32"
        }
      },
      withdrawals: {
        type: "array",
        items: Object.assign({}, withdrawalsSchema)
      }
    }
  };
  var logSchema = {
    type: "object",
    properties: {
      removed: {
        format: "bool"
      },
      logIndex: {
        format: "uint"
      },
      transactionIndex: {
        format: "uint"
      },
      transactionHash: {
        format: "bytes32"
      },
      blockHash: {
        format: "bytes32"
      },
      blockNumber: {
        format: "uint"
      },
      address: {
        format: "address"
      },
      data: {
        format: "bytes"
      },
      topics: {
        type: "array",
        items: {
          format: "bytes32"
        }
      }
    }
  };
  var syncSchema = {
    type: "object",
    properties: {
      startingBlock: {
        format: "string"
      },
      currentBlock: {
        format: "string"
      },
      highestBlock: {
        format: "string"
      },
      knownStates: {
        format: "string"
      },
      pulledStates: {
        format: "string"
      }
    }
  };
  var transactionReceiptSchema = {
    type: "object",
    properties: {
      transactionHash: {
        format: "bytes32"
      },
      transactionIndex: {
        format: "uint"
      },
      blockHash: {
        format: "bytes32"
      },
      blockNumber: {
        format: "uint"
      },
      from: {
        format: "address"
      },
      to: {
        format: "address"
      },
      cumulativeGasUsed: {
        format: "uint"
      },
      gasUsed: {
        format: "uint"
      },
      effectiveGasPrice: {
        format: "uint"
      },
      contractAddress: {
        format: "address"
      },
      logs: {
        type: "array",
        items: Object.assign({}, logSchema)
      },
      logsBloom: {
        format: "bytes"
      },
      root: {
        format: "bytes"
      },
      status: {
        format: "uint"
      },
      type: {
        format: "uint"
      }
    }
  };
  var SignatureObjectSchema = {
    type: "object",
    properties: {
      messageHash: {
        format: "bytes"
      },
      r: {
        format: "bytes32"
      },
      s: {
        format: "bytes32"
      },
      v: {
        format: "bytes"
      },
      message: {
        format: "bytes"
      },
      signature: {
        format: "bytes"
      }
    }
  };
  var feeHistorySchema = {
    type: "object",
    properties: {
      oldestBlock: {
        format: "uint"
      },
      baseFeePerGas: {
        type: "array",
        items: {
          format: "uint"
        }
      },
      reward: {
        type: "array",
        items: {
          type: "array",
          items: {
            format: "uint"
          }
        }
      },
      gasUsedRatio: {
        type: "array",
        items: {
          type: "number"
        }
      }
    }
  };
  var storageProofSchema = {
    type: "object",
    properties: {
      key: {
        format: "bytes32"
      },
      value: {
        format: "uint"
      },
      proof: {
        type: "array",
        items: {
          format: "bytes32"
        }
      }
    }
  };
  var accountSchema = {
    type: "object",
    properties: {
      balance: {
        format: "uint"
      },
      codeHash: {
        format: "bytes32"
      },
      nonce: {
        format: "uint"
      },
      storageHash: {
        format: "bytes32"
      },
      accountProof: {
        type: "array",
        items: {
          format: "bytes32"
        }
      },
      storageProof: {
        type: "array",
        items: Object.assign({}, storageProofSchema)
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/format_transaction.js
  function formatTransaction(transaction, returnFormat = DEFAULT_RETURN_FORMAT, options = {
    transactionSchema: transactionInfoSchema,
    fillInputAndData: false
  }) {
    var _a6, _b3;
    let formattedTransaction = mergeDeep({}, transaction);
    if (!isNullish(transaction === null || transaction === void 0 ? void 0 : transaction.common)) {
      formattedTransaction.common = Object.assign({}, transaction.common);
      if (!isNullish((_a6 = transaction.common) === null || _a6 === void 0 ? void 0 : _a6.customChain))
        formattedTransaction.common.customChain = Object.assign({}, transaction.common.customChain);
    }
    formattedTransaction = format4((_b3 = options.transactionSchema) !== null && _b3 !== void 0 ? _b3 : transactionInfoSchema, formattedTransaction, returnFormat);
    if (!isNullish(formattedTransaction.data) && !isNullish(formattedTransaction.input) && // Converting toHex is accounting for data and input being Uint8Arrays
    // since comparing Uint8Array is not as straightforward as comparing strings
    toHex(formattedTransaction.data) !== toHex(formattedTransaction.input))
      throw new TransactionDataAndInputError({
        data: bytesToHex2(formattedTransaction.data),
        input: bytesToHex2(formattedTransaction.input)
      });
    if (options.fillInputAndData) {
      if (!isNullish(formattedTransaction.data)) {
        formattedTransaction.input = formattedTransaction.data;
      } else if (!isNullish(formattedTransaction.input)) {
        formattedTransaction.data = formattedTransaction.input;
      }
    }
    if (!isNullish(formattedTransaction.gasLimit)) {
      formattedTransaction.gas = formattedTransaction.gasLimit;
      delete formattedTransaction.gasLimit;
    }
    return formattedTransaction;
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/decode_signed_transaction.js
  function decodeSignedTransaction(encodedSignedTransaction, returnFormat, options = { fillInputAndData: false }) {
    return {
      raw: format4({ format: "bytes" }, encodedSignedTransaction, returnFormat),
      tx: formatTransaction(Object.assign(Object.assign({}, TransactionFactory.fromSerializedData(hexToBytes2(encodedSignedTransaction)).toJSON()), { hash: bytesToHex2(keccak256Wrapper(hexToBytes2(encodedSignedTransaction))), type: detectRawTransactionType(hexToBytes2(encodedSignedTransaction)) }), returnFormat, { fillInputAndData: options.fillInputAndData })
    };
  }

  // ../../node_modules/.pnpm/web3-net@4.0.7_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-net/lib/esm/rpc_method_wrappers.js
  var __awaiter19 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function getId2(web3Context, returnFormat) {
    return __awaiter19(this, void 0, void 0, function* () {
      const response = yield net_rpc_methods_exports.getId(web3Context.requestManager);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getPeerCount2(web3Context, returnFormat) {
    return __awaiter19(this, void 0, void 0, function* () {
      const response = yield net_rpc_methods_exports.getPeerCount(web3Context.requestManager);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  var isListening2 = (web3Context) => __awaiter19(void 0, void 0, void 0, function* () {
    return net_rpc_methods_exports.isListening(web3Context.requestManager);
  });

  // ../../node_modules/.pnpm/web3-net@4.0.7_bufferutil@4.0.7_encoding@0.1.13_utf-8-validate@6.0.3/node_modules/web3-net/lib/esm/net.js
  var __awaiter20 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Net = class extends Web3Context {
    /**
     * Gets the current network ID
     *
     * @param returnFormat - Return format
     * @returns A Promise of the network ID.
     * @example
     * ```ts
     * const net = new Net(Net.givenProvider || 'ws://some.local-or-remote.node:8546');
     * await net.getId();
     * > 1
     * ```
     */
    getId(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter20(this, void 0, void 0, function* () {
        return getId2(this, returnFormat);
      });
    }
    /**
     * Get the number of peers connected to.
     *
     * @param returnFormat - Return format
     * @returns A promise of the number of the peers connected to.
     * @example
     * ```ts
     * const net = new Net(Net.givenProvider || 'ws://some.local-or-remote.node:8546');
     * await net.getPeerCount();
     * > 0
     * ```
     */
    getPeerCount(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter20(this, void 0, void 0, function* () {
        return getPeerCount2(this, returnFormat);
      });
    }
    /**
     * Check if the node is listening for peers
     *
     * @returns A promise of a boolean if the node is listening to peers
     * @example
     * ```ts
     * const net = new Net(Net.givenProvider || 'ws://some.local-or-remote.node:8546');
     * await net.isListening();
     * > true
     * ```
     */
    isListening() {
      return __awaiter20(this, void 0, void 0, function* () {
        return isListening2(this);
      });
    }
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/constants.js
  var ALL_EVENTS = "ALLEVENTS";
  var ALL_EVENTS_ABI = {
    name: ALL_EVENTS,
    signature: "",
    type: "event",
    inputs: []
  };
  var NUMBER_DATA_FORMAT = { bytes: FMT_BYTES.HEX, number: FMT_NUMBER.NUMBER };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/get_transaction_gas_pricing.js
  var __awaiter21 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function getEip1559GasPricing(transaction, web3Context, returnFormat) {
    var _a6, _b3, _c2;
    return __awaiter21(this, void 0, void 0, function* () {
      const block = yield getBlock(web3Context, web3Context.defaultBlock, false, returnFormat);
      if (isNullish(block.baseFeePerGas))
        throw new Eip1559NotSupportedError();
      if (!isNullish(transaction.gasPrice)) {
        const convertedTransactionGasPrice = format4({ format: "uint" }, transaction.gasPrice, returnFormat);
        return {
          maxPriorityFeePerGas: convertedTransactionGasPrice,
          maxFeePerGas: convertedTransactionGasPrice
        };
      }
      return {
        maxPriorityFeePerGas: format4({ format: "uint" }, (_a6 = transaction.maxPriorityFeePerGas) !== null && _a6 !== void 0 ? _a6 : web3Context.defaultMaxPriorityFeePerGas, returnFormat),
        maxFeePerGas: format4({ format: "uint" }, (_b3 = transaction.maxFeePerGas) !== null && _b3 !== void 0 ? _b3 : BigInt(block.baseFeePerGas) * BigInt(2) + BigInt((_c2 = transaction.maxPriorityFeePerGas) !== null && _c2 !== void 0 ? _c2 : web3Context.defaultMaxPriorityFeePerGas), returnFormat)
      };
    });
  }
  function getTransactionGasPricing(transaction, web3Context, returnFormat) {
    return __awaiter21(this, void 0, void 0, function* () {
      const transactionType = getTransactionType(transaction, web3Context);
      if (!isNullish(transactionType)) {
        if (transactionType.startsWith("-"))
          throw new UnsupportedTransactionTypeError(transactionType);
        if (Number(transactionType) < 0 || Number(transactionType) > 127)
          throw new UnsupportedTransactionTypeError(transactionType);
        if (isNullish(transaction.gasPrice) && (transactionType === "0x0" || transactionType === "0x1"))
          return {
            gasPrice: yield getGasPrice2(web3Context, returnFormat),
            maxPriorityFeePerGas: void 0,
            maxFeePerGas: void 0
          };
        if (transactionType === "0x2") {
          return Object.assign({ gasPrice: void 0 }, yield getEip1559GasPricing(transaction, web3Context, returnFormat));
        }
      }
      return void 0;
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/transaction_builder.js
  var __awaiter22 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var getTransactionFromOrToAttr = (attr, web3Context, transaction, privateKey) => {
    if (transaction !== void 0 && attr in transaction && transaction[attr] !== void 0) {
      if (typeof transaction[attr] === "string" && isAddress(transaction[attr])) {
        return transaction[attr];
      }
      if (!isHexStrict(transaction[attr]) && isNumber(transaction[attr])) {
        if (web3Context.wallet) {
          const account = web3Context.wallet.get(format4({ format: "uint" }, transaction[attr], NUMBER_DATA_FORMAT));
          if (!isNullish(account)) {
            return account.address;
          }
          throw new LocalWalletNotAvailableError();
        }
        throw new LocalWalletNotAvailableError();
      } else {
        throw attr === "from" ? new InvalidTransactionWithSender(transaction.from) : (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          new InvalidTransactionWithReceiver(transaction.to)
        );
      }
    }
    if (attr === "from") {
      if (!isNullish(privateKey))
        return privateKeyToAddress(privateKey);
      if (!isNullish(web3Context.defaultAccount))
        return web3Context.defaultAccount;
    }
    return void 0;
  };
  var getTransactionNonce = (web3Context, address, returnFormat = DEFAULT_RETURN_FORMAT) => __awaiter22(void 0, void 0, void 0, function* () {
    if (isNullish(address)) {
      throw new UnableToPopulateNonceError();
    }
    return getTransactionCount2(web3Context, address, web3Context.defaultBlock, returnFormat);
  });
  var getTransactionType = (transaction, web3Context) => {
    const inferredType = detectTransactionType(transaction, web3Context);
    if (!isNullish(inferredType))
      return inferredType;
    if (!isNullish(web3Context.defaultTransactionType))
      return format4({ format: "uint" }, web3Context.defaultTransactionType, ETH_DATA_FORMAT);
    return void 0;
  };
  function defaultTransactionBuilder(options) {
    var _a6, _b3;
    return __awaiter22(this, void 0, void 0, function* () {
      let populatedTransaction = format4(transactionSchema, options.transaction, DEFAULT_RETURN_FORMAT);
      if (isNullish(populatedTransaction.from)) {
        populatedTransaction.from = getTransactionFromOrToAttr("from", options.web3Context, void 0, options.privateKey);
      }
      if (isNullish(populatedTransaction.nonce)) {
        populatedTransaction.nonce = yield getTransactionNonce(options.web3Context, populatedTransaction.from, ETH_DATA_FORMAT);
      }
      if (isNullish(populatedTransaction.value)) {
        populatedTransaction.value = "0x0";
      }
      if (!isNullish(populatedTransaction.data)) {
        if (!isNullish(populatedTransaction.input) && populatedTransaction.data !== populatedTransaction.input)
          throw new TransactionDataAndInputError({
            data: bytesToHex2(populatedTransaction.data),
            input: bytesToHex2(populatedTransaction.input)
          });
        if (!populatedTransaction.data.startsWith("0x"))
          populatedTransaction.data = `0x${populatedTransaction.data}`;
      } else if (!isNullish(populatedTransaction.input)) {
        if (!populatedTransaction.input.startsWith("0x"))
          populatedTransaction.input = `0x${populatedTransaction.input}`;
      } else {
        populatedTransaction.input = "0x";
      }
      if (isNullish(populatedTransaction.common)) {
        if (options.web3Context.defaultCommon) {
          const common = options.web3Context.defaultCommon;
          const chainId = common.customChain.chainId;
          const networkId = common.customChain.networkId;
          const name2 = common.customChain.name;
          populatedTransaction.common = Object.assign(Object.assign({}, common), { customChain: { chainId, networkId, name: name2 } });
        }
        if (isNullish(populatedTransaction.chain)) {
          populatedTransaction.chain = options.web3Context.defaultChain;
        }
        if (isNullish(populatedTransaction.hardfork)) {
          populatedTransaction.hardfork = options.web3Context.defaultHardfork;
        }
      }
      if (isNullish(populatedTransaction.chainId) && isNullish((_a6 = populatedTransaction.common) === null || _a6 === void 0 ? void 0 : _a6.customChain.chainId)) {
        populatedTransaction.chainId = yield getChainId2(options.web3Context, ETH_DATA_FORMAT);
      }
      if (isNullish(populatedTransaction.networkId)) {
        populatedTransaction.networkId = (_b3 = options.web3Context.defaultNetworkId) !== null && _b3 !== void 0 ? _b3 : yield getId2(options.web3Context, ETH_DATA_FORMAT);
      }
      if (isNullish(populatedTransaction.gasLimit) && !isNullish(populatedTransaction.gas)) {
        populatedTransaction.gasLimit = populatedTransaction.gas;
      }
      populatedTransaction.type = getTransactionType(populatedTransaction, options.web3Context);
      if (isNullish(populatedTransaction.accessList) && (populatedTransaction.type === "0x1" || populatedTransaction.type === "0x2")) {
        populatedTransaction.accessList = [];
      }
      if (options.fillGasPrice)
        populatedTransaction = Object.assign(Object.assign({}, populatedTransaction), yield getTransactionGasPricing(populatedTransaction, options.web3Context, ETH_DATA_FORMAT));
      if (isNullish(populatedTransaction.gas) && isNullish(populatedTransaction.gasLimit) && options.fillGasLimit) {
        const fillGasLimit = yield estimateGas2(options.web3Context, populatedTransaction, "latest", ETH_DATA_FORMAT);
        populatedTransaction = Object.assign(Object.assign({}, populatedTransaction), { gas: format4({ format: "uint" }, fillGasLimit, ETH_DATA_FORMAT) });
      }
      return populatedTransaction;
    });
  }
  var transactionBuilder = (options) => __awaiter22(void 0, void 0, void 0, function* () {
    var _a6;
    return ((_a6 = options.web3Context.transactionBuilder) !== null && _a6 !== void 0 ? _a6 : defaultTransactionBuilder)(Object.assign(Object.assign({}, options), { transaction: options.transaction }));
  });

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/reject_if_block_timeout.js
  var __awaiter23 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function resolveByPolling(web3Context, starterBlockNumber, transactionHash) {
    const pollingInterval = web3Context.transactionPollingInterval;
    const [intervalId, promiseToError] = rejectIfConditionAtInterval(() => __awaiter23(this, void 0, void 0, function* () {
      let lastBlockNumber;
      try {
        lastBlockNumber = yield getBlockNumber2(web3Context, NUMBER_DATA_FORMAT);
      } catch (error) {
        console.warn("An error happen while trying to get the block number", error);
        return void 0;
      }
      const numberOfBlocks = lastBlockNumber - starterBlockNumber;
      if (numberOfBlocks >= web3Context.transactionBlockTimeout) {
        return new TransactionBlockTimeoutError({
          starterBlockNumber,
          numberOfBlocks,
          transactionHash
        });
      }
      return void 0;
    }), pollingInterval);
    const clean = () => {
      clearInterval(intervalId);
    };
    return [promiseToError, { clean }];
  }
  function resolveBySubscription(web3Context, starterBlockNumber, transactionHash) {
    var _a6;
    return __awaiter23(this, void 0, void 0, function* () {
      let needToWatchLater = true;
      let subscription;
      let resourceCleaner;
      function revertToPolling(reject, previousError) {
        if (previousError) {
          console.warn("error happened at subscription. So revert to polling...", previousError);
        }
        resourceCleaner.clean();
        needToWatchLater = false;
        const [promiseToError2, newResourceCleaner] = resolveByPolling(web3Context, starterBlockNumber, transactionHash);
        resourceCleaner.clean = newResourceCleaner.clean;
        promiseToError2.catch((error) => reject(error));
      }
      try {
        subscription = yield (_a6 = web3Context.subscriptionManager) === null || _a6 === void 0 ? void 0 : _a6.subscribe("newHeads");
        resourceCleaner = {
          clean: () => {
            var _a7;
            if (subscription.id) {
              (_a7 = web3Context.subscriptionManager) === null || _a7 === void 0 ? void 0 : _a7.removeSubscription(subscription).then(() => {
              }).catch(() => {
              });
            }
          }
        };
      } catch (error) {
        return resolveByPolling(web3Context, starterBlockNumber, transactionHash);
      }
      const promiseToError = new Promise((_2, reject) => {
        try {
          subscription.on("data", (lastBlockHeader) => {
            needToWatchLater = false;
            if (!(lastBlockHeader === null || lastBlockHeader === void 0 ? void 0 : lastBlockHeader.number)) {
              return;
            }
            const numberOfBlocks = Number(BigInt(lastBlockHeader.number) - BigInt(starterBlockNumber));
            if (numberOfBlocks >= web3Context.transactionBlockTimeout) {
              reject(new TransactionBlockTimeoutError({
                starterBlockNumber,
                numberOfBlocks,
                transactionHash
              }));
            }
          });
          subscription.on("error", (error) => {
            revertToPolling(reject, error);
          });
        } catch (error) {
          revertToPolling(reject, error);
        }
        setTimeout(() => {
          if (needToWatchLater) {
            revertToPolling(reject);
          }
        }, web3Context.blockHeaderTimeout * 1e3);
      });
      return [promiseToError, resourceCleaner];
    });
  }
  function rejectIfBlockTimeout(web3Context, transactionHash) {
    var _a6, _b3;
    return __awaiter23(this, void 0, void 0, function* () {
      const { provider } = web3Context.requestManager;
      let callingRes;
      const starterBlockNumber = yield getBlockNumber2(web3Context, NUMBER_DATA_FORMAT);
      if (((_b3 = (_a6 = provider).supportsSubscriptions) === null || _b3 === void 0 ? void 0 : _b3.call(_a6)) && web3Context.enableExperimentalFeatures.useSubscriptionWhenCheckingBlockTimeout) {
        callingRes = yield resolveBySubscription(web3Context, starterBlockNumber, transactionHash);
      } else {
        callingRes = resolveByPolling(web3Context, starterBlockNumber, transactionHash);
      }
      return callingRes;
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/try_send_transaction.js
  var __awaiter24 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function trySendTransaction(web3Context, sendTransactionFunc, transactionHash) {
    return __awaiter24(this, void 0, void 0, function* () {
      const [timeoutId, rejectOnTimeout] = rejectIfTimeout(web3Context.transactionSendTimeout, new TransactionSendTimeoutError({
        numberOfSeconds: web3Context.transactionSendTimeout / 1e3,
        transactionHash
      }));
      const [rejectOnBlockTimeout, blockTimeoutResourceCleaner] = yield rejectIfBlockTimeout(web3Context, transactionHash);
      try {
        return yield Promise.race([
          sendTransactionFunc(),
          rejectOnTimeout,
          rejectOnBlockTimeout
          // this will throw an error on Transaction Block Timeout
        ]);
      } finally {
        clearTimeout(timeoutId);
        blockTimeoutResourceCleaner.clean();
      }
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/wait_for_transaction_receipt.js
  var __awaiter25 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function waitForTransactionReceipt(web3Context, transactionHash, returnFormat) {
    var _a6;
    return __awaiter25(this, void 0, void 0, function* () {
      const pollingInterval = (_a6 = web3Context.transactionReceiptPollingInterval) !== null && _a6 !== void 0 ? _a6 : web3Context.transactionPollingInterval;
      const [awaitableTransactionReceipt, IntervalId] = pollTillDefinedAndReturnIntervalId(() => __awaiter25(this, void 0, void 0, function* () {
        try {
          return getTransactionReceipt2(web3Context, transactionHash, returnFormat);
        } catch (error) {
          console.warn("An error happen while trying to get the transaction receipt", error);
          return void 0;
        }
      }), pollingInterval);
      const [timeoutId, rejectOnTimeout] = rejectIfTimeout(web3Context.transactionPollingTimeout, new TransactionPollingTimeoutError({
        numberOfSeconds: web3Context.transactionPollingTimeout / 1e3,
        transactionHash
      }));
      const [rejectOnBlockTimeout, blockTimeoutResourceCleaner] = yield rejectIfBlockTimeout(web3Context, transactionHash);
      try {
        return yield Promise.race([
          awaitableTransactionReceipt,
          rejectOnTimeout,
          rejectOnBlockTimeout
          // this will throw an error on Transaction Block Timeout
        ]);
      } finally {
        if (timeoutId)
          clearTimeout(timeoutId);
        if (IntervalId)
          clearInterval(IntervalId);
        blockTimeoutResourceCleaner.clean();
      }
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/watch_transaction_by_pooling.js
  var __awaiter26 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var watchTransactionByPolling = ({ web3Context, transactionReceipt, transactionPromiEvent, returnFormat }) => {
    var _a6;
    let confirmations = 1;
    const intervalId = setInterval(() => {
      (() => __awaiter26(void 0, void 0, void 0, function* () {
        if (confirmations >= web3Context.transactionConfirmationBlocks)
          clearInterval(intervalId);
        const nextBlock = yield eth_rpc_methods_exports.getBlockByNumber(web3Context.requestManager, numberToHex2(BigInt(transactionReceipt.blockNumber) + BigInt(confirmations)), false);
        if (nextBlock === null || nextBlock === void 0 ? void 0 : nextBlock.hash) {
          confirmations += 1;
          transactionPromiEvent.emit("confirmation", {
            confirmations: format4({ format: "uint" }, confirmations, returnFormat),
            receipt: format4(transactionReceiptSchema, transactionReceipt, returnFormat),
            latestBlockHash: format4({ format: "bytes32" }, nextBlock.hash, returnFormat)
          });
        }
      }))();
    }, (_a6 = web3Context.transactionReceiptPollingInterval) !== null && _a6 !== void 0 ? _a6 : web3Context.transactionPollingInterval);
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/watch_transaction_by_subscription.js
  var __awaiter27 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var watchTransactionBySubscription = ({ web3Context, transactionReceipt, transactionPromiEvent, returnFormat }) => {
    let needToWatchLater = true;
    let lastCaughtBlockHash;
    setImmediate(() => {
      var _a6;
      (_a6 = web3Context.subscriptionManager) === null || _a6 === void 0 ? void 0 : _a6.subscribe("newHeads").then((subscription) => {
        subscription.on("data", (newBlockHeader) => __awaiter27(void 0, void 0, void 0, function* () {
          var _a7;
          needToWatchLater = false;
          if (!(newBlockHeader === null || newBlockHeader === void 0 ? void 0 : newBlockHeader.number) || // For some cases, the on-data event is fired couple times for the same block!
          // This needs investigation but seems to be because of multiple `subscription.on('data'...)` even this should not cause that.
          lastCaughtBlockHash === (newBlockHeader === null || newBlockHeader === void 0 ? void 0 : newBlockHeader.parentHash)) {
            return;
          }
          lastCaughtBlockHash = newBlockHeader === null || newBlockHeader === void 0 ? void 0 : newBlockHeader.parentHash;
          const confirmations = BigInt(newBlockHeader.number) - BigInt(transactionReceipt.blockNumber) + BigInt(1);
          transactionPromiEvent.emit("confirmation", {
            confirmations: format4({ format: "uint" }, confirmations, returnFormat),
            receipt: format4(transactionReceiptSchema, transactionReceipt, returnFormat),
            latestBlockHash: format4({ format: "bytes32" }, newBlockHeader.parentHash, returnFormat)
          });
          if (confirmations >= web3Context.transactionConfirmationBlocks) {
            yield (_a7 = web3Context.subscriptionManager) === null || _a7 === void 0 ? void 0 : _a7.removeSubscription(subscription);
          }
        }));
        subscription.on("error", () => __awaiter27(void 0, void 0, void 0, function* () {
          var _b3;
          yield (_b3 = web3Context.subscriptionManager) === null || _b3 === void 0 ? void 0 : _b3.removeSubscription(subscription);
          needToWatchLater = false;
          watchTransactionByPolling({
            web3Context,
            transactionReceipt,
            transactionPromiEvent,
            returnFormat
          });
        }));
      }).catch(() => {
        needToWatchLater = false;
        watchTransactionByPolling({
          web3Context,
          transactionReceipt,
          transactionPromiEvent,
          returnFormat
        });
      });
    });
    setTimeout(() => {
      if (needToWatchLater) {
        watchTransactionByPolling({
          web3Context,
          transactionReceipt,
          transactionPromiEvent,
          returnFormat
        });
      }
    }, web3Context.blockHeaderTimeout * 1e3);
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/watch_transaction_for_confirmations.js
  function watchTransactionForConfirmations(web3Context, transactionPromiEvent, transactionReceipt, transactionHash, returnFormat) {
    if (isNullish(transactionReceipt) || isNullish(transactionReceipt.blockHash))
      throw new TransactionMissingReceiptOrBlockHashError({
        receipt: transactionReceipt,
        blockHash: format4({ format: "bytes32" }, transactionReceipt === null || transactionReceipt === void 0 ? void 0 : transactionReceipt.blockHash, returnFormat),
        transactionHash: format4({ format: "bytes32" }, transactionHash, returnFormat)
      });
    if (!transactionReceipt.blockNumber)
      throw new TransactionReceiptMissingBlockNumberError({ receipt: transactionReceipt });
    transactionPromiEvent.emit("confirmation", {
      confirmations: format4({ format: "uint" }, 1, returnFormat),
      receipt: format4(transactionReceiptSchema, transactionReceipt, returnFormat),
      latestBlockHash: format4({ format: "bytes32" }, transactionReceipt.blockHash, returnFormat)
    });
    const provider = web3Context.requestManager.provider;
    if (provider && "supportsSubscriptions" in provider && provider.supportsSubscriptions()) {
      watchTransactionBySubscription({
        web3Context,
        transactionReceipt,
        transactionPromiEvent,
        returnFormat
      });
    } else {
      watchTransactionByPolling({
        web3Context,
        transactionReceipt,
        transactionPromiEvent,
        returnFormat
      });
    }
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/utils.js
  var isAbiErrorFragment = (item) => !isNullish2(item) && typeof item === "object" && !isNullish2(item.type) && item.type === "error";
  var isAbiEventFragment = (item) => !isNullish2(item) && typeof item === "object" && !isNullish2(item.type) && item.type === "event";
  var isAbiFunctionFragment = (item) => !isNullish2(item) && typeof item === "object" && !isNullish2(item.type) && item.type === "function";
  var isAbiConstructorFragment = (item) => !isNullish2(item) && typeof item === "object" && !isNullish2(item.type) && item.type === "constructor";
  var isSimplifiedStructFormat = (type) => typeof type === "object" && typeof type.components === "undefined" && typeof type.name === "undefined";
  var mapStructNameAndType = (structName) => structName.includes("[]") ? { type: "tuple[]", name: structName.slice(0, -2) } : { type: "tuple", name: structName };
  var mapStructToCoderFormat = (struct2) => {
    const components = [];
    for (const key of Object.keys(struct2)) {
      const item = struct2[key];
      if (typeof item === "object") {
        components.push(Object.assign(Object.assign({}, mapStructNameAndType(key)), { components: mapStructToCoderFormat(item) }));
      } else {
        components.push({
          name: key,
          type: struct2[key]
        });
      }
    }
    return components;
  };
  var flattenTypes = (includeTuple, puts) => {
    const types3 = [];
    puts.forEach((param) => {
      if (typeof param.components === "object") {
        if (!param.type.startsWith("tuple")) {
          throw new AbiError(`Invalid value given "${param.type}". Error: components found but type is not tuple.`);
        }
        const arrayBracket = param.type.indexOf("[");
        const suffix = arrayBracket >= 0 ? param.type.substring(arrayBracket) : "";
        const result = flattenTypes(includeTuple, param.components);
        if (Array.isArray(result) && includeTuple) {
          types3.push(`tuple(${result.join(",")})${suffix}`);
        } else if (!includeTuple) {
          types3.push(`(${result.join(",")})${suffix}`);
        } else {
          types3.push(`(${result.join()})`);
        }
      } else {
        types3.push(param.type);
      }
    });
    return types3;
  };
  var jsonInterfaceMethodToString = (json) => {
    var _a6, _b3, _c2, _d;
    if (isAbiErrorFragment(json) || isAbiEventFragment(json) || isAbiFunctionFragment(json)) {
      if ((_a6 = json.name) === null || _a6 === void 0 ? void 0 : _a6.includes("(")) {
        return json.name;
      }
      return `${(_b3 = json.name) !== null && _b3 !== void 0 ? _b3 : ""}(${flattenTypes(false, (_c2 = json.inputs) !== null && _c2 !== void 0 ? _c2 : []).join(",")})`;
    }
    return `(${flattenTypes(false, (_d = json.inputs) !== null && _d !== void 0 ? _d : []).join(",")})`;
  };

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/api/errors_api.js
  var encodeErrorSignature = (functionName) => {
    if (typeof functionName !== "string" && !isAbiErrorFragment(functionName)) {
      throw new AbiError("Invalid parameter value in encodeErrorSignature");
    }
    let name2;
    if (functionName && (typeof functionName === "function" || typeof functionName === "object")) {
      name2 = jsonInterfaceMethodToString(functionName);
    } else {
      name2 = functionName;
    }
    return sha3Raw(name2);
  };

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/api/events_api.js
  var encodeEventSignature = (functionName) => {
    if (typeof functionName !== "string" && !isAbiEventFragment(functionName)) {
      throw new AbiError("Invalid parameter value in encodeEventSignature");
    }
    let name2;
    if (functionName && (typeof functionName === "function" || typeof functionName === "object")) {
      name2 = jsonInterfaceMethodToString(functionName);
    } else {
      name2 = functionName;
    }
    return sha3Raw(name2);
  };

  // ../../node_modules/.pnpm/abitype@0.7.1_typescript@5.6.3_zod@3.25.76/node_modules/abitype/dist/chunk-WP7KDV47.mjs
  function execTyped(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
  }
  var bytesRegex = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
  var integerRegex = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
  var isTupleRegex = /^\(.+?\).*?$/;

  // ../../node_modules/.pnpm/abitype@0.7.1_typescript@5.6.3_zod@3.25.76/node_modules/abitype/dist/chunk-NHABU752.mjs
  var __defProp2 = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // ../../node_modules/.pnpm/abitype@0.7.1_typescript@5.6.3_zod@3.25.76/node_modules/abitype/dist/index.mjs
  var name = "abitype";
  var version4 = "0.7.1";
  var BaseError = class extends Error {
    constructor(shortMessage, args = {}) {
      const details = args.cause instanceof BaseError ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
      const docsPath = args.cause instanceof BaseError ? args.cause.docsPath || args.docsPath : args.docsPath;
      const message = [
        shortMessage || "An error occurred.",
        "",
        ...args.metaMessages ? [...args.metaMessages, ""] : [],
        ...docsPath ? [`Docs: https://abitype.dev${docsPath}`] : [],
        ...details ? [`Details: ${details}`] : [],
        `Version: ${name}@${version4}`
      ].join("\n");
      super(message);
      __publicField(this, "details");
      __publicField(this, "docsPath");
      __publicField(this, "metaMessages");
      __publicField(this, "shortMessage");
      __publicField(this, "name", "AbiTypeError");
      if (args.cause)
        this.cause = args.cause;
      this.details = details;
      this.docsPath = docsPath;
      this.metaMessages = args.metaMessages;
      this.shortMessage = shortMessage;
    }
  };
  var structSignatureRegex = /^struct (?<name>[a-zA-Z0-9_]+) \{(?<properties>.*?)\}$/;
  function isStructSignature(signature) {
    return structSignatureRegex.test(signature);
  }
  function execStructSignature(signature) {
    return execTyped(
      structSignatureRegex,
      signature
    );
  }
  var modifiers = /* @__PURE__ */ new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
  ]);
  var functionModifiers = /* @__PURE__ */ new Set([
    "calldata",
    "memory",
    "storage"
  ]);
  function getParameterCacheKey(param, type) {
    if (type)
      return `${type}:${param}`;
    return param;
  }
  var parameterCache = /* @__PURE__ */ new Map([
    // Unnamed
    ["address", { type: "address" }],
    ["bool", { type: "bool" }],
    ["bytes", { type: "bytes" }],
    ["bytes32", { type: "bytes32" }],
    ["int", { type: "int256" }],
    ["int256", { type: "int256" }],
    ["string", { type: "string" }],
    ["uint", { type: "uint256" }],
    ["uint8", { type: "uint8" }],
    ["uint16", { type: "uint16" }],
    ["uint24", { type: "uint24" }],
    ["uint32", { type: "uint32" }],
    ["uint64", { type: "uint64" }],
    ["uint96", { type: "uint96" }],
    ["uint112", { type: "uint112" }],
    ["uint160", { type: "uint160" }],
    ["uint192", { type: "uint192" }],
    ["uint256", { type: "uint256" }],
    // Named
    ["address owner", { type: "address", name: "owner" }],
    ["address to", { type: "address", name: "to" }],
    ["bool approved", { type: "bool", name: "approved" }],
    ["bytes _data", { type: "bytes", name: "_data" }],
    ["bytes data", { type: "bytes", name: "data" }],
    ["bytes signature", { type: "bytes", name: "signature" }],
    ["bytes32 hash", { type: "bytes32", name: "hash" }],
    ["bytes32 r", { type: "bytes32", name: "r" }],
    ["bytes32 root", { type: "bytes32", name: "root" }],
    ["bytes32 s", { type: "bytes32", name: "s" }],
    ["string name", { type: "string", name: "name" }],
    ["string symbol", { type: "string", name: "symbol" }],
    ["string tokenURI", { type: "string", name: "tokenURI" }],
    ["uint tokenId", { type: "uint256", name: "tokenId" }],
    ["uint8 v", { type: "uint8", name: "v" }],
    ["uint256 balance", { type: "uint256", name: "balance" }],
    ["uint256 tokenId", { type: "uint256", name: "tokenId" }],
    ["uint256 value", { type: "uint256", name: "value" }],
    // Indexed
    [
      "event:address indexed from",
      { type: "address", name: "from", indexed: true }
    ],
    ["event:address indexed to", { type: "address", name: "to", indexed: true }],
    [
      "event:uint indexed tokenId",
      { type: "uint256", name: "tokenId", indexed: true }
    ],
    [
      "event:uint256 indexed tokenId",
      { type: "uint256", name: "tokenId", indexed: true }
    ]
  ]);
  var abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z0-9_]+?)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z0-9_]+))?$/;
  var abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z0-9_]+))?$/;
  var dynamicIntegerRegex = /^u?int$/;
  function parseAbiParameter(param, options) {
    const parameterCacheKey = getParameterCacheKey(param, options?.type);
    if (parameterCache.has(parameterCacheKey))
      return parameterCache.get(parameterCacheKey);
    const isTuple = isTupleRegex.test(param);
    const match = execTyped(
      isTuple ? abiParameterWithTupleRegex : abiParameterWithoutTupleRegex,
      param
    );
    if (!match)
      throw new BaseError("Invalid ABI parameter.", {
        details: param
      });
    if (match.name && isSolidityKeyword(match.name))
      throw new BaseError("Invalid ABI parameter.", {
        details: param,
        metaMessages: [
          `"${match.name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
        ]
      });
    const name2 = match.name ? { name: match.name } : {};
    const indexed = match.modifier === "indexed" ? { indexed: true } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
      type = "tuple";
      const params = splitParameters(match.type);
      const components_ = [];
      const length2 = params.length;
      for (let i2 = 0; i2 < length2; i2++) {
        components_.push(parseAbiParameter(params[i2], { structs }));
      }
      components = { components: components_ };
    } else if (match.type in structs) {
      type = "tuple";
      components = { components: structs[match.type] };
    } else if (dynamicIntegerRegex.test(match.type)) {
      type = `${match.type}256`;
    } else {
      type = match.type;
      if (!(options?.type === "struct") && !isSolidityType(type))
        throw new BaseError("Unknown type.", {
          metaMessages: [`Type "${type}" is not a valid ABI type.`]
        });
    }
    if (match.modifier) {
      if (!options?.modifiers?.has?.(match.modifier))
        throw new BaseError("Invalid ABI parameter.", {
          details: param,
          metaMessages: [
            `Modifier "${match.modifier}" not allowed${options?.type ? ` in "${options.type}" type` : ""}.`
          ]
        });
      if (functionModifiers.has(match.modifier) && !isValidDataLocation(type, !!match.array))
        throw new BaseError("Invalid ABI parameter.", {
          details: param,
          metaMessages: [
            `Modifier "${match.modifier}" not allowed${options?.type ? ` in "${options.type}" type` : ""}.`,
            `Data location can only be specified for array, struct, or mapping types, but "${match.modifier}" was given.`
          ]
        });
    }
    const abiParameter = {
      type: `${type}${match.array ?? ""}`,
      ...name2,
      ...indexed,
      ...components
    };
    parameterCache.set(parameterCacheKey, abiParameter);
    return abiParameter;
  }
  function splitParameters(params, result = [], current = "", depth = 0) {
    if (params === "") {
      if (current === "")
        return result;
      if (depth !== 0)
        throw new BaseError("Unbalanced parentheses.", {
          metaMessages: [
            `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
          ],
          details: `Depth "${depth}"`
        });
      return [...result, current.trim()];
    }
    const length2 = params.length;
    for (let i2 = 0; i2 < length2; i2++) {
      const char = params[i2];
      const tail = params.slice(i2 + 1);
      switch (char) {
        case ",":
          return depth === 0 ? splitParameters(tail, [...result, current.trim()]) : splitParameters(tail, result, `${current}${char}`, depth);
        case "(":
          return splitParameters(tail, result, `${current}${char}`, depth + 1);
        case ")":
          return splitParameters(tail, result, `${current}${char}`, depth - 1);
        default:
          return splitParameters(tail, result, `${current}${char}`, depth);
      }
    }
    return [];
  }
  function isSolidityType(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || bytesRegex.test(type) || integerRegex.test(type);
  }
  var protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
  function isSolidityKeyword(name2) {
    return name2 === "address" || name2 === "bool" || name2 === "function" || name2 === "string" || name2 === "tuple" || bytesRegex.test(name2) || integerRegex.test(name2) || protectedKeywordsRegex.test(name2);
  }
  function isValidDataLocation(type, isArray2) {
    return isArray2 || type === "bytes" || type === "string" || type === "tuple";
  }
  function parseStructs(signatures) {
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for (let i2 = 0; i2 < signaturesLength; i2++) {
      const signature = signatures[i2];
      if (!isStructSignature(signature))
        continue;
      const match = execStructSignature(signature);
      if (!match)
        throw new BaseError("Invalid struct signature.", {
          details: signature
        });
      const properties = match.properties.split(";");
      const components = [];
      const propertiesLength = properties.length;
      for (let k = 0; k < propertiesLength; k++) {
        const property = properties[k];
        const trimmed = property.trim();
        if (!trimmed)
          continue;
        const abiParameter = parseAbiParameter(trimmed, {
          type: "struct"
        });
        components.push(abiParameter);
      }
      if (!components.length)
        throw new BaseError("Invalid struct signature.", {
          details: signature,
          metaMessages: ["No properties exist."]
        });
      shallowStructs[match.name] = components;
    }
    const resolvedStructs = {};
    const entries2 = Object.entries(shallowStructs);
    const entriesLength = entries2.length;
    for (let i2 = 0; i2 < entriesLength; i2++) {
      const [name2, parameters] = entries2[i2];
      resolvedStructs[name2] = resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
  }
  var typeWithoutTupleRegex = /^(?<type>[a-zA-Z0-9_]+?)(?<array>(?:\[\d*?\])+?)?$/;
  function resolveStructs(abiParameters, structs, ancestors = /* @__PURE__ */ new Set()) {
    const components = [];
    const length2 = abiParameters.length;
    for (let i2 = 0; i2 < length2; i2++) {
      const abiParameter = abiParameters[i2];
      const isTuple = isTupleRegex.test(abiParameter.type);
      if (isTuple)
        components.push(abiParameter);
      else {
        const match = execTyped(
          typeWithoutTupleRegex,
          abiParameter.type
        );
        if (!match?.type)
          throw new BaseError("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: ["ABI parameter type is invalid."]
          });
        const { array, type } = match;
        if (type in structs) {
          if (ancestors.has(type))
            throw new BaseError("Circular reference detected.", {
              metaMessages: [`Struct "${type}" is a circular reference.`]
            });
          components.push({
            ...abiParameter,
            type: `tuple${array ?? ""}`,
            components: resolveStructs(
              structs[type] ?? [],
              structs,
              /* @__PURE__ */ new Set([...ancestors, type])
            )
          });
        } else {
          if (isSolidityType(type))
            components.push(abiParameter);
          else
            throw new BaseError("Unknown type.", {
              metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
              ]
            });
        }
      }
    }
    return components;
  }
  function parseAbiParameter2(param) {
    let abiParameter;
    if (typeof param === "string")
      abiParameter = parseAbiParameter(param, {
        modifiers
      });
    else {
      const structs = parseStructs(param);
      const length2 = param.length;
      for (let i2 = 0; i2 < length2; i2++) {
        const signature = param[i2];
        if (isStructSignature(signature))
          continue;
        abiParameter = parseAbiParameter(signature, { modifiers, structs });
        break;
      }
    }
    if (!abiParameter)
      throw new BaseError("Failed to parse ABI parameter.", {
        details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
        docsPath: "/api/human.html#parseabiparameter-1"
      });
    return abiParameter;
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/utils.js
  var WORD_SIZE = 32;
  function alloc(size = 0) {
    var _a6;
    if (((_a6 = globalThis.Buffer) === null || _a6 === void 0 ? void 0 : _a6.alloc) !== void 0) {
      const buf = globalThis.Buffer.alloc(size);
      return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    return new Uint8Array(size);
  }
  function convertExternalAbiParameter(abiParam) {
    var _a6, _b3;
    return Object.assign(Object.assign({}, abiParam), { name: (_a6 = abiParam.name) !== null && _a6 !== void 0 ? _a6 : "", components: (_b3 = abiParam.components) === null || _b3 === void 0 ? void 0 : _b3.map((c) => convertExternalAbiParameter(c)) });
  }
  function isAbiParameter(param) {
    return !isNullish2(param) && typeof param === "object" && !isNullish2(param.type) && typeof param.type === "string";
  }
  function toAbiParams(abi) {
    return abi.map((input) => {
      var _a6;
      if (isAbiParameter(input)) {
        return input;
      }
      if (typeof input === "string") {
        return convertExternalAbiParameter(parseAbiParameter2(input.replace(/tuple/, "")));
      }
      if (isSimplifiedStructFormat(input)) {
        const structName = Object.keys(input)[0];
        const structInfo = mapStructNameAndType(structName);
        structInfo.name = (_a6 = structInfo.name) !== null && _a6 !== void 0 ? _a6 : "";
        return Object.assign(Object.assign({}, structInfo), { components: mapStructToCoderFormat(input[structName]) });
      }
      throw new AbiError("Invalid abi");
    });
  }
  function extractArrayType(param) {
    const arrayParenthesisStart = param.type.lastIndexOf("[");
    const arrayParamType = param.type.substring(0, arrayParenthesisStart);
    const sizeString = param.type.substring(arrayParenthesisStart);
    let size = -1;
    if (sizeString !== "[]") {
      size = Number(sizeString.slice(1, -1));
      if (isNaN(size)) {
        throw new AbiError("Invalid fixed array size", { size: sizeString });
      }
    }
    return {
      param: { type: arrayParamType, name: "", components: param.components },
      size
    };
  }
  function isDynamic(param) {
    var _a6, _b3;
    if (param.type === "string" || param.type === "bytes" || param.type.endsWith("[]"))
      return true;
    if (param.type === "tuple") {
      return (_b3 = (_a6 = param.components) === null || _a6 === void 0 ? void 0 : _a6.some(isDynamic)) !== null && _b3 !== void 0 ? _b3 : false;
    }
    if (param.type.endsWith("]")) {
      return isDynamic(extractArrayType(param).param);
    }
    return false;
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/address.js
  var ADDRESS_BYTES_COUNT = 20;
  var ADDRESS_OFFSET = WORD_SIZE - ADDRESS_BYTES_COUNT;
  function encodeAddress(param, input) {
    if (typeof input !== "string") {
      throw new AbiError("address type expects string as input type", {
        value: input,
        name: param.name,
        type: param.type
      });
    }
    let address = input.toLowerCase();
    if (!address.startsWith("0x")) {
      address = `0x${address}`;
    }
    if (!isAddress(address)) {
      throw new AbiError("provided input is not valid address", {
        value: input,
        name: param.name,
        type: param.type
      });
    }
    const addressBytes = utils_exports.hexToUint8Array(address);
    const encoded = alloc(WORD_SIZE);
    encoded.set(addressBytes, ADDRESS_OFFSET);
    return {
      dynamic: false,
      encoded
    };
  }
  function decodeAddress(_param, bytes2) {
    const addressBytes = bytes2.subarray(ADDRESS_OFFSET, WORD_SIZE);
    if (addressBytes.length !== ADDRESS_BYTES_COUNT) {
      throw new AbiError("Invalid decoding input, not enough bytes to decode address", { bytes: bytes2 });
    }
    const result = utils_exports.uint8ArrayToHexString(addressBytes);
    return {
      result: toChecksumAddress(result),
      encoded: bytes2.subarray(WORD_SIZE),
      consumed: WORD_SIZE
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/numbersLimits.js
  var numberLimits = /* @__PURE__ */ new Map();
  var base = BigInt(256);
  for (let i2 = 8; i2 <= 256; i2 += 8) {
    numberLimits.set(`uint${i2}`, {
      min: BigInt(0),
      max: base - BigInt(1)
    });
    numberLimits.set(`int${i2}`, {
      min: -base / BigInt(2),
      max: base / BigInt(2) - BigInt(1)
    });
    base *= BigInt(256);
  }
  numberLimits.set(`int`, numberLimits.get("int256"));
  numberLimits.set(`uint`, numberLimits.get("uint256"));

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/number.js
  var mask = BigInt(1) << BigInt(256);
  function bigIntToUint8Array2(value, byteLength = WORD_SIZE) {
    let hexValue;
    if (value < 0) {
      hexValue = (mask + value).toString(16);
    } else {
      hexValue = value.toString(16);
    }
    hexValue = padLeft2(hexValue, byteLength * 2);
    return utils_exports.hexToUint8Array(hexValue);
  }
  function uint8ArrayToBigInt2(value, max2) {
    const hexValue = utils_exports.uint8ArrayToHexString(value);
    const result = BigInt(hexValue);
    if (result <= max2)
      return result;
    return result - mask;
  }
  function encodeNumber(param, input) {
    let value;
    try {
      value = toBigInt(input);
    } catch (e2) {
      throw new AbiError("provided input is not number value", {
        type: param.type,
        value: input,
        name: param.name
      });
    }
    const limit = numberLimits.get(param.type);
    if (!limit) {
      throw new AbiError("provided abi contains invalid number datatype", { type: param.type });
    }
    if (value < limit.min) {
      throw new AbiError("provided input is less then minimum for given type", {
        type: param.type,
        value: input,
        name: param.name,
        minimum: limit.min.toString()
      });
    }
    if (value > limit.max) {
      throw new AbiError("provided input is greater then maximum for given type", {
        type: param.type,
        value: input,
        name: param.name,
        maximum: limit.max.toString()
      });
    }
    return {
      dynamic: false,
      encoded: bigIntToUint8Array2(value)
    };
  }
  function decodeNumber(param, bytes2) {
    if (bytes2.length < WORD_SIZE) {
      throw new AbiError("Not enough bytes left to decode", { param, bytesLeft: bytes2.length });
    }
    const boolBytes = bytes2.subarray(0, WORD_SIZE);
    const limit = numberLimits.get(param.type);
    if (!limit) {
      throw new AbiError("provided abi contains invalid number datatype", { type: param.type });
    }
    const numberResult = uint8ArrayToBigInt2(boolBytes, limit.max);
    if (numberResult < limit.min) {
      throw new AbiError("decoded value is less then minimum for given type", {
        type: param.type,
        value: numberResult,
        name: param.name,
        minimum: limit.min.toString()
      });
    }
    if (numberResult > limit.max) {
      throw new AbiError("decoded value is greater then maximum for given type", {
        type: param.type,
        value: numberResult,
        name: param.name,
        maximum: limit.max.toString()
      });
    }
    return {
      result: numberResult,
      encoded: bytes2.subarray(WORD_SIZE),
      consumed: WORD_SIZE
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/bool.js
  function encodeBoolean(param, input) {
    let value;
    try {
      value = toBool(input);
    } catch (e2) {
      if (e2 instanceof InvalidBooleanError) {
        throw new AbiError("provided input is not valid boolean value", {
          type: param.type,
          value: input,
          name: param.name
        });
      }
    }
    return encodeNumber({ type: "uint8", name: "" }, Number(value));
  }
  function decodeBool(_param, bytes2) {
    const numberResult = decodeNumber({ type: "uint8", name: "" }, bytes2);
    if (numberResult.result > 1 || numberResult.result < 0) {
      throw new AbiError("Invalid boolean value encoded", {
        boolBytes: bytes2.subarray(0, WORD_SIZE),
        numberResult
      });
    }
    return {
      result: numberResult.result === BigInt(1),
      encoded: numberResult.encoded,
      consumed: WORD_SIZE
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/bytes.js
  var MAX_STATIC_BYTES_COUNT = 32;
  function encodeBytes(param, input) {
    if (typeof input === "string" && input.length % 2 !== 0) {
      input += "0";
    }
    if (!isBytes(input)) {
      throw new AbiError("provided input is not valid bytes value", {
        type: param.type,
        value: input,
        name: param.name
      });
    }
    const bytes2 = bytesToUint8Array(input);
    const [, size] = param.type.split("bytes");
    if (size) {
      if (Number(size) > MAX_STATIC_BYTES_COUNT || Number(size) < 1) {
        throw new AbiError("invalid bytes type. Static byte type can have between 1 and 32 bytes", {
          type: param.type
        });
      }
      if (Number(size) < bytes2.length) {
        throw new AbiError("provided input size is different than type size", {
          type: param.type,
          value: input,
          name: param.name
        });
      }
      const encoded2 = alloc(WORD_SIZE);
      encoded2.set(bytes2);
      return {
        dynamic: false,
        encoded: encoded2
      };
    }
    const partsLength = Math.ceil(bytes2.length / WORD_SIZE);
    const encoded = alloc(WORD_SIZE + partsLength * WORD_SIZE);
    encoded.set(encodeNumber({ type: "uint32", name: "" }, bytes2.length).encoded);
    encoded.set(bytes2, WORD_SIZE);
    return {
      dynamic: true,
      encoded
    };
  }
  function decodeBytes(param, bytes2) {
    const [, sizeString] = param.type.split("bytes");
    let size = Number(sizeString);
    let remainingBytes = bytes2;
    let partsCount = 1;
    let consumed = 0;
    if (!size) {
      const result = decodeNumber({ type: "uint32", name: "" }, remainingBytes);
      size = Number(result.result);
      consumed += result.consumed;
      remainingBytes = result.encoded;
      partsCount = Math.ceil(size / WORD_SIZE);
    }
    if (size > bytes2.length) {
      throw new AbiError("there is not enough data to decode", {
        type: param.type,
        encoded: bytes2,
        size
      });
    }
    return {
      result: bytesToHex2(remainingBytes.subarray(0, size)),
      encoded: remainingBytes.subarray(partsCount * WORD_SIZE),
      consumed: consumed + partsCount * WORD_SIZE
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/string.js
  function encodeString(_param, input) {
    if (typeof input !== "string") {
      throw new AbiError("invalid input, should be string", { input });
    }
    const bytes2 = utf8ToBytes2(input);
    return encodeBytes({ type: "bytes", name: "" }, bytes2);
  }
  function decodeString(_param, bytes2) {
    const r2 = decodeBytes({ type: "bytes", name: "" }, bytes2);
    return {
      result: hexToUtf8(r2.result),
      encoded: r2.encoded,
      consumed: r2.consumed
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/utils.js
  function encodeDynamicParams(encodedParams) {
    let staticSize = 0;
    let dynamicSize = 0;
    const staticParams = [];
    const dynamicParams = [];
    for (const encodedParam of encodedParams) {
      if (encodedParam.dynamic) {
        staticSize += WORD_SIZE;
      } else {
        staticSize += encodedParam.encoded.length;
      }
    }
    for (const encodedParam of encodedParams) {
      if (encodedParam.dynamic) {
        staticParams.push(encodeNumber({ type: "uint256", name: "" }, staticSize + dynamicSize));
        dynamicParams.push(encodedParam);
        dynamicSize += encodedParam.encoded.length;
      } else {
        staticParams.push(encodedParam);
      }
    }
    return uint8ArrayConcat(...staticParams.map((p12) => p12.encoded), ...dynamicParams.map((p12) => p12.encoded));
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/array.js
  function encodeArray(param, values) {
    if (!Array.isArray(values)) {
      throw new AbiError("Expected value to be array", { abi: param, values });
    }
    const { size, param: arrayItemParam } = extractArrayType(param);
    const encodedParams = values.map((v) => encodeParamFromAbiParameter(arrayItemParam, v));
    const dynamic = size === -1;
    const dynamicItems = encodedParams.length > 0 && encodedParams[0].dynamic;
    if (!dynamic && values.length !== size) {
      throw new AbiError("Given arguments count doesn't match array length", {
        arrayLength: size,
        argumentsLength: values.length
      });
    }
    if (dynamic || dynamicItems) {
      const encodingResult = encodeDynamicParams(encodedParams);
      if (dynamic) {
        const encodedLength = encodeNumber({ type: "uint256", name: "" }, encodedParams.length).encoded;
        return {
          dynamic: true,
          encoded: encodedParams.length > 0 ? uint8ArrayConcat(encodedLength, encodingResult) : encodedLength
        };
      }
      return {
        dynamic: true,
        encoded: encodingResult
      };
    }
    return {
      dynamic: false,
      encoded: uint8ArrayConcat(...encodedParams.map((p12) => p12.encoded))
    };
  }
  function decodeArray(param, bytes2) {
    let { size, param: arrayItemParam } = extractArrayType(param);
    const dynamic = size === -1;
    let consumed = 0;
    const result = [];
    let remaining = bytes2;
    if (dynamic) {
      const lengthResult = decodeNumber({ type: "uint32", name: "" }, bytes2);
      size = Number(lengthResult.result);
      consumed = lengthResult.consumed;
      remaining = lengthResult.encoded;
    }
    const hasDynamicChild = isDynamic(arrayItemParam);
    if (hasDynamicChild) {
      for (let i2 = 0; i2 < size; i2 += 1) {
        const offsetResult = decodeNumber({ type: "uint32", name: "" }, remaining.subarray(i2 * WORD_SIZE));
        consumed += offsetResult.consumed;
        const decodedChildResult = decodeParamFromAbiParameter(arrayItemParam, remaining.subarray(Number(offsetResult.result)));
        consumed += decodedChildResult.consumed;
        result.push(decodedChildResult.result);
      }
      return {
        result,
        encoded: remaining.subarray(consumed),
        consumed
      };
    }
    for (let i2 = 0; i2 < size; i2 += 1) {
      const decodedChildResult = decodeParamFromAbiParameter(arrayItemParam, bytes2.subarray(consumed));
      consumed += decodedChildResult.consumed;
      result.push(decodedChildResult.result);
    }
    return {
      result,
      encoded: bytes2.subarray(consumed),
      consumed
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/index.js
  function encodeParamFromAbiParameter(param, value) {
    if (param.type === "string") {
      return encodeString(param, value);
    }
    if (param.type === "bool") {
      return encodeBoolean(param, value);
    }
    if (param.type === "address") {
      return encodeAddress(param, value);
    }
    if (param.type === "tuple") {
      return encodeTuple(param, value);
    }
    if (param.type.endsWith("]")) {
      return encodeArray(param, value);
    }
    if (param.type.startsWith("bytes")) {
      return encodeBytes(param, value);
    }
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
      return encodeNumber(param, value);
    }
    throw new Error("Unsupported");
  }
  function decodeParamFromAbiParameter(param, bytes2) {
    if (param.type === "string") {
      return decodeString(param, bytes2);
    }
    if (param.type === "bool") {
      return decodeBool(param, bytes2);
    }
    if (param.type === "address") {
      return decodeAddress(param, bytes2);
    }
    if (param.type === "tuple") {
      return decodeTuple(param, bytes2);
    }
    if (param.type.endsWith("]")) {
      return decodeArray(param, bytes2);
    }
    if (param.type.startsWith("bytes")) {
      return decodeBytes(param, bytes2);
    }
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
      return decodeNumber(param, bytes2);
    }
    throw new Error("Unsupported");
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/base/tuple.js
  function encodeTuple(param, input) {
    var _a6, _b3, _c2;
    let dynamic = false;
    if (!Array.isArray(input) && typeof input !== "object") {
      throw new AbiError("param must be either Array or Object", {
        param,
        input
      });
    }
    const narrowedInput = input;
    const encoded = [];
    for (let i2 = 0; i2 < ((_b3 = (_a6 = param.components) === null || _a6 === void 0 ? void 0 : _a6.length) !== null && _b3 !== void 0 ? _b3 : 0); i2 += 1) {
      const paramComponent = param.components[i2];
      let result;
      if (Array.isArray(narrowedInput)) {
        if (i2 >= narrowedInput.length) {
          throw new AbiError("input param length missmatch", {
            param,
            input
          });
        }
        result = encodeParamFromAbiParameter(paramComponent, narrowedInput[i2]);
      } else {
        const paramInput = narrowedInput[(_c2 = paramComponent.name) !== null && _c2 !== void 0 ? _c2 : ""];
        if (paramInput === void 0 || paramInput === null) {
          throw new AbiError("missing input defined in abi", {
            param,
            input,
            paramName: paramComponent.name
          });
        }
        result = encodeParamFromAbiParameter(paramComponent, paramInput);
      }
      if (result.dynamic) {
        dynamic = true;
      }
      encoded.push(result);
    }
    if (dynamic) {
      return {
        dynamic: true,
        encoded: encodeDynamicParams(encoded)
      };
    }
    return {
      dynamic: false,
      encoded: uint8ArrayConcat(...encoded.map((e2) => e2.encoded))
    };
  }
  function decodeTuple(param, bytes2) {
    const result = {
      __length__: 0
    };
    let consumed = 0;
    if (!param.components) {
      return {
        result,
        encoded: bytes2,
        consumed
      };
    }
    let dynamicConsumed = 0;
    for (const [index2, childParam] of param.components.entries()) {
      let decodedResult;
      if (isDynamic(childParam)) {
        const offsetResult = decodeNumber({ type: "uint32", name: "" }, bytes2.subarray(consumed));
        decodedResult = decodeParamFromAbiParameter(childParam, bytes2.subarray(Number(offsetResult.result)));
        consumed += offsetResult.consumed;
        dynamicConsumed += decodedResult.consumed;
      } else {
        decodedResult = decodeParamFromAbiParameter(childParam, bytes2.subarray(consumed));
        consumed += decodedResult.consumed;
      }
      result.__length__ += 1;
      result[index2] = decodedResult.result;
      if (childParam.name && childParam.name !== "") {
        result[childParam.name] = decodedResult.result;
      }
    }
    return {
      encoded: bytes2.subarray(consumed + dynamicConsumed),
      result,
      consumed: consumed + dynamicConsumed
    };
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/decode.js
  function decodeParameters(abis, bytes2, _loose) {
    const abiParams = toAbiParams(abis);
    const bytesArray = utils_exports.hexToUint8Array(bytes2);
    return decodeTuple({ type: "tuple", name: "", components: abiParams }, bytesArray).result;
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/coders/encode.js
  function encodeParameters(abi, params) {
    if (abi.length !== params.length) {
      throw new AbiError("Invalid number of values received for given ABI", {
        expected: abi.length,
        received: params.length
      });
    }
    const abiParams = toAbiParams(abi);
    return utils_exports.uint8ArrayToHexString(encodeTuple({ type: "tuple", name: "", components: abiParams }, params).encoded);
  }

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/api/parameters_api.js
  var encodeParameters2 = (abi, params) => encodeParameters(abi, params);
  var encodeParameter = (abi, param) => encodeParameters2([abi], [param]);
  var decodeParametersWith = (abis, bytes2, loose) => {
    try {
      if (abis.length > 0 && (!bytes2 || bytes2 === "0x" || bytes2 === "0X")) {
        throw new AbiError("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
      }
      return decodeParameters(abis, `0x${bytes2.replace(/0x/i, "")}`, loose);
    } catch (err3) {
      throw new AbiError(`Parameter decoding error: ${err3.message}`, {
        internalErr: err3
      });
    }
  };
  var decodeParameters2 = (abi, bytes2) => decodeParametersWith(abi, bytes2, false);
  var decodeParameter = (abi, bytes2) => decodeParameters2([abi], bytes2)["0"];

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/api/functions_api.js
  var encodeFunctionSignature = (functionName) => {
    if (typeof functionName !== "string" && !isAbiFunctionFragment(functionName)) {
      throw new AbiError("Invalid parameter value in encodeFunctionSignature");
    }
    let name2;
    if (functionName && (typeof functionName === "function" || typeof functionName === "object")) {
      name2 = jsonInterfaceMethodToString(functionName);
    } else {
      name2 = functionName;
    }
    return sha3Raw(name2).slice(0, 10);
  };
  var encodeFunctionCall = (jsonInterface, params) => {
    var _a6;
    if (!isAbiFunctionFragment(jsonInterface)) {
      throw new AbiError("Invalid parameter value in encodeFunctionCall");
    }
    return `${encodeFunctionSignature(jsonInterface)}${encodeParameters2((_a6 = jsonInterface.inputs) !== null && _a6 !== void 0 ? _a6 : [], params !== null && params !== void 0 ? params : []).replace("0x", "")}`;
  };

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/api/logs_api.js
  var STATIC_TYPES = ["bool", "string", "int", "uint", "address", "fixed", "ufixed"];
  var _decodeParameter = (inputType, clonedTopic) => inputType === "string" ? clonedTopic : decodeParameter(inputType, clonedTopic);
  var decodeLog = (inputs, data, topics) => {
    const clonedTopics = Array.isArray(topics) ? topics : [topics];
    const indexedInputs = {};
    const nonIndexedInputs = {};
    for (const [i2, input] of inputs.entries()) {
      if (input.indexed) {
        indexedInputs[i2] = input;
      } else {
        nonIndexedInputs[i2] = input;
      }
    }
    const decodedNonIndexedInputs = data ? decodeParametersWith(Object.values(nonIndexedInputs), data, true) : { __length__: 0 };
    const offset = clonedTopics.length - Object.keys(indexedInputs).length;
    const decodedIndexedInputs = Object.values(indexedInputs).map((input, index2) => STATIC_TYPES.some((s2) => input.type.startsWith(s2)) ? _decodeParameter(input.type, clonedTopics[index2 + offset]) : clonedTopics[index2 + offset]);
    const returnValues = { __length__: 0 };
    let indexedCounter = 0;
    let nonIndexedCounter = 0;
    for (const [i2, res] of inputs.entries()) {
      returnValues[i2] = res.type === "string" ? "" : void 0;
      if (indexedInputs[i2]) {
        returnValues[i2] = decodedIndexedInputs[indexedCounter];
        indexedCounter += 1;
      }
      if (nonIndexedInputs[i2]) {
        returnValues[i2] = decodedNonIndexedInputs[String(nonIndexedCounter)];
        nonIndexedCounter += 1;
      }
      if (res.name) {
        returnValues[res.name] = returnValues[i2];
      }
      returnValues.__length__ += 1;
    }
    return returnValues;
  };

  // ../../node_modules/.pnpm/web3-eth-abi@4.1.4_typescript@5.6.3_zod@3.25.76/node_modules/web3-eth-abi/lib/esm/decode_contract_error_data.js
  var decodeContractErrorData = (errorsAbi, error) => {
    if (error === null || error === void 0 ? void 0 : error.data) {
      let errorName;
      let errorSignature;
      let errorArgs;
      try {
        const errorSha = error.data.slice(0, 10);
        const errorAbi = errorsAbi.find((abi) => encodeErrorSignature(abi).startsWith(errorSha));
        if (errorAbi === null || errorAbi === void 0 ? void 0 : errorAbi.inputs) {
          errorName = errorAbi.name;
          errorSignature = jsonInterfaceMethodToString(errorAbi);
          errorArgs = decodeParameters2([...errorAbi.inputs], error.data.substring(10));
        }
      } catch (err3) {
        console.error(err3);
      }
      if (errorName) {
        error.setDecodedProperties(errorName, errorSignature, errorArgs);
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/get_revert_reason.js
  var __awaiter28 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var parseTransactionError = (error, contractAbi) => {
    var _a6, _b3, _c2, _d;
    if (error instanceof ContractExecutionError && error.innerError instanceof Eip838ExecutionError) {
      if (contractAbi !== void 0) {
        const errorsAbi = contractAbi.filter((abi) => isAbiErrorFragment(abi));
        decodeContractErrorData(errorsAbi, error.innerError);
        return {
          reason: error.innerError.message,
          signature: (_a6 = error.innerError.data) === null || _a6 === void 0 ? void 0 : _a6.slice(0, 10),
          data: (_b3 = error.innerError.data) === null || _b3 === void 0 ? void 0 : _b3.substring(10),
          customErrorName: error.innerError.errorName,
          customErrorDecodedSignature: error.innerError.errorSignature,
          customErrorArguments: error.innerError.errorArgs
        };
      }
      return {
        reason: error.innerError.message,
        signature: (_c2 = error.innerError.data) === null || _c2 === void 0 ? void 0 : _c2.slice(0, 10),
        data: (_d = error.innerError.data) === null || _d === void 0 ? void 0 : _d.substring(10)
      };
    }
    if (error instanceof InvalidResponseError && !Array.isArray(error.innerError) && error.innerError !== void 0) {
      return error.innerError.message;
    }
    throw error;
  };
  function getRevertReason(web3Context, transaction, contractAbi, returnFormat = DEFAULT_RETURN_FORMAT) {
    return __awaiter28(this, void 0, void 0, function* () {
      try {
        yield call2(web3Context, transaction, web3Context.defaultBlock, returnFormat);
        return void 0;
      } catch (error) {
        return parseTransactionError(error, contractAbi);
      }
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/get_transaction_error.js
  var __awaiter29 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  function getTransactionError(web3Context, transactionFormatted, transactionReceiptFormatted, receivedError, contractAbi, knownReason) {
    return __awaiter29(this, void 0, void 0, function* () {
      let _reason = knownReason;
      if (_reason === void 0) {
        if (receivedError !== void 0) {
          _reason = parseTransactionError(receivedError);
        } else if (web3Context.handleRevert && transactionFormatted !== void 0) {
          _reason = yield getRevertReason(web3Context, transactionFormatted, contractAbi);
        }
      }
      let error;
      if (_reason === void 0) {
        error = new TransactionRevertedWithoutReasonError(transactionReceiptFormatted);
      } else if (typeof _reason === "string") {
        error = new TransactionRevertInstructionError(_reason, void 0, transactionReceiptFormatted);
      } else if (_reason.customErrorName !== void 0 && _reason.customErrorDecodedSignature !== void 0 && _reason.customErrorArguments !== void 0) {
        const reasonWithCustomError = _reason;
        error = new TransactionRevertWithCustomError(reasonWithCustomError.reason, reasonWithCustomError.customErrorName, reasonWithCustomError.customErrorDecodedSignature, reasonWithCustomError.customErrorArguments, reasonWithCustomError.signature, transactionReceiptFormatted, reasonWithCustomError.data);
      } else {
        error = new TransactionRevertInstructionError(_reason.reason, _reason.signature, transactionReceiptFormatted, _reason.data);
      }
      return error;
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/decoding.js
  var decodeEventABI = (event, data, jsonInterface, returnFormat = DEFAULT_RETURN_FORMAT) => {
    var _a6, _b3, _c2, _d, _e;
    let modifiedEvent = Object.assign({}, event);
    const result = format4(logSchema, data, returnFormat);
    if ([ALL_EVENTS, "allEvents"].includes(modifiedEvent.name)) {
      const matchedEvent = jsonInterface.find((j) => j.signature === data.topics[0]);
      if (matchedEvent) {
        modifiedEvent = matchedEvent;
      } else {
        modifiedEvent = { anonymous: true };
      }
    }
    modifiedEvent.inputs = (_b3 = (_a6 = modifiedEvent.inputs) !== null && _a6 !== void 0 ? _a6 : event.inputs) !== null && _b3 !== void 0 ? _b3 : [];
    if (!modifiedEvent.anonymous) {
      let indexedInputs = 0;
      ((_c2 = modifiedEvent.inputs) !== null && _c2 !== void 0 ? _c2 : []).forEach((input) => {
        if (input.indexed) {
          indexedInputs += 1;
        }
      });
      if (indexedInputs > 0 && (data === null || data === void 0 ? void 0 : data.topics) && (data === null || data === void 0 ? void 0 : data.topics.length) !== indexedInputs + 1) {
        modifiedEvent = Object.assign(Object.assign({}, modifiedEvent), { anonymous: true, inputs: [] });
      }
    }
    const argTopics = modifiedEvent.anonymous ? data.topics : ((_d = data.topics) !== null && _d !== void 0 ? _d : []).slice(1);
    return Object.assign(Object.assign({}, result), { returnValues: decodeLog([...(_e = modifiedEvent.inputs) !== null && _e !== void 0 ? _e : []], data.data, argTopics), event: modifiedEvent.name, signature: modifiedEvent.anonymous || !data.topics || data.topics.length === 0 || !data.topics[0] ? void 0 : data.topics[0], raw: {
      data: data.data,
      topics: data.topics
    } });
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/send_tx_helper.js
  var __awaiter30 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var SendTxHelper = class {
    constructor({ options, web3Context, promiEvent, returnFormat }) {
      this.options = {
        checkRevertBeforeSending: true
      };
      this.options = options;
      this.web3Context = web3Context;
      this.promiEvent = promiEvent;
      this.returnFormat = returnFormat;
    }
    getReceiptWithEvents(data) {
      var _a6, _b3;
      const result = Object.assign({}, data !== null && data !== void 0 ? data : {});
      if (((_a6 = this.options) === null || _a6 === void 0 ? void 0 : _a6.contractAbi) && result.logs && result.logs.length > 0) {
        result.events = {};
        for (const log2 of result.logs) {
          const event = decodeEventABI(ALL_EVENTS_ABI, log2, (_b3 = this.options) === null || _b3 === void 0 ? void 0 : _b3.contractAbi, this.returnFormat);
          if (event.event) {
            result.events[event.event] = event;
          }
        }
      }
      return result;
    }
    checkRevertBeforeSending(tx) {
      return __awaiter30(this, void 0, void 0, function* () {
        if (this.options.checkRevertBeforeSending !== false) {
          const reason = yield getRevertReason(this.web3Context, tx, this.options.contractAbi);
          if (reason !== void 0) {
            throw yield getTransactionError(this.web3Context, tx, void 0, void 0, this.options.contractAbi, reason);
          }
        }
      });
    }
    emitSending(tx) {
      if (this.promiEvent.listenerCount("sending") > 0) {
        this.promiEvent.emit("sending", tx);
      }
    }
    populateGasPrice({ transactionFormatted, transaction }) {
      var _a6;
      return __awaiter30(this, void 0, void 0, function* () {
        let result = transactionFormatted;
        if (!((_a6 = this.options) === null || _a6 === void 0 ? void 0 : _a6.ignoreGasPricing) && isNullish(transactionFormatted.gasPrice) && (isNullish(transaction.maxPriorityFeePerGas) || isNullish(transaction.maxFeePerGas))) {
          result = Object.assign(Object.assign({}, transactionFormatted), yield getTransactionGasPricing(transactionFormatted, this.web3Context, ETH_DATA_FORMAT));
        }
        return result;
      });
    }
    signAndSend({ wallet, tx }) {
      return __awaiter30(this, void 0, void 0, function* () {
        if (wallet) {
          const signedTransaction = yield wallet.signTransaction(tx);
          return trySendTransaction(this.web3Context, () => __awaiter30(this, void 0, void 0, function* () {
            return eth_rpc_methods_exports.sendRawTransaction(this.web3Context.requestManager, signedTransaction.rawTransaction);
          }), signedTransaction.transactionHash);
        }
        return trySendTransaction(this.web3Context, () => __awaiter30(this, void 0, void 0, function* () {
          return eth_rpc_methods_exports.sendTransaction(this.web3Context.requestManager, tx);
        }));
      });
    }
    emitSent(tx) {
      if (this.promiEvent.listenerCount("sent") > 0) {
        this.promiEvent.emit("sent", tx);
      }
    }
    emitTransactionHash(hash2) {
      if (this.promiEvent.listenerCount("transactionHash") > 0) {
        this.promiEvent.emit("transactionHash", hash2);
      }
    }
    emitReceipt(receipt) {
      if (this.promiEvent.listenerCount("receipt") > 0) {
        this.promiEvent.emit(
          "receipt",
          // @ts-expect-error unknown type fix
          receipt
        );
      }
    }
    handleError({ error, tx }) {
      var _a6;
      return __awaiter30(this, void 0, void 0, function* () {
        let _error = error;
        if (_error instanceof ContractExecutionError && this.web3Context.handleRevert) {
          _error = yield getTransactionError(this.web3Context, tx, void 0, void 0, (_a6 = this.options) === null || _a6 === void 0 ? void 0 : _a6.contractAbi);
        }
        if ((_error instanceof InvalidResponseError || _error instanceof ContractExecutionError || _error instanceof TransactionRevertWithCustomError || _error instanceof TransactionRevertedWithoutReasonError || _error instanceof TransactionRevertInstructionError) && this.promiEvent.listenerCount("error") > 0) {
          this.promiEvent.emit("error", _error);
        }
        return _error;
      });
    }
    emitConfirmation({ receipt, transactionHash }) {
      if (this.promiEvent.listenerCount("confirmation") > 0) {
        watchTransactionForConfirmations(this.web3Context, this.promiEvent, receipt, transactionHash, this.returnFormat);
      }
    }
    handleResolve({ receipt, tx }) {
      var _a6, _b3, _c2;
      return __awaiter30(this, void 0, void 0, function* () {
        if ((_a6 = this.options) === null || _a6 === void 0 ? void 0 : _a6.transactionResolver) {
          return (_b3 = this.options) === null || _b3 === void 0 ? void 0 : _b3.transactionResolver(receipt);
        }
        if (receipt.status === BigInt(0)) {
          const error = yield getTransactionError(
            this.web3Context,
            tx,
            // @ts-expect-error unknown type fix
            receipt,
            void 0,
            (_c2 = this.options) === null || _c2 === void 0 ? void 0 : _c2.contractAbi
          );
          if (this.promiEvent.listenerCount("error") > 0) {
            this.promiEvent.emit("error", error);
          }
          throw error;
        } else {
          return receipt;
        }
      });
    }
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/rpc_method_wrappers.js
  var __awaiter31 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __rest = function(s2, e2) {
    var t2 = {};
    for (var p12 in s2) if (Object.prototype.hasOwnProperty.call(s2, p12) && e2.indexOf(p12) < 0)
      t2[p12] = s2[p12];
    if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i2 = 0, p12 = Object.getOwnPropertySymbols(s2); i2 < p12.length; i2++) {
        if (e2.indexOf(p12[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p12[i2]))
          t2[p12[i2]] = s2[p12[i2]];
      }
    return t2;
  };
  var isSyncing = (web3Context) => __awaiter31(void 0, void 0, void 0, function* () {
    return eth_rpc_methods_exports.getSyncing(web3Context.requestManager);
  });
  function getHashRate2(web3Context, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.getHashRate(web3Context.requestManager);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getGasPrice2(web3Context, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.getGasPrice(web3Context.requestManager);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getBlockNumber2(web3Context, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.getBlockNumber(web3Context.requestManager);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getBalance2(web3Context, address, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.getBalance(web3Context.requestManager, address, blockNumberFormatted);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getStorageAt2(web3Context, address, storageSlot, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const storageSlotFormatted = format4({ format: "uint" }, storageSlot, ETH_DATA_FORMAT);
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.getStorageAt(web3Context.requestManager, address, storageSlotFormatted, blockNumberFormatted);
      return format4({ format: "bytes" }, response, returnFormat);
    });
  }
  function getCode2(web3Context, address, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.getCode(web3Context.requestManager, address, blockNumberFormatted);
      return format4({ format: "bytes" }, response, returnFormat);
    });
  }
  function getBlock(web3Context, block = web3Context.defaultBlock, hydrated = false, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      let response;
      if (isBytes(block)) {
        const blockHashFormatted = format4({ format: "bytes32" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getBlockByHash(web3Context.requestManager, blockHashFormatted, hydrated);
      } else {
        const blockNumberFormatted = isBlockTag(block) ? block : format4({ format: "uint" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getBlockByNumber(web3Context.requestManager, blockNumberFormatted, hydrated);
      }
      return format4(blockSchema, response, returnFormat);
    });
  }
  function getBlockTransactionCount(web3Context, block = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      let response;
      if (isBytes(block)) {
        const blockHashFormatted = format4({ format: "bytes32" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getBlockTransactionCountByHash(web3Context.requestManager, blockHashFormatted);
      } else {
        const blockNumberFormatted = isBlockTag(block) ? block : format4({ format: "uint" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getBlockTransactionCountByNumber(web3Context.requestManager, blockNumberFormatted);
      }
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getBlockUncleCount(web3Context, block = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      let response;
      if (isBytes(block)) {
        const blockHashFormatted = format4({ format: "bytes32" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getUncleCountByBlockHash(web3Context.requestManager, blockHashFormatted);
      } else {
        const blockNumberFormatted = isBlockTag(block) ? block : format4({ format: "uint" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getUncleCountByBlockNumber(web3Context.requestManager, blockNumberFormatted);
      }
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getUncle(web3Context, block = web3Context.defaultBlock, uncleIndex, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const uncleIndexFormatted = format4({ format: "uint" }, uncleIndex, ETH_DATA_FORMAT);
      let response;
      if (isBytes(block)) {
        const blockHashFormatted = format4({ format: "bytes32" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getUncleByBlockHashAndIndex(web3Context.requestManager, blockHashFormatted, uncleIndexFormatted);
      } else {
        const blockNumberFormatted = isBlockTag(block) ? block : format4({ format: "uint" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getUncleByBlockNumberAndIndex(web3Context.requestManager, blockNumberFormatted, uncleIndexFormatted);
      }
      return format4(blockSchema, response, returnFormat);
    });
  }
  function getTransaction(web3Context, transactionHash, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const transactionHashFormatted = format4({ format: "bytes32" }, transactionHash, DEFAULT_RETURN_FORMAT);
      const response = yield eth_rpc_methods_exports.getTransactionByHash(web3Context.requestManager, transactionHashFormatted);
      return isNullish(response) ? response : formatTransaction(response, returnFormat, { fillInputAndData: true });
    });
  }
  function getPendingTransactions2(web3Context, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.getPendingTransactions(web3Context.requestManager);
      return response.map((transaction) => formatTransaction(transaction, returnFormat, {
        fillInputAndData: true
      }));
    });
  }
  function getTransactionFromBlock(web3Context, block = web3Context.defaultBlock, transactionIndex, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const transactionIndexFormatted = format4({ format: "uint" }, transactionIndex, ETH_DATA_FORMAT);
      let response;
      if (isBytes(block)) {
        const blockHashFormatted = format4({ format: "bytes32" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getTransactionByBlockHashAndIndex(web3Context.requestManager, blockHashFormatted, transactionIndexFormatted);
      } else {
        const blockNumberFormatted = isBlockTag(block) ? block : format4({ format: "uint" }, block, ETH_DATA_FORMAT);
        response = yield eth_rpc_methods_exports.getTransactionByBlockNumberAndIndex(web3Context.requestManager, blockNumberFormatted, transactionIndexFormatted);
      }
      return isNullish(response) ? response : formatTransaction(response, returnFormat, { fillInputAndData: true });
    });
  }
  function getTransactionReceipt2(web3Context, transactionHash, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const transactionHashFormatted = format4({ format: "bytes32" }, transactionHash, DEFAULT_RETURN_FORMAT);
      const response = yield eth_rpc_methods_exports.getTransactionReceipt(web3Context.requestManager, transactionHashFormatted);
      return isNullish(response) ? response : format4(transactionReceiptSchema, response, returnFormat);
    });
  }
  function getTransactionCount2(web3Context, address, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.getTransactionCount(web3Context.requestManager, address, blockNumberFormatted);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function sendTransaction3(web3Context, transaction, returnFormat, options = { checkRevertBeforeSending: true }) {
    const promiEvent = new Web3PromiEvent((resolve2, reject) => {
      setImmediate(() => {
        (() => __awaiter31(this, void 0, void 0, function* () {
          const sendTxHelper = new SendTxHelper({
            web3Context,
            promiEvent,
            options,
            returnFormat
          });
          let transactionFormatted = formatTransaction(Object.assign(Object.assign({}, transaction), { from: getTransactionFromOrToAttr("from", web3Context, transaction), to: getTransactionFromOrToAttr("to", web3Context, transaction) }), ETH_DATA_FORMAT);
          try {
            transactionFormatted = yield sendTxHelper.populateGasPrice({
              transaction,
              transactionFormatted
            });
            yield sendTxHelper.checkRevertBeforeSending(transactionFormatted);
            sendTxHelper.emitSending(transactionFormatted);
            let wallet;
            if (web3Context.wallet && !isNullish(transactionFormatted.from)) {
              wallet = web3Context.wallet.get(transactionFormatted.from);
            }
            const transactionHash = yield sendTxHelper.signAndSend({
              wallet,
              tx: transactionFormatted
            });
            const transactionHashFormatted = format4({ format: "bytes32" }, transactionHash, returnFormat);
            sendTxHelper.emitSent(transactionFormatted);
            sendTxHelper.emitTransactionHash(transactionHashFormatted);
            const transactionReceipt = yield waitForTransactionReceipt(web3Context, transactionHash, returnFormat);
            const transactionReceiptFormatted = sendTxHelper.getReceiptWithEvents(format4(transactionReceiptSchema, transactionReceipt, returnFormat));
            sendTxHelper.emitReceipt(transactionReceiptFormatted);
            resolve2(yield sendTxHelper.handleResolve({
              receipt: transactionReceiptFormatted,
              tx: transactionFormatted
            }));
            sendTxHelper.emitConfirmation({
              receipt: transactionReceiptFormatted,
              transactionHash
            });
          } catch (error) {
            reject(yield sendTxHelper.handleError({
              error,
              tx: transactionFormatted
            }));
          }
        }))();
      });
    });
    return promiEvent;
  }
  function sendSignedTransaction(web3Context, signedTransaction, returnFormat, options = { checkRevertBeforeSending: true }) {
    const promiEvent = new Web3PromiEvent((resolve2, reject) => {
      setImmediate(() => {
        (() => __awaiter31(this, void 0, void 0, function* () {
          const sendTxHelper = new SendTxHelper({
            web3Context,
            promiEvent,
            options,
            returnFormat
          });
          const signedTransactionFormattedHex = format4({ format: "bytes" }, signedTransaction, ETH_DATA_FORMAT);
          const unSerializedTransaction = TransactionFactory.fromSerializedData(bytesToUint8Array(hexToBytes2(signedTransactionFormattedHex)));
          const unSerializedTransactionWithFrom = Object.assign(Object.assign({}, unSerializedTransaction.toJSON()), {
            // Some providers will default `from` to address(0) causing the error
            // reported from `eth_call` to not be the reason the user's tx failed
            // e.g. `eth_call` will return an Out of Gas error for a failed
            // smart contract execution contract, because the sender, address(0),
            // has no balance to pay for the gas of the transaction execution
            from: unSerializedTransaction.getSenderAddress().toString()
          });
          try {
            const { v, r: r2, s: s2 } = unSerializedTransactionWithFrom, txWithoutSigParams = __rest(unSerializedTransactionWithFrom, ["v", "r", "s"]);
            yield sendTxHelper.checkRevertBeforeSending(txWithoutSigParams);
            sendTxHelper.emitSending(signedTransactionFormattedHex);
            const transactionHash = yield trySendTransaction(web3Context, () => __awaiter31(this, void 0, void 0, function* () {
              return eth_rpc_methods_exports.sendRawTransaction(web3Context.requestManager, signedTransactionFormattedHex);
            }));
            sendTxHelper.emitSent(signedTransactionFormattedHex);
            const transactionHashFormatted = format4({ format: "bytes32" }, transactionHash, returnFormat);
            sendTxHelper.emitTransactionHash(transactionHashFormatted);
            const transactionReceipt = yield waitForTransactionReceipt(web3Context, transactionHash, returnFormat);
            const transactionReceiptFormatted = sendTxHelper.getReceiptWithEvents(format4(transactionReceiptSchema, transactionReceipt, returnFormat));
            sendTxHelper.emitReceipt(transactionReceiptFormatted);
            resolve2(yield sendTxHelper.handleResolve({
              receipt: transactionReceiptFormatted,
              tx: unSerializedTransactionWithFrom
            }));
            sendTxHelper.emitConfirmation({
              receipt: transactionReceiptFormatted,
              transactionHash
            });
          } catch (error) {
            reject(yield sendTxHelper.handleError({
              error,
              tx: unSerializedTransactionWithFrom
            }));
          }
        }))();
      });
    });
    return promiEvent;
  }
  function sign4(web3Context, message, addressOrIndex, returnFormat) {
    var _a6;
    return __awaiter31(this, void 0, void 0, function* () {
      const messageFormatted = format4({ format: "bytes" }, message, DEFAULT_RETURN_FORMAT);
      if ((_a6 = web3Context.wallet) === null || _a6 === void 0 ? void 0 : _a6.get(addressOrIndex)) {
        const wallet = web3Context.wallet.get(addressOrIndex);
        const signed2 = wallet.sign(messageFormatted);
        return format4(SignatureObjectSchema, signed2, returnFormat);
      }
      if (typeof addressOrIndex === "number") {
        throw new SignatureError(message, 'RPC method "eth_sign" does not support index signatures');
      }
      const response = yield eth_rpc_methods_exports.sign(web3Context.requestManager, addressOrIndex, messageFormatted);
      return format4({ format: "bytes" }, response, returnFormat);
    });
  }
  function signTransaction4(web3Context, transaction, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.signTransaction(web3Context.requestManager, formatTransaction(transaction, ETH_DATA_FORMAT));
      return isString(response) ? decodeSignedTransaction(response, returnFormat, {
        fillInputAndData: true
      }) : {
        raw: format4({ format: "bytes" }, response.raw, returnFormat),
        tx: formatTransaction(response.tx, returnFormat, {
          fillInputAndData: true
        })
      };
    });
  }
  function call2(web3Context, transaction, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.call(web3Context.requestManager, formatTransaction(transaction, ETH_DATA_FORMAT), blockNumberFormatted);
      return format4({ format: "bytes" }, response, returnFormat);
    });
  }
  function estimateGas2(web3Context, transaction, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const transactionFormatted = formatTransaction(transaction, ETH_DATA_FORMAT);
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.estimateGas(web3Context.requestManager, transactionFormatted, blockNumberFormatted);
      return format4({ format: "uint" }, response, returnFormat);
    });
  }
  function getLogs2(web3Context, filter2, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      let { toBlock, fromBlock } = filter2;
      if (!isNullish(toBlock)) {
        if (typeof toBlock === "number" || typeof toBlock === "bigint") {
          toBlock = numberToHex2(toBlock);
        }
      }
      if (!isNullish(fromBlock)) {
        if (typeof fromBlock === "number" || typeof fromBlock === "bigint") {
          fromBlock = numberToHex2(fromBlock);
        }
      }
      const formattedFilter = Object.assign(Object.assign({}, filter2), { fromBlock, toBlock });
      const response = yield eth_rpc_methods_exports.getLogs(web3Context.requestManager, formattedFilter);
      const result = response.map((res) => {
        if (typeof res === "string") {
          return res;
        }
        return format4(logSchema, res, returnFormat);
      });
      return result;
    });
  }
  function getChainId2(web3Context, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.getChainId(web3Context.requestManager);
      return format4(
        { format: "uint" },
        // Response is number in hex formatted string
        response,
        returnFormat
      );
    });
  }
  function getProof2(web3Context, address, storageKeys, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const storageKeysFormatted = storageKeys.map((storageKey) => format4({ format: "bytes" }, storageKey, ETH_DATA_FORMAT));
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.getProof(web3Context.requestManager, address, storageKeysFormatted, blockNumberFormatted);
      return format4(accountSchema, response, returnFormat);
    });
  }
  function getFeeHistory2(web3Context, blockCount, newestBlock = web3Context.defaultBlock, rewardPercentiles, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const blockCountFormatted = format4({ format: "uint" }, blockCount, ETH_DATA_FORMAT);
      const newestBlockFormatted = isBlockTag(newestBlock) ? newestBlock : format4({ format: "uint" }, newestBlock, ETH_DATA_FORMAT);
      const rewardPercentilesFormatted = format4({
        type: "array",
        items: {
          format: "uint"
        }
      }, rewardPercentiles, NUMBER_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.getFeeHistory(web3Context.requestManager, blockCountFormatted, newestBlockFormatted, rewardPercentilesFormatted);
      return format4(feeHistorySchema, response, returnFormat);
    });
  }
  function createAccessList2(web3Context, transaction, blockNumber = web3Context.defaultBlock, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const blockNumberFormatted = isBlockTag(blockNumber) ? blockNumber : format4({ format: "uint" }, blockNumber, ETH_DATA_FORMAT);
      const response = yield eth_rpc_methods_exports.createAccessList(web3Context.requestManager, formatTransaction(transaction, ETH_DATA_FORMAT), blockNumberFormatted);
      return format4(accessListResultSchema, response, returnFormat);
    });
  }
  function signTypedData2(web3Context, address, typedData, useLegacy, returnFormat) {
    return __awaiter31(this, void 0, void 0, function* () {
      const response = yield eth_rpc_methods_exports.signTypedData(web3Context.requestManager, address, typedData, useLegacy);
      return format4({ format: "bytes" }, response, returnFormat);
    });
  }

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/web3_subscriptions.js
  var LogsSubscription = class extends Web3Subscription {
    _buildSubscriptionParams() {
      return ["logs", this.args];
    }
    formatSubscriptionResult(data) {
      return format4(logSchema, data, super.returnFormat);
    }
  };
  var NewPendingTransactionsSubscription = class extends Web3Subscription {
    // eslint-disable-next-line
    _buildSubscriptionParams() {
      return ["newPendingTransactions"];
    }
    formatSubscriptionResult(data) {
      return format4({ format: "string" }, data, super.returnFormat);
    }
  };
  var NewHeadsSubscription = class extends Web3Subscription {
    // eslint-disable-next-line
    _buildSubscriptionParams() {
      return ["newHeads"];
    }
    formatSubscriptionResult(data) {
      return format4(blockHeaderSchema, data, super.returnFormat);
    }
  };
  var SyncingSubscription = class extends Web3Subscription {
    // eslint-disable-next-line
    _buildSubscriptionParams() {
      return ["syncing"];
    }
    _processSubscriptionResult(data) {
      if (typeof data === "boolean") {
        this.emit("changed", data);
      } else {
        const mappedData = Object.fromEntries(Object.entries(data.status).map(([key, value]) => [
          key.charAt(0).toLowerCase() + key.substring(1),
          value
        ]));
        this.emit("changed", data.syncing);
        this.emit("data", format4(syncSchema, mappedData, super.returnFormat));
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/web3_eth.js
  var __awaiter32 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var registeredSubscriptions = {
    logs: LogsSubscription,
    newPendingTransactions: NewPendingTransactionsSubscription,
    newHeads: NewHeadsSubscription,
    syncing: SyncingSubscription,
    pendingTransactions: NewPendingTransactionsSubscription,
    newBlockHeaders: NewHeadsSubscription
    // the same as newHeads. just for support API like in version 1.x
  };
  var Web3Eth = class _Web3Eth extends Web3Context {
    constructor(providerOrContext) {
      if (typeof providerOrContext === "string" || isSupportedProvider(providerOrContext)) {
        super({
          provider: providerOrContext,
          registeredSubscriptions
        });
        return;
      }
      if (providerOrContext.registeredSubscriptions) {
        super(providerOrContext);
        return;
      }
      super(Object.assign(Object.assign({}, providerOrContext), { registeredSubscriptions }));
    }
    /**
     * @returns Returns the ethereum protocol version of the node.
     *
     * ```ts
     * web3.eth.getProtocolVersion().then(console.log);
     * > "63"
     * ```
     */
    getProtocolVersion() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.getProtocolVersion(this.requestManager);
      });
    }
    // TODO Add returnFormat parameter
    /**
     * Checks if the node is currently syncing.
     *
     * @returns Either a {@link SyncingStatusAPI}, or `false`.
     *
     * ```ts
     * web3.eth.isSyncing().then(console.log);
     * > {
     *     startingBlock: 100,
     *     currentBlock: 312,
     *     highestBlock: 512,
     *     knownStates: 234566,
     *     pulledStates: 123455
     * }
     * ```
     */
    isSyncing() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.getSyncing(this.requestManager);
      });
    }
    // TODO consider adding returnFormat parameter (to format address as bytes)
    /**
     * @returns Returns the coinbase address to which mining rewards will go.
     *
     * ```ts
     * web3.eth.getCoinbase().then(console.log);
     * > "0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe"
     * ```
     */
    getCoinbase() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.getCoinbase(this.requestManager);
      });
    }
    /**
     * Checks whether the node is mining or not.
     *
     * @returns `true` if the node is mining, otherwise `false`.
     *
     * ```ts
     * web3.eth.isMining().then(console.log);
     * > true
     * ```
     */
    isMining() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.getMining(this.requestManager);
      });
    }
    /**
     * @deprecated Will be removed in the future, please use {@link Web3Eth.getHashRate} method instead.
     *
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The number of hashes per second that the node is mining with.
     *
     * ```ts
     * web3.eth.getHashrate().then(console.log);
     * > 493736n
     *
     * web3.eth.getHashrate({ number: FMT_NUMBER.HEX , bytes: FMT_BYTES.HEX }).then(console.log);
     * > "0x788a8"
     * ```
     */
    getHashrate(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return this.getHashRate(returnFormat);
      });
    }
    /**
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The number of hashes per second that the node is mining with.
     *
     * ```ts
     * web3.eth.getHashRate().then(console.log);
     * > 493736n
     *
     * web3.eth.getHashRate({ number: FMT_NUMBER.HEX , bytes: FMT_BYTES.HEX }).then(console.log);
     * > "0x788a8"
     * ```
     */
    getHashRate(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getHashRate2(this, returnFormat);
      });
    }
    /**
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The gas price determined by the last few blocks median gas price.
     *
     * ```ts
     * web3.eth.getGasPrice().then(console.log);
     * > 20000000000n
     *
     * web3.eth.getGasPrice({ number: FMT_NUMBER.HEX , bytes: FMT_BYTES.HEX }).then(console.log);
     * > "0x4a817c800"
     * ```
     */
    getGasPrice(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getGasPrice2(this, returnFormat);
      });
    }
    /**
     * @returns A list of accounts the node controls (addresses are checksummed).
     *
     * ```ts
     * web3.eth.getAccounts().then(console.log);
     * > ["0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe", "0xDCc6960376d6C6dEa93647383FfB245CfCed97Cf"]
     * ```
     */
    getAccounts() {
      var _a6;
      return __awaiter32(this, void 0, void 0, function* () {
        const hexAddresses = (_a6 = yield eth_rpc_methods_exports.getAccounts(this.requestManager)) !== null && _a6 !== void 0 ? _a6 : [];
        return hexAddresses.map((address) => toChecksumAddress(address));
      });
    }
    /**
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The current block number.
     *
     * ```ts
     * web3.eth.getBlockNumber().then(console.log);
     * > 2744n
     *
     * web3.eth.getBlockNumber({ number: FMT_NUMBER.HEX , bytes: FMT_BYTES.HEX }).then(console.log);
     * > "0xab8"
     * ```
     */
    getBlockNumber(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getBlockNumber2(this, returnFormat);
      });
    }
    /**
     * Get the balance of an address at a given block.
     *
     * @param address The address to get the balance of.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) Specifies what block to use as the current state for the balance query.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The current balance for the given address in `wei`.
     *
     * ```ts
     * web3.eth.getBalance("0x407d73d8a49eeb85d32cf465507dd71d507100c1").then(console.log);
     * > 1000000000000n
     *
     * web3.eth.getBalance("0x407d73d8a49eeb85d32cf465507dd71d507100c1").then(console.log);
     * > "0xe8d4a51000"
     * ```
     */
    getBalance(address, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getBalance2(this, address, blockNumber, returnFormat);
      });
    }
    /**
     * Get the storage at a specific position of an address.
     *
     * @param address The address to get the storage from.
     * @param storageSlot The index position of the storage.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) Specifies what block to use as the current state for the storage query.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The value in storage at the given position.
     *
     * ```ts
     * web3.eth.getStorageAt("0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234", 0).then(console.log);
     * > "0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234"
     *
     * web3.eth.getStorageAt(
     *      "0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234",
     *      0,
     *      undefined,
     *      { number: FMT_NUMBER.HEX , bytes: FMT_BYTES.UINT8ARRAY }
     * ).then(console.log);
     * > Uint8Array(31) [
     *       3, 52,  86, 115,  33,  35, 255, 255,
     *       35, 66,  52,  45, 209,  35,  66,  67,
     *       67, 36,  35,  66,  52, 253,  35,  79,
     *       210, 63, 212, 242,  61,  66,  52
     *    ]
     * ```
     */
    getStorageAt(address, storageSlot, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getStorageAt2(this, address, storageSlot, blockNumber, returnFormat);
      });
    }
    /**
     * Get the code at a specific address.
     *
     * @param address The address to get the code from.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) Specifies what block to use as the current state for the code query.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The [data](https://ethereum.org/en/developers/docs/transactions/#the-data-field) at the provided `address`.
     *
     * ```ts
     * web3.eth.getCode("0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234").then(console.log);
     * > "0x600160008035811a818181146012578301005b601b6001356025565b8060005260206000f25b600060078202905091905056"
     *
     * web3.eth.getCode(
     *      "0x407d73d8a49eeb85d32cf465507dd71d507100c1",
     *      undefined,
     *      { number: FMT_NUMBER.HEX , bytes: FMT_BYTES.UINT8ARRAY }
     * ).then(console.log);
     * > Uint8Array(50) [
     *   96,  1,  96,   0, 128, 53, 129, 26, 129, 129, 129,
     *   20, 96,  18,  87, 131,  1,   0, 91,  96,  27,  96,
     *   1, 53,  96,  37,  86, 91, 128, 96,   0,  82,  96,
     *   32, 96,   0, 242,  91, 96,   0, 96,   7, 130,   2,
     *   144, 80, 145, 144,  80, 86
     * ]
     * ```
     */
    getCode(address, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getCode2(this, address, blockNumber, returnFormat);
      });
    }
    /**
     * Retrieves a {@link Block} matching the provided block number, block hash or block tag.
     *
     * @param block The {@link BlockNumberOrTag} (defaults to {@link Web3Eth.defaultBlock}) or block hash of the desired block.
     * @param hydrated If specified `true`, the returned block will contain all transactions as objects. If `false` it will only contain transaction hashes.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted (does not format transaction objects or hashes).
     * @returns A {@link Block} object matching the provided block number or block hash.
     *
     * ```ts
     * web3.eth.getBlock(0).then(console.log);
     * > {
     *    hash: '0x7dbfdc6a7a67a670cb9b0c3f81ca60c007762f1e4e598cb027a470678ff26d0d',
     *    parentHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    sha3Uncles: '0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347',
     *    miner: '0x0000000000000000000000000000000000000000',
     *    stateRoot: '0x5ed9882897d363c4632a6e67fba6203df61bd994813dcf048da59be442a9c6c4',
     *    transactionsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    receiptsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *    difficulty: 1n,
     *    number: 0n,
     *    gasLimit: 30000000n,
     *    gasUsed: 0n,
     *    timestamp: 1658281638n,
     *    extraData: '0x',
     *    mixHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    nonce: 0n,
     *    totalDifficulty: 1n,
     *    baseFeePerGas: 1000000000n,
     *    size: 514n,
     *    transactions: [],
     *    uncles: []
     *  }
     *
     * web3.eth.getBlock(
     *      "0x7dbfdc6a7a67a670cb9b0c3f81ca60c007762f1e4e598cb027a470678ff26d0d",
     *      false,
     *      { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > {
     *    hash: '0x7dbfdc6a7a67a670cb9b0c3f81ca60c007762f1e4e598cb027a470678ff26d0d',
     *    parentHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    sha3Uncles: '0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347',
     *    miner: '0x0000000000000000000000000000000000000000',
     *    stateRoot: '0x5ed9882897d363c4632a6e67fba6203df61bd994813dcf048da59be442a9c6c4',
     *    transactionsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    receiptsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *    difficulty: 1,
     *    number: 0,
     *    gasLimit: 30000000,
     *    gasUsed: 0,
     *    timestamp: 1658281638,
     *    extraData: '0x',
     *    mixHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    nonce: 0,
     *    totalDifficulty: 1,
     *    baseFeePerGas: 1000000000,
     *    size: 514,
     *    transactions: [],
     *    uncles: []
     *  }
     * ```
     */
    getBlock(block = this.defaultBlock, hydrated = false, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getBlock(this, block, hydrated, returnFormat);
      });
    }
    /**
     * @param block The {@link BlockNumberOrTag} (defaults to {@link Web3Eth.defaultBlock}) or block hash of the desired block.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The number of transactions in the provided block.
     *
     * ```ts
     * web3.eth.getBlockTransactionCount("0x407d73d8a49eeb85d32cf465507dd71d507100c1").then(console.log);
     * > 1n
     *
     * web3.eth.getBlockTransactionCount(
     *     "0x407d73d8a49eeb85d32cf465507dd71d507100c1",
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > 1
     * ```
     */
    getBlockTransactionCount(block = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getBlockTransactionCount(this, block, returnFormat);
      });
    }
    /**
     * @param block The {@link BlockNumberOrTag} (defaults to {@link Web3Eth.defaultBlock}) or block hash of the desired block.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The number of [uncles](https://ethereum.org/en/glossary/#ommer) in the provided block.
     *
     * ```ts
     * web3.eth.getBlockUncleCount("0x407d73d8a49eeb85d32cf465507dd71d507100c1").then(console.log);
     * > 1n
     *
     * web3.eth.getBlockUncleCount(
     *     "0x407d73d8a49eeb85d32cf465507dd71d507100c1",
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > 1
     * ```
     */
    getBlockUncleCount(block = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getBlockUncleCount(this, block, returnFormat);
      });
    }
    /**
     *
     * @param block The {@link BlockNumberOrTag} (defaults to {@link Web3Eth.defaultBlock}) or block hash of the desired block.
     * @param uncleIndex The index position of the uncle.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns A blocks [uncle](https://ethereum.org/en/glossary/#ommer) by a given uncle index position.
     *
     * ```ts
     * web3.eth.getUncle(0, 1).then(console.log);
     * > {
     *    hash: '0x7dbfdc6a7a67a670cb9b0c3f81ca60c007762f1e4e598cb027a470678ff26d0d',
     *    parentHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    sha3Uncles: '0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347',
     *    miner: '0x0000000000000000000000000000000000000000',
     *    stateRoot: '0x5ed9882897d363c4632a6e67fba6203df61bd994813dcf048da59be442a9c6c4',
     *    transactionsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    receiptsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *    difficulty: 1n,
     *    number: 0n,
     *    gasLimit: 30000000n,
     *    gasUsed: 0n,
     *    timestamp: 1658281638n,
     *    extraData: '0x',
     *    mixHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    nonce: 0n,
     *    totalDifficulty: 1n,
     *    baseFeePerGas: 1000000000n,
     *    size: 514n,
     *    transactions: [],
     *    uncles: []
     *  }
     *
     * web3.eth.getUncle(
     *      "0x7dbfdc6a7a67a670cb9b0c3f81ca60c007762f1e4e598cb027a470678ff26d0d",
     *      1,
     *      { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > {
     *    hash: '0x7dbfdc6a7a67a670cb9b0c3f81ca60c007762f1e4e598cb027a470678ff26d0d',
     *    parentHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    sha3Uncles: '0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347',
     *    miner: '0x0000000000000000000000000000000000000000',
     *    stateRoot: '0x5ed9882897d363c4632a6e67fba6203df61bd994813dcf048da59be442a9c6c4',
     *    transactionsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    receiptsRoot: '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421',
     *    logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *    difficulty: 1,
     *    number: 0,
     *    gasLimit: 30000000,
     *    gasUsed: 0,
     *    timestamp: 1658281638,
     *    extraData: '0x',
     *    mixHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *    nonce: 0,
     *    totalDifficulty: 1,
     *    baseFeePerGas: 1000000000,
     *    size: 514,
     *    transactions: [],
     *    uncles: []
     *  }
     * ```
     */
    getUncle(block = this.defaultBlock, uncleIndex, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getUncle(this, block, uncleIndex, returnFormat);
      });
    }
    /**
     * @param transactionHash The hash of the desired transaction.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The desired transaction object.
     *
     * ```ts
     * web3.eth.getTransaction('0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc').then(console.log);
     * {
     *    hash: '0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc',
     *    type: 0n,
     *    nonce: 0n,
     *    blockHash: '0x43202bd16b6bd54bea1b310736bd78bdbe93a64ad940f7586739d9eb25ad8d00',
     *    blockNumber: 1n,
     *    transactionIndex: 0n,
     *    from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *    to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *    value: 1n,
     *    gas: 90000n,
     *    gasPrice: 2000000000n,
     *    input: '0x',
     *    v: 2709n,
     *    r: '0x8b336c290f6d7b2af3ccb2c02203a8356cc7d5b150ab19cce549d55636a3a78c',
     *    s: '0x5a83c6f816befc5cd4b0c997a347224a8aa002e5799c4b082a3ec726d0e9531d'
     *  }
     *
     * web3.eth.getTransaction(
     *     web3.utils.hexToBytes("0x30755ed65396facf86c53e6217c52b4daebe72aa4941d89635409de4c9c7f9466d4e9aaec7977f05e923889b33c0d0dd27d7226b6e6f56ce737465c5cfd04be400"),
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * {
     *    hash: '0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc',
     *    type: 0,
     *    nonce: 0,
     *    blockHash: '0x43202bd16b6bd54bea1b310736bd78bdbe93a64ad940f7586739d9eb25ad8d00',
     *    blockNumber: 1,
     *    transactionIndex: 0,
     *    from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *    to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *    value: 1,
     *    gas: 90000,
     *    gasPrice: 2000000000,
     *    input: '0x',
     *    v: 2709,
     *    r: '0x8b336c290f6d7b2af3ccb2c02203a8356cc7d5b150ab19cce549d55636a3a78c',
     *    s: '0x5a83c6f816befc5cd4b0c997a347224a8aa002e5799c4b082a3ec726d0e9531d'
     *  }
     * ```
     */
    getTransaction(transactionHash, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        const response = yield getTransaction(this, transactionHash, returnFormat);
        if (!response)
          throw new TransactionNotFound();
        return response;
      });
    }
    /**
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns A list of pending transactions.
     *
     * ```ts
     * web3.eth.getPendingTransactions().then(console.log);
     * > [
     *      {
     *          hash: '0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc',
     *          type: 0n,
     *          nonce: 0n,
     *          blockHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *          blockNumber: null,
     *          transactionIndex: 0n,
     *          from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *          to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *          value: 1n,
     *          gas: 90000n,
     *          gasPrice: 2000000000n,
     *          input: '0x',
     *          v: 2709n,
     *          r: '0x8b336c290f6d7b2af3ccb2c02203a8356cc7d5b150ab19cce549d55636a3a78c',
     *          s: '0x5a83c6f816befc5cd4b0c997a347224a8aa002e5799c4b082a3ec726d0e9531d'
     *      },
     *      {
     *          hash: '0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f',
     *          type: 0n,
     *          nonce: 1n,
     *          blockHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *          blockNumber: null,
     *          transactionIndex: 0n,
     *          from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *          to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *          value: 1n,
     *          gas: 90000n,
     *          gasPrice: 2000000000n,
     *          input: '0x',
     *          v: 2710n,
     *          r: '0x55ac19fade21db035a1b7ea0a8d49e265e05dbb926e75f273f836ad67ce5c96a',
     *          s: '0x6550036a7c3fd426d5c3d35d96a7075cd673957620b7889846a980d2d017ec08'
     *      }
     *   ]
     *
     * * web3.eth.getPendingTransactions({ number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }).then(console.log);
     * > [
     *      {
     *          hash: '0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc',
     *          type: 0,
     *          nonce: 0,
     *          blockHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *          blockNumber: null,
     *          transactionIndex: 0,
     *          from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *          to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *          value: 1,
     *          gas: 90000,
     *          gasPrice: 2000000000,
     *          input: '0x',
     *          v: 2709,
     *          r: '0x8b336c290f6d7b2af3ccb2c02203a8356cc7d5b150ab19cce549d55636a3a78c',
     *          s: '0x5a83c6f816befc5cd4b0c997a347224a8aa002e5799c4b082a3ec726d0e9531d'
     *      },
     *      {
     *          hash: '0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f',
     *          type: 0,
     *          nonce: 1,
     *          blockHash: '0x0000000000000000000000000000000000000000000000000000000000000000',
     *          blockNumber: null,
     *          transactionIndex: 0,
     *          from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *          to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *          value: 1,
     *          gas: 90000,
     *          gasPrice: 2000000000,
     *          input: '0x',
     *          v: 2710,
     *          r: '0x55ac19fade21db035a1b7ea0a8d49e265e05dbb926e75f273f836ad67ce5c96a',
     *          s: '0x6550036a7c3fd426d5c3d35d96a7075cd673957620b7889846a980d2d017ec08'
     *      }
     *   ]
     * ```
     */
    getPendingTransactions(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getPendingTransactions2(this, returnFormat);
      });
    }
    /**
     * @param block The {@link BlockNumberOrTag} (defaults to {@link Web3Eth.defaultBlock}) or block hash of the desired block.
     * @param transactionIndex The index position of the transaction.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The desired transaction object.
     *
     * ```ts
     * web3.eth.getTransactionFromBlock('0x43202bd16b6bd54bea1b310736bd78bdbe93a64ad940f7586739d9eb25ad8d00', 0).then(console.log);
     * {
     *    hash: '0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc',
     *    type: 0n,
     *    nonce: 0n,
     *    blockHash: '0x43202bd16b6bd54bea1b310736bd78bdbe93a64ad940f7586739d9eb25ad8d00',
     *    blockNumber: 1n,
     *    transactionIndex: 0n,
     *    from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *    to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *    value: 1n,
     *    gas: 90000n,
     *    gasPrice: 2000000000n,
     *    input: '0x',
     *    v: 2709n,
     *    r: '0x8b336c290f6d7b2af3ccb2c02203a8356cc7d5b150ab19cce549d55636a3a78c',
     *    s: '0x5a83c6f816befc5cd4b0c997a347224a8aa002e5799c4b082a3ec726d0e9531d'
     *  }
     *
     * web3.eth.getTransactionFromBlock(
     *     hexToBytes("0x30755ed65396facf86c53e6217c52b4daebe72aa4941d89635409de4c9c7f9466d4e9aaec7977f05e923889b33c0d0dd27d7226b6e6f56ce737465c5cfd04be400"),
     *     0,
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * {
     *    hash: '0x73aea70e969941f23f9d24103e91aa1f55c7964eb13daf1c9360c308a72686dc',
     *    type: 0,
     *    nonce: 0,
     *    blockHash: '0x43202bd16b6bd54bea1b310736bd78bdbe93a64ad940f7586739d9eb25ad8d00',
     *    blockNumber: 1,
     *    transactionIndex: 0,
     *    from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *    to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *    value: 1,
     *    gas: 90000,
     *    gasPrice: 2000000000,
     *    input: '0x',
     *    v: 2709,
     *    r: '0x8b336c290f6d7b2af3ccb2c02203a8356cc7d5b150ab19cce549d55636a3a78c',
     *    s: '0x5a83c6f816befc5cd4b0c997a347224a8aa002e5799c4b082a3ec726d0e9531d'
     *  }
     * ```
     */
    getTransactionFromBlock(block = this.defaultBlock, transactionIndex, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getTransactionFromBlock(this, block, transactionIndex, returnFormat);
      });
    }
    /**
     * @param transactionHash Hash of the transaction to retrieve the receipt for.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The desired {@link TransactionReceipt} object.
     *
     * ```ts
     * web3.eth.getTransactionReceipt("0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f").then(console.log);
     * > {
     *      transactionHash: '0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f',
     *      transactionIndex: 0n,
     *      blockNumber: 2n,
     *      blockHash: '0xeb1565a08b23429552dafa92e32409f42eb43944f7611963c63ce40e7243941a',
     *      from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *      to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *      cumulativeGasUsed: 21000n,
     *      gasUsed: 21000n,
     *      logs: [],
     *      logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *      status: 1n,
     *      effectiveGasPrice: 2000000000n,
     *      type: 0n
     *  }
     *
     * web3.eth.getTransactionReceipt(
     *      "0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f",
     *      { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > {
     *      transactionHash: '0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f',
     *      transactionIndex: 0,
     *      blockNumber: 2,
     *      blockHash: '0xeb1565a08b23429552dafa92e32409f42eb43944f7611963c63ce40e7243941a',
     *      from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *      to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *      cumulativeGasUsed: 21000,
     *      gasUsed: 21000,
     *      logs: [],
     *      logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *      status: 1,
     *      effectiveGasPrice: 2000000000,
     *      type: 0n
     *  }
     * ```
     */
    getTransactionReceipt(transactionHash, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        const response = yield getTransactionReceipt2(this, transactionHash, returnFormat);
        if (!response)
          throw new TransactionNotFound();
        return response;
      });
    }
    /**
     * @param address The address to get the number of transactions for.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) Specifies what block to use as the current state for the query.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The number of transactions sent from the provided address.
     *
     * ```ts
     * web3.eth.getTransactionCount("0x407d73d8a49eeb85d32cf465507dd71d507100c1").then(console.log);
     * > 1n
     *
     * web3.eth.getTransactionCount(
     *     "0x407d73d8a49eeb85d32cf465507dd71d507100c1",
     *     undefined,
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > 1
     * ```
     */
    getTransactionCount(address, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getTransactionCount2(this, address, blockNumber, returnFormat);
      });
    }
    /**
     * @param transaction The {@link Transaction}, {@link TransactionWithFromLocalWalletIndex}, {@link TransactionWithToLocalWalletIndex} or {@link TransactionWithFromAndToLocalWalletIndex} to send. __Note:__ In the `to` and `from` fields when hex strings are used, it is assumed they are addresses, for any other form (number, string number, etc.) it is assumed they are wallet indexes.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @param options A configuration object used to change the behavior of the `sendTransaction` method.
     * @returns If `await`ed or `.then`d (i.e. the promise resolves), the transaction hash is returned.
     * ```ts
     * const transaction = {
     *   from: '0x6E599DA0bfF7A6598AC1224E4985430Bf16458a4',
     *   to: '0x6f1DF96865D09d21e8f3f9a7fbA3b17A11c7C53C',
     *   value: '0x1'
     * }
     *
     * const transactionHash = await web3.eth.sendTransaction(transaction);
     * console.log(transactionHash);
     * > 0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f
     *
     * web3.eth.sendTransaction(transaction).then(console.log);
     * > 0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f
     *
     * web3.eth.sendTransaction(transaction).catch(console.log);
     * > <Some TransactionError>
     *
     * // Example using options.ignoreGasPricing = true
     * web3.eth.sendTransaction(transaction, undefined, { ignoreGasPricing: true }).then(console.log);
     * > 0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f
     * ```
     *
     *
     * Otherwise, a {@link Web3PromiEvent} is returned which has several events than can be listened to using the `.on` syntax, such as:
     * - `sending`
     * ```ts
     * web3.eth.sendTransaction(transaction).on('sending', transactionToBeSent => console.log(transactionToBeSent));
     * > {
     *    from: '0x6E599DA0bfF7A6598AC1224E4985430Bf16458a4',
     *    to: '0x6f1DF96865D09d21e8f3f9a7fbA3b17A11c7C53C',
     *    value: '0x1',
     *    gasPrice: '0x77359400',
     *    maxPriorityFeePerGas: undefined,
     *    maxFeePerGas: undefined
     * }
     * ```
     * - `sent`
     * ```ts
     * web3.eth.sendTransaction(transaction).on('sent', sentTransaction => console.log(sentTransaction));
     * > {
     *    from: '0x6E599DA0bfF7A6598AC1224E4985430Bf16458a4',
     *    to: '0x6f1DF96865D09d21e8f3f9a7fbA3b17A11c7C53C',
     *    value: '0x1',
     *    gasPrice: '0x77359400',
     *    maxPriorityFeePerGas: undefined,
     *    maxFeePerGas: undefined
     * }
     * ```
     * - `transactionHash`
     * ```ts
     * web3.eth.sendTransaction(transaction).on('transactionHash', transactionHash => console.log(transactionHash));
     * > 0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f
     * ```
     * - `receipt`
     * ```ts
     * web3.eth.sendTransaction(transaction).on('receipt', receipt => console.log(receipt));
     * > {
     *      transactionHash: '0xdf7756865c2056ce34c4eabe4eff42ad251a9f920a1c620c00b4ea0988731d3f',
     *      transactionIndex: 0n,
     *      blockNumber: 2n,
     *      blockHash: '0xeb1565a08b23429552dafa92e32409f42eb43944f7611963c63ce40e7243941a',
     *      from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *      to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *      cumulativeGasUsed: 21000n,
     *      gasUsed: 21000n,
     *      logs: [],
     *      logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *      status: 1n,
     *      effectiveGasPrice: 2000000000n,
     *      type: 0n
     * }
     * ```
     * - `confirmation`
     * ```ts
     * web3.eth.sendTransaction(transaction).on('confirmation', confirmation => console.log(confirmation));
     * > {
     *     confirmations: 1n,
     *     receipt: {
     *         transactionHash: '0xb4a3a35ae0f3e77ef0ff7be42010d948d011b21a4e341072ee18717b67e99ab8',
     *         transactionIndex: 0n,
     *         blockNumber: 5n,
     *         blockHash: '0xb57fbe6f145cefd86a305a9a024a4351d15d4d39607d7af53d69a319bc3b5548',
     *         from: '0x6e599da0bff7a6598ac1224e4985430bf16458a4',
     *         to: '0x6f1df96865d09d21e8f3f9a7fba3b17a11c7c53c',
     *         cumulativeGasUsed: 21000n,
     *         gasUsed: 21000n,
     *         logs: [],
     *         logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *         status: 1n,
     *         effectiveGasPrice: 2000000000n,
     *         type: 0n
     *     },
     *     latestBlockHash: '0xb57fbe6f145cefd86a305a9a024a4351d15d4d39607d7af53d69a319bc3b5548'
     * }
     * ```
     * - `error`
     * ```ts
     * web3.eth.sendTransaction(transaction).on('error', error => console.log);
     * > <Some TransactionError>
     * ```
     */
    sendTransaction(transaction, returnFormat = DEFAULT_RETURN_FORMAT, options) {
      return sendTransaction3(this, transaction, returnFormat, options);
    }
    /**
     * @param transaction Signed transaction in one of the valid {@link Bytes} format.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns If `await`ed or `.then`d (i.e. the promise resolves), the transaction hash is returned.
     * ```ts
     * const signedTransaction = "0xf86580843b9aca0182520894e899f0130fd099c0b896b2ce4e5e15a25b23139a0180820a95a03a42d53ca5b71f845e1cd4c65359b05446a85d16881372d3bfaab8980935cb04a0711497bc8dd3b541152e2fed14fe650a647f1f0edab0d386ad9506f0e642410f"
     *
     * const transactionHash = await web3.eth.sendSignedTransaction(signedTransaction);
     * console.log(transactionHash);
     * > 0xed8c241ea44d57f4605dc22c63500de46254d6c7844fd65fa438b128c80cf700
     *
     * web3.eth.sendSignedTransaction(signedTransaction).then(console.log);
     * > 0xed8c241ea44d57f4605dc22c63500de46254d6c7844fd65fa438b128c80cf700
     *
     * web3.eth.sendSignedTransaction(signedTransaction).catch(console.log);
     * > <Some TransactionError>
     * ```
     *
     *
     * Otherwise, a {@link Web3PromiEvent} is returned which has several events than can be listened to using the `.on` syntax, such as:
     * - `sending`
     * ```ts
     * web3.eth.sendSignedTransaction(signedTransaction).on('sending', transactionToBeSent => console.log(transactionToBeSent));
     * > "0xf86580843b9aca0182520894e899f0130fd099c0b896b2ce4e5e15a25b23139a0180820a95a03a42d53ca5b71f845e1cd4c65359b05446a85d16881372d3bfaab8980935cb04a0711497bc8dd3b541152e2fed14fe650a647f1f0edab0d386ad9506f0e642410f"
     * ```
     * - `sent`
     * ```ts
     * web3.eth.sendSignedTransaction(signedTransaction).on('sent', sentTransaction => console.log(sentTransaction));
     * > "0xf86580843b9aca0182520894e899f0130fd099c0b896b2ce4e5e15a25b23139a0180820a95a03a42d53ca5b71f845e1cd4c65359b05446a85d16881372d3bfaab8980935cb04a0711497bc8dd3b541152e2fed14fe650a647f1f0edab0d386ad9506f0e642410f"
     * ```
     * - `transactionHash`
     * ```ts
     * web3.eth.sendSignedTransaction(signedTransaction).on('transactionHash', transactionHash => console.log(transactionHash));
     * > 0xed8c241ea44d57f4605dc22c63500de46254d6c7844fd65fa438b128c80cf700
     * ```
     * - `receipt`
     * ```ts
     * web3.eth.sendSignedTransaction(signedTransaction).on('receipt', receipt => console.log(receipt));
     * > {
     *      blockHash: '0xff2b1687995d81066361bc6affe4455746120a7d4bb75fc938211a2692a50081',
     *      blockNumber: 1n,
     *      cumulativeGasUsed: 21000n,
     *      effectiveGasPrice: 1000000001n,
     *      from: '0xe899f0130fd099c0b896b2ce4e5e15a25b23139a',
     *      gasUsed: 21000n,
     *      logs: [],
     *      logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *      status: 1n,
     *      to: '0xe899f0130fd099c0b896b2ce4e5e15a25b23139a',
     *      transactionHash: '0xed8c241ea44d57f4605dc22c63500de46254d6c7844fd65fa438b128c80cf700',
     *      transactionIndex: 0n,
     *      type: 0n
     * }
     * ```
     * - `confirmation`
     * ```ts
     * web3.eth.sendSignedTransaction(signedTransaction).on('confirmation', confirmation => console.log(confirmation));
     * > {
     *     confirmations: 1n,
     *     receipt: {
     *          blockHash: '0xff2b1687995d81066361bc6affe4455746120a7d4bb75fc938211a2692a50081',
     *          blockNumber: 1n,
     *          cumulativeGasUsed: 21000n,
     *          effectiveGasPrice: 1000000001n,
     *          from: '0xe899f0130fd099c0b896b2ce4e5e15a25b23139a',
     *          gasUsed: 21000n,
     *          logs: [],
     *          logsBloom: '0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000',
     *          status: 1n,
     *          to: '0xe899f0130fd099c0b896b2ce4e5e15a25b23139a',
     *          transactionHash: '0xed8c241ea44d57f4605dc22c63500de46254d6c7844fd65fa438b128c80cf700',
     *          transactionIndex: 0n,
     *          type: 0n
     *     },
     *     latestBlockHash: '0xff2b1687995d81066361bc6affe4455746120a7d4bb75fc938211a2692a50081'
     * }
     * ```
     * - `error`
     * ```ts
     * web3.eth.sendSignedTransaction(signedTransaction).on('error', error => console.log(error));
     * > <Some TransactionError>
     * ```
     */
    sendSignedTransaction(transaction, returnFormat = DEFAULT_RETURN_FORMAT, options) {
      return sendSignedTransaction(this, transaction, returnFormat, options);
    }
    /**
     * @param message Data to sign in one of the valid {@link Bytes} format.
     * @param address Address to sign data with, can be an address or the index of a local wallet.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns The signed `message`.
     *
     * ```ts
     * // Using an unlocked account managed by connected RPC client
     * web3.eth.sign("0x48656c6c6f20776f726c64", "0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe").then(console.log);
     * > "0x30755ed65396facf86c53e6217c52b4daebe72aa4941d89635409de4c9c7f9466d4e9aaec7977f05e923889b33c0d0dd27d7226b6e6f56ce737465c5cfd04be400"
     *
     * // Using an unlocked account managed by connected RPC client
     * web3.eth.sign("0x48656c6c6f20776f726c64", "0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe", { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.UINT8ARRAY }).then(console.log);
     * > Uint8Array(65) [
     *    48, 117,  94, 214,  83, 150, 250, 207, 134, 197,  62,
     *    98,  23, 197,  43,  77, 174, 190, 114, 170,  73,  65,
     *   216, 150,  53,  64, 157, 228, 201, 199, 249,  70, 109,
     *    78, 154, 174, 199, 151, 127,   5, 233,  35, 136, 155,
     *    51, 192, 208, 221,  39, 215,  34, 107, 110, 111,  86,
     *   206, 115, 116, 101, 197, 207, 208,  75, 228,   0
     * ]
     * ```
     *
     * // Using an indexed account managed by local Web3 wallet
     * web3.eth.sign("0x48656c6c6f20776f726c64", 0).then(console.log);
     * > "0x30755ed65396facf86c53e6217c52b4daebe72aa4941d89635409de4c9c7f9466d4e9aaec7977f05e923889b33c0d0dd27d7226b6e6f56ce737465c5cfd04be400"
     */
    sign(message, address, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return sign4(this, message, address, returnFormat);
      });
    }
    /**
     * @param transaction The transaction object to sign.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) Specifies how the return data should be formatted.
     * @returns {@link SignedTransactionInfoAPI}, an object containing the [RLP](https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/#top) encoded signed transaction (accessed via the `raw` property) and the signed transaction object (accessed via the `tx` property).
     *
     * ```ts
     * const transaction = {
     *      from: '0xe899f0130FD099c0b896B2cE4E5E15A25b23139a',
     *      to: '0xe899f0130FD099c0b896B2cE4E5E15A25b23139a',
     *      value: '0x1',
     *      gas: '21000',
     *      gasPrice: await web3Eth.getGasPrice(),
     *      nonce: '0x1',
     *      type: '0x0'
     * }
     *
     * web3.eth.signTransaction(transaction).then(console.log);
     * > {
     *   raw: '0xf86501843b9aca0182520894e899f0130fd099c0b896b2ce4e5e15a25b23139a0180820a96a0adb3468dbb4dce89fe1785ea9182e85fb56b399b378f82b93af7a8a12a4f9679a027d37d736e9bcf00121f78b2d10e4404fa5c45856d62b746574345f5cd278097',
     *   tx: {
     *      type: 0n,
     *      nonce: 1n,
     *      gasPrice: 1000000001n,
     *      gas: 21000n,
     *      value: 1n,
     *      v: 2710n,
     *      r: '0xadb3468dbb4dce89fe1785ea9182e85fb56b399b378f82b93af7a8a12a4f9679',
     *      s: '0x27d37d736e9bcf00121f78b2d10e4404fa5c45856d62b746574345f5cd278097',
     *      to: '0xe899f0130fd099c0b896b2ce4e5e15a25b23139a',
     *      data: '0x'
     *   }
     * }
     *
     * web3.eth.signTransaction(transaction, { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }).then(console.log);
     * > {
     *   raw: '0xf86501843b9aca0182520894e899f0130fd099c0b896b2ce4e5e15a25b23139a0180820a96a0adb3468dbb4dce89fe1785ea9182e85fb56b399b378f82b93af7a8a12a4f9679a027d37d736e9bcf00121f78b2d10e4404fa5c45856d62b746574345f5cd278097',
     *   tx: {
     *      type: 0,
     *      nonce: 1,
     *      gasPrice: 1000000001,
     *      gas: 21000,
     *      value: 1,
     *      v: 2710,
     *      r: '0xadb3468dbb4dce89fe1785ea9182e85fb56b399b378f82b93af7a8a12a4f9679',
     *      s: '0x27d37d736e9bcf00121f78b2d10e4404fa5c45856d62b746574345f5cd278097',
     *      to: '0xe899f0130fd099c0b896b2ce4e5e15a25b23139a',
     *      data: '0x'
     *   }
     * }
     * ```
     */
    signTransaction(transaction, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return signTransaction4(this, transaction, returnFormat);
      });
    }
    // TODO Decide what to do with transaction.to
    // https://github.com/ChainSafe/web3.js/pull/4525#issuecomment-982330076
    /**
     * Executes a message call within the EVM without creating a transaction.
     * It does not publish anything to the blockchain and does not consume any gas.
     *
     * @param transaction - A transaction object where all properties are optional except `to`, however it's recommended to include the `from` property or it may default to `0x0000000000000000000000000000000000000000` depending on your node or provider.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) - Specifies what block to use as the current state of the blockchain while processing the transaction.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     * @returns The returned data of the call, e.g. a smart contract function's return value.
     */
    call(transaction, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return call2(this, transaction, blockNumber, returnFormat);
      });
    }
    /**
     * Simulates the transaction within the EVM to estimate the amount of gas to be used by the transaction.
     * The transaction will not be added to the blockchain, and actual gas usage can vary when interacting
     * with a contract as a result of updating the contract's state.
     *
     * @param transaction The {@link Transaction} object to estimate the gas for.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) - Specifies what block to use as the current state of the blockchain while processing the gas estimation.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     * @returns The used gas for the simulated transaction execution.
     *
     * ```ts
     * const transaction = {
     *       from: '0xe899f0130FD099c0b896B2cE4E5E15A25b23139a',
     *       to: '0xe899f0130FD099c0b896B2cE4E5E15A25b23139a',
     *       value: '0x1',
     *       nonce: '0x1',
     *       type: '0x0'
     * }
     *
     * web3.eth.estimateGas(transaction).then(console.log);
     * > 21000n
     *
     * web3.eth.estimateGas(transaction, { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }).then(console.log);
     * > 21000
     * ```
     */
    estimateGas(transaction, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return estimateGas2(this, transaction, blockNumber, returnFormat);
      });
    }
    /**
     * Gets past logs, matching the provided `filter`.
     *
     * @param filter A {@link Filter} object containing the properties for the desired logs.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     * @returns {@link FilterResultsAPI}, an array of {@link Log} objects.
     *
     * ```ts
     * web3.eth.getPastLogs({
     *      address: "0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe",
     *      topics: ["0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234"]
     *  }).then(console.log);
     * > [{
     *       data: '0x7f9fade1c0d57a7af66ab4ead79fade1c0d57a7af66ab4ead7c2c2eb7b11a91385',
     *       topics: ['0xfd43ade1c09fade1c0d57a7af66ab4ead7c2c2eb7b11a91ffdd57a7af66ab4ead7', '0x7f9fade1c0d57a7af66ab4ead79fade1c0d57a7af66ab4ead7c2c2eb7b11a91385']
     *       logIndex: 0n,
     *       transactionIndex: 0n,
     *       transactionHash: '0x7f9fade1c0d57a7af66ab4ead79fade1c0d57a7af66ab4ead7c2c2eb7b11a91385',
     *       blockHash: '0xfd43ade1c09fade1c0d57a7af66ab4ead7c2c2eb7b11a91ffdd57a7af66ab4ead7',
     *       blockNumber: 1234n,
     *       address: '0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe'
     *   },
     *   {...}]
     *
     * web3.eth.getPastLogs(
     *     {
     *       address: "0x11f4d0A3c12e86B4b5F39B213F7E19D048276DAe",
     *       topics: ["0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234"]
     *     },
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > [{
     *       data: '0x7f9fade1c0d57a7af66ab4ead79fade1c0d57a7af66ab4ead7c2c2eb7b11a91385',
     *       topics: ['0xfd43ade1c09fade1c0d57a7af66ab4ead7c2c2eb7b11a91ffdd57a7af66ab4ead7', '0x7f9fade1c0d57a7af66ab4ead79fade1c0d57a7af66ab4ead7c2c2eb7b11a91385']
     *       logIndex: 0,
     *       transactionIndex: 0,
     *       transactionHash: '0x7f9fade1c0d57a7af66ab4ead79fade1c0d57a7af66ab4ead7c2c2eb7b11a91385',
     *       blockHash: '0xfd43ade1c09fade1c0d57a7af66ab4ead7c2c2eb7b11a91ffdd57a7af66ab4ead7',
     *       blockNumber: 1234,
     *       address: '0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe'
     *   },
     *   {...}]
     * ```
     */
    getPastLogs(filter2, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getLogs2(this, filter2, returnFormat);
      });
    }
    /**
     * Gets work for miners to mine on. Returns the hash of the current block, the seedHash, and the boundary condition to be met ('target').
     *
     * @returns The mining work as an array of strings with the following structure:
     *
     * String 32 Bytes - at index 0: current block header pow-hash
     * String 32 Bytes - at index 1: the seed hash used for the DAG.
     * String 32 Bytes - at index 2: the boundary condition ('target'), 2^256 / difficulty.
     *
     * ```ts
     * web3.eth.getWork().then(console.log);
     * > [
     *     "0x1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef",
     *     "0x5EED00000000000000000000000000005EED0000000000000000000000000000",
     *     "0xd1ff1c01710000000000000000000000d1ff1c01710000000000000000000000"
     * ]
     * ```
     */
    getWork() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.getWork(this.requestManager);
      });
    }
    /**
     * Used for submitting a proof-of-work solution.
     *
     * @param nonce The nonce found (8 bytes).
     * @param hash  The header’s pow-hash (32 bytes).
     * @param digest The mix digest (32 bytes).
     * @returns Returns `true` if the provided solution is valid, otherwise `false`.
     *
     * ```ts
     * web3.eth.submitWork([
     *     "0x0000000000000001",
     *     "0x1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef",
     *     "0xD1FE5700000000000000000000000000D1FE5700000000000000000000000000"
     * ]).then(console.log);
     * > true
     * ```
     */
    submitWork(nonce, hash2, digest) {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.submitWork(this.requestManager, nonce, hash2, digest);
      });
    }
    // TODO - Format addresses
    /**
     * This method will request/enable the accounts from the current environment and for supporting [EIP 1102](https://eips.ethereum.org/EIPS/eip-1102)
     * This method will only work if you’re using the injected provider from a application like Metamask, Status or TrustWallet.
     * It doesn’t work if you’re connected to a node with a default Web3.js provider (WebsocketProvider, HttpProvider and IpcProvider).
     * For more information about the behavior of this method please read [EIP-1102](https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1102.md): Opt-in account exposure.
     *
     * @returns An array of enabled accounts.
     *
     * ```ts
     * web3.eth.requestAccounts().then(console.log);
     * > ['0aae0B295369a9FD31d5F28D9Ec85E40f4cb692BAf', '0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe']
     * ```
     */
    requestAccounts() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.requestAccounts(this.requestManager);
      });
    }
    /**
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     * @returns The chain ID of the current connected node as described in the [EIP-695](https://github.com/ethereum/EIPs/blob/master/EIPS/eip-695.md).
     *
     * ```ts
     * web3.eth.getChainId().then(console.log);
     * > 61n
     *
     * web3.eth.getChainId({ number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }).then(console.log);
     * > 61
     * ```
     */
    getChainId(returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getChainId2(this, returnFormat);
      });
    }
    /**
     * @returns The current client version.
     *
     * ```ts
     * web3.eth.getNodeInfo().then(console.log);
     * > "Mist/v0.9.3/darwin/go1.4.1"
     * ```
     */
    getNodeInfo() {
      return __awaiter32(this, void 0, void 0, function* () {
        return eth_rpc_methods_exports.getNodeInfo(this.requestManager);
      });
    }
    /**
     * @param address The Address of the account or contract.
     * @param storageKeys Array of storage-keys which should be proofed and included. See {@link web3.getStorageAt}.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) - Specifies what block to use as the current state of the blockchain while processing the gas estimation.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     * @returns The account and storage-values of the specified account including the Merkle-proof as described in [EIP-1186](https://github.com/ethereum/EIPs/blob/master/EIPS/eip-1186.md).
     *
     * ```ts
     * web3.eth.getProof(
     *     "0x1234567890123456789012345678901234567890",
     *     ["0x0000000000000000000000000000000000000000000000000000000000000000","0x0000000000000000000000000000000000000000000000000000000000000001"],
     *     "latest"
     * ).then(console.log);
     * > {
     *     "address": "0x1234567890123456789012345678901234567890",
     *     "accountProof": [
     *         "0xf90211a090dcaf88c40c7bbc95a912cbdde67c175767b31173df9ee4b0d733bfdd511c43a0babe369f6b12092f49181ae04ca173fb68d1a5456f18d20fa32cba73954052bda0473ecf8a7e36a829e75039a3b055e51b8332cbf03324ab4af2066bbd6fbf0021a0bbda34753d7aa6c38e603f360244e8f59611921d9e1f128372fec0d586d4f9e0a04e44caecff45c9891f74f6a2156735886eedf6f1a733628ebc802ec79d844648a0a5f3f2f7542148c973977c8a1e154c4300fec92f755f7846f1b734d3ab1d90e7a0e823850f50bf72baae9d1733a36a444ab65d0a6faaba404f0583ce0ca4dad92da0f7a00cbe7d4b30b11faea3ae61b7f1f2b315b61d9f6bd68bfe587ad0eeceb721a07117ef9fc932f1a88e908eaead8565c19b5645dc9e5b1b6e841c5edbdfd71681a069eb2de283f32c11f859d7bcf93da23990d3e662935ed4d6b39ce3673ec84472a0203d26456312bbc4da5cd293b75b840fc5045e493d6f904d180823ec22bfed8ea09287b5c21f2254af4e64fca76acc5cd87399c7f1ede818db4326c98ce2dc2208a06fc2d754e304c48ce6a517753c62b1a9c1d5925b89707486d7fc08919e0a94eca07b1c54f15e299bd58bdfef9741538c7828b5d7d11a489f9c20d052b3471df475a051f9dd3739a927c89e357580a4c97b40234aa01ed3d5e0390dc982a7975880a0a089d613f26159af43616fd9455bb461f4869bfede26f2130835ed067a8b967bfb80",
     *         "0xf90211a0395d87a95873cd98c21cf1df9421af03f7247880a2554e20738eec2c7507a494a0bcf6546339a1e7e14eb8fb572a968d217d2a0d1f3bc4257b22ef5333e9e4433ca012ae12498af8b2752c99efce07f3feef8ec910493be749acd63822c3558e6671a0dbf51303afdc36fc0c2d68a9bb05dab4f4917e7531e4a37ab0a153472d1b86e2a0ae90b50f067d9a2244e3d975233c0a0558c39ee152969f6678790abf773a9621a01d65cd682cc1be7c5e38d8da5c942e0a73eeaef10f387340a40a106699d494c3a06163b53d956c55544390c13634ea9aa75309f4fd866f312586942daf0f60fb37a058a52c1e858b1382a8893eb9c1f111f266eb9e21e6137aff0dddea243a567000a037b4b100761e02de63ea5f1fcfcf43e81a372dafb4419d126342136d329b7a7ba032472415864b08f808ba4374092003c8d7c40a9f7f9fe9cc8291f62538e1cc14a074e238ff5ec96b810364515551344100138916594d6af966170ff326a092fab0a0d31ac4eef14a79845200a496662e92186ca8b55e29ed0f9f59dbc6b521b116fea090607784fe738458b63c1942bba7c0321ae77e18df4961b2bc66727ea996464ea078f757653c1b63f72aff3dcc3f2a2e4c8cb4a9d36d1117c742833c84e20de994a0f78407de07f4b4cb4f899dfb95eedeb4049aeb5fc1635d65cf2f2f4dfd25d1d7a0862037513ba9d45354dd3e36264aceb2b862ac79d2050f14c95657e43a51b85c80",
     *         "0xf90171a04ad705ea7bf04339fa36b124fa221379bd5a38ffe9a6112cb2d94be3a437b879a08e45b5f72e8149c01efcb71429841d6a8879d4bbe27335604a5bff8dfdf85dcea00313d9b2f7c03733d6549ea3b810e5262ed844ea12f70993d87d3e0f04e3979ea0b59e3cdd6750fa8b15164612a5cb6567cdfb386d4e0137fccee5f35ab55d0efda0fe6db56e42f2057a071c980a778d9a0b61038f269dd74a0e90155b3f40f14364a08538587f2378a0849f9608942cf481da4120c360f8391bbcc225d811823c6432a026eac94e755534e16f9552e73025d6d9c30d1d7682a4cb5bd7741ddabfd48c50a041557da9a74ca68da793e743e81e2029b2835e1cc16e9e25bd0c1e89d4ccad6980a041dda0a40a21ade3a20fcd1a4abb2a42b74e9a32b02424ff8db4ea708a5e0fb9a09aaf8326a51f613607a8685f57458329b41e938bb761131a5747e066b81a0a16808080a022e6cef138e16d2272ef58434ddf49260dc1de1f8ad6dfca3da5d2a92aaaadc58080",
     *         "0xf851808080a009833150c367df138f1538689984b8a84fc55692d3d41fe4d1e5720ff5483a6980808080808080808080a0a319c1c415b271afc0adcb664e67738d103ac168e0bc0b7bd2da7966165cb9518080"
     *     ],
     *     "balance": 0n,
     *     "codeHash": "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
     *     "nonce": 0n,
     *     "storageHash": "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421",
     *     "storageProof": [
     *         {
     *             "key": "0x0000000000000000000000000000000000000000000000000000000000000000",
     *             "value": 0n,
     *             "proof": []
     *         },
     *         {
     *             "key": "0x0000000000000000000000000000000000000000000000000000000000000001",
     *             "value": 0n,
     *             "proof": []
     *         }
     *     ]
     * }
     *
     * web3.eth.getProof(
     *     "0x1234567890123456789012345678901234567890",
     *     ["0x0000000000000000000000000000000000000000000000000000000000000000","0x0000000000000000000000000000000000000000000000000000000000000001"],
     *     undefined,
     *     { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }
     * ).then(console.log);
     * > {
     *     "address": "0x1234567890123456789012345678901234567890",
     *     "accountProof": [
     *         "0xf90211a090dcaf88c40c7bbc95a912cbdde67c175767b31173df9ee4b0d733bfdd511c43a0babe369f6b12092f49181ae04ca173fb68d1a5456f18d20fa32cba73954052bda0473ecf8a7e36a829e75039a3b055e51b8332cbf03324ab4af2066bbd6fbf0021a0bbda34753d7aa6c38e603f360244e8f59611921d9e1f128372fec0d586d4f9e0a04e44caecff45c9891f74f6a2156735886eedf6f1a733628ebc802ec79d844648a0a5f3f2f7542148c973977c8a1e154c4300fec92f755f7846f1b734d3ab1d90e7a0e823850f50bf72baae9d1733a36a444ab65d0a6faaba404f0583ce0ca4dad92da0f7a00cbe7d4b30b11faea3ae61b7f1f2b315b61d9f6bd68bfe587ad0eeceb721a07117ef9fc932f1a88e908eaead8565c19b5645dc9e5b1b6e841c5edbdfd71681a069eb2de283f32c11f859d7bcf93da23990d3e662935ed4d6b39ce3673ec84472a0203d26456312bbc4da5cd293b75b840fc5045e493d6f904d180823ec22bfed8ea09287b5c21f2254af4e64fca76acc5cd87399c7f1ede818db4326c98ce2dc2208a06fc2d754e304c48ce6a517753c62b1a9c1d5925b89707486d7fc08919e0a94eca07b1c54f15e299bd58bdfef9741538c7828b5d7d11a489f9c20d052b3471df475a051f9dd3739a927c89e357580a4c97b40234aa01ed3d5e0390dc982a7975880a0a089d613f26159af43616fd9455bb461f4869bfede26f2130835ed067a8b967bfb80",
     *         "0xf90211a0395d87a95873cd98c21cf1df9421af03f7247880a2554e20738eec2c7507a494a0bcf6546339a1e7e14eb8fb572a968d217d2a0d1f3bc4257b22ef5333e9e4433ca012ae12498af8b2752c99efce07f3feef8ec910493be749acd63822c3558e6671a0dbf51303afdc36fc0c2d68a9bb05dab4f4917e7531e4a37ab0a153472d1b86e2a0ae90b50f067d9a2244e3d975233c0a0558c39ee152969f6678790abf773a9621a01d65cd682cc1be7c5e38d8da5c942e0a73eeaef10f387340a40a106699d494c3a06163b53d956c55544390c13634ea9aa75309f4fd866f312586942daf0f60fb37a058a52c1e858b1382a8893eb9c1f111f266eb9e21e6137aff0dddea243a567000a037b4b100761e02de63ea5f1fcfcf43e81a372dafb4419d126342136d329b7a7ba032472415864b08f808ba4374092003c8d7c40a9f7f9fe9cc8291f62538e1cc14a074e238ff5ec96b810364515551344100138916594d6af966170ff326a092fab0a0d31ac4eef14a79845200a496662e92186ca8b55e29ed0f9f59dbc6b521b116fea090607784fe738458b63c1942bba7c0321ae77e18df4961b2bc66727ea996464ea078f757653c1b63f72aff3dcc3f2a2e4c8cb4a9d36d1117c742833c84e20de994a0f78407de07f4b4cb4f899dfb95eedeb4049aeb5fc1635d65cf2f2f4dfd25d1d7a0862037513ba9d45354dd3e36264aceb2b862ac79d2050f14c95657e43a51b85c80",
     *         "0xf90171a04ad705ea7bf04339fa36b124fa221379bd5a38ffe9a6112cb2d94be3a437b879a08e45b5f72e8149c01efcb71429841d6a8879d4bbe27335604a5bff8dfdf85dcea00313d9b2f7c03733d6549ea3b810e5262ed844ea12f70993d87d3e0f04e3979ea0b59e3cdd6750fa8b15164612a5cb6567cdfb386d4e0137fccee5f35ab55d0efda0fe6db56e42f2057a071c980a778d9a0b61038f269dd74a0e90155b3f40f14364a08538587f2378a0849f9608942cf481da4120c360f8391bbcc225d811823c6432a026eac94e755534e16f9552e73025d6d9c30d1d7682a4cb5bd7741ddabfd48c50a041557da9a74ca68da793e743e81e2029b2835e1cc16e9e25bd0c1e89d4ccad6980a041dda0a40a21ade3a20fcd1a4abb2a42b74e9a32b02424ff8db4ea708a5e0fb9a09aaf8326a51f613607a8685f57458329b41e938bb761131a5747e066b81a0a16808080a022e6cef138e16d2272ef58434ddf49260dc1de1f8ad6dfca3da5d2a92aaaadc58080",
     *         "0xf851808080a009833150c367df138f1538689984b8a84fc55692d3d41fe4d1e5720ff5483a6980808080808080808080a0a319c1c415b271afc0adcb664e67738d103ac168e0bc0b7bd2da7966165cb9518080"
     *     ],
     *     "balance": 0,
     *     "codeHash": "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
     *     "nonce": 0,
     *     "storageHash": "0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421",
     *     "storageProof": [
     *         {
     *             "key": "0x0000000000000000000000000000000000000000000000000000000000000000",
     *             "value": 0,
     *             "proof": []
     *         },
     *         {
     *             "key": "0x0000000000000000000000000000000000000000000000000000000000000001",
     *             "value": 0,
     *             "proof": []
     *         }
     *     ]
     * }
     * ```
     */
    getProof(address, storageKeys, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getProof2(this, address, storageKeys, blockNumber, returnFormat);
      });
    }
    // TODO Throwing an error with Geth, but not Infura
    // TODO gasUsedRatio and reward not formatting
    /**
     * @param blockCount Number of blocks in the requested range. Between `1` and `1024` blocks can be requested in a single query. Less than requested may be returned if not all blocks are available.
     * @param newestBlock Highest number block of the requested range.
     * @param rewardPercentiles A monotonically increasing list of percentile values to sample from each block’s effective priority fees per gas in ascending order, weighted by gas used. Example: `['0', '25', '50', '75', '100']` or `['0', '0.5', '1', '1.5', '3', '80']`
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the call should be formatted.
     * @returns `baseFeePerGas` and transaction effective `priorityFeePerGas` history for the requested block range if available.
     * The range between `headBlock - 4` and `headBlock` is guaranteed to be available while retrieving data from the `pending` block and older history are optional to support.
     * For pre-EIP-1559 blocks the `gasPrice`s are returned as `rewards` and zeroes are returned for the `baseFeePerGas`.
     *
     * ```ts
     * web3.eth.getFeeHistory(4, 'pending', [0, 25, 75, 100]).then(console.log);
     * > {
     *     baseFeePerGas: [
     *         22983878621n,
     *         21417903463n,
     *         19989260230n,
     *         17770954829n,
     *         18850641304n
     *     ],
     *     gasUsedRatio: [
     *         0.22746546666666667,
     *         0.2331871,
     *         0.05610054885262125,
     *         0.7430227268212117
     *     ],
     *     oldestBlock: 15216343n,
     *     reward: [
     *         [ '0x3b9aca00', '0x53724e00', '0x77359400', '0x1d92c03423' ],
     *         [ '0x3b9aca00', '0x3b9aca00', '0x3b9aca00', '0xee6b2800' ],
     *         [ '0x3b9aca00', '0x4f86a721', '0x77d9743a', '0x9502f900' ],
     *         [ '0xcc8ff9e', '0x53724e00', '0x77359400', '0x1ec9771bb3' ]
     *     ]
     * }
     *
     * web3.eth.getFeeHistory(4, BlockTags.LATEST, [0, 25, 75, 100], { number: FMT_NUMBER.NUMBER , bytes: FMT_BYTES.HEX }).then(console.log);
     * > {
     *     baseFeePerGas: [
     *         22983878621,
     *         21417903463,
     *         19989260230,
     *         17770954829,
     *         18850641304
     *     ],
     *     gasUsedRatio: [
     *         0.22746546666666667,
     *         0.2331871,
     *         0.05610054885262125,
     *         0.7430227268212117
     *     ],
     *     oldestBlock: 15216343,
     *     reward: [
     *         [ '0x3b9aca00', '0x53724e00', '0x77359400', '0x1d92c03423' ],
     *         [ '0x3b9aca00', '0x3b9aca00', '0x3b9aca00', '0xee6b2800' ],
     *         [ '0x3b9aca00', '0x4f86a721', '0x77d9743a', '0x9502f900' ],
     *         [ '0xcc8ff9e', '0x53724e00', '0x77359400', '0x1ec9771bb3' ]
     *     ]
     * }
     * ```
     */
    getFeeHistory(blockCount, newestBlock = this.defaultBlock, rewardPercentiles, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return getFeeHistory2(this, blockCount, newestBlock, rewardPercentiles, returnFormat);
      });
    }
    /**
     * This method generates an access list for a transaction.
     *
     * @param transaction - A transaction object where all properties are optional except `from`, however it's recommended to include the `to` property.
     * @param blockNumber ({@link BlockNumberOrTag} defaults to {@link Web3Eth.defaultBlock}) - Specifies what block to use as the current state of the blockchain while processing the transaction.
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the return data from the createAccessList should be formatted.
     * @returns The returned data of the createAccessList,  e.g. The generated access list for transaction.
     * @example
     * ```ts
     * web3.eth.createAccessList({
     * from: '0xDe95305a63302C3aa4d3A9B42654659AeA72b694',
     * data: '0x9a67c8b100000000000000000000000000000000000000000000000000000000000004d0',
     * gasPrice: '0x3b9aca00',
     * gas: '0x3d0900',
     * to: '0x940b25304947ae863568B3804434EC77E2160b87'
     * })
     * .then(console.log);
     *
     * > {
     *  "accessList": [
     *     {
     *       "address": "0x15859bdf5aff2080a9968f6a410361e9598df62f",
     *       "storageKeys": [
     *         "0x0000000000000000000000000000000000000000000000000000000000000000"
     *       ]
     *     }
     *   ],
     *   "gasUsed": "0x7671"
     * }
     * ```
     */
    createAccessList(transaction, blockNumber = this.defaultBlock, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return createAccessList2(this, transaction, blockNumber, returnFormat);
      });
    }
    /**
     * This method sends EIP-712 typed data to the RPC provider to be signed.
     *
     * @param address The address that corresponds with the private key used to sign the typed data.
     * @param typedData The EIP-712 typed data object.
     * @param useLegacy A boolean flag determining whether the RPC call uses the legacy method `eth_signTypedData` or the newer method `eth_signTypedData_v4`
     * @param returnFormat ({@link DataFormat} defaults to {@link DEFAULT_RETURN_FORMAT}) - Specifies how the signed typed data should be formatted.
     * @returns The signed typed data.
     */
    signTypedData(address, typedData, useLegacy = false, returnFormat = DEFAULT_RETURN_FORMAT) {
      return __awaiter32(this, void 0, void 0, function* () {
        return signTypedData2(this, address, typedData, useLegacy, returnFormat);
      });
    }
    /**
     * Lets you subscribe to specific events in the blockchain.
     *
     * @param name - The subscription you want to subscribe to.
     * @param args - Optional additional parameters, depending on the subscription type.
     * @returns A subscription object of type {@link RegisteredSubscription}. The object contains:
     *  - subscription.id: The subscription id, used to identify and unsubscribing the subscription.
     *  - subscription.subscribe(): Can be used to re-subscribe with the same parameters.
     *  - subscription.unsubscribe(): Unsubscribes the subscription and returns TRUE in the callback if successful.
     *  - subscription.args: The subscription arguments, used when re-subscribing.
     *
     *
     * You can use the subscription object to listen on:
     *
     * - on("data") - Fires on each incoming log with the log object as argument.
     * - on("changed") - Fires on each log which was removed from the blockchain. The log will have the additional property "removed: true".
     * - on("error") - Fires when an error in the subscription occurs.
     * - on("connected") - Fires once after the subscription successfully connected. Returns the subscription id.
     *
     * @example **Subscribe to Smart Contract events**
     * ```ts
     * // Subscribe to `logs`
     * const logSubscription = web3.eth.subscribe('logs', {
     *     address: '0x1234567890123456789012345678901234567890',
     *     topics: ['0x033456732123ffff2342342dd12342434324234234fd234fd23fd4f23d4234']
     * });
     * logSubscription.on('data', (data: any) => console.log(data));
     * logSubscription.on('error', (error: any) => console.log(error));
     *
     * ```
     *
     * @example **Subscribe to new block headers**
     * ```ts
     * // Subscribe to `newBlockHeaders`
     * const newBlocksSubscription = await web3.eth.subscribe('newBlockHeaders');
     *
     * newBlocksSubscription.on('data', async blockhead => {
     * 	console.log('New block header: ', blockhead);
     *
     * 	// You do not need the next line, if you like to keep notified for every new block
     * 	await newBlocksSubscription.unsubscribe();
     * 	console.log('Unsubscribed from new block headers.');
     * });
     * newBlocksSubscription.on('error', error =>
     * 	console.log('Error when subscribing to New block header: ', error),
     * );
     * ```
     */
    subscribe(name2, args, returnFormat = DEFAULT_RETURN_FORMAT) {
      var _a6;
      return __awaiter32(this, void 0, void 0, function* () {
        const subscription = yield (_a6 = this.subscriptionManager) === null || _a6 === void 0 ? void 0 : _a6.subscribe(name2, args, returnFormat);
        if (subscription instanceof LogsSubscription && name2 === "logs" && typeof args === "object" && !isNullish2(args.fromBlock) && Number.isFinite(Number(args.fromBlock))) {
          setImmediate(() => {
            this.getPastLogs(args).then((logs) => {
              for (const log2 of logs) {
                subscription._processSubscriptionResult(log2);
              }
            }).catch((e2) => {
              subscription._processSubscriptionError(e2);
            });
          });
        }
        return subscription;
      });
    }
    static shouldClearSubscription({ sub }) {
      return !(sub instanceof SyncingSubscription);
    }
    /**
     * Resets subscriptions.
     *
     * @param notClearSyncing If `true` it keeps the `syncing` subscription.
     * @returns A promise to an array of subscription ids that were cleared.
     *
     * ```ts
     * web3.eth.clearSubscriptions().then(console.log);
     * > [...] An array of subscription ids that were cleared
     * ```
     */
    clearSubscriptions(notClearSyncing = false) {
      var _a6;
      return (_a6 = this.subscriptionManager) === null || _a6 === void 0 ? void 0 : _a6.unsubscribe(
        // eslint-disable-next-line
        notClearSyncing ? _Web3Eth.shouldClearSubscription : void 0
      );
    }
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/validation.js
  var validateCustomChainInfo = (transaction) => {
    if (!isNullish(transaction.common)) {
      if (isNullish(transaction.common.customChain))
        throw new MissingCustomChainError();
      if (isNullish(transaction.common.customChain.chainId))
        throw new MissingCustomChainIdError();
      if (!isNullish(transaction.chainId) && transaction.chainId !== transaction.common.customChain.chainId)
        throw new ChainIdMismatchError({
          txChainId: transaction.chainId,
          customChainId: transaction.common.customChain.chainId
        });
    }
  };
  var validateChainInfo = (transaction) => {
    if (!isNullish(transaction.common) && !isNullish(transaction.chain) && !isNullish(transaction.hardfork)) {
      throw new CommonOrChainAndHardforkError();
    }
    if (!isNullish(transaction.chain) && isNullish(transaction.hardfork) || !isNullish(transaction.hardfork) && isNullish(transaction.chain))
      throw new MissingChainOrHardforkError({
        chain: transaction.chain,
        hardfork: transaction.hardfork
      });
  };
  var validateBaseChain = (transaction) => {
    if (!isNullish(transaction.common)) {
      if (!isNullish(transaction.common.baseChain)) {
        if (!isNullish(transaction.chain) && transaction.chain !== transaction.common.baseChain) {
          throw new ChainMismatchError({
            txChain: transaction.chain,
            baseChain: transaction.common.baseChain
          });
        }
      }
    }
  };
  var validateHardfork = (transaction) => {
    if (!isNullish(transaction.common)) {
      if (!isNullish(transaction.common.hardfork)) {
        if (!isNullish(transaction.hardfork) && transaction.hardfork !== transaction.common.hardfork) {
          throw new HardforkMismatchError({
            txHardfork: transaction.hardfork,
            commonHardfork: transaction.common.hardfork
          });
        }
      }
    }
  };
  var validateLegacyGas = (transaction) => {
    if (
      // This check is verifying gas and gasPrice aren't less than 0.
      isNullish(transaction.gas) || !isUInt(transaction.gas) || isNullish(transaction.gasPrice) || !isUInt(transaction.gasPrice)
    )
      throw new InvalidGasOrGasPrice({
        gas: transaction.gas,
        gasPrice: transaction.gasPrice
      });
    if (!isNullish(transaction.maxFeePerGas) || !isNullish(transaction.maxPriorityFeePerGas))
      throw new UnsupportedFeeMarketError({
        maxFeePerGas: transaction.maxFeePerGas,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas
      });
  };
  var validateFeeMarketGas = (transaction) => {
    if (!isNullish(transaction.gasPrice) && transaction.type === "0x2")
      throw new Eip1559GasPriceError(transaction.gasPrice);
    if (transaction.type === "0x0" || transaction.type === "0x1")
      throw new UnsupportedFeeMarketError({
        maxFeePerGas: transaction.maxFeePerGas,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas
      });
    if (isNullish(transaction.maxFeePerGas) || !isUInt(transaction.maxFeePerGas) || isNullish(transaction.maxPriorityFeePerGas) || !isUInt(transaction.maxPriorityFeePerGas))
      throw new InvalidMaxPriorityFeePerGasOrMaxFeePerGas({
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
        maxFeePerGas: transaction.maxFeePerGas
      });
  };
  var validateGas = (transaction) => {
    const gasPresent = !isNullish(transaction.gas) || !isNullish(transaction.gasLimit);
    const legacyGasPresent = gasPresent && !isNullish(transaction.gasPrice);
    const feeMarketGasPresent = gasPresent && !isNullish(transaction.maxPriorityFeePerGas) && !isNullish(transaction.maxFeePerGas);
    if (!legacyGasPresent && !feeMarketGasPresent)
      throw new MissingGasError({
        gas: transaction.gas,
        gasPrice: transaction.gasPrice,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
        maxFeePerGas: transaction.maxFeePerGas
      });
    if (legacyGasPresent && feeMarketGasPresent)
      throw new TransactionGasMismatchError({
        gas: transaction.gas,
        gasPrice: transaction.gasPrice,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
        maxFeePerGas: transaction.maxFeePerGas
      });
    (legacyGasPresent ? validateLegacyGas : validateFeeMarketGas)(transaction);
    (!isNullish(transaction.type) && transaction.type > "0x1" ? validateFeeMarketGas : validateLegacyGas)(transaction);
  };
  var validateTransactionForSigning = (transaction, overrideMethod) => {
    if (!isNullish(overrideMethod)) {
      overrideMethod(transaction);
      return;
    }
    if (typeof transaction !== "object" || isNullish(transaction))
      throw new InvalidTransactionObjectError(transaction);
    validateCustomChainInfo(transaction);
    validateChainInfo(transaction);
    validateBaseChain(transaction);
    validateHardfork(transaction);
    const formattedTransaction = formatTransaction(transaction, ETH_DATA_FORMAT);
    validateGas(formattedTransaction);
    if (isNullish(formattedTransaction.nonce) || isNullish(formattedTransaction.chainId) || formattedTransaction.nonce.startsWith("-") || formattedTransaction.chainId.startsWith("-"))
      throw new InvalidNonceOrChainIdError({
        nonce: transaction.nonce,
        chainId: transaction.chainId
      });
  };

  // ../../node_modules/.pnpm/web3-eth@4.3.1_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth/lib/esm/utils/prepare_transaction_for_signing.js
  var __awaiter33 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var getEthereumjsTxDataFromTransaction = (transaction) => {
    var _a6, _b3;
    return {
      nonce: transaction.nonce,
      gasPrice: transaction.gasPrice,
      gasLimit: (_a6 = transaction.gasLimit) !== null && _a6 !== void 0 ? _a6 : transaction.gas,
      to: transaction.to,
      value: transaction.value,
      data: (_b3 = transaction.data) !== null && _b3 !== void 0 ? _b3 : transaction.input,
      type: transaction.type,
      chainId: transaction.chainId,
      accessList: transaction.accessList,
      maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
      maxFeePerGas: transaction.maxFeePerGas
    };
  };
  var getEthereumjsTransactionOptions = (transaction, web3Context) => {
    var _a6, _b3, _c2, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const hasTransactionSigningOptions = !isNullish(transaction.chain) && !isNullish(transaction.hardfork) || !isNullish(transaction.common);
    let common;
    if (!hasTransactionSigningOptions) {
      if (web3Context.defaultCommon) {
        common = web3Context.defaultCommon;
        if (isNullish(common.hardfork))
          common.hardfork = (_a6 = transaction.hardfork) !== null && _a6 !== void 0 ? _a6 : web3Context.defaultHardfork;
        if (isNullish(common.baseChain))
          common.baseChain = web3Context.defaultChain;
      } else {
        common = Common.custom({
          name: "custom-network",
          chainId: toNumber2(transaction.chainId),
          networkId: !isNullish(transaction.networkId) ? toNumber2(transaction.networkId) : void 0,
          defaultHardfork: (_b3 = transaction.hardfork) !== null && _b3 !== void 0 ? _b3 : web3Context.defaultHardfork
        }, {
          baseChain: web3Context.defaultChain
        });
      }
    } else {
      const name2 = (_f = (_e = (_d = (_c2 = transaction === null || transaction === void 0 ? void 0 : transaction.common) === null || _c2 === void 0 ? void 0 : _c2.customChain) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : transaction.chain) !== null && _f !== void 0 ? _f : "custom-network";
      const chainId = toNumber2((_j = (_h = (_g = transaction === null || transaction === void 0 ? void 0 : transaction.common) === null || _g === void 0 ? void 0 : _g.customChain) === null || _h === void 0 ? void 0 : _h.chainId) !== null && _j !== void 0 ? _j : transaction === null || transaction === void 0 ? void 0 : transaction.chainId);
      const networkId = toNumber2((_m = (_l = (_k = transaction === null || transaction === void 0 ? void 0 : transaction.common) === null || _k === void 0 ? void 0 : _k.customChain) === null || _l === void 0 ? void 0 : _l.networkId) !== null && _m !== void 0 ? _m : transaction === null || transaction === void 0 ? void 0 : transaction.networkId);
      const defaultHardfork = (_q = (_p = (_o = transaction === null || transaction === void 0 ? void 0 : transaction.common) === null || _o === void 0 ? void 0 : _o.hardfork) !== null && _p !== void 0 ? _p : transaction === null || transaction === void 0 ? void 0 : transaction.hardfork) !== null && _q !== void 0 ? _q : web3Context.defaultHardfork;
      const baseChain = (_t = (_s = (_r = transaction.common) === null || _r === void 0 ? void 0 : _r.baseChain) !== null && _s !== void 0 ? _s : transaction.chain) !== null && _t !== void 0 ? _t : web3Context.defaultChain;
      if (chainId && networkId && name2) {
        common = Common.custom({
          name: name2,
          chainId,
          networkId,
          defaultHardfork
        }, {
          baseChain
        });
      }
    }
    return { common };
  };
  var prepareTransactionForSigning = (transaction, web3Context, privateKey, fillGasPrice = false, fillGasLimit = true) => __awaiter33(void 0, void 0, void 0, function* () {
    const populatedTransaction = yield transactionBuilder({
      transaction,
      web3Context,
      privateKey,
      fillGasPrice,
      fillGasLimit
    });
    const formattedTransaction = formatTransaction(populatedTransaction, ETH_DATA_FORMAT);
    validateTransactionForSigning(formattedTransaction);
    return TransactionFactory.fromTxData(getEthereumjsTxDataFromTransaction(formattedTransaction), getEthereumjsTransactionOptions(formattedTransaction, web3Context));
  });

  // ../../node_modules/.pnpm/web3-eth-contract@4.1.4_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-contract/lib/esm/encoding.js
  var encodeEventABI = ({ address }, event, options) => {
    var _a6, _b3;
    const topics = options === null || options === void 0 ? void 0 : options.topics;
    const filter2 = (_a6 = options === null || options === void 0 ? void 0 : options.filter) !== null && _a6 !== void 0 ? _a6 : {};
    const opts = {};
    if (!isNullish2(options === null || options === void 0 ? void 0 : options.fromBlock)) {
      opts.fromBlock = format4(blockSchema.properties.number, options === null || options === void 0 ? void 0 : options.fromBlock, {
        number: FMT_NUMBER.HEX,
        bytes: FMT_BYTES.HEX
      });
    }
    if (!isNullish2(options === null || options === void 0 ? void 0 : options.toBlock)) {
      opts.toBlock = format4(blockSchema.properties.number, options === null || options === void 0 ? void 0 : options.toBlock, {
        number: FMT_NUMBER.HEX,
        bytes: FMT_BYTES.HEX
      });
    }
    if (topics && Array.isArray(topics)) {
      opts.topics = [...topics];
    } else {
      opts.topics = [];
      if (event && !event.anonymous && ![ALL_EVENTS, "allEvents"].includes(event.name)) {
        opts.topics.push((_b3 = event.signature) !== null && _b3 !== void 0 ? _b3 : encodeEventSignature(jsonInterfaceMethodToString(event)));
      }
      if (![ALL_EVENTS, "allEvents"].includes(event.name) && event.inputs) {
        for (const input of event.inputs) {
          if (!input.indexed) {
            continue;
          }
          const value = filter2[input.name];
          if (!value) {
            opts.topics.push(null);
            continue;
          }
          if (Array.isArray(value)) {
            opts.topics.push(value.map((v) => encodeParameter(input.type, v)));
          } else if (input.type === "string") {
            opts.topics.push(keccak256Wrapper(value));
          } else {
            opts.topics.push(encodeParameter(input.type, value));
          }
        }
      }
    }
    if (!opts.topics.length)
      delete opts.topics;
    if (address) {
      opts.address = address.toLowerCase();
    }
    return opts;
  };
  var encodeMethodABI = (abi, args, deployData) => {
    const inputLength = Array.isArray(abi.inputs) ? abi.inputs.length : 0;
    if (inputLength !== args.length) {
      throw new Web3ContractError(`The number of arguments is not matching the methods required number. You need to pass ${inputLength} arguments.`);
    }
    const params = encodeParameters2(Array.isArray(abi.inputs) ? abi.inputs : [], args).replace("0x", "");
    if (isAbiConstructorFragment(abi)) {
      if (!deployData)
        throw new Web3ContractError("The contract has no contract data option set. This is necessary to append the constructor parameters.");
      if (!deployData.startsWith("0x")) {
        return `0x${deployData}${params}`;
      }
      return `${deployData}${params}`;
    }
    return `${encodeFunctionSignature(abi)}${params}`;
  };
  var decodeMethodReturn = (abi, returnValues) => {
    if (abi.type === "constructor") {
      return returnValues;
    }
    if (!returnValues) {
      return null;
    }
    const value = returnValues.length >= 2 ? returnValues.slice(2) : returnValues;
    if (!abi.outputs) {
      return null;
    }
    const result = decodeParameters2([...abi.outputs], value);
    if (result.__length__ === 1) {
      return result[0];
    }
    return result;
  };

  // ../../node_modules/.pnpm/web3-eth-contract@4.1.4_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-contract/lib/esm/log_subscription.js
  var LogsSubscription2 = class extends Web3Subscription {
    constructor(args, options) {
      super(args, options);
      this.address = args.address;
      this.topics = args.topics;
      this.abi = args.abi;
      this.jsonInterface = args.jsonInterface;
    }
    _buildSubscriptionParams() {
      return ["logs", { address: this.address, topics: this.topics }];
    }
    formatSubscriptionResult(data) {
      return decodeEventABI(this.abi, data, this.jsonInterface, super.returnFormat);
    }
  };

  // ../../node_modules/.pnpm/web3-eth-contract@4.1.4_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-contract/lib/esm/utils.js
  var dataInputEncodeMethodHelper = (txParams, abi, params, dataInputFill) => {
    var _a6, _b3;
    const tx = {};
    if (!isNullish2(txParams.data) || dataInputFill === "both") {
      tx.data = encodeMethodABI(abi, params, (_a6 = txParams.data) !== null && _a6 !== void 0 ? _a6 : txParams.input);
    }
    if (!isNullish2(txParams.input) || dataInputFill === "both") {
      tx.input = encodeMethodABI(abi, params, (_b3 = txParams.input) !== null && _b3 !== void 0 ? _b3 : txParams.data);
    }
    if (isNullish2(tx.input) && isNullish2(tx.data)) {
      tx[dataInputFill] = encodeMethodABI(abi, params);
    }
    return { data: tx.data, input: tx.input };
  };
  var getSendTxParams = ({ abi, params, options, contractOptions }) => {
    var _a6, _b3, _c2;
    const deploymentCall = (_c2 = (_b3 = (_a6 = options === null || options === void 0 ? void 0 : options.input) !== null && _a6 !== void 0 ? _a6 : options === null || options === void 0 ? void 0 : options.data) !== null && _b3 !== void 0 ? _b3 : contractOptions.input) !== null && _c2 !== void 0 ? _c2 : contractOptions.data;
    if (!deploymentCall && !(options === null || options === void 0 ? void 0 : options.to) && !contractOptions.address) {
      throw new Web3ContractError("Contract address not specified");
    }
    if (!(options === null || options === void 0 ? void 0 : options.from) && !contractOptions.from) {
      throw new Web3ContractError('Contract "from" address not specified');
    }
    let txParams = mergeDeep({
      to: contractOptions.address,
      gas: contractOptions.gas,
      gasPrice: contractOptions.gasPrice,
      from: contractOptions.from,
      input: contractOptions.input,
      maxPriorityFeePerGas: contractOptions.maxPriorityFeePerGas,
      maxFeePerGas: contractOptions.maxFeePerGas,
      data: contractOptions.data
    }, options);
    const dataInput = dataInputEncodeMethodHelper(txParams, abi, params, options === null || options === void 0 ? void 0 : options.dataInputFill);
    txParams = Object.assign(Object.assign({}, txParams), { data: dataInput.data, input: dataInput.input });
    return txParams;
  };
  var getEthTxCallParams = ({ abi, params, options, contractOptions }) => {
    if (!(options === null || options === void 0 ? void 0 : options.to) && !contractOptions.address) {
      throw new Web3ContractError("Contract address not specified");
    }
    let txParams = mergeDeep({
      to: contractOptions.address,
      gas: contractOptions.gas,
      gasPrice: contractOptions.gasPrice,
      from: contractOptions.from,
      input: contractOptions.input,
      maxPriorityFeePerGas: contractOptions.maxPriorityFeePerGas,
      maxFeePerGas: contractOptions.maxFeePerGas,
      data: contractOptions.data
    }, options);
    const dataInput = dataInputEncodeMethodHelper(txParams, abi, params, options === null || options === void 0 ? void 0 : options.dataInputFill);
    txParams = Object.assign(Object.assign({}, txParams), { data: dataInput.data, input: dataInput.input });
    return txParams;
  };
  var getEstimateGasParams = ({ abi, params, options, contractOptions }) => {
    let txParams = mergeDeep({
      to: contractOptions.address,
      gas: contractOptions.gas,
      gasPrice: contractOptions.gasPrice,
      from: contractOptions.from,
      input: contractOptions.input,
      data: contractOptions.data
    }, options);
    const dataInput = dataInputEncodeMethodHelper(txParams, abi, params, options === null || options === void 0 ? void 0 : options.dataInputFill);
    txParams = Object.assign(Object.assign({}, txParams), { data: dataInput.data, input: dataInput.input });
    return txParams;
  };
  var isWeb3ContractContext = (options) => typeof options === "object" && !isNullish2(options) && Object.keys(options).length !== 0 && !isContractInitOptions(options);
  var getCreateAccessListParams = ({ abi, params, options, contractOptions }) => {
    if (!(options === null || options === void 0 ? void 0 : options.to) && !contractOptions.address) {
      throw new Web3ContractError("Contract address not specified");
    }
    if (!(options === null || options === void 0 ? void 0 : options.from) && !contractOptions.from) {
      throw new Web3ContractError('Contract "from" address not specified');
    }
    let txParams = mergeDeep({
      to: contractOptions.address,
      gas: contractOptions.gas,
      gasPrice: contractOptions.gasPrice,
      from: contractOptions.from,
      input: contractOptions.input,
      maxPriorityFeePerGas: contractOptions.maxPriorityFeePerGas,
      maxFeePerGas: contractOptions.maxFeePerGas,
      data: contractOptions.data
    }, options);
    const dataInput = dataInputEncodeMethodHelper(txParams, abi, params, options === null || options === void 0 ? void 0 : options.dataInputFill);
    txParams = Object.assign(Object.assign({}, txParams), { data: dataInput.data, input: dataInput.input });
    return txParams;
  };

  // ../../node_modules/.pnpm/web3-eth-contract@4.1.4_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-contract/lib/esm/contract.js
  var __awaiter34 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var contractSubscriptions = {
    logs: LogsSubscription2,
    newHeads: NewHeadsSubscription,
    newBlockHeaders: NewHeadsSubscription
  };
  var Contract = class _Contract extends Web3Context {
    constructor(jsonInterface, addressOrOptionsOrContext, optionsOrContextOrReturnFormat, contextOrReturnFormat, returnFormat) {
      var _a6, _b3, _c2;
      const options = isContractInitOptions(addressOrOptionsOrContext) ? addressOrOptionsOrContext : isContractInitOptions(optionsOrContextOrReturnFormat) ? optionsOrContextOrReturnFormat : void 0;
      let contractContext;
      if (isWeb3ContractContext(addressOrOptionsOrContext)) {
        contractContext = addressOrOptionsOrContext;
      } else if (isWeb3ContractContext(optionsOrContextOrReturnFormat)) {
        contractContext = optionsOrContextOrReturnFormat;
      } else {
        contractContext = contextOrReturnFormat;
      }
      let provider;
      if (typeof addressOrOptionsOrContext === "object" && "provider" in addressOrOptionsOrContext) {
        provider = addressOrOptionsOrContext.provider;
      } else if (typeof optionsOrContextOrReturnFormat === "object" && "provider" in optionsOrContextOrReturnFormat) {
        provider = optionsOrContextOrReturnFormat.provider;
      } else if (typeof contextOrReturnFormat === "object" && "provider" in contextOrReturnFormat) {
        provider = contextOrReturnFormat.provider;
      } else {
        provider = _Contract.givenProvider;
      }
      super(Object.assign(Object.assign({}, contractContext), { provider, registeredSubscriptions: contractSubscriptions }));
      this.syncWithContext = false;
      this._functions = {};
      if (!isNullish(options) && !isNullish(options.data) && !isNullish(options.input) && this.config.contractDataInputFill !== "both")
        throw new ContractTransactionDataAndInputError({
          data: options.data,
          input: options.input
        });
      this._overloadedMethodAbis = /* @__PURE__ */ new Map();
      const returnDataFormat = isDataFormat(contextOrReturnFormat) ? contextOrReturnFormat : isDataFormat(optionsOrContextOrReturnFormat) ? optionsOrContextOrReturnFormat : returnFormat !== null && returnFormat !== void 0 ? returnFormat : DEFAULT_RETURN_FORMAT;
      const address = typeof addressOrOptionsOrContext === "string" ? addressOrOptionsOrContext : void 0;
      this.config.contractDataInputFill = (_a6 = options === null || options === void 0 ? void 0 : options.dataInputFill) !== null && _a6 !== void 0 ? _a6 : this.config.contractDataInputFill;
      this._parseAndSetJsonInterface(jsonInterface, returnDataFormat);
      if (!isNullish(address)) {
        this._parseAndSetAddress(address, returnDataFormat);
      }
      this.options = {
        address,
        jsonInterface: this._jsonInterface,
        gas: (_b3 = options === null || options === void 0 ? void 0 : options.gas) !== null && _b3 !== void 0 ? _b3 : options === null || options === void 0 ? void 0 : options.gasLimit,
        gasPrice: options === null || options === void 0 ? void 0 : options.gasPrice,
        from: options === null || options === void 0 ? void 0 : options.from,
        input: options === null || options === void 0 ? void 0 : options.input,
        data: options === null || options === void 0 ? void 0 : options.data
      };
      this.syncWithContext = (_c2 = options === null || options === void 0 ? void 0 : options.syncWithContext) !== null && _c2 !== void 0 ? _c2 : false;
      if (contractContext instanceof Web3Context) {
        this.subscribeToContextEvents(contractContext);
      }
      Object.defineProperty(this.options, "address", {
        set: (value) => this._parseAndSetAddress(value, returnDataFormat),
        get: () => this._address
      });
      Object.defineProperty(this.options, "jsonInterface", {
        set: (value) => this._parseAndSetJsonInterface(value, returnDataFormat),
        get: () => this._jsonInterface
      });
      if (contractContext instanceof Web3Context) {
        contractContext.on(Web3ConfigEvent.CONFIG_CHANGE, (event) => {
          this.setConfig({ [event.name]: event.newValue });
        });
      }
    }
    /**
     * Subscribe to an event.
     *
     * ```ts
     * await myContract.events.MyEvent([options])
     * ```
     *
     * There is a special event `allEvents` that can be used to subscribe all events.
     *
     * ```ts
     * await myContract.events.allEvents([options])
     * ```
     *
     * @returns - When individual event is accessed will returns {@link ContractBoundEvent} object
     */
    get events() {
      return this._events;
    }
    /**
     * Creates a transaction object for that method, which then can be `called`, `send`, `estimated`, `createAccessList` , or `ABI encoded`.
     *
     * The methods of this smart contract are available through:
     *
     * The name: `myContract.methods.myMethod(123)`
     * The name with parameters: `myContract.methods['myMethod(uint256)'](123)`
     * The signature `myContract.methods['0x58cf5f10'](123)`
     *
     * This allows calling functions with same name but different parameters from the JavaScript contract object.
     *
     * \> The method signature does not provide a type safe interface, so we recommend to use method `name` instead.
     *
     * ```ts
     * // calling a method
     * const result = await myContract.methods.myMethod(123).call({from: '0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe'});
     *
     * // or sending and using a promise
     * const receipt = await myContract.methods.myMethod(123).send({from: '0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe'});
     *
     * // or sending and using the events
     * const sendObject = myContract.methods.myMethod(123).send({from: '0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe'});
     * sendObject.on('transactionHash', function(hash){
     *   ...
     * });
     * sendObject.on('receipt', function(receipt){
     *   ...
     * });
     * sendObject.on('confirmation', function(confirmationNumber, receipt){
     *   ...
     * });
     * sendObject.on('error', function(error, receipt) {
     *   ...
     * });
     * ```
     *
     * @returns - Either returns {@link PayableMethodObject} or {@link NonPayableMethodObject} based on the definitions of the ABI of that contract.
     */
    get methods() {
      return this._methods;
    }
    /**
     * Clones the current contract instance. This doesn't deploy contract on blockchain and only creates a local clone.
     *
     * @returns - The new contract instance.
     *
     * ```ts
     * const contract1 = new eth.Contract(abi, address, {gasPrice: '12345678', from: fromAddress});
     *
     * const contract2 = contract1.clone();
     * contract2.options.address = address2;
     *
     * (contract1.options.address !== contract2.options.address);
     * > true
     * ```
     */
    clone() {
      let newContract;
      if (this.options.address) {
        newContract = new _Contract([...this._jsonInterface, ...this._errorsInterface], this.options.address, {
          gas: this.options.gas,
          gasPrice: this.options.gasPrice,
          from: this.options.from,
          input: this.options.input,
          data: this.options.data,
          provider: this.currentProvider,
          syncWithContext: this.syncWithContext,
          dataInputFill: this.config.contractDataInputFill
        }, this.getContextObject());
      } else {
        newContract = new _Contract([...this._jsonInterface, ...this._errorsInterface], {
          gas: this.options.gas,
          gasPrice: this.options.gasPrice,
          from: this.options.from,
          input: this.options.input,
          data: this.options.data,
          provider: this.currentProvider,
          syncWithContext: this.syncWithContext,
          dataInputFill: this.config.contractDataInputFill
        }, this.getContextObject());
      }
      if (this.context)
        newContract.subscribeToContextEvents(this.context);
      return newContract;
    }
    /**
     * Call this function to deploy the contract to the blockchain. After successful deployment the promise will resolve with a new contract instance.
     *
     * ```ts
     * myContract.deploy({
     *   input: '0x12345...', // data keyword can be used, too. If input is used, data will be ignored.
     *   arguments: [123, 'My String']
     * })
     * .send({
     *   from: '0x1234567890123456789012345678901234567891',
     *   gas: 1500000,
     *   gasPrice: '30000000000000'
     * }, function(error, transactionHash){ ... })
     * .on('error', function(error){ ... })
     * .on('transactionHash', function(transactionHash){ ... })
     * .on('receipt', function(receipt){
     *  console.log(receipt.contractAddress) // contains the new contract address
     * })
     * .on('confirmation', function(confirmationNumber, receipt){ ... })
     * .then(function(newContractInstance){
     *   console.log(newContractInstance.options.address) // instance with the new contract address
     * });
     *
     *
     * // When the data is already set as an option to the contract itself
     * myContract.options.data = '0x12345...';
     *
     * myContract.deploy({
     *   arguments: [123, 'My String']
     * })
     * .send({
     *   from: '0x1234567890123456789012345678901234567891',
     *   gas: 1500000,
     *   gasPrice: '30000000000000'
     * })
     * .then(function(newContractInstance){
     *   console.log(newContractInstance.options.address) // instance with the new contract address
     * });
     *
     *
     * // Simply encoding
     * myContract.deploy({
     *   input: '0x12345...',
     *   arguments: [123, 'My String']
     * })
     * .encodeABI();
     * > '0x12345...0000012345678765432'
     *
     *
     * // Gas estimation
     * myContract.deploy({
     *   input: '0x12345...',
     *   arguments: [123, 'My String']
     * })
     * .estimateGas(function(err, gas){
     *   console.log(gas);
     * });
     * ```
     *
     * @returns - The transaction object
     */
    deploy(deployOptions) {
      var _a6, _b3, _c2;
      let abi = this._jsonInterface.find((j) => j.type === "constructor");
      if (!abi) {
        abi = {
          type: "constructor",
          inputs: [],
          stateMutability: ""
        };
      }
      const _input = format4({ format: "bytes" }, (_a6 = deployOptions === null || deployOptions === void 0 ? void 0 : deployOptions.input) !== null && _a6 !== void 0 ? _a6 : this.options.input, DEFAULT_RETURN_FORMAT);
      const _data = format4({ format: "bytes" }, (_b3 = deployOptions === null || deployOptions === void 0 ? void 0 : deployOptions.data) !== null && _b3 !== void 0 ? _b3 : this.options.data, DEFAULT_RETURN_FORMAT);
      if ((!_input || _input.trim() === "0x") && (!_data || _data.trim() === "0x")) {
        throw new Web3ContractError("contract creation without any data provided.");
      }
      const args = (_c2 = deployOptions === null || deployOptions === void 0 ? void 0 : deployOptions.arguments) !== null && _c2 !== void 0 ? _c2 : [];
      const contractOptions = Object.assign(Object.assign({}, this.options), { input: _input, data: _data });
      const deployData = _input !== null && _input !== void 0 ? _input : _data;
      return {
        arguments: args,
        send: (options) => {
          const modifiedOptions = Object.assign({}, options);
          return this._contractMethodDeploySend(abi, args, modifiedOptions, contractOptions);
        },
        estimateGas: (options, returnFormat = DEFAULT_RETURN_FORMAT) => __awaiter34(this, void 0, void 0, function* () {
          const modifiedOptions = Object.assign({}, options);
          return this._contractMethodEstimateGas({
            abi,
            params: args,
            returnFormat,
            options: modifiedOptions,
            contractOptions
          });
        }),
        encodeABI: () => encodeMethodABI(abi, args, format4({ format: "bytes" }, deployData, DEFAULT_RETURN_FORMAT))
      };
    }
    getPastEvents(param1, param2, param3) {
      var _a6;
      return __awaiter34(this, void 0, void 0, function* () {
        const eventName = typeof param1 === "string" ? param1 : ALL_EVENTS;
        const options = (
          // eslint-disable-next-line no-nested-ternary
          typeof param1 !== "string" && !isDataFormat(param1) ? param1 : !isDataFormat(param2) ? param2 : {}
        );
        const returnFormat = isDataFormat(param1) ? param1 : isDataFormat(param2) ? param2 : param3 !== null && param3 !== void 0 ? param3 : DEFAULT_RETURN_FORMAT;
        const abi = eventName === "allEvents" || eventName === ALL_EVENTS ? ALL_EVENTS_ABI : this._jsonInterface.find((j) => "name" in j && j.name === eventName);
        if (!abi) {
          throw new Web3ContractError(`Event ${eventName} not found.`);
        }
        const { fromBlock, toBlock, topics, address } = encodeEventABI(this.options, abi, options !== null && options !== void 0 ? options : {});
        const logs = yield getLogs2(this, { fromBlock, toBlock, topics, address }, returnFormat);
        const decodedLogs = logs.map((log2) => typeof log2 === "string" ? log2 : decodeEventABI(abi, log2, this._jsonInterface, returnFormat));
        const filter2 = (_a6 = options === null || options === void 0 ? void 0 : options.filter) !== null && _a6 !== void 0 ? _a6 : {};
        const filterKeys = Object.keys(filter2);
        if (filterKeys.length > 0) {
          return decodedLogs.filter((log2) => {
            if (typeof log2 === "string")
              return true;
            return filterKeys.every((key) => {
              var _a7;
              if (Array.isArray(filter2[key])) {
                return filter2[key].some((v) => String(log2.returnValues[key]).toUpperCase() === String(v).toUpperCase());
              }
              const inputAbi = (_a7 = abi.inputs) === null || _a7 === void 0 ? void 0 : _a7.filter((input) => input.name === key)[0];
              if ((inputAbi === null || inputAbi === void 0 ? void 0 : inputAbi.indexed) && inputAbi.type === "string") {
                const hashedIndexedString = keccak256Wrapper(filter2[key]);
                if (hashedIndexedString === String(log2.returnValues[key]))
                  return true;
              }
              return String(log2.returnValues[key]).toUpperCase() === String(filter2[key]).toUpperCase();
            });
          });
        }
        return decodedLogs;
      });
    }
    _parseAndSetAddress(value, returnFormat = DEFAULT_RETURN_FORMAT) {
      this._address = value ? toChecksumAddress(format4({ format: "address" }, value, returnFormat)) : value;
    }
    _parseAndSetJsonInterface(abis, returnFormat = DEFAULT_RETURN_FORMAT) {
      var _a6, _b3, _c2, _d, _e;
      this._functions = {};
      this._methods = {};
      this._events = {};
      let result = [];
      const functionsAbi = abis.filter((abi) => abi.type !== "error");
      const errorsAbi = abis.filter((abi) => isAbiErrorFragment(abi));
      for (const a of functionsAbi) {
        const abi = Object.assign(Object.assign({}, a), { signature: "" });
        if (isAbiFunctionFragment(abi)) {
          const methodName = jsonInterfaceMethodToString(abi);
          const methodSignature = encodeFunctionSignature(methodName);
          abi.signature = methodSignature;
          abi.constant = (_b3 = (_a6 = abi.stateMutability === "view") !== null && _a6 !== void 0 ? _a6 : abi.stateMutability === "pure") !== null && _b3 !== void 0 ? _b3 : abi.constant;
          abi.payable = (_c2 = abi.stateMutability === "payable") !== null && _c2 !== void 0 ? _c2 : abi.payable;
          this._overloadedMethodAbis.set(abi.name, [
            ...(_d = this._overloadedMethodAbis.get(abi.name)) !== null && _d !== void 0 ? _d : [],
            abi
          ]);
          const abiFragment = (_e = this._overloadedMethodAbis.get(abi.name)) !== null && _e !== void 0 ? _e : [];
          const contractMethod = this._createContractMethod(abiFragment, errorsAbi);
          this._functions[methodName] = {
            signature: methodSignature,
            method: contractMethod
          };
          this._methods[abi.name] = this._functions[methodName].method;
          this._methods[methodName] = this._functions[methodName].method;
          this._methods[methodSignature] = this._functions[methodName].method;
        } else if (isAbiEventFragment(abi)) {
          const eventName = jsonInterfaceMethodToString(abi);
          const eventSignature = encodeEventSignature(eventName);
          const event = this._createContractEvent(abi, returnFormat);
          abi.signature = eventSignature;
          if (!(eventName in this._events) || abi.name === "bound") {
            this._events[eventName] = event;
          }
          this._events[abi.name] = event;
          this._events[eventSignature] = event;
        }
        result = [...result, abi];
      }
      this._events.allEvents = this._createContractEvent(ALL_EVENTS_ABI, returnFormat);
      this._jsonInterface = [...result];
      this._errorsInterface = errorsAbi;
    }
    // eslint-disable-next-line class-methods-use-this
    _getAbiParams(abi, params) {
      var _a6;
      try {
        return utils_exports.transformJsonDataToAbiFormat((_a6 = abi.inputs) !== null && _a6 !== void 0 ? _a6 : [], params);
      } catch (error) {
        throw new Web3ContractError(`Invalid parameters for method ${abi.name}: ${error.message}`);
      }
    }
    _createContractMethod(abiArr, errorsAbis) {
      const abi = abiArr[abiArr.length - 1];
      return (...params) => {
        var _a6, _b3;
        let abiParams;
        const abis = (_a6 = this._overloadedMethodAbis.get(abi.name)) !== null && _a6 !== void 0 ? _a6 : [];
        let methodAbi = abis[0];
        const internalErrorsAbis = errorsAbis;
        const arrayOfAbis = abis.filter((_abi) => {
          var _a7;
          return ((_a7 = _abi.inputs) !== null && _a7 !== void 0 ? _a7 : []).length === params.length;
        });
        if (abis.length === 1 || arrayOfAbis.length === 0) {
          abiParams = this._getAbiParams(methodAbi, params);
          validator.validate((_b3 = abi.inputs) !== null && _b3 !== void 0 ? _b3 : [], abiParams);
        } else {
          const errors = [];
          for (const _abi of arrayOfAbis) {
            try {
              abiParams = this._getAbiParams(_abi, params);
              validator.validate(_abi.inputs, abiParams);
              methodAbi = _abi;
              break;
            } catch (e2) {
              errors.push(e2);
            }
          }
          if (errors.length === arrayOfAbis.length) {
            throw new Web3ValidatorError(errors);
          }
        }
        const methods = {
          arguments: abiParams,
          call: (options, block) => __awaiter34(this, void 0, void 0, function* () {
            return this._contractMethodCall(methodAbi, abiParams, internalErrorsAbis, options, block);
          }),
          send: (options) => this._contractMethodSend(methodAbi, abiParams, internalErrorsAbis, options),
          estimateGas: (options, returnFormat = DEFAULT_RETURN_FORMAT) => __awaiter34(this, void 0, void 0, function* () {
            return this._contractMethodEstimateGas({
              abi: methodAbi,
              params: abiParams,
              returnFormat,
              options
            });
          }),
          encodeABI: () => encodeMethodABI(methodAbi, abiParams),
          createAccessList: (options, block) => __awaiter34(this, void 0, void 0, function* () {
            return this._contractMethodCreateAccessList(methodAbi, abiParams, internalErrorsAbis, options, block);
          })
        };
        if (methodAbi.stateMutability === "payable") {
          return methods;
        }
        return methods;
      };
    }
    _contractMethodCall(abi, params, errorsAbi, options, block) {
      var _a6;
      return __awaiter34(this, void 0, void 0, function* () {
        const tx = getEthTxCallParams({
          abi,
          params,
          options: Object.assign(Object.assign({}, options), { dataInputFill: this.config.contractDataInputFill }),
          contractOptions: Object.assign(Object.assign({}, this.options), { from: (_a6 = this.options.from) !== null && _a6 !== void 0 ? _a6 : this.config.defaultAccount })
        });
        try {
          const result = yield call2(this, tx, block, DEFAULT_RETURN_FORMAT);
          return decodeMethodReturn(abi, result);
        } catch (error) {
          if (error instanceof ContractExecutionError) {
            decodeContractErrorData(errorsAbi, error.innerError);
          }
          throw error;
        }
      });
    }
    _contractMethodCreateAccessList(abi, params, errorsAbi, options, block) {
      var _a6;
      return __awaiter34(this, void 0, void 0, function* () {
        const tx = getCreateAccessListParams({
          abi,
          params,
          options: Object.assign(Object.assign({}, options), { dataInputFill: this.config.contractDataInputFill }),
          contractOptions: Object.assign(Object.assign({}, this.options), { from: (_a6 = this.options.from) !== null && _a6 !== void 0 ? _a6 : this.config.defaultAccount })
        });
        try {
          return createAccessList2(this, tx, block, DEFAULT_RETURN_FORMAT);
        } catch (error) {
          if (error instanceof ContractExecutionError) {
            decodeContractErrorData(errorsAbi, error.innerError);
          }
          throw error;
        }
      });
    }
    _contractMethodSend(abi, params, errorsAbi, options, contractOptions) {
      var _a6, _b3;
      let modifiedContractOptions = contractOptions !== null && contractOptions !== void 0 ? contractOptions : this.options;
      modifiedContractOptions = Object.assign(Object.assign({}, modifiedContractOptions), { input: void 0, from: (_b3 = (_a6 = modifiedContractOptions.from) !== null && _a6 !== void 0 ? _a6 : this.defaultAccount) !== null && _b3 !== void 0 ? _b3 : void 0 });
      const tx = getSendTxParams({
        abi,
        params,
        options: Object.assign(Object.assign({}, options), { dataInputFill: this.config.contractDataInputFill }),
        contractOptions: modifiedContractOptions
      });
      const transactionToSend = sendTransaction3(this, tx, DEFAULT_RETURN_FORMAT, {
        // TODO Should make this configurable by the user
        checkRevertBeforeSending: false,
        contractAbi: this._jsonInterface
      });
      void transactionToSend.on("error", (error) => {
        if (error instanceof ContractExecutionError) {
          decodeContractErrorData(errorsAbi, error.innerError);
        }
      });
      return transactionToSend;
    }
    _contractMethodDeploySend(abi, params, options, contractOptions) {
      var _a6, _b3;
      let modifiedContractOptions = contractOptions !== null && contractOptions !== void 0 ? contractOptions : this.options;
      modifiedContractOptions = Object.assign(Object.assign({}, modifiedContractOptions), { from: (_b3 = (_a6 = modifiedContractOptions.from) !== null && _a6 !== void 0 ? _a6 : this.defaultAccount) !== null && _b3 !== void 0 ? _b3 : void 0 });
      const tx = getSendTxParams({
        abi,
        params,
        options: Object.assign(Object.assign({}, options), { dataInputFill: this.config.contractDataInputFill }),
        contractOptions: modifiedContractOptions
      });
      return sendTransaction3(this, tx, DEFAULT_RETURN_FORMAT, {
        transactionResolver: (receipt) => {
          if (receipt.status === BigInt(0)) {
            throw new Web3ContractError("code couldn't be stored", receipt);
          }
          const newContract = this.clone();
          newContract.options.address = receipt.contractAddress;
          return newContract;
        },
        contractAbi: this._jsonInterface,
        // TODO Should make this configurable by the user
        checkRevertBeforeSending: false
      });
    }
    _contractMethodEstimateGas({ abi, params, returnFormat, options, contractOptions }) {
      return __awaiter34(this, void 0, void 0, function* () {
        const tx = getEstimateGasParams({
          abi,
          params,
          options: Object.assign(Object.assign({}, options), { dataInputFill: this.config.contractDataInputFill }),
          contractOptions: contractOptions !== null && contractOptions !== void 0 ? contractOptions : this.options
        });
        return estimateGas2(this, tx, BlockTags.LATEST, returnFormat);
      });
    }
    // eslint-disable-next-line class-methods-use-this
    _createContractEvent(abi, returnFormat = DEFAULT_RETURN_FORMAT) {
      return (...params) => {
        var _a6;
        const { topics, fromBlock } = encodeEventABI(this.options, abi, params[0]);
        const sub = new LogsSubscription2({
          address: this.options.address,
          topics,
          abi,
          jsonInterface: this._jsonInterface
        }, {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          subscriptionManager: this.subscriptionManager,
          returnFormat
        });
        if (!isNullish(fromBlock)) {
          this.getPastEvents(abi.name, { fromBlock, topics }, returnFormat).then((logs) => {
            logs.forEach((log2) => sub.emit("data", log2));
          }).catch((error) => {
            sub.emit("error", new SubscriptionError("Failed to get past events.", error));
          });
        }
        (_a6 = this.subscriptionManager) === null || _a6 === void 0 ? void 0 : _a6.addSubscription(sub).catch((error) => {
          sub.emit("error", new SubscriptionError("Failed to subscribe.", error));
        });
        return sub;
      };
    }
    subscribeToContextEvents(context) {
      const contractThis = this;
      this.context = context;
      if (contractThis.syncWithContext) {
        context.on(Web3ConfigEvent.CONFIG_CHANGE, (event) => {
          contractThis.setConfig({ [event.name]: event.newValue });
        });
      }
    }
  };

  // ../../node_modules/.pnpm/web3-eth-contract@4.1.4_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-contract/lib/esm/index.js
  var esm_default = Contract;

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/config.js
  var interfaceIds = {
    addr: "0x3b3b57de",
    name: "0x691f3431",
    abi: "0x2203ab56",
    pubkey: "0xc8690233",
    text: "0x59d1d43c",
    contenthash: "0xbc1c58d1"
  };
  var methodsInInterface = {
    setAddr: "addr",
    addr: "addr",
    setPubkey: "pubkey",
    pubkey: "pubkey",
    setContenthash: "contenthash",
    contenthash: "contenthash"
  };
  var registryAddresses = {
    main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
  };
  var networkIds = {
    "0x1": "main",
    "0x5": "goerli"
  };

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/abi/ens/ENSRegistry.js
  var ENSRegistryAbi = [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "bytes32",
          name: "label",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "address",
          name: "owner",
          type: "address"
        }
      ],
      name: "NewOwner",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "address",
          name: "resolver",
          type: "address"
        }
      ],
      name: "NewResolver",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "address",
          name: "owner",
          type: "address"
        }
      ],
      name: "Transfer",
      type: "event"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "operator",
          type: "address"
        }
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "recordExists",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "resolver",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "ttl",
      outputs: [
        {
          internalType: "uint64",
          name: "",
          type: "uint64"
        }
      ],
      stateMutability: "view",
      type: "function"
    }
  ];

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/abi/ens/PublicResolver.js
  var PublicResolverAbi = [
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "address",
          name: "a",
          type: "address"
        }
      ],
      name: "AddrChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "coinType",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "newAddress",
          type: "bytes"
        }
      ],
      name: "AddressChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "operator",
          type: "address"
        },
        {
          indexed: false,
          internalType: "bool",
          name: "approved",
          type: "bool"
        }
      ],
      name: "ApprovalForAll",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "hash",
          type: "bytes"
        }
      ],
      name: "ContenthashChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "name",
          type: "bytes"
        },
        {
          indexed: false,
          internalType: "uint16",
          name: "resource",
          type: "uint16"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "record",
          type: "bytes"
        }
      ],
      name: "DNSRecordChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "name",
          type: "bytes"
        },
        {
          indexed: false,
          internalType: "uint16",
          name: "resource",
          type: "uint16"
        }
      ],
      name: "DNSRecordDeleted",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "DNSZoneCleared",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "lastzonehash",
          type: "bytes"
        },
        {
          indexed: false,
          internalType: "bytes",
          name: "zonehash",
          type: "bytes"
        }
      ],
      name: "DNSZonehashChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "bytes4",
          name: "interfaceID",
          type: "bytes4"
        },
        {
          indexed: false,
          internalType: "address",
          name: "implementer",
          type: "address"
        }
      ],
      name: "InterfaceChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "string",
          name: "name",
          type: "string"
        }
      ],
      name: "NameChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "bytes32",
          name: "x",
          type: "bytes32"
        },
        {
          indexed: false,
          internalType: "bytes32",
          name: "y",
          type: "bytes32"
        }
      ],
      name: "PubkeyChanged",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          indexed: true,
          internalType: "string",
          name: "indexedKey",
          type: "string"
        },
        {
          indexed: false,
          internalType: "string",
          name: "key",
          type: "string"
        }
      ],
      name: "TextChanged",
      type: "event"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          internalType: "uint256",
          name: "contentTypes",
          type: "uint256"
        }
      ],
      name: "ABI",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        },
        {
          internalType: "bytes",
          name: "",
          type: "bytes"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "addr",
      outputs: [
        {
          internalType: "address payable",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          internalType: "uint256",
          name: "coinType",
          type: "uint256"
        }
      ],
      name: "addr",
      outputs: [
        {
          internalType: "bytes",
          name: "",
          type: "bytes"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "contenthash",
      outputs: [
        {
          internalType: "bytes",
          name: "",
          type: "bytes"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "name",
          type: "bytes32"
        },
        {
          internalType: "uint16",
          name: "resource",
          type: "uint16"
        }
      ],
      name: "dnsRecord",
      outputs: [
        {
          internalType: "bytes",
          name: "",
          type: "bytes"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "name",
          type: "bytes32"
        }
      ],
      name: "hasDNSRecords",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          internalType: "bytes4",
          name: "interfaceID",
          type: "bytes4"
        }
      ],
      name: "interfaceImplementer",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address"
        },
        {
          internalType: "address",
          name: "operator",
          type: "address"
        }
      ],
      name: "isApprovedForAll",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "pubkey",
      outputs: [
        {
          internalType: "bytes32",
          name: "x",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "y",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes4",
          name: "interfaceID",
          type: "bytes4"
        }
      ],
      name: "supportsInterface",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        },
        {
          internalType: "string",
          name: "key",
          type: "string"
        }
      ],
      name: "text",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "node",
          type: "bytes32"
        }
      ],
      name: "zonehash",
      outputs: [
        {
          internalType: "bytes",
          name: "",
          type: "bytes"
        }
      ],
      stateMutability: "view",
      type: "function"
    }
  ];

  // ../../node_modules/.pnpm/@adraffy+ens-normalize@1.10.0/node_modules/@adraffy/ens-normalize/dist/index.mjs
  var COMPRESSED$1 = "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";
  var FENCED = /* @__PURE__ */ new Map([[8217, "apostrophe"], [8260, "fraction slash"], [12539, "middle dot"]]);
  var NSM_MAX = 4;
  function decode_arithmetic(bytes2) {
    let pos = 0;
    function u162() {
      return bytes2[pos++] << 8 | bytes2[pos++];
    }
    let symbol_count = u162();
    let total = 1;
    let acc = [0, 1];
    for (let i2 = 1; i2 < symbol_count; i2++) {
      acc.push(total += u162());
    }
    let skip = u162();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
      if (read_width == 0) {
        read_buffer = read_buffer << 8 | bytes2[pos++];
        read_width = 8;
      }
      return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    let register = 0;
    for (let i2 = 0; i2 < N; i2++) register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL;
    while (true) {
      let value = Math.floor(((register - low + 1) * total - 1) / range);
      let start = 0;
      let end = symbol_count;
      while (end - start > 1) {
        let mid = start + end >>> 1;
        if (value < acc[mid]) {
          end = mid;
        } else {
          start = mid;
        }
      }
      if (start == 0) break;
      symbols.push(start);
      let a = low + Math.floor(range * acc[start] / total);
      let b = low + Math.floor(range * acc[start + 1] / total) - 1;
      while (((a ^ b) & HALF) == 0) {
        register = register << 1 & MASK | read_bit();
        a = a << 1 & MASK;
        b = b << 1 & MASK | 1;
      }
      while (a & ~b & QRTR) {
        register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
        a = a << 1 ^ HALF;
        b = (b ^ HALF) << 1 | HALF | 1;
      }
      low = a;
      range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x) => {
      switch (x - offset) {
        case 3:
          return offset + 65792 + (bytes2[pos_payload++] << 16 | bytes2[pos_payload++] << 8 | bytes2[pos_payload++]);
        case 2:
          return offset + 256 + (bytes2[pos_payload++] << 8 | bytes2[pos_payload++]);
        case 1:
          return offset + bytes2[pos_payload++];
        default:
          return x - 1;
      }
    });
  }
  function read_payload(v) {
    let pos = 0;
    return () => v[pos++];
  }
  function read_compressed_payload(s2) {
    return read_payload(decode_arithmetic(unsafe_atob(s2)));
  }
  function unsafe_atob(s2) {
    let lookup = [];
    [..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"].forEach((c, i2) => lookup[c.charCodeAt(0)] = i2);
    let n2 = s2.length;
    let ret = new Uint8Array(6 * n2 >> 3);
    for (let i2 = 0, pos = 0, width = 0, carry = 0; i2 < n2; i2++) {
      carry = carry << 6 | lookup[s2.charCodeAt(i2)];
      width += 6;
      if (width >= 8) {
        ret[pos++] = carry >> (width -= 8);
      }
    }
    return ret;
  }
  function signed(i2) {
    return i2 & 1 ? ~i2 >> 1 : i2 >> 1;
  }
  function read_deltas(n2, next) {
    let v = Array(n2);
    for (let i2 = 0, x = 0; i2 < n2; i2++) v[i2] = x += signed(next());
    return v;
  }
  function read_sorted(next, prev = 0) {
    let ret = [];
    while (true) {
      let x = next();
      let n2 = next();
      if (!n2) break;
      prev += x;
      for (let i2 = 0; i2 < n2; i2++) {
        ret.push(prev + i2);
      }
      prev += n2 + 1;
    }
    return ret;
  }
  function read_sorted_arrays(next) {
    return read_array_while(() => {
      let v = read_sorted(next);
      if (v.length) return v;
    });
  }
  function read_mapped(next) {
    let ret = [];
    while (true) {
      let w = next();
      if (w == 0) break;
      ret.push(read_linear_table(w, next));
    }
    while (true) {
      let w = next() - 1;
      if (w < 0) break;
      ret.push(read_replacement_table(w, next));
    }
    return ret.flat();
  }
  function read_array_while(next) {
    let v = [];
    while (true) {
      let x = next(v.length);
      if (!x) break;
      v.push(x);
    }
    return v;
  }
  function read_transposed(n2, w, next) {
    let m = Array(n2).fill().map(() => []);
    for (let i2 = 0; i2 < w; i2++) {
      read_deltas(n2, next).forEach((x, j) => m[j].push(x));
    }
    return m;
  }
  function read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = read_array_while(next);
    let m = read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i2) => {
      let [x, ...ys] = v;
      return Array(vN[i2]).fill().map((_2, j) => {
        let j_dy = j * dy;
        return [x + j * dx, ys.map((y) => y + j_dy)];
      });
    });
  }
  function read_replacement_table(w, next) {
    let n2 = 1 + next();
    let m = read_transposed(n2, 1 + w, next);
    return m.map((v) => [v[0], v.slice(1)]);
  }
  function read_trie(next) {
    let ret = [];
    let sorted = read_sorted(next);
    expand(decode2([]), []);
    return ret;
    function decode2(Q) {
      let S = next();
      let B = read_array_while(() => {
        let cps = read_sorted(next).map((i2) => sorted[i2]);
        if (cps.length) return decode2(cps);
      });
      return { S, B, Q };
    }
    function expand({ S, B }, cps, saved) {
      if (S & 4 && saved === cps[cps.length - 1]) return;
      if (S & 2) saved = cps[cps.length - 1];
      if (S & 1) ret.push(cps);
      for (let br of B) {
        for (let cp3 of br.Q) {
          expand(br, [...cps, cp3], saved);
        }
      }
    }
  }
  function hex_cp(cp3) {
    return cp3.toString(16).toUpperCase().padStart(2, "0");
  }
  function quote_cp(cp3) {
    return `{${hex_cp(cp3)}}`;
  }
  function explode_cp(s2) {
    let cps = [];
    for (let pos = 0, len = s2.length; pos < len; ) {
      let cp3 = s2.codePointAt(pos);
      pos += cp3 < 65536 ? 1 : 2;
      cps.push(cp3);
    }
    return cps;
  }
  function str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for (let i2 = 0; i2 < len; ) {
      buf.push(String.fromCodePoint(...cps.slice(i2, i2 += chunk)));
    }
    return buf.join("");
  }
  function compare_arrays(a, b) {
    let n2 = a.length;
    let c = n2 - b.length;
    for (let i2 = 0; c == 0 && i2 < n2; i2++) c = a[i2] - b[i2];
    return c;
  }
  var COMPRESSED = "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";
  var S0 = 44032;
  var L0 = 4352;
  var V0 = 4449;
  var T0 = 4519;
  var L_COUNT = 19;
  var V_COUNT = 21;
  var T_COUNT = 28;
  var N_COUNT = V_COUNT * T_COUNT;
  var S_COUNT = L_COUNT * N_COUNT;
  var S1 = S0 + S_COUNT;
  var L1 = L0 + L_COUNT;
  var V1 = V0 + V_COUNT;
  var T1 = T0 + T_COUNT;
  function unpack_cc(packed2) {
    return packed2 >> 24 & 255;
  }
  function unpack_cp(packed2) {
    return packed2 & 16777215;
  }
  var SHIFTED_RANK;
  var EXCLUSIONS;
  var DECOMP;
  var RECOMP;
  function init$1() {
    let r2 = read_compressed_payload(COMPRESSED);
    SHIFTED_RANK = new Map(read_sorted_arrays(r2).flatMap((v, i2) => v.map((x) => [x, i2 + 1 << 24])));
    EXCLUSIONS = new Set(read_sorted(r2));
    DECOMP = /* @__PURE__ */ new Map();
    RECOMP = /* @__PURE__ */ new Map();
    for (let [cp3, cps] of read_mapped(r2)) {
      if (!EXCLUSIONS.has(cp3) && cps.length == 2) {
        let [a, b] = cps;
        let bucket = RECOMP.get(a);
        if (!bucket) {
          bucket = /* @__PURE__ */ new Map();
          RECOMP.set(a, bucket);
        }
        bucket.set(b, cp3);
      }
      DECOMP.set(cp3, cps.reverse());
    }
  }
  function is_hangul(cp3) {
    return cp3 >= S0 && cp3 < S1;
  }
  function compose_pair(a, b) {
    if (a >= L0 && a < L1 && b >= V0 && b < V1) {
      return S0 + (a - L0) * N_COUNT + (b - V0) * T_COUNT;
    } else if (is_hangul(a) && b > T0 && b < T1 && (a - S0) % T_COUNT == 0) {
      return a + (b - T0);
    } else {
      let recomp = RECOMP.get(a);
      if (recomp) {
        recomp = recomp.get(b);
        if (recomp) {
          return recomp;
        }
      }
      return -1;
    }
  }
  function decomposed(cps) {
    if (!SHIFTED_RANK) init$1();
    let ret = [];
    let buf = [];
    let check_order = false;
    function add2(cp3) {
      let cc = SHIFTED_RANK.get(cp3);
      if (cc) {
        check_order = true;
        cp3 |= cc;
      }
      ret.push(cp3);
    }
    for (let cp3 of cps) {
      while (true) {
        if (cp3 < 128) {
          ret.push(cp3);
        } else if (is_hangul(cp3)) {
          let s_index = cp3 - S0;
          let l_index = s_index / N_COUNT | 0;
          let v_index = s_index % N_COUNT / T_COUNT | 0;
          let t_index = s_index % T_COUNT;
          add2(L0 + l_index);
          add2(V0 + v_index);
          if (t_index > 0) add2(T0 + t_index);
        } else {
          let mapped = DECOMP.get(cp3);
          if (mapped) {
            buf.push(...mapped);
          } else {
            add2(cp3);
          }
        }
        if (!buf.length) break;
        cp3 = buf.pop();
      }
    }
    if (check_order && ret.length > 1) {
      let prev_cc = unpack_cc(ret[0]);
      for (let i2 = 1; i2 < ret.length; i2++) {
        let cc = unpack_cc(ret[i2]);
        if (cc == 0 || prev_cc <= cc) {
          prev_cc = cc;
          continue;
        }
        let j = i2 - 1;
        while (true) {
          let tmp = ret[j + 1];
          ret[j + 1] = ret[j];
          ret[j] = tmp;
          if (!j) break;
          prev_cc = unpack_cc(ret[--j]);
          if (prev_cc <= cc) break;
        }
        prev_cc = unpack_cc(ret[i2]);
      }
    }
    return ret;
  }
  function composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed2 of v) {
      let cc = unpack_cc(packed2);
      let cp3 = unpack_cp(packed2);
      if (prev_cp == -1) {
        if (cc == 0) {
          prev_cp = cp3;
        } else {
          ret.push(cp3);
        }
      } else if (prev_cc > 0 && prev_cc >= cc) {
        if (cc == 0) {
          ret.push(prev_cp, ...stack);
          stack.length = 0;
          prev_cp = cp3;
        } else {
          stack.push(cp3);
        }
        prev_cc = cc;
      } else {
        let composed = compose_pair(prev_cp, cp3);
        if (composed >= 0) {
          prev_cp = composed;
        } else if (prev_cc == 0 && cc == 0) {
          ret.push(prev_cp);
          prev_cp = cp3;
        } else {
          stack.push(cp3);
          prev_cc = cc;
        }
      }
    }
    if (prev_cp >= 0) {
      ret.push(prev_cp, ...stack);
    }
    return ret;
  }
  function nfd(cps) {
    return decomposed(cps).map(unpack_cp);
  }
  function nfc(cps) {
    return composed_from_decomposed(decomposed(cps));
  }
  var HYPHEN = 45;
  var STOP_CH = ".";
  var FE0F = 65039;
  var UNIQUE_PH = 1;
  var Array_from = (x) => Array.from(x);
  function group_has_cp(g, cp3) {
    return g.P.has(cp3) || g.Q.has(cp3);
  }
  var Emoji = class extends Array {
    get is_emoji() {
      return true;
    }
    // free tagging system
  };
  var MAPPED;
  var IGNORED;
  var CM;
  var NSM;
  var ESCAPE;
  var NFC_CHECK;
  var GROUPS;
  var WHOLE_VALID;
  var WHOLE_MAP;
  var VALID;
  var EMOJI_LIST;
  var EMOJI_ROOT;
  function init() {
    if (MAPPED) return;
    let r2 = read_compressed_payload(COMPRESSED$1);
    const read_sorted_array = () => read_sorted(r2);
    const read_sorted_set = () => new Set(read_sorted_array());
    MAPPED = new Map(read_mapped(r2));
    IGNORED = read_sorted_set();
    CM = read_sorted_array();
    NSM = new Set(read_sorted_array().map((i2) => CM[i2]));
    CM = new Set(CM);
    ESCAPE = read_sorted_set();
    NFC_CHECK = read_sorted_set();
    let chunks = read_sorted_arrays(r2);
    let unrestricted = r2();
    const read_chunked = () => new Set(read_sorted_array().flatMap((i2) => chunks[i2]).concat(read_sorted_array()));
    GROUPS = read_array_while((i2) => {
      let N = read_array_while(r2).map((x) => x + 96);
      if (N.length) {
        let R = i2 >= unrestricted;
        N[0] -= 32;
        N = str_from_cps(N);
        if (R) N = `Restricted[${N}]`;
        let P = read_chunked();
        let Q = read_chunked();
        let M = !r2();
        return { N, P, Q, M, R };
      }
    });
    WHOLE_VALID = read_sorted_set();
    WHOLE_MAP = /* @__PURE__ */ new Map();
    let wholes = read_sorted_array().concat(Array_from(WHOLE_VALID)).sort((a, b) => a - b);
    wholes.forEach((cp3, i2) => {
      let d = r2();
      let w = wholes[i2] = d ? wholes[i2 - d] : { V: [], M: /* @__PURE__ */ new Map() };
      w.V.push(cp3);
      if (!WHOLE_VALID.has(cp3)) {
        WHOLE_MAP.set(cp3, w);
      }
    });
    for (let { V, M } of new Set(WHOLE_MAP.values())) {
      let recs = [];
      for (let cp3 of V) {
        let gs = GROUPS.filter((g) => group_has_cp(g, cp3));
        let rec = recs.find(({ G }) => gs.some((g) => G.has(g)));
        if (!rec) {
          rec = { G: /* @__PURE__ */ new Set(), V: [] };
          recs.push(rec);
        }
        rec.V.push(cp3);
        gs.forEach((g) => rec.G.add(g));
      }
      let union2 = recs.flatMap((x) => Array_from(x.G));
      for (let { G, V: V2 } of recs) {
        let complement = new Set(union2.filter((g) => !G.has(g)));
        for (let cp3 of V2) {
          M.set(cp3, complement);
        }
      }
    }
    let union = /* @__PURE__ */ new Set();
    let multi = /* @__PURE__ */ new Set();
    const add_to_union = (cp3) => union.has(cp3) ? multi.add(cp3) : union.add(cp3);
    for (let g of GROUPS) {
      for (let cp3 of g.P) add_to_union(cp3);
      for (let cp3 of g.Q) add_to_union(cp3);
    }
    for (let cp3 of union) {
      if (!WHOLE_MAP.has(cp3) && !multi.has(cp3)) {
        WHOLE_MAP.set(cp3, UNIQUE_PH);
      }
    }
    VALID = new Set(Array_from(union).concat(Array_from(nfd(union))));
    EMOJI_LIST = read_trie(r2).map((v) => Emoji.from(v)).sort(compare_arrays);
    EMOJI_ROOT = /* @__PURE__ */ new Map();
    for (let cps of EMOJI_LIST) {
      let prev = [EMOJI_ROOT];
      for (let cp3 of cps) {
        let next = prev.map((node) => {
          let child = node.get(cp3);
          if (!child) {
            child = /* @__PURE__ */ new Map();
            node.set(cp3, child);
          }
          return child;
        });
        if (cp3 === FE0F) {
          prev.push(...next);
        } else {
          prev = next;
        }
      }
      for (let x of prev) {
        x.V = cps;
      }
    }
  }
  function quoted_cp(cp3) {
    return (should_escape(cp3) ? "" : `${bidi_qq(safe_str_from_cps([cp3]))} `) + quote_cp(cp3);
  }
  function bidi_qq(s2) {
    return `"${s2}"\u200E`;
  }
  function check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == HYPHEN && cps[3] == HYPHEN) {
      throw new Error(`invalid label extension: "${str_from_cps(cps.slice(0, 4))}"`);
    }
  }
  function check_leading_underscore(cps) {
    const UNDERSCORE = 95;
    for (let i2 = cps.lastIndexOf(UNDERSCORE); i2 > 0; ) {
      if (cps[--i2] !== UNDERSCORE) {
        throw new Error("underscore allowed only at start");
      }
    }
  }
  function check_fenced(cps) {
    let cp3 = cps[0];
    let prev = FENCED.get(cp3);
    if (prev) throw error_placement(`leading ${prev}`);
    let n2 = cps.length;
    let last = -1;
    for (let i2 = 1; i2 < n2; i2++) {
      cp3 = cps[i2];
      let match = FENCED.get(cp3);
      if (match) {
        if (last == i2) throw error_placement(`${prev} + ${match}`);
        last = i2 + 1;
        prev = match;
      }
    }
    if (last == n2) throw error_placement(`trailing ${prev}`);
  }
  function safe_str_from_cps(cps, quoter = quote_cp) {
    let buf = [];
    if (is_combining_mark(cps[0])) buf.push("\u25CC");
    let prev = 0;
    let n2 = cps.length;
    for (let i2 = 0; i2 < n2; i2++) {
      let cp3 = cps[i2];
      if (should_escape(cp3)) {
        buf.push(str_from_cps(cps.slice(prev, i2)));
        buf.push(quoter(cp3));
        prev = i2 + 1;
      }
    }
    buf.push(str_from_cps(cps.slice(prev, n2)));
    return buf.join("");
  }
  function is_combining_mark(cp3) {
    init();
    return CM.has(cp3);
  }
  function should_escape(cp3) {
    init();
    return ESCAPE.has(cp3);
  }
  function ens_normalize(name2) {
    return flatten(split2(name2, nfc, filter_fe0f));
  }
  function split2(name2, nf, ef) {
    if (!name2) return [];
    init();
    let offset = 0;
    return name2.split(STOP_CH).map((label) => {
      let input = explode_cp(label);
      let info2 = {
        input,
        offset
        // codepoint, not substring!
      };
      offset += input.length + 1;
      try {
        let tokens = info2.tokens = tokens_from_str(input, nf, ef);
        let token_count = tokens.length;
        let type;
        if (!token_count) {
          throw new Error(`empty label`);
        }
        let norm = info2.output = tokens.flat();
        check_leading_underscore(norm);
        let emoji = info2.emoji = token_count > 1 || tokens[0].is_emoji;
        if (!emoji && norm.every((cp3) => cp3 < 128)) {
          check_label_extension(norm);
          type = "ASCII";
        } else {
          let chars = tokens.flatMap((x) => x.is_emoji ? [] : x);
          if (!chars.length) {
            type = "Emoji";
          } else {
            if (CM.has(norm[0])) throw error_placement("leading combining mark");
            for (let i2 = 1; i2 < token_count; i2++) {
              let cps = tokens[i2];
              if (!cps.is_emoji && CM.has(cps[0])) {
                throw error_placement(`emoji + combining mark: "${str_from_cps(tokens[i2 - 1])} + ${safe_str_from_cps([cps[0]])}"`);
              }
            }
            check_fenced(norm);
            let unique = Array_from(new Set(chars));
            let [g] = determine_group(unique);
            check_group(g, chars);
            check_whole(g, unique);
            type = g.N;
          }
        }
        info2.type = type;
      } catch (err3) {
        info2.error = err3;
      }
      return info2;
    });
  }
  function check_whole(group, unique) {
    let maker;
    let shared = [];
    for (let cp3 of unique) {
      let whole = WHOLE_MAP.get(cp3);
      if (whole === UNIQUE_PH) return;
      if (whole) {
        let set4 = whole.M.get(cp3);
        maker = maker ? maker.filter((g) => set4.has(g)) : Array_from(set4);
        if (!maker.length) return;
      } else {
        shared.push(cp3);
      }
    }
    if (maker) {
      for (let g of maker) {
        if (shared.every((cp3) => group_has_cp(g, cp3))) {
          throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
        }
      }
    }
  }
  function determine_group(unique) {
    let groups = GROUPS;
    for (let cp3 of unique) {
      let gs = groups.filter((g) => group_has_cp(g, cp3));
      if (!gs.length) {
        if (!GROUPS.some((g) => group_has_cp(g, cp3))) {
          throw error_disallowed(cp3);
        } else {
          throw error_group_member(groups[0], cp3);
        }
      }
      groups = gs;
      if (gs.length == 1) break;
    }
    return groups;
  }
  function flatten(split3) {
    return split3.map(({ input, error, output: output3 }) => {
      if (error) {
        let msg = error.message;
        throw new Error(split3.length == 1 ? msg : `Invalid label ${bidi_qq(safe_str_from_cps(input))}: ${msg}`);
      }
      return str_from_cps(output3);
    }).join(STOP_CH);
  }
  function error_disallowed(cp3) {
    return new Error(`disallowed character: ${quoted_cp(cp3)}`);
  }
  function error_group_member(g, cp3) {
    let quoted = quoted_cp(cp3);
    let gg = GROUPS.find((g2) => g2.P.has(cp3));
    if (gg) {
      quoted = `${gg.N} ${quoted}`;
    }
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
  }
  function error_placement(where) {
    return new Error(`illegal placement: ${where}`);
  }
  function check_group(g, cps) {
    for (let cp3 of cps) {
      if (!group_has_cp(g, cp3)) {
        throw error_group_member(g, cp3);
      }
    }
    if (g.M) {
      let decomposed2 = nfd(cps);
      for (let i2 = 1, e2 = decomposed2.length; i2 < e2; i2++) {
        if (NSM.has(decomposed2[i2])) {
          let j = i2 + 1;
          for (let cp3; j < e2 && NSM.has(cp3 = decomposed2[j]); j++) {
            for (let k = i2; k < j; k++) {
              if (decomposed2[k] == cp3) {
                throw new Error(`duplicate non-spacing marks: ${quoted_cp(cp3)}`);
              }
            }
          }
          if (j - i2 > NSM_MAX) {
            throw new Error(`excessive non-spacing marks: ${bidi_qq(safe_str_from_cps(decomposed2.slice(i2 - 1, j)))} (${j - i2}/${NSM_MAX})`);
          }
          i2 = j;
        }
      }
    }
  }
  function tokens_from_str(input, nf, ef) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse();
    while (input.length) {
      let emoji = consume_emoji_reversed(input);
      if (emoji) {
        if (chars.length) {
          ret.push(nf(chars));
          chars = [];
        }
        ret.push(ef(emoji));
      } else {
        let cp3 = input.pop();
        if (VALID.has(cp3)) {
          chars.push(cp3);
        } else {
          let cps = MAPPED.get(cp3);
          if (cps) {
            chars.push(...cps);
          } else if (!IGNORED.has(cp3)) {
            throw error_disallowed(cp3);
          }
        }
      }
    }
    if (chars.length) {
      ret.push(nf(chars));
    }
    return ret;
  }
  function filter_fe0f(cps) {
    return cps.filter((cp3) => cp3 != FE0F);
  }
  function consume_emoji_reversed(cps, eaten) {
    let node = EMOJI_ROOT;
    let emoji;
    let pos = cps.length;
    while (pos) {
      node = node.get(cps[--pos]);
      if (!node) break;
      let { V } = node;
      if (V) {
        emoji = V;
        if (eaten) eaten.push(...cps.slice(pos).reverse());
        cps.length = pos;
      }
    }
    return emoji;
  }

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/utils.js
  var normalize3 = (name2) => ens_normalize(name2);
  var namehash = (inputName) => {
    let node = "";
    for (let i2 = 0; i2 < 32; i2 += 1) {
      node += "00";
    }
    if (inputName) {
      const name2 = normalize3(inputName);
      const labels = name2.split(".");
      for (let i2 = labels.length - 1; i2 >= 0; i2 -= 1) {
        const labelSha = sha3Raw(labels[i2]).slice(2);
        node = sha3Raw(`0x${node}${labelSha}`).slice(2);
      }
    }
    return `0x${node}`;
  };

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/registry.js
  var __awaiter35 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Registry = class {
    constructor(context, customRegistryAddress) {
      this.contract = new Contract(ENSRegistryAbi, customRegistryAddress !== null && customRegistryAddress !== void 0 ? customRegistryAddress : registryAddresses.main, context);
      this.context = context;
    }
    getOwner(name2) {
      return __awaiter35(this, void 0, void 0, function* () {
        try {
          const result = this.contract.methods.owner(namehash(name2)).call();
          return result;
        } catch (error) {
          throw new Error();
        }
      });
    }
    getTTL(name2) {
      return __awaiter35(this, void 0, void 0, function* () {
        try {
          return this.contract.methods.ttl(namehash(name2)).call();
        } catch (error) {
          throw new Error();
        }
      });
    }
    recordExists(name2) {
      return __awaiter35(this, void 0, void 0, function* () {
        try {
          const promise = this.contract.methods.recordExists(namehash(name2)).call();
          return promise;
        } catch (error) {
          throw new Error();
        }
      });
    }
    getResolver(name2) {
      return __awaiter35(this, void 0, void 0, function* () {
        try {
          return this.contract.methods.resolver(namehash(name2)).call().then((address) => {
            if (typeof address === "string") {
              const contract = new Contract(PublicResolverAbi, address, this.context);
              return contract;
            }
            throw new Error();
          });
        } catch (error) {
          throw new Error();
        }
      });
    }
    get events() {
      return this.contract.events;
    }
  };

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/resolver.js
  var __awaiter36 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Resolver = class {
    constructor(registry) {
      this.registry = registry;
    }
    getResolverContractAdapter(ENSName) {
      return __awaiter36(this, void 0, void 0, function* () {
        return this.registry.getResolver(ENSName);
      });
    }
    //  https://eips.ethereum.org/EIPS/eip-165
    // eslint-disable-next-line class-methods-use-this
    checkInterfaceSupport(resolverContract, methodName) {
      var _a6, _b3;
      return __awaiter36(this, void 0, void 0, function* () {
        if (isNullish2(interfaceIds[methodName]))
          throw new ResolverMethodMissingError((_a6 = resolverContract.options.address) !== null && _a6 !== void 0 ? _a6 : "", methodName);
        const supported = yield resolverContract.methods.supportsInterface(interfaceIds[methodName]).call();
        if (!supported)
          throw new ResolverMethodMissingError((_b3 = resolverContract.options.address) !== null && _b3 !== void 0 ? _b3 : "", methodName);
      });
    }
    supportsInterface(ENSName, interfaceId) {
      var _a6;
      return __awaiter36(this, void 0, void 0, function* () {
        const resolverContract = yield this.getResolverContractAdapter(ENSName);
        let interfaceIdParam = interfaceId;
        if (!isHexStrict(interfaceIdParam)) {
          interfaceIdParam = (_a6 = sha3(interfaceId)) !== null && _a6 !== void 0 ? _a6 : "";
          if (interfaceId === "")
            throw new Error("Invalid interface Id");
          interfaceIdParam = interfaceIdParam.slice(0, 10);
        }
        return resolverContract.methods.supportsInterface(interfaceIdParam).call();
      });
    }
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    getAddress(ENSName, coinType = 60) {
      return __awaiter36(this, void 0, void 0, function* () {
        const resolverContract = yield this.getResolverContractAdapter(ENSName);
        yield this.checkInterfaceSupport(resolverContract, methodsInInterface.addr);
        return resolverContract.methods.addr(namehash(ENSName), coinType).call();
      });
    }
    getPubkey(ENSName) {
      return __awaiter36(this, void 0, void 0, function* () {
        const resolverContract = yield this.getResolverContractAdapter(ENSName);
        yield this.checkInterfaceSupport(resolverContract, methodsInInterface.pubkey);
        return resolverContract.methods.pubkey(namehash(ENSName)).call();
      });
    }
    getContenthash(ENSName) {
      return __awaiter36(this, void 0, void 0, function* () {
        const resolverContract = yield this.getResolverContractAdapter(ENSName);
        yield this.checkInterfaceSupport(resolverContract, methodsInInterface.contenthash);
        return resolverContract.methods.contenthash(namehash(ENSName)).call();
      });
    }
  };

  // ../../node_modules/.pnpm/web3-eth-ens@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-ens/lib/esm/ens.js
  var __awaiter37 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var ENS = class extends Web3Context {
    /**
     * Use to create an instance of ENS
     * @param registryAddr - (Optional) The address of the ENS registry (default: mainnet registry address)
     * @param provider - (Optional) The provider to use for the ENS instance
     * @example
     * ```ts
     * const ens = new ENS(
     * 	"0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
     * 	"http://localhost:8545"
     * );
     *
     * console.log( ens.defaultChain);
     * > mainnet
     * ```
     */
    constructor(registryAddr, provider) {
      super(provider !== null && provider !== void 0 ? provider : "");
      this.registryAddress = registryAddr !== null && registryAddr !== void 0 ? registryAddr : registryAddresses.main;
      this._registry = new Registry(this.getContextObject(), registryAddr);
      this._resolver = new Resolver(this._registry);
    }
    /**
     * Returns the Resolver by the given address
     * @param name - The name of the ENS domain
     * @returns - An contract instance of the resolver
     *
     * @example
     * ```ts
     * const resolver = await ens.getResolver('resolver');
     *
     * console.log(resolver.options.address);
     * > '0x1234567890123456789012345678901234567890'
     * ```
     */
    getResolver(name2) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._registry.getResolver(name2);
      });
    }
    /**
     * Returns true if the record exists
     * @param name - The ENS name
     * @returns - Returns `true` if node exists in this ENS registry. This will return `false` for records that are in the legacy ENS registry but have not yet been migrated to the new one.
     * @example
     * ```ts
     * const exists = await web3.eth.ens.recordExists('ethereum.eth');
     * ```
     */
    recordExists(name2) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._registry.recordExists(name2);
      });
    }
    /**
     * Returns the caching TTL (time-to-live) of an ENS name.
     * @param name - The ENS name
     * @returns - Returns the caching TTL (time-to-live) of a name.
     * @example
     * ```ts
     * const owner = await web3.eth.ens.getTTL('ethereum.eth');
     * ```
     */
    getTTL(name2) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._registry.getTTL(name2);
      });
    }
    /**
     * Returns the owner by the given name and current configured or detected Registry
     * @param name - The ENS name
     * @returns - Returns the address of the owner of the name.
     * @example
     * ```ts
     * const owner = await web3.eth.ens.getOwner('ethereum.eth');
     * ```
     */
    getOwner(name2) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._registry.getOwner(name2);
      });
    }
    /**
     * Resolves an ENS name to an Ethereum address.
     * @param ENSName - The ENS name to resolve
     * @param coinType - (Optional) The coin type, defaults to 60 (ETH)
     * @returns - The Ethereum address of the given name
     * ```ts
     * const address = await web3.eth.ens.getAddress('ethereum.eth');
     * console.log(address);
     * > '0xfB6916095ca1df60bB79Ce92cE3Ea74c37c5d359'
     * ```
     */
    getAddress(ENSName, coinType = 60) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._resolver.getAddress(ENSName, coinType);
      });
    }
    /**
     * Returns the X and Y coordinates of the curve point for the public key.
     * @param ENSName - The ENS name
     * @returns - The X and Y coordinates of the curve point for the public key
     * @example
     * ```ts
     * const key = await web3.eth.ens.getPubkey('ethereum.eth');
     * console.log(key);
     * > {
     * "0": "0x0000000000000000000000000000000000000000000000000000000000000000",
     * "1": "0x0000000000000000000000000000000000000000000000000000000000000000",
     * "x": "0x0000000000000000000000000000000000000000000000000000000000000000",
     * "y": "0x0000000000000000000000000000000000000000000000000000000000000000"
     * }
     * ```
     */
    getPubkey(ENSName) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._resolver.getPubkey(ENSName);
      });
    }
    /**
     * Returns the content hash object associated with an ENS node.
     * @param ENSName - The ENS name
     * @returns - The content hash object associated with an ENS node
     * @example
     * ```ts
     * const hash = await web3.eth.ens.getContenthash('ethereum.eth');
     * console.log(hash);
     * > 'QmaEBknbGT4bTQiQoe2VNgBJbRfygQGktnaW5TbuKixjYL'
     * ```
     */
    getContenthash(ENSName) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._resolver.getContenthash(ENSName);
      });
    }
    /**
     * Checks if the current used network is synced and looks for ENS support there.
     * Throws an error if not.
     * @returns - The address of the ENS registry if the network has been detected successfully
     * @example
     * ```ts
     * console.log(await web3.eth.ens.checkNetwork());
     * > '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'
     * ```
     */
    checkNetwork() {
      return __awaiter37(this, void 0, void 0, function* () {
        const now = Date.now() / 1e3;
        if (!this._lastSyncCheck || now - this._lastSyncCheck > 3600) {
          const syncInfo = yield isSyncing(this);
          if (!(typeof syncInfo === "boolean" && !syncInfo)) {
            throw new ENSNetworkNotSyncedError();
          }
          this._lastSyncCheck = now;
        }
        if (this._detectedAddress) {
          return this._detectedAddress;
        }
        const networkType = yield getId2(this, Object.assign(Object.assign({}, DEFAULT_RETURN_FORMAT), { number: FMT_NUMBER.HEX }));
        const addr = registryAddresses[networkIds[networkType]];
        if (typeof addr === "undefined") {
          throw new ENSUnsupportedNetworkError(networkType);
        }
        this._detectedAddress = addr;
        return this._detectedAddress;
      });
    }
    /**
     * Returns true if the related Resolver does support the given signature or interfaceId.
     * @param ENSName - The ENS name
     * @param interfaceId - The signature of the function or the interfaceId as described in the ENS documentation
     * @returns - `true` if the related Resolver does support the given signature or interfaceId.
     * @example
     * ```ts
     * const supports = await web3.eth.ens.supportsInterface('ethereum.eth', 'addr(bytes32');
     * console.log(supports);
     * > true
     * ```
     */
    supportsInterface(ENSName, interfaceId) {
      return __awaiter37(this, void 0, void 0, function* () {
        return this._resolver.supportsInterface(ENSName, interfaceId);
      });
    }
    /**
     * @returns - Returns all events that can be emitted by the ENS registry.
     */
    get events() {
      return this._registry.events;
    }
  };

  // ../../node_modules/.pnpm/web3-eth-personal@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-personal/lib/esm/rpc_method_wrappers.js
  var __awaiter38 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var getAccounts3 = (requestManager) => __awaiter38(void 0, void 0, void 0, function* () {
    const result = yield personal_rpc_methods_exports.getAccounts(requestManager);
    return result.map(toChecksumAddress);
  });
  var newAccount2 = (requestManager, password) => __awaiter38(void 0, void 0, void 0, function* () {
    validator.validate(["string"], [password]);
    const result = yield personal_rpc_methods_exports.newAccount(requestManager, password);
    return toChecksumAddress(result);
  });
  var unlockAccount2 = (requestManager, address, password, unlockDuration) => __awaiter38(void 0, void 0, void 0, function* () {
    validator.validate(["address", "string", "uint"], [address, password, unlockDuration]);
    return personal_rpc_methods_exports.unlockAccount(requestManager, address, password, unlockDuration);
  });
  var lockAccount2 = (requestManager, address) => __awaiter38(void 0, void 0, void 0, function* () {
    validator.validate(["address"], [address]);
    return personal_rpc_methods_exports.lockAccount(requestManager, address);
  });
  var importRawKey2 = (requestManager, keyData, passphrase) => __awaiter38(void 0, void 0, void 0, function* () {
    validator.validate(["string", "string"], [keyData, passphrase]);
    return personal_rpc_methods_exports.importRawKey(requestManager, keyData, passphrase);
  });
  var sendTransaction4 = (requestManager, tx, passphrase) => __awaiter38(void 0, void 0, void 0, function* () {
    const formattedTx = formatTransaction(tx, ETH_DATA_FORMAT);
    return personal_rpc_methods_exports.sendTransaction(requestManager, formattedTx, passphrase);
  });
  var signTransaction5 = (requestManager, tx, passphrase) => __awaiter38(void 0, void 0, void 0, function* () {
    const formattedTx = formatTransaction(tx, ETH_DATA_FORMAT);
    return personal_rpc_methods_exports.signTransaction(requestManager, formattedTx, passphrase);
  });
  var sign5 = (requestManager, data, address, passphrase) => __awaiter38(void 0, void 0, void 0, function* () {
    validator.validate(["string", "address", "string"], [data, address, passphrase]);
    const dataToSign = isHexStrict(data) ? data : utf8ToHex(data);
    return personal_rpc_methods_exports.sign(requestManager, dataToSign, address, passphrase);
  });
  var ecRecover2 = (requestManager, signedData, signature) => __awaiter38(void 0, void 0, void 0, function* () {
    validator.validate(["string", "string"], [signedData, signature]);
    const signedDataString = isHexStrict(signedData) ? signedData : utf8ToHex(signedData);
    return personal_rpc_methods_exports.ecRecover(requestManager, signedDataString, signature);
  });

  // ../../node_modules/.pnpm/web3-eth-personal@4.0.8_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3-eth-personal/lib/esm/personal.js
  var __awaiter39 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var Personal = class extends Web3Context {
    /**
     *Returns a list of accounts the node controls by using the provider and calling the RPC method personal_listAccounts. Using `web3.eth.accounts.create()` will not add accounts into this list. For that use `web3.eth.personal.newAccount()`.
     * @returns - An array of addresses controlled by the node.
     * @example
     * ```ts
     *  const accounts = await personal.getAccounts();
     * console.log(accounts);
     * >
     * [
     * 	'0x79D7BbaC53C9aF700d0B250e9AE789E503Fcd6AE',
     * 	'0xe2597eB05CF9a87eB1309e86750C903EC38E527e',
     * 	'0x7eD0e85B8E1E925600B4373e6d108F34AB38a401',
     * 	'0xE4bEEf667408b99053dC147Ed19592aDa0d77F59',
     * 	'0x7AB80aeB6bb488B7f6c41c58e83Ef248eB39c882',
     * 	'0x12B1D9d74d73b1C3A245B19C1C5501c653aF1af9',
     * 	'0x1a6075A263Ee140e00Dbf8E374Fc5A443d097894',
     * 	'0x4FEC0A51024B13030D26E70904B066C6d41157A5',
     * 	'0x03095dc4857BB26f3a4550c5651Df8b7f6b6B1Ef',
     * 	'0xac0B9b6e8A17991cb172B2ABAF45Fb5eb769E540'
     * ]
     * ```
     */
    getAccounts() {
      return __awaiter39(this, void 0, void 0, function* () {
        return getAccounts3(this.requestManager);
      });
    }
    /**
     * Creates a new account and returns its address.
     * **_NOTE:_**  This function sends a sensitive information like password. Never call this function over a unsecured Websocket or HTTP provider, as your password will be sent in plain text!
     * @param password - The password to encrypt the account with.
     * @returns - The address of the new account.
     * @example
     * ```ts
     * const addr = await web3.eth.personal.newAccount('password');
     * console.log(addr);
     * > '0x1234567891011121314151617181920212223456'
     * ```
     */
    newAccount(password) {
      return __awaiter39(this, void 0, void 0, function* () {
        return newAccount2(this.requestManager, password);
      });
    }
    /**
     * Unlocks an account for a given duration.
     * @param address - The address of the account to unlock.
     * @param password - The password of the account to unlock.
     * @param unlockDuration - The duration in seconds to unlock the account for.
     * @example
     * ```ts
     * await personal.unlockAccount(
     * 	"0x0d4aa485ecbc499c70860feb7e5aaeaf5fd8172e",
     * 	"123456",
     * 	600
     * );
     * ```
     */
    unlockAccount(address, password, unlockDuration) {
      return __awaiter39(this, void 0, void 0, function* () {
        return unlockAccount2(this.requestManager, address, password, unlockDuration);
      });
    }
    /**
     * Locks the given account
     * @param address - The address of the account to lock.
     * @returns - `true` if the account was locked, otherwise `false`.
     * @example
     * ```ts
     * await personal.lockAccount(
     * 	"0x0d4aa485ecbc499c70860feb7e5aaeaf5fd8172e"
     * );
     */
    lockAccount(address) {
      return __awaiter39(this, void 0, void 0, function* () {
        return lockAccount2(this.requestManager, address);
      });
    }
    /**
     * Imports the given private key into the key store, encrypting it with the passphrase.
     * @param keyData - An unencrypted private key (hex string).
     * @param passphrase  - The password of the account
     * @returns - The address of the new account.
     * @example
     * ```ts
     * const accountAddress = await personal.importRawKey(
     * 	"abe40cb08850da918ee951b237fa87946499b2d8643e4aa12b0610b050c731f6",
     * 	"123456"
     * );
     *
     * console.log(unlockTx);
     * > 0x8727a8b34ec833154b72b62cac05d69f86eb6556
     * ```
     */
    importRawKey(keyData, passphrase) {
      return __awaiter39(this, void 0, void 0, function* () {
        return importRawKey2(this.requestManager, keyData, passphrase);
      });
    }
    /**
     * This method sends a transaction over the management API.
     * **_NOTE:_** Sending your account password over an unsecured HTTP RPC connection is highly unsecure.
     * @param tx - The transaction options
     * @param passphrase - The passphrase of the current account
     * @returns - The transaction hash
     * @example
     * ```ts
     * const txHash = personal
     * .sendTransaction({
     *  	from: "0x0d4aa485ecbc499c70860feb7e5aaeaf5fd8172e",
     * 	gasPrice: "20000000000",
     * 	gas: "21000",
     * 	to: "0x3535353535353535353535353535353535353535",
     * 	value: "1000000",
     * 	data: "",
     * 	nonce: 0,
     * },
     * "123456");
     *
     * console.log(txHash);
     * > 0x9445325c3c5638c9fe425b003b8c32f03e9f99d409555a650a6838ba712bb51b
     * ```
     */
    sendTransaction(tx, passphrase) {
      return __awaiter39(this, void 0, void 0, function* () {
        return sendTransaction4(this.requestManager, tx, passphrase);
      });
    }
    /**
     * Signs a transaction. This account needs to be unlocked.
     * **_NOTE:_** Sending your account password over an unsecured HTTP RPC connection is highly unsecure.
     * @param tx - The transaction data to sign. See {@link sendTransaction}  for more information.
     * @param passphrase - The password of the `from` account, to sign the transaction with.
     * @returns - The RLP encoded transaction. The `raw` property can be used to send the transaction using {@link sendSignedTransaction}.
     * @example
     * ```ts
     * const tx = personal
     * .signTransaction({
     * 	from: "0x0d4aa485ecbc499c70860feb7e5aaeaf5fd8172e",
     * 	gasPrice: "20000000000",
     * 	gas: "21000",
     * 	to: "0x3535353535353535353535353535353535353535",
     * 	value: "1000000000000000000",
     * 	data: "",
     * 	nonce: 0,
     * },
     * "123456");
     *
     * console.log(tx);
     *
     * > {
     * 	raw: '0xf86e808504a817c800825208943535353535353535353535353535353535353535880de0b6b3a764000080820a95a0c951c03238fe930e6e69ab9d6af9f29248a514048e44884f0e60c4de40de3526a038b71399bf0c8925749ab79e91ce6cd2fc068c84c18ff6a197b48c4cbef01e00',
     * 	tx: {
     * 	type: '0x0',
     * 	nonce: '0x0',
     * 	gasPrice: '0x4a817c800',
     * 	maxPriorityFeePerGas: null,
     * 	maxFeePerGas: null,
     * 	gas: '0x5208',
     * 	value: '0xde0b6b3a7640000',
     * 	input: '0x',
     * 	v: '0xa95',
     * 	r: '0xc951c03238fe930e6e69ab9d6af9f29248a514048e44884f0e60c4de40de3526',
     * 	s: '0x38b71399bf0c8925749ab79e91ce6cd2fc068c84c18ff6a197b48c4cbef01e00',
     * 	to: '0x3535353535353535353535353535353535353535',
     * 	hash: '0x65e3df790ab2a32068b13cff970b26445b8995229ae4abbed61bd996f09fce69'
     * 	}
     * }
     * ```
     */
    signTransaction(tx, passphrase) {
      return __awaiter39(this, void 0, void 0, function* () {
        return signTransaction5(this.requestManager, tx, passphrase);
      });
    }
    /**
     * Calculates an Ethereum specific signature with:
     * sign(keccak256("\x19Ethereum Signed Message:\n" + dataToSign.length + dataToSign)))
     * Adding a prefix to the message makes the calculated signature recognisable as an Ethereum specific signature.
     *
     * If you have the original message and the signed message, you can discover the signing account address using web3.eth.personal.ecRecover
     * **_NOTE:_** Sending your account password over an unsecured HTTP RPC connection is highly unsecure.
     * @param data - The data to sign.
     * @param address - The address to sign with.
     * @param passphrase - The passphrase to decrypt the account with.
     * @returns - The signature.
     * @example
     * ```ts
     * const sig = await personal .sign("Hello world", "0x0D4Aa485ECbC499c70860fEb7e5AaeAf5fd8172E", "123456")
     * console.log(sig)
     * > 0x5d21d01b3198ac34d0585a9d76c4d1c8123e5e06746c8962318a1c08ffb207596e6fce4a6f377b7c0fc98c5f646cd73438c80e8a1a95cbec55a84c2889dca0301b
     * ```
     */
    sign(data, address, passphrase) {
      return __awaiter39(this, void 0, void 0, function* () {
        return sign5(this.requestManager, data, address, passphrase);
      });
    }
    /**
     * Recovers the account that signed the data.
     * @param signedData - Data that was signed. If String it will be converted using {@link utf8ToHex}
     * @param signature - The signature
     * @returns - The address of the account that signed the data.
     * @example
     * ```ts
     *  const address = await personal.ecRecover(
     * 	"Hello world",
     * 	"0x5d21d01b3198ac34d0585a9d76c4d1c8123e5e06746c8962318a1c08ffb207596e6fce4a6f377b7c0fc98c5f646cd73438c80e8a1a95cbec55a84c2889dca0301b"
     * );
     * console.log(address);
     * > 0x0d4aa485ecbc499c70860feb7e5aaeaf5fd8172e
     * ```
     */
    ecRecover(signedData, signature) {
      return __awaiter39(this, void 0, void 0, function* () {
        return ecRecover2(this.requestManager, signedData, signature);
      });
    }
  };

  // ../../node_modules/.pnpm/web3@4.3.0_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3/lib/esm/abi.js
  var abi_default = {
    encodeEventSignature,
    encodeFunctionCall,
    encodeFunctionSignature,
    encodeParameter,
    encodeParameters: encodeParameters2,
    decodeParameter,
    decodeParameters: decodeParameters2,
    decodeLog
  };

  // ../../node_modules/.pnpm/web3@4.3.0_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3/lib/esm/accounts.js
  var __awaiter40 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve2) {
        resolve2(value);
      });
    }
    return new (P || (P = Promise))(function(resolve2, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e2) {
          reject(e2);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e2) {
          reject(e2);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var initAccountsForContext = (context) => {
    const signTransactionWithContext = (transaction, privateKey) => __awaiter40(void 0, void 0, void 0, function* () {
      const tx = yield prepareTransactionForSigning(transaction, context);
      const privateKeyBytes = format4({ format: "bytes" }, privateKey, ETH_DATA_FORMAT);
      return signTransaction(tx, privateKeyBytes);
    });
    const privateKeyToAccountWithContext = (privateKey) => {
      const account = privateKeyToAccount(privateKey);
      return Object.assign(Object.assign({}, account), { signTransaction: (transaction) => __awaiter40(void 0, void 0, void 0, function* () {
        return signTransactionWithContext(transaction, account.privateKey);
      }) });
    };
    const decryptWithContext = (keystore, password, options) => __awaiter40(void 0, void 0, void 0, function* () {
      var _a6;
      const account = yield decrypt2(keystore, password, (_a6 = options === null || options === void 0 ? void 0 : options.nonStrict) !== null && _a6 !== void 0 ? _a6 : true);
      return Object.assign(Object.assign({}, account), { signTransaction: (transaction) => __awaiter40(void 0, void 0, void 0, function* () {
        return signTransactionWithContext(transaction, account.privateKey);
      }) });
    });
    const createWithContext = () => {
      const account = create();
      return Object.assign(Object.assign({}, account), { signTransaction: (transaction) => __awaiter40(void 0, void 0, void 0, function* () {
        return signTransactionWithContext(transaction, account.privateKey);
      }) });
    };
    const wallet = new Wallet({
      create: createWithContext,
      privateKeyToAccount: privateKeyToAccountWithContext,
      decrypt: decryptWithContext
    });
    return {
      signTransaction: signTransactionWithContext,
      create: createWithContext,
      privateKeyToAccount: privateKeyToAccountWithContext,
      decrypt: decryptWithContext,
      recoverTransaction,
      hashMessage,
      sign,
      recover,
      encrypt: encrypt2,
      wallet,
      privateKeyToAddress,
      parseAndValidatePrivateKey,
      privateKeyToPublicKey
    };
  };

  // ../../node_modules/.pnpm/web3@4.3.0_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3/lib/esm/version.js
  var Web3PkgInfo = { version: "4.3.0" };

  // ../../node_modules/.pnpm/web3@4.3.0_bufferutil@4.0.7_encoding@0.1.13_typescript@5.6.3_utf-8-validate@6.0.3_zod@3.25.76/node_modules/web3/lib/esm/web3.js
  var Web3 = class extends Web3Context {
    constructor(providerOrContext) {
      var _a6;
      if (isNullish2(providerOrContext) || typeof providerOrContext === "string" && providerOrContext.trim() === "" || typeof providerOrContext !== "string" && !isSupportedProvider(providerOrContext) && !providerOrContext.provider) {
        console.warn("NOTE: web3.js is running without provider. You need to pass a provider in order to interact with the network!");
      }
      let contextInitOptions = {};
      if (typeof providerOrContext === "string" || isSupportedProvider(providerOrContext)) {
        contextInitOptions.provider = providerOrContext;
      } else if (providerOrContext) {
        contextInitOptions = providerOrContext;
      } else {
        contextInitOptions = {};
      }
      contextInitOptions.registeredSubscriptions = Object.assign(Object.assign({}, registeredSubscriptions), (_a6 = contextInitOptions.registeredSubscriptions) !== null && _a6 !== void 0 ? _a6 : {});
      super(contextInitOptions);
      const accounts = initAccountsForContext(this);
      this._wallet = accounts.wallet;
      this._accountProvider = accounts;
      this.utils = esm_exports;
      const self2 = this;
      class ContractBuilder extends esm_default {
        constructor(jsonInterface, addressOrOptionsOrContext, optionsOrContextOrReturnFormat, contextOrReturnFormat, returnFormat) {
          if (isContractInitOptions(addressOrOptionsOrContext) && isContractInitOptions(optionsOrContextOrReturnFormat)) {
            throw new InvalidMethodParamsError("Should not provide options at both 2nd and 3rd parameters");
          }
          let address;
          let options = {};
          let context;
          let dataFormat = DEFAULT_RETURN_FORMAT;
          if (!isNullish2(addressOrOptionsOrContext) && typeof addressOrOptionsOrContext !== "object" && typeof addressOrOptionsOrContext !== "string") {
            throw new InvalidMethodParamsError();
          }
          if (typeof addressOrOptionsOrContext === "string") {
            address = addressOrOptionsOrContext;
          }
          if (isContractInitOptions(addressOrOptionsOrContext)) {
            options = addressOrOptionsOrContext;
          } else if (isContractInitOptions(optionsOrContextOrReturnFormat)) {
            options = optionsOrContextOrReturnFormat;
          } else {
            options = {};
          }
          if (addressOrOptionsOrContext instanceof Web3Context) {
            context = addressOrOptionsOrContext;
          } else if (optionsOrContextOrReturnFormat instanceof Web3Context) {
            context = optionsOrContextOrReturnFormat;
          } else if (contextOrReturnFormat instanceof Web3Context) {
            context = contextOrReturnFormat;
          } else {
            context = self2.getContextObject();
          }
          if (returnFormat) {
            dataFormat = returnFormat;
          } else if (isDataFormat(optionsOrContextOrReturnFormat)) {
            dataFormat = optionsOrContextOrReturnFormat;
          } else if (isDataFormat(contextOrReturnFormat)) {
            dataFormat = contextOrReturnFormat;
          }
          super(jsonInterface, address, options, context, dataFormat);
          super.subscribeToContextEvents(self2);
        }
      }
      const eth = self2.use(Web3Eth);
      this.eth = Object.assign(eth, {
        // ENS module
        ens: self2.use(ENS, registryAddresses.main),
        // Iban helpers
        Iban,
        net: self2.use(Net),
        personal: self2.use(Personal),
        // Contract helper and module
        Contract: ContractBuilder,
        // ABI Helpers
        abi: abi_default,
        // Accounts helper
        accounts
      });
    }
  };
  Web3.version = Web3PkgInfo.version;
  Web3.utils = esm_exports;
  Web3.modules = {
    Web3Eth,
    Iban,
    Net,
    ENS,
    Personal
  };
  var web3_default = Web3;

  // ../ethereum/package.json
  var package_default4 = {
    name: "@slangroom/ethereum",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*",
      web3: "4.3.0",
      "web3-validator": "2.0.3"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    },
    devDependencies: {
      ganache: "^7.9.2"
    }
  };

  // ../ethereum/build/esm/src/plugin.js
  var version5 = package_default4.version;
  var p = new Plugin();
  var EthereumError = class extends Error {
    constructor(e2) {
      super(e2);
      this.name = "Slangroom @slangroom/ethereum@" + package_default4.version + " Error";
    }
  };
  var ethNonce = p.new("connect", ["address"], "read the ethereum nonce", async (ctx) => {
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const addr = ctx.fetch("address");
    if (typeof addr !== "string")
      return ctx.fail(new EthereumError("address must be string"));
    const nonce = await web3.eth.getTransactionCount(addr);
    return ctx.pass(nonce.toString());
  });
  var ethBytes = p.new("connect", ["transaction_id"], "read the ethereum bytes", async (ctx) => {
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const tag = ctx.fetch("transaction_id");
    if (typeof tag !== "string")
      return ctx.fail(new EthereumError("tag must be string"));
    const receipt = await web3.eth.getTransactionReceipt(tag.startsWith("0x") ? tag : "0x" + tag);
    if (!receipt)
      return ctx.fail(new EthereumError("Transaction id doesn't exist"));
    if (!receipt.status)
      return ctx.fail(new EthereumError("Failed transaction"));
    try {
      const dataRead = receipt.logs[0]?.data?.slice(2);
      return ctx.pass(dataRead?.toString() || "");
    } catch (e2) {
      return ctx.fail(new EthereumError("Empty transaction"));
    }
  });
  var ethBalanceAddr = p.new("connect", ["address"], "read the ethereum balance", async (ctx) => {
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const addr = ctx.get("address");
    if (typeof addr !== "string")
      return ctx.fail(new EthereumError("address must be string"));
    return ctx.pass((await web3.eth.getBalance(addr)).toString());
  });
  var ethBalanceAddrs = p.new("connect", ["addresses"], "read the ethereum balance", async (ctx) => {
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const addrs = ctx.fetch("addresses");
    if (!Array.isArray(addrs) || !addrs.every((x) => typeof x === "string"))
      return ctx.fail(new EthereumError("addresses must be string array"));
    const balances = await Promise.all(addrs.map((addr) => web3.eth.getBalance(addr)));
    return ctx.pass(balances.map((b) => b.toString()));
  });
  var ethGasPrice = p.new("connect", "read the ethereum suggested gas price", async (ctx) => {
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const gasPrice = await web3.eth.getGasPrice();
    return ctx.pass(gasPrice.toString());
  });
  var ethBrodcast = p.new("connect", ["transaction"], "read the ethereum transaction id after broadcast", async (ctx) => {
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const rawtx = ctx.fetch("transaction");
    if (typeof rawtx !== "string")
      return ctx.fail(new EthereumError("transaction must be string"));
    try {
      const receipt = await web3.eth.sendSignedTransaction(rawtx.startsWith("0x") ? rawtx : "0x" + rawtx);
      if (!receipt.status)
        return ctx.fail(new EthereumError("transaction failed"));
      return ctx.pass(receipt.transactionHash.toString().substring(2));
    } catch (e2) {
      return ctx.fail(new EthereumError(e2.message));
    }
  });
  var erc20helper = (name2) => {
    return async (ctx) => {
      const web3 = new web3_default(ctx.fetchConnect()[0]);
      const sc = ctx.fetch("sc");
      if (typeof sc !== "string")
        return ctx.fail(new EthereumError("sc must be string"));
      if (!isAddress(sc))
        return ctx.fail(new EthereumError(`sc must be a valid ethereum address: ${sc}`));
      const erc20 = new web3.eth.Contract(erc20abi, sc);
      const res = (await erc20.methods[name2]?.().call())?.toString();
      if (!res)
        return ctx.fail(new EthereumError(`${name2} call failed`));
      return ctx.pass(res);
    };
  };
  var erc20decimals = p.new("connect", ["sc"], "read the erc20 decimals", erc20helper("decimals()"));
  var erc20name = p.new("connect", ["sc"], "read the erc20 name", erc20helper("name()"));
  var erc20symbol = p.new("connect", ["sc"], "read the erc20 symbol", erc20helper("symbol()"));
  var erc20balance = p.new("connect", ["sc", "address"], "read the erc20 balance", erc20helper("balanceOf()"));
  var erc20totalSupply = p.new("connect", ["sc"], "read the erc20 total supply", erc20helper("totalSupply()"));
  var erc721id = p.new("connect", ["transaction_id"], "read the erc721 id in transaction", async (ctx) => {
    const ERC721_TRANSFER_EVENT = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";
    const web3 = new web3_default(ctx.fetchConnect()[0]);
    const tag = ctx.fetch("transaction_id");
    const receipt = await web3.eth.getTransactionReceipt(tag.startsWith("0x") ? tag : "0x" + tag);
    const log2 = receipt.logs.find((v) => v && v.topics && v.topics.length > 0 && v.topics[0] === ERC721_TRANSFER_EVENT);
    if (!log2 || !log2.topics)
      return ctx.fail(new EthereumError("Token Id not found"));
    return ctx.pass(parseInt(log2.topics[3]?.toString() || "", 16));
  });
  var erc712owner = p.new("connect", "read the erc721 owner", async (ctx) => {
    return ctx.fail(new EthereumError("not implemented"));
  });
  var erc721asset = p.new("connect", "read the erc721 asset", async (ctx) => {
    return ctx.fail(new EthereumError("not implemented"));
  });
  var ethereum = p;

  // ../ethereum/build/esm/src/erc20abi.js
  var erc20abi = [
    {
      constant: true,
      inputs: [],
      name: "name",
      outputs: [
        {
          name: "",
          type: "string"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          name: "_spender",
          type: "address"
        },
        {
          name: "_value",
          type: "uint256"
        }
      ],
      name: "approve",
      outputs: [
        {
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          name: "_from",
          type: "address"
        },
        {
          name: "_to",
          type: "address"
        },
        {
          name: "_value",
          type: "uint256"
        }
      ],
      name: "transferFrom",
      outputs: [
        {
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "decimals",
      outputs: [
        {
          name: "",
          type: "uint8"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          name: "_owner",
          type: "address"
        }
      ],
      name: "balanceOf",
      outputs: [
        {
          name: "balance",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: true,
      inputs: [],
      name: "symbol",
      outputs: [
        {
          name: "",
          type: "string"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      constant: false,
      inputs: [
        {
          name: "_to",
          type: "address"
        },
        {
          name: "_value",
          type: "uint256"
        }
      ],
      name: "transfer",
      outputs: [
        {
          name: "",
          type: "bool"
        }
      ],
      payable: false,
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      constant: true,
      inputs: [
        {
          name: "_owner",
          type: "address"
        },
        {
          name: "_spender",
          type: "address"
        }
      ],
      name: "allowance",
      outputs: [
        {
          name: "",
          type: "uint256"
        }
      ],
      payable: false,
      stateMutability: "view",
      type: "function"
    },
    {
      payable: true,
      stateMutability: "payable",
      type: "fallback"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          name: "spender",
          type: "address"
        },
        {
          indexed: false,
          name: "value",
          type: "uint256"
        }
      ],
      name: "Approval",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          name: "from",
          type: "address"
        },
        {
          indexed: true,
          name: "to",
          type: "address"
        },
        {
          indexed: false,
          name: "value",
          type: "uint256"
        }
      ],
      name: "Transfer",
      type: "event"
    }
  ];

  // ../fs/build/esm/src/plugin.js
  var path = __toESM(require_path_browserify(), 1);
  init_dist4();

  // ../../node_modules/.pnpm/fflate@0.8.2/node_modules/fflate/esm/browser.js
  var u8 = Uint8Array;
  var u16 = Uint16Array;
  var i32 = Int32Array;
  var fleb = new u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */
    0,
    0,
    /* impossible */
    0
  ]);
  var fdeb = new u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */
    0,
    0
  ]);
  var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  var freb = function(eb, start) {
    var b = new u16(31);
    for (var i2 = 0; i2 < 31; ++i2) {
      b[i2] = start += 1 << eb[i2 - 1];
    }
    var r2 = new i32(b[30]);
    for (var i2 = 1; i2 < 30; ++i2) {
      for (var j = b[i2]; j < b[i2 + 1]; ++j) {
        r2[j] = j - b[i2] << 5 | i2;
      }
    }
    return { b, r: r2 };
  };
  var _a5 = freb(fleb, 2);
  var fl = _a5.b;
  var revfl = _a5.r;
  fl[28] = 258, revfl[258] = 28;
  var _b2 = freb(fdeb, 0);
  var fd = _b2.b;
  var revfd = _b2.r;
  var rev = new u16(32768);
  for (i2 = 0; i2 < 32768; ++i2) {
    x = (i2 & 43690) >> 1 | (i2 & 21845) << 1;
    x = (x & 52428) >> 2 | (x & 13107) << 2;
    x = (x & 61680) >> 4 | (x & 3855) << 4;
    rev[i2] = ((x & 65280) >> 8 | (x & 255) << 8) >> 1;
  }
  var x;
  var i2;
  var hMap = function(cd, mb, r2) {
    var s2 = cd.length;
    var i2 = 0;
    var l = new u16(mb);
    for (; i2 < s2; ++i2) {
      if (cd[i2])
        ++l[cd[i2] - 1];
    }
    var le = new u16(mb);
    for (i2 = 1; i2 < mb; ++i2) {
      le[i2] = le[i2 - 1] + l[i2 - 1] << 1;
    }
    var co;
    if (r2) {
      co = new u16(1 << mb);
      var rvb = 15 - mb;
      for (i2 = 0; i2 < s2; ++i2) {
        if (cd[i2]) {
          var sv = i2 << 4 | cd[i2];
          var r_1 = mb - cd[i2];
          var v = le[cd[i2] - 1]++ << r_1;
          for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
            co[rev[v] >> rvb] = sv;
          }
        }
      }
    } else {
      co = new u16(s2);
      for (i2 = 0; i2 < s2; ++i2) {
        if (cd[i2]) {
          co[i2] = rev[le[cd[i2] - 1]++] >> 15 - cd[i2];
        }
      }
    }
    return co;
  };
  var flt = new u8(288);
  for (i2 = 0; i2 < 144; ++i2)
    flt[i2] = 8;
  var i2;
  for (i2 = 144; i2 < 256; ++i2)
    flt[i2] = 9;
  var i2;
  for (i2 = 256; i2 < 280; ++i2)
    flt[i2] = 7;
  var i2;
  for (i2 = 280; i2 < 288; ++i2)
    flt[i2] = 8;
  var i2;
  var fdt = new u8(32);
  for (i2 = 0; i2 < 32; ++i2)
    fdt[i2] = 5;
  var i2;
  var flrm = /* @__PURE__ */ hMap(flt, 9, 1);
  var fdrm = /* @__PURE__ */ hMap(fdt, 5, 1);
  var max = function(a) {
    var m = a[0];
    for (var i2 = 1; i2 < a.length; ++i2) {
      if (a[i2] > m)
        m = a[i2];
    }
    return m;
  };
  var bits = function(d, p12, m) {
    var o = p12 / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p12 & 7) & m;
  };
  var bits16 = function(d, p12) {
    var o = p12 / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p12 & 7);
  };
  var shft = function(p12) {
    return (p12 + 7) / 8 | 0;
  };
  var slc = function(v, s2, e2) {
    if (s2 == null || s2 < 0)
      s2 = 0;
    if (e2 == null || e2 > v.length)
      e2 = v.length;
    return new u8(v.subarray(s2, e2));
  };
  var ec = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
    // determined by unknown compression method
  ];
  var err2 = function(ind, msg, nt) {
    var e2 = new Error(msg || ec[ind]);
    e2.code = ind;
    if (Error.captureStackTrace)
      Error.captureStackTrace(e2, err2);
    if (!nt)
      throw e2;
    return e2;
  };
  var inflt = function(dat, st, buf, dict) {
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l)
      return buf || new u8(0);
    var noBuf = !buf;
    var resize = noBuf || st.i != 2;
    var noSt = st.i;
    if (noBuf)
      buf = new u8(sl * 3);
    var cbuf = function(l2) {
      var bl = buf.length;
      if (l2 > bl) {
        var nbuf = new u8(Math.max(bl * 2, l2));
        nbuf.set(buf);
        buf = nbuf;
      }
    };
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    var tbts = sl * 8;
    do {
      if (!lm) {
        final = bits(dat, pos, 1);
        var type = bits(dat, pos + 1, 3);
        pos += 3;
        if (!type) {
          var s2 = shft(pos) + 4, l = dat[s2 - 4] | dat[s2 - 3] << 8, t2 = s2 + l;
          if (t2 > sl) {
            if (noSt)
              err2(0);
            break;
          }
          if (resize)
            cbuf(bt + l);
          buf.set(dat.subarray(s2, t2), bt);
          st.b = bt += l, st.p = pos = t2 * 8, st.f = final;
          continue;
        } else if (type == 1)
          lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
        else if (type == 2) {
          var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
          var tl = hLit + bits(dat, pos + 5, 31) + 1;
          pos += 14;
          var ldt = new u8(tl);
          var clt = new u8(19);
          for (var i2 = 0; i2 < hcLen; ++i2) {
            clt[clim[i2]] = bits(dat, pos + i2 * 3, 7);
          }
          pos += hcLen * 3;
          var clb = max(clt), clbmsk = (1 << clb) - 1;
          var clm = hMap(clt, clb, 1);
          for (var i2 = 0; i2 < tl; ) {
            var r2 = clm[bits(dat, pos, clbmsk)];
            pos += r2 & 15;
            var s2 = r2 >> 4;
            if (s2 < 16) {
              ldt[i2++] = s2;
            } else {
              var c = 0, n2 = 0;
              if (s2 == 16)
                n2 = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i2 - 1];
              else if (s2 == 17)
                n2 = 3 + bits(dat, pos, 7), pos += 3;
              else if (s2 == 18)
                n2 = 11 + bits(dat, pos, 127), pos += 7;
              while (n2--)
                ldt[i2++] = c;
            }
          }
          var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
          lbt = max(lt);
          dbt = max(dt);
          lm = hMap(lt, lbt, 1);
          dm = hMap(dt, dbt, 1);
        } else
          err2(1);
        if (pos > tbts) {
          if (noSt)
            err2(0);
          break;
        }
      }
      if (resize)
        cbuf(bt + 131072);
      var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
      var lpos = pos;
      for (; ; lpos = pos) {
        var c = lm[bits16(dat, pos) & lms], sym = c >> 4;
        pos += c & 15;
        if (pos > tbts) {
          if (noSt)
            err2(0);
          break;
        }
        if (!c)
          err2(2);
        if (sym < 256)
          buf[bt++] = sym;
        else if (sym == 256) {
          lpos = pos, lm = null;
          break;
        } else {
          var add2 = sym - 254;
          if (sym > 264) {
            var i2 = sym - 257, b = fleb[i2];
            add2 = bits(dat, pos, (1 << b) - 1) + fl[i2];
            pos += b;
          }
          var d = dm[bits16(dat, pos) & dms], dsym = d >> 4;
          if (!d)
            err2(3);
          pos += d & 15;
          var dt = fd[dsym];
          if (dsym > 3) {
            var b = fdeb[dsym];
            dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
          }
          if (pos > tbts) {
            if (noSt)
              err2(0);
            break;
          }
          if (resize)
            cbuf(bt + 131072);
          var end = bt + add2;
          if (bt < dt) {
            var shift = dl - dt, dend = Math.min(dt, end);
            if (shift + bt < 0)
              err2(3);
            for (; bt < dend; ++bt)
              buf[bt] = dict[shift + bt];
          }
          for (; bt < end; ++bt)
            buf[bt] = buf[bt - dt];
        }
      }
      st.l = lm, st.p = lpos, st.b = bt, st.f = final;
      if (lm)
        final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
  };
  var et = /* @__PURE__ */ new u8(0);
  var b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
  };
  var b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
  };
  var b8 = function(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
  };
  function inflateSync(data, opts) {
    return inflt(data, { i: 2 }, opts && opts.out, opts && opts.dictionary);
  }
  var td = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
  var tds = 0;
  try {
    td.decode(et, { stream: true });
    tds = 1;
  } catch (e2) {
  }
  var dutf8 = function(d) {
    for (var r2 = "", i2 = 0; ; ) {
      var c = d[i2++];
      var eb = (c > 127) + (c > 223) + (c > 239);
      if (i2 + eb > d.length)
        return { s: r2, r: slc(d, i2 - 1) };
      if (!eb)
        r2 += String.fromCharCode(c);
      else if (eb == 3) {
        c = ((c & 15) << 18 | (d[i2++] & 63) << 12 | (d[i2++] & 63) << 6 | d[i2++] & 63) - 65536, r2 += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
      } else if (eb & 1)
        r2 += String.fromCharCode((c & 31) << 6 | d[i2++] & 63);
      else
        r2 += String.fromCharCode((c & 15) << 12 | (d[i2++] & 63) << 6 | d[i2++] & 63);
    }
  };
  function strFromU8(dat, latin1) {
    if (latin1) {
      var r2 = "";
      for (var i2 = 0; i2 < dat.length; i2 += 16384)
        r2 += String.fromCharCode.apply(null, dat.subarray(i2, i2 + 16384));
      return r2;
    } else if (td) {
      return td.decode(dat);
    } else {
      var _a6 = dutf8(dat), s2 = _a6.s, r2 = _a6.r;
      if (r2.length)
        err2(8);
      return s2;
    }
  }
  var slzh = function(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
  };
  var zh = function(d, b, z2) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a6 = z2 && bs == 4294967295 ? z64e(d, es) : [bs, b4(d, b + 24), b4(d, b + 42)], sc = _a6[0], su = _a6[1], off = _a6[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
  };
  var z64e = function(d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2))
      ;
    return [b8(d, b + 12), b8(d, b + 4), b8(d, b + 20)];
  };
  function unzipSync(data, opts) {
    var files = {};
    var e2 = data.length - 22;
    for (; b4(data, e2) != 101010256; --e2) {
      if (!e2 || data.length - e2 > 65558)
        err2(13);
    }
    ;
    var c = b2(data, e2 + 8);
    if (!c)
      return {};
    var o = b4(data, e2 + 16);
    var z2 = o == 4294967295 || c == 65535;
    if (z2) {
      var ze = b4(data, e2 - 12);
      z2 = b4(data, ze) == 101075792;
      if (z2) {
        c = b4(data, ze + 32);
        o = b4(data, ze + 48);
      }
    }
    var fltr = opts && opts.filter;
    for (var i2 = 0; i2 < c; ++i2) {
      var _a6 = zh(data, o, z2), c_2 = _a6[0], sc = _a6[1], su = _a6[2], fn = _a6[3], no = _a6[4], off = _a6[5], b = slzh(data, off);
      o = no;
      if (!fltr || fltr({
        name: fn,
        size: sc,
        originalSize: su,
        compression: c_2
      })) {
        if (!c_2)
          files[fn] = slc(data, b, b + sc);
        else if (c_2 == 8)
          files[fn] = inflateSync(data.subarray(b, b + sc), { out: new u8(su) });
        else
          err2(14, "unknown compression type " + c_2);
      }
    }
    return files;
  }

  // ../fs/package.json
  var package_default5 = {
    name: "@slangroom/fs",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*",
      fflate: "0.8.2"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../fs/build/esm/src/plugin.js
  var version6 = package_default5.version;
  var FsError = class extends Error {
    constructor(e2) {
      super(e2);
      this.name = "Slangroom @slangroom/fs@" + package_default5.version + " Error";
    }
  };
  var sandboxDir = () => {
    if (typeof process === "undefined")
      return ".";
    return process.env["FILES_DIR"];
  };
  var resolveDirPath = (unsafe) => {
    const normalized = path.normalize(unsafe);
    const doesDirectoryTraversal = normalized.startsWith("/") || normalized.startsWith("..");
    if (doesDirectoryTraversal)
      return { ok: false, error: `dirpath is unsafe: ${unsafe}` };
    const sandboxdir = sandboxDir();
    if (!sandboxdir)
      return { ok: false, error: "$FILES_DIR must be provided" };
    return { ok: true, dirpath: path.join(sandboxdir, normalized) };
  };
  var resolveFilepath = (unsafe) => {
    const normalized = path.normalize(unsafe);
    const doesDirectoryTraversal = normalized.startsWith("/") || normalized.startsWith("..");
    const DoesntProvideFile = normalized.startsWith(".");
    if (doesDirectoryTraversal || DoesntProvideFile)
      return { ok: false, error: `filepath is unsafe: ${unsafe}` };
    const sandboxdir = sandboxDir();
    if (!sandboxdir)
      return { ok: false, error: "$FILES_DIR must be provided" };
    return { ok: true, filepath: path.join(sandboxdir, normalized) };
  };
  var readFile3 = async (safePath) => {
    try {
      return { ok: true, value: await promises_exports.readFile(safePath, "utf8") };
    } catch (e2) {
      return { ok: false, error: e2.message };
    }
  };
  var readJSON = async (safePath) => {
    try {
      const str = await promises_exports.readFile(safePath, "utf8");
      return { ok: true, value: JSON.parse(str) };
    } catch (e2) {
      return { ok: false, error: e2.message };
    }
  };
  var checkFileExists = async (safePath) => {
    try {
      await promises_exports.stat(safePath);
    } catch {
      return false;
    }
    return true;
  };
  var p2 = new Plugin();
  var downloadAndExtract = p2.new("connect", ["path"], "download and extract", async (ctx) => {
    const zipUrl = ctx.fetchConnect()[0];
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveDirPath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    await promises_exports.mkdir(res.dirpath, { recursive: true });
    try {
      const resp = await fetch(zipUrl);
      if (!resp.ok)
        return ctx.fail(new FsError(`Failed to fetch zip from ${zipUrl}: ${resp.status} ${resp.statusText}`));
      const zipData = new Uint8Array(await resp.arrayBuffer());
      const files = unzipSync(zipData);
      for (const [filename, fileData] of Object.entries(files)) {
        if (filename.endsWith("/"))
          continue;
        const fullPath = path.join(res.dirpath, filename);
        const dir = path.dirname(fullPath);
        await promises_exports.mkdir(dir, { recursive: true });
        await promises_exports.writeFile(fullPath, fileData);
      }
      return ctx.pass(null);
    } catch (e2) {
      if (e2 instanceof Error)
        return ctx.fail(new FsError(e2.message));
      return ctx.fail(new FsError(`unknown error: ${e2}`));
    }
  });
  var readFileContent = p2.new(["path"], "read file content", async (ctx) => {
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveFilepath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    const cont = await readJSON(res.filepath);
    if (!cont.ok)
      return ctx.fail(new FsError(cont.error));
    return ctx.pass(cont.value);
  });
  var readVerbatimFileContent = p2.new(["path"], "read verbatim file content", async (ctx) => {
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveFilepath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    const cont = await readFile3(res.filepath);
    if (!cont.ok)
      return ctx.fail(new FsError(cont.error));
    return ctx.pass(cont.value);
  });
  var storeInFile = p2.new(["content", "path"], "store in file", async (ctx) => {
    let content = ctx.fetch("content");
    if (typeof content === "object" || typeof content === "number")
      content = JSON.stringify(content);
    if (typeof content !== "string")
      return ctx.fail(new FsError("content must be string or object"));
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveFilepath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    try {
      await promises_exports.mkdir(path.dirname(res.filepath), { recursive: true });
      await promises_exports.writeFile(res.filepath, content);
    } catch (e2) {
      return ctx.fail(new FsError(e2.message));
    }
    return ctx.pass(null);
  });
  var listDirectoryContent = p2.new(["path"], "list directory content", async (ctx) => {
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveDirPath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    const filepaths = (await promises_exports.readdir(res.dirpath)).map((f) => path.join(res.dirpath, f));
    const stats = await Promise.all(filepaths.map((f) => promises_exports.stat(f)));
    const result = stats.map((stat3, i2) => {
      const filepath = filepaths[i2];
      return {
        name: filepath,
        mode: stat3.mode.toString(8),
        dev: stat3.dev,
        nlink: stat3.nlink,
        uid: stat3.uid,
        gid: stat3.gid,
        size: stat3.size,
        blksize: stat3.blksize,
        blocks: stat3.blocks,
        atime: stat3.atime.toISOString(),
        mtime: stat3.mtime.toISOString(),
        ctime: stat3.ctime.toISOString(),
        birthtime: stat3.birthtime.toISOString()
      };
    });
    return ctx.pass(result);
  });
  var verifyFileExists = p2.new(["path"], "verify file exists", async (ctx) => {
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveFilepath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    if (!await checkFileExists(res.filepath))
      return ctx.fail(new FsError("no such file or directory: " + res.filepath));
    return ctx.pass(null);
  });
  var verifyFileDoesNotExist = p2.new(["path"], "verify file does not exist", async (ctx) => {
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new FsError("path must be string"));
    const res = resolveFilepath(unsafe);
    if (!res.ok)
      return ctx.fail(new FsError(res.error));
    if (await checkFileExists(res.filepath))
      return ctx.fail(new FsError("file or directory found under: " + res.filepath));
    return ctx.pass(null);
  });
  var fs = p2;

  // ../git/build/esm/src/plugin.js
  var import_isomorphic_git = __toESM(require_isomorphic_git(), 1);

  // ../../node_modules/.pnpm/isomorphic-git@1.32.3/node_modules/isomorphic-git/http/web/index.js
  function fromValue(value) {
    let queue = [value];
    return {
      next() {
        return Promise.resolve({ done: queue.length === 0, value: queue.pop() });
      },
      return() {
        queue = [];
        return {};
      },
      [Symbol.asyncIterator]() {
        return this;
      }
    };
  }
  function getIterator(iterable) {
    if (iterable[Symbol.asyncIterator]) {
      return iterable[Symbol.asyncIterator]();
    }
    if (iterable[Symbol.iterator]) {
      return iterable[Symbol.iterator]();
    }
    if (iterable.next) {
      return iterable;
    }
    return fromValue(iterable);
  }
  async function forAwait(iterable, cb) {
    const iter = getIterator(iterable);
    while (true) {
      const { value, done } = await iter.next();
      if (value) await cb(value);
      if (done) break;
    }
    if (iter.return) iter.return();
  }
  async function collect(iterable) {
    let size = 0;
    const buffers = [];
    await forAwait(iterable, (value) => {
      buffers.push(value);
      size += value.byteLength;
    });
    const result = new Uint8Array(size);
    let nextIndex = 0;
    for (const buffer of buffers) {
      result.set(buffer, nextIndex);
      nextIndex += buffer.byteLength;
    }
    return result;
  }
  function fromStream(stream) {
    if (stream[Symbol.asyncIterator]) return stream;
    const reader = stream.getReader();
    return {
      next() {
        return reader.read();
      },
      return() {
        reader.releaseLock();
        return {};
      },
      [Symbol.asyncIterator]() {
        return this;
      }
    };
  }
  async function request2({
    onProgress,
    url,
    method = "GET",
    headers = {},
    body
  }) {
    if (body) {
      body = await collect(body);
    }
    const res = await fetch(url, { method, headers, body });
    const iter = res.body && res.body.getReader ? fromStream(res.body) : [new Uint8Array(await res.arrayBuffer())];
    headers = {};
    for (const [key, value] of res.headers.entries()) {
      headers[key] = value;
    }
    return {
      url: res.url,
      method: res.method,
      statusCode: res.status,
      statusMessage: res.statusText,
      body: iter,
      headers
    };
  }
  var index = { request: request2 };
  var web_default = index;

  // ../git/build/esm/src/plugin.js
  init_dist4();
  var import_path14 = __toESM(require_path_browserify(), 1);

  // ../git/package.json
  var package_default6 = {
    name: "@slangroom/git",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "isomorphic-git": "1.32.3"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || >=22.0.0 <22.3.0 || ^22.4.0 || ^23 || ^24"
    }
  };

  // ../git/build/esm/src/plugin.js
  var version7 = package_default6.version;
  var GitError = class extends Error {
    constructor(e2) {
      super(e2);
      this.name = "Slangroom @slangroom/git@" + package_default6.version + " Error";
    }
  };
  var sandboxDir2 = () => {
    if (typeof process === "undefined")
      return ".";
    return process.env["FILES_DIR"];
  };
  var sandboxizeDir = (unsafe) => {
    const normalized = import_path14.default.normalize(unsafe);
    const doesDirectoryTraversal = normalized.startsWith("/") || normalized.startsWith("..");
    if (doesDirectoryTraversal)
      return { ok: false, error: `dirpath is unsafe: ${unsafe}` };
    const sandboxdir = sandboxDir2();
    if (!sandboxdir)
      return { ok: false, error: "$FILES_DIR must be provided" };
    return { ok: true, dirpath: import_path14.default.join(sandboxdir, normalized) };
  };
  var sandboxizeFile = (sandboxdir, unsafe) => {
    const normalized = import_path14.default.normalize(unsafe);
    const doesDirectoryTraversal = normalized.startsWith("/") || normalized.startsWith("..");
    const DoesntProvideFile = normalized.startsWith(".");
    if (doesDirectoryTraversal || DoesntProvideFile)
      return { ok: false, error: `filepath is unsafe: ${unsafe}` };
    return { ok: true, filepath: import_path14.default.join(sandboxdir, normalized) };
  };
  var p3 = new Plugin();
  var verifyGitRepository = p3.new("open", "verify git repository", async (ctx) => {
    const unsafe = ctx.fetchOpen()[0];
    const res = sandboxizeDir(unsafe);
    if (!res.ok)
      return ctx.fail(new GitError(res.error));
    try {
      await import_isomorphic_git.default.findRoot({ fs: promises_exports, filepath: res.dirpath });
      return ctx.pass(null);
    } catch (e2) {
      return ctx.fail(new GitError(e2.message));
    }
  });
  var cloneRepository = p3.new("connect", ["path"], "clone repository", async (ctx) => {
    const repoUrl = ctx.fetchConnect()[0];
    const unsafe = ctx.fetch("path");
    if (typeof unsafe !== "string")
      return ctx.fail(new GitError("path must be string"));
    const res = sandboxizeDir(unsafe);
    if (!res.ok)
      return ctx.fail(new GitError(res.error));
    try {
      await import_isomorphic_git.default.clone({ fs: promises_exports, http: web_default, dir: res.dirpath, url: repoUrl });
      return ctx.pass(null);
    } catch (e2) {
      return ctx.fail(new GitError(e2.message));
    }
  });
  var createNewGitCommit = p3.new("open", ["commit"], "create new git commit", async (ctx) => {
    const unsafe = ctx.fetchOpen()[0];
    const res = sandboxizeDir(unsafe);
    if (!res.ok)
      return ctx.fail(new GitError(res.error));
    const commit = ctx.fetch("commit");
    try {
      commit.files.map((unsafe2) => {
        const r2 = sandboxizeFile(res.dirpath, unsafe2);
        if (!r2.ok)
          throw new Error(r2.error);
        return r2.filepath;
      });
      await Promise.all(commit.files.map((safe) => {
        return import_isomorphic_git.default.add({
          fs: promises_exports,
          dir: res.dirpath,
          filepath: safe
        });
      }));
      const hash2 = await import_isomorphic_git.default.commit({
        fs: promises_exports,
        dir: res.dirpath,
        message: commit.message,
        author: {
          name: commit.author,
          email: commit.email
        }
      });
      return ctx.pass(hash2);
    } catch (e2) {
      return ctx.fail(new GitError(e2.message));
    }
  });
  var git = p3;

  // ../helpers/build/esm/src/plugin.js
  var import_lodash = __toESM(require_lodash(), 1);

  // ../helpers/package.json
  var package_default7 = {
    name: "@slangroom/helpers",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*",
      "@types/lodash": "4.14.202",
      lodash: "4.17.21"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../helpers/build/esm/src/plugin.js
  var version8 = package_default7.version;
  var p4 = new Plugin();
  var HelperError = class extends Error {
    constructor(e2) {
      super(e2.message);
      this.name = "Slangroom @slangroom/helper@" + package_default7.version + " Error";
    }
  };
  var get3 = p4.new(["object", "path"], "manipulate and get", async (ctx) => {
    const object = ctx.fetch("object");
    const path3 = ctx.fetch("path");
    try {
      return ctx.pass(import_lodash.default.get(object, path3));
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var set3 = p4.new(["object", "path", "value"], "manipulate and set", async (ctx) => {
    const object = ctx.fetch("object");
    const path3 = ctx.fetch("path");
    const value = ctx.fetch("value");
    try {
      return ctx.pass(import_lodash.default.set(object, path3, value));
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var merge = p4.new(["object", "sources"], "manipulate and merge", async (ctx) => {
    const object = ctx.fetch("object");
    const sources = ctx.fetch("sources");
    try {
      return ctx.pass(import_lodash.default.merge(object, ...sources));
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var omit2 = p4.new(["object", "paths"], "manipulate and omit", async (ctx) => {
    const object = ctx.fetch("object");
    const paths = ctx.fetch("paths");
    try {
      return ctx.pass(import_lodash.default.omit(object, paths));
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var concat = p4.new(["array", "values"], "manipulate and concat", async (ctx) => {
    const array = ctx.fetch("array");
    const values = ctx.fetch("values");
    try {
      return ctx.pass(import_lodash.default.concat(array, ...values));
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var compact = p4.new(["array"], "manipulate and compact", async (ctx) => {
    const array = ctx.fetch("array");
    try {
      return ctx.pass(import_lodash.default.compact(array));
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var pick2 = p4.new(["object", "properties"], "manipulate and pick", async (ctx) => {
    const properties = ctx.fetch("properties");
    const obj = ctx.fetch("object");
    try {
      const manipulated = import_lodash.default.pick(obj, properties);
      if (Object.keys(manipulated).length === 0) {
        return ctx.fail(new HelperError(new Error(`MANIPULATION ERRROR:
None of the properties

 ${JSON.stringify(properties)}

 exist in the object:

 ${JSON.stringify(obj, null, 3)}`)));
      }
      return ctx.pass(manipulated);
    } catch (e2) {
      return ctx.fail(new HelperError(e2));
    }
  });
  var del = p4.new("manipulate and delete", async (ctx) => {
    return ctx.pass(null);
  });
  var helpers = p4;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/bind.js
  function bind(fn, thisArg) {
    return function wrap2() {
      return fn.apply(thisArg, arguments);
    };
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/utils.js
  var { toString } = Object.prototype;
  var { getPrototypeOf } = Object;
  var kindOf = /* @__PURE__ */ ((cache2) => (thing) => {
    const str = toString.call(thing);
    return cache2[str] || (cache2[str] = str.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null));
  var kindOfTest = (type) => {
    type = type.toLowerCase();
    return (thing) => kindOf(thing) === type;
  };
  var typeOfTest = (type) => (thing) => typeof thing === type;
  var { isArray } = Array;
  var isUndefined = typeOfTest("undefined");
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
  }
  var isArrayBuffer = kindOfTest("ArrayBuffer");
  function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
      result = ArrayBuffer.isView(val);
    } else {
      result = val && val.buffer && isArrayBuffer(val.buffer);
    }
    return result;
  }
  var isString2 = typeOfTest("string");
  var isFunction = typeOfTest("function");
  var isNumber2 = typeOfTest("number");
  var isObject2 = (thing) => thing !== null && typeof thing === "object";
  var isBoolean2 = (thing) => thing === true || thing === false;
  var isPlainObject2 = (val) => {
    if (kindOf(val) !== "object") {
      return false;
    }
    const prototype3 = getPrototypeOf(val);
    return (prototype3 === null || prototype3 === Object.prototype || Object.getPrototypeOf(prototype3) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
  };
  var isDate = kindOfTest("Date");
  var isFile2 = kindOfTest("File");
  var isBlob = kindOfTest("Blob");
  var isFileList = kindOfTest("FileList");
  var isStream = (val) => isObject2(val) && isFunction(val.pipe);
  var isFormData = (thing) => {
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
  };
  var isURLSearchParams = kindOfTest("URLSearchParams");
  var trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function forEach(obj, fn, { allOwnKeys = false } = {}) {
    if (obj === null || typeof obj === "undefined") {
      return;
    }
    let i2;
    let l;
    if (typeof obj !== "object") {
      obj = [obj];
    }
    if (isArray(obj)) {
      for (i2 = 0, l = obj.length; i2 < l; i2++) {
        fn.call(null, obj[i2], i2, obj);
      }
    } else {
      const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
      const len = keys.length;
      let key;
      for (i2 = 0; i2 < len; i2++) {
        key = keys[i2];
        fn.call(null, obj[key], key, obj);
      }
    }
  }
  function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i2 = keys.length;
    let _key;
    while (i2-- > 0) {
      _key = keys[i2];
      if (key === _key.toLowerCase()) {
        return _key;
      }
    }
    return null;
  }
  var _global = (() => {
    if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
  })();
  var isContextDefined = (context) => !isUndefined(context) && context !== _global;
  function merge2() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key) => {
      const targetKey = caseless && findKey(result, key) || key;
      if (isPlainObject2(result[targetKey]) && isPlainObject2(val)) {
        result[targetKey] = merge2(result[targetKey], val);
      } else if (isPlainObject2(val)) {
        result[targetKey] = merge2({}, val);
      } else if (isArray(val)) {
        result[targetKey] = val.slice();
      } else {
        result[targetKey] = val;
      }
    };
    for (let i2 = 0, l = arguments.length; i2 < l; i2++) {
      arguments[i2] && forEach(arguments[i2], assignValue);
    }
    return result;
  }
  var extend = (a, b, thisArg, { allOwnKeys } = {}) => {
    forEach(b, (val, key) => {
      if (thisArg && isFunction(val)) {
        a[key] = bind(val, thisArg);
      } else {
        a[key] = val;
      }
    }, { allOwnKeys });
    return a;
  };
  var stripBOM = (content) => {
    if (content.charCodeAt(0) === 65279) {
      content = content.slice(1);
    }
    return content;
  };
  var inherits = (constructor, superConstructor, props, descriptors2) => {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
      value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
  };
  var toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
    let props;
    let i2;
    let prop;
    const merged = {};
    destObj = destObj || {};
    if (sourceObj == null) return destObj;
    do {
      props = Object.getOwnPropertyNames(sourceObj);
      i2 = props.length;
      while (i2-- > 0) {
        prop = props[i2];
        if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
          destObj[prop] = sourceObj[prop];
          merged[prop] = true;
        }
      }
      sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
    } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
  };
  var endsWith = (str, searchString, position) => {
    str = String(str);
    if (position === void 0 || position > str.length) {
      position = str.length;
    }
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
  var toArray = (thing) => {
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i2 = thing.length;
    if (!isNumber2(i2)) return null;
    const arr = new Array(i2);
    while (i2-- > 0) {
      arr[i2] = thing[i2];
    }
    return arr;
  };
  var isTypedArray = /* @__PURE__ */ ((TypedArray2) => {
    return (thing) => {
      return TypedArray2 && thing instanceof TypedArray2;
    };
  })(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
  var forEachEntry = (obj, fn) => {
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while ((result = iterator.next()) && !result.done) {
      const pair = result.value;
      fn.call(obj, pair[0], pair[1]);
    }
  };
  var matchAll = (regExp, str) => {
    let matches;
    const arr = [];
    while ((matches = regExp.exec(str)) !== null) {
      arr.push(matches);
    }
    return arr;
  };
  var isHTMLForm = kindOfTest("HTMLFormElement");
  var toCamelCase = (str) => {
    return str.toLowerCase().replace(
      /[-_\s]([a-z\d])(\w*)/g,
      function replacer(m, p1, p22) {
        return p1.toUpperCase() + p22;
      }
    );
  };
  var hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
  var isRegExp = kindOfTest("RegExp");
  var reduceDescriptors = (obj, reducer) => {
    const descriptors2 = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors2, (descriptor, name2) => {
      let ret;
      if ((ret = reducer(descriptor, name2, obj)) !== false) {
        reducedDescriptors[name2] = ret || descriptor;
      }
    });
    Object.defineProperties(obj, reducedDescriptors);
  };
  var freezeMethods = (obj) => {
    reduceDescriptors(obj, (descriptor, name2) => {
      if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name2) !== -1) {
        return false;
      }
      const value = obj[name2];
      if (!isFunction(value)) return;
      descriptor.enumerable = false;
      if ("writable" in descriptor) {
        descriptor.writable = false;
        return;
      }
      if (!descriptor.set) {
        descriptor.set = () => {
          throw Error("Can not rewrite read-only method '" + name2 + "'");
        };
      }
    });
  };
  var toObjectSet = (arrayOrString, delimiter) => {
    const obj = {};
    const define2 = (arr) => {
      arr.forEach((value) => {
        obj[value] = true;
      });
    };
    isArray(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter));
    return obj;
  };
  var noop = () => {
  };
  var toFiniteNumber = (value, defaultValue) => {
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
  };
  var ALPHA = "abcdefghijklmnopqrstuvwxyz";
  var DIGIT = "0123456789";
  var ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
  };
  var generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
    let str = "";
    const { length: length2 } = alphabet;
    while (size--) {
      str += alphabet[Math.random() * length2 | 0];
    }
    return str;
  };
  function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
  }
  var toJSONObject = (obj) => {
    const stack = new Array(10);
    const visit2 = (source, i2) => {
      if (isObject2(source)) {
        if (stack.indexOf(source) >= 0) {
          return;
        }
        if (!("toJSON" in source)) {
          stack[i2] = source;
          const target = isArray(source) ? [] : {};
          forEach(source, (value, key) => {
            const reducedValue = visit2(value, i2 + 1);
            !isUndefined(reducedValue) && (target[key] = reducedValue);
          });
          stack[i2] = void 0;
          return target;
        }
      }
      return source;
    };
    return visit2(obj, 0);
  };
  var isAsyncFn = kindOfTest("AsyncFunction");
  var isThenable = (thing) => thing && (isObject2(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
  var utils_default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString: isString2,
    isNumber: isNumber2,
    isBoolean: isBoolean2,
    isObject: isObject2,
    isPlainObject: isPlainObject2,
    isUndefined,
    isDate,
    isFile: isFile2,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge: merge2,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    // an alias to avoid ESLint no-prototype-builtins detection
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/AxiosError.js
  function AxiosError(message, code, config, request4, response) {
    Error.call(this);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error().stack;
    }
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request4 && (this.request = request4);
    response && (this.response = response);
  }
  utils_default.inherits(AxiosError, Error, {
    toJSON: function toJSON() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: utils_default.toJSONObject(this.config),
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    }
  });
  var prototype = AxiosError.prototype;
  var descriptors = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
    // eslint-disable-next-line func-names
  ].forEach((code) => {
    descriptors[code] = { value: code };
  });
  Object.defineProperties(AxiosError, descriptors);
  Object.defineProperty(prototype, "isAxiosError", { value: true });
  AxiosError.from = (error, code, config, request4, response, customProps) => {
    const axiosError = Object.create(prototype);
    utils_default.toFlatObject(error, axiosError, function filter2(obj) {
      return obj !== Error.prototype;
    }, (prop) => {
      return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request4, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
  };
  var AxiosError_default = AxiosError;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/null.js
  var null_default = null;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/toFormData.js
  function isVisitable(thing) {
    return utils_default.isPlainObject(thing) || utils_default.isArray(thing);
  }
  function removeBrackets(key) {
    return utils_default.endsWith(key, "[]") ? key.slice(0, -2) : key;
  }
  function renderKey(path3, key, dots) {
    if (!path3) return key;
    return path3.concat(key).map(function each(token, i2) {
      token = removeBrackets(token);
      return !dots && i2 ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
  }
  function isFlatArray(arr) {
    return utils_default.isArray(arr) && !arr.some(isVisitable);
  }
  var predicates = utils_default.toFlatObject(utils_default, {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
  });
  function toFormData(obj, formData, options) {
    if (!utils_default.isObject(obj)) {
      throw new TypeError("target must be an object");
    }
    formData = formData || new (null_default || FormData)();
    options = utils_default.toFlatObject(options, {
      metaTokens: true,
      dots: false,
      indexes: false
    }, false, function defined(option, source) {
      return !utils_default.isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && utils_default.isSpecCompliantForm(formData);
    if (!utils_default.isFunction(visitor)) {
      throw new TypeError("visitor must be a function");
    }
    function convertValue(value) {
      if (value === null) return "";
      if (utils_default.isDate(value)) {
        return value.toISOString();
      }
      if (!useBlob && utils_default.isBlob(value)) {
        throw new AxiosError_default("Blob is not supported. Use a Buffer instead.");
      }
      if (utils_default.isArrayBuffer(value) || utils_default.isTypedArray(value)) {
        return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
      }
      return value;
    }
    function defaultVisitor(value, key, path3) {
      let arr = value;
      if (value && !path3 && typeof value === "object") {
        if (utils_default.endsWith(key, "{}")) {
          key = metaTokens ? key : key.slice(0, -2);
          value = JSON.stringify(value);
        } else if (utils_default.isArray(value) && isFlatArray(value) || (utils_default.isFileList(value) || utils_default.endsWith(key, "[]")) && (arr = utils_default.toArray(value))) {
          key = removeBrackets(key);
          arr.forEach(function each(el, index2) {
            !(utils_default.isUndefined(el) || el === null) && formData.append(
              // eslint-disable-next-line no-nested-ternary
              indexes === true ? renderKey([key], index2, dots) : indexes === null ? key : key + "[]",
              convertValue(el)
            );
          });
          return false;
        }
      }
      if (isVisitable(value)) {
        return true;
      }
      formData.append(renderKey(path3, key, dots), convertValue(value));
      return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
      defaultVisitor,
      convertValue,
      isVisitable
    });
    function build(value, path3) {
      if (utils_default.isUndefined(value)) return;
      if (stack.indexOf(value) !== -1) {
        throw Error("Circular reference detected in " + path3.join("."));
      }
      stack.push(value);
      utils_default.forEach(value, function each(el, key) {
        const result = !(utils_default.isUndefined(el) || el === null) && visitor.call(
          formData,
          el,
          utils_default.isString(key) ? key.trim() : key,
          path3,
          exposedHelpers
        );
        if (result === true) {
          build(el, path3 ? path3.concat(key) : [key]);
        }
      });
      stack.pop();
    }
    if (!utils_default.isObject(obj)) {
      throw new TypeError("data must be an object");
    }
    build(obj);
    return formData;
  }
  var toFormData_default = toFormData;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/AxiosURLSearchParams.js
  function encode(str) {
    const charMap = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
      return charMap[match];
    });
  }
  function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && toFormData_default(params, this, options);
  }
  var prototype2 = AxiosURLSearchParams.prototype;
  prototype2.append = function append(name2, value) {
    this._pairs.push([name2, value]);
  };
  prototype2.toString = function toString2(encoder2) {
    const _encode = encoder2 ? function(value) {
      return encoder2.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
      return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
  };
  var AxiosURLSearchParams_default = AxiosURLSearchParams;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/buildURL.js
  function encode2(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  function buildURL(url, params, options) {
    if (!params) {
      return url;
    }
    const _encode = options && options.encode || encode2;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) {
      serializedParams = serializeFn(params, options);
    } else {
      serializedParams = utils_default.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams_default(params, options).toString(_encode);
    }
    if (serializedParams) {
      const hashmarkIndex = url.indexOf("#");
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }
      url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/InterceptorManager.js
  var InterceptorManager = class {
    constructor() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */
    use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
    eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
    clear() {
      if (this.handlers) {
        this.handlers = [];
      }
    }
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */
    forEach(fn) {
      utils_default.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    }
  };
  var InterceptorManager_default = InterceptorManager;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/defaults/transitional.js
  var transitional_default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/platform/browser/classes/URLSearchParams.js
  var URLSearchParams_default = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams_default;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/platform/browser/classes/FormData.js
  var FormData_default = typeof FormData !== "undefined" ? FormData : null;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/platform/browser/classes/Blob.js
  var Blob_default = typeof Blob !== "undefined" ? Blob : null;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/platform/browser/index.js
  var browser_default3 = {
    isBrowser: true,
    classes: {
      URLSearchParams: URLSearchParams_default,
      FormData: FormData_default,
      Blob: Blob_default
    },
    protocols: ["http", "https", "file", "blob", "url", "data"]
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/platform/common/utils.js
  var utils_exports4 = {};
  __export(utils_exports4, {
    hasBrowserEnv: () => hasBrowserEnv,
    hasStandardBrowserEnv: () => hasStandardBrowserEnv,
    hasStandardBrowserWebWorkerEnv: () => hasStandardBrowserWebWorkerEnv
  });
  var hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
  var hasStandardBrowserEnv = ((product) => {
    return hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(product) < 0;
  })(typeof navigator !== "undefined" && navigator.product);
  var hasStandardBrowserWebWorkerEnv = (() => {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
  })();

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/platform/index.js
  var platform_default = {
    ...utils_exports4,
    ...browser_default3
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/toURLEncodedForm.js
  function toURLEncodedForm(data, options) {
    return toFormData_default(data, new platform_default.classes.URLSearchParams(), Object.assign({
      visitor: function(value, key, path3, helpers2) {
        if (platform_default.isNode && utils_default.isBuffer(value)) {
          this.append(key, value.toString("base64"));
          return false;
        }
        return helpers2.defaultVisitor.apply(this, arguments);
      }
    }, options));
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/formDataToJSON.js
  function parsePropPath(name2) {
    return utils_default.matchAll(/\w+|\[(\w*)]/g, name2).map((match) => {
      return match[0] === "[]" ? "" : match[1] || match[0];
    });
  }
  function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i2;
    const len = keys.length;
    let key;
    for (i2 = 0; i2 < len; i2++) {
      key = keys[i2];
      obj[key] = arr[key];
    }
    return obj;
  }
  function formDataToJSON(formData) {
    function buildPath(path3, value, target, index2) {
      let name2 = path3[index2++];
      const isNumericKey = Number.isFinite(+name2);
      const isLast = index2 >= path3.length;
      name2 = !name2 && utils_default.isArray(target) ? target.length : name2;
      if (isLast) {
        if (utils_default.hasOwnProp(target, name2)) {
          target[name2] = [target[name2], value];
        } else {
          target[name2] = value;
        }
        return !isNumericKey;
      }
      if (!target[name2] || !utils_default.isObject(target[name2])) {
        target[name2] = [];
      }
      const result = buildPath(path3, value, target[name2], index2);
      if (result && utils_default.isArray(target[name2])) {
        target[name2] = arrayToObject(target[name2]);
      }
      return !isNumericKey;
    }
    if (utils_default.isFormData(formData) && utils_default.isFunction(formData.entries)) {
      const obj = {};
      utils_default.forEachEntry(formData, (name2, value) => {
        buildPath(parsePropPath(name2), value, obj, 0);
      });
      return obj;
    }
    return null;
  }
  var formDataToJSON_default = formDataToJSON;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/defaults/index.js
  function stringifySafely(rawValue, parser, encoder2) {
    if (utils_default.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils_default.trim(rawValue);
      } catch (e2) {
        if (e2.name !== "SyntaxError") {
          throw e2;
        }
      }
    }
    return (encoder2 || JSON.stringify)(rawValue);
  }
  var defaults = {
    transitional: transitional_default,
    adapter: ["xhr", "http"],
    transformRequest: [function transformRequest(data, headers) {
      const contentType = headers.getContentType() || "";
      const hasJSONContentType = contentType.indexOf("application/json") > -1;
      const isObjectPayload = utils_default.isObject(data);
      if (isObjectPayload && utils_default.isHTMLForm(data)) {
        data = new FormData(data);
      }
      const isFormData3 = utils_default.isFormData(data);
      if (isFormData3) {
        if (!hasJSONContentType) {
          return data;
        }
        return hasJSONContentType ? JSON.stringify(formDataToJSON_default(data)) : data;
      }
      if (utils_default.isArrayBuffer(data) || utils_default.isBuffer(data) || utils_default.isStream(data) || utils_default.isFile(data) || utils_default.isBlob(data)) {
        return data;
      }
      if (utils_default.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils_default.isURLSearchParams(data)) {
        headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
        return data.toString();
      }
      let isFileList2;
      if (isObjectPayload) {
        if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
          return toURLEncodedForm(data, this.formSerializer).toString();
        }
        if ((isFileList2 = utils_default.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
          const _FormData = this.env && this.env.FormData;
          return toFormData_default(
            isFileList2 ? { "files[]": data } : data,
            _FormData && new _FormData(),
            this.formSerializer
          );
        }
      }
      if (isObjectPayload || hasJSONContentType) {
        headers.setContentType("application/json", false);
        return stringifySafely(data);
      }
      return data;
    }],
    transformResponse: [function transformResponse(data) {
      const transitional2 = this.transitional || defaults.transitional;
      const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
      const JSONRequested = this.responseType === "json";
      if (data && utils_default.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
        const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
        const strictJSONParsing = !silentJSONParsing && JSONRequested;
        try {
          return JSON.parse(data);
        } catch (e2) {
          if (strictJSONParsing) {
            if (e2.name === "SyntaxError") {
              throw AxiosError_default.from(e2, AxiosError_default.ERR_BAD_RESPONSE, this, null, this.response);
            }
            throw e2;
          }
        }
      }
      return data;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
      FormData: platform_default.classes.FormData,
      Blob: platform_default.classes.Blob
    },
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": void 0
      }
    }
  };
  utils_default.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
    defaults.headers[method] = {};
  });
  var defaults_default = defaults;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/parseHeaders.js
  var ignoreDuplicateOf = utils_default.toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ]);
  var parseHeaders_default = (rawHeaders) => {
    const parsed = {};
    let key;
    let val;
    let i2;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
      i2 = line.indexOf(":");
      key = line.substring(0, i2).trim().toLowerCase();
      val = line.substring(i2 + 1).trim();
      if (!key || parsed[key] && ignoreDuplicateOf[key]) {
        return;
      }
      if (key === "set-cookie") {
        if (parsed[key]) {
          parsed[key].push(val);
        } else {
          parsed[key] = [val];
        }
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    });
    return parsed;
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/AxiosHeaders.js
  var $internals = Symbol("internals");
  function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
  }
  function normalizeValue(value) {
    if (value === false || value == null) {
      return value;
    }
    return utils_default.isArray(value) ? value.map(normalizeValue) : String(value);
  }
  function parseTokens(str) {
    const tokens = /* @__PURE__ */ Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while (match = tokensRE.exec(str)) {
      tokens[match[1]] = match[2];
    }
    return tokens;
  }
  var isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
  function matchHeaderValue(context, value, header, filter2, isHeaderNameFilter) {
    if (utils_default.isFunction(filter2)) {
      return filter2.call(this, value, header);
    }
    if (isHeaderNameFilter) {
      value = header;
    }
    if (!utils_default.isString(value)) return;
    if (utils_default.isString(filter2)) {
      return value.indexOf(filter2) !== -1;
    }
    if (utils_default.isRegExp(filter2)) {
      return filter2.test(value);
    }
  }
  function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
  }
  function buildAccessors(obj, header) {
    const accessorName = utils_default.toCamelCase(" " + header);
    ["get", "set", "has"].forEach((methodName) => {
      Object.defineProperty(obj, methodName + accessorName, {
        value: function(arg1, arg2, arg3) {
          return this[methodName].call(this, header, arg1, arg2, arg3);
        },
        configurable: true
      });
    });
  }
  var AxiosHeaders = class {
    constructor(headers) {
      headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
      const self2 = this;
      function setHeader(_value, _header, _rewrite) {
        const lHeader = normalizeHeader(_header);
        if (!lHeader) {
          throw new Error("header name must be a non-empty string");
        }
        const key = utils_default.findKey(self2, lHeader);
        if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
          self2[key || _header] = normalizeValue(_value);
        }
      }
      const setHeaders = (headers, _rewrite) => utils_default.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
      if (utils_default.isPlainObject(header) || header instanceof this.constructor) {
        setHeaders(header, valueOrRewrite);
      } else if (utils_default.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
        setHeaders(parseHeaders_default(header), valueOrRewrite);
      } else {
        header != null && setHeader(valueOrRewrite, header, rewrite);
      }
      return this;
    }
    get(header, parser) {
      header = normalizeHeader(header);
      if (header) {
        const key = utils_default.findKey(this, header);
        if (key) {
          const value = this[key];
          if (!parser) {
            return value;
          }
          if (parser === true) {
            return parseTokens(value);
          }
          if (utils_default.isFunction(parser)) {
            return parser.call(this, value, key);
          }
          if (utils_default.isRegExp(parser)) {
            return parser.exec(value);
          }
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(header, matcher) {
      header = normalizeHeader(header);
      if (header) {
        const key = utils_default.findKey(this, header);
        return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
      }
      return false;
    }
    delete(header, matcher) {
      const self2 = this;
      let deleted = false;
      function deleteHeader(_header) {
        _header = normalizeHeader(_header);
        if (_header) {
          const key = utils_default.findKey(self2, _header);
          if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
            delete self2[key];
            deleted = true;
          }
        }
      }
      if (utils_default.isArray(header)) {
        header.forEach(deleteHeader);
      } else {
        deleteHeader(header);
      }
      return deleted;
    }
    clear(matcher) {
      const keys = Object.keys(this);
      let i2 = keys.length;
      let deleted = false;
      while (i2--) {
        const key = keys[i2];
        if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
          delete this[key];
          deleted = true;
        }
      }
      return deleted;
    }
    normalize(format5) {
      const self2 = this;
      const headers = {};
      utils_default.forEach(this, (value, header) => {
        const key = utils_default.findKey(headers, header);
        if (key) {
          self2[key] = normalizeValue(value);
          delete self2[header];
          return;
        }
        const normalized = format5 ? formatHeader(header) : String(header).trim();
        if (normalized !== header) {
          delete self2[header];
        }
        self2[normalized] = normalizeValue(value);
        headers[normalized] = true;
      });
      return this;
    }
    concat(...targets) {
      return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
      const obj = /* @__PURE__ */ Object.create(null);
      utils_default.forEach(this, (value, header) => {
        value != null && value !== false && (obj[header] = asStrings && utils_default.isArray(value) ? value.join(", ") : value);
      });
      return obj;
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(thing) {
      return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
      const computed = new this(first);
      targets.forEach((target) => computed.set(target));
      return computed;
    }
    static accessor(header) {
      const internals = this[$internals] = this[$internals] = {
        accessors: {}
      };
      const accessors = internals.accessors;
      const prototype3 = this.prototype;
      function defineAccessor(_header) {
        const lHeader = normalizeHeader(_header);
        if (!accessors[lHeader]) {
          buildAccessors(prototype3, _header);
          accessors[lHeader] = true;
        }
      }
      utils_default.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
      return this;
    }
  };
  AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
  utils_default.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
    let mapped = key[0].toUpperCase() + key.slice(1);
    return {
      get: () => value,
      set(headerValue) {
        this[mapped] = headerValue;
      }
    };
  });
  utils_default.freezeMethods(AxiosHeaders);
  var AxiosHeaders_default = AxiosHeaders;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/transformData.js
  function transformData(fns, response) {
    const config = this || defaults_default;
    const context = response || config;
    const headers = AxiosHeaders_default.from(context.headers);
    let data = context.data;
    utils_default.forEach(fns, function transform(fn) {
      data = fn.call(config, data, headers.normalize(), response ? response.status : void 0);
    });
    headers.normalize();
    return data;
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/cancel/isCancel.js
  function isCancel(value) {
    return !!(value && value.__CANCEL__);
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/cancel/CanceledError.js
  function CanceledError(message, config, request4) {
    AxiosError_default.call(this, message == null ? "canceled" : message, AxiosError_default.ERR_CANCELED, config, request4);
    this.name = "CanceledError";
  }
  utils_default.inherits(CanceledError, AxiosError_default, {
    __CANCEL__: true
  });
  var CanceledError_default = CanceledError;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/settle.js
  function settle(resolve2, reject, response) {
    const validateStatus2 = response.config.validateStatus;
    if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
      resolve2(response);
    } else {
      reject(new AxiosError_default(
        "Request failed with status code " + response.status,
        [AxiosError_default.ERR_BAD_REQUEST, AxiosError_default.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
        response.config,
        response.request,
        response
      ));
    }
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/cookies.js
  var cookies_default = platform_default.hasStandardBrowserEnv ? (
    // Standard browser envs support document.cookie
    {
      write(name2, value, expires, path3, domain, secure) {
        const cookie = [name2 + "=" + encodeURIComponent(value)];
        utils_default.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        utils_default.isString(path3) && cookie.push("path=" + path3);
        utils_default.isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
      },
      read(name2) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
      },
      remove(name2) {
        this.write(name2, "", Date.now() - 864e5);
      }
    }
  ) : (
    // Non-standard browser env (web workers, react-native) lack needed support.
    {
      write() {
      },
      read() {
        return null;
      },
      remove() {
      }
    }
  );

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/isAbsoluteURL.js
  function isAbsoluteURL(url) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/combineURLs.js
  function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/buildFullPath.js
  function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) {
      return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/isURLSameOrigin.js
  var isURLSameOrigin_default = platform_default.hasStandardBrowserEnv ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
      const msie = /(msie|trident)/i.test(navigator.userAgent);
      const urlParsingNode = document.createElement("a");
      let originURL;
      function resolveURL(url) {
        let href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin(requestURL) {
        const parsed = utils_default.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }()
  );

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/parseProtocol.js
  function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/speedometer.js
  function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes2 = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== void 0 ? min : 1e3;
    return function push(chunkLength) {
      const now = Date.now();
      const startedAt = timestamps[tail];
      if (!firstSampleTS) {
        firstSampleTS = now;
      }
      bytes2[head] = chunkLength;
      timestamps[head] = now;
      let i2 = tail;
      let bytesCount = 0;
      while (i2 !== head) {
        bytesCount += bytes2[i2++];
        i2 = i2 % samplesCount;
      }
      head = (head + 1) % samplesCount;
      if (head === tail) {
        tail = (tail + 1) % samplesCount;
      }
      if (now - firstSampleTS < min) {
        return;
      }
      const passed = startedAt && now - startedAt;
      return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
    };
  }
  var speedometer_default = speedometer;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/adapters/xhr.js
  function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = speedometer_default(50, 250);
    return (e2) => {
      const loaded = e2.loaded;
      const total = e2.lengthComputable ? e2.total : void 0;
      const progressBytes = loaded - bytesNotified;
      const rate = _speedometer(progressBytes);
      const inRange = loaded <= total;
      bytesNotified = loaded;
      const data = {
        loaded,
        total,
        progress: total ? loaded / total : void 0,
        bytes: progressBytes,
        rate: rate ? rate : void 0,
        estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
        event: e2
      };
      data[isDownloadStream ? "download" : "upload"] = true;
      listener(data);
    };
  }
  var isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
  var xhr_default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve2, reject) {
      let requestData = config.data;
      const requestHeaders = AxiosHeaders_default.from(config.headers).normalize();
      let { responseType, withXSRFToken } = config;
      let onCanceled;
      function done() {
        if (config.cancelToken) {
          config.cancelToken.unsubscribe(onCanceled);
        }
        if (config.signal) {
          config.signal.removeEventListener("abort", onCanceled);
        }
      }
      let contentType;
      if (utils_default.isFormData(requestData)) {
        if (platform_default.hasStandardBrowserEnv || platform_default.hasStandardBrowserWebWorkerEnv) {
          requestHeaders.setContentType(false);
        } else if ((contentType = requestHeaders.getContentType()) !== false) {
          const [type, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
          requestHeaders.setContentType([type || "multipart/form-data", ...tokens].join("; "));
        }
      }
      let request4 = new XMLHttpRequest();
      if (config.auth) {
        const username = config.auth.username || "";
        const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
        requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
      }
      const fullPath = buildFullPath(config.baseURL, config.url);
      request4.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
      request4.timeout = config.timeout;
      function onloadend() {
        if (!request4) {
          return;
        }
        const responseHeaders = AxiosHeaders_default.from(
          "getAllResponseHeaders" in request4 && request4.getAllResponseHeaders()
        );
        const responseData = !responseType || responseType === "text" || responseType === "json" ? request4.responseText : request4.response;
        const response = {
          data: responseData,
          status: request4.status,
          statusText: request4.statusText,
          headers: responseHeaders,
          config,
          request: request4
        };
        settle(function _resolve2(value) {
          resolve2(value);
          done();
        }, function _reject(err3) {
          reject(err3);
          done();
        }, response);
        request4 = null;
      }
      if ("onloadend" in request4) {
        request4.onloadend = onloadend;
      } else {
        request4.onreadystatechange = function handleLoad() {
          if (!request4 || request4.readyState !== 4) {
            return;
          }
          if (request4.status === 0 && !(request4.responseURL && request4.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request4.onabort = function handleAbort() {
        if (!request4) {
          return;
        }
        reject(new AxiosError_default("Request aborted", AxiosError_default.ECONNABORTED, config, request4));
        request4 = null;
      };
      request4.onerror = function handleError() {
        reject(new AxiosError_default("Network Error", AxiosError_default.ERR_NETWORK, config, request4));
        request4 = null;
      };
      request4.ontimeout = function handleTimeout() {
        let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
        const transitional2 = config.transitional || transitional_default;
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        }
        reject(new AxiosError_default(
          timeoutErrorMessage,
          transitional2.clarifyTimeoutError ? AxiosError_default.ETIMEDOUT : AxiosError_default.ECONNABORTED,
          config,
          request4
        ));
        request4 = null;
      };
      if (platform_default.hasStandardBrowserEnv) {
        withXSRFToken && utils_default.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
        if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin_default(fullPath)) {
          const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies_default.read(config.xsrfCookieName);
          if (xsrfValue) {
            requestHeaders.set(config.xsrfHeaderName, xsrfValue);
          }
        }
      }
      requestData === void 0 && requestHeaders.setContentType(null);
      if ("setRequestHeader" in request4) {
        utils_default.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
          request4.setRequestHeader(key, val);
        });
      }
      if (!utils_default.isUndefined(config.withCredentials)) {
        request4.withCredentials = !!config.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request4.responseType = config.responseType;
      }
      if (typeof config.onDownloadProgress === "function") {
        request4.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
      }
      if (typeof config.onUploadProgress === "function" && request4.upload) {
        request4.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
      }
      if (config.cancelToken || config.signal) {
        onCanceled = (cancel) => {
          if (!request4) {
            return;
          }
          reject(!cancel || cancel.type ? new CanceledError_default(null, config, request4) : cancel);
          request4.abort();
          request4 = null;
        };
        config.cancelToken && config.cancelToken.subscribe(onCanceled);
        if (config.signal) {
          config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
      }
      const protocol = parseProtocol(fullPath);
      if (protocol && platform_default.protocols.indexOf(protocol) === -1) {
        reject(new AxiosError_default("Unsupported protocol " + protocol + ":", AxiosError_default.ERR_BAD_REQUEST, config));
        return;
      }
      request4.send(requestData || null);
    });
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/adapters/adapters.js
  var knownAdapters = {
    http: null_default,
    xhr: xhr_default
  };
  utils_default.forEach(knownAdapters, (fn, value) => {
    if (fn) {
      try {
        Object.defineProperty(fn, "name", { value });
      } catch (e2) {
      }
      Object.defineProperty(fn, "adapterName", { value });
    }
  });
  var renderReason = (reason) => `- ${reason}`;
  var isResolvedHandle = (adapter) => utils_default.isFunction(adapter) || adapter === null || adapter === false;
  var adapters_default = {
    getAdapter: (adapters) => {
      adapters = utils_default.isArray(adapters) ? adapters : [adapters];
      const { length: length2 } = adapters;
      let nameOrAdapter;
      let adapter;
      const rejectedReasons = {};
      for (let i2 = 0; i2 < length2; i2++) {
        nameOrAdapter = adapters[i2];
        let id;
        adapter = nameOrAdapter;
        if (!isResolvedHandle(nameOrAdapter)) {
          adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
          if (adapter === void 0) {
            throw new AxiosError_default(`Unknown adapter '${id}'`);
          }
        }
        if (adapter) {
          break;
        }
        rejectedReasons[id || "#" + i2] = adapter;
      }
      if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(
          ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
        );
        let s2 = length2 ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
        throw new AxiosError_default(
          `There is no suitable adapter to dispatch the request ` + s2,
          "ERR_NOT_SUPPORT"
        );
      }
      return adapter;
    },
    adapters: knownAdapters
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/dispatchRequest.js
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }
    if (config.signal && config.signal.aborted) {
      throw new CanceledError_default(null, config);
    }
  }
  function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = AxiosHeaders_default.from(config.headers);
    config.data = transformData.call(
      config,
      config.transformRequest
    );
    if (["post", "put", "patch"].indexOf(config.method) !== -1) {
      config.headers.setContentType("application/x-www-form-urlencoded", false);
    }
    const adapter = adapters_default.getAdapter(config.adapter || defaults_default.adapter);
    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);
      response.data = transformData.call(
        config,
        config.transformResponse,
        response
      );
      response.headers = AxiosHeaders_default.from(response.headers);
      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);
        if (reason && reason.response) {
          reason.response.data = transformData.call(
            config,
            config.transformResponse,
            reason.response
          );
          reason.response.headers = AxiosHeaders_default.from(reason.response.headers);
        }
      }
      return Promise.reject(reason);
    });
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/mergeConfig.js
  var headersToObject = (thing) => thing instanceof AxiosHeaders_default ? thing.toJSON() : thing;
  function mergeConfig(config1, config2) {
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
      if (utils_default.isPlainObject(target) && utils_default.isPlainObject(source)) {
        return utils_default.merge.call({ caseless }, target, source);
      } else if (utils_default.isPlainObject(source)) {
        return utils_default.merge({}, source);
      } else if (utils_default.isArray(source)) {
        return source.slice();
      }
      return source;
    }
    function mergeDeepProperties(a, b, caseless) {
      if (!utils_default.isUndefined(b)) {
        return getMergedValue(a, b, caseless);
      } else if (!utils_default.isUndefined(a)) {
        return getMergedValue(void 0, a, caseless);
      }
    }
    function valueFromConfig2(a, b) {
      if (!utils_default.isUndefined(b)) {
        return getMergedValue(void 0, b);
      }
    }
    function defaultToConfig2(a, b) {
      if (!utils_default.isUndefined(b)) {
        return getMergedValue(void 0, b);
      } else if (!utils_default.isUndefined(a)) {
        return getMergedValue(void 0, a);
      }
    }
    function mergeDirectKeys(a, b, prop) {
      if (prop in config2) {
        return getMergedValue(a, b);
      } else if (prop in config1) {
        return getMergedValue(void 0, a);
      }
    }
    const mergeMap = {
      url: valueFromConfig2,
      method: valueFromConfig2,
      data: valueFromConfig2,
      baseURL: defaultToConfig2,
      transformRequest: defaultToConfig2,
      transformResponse: defaultToConfig2,
      paramsSerializer: defaultToConfig2,
      timeout: defaultToConfig2,
      timeoutMessage: defaultToConfig2,
      withCredentials: defaultToConfig2,
      withXSRFToken: defaultToConfig2,
      adapter: defaultToConfig2,
      responseType: defaultToConfig2,
      xsrfCookieName: defaultToConfig2,
      xsrfHeaderName: defaultToConfig2,
      onUploadProgress: defaultToConfig2,
      onDownloadProgress: defaultToConfig2,
      decompress: defaultToConfig2,
      maxContentLength: defaultToConfig2,
      maxBodyLength: defaultToConfig2,
      beforeRedirect: defaultToConfig2,
      transport: defaultToConfig2,
      httpAgent: defaultToConfig2,
      httpsAgent: defaultToConfig2,
      cancelToken: defaultToConfig2,
      socketPath: defaultToConfig2,
      responseEncoding: defaultToConfig2,
      validateStatus: mergeDirectKeys,
      headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    utils_default.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
      const merge3 = mergeMap[prop] || mergeDeepProperties;
      const configValue = merge3(config1[prop], config2[prop], prop);
      utils_default.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/env/data.js
  var VERSION2 = "1.6.2";

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/validator.js
  var validators = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach((type, i2) => {
    validators[type] = function validator2(thing) {
      return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
    };
  });
  var deprecatedWarnings = {};
  validators.transitional = function transitional(validator2, version17, message) {
    function formatMessage(opt, desc) {
      return "[Axios v" + VERSION2 + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    return (value, opt, opts) => {
      if (validator2 === false) {
        throw new AxiosError_default(
          formatMessage(opt, " has been removed" + (version17 ? " in " + version17 : "")),
          AxiosError_default.ERR_DEPRECATED
        );
      }
      if (version17 && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        console.warn(
          formatMessage(
            opt,
            " has been deprecated since v" + version17 + " and will be removed in the near future"
          )
        );
      }
      return validator2 ? validator2(value, opt, opts) : true;
    };
  };
  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") {
      throw new AxiosError_default("options must be an object", AxiosError_default.ERR_BAD_OPTION_VALUE);
    }
    const keys = Object.keys(options);
    let i2 = keys.length;
    while (i2-- > 0) {
      const opt = keys[i2];
      const validator2 = schema[opt];
      if (validator2) {
        const value = options[opt];
        const result = value === void 0 || validator2(value, opt, options);
        if (result !== true) {
          throw new AxiosError_default("option " + opt + " must be " + result, AxiosError_default.ERR_BAD_OPTION_VALUE);
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw new AxiosError_default("Unknown option " + opt, AxiosError_default.ERR_BAD_OPTION);
      }
    }
  }
  var validator_default = {
    assertOptions,
    validators
  };

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/core/Axios.js
  var validators2 = validator_default.validators;
  var Axios = class {
    constructor(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager_default(),
        response: new InterceptorManager_default()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
     * @param {?Object} config
     *
     * @returns {Promise} The Promise to be fulfilled
     */
    request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      const { transitional: transitional2, paramsSerializer, headers } = config;
      if (transitional2 !== void 0) {
        validator_default.assertOptions(transitional2, {
          silentJSONParsing: validators2.transitional(validators2.boolean),
          forcedJSONParsing: validators2.transitional(validators2.boolean),
          clarifyTimeoutError: validators2.transitional(validators2.boolean)
        }, false);
      }
      if (paramsSerializer != null) {
        if (utils_default.isFunction(paramsSerializer)) {
          config.paramsSerializer = {
            serialize: paramsSerializer
          };
        } else {
          validator_default.assertOptions(paramsSerializer, {
            encode: validators2.function,
            serialize: validators2.function
          }, true);
        }
      }
      config.method = (config.method || this.defaults.method || "get").toLowerCase();
      let contextHeaders = headers && utils_default.merge(
        headers.common,
        headers[config.method]
      );
      headers && utils_default.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        (method) => {
          delete headers[method];
        }
      );
      config.headers = AxiosHeaders_default.concat(contextHeaders, headers);
      const requestInterceptorChain = [];
      let synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      const responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      let promise;
      let i2 = 0;
      let len;
      if (!synchronousRequestInterceptors) {
        const chain = [dispatchRequest.bind(this), void 0];
        chain.unshift.apply(chain, requestInterceptorChain);
        chain.push.apply(chain, responseInterceptorChain);
        len = chain.length;
        promise = Promise.resolve(config);
        while (i2 < len) {
          promise = promise.then(chain[i2++], chain[i2++]);
        }
        return promise;
      }
      len = requestInterceptorChain.length;
      let newConfig = config;
      i2 = 0;
      while (i2 < len) {
        const onFulfilled = requestInterceptorChain[i2++];
        const onRejected = requestInterceptorChain[i2++];
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected.call(this, error);
          break;
        }
      }
      try {
        promise = dispatchRequest.call(this, newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      i2 = 0;
      len = responseInterceptorChain.length;
      while (i2 < len) {
        promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
      }
      return promise;
    }
    getUri(config) {
      config = mergeConfig(this.defaults, config);
      const fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    }
  };
  utils_default.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
    Axios.prototype[method] = function(url, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        url,
        data: (config || {}).data
      }));
    };
  });
  utils_default.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
      return function httpMethod(url, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          headers: isForm ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url,
          data
        }));
      };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
  });
  var Axios_default = Axios;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/cancel/CancelToken.js
  var CancelToken = class _CancelToken {
    constructor(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      let resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve2) {
        resolvePromise = resolve2;
      });
      const token = this;
      this.promise.then((cancel) => {
        if (!token._listeners) return;
        let i2 = token._listeners.length;
        while (i2-- > 0) {
          token._listeners[i2](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = (onfulfilled) => {
        let _resolve2;
        const promise = new Promise((resolve2) => {
          token.subscribe(resolve2);
          _resolve2 = resolve2;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve2);
        };
        return promise;
      };
      executor(function cancel(message, config, request4) {
        if (token.reason) {
          return;
        }
        token.reason = new CanceledError_default(message, config, request4);
        resolvePromise(token.reason);
      });
    }
    /**
     * Throws a `CanceledError` if cancellation has been requested.
     */
    throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    }
    /**
     * Subscribe to the cancel signal
     */
    subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    }
    /**
     * Unsubscribe from the cancel signal
     */
    unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      const index2 = this._listeners.indexOf(listener);
      if (index2 !== -1) {
        this._listeners.splice(index2, 1);
      }
    }
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */
    static source() {
      let cancel;
      const token = new _CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    }
  };
  var CancelToken_default = CancelToken;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/spread.js
  function spread(callback) {
    return function wrap2(arr) {
      return callback.apply(null, arr);
    };
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/isAxiosError.js
  function isAxiosError(payload) {
    return utils_default.isObject(payload) && payload.isAxiosError === true;
  }

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/helpers/HttpStatusCode.js
  var HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
  };
  Object.entries(HttpStatusCode).forEach(([key, value]) => {
    HttpStatusCode[value] = key;
  });
  var HttpStatusCode_default = HttpStatusCode;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/lib/axios.js
  function createInstance(defaultConfig) {
    const context = new Axios_default(defaultConfig);
    const instance = bind(Axios_default.prototype.request, context);
    utils_default.extend(instance, Axios_default.prototype, context, { allOwnKeys: true });
    utils_default.extend(instance, context, null, { allOwnKeys: true });
    instance.create = function create2(instanceConfig) {
      return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
  }
  var axios = createInstance(defaults_default);
  axios.Axios = Axios_default;
  axios.CanceledError = CanceledError_default;
  axios.CancelToken = CancelToken_default;
  axios.isCancel = isCancel;
  axios.VERSION = VERSION2;
  axios.toFormData = toFormData_default;
  axios.AxiosError = AxiosError_default;
  axios.Cancel = axios.CanceledError;
  axios.all = function all(promises) {
    return Promise.all(promises);
  };
  axios.spread = spread;
  axios.isAxiosError = isAxiosError;
  axios.mergeConfig = mergeConfig;
  axios.AxiosHeaders = AxiosHeaders_default;
  axios.formToJSON = (thing) => formDataToJSON_default(utils_default.isHTMLForm(thing) ? new FormData(thing) : thing);
  axios.getAdapter = adapters_default.getAdapter;
  axios.HttpStatusCode = HttpStatusCode_default;
  axios.default = axios;
  var axios_default = axios;

  // ../../node_modules/.pnpm/axios@1.6.2/node_modules/axios/index.js
  var {
    Axios: Axios2,
    AxiosError: AxiosError2,
    CanceledError: CanceledError2,
    isCancel: isCancel2,
    CancelToken: CancelToken2,
    VERSION: VERSION3,
    all: all2,
    Cancel,
    isAxiosError: isAxiosError2,
    spread: spread2,
    toFormData: toFormData2,
    AxiosHeaders: AxiosHeaders2,
    HttpStatusCode: HttpStatusCode2,
    formToJSON,
    getAdapter,
    mergeConfig: mergeConfig2
  } = axios_default;

  // ../http/package.json
  var package_default8 = {
    name: "@slangroom/http",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*",
      axios: "1.6.2"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../http/build/esm/src/plugin.js
  var version9 = package_default8.version;
  var HttpError = class extends Error {
    constructor(message) {
      super(message);
      this.name = "Slangroom @slangroom/http@" + package_default8.version + " Error";
    }
  };
  var p5 = new Plugin();
  var { request: request3 } = axios_default.create({
    headers: { "Content-Type": "application/json" },
    validateStatus: null,
    timeout: 0
    // no timeout
  });
  var defaultRequest = (m) => {
    return async (ctx) => {
      const url = ctx.fetchConnect()[0];
      const headers = ctx.get("headers");
      const object = ctx.get("object");
      const conf = { url, method: m };
      if (object)
        conf.data = object;
      if (headers)
        conf.headers = headers;
      try {
        const req = await request3(conf);
        return ctx.pass({ status: req.status.toString(), result: req.data });
      } catch (e2) {
        if (axios_default.isAxiosError(e2))
          return ctx.pass({ status: e2.code ?? "", result: "" });
        return ctx.fail(new HttpError(e2.message));
      }
    };
  };
  var sameParallelRequest = (m, isSame) => {
    return async (ctx) => {
      const reqs = [];
      const urls = ctx.fetchConnect();
      const headers = ctx.get("headers");
      if (isSame) {
        const object = ctx.get("object");
        for (const u of urls) {
          const conf = { url: u, method: m };
          if (headers)
            conf.headers = headers;
          if (object)
            conf.data = object;
          reqs.push(request3(conf));
        }
      } else {
        const objects = ctx.get("object");
        for (const [i2, u] of urls.entries()) {
          const conf = { url: u, method: m };
          if (headers)
            conf.headers = headers;
          if (objects)
            conf.data = objects[i2];
          reqs.push(request3(conf));
        }
      }
      const results = [];
      try {
        (await Promise.allSettled(reqs)).map((x) => {
          if (x.status === "fulfilled") {
            results.push({ status: x.value.status.toString(), result: x.value.data });
            return;
          }
          const err3 = x.reason;
          if (axios_default.isAxiosError(err3)) {
            results.push({ status: err3.code ?? "", result: "" });
            return;
          }
          throw new HttpError(err3.message);
        });
      } catch (e2) {
        ctx.fail(new HttpError(e2.message));
      }
      return ctx.pass(results);
    };
  };
  var defaults2 = {};
  var sequentials = {};
  var parallels = {};
  var sames = {};
  ["get", "post", "put", "patch", "delete"].forEach((m) => {
    [defaults2, sequentials, parallels, sames].forEach((x) => {
      let phrase, cb;
      if (x === defaults2) {
        phrase = `do ${m}`;
        cb = defaultRequest(m);
      } else if (x === sequentials) {
        phrase = `do sequential ${m}`;
        cb = (ctx) => ctx.fail(new HttpError("sequential requests are not implemented"));
      } else if (x === parallels) {
        phrase = `do parallel ${m}`;
        cb = sameParallelRequest(m, false);
      } else if (x === sames) {
        phrase = `do same ${m}`;
        cb = sameParallelRequest(m, true);
      } else {
        throw new Error("unreachable");
      }
      x[m] = p5.new("connect", phrase, cb);
      x[`${m}Headers`] = p5.new("connect", ["headers"], phrase, cb);
      if (m != "get") {
        x[`${m}Object`] = p5.new("connect", ["object"], phrase, cb);
        x[`${m}ObjectHeaders`] = p5.new("connect", ["object", "headers"], phrase, cb);
      }
    });
  });
  var http = p5;

  // ../json-schema/build/esm/src/plugin.js
  var import_ajv = __toESM(require_ajv(), 1);

  // ../json-schema/package.json
  var package_default9 = {
    name: "@slangroom/json-schema",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*",
      ajv: "8.17.1"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../json-schema/build/esm/src/plugin.js
  var version10 = package_default9.version;
  var JsonSchemaError = class extends Error {
    constructor(message) {
      super(message);
      this.name = "Slangroom @slangroom/json-schema@" + package_default9.version + " Error";
    }
  };
  var p6 = new Plugin();
  var ARG_JSON_DATA = "json_data";
  var ARG_JSON_SCHEMA = "json_schema";
  var PHRASE_VALIDATE_JSON = "validate json";
  var validateJSON = p6.new([ARG_JSON_DATA, ARG_JSON_SCHEMA], PHRASE_VALIDATE_JSON, async (ctx) => {
    const data = ctx.fetch(ARG_JSON_DATA);
    const schema = ctx.fetch(ARG_JSON_SCHEMA);
    try {
      const ajv = new import_ajv.Ajv({ allErrors: true });
      const validate = ajv.compile(schema);
      validate(data);
      return ctx.pass({
        errors: validate.errors ?? []
      });
    } catch (e2) {
      return ctx.fail(new JsonSchemaError("JSON Schema not valid" + e2.message));
    }
  });
  var JSONSchema = p6;

  // ../location/package.json
  var package_default10 = {
    name: "@slangroom/location",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../location/build/esm/src/plugin.js
  var version11 = package_default10.version;
  var LocationBaseError = class extends Error {
    constructor(message) {
      super(message);
      this.name = "Slangroom @slangroom/location@" + package_default10.version + " Error";
    }
  };
  var p7 = new Plugin();
  var getLocation = p7.new("get the current location", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    const location2 = window.location;
    return ctx.pass({
      href: location2.href,
      protocol: location2.protocol,
      host: location2.host,
      hostname: location2.hostname,
      port: location2.port,
      pathname: location2.pathname,
      search: location2.search,
      hash: location2.hash
    });
  });
  var getHref = p7.new("get the current location href", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.href);
  });
  var getProtocol = p7.new("get the current location protocol", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.protocol);
  });
  var getHost = p7.new("get the current location host", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.host);
  });
  var getHostname = p7.new("get the current location hostname", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.hostname);
  });
  var getPort = p7.new("get the current location port", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.port);
  });
  var getPathname = p7.new("get the current location pathname", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.pathname);
  });
  var getSearch = p7.new("get the current location search params", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.search);
  });
  var getHash2 = p7.new("get the current location hash", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.location.hash);
  });
  var reload = p7.new("reload the current page", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    window.location.reload();
    return ctx.pass("reload");
  });
  var replace = p7.new(["url"], "replace the current location", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    const url = ctx.get("url");
    if (typeof url !== "string") {
      return ctx.fail(new LocationBaseError("url must be a string"));
    }
    window.location.replace(url);
    return ctx.pass("replace");
  });
  var assign = p7.new(["url"], "assign the current location", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    const url = ctx.get("url");
    if (typeof url !== "string") {
      return ctx.fail(new LocationBaseError("url must be a string"));
    }
    window.location.assign(url);
    return ctx.pass("assign");
  });
  var redirectToUrl = p7.new(["url"], "redirect to the url", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    const url = ctx.get("url");
    if (typeof url !== "string") {
      return ctx.fail(new LocationBaseError("url must be a string"));
    }
    window.location.href = url;
    return ctx.pass("redirect");
  });
  var goBack = p7.new("go back in history", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    window.history.back();
    return ctx.pass("back");
  });
  var goForward = p7.new("go forward in history", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    window.history.forward();
    return ctx.pass("forward");
  });
  var go = p7.new(["index"], "go to a specific page in history", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    const index2 = ctx.get("index");
    if (typeof index2 !== "number") {
      return ctx.fail(new LocationBaseError("index must be a number"));
    }
    window.history.go(index2);
    return ctx.pass("go");
  });
  var length = p7.new("get the history length", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    return ctx.pass(window.history.length);
  });
  var openWindow = p7.new(["url"], "open the url in a new window", (ctx) => {
    if (window === void 0) {
      return ctx.fail(new LocationBaseError("You must be in a browser environment to use this plugin"));
    }
    const url = ctx.get("url");
    if (typeof url !== "string") {
      return ctx.fail(new LocationBaseError("url must be a string"));
    }
    window.open(url, "_blank");
    return ctx.pass("open");
  });
  var location = p7;

  // ../../node_modules/.pnpm/pocketbase@0.25.1/node_modules/pocketbase/dist/pocketbase.es.mjs
  var ClientResponseError = class _ClientResponseError extends Error {
    constructor(e2) {
      super("ClientResponseError"), this.url = "", this.status = 0, this.response = {}, this.isAbort = false, this.originalError = null, Object.setPrototypeOf(this, _ClientResponseError.prototype), null !== e2 && "object" == typeof e2 && (this.url = "string" == typeof e2.url ? e2.url : "", this.status = "number" == typeof e2.status ? e2.status : 0, this.isAbort = !!e2.isAbort, this.originalError = e2.originalError, null !== e2.response && "object" == typeof e2.response ? this.response = e2.response : null !== e2.data && "object" == typeof e2.data ? this.response = e2.data : this.response = {}), this.originalError || e2 instanceof _ClientResponseError || (this.originalError = e2), "undefined" != typeof DOMException && e2 instanceof DOMException && (this.isAbort = true), this.name = "ClientResponseError " + this.status, this.message = this.response?.message, this.message || (this.isAbort ? this.message = "The request was autocancelled. You can find more info in https://github.com/pocketbase/js-sdk#auto-cancellation." : this.originalError?.cause?.message?.includes("ECONNREFUSED ::1") ? this.message = "Failed to connect to the PocketBase server. Try changing the SDK URL from localhost to 127.0.0.1 (https://github.com/pocketbase/js-sdk/issues/21)." : this.message = "Something went wrong while processing your request.");
    }
    get data() {
      return this.response;
    }
    toJSON() {
      return { ...this };
    }
  };
  var e = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
  function cookieParse(e2, t2) {
    const s2 = {};
    if ("string" != typeof e2) return s2;
    const i2 = Object.assign({}, t2 || {}).decode || defaultDecode;
    let n2 = 0;
    for (; n2 < e2.length; ) {
      const t3 = e2.indexOf("=", n2);
      if (-1 === t3) break;
      let r2 = e2.indexOf(";", n2);
      if (-1 === r2) r2 = e2.length;
      else if (r2 < t3) {
        n2 = e2.lastIndexOf(";", t3 - 1) + 1;
        continue;
      }
      const o = e2.slice(n2, t3).trim();
      if (void 0 === s2[o]) {
        let n3 = e2.slice(t3 + 1, r2).trim();
        34 === n3.charCodeAt(0) && (n3 = n3.slice(1, -1));
        try {
          s2[o] = i2(n3);
        } catch (e3) {
          s2[o] = n3;
        }
      }
      n2 = r2 + 1;
    }
    return s2;
  }
  function cookieSerialize(t2, s2, i2) {
    const n2 = Object.assign({}, i2 || {}), r2 = n2.encode || defaultEncode;
    if (!e.test(t2)) throw new TypeError("argument name is invalid");
    const o = r2(s2);
    if (o && !e.test(o)) throw new TypeError("argument val is invalid");
    let a = t2 + "=" + o;
    if (null != n2.maxAge) {
      const e2 = n2.maxAge - 0;
      if (isNaN(e2) || !isFinite(e2)) throw new TypeError("option maxAge is invalid");
      a += "; Max-Age=" + Math.floor(e2);
    }
    if (n2.domain) {
      if (!e.test(n2.domain)) throw new TypeError("option domain is invalid");
      a += "; Domain=" + n2.domain;
    }
    if (n2.path) {
      if (!e.test(n2.path)) throw new TypeError("option path is invalid");
      a += "; Path=" + n2.path;
    }
    if (n2.expires) {
      if (!function isDate2(e2) {
        return "[object Date]" === Object.prototype.toString.call(e2) || e2 instanceof Date;
      }(n2.expires) || isNaN(n2.expires.valueOf())) throw new TypeError("option expires is invalid");
      a += "; Expires=" + n2.expires.toUTCString();
    }
    if (n2.httpOnly && (a += "; HttpOnly"), n2.secure && (a += "; Secure"), n2.priority) {
      switch ("string" == typeof n2.priority ? n2.priority.toLowerCase() : n2.priority) {
        case "low":
          a += "; Priority=Low";
          break;
        case "medium":
          a += "; Priority=Medium";
          break;
        case "high":
          a += "; Priority=High";
          break;
        default:
          throw new TypeError("option priority is invalid");
      }
    }
    if (n2.sameSite) {
      switch ("string" == typeof n2.sameSite ? n2.sameSite.toLowerCase() : n2.sameSite) {
        case true:
          a += "; SameSite=Strict";
          break;
        case "lax":
          a += "; SameSite=Lax";
          break;
        case "strict":
          a += "; SameSite=Strict";
          break;
        case "none":
          a += "; SameSite=None";
          break;
        default:
          throw new TypeError("option sameSite is invalid");
      }
    }
    return a;
  }
  function defaultDecode(e2) {
    return -1 !== e2.indexOf("%") ? decodeURIComponent(e2) : e2;
  }
  function defaultEncode(e2) {
    return encodeURIComponent(e2);
  }
  var t = "undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof global && global.HermesInternal;
  var s;
  function getTokenPayload(e2) {
    if (e2) try {
      const t2 = decodeURIComponent(s(e2.split(".")[1]).split("").map(function(e3) {
        return "%" + ("00" + e3.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
      return JSON.parse(t2) || {};
    } catch (e3) {
    }
    return {};
  }
  function isTokenExpired(e2, t2 = 0) {
    let s2 = getTokenPayload(e2);
    return !(Object.keys(s2).length > 0 && (!s2.exp || s2.exp - t2 > Date.now() / 1e3));
  }
  s = "function" != typeof atob || t ? (e2) => {
    let t2 = String(e2).replace(/=+$/, "");
    if (t2.length % 4 == 1) throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    for (var s2, i2, n2 = 0, r2 = 0, o = ""; i2 = t2.charAt(r2++); ~i2 && (s2 = n2 % 4 ? 64 * s2 + i2 : i2, n2++ % 4) ? o += String.fromCharCode(255 & s2 >> (-2 * n2 & 6)) : 0) i2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i2);
    return o;
  } : atob;
  var i = "pb_auth";
  var BaseAuthStore = class {
    constructor() {
      this.baseToken = "", this.baseModel = null, this._onChangeCallbacks = [];
    }
    get token() {
      return this.baseToken;
    }
    get record() {
      return this.baseModel;
    }
    get model() {
      return this.baseModel;
    }
    get isValid() {
      return !isTokenExpired(this.token);
    }
    get isSuperuser() {
      let e2 = getTokenPayload(this.token);
      return "auth" == e2.type && ("_superusers" == this.record?.collectionName || !this.record?.collectionName && "pbc_3142635823" == e2.collectionId);
    }
    get isAdmin() {
      return console.warn("Please replace pb.authStore.isAdmin with pb.authStore.isSuperuser OR simply check the value of pb.authStore.record?.collectionName"), this.isSuperuser;
    }
    get isAuthRecord() {
      return console.warn("Please replace pb.authStore.isAuthRecord with !pb.authStore.isSuperuser OR simply check the value of pb.authStore.record?.collectionName"), "auth" == getTokenPayload(this.token).type && !this.isSuperuser;
    }
    save(e2, t2) {
      this.baseToken = e2 || "", this.baseModel = t2 || null, this.triggerChange();
    }
    clear() {
      this.baseToken = "", this.baseModel = null, this.triggerChange();
    }
    loadFromCookie(e2, t2 = i) {
      const s2 = cookieParse(e2 || "")[t2] || "";
      let n2 = {};
      try {
        n2 = JSON.parse(s2), (null === typeof n2 || "object" != typeof n2 || Array.isArray(n2)) && (n2 = {});
      } catch (e3) {
      }
      this.save(n2.token || "", n2.record || n2.model || null);
    }
    exportToCookie(e2, t2 = i) {
      const s2 = { secure: true, sameSite: true, httpOnly: true, path: "/" }, n2 = getTokenPayload(this.token);
      s2.expires = n2?.exp ? new Date(1e3 * n2.exp) : /* @__PURE__ */ new Date("1970-01-01"), e2 = Object.assign({}, s2, e2);
      const r2 = { token: this.token, record: this.record ? JSON.parse(JSON.stringify(this.record)) : null };
      let o = cookieSerialize(t2, JSON.stringify(r2), e2);
      const a = "undefined" != typeof Blob ? new Blob([o]).size : o.length;
      if (r2.record && a > 4096) {
        r2.record = { id: r2.record?.id, email: r2.record?.email };
        const s3 = ["collectionId", "collectionName", "verified"];
        for (const e3 in this.record) s3.includes(e3) && (r2.record[e3] = this.record[e3]);
        o = cookieSerialize(t2, JSON.stringify(r2), e2);
      }
      return o;
    }
    onChange(e2, t2 = false) {
      return this._onChangeCallbacks.push(e2), t2 && e2(this.token, this.record), () => {
        for (let t3 = this._onChangeCallbacks.length - 1; t3 >= 0; t3--) if (this._onChangeCallbacks[t3] == e2) return delete this._onChangeCallbacks[t3], void this._onChangeCallbacks.splice(t3, 1);
      };
    }
    triggerChange() {
      for (const e2 of this._onChangeCallbacks) e2 && e2(this.token, this.record);
    }
  };
  var LocalAuthStore = class extends BaseAuthStore {
    constructor(e2 = "pocketbase_auth") {
      super(), this.storageFallback = {}, this.storageKey = e2, this._bindStorageEvent();
    }
    get token() {
      return (this._storageGet(this.storageKey) || {}).token || "";
    }
    get record() {
      const e2 = this._storageGet(this.storageKey) || {};
      return e2.record || e2.model || null;
    }
    get model() {
      return this.record;
    }
    save(e2, t2) {
      this._storageSet(this.storageKey, { token: e2, record: t2 }), super.save(e2, t2);
    }
    clear() {
      this._storageRemove(this.storageKey), super.clear();
    }
    _storageGet(e2) {
      if ("undefined" != typeof window && window?.localStorage) {
        const t2 = window.localStorage.getItem(e2) || "";
        try {
          return JSON.parse(t2);
        } catch (e3) {
          return t2;
        }
      }
      return this.storageFallback[e2];
    }
    _storageSet(e2, t2) {
      if ("undefined" != typeof window && window?.localStorage) {
        let s2 = t2;
        "string" != typeof t2 && (s2 = JSON.stringify(t2)), window.localStorage.setItem(e2, s2);
      } else this.storageFallback[e2] = t2;
    }
    _storageRemove(e2) {
      "undefined" != typeof window && window?.localStorage && window.localStorage?.removeItem(e2), delete this.storageFallback[e2];
    }
    _bindStorageEvent() {
      "undefined" != typeof window && window?.localStorage && window.addEventListener && window.addEventListener("storage", (e2) => {
        if (e2.key != this.storageKey) return;
        const t2 = this._storageGet(this.storageKey) || {};
        super.save(t2.token || "", t2.record || t2.model || null);
      });
    }
  };
  var BaseService = class {
    constructor(e2) {
      this.client = e2;
    }
  };
  var SettingsService = class extends BaseService {
    async getAll(e2) {
      return e2 = Object.assign({ method: "GET" }, e2), this.client.send("/api/settings", e2);
    }
    async update(e2, t2) {
      return t2 = Object.assign({ method: "PATCH", body: e2 }, t2), this.client.send("/api/settings", t2);
    }
    async testS3(e2 = "storage", t2) {
      return t2 = Object.assign({ method: "POST", body: { filesystem: e2 } }, t2), this.client.send("/api/settings/test/s3", t2).then(() => true);
    }
    async testEmail(e2, t2, s2, i2) {
      return i2 = Object.assign({ method: "POST", body: { email: t2, template: s2, collection: e2 } }, i2), this.client.send("/api/settings/test/email", i2).then(() => true);
    }
    async generateAppleClientSecret(e2, t2, s2, i2, n2, r2) {
      return r2 = Object.assign({ method: "POST", body: { clientId: e2, teamId: t2, keyId: s2, privateKey: i2, duration: n2 } }, r2), this.client.send("/api/settings/apple/generate-client-secret", r2);
    }
  };
  var n = ["requestKey", "$cancelKey", "$autoCancel", "fetch", "headers", "body", "query", "params", "cache", "credentials", "headers", "integrity", "keepalive", "method", "mode", "redirect", "referrer", "referrerPolicy", "signal", "window"];
  function normalizeUnknownQueryParams(e2) {
    if (e2) {
      e2.query = e2.query || {};
      for (let t2 in e2) n.includes(t2) || (e2.query[t2] = e2[t2], delete e2[t2]);
    }
  }
  function serializeQueryParams(e2) {
    const t2 = [];
    for (const s2 in e2) {
      if (null === e2[s2] || void 0 === e2[s2]) continue;
      const i2 = e2[s2], n2 = encodeURIComponent(s2);
      if (Array.isArray(i2)) for (const e3 of i2) t2.push(n2 + "=" + encodeURIComponent(e3));
      else i2 instanceof Date ? t2.push(n2 + "=" + encodeURIComponent(i2.toISOString())) : null !== typeof i2 && "object" == typeof i2 ? t2.push(n2 + "=" + encodeURIComponent(JSON.stringify(i2))) : t2.push(n2 + "=" + encodeURIComponent(i2));
    }
    return t2.join("&");
  }
  var RealtimeService = class extends BaseService {
    constructor() {
      super(...arguments), this.clientId = "", this.eventSource = null, this.subscriptions = {}, this.lastSentSubscriptions = [], this.maxConnectTimeout = 15e3, this.reconnectAttempts = 0, this.maxReconnectAttempts = 1 / 0, this.predefinedReconnectIntervals = [200, 300, 500, 1e3, 1200, 1500, 2e3], this.pendingConnects = [];
    }
    get isConnected() {
      return !!this.eventSource && !!this.clientId && !this.pendingConnects.length;
    }
    async subscribe(e2, t2, s2) {
      if (!e2) throw new Error("topic must be set.");
      let i2 = e2;
      if (s2) {
        normalizeUnknownQueryParams(s2 = Object.assign({}, s2));
        const e3 = "options=" + encodeURIComponent(JSON.stringify({ query: s2.query, headers: s2.headers }));
        i2 += (i2.includes("?") ? "&" : "?") + e3;
      }
      const listener = function(e3) {
        const s3 = e3;
        let i3;
        try {
          i3 = JSON.parse(s3?.data);
        } catch {
        }
        t2(i3 || {});
      };
      return this.subscriptions[i2] || (this.subscriptions[i2] = []), this.subscriptions[i2].push(listener), this.isConnected ? 1 === this.subscriptions[i2].length ? await this.submitSubscriptions() : this.eventSource?.addEventListener(i2, listener) : await this.connect(), async () => this.unsubscribeByTopicAndListener(e2, listener);
    }
    async unsubscribe(e2) {
      let t2 = false;
      if (e2) {
        const s2 = this.getSubscriptionsByTopic(e2);
        for (let e3 in s2) if (this.hasSubscriptionListeners(e3)) {
          for (let t3 of this.subscriptions[e3]) this.eventSource?.removeEventListener(e3, t3);
          delete this.subscriptions[e3], t2 || (t2 = true);
        }
      } else this.subscriptions = {};
      this.hasSubscriptionListeners() ? t2 && await this.submitSubscriptions() : this.disconnect();
    }
    async unsubscribeByPrefix(e2) {
      let t2 = false;
      for (let s2 in this.subscriptions) if ((s2 + "?").startsWith(e2)) {
        t2 = true;
        for (let e3 of this.subscriptions[s2]) this.eventSource?.removeEventListener(s2, e3);
        delete this.subscriptions[s2];
      }
      t2 && (this.hasSubscriptionListeners() ? await this.submitSubscriptions() : this.disconnect());
    }
    async unsubscribeByTopicAndListener(e2, t2) {
      let s2 = false;
      const i2 = this.getSubscriptionsByTopic(e2);
      for (let e3 in i2) {
        if (!Array.isArray(this.subscriptions[e3]) || !this.subscriptions[e3].length) continue;
        let i3 = false;
        for (let s3 = this.subscriptions[e3].length - 1; s3 >= 0; s3--) this.subscriptions[e3][s3] === t2 && (i3 = true, delete this.subscriptions[e3][s3], this.subscriptions[e3].splice(s3, 1), this.eventSource?.removeEventListener(e3, t2));
        i3 && (this.subscriptions[e3].length || delete this.subscriptions[e3], s2 || this.hasSubscriptionListeners(e3) || (s2 = true));
      }
      this.hasSubscriptionListeners() ? s2 && await this.submitSubscriptions() : this.disconnect();
    }
    hasSubscriptionListeners(e2) {
      if (this.subscriptions = this.subscriptions || {}, e2) return !!this.subscriptions[e2]?.length;
      for (let e3 in this.subscriptions) if (this.subscriptions[e3]?.length) return true;
      return false;
    }
    async submitSubscriptions() {
      if (this.clientId) return this.addAllSubscriptionListeners(), this.lastSentSubscriptions = this.getNonEmptySubscriptionKeys(), this.client.send("/api/realtime", { method: "POST", body: { clientId: this.clientId, subscriptions: this.lastSentSubscriptions }, requestKey: this.getSubscriptionsCancelKey() }).catch((e2) => {
        if (!e2?.isAbort) throw e2;
      });
    }
    getSubscriptionsCancelKey() {
      return "realtime_" + this.clientId;
    }
    getSubscriptionsByTopic(e2) {
      const t2 = {};
      e2 = e2.includes("?") ? e2 : e2 + "?";
      for (let s2 in this.subscriptions) (s2 + "?").startsWith(e2) && (t2[s2] = this.subscriptions[s2]);
      return t2;
    }
    getNonEmptySubscriptionKeys() {
      const e2 = [];
      for (let t2 in this.subscriptions) this.subscriptions[t2].length && e2.push(t2);
      return e2;
    }
    addAllSubscriptionListeners() {
      if (this.eventSource) {
        this.removeAllSubscriptionListeners();
        for (let e2 in this.subscriptions) for (let t2 of this.subscriptions[e2]) this.eventSource.addEventListener(e2, t2);
      }
    }
    removeAllSubscriptionListeners() {
      if (this.eventSource) for (let e2 in this.subscriptions) for (let t2 of this.subscriptions[e2]) this.eventSource.removeEventListener(e2, t2);
    }
    async connect() {
      if (!(this.reconnectAttempts > 0)) return new Promise((e2, t2) => {
        this.pendingConnects.push({ resolve: e2, reject: t2 }), this.pendingConnects.length > 1 || this.initConnect();
      });
    }
    initConnect() {
      this.disconnect(true), clearTimeout(this.connectTimeoutId), this.connectTimeoutId = setTimeout(() => {
        this.connectErrorHandler(new Error("EventSource connect took too long."));
      }, this.maxConnectTimeout), this.eventSource = new EventSource(this.client.buildURL("/api/realtime")), this.eventSource.onerror = (e2) => {
        this.connectErrorHandler(new Error("Failed to establish realtime connection."));
      }, this.eventSource.addEventListener("PB_CONNECT", (e2) => {
        const t2 = e2;
        this.clientId = t2?.lastEventId, this.submitSubscriptions().then(async () => {
          let e3 = 3;
          for (; this.hasUnsentSubscriptions() && e3 > 0; ) e3--, await this.submitSubscriptions();
        }).then(() => {
          for (let e3 of this.pendingConnects) e3.resolve();
          this.pendingConnects = [], this.reconnectAttempts = 0, clearTimeout(this.reconnectTimeoutId), clearTimeout(this.connectTimeoutId);
          const t3 = this.getSubscriptionsByTopic("PB_CONNECT");
          for (let s2 in t3) for (let i2 of t3[s2]) i2(e2);
        }).catch((e3) => {
          this.clientId = "", this.connectErrorHandler(e3);
        });
      });
    }
    hasUnsentSubscriptions() {
      const e2 = this.getNonEmptySubscriptionKeys();
      if (e2.length != this.lastSentSubscriptions.length) return true;
      for (const t2 of e2) if (!this.lastSentSubscriptions.includes(t2)) return true;
      return false;
    }
    connectErrorHandler(e2) {
      if (clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), !this.clientId && !this.reconnectAttempts || this.reconnectAttempts > this.maxReconnectAttempts) {
        for (let t3 of this.pendingConnects) t3.reject(new ClientResponseError(e2));
        return this.pendingConnects = [], void this.disconnect();
      }
      this.disconnect(true);
      const t2 = this.predefinedReconnectIntervals[this.reconnectAttempts] || this.predefinedReconnectIntervals[this.predefinedReconnectIntervals.length - 1];
      this.reconnectAttempts++, this.reconnectTimeoutId = setTimeout(() => {
        this.initConnect();
      }, t2);
    }
    disconnect(e2 = false) {
      if (this.clientId && this.onDisconnect && this.onDisconnect(Object.keys(this.subscriptions)), clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), this.removeAllSubscriptionListeners(), this.client.cancelRequest(this.getSubscriptionsCancelKey()), this.eventSource?.close(), this.eventSource = null, this.clientId = "", !e2) {
        this.reconnectAttempts = 0;
        for (let e3 of this.pendingConnects) e3.resolve();
        this.pendingConnects = [];
      }
    }
  };
  var CrudService = class extends BaseService {
    decode(e2) {
      return e2;
    }
    async getFullList(e2, t2) {
      if ("number" == typeof e2) return this._getFullList(e2, t2);
      let s2 = 500;
      return (t2 = Object.assign({}, e2, t2)).batch && (s2 = t2.batch, delete t2.batch), this._getFullList(s2, t2);
    }
    async getList(e2 = 1, t2 = 30, s2) {
      return (s2 = Object.assign({ method: "GET" }, s2)).query = Object.assign({ page: e2, perPage: t2 }, s2.query), this.client.send(this.baseCrudPath, s2).then((e3) => (e3.items = e3.items?.map((e4) => this.decode(e4)) || [], e3));
    }
    async getFirstListItem(e2, t2) {
      return (t2 = Object.assign({ requestKey: "one_by_filter_" + this.baseCrudPath + "_" + e2 }, t2)).query = Object.assign({ filter: e2, skipTotal: 1 }, t2.query), this.getList(1, 1, t2).then((e3) => {
        if (!e3?.items?.length) throw new ClientResponseError({ status: 404, response: { code: 404, message: "The requested resource wasn't found.", data: {} } });
        return e3.items[0];
      });
    }
    async getOne(e2, t2) {
      if (!e2) throw new ClientResponseError({ url: this.client.buildURL(this.baseCrudPath + "/"), status: 404, response: { code: 404, message: "Missing required record id.", data: {} } });
      return t2 = Object.assign({ method: "GET" }, t2), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e2), t2).then((e3) => this.decode(e3));
    }
    async create(e2, t2) {
      return t2 = Object.assign({ method: "POST", body: e2 }, t2), this.client.send(this.baseCrudPath, t2).then((e3) => this.decode(e3));
    }
    async update(e2, t2, s2) {
      return s2 = Object.assign({ method: "PATCH", body: t2 }, s2), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e2), s2).then((e3) => this.decode(e3));
    }
    async delete(e2, t2) {
      return t2 = Object.assign({ method: "DELETE" }, t2), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e2), t2).then(() => true);
    }
    _getFullList(e2 = 500, t2) {
      (t2 = t2 || {}).query = Object.assign({ skipTotal: 1 }, t2.query);
      let s2 = [], request4 = async (i2) => this.getList(i2, e2 || 500, t2).then((e3) => {
        const t3 = e3.items;
        return s2 = s2.concat(t3), t3.length == e3.perPage ? request4(i2 + 1) : s2;
      });
      return request4(1);
    }
  };
  function normalizeLegacyOptionsArgs(e2, t2, s2, i2) {
    const n2 = void 0 !== i2;
    return n2 || void 0 !== s2 ? n2 ? (console.warn(e2), t2.body = Object.assign({}, t2.body, s2), t2.query = Object.assign({}, t2.query, i2), t2) : Object.assign(t2, s2) : t2;
  }
  function resetAutoRefresh(e2) {
    e2._resetAutoRefresh?.();
  }
  var RecordService = class extends CrudService {
    constructor(e2, t2) {
      super(e2), this.collectionIdOrName = t2;
    }
    get baseCrudPath() {
      return this.baseCollectionPath + "/records";
    }
    get baseCollectionPath() {
      return "/api/collections/" + encodeURIComponent(this.collectionIdOrName);
    }
    get isSuperusers() {
      return "_superusers" == this.collectionIdOrName || "_pbc_2773867675" == this.collectionIdOrName;
    }
    async subscribe(e2, t2, s2) {
      if (!e2) throw new Error("Missing topic.");
      if (!t2) throw new Error("Missing subscription callback.");
      return this.client.realtime.subscribe(this.collectionIdOrName + "/" + e2, t2, s2);
    }
    async unsubscribe(e2) {
      return e2 ? this.client.realtime.unsubscribe(this.collectionIdOrName + "/" + e2) : this.client.realtime.unsubscribeByPrefix(this.collectionIdOrName);
    }
    async getFullList(e2, t2) {
      if ("number" == typeof e2) return super.getFullList(e2, t2);
      const s2 = Object.assign({}, e2, t2);
      return super.getFullList(s2);
    }
    async getList(e2 = 1, t2 = 30, s2) {
      return super.getList(e2, t2, s2);
    }
    async getFirstListItem(e2, t2) {
      return super.getFirstListItem(e2, t2);
    }
    async getOne(e2, t2) {
      return super.getOne(e2, t2);
    }
    async create(e2, t2) {
      return super.create(e2, t2);
    }
    async update(e2, t2, s2) {
      return super.update(e2, t2, s2).then((e3) => {
        if (this.client.authStore.record?.id === e3?.id && (this.client.authStore.record?.collectionId === this.collectionIdOrName || this.client.authStore.record?.collectionName === this.collectionIdOrName)) {
          let t3 = Object.assign({}, this.client.authStore.record.expand), s3 = Object.assign({}, this.client.authStore.record, e3);
          t3 && (s3.expand = Object.assign(t3, e3.expand)), this.client.authStore.save(this.client.authStore.token, s3);
        }
        return e3;
      });
    }
    async delete(e2, t2) {
      return super.delete(e2, t2).then((t3) => (!t3 || this.client.authStore.record?.id !== e2 || this.client.authStore.record?.collectionId !== this.collectionIdOrName && this.client.authStore.record?.collectionName !== this.collectionIdOrName || this.client.authStore.clear(), t3));
    }
    authResponse(e2) {
      const t2 = this.decode(e2?.record || {});
      return this.client.authStore.save(e2?.token, t2), Object.assign({}, e2, { token: e2?.token || "", record: t2 });
    }
    async listAuthMethods(e2) {
      return e2 = Object.assign({ method: "GET", fields: "mfa,otp,password,oauth2" }, e2), this.client.send(this.baseCollectionPath + "/auth-methods", e2);
    }
    async authWithPassword(e2, t2, s2) {
      let i2;
      s2 = Object.assign({ method: "POST", body: { identity: e2, password: t2 } }, s2), this.isSuperusers && (i2 = s2.autoRefreshThreshold, delete s2.autoRefreshThreshold, s2.autoRefresh || resetAutoRefresh(this.client));
      let n2 = await this.client.send(this.baseCollectionPath + "/auth-with-password", s2);
      return n2 = this.authResponse(n2), i2 && this.isSuperusers && function registerAutoRefresh(e3, t3, s3, i3) {
        resetAutoRefresh(e3);
        const n3 = e3.beforeSend, r2 = e3.authStore.record, o = e3.authStore.onChange((t4, s4) => {
          (!t4 || s4?.id != r2?.id || (s4?.collectionId || r2?.collectionId) && s4?.collectionId != r2?.collectionId) && resetAutoRefresh(e3);
        });
        e3._resetAutoRefresh = function() {
          o(), e3.beforeSend = n3, delete e3._resetAutoRefresh;
        }, e3.beforeSend = async (r3, o2) => {
          const a = e3.authStore.token;
          if (o2.query?.autoRefresh) return n3 ? n3(r3, o2) : { url: r3, sendOptions: o2 };
          let c = e3.authStore.isValid;
          if (c && isTokenExpired(e3.authStore.token, t3)) try {
            await s3();
          } catch (e4) {
            c = false;
          }
          c || await i3();
          const l = o2.headers || {};
          for (let t4 in l) if ("authorization" == t4.toLowerCase() && a == l[t4] && e3.authStore.token) {
            l[t4] = e3.authStore.token;
            break;
          }
          return o2.headers = l, n3 ? n3(r3, o2) : { url: r3, sendOptions: o2 };
        };
      }(this.client, i2, () => this.authRefresh({ autoRefresh: true }), () => this.authWithPassword(e2, t2, Object.assign({ autoRefresh: true }, s2))), n2;
    }
    async authWithOAuth2Code(e2, t2, s2, i2, n2, r2, o) {
      let a = { method: "POST", body: { provider: e2, code: t2, codeVerifier: s2, redirectURL: i2, createData: n2 } };
      return a = normalizeLegacyOptionsArgs("This form of authWithOAuth2Code(provider, code, codeVerifier, redirectURL, createData?, body?, query?) is deprecated. Consider replacing it with authWithOAuth2Code(provider, code, codeVerifier, redirectURL, createData?, options?).", a, r2, o), this.client.send(this.baseCollectionPath + "/auth-with-oauth2", a).then((e3) => this.authResponse(e3));
    }
    authWithOAuth2(...e2) {
      if (e2.length > 1 || "string" == typeof e2?.[0]) return console.warn("PocketBase: This form of authWithOAuth2() is deprecated and may get removed in the future. Please replace with authWithOAuth2Code() OR use the authWithOAuth2() realtime form as shown in https://pocketbase.io/docs/authentication/#oauth2-integration."), this.authWithOAuth2Code(e2?.[0] || "", e2?.[1] || "", e2?.[2] || "", e2?.[3] || "", e2?.[4] || {}, e2?.[5] || {}, e2?.[6] || {});
      const t2 = e2?.[0] || {};
      let s2 = null;
      t2.urlCallback || (s2 = openBrowserPopup(void 0));
      const i2 = new RealtimeService(this.client);
      function cleanup() {
        s2?.close(), i2.unsubscribe();
      }
      const n2 = {}, r2 = t2.requestKey;
      return r2 && (n2.requestKey = r2), this.listAuthMethods(n2).then((e3) => {
        const n3 = e3.oauth2.providers.find((e4) => e4.name === t2.provider);
        if (!n3) throw new ClientResponseError(new Error(`Missing or invalid provider "${t2.provider}".`));
        const o = this.client.buildURL("/api/oauth2-redirect"), a = r2 ? this.client.cancelControllers?.[r2] : void 0;
        return a && (a.signal.onabort = () => {
          cleanup();
        }), new Promise(async (e4, r3) => {
          try {
            await i2.subscribe("@oauth2", async (s3) => {
              const c2 = i2.clientId;
              try {
                if (!s3.state || c2 !== s3.state) throw new Error("State parameters don't match.");
                if (s3.error || !s3.code) throw new Error("OAuth2 redirect error or missing code: " + s3.error);
                const i3 = Object.assign({}, t2);
                delete i3.provider, delete i3.scopes, delete i3.createData, delete i3.urlCallback, a?.signal?.onabort && (a.signal.onabort = null);
                const r4 = await this.authWithOAuth2Code(n3.name, s3.code, n3.codeVerifier, o, t2.createData, i3);
                e4(r4);
              } catch (e5) {
                r3(new ClientResponseError(e5));
              }
              cleanup();
            });
            const c = { state: i2.clientId };
            t2.scopes?.length && (c.scope = t2.scopes.join(" "));
            const l = this._replaceQueryParams(n3.authURL + o, c);
            let h = t2.urlCallback || function(e5) {
              s2 ? s2.location.href = e5 : s2 = openBrowserPopup(e5);
            };
            await h(l);
          } catch (e5) {
            cleanup(), r3(new ClientResponseError(e5));
          }
        });
      }).catch((e3) => {
        throw cleanup(), e3;
      });
    }
    async authRefresh(e2, t2) {
      let s2 = { method: "POST" };
      return s2 = normalizeLegacyOptionsArgs("This form of authRefresh(body?, query?) is deprecated. Consider replacing it with authRefresh(options?).", s2, e2, t2), this.client.send(this.baseCollectionPath + "/auth-refresh", s2).then((e3) => this.authResponse(e3));
    }
    async requestPasswordReset(e2, t2, s2) {
      let i2 = { method: "POST", body: { email: e2 } };
      return i2 = normalizeLegacyOptionsArgs("This form of requestPasswordReset(email, body?, query?) is deprecated. Consider replacing it with requestPasswordReset(email, options?).", i2, t2, s2), this.client.send(this.baseCollectionPath + "/request-password-reset", i2).then(() => true);
    }
    async confirmPasswordReset(e2, t2, s2, i2, n2) {
      let r2 = { method: "POST", body: { token: e2, password: t2, passwordConfirm: s2 } };
      return r2 = normalizeLegacyOptionsArgs("This form of confirmPasswordReset(token, password, passwordConfirm, body?, query?) is deprecated. Consider replacing it with confirmPasswordReset(token, password, passwordConfirm, options?).", r2, i2, n2), this.client.send(this.baseCollectionPath + "/confirm-password-reset", r2).then(() => true);
    }
    async requestVerification(e2, t2, s2) {
      let i2 = { method: "POST", body: { email: e2 } };
      return i2 = normalizeLegacyOptionsArgs("This form of requestVerification(email, body?, query?) is deprecated. Consider replacing it with requestVerification(email, options?).", i2, t2, s2), this.client.send(this.baseCollectionPath + "/request-verification", i2).then(() => true);
    }
    async confirmVerification(e2, t2, s2) {
      let i2 = { method: "POST", body: { token: e2 } };
      return i2 = normalizeLegacyOptionsArgs("This form of confirmVerification(token, body?, query?) is deprecated. Consider replacing it with confirmVerification(token, options?).", i2, t2, s2), this.client.send(this.baseCollectionPath + "/confirm-verification", i2).then(() => {
        const t3 = getTokenPayload(e2), s3 = this.client.authStore.record;
        return s3 && !s3.verified && s3.id === t3.id && s3.collectionId === t3.collectionId && (s3.verified = true, this.client.authStore.save(this.client.authStore.token, s3)), true;
      });
    }
    async requestEmailChange(e2, t2, s2) {
      let i2 = { method: "POST", body: { newEmail: e2 } };
      return i2 = normalizeLegacyOptionsArgs("This form of requestEmailChange(newEmail, body?, query?) is deprecated. Consider replacing it with requestEmailChange(newEmail, options?).", i2, t2, s2), this.client.send(this.baseCollectionPath + "/request-email-change", i2).then(() => true);
    }
    async confirmEmailChange(e2, t2, s2, i2) {
      let n2 = { method: "POST", body: { token: e2, password: t2 } };
      return n2 = normalizeLegacyOptionsArgs("This form of confirmEmailChange(token, password, body?, query?) is deprecated. Consider replacing it with confirmEmailChange(token, password, options?).", n2, s2, i2), this.client.send(this.baseCollectionPath + "/confirm-email-change", n2).then(() => {
        const t3 = getTokenPayload(e2), s3 = this.client.authStore.record;
        return s3 && s3.id === t3.id && s3.collectionId === t3.collectionId && this.client.authStore.clear(), true;
      });
    }
    async listExternalAuths(e2, t2) {
      return this.client.collection("_externalAuths").getFullList(Object.assign({}, t2, { filter: this.client.filter("recordRef = {:id}", { id: e2 }) }));
    }
    async unlinkExternalAuth(e2, t2, s2) {
      const i2 = await this.client.collection("_externalAuths").getFirstListItem(this.client.filter("recordRef = {:recordId} && provider = {:provider}", { recordId: e2, provider: t2 }));
      return this.client.collection("_externalAuths").delete(i2.id, s2).then(() => true);
    }
    async requestOTP(e2, t2) {
      return t2 = Object.assign({ method: "POST", body: { email: e2 } }, t2), this.client.send(this.baseCollectionPath + "/request-otp", t2);
    }
    async authWithOTP(e2, t2, s2) {
      return s2 = Object.assign({ method: "POST", body: { otpId: e2, password: t2 } }, s2), this.client.send(this.baseCollectionPath + "/auth-with-otp", s2).then((e3) => this.authResponse(e3));
    }
    async impersonate(e2, t2, s2) {
      (s2 = Object.assign({ method: "POST", body: { duration: t2 } }, s2)).headers = s2.headers || {}, s2.headers.Authorization || (s2.headers.Authorization = this.client.authStore.token);
      const i2 = new Client(this.client.baseURL, new BaseAuthStore(), this.client.lang), n2 = await i2.send(this.baseCollectionPath + "/impersonate/" + encodeURIComponent(e2), s2);
      return i2.authStore.save(n2?.token, this.decode(n2?.record || {})), i2;
    }
    _replaceQueryParams(e2, t2 = {}) {
      let s2 = e2, i2 = "";
      e2.indexOf("?") >= 0 && (s2 = e2.substring(0, e2.indexOf("?")), i2 = e2.substring(e2.indexOf("?") + 1));
      const n2 = {}, r2 = i2.split("&");
      for (const e3 of r2) {
        if ("" == e3) continue;
        const t3 = e3.split("=");
        n2[decodeURIComponent(t3[0].replace(/\+/g, " "))] = decodeURIComponent((t3[1] || "").replace(/\+/g, " "));
      }
      for (let e3 in t2) t2.hasOwnProperty(e3) && (null == t2[e3] ? delete n2[e3] : n2[e3] = t2[e3]);
      i2 = "";
      for (let e3 in n2) n2.hasOwnProperty(e3) && ("" != i2 && (i2 += "&"), i2 += encodeURIComponent(e3.replace(/%20/g, "+")) + "=" + encodeURIComponent(n2[e3].replace(/%20/g, "+")));
      return "" != i2 ? s2 + "?" + i2 : s2;
    }
  };
  function openBrowserPopup(e2) {
    if ("undefined" == typeof window || !window?.open) throw new ClientResponseError(new Error("Not in a browser context - please pass a custom urlCallback function."));
    let t2 = 1024, s2 = 768, i2 = window.innerWidth, n2 = window.innerHeight;
    t2 = t2 > i2 ? i2 : t2, s2 = s2 > n2 ? n2 : s2;
    let r2 = i2 / 2 - t2 / 2, o = n2 / 2 - s2 / 2;
    return window.open(e2, "popup_window", "width=" + t2 + ",height=" + s2 + ",top=" + o + ",left=" + r2 + ",resizable,menubar=no");
  }
  var CollectionService = class extends CrudService {
    get baseCrudPath() {
      return "/api/collections";
    }
    async import(e2, t2 = false, s2) {
      return s2 = Object.assign({ method: "PUT", body: { collections: e2, deleteMissing: t2 } }, s2), this.client.send(this.baseCrudPath + "/import", s2).then(() => true);
    }
    async getScaffolds(e2) {
      return e2 = Object.assign({ method: "GET" }, e2), this.client.send(this.baseCrudPath + "/meta/scaffolds", e2);
    }
    async truncate(e2, t2) {
      return t2 = Object.assign({ method: "DELETE" }, t2), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e2) + "/truncate", t2).then(() => true);
    }
  };
  var LogService = class extends BaseService {
    async getList(e2 = 1, t2 = 30, s2) {
      return (s2 = Object.assign({ method: "GET" }, s2)).query = Object.assign({ page: e2, perPage: t2 }, s2.query), this.client.send("/api/logs", s2);
    }
    async getOne(e2, t2) {
      if (!e2) throw new ClientResponseError({ url: this.client.buildURL("/api/logs/"), status: 404, response: { code: 404, message: "Missing required log id.", data: {} } });
      return t2 = Object.assign({ method: "GET" }, t2), this.client.send("/api/logs/" + encodeURIComponent(e2), t2);
    }
    async getStats(e2) {
      return e2 = Object.assign({ method: "GET" }, e2), this.client.send("/api/logs/stats", e2);
    }
  };
  var HealthService = class extends BaseService {
    async check(e2) {
      return e2 = Object.assign({ method: "GET" }, e2), this.client.send("/api/health", e2);
    }
  };
  var FileService = class extends BaseService {
    getUrl(e2, t2, s2 = {}) {
      return console.warn("Please replace pb.files.getUrl() with pb.files.getURL()"), this.getURL(e2, t2, s2);
    }
    getURL(e2, t2, s2 = {}) {
      if (!t2 || !e2?.id || !e2?.collectionId && !e2?.collectionName) return "";
      const i2 = [];
      i2.push("api"), i2.push("files"), i2.push(encodeURIComponent(e2.collectionId || e2.collectionName)), i2.push(encodeURIComponent(e2.id)), i2.push(encodeURIComponent(t2));
      let n2 = this.client.buildURL(i2.join("/"));
      if (Object.keys(s2).length) {
        false === s2.download && delete s2.download;
        const e3 = new URLSearchParams(s2);
        n2 += (n2.includes("?") ? "&" : "?") + e3;
      }
      return n2;
    }
    async getToken(e2) {
      return e2 = Object.assign({ method: "POST" }, e2), this.client.send("/api/files/token", e2).then((e3) => e3?.token || "");
    }
  };
  var BackupService = class extends BaseService {
    async getFullList(e2) {
      return e2 = Object.assign({ method: "GET" }, e2), this.client.send("/api/backups", e2);
    }
    async create(e2, t2) {
      return t2 = Object.assign({ method: "POST", body: { name: e2 } }, t2), this.client.send("/api/backups", t2).then(() => true);
    }
    async upload(e2, t2) {
      return t2 = Object.assign({ method: "POST", body: e2 }, t2), this.client.send("/api/backups/upload", t2).then(() => true);
    }
    async delete(e2, t2) {
      return t2 = Object.assign({ method: "DELETE" }, t2), this.client.send(`/api/backups/${encodeURIComponent(e2)}`, t2).then(() => true);
    }
    async restore(e2, t2) {
      return t2 = Object.assign({ method: "POST" }, t2), this.client.send(`/api/backups/${encodeURIComponent(e2)}/restore`, t2).then(() => true);
    }
    getDownloadUrl(e2, t2) {
      return console.warn("Please replace pb.backups.getDownloadUrl() with pb.backups.getDownloadURL()"), this.getDownloadURL(e2, t2);
    }
    getDownloadURL(e2, t2) {
      return this.client.buildURL(`/api/backups/${encodeURIComponent(t2)}?token=${encodeURIComponent(e2)}`);
    }
  };
  var CronService = class extends BaseService {
    async getFullList(e2) {
      return e2 = Object.assign({ method: "GET" }, e2), this.client.send("/api/crons", e2);
    }
    async run(e2, t2) {
      return t2 = Object.assign({ method: "POST" }, t2), this.client.send(`/api/crons/${encodeURIComponent(e2)}`, t2).then(() => true);
    }
  };
  function isFile3(e2) {
    return "undefined" != typeof Blob && e2 instanceof Blob || "undefined" != typeof File && e2 instanceof File || null !== e2 && "object" == typeof e2 && e2.uri && ("undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof global && global.HermesInternal);
  }
  function isFormData2(e2) {
    return e2 && ("FormData" === e2.constructor.name || "undefined" != typeof FormData && e2 instanceof FormData);
  }
  function hasFileField(e2) {
    for (const t2 in e2) {
      const s2 = Array.isArray(e2[t2]) ? e2[t2] : [e2[t2]];
      for (const e3 of s2) if (isFile3(e3)) return true;
    }
    return false;
  }
  var r = /^[\-\.\d]+$/;
  function inferFormDataValue(e2) {
    if ("string" != typeof e2) return e2;
    if ("true" == e2) return true;
    if ("false" == e2) return false;
    if (("-" === e2[0] || e2[0] >= "0" && e2[0] <= "9") && r.test(e2)) {
      let t2 = +e2;
      if ("" + t2 === e2) return t2;
    }
    return e2;
  }
  var BatchService = class extends BaseService {
    constructor() {
      super(...arguments), this.requests = [], this.subs = {};
    }
    collection(e2) {
      return this.subs[e2] || (this.subs[e2] = new SubBatchService(this.requests, e2)), this.subs[e2];
    }
    async send(e2) {
      const t2 = new FormData(), s2 = [];
      for (let e3 = 0; e3 < this.requests.length; e3++) {
        const i2 = this.requests[e3];
        if (s2.push({ method: i2.method, url: i2.url, headers: i2.headers, body: i2.json }), i2.files) for (let s3 in i2.files) {
          const n2 = i2.files[s3] || [];
          for (let i3 of n2) t2.append("requests." + e3 + "." + s3, i3);
        }
      }
      return t2.append("@jsonPayload", JSON.stringify({ requests: s2 })), e2 = Object.assign({ method: "POST", body: t2 }, e2), this.client.send("/api/batch", e2);
    }
  };
  var SubBatchService = class {
    constructor(e2, t2) {
      this.requests = [], this.requests = e2, this.collectionIdOrName = t2;
    }
    upsert(e2, t2) {
      t2 = Object.assign({ body: e2 || {} }, t2);
      const s2 = { method: "PUT", url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records" };
      this.prepareRequest(s2, t2), this.requests.push(s2);
    }
    create(e2, t2) {
      t2 = Object.assign({ body: e2 || {} }, t2);
      const s2 = { method: "POST", url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records" };
      this.prepareRequest(s2, t2), this.requests.push(s2);
    }
    update(e2, t2, s2) {
      s2 = Object.assign({ body: t2 || {} }, s2);
      const i2 = { method: "PATCH", url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records/" + encodeURIComponent(e2) };
      this.prepareRequest(i2, s2), this.requests.push(i2);
    }
    delete(e2, t2) {
      t2 = Object.assign({}, t2);
      const s2 = { method: "DELETE", url: "/api/collections/" + encodeURIComponent(this.collectionIdOrName) + "/records/" + encodeURIComponent(e2) };
      this.prepareRequest(s2, t2), this.requests.push(s2);
    }
    prepareRequest(e2, t2) {
      if (normalizeUnknownQueryParams(t2), e2.headers = t2.headers, e2.json = {}, e2.files = {}, void 0 !== t2.query) {
        const s3 = serializeQueryParams(t2.query);
        s3 && (e2.url += (e2.url.includes("?") ? "&" : "?") + s3);
      }
      let s2 = t2.body;
      isFormData2(s2) && (s2 = function convertFormDataToObject(e3) {
        let t3 = {};
        return e3.forEach((e4, s3) => {
          if ("@jsonPayload" === s3 && "string" == typeof e4) try {
            let s4 = JSON.parse(e4);
            Object.assign(t3, s4);
          } catch (e5) {
            console.warn("@jsonPayload error:", e5);
          }
          else void 0 !== t3[s3] ? (Array.isArray(t3[s3]) || (t3[s3] = [t3[s3]]), t3[s3].push(inferFormDataValue(e4))) : t3[s3] = inferFormDataValue(e4);
        }), t3;
      }(s2));
      for (const t3 in s2) {
        const i2 = s2[t3];
        if (isFile3(i2)) e2.files[t3] = e2.files[t3] || [], e2.files[t3].push(i2);
        else if (Array.isArray(i2)) {
          const s3 = [], n2 = [];
          for (const e3 of i2) isFile3(e3) ? s3.push(e3) : n2.push(e3);
          if (s3.length > 0 && s3.length == i2.length) {
            e2.files[t3] = e2.files[t3] || [];
            for (let i3 of s3) e2.files[t3].push(i3);
          } else if (e2.json[t3] = n2, s3.length > 0) {
            let i3 = t3;
            t3.startsWith("+") || t3.endsWith("+") || (i3 += "+"), e2.files[i3] = e2.files[i3] || [];
            for (let t4 of s3) e2.files[i3].push(t4);
          }
        } else e2.json[t3] = i2;
      }
    }
  };
  var Client = class {
    get baseUrl() {
      return this.baseURL;
    }
    set baseUrl(e2) {
      this.baseURL = e2;
    }
    constructor(e2 = "/", t2, s2 = "en-US") {
      this.cancelControllers = {}, this.recordServices = {}, this.enableAutoCancellation = true, this.baseURL = e2, this.lang = s2, t2 ? this.authStore = t2 : "undefined" != typeof window && window.Deno ? this.authStore = new BaseAuthStore() : this.authStore = new LocalAuthStore(), this.collections = new CollectionService(this), this.files = new FileService(this), this.logs = new LogService(this), this.settings = new SettingsService(this), this.realtime = new RealtimeService(this), this.health = new HealthService(this), this.backups = new BackupService(this), this.crons = new CronService(this);
    }
    get admins() {
      return this.collection("_superusers");
    }
    createBatch() {
      return new BatchService(this);
    }
    collection(e2) {
      return this.recordServices[e2] || (this.recordServices[e2] = new RecordService(this, e2)), this.recordServices[e2];
    }
    autoCancellation(e2) {
      return this.enableAutoCancellation = !!e2, this;
    }
    cancelRequest(e2) {
      return this.cancelControllers[e2] && (this.cancelControllers[e2].abort(), delete this.cancelControllers[e2]), this;
    }
    cancelAllRequests() {
      for (let e2 in this.cancelControllers) this.cancelControllers[e2].abort();
      return this.cancelControllers = {}, this;
    }
    filter(e2, t2) {
      if (!t2) return e2;
      for (let s2 in t2) {
        let i2 = t2[s2];
        switch (typeof i2) {
          case "boolean":
          case "number":
            i2 = "" + i2;
            break;
          case "string":
            i2 = "'" + i2.replace(/'/g, "\\'") + "'";
            break;
          default:
            i2 = null === i2 ? "null" : i2 instanceof Date ? "'" + i2.toISOString().replace("T", " ") + "'" : "'" + JSON.stringify(i2).replace(/'/g, "\\'") + "'";
        }
        e2 = e2.replaceAll("{:" + s2 + "}", i2);
      }
      return e2;
    }
    getFileUrl(e2, t2, s2 = {}) {
      return console.warn("Please replace pb.getFileUrl() with pb.files.getURL()"), this.files.getURL(e2, t2, s2);
    }
    buildUrl(e2) {
      return console.warn("Please replace pb.buildUrl() with pb.buildURL()"), this.buildURL(e2);
    }
    buildURL(e2) {
      let t2 = this.baseURL;
      return "undefined" == typeof window || !window.location || t2.startsWith("https://") || t2.startsWith("http://") || (t2 = window.location.origin?.endsWith("/") ? window.location.origin.substring(0, window.location.origin.length - 1) : window.location.origin || "", this.baseURL.startsWith("/") || (t2 += window.location.pathname || "/", t2 += t2.endsWith("/") ? "" : "/"), t2 += this.baseURL), e2 && (t2 += t2.endsWith("/") ? "" : "/", t2 += e2.startsWith("/") ? e2.substring(1) : e2), t2;
    }
    async send(e2, t2) {
      t2 = this.initSendOptions(e2, t2);
      let s2 = this.buildURL(e2);
      if (this.beforeSend) {
        const e3 = Object.assign({}, await this.beforeSend(s2, t2));
        void 0 !== e3.url || void 0 !== e3.options ? (s2 = e3.url || s2, t2 = e3.options || t2) : Object.keys(e3).length && (t2 = e3, console?.warn && console.warn("Deprecated format of beforeSend return: please use `return { url, options }`, instead of `return options`."));
      }
      if (void 0 !== t2.query) {
        const e3 = serializeQueryParams(t2.query);
        e3 && (s2 += (s2.includes("?") ? "&" : "?") + e3), delete t2.query;
      }
      "application/json" == this.getHeader(t2.headers, "Content-Type") && t2.body && "string" != typeof t2.body && (t2.body = JSON.stringify(t2.body));
      return (t2.fetch || fetch)(s2, t2).then(async (e3) => {
        let s3 = {};
        try {
          s3 = await e3.json();
        } catch (e4) {
        }
        if (this.afterSend && (s3 = await this.afterSend(e3, s3, t2)), e3.status >= 400) throw new ClientResponseError({ url: e3.url, status: e3.status, data: s3 });
        return s3;
      }).catch((e3) => {
        throw new ClientResponseError(e3);
      });
    }
    initSendOptions(e2, t2) {
      if ((t2 = Object.assign({ method: "GET" }, t2)).body = function convertToFormDataIfNeeded(e3) {
        if ("undefined" == typeof FormData || void 0 === e3 || "object" != typeof e3 || null === e3 || isFormData2(e3) || !hasFileField(e3)) return e3;
        const t3 = new FormData();
        for (const s2 in e3) {
          const i2 = e3[s2];
          if ("object" != typeof i2 || hasFileField({ data: i2 })) {
            const e4 = Array.isArray(i2) ? i2 : [i2];
            for (let i3 of e4) t3.append(s2, i3);
          } else {
            let e4 = {};
            e4[s2] = i2, t3.append("@jsonPayload", JSON.stringify(e4));
          }
        }
        return t3;
      }(t2.body), normalizeUnknownQueryParams(t2), t2.query = Object.assign({}, t2.params, t2.query), void 0 === t2.requestKey && (false === t2.$autoCancel || false === t2.query.$autoCancel ? t2.requestKey = null : (t2.$cancelKey || t2.query.$cancelKey) && (t2.requestKey = t2.$cancelKey || t2.query.$cancelKey)), delete t2.$autoCancel, delete t2.query.$autoCancel, delete t2.$cancelKey, delete t2.query.$cancelKey, null !== this.getHeader(t2.headers, "Content-Type") || isFormData2(t2.body) || (t2.headers = Object.assign({}, t2.headers, { "Content-Type": "application/json" })), null === this.getHeader(t2.headers, "Accept-Language") && (t2.headers = Object.assign({}, t2.headers, { "Accept-Language": this.lang })), this.authStore.token && null === this.getHeader(t2.headers, "Authorization") && (t2.headers = Object.assign({}, t2.headers, { Authorization: this.authStore.token })), this.enableAutoCancellation && null !== t2.requestKey) {
        const s2 = t2.requestKey || (t2.method || "GET") + e2;
        delete t2.requestKey, this.cancelRequest(s2);
        const i2 = new AbortController();
        this.cancelControllers[s2] = i2, t2.signal = i2.signal;
      }
      return t2;
    }
    getHeader(e2, t2) {
      e2 = e2 || {}, t2 = t2.toLowerCase();
      for (let s2 in e2) if (s2.toLowerCase() == t2) return e2[s2];
      return null;
    }
  };
  var AsyncAuthStore = class extends BaseAuthStore {
    constructor(e2) {
      super(), this.queue = [], this.saveFunc = e2.save, this.clearFunc = e2.clear, this._enqueue(() => this._loadInitial(e2.initial));
    }
    save(e2, t2) {
      super.save(e2, t2);
      let s2 = "";
      try {
        s2 = JSON.stringify({ token: e2, record: t2 });
      } catch (e3) {
        console.warn("AsyncAuthStore: failed to stringify the new state");
      }
      this._enqueue(() => this.saveFunc(s2));
    }
    clear() {
      super.clear(), this.clearFunc ? this._enqueue(() => this.clearFunc()) : this._enqueue(() => this.saveFunc(""));
    }
    async _loadInitial(e2) {
      try {
        if (e2 = await e2) {
          let t2;
          "string" == typeof e2 ? t2 = JSON.parse(e2) || {} : "object" == typeof e2 && (t2 = e2), this.save(t2.token || "", t2.record || t2.model || null);
        }
      } catch (e3) {
      }
    }
    _enqueue(e2) {
      this.queue.push(e2), 1 == this.queue.length && this._dequeue();
    }
    _dequeue() {
      this.queue.length && this.queue[0]().finally(() => {
        this.queue.shift(), this.queue.length && this._dequeue();
      });
    }
  };

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/external.js
  var external_exports = {};
  __export(external_exports, {
    BRAND: () => BRAND2,
    DIRTY: () => DIRTY2,
    EMPTY_PATH: () => EMPTY_PATH2,
    INVALID: () => INVALID2,
    NEVER: () => NEVER2,
    OK: () => OK2,
    ParseStatus: () => ParseStatus2,
    Schema: () => ZodType2,
    ZodAny: () => ZodAny2,
    ZodArray: () => ZodArray2,
    ZodBigInt: () => ZodBigInt2,
    ZodBoolean: () => ZodBoolean2,
    ZodBranded: () => ZodBranded2,
    ZodCatch: () => ZodCatch2,
    ZodDate: () => ZodDate2,
    ZodDefault: () => ZodDefault2,
    ZodDiscriminatedUnion: () => ZodDiscriminatedUnion2,
    ZodEffects: () => ZodEffects2,
    ZodEnum: () => ZodEnum2,
    ZodError: () => ZodError2,
    ZodFirstPartyTypeKind: () => ZodFirstPartyTypeKind2,
    ZodFunction: () => ZodFunction2,
    ZodIntersection: () => ZodIntersection2,
    ZodIssueCode: () => ZodIssueCode2,
    ZodLazy: () => ZodLazy2,
    ZodLiteral: () => ZodLiteral2,
    ZodMap: () => ZodMap2,
    ZodNaN: () => ZodNaN2,
    ZodNativeEnum: () => ZodNativeEnum2,
    ZodNever: () => ZodNever2,
    ZodNull: () => ZodNull2,
    ZodNullable: () => ZodNullable2,
    ZodNumber: () => ZodNumber2,
    ZodObject: () => ZodObject2,
    ZodOptional: () => ZodOptional2,
    ZodParsedType: () => ZodParsedType2,
    ZodPipeline: () => ZodPipeline2,
    ZodPromise: () => ZodPromise2,
    ZodReadonly: () => ZodReadonly2,
    ZodRecord: () => ZodRecord2,
    ZodSchema: () => ZodType2,
    ZodSet: () => ZodSet2,
    ZodString: () => ZodString2,
    ZodSymbol: () => ZodSymbol2,
    ZodTransformer: () => ZodEffects2,
    ZodTuple: () => ZodTuple2,
    ZodType: () => ZodType2,
    ZodUndefined: () => ZodUndefined2,
    ZodUnion: () => ZodUnion2,
    ZodUnknown: () => ZodUnknown2,
    ZodVoid: () => ZodVoid2,
    addIssueToContext: () => addIssueToContext2,
    any: () => anyType2,
    array: () => arrayType2,
    bigint: () => bigIntType2,
    boolean: () => booleanType2,
    coerce: () => coerce2,
    custom: () => custom2,
    date: () => dateType2,
    datetimeRegex: () => datetimeRegex2,
    defaultErrorMap: () => en_default,
    discriminatedUnion: () => discriminatedUnionType2,
    effect: () => effectsType2,
    enum: () => enumType2,
    function: () => functionType2,
    getErrorMap: () => getErrorMap2,
    getParsedType: () => getParsedType2,
    instanceof: () => instanceOfType2,
    intersection: () => intersectionType2,
    isAborted: () => isAborted2,
    isAsync: () => isAsync2,
    isDirty: () => isDirty2,
    isValid: () => isValid3,
    late: () => late2,
    lazy: () => lazyType2,
    literal: () => literalType2,
    makeIssue: () => makeIssue2,
    map: () => mapType2,
    nan: () => nanType2,
    nativeEnum: () => nativeEnumType2,
    never: () => neverType2,
    null: () => nullType2,
    nullable: () => nullableType2,
    number: () => numberType2,
    object: () => objectType2,
    objectUtil: () => objectUtil2,
    oboolean: () => oboolean2,
    onumber: () => onumber2,
    optional: () => optionalType2,
    ostring: () => ostring2,
    pipeline: () => pipelineType2,
    preprocess: () => preprocessType2,
    promise: () => promiseType2,
    quotelessJson: () => quotelessJson2,
    record: () => recordType2,
    set: () => setType2,
    setErrorMap: () => setErrorMap2,
    strictObject: () => strictObjectType2,
    string: () => stringType2,
    symbol: () => symbolType2,
    transformer: () => effectsType2,
    tuple: () => tupleType2,
    undefined: () => undefinedType2,
    union: () => unionType2,
    unknown: () => unknownType2,
    util: () => util2,
    void: () => voidType2
  });

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/util.js
  var util2;
  (function(util3) {
    util3.assertEqual = (_2) => {
    };
    function assertIs(_arg) {
    }
    util3.assertIs = assertIs;
    function assertNever(_x) {
      throw new Error();
    }
    util3.assertNever = assertNever;
    util3.arrayToEnum = (items) => {
      const obj = {};
      for (const item of items) {
        obj[item] = item;
      }
      return obj;
    };
    util3.getValidEnumValues = (obj) => {
      const validKeys = util3.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
      const filtered = {};
      for (const k of validKeys) {
        filtered[k] = obj[k];
      }
      return util3.objectValues(filtered);
    };
    util3.objectValues = (obj) => {
      return util3.objectKeys(obj).map(function(e2) {
        return obj[e2];
      });
    };
    util3.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
      const keys = [];
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          keys.push(key);
        }
      }
      return keys;
    };
    util3.find = (arr, checker) => {
      for (const item of arr) {
        if (checker(item))
          return item;
      }
      return void 0;
    };
    util3.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
      return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util3.joinValues = joinValues;
    util3.jsonStringifyReplacer = (_2, value) => {
      if (typeof value === "bigint") {
        return value.toString();
      }
      return value;
    };
  })(util2 || (util2 = {}));
  var objectUtil2;
  (function(objectUtil3) {
    objectUtil3.mergeShapes = (first, second) => {
      return {
        ...first,
        ...second
        // second overwrites first
      };
    };
  })(objectUtil2 || (objectUtil2 = {}));
  var ZodParsedType2 = util2.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
  ]);
  var getParsedType2 = (data) => {
    const t2 = typeof data;
    switch (t2) {
      case "undefined":
        return ZodParsedType2.undefined;
      case "string":
        return ZodParsedType2.string;
      case "number":
        return Number.isNaN(data) ? ZodParsedType2.nan : ZodParsedType2.number;
      case "boolean":
        return ZodParsedType2.boolean;
      case "function":
        return ZodParsedType2.function;
      case "bigint":
        return ZodParsedType2.bigint;
      case "symbol":
        return ZodParsedType2.symbol;
      case "object":
        if (Array.isArray(data)) {
          return ZodParsedType2.array;
        }
        if (data === null) {
          return ZodParsedType2.null;
        }
        if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
          return ZodParsedType2.promise;
        }
        if (typeof Map !== "undefined" && data instanceof Map) {
          return ZodParsedType2.map;
        }
        if (typeof Set !== "undefined" && data instanceof Set) {
          return ZodParsedType2.set;
        }
        if (typeof Date !== "undefined" && data instanceof Date) {
          return ZodParsedType2.date;
        }
        return ZodParsedType2.object;
      default:
        return ZodParsedType2.unknown;
    }
  };

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/ZodError.js
  var ZodIssueCode2 = util2.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
  ]);
  var quotelessJson2 = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
  };
  var ZodError2 = class _ZodError extends Error {
    get errors() {
      return this.issues;
    }
    constructor(issues) {
      super();
      this.issues = [];
      this.addIssue = (sub) => {
        this.issues = [...this.issues, sub];
      };
      this.addIssues = (subs = []) => {
        this.issues = [...this.issues, ...subs];
      };
      const actualProto = new.target.prototype;
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(this, actualProto);
      } else {
        this.__proto__ = actualProto;
      }
      this.name = "ZodError";
      this.issues = issues;
    }
    format(_mapper) {
      const mapper = _mapper || function(issue) {
        return issue.message;
      };
      const fieldErrors = { _errors: [] };
      const processError = (error) => {
        for (const issue of error.issues) {
          if (issue.code === "invalid_union") {
            issue.unionErrors.map(processError);
          } else if (issue.code === "invalid_return_type") {
            processError(issue.returnTypeError);
          } else if (issue.code === "invalid_arguments") {
            processError(issue.argumentsError);
          } else if (issue.path.length === 0) {
            fieldErrors._errors.push(mapper(issue));
          } else {
            let curr = fieldErrors;
            let i2 = 0;
            while (i2 < issue.path.length) {
              const el = issue.path[i2];
              const terminal = i2 === issue.path.length - 1;
              if (!terminal) {
                curr[el] = curr[el] || { _errors: [] };
              } else {
                curr[el] = curr[el] || { _errors: [] };
                curr[el]._errors.push(mapper(issue));
              }
              curr = curr[el];
              i2++;
            }
          }
        }
      };
      processError(this);
      return fieldErrors;
    }
    static assert(value) {
      if (!(value instanceof _ZodError)) {
        throw new Error(`Not a ZodError: ${value}`);
      }
    }
    toString() {
      return this.message;
    }
    get message() {
      return JSON.stringify(this.issues, util2.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
      return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
      const fieldErrors = {};
      const formErrors = [];
      for (const sub of this.issues) {
        if (sub.path.length > 0) {
          const firstEl = sub.path[0];
          fieldErrors[firstEl] = fieldErrors[firstEl] || [];
          fieldErrors[firstEl].push(mapper(sub));
        } else {
          formErrors.push(mapper(sub));
        }
      }
      return { formErrors, fieldErrors };
    }
    get formErrors() {
      return this.flatten();
    }
  };
  ZodError2.create = (issues) => {
    const error = new ZodError2(issues);
    return error;
  };

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/locales/en.js
  var errorMap2 = (issue, _ctx) => {
    let message;
    switch (issue.code) {
      case ZodIssueCode2.invalid_type:
        if (issue.received === ZodParsedType2.undefined) {
          message = "Required";
        } else {
          message = `Expected ${issue.expected}, received ${issue.received}`;
        }
        break;
      case ZodIssueCode2.invalid_literal:
        message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util2.jsonStringifyReplacer)}`;
        break;
      case ZodIssueCode2.unrecognized_keys:
        message = `Unrecognized key(s) in object: ${util2.joinValues(issue.keys, ", ")}`;
        break;
      case ZodIssueCode2.invalid_union:
        message = `Invalid input`;
        break;
      case ZodIssueCode2.invalid_union_discriminator:
        message = `Invalid discriminator value. Expected ${util2.joinValues(issue.options)}`;
        break;
      case ZodIssueCode2.invalid_enum_value:
        message = `Invalid enum value. Expected ${util2.joinValues(issue.options)}, received '${issue.received}'`;
        break;
      case ZodIssueCode2.invalid_arguments:
        message = `Invalid function arguments`;
        break;
      case ZodIssueCode2.invalid_return_type:
        message = `Invalid function return type`;
        break;
      case ZodIssueCode2.invalid_date:
        message = `Invalid date`;
        break;
      case ZodIssueCode2.invalid_string:
        if (typeof issue.validation === "object") {
          if ("includes" in issue.validation) {
            message = `Invalid input: must include "${issue.validation.includes}"`;
            if (typeof issue.validation.position === "number") {
              message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
            }
          } else if ("startsWith" in issue.validation) {
            message = `Invalid input: must start with "${issue.validation.startsWith}"`;
          } else if ("endsWith" in issue.validation) {
            message = `Invalid input: must end with "${issue.validation.endsWith}"`;
          } else {
            util2.assertNever(issue.validation);
          }
        } else if (issue.validation !== "regex") {
          message = `Invalid ${issue.validation}`;
        } else {
          message = "Invalid";
        }
        break;
      case ZodIssueCode2.too_small:
        if (issue.type === "array")
          message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
        else if (issue.type === "string")
          message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
        else if (issue.type === "number")
          message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
        else if (issue.type === "bigint")
          message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
        else if (issue.type === "date")
          message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
        else
          message = "Invalid input";
        break;
      case ZodIssueCode2.too_big:
        if (issue.type === "array")
          message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
        else if (issue.type === "string")
          message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
        else if (issue.type === "number")
          message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
        else if (issue.type === "bigint")
          message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
        else if (issue.type === "date")
          message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
        else
          message = "Invalid input";
        break;
      case ZodIssueCode2.custom:
        message = `Invalid input`;
        break;
      case ZodIssueCode2.invalid_intersection_types:
        message = `Intersection results could not be merged`;
        break;
      case ZodIssueCode2.not_multiple_of:
        message = `Number must be a multiple of ${issue.multipleOf}`;
        break;
      case ZodIssueCode2.not_finite:
        message = "Number must be finite";
        break;
      default:
        message = _ctx.defaultError;
        util2.assertNever(issue);
    }
    return { message };
  };
  var en_default = errorMap2;

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/errors.js
  var overrideErrorMap2 = en_default;
  function setErrorMap2(map) {
    overrideErrorMap2 = map;
  }
  function getErrorMap2() {
    return overrideErrorMap2;
  }

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/parseUtil.js
  var makeIssue2 = (params) => {
    const { data, path: path3, errorMaps, issueData } = params;
    const fullPath = [...path3, ...issueData.path || []];
    const fullIssue = {
      ...issueData,
      path: fullPath
    };
    if (issueData.message !== void 0) {
      return {
        ...issueData,
        path: fullPath,
        message: issueData.message
      };
    }
    let errorMessage = "";
    const maps = errorMaps.filter((m) => !!m).slice().reverse();
    for (const map of maps) {
      errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
      ...issueData,
      path: fullPath,
      message: errorMessage
    };
  };
  var EMPTY_PATH2 = [];
  function addIssueToContext2(ctx, issueData) {
    const overrideMap = getErrorMap2();
    const issue = makeIssue2({
      issueData,
      data: ctx.data,
      path: ctx.path,
      errorMaps: [
        ctx.common.contextualErrorMap,
        // contextual error map is first priority
        ctx.schemaErrorMap,
        // then schema-bound map if available
        overrideMap,
        // then global override map
        overrideMap === en_default ? void 0 : en_default
        // then global default map
      ].filter((x) => !!x)
    });
    ctx.common.issues.push(issue);
  }
  var ParseStatus2 = class _ParseStatus {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      if (this.value === "valid")
        this.value = "dirty";
    }
    abort() {
      if (this.value !== "aborted")
        this.value = "aborted";
    }
    static mergeArray(status, results) {
      const arrayValue = [];
      for (const s2 of results) {
        if (s2.status === "aborted")
          return INVALID2;
        if (s2.status === "dirty")
          status.dirty();
        arrayValue.push(s2.value);
      }
      return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
      const syncPairs = [];
      for (const pair of pairs) {
        const key = await pair.key;
        const value = await pair.value;
        syncPairs.push({
          key,
          value
        });
      }
      return _ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
      const finalObject = {};
      for (const pair of pairs) {
        const { key, value } = pair;
        if (key.status === "aborted")
          return INVALID2;
        if (value.status === "aborted")
          return INVALID2;
        if (key.status === "dirty")
          status.dirty();
        if (value.status === "dirty")
          status.dirty();
        if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
          finalObject[key.value] = value.value;
        }
      }
      return { status: status.value, value: finalObject };
    }
  };
  var INVALID2 = Object.freeze({
    status: "aborted"
  });
  var DIRTY2 = (value) => ({ status: "dirty", value });
  var OK2 = (value) => ({ status: "valid", value });
  var isAborted2 = (x) => x.status === "aborted";
  var isDirty2 = (x) => x.status === "dirty";
  var isValid3 = (x) => x.status === "valid";
  var isAsync2 = (x) => typeof Promise !== "undefined" && x instanceof Promise;

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/errorUtil.js
  var errorUtil2;
  (function(errorUtil3) {
    errorUtil3.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil3.toString = (message) => typeof message === "string" ? message : message?.message;
  })(errorUtil2 || (errorUtil2 = {}));

  // ../../node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/types.js
  var ParseInputLazyPath2 = class {
    constructor(parent, value, path3, key) {
      this._cachedPath = [];
      this.parent = parent;
      this.data = value;
      this._path = path3;
      this._key = key;
    }
    get path() {
      if (!this._cachedPath.length) {
        if (Array.isArray(this._key)) {
          this._cachedPath.push(...this._path, ...this._key);
        } else {
          this._cachedPath.push(...this._path, this._key);
        }
      }
      return this._cachedPath;
    }
  };
  var handleResult2 = (ctx, result) => {
    if (isValid3(result)) {
      return { success: true, data: result.value };
    } else {
      if (!ctx.common.issues.length) {
        throw new Error("Validation failed but no issues detected.");
      }
      return {
        success: false,
        get error() {
          if (this._error)
            return this._error;
          const error = new ZodError2(ctx.common.issues);
          this._error = error;
          return this._error;
        }
      };
    }
  };
  function processCreateParams2(params) {
    if (!params)
      return {};
    const { errorMap: errorMap3, invalid_type_error, required_error, description } = params;
    if (errorMap3 && (invalid_type_error || required_error)) {
      throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap3)
      return { errorMap: errorMap3, description };
    const customMap = (iss, ctx) => {
      const { message } = params;
      if (iss.code === "invalid_enum_value") {
        return { message: message ?? ctx.defaultError };
      }
      if (typeof ctx.data === "undefined") {
        return { message: message ?? required_error ?? ctx.defaultError };
      }
      if (iss.code !== "invalid_type")
        return { message: ctx.defaultError };
      return { message: message ?? invalid_type_error ?? ctx.defaultError };
    };
    return { errorMap: customMap, description };
  }
  var ZodType2 = class {
    get description() {
      return this._def.description;
    }
    _getType(input) {
      return getParsedType2(input.data);
    }
    _getOrReturnCtx(input, ctx) {
      return ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType2(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      };
    }
    _processInputParams(input) {
      return {
        status: new ParseStatus2(),
        ctx: {
          common: input.parent.common,
          data: input.data,
          parsedType: getParsedType2(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        }
      };
    }
    _parseSync(input) {
      const result = this._parse(input);
      if (isAsync2(result)) {
        throw new Error("Synchronous parse encountered promise.");
      }
      return result;
    }
    _parseAsync(input) {
      const result = this._parse(input);
      return Promise.resolve(result);
    }
    parse(data, params) {
      const result = this.safeParse(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    }
    safeParse(data, params) {
      const ctx = {
        common: {
          issues: [],
          async: params?.async ?? false,
          contextualErrorMap: params?.errorMap
        },
        path: params?.path || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType2(data)
      };
      const result = this._parseSync({ data, path: ctx.path, parent: ctx });
      return handleResult2(ctx, result);
    }
    "~validate"(data) {
      const ctx = {
        common: {
          issues: [],
          async: !!this["~standard"].async
        },
        path: [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType2(data)
      };
      if (!this["~standard"].async) {
        try {
          const result = this._parseSync({ data, path: [], parent: ctx });
          return isValid3(result) ? {
            value: result.value
          } : {
            issues: ctx.common.issues
          };
        } catch (err3) {
          if (err3?.message?.toLowerCase()?.includes("encountered")) {
            this["~standard"].async = true;
          }
          ctx.common = {
            issues: [],
            async: true
          };
        }
      }
      return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid3(result) ? {
        value: result.value
      } : {
        issues: ctx.common.issues
      });
    }
    async parseAsync(data, params) {
      const result = await this.safeParseAsync(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    }
    async safeParseAsync(data, params) {
      const ctx = {
        common: {
          issues: [],
          contextualErrorMap: params?.errorMap,
          async: true
        },
        path: params?.path || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType2(data)
      };
      const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
      const result = await (isAsync2(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
      return handleResult2(ctx, result);
    }
    refine(check, message) {
      const getIssueProperties = (val) => {
        if (typeof message === "string" || typeof message === "undefined") {
          return { message };
        } else if (typeof message === "function") {
          return message(val);
        } else {
          return message;
        }
      };
      return this._refinement((val, ctx) => {
        const result = check(val);
        const setError = () => ctx.addIssue({
          code: ZodIssueCode2.custom,
          ...getIssueProperties(val)
        });
        if (typeof Promise !== "undefined" && result instanceof Promise) {
          return result.then((data) => {
            if (!data) {
              setError();
              return false;
            } else {
              return true;
            }
          });
        }
        if (!result) {
          setError();
          return false;
        } else {
          return true;
        }
      });
    }
    refinement(check, refinementData) {
      return this._refinement((val, ctx) => {
        if (!check(val)) {
          ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
          return false;
        } else {
          return true;
        }
      });
    }
    _refinement(refinement) {
      return new ZodEffects2({
        schema: this,
        typeName: ZodFirstPartyTypeKind2.ZodEffects,
        effect: { type: "refinement", refinement }
      });
    }
    superRefine(refinement) {
      return this._refinement(refinement);
    }
    constructor(def) {
      this.spa = this.safeParseAsync;
      this._def = def;
      this.parse = this.parse.bind(this);
      this.safeParse = this.safeParse.bind(this);
      this.parseAsync = this.parseAsync.bind(this);
      this.safeParseAsync = this.safeParseAsync.bind(this);
      this.spa = this.spa.bind(this);
      this.refine = this.refine.bind(this);
      this.refinement = this.refinement.bind(this);
      this.superRefine = this.superRefine.bind(this);
      this.optional = this.optional.bind(this);
      this.nullable = this.nullable.bind(this);
      this.nullish = this.nullish.bind(this);
      this.array = this.array.bind(this);
      this.promise = this.promise.bind(this);
      this.or = this.or.bind(this);
      this.and = this.and.bind(this);
      this.transform = this.transform.bind(this);
      this.brand = this.brand.bind(this);
      this.default = this.default.bind(this);
      this.catch = this.catch.bind(this);
      this.describe = this.describe.bind(this);
      this.pipe = this.pipe.bind(this);
      this.readonly = this.readonly.bind(this);
      this.isNullable = this.isNullable.bind(this);
      this.isOptional = this.isOptional.bind(this);
      this["~standard"] = {
        version: 1,
        vendor: "zod",
        validate: (data) => this["~validate"](data)
      };
    }
    optional() {
      return ZodOptional2.create(this, this._def);
    }
    nullable() {
      return ZodNullable2.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return ZodArray2.create(this);
    }
    promise() {
      return ZodPromise2.create(this, this._def);
    }
    or(option) {
      return ZodUnion2.create([this, option], this._def);
    }
    and(incoming) {
      return ZodIntersection2.create(this, incoming, this._def);
    }
    transform(transform) {
      return new ZodEffects2({
        ...processCreateParams2(this._def),
        schema: this,
        typeName: ZodFirstPartyTypeKind2.ZodEffects,
        effect: { type: "transform", transform }
      });
    }
    default(def) {
      const defaultValueFunc = typeof def === "function" ? def : () => def;
      return new ZodDefault2({
        ...processCreateParams2(this._def),
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind2.ZodDefault
      });
    }
    brand() {
      return new ZodBranded2({
        typeName: ZodFirstPartyTypeKind2.ZodBranded,
        type: this,
        ...processCreateParams2(this._def)
      });
    }
    catch(def) {
      const catchValueFunc = typeof def === "function" ? def : () => def;
      return new ZodCatch2({
        ...processCreateParams2(this._def),
        innerType: this,
        catchValue: catchValueFunc,
        typeName: ZodFirstPartyTypeKind2.ZodCatch
      });
    }
    describe(description) {
      const This = this.constructor;
      return new This({
        ...this._def,
        description
      });
    }
    pipe(target) {
      return ZodPipeline2.create(this, target);
    }
    readonly() {
      return ZodReadonly2.create(this);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  };
  var cuidRegex2 = /^c[^\s-]{8,}$/i;
  var cuid2Regex2 = /^[0-9a-z]+$/;
  var ulidRegex2 = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
  var uuidRegex2 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
  var nanoidRegex2 = /^[a-z0-9_-]{21}$/i;
  var jwtRegex2 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
  var durationRegex2 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
  var emailRegex2 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
  var _emojiRegex2 = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
  var emojiRegex2;
  var ipv4Regex2 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
  var ipv4CidrRegex2 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
  var ipv6Regex2 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
  var ipv6CidrRegex2 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
  var base64Regex2 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  var base64urlRegex2 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
  var dateRegexSource2 = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
  var dateRegex2 = new RegExp(`^${dateRegexSource2}$`);
  function timeRegexSource2(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) {
      secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    } else if (args.precision == null) {
      secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    }
    const secondsQuantifier = args.precision ? "+" : "?";
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
  }
  function timeRegex2(args) {
    return new RegExp(`^${timeRegexSource2(args)}$`);
  }
  function datetimeRegex2(args) {
    let regex = `${dateRegexSource2}T${timeRegexSource2(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset)
      opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
  }
  function isValidIP2(ip, version17) {
    if ((version17 === "v4" || !version17) && ipv4Regex2.test(ip)) {
      return true;
    }
    if ((version17 === "v6" || !version17) && ipv6Regex2.test(ip)) {
      return true;
    }
    return false;
  }
  function isValidJWT2(jwt, alg) {
    if (!jwtRegex2.test(jwt))
      return false;
    try {
      const [header] = jwt.split(".");
      if (!header)
        return false;
      const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
      const decoded = JSON.parse(atob(base64));
      if (typeof decoded !== "object" || decoded === null)
        return false;
      if ("typ" in decoded && decoded?.typ !== "JWT")
        return false;
      if (!decoded.alg)
        return false;
      if (alg && decoded.alg !== alg)
        return false;
      return true;
    } catch {
      return false;
    }
  }
  function isValidCidr2(ip, version17) {
    if ((version17 === "v4" || !version17) && ipv4CidrRegex2.test(ip)) {
      return true;
    }
    if ((version17 === "v6" || !version17) && ipv6CidrRegex2.test(ip)) {
      return true;
    }
    return false;
  }
  var ZodString2 = class _ZodString extends ZodType2 {
    _parse(input) {
      if (this._def.coerce) {
        input.data = String(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.string) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext2(ctx2, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.string,
          received: ctx2.parsedType
        });
        return INVALID2;
      }
      const status = new ParseStatus2();
      let ctx = void 0;
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          if (input.data.length < check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          if (input.data.length > check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "length") {
          const tooBig = input.data.length > check.value;
          const tooSmall = input.data.length < check.value;
          if (tooBig || tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            if (tooBig) {
              addIssueToContext2(ctx, {
                code: ZodIssueCode2.too_big,
                maximum: check.value,
                type: "string",
                inclusive: true,
                exact: true,
                message: check.message
              });
            } else if (tooSmall) {
              addIssueToContext2(ctx, {
                code: ZodIssueCode2.too_small,
                minimum: check.value,
                type: "string",
                inclusive: true,
                exact: true,
                message: check.message
              });
            }
            status.dirty();
          }
        } else if (check.kind === "email") {
          if (!emailRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "email",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "emoji") {
          if (!emojiRegex2) {
            emojiRegex2 = new RegExp(_emojiRegex2, "u");
          }
          if (!emojiRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "emoji",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "uuid") {
          if (!uuidRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "uuid",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "nanoid") {
          if (!nanoidRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "nanoid",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cuid") {
          if (!cuidRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "cuid",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cuid2") {
          if (!cuid2Regex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "cuid2",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "ulid") {
          if (!ulidRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "ulid",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "url") {
          try {
            new URL(input.data);
          } catch {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "url",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "regex") {
          check.regex.lastIndex = 0;
          const testResult = check.regex.test(input.data);
          if (!testResult) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "regex",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "trim") {
          input.data = input.data.trim();
        } else if (check.kind === "includes") {
          if (!input.data.includes(check.value, check.position)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_string,
              validation: { includes: check.value, position: check.position },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "toLowerCase") {
          input.data = input.data.toLowerCase();
        } else if (check.kind === "toUpperCase") {
          input.data = input.data.toUpperCase();
        } else if (check.kind === "startsWith") {
          if (!input.data.startsWith(check.value)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_string,
              validation: { startsWith: check.value },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "endsWith") {
          if (!input.data.endsWith(check.value)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_string,
              validation: { endsWith: check.value },
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "datetime") {
          const regex = datetimeRegex2(check);
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_string,
              validation: "datetime",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "date") {
          const regex = dateRegex2;
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_string,
              validation: "date",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "time") {
          const regex = timeRegex2(check);
          if (!regex.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_string,
              validation: "time",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "duration") {
          if (!durationRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "duration",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "ip") {
          if (!isValidIP2(input.data, check.version)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "ip",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "jwt") {
          if (!isValidJWT2(input.data, check.alg)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "jwt",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "cidr") {
          if (!isValidCidr2(input.data, check.version)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "cidr",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "base64") {
          if (!base64Regex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "base64",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "base64url") {
          if (!base64urlRegex2.test(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              validation: "base64url",
              code: ZodIssueCode2.invalid_string,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util2.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
      return this.refinement((data) => regex.test(data), {
        validation,
        code: ZodIssueCode2.invalid_string,
        ...errorUtil2.errToObj(message)
      });
    }
    _addCheck(check) {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    email(message) {
      return this._addCheck({ kind: "email", ...errorUtil2.errToObj(message) });
    }
    url(message) {
      return this._addCheck({ kind: "url", ...errorUtil2.errToObj(message) });
    }
    emoji(message) {
      return this._addCheck({ kind: "emoji", ...errorUtil2.errToObj(message) });
    }
    uuid(message) {
      return this._addCheck({ kind: "uuid", ...errorUtil2.errToObj(message) });
    }
    nanoid(message) {
      return this._addCheck({ kind: "nanoid", ...errorUtil2.errToObj(message) });
    }
    cuid(message) {
      return this._addCheck({ kind: "cuid", ...errorUtil2.errToObj(message) });
    }
    cuid2(message) {
      return this._addCheck({ kind: "cuid2", ...errorUtil2.errToObj(message) });
    }
    ulid(message) {
      return this._addCheck({ kind: "ulid", ...errorUtil2.errToObj(message) });
    }
    base64(message) {
      return this._addCheck({ kind: "base64", ...errorUtil2.errToObj(message) });
    }
    base64url(message) {
      return this._addCheck({
        kind: "base64url",
        ...errorUtil2.errToObj(message)
      });
    }
    jwt(options) {
      return this._addCheck({ kind: "jwt", ...errorUtil2.errToObj(options) });
    }
    ip(options) {
      return this._addCheck({ kind: "ip", ...errorUtil2.errToObj(options) });
    }
    cidr(options) {
      return this._addCheck({ kind: "cidr", ...errorUtil2.errToObj(options) });
    }
    datetime(options) {
      if (typeof options === "string") {
        return this._addCheck({
          kind: "datetime",
          precision: null,
          offset: false,
          local: false,
          message: options
        });
      }
      return this._addCheck({
        kind: "datetime",
        precision: typeof options?.precision === "undefined" ? null : options?.precision,
        offset: options?.offset ?? false,
        local: options?.local ?? false,
        ...errorUtil2.errToObj(options?.message)
      });
    }
    date(message) {
      return this._addCheck({ kind: "date", message });
    }
    time(options) {
      if (typeof options === "string") {
        return this._addCheck({
          kind: "time",
          precision: null,
          message: options
        });
      }
      return this._addCheck({
        kind: "time",
        precision: typeof options?.precision === "undefined" ? null : options?.precision,
        ...errorUtil2.errToObj(options?.message)
      });
    }
    duration(message) {
      return this._addCheck({ kind: "duration", ...errorUtil2.errToObj(message) });
    }
    regex(regex, message) {
      return this._addCheck({
        kind: "regex",
        regex,
        ...errorUtil2.errToObj(message)
      });
    }
    includes(value, options) {
      return this._addCheck({
        kind: "includes",
        value,
        position: options?.position,
        ...errorUtil2.errToObj(options?.message)
      });
    }
    startsWith(value, message) {
      return this._addCheck({
        kind: "startsWith",
        value,
        ...errorUtil2.errToObj(message)
      });
    }
    endsWith(value, message) {
      return this._addCheck({
        kind: "endsWith",
        value,
        ...errorUtil2.errToObj(message)
      });
    }
    min(minLength, message) {
      return this._addCheck({
        kind: "min",
        value: minLength,
        ...errorUtil2.errToObj(message)
      });
    }
    max(maxLength, message) {
      return this._addCheck({
        kind: "max",
        value: maxLength,
        ...errorUtil2.errToObj(message)
      });
    }
    length(len, message) {
      return this._addCheck({
        kind: "length",
        value: len,
        ...errorUtil2.errToObj(message)
      });
    }
    /**
     * Equivalent to `.min(1)`
     */
    nonempty(message) {
      return this.min(1, errorUtil2.errToObj(message));
    }
    trim() {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }]
      });
    }
    toLowerCase() {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "toLowerCase" }]
      });
    }
    toUpperCase() {
      return new _ZodString({
        ...this._def,
        checks: [...this._def.checks, { kind: "toUpperCase" }]
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isDate() {
      return !!this._def.checks.find((ch) => ch.kind === "date");
    }
    get isTime() {
      return !!this._def.checks.find((ch) => ch.kind === "time");
    }
    get isDuration() {
      return !!this._def.checks.find((ch) => ch.kind === "duration");
    }
    get isEmail() {
      return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
      return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
      return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isNANOID() {
      return !!this._def.checks.find((ch) => ch.kind === "nanoid");
    }
    get isCUID() {
      return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
      return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
      return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
      return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get isCIDR() {
      return !!this._def.checks.find((ch) => ch.kind === "cidr");
    }
    get isBase64() {
      return !!this._def.checks.find((ch) => ch.kind === "base64");
    }
    get isBase64url() {
      return !!this._def.checks.find((ch) => ch.kind === "base64url");
    }
    get minLength() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxLength() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2;
    }
  };
  ZodString2.create = (params) => {
    return new ZodString2({
      checks: [],
      typeName: ZodFirstPartyTypeKind2.ZodString,
      coerce: params?.coerce ?? false,
      ...processCreateParams2(params)
    });
  };
  function floatSafeRemainder2(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
  }
  var ZodNumber2 = class _ZodNumber extends ZodType2 {
    constructor() {
      super(...arguments);
      this.min = this.gte;
      this.max = this.lte;
      this.step = this.multipleOf;
    }
    _parse(input) {
      if (this._def.coerce) {
        input.data = Number(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.number) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext2(ctx2, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.number,
          received: ctx2.parsedType
        });
        return INVALID2;
      }
      let ctx = void 0;
      const status = new ParseStatus2();
      for (const check of this._def.checks) {
        if (check.kind === "int") {
          if (!util2.isInteger(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.invalid_type,
              expected: "integer",
              received: "float",
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "min") {
          const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
          if (tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_small,
              minimum: check.value,
              type: "number",
              inclusive: check.inclusive,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
          if (tooBig) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_big,
              maximum: check.value,
              type: "number",
              inclusive: check.inclusive,
              exact: false,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "multipleOf") {
          if (floatSafeRemainder2(input.data, check.value) !== 0) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.not_multiple_of,
              multipleOf: check.value,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "finite") {
          if (!Number.isFinite(input.data)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.not_finite,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util2.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    gte(value, message) {
      return this.setLimit("min", value, true, errorUtil2.toString(message));
    }
    gt(value, message) {
      return this.setLimit("min", value, false, errorUtil2.toString(message));
    }
    lte(value, message) {
      return this.setLimit("max", value, true, errorUtil2.toString(message));
    }
    lt(value, message) {
      return this.setLimit("max", value, false, errorUtil2.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
      return new _ZodNumber({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind,
            value,
            inclusive,
            message: errorUtil2.toString(message)
          }
        ]
      });
    }
    _addCheck(check) {
      return new _ZodNumber({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    int(message) {
      return this._addCheck({
        kind: "int",
        message: errorUtil2.toString(message)
      });
    }
    positive(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: false,
        message: errorUtil2.toString(message)
      });
    }
    negative(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: false,
        message: errorUtil2.toString(message)
      });
    }
    nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: true,
        message: errorUtil2.toString(message)
      });
    }
    nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: true,
        message: errorUtil2.toString(message)
      });
    }
    multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value,
        message: errorUtil2.toString(message)
      });
    }
    finite(message) {
      return this._addCheck({
        kind: "finite",
        message: errorUtil2.toString(message)
      });
    }
    safe(message) {
      return this._addCheck({
        kind: "min",
        inclusive: true,
        value: Number.MIN_SAFE_INTEGER,
        message: errorUtil2.toString(message)
      })._addCheck({
        kind: "max",
        inclusive: true,
        value: Number.MAX_SAFE_INTEGER,
        message: errorUtil2.toString(message)
      });
    }
    get minValue() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxValue() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2;
    }
    get isInt() {
      return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util2.isInteger(ch.value));
    }
    get isFinite() {
      let max2 = null;
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
          return true;
        } else if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        } else if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return Number.isFinite(min) && Number.isFinite(max2);
    }
  };
  ZodNumber2.create = (params) => {
    return new ZodNumber2({
      checks: [],
      typeName: ZodFirstPartyTypeKind2.ZodNumber,
      coerce: params?.coerce || false,
      ...processCreateParams2(params)
    });
  };
  var ZodBigInt2 = class _ZodBigInt extends ZodType2 {
    constructor() {
      super(...arguments);
      this.min = this.gte;
      this.max = this.lte;
    }
    _parse(input) {
      if (this._def.coerce) {
        try {
          input.data = BigInt(input.data);
        } catch {
          return this._getInvalidInput(input);
        }
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.bigint) {
        return this._getInvalidInput(input);
      }
      let ctx = void 0;
      const status = new ParseStatus2();
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
          if (tooSmall) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_small,
              type: "bigint",
              minimum: check.value,
              inclusive: check.inclusive,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
          if (tooBig) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_big,
              type: "bigint",
              maximum: check.value,
              inclusive: check.inclusive,
              message: check.message
            });
            status.dirty();
          }
        } else if (check.kind === "multipleOf") {
          if (input.data % check.value !== BigInt(0)) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.not_multiple_of,
              multipleOf: check.value,
              message: check.message
            });
            status.dirty();
          }
        } else {
          util2.assertNever(check);
        }
      }
      return { status: status.value, value: input.data };
    }
    _getInvalidInput(input) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext2(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType2.bigint,
        received: ctx.parsedType
      });
      return INVALID2;
    }
    gte(value, message) {
      return this.setLimit("min", value, true, errorUtil2.toString(message));
    }
    gt(value, message) {
      return this.setLimit("min", value, false, errorUtil2.toString(message));
    }
    lte(value, message) {
      return this.setLimit("max", value, true, errorUtil2.toString(message));
    }
    lt(value, message) {
      return this.setLimit("max", value, false, errorUtil2.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
      return new _ZodBigInt({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind,
            value,
            inclusive,
            message: errorUtil2.toString(message)
          }
        ]
      });
    }
    _addCheck(check) {
      return new _ZodBigInt({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    positive(message) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: false,
        message: errorUtil2.toString(message)
      });
    }
    negative(message) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: false,
        message: errorUtil2.toString(message)
      });
    }
    nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: true,
        message: errorUtil2.toString(message)
      });
    }
    nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: true,
        message: errorUtil2.toString(message)
      });
    }
    multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value,
        message: errorUtil2.toString(message)
      });
    }
    get minValue() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min;
    }
    get maxValue() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2;
    }
  };
  ZodBigInt2.create = (params) => {
    return new ZodBigInt2({
      checks: [],
      typeName: ZodFirstPartyTypeKind2.ZodBigInt,
      coerce: params?.coerce ?? false,
      ...processCreateParams2(params)
    });
  };
  var ZodBoolean2 = class extends ZodType2 {
    _parse(input) {
      if (this._def.coerce) {
        input.data = Boolean(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.boolean) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.boolean,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
  };
  ZodBoolean2.create = (params) => {
    return new ZodBoolean2({
      typeName: ZodFirstPartyTypeKind2.ZodBoolean,
      coerce: params?.coerce || false,
      ...processCreateParams2(params)
    });
  };
  var ZodDate2 = class _ZodDate extends ZodType2 {
    _parse(input) {
      if (this._def.coerce) {
        input.data = new Date(input.data);
      }
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.date) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext2(ctx2, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.date,
          received: ctx2.parsedType
        });
        return INVALID2;
      }
      if (Number.isNaN(input.data.getTime())) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext2(ctx2, {
          code: ZodIssueCode2.invalid_date
        });
        return INVALID2;
      }
      const status = new ParseStatus2();
      let ctx = void 0;
      for (const check of this._def.checks) {
        if (check.kind === "min") {
          if (input.data.getTime() < check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_small,
              message: check.message,
              inclusive: true,
              exact: false,
              minimum: check.value,
              type: "date"
            });
            status.dirty();
          }
        } else if (check.kind === "max") {
          if (input.data.getTime() > check.value) {
            ctx = this._getOrReturnCtx(input, ctx);
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.too_big,
              message: check.message,
              inclusive: true,
              exact: false,
              maximum: check.value,
              type: "date"
            });
            status.dirty();
          }
        } else {
          util2.assertNever(check);
        }
      }
      return {
        status: status.value,
        value: new Date(input.data.getTime())
      };
    }
    _addCheck(check) {
      return new _ZodDate({
        ...this._def,
        checks: [...this._def.checks, check]
      });
    }
    min(minDate, message) {
      return this._addCheck({
        kind: "min",
        value: minDate.getTime(),
        message: errorUtil2.toString(message)
      });
    }
    max(maxDate, message) {
      return this._addCheck({
        kind: "max",
        value: maxDate.getTime(),
        message: errorUtil2.toString(message)
      });
    }
    get minDate() {
      let min = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min)
            min = ch.value;
        }
      }
      return min != null ? new Date(min) : null;
    }
    get maxDate() {
      let max2 = null;
      for (const ch of this._def.checks) {
        if (ch.kind === "max") {
          if (max2 === null || ch.value < max2)
            max2 = ch.value;
        }
      }
      return max2 != null ? new Date(max2) : null;
    }
  };
  ZodDate2.create = (params) => {
    return new ZodDate2({
      checks: [],
      coerce: params?.coerce || false,
      typeName: ZodFirstPartyTypeKind2.ZodDate,
      ...processCreateParams2(params)
    });
  };
  var ZodSymbol2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.symbol) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.symbol,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
  };
  ZodSymbol2.create = (params) => {
    return new ZodSymbol2({
      typeName: ZodFirstPartyTypeKind2.ZodSymbol,
      ...processCreateParams2(params)
    });
  };
  var ZodUndefined2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.undefined) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.undefined,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
  };
  ZodUndefined2.create = (params) => {
    return new ZodUndefined2({
      typeName: ZodFirstPartyTypeKind2.ZodUndefined,
      ...processCreateParams2(params)
    });
  };
  var ZodNull2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.null) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.null,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
  };
  ZodNull2.create = (params) => {
    return new ZodNull2({
      typeName: ZodFirstPartyTypeKind2.ZodNull,
      ...processCreateParams2(params)
    });
  };
  var ZodAny2 = class extends ZodType2 {
    constructor() {
      super(...arguments);
      this._any = true;
    }
    _parse(input) {
      return OK2(input.data);
    }
  };
  ZodAny2.create = (params) => {
    return new ZodAny2({
      typeName: ZodFirstPartyTypeKind2.ZodAny,
      ...processCreateParams2(params)
    });
  };
  var ZodUnknown2 = class extends ZodType2 {
    constructor() {
      super(...arguments);
      this._unknown = true;
    }
    _parse(input) {
      return OK2(input.data);
    }
  };
  ZodUnknown2.create = (params) => {
    return new ZodUnknown2({
      typeName: ZodFirstPartyTypeKind2.ZodUnknown,
      ...processCreateParams2(params)
    });
  };
  var ZodNever2 = class extends ZodType2 {
    _parse(input) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext2(ctx, {
        code: ZodIssueCode2.invalid_type,
        expected: ZodParsedType2.never,
        received: ctx.parsedType
      });
      return INVALID2;
    }
  };
  ZodNever2.create = (params) => {
    return new ZodNever2({
      typeName: ZodFirstPartyTypeKind2.ZodNever,
      ...processCreateParams2(params)
    });
  };
  var ZodVoid2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.undefined) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.void,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
  };
  ZodVoid2.create = (params) => {
    return new ZodVoid2({
      typeName: ZodFirstPartyTypeKind2.ZodVoid,
      ...processCreateParams2(params)
    });
  };
  var ZodArray2 = class _ZodArray extends ZodType2 {
    _parse(input) {
      const { ctx, status } = this._processInputParams(input);
      const def = this._def;
      if (ctx.parsedType !== ZodParsedType2.array) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.array,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      if (def.exactLength !== null) {
        const tooBig = ctx.data.length > def.exactLength.value;
        const tooSmall = ctx.data.length < def.exactLength.value;
        if (tooBig || tooSmall) {
          addIssueToContext2(ctx, {
            code: tooBig ? ZodIssueCode2.too_big : ZodIssueCode2.too_small,
            minimum: tooSmall ? def.exactLength.value : void 0,
            maximum: tooBig ? def.exactLength.value : void 0,
            type: "array",
            inclusive: true,
            exact: true,
            message: def.exactLength.message
          });
          status.dirty();
        }
      }
      if (def.minLength !== null) {
        if (ctx.data.length < def.minLength.value) {
          addIssueToContext2(ctx, {
            code: ZodIssueCode2.too_small,
            minimum: def.minLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.minLength.message
          });
          status.dirty();
        }
      }
      if (def.maxLength !== null) {
        if (ctx.data.length > def.maxLength.value) {
          addIssueToContext2(ctx, {
            code: ZodIssueCode2.too_big,
            maximum: def.maxLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.maxLength.message
          });
          status.dirty();
        }
      }
      if (ctx.common.async) {
        return Promise.all([...ctx.data].map((item, i2) => {
          return def.type._parseAsync(new ParseInputLazyPath2(ctx, item, ctx.path, i2));
        })).then((result2) => {
          return ParseStatus2.mergeArray(status, result2);
        });
      }
      const result = [...ctx.data].map((item, i2) => {
        return def.type._parseSync(new ParseInputLazyPath2(ctx, item, ctx.path, i2));
      });
      return ParseStatus2.mergeArray(status, result);
    }
    get element() {
      return this._def.type;
    }
    min(minLength, message) {
      return new _ZodArray({
        ...this._def,
        minLength: { value: minLength, message: errorUtil2.toString(message) }
      });
    }
    max(maxLength, message) {
      return new _ZodArray({
        ...this._def,
        maxLength: { value: maxLength, message: errorUtil2.toString(message) }
      });
    }
    length(len, message) {
      return new _ZodArray({
        ...this._def,
        exactLength: { value: len, message: errorUtil2.toString(message) }
      });
    }
    nonempty(message) {
      return this.min(1, message);
    }
  };
  ZodArray2.create = (schema, params) => {
    return new ZodArray2({
      type: schema,
      minLength: null,
      maxLength: null,
      exactLength: null,
      typeName: ZodFirstPartyTypeKind2.ZodArray,
      ...processCreateParams2(params)
    });
  };
  function deepPartialify2(schema) {
    if (schema instanceof ZodObject2) {
      const newShape = {};
      for (const key in schema.shape) {
        const fieldSchema = schema.shape[key];
        newShape[key] = ZodOptional2.create(deepPartialify2(fieldSchema));
      }
      return new ZodObject2({
        ...schema._def,
        shape: () => newShape
      });
    } else if (schema instanceof ZodArray2) {
      return new ZodArray2({
        ...schema._def,
        type: deepPartialify2(schema.element)
      });
    } else if (schema instanceof ZodOptional2) {
      return ZodOptional2.create(deepPartialify2(schema.unwrap()));
    } else if (schema instanceof ZodNullable2) {
      return ZodNullable2.create(deepPartialify2(schema.unwrap()));
    } else if (schema instanceof ZodTuple2) {
      return ZodTuple2.create(schema.items.map((item) => deepPartialify2(item)));
    } else {
      return schema;
    }
  }
  var ZodObject2 = class _ZodObject extends ZodType2 {
    constructor() {
      super(...arguments);
      this._cached = null;
      this.nonstrict = this.passthrough;
      this.augment = this.extend;
    }
    _getCached() {
      if (this._cached !== null)
        return this._cached;
      const shape = this._def.shape();
      const keys = util2.objectKeys(shape);
      this._cached = { shape, keys };
      return this._cached;
    }
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.object) {
        const ctx2 = this._getOrReturnCtx(input);
        addIssueToContext2(ctx2, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.object,
          received: ctx2.parsedType
        });
        return INVALID2;
      }
      const { status, ctx } = this._processInputParams(input);
      const { shape, keys: shapeKeys } = this._getCached();
      const extraKeys = [];
      if (!(this._def.catchall instanceof ZodNever2 && this._def.unknownKeys === "strip")) {
        for (const key in ctx.data) {
          if (!shapeKeys.includes(key)) {
            extraKeys.push(key);
          }
        }
      }
      const pairs = [];
      for (const key of shapeKeys) {
        const keyValidator = shape[key];
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: keyValidator._parse(new ParseInputLazyPath2(ctx, value, ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }
      if (this._def.catchall instanceof ZodNever2) {
        const unknownKeys = this._def.unknownKeys;
        if (unknownKeys === "passthrough") {
          for (const key of extraKeys) {
            pairs.push({
              key: { status: "valid", value: key },
              value: { status: "valid", value: ctx.data[key] }
            });
          }
        } else if (unknownKeys === "strict") {
          if (extraKeys.length > 0) {
            addIssueToContext2(ctx, {
              code: ZodIssueCode2.unrecognized_keys,
              keys: extraKeys
            });
            status.dirty();
          }
        } else if (unknownKeys === "strip") {
        } else {
          throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        }
      } else {
        const catchall = this._def.catchall;
        for (const key of extraKeys) {
          const value = ctx.data[key];
          pairs.push({
            key: { status: "valid", value: key },
            value: catchall._parse(
              new ParseInputLazyPath2(ctx, value, ctx.path, key)
              //, ctx.child(key), value, getParsedType(value)
            ),
            alwaysSet: key in ctx.data
          });
        }
      }
      if (ctx.common.async) {
        return Promise.resolve().then(async () => {
          const syncPairs = [];
          for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
              key,
              value,
              alwaysSet: pair.alwaysSet
            });
          }
          return syncPairs;
        }).then((syncPairs) => {
          return ParseStatus2.mergeObjectSync(status, syncPairs);
        });
      } else {
        return ParseStatus2.mergeObjectSync(status, pairs);
      }
    }
    get shape() {
      return this._def.shape();
    }
    strict(message) {
      errorUtil2.errToObj;
      return new _ZodObject({
        ...this._def,
        unknownKeys: "strict",
        ...message !== void 0 ? {
          errorMap: (issue, ctx) => {
            const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
            if (issue.code === "unrecognized_keys")
              return {
                message: errorUtil2.errToObj(message).message ?? defaultError
              };
            return {
              message: defaultError
            };
          }
        } : {}
      });
    }
    strip() {
      return new _ZodObject({
        ...this._def,
        unknownKeys: "strip"
      });
    }
    passthrough() {
      return new _ZodObject({
        ...this._def,
        unknownKeys: "passthrough"
      });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
      return new _ZodObject({
        ...this._def,
        shape: () => ({
          ...this._def.shape(),
          ...augmentation
        })
      });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
      const merged = new _ZodObject({
        unknownKeys: merging._def.unknownKeys,
        catchall: merging._def.catchall,
        shape: () => ({
          ...this._def.shape(),
          ...merging._def.shape()
        }),
        typeName: ZodFirstPartyTypeKind2.ZodObject
      });
      return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
      return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index2) {
      return new _ZodObject({
        ...this._def,
        catchall: index2
      });
    }
    pick(mask2) {
      const shape = {};
      for (const key of util2.objectKeys(mask2)) {
        if (mask2[key] && this.shape[key]) {
          shape[key] = this.shape[key];
        }
      }
      return new _ZodObject({
        ...this._def,
        shape: () => shape
      });
    }
    omit(mask2) {
      const shape = {};
      for (const key of util2.objectKeys(this.shape)) {
        if (!mask2[key]) {
          shape[key] = this.shape[key];
        }
      }
      return new _ZodObject({
        ...this._def,
        shape: () => shape
      });
    }
    /**
     * @deprecated
     */
    deepPartial() {
      return deepPartialify2(this);
    }
    partial(mask2) {
      const newShape = {};
      for (const key of util2.objectKeys(this.shape)) {
        const fieldSchema = this.shape[key];
        if (mask2 && !mask2[key]) {
          newShape[key] = fieldSchema;
        } else {
          newShape[key] = fieldSchema.optional();
        }
      }
      return new _ZodObject({
        ...this._def,
        shape: () => newShape
      });
    }
    required(mask2) {
      const newShape = {};
      for (const key of util2.objectKeys(this.shape)) {
        if (mask2 && !mask2[key]) {
          newShape[key] = this.shape[key];
        } else {
          const fieldSchema = this.shape[key];
          let newField = fieldSchema;
          while (newField instanceof ZodOptional2) {
            newField = newField._def.innerType;
          }
          newShape[key] = newField;
        }
      }
      return new _ZodObject({
        ...this._def,
        shape: () => newShape
      });
    }
    keyof() {
      return createZodEnum2(util2.objectKeys(this.shape));
    }
  };
  ZodObject2.create = (shape, params) => {
    return new ZodObject2({
      shape: () => shape,
      unknownKeys: "strip",
      catchall: ZodNever2.create(),
      typeName: ZodFirstPartyTypeKind2.ZodObject,
      ...processCreateParams2(params)
    });
  };
  ZodObject2.strictCreate = (shape, params) => {
    return new ZodObject2({
      shape: () => shape,
      unknownKeys: "strict",
      catchall: ZodNever2.create(),
      typeName: ZodFirstPartyTypeKind2.ZodObject,
      ...processCreateParams2(params)
    });
  };
  ZodObject2.lazycreate = (shape, params) => {
    return new ZodObject2({
      shape,
      unknownKeys: "strip",
      catchall: ZodNever2.create(),
      typeName: ZodFirstPartyTypeKind2.ZodObject,
      ...processCreateParams2(params)
    });
  };
  var ZodUnion2 = class extends ZodType2 {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const options = this._def.options;
      function handleResults(results) {
        for (const result of results) {
          if (result.result.status === "valid") {
            return result.result;
          }
        }
        for (const result of results) {
          if (result.result.status === "dirty") {
            ctx.common.issues.push(...result.ctx.common.issues);
            return result.result;
          }
        }
        const unionErrors = results.map((result) => new ZodError2(result.ctx.common.issues));
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_union,
          unionErrors
        });
        return INVALID2;
      }
      if (ctx.common.async) {
        return Promise.all(options.map(async (option) => {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: []
            },
            parent: null
          };
          return {
            result: await option._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            }),
            ctx: childCtx
          };
        })).then(handleResults);
      } else {
        let dirty = void 0;
        const issues = [];
        for (const option of options) {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: []
            },
            parent: null
          };
          const result = option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          });
          if (result.status === "valid") {
            return result;
          } else if (result.status === "dirty" && !dirty) {
            dirty = { result, ctx: childCtx };
          }
          if (childCtx.common.issues.length) {
            issues.push(childCtx.common.issues);
          }
        }
        if (dirty) {
          ctx.common.issues.push(...dirty.ctx.common.issues);
          return dirty.result;
        }
        const unionErrors = issues.map((issues2) => new ZodError2(issues2));
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_union,
          unionErrors
        });
        return INVALID2;
      }
    }
    get options() {
      return this._def.options;
    }
  };
  ZodUnion2.create = (types3, params) => {
    return new ZodUnion2({
      options: types3,
      typeName: ZodFirstPartyTypeKind2.ZodUnion,
      ...processCreateParams2(params)
    });
  };
  var getDiscriminator2 = (type) => {
    if (type instanceof ZodLazy2) {
      return getDiscriminator2(type.schema);
    } else if (type instanceof ZodEffects2) {
      return getDiscriminator2(type.innerType());
    } else if (type instanceof ZodLiteral2) {
      return [type.value];
    } else if (type instanceof ZodEnum2) {
      return type.options;
    } else if (type instanceof ZodNativeEnum2) {
      return util2.objectValues(type.enum);
    } else if (type instanceof ZodDefault2) {
      return getDiscriminator2(type._def.innerType);
    } else if (type instanceof ZodUndefined2) {
      return [void 0];
    } else if (type instanceof ZodNull2) {
      return [null];
    } else if (type instanceof ZodOptional2) {
      return [void 0, ...getDiscriminator2(type.unwrap())];
    } else if (type instanceof ZodNullable2) {
      return [null, ...getDiscriminator2(type.unwrap())];
    } else if (type instanceof ZodBranded2) {
      return getDiscriminator2(type.unwrap());
    } else if (type instanceof ZodReadonly2) {
      return getDiscriminator2(type.unwrap());
    } else if (type instanceof ZodCatch2) {
      return getDiscriminator2(type._def.innerType);
    } else {
      return [];
    }
  };
  var ZodDiscriminatedUnion2 = class _ZodDiscriminatedUnion extends ZodType2 {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.object) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.object,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      const discriminator = this.discriminator;
      const discriminatorValue = ctx.data[discriminator];
      const option = this.optionsMap.get(discriminatorValue);
      if (!option) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_union_discriminator,
          options: Array.from(this.optionsMap.keys()),
          path: [discriminator]
        });
        return INVALID2;
      }
      if (ctx.common.async) {
        return option._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      } else {
        return option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
      const optionsMap = /* @__PURE__ */ new Map();
      for (const type of options) {
        const discriminatorValues = getDiscriminator2(type.shape[discriminator]);
        if (!discriminatorValues.length) {
          throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
        }
        for (const value of discriminatorValues) {
          if (optionsMap.has(value)) {
            throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
          }
          optionsMap.set(value, type);
        }
      }
      return new _ZodDiscriminatedUnion({
        typeName: ZodFirstPartyTypeKind2.ZodDiscriminatedUnion,
        discriminator,
        options,
        optionsMap,
        ...processCreateParams2(params)
      });
    }
  };
  function mergeValues2(a, b) {
    const aType = getParsedType2(a);
    const bType = getParsedType2(b);
    if (a === b) {
      return { valid: true, data: a };
    } else if (aType === ZodParsedType2.object && bType === ZodParsedType2.object) {
      const bKeys = util2.objectKeys(b);
      const sharedKeys = util2.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
      const newObj = { ...a, ...b };
      for (const key of sharedKeys) {
        const sharedValue = mergeValues2(a[key], b[key]);
        if (!sharedValue.valid) {
          return { valid: false };
        }
        newObj[key] = sharedValue.data;
      }
      return { valid: true, data: newObj };
    } else if (aType === ZodParsedType2.array && bType === ZodParsedType2.array) {
      if (a.length !== b.length) {
        return { valid: false };
      }
      const newArray = [];
      for (let index2 = 0; index2 < a.length; index2++) {
        const itemA = a[index2];
        const itemB = b[index2];
        const sharedValue = mergeValues2(itemA, itemB);
        if (!sharedValue.valid) {
          return { valid: false };
        }
        newArray.push(sharedValue.data);
      }
      return { valid: true, data: newArray };
    } else if (aType === ZodParsedType2.date && bType === ZodParsedType2.date && +a === +b) {
      return { valid: true, data: a };
    } else {
      return { valid: false };
    }
  }
  var ZodIntersection2 = class extends ZodType2 {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      const handleParsed = (parsedLeft, parsedRight) => {
        if (isAborted2(parsedLeft) || isAborted2(parsedRight)) {
          return INVALID2;
        }
        const merged = mergeValues2(parsedLeft.value, parsedRight.value);
        if (!merged.valid) {
          addIssueToContext2(ctx, {
            code: ZodIssueCode2.invalid_intersection_types
          });
          return INVALID2;
        }
        if (isDirty2(parsedLeft) || isDirty2(parsedRight)) {
          status.dirty();
        }
        return { status: status.value, value: merged.data };
      };
      if (ctx.common.async) {
        return Promise.all([
          this._def.left._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }),
          this._def.right._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          })
        ]).then(([left, right]) => handleParsed(left, right));
      } else {
        return handleParsed(this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }));
      }
    }
  };
  ZodIntersection2.create = (left, right, params) => {
    return new ZodIntersection2({
      left,
      right,
      typeName: ZodFirstPartyTypeKind2.ZodIntersection,
      ...processCreateParams2(params)
    });
  };
  var ZodTuple2 = class _ZodTuple extends ZodType2 {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.array) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.array,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      if (ctx.data.length < this._def.items.length) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.too_small,
          minimum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        return INVALID2;
      }
      const rest = this._def.rest;
      if (!rest && ctx.data.length > this._def.items.length) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.too_big,
          maximum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        status.dirty();
      }
      const items = [...ctx.data].map((item, itemIndex) => {
        const schema = this._def.items[itemIndex] || this._def.rest;
        if (!schema)
          return null;
        return schema._parse(new ParseInputLazyPath2(ctx, item, ctx.path, itemIndex));
      }).filter((x) => !!x);
      if (ctx.common.async) {
        return Promise.all(items).then((results) => {
          return ParseStatus2.mergeArray(status, results);
        });
      } else {
        return ParseStatus2.mergeArray(status, items);
      }
    }
    get items() {
      return this._def.items;
    }
    rest(rest) {
      return new _ZodTuple({
        ...this._def,
        rest
      });
    }
  };
  ZodTuple2.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
      throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple2({
      items: schemas,
      typeName: ZodFirstPartyTypeKind2.ZodTuple,
      rest: null,
      ...processCreateParams2(params)
    });
  };
  var ZodRecord2 = class _ZodRecord extends ZodType2 {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.object) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.object,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      const pairs = [];
      const keyType = this._def.keyType;
      const valueType = this._def.valueType;
      for (const key in ctx.data) {
        pairs.push({
          key: keyType._parse(new ParseInputLazyPath2(ctx, key, ctx.path, key)),
          value: valueType._parse(new ParseInputLazyPath2(ctx, ctx.data[key], ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }
      if (ctx.common.async) {
        return ParseStatus2.mergeObjectAsync(status, pairs);
      } else {
        return ParseStatus2.mergeObjectSync(status, pairs);
      }
    }
    get element() {
      return this._def.valueType;
    }
    static create(first, second, third) {
      if (second instanceof ZodType2) {
        return new _ZodRecord({
          keyType: first,
          valueType: second,
          typeName: ZodFirstPartyTypeKind2.ZodRecord,
          ...processCreateParams2(third)
        });
      }
      return new _ZodRecord({
        keyType: ZodString2.create(),
        valueType: first,
        typeName: ZodFirstPartyTypeKind2.ZodRecord,
        ...processCreateParams2(second)
      });
    }
  };
  var ZodMap2 = class extends ZodType2 {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.map) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.map,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      const keyType = this._def.keyType;
      const valueType = this._def.valueType;
      const pairs = [...ctx.data.entries()].map(([key, value], index2) => {
        return {
          key: keyType._parse(new ParseInputLazyPath2(ctx, key, ctx.path, [index2, "key"])),
          value: valueType._parse(new ParseInputLazyPath2(ctx, value, ctx.path, [index2, "value"]))
        };
      });
      if (ctx.common.async) {
        const finalMap = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            if (key.status === "aborted" || value.status === "aborted") {
              return INVALID2;
            }
            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }
            finalMap.set(key.value, value.value);
          }
          return { status: status.value, value: finalMap };
        });
      } else {
        const finalMap = /* @__PURE__ */ new Map();
        for (const pair of pairs) {
          const key = pair.key;
          const value = pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID2;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      }
    }
  };
  ZodMap2.create = (keyType, valueType, params) => {
    return new ZodMap2({
      valueType,
      keyType,
      typeName: ZodFirstPartyTypeKind2.ZodMap,
      ...processCreateParams2(params)
    });
  };
  var ZodSet2 = class _ZodSet extends ZodType2 {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.set) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.set,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      const def = this._def;
      if (def.minSize !== null) {
        if (ctx.data.size < def.minSize.value) {
          addIssueToContext2(ctx, {
            code: ZodIssueCode2.too_small,
            minimum: def.minSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.minSize.message
          });
          status.dirty();
        }
      }
      if (def.maxSize !== null) {
        if (ctx.data.size > def.maxSize.value) {
          addIssueToContext2(ctx, {
            code: ZodIssueCode2.too_big,
            maximum: def.maxSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.maxSize.message
          });
          status.dirty();
        }
      }
      const valueType = this._def.valueType;
      function finalizeSet(elements2) {
        const parsedSet = /* @__PURE__ */ new Set();
        for (const element of elements2) {
          if (element.status === "aborted")
            return INVALID2;
          if (element.status === "dirty")
            status.dirty();
          parsedSet.add(element.value);
        }
        return { status: status.value, value: parsedSet };
      }
      const elements = [...ctx.data.values()].map((item, i2) => valueType._parse(new ParseInputLazyPath2(ctx, item, ctx.path, i2)));
      if (ctx.common.async) {
        return Promise.all(elements).then((elements2) => finalizeSet(elements2));
      } else {
        return finalizeSet(elements);
      }
    }
    min(minSize, message) {
      return new _ZodSet({
        ...this._def,
        minSize: { value: minSize, message: errorUtil2.toString(message) }
      });
    }
    max(maxSize, message) {
      return new _ZodSet({
        ...this._def,
        maxSize: { value: maxSize, message: errorUtil2.toString(message) }
      });
    }
    size(size, message) {
      return this.min(size, message).max(size, message);
    }
    nonempty(message) {
      return this.min(1, message);
    }
  };
  ZodSet2.create = (valueType, params) => {
    return new ZodSet2({
      valueType,
      minSize: null,
      maxSize: null,
      typeName: ZodFirstPartyTypeKind2.ZodSet,
      ...processCreateParams2(params)
    });
  };
  var ZodFunction2 = class _ZodFunction extends ZodType2 {
    constructor() {
      super(...arguments);
      this.validate = this.implement;
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.function) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.function,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      function makeArgsIssue(args, error) {
        return makeIssue2({
          data: args,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap2(), en_default].filter((x) => !!x),
          issueData: {
            code: ZodIssueCode2.invalid_arguments,
            argumentsError: error
          }
        });
      }
      function makeReturnsIssue(returns, error) {
        return makeIssue2({
          data: returns,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap2(), en_default].filter((x) => !!x),
          issueData: {
            code: ZodIssueCode2.invalid_return_type,
            returnTypeError: error
          }
        });
      }
      const params = { errorMap: ctx.common.contextualErrorMap };
      const fn = ctx.data;
      if (this._def.returns instanceof ZodPromise2) {
        const me = this;
        return OK2(async function(...args) {
          const error = new ZodError2([]);
          const parsedArgs = await me._def.args.parseAsync(args, params).catch((e2) => {
            error.addIssue(makeArgsIssue(args, e2));
            throw error;
          });
          const result = await Reflect.apply(fn, this, parsedArgs);
          const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e2) => {
            error.addIssue(makeReturnsIssue(result, e2));
            throw error;
          });
          return parsedReturns;
        });
      } else {
        const me = this;
        return OK2(function(...args) {
          const parsedArgs = me._def.args.safeParse(args, params);
          if (!parsedArgs.success) {
            throw new ZodError2([makeArgsIssue(args, parsedArgs.error)]);
          }
          const result = Reflect.apply(fn, this, parsedArgs.data);
          const parsedReturns = me._def.returns.safeParse(result, params);
          if (!parsedReturns.success) {
            throw new ZodError2([makeReturnsIssue(result, parsedReturns.error)]);
          }
          return parsedReturns.data;
        });
      }
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...items) {
      return new _ZodFunction({
        ...this._def,
        args: ZodTuple2.create(items).rest(ZodUnknown2.create())
      });
    }
    returns(returnType) {
      return new _ZodFunction({
        ...this._def,
        returns: returnType
      });
    }
    implement(func) {
      const validatedFunc = this.parse(func);
      return validatedFunc;
    }
    strictImplement(func) {
      const validatedFunc = this.parse(func);
      return validatedFunc;
    }
    static create(args, returns, params) {
      return new _ZodFunction({
        args: args ? args : ZodTuple2.create([]).rest(ZodUnknown2.create()),
        returns: returns || ZodUnknown2.create(),
        typeName: ZodFirstPartyTypeKind2.ZodFunction,
        ...processCreateParams2(params)
      });
    }
  };
  var ZodLazy2 = class extends ZodType2 {
    get schema() {
      return this._def.getter();
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const lazySchema = this._def.getter();
      return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
  };
  ZodLazy2.create = (getter, params) => {
    return new ZodLazy2({
      getter,
      typeName: ZodFirstPartyTypeKind2.ZodLazy,
      ...processCreateParams2(params)
    });
  };
  var ZodLiteral2 = class extends ZodType2 {
    _parse(input) {
      if (input.data !== this._def.value) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          received: ctx.data,
          code: ZodIssueCode2.invalid_literal,
          expected: this._def.value
        });
        return INVALID2;
      }
      return { status: "valid", value: input.data };
    }
    get value() {
      return this._def.value;
    }
  };
  ZodLiteral2.create = (value, params) => {
    return new ZodLiteral2({
      value,
      typeName: ZodFirstPartyTypeKind2.ZodLiteral,
      ...processCreateParams2(params)
    });
  };
  function createZodEnum2(values, params) {
    return new ZodEnum2({
      values,
      typeName: ZodFirstPartyTypeKind2.ZodEnum,
      ...processCreateParams2(params)
    });
  }
  var ZodEnum2 = class _ZodEnum extends ZodType2 {
    _parse(input) {
      if (typeof input.data !== "string") {
        const ctx = this._getOrReturnCtx(input);
        const expectedValues = this._def.values;
        addIssueToContext2(ctx, {
          expected: util2.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode2.invalid_type
        });
        return INVALID2;
      }
      if (!this._cache) {
        this._cache = new Set(this._def.values);
      }
      if (!this._cache.has(input.data)) {
        const ctx = this._getOrReturnCtx(input);
        const expectedValues = this._def.values;
        addIssueToContext2(ctx, {
          received: ctx.data,
          code: ZodIssueCode2.invalid_enum_value,
          options: expectedValues
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    get Values() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    get Enum() {
      const enumValues = {};
      for (const val of this._def.values) {
        enumValues[val] = val;
      }
      return enumValues;
    }
    extract(values, newDef = this._def) {
      return _ZodEnum.create(values, {
        ...this._def,
        ...newDef
      });
    }
    exclude(values, newDef = this._def) {
      return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
        ...this._def,
        ...newDef
      });
    }
  };
  ZodEnum2.create = createZodEnum2;
  var ZodNativeEnum2 = class extends ZodType2 {
    _parse(input) {
      const nativeEnumValues = util2.getValidEnumValues(this._def.values);
      const ctx = this._getOrReturnCtx(input);
      if (ctx.parsedType !== ZodParsedType2.string && ctx.parsedType !== ZodParsedType2.number) {
        const expectedValues = util2.objectValues(nativeEnumValues);
        addIssueToContext2(ctx, {
          expected: util2.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode2.invalid_type
        });
        return INVALID2;
      }
      if (!this._cache) {
        this._cache = new Set(util2.getValidEnumValues(this._def.values));
      }
      if (!this._cache.has(input.data)) {
        const expectedValues = util2.objectValues(nativeEnumValues);
        addIssueToContext2(ctx, {
          received: ctx.data,
          code: ZodIssueCode2.invalid_enum_value,
          options: expectedValues
        });
        return INVALID2;
      }
      return OK2(input.data);
    }
    get enum() {
      return this._def.values;
    }
  };
  ZodNativeEnum2.create = (values, params) => {
    return new ZodNativeEnum2({
      values,
      typeName: ZodFirstPartyTypeKind2.ZodNativeEnum,
      ...processCreateParams2(params)
    });
  };
  var ZodPromise2 = class extends ZodType2 {
    unwrap() {
      return this._def.type;
    }
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      if (ctx.parsedType !== ZodParsedType2.promise && ctx.common.async === false) {
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.promise,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      const promisified = ctx.parsedType === ZodParsedType2.promise ? ctx.data : Promise.resolve(ctx.data);
      return OK2(promisified.then((data) => {
        return this._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap
        });
      }));
    }
  };
  ZodPromise2.create = (schema, params) => {
    return new ZodPromise2({
      type: schema,
      typeName: ZodFirstPartyTypeKind2.ZodPromise,
      ...processCreateParams2(params)
    });
  };
  var ZodEffects2 = class extends ZodType2 {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === ZodFirstPartyTypeKind2.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      const effect = this._def.effect || null;
      const checkCtx = {
        addIssue: (arg) => {
          addIssueToContext2(ctx, arg);
          if (arg.fatal) {
            status.abort();
          } else {
            status.dirty();
          }
        },
        get path() {
          return ctx.path;
        }
      };
      checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
      if (effect.type === "preprocess") {
        const processed = effect.transform(ctx.data, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(processed).then(async (processed2) => {
            if (status.value === "aborted")
              return INVALID2;
            const result = await this._def.schema._parseAsync({
              data: processed2,
              path: ctx.path,
              parent: ctx
            });
            if (result.status === "aborted")
              return INVALID2;
            if (result.status === "dirty")
              return DIRTY2(result.value);
            if (status.value === "dirty")
              return DIRTY2(result.value);
            return result;
          });
        } else {
          if (status.value === "aborted")
            return INVALID2;
          const result = this._def.schema._parseSync({
            data: processed,
            path: ctx.path,
            parent: ctx
          });
          if (result.status === "aborted")
            return INVALID2;
          if (result.status === "dirty")
            return DIRTY2(result.value);
          if (status.value === "dirty")
            return DIRTY2(result.value);
          return result;
        }
      }
      if (effect.type === "refinement") {
        const executeRefinement = (acc) => {
          const result = effect.refinement(acc, checkCtx);
          if (ctx.common.async) {
            return Promise.resolve(result);
          }
          if (result instanceof Promise) {
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          }
          return acc;
        };
        if (ctx.common.async === false) {
          const inner = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inner.status === "aborted")
            return INVALID2;
          if (inner.status === "dirty")
            status.dirty();
          executeRefinement(inner.value);
          return { status: status.value, value: inner.value };
        } else {
          return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
            if (inner.status === "aborted")
              return INVALID2;
            if (inner.status === "dirty")
              status.dirty();
            return executeRefinement(inner.value).then(() => {
              return { status: status.value, value: inner.value };
            });
          });
        }
      }
      if (effect.type === "transform") {
        if (ctx.common.async === false) {
          const base2 = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (!isValid3(base2))
            return INVALID2;
          const result = effect.transform(base2.value, checkCtx);
          if (result instanceof Promise) {
            throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
          }
          return { status: status.value, value: result };
        } else {
          return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base2) => {
            if (!isValid3(base2))
              return INVALID2;
            return Promise.resolve(effect.transform(base2.value, checkCtx)).then((result) => ({
              status: status.value,
              value: result
            }));
          });
        }
      }
      util2.assertNever(effect);
    }
  };
  ZodEffects2.create = (schema, effect, params) => {
    return new ZodEffects2({
      schema,
      typeName: ZodFirstPartyTypeKind2.ZodEffects,
      effect,
      ...processCreateParams2(params)
    });
  };
  ZodEffects2.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects2({
      schema,
      effect: { type: "preprocess", transform: preprocess },
      typeName: ZodFirstPartyTypeKind2.ZodEffects,
      ...processCreateParams2(params)
    });
  };
  var ZodOptional2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType === ZodParsedType2.undefined) {
        return OK2(void 0);
      }
      return this._def.innerType._parse(input);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodOptional2.create = (type, params) => {
    return new ZodOptional2({
      innerType: type,
      typeName: ZodFirstPartyTypeKind2.ZodOptional,
      ...processCreateParams2(params)
    });
  };
  var ZodNullable2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType === ZodParsedType2.null) {
        return OK2(null);
      }
      return this._def.innerType._parse(input);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodNullable2.create = (type, params) => {
    return new ZodNullable2({
      innerType: type,
      typeName: ZodFirstPartyTypeKind2.ZodNullable,
      ...processCreateParams2(params)
    });
  };
  var ZodDefault2 = class extends ZodType2 {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      let data = ctx.data;
      if (ctx.parsedType === ZodParsedType2.undefined) {
        data = this._def.defaultValue();
      }
      return this._def.innerType._parse({
        data,
        path: ctx.path,
        parent: ctx
      });
    }
    removeDefault() {
      return this._def.innerType;
    }
  };
  ZodDefault2.create = (type, params) => {
    return new ZodDefault2({
      innerType: type,
      typeName: ZodFirstPartyTypeKind2.ZodDefault,
      defaultValue: typeof params.default === "function" ? params.default : () => params.default,
      ...processCreateParams2(params)
    });
  };
  var ZodCatch2 = class extends ZodType2 {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const newCtx = {
        ...ctx,
        common: {
          ...ctx.common,
          issues: []
        }
      };
      const result = this._def.innerType._parse({
        data: newCtx.data,
        path: newCtx.path,
        parent: {
          ...newCtx
        }
      });
      if (isAsync2(result)) {
        return result.then((result2) => {
          return {
            status: "valid",
            value: result2.status === "valid" ? result2.value : this._def.catchValue({
              get error() {
                return new ZodError2(newCtx.common.issues);
              },
              input: newCtx.data
            })
          };
        });
      } else {
        return {
          status: "valid",
          value: result.status === "valid" ? result.value : this._def.catchValue({
            get error() {
              return new ZodError2(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      }
    }
    removeCatch() {
      return this._def.innerType;
    }
  };
  ZodCatch2.create = (type, params) => {
    return new ZodCatch2({
      innerType: type,
      typeName: ZodFirstPartyTypeKind2.ZodCatch,
      catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
      ...processCreateParams2(params)
    });
  };
  var ZodNaN2 = class extends ZodType2 {
    _parse(input) {
      const parsedType = this._getType(input);
      if (parsedType !== ZodParsedType2.nan) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext2(ctx, {
          code: ZodIssueCode2.invalid_type,
          expected: ZodParsedType2.nan,
          received: ctx.parsedType
        });
        return INVALID2;
      }
      return { status: "valid", value: input.data };
    }
  };
  ZodNaN2.create = (params) => {
    return new ZodNaN2({
      typeName: ZodFirstPartyTypeKind2.ZodNaN,
      ...processCreateParams2(params)
    });
  };
  var BRAND2 = Symbol("zod_brand");
  var ZodBranded2 = class extends ZodType2 {
    _parse(input) {
      const { ctx } = this._processInputParams(input);
      const data = ctx.data;
      return this._def.type._parse({
        data,
        path: ctx.path,
        parent: ctx
      });
    }
    unwrap() {
      return this._def.type;
    }
  };
  var ZodPipeline2 = class _ZodPipeline extends ZodType2 {
    _parse(input) {
      const { status, ctx } = this._processInputParams(input);
      if (ctx.common.async) {
        const handleAsync = async () => {
          const inResult = await this._def.in._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inResult.status === "aborted")
            return INVALID2;
          if (inResult.status === "dirty") {
            status.dirty();
            return DIRTY2(inResult.value);
          } else {
            return this._def.out._parseAsync({
              data: inResult.value,
              path: ctx.path,
              parent: ctx
            });
          }
        };
        return handleAsync();
      } else {
        const inResult = this._def.in._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID2;
        if (inResult.status === "dirty") {
          status.dirty();
          return {
            status: "dirty",
            value: inResult.value
          };
        } else {
          return this._def.out._parseSync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      }
    }
    static create(a, b) {
      return new _ZodPipeline({
        in: a,
        out: b,
        typeName: ZodFirstPartyTypeKind2.ZodPipeline
      });
    }
  };
  var ZodReadonly2 = class extends ZodType2 {
    _parse(input) {
      const result = this._def.innerType._parse(input);
      const freeze = (data) => {
        if (isValid3(data)) {
          data.value = Object.freeze(data.value);
        }
        return data;
      };
      return isAsync2(result) ? result.then((data) => freeze(data)) : freeze(result);
    }
    unwrap() {
      return this._def.innerType;
    }
  };
  ZodReadonly2.create = (type, params) => {
    return new ZodReadonly2({
      innerType: type,
      typeName: ZodFirstPartyTypeKind2.ZodReadonly,
      ...processCreateParams2(params)
    });
  };
  function cleanParams(params, data) {
    const p12 = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
    const p22 = typeof p12 === "string" ? { message: p12 } : p12;
    return p22;
  }
  function custom2(check, _params = {}, fatal) {
    if (check)
      return ZodAny2.create().superRefine((data, ctx) => {
        const r2 = check(data);
        if (r2 instanceof Promise) {
          return r2.then((r3) => {
            if (!r3) {
              const params = cleanParams(_params, data);
              const _fatal = params.fatal ?? fatal ?? true;
              ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
            }
          });
        }
        if (!r2) {
          const params = cleanParams(_params, data);
          const _fatal = params.fatal ?? fatal ?? true;
          ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
        }
        return;
      });
    return ZodAny2.create();
  }
  var late2 = {
    object: ZodObject2.lazycreate
  };
  var ZodFirstPartyTypeKind2;
  (function(ZodFirstPartyTypeKind3) {
    ZodFirstPartyTypeKind3["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind3["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind3["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind3["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind3["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind3["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind3["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind3["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind3["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind3["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind3["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind3["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind3["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind3["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind3["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind3["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind3["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind3["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind3["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind3["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind3["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind3["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind3["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind3["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind3["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind3["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind3["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind3["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind3["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind3["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind3["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind3["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind3["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind3["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind3["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind3["ZodReadonly"] = "ZodReadonly";
  })(ZodFirstPartyTypeKind2 || (ZodFirstPartyTypeKind2 = {}));
  var instanceOfType2 = (cls, params = {
    message: `Input not instance of ${cls.name}`
  }) => custom2((data) => data instanceof cls, params);
  var stringType2 = ZodString2.create;
  var numberType2 = ZodNumber2.create;
  var nanType2 = ZodNaN2.create;
  var bigIntType2 = ZodBigInt2.create;
  var booleanType2 = ZodBoolean2.create;
  var dateType2 = ZodDate2.create;
  var symbolType2 = ZodSymbol2.create;
  var undefinedType2 = ZodUndefined2.create;
  var nullType2 = ZodNull2.create;
  var anyType2 = ZodAny2.create;
  var unknownType2 = ZodUnknown2.create;
  var neverType2 = ZodNever2.create;
  var voidType2 = ZodVoid2.create;
  var arrayType2 = ZodArray2.create;
  var objectType2 = ZodObject2.create;
  var strictObjectType2 = ZodObject2.strictCreate;
  var unionType2 = ZodUnion2.create;
  var discriminatedUnionType2 = ZodDiscriminatedUnion2.create;
  var intersectionType2 = ZodIntersection2.create;
  var tupleType2 = ZodTuple2.create;
  var recordType2 = ZodRecord2.create;
  var mapType2 = ZodMap2.create;
  var setType2 = ZodSet2.create;
  var functionType2 = ZodFunction2.create;
  var lazyType2 = ZodLazy2.create;
  var literalType2 = ZodLiteral2.create;
  var enumType2 = ZodEnum2.create;
  var nativeEnumType2 = ZodNativeEnum2.create;
  var promiseType2 = ZodPromise2.create;
  var effectsType2 = ZodEffects2.create;
  var optionalType2 = ZodOptional2.create;
  var nullableType2 = ZodNullable2.create;
  var preprocessType2 = ZodEffects2.createWithPreprocess;
  var pipelineType2 = ZodPipeline2.create;
  var ostring2 = () => stringType2().optional();
  var onumber2 = () => numberType2().optional();
  var oboolean2 = () => booleanType2().optional();
  var coerce2 = {
    string: (arg) => ZodString2.create({ ...arg, coerce: true }),
    number: (arg) => ZodNumber2.create({ ...arg, coerce: true }),
    boolean: (arg) => ZodBoolean2.create({
      ...arg,
      coerce: true
    }),
    bigint: (arg) => ZodBigInt2.create({ ...arg, coerce: true }),
    date: (arg) => ZodDate2.create({ ...arg, coerce: true })
  };
  var NEVER2 = INVALID2;

  // ../../node_modules/.pnpm/@capacitor+preferences@6.0.3_@capacitor+core@6.0.0/node_modules/@capacitor/preferences/dist/esm/index.js
  init_dist5();
  var Preferences = registerPlugin("Preferences", {
    web: () => Promise.resolve().then(() => (init_web(), web_exports)).then((m) => new m.PreferencesWeb())
  });

  // ../pocketbase/package.json
  var package_default11 = {
    name: "@slangroom/pocketbase",
    version: "1.49.3",
    dependencies: {
      "@capacitor/preferences": "6.0.3",
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*",
      pocketbase: "0.25.1",
      zod: "3.25.76"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../pocketbase/build/esm/src/plugin.js
  var version12 = package_default11.version;
  var PocketBaseError = class extends Error {
    constructor(message) {
      super(message);
      this.name = "Slangroom @slangroom/pocketbase@" + package_default11.version + " Error";
    }
  };
  var pb;
  var p8 = new Plugin();
  var serverUrlSchema = external_exports.literal(`http${external_exports.union([external_exports.literal("s"), external_exports.literal("")])}://${external_exports.string()}/`);
  var credentialsSchema = external_exports.object({
    email: external_exports.string().email(),
    password: external_exports.string()
  });
  var baseRecordParametersSchema = external_exports.object({
    expand: external_exports.string().nullish(),
    requestKey: external_exports.string().nullish(),
    fields: external_exports.string().nullish()
  });
  var baseFetchRecordParametersSchema = baseRecordParametersSchema.extend({
    collection: external_exports.string()
  });
  var paginationSchema = external_exports.object({
    page: external_exports.number().int(),
    perPage: external_exports.number().int()
  });
  var listParametersBaseSchema = external_exports.object({
    sort: external_exports.string().nullish()
  }).merge(baseFetchRecordParametersSchema);
  var listParametersSchema = external_exports.discriminatedUnion("type", [
    listParametersBaseSchema.extend({ type: external_exports.literal("all"), filter: external_exports.string().nullish() }),
    listParametersBaseSchema.extend({
      type: external_exports.literal("list"),
      filter: external_exports.string().nullish(),
      pagination: paginationSchema
    }),
    listParametersBaseSchema.extend({ type: external_exports.literal("first"), filter: external_exports.string() })
  ]);
  var showParametersSchema = external_exports.object({
    id: external_exports.string()
  }).merge(baseFetchRecordParametersSchema);
  var createRecordParametersSchema = external_exports.object({
    record: external_exports.record(external_exports.string(), external_exports.any()),
    collection: external_exports.string()
  });
  var updateRecordParametersSchema = external_exports.object({
    id: external_exports.string()
  }).merge(createRecordParametersSchema);
  var deleteParametersSchema = external_exports.object({
    collection: external_exports.string(),
    id: external_exports.string()
  });
  var isPbRunning = async () => {
    const res = await pb.health.check({ requestKey: null });
    return res.code === 200;
  };
  var createRecordOptions = (p12) => {
    const { expand, fields, requestKey } = p12;
    const options = {};
    if (expand && expand !== null)
      options.expand = expand;
    if (fields && fields !== null)
      options.fields = fields;
    if (requestKey && requestKey !== null)
      options.requestKey = requestKey;
    return options;
  };
  var setupClient = p8.new("connect", "start pb client", async (ctx) => {
    const address = ctx.fetchConnect()[0];
    if (typeof address !== "string")
      return ctx.fail(new PocketBaseError("Invalid address"));
    try {
      pb = new Client(address);
      if (!await isPbRunning())
        return ctx.fail(new PocketBaseError("Client is not running"));
      return ctx.pass("pb client successfully created");
    } catch (e2) {
      return ctx.fail(new PocketBaseError(e2.message));
    }
  });
  var init2 = async (key) => {
    return (await Preferences.get({ key })).value;
  };
  var setupCapacitorClient = p8.new("connect", "start capacitor pb client", async (ctx) => {
    if (typeof window === "undefined")
      return ctx.fail(new PocketBaseError("Can not start capacitor client in node environment"));
    const address = ctx.fetchConnect()[0];
    if (typeof address !== "string")
      return ctx.fail(new PocketBaseError("Invalid address"));
    const PB_AUTH_KEY = "pb_auth";
    const store = new AsyncAuthStore({
      save: async (serialized) => await Preferences.set({
        key: PB_AUTH_KEY,
        value: serialized
      }),
      initial: init2(PB_AUTH_KEY)
    });
    try {
      pb = new Client(address, store);
      if (!await isPbRunning())
        return ctx.fail(new PocketBaseError("Client is not running"));
      return ctx.pass("pb client successfully created");
    } catch (e2) {
      return ctx.fail(new PocketBaseError(e2.message));
    }
  });
  var authWithPassword = p8.new(["my_credentials"], "login", async (ctx) => {
    const credentials = ctx.fetch("my_credentials");
    const validation = credentialsSchema.safeParse(credentials);
    if (!validation.success)
      return ctx.fail(new PocketBaseError(validation.error.message));
    if (!await isPbRunning())
      return ctx.fail(new PocketBaseError("Client is not running"));
    try {
      const res = await pb.collection("users").authWithPassword(credentials.email, credentials.password, { requestKey: null });
      return ctx.pass({ token: res.token, record: res.record });
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var authRefresh = p8.new("refresh token", async (ctx) => {
    if (!await isPbRunning())
      return ctx.fail(new PocketBaseError("Client is not running"));
    if (!pb.authStore.isValid)
      return ctx.fail(new PocketBaseError("Invalid token"));
    try {
      const res = await pb.collection("users").authRefresh();
      return ctx.pass({ token: res.token, record: res.record });
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var requestPasswordReset = p8.new(["email"], "ask password reset", async (ctx) => {
    const email = ctx.fetch("email");
    if (!await isPbRunning())
      return ctx.fail(new PocketBaseError("Client is not running"));
    try {
      const res = await pb.collection("users").requestPasswordReset(email);
      return ctx.pass({ res });
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var getList = p8.new(["list_parameters"], "get some records", async (ctx) => {
    const params = ctx.fetch("list_parameters");
    const validation = listParametersSchema.safeParse(params);
    if (!validation.success)
      return ctx.fail(new PocketBaseError(validation.error.message));
    const { collection, sort, filter: filter2, expand, type, requestKey } = params;
    if (!await isPbRunning())
      return ctx.fail(new PocketBaseError("client is not working"));
    const options = { requestKey: requestKey || type };
    if (sort)
      options.sort = sort;
    if (filter2)
      options.filter = filter2;
    if (expand)
      options["expand"] = expand;
    let res;
    try {
      if (type === "all") {
        res = await pb.collection(collection).getFullList(options);
      } else if (type === "list") {
        const { page, perPage } = params.pagination;
        res = await pb.collection(collection).getList(page, perPage, options);
      } else {
        res = await pb.collection(collection).getFirstListItem(filter2, options);
      }
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
    return ctx.pass({ records: res });
  });
  var showRecord = p8.new(["show_parameters"], "get one record", async (ctx) => {
    const p12 = ctx.fetch("show_parameters");
    const validation = showParametersSchema.safeParse(p12);
    if (!validation.success)
      return ctx.fail(new PocketBaseError(validation.error.message));
    const options = createRecordOptions(p12);
    try {
      const res = await pb.collection(p12.collection).getOne(p12.id, options);
      return ctx.pass(res);
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var createRecord = p8.new(["create_parameters", "record_parameters"], "create record", async (ctx) => {
    const p12 = ctx.fetch("create_parameters");
    const r2 = ctx.fetch("record_parameters");
    const validateCreateParams = createRecordParametersSchema.safeParse(p12);
    const validateRecordParams = baseRecordParametersSchema.safeParse(r2);
    if (!validateCreateParams.success)
      return ctx.fail(new PocketBaseError(validateCreateParams.error.message));
    if (!validateRecordParams.success)
      return ctx.fail(new PocketBaseError(validateRecordParams.error.message));
    const { collection, record } = p12;
    const options = createRecordOptions(r2);
    try {
      const res = await pb.collection(collection).create(record, options);
      return ctx.pass(res);
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var updateRecord = p8.new(["update_parameters", "record_parameters"], "update record", async (ctx) => {
    const p12 = ctx.fetch("update_parameters");
    const r2 = ctx.fetch("record_parameters");
    const validateUpdateParams = updateRecordParametersSchema.safeParse(p12);
    const validateRecordParams = baseRecordParametersSchema.safeParse(r2);
    if (!validateUpdateParams.success)
      return ctx.fail(new PocketBaseError(validateUpdateParams.error.message));
    if (!validateRecordParams.success)
      return ctx.fail(new PocketBaseError(validateRecordParams.error.message));
    const { collection, record, id } = p12;
    const options = createRecordOptions(r2);
    try {
      const res = await pb.collection(collection).update(id, record, options);
      return ctx.pass(res);
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var deleteRecord = p8.new(["delete_parameters"], "delete record", async (ctx) => {
    const p12 = ctx.fetch("delete_parameters");
    const validation = deleteParametersSchema.safeParse(p12);
    if (!validation.success)
      return ctx.fail(new PocketBaseError(validation.error.message));
    const { collection, id } = p12;
    try {
      await pb.collection(collection).delete(id);
      return ctx.pass("deleted");
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var sendParametersSchema = external_exports.object({
    fetch: external_exports.any(),
    headers: external_exports.record(external_exports.unknown()).nullish(),
    body: external_exports.any(),
    query: external_exports.record(external_exports.unknown()).nullish(),
    requestKey: external_exports.string().nullish()
  });
  var urlSchema = external_exports.string();
  var sendRequest = p8.new(["url", "send_parameters"], "send request", async (ctx) => {
    const p12 = ctx.fetch("send_parameters");
    const u = ctx.fetch("url");
    const validation = sendParametersSchema.safeParse(p12);
    if (!validation.success)
      return ctx.fail(new PocketBaseError(validation.error.message));
    const validateUrl = urlSchema.safeParse(u);
    if (!validateUrl.success)
      return ctx.fail(new PocketBaseError(validateUrl.error.message));
    try {
      const res = await pb.send(u, p12);
      return ctx.pass(res);
    } catch (err3) {
      return ctx.fail(new PocketBaseError(err3.message));
    }
  });
  var pocketbase = p8;

  // ../qrcode/build/esm/src/plugin.js
  var import_qrcode = __toESM(require_browser4(), 1);

  // ../qrcode/package.json
  var package_default12 = {
    name: "@slangroom/qrcode",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      qrcode: "1.5.4"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    devDependencies: {
      "@types/qrcode": "^1.5.5"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../qrcode/build/esm/src/plugin.js
  var version13 = package_default12.version;
  var QrCodeError = class extends Error {
    constructor(message) {
      super(message);
      this.name = "Slangroom @slangroom/qrcode@" + package_default12.version + " Error";
    }
  };
  var p9 = new Plugin();
  var generateQr = p9.new(["text"], "create qr code", async (ctx) => {
    const textToEncode = ctx.fetch("text");
    if (typeof textToEncode !== "string")
      return ctx.fail(new QrCodeError("text must be string"));
    try {
      const res = await import_qrcode.default.toDataURL(textToEncode, {
        errorCorrectionLevel: "L",
        type: "image/png"
      });
      return ctx.pass(res);
    } catch (e2) {
      return ctx.fail(new QrCodeError(e2.message));
    }
  });
  var qrcode = p9;

  // ../timestamp/package.json
  var package_default13 = {
    name: "@slangroom/timestamp",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../timestamp/build/esm/src/plugin.js
  var version14 = package_default13.version;
  var p10 = new Plugin();
  var milliseconds = p10.new("fetch the local timestamp in milliseconds", async (ctx) => {
    const t2 = Date.now();
    return ctx.pass(t2.toString());
  });
  var seconds = p10.new("fetch the local timestamp in seconds", async (ctx) => {
    const t2 = Math.floor(Date.now() / 1e3);
    return ctx.pass(t2.toString());
  });
  var timestamp = p10;

  // ../zencode/package.json
  var package_default14 = {
    name: "@slangroom/zencode",
    version: "1.49.3",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/shared": "workspace:*"
    },
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    types: "./build/esm/src/index.d.ts",
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // ../zencode/build/esm/src/plugin.js
  var version15 = package_default14.version;
  var ZencodeError = class extends Error {
    constructor(message) {
      super(message);
      this.name = "Slangroom @slangroom/zencode@" + package_default14.version + " Error";
    }
  };
  var p11 = new Plugin();
  var exec = async (script, data, keys, extra, conf = "") => {
    if (!script)
      throw new Error("script is required");
    if (!data)
      throw new Error("data is required");
    if (!keys)
      throw new Error("keys is required");
    return await zencodeExec(script, { data, keys, extra, conf });
  };
  var zencodeExecPlugin = p11.new(["script", "data", "keys"], "execute zencode", async (ctx) => {
    const script = ctx.fetch("script");
    const data = ctx.get("data") || {};
    const keys = ctx.get("keys") || {};
    const extra = {};
    const conf = "";
    try {
      const zout = await exec(script, data, keys, extra, conf);
      return ctx.pass(zout.result);
    } catch (e2) {
      return ctx.fail(new ZencodeError(e2.message));
    }
  });
  var zencodeExecFullPlugin = p11.new(["script", "data", "keys", "extra", "conf"], "execute zencode", async (ctx) => {
    const script = ctx.fetch("script");
    const data = ctx.get("data") || {};
    const keys = ctx.get("keys") || {};
    const extra = ctx.get("extra") || {};
    const conf = ctx.get("conf") || "";
    try {
      const zout = await exec(script, data, keys, extra, conf);
      return ctx.pass(zout.result);
    } catch (e2) {
      return ctx.fail(new ZencodeError(e2.message));
    }
  });
  var zencode = p11;

  // package.json
  var package_default15 = {
    name: "@slangroom/browser",
    dependencies: {
      "@slangroom/core": "workspace:*",
      "@slangroom/deps": "workspace:*",
      "@slangroom/ethereum": "workspace:*",
      "@slangroom/fs": "workspace:*",
      "@slangroom/git": "workspace:*",
      "@slangroom/helpers": "workspace:*",
      "@slangroom/http": "workspace:*",
      "@slangroom/json-schema": "workspace:*",
      "@slangroom/location": "workspace:*",
      "@slangroom/pocketbase": "workspace:*",
      "@slangroom/qrcode": "workspace:*",
      "@slangroom/timestamp": "workspace:*",
      "@slangroom/zencode": "workspace:*",
      buffer: "6.0.3"
    },
    version: "1.49.3",
    repository: "https://github.com/dyne/slangroom",
    license: "AGPL-3.0-only",
    type: "module",
    main: "./build/esm/src/index.js",
    browser: "./build/slangroom.js",
    types: "./build/esm/src/index.d.ts",
    files: [
      "./build/**/*.js"
    ],
    exports: {
      ".": {
        import: {
          types: "./build/esm/src/index.d.ts",
          default: "./build/esm/src/index.js"
        }
      },
      "./*": {
        import: {
          types: "./build/esm/src/*.d.ts",
          default: "./build/esm/src/*.js"
        }
      },
      "./package.json": "./package.json"
    },
    publishConfig: {
      access: "public"
    },
    devDependencies: {
      "@playwright/test": "^1.52.0",
      "@types/node": "^20.17.32",
      "@types/path-browserify": "^1.0.3",
      "@zenfs/core": "^2.2.0",
      esbuild: "^0.21.5",
      "path-browserify": "^1.0.1"
    },
    scripts: {
      build: "pnpm exec esbuild --bundle src/index.ts --outfile=build/slangroom.js --target=ESNext --external:crypto --external:module --alias:fs=@zenfs/core --alias:path=path-browserify && cp build/slangroom.js public"
    },
    engines: {
      node: "^18.20.0 || ^20.10.0 || ^22 || ^23 || ^24"
    }
  };

  // src/index.ts
  var import_buffer10 = __toESM(require_buffer(), 1);
  var version16 = package_default15.version;
  var plugins_dict = {
    ethereum: {
      plugin: ethereum,
      version: version5
    },
    fs: {
      plugin: fs,
      version: version6
    },
    git: {
      plugin: git,
      version: version7
    },
    helpers: {
      plugin: helpers,
      version: version8
    },
    http: {
      plugin: http,
      version: version9
    },
    "json-schema": {
      plugin: JSONSchema,
      version: version10
    },
    location: {
      plugin: location,
      version: version11
    },
    pocketbase: {
      plugin: pocketbase,
      version: version12
    },
    qrcode: {
      plugin: qrcode,
      version: version13
    },
    timestamp: {
      plugin: timestamp,
      version: version14
    },
    zencode: {
      plugin: zencode,
      version: version15
    }
  };
  var welcome_message = "\u{1F389} Slangroom is ready, installed zenroom and plugins:\n";
  welcome_message = welcome_message.concat(` - zenroom@${zenroomVersion}
`);
  welcome_message = welcome_message.concat(` - @slangroom/core@${version2}
`);
  var plugins = [];
  for (const [name2, dict] of Object.entries(plugins_dict)) {
    plugins.push(dict.plugin);
    welcome_message = welcome_message.concat(` - @slangroom/${name2}@${dict.version}
`);
  }
  var slangroom = new Slangroom(plugins);
  window.slangroom = slangroom;
  window.Buffer = import_buffer10.Buffer;
  console.log(welcome_message);
})();
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

safe-buffer/index.js:
  (*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)

crc-32/crc32.js:
  (*! crc32.js (C) 2014-present SheetJS -- http://sheetjs.com *)

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

@capacitor/core/dist/index.js:
  (*! Capacitor: https://capacitorjs.com/ - MIT License *)

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/utils.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/modular.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/curve.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/abstract/weierstrass.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/_shortw_utils.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)

@noble/curves/esm/secp256k1.js:
  (*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) *)
*/
